
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea39d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea39d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fbycL", function(module, exports) {

$parcel$export(module.exports, "register", () => $b0e26a78cf218a37$export$6503ec6e8aabbaf, (v) => $b0e26a78cf218a37$export$6503ec6e8aabbaf = v);
var $b0e26a78cf218a37$export$6503ec6e8aabbaf;
var $b0e26a78cf218a37$export$f7ad0328861e2f03;
"use strict";
var $b0e26a78cf218a37$var$mapping = new Map();
function $b0e26a78cf218a37$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b0e26a78cf218a37$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b0e26a78cf218a37$var$resolve(id) {
    var resolved = $b0e26a78cf218a37$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b0e26a78cf218a37$export$6503ec6e8aabbaf = $b0e26a78cf218a37$var$register;
$b0e26a78cf218a37$export$f7ad0328861e2f03 = $b0e26a78cf218a37$var$resolve;

});

parcelRegister("ghbiQ", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $bd9700672deaa340$export$bdfd709ae4826697, (v) => $bd9700672deaa340$export$bdfd709ae4826697 = v);
var $bd9700672deaa340$export$bdfd709ae4826697;
var $bd9700672deaa340$export$c9e73fbda7da57b6;
var $bd9700672deaa340$export$5a759dc7a1cfb72a;
"use strict";
var $bd9700672deaa340$var$bundleURL = {};
function $bd9700672deaa340$var$getBundleURLCached(id) {
    var value = $bd9700672deaa340$var$bundleURL[id];
    if (!value) {
        value = $bd9700672deaa340$var$getBundleURL();
        $bd9700672deaa340$var$bundleURL[id] = value;
    }
    return value;
}
function $bd9700672deaa340$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $bd9700672deaa340$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $bd9700672deaa340$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $bd9700672deaa340$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$bd9700672deaa340$export$bdfd709ae4826697 = $bd9700672deaa340$var$getBundleURLCached;
$bd9700672deaa340$export$c9e73fbda7da57b6 = $bd9700672deaa340$var$getBaseURL;
$bd9700672deaa340$export$5a759dc7a1cfb72a = $bd9700672deaa340$var$getOrigin;

});

parcelRegister("8qmxs", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $62223c25e093ced5$export$ffb0004e005737fa, (v) => $62223c25e093ced5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $62223c25e093ced5$export$34b9dba7ce09269b, (v) => $62223c25e093ced5$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $62223c25e093ced5$export$25062201e9e25d76, (v) => $62223c25e093ced5$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $62223c25e093ced5$export$ffb0004e005737fa;
var $62223c25e093ced5$export$34b9dba7ce09269b;
var $62223c25e093ced5$export$25062201e9e25d76;
"use strict";

var $lT7pJ = parcelRequire("lT7pJ");
var $62223c25e093ced5$var$k = Symbol.for("react.element"), $62223c25e093ced5$var$l = Symbol.for("react.fragment"), $62223c25e093ced5$var$m = Object.prototype.hasOwnProperty, $62223c25e093ced5$var$n = $lT7pJ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $62223c25e093ced5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $62223c25e093ced5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$62223c25e093ced5$var$m.call(a, b) && !$62223c25e093ced5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $62223c25e093ced5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $62223c25e093ced5$var$n.current
    };
}
$62223c25e093ced5$export$ffb0004e005737fa = $62223c25e093ced5$var$l;
$62223c25e093ced5$export$34b9dba7ce09269b = $62223c25e093ced5$var$q;
$62223c25e093ced5$export$25062201e9e25d76 = $62223c25e093ced5$var$q;

});
parcelRegister("lT7pJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("g4nhu"));

});
parcelRegister("g4nhu", function(module, exports) {

$parcel$export(module.exports, "Children", () => $bb2f1437e024f40d$export$dca3b0875bd9a954, (v) => $bb2f1437e024f40d$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $bb2f1437e024f40d$export$16fa2f45be04daa8, (v) => $bb2f1437e024f40d$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $bb2f1437e024f40d$export$ffb0004e005737fa, (v) => $bb2f1437e024f40d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $bb2f1437e024f40d$export$e2c29f18771995cb, (v) => $bb2f1437e024f40d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $bb2f1437e024f40d$export$221d75b3f55bb0bd, (v) => $bb2f1437e024f40d$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $bb2f1437e024f40d$export$5f8d39834fd61797, (v) => $bb2f1437e024f40d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $bb2f1437e024f40d$export$74bf444e3cd11ea5, (v) => $bb2f1437e024f40d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $bb2f1437e024f40d$export$ae55be85d98224ed, (v) => $bb2f1437e024f40d$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $bb2f1437e024f40d$export$e530037191fcd5d7, (v) => $bb2f1437e024f40d$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $bb2f1437e024f40d$export$fd42f52fd3ae1109, (v) => $bb2f1437e024f40d$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $bb2f1437e024f40d$export$c8a8987d4410bf2d, (v) => $bb2f1437e024f40d$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $bb2f1437e024f40d$export$d38cd72104c1f0e9, (v) => $bb2f1437e024f40d$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $bb2f1437e024f40d$export$7d1e3a5e95ceca43, (v) => $bb2f1437e024f40d$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $bb2f1437e024f40d$export$257a8862b851cb5b, (v) => $bb2f1437e024f40d$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $bb2f1437e024f40d$export$a8257692ac88316c, (v) => $bb2f1437e024f40d$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $bb2f1437e024f40d$export$488013bae63b21da, (v) => $bb2f1437e024f40d$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $bb2f1437e024f40d$export$7c73462e0d25e514, (v) => $bb2f1437e024f40d$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $bb2f1437e024f40d$export$7568632d0d33d16d, (v) => $bb2f1437e024f40d$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $bb2f1437e024f40d$export$88948ce120ea2619, (v) => $bb2f1437e024f40d$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $bb2f1437e024f40d$export$35808ee640e87ca7, (v) => $bb2f1437e024f40d$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $bb2f1437e024f40d$export$fae74005e78b1a27, (v) => $bb2f1437e024f40d$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $bb2f1437e024f40d$export$dc8fbce3eb94dc1e, (v) => $bb2f1437e024f40d$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $bb2f1437e024f40d$export$6a7bc4e911dc01cf, (v) => $bb2f1437e024f40d$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $bb2f1437e024f40d$export$6d9c69b0de29b591, (v) => $bb2f1437e024f40d$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $bb2f1437e024f40d$export$f680877a34711e37, (v) => $bb2f1437e024f40d$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $bb2f1437e024f40d$export$d5a552a76deda3c2, (v) => $bb2f1437e024f40d$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $bb2f1437e024f40d$export$aaabe4eda9ed9969, (v) => $bb2f1437e024f40d$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $bb2f1437e024f40d$export$e5c5a5f917a5871c, (v) => $bb2f1437e024f40d$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $bb2f1437e024f40d$export$1538c33de8887b59, (v) => $bb2f1437e024f40d$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $bb2f1437e024f40d$export$13e3392192263954, (v) => $bb2f1437e024f40d$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $bb2f1437e024f40d$export$b8f5890fc79d6aca, (v) => $bb2f1437e024f40d$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $bb2f1437e024f40d$export$60241385465d0a34, (v) => $bb2f1437e024f40d$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $bb2f1437e024f40d$export$306c0aa65ff9ec16, (v) => $bb2f1437e024f40d$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $bb2f1437e024f40d$export$7b286972b8d8ccbf, (v) => $bb2f1437e024f40d$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $bb2f1437e024f40d$export$83d89fbfd8236492, (v) => $bb2f1437e024f40d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb2f1437e024f40d$export$dca3b0875bd9a954;
var $bb2f1437e024f40d$export$16fa2f45be04daa8;
var $bb2f1437e024f40d$export$ffb0004e005737fa;
var $bb2f1437e024f40d$export$e2c29f18771995cb;
var $bb2f1437e024f40d$export$221d75b3f55bb0bd;
var $bb2f1437e024f40d$export$5f8d39834fd61797;
var $bb2f1437e024f40d$export$74bf444e3cd11ea5;
var $bb2f1437e024f40d$export$ae55be85d98224ed;
var $bb2f1437e024f40d$export$e530037191fcd5d7;
var $bb2f1437e024f40d$export$fd42f52fd3ae1109;
var $bb2f1437e024f40d$export$c8a8987d4410bf2d;
var $bb2f1437e024f40d$export$d38cd72104c1f0e9;
var $bb2f1437e024f40d$export$7d1e3a5e95ceca43;
var $bb2f1437e024f40d$export$257a8862b851cb5b;
var $bb2f1437e024f40d$export$a8257692ac88316c;
var $bb2f1437e024f40d$export$488013bae63b21da;
var $bb2f1437e024f40d$export$7c73462e0d25e514;
var $bb2f1437e024f40d$export$7568632d0d33d16d;
var $bb2f1437e024f40d$export$88948ce120ea2619;
var $bb2f1437e024f40d$export$35808ee640e87ca7;
var $bb2f1437e024f40d$export$fae74005e78b1a27;
var $bb2f1437e024f40d$export$dc8fbce3eb94dc1e;
var $bb2f1437e024f40d$export$6a7bc4e911dc01cf;
var $bb2f1437e024f40d$export$6d9c69b0de29b591;
var $bb2f1437e024f40d$export$f680877a34711e37;
var $bb2f1437e024f40d$export$d5a552a76deda3c2;
var $bb2f1437e024f40d$export$aaabe4eda9ed9969;
var $bb2f1437e024f40d$export$e5c5a5f917a5871c;
var $bb2f1437e024f40d$export$1538c33de8887b59;
var $bb2f1437e024f40d$export$13e3392192263954;
var $bb2f1437e024f40d$export$b8f5890fc79d6aca;
var $bb2f1437e024f40d$export$60241385465d0a34;
var $bb2f1437e024f40d$export$306c0aa65ff9ec16;
var $bb2f1437e024f40d$export$7b286972b8d8ccbf;
var $bb2f1437e024f40d$export$83d89fbfd8236492;
"use strict";
var $bb2f1437e024f40d$var$l = Symbol.for("react.element"), $bb2f1437e024f40d$var$n = Symbol.for("react.portal"), $bb2f1437e024f40d$var$p = Symbol.for("react.fragment"), $bb2f1437e024f40d$var$q = Symbol.for("react.strict_mode"), $bb2f1437e024f40d$var$r = Symbol.for("react.profiler"), $bb2f1437e024f40d$var$t = Symbol.for("react.provider"), $bb2f1437e024f40d$var$u = Symbol.for("react.context"), $bb2f1437e024f40d$var$v = Symbol.for("react.forward_ref"), $bb2f1437e024f40d$var$w = Symbol.for("react.suspense"), $bb2f1437e024f40d$var$x = Symbol.for("react.memo"), $bb2f1437e024f40d$var$y = Symbol.for("react.lazy"), $bb2f1437e024f40d$var$z = Symbol.iterator;
function $bb2f1437e024f40d$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bb2f1437e024f40d$var$z && a[$bb2f1437e024f40d$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bb2f1437e024f40d$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bb2f1437e024f40d$var$C = Object.assign, $bb2f1437e024f40d$var$D = {};
function $bb2f1437e024f40d$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bb2f1437e024f40d$var$D;
    this.updater = e || $bb2f1437e024f40d$var$B;
}
$bb2f1437e024f40d$var$E.prototype.isReactComponent = {};
$bb2f1437e024f40d$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$bb2f1437e024f40d$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $bb2f1437e024f40d$var$F() {}
$bb2f1437e024f40d$var$F.prototype = $bb2f1437e024f40d$var$E.prototype;
function $bb2f1437e024f40d$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bb2f1437e024f40d$var$D;
    this.updater = e || $bb2f1437e024f40d$var$B;
}
var $bb2f1437e024f40d$var$H = $bb2f1437e024f40d$var$G.prototype = new $bb2f1437e024f40d$var$F;
$bb2f1437e024f40d$var$H.constructor = $bb2f1437e024f40d$var$G;
$bb2f1437e024f40d$var$C($bb2f1437e024f40d$var$H, $bb2f1437e024f40d$var$E.prototype);
$bb2f1437e024f40d$var$H.isPureReactComponent = !0;
var $bb2f1437e024f40d$var$I = Array.isArray, $bb2f1437e024f40d$var$J = Object.prototype.hasOwnProperty, $bb2f1437e024f40d$var$K = {
    current: null
}, $bb2f1437e024f40d$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bb2f1437e024f40d$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$bb2f1437e024f40d$var$J.call(b, d) && !$bb2f1437e024f40d$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $bb2f1437e024f40d$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $bb2f1437e024f40d$var$K.current
    };
}
function $bb2f1437e024f40d$var$N(a, b) {
    return {
        $$typeof: $bb2f1437e024f40d$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $bb2f1437e024f40d$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bb2f1437e024f40d$var$l;
}
function $bb2f1437e024f40d$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $bb2f1437e024f40d$var$P = /\/+/g;
function $bb2f1437e024f40d$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $bb2f1437e024f40d$var$escape("" + a.key) : b.toString(36);
}
function $bb2f1437e024f40d$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $bb2f1437e024f40d$var$l:
                case $bb2f1437e024f40d$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $bb2f1437e024f40d$var$Q(h, 0) : d, $bb2f1437e024f40d$var$I(c) ? (e = "", null != a && (e = a.replace($bb2f1437e024f40d$var$P, "$&/") + "/"), $bb2f1437e024f40d$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($bb2f1437e024f40d$var$O(c) && (c = $bb2f1437e024f40d$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($bb2f1437e024f40d$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($bb2f1437e024f40d$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $bb2f1437e024f40d$var$Q(k, g);
        h += $bb2f1437e024f40d$var$R(k, b, e, f, c);
    }
    else if (f = $bb2f1437e024f40d$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $bb2f1437e024f40d$var$Q(k, g++), h += $bb2f1437e024f40d$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $bb2f1437e024f40d$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $bb2f1437e024f40d$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $bb2f1437e024f40d$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $bb2f1437e024f40d$var$U = {
    current: null
}, $bb2f1437e024f40d$var$V = {
    transition: null
}, $bb2f1437e024f40d$var$W = {
    ReactCurrentDispatcher: $bb2f1437e024f40d$var$U,
    ReactCurrentBatchConfig: $bb2f1437e024f40d$var$V,
    ReactCurrentOwner: $bb2f1437e024f40d$var$K
};
$bb2f1437e024f40d$export$dca3b0875bd9a954 = {
    map: $bb2f1437e024f40d$var$S,
    forEach: function(a, b, e) {
        $bb2f1437e024f40d$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $bb2f1437e024f40d$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $bb2f1437e024f40d$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$bb2f1437e024f40d$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$bb2f1437e024f40d$export$16fa2f45be04daa8 = $bb2f1437e024f40d$var$E;
$bb2f1437e024f40d$export$ffb0004e005737fa = $bb2f1437e024f40d$var$p;
$bb2f1437e024f40d$export$e2c29f18771995cb = $bb2f1437e024f40d$var$r;
$bb2f1437e024f40d$export$221d75b3f55bb0bd = $bb2f1437e024f40d$var$G;
$bb2f1437e024f40d$export$5f8d39834fd61797 = $bb2f1437e024f40d$var$q;
$bb2f1437e024f40d$export$74bf444e3cd11ea5 = $bb2f1437e024f40d$var$w;
$bb2f1437e024f40d$export$ae55be85d98224ed = $bb2f1437e024f40d$var$W;
$bb2f1437e024f40d$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $bb2f1437e024f40d$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $bb2f1437e024f40d$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$bb2f1437e024f40d$var$J.call(b, f) && !$bb2f1437e024f40d$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $bb2f1437e024f40d$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$bb2f1437e024f40d$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $bb2f1437e024f40d$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $bb2f1437e024f40d$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$bb2f1437e024f40d$export$c8a8987d4410bf2d = $bb2f1437e024f40d$var$M;
$bb2f1437e024f40d$export$d38cd72104c1f0e9 = function(a) {
    var b = $bb2f1437e024f40d$var$M.bind(null, a);
    b.type = a;
    return b;
};
$bb2f1437e024f40d$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bb2f1437e024f40d$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $bb2f1437e024f40d$var$v,
        render: a
    };
};
$bb2f1437e024f40d$export$a8257692ac88316c = $bb2f1437e024f40d$var$O;
$bb2f1437e024f40d$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $bb2f1437e024f40d$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $bb2f1437e024f40d$var$T
    };
};
$bb2f1437e024f40d$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $bb2f1437e024f40d$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$bb2f1437e024f40d$export$7568632d0d33d16d = function(a) {
    var b = $bb2f1437e024f40d$var$V.transition;
    $bb2f1437e024f40d$var$V.transition = {};
    try {
        a();
    } finally{
        $bb2f1437e024f40d$var$V.transition = b;
    }
};
$bb2f1437e024f40d$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$bb2f1437e024f40d$export$35808ee640e87ca7 = function(a, b) {
    return $bb2f1437e024f40d$var$U.current.useCallback(a, b);
};
$bb2f1437e024f40d$export$fae74005e78b1a27 = function(a) {
    return $bb2f1437e024f40d$var$U.current.useContext(a);
};
$bb2f1437e024f40d$export$dc8fbce3eb94dc1e = function() {};
$bb2f1437e024f40d$export$6a7bc4e911dc01cf = function(a) {
    return $bb2f1437e024f40d$var$U.current.useDeferredValue(a);
};
$bb2f1437e024f40d$export$6d9c69b0de29b591 = function(a, b) {
    return $bb2f1437e024f40d$var$U.current.useEffect(a, b);
};
$bb2f1437e024f40d$export$f680877a34711e37 = function() {
    return $bb2f1437e024f40d$var$U.current.useId();
};
$bb2f1437e024f40d$export$d5a552a76deda3c2 = function(a, b, e) {
    return $bb2f1437e024f40d$var$U.current.useImperativeHandle(a, b, e);
};
$bb2f1437e024f40d$export$aaabe4eda9ed9969 = function(a, b) {
    return $bb2f1437e024f40d$var$U.current.useInsertionEffect(a, b);
};
$bb2f1437e024f40d$export$e5c5a5f917a5871c = function(a, b) {
    return $bb2f1437e024f40d$var$U.current.useLayoutEffect(a, b);
};
$bb2f1437e024f40d$export$1538c33de8887b59 = function(a, b) {
    return $bb2f1437e024f40d$var$U.current.useMemo(a, b);
};
$bb2f1437e024f40d$export$13e3392192263954 = function(a, b, e) {
    return $bb2f1437e024f40d$var$U.current.useReducer(a, b, e);
};
$bb2f1437e024f40d$export$b8f5890fc79d6aca = function(a) {
    return $bb2f1437e024f40d$var$U.current.useRef(a);
};
$bb2f1437e024f40d$export$60241385465d0a34 = function(a) {
    return $bb2f1437e024f40d$var$U.current.useState(a);
};
$bb2f1437e024f40d$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $bb2f1437e024f40d$var$U.current.useSyncExternalStore(a, b, e);
};
$bb2f1437e024f40d$export$7b286972b8d8ccbf = function() {
    return $bb2f1437e024f40d$var$U.current.useTransition();
};
$bb2f1437e024f40d$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("1E5eb", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $132d94fbf41cf0d4$export$ae55be85d98224ed, (v) => $132d94fbf41cf0d4$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $132d94fbf41cf0d4$export$d39a5bbd09211389, (v) => $132d94fbf41cf0d4$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $132d94fbf41cf0d4$export$882461b6382ed46c, (v) => $132d94fbf41cf0d4$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $132d94fbf41cf0d4$export$466bfc07425424d5, (v) => $132d94fbf41cf0d4$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $132d94fbf41cf0d4$export$cd75ccfd720a3cd4, (v) => $132d94fbf41cf0d4$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $132d94fbf41cf0d4$export$fa8d919ba61d84db, (v) => $132d94fbf41cf0d4$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $132d94fbf41cf0d4$export$757ceba2d55c277e, (v) => $132d94fbf41cf0d4$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $132d94fbf41cf0d4$export$b3890eb0ae9dca99, (v) => $132d94fbf41cf0d4$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $132d94fbf41cf0d4$export$502457920280e6be, (v) => $132d94fbf41cf0d4$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $132d94fbf41cf0d4$export$c78a37762a8d58e1, (v) => $132d94fbf41cf0d4$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $132d94fbf41cf0d4$export$dc54d992c10e8a18, (v) => $132d94fbf41cf0d4$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $132d94fbf41cf0d4$export$83d89fbfd8236492, (v) => $132d94fbf41cf0d4$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $132d94fbf41cf0d4$export$ae55be85d98224ed;
var $132d94fbf41cf0d4$export$d39a5bbd09211389;
var $132d94fbf41cf0d4$export$882461b6382ed46c;
var $132d94fbf41cf0d4$export$466bfc07425424d5;
var $132d94fbf41cf0d4$export$cd75ccfd720a3cd4;
var $132d94fbf41cf0d4$export$fa8d919ba61d84db;
var $132d94fbf41cf0d4$export$757ceba2d55c277e;
var $132d94fbf41cf0d4$export$b3890eb0ae9dca99;
var $132d94fbf41cf0d4$export$502457920280e6be;
var $132d94fbf41cf0d4$export$c78a37762a8d58e1;
var $132d94fbf41cf0d4$export$dc54d992c10e8a18;
var $132d94fbf41cf0d4$export$83d89fbfd8236492;
"use strict";

var $lT7pJ = parcelRequire("lT7pJ");

var $aVkVc = parcelRequire("aVkVc");
function $132d94fbf41cf0d4$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $132d94fbf41cf0d4$var$da = new Set, $132d94fbf41cf0d4$var$ea = {};
function $132d94fbf41cf0d4$var$fa(a, b) {
    $132d94fbf41cf0d4$var$ha(a, b);
    $132d94fbf41cf0d4$var$ha(a + "Capture", b);
}
function $132d94fbf41cf0d4$var$ha(a, b) {
    $132d94fbf41cf0d4$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$132d94fbf41cf0d4$var$da.add(b[a]);
}
var $132d94fbf41cf0d4$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $132d94fbf41cf0d4$var$ja = Object.prototype.hasOwnProperty, $132d94fbf41cf0d4$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $132d94fbf41cf0d4$var$la = {}, $132d94fbf41cf0d4$var$ma = {};
function $132d94fbf41cf0d4$var$oa(a) {
    if ($132d94fbf41cf0d4$var$ja.call($132d94fbf41cf0d4$var$ma, a)) return !0;
    if ($132d94fbf41cf0d4$var$ja.call($132d94fbf41cf0d4$var$la, a)) return !1;
    if ($132d94fbf41cf0d4$var$ka.test(a)) return $132d94fbf41cf0d4$var$ma[a] = !0;
    $132d94fbf41cf0d4$var$la[a] = !0;
    return !1;
}
function $132d94fbf41cf0d4$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $132d94fbf41cf0d4$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $132d94fbf41cf0d4$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $132d94fbf41cf0d4$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $132d94fbf41cf0d4$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $132d94fbf41cf0d4$var$z[b] = new $132d94fbf41cf0d4$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $132d94fbf41cf0d4$var$ra = /[\-:]([a-z])/g;
function $132d94fbf41cf0d4$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($132d94fbf41cf0d4$var$ra, $132d94fbf41cf0d4$var$sa);
    $132d94fbf41cf0d4$var$z[b] = new $132d94fbf41cf0d4$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($132d94fbf41cf0d4$var$ra, $132d94fbf41cf0d4$var$sa);
    $132d94fbf41cf0d4$var$z[b] = new $132d94fbf41cf0d4$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($132d94fbf41cf0d4$var$ra, $132d94fbf41cf0d4$var$sa);
    $132d94fbf41cf0d4$var$z[b] = new $132d94fbf41cf0d4$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$132d94fbf41cf0d4$var$z.xlinkHref = new $132d94fbf41cf0d4$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $132d94fbf41cf0d4$var$z[a] = new $132d94fbf41cf0d4$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $132d94fbf41cf0d4$var$ta(a, b, c, d) {
    var e = $132d94fbf41cf0d4$var$z.hasOwnProperty(b) ? $132d94fbf41cf0d4$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $132d94fbf41cf0d4$var$qa(b, c, e, d) && (c = null), d || null === e ? $132d94fbf41cf0d4$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $132d94fbf41cf0d4$var$ua = $lT7pJ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $132d94fbf41cf0d4$var$va = Symbol.for("react.element"), $132d94fbf41cf0d4$var$wa = Symbol.for("react.portal"), $132d94fbf41cf0d4$var$ya = Symbol.for("react.fragment"), $132d94fbf41cf0d4$var$za = Symbol.for("react.strict_mode"), $132d94fbf41cf0d4$var$Aa = Symbol.for("react.profiler"), $132d94fbf41cf0d4$var$Ba = Symbol.for("react.provider"), $132d94fbf41cf0d4$var$Ca = Symbol.for("react.context"), $132d94fbf41cf0d4$var$Da = Symbol.for("react.forward_ref"), $132d94fbf41cf0d4$var$Ea = Symbol.for("react.suspense"), $132d94fbf41cf0d4$var$Fa = Symbol.for("react.suspense_list"), $132d94fbf41cf0d4$var$Ga = Symbol.for("react.memo"), $132d94fbf41cf0d4$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $132d94fbf41cf0d4$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $132d94fbf41cf0d4$var$Ja = Symbol.iterator;
function $132d94fbf41cf0d4$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $132d94fbf41cf0d4$var$Ja && a[$132d94fbf41cf0d4$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $132d94fbf41cf0d4$var$A = Object.assign, $132d94fbf41cf0d4$var$La;
function $132d94fbf41cf0d4$var$Ma(a) {
    if (void 0 === $132d94fbf41cf0d4$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $132d94fbf41cf0d4$var$La = b && b[1] || "";
    }
    return "\n" + $132d94fbf41cf0d4$var$La + a;
}
var $132d94fbf41cf0d4$var$Na = !1;
function $132d94fbf41cf0d4$var$Oa(a, b) {
    if (!a || $132d94fbf41cf0d4$var$Na) return "";
    $132d94fbf41cf0d4$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $132d94fbf41cf0d4$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $132d94fbf41cf0d4$var$Ma(a) : "";
}
function $132d94fbf41cf0d4$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $132d94fbf41cf0d4$var$Ma(a.type);
        case 16:
            return $132d94fbf41cf0d4$var$Ma("Lazy");
        case 13:
            return $132d94fbf41cf0d4$var$Ma("Suspense");
        case 19:
            return $132d94fbf41cf0d4$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $132d94fbf41cf0d4$var$Oa(a.type, !1), a;
        case 11:
            return a = $132d94fbf41cf0d4$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $132d94fbf41cf0d4$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $132d94fbf41cf0d4$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $132d94fbf41cf0d4$var$ya:
            return "Fragment";
        case $132d94fbf41cf0d4$var$wa:
            return "Portal";
        case $132d94fbf41cf0d4$var$Aa:
            return "Profiler";
        case $132d94fbf41cf0d4$var$za:
            return "StrictMode";
        case $132d94fbf41cf0d4$var$Ea:
            return "Suspense";
        case $132d94fbf41cf0d4$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $132d94fbf41cf0d4$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $132d94fbf41cf0d4$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $132d94fbf41cf0d4$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $132d94fbf41cf0d4$var$Ga:
            return b = a.displayName || null, null !== b ? b : $132d94fbf41cf0d4$var$Qa(a.type) || "Memo";
        case $132d94fbf41cf0d4$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $132d94fbf41cf0d4$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $132d94fbf41cf0d4$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $132d94fbf41cf0d4$var$Qa(b);
        case 8:
            return b === $132d94fbf41cf0d4$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $132d94fbf41cf0d4$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $132d94fbf41cf0d4$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $132d94fbf41cf0d4$var$Ua(a) {
    var b = $132d94fbf41cf0d4$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $132d94fbf41cf0d4$var$Va(a) {
    a._valueTracker || (a._valueTracker = $132d94fbf41cf0d4$var$Ua(a));
}
function $132d94fbf41cf0d4$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $132d94fbf41cf0d4$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $132d94fbf41cf0d4$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $132d94fbf41cf0d4$var$Ya(a, b) {
    var c = b.checked;
    return $132d94fbf41cf0d4$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $132d94fbf41cf0d4$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $132d94fbf41cf0d4$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $132d94fbf41cf0d4$var$ab(a, b) {
    b = b.checked;
    null != b && $132d94fbf41cf0d4$var$ta(a, "checked", b, !1);
}
function $132d94fbf41cf0d4$var$bb(a, b) {
    $132d94fbf41cf0d4$var$ab(a, b);
    var c = $132d94fbf41cf0d4$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $132d94fbf41cf0d4$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $132d94fbf41cf0d4$var$cb(a, b.type, $132d94fbf41cf0d4$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $132d94fbf41cf0d4$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $132d94fbf41cf0d4$var$cb(a, b, c) {
    if ("number" !== b || $132d94fbf41cf0d4$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $132d94fbf41cf0d4$var$eb = Array.isArray;
function $132d94fbf41cf0d4$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $132d94fbf41cf0d4$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $132d94fbf41cf0d4$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($132d94fbf41cf0d4$var$p(91));
    return $132d94fbf41cf0d4$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $132d94fbf41cf0d4$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($132d94fbf41cf0d4$var$p(92));
            if ($132d94fbf41cf0d4$var$eb(c)) {
                if (1 < c.length) throw Error($132d94fbf41cf0d4$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $132d94fbf41cf0d4$var$Sa(c)
    };
}
function $132d94fbf41cf0d4$var$ib(a, b) {
    var c = $132d94fbf41cf0d4$var$Sa(b.value), d = $132d94fbf41cf0d4$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $132d94fbf41cf0d4$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $132d94fbf41cf0d4$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $132d94fbf41cf0d4$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $132d94fbf41cf0d4$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $132d94fbf41cf0d4$var$mb, $132d94fbf41cf0d4$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $132d94fbf41cf0d4$var$mb = $132d94fbf41cf0d4$var$mb || document.createElement("div");
        $132d94fbf41cf0d4$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $132d94fbf41cf0d4$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $132d94fbf41cf0d4$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $132d94fbf41cf0d4$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $132d94fbf41cf0d4$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($132d94fbf41cf0d4$var$pb).forEach(function(a) {
    $132d94fbf41cf0d4$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $132d94fbf41cf0d4$var$pb[b] = $132d94fbf41cf0d4$var$pb[a];
    });
});
function $132d94fbf41cf0d4$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $132d94fbf41cf0d4$var$pb.hasOwnProperty(a) && $132d94fbf41cf0d4$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $132d94fbf41cf0d4$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $132d94fbf41cf0d4$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $132d94fbf41cf0d4$var$tb = $132d94fbf41cf0d4$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $132d94fbf41cf0d4$var$ub(a, b) {
    if (b) {
        if ($132d94fbf41cf0d4$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($132d94fbf41cf0d4$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($132d94fbf41cf0d4$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($132d94fbf41cf0d4$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($132d94fbf41cf0d4$var$p(62));
    }
}
function $132d94fbf41cf0d4$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $132d94fbf41cf0d4$var$wb = null;
function $132d94fbf41cf0d4$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $132d94fbf41cf0d4$var$yb = null, $132d94fbf41cf0d4$var$zb = null, $132d94fbf41cf0d4$var$Ab = null;
function $132d94fbf41cf0d4$var$Bb(a) {
    if (a = $132d94fbf41cf0d4$var$Cb(a)) {
        if ("function" !== typeof $132d94fbf41cf0d4$var$yb) throw Error($132d94fbf41cf0d4$var$p(280));
        var b = a.stateNode;
        b && (b = $132d94fbf41cf0d4$var$Db(b), $132d94fbf41cf0d4$var$yb(a.stateNode, a.type, b));
    }
}
function $132d94fbf41cf0d4$var$Eb(a) {
    $132d94fbf41cf0d4$var$zb ? $132d94fbf41cf0d4$var$Ab ? $132d94fbf41cf0d4$var$Ab.push(a) : $132d94fbf41cf0d4$var$Ab = [
        a
    ] : $132d94fbf41cf0d4$var$zb = a;
}
function $132d94fbf41cf0d4$var$Fb() {
    if ($132d94fbf41cf0d4$var$zb) {
        var a = $132d94fbf41cf0d4$var$zb, b = $132d94fbf41cf0d4$var$Ab;
        $132d94fbf41cf0d4$var$Ab = $132d94fbf41cf0d4$var$zb = null;
        $132d94fbf41cf0d4$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$132d94fbf41cf0d4$var$Bb(b[a]);
    }
}
function $132d94fbf41cf0d4$var$Gb(a, b) {
    return a(b);
}
function $132d94fbf41cf0d4$var$Hb() {}
var $132d94fbf41cf0d4$var$Ib = !1;
function $132d94fbf41cf0d4$var$Jb(a, b, c) {
    if ($132d94fbf41cf0d4$var$Ib) return a(b, c);
    $132d94fbf41cf0d4$var$Ib = !0;
    try {
        return $132d94fbf41cf0d4$var$Gb(a, b, c);
    } finally{
        if ($132d94fbf41cf0d4$var$Ib = !1, null !== $132d94fbf41cf0d4$var$zb || null !== $132d94fbf41cf0d4$var$Ab) $132d94fbf41cf0d4$var$Hb(), $132d94fbf41cf0d4$var$Fb();
    }
}
function $132d94fbf41cf0d4$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $132d94fbf41cf0d4$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($132d94fbf41cf0d4$var$p(231, b, typeof c));
    return c;
}
var $132d94fbf41cf0d4$var$Lb = !1;
if ($132d94fbf41cf0d4$var$ia) try {
    var $132d94fbf41cf0d4$var$Mb = {};
    Object.defineProperty($132d94fbf41cf0d4$var$Mb, "passive", {
        get: function() {
            $132d94fbf41cf0d4$var$Lb = !0;
        }
    });
    window.addEventListener("test", $132d94fbf41cf0d4$var$Mb, $132d94fbf41cf0d4$var$Mb);
    window.removeEventListener("test", $132d94fbf41cf0d4$var$Mb, $132d94fbf41cf0d4$var$Mb);
} catch (a) {
    $132d94fbf41cf0d4$var$Lb = !1;
}
function $132d94fbf41cf0d4$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $132d94fbf41cf0d4$var$Ob = !1, $132d94fbf41cf0d4$var$Pb = null, $132d94fbf41cf0d4$var$Qb = !1, $132d94fbf41cf0d4$var$Rb = null, $132d94fbf41cf0d4$var$Sb = {
    onError: function(a) {
        $132d94fbf41cf0d4$var$Ob = !0;
        $132d94fbf41cf0d4$var$Pb = a;
    }
};
function $132d94fbf41cf0d4$var$Tb(a, b, c, d, e, f, g, h, k) {
    $132d94fbf41cf0d4$var$Ob = !1;
    $132d94fbf41cf0d4$var$Pb = null;
    $132d94fbf41cf0d4$var$Nb.apply($132d94fbf41cf0d4$var$Sb, arguments);
}
function $132d94fbf41cf0d4$var$Ub(a, b, c, d, e, f, g, h, k) {
    $132d94fbf41cf0d4$var$Tb.apply(this, arguments);
    if ($132d94fbf41cf0d4$var$Ob) {
        if ($132d94fbf41cf0d4$var$Ob) {
            var l = $132d94fbf41cf0d4$var$Pb;
            $132d94fbf41cf0d4$var$Ob = !1;
            $132d94fbf41cf0d4$var$Pb = null;
        } else throw Error($132d94fbf41cf0d4$var$p(198));
        $132d94fbf41cf0d4$var$Qb || ($132d94fbf41cf0d4$var$Qb = !0, $132d94fbf41cf0d4$var$Rb = l);
    }
}
function $132d94fbf41cf0d4$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $132d94fbf41cf0d4$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $132d94fbf41cf0d4$var$Xb(a) {
    if ($132d94fbf41cf0d4$var$Vb(a) !== a) throw Error($132d94fbf41cf0d4$var$p(188));
}
function $132d94fbf41cf0d4$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $132d94fbf41cf0d4$var$Vb(a);
        if (null === b) throw Error($132d94fbf41cf0d4$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $132d94fbf41cf0d4$var$Xb(e), a;
                if (f === d) return $132d94fbf41cf0d4$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($132d94fbf41cf0d4$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($132d94fbf41cf0d4$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($132d94fbf41cf0d4$var$p(190));
    }
    if (3 !== c.tag) throw Error($132d94fbf41cf0d4$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $132d94fbf41cf0d4$var$Zb(a) {
    a = $132d94fbf41cf0d4$var$Yb(a);
    return null !== a ? $132d94fbf41cf0d4$var$$b(a) : null;
}
function $132d94fbf41cf0d4$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $132d94fbf41cf0d4$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $132d94fbf41cf0d4$var$ac = $aVkVc.unstable_scheduleCallback, $132d94fbf41cf0d4$var$bc = $aVkVc.unstable_cancelCallback, $132d94fbf41cf0d4$var$cc = $aVkVc.unstable_shouldYield, $132d94fbf41cf0d4$var$dc = $aVkVc.unstable_requestPaint, $132d94fbf41cf0d4$var$B = $aVkVc.unstable_now, $132d94fbf41cf0d4$var$ec = $aVkVc.unstable_getCurrentPriorityLevel, $132d94fbf41cf0d4$var$fc = $aVkVc.unstable_ImmediatePriority, $132d94fbf41cf0d4$var$gc = $aVkVc.unstable_UserBlockingPriority, $132d94fbf41cf0d4$var$hc = $aVkVc.unstable_NormalPriority, $132d94fbf41cf0d4$var$ic = $aVkVc.unstable_LowPriority, $132d94fbf41cf0d4$var$jc = $aVkVc.unstable_IdlePriority, $132d94fbf41cf0d4$var$kc = null, $132d94fbf41cf0d4$var$lc = null;
function $132d94fbf41cf0d4$var$mc(a) {
    if ($132d94fbf41cf0d4$var$lc && "function" === typeof $132d94fbf41cf0d4$var$lc.onCommitFiberRoot) try {
        $132d94fbf41cf0d4$var$lc.onCommitFiberRoot($132d94fbf41cf0d4$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $132d94fbf41cf0d4$var$oc = Math.clz32 ? Math.clz32 : $132d94fbf41cf0d4$var$nc, $132d94fbf41cf0d4$var$pc = Math.log, $132d94fbf41cf0d4$var$qc = Math.LN2;
function $132d94fbf41cf0d4$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($132d94fbf41cf0d4$var$pc(a) / $132d94fbf41cf0d4$var$qc | 0) | 0;
}
var $132d94fbf41cf0d4$var$rc = 64, $132d94fbf41cf0d4$var$sc = 4194304;
function $132d94fbf41cf0d4$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $132d94fbf41cf0d4$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $132d94fbf41cf0d4$var$tc(h) : (f &= g, 0 !== f && (d = $132d94fbf41cf0d4$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $132d94fbf41cf0d4$var$tc(g) : 0 !== f && (d = $132d94fbf41cf0d4$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $132d94fbf41cf0d4$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $132d94fbf41cf0d4$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $132d94fbf41cf0d4$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $132d94fbf41cf0d4$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $132d94fbf41cf0d4$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $132d94fbf41cf0d4$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $132d94fbf41cf0d4$var$yc() {
    var a = $132d94fbf41cf0d4$var$rc;
    $132d94fbf41cf0d4$var$rc <<= 1;
    0 === ($132d94fbf41cf0d4$var$rc & 4194240) && ($132d94fbf41cf0d4$var$rc = 64);
    return a;
}
function $132d94fbf41cf0d4$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $132d94fbf41cf0d4$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $132d94fbf41cf0d4$var$oc(b);
    a[b] = c;
}
function $132d94fbf41cf0d4$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $132d94fbf41cf0d4$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $132d94fbf41cf0d4$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $132d94fbf41cf0d4$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $132d94fbf41cf0d4$var$C = 0;
function $132d94fbf41cf0d4$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $132d94fbf41cf0d4$var$Ec, $132d94fbf41cf0d4$var$Fc, $132d94fbf41cf0d4$var$Gc, $132d94fbf41cf0d4$var$Hc, $132d94fbf41cf0d4$var$Ic, $132d94fbf41cf0d4$var$Jc = !1, $132d94fbf41cf0d4$var$Kc = [], $132d94fbf41cf0d4$var$Lc = null, $132d94fbf41cf0d4$var$Mc = null, $132d94fbf41cf0d4$var$Nc = null, $132d94fbf41cf0d4$var$Oc = new Map, $132d94fbf41cf0d4$var$Pc = new Map, $132d94fbf41cf0d4$var$Qc = [], $132d94fbf41cf0d4$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $132d94fbf41cf0d4$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $132d94fbf41cf0d4$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $132d94fbf41cf0d4$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $132d94fbf41cf0d4$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $132d94fbf41cf0d4$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $132d94fbf41cf0d4$var$Pc.delete(b.pointerId);
    }
}
function $132d94fbf41cf0d4$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $132d94fbf41cf0d4$var$Cb(b), null !== b && $132d94fbf41cf0d4$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $132d94fbf41cf0d4$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $132d94fbf41cf0d4$var$Lc = $132d94fbf41cf0d4$var$Tc($132d94fbf41cf0d4$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $132d94fbf41cf0d4$var$Mc = $132d94fbf41cf0d4$var$Tc($132d94fbf41cf0d4$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $132d94fbf41cf0d4$var$Nc = $132d94fbf41cf0d4$var$Tc($132d94fbf41cf0d4$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $132d94fbf41cf0d4$var$Oc.set(f, $132d94fbf41cf0d4$var$Tc($132d94fbf41cf0d4$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $132d94fbf41cf0d4$var$Pc.set(f, $132d94fbf41cf0d4$var$Tc($132d94fbf41cf0d4$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $132d94fbf41cf0d4$var$Vc(a) {
    var b = $132d94fbf41cf0d4$var$Wc(a.target);
    if (null !== b) {
        var c = $132d94fbf41cf0d4$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $132d94fbf41cf0d4$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $132d94fbf41cf0d4$var$Ic(a.priority, function() {
                        $132d94fbf41cf0d4$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $132d94fbf41cf0d4$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $132d94fbf41cf0d4$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $132d94fbf41cf0d4$var$wb = d;
            c.target.dispatchEvent(d);
            $132d94fbf41cf0d4$var$wb = null;
        } else return b = $132d94fbf41cf0d4$var$Cb(c), null !== b && $132d94fbf41cf0d4$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $132d94fbf41cf0d4$var$Zc(a, b, c) {
    $132d94fbf41cf0d4$var$Xc(a) && c.delete(b);
}
function $132d94fbf41cf0d4$var$$c() {
    $132d94fbf41cf0d4$var$Jc = !1;
    null !== $132d94fbf41cf0d4$var$Lc && $132d94fbf41cf0d4$var$Xc($132d94fbf41cf0d4$var$Lc) && ($132d94fbf41cf0d4$var$Lc = null);
    null !== $132d94fbf41cf0d4$var$Mc && $132d94fbf41cf0d4$var$Xc($132d94fbf41cf0d4$var$Mc) && ($132d94fbf41cf0d4$var$Mc = null);
    null !== $132d94fbf41cf0d4$var$Nc && $132d94fbf41cf0d4$var$Xc($132d94fbf41cf0d4$var$Nc) && ($132d94fbf41cf0d4$var$Nc = null);
    $132d94fbf41cf0d4$var$Oc.forEach($132d94fbf41cf0d4$var$Zc);
    $132d94fbf41cf0d4$var$Pc.forEach($132d94fbf41cf0d4$var$Zc);
}
function $132d94fbf41cf0d4$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $132d94fbf41cf0d4$var$Jc || ($132d94fbf41cf0d4$var$Jc = !0, $aVkVc.unstable_scheduleCallback($aVkVc.unstable_NormalPriority, $132d94fbf41cf0d4$var$$c)));
}
function $132d94fbf41cf0d4$var$bd(a) {
    function b(b) {
        return $132d94fbf41cf0d4$var$ad(b, a);
    }
    if (0 < $132d94fbf41cf0d4$var$Kc.length) {
        $132d94fbf41cf0d4$var$ad($132d94fbf41cf0d4$var$Kc[0], a);
        for(var c = 1; c < $132d94fbf41cf0d4$var$Kc.length; c++){
            var d = $132d94fbf41cf0d4$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $132d94fbf41cf0d4$var$Lc && $132d94fbf41cf0d4$var$ad($132d94fbf41cf0d4$var$Lc, a);
    null !== $132d94fbf41cf0d4$var$Mc && $132d94fbf41cf0d4$var$ad($132d94fbf41cf0d4$var$Mc, a);
    null !== $132d94fbf41cf0d4$var$Nc && $132d94fbf41cf0d4$var$ad($132d94fbf41cf0d4$var$Nc, a);
    $132d94fbf41cf0d4$var$Oc.forEach(b);
    $132d94fbf41cf0d4$var$Pc.forEach(b);
    for(c = 0; c < $132d94fbf41cf0d4$var$Qc.length; c++)d = $132d94fbf41cf0d4$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $132d94fbf41cf0d4$var$Qc.length && (c = $132d94fbf41cf0d4$var$Qc[0], null === c.blockedOn);)$132d94fbf41cf0d4$var$Vc(c), null === c.blockedOn && $132d94fbf41cf0d4$var$Qc.shift();
}
var $132d94fbf41cf0d4$var$cd = $132d94fbf41cf0d4$var$ua.ReactCurrentBatchConfig, $132d94fbf41cf0d4$var$dd = !0;
function $132d94fbf41cf0d4$var$ed(a, b, c, d) {
    var e = $132d94fbf41cf0d4$var$C, f = $132d94fbf41cf0d4$var$cd.transition;
    $132d94fbf41cf0d4$var$cd.transition = null;
    try {
        $132d94fbf41cf0d4$var$C = 1, $132d94fbf41cf0d4$var$fd(a, b, c, d);
    } finally{
        $132d94fbf41cf0d4$var$C = e, $132d94fbf41cf0d4$var$cd.transition = f;
    }
}
function $132d94fbf41cf0d4$var$gd(a, b, c, d) {
    var e = $132d94fbf41cf0d4$var$C, f = $132d94fbf41cf0d4$var$cd.transition;
    $132d94fbf41cf0d4$var$cd.transition = null;
    try {
        $132d94fbf41cf0d4$var$C = 4, $132d94fbf41cf0d4$var$fd(a, b, c, d);
    } finally{
        $132d94fbf41cf0d4$var$C = e, $132d94fbf41cf0d4$var$cd.transition = f;
    }
}
function $132d94fbf41cf0d4$var$fd(a, b, c, d) {
    if ($132d94fbf41cf0d4$var$dd) {
        var e = $132d94fbf41cf0d4$var$Yc(a, b, c, d);
        if (null === e) $132d94fbf41cf0d4$var$hd(a, b, d, $132d94fbf41cf0d4$var$id, c), $132d94fbf41cf0d4$var$Sc(a, d);
        else if ($132d94fbf41cf0d4$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($132d94fbf41cf0d4$var$Sc(a, d), b & 4 && -1 < $132d94fbf41cf0d4$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $132d94fbf41cf0d4$var$Cb(e);
                null !== f && $132d94fbf41cf0d4$var$Ec(f);
                f = $132d94fbf41cf0d4$var$Yc(a, b, c, d);
                null === f && $132d94fbf41cf0d4$var$hd(a, b, d, $132d94fbf41cf0d4$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $132d94fbf41cf0d4$var$hd(a, b, d, null, c);
    }
}
var $132d94fbf41cf0d4$var$id = null;
function $132d94fbf41cf0d4$var$Yc(a, b, c, d) {
    $132d94fbf41cf0d4$var$id = null;
    a = $132d94fbf41cf0d4$var$xb(d);
    a = $132d94fbf41cf0d4$var$Wc(a);
    if (null !== a) {
        if (b = $132d94fbf41cf0d4$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $132d94fbf41cf0d4$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $132d94fbf41cf0d4$var$id = a;
    return null;
}
function $132d94fbf41cf0d4$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($132d94fbf41cf0d4$var$ec()){
                case $132d94fbf41cf0d4$var$fc:
                    return 1;
                case $132d94fbf41cf0d4$var$gc:
                    return 4;
                case $132d94fbf41cf0d4$var$hc:
                case $132d94fbf41cf0d4$var$ic:
                    return 16;
                case $132d94fbf41cf0d4$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $132d94fbf41cf0d4$var$kd = null, $132d94fbf41cf0d4$var$ld = null, $132d94fbf41cf0d4$var$md = null;
function $132d94fbf41cf0d4$var$nd() {
    if ($132d94fbf41cf0d4$var$md) return $132d94fbf41cf0d4$var$md;
    var a, b = $132d94fbf41cf0d4$var$ld, c = b.length, d, e = "value" in $132d94fbf41cf0d4$var$kd ? $132d94fbf41cf0d4$var$kd.value : $132d94fbf41cf0d4$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $132d94fbf41cf0d4$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $132d94fbf41cf0d4$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $132d94fbf41cf0d4$var$pd() {
    return !0;
}
function $132d94fbf41cf0d4$var$qd() {
    return !1;
}
function $132d94fbf41cf0d4$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $132d94fbf41cf0d4$var$pd : $132d94fbf41cf0d4$var$qd;
        this.isPropagationStopped = $132d94fbf41cf0d4$var$qd;
        return this;
    }
    $132d94fbf41cf0d4$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $132d94fbf41cf0d4$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $132d94fbf41cf0d4$var$pd);
        },
        persist: function() {},
        isPersistent: $132d94fbf41cf0d4$var$pd
    });
    return b;
}
var $132d94fbf41cf0d4$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $132d94fbf41cf0d4$var$td = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$sd), $132d94fbf41cf0d4$var$ud = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$sd, {
    view: 0,
    detail: 0
}), $132d94fbf41cf0d4$var$vd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$ud), $132d94fbf41cf0d4$var$wd, $132d94fbf41cf0d4$var$xd, $132d94fbf41cf0d4$var$yd, $132d94fbf41cf0d4$var$Ad = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $132d94fbf41cf0d4$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $132d94fbf41cf0d4$var$yd && ($132d94fbf41cf0d4$var$yd && "mousemove" === a.type ? ($132d94fbf41cf0d4$var$wd = a.screenX - $132d94fbf41cf0d4$var$yd.screenX, $132d94fbf41cf0d4$var$xd = a.screenY - $132d94fbf41cf0d4$var$yd.screenY) : $132d94fbf41cf0d4$var$xd = $132d94fbf41cf0d4$var$wd = 0, $132d94fbf41cf0d4$var$yd = a);
        return $132d94fbf41cf0d4$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $132d94fbf41cf0d4$var$xd;
    }
}), $132d94fbf41cf0d4$var$Bd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Ad), $132d94fbf41cf0d4$var$Cd = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$Ad, {
    dataTransfer: 0
}), $132d94fbf41cf0d4$var$Dd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Cd), $132d94fbf41cf0d4$var$Ed = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$ud, {
    relatedTarget: 0
}), $132d94fbf41cf0d4$var$Fd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Ed), $132d94fbf41cf0d4$var$Gd = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $132d94fbf41cf0d4$var$Hd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Gd), $132d94fbf41cf0d4$var$Id = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $132d94fbf41cf0d4$var$Jd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Id), $132d94fbf41cf0d4$var$Kd = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$sd, {
    data: 0
}), $132d94fbf41cf0d4$var$Ld = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Kd), $132d94fbf41cf0d4$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $132d94fbf41cf0d4$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $132d94fbf41cf0d4$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $132d94fbf41cf0d4$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $132d94fbf41cf0d4$var$Od[a]) ? !!b[a] : !1;
}
function $132d94fbf41cf0d4$var$zd() {
    return $132d94fbf41cf0d4$var$Pd;
}
var $132d94fbf41cf0d4$var$Qd = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $132d94fbf41cf0d4$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $132d94fbf41cf0d4$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $132d94fbf41cf0d4$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $132d94fbf41cf0d4$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $132d94fbf41cf0d4$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $132d94fbf41cf0d4$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $132d94fbf41cf0d4$var$Rd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Qd), $132d94fbf41cf0d4$var$Sd = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $132d94fbf41cf0d4$var$Td = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Sd), $132d94fbf41cf0d4$var$Ud = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $132d94fbf41cf0d4$var$zd
}), $132d94fbf41cf0d4$var$Vd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Ud), $132d94fbf41cf0d4$var$Wd = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $132d94fbf41cf0d4$var$Xd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Wd), $132d94fbf41cf0d4$var$Yd = $132d94fbf41cf0d4$var$A({}, $132d94fbf41cf0d4$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $132d94fbf41cf0d4$var$Zd = $132d94fbf41cf0d4$var$rd($132d94fbf41cf0d4$var$Yd), $132d94fbf41cf0d4$var$$d = [
    9,
    13,
    27,
    32
], $132d94fbf41cf0d4$var$ae = $132d94fbf41cf0d4$var$ia && "CompositionEvent" in window, $132d94fbf41cf0d4$var$be = null;
$132d94fbf41cf0d4$var$ia && "documentMode" in document && ($132d94fbf41cf0d4$var$be = document.documentMode);
var $132d94fbf41cf0d4$var$ce = $132d94fbf41cf0d4$var$ia && "TextEvent" in window && !$132d94fbf41cf0d4$var$be, $132d94fbf41cf0d4$var$de = $132d94fbf41cf0d4$var$ia && (!$132d94fbf41cf0d4$var$ae || $132d94fbf41cf0d4$var$be && 8 < $132d94fbf41cf0d4$var$be && 11 >= $132d94fbf41cf0d4$var$be), $132d94fbf41cf0d4$var$ee = String.fromCharCode(32), $132d94fbf41cf0d4$var$fe = !1;
function $132d94fbf41cf0d4$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $132d94fbf41cf0d4$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $132d94fbf41cf0d4$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $132d94fbf41cf0d4$var$ie = !1;
function $132d94fbf41cf0d4$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $132d94fbf41cf0d4$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $132d94fbf41cf0d4$var$fe = !0;
            return $132d94fbf41cf0d4$var$ee;
        case "textInput":
            return a = b.data, a === $132d94fbf41cf0d4$var$ee && $132d94fbf41cf0d4$var$fe ? null : a;
        default:
            return null;
    }
}
function $132d94fbf41cf0d4$var$ke(a, b) {
    if ($132d94fbf41cf0d4$var$ie) return "compositionend" === a || !$132d94fbf41cf0d4$var$ae && $132d94fbf41cf0d4$var$ge(a, b) ? (a = $132d94fbf41cf0d4$var$nd(), $132d94fbf41cf0d4$var$md = $132d94fbf41cf0d4$var$ld = $132d94fbf41cf0d4$var$kd = null, $132d94fbf41cf0d4$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $132d94fbf41cf0d4$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $132d94fbf41cf0d4$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $132d94fbf41cf0d4$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$132d94fbf41cf0d4$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $132d94fbf41cf0d4$var$ne(a, b, c, d) {
    $132d94fbf41cf0d4$var$Eb(d);
    b = $132d94fbf41cf0d4$var$oe(b, "onChange");
    0 < b.length && (c = new $132d94fbf41cf0d4$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $132d94fbf41cf0d4$var$pe = null, $132d94fbf41cf0d4$var$qe = null;
function $132d94fbf41cf0d4$var$re(a) {
    $132d94fbf41cf0d4$var$se(a, 0);
}
function $132d94fbf41cf0d4$var$te(a) {
    var b = $132d94fbf41cf0d4$var$ue(a);
    if ($132d94fbf41cf0d4$var$Wa(b)) return a;
}
function $132d94fbf41cf0d4$var$ve(a, b) {
    if ("change" === a) return b;
}
var $132d94fbf41cf0d4$var$we = !1;
if ($132d94fbf41cf0d4$var$ia) {
    var $132d94fbf41cf0d4$var$xe;
    if ($132d94fbf41cf0d4$var$ia) {
        var $132d94fbf41cf0d4$var$ye = "oninput" in document;
        if (!$132d94fbf41cf0d4$var$ye) {
            var $132d94fbf41cf0d4$var$ze = document.createElement("div");
            $132d94fbf41cf0d4$var$ze.setAttribute("oninput", "return;");
            $132d94fbf41cf0d4$var$ye = "function" === typeof $132d94fbf41cf0d4$var$ze.oninput;
        }
        $132d94fbf41cf0d4$var$xe = $132d94fbf41cf0d4$var$ye;
    } else $132d94fbf41cf0d4$var$xe = !1;
    $132d94fbf41cf0d4$var$we = $132d94fbf41cf0d4$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $132d94fbf41cf0d4$var$Ae() {
    $132d94fbf41cf0d4$var$pe && ($132d94fbf41cf0d4$var$pe.detachEvent("onpropertychange", $132d94fbf41cf0d4$var$Be), $132d94fbf41cf0d4$var$qe = $132d94fbf41cf0d4$var$pe = null);
}
function $132d94fbf41cf0d4$var$Be(a) {
    if ("value" === a.propertyName && $132d94fbf41cf0d4$var$te($132d94fbf41cf0d4$var$qe)) {
        var b = [];
        $132d94fbf41cf0d4$var$ne(b, $132d94fbf41cf0d4$var$qe, a, $132d94fbf41cf0d4$var$xb(a));
        $132d94fbf41cf0d4$var$Jb($132d94fbf41cf0d4$var$re, b);
    }
}
function $132d94fbf41cf0d4$var$Ce(a, b, c) {
    "focusin" === a ? ($132d94fbf41cf0d4$var$Ae(), $132d94fbf41cf0d4$var$pe = b, $132d94fbf41cf0d4$var$qe = c, $132d94fbf41cf0d4$var$pe.attachEvent("onpropertychange", $132d94fbf41cf0d4$var$Be)) : "focusout" === a && $132d94fbf41cf0d4$var$Ae();
}
function $132d94fbf41cf0d4$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $132d94fbf41cf0d4$var$te($132d94fbf41cf0d4$var$qe);
}
function $132d94fbf41cf0d4$var$Ee(a, b) {
    if ("click" === a) return $132d94fbf41cf0d4$var$te(b);
}
function $132d94fbf41cf0d4$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $132d94fbf41cf0d4$var$te(b);
}
function $132d94fbf41cf0d4$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $132d94fbf41cf0d4$var$He = "function" === typeof Object.is ? Object.is : $132d94fbf41cf0d4$var$Ge;
function $132d94fbf41cf0d4$var$Ie(a, b) {
    if ($132d94fbf41cf0d4$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$132d94fbf41cf0d4$var$ja.call(b, e) || !$132d94fbf41cf0d4$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $132d94fbf41cf0d4$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $132d94fbf41cf0d4$var$Ke(a, b) {
    var c = $132d94fbf41cf0d4$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $132d94fbf41cf0d4$var$Je(c);
    }
}
function $132d94fbf41cf0d4$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $132d94fbf41cf0d4$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $132d94fbf41cf0d4$var$Me() {
    for(var a = window, b = $132d94fbf41cf0d4$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $132d94fbf41cf0d4$var$Xa(a.document);
    }
    return b;
}
function $132d94fbf41cf0d4$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $132d94fbf41cf0d4$var$Oe(a) {
    var b = $132d94fbf41cf0d4$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $132d94fbf41cf0d4$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $132d94fbf41cf0d4$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $132d94fbf41cf0d4$var$Ke(c, f);
                var g = $132d94fbf41cf0d4$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $132d94fbf41cf0d4$var$Pe = $132d94fbf41cf0d4$var$ia && "documentMode" in document && 11 >= document.documentMode, $132d94fbf41cf0d4$var$Qe = null, $132d94fbf41cf0d4$var$Re = null, $132d94fbf41cf0d4$var$Se = null, $132d94fbf41cf0d4$var$Te = !1;
function $132d94fbf41cf0d4$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $132d94fbf41cf0d4$var$Te || null == $132d94fbf41cf0d4$var$Qe || $132d94fbf41cf0d4$var$Qe !== $132d94fbf41cf0d4$var$Xa(d) || (d = $132d94fbf41cf0d4$var$Qe, "selectionStart" in d && $132d94fbf41cf0d4$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $132d94fbf41cf0d4$var$Se && $132d94fbf41cf0d4$var$Ie($132d94fbf41cf0d4$var$Se, d) || ($132d94fbf41cf0d4$var$Se = d, d = $132d94fbf41cf0d4$var$oe($132d94fbf41cf0d4$var$Re, "onSelect"), 0 < d.length && (b = new $132d94fbf41cf0d4$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $132d94fbf41cf0d4$var$Qe)));
}
function $132d94fbf41cf0d4$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $132d94fbf41cf0d4$var$We = {
    animationend: $132d94fbf41cf0d4$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $132d94fbf41cf0d4$var$Ve("Animation", "AnimationIteration"),
    animationstart: $132d94fbf41cf0d4$var$Ve("Animation", "AnimationStart"),
    transitionend: $132d94fbf41cf0d4$var$Ve("Transition", "TransitionEnd")
}, $132d94fbf41cf0d4$var$Xe = {}, $132d94fbf41cf0d4$var$Ye = {};
$132d94fbf41cf0d4$var$ia && ($132d94fbf41cf0d4$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $132d94fbf41cf0d4$var$We.animationend.animation, delete $132d94fbf41cf0d4$var$We.animationiteration.animation, delete $132d94fbf41cf0d4$var$We.animationstart.animation), "TransitionEvent" in window || delete $132d94fbf41cf0d4$var$We.transitionend.transition);
function $132d94fbf41cf0d4$var$Ze(a) {
    if ($132d94fbf41cf0d4$var$Xe[a]) return $132d94fbf41cf0d4$var$Xe[a];
    if (!$132d94fbf41cf0d4$var$We[a]) return a;
    var b = $132d94fbf41cf0d4$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $132d94fbf41cf0d4$var$Ye) return $132d94fbf41cf0d4$var$Xe[a] = b[c];
    return a;
}
var $132d94fbf41cf0d4$var$$e = $132d94fbf41cf0d4$var$Ze("animationend"), $132d94fbf41cf0d4$var$af = $132d94fbf41cf0d4$var$Ze("animationiteration"), $132d94fbf41cf0d4$var$bf = $132d94fbf41cf0d4$var$Ze("animationstart"), $132d94fbf41cf0d4$var$cf = $132d94fbf41cf0d4$var$Ze("transitionend"), $132d94fbf41cf0d4$var$df = new Map, $132d94fbf41cf0d4$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $132d94fbf41cf0d4$var$ff(a, b) {
    $132d94fbf41cf0d4$var$df.set(a, b);
    $132d94fbf41cf0d4$var$fa(b, [
        a
    ]);
}
for(var $132d94fbf41cf0d4$var$gf = 0; $132d94fbf41cf0d4$var$gf < $132d94fbf41cf0d4$var$ef.length; $132d94fbf41cf0d4$var$gf++){
    var $132d94fbf41cf0d4$var$hf = $132d94fbf41cf0d4$var$ef[$132d94fbf41cf0d4$var$gf], $132d94fbf41cf0d4$var$jf = $132d94fbf41cf0d4$var$hf.toLowerCase(), $132d94fbf41cf0d4$var$kf = $132d94fbf41cf0d4$var$hf[0].toUpperCase() + $132d94fbf41cf0d4$var$hf.slice(1);
    $132d94fbf41cf0d4$var$ff($132d94fbf41cf0d4$var$jf, "on" + $132d94fbf41cf0d4$var$kf);
}
$132d94fbf41cf0d4$var$ff($132d94fbf41cf0d4$var$$e, "onAnimationEnd");
$132d94fbf41cf0d4$var$ff($132d94fbf41cf0d4$var$af, "onAnimationIteration");
$132d94fbf41cf0d4$var$ff($132d94fbf41cf0d4$var$bf, "onAnimationStart");
$132d94fbf41cf0d4$var$ff("dblclick", "onDoubleClick");
$132d94fbf41cf0d4$var$ff("focusin", "onFocus");
$132d94fbf41cf0d4$var$ff("focusout", "onBlur");
$132d94fbf41cf0d4$var$ff($132d94fbf41cf0d4$var$cf, "onTransitionEnd");
$132d94fbf41cf0d4$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$132d94fbf41cf0d4$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$132d94fbf41cf0d4$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$132d94fbf41cf0d4$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$132d94fbf41cf0d4$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$132d94fbf41cf0d4$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$132d94fbf41cf0d4$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$132d94fbf41cf0d4$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$132d94fbf41cf0d4$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$132d94fbf41cf0d4$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $132d94fbf41cf0d4$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $132d94fbf41cf0d4$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($132d94fbf41cf0d4$var$lf));
function $132d94fbf41cf0d4$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $132d94fbf41cf0d4$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $132d94fbf41cf0d4$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $132d94fbf41cf0d4$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $132d94fbf41cf0d4$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($132d94fbf41cf0d4$var$Qb) throw a = $132d94fbf41cf0d4$var$Rb, $132d94fbf41cf0d4$var$Qb = !1, $132d94fbf41cf0d4$var$Rb = null, a;
}
function $132d94fbf41cf0d4$var$D(a, b) {
    var c = b[$132d94fbf41cf0d4$var$of];
    void 0 === c && (c = b[$132d94fbf41cf0d4$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($132d94fbf41cf0d4$var$pf(b, a, 2, !1), c.add(d));
}
function $132d94fbf41cf0d4$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $132d94fbf41cf0d4$var$pf(c, a, d, b);
}
var $132d94fbf41cf0d4$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $132d94fbf41cf0d4$var$sf(a) {
    if (!a[$132d94fbf41cf0d4$var$rf]) {
        a[$132d94fbf41cf0d4$var$rf] = !0;
        $132d94fbf41cf0d4$var$da.forEach(function(b) {
            "selectionchange" !== b && ($132d94fbf41cf0d4$var$mf.has(b) || $132d94fbf41cf0d4$var$qf(b, !1, a), $132d94fbf41cf0d4$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$132d94fbf41cf0d4$var$rf] || (b[$132d94fbf41cf0d4$var$rf] = !0, $132d94fbf41cf0d4$var$qf("selectionchange", !1, b));
    }
}
function $132d94fbf41cf0d4$var$pf(a, b, c, d) {
    switch($132d94fbf41cf0d4$var$jd(b)){
        case 1:
            var e = $132d94fbf41cf0d4$var$ed;
            break;
        case 4:
            e = $132d94fbf41cf0d4$var$gd;
            break;
        default:
            e = $132d94fbf41cf0d4$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$132d94fbf41cf0d4$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $132d94fbf41cf0d4$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $132d94fbf41cf0d4$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $132d94fbf41cf0d4$var$Jb(function() {
        var d = f, e = $132d94fbf41cf0d4$var$xb(c), g = [];
        a: {
            var h = $132d94fbf41cf0d4$var$df.get(a);
            if (void 0 !== h) {
                var k = $132d94fbf41cf0d4$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $132d94fbf41cf0d4$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $132d94fbf41cf0d4$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $132d94fbf41cf0d4$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $132d94fbf41cf0d4$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $132d94fbf41cf0d4$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $132d94fbf41cf0d4$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $132d94fbf41cf0d4$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $132d94fbf41cf0d4$var$Vd;
                        break;
                    case $132d94fbf41cf0d4$var$$e:
                    case $132d94fbf41cf0d4$var$af:
                    case $132d94fbf41cf0d4$var$bf:
                        k = $132d94fbf41cf0d4$var$Hd;
                        break;
                    case $132d94fbf41cf0d4$var$cf:
                        k = $132d94fbf41cf0d4$var$Xd;
                        break;
                    case "scroll":
                        k = $132d94fbf41cf0d4$var$vd;
                        break;
                    case "wheel":
                        k = $132d94fbf41cf0d4$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $132d94fbf41cf0d4$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $132d94fbf41cf0d4$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $132d94fbf41cf0d4$var$Kb(w, x), null != F && t.push($132d94fbf41cf0d4$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $132d94fbf41cf0d4$var$wb && (n = c.relatedTarget || c.fromElement) && ($132d94fbf41cf0d4$var$Wc(n) || n[$132d94fbf41cf0d4$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $132d94fbf41cf0d4$var$Wc(n) : null, null !== n && (J = $132d94fbf41cf0d4$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $132d94fbf41cf0d4$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $132d94fbf41cf0d4$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $132d94fbf41cf0d4$var$ue(k);
                        u = null == n ? h : $132d94fbf41cf0d4$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $132d94fbf41cf0d4$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $132d94fbf41cf0d4$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $132d94fbf41cf0d4$var$vf(F))u++;
                            for(; 0 < w - u;)t = $132d94fbf41cf0d4$var$vf(t), w--;
                            for(; 0 < u - w;)x = $132d94fbf41cf0d4$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $132d94fbf41cf0d4$var$vf(t);
                                x = $132d94fbf41cf0d4$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $132d94fbf41cf0d4$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $132d94fbf41cf0d4$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $132d94fbf41cf0d4$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $132d94fbf41cf0d4$var$ve;
                else if ($132d94fbf41cf0d4$var$me(h)) {
                    if ($132d94fbf41cf0d4$var$we) na = $132d94fbf41cf0d4$var$Fe;
                    else {
                        na = $132d94fbf41cf0d4$var$De;
                        var xa = $132d94fbf41cf0d4$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $132d94fbf41cf0d4$var$Ee);
                if (na && (na = na(a, d))) {
                    $132d94fbf41cf0d4$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $132d94fbf41cf0d4$var$cb(h, "number", h.value);
            }
            xa = d ? $132d94fbf41cf0d4$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($132d94fbf41cf0d4$var$me(xa) || "true" === xa.contentEditable) $132d94fbf41cf0d4$var$Qe = xa, $132d94fbf41cf0d4$var$Re = d, $132d94fbf41cf0d4$var$Se = null;
                    break;
                case "focusout":
                    $132d94fbf41cf0d4$var$Se = $132d94fbf41cf0d4$var$Re = $132d94fbf41cf0d4$var$Qe = null;
                    break;
                case "mousedown":
                    $132d94fbf41cf0d4$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $132d94fbf41cf0d4$var$Te = !1;
                    $132d94fbf41cf0d4$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($132d94fbf41cf0d4$var$Pe) break;
                case "keydown":
                case "keyup":
                    $132d94fbf41cf0d4$var$Ue(g, c, e);
            }
            var $a;
            if ($132d94fbf41cf0d4$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $132d94fbf41cf0d4$var$ie ? $132d94fbf41cf0d4$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($132d94fbf41cf0d4$var$de && "ko" !== c.locale && ($132d94fbf41cf0d4$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $132d94fbf41cf0d4$var$ie && ($a = $132d94fbf41cf0d4$var$nd()) : ($132d94fbf41cf0d4$var$kd = e, $132d94fbf41cf0d4$var$ld = "value" in $132d94fbf41cf0d4$var$kd ? $132d94fbf41cf0d4$var$kd.value : $132d94fbf41cf0d4$var$kd.textContent, $132d94fbf41cf0d4$var$ie = !0)), xa = $132d94fbf41cf0d4$var$oe(d, ba), 0 < xa.length && (ba = new $132d94fbf41cf0d4$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $132d94fbf41cf0d4$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $132d94fbf41cf0d4$var$ce ? $132d94fbf41cf0d4$var$je(a, c) : $132d94fbf41cf0d4$var$ke(a, c)) d = $132d94fbf41cf0d4$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $132d94fbf41cf0d4$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $132d94fbf41cf0d4$var$se(g, b);
    });
}
function $132d94fbf41cf0d4$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $132d94fbf41cf0d4$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $132d94fbf41cf0d4$var$Kb(a, c), null != f && d.unshift($132d94fbf41cf0d4$var$tf(a, f, e)), f = $132d94fbf41cf0d4$var$Kb(a, b), null != f && d.push($132d94fbf41cf0d4$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $132d94fbf41cf0d4$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $132d94fbf41cf0d4$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $132d94fbf41cf0d4$var$Kb(c, f), null != k && g.unshift($132d94fbf41cf0d4$var$tf(c, k, h))) : e || (k = $132d94fbf41cf0d4$var$Kb(c, f), null != k && g.push($132d94fbf41cf0d4$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $132d94fbf41cf0d4$var$xf = /\r\n?/g, $132d94fbf41cf0d4$var$yf = /\u0000|\uFFFD/g;
function $132d94fbf41cf0d4$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($132d94fbf41cf0d4$var$xf, "\n").replace($132d94fbf41cf0d4$var$yf, "");
}
function $132d94fbf41cf0d4$var$Af(a, b, c) {
    b = $132d94fbf41cf0d4$var$zf(b);
    if ($132d94fbf41cf0d4$var$zf(a) !== b && c) throw Error($132d94fbf41cf0d4$var$p(425));
}
function $132d94fbf41cf0d4$var$Bf() {}
var $132d94fbf41cf0d4$var$Cf = null, $132d94fbf41cf0d4$var$Df = null;
function $132d94fbf41cf0d4$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $132d94fbf41cf0d4$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $132d94fbf41cf0d4$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $132d94fbf41cf0d4$var$Hf = "function" === typeof Promise ? Promise : void 0, $132d94fbf41cf0d4$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $132d94fbf41cf0d4$var$Hf ? function(a) {
    return $132d94fbf41cf0d4$var$Hf.resolve(null).then(a).catch($132d94fbf41cf0d4$var$If);
} : $132d94fbf41cf0d4$var$Ff;
function $132d94fbf41cf0d4$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $132d94fbf41cf0d4$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $132d94fbf41cf0d4$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $132d94fbf41cf0d4$var$bd(b);
}
function $132d94fbf41cf0d4$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $132d94fbf41cf0d4$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $132d94fbf41cf0d4$var$Nf = Math.random().toString(36).slice(2), $132d94fbf41cf0d4$var$Of = "__reactFiber$" + $132d94fbf41cf0d4$var$Nf, $132d94fbf41cf0d4$var$Pf = "__reactProps$" + $132d94fbf41cf0d4$var$Nf, $132d94fbf41cf0d4$var$uf = "__reactContainer$" + $132d94fbf41cf0d4$var$Nf, $132d94fbf41cf0d4$var$of = "__reactEvents$" + $132d94fbf41cf0d4$var$Nf, $132d94fbf41cf0d4$var$Qf = "__reactListeners$" + $132d94fbf41cf0d4$var$Nf, $132d94fbf41cf0d4$var$Rf = "__reactHandles$" + $132d94fbf41cf0d4$var$Nf;
function $132d94fbf41cf0d4$var$Wc(a) {
    var b = a[$132d94fbf41cf0d4$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$132d94fbf41cf0d4$var$uf] || c[$132d94fbf41cf0d4$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $132d94fbf41cf0d4$var$Mf(a); null !== a;){
                if (c = a[$132d94fbf41cf0d4$var$Of]) return c;
                a = $132d94fbf41cf0d4$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $132d94fbf41cf0d4$var$Cb(a) {
    a = a[$132d94fbf41cf0d4$var$Of] || a[$132d94fbf41cf0d4$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $132d94fbf41cf0d4$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($132d94fbf41cf0d4$var$p(33));
}
function $132d94fbf41cf0d4$var$Db(a) {
    return a[$132d94fbf41cf0d4$var$Pf] || null;
}
var $132d94fbf41cf0d4$var$Sf = [], $132d94fbf41cf0d4$var$Tf = -1;
function $132d94fbf41cf0d4$var$Uf(a) {
    return {
        current: a
    };
}
function $132d94fbf41cf0d4$var$E(a) {
    0 > $132d94fbf41cf0d4$var$Tf || (a.current = $132d94fbf41cf0d4$var$Sf[$132d94fbf41cf0d4$var$Tf], $132d94fbf41cf0d4$var$Sf[$132d94fbf41cf0d4$var$Tf] = null, $132d94fbf41cf0d4$var$Tf--);
}
function $132d94fbf41cf0d4$var$G(a, b) {
    $132d94fbf41cf0d4$var$Tf++;
    $132d94fbf41cf0d4$var$Sf[$132d94fbf41cf0d4$var$Tf] = a.current;
    a.current = b;
}
var $132d94fbf41cf0d4$var$Vf = {}, $132d94fbf41cf0d4$var$H = $132d94fbf41cf0d4$var$Uf($132d94fbf41cf0d4$var$Vf), $132d94fbf41cf0d4$var$Wf = $132d94fbf41cf0d4$var$Uf(!1), $132d94fbf41cf0d4$var$Xf = $132d94fbf41cf0d4$var$Vf;
function $132d94fbf41cf0d4$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $132d94fbf41cf0d4$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $132d94fbf41cf0d4$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $132d94fbf41cf0d4$var$$f() {
    $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Wf);
    $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$H);
}
function $132d94fbf41cf0d4$var$ag(a, b, c) {
    if ($132d94fbf41cf0d4$var$H.current !== $132d94fbf41cf0d4$var$Vf) throw Error($132d94fbf41cf0d4$var$p(168));
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$H, b);
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Wf, c);
}
function $132d94fbf41cf0d4$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($132d94fbf41cf0d4$var$p(108, $132d94fbf41cf0d4$var$Ra(a) || "Unknown", e));
    return $132d94fbf41cf0d4$var$A({}, c, d);
}
function $132d94fbf41cf0d4$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $132d94fbf41cf0d4$var$Vf;
    $132d94fbf41cf0d4$var$Xf = $132d94fbf41cf0d4$var$H.current;
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$H, a);
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Wf, $132d94fbf41cf0d4$var$Wf.current);
    return !0;
}
function $132d94fbf41cf0d4$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($132d94fbf41cf0d4$var$p(169));
    c ? (a = $132d94fbf41cf0d4$var$bg(a, b, $132d94fbf41cf0d4$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Wf), $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$H), $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$H, a)) : $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Wf);
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Wf, c);
}
var $132d94fbf41cf0d4$var$eg = null, $132d94fbf41cf0d4$var$fg = !1, $132d94fbf41cf0d4$var$gg = !1;
function $132d94fbf41cf0d4$var$hg(a) {
    null === $132d94fbf41cf0d4$var$eg ? $132d94fbf41cf0d4$var$eg = [
        a
    ] : $132d94fbf41cf0d4$var$eg.push(a);
}
function $132d94fbf41cf0d4$var$ig(a) {
    $132d94fbf41cf0d4$var$fg = !0;
    $132d94fbf41cf0d4$var$hg(a);
}
function $132d94fbf41cf0d4$var$jg() {
    if (!$132d94fbf41cf0d4$var$gg && null !== $132d94fbf41cf0d4$var$eg) {
        $132d94fbf41cf0d4$var$gg = !0;
        var a = 0, b = $132d94fbf41cf0d4$var$C;
        try {
            var c = $132d94fbf41cf0d4$var$eg;
            for($132d94fbf41cf0d4$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $132d94fbf41cf0d4$var$eg = null;
            $132d94fbf41cf0d4$var$fg = !1;
        } catch (e) {
            throw null !== $132d94fbf41cf0d4$var$eg && ($132d94fbf41cf0d4$var$eg = $132d94fbf41cf0d4$var$eg.slice(a + 1)), $132d94fbf41cf0d4$var$ac($132d94fbf41cf0d4$var$fc, $132d94fbf41cf0d4$var$jg), e;
        } finally{
            $132d94fbf41cf0d4$var$C = b, $132d94fbf41cf0d4$var$gg = !1;
        }
    }
    return null;
}
var $132d94fbf41cf0d4$var$kg = [], $132d94fbf41cf0d4$var$lg = 0, $132d94fbf41cf0d4$var$mg = null, $132d94fbf41cf0d4$var$ng = 0, $132d94fbf41cf0d4$var$og = [], $132d94fbf41cf0d4$var$pg = 0, $132d94fbf41cf0d4$var$qg = null, $132d94fbf41cf0d4$var$rg = 1, $132d94fbf41cf0d4$var$sg = "";
function $132d94fbf41cf0d4$var$tg(a, b) {
    $132d94fbf41cf0d4$var$kg[$132d94fbf41cf0d4$var$lg++] = $132d94fbf41cf0d4$var$ng;
    $132d94fbf41cf0d4$var$kg[$132d94fbf41cf0d4$var$lg++] = $132d94fbf41cf0d4$var$mg;
    $132d94fbf41cf0d4$var$mg = a;
    $132d94fbf41cf0d4$var$ng = b;
}
function $132d94fbf41cf0d4$var$ug(a, b, c) {
    $132d94fbf41cf0d4$var$og[$132d94fbf41cf0d4$var$pg++] = $132d94fbf41cf0d4$var$rg;
    $132d94fbf41cf0d4$var$og[$132d94fbf41cf0d4$var$pg++] = $132d94fbf41cf0d4$var$sg;
    $132d94fbf41cf0d4$var$og[$132d94fbf41cf0d4$var$pg++] = $132d94fbf41cf0d4$var$qg;
    $132d94fbf41cf0d4$var$qg = a;
    var d = $132d94fbf41cf0d4$var$rg;
    a = $132d94fbf41cf0d4$var$sg;
    var e = 32 - $132d94fbf41cf0d4$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $132d94fbf41cf0d4$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $132d94fbf41cf0d4$var$rg = 1 << 32 - $132d94fbf41cf0d4$var$oc(b) + e | c << e | d;
        $132d94fbf41cf0d4$var$sg = f + a;
    } else $132d94fbf41cf0d4$var$rg = 1 << f | c << e | d, $132d94fbf41cf0d4$var$sg = a;
}
function $132d94fbf41cf0d4$var$vg(a) {
    null !== a.return && ($132d94fbf41cf0d4$var$tg(a, 1), $132d94fbf41cf0d4$var$ug(a, 1, 0));
}
function $132d94fbf41cf0d4$var$wg(a) {
    for(; a === $132d94fbf41cf0d4$var$mg;)$132d94fbf41cf0d4$var$mg = $132d94fbf41cf0d4$var$kg[--$132d94fbf41cf0d4$var$lg], $132d94fbf41cf0d4$var$kg[$132d94fbf41cf0d4$var$lg] = null, $132d94fbf41cf0d4$var$ng = $132d94fbf41cf0d4$var$kg[--$132d94fbf41cf0d4$var$lg], $132d94fbf41cf0d4$var$kg[$132d94fbf41cf0d4$var$lg] = null;
    for(; a === $132d94fbf41cf0d4$var$qg;)$132d94fbf41cf0d4$var$qg = $132d94fbf41cf0d4$var$og[--$132d94fbf41cf0d4$var$pg], $132d94fbf41cf0d4$var$og[$132d94fbf41cf0d4$var$pg] = null, $132d94fbf41cf0d4$var$sg = $132d94fbf41cf0d4$var$og[--$132d94fbf41cf0d4$var$pg], $132d94fbf41cf0d4$var$og[$132d94fbf41cf0d4$var$pg] = null, $132d94fbf41cf0d4$var$rg = $132d94fbf41cf0d4$var$og[--$132d94fbf41cf0d4$var$pg], $132d94fbf41cf0d4$var$og[$132d94fbf41cf0d4$var$pg] = null;
}
var $132d94fbf41cf0d4$var$xg = null, $132d94fbf41cf0d4$var$yg = null, $132d94fbf41cf0d4$var$I = !1, $132d94fbf41cf0d4$var$zg = null;
function $132d94fbf41cf0d4$var$Ag(a, b) {
    var c = $132d94fbf41cf0d4$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $132d94fbf41cf0d4$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $132d94fbf41cf0d4$var$xg = a, $132d94fbf41cf0d4$var$yg = $132d94fbf41cf0d4$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $132d94fbf41cf0d4$var$xg = a, $132d94fbf41cf0d4$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $132d94fbf41cf0d4$var$qg ? {
                id: $132d94fbf41cf0d4$var$rg,
                overflow: $132d94fbf41cf0d4$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $132d94fbf41cf0d4$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $132d94fbf41cf0d4$var$xg = a, $132d94fbf41cf0d4$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $132d94fbf41cf0d4$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $132d94fbf41cf0d4$var$Eg(a) {
    if ($132d94fbf41cf0d4$var$I) {
        var b = $132d94fbf41cf0d4$var$yg;
        if (b) {
            var c = b;
            if (!$132d94fbf41cf0d4$var$Cg(a, b)) {
                if ($132d94fbf41cf0d4$var$Dg(a)) throw Error($132d94fbf41cf0d4$var$p(418));
                b = $132d94fbf41cf0d4$var$Lf(c.nextSibling);
                var d = $132d94fbf41cf0d4$var$xg;
                b && $132d94fbf41cf0d4$var$Cg(a, b) ? $132d94fbf41cf0d4$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $132d94fbf41cf0d4$var$I = !1, $132d94fbf41cf0d4$var$xg = a);
            }
        } else {
            if ($132d94fbf41cf0d4$var$Dg(a)) throw Error($132d94fbf41cf0d4$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $132d94fbf41cf0d4$var$I = !1;
            $132d94fbf41cf0d4$var$xg = a;
        }
    }
}
function $132d94fbf41cf0d4$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $132d94fbf41cf0d4$var$xg = a;
}
function $132d94fbf41cf0d4$var$Gg(a) {
    if (a !== $132d94fbf41cf0d4$var$xg) return !1;
    if (!$132d94fbf41cf0d4$var$I) return $132d94fbf41cf0d4$var$Fg(a), $132d94fbf41cf0d4$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$132d94fbf41cf0d4$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $132d94fbf41cf0d4$var$yg)) {
        if ($132d94fbf41cf0d4$var$Dg(a)) throw $132d94fbf41cf0d4$var$Hg(), Error($132d94fbf41cf0d4$var$p(418));
        for(; b;)$132d94fbf41cf0d4$var$Ag(a, b), b = $132d94fbf41cf0d4$var$Lf(b.nextSibling);
    }
    $132d94fbf41cf0d4$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($132d94fbf41cf0d4$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $132d94fbf41cf0d4$var$yg = $132d94fbf41cf0d4$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $132d94fbf41cf0d4$var$yg = null;
        }
    } else $132d94fbf41cf0d4$var$yg = $132d94fbf41cf0d4$var$xg ? $132d94fbf41cf0d4$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $132d94fbf41cf0d4$var$Hg() {
    for(var a = $132d94fbf41cf0d4$var$yg; a;)a = $132d94fbf41cf0d4$var$Lf(a.nextSibling);
}
function $132d94fbf41cf0d4$var$Ig() {
    $132d94fbf41cf0d4$var$yg = $132d94fbf41cf0d4$var$xg = null;
    $132d94fbf41cf0d4$var$I = !1;
}
function $132d94fbf41cf0d4$var$Jg(a) {
    null === $132d94fbf41cf0d4$var$zg ? $132d94fbf41cf0d4$var$zg = [
        a
    ] : $132d94fbf41cf0d4$var$zg.push(a);
}
var $132d94fbf41cf0d4$var$Kg = $132d94fbf41cf0d4$var$ua.ReactCurrentBatchConfig;
function $132d94fbf41cf0d4$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $132d94fbf41cf0d4$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $132d94fbf41cf0d4$var$Mg = $132d94fbf41cf0d4$var$Uf(null), $132d94fbf41cf0d4$var$Ng = null, $132d94fbf41cf0d4$var$Og = null, $132d94fbf41cf0d4$var$Pg = null;
function $132d94fbf41cf0d4$var$Qg() {
    $132d94fbf41cf0d4$var$Pg = $132d94fbf41cf0d4$var$Og = $132d94fbf41cf0d4$var$Ng = null;
}
function $132d94fbf41cf0d4$var$Rg(a) {
    var b = $132d94fbf41cf0d4$var$Mg.current;
    $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Mg);
    a._currentValue = b;
}
function $132d94fbf41cf0d4$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $132d94fbf41cf0d4$var$Tg(a, b) {
    $132d94fbf41cf0d4$var$Ng = a;
    $132d94fbf41cf0d4$var$Pg = $132d94fbf41cf0d4$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($132d94fbf41cf0d4$var$Ug = !0), a.firstContext = null);
}
function $132d94fbf41cf0d4$var$Vg(a) {
    var b = a._currentValue;
    if ($132d94fbf41cf0d4$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $132d94fbf41cf0d4$var$Og) {
            if (null === $132d94fbf41cf0d4$var$Ng) throw Error($132d94fbf41cf0d4$var$p(308));
            $132d94fbf41cf0d4$var$Og = a;
            $132d94fbf41cf0d4$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $132d94fbf41cf0d4$var$Og = $132d94fbf41cf0d4$var$Og.next = a;
    }
    return b;
}
var $132d94fbf41cf0d4$var$Wg = null;
function $132d94fbf41cf0d4$var$Xg(a) {
    null === $132d94fbf41cf0d4$var$Wg ? $132d94fbf41cf0d4$var$Wg = [
        a
    ] : $132d94fbf41cf0d4$var$Wg.push(a);
}
function $132d94fbf41cf0d4$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $132d94fbf41cf0d4$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $132d94fbf41cf0d4$var$Zg(a, d);
}
function $132d94fbf41cf0d4$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $132d94fbf41cf0d4$var$$g = !1;
function $132d94fbf41cf0d4$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $132d94fbf41cf0d4$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $132d94fbf41cf0d4$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $132d94fbf41cf0d4$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($132d94fbf41cf0d4$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $132d94fbf41cf0d4$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $132d94fbf41cf0d4$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $132d94fbf41cf0d4$var$Zg(a, c);
}
function $132d94fbf41cf0d4$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $132d94fbf41cf0d4$var$Cc(a, c);
    }
}
function $132d94fbf41cf0d4$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $132d94fbf41cf0d4$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $132d94fbf41cf0d4$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $132d94fbf41cf0d4$var$A({}, q, r);
                            break a;
                        case 2:
                            $132d94fbf41cf0d4$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $132d94fbf41cf0d4$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $132d94fbf41cf0d4$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($132d94fbf41cf0d4$var$p(191, e));
            e.call(d);
        }
    }
}
var $132d94fbf41cf0d4$var$jh = (new $lT7pJ.Component).refs;
function $132d94fbf41cf0d4$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $132d94fbf41cf0d4$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $132d94fbf41cf0d4$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $132d94fbf41cf0d4$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $132d94fbf41cf0d4$var$L(), e = $132d94fbf41cf0d4$var$lh(a), f = $132d94fbf41cf0d4$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $132d94fbf41cf0d4$var$dh(a, f, e);
        null !== b && ($132d94fbf41cf0d4$var$mh(b, a, e, d), $132d94fbf41cf0d4$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $132d94fbf41cf0d4$var$L(), e = $132d94fbf41cf0d4$var$lh(a), f = $132d94fbf41cf0d4$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $132d94fbf41cf0d4$var$dh(a, f, e);
        null !== b && ($132d94fbf41cf0d4$var$mh(b, a, e, d), $132d94fbf41cf0d4$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $132d94fbf41cf0d4$var$L(), d = $132d94fbf41cf0d4$var$lh(a), e = $132d94fbf41cf0d4$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $132d94fbf41cf0d4$var$dh(a, e, d);
        null !== b && ($132d94fbf41cf0d4$var$mh(b, a, d, c), $132d94fbf41cf0d4$var$eh(b, a, d));
    }
};
function $132d94fbf41cf0d4$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$132d94fbf41cf0d4$var$Ie(c, d) || !$132d94fbf41cf0d4$var$Ie(e, f) : !0;
}
function $132d94fbf41cf0d4$var$ph(a, b, c) {
    var d = !1, e = $132d94fbf41cf0d4$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $132d94fbf41cf0d4$var$Vg(f) : (e = $132d94fbf41cf0d4$var$Zf(b) ? $132d94fbf41cf0d4$var$Xf : $132d94fbf41cf0d4$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $132d94fbf41cf0d4$var$Yf(a, e) : $132d94fbf41cf0d4$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $132d94fbf41cf0d4$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $132d94fbf41cf0d4$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $132d94fbf41cf0d4$var$nh.enqueueReplaceState(b, b.state, null);
}
function $132d94fbf41cf0d4$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $132d94fbf41cf0d4$var$jh;
    $132d94fbf41cf0d4$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $132d94fbf41cf0d4$var$Vg(f) : (f = $132d94fbf41cf0d4$var$Zf(b) ? $132d94fbf41cf0d4$var$Xf : $132d94fbf41cf0d4$var$H.current, e.context = $132d94fbf41cf0d4$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($132d94fbf41cf0d4$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $132d94fbf41cf0d4$var$nh.enqueueReplaceState(e, e.state, null), $132d94fbf41cf0d4$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $132d94fbf41cf0d4$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($132d94fbf41cf0d4$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($132d94fbf41cf0d4$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $132d94fbf41cf0d4$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($132d94fbf41cf0d4$var$p(284));
        if (!c._owner) throw Error($132d94fbf41cf0d4$var$p(290, a));
    }
    return a;
}
function $132d94fbf41cf0d4$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($132d94fbf41cf0d4$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $132d94fbf41cf0d4$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $132d94fbf41cf0d4$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $132d94fbf41cf0d4$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $132d94fbf41cf0d4$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $132d94fbf41cf0d4$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $132d94fbf41cf0d4$var$Ha && $132d94fbf41cf0d4$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $132d94fbf41cf0d4$var$sh(a, b, c), d.return = a, d;
        d = $132d94fbf41cf0d4$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $132d94fbf41cf0d4$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $132d94fbf41cf0d4$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $132d94fbf41cf0d4$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $132d94fbf41cf0d4$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $132d94fbf41cf0d4$var$va:
                    return c = $132d94fbf41cf0d4$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $132d94fbf41cf0d4$var$sh(a, null, b), c.return = a, c;
                case $132d94fbf41cf0d4$var$wa:
                    return b = $132d94fbf41cf0d4$var$zh(b, a.mode, c), b.return = a, b;
                case $132d94fbf41cf0d4$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($132d94fbf41cf0d4$var$eb(b) || $132d94fbf41cf0d4$var$Ka(b)) return b = $132d94fbf41cf0d4$var$Ah(b, a.mode, c, null), b.return = a, b;
            $132d94fbf41cf0d4$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $132d94fbf41cf0d4$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $132d94fbf41cf0d4$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $132d94fbf41cf0d4$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($132d94fbf41cf0d4$var$eb(c) || $132d94fbf41cf0d4$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $132d94fbf41cf0d4$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $132d94fbf41cf0d4$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $132d94fbf41cf0d4$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $132d94fbf41cf0d4$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($132d94fbf41cf0d4$var$eb(d) || $132d94fbf41cf0d4$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $132d94fbf41cf0d4$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $132d94fbf41cf0d4$var$I && $132d94fbf41cf0d4$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $132d94fbf41cf0d4$var$I && $132d94fbf41cf0d4$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $132d94fbf41cf0d4$var$I && $132d94fbf41cf0d4$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $132d94fbf41cf0d4$var$Ka(h);
        if ("function" !== typeof l) throw Error($132d94fbf41cf0d4$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($132d94fbf41cf0d4$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $132d94fbf41cf0d4$var$I && $132d94fbf41cf0d4$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $132d94fbf41cf0d4$var$I && $132d94fbf41cf0d4$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $132d94fbf41cf0d4$var$I && $132d94fbf41cf0d4$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $132d94fbf41cf0d4$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $132d94fbf41cf0d4$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $132d94fbf41cf0d4$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $132d94fbf41cf0d4$var$Ha && $132d94fbf41cf0d4$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $132d94fbf41cf0d4$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $132d94fbf41cf0d4$var$ya ? (d = $132d94fbf41cf0d4$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $132d94fbf41cf0d4$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $132d94fbf41cf0d4$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $132d94fbf41cf0d4$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $132d94fbf41cf0d4$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $132d94fbf41cf0d4$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($132d94fbf41cf0d4$var$eb(f)) return n(a, d, f, h);
            if ($132d94fbf41cf0d4$var$Ka(f)) return t(a, d, f, h);
            $132d94fbf41cf0d4$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $132d94fbf41cf0d4$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $132d94fbf41cf0d4$var$Bh = $132d94fbf41cf0d4$var$vh(!0), $132d94fbf41cf0d4$var$Ch = $132d94fbf41cf0d4$var$vh(!1), $132d94fbf41cf0d4$var$Dh = {}, $132d94fbf41cf0d4$var$Eh = $132d94fbf41cf0d4$var$Uf($132d94fbf41cf0d4$var$Dh), $132d94fbf41cf0d4$var$Fh = $132d94fbf41cf0d4$var$Uf($132d94fbf41cf0d4$var$Dh), $132d94fbf41cf0d4$var$Gh = $132d94fbf41cf0d4$var$Uf($132d94fbf41cf0d4$var$Dh);
function $132d94fbf41cf0d4$var$Hh(a) {
    if (a === $132d94fbf41cf0d4$var$Dh) throw Error($132d94fbf41cf0d4$var$p(174));
    return a;
}
function $132d94fbf41cf0d4$var$Ih(a, b) {
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Gh, b);
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Fh, a);
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Eh, $132d94fbf41cf0d4$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $132d94fbf41cf0d4$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $132d94fbf41cf0d4$var$lb(b, a);
    }
    $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Eh);
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Eh, b);
}
function $132d94fbf41cf0d4$var$Jh() {
    $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Eh);
    $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Fh);
    $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Gh);
}
function $132d94fbf41cf0d4$var$Kh(a) {
    $132d94fbf41cf0d4$var$Hh($132d94fbf41cf0d4$var$Gh.current);
    var b = $132d94fbf41cf0d4$var$Hh($132d94fbf41cf0d4$var$Eh.current);
    var c = $132d94fbf41cf0d4$var$lb(b, a.type);
    b !== c && ($132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Fh, a), $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Eh, c));
}
function $132d94fbf41cf0d4$var$Lh(a) {
    $132d94fbf41cf0d4$var$Fh.current === a && ($132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Eh), $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Fh));
}
var $132d94fbf41cf0d4$var$M = $132d94fbf41cf0d4$var$Uf(0);
function $132d94fbf41cf0d4$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $132d94fbf41cf0d4$var$Nh = [];
function $132d94fbf41cf0d4$var$Oh() {
    for(var a = 0; a < $132d94fbf41cf0d4$var$Nh.length; a++)$132d94fbf41cf0d4$var$Nh[a]._workInProgressVersionPrimary = null;
    $132d94fbf41cf0d4$var$Nh.length = 0;
}
var $132d94fbf41cf0d4$var$Ph = $132d94fbf41cf0d4$var$ua.ReactCurrentDispatcher, $132d94fbf41cf0d4$var$Qh = $132d94fbf41cf0d4$var$ua.ReactCurrentBatchConfig, $132d94fbf41cf0d4$var$Rh = 0, $132d94fbf41cf0d4$var$N = null, $132d94fbf41cf0d4$var$O = null, $132d94fbf41cf0d4$var$P = null, $132d94fbf41cf0d4$var$Sh = !1, $132d94fbf41cf0d4$var$Th = !1, $132d94fbf41cf0d4$var$Uh = 0, $132d94fbf41cf0d4$var$Vh = 0;
function $132d94fbf41cf0d4$var$Q() {
    throw Error($132d94fbf41cf0d4$var$p(321));
}
function $132d94fbf41cf0d4$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$132d94fbf41cf0d4$var$He(a[c], b[c])) return !1;
    return !0;
}
function $132d94fbf41cf0d4$var$Xh(a, b, c, d, e, f) {
    $132d94fbf41cf0d4$var$Rh = f;
    $132d94fbf41cf0d4$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $132d94fbf41cf0d4$var$Ph.current = null === a || null === a.memoizedState ? $132d94fbf41cf0d4$var$Yh : $132d94fbf41cf0d4$var$Zh;
    a = c(d, e);
    if ($132d94fbf41cf0d4$var$Th) {
        f = 0;
        do {
            $132d94fbf41cf0d4$var$Th = !1;
            $132d94fbf41cf0d4$var$Uh = 0;
            if (25 <= f) throw Error($132d94fbf41cf0d4$var$p(301));
            f += 1;
            $132d94fbf41cf0d4$var$P = $132d94fbf41cf0d4$var$O = null;
            b.updateQueue = null;
            $132d94fbf41cf0d4$var$Ph.current = $132d94fbf41cf0d4$var$$h;
            a = c(d, e);
        }while ($132d94fbf41cf0d4$var$Th);
    }
    $132d94fbf41cf0d4$var$Ph.current = $132d94fbf41cf0d4$var$ai;
    b = null !== $132d94fbf41cf0d4$var$O && null !== $132d94fbf41cf0d4$var$O.next;
    $132d94fbf41cf0d4$var$Rh = 0;
    $132d94fbf41cf0d4$var$P = $132d94fbf41cf0d4$var$O = $132d94fbf41cf0d4$var$N = null;
    $132d94fbf41cf0d4$var$Sh = !1;
    if (b) throw Error($132d94fbf41cf0d4$var$p(300));
    return a;
}
function $132d94fbf41cf0d4$var$bi() {
    var a = 0 !== $132d94fbf41cf0d4$var$Uh;
    $132d94fbf41cf0d4$var$Uh = 0;
    return a;
}
function $132d94fbf41cf0d4$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $132d94fbf41cf0d4$var$P ? $132d94fbf41cf0d4$var$N.memoizedState = $132d94fbf41cf0d4$var$P = a : $132d94fbf41cf0d4$var$P = $132d94fbf41cf0d4$var$P.next = a;
    return $132d94fbf41cf0d4$var$P;
}
function $132d94fbf41cf0d4$var$di() {
    if (null === $132d94fbf41cf0d4$var$O) {
        var a = $132d94fbf41cf0d4$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $132d94fbf41cf0d4$var$O.next;
    var b = null === $132d94fbf41cf0d4$var$P ? $132d94fbf41cf0d4$var$N.memoizedState : $132d94fbf41cf0d4$var$P.next;
    if (null !== b) $132d94fbf41cf0d4$var$P = b, $132d94fbf41cf0d4$var$O = a;
    else {
        if (null === a) throw Error($132d94fbf41cf0d4$var$p(310));
        $132d94fbf41cf0d4$var$O = a;
        a = {
            memoizedState: $132d94fbf41cf0d4$var$O.memoizedState,
            baseState: $132d94fbf41cf0d4$var$O.baseState,
            baseQueue: $132d94fbf41cf0d4$var$O.baseQueue,
            queue: $132d94fbf41cf0d4$var$O.queue,
            next: null
        };
        null === $132d94fbf41cf0d4$var$P ? $132d94fbf41cf0d4$var$N.memoizedState = $132d94fbf41cf0d4$var$P = a : $132d94fbf41cf0d4$var$P = $132d94fbf41cf0d4$var$P.next = a;
    }
    return $132d94fbf41cf0d4$var$P;
}
function $132d94fbf41cf0d4$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $132d94fbf41cf0d4$var$fi(a) {
    var b = $132d94fbf41cf0d4$var$di(), c = b.queue;
    if (null === c) throw Error($132d94fbf41cf0d4$var$p(311));
    c.lastRenderedReducer = a;
    var d = $132d94fbf41cf0d4$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($132d94fbf41cf0d4$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $132d94fbf41cf0d4$var$N.lanes |= m;
                $132d94fbf41cf0d4$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $132d94fbf41cf0d4$var$He(d, b.memoizedState) || ($132d94fbf41cf0d4$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $132d94fbf41cf0d4$var$N.lanes |= f, $132d94fbf41cf0d4$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $132d94fbf41cf0d4$var$gi(a) {
    var b = $132d94fbf41cf0d4$var$di(), c = b.queue;
    if (null === c) throw Error($132d94fbf41cf0d4$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $132d94fbf41cf0d4$var$He(f, b.memoizedState) || ($132d94fbf41cf0d4$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $132d94fbf41cf0d4$var$hi() {}
function $132d94fbf41cf0d4$var$ii(a, b) {
    var c = $132d94fbf41cf0d4$var$N, d = $132d94fbf41cf0d4$var$di(), e = b(), f = !$132d94fbf41cf0d4$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $132d94fbf41cf0d4$var$Ug = !0);
    d = d.queue;
    $132d94fbf41cf0d4$var$ji($132d94fbf41cf0d4$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $132d94fbf41cf0d4$var$P && $132d94fbf41cf0d4$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $132d94fbf41cf0d4$var$li(9, $132d94fbf41cf0d4$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $132d94fbf41cf0d4$var$R) throw Error($132d94fbf41cf0d4$var$p(349));
        0 !== ($132d94fbf41cf0d4$var$Rh & 30) || $132d94fbf41cf0d4$var$ni(c, b, e);
    }
    return e;
}
function $132d94fbf41cf0d4$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $132d94fbf41cf0d4$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $132d94fbf41cf0d4$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $132d94fbf41cf0d4$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $132d94fbf41cf0d4$var$oi(b) && $132d94fbf41cf0d4$var$pi(a);
}
function $132d94fbf41cf0d4$var$ki(a, b, c) {
    return c(function() {
        $132d94fbf41cf0d4$var$oi(b) && $132d94fbf41cf0d4$var$pi(a);
    });
}
function $132d94fbf41cf0d4$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$132d94fbf41cf0d4$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $132d94fbf41cf0d4$var$pi(a) {
    var b = $132d94fbf41cf0d4$var$Zg(a, 1);
    null !== b && $132d94fbf41cf0d4$var$mh(b, a, 1, -1);
}
function $132d94fbf41cf0d4$var$qi(a) {
    var b = $132d94fbf41cf0d4$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $132d94fbf41cf0d4$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $132d94fbf41cf0d4$var$ri.bind(null, $132d94fbf41cf0d4$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $132d94fbf41cf0d4$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $132d94fbf41cf0d4$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $132d94fbf41cf0d4$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $132d94fbf41cf0d4$var$si() {
    return $132d94fbf41cf0d4$var$di().memoizedState;
}
function $132d94fbf41cf0d4$var$ti(a, b, c, d) {
    var e = $132d94fbf41cf0d4$var$ci();
    $132d94fbf41cf0d4$var$N.flags |= a;
    e.memoizedState = $132d94fbf41cf0d4$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $132d94fbf41cf0d4$var$ui(a, b, c, d) {
    var e = $132d94fbf41cf0d4$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $132d94fbf41cf0d4$var$O) {
        var g = $132d94fbf41cf0d4$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $132d94fbf41cf0d4$var$Wh(d, g.deps)) {
            e.memoizedState = $132d94fbf41cf0d4$var$li(b, c, f, d);
            return;
        }
    }
    $132d94fbf41cf0d4$var$N.flags |= a;
    e.memoizedState = $132d94fbf41cf0d4$var$li(1 | b, c, f, d);
}
function $132d94fbf41cf0d4$var$vi(a, b) {
    return $132d94fbf41cf0d4$var$ti(8390656, 8, a, b);
}
function $132d94fbf41cf0d4$var$ji(a, b) {
    return $132d94fbf41cf0d4$var$ui(2048, 8, a, b);
}
function $132d94fbf41cf0d4$var$wi(a, b) {
    return $132d94fbf41cf0d4$var$ui(4, 2, a, b);
}
function $132d94fbf41cf0d4$var$xi(a, b) {
    return $132d94fbf41cf0d4$var$ui(4, 4, a, b);
}
function $132d94fbf41cf0d4$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $132d94fbf41cf0d4$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $132d94fbf41cf0d4$var$ui(4, 4, $132d94fbf41cf0d4$var$yi.bind(null, b, a), c);
}
function $132d94fbf41cf0d4$var$Ai() {}
function $132d94fbf41cf0d4$var$Bi(a, b) {
    var c = $132d94fbf41cf0d4$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $132d94fbf41cf0d4$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $132d94fbf41cf0d4$var$Ci(a, b) {
    var c = $132d94fbf41cf0d4$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $132d94fbf41cf0d4$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $132d94fbf41cf0d4$var$Di(a, b, c) {
    if (0 === ($132d94fbf41cf0d4$var$Rh & 21)) return a.baseState && (a.baseState = !1, $132d94fbf41cf0d4$var$Ug = !0), a.memoizedState = c;
    $132d94fbf41cf0d4$var$He(c, b) || (c = $132d94fbf41cf0d4$var$yc(), $132d94fbf41cf0d4$var$N.lanes |= c, $132d94fbf41cf0d4$var$hh |= c, a.baseState = !0);
    return b;
}
function $132d94fbf41cf0d4$var$Ei(a, b) {
    var c = $132d94fbf41cf0d4$var$C;
    $132d94fbf41cf0d4$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $132d94fbf41cf0d4$var$Qh.transition;
    $132d94fbf41cf0d4$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $132d94fbf41cf0d4$var$C = c, $132d94fbf41cf0d4$var$Qh.transition = d;
    }
}
function $132d94fbf41cf0d4$var$Fi() {
    return $132d94fbf41cf0d4$var$di().memoizedState;
}
function $132d94fbf41cf0d4$var$Gi(a, b, c) {
    var d = $132d94fbf41cf0d4$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($132d94fbf41cf0d4$var$Hi(a)) $132d94fbf41cf0d4$var$Ii(b, c);
    else if (c = $132d94fbf41cf0d4$var$Yg(a, b, c, d), null !== c) {
        var e = $132d94fbf41cf0d4$var$L();
        $132d94fbf41cf0d4$var$mh(c, a, d, e);
        $132d94fbf41cf0d4$var$Ji(c, b, d);
    }
}
function $132d94fbf41cf0d4$var$ri(a, b, c) {
    var d = $132d94fbf41cf0d4$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($132d94fbf41cf0d4$var$Hi(a)) $132d94fbf41cf0d4$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($132d94fbf41cf0d4$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $132d94fbf41cf0d4$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $132d94fbf41cf0d4$var$Yg(a, b, e, d);
        null !== c && (e = $132d94fbf41cf0d4$var$L(), $132d94fbf41cf0d4$var$mh(c, a, d, e), $132d94fbf41cf0d4$var$Ji(c, b, d));
    }
}
function $132d94fbf41cf0d4$var$Hi(a) {
    var b = a.alternate;
    return a === $132d94fbf41cf0d4$var$N || null !== b && b === $132d94fbf41cf0d4$var$N;
}
function $132d94fbf41cf0d4$var$Ii(a, b) {
    $132d94fbf41cf0d4$var$Th = $132d94fbf41cf0d4$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $132d94fbf41cf0d4$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $132d94fbf41cf0d4$var$Cc(a, c);
    }
}
var $132d94fbf41cf0d4$var$ai = {
    readContext: $132d94fbf41cf0d4$var$Vg,
    useCallback: $132d94fbf41cf0d4$var$Q,
    useContext: $132d94fbf41cf0d4$var$Q,
    useEffect: $132d94fbf41cf0d4$var$Q,
    useImperativeHandle: $132d94fbf41cf0d4$var$Q,
    useInsertionEffect: $132d94fbf41cf0d4$var$Q,
    useLayoutEffect: $132d94fbf41cf0d4$var$Q,
    useMemo: $132d94fbf41cf0d4$var$Q,
    useReducer: $132d94fbf41cf0d4$var$Q,
    useRef: $132d94fbf41cf0d4$var$Q,
    useState: $132d94fbf41cf0d4$var$Q,
    useDebugValue: $132d94fbf41cf0d4$var$Q,
    useDeferredValue: $132d94fbf41cf0d4$var$Q,
    useTransition: $132d94fbf41cf0d4$var$Q,
    useMutableSource: $132d94fbf41cf0d4$var$Q,
    useSyncExternalStore: $132d94fbf41cf0d4$var$Q,
    useId: $132d94fbf41cf0d4$var$Q,
    unstable_isNewReconciler: !1
}, $132d94fbf41cf0d4$var$Yh = {
    readContext: $132d94fbf41cf0d4$var$Vg,
    useCallback: function(a, b) {
        $132d94fbf41cf0d4$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $132d94fbf41cf0d4$var$Vg,
    useEffect: $132d94fbf41cf0d4$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $132d94fbf41cf0d4$var$ti(4194308, 4, $132d94fbf41cf0d4$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $132d94fbf41cf0d4$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $132d94fbf41cf0d4$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $132d94fbf41cf0d4$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $132d94fbf41cf0d4$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $132d94fbf41cf0d4$var$Gi.bind(null, $132d94fbf41cf0d4$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $132d94fbf41cf0d4$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $132d94fbf41cf0d4$var$qi,
    useDebugValue: $132d94fbf41cf0d4$var$Ai,
    useDeferredValue: function(a) {
        return $132d94fbf41cf0d4$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $132d94fbf41cf0d4$var$qi(!1), b = a[0];
        a = $132d94fbf41cf0d4$var$Ei.bind(null, a[1]);
        $132d94fbf41cf0d4$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $132d94fbf41cf0d4$var$N, e = $132d94fbf41cf0d4$var$ci();
        if ($132d94fbf41cf0d4$var$I) {
            if (void 0 === c) throw Error($132d94fbf41cf0d4$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $132d94fbf41cf0d4$var$R) throw Error($132d94fbf41cf0d4$var$p(349));
            0 !== ($132d94fbf41cf0d4$var$Rh & 30) || $132d94fbf41cf0d4$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $132d94fbf41cf0d4$var$vi($132d94fbf41cf0d4$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $132d94fbf41cf0d4$var$li(9, $132d94fbf41cf0d4$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $132d94fbf41cf0d4$var$ci(), b = $132d94fbf41cf0d4$var$R.identifierPrefix;
        if ($132d94fbf41cf0d4$var$I) {
            var c = $132d94fbf41cf0d4$var$sg;
            var d = $132d94fbf41cf0d4$var$rg;
            c = (d & ~(1 << 32 - $132d94fbf41cf0d4$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $132d94fbf41cf0d4$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $132d94fbf41cf0d4$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $132d94fbf41cf0d4$var$Zh = {
    readContext: $132d94fbf41cf0d4$var$Vg,
    useCallback: $132d94fbf41cf0d4$var$Bi,
    useContext: $132d94fbf41cf0d4$var$Vg,
    useEffect: $132d94fbf41cf0d4$var$ji,
    useImperativeHandle: $132d94fbf41cf0d4$var$zi,
    useInsertionEffect: $132d94fbf41cf0d4$var$wi,
    useLayoutEffect: $132d94fbf41cf0d4$var$xi,
    useMemo: $132d94fbf41cf0d4$var$Ci,
    useReducer: $132d94fbf41cf0d4$var$fi,
    useRef: $132d94fbf41cf0d4$var$si,
    useState: function() {
        return $132d94fbf41cf0d4$var$fi($132d94fbf41cf0d4$var$ei);
    },
    useDebugValue: $132d94fbf41cf0d4$var$Ai,
    useDeferredValue: function(a) {
        var b = $132d94fbf41cf0d4$var$di();
        return $132d94fbf41cf0d4$var$Di(b, $132d94fbf41cf0d4$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $132d94fbf41cf0d4$var$fi($132d94fbf41cf0d4$var$ei)[0], b = $132d94fbf41cf0d4$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $132d94fbf41cf0d4$var$hi,
    useSyncExternalStore: $132d94fbf41cf0d4$var$ii,
    useId: $132d94fbf41cf0d4$var$Fi,
    unstable_isNewReconciler: !1
}, $132d94fbf41cf0d4$var$$h = {
    readContext: $132d94fbf41cf0d4$var$Vg,
    useCallback: $132d94fbf41cf0d4$var$Bi,
    useContext: $132d94fbf41cf0d4$var$Vg,
    useEffect: $132d94fbf41cf0d4$var$ji,
    useImperativeHandle: $132d94fbf41cf0d4$var$zi,
    useInsertionEffect: $132d94fbf41cf0d4$var$wi,
    useLayoutEffect: $132d94fbf41cf0d4$var$xi,
    useMemo: $132d94fbf41cf0d4$var$Ci,
    useReducer: $132d94fbf41cf0d4$var$gi,
    useRef: $132d94fbf41cf0d4$var$si,
    useState: function() {
        return $132d94fbf41cf0d4$var$gi($132d94fbf41cf0d4$var$ei);
    },
    useDebugValue: $132d94fbf41cf0d4$var$Ai,
    useDeferredValue: function(a) {
        var b = $132d94fbf41cf0d4$var$di();
        return null === $132d94fbf41cf0d4$var$O ? b.memoizedState = a : $132d94fbf41cf0d4$var$Di(b, $132d94fbf41cf0d4$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $132d94fbf41cf0d4$var$gi($132d94fbf41cf0d4$var$ei)[0], b = $132d94fbf41cf0d4$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $132d94fbf41cf0d4$var$hi,
    useSyncExternalStore: $132d94fbf41cf0d4$var$ii,
    useId: $132d94fbf41cf0d4$var$Fi,
    unstable_isNewReconciler: !1
};
function $132d94fbf41cf0d4$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $132d94fbf41cf0d4$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $132d94fbf41cf0d4$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $132d94fbf41cf0d4$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $132d94fbf41cf0d4$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $132d94fbf41cf0d4$var$Oi(a, b, c) {
    c = $132d94fbf41cf0d4$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $132d94fbf41cf0d4$var$Pi || ($132d94fbf41cf0d4$var$Pi = !0, $132d94fbf41cf0d4$var$Qi = d);
        $132d94fbf41cf0d4$var$Mi(a, b);
    };
    return c;
}
function $132d94fbf41cf0d4$var$Ri(a, b, c) {
    c = $132d94fbf41cf0d4$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $132d94fbf41cf0d4$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $132d94fbf41cf0d4$var$Mi(a, b);
        "function" !== typeof d && (null === $132d94fbf41cf0d4$var$Si ? $132d94fbf41cf0d4$var$Si = new Set([
            this
        ]) : $132d94fbf41cf0d4$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $132d94fbf41cf0d4$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $132d94fbf41cf0d4$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $132d94fbf41cf0d4$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $132d94fbf41cf0d4$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $132d94fbf41cf0d4$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $132d94fbf41cf0d4$var$ch(-1, 1), b.tag = 2, $132d94fbf41cf0d4$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $132d94fbf41cf0d4$var$Xi = $132d94fbf41cf0d4$var$ua.ReactCurrentOwner, $132d94fbf41cf0d4$var$Ug = !1;
function $132d94fbf41cf0d4$var$Yi(a, b, c, d) {
    b.child = null === a ? $132d94fbf41cf0d4$var$Ch(b, null, c, d) : $132d94fbf41cf0d4$var$Bh(b, a.child, c, d);
}
function $132d94fbf41cf0d4$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $132d94fbf41cf0d4$var$Tg(b, e);
    d = $132d94fbf41cf0d4$var$Xh(a, b, c, d, f, e);
    c = $132d94fbf41cf0d4$var$bi();
    if (null !== a && !$132d94fbf41cf0d4$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $132d94fbf41cf0d4$var$$i(a, b, e);
    $132d94fbf41cf0d4$var$I && c && $132d94fbf41cf0d4$var$vg(b);
    b.flags |= 1;
    $132d94fbf41cf0d4$var$Yi(a, b, d, e);
    return b.child;
}
function $132d94fbf41cf0d4$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$132d94fbf41cf0d4$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $132d94fbf41cf0d4$var$cj(a, b, f, d, e);
        a = $132d94fbf41cf0d4$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $132d94fbf41cf0d4$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $132d94fbf41cf0d4$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $132d94fbf41cf0d4$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $132d94fbf41cf0d4$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($132d94fbf41cf0d4$var$Ie(f, d) && a.ref === b.ref) {
            if ($132d94fbf41cf0d4$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($132d94fbf41cf0d4$var$Ug = !0);
            else return b.lanes = a.lanes, $132d94fbf41cf0d4$var$$i(a, b, e);
        }
    }
    return $132d94fbf41cf0d4$var$dj(a, b, c, d, e);
}
function $132d94fbf41cf0d4$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$fj, $132d94fbf41cf0d4$var$gj), $132d94fbf41cf0d4$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$fj, $132d94fbf41cf0d4$var$gj), $132d94fbf41cf0d4$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$fj, $132d94fbf41cf0d4$var$gj);
            $132d94fbf41cf0d4$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$fj, $132d94fbf41cf0d4$var$gj), $132d94fbf41cf0d4$var$gj |= d;
    $132d94fbf41cf0d4$var$Yi(a, b, e, c);
    return b.child;
}
function $132d94fbf41cf0d4$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $132d94fbf41cf0d4$var$dj(a, b, c, d, e) {
    var f = $132d94fbf41cf0d4$var$Zf(c) ? $132d94fbf41cf0d4$var$Xf : $132d94fbf41cf0d4$var$H.current;
    f = $132d94fbf41cf0d4$var$Yf(b, f);
    $132d94fbf41cf0d4$var$Tg(b, e);
    c = $132d94fbf41cf0d4$var$Xh(a, b, c, d, f, e);
    d = $132d94fbf41cf0d4$var$bi();
    if (null !== a && !$132d94fbf41cf0d4$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $132d94fbf41cf0d4$var$$i(a, b, e);
    $132d94fbf41cf0d4$var$I && d && $132d94fbf41cf0d4$var$vg(b);
    b.flags |= 1;
    $132d94fbf41cf0d4$var$Yi(a, b, c, e);
    return b.child;
}
function $132d94fbf41cf0d4$var$ij(a, b, c, d, e) {
    if ($132d94fbf41cf0d4$var$Zf(c)) {
        var f = !0;
        $132d94fbf41cf0d4$var$cg(b);
    } else f = !1;
    $132d94fbf41cf0d4$var$Tg(b, e);
    if (null === b.stateNode) $132d94fbf41cf0d4$var$jj(a, b), $132d94fbf41cf0d4$var$ph(b, c, d), $132d94fbf41cf0d4$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $132d94fbf41cf0d4$var$Vg(l) : (l = $132d94fbf41cf0d4$var$Zf(c) ? $132d94fbf41cf0d4$var$Xf : $132d94fbf41cf0d4$var$H.current, l = $132d94fbf41cf0d4$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $132d94fbf41cf0d4$var$qh(b, g, d, l);
        $132d94fbf41cf0d4$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $132d94fbf41cf0d4$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $132d94fbf41cf0d4$var$Wf.current || $132d94fbf41cf0d4$var$$g ? ("function" === typeof m && ($132d94fbf41cf0d4$var$kh(b, c, m, d), k = b.memoizedState), (h = $132d94fbf41cf0d4$var$$g || $132d94fbf41cf0d4$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $132d94fbf41cf0d4$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $132d94fbf41cf0d4$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $132d94fbf41cf0d4$var$Vg(k) : (k = $132d94fbf41cf0d4$var$Zf(c) ? $132d94fbf41cf0d4$var$Xf : $132d94fbf41cf0d4$var$H.current, k = $132d94fbf41cf0d4$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $132d94fbf41cf0d4$var$qh(b, g, d, k);
        $132d94fbf41cf0d4$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $132d94fbf41cf0d4$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $132d94fbf41cf0d4$var$Wf.current || $132d94fbf41cf0d4$var$$g ? ("function" === typeof y && ($132d94fbf41cf0d4$var$kh(b, c, y, d), n = b.memoizedState), (l = $132d94fbf41cf0d4$var$$g || $132d94fbf41cf0d4$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $132d94fbf41cf0d4$var$kj(a, b, c, d, f, e);
}
function $132d94fbf41cf0d4$var$kj(a, b, c, d, e, f) {
    $132d94fbf41cf0d4$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $132d94fbf41cf0d4$var$dg(b, c, !1), $132d94fbf41cf0d4$var$$i(a, b, f);
    d = b.stateNode;
    $132d94fbf41cf0d4$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $132d94fbf41cf0d4$var$Bh(b, a.child, null, f), b.child = $132d94fbf41cf0d4$var$Bh(b, null, h, f)) : $132d94fbf41cf0d4$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $132d94fbf41cf0d4$var$dg(b, c, !0);
    return b.child;
}
function $132d94fbf41cf0d4$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $132d94fbf41cf0d4$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $132d94fbf41cf0d4$var$ag(a, b.context, !1);
    $132d94fbf41cf0d4$var$Ih(a, b.containerInfo);
}
function $132d94fbf41cf0d4$var$mj(a, b, c, d, e) {
    $132d94fbf41cf0d4$var$Ig();
    $132d94fbf41cf0d4$var$Jg(e);
    b.flags |= 256;
    $132d94fbf41cf0d4$var$Yi(a, b, c, d);
    return b.child;
}
var $132d94fbf41cf0d4$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $132d94fbf41cf0d4$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $132d94fbf41cf0d4$var$pj(a, b, c) {
    var d = b.pendingProps, e = $132d94fbf41cf0d4$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$M, e & 1);
    if (null === a) {
        $132d94fbf41cf0d4$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $132d94fbf41cf0d4$var$qj(g, d, 0, null), a = $132d94fbf41cf0d4$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $132d94fbf41cf0d4$var$oj(c), b.memoizedState = $132d94fbf41cf0d4$var$nj, a) : $132d94fbf41cf0d4$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $132d94fbf41cf0d4$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $132d94fbf41cf0d4$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $132d94fbf41cf0d4$var$wh(h, f) : (f = $132d94fbf41cf0d4$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $132d94fbf41cf0d4$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $132d94fbf41cf0d4$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $132d94fbf41cf0d4$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $132d94fbf41cf0d4$var$rj(a, b) {
    b = $132d94fbf41cf0d4$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $132d94fbf41cf0d4$var$tj(a, b, c, d) {
    null !== d && $132d94fbf41cf0d4$var$Jg(d);
    $132d94fbf41cf0d4$var$Bh(b, a.child, null, c);
    a = $132d94fbf41cf0d4$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $132d94fbf41cf0d4$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $132d94fbf41cf0d4$var$Li(Error($132d94fbf41cf0d4$var$p(422))), $132d94fbf41cf0d4$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $132d94fbf41cf0d4$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $132d94fbf41cf0d4$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $132d94fbf41cf0d4$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $132d94fbf41cf0d4$var$oj(g);
        b.memoizedState = $132d94fbf41cf0d4$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $132d94fbf41cf0d4$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($132d94fbf41cf0d4$var$p(419));
        d = $132d94fbf41cf0d4$var$Li(f, d, void 0);
        return $132d94fbf41cf0d4$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($132d94fbf41cf0d4$var$Ug || h) {
        d = $132d94fbf41cf0d4$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $132d94fbf41cf0d4$var$Zg(a, e), $132d94fbf41cf0d4$var$mh(d, a, e, -1));
        }
        $132d94fbf41cf0d4$var$uj();
        d = $132d94fbf41cf0d4$var$Li(Error($132d94fbf41cf0d4$var$p(421)));
        return $132d94fbf41cf0d4$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $132d94fbf41cf0d4$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $132d94fbf41cf0d4$var$yg = $132d94fbf41cf0d4$var$Lf(e.nextSibling);
    $132d94fbf41cf0d4$var$xg = b;
    $132d94fbf41cf0d4$var$I = !0;
    $132d94fbf41cf0d4$var$zg = null;
    null !== a && ($132d94fbf41cf0d4$var$og[$132d94fbf41cf0d4$var$pg++] = $132d94fbf41cf0d4$var$rg, $132d94fbf41cf0d4$var$og[$132d94fbf41cf0d4$var$pg++] = $132d94fbf41cf0d4$var$sg, $132d94fbf41cf0d4$var$og[$132d94fbf41cf0d4$var$pg++] = $132d94fbf41cf0d4$var$qg, $132d94fbf41cf0d4$var$rg = a.id, $132d94fbf41cf0d4$var$sg = a.overflow, $132d94fbf41cf0d4$var$qg = b);
    b = $132d94fbf41cf0d4$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $132d94fbf41cf0d4$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $132d94fbf41cf0d4$var$Sg(a.return, b, c);
}
function $132d94fbf41cf0d4$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $132d94fbf41cf0d4$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $132d94fbf41cf0d4$var$Yi(a, b, d.children, c);
    d = $132d94fbf41cf0d4$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $132d94fbf41cf0d4$var$wj(a, c, b);
            else if (19 === a.tag) $132d94fbf41cf0d4$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $132d94fbf41cf0d4$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $132d94fbf41cf0d4$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $132d94fbf41cf0d4$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $132d94fbf41cf0d4$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $132d94fbf41cf0d4$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $132d94fbf41cf0d4$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $132d94fbf41cf0d4$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $132d94fbf41cf0d4$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($132d94fbf41cf0d4$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $132d94fbf41cf0d4$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $132d94fbf41cf0d4$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $132d94fbf41cf0d4$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $132d94fbf41cf0d4$var$lj(b);
            $132d94fbf41cf0d4$var$Ig();
            break;
        case 5:
            $132d94fbf41cf0d4$var$Kh(b);
            break;
        case 1:
            $132d94fbf41cf0d4$var$Zf(b.type) && $132d94fbf41cf0d4$var$cg(b);
            break;
        case 4:
            $132d94fbf41cf0d4$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$M, $132d94fbf41cf0d4$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $132d94fbf41cf0d4$var$pj(a, b, c);
                $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$M, $132d94fbf41cf0d4$var$M.current & 1);
                a = $132d94fbf41cf0d4$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$M, $132d94fbf41cf0d4$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $132d94fbf41cf0d4$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$M, $132d94fbf41cf0d4$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $132d94fbf41cf0d4$var$ej(a, b, c);
    }
    return $132d94fbf41cf0d4$var$$i(a, b, c);
}
var $132d94fbf41cf0d4$var$Aj, $132d94fbf41cf0d4$var$Bj, $132d94fbf41cf0d4$var$Cj, $132d94fbf41cf0d4$var$Dj;
$132d94fbf41cf0d4$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$132d94fbf41cf0d4$var$Bj = function() {};
$132d94fbf41cf0d4$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $132d94fbf41cf0d4$var$Hh($132d94fbf41cf0d4$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $132d94fbf41cf0d4$var$Ya(a, e);
                d = $132d94fbf41cf0d4$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $132d94fbf41cf0d4$var$A({}, e, {
                    value: void 0
                });
                d = $132d94fbf41cf0d4$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $132d94fbf41cf0d4$var$gb(a, e);
                d = $132d94fbf41cf0d4$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $132d94fbf41cf0d4$var$Bf);
        }
        $132d94fbf41cf0d4$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($132d94fbf41cf0d4$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($132d94fbf41cf0d4$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $132d94fbf41cf0d4$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$132d94fbf41cf0d4$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $132d94fbf41cf0d4$var$Ej(a, b) {
    if (!$132d94fbf41cf0d4$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $132d94fbf41cf0d4$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $132d94fbf41cf0d4$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $132d94fbf41cf0d4$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $132d94fbf41cf0d4$var$S(b), null;
        case 1:
            return $132d94fbf41cf0d4$var$Zf(b.type) && $132d94fbf41cf0d4$var$$f(), $132d94fbf41cf0d4$var$S(b), null;
        case 3:
            d = b.stateNode;
            $132d94fbf41cf0d4$var$Jh();
            $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Wf);
            $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$H);
            $132d94fbf41cf0d4$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $132d94fbf41cf0d4$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $132d94fbf41cf0d4$var$zg && ($132d94fbf41cf0d4$var$Gj($132d94fbf41cf0d4$var$zg), $132d94fbf41cf0d4$var$zg = null));
            $132d94fbf41cf0d4$var$Bj(a, b);
            $132d94fbf41cf0d4$var$S(b);
            return null;
        case 5:
            $132d94fbf41cf0d4$var$Lh(b);
            var e = $132d94fbf41cf0d4$var$Hh($132d94fbf41cf0d4$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $132d94fbf41cf0d4$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($132d94fbf41cf0d4$var$p(166));
                    $132d94fbf41cf0d4$var$S(b);
                    return null;
                }
                a = $132d94fbf41cf0d4$var$Hh($132d94fbf41cf0d4$var$Eh.current);
                if ($132d94fbf41cf0d4$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$132d94fbf41cf0d4$var$Of] = b;
                    d[$132d94fbf41cf0d4$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $132d94fbf41cf0d4$var$D("cancel", d);
                            $132d94fbf41cf0d4$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $132d94fbf41cf0d4$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $132d94fbf41cf0d4$var$lf.length; e++)$132d94fbf41cf0d4$var$D($132d94fbf41cf0d4$var$lf[e], d);
                            break;
                        case "source":
                            $132d94fbf41cf0d4$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $132d94fbf41cf0d4$var$D("error", d);
                            $132d94fbf41cf0d4$var$D("load", d);
                            break;
                        case "details":
                            $132d94fbf41cf0d4$var$D("toggle", d);
                            break;
                        case "input":
                            $132d94fbf41cf0d4$var$Za(d, f);
                            $132d94fbf41cf0d4$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $132d94fbf41cf0d4$var$D("invalid", d);
                            break;
                        case "textarea":
                            $132d94fbf41cf0d4$var$hb(d, f), $132d94fbf41cf0d4$var$D("invalid", d);
                    }
                    $132d94fbf41cf0d4$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $132d94fbf41cf0d4$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $132d94fbf41cf0d4$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $132d94fbf41cf0d4$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $132d94fbf41cf0d4$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $132d94fbf41cf0d4$var$Va(d);
                            $132d94fbf41cf0d4$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $132d94fbf41cf0d4$var$Va(d);
                            $132d94fbf41cf0d4$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $132d94fbf41cf0d4$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $132d94fbf41cf0d4$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$132d94fbf41cf0d4$var$Of] = b;
                    a[$132d94fbf41cf0d4$var$Pf] = d;
                    $132d94fbf41cf0d4$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $132d94fbf41cf0d4$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $132d94fbf41cf0d4$var$D("cancel", a);
                                $132d94fbf41cf0d4$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $132d94fbf41cf0d4$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $132d94fbf41cf0d4$var$lf.length; e++)$132d94fbf41cf0d4$var$D($132d94fbf41cf0d4$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $132d94fbf41cf0d4$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $132d94fbf41cf0d4$var$D("error", a);
                                $132d94fbf41cf0d4$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $132d94fbf41cf0d4$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $132d94fbf41cf0d4$var$Za(a, d);
                                e = $132d94fbf41cf0d4$var$Ya(a, d);
                                $132d94fbf41cf0d4$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $132d94fbf41cf0d4$var$A({}, d, {
                                    value: void 0
                                });
                                $132d94fbf41cf0d4$var$D("invalid", a);
                                break;
                            case "textarea":
                                $132d94fbf41cf0d4$var$hb(a, d);
                                e = $132d94fbf41cf0d4$var$gb(a, d);
                                $132d94fbf41cf0d4$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $132d94fbf41cf0d4$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $132d94fbf41cf0d4$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $132d94fbf41cf0d4$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $132d94fbf41cf0d4$var$ob(a, k) : "number" === typeof k && $132d94fbf41cf0d4$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($132d94fbf41cf0d4$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $132d94fbf41cf0d4$var$D("scroll", a) : null != k && $132d94fbf41cf0d4$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $132d94fbf41cf0d4$var$Va(a);
                                $132d94fbf41cf0d4$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $132d94fbf41cf0d4$var$Va(a);
                                $132d94fbf41cf0d4$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $132d94fbf41cf0d4$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $132d94fbf41cf0d4$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $132d94fbf41cf0d4$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $132d94fbf41cf0d4$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $132d94fbf41cf0d4$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $132d94fbf41cf0d4$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($132d94fbf41cf0d4$var$p(166));
                c = $132d94fbf41cf0d4$var$Hh($132d94fbf41cf0d4$var$Gh.current);
                $132d94fbf41cf0d4$var$Hh($132d94fbf41cf0d4$var$Eh.current);
                if ($132d94fbf41cf0d4$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$132d94fbf41cf0d4$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $132d94fbf41cf0d4$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $132d94fbf41cf0d4$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $132d94fbf41cf0d4$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$132d94fbf41cf0d4$var$Of] = b, b.stateNode = d;
            }
            $132d94fbf41cf0d4$var$S(b);
            return null;
        case 13:
            $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($132d94fbf41cf0d4$var$I && null !== $132d94fbf41cf0d4$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $132d94fbf41cf0d4$var$Hg(), $132d94fbf41cf0d4$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $132d94fbf41cf0d4$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($132d94fbf41cf0d4$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($132d94fbf41cf0d4$var$p(317));
                        f[$132d94fbf41cf0d4$var$Of] = b;
                    } else $132d94fbf41cf0d4$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $132d94fbf41cf0d4$var$S(b);
                    f = !1;
                } else null !== $132d94fbf41cf0d4$var$zg && ($132d94fbf41cf0d4$var$Gj($132d94fbf41cf0d4$var$zg), $132d94fbf41cf0d4$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($132d94fbf41cf0d4$var$M.current & 1) ? 0 === $132d94fbf41cf0d4$var$T && ($132d94fbf41cf0d4$var$T = 3) : $132d94fbf41cf0d4$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $132d94fbf41cf0d4$var$S(b);
            return null;
        case 4:
            return $132d94fbf41cf0d4$var$Jh(), $132d94fbf41cf0d4$var$Bj(a, b), null === a && $132d94fbf41cf0d4$var$sf(b.stateNode.containerInfo), $132d94fbf41cf0d4$var$S(b), null;
        case 10:
            return $132d94fbf41cf0d4$var$Rg(b.type._context), $132d94fbf41cf0d4$var$S(b), null;
        case 17:
            return $132d94fbf41cf0d4$var$Zf(b.type) && $132d94fbf41cf0d4$var$$f(), $132d94fbf41cf0d4$var$S(b), null;
        case 19:
            $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$M);
            f = b.memoizedState;
            if (null === f) return $132d94fbf41cf0d4$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $132d94fbf41cf0d4$var$Ej(f, !1);
                else {
                    if (0 !== $132d94fbf41cf0d4$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $132d94fbf41cf0d4$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $132d94fbf41cf0d4$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$M, $132d94fbf41cf0d4$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $132d94fbf41cf0d4$var$B() > $132d94fbf41cf0d4$var$Hj && (b.flags |= 128, d = !0, $132d94fbf41cf0d4$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $132d94fbf41cf0d4$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $132d94fbf41cf0d4$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$132d94fbf41cf0d4$var$I) return $132d94fbf41cf0d4$var$S(b), null;
                    } else 2 * $132d94fbf41cf0d4$var$B() - f.renderingStartTime > $132d94fbf41cf0d4$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $132d94fbf41cf0d4$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $132d94fbf41cf0d4$var$B(), b.sibling = null, c = $132d94fbf41cf0d4$var$M.current, $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$M, d ? c & 1 | 2 : c & 1), b;
            $132d94fbf41cf0d4$var$S(b);
            return null;
        case 22:
        case 23:
            return $132d94fbf41cf0d4$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($132d94fbf41cf0d4$var$gj & 1073741824) && ($132d94fbf41cf0d4$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $132d94fbf41cf0d4$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($132d94fbf41cf0d4$var$p(156, b.tag));
}
function $132d94fbf41cf0d4$var$Jj(a, b) {
    $132d94fbf41cf0d4$var$wg(b);
    switch(b.tag){
        case 1:
            return $132d94fbf41cf0d4$var$Zf(b.type) && $132d94fbf41cf0d4$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $132d94fbf41cf0d4$var$Jh(), $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Wf), $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$H), $132d94fbf41cf0d4$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $132d94fbf41cf0d4$var$Lh(b), null;
        case 13:
            $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($132d94fbf41cf0d4$var$p(340));
                $132d94fbf41cf0d4$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$M), null;
        case 4:
            return $132d94fbf41cf0d4$var$Jh(), null;
        case 10:
            return $132d94fbf41cf0d4$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $132d94fbf41cf0d4$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $132d94fbf41cf0d4$var$Kj = !1, $132d94fbf41cf0d4$var$U = !1, $132d94fbf41cf0d4$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $132d94fbf41cf0d4$var$V = null;
function $132d94fbf41cf0d4$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $132d94fbf41cf0d4$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $132d94fbf41cf0d4$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $132d94fbf41cf0d4$var$W(a, b, d);
    }
}
var $132d94fbf41cf0d4$var$Oj = !1;
function $132d94fbf41cf0d4$var$Pj(a, b) {
    $132d94fbf41cf0d4$var$Cf = $132d94fbf41cf0d4$var$dd;
    a = $132d94fbf41cf0d4$var$Me();
    if ($132d94fbf41cf0d4$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $132d94fbf41cf0d4$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $132d94fbf41cf0d4$var$dd = !1;
    for($132d94fbf41cf0d4$var$V = b; null !== $132d94fbf41cf0d4$var$V;)if (b = $132d94fbf41cf0d4$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $132d94fbf41cf0d4$var$V = a;
    else for(; null !== $132d94fbf41cf0d4$var$V;){
        b = $132d94fbf41cf0d4$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $132d94fbf41cf0d4$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($132d94fbf41cf0d4$var$p(163));
            }
        } catch (F) {
            $132d94fbf41cf0d4$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $132d94fbf41cf0d4$var$V = a;
            break;
        }
        $132d94fbf41cf0d4$var$V = b.return;
    }
    n = $132d94fbf41cf0d4$var$Oj;
    $132d94fbf41cf0d4$var$Oj = !1;
    return n;
}
function $132d94fbf41cf0d4$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $132d94fbf41cf0d4$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $132d94fbf41cf0d4$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $132d94fbf41cf0d4$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $132d94fbf41cf0d4$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $132d94fbf41cf0d4$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$132d94fbf41cf0d4$var$Of], delete b[$132d94fbf41cf0d4$var$Pf], delete b[$132d94fbf41cf0d4$var$of], delete b[$132d94fbf41cf0d4$var$Qf], delete b[$132d94fbf41cf0d4$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $132d94fbf41cf0d4$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $132d94fbf41cf0d4$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $132d94fbf41cf0d4$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $132d94fbf41cf0d4$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $132d94fbf41cf0d4$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($132d94fbf41cf0d4$var$Wj(a, b, c), a = a.sibling; null !== a;)$132d94fbf41cf0d4$var$Wj(a, b, c), a = a.sibling;
}
function $132d94fbf41cf0d4$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($132d94fbf41cf0d4$var$Xj(a, b, c), a = a.sibling; null !== a;)$132d94fbf41cf0d4$var$Xj(a, b, c), a = a.sibling;
}
var $132d94fbf41cf0d4$var$X = null, $132d94fbf41cf0d4$var$Yj = !1;
function $132d94fbf41cf0d4$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$132d94fbf41cf0d4$var$ak(a, b, c), c = c.sibling;
}
function $132d94fbf41cf0d4$var$ak(a, b, c) {
    if ($132d94fbf41cf0d4$var$lc && "function" === typeof $132d94fbf41cf0d4$var$lc.onCommitFiberUnmount) try {
        $132d94fbf41cf0d4$var$lc.onCommitFiberUnmount($132d94fbf41cf0d4$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $132d94fbf41cf0d4$var$U || $132d94fbf41cf0d4$var$Mj(c, b);
        case 6:
            var d = $132d94fbf41cf0d4$var$X, e = $132d94fbf41cf0d4$var$Yj;
            $132d94fbf41cf0d4$var$X = null;
            $132d94fbf41cf0d4$var$Zj(a, b, c);
            $132d94fbf41cf0d4$var$X = d;
            $132d94fbf41cf0d4$var$Yj = e;
            null !== $132d94fbf41cf0d4$var$X && ($132d94fbf41cf0d4$var$Yj ? (a = $132d94fbf41cf0d4$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $132d94fbf41cf0d4$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $132d94fbf41cf0d4$var$X && ($132d94fbf41cf0d4$var$Yj ? (a = $132d94fbf41cf0d4$var$X, c = c.stateNode, 8 === a.nodeType ? $132d94fbf41cf0d4$var$Kf(a.parentNode, c) : 1 === a.nodeType && $132d94fbf41cf0d4$var$Kf(a, c), $132d94fbf41cf0d4$var$bd(a)) : $132d94fbf41cf0d4$var$Kf($132d94fbf41cf0d4$var$X, c.stateNode));
            break;
        case 4:
            d = $132d94fbf41cf0d4$var$X;
            e = $132d94fbf41cf0d4$var$Yj;
            $132d94fbf41cf0d4$var$X = c.stateNode.containerInfo;
            $132d94fbf41cf0d4$var$Yj = !0;
            $132d94fbf41cf0d4$var$Zj(a, b, c);
            $132d94fbf41cf0d4$var$X = d;
            $132d94fbf41cf0d4$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$132d94fbf41cf0d4$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $132d94fbf41cf0d4$var$Nj(c, b, g) : 0 !== (f & 4) && $132d94fbf41cf0d4$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $132d94fbf41cf0d4$var$Zj(a, b, c);
            break;
        case 1:
            if (!$132d94fbf41cf0d4$var$U && ($132d94fbf41cf0d4$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $132d94fbf41cf0d4$var$W(c, b, h);
            }
            $132d94fbf41cf0d4$var$Zj(a, b, c);
            break;
        case 21:
            $132d94fbf41cf0d4$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($132d94fbf41cf0d4$var$U = (d = $132d94fbf41cf0d4$var$U) || null !== c.memoizedState, $132d94fbf41cf0d4$var$Zj(a, b, c), $132d94fbf41cf0d4$var$U = d) : $132d94fbf41cf0d4$var$Zj(a, b, c);
            break;
        default:
            $132d94fbf41cf0d4$var$Zj(a, b, c);
    }
}
function $132d94fbf41cf0d4$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $132d94fbf41cf0d4$var$Lj);
        b.forEach(function(b) {
            var d = $132d94fbf41cf0d4$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $132d94fbf41cf0d4$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $132d94fbf41cf0d4$var$X = h.stateNode;
                        $132d94fbf41cf0d4$var$Yj = !1;
                        break a;
                    case 3:
                        $132d94fbf41cf0d4$var$X = h.stateNode.containerInfo;
                        $132d94fbf41cf0d4$var$Yj = !0;
                        break a;
                    case 4:
                        $132d94fbf41cf0d4$var$X = h.stateNode.containerInfo;
                        $132d94fbf41cf0d4$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $132d94fbf41cf0d4$var$X) throw Error($132d94fbf41cf0d4$var$p(160));
            $132d94fbf41cf0d4$var$ak(f, g, e);
            $132d94fbf41cf0d4$var$X = null;
            $132d94fbf41cf0d4$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $132d94fbf41cf0d4$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$132d94fbf41cf0d4$var$ek(b, a), b = b.sibling;
}
function $132d94fbf41cf0d4$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $132d94fbf41cf0d4$var$dk(b, a);
            $132d94fbf41cf0d4$var$fk(a);
            if (d & 4) {
                try {
                    $132d94fbf41cf0d4$var$Qj(3, a, a.return), $132d94fbf41cf0d4$var$Rj(3, a);
                } catch (t) {
                    $132d94fbf41cf0d4$var$W(a, a.return, t);
                }
                try {
                    $132d94fbf41cf0d4$var$Qj(5, a, a.return);
                } catch (t) {
                    $132d94fbf41cf0d4$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $132d94fbf41cf0d4$var$dk(b, a);
            $132d94fbf41cf0d4$var$fk(a);
            d & 512 && null !== c && $132d94fbf41cf0d4$var$Mj(c, c.return);
            break;
        case 5:
            $132d94fbf41cf0d4$var$dk(b, a);
            $132d94fbf41cf0d4$var$fk(a);
            d & 512 && null !== c && $132d94fbf41cf0d4$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $132d94fbf41cf0d4$var$ob(e, "");
                } catch (t) {
                    $132d94fbf41cf0d4$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $132d94fbf41cf0d4$var$ab(e, f);
                    $132d94fbf41cf0d4$var$vb(h, g);
                    var l = $132d94fbf41cf0d4$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $132d94fbf41cf0d4$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $132d94fbf41cf0d4$var$nb(e, q) : "children" === m ? $132d94fbf41cf0d4$var$ob(e, q) : $132d94fbf41cf0d4$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $132d94fbf41cf0d4$var$bb(e, f);
                            break;
                        case "textarea":
                            $132d94fbf41cf0d4$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $132d94fbf41cf0d4$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $132d94fbf41cf0d4$var$fb(e, !!f.multiple, f.defaultValue, !0) : $132d94fbf41cf0d4$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$132d94fbf41cf0d4$var$Pf] = f;
                } catch (t) {
                    $132d94fbf41cf0d4$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $132d94fbf41cf0d4$var$dk(b, a);
            $132d94fbf41cf0d4$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($132d94fbf41cf0d4$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $132d94fbf41cf0d4$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $132d94fbf41cf0d4$var$dk(b, a);
            $132d94fbf41cf0d4$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $132d94fbf41cf0d4$var$bd(b.containerInfo);
            } catch (t) {
                $132d94fbf41cf0d4$var$W(a, a.return, t);
            }
            break;
        case 4:
            $132d94fbf41cf0d4$var$dk(b, a);
            $132d94fbf41cf0d4$var$fk(a);
            break;
        case 13:
            $132d94fbf41cf0d4$var$dk(b, a);
            $132d94fbf41cf0d4$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($132d94fbf41cf0d4$var$gk = $132d94fbf41cf0d4$var$B()));
            d & 4 && $132d94fbf41cf0d4$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($132d94fbf41cf0d4$var$U = (l = $132d94fbf41cf0d4$var$U) || m, $132d94fbf41cf0d4$var$dk(b, a), $132d94fbf41cf0d4$var$U = l) : $132d94fbf41cf0d4$var$dk(b, a);
            $132d94fbf41cf0d4$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($132d94fbf41cf0d4$var$V = a, m = a.child; null !== m;){
                    for(q = $132d94fbf41cf0d4$var$V = m; null !== $132d94fbf41cf0d4$var$V;){
                        r = $132d94fbf41cf0d4$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $132d94fbf41cf0d4$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $132d94fbf41cf0d4$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $132d94fbf41cf0d4$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $132d94fbf41cf0d4$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $132d94fbf41cf0d4$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $132d94fbf41cf0d4$var$V = y) : $132d94fbf41cf0d4$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $132d94fbf41cf0d4$var$rb("display", g));
                            } catch (t) {
                                $132d94fbf41cf0d4$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $132d94fbf41cf0d4$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $132d94fbf41cf0d4$var$dk(b, a);
            $132d94fbf41cf0d4$var$fk(a);
            d & 4 && $132d94fbf41cf0d4$var$bk(a);
            break;
        case 21:
            break;
        default:
            $132d94fbf41cf0d4$var$dk(b, a), $132d94fbf41cf0d4$var$fk(a);
    }
}
function $132d94fbf41cf0d4$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($132d94fbf41cf0d4$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($132d94fbf41cf0d4$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($132d94fbf41cf0d4$var$ob(e, ""), d.flags &= -33);
                    var f = $132d94fbf41cf0d4$var$Vj(a);
                    $132d94fbf41cf0d4$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $132d94fbf41cf0d4$var$Vj(a);
                    $132d94fbf41cf0d4$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($132d94fbf41cf0d4$var$p(161));
            }
        } catch (k) {
            $132d94fbf41cf0d4$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $132d94fbf41cf0d4$var$ik(a, b, c) {
    $132d94fbf41cf0d4$var$V = a;
    $132d94fbf41cf0d4$var$jk(a, b, c);
}
function $132d94fbf41cf0d4$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $132d94fbf41cf0d4$var$V;){
        var e = $132d94fbf41cf0d4$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $132d94fbf41cf0d4$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $132d94fbf41cf0d4$var$U;
                h = $132d94fbf41cf0d4$var$Kj;
                var l = $132d94fbf41cf0d4$var$U;
                $132d94fbf41cf0d4$var$Kj = g;
                if (($132d94fbf41cf0d4$var$U = k) && !l) for($132d94fbf41cf0d4$var$V = e; null !== $132d94fbf41cf0d4$var$V;)g = $132d94fbf41cf0d4$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $132d94fbf41cf0d4$var$kk(e) : null !== k ? (k.return = g, $132d94fbf41cf0d4$var$V = k) : $132d94fbf41cf0d4$var$kk(e);
                for(; null !== f;)$132d94fbf41cf0d4$var$V = f, $132d94fbf41cf0d4$var$jk(f, b, c), f = f.sibling;
                $132d94fbf41cf0d4$var$V = e;
                $132d94fbf41cf0d4$var$Kj = h;
                $132d94fbf41cf0d4$var$U = l;
            }
            $132d94fbf41cf0d4$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $132d94fbf41cf0d4$var$V = f) : $132d94fbf41cf0d4$var$lk(a, b, c);
    }
}
function $132d94fbf41cf0d4$var$lk(a) {
    for(; null !== $132d94fbf41cf0d4$var$V;){
        var b = $132d94fbf41cf0d4$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $132d94fbf41cf0d4$var$U || $132d94fbf41cf0d4$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$132d94fbf41cf0d4$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $132d94fbf41cf0d4$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $132d94fbf41cf0d4$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $132d94fbf41cf0d4$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $132d94fbf41cf0d4$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($132d94fbf41cf0d4$var$p(163));
                }
                $132d94fbf41cf0d4$var$U || b.flags & 512 && $132d94fbf41cf0d4$var$Sj(b);
            } catch (r) {
                $132d94fbf41cf0d4$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $132d94fbf41cf0d4$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $132d94fbf41cf0d4$var$V = c;
            break;
        }
        $132d94fbf41cf0d4$var$V = b.return;
    }
}
function $132d94fbf41cf0d4$var$hk(a) {
    for(; null !== $132d94fbf41cf0d4$var$V;){
        var b = $132d94fbf41cf0d4$var$V;
        if (b === a) {
            $132d94fbf41cf0d4$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $132d94fbf41cf0d4$var$V = c;
            break;
        }
        $132d94fbf41cf0d4$var$V = b.return;
    }
}
function $132d94fbf41cf0d4$var$kk(a) {
    for(; null !== $132d94fbf41cf0d4$var$V;){
        var b = $132d94fbf41cf0d4$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $132d94fbf41cf0d4$var$Rj(4, b);
                    } catch (k) {
                        $132d94fbf41cf0d4$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $132d94fbf41cf0d4$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $132d94fbf41cf0d4$var$Sj(b);
                    } catch (k) {
                        $132d94fbf41cf0d4$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $132d94fbf41cf0d4$var$Sj(b);
                    } catch (k) {
                        $132d94fbf41cf0d4$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $132d94fbf41cf0d4$var$W(b, b.return, k);
        }
        if (b === a) {
            $132d94fbf41cf0d4$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $132d94fbf41cf0d4$var$V = h;
            break;
        }
        $132d94fbf41cf0d4$var$V = b.return;
    }
}
var $132d94fbf41cf0d4$var$mk = Math.ceil, $132d94fbf41cf0d4$var$nk = $132d94fbf41cf0d4$var$ua.ReactCurrentDispatcher, $132d94fbf41cf0d4$var$ok = $132d94fbf41cf0d4$var$ua.ReactCurrentOwner, $132d94fbf41cf0d4$var$pk = $132d94fbf41cf0d4$var$ua.ReactCurrentBatchConfig, $132d94fbf41cf0d4$var$K = 0, $132d94fbf41cf0d4$var$R = null, $132d94fbf41cf0d4$var$Y = null, $132d94fbf41cf0d4$var$Z = 0, $132d94fbf41cf0d4$var$gj = 0, $132d94fbf41cf0d4$var$fj = $132d94fbf41cf0d4$var$Uf(0), $132d94fbf41cf0d4$var$T = 0, $132d94fbf41cf0d4$var$qk = null, $132d94fbf41cf0d4$var$hh = 0, $132d94fbf41cf0d4$var$rk = 0, $132d94fbf41cf0d4$var$sk = 0, $132d94fbf41cf0d4$var$tk = null, $132d94fbf41cf0d4$var$uk = null, $132d94fbf41cf0d4$var$gk = 0, $132d94fbf41cf0d4$var$Hj = Infinity, $132d94fbf41cf0d4$var$vk = null, $132d94fbf41cf0d4$var$Pi = !1, $132d94fbf41cf0d4$var$Qi = null, $132d94fbf41cf0d4$var$Si = null, $132d94fbf41cf0d4$var$wk = !1, $132d94fbf41cf0d4$var$xk = null, $132d94fbf41cf0d4$var$yk = 0, $132d94fbf41cf0d4$var$zk = 0, $132d94fbf41cf0d4$var$Ak = null, $132d94fbf41cf0d4$var$Bk = -1, $132d94fbf41cf0d4$var$Ck = 0;
function $132d94fbf41cf0d4$var$L() {
    return 0 !== ($132d94fbf41cf0d4$var$K & 6) ? $132d94fbf41cf0d4$var$B() : -1 !== $132d94fbf41cf0d4$var$Bk ? $132d94fbf41cf0d4$var$Bk : $132d94fbf41cf0d4$var$Bk = $132d94fbf41cf0d4$var$B();
}
function $132d94fbf41cf0d4$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($132d94fbf41cf0d4$var$K & 2) && 0 !== $132d94fbf41cf0d4$var$Z) return $132d94fbf41cf0d4$var$Z & -$132d94fbf41cf0d4$var$Z;
    if (null !== $132d94fbf41cf0d4$var$Kg.transition) return 0 === $132d94fbf41cf0d4$var$Ck && ($132d94fbf41cf0d4$var$Ck = $132d94fbf41cf0d4$var$yc()), $132d94fbf41cf0d4$var$Ck;
    a = $132d94fbf41cf0d4$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $132d94fbf41cf0d4$var$jd(a.type);
    return a;
}
function $132d94fbf41cf0d4$var$mh(a, b, c, d) {
    if (50 < $132d94fbf41cf0d4$var$zk) throw $132d94fbf41cf0d4$var$zk = 0, $132d94fbf41cf0d4$var$Ak = null, Error($132d94fbf41cf0d4$var$p(185));
    $132d94fbf41cf0d4$var$Ac(a, c, d);
    if (0 === ($132d94fbf41cf0d4$var$K & 2) || a !== $132d94fbf41cf0d4$var$R) a === $132d94fbf41cf0d4$var$R && (0 === ($132d94fbf41cf0d4$var$K & 2) && ($132d94fbf41cf0d4$var$rk |= c), 4 === $132d94fbf41cf0d4$var$T && $132d94fbf41cf0d4$var$Dk(a, $132d94fbf41cf0d4$var$Z)), $132d94fbf41cf0d4$var$Ek(a, d), 1 === c && 0 === $132d94fbf41cf0d4$var$K && 0 === (b.mode & 1) && ($132d94fbf41cf0d4$var$Hj = $132d94fbf41cf0d4$var$B() + 500, $132d94fbf41cf0d4$var$fg && $132d94fbf41cf0d4$var$jg());
}
function $132d94fbf41cf0d4$var$Ek(a, b) {
    var c = a.callbackNode;
    $132d94fbf41cf0d4$var$wc(a, b);
    var d = $132d94fbf41cf0d4$var$uc(a, a === $132d94fbf41cf0d4$var$R ? $132d94fbf41cf0d4$var$Z : 0);
    if (0 === d) null !== c && $132d94fbf41cf0d4$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $132d94fbf41cf0d4$var$bc(c);
        if (1 === b) 0 === a.tag ? $132d94fbf41cf0d4$var$ig($132d94fbf41cf0d4$var$Fk.bind(null, a)) : $132d94fbf41cf0d4$var$hg($132d94fbf41cf0d4$var$Fk.bind(null, a)), $132d94fbf41cf0d4$var$Jf(function() {
            0 === ($132d94fbf41cf0d4$var$K & 6) && $132d94fbf41cf0d4$var$jg();
        }), c = null;
        else {
            switch($132d94fbf41cf0d4$var$Dc(d)){
                case 1:
                    c = $132d94fbf41cf0d4$var$fc;
                    break;
                case 4:
                    c = $132d94fbf41cf0d4$var$gc;
                    break;
                case 16:
                    c = $132d94fbf41cf0d4$var$hc;
                    break;
                case 536870912:
                    c = $132d94fbf41cf0d4$var$jc;
                    break;
                default:
                    c = $132d94fbf41cf0d4$var$hc;
            }
            c = $132d94fbf41cf0d4$var$Gk(c, $132d94fbf41cf0d4$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $132d94fbf41cf0d4$var$Hk(a, b) {
    $132d94fbf41cf0d4$var$Bk = -1;
    $132d94fbf41cf0d4$var$Ck = 0;
    if (0 !== ($132d94fbf41cf0d4$var$K & 6)) throw Error($132d94fbf41cf0d4$var$p(327));
    var c = a.callbackNode;
    if ($132d94fbf41cf0d4$var$Ik() && a.callbackNode !== c) return null;
    var d = $132d94fbf41cf0d4$var$uc(a, a === $132d94fbf41cf0d4$var$R ? $132d94fbf41cf0d4$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $132d94fbf41cf0d4$var$Jk(a, d);
    else {
        b = d;
        var e = $132d94fbf41cf0d4$var$K;
        $132d94fbf41cf0d4$var$K |= 2;
        var f = $132d94fbf41cf0d4$var$Kk();
        if ($132d94fbf41cf0d4$var$R !== a || $132d94fbf41cf0d4$var$Z !== b) $132d94fbf41cf0d4$var$vk = null, $132d94fbf41cf0d4$var$Hj = $132d94fbf41cf0d4$var$B() + 500, $132d94fbf41cf0d4$var$Lk(a, b);
        for(;;)try {
            $132d94fbf41cf0d4$var$Mk();
            break;
        } catch (h) {
            $132d94fbf41cf0d4$var$Nk(a, h);
        }
        $132d94fbf41cf0d4$var$Qg();
        $132d94fbf41cf0d4$var$nk.current = f;
        $132d94fbf41cf0d4$var$K = e;
        null !== $132d94fbf41cf0d4$var$Y ? b = 0 : ($132d94fbf41cf0d4$var$R = null, $132d94fbf41cf0d4$var$Z = 0, b = $132d94fbf41cf0d4$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $132d94fbf41cf0d4$var$xc(a), 0 !== e && (d = e, b = $132d94fbf41cf0d4$var$Ok(a, e)));
        if (1 === b) throw c = $132d94fbf41cf0d4$var$qk, $132d94fbf41cf0d4$var$Lk(a, 0), $132d94fbf41cf0d4$var$Dk(a, d), $132d94fbf41cf0d4$var$Ek(a, $132d94fbf41cf0d4$var$B()), c;
        if (6 === b) $132d94fbf41cf0d4$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$132d94fbf41cf0d4$var$Pk(e) && (b = $132d94fbf41cf0d4$var$Jk(a, d), 2 === b && (f = $132d94fbf41cf0d4$var$xc(a), 0 !== f && (d = f, b = $132d94fbf41cf0d4$var$Ok(a, f))), 1 === b)) throw c = $132d94fbf41cf0d4$var$qk, $132d94fbf41cf0d4$var$Lk(a, 0), $132d94fbf41cf0d4$var$Dk(a, d), $132d94fbf41cf0d4$var$Ek(a, $132d94fbf41cf0d4$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($132d94fbf41cf0d4$var$p(345));
                case 2:
                    $132d94fbf41cf0d4$var$Qk(a, $132d94fbf41cf0d4$var$uk, $132d94fbf41cf0d4$var$vk);
                    break;
                case 3:
                    $132d94fbf41cf0d4$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $132d94fbf41cf0d4$var$gk + 500 - $132d94fbf41cf0d4$var$B(), 10 < b)) {
                        if (0 !== $132d94fbf41cf0d4$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $132d94fbf41cf0d4$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $132d94fbf41cf0d4$var$Ff($132d94fbf41cf0d4$var$Qk.bind(null, a, $132d94fbf41cf0d4$var$uk, $132d94fbf41cf0d4$var$vk), b);
                        break;
                    }
                    $132d94fbf41cf0d4$var$Qk(a, $132d94fbf41cf0d4$var$uk, $132d94fbf41cf0d4$var$vk);
                    break;
                case 4:
                    $132d94fbf41cf0d4$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $132d94fbf41cf0d4$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $132d94fbf41cf0d4$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $132d94fbf41cf0d4$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $132d94fbf41cf0d4$var$Ff($132d94fbf41cf0d4$var$Qk.bind(null, a, $132d94fbf41cf0d4$var$uk, $132d94fbf41cf0d4$var$vk), d);
                        break;
                    }
                    $132d94fbf41cf0d4$var$Qk(a, $132d94fbf41cf0d4$var$uk, $132d94fbf41cf0d4$var$vk);
                    break;
                case 5:
                    $132d94fbf41cf0d4$var$Qk(a, $132d94fbf41cf0d4$var$uk, $132d94fbf41cf0d4$var$vk);
                    break;
                default:
                    throw Error($132d94fbf41cf0d4$var$p(329));
            }
        }
    }
    $132d94fbf41cf0d4$var$Ek(a, $132d94fbf41cf0d4$var$B());
    return a.callbackNode === c ? $132d94fbf41cf0d4$var$Hk.bind(null, a) : null;
}
function $132d94fbf41cf0d4$var$Ok(a, b) {
    var c = $132d94fbf41cf0d4$var$tk;
    a.current.memoizedState.isDehydrated && ($132d94fbf41cf0d4$var$Lk(a, b).flags |= 256);
    a = $132d94fbf41cf0d4$var$Jk(a, b);
    2 !== a && (b = $132d94fbf41cf0d4$var$uk, $132d94fbf41cf0d4$var$uk = c, null !== b && $132d94fbf41cf0d4$var$Gj(b));
    return a;
}
function $132d94fbf41cf0d4$var$Gj(a) {
    null === $132d94fbf41cf0d4$var$uk ? $132d94fbf41cf0d4$var$uk = a : $132d94fbf41cf0d4$var$uk.push.apply($132d94fbf41cf0d4$var$uk, a);
}
function $132d94fbf41cf0d4$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$132d94fbf41cf0d4$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $132d94fbf41cf0d4$var$Dk(a, b) {
    b &= ~$132d94fbf41cf0d4$var$sk;
    b &= ~$132d94fbf41cf0d4$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $132d94fbf41cf0d4$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $132d94fbf41cf0d4$var$Fk(a) {
    if (0 !== ($132d94fbf41cf0d4$var$K & 6)) throw Error($132d94fbf41cf0d4$var$p(327));
    $132d94fbf41cf0d4$var$Ik();
    var b = $132d94fbf41cf0d4$var$uc(a, 0);
    if (0 === (b & 1)) return $132d94fbf41cf0d4$var$Ek(a, $132d94fbf41cf0d4$var$B()), null;
    var c = $132d94fbf41cf0d4$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $132d94fbf41cf0d4$var$xc(a);
        0 !== d && (b = d, c = $132d94fbf41cf0d4$var$Ok(a, d));
    }
    if (1 === c) throw c = $132d94fbf41cf0d4$var$qk, $132d94fbf41cf0d4$var$Lk(a, 0), $132d94fbf41cf0d4$var$Dk(a, b), $132d94fbf41cf0d4$var$Ek(a, $132d94fbf41cf0d4$var$B()), c;
    if (6 === c) throw Error($132d94fbf41cf0d4$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $132d94fbf41cf0d4$var$Qk(a, $132d94fbf41cf0d4$var$uk, $132d94fbf41cf0d4$var$vk);
    $132d94fbf41cf0d4$var$Ek(a, $132d94fbf41cf0d4$var$B());
    return null;
}
function $132d94fbf41cf0d4$var$Rk(a, b) {
    var c = $132d94fbf41cf0d4$var$K;
    $132d94fbf41cf0d4$var$K |= 1;
    try {
        return a(b);
    } finally{
        $132d94fbf41cf0d4$var$K = c, 0 === $132d94fbf41cf0d4$var$K && ($132d94fbf41cf0d4$var$Hj = $132d94fbf41cf0d4$var$B() + 500, $132d94fbf41cf0d4$var$fg && $132d94fbf41cf0d4$var$jg());
    }
}
function $132d94fbf41cf0d4$var$Sk(a) {
    null !== $132d94fbf41cf0d4$var$xk && 0 === $132d94fbf41cf0d4$var$xk.tag && 0 === ($132d94fbf41cf0d4$var$K & 6) && $132d94fbf41cf0d4$var$Ik();
    var b = $132d94fbf41cf0d4$var$K;
    $132d94fbf41cf0d4$var$K |= 1;
    var c = $132d94fbf41cf0d4$var$pk.transition, d = $132d94fbf41cf0d4$var$C;
    try {
        if ($132d94fbf41cf0d4$var$pk.transition = null, $132d94fbf41cf0d4$var$C = 1, a) return a();
    } finally{
        $132d94fbf41cf0d4$var$C = d, $132d94fbf41cf0d4$var$pk.transition = c, $132d94fbf41cf0d4$var$K = b, 0 === ($132d94fbf41cf0d4$var$K & 6) && $132d94fbf41cf0d4$var$jg();
    }
}
function $132d94fbf41cf0d4$var$Ij() {
    $132d94fbf41cf0d4$var$gj = $132d94fbf41cf0d4$var$fj.current;
    $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$fj);
}
function $132d94fbf41cf0d4$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $132d94fbf41cf0d4$var$Gf(c));
    if (null !== $132d94fbf41cf0d4$var$Y) for(c = $132d94fbf41cf0d4$var$Y.return; null !== c;){
        var d = c;
        $132d94fbf41cf0d4$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $132d94fbf41cf0d4$var$$f();
                break;
            case 3:
                $132d94fbf41cf0d4$var$Jh();
                $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$Wf);
                $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$H);
                $132d94fbf41cf0d4$var$Oh();
                break;
            case 5:
                $132d94fbf41cf0d4$var$Lh(d);
                break;
            case 4:
                $132d94fbf41cf0d4$var$Jh();
                break;
            case 13:
                $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$M);
                break;
            case 19:
                $132d94fbf41cf0d4$var$E($132d94fbf41cf0d4$var$M);
                break;
            case 10:
                $132d94fbf41cf0d4$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $132d94fbf41cf0d4$var$Ij();
        }
        c = c.return;
    }
    $132d94fbf41cf0d4$var$R = a;
    $132d94fbf41cf0d4$var$Y = a = $132d94fbf41cf0d4$var$wh(a.current, null);
    $132d94fbf41cf0d4$var$Z = $132d94fbf41cf0d4$var$gj = b;
    $132d94fbf41cf0d4$var$T = 0;
    $132d94fbf41cf0d4$var$qk = null;
    $132d94fbf41cf0d4$var$sk = $132d94fbf41cf0d4$var$rk = $132d94fbf41cf0d4$var$hh = 0;
    $132d94fbf41cf0d4$var$uk = $132d94fbf41cf0d4$var$tk = null;
    if (null !== $132d94fbf41cf0d4$var$Wg) {
        for(b = 0; b < $132d94fbf41cf0d4$var$Wg.length; b++)if (c = $132d94fbf41cf0d4$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $132d94fbf41cf0d4$var$Wg = null;
    }
    return a;
}
function $132d94fbf41cf0d4$var$Nk(a, b) {
    do {
        var c = $132d94fbf41cf0d4$var$Y;
        try {
            $132d94fbf41cf0d4$var$Qg();
            $132d94fbf41cf0d4$var$Ph.current = $132d94fbf41cf0d4$var$ai;
            if ($132d94fbf41cf0d4$var$Sh) {
                for(var d = $132d94fbf41cf0d4$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $132d94fbf41cf0d4$var$Sh = !1;
            }
            $132d94fbf41cf0d4$var$Rh = 0;
            $132d94fbf41cf0d4$var$P = $132d94fbf41cf0d4$var$O = $132d94fbf41cf0d4$var$N = null;
            $132d94fbf41cf0d4$var$Th = !1;
            $132d94fbf41cf0d4$var$Uh = 0;
            $132d94fbf41cf0d4$var$ok.current = null;
            if (null === c || null === c.return) {
                $132d94fbf41cf0d4$var$T = 1;
                $132d94fbf41cf0d4$var$qk = b;
                $132d94fbf41cf0d4$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $132d94fbf41cf0d4$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $132d94fbf41cf0d4$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $132d94fbf41cf0d4$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $132d94fbf41cf0d4$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $132d94fbf41cf0d4$var$Ti(f, l, b);
                            $132d94fbf41cf0d4$var$uj();
                            break a;
                        }
                        k = Error($132d94fbf41cf0d4$var$p(426));
                    }
                } else if ($132d94fbf41cf0d4$var$I && h.mode & 1) {
                    var J = $132d94fbf41cf0d4$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $132d94fbf41cf0d4$var$Wi(J, g, h, f, b);
                        $132d94fbf41cf0d4$var$Jg($132d94fbf41cf0d4$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $132d94fbf41cf0d4$var$Ki(k, h);
                4 !== $132d94fbf41cf0d4$var$T && ($132d94fbf41cf0d4$var$T = 2);
                null === $132d94fbf41cf0d4$var$tk ? $132d94fbf41cf0d4$var$tk = [
                    f
                ] : $132d94fbf41cf0d4$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $132d94fbf41cf0d4$var$Oi(f, k, b);
                            $132d94fbf41cf0d4$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $132d94fbf41cf0d4$var$Si || !$132d94fbf41cf0d4$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $132d94fbf41cf0d4$var$Ri(f, h, b);
                                $132d94fbf41cf0d4$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $132d94fbf41cf0d4$var$Tk(c);
        } catch (na) {
            b = na;
            $132d94fbf41cf0d4$var$Y === c && null !== c && ($132d94fbf41cf0d4$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $132d94fbf41cf0d4$var$Kk() {
    var a = $132d94fbf41cf0d4$var$nk.current;
    $132d94fbf41cf0d4$var$nk.current = $132d94fbf41cf0d4$var$ai;
    return null === a ? $132d94fbf41cf0d4$var$ai : a;
}
function $132d94fbf41cf0d4$var$uj() {
    if (0 === $132d94fbf41cf0d4$var$T || 3 === $132d94fbf41cf0d4$var$T || 2 === $132d94fbf41cf0d4$var$T) $132d94fbf41cf0d4$var$T = 4;
    null === $132d94fbf41cf0d4$var$R || 0 === ($132d94fbf41cf0d4$var$hh & 268435455) && 0 === ($132d94fbf41cf0d4$var$rk & 268435455) || $132d94fbf41cf0d4$var$Dk($132d94fbf41cf0d4$var$R, $132d94fbf41cf0d4$var$Z);
}
function $132d94fbf41cf0d4$var$Jk(a, b) {
    var c = $132d94fbf41cf0d4$var$K;
    $132d94fbf41cf0d4$var$K |= 2;
    var d = $132d94fbf41cf0d4$var$Kk();
    if ($132d94fbf41cf0d4$var$R !== a || $132d94fbf41cf0d4$var$Z !== b) $132d94fbf41cf0d4$var$vk = null, $132d94fbf41cf0d4$var$Lk(a, b);
    for(;;)try {
        $132d94fbf41cf0d4$var$Uk();
        break;
    } catch (e) {
        $132d94fbf41cf0d4$var$Nk(a, e);
    }
    $132d94fbf41cf0d4$var$Qg();
    $132d94fbf41cf0d4$var$K = c;
    $132d94fbf41cf0d4$var$nk.current = d;
    if (null !== $132d94fbf41cf0d4$var$Y) throw Error($132d94fbf41cf0d4$var$p(261));
    $132d94fbf41cf0d4$var$R = null;
    $132d94fbf41cf0d4$var$Z = 0;
    return $132d94fbf41cf0d4$var$T;
}
function $132d94fbf41cf0d4$var$Uk() {
    for(; null !== $132d94fbf41cf0d4$var$Y;)$132d94fbf41cf0d4$var$Vk($132d94fbf41cf0d4$var$Y);
}
function $132d94fbf41cf0d4$var$Mk() {
    for(; null !== $132d94fbf41cf0d4$var$Y && !$132d94fbf41cf0d4$var$cc();)$132d94fbf41cf0d4$var$Vk($132d94fbf41cf0d4$var$Y);
}
function $132d94fbf41cf0d4$var$Vk(a) {
    var b = $132d94fbf41cf0d4$var$Wk(a.alternate, a, $132d94fbf41cf0d4$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $132d94fbf41cf0d4$var$Tk(a) : $132d94fbf41cf0d4$var$Y = b;
    $132d94fbf41cf0d4$var$ok.current = null;
}
function $132d94fbf41cf0d4$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $132d94fbf41cf0d4$var$Fj(c, b, $132d94fbf41cf0d4$var$gj), null !== c) {
                $132d94fbf41cf0d4$var$Y = c;
                return;
            }
        } else {
            c = $132d94fbf41cf0d4$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $132d94fbf41cf0d4$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $132d94fbf41cf0d4$var$T = 6;
                $132d94fbf41cf0d4$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $132d94fbf41cf0d4$var$Y = b;
            return;
        }
        $132d94fbf41cf0d4$var$Y = b = a;
    }while (null !== b);
    0 === $132d94fbf41cf0d4$var$T && ($132d94fbf41cf0d4$var$T = 5);
}
function $132d94fbf41cf0d4$var$Qk(a, b, c) {
    var d = $132d94fbf41cf0d4$var$C, e = $132d94fbf41cf0d4$var$pk.transition;
    try {
        $132d94fbf41cf0d4$var$pk.transition = null, $132d94fbf41cf0d4$var$C = 1, $132d94fbf41cf0d4$var$Xk(a, b, c, d);
    } finally{
        $132d94fbf41cf0d4$var$pk.transition = e, $132d94fbf41cf0d4$var$C = d;
    }
    return null;
}
function $132d94fbf41cf0d4$var$Xk(a, b, c, d) {
    do $132d94fbf41cf0d4$var$Ik();
    while (null !== $132d94fbf41cf0d4$var$xk);
    if (0 !== ($132d94fbf41cf0d4$var$K & 6)) throw Error($132d94fbf41cf0d4$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($132d94fbf41cf0d4$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $132d94fbf41cf0d4$var$Bc(a, f);
    a === $132d94fbf41cf0d4$var$R && ($132d94fbf41cf0d4$var$Y = $132d94fbf41cf0d4$var$R = null, $132d94fbf41cf0d4$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $132d94fbf41cf0d4$var$wk || ($132d94fbf41cf0d4$var$wk = !0, $132d94fbf41cf0d4$var$Gk($132d94fbf41cf0d4$var$hc, function() {
        $132d94fbf41cf0d4$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $132d94fbf41cf0d4$var$pk.transition;
        $132d94fbf41cf0d4$var$pk.transition = null;
        var g = $132d94fbf41cf0d4$var$C;
        $132d94fbf41cf0d4$var$C = 1;
        var h = $132d94fbf41cf0d4$var$K;
        $132d94fbf41cf0d4$var$K |= 4;
        $132d94fbf41cf0d4$var$ok.current = null;
        $132d94fbf41cf0d4$var$Pj(a, c);
        $132d94fbf41cf0d4$var$ek(c, a);
        $132d94fbf41cf0d4$var$Oe($132d94fbf41cf0d4$var$Df);
        $132d94fbf41cf0d4$var$dd = !!$132d94fbf41cf0d4$var$Cf;
        $132d94fbf41cf0d4$var$Df = $132d94fbf41cf0d4$var$Cf = null;
        a.current = c;
        $132d94fbf41cf0d4$var$ik(c, a, e);
        $132d94fbf41cf0d4$var$dc();
        $132d94fbf41cf0d4$var$K = h;
        $132d94fbf41cf0d4$var$C = g;
        $132d94fbf41cf0d4$var$pk.transition = f;
    } else a.current = c;
    $132d94fbf41cf0d4$var$wk && ($132d94fbf41cf0d4$var$wk = !1, $132d94fbf41cf0d4$var$xk = a, $132d94fbf41cf0d4$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($132d94fbf41cf0d4$var$Si = null);
    $132d94fbf41cf0d4$var$mc(c.stateNode, d);
    $132d94fbf41cf0d4$var$Ek(a, $132d94fbf41cf0d4$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($132d94fbf41cf0d4$var$Pi) throw $132d94fbf41cf0d4$var$Pi = !1, a = $132d94fbf41cf0d4$var$Qi, $132d94fbf41cf0d4$var$Qi = null, a;
    0 !== ($132d94fbf41cf0d4$var$yk & 1) && 0 !== a.tag && $132d94fbf41cf0d4$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $132d94fbf41cf0d4$var$Ak ? $132d94fbf41cf0d4$var$zk++ : ($132d94fbf41cf0d4$var$zk = 0, $132d94fbf41cf0d4$var$Ak = a) : $132d94fbf41cf0d4$var$zk = 0;
    $132d94fbf41cf0d4$var$jg();
    return null;
}
function $132d94fbf41cf0d4$var$Ik() {
    if (null !== $132d94fbf41cf0d4$var$xk) {
        var a = $132d94fbf41cf0d4$var$Dc($132d94fbf41cf0d4$var$yk), b = $132d94fbf41cf0d4$var$pk.transition, c = $132d94fbf41cf0d4$var$C;
        try {
            $132d94fbf41cf0d4$var$pk.transition = null;
            $132d94fbf41cf0d4$var$C = 16 > a ? 16 : a;
            if (null === $132d94fbf41cf0d4$var$xk) var d = !1;
            else {
                a = $132d94fbf41cf0d4$var$xk;
                $132d94fbf41cf0d4$var$xk = null;
                $132d94fbf41cf0d4$var$yk = 0;
                if (0 !== ($132d94fbf41cf0d4$var$K & 6)) throw Error($132d94fbf41cf0d4$var$p(331));
                var e = $132d94fbf41cf0d4$var$K;
                $132d94fbf41cf0d4$var$K |= 4;
                for($132d94fbf41cf0d4$var$V = a.current; null !== $132d94fbf41cf0d4$var$V;){
                    var f = $132d94fbf41cf0d4$var$V, g = f.child;
                    if (0 !== ($132d94fbf41cf0d4$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($132d94fbf41cf0d4$var$V = l; null !== $132d94fbf41cf0d4$var$V;){
                                    var m = $132d94fbf41cf0d4$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $132d94fbf41cf0d4$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $132d94fbf41cf0d4$var$V = q;
                                    else for(; null !== $132d94fbf41cf0d4$var$V;){
                                        m = $132d94fbf41cf0d4$var$V;
                                        var r = m.sibling, y = m.return;
                                        $132d94fbf41cf0d4$var$Tj(m);
                                        if (m === l) {
                                            $132d94fbf41cf0d4$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $132d94fbf41cf0d4$var$V = r;
                                            break;
                                        }
                                        $132d94fbf41cf0d4$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $132d94fbf41cf0d4$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $132d94fbf41cf0d4$var$V = g;
                    else b: for(; null !== $132d94fbf41cf0d4$var$V;){
                        f = $132d94fbf41cf0d4$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $132d94fbf41cf0d4$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $132d94fbf41cf0d4$var$V = x;
                            break b;
                        }
                        $132d94fbf41cf0d4$var$V = f.return;
                    }
                }
                var w = a.current;
                for($132d94fbf41cf0d4$var$V = w; null !== $132d94fbf41cf0d4$var$V;){
                    g = $132d94fbf41cf0d4$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $132d94fbf41cf0d4$var$V = u;
                    else b: for(g = w; null !== $132d94fbf41cf0d4$var$V;){
                        h = $132d94fbf41cf0d4$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $132d94fbf41cf0d4$var$Rj(9, h);
                            }
                        } catch (na) {
                            $132d94fbf41cf0d4$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $132d94fbf41cf0d4$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $132d94fbf41cf0d4$var$V = F;
                            break b;
                        }
                        $132d94fbf41cf0d4$var$V = h.return;
                    }
                }
                $132d94fbf41cf0d4$var$K = e;
                $132d94fbf41cf0d4$var$jg();
                if ($132d94fbf41cf0d4$var$lc && "function" === typeof $132d94fbf41cf0d4$var$lc.onPostCommitFiberRoot) try {
                    $132d94fbf41cf0d4$var$lc.onPostCommitFiberRoot($132d94fbf41cf0d4$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $132d94fbf41cf0d4$var$C = c, $132d94fbf41cf0d4$var$pk.transition = b;
        }
    }
    return !1;
}
function $132d94fbf41cf0d4$var$Yk(a, b, c) {
    b = $132d94fbf41cf0d4$var$Ki(c, b);
    b = $132d94fbf41cf0d4$var$Oi(a, b, 1);
    a = $132d94fbf41cf0d4$var$dh(a, b, 1);
    b = $132d94fbf41cf0d4$var$L();
    null !== a && ($132d94fbf41cf0d4$var$Ac(a, 1, b), $132d94fbf41cf0d4$var$Ek(a, b));
}
function $132d94fbf41cf0d4$var$W(a, b, c) {
    if (3 === a.tag) $132d94fbf41cf0d4$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $132d94fbf41cf0d4$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $132d94fbf41cf0d4$var$Si || !$132d94fbf41cf0d4$var$Si.has(d))) {
                a = $132d94fbf41cf0d4$var$Ki(c, a);
                a = $132d94fbf41cf0d4$var$Ri(b, a, 1);
                b = $132d94fbf41cf0d4$var$dh(b, a, 1);
                a = $132d94fbf41cf0d4$var$L();
                null !== b && ($132d94fbf41cf0d4$var$Ac(b, 1, a), $132d94fbf41cf0d4$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $132d94fbf41cf0d4$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $132d94fbf41cf0d4$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $132d94fbf41cf0d4$var$R === a && ($132d94fbf41cf0d4$var$Z & c) === c && (4 === $132d94fbf41cf0d4$var$T || 3 === $132d94fbf41cf0d4$var$T && ($132d94fbf41cf0d4$var$Z & 130023424) === $132d94fbf41cf0d4$var$Z && 500 > $132d94fbf41cf0d4$var$B() - $132d94fbf41cf0d4$var$gk ? $132d94fbf41cf0d4$var$Lk(a, 0) : $132d94fbf41cf0d4$var$sk |= c);
    $132d94fbf41cf0d4$var$Ek(a, b);
}
function $132d94fbf41cf0d4$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $132d94fbf41cf0d4$var$sc, $132d94fbf41cf0d4$var$sc <<= 1, 0 === ($132d94fbf41cf0d4$var$sc & 130023424) && ($132d94fbf41cf0d4$var$sc = 4194304)));
    var c = $132d94fbf41cf0d4$var$L();
    a = $132d94fbf41cf0d4$var$Zg(a, b);
    null !== a && ($132d94fbf41cf0d4$var$Ac(a, b, c), $132d94fbf41cf0d4$var$Ek(a, c));
}
function $132d94fbf41cf0d4$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $132d94fbf41cf0d4$var$Zk(a, c);
}
function $132d94fbf41cf0d4$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($132d94fbf41cf0d4$var$p(314));
    }
    null !== d && d.delete(b);
    $132d94fbf41cf0d4$var$Zk(a, c);
}
var $132d94fbf41cf0d4$var$Wk;
$132d94fbf41cf0d4$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $132d94fbf41cf0d4$var$Wf.current) $132d94fbf41cf0d4$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $132d94fbf41cf0d4$var$Ug = !1, $132d94fbf41cf0d4$var$zj(a, b, c);
            $132d94fbf41cf0d4$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $132d94fbf41cf0d4$var$Ug = !1, $132d94fbf41cf0d4$var$I && 0 !== (b.flags & 1048576) && $132d94fbf41cf0d4$var$ug(b, $132d94fbf41cf0d4$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $132d94fbf41cf0d4$var$jj(a, b);
            a = b.pendingProps;
            var e = $132d94fbf41cf0d4$var$Yf(b, $132d94fbf41cf0d4$var$H.current);
            $132d94fbf41cf0d4$var$Tg(b, c);
            e = $132d94fbf41cf0d4$var$Xh(null, b, d, a, e, c);
            var f = $132d94fbf41cf0d4$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $132d94fbf41cf0d4$var$Zf(d) ? (f = !0, $132d94fbf41cf0d4$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $132d94fbf41cf0d4$var$ah(b), e.updater = $132d94fbf41cf0d4$var$nh, b.stateNode = e, e._reactInternals = b, $132d94fbf41cf0d4$var$rh(b, d, a, c), b = $132d94fbf41cf0d4$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $132d94fbf41cf0d4$var$I && f && $132d94fbf41cf0d4$var$vg(b), $132d94fbf41cf0d4$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $132d94fbf41cf0d4$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $132d94fbf41cf0d4$var$$k(d);
                a = $132d94fbf41cf0d4$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $132d94fbf41cf0d4$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $132d94fbf41cf0d4$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $132d94fbf41cf0d4$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $132d94fbf41cf0d4$var$aj(null, b, d, $132d94fbf41cf0d4$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($132d94fbf41cf0d4$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $132d94fbf41cf0d4$var$Lg(d, e), $132d94fbf41cf0d4$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $132d94fbf41cf0d4$var$Lg(d, e), $132d94fbf41cf0d4$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $132d94fbf41cf0d4$var$lj(b);
                if (null === a) throw Error($132d94fbf41cf0d4$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $132d94fbf41cf0d4$var$bh(a, b);
                $132d94fbf41cf0d4$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $132d94fbf41cf0d4$var$Ki(Error($132d94fbf41cf0d4$var$p(423)), b);
                        b = $132d94fbf41cf0d4$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $132d94fbf41cf0d4$var$Ki(Error($132d94fbf41cf0d4$var$p(424)), b);
                        b = $132d94fbf41cf0d4$var$mj(a, b, d, c, e);
                        break a;
                    } else for($132d94fbf41cf0d4$var$yg = $132d94fbf41cf0d4$var$Lf(b.stateNode.containerInfo.firstChild), $132d94fbf41cf0d4$var$xg = b, $132d94fbf41cf0d4$var$I = !0, $132d94fbf41cf0d4$var$zg = null, c = $132d94fbf41cf0d4$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $132d94fbf41cf0d4$var$Ig();
                    if (d === e) {
                        b = $132d94fbf41cf0d4$var$$i(a, b, c);
                        break a;
                    }
                    $132d94fbf41cf0d4$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $132d94fbf41cf0d4$var$Kh(b), null === a && $132d94fbf41cf0d4$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $132d94fbf41cf0d4$var$Ef(d, e) ? g = null : null !== f && $132d94fbf41cf0d4$var$Ef(d, f) && (b.flags |= 32), $132d94fbf41cf0d4$var$hj(a, b), $132d94fbf41cf0d4$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $132d94fbf41cf0d4$var$Eg(b), null;
        case 13:
            return $132d94fbf41cf0d4$var$pj(a, b, c);
        case 4:
            return $132d94fbf41cf0d4$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $132d94fbf41cf0d4$var$Bh(b, null, d, c) : $132d94fbf41cf0d4$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $132d94fbf41cf0d4$var$Lg(d, e), $132d94fbf41cf0d4$var$Zi(a, b, d, e, c);
        case 7:
            return $132d94fbf41cf0d4$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $132d94fbf41cf0d4$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $132d94fbf41cf0d4$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $132d94fbf41cf0d4$var$G($132d94fbf41cf0d4$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($132d94fbf41cf0d4$var$He(f.value, g)) {
                        if (f.children === e.children && !$132d94fbf41cf0d4$var$Wf.current) {
                            b = $132d94fbf41cf0d4$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $132d94fbf41cf0d4$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $132d94fbf41cf0d4$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($132d94fbf41cf0d4$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $132d94fbf41cf0d4$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $132d94fbf41cf0d4$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $132d94fbf41cf0d4$var$Tg(b, c), e = $132d94fbf41cf0d4$var$Vg(e), d = d(e), b.flags |= 1, $132d94fbf41cf0d4$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $132d94fbf41cf0d4$var$Lg(d, b.pendingProps), e = $132d94fbf41cf0d4$var$Lg(d.type, e), $132d94fbf41cf0d4$var$aj(a, b, d, e, c);
        case 15:
            return $132d94fbf41cf0d4$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $132d94fbf41cf0d4$var$Lg(d, e), $132d94fbf41cf0d4$var$jj(a, b), b.tag = 1, $132d94fbf41cf0d4$var$Zf(d) ? (a = !0, $132d94fbf41cf0d4$var$cg(b)) : a = !1, $132d94fbf41cf0d4$var$Tg(b, c), $132d94fbf41cf0d4$var$ph(b, d, e), $132d94fbf41cf0d4$var$rh(b, d, e, c), $132d94fbf41cf0d4$var$kj(null, b, d, !0, a, c);
        case 19:
            return $132d94fbf41cf0d4$var$yj(a, b, c);
        case 22:
            return $132d94fbf41cf0d4$var$ej(a, b, c);
    }
    throw Error($132d94fbf41cf0d4$var$p(156, b.tag));
};
function $132d94fbf41cf0d4$var$Gk(a, b) {
    return $132d94fbf41cf0d4$var$ac(a, b);
}
function $132d94fbf41cf0d4$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $132d94fbf41cf0d4$var$Bg(a, b, c, d) {
    return new $132d94fbf41cf0d4$var$al(a, b, c, d);
}
function $132d94fbf41cf0d4$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $132d94fbf41cf0d4$var$$k(a) {
    if ("function" === typeof a) return $132d94fbf41cf0d4$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $132d94fbf41cf0d4$var$Da) return 11;
        if (a === $132d94fbf41cf0d4$var$Ga) return 14;
    }
    return 2;
}
function $132d94fbf41cf0d4$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $132d94fbf41cf0d4$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $132d94fbf41cf0d4$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $132d94fbf41cf0d4$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $132d94fbf41cf0d4$var$ya:
            return $132d94fbf41cf0d4$var$Ah(c.children, e, f, b);
        case $132d94fbf41cf0d4$var$za:
            g = 8;
            e |= 8;
            break;
        case $132d94fbf41cf0d4$var$Aa:
            return a = $132d94fbf41cf0d4$var$Bg(12, c, b, e | 2), a.elementType = $132d94fbf41cf0d4$var$Aa, a.lanes = f, a;
        case $132d94fbf41cf0d4$var$Ea:
            return a = $132d94fbf41cf0d4$var$Bg(13, c, b, e), a.elementType = $132d94fbf41cf0d4$var$Ea, a.lanes = f, a;
        case $132d94fbf41cf0d4$var$Fa:
            return a = $132d94fbf41cf0d4$var$Bg(19, c, b, e), a.elementType = $132d94fbf41cf0d4$var$Fa, a.lanes = f, a;
        case $132d94fbf41cf0d4$var$Ia:
            return $132d94fbf41cf0d4$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $132d94fbf41cf0d4$var$Ba:
                    g = 10;
                    break a;
                case $132d94fbf41cf0d4$var$Ca:
                    g = 9;
                    break a;
                case $132d94fbf41cf0d4$var$Da:
                    g = 11;
                    break a;
                case $132d94fbf41cf0d4$var$Ga:
                    g = 14;
                    break a;
                case $132d94fbf41cf0d4$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($132d94fbf41cf0d4$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $132d94fbf41cf0d4$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $132d94fbf41cf0d4$var$Ah(a, b, c, d) {
    a = $132d94fbf41cf0d4$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $132d94fbf41cf0d4$var$qj(a, b, c, d) {
    a = $132d94fbf41cf0d4$var$Bg(22, a, d, b);
    a.elementType = $132d94fbf41cf0d4$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $132d94fbf41cf0d4$var$xh(a, b, c) {
    a = $132d94fbf41cf0d4$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $132d94fbf41cf0d4$var$zh(a, b, c) {
    b = $132d94fbf41cf0d4$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $132d94fbf41cf0d4$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $132d94fbf41cf0d4$var$zc(0);
    this.expirationTimes = $132d94fbf41cf0d4$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $132d94fbf41cf0d4$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $132d94fbf41cf0d4$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $132d94fbf41cf0d4$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $132d94fbf41cf0d4$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $132d94fbf41cf0d4$var$ah(f);
    return a;
}
function $132d94fbf41cf0d4$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $132d94fbf41cf0d4$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $132d94fbf41cf0d4$var$el(a) {
    if (!a) return $132d94fbf41cf0d4$var$Vf;
    a = a._reactInternals;
    a: {
        if ($132d94fbf41cf0d4$var$Vb(a) !== a || 1 !== a.tag) throw Error($132d94fbf41cf0d4$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($132d94fbf41cf0d4$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($132d94fbf41cf0d4$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($132d94fbf41cf0d4$var$Zf(c)) return $132d94fbf41cf0d4$var$bg(a, c, b);
    }
    return b;
}
function $132d94fbf41cf0d4$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $132d94fbf41cf0d4$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $132d94fbf41cf0d4$var$el(null);
    c = a.current;
    d = $132d94fbf41cf0d4$var$L();
    e = $132d94fbf41cf0d4$var$lh(c);
    f = $132d94fbf41cf0d4$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $132d94fbf41cf0d4$var$dh(c, f, e);
    a.current.lanes = e;
    $132d94fbf41cf0d4$var$Ac(a, e, d);
    $132d94fbf41cf0d4$var$Ek(a, d);
    return a;
}
function $132d94fbf41cf0d4$var$gl(a, b, c, d) {
    var e = b.current, f = $132d94fbf41cf0d4$var$L(), g = $132d94fbf41cf0d4$var$lh(e);
    c = $132d94fbf41cf0d4$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $132d94fbf41cf0d4$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $132d94fbf41cf0d4$var$dh(e, b, g);
    null !== a && ($132d94fbf41cf0d4$var$mh(a, e, g, f), $132d94fbf41cf0d4$var$eh(a, e, g));
    return g;
}
function $132d94fbf41cf0d4$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $132d94fbf41cf0d4$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $132d94fbf41cf0d4$var$jl(a, b) {
    $132d94fbf41cf0d4$var$il(a, b);
    (a = a.alternate) && $132d94fbf41cf0d4$var$il(a, b);
}
function $132d94fbf41cf0d4$var$kl() {
    return null;
}
var $132d94fbf41cf0d4$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $132d94fbf41cf0d4$var$ml(a) {
    this._internalRoot = a;
}
$132d94fbf41cf0d4$var$nl.prototype.render = $132d94fbf41cf0d4$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($132d94fbf41cf0d4$var$p(409));
    $132d94fbf41cf0d4$var$gl(a, b, null, null);
};
$132d94fbf41cf0d4$var$nl.prototype.unmount = $132d94fbf41cf0d4$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $132d94fbf41cf0d4$var$Sk(function() {
            $132d94fbf41cf0d4$var$gl(null, a, null, null);
        });
        b[$132d94fbf41cf0d4$var$uf] = null;
    }
};
function $132d94fbf41cf0d4$var$nl(a) {
    this._internalRoot = a;
}
$132d94fbf41cf0d4$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $132d94fbf41cf0d4$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $132d94fbf41cf0d4$var$Qc.length && 0 !== b && b < $132d94fbf41cf0d4$var$Qc[c].priority; c++);
        $132d94fbf41cf0d4$var$Qc.splice(c, 0, a);
        0 === c && $132d94fbf41cf0d4$var$Vc(a);
    }
};
function $132d94fbf41cf0d4$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $132d94fbf41cf0d4$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $132d94fbf41cf0d4$var$ql() {}
function $132d94fbf41cf0d4$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $132d94fbf41cf0d4$var$hl(g);
                f.call(a);
            };
        }
        var g = $132d94fbf41cf0d4$var$fl(b, d, a, 0, null, !1, !1, "", $132d94fbf41cf0d4$var$ql);
        a._reactRootContainer = g;
        a[$132d94fbf41cf0d4$var$uf] = g.current;
        $132d94fbf41cf0d4$var$sf(8 === a.nodeType ? a.parentNode : a);
        $132d94fbf41cf0d4$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $132d94fbf41cf0d4$var$hl(k);
            h.call(a);
        };
    }
    var k = $132d94fbf41cf0d4$var$cl(a, 0, !1, null, null, !1, !1, "", $132d94fbf41cf0d4$var$ql);
    a._reactRootContainer = k;
    a[$132d94fbf41cf0d4$var$uf] = k.current;
    $132d94fbf41cf0d4$var$sf(8 === a.nodeType ? a.parentNode : a);
    $132d94fbf41cf0d4$var$Sk(function() {
        $132d94fbf41cf0d4$var$gl(b, k, c, d);
    });
    return k;
}
function $132d94fbf41cf0d4$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $132d94fbf41cf0d4$var$hl(g);
                h.call(a);
            };
        }
        $132d94fbf41cf0d4$var$gl(b, g, a, e);
    } else g = $132d94fbf41cf0d4$var$rl(c, b, a, e, d);
    return $132d94fbf41cf0d4$var$hl(g);
}
$132d94fbf41cf0d4$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $132d94fbf41cf0d4$var$tc(b.pendingLanes);
                0 !== c && ($132d94fbf41cf0d4$var$Cc(b, c | 1), $132d94fbf41cf0d4$var$Ek(b, $132d94fbf41cf0d4$var$B()), 0 === ($132d94fbf41cf0d4$var$K & 6) && ($132d94fbf41cf0d4$var$Hj = $132d94fbf41cf0d4$var$B() + 500, $132d94fbf41cf0d4$var$jg()));
            }
            break;
        case 13:
            $132d94fbf41cf0d4$var$Sk(function() {
                var b = $132d94fbf41cf0d4$var$Zg(a, 1);
                if (null !== b) {
                    var c = $132d94fbf41cf0d4$var$L();
                    $132d94fbf41cf0d4$var$mh(b, a, 1, c);
                }
            }), $132d94fbf41cf0d4$var$jl(a, 1);
    }
};
$132d94fbf41cf0d4$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $132d94fbf41cf0d4$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $132d94fbf41cf0d4$var$L();
            $132d94fbf41cf0d4$var$mh(b, a, 134217728, c);
        }
        $132d94fbf41cf0d4$var$jl(a, 134217728);
    }
};
$132d94fbf41cf0d4$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $132d94fbf41cf0d4$var$lh(a), c = $132d94fbf41cf0d4$var$Zg(a, b);
        if (null !== c) {
            var d = $132d94fbf41cf0d4$var$L();
            $132d94fbf41cf0d4$var$mh(c, a, b, d);
        }
        $132d94fbf41cf0d4$var$jl(a, b);
    }
};
$132d94fbf41cf0d4$var$Hc = function() {
    return $132d94fbf41cf0d4$var$C;
};
$132d94fbf41cf0d4$var$Ic = function(a, b) {
    var c = $132d94fbf41cf0d4$var$C;
    try {
        return $132d94fbf41cf0d4$var$C = a, b();
    } finally{
        $132d94fbf41cf0d4$var$C = c;
    }
};
$132d94fbf41cf0d4$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $132d94fbf41cf0d4$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $132d94fbf41cf0d4$var$Db(d);
                        if (!e) throw Error($132d94fbf41cf0d4$var$p(90));
                        $132d94fbf41cf0d4$var$Wa(d);
                        $132d94fbf41cf0d4$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $132d94fbf41cf0d4$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $132d94fbf41cf0d4$var$fb(a, !!c.multiple, b, !1);
    }
};
$132d94fbf41cf0d4$var$Gb = $132d94fbf41cf0d4$var$Rk;
$132d94fbf41cf0d4$var$Hb = $132d94fbf41cf0d4$var$Sk;
var $132d94fbf41cf0d4$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $132d94fbf41cf0d4$var$Cb,
        $132d94fbf41cf0d4$var$ue,
        $132d94fbf41cf0d4$var$Db,
        $132d94fbf41cf0d4$var$Eb,
        $132d94fbf41cf0d4$var$Fb,
        $132d94fbf41cf0d4$var$Rk
    ]
}, $132d94fbf41cf0d4$var$ul = {
    findFiberByHostInstance: $132d94fbf41cf0d4$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $132d94fbf41cf0d4$var$vl = {
    bundleType: $132d94fbf41cf0d4$var$ul.bundleType,
    version: $132d94fbf41cf0d4$var$ul.version,
    rendererPackageName: $132d94fbf41cf0d4$var$ul.rendererPackageName,
    rendererConfig: $132d94fbf41cf0d4$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $132d94fbf41cf0d4$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $132d94fbf41cf0d4$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $132d94fbf41cf0d4$var$ul.findFiberByHostInstance || $132d94fbf41cf0d4$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $132d94fbf41cf0d4$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$132d94fbf41cf0d4$var$wl.isDisabled && $132d94fbf41cf0d4$var$wl.supportsFiber) try {
        $132d94fbf41cf0d4$var$kc = $132d94fbf41cf0d4$var$wl.inject($132d94fbf41cf0d4$var$vl), $132d94fbf41cf0d4$var$lc = $132d94fbf41cf0d4$var$wl;
    } catch (a) {}
}
$132d94fbf41cf0d4$export$ae55be85d98224ed = $132d94fbf41cf0d4$var$tl;
$132d94fbf41cf0d4$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$132d94fbf41cf0d4$var$ol(b)) throw Error($132d94fbf41cf0d4$var$p(200));
    return $132d94fbf41cf0d4$var$dl(a, b, null, c);
};
$132d94fbf41cf0d4$export$882461b6382ed46c = function(a, b) {
    if (!$132d94fbf41cf0d4$var$ol(a)) throw Error($132d94fbf41cf0d4$var$p(299));
    var c = !1, d = "", e = $132d94fbf41cf0d4$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $132d94fbf41cf0d4$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$132d94fbf41cf0d4$var$uf] = b.current;
    $132d94fbf41cf0d4$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $132d94fbf41cf0d4$var$ml(b);
};
$132d94fbf41cf0d4$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($132d94fbf41cf0d4$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($132d94fbf41cf0d4$var$p(268, a));
    }
    a = $132d94fbf41cf0d4$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$132d94fbf41cf0d4$export$cd75ccfd720a3cd4 = function(a) {
    return $132d94fbf41cf0d4$var$Sk(a);
};
$132d94fbf41cf0d4$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$132d94fbf41cf0d4$var$pl(b)) throw Error($132d94fbf41cf0d4$var$p(200));
    return $132d94fbf41cf0d4$var$sl(null, a, b, !0, c);
};
$132d94fbf41cf0d4$export$757ceba2d55c277e = function(a, b, c) {
    if (!$132d94fbf41cf0d4$var$ol(a)) throw Error($132d94fbf41cf0d4$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $132d94fbf41cf0d4$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $132d94fbf41cf0d4$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$132d94fbf41cf0d4$var$uf] = b.current;
    $132d94fbf41cf0d4$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $132d94fbf41cf0d4$var$nl(b);
};
$132d94fbf41cf0d4$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$132d94fbf41cf0d4$var$pl(b)) throw Error($132d94fbf41cf0d4$var$p(200));
    return $132d94fbf41cf0d4$var$sl(null, a, b, !1, c);
};
$132d94fbf41cf0d4$export$502457920280e6be = function(a) {
    if (!$132d94fbf41cf0d4$var$pl(a)) throw Error($132d94fbf41cf0d4$var$p(40));
    return a._reactRootContainer ? ($132d94fbf41cf0d4$var$Sk(function() {
        $132d94fbf41cf0d4$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$132d94fbf41cf0d4$var$uf] = null;
        });
    }), !0) : !1;
};
$132d94fbf41cf0d4$export$c78a37762a8d58e1 = $132d94fbf41cf0d4$var$Rk;
$132d94fbf41cf0d4$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$132d94fbf41cf0d4$var$pl(c)) throw Error($132d94fbf41cf0d4$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($132d94fbf41cf0d4$var$p(38));
    return $132d94fbf41cf0d4$var$sl(a, b, c, !1, d);
};
$132d94fbf41cf0d4$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("aVkVc", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hGRYp"));

});
parcelRegister("hGRYp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $ce1039e2a5f863f5$export$c4744153514ff05d, (v) => $ce1039e2a5f863f5$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $ce1039e2a5f863f5$export$3e506c1ccc9cc1a7, (v) => $ce1039e2a5f863f5$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $ce1039e2a5f863f5$export$e26fe2ed2fa76875, (v) => $ce1039e2a5f863f5$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $ce1039e2a5f863f5$export$502329bbf4b505b1, (v) => $ce1039e2a5f863f5$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $ce1039e2a5f863f5$export$6e3807111c4874c4, (v) => $ce1039e2a5f863f5$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $ce1039e2a5f863f5$export$c27134553091fb3a, (v) => $ce1039e2a5f863f5$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $ce1039e2a5f863f5$export$33ee1acdc04fd2a2, (v) => $ce1039e2a5f863f5$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $ce1039e2a5f863f5$export$b00a404bbd5edef2, (v) => $ce1039e2a5f863f5$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $ce1039e2a5f863f5$export$8352ce38b91d0c62, (v) => $ce1039e2a5f863f5$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $ce1039e2a5f863f5$export$d66a1c1c77bd778b, (v) => $ce1039e2a5f863f5$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $ce1039e2a5f863f5$export$d3dfb8e4810cb555, (v) => $ce1039e2a5f863f5$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $ce1039e2a5f863f5$export$839f9183b0465a69, (v) => $ce1039e2a5f863f5$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $ce1039e2a5f863f5$export$72fdf0e06517287b, (v) => $ce1039e2a5f863f5$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $ce1039e2a5f863f5$export$4b844e58a3e414b4, (v) => $ce1039e2a5f863f5$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $ce1039e2a5f863f5$export$816d2913ae6b83b1, (v) => $ce1039e2a5f863f5$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $ce1039e2a5f863f5$export$61bcfe829111a1d0, (v) => $ce1039e2a5f863f5$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $ce1039e2a5f863f5$export$7ee8c9beb337bc3f, (v) => $ce1039e2a5f863f5$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $ce1039e2a5f863f5$export$b5836b71941fa3ed, (v) => $ce1039e2a5f863f5$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $ce1039e2a5f863f5$export$cf845f2c119da08a, (v) => $ce1039e2a5f863f5$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ce1039e2a5f863f5$export$c4744153514ff05d;
var $ce1039e2a5f863f5$export$3e506c1ccc9cc1a7;
var $ce1039e2a5f863f5$export$e26fe2ed2fa76875;
var $ce1039e2a5f863f5$export$502329bbf4b505b1;
var $ce1039e2a5f863f5$export$6e3807111c4874c4;
var $ce1039e2a5f863f5$export$c27134553091fb3a;
var $ce1039e2a5f863f5$export$33ee1acdc04fd2a2;
var $ce1039e2a5f863f5$export$b00a404bbd5edef2;
var $ce1039e2a5f863f5$export$8352ce38b91d0c62;
var $ce1039e2a5f863f5$export$d66a1c1c77bd778b;
var $ce1039e2a5f863f5$export$d3dfb8e4810cb555;
var $ce1039e2a5f863f5$export$839f9183b0465a69;
var $ce1039e2a5f863f5$export$72fdf0e06517287b;
var $ce1039e2a5f863f5$export$4b844e58a3e414b4;
var $ce1039e2a5f863f5$export$816d2913ae6b83b1;
var $ce1039e2a5f863f5$export$61bcfe829111a1d0;
var $ce1039e2a5f863f5$export$7ee8c9beb337bc3f;
var $ce1039e2a5f863f5$export$b5836b71941fa3ed;
var $ce1039e2a5f863f5$export$cf845f2c119da08a;
"use strict";
function $ce1039e2a5f863f5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ce1039e2a5f863f5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ce1039e2a5f863f5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ce1039e2a5f863f5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ce1039e2a5f863f5$var$g(C, c)) n < e && 0 > $ce1039e2a5f863f5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ce1039e2a5f863f5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ce1039e2a5f863f5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ce1039e2a5f863f5$var$l = performance;
    $ce1039e2a5f863f5$export$c4744153514ff05d = function() {
        return $ce1039e2a5f863f5$var$l.now();
    };
} else {
    var $ce1039e2a5f863f5$var$p = Date, $ce1039e2a5f863f5$var$q = $ce1039e2a5f863f5$var$p.now();
    $ce1039e2a5f863f5$export$c4744153514ff05d = function() {
        return $ce1039e2a5f863f5$var$p.now() - $ce1039e2a5f863f5$var$q;
    };
}
var $ce1039e2a5f863f5$var$r = [], $ce1039e2a5f863f5$var$t = [], $ce1039e2a5f863f5$var$u = 1, $ce1039e2a5f863f5$var$v = null, $ce1039e2a5f863f5$var$y = 3, $ce1039e2a5f863f5$var$z = !1, $ce1039e2a5f863f5$var$A = !1, $ce1039e2a5f863f5$var$B = !1, $ce1039e2a5f863f5$var$D = "function" === typeof setTimeout ? setTimeout : null, $ce1039e2a5f863f5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ce1039e2a5f863f5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ce1039e2a5f863f5$var$G(a) {
    for(var b = $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$t); null !== b;){
        if (null === b.callback) $ce1039e2a5f863f5$var$k($ce1039e2a5f863f5$var$t);
        else if (b.startTime <= a) $ce1039e2a5f863f5$var$k($ce1039e2a5f863f5$var$t), b.sortIndex = b.expirationTime, $ce1039e2a5f863f5$var$f($ce1039e2a5f863f5$var$r, b);
        else break;
        b = $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$t);
    }
}
function $ce1039e2a5f863f5$var$H(a) {
    $ce1039e2a5f863f5$var$B = !1;
    $ce1039e2a5f863f5$var$G(a);
    if (!$ce1039e2a5f863f5$var$A) {
        if (null !== $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$r)) $ce1039e2a5f863f5$var$A = !0, $ce1039e2a5f863f5$var$I($ce1039e2a5f863f5$var$J);
        else {
            var b = $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$t);
            null !== b && $ce1039e2a5f863f5$var$K($ce1039e2a5f863f5$var$H, b.startTime - a);
        }
    }
}
function $ce1039e2a5f863f5$var$J(a, b) {
    $ce1039e2a5f863f5$var$A = !1;
    $ce1039e2a5f863f5$var$B && ($ce1039e2a5f863f5$var$B = !1, $ce1039e2a5f863f5$var$E($ce1039e2a5f863f5$var$L), $ce1039e2a5f863f5$var$L = -1);
    $ce1039e2a5f863f5$var$z = !0;
    var c = $ce1039e2a5f863f5$var$y;
    try {
        $ce1039e2a5f863f5$var$G(b);
        for($ce1039e2a5f863f5$var$v = $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$r); null !== $ce1039e2a5f863f5$var$v && (!($ce1039e2a5f863f5$var$v.expirationTime > b) || a && !$ce1039e2a5f863f5$var$M());){
            var d = $ce1039e2a5f863f5$var$v.callback;
            if ("function" === typeof d) {
                $ce1039e2a5f863f5$var$v.callback = null;
                $ce1039e2a5f863f5$var$y = $ce1039e2a5f863f5$var$v.priorityLevel;
                var e = d($ce1039e2a5f863f5$var$v.expirationTime <= b);
                b = $ce1039e2a5f863f5$export$c4744153514ff05d();
                "function" === typeof e ? $ce1039e2a5f863f5$var$v.callback = e : $ce1039e2a5f863f5$var$v === $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$r) && $ce1039e2a5f863f5$var$k($ce1039e2a5f863f5$var$r);
                $ce1039e2a5f863f5$var$G(b);
            } else $ce1039e2a5f863f5$var$k($ce1039e2a5f863f5$var$r);
            $ce1039e2a5f863f5$var$v = $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$r);
        }
        if (null !== $ce1039e2a5f863f5$var$v) var w = !0;
        else {
            var m = $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$t);
            null !== m && $ce1039e2a5f863f5$var$K($ce1039e2a5f863f5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ce1039e2a5f863f5$var$v = null, $ce1039e2a5f863f5$var$y = c, $ce1039e2a5f863f5$var$z = !1;
    }
}
var $ce1039e2a5f863f5$var$N = !1, $ce1039e2a5f863f5$var$O = null, $ce1039e2a5f863f5$var$L = -1, $ce1039e2a5f863f5$var$P = 5, $ce1039e2a5f863f5$var$Q = -1;
function $ce1039e2a5f863f5$var$M() {
    return $ce1039e2a5f863f5$export$c4744153514ff05d() - $ce1039e2a5f863f5$var$Q < $ce1039e2a5f863f5$var$P ? !1 : !0;
}
function $ce1039e2a5f863f5$var$R() {
    if (null !== $ce1039e2a5f863f5$var$O) {
        var a = $ce1039e2a5f863f5$export$c4744153514ff05d();
        $ce1039e2a5f863f5$var$Q = a;
        var b = !0;
        try {
            b = $ce1039e2a5f863f5$var$O(!0, a);
        } finally{
            b ? $ce1039e2a5f863f5$var$S() : ($ce1039e2a5f863f5$var$N = !1, $ce1039e2a5f863f5$var$O = null);
        }
    } else $ce1039e2a5f863f5$var$N = !1;
}
var $ce1039e2a5f863f5$var$S;
if ("function" === typeof $ce1039e2a5f863f5$var$F) $ce1039e2a5f863f5$var$S = function() {
    $ce1039e2a5f863f5$var$F($ce1039e2a5f863f5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ce1039e2a5f863f5$var$T = new MessageChannel, $ce1039e2a5f863f5$var$U = $ce1039e2a5f863f5$var$T.port2;
    $ce1039e2a5f863f5$var$T.port1.onmessage = $ce1039e2a5f863f5$var$R;
    $ce1039e2a5f863f5$var$S = function() {
        $ce1039e2a5f863f5$var$U.postMessage(null);
    };
} else $ce1039e2a5f863f5$var$S = function() {
    $ce1039e2a5f863f5$var$D($ce1039e2a5f863f5$var$R, 0);
};
function $ce1039e2a5f863f5$var$I(a) {
    $ce1039e2a5f863f5$var$O = a;
    $ce1039e2a5f863f5$var$N || ($ce1039e2a5f863f5$var$N = !0, $ce1039e2a5f863f5$var$S());
}
function $ce1039e2a5f863f5$var$K(a, b) {
    $ce1039e2a5f863f5$var$L = $ce1039e2a5f863f5$var$D(function() {
        a($ce1039e2a5f863f5$export$c4744153514ff05d());
    }, b);
}
$ce1039e2a5f863f5$export$3e506c1ccc9cc1a7 = 5;
$ce1039e2a5f863f5$export$e26fe2ed2fa76875 = 1;
$ce1039e2a5f863f5$export$502329bbf4b505b1 = 4;
$ce1039e2a5f863f5$export$6e3807111c4874c4 = 3;
$ce1039e2a5f863f5$export$c27134553091fb3a = null;
$ce1039e2a5f863f5$export$33ee1acdc04fd2a2 = 2;
$ce1039e2a5f863f5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ce1039e2a5f863f5$export$8352ce38b91d0c62 = function() {
    $ce1039e2a5f863f5$var$A || $ce1039e2a5f863f5$var$z || ($ce1039e2a5f863f5$var$A = !0, $ce1039e2a5f863f5$var$I($ce1039e2a5f863f5$var$J));
};
$ce1039e2a5f863f5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ce1039e2a5f863f5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ce1039e2a5f863f5$export$d3dfb8e4810cb555 = function() {
    return $ce1039e2a5f863f5$var$y;
};
$ce1039e2a5f863f5$export$839f9183b0465a69 = function() {
    return $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$r);
};
$ce1039e2a5f863f5$export$72fdf0e06517287b = function(a) {
    switch($ce1039e2a5f863f5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ce1039e2a5f863f5$var$y;
    }
    var c = $ce1039e2a5f863f5$var$y;
    $ce1039e2a5f863f5$var$y = b;
    try {
        return a();
    } finally{
        $ce1039e2a5f863f5$var$y = c;
    }
};
$ce1039e2a5f863f5$export$4b844e58a3e414b4 = function() {};
$ce1039e2a5f863f5$export$816d2913ae6b83b1 = function() {};
$ce1039e2a5f863f5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ce1039e2a5f863f5$var$y;
    $ce1039e2a5f863f5$var$y = a;
    try {
        return b();
    } finally{
        $ce1039e2a5f863f5$var$y = c;
    }
};
$ce1039e2a5f863f5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ce1039e2a5f863f5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ce1039e2a5f863f5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ce1039e2a5f863f5$var$f($ce1039e2a5f863f5$var$t, a), null === $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$r) && a === $ce1039e2a5f863f5$var$h($ce1039e2a5f863f5$var$t) && ($ce1039e2a5f863f5$var$B ? ($ce1039e2a5f863f5$var$E($ce1039e2a5f863f5$var$L), $ce1039e2a5f863f5$var$L = -1) : $ce1039e2a5f863f5$var$B = !0, $ce1039e2a5f863f5$var$K($ce1039e2a5f863f5$var$H, c - d))) : (a.sortIndex = e, $ce1039e2a5f863f5$var$f($ce1039e2a5f863f5$var$r, a), $ce1039e2a5f863f5$var$A || $ce1039e2a5f863f5$var$z || ($ce1039e2a5f863f5$var$A = !0, $ce1039e2a5f863f5$var$I($ce1039e2a5f863f5$var$J)));
    return a;
};
$ce1039e2a5f863f5$export$b5836b71941fa3ed = $ce1039e2a5f863f5$var$M;
$ce1039e2a5f863f5$export$cf845f2c119da08a = function(a) {
    var b = $ce1039e2a5f863f5$var$y;
    return function() {
        var c = $ce1039e2a5f863f5$var$y;
        $ce1039e2a5f863f5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ce1039e2a5f863f5$var$y = c;
        }
    };
};

});



parcelRegister("1C9lN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aQYhM = parcelRequire("aQYhM");
function $12d097e15e8b866e$var$emptyFunction() {}
function $12d097e15e8b866e$var$emptyFunctionWithReset() {}
$12d097e15e8b866e$var$emptyFunctionWithReset.resetWarningCache = $12d097e15e8b866e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aQYhM) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $12d097e15e8b866e$var$emptyFunctionWithReset,
        resetWarningCache: $12d097e15e8b866e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aQYhM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $7e6d8632f78b3b9e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $7e6d8632f78b3b9e$var$ReactPropTypesSecret;

});


parcelRegister("NHqNP", function(module, exports) {

var $gtElv = parcelRequire("gtElv");
function $095644450c4de488$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $gtElv(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $095644450c4de488$var$_objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("gtElv", function(module, exports) {
function $bfeea69c1aa0fd4c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $bfeea69c1aa0fd4c$var$_objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("2Ao05", function(module, exports) {
function $1e218f85961664e3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $1e218f85961664e3$var$_classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("awXxO", function(module, exports) {
function $7aab14d60564f723$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7aab14d60564f723$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7aab14d60564f723$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7aab14d60564f723$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
module.exports = $7aab14d60564f723$var$_createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("k9YyE", function(module, exports) {
function $ead39f72c7822156$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $ead39f72c7822156$var$_defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("dB0fk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "InvalidTokenError", () => $9e5eebf4b7267f87$export$b9721ef022f71a68);
$parcel$export(module.exports, "default", () => $9e5eebf4b7267f87$export$2e2bcd8739ae039);
function $9e5eebf4b7267f87$var$e(e) {
    this.message = e;
}
$9e5eebf4b7267f87$var$e.prototype = new Error, $9e5eebf4b7267f87$var$e.prototype.name = "InvalidCharacterError";
var $9e5eebf4b7267f87$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $9e5eebf4b7267f87$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $9e5eebf4b7267f87$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($9e5eebf4b7267f87$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $9e5eebf4b7267f87$var$r(t);
    }
}
function $9e5eebf4b7267f87$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $9e5eebf4b7267f87$var$o(e, r) {
    if ("string" != typeof e) throw new $9e5eebf4b7267f87$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($9e5eebf4b7267f87$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $9e5eebf4b7267f87$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$9e5eebf4b7267f87$export$b9721ef022f71a68.prototype = new Error, $9e5eebf4b7267f87$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $9e5eebf4b7267f87$export$2e2bcd8739ae039 = $9e5eebf4b7267f87$var$o;

});

parcelRegister("arYek", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7fWJJ = parcelRequire("7fWJJ");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($7fWJJ.Subscriber);

});
parcelRegister("7fWJJ", function(module, exports) {
"use strict";
var $54877efc17efb187$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zo2d7 = parcelRequire("zo2d7");

var $8huxl = parcelRequire("8huxl");

var $2HoWN = parcelRequire("2HoWN");

var $fLDtq = parcelRequire("fLDtq");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $54877efc17efb187$var$Subscriber = function(_super) {
    $54877efc17efb187$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $2HoWN.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $2HoWN.empty;
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($54877efc17efb187$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$fLDtq.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $54877efc17efb187$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $54877efc17efb187$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$fLDtq.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($8huxl.Subscription);
module.exports.Subscriber = $54877efc17efb187$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $54877efc17efb187$var$SafeSubscriber = function(_super) {
    $54877efc17efb187$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($zo2d7.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $2HoWN.empty) {
                context = Object.create(observerOrNext);
                if ($zo2d7.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($54877efc17efb187$var$Subscriber);
function $54877efc17efb187$var$isTrustedSubscriber(obj) {
    return obj instanceof $54877efc17efb187$var$Subscriber || "syncErrorThrowable" in obj && obj[$fLDtq.rxSubscriber];
}

});
parcelRegister("zo2d7", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $06a5e9c7d4340da8$export$f6e2535fb5126e54, (v) => $06a5e9c7d4340da8$export$f6e2535fb5126e54 = v);
var $06a5e9c7d4340da8$export$f6e2535fb5126e54;
"use strict";
function $06a5e9c7d4340da8$var$isFunction(x) {
    return typeof x === "function";
}
$06a5e9c7d4340da8$export$f6e2535fb5126e54 = $06a5e9c7d4340da8$var$isFunction;

});

parcelRegister("8huxl", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $60779940fbba8ad0$export$f55210826850c514, (v) => $60779940fbba8ad0$export$f55210826850c514 = v);
var $60779940fbba8ad0$export$f55210826850c514;
"use strict";

var $6QitX = parcelRequire("6QitX");

var $hKVxI = parcelRequire("hKVxI");

var $zo2d7 = parcelRequire("zo2d7");

var $gCTjO = parcelRequire("gCTjO");

var $ieSGQ = parcelRequire("ieSGQ");

var $k6U0q = parcelRequire("k6U0q");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $60779940fbba8ad0$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($zo2d7.isFunction(_unsubscribe)) {
            var trial = $gCTjO.tryCatch(_unsubscribe).call(this);
            if (trial === $ieSGQ.errorObject) {
                hasErrors = true;
                errors = errors || ($ieSGQ.errorObject.e instanceof $k6U0q.UnsubscriptionError ? $60779940fbba8ad0$var$flattenUnsubscriptionErrors($ieSGQ.errorObject.e.errors) : [
                    $ieSGQ.errorObject.e
                ]);
            }
        }
        if ($6QitX.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($hKVxI.isObject(sub)) {
                    var trial = $gCTjO.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $ieSGQ.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $ieSGQ.errorObject.e;
                        if (err instanceof $k6U0q.UnsubscriptionError) errors = errors.concat($60779940fbba8ad0$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $k6U0q.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== "function" /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$60779940fbba8ad0$export$f55210826850c514 = $60779940fbba8ad0$var$Subscription;
function $60779940fbba8ad0$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $k6U0q.UnsubscriptionError ? err.errors : err);
    }, []);
}

});
parcelRegister("6QitX", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $4fb5ef92bd7673db$export$43bee75e5e14138e, (v) => $4fb5ef92bd7673db$export$43bee75e5e14138e = v);
var $4fb5ef92bd7673db$export$43bee75e5e14138e;
"use strict";
$4fb5ef92bd7673db$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === "number";
};

});

parcelRegister("hKVxI", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $ced35e5f1391537f$export$a6cdc56e425d0d0a, (v) => $ced35e5f1391537f$export$a6cdc56e425d0d0a = v);
var $ced35e5f1391537f$export$a6cdc56e425d0d0a;
"use strict";
function $ced35e5f1391537f$var$isObject(x) {
    return x != null && typeof x === "object";
}
$ced35e5f1391537f$export$a6cdc56e425d0d0a = $ced35e5f1391537f$var$isObject;

});

parcelRegister("gCTjO", function(module, exports) {

$parcel$export(module.exports, "tryCatch", () => $c1ab1b123679ab3a$export$d234c058d1d4e435, (v) => $c1ab1b123679ab3a$export$d234c058d1d4e435 = v);
var $c1ab1b123679ab3a$export$d234c058d1d4e435;
"use strict";

var $ieSGQ = parcelRequire("ieSGQ");
var $c1ab1b123679ab3a$var$tryCatchTarget;
function $c1ab1b123679ab3a$var$tryCatcher() {
    try {
        return $c1ab1b123679ab3a$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $ieSGQ.errorObject.e = e;
        return $ieSGQ.errorObject;
    }
}
function $c1ab1b123679ab3a$var$tryCatch(fn) {
    $c1ab1b123679ab3a$var$tryCatchTarget = fn;
    return $c1ab1b123679ab3a$var$tryCatcher;
}
$c1ab1b123679ab3a$export$d234c058d1d4e435 = $c1ab1b123679ab3a$var$tryCatch;

});
parcelRegister("ieSGQ", function(module, exports) {

$parcel$export(module.exports, "errorObject", () => $d473f51f6cbf4f59$export$fc504b39d7c1176, (v) => $d473f51f6cbf4f59$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $d473f51f6cbf4f59$export$fc504b39d7c1176;
"use strict";
$d473f51f6cbf4f59$export$fc504b39d7c1176 = {
    e: {}
};

});


parcelRegister("k6U0q", function(module, exports) {
"use strict";
var $ea3fcfc722bded79$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $ea3fcfc722bded79$var$UnsubscriptionError = function(_super) {
    $ea3fcfc722bded79$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "");
        this.name = err.name = "UnsubscriptionError";
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $ea3fcfc722bded79$var$UnsubscriptionError;

});


parcelRegister("2HoWN", function(module, exports) {

$parcel$export(module.exports, "empty", () => $1f72f2f10977c821$export$6e22c362a0406a2c, (v) => $1f72f2f10977c821$export$6e22c362a0406a2c = v);
var $1f72f2f10977c821$export$6e22c362a0406a2c;
"use strict";
$1f72f2f10977c821$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRegister("fLDtq", function(module, exports) {

$parcel$export(module.exports, "rxSubscriber", () => $b7a9dd746e99afa7$export$77f77496d7cade10, (v) => $b7a9dd746e99afa7$export$77f77496d7cade10 = v);
var $b7a9dd746e99afa7$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $b7a9dd746e99afa7$export$4a2e07ff24d010f0;
"use strict";

var $aBIZ8 = parcelRequire("aBIZ8");
var $b7a9dd746e99afa7$var$Symbol = $aBIZ8.root.Symbol;
$b7a9dd746e99afa7$export$77f77496d7cade10 = typeof $b7a9dd746e99afa7$var$Symbol === "function" && typeof $b7a9dd746e99afa7$var$Symbol.for === "function" ? $b7a9dd746e99afa7$var$Symbol.for("rxSubscriber") : "@@rxSubscriber";
$b7a9dd746e99afa7$export$4a2e07ff24d010f0 = $b7a9dd746e99afa7$export$77f77496d7cade10;

});
parcelRegister("aBIZ8", function(module, exports) {

$parcel$export(module.exports, "root", () => $7b90412b6dc4a57f$export$e8e78c978b129247, (v) => $7b90412b6dc4a57f$export$e8e78c978b129247 = v);
var $7b90412b6dc4a57f$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $7b90412b6dc4a57f$var$__window = typeof window !== "undefined" && window;
var $7b90412b6dc4a57f$var$__self = typeof self !== "undefined" && typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope && self;
var $7b90412b6dc4a57f$var$__global = typeof $parcel$global !== "undefined" && $parcel$global;
var $7b90412b6dc4a57f$var$_root = $7b90412b6dc4a57f$var$__window || $7b90412b6dc4a57f$var$__global || $7b90412b6dc4a57f$var$__self;
$7b90412b6dc4a57f$export$e8e78c978b129247 = $7b90412b6dc4a57f$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$7b90412b6dc4a57f$var$_root) throw new Error("RxJS could not find any global context (window, self, global)");
})();

});




parcelRegister("8CEnu", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lDxEl = parcelRequire("lDxEl");

var $i3fHp = parcelRequire("i3fHp");

var $7fWJJ = parcelRequire("7fWJJ");

var $7dD0d = parcelRequire("7dD0d");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $lDxEl.async;
    var absoluteDelay = $i3fHp.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($7dD0d.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($7dD0d.Notification.createComplete());
    };
    return DelaySubscriber;
}($7fWJJ.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});
parcelRegister("lDxEl", function(module, exports) {

$parcel$export(module.exports, "async", () => $fc07579e1dc5226b$export$12af436354f1a4f7, (v) => $fc07579e1dc5226b$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $fc07579e1dc5226b$export$12af436354f1a4f7;
"use strict";

var $bUGHS = parcelRequire("bUGHS");

var $5VSFE = parcelRequire("5VSFE");
$fc07579e1dc5226b$export$12af436354f1a4f7 = new $5VSFE.AsyncScheduler($bUGHS.AsyncAction);

});
parcelRegister("bUGHS", function(module, exports) {
"use strict";
var $8ac60d5386a745a8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aBIZ8 = parcelRequire("aBIZ8");

var $jhjSb = parcelRequire("jhjSb");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8ac60d5386a745a8$var$AsyncAction = function(_super) {
    $8ac60d5386a745a8$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $aBIZ8.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $aBIZ8.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($jhjSb.Action);
module.exports.AsyncAction = $8ac60d5386a745a8$var$AsyncAction;

});
parcelRegister("jhjSb", function(module, exports) {
"use strict";
var $e08f0538ca729d2d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8huxl = parcelRequire("8huxl");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $e08f0538ca729d2d$var$Action = function(_super) {
    $e08f0538ca729d2d$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($8huxl.Subscription);
module.exports.Action = $e08f0538ca729d2d$var$Action;

});


parcelRegister("5VSFE", function(module, exports) {
"use strict";
var $451caf1f32e9f6e2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kXkTR = parcelRequire("kXkTR");
var $451caf1f32e9f6e2$var$AsyncScheduler = function(_super) {
    $451caf1f32e9f6e2$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($kXkTR.Scheduler);
module.exports.AsyncScheduler = $451caf1f32e9f6e2$var$AsyncScheduler;

});
parcelRegister("kXkTR", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $f41987a66f7699cc$export$d3e54bb8584cda7c, (v) => $f41987a66f7699cc$export$d3e54bb8584cda7c = v);
var $f41987a66f7699cc$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $f41987a66f7699cc$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$f41987a66f7699cc$export$d3e54bb8584cda7c = $f41987a66f7699cc$var$Scheduler;

});



parcelRegister("i3fHp", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $d244af50f78da807$export$871608497c498473, (v) => $d244af50f78da807$export$871608497c498473 = v);
var $d244af50f78da807$export$871608497c498473;
"use strict";
function $d244af50f78da807$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$d244af50f78da807$export$871608497c498473 = $d244af50f78da807$var$isDate;

});

parcelRegister("7dD0d", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $54180067e8cdda28$export$14834abbfce3b8cd, (v) => $54180067e8cdda28$export$14834abbfce3b8cd = v);
var $54180067e8cdda28$export$14834abbfce3b8cd;
"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $54180067e8cdda28$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return $2Ioq1.Observable.of(this.value);
            case "E":
                return $2Ioq1.Observable.throw(this.error);
            case "C":
                return $2Ioq1.Observable.empty();
        }
        throw new Error("unexpected notification kind value");
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();
$54180067e8cdda28$export$14834abbfce3b8cd = $54180067e8cdda28$var$Notification;

});
parcelRegister("2Ioq1", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $1fa2a1e38f074044$export$77cea355fa80b5f4, (v) => $1fa2a1e38f074044$export$77cea355fa80b5f4 = v);
var $1fa2a1e38f074044$export$77cea355fa80b5f4;
"use strict";

var $aBIZ8 = parcelRequire("aBIZ8");

var $lapTj = parcelRequire("lapTj");

var $kUXEd = parcelRequire("kUXEd");

var $effvc = parcelRequire("effvc");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $1fa2a1e38f074044$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $lapTj.toSubscriber(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($aBIZ8.root.Rx && $aBIZ8.root.Rx.config && $aBIZ8.root.Rx.config.Promise) PromiseCtor = $aBIZ8.root.Rx.config.Promise;
            else if ($aBIZ8.root.Promise) PromiseCtor = $aBIZ8.root.Promise;
        }
        if (!PromiseCtor) throw new Error("no Promise impl found");
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$kUXEd.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $effvc.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($aBIZ8.root.Rx && $aBIZ8.root.Rx.config && $aBIZ8.root.Rx.config.Promise) PromiseCtor = $aBIZ8.root.Rx.config.Promise;
            else if ($aBIZ8.root.Promise) PromiseCtor = $aBIZ8.root.Promise;
        }
        if (!PromiseCtor) throw new Error("no Promise impl found");
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$1fa2a1e38f074044$export$77cea355fa80b5f4 = $1fa2a1e38f074044$var$Observable;

});
parcelRegister("lapTj", function(module, exports) {

$parcel$export(module.exports, "toSubscriber", () => $f68e9d9368eba9c0$export$2a12c2cebbfd1087, (v) => $f68e9d9368eba9c0$export$2a12c2cebbfd1087 = v);
var $f68e9d9368eba9c0$export$2a12c2cebbfd1087;
"use strict";

var $7fWJJ = parcelRequire("7fWJJ");

var $fLDtq = parcelRequire("fLDtq");

var $2HoWN = parcelRequire("2HoWN");
function $f68e9d9368eba9c0$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $7fWJJ.Subscriber) return nextOrObserver;
        if (nextOrObserver[$fLDtq.rxSubscriber]) return nextOrObserver[$fLDtq.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $7fWJJ.Subscriber($2HoWN.empty);
    return new $7fWJJ.Subscriber(nextOrObserver, error, complete);
}
$f68e9d9368eba9c0$export$2a12c2cebbfd1087 = $f68e9d9368eba9c0$var$toSubscriber;

});

parcelRegister("kUXEd", function(module, exports) {

$parcel$export(module.exports, "observable", () => $f3a74e5d8bc0e9ef$export$5ab46cbf6120b33a, (v) => $f3a74e5d8bc0e9ef$export$5ab46cbf6120b33a = v);
var $f3a74e5d8bc0e9ef$export$7e68bb2e8ecea8fe;
var $f3a74e5d8bc0e9ef$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $f3a74e5d8bc0e9ef$export$a7c40509ff863847;
"use strict";

var $aBIZ8 = parcelRequire("aBIZ8");
function $f3a74e5d8bc0e9ef$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol("observable");
            Symbol.observable = $$observable;
        }
    } else $$observable = "@@observable";
    return $$observable;
}
$f3a74e5d8bc0e9ef$export$7e68bb2e8ecea8fe = $f3a74e5d8bc0e9ef$var$getSymbolObservable;
$f3a74e5d8bc0e9ef$export$5ab46cbf6120b33a = $f3a74e5d8bc0e9ef$var$getSymbolObservable($aBIZ8.root);
$f3a74e5d8bc0e9ef$export$a7c40509ff863847 = $f3a74e5d8bc0e9ef$export$5ab46cbf6120b33a;

});

parcelRegister("effvc", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $a5ee7dd6e55d8bf5$export$71f88a61afaa14d7, (v) => $a5ee7dd6e55d8bf5$export$71f88a61afaa14d7 = v);
var $a5ee7dd6e55d8bf5$export$a4627e546088548d;
var $a5ee7dd6e55d8bf5$export$71f88a61afaa14d7;
"use strict";

var $4PvLb = parcelRequire("4PvLb");
/* tslint:enable:max-line-length */ function $a5ee7dd6e55d8bf5$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $a5ee7dd6e55d8bf5$var$pipeFromArray(fns);
}
$a5ee7dd6e55d8bf5$export$a4627e546088548d = $a5ee7dd6e55d8bf5$var$pipe;
/* @internal */ function $a5ee7dd6e55d8bf5$var$pipeFromArray(fns) {
    if (!fns) return $4PvLb.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$a5ee7dd6e55d8bf5$export$71f88a61afaa14d7 = $a5ee7dd6e55d8bf5$var$pipeFromArray;

});
parcelRegister("4PvLb", function(module, exports) {

$parcel$export(module.exports, "noop", () => $38448fb895aa7935$export$8793edee2d425525, (v) => $38448fb895aa7935$export$8793edee2d425525 = v);
var $38448fb895aa7935$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $38448fb895aa7935$var$noop() {}
$38448fb895aa7935$export$8793edee2d425525 = $38448fb895aa7935$var$noop;

});





parcelRegister("aEvSz", function(module, exports) {
"use strict";

var $1PoM0 = parcelRequire("1PoM0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $7c165e5d7b80ea85$var$dedupeFilenames;

var $7c165e5d7b80ea85$var$_parseFilename2 = $1PoM0((parcelRequire("7YNtb")));
function $7c165e5d7b80ea85$var$dedupeFilenames(array) {
    var nextArray = [];
    array.forEach(function(value) {
        var _parseFilename = (0, $7c165e5d7b80ea85$var$_parseFilename2["default"])(value), extname = _parseFilename.extname, name = _parseFilename.name;
        var count = 0;
        var nextValue = value;
        while(nextArray.includes(nextValue))nextValue = [
            name,
            "(".concat(++count, ")")
        ].filter(function(segment) {
            return segment;
        }).join(" ") + extname;
        nextArray.push(nextValue);
    });
    return nextArray;
}

});
parcelRegister("1PoM0", function(module, exports) {
function $154dc54c822727ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $154dc54c822727ab$var$_interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("7YNtb", function(module, exports) {
"use strict";

var $1PoM0 = parcelRequire("1PoM0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $5cf482a24f7f7515$var$parseFilename;

var $5cf482a24f7f7515$var$_toArray2 = $1PoM0((parcelRequire("6HyL5")));
function $5cf482a24f7f7515$var$parseFilename(filename) {
    if (!filename) return {
        extname: "",
        name: ""
    };
    else if (~filename.indexOf(".")) {
        var _filename$split$rever = filename.split(".").reverse(), _filename$split$rever2 = (0, $5cf482a24f7f7515$var$_toArray2["default"])(_filename$split$rever), extensionWithoutDot = _filename$split$rever2[0], nameSegments = _filename$split$rever2.slice(1);
        return {
            extname: "." + extensionWithoutDot,
            name: nameSegments.reverse().join(".")
        };
    } else return {
        extname: "",
        name: filename
    };
}

});
parcelRegister("6HyL5", function(module, exports) {

var $aMZav = parcelRequire("aMZav");

var $ilT31 = parcelRequire("ilT31");

var $l4r70 = parcelRequire("l4r70");

var $3JioY = parcelRequire("3JioY");
function $4e11b88fb7c7715f$var$_toArray(arr) {
    return $aMZav(arr) || $ilT31(arr) || $l4r70(arr) || $3JioY();
}
module.exports = $4e11b88fb7c7715f$var$_toArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("aMZav", function(module, exports) {
function $7dadd5dc155e58f6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $7dadd5dc155e58f6$var$_arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("ilT31", function(module, exports) {
function $d5c4e3797993502e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $d5c4e3797993502e$var$_iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("l4r70", function(module, exports) {

var $1U5pu = parcelRequire("1U5pu");
function $f56f0094e47a2f9a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1U5pu(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1U5pu(o, minLen);
}
module.exports = $f56f0094e47a2f9a$var$_unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("1U5pu", function(module, exports) {
function $162f37c1df5ca84c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $162f37c1df5ca84c$var$_arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("3JioY", function(module, exports) {
function $2b73d94b393b2d9f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $2b73d94b393b2d9f$var$_nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});




parcelRegister("kbZRJ", function(module, exports) {

module.exports = (parcelRequire("7Sozq"));

});
parcelRegister("7Sozq", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5bc0a2b0bbab10b6$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $5bc0a2b0bbab10b6$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $5bc0a2b0bbab10b6$var$runtime;
    else Function("r", "regeneratorRuntime = r")($5bc0a2b0bbab10b6$var$runtime);
}

});


parcelRegister("l2Sqt", function(module, exports) {

var $3XqOZ = parcelRequire("3XqOZ");

var $8mo4A = parcelRequire("8mo4A");
function $f52400c23730b461$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $8mo4A(receiver, privateMap, "get");
    return $3XqOZ(receiver, descriptor);
}
module.exports = $f52400c23730b461$var$_classPrivateFieldGet;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("3XqOZ", function(module, exports) {
function $2e1baff1c2d3db20$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
module.exports = $2e1baff1c2d3db20$var$_classApplyDescriptorGet;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("8mo4A", function(module, exports) {
function $61630d2f211e795b$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
module.exports = $61630d2f211e795b$var$_classExtractFieldDescriptor;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("c0mXe", function(module, exports) {

var $am7kx = parcelRequire("am7kx");

var $8mo4A = parcelRequire("8mo4A");
function $8bd74a632b013678$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $8mo4A(receiver, privateMap, "set");
    $am7kx(receiver, descriptor, value);
    return value;
}
module.exports = $8bd74a632b013678$var$_classPrivateFieldSet;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("am7kx", function(module, exports) {
function $78a1a51254abef2a$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
module.exports = $78a1a51254abef2a$var$_classApplyDescriptorSet;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("l1sDn", function(module, exports) {

var $36c7H = parcelRequire("36c7H");

var $ilT31 = parcelRequire("ilT31");

var $l4r70 = parcelRequire("l4r70");

var $7QEcs = parcelRequire("7QEcs");
function $f4dfe71d1bc59da8$var$_toConsumableArray(arr) {
    return $36c7H(arr) || $ilT31(arr) || $l4r70(arr) || $7QEcs();
}
module.exports = $f4dfe71d1bc59da8$var$_toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("36c7H", function(module, exports) {

var $1U5pu = parcelRequire("1U5pu");
function $241b560d6aaa9bd6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1U5pu(arr);
}
module.exports = $241b560d6aaa9bd6$var$_arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("7QEcs", function(module, exports) {
function $5b6c9297bf125364$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $5b6c9297bf125364$var$_nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("bH9fD", function(module, exports) {
function $883ae2f3b5b6b26b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $883ae2f3b5b6b26b$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $883ae2f3b5b6b26b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $883ae2f3b5b6b26b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $883ae2f3b5b6b26b$var$_asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("lIM9r", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadAssembler = void 0;
                var subscribableStream_1 = require("../subscribableStream");
                var payloads_1 = require("../payloads");
                var contentStream_1 = require("../contentStream");
                /**
 * Assembles payloads for streaming library.
 *
 * @internal
 */ var PayloadAssembler = /** @class */ function() {
                    /**
     * Initializes a new instance of the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) class.
     *
     * @param streamManager The [StreamManager](xref:botframework-streaming.StreamManager) managing the stream being assembled.
     * @param params Parameters for a streaming assembler.
     */ function PayloadAssembler(streamManager, params) {
                        this.streamManager = streamManager;
                        this._byteOrderMark = 0xfeff;
                        this._utf = "utf8";
                        if (params.header) {
                            this.id = params.header.id;
                            this.payloadType = params.header.payloadType;
                            this.contentLength = params.header.payloadLength;
                            this.end = params.header.end;
                        } else this.id = params.id;
                        if (!this.id) throw Error("An ID must be supplied when creating an assembler.");
                        this._onCompleted = params.onCompleted;
                    }
                    /**
     * Retrieves the assembler's payload as a stream.
     *
     * @returns A [SubscribableStream](xref:botframework-streaming.SubscribableStream) of the assembler's payload.
     */ PayloadAssembler.prototype.getPayloadStream = function() {
                        if (!this.stream) this.stream = this.createPayloadStream();
                        return this.stream;
                    };
                    /**
     * The action the assembler executes when new bytes are received on the incoming stream.
     *
     * @param header The stream's Header.
     * @param stream The incoming stream being assembled.
     * @param _contentLength The length of the stream, if finite.
     */ PayloadAssembler.prototype.onReceive = function(header, stream, _contentLength) {
                        this.end = header.end;
                        if (header.payloadType === payloads_1.PayloadTypes.response || header.payloadType === payloads_1.PayloadTypes.request) this.process(stream).then().catch();
                        else if (header.end) stream.end();
                    };
                    /**
     * Closes the assembler.
     */ PayloadAssembler.prototype.close = function() {
                        this.streamManager.closeStream(this.id);
                    };
                    /**
     * Creates a new [SubscribableStream](xref:botframework-streaming.SubscribableStream) instance.
     *
     * @returns The new stream ready for consumption.
     */ PayloadAssembler.prototype.createPayloadStream = function() {
                        return new subscribableStream_1.SubscribableStream();
                    };
                    PayloadAssembler.prototype.payloadFromJson = function(json) {
                        return JSON.parse(json.charCodeAt(0) === this._byteOrderMark ? json.slice(1) : json);
                    };
                    PayloadAssembler.prototype.stripBOM = function(input) {
                        return input.charCodeAt(0) === this._byteOrderMark ? input.slice(1) : input;
                    };
                    PayloadAssembler.prototype.process = function(stream) {
                        return __awaiter(this, void 0, void 0, function() {
                            var streamData, streamDataAsString;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        streamData = stream.read(stream.length);
                                        if (!streamData) return [
                                            2 /*return*/ 
                                        ];
                                        streamDataAsString = streamData.toString(this._utf);
                                        if (!(this.payloadType === payloads_1.PayloadTypes.request)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.processRequest(streamDataAsString)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 2:
                                        if (!(this.payloadType === payloads_1.PayloadTypes.response)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.processResponse(streamDataAsString)
                                        ];
                                    case 3:
                                        _a.sent();
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    PayloadAssembler.prototype.processResponse = function(streamDataAsString) {
                        return __awaiter(this, void 0, void 0, function() {
                            var responsePayload, receiveResponse;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        responsePayload = this.payloadFromJson(this.stripBOM(streamDataAsString));
                                        receiveResponse = {
                                            streams: [],
                                            statusCode: responsePayload.statusCode
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.processStreams(responsePayload, receiveResponse)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    PayloadAssembler.prototype.processRequest = function(streamDataAsString) {
                        return __awaiter(this, void 0, void 0, function() {
                            var requestPayload, receiveRequest;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        requestPayload = this.payloadFromJson(streamDataAsString);
                                        receiveRequest = {
                                            streams: [],
                                            path: requestPayload.path,
                                            verb: requestPayload.verb
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.processStreams(requestPayload, receiveRequest)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    PayloadAssembler.prototype.processStreams = function(responsePayload, receiveResponse) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function() {
                            var _this = this;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        (_a = responsePayload.streams) === null || _a === void 0 || _a.forEach(function(responseStream) {
                                            var _a;
                                            // There was a bug in how streams were handled. In .NET, the StreamDescription definiton mapped the
                                            // "type" JSON property to `contentType`, but in Typescript there was no mapping. This is a workaround
                                            // to resolve this inconsistency.
                                            //
                                            // .NET code:
                                            // https://github.com/microsoft/botbuilder-dotnet/blob/a79036ddf6625ec3fd68a6f7295886eb7831bc1c/libraries/Microsoft.Bot.Streaming/Payloads/Models/StreamDescription.cs#L28-L29
                                            var contentType = (_a = responseStream.type) !== null && _a !== void 0 ? _a : responseStream.contentType;
                                            var contentAssembler = _this.streamManager.getPayloadAssembler(responseStream.id);
                                            contentAssembler.payloadType = contentType;
                                            contentAssembler.contentLength = responseStream.length;
                                            receiveResponse.streams.push(new contentStream_1.ContentStream(responseStream.id, contentAssembler));
                                        });
                                        return [
                                            4 /*yield*/ ,
                                            this._onCompleted(this.id, receiveResponse)
                                        ];
                                    case 1:
                                        _b.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return PayloadAssembler;
                }();
                exports.PayloadAssembler = PayloadAssembler;
            },
            {
                "../contentStream": 2,
                "../payloads": 16,
                "../subscribableStream": 27
            }
        ],
        2: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ContentStream = void 0;
                /**
 * A stream of fixed or infinite length containing content to be decoded.
 */ var ContentStream = /** @class */ function() {
                    /**
     * Initializes a new instance of the [ContentStream](xref:botframework-streaming.ContentStream) class.
     *
     * @param id The ID assigned to this instance.
     * @param assembler The [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) assigned to this instance.
     */ function ContentStream(id, assembler) {
                        if (!assembler) throw Error("Null Argument Exception");
                        this.id = id;
                        this.assembler = assembler;
                    }
                    Object.defineProperty(ContentStream.prototype, "contentType", {
                        /**
         * Gets the name of the type of the object contained within this [ContentStream](xref:botframework-streaming.ContentStream).
         *
         * @returns The [PayloadType](xref:botframework-streaming.PayloadType) of this [ContentStream](xref:botframework-streaming.ContentStream).
         */ get: function() {
                            return this.assembler.payloadType;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ContentStream.prototype, "length", {
                        /**
         * Gets the length of this [ContentStream](xref:botframework-streaming.ContentStream).
         *
         * @returns A number representing the length of this [ContentStream](xref:botframework-streaming.ContentStream).
         */ get: function() {
                            return this.assembler.contentLength;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Gets the data contained within this [ContentStream](xref:botframework-streaming.ContentStream).
     *
     * @returns This [ContentStream's](xref:botframework-streaming.ContentStream) [SubscribableStream](xref:botframework-streaming.SubscribableStream).
     */ ContentStream.prototype.getStream = function() {
                        if (!this.stream) this.stream = this.assembler.getPayloadStream();
                        return this.stream;
                    };
                    /**
     * Closes the assembler.
     */ ContentStream.prototype.cancel = function() {
                        this.assembler.close();
                    };
                    /**
     * Gets the [SubscribableStream](xref:botframework-streaming.SubscribableStream) content as a string.
     *
     * @returns A string Promise with [SubscribableStream](xref:botframework-streaming.SubscribableStream) content.
     */ ContentStream.prototype.readAsString = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var bufferArray;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.readAll()
                                        ];
                                    case 1:
                                        bufferArray = _a.sent().bufferArray;
                                        return [
                                            2 /*return*/ ,
                                            (bufferArray || []).map(function(result) {
                                                return result.toString("utf8");
                                            }).join("")
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets the [SubscribableStream](xref:botframework-streaming.SubscribableStream) content as a typed JSON object.
     *
     * @returns A typed object Promise with `SubscribableStream` content.
     */ ContentStream.prototype.readAsJson = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var stringToParse;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.readAsString()
                                        ];
                                    case 1:
                                        stringToParse = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            JSON.parse(stringToParse)
                                        ];
                                }
                            });
                        });
                    };
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ContentStream.prototype.readAll = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var allData, count, stream, chunk, readToEnd;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        allData = [];
                                        count = 0;
                                        stream = this.getStream();
                                        // populate the array with any existing buffers
                                        while(count < stream.length){
                                            chunk = stream.read(stream.length);
                                            allData.push(chunk);
                                            count += chunk.length;
                                        }
                                        if (!(count < this.length)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        readToEnd = new Promise(function(resolve) {
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            var callback = function(cs) {
                                                return function(chunk) {
                                                    allData.push(chunk);
                                                    count += chunk.length;
                                                    if (count === cs.length) resolve(true);
                                                };
                                            };
                                            stream.subscribe(callback(_this));
                                        });
                                        return [
                                            4 /*yield*/ ,
                                            readToEnd
                                        ];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            {
                                                bufferArray: allData,
                                                size: count
                                            }
                                        ];
                                }
                            });
                        });
                    };
                    return ContentStream;
                }();
                exports.ContentStream = ContentStream;
            },
            {}
        ],
        3: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CancelDisassembler = void 0;
                /**
 * Streaming cancel disassembler.
 */ var CancelDisassembler = /** @class */ function() {
                    /**
     * Initializes a new instance of the [CancelDisassembler](xref:botframework-streaming.CancelDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) that this Cancel request will be sent by.
     * @param id The ID of the Stream to cancel.
     * @param payloadType The type of the Stream that is being cancelled.
     */ function CancelDisassembler(sender, id, payloadType) {
                        this.sender = sender;
                        this.id = id;
                        this.payloadType = payloadType;
                    }
                    /**
     * Initiates the process of disassembling the request and signals the [PayloadSender](xref:botframework-streaming.PayloadSender) to begin sending.
     */ CancelDisassembler.prototype.disassemble = function() {
                        var header = {
                            payloadType: this.payloadType,
                            payloadLength: 0,
                            id: this.id,
                            end: true
                        };
                        this.sender.sendPayload(header);
                    };
                    return CancelDisassembler;
                }();
                exports.CancelDisassembler = CancelDisassembler;
            },
            {}
        ],
        4: [
            function(require, module, exports) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HttpContentStreamDisassembler = void 0;
                var payloadDisassembler_1 = require("./payloadDisassembler");
                var payloads_1 = require("../payloads");
                /**
 * Disassembler for Http content stream
 */ var HttpContentStreamDisassembler = /** @class */ function(_super) {
                    __extends(HttpContentStreamDisassembler, _super);
                    /**
     * Initializes a new instance of the [HttpContentStreamDisassembler](xref:botframework-streaming.HttpContentStreamDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) to send the disassembled data to.
     * @param contentStream The [HttpContentStream](xref:botframework-streaming.HttpContentStream) to be disassembled.
     */ function HttpContentStreamDisassembler(sender, contentStream) {
                        var _this = _super.call(this, sender, contentStream.id) || this;
                        _this.payloadType = payloads_1.PayloadTypes.stream;
                        _this.contentStream = contentStream;
                        return _this;
                    }
                    /**
     * Gets the stream this disassembler is operating on.
     *
     * @returns An [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) with a Subscribable Strea.
     */ HttpContentStreamDisassembler.prototype.getStream = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var stream;
                            return __generator(this, function(_a) {
                                stream = this.contentStream.content.getStream();
                                return [
                                    2 /*return*/ ,
                                    {
                                        stream: stream,
                                        streamLength: stream.length
                                    }
                                ];
                            });
                        });
                    };
                    return HttpContentStreamDisassembler;
                }(payloadDisassembler_1.PayloadDisassembler);
                exports.HttpContentStreamDisassembler = HttpContentStreamDisassembler;
            },
            {
                "../payloads": 16,
                "./payloadDisassembler": 5
            }
        ],
        5: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadDisassembler = void 0;
                var subscribableStream_1 = require("../subscribableStream");
                /**
 * Base class streaming payload disassembling.
 */ var PayloadDisassembler = /** @class */ function() {
                    /**
     * Initializes a new instance of the [PayloadDisassembler](xref:botframework-streaming.PayloadDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) used to send the disassembled payload chunks.
     * @param id The ID of this disassembler.
     */ function PayloadDisassembler(sender, id) {
                        this.sender = sender;
                        this.id = id;
                    }
                    /**
     * Serializes the item into the [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) that exposes the stream and length of the result.
     *
     * @param item The item to be serialized.
     * @returns The stream containing the serialized item and the length of the stream.
     */ PayloadDisassembler.serialize = function(item) {
                        var stream = new subscribableStream_1.SubscribableStream();
                        stream.write(JSON.stringify(item));
                        stream.end();
                        return {
                            stream: stream,
                            streamLength: stream.length
                        };
                    };
                    /**
     * Begins the process of disassembling a payload and sending the resulting chunks to the [PayloadSender](xref:botframework-streaming.PayloadSender) to dispatch over the transport.
     *
     * @returns A completed Promise after the disassembled payload has been sent.
     */ PayloadDisassembler.prototype.disassemble = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var _a, stream, streamLength;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.getStream()
                                        ];
                                    case 1:
                                        _a = _b.sent(), stream = _a.stream, streamLength = _a.streamLength;
                                        this.stream = stream;
                                        this.streamLength = streamLength;
                                        return [
                                            2 /*return*/ ,
                                            this.send()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Begins the process of disassembling a payload and signals the [PayloadSender](xref:botframework-streaming.PayloadSender).
     */ PayloadDisassembler.prototype.send = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var header;
                            return __generator(this, function(_a) {
                                header = {
                                    payloadType: this.payloadType,
                                    payloadLength: this.streamLength,
                                    id: this.id,
                                    end: true
                                };
                                this.sender.sendPayload(header, this.stream);
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    return PayloadDisassembler;
                }();
                exports.PayloadDisassembler = PayloadDisassembler;
            },
            {
                "../subscribableStream": 27
            }
        ],
        6: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RequestDisassembler = void 0;
                var payloadTypes_1 = require("../payloads/payloadTypes");
                var payloadDisassembler_1 = require("./payloadDisassembler");
                /**
 * Streaming request disassembler.
 */ var RequestDisassembler = /** @class */ function(_super) {
                    __extends(RequestDisassembler, _super);
                    /**
     * Initializes a new instance of the [RequestDisassembler](xref:botframework-streaming.RequestDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) to send the disassembled data to.
     * @param id The ID of this disassembler.
     * @param request The request to be disassembled.
     */ function RequestDisassembler(sender, id, request) {
                        var _this = _super.call(this, sender, id) || this;
                        _this.request = request;
                        _this.payloadType = payloadTypes_1.PayloadTypes.request;
                        return _this;
                    }
                    /**
     * Gets the stream this disassembler is operating on.
     *
     * @returns An [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) with a Subscribable Stream.
     */ RequestDisassembler.prototype.getStream = function() {
                        var _a, _b, _c, _d;
                        return __awaiter(this, void 0, void 0, function() {
                            var payload;
                            return __generator(this, function(_e) {
                                payload = {
                                    verb: (_a = this.request) === null || _a === void 0 ? void 0 : _a.verb,
                                    path: (_b = this.request) === null || _b === void 0 ? void 0 : _b.path,
                                    streams: []
                                };
                                (_d = (_c = this.request) === null || _c === void 0 ? void 0 : _c.streams) === null || _d === void 0 || _d.forEach(function(stream) {
                                    payload.streams.push(stream.description);
                                });
                                return [
                                    2 /*return*/ ,
                                    payloadDisassembler_1.PayloadDisassembler.serialize(payload)
                                ];
                            });
                        });
                    };
                    return RequestDisassembler;
                }(payloadDisassembler_1.PayloadDisassembler);
                exports.RequestDisassembler = RequestDisassembler;
            },
            {
                "../payloads/payloadTypes": 19,
                "./payloadDisassembler": 5
            }
        ],
        7: [
            function(require, module, exports) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ResponseDisassembler = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var payloadTypes_1 = require("../payloads/payloadTypes");
                var payloadDisassembler_1 = require("./payloadDisassembler");
                /**
 * Streaming response disassembler.
 */ var ResponseDisassembler = /** @class */ function(_super) {
                    __extends(ResponseDisassembler, _super);
                    /**
     * Initializes a new instance of the [ResponseDisassembler](xref:botframework-streaming.ResponseDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) to send the disassembled data to.
     * @param id The ID of this disassembler.
     * @param response The response to be disassembled.
     */ function ResponseDisassembler(sender, id, response) {
                        var _this = _super.call(this, sender, id) || this;
                        _this.payloadType = payloadTypes_1.PayloadTypes.response;
                        _this.response = response;
                        return _this;
                    }
                    /**
     * Gets the stream this disassembler is operating on.
     *
     * @returns An [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) with a Subscribable Stream.
     */ ResponseDisassembler.prototype.getStream = function() {
                        var _a;
                        return __awaiter(this, void 0, void 0, function() {
                            var payload;
                            return __generator(this, function(_b) {
                                payload = {
                                    statusCode: this.response.statusCode,
                                    streams: []
                                };
                                (_a = this.response.streams) === null || _a === void 0 || _a.forEach(function(_a) {
                                    var description = _a.description;
                                    payload.streams.push({
                                        id: description.id,
                                        contentType: description.type,
                                        length: description.length
                                    });
                                });
                                return [
                                    2 /*return*/ ,
                                    payloadDisassembler_1.PayloadDisassembler.serialize(payload)
                                ];
                            });
                        });
                    };
                    return ResponseDisassembler;
                }(payloadDisassembler_1.PayloadDisassembler);
                exports.ResponseDisassembler = ResponseDisassembler;
            },
            {
                "../payloads/payloadTypes": 19,
                "./payloadDisassembler": 5
            }
        ],
        8: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HttpContent = exports.HttpContentStream = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var protocol_base_1 = require("./utilities/protocol-base");
                /**
 * An attachment contained within a StreamingRequest's stream collection, which itself contains any form of media item.
 */ var HttpContentStream = /** @class */ function() {
                    /**
     * Initializes a new instance of the [HttpContentStream](xref:botframework-streaming.HttpContentStream) class.
     *
     * @param content The [HttpContent](xref:botframework-streaming.HttpContent) to assign to the [HttpContentStream](xref:botframework-streaming.HttpContentStream).
     */ function HttpContentStream(content) {
                        var _a, _b, _c, _d, _e, _f;
                        this.content = content;
                        this.id = (0, protocol_base_1.generateGuid)();
                        this.description = {
                            id: this.id,
                            type: (_c = (_b = (_a = this.content) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : "unknown",
                            length: (_f = (_e = (_d = this.content) === null || _d === void 0 ? void 0 : _d.headers) === null || _e === void 0 ? void 0 : _e.contentLength) !== null && _f !== void 0 ? _f : 0
                        };
                    }
                    return HttpContentStream;
                }();
                exports.HttpContentStream = HttpContentStream;
                /**
 * The HttpContent class that contains a [SubscribableStream](xref:botframework-streaming.SubscribableStream).
 */ var HttpContent = /** @class */ function() {
                    /**
     * Initializes a new instance of the [HttpContent](xref:botframework-streaming.HttpContent) class.
     *
     * @param headers The Streaming Http content header definition.
     * @param stream The stream of buffered data.
     */ function HttpContent(headers, stream) {
                        this.headers = headers;
                        this.stream = stream;
                    }
                    /**
     * Gets the data contained within this [HttpContent](xref:botframework-streaming.HttpContent).
     *
     * @returns This [HttpContent's](xref:botframework-streaming.HttpContent) [SubscribableStream](xref:botframework-streaming.SubscribableStream) member.
     */ HttpContent.prototype.getStream = function() {
                        return this.stream;
                    };
                    return HttpContent;
                }();
                exports.HttpContent = HttpContent;
            },
            {
                "./utilities/protocol-base": 28
            }
        ],
        9: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WebSocketClient = exports.BrowserWebSocket = exports.SubscribableStream = exports.StreamingResponse = exports.StreamingRequest = exports.RequestHandler = exports.HttpContent = exports.ContentStream = void 0;
                var contentStream_1 = require("./contentStream");
                Object.defineProperty(exports, "ContentStream", {
                    enumerable: true,
                    get: function() {
                        return contentStream_1.ContentStream;
                    }
                });
                var httpContentStream_1 = require("./httpContentStream");
                Object.defineProperty(exports, "HttpContent", {
                    enumerable: true,
                    get: function() {
                        return httpContentStream_1.HttpContent;
                    }
                });
                var requestHandler_1 = require("./requestHandler");
                Object.defineProperty(exports, "RequestHandler", {
                    enumerable: true,
                    get: function() {
                        return requestHandler_1.RequestHandler;
                    }
                });
                var streamingRequest_1 = require("./streamingRequest");
                Object.defineProperty(exports, "StreamingRequest", {
                    enumerable: true,
                    get: function() {
                        return streamingRequest_1.StreamingRequest;
                    }
                });
                var streamingResponse_1 = require("./streamingResponse");
                Object.defineProperty(exports, "StreamingResponse", {
                    enumerable: true,
                    get: function() {
                        return streamingResponse_1.StreamingResponse;
                    }
                });
                var subscribableStream_1 = require("./subscribableStream");
                Object.defineProperty(exports, "SubscribableStream", {
                    enumerable: true,
                    get: function() {
                        return subscribableStream_1.SubscribableStream;
                    }
                });
                var index_browser_1 = require("./webSocket/index-browser");
                Object.defineProperty(exports, "BrowserWebSocket", {
                    enumerable: true,
                    get: function() {
                        return index_browser_1.BrowserWebSocket;
                    }
                });
                Object.defineProperty(exports, "WebSocketClient", {
                    enumerable: true,
                    get: function() {
                        return index_browser_1.WebSocketClient;
                    }
                });
            },
            {
                "./contentStream": 2,
                "./httpContentStream": 8,
                "./requestHandler": 24,
                "./streamingRequest": 25,
                "./streamingResponse": 26,
                "./subscribableStream": 27,
                "./webSocket/index-browser": 31
            }
        ],
        10: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(require("./payloadReceiver"), exports);
                __exportStar(require("./payloadSender"), exports);
                __exportStar(require("./transportDisconnectedEvent"), exports);
                __exportStar(require("./transportDisconnectedEventHandler"), exports);
            },
            {
                "./payloadReceiver": 11,
                "./payloadSender": 12,
                "./transportDisconnectedEvent": 13,
                "./transportDisconnectedEventHandler": 14
            }
        ],
        11: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadReceiver = void 0;
                var payloadTypes_1 = require("../payloads/payloadTypes");
                var headerSerializer_1 = require("../payloads/headerSerializer");
                var payloadConstants_1 = require("../payloads/payloadConstants");
                var transportDisconnectedEvent_1 = require("./transportDisconnectedEvent");
                /**
 * Payload receiver for streaming.
 */ var PayloadReceiver = /** @class */ function() {
                    function PayloadReceiver() {}
                    Object.defineProperty(PayloadReceiver.prototype, "isConnected", {
                        /**
         * Get current connected state
         *
         * @returns true if connected to a transport sender.
         */ get: function() {
                            return this._receiver != null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Connects to a transport receiver
     *
     * @param receiver The [ITransportReceiver](xref:botframework-streaming.ITransportReceiver) object to pull incoming data from.
     * @returns a promise that resolves when the receiver is complete
     */ PayloadReceiver.prototype.connect = function(receiver) {
                        this._receiver = receiver;
                        return this.receivePackets();
                    };
                    /**
     * Allows subscribing to this receiver in order to be notified when new data comes in.
     *
     * @param getStream Callback when a new stream has been received.
     * @param receiveAction Callback when a new message has been received.
     */ PayloadReceiver.prototype.subscribe = function(getStream, receiveAction) {
                        this._getStream = getStream;
                        this._receiveAction = receiveAction;
                    };
                    /**
     * Force this receiver to disconnect.
     *
     * @param event Event arguments to include when broadcasting disconnection event.
     */ PayloadReceiver.prototype.disconnect = function(event) {
                        var _a, _b;
                        if (event === void 0) event = transportDisconnectedEvent_1.TransportDisconnectedEvent.Empty;
                        if (!this.isConnected) return;
                        try {
                            this._receiver.close();
                            (_a = this.disconnected) === null || _a === void 0 || _a.call(this, this, event);
                        } catch (err) {
                            (_b = this.disconnected) === null || _b === void 0 || _b.call(this, this, new transportDisconnectedEvent_1.TransportDisconnectedEvent(err.message));
                        } finally{
                            this._receiver = null;
                        }
                    };
                    PayloadReceiver.prototype.receivePackets = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var readSoFar, _a, header, isStream, bytesActuallyRead, contentStream, count, _b, err_1;
                            return __generator(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        if (!this.isConnected) return [
                                            3 /*break*/ ,
                                            11
                                        ];
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([
                                            1,
                                            9,
                                            ,
                                            10
                                        ]);
                                        readSoFar = 0;
                                        _c.label = 2;
                                    case 2:
                                        if (!(readSoFar < payloadConstants_1.PayloadConstants.MaxHeaderLength)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        _a = this;
                                        return [
                                            4 /*yield*/ ,
                                            this._receiver.receive(payloadConstants_1.PayloadConstants.MaxHeaderLength - readSoFar)
                                        ];
                                    case 3:
                                        _a._receiveHeaderBuffer = _c.sent();
                                        if (this._receiveHeaderBuffer) readSoFar += this._receiveHeaderBuffer.length;
                                        return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                    case 4:
                                        header = headerSerializer_1.HeaderSerializer.deserialize(this._receiveHeaderBuffer);
                                        isStream = header.payloadType === payloadTypes_1.PayloadTypes.stream;
                                        if (!(header.payloadLength > 0)) return [
                                            3 /*break*/ ,
                                            8
                                        ];
                                        bytesActuallyRead = 0;
                                        contentStream = this._getStream(header);
                                        _c.label = 5;
                                    case 5:
                                        if (!(bytesActuallyRead < header.payloadLength && bytesActuallyRead < payloadConstants_1.PayloadConstants.MaxPayloadLength)) return [
                                            3 /*break*/ ,
                                            7
                                        ];
                                        count = Math.min(header.payloadLength - bytesActuallyRead, payloadConstants_1.PayloadConstants.MaxPayloadLength);
                                        _b = this;
                                        return [
                                            4 /*yield*/ ,
                                            this._receiver.receive(count)
                                        ];
                                    case 6:
                                        _b._receivePayloadBuffer = _c.sent();
                                        bytesActuallyRead += this._receivePayloadBuffer.byteLength;
                                        contentStream.write(this._receivePayloadBuffer);
                                        // If this is a stream we want to keep handing it up as it comes in
                                        if (isStream) this._receiveAction(header, contentStream, bytesActuallyRead);
                                        return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                    case 7:
                                        if (!isStream) this._receiveAction(header, contentStream, bytesActuallyRead);
                                        _c.label = 8;
                                    case 8:
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 9:
                                        err_1 = _c.sent();
                                        this.disconnect(new transportDisconnectedEvent_1.TransportDisconnectedEvent(err_1.message));
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 10:
                                        return [
                                            3 /*break*/ ,
                                            0
                                        ];
                                    case 11:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return PayloadReceiver;
                }();
                exports.PayloadReceiver = PayloadReceiver;
            },
            {
                "../payloads/headerSerializer": 15,
                "../payloads/payloadConstants": 18,
                "../payloads/payloadTypes": 19,
                "./transportDisconnectedEvent": 13
            }
        ],
        12: [
            function(require, module, exports) {
                (function(Buffer) {
                    (function() {
                        "use strict";
                        /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                            value: true
                        });
                        exports.PayloadSender = void 0;
                        var headerSerializer_1 = require("../payloads/headerSerializer");
                        var payloadConstants_1 = require("../payloads/payloadConstants");
                        var transportDisconnectedEvent_1 = require("./transportDisconnectedEvent");
                        /**
 * Streaming payload sender.
 */ var PayloadSender = /** @class */ function() {
                            function PayloadSender() {}
                            Object.defineProperty(PayloadSender.prototype, "isConnected", {
                                /**
         * Get current connected state
         *
         * @returns true if connected to a transport sender.
         */ get: function() {
                                    return this._sender != null;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            /**
     * Connects to the given transport sender.
     *
     * @param sender The transport sender to connect this payload sender to.
     */ PayloadSender.prototype.connect = function(sender) {
                                this._sender = sender;
                            };
                            /**
     * Sends a payload out over the connected transport sender.
     *
     * @param header The header to attach to the outgoing payload.
     * @param payload The stream of buffered data to send.
     * @param sentCallback The function to execute when the send has completed.
     */ PayloadSender.prototype.sendPayload = function(header, payload, sentCallback) {
                                var packet = {
                                    header: header,
                                    payload: payload,
                                    sentCallback: sentCallback
                                };
                                this.writePacket(packet);
                            };
                            /**
     * Disconnects this payload sender.
     *
     * @param event The disconnected event arguments to include in the disconnected event broadcast.
     */ PayloadSender.prototype.disconnect = function(event) {
                                var _a, _b;
                                if (event === void 0) event = transportDisconnectedEvent_1.TransportDisconnectedEvent.Empty;
                                if (!this.isConnected) return;
                                try {
                                    this._sender.close();
                                    (_a = this.disconnected) === null || _a === void 0 || _a.call(this, this, event);
                                } catch (err) {
                                    (_b = this.disconnected) === null || _b === void 0 || _b.call(this, this, new transportDisconnectedEvent_1.TransportDisconnectedEvent(err.message));
                                } finally{
                                    this._sender = null;
                                }
                            };
                            PayloadSender.prototype.writePacket = function(packet) {
                                try {
                                    if (packet.header.payloadLength > 0 && packet.payload) {
                                        var leftOver = packet.header.payloadLength;
                                        while(leftOver > 0){
                                            var count = leftOver <= payloadConstants_1.PayloadConstants.MaxPayloadLength ? leftOver : payloadConstants_1.PayloadConstants.MaxPayloadLength;
                                            var chunk = packet.payload.read(count);
                                            var header = packet.header;
                                            header.payloadLength = count;
                                            header.end = leftOver <= payloadConstants_1.PayloadConstants.MaxPayloadLength;
                                            var sendHeaderBuffer = Buffer.alloc(payloadConstants_1.PayloadConstants.MaxHeaderLength);
                                            headerSerializer_1.HeaderSerializer.serialize(header, sendHeaderBuffer);
                                            this._sender.send(sendHeaderBuffer);
                                            this._sender.send(chunk);
                                            leftOver -= chunk.length;
                                        }
                                        if (packet.sentCallback) packet.sentCallback();
                                    }
                                } catch (err) {
                                    this.disconnect(new transportDisconnectedEvent_1.TransportDisconnectedEvent(err.message));
                                }
                            };
                            return PayloadSender;
                        }();
                        exports.PayloadSender = PayloadSender;
                    }).call(this);
                }).call(this, require("buffer").Buffer);
            },
            {
                "../payloads/headerSerializer": 15,
                "../payloads/payloadConstants": 18,
                "./transportDisconnectedEvent": 13,
                "buffer": 35
            }
        ],
        13: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TransportDisconnectedEvent = void 0;
                /**
 * Event to be included when disconnection events are fired.
 */ var TransportDisconnectedEvent = /** @class */ function() {
                    /**
     * Indicates a transport disconnected with the reason provided via the constructor.
     *
     * @remarks
     * This class is used for communicating disconnection events between the
     * PayloadReceiver and PayloadSender.
     * @param reason The reason the disconnection event fired, in plain text.
     */ function TransportDisconnectedEvent(reason) {
                        this.reason = reason;
                    }
                    /**
     * A new and empty TransportDisconnectedEvent.
     */ TransportDisconnectedEvent.Empty = new TransportDisconnectedEvent();
                    return TransportDisconnectedEvent;
                }();
                exports.TransportDisconnectedEvent = TransportDisconnectedEvent;
            },
            {}
        ],
        14: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            },
            {}
        ],
        15: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HeaderSerializer = void 0;
                var payloadConstants_1 = require("./payloadConstants");
                /**
 * Streaming header serializer
 */ var HeaderSerializer = /** @class */ function() {
                    function HeaderSerializer() {}
                    /**
     * Serializes the header into a buffer
     *
     * @param header The header to serialize.
     * @param buffer The buffer into which to serialize the header.
     */ HeaderSerializer.serialize = function(header, buffer) {
                        buffer.write(header.payloadType, this.TypeOffset, 1, this.Encoding);
                        buffer.write(this.Delimiter, this.TypeDelimiterOffset, 1, this.Encoding);
                        buffer.write(this.headerLengthPadder(header.payloadLength, this.LengthLength, "0"), this.LengthOffset, this.LengthLength, this.Encoding);
                        buffer.write(this.Delimiter, this.LengthDelimeterOffset, 1, this.Encoding);
                        buffer.write(header.id, this.IdOffset);
                        buffer.write(this.Delimiter, this.IdDelimeterOffset, 1, this.Encoding);
                        buffer.write(header.end ? this.End : this.NotEnd, this.EndOffset);
                        buffer.write(this.Terminator, this.TerminatorOffset);
                    };
                    /**
     * Deserializes a buffer containing header information.
     *
     * @param buffer The buffer from which to obtain the data to deserialize.
     * @returns The deserialized header from the buffer.
     */ HeaderSerializer.deserialize = function(buffer) {
                        var jsonBuffer = buffer.toString(this.Encoding);
                        var headerArray = jsonBuffer.split(this.Delimiter);
                        if (headerArray.length !== 4) throw Error("Cannot parse header, header is malformed. Header: ".concat(jsonBuffer));
                        var payloadType = headerArray[0], length = headerArray[1], id = headerArray[2], headerEnd = headerArray[3];
                        var end = headerEnd === "1\n";
                        var payloadLength = Number(length);
                        var header = {
                            end: end,
                            payloadLength: payloadLength,
                            payloadType: payloadType,
                            id: id
                        };
                        if (!(header.payloadLength <= payloadConstants_1.PayloadConstants.MaxPayloadLength && header.payloadLength >= payloadConstants_1.PayloadConstants.MinLength)) throw Error("Header length of ".concat(header.payloadLength, " is missing or malformed"));
                        if (header.payloadType.length !== this.TypeDelimiterOffset) throw Error("Header type '".concat(header.payloadType.length, "' is missing or malformed."));
                        if (!header.id || !header.id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i) || header.id.length !== this.IdLength) throw Error("Header ID '".concat(header.id, "' is missing or malformed."));
                        if (!(headerEnd === "0\n" || headerEnd === "1\n")) throw Error("Header End is missing or not a valid value. Header end: '".concat(headerEnd, "'"));
                        return header;
                    };
                    /**
     * Creates a padded string based on a length and character to be padded to.
     *
     * @param lengthValue The value to be assingned on the result.
     * @param totalLength The length of the padded string result.
     * @param padChar The character value to use as filling.
     * @returns The padded string.
     */ HeaderSerializer.headerLengthPadder = function(lengthValue, totalLength, padChar) {
                        var result = Array(totalLength + 1).join(padChar);
                        var lengthString = lengthValue.toString();
                        return (result + lengthString).slice(lengthString.length);
                    };
                    HeaderSerializer.Delimiter = ".";
                    HeaderSerializer.Terminator = "\n";
                    HeaderSerializer.End = "1";
                    HeaderSerializer.NotEnd = "0";
                    HeaderSerializer.TypeOffset = 0;
                    HeaderSerializer.TypeDelimiterOffset = 1;
                    HeaderSerializer.LengthOffset = 2;
                    HeaderSerializer.LengthLength = 6;
                    HeaderSerializer.LengthDelimeterOffset = 8;
                    HeaderSerializer.IdOffset = 9;
                    HeaderSerializer.IdLength = 36;
                    HeaderSerializer.IdDelimeterOffset = 45;
                    HeaderSerializer.EndOffset = 46;
                    HeaderSerializer.TerminatorOffset = 47;
                    HeaderSerializer.Encoding = "utf8";
                    return HeaderSerializer;
                }();
                exports.HeaderSerializer = HeaderSerializer;
            },
            {
                "./payloadConstants": 18
            }
        ],
        16: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(require("./headerSerializer"), exports);
                __exportStar(require("./streamManager"), exports);
                __exportStar(require("./payloadAssemblerManager"), exports);
                __exportStar(require("./payloadTypes"), exports);
                __exportStar(require("./requestManager"), exports);
                __exportStar(require("./sendOperations"), exports);
                __exportStar(require("./streamManager"), exports);
            },
            {
                "./headerSerializer": 15,
                "./payloadAssemblerManager": 17,
                "./payloadTypes": 19,
                "./requestManager": 20,
                "./sendOperations": 21,
                "./streamManager": 22
            }
        ],
        17: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadAssemblerManager = void 0;
                var payloadAssembler_1 = require("../assemblers/payloadAssembler");
                var payloadTypes_1 = require("./payloadTypes");
                /**
 * Orchestrates assembly of payloads.
 */ var PayloadAssemblerManager = /** @class */ function() {
                    /**
     * Initializes a new instance of the [PayloadAssemblerManager](xref:botframework-streaming.PayloadAssemblerManager) class.
     *
     * @param streamManager The [StreamManager](xref:botframework-streaming.StreamManager) managing the stream being assembled.
     * @param onReceiveResponse Function that executes when new bytes are received on a `response` stream.
     * @param onReceiveRequest Function that executes when new bytes are received on a `request` stream.
     */ function PayloadAssemblerManager(streamManager, onReceiveResponse, onReceiveRequest) {
                        this.streamManager = streamManager;
                        this.onReceiveResponse = onReceiveResponse;
                        this.onReceiveRequest = onReceiveRequest;
                        this.activeAssemblers = {};
                    }
                    /**
     * Retrieves the assembler's payload as a stream.
     *
     * @param header The Header of the Stream to retrieve.
     * @returns A [SubscribableStream](xref:botframework-streaming.SubscribableStream) of the assembler's payload.
     */ PayloadAssemblerManager.prototype.getPayloadStream = function(header) {
                        if (header.payloadType === payloadTypes_1.PayloadTypes.stream) return this.streamManager.getPayloadStream(header);
                        else if (!this.activeAssemblers[header.id]) {
                            var assembler = this.createPayloadAssembler(header);
                            if (assembler) {
                                this.activeAssemblers[header.id] = assembler;
                                return assembler.getPayloadStream();
                            }
                        }
                    };
                    /**
     * The action the assembler executes when new bytes are received on the incoming stream.
     *
     * @param header The stream's Header.
     * @param contentStream The incoming stream being assembled.
     * @param contentLength The length of the stream, if finite.
     */ PayloadAssemblerManager.prototype.onReceive = function(header, contentStream, contentLength) {
                        if (header.payloadType === payloadTypes_1.PayloadTypes.stream) this.streamManager.onReceive(header, contentStream, contentLength);
                        else {
                            if (this.activeAssemblers && this.activeAssemblers[header.id]) {
                                var assembler = this.activeAssemblers[header.id];
                                assembler.onReceive(header, contentStream, contentLength);
                            }
                            if (header.end) delete this.activeAssemblers[header.id];
                        }
                    };
                    PayloadAssemblerManager.prototype.createPayloadAssembler = function(header) {
                        if (header.payloadType === payloadTypes_1.PayloadTypes.request) return new payloadAssembler_1.PayloadAssembler(this.streamManager, {
                            header: header,
                            onCompleted: this.onReceiveRequest
                        });
                        else if (header.payloadType === payloadTypes_1.PayloadTypes.response) return new payloadAssembler_1.PayloadAssembler(this.streamManager, {
                            header: header,
                            onCompleted: this.onReceiveResponse
                        });
                    };
                    return PayloadAssemblerManager;
                }();
                exports.PayloadAssemblerManager = PayloadAssemblerManager;
            },
            {
                "../assemblers/payloadAssembler": 1,
                "./payloadTypes": 19
            }
        ],
        18: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadConstants = void 0;
                /**
 * Constants for streaming payloads.
 */ var PayloadConstants;
                (function(PayloadConstants) {
                    PayloadConstants[PayloadConstants["MaxPayloadLength"] = 4096] = "MaxPayloadLength";
                    PayloadConstants[PayloadConstants["MaxHeaderLength"] = 48] = "MaxHeaderLength";
                    PayloadConstants[PayloadConstants["MaxLength"] = 999999] = "MaxLength";
                    PayloadConstants[PayloadConstants["MinLength"] = 0] = "MinLength";
                })(PayloadConstants = exports.PayloadConstants || (exports.PayloadConstants = {}));
            },
            {}
        ],
        19: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PayloadTypes = void 0;
                /**
 * Typess of payloads supported in the streaming library.
 */ var PayloadTypes;
                (function(PayloadTypes) {
                    PayloadTypes["request"] = "A";
                    PayloadTypes["response"] = "B";
                    PayloadTypes["stream"] = "S";
                    PayloadTypes["cancelAll"] = "X";
                    PayloadTypes["cancelStream"] = "C";
                })(PayloadTypes = exports.PayloadTypes || (exports.PayloadTypes = {}));
            },
            {}
        ],
        20: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RequestManager = void 0;
                /**
 * A streaming pending request.
 */ var PendingRequest = /** @class */ function() {
                    function PendingRequest() {}
                    return PendingRequest;
                }();
                /**
 * Orchestrates and manages pending streaming requests.
 */ var RequestManager = /** @class */ function() {
                    function RequestManager() {
                        this._pendingRequests = {};
                    }
                    /**
     * Gets the count of the pending requests.
     *
     * @returns Number with the pending requests count.
     */ RequestManager.prototype.pendingRequestCount = function() {
                        return Object.keys(this._pendingRequests).length;
                    };
                    /**
     * Signal fired when all response tasks have completed.
     *
     * @param requestId The ID of the StreamingRequest.
     * @param response The [IReceiveResponse](xref:botframework-streaming.IReceiveResponse) in response to the request.
     * @returns A Promise that when completed returns `true` if the `requestId`'s pending response task was completed, otherwise `false`.
     */ RequestManager.prototype.signalResponse = function(requestId, response) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pendingRequest;
                            return __generator(this, function(_a) {
                                pendingRequest = this._pendingRequests[requestId];
                                if (pendingRequest) {
                                    pendingRequest.resolve(response);
                                    delete this._pendingRequests[requestId];
                                    return [
                                        2 /*return*/ ,
                                        true
                                    ];
                                }
                                return [
                                    2 /*return*/ ,
                                    false
                                ];
                            });
                        });
                    };
                    /**
     * Constructs and returns a response for this request.
     *
     * @param requestId The ID of the StreamingRequest being responded to.
     * @returns The response to the specified request.
     */ RequestManager.prototype.getResponse = function(requestId) {
                        var pendingRequest = this._pendingRequests[requestId];
                        if (pendingRequest) return Promise.reject("requestId '".concat(requestId, "' already exists in RequestManager"));
                        pendingRequest = new PendingRequest();
                        pendingRequest.requestId = requestId;
                        var promise = new Promise(function(resolve, reject) {
                            pendingRequest.resolve = resolve;
                            pendingRequest.reject = reject;
                        });
                        this._pendingRequests[requestId] = pendingRequest;
                        return promise;
                    };
                    /**
     * Rejects all requests pending a response.
     *
     * @param reason The reason for rejection.
     */ RequestManager.prototype.rejectAllResponses = function(reason) {
                        var _this = this;
                        Object.entries(this._pendingRequests).forEach(function(_a) {
                            var requestId = _a[0], reject = _a[1].reject;
                            reject(reason);
                            delete _this._pendingRequests[requestId];
                        });
                    };
                    return RequestManager;
                }();
                exports.RequestManager = RequestManager;
            },
            {}
        ],
        21: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SendOperations = void 0;
                var cancelDisassembler_1 = require("../disassemblers/cancelDisassembler");
                var httpContentStreamDisassembler_1 = require("../disassemblers/httpContentStreamDisassembler");
                var requestDisassembler_1 = require("../disassemblers/requestDisassembler");
                var responseDisassembler_1 = require("../disassemblers/responseDisassembler");
                var payloadTypes_1 = require("./payloadTypes");
                /**
 * Send operations for streaming payloads.
 */ var SendOperations = /** @class */ function() {
                    /**
     * Initializes a new instance of the [SendOperations](xref:botframework-streaming.SendOperations) class.
     *
     * @param payloadSender The [PayloadSender](xref:botframework-streaming.PayloadSender) that will send the disassembled data from all of this instance's send operations.
     */ function SendOperations(payloadSender) {
                        this.payloadSender = payloadSender;
                    }
                    /**
     * The send operation used to send a [StreamingRequest](xref:botframework-streaming.StreamingRequest).
     *
     * @param id The ID to assign to the [RequestDisassembler](xref:botframework-streaming.RequestDisassembler) used by this operation.
     * @param request The request to send.
     */ SendOperations.prototype.sendRequest = function(id, request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var disassembler;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        disassembler = new requestDisassembler_1.RequestDisassembler(this.payloadSender, id, request);
                                        return [
                                            4 /*yield*/ ,
                                            disassembler.disassemble()
                                        ];
                                    case 1:
                                        _a.sent();
                                        if (request.streams) request.streams.forEach(function(contentStream) {
                                            return __awaiter(_this, void 0, void 0, function() {
                                                return __generator(this, function(_a) {
                                                    switch(_a.label){
                                                        case 0:
                                                            return [
                                                                4 /*yield*/ ,
                                                                new httpContentStreamDisassembler_1.HttpContentStreamDisassembler(this.payloadSender, contentStream).disassemble()
                                                            ];
                                                        case 1:
                                                            _a.sent();
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        });
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * The send operation used to send a [PayloadTypes.response](xref:botframework-streaming.PayloadTypes.response).
     *
     * @param id The ID to assign to the [ResponseDisassembler](xref:botframework-streaming.ResponseDisassembler) used by this operation.
     * @param response The response to send.
     */ SendOperations.prototype.sendResponse = function(id, response) {
                        return __awaiter(this, void 0, void 0, function() {
                            var disassembler;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        disassembler = new responseDisassembler_1.ResponseDisassembler(this.payloadSender, id, response);
                                        return [
                                            4 /*yield*/ ,
                                            disassembler.disassemble()
                                        ];
                                    case 1:
                                        _a.sent();
                                        if (response.streams) response.streams.forEach(function(contentStream) {
                                            return __awaiter(_this, void 0, void 0, function() {
                                                return __generator(this, function(_a) {
                                                    switch(_a.label){
                                                        case 0:
                                                            return [
                                                                4 /*yield*/ ,
                                                                new httpContentStreamDisassembler_1.HttpContentStreamDisassembler(this.payloadSender, contentStream).disassemble()
                                                            ];
                                                        case 1:
                                                            _a.sent();
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        });
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * The send operation used to send a [PayloadTypes.cancelStream](xref:botframework-streaming.PayloadTypes.cancelStream).
     *
     * @param id The ID to assign to the [CancelDisassembler](xref:botframework-streaming.CancelDisassembler) used by this operation.
     */ SendOperations.prototype.sendCancelStream = function(id) {
                        return __awaiter(this, void 0, void 0, function() {
                            var disassembler;
                            return __generator(this, function(_a) {
                                disassembler = new cancelDisassembler_1.CancelDisassembler(this.payloadSender, id, payloadTypes_1.PayloadTypes.cancelStream);
                                disassembler.disassemble();
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    return SendOperations;
                }();
                exports.SendOperations = SendOperations;
            },
            {
                "../disassemblers/cancelDisassembler": 3,
                "../disassemblers/httpContentStreamDisassembler": 4,
                "../disassemblers/requestDisassembler": 6,
                "../disassemblers/responseDisassembler": 7,
                "./payloadTypes": 19
            }
        ],
        22: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamManager = void 0;
                var payloadAssembler_1 = require("../assemblers/payloadAssembler");
                /**
 * Orchestrates and manages streams.
 */ var StreamManager = /** @class */ function() {
                    /**
     * Initializes a new instance of the [StreamManager](xref:botframework-streaming.StreamManager) class.
     *
     * @param onCancelStream Function to trigger if the managed stream is cancelled.
     */ function StreamManager(onCancelStream) {
                        this.onCancelStream = onCancelStream;
                        this.activeAssemblers = [];
                    }
                    /**
     * Retrieves a [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) with the given ID if one exists, otherwise a new instance is created and assigned the given ID.
     *
     * @param id The ID of the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) to retrieve or create.
     * @returns The [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) with the given ID.
     */ StreamManager.prototype.getPayloadAssembler = function(id) {
                        if (!this.activeAssemblers[id]) {
                            // A new id has come in, kick off the process of tracking it.
                            var assembler = new payloadAssembler_1.PayloadAssembler(this, {
                                id: id
                            });
                            this.activeAssemblers[id] = assembler;
                            return assembler;
                        } else return this.activeAssemblers[id];
                    };
                    /**
     * Retrieves the [SubscribableStream](xref:botframework-streaming.SubscribableStream) from the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) this manager manages.
     *
     * @param header The Header of the [SubscribableStream](xref:botframework-streaming.SubscribableStream) to retrieve.
     * @returns The [SubscribableStream](xref:botframework-streaming.SubscribableStream) with the given header.
     */ StreamManager.prototype.getPayloadStream = function(header) {
                        var assembler = this.getPayloadAssembler(header.id);
                        return assembler.getPayloadStream();
                    };
                    /**
     * Used to set the behavior of the managed [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) when data is received.
     *
     * @param header The Header of the stream.
     * @param contentStream The [SubscribableStream](xref:botframework-streaming.SubscribableStream) to write incoming data to.
     * @param contentLength The amount of data to write to the contentStream.
     */ StreamManager.prototype.onReceive = function(header, contentStream, contentLength) {
                        if (!this.activeAssemblers[header.id]) return;
                        this.activeAssemblers[header.id].onReceive(header, contentStream, contentLength);
                    };
                    /**
     * Closes the [PayloadAssembler](xref:botframework-streaming.PayloadAssembler) assigned to the [SubscribableStream](xref:botframework-streaming.SubscribableStream) with the given ID.
     *
     * @param id The ID of the [SubscribableStream](xref:botframework-streaming.SubscribableStream) to close.
     */ StreamManager.prototype.closeStream = function(id) {
                        if (!this.activeAssemblers[id]) return;
                        else {
                            var assembler = this.activeAssemblers[id];
                            this.activeAssemblers.splice(this.activeAssemblers.indexOf(id), 1);
                            var targetStream = assembler.getPayloadStream();
                            if (assembler.contentLength && targetStream.length < assembler.contentLength || !assembler.end) this.onCancelStream(assembler);
                        }
                    };
                    return StreamManager;
                }();
                exports.StreamManager = StreamManager;
            },
            {
                "../assemblers/payloadAssembler": 1
            }
        ],
        23: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ProtocolAdapter = void 0;
                var payloadAssemblerManager_1 = require("./payloads/payloadAssemblerManager");
                var sendOperations_1 = require("./payloads/sendOperations");
                var streamManager_1 = require("./payloads/streamManager");
                var protocol_base_1 = require("./utilities/protocol-base");
                /**
 * Creates a protocol adapter for Streaming.
 */ var ProtocolAdapter = /** @class */ function() {
                    /**
     * Creates a new instance of the protocol adapter class.
     *
     * @param requestHandler The [RequestHandler](xref:botframework-streaming.RequestHandler) that will process incoming requests.
     * @param requestManager The [RequestManager](xref:botframework-streaming.RequestManager) that will process outgoing requests.
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) for use with outgoing requests.
     * @param receiver The [PayloadReceiver](xref:botframework-streaming.PayloadReceiver) for use with incoming requests.
     */ function ProtocolAdapter(requestHandler, requestManager, sender, receiver) {
                        var _this = this;
                        this.requestHandler = requestHandler;
                        this.requestManager = requestManager;
                        this.payloadSender = sender;
                        this.payloadReceiver = receiver;
                        this.sendOperations = new sendOperations_1.SendOperations(this.payloadSender);
                        this.streamManager = new streamManager_1.StreamManager(this.onCancelStream);
                        this.assemblerManager = new payloadAssemblerManager_1.PayloadAssemblerManager(this.streamManager, function(id, response) {
                            return _this.onReceiveResponse(id, response);
                        }, function(id, request) {
                            return _this.onReceiveRequest(id, request);
                        });
                        this.payloadReceiver.subscribe(function(header) {
                            return _this.assemblerManager.getPayloadStream(header);
                        }, function(header, contentStream, contentLength) {
                            return _this.assemblerManager.onReceive(header, contentStream, contentLength);
                        });
                    }
                    /**
     * Sends a request over the attached request manager.
     *
     * @param request The outgoing request to send.
     * @returns The response to the specified request.
     */ ProtocolAdapter.prototype.sendRequest = function(request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var requestId, getResponsePromise;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        requestId = (0, protocol_base_1.generateGuid)();
                                        getResponsePromise = this.requestManager.getResponse(requestId);
                                        return [
                                            4 /*yield*/ ,
                                            this.sendOperations.sendRequest(requestId, request)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            getResponsePromise
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Executes the receive pipeline when a request comes in.
     *
     * @param id The id the resources created for the response will be assigned.
     * @param request The incoming request to process.
     */ ProtocolAdapter.prototype.onReceiveRequest = function(id, request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!this.requestHandler) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.requestHandler.processRequest(request)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        if (!response) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.sendOperations.sendResponse(id, response)
                                        ];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Executes the receive pipeline when a response comes in.
     *
     * @param id The id the resources created for the response will be assigned.
     * @param response The incoming response to process.
     */ ProtocolAdapter.prototype.onReceiveResponse = function(id, response) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.requestManager.signalResponse(id, response)
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Executes the receive pipeline when a cancellation comes in.
     *
     * @param contentStreamAssembler The payload assembler processing the incoming data that this cancellation request targets.
     */ ProtocolAdapter.prototype.onCancelStream = function(contentStreamAssembler) {
                        this.sendOperations.sendCancelStream(contentStreamAssembler.id).catch();
                    };
                    return ProtocolAdapter;
                }();
                exports.ProtocolAdapter = ProtocolAdapter;
            },
            {
                "./payloads/payloadAssemblerManager": 17,
                "./payloads/sendOperations": 21,
                "./payloads/streamManager": 22,
                "./utilities/protocol-base": 28
            }
        ],
        24: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RequestHandler = void 0;
                /**
 * Implemented by classes used to process incoming streaming requests sent over an [IStreamingTransport](xref:botframework-streaming.IStreamingTransport).
 */ var RequestHandler = /** @class */ function() {
                    function RequestHandler() {}
                    return RequestHandler;
                }();
                exports.RequestHandler = RequestHandler;
            },
            {}
        ],
        25: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamingRequest = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var httpContentStream_1 = require("./httpContentStream");
                var subscribableStream_1 = require("./subscribableStream");
                /**
 * The basic request type sent over Bot Framework Protocol 3 with Streaming Extensions transports, equivalent to HTTP request messages.
 */ var StreamingRequest = /** @class */ function() {
                    function StreamingRequest() {
                        /**
         * List of associated streams.
         */ this.streams = [];
                    }
                    /**
     * Creates a streaming request with the passed in method, path, and body.
     *
     * @param method The HTTP verb to use for this request.
     * @param path Optional path where the resource can be found on the remote server.
     * @param body Optional body to send to the remote server.
     * @returns On success returns a streaming request with appropriate status code and body.
     */ StreamingRequest.create = function(method, path, body) {
                        var request = new StreamingRequest();
                        request.verb = method;
                        request.path = path;
                        if (body) request.setBody(body);
                        return request;
                    };
                    /**
     * Adds a new stream attachment to this streaming request.
     *
     * @param content The Http content to include in the new stream attachment.
     */ StreamingRequest.prototype.addStream = function(content) {
                        if (!content) throw new Error("Argument Undefined Exception: content undefined.");
                        this.streams.push(new httpContentStream_1.HttpContentStream(content));
                    };
                    /**
     * Sets the contents of the body of this streamingRequest.
     *
     * @param body The JSON text to write to the body of the streamingRequest.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                    StreamingRequest.prototype.setBody = function(body) {
                        if (typeof body === "string") {
                            var stream = new subscribableStream_1.SubscribableStream();
                            stream.write(body, "utf8");
                            this.addStream(new httpContentStream_1.HttpContent({
                                type: "application/json; charset=utf-8",
                                contentLength: stream.length
                            }, stream));
                        } else if (typeof body === "object") this.addStream(body);
                    };
                    return StreamingRequest;
                }();
                exports.StreamingRequest = StreamingRequest;
            },
            {
                "./httpContentStream": 8,
                "./subscribableStream": 27
            }
        ],
        26: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamingResponse = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var httpContentStream_1 = require("./httpContentStream");
                var subscribableStream_1 = require("./subscribableStream");
                /**
 * The basic response type sent over Bot Framework Protocol 3 with Streaming Extensions transports, equivalent to HTTP response messages.
 */ var StreamingResponse = /** @class */ function() {
                    function StreamingResponse() {
                        this.streams = [];
                    }
                    /**
     * Creates a streaming response with the passed in method, path, and body.
     *
     * @param statusCode The HTTP verb to use for this request.
     * @param body Optional body containing additional information.
     * @returns A streaming response with the appropriate statuscode and passed in body.
     */ StreamingResponse.create = function(statusCode, body) {
                        var response = new StreamingResponse();
                        response.statusCode = statusCode;
                        if (body) response.addStream(body);
                        return response;
                    };
                    /**
     * Adds a new stream attachment to this streaming request.
     *
     * @param content The Http content to include in the new stream attachment.
     */ StreamingResponse.prototype.addStream = function(content) {
                        this.streams.push(new httpContentStream_1.HttpContentStream(content));
                    };
                    /**
     * Sets the contents of the body of this streaming response.
     *
     * @param body The JSON text to write to the body of the streaming response.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                    StreamingResponse.prototype.setBody = function(body) {
                        var stream = new subscribableStream_1.SubscribableStream();
                        stream.write(JSON.stringify(body), "utf8");
                        this.addStream(new httpContentStream_1.HttpContent({
                            type: "application/json; charset=utf-8",
                            contentLength: stream.length
                        }, stream));
                    };
                    return StreamingResponse;
                }();
                exports.StreamingResponse = StreamingResponse;
            },
            {
                "./httpContentStream": 8,
                "./subscribableStream": 27
            }
        ],
        27: [
            function(require, module, exports) {
                (function(Buffer) {
                    (function() {
                        "use strict";
                        var __extends = this && this.__extends || function() {
                            var extendStatics = function(d, b) {
                                extendStatics = Object.setPrototypeOf || ({
                                    __proto__: []
                                }) instanceof Array && function(d, b) {
                                    d.__proto__ = b;
                                } || function(d, b) {
                                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                };
                                return extendStatics(d, b);
                            };
                            return function(d, b) {
                                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                extendStatics(d, b);
                                function __() {
                                    this.constructor = d;
                                }
                                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                            };
                        }();
                        Object.defineProperty(exports, "__esModule", {
                            value: true
                        });
                        exports.SubscribableStream = void 0;
                        /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var stream_1 = require("stream");
                        /**
 * An extension of `Duplex` that operates in conjunction with a `PayloadAssembler` to convert raw bytes into a consumable form.
 */ var SubscribableStream = /** @class */ function(_super) {
                            __extends(SubscribableStream, _super);
                            /**
     * Initializes a new instance of the [SubscribableStream](xref:botframework-streaming.SubscribableStream) class.
     *
     * @param options The `DuplexOptions` to use when constructing this stream.
     */ function SubscribableStream(options) {
                                var _this = _super.call(this, options) || this;
                                _this.length = 0;
                                _this.bufferList = [];
                                return _this;
                            }
                            /**
     * Writes data to the buffered list.
     * All calls to writable.write() that occur between the time writable._write() is called and the callback is called will cause the written data to be buffered.
     *
     * @param chunk The Buffer to be written.
     * @param _encoding The encoding. Unused in the implementation of Duplex.
     * @param callback Callback for when this chunk of data is flushed.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                            SubscribableStream.prototype._write = function(chunk, _encoding, callback) {
                                var buffer = Buffer.from(chunk);
                                this.bufferList.push(buffer);
                                this.length += chunk.length;
                                if (this._onData) this._onData(buffer);
                                callback();
                            };
                            /**
     * Reads the buffered list.
     * Once the readable._read() method has been called, it will not be called again until more data is pushed through the readable.push() method.
     * Empty data such as empty buffers and strings will not cause readable._read() to be called.
     *
     * @param size Number of bytes to read.
     */ SubscribableStream.prototype._read = function(size) {
                                if (this.bufferList.length === 0) // null signals end of stream
                                this.push(null);
                                else {
                                    var total = 0;
                                    while(total < size && this.bufferList.length > 0){
                                        var buffer = this.bufferList[0];
                                        this.push(buffer);
                                        this.bufferList.splice(0, 1);
                                        total += buffer.length;
                                    }
                                }
                            };
                            /**
     * Subscribes to the stream when receives data.
     *
     * @param onData Callback to be called when onData is executed.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
                            SubscribableStream.prototype.subscribe = function(onData) {
                                this._onData = onData;
                            };
                            return SubscribableStream;
                        }(stream_1.Duplex);
                        exports.SubscribableStream = SubscribableStream;
                    }).call(this);
                }).call(this, require("buffer").Buffer);
            },
            {
                "buffer": 35,
                "stream": 41
            }
        ],
        28: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.generateGuid = void 0;
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var uuid_1 = require("uuid");
                /**
 * Generates an uuid v4 string.
 *
 * @returns An uuidv4 string.
 */ function generateGuid() {
                    return (0, uuid_1.v4)();
                }
                exports.generateGuid = generateGuid;
            },
            {
                "uuid": 58
            }
        ],
        29: [
            function(require, module, exports) {
                "use strict";
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BrowserWebSocket = void 0;
                /**
 * Represents a WebSocket that implements [ISocket](xref:botframework-streaming.ISocket).
 */ var BrowserWebSocket = /** @class */ function() {
                    /**
     * Creates a new instance of the [BrowserWebSocket](xref:botframework-streaming.BrowserWebSocket) class.
     *
     * @param socket The socket object to build this connection on.
     */ function BrowserWebSocket(socket) {
                        if (socket) this.webSocket = socket;
                    }
                    /**
     * Connects to the supporting socket using WebSocket protocol.
     *
     * @param serverAddress The address the server is listening on.
     * @returns A Promise that resolves the websocket is open and rejects if an error is encountered.
     */ BrowserWebSocket.prototype.connect = function(serverAddress) {
                        return __awaiter(this, void 0, void 0, function() {
                            var resolver, rejector;
                            return __generator(this, function(_a) {
                                if (!this.webSocket) this.webSocket = new WebSocket(serverAddress);
                                this.webSocket.onerror = function(e) {
                                    rejector(e);
                                };
                                this.webSocket.onopen = function(e) {
                                    resolver(e);
                                };
                                return [
                                    2 /*return*/ ,
                                    new Promise(function(resolve, reject) {
                                        resolver = resolve;
                                        rejector = reject;
                                    })
                                ];
                            });
                        });
                    };
                    Object.defineProperty(BrowserWebSocket.prototype, "isConnected", {
                        /**
         * Indicates if the [BrowserWebSocket's](xref:botframework-streaming.BrowserWebSocket) underlying websocket is currently connected.
         *
         * @returns `true` if the underlying websocket is ready and availble to send messages, otherwise `false`.
         */ get: function() {
                            return this.webSocket.readyState === 1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Writes a buffer to the socket and sends it.
     *
     * @param buffer The buffer of data to send across the connection.
     */ BrowserWebSocket.prototype.write = function(buffer) {
                        this.webSocket.send(buffer);
                    };
                    /**
     * Close the socket.
     */ BrowserWebSocket.prototype.close = function() {
                        this.webSocket.close();
                    };
                    /**
     * Set the handler for text and binary messages received on the socket.
     *
     * @param handler The callback to handle the "message" event.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    BrowserWebSocket.prototype.setOnMessageHandler = function(handler) {
                        var bufferKey = "buffer";
                        var packets = [];
                        this.webSocket.onmessage = function(evt) {
                            var fileReader = new FileReader();
                            var queueEntry = {
                                buffer: null
                            };
                            packets.push(queueEntry);
                            fileReader.onload = function(e) {
                                var t = e.target;
                                queueEntry[bufferKey] = t.result;
                                if (packets[0] === queueEntry) while(0 < packets.length && packets[0][bufferKey]){
                                    handler(packets[0][bufferKey]);
                                    packets.splice(0, 1);
                                }
                            };
                            fileReader.readAsArrayBuffer(evt.data);
                        };
                    };
                    /**
     * Set the callback to call when encountering errors.
     *
     * @param handler The callback to handle the "error" event.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    BrowserWebSocket.prototype.setOnErrorHandler = function(handler) {
                        this.webSocket.onerror = function(error) {
                            if (error) handler(error);
                        };
                    };
                    /**
     * Set the callback to call when encountering socket closures.
     *
     * @param handler The callback to handle the "close" event.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    BrowserWebSocket.prototype.setOnCloseHandler = function(handler) {
                        this.webSocket.onclose = handler;
                    };
                    return BrowserWebSocket;
                }();
                exports.BrowserWebSocket = BrowserWebSocket;
            },
            {}
        ],
        30: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(g && (g = 0, op[0] && (_ = 0)), _)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WebSocketClient = void 0;
                var browserWebSocket_1 = require("./browserWebSocket");
                var payloadTransport_1 = require("../payloadTransport");
                var protocolAdapter_1 = require("../protocolAdapter");
                var payloads_1 = require("../payloads");
                var webSocketTransport_1 = require("./webSocketTransport");
                /**
 * Web socket based client to be used as streaming transport.
 */ var WebSocketClient = /** @class */ function() {
                    /**
     * Creates a new instance of the [WebSocketClient](xref:botframework-streaming.WebSocketClient) class.
     *
     * @param config For configuring a [WebSocketClient](xref:botframework-streaming.WebSocketClient) instance to communicate with a WebSocket server.
     * @param config.url The URL of the remote server to connect to.
     * @param config.requestHandler The [RequestHandler](xref:botframework-streaming.RequestHandler) used to process incoming messages received by this client.
     * @param config.disconnectionHandler Optional function to handle the disconnection message.
     */ function WebSocketClient(_a) {
                        var url = _a.url, requestHandler = _a.requestHandler, _b = _a.disconnectionHandler, disconnectionHandler = _b === void 0 ? null : _b;
                        this._url = url;
                        this._requestHandler = requestHandler;
                        this._disconnectionHandler = disconnectionHandler;
                        this._requestManager = new payloads_1.RequestManager();
                        this._sender = new payloadTransport_1.PayloadSender();
                        this._sender.disconnected = this.onConnectionDisconnected.bind(this);
                        this._receiver = new payloadTransport_1.PayloadReceiver();
                        this._receiver.disconnected = this.onConnectionDisconnected.bind(this);
                        this._protocolAdapter = new protocolAdapter_1.ProtocolAdapter(this._requestHandler, this._requestManager, this._sender, this._receiver);
                    }
                    /**
     * Establish a connection with no custom headers.
     *
     * @returns A promise that will not resolve until the client stops listening for incoming messages.
     */ WebSocketClient.prototype.connect = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var ws, transport;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        ws = new browserWebSocket_1.BrowserWebSocket();
                                        return [
                                            4 /*yield*/ ,
                                            ws.connect(this._url)
                                        ];
                                    case 1:
                                        _a.sent();
                                        transport = new webSocketTransport_1.WebSocketTransport(ws);
                                        this._sender.connect(transport);
                                        this._receiver.connect(transport);
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Stop this client from listening.
     */ WebSocketClient.prototype.disconnect = function() {
                        this._sender.disconnect(new payloadTransport_1.TransportDisconnectedEvent("Disconnect was called."));
                        this._receiver.disconnect(new payloadTransport_1.TransportDisconnectedEvent("Disconnect was called."));
                    };
                    /**
     * Task used to send data over this client connection.
     *
     * @param request The streaming request to send.
     * @returns A promise that will produce an instance of receive response on completion of the send operation.
     */ WebSocketClient.prototype.send = function(request) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._protocolAdapter.sendRequest(request)
                                ];
                            });
                        });
                    };
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    WebSocketClient.prototype.onConnectionDisconnected = function(sender, args) {
                        // Rejects all pending requests on disconnect.
                        this._requestManager.rejectAllResponses(new Error("Disconnect was called."));
                        if (this._disconnectionHandler != null) {
                            this._disconnectionHandler("Disconnected");
                            return;
                        }
                        throw new Error("Unable to re-connect client to transport for url ".concat(this._url, ". Sender: '").concat(JSON.stringify(sender), "'. Args:' ").concat(JSON.stringify(args)));
                    };
                    return WebSocketClient;
                }();
                exports.WebSocketClient = WebSocketClient;
            },
            {
                "../payloadTransport": 10,
                "../payloads": 16,
                "../protocolAdapter": 23,
                "./browserWebSocket": 29,
                "./webSocketTransport": 32
            }
        ],
        31: [
            function(require, module, exports) {
                "use strict";
                /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WebSocketTransport = exports.WebSocketClient = exports.BrowserWebSocket = void 0;
                var browserWebSocket_1 = require("./browserWebSocket");
                Object.defineProperty(exports, "BrowserWebSocket", {
                    enumerable: true,
                    get: function() {
                        return browserWebSocket_1.BrowserWebSocket;
                    }
                });
                var browserWebSocketClient_1 = require("./browserWebSocketClient");
                Object.defineProperty(exports, "WebSocketClient", {
                    enumerable: true,
                    get: function() {
                        return browserWebSocketClient_1.WebSocketClient;
                    }
                });
                /** @internal */ var webSocketTransport_1 = require("./webSocketTransport");
                Object.defineProperty(exports, "WebSocketTransport", {
                    enumerable: true,
                    get: function() {
                        return webSocketTransport_1.WebSocketTransport;
                    }
                });
            },
            {
                "./browserWebSocket": 29,
                "./browserWebSocketClient": 30,
                "./webSocketTransport": 32
            }
        ],
        32: [
            function(require, module, exports) {
                (function(Buffer) {
                    (function() {
                        "use strict";
                        /**
 * @module botframework-streaming
 */ /**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                            function adopt(value) {
                                return value instanceof P ? value : new P(function(resolve) {
                                    resolve(value);
                                });
                            }
                            return new (P || (P = Promise))(function(resolve, reject) {
                                function fulfilled(value) {
                                    try {
                                        step(generator.next(value));
                                    } catch (e) {
                                        reject(e);
                                    }
                                }
                                function rejected(value) {
                                    try {
                                        step(generator["throw"](value));
                                    } catch (e) {
                                        reject(e);
                                    }
                                }
                                function step(result) {
                                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                                }
                                step((generator = generator.apply(thisArg, _arguments || [])).next());
                            });
                        };
                        var __generator = this && this.__generator || function(thisArg, body) {
                            var _ = {
                                label: 0,
                                sent: function() {
                                    if (t[0] & 1) throw t[1];
                                    return t[1];
                                },
                                trys: [],
                                ops: []
                            }, f, y, t, g;
                            return g = {
                                next: verb(0),
                                "throw": verb(1),
                                "return": verb(2)
                            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                                return this;
                            }), g;
                            function verb(n) {
                                return function(v) {
                                    return step([
                                        n,
                                        v
                                    ]);
                                };
                            }
                            function step(op) {
                                if (f) throw new TypeError("Generator is already executing.");
                                while(g && (g = 0, op[0] && (_ = 0)), _)try {
                                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                                    if (y = 0, t) op = [
                                        op[0] & 2,
                                        t.value
                                    ];
                                    switch(op[0]){
                                        case 0:
                                        case 1:
                                            t = op;
                                            break;
                                        case 4:
                                            _.label++;
                                            return {
                                                value: op[1],
                                                done: false
                                            };
                                        case 5:
                                            _.label++;
                                            y = op[1];
                                            op = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            op = _.ops.pop();
                                            _.trys.pop();
                                            continue;
                                        default:
                                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                                _ = 0;
                                                continue;
                                            }
                                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                                _.label = op[1];
                                                break;
                                            }
                                            if (op[0] === 6 && _.label < t[1]) {
                                                _.label = t[1];
                                                t = op;
                                                break;
                                            }
                                            if (t && _.label < t[2]) {
                                                _.label = t[2];
                                                _.ops.push(op);
                                                break;
                                            }
                                            if (t[2]) _.ops.pop();
                                            _.trys.pop();
                                            continue;
                                    }
                                    op = body.call(thisArg, _);
                                } catch (e) {
                                    op = [
                                        6,
                                        e
                                    ];
                                    y = 0;
                                } finally{
                                    f = t = 0;
                                }
                                if (op[0] & 5) throw op[1];
                                return {
                                    value: op[0] ? op[1] : void 0,
                                    done: true
                                };
                            }
                        };
                        Object.defineProperty(exports, "__esModule", {
                            value: true
                        });
                        exports.WebSocketTransport = void 0;
                        /**
 * Web socket based transport.
 */ var WebSocketTransport = /** @class */ function() {
                            /**
     * Creates a new instance of the [WebSocketTransport](xref:botframework-streaming.WebSocketTransport) class.
     *
     * @param ws The ISocket to build this transport on top of.
     */ function WebSocketTransport(ws) {
                                var _this = this;
                                this.ws = ws;
                                this._queue = [];
                                this._activeOffset = 0;
                                this._activeReceiveCount = 0;
                                this.ws.setOnMessageHandler(function(data) {
                                    _this.onReceive(data);
                                });
                                this.ws.setOnErrorHandler(function(err) {
                                    _this.onError(err);
                                });
                                this.ws.setOnCloseHandler(function() {
                                    _this.onClose();
                                });
                            }
                            /**
     * Sends the given buffer out over the socket's connection.
     *
     * @param buffer The buffered data to send out over the connection.
     * @returns A number indicating the length of the sent data if the data was successfully sent, otherwise 0.
     */ WebSocketTransport.prototype.send = function(buffer) {
                                var _a;
                                if ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.isConnected) {
                                    this.ws.write(buffer);
                                    return buffer.length;
                                }
                                return 0;
                            };
                            Object.defineProperty(WebSocketTransport.prototype, "isConnected", {
                                /**
         * Returns true if the transport is connected to a socket.
         *
         * @returns `true` if the the transport is connected and ready to send data, `false` otherwise.
         */ get: function() {
                                    var _a;
                                    return !!((_a = this.ws) === null || _a === void 0 ? void 0 : _a.isConnected);
                                },
                                enumerable: false,
                                configurable: true
                            });
                            /**
     * Close the socket this transport is connected to.
     */ WebSocketTransport.prototype.close = function() {
                                var _a;
                                if ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.isConnected) this.ws.close();
                            };
                            /**
     * Attempt to receive incoming data from the connected socket.
     *
     * @param count The number of bytes to attempt to receive.
     * @returns A buffer populated with the received data.
     */ WebSocketTransport.prototype.receive = function(count) {
                                return __awaiter(this, void 0, void 0, function() {
                                    var promise;
                                    var _this = this;
                                    return __generator(this, function(_a) {
                                        if (this._activeReceiveResolve) throw new Error("Cannot call receive more than once before it has returned.");
                                        this._activeReceiveCount = count;
                                        promise = new Promise(function(resolve, reject) {
                                            _this._activeReceiveResolve = resolve;
                                            _this._activeReceiveReject = reject;
                                        });
                                        this.trySignalData();
                                        return [
                                            2 /*return*/ ,
                                            promise
                                        ];
                                    });
                                });
                            };
                            /**
     * Sets the transport to attempt to receive incoming data that has not yet arrived.
     *
     * @param data A buffer to store incoming data in.
     */ WebSocketTransport.prototype.onReceive = function(data) {
                                if (this._queue && data && data.byteLength > 0) {
                                    this._queue.push(Buffer.from(data));
                                    this.trySignalData();
                                }
                            };
                            WebSocketTransport.prototype.onClose = function() {
                                if (this._activeReceiveReject) this._activeReceiveReject(new Error("Socket was closed."));
                                this._active = null;
                                this._activeOffset = 0;
                                this._activeReceiveResolve = null;
                                this._activeReceiveReject = null;
                                this._activeReceiveCount = 0;
                                this.ws = null;
                            };
                            WebSocketTransport.prototype.onError = function(err) {
                                if (this._activeReceiveReject) this._activeReceiveReject(err);
                                this.onClose();
                            };
                            WebSocketTransport.prototype.trySignalData = function() {
                                if (this._activeReceiveResolve) {
                                    if (!this._active && this._queue.length > 0) {
                                        this._active = this._queue.shift();
                                        this._activeOffset = 0;
                                    }
                                    if (this._active) {
                                        if (this._activeOffset === 0 && this._active.length === this._activeReceiveCount) {
                                            // can send the entire _active buffer
                                            var buffer = this._active;
                                            this._active = null;
                                            this._activeReceiveResolve(buffer);
                                        } else {
                                            // create a Buffer.from and copy some of the contents into it
                                            var available = Math.min(this._activeReceiveCount, this._active.length - this._activeOffset);
                                            var buffer = Buffer.alloc(available);
                                            this._active.copy(buffer, 0, this._activeOffset, this._activeOffset + available);
                                            this._activeOffset += available;
                                            // if we used all of active, set it to undefined
                                            if (this._activeOffset >= this._active.length) {
                                                this._active = null;
                                                this._activeOffset = 0;
                                            }
                                            this._activeReceiveResolve(buffer);
                                        }
                                        this._activeReceiveCount = 0;
                                        this._activeReceiveReject = null;
                                        this._activeReceiveResolve = null;
                                    }
                                }
                            };
                            return WebSocketTransport;
                        }();
                        exports.WebSocketTransport = WebSocketTransport;
                    }).call(this);
                }).call(this, require("buffer").Buffer);
            },
            {
                "buffer": 35
            }
        ],
        33: [
            function(require, module, exports) {
                "use strict";
                exports.byteLength = byteLength;
                exports.toByteArray = toByteArray;
                exports.fromByteArray = fromByteArray;
                var lookup = [];
                var revLookup = [];
                var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
                var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                for(var i = 0, len = code.length; i < len; ++i){
                    lookup[i] = code[i];
                    revLookup[code.charCodeAt(i)] = i;
                }
                // Support decoding URL-safe base64 strings, as Node.js does.
                // See: https://en.wikipedia.org/wiki/Base64#URL_applications
                revLookup["-".charCodeAt(0)] = 62;
                revLookup["_".charCodeAt(0)] = 63;
                function getLens(b64) {
                    var len = b64.length;
                    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    // Trim off extra bytes after placeholder bytes are found
                    // See: https://github.com/beatgammit/base64-js/issues/42
                    var validLen = b64.indexOf("=");
                    if (validLen === -1) validLen = len;
                    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
                    return [
                        validLen,
                        placeHoldersLen
                    ];
                }
                // base64 is 4/3 + up to two characters of the original data
                function byteLength(b64) {
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function _byteLength(b64, validLen, placeHoldersLen) {
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function toByteArray(b64) {
                    var tmp;
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
                    var curByte = 0;
                    // if there are placeholders, only get up to the last complete 4 chars
                    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
                    var i;
                    for(i = 0; i < len; i += 4){
                        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                        arr[curByte++] = tmp >> 16 & 0xFF;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 2) {
                        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 1) {
                        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    return arr;
                }
                function tripletToBase64(num) {
                    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
                }
                function encodeChunk(uint8, start, end) {
                    var tmp;
                    var output = [];
                    for(var i = start; i < end; i += 3){
                        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
                        output.push(tripletToBase64(tmp));
                    }
                    return output.join("");
                }
                function fromByteArray(uint8) {
                    var tmp;
                    var len = uint8.length;
                    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
                    ;
                    var parts = [];
                    var maxChunkLength = 16383 // must be multiple of 3
                    ;
                    // go through the array every three bytes, we'll deal with trailing stuff later
                    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
                    // pad the end with zeros, but make sure to not forget the extra bytes
                    if (extraBytes === 1) {
                        tmp = uint8[len - 1];
                        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
                    } else if (extraBytes === 2) {
                        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
                    }
                    return parts.join("");
                }
            },
            {}
        ],
        34: [
            function(require, module, exports) {},
            {}
        ],
        35: [
            function(require, module, exports) {
                (function(Buffer) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
                        var base64 = require("base64-js");
                        var ieee754 = require("ieee754");
                        exports.Buffer = Buffer;
                        exports.SlowBuffer = SlowBuffer;
                        exports.INSPECT_MAX_BYTES = 50;
                        var K_MAX_LENGTH = 0x7fffffff;
                        exports.kMaxLength = K_MAX_LENGTH;
                        /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
                        if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                        function typedArraySupport() {
                            // Can typed array instances can be augmented?
                            try {
                                var arr = new Uint8Array(1);
                                arr.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                };
                                return arr.foo() === 42;
                            } catch (e) {
                                return false;
                            }
                        }
                        Object.defineProperty(Buffer.prototype, "parent", {
                            enumerable: true,
                            get: function() {
                                if (!Buffer.isBuffer(this)) return undefined;
                                return this.buffer;
                            }
                        });
                        Object.defineProperty(Buffer.prototype, "offset", {
                            enumerable: true,
                            get: function() {
                                if (!Buffer.isBuffer(this)) return undefined;
                                return this.byteOffset;
                            }
                        });
                        function createBuffer(length) {
                            if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
                            // Return an augmented `Uint8Array` instance
                            var buf = new Uint8Array(length);
                            buf.__proto__ = Buffer.prototype;
                            return buf;
                        }
                        /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
                            // Common case.
                            if (typeof arg === "number") {
                                if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                                return allocUnsafe(arg);
                            }
                            return from(arg, encodingOrOffset, length);
                        }
                        // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
                        if (typeof Symbol !== "undefined" && Symbol.species != null && Buffer[Symbol.species] === Buffer) Object.defineProperty(Buffer, Symbol.species, {
                            value: null,
                            configurable: true,
                            enumerable: false,
                            writable: false
                        });
                        Buffer.poolSize = 8192 // not used by this implementation
                        ;
                        function from(value, encodingOrOffset, length) {
                            if (typeof value === "string") return fromString(value, encodingOrOffset);
                            if (ArrayBuffer.isView(value)) return fromArrayLike(value);
                            if (value == null) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                            if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
                            if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var valueOf = value.valueOf && value.valueOf();
                            if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
                            var b = fromObject(value);
                            if (b) return b;
                            if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                        }
                        /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
                            return from(value, encodingOrOffset, length);
                        };
                        // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
                        // https://github.com/feross/buffer/pull/148
                        Buffer.prototype.__proto__ = Uint8Array.prototype;
                        Buffer.__proto__ = Uint8Array;
                        function assertSize(size) {
                            if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
                            else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                        }
                        function alloc(size, fill, encoding) {
                            assertSize(size);
                            if (size <= 0) return createBuffer(size);
                            if (fill !== undefined) // Only pay attention to encoding if it's a string. This
                            // prevents accidentally sending in a number that would
                            // be interpretted as a start offset.
                            return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
                            return createBuffer(size);
                        }
                        /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
                            return alloc(size, fill, encoding);
                        };
                        function allocUnsafe(size) {
                            assertSize(size);
                            return createBuffer(size < 0 ? 0 : checked(size) | 0);
                        }
                        /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
                            return allocUnsafe(size);
                        };
                        /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
                            return allocUnsafe(size);
                        };
                        function fromString(string, encoding) {
                            if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
                            if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                            var length = byteLength(string, encoding) | 0;
                            var buf = createBuffer(length);
                            var actual = buf.write(string, encoding);
                            if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
                            // cause everything after the first invalid character to be ignored. (e.g.
                            // 'abxxcd' will be treated as 'ab')
                            buf = buf.slice(0, actual);
                            return buf;
                        }
                        function fromArrayLike(array) {
                            var length = array.length < 0 ? 0 : checked(array.length) | 0;
                            var buf = createBuffer(length);
                            for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
                            return buf;
                        }
                        function fromArrayBuffer(array, byteOffset, length) {
                            if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
                            if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
                            var buf;
                            if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
                            else if (length === undefined) buf = new Uint8Array(array, byteOffset);
                            else buf = new Uint8Array(array, byteOffset, length);
                            // Return an augmented `Uint8Array` instance
                            buf.__proto__ = Buffer.prototype;
                            return buf;
                        }
                        function fromObject(obj) {
                            if (Buffer.isBuffer(obj)) {
                                var len = checked(obj.length) | 0;
                                var buf = createBuffer(len);
                                if (buf.length === 0) return buf;
                                obj.copy(buf, 0, 0, len);
                                return buf;
                            }
                            if (obj.length !== undefined) {
                                if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
                                return fromArrayLike(obj);
                            }
                            if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
                        }
                        function checked(length) {
                            // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                            // length is NaN (which is otherwise coerced to zero.)
                            if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
                            return length | 0;
                        }
                        function SlowBuffer(length) {
                            if (+length != length) length = 0;
                            return Buffer.alloc(+length);
                        }
                        Buffer.isBuffer = function isBuffer(b) {
                            return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
                            ;
                        };
                        Buffer.compare = function compare(a, b) {
                            if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
                            if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
                            if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (a === b) return 0;
                            var x = a.length;
                            var y = b.length;
                            for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                                x = a[i];
                                y = b[i];
                                break;
                            }
                            if (x < y) return -1;
                            if (y < x) return 1;
                            return 0;
                        };
                        Buffer.isEncoding = function isEncoding(encoding) {
                            switch(String(encoding).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return true;
                                default:
                                    return false;
                            }
                        };
                        Buffer.concat = function concat(list, length) {
                            if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (list.length === 0) return Buffer.alloc(0);
                            var i;
                            if (length === undefined) {
                                length = 0;
                                for(i = 0; i < list.length; ++i)length += list[i].length;
                            }
                            var buffer = Buffer.allocUnsafe(length);
                            var pos = 0;
                            for(i = 0; i < list.length; ++i){
                                var buf = list[i];
                                if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
                                if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                                buf.copy(buffer, pos);
                                pos += buf.length;
                            }
                            return buffer;
                        };
                        function byteLength(string, encoding) {
                            if (Buffer.isBuffer(string)) return string.length;
                            if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
                            if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
                            var len = string.length;
                            var mustMatch = arguments.length > 2 && arguments[2] === true;
                            if (!mustMatch && len === 0) return 0;
                            // Use a for loop to avoid recursion
                            var loweredCase = false;
                            for(;;)switch(encoding){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return len;
                                case "utf8":
                                case "utf-8":
                                    return utf8ToBytes(string).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return len * 2;
                                case "hex":
                                    return len >>> 1;
                                case "base64":
                                    return base64ToBytes(string).length;
                                default:
                                    if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                                    ;
                                    encoding = ("" + encoding).toLowerCase();
                                    loweredCase = true;
                            }
                        }
                        Buffer.byteLength = byteLength;
                        function slowToString(encoding, start, end) {
                            var loweredCase = false;
                            // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                            // property of a typed array.
                            // This behaves neither like String nor Uint8Array in that we set start/end
                            // to their upper/lower bounds if the value passed is out of range.
                            // undefined is handled specially as per ECMA-262 6th Edition,
                            // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                            if (start === undefined || start < 0) start = 0;
                            // Return early if start > this.length. Done here to prevent potential uint32
                            // coercion fail below.
                            if (start > this.length) return "";
                            if (end === undefined || end > this.length) end = this.length;
                            if (end <= 0) return "";
                            // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
                            end >>>= 0;
                            start >>>= 0;
                            if (end <= start) return "";
                            if (!encoding) encoding = "utf8";
                            while(true)switch(encoding){
                                case "hex":
                                    return hexSlice(this, start, end);
                                case "utf8":
                                case "utf-8":
                                    return utf8Slice(this, start, end);
                                case "ascii":
                                    return asciiSlice(this, start, end);
                                case "latin1":
                                case "binary":
                                    return latin1Slice(this, start, end);
                                case "base64":
                                    return base64Slice(this, start, end);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return utf16leSlice(this, start, end);
                                default:
                                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                                    encoding = (encoding + "").toLowerCase();
                                    loweredCase = true;
                            }
                        }
                        // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
                        // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
                        // reliably in a browserify context because there could be multiple different
                        // copies of the 'buffer' package in use. This method works even for Buffer
                        // instances that were created from another copy of the `buffer` package.
                        // See: https://github.com/feross/buffer/issues/154
                        Buffer.prototype._isBuffer = true;
                        function swap(b, n, m) {
                            var i = b[n];
                            b[n] = b[m];
                            b[m] = i;
                        }
                        Buffer.prototype.swap16 = function swap16() {
                            var len = this.length;
                            if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
                            return this;
                        };
                        Buffer.prototype.swap32 = function swap32() {
                            var len = this.length;
                            if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var i = 0; i < len; i += 4){
                                swap(this, i, i + 3);
                                swap(this, i + 1, i + 2);
                            }
                            return this;
                        };
                        Buffer.prototype.swap64 = function swap64() {
                            var len = this.length;
                            if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var i = 0; i < len; i += 8){
                                swap(this, i, i + 7);
                                swap(this, i + 1, i + 6);
                                swap(this, i + 2, i + 5);
                                swap(this, i + 3, i + 4);
                            }
                            return this;
                        };
                        Buffer.prototype.toString = function toString() {
                            var length = this.length;
                            if (length === 0) return "";
                            if (arguments.length === 0) return utf8Slice(this, 0, length);
                            return slowToString.apply(this, arguments);
                        };
                        Buffer.prototype.toLocaleString = Buffer.prototype.toString;
                        Buffer.prototype.equals = function equals(b) {
                            if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
                            if (this === b) return true;
                            return Buffer.compare(this, b) === 0;
                        };
                        Buffer.prototype.inspect = function inspect() {
                            var str = "";
                            var max = exports.INSPECT_MAX_BYTES;
                            str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
                            if (this.length > max) str += " ... ";
                            return "<Buffer " + str + ">";
                        };
                        Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
                            if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
                            if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
                            if (start === undefined) start = 0;
                            if (end === undefined) end = target ? target.length : 0;
                            if (thisStart === undefined) thisStart = 0;
                            if (thisEnd === undefined) thisEnd = this.length;
                            if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
                            if (thisStart >= thisEnd && start >= end) return 0;
                            if (thisStart >= thisEnd) return -1;
                            if (start >= end) return 1;
                            start >>>= 0;
                            end >>>= 0;
                            thisStart >>>= 0;
                            thisEnd >>>= 0;
                            if (this === target) return 0;
                            var x = thisEnd - thisStart;
                            var y = end - start;
                            var len = Math.min(x, y);
                            var thisCopy = this.slice(thisStart, thisEnd);
                            var targetCopy = target.slice(start, end);
                            for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                                x = thisCopy[i];
                                y = targetCopy[i];
                                break;
                            }
                            if (x < y) return -1;
                            if (y < x) return 1;
                            return 0;
                        };
                        // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
                        // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
                        //
                        // Arguments:
                        // - buffer - a Buffer to search
                        // - val - a string, Buffer, or number
                        // - byteOffset - an index into `buffer`; will be clamped to an int32
                        // - encoding - an optional encoding, relevant is val is a string
                        // - dir - true for indexOf, false for lastIndexOf
                        function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
                            // Empty buffer means no match
                            if (buffer.length === 0) return -1;
                            // Normalize byteOffset
                            if (typeof byteOffset === "string") {
                                encoding = byteOffset;
                                byteOffset = 0;
                            } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
                            else if (byteOffset < -2147483648) byteOffset = -2147483648;
                            byteOffset = +byteOffset // Coerce to Number.
                            ;
                            if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                            byteOffset = dir ? 0 : buffer.length - 1;
                            // Normalize byteOffset: negative offsets start from the end of the buffer
                            if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                            if (byteOffset >= buffer.length) {
                                if (dir) return -1;
                                else byteOffset = buffer.length - 1;
                            } else if (byteOffset < 0) {
                                if (dir) byteOffset = 0;
                                else return -1;
                            }
                            // Normalize val
                            if (typeof val === "string") val = Buffer.from(val, encoding);
                            // Finally, search either indexOf (if dir is true) or lastIndexOf
                            if (Buffer.isBuffer(val)) {
                                // Special case: looking for empty string/buffer always fails
                                if (val.length === 0) return -1;
                                return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                            } else if (typeof val === "number") {
                                val = val & 0xFF // Search for a byte value [0-255]
                                ;
                                if (typeof Uint8Array.prototype.indexOf === "function") {
                                    if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                                    else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                                }
                                return arrayIndexOf(buffer, [
                                    val
                                ], byteOffset, encoding, dir);
                            }
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                            var indexSize = 1;
                            var arrLength = arr.length;
                            var valLength = val.length;
                            if (encoding !== undefined) {
                                encoding = String(encoding).toLowerCase();
                                if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                                    if (arr.length < 2 || val.length < 2) return -1;
                                    indexSize = 2;
                                    arrLength /= 2;
                                    valLength /= 2;
                                    byteOffset /= 2;
                                }
                            }
                            function read(buf, i) {
                                if (indexSize === 1) return buf[i];
                                else return buf.readUInt16BE(i * indexSize);
                            }
                            var i;
                            if (dir) {
                                var foundIndex = -1;
                                for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                                    if (foundIndex === -1) foundIndex = i;
                                    if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                                } else {
                                    if (foundIndex !== -1) i -= i - foundIndex;
                                    foundIndex = -1;
                                }
                            } else {
                                if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                                for(i = byteOffset; i >= 0; i--){
                                    var found = true;
                                    for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                                        found = false;
                                        break;
                                    }
                                    if (found) return i;
                                }
                            }
                            return -1;
                        }
                        Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
                            return this.indexOf(val, byteOffset, encoding) !== -1;
                        };
                        Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
                            return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
                        };
                        Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
                            return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
                        };
                        function hexWrite(buf, string, offset, length) {
                            offset = Number(offset) || 0;
                            var remaining = buf.length - offset;
                            if (!length) length = remaining;
                            else {
                                length = Number(length);
                                if (length > remaining) length = remaining;
                            }
                            var strLen = string.length;
                            if (length > strLen / 2) length = strLen / 2;
                            for(var i = 0; i < length; ++i){
                                var parsed = parseInt(string.substr(i * 2, 2), 16);
                                if (numberIsNaN(parsed)) return i;
                                buf[offset + i] = parsed;
                            }
                            return i;
                        }
                        function utf8Write(buf, string, offset, length) {
                            return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
                        }
                        function asciiWrite(buf, string, offset, length) {
                            return blitBuffer(asciiToBytes(string), buf, offset, length);
                        }
                        function latin1Write(buf, string, offset, length) {
                            return asciiWrite(buf, string, offset, length);
                        }
                        function base64Write(buf, string, offset, length) {
                            return blitBuffer(base64ToBytes(string), buf, offset, length);
                        }
                        function ucs2Write(buf, string, offset, length) {
                            return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
                        }
                        Buffer.prototype.write = function write(string, offset, length, encoding) {
                            // Buffer#write(string)
                            if (offset === undefined) {
                                encoding = "utf8";
                                length = this.length;
                                offset = 0;
                            // Buffer#write(string, encoding)
                            } else if (length === undefined && typeof offset === "string") {
                                encoding = offset;
                                length = this.length;
                                offset = 0;
                            // Buffer#write(string, offset[, length][, encoding])
                            } else if (isFinite(offset)) {
                                offset = offset >>> 0;
                                if (isFinite(length)) {
                                    length = length >>> 0;
                                    if (encoding === undefined) encoding = "utf8";
                                } else {
                                    encoding = length;
                                    length = undefined;
                                }
                            } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                            var remaining = this.length - offset;
                            if (length === undefined || length > remaining) length = remaining;
                            if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            if (!encoding) encoding = "utf8";
                            var loweredCase = false;
                            for(;;)switch(encoding){
                                case "hex":
                                    return hexWrite(this, string, offset, length);
                                case "utf8":
                                case "utf-8":
                                    return utf8Write(this, string, offset, length);
                                case "ascii":
                                    return asciiWrite(this, string, offset, length);
                                case "latin1":
                                case "binary":
                                    return latin1Write(this, string, offset, length);
                                case "base64":
                                    // Warning: maxLength not taken into account in base64Write
                                    return base64Write(this, string, offset, length);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return ucs2Write(this, string, offset, length);
                                default:
                                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                                    encoding = ("" + encoding).toLowerCase();
                                    loweredCase = true;
                            }
                        };
                        Buffer.prototype.toJSON = function toJSON() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function base64Slice(buf, start, end) {
                            if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
                            else return base64.fromByteArray(buf.slice(start, end));
                        }
                        function utf8Slice(buf, start, end) {
                            end = Math.min(buf.length, end);
                            var res = [];
                            var i = start;
                            while(i < end){
                                var firstByte = buf[i];
                                var codePoint = null;
                                var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
                                if (i + bytesPerSequence <= end) {
                                    var secondByte, thirdByte, fourthByte, tempCodePoint;
                                    switch(bytesPerSequence){
                                        case 1:
                                            if (firstByte < 0x80) codePoint = firstByte;
                                            break;
                                        case 2:
                                            secondByte = buf[i + 1];
                                            if ((secondByte & 0xC0) === 0x80) {
                                                tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                                                if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                                            }
                                            break;
                                        case 3:
                                            secondByte = buf[i + 1];
                                            thirdByte = buf[i + 2];
                                            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                                                tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                                                if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                                            }
                                            break;
                                        case 4:
                                            secondByte = buf[i + 1];
                                            thirdByte = buf[i + 2];
                                            fourthByte = buf[i + 3];
                                            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                                                tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                                                if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                                            }
                                    }
                                }
                                if (codePoint === null) {
                                    // we did not generate a valid codePoint so insert a
                                    // replacement char (U+FFFD) and advance only 1 byte
                                    codePoint = 0xFFFD;
                                    bytesPerSequence = 1;
                                } else if (codePoint > 0xFFFF) {
                                    // encode to utf16 (surrogate pair dance)
                                    codePoint -= 0x10000;
                                    res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                                    codePoint = 0xDC00 | codePoint & 0x3FF;
                                }
                                res.push(codePoint);
                                i += bytesPerSequence;
                            }
                            return decodeCodePointsArray(res);
                        }
                        // Based on http://stackoverflow.com/a/22747272/680742, the browser with
                        // the lowest limit is Chrome, with 0x10000 args.
                        // We go 1 magnitude less, for safety
                        var MAX_ARGUMENTS_LENGTH = 0x1000;
                        function decodeCodePointsArray(codePoints) {
                            var len = codePoints.length;
                            if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
                            ;
                            // Decode in chunks to avoid "call stack size exceeded".
                            var res = "";
                            var i = 0;
                            while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
                            return res;
                        }
                        function asciiSlice(buf, start, end) {
                            var ret = "";
                            end = Math.min(buf.length, end);
                            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
                            return ret;
                        }
                        function latin1Slice(buf, start, end) {
                            var ret = "";
                            end = Math.min(buf.length, end);
                            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
                            return ret;
                        }
                        function hexSlice(buf, start, end) {
                            var len = buf.length;
                            if (!start || start < 0) start = 0;
                            if (!end || end < 0 || end > len) end = len;
                            var out = "";
                            for(var i = start; i < end; ++i)out += toHex(buf[i]);
                            return out;
                        }
                        function utf16leSlice(buf, start, end) {
                            var bytes = buf.slice(start, end);
                            var res = "";
                            for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                            return res;
                        }
                        Buffer.prototype.slice = function slice(start, end) {
                            var len = this.length;
                            start = ~~start;
                            end = end === undefined ? len : ~~end;
                            if (start < 0) {
                                start += len;
                                if (start < 0) start = 0;
                            } else if (start > len) start = len;
                            if (end < 0) {
                                end += len;
                                if (end < 0) end = 0;
                            } else if (end > len) end = len;
                            if (end < start) end = start;
                            var newBuf = this.subarray(start, end);
                            // Return an augmented `Uint8Array` instance
                            newBuf.__proto__ = Buffer.prototype;
                            return newBuf;
                        };
                        /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
                            if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
                            if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
                        }
                        Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var val = this[offset];
                            var mul = 1;
                            var i = 0;
                            while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                            return val;
                        };
                        Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var val = this[offset + --byteLength];
                            var mul = 1;
                            while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
                            return val;
                        };
                        Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 1, this.length);
                            return this[offset];
                        };
                        Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            return this[offset] | this[offset + 1] << 8;
                        };
                        Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            return this[offset] << 8 | this[offset + 1];
                        };
                        Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
                        };
                        Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
                        };
                        Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var val = this[offset];
                            var mul = 1;
                            var i = 0;
                            while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                            mul *= 0x80;
                            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                            return val;
                        };
                        Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) checkOffset(offset, byteLength, this.length);
                            var i = byteLength;
                            var mul = 1;
                            var val = this[offset + --i];
                            while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
                            mul *= 0x80;
                            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                            return val;
                        };
                        Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 1, this.length);
                            if (!(this[offset] & 0x80)) return this[offset];
                            return (0xff - this[offset] + 1) * -1;
                        };
                        Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            var val = this[offset] | this[offset + 1] << 8;
                            return val & 0x8000 ? val | 0xFFFF0000 : val;
                        };
                        Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 2, this.length);
                            var val = this[offset + 1] | this[offset] << 8;
                            return val & 0x8000 ? val | 0xFFFF0000 : val;
                        };
                        Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
                        };
                        Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
                        };
                        Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return ieee754.read(this, offset, true, 23, 4);
                        };
                        Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 4, this.length);
                            return ieee754.read(this, offset, false, 23, 4);
                        };
                        Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 8, this.length);
                            return ieee754.read(this, offset, true, 52, 8);
                        };
                        Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
                            offset = offset >>> 0;
                            if (!noAssert) checkOffset(offset, 8, this.length);
                            return ieee754.read(this, offset, false, 52, 8);
                        };
                        function checkInt(buf, value, offset, ext, max, min) {
                            if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
                            if (offset + ext > buf.length) throw new RangeError("Index out of range");
                        }
                        Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) {
                                var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                                checkInt(this, value, offset, byteLength, maxBytes, 0);
                            }
                            var mul = 1;
                            var i = 0;
                            this[offset] = value & 0xFF;
                            while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            byteLength = byteLength >>> 0;
                            if (!noAssert) {
                                var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                                checkInt(this, value, offset, byteLength, maxBytes, 0);
                            }
                            var i = byteLength - 1;
                            var mul = 1;
                            this[offset + i] = value & 0xFF;
                            while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                            this[offset] = value & 0xff;
                            return offset + 1;
                        };
                        Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                            this[offset] = value & 0xff;
                            this[offset + 1] = value >>> 8;
                            return offset + 2;
                        };
                        Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                            this[offset] = value >>> 8;
                            this[offset + 1] = value & 0xff;
                            return offset + 2;
                        };
                        Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                            this[offset + 3] = value >>> 24;
                            this[offset + 2] = value >>> 16;
                            this[offset + 1] = value >>> 8;
                            this[offset] = value & 0xff;
                            return offset + 4;
                        };
                        Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                            this[offset] = value >>> 24;
                            this[offset + 1] = value >>> 16;
                            this[offset + 2] = value >>> 8;
                            this[offset + 3] = value & 0xff;
                            return offset + 4;
                        };
                        Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) {
                                var limit = Math.pow(2, 8 * byteLength - 1);
                                checkInt(this, value, offset, byteLength, limit - 1, -limit);
                            }
                            var i = 0;
                            var mul = 1;
                            var sub = 0;
                            this[offset] = value & 0xFF;
                            while(++i < byteLength && (mul *= 0x100)){
                                if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                                this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                            }
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) {
                                var limit = Math.pow(2, 8 * byteLength - 1);
                                checkInt(this, value, offset, byteLength, limit - 1, -limit);
                            }
                            var i = byteLength - 1;
                            var mul = 1;
                            var sub = 0;
                            this[offset + i] = value & 0xFF;
                            while(--i >= 0 && (mul *= 0x100)){
                                if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                                this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                            }
                            return offset + byteLength;
                        };
                        Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
                            if (value < 0) value = 0xff + value + 1;
                            this[offset] = value & 0xff;
                            return offset + 1;
                        };
                        Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                            this[offset] = value & 0xff;
                            this[offset + 1] = value >>> 8;
                            return offset + 2;
                        };
                        Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                            this[offset] = value >>> 8;
                            this[offset + 1] = value & 0xff;
                            return offset + 2;
                        };
                        Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                            this[offset] = value & 0xff;
                            this[offset + 1] = value >>> 8;
                            this[offset + 2] = value >>> 16;
                            this[offset + 3] = value >>> 24;
                            return offset + 4;
                        };
                        Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                            if (value < 0) value = 0xffffffff + value + 1;
                            this[offset] = value >>> 24;
                            this[offset + 1] = value >>> 16;
                            this[offset + 2] = value >>> 8;
                            this[offset + 3] = value & 0xff;
                            return offset + 4;
                        };
                        function checkIEEE754(buf, value, offset, ext, max, min) {
                            if (offset + ext > buf.length) throw new RangeError("Index out of range");
                            if (offset < 0) throw new RangeError("Index out of range");
                        }
                        function writeFloat(buf, value, offset, littleEndian, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
                            ieee754.write(buf, value, offset, littleEndian, 23, 4);
                            return offset + 4;
                        }
                        Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
                            return writeFloat(this, value, offset, true, noAssert);
                        };
                        Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
                            return writeFloat(this, value, offset, false, noAssert);
                        };
                        function writeDouble(buf, value, offset, littleEndian, noAssert) {
                            value = +value;
                            offset = offset >>> 0;
                            if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
                            ieee754.write(buf, value, offset, littleEndian, 52, 8);
                            return offset + 8;
                        }
                        Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
                            return writeDouble(this, value, offset, true, noAssert);
                        };
                        Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
                            return writeDouble(this, value, offset, false, noAssert);
                        };
                        // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
                        Buffer.prototype.copy = function copy(target, targetStart, start, end) {
                            if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
                            if (!start) start = 0;
                            if (!end && end !== 0) end = this.length;
                            if (targetStart >= target.length) targetStart = target.length;
                            if (!targetStart) targetStart = 0;
                            if (end > 0 && end < start) end = start;
                            // Copy 0 bytes; we're done
                            if (end === start) return 0;
                            if (target.length === 0 || this.length === 0) return 0;
                            // Fatal error conditions
                            if (targetStart < 0) throw new RangeError("targetStart out of bounds");
                            if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
                            if (end < 0) throw new RangeError("sourceEnd out of bounds");
                            // Are we oob?
                            if (end > this.length) end = this.length;
                            if (target.length - targetStart < end - start) end = target.length - targetStart + start;
                            var len = end - start;
                            if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
                            this.copyWithin(targetStart, start, end);
                            else if (this === target && start < targetStart && targetStart < end) // descending copy from end
                            for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
                            else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
                            return len;
                        };
                        // Usage:
                        //    buffer.fill(number[, offset[, end]])
                        //    buffer.fill(buffer[, offset[, end]])
                        //    buffer.fill(string[, offset[, end]][, encoding])
                        Buffer.prototype.fill = function fill(val, start, end, encoding) {
                            // Handle string cases:
                            if (typeof val === "string") {
                                if (typeof start === "string") {
                                    encoding = start;
                                    start = 0;
                                    end = this.length;
                                } else if (typeof end === "string") {
                                    encoding = end;
                                    end = this.length;
                                }
                                if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
                                if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                                if (val.length === 1) {
                                    var code = val.charCodeAt(0);
                                    if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
                                    val = code;
                                }
                            } else if (typeof val === "number") val = val & 255;
                            // Invalid ranges are not set to a default, so can range check early.
                            if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
                            if (end <= start) return this;
                            start = start >>> 0;
                            end = end === undefined ? this.length : end >>> 0;
                            if (!val) val = 0;
                            var i;
                            if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
                            else {
                                var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
                                var len = bytes.length;
                                if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                                for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
                            }
                            return this;
                        };
                        // HELPER FUNCTIONS
                        // ================
                        var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
                        function base64clean(str) {
                            // Node takes equal signs as end of the Base64 encoding
                            str = str.split("=")[0];
                            // Node strips out invalid characters like \n and \t from the string, base64-js does not
                            str = str.trim().replace(INVALID_BASE64_RE, "");
                            // Node converts strings with length < 2 to ''
                            if (str.length < 2) return "";
                            // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                            while(str.length % 4 !== 0)str = str + "=";
                            return str;
                        }
                        function toHex(n) {
                            if (n < 16) return "0" + n.toString(16);
                            return n.toString(16);
                        }
                        function utf8ToBytes(string, units) {
                            units = units || Infinity;
                            var codePoint;
                            var length = string.length;
                            var leadSurrogate = null;
                            var bytes = [];
                            for(var i = 0; i < length; ++i){
                                codePoint = string.charCodeAt(i);
                                // is surrogate component
                                if (codePoint > 0xD7FF && codePoint < 0xE000) {
                                    // last char was a lead
                                    if (!leadSurrogate) {
                                        // no lead yet
                                        if (codePoint > 0xDBFF) {
                                            // unexpected trail
                                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                            continue;
                                        } else if (i + 1 === length) {
                                            // unpaired lead
                                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                            continue;
                                        }
                                        // valid lead
                                        leadSurrogate = codePoint;
                                        continue;
                                    }
                                    // 2 leads in a row
                                    if (codePoint < 0xDC00) {
                                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                        leadSurrogate = codePoint;
                                        continue;
                                    }
                                    // valid surrogate pair
                                    codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
                                } else if (leadSurrogate) // valid bmp char, but last char was a lead
                                {
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                }
                                leadSurrogate = null;
                                // encode utf8
                                if (codePoint < 0x80) {
                                    if ((units -= 1) < 0) break;
                                    bytes.push(codePoint);
                                } else if (codePoint < 0x800) {
                                    if ((units -= 2) < 0) break;
                                    bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                                } else if (codePoint < 0x10000) {
                                    if ((units -= 3) < 0) break;
                                    bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                                } else if (codePoint < 0x110000) {
                                    if ((units -= 4) < 0) break;
                                    bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                                } else throw new Error("Invalid code point");
                            }
                            return bytes;
                        }
                        function asciiToBytes(str) {
                            var byteArray = [];
                            for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
                            byteArray.push(str.charCodeAt(i) & 0xFF);
                            return byteArray;
                        }
                        function utf16leToBytes(str, units) {
                            var c, hi, lo;
                            var byteArray = [];
                            for(var i = 0; i < str.length; ++i){
                                if ((units -= 2) < 0) break;
                                c = str.charCodeAt(i);
                                hi = c >> 8;
                                lo = c % 256;
                                byteArray.push(lo);
                                byteArray.push(hi);
                            }
                            return byteArray;
                        }
                        function base64ToBytes(str) {
                            return base64.toByteArray(base64clean(str));
                        }
                        function blitBuffer(src, dst, offset, length) {
                            for(var i = 0; i < length; ++i){
                                if (i + offset >= dst.length || i >= src.length) break;
                                dst[i + offset] = src[i];
                            }
                            return i;
                        }
                        // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
                        // the `instanceof` check but they should be treated as of that type.
                        // See: https://github.com/feross/buffer/issues/166
                        function isInstance(obj, type) {
                            return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
                        }
                        function numberIsNaN(obj) {
                            // For IE11 support
                            return obj !== obj // eslint-disable-line no-self-compare
                            ;
                        }
                    }).call(this);
                }).call(this, require("buffer").Buffer);
            },
            {
                "base64-js": 33,
                "buffer": 35,
                "ieee754": 37
            }
        ],
        36: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                "use strict";
                var R = typeof Reflect === "object" ? Reflect : null;
                var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
                    return Function.prototype.apply.call(target, receiver, args);
                };
                var ReflectOwnKeys;
                if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
                else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
                };
                else ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target);
                };
                function ProcessEmitWarning(warning) {
                    if (console && console.warn) console.warn(warning);
                }
                var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
                    return value !== value;
                };
                function EventEmitter() {
                    EventEmitter.init.call(this);
                }
                module.exports = EventEmitter;
                module.exports.once = once;
                // Backwards-compat with node 0.10.x
                EventEmitter.EventEmitter = EventEmitter;
                EventEmitter.prototype._events = undefined;
                EventEmitter.prototype._eventsCount = 0;
                EventEmitter.prototype._maxListeners = undefined;
                // By default EventEmitters will print a warning if more than 10 listeners are
                // added to it. This is a useful default which helps finding memory leaks.
                var defaultMaxListeners = 10;
                function checkListener(listener) {
                    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
                }
                Object.defineProperty(EventEmitter, "defaultMaxListeners", {
                    enumerable: true,
                    get: function() {
                        return defaultMaxListeners;
                    },
                    set: function(arg) {
                        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
                        defaultMaxListeners = arg;
                    }
                });
                EventEmitter.init = function() {
                    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                    }
                    this._maxListeners = this._maxListeners || undefined;
                };
                // Obviously not all Emitters should be limited to 10. This function allows
                // that to be increased. Set to zero for unlimited.
                EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
                    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
                    this._maxListeners = n;
                    return this;
                };
                function _getMaxListeners(that) {
                    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
                    return that._maxListeners;
                }
                EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
                    return _getMaxListeners(this);
                };
                EventEmitter.prototype.emit = function emit(type) {
                    var args = [];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    var doError = type === "error";
                    var events = this._events;
                    if (events !== undefined) doError = doError && events.error === undefined;
                    else if (!doError) return false;
                    // If there is no 'error' event listener then throw.
                    if (doError) {
                        var er;
                        if (args.length > 0) er = args[0];
                        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
                        // up in Node's output if this results in an unhandled exception.
                        throw er; // Unhandled 'error' event
                        // At least give some kind of context to the user
                        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
                        err.context = er;
                        throw err; // Unhandled 'error' event
                    }
                    var handler = events[type];
                    if (handler === undefined) return false;
                    if (typeof handler === "function") ReflectApply(handler, this, args);
                    else {
                        var len = handler.length;
                        var listeners = arrayClone(handler, len);
                        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
                    }
                    return true;
                };
                function _addListener(target, type, listener, prepend) {
                    var m;
                    var events;
                    var existing;
                    checkListener(listener);
                    events = target._events;
                    if (events === undefined) {
                        events = target._events = Object.create(null);
                        target._eventsCount = 0;
                    } else {
                        // To avoid recursion in the case that type === "newListener"! Before
                        // adding it to the listeners, first emit "newListener".
                        if (events.newListener !== undefined) {
                            target.emit("newListener", type, listener.listener ? listener.listener : listener);
                            // Re-assign `events` because a newListener handler could have caused the
                            // this._events to be assigned to a new object
                            events = target._events;
                        }
                        existing = events[type];
                    }
                    if (existing === undefined) {
                        // Optimize the case of one listener. Don't need the extra array object.
                        existing = events[type] = listener;
                        ++target._eventsCount;
                    } else {
                        if (typeof existing === "function") // Adding the second element, need to change to array.
                        existing = events[type] = prepend ? [
                            listener,
                            existing
                        ] : [
                            existing,
                            listener
                        ];
                        else if (prepend) existing.unshift(listener);
                        else existing.push(listener);
                        // Check for listener leak
                        m = _getMaxListeners(target);
                        if (m > 0 && existing.length > m && !existing.warned) {
                            existing.warned = true;
                            // No error code for this since it is a Warning
                            // eslint-disable-next-line no-restricted-syntax
                            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
                            w.name = "MaxListenersExceededWarning";
                            w.emitter = target;
                            w.type = type;
                            w.count = existing.length;
                            ProcessEmitWarning(w);
                        }
                    }
                    return target;
                }
                EventEmitter.prototype.addListener = function addListener(type, listener) {
                    return _addListener(this, type, listener, false);
                };
                EventEmitter.prototype.on = EventEmitter.prototype.addListener;
                EventEmitter.prototype.prependListener = function prependListener(type, listener) {
                    return _addListener(this, type, listener, true);
                };
                function onceWrapper() {
                    if (!this.fired) {
                        this.target.removeListener(this.type, this.wrapFn);
                        this.fired = true;
                        if (arguments.length === 0) return this.listener.call(this.target);
                        return this.listener.apply(this.target, arguments);
                    }
                }
                function _onceWrap(target, type, listener) {
                    var state = {
                        fired: false,
                        wrapFn: undefined,
                        target: target,
                        type: type,
                        listener: listener
                    };
                    var wrapped = onceWrapper.bind(state);
                    wrapped.listener = listener;
                    state.wrapFn = wrapped;
                    return wrapped;
                }
                EventEmitter.prototype.once = function once(type, listener) {
                    checkListener(listener);
                    this.on(type, _onceWrap(this, type, listener));
                    return this;
                };
                EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
                    checkListener(listener);
                    this.prependListener(type, _onceWrap(this, type, listener));
                    return this;
                };
                // Emits a 'removeListener' event if and only if the listener was removed.
                EventEmitter.prototype.removeListener = function removeListener(type, listener) {
                    var list, events, position, i, originalListener;
                    checkListener(listener);
                    events = this._events;
                    if (events === undefined) return this;
                    list = events[type];
                    if (list === undefined) return this;
                    if (list === listener || list.listener === listener) {
                        if (--this._eventsCount === 0) this._events = Object.create(null);
                        else {
                            delete events[type];
                            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
                        }
                    } else if (typeof list !== "function") {
                        position = -1;
                        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                            originalListener = list[i].listener;
                            position = i;
                            break;
                        }
                        if (position < 0) return this;
                        if (position === 0) list.shift();
                        else spliceOne(list, position);
                        if (list.length === 1) events[type] = list[0];
                        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
                    }
                    return this;
                };
                EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
                EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
                    var listeners, events, i;
                    events = this._events;
                    if (events === undefined) return this;
                    // not listening for removeListener, no need to emit
                    if (events.removeListener === undefined) {
                        if (arguments.length === 0) {
                            this._events = Object.create(null);
                            this._eventsCount = 0;
                        } else if (events[type] !== undefined) {
                            if (--this._eventsCount === 0) this._events = Object.create(null);
                            else delete events[type];
                        }
                        return this;
                    }
                    // emit removeListener for all listeners on all events
                    if (arguments.length === 0) {
                        var keys = Object.keys(events);
                        var key;
                        for(i = 0; i < keys.length; ++i){
                            key = keys[i];
                            if (key === "removeListener") continue;
                            this.removeAllListeners(key);
                        }
                        this.removeAllListeners("removeListener");
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                        return this;
                    }
                    listeners = events[type];
                    if (typeof listeners === "function") this.removeListener(type, listeners);
                    else if (listeners !== undefined) // LIFO order
                    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
                    return this;
                };
                function _listeners(target, type, unwrap) {
                    var events = target._events;
                    if (events === undefined) return [];
                    var evlistener = events[type];
                    if (evlistener === undefined) return [];
                    if (typeof evlistener === "function") return unwrap ? [
                        evlistener.listener || evlistener
                    ] : [
                        evlistener
                    ];
                    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
                }
                EventEmitter.prototype.listeners = function listeners(type) {
                    return _listeners(this, type, true);
                };
                EventEmitter.prototype.rawListeners = function rawListeners(type) {
                    return _listeners(this, type, false);
                };
                EventEmitter.listenerCount = function(emitter, type) {
                    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
                    else return listenerCount.call(emitter, type);
                };
                EventEmitter.prototype.listenerCount = listenerCount;
                function listenerCount(type) {
                    var events = this._events;
                    if (events !== undefined) {
                        var evlistener = events[type];
                        if (typeof evlistener === "function") return 1;
                        else if (evlistener !== undefined) return evlistener.length;
                    }
                    return 0;
                }
                EventEmitter.prototype.eventNames = function eventNames() {
                    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
                };
                function arrayClone(arr, n) {
                    var copy = new Array(n);
                    for(var i = 0; i < n; ++i)copy[i] = arr[i];
                    return copy;
                }
                function spliceOne(list, index) {
                    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
                    list.pop();
                }
                function unwrapListeners(arr) {
                    var ret = new Array(arr.length);
                    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
                    return ret;
                }
                function once(emitter, name) {
                    return new Promise(function(resolve, reject) {
                        function eventListener() {
                            if (errorListener !== undefined) emitter.removeListener("error", errorListener);
                            resolve([].slice.call(arguments));
                        }
                        var errorListener;
                        // Adding an error listener is not optional because
                        // if an error is thrown on an event emitter we cannot
                        // guarantee that the actual event we are waiting will
                        // be fired. The result could be a silent way to create
                        // memory or file descriptor leaks, which is something
                        // we should avoid.
                        if (name !== "error") {
                            errorListener = function errorListener(err) {
                                emitter.removeListener(name, eventListener);
                                reject(err);
                            };
                            emitter.once("error", errorListener);
                        }
                        emitter.once(name, eventListener);
                    });
                }
            },
            {}
        ],
        37: [
            function(require, module, exports) {
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
                    var e, m;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var nBits = -7;
                    var i = isLE ? nBytes - 1 : 0;
                    var d = isLE ? -1 : 1;
                    var s = buffer[offset + i];
                    i += d;
                    e = s & (1 << -nBits) - 1;
                    s >>= -nBits;
                    nBits += eLen;
                    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
                    m = e & (1 << -nBits) - 1;
                    e >>= -nBits;
                    nBits += mLen;
                    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
                    if (e === 0) e = 1 - eBias;
                    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
                    else {
                        m = m + Math.pow(2, mLen);
                        e = e - eBias;
                    }
                    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
                };
                exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
                    var e, m, c;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
                    var i = isLE ? 0 : nBytes - 1;
                    var d = isLE ? 1 : -1;
                    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                    value = Math.abs(value);
                    if (isNaN(value) || value === Infinity) {
                        m = isNaN(value) ? 1 : 0;
                        e = eMax;
                    } else {
                        e = Math.floor(Math.log(value) / Math.LN2);
                        if (value * (c = Math.pow(2, -e)) < 1) {
                            e--;
                            c *= 2;
                        }
                        if (e + eBias >= 1) value += rt / c;
                        else value += rt * Math.pow(2, 1 - eBias);
                        if (value * c >= 2) {
                            e++;
                            c /= 2;
                        }
                        if (e + eBias >= eMax) {
                            m = 0;
                            e = eMax;
                        } else if (e + eBias >= 1) {
                            m = (value * c - 1) * Math.pow(2, mLen);
                            e = e + eBias;
                        } else {
                            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                            e = 0;
                        }
                    }
                    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
                    e = e << mLen | m;
                    eLen += mLen;
                    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
                    buffer[offset + i - d] |= s * 128;
                };
            },
            {}
        ],
        38: [
            function(require, module, exports) {
                if (typeof Object.create === "function") // implementation from standard node.js 'util' module
                module.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        ctor.prototype = Object.create(superCtor.prototype, {
                            constructor: {
                                value: ctor,
                                enumerable: false,
                                writable: true,
                                configurable: true
                            }
                        });
                    }
                };
                else // old school shim for old browsers
                module.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        var TempCtor = function() {};
                        TempCtor.prototype = superCtor.prototype;
                        ctor.prototype = new TempCtor();
                        ctor.prototype.constructor = ctor;
                    }
                };
            },
            {}
        ],
        39: [
            function(require, module, exports) {
                // shim for using process in browser
                var process = module.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error("setTimeout has not been defined");
                }
                function defaultClearTimeout() {
                    throw new Error("clearTimeout has not been defined");
                }
                (function() {
                    try {
                        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ""; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error("process.binding is not supported");
                };
                process.cwd = function() {
                    return "/";
                };
                process.chdir = function(dir) {
                    throw new Error("process.chdir is not supported");
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        40: [
            function(require, module, exports) {
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("buffer");
                var Buffer = buffer.Buffer;
                // alternative to using Object.keys for old browsers
                function copyProps(src, dst) {
                    for(var key in src)dst[key] = src[key];
                }
                if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
                else {
                    // Copy properties from require('buffer')
                    copyProps(buffer, exports);
                    exports.Buffer = SafeBuffer;
                }
                function SafeBuffer(arg, encodingOrOffset, length) {
                    return Buffer(arg, encodingOrOffset, length);
                }
                SafeBuffer.prototype = Object.create(Buffer.prototype);
                // Copy static methods from Buffer
                copyProps(Buffer, SafeBuffer);
                SafeBuffer.from = function(arg, encodingOrOffset, length) {
                    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
                    return Buffer(arg, encodingOrOffset, length);
                };
                SafeBuffer.alloc = function(size, fill, encoding) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    var buf = Buffer(size);
                    if (fill !== undefined) {
                        if (typeof encoding === "string") buf.fill(fill, encoding);
                        else buf.fill(fill);
                    } else buf.fill(0);
                    return buf;
                };
                SafeBuffer.allocUnsafe = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return Buffer(size);
                };
                SafeBuffer.allocUnsafeSlow = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return buffer.SlowBuffer(size);
                };
            },
            {
                "buffer": 35
            }
        ],
        41: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                module.exports = Stream;
                var EE = require("events").EventEmitter;
                var inherits = require("inherits");
                inherits(Stream, EE);
                Stream.Readable = require("readable-stream/lib/_stream_readable.js");
                Stream.Writable = require("readable-stream/lib/_stream_writable.js");
                Stream.Duplex = require("readable-stream/lib/_stream_duplex.js");
                Stream.Transform = require("readable-stream/lib/_stream_transform.js");
                Stream.PassThrough = require("readable-stream/lib/_stream_passthrough.js");
                Stream.finished = require("readable-stream/lib/internal/streams/end-of-stream.js");
                Stream.pipeline = require("readable-stream/lib/internal/streams/pipeline.js");
                // Backwards-compat with node 0.4.x
                Stream.Stream = Stream;
                // old-style streams.  Note that the pipe method (the only relevant
                // part of this class) is overridden in the Readable class.
                function Stream() {
                    EE.call(this);
                }
                Stream.prototype.pipe = function(dest, options) {
                    var source = this;
                    function ondata(chunk) {
                        if (dest.writable) {
                            if (false === dest.write(chunk) && source.pause) source.pause();
                        }
                    }
                    source.on("data", ondata);
                    function ondrain() {
                        if (source.readable && source.resume) source.resume();
                    }
                    dest.on("drain", ondrain);
                    // If the 'end' option is not supplied, dest.end() will be called when
                    // source gets the 'end' or 'close' events.  Only dest.end() once.
                    if (!dest._isStdio && (!options || options.end !== false)) {
                        source.on("end", onend);
                        source.on("close", onclose);
                    }
                    var didOnEnd = false;
                    function onend() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        dest.end();
                    }
                    function onclose() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        if (typeof dest.destroy === "function") dest.destroy();
                    }
                    // don't leave dangling pipes when there are errors.
                    function onerror(er) {
                        cleanup();
                        if (EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
                    }
                    source.on("error", onerror);
                    dest.on("error", onerror);
                    // remove all the event listeners that were added.
                    function cleanup() {
                        source.removeListener("data", ondata);
                        dest.removeListener("drain", ondrain);
                        source.removeListener("end", onend);
                        source.removeListener("close", onclose);
                        source.removeListener("error", onerror);
                        dest.removeListener("error", onerror);
                        source.removeListener("end", cleanup);
                        source.removeListener("close", cleanup);
                        dest.removeListener("close", cleanup);
                    }
                    source.on("end", cleanup);
                    source.on("close", cleanup);
                    dest.on("close", cleanup);
                    dest.emit("pipe", source);
                    // Allow for unix-like usage: A.pipe(B).pipe(C)
                    return dest;
                };
            },
            {
                "events": 36,
                "inherits": 38,
                "readable-stream/lib/_stream_duplex.js": 43,
                "readable-stream/lib/_stream_passthrough.js": 44,
                "readable-stream/lib/_stream_readable.js": 45,
                "readable-stream/lib/_stream_transform.js": 46,
                "readable-stream/lib/_stream_writable.js": 47,
                "readable-stream/lib/internal/streams/end-of-stream.js": 51,
                "readable-stream/lib/internal/streams/pipeline.js": 53
            }
        ],
        42: [
            function(require, module, exports) {
                "use strict";
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    subClass.__proto__ = superClass;
                }
                var codes = {};
                function createErrorType(code, message, Base) {
                    if (!Base) Base = Error;
                    function getMessage(arg1, arg2, arg3) {
                        if (typeof message === "string") return message;
                        else return message(arg1, arg2, arg3);
                    }
                    var NodeError = /*#__PURE__*/ function(_Base) {
                        _inheritsLoose(NodeError, _Base);
                        function NodeError(arg1, arg2, arg3) {
                            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
                        }
                        return NodeError;
                    }(Base);
                    NodeError.prototype.name = Base.name;
                    NodeError.prototype.code = code;
                    codes[code] = NodeError;
                } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
                function oneOf(expected, thing) {
                    if (Array.isArray(expected)) {
                        var len = expected.length;
                        expected = expected.map(function(i) {
                            return String(i);
                        });
                        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
                        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
                        else return "of ".concat(thing, " ").concat(expected[0]);
                    } else return "of ".concat(thing, " ").concat(String(expected));
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
                function startsWith(str, search, pos) {
                    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
                function endsWith(str, search, this_len) {
                    if (this_len === undefined || this_len > str.length) this_len = str.length;
                    return str.substring(this_len - search.length, this_len) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
                function includes(str, search, start) {
                    if (typeof start !== "number") start = 0;
                    if (start + search.length > str.length) return false;
                    else return str.indexOf(search, start) !== -1;
                }
                createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
                    return 'The value "' + value + '" is invalid for option "' + name + '"';
                }, TypeError);
                createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
                    // determiner: 'must be' or 'must not be'
                    var determiner;
                    if (typeof expected === "string" && startsWith(expected, "not ")) {
                        determiner = "must not be";
                        expected = expected.replace(/^not /, "");
                    } else determiner = "must be";
                    var msg;
                    if (endsWith(name, " argument")) // For cases like 'first argument'
                    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
                    else {
                        var type = includes(name, ".") ? "property" : "argument";
                        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
                    }
                    msg += ". Received type ".concat(typeof actual);
                    return msg;
                }, TypeError);
                createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
                createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
                    return "The " + name + " method is not implemented";
                });
                createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
                createErrorType("ERR_STREAM_DESTROYED", function(name) {
                    return "Cannot call " + name + " after a stream was destroyed";
                });
                createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
                createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
                createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
                createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
                createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
                    return "Unknown encoding: " + arg;
                }, TypeError);
                createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
                module.exports.codes = codes;
            },
            {}
        ],
        43: [
            function(require, module, exports) {
                (function(process) {
                    (function() {
                        // Copyright Joyent, Inc. and other Node contributors.
                        //
                        // Permission is hereby granted, free of charge, to any person obtaining a
                        // copy of this software and associated documentation files (the
                        // "Software"), to deal in the Software without restriction, including
                        // without limitation the rights to use, copy, modify, merge, publish,
                        // distribute, sublicense, and/or sell copies of the Software, and to permit
                        // persons to whom the Software is furnished to do so, subject to the
                        // following conditions:
                        //
                        // The above copyright notice and this permission notice shall be included
                        // in all copies or substantial portions of the Software.
                        //
                        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                        // USE OR OTHER DEALINGS IN THE SOFTWARE.
                        // a duplex stream is just a stream that is both readable and writable.
                        // Since JS doesn't have multiple prototypal inheritance, this class
                        // prototypally inherits from Readable, and then parasitically from
                        // Writable.
                        "use strict";
                        /*<replacement>*/ var objectKeys = Object.keys || function(obj) {
                            var keys = [];
                            for(var key in obj)keys.push(key);
                            return keys;
                        };
                        /*</replacement>*/ module.exports = Duplex;
                        var Readable = require("./_stream_readable");
                        var Writable = require("./_stream_writable");
                        require("inherits")(Duplex, Readable);
                        // Allow the keys array to be GC'ed.
                        var keys = objectKeys(Writable.prototype);
                        for(var v = 0; v < keys.length; v++){
                            var method = keys[v];
                            if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
                        }
                        function Duplex(options) {
                            if (!(this instanceof Duplex)) return new Duplex(options);
                            Readable.call(this, options);
                            Writable.call(this, options);
                            this.allowHalfOpen = true;
                            if (options) {
                                if (options.readable === false) this.readable = false;
                                if (options.writable === false) this.writable = false;
                                if (options.allowHalfOpen === false) {
                                    this.allowHalfOpen = false;
                                    this.once("end", onend);
                                }
                            }
                        }
                        Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.highWaterMark;
                            }
                        });
                        Object.defineProperty(Duplex.prototype, "writableBuffer", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        });
                        Object.defineProperty(Duplex.prototype, "writableLength", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.length;
                            }
                        }); // the no-half-open enforcer
                        function onend() {
                            // If the writable side ended, then we're ok.
                            if (this._writableState.ended) return; // no more data can be written.
                            // But allow more writes to happen in this tick.
                            process.nextTick(onEndNT, this);
                        }
                        function onEndNT(self1) {
                            self1.end();
                        }
                        Object.defineProperty(Duplex.prototype, "destroyed", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                if (this._readableState === undefined || this._writableState === undefined) return false;
                                return this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function set(value) {
                                // we ignore the value if the stream
                                // has not been initialized yet
                                if (this._readableState === undefined || this._writableState === undefined) return;
                                 // backward compatibility, the user is explicitly
                                // managing destroyed
                                this._readableState.destroyed = value;
                                this._writableState.destroyed = value;
                            }
                        });
                    }).call(this);
                }).call(this, require("_process"));
            },
            {
                "./_stream_readable": 45,
                "./_stream_writable": 47,
                "_process": 39,
                "inherits": 38
            }
        ],
        44: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a passthrough stream.
                // basically just the most minimal sort of Transform stream.
                // Every written chunk gets output as-is.
                "use strict";
                module.exports = PassThrough;
                var Transform = require("./_stream_transform");
                require("inherits")(PassThrough, Transform);
                function PassThrough(options) {
                    if (!(this instanceof PassThrough)) return new PassThrough(options);
                    Transform.call(this, options);
                }
                PassThrough.prototype._transform = function(chunk, encoding, cb) {
                    cb(null, chunk);
                };
            },
            {
                "./_stream_transform": 46,
                "inherits": 38
            }
        ],
        45: [
            function(require, module, exports) {
                (function(process, global) {
                    (function() {
                        // Copyright Joyent, Inc. and other Node contributors.
                        //
                        // Permission is hereby granted, free of charge, to any person obtaining a
                        // copy of this software and associated documentation files (the
                        // "Software"), to deal in the Software without restriction, including
                        // without limitation the rights to use, copy, modify, merge, publish,
                        // distribute, sublicense, and/or sell copies of the Software, and to permit
                        // persons to whom the Software is furnished to do so, subject to the
                        // following conditions:
                        //
                        // The above copyright notice and this permission notice shall be included
                        // in all copies or substantial portions of the Software.
                        //
                        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                        // USE OR OTHER DEALINGS IN THE SOFTWARE.
                        "use strict";
                        module.exports = Readable;
                        /*<replacement>*/ var Duplex;
                        /*</replacement>*/ Readable.ReadableState = ReadableState;
                        /*<replacement>*/ var EE = require("events").EventEmitter;
                        var EElistenerCount = function EElistenerCount(emitter, type) {
                            return emitter.listeners(type).length;
                        };
                        /*</replacement>*/ /*<replacement>*/ var Stream = require("./internal/streams/stream");
                        /*</replacement>*/ var Buffer = require("buffer").Buffer;
                        var OurUint8Array = global.Uint8Array || function() {};
                        function _uint8ArrayToBuffer(chunk) {
                            return Buffer.from(chunk);
                        }
                        function _isUint8Array(obj) {
                            return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                        }
                        /*<replacement>*/ var debugUtil = require("util");
                        var debug;
                        if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
                        else debug = function debug() {};
                        /*</replacement>*/ var BufferList = require("./internal/streams/buffer_list");
                        var destroyImpl = require("./internal/streams/destroy");
                        var _require = require("./internal/streams/state"), getHighWaterMark = _require.getHighWaterMark;
                        var _require$codes = require("../errors").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
                        var StringDecoder;
                        var createReadableStreamAsyncIterator;
                        var from;
                        require("inherits")(Readable, Stream);
                        var errorOrDestroy = destroyImpl.errorOrDestroy;
                        var kProxyEvents = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function prependListener(emitter, event, fn) {
                            // Sadly this is not cacheable as some libraries bundle their own
                            // event emitter implementation with them.
                            if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
                            // userland ones.  NEVER DO THIS. This is here only because this code needs
                            // to continue to work with older versions of Node.js that do not include
                            // the prependListener() method. The goal is to eventually remove this hack.
                            if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
                            else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
                            else emitter._events[event] = [
                                fn,
                                emitter._events[event]
                            ];
                        }
                        function ReadableState(options, stream, isDuplex) {
                            Duplex = Duplex || require("./_stream_duplex");
                            options = options || {}; // Duplex streams are both readable and writable, but share
                            // the same options object.
                            // However, some cases require setting options to different
                            // values for the readable and the writable sides of the duplex stream.
                            // These options can be provided separately as readableXXX and writableXXX.
                            if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
                            // make all the buffer merging and length checks go away
                            this.objectMode = !!options.objectMode;
                            if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
                            // Note: 0 is a valid value, means "don't call _read preemptively ever"
                            this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
                            // linked list can remove elements from the beginning faster than
                            // array.shift()
                            this.buffer = new BufferList();
                            this.length = 0;
                            this.pipes = null;
                            this.pipesCount = 0;
                            this.flowing = null;
                            this.ended = false;
                            this.endEmitted = false;
                            this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
                            // immediately, or on a later tick.  We set this to true at first, because
                            // any actions that shouldn't happen until "later" should generally also
                            // not happen before the first read call.
                            this.sync = true; // whenever we return null, then we set a flag to say
                            // that we're awaiting a 'readable' event emission.
                            this.needReadable = false;
                            this.emittedReadable = false;
                            this.readableListening = false;
                            this.resumeScheduled = false;
                            this.paused = true; // Should close be emitted on destroy. Defaults to true.
                            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
                            this.autoDestroy = !!options.autoDestroy; // has it been destroyed
                            this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
                            // encoding is 'binary' so we have to make this configurable.
                            // Everything else in the universe uses 'utf8', though.
                            this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
                            this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
                            this.readingMore = false;
                            this.decoder = null;
                            this.encoding = null;
                            if (options.encoding) {
                                if (!StringDecoder) StringDecoder = require("string_decoder/").StringDecoder;
                                this.decoder = new StringDecoder(options.encoding);
                                this.encoding = options.encoding;
                            }
                        }
                        function Readable(options) {
                            Duplex = Duplex || require("./_stream_duplex");
                            if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
                            // the ReadableState constructor, at least with V8 6.5
                            var isDuplex = this instanceof Duplex;
                            this._readableState = new ReadableState(options, this, isDuplex); // legacy
                            this.readable = true;
                            if (options) {
                                if (typeof options.read === "function") this._read = options.read;
                                if (typeof options.destroy === "function") this._destroy = options.destroy;
                            }
                            Stream.call(this);
                        }
                        Object.defineProperty(Readable.prototype, "destroyed", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                if (this._readableState === undefined) return false;
                                return this._readableState.destroyed;
                            },
                            set: function set(value) {
                                // we ignore the value if the stream
                                // has not been initialized yet
                                if (!this._readableState) return;
                                 // backward compatibility, the user is explicitly
                                // managing destroyed
                                this._readableState.destroyed = value;
                            }
                        });
                        Readable.prototype.destroy = destroyImpl.destroy;
                        Readable.prototype._undestroy = destroyImpl.undestroy;
                        Readable.prototype._destroy = function(err, cb) {
                            cb(err);
                        }; // Manually shove something into the read() buffer.
                        // This returns true if the highWaterMark has not been hit yet,
                        // similar to how Writable.write() returns true if you should
                        // write() some more.
                        Readable.prototype.push = function(chunk, encoding) {
                            var state = this._readableState;
                            var skipChunkCheck;
                            if (!state.objectMode) {
                                if (typeof chunk === "string") {
                                    encoding = encoding || state.defaultEncoding;
                                    if (encoding !== state.encoding) {
                                        chunk = Buffer.from(chunk, encoding);
                                        encoding = "";
                                    }
                                    skipChunkCheck = true;
                                }
                            } else skipChunkCheck = true;
                            return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
                        }; // Unshift should *always* be something directly out of read()
                        Readable.prototype.unshift = function(chunk) {
                            return readableAddChunk(this, chunk, null, true, false);
                        };
                        function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
                            debug("readableAddChunk", chunk);
                            var state = stream._readableState;
                            if (chunk === null) {
                                state.reading = false;
                                onEofChunk(stream, state);
                            } else {
                                var er;
                                if (!skipChunkCheck) er = chunkInvalid(state, chunk);
                                if (er) errorOrDestroy(stream, er);
                                else if (state.objectMode || chunk && chunk.length > 0) {
                                    if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
                                    if (addToFront) {
                                        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                                        else addChunk(stream, state, chunk, true);
                                    } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                                    else if (state.destroyed) return false;
                                    else {
                                        state.reading = false;
                                        if (state.decoder && !encoding) {
                                            chunk = state.decoder.write(chunk);
                                            if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                                            else maybeReadMore(stream, state);
                                        } else addChunk(stream, state, chunk, false);
                                    }
                                } else if (!addToFront) {
                                    state.reading = false;
                                    maybeReadMore(stream, state);
                                }
                            } // We can push more data if we are below the highWaterMark.
                            // Also, if we have no data yet, we can stand some more bytes.
                            // This is to work around cases where hwm=0, such as the repl.
                            return !state.ended && (state.length < state.highWaterMark || state.length === 0);
                        }
                        function addChunk(stream, state, chunk, addToFront) {
                            if (state.flowing && state.length === 0 && !state.sync) {
                                state.awaitDrain = 0;
                                stream.emit("data", chunk);
                            } else {
                                // update the buffer info.
                                state.length += state.objectMode ? 1 : chunk.length;
                                if (addToFront) state.buffer.unshift(chunk);
                                else state.buffer.push(chunk);
                                if (state.needReadable) emitReadable(stream);
                            }
                            maybeReadMore(stream, state);
                        }
                        function chunkInvalid(state, chunk) {
                            var er;
                            if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
                                "string",
                                "Buffer",
                                "Uint8Array"
                            ], chunk);
                            return er;
                        }
                        Readable.prototype.isPaused = function() {
                            return this._readableState.flowing === false;
                        }; // backwards compatibility.
                        Readable.prototype.setEncoding = function(enc) {
                            if (!StringDecoder) StringDecoder = require("string_decoder/").StringDecoder;
                            var decoder = new StringDecoder(enc);
                            this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
                            this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
                            var p = this._readableState.buffer.head;
                            var content = "";
                            while(p !== null){
                                content += decoder.write(p.data);
                                p = p.next;
                            }
                            this._readableState.buffer.clear();
                            if (content !== "") this._readableState.buffer.push(content);
                            this._readableState.length = content.length;
                            return this;
                        }; // Don't raise the hwm > 1GB
                        var MAX_HWM = 0x40000000;
                        function computeNewHighWaterMark(n) {
                            if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
                            n = MAX_HWM;
                            else {
                                // Get the next highest power of 2 to prevent increasing hwm excessively in
                                // tiny amounts
                                n--;
                                n |= n >>> 1;
                                n |= n >>> 2;
                                n |= n >>> 4;
                                n |= n >>> 8;
                                n |= n >>> 16;
                                n++;
                            }
                            return n;
                        } // This function is designed to be inlinable, so please take care when making
                        // changes to the function body.
                        function howMuchToRead(n, state) {
                            if (n <= 0 || state.length === 0 && state.ended) return 0;
                            if (state.objectMode) return 1;
                            if (n !== n) {
                                // Only flow one buffer at a time
                                if (state.flowing && state.length) return state.buffer.head.data.length;
                                else return state.length;
                            } // If we're asking for more than the current hwm, then raise the hwm.
                            if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
                            if (n <= state.length) return n; // Don't have enough
                            if (!state.ended) {
                                state.needReadable = true;
                                return 0;
                            }
                            return state.length;
                        } // you can override either this method, or the async _read(n) below.
                        Readable.prototype.read = function(n) {
                            debug("read", n);
                            n = parseInt(n, 10);
                            var state = this._readableState;
                            var nOrig = n;
                            if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
                            // already have a bunch of data in the buffer, then just trigger
                            // the 'readable' event and move on.
                            if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
                                debug("read: emitReadable", state.length, state.ended);
                                if (state.length === 0 && state.ended) endReadable(this);
                                else emitReadable(this);
                                return null;
                            }
                            n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
                            if (n === 0 && state.ended) {
                                if (state.length === 0) endReadable(this);
                                return null;
                            } // All the actual chunk generation logic needs to be
                            // *below* the call to _read.  The reason is that in certain
                            // synthetic stream cases, such as passthrough streams, _read
                            // may be a completely synchronous operation which may change
                            // the state of the read buffer, providing enough data when
                            // before there was *not* enough.
                            //
                            // So, the steps are:
                            // 1. Figure out what the state of things will be after we do
                            // a read from the buffer.
                            //
                            // 2. If that resulting state will trigger a _read, then call _read.
                            // Note that this may be asynchronous, or synchronous.  Yes, it is
                            // deeply ugly to write APIs this way, but that still doesn't mean
                            // that the Readable class should behave improperly, as streams are
                            // designed to be sync/async agnostic.
                            // Take note if the _read call is sync or async (ie, if the read call
                            // has returned yet), so that we know whether or not it's safe to emit
                            // 'readable' etc.
                            //
                            // 3. Actually pull the requested chunks out of the buffer and return.
                            // if we need a readable event, then we need to do some reading.
                            var doRead = state.needReadable;
                            debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
                            if (state.length === 0 || state.length - n < state.highWaterMark) {
                                doRead = true;
                                debug("length less than watermark", doRead);
                            } // however, if we've ended, then there's no point, and if we're already
                            // reading, then it's unnecessary.
                            if (state.ended || state.reading) {
                                doRead = false;
                                debug("reading or ended", doRead);
                            } else if (doRead) {
                                debug("do read");
                                state.reading = true;
                                state.sync = true; // if the length is currently zero, then we *need* a readable event.
                                if (state.length === 0) state.needReadable = true; // call internal read method
                                this._read(state.highWaterMark);
                                state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
                                // and we need to re-evaluate how much data we can return to the user.
                                if (!state.reading) n = howMuchToRead(nOrig, state);
                            }
                            var ret;
                            if (n > 0) ret = fromList(n, state);
                            else ret = null;
                            if (ret === null) {
                                state.needReadable = state.length <= state.highWaterMark;
                                n = 0;
                            } else {
                                state.length -= n;
                                state.awaitDrain = 0;
                            }
                            if (state.length === 0) {
                                // If we have nothing in the buffer, then we want to know
                                // as soon as we *do* get something into the buffer.
                                if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
                                if (nOrig !== n && state.ended) endReadable(this);
                            }
                            if (ret !== null) this.emit("data", ret);
                            return ret;
                        };
                        function onEofChunk(stream, state) {
                            debug("onEofChunk");
                            if (state.ended) return;
                            if (state.decoder) {
                                var chunk = state.decoder.end();
                                if (chunk && chunk.length) {
                                    state.buffer.push(chunk);
                                    state.length += state.objectMode ? 1 : chunk.length;
                                }
                            }
                            state.ended = true;
                            if (state.sync) // if we are sync, wait until next tick to emit the data.
                            // Otherwise we risk emitting data in the flow()
                            // the readable code triggers during a read() call
                            emitReadable(stream);
                            else {
                                // emit 'readable' now to make sure it gets picked up.
                                state.needReadable = false;
                                if (!state.emittedReadable) {
                                    state.emittedReadable = true;
                                    emitReadable_(stream);
                                }
                            }
                        } // Don't emit readable right away in sync mode, because this can trigger
                        // another read() call => stack overflow.  This way, it might trigger
                        // a nextTick recursion warning, but that's not so bad.
                        function emitReadable(stream) {
                            var state = stream._readableState;
                            debug("emitReadable", state.needReadable, state.emittedReadable);
                            state.needReadable = false;
                            if (!state.emittedReadable) {
                                debug("emitReadable", state.flowing);
                                state.emittedReadable = true;
                                process.nextTick(emitReadable_, stream);
                            }
                        }
                        function emitReadable_(stream) {
                            var state = stream._readableState;
                            debug("emitReadable_", state.destroyed, state.length, state.ended);
                            if (!state.destroyed && (state.length || state.ended)) {
                                stream.emit("readable");
                                state.emittedReadable = false;
                            } // The stream needs another readable event if
                            // 1. It is not flowing, as the flow mechanism will take
                            //    care of it.
                            // 2. It is not ended.
                            // 3. It is below the highWaterMark, so we can schedule
                            //    another readable later.
                            state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
                            flow(stream);
                        } // at this point, the user has presumably seen the 'readable' event,
                        // and called read() to consume some data.  that may have triggered
                        // in turn another _read(n) call, in which case reading = true if
                        // it's in progress.
                        // However, if we're not ended, or reading, and the length < hwm,
                        // then go ahead and try to read some more preemptively.
                        function maybeReadMore(stream, state) {
                            if (!state.readingMore) {
                                state.readingMore = true;
                                process.nextTick(maybeReadMore_, stream, state);
                            }
                        }
                        function maybeReadMore_(stream, state) {
                            // Attempt to read more data if we should.
                            //
                            // The conditions for reading more data are (one of):
                            // - Not enough data buffered (state.length < state.highWaterMark). The loop
                            //   is responsible for filling the buffer with enough data if such data
                            //   is available. If highWaterMark is 0 and we are not in the flowing mode
                            //   we should _not_ attempt to buffer any extra data. We'll get more data
                            //   when the stream consumer calls read() instead.
                            // - No data in the buffer, and the stream is in flowing mode. In this mode
                            //   the loop below is responsible for ensuring read() is called. Failing to
                            //   call read here would abort the flow and there's no other mechanism for
                            //   continuing the flow if the stream consumer has just subscribed to the
                            //   'data' event.
                            //
                            // In addition to the above conditions to keep reading data, the following
                            // conditions prevent the data from being read:
                            // - The stream has ended (state.ended).
                            // - There is already a pending 'read' operation (state.reading). This is a
                            //   case where the the stream has called the implementation defined _read()
                            //   method, but they are processing the call asynchronously and have _not_
                            //   called push() with new data. In this case we skip performing more
                            //   read()s. The execution ends in this method again after the _read() ends
                            //   up calling push() with more data.
                            while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
                                var len = state.length;
                                debug("maybeReadMore read 0");
                                stream.read(0);
                                if (len === state.length) break;
                            }
                            state.readingMore = false;
                        } // abstract method.  to be overridden in specific implementation classes.
                        // call cb(er, data) where data is <= n in length.
                        // for virtual (non-string, non-buffer) streams, "length" is somewhat
                        // arbitrary, and perhaps not very meaningful.
                        Readable.prototype._read = function(n) {
                            errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
                        };
                        Readable.prototype.pipe = function(dest, pipeOpts) {
                            var src = this;
                            var state = this._readableState;
                            switch(state.pipesCount){
                                case 0:
                                    state.pipes = dest;
                                    break;
                                case 1:
                                    state.pipes = [
                                        state.pipes,
                                        dest
                                    ];
                                    break;
                                default:
                                    state.pipes.push(dest);
                                    break;
                            }
                            state.pipesCount += 1;
                            debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
                            var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
                            var endFn = doEnd ? onend : unpipe;
                            if (state.endEmitted) process.nextTick(endFn);
                            else src.once("end", endFn);
                            dest.on("unpipe", onunpipe);
                            function onunpipe(readable, unpipeInfo) {
                                debug("onunpipe");
                                if (readable === src) {
                                    if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                                        unpipeInfo.hasUnpiped = true;
                                        cleanup();
                                    }
                                }
                            }
                            function onend() {
                                debug("onend");
                                dest.end();
                            } // when the dest drains, it reduces the awaitDrain counter
                            // on the source.  This would be more elegant with a .once()
                            // handler in flow(), but adding and removing repeatedly is
                            // too slow.
                            var ondrain = pipeOnDrain(src);
                            dest.on("drain", ondrain);
                            var cleanedUp = false;
                            function cleanup() {
                                debug("cleanup"); // cleanup event handlers once the pipe is broken
                                dest.removeListener("close", onclose);
                                dest.removeListener("finish", onfinish);
                                dest.removeListener("drain", ondrain);
                                dest.removeListener("error", onerror);
                                dest.removeListener("unpipe", onunpipe);
                                src.removeListener("end", onend);
                                src.removeListener("end", unpipe);
                                src.removeListener("data", ondata);
                                cleanedUp = true; // if the reader is waiting for a drain event from this
                                // specific writer, then it would cause it to never start
                                // flowing again.
                                // So, if this is awaiting a drain, then we just call it now.
                                // If we don't know, then assume that we are waiting for one.
                                if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
                            }
                            src.on("data", ondata);
                            function ondata(chunk) {
                                debug("ondata");
                                var ret = dest.write(chunk);
                                debug("dest.write", ret);
                                if (ret === false) {
                                    // If the user unpiped during `dest.write()`, it is possible
                                    // to get stuck in a permanently paused state if that write
                                    // also returned false.
                                    // => Check whether `dest` is still a piping destination.
                                    if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                                        debug("false write response, pause", state.awaitDrain);
                                        state.awaitDrain++;
                                    }
                                    src.pause();
                                }
                            } // if the dest has an error, then stop piping into it.
                            // however, don't suppress the throwing behavior for this.
                            function onerror(er) {
                                debug("onerror", er);
                                unpipe();
                                dest.removeListener("error", onerror);
                                if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
                            } // Make sure our error handler is attached before userland ones.
                            prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
                            function onclose() {
                                dest.removeListener("finish", onfinish);
                                unpipe();
                            }
                            dest.once("close", onclose);
                            function onfinish() {
                                debug("onfinish");
                                dest.removeListener("close", onclose);
                                unpipe();
                            }
                            dest.once("finish", onfinish);
                            function unpipe() {
                                debug("unpipe");
                                src.unpipe(dest);
                            } // tell the dest that it's being piped to
                            dest.emit("pipe", src); // start the flow if it hasn't been started already.
                            if (!state.flowing) {
                                debug("pipe resume");
                                src.resume();
                            }
                            return dest;
                        };
                        function pipeOnDrain(src) {
                            return function pipeOnDrainFunctionResult() {
                                var state = src._readableState;
                                debug("pipeOnDrain", state.awaitDrain);
                                if (state.awaitDrain) state.awaitDrain--;
                                if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
                                    state.flowing = true;
                                    flow(src);
                                }
                            };
                        }
                        Readable.prototype.unpipe = function(dest) {
                            var state = this._readableState;
                            var unpipeInfo = {
                                hasUnpiped: false
                            }; // if we're not piping anywhere, then do nothing.
                            if (state.pipesCount === 0) return this; // just one destination.  most common case.
                            if (state.pipesCount === 1) {
                                // passed in one, but it's not the right one.
                                if (dest && dest !== state.pipes) return this;
                                if (!dest) dest = state.pipes; // got a match.
                                state.pipes = null;
                                state.pipesCount = 0;
                                state.flowing = false;
                                if (dest) dest.emit("unpipe", this, unpipeInfo);
                                return this;
                            } // slow case. multiple pipe destinations.
                            if (!dest) {
                                // remove all.
                                var dests = state.pipes;
                                var len = state.pipesCount;
                                state.pipes = null;
                                state.pipesCount = 0;
                                state.flowing = false;
                                for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
                                    hasUnpiped: false
                                });
                                return this;
                            } // try to find the right one.
                            var index = indexOf(state.pipes, dest);
                            if (index === -1) return this;
                            state.pipes.splice(index, 1);
                            state.pipesCount -= 1;
                            if (state.pipesCount === 1) state.pipes = state.pipes[0];
                            dest.emit("unpipe", this, unpipeInfo);
                            return this;
                        }; // set up data events if they are asked for
                        // Ensure readable listeners eventually get something
                        Readable.prototype.on = function(ev, fn) {
                            var res = Stream.prototype.on.call(this, ev, fn);
                            var state = this._readableState;
                            if (ev === "data") {
                                // update readableListening so that resume() may be a no-op
                                // a few lines down. This is needed to support once('readable').
                                state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
                                if (state.flowing !== false) this.resume();
                            } else if (ev === "readable") {
                                if (!state.endEmitted && !state.readableListening) {
                                    state.readableListening = state.needReadable = true;
                                    state.flowing = false;
                                    state.emittedReadable = false;
                                    debug("on readable", state.length, state.reading);
                                    if (state.length) emitReadable(this);
                                    else if (!state.reading) process.nextTick(nReadingNextTick, this);
                                }
                            }
                            return res;
                        };
                        Readable.prototype.addListener = Readable.prototype.on;
                        Readable.prototype.removeListener = function(ev, fn) {
                            var res = Stream.prototype.removeListener.call(this, ev, fn);
                            if (ev === "readable") // We need to check if there is someone still listening to
                            // readable and reset the state. However this needs to happen
                            // after readable has been emitted but before I/O (nextTick) to
                            // support once('readable', fn) cycles. This means that calling
                            // resume within the same tick will have no
                            // effect.
                            process.nextTick(updateReadableListening, this);
                            return res;
                        };
                        Readable.prototype.removeAllListeners = function(ev) {
                            var res = Stream.prototype.removeAllListeners.apply(this, arguments);
                            if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
                            // readable and reset the state. However this needs to happen
                            // after readable has been emitted but before I/O (nextTick) to
                            // support once('readable', fn) cycles. This means that calling
                            // resume within the same tick will have no
                            // effect.
                            process.nextTick(updateReadableListening, this);
                            return res;
                        };
                        function updateReadableListening(self1) {
                            var state = self1._readableState;
                            state.readableListening = self1.listenerCount("readable") > 0;
                            if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
                            // the upcoming resume will not flow.
                            state.flowing = true; // crude way to check if we should resume
                            else if (self1.listenerCount("data") > 0) self1.resume();
                        }
                        function nReadingNextTick(self1) {
                            debug("readable nexttick read 0");
                            self1.read(0);
                        } // pause() and resume() are remnants of the legacy readable stream API
                        // If the user uses them, then switch into old mode.
                        Readable.prototype.resume = function() {
                            var state = this._readableState;
                            if (!state.flowing) {
                                debug("resume"); // we flow only if there is no one listening
                                // for readable, but we still have to call
                                // resume()
                                state.flowing = !state.readableListening;
                                resume(this, state);
                            }
                            state.paused = false;
                            return this;
                        };
                        function resume(stream, state) {
                            if (!state.resumeScheduled) {
                                state.resumeScheduled = true;
                                process.nextTick(resume_, stream, state);
                            }
                        }
                        function resume_(stream, state) {
                            debug("resume", state.reading);
                            if (!state.reading) stream.read(0);
                            state.resumeScheduled = false;
                            stream.emit("resume");
                            flow(stream);
                            if (state.flowing && !state.reading) stream.read(0);
                        }
                        Readable.prototype.pause = function() {
                            debug("call pause flowing=%j", this._readableState.flowing);
                            if (this._readableState.flowing !== false) {
                                debug("pause");
                                this._readableState.flowing = false;
                                this.emit("pause");
                            }
                            this._readableState.paused = true;
                            return this;
                        };
                        function flow(stream) {
                            var state = stream._readableState;
                            debug("flow", state.flowing);
                            while(state.flowing && stream.read() !== null);
                        } // wrap an old-style stream as the async data source.
                        // This is *not* part of the readable stream interface.
                        // It is an ugly unfortunate mess of history.
                        Readable.prototype.wrap = function(stream) {
                            var _this = this;
                            var state = this._readableState;
                            var paused = false;
                            stream.on("end", function() {
                                debug("wrapped end");
                                if (state.decoder && !state.ended) {
                                    var chunk = state.decoder.end();
                                    if (chunk && chunk.length) _this.push(chunk);
                                }
                                _this.push(null);
                            });
                            stream.on("data", function(chunk) {
                                debug("wrapped data");
                                if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
                                if (state.objectMode && (chunk === null || chunk === undefined)) return;
                                else if (!state.objectMode && (!chunk || !chunk.length)) return;
                                var ret = _this.push(chunk);
                                if (!ret) {
                                    paused = true;
                                    stream.pause();
                                }
                            }); // proxy all the other methods.
                            // important when wrapping filters and duplexes.
                            for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
                                return function methodWrapReturnFunction() {
                                    return stream[method].apply(stream, arguments);
                                };
                            }(i);
                             // proxy certain important events.
                            for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
                             // when we try to consume some more bytes, simply unpause the
                            // underlying stream.
                            this._read = function(n) {
                                debug("wrapped _read", n);
                                if (paused) {
                                    paused = false;
                                    stream.resume();
                                }
                            };
                            return this;
                        };
                        if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
                            if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("./internal/streams/async_iterator");
                            return createReadableStreamAsyncIterator(this);
                        };
                        Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState.highWaterMark;
                            }
                        });
                        Object.defineProperty(Readable.prototype, "readableBuffer", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState && this._readableState.buffer;
                            }
                        });
                        Object.defineProperty(Readable.prototype, "readableFlowing", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState.flowing;
                            },
                            set: function set(state) {
                                if (this._readableState) this._readableState.flowing = state;
                            }
                        }); // exposed for testing purposes only.
                        Readable._fromList = fromList;
                        Object.defineProperty(Readable.prototype, "readableLength", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._readableState.length;
                            }
                        }); // Pluck off n bytes from an array of buffers.
                        // Length is the combined lengths of all the buffers in the list.
                        // This function is designed to be inlinable, so please take care when making
                        // changes to the function body.
                        function fromList(n, state) {
                            // nothing buffered
                            if (state.length === 0) return null;
                            var ret;
                            if (state.objectMode) ret = state.buffer.shift();
                            else if (!n || n >= state.length) {
                                // read it all, truncate the list
                                if (state.decoder) ret = state.buffer.join("");
                                else if (state.buffer.length === 1) ret = state.buffer.first();
                                else ret = state.buffer.concat(state.length);
                                state.buffer.clear();
                            } else // read part of list
                            ret = state.buffer.consume(n, state.decoder);
                            return ret;
                        }
                        function endReadable(stream) {
                            var state = stream._readableState;
                            debug("endReadable", state.endEmitted);
                            if (!state.endEmitted) {
                                state.ended = true;
                                process.nextTick(endReadableNT, state, stream);
                            }
                        }
                        function endReadableNT(state, stream) {
                            debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
                            if (!state.endEmitted && state.length === 0) {
                                state.endEmitted = true;
                                stream.readable = false;
                                stream.emit("end");
                                if (state.autoDestroy) {
                                    // In case of duplex streams we need a way to detect
                                    // if the writable side is ready for autoDestroy as well
                                    var wState = stream._writableState;
                                    if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
                                }
                            }
                        }
                        if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
                            if (from === undefined) from = require("./internal/streams/from");
                            return from(Readable, iterable, opts);
                        };
                        function indexOf(xs, x) {
                            for(var i = 0, l = xs.length; i < l; i++){
                                if (xs[i] === x) return i;
                            }
                            return -1;
                        }
                    }).call(this);
                }).call(this, require("_process"), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "../errors": 42,
                "./_stream_duplex": 43,
                "./internal/streams/async_iterator": 48,
                "./internal/streams/buffer_list": 49,
                "./internal/streams/destroy": 50,
                "./internal/streams/from": 52,
                "./internal/streams/state": 54,
                "./internal/streams/stream": 55,
                "_process": 39,
                "buffer": 35,
                "events": 36,
                "inherits": 38,
                "string_decoder/": 56,
                "util": 34
            }
        ],
        46: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a transform stream is a readable/writable stream where you do
                // something with the data.  Sometimes it's called a "filter",
                // but that's not a great name for it, since that implies a thing where
                // some bits pass through, and others are simply ignored.  (That would
                // be a valid example of a transform, of course.)
                //
                // While the output is causally related to the input, it's not a
                // necessarily symmetric or synchronous transformation.  For example,
                // a zlib stream might take multiple plain-text writes(), and then
                // emit a single compressed chunk some time in the future.
                //
                // Here's how this works:
                //
                // The Transform stream has all the aspects of the readable and writable
                // stream classes.  When you write(chunk), that calls _write(chunk,cb)
                // internally, and returns false if there's a lot of pending writes
                // buffered up.  When you call read(), that calls _read(n) until
                // there's enough pending readable data buffered up.
                //
                // In a transform stream, the written data is placed in a buffer.  When
                // _read(n) is called, it transforms the queued up data, calling the
                // buffered _write cb's as it consumes chunks.  If consuming a single
                // written chunk would result in multiple output chunks, then the first
                // outputted bit calls the readcb, and subsequent chunks just go into
                // the read buffer, and will cause it to emit 'readable' if necessary.
                //
                // This way, back-pressure is actually determined by the reading side,
                // since _read has to be called to start processing a new chunk.  However,
                // a pathological inflate type of transform can cause excessive buffering
                // here.  For example, imagine a stream where every byte of input is
                // interpreted as an integer from 0-255, and then results in that many
                // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
                // 1kb of data being output.  In this case, you could write a very small
                // amount of input, and end up with a very large amount of output.  In
                // such a pathological inflating mechanism, there'd be no way to tell
                // the system to stop doing the transform.  A single 4MB write could
                // cause the system to run out of memory.
                //
                // However, even in such a pathological case, only a single written chunk
                // would be consumed, and then the rest would wait (un-transformed) until
                // the results of the previous transformed chunk were consumed.
                "use strict";
                module.exports = Transform;
                var _require$codes = require("../errors").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
                var Duplex = require("./_stream_duplex");
                require("inherits")(Transform, Duplex);
                function afterTransform(er, data) {
                    var ts = this._transformState;
                    ts.transforming = false;
                    var cb = ts.writecb;
                    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
                    ts.writechunk = null;
                    ts.writecb = null;
                    if (data != null) this.push(data);
                    cb(er);
                    var rs = this._readableState;
                    rs.reading = false;
                    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                }
                function Transform(options) {
                    if (!(this instanceof Transform)) return new Transform(options);
                    Duplex.call(this, options);
                    this._transformState = {
                        afterTransform: afterTransform.bind(this),
                        needTransform: false,
                        transforming: false,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }; // start out asking for a readable event once data is transformed.
                    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
                    // that Readable wants before the first _read call, so unset the
                    // sync guard flag.
                    this._readableState.sync = false;
                    if (options) {
                        if (typeof options.transform === "function") this._transform = options.transform;
                        if (typeof options.flush === "function") this._flush = options.flush;
                    } // When the writable side finishes, then flush out anything remaining.
                    this.on("prefinish", prefinish);
                }
                function prefinish() {
                    var _this = this;
                    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
                        done(_this, er, data);
                    });
                    else done(this, null, null);
                }
                Transform.prototype.push = function(chunk, encoding) {
                    this._transformState.needTransform = false;
                    return Duplex.prototype.push.call(this, chunk, encoding);
                }; // This is the part where you do stuff!
                // override this function in implementation classes.
                // 'chunk' is an input chunk.
                //
                // Call `push(newChunk)` to pass along transformed output
                // to the readable side.  You may call 'push' zero or more times.
                //
                // Call `cb(err)` when you are done with this chunk.  If you pass
                // an error, then that'll put the hurt on the whole operation.  If you
                // never call cb(), then you'll never get another chunk.
                Transform.prototype._transform = function(chunk, encoding, cb) {
                    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
                };
                Transform.prototype._write = function(chunk, encoding, cb) {
                    var ts = this._transformState;
                    ts.writecb = cb;
                    ts.writechunk = chunk;
                    ts.writeencoding = encoding;
                    if (!ts.transforming) {
                        var rs = this._readableState;
                        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                    }
                }; // Doesn't matter what the args are here.
                // _transform does all the work.
                // That we got here means that the readable side wants more data.
                Transform.prototype._read = function(n) {
                    var ts = this._transformState;
                    if (ts.writechunk !== null && !ts.transforming) {
                        ts.transforming = true;
                        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
                    } else // mark that we need a transform, so that any data that comes in
                    // will get processed, now that we've asked for it.
                    ts.needTransform = true;
                };
                Transform.prototype._destroy = function(err, cb) {
                    Duplex.prototype._destroy.call(this, err, function(err2) {
                        cb(err2);
                    });
                };
                function done(stream, er, data) {
                    if (er) return stream.emit("error", er);
                    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
                    // if there's nothing in the write buffer, then that means
                    // that nothing more will ever be provided
                    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
                    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
                    return stream.push(null);
                }
            },
            {
                "../errors": 42,
                "./_stream_duplex": 43,
                "inherits": 38
            }
        ],
        47: [
            function(require, module, exports) {
                (function(process, global) {
                    (function() {
                        // Copyright Joyent, Inc. and other Node contributors.
                        //
                        // Permission is hereby granted, free of charge, to any person obtaining a
                        // copy of this software and associated documentation files (the
                        // "Software"), to deal in the Software without restriction, including
                        // without limitation the rights to use, copy, modify, merge, publish,
                        // distribute, sublicense, and/or sell copies of the Software, and to permit
                        // persons to whom the Software is furnished to do so, subject to the
                        // following conditions:
                        //
                        // The above copyright notice and this permission notice shall be included
                        // in all copies or substantial portions of the Software.
                        //
                        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                        // USE OR OTHER DEALINGS IN THE SOFTWARE.
                        // A bit simpler than readable streams.
                        // Implement an async ._write(chunk, encoding, cb), and it'll handle all
                        // the drain event emission and buffering.
                        "use strict";
                        module.exports = Writable;
                        /* <replacement> */ function WriteReq(chunk, encoding, cb) {
                            this.chunk = chunk;
                            this.encoding = encoding;
                            this.callback = cb;
                            this.next = null;
                        } // It seems a linked list but it is not
                        // there will be only 2 of these for each stream
                        function CorkedRequest(state) {
                            var _this = this;
                            this.next = null;
                            this.entry = null;
                            this.finish = function() {
                                onCorkedFinish(_this, state);
                            };
                        }
                        /* </replacement> */ /*<replacement>*/ var Duplex;
                        /*</replacement>*/ Writable.WritableState = WritableState;
                        /*<replacement>*/ var internalUtil = {
                            deprecate: require("util-deprecate")
                        };
                        /*</replacement>*/ /*<replacement>*/ var Stream = require("./internal/streams/stream");
                        /*</replacement>*/ var Buffer = require("buffer").Buffer;
                        var OurUint8Array = global.Uint8Array || function() {};
                        function _uint8ArrayToBuffer(chunk) {
                            return Buffer.from(chunk);
                        }
                        function _isUint8Array(obj) {
                            return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                        }
                        var destroyImpl = require("./internal/streams/destroy");
                        var _require = require("./internal/streams/state"), getHighWaterMark = _require.getHighWaterMark;
                        var _require$codes = require("../errors").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
                        var errorOrDestroy = destroyImpl.errorOrDestroy;
                        require("inherits")(Writable, Stream);
                        function nop() {}
                        function WritableState(options, stream, isDuplex) {
                            Duplex = Duplex || require("./_stream_duplex");
                            options = options || {}; // Duplex streams are both readable and writable, but share
                            // the same options object.
                            // However, some cases require setting options to different
                            // values for the readable and the writable sides of the duplex stream,
                            // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
                            if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
                            // contains buffers or objects.
                            this.objectMode = !!options.objectMode;
                            if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
                            // Note: 0 is a valid value, means that we always return false if
                            // the entire buffer is not flushed immediately on write()
                            this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
                            this.finalCalled = false; // drain event flag.
                            this.needDrain = false; // at the start of calling end()
                            this.ending = false; // when end() has been called, and returned
                            this.ended = false; // when 'finish' is emitted
                            this.finished = false; // has it been destroyed
                            this.destroyed = false; // should we decode strings into buffers before passing to _write?
                            // this is here so that some node-core streams can optimize string
                            // handling at a lower level.
                            var noDecode = options.decodeStrings === false;
                            this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
                            // encoding is 'binary' so we have to make this configurable.
                            // Everything else in the universe uses 'utf8', though.
                            this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
                            // of how much we're waiting to get pushed to some underlying
                            // socket or file.
                            this.length = 0; // a flag to see when we're in the middle of a write.
                            this.writing = false; // when true all writes will be buffered until .uncork() call
                            this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
                            // or on a later tick.  We set this to true at first, because any
                            // actions that shouldn't happen until "later" should generally also
                            // not happen before the first write call.
                            this.sync = true; // a flag to know if we're processing previously buffered items, which
                            // may call the _write() callback in the same tick, so that we don't
                            // end up in an overlapped onwrite situation.
                            this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
                            this.onwrite = function(er) {
                                onwrite(stream, er);
                            }; // the callback that the user supplies to write(chunk,encoding,cb)
                            this.writecb = null; // the amount that is being written when _write is called.
                            this.writelen = 0;
                            this.bufferedRequest = null;
                            this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
                            // this must be 0 before 'finish' can be emitted
                            this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
                            // This is relevant for synchronous Transform streams
                            this.prefinished = false; // True if the error was already emitted and should not be thrown again
                            this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
                            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
                            this.autoDestroy = !!options.autoDestroy; // count buffered requests
                            this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
                            // one allocated and free to use, and we maintain at most two
                            this.corkedRequestsFree = new CorkedRequest(this);
                        }
                        WritableState.prototype.getBuffer = function getBuffer() {
                            var current = this.bufferedRequest;
                            var out = [];
                            while(current){
                                out.push(current);
                                current = current.next;
                            }
                            return out;
                        };
                        (function() {
                            try {
                                Object.defineProperty(WritableState.prototype, "buffer", {
                                    get: internalUtil.deprecate(function writableStateBufferGetter() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (_) {}
                        })(); // Test _writableState for inheritance to account for Duplex streams,
                        // whose prototype chain only points to Readable.
                        var realHasInstance;
                        if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
                            realHasInstance = Function.prototype[Symbol.hasInstance];
                            Object.defineProperty(Writable, Symbol.hasInstance, {
                                value: function value(object) {
                                    if (realHasInstance.call(this, object)) return true;
                                    if (this !== Writable) return false;
                                    return object && object._writableState instanceof WritableState;
                                }
                            });
                        } else realHasInstance = function realHasInstance(object) {
                            return object instanceof this;
                        };
                        function Writable(options) {
                            Duplex = Duplex || require("./_stream_duplex"); // Writable ctor is applied to Duplexes, too.
                            // `realHasInstance` is necessary because using plain `instanceof`
                            // would return false, as no `_writableState` property is attached.
                            // Trying to use the custom `instanceof` for Writable here will also break the
                            // Node.js LazyTransform implementation, which has a non-trivial getter for
                            // `_writableState` that would lead to infinite recursion.
                            // Checking for a Stream.Duplex instance is faster here instead of inside
                            // the WritableState constructor, at least with V8 6.5
                            var isDuplex = this instanceof Duplex;
                            if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
                            this._writableState = new WritableState(options, this, isDuplex); // legacy.
                            this.writable = true;
                            if (options) {
                                if (typeof options.write === "function") this._write = options.write;
                                if (typeof options.writev === "function") this._writev = options.writev;
                                if (typeof options.destroy === "function") this._destroy = options.destroy;
                                if (typeof options.final === "function") this._final = options.final;
                            }
                            Stream.call(this);
                        } // Otherwise people can pipe Writable streams, which is just wrong.
                        Writable.prototype.pipe = function() {
                            errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
                        };
                        function writeAfterEnd(stream, cb) {
                            var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
                            errorOrDestroy(stream, er);
                            process.nextTick(cb, er);
                        } // Checks that a user-supplied chunk is valid, especially for the particular
                        // mode the stream is in. Currently this means that `null` is never accepted
                        // and undefined/non-string values are only allowed in object mode.
                        function validChunk(stream, state, chunk, cb) {
                            var er;
                            if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
                            else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
                                "string",
                                "Buffer"
                            ], chunk);
                            if (er) {
                                errorOrDestroy(stream, er);
                                process.nextTick(cb, er);
                                return false;
                            }
                            return true;
                        }
                        Writable.prototype.write = function(chunk, encoding, cb) {
                            var state = this._writableState;
                            var ret = false;
                            var isBuf = !state.objectMode && _isUint8Array(chunk);
                            if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
                            if (typeof encoding === "function") {
                                cb = encoding;
                                encoding = null;
                            }
                            if (isBuf) encoding = "buffer";
                            else if (!encoding) encoding = state.defaultEncoding;
                            if (typeof cb !== "function") cb = nop;
                            if (state.ending) writeAfterEnd(this, cb);
                            else if (isBuf || validChunk(this, state, chunk, cb)) {
                                state.pendingcb++;
                                ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
                            }
                            return ret;
                        };
                        Writable.prototype.cork = function() {
                            this._writableState.corked++;
                        };
                        Writable.prototype.uncork = function() {
                            var state = this._writableState;
                            if (state.corked) {
                                state.corked--;
                                if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
                            }
                        };
                        Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
                            // node::ParseEncoding() requires lower case.
                            if (typeof encoding === "string") encoding = encoding.toLowerCase();
                            if (!([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
                            this._writableState.defaultEncoding = encoding;
                            return this;
                        };
                        Object.defineProperty(Writable.prototype, "writableBuffer", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        });
                        function decodeChunk(state, chunk, encoding) {
                            if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
                            return chunk;
                        }
                        Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.highWaterMark;
                            }
                        }); // if we're already writing something, then just put this
                        // in the queue, and wait our turn.  Otherwise, call _write
                        // If we return false, then we need a drain event, so set that flag.
                        function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
                            if (!isBuf) {
                                var newChunk = decodeChunk(state, chunk, encoding);
                                if (chunk !== newChunk) {
                                    isBuf = true;
                                    encoding = "buffer";
                                    chunk = newChunk;
                                }
                            }
                            var len = state.objectMode ? 1 : chunk.length;
                            state.length += len;
                            var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
                            if (!ret) state.needDrain = true;
                            if (state.writing || state.corked) {
                                var last = state.lastBufferedRequest;
                                state.lastBufferedRequest = {
                                    chunk: chunk,
                                    encoding: encoding,
                                    isBuf: isBuf,
                                    callback: cb,
                                    next: null
                                };
                                if (last) last.next = state.lastBufferedRequest;
                                else state.bufferedRequest = state.lastBufferedRequest;
                                state.bufferedRequestCount += 1;
                            } else doWrite(stream, state, false, len, chunk, encoding, cb);
                            return ret;
                        }
                        function doWrite(stream, state, writev, len, chunk, encoding, cb) {
                            state.writelen = len;
                            state.writecb = cb;
                            state.writing = true;
                            state.sync = true;
                            if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
                            else if (writev) stream._writev(chunk, state.onwrite);
                            else stream._write(chunk, encoding, state.onwrite);
                            state.sync = false;
                        }
                        function onwriteError(stream, state, sync, er, cb) {
                            --state.pendingcb;
                            if (sync) {
                                // defer the callback if we are being called synchronously
                                // to avoid piling up things on the stack
                                process.nextTick(cb, er); // this can emit finish, and it will always happen
                                // after error
                                process.nextTick(finishMaybe, stream, state);
                                stream._writableState.errorEmitted = true;
                                errorOrDestroy(stream, er);
                            } else {
                                // the caller expect this to happen before if
                                // it is async
                                cb(er);
                                stream._writableState.errorEmitted = true;
                                errorOrDestroy(stream, er); // this can emit finish, but finish must
                                // always follow error
                                finishMaybe(stream, state);
                            }
                        }
                        function onwriteStateUpdate(state) {
                            state.writing = false;
                            state.writecb = null;
                            state.length -= state.writelen;
                            state.writelen = 0;
                        }
                        function onwrite(stream, er) {
                            var state = stream._writableState;
                            var sync = state.sync;
                            var cb = state.writecb;
                            if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
                            onwriteStateUpdate(state);
                            if (er) onwriteError(stream, state, sync, er, cb);
                            else {
                                // Check if we're actually ready to finish, but don't emit yet
                                var finished = needFinish(state) || stream.destroyed;
                                if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
                                if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
                                else afterWrite(stream, state, finished, cb);
                            }
                        }
                        function afterWrite(stream, state, finished, cb) {
                            if (!finished) onwriteDrain(stream, state);
                            state.pendingcb--;
                            cb();
                            finishMaybe(stream, state);
                        } // Must force callback to be called on nextTick, so that we don't
                        // emit 'drain' before the write() consumer gets the 'false' return
                        // value, and has a chance to attach a 'drain' listener.
                        function onwriteDrain(stream, state) {
                            if (state.length === 0 && state.needDrain) {
                                state.needDrain = false;
                                stream.emit("drain");
                            }
                        } // if there's something in the buffer waiting, then process it
                        function clearBuffer(stream, state) {
                            state.bufferProcessing = true;
                            var entry = state.bufferedRequest;
                            if (stream._writev && entry && entry.next) {
                                // Fast case, write everything using _writev()
                                var l = state.bufferedRequestCount;
                                var buffer = new Array(l);
                                var holder = state.corkedRequestsFree;
                                holder.entry = entry;
                                var count = 0;
                                var allBuffers = true;
                                while(entry){
                                    buffer[count] = entry;
                                    if (!entry.isBuf) allBuffers = false;
                                    entry = entry.next;
                                    count += 1;
                                }
                                buffer.allBuffers = allBuffers;
                                doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
                                // as the hot path ends with doWrite
                                state.pendingcb++;
                                state.lastBufferedRequest = null;
                                if (holder.next) {
                                    state.corkedRequestsFree = holder.next;
                                    holder.next = null;
                                } else state.corkedRequestsFree = new CorkedRequest(state);
                                state.bufferedRequestCount = 0;
                            } else {
                                // Slow case, write chunks one-by-one
                                while(entry){
                                    var chunk = entry.chunk;
                                    var encoding = entry.encoding;
                                    var cb = entry.callback;
                                    var len = state.objectMode ? 1 : chunk.length;
                                    doWrite(stream, state, false, len, chunk, encoding, cb);
                                    entry = entry.next;
                                    state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
                                    // it means that we need to wait until it does.
                                    // also, that means that the chunk and cb are currently
                                    // being processed, so move the buffer counter past them.
                                    if (state.writing) break;
                                }
                                if (entry === null) state.lastBufferedRequest = null;
                            }
                            state.bufferedRequest = entry;
                            state.bufferProcessing = false;
                        }
                        Writable.prototype._write = function(chunk, encoding, cb) {
                            cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
                        };
                        Writable.prototype._writev = null;
                        Writable.prototype.end = function(chunk, encoding, cb) {
                            var state = this._writableState;
                            if (typeof chunk === "function") {
                                cb = chunk;
                                chunk = null;
                                encoding = null;
                            } else if (typeof encoding === "function") {
                                cb = encoding;
                                encoding = null;
                            }
                            if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
                            if (state.corked) {
                                state.corked = 1;
                                this.uncork();
                            } // ignore unnecessary end() calls.
                            if (!state.ending) endWritable(this, state, cb);
                            return this;
                        };
                        Object.defineProperty(Writable.prototype, "writableLength", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                return this._writableState.length;
                            }
                        });
                        function needFinish(state) {
                            return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
                        }
                        function callFinal(stream, state) {
                            stream._final(function(err) {
                                state.pendingcb--;
                                if (err) errorOrDestroy(stream, err);
                                state.prefinished = true;
                                stream.emit("prefinish");
                                finishMaybe(stream, state);
                            });
                        }
                        function prefinish(stream, state) {
                            if (!state.prefinished && !state.finalCalled) {
                                if (typeof stream._final === "function" && !state.destroyed) {
                                    state.pendingcb++;
                                    state.finalCalled = true;
                                    process.nextTick(callFinal, stream, state);
                                } else {
                                    state.prefinished = true;
                                    stream.emit("prefinish");
                                }
                            }
                        }
                        function finishMaybe(stream, state) {
                            var need = needFinish(state);
                            if (need) {
                                prefinish(stream, state);
                                if (state.pendingcb === 0) {
                                    state.finished = true;
                                    stream.emit("finish");
                                    if (state.autoDestroy) {
                                        // In case of duplex streams we need a way to detect
                                        // if the readable side is ready for autoDestroy as well
                                        var rState = stream._readableState;
                                        if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
                                    }
                                }
                            }
                            return need;
                        }
                        function endWritable(stream, state, cb) {
                            state.ending = true;
                            finishMaybe(stream, state);
                            if (cb) {
                                if (state.finished) process.nextTick(cb);
                                else stream.once("finish", cb);
                            }
                            state.ended = true;
                            stream.writable = false;
                        }
                        function onCorkedFinish(corkReq, state, err) {
                            var entry = corkReq.entry;
                            corkReq.entry = null;
                            while(entry){
                                var cb = entry.callback;
                                state.pendingcb--;
                                cb(err);
                                entry = entry.next;
                            } // reuse the free corkReq.
                            state.corkedRequestsFree.next = corkReq;
                        }
                        Object.defineProperty(Writable.prototype, "destroyed", {
                            // making it explicit this property is not enumerable
                            // because otherwise some prototype manipulation in
                            // userland will fail
                            enumerable: false,
                            get: function get() {
                                if (this._writableState === undefined) return false;
                                return this._writableState.destroyed;
                            },
                            set: function set(value) {
                                // we ignore the value if the stream
                                // has not been initialized yet
                                if (!this._writableState) return;
                                 // backward compatibility, the user is explicitly
                                // managing destroyed
                                this._writableState.destroyed = value;
                            }
                        });
                        Writable.prototype.destroy = destroyImpl.destroy;
                        Writable.prototype._undestroy = destroyImpl.undestroy;
                        Writable.prototype._destroy = function(err, cb) {
                            cb(err);
                        };
                    }).call(this);
                }).call(this, require("_process"), typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "../errors": 42,
                "./_stream_duplex": 43,
                "./internal/streams/destroy": 50,
                "./internal/streams/state": 54,
                "./internal/streams/stream": 55,
                "_process": 39,
                "buffer": 35,
                "inherits": 38,
                "util-deprecate": 57
            }
        ],
        48: [
            function(require, module, exports) {
                (function(process) {
                    (function() {
                        "use strict";
                        var _Object$setPrototypeO;
                        function _defineProperty(obj, key, value) {
                            if (key in obj) Object.defineProperty(obj, key, {
                                value: value,
                                enumerable: true,
                                configurable: true,
                                writable: true
                            });
                            else obj[key] = value;
                            return obj;
                        }
                        var finished = require("./end-of-stream");
                        var kLastResolve = Symbol("lastResolve");
                        var kLastReject = Symbol("lastReject");
                        var kError = Symbol("error");
                        var kEnded = Symbol("ended");
                        var kLastPromise = Symbol("lastPromise");
                        var kHandlePromise = Symbol("handlePromise");
                        var kStream = Symbol("stream");
                        function createIterResult(value, done) {
                            return {
                                value: value,
                                done: done
                            };
                        }
                        function readAndResolve(iter) {
                            var resolve = iter[kLastResolve];
                            if (resolve !== null) {
                                var data = iter[kStream].read(); // we defer if data is null
                                // we can be expecting either 'end' or
                                // 'error'
                                if (data !== null) {
                                    iter[kLastPromise] = null;
                                    iter[kLastResolve] = null;
                                    iter[kLastReject] = null;
                                    resolve(createIterResult(data, false));
                                }
                            }
                        }
                        function onReadable(iter) {
                            // we wait for the next tick, because it might
                            // emit an error with process.nextTick
                            process.nextTick(readAndResolve, iter);
                        }
                        function wrapForNext(lastPromise, iter) {
                            return function(resolve, reject) {
                                lastPromise.then(function() {
                                    if (iter[kEnded]) {
                                        resolve(createIterResult(undefined, true));
                                        return;
                                    }
                                    iter[kHandlePromise](resolve, reject);
                                }, reject);
                            };
                        }
                        var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
                        var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
                            get stream () {
                                return this[kStream];
                            },
                            next: function next() {
                                var _this = this;
                                // if we have detected an error in the meanwhile
                                // reject straight away
                                var error = this[kError];
                                if (error !== null) return Promise.reject(error);
                                if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
                                if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
                                // called, the error will be emitted via nextTick, and
                                // we cannot guarantee that there is no error lingering around
                                // waiting to be emitted.
                                return new Promise(function(resolve, reject) {
                                    process.nextTick(function() {
                                        if (_this[kError]) reject(_this[kError]);
                                        else resolve(createIterResult(undefined, true));
                                    });
                                });
                                 // if we have multiple next() calls
                                // we will wait for the previous Promise to finish
                                // this logic is optimized to support for await loops,
                                // where next() is only called once at a time
                                var lastPromise = this[kLastPromise];
                                var promise;
                                if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
                                else {
                                    // fast path needed to support multiple this.push()
                                    // without triggering the next() queue
                                    var data = this[kStream].read();
                                    if (data !== null) return Promise.resolve(createIterResult(data, false));
                                    promise = new Promise(this[kHandlePromise]);
                                }
                                this[kLastPromise] = promise;
                                return promise;
                            }
                        }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
                            return this;
                        }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
                            var _this2 = this;
                            // destroy(err, cb) is a private API
                            // we can guarantee we have that here, because we control the
                            // Readable class this is attached to
                            return new Promise(function(resolve, reject) {
                                _this2[kStream].destroy(null, function(err) {
                                    if (err) {
                                        reject(err);
                                        return;
                                    }
                                    resolve(createIterResult(undefined, true));
                                });
                            });
                        }), _Object$setPrototypeO), AsyncIteratorPrototype);
                        var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
                            var _Object$create;
                            var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
                                value: stream,
                                writable: true
                            }), _defineProperty(_Object$create, kLastResolve, {
                                value: null,
                                writable: true
                            }), _defineProperty(_Object$create, kLastReject, {
                                value: null,
                                writable: true
                            }), _defineProperty(_Object$create, kError, {
                                value: null,
                                writable: true
                            }), _defineProperty(_Object$create, kEnded, {
                                value: stream._readableState.endEmitted,
                                writable: true
                            }), _defineProperty(_Object$create, kHandlePromise, {
                                value: function value(resolve, reject) {
                                    var data = iterator[kStream].read();
                                    if (data) {
                                        iterator[kLastPromise] = null;
                                        iterator[kLastResolve] = null;
                                        iterator[kLastReject] = null;
                                        resolve(createIterResult(data, false));
                                    } else {
                                        iterator[kLastResolve] = resolve;
                                        iterator[kLastReject] = reject;
                                    }
                                },
                                writable: true
                            }), _Object$create));
                            iterator[kLastPromise] = null;
                            finished(stream, function(err) {
                                if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                                    var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
                                    // returned by next() and store the error
                                    if (reject !== null) {
                                        iterator[kLastPromise] = null;
                                        iterator[kLastResolve] = null;
                                        iterator[kLastReject] = null;
                                        reject(err);
                                    }
                                    iterator[kError] = err;
                                    return;
                                }
                                var resolve = iterator[kLastResolve];
                                if (resolve !== null) {
                                    iterator[kLastPromise] = null;
                                    iterator[kLastResolve] = null;
                                    iterator[kLastReject] = null;
                                    resolve(createIterResult(undefined, true));
                                }
                                iterator[kEnded] = true;
                            });
                            stream.on("readable", onReadable.bind(null, iterator));
                            return iterator;
                        };
                        module.exports = createReadableStreamAsyncIterator;
                    }).call(this);
                }).call(this, require("_process"));
            },
            {
                "./end-of-stream": 51,
                "_process": 39
            }
        ],
        49: [
            function(require, module, exports) {
                "use strict";
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        if (enumerableOnly) symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        });
                        keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = arguments[i] != null ? arguments[i] : {};
                        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        });
                        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                        else ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var _require = require("buffer"), Buffer = _require.Buffer;
                var _require2 = require("util"), inspect = _require2.inspect;
                var custom = inspect && inspect.custom || "inspect";
                function copyBuffer(src, target, offset) {
                    Buffer.prototype.copy.call(src, target, offset);
                }
                module.exports = /*#__PURE__*/ function() {
                    function BufferList() {
                        _classCallCheck(this, BufferList);
                        this.head = null;
                        this.tail = null;
                        this.length = 0;
                    }
                    _createClass(BufferList, [
                        {
                            key: "push",
                            value: function push(v) {
                                var entry = {
                                    data: v,
                                    next: null
                                };
                                if (this.length > 0) this.tail.next = entry;
                                else this.head = entry;
                                this.tail = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function unshift(v) {
                                var entry = {
                                    data: v,
                                    next: this.head
                                };
                                if (this.length === 0) this.tail = entry;
                                this.head = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function shift() {
                                if (this.length === 0) return;
                                var ret = this.head.data;
                                if (this.length === 1) this.head = this.tail = null;
                                else this.head = this.head.next;
                                --this.length;
                                return ret;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.head = this.tail = null;
                                this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function join(s) {
                                if (this.length === 0) return "";
                                var p = this.head;
                                var ret = "" + p.data;
                                while(p = p.next)ret += s + p.data;
                                return ret;
                            }
                        },
                        {
                            key: "concat",
                            value: function concat(n) {
                                if (this.length === 0) return Buffer.alloc(0);
                                var ret = Buffer.allocUnsafe(n >>> 0);
                                var p = this.head;
                                var i = 0;
                                while(p){
                                    copyBuffer(p.data, ret, i);
                                    i += p.data.length;
                                    p = p.next;
                                }
                                return ret;
                            } // Consumes a specified amount of bytes or characters from the buffered data.
                        },
                        {
                            key: "consume",
                            value: function consume(n, hasStrings) {
                                var ret;
                                if (n < this.head.data.length) {
                                    // `slice` is the same for buffers and strings.
                                    ret = this.head.data.slice(0, n);
                                    this.head.data = this.head.data.slice(n);
                                } else if (n === this.head.data.length) // First chunk is a perfect match.
                                ret = this.shift();
                                else // Result spans more than one buffer.
                                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                                return ret;
                            }
                        },
                        {
                            key: "first",
                            value: function first() {
                                return this.head.data;
                            } // Consumes a specified amount of characters from the buffered data.
                        },
                        {
                            key: "_getString",
                            value: function _getString(n) {
                                var p = this.head;
                                var c = 1;
                                var ret = p.data;
                                n -= ret.length;
                                while(p = p.next){
                                    var str = p.data;
                                    var nb = n > str.length ? str.length : n;
                                    if (nb === str.length) ret += str;
                                    else ret += str.slice(0, n);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === str.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = str.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            } // Consumes a specified amount of bytes from the buffered data.
                        },
                        {
                            key: "_getBuffer",
                            value: function _getBuffer(n) {
                                var ret = Buffer.allocUnsafe(n);
                                var p = this.head;
                                var c = 1;
                                p.data.copy(ret);
                                n -= p.data.length;
                                while(p = p.next){
                                    var buf = p.data;
                                    var nb = n > buf.length ? buf.length : n;
                                    buf.copy(ret, ret.length - n, 0, nb);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === buf.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = buf.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            } // Make sure the linked list only shows the minimal necessary information.
                        },
                        {
                            key: custom,
                            value: function value(_, options) {
                                return inspect(this, _objectSpread({}, options, {
                                    // Only inspect one level.
                                    depth: 0,
                                    // It should not recurse.
                                    customInspect: false
                                }));
                            }
                        }
                    ]);
                    return BufferList;
                }();
            },
            {
                "buffer": 35,
                "util": 34
            }
        ],
        50: [
            function(require, module, exports) {
                (function(process) {
                    (function() {
                        "use strict"; // undocumented cb() API, needed for core, not for public API
                        function destroy(err, cb) {
                            var _this = this;
                            var readableDestroyed = this._readableState && this._readableState.destroyed;
                            var writableDestroyed = this._writableState && this._writableState.destroyed;
                            if (readableDestroyed || writableDestroyed) {
                                if (cb) cb(err);
                                else if (err) {
                                    if (!this._writableState) process.nextTick(emitErrorNT, this, err);
                                    else if (!this._writableState.errorEmitted) {
                                        this._writableState.errorEmitted = true;
                                        process.nextTick(emitErrorNT, this, err);
                                    }
                                }
                                return this;
                            } // we set destroyed to true before firing error callbacks in order
                            // to make it re-entrance safe in case destroy() is called within callbacks
                            if (this._readableState) this._readableState.destroyed = true;
                             // if this is a duplex stream mark the writable part as destroyed as well
                            if (this._writableState) this._writableState.destroyed = true;
                            this._destroy(err || null, function(err) {
                                if (!cb && err) {
                                    if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
                                    else if (!_this._writableState.errorEmitted) {
                                        _this._writableState.errorEmitted = true;
                                        process.nextTick(emitErrorAndCloseNT, _this, err);
                                    } else process.nextTick(emitCloseNT, _this);
                                } else if (cb) {
                                    process.nextTick(emitCloseNT, _this);
                                    cb(err);
                                } else process.nextTick(emitCloseNT, _this);
                            });
                            return this;
                        }
                        function emitErrorAndCloseNT(self1, err) {
                            emitErrorNT(self1, err);
                            emitCloseNT(self1);
                        }
                        function emitCloseNT(self1) {
                            if (self1._writableState && !self1._writableState.emitClose) return;
                            if (self1._readableState && !self1._readableState.emitClose) return;
                            self1.emit("close");
                        }
                        function undestroy() {
                            if (this._readableState) {
                                this._readableState.destroyed = false;
                                this._readableState.reading = false;
                                this._readableState.ended = false;
                                this._readableState.endEmitted = false;
                            }
                            if (this._writableState) {
                                this._writableState.destroyed = false;
                                this._writableState.ended = false;
                                this._writableState.ending = false;
                                this._writableState.finalCalled = false;
                                this._writableState.prefinished = false;
                                this._writableState.finished = false;
                                this._writableState.errorEmitted = false;
                            }
                        }
                        function emitErrorNT(self1, err) {
                            self1.emit("error", err);
                        }
                        function errorOrDestroy(stream, err) {
                            // We have tests that rely on errors being emitted
                            // in the same tick, so changing this is semver major.
                            // For now when you opt-in to autoDestroy we allow
                            // the error to be emitted nextTick. In a future
                            // semver major update we should change the default to this.
                            var rState = stream._readableState;
                            var wState = stream._writableState;
                            if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
                            else stream.emit("error", err);
                        }
                        module.exports = {
                            destroy: destroy,
                            undestroy: undestroy,
                            errorOrDestroy: errorOrDestroy
                        };
                    }).call(this);
                }).call(this, require("_process"));
            },
            {
                "_process": 39
            }
        ],
        51: [
            function(require, module, exports) {
                // Ported from https://github.com/mafintosh/end-of-stream with
                // permission from the author, Mathias Buus (@mafintosh).
                "use strict";
                var ERR_STREAM_PREMATURE_CLOSE = require("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        callback.apply(this, args);
                    };
                }
                function noop() {}
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === "function";
                }
                function eos(stream, opts, callback) {
                    if (typeof opts === "function") return eos(stream, null, opts);
                    if (!opts) opts = {};
                    callback = once(callback || noop);
                    var readable = opts.readable || opts.readable !== false && stream.readable;
                    var writable = opts.writable || opts.writable !== false && stream.writable;
                    var onlegacyfinish = function onlegacyfinish() {
                        if (!stream.writable) onfinish();
                    };
                    var writableEnded = stream._writableState && stream._writableState.finished;
                    var onfinish = function onfinish() {
                        writable = false;
                        writableEnded = true;
                        if (!readable) callback.call(stream);
                    };
                    var readableEnded = stream._readableState && stream._readableState.endEmitted;
                    var onend = function onend() {
                        readable = false;
                        readableEnded = true;
                        if (!writable) callback.call(stream);
                    };
                    var onerror = function onerror(err) {
                        callback.call(stream, err);
                    };
                    var onclose = function onclose() {
                        var err;
                        if (readable && !readableEnded) {
                            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                        if (writable && !writableEnded) {
                            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                    };
                    var onrequest = function onrequest() {
                        stream.req.on("finish", onfinish);
                    };
                    if (isRequest(stream)) {
                        stream.on("complete", onfinish);
                        stream.on("abort", onclose);
                        if (stream.req) onrequest();
                        else stream.on("request", onrequest);
                    } else if (writable && !stream._writableState) {
                        // legacy streams
                        stream.on("end", onlegacyfinish);
                        stream.on("close", onlegacyfinish);
                    }
                    stream.on("end", onend);
                    stream.on("finish", onfinish);
                    if (opts.error !== false) stream.on("error", onerror);
                    stream.on("close", onclose);
                    return function() {
                        stream.removeListener("complete", onfinish);
                        stream.removeListener("abort", onclose);
                        stream.removeListener("request", onrequest);
                        if (stream.req) stream.req.removeListener("finish", onfinish);
                        stream.removeListener("end", onlegacyfinish);
                        stream.removeListener("close", onlegacyfinish);
                        stream.removeListener("finish", onfinish);
                        stream.removeListener("end", onend);
                        stream.removeListener("error", onerror);
                        stream.removeListener("close", onclose);
                    };
                }
                module.exports = eos;
            },
            {
                "../../../errors": 42
            }
        ],
        52: [
            function(require, module, exports) {
                module.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        53: [
            function(require, module, exports) {
                // Ported from https://github.com/mafintosh/pump with
                // permission from the author, Mathias Buus (@mafintosh).
                "use strict";
                var eos;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        callback.apply(void 0, arguments);
                    };
                }
                var _require$codes = require("../../../errors").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
                function noop(err) {
                    // Rethrow the error if it exists to avoid swallowing it
                    if (err) throw err;
                }
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === "function";
                }
                function destroyer(stream, reading, writing, callback) {
                    callback = once(callback);
                    var closed = false;
                    stream.on("close", function() {
                        closed = true;
                    });
                    if (eos === undefined) eos = require("./end-of-stream");
                    eos(stream, {
                        readable: reading,
                        writable: writing
                    }, function(err) {
                        if (err) return callback(err);
                        closed = true;
                        callback();
                    });
                    var destroyed = false;
                    return function(err) {
                        if (closed) return;
                        if (destroyed) return;
                        destroyed = true; // request.destroy just do .end - .abort is what we want
                        if (isRequest(stream)) return stream.abort();
                        if (typeof stream.destroy === "function") return stream.destroy();
                        callback(err || new ERR_STREAM_DESTROYED("pipe"));
                    };
                }
                function call(fn) {
                    fn();
                }
                function pipe(from, to) {
                    return from.pipe(to);
                }
                function popCallback(streams) {
                    if (!streams.length) return noop;
                    if (typeof streams[streams.length - 1] !== "function") return noop;
                    return streams.pop();
                }
                function pipeline() {
                    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
                    var callback = popCallback(streams);
                    if (Array.isArray(streams[0])) streams = streams[0];
                    if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
                    var error;
                    var destroys = streams.map(function(stream, i) {
                        var reading = i < streams.length - 1;
                        var writing = i > 0;
                        return destroyer(stream, reading, writing, function(err) {
                            if (!error) error = err;
                            if (err) destroys.forEach(call);
                            if (reading) return;
                            destroys.forEach(call);
                            callback(error);
                        });
                    });
                    return streams.reduce(pipe);
                }
                module.exports = pipeline;
            },
            {
                "../../../errors": 42,
                "./end-of-stream": 51
            }
        ],
        54: [
            function(require, module, exports) {
                "use strict";
                var ERR_INVALID_OPT_VALUE = require("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                function highWaterMarkFrom(options, isDuplex, duplexKey) {
                    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
                }
                function getHighWaterMark(state, options, duplexKey, isDuplex) {
                    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
                    if (hwm != null) {
                        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                            var name = isDuplex ? duplexKey : "highWaterMark";
                            throw new ERR_INVALID_OPT_VALUE(name, hwm);
                        }
                        return Math.floor(hwm);
                    } // Default value
                    return state.objectMode ? 16 : 16384;
                }
                module.exports = {
                    getHighWaterMark: getHighWaterMark
                };
            },
            {
                "../../../errors": 42
            }
        ],
        55: [
            function(require, module, exports) {
                module.exports = require("events").EventEmitter;
            },
            {
                "events": 36
            }
        ],
        56: [
            function(require, module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                "use strict";
                /*<replacement>*/ var Buffer = require("safe-buffer").Buffer;
                /*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
                    encoding = "" + encoding;
                    switch(encoding && encoding.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return true;
                        default:
                            return false;
                    }
                };
                function _normalizeEncoding(enc) {
                    if (!enc) return "utf8";
                    var retried;
                    while(true)switch(enc){
                        case "utf8":
                        case "utf-8":
                            return "utf8";
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return "utf16le";
                        case "latin1":
                        case "binary":
                            return "latin1";
                        case "base64":
                        case "ascii":
                        case "hex":
                            return enc;
                        default:
                            if (retried) return; // undefined
                            enc = ("" + enc).toLowerCase();
                            retried = true;
                    }
                }
                // Do not cache `Buffer.isEncoding` when checking encoding names as some
                // modules monkey-patch it to support additional encodings
                function normalizeEncoding(enc) {
                    var nenc = _normalizeEncoding(enc);
                    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
                    return nenc || enc;
                }
                // StringDecoder provides an interface for efficiently splitting a series of
                // buffers into a series of JS strings without breaking apart multi-byte
                // characters.
                exports.StringDecoder = StringDecoder;
                function StringDecoder(encoding) {
                    this.encoding = normalizeEncoding(encoding);
                    var nb;
                    switch(this.encoding){
                        case "utf16le":
                            this.text = utf16Text;
                            this.end = utf16End;
                            nb = 4;
                            break;
                        case "utf8":
                            this.fillLast = utf8FillLast;
                            nb = 4;
                            break;
                        case "base64":
                            this.text = base64Text;
                            this.end = base64End;
                            nb = 3;
                            break;
                        default:
                            this.write = simpleWrite;
                            this.end = simpleEnd;
                            return;
                    }
                    this.lastNeed = 0;
                    this.lastTotal = 0;
                    this.lastChar = Buffer.allocUnsafe(nb);
                }
                StringDecoder.prototype.write = function(buf) {
                    if (buf.length === 0) return "";
                    var r;
                    var i;
                    if (this.lastNeed) {
                        r = this.fillLast(buf);
                        if (r === undefined) return "";
                        i = this.lastNeed;
                        this.lastNeed = 0;
                    } else i = 0;
                    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
                    return r || "";
                };
                StringDecoder.prototype.end = utf8End;
                // Returns only complete characters in a Buffer
                StringDecoder.prototype.text = utf8Text;
                // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
                StringDecoder.prototype.fillLast = function(buf) {
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
                    this.lastNeed -= buf.length;
                };
                // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
                // continuation byte. If an invalid byte is detected, -2 is returned.
                function utf8CheckByte(byte) {
                    if (byte <= 0x7F) return 0;
                    else if (byte >> 5 === 0x06) return 2;
                    else if (byte >> 4 === 0x0E) return 3;
                    else if (byte >> 3 === 0x1E) return 4;
                    return byte >> 6 === 0x02 ? -1 : -2;
                }
                // Checks at most 3 bytes at the end of a Buffer in order to detect an
                // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
                // needed to complete the UTF-8 character (if applicable) are returned.
                function utf8CheckIncomplete(self1, buf, i) {
                    var j = buf.length - 1;
                    if (j < i) return 0;
                    var nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 1;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 2;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) {
                            if (nb === 2) nb = 0;
                            else self1.lastNeed = nb - 3;
                        }
                        return nb;
                    }
                    return 0;
                }
                // Validates as many continuation bytes for a multi-byte UTF-8 character as
                // needed or are available. If we see a non-continuation byte where we expect
                // one, we "replace" the validated continuation bytes we've seen so far with
                // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
                // behavior. The continuation byte check is included three times in the case
                // where all of the continuation bytes for a character exist in the same buffer.
                // It is also done this way as a slight performance increase instead of using a
                // loop.
                function utf8CheckExtraBytes(self1, buf, p) {
                    if ((buf[0] & 0xC0) !== 0x80) {
                        self1.lastNeed = 0;
                        return "\uFFFD";
                    }
                    if (self1.lastNeed > 1 && buf.length > 1) {
                        if ((buf[1] & 0xC0) !== 0x80) {
                            self1.lastNeed = 1;
                            return "\uFFFD";
                        }
                        if (self1.lastNeed > 2 && buf.length > 2) {
                            if ((buf[2] & 0xC0) !== 0x80) {
                                self1.lastNeed = 2;
                                return "\uFFFD";
                            }
                        }
                    }
                }
                // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
                function utf8FillLast(buf) {
                    var p = this.lastTotal - this.lastNeed;
                    var r = utf8CheckExtraBytes(this, buf, p);
                    if (r !== undefined) return r;
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, p, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, p, 0, buf.length);
                    this.lastNeed -= buf.length;
                }
                // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
                // partial character, the character's bytes are buffered until the required
                // number of bytes are available.
                function utf8Text(buf, i) {
                    var total = utf8CheckIncomplete(this, buf, i);
                    if (!this.lastNeed) return buf.toString("utf8", i);
                    this.lastTotal = total;
                    var end = buf.length - (total - this.lastNeed);
                    buf.copy(this.lastChar, 0, end);
                    return buf.toString("utf8", i, end);
                }
                // For UTF-8, a replacement character is added when ending on a partial
                // character.
                function utf8End(buf) {
                    var r = buf && buf.length ? this.write(buf) : "";
                    if (this.lastNeed) return r + "\uFFFD";
                    return r;
                }
                // UTF-16LE typically needs two bytes per character, but even if we have an even
                // number of bytes available, we need to check if we end on a leading/high
                // surrogate. In that case, we need to wait for the next two bytes in order to
                // decode the last character properly.
                function utf16Text(buf, i) {
                    if ((buf.length - i) % 2 === 0) {
                        var r = buf.toString("utf16le", i);
                        if (r) {
                            var c = r.charCodeAt(r.length - 1);
                            if (c >= 0xD800 && c <= 0xDBFF) {
                                this.lastNeed = 2;
                                this.lastTotal = 4;
                                this.lastChar[0] = buf[buf.length - 2];
                                this.lastChar[1] = buf[buf.length - 1];
                                return r.slice(0, -1);
                            }
                        }
                        return r;
                    }
                    this.lastNeed = 1;
                    this.lastTotal = 2;
                    this.lastChar[0] = buf[buf.length - 1];
                    return buf.toString("utf16le", i, buf.length - 1);
                }
                // For UTF-16LE we do not explicitly append special replacement characters if we
                // end on a partial character, we simply let v8 handle that.
                function utf16End(buf) {
                    var r = buf && buf.length ? this.write(buf) : "";
                    if (this.lastNeed) {
                        var end = this.lastTotal - this.lastNeed;
                        return r + this.lastChar.toString("utf16le", 0, end);
                    }
                    return r;
                }
                function base64Text(buf, i) {
                    var n = (buf.length - i) % 3;
                    if (n === 0) return buf.toString("base64", i);
                    this.lastNeed = 3 - n;
                    this.lastTotal = 3;
                    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
                    else {
                        this.lastChar[0] = buf[buf.length - 2];
                        this.lastChar[1] = buf[buf.length - 1];
                    }
                    return buf.toString("base64", i, buf.length - n);
                }
                function base64End(buf) {
                    var r = buf && buf.length ? this.write(buf) : "";
                    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
                    return r;
                }
                // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
                function simpleWrite(buf) {
                    return buf.toString(this.encoding);
                }
                function simpleEnd(buf) {
                    return buf && buf.length ? this.write(buf) : "";
                }
            },
            {
                "safe-buffer": 40
            }
        ],
        57: [
            function(require, module, exports) {
                (function(global) {
                    (function() {
                        /**
 * Module exports.
 */ module.exports = deprecate;
                        /**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
                            if (config("noDeprecation")) return fn;
                            var warned = false;
                            function deprecated() {
                                if (!warned) {
                                    if (config("throwDeprecation")) throw new Error(msg);
                                    else if (config("traceDeprecation")) console.trace(msg);
                                    else console.warn(msg);
                                    warned = true;
                                }
                                return fn.apply(this, arguments);
                            }
                            return deprecated;
                        }
                        /**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
                            // accessing global.localStorage can trigger a DOMException in sandboxed iframes
                            try {
                                if (!global.localStorage) return false;
                            } catch (_) {
                                return false;
                            }
                            var val = global.localStorage[name];
                            if (null == val) return false;
                            return String(val).toLowerCase() === "true";
                        }
                    }).call(this);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        58: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                Object.defineProperty(exports, "v1", {
                    enumerable: true,
                    get: function() {
                        return _v.default;
                    }
                });
                Object.defineProperty(exports, "v3", {
                    enumerable: true,
                    get: function() {
                        return _v2.default;
                    }
                });
                Object.defineProperty(exports, "v4", {
                    enumerable: true,
                    get: function() {
                        return _v3.default;
                    }
                });
                Object.defineProperty(exports, "v5", {
                    enumerable: true,
                    get: function() {
                        return _v4.default;
                    }
                });
                Object.defineProperty(exports, "NIL", {
                    enumerable: true,
                    get: function() {
                        return _nil.default;
                    }
                });
                Object.defineProperty(exports, "version", {
                    enumerable: true,
                    get: function() {
                        return _version.default;
                    }
                });
                Object.defineProperty(exports, "validate", {
                    enumerable: true,
                    get: function() {
                        return _validate.default;
                    }
                });
                Object.defineProperty(exports, "stringify", {
                    enumerable: true,
                    get: function() {
                        return _stringify.default;
                    }
                });
                Object.defineProperty(exports, "parse", {
                    enumerable: true,
                    get: function() {
                        return _parse.default;
                    }
                });
                var _v = _interopRequireDefault(require("./v1.js"));
                var _v2 = _interopRequireDefault(require("./v3.js"));
                var _v3 = _interopRequireDefault(require("./v4.js"));
                var _v4 = _interopRequireDefault(require("./v5.js"));
                var _nil = _interopRequireDefault(require("./nil.js"));
                var _version = _interopRequireDefault(require("./version.js"));
                var _validate = _interopRequireDefault(require("./validate.js"));
                var _stringify = _interopRequireDefault(require("./stringify.js"));
                var _parse = _interopRequireDefault(require("./parse.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
            },
            {
                "./nil.js": 60,
                "./parse.js": 61,
                "./stringify.js": 65,
                "./v1.js": 66,
                "./v3.js": 67,
                "./v4.js": 69,
                "./v5.js": 70,
                "./validate.js": 71,
                "./version.js": 72
            }
        ],
        59: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                /*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ function md5(bytes) {
                    if (typeof bytes === "string") {
                        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
                        bytes = new Uint8Array(msg.length);
                        for(let i = 0; i < msg.length; ++i)bytes[i] = msg.charCodeAt(i);
                    }
                    return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
                }
                /*
 * Convert an array of little-endian words to an array of bytes
 */ function md5ToHexEncodedArray(input) {
                    const output = [];
                    const length32 = input.length * 32;
                    const hexTab = "0123456789abcdef";
                    for(let i = 0; i < length32; i += 8){
                        const x = input[i >> 5] >>> i % 32 & 0xff;
                        const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
                        output.push(hex);
                    }
                    return output;
                }
                /**
 * Calculate output length with padding and bit length
 */ function getOutputLength(inputLength8) {
                    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
                }
                /*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */ function wordsToMd5(x, len) {
                    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
                    x[getOutputLength(len) - 1] = len;
                    let a = 1732584193;
                    let b = -271733879;
                    let c = -1732584194;
                    let d = 271733878;
                    for(let i = 0; i < x.length; i += 16){
                        const olda = a;
                        const oldb = b;
                        const oldc = c;
                        const oldd = d;
                        a = md5ff(a, b, c, d, x[i], 7, -680876936);
                        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
                        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
                        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
                        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
                        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
                        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
                        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
                        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
                        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
                        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
                        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
                        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
                        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
                        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
                        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
                        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
                        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
                        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
                        b = md5gg(b, c, d, a, x[i], 20, -373897302);
                        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
                        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
                        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
                        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
                        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
                        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
                        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
                        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
                        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
                        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
                        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
                        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
                        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
                        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
                        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
                        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
                        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
                        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
                        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
                        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
                        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
                        d = md5hh(d, a, b, c, x[i], 11, -358537222);
                        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
                        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
                        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
                        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
                        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
                        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
                        a = md5ii(a, b, c, d, x[i], 6, -198630844);
                        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
                        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
                        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
                        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
                        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
                        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
                        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
                        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
                        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
                        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
                        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
                        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
                        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
                        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
                        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
                        a = safeAdd(a, olda);
                        b = safeAdd(b, oldb);
                        c = safeAdd(c, oldc);
                        d = safeAdd(d, oldd);
                    }
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                }
                /*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */ function bytesToWords(input) {
                    if (input.length === 0) return [];
                    const length8 = input.length * 8;
                    const output = new Uint32Array(getOutputLength(length8));
                    for(let i = 0; i < length8; i += 8)output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
                    return output;
                }
                /*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function safeAdd(x, y) {
                    const lsw = (x & 0xffff) + (y & 0xffff);
                    const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
                    return msw << 16 | lsw & 0xffff;
                }
                /*
 * Bitwise rotate a 32-bit number to the left.
 */ function bitRotateLeft(num, cnt) {
                    return num << cnt | num >>> 32 - cnt;
                }
                /*
 * These functions implement the four basic operations the algorithm uses.
 */ function md5cmn(q, a, b, x, s, t) {
                    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
                }
                function md5ff(a, b, c, d, x, s, t) {
                    return md5cmn(b & c | ~b & d, a, b, x, s, t);
                }
                function md5gg(a, b, c, d, x, s, t) {
                    return md5cmn(b & d | c & ~d, a, b, x, s, t);
                }
                function md5hh(a, b, c, d, x, s, t) {
                    return md5cmn(b ^ c ^ d, a, b, x, s, t);
                }
                function md5ii(a, b, c, d, x, s, t) {
                    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
                }
                var _default = md5;
                exports.default = _default;
            },
            {}
        ],
        60: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _default = "00000000-0000-0000-0000-000000000000";
                exports.default = _default;
            },
            {}
        ],
        61: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _validate = _interopRequireDefault(require("./validate.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function parse(uuid) {
                    if (!(0, _validate.default)(uuid)) throw TypeError("Invalid UUID");
                    let v;
                    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
                    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
                    arr[1] = v >>> 16 & 0xff;
                    arr[2] = v >>> 8 & 0xff;
                    arr[3] = v & 0xff; // Parse ........-####-....-....-............
                    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
                    arr[5] = v & 0xff; // Parse ........-....-####-....-............
                    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
                    arr[7] = v & 0xff; // Parse ........-....-....-####-............
                    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
                    arr[9] = v & 0xff; // Parse ........-....-....-....-############
                    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
                    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
                    arr[11] = v / 0x100000000 & 0xff;
                    arr[12] = v >>> 24 & 0xff;
                    arr[13] = v >>> 16 & 0xff;
                    arr[14] = v >>> 8 & 0xff;
                    arr[15] = v & 0xff;
                    return arr;
                }
                var _default = parse;
                exports.default = _default;
            },
            {
                "./validate.js": 71
            }
        ],
        62: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
                exports.default = _default;
            },
            {}
        ],
        63: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = rng;
                // Unique ID creation requires a high quality random # generator. In the browser we therefore
                // require the crypto API and do not support built-in fallback to lower quality random number
                // generators (like Math.random()).
                let getRandomValues;
                const rnds8 = new Uint8Array(16);
                function rng() {
                    // lazy load so that environments that need to polyfill have a chance to do so
                    if (!getRandomValues) {
                        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
                        // find the complete implementation of crypto (msCrypto) on IE11.
                        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
                        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    }
                    return getRandomValues(rnds8);
                }
            },
            {}
        ],
        64: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                // Adapted from Chris Veness' SHA1 code at
                // http://www.movable-type.co.uk/scripts/sha1.html
                function f(s, x, y, z) {
                    switch(s){
                        case 0:
                            return x & y ^ ~x & z;
                        case 1:
                            return x ^ y ^ z;
                        case 2:
                            return x & y ^ x & z ^ y & z;
                        case 3:
                            return x ^ y ^ z;
                    }
                }
                function ROTL(x, n) {
                    return x << n | x >>> 32 - n;
                }
                function sha1(bytes) {
                    const K = [
                        0x5a827999,
                        0x6ed9eba1,
                        0x8f1bbcdc,
                        0xca62c1d6
                    ];
                    const H = [
                        0x67452301,
                        0xefcdab89,
                        0x98badcfe,
                        0x10325476,
                        0xc3d2e1f0
                    ];
                    if (typeof bytes === "string") {
                        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
                        bytes = [];
                        for(let i = 0; i < msg.length; ++i)bytes.push(msg.charCodeAt(i));
                    } else if (!Array.isArray(bytes)) // Convert Array-like to Array
                    bytes = Array.prototype.slice.call(bytes);
                    bytes.push(0x80);
                    const l = bytes.length / 4 + 2;
                    const N = Math.ceil(l / 16);
                    const M = new Array(N);
                    for(let i = 0; i < N; ++i){
                        const arr = new Uint32Array(16);
                        for(let j = 0; j < 16; ++j)arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
                        M[i] = arr;
                    }
                    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
                    M[N - 1][14] = Math.floor(M[N - 1][14]);
                    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
                    for(let i = 0; i < N; ++i){
                        const W = new Uint32Array(80);
                        for(let t = 0; t < 16; ++t)W[t] = M[i][t];
                        for(let t = 16; t < 80; ++t)W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
                        let a = H[0];
                        let b = H[1];
                        let c = H[2];
                        let d = H[3];
                        let e = H[4];
                        for(let t = 0; t < 80; ++t){
                            const s = Math.floor(t / 20);
                            const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
                            e = d;
                            d = c;
                            c = ROTL(b, 30) >>> 0;
                            b = a;
                            a = T;
                        }
                        H[0] = H[0] + a >>> 0;
                        H[1] = H[1] + b >>> 0;
                        H[2] = H[2] + c >>> 0;
                        H[3] = H[3] + d >>> 0;
                        H[4] = H[4] + e >>> 0;
                    }
                    return [
                        H[0] >> 24 & 0xff,
                        H[0] >> 16 & 0xff,
                        H[0] >> 8 & 0xff,
                        H[0] & 0xff,
                        H[1] >> 24 & 0xff,
                        H[1] >> 16 & 0xff,
                        H[1] >> 8 & 0xff,
                        H[1] & 0xff,
                        H[2] >> 24 & 0xff,
                        H[2] >> 16 & 0xff,
                        H[2] >> 8 & 0xff,
                        H[2] & 0xff,
                        H[3] >> 24 & 0xff,
                        H[3] >> 16 & 0xff,
                        H[3] >> 8 & 0xff,
                        H[3] & 0xff,
                        H[4] >> 24 & 0xff,
                        H[4] >> 16 & 0xff,
                        H[4] >> 8 & 0xff,
                        H[4] & 0xff
                    ];
                }
                var _default = sha1;
                exports.default = _default;
            },
            {}
        ],
        65: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _validate = _interopRequireDefault(require("./validate.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                /**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
                for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
                function stringify(arr, offset = 0) {
                    // Note: Be careful editing this code!  It's been tuned for performance
                    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
                    const uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
                    // of the following:
                    // - One or more input array values don't map to a hex octet (leading to
                    // "undefined" in the uuid)
                    // - Invalid input values for the RFC `version` or `variant` fields
                    if (!(0, _validate.default)(uuid)) throw TypeError("Stringified UUID is invalid");
                    return uuid;
                }
                var _default = stringify;
                exports.default = _default;
            },
            {
                "./validate.js": 71
            }
        ],
        66: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _rng = _interopRequireDefault(require("./rng.js"));
                var _stringify = _interopRequireDefault(require("./stringify.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                // **`v1()` - Generate time-based UUID**
                //
                // Inspired by https://github.com/LiosK/UUID.js
                // and http://docs.python.org/library/uuid.html
                let _nodeId;
                let _clockseq; // Previous uuid creation time
                let _lastMSecs = 0;
                let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
                function v1(options, buf, offset) {
                    let i = buf && offset || 0;
                    const b = buf || new Array(16);
                    options = options || {};
                    let node = options.node || _nodeId;
                    let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
                    // specified.  We do this lazily to minimize issues related to insufficient
                    // system entropy.  See #189
                    if (node == null || clockseq == null) {
                        const seedBytes = options.random || (options.rng || _rng.default)();
                        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
                        node = _nodeId = [
                            seedBytes[0] | 0x01,
                            seedBytes[1],
                            seedBytes[2],
                            seedBytes[3],
                            seedBytes[4],
                            seedBytes[5]
                        ];
                        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
                        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
                    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
                    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
                    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
                    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
                    let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
                    // cycle to simulate higher resolution clock
                    let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
                    const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
                    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
                     // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
                    // time interval
                    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
                     // Per 4.2.1.2 Throw error if too many uuids are requested
                    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    _lastMSecs = msecs;
                    _lastNSecs = nsecs;
                    _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
                    msecs += 12219292800000; // `time_low`
                    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
                    b[i++] = tl >>> 24 & 0xff;
                    b[i++] = tl >>> 16 & 0xff;
                    b[i++] = tl >>> 8 & 0xff;
                    b[i++] = tl & 0xff; // `time_mid`
                    const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
                    b[i++] = tmh >>> 8 & 0xff;
                    b[i++] = tmh & 0xff; // `time_high_and_version`
                    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
                    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
                    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
                    b[i++] = clockseq & 0xff; // `node`
                    for(let n = 0; n < 6; ++n)b[i + n] = node[n];
                    return buf || (0, _stringify.default)(b);
                }
                var _default = v1;
                exports.default = _default;
            },
            {
                "./rng.js": 63,
                "./stringify.js": 65
            }
        ],
        67: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _v = _interopRequireDefault(require("./v35.js"));
                var _md = _interopRequireDefault(require("./md5.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                const v3 = (0, _v.default)("v3", 0x30, _md.default);
                var _default = v3;
                exports.default = _default;
            },
            {
                "./md5.js": 59,
                "./v35.js": 68
            }
        ],
        68: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = _default;
                exports.URL = exports.DNS = void 0;
                var _stringify = _interopRequireDefault(require("./stringify.js"));
                var _parse = _interopRequireDefault(require("./parse.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function stringToBytes(str) {
                    str = unescape(encodeURIComponent(str)); // UTF8 escape
                    const bytes = [];
                    for(let i = 0; i < str.length; ++i)bytes.push(str.charCodeAt(i));
                    return bytes;
                }
                const DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                exports.DNS = DNS;
                const URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                exports.URL = URL;
                function _default(name, version, hashfunc) {
                    function generateUUID(value, namespace, buf, offset) {
                        if (typeof value === "string") value = stringToBytes(value);
                        if (typeof namespace === "string") namespace = (0, _parse.default)(namespace);
                        if (namespace.length !== 16) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                         // Compute hash of namespace and value, Per 4.3
                        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
                        // hashfunc([...namespace, ... value])`
                        let bytes = new Uint8Array(16 + value.length);
                        bytes.set(namespace);
                        bytes.set(value, namespace.length);
                        bytes = hashfunc(bytes);
                        bytes[6] = bytes[6] & 0x0f | version;
                        bytes[8] = bytes[8] & 0x3f | 0x80;
                        if (buf) {
                            offset = offset || 0;
                            for(let i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
                            return buf;
                        }
                        return (0, _stringify.default)(bytes);
                    } // Function#name is not settable on some platforms (#270)
                    try {
                        generateUUID.name = name; // eslint-disable-next-line no-empty
                    } catch (err) {} // For CommonJS default export support
                    generateUUID.DNS = DNS;
                    generateUUID.URL = URL;
                    return generateUUID;
                }
            },
            {
                "./parse.js": 61,
                "./stringify.js": 65
            }
        ],
        69: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _rng = _interopRequireDefault(require("./rng.js"));
                var _stringify = _interopRequireDefault(require("./stringify.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function v4(options, buf, offset) {
                    options = options || {};
                    const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
                    rnds[6] = rnds[6] & 0x0f | 0x40;
                    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
                    if (buf) {
                        offset = offset || 0;
                        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
                        return buf;
                    }
                    return (0, _stringify.default)(rnds);
                }
                var _default = v4;
                exports.default = _default;
            },
            {
                "./rng.js": 63,
                "./stringify.js": 65
            }
        ],
        70: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _v = _interopRequireDefault(require("./v35.js"));
                var _sha = _interopRequireDefault(require("./sha1.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                const v5 = (0, _v.default)("v5", 0x50, _sha.default);
                var _default = v5;
                exports.default = _default;
            },
            {
                "./sha1.js": 64,
                "./v35.js": 68
            }
        ],
        71: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _regex = _interopRequireDefault(require("./regex.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function validate(uuid) {
                    return typeof uuid === "string" && _regex.default.test(uuid);
                }
                var _default = validate;
                exports.default = _default;
            },
            {
                "./regex.js": 62
            }
        ],
        72: [
            function(require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _validate = _interopRequireDefault(require("./validate.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function version(uuid) {
                    if (!(0, _validate.default)(uuid)) throw TypeError("Invalid UUID");
                    return parseInt(uuid.substr(14, 1), 16);
                }
                var _default = version;
                exports.default = _default;
            },
            {
                "./validate.js": 71
            }
        ]
    }, {}, [
        9
    ])(9);
});

});

parcelRegister("1TUrp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $1626b5832af6566c$var$createDeferred() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.reject = reject;
        deferred.resolve = resolve;
    });
    return deferred;
}
var $1626b5832af6566c$var$_default = $1626b5832af6566c$var$createDeferred;
module.exports["default"] = $1626b5832af6566c$var$_default;

});

parcelRegister("cN33n", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("5RUcQ", function(module, exports) {
"use strict";

var $1PoM0 = parcelRequire("1PoM0");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $445d80631b43fbc6$var$_classCallCheck2 = $1PoM0((parcelRequire("2Ao05")));

var $445d80631b43fbc6$var$_createClass2 = $1PoM0((parcelRequire("awXxO")));

var $445d80631b43fbc6$var$_assertThisInitialized2 = $1PoM0((parcelRequire("N0CzN")));

var $445d80631b43fbc6$var$_get2 = $1PoM0((parcelRequire("bLXll")));

var $445d80631b43fbc6$var$_inherits2 = $1PoM0((parcelRequire("eSVSO")));

var $445d80631b43fbc6$var$_possibleConstructorReturn2 = $1PoM0((parcelRequire("585Nv")));

var $445d80631b43fbc6$var$_getPrototypeOf2 = $1PoM0((parcelRequire("eJUyy")));

var $445d80631b43fbc6$var$_classPrivateFieldGet4 = $1PoM0((parcelRequire("l2Sqt")));

var $445d80631b43fbc6$var$_classPrivateFieldSet2 = $1PoM0((parcelRequire("c0mXe")));

var $lIM9r = parcelRequire("lIM9r");
function $445d80631b43fbc6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $445d80631b43fbc6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $445d80631b43fbc6$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $445d80631b43fbc6$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $445d80631b43fbc6$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $445d80631b43fbc6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $445d80631b43fbc6$var$_connectCalled = /*#__PURE__*/ new WeakMap();
var $445d80631b43fbc6$var$_handleNetworkInformationChange = /*#__PURE__*/ new WeakMap();
var $445d80631b43fbc6$var$_initialNetworkInformationType = /*#__PURE__*/ new WeakMap();
var $445d80631b43fbc6$var$_networkInformation = /*#__PURE__*/ new WeakMap();
var $445d80631b43fbc6$var$WebSocketClientWithNetworkInformation = /*#__PURE__*/ function(_WebSocketClient) {
    (0, $445d80631b43fbc6$var$_inherits2["default"])(WebSocketClientWithNetworkInformation, _WebSocketClient);
    var _super = $445d80631b43fbc6$var$_createSuper(WebSocketClientWithNetworkInformation);
    function WebSocketClientWithNetworkInformation(_ref) {
        var _this;
        var disconnectionHandler = _ref.disconnectionHandler, networkInformation = _ref.networkInformation, requestHandler = _ref.requestHandler, url = _ref.url;
        (0, $445d80631b43fbc6$var$_classCallCheck2["default"])(this, WebSocketClientWithNetworkInformation);
        _this = _super.call(this, {
            disconnectionHandler: disconnectionHandler,
            requestHandler: requestHandler,
            url: url
        });
        $445d80631b43fbc6$var$_connectCalled.set((0, $445d80631b43fbc6$var$_assertThisInitialized2["default"])(_this), {
            writable: true,
            value: false
        });
        $445d80631b43fbc6$var$_handleNetworkInformationChange.set((0, $445d80631b43fbc6$var$_assertThisInitialized2["default"])(_this), {
            writable: true,
            value: function value() {
                return (0, $445d80631b43fbc6$var$_classPrivateFieldGet4["default"])((0, $445d80631b43fbc6$var$_assertThisInitialized2["default"])(_this), $445d80631b43fbc6$var$_initialNetworkInformationType) === (0, $445d80631b43fbc6$var$_classPrivateFieldGet4["default"])((0, $445d80631b43fbc6$var$_assertThisInitialized2["default"])(_this), $445d80631b43fbc6$var$_networkInformation).type || _this.disconnect();
            }
        });
        $445d80631b43fbc6$var$_initialNetworkInformationType.set((0, $445d80631b43fbc6$var$_assertThisInitialized2["default"])(_this), {
            writable: true,
            value: void 0
        });
        $445d80631b43fbc6$var$_networkInformation.set((0, $445d80631b43fbc6$var$_assertThisInitialized2["default"])(_this), {
            writable: true,
            value: void 0
        });
        (0, $445d80631b43fbc6$var$_classPrivateFieldSet2["default"])((0, $445d80631b43fbc6$var$_assertThisInitialized2["default"])(_this), $445d80631b43fbc6$var$_networkInformation, networkInformation);
        return _this;
    }
    (0, $445d80631b43fbc6$var$_createClass2["default"])(WebSocketClientWithNetworkInformation, [
        {
            key: "connect",
            value: //       `BrowserWebSocket` is where it creates `WebSocket` object.
            //       The `NetworkInformation` instance should accompany `WebSocket` and forcibly close it on abort.
            //       Maybe `botframework-streaming` should accept ponyfills.
            function connect() {
                if ((0, $445d80631b43fbc6$var$_classPrivateFieldGet4["default"])(this, $445d80631b43fbc6$var$_connectCalled)) {
                    console.warn("botframework-directlinejs: connect() can only be called once.");
                    return Promise.resolve();
                }
                (0, $445d80631b43fbc6$var$_classPrivateFieldSet2["default"])(this, $445d80631b43fbc6$var$_connectCalled, true);
                if ((0, $445d80631b43fbc6$var$_classPrivateFieldGet4["default"])(this, $445d80631b43fbc6$var$_networkInformation)) {
                    var _classPrivateFieldGet2 = (0, $445d80631b43fbc6$var$_classPrivateFieldGet4["default"])(this, $445d80631b43fbc6$var$_networkInformation), initialType = _classPrivateFieldGet2.type;
                    (0, $445d80631b43fbc6$var$_classPrivateFieldSet2["default"])(this, $445d80631b43fbc6$var$_initialNetworkInformationType, initialType);
                    if (initialType === "none") {
                        console.warn("botframework-directlinejs: Failed to connect while offline.");
                        return Promise.reject(new Error("botframework-directlinejs: Failed to connect while offline."));
                    }
                    (0, $445d80631b43fbc6$var$_classPrivateFieldGet4["default"])(this, $445d80631b43fbc6$var$_networkInformation).addEventListener("change", (0, $445d80631b43fbc6$var$_classPrivateFieldGet4["default"])(this, $445d80631b43fbc6$var$_handleNetworkInformationChange));
                }
                return (0, $445d80631b43fbc6$var$_get2["default"])((0, $445d80631b43fbc6$var$_getPrototypeOf2["default"])(WebSocketClientWithNetworkInformation.prototype), "connect", this).call(this);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _classPrivateFieldGet3;
                (_classPrivateFieldGet3 = (0, $445d80631b43fbc6$var$_classPrivateFieldGet4["default"])(this, $445d80631b43fbc6$var$_networkInformation)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.removeEventListener("change", (0, $445d80631b43fbc6$var$_classPrivateFieldGet4["default"])(this, $445d80631b43fbc6$var$_handleNetworkInformationChange));
                (0, $445d80631b43fbc6$var$_get2["default"])((0, $445d80631b43fbc6$var$_getPrototypeOf2["default"])(WebSocketClientWithNetworkInformation.prototype), "disconnect", this).call(this);
            }
        }
    ]);
    return WebSocketClientWithNetworkInformation;
}($lIM9r.WebSocketClient);
module.exports["default"] = $445d80631b43fbc6$var$WebSocketClientWithNetworkInformation;

});
parcelRegister("N0CzN", function(module, exports) {
function $09350f1358c38c38$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $09350f1358c38c38$var$_assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("bLXll", function(module, exports) {

var $bKeRH = parcelRequire("bKeRH");
function $89221dd248ee9009$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        module.exports = $89221dd248ee9009$var$_get = Reflect.get;
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
        module.exports = $89221dd248ee9009$var$_get = function _get(target, property, receiver) {
            var base = $bKeRH(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) return desc.get.call(receiver);
            return desc.value;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    }
    return $89221dd248ee9009$var$_get(target, property, receiver || target);
}
module.exports = $89221dd248ee9009$var$_get;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("bKeRH", function(module, exports) {

var $eJUyy = parcelRequire("eJUyy");
function $88cf8581b3f06fad$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $eJUyy(object);
        if (object === null) break;
    }
    return object;
}
module.exports = $88cf8581b3f06fad$var$_superPropBase;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("eJUyy", function(module, exports) {
function $abb12392ad264e7c$var$_getPrototypeOf(o) {
    module.exports = $abb12392ad264e7c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return $abb12392ad264e7c$var$_getPrototypeOf(o);
}
module.exports = $abb12392ad264e7c$var$_getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});



parcelRegister("eSVSO", function(module, exports) {

var $lIlXB = parcelRequire("lIlXB");
function $ad630234de80cec4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $lIlXB(subClass, superClass);
}
module.exports = $ad630234de80cec4$var$_inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("lIlXB", function(module, exports) {
function $fceebde21f652621$var$_setPrototypeOf(o, p) {
    module.exports = $fceebde21f652621$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return $fceebde21f652621$var$_setPrototypeOf(o, p);
}
module.exports = $fceebde21f652621$var$_setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("585Nv", function(module, exports) {

var $kKXRo = parcelRequire("kKXRo");
var $3bc23263aa32ff7e$var$_typeof = $kKXRo.default;

var $N0CzN = parcelRequire("N0CzN");
function $3bc23263aa32ff7e$var$_possibleConstructorReturn(self, call) {
    if (call && ($3bc23263aa32ff7e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $N0CzN(self);
}
module.exports = $3bc23263aa32ff7e$var$_possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("kKXRo", function(module, exports) {
function $f1c68984bb80db2c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        module.exports = $f1c68984bb80db2c$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
        module.exports = $f1c68984bb80db2c$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    }
    return $f1c68984bb80db2c$var$_typeof(obj);
}
module.exports = $f1c68984bb80db2c$var$_typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});



parcelRegister("k4mfS", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $e9c571c1ae5ec727$export$bf730a2d8bf68b42, (v) => $e9c571c1ae5ec727$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e9c571c1ae5ec727$export$bf730a2d8bf68b42;
"use strict";

var $lT7pJ = parcelRequire("lT7pJ");

var $lrWjX = parcelRequire("lrWjX");
function $e9c571c1ae5ec727$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e9c571c1ae5ec727$var$q = "function" === typeof Object.is ? Object.is : $e9c571c1ae5ec727$var$p, $e9c571c1ae5ec727$var$r = $lrWjX.useSyncExternalStore, $e9c571c1ae5ec727$var$t = $lT7pJ.useRef, $e9c571c1ae5ec727$var$u = $lT7pJ.useEffect, $e9c571c1ae5ec727$var$v = $lT7pJ.useMemo, $e9c571c1ae5ec727$var$w = $lT7pJ.useDebugValue;
$e9c571c1ae5ec727$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $e9c571c1ae5ec727$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $e9c571c1ae5ec727$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($e9c571c1ae5ec727$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $e9c571c1ae5ec727$var$r(a, c[0], c[1]);
    $e9c571c1ae5ec727$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $e9c571c1ae5ec727$var$w(d);
    return d;
};

});
parcelRegister("lrWjX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cJBOo"));

});
parcelRegister("cJBOo", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $945704a09a091735$export$306c0aa65ff9ec16, (v) => $945704a09a091735$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $945704a09a091735$export$306c0aa65ff9ec16;
"use strict";

var $lT7pJ = parcelRequire("lT7pJ");
function $945704a09a091735$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $945704a09a091735$var$k = "function" === typeof Object.is ? Object.is : $945704a09a091735$var$h, $945704a09a091735$var$l = $lT7pJ.useState, $945704a09a091735$var$m = $lT7pJ.useEffect, $945704a09a091735$var$n = $lT7pJ.useLayoutEffect, $945704a09a091735$var$p = $lT7pJ.useDebugValue;
function $945704a09a091735$var$q(a, b) {
    var d = b(), f = $945704a09a091735$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $945704a09a091735$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $945704a09a091735$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $945704a09a091735$var$m(function() {
        $945704a09a091735$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $945704a09a091735$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $945704a09a091735$var$p(d);
    return d;
}
function $945704a09a091735$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$945704a09a091735$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $945704a09a091735$var$t(a, b) {
    return b();
}
var $945704a09a091735$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $945704a09a091735$var$t : $945704a09a091735$var$q;
$945704a09a091735$export$306c0aa65ff9ec16 = void 0 !== $lT7pJ.useSyncExternalStore ? $lT7pJ.useSyncExternalStore : $945704a09a091735$var$u;

});



parcelRegister("luP4B", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Strings = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $fa64046959e02000$var$Strings = /** @class */ function() {
    function Strings() {}
    Strings.errors = {
        unknownElementType: function(typeName) {
            return 'Unknown element type "'.concat(typeName, '". Fallback will be used if present.');
        },
        unknownActionType: function(typeName) {
            return 'Unknown action type "'.concat(typeName, '". Fallback will be used if present.');
        },
        elementTypeNotAllowed: function(typeName) {
            return 'Element type "'.concat(typeName, '" is not allowed in this context.');
        },
        actionTypeNotAllowed: function(typeName) {
            return 'Action type "'.concat(typeName, '" is not allowed in this context.');
        },
        invalidPropertyValue: function(value, propertyName) {
            return 'Invalid value "'.concat(value, '" for property "').concat(propertyName, '".');
        },
        showCardMustHaveCard: function() {
            return '"An Action.ShowCard must have its "card" property set to a valid AdaptiveCard object.';
        },
        invalidColumnWidth: function(invalidWidth) {
            return 'Invalid column width "'.concat(invalidWidth, '" - defaulting to "auto".');
        },
        invalidCardVersion: function(defaultingToVersion) {
            return 'Invalid card version. Defaulting to "'.concat(defaultingToVersion, '".');
        },
        invalidVersionString: function(versionString) {
            return 'Invalid version string "'.concat(versionString, '".');
        },
        propertyValueNotSupported: function(value, propertyName, supportedInVersion, versionUsed) {
            return 'Value "'.concat(value, '" for property "').concat(propertyName, '" is supported in version ').concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        propertyNotSupported: function(propertyName, supportedInVersion, versionUsed) {
            return 'Property "'.concat(propertyName, '" is supported in version ').concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
        },
        indexOutOfRange: function(index) {
            return "Index out of range (".concat(index, ").");
        },
        elementCannotBeUsedAsInline: function() {
            return "RichTextBlock.addInline: the specified card element cannot be used as a RichTextBlock inline.";
        },
        inlineAlreadyParented: function() {
            return "RichTextBlock.addInline: the specified inline already belongs to another RichTextBlock.";
        },
        interactivityNotAllowed: function() {
            return "Interactivity is not allowed.";
        },
        inputsMustHaveUniqueId: function() {
            return "All inputs must have a unique Id.";
        },
        choiceSetMustHaveAtLeastOneChoice: function() {
            return "An Input.ChoiceSet must have at least one choice defined.";
        },
        choiceSetChoicesMustHaveTitleAndValue: function() {
            return "All choices in an Input.ChoiceSet must have their title and value properties set.";
        },
        propertyMustBeSet: function(propertyName) {
            return 'Property "'.concat(propertyName, '" must be set.');
        },
        actionHttpHeadersMustHaveNameAndValue: function() {
            return "All headers of an Action.Http must have their name and value properties set.";
        },
        tooManyActions: function(maximumActions) {
            return "Maximum number of actions exceeded (".concat(maximumActions, ").");
        },
        tooLittleTimeDelay: function(minAutoplayDelay) {
            return "Autoplay Delay is too short (".concat(minAutoplayDelay, ").");
        },
        tooManyCarouselPages: function(maxCarouselPages) {
            return "Maximum number of Carousel pages exceeded (".concat(maxCarouselPages, ").");
        },
        invalidInitialPageIndex: function(initialPageIndex) {
            return "InitialPage for carousel is invalid (".concat(initialPageIndex, ").");
        },
        columnAlreadyBelongsToAnotherSet: function() {
            return "This column already belongs to another ColumnSet.";
        },
        invalidCardType: function() {
            return 'Invalid or missing card type. Make sure the card\'s type property is set to "AdaptiveCard".';
        },
        unsupportedCardVersion: function(version, maxSupportedVersion) {
            return "The specified card version (".concat(version, ") is not supported or still in preview. The latest released card version is ").concat(maxSupportedVersion, ".");
        },
        duplicateId: function(id) {
            return 'Duplicate Id "'.concat(id, '".');
        },
        markdownProcessingNotEnabled: function() {
            return "Markdown processing isn't enabled. Please see https://www.npmjs.com/package/adaptivecards#supporting-markdown";
        },
        processMarkdownEventRemoved: function() {
            return "The processMarkdown event has been removed. Please update your code and set onProcessMarkdown instead.";
        },
        elementAlreadyParented: function() {
            return "The element already belongs to another container.";
        },
        actionAlreadyParented: function() {
            return "The action already belongs to another element.";
        },
        elementTypeNotStandalone: function(typeName) {
            return "Elements of type ".concat(typeName, " cannot be used as standalone elements.");
        },
        invalidInputLabelWidth: function() {
            return "Invalid input label width. Defaulting to label width from host config.";
        }
    };
    Strings.magicCodeInputCard = {
        tryAgain: function() {
            return "That didn't work... let's try again.";
        },
        pleaseLogin: function() {
            return 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"';
        },
        enterMagicCode: function() {
            return "Enter magic code";
        },
        pleaseEnterMagicCodeYouReceived: function() {
            return "Please enter the magic code you received.";
        },
        submit: function() {
            return "Submit";
        },
        cancel: function() {
            return "Cancel";
        },
        somethingWentWrong: function() {
            return "Something went wrong. This action can't be handled.";
        },
        authenticationFailed: function() {
            return "Authentication failed.";
        }
    };
    Strings.runtime = {
        automaticRefreshPaused: function() {
            return "Automatic refresh paused.";
        },
        clckToRestartAutomaticRefresh: function() {
            return "Click to restart.";
        },
        refreshThisCard: function() {
            return "Refresh this card";
        }
    };
    Strings.hints = {
        dontUseWeightedAndStrecthedColumnsInSameSet: function() {
            return "It is not recommended to use weighted and stretched columns in the same ColumnSet, because in such a situation stretched columns will always get the minimum amount of space.";
        }
    };
    Strings.defaults = {
        inlineActionTitle: function() {
            return "Inline Action";
        },
        overflowButtonText: function() {
            return "...";
        },
        overflowButtonTooltip: function() {
            return "More options";
        },
        emptyElementText: function(elementType) {
            return "Empty ".concat(elementType);
        },
        mediaPlayerAriaLabel: function() {
            return "Media content";
        },
        mediaPlayerPlayMedia: function() {
            return "Play media";
        },
        youTubeVideoPlayer: function() {
            return "YouTube video player";
        },
        vimeoVideoPlayer: function() {
            return "Vimeo video player";
        },
        dailymotionVideoPlayer: function() {
            return "Dailymotion video player";
        },
        carouselNavigationPreviousTooltip: function() {
            return "Previous carousel page";
        },
        carouselNavigationNextTooltip: function() {
            return "Next carousel page";
        }
    };
    return Strings;
}();
module.exports.Strings = $fa64046959e02000$var$Strings;

});

parcelRegister("4uYwi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionRole = module.exports.CarouselInteractionEvent = module.exports.LogLevel = module.exports.RefreshMode = module.exports.TypeErrorType = module.exports.ContainerFitStatus = module.exports.ValidationEvent = module.exports.ValidationPhase = module.exports.InputLabelPosition = module.exports.InputTextStyle = module.exports.ActionIconPlacement = module.exports.FillMode = module.exports.Orientation = module.exports.ShowCardActionMode = module.exports.ImageStyle = module.exports.ActionAlignment = module.exports.VerticalAlignment = module.exports.HorizontalAlignment = module.exports.TextColor = module.exports.Spacing = module.exports.FontType = module.exports.TextWeight = module.exports.InputStyle = module.exports.TextSize = module.exports.SizeUnit = module.exports.ImageSetPresentationStyle = module.exports.ImageSize = module.exports.Size = module.exports.ActionMode = module.exports.ActionStyle = module.exports.ContainerStyle = void 0;
/*
    This should really be a string enum, e.g.

        export enum ContainerStyle {
            Default = "default",
            Emphasis = "emphasis"
        }

    However, some hosts do not use a version of TypeScript
    recent enough to understand string enums. This is
    a compatible construct that does not require using
    a more recent version of TypeScript.

    Also note the "weird" way these readonly fields are declared is to work around
    a breaking change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    and adopt this syntax for all other static readonly fields.
*/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $3468e8bc3bcb70cd$var$ContainerStyle = /** @class */ function() {
    function ContainerStyle() {}
    ContainerStyle.Default = "default";
    ContainerStyle.Emphasis = "emphasis";
    ContainerStyle.Accent = "accent";
    ContainerStyle.Good = "good";
    ContainerStyle.Attention = "attention";
    ContainerStyle.Warning = "warning";
    return ContainerStyle;
}();
module.exports.ContainerStyle = $3468e8bc3bcb70cd$var$ContainerStyle;
var $3468e8bc3bcb70cd$var$ActionStyle = /** @class */ function() {
    function ActionStyle() {}
    ActionStyle.Default = "default";
    ActionStyle.Positive = "positive";
    ActionStyle.Destructive = "destructive";
    return ActionStyle;
}();
module.exports.ActionStyle = $3468e8bc3bcb70cd$var$ActionStyle;
var $3468e8bc3bcb70cd$var$ActionMode = /** @class */ function() {
    function ActionMode() {}
    ActionMode.Primary = "primary";
    ActionMode.Secondary = "secondary";
    return ActionMode;
}();
module.exports.ActionMode = $3468e8bc3bcb70cd$var$ActionMode;
/* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention */ var $3468e8bc3bcb70cd$var$Size;
(function(Size) {
    Size[Size["Auto"] = 0] = "Auto";
    Size[Size["Stretch"] = 1] = "Stretch";
    Size[Size["Small"] = 2] = "Small";
    Size[Size["Medium"] = 3] = "Medium";
    Size[Size["Large"] = 4] = "Large";
})($3468e8bc3bcb70cd$var$Size = module.exports.Size || (module.exports.Size = {}));
var $3468e8bc3bcb70cd$var$ImageSize;
(function(ImageSize) {
    ImageSize[ImageSize["Small"] = 0] = "Small";
    ImageSize[ImageSize["Medium"] = 1] = "Medium";
    ImageSize[ImageSize["Large"] = 2] = "Large";
})($3468e8bc3bcb70cd$var$ImageSize = module.exports.ImageSize || (module.exports.ImageSize = {}));
var $3468e8bc3bcb70cd$var$ImageSetPresentationStyle;
(function(ImageSetPresentationStyle) {
    ImageSetPresentationStyle[ImageSetPresentationStyle["Default"] = 0] = "Default";
    ImageSetPresentationStyle[ImageSetPresentationStyle["Stacked"] = 1] = "Stacked";
})($3468e8bc3bcb70cd$var$ImageSetPresentationStyle = module.exports.ImageSetPresentationStyle || (module.exports.ImageSetPresentationStyle = {}));
var $3468e8bc3bcb70cd$var$SizeUnit;
(function(SizeUnit) {
    SizeUnit[SizeUnit["Weight"] = 0] = "Weight";
    SizeUnit[SizeUnit["Pixel"] = 1] = "Pixel";
})($3468e8bc3bcb70cd$var$SizeUnit = module.exports.SizeUnit || (module.exports.SizeUnit = {}));
var $3468e8bc3bcb70cd$var$TextSize;
(function(TextSize) {
    TextSize[TextSize["Small"] = 0] = "Small";
    TextSize[TextSize["Default"] = 1] = "Default";
    TextSize[TextSize["Medium"] = 2] = "Medium";
    TextSize[TextSize["Large"] = 3] = "Large";
    TextSize[TextSize["ExtraLarge"] = 4] = "ExtraLarge";
})($3468e8bc3bcb70cd$var$TextSize = module.exports.TextSize || (module.exports.TextSize = {}));
var $3468e8bc3bcb70cd$var$InputStyle;
(function(InputStyle) {
    InputStyle[InputStyle["RevealOnHover"] = 0] = "RevealOnHover";
    InputStyle[InputStyle["Default"] = 1] = "Default";
})($3468e8bc3bcb70cd$var$InputStyle = module.exports.InputStyle || (module.exports.InputStyle = {}));
var $3468e8bc3bcb70cd$var$TextWeight;
(function(TextWeight) {
    TextWeight[TextWeight["Lighter"] = 0] = "Lighter";
    TextWeight[TextWeight["Default"] = 1] = "Default";
    TextWeight[TextWeight["Bolder"] = 2] = "Bolder";
})($3468e8bc3bcb70cd$var$TextWeight = module.exports.TextWeight || (module.exports.TextWeight = {}));
var $3468e8bc3bcb70cd$var$FontType;
(function(FontType) {
    FontType[FontType["Default"] = 0] = "Default";
    FontType[FontType["Monospace"] = 1] = "Monospace";
})($3468e8bc3bcb70cd$var$FontType = module.exports.FontType || (module.exports.FontType = {}));
var $3468e8bc3bcb70cd$var$Spacing;
(function(Spacing) {
    Spacing[Spacing["None"] = 0] = "None";
    Spacing[Spacing["Small"] = 1] = "Small";
    Spacing[Spacing["Default"] = 2] = "Default";
    Spacing[Spacing["Medium"] = 3] = "Medium";
    Spacing[Spacing["Large"] = 4] = "Large";
    Spacing[Spacing["ExtraLarge"] = 5] = "ExtraLarge";
    Spacing[Spacing["Padding"] = 6] = "Padding";
})($3468e8bc3bcb70cd$var$Spacing = module.exports.Spacing || (module.exports.Spacing = {}));
var $3468e8bc3bcb70cd$var$TextColor;
(function(TextColor) {
    TextColor[TextColor["Default"] = 0] = "Default";
    TextColor[TextColor["Dark"] = 1] = "Dark";
    TextColor[TextColor["Light"] = 2] = "Light";
    TextColor[TextColor["Accent"] = 3] = "Accent";
    TextColor[TextColor["Good"] = 4] = "Good";
    TextColor[TextColor["Warning"] = 5] = "Warning";
    TextColor[TextColor["Attention"] = 6] = "Attention";
})($3468e8bc3bcb70cd$var$TextColor = module.exports.TextColor || (module.exports.TextColor = {}));
var $3468e8bc3bcb70cd$var$HorizontalAlignment;
(function(HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
    HorizontalAlignment[HorizontalAlignment["Center"] = 1] = "Center";
    HorizontalAlignment[HorizontalAlignment["Right"] = 2] = "Right";
})($3468e8bc3bcb70cd$var$HorizontalAlignment = module.exports.HorizontalAlignment || (module.exports.HorizontalAlignment = {}));
var $3468e8bc3bcb70cd$var$VerticalAlignment;
(function(VerticalAlignment) {
    VerticalAlignment[VerticalAlignment["Top"] = 0] = "Top";
    VerticalAlignment[VerticalAlignment["Center"] = 1] = "Center";
    VerticalAlignment[VerticalAlignment["Bottom"] = 2] = "Bottom";
})($3468e8bc3bcb70cd$var$VerticalAlignment = module.exports.VerticalAlignment || (module.exports.VerticalAlignment = {}));
var $3468e8bc3bcb70cd$var$ActionAlignment;
(function(ActionAlignment) {
    ActionAlignment[ActionAlignment["Left"] = 0] = "Left";
    ActionAlignment[ActionAlignment["Center"] = 1] = "Center";
    ActionAlignment[ActionAlignment["Right"] = 2] = "Right";
    ActionAlignment[ActionAlignment["Stretch"] = 3] = "Stretch";
})($3468e8bc3bcb70cd$var$ActionAlignment = module.exports.ActionAlignment || (module.exports.ActionAlignment = {}));
var $3468e8bc3bcb70cd$var$ImageStyle;
(function(ImageStyle) {
    ImageStyle[ImageStyle["Default"] = 0] = "Default";
    ImageStyle[ImageStyle["Person"] = 1] = "Person";
})($3468e8bc3bcb70cd$var$ImageStyle = module.exports.ImageStyle || (module.exports.ImageStyle = {}));
var $3468e8bc3bcb70cd$var$ShowCardActionMode;
(function(ShowCardActionMode) {
    ShowCardActionMode[ShowCardActionMode["Inline"] = 0] = "Inline";
    ShowCardActionMode[ShowCardActionMode["Popup"] = 1] = "Popup";
})($3468e8bc3bcb70cd$var$ShowCardActionMode = module.exports.ShowCardActionMode || (module.exports.ShowCardActionMode = {}));
var $3468e8bc3bcb70cd$var$Orientation;
(function(Orientation) {
    Orientation[Orientation["Horizontal"] = 0] = "Horizontal";
    Orientation[Orientation["Vertical"] = 1] = "Vertical";
})($3468e8bc3bcb70cd$var$Orientation = module.exports.Orientation || (module.exports.Orientation = {}));
var $3468e8bc3bcb70cd$var$FillMode;
(function(FillMode) {
    FillMode[FillMode["Cover"] = 0] = "Cover";
    FillMode[FillMode["RepeatHorizontally"] = 1] = "RepeatHorizontally";
    FillMode[FillMode["RepeatVertically"] = 2] = "RepeatVertically";
    FillMode[FillMode["Repeat"] = 3] = "Repeat";
})($3468e8bc3bcb70cd$var$FillMode = module.exports.FillMode || (module.exports.FillMode = {}));
var $3468e8bc3bcb70cd$var$ActionIconPlacement;
(function(ActionIconPlacement) {
    ActionIconPlacement[ActionIconPlacement["LeftOfTitle"] = 0] = "LeftOfTitle";
    ActionIconPlacement[ActionIconPlacement["AboveTitle"] = 1] = "AboveTitle";
})($3468e8bc3bcb70cd$var$ActionIconPlacement = module.exports.ActionIconPlacement || (module.exports.ActionIconPlacement = {}));
var $3468e8bc3bcb70cd$var$InputTextStyle;
(function(InputTextStyle) {
    InputTextStyle[InputTextStyle["Text"] = 0] = "Text";
    InputTextStyle[InputTextStyle["Tel"] = 1] = "Tel";
    InputTextStyle[InputTextStyle["Url"] = 2] = "Url";
    InputTextStyle[InputTextStyle["Email"] = 3] = "Email";
    InputTextStyle[InputTextStyle["Password"] = 4] = "Password";
})($3468e8bc3bcb70cd$var$InputTextStyle = module.exports.InputTextStyle || (module.exports.InputTextStyle = {}));
var $3468e8bc3bcb70cd$var$InputLabelPosition;
(function(InputLabelPosition) {
    InputLabelPosition[InputLabelPosition["Inline"] = 0] = "Inline";
    InputLabelPosition[InputLabelPosition["Above"] = 1] = "Above";
})($3468e8bc3bcb70cd$var$InputLabelPosition = module.exports.InputLabelPosition || (module.exports.InputLabelPosition = {}));
var $3468e8bc3bcb70cd$var$ValidationPhase;
(function(ValidationPhase) {
    ValidationPhase[ValidationPhase["Parse"] = 0] = "Parse";
    ValidationPhase[ValidationPhase["ToJSON"] = 1] = "ToJSON";
    ValidationPhase[ValidationPhase["Validation"] = 2] = "Validation";
})($3468e8bc3bcb70cd$var$ValidationPhase = module.exports.ValidationPhase || (module.exports.ValidationPhase = {}));
var $3468e8bc3bcb70cd$var$ValidationEvent;
(function(ValidationEvent) {
    ValidationEvent[ValidationEvent["Hint"] = 0] = "Hint";
    ValidationEvent[ValidationEvent["ActionTypeNotAllowed"] = 1] = "ActionTypeNotAllowed";
    ValidationEvent[ValidationEvent["CollectionCantBeEmpty"] = 2] = "CollectionCantBeEmpty";
    ValidationEvent[ValidationEvent["Deprecated"] = 3] = "Deprecated";
    ValidationEvent[ValidationEvent["ElementTypeNotAllowed"] = 4] = "ElementTypeNotAllowed";
    ValidationEvent[ValidationEvent["InteractivityNotAllowed"] = 5] = "InteractivityNotAllowed";
    ValidationEvent[ValidationEvent["InvalidPropertyValue"] = 6] = "InvalidPropertyValue";
    ValidationEvent[ValidationEvent["MissingCardType"] = 7] = "MissingCardType";
    ValidationEvent[ValidationEvent["PropertyCantBeNull"] = 8] = "PropertyCantBeNull";
    ValidationEvent[ValidationEvent["TooManyActions"] = 9] = "TooManyActions";
    ValidationEvent[ValidationEvent["UnknownActionType"] = 10] = "UnknownActionType";
    ValidationEvent[ValidationEvent["UnknownElementType"] = 11] = "UnknownElementType";
    ValidationEvent[ValidationEvent["UnsupportedCardVersion"] = 12] = "UnsupportedCardVersion";
    ValidationEvent[ValidationEvent["DuplicateId"] = 13] = "DuplicateId";
    ValidationEvent[ValidationEvent["UnsupportedProperty"] = 14] = "UnsupportedProperty";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveLabel"] = 15] = "RequiredInputsShouldHaveLabel";
    ValidationEvent[ValidationEvent["RequiredInputsShouldHaveErrorMessage"] = 16] = "RequiredInputsShouldHaveErrorMessage";
    ValidationEvent[ValidationEvent["Other"] = 17] = "Other";
})($3468e8bc3bcb70cd$var$ValidationEvent = module.exports.ValidationEvent || (module.exports.ValidationEvent = {}));
var $3468e8bc3bcb70cd$var$ContainerFitStatus;
(function(ContainerFitStatus) {
    ContainerFitStatus[ContainerFitStatus["FullyInContainer"] = 0] = "FullyInContainer";
    ContainerFitStatus[ContainerFitStatus["Overflowing"] = 1] = "Overflowing";
    ContainerFitStatus[ContainerFitStatus["FullyOutOfContainer"] = 2] = "FullyOutOfContainer";
})($3468e8bc3bcb70cd$var$ContainerFitStatus = module.exports.ContainerFitStatus || (module.exports.ContainerFitStatus = {}));
var $3468e8bc3bcb70cd$var$TypeErrorType;
(function(TypeErrorType) {
    TypeErrorType[TypeErrorType["UnknownType"] = 0] = "UnknownType";
    TypeErrorType[TypeErrorType["ForbiddenType"] = 1] = "ForbiddenType";
})($3468e8bc3bcb70cd$var$TypeErrorType = module.exports.TypeErrorType || (module.exports.TypeErrorType = {}));
var $3468e8bc3bcb70cd$var$RefreshMode;
(function(RefreshMode) {
    RefreshMode[RefreshMode["Disabled"] = 0] = "Disabled";
    RefreshMode[RefreshMode["Manual"] = 1] = "Manual";
    RefreshMode[RefreshMode["Automatic"] = 2] = "Automatic";
})($3468e8bc3bcb70cd$var$RefreshMode = module.exports.RefreshMode || (module.exports.RefreshMode = {}));
var $3468e8bc3bcb70cd$var$LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["Info"] = 0] = "Info";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Error"] = 2] = "Error";
})($3468e8bc3bcb70cd$var$LogLevel = module.exports.LogLevel || (module.exports.LogLevel = {}));
var $3468e8bc3bcb70cd$var$CarouselInteractionEvent;
(function(CarouselInteractionEvent) {
    CarouselInteractionEvent[CarouselInteractionEvent["NavigationNext"] = 0] = "NavigationNext";
    CarouselInteractionEvent[CarouselInteractionEvent["NavigationPrevious"] = 1] = "NavigationPrevious";
    CarouselInteractionEvent[CarouselInteractionEvent["Pagination"] = 2] = "Pagination";
    CarouselInteractionEvent[CarouselInteractionEvent["Autoplay"] = 3] = "Autoplay";
})($3468e8bc3bcb70cd$var$CarouselInteractionEvent = module.exports.CarouselInteractionEvent || (module.exports.CarouselInteractionEvent = {}));
var $3468e8bc3bcb70cd$var$ActionRole;
(function(ActionRole) {
    ActionRole[ActionRole["Button"] = 0] = "Button";
    ActionRole[ActionRole["Link"] = 1] = "Link";
    ActionRole[ActionRole["Tab"] = 2] = "Tab";
    ActionRole[ActionRole["Menu"] = 3] = "Menu";
    ActionRole[ActionRole["MenuItem"] = 4] = "MenuItem";
})($3468e8bc3bcb70cd$var$ActionRole = module.exports.ActionRole || (module.exports.ActionRole = {}));

});

parcelRegister("krmaK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = module.exports.SizeAndUnit = module.exports.PaddingDefinition = module.exports.SpacingDefinition = module.exports.StringWithSubstitutions = module.exports.ContentTypes = module.exports.GlobalSettings = void 0;

var $4uYwi = parcelRequire("4uYwi");
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $ee17873a6a083cd5$var$GlobalSettings = /** @class */ function() {
    function GlobalSettings() {}
    GlobalSettings.useAdvancedTextBlockTruncation = true;
    GlobalSettings.useAdvancedCardBottomTruncation = false;
    GlobalSettings.useMarkdownInRadioButtonAndCheckbox = true;
    GlobalSettings.allowMarkForTextHighlighting = false;
    GlobalSettings.alwaysBleedSeparators = false;
    GlobalSettings.enableFullJsonRoundTrip = false;
    GlobalSettings.displayInputValidationErrors = true;
    GlobalSettings.allowPreProcessingPropertyValues = false;
    GlobalSettings.setTabIndexAtCardRoot = true;
    GlobalSettings.enableFallback = true;
    GlobalSettings.useWebkitLineClamp = true;
    GlobalSettings.allowMoreThanMaxActionsInOverflowMenu = false;
    GlobalSettings.removePaddingFromContainersWithBackgroundImage = false;
    GlobalSettings.resetInputsDirtyStateAfterActionExecution = true;
    GlobalSettings.applets = {
        logEnabled: true,
        logLevel: $4uYwi.LogLevel.Error,
        maximumRetryAttempts: 3,
        defaultTimeBetweenRetryAttempts: 3000,
        authPromptWidth: 400,
        authPromptHeight: 600,
        refresh: {
            mode: $4uYwi.RefreshMode.Manual,
            timeBetweenAutomaticRefreshes: 3000,
            maximumConsecutiveAutomaticRefreshes: 3,
            allowManualRefreshesAfterAutomaticRefreshes: true
        }
    };
    return GlobalSettings;
}();
module.exports.GlobalSettings = $ee17873a6a083cd5$var$GlobalSettings;
module.exports.ContentTypes = {
    applicationJson: "application/json",
    applicationXWwwFormUrlencoded: "application/x-www-form-urlencoded"
};
var $ee17873a6a083cd5$var$StringWithSubstitutions = /** @class */ function() {
    function StringWithSubstitutions() {
        this._isProcessed = false;
    }
    StringWithSubstitutions.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        if (!referencedInputs) throw new Error("The referencedInputs parameter cannot be null.");
        if (this._original) for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
            var input = inputs_1[_i];
            var matches = new RegExp("\\{{2}(" + input.id + ").value\\}{2}", "gi").exec(this._original);
            if (matches != null && input.id) referencedInputs[input.id] = input;
        }
    };
    StringWithSubstitutions.prototype.substituteInputValues = function(inputs, contentType) {
        this._processed = this._original;
        if (this._original) {
            var regEx = /\{{2}([a-z0-9_$@]+).value\}{2}/gi;
            var matches = void 0;
            while((matches = regEx.exec(this._original)) !== null && this._processed)for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
                var key = _a[_i];
                if (key.toLowerCase() === matches[1].toLowerCase()) {
                    var matchedInput = inputs[key];
                    var valueForReplace = "";
                    if (matchedInput.value) valueForReplace = matchedInput.value;
                    if (contentType === module.exports.ContentTypes.applicationJson) {
                        valueForReplace = JSON.stringify(valueForReplace);
                        valueForReplace = valueForReplace.slice(1, -1);
                    } else if (contentType === module.exports.ContentTypes.applicationXWwwFormUrlencoded) valueForReplace = encodeURIComponent(valueForReplace);
                    this._processed = this._processed.replace(matches[0], valueForReplace);
                    break;
                }
            }
        }
        this._isProcessed = true;
    };
    StringWithSubstitutions.prototype.getOriginal = function() {
        return this._original;
    };
    StringWithSubstitutions.prototype.get = function() {
        if (!this._isProcessed) return this._original;
        else return this._processed;
    };
    StringWithSubstitutions.prototype.set = function(value) {
        this._original = value;
        this._isProcessed = false;
    };
    return StringWithSubstitutions;
}();
module.exports.StringWithSubstitutions = $ee17873a6a083cd5$var$StringWithSubstitutions;
var $ee17873a6a083cd5$var$SpacingDefinition = /** @class */ function() {
    function SpacingDefinition(top, right, bottom, left) {
        if (top === void 0) top = 0;
        if (right === void 0) right = 0;
        if (bottom === void 0) bottom = 0;
        if (left === void 0) left = 0;
        this.left = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return SpacingDefinition;
}();
module.exports.SpacingDefinition = $ee17873a6a083cd5$var$SpacingDefinition;
var $ee17873a6a083cd5$var$PaddingDefinition = /** @class */ function() {
    function PaddingDefinition(top, right, bottom, left) {
        if (top === void 0) top = $4uYwi.Spacing.None;
        if (right === void 0) right = $4uYwi.Spacing.None;
        if (bottom === void 0) bottom = $4uYwi.Spacing.None;
        if (left === void 0) left = $4uYwi.Spacing.None;
        this.top = $4uYwi.Spacing.None;
        this.right = $4uYwi.Spacing.None;
        this.bottom = $4uYwi.Spacing.None;
        this.left = $4uYwi.Spacing.None;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    return PaddingDefinition;
}();
module.exports.PaddingDefinition = $ee17873a6a083cd5$var$PaddingDefinition;
var $ee17873a6a083cd5$var$SizeAndUnit = /** @class */ function() {
    function SizeAndUnit(physicalSize, unit) {
        this.physicalSize = physicalSize;
        this.unit = unit;
    }
    SizeAndUnit.parse = function(input, requireUnitSpecifier) {
        if (requireUnitSpecifier === void 0) requireUnitSpecifier = false;
        var result = new SizeAndUnit(0, $4uYwi.SizeUnit.Weight);
        if (typeof input === "number") {
            result.physicalSize = input;
            return result;
        } else if (typeof input === "string") {
            var regExp = /^([0-9]+)(px|\*)?$/g;
            var matches = regExp.exec(input);
            var expectedMatchCount = requireUnitSpecifier ? 3 : 2;
            if (matches && matches.length >= expectedMatchCount) {
                result.physicalSize = parseInt(matches[1]);
                if (matches.length === 3) {
                    if (matches[2] === "px") result.unit = $4uYwi.SizeUnit.Pixel;
                }
                return result;
            }
        }
        throw new Error("Invalid size: " + input);
    };
    return SizeAndUnit;
}();
module.exports.SizeAndUnit = $ee17873a6a083cd5$var$SizeAndUnit;
/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 **/ /* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ var $ee17873a6a083cd5$var$UUID = /** @class */ function() {
    function UUID() {}
    UUID.generate = function() {
        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;
        return UUID.lut[d0 & 0xff] + UUID.lut[d0 >> 8 & 0xff] + UUID.lut[d0 >> 16 & 0xff] + UUID.lut[d0 >> 24 & 0xff] + "-" + UUID.lut[d1 & 0xff] + UUID.lut[d1 >> 8 & 0xff] + "-" + UUID.lut[d1 >> 16 & 0x0f | 0x40] + UUID.lut[d1 >> 24 & 0xff] + "-" + UUID.lut[d2 & 0x3f | 0x80] + UUID.lut[d2 >> 8 & 0xff] + "-" + UUID.lut[d2 >> 16 & 0xff] + UUID.lut[d2 >> 24 & 0xff] + UUID.lut[d3 & 0xff] + UUID.lut[d3 >> 8 & 0xff] + UUID.lut[d3 >> 16 & 0xff] + UUID.lut[d3 >> 24 & 0xff];
    };
    UUID.initialize = function() {
        for(var i = 0; i < 256; i++)UUID.lut[i] = (i < 16 ? "0" : "") + i.toString(16);
    };
    UUID.lut = [];
    return UUID;
}();
module.exports.UUID = $ee17873a6a083cd5$var$UUID;
$ee17873a6a083cd5$var$UUID.initialize(); /* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/naming-convention, no-bitwise */ 

});

parcelRegister("6EfR6", function(module, exports) {
"use strict";
var $4d72c7149e1d6175$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.debounce = module.exports.addCancelSelectActionEventHandler = module.exports.clearElementChildren = module.exports.getScrollY = module.exports.getScrollX = module.exports.getFitStatus = module.exports.truncate = module.exports.truncateText = module.exports.stringToCssColor = module.exports.parseEnum = module.exports.getEnumValueByName = module.exports.parseBool = module.exports.parseNumber = module.exports.parseString = module.exports.appendChild = module.exports.generateUniqueId = module.exports.isMobileOS = module.exports.isInternetExplorer = void 0;

var $4uYwi = parcelRequire("4uYwi");

var $krmaK = parcelRequire("krmaK");
function $4d72c7149e1d6175$var$isInternetExplorer() {
    // The documentMode property only exists in IE
    return window.document.documentMode !== undefined;
}
module.exports.isInternetExplorer = $4d72c7149e1d6175$var$isInternetExplorer;
function $4d72c7149e1d6175$var$isMobileOS() {
    var userAgent = window.navigator.userAgent;
    return !!userAgent.match(/Android/i) || !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i);
}
module.exports.isMobileOS = $4d72c7149e1d6175$var$isMobileOS;
/**
 * Generate a UUID prepended with "__ac-"
 */ function $4d72c7149e1d6175$var$generateUniqueId() {
    return "__ac-" + $krmaK.UUID.generate();
}
module.exports.generateUniqueId = $4d72c7149e1d6175$var$generateUniqueId;
function $4d72c7149e1d6175$var$appendChild(node, child) {
    if (child) node.appendChild(child);
}
module.exports.appendChild = $4d72c7149e1d6175$var$appendChild;
function $4d72c7149e1d6175$var$parseString(obj, defaultValue) {
    return typeof obj === "string" ? obj : defaultValue;
}
module.exports.parseString = $4d72c7149e1d6175$var$parseString;
function $4d72c7149e1d6175$var$parseNumber(obj, defaultValue) {
    return typeof obj === "number" ? obj : defaultValue;
}
module.exports.parseNumber = $4d72c7149e1d6175$var$parseNumber;
function $4d72c7149e1d6175$var$parseBool(value, defaultValue) {
    if (typeof value === "boolean") return value;
    else if (typeof value === "string") switch(value.toLowerCase()){
        case "true":
            return true;
        case "false":
            return false;
        default:
            return defaultValue;
    }
    return defaultValue;
}
module.exports.parseBool = $4d72c7149e1d6175$var$parseBool;
function $4d72c7149e1d6175$var$getEnumValueByName(enumType, name) {
    // eslint-disable-next-line guard-for-in
    for(var key in enumType){
        var keyAsNumber = parseInt(key, 10);
        if (keyAsNumber >= 0) {
            var value = enumType[key];
            if (value && typeof value === "string" && value.toLowerCase() === name.toLowerCase()) return keyAsNumber;
        }
    }
    return undefined;
}
module.exports.getEnumValueByName = $4d72c7149e1d6175$var$getEnumValueByName;
function $4d72c7149e1d6175$var$parseEnum(enumType, name, defaultValue) {
    if (!name) return defaultValue;
    var enumValue = $4d72c7149e1d6175$var$getEnumValueByName(enumType, name);
    return enumValue !== undefined ? enumValue : defaultValue;
}
module.exports.parseEnum = $4d72c7149e1d6175$var$parseEnum;
function $4d72c7149e1d6175$var$stringToCssColor(color) {
    if (color) {
        var regEx = /#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})?/gi;
        var matches = regEx.exec(color);
        if (matches && matches[4]) {
            var a = parseInt(matches[1], 16) / 255;
            var r = parseInt(matches[2], 16);
            var g = parseInt(matches[3], 16);
            var b = parseInt(matches[4], 16);
            return "rgba(" + r + "," + g + "," + b + "," + a + ")";
        }
    }
    return color;
}
module.exports.stringToCssColor = $4d72c7149e1d6175$var$stringToCssColor;
function $4d72c7149e1d6175$var$truncateWorker(element, maxHeight, fullText, truncateAt, lineHeight) {
    var fits = function() {
        // Allow a one pixel overflow to account for rounding differences
        // between browsers
        return maxHeight - element.scrollHeight >= -1;
    };
    if (fits()) return;
    var breakableIndices = $4d72c7149e1d6175$var$findBreakableIndices(fullText);
    var lo = 0;
    var hi = breakableIndices.length;
    var bestBreakIdx = 0;
    // Do a binary search for the longest string that fits
    while(lo < hi){
        var mid = Math.floor((lo + hi) / 2);
        truncateAt(fullText, breakableIndices[mid]);
        if (fits()) {
            bestBreakIdx = breakableIndices[mid];
            lo = mid + 1;
        } else hi = mid;
    }
    truncateAt(fullText, bestBreakIdx);
    // If we have extra room, try to expand the string letter by letter
    // (covers the case where we have to break in the middle of a long word)
    if (lineHeight && maxHeight - element.scrollHeight >= lineHeight - 1.0) {
        var idx = $4d72c7149e1d6175$var$findNextCharacter(fullText, bestBreakIdx);
        while(idx < fullText.length){
            truncateAt(fullText, idx);
            if (fits()) {
                bestBreakIdx = idx;
                idx = $4d72c7149e1d6175$var$findNextCharacter(fullText, idx);
            } else break;
        }
        truncateAt(fullText, bestBreakIdx);
    }
}
function $4d72c7149e1d6175$var$truncateText(element, maxHeight, lineHeight) {
    $4d72c7149e1d6175$var$truncateWorker(element, maxHeight, element.innerText, function(text, idx) {
        element.innerText = text.substring(0, idx) + "...";
    }, lineHeight);
}
module.exports.truncateText = $4d72c7149e1d6175$var$truncateText;
/**
 * {@link truncate} has been deprecated and is no longer in use internally. This policy passes
 * content through as it always has, which is _supposed_ to be dealing with text only (see {@link
 * TextBlock.truncateIfSupported}), but had a bug where it might actually pass through an element
 * for which innerHTML yielded actual HTML (since fixed).
 */ var $4d72c7149e1d6175$var$ttDeprecatedPolicy = typeof window === "undefined" ? undefined : ($4d72c7149e1d6175$var$_a = window.trustedTypes) === null || $4d72c7149e1d6175$var$_a === void 0 ? void 0 : $4d72c7149e1d6175$var$_a.createPolicy("adaptivecards#deprecatedExportedFunctionPolicy", {
    createHTML: function(value) {
        return value;
    }
});
/** @deprecated Use {@link truncateText} instead. */ function $4d72c7149e1d6175$var$truncate(element, maxHeight, lineHeight) {
    $4d72c7149e1d6175$var$truncateWorker(element, maxHeight, element.innerHTML, function(text, idx) {
        var _a;
        var truncatedString = text.substring(0, idx) + "...";
        var truncatedHTML = (_a = $4d72c7149e1d6175$var$ttDeprecatedPolicy === null || $4d72c7149e1d6175$var$ttDeprecatedPolicy === void 0 ? void 0 : $4d72c7149e1d6175$var$ttDeprecatedPolicy.createHTML(truncatedString)) !== null && _a !== void 0 ? _a : truncatedString;
        element.innerHTML = truncatedHTML;
    }, lineHeight);
}
module.exports.truncate = $4d72c7149e1d6175$var$truncate;
function $4d72c7149e1d6175$var$findBreakableIndices(html) {
    var results = [];
    var idx = $4d72c7149e1d6175$var$findNextCharacter(html, -1);
    while(idx < html.length){
        if (html[idx] === " ") results.push(idx);
        idx = $4d72c7149e1d6175$var$findNextCharacter(html, idx);
    }
    return results;
}
function $4d72c7149e1d6175$var$findNextCharacter(html, currIdx) {
    currIdx += 1;
    // If we found the start of an HTML tag, keep advancing until we get
    // past it, so we don't end up truncating in the middle of the tag
    while(currIdx < html.length && html[currIdx] === "<"){
        while(currIdx < html.length && html[currIdx++] !== ">")continue;
    }
    return currIdx;
}
function $4d72c7149e1d6175$var$getFitStatus(element, containerEnd) {
    var start = element.offsetTop;
    var end = start + element.clientHeight;
    if (end <= containerEnd) return $4uYwi.ContainerFitStatus.FullyInContainer;
    else if (start < containerEnd) return $4uYwi.ContainerFitStatus.Overflowing;
    else return $4uYwi.ContainerFitStatus.FullyOutOfContainer;
}
module.exports.getFitStatus = $4d72c7149e1d6175$var$getFitStatus;
function $4d72c7149e1d6175$var$getScrollX() {
    return window.pageXOffset;
}
module.exports.getScrollX = $4d72c7149e1d6175$var$getScrollX;
function $4d72c7149e1d6175$var$getScrollY() {
    return window.pageYOffset;
}
module.exports.getScrollY = $4d72c7149e1d6175$var$getScrollY;
function $4d72c7149e1d6175$var$clearElementChildren(element) {
    while(element.firstChild)element.removeChild(element.firstChild);
}
module.exports.clearElementChildren = $4d72c7149e1d6175$var$clearElementChildren;
function $4d72c7149e1d6175$var$addCancelSelectActionEventHandler(element) {
    element.onclick = function(e) {
        e.preventDefault();
        e.cancelBubble = true;
    };
}
module.exports.addCancelSelectActionEventHandler = $4d72c7149e1d6175$var$addCancelSelectActionEventHandler;
function $4d72c7149e1d6175$var$debounce(fn, delay) {
    var timer;
    function debouncedFn() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (timer) clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(void 0, args);
        }, delay);
    }
    return debouncedFn;
}
module.exports.debounce = $4d72c7149e1d6175$var$debounce;

});

parcelRegister("dA5cX", function(module, exports) {
"use strict";
var $9e32ad5ad3f20ed6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SerializableObject = module.exports.property = module.exports.SerializableObjectSchema = module.exports.CustomProperty = module.exports.SerializableObjectCollectionProperty = module.exports.SerializableObjectProperty = module.exports.EnumProperty = module.exports.ValueSetProperty = module.exports.StringArrayProperty = module.exports.PixelSizeProperty = module.exports.NumProperty = module.exports.BoolProperty = module.exports.StringProperty = module.exports.PropertyDefinition = module.exports.BaseSerializationContext = module.exports.isVersionLessOrEqual = module.exports.Versions = module.exports.Version = void 0;

var $krmaK = parcelRequire("krmaK");

var $6EfR6 = parcelRequire("6EfR6");

var $4uYwi = parcelRequire("4uYwi");

var $luP4B = parcelRequire("luP4B");
var $9e32ad5ad3f20ed6$var$Version = /** @class */ function() {
    function Version(major, minor, label) {
        if (major === void 0) major = 1;
        if (minor === void 0) minor = 1;
        this._isValid = true;
        this._major = major;
        this._minor = minor;
        this._label = label;
    }
    Version.parse = function(versionString, context) {
        if (!versionString) return undefined;
        var result = new Version();
        result._versionString = versionString;
        var regEx = /(\d+).(\d+)/gi;
        var matches = regEx.exec(versionString);
        if (matches != null && matches.length === 3) {
            result._major = parseInt(matches[1]);
            result._minor = parseInt(matches[2]);
        } else result._isValid = false;
        if (!result._isValid) context.logParseEvent(undefined, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidVersionString(result._versionString));
        return result;
    };
    Version.prototype.toString = function() {
        return !this._isValid ? this._versionString : this._major + "." + this._minor;
    };
    Version.prototype.toJSON = function() {
        return this.toString();
    };
    Version.prototype.compareTo = function(otherVersion) {
        if (!this.isValid || !otherVersion.isValid) throw new Error("Cannot compare invalid version.");
        if (this.major > otherVersion.major) return 1;
        else if (this.major < otherVersion.major) return -1;
        else if (this.minor > otherVersion.minor) return 1;
        else if (this.minor < otherVersion.minor) return -1;
        return 0;
    };
    Object.defineProperty(Version.prototype, "label", {
        get: function() {
            return this._label ? this._label : this.toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "major", {
        get: function() {
            return this._major;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "minor", {
        get: function() {
            return this._minor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "isValid", {
        get: function() {
            return this._isValid;
        },
        enumerable: false,
        configurable: true
    });
    return Version;
}();
module.exports.Version = $9e32ad5ad3f20ed6$var$Version;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $9e32ad5ad3f20ed6$var$Versions = /** @class */ function() {
    function Versions() {}
    // If preview tag is added/removed from any version,
    // don't forget to update .ac-schema-version-1-?::after too in adaptivecards-site\themes\adaptivecards\source\css\style.css
    /* eslint-enable @typescript-eslint/naming-convention */ Versions.getAllDeclaredVersions = function() {
        var ctor = Versions;
        var properties = [];
        for(var propertyName in ctor){
            if (propertyName.match(/^v[0-9_]*$/)) // filter latest
            try {
                var propertyValue = ctor[propertyName];
                if (propertyValue instanceof $9e32ad5ad3f20ed6$var$Version) properties.push(propertyValue);
            } catch (_a) {
            // If a property happens to have a getter function and
            // it throws an exception, we need to catch it here
            }
        }
        return properties.sort(function(v1, v2) {
            return v1.compareTo(v2);
        });
    };
    /* eslint-disable @typescript-eslint/naming-convention */ Versions.v1_0 = new $9e32ad5ad3f20ed6$var$Version(1, 0);
    Versions.v1_1 = new $9e32ad5ad3f20ed6$var$Version(1, 1);
    Versions.v1_2 = new $9e32ad5ad3f20ed6$var$Version(1, 2);
    Versions.v1_3 = new $9e32ad5ad3f20ed6$var$Version(1, 3);
    Versions.v1_4 = new $9e32ad5ad3f20ed6$var$Version(1, 4);
    Versions.v1_5 = new $9e32ad5ad3f20ed6$var$Version(1, 5);
    Versions.v1_6 = new $9e32ad5ad3f20ed6$var$Version(1, 6);
    Versions.latest = Versions.v1_6;
    return Versions;
}();
module.exports.Versions = $9e32ad5ad3f20ed6$var$Versions;
function $9e32ad5ad3f20ed6$var$isVersionLessOrEqual(version, targetVersion) {
    if (version instanceof $9e32ad5ad3f20ed6$var$Version) {
        if (targetVersion instanceof $9e32ad5ad3f20ed6$var$Version) return targetVersion.compareTo(version) >= 0;
        else // Target version is *
        return true;
    } else // Version is *
    return true;
}
module.exports.isVersionLessOrEqual = $9e32ad5ad3f20ed6$var$isVersionLessOrEqual;
var $9e32ad5ad3f20ed6$var$BaseSerializationContext = /** @class */ function() {
    function BaseSerializationContext(targetVersion) {
        if (targetVersion === void 0) targetVersion = $9e32ad5ad3f20ed6$var$Versions.latest;
        this._validationEvents = [];
        this.targetVersion = targetVersion;
    }
    BaseSerializationContext.prototype.isTemplateString = function(value) {
        if (typeof value === "string") return value.startsWith("${");
        else return false;
    };
    BaseSerializationContext.prototype.tryDeleteValue = function(target, propertyName) {
        if (!$krmaK.GlobalSettings.enableFullJsonRoundTrip) delete target[propertyName];
    };
    BaseSerializationContext.prototype.tryDeleteDefaultValue = function(target, propertyName) {
        if (!$krmaK.GlobalSettings.enableFullJsonRoundTrip || !this.isTemplateString(target[propertyName])) delete target[propertyName];
    };
    BaseSerializationContext.prototype.serializeValue = function(target, propertyName, propertyValue, defaultValue, forceDeleteIfNullOrDefault) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (forceDeleteIfNullOrDefault === void 0) forceDeleteIfNullOrDefault = false;
        if (propertyValue === null || propertyValue === undefined) {
            if (!$krmaK.GlobalSettings.enableFullJsonRoundTrip || forceDeleteIfNullOrDefault) delete target[propertyName];
        } else if (propertyValue === defaultValue) {
            if (!$krmaK.GlobalSettings.enableFullJsonRoundTrip || forceDeleteIfNullOrDefault || !this.isTemplateString(target[propertyName])) delete target[propertyName];
        } else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeString = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeBool = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeNumber = function(target, propertyName, propertyValue, defaultValue) {
        if (propertyValue === null || propertyValue === undefined || isNaN(propertyValue)) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = propertyValue;
    };
    BaseSerializationContext.prototype.serializeEnum = function(enumType, target, propertyName, propertyValue, defaultValue) {
        if (defaultValue === void 0) defaultValue = undefined;
        if (propertyValue === null || propertyValue === undefined) this.tryDeleteValue(target, propertyName);
        else if (propertyValue === defaultValue) this.tryDeleteDefaultValue(target, propertyName);
        else target[propertyName] = enumType[propertyValue];
    };
    BaseSerializationContext.prototype.serializeArray = function(target, propertyName, propertyValue) {
        var items = [];
        if (propertyValue) for(var _i = 0, propertyValue_1 = propertyValue; _i < propertyValue_1.length; _i++){
            var item = propertyValue_1[_i];
            var serializedItem = undefined;
            if (item instanceof $9e32ad5ad3f20ed6$var$SerializableObject) serializedItem = item.toJSON(this);
            else if (item.toJSON) serializedItem = item.toJSON();
            else serializedItem = item;
            if (serializedItem !== undefined) items.push(serializedItem);
        }
        if (items.length === 0) {
            if (target.hasOwnProperty(propertyName) && Array.isArray(target[propertyName])) delete target[propertyName];
        } else this.serializeValue(target, propertyName, items);
    };
    BaseSerializationContext.prototype.clearEvents = function() {
        this._validationEvents = [];
    };
    BaseSerializationContext.prototype.logEvent = function(source, phase, event, message) {
        this._validationEvents.push({
            source: source,
            phase: phase,
            event: event,
            message: message
        });
    };
    BaseSerializationContext.prototype.logParseEvent = function(source, event, message) {
        this.logEvent(source, $4uYwi.ValidationPhase.Parse, event, message);
    };
    BaseSerializationContext.prototype.getEventAt = function(index) {
        return this._validationEvents[index];
    };
    Object.defineProperty(BaseSerializationContext.prototype, "eventCount", {
        get: function() {
            return this._validationEvents.length;
        },
        enumerable: false,
        configurable: true
    });
    return BaseSerializationContext;
}();
module.exports.BaseSerializationContext = $9e32ad5ad3f20ed6$var$BaseSerializationContext;
var $9e32ad5ad3f20ed6$var$SimpleSerializationContext = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(SimpleSerializationContext, _super);
    function SimpleSerializationContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SimpleSerializationContext;
}($9e32ad5ad3f20ed6$var$BaseSerializationContext);
var $9e32ad5ad3f20ed6$var$PropertyDefinition = /** @class */ function() {
    function PropertyDefinition(targetVersion, name, defaultValue, onGetInitialValue) {
        this.targetVersion = targetVersion;
        this.name = name;
        this.defaultValue = defaultValue;
        this.onGetInitialValue = onGetInitialValue;
        this.isSerializationEnabled = true;
        this.sequentialNumber = PropertyDefinition._sequentialNumber;
        PropertyDefinition._sequentialNumber++;
    }
    PropertyDefinition.prototype.getInternalName = function() {
        return this.name;
    };
    PropertyDefinition.prototype.parse = function(sender, source, context) {
        return source[this.name];
    };
    PropertyDefinition.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value, this.defaultValue);
    };
    PropertyDefinition._sequentialNumber = 0;
    return PropertyDefinition;
}();
module.exports.PropertyDefinition = $9e32ad5ad3f20ed6$var$PropertyDefinition;
var $9e32ad5ad3f20ed6$var$StringProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(StringProperty, _super);
    function StringProperty(targetVersion, name, treatEmptyAsUndefined, regEx, defaultValue, onGetInitialValue) {
        if (treatEmptyAsUndefined === void 0) treatEmptyAsUndefined = true;
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.treatEmptyAsUndefined = treatEmptyAsUndefined;
        _this.regEx = regEx;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringProperty.prototype.parse = function(sender, source, context) {
        var parsedValue = $6EfR6.parseString(source[this.name], this.defaultValue);
        var isUndefined = parsedValue === undefined || parsedValue === "" && this.treatEmptyAsUndefined;
        if (!isUndefined && this.regEx !== undefined) {
            var matches = this.regEx.exec(parsedValue);
            if (!matches) {
                context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidPropertyValue(parsedValue, this.name));
                return undefined;
            }
        }
        return parsedValue;
    };
    StringProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeString(target, this.name, value === "" && this.treatEmptyAsUndefined ? undefined : value, this.defaultValue);
    };
    return StringProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.StringProperty = $9e32ad5ad3f20ed6$var$StringProperty;
var $9e32ad5ad3f20ed6$var$BoolProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(BoolProperty, _super);
    function BoolProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    BoolProperty.prototype.parse = function(sender, source, context) {
        return $6EfR6.parseBool(source[this.name], this.defaultValue);
    };
    BoolProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeBool(target, this.name, value, this.defaultValue);
    };
    return BoolProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.BoolProperty = $9e32ad5ad3f20ed6$var$BoolProperty;
var $9e32ad5ad3f20ed6$var$NumProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(NumProperty, _super);
    function NumProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    NumProperty.prototype.parse = function(sender, source, context) {
        return $6EfR6.parseNumber(source[this.name], this.defaultValue);
    };
    NumProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeNumber(target, this.name, value, this.defaultValue);
    };
    return NumProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.NumProperty = $9e32ad5ad3f20ed6$var$NumProperty;
var $9e32ad5ad3f20ed6$var$PixelSizeProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(PixelSizeProperty, _super);
    function PixelSizeProperty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PixelSizeProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var value = source[this.name];
        if (typeof value === "string") {
            var isValid = false;
            try {
                var size = $krmaK.SizeAndUnit.parse(value, true);
                if (size.unit === $4uYwi.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Do nothing. A parse error is emitted below
            }
            if (!isValid) context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidPropertyValue(source[this.name], this.name));
        }
        return result;
    };
    PixelSizeProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return PixelSizeProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.PixelSizeProperty = $9e32ad5ad3f20ed6$var$PixelSizeProperty;
var $9e32ad5ad3f20ed6$var$StringArrayProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(StringArrayProperty, _super);
    function StringArrayProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    StringArrayProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined || !Array.isArray(sourceValue)) return this.defaultValue;
        var result = [];
        for(var _i = 0, sourceValue_1 = sourceValue; _i < sourceValue_1.length; _i++){
            var value = sourceValue_1[_i];
            if (typeof value === "string") result.push(value);
            else context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, 'Invalid array value "'.concat(JSON.stringify(value), '" of type "').concat(typeof value, '" ignored for "').concat(this.name, '".'));
        }
        return result;
    };
    StringArrayProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return StringArrayProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.StringArrayProperty = $9e32ad5ad3f20ed6$var$StringArrayProperty;
var $9e32ad5ad3f20ed6$var$ValueSetProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(ValueSetProperty, _super);
    function ValueSetProperty(targetVersion, name, values, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.values = values;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    ValueSetProperty.prototype.isValidValue = function(value, context) {
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (value.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                return targetVersion.compareTo(context.targetVersion) <= 0;
            }
        }
        return false;
    };
    ValueSetProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        if (typeof sourceValue === "string") for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (sourceValue.toLowerCase() === versionedValue.value.toLowerCase()) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return versionedValue.value;
                else {
                    context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    ValueSetProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $4uYwi.ValidationPhase.ToJSON, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.propertyValueNotSupported(value, this.name, targetVersion.toString(), context.targetVersion.toString()));
                }
            }
        }
        if (!invalidValue) context.serializeValue(target, this.name, value, this.defaultValue, true);
    };
    return ValueSetProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.ValueSetProperty = $9e32ad5ad3f20ed6$var$ValueSetProperty;
var $9e32ad5ad3f20ed6$var$EnumProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(EnumProperty, _super);
    function EnumProperty(targetVersion, name, enumType, defaultValue, values, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.enumType = enumType;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        _this._values = [];
        if (!values) // eslint-disable-next-line guard-for-in
        for(var key in enumType){
            var keyAsNumber = parseInt(key, 10);
            if (keyAsNumber >= 0) _this._values.push({
                value: keyAsNumber
            });
        }
        else _this._values = values;
        return _this;
    }
    EnumProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (typeof sourceValue !== "string") return this.defaultValue;
        var enumValue = $6EfR6.getEnumValueByName(this.enumType, sourceValue);
        if (enumValue !== undefined) for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var versionedValue = _a[_i];
            if (versionedValue.value === enumValue) {
                var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                if (targetVersion.compareTo(context.targetVersion) <= 0) return enumValue;
                else {
                    context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.propertyValueNotSupported(sourceValue, this.name, targetVersion.toString(), context.targetVersion.toString()));
                    return this.defaultValue;
                }
            }
        }
        context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return this.defaultValue;
    };
    EnumProperty.prototype.toJSON = function(sender, target, value, context) {
        var invalidValue = false;
        if (value !== undefined) {
            invalidValue = true;
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var versionedValue = _a[_i];
                if (versionedValue.value === value) {
                    var targetVersion = versionedValue.targetVersion ? versionedValue.targetVersion : this.targetVersion;
                    if (targetVersion.compareTo(context.targetVersion) <= 0) {
                        invalidValue = false;
                        break;
                    } else context.logEvent(sender, $4uYwi.ValidationPhase.ToJSON, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidPropertyValue(value, this.name));
                }
            }
        }
        if (!invalidValue) context.serializeEnum(this.enumType, target, this.name, value, this.defaultValue);
    };
    Object.defineProperty(EnumProperty.prototype, "values", {
        get: function() {
            return this._values;
        },
        enumerable: false,
        configurable: true
    });
    return EnumProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.EnumProperty = $9e32ad5ad3f20ed6$var$EnumProperty;
var $9e32ad5ad3f20ed6$var$SerializableObjectProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(SerializableObjectProperty, _super);
    function SerializableObjectProperty(targetVersion, name, objectType, nullable, defaultValue) {
        if (nullable === void 0) nullable = false;
        var _this = _super.call(this, targetVersion, name, defaultValue, function(sender) {
            return _this.nullable ? undefined : new _this.objectType();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.nullable = nullable;
        return _this;
    }
    SerializableObjectProperty.prototype.parse = function(sender, source, context) {
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.onGetInitialValue ? this.onGetInitialValue(sender) : this.defaultValue;
        var result = new this.objectType();
        result.parse(sourceValue, context);
        return result;
    };
    SerializableObjectProperty.prototype.toJSON = function(sender, target, value, context) {
        var serializedValue = undefined;
        if (value !== undefined && !value.hasAllDefaultValues()) serializedValue = value.toJSON(context);
        if (typeof serializedValue === "object" && Object.keys(serializedValue).length === 0) serializedValue = undefined;
        context.serializeValue(target, this.name, serializedValue, this.defaultValue, true);
    };
    return SerializableObjectProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.SerializableObjectProperty = $9e32ad5ad3f20ed6$var$SerializableObjectProperty;
var $9e32ad5ad3f20ed6$var$SerializableObjectCollectionProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(SerializableObjectCollectionProperty, _super);
    function SerializableObjectCollectionProperty(targetVersion, name, objectType, onItemAdded) {
        var _this = _super.call(this, targetVersion, name, undefined, function(sender) {
            return [];
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.objectType = objectType;
        _this.onItemAdded = onItemAdded;
        return _this;
    }
    SerializableObjectCollectionProperty.prototype.parse = function(sender, source, context) {
        var result = [];
        var sourceCollection = source[this.name];
        if (Array.isArray(sourceCollection)) for(var _i = 0, sourceCollection_1 = sourceCollection; _i < sourceCollection_1.length; _i++){
            var sourceItem = sourceCollection_1[_i];
            var item = new this.objectType();
            item.parse(sourceItem, context);
            result.push(item);
            if (this.onItemAdded) this.onItemAdded(sender, item);
        }
        return result.length > 0 ? result : this.onGetInitialValue ? this.onGetInitialValue(sender) : undefined;
    };
    SerializableObjectCollectionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeArray(target, this.name, value);
    };
    return SerializableObjectCollectionProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.SerializableObjectCollectionProperty = $9e32ad5ad3f20ed6$var$SerializableObjectCollectionProperty;
var $9e32ad5ad3f20ed6$var$CustomProperty = /** @class */ function(_super) {
    $9e32ad5ad3f20ed6$var$__extends(CustomProperty, _super);
    function CustomProperty(targetVersion, name, onParse, onToJSON, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.onParse = onParse;
        _this.onToJSON = onToJSON;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        if (!_this.onParse) throw new Error("CustomPropertyDefinition instances must have an onParse handler.");
        if (!_this.onToJSON) throw new Error("CustomPropertyDefinition instances must have an onToJSON handler.");
        return _this;
    }
    CustomProperty.prototype.parse = function(sender, source, context) {
        return this.onParse(sender, this, source, context);
    };
    CustomProperty.prototype.toJSON = function(sender, target, value, context) {
        this.onToJSON(sender, this, target, value, context);
    };
    return CustomProperty;
}($9e32ad5ad3f20ed6$var$PropertyDefinition);
module.exports.CustomProperty = $9e32ad5ad3f20ed6$var$CustomProperty;
var $9e32ad5ad3f20ed6$var$SerializableObjectSchema = /** @class */ function() {
    function SerializableObjectSchema() {
        this._properties = [];
    }
    SerializableObjectSchema.prototype.indexOf = function(prop) {
        for(var i = 0; i < this._properties.length; i++){
            if (this._properties[i] === prop) return i;
        }
        return -1;
    };
    SerializableObjectSchema.prototype.add = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_1 = properties; _a < properties_1.length; _a++){
            var prop = properties_1[_a];
            if (this.indexOf(prop) === -1) this._properties.push(prop);
        }
    };
    SerializableObjectSchema.prototype.remove = function() {
        var properties = [];
        for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
        for(var _a = 0, properties_2 = properties; _a < properties_2.length; _a++){
            var prop = properties_2[_a];
            while(true){
                var index = this.indexOf(prop);
                if (index >= 0) this._properties.splice(index, 1);
                else break;
            }
        }
    };
    SerializableObjectSchema.prototype.getItemAt = function(index) {
        return this._properties[index];
    };
    SerializableObjectSchema.prototype.getCount = function() {
        return this._properties.length;
    };
    return SerializableObjectSchema;
}();
module.exports.SerializableObjectSchema = $9e32ad5ad3f20ed6$var$SerializableObjectSchema;
// This is a decorator function, used to map SerializableObject descendant class members to
// schema properties
function $9e32ad5ad3f20ed6$var$property(prop) {
    return function(target, propertyKey) {
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || {};
        if (!descriptor.get && !descriptor.set) {
            descriptor.get = function() {
                return this.getValue(prop);
            };
            descriptor.set = function(value) {
                this.setValue(prop, value);
            };
            Object.defineProperty(target, propertyKey, descriptor);
        }
    };
}
module.exports.property = $9e32ad5ad3f20ed6$var$property;
var $9e32ad5ad3f20ed6$var$SerializableObject = /** @class */ function() {
    function SerializableObject() {
        this._propertyBag = {};
        this._rawProperties = {};
        this.maxVersion = SerializableObject.defaultMaxVersion;
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (prop.onGetInitialValue) this.setValue(prop, prop.onGetInitialValue(this));
        }
    }
    SerializableObject.prototype.getDefaultSerializationContext = function() {
        return new $9e32ad5ad3f20ed6$var$SimpleSerializationContext();
    };
    SerializableObject.prototype.populateSchema = function(schema) {
        var ctor = this.constructor;
        var properties = [];
        // eslint-disable-next-line guard-for-in
        for(var propertyName in ctor)try {
            var propertyValue = ctor[propertyName];
            if (propertyValue instanceof $9e32ad5ad3f20ed6$var$PropertyDefinition) properties.push(propertyValue);
        } catch (_a) {
        // If a property happens to have a getter function and
        // it throws an exception, we need to catch it here
        }
        if (properties.length > 0) {
            var sortedProperties = properties.sort(function(p1, p2) {
                if (p1.sequentialNumber > p2.sequentialNumber) return 1;
                else if (p1.sequentialNumber < p2.sequentialNumber) return -1;
                return 0;
            });
            schema.add.apply(schema, sortedProperties);
        }
        if (SerializableObject.onRegisterCustomProperties) SerializableObject.onRegisterCustomProperties(this, schema);
    };
    SerializableObject.prototype.getValue = function(prop) {
        return this._propertyBag.hasOwnProperty(prop.getInternalName()) ? this._propertyBag[prop.getInternalName()] : prop.defaultValue;
    };
    SerializableObject.prototype.setValue = function(prop, value) {
        if (value === undefined || value === null) delete this._propertyBag[prop.getInternalName()];
        else this._propertyBag[prop.getInternalName()] = value;
    };
    SerializableObject.prototype.internalParse = function(source, context) {
        this._propertyBag = {};
        this._rawProperties = $krmaK.GlobalSettings.enableFullJsonRoundTrip ? source ? source : {} : {};
        if (source) {
            var s = this.getSchema();
            for(var i = 0; i < s.getCount(); i++){
                var prop = s.getItemAt(i);
                if (prop.isSerializationEnabled) {
                    var propertyValue = prop.onGetInitialValue ? prop.onGetInitialValue(this) : undefined;
                    if (source.hasOwnProperty(prop.name)) {
                        if (prop.targetVersion.compareTo(context.targetVersion) <= 0) propertyValue = prop.parse(this, source, context);
                        else context.logParseEvent(this, $4uYwi.ValidationEvent.UnsupportedProperty, $luP4B.Strings.errors.propertyNotSupported(prop.name, prop.targetVersion.toString(), context.targetVersion.toString()));
                    }
                    this.setValue(prop, propertyValue);
                }
            }
        } else this.resetDefaultValues();
    };
    SerializableObject.prototype.internalToJSON = function(target, context) {
        var s = this.getSchema();
        var serializedProperties = [];
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            // Avoid serializing the same property multiple times. This is necessary
            // because some property definitions map to the same underlying schema
            // property
            if (prop.isSerializationEnabled && prop.targetVersion.compareTo(context.targetVersion) <= 0 && serializedProperties.indexOf(prop.name) === -1) {
                prop.toJSON(this, target, this.getValue(prop), context);
                serializedProperties.push(prop.name);
            }
        }
    };
    SerializableObject.prototype.shouldSerialize = function(_context) {
        return true;
    };
    SerializableObject.prototype.parse = function(source, context) {
        this.internalParse(source, context ? context : new $9e32ad5ad3f20ed6$var$SimpleSerializationContext());
    };
    SerializableObject.prototype.toJSON = function(context) {
        var effectiveContext;
        if (context && context instanceof $9e32ad5ad3f20ed6$var$BaseSerializationContext) effectiveContext = context;
        else {
            effectiveContext = this.getDefaultSerializationContext();
            effectiveContext.toJSONOriginalParam = context;
        }
        if (this.shouldSerialize(effectiveContext)) {
            var result = void 0;
            if ($krmaK.GlobalSettings.enableFullJsonRoundTrip && this._rawProperties && typeof this._rawProperties === "object") result = this._rawProperties;
            else result = {};
            this.internalToJSON(result, effectiveContext);
            return result;
        } else return undefined;
    };
    SerializableObject.prototype.hasDefaultValue = function(prop) {
        return this.getValue(prop) === prop.defaultValue;
    };
    SerializableObject.prototype.hasAllDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            if (!this.hasDefaultValue(prop)) return false;
        }
        return true;
    };
    SerializableObject.prototype.resetDefaultValues = function() {
        var s = this.getSchema();
        for(var i = 0; i < s.getCount(); i++){
            var prop = s.getItemAt(i);
            this.setValue(prop, prop.defaultValue);
        }
    };
    SerializableObject.prototype.setCustomProperty = function(name, value) {
        var shouldDeleteProperty = typeof value === "string" && !value || value === undefined || value === null;
        if (shouldDeleteProperty) delete this._rawProperties[name];
        else this._rawProperties[name] = value;
    };
    SerializableObject.prototype.getCustomProperty = function(name) {
        return this._rawProperties[name];
    };
    SerializableObject.prototype.getSchema = function() {
        var schema = SerializableObject._schemaCache[this.getSchemaKey()];
        if (!schema) {
            schema = new $9e32ad5ad3f20ed6$var$SerializableObjectSchema();
            this.populateSchema(schema);
            SerializableObject._schemaCache[this.getSchemaKey()] = schema;
        }
        return schema;
    };
    SerializableObject.defaultMaxVersion = $9e32ad5ad3f20ed6$var$Versions.latest;
    SerializableObject._schemaCache = {};
    return SerializableObject;
}();
module.exports.SerializableObject = $9e32ad5ad3f20ed6$var$SerializableObject;

});

parcelRegister("8Pqcb", function(module, exports) {
"use strict";
var $66d7680b64cc5850$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HostCapabilities = void 0;

var $dA5cX = parcelRequire("dA5cX");
var $66d7680b64cc5850$var$HostCapabilities = /** @class */ function(_super) {
    $66d7680b64cc5850$var$__extends(HostCapabilities, _super);
    function HostCapabilities() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._capabilities = {};
        return _this;
    }
    HostCapabilities.prototype.getSchemaKey = function() {
        return "HostCapabilities";
    };
    HostCapabilities.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        if (source) // eslint-disable-next-line guard-for-in
        for(var name_1 in source){
            var jsonVersion = source[name_1];
            if (typeof jsonVersion === "string") {
                if (jsonVersion === "*") this.addCapability(name_1, "*");
                else {
                    var version = $dA5cX.Version.parse(jsonVersion, context);
                    if (version === null || version === void 0 ? void 0 : version.isValid) this.addCapability(name_1, version);
                }
            }
        }
    };
    HostCapabilities.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        // eslint-disable-next-line guard-for-in
        for(var key in this._capabilities)target[key] = this._capabilities[key];
    };
    HostCapabilities.prototype.addCapability = function(name, version) {
        this._capabilities[name] = version;
    };
    HostCapabilities.prototype.removeCapability = function(name) {
        delete this._capabilities[name];
    };
    HostCapabilities.prototype.clear = function() {
        this._capabilities = {};
    };
    HostCapabilities.prototype.hasCapability = function(name, version) {
        if (this._capabilities.hasOwnProperty(name)) {
            if (version === "*" || this._capabilities[name] === "*") return true;
            return version.compareTo(this._capabilities[name]) <= 0;
        }
        return false;
    };
    HostCapabilities.prototype.areAllMet = function(hostCapabilities) {
        for(var capabilityName in this._capabilities){
            if (!hostCapabilities.hasCapability(capabilityName, this._capabilities[capabilityName])) return false;
        }
        return true;
    };
    return HostCapabilities;
}($dA5cX.SerializableObject);
module.exports.HostCapabilities = $66d7680b64cc5850$var$HostCapabilities;

});

parcelRegister("icYWo", function(module, exports) {
"use strict";
var $d4189e90ec990f76$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultHostConfig = module.exports.HostConfig = module.exports.CarouselConfig = module.exports.FontTypeSet = module.exports.FontTypeDefinition = module.exports.ContainerStyleSet = module.exports.ContainerStyleDefinition = module.exports.ColorSetDefinition = module.exports.ActionsConfig = module.exports.ShowCardActionConfig = module.exports.FactSetConfig = module.exports.FactTitleDefinition = module.exports.FactTextDefinition = module.exports.InputConfig = module.exports.InputLabelConfig = module.exports.RequiredInputLabelTextDefinition = module.exports.TextBlockConfig = module.exports.TextStyleSet = module.exports.TextStyleDefinition = module.exports.BaseTextDefinition = module.exports.TableConfig = module.exports.MediaConfig = module.exports.ImageSetConfig = module.exports.AdaptiveCardConfig = module.exports.TextColorDefinition = module.exports.ColorDefinition = void 0;

var $4uYwi = parcelRequire("4uYwi");

var $6EfR6 = parcelRequire("6EfR6");

var $krmaK = parcelRequire("krmaK");

var $8Pqcb = parcelRequire("8Pqcb");
function $d4189e90ec990f76$var$parseHostConfigEnum(targetEnum, value, defaultValue) {
    if (typeof value === "string") {
        var parsedValue = $6EfR6.parseEnum(targetEnum, value, defaultValue);
        return parsedValue !== undefined ? parsedValue : defaultValue;
    } else if (typeof value === "number") return value;
    else return defaultValue;
}
var $d4189e90ec990f76$var$ColorDefinition = /** @class */ function() {
    function ColorDefinition(defaultColor, subtleColor) {
        this.default = "#000000";
        this.subtle = "#666666";
        if (defaultColor) this.default = defaultColor;
        if (subtleColor) this.subtle = subtleColor;
    }
    ColorDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.default = obj["default"] || this.default;
            this.subtle = obj["subtle"] || this.subtle;
        }
    };
    return ColorDefinition;
}();
module.exports.ColorDefinition = $d4189e90ec990f76$var$ColorDefinition;
var $d4189e90ec990f76$var$TextColorDefinition = /** @class */ function(_super) {
    $d4189e90ec990f76$var$__extends(TextColorDefinition, _super);
    function TextColorDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.highlightColors = new $d4189e90ec990f76$var$ColorDefinition("#22000000", "#11000000");
        return _this;
    }
    TextColorDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.highlightColors.parse(obj["highlightColors"]);
    };
    return TextColorDefinition;
}($d4189e90ec990f76$var$ColorDefinition);
module.exports.TextColorDefinition = $d4189e90ec990f76$var$TextColorDefinition;
var $d4189e90ec990f76$var$AdaptiveCardConfig = /** @class */ function() {
    function AdaptiveCardConfig(obj) {
        this.allowCustomStyle = false;
        if (obj) this.allowCustomStyle = obj["allowCustomStyle"] || this.allowCustomStyle;
    }
    return AdaptiveCardConfig;
}();
module.exports.AdaptiveCardConfig = $d4189e90ec990f76$var$AdaptiveCardConfig;
var $d4189e90ec990f76$var$ImageSetConfig = /** @class */ function() {
    function ImageSetConfig(obj) {
        this.imageSize = $4uYwi.Size.Medium;
        this.maxImageHeight = 100;
        if (obj) {
            this.imageSize = obj["imageSize"] != null ? obj["imageSize"] : this.imageSize;
            this.maxImageHeight = $6EfR6.parseNumber(obj["maxImageHeight"], 100);
        }
    }
    ImageSetConfig.prototype.toJSON = function() {
        return {
            imageSize: $4uYwi.Size[this.imageSize],
            maxImageHeight: this.maxImageHeight
        };
    };
    return ImageSetConfig;
}();
module.exports.ImageSetConfig = $d4189e90ec990f76$var$ImageSetConfig;
var $d4189e90ec990f76$var$MediaConfig = /** @class */ function() {
    function MediaConfig(obj) {
        this.allowInlinePlayback = true;
        if (obj) {
            this.defaultPoster = obj["defaultPoster"];
            this.allowInlinePlayback = obj["allowInlinePlayback"] || this.allowInlinePlayback;
        }
    }
    MediaConfig.prototype.toJSON = function() {
        return {
            defaultPoster: this.defaultPoster,
            allowInlinePlayback: this.allowInlinePlayback
        };
    };
    return MediaConfig;
}();
module.exports.MediaConfig = $d4189e90ec990f76$var$MediaConfig;
var $d4189e90ec990f76$var$TableConfig = /** @class */ function() {
    function TableConfig(obj) {
        this.cellSpacing = 8;
        if (obj) this.cellSpacing = obj.cellSpacing && typeof obj.cellSpacing === "number" ? obj.cellSpacing : this.cellSpacing;
    }
    TableConfig.prototype.toJSON = function() {
        return {
            cellSpacing: this.cellSpacing
        };
    };
    return TableConfig;
}();
module.exports.TableConfig = $d4189e90ec990f76$var$TableConfig;
var $d4189e90ec990f76$var$BaseTextDefinition = /** @class */ function() {
    function BaseTextDefinition(obj) {
        this.size = $4uYwi.TextSize.Default;
        this.color = $4uYwi.TextColor.Default;
        this.isSubtle = false;
        this.weight = $4uYwi.TextWeight.Default;
        this.parse(obj);
    }
    BaseTextDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.size = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.TextSize, obj["size"], this.size);
            this.color = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.TextColor, obj["color"], this.color);
            this.isSubtle = obj.isSubtle !== undefined && typeof obj.isSubtle === "boolean" ? obj.isSubtle : this.isSubtle;
            this.weight = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.TextWeight, obj["weight"], this.getDefaultWeight());
        }
    };
    BaseTextDefinition.prototype.getDefaultWeight = function() {
        return $4uYwi.TextWeight.Default;
    };
    BaseTextDefinition.prototype.toJSON = function() {
        return {
            size: $4uYwi.TextSize[this.size],
            color: $4uYwi.TextColor[this.color],
            isSubtle: this.isSubtle,
            weight: $4uYwi.TextWeight[this.weight]
        };
    };
    return BaseTextDefinition;
}();
module.exports.BaseTextDefinition = $d4189e90ec990f76$var$BaseTextDefinition;
var $d4189e90ec990f76$var$TextStyleDefinition = /** @class */ function(_super) {
    $d4189e90ec990f76$var$__extends(TextStyleDefinition, _super);
    function TextStyleDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fontType = $4uYwi.FontType.Default;
        return _this;
    }
    TextStyleDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.fontType = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.FontType, obj.fontType, this.fontType);
    };
    return TextStyleDefinition;
}($d4189e90ec990f76$var$BaseTextDefinition);
module.exports.TextStyleDefinition = $d4189e90ec990f76$var$TextStyleDefinition;
var $d4189e90ec990f76$var$TextStyleSet = /** @class */ function() {
    function TextStyleSet(obj) {
        this.default = new $d4189e90ec990f76$var$TextStyleDefinition();
        this.heading = new $d4189e90ec990f76$var$TextStyleDefinition({
            size: "Large",
            weight: "Bolder"
        });
        this.columnHeader = new $d4189e90ec990f76$var$TextStyleDefinition({
            weight: "Bolder"
        });
        if (obj) {
            this.heading.parse(obj.heading);
            this.columnHeader.parse(obj.columnHeader);
        }
    }
    TextStyleSet.prototype.getStyleByName = function(name) {
        switch(name.toLowerCase()){
            case "heading":
                return this.heading;
            case "columnHeader":
                return this.columnHeader;
            default:
                return this.default;
        }
    };
    return TextStyleSet;
}();
module.exports.TextStyleSet = $d4189e90ec990f76$var$TextStyleSet;
var $d4189e90ec990f76$var$TextBlockConfig = /** @class */ function() {
    function TextBlockConfig(obj) {
        if (obj) this.headingLevel = $6EfR6.parseNumber(obj.headingLevel);
    }
    return TextBlockConfig;
}();
module.exports.TextBlockConfig = $d4189e90ec990f76$var$TextBlockConfig;
var $d4189e90ec990f76$var$RequiredInputLabelTextDefinition = /** @class */ function(_super) {
    $d4189e90ec990f76$var$__extends(RequiredInputLabelTextDefinition, _super);
    function RequiredInputLabelTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suffix = " *";
        _this.suffixColor = $4uYwi.TextColor.Attention;
        return _this;
    }
    RequiredInputLabelTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) {
            this.suffix = obj["suffix"] || this.suffix;
            this.suffixColor = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.TextColor, obj["suffixColor"], this.suffixColor);
        }
    };
    RequiredInputLabelTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["suffix"] = this.suffix;
        result["suffixColor"] = $4uYwi.TextColor[this.suffixColor];
        return result;
    };
    return RequiredInputLabelTextDefinition;
}($d4189e90ec990f76$var$BaseTextDefinition);
module.exports.RequiredInputLabelTextDefinition = $d4189e90ec990f76$var$RequiredInputLabelTextDefinition;
var $d4189e90ec990f76$var$InputLabelConfig = /** @class */ function() {
    function InputLabelConfig(obj) {
        this.inputSpacing = $4uYwi.Spacing.Small;
        this.width = 30;
        this.requiredInputs = new $d4189e90ec990f76$var$RequiredInputLabelTextDefinition();
        this.optionalInputs = new $d4189e90ec990f76$var$BaseTextDefinition();
        if (obj) {
            this.inputSpacing = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.Spacing, obj["inputSpacing"], this.inputSpacing);
            this.requiredInputs = new $d4189e90ec990f76$var$RequiredInputLabelTextDefinition(obj["requiredInputs"]);
            this.optionalInputs = new $d4189e90ec990f76$var$BaseTextDefinition(obj["optionalInputs"]);
            this.width = obj["width"] != null ? obj["width"] : this.width;
        }
    }
    return InputLabelConfig;
}();
module.exports.InputLabelConfig = $d4189e90ec990f76$var$InputLabelConfig;
var $d4189e90ec990f76$var$InputConfig = /** @class */ function() {
    function InputConfig(obj) {
        this.label = new $d4189e90ec990f76$var$InputLabelConfig();
        this.errorMessage = new $d4189e90ec990f76$var$BaseTextDefinition({
            color: $4uYwi.TextColor.Attention
        });
        this.debounceTimeInMilliSeconds = 0;
        this.allowDynamicallyFilteredChoiceSet = true;
        this.allowRevealOnHoverStyle = false;
        if (obj) {
            this.label = new $d4189e90ec990f76$var$InputLabelConfig(obj["label"]);
            this.errorMessage = new $d4189e90ec990f76$var$BaseTextDefinition(obj["errorMessage"]);
            this.allowRevealOnHoverStyle = obj["allowRevealOnHoverStyle"] || this.allowRevealOnHoverStyle;
            this.allowDynamicallyFilteredChoiceSet = obj["allowDynamicallyFilteredChoiceSet"] || this.allowDynamicallyFilteredChoiceSet;
            this.debounceTimeInMilliSeconds = obj["debounceTimeInMilliSeconds"] || this.debounceTimeInMilliSeconds;
        }
    }
    return InputConfig;
}();
module.exports.InputConfig = $d4189e90ec990f76$var$InputConfig;
var $d4189e90ec990f76$var$FactTextDefinition = /** @class */ function(_super) {
    $d4189e90ec990f76$var$__extends(FactTextDefinition, _super);
    function FactTextDefinition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = true;
        return _this;
    }
    FactTextDefinition.prototype.parse = function(obj) {
        _super.prototype.parse.call(this, obj);
        if (obj) this.wrap = obj["wrap"] != null ? obj["wrap"] : this.wrap;
    };
    FactTextDefinition.prototype.toJSON = function() {
        var result = _super.prototype.toJSON.call(this);
        result["wrap"] = this.wrap;
        return result;
    };
    return FactTextDefinition;
}($d4189e90ec990f76$var$BaseTextDefinition);
module.exports.FactTextDefinition = $d4189e90ec990f76$var$FactTextDefinition;
var $d4189e90ec990f76$var$FactTitleDefinition = /** @class */ function(_super) {
    $d4189e90ec990f76$var$__extends(FactTitleDefinition, _super);
    function FactTitleDefinition(obj) {
        var _this = _super.call(this, obj) || this;
        _this.maxWidth = 150;
        _this.weight = $4uYwi.TextWeight.Bolder;
        if (obj) {
            _this.maxWidth = obj["maxWidth"] != null ? obj["maxWidth"] : _this.maxWidth;
            _this.weight = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.TextWeight, obj["weight"], $4uYwi.TextWeight.Bolder);
        }
        return _this;
    }
    FactTitleDefinition.prototype.getDefaultWeight = function() {
        return $4uYwi.TextWeight.Bolder;
    };
    return FactTitleDefinition;
}($d4189e90ec990f76$var$FactTextDefinition);
module.exports.FactTitleDefinition = $d4189e90ec990f76$var$FactTitleDefinition;
var $d4189e90ec990f76$var$FactSetConfig = /** @class */ function() {
    function FactSetConfig(obj) {
        this.title = new $d4189e90ec990f76$var$FactTitleDefinition();
        this.value = new $d4189e90ec990f76$var$FactTextDefinition();
        this.spacing = 10;
        if (obj) {
            this.title = new $d4189e90ec990f76$var$FactTitleDefinition(obj["title"]);
            this.value = new $d4189e90ec990f76$var$FactTextDefinition(obj["value"]);
            this.spacing = obj.spacing && obj.spacing != null ? obj.spacing && obj.spacing : this.spacing;
        }
    }
    return FactSetConfig;
}();
module.exports.FactSetConfig = $d4189e90ec990f76$var$FactSetConfig;
var $d4189e90ec990f76$var$ShowCardActionConfig = /** @class */ function() {
    function ShowCardActionConfig(obj) {
        this.actionMode = $4uYwi.ShowCardActionMode.Inline;
        this.inlineTopMargin = 16;
        this.style = $4uYwi.ContainerStyle.Emphasis;
        if (obj) {
            this.actionMode = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.ShowCardActionMode, obj["actionMode"], $4uYwi.ShowCardActionMode.Inline);
            this.inlineTopMargin = obj["inlineTopMargin"] != null ? obj["inlineTopMargin"] : this.inlineTopMargin;
            this.style = obj["style"] && typeof obj["style"] === "string" ? obj["style"] : $4uYwi.ContainerStyle.Emphasis;
        }
    }
    ShowCardActionConfig.prototype.toJSON = function() {
        return {
            actionMode: $4uYwi.ShowCardActionMode[this.actionMode],
            inlineTopMargin: this.inlineTopMargin,
            style: this.style
        };
    };
    return ShowCardActionConfig;
}();
module.exports.ShowCardActionConfig = $d4189e90ec990f76$var$ShowCardActionConfig;
var $d4189e90ec990f76$var$ActionsConfig = /** @class */ function() {
    function ActionsConfig(obj) {
        this.maxActions = 5;
        this.spacing = $4uYwi.Spacing.Default;
        this.buttonSpacing = 20;
        this.showCard = new $d4189e90ec990f76$var$ShowCardActionConfig();
        this.preExpandSingleShowCardAction = false;
        this.actionsOrientation = $4uYwi.Orientation.Horizontal;
        this.actionAlignment = $4uYwi.ActionAlignment.Left;
        this.iconPlacement = $4uYwi.ActionIconPlacement.LeftOfTitle;
        this.allowTitleToWrap = false;
        this.iconSize = 16;
        if (obj) {
            this.maxActions = obj["maxActions"] != null ? obj["maxActions"] : this.maxActions;
            this.spacing = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.Spacing, obj.spacing && obj.spacing, $4uYwi.Spacing.Default);
            this.buttonSpacing = obj["buttonSpacing"] != null ? obj["buttonSpacing"] : this.buttonSpacing;
            this.showCard = new $d4189e90ec990f76$var$ShowCardActionConfig(obj["showCard"]);
            this.preExpandSingleShowCardAction = $6EfR6.parseBool(obj["preExpandSingleShowCardAction"], false);
            this.actionsOrientation = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.Orientation, obj["actionsOrientation"], $4uYwi.Orientation.Horizontal);
            this.actionAlignment = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.ActionAlignment, obj["actionAlignment"], $4uYwi.ActionAlignment.Left);
            this.iconPlacement = $d4189e90ec990f76$var$parseHostConfigEnum($4uYwi.ActionIconPlacement, obj["iconPlacement"], $4uYwi.ActionIconPlacement.LeftOfTitle);
            this.allowTitleToWrap = obj["allowTitleToWrap"] != null ? obj["allowTitleToWrap"] : this.allowTitleToWrap;
            try {
                var sizeAndUnit = $krmaK.SizeAndUnit.parse(obj["iconSize"]);
                if (sizeAndUnit.unit === $4uYwi.SizeUnit.Pixel) this.iconSize = sizeAndUnit.physicalSize;
            } catch (e) {
            // Swallow this, keep default icon size
            }
        }
    }
    ActionsConfig.prototype.toJSON = function() {
        return {
            maxActions: this.maxActions,
            spacing: $4uYwi.Spacing[this.spacing],
            buttonSpacing: this.buttonSpacing,
            showCard: this.showCard,
            preExpandSingleShowCardAction: this.preExpandSingleShowCardAction,
            actionsOrientation: $4uYwi.Orientation[this.actionsOrientation],
            actionAlignment: $4uYwi.ActionAlignment[this.actionAlignment]
        };
    };
    return ActionsConfig;
}();
module.exports.ActionsConfig = $d4189e90ec990f76$var$ActionsConfig;
var $d4189e90ec990f76$var$ColorSetDefinition = /** @class */ function() {
    function ColorSetDefinition(obj) {
        this.default = new $d4189e90ec990f76$var$TextColorDefinition();
        this.dark = new $d4189e90ec990f76$var$TextColorDefinition();
        this.light = new $d4189e90ec990f76$var$TextColorDefinition();
        this.accent = new $d4189e90ec990f76$var$TextColorDefinition();
        this.good = new $d4189e90ec990f76$var$TextColorDefinition();
        this.warning = new $d4189e90ec990f76$var$TextColorDefinition();
        this.attention = new $d4189e90ec990f76$var$TextColorDefinition();
        this.parse(obj);
    }
    ColorSetDefinition.prototype.parseSingleColor = function(obj, propertyName) {
        if (obj) this[propertyName].parse(obj[propertyName]);
    };
    ColorSetDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.parseSingleColor(obj, "default");
            this.parseSingleColor(obj, "dark");
            this.parseSingleColor(obj, "light");
            this.parseSingleColor(obj, "accent");
            this.parseSingleColor(obj, "good");
            this.parseSingleColor(obj, "warning");
            this.parseSingleColor(obj, "attention");
        }
    };
    return ColorSetDefinition;
}();
module.exports.ColorSetDefinition = $d4189e90ec990f76$var$ColorSetDefinition;
var $d4189e90ec990f76$var$ContainerStyleDefinition = /** @class */ function() {
    function ContainerStyleDefinition(obj) {
        this.foregroundColors = new $d4189e90ec990f76$var$ColorSetDefinition({
            "default": {
                default: "#333333",
                subtle: "#EE333333"
            },
            "dark": {
                default: "#000000",
                subtle: "#66000000"
            },
            "light": {
                default: "#FFFFFF",
                subtle: "#33000000"
            },
            "accent": {
                default: "#2E89FC",
                subtle: "#882E89FC"
            },
            "good": {
                default: "#028A02",
                subtle: "#DD027502"
            },
            "warning": {
                default: "#E69500",
                subtle: "#DDE69500"
            },
            "attention": {
                default: "#CC3300",
                subtle: "#DDCC3300"
            }
        });
        this.parse(obj);
    }
    ContainerStyleDefinition.prototype.parse = function(obj) {
        if (obj) {
            this.backgroundColor = obj["backgroundColor"];
            this.foregroundColors.parse(obj["foregroundColors"]);
            this.highlightBackgroundColor = obj["highlightBackgroundColor"];
            this.highlightForegroundColor = obj["highlightForegroundColor"];
            this.borderColor = obj["borderColor"];
        }
    };
    Object.defineProperty(ContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleDefinition;
}();
module.exports.ContainerStyleDefinition = $d4189e90ec990f76$var$ContainerStyleDefinition;
var $d4189e90ec990f76$var$BuiltInContainerStyleDefinition = /** @class */ function(_super) {
    $d4189e90ec990f76$var$__extends(BuiltInContainerStyleDefinition, _super);
    function BuiltInContainerStyleDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BuiltInContainerStyleDefinition.prototype, "isBuiltIn", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return BuiltInContainerStyleDefinition;
}($d4189e90ec990f76$var$ContainerStyleDefinition);
var $d4189e90ec990f76$var$ContainerStyleSet = /** @class */ function() {
    function ContainerStyleSet(obj) {
        this._allStyles = {};
        this._allStyles[$4uYwi.ContainerStyle.Default] = new $d4189e90ec990f76$var$BuiltInContainerStyleDefinition();
        this._allStyles[$4uYwi.ContainerStyle.Emphasis] = new $d4189e90ec990f76$var$BuiltInContainerStyleDefinition();
        this._allStyles[$4uYwi.ContainerStyle.Accent] = new $d4189e90ec990f76$var$BuiltInContainerStyleDefinition();
        this._allStyles[$4uYwi.ContainerStyle.Good] = new $d4189e90ec990f76$var$BuiltInContainerStyleDefinition();
        this._allStyles[$4uYwi.ContainerStyle.Attention] = new $d4189e90ec990f76$var$BuiltInContainerStyleDefinition();
        this._allStyles[$4uYwi.ContainerStyle.Warning] = new $d4189e90ec990f76$var$BuiltInContainerStyleDefinition();
        if (obj) {
            this._allStyles[$4uYwi.ContainerStyle.Default].parse(obj[$4uYwi.ContainerStyle.Default]);
            this._allStyles[$4uYwi.ContainerStyle.Emphasis].parse(obj[$4uYwi.ContainerStyle.Emphasis]);
            this._allStyles[$4uYwi.ContainerStyle.Accent].parse(obj[$4uYwi.ContainerStyle.Accent]);
            this._allStyles[$4uYwi.ContainerStyle.Good].parse(obj[$4uYwi.ContainerStyle.Good]);
            this._allStyles[$4uYwi.ContainerStyle.Attention].parse(obj[$4uYwi.ContainerStyle.Attention]);
            this._allStyles[$4uYwi.ContainerStyle.Warning].parse(obj[$4uYwi.ContainerStyle.Warning]);
            var customStyleArray = obj["customStyles"];
            if (customStyleArray && Array.isArray(customStyleArray)) for(var _i = 0, customStyleArray_1 = customStyleArray; _i < customStyleArray_1.length; _i++){
                var customStyle = customStyleArray_1[_i];
                if (customStyle) {
                    var styleName = customStyle["name"];
                    if (styleName && typeof styleName === "string") {
                        if (this._allStyles.hasOwnProperty(styleName)) this._allStyles[styleName].parse(customStyle["style"]);
                        else this._allStyles[styleName] = new $d4189e90ec990f76$var$ContainerStyleDefinition(customStyle["style"]);
                    }
                }
            }
        }
    }
    ContainerStyleSet.prototype.toJSON = function() {
        var _this = this;
        var customStyleArray = [];
        Object.keys(this._allStyles).forEach(function(key) {
            if (!_this._allStyles[key].isBuiltIn) customStyleArray.push({
                name: key,
                style: _this._allStyles[key]
            });
        });
        var result = {
            default: this.default,
            emphasis: this.emphasis
        };
        if (customStyleArray.length > 0) result.customStyles = customStyleArray;
        return result;
    };
    ContainerStyleSet.prototype.getStyleByName = function(name, defaultValue) {
        if (name && this._allStyles.hasOwnProperty(name)) return this._allStyles[name];
        else return defaultValue ? defaultValue : this._allStyles[$4uYwi.ContainerStyle.Default];
    };
    Object.defineProperty(ContainerStyleSet.prototype, "default", {
        get: function() {
            return this._allStyles[$4uYwi.ContainerStyle.Default];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerStyleSet.prototype, "emphasis", {
        get: function() {
            return this._allStyles[$4uYwi.ContainerStyle.Emphasis];
        },
        enumerable: false,
        configurable: true
    });
    return ContainerStyleSet;
}();
module.exports.ContainerStyleSet = $d4189e90ec990f76$var$ContainerStyleSet;
var $d4189e90ec990f76$var$FontTypeDefinition = /** @class */ function() {
    function FontTypeDefinition(fontFamily) {
        this.fontFamily = "Segoe UI,Segoe,Segoe WP,Helvetica Neue,Helvetica,sans-serif";
        this.fontSizes = {
            small: 12,
            default: 14,
            medium: 17,
            large: 21,
            extraLarge: 26
        };
        this.fontWeights = {
            lighter: 200,
            default: 400,
            bolder: 600
        };
        if (fontFamily) this.fontFamily = fontFamily;
    }
    FontTypeDefinition.prototype.parse = function(obj) {
        this.fontFamily = obj["fontFamily"] || this.fontFamily;
        this.fontSizes = {
            small: obj.fontSizes && obj.fontSizes["small"] || this.fontSizes.small,
            default: obj.fontSizes && obj.fontSizes["default"] || this.fontSizes.default,
            medium: obj.fontSizes && obj.fontSizes["medium"] || this.fontSizes.medium,
            large: obj.fontSizes && obj.fontSizes["large"] || this.fontSizes.large,
            extraLarge: obj.fontSizes && obj.fontSizes["extraLarge"] || this.fontSizes.extraLarge
        };
        this.fontWeights = {
            lighter: obj.fontWeights && obj.fontWeights["lighter"] || this.fontWeights.lighter,
            default: obj.fontWeights && obj.fontWeights["default"] || this.fontWeights.default,
            bolder: obj.fontWeights && obj.fontWeights["bolder"] || this.fontWeights.bolder
        };
    };
    FontTypeDefinition.monospace = new FontTypeDefinition("'Courier New', Courier, monospace");
    return FontTypeDefinition;
}();
module.exports.FontTypeDefinition = $d4189e90ec990f76$var$FontTypeDefinition;
var $d4189e90ec990f76$var$FontTypeSet = /** @class */ function() {
    function FontTypeSet(obj) {
        this.default = new $d4189e90ec990f76$var$FontTypeDefinition();
        this.monospace = new $d4189e90ec990f76$var$FontTypeDefinition("'Courier New', Courier, monospace");
        if (obj) {
            this.default.parse(obj["default"]);
            this.monospace.parse(obj["monospace"]);
        }
    }
    FontTypeSet.prototype.getStyleDefinition = function(style) {
        switch(style){
            case $4uYwi.FontType.Monospace:
                return this.monospace;
            case $4uYwi.FontType.Default:
            default:
                return this.default;
        }
    };
    return FontTypeSet;
}();
module.exports.FontTypeSet = $d4189e90ec990f76$var$FontTypeSet;
var $d4189e90ec990f76$var$CarouselConfig = /** @class */ function() {
    function CarouselConfig(obj) {
        this.maxCarouselPages = 10;
        this.minAutoplayDelay = 5000.0;
        if (obj) {
            this.maxCarouselPages = obj["maxCarouselPages"] != null ? obj["maxCarouselPages"] : this.maxCarouselPages;
            this.minAutoplayDelay = obj["minAutoplayDelay"] != null ? obj["minAutoplayDelay"] : this.minAutoplayDelay;
        }
    }
    CarouselConfig.prototype.toJSON = function() {
        return {
            maxCarouselPages: this.maxCarouselPages,
            minAutoplayDelay: this.minAutoplayDelay
        };
    };
    return CarouselConfig;
}();
module.exports.CarouselConfig = $d4189e90ec990f76$var$CarouselConfig;
var $d4189e90ec990f76$var$HostConfig = /** @class */ function() {
    function HostConfig(obj) {
        this.hostCapabilities = new $8Pqcb.HostCapabilities();
        this.choiceSetInputValueSeparator = ",";
        this.supportsInteractivity = true;
        this.spacing = {
            small: 3,
            default: 8,
            medium: 20,
            large: 30,
            extraLarge: 40,
            padding: 15
        };
        this.separator = {
            lineThickness: 1,
            lineColor: "#EEEEEE"
        };
        this.imageSizes = {
            small: 40,
            medium: 80,
            large: 160
        };
        this.containerStyles = new $d4189e90ec990f76$var$ContainerStyleSet();
        this.inputs = new $d4189e90ec990f76$var$InputConfig();
        this.actions = new $d4189e90ec990f76$var$ActionsConfig();
        this.adaptiveCard = new $d4189e90ec990f76$var$AdaptiveCardConfig();
        this.imageSet = new $d4189e90ec990f76$var$ImageSetConfig();
        this.media = new $d4189e90ec990f76$var$MediaConfig();
        this.factSet = new $d4189e90ec990f76$var$FactSetConfig();
        this.table = new $d4189e90ec990f76$var$TableConfig();
        this.textStyles = new $d4189e90ec990f76$var$TextStyleSet();
        this.textBlock = new $d4189e90ec990f76$var$TextBlockConfig();
        this.carousel = new $d4189e90ec990f76$var$CarouselConfig();
        this.alwaysAllowBleed = false;
        if (obj) {
            if (typeof obj === "string" || obj instanceof String) obj = JSON.parse(obj);
            this.choiceSetInputValueSeparator = obj && typeof obj["choiceSetInputValueSeparator"] === "string" ? obj["choiceSetInputValueSeparator"] : this.choiceSetInputValueSeparator;
            this.supportsInteractivity = obj && typeof obj["supportsInteractivity"] === "boolean" ? obj["supportsInteractivity"] : this.supportsInteractivity;
            this._legacyFontType = new $d4189e90ec990f76$var$FontTypeDefinition();
            this._legacyFontType.parse(obj);
            if (obj.fontTypes) this.fontTypes = new $d4189e90ec990f76$var$FontTypeSet(obj.fontTypes);
            if (obj.lineHeights) this.lineHeights = {
                small: obj.lineHeights["small"],
                default: obj.lineHeights["default"],
                medium: obj.lineHeights["medium"],
                large: obj.lineHeights["large"],
                extraLarge: obj.lineHeights["extraLarge"]
            };
            this.imageSizes = {
                small: obj.imageSizes && obj.imageSizes["small"] || this.imageSizes.small,
                medium: obj.imageSizes && obj.imageSizes["medium"] || this.imageSizes.medium,
                large: obj.imageSizes && obj.imageSizes["large"] || this.imageSizes.large
            };
            this.containerStyles = new $d4189e90ec990f76$var$ContainerStyleSet(obj["containerStyles"]);
            this.spacing = {
                small: obj.spacing && obj.spacing["small"] || this.spacing.small,
                default: obj.spacing && obj.spacing["default"] || this.spacing.default,
                medium: obj.spacing && obj.spacing["medium"] || this.spacing.medium,
                large: obj.spacing && obj.spacing["large"] || this.spacing.large,
                extraLarge: obj.spacing && obj.spacing["extraLarge"] || this.spacing.extraLarge,
                padding: obj.spacing && obj.spacing["padding"] || this.spacing.padding
            };
            this.separator = {
                lineThickness: obj.separator && obj.separator["lineThickness"] || this.separator.lineThickness,
                lineColor: obj.separator && obj.separator["lineColor"] || this.separator.lineColor
            };
            this.inputs = new $d4189e90ec990f76$var$InputConfig(obj.inputs || this.inputs);
            this.actions = new $d4189e90ec990f76$var$ActionsConfig(obj.actions || this.actions);
            this.adaptiveCard = new $d4189e90ec990f76$var$AdaptiveCardConfig(obj.adaptiveCard || this.adaptiveCard);
            this.imageSet = new $d4189e90ec990f76$var$ImageSetConfig(obj["imageSet"]);
            this.factSet = new $d4189e90ec990f76$var$FactSetConfig(obj["factSet"]);
            this.textStyles = new $d4189e90ec990f76$var$TextStyleSet(obj["textStyles"]);
            this.textBlock = new $d4189e90ec990f76$var$TextBlockConfig(obj["textBlock"]);
            this.carousel = new $d4189e90ec990f76$var$CarouselConfig(obj["carousel"]);
        }
    }
    HostConfig.prototype.getFontTypeDefinition = function(style) {
        if (this.fontTypes) return this.fontTypes.getStyleDefinition(style);
        else return style === $4uYwi.FontType.Monospace ? $d4189e90ec990f76$var$FontTypeDefinition.monospace : this._legacyFontType;
    };
    HostConfig.prototype.getEffectiveSpacing = function(spacing) {
        switch(spacing){
            case $4uYwi.Spacing.Small:
                return this.spacing.small;
            case $4uYwi.Spacing.Default:
                return this.spacing.default;
            case $4uYwi.Spacing.Medium:
                return this.spacing.medium;
            case $4uYwi.Spacing.Large:
                return this.spacing.large;
            case $4uYwi.Spacing.ExtraLarge:
                return this.spacing.extraLarge;
            case $4uYwi.Spacing.Padding:
                return this.spacing.padding;
            default:
                return 0;
        }
    };
    HostConfig.prototype.paddingDefinitionToSpacingDefinition = function(paddingDefinition) {
        return new $krmaK.SpacingDefinition(this.getEffectiveSpacing(paddingDefinition.top), this.getEffectiveSpacing(paddingDefinition.right), this.getEffectiveSpacing(paddingDefinition.bottom), this.getEffectiveSpacing(paddingDefinition.left));
    };
    HostConfig.prototype.makeCssClassNames = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = [];
        for(var _a = 0, classNames_1 = classNames; _a < classNames_1.length; _a++){
            var className = classNames_1[_a];
            result.push((this.cssClassNamePrefix ? this.cssClassNamePrefix + "-" : "") + className);
        }
        return result;
    };
    HostConfig.prototype.makeCssClassName = function() {
        var classNames = [];
        for(var _i = 0; _i < arguments.length; _i++)classNames[_i] = arguments[_i];
        var result = this.makeCssClassNames.apply(this, classNames).join(" ");
        return result ? result : "";
    };
    Object.defineProperty(HostConfig.prototype, "fontFamily", {
        get: function() {
            return this._legacyFontType.fontFamily;
        },
        set: function(value) {
            this._legacyFontType.fontFamily = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontSizes", {
        get: function() {
            return this._legacyFontType.fontSizes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HostConfig.prototype, "fontWeights", {
        get: function() {
            return this._legacyFontType.fontWeights;
        },
        enumerable: false,
        configurable: true
    });
    return HostConfig;
}();
module.exports.HostConfig = $d4189e90ec990f76$var$HostConfig;
// eslint-disable-next-line @typescript-eslint/naming-convention
module.exports.defaultHostConfig = new $d4189e90ec990f76$var$HostConfig({
    supportsInteractivity: true,
    spacing: {
        small: 10,
        default: 20,
        medium: 30,
        large: 40,
        extraLarge: 50,
        padding: 20
    },
    separator: {
        lineThickness: 1,
        lineColor: "#EEEEEE"
    },
    fontTypes: {
        default: {
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        },
        monospace: {
            fontFamily: "'Courier New', Courier, monospace",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600
            }
        }
    },
    imageSizes: {
        small: 40,
        medium: 80,
        large: 160
    },
    containerStyles: {
        default: {
            backgroundColor: "#FFFFFF",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        emphasis: {
            backgroundColor: "#08000000",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        accent: {
            backgroundColor: "#C7DEF9",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        good: {
            backgroundColor: "#CCFFCC",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        attention: {
            backgroundColor: "#FFC5B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        },
        warning: {
            backgroundColor: "#FFE2B2",
            foregroundColors: {
                default: {
                    default: "#333333",
                    subtle: "#EE333333"
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000"
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000"
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC"
                },
                attention: {
                    default: "#cc3300",
                    subtle: "#DDcc3300"
                },
                good: {
                    default: "#028A02",
                    subtle: "#DD027502"
                },
                warning: {
                    default: "#e69500",
                    subtle: "#DDe69500"
                }
            }
        }
    },
    inputs: {
        label: {
            requiredInputs: {
                weight: $4uYwi.TextWeight.Bolder,
                suffix: " *",
                suffixColor: $4uYwi.TextColor.Attention
            },
            optionalInputs: {
                weight: $4uYwi.TextWeight.Bolder
            }
        },
        errorMessage: {
            color: $4uYwi.TextColor.Attention,
            weight: $4uYwi.TextWeight.Bolder
        },
        debounceTimeInMilliSeconds: 250
    },
    actions: {
        maxActions: 5,
        spacing: $4uYwi.Spacing.Default,
        buttonSpacing: 10,
        showCard: {
            actionMode: $4uYwi.ShowCardActionMode.Inline,
            inlineTopMargin: 16
        },
        actionsOrientation: $4uYwi.Orientation.Horizontal,
        actionAlignment: $4uYwi.ActionAlignment.Left
    },
    adaptiveCard: {
        allowCustomStyle: false
    },
    imageSet: {
        imageSize: $4uYwi.Size.Medium,
        maxImageHeight: 100
    },
    factSet: {
        title: {
            color: $4uYwi.TextColor.Default,
            size: $4uYwi.TextSize.Default,
            isSubtle: false,
            weight: $4uYwi.TextWeight.Bolder,
            wrap: true,
            maxWidth: 150
        },
        value: {
            color: $4uYwi.TextColor.Default,
            size: $4uYwi.TextSize.Default,
            isSubtle: false,
            weight: $4uYwi.TextWeight.Default,
            wrap: true
        },
        spacing: 10
    },
    carousel: {
        maxCarouselPages: 10,
        minAutoplayDuration: 5000
    },
    textBlock: {
        headingLevel: 2
    }
});

});

parcelRegister("4TaX1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GlobalRegistry = module.exports.CardObjectRegistry = void 0;

var $dA5cX = parcelRequire("dA5cX");
var $38f4cb1a7dd32af7$var$CardObjectRegistry = /** @class */ function() {
    function CardObjectRegistry() {
        this._items = {};
    }
    CardObjectRegistry.prototype.findByName = function(typeName) {
        return this._items.hasOwnProperty(typeName) ? this._items[typeName] : undefined;
    };
    CardObjectRegistry.prototype.clear = function() {
        this._items = {};
    };
    CardObjectRegistry.prototype.copyTo = function(target) {
        var keys = Object.keys(this._items);
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            var typeRegistration = this._items[key];
            target.register(typeRegistration.typeName, typeRegistration.objectType, typeRegistration.schemaVersion);
        }
    };
    CardObjectRegistry.prototype.register = function(typeName, objectType, schemaVersion) {
        if (schemaVersion === void 0) schemaVersion = $dA5cX.Versions.v1_0;
        var registrationInfo = this.findByName(typeName);
        if (registrationInfo !== undefined) registrationInfo.objectType = objectType;
        else registrationInfo = {
            typeName: typeName,
            objectType: objectType,
            schemaVersion: schemaVersion
        };
        this._items[typeName] = registrationInfo;
    };
    CardObjectRegistry.prototype.unregister = function(typeName) {
        delete this._items[typeName];
    };
    CardObjectRegistry.prototype.createInstance = function(typeName, targetVersion) {
        var registrationInfo = this.findByName(typeName);
        return registrationInfo && registrationInfo.schemaVersion.compareTo(targetVersion) <= 0 ? new registrationInfo.objectType() : undefined;
    };
    CardObjectRegistry.prototype.getItemCount = function() {
        return Object.keys(this._items).length;
    };
    CardObjectRegistry.prototype.getItemAt = function(index) {
        var _this = this;
        return Object.keys(this._items).map(function(e) {
            return _this._items[e];
        })[index];
    };
    return CardObjectRegistry;
}();
module.exports.CardObjectRegistry = $38f4cb1a7dd32af7$var$CardObjectRegistry;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $38f4cb1a7dd32af7$var$GlobalRegistry = /** @class */ function() {
    function GlobalRegistry() {}
    GlobalRegistry.populateWithDefaultElements = function(registry) {
        registry.clear();
        GlobalRegistry.defaultElements.copyTo(registry);
    };
    GlobalRegistry.populateWithDefaultActions = function(registry) {
        registry.clear();
        GlobalRegistry.defaultActions.copyTo(registry);
    };
    Object.defineProperty(GlobalRegistry, "elements", {
        get: function() {
            if (!GlobalRegistry._elements) {
                GlobalRegistry._elements = new $38f4cb1a7dd32af7$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultElements(GlobalRegistry._elements);
            }
            return GlobalRegistry._elements;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalRegistry, "actions", {
        get: function() {
            if (!GlobalRegistry._actions) {
                GlobalRegistry._actions = new $38f4cb1a7dd32af7$var$CardObjectRegistry();
                GlobalRegistry.populateWithDefaultActions(GlobalRegistry._actions);
            }
            return GlobalRegistry._actions;
        },
        enumerable: false,
        configurable: true
    });
    GlobalRegistry.reset = function() {
        GlobalRegistry._elements = undefined;
        GlobalRegistry._actions = undefined;
    };
    GlobalRegistry.defaultElements = new $38f4cb1a7dd32af7$var$CardObjectRegistry();
    GlobalRegistry.defaultActions = new $38f4cb1a7dd32af7$var$CardObjectRegistry();
    return GlobalRegistry;
}();
module.exports.GlobalRegistry = $38f4cb1a7dd32af7$var$GlobalRegistry;

});

parcelRegister("hj3le", function(module, exports) {
"use strict";
var $c996cd8d2f168642$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c996cd8d2f168642$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardObject = module.exports.ValidationResults = void 0;

var $4uYwi = parcelRequire("4uYwi");

var $luP4B = parcelRequire("luP4B");

var $krmaK = parcelRequire("krmaK");

var $8Pqcb = parcelRequire("8Pqcb");

var $dA5cX = parcelRequire("dA5cX");
var $c996cd8d2f168642$var$ValidationResults = /** @class */ function() {
    function ValidationResults() {
        this.allIds = {};
        this.validationEvents = [];
    }
    ValidationResults.prototype.addFailure = function(cardObject, event, message) {
        this.validationEvents.push({
            phase: $4uYwi.ValidationPhase.Validation,
            source: cardObject,
            event: event,
            message: message
        });
    };
    return ValidationResults;
}();
module.exports.ValidationResults = $c996cd8d2f168642$var$ValidationResults;
var $c996cd8d2f168642$var$CardObject = /** @class */ function(_super) {
    $c996cd8d2f168642$var$__extends(CardObject, _super);
    function CardObject() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._shouldFallback = false;
        return _this;
    }
    CardObject.prototype.getSchemaKey = function() {
        return this.getJsonTypeName();
    };
    Object.defineProperty(CardObject.prototype, "requires", {
        get: function() {
            return this.getValue(CardObject.requiresProperty);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Checks if this CardObject contains the given DOM Node.
     * @param node The DOM Node to look for.
     * @returns `true` if the DOM Node was found, `false` otherwise.
     */ CardObject.prototype.contains = function(node) {
        if (this._renderedElement) return this._renderedElement.contains(node);
        return false;
    };
    CardObject.prototype.preProcessPropertyValue = function(prop, propertyValue) {
        var value = propertyValue === undefined ? this.getValue(prop) : propertyValue;
        if ($krmaK.GlobalSettings.allowPreProcessingPropertyValues) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var currentObject = this;
            while(currentObject && !currentObject.onPreProcessPropertyValue)currentObject = currentObject.parent;
            if (currentObject && currentObject.onPreProcessPropertyValue) return currentObject.onPreProcessPropertyValue(this, prop, value);
        }
        return value;
    };
    CardObject.prototype.setParent = function(value) {
        this._parent = value;
    };
    CardObject.prototype.setShouldFallback = function(value) {
        this._shouldFallback = value;
    };
    CardObject.prototype.shouldFallback = function() {
        return this._shouldFallback || !this.requires.areAllMet(this.hostConfig.hostCapabilities);
    };
    CardObject.prototype.getRootObject = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var currentObject = this;
        while(currentObject.parent)currentObject = currentObject.parent;
        return currentObject;
    };
    CardObject.prototype.internalValidateProperties = function(context) {
        if (this.id) {
            if (context.allIds.hasOwnProperty(this.id)) {
                if (context.allIds[this.id] === 1) context.addFailure(this, $4uYwi.ValidationEvent.DuplicateId, $luP4B.Strings.errors.duplicateId(this.id));
                context.allIds[this.id] += 1;
            } else context.allIds[this.id] = 1;
        }
    };
    CardObject.prototype.validateProperties = function() {
        var result = new $c996cd8d2f168642$var$ValidationResults();
        this.internalValidateProperties(result);
        return result;
    };
    /**
     * Recursively searches this CardObject and any children to find the
     * innermost CardObject that owns the given DOM Node.
     *
     * @param node The DOM Node to look for.
     *
     * @returns The owner of the given DOM Node, or `undefined` if no owner was found.
     */ CardObject.prototype.findDOMNodeOwner = function(node) {
        // default implementation for CardObjects with no associated children
        return this.contains(node) ? this : undefined;
    };
    CardObject.prototype.releaseDOMResources = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(CardObject.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardObject.prototype, "renderedElement", {
        get: function() {
            return this._renderedElement;
        },
        enumerable: false,
        configurable: true
    });
    CardObject.typeNameProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "type", undefined, undefined, undefined, function(sender) {
        return sender.getJsonTypeName();
    });
    CardObject.idProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "id");
    CardObject.requiresProperty = new $dA5cX.SerializableObjectProperty($dA5cX.Versions.v1_2, "requires", $8Pqcb.HostCapabilities, false, new $8Pqcb.HostCapabilities());
    $c996cd8d2f168642$var$__decorate([
        (0, $dA5cX.property)(CardObject.idProperty)
    ], CardObject.prototype, "id", void 0);
    $c996cd8d2f168642$var$__decorate([
        (0, $dA5cX.property)(CardObject.requiresProperty)
    ], CardObject.prototype, "requires", null);
    return CardObject;
}($dA5cX.SerializableObject);
module.exports.CardObject = $c996cd8d2f168642$var$CardObject;

});

parcelRegister("iBTKZ", function(module, exports) {
"use strict";
var $d8c6eedade336127$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d8c6eedade336127$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d8c6eedade336127$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8c6eedade336127$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d8c6eedade336127$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundImage = module.exports.ContainerBase = module.exports.StylableCardElementContainer = module.exports.ContainerStyleProperty = module.exports.ActionSet = module.exports.ShowCardAction = module.exports.HttpAction = module.exports.HttpHeader = module.exports.ToggleVisibilityAction = module.exports.OpenUrlAction = module.exports.DataQuery = module.exports.ExecuteAction = module.exports.UniversalAction = module.exports.SubmitAction = module.exports.SubmitActionBase = module.exports.Action = module.exports.TimeInput = module.exports.TimeProperty = module.exports.DateInput = module.exports.NumberInput = module.exports.FilteredChoiceSet = module.exports.ChoiceSetInput = module.exports.ChoiceSetInputDataQuery = module.exports.Choice = module.exports.ToggleInput = module.exports.TextInput = module.exports.Input = module.exports.Media = module.exports.YouTubePlayer = module.exports.DailymotionPlayer = module.exports.VimeoPlayer = module.exports.IFrameMediaMediaPlayer = module.exports.CustomMediaPlayer = module.exports.HTML5MediaPlayer = module.exports.MediaPlayer = module.exports.MediaSource = module.exports.CaptionSource = module.exports.ContentSource = module.exports.ImageSet = module.exports.CardElementContainer = module.exports.Image = module.exports.FactSet = module.exports.Fact = module.exports.RichTextBlock = module.exports.TextRun = module.exports.TextBlock = module.exports.BaseTextBlock = module.exports.ActionProperty = module.exports.CardElement = module.exports.renderSeparation = void 0;
module.exports.SerializationContext = module.exports.AdaptiveCard = module.exports.Authentication = module.exports.TokenExchangeResource = module.exports.AuthCardButton = module.exports.RefreshDefinition = module.exports.RefreshActionProperty = module.exports.ContainerWithActions = module.exports.ColumnSet = module.exports.Column = module.exports.Container = void 0;

var $4uYwi = parcelRequire("4uYwi");

var $krmaK = parcelRequire("krmaK");

var $6EfR6 = parcelRequire("6EfR6");

var $icYWo = parcelRequire("icYWo");

var $eDIVK = parcelRequire("eDIVK");

var $hj3le = parcelRequire("hj3le");

var $dA5cX = parcelRequire("dA5cX");

var $4TaX1 = parcelRequire("4TaX1");

var $luP4B = parcelRequire("luP4B");

var $eH86Z = parcelRequire("eH86Z");
function $d8c6eedade336127$var$clearElement(element) {
    var _a, _b;
    var trustedHtml = typeof window === "undefined" ? "" : (_b = (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.emptyHTML) !== null && _b !== void 0 ? _b : "";
    element.innerHTML = trustedHtml;
}
function $d8c6eedade336127$var$renderSeparation(hostConfig, separationDefinition, orientation) {
    if (separationDefinition.spacing > 0 || separationDefinition.lineThickness && separationDefinition.lineThickness > 0) {
        var separator = document.createElement("div");
        separator.className = hostConfig.makeCssClassName("ac-" + (orientation === $4uYwi.Orientation.Horizontal ? "horizontal" : "vertical") + "-separator");
        separator.setAttribute("aria-hidden", "true");
        var color = separationDefinition.lineColor ? $6EfR6.stringToCssColor(separationDefinition.lineColor) : "";
        if (orientation === $4uYwi.Orientation.Horizontal) {
            if (separationDefinition.lineThickness) {
                separator.style.paddingTop = separationDefinition.spacing / 2 + "px";
                separator.style.marginBottom = separationDefinition.spacing / 2 + "px";
                separator.style.borderBottom = separationDefinition.lineThickness + "px solid " + color;
            } else separator.style.height = separationDefinition.spacing + "px";
        } else if (separationDefinition.lineThickness) {
            separator.style.paddingLeft = separationDefinition.spacing / 2 + "px";
            separator.style.marginRight = separationDefinition.spacing / 2 + "px";
            separator.style.borderRight = separationDefinition.lineThickness + "px solid " + color;
        } else separator.style.width = separationDefinition.spacing + "px";
        separator.style.overflow = "hidden";
        separator.style.flex = "0 0 auto";
        return separator;
    } else return undefined;
}
module.exports.renderSeparation = $d8c6eedade336127$var$renderSeparation;
var $d8c6eedade336127$var$CardElement = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(CardElement, _super);
    function CardElement() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._truncatedDueToOverflow = false;
        return _this;
    }
    Object.defineProperty(CardElement.prototype, "lang", {
        get: function() {
            var lang = this.getValue(CardElement.langProperty);
            if (lang) return lang;
            else {
                if (this.parent) return this.parent.lang;
                else return undefined;
            }
        },
        set: function(value) {
            this.setValue(CardElement.langProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isVisible", {
        get: function() {
            return this.getValue(CardElement.isVisibleProperty);
        },
        set: function(value) {
            // If the element is going to be hidden, reset any changes that were due
            // to overflow truncation (this ensures that if the element is later
            // un-hidden it has the right content)
            if ($krmaK.GlobalSettings.useAdvancedCardBottomTruncation && !value) this.undoOverflowTruncation();
            if (this.isVisible !== value) {
                this.setValue(CardElement.isVisibleProperty, value);
                this.updateRenderedElementVisibility();
                if (this._renderedElement) $d8c6eedade336127$var$raiseElementVisibilityChangedEvent(this);
            }
            if (this._renderedElement) this._renderedElement.setAttribute("aria-expanded", value.toString());
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.internalRenderSeparator = function() {
        var renderedSeparator = $d8c6eedade336127$var$renderSeparation(this.hostConfig, {
            spacing: this.hostConfig.getEffectiveSpacing(this.spacing),
            lineThickness: this.separator ? this.hostConfig.separator.lineThickness : undefined,
            lineColor: this.separator ? this.hostConfig.separator.lineColor : undefined
        }, this.separatorOrientation);
        if ($krmaK.GlobalSettings.alwaysBleedSeparators && renderedSeparator && this.separatorOrientation === $4uYwi.Orientation.Horizontal) {
            // Adjust separator's margins if the option to always bleed separators is turned on
            var parentContainer = this.getParentContainer();
            if (parentContainer && parentContainer.getEffectivePadding()) {
                var parentPhysicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(parentContainer.getEffectivePadding());
                renderedSeparator.style.marginLeft = "-" + parentPhysicalPadding.left + "px";
                renderedSeparator.style.marginRight = "-" + parentPhysicalPadding.right + "px";
            }
        }
        return renderedSeparator;
    };
    CardElement.prototype.updateRenderedElementVisibility = function() {
        var displayMode = this.isDesignMode() || this.isVisible ? this._defaultRenderedElementDisplayMode : "none";
        if (this._renderedElement) {
            if (displayMode) this._renderedElement.style.display = displayMode;
            else this._renderedElement.style.removeProperty("display");
        }
        if (this._separatorElement) {
            if (this.parent && this.parent.isFirstElement(this)) this._separatorElement.style.display = "none";
            else if (displayMode) this._separatorElement.style.display = displayMode;
            else this._separatorElement.style.removeProperty("display");
        }
    };
    CardElement.prototype.hideElementDueToOverflow = function() {
        if (this._renderedElement && this.isVisible) {
            this._renderedElement.style.visibility = "hidden";
            this.isVisible = false;
            $d8c6eedade336127$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    CardElement.prototype.showElementHiddenDueToOverflow = function() {
        if (this._renderedElement && !this.isVisible) {
            this._renderedElement.style.removeProperty("visibility");
            this.isVisible = true;
            $d8c6eedade336127$var$raiseElementVisibilityChangedEvent(this, false);
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.handleOverflow = function(maxHeight) {
        if (this.isVisible || this.isHiddenDueToOverflow()) {
            var handled = this.truncateOverflow(maxHeight);
            // Even if we were unable to truncate the element to fit this time,
            // it still could have been previously truncated
            this._truncatedDueToOverflow = handled || this._truncatedDueToOverflow;
            if (!handled) this.hideElementDueToOverflow();
            else if (handled && !this.isVisible) this.showElementHiddenDueToOverflow();
        }
    };
    // Marked private to emulate internal access
    CardElement.prototype.resetOverflow = function() {
        var sizeChanged = false;
        if (this._truncatedDueToOverflow) {
            this.undoOverflowTruncation();
            this._truncatedDueToOverflow = false;
            sizeChanged = true;
        }
        if (this.isHiddenDueToOverflow()) this.showElementHiddenDueToOverflow();
        return sizeChanged;
    };
    CardElement.prototype.getDefaultSerializationContext = function() {
        return new $d8c6eedade336127$var$SerializationContext();
    };
    CardElement.prototype.createPlaceholderElement = function() {
        var styleDefinition = this.getEffectiveStyleDefinition();
        var foregroundCssColor = $6EfR6.stringToCssColor(styleDefinition.foregroundColors.default.subtle);
        var element = document.createElement("div");
        element.style.border = "1px dashed " + foregroundCssColor;
        element.style.padding = "4px";
        element.style.minHeight = "32px";
        element.style.fontSize = "10px";
        if (foregroundCssColor) element.style.color = foregroundCssColor;
        element.innerText = $luP4B.Strings.defaults.emptyElementText(this.getJsonTypeName());
        return element;
    };
    CardElement.prototype.adjustRenderedElementSize = function(renderedElement) {
        if (this.height === "auto") renderedElement.style.flex = "0 0 auto";
        else renderedElement.style.flex = "1 1 auto";
    };
    /*
     * Called when mouse enters or leaves the card.
     * Inputs elements need to update their visual state in such events like showing or hiding borders etc.
     * It calls Input.updateVisualState(eventType) for all inputs.
     * This method on input (updateVisualState) is supposed to be called from card level on mouse events.
     */ CardElement.prototype.updateInputsVisualState = function(hover) {
        var allInputs = this.getAllInputs();
        var inputEventType = !!hover ? $d8c6eedade336127$var$InputEventType.MouseEnterOnCard : $d8c6eedade336127$var$InputEventType.MouseLeaveOnCard;
        allInputs.forEach(function(input) {
            return input.updateVisualState(inputEventType);
        });
    };
    CardElement.prototype.isDisplayed = function() {
        return this._renderedElement !== undefined && this.isVisible && this._renderedElement.offsetHeight > 0;
    };
    CardElement.prototype.overrideInternalRender = function() {
        return this.internalRender();
    };
    CardElement.prototype.applyPadding = function() {
        if (this.separatorElement && this.separatorOrientation === $4uYwi.Orientation.Horizontal) {
            if ($krmaK.GlobalSettings.alwaysBleedSeparators && !this.isBleeding()) {
                var padding = new $krmaK.PaddingDefinition();
                this.getImmediateSurroundingPadding(padding);
                var physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
                this.separatorElement.style.marginLeft = "-" + physicalPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + physicalPadding.right + "px";
            } else {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    /*
     * Called when this element overflows the bottom of the card.
     * maxHeight will be the amount of space still available on the card (0 if
     * the element is fully off the card).
     */ CardElement.prototype.truncateOverflow = function(_maxHeight) {
        // Child implementations should return true if the element handled
        // the truncation request such that its content fits within maxHeight,
        // false if the element should fall back to being hidden
        return false;
    };
    /*
     * This should reverse any changes performed in truncateOverflow().
     */ CardElement.prototype.undoOverflowTruncation = function() {
        return;
    };
    CardElement.prototype.getDefaultPadding = function() {
        return new $krmaK.PaddingDefinition();
    };
    CardElement.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return false;
    };
    CardElement.prototype.getHasBorder = function() {
        return false;
    };
    CardElement.prototype.getPadding = function() {
        return this._padding;
    };
    CardElement.prototype.setPadding = function(value) {
        this._padding = value;
    };
    CardElement.prototype.shouldSerialize = function(context) {
        return context.elementRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Object.defineProperty(CardElement.prototype, "useDefaultSizing", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorOrientation", {
        get: function() {
            return $4uYwi.Orientation.Horizontal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "defaultStyle", {
        get: function() {
            return $4uYwi.ContainerStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.prototype.parse = function(source, context) {
        _super.prototype.parse.call(this, source, context ? context : new $d8c6eedade336127$var$SerializationContext());
    };
    CardElement.prototype.asString = function() {
        return "";
    };
    CardElement.prototype.isBleeding = function() {
        return false;
    };
    CardElement.prototype.getEffectiveStyle = function() {
        if (this.parent) return this.parent.getEffectiveStyle();
        return this.defaultStyle;
    };
    CardElement.prototype.getEffectiveStyleDefinition = function() {
        return this.hostConfig.containerStyles.getStyleByName(this.getEffectiveStyle());
    };
    CardElement.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.parent) return this.parent.getEffectiveTextStyleDefinition();
        return this.hostConfig.textStyles.default;
    };
    CardElement.prototype.getForbiddenActionTypes = function() {
        return [];
    };
    CardElement.prototype.getImmediateSurroundingPadding = function(result, processTop, processRight, processBottom, processLeft) {
        if (processTop === void 0) processTop = true;
        if (processRight === void 0) processRight = true;
        if (processBottom === void 0) processBottom = true;
        if (processLeft === void 0) processLeft = true;
        if (this.parent) {
            var doProcessTop = processTop && this.parent.isTopElement(this);
            var doProcessRight = processRight && this.parent.isRightMostElement(this);
            var doProcessBottom = processBottom && this.parent.isBottomElement(this);
            var doProcessLeft = processLeft && this.parent.isLeftMostElement(this);
            var effectivePadding = this.parent.getEffectivePadding();
            if (effectivePadding) {
                if (doProcessTop && effectivePadding.top !== $4uYwi.Spacing.None) {
                    result.top = effectivePadding.top;
                    doProcessTop = false;
                }
                if (doProcessRight && effectivePadding.right !== $4uYwi.Spacing.None) {
                    result.right = effectivePadding.right;
                    doProcessRight = false;
                }
                if (doProcessBottom && effectivePadding.bottom !== $4uYwi.Spacing.None) {
                    result.bottom = effectivePadding.bottom;
                    doProcessBottom = false;
                }
                if (doProcessLeft && effectivePadding.left !== $4uYwi.Spacing.None) {
                    result.left = effectivePadding.left;
                    doProcessLeft = false;
                }
            }
            if (doProcessTop || doProcessRight || doProcessBottom || doProcessLeft) this.parent.getImmediateSurroundingPadding(result, doProcessTop, doProcessRight, doProcessBottom, doProcessLeft);
        }
    };
    CardElement.prototype.getActionCount = function() {
        return 0;
    };
    CardElement.prototype.getActionAt = function(index) {
        throw new Error($luP4B.Strings.errors.indexOutOfRange(index));
    };
    CardElement.prototype.indexOfAction = function(action) {
        for(var i = 0; i < this.getActionCount(); i++){
            if (this.getActionAt(i) === action) return i;
        }
        return -1;
    };
    CardElement.prototype.remove = function() {
        if (this.parent && this.parent instanceof $d8c6eedade336127$var$CardElementContainer) return this.parent.removeItem(this);
        return false;
    };
    CardElement.prototype.render = function() {
        this._renderedElement = this.overrideInternalRender();
        this._separatorElement = this.internalRenderSeparator();
        if (this._renderedElement) {
            if (this.id) this._renderedElement.id = this.id;
            if (this.customCssSelector) this._renderedElement.classList.add(this.customCssSelector);
            this._renderedElement.style.boxSizing = "border-box";
            this._defaultRenderedElementDisplayMode = this._renderedElement.style.display ? this._renderedElement.style.display : undefined;
            this.adjustRenderedElementSize(this._renderedElement);
            this.updateLayout(false);
        } else if (this.isDesignMode()) this._renderedElement = this.createPlaceholderElement();
        return this._renderedElement;
    };
    CardElement.prototype.updateLayout = function(_processChildren) {
        if (_processChildren === void 0) _processChildren = true;
        this.updateRenderedElementVisibility();
        this.applyPadding();
    };
    CardElement.prototype.updateActionsEnabledState = function() {
        var allActions = this.getRootElement().getAllActions();
        for(var _i = 0, allActions_1 = allActions; _i < allActions_1.length; _i++){
            var action = allActions_1[_i];
            action.updateEnabledState();
        }
    };
    CardElement.prototype.indexOf = function(_cardElement) {
        return -1;
    };
    CardElement.prototype.isDesignMode = function() {
        var rootElement = this.getRootElement();
        return rootElement instanceof $d8c6eedade336127$var$AdaptiveCard && rootElement.designMode;
    };
    CardElement.prototype.isFirstElement = function(_element) {
        return true;
    };
    CardElement.prototype.isLastElement = function(_element) {
        return true;
    };
    CardElement.prototype.isAtTheVeryLeft = function() {
        return this.parent ? this.parent.isLeftMostElement(this) && this.parent.isAtTheVeryLeft() : true;
    };
    CardElement.prototype.isAtTheVeryRight = function() {
        return this.parent ? this.parent.isRightMostElement(this) && this.parent.isAtTheVeryRight() : true;
    };
    CardElement.prototype.isAtTheVeryTop = function() {
        return this.parent ? this.parent.isFirstElement(this) && this.parent.isAtTheVeryTop() : true;
    };
    CardElement.prototype.isAtTheVeryBottom = function() {
        return this.parent ? this.parent.isLastElement(this) && this.parent.isAtTheVeryBottom() : true;
    };
    CardElement.prototype.isBleedingAtTop = function() {
        return false;
    };
    CardElement.prototype.isBleedingAtBottom = function() {
        return false;
    };
    CardElement.prototype.isLeftMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isRightMostElement = function(_element) {
        return true;
    };
    CardElement.prototype.isTopElement = function(element) {
        return this.isFirstElement(element);
    };
    CardElement.prototype.isBottomElement = function(element) {
        return this.isLastElement(element);
    };
    CardElement.prototype.isHiddenDueToOverflow = function() {
        return this._renderedElement !== undefined && this._renderedElement.style.visibility === "hidden";
    };
    CardElement.prototype.getRootElement = function() {
        return this.getRootObject();
    };
    CardElement.prototype.getParentContainer = function() {
        var currentElement = this.parent;
        while(currentElement){
            if (currentElement instanceof $d8c6eedade336127$var$Container) return currentElement;
            currentElement = currentElement.parent;
        }
        return undefined;
    };
    CardElement.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    CardElement.prototype.getAllActions = function() {
        var result = [];
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    CardElement.prototype.getResourceInformation = function() {
        return [];
    };
    CardElement.prototype.getElementById = function(id) {
        return this.id === id ? this : undefined;
    };
    CardElement.prototype.getActionById = function(_id) {
        return undefined;
    };
    CardElement.prototype.getElementByIdFromAction = function(id) {
        var result = undefined;
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action instanceof $d8c6eedade336127$var$ShowCardAction) {
                result = action.card.getElementById(id);
                if (result) break;
            }
        }
        return result;
    };
    CardElement.prototype.getEffectivePadding = function() {
        var padding = this.getPadding();
        return padding ? padding : this.getDefaultPadding();
    };
    CardElement.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parent) return this.parent.getEffectiveHorizontalAlignment();
        return $4uYwi.HorizontalAlignment.Left;
    };
    Object.defineProperty(CardElement.prototype, "hostConfig", {
        get: function() {
            if (this._hostConfig) return this._hostConfig;
            else {
                if (this.parent) return this.parent.hostConfig;
                else return $icYWo.defaultHostConfig;
            }
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "index", {
        get: function() {
            if (this.parent) return this.parent.indexOf(this);
            else return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInteractive", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isStandalone", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "isInline", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.separatorElement) return !this.parent.isFirstElement(this) && (this.isVisible || this.isDesignMode());
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "separatorElement", {
        get: function() {
            return this._separatorElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardElement.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    CardElement.langProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_1, "lang", true, /^[a-z]{2,3}$/gi);
    CardElement.isVisibleProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_2, "isVisible", true);
    CardElement.separatorProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_0, "separator", false);
    CardElement.heightProperty = new $dA5cX.ValueSetProperty($dA5cX.Versions.v1_1, "height", [
        {
            value: "auto"
        },
        {
            value: "stretch"
        }
    ], "auto");
    CardElement.horizontalAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_0, "horizontalAlignment", $4uYwi.HorizontalAlignment);
    CardElement.spacingProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_0, "spacing", $4uYwi.Spacing, $4uYwi.Spacing.Default);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(CardElement.horizontalAlignmentProperty)
    ], CardElement.prototype, "horizontalAlignment", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(CardElement.spacingProperty)
    ], CardElement.prototype, "spacing", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(CardElement.separatorProperty)
    ], CardElement.prototype, "separator", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(CardElement.heightProperty)
    ], CardElement.prototype, "height", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(CardElement.langProperty)
    ], CardElement.prototype, "lang", null);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(CardElement.isVisibleProperty)
    ], CardElement.prototype, "isVisible", null);
    return CardElement;
}($hj3le.CardObject);
module.exports.CardElement = $d8c6eedade336127$var$CardElement;
var $d8c6eedade336127$var$ActionProperty = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ActionProperty, _super);
    function ActionProperty(targetVersion, name, forbiddenActionTypes) {
        if (forbiddenActionTypes === void 0) forbiddenActionTypes = [];
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.forbiddenActionTypes = forbiddenActionTypes;
        return _this;
    }
    ActionProperty.prototype.parse = function(sender, source, context) {
        var parent = sender;
        return context.parseAction(parent, source[this.name], this.forbiddenActionTypes, parent.isDesignMode());
    };
    ActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return ActionProperty;
}($dA5cX.PropertyDefinition);
module.exports.ActionProperty = $d8c6eedade336127$var$ActionProperty;
var $d8c6eedade336127$var$BaseTextBlock = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(BaseTextBlock, _super);
    function BaseTextBlock(text) {
        var _this = _super.call(this) || this;
        _this.ariaHidden = false;
        if (text) _this.text = text;
        return _this;
    }
    BaseTextBlock.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // selectAction is declared on BaseTextBlock but is only exposed on TextRun,
        // so the property is removed from the BaseTextBlock schema.
        schema.remove(BaseTextBlock.selectActionProperty);
    };
    Object.defineProperty(BaseTextBlock.prototype, "text", {
        get: function() {
            return this.getValue(BaseTextBlock.textProperty);
        },
        set: function(value) {
            this.setText(value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    BaseTextBlock.prototype.getFontSize = function(fontType) {
        switch(this.effectiveSize){
            case $4uYwi.TextSize.Small:
                return fontType.fontSizes.small;
            case $4uYwi.TextSize.Medium:
                return fontType.fontSizes.medium;
            case $4uYwi.TextSize.Large:
                return fontType.fontSizes.large;
            case $4uYwi.TextSize.ExtraLarge:
                return fontType.fontSizes.extraLarge;
            default:
                return fontType.fontSizes.default;
        }
    };
    BaseTextBlock.prototype.getColorDefinition = function(colorSet, color) {
        switch(color){
            case $4uYwi.TextColor.Accent:
                return colorSet.accent;
            case $4uYwi.TextColor.Dark:
                return colorSet.dark;
            case $4uYwi.TextColor.Light:
                return colorSet.light;
            case $4uYwi.TextColor.Good:
                return colorSet.good;
            case $4uYwi.TextColor.Warning:
                return colorSet.warning;
            case $4uYwi.TextColor.Attention:
                return colorSet.attention;
            default:
                return colorSet.default;
        }
    };
    BaseTextBlock.prototype.setText = function(value) {
        this.setValue(BaseTextBlock.textProperty, value);
    };
    BaseTextBlock.prototype.init = function(textDefinition) {
        this.size = textDefinition.size;
        this.weight = textDefinition.weight;
        this.color = textDefinition.color;
        this.isSubtle = textDefinition.isSubtle;
    };
    BaseTextBlock.prototype.asString = function() {
        return this.text;
    };
    BaseTextBlock.prototype.applyStylesTo = function(targetElement) {
        var fontType = this.hostConfig.getFontTypeDefinition(this.effectiveFontType);
        if (fontType.fontFamily) targetElement.style.fontFamily = fontType.fontFamily;
        var fontSize;
        switch(this.effectiveSize){
            case $4uYwi.TextSize.Small:
                fontSize = fontType.fontSizes.small;
                break;
            case $4uYwi.TextSize.Medium:
                fontSize = fontType.fontSizes.medium;
                break;
            case $4uYwi.TextSize.Large:
                fontSize = fontType.fontSizes.large;
                break;
            case $4uYwi.TextSize.ExtraLarge:
                fontSize = fontType.fontSizes.extraLarge;
                break;
            default:
                fontSize = fontType.fontSizes.default;
                break;
        }
        targetElement.style.fontSize = fontSize + "px";
        var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
        var targetColor = $6EfR6.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.subtle : colorDefinition.default);
        if (targetColor) targetElement.style.color = targetColor;
        var fontWeight;
        switch(this.effectiveWeight){
            case $4uYwi.TextWeight.Lighter:
                fontWeight = fontType.fontWeights.lighter;
                break;
            case $4uYwi.TextWeight.Bolder:
                fontWeight = fontType.fontWeights.bolder;
                break;
            default:
                fontWeight = fontType.fontWeights.default;
                break;
        }
        targetElement.style.fontWeight = fontWeight.toString();
        if (this.ariaHidden) targetElement.setAttribute("aria-hidden", "true");
    };
    BaseTextBlock.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Object.defineProperty(BaseTextBlock.prototype, "effectiveColor", {
        get: function() {
            return this.color !== undefined ? this.color : this.getEffectiveTextStyleDefinition().color;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveFontType", {
        get: function() {
            return this.fontType !== undefined ? this.fontType : this.getEffectiveTextStyleDefinition().fontType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveIsSubtle", {
        get: function() {
            return this.isSubtle !== undefined ? this.isSubtle : this.getEffectiveTextStyleDefinition().isSubtle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveSize", {
        get: function() {
            return this.size !== undefined ? this.size : this.getEffectiveTextStyleDefinition().size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTextBlock.prototype, "effectiveWeight", {
        get: function() {
            return this.weight !== undefined ? this.weight : this.getEffectiveTextStyleDefinition().weight;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    BaseTextBlock.textProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "text", true);
    BaseTextBlock.sizeProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_0, "size", $4uYwi.TextSize);
    BaseTextBlock.weightProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_0, "weight", $4uYwi.TextWeight);
    BaseTextBlock.colorProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_0, "color", $4uYwi.TextColor);
    BaseTextBlock.isSubtleProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_0, "isSubtle");
    BaseTextBlock.fontTypeProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_2, "fontType", $4uYwi.FontType);
    BaseTextBlock.selectActionProperty = new $d8c6eedade336127$var$ActionProperty($dA5cX.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BaseTextBlock.sizeProperty)
    ], BaseTextBlock.prototype, "size", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BaseTextBlock.weightProperty)
    ], BaseTextBlock.prototype, "weight", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BaseTextBlock.colorProperty)
    ], BaseTextBlock.prototype, "color", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BaseTextBlock.fontTypeProperty)
    ], BaseTextBlock.prototype, "fontType", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BaseTextBlock.isSubtleProperty)
    ], BaseTextBlock.prototype, "isSubtle", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BaseTextBlock.textProperty)
    ], BaseTextBlock.prototype, "text", null);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BaseTextBlock.selectActionProperty)
    ], BaseTextBlock.prototype, "selectAction", void 0);
    return BaseTextBlock;
}($d8c6eedade336127$var$CardElement);
module.exports.BaseTextBlock = $d8c6eedade336127$var$BaseTextBlock;
var $d8c6eedade336127$var$TextBlock = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(TextBlock, _super);
    function TextBlock() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrap = false;
        _this._treatAsPlainText = true;
        _this.useMarkdown = true;
        return _this;
    }
    TextBlock.prototype.restoreOriginalContent = function() {
        var _a, _b;
        if (this.renderedElement !== undefined) {
            if (this.maxLines && this.maxLines > 0) this.renderedElement.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
            var originalHtml = (_b = (_a = TextBlock._ttRoundtripPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._originalInnerHtml)) !== null && _b !== void 0 ? _b : this._originalInnerHtml;
            this.renderedElement.innerHTML = originalHtml;
        }
    };
    TextBlock.prototype.truncateIfSupported = function(maxHeight) {
        if (this.renderedElement !== undefined) {
            // For now, only truncate TextBlocks that contain just a single
            // paragraph -- since the maxLines calculation doesn't take into
            // account Markdown lists
            var children = this.renderedElement.children;
            var isTextOnly = !children.length;
            var truncationSupported = isTextOnly || children.length === 1 && children[0].tagName.toLowerCase() === "p" && !children[0].children.length;
            if (truncationSupported) {
                var element = isTextOnly ? this.renderedElement : children[0];
                $6EfR6.truncateText(element, maxHeight, this._computedLineHeight);
                return true;
            }
        }
        return false;
    };
    TextBlock.prototype.setText = function(value) {
        _super.prototype.setText.call(this, value);
        this._processedText = undefined;
    };
    TextBlock.prototype.internalRender = function() {
        var _this = this;
        var _a, _b;
        this._processedText = undefined;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($d8c6eedade336127$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.classList.add(hostConfig.makeCssClassName("ac-textBlock"));
            element.style.overflow = "hidden";
            this.applyStylesTo(element);
            if (this.style === "heading") {
                element.setAttribute("role", "heading");
                var headingLevel = this.hostConfig.textBlock.headingLevel;
                if (headingLevel !== undefined && headingLevel > 0) element.setAttribute("aria-level", headingLevel.toString());
            }
            if (this.selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(element);
                if (this.selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            if (!this._processedText) {
                this._treatAsPlainText = true;
                var formattedText = $eDIVK.formatText(this.lang, preProcessedText);
                if (this.useMarkdown && formattedText) {
                    if ($krmaK.GlobalSettings.allowMarkForTextHighlighting) formattedText = formattedText.replace(/<mark>/g, "===").replace(/<\/mark>/g, "/==/");
                    var markdownProcessingResult = $d8c6eedade336127$var$AdaptiveCard.applyMarkdown(formattedText);
                    if (markdownProcessingResult.didProcess && markdownProcessingResult.outputHtml) {
                        this._processedText = markdownProcessingResult.outputHtml;
                        this._treatAsPlainText = false;
                        // Only process <mark> tag if markdown processing was applied because
                        // markdown processing is also responsible for sanitizing the input string
                        if ($krmaK.GlobalSettings.allowMarkForTextHighlighting && this._processedText) {
                            var markStyle = "";
                            var effectiveStyle = this.getEffectiveStyleDefinition();
                            if (effectiveStyle.highlightBackgroundColor) markStyle += "background-color: " + effectiveStyle.highlightBackgroundColor + ";";
                            if (effectiveStyle.highlightForegroundColor) markStyle += "color: " + effectiveStyle.highlightForegroundColor + ";";
                            if (markStyle) markStyle = 'style="' + markStyle + '"';
                            this._processedText = this._processedText.replace(/===/g, "<mark " + markStyle + ">").replace(/\/==\//g, "</mark>");
                        }
                    } else {
                        this._processedText = formattedText;
                        this._treatAsPlainText = true;
                    }
                } else {
                    this._processedText = formattedText;
                    this._treatAsPlainText = true;
                }
            }
            if (!this._processedText) this._processedText = "";
            if (this._treatAsPlainText) element.innerText = this._processedText;
            else {
                var processedHtml = (_b = (_a = TextBlock._ttMarkdownPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._processedText)) !== null && _b !== void 0 ? _b : this._processedText;
                element.innerHTML = processedHtml;
            }
            if (element.firstElementChild instanceof HTMLElement) {
                var firstElementChild = element.firstElementChild;
                firstElementChild.style.marginTop = "0px";
                firstElementChild.style.width = "100%";
                if (!this.wrap) {
                    firstElementChild.style.overflow = "hidden";
                    firstElementChild.style.textOverflow = "ellipsis";
                }
            }
            if (element.lastElementChild instanceof HTMLElement) element.lastElementChild.style.marginBottom = "0px";
            var anchors = element.getElementsByTagName("a");
            var _loop_1 = function(anchor) {
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if ($d8c6eedade336127$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                    }
                };
                anchor.oncontextmenu = function(e) {
                    if ($d8c6eedade336127$var$raiseAnchorClickedEvent(_this, anchor, e)) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        return false;
                    }
                    return true;
                };
            };
            for(var _i = 0, _c = Array.from(anchors); _i < _c.length; _i++){
                var anchor = _c[_i];
                _loop_1(anchor);
            }
            if (this.wrap) {
                element.style.wordWrap = "break-word";
                if (this.maxLines && this.maxLines > 0) {
                    element.style.overflow = "hidden";
                    if ($6EfR6.isInternetExplorer() || !$krmaK.GlobalSettings.useWebkitLineClamp) element.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
                    else {
                        // While non standard, --webkit-line-clamp works in every browser (except IE)
                        // and is a great solution to support the maxLines feature with ellipsis
                        // truncation. With --webkit-line-clamp there is need to use explicit line heights
                        element.style.removeProperty("line-height");
                        element.style.display = "-webkit-box";
                        element.style.webkitBoxOrient = "vertical";
                        element.style.webkitLineClamp = this.maxLines.toString();
                    }
                }
            } else {
                element.style.whiteSpace = "nowrap";
                element.style.textOverflow = "ellipsis";
            }
            if ($krmaK.GlobalSettings.useAdvancedTextBlockTruncation || $krmaK.GlobalSettings.useAdvancedCardBottomTruncation) this._originalInnerHtml = element.innerHTML;
            return element;
        } else return undefined;
    };
    TextBlock.prototype.truncateOverflow = function(maxHeight) {
        if (maxHeight >= this._computedLineHeight) return this.truncateIfSupported(maxHeight);
        return false;
    };
    TextBlock.prototype.undoOverflowTruncation = function() {
        this.restoreOriginalContent();
        if ($krmaK.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines) {
            var maxHeight = this._computedLineHeight * this.maxLines;
            this.truncateIfSupported(maxHeight);
        }
    };
    TextBlock.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        switch(this.getEffectiveHorizontalAlignment()){
            case $4uYwi.HorizontalAlignment.Center:
                targetElement.style.textAlign = "center";
                break;
            case $4uYwi.HorizontalAlignment.Right:
                targetElement.style.textAlign = "end";
                break;
            default:
                targetElement.style.textAlign = "start";
                break;
        }
        var lineHeights = this.hostConfig.lineHeights;
        if (lineHeights) switch(this.effectiveSize){
            case $4uYwi.TextSize.Small:
                this._computedLineHeight = lineHeights.small;
                break;
            case $4uYwi.TextSize.Medium:
                this._computedLineHeight = lineHeights.medium;
                break;
            case $4uYwi.TextSize.Large:
                this._computedLineHeight = lineHeights.large;
                break;
            case $4uYwi.TextSize.ExtraLarge:
                this._computedLineHeight = lineHeights.extraLarge;
                break;
            default:
                this._computedLineHeight = lineHeights.default;
                break;
        }
        else // Looks like 1.33 is the magic number to compute line-height
        // from font size.
        this._computedLineHeight = this.getFontSize(this.hostConfig.getFontTypeDefinition(this.effectiveFontType)) * 1.33;
        targetElement.style.lineHeight = this._computedLineHeight + "px";
    };
    TextBlock.prototype.getJsonTypeName = function() {
        return "TextBlock";
    };
    TextBlock.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.style) return this.hostConfig.textStyles.getStyleByName(this.style);
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TextBlock.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = false;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($krmaK.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines && this.isDisplayed()) {
            // Reset the element's innerHTML in case the available room for
            // content has increased
            this.restoreOriginalContent();
            this.truncateIfSupported(this._computedLineHeight * this.maxLines);
        }
    };
    var _a, _b;
    TextBlock.wrapProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_0, "wrap", false);
    TextBlock.maxLinesProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_0, "maxLines");
    TextBlock.styleProperty = new $dA5cX.ValueSetProperty($dA5cX.Versions.v1_5, "style", [
        {
            value: "default"
        },
        {
            value: "columnHeader"
        },
        {
            value: "heading"
        }
    ]);
    // Markdown processing is handled outside of Adaptive Cards. It's up to the host to ensure that markdown is safely
    // processed.
    TextBlock._ttMarkdownPolicy = typeof window === "undefined" ? undefined : (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.createPolicy("adaptivecards#markdownPassthroughPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    // When "advanced" truncation is enabled (see GlobalSettings.useAdvancedCardBottomTruncation and
    // GlobalSettings.useAdvancedTextBlockTruncation), we store the original pre-truncation content in
    // _originalInnerHtml so that we can restore/recalculate truncation later if space availability has changed (see
    // TextBlock.restoreOriginalContent())
    TextBlock._ttRoundtripPolicy = typeof window === "undefined" ? undefined : (_b = window.trustedTypes) === null || _b === void 0 ? void 0 : _b.createPolicy("adaptivecards#restoreContentsPolicy", {
        createHTML: function(value) {
            return value;
        }
    });
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextBlock.wrapProperty)
    ], TextBlock.prototype, "wrap", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextBlock.maxLinesProperty)
    ], TextBlock.prototype, "maxLines", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextBlock.styleProperty)
    ], TextBlock.prototype, "style", void 0);
    return TextBlock;
}($d8c6eedade336127$var$BaseTextBlock);
module.exports.TextBlock = $d8c6eedade336127$var$TextBlock;
var $d8c6eedade336127$var$TextRun = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(TextRun, _super);
    function TextRun() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.italic = false;
        _this.strikethrough = false;
        _this.highlight = false;
        _this.underline = false;
        return _this;
    }
    TextRun.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.add($d8c6eedade336127$var$BaseTextBlock.selectActionProperty);
    };
    //#endregion
    TextRun.prototype.internalRender = function() {
        var _this = this;
        if (this.text) {
            var preProcessedText = this.preProcessPropertyValue($d8c6eedade336127$var$BaseTextBlock.textProperty);
            var hostConfig = this.hostConfig;
            var formattedText = $eDIVK.formatText(this.lang, preProcessedText);
            if (!formattedText) formattedText = "";
            var element = document.createElement("span");
            element.classList.add(hostConfig.makeCssClassName("ac-textRun"));
            this.applyStylesTo(element);
            if (this.selectAction && hostConfig.supportsInteractivity) {
                var anchor = document.createElement("a");
                anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
                var href = this.selectAction.getHref();
                anchor.href = href ? href : "";
                anchor.target = "_blank";
                anchor.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(anchor);
                anchor.innerText = formattedText;
                element.appendChild(anchor);
            } else element.innerText = formattedText;
            return element;
        } else return undefined;
    };
    TextRun.prototype.applyStylesTo = function(targetElement) {
        _super.prototype.applyStylesTo.call(this, targetElement);
        if (this.italic) targetElement.style.fontStyle = "italic";
        if (this.strikethrough) targetElement.style.textDecoration = "line-through";
        if (this.highlight) {
            var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
            var backgroundColor = $6EfR6.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.highlightColors.subtle : colorDefinition.highlightColors.default);
            if (backgroundColor) targetElement.style.backgroundColor = backgroundColor;
        }
        if (this.underline) targetElement.style.textDecoration = "underline";
    };
    TextRun.prototype.getJsonTypeName = function() {
        return "TextRun";
    };
    Object.defineProperty(TextRun.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextRun.prototype, "isInline", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    TextRun.italicProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_2, "italic", false);
    TextRun.strikethroughProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_2, "strikethrough", false);
    TextRun.highlightProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_2, "highlight", false);
    TextRun.underlineProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_3, "underline", false);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextRun.italicProperty)
    ], TextRun.prototype, "italic", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextRun.strikethroughProperty)
    ], TextRun.prototype, "strikethrough", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextRun.highlightProperty)
    ], TextRun.prototype, "highlight", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextRun.underlineProperty)
    ], TextRun.prototype, "underline", void 0);
    return TextRun;
}($d8c6eedade336127$var$BaseTextBlock);
module.exports.TextRun = $d8c6eedade336127$var$TextRun;
var $d8c6eedade336127$var$RichTextBlock = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(RichTextBlock, _super);
    function RichTextBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inlines = [];
        return _this;
    }
    RichTextBlock.prototype.internalAddInline = function(inline, forceAdd) {
        if (forceAdd === void 0) forceAdd = false;
        if (!inline.isInline) throw new Error($luP4B.Strings.errors.elementCannotBeUsedAsInline());
        var doAdd = inline.parent === undefined || forceAdd;
        if (!doAdd && inline.parent !== this) throw new Error($luP4B.Strings.errors.inlineAlreadyParented());
        else {
            inline.setParent(this);
            this._inlines.push(inline);
        }
    };
    RichTextBlock.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._inlines = [];
        if (Array.isArray(source["inlines"])) for(var _i = 0, _a = source["inlines"]; _i < _a.length; _i++){
            var jsonInline = _a[_i];
            var inline = void 0;
            if (typeof jsonInline === "string") {
                var textRun = new $d8c6eedade336127$var$TextRun();
                textRun.text = jsonInline;
                inline = textRun;
            } else // No fallback for inlines in 1.2
            inline = context.parseElement(this, jsonInline, [], false);
            if (inline) this.internalAddInline(inline, true);
        }
    };
    RichTextBlock.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this._inlines.length > 0) {
            var jsonInlines = [];
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                jsonInlines.push(inline.toJSON(context));
            }
            context.serializeValue(target, "inlines", jsonInlines);
        }
    };
    RichTextBlock.prototype.internalRender = function() {
        if (this._inlines.length > 0) {
            var element = void 0;
            if (this.forElementId) {
                var labelElement = document.createElement("label");
                labelElement.htmlFor = this.forElementId;
                element = labelElement;
            } else element = document.createElement("div");
            element.className = this.hostConfig.makeCssClassName("ac-richTextBlock");
            switch(this.getEffectiveHorizontalAlignment()){
                case $4uYwi.HorizontalAlignment.Center:
                    element.style.textAlign = "center";
                    break;
                case $4uYwi.HorizontalAlignment.Right:
                    element.style.textAlign = "end";
                    break;
                default:
                    element.style.textAlign = "start";
                    break;
            }
            var renderedInlines = 0;
            for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
                var inline = _a[_i];
                var renderedInline = inline.render();
                if (renderedInline) {
                    element.appendChild(renderedInline);
                    renderedInlines++;
                }
            }
            if (renderedInlines > 0) return element;
        }
        return undefined;
    };
    RichTextBlock.prototype.asString = function() {
        var result = "";
        for(var _i = 0, _a = this._inlines; _i < _a.length; _i++){
            var inline = _a[_i];
            result += inline.asString();
        }
        return result;
    };
    RichTextBlock.prototype.getJsonTypeName = function() {
        return "RichTextBlock";
    };
    RichTextBlock.prototype.getInlineCount = function() {
        return this._inlines.length;
    };
    RichTextBlock.prototype.getInlineAt = function(index) {
        if (index >= 0 && index < this._inlines.length) return this._inlines[index];
        else throw new Error($luP4B.Strings.errors.indexOutOfRange(index));
    };
    RichTextBlock.prototype.addInline = function(inline) {
        if (typeof inline === "string") this.internalAddInline(new $d8c6eedade336127$var$TextRun(inline));
        else this.internalAddInline(inline);
    };
    RichTextBlock.prototype.removeInline = function(inline) {
        var index = this._inlines.indexOf(inline);
        if (index >= 0) {
            this._inlines[index].setParent(undefined);
            this._inlines.splice(index, 1);
            return true;
        }
        return false;
    };
    return RichTextBlock;
}($d8c6eedade336127$var$CardElement);
module.exports.RichTextBlock = $d8c6eedade336127$var$RichTextBlock;
var $d8c6eedade336127$var$Fact = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(Fact, _super);
    function Fact(name, value) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    //#endregion
    Fact.prototype.getSchemaKey = function() {
        return "Fact";
    };
    //#region Schema
    Fact.titleProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "title");
    Fact.valueProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "value");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Fact.titleProperty)
    ], Fact.prototype, "name", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Fact.valueProperty)
    ], Fact.prototype, "value", void 0);
    return Fact;
}($dA5cX.SerializableObject);
module.exports.Fact = $d8c6eedade336127$var$Fact;
var $d8c6eedade336127$var$FactSet = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(FactSet, _super);
    function FactSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FactSet.prototype, "useDefaultSizing", {
        //#endregion
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    FactSet.prototype.internalRender = function() {
        var element = undefined;
        var hostConfig = this.hostConfig;
        if (this.facts.length > 0) {
            element = document.createElement("table");
            element.style.borderWidth = "0px";
            element.style.borderSpacing = "0px";
            element.style.borderStyle = "none";
            element.style.borderCollapse = "collapse";
            element.style.display = "block";
            element.style.overflow = "hidden";
            element.classList.add(hostConfig.makeCssClassName("ac-factset"));
            element.setAttribute("role", "presentation");
            for(var i = 0; i < this.facts.length; i++){
                var trElement = document.createElement("tr");
                if (i > 0) trElement.style.marginTop = hostConfig.factSet.spacing + "px";
                // Title column
                var tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-title"));
                if (hostConfig.factSet.title.maxWidth) tdElement.style.maxWidth = hostConfig.factSet.title.maxWidth + "px";
                tdElement.style.verticalAlign = "top";
                var textBlock = new $d8c6eedade336127$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = !this.facts[i].name && this.isDesignMode() ? "Title" : this.facts[i].name;
                textBlock.size = hostConfig.factSet.title.size;
                textBlock.color = hostConfig.factSet.title.color;
                textBlock.isSubtle = hostConfig.factSet.title.isSubtle;
                textBlock.weight = hostConfig.factSet.title.weight;
                textBlock.wrap = hostConfig.factSet.title.wrap;
                textBlock.spacing = $4uYwi.Spacing.None;
                $6EfR6.appendChild(tdElement, textBlock.render());
                $6EfR6.appendChild(trElement, tdElement);
                // Spacer column
                tdElement = document.createElement("td");
                tdElement.style.width = "10px";
                $6EfR6.appendChild(trElement, tdElement);
                // Value column
                tdElement = document.createElement("td");
                tdElement.style.padding = "0";
                tdElement.style.verticalAlign = "top";
                tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-value"));
                textBlock = new $d8c6eedade336127$var$TextBlock();
                textBlock.setParent(this);
                textBlock.text = this.facts[i].value;
                textBlock.size = hostConfig.factSet.value.size;
                textBlock.color = hostConfig.factSet.value.color;
                textBlock.isSubtle = hostConfig.factSet.value.isSubtle;
                textBlock.weight = hostConfig.factSet.value.weight;
                textBlock.wrap = hostConfig.factSet.value.wrap;
                textBlock.spacing = $4uYwi.Spacing.None;
                $6EfR6.appendChild(tdElement, textBlock.render());
                $6EfR6.appendChild(trElement, tdElement);
                $6EfR6.appendChild(element, trElement);
            }
        }
        return element;
    };
    FactSet.prototype.getJsonTypeName = function() {
        return "FactSet";
    };
    //#region Schema
    FactSet.factsProperty = new $dA5cX.SerializableObjectCollectionProperty($dA5cX.Versions.v1_0, "facts", $d8c6eedade336127$var$Fact);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(FactSet.factsProperty)
    ], FactSet.prototype, "facts", void 0);
    return FactSet;
}($d8c6eedade336127$var$CardElement);
module.exports.FactSet = $d8c6eedade336127$var$FactSet;
var $d8c6eedade336127$var$ImageDimensionProperty = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ImageDimensionProperty, _super);
    function ImageDimensionProperty(targetVersion, name, internalName, fallbackProperty) {
        var _this = _super.call(this, targetVersion, name) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.internalName = internalName;
        _this.fallbackProperty = fallbackProperty;
        return _this;
    }
    ImageDimensionProperty.prototype.getInternalName = function() {
        return this.internalName;
    };
    ImageDimensionProperty.prototype.parse = function(sender, source, context) {
        var result = undefined;
        var sourceValue = source[this.name];
        if (sourceValue === undefined) return this.defaultValue;
        var isValid = false;
        if (typeof sourceValue === "string") {
            try {
                var size = $krmaK.SizeAndUnit.parse(sourceValue, true);
                if (size.unit === $4uYwi.SizeUnit.Pixel) {
                    result = size.physicalSize;
                    isValid = true;
                }
            } catch (_a) {
            // Swallow the exception
            }
            // If the source value isn't valid per this property definition,
            // check its validity per the fallback property, if specified
            if (!isValid && this.fallbackProperty) isValid = this.fallbackProperty.isValidValue(sourceValue, context);
        }
        if (!isValid) context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidPropertyValue(sourceValue, this.name));
        return result;
    };
    ImageDimensionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
    };
    return ImageDimensionProperty;
}($dA5cX.PropertyDefinition);
var $d8c6eedade336127$var$Image = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(Image, _super);
    function Image() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.size = $4uYwi.Size.Auto;
        _this.style = $4uYwi.ImageStyle.Default;
        return _this;
    }
    Image.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($d8c6eedade336127$var$CardElement.heightProperty);
    };
    //#endregion
    Image.prototype.applySize = function(element) {
        if (this.pixelWidth || this.pixelHeight) {
            if (this.pixelWidth) element.style.width = this.pixelWidth + "px";
            if (this.pixelHeight) element.style.height = this.pixelHeight + "px";
        } else if (this.maxHeight) {
            // If the image is constrained in height, we set its height property and
            // auto and stretch are ignored (default to medium). THis is necessary for
            // ImageSet which uses a maximum image height as opposed to the cards width
            // as a constraining dimension
            switch(this.size){
                case $4uYwi.Size.Small:
                    element.style.height = this.hostConfig.imageSizes.small + "px";
                    break;
                case $4uYwi.Size.Large:
                    element.style.height = this.hostConfig.imageSizes.large + "px";
                    break;
                default:
                    element.style.height = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = this.maxHeight + "px";
        } else {
            switch(this.size){
                case $4uYwi.Size.Stretch:
                    element.style.width = "100%";
                    break;
                case $4uYwi.Size.Auto:
                    element.style.maxWidth = "100%";
                    break;
                case $4uYwi.Size.Small:
                    element.style.width = this.hostConfig.imageSizes.small + "px";
                    break;
                case $4uYwi.Size.Large:
                    element.style.width = this.hostConfig.imageSizes.large + "px";
                    break;
                case $4uYwi.Size.Medium:
                    element.style.width = this.hostConfig.imageSizes.medium + "px";
                    break;
            }
            element.style.maxHeight = "100%";
        }
    };
    Object.defineProperty(Image.prototype, "useDefaultSizing", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Image.prototype.internalRender = function() {
        var _this = this;
        var element = undefined;
        if (this.url) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.alignItems = "flex-start";
            // Cache hostConfig to avoid walking the parent hierarchy multiple times
            var hostConfig = this.hostConfig;
            switch(this.getEffectiveHorizontalAlignment()){
                case $4uYwi.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $4uYwi.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var imageElement = document.createElement("img");
            this.renderedImageElement = imageElement;
            imageElement.onload = function(_e) {
                $d8c6eedade336127$var$raiseImageLoadedEvent(_this);
            };
            imageElement.onerror = function(_e) {
                if (_this.renderedElement) {
                    var card = _this.getRootElement();
                    $d8c6eedade336127$var$clearElement(_this.renderedElement);
                    if (card && card.designMode) {
                        var errorElement = document.createElement("div");
                        errorElement.style.display = "flex";
                        errorElement.style.alignItems = "center";
                        errorElement.style.justifyContent = "center";
                        errorElement.style.backgroundColor = "#EEEEEE";
                        errorElement.style.color = "black";
                        errorElement.innerText = ":-(";
                        errorElement.style.padding = "10px";
                        _this.applySize(errorElement);
                        _this.renderedElement.appendChild(errorElement);
                    }
                }
                $d8c6eedade336127$var$raiseImageLoadedEvent(_this);
            };
            imageElement.style.minWidth = "0";
            imageElement.classList.add(hostConfig.makeCssClassName("ac-image"));
            if (this.selectAction && hostConfig.supportsInteractivity) {
                imageElement.onkeypress = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                imageElement.onclick = function(e) {
                    if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this.selectAction.execute();
                    }
                };
                this.selectAction.setupElementForAccessibility(imageElement);
                if (this.selectAction.isEffectivelyEnabled()) imageElement.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
            this.applySize(imageElement);
            if (this.style === $4uYwi.ImageStyle.Person) {
                imageElement.style.borderRadius = "50%";
                imageElement.style.backgroundPosition = "50% 50%";
                imageElement.style.backgroundRepeat = "no-repeat";
            }
            var backgroundColor = $6EfR6.stringToCssColor(this.backgroundColor);
            if (backgroundColor) imageElement.style.backgroundColor = backgroundColor;
            this.setImageSource(imageElement);
            var altTextProperty = this.preProcessPropertyValue(Image.altTextProperty);
            if (altTextProperty) imageElement.alt = altTextProperty;
            element.appendChild(imageElement);
        }
        return element;
    };
    Image.prototype.getJsonTypeName = function() {
        return "Image";
    };
    Image.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.selectAction) result.push(this.selectAction);
        return result;
    };
    Image.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.selectAction) result = this.selectAction.getActionById(id);
        return result;
    };
    Image.prototype.getResourceInformation = function() {
        return this.url ? [
            {
                url: this.url,
                mimeType: "image"
            }
        ] : [];
    };
    Image.prototype.setImageSource = function(imageElement) {
        var imageForceLoader = new $d8c6eedade336127$var$ImageForceLoader(this.forceLoad, this.url);
        imageForceLoader.configureImage(this);
        imageElement.src = this.preProcessPropertyValue(Image.urlProperty);
        imageForceLoader.resetImage(this);
    };
    Image.urlProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "url");
    Image.altTextProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "altText");
    Image.backgroundColorProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_1, "backgroundColor");
    Image.styleProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_0, "style", $4uYwi.ImageStyle, $4uYwi.ImageStyle.Default);
    Image.sizeProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_0, "size", $4uYwi.Size, $4uYwi.Size.Auto);
    Image.pixelWidthProperty = new $d8c6eedade336127$var$ImageDimensionProperty($dA5cX.Versions.v1_1, "width", "pixelWidth");
    Image.pixelHeightProperty = new $d8c6eedade336127$var$ImageDimensionProperty($dA5cX.Versions.v1_1, "height", "pixelHeight", $d8c6eedade336127$var$CardElement.heightProperty);
    Image.selectActionProperty = new $d8c6eedade336127$var$ActionProperty($dA5cX.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    Image.shouldForceLoadProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_6, "forceLoad", false);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Image.urlProperty)
    ], Image.prototype, "url", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Image.altTextProperty)
    ], Image.prototype, "altText", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Image.backgroundColorProperty)
    ], Image.prototype, "backgroundColor", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Image.sizeProperty)
    ], Image.prototype, "size", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Image.styleProperty)
    ], Image.prototype, "style", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Image.pixelWidthProperty)
    ], Image.prototype, "pixelWidth", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Image.pixelHeightProperty)
    ], Image.prototype, "pixelHeight", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Image.selectActionProperty)
    ], Image.prototype, "selectAction", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Image.shouldForceLoadProperty)
    ], Image.prototype, "forceLoad", void 0);
    return Image;
}($d8c6eedade336127$var$CardElement);
module.exports.Image = $d8c6eedade336127$var$Image;
// configures Image element to fetch a new image data from url source instead of relying on cache
// currently rudimentary refreshing scheme is used
// by attaching unique query string to url, we bypass the cache usage
var $d8c6eedade336127$var$ImageForceLoader = /** @class */ function() {
    function ImageForceLoader(doForceLoad, url) {
        this.doForceLoad = doForceLoad;
        this.url = url;
        if (url && url.length && doForceLoad) {
            // we can do better by appending unique key such as uuid instead of epoch
            // however the current usage is for front-end ui and networking,  
            // since ui is running in single main thread, this is sufficient mechanism
            // without needing to depend on external library for our small use cases.
            this.uniqueHash = "?" + Date.now();
            this.urlWithForceLoadOption = url + this.uniqueHash;
        }
    }
    ImageForceLoader.prototype.configureImage = function(image) {
        if (this.urlWithForceLoadOption && this.urlWithForceLoadOption.length) image.url = this.urlWithForceLoadOption;
    };
    ImageForceLoader.prototype.resetImage = function(image) {
        image.url = this.url;
    };
    return ImageForceLoader;
}();
var $d8c6eedade336127$var$CardElementContainer = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(CardElementContainer, _super);
    function CardElementContainer() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowVerticalOverflow = false;
        return _this;
    }
    CardElementContainer.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        if (!this.isSelectable) schema.remove(CardElementContainer.selectActionProperty);
    };
    //#endregion
    CardElementContainer.prototype.isElementAllowed = function(element) {
        return this.hostConfig.supportsInteractivity || !element.isInteractive;
    };
    CardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $krmaK.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        this.renderedElement.style.marginRight = "0";
        this.renderedElement.style.marginLeft = "0";
    };
    Object.defineProperty(CardElementContainer.prototype, "isSelectable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CardElementContainer.prototype.forbiddenChildElements = function() {
        return [];
    };
    CardElementContainer.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).releaseDOMResources();
    };
    CardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        for(var i = 0; i < this.getItemCount(); i++){
            var item = this.getItemAt(i);
            if (!this.hostConfig.supportsInteractivity && item.isInteractive) context.addFailure(this, $4uYwi.ValidationEvent.InteractivityNotAllowed, $luP4B.Strings.errors.interactivityNotAllowed());
            if (!this.isElementAllowed(item)) context.addFailure(this, $4uYwi.ValidationEvent.InteractivityNotAllowed, $luP4B.Strings.errors.elementTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
        if (this._selectAction) this._selectAction.internalValidateProperties(context);
    };
    CardElementContainer.prototype.render = function() {
        var _this = this;
        var element = _super.prototype.render.call(this);
        if (element) {
            var hostConfig = this.hostConfig;
            if (this.allowVerticalOverflow) {
                element.style.overflowX = "hidden";
                element.style.overflowY = "auto";
            }
            if (element && this.isSelectable && this._selectAction && hostConfig.supportsInteractivity) {
                element.onclick = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled()) {
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                element.onkeypress = function(e) {
                    if (_this._selectAction && _this._selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
                        // Enter or space pressed
                        e.preventDefault();
                        e.cancelBubble = true;
                        _this._selectAction.execute();
                    }
                };
                this._selectAction.setupElementForAccessibility(element);
                if (this._selectAction.isEffectivelyEnabled()) element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
            }
        }
        return element;
    };
    CardElementContainer.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if (processChildren) for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).updateLayout();
    };
    CardElementContainer.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllInputs(processActions));
        return result;
    };
    CardElementContainer.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getAllActions());
        if (this._selectAction) result.push(this._selectAction);
        return result;
    };
    CardElementContainer.prototype.getResourceInformation = function() {
        var result = [];
        for(var i = 0; i < this.getItemCount(); i++)result.push.apply(result, this.getItemAt(i).getResourceInformation());
        return result;
    };
    CardElementContainer.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) for(var i = 0; i < this.getItemCount(); i++){
            result = this.getItemAt(i).getElementById(id);
            if (result) break;
        }
        return result;
    };
    /**
     * @inheritdoc
     */ CardElementContainer.prototype.findDOMNodeOwner = function(node) {
        var _a;
        var target = undefined;
        for(var i = 0; i < this.getItemCount(); i++){
            // recur through child elements
            target = this.getItemAt(i).findDOMNodeOwner(node);
            if (target) return target;
        }
        // If not found in children, check the actions
        for(var i = 0; i < this.getActionCount(); i++){
            target = (_a = this.getActionAt(i)) === null || _a === void 0 ? void 0 : _a.findDOMNodeOwner(node);
            if (target) return target;
        }
        // if not found in children or actions, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    CardElementContainer.selectActionProperty = new $d8c6eedade336127$var$ActionProperty($dA5cX.Versions.v1_1, "selectAction", [
        "Action.ShowCard"
    ]);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(CardElementContainer.selectActionProperty)
    ], CardElementContainer.prototype, "_selectAction", void 0);
    return CardElementContainer;
}($d8c6eedade336127$var$CardElement);
module.exports.CardElementContainer = $d8c6eedade336127$var$CardElementContainer;
var $d8c6eedade336127$var$ImageSet = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ImageSet, _super);
    function ImageSet() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._images = [];
        _this.imageSize = $4uYwi.ImageSize.Medium;
        _this.presentationStyle = $4uYwi.ImageSetPresentationStyle.Default;
        _this.pixelOffset = 0;
        return _this;
    }
    //#endregion
    ImageSet.prototype.internalRender = function() {
        var element = undefined;
        if (this._images.length > 0) {
            element = document.createElement("div");
            element.style.display = "flex";
            element.style.flexWrap = "wrap";
            for(var _i = 0, _a = this._images; _i < _a.length; _i++){
                var image = _a[_i];
                switch(this.imageSize){
                    case $4uYwi.ImageSize.Small:
                        image.size = $4uYwi.Size.Small;
                        break;
                    case $4uYwi.ImageSize.Large:
                        image.size = $4uYwi.Size.Large;
                        break;
                    default:
                        image.size = $4uYwi.Size.Medium;
                        break;
                }
                image.maxHeight = this.hostConfig.imageSet.maxImageHeight;
                var renderedImage = image.render();
                if (renderedImage) {
                    renderedImage.style.display = "inline-flex";
                    renderedImage.style.margin = "0px";
                    if (this.presentationStyle == $4uYwi.ImageSetPresentationStyle.Default) renderedImage.style.marginRight = "10px";
                    $6EfR6.appendChild(element, renderedImage);
                }
            }
            if (this.presentationStyle == $4uYwi.ImageSetPresentationStyle.Stacked) this.applyStackedPresentationStyle();
        }
        return element;
    };
    ImageSet.prototype.applyStackedPresentationStyle = function() {
        if (this._images[0].renderedImageElement) {
            var dimension = $d8c6eedade336127$var$StackedImageConfigurator.parseNumericPixelDimension(this._images[0].renderedImageElement.style.height);
            var bgColor = this.getEffectiveBackgroundColor();
            if (dimension) {
                var stackedImageConfigurator = new $d8c6eedade336127$var$StackedImageConfigurator(this.pixelOffset, dimension, bgColor);
                stackedImageConfigurator.configureImagesArrayAsStackedLayout(this._images);
            }
        }
    };
    ImageSet.prototype.getEffectiveBackgroundColor = function() {
        var parentContainer = this.getParentContainer();
        var style = parentContainer === null || parentContainer === void 0 ? void 0 : parentContainer.getEffectiveStyle();
        var styleDefinition = this.hostConfig.containerStyles.getStyleByName(style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
        return $6EfR6.stringToCssColor(styleDefinition.backgroundColor);
    };
    ImageSet.prototype.getItemCount = function() {
        return this._images.length;
    };
    ImageSet.prototype.getItemAt = function(index) {
        return this._images[index];
    };
    ImageSet.prototype.getFirstVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[0] : undefined;
    };
    ImageSet.prototype.getLastVisibleRenderedItem = function() {
        return this._images && this._images.length > 0 ? this._images[this._images.length - 1] : undefined;
    };
    ImageSet.prototype.removeItem = function(item) {
        if (item instanceof $d8c6eedade336127$var$Image) {
            var itemIndex = this._images.indexOf(item);
            if (itemIndex >= 0) {
                this._images.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ImageSet.prototype.getJsonTypeName = function() {
        return "ImageSet";
    };
    ImageSet.prototype.addImage = function(image) {
        if (!image.parent) {
            this._images.push(image);
            image.setParent(this);
        } else throw new Error("This image already belongs to another ImageSet");
    };
    ImageSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $d8c6eedade336127$var$Image ? this._images.indexOf(cardElement) : -1;
    };
    ImageSet.imagesProperty = new $dA5cX.SerializableObjectCollectionProperty($dA5cX.Versions.v1_0, "images", $d8c6eedade336127$var$Image, function(sender, item) {
        item.setParent(sender);
    });
    ImageSet.imageSizeProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_0, "imageSize", $4uYwi.ImageSize, $4uYwi.ImageSize.Medium);
    ImageSet.imagePresentationStyle = new $dA5cX.EnumProperty($dA5cX.Versions.v1_6, "style", $4uYwi.ImageSetPresentationStyle, $4uYwi.ImageSetPresentationStyle.Default);
    ImageSet.pixelOffset = new $dA5cX.NumProperty($dA5cX.Versions.v1_6, "offset", 0, undefined);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ImageSet.imagesProperty)
    ], ImageSet.prototype, "_images", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ImageSet.imageSizeProperty)
    ], ImageSet.prototype, "imageSize", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ImageSet.imagePresentationStyle)
    ], ImageSet.prototype, "presentationStyle", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ImageSet.pixelOffset)
    ], ImageSet.prototype, "pixelOffset", void 0);
    return ImageSet;
}($d8c6eedade336127$var$CardElementContainer);
module.exports.ImageSet = $d8c6eedade336127$var$ImageSet;
var $d8c6eedade336127$var$StackedImageConfigurator = /** @class */ function() {
    function StackedImageConfigurator(offset, dimension, style) {
        this.sign45 = 0.7071;
        this.maxImageCounts = 2;
        this.offset = 0;
        this.normalizationConstant = 0;
        this.border = 5;
        this.dimension = 0;
        this.dimension = dimension;
        this.normalizationConstant = (dimension * this.sign45 - 0.5 * dimension) * 2;
        // offset determines how far images are placed from each other
        // at zero, images are separated only by the border
        // there is no restriction on how far they are apart in positive values, their actual
        // positioning is limited by maximum size imposed by Image renderer
        // a negative value can decrease upto the diameter of the image since a value less than the diameter
        // put the images past each other, and the use of such value is not reasonable request
        // users should change image positions in such case.
        this.offset = this.sign45 * (Math.max(offset, -dimension) - this.normalizationConstant);
        this.style = style ? style : "";
    }
    StackedImageConfigurator.prototype.moveImageRight = function(element) {
        element.style.marginLeft = this.offset + "px";
    };
    StackedImageConfigurator.prototype.moveImageUp = function(element) {
        element.style.marginBottom = this.offset + this.dimension + "px";
    };
    StackedImageConfigurator.prototype.moveImageDown = function(element) {
        element.style.marginTop = this.offset + this.dimension + "px";
    };
    StackedImageConfigurator.prototype.makeImageRound = function(element) {
        element.style.borderRadius = "50%";
        element.style.backgroundPosition = "50% 50%";
        element.style.backgroundRepeat = "no-repeat";
    };
    StackedImageConfigurator.prototype.applyBorder = function(element) {
        element.style.height = this.dimension + this.border * 2 + "px";
        element.style.border = this.border + "px" + " solid " + this.style;
    };
    StackedImageConfigurator.prototype.configureImageForBottomLeft = function(element) {
        this.moveImageDown(element);
        this.makeImageRound(element);
        this.applyBorder(element);
        element.style.zIndex = "2";
    };
    StackedImageConfigurator.prototype.configureImageForTopRight = function(element) {
        this.moveImageUp(element);
        this.moveImageRight(element);
        this.makeImageRound(element);
        element.style.zIndex = "1";
    };
    // stacked layout is applied when there are two images in ImageSet,
    // first image in the ImageSet is put bottom left of ImageSet,
    // second image is placed top right diagonally to the first image at 45 angle
    // first image is placed over the second image should the overlap to occur.
    StackedImageConfigurator.prototype.configureImagesArrayAsStackedLayout = function(elements) {
        if (elements.length == 1) {
            if (elements[0].renderedImageElement) this.makeImageRound(elements[0].renderedImageElement);
        } else if (elements.length <= this.maxImageCounts) {
            if (elements[0].renderedImageElement && elements[1].renderedImageElement) {
                this.configureImageForBottomLeft(elements[0].renderedImageElement);
                this.configureImageForTopRight(elements[1].renderedImageElement);
            }
        }
    };
    StackedImageConfigurator.parseNumericPixelDimension = function(dimension) {
        if ((dimension === null || dimension === void 0 ? void 0 : dimension.substring(dimension.length - 2)) == "px") return parseInt(dimension.substring(0, dimension.length - 2));
        return undefined;
    };
    return StackedImageConfigurator;
}();
var $d8c6eedade336127$var$ContentSource = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ContentSource, _super);
    //#endregion
    function ContentSource(url, mimeType) {
        var _this = _super.call(this) || this;
        _this.url = url;
        _this.mimeType = mimeType;
        return _this;
    }
    ContentSource.prototype.isValid = function() {
        return this.mimeType && this.url ? true : false;
    };
    //#region Schema
    ContentSource.mimeTypeProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_1, "mimeType");
    ContentSource.urlProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_1, "url");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ContentSource.mimeTypeProperty)
    ], ContentSource.prototype, "mimeType", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ContentSource.urlProperty)
    ], ContentSource.prototype, "url", void 0);
    return ContentSource;
}($dA5cX.SerializableObject);
module.exports.ContentSource = $d8c6eedade336127$var$ContentSource;
var $d8c6eedade336127$var$CaptionSource = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(CaptionSource, _super);
    //#endregion
    function CaptionSource(url, mimeType, label) {
        var _this = _super.call(this, url, mimeType) || this;
        _this.label = label;
        return _this;
    }
    CaptionSource.prototype.getSchemaKey = function() {
        return "CaptionSource";
    };
    CaptionSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("track");
            result.src = this.url;
            result.kind = "captions";
            result.label = this.label;
        }
        return result;
    };
    //#region Schema
    CaptionSource.labelProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_6, "label");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(CaptionSource.labelProperty)
    ], CaptionSource.prototype, "label", void 0);
    return CaptionSource;
}($d8c6eedade336127$var$ContentSource);
module.exports.CaptionSource = $d8c6eedade336127$var$CaptionSource;
var $d8c6eedade336127$var$MediaSource = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(MediaSource, _super);
    function MediaSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaSource.prototype.getSchemaKey = function() {
        return "MediaSource";
    };
    MediaSource.prototype.render = function() {
        var result = undefined;
        if (this.isValid()) {
            result = document.createElement("source");
            result.src = this.url;
            result.type = this.mimeType;
        }
        return result;
    };
    return MediaSource;
}($d8c6eedade336127$var$ContentSource);
module.exports.MediaSource = $d8c6eedade336127$var$MediaSource;
var $d8c6eedade336127$var$MediaPlayer = /** @class */ function() {
    function MediaPlayer() {}
    MediaPlayer.prototype.play = function() {
    // Do nothing in base implementation
    };
    Object.defineProperty(MediaPlayer.prototype, "posterUrl", {
        get: function() {
            return this._posterUrl;
        },
        set: function(value) {
            this._posterUrl = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    return MediaPlayer;
}();
module.exports.MediaPlayer = $d8c6eedade336127$var$MediaPlayer;
var $d8c6eedade336127$var$HTML5MediaPlayer = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(HTML5MediaPlayer, _super);
    function HTML5MediaPlayer(owner) {
        var _this = _super.call(this) || this;
        _this.owner = owner;
        _this._selectedSources = [];
        _this._captionSources = [];
        _this.processSources();
        return _this;
    }
    HTML5MediaPlayer.prototype.processSources = function() {
        var _a;
        this._selectedSources = [];
        this._captionSources = [];
        this._selectedMediaType = undefined;
        for(var _i = 0, _b = this.owner.sources; _i < _b.length; _i++){
            var source = _b[_i];
            var mimeComponents = source.mimeType ? source.mimeType.split("/") : [];
            if (mimeComponents.length === 2) {
                if (!this._selectedMediaType) {
                    var index = HTML5MediaPlayer.supportedMediaTypes.indexOf(mimeComponents[0]);
                    if (index >= 0) this._selectedMediaType = HTML5MediaPlayer.supportedMediaTypes[index];
                }
                if (mimeComponents[0] === this._selectedMediaType) this._selectedSources.push(source);
            }
        }
        (_a = this._captionSources).push.apply(_a, this.owner.captionSources);
    };
    HTML5MediaPlayer.prototype.canPlay = function() {
        return this._selectedSources.length > 0;
    };
    HTML5MediaPlayer.prototype.fetchVideoDetails = function() {
        return $d8c6eedade336127$var$__awaiter(this, void 0, void 0, function() {
            return $d8c6eedade336127$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    HTML5MediaPlayer.prototype.render = function() {
        if (this._selectedMediaType === "video") this._mediaElement = document.createElement("video");
        else this._mediaElement = document.createElement("audio");
        this._mediaElement.setAttribute("aria-label", this.owner.altText ? this.owner.altText : $luP4B.Strings.defaults.mediaPlayerAriaLabel());
        this._mediaElement.setAttribute("webkit-playsinline", "");
        this._mediaElement.setAttribute("playsinline", "");
        // We enable crossorigin for cases where the caption file has a different domain than
        // the video file. If the caption file lives in a different domain than the video file
        // and crossorigin is not set, then the caption file will fail to load.
        this._mediaElement.setAttribute("crossorigin", "");
        this._mediaElement.autoplay = true;
        this._mediaElement.controls = true;
        if ($6EfR6.isMobileOS()) this._mediaElement.muted = true;
        this._mediaElement.preload = "none";
        this._mediaElement.style.width = "100%";
        for(var _i = 0, _a = this.owner.sources; _i < _a.length; _i++){
            var source = _a[_i];
            var renderedSource = source.render();
            $6EfR6.appendChild(this._mediaElement, renderedSource);
        }
        for(var _b = 0, _c = this.owner.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.mimeType == "vtt") {
                var renderedCaptionSource = captionSource.render();
                $6EfR6.appendChild(this._mediaElement, renderedCaptionSource);
            }
        }
        return this._mediaElement;
    };
    HTML5MediaPlayer.prototype.play = function() {
        if (this._mediaElement) this._mediaElement.play();
    };
    Object.defineProperty(HTML5MediaPlayer.prototype, "selectedMediaType", {
        get: function() {
            return this._selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    HTML5MediaPlayer.supportedMediaTypes = [
        "audio",
        "video"
    ];
    return HTML5MediaPlayer;
}($d8c6eedade336127$var$MediaPlayer);
module.exports.HTML5MediaPlayer = $d8c6eedade336127$var$HTML5MediaPlayer;
var $d8c6eedade336127$var$CustomMediaPlayer = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(CustomMediaPlayer, _super);
    function CustomMediaPlayer(matches) {
        return _super.call(this) || this;
    }
    return CustomMediaPlayer;
}($d8c6eedade336127$var$MediaPlayer);
module.exports.CustomMediaPlayer = $d8c6eedade336127$var$CustomMediaPlayer;
var $d8c6eedade336127$var$IFrameMediaMediaPlayer = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(IFrameMediaMediaPlayer, _super);
    function IFrameMediaMediaPlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 2) _this._videoId = matches[1];
        return _this;
    }
    IFrameMediaMediaPlayer.prototype.canPlay = function() {
        return this._videoId !== undefined;
    };
    IFrameMediaMediaPlayer.prototype.render = function() {
        var container = document.createElement("div");
        container.style.position = "relative";
        container.style.width = "100%";
        container.style.height = "0";
        container.style.paddingBottom = "56.25%";
        var iFrame = document.createElement("iframe");
        iFrame.style.position = "absolute";
        iFrame.style.top = "0";
        iFrame.style.left = "0";
        iFrame.style.width = "100%";
        iFrame.style.height = "100%";
        iFrame.src = this.getEmbedVideoUrl();
        iFrame.frameBorder = "0";
        if (this.iFrameTitle) iFrame.title = this.iFrameTitle;
        iFrame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iFrame.allowFullscreen = true;
        container.appendChild(iFrame);
        return container;
    };
    Object.defineProperty(IFrameMediaMediaPlayer.prototype, "videoId", {
        get: function() {
            return this._videoId;
        },
        enumerable: false,
        configurable: true
    });
    return IFrameMediaMediaPlayer;
}($d8c6eedade336127$var$CustomMediaPlayer);
module.exports.IFrameMediaMediaPlayer = $d8c6eedade336127$var$IFrameMediaMediaPlayer;
var $d8c6eedade336127$var$VimeoPlayer = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(VimeoPlayer, _super);
    function VimeoPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VimeoPlayer.prototype.fetchVideoDetails = function() {
        return $d8c6eedade336127$var$__awaiter(this, void 0, void 0, function() {
            var oEmbedUrl, response, json;
            return $d8c6eedade336127$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        oEmbedUrl = "https://vimeo.com/api/oembed.json?url=".concat(this.getEmbedVideoUrl());
                        return [
                            4 /*yield*/ ,
                            fetch(oEmbedUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    VimeoPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://player.vimeo.com/video/".concat(this.videoId, "?autoplay=1");
    };
    return VimeoPlayer;
}($d8c6eedade336127$var$IFrameMediaMediaPlayer);
module.exports.VimeoPlayer = $d8c6eedade336127$var$VimeoPlayer;
var $d8c6eedade336127$var$DailymotionPlayer = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(DailymotionPlayer, _super);
    function DailymotionPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DailymotionPlayer.prototype.fetchVideoDetails = function() {
        return $d8c6eedade336127$var$__awaiter(this, void 0, void 0, function() {
            var apiUrl, response, json;
            return $d8c6eedade336127$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        apiUrl = "https://api.dailymotion.com/video/".concat(this.videoId, "?fields=thumbnail_720_url");
                        return [
                            4 /*yield*/ ,
                            fetch(apiUrl)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        json = _a.sent();
                        this.posterUrl = json["thumbnail_720_url"];
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DailymotionPlayer.prototype.getEmbedVideoUrl = function() {
        return "https://www.dailymotion.com/embed/video/".concat(this.videoId, "?autoplay=1");
    };
    return DailymotionPlayer;
}($d8c6eedade336127$var$IFrameMediaMediaPlayer);
module.exports.DailymotionPlayer = $d8c6eedade336127$var$DailymotionPlayer;
var $d8c6eedade336127$var$YouTubePlayer = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(YouTubePlayer, _super);
    function YouTubePlayer(matches, iFrameTitle) {
        var _this = _super.call(this, matches, iFrameTitle) || this;
        _this.iFrameTitle = iFrameTitle;
        if (matches.length >= 3 && matches[2] !== undefined) _this._startTimeIndex = parseInt(matches[2]);
        return _this;
    }
    YouTubePlayer.prototype.fetchVideoDetails = function() {
        return $d8c6eedade336127$var$__awaiter(this, void 0, void 0, function() {
            return $d8c6eedade336127$var$__generator(this, function(_a) {
                this.posterUrl = this.videoId ? "https://img.youtube.com/vi/".concat(this.videoId, "/maxresdefault.jpg") : undefined;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    YouTubePlayer.prototype.getEmbedVideoUrl = function() {
        var url = "https://www.youtube.com/embed/".concat(this.videoId, "?autoplay=1");
        if (this._startTimeIndex !== undefined) url += "&start=".concat(this._startTimeIndex);
        return url;
    };
    return YouTubePlayer;
}($d8c6eedade336127$var$IFrameMediaMediaPlayer);
module.exports.YouTubePlayer = $d8c6eedade336127$var$YouTubePlayer;
var $d8c6eedade336127$var$Media = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(Media, _super);
    function Media() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sources = [];
        _this.captionSources = [];
        return _this;
    }
    Media.prototype.createMediaPlayer = function() {
        for(var _i = 0, _a = Media.customMediaPlayers; _i < _a.length; _i++){
            var provider = _a[_i];
            for(var _b = 0, _c = this.sources; _b < _c.length; _b++){
                var source = _c[_b];
                if (source.url) for(var _d = 0, _f = provider.urlPatterns; _d < _f.length; _d++){
                    var pattern = _f[_d];
                    var matches = pattern.exec(source.url);
                    if (matches !== null) return provider.createMediaPlayer(matches);
                }
            }
        }
        return new $d8c6eedade336127$var$HTML5MediaPlayer(this);
    };
    Media.prototype.handlePlayButtonInvoke = function(event) {
        if (this.hostConfig.media.allowInlinePlayback) {
            event.preventDefault();
            event.cancelBubble = true;
            if (this.renderedElement) {
                var mediaPlayerElement = this._mediaPlayer.render();
                $d8c6eedade336127$var$clearElement(this.renderedElement);
                this.renderedElement.appendChild(mediaPlayerElement);
                this._mediaPlayer.play();
                mediaPlayerElement.focus();
            }
        } else if (Media.onPlay) {
            event.preventDefault();
            event.cancelBubble = true;
            Media.onPlay(this);
        }
    };
    Media.prototype.displayPoster = function() {
        return $d8c6eedade336127$var$__awaiter(this, void 0, void 0, function() {
            var playButtonArrowWidth, playButtonArrowHeight, posterRootElement_1, posterUrl, posterImageElement_1, playButtonOuterElement, playButtonInnerElement, playButtonContainer;
            var _this = this;
            return $d8c6eedade336127$var$__generator(this, function(_a) {
                if (this.renderedElement) {
                    playButtonArrowWidth = 12;
                    playButtonArrowHeight = 15;
                    posterRootElement_1 = document.createElement("div");
                    posterRootElement_1.className = this.hostConfig.makeCssClassName("ac-media-poster");
                    posterRootElement_1.setAttribute("role", "contentinfo");
                    posterRootElement_1.setAttribute("aria-label", this.altText ? this.altText : $luP4B.Strings.defaults.mediaPlayerAriaLabel());
                    posterRootElement_1.style.position = "relative";
                    posterRootElement_1.style.display = "flex";
                    posterUrl = this.poster ? this.poster : this._mediaPlayer.posterUrl;
                    if (!posterUrl) posterUrl = this.hostConfig.media.defaultPoster;
                    if (posterUrl) {
                        posterImageElement_1 = document.createElement("img");
                        posterImageElement_1.style.width = "100%";
                        posterImageElement_1.style.height = "100%";
                        posterImageElement_1.setAttribute("role", "presentation");
                        posterImageElement_1.onerror = function(_e) {
                            if (posterImageElement_1.parentNode) posterImageElement_1.parentNode.removeChild(posterImageElement_1);
                            posterRootElement_1.classList.add("empty");
                            posterRootElement_1.style.minHeight = "150px";
                        };
                        posterImageElement_1.src = posterUrl;
                        posterRootElement_1.appendChild(posterImageElement_1);
                    } else {
                        posterRootElement_1.classList.add("empty");
                        posterRootElement_1.style.minHeight = "150px";
                    }
                    if (this.hostConfig.supportsInteractivity && this._mediaPlayer.canPlay()) {
                        playButtonOuterElement = document.createElement("div");
                        playButtonOuterElement.tabIndex = 0;
                        playButtonOuterElement.setAttribute("role", "button");
                        playButtonOuterElement.setAttribute("aria-label", $luP4B.Strings.defaults.mediaPlayerPlayMedia());
                        playButtonOuterElement.className = this.hostConfig.makeCssClassName("ac-media-playButton");
                        playButtonOuterElement.style.display = "flex";
                        playButtonOuterElement.style.alignItems = "center";
                        playButtonOuterElement.style.justifyContent = "center";
                        playButtonOuterElement.onclick = function(e) {
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonOuterElement.onkeypress = function(e) {
                            if (e.code === "Enter" || e.code === "Space") // space or enter
                            _this.handlePlayButtonInvoke(e);
                        };
                        playButtonInnerElement = document.createElement("div");
                        playButtonInnerElement.className = this.hostConfig.makeCssClassName("ac-media-playButton-arrow");
                        playButtonInnerElement.style.width = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.height = playButtonArrowHeight + "px";
                        playButtonInnerElement.style.borderTopWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderBottomWidth = playButtonArrowHeight / 2 + "px";
                        playButtonInnerElement.style.borderLeftWidth = playButtonArrowWidth + "px";
                        playButtonInnerElement.style.borderRightWidth = "0";
                        playButtonInnerElement.style.borderStyle = "solid";
                        playButtonInnerElement.style.borderTopColor = "transparent";
                        playButtonInnerElement.style.borderRightColor = "transparent";
                        playButtonInnerElement.style.borderBottomColor = "transparent";
                        playButtonInnerElement.style.transform = "translate(" + playButtonArrowWidth / 10 + "px,0px)";
                        playButtonOuterElement.appendChild(playButtonInnerElement);
                        playButtonContainer = document.createElement("div");
                        playButtonContainer.style.position = "absolute";
                        playButtonContainer.style.left = "0";
                        playButtonContainer.style.top = "0";
                        playButtonContainer.style.width = "100%";
                        playButtonContainer.style.height = "100%";
                        playButtonContainer.style.display = "flex";
                        playButtonContainer.style.justifyContent = "center";
                        playButtonContainer.style.alignItems = "center";
                        playButtonContainer.appendChild(playButtonOuterElement);
                        posterRootElement_1.appendChild(playButtonContainer);
                    }
                    $d8c6eedade336127$var$clearElement(this.renderedElement);
                    this.renderedElement.appendChild(posterRootElement_1);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    Media.prototype.internalRender = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-media");
        return element;
    };
    Media.prototype.render = function() {
        var _this = this;
        var result = _super.prototype.render.call(this);
        if (result) {
            this._mediaPlayer = this.createMediaPlayer();
            this._mediaPlayer.fetchVideoDetails().then(function() {
                return _this.displayPoster();
            });
        }
        return result;
    };
    Media.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.displayPoster();
    };
    Media.prototype.getJsonTypeName = function() {
        return "Media";
    };
    Media.prototype.getResourceInformation = function() {
        var result = [];
        if (this._mediaPlayer) {
            var posterUrl = this.poster ? this.poster : this.hostConfig.media.defaultPoster;
            if (posterUrl) result.push({
                url: posterUrl,
                mimeType: "image"
            });
        }
        for(var _i = 0, _a = this.sources; _i < _a.length; _i++){
            var mediaSource = _a[_i];
            if (mediaSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `mediaSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: mediaSource.url,
                mimeType: mediaSource.mimeType
            });
        }
        for(var _b = 0, _c = this.captionSources; _b < _c.length; _b++){
            var captionSource = _c[_b];
            if (captionSource.isValid()) result.push({
                /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `captionSource.url` is of type `string | undefined`, but is validated by `isValid()` call */ url: captionSource.url,
                mimeType: captionSource.mimeType
            });
        }
        return result;
    };
    Object.defineProperty(Media.prototype, "selectedMediaType", {
        get: function() {
            return this._mediaPlayer.selectedMediaType;
        },
        enumerable: false,
        configurable: true
    });
    Media.customMediaPlayers = [
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?youtube.com\/watch\?(?=.*v=([\w\d-_]+))(?=(?:.*t=(\d+))?).*/gi,
                /^(?:https?:\/\/)?youtu.be\/([\w\d-_]+)(?:\?t=(\d+))?/gi
            ],
            createMediaPlayer: function(matches) {
                return new $d8c6eedade336127$var$YouTubePlayer(matches, $luP4B.Strings.defaults.youTubeVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?vimeo.com\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $d8c6eedade336127$var$VimeoPlayer(matches, $luP4B.Strings.defaults.vimeoVideoPlayer());
            }
        },
        {
            urlPatterns: [
                /^(?:https?:\/\/)?(?:www.)?dailymotion.com\/video\/([\w\d-_]+).*/gi
            ],
            createMediaPlayer: function(matches) {
                return new $d8c6eedade336127$var$DailymotionPlayer(matches, $luP4B.Strings.defaults.dailymotionVideoPlayer());
            }
        }
    ];
    //#region Schema
    Media.sourcesProperty = new $dA5cX.SerializableObjectCollectionProperty($dA5cX.Versions.v1_1, "sources", $d8c6eedade336127$var$MediaSource);
    Media.captionSourcesProperty = new $dA5cX.SerializableObjectCollectionProperty($dA5cX.Versions.v1_6, "captionSources", $d8c6eedade336127$var$CaptionSource);
    Media.posterProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_1, "poster");
    Media.altTextProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_1, "altText");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Media.sourcesProperty)
    ], Media.prototype, "sources", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Media.captionSourcesProperty)
    ], Media.prototype, "captionSources", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Media.posterProperty)
    ], Media.prototype, "poster", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Media.altTextProperty)
    ], Media.prototype, "altText", void 0);
    return Media;
}($d8c6eedade336127$var$CardElement);
module.exports.Media = $d8c6eedade336127$var$Media;
var $d8c6eedade336127$var$InputEventType;
(function(InputEventType) {
    InputEventType[InputEventType["InitialRender"] = 0] = "InitialRender";
    InputEventType[InputEventType["MouseEnterOnCard"] = 1] = "MouseEnterOnCard";
    InputEventType[InputEventType["MouseLeaveOnCard"] = 2] = "MouseLeaveOnCard";
    InputEventType[InputEventType["FocusLeave"] = 3] = "FocusLeave";
})($d8c6eedade336127$var$InputEventType || ($d8c6eedade336127$var$InputEventType = {}));
var $d8c6eedade336127$var$Input = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputStyle = $4uYwi.InputStyle.Default;
        return _this;
    }
    Input.prototype.getAllLabelIds = function() {
        var labelIds = [];
        if (this.labelledBy) labelIds.push(this.labelledBy);
        if (this._renderedLabelElement) labelIds.push(this._renderedLabelElement.id);
        if (this._renderedErrorMessageElement) labelIds.push(this._renderedErrorMessageElement.id);
        return labelIds;
    };
    Input.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._renderedInputControlElement) {
            var labelIds = this.getAllLabelIds();
            if (labelIds.length > 0) this._renderedInputControlElement.setAttribute("aria-labelledby", labelIds.join(" "));
            else this._renderedInputControlElement.removeAttribute("aria-labelledby");
        }
    };
    Object.defineProperty(Input.prototype, "isNullable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "renderedInputControlElement", {
        get: function() {
            return this._renderedInputControlElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "inputControlContainerElement", {
        get: function() {
            return this._inputControlContainerElement;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.overrideInternalRender = function() {
        var _this = this;
        var hostConfig = this.hostConfig;
        this._outerContainerElement = document.createElement("div");
        this._outerContainerElement.style.display = "flex";
        if (this.labelPosition === $4uYwi.InputLabelPosition.Inline) this._outerContainerElement.style.flexDirection = "row";
        else this._outerContainerElement.style.flexDirection = "column";
        var renderedInputControlId = $6EfR6.generateUniqueId();
        if (this.label) {
            var labelRichTextBlock = new $d8c6eedade336127$var$RichTextBlock();
            labelRichTextBlock.setParent(this);
            labelRichTextBlock.forElementId = renderedInputControlId;
            var labelInline = new $d8c6eedade336127$var$TextRun(this.label);
            labelRichTextBlock.addInline(labelInline);
            if (this.isRequired) {
                labelInline.init(hostConfig.inputs.label.requiredInputs);
                var isRequiredCueInline = new $d8c6eedade336127$var$TextRun(hostConfig.inputs.label.requiredInputs.suffix);
                isRequiredCueInline.color = hostConfig.inputs.label.requiredInputs.suffixColor;
                isRequiredCueInline.ariaHidden = true;
                labelRichTextBlock.addInline(isRequiredCueInline);
            } else labelInline.init(hostConfig.inputs.label.optionalInputs);
            this._renderedLabelElement = labelRichTextBlock.render();
            if (this._renderedLabelElement) {
                this._renderedLabelElement.id = $6EfR6.generateUniqueId();
                if (this.labelPosition === $4uYwi.InputLabelPosition.Inline) // For inline label position: label should be in center of the div and no extra spacing needed
                this._renderedLabelElement.style.alignSelf = "center";
                else this._renderedLabelElement.style.marginBottom = hostConfig.getEffectiveSpacing(hostConfig.inputs.label.inputSpacing) + "px";
                this._outerContainerElement.appendChild(this._renderedLabelElement);
            }
        }
        this._inputControlContainerElement = document.createElement("div");
        this._inputControlContainerElement.className = hostConfig.makeCssClassName("ac-input-container");
        this._inputControlContainerElement.style.display = "flex";
        if (this.height === "stretch") {
            this._inputControlContainerElement.style.alignItems = "stretch";
            this._inputControlContainerElement.style.flex = "1 1 auto";
        }
        this._renderedInputControlElement = this.internalRender();
        if (this._renderedInputControlElement) {
            this._renderedInputControlElement.id = renderedInputControlId;
            this._renderedInputControlElement.style.minWidth = "0px";
            if (this.isNullable && this.isRequired) {
                this._renderedInputControlElement.setAttribute("aria-required", "true");
                this._renderedInputControlElement.classList.add(hostConfig.makeCssClassName("ac-input-required"));
            }
            this._inputControlContainerElement.appendChild(this._renderedInputControlElement);
            this._outerContainerElement.appendChild(this._inputControlContainerElement);
            if (this._renderedLabelElement && this.labelPosition === $4uYwi.InputLabelPosition.Inline) {
                if (!this.labelWidth) {
                    var defaultLabelWidth = hostConfig.inputs.label.width;
                    this._renderedLabelElement.style.width = defaultLabelWidth.toString() + "%";
                    this._inputControlContainerElement.style.width = 100 - defaultLabelWidth + "%";
                } else if (this.labelWidth.unit == $4uYwi.SizeUnit.Weight) {
                    var labelWidthInPercent = this.labelWidth.physicalSize;
                    this._renderedLabelElement.style.width = labelWidthInPercent.toString() + "%";
                    this._inputControlContainerElement.style.width = (100 - labelWidthInPercent).toString() + "%";
                } else if (this.labelWidth.unit == $4uYwi.SizeUnit.Pixel) {
                    var labelWidthInPixel = this.labelWidth.physicalSize;
                    this._renderedLabelElement.style.width = labelWidthInPixel.toString() + "px";
                }
            }
            this.updateVisualState($d8c6eedade336127$var$InputEventType.InitialRender);
            if (this._renderedInputControlElement) this._renderedInputControlElement.onblur = function(ev) {
                _this.updateVisualState($d8c6eedade336127$var$InputEventType.FocusLeave);
            };
            this.updateInputControlAriaLabelledBy();
            return this._outerContainerElement;
        }
        this.resetDirtyState();
        return undefined;
    };
    Input.prototype.valueChanged = function() {
        this.getRootElement().updateActionsEnabledState();
        if (this.isValid()) this.resetValidationFailureCue();
        if (this.onValueChanged) this.onValueChanged(this);
        $d8c6eedade336127$var$raiseInputValueChangedEvent(this);
    };
    Input.prototype.resetValidationFailureCue = function() {
        if (this.renderedInputControlElement) {
            if (this instanceof $d8c6eedade336127$var$ChoiceSetInput && this.isDynamicTypeahead()) this.removeValidationFailureCue();
            else this.renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.updateInputControlAriaLabelledBy();
            if (this._renderedErrorMessageElement) {
                this._outerContainerElement.removeChild(this._renderedErrorMessageElement);
                this._renderedErrorMessageElement = undefined;
            }
        }
    };
    Input.prototype.showValidationErrorMessage = function() {
        if (this.renderedElement && this.errorMessage && $krmaK.GlobalSettings.displayInputValidationErrors) {
            var errorMessageTextBlock = new $d8c6eedade336127$var$TextBlock();
            errorMessageTextBlock.setParent(this);
            errorMessageTextBlock.text = this.errorMessage;
            errorMessageTextBlock.wrap = true;
            errorMessageTextBlock.init(this.hostConfig.inputs.errorMessage);
            this._renderedErrorMessageElement = errorMessageTextBlock.render();
            if (this._renderedErrorMessageElement) {
                this._renderedErrorMessageElement.id = $6EfR6.generateUniqueId();
                this._outerContainerElement.appendChild(this._renderedErrorMessageElement);
                this.updateInputControlAriaLabelledBy();
            }
        }
    };
    Object.defineProperty(Input.prototype, "allowRevealOnHoverStyle", {
        get: function() {
            return this.hostConfig.inputs && this.hostConfig.inputs.allowRevealOnHoverStyle;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.shouldHideInputAdornersForRevealOnHover = function(input, eventType) {
        // show/hide input adorners (date picker, time picker, select dropdown picker) with inputStyle RevealOnHover
        // 1. intial render of card: hide input adorners
        // 2. mouse hover on the card: show input adorners
        // 3. mouse hover outside the card: hide input adorners unless input is still in focus state
        // 4. input loses focus: hide the input adorners unless mouse is still hovering on the card
        // check if input still has the focus
        var isInputInFocus = input === document.activeElement;
        // check if mouse is still on the card
        var inputHoverClassName = this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover");
        var isMouseOverCard = input.classList.contains(inputHoverClassName);
        var hideInputAdorners = eventType === $d8c6eedade336127$var$InputEventType.InitialRender || eventType === $d8c6eedade336127$var$InputEventType.FocusLeave && !isMouseOverCard || eventType === $d8c6eedade336127$var$InputEventType.MouseLeaveOnCard && !isInputInFocus;
        return hideInputAdorners;
    };
    Input.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle || !this._renderedInputControlElement || this.inputStyle !== $4uYwi.InputStyle.RevealOnHover) return;
        if (eventType === $d8c6eedade336127$var$InputEventType.InitialRender) // on initial render, we will show input fields as read only view
        this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onrender"));
        else if (eventType === $d8c6eedade336127$var$InputEventType.MouseEnterOnCard) // on hover on the card, we will reveal the inputs by showing borders etc
        // ac-inputStyle-revealOnHover-onhover class is also used to identify if mouse is hovering on the card
        this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
        else if (eventType === $d8c6eedade336127$var$InputEventType.MouseLeaveOnCard) this._renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
    };
    Input.prototype.focus = function() {
        if (this._renderedInputControlElement) this._renderedInputControlElement.focus();
    };
    Input.prototype.isValid = function() {
        return true;
    };
    Input.prototype.isDirty = function() {
        return this.value !== this._oldValue;
    };
    Input.prototype.resetDirtyState = function() {
        this._oldValue = this.value;
    };
    Input.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.id) context.addFailure(this, $4uYwi.ValidationEvent.PropertyCantBeNull, $luP4B.Strings.errors.inputsMustHaveUniqueId());
        if (this.isRequired) {
            if (!this.label) context.addFailure(this, $4uYwi.ValidationEvent.RequiredInputsShouldHaveLabel, "Required inputs should have a label");
            if (!this.errorMessage) context.addFailure(this, $4uYwi.ValidationEvent.RequiredInputsShouldHaveErrorMessage, "Required inputs should have an error message");
        }
    };
    Input.prototype.validateValue = function() {
        this.resetValidationFailureCue();
        var result = this.isRequired ? this.isSet() && this.isValid() : this.isValid();
        if (!result && this.renderedInputControlElement) {
            if (this instanceof $d8c6eedade336127$var$ChoiceSetInput && this.isDynamicTypeahead()) this.showValidationFailureCue();
            else this.renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
            this.showValidationErrorMessage();
        }
        return result;
    };
    Input.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [
            this
        ];
    };
    Input.prototype.render = function() {
        var result = _super.prototype.render.call(this);
        this.resetDirtyState();
        return result;
    };
    Object.defineProperty(Input.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Input.labelProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_3, "label", true);
    Input.isRequiredProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_3, "isRequired", false);
    Input.errorMessageProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_3, "errorMessage", true);
    Input.inputStyleProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_6, "inputStyle", $4uYwi.InputStyle, $4uYwi.InputStyle.Default, [
        {
            value: $4uYwi.InputStyle.RevealOnHover
        },
        {
            value: $4uYwi.InputStyle.Default
        }
    ]);
    Input.labelWidthProperty = new $dA5cX.CustomProperty($dA5cX.Versions.v1_6, "labelWidth", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidLabelWidth = false;
        if (typeof value === "number" && !isNaN(value)) {
            result = new $krmaK.SizeAndUnit(value, $4uYwi.SizeUnit.Weight);
            if (result.physicalSize < 0 || result.physicalSize > 100) invalidLabelWidth = true;
        } else if (typeof value === "string") try {
            result = $krmaK.SizeAndUnit.parse(value);
        } catch (e) {
            invalidLabelWidth = true;
        }
        else invalidLabelWidth = true;
        if (invalidLabelWidth) {
            context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidInputLabelWidth());
            result = undefined;
        }
        return result;
    }, function(sender, property, target, value, context) {
        if (value instanceof $krmaK.SizeAndUnit) {
            if (value.unit === $4uYwi.SizeUnit.Pixel) context.serializeValue(target, "labelWidth", value.physicalSize + "px");
            else context.serializeNumber(target, "labelWidth", value.physicalSize);
        }
    }, undefined);
    Input.labelPositionProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_6, "labelPosition", $4uYwi.InputLabelPosition, $4uYwi.InputLabelPosition.Above, [
        {
            value: $4uYwi.InputLabelPosition.Inline
        },
        {
            value: $4uYwi.InputLabelPosition.Above
        }
    ]);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Input.labelProperty)
    ], Input.prototype, "label", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Input.isRequiredProperty)
    ], Input.prototype, "isRequired", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Input.errorMessageProperty)
    ], Input.prototype, "errorMessage", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Input.inputStyleProperty)
    ], Input.prototype, "inputStyle", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Input.labelWidthProperty)
    ], Input.prototype, "labelWidth", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Input.labelPositionProperty)
    ], Input.prototype, "labelPosition", void 0);
    return Input;
}($d8c6eedade336127$var$CardElement);
module.exports.Input = $d8c6eedade336127$var$Input;
var $d8c6eedade336127$var$TextInput = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(TextInput, _super);
    function TextInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiline = false;
        _this.style = $4uYwi.InputTextStyle.Text;
        return _this;
    }
    //#endregion
    TextInput.prototype.setupInput = function(input) {
        var _this = this;
        input.style.flex = "1 1 auto";
        input.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.placeholder) {
            input.placeholder = this.placeholder;
            input.setAttribute("aria-label", this.placeholder);
        }
        if (this.defaultValue) input.value = this.defaultValue;
        if (this.maxLength && this.maxLength > 0) input.maxLength = this.maxLength;
        input.oninput = function() {
            _this.valueChanged();
        };
        input.onkeypress = function(e) {
            // Ctrl+Enter pressed
            if (e.ctrlKey && e.code === "Enter" && _this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) _this.inlineAction.execute();
        };
    };
    TextInput.prototype.internalRender = function() {
        var result;
        if (this.isMultiline && this.style !== $4uYwi.InputTextStyle.Password) {
            result = document.createElement("textarea");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput", "ac-multiline");
            if (this.height === "stretch") result.style.height = "initial";
        } else {
            result = document.createElement("input");
            result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput");
            result.type = $4uYwi.InputTextStyle[this.style].toLowerCase();
        }
        this.setupInput(result);
        return result;
    };
    TextInput.prototype.overrideInternalRender = function() {
        var _this = this;
        var renderedInputControl = _super.prototype.overrideInternalRender.call(this);
        if (this.inlineAction) {
            var button_1 = document.createElement("button");
            button_1.className = this.hostConfig.makeCssClassName(this.inlineAction.isEffectivelyEnabled() ? "ac-inlineActionButton" : "ac-inlineActionButton-disabled");
            button_1.onclick = function(e) {
                if (_this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) {
                    e.preventDefault();
                    e.cancelBubble = true;
                    _this.inlineAction.execute();
                }
            };
            if (this.inlineAction.iconUrl) {
                button_1.classList.add("iconOnly");
                var icon_1 = document.createElement("img");
                icon_1.style.height = "100%";
                icon_1.setAttribute("role", "presentation");
                // The below trick is necessary as a workaround in Chrome where the icon is initially displayed
                // at its native size then resized to 100% of the button's height. This cfreates an unpleasant
                // flicker. On top of that, Chrome's flex implementation fails to prperly re-layout the button
                // after the image has loaded and been gicven its final size. The below trick also fixes that.
                icon_1.style.display = "none";
                icon_1.onload = function() {
                    icon_1.style.removeProperty("display");
                };
                icon_1.onerror = function() {
                    button_1.removeChild(icon_1);
                    button_1.classList.remove("iconOnly");
                    button_1.classList.add("textOnly");
                    button_1.textContent = _this.inlineAction && _this.inlineAction.title ? _this.inlineAction.title : $luP4B.Strings.defaults.inlineActionTitle();
                };
                icon_1.src = this.inlineAction.iconUrl;
                button_1.appendChild(icon_1);
                button_1.title = this.inlineAction.title ? this.inlineAction.title : $luP4B.Strings.defaults.inlineActionTitle();
            } else {
                button_1.classList.add("textOnly");
                button_1.textContent = this.inlineAction.title ? this.inlineAction.title : $luP4B.Strings.defaults.inlineActionTitle();
            }
            this.inlineAction.setupElementForAccessibility(button_1, true);
            button_1.style.marginLeft = "8px";
            this.inputControlContainerElement.appendChild(button_1);
        }
        return renderedInputControl;
    };
    TextInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        if (!(this.inlineAction || this.isMultiline)) _super.prototype.updateVisualState.call(this, eventType);
    };
    TextInput.prototype.getJsonTypeName = function() {
        return "Input.Text";
    };
    TextInput.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        if (this.inlineAction) result.push(this.inlineAction);
        return result;
    };
    TextInput.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result && this.inlineAction) result = this.inlineAction.getActionById(id);
        return result;
    };
    TextInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TextInput.prototype.isValid = function() {
        if (!this.value) return true;
        if (this.regex) return new RegExp(this.regex, "g").test(this.value);
        return true;
    };
    Object.defineProperty(TextInput.prototype, "value", {
        get: function() {
            if (this.renderedInputControlElement) {
                if (this.isMultiline) return this.renderedInputControlElement.value;
                else return this.renderedInputControlElement.value;
            } else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    TextInput.valueProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "value");
    TextInput.maxLengthProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_0, "maxLength");
    TextInput.isMultilineProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_0, "isMultiline", false);
    TextInput.placeholderProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "placeholder");
    TextInput.styleProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_0, "style", $4uYwi.InputTextStyle, $4uYwi.InputTextStyle.Text, [
        {
            value: $4uYwi.InputTextStyle.Text
        },
        {
            value: $4uYwi.InputTextStyle.Tel
        },
        {
            value: $4uYwi.InputTextStyle.Url
        },
        {
            value: $4uYwi.InputTextStyle.Email
        },
        {
            value: $4uYwi.InputTextStyle.Password,
            targetVersion: $dA5cX.Versions.v1_5
        }
    ]);
    TextInput.inlineActionProperty = new $d8c6eedade336127$var$ActionProperty($dA5cX.Versions.v1_0, "inlineAction", [
        "Action.ShowCard"
    ]);
    TextInput.regexProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_3, "regex", true);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextInput.valueProperty)
    ], TextInput.prototype, "defaultValue", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextInput.maxLengthProperty)
    ], TextInput.prototype, "maxLength", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextInput.isMultilineProperty)
    ], TextInput.prototype, "isMultiline", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextInput.placeholderProperty)
    ], TextInput.prototype, "placeholder", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextInput.styleProperty)
    ], TextInput.prototype, "style", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextInput.inlineActionProperty)
    ], TextInput.prototype, "inlineAction", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TextInput.regexProperty)
    ], TextInput.prototype, "regex", void 0);
    return TextInput;
}($d8c6eedade336127$var$Input);
module.exports.TextInput = $d8c6eedade336127$var$TextInput;
var $d8c6eedade336127$var$ToggleInput = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ToggleInput, _super);
    function ToggleInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.valueOn = "true";
        _this.valueOff = "false";
        _this.wrap = false;
        return _this;
    }
    ToggleInput.prototype.updateInputControlAriaLabelledBy = function() {
        if (this._checkboxInputElement) {
            var joinedLabelIds = this.getAllLabelIds().join(" ");
            if (this._checkboxInputLabelElement && this._checkboxInputLabelElement.id) joinedLabelIds += " " + this._checkboxInputLabelElement.id;
            if (joinedLabelIds) this._checkboxInputElement.setAttribute("aria-labelledby", joinedLabelIds);
            else this._checkboxInputElement.removeAttribute("aria-labelledby");
        }
    };
    ToggleInput.prototype.internalRender = function() {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", "ac-toggleInput");
        element.style.width = "100%";
        element.style.display = "flex";
        element.style.alignItems = "center";
        this._checkboxInputElement = document.createElement("input");
        this._checkboxInputElement.id = $6EfR6.generateUniqueId();
        this._checkboxInputElement.type = "checkbox";
        this._checkboxInputElement.style.display = "inline-block";
        this._checkboxInputElement.style.verticalAlign = "middle";
        this._checkboxInputElement.style.margin = "0";
        this._checkboxInputElement.style.flex = "0 0 auto";
        if (this.title) this._checkboxInputElement.setAttribute("aria-label", this.title);
        if (this.isRequired) this._checkboxInputElement.setAttribute("aria-required", "true");
        this._checkboxInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue === this.valueOn) this._checkboxInputElement.checked = true;
        this._oldCheckboxValue = this._checkboxInputElement.checked;
        this._checkboxInputElement.onchange = function() {
            _this.valueChanged();
        };
        $6EfR6.appendChild(element, this._checkboxInputElement);
        if (this.title || this.isDesignMode()) {
            var label = new $d8c6eedade336127$var$TextBlock();
            label.setParent(this);
            label.forElementId = this._checkboxInputElement.id;
            label.hostConfig = this.hostConfig;
            label.text = !this.title ? this.getJsonTypeName() : this.title;
            label.useMarkdown = $krmaK.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            this._checkboxInputLabelElement = label.render();
            if (this._checkboxInputLabelElement) {
                this._checkboxInputLabelElement.id = $6EfR6.generateUniqueId();
                this._checkboxInputLabelElement.style.display = "inline-block";
                this._checkboxInputLabelElement.style.flex = "1 1 auto";
                this._checkboxInputLabelElement.style.marginLeft = "6px";
                this._checkboxInputLabelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $6EfR6.appendChild(element, spacerElement);
                $6EfR6.appendChild(element, this._checkboxInputLabelElement);
            }
        }
        return element;
    };
    Object.defineProperty(ToggleInput.prototype, "isNullable", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.prototype.updateVisualState = function(eventType) {};
    ToggleInput.prototype.getJsonTypeName = function() {
        return "Input.Toggle";
    };
    ToggleInput.prototype.focus = function() {
        if (this._checkboxInputElement) this._checkboxInputElement.focus();
    };
    ToggleInput.prototype.isSet = function() {
        if (this.isRequired) return this.value === this.valueOn;
        return this.value ? true : false;
    };
    ToggleInput.prototype.isDirty = function() {
        return this._checkboxInputElement ? this._checkboxInputElement.checked !== this._oldCheckboxValue : false;
    };
    Object.defineProperty(ToggleInput.prototype, "value", {
        get: function() {
            if (this._checkboxInputElement) return this._checkboxInputElement.checked ? this.valueOn : this.valueOff;
            else return undefined;
        },
        enumerable: false,
        configurable: true
    });
    ToggleInput.valueProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "value");
    ToggleInput.titleProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "title");
    ToggleInput.valueOnProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "valueOn", true, undefined, "true", function(sender) {
        return "true";
    });
    ToggleInput.valueOffProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "valueOff", true, undefined, "false", function(sender) {
        return "false";
    });
    ToggleInput.wrapProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_2, "wrap", false);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ToggleInput.valueProperty)
    ], ToggleInput.prototype, "defaultValue", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ToggleInput.titleProperty)
    ], ToggleInput.prototype, "title", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ToggleInput.valueOnProperty)
    ], ToggleInput.prototype, "valueOn", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ToggleInput.valueOffProperty)
    ], ToggleInput.prototype, "valueOff", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ToggleInput.wrapProperty)
    ], ToggleInput.prototype, "wrap", void 0);
    return ToggleInput;
}($d8c6eedade336127$var$Input);
module.exports.ToggleInput = $d8c6eedade336127$var$ToggleInput;
var $d8c6eedade336127$var$Choice = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(Choice, _super);
    function Choice(title, value) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.value = value;
        return _this;
    }
    //#endregion
    Choice.prototype.getSchemaKey = function() {
        return "Choice";
    };
    //#region Schema
    Choice.titleProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "title");
    Choice.valueProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "value");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Choice.titleProperty)
    ], Choice.prototype, "title", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Choice.valueProperty)
    ], Choice.prototype, "value", void 0);
    return Choice;
}($dA5cX.SerializableObject);
module.exports.Choice = $d8c6eedade336127$var$Choice;
/**
 * DataQuery class is declared later in the file and derives from subsequent base classes
 * Hence, it cannot be used in ChoiceSetInput.
 * Refactor is needed to separate elements and actions in separate files.
 */ var $d8c6eedade336127$var$ChoiceSetInputDataQuery = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ChoiceSetInputDataQuery, _super);
    function ChoiceSetInputDataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    ChoiceSetInputDataQuery.prototype.getSchemaKey = function() {
        return "choices.data";
    };
    //#region Schema
    ChoiceSetInputDataQuery.typeProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_6, "type", true, new RegExp("^Data.Query$"));
    ChoiceSetInputDataQuery.datasetProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_6, "dataset");
    ChoiceSetInputDataQuery.countProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_6, "count");
    ChoiceSetInputDataQuery.skipProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_6, "skip");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInputDataQuery.typeProperty)
    ], ChoiceSetInputDataQuery.prototype, "type", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInputDataQuery.datasetProperty)
    ], ChoiceSetInputDataQuery.prototype, "dataset", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInputDataQuery.countProperty)
    ], ChoiceSetInputDataQuery.prototype, "count", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInputDataQuery.skipProperty)
    ], ChoiceSetInputDataQuery.prototype, "skip", void 0);
    return ChoiceSetInputDataQuery;
}($dA5cX.SerializableObject);
module.exports.ChoiceSetInputDataQuery = $d8c6eedade336127$var$ChoiceSetInputDataQuery;
var $d8c6eedade336127$var$ChoiceSetInput = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ChoiceSetInput, _super);
    function ChoiceSetInput() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiSelect = false;
        _this.wrap = false;
        _this.choices = [];
        return _this;
    }
    Object.defineProperty(ChoiceSetInput.prototype, "isCompact", {
        get: function() {
            return !this.style || this.style === "compact";
        },
        set: function(value) {
            this.style = value ? undefined : "expanded";
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.getUniqueCategoryName = function() {
        var uniqueCategoryName = "__ac-category" + ChoiceSetInput._uniqueCategoryCounter;
        ChoiceSetInput._uniqueCategoryCounter++;
        return uniqueCategoryName;
    };
    ChoiceSetInput.prototype.isDynamicTypeahead = function() {
        return this.hostConfig.inputs.allowDynamicallyFilteredChoiceSet && !!this.choicesData && !!this.choicesData.dataset && this.choicesData.type === "Data.Query";
    };
    ChoiceSetInput.prototype.getFilterForDynamicSearch = function() {
        var _a;
        return (_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value;
    };
    ChoiceSetInput.prototype.getDropdownElement = function() {
        var _a;
        return (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.dropdown;
    };
    ChoiceSetInput.prototype.renderChoices = function(filter, fetchedChoices) {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.processResponse(filter, fetchedChoices);
    };
    ChoiceSetInput.prototype.showLoadingIndicator = function() {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.showLoadingIndicator();
    };
    ChoiceSetInput.prototype.removeLoadingIndicator = function() {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.removeLoadingIndicator();
    };
    ChoiceSetInput.prototype.showErrorIndicator = function(filter, error) {
        var _a;
        (_a = this._filteredChoiceSet) === null || _a === void 0 || _a.showErrorIndicator(filter, error);
    };
    ChoiceSetInput.prototype.showValidationFailureCue = function() {
        var _a;
        (_a = this._textInput) === null || _a === void 0 || _a.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
    };
    ChoiceSetInput.prototype.removeValidationFailureCue = function() {
        var _a;
        (_a = this._textInput) === null || _a === void 0 || _a.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
    };
    ChoiceSetInput.prototype.createPlaceholderOptionWhenValueDoesNotExist = function() {
        if (!this.value) {
            var placeholderOption = document.createElement("option");
            placeholderOption.selected = true;
            placeholderOption.disabled = true;
            placeholderOption.hidden = true;
            placeholderOption.value = "";
            if (this.placeholder) placeholderOption.text = this.placeholder;
            return placeholderOption;
        }
        return undefined;
    };
    // Make sure `aria-current` is applied to the currently-selected item
    ChoiceSetInput.prototype.internalApplyAriaCurrent = function() {
        if (this._selectElement) {
            var options = this._selectElement.options;
            if (options) for(var _i = 0, _a = Array.from(options); _i < _a.length; _i++){
                var option = _a[_i];
                if (option.selected) option.setAttribute("aria-current", "true");
                else option.removeAttribute("aria-current");
            }
        }
    };
    ChoiceSetInput.prototype.renderCompoundInput = function(cssClassName, type, defaultValues) {
        var _this = this;
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-input", cssClassName);
        element.style.width = "100%";
        element.tabIndex = this.isDesignMode() ? -1 : 0;
        this._toggleInputs = [];
        this._labels = [];
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            var input = document.createElement("input");
            input.id = $6EfR6.generateUniqueId();
            input.type = type;
            input.style.margin = "0";
            input.style.display = "inline-block";
            input.style.verticalAlign = "middle";
            input.style.flex = "0 0 auto";
            input.name = this.id ? this.id : this._uniqueCategoryName;
            if (this.isRequired) input.setAttribute("aria-required", "true");
            input.tabIndex = this.isDesignMode() ? -1 : 0;
            if (choice.value) input.value = choice.value;
            if (choice.title) input.setAttribute("aria-label", choice.title);
            if (defaultValues && choice.value) {
                if (defaultValues.indexOf(choice.value) >= 0) input.checked = true;
            }
            input.onchange = function() {
                _this.valueChanged();
            };
            this._toggleInputs.push(input);
            var compoundInput = document.createElement("div");
            compoundInput.style.display = "flex";
            compoundInput.style.alignItems = "center";
            $6EfR6.appendChild(compoundInput, input);
            var label = new $d8c6eedade336127$var$TextBlock();
            label.setParent(this);
            label.forElementId = input.id;
            label.hostConfig = this.hostConfig;
            label.text = choice.title ? choice.title : "Choice " + this._toggleInputs.length;
            label.useMarkdown = $krmaK.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
            label.wrap = this.wrap;
            var labelElement = label.render();
            this._labels.push(labelElement);
            if (labelElement) {
                labelElement.id = $6EfR6.generateUniqueId();
                labelElement.style.display = "inline-block";
                labelElement.style.flex = "1 1 auto";
                labelElement.style.marginLeft = "6px";
                labelElement.style.verticalAlign = "middle";
                var spacerElement = document.createElement("div");
                spacerElement.style.width = "6px";
                $6EfR6.appendChild(compoundInput, spacerElement);
                $6EfR6.appendChild(compoundInput, labelElement);
            }
            $6EfR6.appendChild(element, compoundInput);
        }
        return element;
    };
    ChoiceSetInput.prototype.updateInputControlAriaLabelledBy = function() {
        if ((this.isMultiSelect || this.style === "expanded") && this._toggleInputs && this._labels) {
            var labelIds = this.getAllLabelIds();
            for(var i = 0; i < this._toggleInputs.length; i++){
                var joinedLabelIds = labelIds.join(" ");
                var label = this._labels[i];
                if (label && label.id) joinedLabelIds += " " + label.id;
                if (joinedLabelIds) this._toggleInputs[i].setAttribute("aria-labelledby", joinedLabelIds);
                else this._toggleInputs[i].removeAttribute("aria-labelledby");
            }
        } else _super.prototype.updateInputControlAriaLabelledBy.call(this);
    };
    ChoiceSetInput.prototype.internalRender = function() {
        var _this = this;
        this._uniqueCategoryName = ChoiceSetInput.getUniqueCategoryName();
        if (this.isDynamicTypeahead()) {
            var filteredChoiceSet_1 = new $d8c6eedade336127$var$FilteredChoiceSet(ChoiceSetInput._uniqueCategoryCounter, this.choices, this.hostConfig);
            filteredChoiceSet_1.render();
            if (filteredChoiceSet_1.textInput) {
                this._textInput = filteredChoiceSet_1.textInput;
                if (this.defaultValue) this._textInput.value = this.defaultValue;
                if (this.placeholder && !this._textInput.value) {
                    this._textInput.placeholder = this.placeholder;
                    this._textInput.setAttribute("aria-label", this.placeholder);
                }
                this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
                var onInputChangeEventHandler = $6EfR6.debounce(function() {
                    filteredChoiceSet_1.processChoices();
                    _this.valueChanged();
                    if (_this._textInput) {
                        // Remove aria-label when value is not empty so narration software doesn't
                        // read the placeholder
                        if (_this.value) {
                            _this._textInput.removeAttribute("placeholder");
                            _this._textInput.removeAttribute("aria-label");
                        } else if (_this.placeholder) {
                            _this._textInput.placeholder = _this.placeholder;
                            _this._textInput.setAttribute("aria-label", _this.placeholder);
                        }
                    }
                }, this.hostConfig.inputs.debounceTimeInMilliSeconds);
                this._textInput.onclick = onInputChangeEventHandler;
                this._textInput.oninput = onInputChangeEventHandler;
            }
            filteredChoiceSet_1.parent = this;
            this._filteredChoiceSet = filteredChoiceSet_1;
            return filteredChoiceSet_1.renderedElement;
        } else if (this.isMultiSelect) // Render as a list of toggle inputs
        return this.renderCompoundInput("ac-choiceSetInput-multiSelect", "checkbox", this.defaultValue ? this.defaultValue.split(this.hostConfig.choiceSetInputValueSeparator) : undefined);
        else {
            if (this.style === "expanded") // Render as a series of radio buttons
            return this.renderCompoundInput("ac-choiceSetInput-expanded", "radio", this.defaultValue ? [
                this.defaultValue
            ] : undefined);
            else if (this.style === "filtered") {
                // Render as a text input coupled with a datalist
                var inputContainer = document.createElement("div");
                inputContainer.style.width = "100%";
                this._textInput = document.createElement("input");
                this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-filtered");
                this._textInput.type = "text";
                this._textInput.style.width = "100%";
                this._textInput.oninput = function() {
                    _this.valueChanged();
                    if (_this._textInput) {
                        // Remove aria-label when value is not empty so narration software doesn't
                        // read the placeholder
                        if (_this.value) {
                            _this._textInput.removeAttribute("placeholder");
                            _this._textInput.removeAttribute("aria-label");
                        } else if (_this.placeholder) {
                            _this._textInput.placeholder = _this.placeholder;
                            _this._textInput.setAttribute("aria-label", _this.placeholder);
                        }
                    }
                };
                if (this.defaultValue) this._textInput.value = this.defaultValue;
                if (this.placeholder && !this._textInput.value) {
                    this._textInput.placeholder = this.placeholder;
                    this._textInput.setAttribute("aria-label", this.placeholder);
                }
                this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
                var dataList = document.createElement("datalist");
                dataList.id = $6EfR6.generateUniqueId();
                for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                    var choice = _a[_i];
                    var option = document.createElement("option");
                    // To fix https://stackoverflow.com/questions/29882361/show-datalist-labels-but-submit-the-actual-value
                    // value is mapped to choice.title other than choice.value
                    if (choice.title) {
                        option.value = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    dataList.appendChild(option);
                }
                this._textInput.setAttribute("list", dataList.id);
                inputContainer.append(this._textInput, dataList);
                return inputContainer;
            } else {
                // Render as a combo box
                this._selectElement = document.createElement("select");
                this._selectElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-compact");
                this._selectElement.style.width = "100%";
                this._selectElement.tabIndex = this.isDesignMode() ? -1 : 0;
                var placeholderOption = this.createPlaceholderOptionWhenValueDoesNotExist();
                $6EfR6.appendChild(this._selectElement, placeholderOption);
                for(var _b = 0, _c = this.choices; _b < _c.length; _b++){
                    var choice = _c[_b];
                    var option = document.createElement("option");
                    option.value = choice.value;
                    if (choice.title) {
                        option.text = choice.title;
                        option.setAttribute("aria-label", choice.title);
                    }
                    option.tabIndex = this.isDesignMode() ? -1 : 0;
                    if (choice.value === this.defaultValue) option.selected = true;
                    $6EfR6.appendChild(this._selectElement, option);
                }
                this._selectElement.onchange = function() {
                    _this.internalApplyAriaCurrent();
                    _this.valueChanged();
                };
                this.internalApplyAriaCurrent();
                return this._selectElement;
            }
        }
    };
    ChoiceSetInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        if (!this.isMultiSelect && this.isCompact) {
            _super.prototype.updateVisualState.call(this, eventType);
            if (this._selectElement && this.inputStyle === $4uYwi.InputStyle.RevealOnHover) {
                var hideDropDownPicker = this.shouldHideInputAdornersForRevealOnHover(this._selectElement, eventType);
                if (hideDropDownPicker) {
                    this._selectElement.style.appearance = "none";
                    this._selectElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
                } else {
                    this._selectElement.style.appearance = "auto";
                    this._selectElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
                }
            }
        }
    };
    ChoiceSetInput.prototype.getJsonTypeName = function() {
        return "Input.ChoiceSet";
    };
    ChoiceSetInput.prototype.focus = function() {
        if (this._toggleInputs && (this.isMultiSelect || this.style === "expanded")) {
            if (this._toggleInputs.length > 0) this._toggleInputs[0].focus();
        } else if (this._textInput) this._textInput.focus();
        else _super.prototype.focus.call(this);
    };
    ChoiceSetInput.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.choices.length === 0) context.addFailure(this, $4uYwi.ValidationEvent.CollectionCantBeEmpty, $luP4B.Strings.errors.choiceSetMustHaveAtLeastOneChoice());
        for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
            var choice = _a[_i];
            if (!choice.title || !choice.value) context.addFailure(this, $4uYwi.ValidationEvent.PropertyCantBeNull, $luP4B.Strings.errors.choiceSetChoicesMustHaveTitleAndValue());
        }
    };
    ChoiceSetInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    ChoiceSetInput.prototype.isValid = function() {
        if (this._textInput) {
            if (this.value === "" || this.value === this.placeholder) return true;
            for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                var choice = _a[_i];
                if (this.value === choice.value) return true;
            }
            if (this.dynamicChoices) for(var _b = 0, _c = this.dynamicChoices; _b < _c.length; _b++){
                var choice = _c[_b];
                if (this.value === choice) return true;
            }
            return false;
        }
        return _super.prototype.isValid.call(this);
    };
    Object.defineProperty(ChoiceSetInput.prototype, "value", {
        get: function() {
            if (!this.isMultiSelect) {
                if (this._selectElement) return this._selectElement.selectedIndex > 0 ? this._selectElement.value : undefined;
                else if (this._textInput) {
                    for(var _i = 0, _a = this.choices; _i < _a.length; _i++){
                        var choice = _a[_i];
                        if (choice.title && this._textInput.value === choice.title) return choice.value;
                    }
                    return this._textInput.value;
                } else if (this._toggleInputs && this._toggleInputs.length > 0) for(var _b = 0, _c = this._toggleInputs; _b < _c.length; _b++){
                    var toggleInput = _c[_b];
                    if (toggleInput.checked) return toggleInput.value;
                }
                return undefined;
            } else {
                if (!this._toggleInputs || this._toggleInputs.length === 0) return undefined;
                var result = "";
                for(var _d = 0, _f = this._toggleInputs; _d < _f.length; _d++){
                    var toggleInput = _f[_d];
                    if (toggleInput.checked) {
                        if (result !== "") result += this.hostConfig.choiceSetInputValueSeparator;
                        result += toggleInput.value;
                    }
                }
                return result ? result : undefined;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChoiceSetInput.prototype, "dynamicChoices", {
        get: function() {
            var _a;
            return (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.dynamicChoices;
        },
        enumerable: false,
        configurable: true
    });
    ChoiceSetInput.valueProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "value");
    ChoiceSetInput.choicesProperty = new $dA5cX.SerializableObjectCollectionProperty($dA5cX.Versions.v1_0, "choices", $d8c6eedade336127$var$Choice);
    ChoiceSetInput.choicesDataProperty = new $dA5cX.SerializableObjectProperty($dA5cX.Versions.v1_6, "choices.data", $d8c6eedade336127$var$ChoiceSetInputDataQuery);
    ChoiceSetInput.styleProperty = new $dA5cX.ValueSetProperty($dA5cX.Versions.v1_0, "style", [
        {
            value: "compact"
        },
        {
            value: "expanded"
        },
        {
            value: "filtered",
            targetVersion: $dA5cX.Versions.v1_5
        }
    ], "compact");
    ChoiceSetInput.isMultiSelectProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_0, "isMultiSelect", false);
    ChoiceSetInput.placeholderProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "placeholder");
    ChoiceSetInput.wrapProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_2, "wrap", false);
    //#endregion
    ChoiceSetInput._uniqueCategoryCounter = 0;
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInput.valueProperty)
    ], ChoiceSetInput.prototype, "defaultValue", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInput.styleProperty)
    ], ChoiceSetInput.prototype, "style", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInput.isMultiSelectProperty)
    ], ChoiceSetInput.prototype, "isMultiSelect", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInput.placeholderProperty)
    ], ChoiceSetInput.prototype, "placeholder", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInput.wrapProperty)
    ], ChoiceSetInput.prototype, "wrap", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInput.choicesProperty)
    ], ChoiceSetInput.prototype, "choices", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ChoiceSetInput.choicesDataProperty)
    ], ChoiceSetInput.prototype, "choicesData", void 0);
    return ChoiceSetInput;
}($d8c6eedade336127$var$Input);
module.exports.ChoiceSetInput = $d8c6eedade336127$var$ChoiceSetInput;
var $d8c6eedade336127$var$FilteredChoiceSet = /** @class */ function() {
    function FilteredChoiceSet(choiceSetId, choices, hostConfig) {
        this._choiceSetId = choiceSetId;
        this._choices = choices;
        this._dynamicChoices = [];
        this._visibleChoiceCount = 0;
        this._highlightedChoiceId = -1;
        this._hostConfig = hostConfig;
    }
    FilteredChoiceSet.prototype.render = function() {
        var _this = this;
        var choiceSetContainer = document.createElement("div");
        choiceSetContainer.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-container");
        this._textInput = document.createElement("input");
        this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-textbox");
        this._textInput.type = "text";
        this._textInput.onkeydown = function(event) {
            if (event.key === "ArrowDown") {
                event.preventDefault();
                _this.highlightChoice(_this._highlightedChoiceId + 1);
            } else if (event.key === "ArrowUp") {
                event.preventDefault();
                _this.highlightChoice(_this._highlightedChoiceId - 1);
            } else if (event.key === "Enter") {
                var choice = document.getElementById("ac-choiceSetInput-".concat(_this._choiceSetId, "-choice-").concat(_this._highlightedChoiceId));
                choice === null || choice === void 0 || choice.click();
            }
        };
        this._dropdown = document.createElement("div");
        this._dropdown.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-dropdown");
        choiceSetContainer.append(this._textInput, this._dropdown);
        this._renderedElement = choiceSetContainer;
    };
    FilteredChoiceSet.prototype.createChoice = function(value, filter, id) {
        var _this = this;
        var choice = document.createElement("span");
        choice.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-choice");
        choice.id = "ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id);
        choice.innerHTML = value.replace(filter, "<b>".concat(filter, "</b>"));
        choice.tabIndex = -1;
        choice.onclick = function() {
            choice.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
            _this._highlightedChoiceId = -1;
            if (_this._textInput) {
                _this._textInput.value = choice.innerText;
                _this._textInput.focus();
            }
            if (_this._dropdown) _this._dropdown.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
        };
        choice.onmousemove = function() {
            if (_this._highlightedChoiceId !== id) _this.highlightChoice(id, false);
        };
        return choice;
    };
    FilteredChoiceSet.prototype.highlightChoice = function(id, scrollIntoView) {
        if (scrollIntoView === void 0) scrollIntoView = true;
        if (this._visibleChoiceCount > 0) {
            var currentHighlightedChoice = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(this._highlightedChoiceId));
            var nextHighlightedChoice = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id));
            if (nextHighlightedChoice) {
                currentHighlightedChoice === null || currentHighlightedChoice === void 0 || currentHighlightedChoice.classList.remove(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
                nextHighlightedChoice.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
                if (scrollIntoView) nextHighlightedChoice.scrollIntoView();
                this._highlightedChoiceId = id;
            } else if (currentHighlightedChoice && this._highlightedChoiceId !== 0) this.highlightChoice(0);
            else this.highlightChoice(this._visibleChoiceCount - 1);
        }
    };
    FilteredChoiceSet.prototype.filterChoices = function() {
        var _a, _b;
        var filter = ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value.toLowerCase().trim()) || "";
        var choices = $d8c6eedade336127$var$__spreadArray($d8c6eedade336127$var$__spreadArray([], this._choices, true), this._dynamicChoices, true);
        for(var _i = 0, choices_1 = choices; _i < choices_1.length; _i++){
            var choice = choices_1[_i];
            if (choice.title) {
                var matchIndex = choice.title.toLowerCase().indexOf(filter);
                if (matchIndex !== -1) {
                    var matchedText = choice.title.substring(matchIndex, matchIndex + filter.length);
                    var choiceContainer = this.createChoice(choice.title, matchedText, this._visibleChoiceCount++);
                    (_b = this._dropdown) === null || _b === void 0 || _b.appendChild(choiceContainer);
                }
            }
        }
    };
    FilteredChoiceSet.prototype.getStatusIndicator = function(error) {
        if (error) {
            if (!this._errorIndicator) {
                var errorIndicator = document.createElement("div");
                errorIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator", "ac-choiceSetInput-errorIndicator");
                this._errorIndicator = errorIndicator;
            }
            this._errorIndicator.innerText = error;
            return this._errorIndicator;
        } else {
            if (!this._loadingIndicator) {
                var loadingIndicator = document.createElement("div");
                loadingIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator");
                this._loadingIndicator = loadingIndicator;
            }
            this._loadingIndicator.innerText = this._visibleChoiceCount === 0 ? "Loading..." : "Loading more...";
            return this._loadingIndicator;
        }
    };
    FilteredChoiceSet.prototype.resetDropdown = function() {
        if (this._dropdown) {
            $6EfR6.clearElementChildren(this._dropdown);
            this._visibleChoiceCount = 0;
            this._highlightedChoiceId = -1;
        }
    };
    FilteredChoiceSet.prototype.showDropdown = function() {
        var _a;
        if ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.hasChildNodes()) this._dropdown.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
    };
    FilteredChoiceSet.prototype.processChoices = function() {
        this.resetDropdown();
        this.filterChoices();
        this.showDropdown();
    };
    FilteredChoiceSet.prototype.processResponse = function(filter, fetchedChoices) {
        var _a;
        if (filter === ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value)) {
            this.resetDropdown();
            this._dynamicChoices = fetchedChoices;
            this.filterChoices();
            if (this._visibleChoiceCount === 0) this.showErrorIndicator(filter, "No results found");
        }
    };
    FilteredChoiceSet.prototype.showLoadingIndicator = function() {
        var _a;
        var loadingIndicator = this.getStatusIndicator();
        (_a = this._dropdown) === null || _a === void 0 || _a.appendChild(loadingIndicator);
        this.showDropdown();
    };
    FilteredChoiceSet.prototype.removeLoadingIndicator = function() {
        var _a, _b;
        if (this._loadingIndicator && ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.contains(this._loadingIndicator))) (_b = this._dropdown) === null || _b === void 0 || _b.removeChild(this._loadingIndicator);
    };
    FilteredChoiceSet.prototype.showErrorIndicator = function(filter, error) {
        var _a, _b;
        if (filter === ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value)) {
            this.processChoices();
            var errorIndicator = this.getStatusIndicator(error);
            (_b = this._dropdown) === null || _b === void 0 || _b.appendChild(errorIndicator);
            errorIndicator.scrollIntoView();
        }
    };
    Object.defineProperty(FilteredChoiceSet.prototype, "dynamicChoices", {
        get: function() {
            var _a;
            return (_a = this._dynamicChoices) === null || _a === void 0 ? void 0 : _a.map(function(choice) {
                return choice.title;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "hostConfig", {
        get: function() {
            if (this._hostConfig) return this._hostConfig;
            else {
                if (this.parent) return this.parent.hostConfig;
                else return $icYWo.defaultHostConfig;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        set: function(value) {
            this._parent = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "renderedElement", {
        get: function() {
            return this._renderedElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "textInput", {
        get: function() {
            return this._textInput;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilteredChoiceSet.prototype, "dropdown", {
        get: function() {
            return this._dropdown;
        },
        enumerable: false,
        configurable: true
    });
    return FilteredChoiceSet;
}();
module.exports.FilteredChoiceSet = $d8c6eedade336127$var$FilteredChoiceSet;
var $d8c6eedade336127$var$NumberInput = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(NumberInput, _super);
    function NumberInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberInput.prototype.internalRender = function() {
        var _this = this;
        this._numberInputElement = document.createElement("input");
        this._numberInputElement.setAttribute("type", "number");
        if (this.min !== undefined) this._numberInputElement.setAttribute("min", this.min.toString());
        if (this.max !== undefined) this._numberInputElement.setAttribute("max", this.max.toString());
        this._numberInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-numberInput");
        this._numberInputElement.style.width = "100%";
        this._numberInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue !== undefined) this._numberInputElement.valueAsNumber = this.defaultValue;
        if (this.placeholder) {
            this._numberInputElement.placeholder = this.placeholder;
            this._numberInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._numberInputElement.oninput = function() {
            _this.valueChanged();
        };
        return this._numberInputElement;
    };
    NumberInput.prototype.getJsonTypeName = function() {
        return "Input.Number";
    };
    NumberInput.prototype.isSet = function() {
        return this.value !== undefined && !isNaN(this.value);
    };
    NumberInput.prototype.isValid = function() {
        if (this.value === undefined) return !this.isRequired;
        var result = true;
        if (this.min !== undefined) result = result && this.value >= this.min;
        if (this.max !== undefined) result = result && this.value <= this.max;
        return result;
    };
    Object.defineProperty(NumberInput.prototype, "value", {
        get: function() {
            return this._numberInputElement ? this._numberInputElement.valueAsNumber : undefined;
        },
        set: function(value) {
            if (value && this._numberInputElement) this._numberInputElement.value = value.toString();
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    NumberInput.valueProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_0, "value");
    NumberInput.placeholderProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "placeholder");
    NumberInput.minProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_0, "min");
    NumberInput.maxProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_0, "max");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(NumberInput.valueProperty)
    ], NumberInput.prototype, "defaultValue", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(NumberInput.minProperty)
    ], NumberInput.prototype, "min", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(NumberInput.maxProperty)
    ], NumberInput.prototype, "max", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(NumberInput.placeholderProperty)
    ], NumberInput.prototype, "placeholder", void 0);
    return NumberInput;
}($d8c6eedade336127$var$Input);
module.exports.NumberInput = $d8c6eedade336127$var$NumberInput;
var $d8c6eedade336127$var$DateInput = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(DateInput, _super);
    function DateInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateInput.prototype.internalRender = function() {
        var _this = this;
        this._dateInputElement = document.createElement("input");
        this._dateInputElement.setAttribute("type", "date");
        if (this.min) this._dateInputElement.setAttribute("min", this.min);
        if (this.max) this._dateInputElement.setAttribute("max", this.max);
        if (this.placeholder) {
            this._dateInputElement.placeholder = this.placeholder;
            this._dateInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._dateInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        this._dateInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-dateInput");
        this._dateInputElement.style.width = "100%";
        this._dateInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.defaultValue) this._dateInputElement.value = this.defaultValue;
        return this._dateInputElement;
    };
    DateInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        _super.prototype.updateVisualState.call(this, eventType);
        if (this._dateInputElement && this.inputStyle === $4uYwi.InputStyle.RevealOnHover) {
            var hideDatePicker = this.shouldHideInputAdornersForRevealOnHover(this._dateInputElement, eventType);
            if (hideDatePicker) this._dateInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            else this._dateInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            $d8c6eedade336127$var$updateInputAdornersVisibility(this._dateInputElement, hideDatePicker /*hide*/ );
        }
    };
    DateInput.prototype.getJsonTypeName = function() {
        return "Input.Date";
    };
    DateInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    DateInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = new Date(this.value);
        var result = true;
        if (this.min) {
            var minDate = new Date(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = new Date(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(DateInput.prototype, "value", {
        get: function() {
            return this._dateInputElement ? this._dateInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    DateInput.valueProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "value");
    DateInput.placeholderProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "placeholder");
    DateInput.minProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "min");
    DateInput.maxProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "max");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(DateInput.valueProperty)
    ], DateInput.prototype, "defaultValue", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(DateInput.minProperty)
    ], DateInput.prototype, "min", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(DateInput.maxProperty)
    ], DateInput.prototype, "max", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(DateInput.placeholderProperty)
    ], DateInput.prototype, "placeholder", void 0);
    return DateInput;
}($d8c6eedade336127$var$Input);
module.exports.DateInput = $d8c6eedade336127$var$DateInput;
var $d8c6eedade336127$var$TimeProperty = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(TimeProperty, _super);
    function TimeProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, function(sender, prop, source, context) {
            var value = source[prop.name];
            if (typeof value === "string" && value && /^[0-9]{2}:[0-9]{2}$/.test(value)) return value;
            return undefined;
        }, function(sender, prop, target, value, context) {
            context.serializeValue(target, prop.name, value);
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    return TimeProperty;
}($dA5cX.CustomProperty);
module.exports.TimeProperty = $d8c6eedade336127$var$TimeProperty;
var $d8c6eedade336127$var$TimeInput = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(TimeInput, _super);
    function TimeInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeInput.convertTimeStringToDate = function(timeString) {
        return new Date("1973-09-04T" + timeString + ":00Z");
    };
    TimeInput.prototype.internalRender = function() {
        var _this = this;
        this._timeInputElement = document.createElement("input");
        this._timeInputElement.setAttribute("type", "time");
        if (this.min) this._timeInputElement.setAttribute("min", this.min);
        if (this.max) this._timeInputElement.setAttribute("max", this.max);
        this._timeInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-timeInput");
        this._timeInputElement.style.width = "100%";
        this._timeInputElement.oninput = function() {
            _this.valueChanged();
        };
        if (this.placeholder) {
            this._timeInputElement.placeholder = this.placeholder;
            this._timeInputElement.setAttribute("aria-label", this.placeholder);
        }
        this._timeInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
        if (this.defaultValue) this._timeInputElement.value = this.defaultValue;
        return this._timeInputElement;
    };
    TimeInput.prototype.updateVisualState = function(eventType) {
        if (!this.allowRevealOnHoverStyle) return;
        _super.prototype.updateVisualState.call(this, eventType);
        if (this._timeInputElement && this.inputStyle === $4uYwi.InputStyle.RevealOnHover) {
            var hideTimePicker = this.shouldHideInputAdornersForRevealOnHover(this._timeInputElement, eventType);
            if (hideTimePicker) this._timeInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            else this._timeInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
            $d8c6eedade336127$var$updateInputAdornersVisibility(this._timeInputElement, hideTimePicker /*hide*/ );
        }
    };
    TimeInput.prototype.getJsonTypeName = function() {
        return "Input.Time";
    };
    TimeInput.prototype.isSet = function() {
        return this.value ? true : false;
    };
    TimeInput.prototype.isValid = function() {
        if (!this.value) return !this.isRequired;
        var valueAsDate = TimeInput.convertTimeStringToDate(this.value);
        var result = true;
        if (this.min) {
            var minDate = TimeInput.convertTimeStringToDate(this.min);
            result = result && valueAsDate >= minDate;
        }
        if (this.max) {
            var maxDate = TimeInput.convertTimeStringToDate(this.max);
            result = result && valueAsDate <= maxDate;
        }
        return result;
    };
    Object.defineProperty(TimeInput.prototype, "value", {
        get: function() {
            return this._timeInputElement ? this._timeInputElement.value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TimeInput.valueProperty = new $d8c6eedade336127$var$TimeProperty($dA5cX.Versions.v1_0, "value");
    TimeInput.placeholderProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "placeholder");
    TimeInput.minProperty = new $d8c6eedade336127$var$TimeProperty($dA5cX.Versions.v1_0, "min");
    TimeInput.maxProperty = new $d8c6eedade336127$var$TimeProperty($dA5cX.Versions.v1_0, "max");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TimeInput.valueProperty)
    ], TimeInput.prototype, "defaultValue", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TimeInput.minProperty)
    ], TimeInput.prototype, "min", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TimeInput.maxProperty)
    ], TimeInput.prototype, "max", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TimeInput.placeholderProperty)
    ], TimeInput.prototype, "placeholder", void 0);
    return TimeInput;
}($d8c6eedade336127$var$Input);
module.exports.TimeInput = $d8c6eedade336127$var$TimeInput;
var $d8c6eedade336127$var$Action = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(Action, _super);
    function Action() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = $4uYwi.ActionStyle.Default;
        _this.mode = $4uYwi.ActionMode.Primary;
        _this._state = 0 /* Normal */ ;
        _this._isFocusable = true;
        return _this;
    }
    //#endregion
    Action.prototype.renderButtonContent = function() {
        if (this.renderedElement) {
            // Cache hostConfig for perf
            var hostConfig = this.hostConfig;
            var titleElement = document.createElement("div");
            titleElement.style.overflow = "hidden";
            titleElement.style.textOverflow = "ellipsis";
            if (!(hostConfig.actions.iconPlacement === $4uYwi.ActionIconPlacement.AboveTitle || hostConfig.actions.allowTitleToWrap)) titleElement.style.whiteSpace = "nowrap";
            if (this.title) titleElement.innerText = this.title;
            if (!this.iconUrl) {
                this.renderedElement.classList.add("noIcon");
                this.renderedElement.appendChild(titleElement);
            } else {
                var iconElement = document.createElement("img");
                iconElement.src = this.iconUrl;
                iconElement.style.width = hostConfig.actions.iconSize + "px";
                iconElement.style.height = hostConfig.actions.iconSize + "px";
                iconElement.style.flex = "0 0 auto";
                if (hostConfig.actions.iconPlacement === $4uYwi.ActionIconPlacement.AboveTitle) {
                    this.renderedElement.classList.add("iconAbove");
                    this.renderedElement.style.flexDirection = "column";
                    if (this.title) iconElement.style.marginBottom = "6px";
                } else {
                    this.renderedElement.classList.add("iconLeft");
                    iconElement.style.maxHeight = "100%";
                    if (this.title) iconElement.style.marginRight = "6px";
                }
                this.renderedElement.appendChild(iconElement);
                this.renderedElement.appendChild(titleElement);
            }
        }
    };
    Action.prototype.getParentContainer = function() {
        if (this.parent instanceof $d8c6eedade336127$var$Container) return this.parent;
        return this.parent ? this.parent.getParentContainer() : undefined;
    };
    Action.prototype.isDesignMode = function() {
        var rootElement = this.getRootObject();
        return rootElement instanceof $d8c6eedade336127$var$CardElement && rootElement.isDesignMode();
    };
    Action.prototype.updateCssClasses = function() {
        var _a, _b;
        if (this.parent && this.renderedElement) {
            var hostConfig = this.parent.hostConfig;
            this.renderedElement.className = hostConfig.makeCssClassName(this.isEffectivelyEnabled() ? "ac-pushButton" : "ac-pushButton-disabled");
            var parentContainer = this.getParentContainer();
            if (parentContainer) {
                var parentContainerStyle = parentContainer.getEffectiveStyle();
                if (parentContainerStyle) this.renderedElement.classList.add("style-" + parentContainerStyle);
            }
            this.renderedElement.tabIndex = !this.isDesignMode() && this.isFocusable ? 0 : -1;
            switch(this._state){
                case 0 /* Normal */ :
                    break;
                case 1 /* Expanded */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("expanded"));
                    break;
                case 2 /* Subdued */ :
                    this.renderedElement.classList.add(hostConfig.makeCssClassName("subdued"));
                    break;
            }
            if (this.style && this.isEffectivelyEnabled()) {
                if (this.style === $4uYwi.ActionStyle.Positive) (_a = this.renderedElement.classList).add.apply(_a, hostConfig.makeCssClassNames("primary", "style-positive"));
                else (_b = this.renderedElement.classList).add.apply(_b, hostConfig.makeCssClassNames("style-" + this.style.toLowerCase()));
            }
        }
    };
    Action.prototype.getDefaultSerializationContext = function() {
        return new $d8c6eedade336127$var$SerializationContext();
    };
    Action.prototype.internalGetReferencedInputs = function() {
        return {};
    };
    Action.prototype.internalPrepareForExecution = function(_inputs) {
    // Do nothing in base implementation
    };
    Action.prototype.internalValidateInputs = function(referencedInputs) {
        var result = [];
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (!input.validateValue()) result.push(input);
        }
        return result;
    };
    Action.prototype.shouldSerialize = function(context) {
        return context.actionRegistry.findByName(this.getJsonTypeName()) !== undefined;
    };
    Action.prototype.raiseExecuteActionEvent = function() {
        if (this.onExecute) this.onExecute(this);
        $d8c6eedade336127$var$raiseExecuteActionEvent(this);
    };
    Action.prototype.internalAfterExecute = function() {
        var rootObject = this.getRootObject();
        if (rootObject instanceof $d8c6eedade336127$var$CardElement) rootObject.updateActionsEnabledState();
    };
    Action.prototype.getHref = function() {
        return "";
    };
    Action.prototype.getAriaRole = function() {
        var ariaRole = this.getAriaRoleFromEnum();
        return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "button";
    };
    Action.prototype.getAriaRoleFromEnum = function() {
        switch(this.role){
            case $4uYwi.ActionRole.Button:
                return "button";
            case $4uYwi.ActionRole.Link:
                return "link";
            case $4uYwi.ActionRole.Menu:
                return "menu";
            case $4uYwi.ActionRole.MenuItem:
                return "menuitem";
            case $4uYwi.ActionRole.Tab:
                return "tab";
            default:
                return undefined;
        }
    };
    Action.prototype.setupElementForAccessibility = function(element, promoteTooltipToLabel) {
        if (promoteTooltipToLabel === void 0) promoteTooltipToLabel = false;
        element.tabIndex = this.isEffectivelyEnabled() && !this.isDesignMode() ? 0 : -1;
        element.setAttribute("role", this.getAriaRole());
        if (element instanceof HTMLButtonElement) element.disabled = !this.isEffectivelyEnabled();
        if (!this.isEffectivelyEnabled()) element.setAttribute("aria-disabled", "true");
        else {
            element.removeAttribute("aria-disabled");
            element.classList.add(this.hostConfig.makeCssClassName("ac-selectable"));
        }
        if (this.title) {
            element.setAttribute("aria-label", this.title);
            element.title = this.title;
        } else {
            element.removeAttribute("aria-label");
            element.removeAttribute("title");
        }
        if (this.tooltip) {
            if (promoteTooltipToLabel && !this.title) element.setAttribute("aria-label", this.tooltip);
            element.title = this.tooltip;
        }
    };
    Action.prototype.parse = function(source, context) {
        return _super.prototype.parse.call(this, source, context ? context : new $d8c6eedade336127$var$SerializationContext());
    };
    Action.prototype.render = function() {
        var _this = this;
        var buttonElement = document.createElement("button");
        buttonElement.type = "button";
        buttonElement.style.display = "flex";
        buttonElement.style.alignItems = "center";
        buttonElement.style.justifyContent = "center";
        buttonElement.onclick = function(e) {
            if (_this.isEffectivelyEnabled()) {
                e.preventDefault();
                e.cancelBubble = true;
                _this.execute();
            }
        };
        this._renderedElement = buttonElement;
        this.renderButtonContent();
        this.updateCssClasses();
        this.setupElementForAccessibility(buttonElement);
    };
    Action.prototype.execute = function() {
        if (this._actionCollection) this._actionCollection.actionExecuted(this);
        this.raiseExecuteActionEvent();
        this.internalAfterExecute();
    };
    Action.prototype.prepareForExecution = function() {
        var referencedInputs = this.getReferencedInputs();
        var invalidInputs = this.internalValidateInputs(referencedInputs);
        if (invalidInputs.length > 0) {
            invalidInputs[0].focus();
            return false;
        }
        this.internalPrepareForExecution(referencedInputs);
        return true;
    };
    Action.prototype.remove = function() {
        if (this._actionCollection) return this._actionCollection.removeAction(this);
        return false;
    };
    Action.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return [];
    };
    Action.prototype.getAllActions = function() {
        return [
            this
        ];
    };
    Action.prototype.getResourceInformation = function() {
        return this.iconUrl ? [
            {
                url: this.iconUrl,
                mimeType: "image"
            }
        ] : [];
    };
    Action.prototype.getActionById = function(id) {
        return this.id === id ? this : undefined;
    };
    Action.prototype.getReferencedInputs = function() {
        return this.internalGetReferencedInputs();
    };
    /**
     * Validates the inputs associated with this action.
     *
     * @returns A list of inputs that failed validation, or an empty array if no input failed validation.
     */ Action.prototype.validateInputs = function() {
        return this.internalValidateInputs(this.getReferencedInputs());
    };
    Action.prototype.updateEnabledState = function() {
    // Do nothing in base implementation
    };
    Action.prototype.isEffectivelyEnabled = function() {
        return this.isEnabled;
    };
    Object.defineProperty(Action.prototype, "isPrimary", {
        get: function() {
            return this.style === $4uYwi.ActionStyle.Positive;
        },
        set: function(value) {
            if (value) this.style = $4uYwi.ActionStyle.Positive;
            else if (this.style === $4uYwi.ActionStyle.Positive) this.style = $4uYwi.ActionStyle.Default;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "hostConfig", {
        get: function() {
            return this.parent ? this.parent.hostConfig : $icYWo.defaultHostConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "state", {
        get: function() {
            return this._state;
        },
        set: function(value) {
            if (this._state !== value) {
                this._state = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Action.prototype, "isFocusable", {
        get: function() {
            return this._isFocusable;
        },
        set: function(value) {
            if (this._isFocusable !== value) {
                this._isFocusable = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    Action.titleProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "title");
    Action.iconUrlProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_1, "iconUrl");
    Action.styleProperty = new $dA5cX.ValueSetProperty($dA5cX.Versions.v1_2, "style", [
        {
            value: $4uYwi.ActionStyle.Default
        },
        {
            value: $4uYwi.ActionStyle.Positive
        },
        {
            value: $4uYwi.ActionStyle.Destructive
        }
    ], $4uYwi.ActionStyle.Default);
    Action.modeProperty = new $dA5cX.ValueSetProperty($dA5cX.Versions.v1_5, "mode", [
        {
            value: $4uYwi.ActionMode.Primary
        },
        {
            value: $4uYwi.ActionMode.Secondary
        }
    ], $4uYwi.ActionMode.Primary);
    Action.tooltipProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_5, "tooltip");
    Action.isEnabledProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_5, "isEnabled", true);
    Action.roleProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_6, "role", $4uYwi.ActionRole);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Action.titleProperty)
    ], Action.prototype, "title", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Action.iconUrlProperty)
    ], Action.prototype, "iconUrl", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Action.styleProperty)
    ], Action.prototype, "style", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Action.modeProperty)
    ], Action.prototype, "mode", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Action.tooltipProperty)
    ], Action.prototype, "tooltip", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Action.isEnabledProperty)
    ], Action.prototype, "isEnabled", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Action.roleProperty)
    ], Action.prototype, "role", void 0);
    return Action;
}($hj3le.CardObject);
module.exports.Action = $d8c6eedade336127$var$Action;
var $d8c6eedade336127$var$SubmitActionBase = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(SubmitActionBase, _super);
    function SubmitActionBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabledUnlessAssociatedInputsChange = false;
        //#endregion
        _this._isPrepared = false;
        _this._areReferencedInputsDirty = false;
        return _this;
    }
    SubmitActionBase.prototype.internalGetReferencedInputs = function() {
        var result = {};
        if (this.associatedInputs !== "none") {
            var current = this.parent;
            var inputs = [];
            while(current){
                inputs.push.apply(inputs, current.getAllInputs(false));
                current = current.parent;
            }
            for(var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++){
                var input = inputs_1[_i];
                if (input.id) result[input.id] = input;
            }
        }
        return result;
    };
    SubmitActionBase.prototype.internalPrepareForExecution = function(inputs) {
        if (this._originalData) this._processedData = JSON.parse(JSON.stringify(this._originalData));
        else this._processedData = {};
        if (this._processedData && inputs) for(var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = inputs[key];
            if (input.id && input.isSet()) this._processedData[input.id] = typeof input.value === "string" ? input.value : input.value.toString();
        }
        this._isPrepared = true;
    };
    SubmitActionBase.prototype.internalAfterExecute = function() {
        if ($krmaK.GlobalSettings.resetInputsDirtyStateAfterActionExecution) this.resetReferencedInputsDirtyState();
    };
    SubmitActionBase.prototype.resetReferencedInputsDirtyState = function() {
        var referencedInputs = this.getReferencedInputs();
        this._areReferencedInputsDirty = false;
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            input.resetDirtyState();
        }
    };
    SubmitActionBase.prototype.updateEnabledState = function() {
        this._areReferencedInputsDirty = false;
        var referencedInputs = this.getReferencedInputs();
        if (referencedInputs) for(var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++){
            var key = _a[_i];
            var input = referencedInputs[key];
            if (input.isDirty()) {
                this._areReferencedInputsDirty = true;
                break;
            }
        }
        this.updateCssClasses();
        if (this._renderedElement) this.setupElementForAccessibility(this._renderedElement);
    };
    SubmitActionBase.prototype.isEffectivelyEnabled = function() {
        var result = _super.prototype.isEffectivelyEnabled.call(this);
        return this.disabledUnlessAssociatedInputsChange ? result && this._areReferencedInputsDirty : result;
    };
    Object.defineProperty(SubmitActionBase.prototype, "data", {
        get: function() {
            return this._isPrepared ? this._processedData : this._originalData;
        },
        set: function(value) {
            this._originalData = value;
            this._isPrepared = false;
        },
        enumerable: false,
        configurable: true
    });
    SubmitActionBase.dataProperty = new $dA5cX.PropertyDefinition($dA5cX.Versions.v1_0, "data");
    SubmitActionBase.associatedInputsProperty = new $dA5cX.CustomProperty($dA5cX.Versions.v1_3, "associatedInputs", function(sender, prop, source, context) {
        var value = source[prop.name];
        if (value !== undefined && typeof value === "string") return value.toLowerCase() === "none" ? "none" : "auto";
        return undefined;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, value);
    });
    SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_6, "disabledUnlessAssociatedInputsChange", false);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(SubmitActionBase.dataProperty)
    ], SubmitActionBase.prototype, "_originalData", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(SubmitActionBase.associatedInputsProperty)
    ], SubmitActionBase.prototype, "associatedInputs", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty)
    ], SubmitActionBase.prototype, "disabledUnlessAssociatedInputsChange", void 0);
    return SubmitActionBase;
}($d8c6eedade336127$var$Action);
module.exports.SubmitActionBase = $d8c6eedade336127$var$SubmitActionBase;
var $d8c6eedade336127$var$SubmitAction = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(SubmitAction, _super);
    function SubmitAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubmitAction.prototype.getJsonTypeName = function() {
        return SubmitAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    SubmitAction.JsonTypeName = "Action.Submit";
    return SubmitAction;
}($d8c6eedade336127$var$SubmitActionBase);
module.exports.SubmitAction = $d8c6eedade336127$var$SubmitAction;
var $d8c6eedade336127$var$UniversalAction = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(UniversalAction, _super);
    function UniversalAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UniversalAction;
}($d8c6eedade336127$var$SubmitActionBase);
module.exports.UniversalAction = $d8c6eedade336127$var$UniversalAction;
var $d8c6eedade336127$var$ExecuteAction = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ExecuteAction, _super);
    function ExecuteAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    ExecuteAction.prototype.getJsonTypeName = function() {
        return ExecuteAction.JsonTypeName;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ExecuteAction.JsonTypeName = "Action.Execute";
    //#region Schema
    ExecuteAction.verbProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "verb");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ExecuteAction.verbProperty)
    ], ExecuteAction.prototype, "verb", void 0);
    return ExecuteAction;
}($d8c6eedade336127$var$UniversalAction);
module.exports.ExecuteAction = $d8c6eedade336127$var$ExecuteAction;
var $d8c6eedade336127$var$DataQuery = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(DataQuery, _super);
    function DataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    DataQuery.prototype.getJsonTypeName = function() {
        return DataQuery.JsonTypeName;
    };
    Object.defineProperty(DataQuery.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    DataQuery.JsonTypeName = "Data.Query";
    //#region Schema
    DataQuery.datasetProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_6, "dataset");
    DataQuery.filterProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_6, "filter");
    DataQuery.countProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_6, "count");
    DataQuery.skipProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_6, "skip");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(DataQuery.datasetProperty)
    ], DataQuery.prototype, "dataset", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(DataQuery.filterProperty)
    ], DataQuery.prototype, "filter", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(DataQuery.countProperty)
    ], DataQuery.prototype, "count", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(DataQuery.skipProperty)
    ], DataQuery.prototype, "skip", void 0);
    return DataQuery;
}($d8c6eedade336127$var$UniversalAction);
module.exports.DataQuery = $d8c6eedade336127$var$DataQuery;
var $d8c6eedade336127$var$OpenUrlAction = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(OpenUrlAction, _super);
    function OpenUrlAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenUrlAction.prototype.getJsonTypeName = function() {
        return OpenUrlAction.JsonTypeName;
    };
    OpenUrlAction.prototype.getAriaRole = function() {
        var ariaRole = this.getAriaRoleFromEnum();
        return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "link";
    };
    OpenUrlAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $4uYwi.ValidationEvent.PropertyCantBeNull, $luP4B.Strings.errors.propertyMustBeSet("url"));
    };
    OpenUrlAction.prototype.getHref = function() {
        return this.url;
    };
    //#region Schema
    OpenUrlAction.urlProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "url");
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    OpenUrlAction.JsonTypeName = "Action.OpenUrl";
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(OpenUrlAction.urlProperty)
    ], OpenUrlAction.prototype, "url", void 0);
    return OpenUrlAction;
}($d8c6eedade336127$var$Action);
module.exports.OpenUrlAction = $d8c6eedade336127$var$OpenUrlAction;
var $d8c6eedade336127$var$ToggleVisibilityAction = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ToggleVisibilityAction, _super);
    function ToggleVisibilityAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.targetElements = {};
        return _this;
    }
    ToggleVisibilityAction.prototype.updateAriaControlsAttribute = function() {
        // apply aria labels to make it clear which elements this action will toggle
        if (this.targetElements) {
            var elementIds = Object.keys(this.targetElements);
            if (this._renderedElement) {
                if (elementIds.length > 0) this._renderedElement.setAttribute("aria-controls", elementIds.join(" "));
                else this._renderedElement.removeAttribute("aria-controls");
            }
        }
    };
    ToggleVisibilityAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.targetElements) context.addFailure(this, $4uYwi.ValidationEvent.PropertyCantBeNull, $luP4B.Strings.errors.propertyMustBeSet("targetElements"));
    };
    ToggleVisibilityAction.prototype.getJsonTypeName = function() {
        return ToggleVisibilityAction.JsonTypeName;
    };
    ToggleVisibilityAction.prototype.render = function() {
        _super.prototype.render.call(this);
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.execute = function() {
        _super.prototype.execute.call(this);
        if (this.parent) for(var _i = 0, _a = Object.keys(this.targetElements); _i < _a.length; _i++){
            var elementId = _a[_i];
            var targetElement = this.parent.getRootElement().getElementById(elementId);
            if (targetElement) {
                if (typeof this.targetElements[elementId] === "boolean") targetElement.isVisible = this.targetElements[elementId];
                else targetElement.isVisible = !targetElement.isVisible;
            }
        }
    };
    ToggleVisibilityAction.prototype.addTargetElement = function(elementId, isVisible) {
        if (isVisible === void 0) isVisible = undefined;
        this.targetElements[elementId] = isVisible;
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.prototype.removeTargetElement = function(elementId) {
        delete this.targetElements[elementId];
        this.updateAriaControlsAttribute();
    };
    ToggleVisibilityAction.targetElementsProperty = new $dA5cX.CustomProperty($dA5cX.Versions.v1_2, "targetElements", function(sender, prop, source, context) {
        var result = {};
        if (Array.isArray(source[prop.name])) for(var _i = 0, _a = source[prop.name]; _i < _a.length; _i++){
            var item = _a[_i];
            if (typeof item === "string") result[item] = undefined;
            else if (typeof item === "object") {
                var elementId = item["elementId"];
                if (typeof elementId === "string") result[elementId] = $6EfR6.parseBool(item["isVisible"]);
            }
        }
        return result;
    }, function(sender, prop, target, value, context) {
        var targetElements = [];
        for(var _i = 0, _a = Object.keys(value); _i < _a.length; _i++){
            var id = _a[_i];
            if (typeof value[id] === "boolean") targetElements.push({
                elementId: id,
                isVisible: value[id]
            });
            else targetElements.push(id);
        }
        context.serializeArray(target, prop.name, targetElements);
    }, {}, function(sender) {
        return {};
    });
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ToggleVisibilityAction.JsonTypeName = "Action.ToggleVisibility";
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ToggleVisibilityAction.targetElementsProperty)
    ], ToggleVisibilityAction.prototype, "targetElements", void 0);
    return ToggleVisibilityAction;
}($d8c6eedade336127$var$Action);
module.exports.ToggleVisibilityAction = $d8c6eedade336127$var$ToggleVisibilityAction;
var $d8c6eedade336127$var$StringWithSubstitutionProperty = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(StringWithSubstitutionProperty, _super);
    function StringWithSubstitutionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined, function() {
            return new $krmaK.StringWithSubstitutions();
        }) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    StringWithSubstitutionProperty.prototype.parse = function(sender, source, context) {
        var result = new $krmaK.StringWithSubstitutions();
        result.set($6EfR6.parseString(source[this.name]));
        return result;
    };
    StringWithSubstitutionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value.getOriginal());
    };
    return StringWithSubstitutionProperty;
}($dA5cX.PropertyDefinition);
var $d8c6eedade336127$var$HttpHeader = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(HttpHeader, _super);
    //#endregion
    function HttpHeader(name, value) {
        if (name === void 0) name = "";
        if (value === void 0) value = "";
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    HttpHeader.prototype.getSchemaKey = function() {
        return "HttpHeader";
    };
    HttpHeader.prototype.getReferencedInputs = function(inputs, referencedInputs) {
        this._value.getReferencedInputs(inputs, referencedInputs);
    };
    HttpHeader.prototype.prepareForExecution = function(inputs) {
        this._value.substituteInputValues(inputs, $krmaK.ContentTypes.applicationXWwwFormUrlencoded);
    };
    Object.defineProperty(HttpHeader.prototype, "value", {
        get: function() {
            return this._value.get();
        },
        set: function(newValue) {
            this._value.set(newValue);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    HttpHeader.nameProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "name");
    HttpHeader.valueProperty = new $d8c6eedade336127$var$StringWithSubstitutionProperty($dA5cX.Versions.v1_0, "value");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(HttpHeader.nameProperty)
    ], HttpHeader.prototype, "name", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(HttpHeader.valueProperty)
    ], HttpHeader.prototype, "_value", void 0);
    return HttpHeader;
}($dA5cX.SerializableObject);
module.exports.HttpHeader = $d8c6eedade336127$var$HttpHeader;
var $d8c6eedade336127$var$HttpAction = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(HttpAction, _super);
    function HttpAction() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._ignoreInputValidation = false;
        return _this;
    }
    HttpAction.prototype.internalGetReferencedInputs = function() {
        var allInputs = this.parent ? this.parent.getRootElement().getAllInputs() : [];
        var result = {};
        this._url.getReferencedInputs(allInputs, result);
        for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            header.getReferencedInputs(allInputs, result);
        }
        this._body.getReferencedInputs(allInputs, result);
        return result;
    };
    HttpAction.prototype.internalPrepareForExecution = function(inputs) {
        if (inputs) {
            this._url.substituteInputValues(inputs, $krmaK.ContentTypes.applicationXWwwFormUrlencoded);
            var contentType = $krmaK.ContentTypes.applicationJson;
            for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
                var header = _a[_i];
                header.prepareForExecution(inputs);
                if (header.name && header.name.toLowerCase() === "content-type") contentType = header.value;
            }
            this._body.substituteInputValues(inputs, contentType);
        }
    };
    HttpAction.prototype.getJsonTypeName = function() {
        return HttpAction.JsonTypeName;
    };
    HttpAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (!this.url) context.addFailure(this, $4uYwi.ValidationEvent.PropertyCantBeNull, $luP4B.Strings.errors.propertyMustBeSet("url"));
        if (this.headers.length > 0) for(var _i = 0, _a = this.headers; _i < _a.length; _i++){
            var header = _a[_i];
            if (!header.name) context.addFailure(this, $4uYwi.ValidationEvent.PropertyCantBeNull, $luP4B.Strings.errors.actionHttpHeadersMustHaveNameAndValue());
        }
    };
    Object.defineProperty(HttpAction.prototype, "ignoreInputValidation", {
        get: function() {
            return this._ignoreInputValidation;
        },
        set: function(value) {
            this._ignoreInputValidation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "url", {
        get: function() {
            return this._url.get();
        },
        set: function(value) {
            this._url.set(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpAction.prototype, "body", {
        get: function() {
            return this._body.get();
        },
        set: function(value) {
            this._body.set(value);
        },
        enumerable: false,
        configurable: true
    });
    HttpAction.urlProperty = new $d8c6eedade336127$var$StringWithSubstitutionProperty($dA5cX.Versions.v1_0, "url");
    HttpAction.bodyProperty = new $d8c6eedade336127$var$StringWithSubstitutionProperty($dA5cX.Versions.v1_0, "body");
    HttpAction.methodProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "method");
    HttpAction.headersProperty = new $dA5cX.SerializableObjectCollectionProperty($dA5cX.Versions.v1_0, "headers", $d8c6eedade336127$var$HttpHeader);
    HttpAction.ignoreInputValidationProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_3, "ignoreInputValidation", false);
    //#endregion
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    HttpAction.JsonTypeName = "Action.Http";
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(HttpAction.urlProperty)
    ], HttpAction.prototype, "_url", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(HttpAction.bodyProperty)
    ], HttpAction.prototype, "_body", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(HttpAction.methodProperty)
    ], HttpAction.prototype, "method", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(HttpAction.headersProperty)
    ], HttpAction.prototype, "headers", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(HttpAction.ignoreInputValidationProperty)
    ], HttpAction.prototype, "_ignoreInputValidation", void 0);
    return HttpAction;
}($d8c6eedade336127$var$Action);
module.exports.HttpAction = $d8c6eedade336127$var$HttpAction;
var $d8c6eedade336127$var$ShowCardAction = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ShowCardAction, _super);
    function ShowCardAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.card = new $d8c6eedade336127$var$InlineAdaptiveCard();
        return _this;
    }
    ShowCardAction.prototype.updateCssClasses = function() {
        _super.prototype.updateCssClasses.call(this);
        if (this.renderedElement) {
            var effectiveHostConfig = this.parent ? this.parent.hostConfig : $icYWo.defaultHostConfig;
            this.renderedElement.classList.add(effectiveHostConfig.makeCssClassName("expandable"));
            this.renderedElement.setAttribute("aria-expanded", (this.state === 1 /* Expanded */ ).toString());
        }
    };
    ShowCardAction.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        var jsonCard = source["card"];
        if (jsonCard) this.card.parse(jsonCard, context);
        else context.logParseEvent(this, $4uYwi.ValidationEvent.PropertyCantBeNull, $luP4B.Strings.errors.showCardMustHaveCard());
    };
    ShowCardAction.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        if (this.card) context.serializeValue(target, "card", this.card.toJSON(context));
    };
    ShowCardAction.prototype.raiseExecuteActionEvent = function() {
        if (this.hostConfig.actions.showCard.actionMode === $4uYwi.ShowCardActionMode.Popup) // Only raise the event in Popup mode.
        _super.prototype.raiseExecuteActionEvent.call(this);
    };
    ShowCardAction.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this.card.releaseDOMResources();
    };
    ShowCardAction.prototype.getJsonTypeName = function() {
        return ShowCardAction.JsonTypeName;
    };
    ShowCardAction.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this.card.internalValidateProperties(context);
    };
    ShowCardAction.prototype.setParent = function(value) {
        _super.prototype.setParent.call(this, value);
        this.card.setParent(value);
    };
    ShowCardAction.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return this.card.getAllInputs(processActions);
    };
    ShowCardAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this.card.getAllActions());
        return result;
    };
    ShowCardAction.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this.card.getResourceInformation());
        return result;
    };
    ShowCardAction.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) result = this.card.getActionById(id);
        return result;
    };
    // Note the "weird" way this field is declared is to work around a breaking
    // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
    ShowCardAction.JsonTypeName = "Action.ShowCard";
    return ShowCardAction;
}($d8c6eedade336127$var$Action);
module.exports.ShowCardAction = $d8c6eedade336127$var$ShowCardAction;
var $d8c6eedade336127$var$OverflowAction = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(OverflowAction, _super);
    function OverflowAction(actions) {
        var _this = _super.call(this) || this;
        _this._actions = actions;
        _this.title = $luP4B.Strings.defaults.overflowButtonText();
        _this.tooltip = $luP4B.Strings.defaults.overflowButtonTooltip();
        return _this;
    }
    OverflowAction.prototype.getActions = function() {
        return this._actions;
    };
    OverflowAction.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        result.push.apply(result, this._actions);
        return result;
    };
    OverflowAction.prototype.getJsonTypeName = function() {
        return $d8c6eedade336127$var$ShowCardAction.JsonTypeName;
    };
    OverflowAction.prototype.execute = function() {
        var _this = this;
        var _a;
        var shouldDisplayPopupMenu = !$d8c6eedade336127$var$raiseDisplayOverflowActionMenuEvent(this, this.renderedElement);
        if (shouldDisplayPopupMenu && this.renderedElement) {
            var contextMenu_1 = new $eH86Z.PopupMenu();
            contextMenu_1.hostConfig = this.hostConfig;
            var _loop_2 = function(i) {
                var menuItem = new $eH86Z.MenuItem(i.toString(), (_a = this_1._actions[i].title) !== null && _a !== void 0 ? _a : "");
                menuItem.isEnabled = this_1._actions[i].isEnabled;
                menuItem.onClick = function() {
                    var actionToExecute = _this._actions[i];
                    contextMenu_1.closePopup(false);
                    if (actionToExecute.isEnabled) actionToExecute.execute();
                };
                contextMenu_1.items.add(menuItem);
            };
            var this_1 = this;
            for(var i = 0; i < this._actions.length; i++)_loop_2(i);
            contextMenu_1.onClose = function() {
                var _a;
                (_a = _this.renderedElement) === null || _a === void 0 || _a.setAttribute("aria-expanded", "false");
            };
            this.renderedElement.setAttribute("aria-expanded", "true");
            contextMenu_1.popup(this.renderedElement);
        }
    };
    OverflowAction.prototype.setupElementForAccessibility = function(element, promoteTooltipToLabel) {
        if (promoteTooltipToLabel === void 0) promoteTooltipToLabel = false;
        _super.prototype.setupElementForAccessibility.call(this, element, promoteTooltipToLabel);
        element.setAttribute("aria-label", $luP4B.Strings.defaults.overflowButtonTooltip());
        element.setAttribute("aria-expanded", "false");
    };
    OverflowAction.JsonTypeName = "Action.Overflow";
    return OverflowAction;
}($d8c6eedade336127$var$Action);
var $d8c6eedade336127$var$ActionCollection = /** @class */ function() {
    function ActionCollection(owner) {
        this._items = [];
        this._renderedActions = [];
        this._owner = owner;
    }
    ActionCollection.prototype.isActionAllowed = function(action) {
        var forbiddenTypes = this._owner.getForbiddenActionTypes();
        if (forbiddenTypes) for(var _i = 0, forbiddenTypes_1 = forbiddenTypes; _i < forbiddenTypes_1.length; _i++){
            var forbiddenType = forbiddenTypes_1[_i];
            if (action.constructor === forbiddenType) return false;
        }
        return true;
    };
    ActionCollection.prototype.refreshContainer = function() {
        $d8c6eedade336127$var$clearElement(this._actionCardContainer);
        if (!this._actionCard) {
            this._actionCardContainer.style.marginTop = "0px";
            return;
        }
        this._actionCardContainer.style.marginTop = this.renderedActionCount > 0 ? this._owner.hostConfig.actions.showCard.inlineTopMargin + "px" : "0px";
        var padding = this._owner.getEffectivePadding();
        this._owner.getImmediateSurroundingPadding(padding);
        var physicalPadding = this._owner.hostConfig.paddingDefinitionToSpacingDefinition(padding);
        if (this._actionCard) {
            this._actionCard.style.paddingLeft = physicalPadding.left + "px";
            this._actionCard.style.paddingRight = physicalPadding.right + "px";
            this._actionCard.style.marginLeft = "-" + physicalPadding.left + "px";
            this._actionCard.style.marginRight = "-" + physicalPadding.right + "px";
            if (physicalPadding.bottom !== 0 && !this._owner.isDesignMode()) {
                this._actionCard.style.paddingBottom = physicalPadding.bottom + "px";
                this._actionCard.style.marginBottom = "-" + physicalPadding.bottom + "px";
            }
            $6EfR6.appendChild(this._actionCardContainer, this._actionCard);
        }
    };
    ActionCollection.prototype.layoutChanged = function() {
        this._owner.getRootElement().updateLayout();
    };
    ActionCollection.prototype.showActionCard = function(action, suppressStyle, raiseEvent) {
        if (suppressStyle === void 0) suppressStyle = false;
        if (raiseEvent === void 0) raiseEvent = true;
        action.card.suppressStyle = suppressStyle;
        // Always re-render a ShowCard action in design mode; reuse already rendered ShowCard (if available) otherwise
        var renderedCard = action.card.renderedElement && !this._owner.isDesignMode() ? action.card.renderedElement : action.card.render();
        this._actionCard = renderedCard;
        this._expandedAction = action;
        this.refreshContainer();
        if (raiseEvent) {
            this.layoutChanged();
            $d8c6eedade336127$var$raiseInlineCardExpandedEvent(action, true);
        }
    };
    ActionCollection.prototype.collapseExpandedAction = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.state = 0 /* Normal */ ;
        }
        var previouslyExpandedAction = this._expandedAction;
        this._expandedAction = undefined;
        this._actionCard = undefined;
        this.refreshContainer();
        if (previouslyExpandedAction) {
            this.layoutChanged();
            $d8c6eedade336127$var$raiseInlineCardExpandedEvent(previouslyExpandedAction, false);
        }
    };
    ActionCollection.prototype.expandShowCardAction = function(action, raiseEvent) {
        var _this = this;
        var afterSelectedAction = false;
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            // Remove actions after selected action from tabOrder if the actions are oriented horizontally, to skip focus directly to expanded card
            if (this._owner.hostConfig.actions.actionsOrientation == $4uYwi.Orientation.Horizontal && afterSelectedAction) renderedAction.isFocusable = false;
            if (renderedAction !== action) renderedAction.state = 2 /* Subdued */ ;
            else {
                renderedAction.state = 1 /* Expanded */ ;
                afterSelectedAction = true;
                if (renderedAction.renderedElement) renderedAction.renderedElement.onblur = function(_e) {
                    for(var _i = 0, _a = _this._renderedActions; _i < _a.length; _i++){
                        var ra = _a[_i];
                        ra.isFocusable = true;
                    }
                };
            }
        }
        this.showActionCard(action, !(this._owner.isAtTheVeryLeft() && this._owner.isAtTheVeryRight()), raiseEvent);
    };
    ActionCollection.prototype.releaseDOMResources = function() {
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var action = _a[_i];
            action.releaseDOMResources();
        }
    };
    ActionCollection.prototype.actionExecuted = function(action) {
        if (!(action instanceof $d8c6eedade336127$var$ShowCardAction)) this.collapseExpandedAction();
        else {
            if (action === this._expandedAction) this.collapseExpandedAction();
            else if (this._owner.hostConfig.actions.showCard.actionMode === $4uYwi.ShowCardActionMode.Inline) this.expandShowCardAction(action, true);
        }
    };
    ActionCollection.prototype.parse = function(source, context) {
        this.clear();
        if (Array.isArray(source)) for(var _i = 0, source_1 = source; _i < source_1.length; _i++){
            var jsonAction = source_1[_i];
            var forbiddenActions = [];
            // If the action owner is a ContainerWithActions, we should check for forbidden actions
            if (this._owner instanceof $d8c6eedade336127$var$ContainerWithActions) forbiddenActions = this._owner.getForbiddenActionNames();
            var action = context.parseAction(this._owner, jsonAction, forbiddenActions, !this._owner.isDesignMode());
            if (action) this.addAction(action);
        }
    };
    ActionCollection.prototype.toJSON = function(target, propertyName, context) {
        context.serializeArray(target, propertyName, this._items);
    };
    ActionCollection.prototype.getActionAt = function(id) {
        return this._items[id];
    };
    ActionCollection.prototype.getActionCount = function() {
        return this._items.length;
    };
    ActionCollection.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            result = item.getActionById(id);
            if (result) break;
        }
        return result;
    };
    ActionCollection.prototype.validateProperties = function(context) {
        if (this._owner.hostConfig.actions.maxActions && this._items.length > this._owner.hostConfig.actions.maxActions) context.addFailure(this._owner, $4uYwi.ValidationEvent.TooManyActions, $luP4B.Strings.errors.tooManyActions(this._owner.hostConfig.actions.maxActions));
        if (this._items.length > 0 && !this._owner.hostConfig.supportsInteractivity) context.addFailure(this._owner, $4uYwi.ValidationEvent.InteractivityNotAllowed, $luP4B.Strings.errors.interactivityNotAllowed());
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (!this.isActionAllowed(item)) context.addFailure(this._owner, $4uYwi.ValidationEvent.ActionTypeNotAllowed, $luP4B.Strings.errors.actionTypeNotAllowed(item.getJsonTypeName()));
            item.internalValidateProperties(context);
        }
    };
    ActionCollection.prototype.render = function(orientation) {
        // Cache hostConfig for better perf
        var hostConfig = this._owner.hostConfig;
        if (!hostConfig.supportsInteractivity) return undefined;
        var element = document.createElement("div");
        var maxActions = hostConfig.actions.maxActions ? Math.min(hostConfig.actions.maxActions, this._items.length) : this._items.length;
        this._actionCardContainer = document.createElement("div");
        this._renderedActions = [];
        if (hostConfig.actions.preExpandSingleShowCardAction && maxActions === 1 && this._items[0] instanceof $d8c6eedade336127$var$ShowCardAction && this.isActionAllowed(this._items[0])) {
            this.showActionCard(this._items[0], true);
            this._renderedActions.push(this._items[0]);
        } else {
            var buttonStrip = document.createElement("div");
            buttonStrip.className = hostConfig.makeCssClassName("ac-actionSet");
            buttonStrip.style.display = "flex";
            if (orientation === $4uYwi.Orientation.Horizontal) {
                buttonStrip.style.flexDirection = "row";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $4uYwi.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $4uYwi.HorizontalAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $4uYwi.HorizontalAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $4uYwi.ActionAlignment.Center:
                        buttonStrip.style.justifyContent = "center";
                        break;
                    case $4uYwi.ActionAlignment.Right:
                        buttonStrip.style.justifyContent = "flex-end";
                        break;
                    default:
                        buttonStrip.style.justifyContent = "flex-start";
                        break;
                }
            } else {
                buttonStrip.style.flexDirection = "column";
                if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== $4uYwi.ActionAlignment.Stretch) switch(this._owner.horizontalAlignment){
                    case $4uYwi.HorizontalAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $4uYwi.HorizontalAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
                else switch(hostConfig.actions.actionAlignment){
                    case $4uYwi.ActionAlignment.Center:
                        buttonStrip.style.alignItems = "center";
                        break;
                    case $4uYwi.ActionAlignment.Right:
                        buttonStrip.style.alignItems = "flex-end";
                        break;
                    case $4uYwi.ActionAlignment.Stretch:
                        buttonStrip.style.alignItems = "stretch";
                        break;
                    default:
                        buttonStrip.style.alignItems = "flex-start";
                        break;
                }
            }
            var allowedActions = this._items.filter(this.isActionAllowed.bind(this));
            var primaryActions_1 = [];
            var secondaryActions_1 = [];
            if (!this._owner.isDesignMode()) {
                allowedActions.forEach(function(action) {
                    return action.mode === $4uYwi.ActionMode.Secondary ? secondaryActions_1.push(action) : primaryActions_1.push(action);
                });
                // If primaryActions.length > maxActions, extra actions are moved to overflow
                var overflowPrimaryActions = primaryActions_1.splice(hostConfig.actions.maxActions);
                if ($krmaK.GlobalSettings.allowMoreThanMaxActionsInOverflowMenu) secondaryActions_1.push.apply(secondaryActions_1, overflowPrimaryActions);
                var shouldRenderOverflowActionButton = true;
                if (secondaryActions_1.length > 0) {
                    if (!this._overflowAction) {
                        this._overflowAction = new $d8c6eedade336127$var$OverflowAction(secondaryActions_1);
                        this._overflowAction.setParent(this._owner);
                        this._overflowAction["_actionCollection"] = this;
                    }
                    var isRootAction = this._owner instanceof $d8c6eedade336127$var$AdaptiveCard && !this._owner.parent;
                    shouldRenderOverflowActionButton = !$d8c6eedade336127$var$raiseRenderOverflowActionsEvent(this._overflowAction, isRootAction);
                }
                if (this._overflowAction && shouldRenderOverflowActionButton) primaryActions_1.push(this._overflowAction);
            } else primaryActions_1 = allowedActions;
            for(var i = 0; i < primaryActions_1.length; i++){
                var action = primaryActions_1[i];
                action.render();
                if (action.renderedElement) {
                    if (hostConfig.actions.actionsOrientation === $4uYwi.Orientation.Horizontal && hostConfig.actions.actionAlignment === $4uYwi.ActionAlignment.Stretch) action.renderedElement.style.flex = "0 1 100%";
                    else action.renderedElement.style.flex = "0 1 auto";
                    buttonStrip.appendChild(action.renderedElement);
                    this._renderedActions.push(action);
                    if (i < primaryActions_1.length - 1 && hostConfig.actions.buttonSpacing > 0) {
                        var spacer = document.createElement("div");
                        if (orientation === $4uYwi.Orientation.Horizontal) {
                            spacer.style.flex = "0 0 auto";
                            spacer.style.width = hostConfig.actions.buttonSpacing + "px";
                        } else spacer.style.height = hostConfig.actions.buttonSpacing + "px";
                        $6EfR6.appendChild(buttonStrip, spacer);
                    }
                }
            }
            var buttonStripContainer = document.createElement("div");
            buttonStripContainer.style.overflow = "hidden";
            buttonStripContainer.appendChild(buttonStrip);
            $6EfR6.appendChild(element, buttonStripContainer);
        }
        $6EfR6.appendChild(element, this._actionCardContainer);
        for(var _i = 0, _a = this._renderedActions; _i < _a.length; _i++){
            var renderedAction = _a[_i];
            if (renderedAction.state === 1 /* Expanded */ ) {
                this.expandShowCardAction(renderedAction, false);
                break;
            }
        }
        return this._renderedActions.length > 0 ? element : undefined;
    };
    ActionCollection.prototype.addAction = function(action) {
        if (!action) throw new Error("The action parameter cannot be null.");
        if ((!action.parent || action.parent === this._owner) && this._items.indexOf(action) < 0) {
            this._items.push(action);
            if (!action.parent) action.setParent(this._owner);
            action["_actionCollection"] = this;
        } else throw new Error($luP4B.Strings.errors.actionAlreadyParented());
    };
    ActionCollection.prototype.removeAction = function(action) {
        if (this.expandedAction && this._expandedAction === action) this.collapseExpandedAction();
        var actionIndex = this._items.indexOf(action);
        if (actionIndex >= 0) {
            this._items.splice(actionIndex, 1);
            action.setParent(undefined);
            action["_actionCollection"] = undefined;
            for(var i = 0; i < this._renderedActions.length; i++)if (this._renderedActions[i] === action) {
                this._renderedActions.splice(i, 1);
                break;
            }
            return true;
        }
        return false;
    };
    ActionCollection.prototype.clear = function() {
        this._items = [];
        this._renderedActions = [];
        this._expandedAction = undefined;
    };
    ActionCollection.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = [];
        if (processActions) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getAllInputs());
        }
        return result;
    };
    ActionCollection.prototype.getResourceInformation = function() {
        var result = [];
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var action = _a[_i];
            result.push.apply(result, action.getResourceInformation());
        }
        return result;
    };
    Object.defineProperty(ActionCollection.prototype, "renderedActionCount", {
        get: function() {
            return this._renderedActions.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionCollection.prototype, "expandedAction", {
        get: function() {
            return this._expandedAction;
        },
        enumerable: false,
        configurable: true
    });
    return ActionCollection;
}();
var $d8c6eedade336127$var$ActionSet = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ActionSet, _super);
    function ActionSet() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $d8c6eedade336127$var$ActionCollection(_this);
        return _this;
    }
    ActionSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._actionCollection.parse(source["actions"], context);
    };
    ActionSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ActionSet.prototype.internalRender = function() {
        return this._actionCollection.render(this.orientation !== undefined ? this.orientation : this.hostConfig.actions.actionsOrientation);
    };
    ActionSet.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ActionSet.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ActionSet.prototype.getJsonTypeName = function() {
        return "ActionSet";
    };
    ActionSet.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ActionSet.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ActionSet.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ActionSet.prototype.getAllActions = function() {
        var result = _super.prototype.getAllActions.call(this);
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) result.push(action);
        }
        return result;
    };
    ActionSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        this._actionCollection.validateProperties(context);
    };
    ActionSet.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ActionSet.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        return processActions ? this._actionCollection.getAllInputs() : [];
    };
    ActionSet.prototype.getResourceInformation = function() {
        return this._actionCollection.getResourceInformation();
    };
    /**
     * @inheritdoc
     */ ActionSet.prototype.findDOMNodeOwner = function(node) {
        var target = undefined;
        for(var i = 0; i < this.getActionCount(); i++){
            var action = this.getActionAt(i);
            if (action) {
                // recur through each Action
                target = action.findDOMNodeOwner(node);
                if (target) return target;
            }
        }
        // if not found in any Action, defer to parent implementation
        return _super.prototype.findDOMNodeOwner.call(this, node);
    };
    ActionSet.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) result = this.getElementByIdFromAction(id);
        return result;
    };
    Object.defineProperty(ActionSet.prototype, "isInteractive", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    ActionSet.orientationProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_1, "orientation", $4uYwi.Orientation);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ActionSet.orientationProperty)
    ], ActionSet.prototype, "orientation", void 0);
    return ActionSet;
}($d8c6eedade336127$var$CardElement);
module.exports.ActionSet = $d8c6eedade336127$var$ActionSet;
var $d8c6eedade336127$var$ContainerStyleProperty = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ContainerStyleProperty, _super);
    function ContainerStyleProperty(targetVersion, name, defaultValue, onGetInitialValue) {
        var _this = _super.call(this, targetVersion, name, [
            {
                value: $4uYwi.ContainerStyle.Default
            },
            {
                value: $4uYwi.ContainerStyle.Emphasis
            },
            {
                targetVersion: $dA5cX.Versions.v1_2,
                value: $4uYwi.ContainerStyle.Accent
            },
            {
                targetVersion: $dA5cX.Versions.v1_2,
                value: $4uYwi.ContainerStyle.Good
            },
            {
                targetVersion: $dA5cX.Versions.v1_2,
                value: $4uYwi.ContainerStyle.Attention
            },
            {
                targetVersion: $dA5cX.Versions.v1_2,
                value: $4uYwi.ContainerStyle.Warning
            }
        ], defaultValue, onGetInitialValue) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        _this.defaultValue = defaultValue;
        _this.onGetInitialValue = onGetInitialValue;
        return _this;
    }
    return ContainerStyleProperty;
}($dA5cX.ValueSetProperty);
module.exports.ContainerStyleProperty = $d8c6eedade336127$var$ContainerStyleProperty;
var $d8c6eedade336127$var$StylableCardElementContainer = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(StylableCardElementContainer, _super);
    function StylableCardElementContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StylableCardElementContainer.prototype, "style", {
        get: function() {
            if (this.allowCustomStyle) {
                var style = this.getValue(StylableCardElementContainer.styleProperty);
                if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            }
            return undefined;
        },
        set: function(value) {
            this.setValue(StylableCardElementContainer.styleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "allowCustomStyle", {
        //#endregion
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableCardElementContainer.prototype, "hasExplicitStyle", {
        get: function() {
            return this.getValue(StylableCardElementContainer.styleProperty) !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    StylableCardElementContainer.prototype.applyBorder = function() {
    // No border in base implementation
    };
    StylableCardElementContainer.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = $6EfR6.stringToCssColor(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    StylableCardElementContainer.prototype.applyPadding = function() {
        _super.prototype.applyPadding.call(this);
        if (!this.renderedElement) return;
        var physicalPadding = new $krmaK.SpacingDefinition();
        if (this.getEffectivePadding()) physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
        this.renderedElement.style.paddingTop = physicalPadding.top + "px";
        this.renderedElement.style.paddingRight = physicalPadding.right + "px";
        this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
        this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
        if (this.isBleeding()) {
            // Bleed into the first parent that does have padding
            var padding = new $krmaK.PaddingDefinition();
            this.getImmediateSurroundingPadding(padding);
            var surroundingPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
            this.renderedElement.style.marginRight = "-" + surroundingPadding.right + "px";
            this.renderedElement.style.marginLeft = "-" + surroundingPadding.left + "px";
            if (!this.isDesignMode()) {
                this.renderedElement.style.marginTop = "-" + surroundingPadding.top + "px";
                this.renderedElement.style.marginBottom = "-" + surroundingPadding.bottom + "px";
            }
            if (this.separatorElement && this.separatorOrientation === $4uYwi.Orientation.Horizontal) {
                this.separatorElement.style.marginLeft = "-" + surroundingPadding.left + "px";
                this.separatorElement.style.marginRight = "-" + surroundingPadding.right + "px";
            }
        } else {
            this.renderedElement.style.marginRight = "0";
            this.renderedElement.style.marginLeft = "0";
            this.renderedElement.style.marginTop = "0";
            this.renderedElement.style.marginBottom = "0";
            if (this.separatorElement && this.separatorOrientation === $4uYwi.Orientation.Horizontal) {
                this.separatorElement.style.marginRight = "0";
                this.separatorElement.style.marginLeft = "0";
            }
        }
    };
    StylableCardElementContainer.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var currentElement = this.parent;
        while(currentElement){
            var currentElementHasBackgroundImage = false;
            if (ignoreBackgroundImages) currentElementHasBackgroundImage = false;
            else currentElementHasBackgroundImage = currentElement instanceof $d8c6eedade336127$var$Container ? currentElement.backgroundImage.isValid() : false;
            if (currentElement instanceof StylableCardElementContainer) {
                if (this.hasExplicitStyle && (currentElement.getEffectiveStyle() !== this.getEffectiveStyle() || currentElementHasBackgroundImage)) return true;
            }
            currentElement = currentElement.parent;
        }
        return false;
    };
    StylableCardElementContainer.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $krmaK.PaddingDefinition($4uYwi.Spacing.Padding, $4uYwi.Spacing.Padding, $4uYwi.Spacing.Padding, $4uYwi.Spacing.Padding) : _super.prototype.getDefaultPadding.call(this);
    };
    StylableCardElementContainer.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var explicitStyle = this.getValue(StylableCardElementContainer.styleProperty);
        if (explicitStyle !== undefined) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(explicitStyle);
            if (!styleDefinition) context.addFailure(this, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidPropertyValue(explicitStyle, "style"));
        }
    };
    StylableCardElementContainer.prototype.render = function() {
        var renderedElement = _super.prototype.render.call(this);
        if (renderedElement && this.getHasBackground()) this.applyBackground();
        this.applyBorder();
        return renderedElement;
    };
    StylableCardElementContainer.prototype.getEffectiveStyle = function() {
        var effectiveStyle = this.style;
        return effectiveStyle ? effectiveStyle : _super.prototype.getEffectiveStyle.call(this);
    };
    //#region Schema
    StylableCardElementContainer.styleProperty = new $d8c6eedade336127$var$ContainerStyleProperty($dA5cX.Versions.v1_0, "style");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(StylableCardElementContainer.styleProperty)
    ], StylableCardElementContainer.prototype, "style", null);
    return StylableCardElementContainer;
}($d8c6eedade336127$var$CardElementContainer);
module.exports.StylableCardElementContainer = $d8c6eedade336127$var$StylableCardElementContainer;
var $d8c6eedade336127$var$ContainerBase = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ContainerBase, _super);
    function ContainerBase() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._bleed = false;
        return _this;
    }
    //#endregion
    ContainerBase.prototype.adjustRenderedElementSize = function(renderedElement) {
        _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
        if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
    };
    ContainerBase.prototype.getHasExpandedAction = function() {
        return false;
    };
    ContainerBase.prototype.getBleed = function() {
        return this._bleed;
    };
    ContainerBase.prototype.setBleed = function(value) {
        this._bleed = value;
    };
    Object.defineProperty(ContainerBase.prototype, "renderedActionCount", {
        get: function() {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    ContainerBase.prototype.isBleeding = function() {
        return (this.getHasBackground() || this.hostConfig.alwaysAllowBleed) && this.getBleed();
    };
    ContainerBase.bleedProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_2, "bleed", false);
    ContainerBase.minHeightProperty = new $dA5cX.PixelSizeProperty($dA5cX.Versions.v1_2, "minHeight");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ContainerBase.bleedProperty)
    ], ContainerBase.prototype, "_bleed", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(ContainerBase.minHeightProperty)
    ], ContainerBase.prototype, "minPixelHeight", void 0);
    return ContainerBase;
}($d8c6eedade336127$var$StylableCardElementContainer);
module.exports.ContainerBase = $d8c6eedade336127$var$ContainerBase;
var $d8c6eedade336127$var$BackgroundImage = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(BackgroundImage, _super);
    function BackgroundImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    BackgroundImage.prototype.getSchemaKey = function() {
        return "BackgroundImage";
    };
    BackgroundImage.prototype.internalParse = function(source, context) {
        if (typeof source === "string") {
            this.resetDefaultValues();
            this.url = source;
        } else return _super.prototype.internalParse.call(this, source, context);
    };
    BackgroundImage.prototype.apply = function(element) {
        if (this.url && element.renderedElement) {
            element.renderedElement.style.backgroundImage = "url('" + element.preProcessPropertyValue(BackgroundImage.urlProperty, this.url) + "')";
            switch(this.fillMode){
                case $4uYwi.FillMode.Repeat:
                    element.renderedElement.style.backgroundRepeat = "repeat";
                    break;
                case $4uYwi.FillMode.RepeatHorizontally:
                    element.renderedElement.style.backgroundRepeat = "repeat-x";
                    break;
                case $4uYwi.FillMode.RepeatVertically:
                    element.renderedElement.style.backgroundRepeat = "repeat-y";
                    break;
                case $4uYwi.FillMode.Cover:
                default:
                    element.renderedElement.style.backgroundRepeat = "no-repeat";
                    element.renderedElement.style.backgroundSize = "cover";
                    break;
            }
            switch(this.horizontalAlignment){
                case $4uYwi.HorizontalAlignment.Left:
                    break;
                case $4uYwi.HorizontalAlignment.Center:
                    element.renderedElement.style.backgroundPositionX = "center";
                    break;
                case $4uYwi.HorizontalAlignment.Right:
                    element.renderedElement.style.backgroundPositionX = "right";
                    break;
            }
            switch(this.verticalAlignment){
                case $4uYwi.VerticalAlignment.Top:
                    break;
                case $4uYwi.VerticalAlignment.Center:
                    element.renderedElement.style.backgroundPositionY = "center";
                    break;
                case $4uYwi.VerticalAlignment.Bottom:
                    element.renderedElement.style.backgroundPositionY = "bottom";
                    break;
            }
        }
    };
    BackgroundImage.prototype.isValid = function() {
        return this.url ? true : false;
    };
    //#region Schema
    BackgroundImage.urlProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "url");
    BackgroundImage.fillModeProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_2, "fillMode", $4uYwi.FillMode, $4uYwi.FillMode.Cover);
    BackgroundImage.horizontalAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_2, "horizontalAlignment", $4uYwi.HorizontalAlignment, $4uYwi.HorizontalAlignment.Left);
    BackgroundImage.verticalAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_2, "verticalAlignment", $4uYwi.VerticalAlignment, $4uYwi.VerticalAlignment.Top);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BackgroundImage.urlProperty)
    ], BackgroundImage.prototype, "url", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BackgroundImage.fillModeProperty)
    ], BackgroundImage.prototype, "fillMode", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BackgroundImage.horizontalAlignmentProperty)
    ], BackgroundImage.prototype, "horizontalAlignment", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(BackgroundImage.verticalAlignmentProperty)
    ], BackgroundImage.prototype, "verticalAlignment", void 0);
    return BackgroundImage;
}($dA5cX.SerializableObject);
module.exports.BackgroundImage = $d8c6eedade336127$var$BackgroundImage;
var $d8c6eedade336127$var$Container = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(Container, _super);
    function Container() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        _this._items = [];
        _this._renderedItems = [];
        return _this;
    }
    Object.defineProperty(Container.prototype, "backgroundImage", {
        get: function() {
            return this.getValue(Container.backgroundImageProperty);
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.insertItemAt = function(item, index, forceInsert) {
        if (!item.parent || forceInsert) {
            if (item.isStandalone) {
                if (index < 0 || index >= this._items.length) this._items.push(item);
                else this._items.splice(index, 0, item);
                item.setParent(this);
            } else throw new Error($luP4B.Strings.errors.elementTypeNotStandalone(item.getJsonTypeName()));
        } else throw new Error($luP4B.Strings.errors.elementAlreadyParented());
    };
    Container.prototype.getItemsCollectionPropertyName = function() {
        return "items";
    };
    Container.prototype.applyBackground = function() {
        if (this.backgroundImage.isValid() && this.renderedElement) this.backgroundImage.apply(this);
        _super.prototype.applyBackground.call(this);
    };
    Container.prototype.applyRTL = function(element) {
        if (this.rtl !== undefined) element.dir = this.rtl ? "rtl" : "ltr";
    };
    Container.prototype.internalRender = function() {
        this._renderedItems = [];
        // Cache hostConfig to avoid walking the parent hierarchy several times
        var hostConfig = this.hostConfig;
        var element = document.createElement("div");
        this.applyRTL(element);
        element.classList.add(hostConfig.makeCssClassName("ac-container"));
        element.style.display = "flex";
        element.style.flexDirection = "column";
        if ($krmaK.GlobalSettings.useAdvancedCardBottomTruncation) // Forces the container to be at least as tall as its content.
        //
        // Fixes a quirk in Chrome where, for nested flex elements, the
        // inner element's height would never exceed the outer element's
        // height. This caused overflow truncation to break -- containers
        // would always be measured as not overflowing, since their heights
        // were constrained by their parents as opposed to truly reflecting
        // the height of their content.
        //
        // See the "Browser Rendering Notes" section of this answer:
        // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
        element.style.minHeight = "-webkit-min-content";
        switch(this.getEffectiveVerticalContentAlignment()){
            case $4uYwi.VerticalAlignment.Center:
                element.style.justifyContent = "center";
                break;
            case $4uYwi.VerticalAlignment.Bottom:
                element.style.justifyContent = "flex-end";
                break;
            default:
                element.style.justifyContent = "flex-start";
                break;
        }
        if (this._items.length > 0) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            var renderedItem = this.isElementAllowed(item) ? item.render() : undefined;
            if (renderedItem) {
                if (this._renderedItems.length > 0 && item.separatorElement) {
                    item.separatorElement.style.flex = "0 0 auto";
                    $6EfR6.appendChild(element, item.separatorElement);
                }
                $6EfR6.appendChild(element, renderedItem);
                this._renderedItems.push(item);
            }
        }
        else if (this.isDesignMode()) {
            var placeholderElement = this.createPlaceholderElement();
            placeholderElement.style.width = "100%";
            placeholderElement.style.height = "100%";
            element.appendChild(placeholderElement);
        }
        return element;
    };
    Container.prototype.truncateOverflow = function(maxHeight) {
        if (this.renderedElement) {
            // Add 1 to account for rounding differences between browsers
            var boundary_1 = this.renderedElement.offsetTop + maxHeight + 1;
            var handleElement_1 = function(cardElement) {
                var elt = cardElement.renderedElement;
                if (elt) switch($6EfR6.getFitStatus(elt, boundary_1)){
                    case $4uYwi.ContainerFitStatus.FullyInContainer:
                        var sizeChanged = cardElement["resetOverflow"]();
                        // If the element's size changed after resetting content,
                        // we have to check if it still fits fully in the card
                        if (sizeChanged) handleElement_1(cardElement);
                        break;
                    case $4uYwi.ContainerFitStatus.Overflowing:
                        var containerMaxHeight = boundary_1 - elt.offsetTop;
                        cardElement["handleOverflow"](containerMaxHeight);
                        break;
                    case $4uYwi.ContainerFitStatus.FullyOutOfContainer:
                        cardElement["handleOverflow"](0);
                        break;
                }
            };
            for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                handleElement_1(item);
            }
            return true;
        }
        return false;
    };
    Container.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            item["resetOverflow"]();
        }
    };
    Container.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        var result = ignoreBackgroundImages ? false : this.backgroundImage.isValid();
        return result || _super.prototype.getHasBackground.call(this, ignoreBackgroundImages);
    };
    Container.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.clear();
        this.setShouldFallback(false);
        var jsonItems = source[this.getItemsCollectionPropertyName()];
        if (Array.isArray(jsonItems)) for(var _i = 0, jsonItems_1 = jsonItems; _i < jsonItems_1.length; _i++){
            var item = jsonItems_1[_i];
            var element = context.parseElement(this, item, this.forbiddenChildElements(), !this.isDesignMode());
            if (element) this.insertItemAt(element, -1, true);
        }
    };
    Container.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        var collectionPropertyName = this.getItemsCollectionPropertyName();
        context.serializeArray(target, collectionPropertyName, this._items);
    };
    Object.defineProperty(Container.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Container.prototype.getEffectivePadding = function() {
        if ($krmaK.GlobalSettings.removePaddingFromContainersWithBackgroundImage && !this.getHasBackground(true)) return new $krmaK.PaddingDefinition();
        return _super.prototype.getEffectivePadding.call(this);
    };
    Container.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        var parentContainer = this.getParentContainer();
        return parentContainer ? parentContainer.getEffectiveVerticalContentAlignment() : $4uYwi.VerticalAlignment.Top;
    };
    Container.prototype.getItemCount = function() {
        return this._items.length;
    };
    Container.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    Container.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var _i = 0, _a = this._renderedItems; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible) return item;
        }
        return undefined;
    };
    Container.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) for(var i = this._renderedItems.length - 1; i >= 0; i--){
            if (this._renderedItems[i].isVisible) return this._renderedItems[i];
        }
        return undefined;
    };
    Container.prototype.getJsonTypeName = function() {
        return "Container";
    };
    Container.prototype.isFirstElement = function(element) {
        var designMode = this.isDesignMode();
        for(var _i = 0, _a = this._items; _i < _a.length; _i++){
            var item = _a[_i];
            if (item.isVisible || designMode) return item === element;
        }
        return false;
    };
    Container.prototype.isLastElement = function(element) {
        var designMode = this.isDesignMode();
        for(var i = this._items.length - 1; i >= 0; i--){
            if (this._items[i].isVisible || designMode) return this._items[i] === element;
        }
        return false;
    };
    Container.prototype.isRtl = function() {
        if (this.rtl !== undefined) return this.rtl;
        else {
            var parentContainer = this.getParentContainer();
            return parentContainer ? parentContainer.isRtl() : false;
        }
    };
    Container.prototype.isBleedingAtTop = function() {
        var firstRenderedItem = this.getFirstVisibleRenderedItem();
        return this.isBleeding() || (firstRenderedItem ? firstRenderedItem.isBleedingAtTop() : false);
    };
    Container.prototype.isBleedingAtBottom = function() {
        var lastRenderedItem = this.getLastVisibleRenderedItem();
        return this.isBleeding() || (lastRenderedItem ? lastRenderedItem.isBleedingAtBottom() && lastRenderedItem.getEffectiveStyle() === this.getEffectiveStyle() : false);
    };
    Container.prototype.indexOf = function(cardElement) {
        return this._items.indexOf(cardElement);
    };
    Container.prototype.addItem = function(item) {
        this.insertItemAt(item, -1, false);
    };
    Container.prototype.insertItemBefore = function(item, insertBefore) {
        this.insertItemAt(item, this._items.indexOf(insertBefore), false);
    };
    Container.prototype.insertItemAfter = function(item, insertAfter) {
        this.insertItemAt(item, this._items.indexOf(insertAfter) + 1, false);
    };
    Container.prototype.removeItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    Container.prototype.clear = function() {
        this._items = [];
        this._renderedItems = [];
    };
    Container.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        if (this.backgroundImage.isValid()) result.push({
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- validated by `isValid()`
            url: this.backgroundImage.url,
            mimeType: "image"
        });
        return result;
    };
    Container.prototype.getActionById = function(id) {
        var result = _super.prototype.getActionById.call(this, id);
        if (!result) {
            if (this.selectAction) result = this.selectAction.getActionById(id);
            if (!result) for(var _i = 0, _a = this._items; _i < _a.length; _i++){
                var item = _a[_i];
                result = item.getActionById(id);
                if (result) break;
            }
        }
        return result;
    };
    Object.defineProperty(Container.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Container.backgroundImageProperty = new $dA5cX.SerializableObjectProperty($dA5cX.Versions.v1_0, "backgroundImage", $d8c6eedade336127$var$BackgroundImage);
    Container.verticalContentAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_1, "verticalContentAlignment", $4uYwi.VerticalAlignment);
    Container.rtlProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_0, "rtl");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Container.backgroundImageProperty)
    ], Container.prototype, "backgroundImage", null);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Container.verticalContentAlignmentProperty)
    ], Container.prototype, "verticalContentAlignment", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Container.rtlProperty)
    ], Container.prototype, "rtl", void 0);
    return Container;
}($d8c6eedade336127$var$ContainerBase);
module.exports.Container = $d8c6eedade336127$var$Container;
var $d8c6eedade336127$var$Column = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(Column, _super);
    function Column(width) {
        if (width === void 0) width = "stretch";
        var _this = _super.call(this) || this;
        _this.width = "stretch";
        //#endregion
        _this._computedWeight = 0;
        _this.width = width;
        return _this;
    }
    Column.prototype.adjustRenderedElementSize = function(renderedElement) {
        var minDesignTimeColumnHeight = 20;
        if (this.isDesignMode()) {
            renderedElement.style.minWidth = "20px";
            renderedElement.style.minHeight = (!this.minPixelHeight ? minDesignTimeColumnHeight : Math.max(this.minPixelHeight, minDesignTimeColumnHeight)) + "px";
        } else {
            renderedElement.style.minWidth = "0";
            if (this.minPixelHeight) renderedElement.style.minHeight = this.minPixelHeight + "px";
        }
        if (this.width === "auto") renderedElement.style.flex = "0 1 auto";
        else if (this.width === "stretch") renderedElement.style.flex = "1 1 50px";
        else if (this.width instanceof $krmaK.SizeAndUnit) {
            if (this.width.unit === $4uYwi.SizeUnit.Pixel) {
                renderedElement.style.flex = "0 0 auto";
                renderedElement.style.width = this.width.physicalSize + "px";
            } else renderedElement.style.flex = "1 1 " + (this._computedWeight > 0 ? this._computedWeight : this.width.physicalSize) + "%";
        }
    };
    Column.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(Column.prototype, "separatorOrientation", {
        get: function() {
            return $4uYwi.Orientation.Vertical;
        },
        enumerable: false,
        configurable: true
    });
    Column.prototype.getJsonTypeName = function() {
        return "Column";
    };
    Object.defineProperty(Column.prototype, "hasVisibleSeparator", {
        get: function() {
            if (this.parent && this.parent instanceof $d8c6eedade336127$var$ColumnSet) return this.separatorElement !== undefined && !this.parent.isLeftMostElement(this);
            else return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    Column.widthProperty = new $dA5cX.CustomProperty($dA5cX.Versions.v1_0, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $krmaK.SizeAndUnit(value, $4uYwi.SizeUnit.Weight);
        else if (value === "auto" || value === "stretch") result = value;
        else if (typeof value === "string") try {
            result = $krmaK.SizeAndUnit.parse(value);
            if (result.unit === $4uYwi.SizeUnit.Pixel && prop.targetVersion.compareTo(context.targetVersion) > 0) invalidWidth = true;
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) {
            context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidColumnWidth(value));
            result = "auto";
        }
        return result;
    }, function(sender, property, target, value, context) {
        if (value instanceof $krmaK.SizeAndUnit) {
            if (value.unit === $4uYwi.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
            else context.serializeNumber(target, "width", value.physicalSize);
        } else context.serializeValue(target, "width", value);
    }, "stretch");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Column.widthProperty)
    ], Column.prototype, "width", void 0);
    return Column;
}($d8c6eedade336127$var$Container);
module.exports.Column = $d8c6eedade336127$var$Column;
var $d8c6eedade336127$var$ColumnSet = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ColumnSet, _super);
    function ColumnSet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        return _this;
    }
    ColumnSet.prototype.createColumnInstance = function(source, context) {
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return !typeName || typeName === "Column" ? new $d8c6eedade336127$var$Column() : undefined;
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $4uYwi.ValidationEvent.ElementTypeNotAllowed, $luP4B.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    ColumnSet.prototype.internalRender = function() {
        this._renderedColumns = [];
        if (this._columns.length > 0) {
            // Cache hostConfig to avoid walking the parent hierarchy several times
            var hostConfig = this.hostConfig;
            var element = document.createElement("div");
            element.className = hostConfig.makeCssClassName("ac-columnSet");
            element.style.display = "flex";
            if ($krmaK.GlobalSettings.useAdvancedCardBottomTruncation) // See comment in Container.internalRender()
            element.style.minHeight = "-webkit-min-content";
            switch(this.getEffectiveHorizontalAlignment()){
                case $4uYwi.HorizontalAlignment.Center:
                    element.style.justifyContent = "center";
                    break;
                case $4uYwi.HorizontalAlignment.Right:
                    element.style.justifyContent = "flex-end";
                    break;
                default:
                    element.style.justifyContent = "flex-start";
                    break;
            }
            var totalWeight = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width instanceof $krmaK.SizeAndUnit && column.width.unit === $4uYwi.SizeUnit.Weight) totalWeight += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width instanceof $krmaK.SizeAndUnit && column.width.unit === $4uYwi.SizeUnit.Weight && totalWeight > 0) {
                    var computedWeight = 100 / totalWeight * column.width.physicalSize;
                    // Best way to emulate "internal" access I know of
                    column["_computedWeight"] = computedWeight;
                }
                var renderedColumn = column.render();
                if (renderedColumn) {
                    if (this._renderedColumns.length > 0 && column.separatorElement) {
                        column.separatorElement.style.flex = "0 0 auto";
                        $6EfR6.appendChild(element, column.separatorElement);
                    }
                    $6EfR6.appendChild(element, renderedColumn);
                    this._renderedColumns.push(column);
                }
            }
            return this._renderedColumns.length > 0 ? element : undefined;
        } else return undefined;
    };
    ColumnSet.prototype.truncateOverflow = function(maxHeight) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["handleOverflow"](maxHeight);
        }
        return true;
    };
    ColumnSet.prototype.undoOverflowTruncation = function() {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            column["resetOverflow"]();
        }
    };
    Object.defineProperty(ColumnSet.prototype, "isSelectable", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ColumnSet.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._columns = [];
        this._renderedColumns = [];
        var jsonColumns = source["columns"];
        if (Array.isArray(jsonColumns)) for(var _i = 0, jsonColumns_1 = jsonColumns; _i < jsonColumns_1.length; _i++){
            var item = jsonColumns_1[_i];
            var column = this.createColumnInstance(item, context);
            if (column) this._columns.push(column);
        }
    };
    ColumnSet.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, "columns", this._columns);
    };
    ColumnSet.prototype.isFirstElement = function(element) {
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isVisible) return column === element;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtTop = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtTop()) return true;
        }
        return false;
    };
    ColumnSet.prototype.isBleedingAtBottom = function() {
        if (this.isBleeding()) return true;
        if (this._renderedColumns && this._renderedColumns.length > 0) for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (column.isBleedingAtBottom()) return true;
        }
        return false;
    };
    ColumnSet.prototype.getItemCount = function() {
        return this._columns.length;
    };
    ColumnSet.prototype.getFirstVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[0];
        else return undefined;
    };
    ColumnSet.prototype.getLastVisibleRenderedItem = function() {
        if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) return this._renderedColumns[this._renderedColumns.length - 1];
        else return undefined;
    };
    ColumnSet.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    ColumnSet.prototype.getItemAt = function(index) {
        return this.getColumnAt(index);
    };
    ColumnSet.prototype.getJsonTypeName = function() {
        return "ColumnSet";
    };
    ColumnSet.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        var weightedColumns = 0;
        var stretchedColumns = 0;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            if (typeof column.width === "number") weightedColumns++;
            else if (column.width === "stretch") stretchedColumns++;
        }
        if (weightedColumns > 0 && stretchedColumns > 0) context.addFailure(this, $4uYwi.ValidationEvent.Hint, $luP4B.Strings.hints.dontUseWeightedAndStrecthedColumnsInSameSet());
    };
    ColumnSet.prototype.addColumn = function(column) {
        if (!column.parent) {
            this._columns.push(column);
            column.setParent(this);
        } else throw new Error($luP4B.Strings.errors.columnAlreadyBelongsToAnotherSet());
    };
    ColumnSet.prototype.removeItem = function(item) {
        if (item instanceof $d8c6eedade336127$var$Column) {
            var itemIndex = this._columns.indexOf(item);
            if (itemIndex >= 0) {
                this._columns.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    ColumnSet.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $d8c6eedade336127$var$Column ? this._columns.indexOf(cardElement) : -1;
    };
    ColumnSet.prototype.isLeftMostElement = function(element) {
        return this._columns.indexOf(element) === 0;
    };
    ColumnSet.prototype.isRightMostElement = function(element) {
        return this._columns.indexOf(element) === this._columns.length - 1;
    };
    ColumnSet.prototype.isTopElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.isBottomElement = function(element) {
        return this._columns.indexOf(element) >= 0;
    };
    ColumnSet.prototype.getActionById = function(id) {
        var result = undefined;
        for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
            var column = _a[_i];
            result = column.getActionById(id);
            if (result) break;
        }
        return result;
    };
    Object.defineProperty(ColumnSet.prototype, "bleed", {
        get: function() {
            return this.getBleed();
        },
        set: function(value) {
            this.setBleed(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "padding", {
        get: function() {
            return this.getPadding();
        },
        set: function(value) {
            this.setPadding(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColumnSet.prototype, "selectAction", {
        get: function() {
            return this._selectAction;
        },
        set: function(value) {
            this._selectAction = value;
        },
        enumerable: false,
        configurable: true
    });
    return ColumnSet;
}($d8c6eedade336127$var$ContainerBase);
module.exports.ColumnSet = $d8c6eedade336127$var$ColumnSet;
function $d8c6eedade336127$var$raiseImageLoadedEvent(image) {
    var card = image.getRootElement();
    var onImageLoadedHandler = card && card.onImageLoaded ? card.onImageLoaded : $d8c6eedade336127$var$AdaptiveCard.onImageLoaded;
    if (onImageLoadedHandler) onImageLoadedHandler(image);
}
function $d8c6eedade336127$var$raiseAnchorClickedEvent(element, anchor, ev) {
    var card = element.getRootElement();
    var onAnchorClickedHandler = card && card.onAnchorClicked ? card.onAnchorClicked : $d8c6eedade336127$var$AdaptiveCard.onAnchorClicked;
    return onAnchorClickedHandler !== undefined ? onAnchorClickedHandler(element, anchor, ev) : false;
}
function $d8c6eedade336127$var$raiseExecuteActionEvent(action) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onExecuteActionHandler = card && card.onExecuteAction ? card.onExecuteAction : $d8c6eedade336127$var$AdaptiveCard.onExecuteAction;
    if (action.prepareForExecution() && onExecuteActionHandler) onExecuteActionHandler(action);
}
function $d8c6eedade336127$var$raiseInlineCardExpandedEvent(action, isExpanded) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onInlineCardExpandedHandler = card && card.onInlineCardExpanded ? card.onInlineCardExpanded : $d8c6eedade336127$var$AdaptiveCard.onInlineCardExpanded;
    if (onInlineCardExpandedHandler) onInlineCardExpandedHandler(action, isExpanded);
}
function $d8c6eedade336127$var$raiseInputValueChangedEvent(input) {
    var card = input.getRootElement();
    var onInputValueChangedHandler = card && card.onInputValueChanged ? card.onInputValueChanged : $d8c6eedade336127$var$AdaptiveCard.onInputValueChanged;
    if (onInputValueChangedHandler) onInputValueChangedHandler(input);
}
function $d8c6eedade336127$var$raiseElementVisibilityChangedEvent(element, shouldUpdateLayout) {
    if (shouldUpdateLayout === void 0) shouldUpdateLayout = true;
    var rootElement = element.getRootElement();
    if (shouldUpdateLayout) rootElement.updateLayout();
    var card = rootElement;
    var onElementVisibilityChangedHandler = card && card.onElementVisibilityChanged ? card.onElementVisibilityChanged : $d8c6eedade336127$var$AdaptiveCard.onElementVisibilityChanged;
    if (onElementVisibilityChangedHandler !== undefined) onElementVisibilityChangedHandler(element);
}
function $d8c6eedade336127$var$updateInputAdornersVisibility(input, hide) {
    if (!!hide) {
        // hides the time/date picker icon
        input.readOnly = true;
        // hides the cross button icon
        input.required = true;
    } else {
        // shows the time/date picker icon
        input.readOnly = false;
        // shows the cross button icon
        input.required = false;
    }
}
/**
 * @returns return false to continue with default context menu; return true to skip SDK default context menu
 */ function $d8c6eedade336127$var$raiseDisplayOverflowActionMenuEvent(action, target) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onDisplayOverflowActionMenuHandler = card && card.onDisplayOverflowActionMenu ? card.onDisplayOverflowActionMenu : $d8c6eedade336127$var$AdaptiveCard.onDisplayOverflowActionMenu;
    return onDisplayOverflowActionMenuHandler !== undefined ? onDisplayOverflowActionMenuHandler(action.getActions(), target) : false;
}
/**
 * @returns return false to continue with default action button; return true to skip SDK default action button
 */ function $d8c6eedade336127$var$raiseRenderOverflowActionsEvent(action, isAtRootLevelActions) {
    var card = action.parent ? action.parent.getRootElement() : undefined;
    var onRenderOverflowActionsHandler = card && card.onRenderOverflowActions ? card.onRenderOverflowActions : $d8c6eedade336127$var$AdaptiveCard.onRenderOverflowActions;
    return onRenderOverflowActionsHandler !== undefined ? onRenderOverflowActionsHandler(action.getActions(), isAtRootLevelActions) : false;
}
var $d8c6eedade336127$var$ContainerWithActions = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(ContainerWithActions, _super);
    function ContainerWithActions() {
        var _this = _super.call(this) || this;
        _this._actionCollection = new $d8c6eedade336127$var$ActionCollection(_this);
        return _this;
    }
    ContainerWithActions.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.parseActions(source, context);
    };
    ContainerWithActions.prototype.parseActions = function(source, context) {
        this._actionCollection.parse(source["actions"], context);
    };
    ContainerWithActions.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        this._actionCollection.toJSON(target, "actions", context);
    };
    ContainerWithActions.prototype.internalRender = function() {
        var element = _super.prototype.internalRender.call(this);
        if (element) {
            var renderedActions = this._actionCollection.render(this.hostConfig.actions.actionsOrientation);
            if (renderedActions) {
                $6EfR6.appendChild(element, $d8c6eedade336127$var$renderSeparation(this.hostConfig, {
                    spacing: this.hostConfig.getEffectiveSpacing(this.hostConfig.actions.spacing)
                }, $4uYwi.Orientation.Horizontal));
                $6EfR6.appendChild(element, renderedActions);
            }
            if (this.renderIfEmpty) return element;
            else return element.children.length > 0 ? element : undefined;
        } else return undefined;
    };
    ContainerWithActions.prototype.getHasExpandedAction = function() {
        if (this.renderedActionCount === 0) return false;
        else if (this.renderedActionCount === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
        else return this._actionCollection.expandedAction !== undefined;
    };
    Object.defineProperty(ContainerWithActions.prototype, "renderedActionCount", {
        get: function() {
            return this._actionCollection.renderedActionCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContainerWithActions.prototype, "renderIfEmpty", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ContainerWithActions.prototype.releaseDOMResources = function() {
        _super.prototype.releaseDOMResources.call(this);
        this._actionCollection.releaseDOMResources();
    };
    ContainerWithActions.prototype.getActionCount = function() {
        return this._actionCollection.getActionCount();
    };
    ContainerWithActions.prototype.getActionAt = function(index) {
        if (index >= 0 && index < this.getActionCount()) return this._actionCollection.getActionAt(index);
        else return _super.prototype.getActionAt.call(this, index);
    };
    ContainerWithActions.prototype.getActionById = function(id) {
        var result = this._actionCollection.getActionById(id);
        return result ? result : _super.prototype.getActionById.call(this, id);
    };
    ContainerWithActions.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this._actionCollection) this._actionCollection.validateProperties(context);
    };
    ContainerWithActions.prototype.isLastElement = function(element) {
        return _super.prototype.isLastElement.call(this, element) && this._actionCollection.getActionCount() === 0;
    };
    ContainerWithActions.prototype.addAction = function(action) {
        this._actionCollection.addAction(action);
    };
    ContainerWithActions.prototype.clear = function() {
        _super.prototype.clear.call(this);
        this._actionCollection.clear();
    };
    ContainerWithActions.prototype.getAllInputs = function(processActions) {
        if (processActions === void 0) processActions = true;
        var result = _super.prototype.getAllInputs.call(this, processActions);
        if (processActions) result.push.apply(result, this._actionCollection.getAllInputs(processActions));
        return result;
    };
    ContainerWithActions.prototype.getResourceInformation = function() {
        var result = _super.prototype.getResourceInformation.call(this);
        result.push.apply(result, this._actionCollection.getResourceInformation());
        return result;
    };
    ContainerWithActions.prototype.isBleedingAtBottom = function() {
        if (this._actionCollection.renderedActionCount === 0) return _super.prototype.isBleedingAtBottom.call(this);
        else {
            if (this._actionCollection.getActionCount() === 1) return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
            else return this._actionCollection.expandedAction !== undefined;
        }
    };
    ContainerWithActions.prototype.getForbiddenActionNames = function() {
        return [];
    };
    ContainerWithActions.prototype.getElementById = function(id) {
        var result = _super.prototype.getElementById.call(this, id);
        if (!result) result = this.getElementByIdFromAction(id);
        return result;
    };
    Object.defineProperty(ContainerWithActions.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return ContainerWithActions;
}($d8c6eedade336127$var$Container);
module.exports.ContainerWithActions = $d8c6eedade336127$var$ContainerWithActions;
var $d8c6eedade336127$var$RefreshActionProperty = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(RefreshActionProperty, _super);
    function RefreshActionProperty(targetVersion, name) {
        var _this = _super.call(this, targetVersion, name, undefined) || this;
        _this.targetVersion = targetVersion;
        _this.name = name;
        return _this;
    }
    RefreshActionProperty.prototype.parse = function(sender, source, context) {
        var action = context.parseAction(sender.parent, source[this.name], [], false);
        if (action !== undefined) {
            if (action instanceof $d8c6eedade336127$var$ExecuteAction) return action;
            context.logParseEvent(sender, $4uYwi.ValidationEvent.ActionTypeNotAllowed, $luP4B.Strings.errors.actionTypeNotAllowed(action.getJsonTypeName()));
        }
        context.logParseEvent(sender, $4uYwi.ValidationEvent.PropertyCantBeNull, $luP4B.Strings.errors.propertyMustBeSet("action"));
        return undefined;
    };
    RefreshActionProperty.prototype.toJSON = function(sender, target, value, context) {
        context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
    };
    return RefreshActionProperty;
}($dA5cX.PropertyDefinition);
module.exports.RefreshActionProperty = $d8c6eedade336127$var$RefreshActionProperty;
var $d8c6eedade336127$var$RefreshDefinition = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(RefreshDefinition, _super);
    function RefreshDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RefreshDefinition.prototype, "action", {
        get: function() {
            return this.getValue(RefreshDefinition.actionProperty);
        },
        set: function(value) {
            this.setValue(RefreshDefinition.actionProperty, value);
            if (value) value.setParent(this.parent);
        },
        enumerable: false,
        configurable: true
    });
    RefreshDefinition.prototype.getSchemaKey = function() {
        return "RefreshDefinition";
    };
    //#region Schema
    RefreshDefinition.actionProperty = new $d8c6eedade336127$var$RefreshActionProperty($dA5cX.Versions.v1_4, "action");
    RefreshDefinition.userIdsProperty = new $dA5cX.StringArrayProperty($dA5cX.Versions.v1_4, "userIds");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(RefreshDefinition.actionProperty)
    ], RefreshDefinition.prototype, "action", null);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(RefreshDefinition.userIdsProperty)
    ], RefreshDefinition.prototype, "userIds", void 0);
    return RefreshDefinition;
}($dA5cX.SerializableObject);
module.exports.RefreshDefinition = $d8c6eedade336127$var$RefreshDefinition;
var $d8c6eedade336127$var$AuthCardButton = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(AuthCardButton, _super);
    function AuthCardButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthCardButton.prototype.getSchemaKey = function() {
        return "AuthCardButton";
    };
    //#region Schema
    AuthCardButton.typeProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "type");
    AuthCardButton.titleProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "title");
    AuthCardButton.imageProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "image");
    AuthCardButton.valueProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "value");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(AuthCardButton.typeProperty)
    ], AuthCardButton.prototype, "type", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(AuthCardButton.titleProperty)
    ], AuthCardButton.prototype, "title", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(AuthCardButton.imageProperty)
    ], AuthCardButton.prototype, "image", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(AuthCardButton.valueProperty)
    ], AuthCardButton.prototype, "value", void 0);
    return AuthCardButton;
}($dA5cX.SerializableObject);
module.exports.AuthCardButton = $d8c6eedade336127$var$AuthCardButton;
var $d8c6eedade336127$var$TokenExchangeResource = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(TokenExchangeResource, _super);
    function TokenExchangeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenExchangeResource.prototype.getSchemaKey = function() {
        return "TokenExchangeResource";
    };
    //#region Schema
    TokenExchangeResource.idProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "id");
    TokenExchangeResource.uriProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "uri");
    TokenExchangeResource.providerIdProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "providerId");
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TokenExchangeResource.idProperty)
    ], TokenExchangeResource.prototype, "id", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TokenExchangeResource.uriProperty)
    ], TokenExchangeResource.prototype, "uri", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(TokenExchangeResource.providerIdProperty)
    ], TokenExchangeResource.prototype, "providerId", void 0);
    return TokenExchangeResource;
}($dA5cX.SerializableObject);
module.exports.TokenExchangeResource = $d8c6eedade336127$var$TokenExchangeResource;
var $d8c6eedade336127$var$Authentication = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(Authentication, _super);
    function Authentication() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Authentication.prototype.getSchemaKey = function() {
        return "Authentication";
    };
    //#region Schema
    Authentication.textProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "text");
    Authentication.connectionNameProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_4, "connectionName");
    Authentication.buttonsProperty = new $dA5cX.SerializableObjectCollectionProperty($dA5cX.Versions.v1_4, "buttons", $d8c6eedade336127$var$AuthCardButton);
    Authentication.tokenExchangeResourceProperty = new $dA5cX.SerializableObjectProperty($dA5cX.Versions.v1_4, "tokenExchangeResource", $d8c6eedade336127$var$TokenExchangeResource, true);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Authentication.textProperty)
    ], Authentication.prototype, "text", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Authentication.connectionNameProperty)
    ], Authentication.prototype, "connectionName", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Authentication.buttonsProperty)
    ], Authentication.prototype, "buttons", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(Authentication.tokenExchangeResourceProperty)
    ], Authentication.prototype, "tokenExchangeResource", void 0);
    return Authentication;
}($dA5cX.SerializableObject);
module.exports.Authentication = $d8c6eedade336127$var$Authentication;
// @dynamic
var $d8c6eedade336127$var$AdaptiveCard = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(AdaptiveCard, _super);
    function AdaptiveCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.designMode = false;
        return _this;
    }
    Object.defineProperty(AdaptiveCard.prototype, "refresh", {
        get: function() {
            return this.getValue(AdaptiveCard.refreshProperty);
        },
        set: function(value) {
            this.setValue(AdaptiveCard.refreshProperty, value);
            if (value) value.parent = this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard, "processMarkdown", {
        get: function() {
            throw new Error($luP4B.Strings.errors.processMarkdownEventRemoved());
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        set: function(_value) {
            throw new Error($luP4B.Strings.errors.processMarkdownEventRemoved());
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.applyMarkdown = function(text) {
        var result = {
            didProcess: false
        };
        if (AdaptiveCard.onProcessMarkdown) AdaptiveCard.onProcessMarkdown(text, result);
        else if (window.markdownit) {
            // Check for markdownit
            var markdownIt = window.markdownit;
            result.outputHtml = markdownIt().render(text);
            result.didProcess = true;
        } else if (!AdaptiveCard._haveWarnedAboutNoMarkdownProcessing) {
            // eslint-disable-next-line no-console
            console.warn($luP4B.Strings.errors.markdownProcessingNotEnabled);
            AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = true;
        }
        return result;
    };
    AdaptiveCard.prototype.isVersionSupported = function() {
        if (this.bypassVersionCheck) return true;
        else {
            var unsupportedVersion = !this.version || !this.version.isValid || this.maxVersion.major < this.version.major || this.maxVersion.major === this.version.major && this.maxVersion.minor < this.version.minor;
            return !unsupportedVersion;
        }
    };
    AdaptiveCard.prototype.getDefaultSerializationContext = function() {
        return new $d8c6eedade336127$var$SerializationContext(this.version);
    };
    AdaptiveCard.prototype.getItemsCollectionPropertyName = function() {
        return "body";
    };
    AdaptiveCard.prototype.internalParse = function(source, context) {
        this._fallbackCard = undefined;
        var fallbackElement = context.parseElement(undefined, source["fallback"], this.forbiddenChildElements(), !this.isDesignMode());
        if (fallbackElement) {
            this._fallbackCard = new AdaptiveCard();
            this._fallbackCard.addItem(fallbackElement);
        }
        _super.prototype.internalParse.call(this, source, context);
    };
    AdaptiveCard.prototype.internalToJSON = function(target, context) {
        this.setValue(AdaptiveCard.versionProperty, context.targetVersion);
        _super.prototype.internalToJSON.call(this, target, context);
    };
    AdaptiveCard.prototype.internalRender = function() {
        var renderedElement = _super.prototype.internalRender.call(this);
        if ($krmaK.GlobalSettings.useAdvancedCardBottomTruncation && renderedElement) // Unlike containers, the root card element should be allowed to
        // be shorter than its content (otherwise the overflow truncation
        // logic would never get triggered)
        renderedElement.style.removeProperty("minHeight");
        return renderedElement;
    };
    AdaptiveCard.prototype.getHasBackground = function(ignoreBackgroundImages) {
        if (ignoreBackgroundImages === void 0) ignoreBackgroundImages = false;
        return true;
    };
    AdaptiveCard.prototype.getDefaultPadding = function() {
        return new $krmaK.PaddingDefinition($4uYwi.Spacing.Padding, $4uYwi.Spacing.Padding, $4uYwi.Spacing.Padding, $4uYwi.Spacing.Padding);
    };
    AdaptiveCard.prototype.shouldSerialize = function(_context) {
        return true;
    };
    Object.defineProperty(AdaptiveCard.prototype, "renderIfEmpty", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "allowCustomStyle", {
        get: function() {
            return this.hostConfig.adaptiveCard && this.hostConfig.adaptiveCard.allowCustomStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdaptiveCard.prototype, "hasBackground", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.prototype.getJsonTypeName = function() {
        return "AdaptiveCard";
    };
    AdaptiveCard.prototype.internalValidateProperties = function(context) {
        _super.prototype.internalValidateProperties.call(this, context);
        if (this.getValue($d8c6eedade336127$var$CardElement.typeNameProperty) !== "AdaptiveCard") context.addFailure(this, $4uYwi.ValidationEvent.MissingCardType, $luP4B.Strings.errors.invalidCardType());
        if (!this.bypassVersionCheck && !this.version) context.addFailure(this, $4uYwi.ValidationEvent.PropertyCantBeNull, $luP4B.Strings.errors.propertyMustBeSet("version"));
        else if (!this.isVersionSupported()) context.addFailure(this, $4uYwi.ValidationEvent.UnsupportedCardVersion, $luP4B.Strings.errors.unsupportedCardVersion(this.version.toString(), this.maxVersion.toString()));
    };
    AdaptiveCard.prototype.render = function(target) {
        var _this = this;
        var renderedCard;
        if (this.shouldFallback() && this._fallbackCard) {
            this._fallbackCard.hostConfig = this.hostConfig;
            renderedCard = this._fallbackCard.render();
        } else {
            renderedCard = _super.prototype.render.call(this);
            if (renderedCard) {
                renderedCard.classList.add(this.hostConfig.makeCssClassName("ac-adaptiveCard"));
                // Having a tabIndex on the root container for a card can mess up accessibility in some scenarios.
                // However, we've shipped this behavior before, and so can't just turn it off in a point release. For
                // now, to unblock accessibility scenarios for our customers, we've got an option to turn it off. In a
                // future release, we should strongly consider flipping the default such that we *don't* emit a tabIndex
                // by default.
                if ($krmaK.GlobalSettings.setTabIndexAtCardRoot) renderedCard.tabIndex = 0;
                if (this.speak) renderedCard.setAttribute("aria-label", this.speak);
                renderedCard.onmouseenter = function(ev) {
                    _this.updateInputsVisualState(true);
                };
                renderedCard.onmouseleave = function(ev) {
                    _this.updateInputsVisualState(false);
                };
                this.getRootElement().updateActionsEnabledState();
            }
        }
        if (target) {
            $6EfR6.appendChild(target, renderedCard);
            this.updateLayout();
        }
        var inputElements = this.getAllInputs();
        document.onclick = function(event) {
            inputElements.forEach(function(input) {
                var _a, _b;
                if (input instanceof $d8c6eedade336127$var$ChoiceSetInput && !((_a = input.renderedElement) === null || _a === void 0 ? void 0 : _a.contains(event.target))) (_b = input.getDropdownElement()) === null || _b === void 0 || _b.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
            });
        };
        return renderedCard;
    };
    AdaptiveCard.prototype.updateLayout = function(processChildren) {
        if (processChildren === void 0) processChildren = true;
        _super.prototype.updateLayout.call(this, processChildren);
        if ($krmaK.GlobalSettings.useAdvancedCardBottomTruncation && this.isDisplayed()) {
            var padding = this.hostConfig.getEffectiveSpacing($4uYwi.Spacing.Default);
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            this["handleOverflow"](this.renderedElement.offsetHeight - padding);
        }
    };
    AdaptiveCard.prototype.shouldFallback = function() {
        return _super.prototype.shouldFallback.call(this) || !this.isVersionSupported();
    };
    Object.defineProperty(AdaptiveCard.prototype, "hasVisibleSeparator", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveCard.schemaUrl = "http://adaptivecards.io/schemas/adaptive-card.json";
    //#region Schema
    // eslint-disable-next-line @typescript-eslint/naming-convention
    AdaptiveCard.$schemaProperty = new $dA5cX.CustomProperty($dA5cX.Versions.v1_0, "$schema", function(sender, property, source, context) {
        return AdaptiveCard.schemaUrl;
    }, function(sender, prop, target, value, context) {
        context.serializeValue(target, prop.name, AdaptiveCard.schemaUrl);
    });
    AdaptiveCard.versionProperty = new $dA5cX.CustomProperty($dA5cX.Versions.v1_0, "version", function(sender, prop, source, context) {
        var version = $dA5cX.Version.parse(source[prop.name], context);
        if (version === undefined) {
            version = $dA5cX.Versions.latest;
            context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidCardVersion(version.toString()));
        }
        return version;
    }, function(sender, prop, target, value, context) {
        if (value !== undefined) context.serializeValue(target, prop.name, value.toString());
    }, $dA5cX.Versions.v1_0);
    AdaptiveCard.fallbackTextProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "fallbackText");
    AdaptiveCard.speakProperty = new $dA5cX.StringProperty($dA5cX.Versions.v1_0, "speak");
    AdaptiveCard.refreshProperty = new $dA5cX.SerializableObjectProperty($dA5cX.Versions.v1_4, "refresh", $d8c6eedade336127$var$RefreshDefinition, true);
    AdaptiveCard.authenticationProperty = new $dA5cX.SerializableObjectProperty($dA5cX.Versions.v1_4, "authentication", $d8c6eedade336127$var$Authentication, true);
    //#endregion
    AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = false;
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(AdaptiveCard.versionProperty)
    ], AdaptiveCard.prototype, "version", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(AdaptiveCard.fallbackTextProperty)
    ], AdaptiveCard.prototype, "fallbackText", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(AdaptiveCard.speakProperty)
    ], AdaptiveCard.prototype, "speak", void 0);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(AdaptiveCard.refreshProperty)
    ], AdaptiveCard.prototype, "refresh", null);
    $d8c6eedade336127$var$__decorate([
        (0, $dA5cX.property)(AdaptiveCard.authenticationProperty)
    ], AdaptiveCard.prototype, "authentication", void 0);
    return AdaptiveCard;
}($d8c6eedade336127$var$ContainerWithActions);
module.exports.AdaptiveCard = $d8c6eedade336127$var$AdaptiveCard;
var $d8c6eedade336127$var$InlineAdaptiveCard = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(InlineAdaptiveCard, _super);
    function InlineAdaptiveCard() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suppressStyle = false;
        return _this;
    }
    InlineAdaptiveCard.prototype.getSchemaKey = function() {
        return "InlineAdaptiveCard";
    };
    InlineAdaptiveCard.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        schema.remove($d8c6eedade336127$var$AdaptiveCard.$schemaProperty, $d8c6eedade336127$var$AdaptiveCard.versionProperty);
    };
    //#endregion
    InlineAdaptiveCard.prototype.getDefaultPadding = function() {
        return new $krmaK.PaddingDefinition(this.suppressStyle ? $4uYwi.Spacing.None : $4uYwi.Spacing.Padding, $4uYwi.Spacing.Padding, this.suppressStyle ? $4uYwi.Spacing.None : $4uYwi.Spacing.Padding, $4uYwi.Spacing.Padding);
    };
    Object.defineProperty(InlineAdaptiveCard.prototype, "bypassVersionCheck", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InlineAdaptiveCard.prototype, "defaultStyle", {
        get: function() {
            if (this.suppressStyle) return $4uYwi.ContainerStyle.Default;
            else return this.hostConfig.actions.showCard.style ? this.hostConfig.actions.showCard.style : $4uYwi.ContainerStyle.Emphasis;
        },
        enumerable: false,
        configurable: true
    });
    InlineAdaptiveCard.prototype.render = function(target) {
        var renderedCard = _super.prototype.render.call(this, target);
        if (renderedCard) {
            renderedCard.setAttribute("aria-live", "polite");
            renderedCard.removeAttribute("tabindex");
        }
        return renderedCard;
    };
    return InlineAdaptiveCard;
}($d8c6eedade336127$var$AdaptiveCard);
var $d8c6eedade336127$var$SerializationContext = /** @class */ function(_super) {
    $d8c6eedade336127$var$__extends(SerializationContext, _super);
    function SerializationContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._forbiddenTypes = new Set();
        return _this;
    }
    SerializationContext.prototype.internalParseCardObject = function(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent) {
        var _this = this;
        var result = undefined;
        if (source && typeof source === "object") {
            var oldForbiddenTypes_1 = new Set();
            this._forbiddenTypes.forEach(function(type) {
                oldForbiddenTypes_1.add(type);
            });
            forbiddenTypes.forEach(function(type) {
                _this._forbiddenTypes.add(type);
            });
            var typeName = $6EfR6.parseString(source["type"]);
            if (typeName && this._forbiddenTypes.has(typeName)) logParseEvent(typeName, $4uYwi.TypeErrorType.ForbiddenType);
            else {
                var tryToFallback = false;
                result = createInstanceCallback(typeName);
                if (!result) {
                    tryToFallback = $krmaK.GlobalSettings.enableFallback && allowFallback;
                    logParseEvent(typeName, $4uYwi.TypeErrorType.UnknownType);
                } else {
                    result.setParent(parent);
                    result.parse(source, this);
                    tryToFallback = $krmaK.GlobalSettings.enableFallback && allowFallback && result.shouldFallback();
                }
                if (tryToFallback) {
                    var fallback = source["fallback"];
                    if (!fallback && parent) parent.setShouldFallback(true);
                    if (typeof fallback === "string" && fallback.toLowerCase() === "drop") result = undefined;
                    else if (typeof fallback === "object") result = this.internalParseCardObject(parent, fallback, forbiddenTypes, true, createInstanceCallback, logParseEvent);
                }
            }
            this._forbiddenTypes = oldForbiddenTypes_1;
        }
        return result;
    };
    SerializationContext.prototype.cardObjectParsed = function(o, source) {
        if (o instanceof $d8c6eedade336127$var$Action && this.onParseAction) this.onParseAction(o, source, this);
        else if (o instanceof $d8c6eedade336127$var$CardElement && this.onParseElement) this.onParseElement(o, source, this);
    };
    SerializationContext.prototype.shouldSerialize = function(o) {
        if (o instanceof $d8c6eedade336127$var$Action) return this.actionRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else if (o instanceof $d8c6eedade336127$var$CardElement) return this.elementRegistry.findByName(o.getJsonTypeName()) !== undefined;
        else return true;
    };
    SerializationContext.prototype.parseCardObject = function(parent, source, forbiddenTypeNames, allowFallback, createInstanceCallback, logParseEvent) {
        var forbiddenTypes = new Set(forbiddenTypeNames);
        var result = this.internalParseCardObject(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent);
        if (result !== undefined) this.cardObjectParsed(result, source);
        return result;
    };
    SerializationContext.prototype.parseElement = function(parent, source, forbiddenTypes, allowFallback) {
        var _this = this;
        return this.parseCardObject(parent, source, forbiddenTypes, allowFallback, function(typeName) {
            return _this.elementRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $4uYwi.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $4uYwi.ValidationEvent.UnknownElementType, $luP4B.Strings.errors.unknownElementType(typeName));
            else _this.logParseEvent(undefined, $4uYwi.ValidationEvent.ElementTypeNotAllowed, $luP4B.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    SerializationContext.prototype.parseAction = function(parent, source, forbiddenActionTypes, allowFallback) {
        var _this = this;
        return this.parseCardObject(parent, source, forbiddenActionTypes, allowFallback, function(typeName) {
            return _this.actionRegistry.createInstance(typeName, _this.targetVersion);
        }, function(typeName, errorType) {
            if (errorType === $4uYwi.TypeErrorType.UnknownType) _this.logParseEvent(undefined, $4uYwi.ValidationEvent.UnknownActionType, $luP4B.Strings.errors.unknownActionType(typeName));
            else _this.logParseEvent(undefined, $4uYwi.ValidationEvent.ActionTypeNotAllowed, $luP4B.Strings.errors.actionTypeNotAllowed(typeName));
        });
    };
    Object.defineProperty(SerializationContext.prototype, "elementRegistry", {
        get: function() {
            var _a;
            return (_a = this._elementRegistry) !== null && _a !== void 0 ? _a : $4TaX1.GlobalRegistry.elements;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setElementRegistry = function(value) {
        this._elementRegistry = value;
    };
    Object.defineProperty(SerializationContext.prototype, "actionRegistry", {
        get: function() {
            var _a;
            return (_a = this._actionRegistry) !== null && _a !== void 0 ? _a : $4TaX1.GlobalRegistry.actions;
        },
        enumerable: false,
        configurable: true
    });
    // Not using a property setter here because the setter should accept "undefined"
    // whereas the getter should never return undefined.
    SerializationContext.prototype.setActionRegistry = function(value) {
        this._actionRegistry = value;
    };
    return SerializationContext;
}($dA5cX.BaseSerializationContext);
module.exports.SerializationContext = $d8c6eedade336127$var$SerializationContext;
$4TaX1.GlobalRegistry.defaultElements.register("Container", $d8c6eedade336127$var$Container);
$4TaX1.GlobalRegistry.defaultElements.register("TextBlock", $d8c6eedade336127$var$TextBlock);
$4TaX1.GlobalRegistry.defaultElements.register("RichTextBlock", $d8c6eedade336127$var$RichTextBlock, $dA5cX.Versions.v1_2);
$4TaX1.GlobalRegistry.defaultElements.register("TextRun", $d8c6eedade336127$var$TextRun, $dA5cX.Versions.v1_2);
$4TaX1.GlobalRegistry.defaultElements.register("Image", $d8c6eedade336127$var$Image);
$4TaX1.GlobalRegistry.defaultElements.register("ImageSet", $d8c6eedade336127$var$ImageSet);
$4TaX1.GlobalRegistry.defaultElements.register("Media", $d8c6eedade336127$var$Media, $dA5cX.Versions.v1_1);
$4TaX1.GlobalRegistry.defaultElements.register("FactSet", $d8c6eedade336127$var$FactSet);
$4TaX1.GlobalRegistry.defaultElements.register("ColumnSet", $d8c6eedade336127$var$ColumnSet);
$4TaX1.GlobalRegistry.defaultElements.register("ActionSet", $d8c6eedade336127$var$ActionSet, $dA5cX.Versions.v1_2);
$4TaX1.GlobalRegistry.defaultElements.register("Input.Text", $d8c6eedade336127$var$TextInput);
$4TaX1.GlobalRegistry.defaultElements.register("Input.Date", $d8c6eedade336127$var$DateInput);
$4TaX1.GlobalRegistry.defaultElements.register("Input.Time", $d8c6eedade336127$var$TimeInput);
$4TaX1.GlobalRegistry.defaultElements.register("Input.Number", $d8c6eedade336127$var$NumberInput);
$4TaX1.GlobalRegistry.defaultElements.register("Input.ChoiceSet", $d8c6eedade336127$var$ChoiceSetInput);
$4TaX1.GlobalRegistry.defaultElements.register("Input.Toggle", $d8c6eedade336127$var$ToggleInput);
$4TaX1.GlobalRegistry.defaultActions.register($d8c6eedade336127$var$OpenUrlAction.JsonTypeName, $d8c6eedade336127$var$OpenUrlAction);
$4TaX1.GlobalRegistry.defaultActions.register($d8c6eedade336127$var$SubmitAction.JsonTypeName, $d8c6eedade336127$var$SubmitAction);
$4TaX1.GlobalRegistry.defaultActions.register($d8c6eedade336127$var$ShowCardAction.JsonTypeName, $d8c6eedade336127$var$ShowCardAction);
$4TaX1.GlobalRegistry.defaultActions.register($d8c6eedade336127$var$ToggleVisibilityAction.JsonTypeName, $d8c6eedade336127$var$ToggleVisibilityAction, $dA5cX.Versions.v1_2);
$4TaX1.GlobalRegistry.defaultActions.register($d8c6eedade336127$var$ExecuteAction.JsonTypeName, $d8c6eedade336127$var$ExecuteAction, $dA5cX.Versions.v1_4);

});
parcelRegister("eDIVK", function(module, exports) {
"use strict";
var $aa878f6f237b2753$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatText = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $aa878f6f237b2753$var$AbstractTextFormatter = /** @class */ function() {
    function AbstractTextFormatter(regularExpression) {
        this._regularExpression = regularExpression;
    }
    AbstractTextFormatter.prototype.format = function(lang, input) {
        var matches;
        if (input) {
            var result = input;
            while((matches = this._regularExpression.exec(input)) != null)result = result.replace(matches[0], this.internalFormat(lang, matches));
            return result;
        } else return input;
    };
    return AbstractTextFormatter;
}();
var $aa878f6f237b2753$var$DateFormatter = /** @class */ function(_super) {
    $aa878f6f237b2753$var$__extends(DateFormatter, _super);
    function DateFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        var format = matches[2] !== undefined ? matches[2].toLowerCase() : "compact";
        if (format !== "compact") return date.toLocaleDateString(lang, {
            day: "numeric",
            weekday: format,
            month: format,
            year: "numeric"
        });
        else return date.toLocaleDateString();
    };
    return DateFormatter;
}($aa878f6f237b2753$var$AbstractTextFormatter);
var $aa878f6f237b2753$var$TimeFormatter = /** @class */ function(_super) {
    $aa878f6f237b2753$var$__extends(TimeFormatter, _super);
    function TimeFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeFormatter.prototype.internalFormat = function(lang, matches) {
        var date = new Date(Date.parse(matches[1]));
        return date.toLocaleTimeString(lang, {
            hour: "numeric",
            minute: "2-digit"
        });
    };
    return TimeFormatter;
}($aa878f6f237b2753$var$AbstractTextFormatter);
function $aa878f6f237b2753$var$formatText(lang, text) {
    var formatters = [
        new $aa878f6f237b2753$var$DateFormatter(/\{{2}DATE\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))(?:, ?(COMPACT|LONG|SHORT))?\)\}{2}/g),
        new $aa878f6f237b2753$var$TimeFormatter(/\{{2}TIME\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))\)\}{2}/g)
    ];
    var result = text;
    for(var _i = 0, formatters_1 = formatters; _i < formatters_1.length; _i++){
        var formatter = formatters_1[_i];
        result = formatter.format(lang, result);
    }
    return result;
}
module.exports.formatText = $aa878f6f237b2753$var$formatText;

});

parcelRegister("eH86Z", function(module, exports) {
"use strict";
var $ab2b5fa748bc0e9c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ab2b5fa748bc0e9c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) $ab2b5fa748bc0e9c$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// Copyright (C) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$ab2b5fa748bc0e9c$var$__exportStar((parcelRequire("h7yKy")), module.exports);

$ab2b5fa748bc0e9c$var$__exportStar((parcelRequire("ialW6")), module.exports);

});
parcelRegister("h7yKy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MenuItem = void 0;

var $icYWo = parcelRequire("icYWo");

var $l9Sw8 = parcelRequire("l9Sw8");
var $c76e0bb42850fcbb$var$MenuItem = /** @class */ function() {
    function MenuItem(key, value) {
        this._isEnabled = true;
        this.key = key;
        this._value = value;
    }
    MenuItem.prototype.click = function() {
        if (this.isEnabled && this.onClick) this.onClick(this);
    };
    MenuItem.prototype.updateCssClasses = function() {
        if (this._element) {
            var effectiveHostConfig = this._hostConfig ? this._hostConfig : $icYWo.defaultHostConfig;
            this._element.className = effectiveHostConfig.makeCssClassName("ac-ctrl");
            this._element.classList.add(effectiveHostConfig.makeCssClassName(this.isEnabled ? "ac-ctrl-dropdown-item" : "ac-ctrl-dropdown-item-disabled"));
            if (!this.isEnabled) this._element.classList.add(effectiveHostConfig.makeCssClassName("ac-disabled"));
        }
    };
    MenuItem.prototype.toString = function() {
        return this.value;
    };
    MenuItem.prototype.render = function(hostConfig) {
        var _this = this;
        this._hostConfig = hostConfig;
        if (!this._element) {
            this._element = document.createElement("span");
            this._element.innerText = this.value;
            this._element.setAttribute("role", "menuitem");
            if (!this.isEnabled) this._element.setAttribute("aria-disabled", "true");
            this._element.setAttribute("aria-current", "false");
            this._element.onmouseup = function(_e) {
                _this.click();
            };
            this._element.onkeydown = function(e) {
                if (e.key === $l9Sw8.Constants.keys.enter) {
                    e.cancelBubble = true;
                    _this.click();
                }
            };
            this.updateCssClasses();
        }
        return this._element;
    };
    Object.defineProperty(MenuItem.prototype, "value", {
        get: function() {
            return this._value;
        },
        set: function(newValue) {
            this._value = newValue;
            if (this._element) this._element.innerText = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItem.prototype, "isEnabled", {
        get: function() {
            return this._isEnabled;
        },
        set: function(value) {
            if (this._isEnabled !== value) {
                this._isEnabled = value;
                this.updateCssClasses();
            }
        },
        enumerable: false,
        configurable: true
    });
    return MenuItem;
}();
module.exports.MenuItem = $c76e0bb42850fcbb$var$MenuItem;

});
parcelRegister("l9Sw8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Constants = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var $f674ba421eb3ba86$var$Constants = /** @class */ function() {
    function Constants() {}
    Constants.keys = {
        tab: "Tab",
        enter: "Enter",
        escape: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        delete: "Delete"
    };
    return Constants;
}();
module.exports.Constants = $f674ba421eb3ba86$var$Constants;

});


parcelRegister("ialW6", function(module, exports) {
"use strict";
var $d39a2d36e7132e99$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupMenu = void 0;

var $l9Sw8 = parcelRequire("l9Sw8");

var $28AtQ = parcelRequire("28AtQ");

var $jchf9 = parcelRequire("jchf9");
var $d39a2d36e7132e99$var$PopupMenu = /** @class */ function(_super) {
    $d39a2d36e7132e99$var$__extends(PopupMenu, _super);
    function PopupMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = new $28AtQ.Collection();
        _this._renderedItems = [];
        _this._selectedIndex = -1;
        return _this;
    }
    PopupMenu.prototype.renderContent = function() {
        var element = document.createElement("div");
        element.className = this.hostConfig.makeCssClassName("ac-ctrl ac-popup");
        element.setAttribute("role", "listbox");
        for(var i = 0; i < this._items.length; i++){
            var renderedItem = this._items.get(i).render(this.hostConfig);
            renderedItem.tabIndex = 0;
            element.appendChild(renderedItem);
            if (i === this.selectedIndex) renderedItem.focus();
            this._renderedItems.push(renderedItem);
        }
        return element;
    };
    PopupMenu.prototype.keyDown = function(e) {
        _super.prototype.keyDown.call(this, e);
        var selectedItemIndex = this._selectedIndex;
        switch(e.key){
            case $l9Sw8.Constants.keys.tab:
                this.closePopup(true);
                break;
            /*
            case Constants.keys.enter:
                if (this.selectedIndex >= 0) {
                    this.selectedIndex = this.selectedIndex;

                    this.close();
                }

                break;
            */ case $l9Sw8.Constants.keys.up:
                if (selectedItemIndex <= 0) selectedItemIndex = this._renderedItems.length - 1;
                else {
                    selectedItemIndex--;
                    if (selectedItemIndex < 0) selectedItemIndex = this._renderedItems.length - 1;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
            case $l9Sw8.Constants.keys.down:
                if (selectedItemIndex < 0) selectedItemIndex = 0;
                else {
                    selectedItemIndex++;
                    if (selectedItemIndex >= this._renderedItems.length) selectedItemIndex = 0;
                }
                this.selectedIndex = selectedItemIndex;
                e.cancelBubble = true;
                break;
        }
    };
    Object.defineProperty(PopupMenu.prototype, "items", {
        get: function() {
            return this._items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupMenu.prototype, "selectedIndex", {
        get: function() {
            return this._selectedIndex;
        },
        set: function(index) {
            if (index >= 0 && index < this._renderedItems.length) {
                this._renderedItems[index].focus();
                this._selectedIndex = index;
            }
        },
        enumerable: false,
        configurable: true
    });
    return PopupMenu;
}($jchf9.PopupControl);
module.exports.PopupMenu = $d39a2d36e7132e99$var$PopupMenu;

});
parcelRegister("28AtQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collection = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $18e8a05f4a6a70df$var$Collection = /** @class */ function() {
    function Collection() {
        this._items = [];
    }
    Collection.prototype.get = function(index) {
        return this._items[index];
    };
    Collection.prototype.add = function(item) {
        this._items.push(item);
        if (this.onItemAdded) this.onItemAdded(item);
    };
    Collection.prototype.remove = function(item) {
        var i = this._items.indexOf(item);
        if (i >= 0) {
            this._items = this._items.splice(i, 1);
            if (this.onItemRemoved) this.onItemRemoved(item);
        }
    };
    Collection.prototype.indexOf = function(item) {
        return this._items.indexOf(item);
    };
    Object.defineProperty(Collection.prototype, "length", {
        get: function() {
            return this._items.length;
        },
        enumerable: false,
        configurable: true
    });
    return Collection;
}();
module.exports.Collection = $18e8a05f4a6a70df$var$Collection;

});

parcelRegister("jchf9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PopupControl = void 0;

var $l9Sw8 = parcelRequire("l9Sw8");

var $6EfR6 = parcelRequire("6EfR6");

var $icYWo = parcelRequire("icYWo");
var $df9c83759abe8270$var$PopupControl = /** @class */ function() {
    function PopupControl() {
        this._isOpen = false;
    }
    PopupControl.prototype.keyDown = function(e) {
        switch(e.key){
            case $l9Sw8.Constants.keys.escape:
                this.closePopup(true);
                break;
        }
    };
    PopupControl.prototype.render = function(_rootElementBounds) {
        var _this = this;
        var element = document.createElement("div");
        element.tabIndex = 0;
        element.className = this.hostConfig.makeCssClassName("ac-ctrl", "ac-ctrl-popup-container");
        element.setAttribute("role", "dialog");
        element.setAttribute("aria-modal", "true");
        element.onkeydown = function(e) {
            _this.keyDown(e);
            return !e.cancelBubble;
        };
        element.appendChild(this.renderContent());
        return element;
    };
    PopupControl.prototype.focus = function() {
        if (this._popupElement) this._popupElement.firstElementChild.focus();
    };
    PopupControl.prototype.popup = function(rootElement) {
        var _a, _b, _c, _d, _f;
        var _this = this;
        if (!this._isOpen) {
            this._overlayElement = document.createElement("div");
            this._overlayElement.className = this.hostConfig.makeCssClassName("ac-ctrl-overlay");
            this._overlayElement.tabIndex = 0;
            this._overlayElement.style.width = document.documentElement.scrollWidth + "px";
            this._overlayElement.style.height = document.documentElement.scrollHeight + "px";
            this._overlayElement.onfocus = function(_e) {
                _this.closePopup(true);
            };
            document.body.appendChild(this._overlayElement);
            var rootElementBounds = rootElement.getBoundingClientRect();
            this._popupElement = this.render(rootElementBounds);
            (_a = this._popupElement.classList).remove.apply(_a, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight", "ac-ctrl-slideRightToLeft", "ac-ctrl-slideTopToBottom", "ac-ctrl-slideRightToLeft"));
            window.addEventListener("resize", function(_e) {
                _this.closePopup(true);
            });
            var rootElementLabel = rootElement.getAttribute("aria-label");
            if (rootElementLabel) this._popupElement.setAttribute("aria-label", rootElementLabel);
            this._overlayElement.appendChild(this._popupElement);
            var popupElementBounds = this._popupElement.getBoundingClientRect();
            var availableSpaceBelow = window.innerHeight - rootElementBounds.bottom;
            var availableSpaceAbove = rootElementBounds.top;
            var availableSpaceRight = window.innerWidth - rootElementBounds.right;
            var availableSpaceLeft = rootElementBounds.left;
            var left = rootElementBounds.left + $6EfR6.getScrollX();
            var top_1;
            if (availableSpaceAbove < popupElementBounds.height && availableSpaceBelow < popupElementBounds.height) {
                // Not enough space above or below root element
                var actualPopupHeight = Math.min(popupElementBounds.height, window.innerHeight);
                this._popupElement.style.maxHeight = actualPopupHeight + "px";
                if (actualPopupHeight < popupElementBounds.height) top_1 = $6EfR6.getScrollY();
                else top_1 = $6EfR6.getScrollY() + rootElementBounds.top + (rootElementBounds.height - actualPopupHeight) / 2;
                if (availableSpaceLeft < popupElementBounds.width && availableSpaceRight < popupElementBounds.width) {
                    // Not enough space left or right of root element
                    var actualPopupWidth = Math.min(popupElementBounds.width, window.innerWidth);
                    this._popupElement.style.maxWidth = actualPopupWidth + "px";
                    if (actualPopupWidth < popupElementBounds.width) left = $6EfR6.getScrollX();
                    else left = $6EfR6.getScrollX() + rootElementBounds.left + (rootElementBounds.width - actualPopupWidth) / 2;
                } else // Enough space on the left or right of the root element
                if (availableSpaceRight >= popupElementBounds.width) {
                    left = $6EfR6.getScrollX() + rootElementBounds.right;
                    (_b = this._popupElement.classList).add.apply(_b, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideLeftToRight"));
                } else {
                    left = $6EfR6.getScrollX() + rootElementBounds.left - popupElementBounds.width;
                    (_c = this._popupElement.classList).add.apply(_c, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideRightToLeft"));
                }
            } else {
                // Enough space above or below root element
                if (availableSpaceBelow >= popupElementBounds.height) {
                    top_1 = $6EfR6.getScrollY() + rootElementBounds.bottom;
                    (_d = this._popupElement.classList).add.apply(_d, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideTopToBottom"));
                } else {
                    top_1 = $6EfR6.getScrollY() + rootElementBounds.top - popupElementBounds.height;
                    (_f = this._popupElement.classList).add.apply(_f, this.hostConfig.makeCssClassNames("ac-ctrl-slide", "ac-ctrl-slideBottomToTop"));
                }
                if (availableSpaceRight < popupElementBounds.width) left = $6EfR6.getScrollX() + rootElementBounds.right - popupElementBounds.width;
            }
            this._popupElement.style.left = left + "px";
            this._popupElement.style.top = top_1 + "px";
            this._popupElement.focus();
            this._isOpen = true;
        }
    };
    PopupControl.prototype.closePopup = function(wasCancelled) {
        if (this._isOpen) {
            document.body.removeChild(this._overlayElement);
            this._isOpen = false;
            if (this.onClose) this.onClose(this, wasCancelled);
        }
    };
    Object.defineProperty(PopupControl.prototype, "hostConfig", {
        get: function() {
            return this._hostConfig ? this._hostConfig : $icYWo.defaultHostConfig;
        },
        set: function(value) {
            this._hostConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PopupControl.prototype, "isOpen", {
        get: function() {
            return this._isOpen;
        },
        enumerable: false,
        configurable: true
    });
    return PopupControl;
}();
module.exports.PopupControl = $df9c83759abe8270$var$PopupControl;

});




parcelRegister("5TiFc", function(module, exports) {
"use strict";
var $011b5d2d6e7e6270$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $011b5d2d6e7e6270$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $011b5d2d6e7e6270$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CarouselEvent = module.exports.Carousel = module.exports.CarouselPage = void 0;

var $iBTKZ = parcelRequire("iBTKZ");

var $4uYwi = parcelRequire("4uYwi");

var $dA5cX = parcelRequire("dA5cX");

var $4TaX1 = parcelRequire("4TaX1");

var $4uYwi = parcelRequire("4uYwi");

var $luP4B = parcelRequire("luP4B");
parcelRequire("gDp0b");
var $g4zLJ = parcelRequire("g4zLJ");
var $fHuP7 = parcelRequire("fHuP7");
var $hej2P = parcelRequire("hej2P");
var $a9amb = parcelRequire("a9amb");
var $68aNx = parcelRequire("68aNx");
var $lLTYX = parcelRequire("lLTYX");
var $lSZ1k = parcelRequire("lSZ1k");
var $fFmdt = parcelRequire("fFmdt");

var $6EfR6 = parcelRequire("6EfR6");

var $krmaK = parcelRequire("krmaK");
// Note: to function correctly, consumers need to have CSS from swiper/css, swiper/css/pagination, and
// swiper/css/navigation
var $011b5d2d6e7e6270$var$CarouselPage = /** @class */ function(_super) {
    $011b5d2d6e7e6270$var$__extends(CarouselPage, _super);
    function CarouselPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#region Schema
    CarouselPage.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // `style`, `bleed`, `isVisible` are not supported in CarouselPage
        schema.remove($iBTKZ.Container.styleProperty);
        schema.remove($iBTKZ.Container.bleedProperty);
        schema.remove($iBTKZ.Container.isVisibleProperty);
    };
    //#endregion
    CarouselPage.prototype.internalRender = function() {
        var carouselSlide = document.createElement("div");
        carouselSlide.className = this.hostConfig.makeCssClassName("swiper-slide");
        // `isRtl()` will set the correct value of rtl by reading the value from the parents
        this.rtl = this.isRtl();
        var renderedElement = _super.prototype.internalRender.call(this);
        $6EfR6.appendChild(carouselSlide, renderedElement);
        return carouselSlide;
    };
    CarouselPage.prototype.getForbiddenActionTypes = function() {
        return [
            $iBTKZ.ShowCardAction,
            $iBTKZ.ToggleVisibilityAction
        ];
    };
    CarouselPage.prototype.getForbiddenChildElements = function() {
        return this.forbiddenChildElements();
    };
    CarouselPage.prototype.forbiddenChildElements = function() {
        return $011b5d2d6e7e6270$var$__spreadArray([
            $iBTKZ.ToggleVisibilityAction.JsonTypeName,
            $iBTKZ.ShowCardAction.JsonTypeName,
            "Media",
            "ActionSet",
            "Input.Text",
            "Input.Date",
            "Input.Time",
            "Input.Number",
            "Input.ChoiceSet",
            "Input.Toggle",
            "Carousel"
        ], _super.prototype.forbiddenChildElements.call(this), true);
    };
    CarouselPage.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.setShouldFallback(false);
    };
    CarouselPage.prototype.shouldSerialize = function(_context) {
        return true;
    };
    CarouselPage.prototype.getJsonTypeName = function() {
        return "CarouselPage";
    };
    Object.defineProperty(CarouselPage.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarouselPage.prototype, "hasVisibleSeparator", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return CarouselPage;
}($iBTKZ.Container);
module.exports.CarouselPage = $011b5d2d6e7e6270$var$CarouselPage;
var $011b5d2d6e7e6270$var$Carousel = /** @class */ function(_super) {
    $011b5d2d6e7e6270$var$__extends(Carousel, _super);
    function Carousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.carouselLoop = true;
        _this.carouselOrientation = $4uYwi.Orientation.Horizontal;
        _this._pages = [];
        _this._currentIndex = 0;
        _this._previousEventType = $4uYwi.CarouselInteractionEvent.Pagination;
        return _this;
    }
    //#region Schema
    Carousel.prototype.populateSchema = function(schema) {
        _super.prototype.populateSchema.call(this, schema);
        // `style`, `bleed`, `isVisible` are not supported in Carousel
        schema.remove($iBTKZ.Container.styleProperty);
        schema.remove($iBTKZ.Container.bleedProperty);
        schema.remove($iBTKZ.Container.isVisibleProperty);
    };
    Object.defineProperty(Carousel.prototype, "timer", {
        get: function() {
            var timer = this.getValue(Carousel.timerProperty);
            if (timer && timer < this.hostConfig.carousel.minAutoplayDelay) {
                console.warn($luP4B.Strings.errors.tooLittleTimeDelay);
                timer = this.hostConfig.carousel.minAutoplayDelay;
            }
            return timer;
        },
        set: function(value) {
            if (value && value < this.hostConfig.carousel.minAutoplayDelay) {
                console.warn($luP4B.Strings.errors.tooLittleTimeDelay);
                this.setValue(Carousel.timerProperty, this.hostConfig.carousel.minAutoplayDelay);
            } else this.setValue(Carousel.timerProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "initialPageIndex", {
        get: function() {
            return this.getValue(Carousel.initialPageProperty);
        },
        set: function(value) {
            if (this.isValidParsedPageIndex(value)) this.setValue(Carousel.initialPageProperty, value);
            else {
                console.warn($luP4B.Strings.errors.invalidInitialPageIndex(value));
                this.setValue(Carousel.initialPageProperty, 0);
            }
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.isValidParsedPageIndex = function(index) {
        return this._pages ? this.isValidPageIndex(index, this._pages.length) : false;
    };
    Carousel.prototype.isValidRenderedPageIndex = function(index) {
        return this._renderedPages ? this.isValidPageIndex(index, this._renderedPages.length) : false;
    };
    Carousel.prototype.isValidPageIndex = function(index, collectionSize) {
        return collectionSize > 0 && 0 <= index && index < collectionSize;
    };
    Object.defineProperty(Carousel.prototype, "previousEventType", {
        //#endregion
        get: function() {
            return this._previousEventType;
        },
        set: function(eventType) {
            this._previousEventType = eventType;
        },
        enumerable: false,
        configurable: true
    });
    // Question: Why do we place this on the Carousel instead of the CarouselPage?
    Carousel.prototype.forbiddenChildElements = function() {
        return $011b5d2d6e7e6270$var$__spreadArray([
            $iBTKZ.ToggleVisibilityAction.JsonTypeName,
            $iBTKZ.ShowCardAction.JsonTypeName,
            "Media",
            "ActionSet",
            "Input.Text",
            "Input.Date",
            "Input.Time",
            "Input.Number",
            "Input.ChoiceSet",
            "Input.Toggle"
        ], _super.prototype.forbiddenChildElements.call(this), true);
    };
    Carousel.prototype.adjustRenderedElementSize = function(renderedElement) {
        _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
        if (this.height == "stretch" && this._containerForAdorners !== undefined) this._containerForAdorners.style.height = "100%";
        // Assign the explicit height to carouselPageContainer if given
        if (this.carouselHeight) this._carouselPageContainer.style.height = this.carouselHeight + "px";
    };
    Carousel.prototype.getJsonTypeName = function() {
        return "Carousel";
    };
    Carousel.prototype.getItemCount = function() {
        return this._pages.length;
    };
    Carousel.prototype.getItemAt = function(index) {
        return this._pages[index];
    };
    Carousel.prototype.addPage = function(page) {
        this._pages.push(page);
        page.setParent(this);
    };
    Carousel.prototype.removeItem = function(item) {
        if (item instanceof $011b5d2d6e7e6270$var$CarouselPage) {
            var itemIndex = this._pages.indexOf(item);
            if (itemIndex >= 0) {
                this._pages.splice(itemIndex, 1);
                item.setParent(undefined);
                this.updateLayout();
                return true;
            }
        }
        return false;
    };
    Carousel.prototype.getFirstVisibleRenderedItem = function() {
        var _a;
        if (this.renderedElement && ((_a = this._renderedPages) === null || _a === void 0 ? void 0 : _a.length) > 0) return this._renderedPages[0];
        else return undefined;
    };
    Carousel.prototype.getLastVisibleRenderedItem = function() {
        var _a;
        if (this.renderedElement && ((_a = this._renderedPages) === null || _a === void 0 ? void 0 : _a.length) > 0) return this._renderedPages[this._renderedPages.length - 1];
        else return undefined;
    };
    Object.defineProperty(Carousel.prototype, "currentPageId", {
        get: function() {
            var _a, _b;
            if ((_b = (_a = this._carousel) === null || _a === void 0 ? void 0 : _a.slides) === null || _b === void 0 ? void 0 : _b.length) {
                var activeSlide = this._carousel.slides[this._carousel.activeIndex];
                return activeSlide.id;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "currentPageIndex", {
        get: function() {
            var _a;
            return (_a = this._carousel) === null || _a === void 0 ? void 0 : _a.realIndex;
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._pages = [];
        var jsonPages = source["pages"];
        if (Array.isArray(jsonPages)) for(var _i = 0, jsonPages_1 = jsonPages; _i < jsonPages_1.length; _i++){
            var item = jsonPages_1[_i];
            var page = this.createCarouselPageInstance(item, context);
            if (page) this._pages.push(page);
        }
        // everything is parsed do validate on initial page index
        this.validateParsing(context);
    };
    Carousel.prototype.validateParsing = function(context) {
        if (!this.isValidParsedPageIndex(this.initialPageIndex)) context.logParseEvent(this, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidInitialPageIndex(this.initialPageIndex));
    };
    Carousel.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, "pages", this._pages);
    };
    Carousel.prototype.internalRender = function() {
        var _a;
        this._renderedPages = [];
        if (this._pages.length <= 0) return undefined;
        this.validateOrientationProperties();
        var cardLevelContainer = document.createElement("div");
        cardLevelContainer.className = this.hostConfig.makeCssClassName("ac-carousel-card-level-container");
        var carouselContainer = document.createElement("div");
        carouselContainer.className = this.hostConfig.makeCssClassName("swiper", "ac-carousel");
        this._carouselPageContainer = carouselContainer;
        var containerForAdorners = document.createElement("div");
        containerForAdorners.className = this.hostConfig.makeCssClassName("ac-carousel-container");
        this._containerForAdorners = containerForAdorners;
        cardLevelContainer.appendChild(containerForAdorners);
        var navigationContainer = document.createElement("div");
        navigationContainer.className = this.hostConfig.makeCssClassName("ac-carousel-navigation");
        containerForAdorners.appendChild(navigationContainer);
        var carouselWrapper = document.createElement("div");
        carouselWrapper.className = this.hostConfig.makeCssClassName("swiper-wrapper", "ac-carousel-card-container");
        carouselWrapper.style.display = "flex";
        switch(this.getEffectiveVerticalContentAlignment()){
            case $4uYwi.VerticalAlignment.Top:
                carouselWrapper.style.alignItems = "flex-start";
                break;
            case $4uYwi.VerticalAlignment.Bottom:
                carouselWrapper.style.alignItems = "flex-end";
                break;
            default:
                carouselWrapper.style.alignItems = "center";
                break;
        }
        if ($krmaK.GlobalSettings.useAdvancedCardBottomTruncation) // Forces the container to be at least as tall as its content.
        //
        // Fixes a quirk in Chrome where, for nested flex elements, the
        // inner element's height would never exceed the outer element's
        // height. This caused overflow truncation to break -- containers
        // would always be measured as not overflowing, since their heights
        // were constrained by their parents as opposed to truly reflecting
        // the height of their content.
        //
        // See the "Browser Rendering Notes" section of this answer:
        // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
        carouselWrapper.style.minHeight = "-webkit-min-content";
        var prevElementDiv = document.createElement("div");
        prevElementDiv.className = this.hostConfig.makeCssClassName("swiper-button-prev");
        var nextElementDiv = document.createElement("div");
        nextElementDiv.className = this.hostConfig.makeCssClassName("swiper-button-next");
        if (this.carouselOrientation === $4uYwi.Orientation.Horizontal) this.updateCssForHorizontalCarousel(prevElementDiv, nextElementDiv);
        else this.updateCssForVerticalCarousel(navigationContainer, prevElementDiv, nextElementDiv);
        var pagination = document.createElement("div");
        pagination.className = this.hostConfig.makeCssClassName("swiper-pagination", "ac-carousel-pagination");
        navigationContainer.appendChild(prevElementDiv);
        $6EfR6.addCancelSelectActionEventHandler(prevElementDiv);
        navigationContainer.appendChild(pagination);
        $6EfR6.addCancelSelectActionEventHandler(pagination);
        navigationContainer.appendChild(nextElementDiv);
        $6EfR6.addCancelSelectActionEventHandler(nextElementDiv);
        if (this.isDesignMode()) {
            // If we are in design mode, we need to ensure these elements are in front of the peers
            prevElementDiv.style.zIndex = "20";
            nextElementDiv.style.zIndex = "20";
            pagination.style.zIndex = "20";
        }
        var requestedNumberOfPages = Math.min(this._pages.length, this.hostConfig.carousel.maxCarouselPages);
        if (this._pages.length > this.hostConfig.carousel.maxCarouselPages) console.warn($luP4B.Strings.errors.tooManyCarouselPages);
        if (this._pages.length > 0) for(var i = 0; i < requestedNumberOfPages; i++){
            var page = this._pages[i];
            var renderedItem = this.isElementAllowed(page) ? page.render() : undefined;
            renderedItem === null || renderedItem === void 0 || renderedItem.classList.add("ac-carousel-page");
            (_a = renderedItem === null || renderedItem === void 0 ? void 0 : renderedItem.children[0]) === null || _a === void 0 || _a.classList.add("ac-carousel-page-container");
            if (renderedItem) {
                $6EfR6.appendChild(carouselWrapper, renderedItem);
                this._renderedPages.push(page);
            }
        }
        carouselContainer.appendChild(carouselWrapper);
        carouselContainer.tabIndex = this.isDesignMode() ? -1 : 0;
        containerForAdorners.appendChild(carouselContainer);
        // `isRtl()` will set the correct value of rtl by reading the value from the parents
        this.rtl = this.isRtl();
        this.applyRTL(pagination);
        if (!this.isDesignMode()) {
            if (this.isValidRenderedPageIndex(this.initialPageIndex)) this._currentIndex = this.initialPageIndex;
            else {
                console.warn($luP4B.Strings.errors.invalidInitialPageIndex(this.initialPageIndex));
                this._currentIndex = 0;
            }
        }
        this.initializeCarouselControl(carouselContainer, nextElementDiv, prevElementDiv, pagination, this.rtl);
        return this._renderedPages.length > 0 ? cardLevelContainer : undefined;
    };
    Carousel.prototype.applyRTL = function(pagination) {
        _super.prototype.applyRTL.call(this, this._carouselPageContainer);
        if (this.rtl) pagination.classList.add(this.hostConfig.makeCssClassName("ac-carousel-pagination-rtl"));
    };
    Carousel.prototype.validateOrientationProperties = function() {
        if (!this.carouselHeight) this.carouselOrientation = $4uYwi.Orientation.Horizontal;
    };
    Carousel.prototype.updateCssForHorizontalCarousel = function(prevElementDiv, nextElementDiv) {
        prevElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-left"));
        nextElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-right"));
    };
    Carousel.prototype.updateCssForVerticalCarousel = function(navigationContainer, prevElementDiv, nextElementDiv) {
        this._containerForAdorners.classList.add(this.hostConfig.makeCssClassName("ac-carousel-container-vertical"));
        navigationContainer.classList.add(this.hostConfig.makeCssClassName("ac-carousel-navigation-vertical"));
        prevElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-up"));
        nextElementDiv.classList.add(this.hostConfig.makeCssClassName("ac-carousel-down"));
    };
    Carousel.prototype.initializeCarouselControl = function(carouselContainer, nextElement, prevElement, paginationElement, rtl) {
        var _this = this;
        var _a, _b, _c;
        var nextElementAdjustedForRtl = rtl === undefined || !rtl ? nextElement : prevElement;
        var prevElementAdjustedForRtl = rtl === undefined || !rtl ? prevElement : nextElement;
        var prevElementAdjustedForOrientation = $4uYwi.Orientation.Horizontal === this.carouselOrientation ? prevElementAdjustedForRtl : prevElement;
        var nextElementAdjustedForOrientation = $4uYwi.Orientation.Horizontal === this.carouselOrientation ? nextElementAdjustedForRtl : nextElement;
        var swiperOptions = {
            loop: !this.isDesignMode() && this.carouselLoop,
            modules: [
                $68aNx.default,
                $lLTYX.default,
                $lSZ1k.default,
                $g4zLJ.default,
                $hej2P.default,
                $a9amb.default
            ],
            pagination: {
                el: paginationElement,
                clickable: true
            },
            navigation: {
                prevEl: prevElementAdjustedForOrientation,
                nextEl: nextElementAdjustedForOrientation
            },
            a11y: {
                enabled: true
            },
            keyboard: {
                enabled: false,
                onlyInViewport: true
            },
            direction: this.carouselOrientation === $4uYwi.Orientation.Horizontal ? "horizontal" : "vertical",
            resizeObserver: false,
            initialSlide: this._currentIndex
        };
        if (this.timer && !this.isDesignMode()) {
            (_a = swiperOptions.modules) === null || _a === void 0 || _a.push($fHuP7.default);
            swiperOptions.autoplay = {
                delay: this.timer,
                pauseOnMouseEnter: true
            };
        }
        var carousel = new $fFmdt.default(carouselContainer, swiperOptions);
        // While the 'pauseOnMouseEnter' option should resume autoplay on
        // mouse exit it doesn't do it, so adding custom events to handle it
        carouselContainer.addEventListener("mouseenter", function(_event) {
            var _a;
            (_a = carousel.autoplay) === null || _a === void 0 || _a.stop();
        });
        carouselContainer.addEventListener("mouseleave", function(_event) {
            var _a;
            (_a = carousel.autoplay) === null || _a === void 0 || _a.start();
        });
        carousel.on("navigationNext", function(swiper) {
            _this.raiseCarouselEvent($4uYwi.CarouselInteractionEvent.NavigationNext);
        });
        carousel.on("navigationPrev", function(swiper) {
            _this.raiseCarouselEvent($4uYwi.CarouselInteractionEvent.NavigationPrevious);
        });
        carousel.on("slideChangeTransitionEnd", function(swiper) {
            _this.currentIndex = swiper.realIndex;
            _this.raiseCarouselEvent($4uYwi.CarouselInteractionEvent.Pagination);
        });
        carousel.on("autoplay", function() {
            _this.raiseCarouselEvent($4uYwi.CarouselInteractionEvent.Autoplay);
        });
        carousel.on("paginationRender", function(swiper, paginationEl) {
            swiper.pagination.bullets.forEach(function(bullet, index) {
                bullet.addEventListener("keypress", function(event) {
                    if (event.key == "Enter") {
                        event.preventDefault();
                        swiper.slideTo(index + 1);
                    }
                });
            });
        });
        carousel.on("destroy", function() {
            _this.destroyResizeObserver();
        });
        prevElement.title = (_b = prevElement.ariaLabel) !== null && _b !== void 0 ? _b : $luP4B.Strings.defaults.carouselNavigationPreviousTooltip();
        nextElement.title = (_c = nextElement.ariaLabel) !== null && _c !== void 0 ? _c : $luP4B.Strings.defaults.carouselNavigationNextTooltip();
        this._carousel = carousel;
        this.createResizeObserver();
    };
    Carousel.prototype.createCarouselPageInstance = function(source, context) {
        return context.parseCardObject(this, source, this.forbiddenChildElements(), !this.isDesignMode(), function(typeName) {
            return !typeName || typeName === "CarouselPage" ? new $011b5d2d6e7e6270$var$CarouselPage() : undefined;
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $4uYwi.ValidationEvent.ElementTypeNotAllowed, $luP4B.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    Carousel.prototype.slideTo = function(index) {
        var _a;
        (_a = this._carousel) === null || _a === void 0 || _a.slideTo(index);
    };
    Object.defineProperty(Carousel.prototype, "carouselPageContainer", {
        get: function() {
            return this._carouselPageContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "currentIndex", {
        get: function() {
            return this._currentIndex;
        },
        set: function(currentIndex) {
            this._currentIndex = currentIndex;
        },
        enumerable: false,
        configurable: true
    });
    Carousel.prototype.createCarouselEvent = function(type) {
        var currentPageId;
        if (this.currentPageIndex != undefined) currentPageId = this.getItemAt(this.currentPageIndex).id;
        return new $011b5d2d6e7e6270$var$CarouselEvent(type, this.id, currentPageId, this.currentPageIndex);
    };
    Carousel.prototype.raiseCarouselEvent = function(eventType) {
        var card = this.parent ? this.parent.getRootElement() : undefined;
        var onCarouselEventHandler = card && card.onCarouselEvent ? card.onCarouselEvent : $iBTKZ.AdaptiveCard.onCarouselEvent;
        // pagination event is triggered on slide transition end event 
        if (onCarouselEventHandler && eventType == $4uYwi.CarouselInteractionEvent.Pagination) // returns the event type that causes slide transition
        onCarouselEventHandler(this.createCarouselEvent(this.previousEventType));
        this.previousEventType = eventType;
    };
    /// Swiper version 8 added requestAnimationFrame() call in its resize observer code
    /// The new call causes flickering issue,
    /// We've copied resize observer code from Swiper version 7 with some modifications
    Carousel.prototype.createResizeObserver = function() {
        var _this = this;
        var _a;
        if (!this.checkIfCarouselInValidStateForResizeEvent()) return;
        this._observer = new ResizeObserver(function(entries) {
            var _a, _b, _c, _d;
            var width = (_a = _this._carousel) === null || _a === void 0 ? void 0 : _a.width;
            var height = (_b = _this._carousel) === null || _b === void 0 ? void 0 : _b.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function(_a) {
                var _b;
                var contentBoxSize = _a.contentBoxSize, contentRect = _a.contentRect, target = _a.target;
                if (target && target !== ((_b = _this._carousel) === null || _b === void 0 ? void 0 : _b.el)) return;
                newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) {
                if (_this.checkIfCarouselInValidStateForResizeEvent()) {
                    (_c = _this._carousel) === null || _c === void 0 || _c.emit("beforeResize");
                    (_d = _this._carousel) === null || _d === void 0 || _d.emit("resize");
                }
            }
        });
        this._observer.observe((_a = this._carousel) === null || _a === void 0 ? void 0 : _a.el);
    };
    Carousel.prototype.destroyResizeObserver = function() {
        var _a;
        if (this._observer && this._observer.unobserve && ((_a = this._carousel) === null || _a === void 0 ? void 0 : _a.el)) {
            this._observer.unobserve(this._carousel.el);
            this._observer = null;
        }
    };
    Carousel.prototype.checkIfCarouselInValidStateForResizeEvent = function() {
        return this._carousel && !this._carousel.destroyed;
    };
    Carousel.timerProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_6, "timer", undefined);
    Carousel.initialPageProperty = new $dA5cX.NumProperty($dA5cX.Versions.v1_6, "initialPage", 0);
    Carousel.loopProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_6, "loop", true);
    Carousel.orientationProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_6, "orientation", $4uYwi.Orientation, $4uYwi.Orientation.Horizontal);
    Carousel.carouselHeightProperty = new $dA5cX.PixelSizeProperty($dA5cX.Versions.v1_6, "heightInPixels");
    $011b5d2d6e7e6270$var$__decorate([
        (0, $dA5cX.property)(Carousel.timerProperty)
    ], Carousel.prototype, "timer", null);
    $011b5d2d6e7e6270$var$__decorate([
        (0, $dA5cX.property)(Carousel.initialPageProperty)
    ], Carousel.prototype, "initialPageIndex", null);
    $011b5d2d6e7e6270$var$__decorate([
        (0, $dA5cX.property)(Carousel.loopProperty)
    ], Carousel.prototype, "carouselLoop", void 0);
    $011b5d2d6e7e6270$var$__decorate([
        (0, $dA5cX.property)(Carousel.orientationProperty)
    ], Carousel.prototype, "carouselOrientation", void 0);
    $011b5d2d6e7e6270$var$__decorate([
        (0, $dA5cX.property)(Carousel.carouselHeightProperty)
    ], Carousel.prototype, "carouselHeight", void 0);
    return Carousel;
}($iBTKZ.Container);
module.exports.Carousel = $011b5d2d6e7e6270$var$Carousel;
var $011b5d2d6e7e6270$var$CarouselEvent = /** @class */ function() {
    function CarouselEvent(type, carouselId, activeCarouselPageId, activeCarouselPageIndex) {
        this.type = type;
        this.carouselId = carouselId;
        this.activeCarouselPageId = activeCarouselPageId;
        this.activeCarouselPageIndex = activeCarouselPageIndex;
    }
    return CarouselEvent;
}();
module.exports.CarouselEvent = $011b5d2d6e7e6270$var$CarouselEvent;
$4TaX1.GlobalRegistry.defaultElements.register("Carousel", $011b5d2d6e7e6270$var$Carousel, $dA5cX.Versions.v1_6);

});
parcelRegister("gDp0b", function(module, exports) {

$parcel$export(module.exports, "Swiper", () => (parcelRequire("fFmdt")).default);
$parcel$export(module.exports, "Keyboard", () => (parcelRequire("a9amb")).default);
$parcel$export(module.exports, "Navigation", () => (parcelRequire("68aNx")).default);
$parcel$export(module.exports, "Pagination", () => (parcelRequire("lLTYX")).default);
$parcel$export(module.exports, "Scrollbar", () => (parcelRequire("lSZ1k")).default);
$parcel$export(module.exports, "A11y", () => (parcelRequire("g4zLJ")).default);
$parcel$export(module.exports, "History", () => (parcelRequire("hej2P")).default);
$parcel$export(module.exports, "Autoplay", () => (parcelRequire("fHuP7")).default);
/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ 
var $fFmdt = parcelRequire("fFmdt");

var $629iZ = parcelRequire("629iZ");

var $a9amb = parcelRequire("a9amb");

var $2wVML = parcelRequire("2wVML");

var $68aNx = parcelRequire("68aNx");

var $lLTYX = parcelRequire("lLTYX");

var $lSZ1k = parcelRequire("lSZ1k");

var $gBMuC = parcelRequire("gBMuC");

var $4izHL = parcelRequire("4izHL");

var $Vfci2 = parcelRequire("Vfci2");

var $4vY60 = parcelRequire("4vY60");

var $g4zLJ = parcelRequire("g4zLJ");

var $hej2P = parcelRequire("hej2P");

var $6tg80 = parcelRequire("6tg80");

var $fHuP7 = parcelRequire("fHuP7");

var $3LDuZ = parcelRequire("3LDuZ");

var $1e0qN = parcelRequire("1e0qN");

var $3Bgzs = parcelRequire("3Bgzs");

var $jbTEe = parcelRequire("jbTEe");

var $c5fUf = parcelRequire("c5fUf");

var $iYXoD = parcelRequire("iYXoD");

var $gYF09 = parcelRequire("gYF09");

var $efsTi = parcelRequire("efsTi");

var $3UuMB = parcelRequire("3UuMB");

var $8Sfjh = parcelRequire("8Sfjh");

});
parcelRegister("fFmdt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b67beb12004d4eaf$export$2e2bcd8739ae039);
/* eslint no-param-reassign: "off" */ 
var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");

var $aRn8z = parcelRequire("aRn8z");

var $9BUZY = parcelRequire("9BUZY");

var $9gver = parcelRequire("9gver");

var $bXJqH = parcelRequire("bXJqH");

var $8CKP7 = parcelRequire("8CKP7");

var $lHsTe = parcelRequire("lHsTe");

var $3Ha1n = parcelRequire("3Ha1n");

var $cdydt = parcelRequire("cdydt");

var $eGzUU = parcelRequire("eGzUU");

var $bvd35 = parcelRequire("bvd35");

var $cK6ta = parcelRequire("cK6ta");

var $cub6L = parcelRequire("cub6L");

var $gbZz5 = parcelRequire("gbZz5");

var $cSzjC = parcelRequire("cSzjC");

var $2ed62 = parcelRequire("2ed62");

var $4XpkI = parcelRequire("4XpkI");

var $iuX65 = parcelRequire("iuX65");

var $e2LtX = parcelRequire("e2LtX");

var $7FcRu = parcelRequire("7FcRu");

var $91wPx = parcelRequire("91wPx");
const $b67beb12004d4eaf$var$prototypes = {
    eventsEmitter: $3Ha1n.default,
    update: $cdydt.default,
    translate: $eGzUU.default,
    transition: $bvd35.default,
    slide: $cK6ta.default,
    loop: $cub6L.default,
    grabCursor: $gbZz5.default,
    events: $cSzjC.default,
    breakpoints: $2ed62.default,
    checkOverflow: $e2LtX.default,
    classes: $4XpkI.default,
    images: $iuX65.default
};
const $b67beb12004d4eaf$var$extendedDefaults = {};
class $b67beb12004d4eaf$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $aRn8z.extend)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $4ADnt.default)(params.el).length > 1) {
            const swipers = [];
            (0, $4ADnt.default)(params.el).each((containerEl)=>{
                const newParams = (0, $aRn8z.extend)({}, params, {
                    el: containerEl
                });
                swipers.push(new $b67beb12004d4eaf$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $9BUZY.getSupport)();
        swiper.device = (0, $9gver.getDevice)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $bXJqH.getBrowser)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $91wPx.default)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $aRn8z.extend)({}, (0, $7FcRu.default), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $aRn8z.extend)({}, swiperParams, $b67beb12004d4eaf$var$extendedDefaults, params);
        swiper.originalParams = (0, $aRn8z.extend)({}, swiper.params);
        swiper.passedParams = (0, $aRn8z.extend)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $4ADnt.default); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $4ADnt.default)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel"
                ];
                const desktop = [
                    "pointerdown",
                    "pointermove",
                    "pointerup"
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $aRn8z.now)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper"); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $4ADnt.default)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $4ADnt.default)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $4ADnt.default)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $2iHxd.getDocument)();
            const wrapper = document.createElement("div");
            $wrapperEl = (0, $4ADnt.default)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
            wrongRTL: $wrapperEl.css("display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit"); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy"); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr("style");
            $wrapperEl.removeAttr("style");
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
        }
        swiper.emit("destroy"); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $aRn8z.deleteProps)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $aRn8z.extend)($b67beb12004d4eaf$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $b67beb12004d4eaf$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $7FcRu.default;
    }
    static installModule(mod) {
        if (!$b67beb12004d4eaf$var$Swiper.prototype.__modules__) $b67beb12004d4eaf$var$Swiper.prototype.__modules__ = [];
        const modules = $b67beb12004d4eaf$var$Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$b67beb12004d4eaf$var$Swiper.installModule(m));
            return $b67beb12004d4eaf$var$Swiper;
        }
        $b67beb12004d4eaf$var$Swiper.installModule(module);
        return $b67beb12004d4eaf$var$Swiper;
    }
}
Object.keys($b67beb12004d4eaf$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($b67beb12004d4eaf$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $b67beb12004d4eaf$var$Swiper.prototype[protoMethod] = $b67beb12004d4eaf$var$prototypes[prototypeGroup][protoMethod];
    });
});
$b67beb12004d4eaf$var$Swiper.use([
    (0, $8CKP7.default),
    (0, $lHsTe.default)
]);
var $b67beb12004d4eaf$export$2e2bcd8739ae039 = $b67beb12004d4eaf$var$Swiper;

});
parcelRegister("2iHxd", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $1acf084b7c5c48cd$export$f65ca476c09acec0);
$parcel$export(module.exports, "getWindow", () => $1acf084b7c5c48cd$export$38b2d434cce3ea22);
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $1acf084b7c5c48cd$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $1acf084b7c5c48cd$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($1acf084b7c5c48cd$var$isObject(src[key]) && $1acf084b7c5c48cd$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $1acf084b7c5c48cd$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $1acf084b7c5c48cd$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $1acf084b7c5c48cd$export$f65ca476c09acec0() {
    const doc = typeof document !== "undefined" ? document : {};
    $1acf084b7c5c48cd$export$8b58be045bf06082(doc, $1acf084b7c5c48cd$export$3fdcb9b4d81368d8);
    return doc;
}
const $1acf084b7c5c48cd$export$8582633f185c62bb = {
    document: $1acf084b7c5c48cd$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $1acf084b7c5c48cd$export$38b2d434cce3ea22() {
    const win = typeof window !== "undefined" ? window : {};
    $1acf084b7c5c48cd$export$8b58be045bf06082(win, $1acf084b7c5c48cd$export$8582633f185c62bb);
    return win;
}

});

parcelRegister("4ADnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $357911cf31e1128c$export$2e2bcd8739ae039);

var $kUuVS = parcelRequire("kUuVS");
const $357911cf31e1128c$var$Methods = {
    addClass: $kUuVS.addClass,
    removeClass: $kUuVS.removeClass,
    hasClass: $kUuVS.hasClass,
    toggleClass: $kUuVS.toggleClass,
    attr: $kUuVS.attr,
    removeAttr: $kUuVS.removeAttr,
    transform: $kUuVS.transform,
    transition: $kUuVS.transition,
    on: $kUuVS.on,
    off: $kUuVS.off,
    trigger: $kUuVS.trigger,
    transitionEnd: $kUuVS.transitionEnd,
    outerWidth: $kUuVS.outerWidth,
    outerHeight: $kUuVS.outerHeight,
    styles: $kUuVS.styles,
    offset: $kUuVS.offset,
    css: $kUuVS.css,
    each: $kUuVS.each,
    html: $kUuVS.html,
    text: $kUuVS.text,
    is: $kUuVS.is,
    index: $kUuVS.index,
    eq: $kUuVS.eq,
    append: $kUuVS.append,
    prepend: $kUuVS.prepend,
    next: $kUuVS.next,
    nextAll: $kUuVS.nextAll,
    prev: $kUuVS.prev,
    prevAll: $kUuVS.prevAll,
    parent: $kUuVS.parent,
    parents: $kUuVS.parents,
    closest: $kUuVS.closest,
    find: $kUuVS.find,
    children: $kUuVS.children,
    filter: $kUuVS.filter,
    remove: $kUuVS.remove
};
Object.keys($357911cf31e1128c$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $kUuVS.$).fn, methodName, {
        value: $357911cf31e1128c$var$Methods[methodName],
        writable: true
    });
});
var $357911cf31e1128c$export$2e2bcd8739ae039 = (0, $kUuVS.$);

});
parcelRegister("kUuVS", function(module, exports) {

$parcel$export(module.exports, "$", () => $);
$parcel$export(module.exports, "addClass", () => addClass);
$parcel$export(module.exports, "removeClass", () => removeClass);
$parcel$export(module.exports, "toggleClass", () => toggleClass);
$parcel$export(module.exports, "hasClass", () => hasClass);
$parcel$export(module.exports, "attr", () => attr);
$parcel$export(module.exports, "removeAttr", () => removeAttr);
$parcel$export(module.exports, "transform", () => transform);
$parcel$export(module.exports, "transition", () => transition);
$parcel$export(module.exports, "on", () => on);
$parcel$export(module.exports, "off", () => off);
$parcel$export(module.exports, "trigger", () => trigger);
$parcel$export(module.exports, "transitionEnd", () => transitionEnd);
$parcel$export(module.exports, "outerWidth", () => outerWidth);
$parcel$export(module.exports, "outerHeight", () => outerHeight);
$parcel$export(module.exports, "offset", () => offset);
$parcel$export(module.exports, "styles", () => styles);
$parcel$export(module.exports, "css", () => css);
$parcel$export(module.exports, "each", () => each);
$parcel$export(module.exports, "filter", () => filter);
$parcel$export(module.exports, "html", () => html);
$parcel$export(module.exports, "text", () => text);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "index", () => index);
$parcel$export(module.exports, "eq", () => eq);
$parcel$export(module.exports, "append", () => append);
$parcel$export(module.exports, "prepend", () => prepend);
$parcel$export(module.exports, "next", () => next);
$parcel$export(module.exports, "nextAll", () => nextAll);
$parcel$export(module.exports, "prev", () => prev);
$parcel$export(module.exports, "prevAll", () => prevAll);
$parcel$export(module.exports, "parent", () => parent);
$parcel$export(module.exports, "parents", () => parents);
$parcel$export(module.exports, "closest", () => closest);
$parcel$export(module.exports, "find", () => find);
$parcel$export(module.exports, "children", () => children);
$parcel$export(module.exports, "remove", () => remove);
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $2iHxd = parcelRequire("2iHxd");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, "__proto__", {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === "number") super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== "string") return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $2iHxd.getWindow)();
    const document = (0, $2iHxd.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === "string") {
        const html = selector.trim();
        if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
            let toCreate = "div";
            if (html.indexOf("<li") === 0) toCreate = "ul";
            if (html.indexOf("<tr") === 0) toCreate = "tbody";
            if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0) toCreate = "tr";
            if (html.indexOf("<tbody") === 0) toCreate = "table";
            if (html.indexOf("<option") === 0) toCreate = "select";
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === "undefined") {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf("data-") >= 0) dataset[toCamelCase(attr.name.split("data-")[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === "undefined") {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === "select") {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === "select") for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== "string" ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(" ");
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(" ");
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $2iHxd.getWindow)();
    const events = args[0].split(" ");
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionstart", fireCallBack);
    }
    if (callback) dom.on("transitionstart", fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionend", fireCallBack);
    }
    if (callback) dom.on("transitionend", fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("animationend", fireCallBack);
    }
    if (callback) dom.on("animationend", fireCallBack);
    return this;
}
function width() {
    const window = (0, $2iHxd.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css("width"));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue("margin-right")) + parseFloat(styles.getPropertyValue("margin-left"));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $2iHxd.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css("height"));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue("margin-top")) + parseFloat(styles.getPropertyValue("margin-bottom"));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $2iHxd.getWindow)();
        const document = (0, $2iHxd.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = "none";
    return this;
}
function show() {
    const window = (0, $2iHxd.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === "none") el.style.display = "";
        if (window.getComputedStyle(el, null).getPropertyValue("display") === "none") // Still not visible
        el.style.display = "block";
    }
    return this;
}
function styles() {
    const window = (0, $2iHxd.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $2iHxd.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === "string") {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === "string") {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === "undefined") return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === "undefined") return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $2iHxd.getWindow)();
    const document = (0, $2iHxd.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === "undefined") return false;
    if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === "undefined") return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $2iHxd.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === "string") {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $2iHxd.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === "string") {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === "undefined") return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = "";
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $2iHxd.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === "undefined") easing = "swing";
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") easing = "swing";
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === "linear" ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $2iHxd.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: "swing" // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === "swing") return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === "function") return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(",", ".");
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, "");
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === "stop") animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = "resize scroll".split(" ");
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === "undefined") {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut("click");
const blur = shortcut("blur");
const focus = shortcut("focus");
const focusin = shortcut("focusin");
const focusout = shortcut("focusout");
const keyup = shortcut("keyup");
const keydown = shortcut("keydown");
const keypress = shortcut("keypress");
const submit = shortcut("submit");
const change = shortcut("change");
const mousedown = shortcut("mousedown");
const mousemove = shortcut("mousemove");
const mouseup = shortcut("mouseup");
const mouseenter = shortcut("mouseenter");
const mouseleave = shortcut("mouseleave");
const mouseout = shortcut("mouseout");
const mouseover = shortcut("mouseover");
const touchstart = shortcut("touchstart");
const touchend = shortcut("touchend");
const touchmove = shortcut("touchmove");
const resize = shortcut("resize");
const scroll = shortcut("scroll");
var $f391082c90127bb3$export$2e2bcd8739ae039 = $;

});


parcelRegister("aRn8z", function(module, exports) {

$parcel$export(module.exports, "deleteProps", () => $7e80cd37d9547361$export$8694e5c03a4df8e6);
$parcel$export(module.exports, "nextTick", () => $7e80cd37d9547361$export$bdd553fddd433dcb);
$parcel$export(module.exports, "now", () => $7e80cd37d9547361$export$461939dd4422153);
$parcel$export(module.exports, "getTranslate", () => $7e80cd37d9547361$export$5ec402b7fcf74398);
$parcel$export(module.exports, "isObject", () => $7e80cd37d9547361$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "extend", () => $7e80cd37d9547361$export$8b58be045bf06082);
$parcel$export(module.exports, "setCSSProperty", () => $7e80cd37d9547361$export$a607267f322101fd);
$parcel$export(module.exports, "animateCSSModeScroll", () => $7e80cd37d9547361$export$a5dd2b4b1a116d6d);

var $2iHxd = parcelRequire("2iHxd");
function $7e80cd37d9547361$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $7e80cd37d9547361$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $7e80cd37d9547361$export$461939dd4422153() {
    return Date.now();
}
function $7e80cd37d9547361$export$3735103072e4a80(el) {
    const window1 = (0, $2iHxd.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $7e80cd37d9547361$export$5ec402b7fcf74398(el, axis = "x") {
    const window1 = (0, $2iHxd.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $7e80cd37d9547361$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $7e80cd37d9547361$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $7e80cd37d9547361$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $7e80cd37d9547361$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$7e80cd37d9547361$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($7e80cd37d9547361$export$a6cdc56e425d0d0a(to[nextKey]) && $7e80cd37d9547361$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $7e80cd37d9547361$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$7e80cd37d9547361$export$a6cdc56e425d0d0a(to[nextKey]) && $7e80cd37d9547361$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $7e80cd37d9547361$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $7e80cd37d9547361$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $7e80cd37d9547361$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $2iHxd.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}

});

parcelRegister("9BUZY", function(module, exports) {

$parcel$export(module.exports, "getSupport", () => $6ff3c87f2b39ded7$export$d61c7b85ff180578);

var $2iHxd = parcelRequire("2iHxd");
let $6ff3c87f2b39ded7$var$support;
function $6ff3c87f2b39ded7$var$calcSupport() {
    const window = (0, $2iHxd.getWindow)();
    const document = (0, $2iHxd.getDocument)();
    return {
        smoothScroll: document.documentElement && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassiveListener", null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in window;
        }()
    };
}
function $6ff3c87f2b39ded7$export$d61c7b85ff180578() {
    if (!$6ff3c87f2b39ded7$var$support) $6ff3c87f2b39ded7$var$support = $6ff3c87f2b39ded7$var$calcSupport();
    return $6ff3c87f2b39ded7$var$support;
}

});

parcelRegister("9gver", function(module, exports) {

$parcel$export(module.exports, "getDevice", () => $6bedd5b1caa0b288$export$30c823bc834d6ab4);

var $2iHxd = parcelRequire("2iHxd");

var $9BUZY = parcelRequire("9BUZY");
let $6bedd5b1caa0b288$var$deviceCached;
function $6bedd5b1caa0b288$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $9BUZY.getSupport)();
    const window = (0, $2iHxd.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel"; // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    } // Export object
    return device;
}
function $6bedd5b1caa0b288$export$30c823bc834d6ab4(overrides = {}) {
    if (!$6bedd5b1caa0b288$var$deviceCached) $6bedd5b1caa0b288$var$deviceCached = $6bedd5b1caa0b288$var$calcDevice(overrides);
    return $6bedd5b1caa0b288$var$deviceCached;
}

});

parcelRegister("bXJqH", function(module, exports) {

$parcel$export(module.exports, "getBrowser", () => $8b5871c200db1cac$export$89e15fc796a4a429);

var $2iHxd = parcelRequire("2iHxd");
let $8b5871c200db1cac$var$browser;
function $8b5871c200db1cac$var$calcBrowser() {
    const window = (0, $2iHxd.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $8b5871c200db1cac$export$89e15fc796a4a429() {
    if (!$8b5871c200db1cac$var$browser) $8b5871c200db1cac$var$browser = $8b5871c200db1cac$var$calcBrowser();
    return $8b5871c200db1cac$var$browser;
}

});

parcelRegister("8CKP7", function(module, exports) {

$parcel$export(module.exports, "default", () => $64763181301e0c98$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");
function $64763181301e0c98$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $2iHxd.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}

});

parcelRegister("lHsTe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcc406120a631147$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");
function $fcc406120a631147$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $2iHxd.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}

});

parcelRegister("3Ha1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b0d2946631bf6c5$export$2e2bcd8739ae039);
/* eslint-disable no-underscore-dangle */ var $2b0d2946631bf6c5$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};

});

parcelRegister("cdydt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e513d922b04eddd$export$2e2bcd8739ae039);

var $jXK8T = parcelRequire("jXK8T");

var $6d1Aj = parcelRequire("6d1Aj");

var $bYyR7 = parcelRequire("bYyR7");

var $9G9XR = parcelRequire("9G9XR");

var $art9l = parcelRequire("art9l");

var $6op9r = parcelRequire("6op9r");

var $04OCv = parcelRequire("04OCv");

var $5l1OV = parcelRequire("5l1OV");

var $jsiaC = parcelRequire("jsiaC");
var $8e513d922b04eddd$export$2e2bcd8739ae039 = {
    updateSize: $jXK8T.default,
    updateSlides: $6d1Aj.default,
    updateAutoHeight: $bYyR7.default,
    updateSlidesOffset: $9G9XR.default,
    updateSlidesProgress: $art9l.default,
    updateProgress: $6op9r.default,
    updateSlidesClasses: $04OCv.default,
    updateActiveIndex: $5l1OV.default,
    updateClickedSlide: $jsiaC.default
};

});
parcelRegister("jXK8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88751ed64d7f19a$export$2e2bcd8739ae039);
function $e88751ed64d7f19a$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
    height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}

});

parcelRegister("6d1Aj", function(module, exports) {

$parcel$export(module.exports, "default", () => $48552fa926249387$export$2e2bcd8739ae039);

var $aRn8z = parcelRequire("aRn8z");
function $48552fa926249387$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginBottom: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: "",
        marginTop: ""
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $aRn8z.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-before", "");
        (0, $aRn8z.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = "none";
            if (currentWebKitTransform) slide[0].style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $aRn8z.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $aRn8z.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}

});

parcelRegister("bYyR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8055f2a1041e18$export$2e2bcd8739ae039);

var $4ADnt = parcelRequire("4ADnt");
function $8b8055f2a1041e18$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $4ADnt.default)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css("height", `${newHeight}px`);
}

});

parcelRegister("9G9XR", function(module, exports) {

$parcel$export(module.exports, "default", () => $70bfc404d62ba8a7$export$2e2bcd8739ae039);
function $70bfc404d62ba8a7$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}

});

parcelRegister("art9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $79a30986184c7987$export$2e2bcd8739ae039);

var $4ADnt = parcelRequire("4ADnt");
function $79a30986184c7987$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $4ADnt.default)(swiper.visibleSlides);
}

});

parcelRegister("6op9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a787e7c330100b0$export$2e2bcd8739ae039);
function $4a787e7c330100b0$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}

});

parcelRegister("04OCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e7a3eb08f93ec6$export$2e2bcd8739ae039);
function $00e7a3eb08f93ec6$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}

});

parcelRegister("5l1OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e3053635f209b8f$export$2e2bcd8739ae039);
function $3e3053635f209b8f$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === "undefined") {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}

});

parcelRegister("jsiaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29eba0f60c09bcc$export$2e2bcd8739ae039);

var $4ADnt = parcelRequire("4ADnt");
function $e29eba0f60c09bcc$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $4ADnt.default)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $4ADnt.default)(slide).attr("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}

});


parcelRegister("eGzUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab10d94b4c1030ba$export$2e2bcd8739ae039);

var $6DHWn = parcelRequire("6DHWn");

var $bVZ0y = parcelRequire("bVZ0y");

var $3wkwj = parcelRequire("3wkwj");

var $hMinR = parcelRequire("hMinR");

var $2F9ef = parcelRequire("2F9ef");
var $ab10d94b4c1030ba$export$2e2bcd8739ae039 = {
    getTranslate: $6DHWn.default,
    setTranslate: $bVZ0y.default,
    minTranslate: $3wkwj.default,
    maxTranslate: $hMinR.default,
    translateTo: $2F9ef.default
};

});
parcelRegister("6DHWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d58784bddac589b$export$2e2bcd8739ae039);

var $aRn8z = parcelRequire("aRn8z");
function $4d58784bddac589b$export$2e2bcd8739ae039(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $aRn8z.getTranslate)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}

});

parcelRegister("bVZ0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b04577aad199f61$export$2e2bcd8739ae039);
function $8b04577aad199f61$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}

});

parcelRegister("3wkwj", function(module, exports) {

$parcel$export(module.exports, "default", () => $29044724767a6ce3$export$2e2bcd8739ae039);
function $29044724767a6ce3$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}

});

parcelRegister("hMinR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf152e087273d5ab$export$2e2bcd8739ae039);
function $cf152e087273d5ab$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}

});

parcelRegister("2F9ef", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f0691bc07325ffa$export$2e2bcd8739ae039);

var $aRn8z = parcelRequire("aRn8z");
function $1f0691bc07325ffa$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $aRn8z.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}

});


parcelRegister("bvd35", function(module, exports) {

$parcel$export(module.exports, "default", () => $85fcb62e766c13e8$export$2e2bcd8739ae039);

var $gwueO = parcelRequire("gwueO");

var $3iLzz = parcelRequire("3iLzz");

var $2vKYR = parcelRequire("2vKYR");
var $85fcb62e766c13e8$export$2e2bcd8739ae039 = {
    setTransition: $gwueO.default,
    transitionStart: $3iLzz.default,
    transitionEnd: $2vKYR.default
};

});
parcelRegister("gwueO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c07717216779ad60$export$2e2bcd8739ae039);
function $c07717216779ad60$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit("setTransition", duration, byController);
}

});

parcelRegister("3iLzz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2677f47b6af7c9fd$export$2e2bcd8739ae039);

var $fAh2y = parcelRequire("fAh2y");
function $2677f47b6af7c9fd$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $fAh2y.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}

});
parcelRegister("fAh2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ed8a0ee971d542$export$2e2bcd8739ae039);
function $02ed8a0ee971d542$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}

});


parcelRegister("2vKYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d42eb642c13bb99$export$2e2bcd8739ae039);

var $fAh2y = parcelRequire("fAh2y");
function $1d42eb642c13bb99$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $fAh2y.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}

});


parcelRegister("cK6ta", function(module, exports) {

$parcel$export(module.exports, "default", () => $946ecc9b622cb711$export$2e2bcd8739ae039);

var $ImQNz = parcelRequire("ImQNz");

var $jZ4K8 = parcelRequire("jZ4K8");

var $3idlJ = parcelRequire("3idlJ");

var $l4dRH = parcelRequire("l4dRH");

var $dE473 = parcelRequire("dE473");

var $6FJK3 = parcelRequire("6FJK3");

var $96gaa = parcelRequire("96gaa");
var $946ecc9b622cb711$export$2e2bcd8739ae039 = {
    slideTo: $ImQNz.default,
    slideToLoop: $jZ4K8.default,
    slideNext: $3idlJ.default,
    slidePrev: $l4dRH.default,
    slideReset: $dE473.default,
    slideToClosest: $6FJK3.default,
    slideToClickedSlide: $96gaa.default
};

});
parcelRegister("ImQNz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0855d5d386d74468$export$2e2bcd8739ae039);

var $aRn8z = parcelRequire("aRn8z");
function $0855d5d386d74468$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== "number" && typeof index !== "string") throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset"; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $aRn8z.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}

});

parcelRegister("jZ4K8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c764aff465d2c6$export$2e2bcd8739ae039);
function $e8c764aff465d2c6$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

});

parcelRegister("3idlJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $265d687e1eec5636$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $265d687e1eec5636$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

});

parcelRegister("l4dRH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f564ba01fec4476f$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $f564ba01fec4476f$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

});

parcelRegister("dE473", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef2338263311b72$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $9ef2338263311b72$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

});

parcelRegister("6FJK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dba0dc33eed0a0e$export$2e2bcd8739ae039);
/* eslint no-unused-vars: "off" */ function $4dba0dc33eed0a0e$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}

});

parcelRegister("96gaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a013634c34b0eb0$export$2e2bcd8739ae039);

var $4ADnt = parcelRequire("4ADnt");

var $aRn8z = parcelRequire("aRn8z");
function $6a013634c34b0eb0$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $4ADnt.default)(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $aRn8z.nextTick)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $aRn8z.nextTick)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}

});


parcelRegister("cub6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $9170e73d532f20f9$export$2e2bcd8739ae039);

var $j0Bf8 = parcelRequire("j0Bf8");

var $cfLbT = parcelRequire("cfLbT");

var $dSijR = parcelRequire("dSijR");
var $9170e73d532f20f9$export$2e2bcd8739ae039 = {
    loopCreate: $j0Bf8.default,
    loopFix: $cfLbT.default,
    loopDestroy: $dSijR.default
};

});
parcelRegister("j0Bf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6ae818a4dd811e$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");
function $dd6ae818a4dd811e$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $2iHxd.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $4ADnt.default)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $4ADnt.default)(document.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $4ADnt.default)(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $4ADnt.default)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $4ADnt.default)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}

});

parcelRegister("cfLbT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ebb7dd9155f5e78$export$2e2bcd8739ae039);
function $8ebb7dd9155f5e78$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit("beforeLoopFix");
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
}

});

parcelRegister("dSijR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a19e8759b0da6532$export$2e2bcd8739ae039);
function $a19e8759b0da6532$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr("data-swiper-slide-index");
}

});


parcelRegister("gbZz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9d6de8dfb013ec$export$2e2bcd8739ae039);

var $NsKOn = parcelRequire("NsKOn");

var $jNCyH = parcelRequire("jNCyH");
var $bc9d6de8dfb013ec$export$2e2bcd8739ae039 = {
    setGrabCursor: $NsKOn.default,
    unsetGrabCursor: $jNCyH.default
};

});
parcelRegister("NsKOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $094ae1ab034a16dd$export$2e2bcd8739ae039);
function $094ae1ab034a16dd$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
}

});

parcelRegister("jNCyH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6a080e4613b5a64$export$2e2bcd8739ae039);
function $e6a080e4613b5a64$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}

});


parcelRegister("cSzjC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9605ec1960a4b72a$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");

var $9DvVm = parcelRequire("9DvVm");

var $dNuTe = parcelRequire("dNuTe");

var $3AYyc = parcelRequire("3AYyc");

var $4fOIc = parcelRequire("4fOIc");

var $18JYh = parcelRequire("18JYh");

var $XCX3i = parcelRequire("XCX3i");
let $9605ec1960a4b72a$var$dummyEventAttached = false;
function $9605ec1960a4b72a$var$dummyEventListener() {}
const $9605ec1960a4b72a$var$events = (swiper, method)=>{
    const document = (0, $2iHxd.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === "touchstart" && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $4fOIc.default), true);
    else swiper[swiperMethod]("observerUpdate", (0, $4fOIc.default), true);
};
function $9605ec1960a4b72a$var$attachEvents() {
    const swiper = this;
    const document = (0, $2iHxd.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $9DvVm.default).bind(swiper);
    swiper.onTouchMove = (0, $dNuTe.default).bind(swiper);
    swiper.onTouchEnd = (0, $3AYyc.default).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $XCX3i.default).bind(swiper);
    swiper.onClick = (0, $18JYh.default).bind(swiper);
    if (support.touch && !$9605ec1960a4b72a$var$dummyEventAttached) {
        document.addEventListener("touchstart", $9605ec1960a4b72a$var$dummyEventListener);
        $9605ec1960a4b72a$var$dummyEventAttached = true;
    }
    $9605ec1960a4b72a$var$events(swiper, "on");
}
function $9605ec1960a4b72a$var$detachEvents() {
    const swiper = this;
    $9605ec1960a4b72a$var$events(swiper, "off");
}
var $9605ec1960a4b72a$export$2e2bcd8739ae039 = {
    attachEvents: $9605ec1960a4b72a$var$attachEvents,
    detachEvents: $9605ec1960a4b72a$var$detachEvents
};

});
parcelRegister("9DvVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7040850fdd9c7181$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");

var $aRn8z = parcelRequire("aRn8z");
function $7040850fdd9c7181$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $2iHxd.getDocument)() || el === (0, $2iHxd.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $7040850fdd9c7181$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $2iHxd.getDocument)();
    const window = (0, $2iHxd.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $4ADnt.default)(e.target);
    if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === "touchstart";
    if (!data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!data.isTouchEvent && "button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ""; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $4ADnt.default)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $7040850fdd9c7181$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $aRn8z.now)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === "SELECT") data.isTouched = false;
        }
        if (document.activeElement && (0, $4ADnt.default)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}

});

parcelRegister("dNuTe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b7d00ad84db7fb$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");

var $aRn8z = parcelRequire("aRn8z");
function $a0b7d00ad84db7fb$export$2e2bcd8739ae039(event) {
    const document = (0, $2iHxd.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    if (data.isTouchEvent && e.type !== "touchmove") return;
    const targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
    const pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $4ADnt.default)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $aRn8z.now)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $4ADnt.default)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}

});

parcelRegister("3AYyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e3b3fc00e3fcc6$export$2e2bcd8739ae039);

var $aRn8z = parcelRequire("aRn8z");
function $29e3b3fc00e3fcc6$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $aRn8z.now)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $aRn8z.now)();
    (0, $aRn8z.nextTick)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}

});

parcelRegister("4fOIc", function(module, exports) {

$parcel$export(module.exports, "default", () => $318fe67158fac579$export$2e2bcd8739ae039);
function $318fe67158fac579$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}

});

parcelRegister("18JYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d4a32b707215ef0$export$2e2bcd8739ae039);
function $0d4a32b707215ef0$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}

});

parcelRegister("XCX3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b33b9c00c5509b9$export$2e2bcd8739ae039);
function $0b33b9c00c5509b9$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}

});


parcelRegister("2ed62", function(module, exports) {

$parcel$export(module.exports, "default", () => $19f70c3c00ee8a78$export$2e2bcd8739ae039);

var $6eJ9z = parcelRequire("6eJ9z");

var $e3ZhX = parcelRequire("e3ZhX");
var $19f70c3c00ee8a78$export$2e2bcd8739ae039 = {
    setBreakpoint: $6eJ9z.default,
    getBreakpoint: $e3ZhX.default
};

});
parcelRegister("6eJ9z", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a713658fbeea99$export$2e2bcd8739ae039);

var $aRn8z = parcelRequire("aRn8z");
const $48a713658fbeea99$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $48a713658fbeea99$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $48a713658fbeea99$var$isGridEnabled(swiper, params);
    const isMultiRow = $48a713658fbeea99$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $aRn8z.extend)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit("breakpoint", breakpointParams);
}

});

parcelRegister("e3ZhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3d0e3238e5b988a$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");
function $a3d0e3238e5b988a$export$2e2bcd8739ae039(breakpoints, base = "window", containerEl) {
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $2iHxd.getWindow)();
    const currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}

});


parcelRegister("4XpkI", function(module, exports) {

$parcel$export(module.exports, "default", () => $39c052b9f7f81c7a$export$2e2bcd8739ae039);

var $b4Pdc = parcelRequire("b4Pdc");

var $gtI3a = parcelRequire("gtI3a");
var $39c052b9f7f81c7a$export$2e2bcd8739ae039 = {
    addClasses: $b4Pdc.default,
    removeClasses: $gtI3a.default
};

});
parcelRegister("b4Pdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8107cb10cba64abc$export$2e2bcd8739ae039);
function $8107cb10cba64abc$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $8107cb10cba64abc$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $8107cb10cba64abc$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "pointer-events": !support.touch
        },
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(" "));
    swiper.emitContainerClasses();
}

});

parcelRegister("gtI3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $bff1863547145932$export$2e2bcd8739ae039);
function $bff1863547145932$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(" "));
    swiper.emitContainerClasses();
}

});


parcelRegister("iuX65", function(module, exports) {

$parcel$export(module.exports, "default", () => $d778ded083e1b269$export$2e2bcd8739ae039);

var $bVSEv = parcelRequire("bVSEv");

var $e2OUj = parcelRequire("e2OUj");
var $d778ded083e1b269$export$2e2bcd8739ae039 = {
    loadImage: $bVSEv.default,
    preloadImages: $e2OUj.default
};

});
parcelRegister("bVSEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aff6962ed1e9953$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");
function $8aff6962ed1e9953$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $2iHxd.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $4ADnt.default)(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}

});

parcelRegister("e2OUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a398bdbcff4c7669$export$2e2bcd8739ae039);
function $a398bdbcff4c7669$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}

});


parcelRegister("e2LtX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3961596506b3a05$export$2e2bcd8739ae039);
function $a3961596506b3a05$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $a3961596506b3a05$export$2e2bcd8739ae039 = {
    checkOverflow: $a3961596506b3a05$var$checkOverflow
};

});

parcelRegister("7FcRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $594656cf6ccf8af4$export$2e2bcd8739ae039);
var $594656cf6ccf8af4$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};

});

parcelRegister("91wPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $691dac749bebf7b9$export$2e2bcd8739ae039);

var $aRn8z = parcelRequire("aRn8z");
function $691dac749bebf7b9$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $aRn8z.extend)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $aRn8z.extend)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $aRn8z.extend)(allModulesParams, obj);
    };
}

});


parcelRegister("629iZ", function(module, exports) {

var $4ADnt = parcelRequire("4ADnt");

var $aRn8z = parcelRequire("aRn8z");
function $464a25d2e1ff215f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $4ADnt.default)(params.renderSlide.call(swiper, slide, index)) : (0, $4ADnt.default)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === "undefined" || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
                if (cachedElIndex) $cachedEl.attr("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $aRn8z.setCSSProperty)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}

});

parcelRegister("a9amb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7632c744f2f30410$export$2e2bcd8739ae039);
/* eslint-disable consistent-return */ 
var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");
function $7632c744f2f30410$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $2iHxd.getDocument)();
    const window = (0, $2iHxd.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $4ADnt.default)(document).on("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $4ADnt.default)(document).off("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("2wVML", function(module, exports) {
/* eslint-disable consistent-return */ 
var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");

var $aRn8z = parcelRequire("aRn8z");
function $1d7b64eb124784c7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $2iHxd.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $aRn8z.now)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $aRn8z.now)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $aRn8z.now)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $4ADnt.default)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $aRn8z.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $aRn8z.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $aRn8z.nextTick)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $aRn8z.nextTick)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit("scroll", e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $4ADnt.default)(swiper.params.mousewheel.eventsTarget);
        target[method]("mouseenter", handleMouseEnter);
        target[method]("mouseleave", handleMouseLeave);
        target[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("on");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("off");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("68aNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $476bddb3dc81215f$export$2e2bcd8739ae039);

var $dbSQl = parcelRequire("dbSQl");

var $4ADnt = parcelRequire("4ADnt");
function $476bddb3dc81215f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $4ADnt.default)(el);
            if (swiper.params.uniqueNavElements && typeof el === "string" && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
            if ($el[0] && $el[0].tagName === "BUTTON") $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $dbSQl.default)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on("click", onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on("click", onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
    });
    on("click", (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $4ADnt.default)(targetEl).is($prevEl) && !(0, $4ADnt.default)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("dbSQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $99a6d8296f428695$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");
function $99a6d8296f428695$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $2iHxd.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement("div");
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

});


parcelRegister("lLTYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd9969a6ac51294d$export$2e2bcd8739ae039);

var $4ADnt = parcelRequire("4ADnt");

var $cbPNN = parcelRequire("cbPNN");

var $dbSQl = parcelRequire("dbSQl");
function $fd9969a6ac51294d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                "",
                "-next",
                "-next-next",
                "-prev",
                "-prev-prev",
                "-main"
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(" "));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $4ADnt.default)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets($bullet, "next");
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, "prev");
                            setSideBullets($lastDisplayedBullet, "next");
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, "prev");
                        setSideBullets($lastDisplayedBullet, "next");
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", `${bulletsOffset}px`);
            }
        }
        if (params.type === "fraction") {
            $el.find((0, $cbPNN.default)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $cbPNN.default)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === "horizontal") scaleX = scale;
            else scaleY = scale;
            $el.find((0, $cbPNN.default)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit("paginationRender", $el[0]);
        } else emit("paginationUpdate", $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $cbPNN.default)(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") emit("paginationRender", swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $dbSQl.default)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $4ADnt.default)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $4ADnt.default)(el).parents(".swiper")[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === "bullets" && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === "progressbar" && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on("click", (0, $cbPNN.default)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $4ADnt.default)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off("click", (0, $cbPNN.default)(params.bulletClass));
    }
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        if (!swiper.params.loop) update();
    });
    on("slidesLengthChange", ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on("snapGridLengthChange", ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $4ADnt.default)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("cbPNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfeb1ee93222d24$export$2e2bcd8739ae039);
function $8dfeb1ee93222d24$export$2e2bcd8739ae039(classes = "") {
    return `.${classes.trim().replace(/([\.:!\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}

});


parcelRegister("lSZ1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $feedf9812d04e1d6$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");

var $aRn8z = parcelRequire("aRn8z");

var $dbSQl = parcelRequire("dbSQl");
function $feedf9812d04e1d6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $2iHxd.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = "none";
        else $el[0].style.display = "";
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css("opacity", 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css("scroll-snap-type", "none");
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "");
            $wrapperEl.transition("");
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $aRn8z.nextTick)(()=>{
                $el.css("opacity", 0);
                $el.transition(400);
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $dbSQl.default)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $4ADnt.default)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $4ADnt.default)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}

});

parcelRegister("gBMuC", function(module, exports) {

var $4ADnt = parcelRequire("4ADnt");
function $c175b7b3474e7a55$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $4ADnt.default)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr("data-swiper-parallax") || "0";
        let x = $el.attr("data-swiper-parallax-x");
        let y = $el.attr("data-swiper-parallax-y");
        const scale = $el.attr("data-swiper-parallax-scale");
        const opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $4ADnt.default)(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((parallaxEl)=>{
            const $parallaxEl = (0, $4ADnt.default)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

});

parcelRegister("4izHL", function(module, exports) {

var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");

var $aRn8z = parcelRequire("aRn8z");
function $32148a20af5b6e8b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $2iHxd.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $4ADnt.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === "gesturechange") onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $aRn8z.getTranslate)(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = (0, $aRn8z.getTranslate)(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $4ADnt.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === "touchstart" && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]("gesturestart", slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]("gesturechange", slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]("gestureend", slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures("on");
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures("off");
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

});

parcelRegister("Vfci2", function(module, exports) {

var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");
function $0ac11cd687184652$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $4ADnt.default)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr("data-background");
            const src = $imageEl.attr("data-src");
            const srcset = $imageEl.attr("data-srcset");
            const sizes = $imageEl.attr("data-sizes");
            const $pictureEl = $imageEl.parent("picture");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", `url("${background}")`);
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if ($pictureEl.length) $pictureEl.children("source").each((sourceEl)=>{
                        const $source = (0, $4ADnt.default)(sourceEl);
                        if ($source.attr("data-srcset")) {
                            $source.attr("srcset", $source.attr("data-srcset"));
                            $source.removeAttr("data-srcset");
                        }
                    });
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit("lazyImageReady", $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $4ADnt.default)(slideEl).attr("data-swiper-slide-index");
            return (0, $4ADnt.default)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $4ADnt.default)(slideEl).attr("data-swiper-slide-index") : (0, $4ADnt.default)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $2iHxd.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $4ADnt.default)(swiper.params.lazy.scrollingElement) : (0, $4ADnt.default)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off("scroll", checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on("scroll", checkInViewOnLoad, passiveListener);
        }
    }
    on("beforeInit", ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on("init", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("scroll", ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on("scrollbarDragMove resize _freeModeNoMomentumRelease", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("transitionStart", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on("transitionEnd", ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("slideChange", ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on("destroy", ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}

});

parcelRegister("4vY60", function(module, exports) {
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
var $aRn8z = parcelRequire("aRn8z");
function $3498ac75707b2da6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $aRn8z.nextTick)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}

});

parcelRegister("g4zLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb38c400e3b6d6de$export$2e2bcd8739ae039);

var $cbPNN = parcelRequire("cbPNN");

var $4ADnt = parcelRequire("4ADnt");
function $bb38c400e3b6d6de$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
    }
    function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
    }
    function addElRole($el, role) {
        $el.attr("role", role);
    }
    function addElRoleDescription($el, description) {
        $el.attr("aria-roledescription", description);
    }
    function addElControls($el, controls) {
        $el.attr("aria-controls", controls);
    }
    function addElLabel($el, label) {
        $el.attr("aria-label", label);
    }
    function addElId($el, id) {
        $el.attr("id", id);
    }
    function addElLive($el, live) {
        $el.attr("aria-live", live);
    }
    function disableEl($el) {
        $el.attr("aria-disabled", true);
    }
    function enableEl($el) {
        $el.attr("aria-disabled", false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $4ADnt.default)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $cbPNN.default)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $4ADnt.default)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, "button");
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr("aria-current", "true");
            else $bulletEl.removeAttr("aria-current");
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== "BUTTON") {
            addElRole($el, "button");
            $el.on("keydown", onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $4ADnt.default)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $4ADnt.default)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $4ADnt.default)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on("keydown", (0, $cbPNN.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on("focus", handleFocus, true);
        swiper.$el.on("pointerdown", handlePointerDown, true);
        swiper.$el.on("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off("keydown", onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off("keydown", onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off("keydown", (0, $cbPNN.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off("focus", handleFocus, true);
        swiper.$el.off("pointerdown", handlePointerDown, true);
        swiper.$el.off("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $4ADnt.default)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

});

parcelRegister("hej2P", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b28450c8364781$export$2e2bcd8739ae039);

var $2iHxd = parcelRequire("2iHxd");
function $c8b28450c8364781$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $2iHxd.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $2iHxd.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr("data-history"));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $2iHxd.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $2iHxd.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

});

parcelRegister("6tg80", function(module, exports) {

var $2iHxd = parcelRequire("2iHxd");

var $4ADnt = parcelRequire("4ADnt");
function $013741e8234a66a6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $2iHxd.getDocument)();
    const window = (0, $2iHxd.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr("data-hash")}` || "");
            emit("hashSet");
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr("data-hash") || slide.attr("data-history");
            document.location.hash = hash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $4ADnt.default)(window).on("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $4ADnt.default)(window).off("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

});

parcelRegister("fHuP7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6e2c8180808a67f$export$2e2bcd8739ae039);
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $2iHxd = parcelRequire("2iHxd");

var $aRn8z = parcelRequire("aRn8z");
function $b6e2c8180808a67f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $aRn8z.nextTick)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit("autoplay");
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit("autoplay");
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit("autoplayStart");
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === "undefined") return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit("autoplayStop");
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $2iHxd.getDocument)();
        if (document.visibilityState === "hidden" && swiper.autoplay.running) pause();
        if (document.visibilityState === "visible" && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit("autoplayPause");
            pause();
        }
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit("autoplayResume");
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on("mouseenter", onMouseEnter);
            swiper.$el.on("mouseleave", onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off("mouseenter", onMouseEnter);
        swiper.$el.off("mouseleave", onMouseLeave);
    }
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $2iHxd.getDocument)();
            document.addEventListener("visibilitychange", onVisibilityChange);
            attachMouseEvents();
        }
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on("sliderFirstMove", ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on("touchEnd", ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on("destroy", ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $2iHxd.getDocument)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}

});

parcelRegister("3LDuZ", function(module, exports) {

var $aRn8z = parcelRequire("aRn8z");

var $4ADnt = parcelRequire("4ADnt");
function $2be4668c11f37ba0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $4ADnt.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $4ADnt.default)(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $aRn8z.isObject)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}

});

parcelRegister("1e0qN", function(module, exports) {

var $aRn8z = parcelRequire("aRn8z");
function $0e476ee546df2d71$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $aRn8z.now)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $aRn8z.now)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $aRn8z.now)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}

});

parcelRegister("3Bgzs", function(module, exports) {
function $29f1ae6ff7d91bef$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                "-webkit-order": newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel("margin-top"), row !== 0 ? spaceBetween && `${spaceBetween}px` : "");
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel("width")]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}

});

parcelRegister("jbTEe", function(module, exports) {

var $LhJOF = parcelRequire("LhJOF");

var $f3AFt = parcelRequire("f3AFt");

var $3MxVl = parcelRequire("3MxVl");

var $3p0l4 = parcelRequire("3p0l4");

var $e0h2M = parcelRequire("e0h2M");
function $df8a35ef70a8587c$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $LhJOF.default).bind(swiper),
        prependSlide: (0, $f3AFt.default).bind(swiper),
        addSlide: (0, $3MxVl.default).bind(swiper),
        removeSlide: (0, $3p0l4.default).bind(swiper),
        removeAllSlides: (0, $e0h2M.default).bind(swiper)
    });
}

});
parcelRegister("LhJOF", function(module, exports) {

$parcel$export(module.exports, "default", () => $08e2264af1a78234$export$2e2bcd8739ae039);
function $08e2264af1a78234$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}

});

parcelRegister("f3AFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $af6394571980de1e$export$2e2bcd8739ae039);
function $af6394571980de1e$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("3MxVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c102b5e9e9fb3ef$export$2e2bcd8739ae039);
function $2c102b5e9e9fb3ef$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("3p0l4", function(module, exports) {

$parcel$export(module.exports, "default", () => $27a3f833d9fecf13$export$2e2bcd8739ae039);
function $27a3f833d9fecf13$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRegister("e0h2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31e4955dcaec3e8$export$2e2bcd8739ae039);
function $a31e4955dcaec3e8$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}

});


parcelRegister("c5fUf", function(module, exports) {

var $cDZx8 = parcelRequire("cDZx8");

var $7FcKX = parcelRequire("7FcKX");

var $3WM4a = parcelRequire("3WM4a");
function $8cc24a535a1e5991$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $7FcKX.default)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $3WM4a.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $cDZx8.default)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("cDZx8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9348dbcf41f0c5be$export$2e2bcd8739ae039);
function $9348dbcf41f0c5be$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

});

parcelRegister("7FcKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $01709df73a628ae0$export$2e2bcd8739ae039);
function $01709df73a628ae0$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        "backface-visibility": "hidden",
        "-webkit-backface-visibility": "hidden"
    });
    return $slideEl;
}

});

parcelRegister("3WM4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dfc12d840aad435$export$2e2bcd8739ae039);
function $2dfc12d840aad435$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                "webkitTransitionEnd",
                "transitionend"
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}

});


parcelRegister("iYXoD", function(module, exports) {

var $4ADnt = parcelRequire("4ADnt");

var $cDZx8 = parcelRequire("cDZx8");
function $dd1be77de2cc1fcd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $4ADnt.default)(`<div class="swiper-slide-shadow-${isHorizontal ? "left" : "top"}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $4ADnt.default)(`<div class="swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $4ADnt.default)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $4ADnt.default)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $4ADnt.default)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            "-webkit-transform-origin": `50% 50% -${swiperSize / 2}px`,
            "transform-origin": `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find(".swiper-cube-shadow").transition(duration);
    };
    (0, $cDZx8.default)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

});

parcelRegister("gYF09", function(module, exports) {

var $4ADnt = parcelRequire("4ADnt");

var $lVML0 = parcelRequire("lVML0");

var $cDZx8 = parcelRequire("cDZx8");

var $7FcKX = parcelRequire("7FcKX");

var $3WM4a = parcelRequire("3WM4a");
function $c5c20df543e0de22$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) shadowBefore = (0, $lVML0.default)(params, $slideEl, swiper.isHorizontal() ? "left" : "top");
        if (shadowAfter.length === 0) shadowAfter = (0, $lVML0.default)(params, $slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $4ADnt.default)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $7FcKX.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        (0, $3WM4a.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $cDZx8.default)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("lVML0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff74be01e998fa34$export$2e2bcd8739ae039);

var $4ADnt = parcelRequire("4ADnt");
function $ff74be01e998fa34$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $4ADnt.default)(`<div class="swiper-slide-shadow${side ? `-${side}` : ""}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}

});


parcelRegister("efsTi", function(module, exports) {

var $lVML0 = parcelRequire("lVML0");

var $cDZx8 = parcelRequire("cDZx8");

var $7FcKX = parcelRequire("7FcKX");
function $a5f8e08611927a16$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $7FcKX.default)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                let $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $lVML0.default)(params, $slideEl, isHorizontal ? "left" : "top");
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $lVML0.default)(params, $slideEl, isHorizontal ? "right" : "bottom");
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    };
    (0, $cDZx8.default)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

});

parcelRegister("3UuMB", function(module, exports) {

var $lVML0 = parcelRequire("lVML0");

var $cDZx8 = parcelRequire("cDZx8");

var $7FcKX = parcelRequire("7FcKX");

var $3WM4a = parcelRequire("3WM4a");
function $2d8e7ae30d46f744$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children(".swiper-slide-shadow");
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $lVML0.default)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $7FcKX.default)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css("transform-origin", data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $3WM4a.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $cDZx8.default)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});

parcelRegister("8Sfjh", function(module, exports) {

var $lVML0 = parcelRequire("lVML0");

var $cDZx8 = parcelRequire("cDZx8");

var $7FcKX = parcelRequire("7FcKX");

var $3WM4a = parcelRequire("3WM4a");
function $675f3e186f1f76fd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find(".swiper-slide-shadow");
                if ($shadowEl.length === 0) $shadowEl = (0, $lVML0.default)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $7FcKX.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $3WM4a.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $cDZx8.default)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});



parcelRegister("3ojaG", function(module, exports) {
"use strict";
var $27827c083cc3a532$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $27827c083cc3a532$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Table = module.exports.TableRow = module.exports.TableCell = module.exports.StylableContainer = module.exports.TableColumnDefinition = void 0;

var $iBTKZ = parcelRequire("iBTKZ");

var $4uYwi = parcelRequire("4uYwi");

var $4TaX1 = parcelRequire("4TaX1");

var $dA5cX = parcelRequire("dA5cX");

var $krmaK = parcelRequire("krmaK");

var $luP4B = parcelRequire("luP4B");

var $6EfR6 = parcelRequire("6EfR6");
var $27827c083cc3a532$var$TableColumnDefinition = /** @class */ function(_super) {
    $27827c083cc3a532$var$__extends(TableColumnDefinition, _super);
    function TableColumnDefinition() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.width = new $krmaK.SizeAndUnit(1, $4uYwi.SizeUnit.Weight);
        return _this;
    }
    TableColumnDefinition.prototype.getSchemaKey = function() {
        return "ColumnDefinition";
    };
    TableColumnDefinition.horizontalCellContentAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_5, "horizontalCellContentAlignment", $4uYwi.HorizontalAlignment);
    TableColumnDefinition.verticalCellContentAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_5, "verticalCellContentAlignment", $4uYwi.VerticalAlignment);
    TableColumnDefinition.widthProperty = new $dA5cX.CustomProperty($dA5cX.Versions.v1_5, "width", function(sender, prop, source, context) {
        var result = prop.defaultValue;
        var value = source[prop.name];
        var invalidWidth = false;
        if (typeof value === "number" && !isNaN(value)) result = new $krmaK.SizeAndUnit(value, $4uYwi.SizeUnit.Weight);
        else if (typeof value === "string") try {
            result = $krmaK.SizeAndUnit.parse(value);
        } catch (e) {
            invalidWidth = true;
        }
        else invalidWidth = true;
        if (invalidWidth) context.logParseEvent(sender, $4uYwi.ValidationEvent.InvalidPropertyValue, $luP4B.Strings.errors.invalidColumnWidth(value));
        return result;
    }, function(sender, property, target, value, context) {
        if (value.unit === $4uYwi.SizeUnit.Pixel) context.serializeValue(target, "width", value.physicalSize + "px");
        else context.serializeNumber(target, "width", value.physicalSize);
    }, new $krmaK.SizeAndUnit(1, $4uYwi.SizeUnit.Weight));
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(TableColumnDefinition.horizontalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "horizontalCellContentAlignment", void 0);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(TableColumnDefinition.verticalCellContentAlignmentProperty)
    ], TableColumnDefinition.prototype, "verticalCellContentAlignment", void 0);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(TableColumnDefinition.widthProperty)
    ], TableColumnDefinition.prototype, "width", void 0);
    return TableColumnDefinition;
}($dA5cX.SerializableObject);
module.exports.TableColumnDefinition = $27827c083cc3a532$var$TableColumnDefinition;
var $27827c083cc3a532$var$StylableContainer = /** @class */ function(_super) {
    $27827c083cc3a532$var$__extends(StylableContainer, _super);
    function StylableContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._items = [];
        return _this;
    }
    StylableContainer.prototype.parseItem = function(source, context) {
        var _this = this;
        return context.parseCardObject(this, source, [], !this.isDesignMode(), function(typeName) {
            return _this.createItemInstance(typeName);
        }, function(typeName, _errorType) {
            context.logParseEvent(undefined, $4uYwi.ValidationEvent.ElementTypeNotAllowed, $luP4B.Strings.errors.elementTypeNotAllowed(typeName));
        });
    };
    StylableContainer.prototype.internalAddItem = function(item) {
        if (!item.parent) {
            this._items.push(item);
            item.setParent(this);
        } else throw new Error($luP4B.Strings.errors.elementAlreadyParented());
    };
    StylableContainer.prototype.internalRemoveItem = function(item) {
        var itemIndex = this._items.indexOf(item);
        if (itemIndex >= 0) {
            this._items.splice(itemIndex, 1);
            item.setParent(undefined);
            this.updateLayout();
            return true;
        }
        return false;
    };
    StylableContainer.prototype.internalIndexOf = function(item) {
        return this._items.indexOf(item);
    };
    StylableContainer.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this._items = [];
        var items = source[this.getCollectionPropertyName()];
        if (Array.isArray(items)) for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            var instance = this.parseItem(item, context);
            if (instance) this._items.push(instance);
        }
    };
    StylableContainer.prototype.internalToJSON = function(target, context) {
        _super.prototype.internalToJSON.call(this, target, context);
        context.serializeArray(target, this.getCollectionPropertyName(), this._items);
    };
    StylableContainer.prototype.removeItem = function(item) {
        return this.internalRemoveItem(item);
    };
    StylableContainer.prototype.getItemCount = function() {
        return this._items.length;
    };
    StylableContainer.prototype.getItemAt = function(index) {
        return this._items[index];
    };
    StylableContainer.prototype.getFirstVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(0) : undefined;
    };
    StylableContainer.prototype.getLastVisibleRenderedItem = function() {
        return this.getItemCount() > 0 ? this.getItemAt(this.getItemCount() - 1) : undefined;
    };
    return StylableContainer;
}($iBTKZ.StylableCardElementContainer);
module.exports.StylableContainer = $27827c083cc3a532$var$StylableContainer;
var $27827c083cc3a532$var$TableCell = /** @class */ function(_super) {
    $27827c083cc3a532$var$__extends(TableCell, _super);
    function TableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columnIndex = -1;
        _this._cellType = "data";
        return _this;
    }
    TableCell.prototype.getHasBorder = function() {
        return this.parentRow.parentTable.showGridLines;
    };
    TableCell.prototype.applyBorder = function() {
        if (this.renderedElement && this.getHasBorder()) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.parentRow.parentTable.gridStyle);
            if (styleDefinition.borderColor) {
                var borderColor = (0, $6EfR6.stringToCssColor)(styleDefinition.borderColor);
                if (borderColor) {
                    this.renderedElement.style.borderRight = "1px solid " + borderColor;
                    this.renderedElement.style.borderBottom = "1px solid " + borderColor;
                }
            }
        }
    };
    TableCell.prototype.getDefaultPadding = function() {
        return this.getHasBackground() || this.getHasBorder() ? new $krmaK.PaddingDefinition($4uYwi.Spacing.Small, $4uYwi.Spacing.Small, $4uYwi.Spacing.Small, $4uYwi.Spacing.Small) : _super.prototype.getDefaultPadding.call(this);
    };
    TableCell.prototype.internalRender = function() {
        var cellElement = _super.prototype.internalRender.call(this);
        if (cellElement) {
            cellElement.setAttribute("role", this.cellType === "data" ? "cell" : "columnheader");
            cellElement.style.minWidth = "0";
            if (this.cellType === "header") cellElement.setAttribute("scope", "col");
        }
        return cellElement;
    };
    TableCell.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableCell.prototype.getJsonTypeName = function() {
        return "TableCell";
    };
    TableCell.prototype.getEffectiveTextStyleDefinition = function() {
        if (this.cellType === "header") return this.hostConfig.textStyles.columnHeader;
        return _super.prototype.getEffectiveTextStyleDefinition.call(this);
    };
    TableCell.prototype.getEffectiveHorizontalAlignment = function() {
        if (this.horizontalAlignment !== undefined) return this.horizontalAlignment;
        if (this.parentRow.horizontalCellContentAlignment !== undefined) return this.parentRow.horizontalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var horizontalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).horizontalCellContentAlignment;
            if (horizontalAlignment !== undefined) return horizontalAlignment;
        }
        if (this.parentRow.parentTable.horizontalCellContentAlignment !== undefined) return this.parentRow.parentTable.horizontalCellContentAlignment;
        return _super.prototype.getEffectiveHorizontalAlignment.call(this);
    };
    TableCell.prototype.getEffectiveVerticalContentAlignment = function() {
        if (this.verticalContentAlignment !== undefined) return this.verticalContentAlignment;
        if (this.parentRow.verticalCellContentAlignment !== undefined) return this.parentRow.verticalCellContentAlignment;
        if (this.columnIndex >= 0) {
            var verticalAlignment = this.parentRow.parentTable.getColumnAt(this.columnIndex).verticalCellContentAlignment;
            if (verticalAlignment !== undefined) return verticalAlignment;
        }
        if (this.parentRow.parentTable.verticalCellContentAlignment !== undefined) return this.parentRow.parentTable.verticalCellContentAlignment;
        return _super.prototype.getEffectiveVerticalContentAlignment.call(this);
    };
    Object.defineProperty(TableCell.prototype, "columnIndex", {
        get: function() {
            return this._columnIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "cellType", {
        get: function() {
            return this._cellType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "parentRow", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return TableCell;
}($iBTKZ.Container);
module.exports.TableCell = $27827c083cc3a532$var$TableCell;
var $27827c083cc3a532$var$TableRow = /** @class */ function(_super) {
    $27827c083cc3a532$var$__extends(TableRow, _super);
    function TableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#endregion
    TableRow.prototype.getDefaultPadding = function() {
        return new $krmaK.PaddingDefinition($4uYwi.Spacing.None, $4uYwi.Spacing.None, $4uYwi.Spacing.None, $4uYwi.Spacing.None);
    };
    TableRow.prototype.applyBackground = function() {
        if (this.renderedElement) {
            var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
            if (styleDefinition.backgroundColor) {
                var bgColor = (0, $6EfR6.stringToCssColor)(styleDefinition.backgroundColor);
                if (bgColor) this.renderedElement.style.backgroundColor = bgColor;
            }
        }
    };
    TableRow.prototype.getCollectionPropertyName = function() {
        return "cells";
    };
    TableRow.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableCell" ? new $27827c083cc3a532$var$TableCell() : undefined;
    };
    TableRow.prototype.internalRender = function() {
        var isFirstRow = this.getIsFirstRow();
        var cellSpacing = this.hostConfig.table.cellSpacing;
        var rowElement = document.createElement("div");
        rowElement.setAttribute("role", "row");
        rowElement.style.display = "flex";
        rowElement.style.flexDirection = "row";
        for(var i = 0; i < Math.min(this.getItemCount(), this.parentTable.getColumnCount()); i++){
            var cell = this.getItemAt(i);
            // Cheating a bit in order to keep cellType read-only
            cell["_columnIndex"] = i;
            cell["_cellType"] = this.parentTable.firstRowAsHeaders && isFirstRow ? "header" : "data";
            var renderedCell = cell.render();
            if (renderedCell) {
                var column = this.parentTable.getColumnAt(i);
                if (column.computedWidth.unit === $4uYwi.SizeUnit.Pixel) renderedCell.style.flex = "0 0 " + column.computedWidth.physicalSize + "px";
                else renderedCell.style.flex = "1 1 " + column.computedWidth.physicalSize + "%";
                if (i > 0 && !this.parentTable.showGridLines && cellSpacing > 0) renderedCell.style.marginLeft = cellSpacing + "px";
                rowElement.appendChild(renderedCell);
            }
        }
        return rowElement.children.length > 0 ? rowElement : undefined;
    };
    TableRow.prototype.shouldSerialize = function(_context) {
        return true;
    };
    TableRow.prototype.addCell = function(cell) {
        this.internalAddItem(cell);
    };
    TableRow.prototype.removeCellAt = function(columnIndex) {
        if (columnIndex >= 0 && columnIndex < this.getItemCount()) return this.removeItem(this.getItemAt(columnIndex));
        return false;
    };
    TableRow.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $27827c083cc3a532$var$TableCell ? this.internalIndexOf(cardElement) : -1;
    };
    TableRow.prototype.ensureHasEnoughCells = function(cellCount) {
        while(this.getItemCount() < cellCount)this.addCell(new $27827c083cc3a532$var$TableCell());
    };
    TableRow.prototype.getJsonTypeName = function() {
        return "TableRow";
    };
    TableRow.prototype.getIsFirstRow = function() {
        return this.parentTable.getItemAt(0) === this;
    };
    Object.defineProperty(TableRow.prototype, "parentTable", {
        get: function() {
            return this.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableRow.prototype, "isStandalone", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    //#region Schema
    TableRow.styleProperty = new $iBTKZ.ContainerStyleProperty($dA5cX.Versions.v1_5, "style");
    TableRow.horizontalCellContentAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_5, "horizontalCellContentAlignment", $4uYwi.HorizontalAlignment);
    TableRow.verticalCellContentAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_5, "verticalCellContentAlignment", $4uYwi.VerticalAlignment);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(TableRow.horizontalCellContentAlignmentProperty)
    ], TableRow.prototype, "horizontalCellContentAlignment", void 0);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(TableRow.verticalCellContentAlignmentProperty)
    ], TableRow.prototype, "verticalCellContentAlignment", void 0);
    return TableRow;
}($27827c083cc3a532$var$StylableContainer);
module.exports.TableRow = $27827c083cc3a532$var$TableRow;
var $27827c083cc3a532$var$Table = /** @class */ function(_super) {
    $27827c083cc3a532$var$__extends(Table, _super);
    function Table() {
        //#region Schema
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = [];
        _this.firstRowAsHeaders = true;
        _this.showGridLines = true;
        return _this;
    }
    Object.defineProperty(Table.prototype, "gridStyle", {
        get: function() {
            var style = this.getValue(Table.gridStyleProperty);
            if (style && this.hostConfig.containerStyles.getStyleByName(style)) return style;
            return undefined;
        },
        set: function(value) {
            this.setValue(Table.gridStyleProperty, value);
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    Table.prototype.ensureRowsHaveEnoughCells = function() {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.removeCellsFromColumn = function(columnIndex) {
        for(var i = 0; i < this.getItemCount(); i++)this.getItemAt(i).removeCellAt(columnIndex);
    };
    Table.prototype.getCollectionPropertyName = function() {
        return "rows";
    };
    Table.prototype.createItemInstance = function(typeName) {
        return !typeName || typeName === "TableRow" ? new $27827c083cc3a532$var$TableRow() : undefined;
    };
    Table.prototype.internalParse = function(source, context) {
        _super.prototype.internalParse.call(this, source, context);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.internalRender = function() {
        if (this.getItemCount() > 0) {
            var totalWeights = 0;
            for(var _i = 0, _a = this._columns; _i < _a.length; _i++){
                var column = _a[_i];
                if (column.width.unit === $4uYwi.SizeUnit.Weight) totalWeights += column.width.physicalSize;
            }
            for(var _b = 0, _c = this._columns; _b < _c.length; _b++){
                var column = _c[_b];
                if (column.width.unit === $4uYwi.SizeUnit.Pixel) column.computedWidth = new $krmaK.SizeAndUnit(column.width.physicalSize, $4uYwi.SizeUnit.Pixel);
                else column.computedWidth = new $krmaK.SizeAndUnit(100 / totalWeights * column.width.physicalSize, $4uYwi.SizeUnit.Weight);
            }
            var tableElement = document.createElement("div");
            tableElement.setAttribute("role", "table");
            tableElement.style.display = "flex";
            tableElement.style.flexDirection = "column";
            if (this.showGridLines) {
                var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.gridStyle);
                if (styleDefinition.borderColor) {
                    var borderColor = (0, $6EfR6.stringToCssColor)(styleDefinition.borderColor);
                    if (borderColor) {
                        tableElement.style.borderTop = "1px solid " + borderColor;
                        tableElement.style.borderLeft = "1px solid " + borderColor;
                    }
                }
            }
            var cellSpacing = this.hostConfig.table.cellSpacing;
            for(var i = 0; i < this.getItemCount(); i++){
                var renderedRow = this.getItemAt(i).render();
                if (renderedRow) {
                    if (i > 0 && !this.showGridLines && cellSpacing > 0) {
                        var separatorRow = document.createElement("div");
                        separatorRow.setAttribute("aria-hidden", "true");
                        separatorRow.style.height = cellSpacing + "px";
                        tableElement.appendChild(separatorRow);
                    }
                    tableElement.appendChild(renderedRow);
                }
            }
            return tableElement;
        }
        return undefined;
    };
    Table.prototype.addColumn = function(column) {
        this._columns.push(column);
        this.ensureRowsHaveEnoughCells();
    };
    Table.prototype.removeColumn = function(column) {
        var index = this._columns.indexOf(column);
        if (index >= 0) {
            this.removeCellsFromColumn(index);
            this._columns.splice(index, 1);
        }
    };
    Table.prototype.getColumnCount = function() {
        return this._columns.length;
    };
    Table.prototype.getColumnAt = function(index) {
        return this._columns[index];
    };
    Table.prototype.addRow = function(row) {
        this.internalAddItem(row);
        row.ensureHasEnoughCells(this.getColumnCount());
    };
    Table.prototype.indexOf = function(cardElement) {
        return cardElement instanceof $27827c083cc3a532$var$TableRow ? this.internalIndexOf(cardElement) : -1;
    };
    Table.prototype.getJsonTypeName = function() {
        return "Table";
    };
    Table._columnsProperty = new $dA5cX.SerializableObjectCollectionProperty($dA5cX.Versions.v1_5, "columns", $27827c083cc3a532$var$TableColumnDefinition);
    Table.firstRowAsHeadersProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_5, "firstRowAsHeaders", true);
    Table.showGridLinesProperty = new $dA5cX.BoolProperty($dA5cX.Versions.v1_5, "showGridLines", true);
    Table.gridStyleProperty = new $iBTKZ.ContainerStyleProperty($dA5cX.Versions.v1_5, "gridStyle");
    Table.horizontalCellContentAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_5, "horizontalCellContentAlignment", $4uYwi.HorizontalAlignment);
    Table.verticalCellContentAlignmentProperty = new $dA5cX.EnumProperty($dA5cX.Versions.v1_5, "verticalCellContentAlignment", $4uYwi.VerticalAlignment);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(Table._columnsProperty)
    ], Table.prototype, "_columns", void 0);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(Table.firstRowAsHeadersProperty)
    ], Table.prototype, "firstRowAsHeaders", void 0);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(Table.showGridLinesProperty)
    ], Table.prototype, "showGridLines", void 0);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(Table.gridStyleProperty)
    ], Table.prototype, "gridStyle", null);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(Table.horizontalCellContentAlignmentProperty)
    ], Table.prototype, "horizontalCellContentAlignment", void 0);
    $27827c083cc3a532$var$__decorate([
        (0, $dA5cX.property)(Table.verticalCellContentAlignmentProperty)
    ], Table.prototype, "verticalCellContentAlignment", void 0);
    return Table;
}($27827c083cc3a532$var$StylableContainer);
module.exports.Table = $27827c083cc3a532$var$Table;
$4TaX1.GlobalRegistry.defaultElements.register("Table", $27827c083cc3a532$var$Table, $dA5cX.Versions.v1_5);

});

parcelRegister("hSHFV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChannelAdapter = void 0;
var $d0495bd18108c609$var$ChannelAdapter = /** @class */ function() {
    function ChannelAdapter() {}
    return ChannelAdapter;
}();
module.exports.ChannelAdapter = $d0495bd18108c609$var$ChannelAdapter;

});

parcelRegister("3iICS", function(module, exports) {
"use strict";
var $2675ab53231f82aa$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoginRequestResponse = module.exports.ErrorResponse = module.exports.SuccessResponse = module.exports.ActivityResponse = module.exports.ActivityRequestError = module.exports.ActivityRequestTrigger = void 0;
var $2675ab53231f82aa$var$ActivityRequestTrigger;
(function(ActivityRequestTrigger) {
    ActivityRequestTrigger["Automatic"] = "automatic";
    ActivityRequestTrigger["Manual"] = "manual";
})($2675ab53231f82aa$var$ActivityRequestTrigger = module.exports.ActivityRequestTrigger || (module.exports.ActivityRequestTrigger = {}));
var $2675ab53231f82aa$var$ActivityRequestError = /** @class */ function() {
    function ActivityRequestError(code, message) {
        this.code = code;
        this.message = message;
    }
    return ActivityRequestError;
}();
module.exports.ActivityRequestError = $2675ab53231f82aa$var$ActivityRequestError;
var $2675ab53231f82aa$var$ActivityResponse = /** @class */ function() {
    function ActivityResponse(request) {
        this.request = request;
    }
    return ActivityResponse;
}();
module.exports.ActivityResponse = $2675ab53231f82aa$var$ActivityResponse;
var $2675ab53231f82aa$var$SuccessResponse = /** @class */ function(_super) {
    $2675ab53231f82aa$var$__extends(SuccessResponse, _super);
    function SuccessResponse(request, rawContent) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.rawContent = rawContent;
        return _this;
    }
    return SuccessResponse;
}($2675ab53231f82aa$var$ActivityResponse);
module.exports.SuccessResponse = $2675ab53231f82aa$var$SuccessResponse;
var $2675ab53231f82aa$var$ErrorResponse = /** @class */ function(_super) {
    $2675ab53231f82aa$var$__extends(ErrorResponse, _super);
    function ErrorResponse(request, error) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this.error = error;
        return _this;
    }
    return ErrorResponse;
}($2675ab53231f82aa$var$ActivityResponse);
module.exports.ErrorResponse = $2675ab53231f82aa$var$ErrorResponse;
var $2675ab53231f82aa$var$LoginRequestResponse = /** @class */ function(_super) {
    $2675ab53231f82aa$var$__extends(LoginRequestResponse, _super);
    function LoginRequestResponse(request, auth) {
        var _this = _super.call(this, request) || this;
        _this.request = request;
        _this._auth = auth;
        for(var _i = 0, _a = _this._auth.buttons; _i < _a.length; _i++){
            var button = _a[_i];
            if (button.type === "signin" && button.value !== undefined) try {
                new URL(button.value);
                _this.signinButton = button;
                break;
            } catch (e) {
            // Ignore parsing error
            }
        }
        return _this;
    }
    Object.defineProperty(LoginRequestResponse.prototype, "tokenExchangeResource", {
        get: function() {
            return this._auth.tokenExchangeResource;
        },
        enumerable: false,
        configurable: true
    });
    return LoginRequestResponse;
}($2675ab53231f82aa$var$ActivityResponse);
module.exports.LoginRequestResponse = $2675ab53231f82aa$var$LoginRequestResponse;

});

parcelRegister("l4BEw", function(module, exports) {
"use strict";
var $f5772db44fd5e3e2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f5772db44fd5e3e2$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdaptiveApplet = void 0;

var $4uYwi = parcelRequire("4uYwi");

var $6EfR6 = parcelRequire("6EfR6");

var $krmaK = parcelRequire("krmaK");

var $3iICS = parcelRequire("3iICS");

var $luP4B = parcelRequire("luP4B");

var $iBTKZ = parcelRequire("iBTKZ");

var $dA5cX = parcelRequire("dA5cX");
function $f5772db44fd5e3e2$var$logEvent(level, message) {
    var optionalParams = [];
    for(var _i = 2; _i < arguments.length; _i++)optionalParams[_i - 2] = arguments[_i];
    if ($krmaK.GlobalSettings.applets.logEnabled) {
        if ($krmaK.GlobalSettings.applets.onLogEvent) $krmaK.GlobalSettings.applets.onLogEvent(level, message, optionalParams);
        else /* eslint-disable no-console */ switch(level){
            case $4uYwi.LogLevel.Warning:
                console.warn(message, optionalParams);
                break;
            case $4uYwi.LogLevel.Error:
                console.error(message, optionalParams);
                break;
            default:
                console.log(message, optionalParams);
                break;
        }
    }
}
var $f5772db44fd5e3e2$var$ActivityRequest = /** @class */ function() {
    function ActivityRequest(action, trigger, consecutiveActions) {
        this.action = action;
        this.trigger = trigger;
        this.consecutiveActions = consecutiveActions;
        this.attemptNumber = 0;
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    ActivityRequest.prototype.retryAsync = function() {
        return $f5772db44fd5e3e2$var$__awaiter(this, void 0, void 0, function() {
            return $f5772db44fd5e3e2$var$__generator(this, function(_a) {
                if (this.onSend) this.onSend(this);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return ActivityRequest;
}();
var $f5772db44fd5e3e2$var$AdaptiveApplet = /** @class */ function() {
    function AdaptiveApplet() {
        this._allowAutomaticCardUpdate = false;
        this.renderedElement = document.createElement("div");
        this.renderedElement.className = "aaf-cardHost";
        this.renderedElement.style.position = "relative";
        this.renderedElement.style.display = "flex";
        this.renderedElement.style.flexDirection = "column";
        this._cardHostElement = document.createElement("div");
        this._refreshButtonHostElement = document.createElement("div");
        this._refreshButtonHostElement.className = "aaf-refreshButtonHost";
        this._refreshButtonHostElement.style.display = "none";
        this.renderedElement.appendChild(this._cardHostElement);
        this.renderedElement.appendChild(this._refreshButtonHostElement);
    }
    AdaptiveApplet.prototype.displayCard = function(card) {
        if (card.renderedElement) {
            $6EfR6.clearElementChildren(this._cardHostElement);
            this._refreshButtonHostElement.style.display = "none";
            this._cardHostElement.appendChild(card.renderedElement);
        } else throw new Error("displayCard: undefined card.");
    };
    AdaptiveApplet.prototype.showManualRefreshButton = function(refreshAction) {
        var _this = this;
        var displayBuiltInManualRefreshButton = this.onShowManualRefreshButton ? this.onShowManualRefreshButton(this) : true;
        if (displayBuiltInManualRefreshButton) {
            this._refreshButtonHostElement.style.display = "none";
            var renderedRefreshButton = undefined;
            if (this.onRenderManualRefreshButton) renderedRefreshButton = this.onRenderManualRefreshButton(this);
            else {
                var message = $luP4B.Strings.runtime.refreshThisCard();
                if ($krmaK.GlobalSettings.applets.refresh.mode === $4uYwi.RefreshMode.Automatic) {
                    var autoRefreshPausedMessage = $luP4B.Strings.runtime.automaticRefreshPaused();
                    if (autoRefreshPausedMessage[autoRefreshPausedMessage.length - 1] !== " ") autoRefreshPausedMessage += " ";
                    message = $luP4B.Strings.runtime.clckToRestartAutomaticRefresh();
                }
                var cardPayload = {
                    type: "AdaptiveCard",
                    version: "1.2",
                    body: [
                        {
                            type: "RichTextBlock",
                            horizontalAlignment: "right",
                            inlines: [
                                {
                                    type: "TextRun",
                                    text: message,
                                    selectAction: {
                                        type: "Action.Submit",
                                        id: "refreshCard"
                                    }
                                }
                            ]
                        }
                    ]
                };
                var card = new $iBTKZ.AdaptiveCard();
                card.parse(cardPayload, new $iBTKZ.SerializationContext($dA5cX.Versions.v1_2));
                card.onExecuteAction = function(action) {
                    if (action.id === "refreshCard") {
                        $6EfR6.clearElementChildren(_this._refreshButtonHostElement);
                        _this.internalExecuteAction(refreshAction, $3iICS.ActivityRequestTrigger.Automatic, 0);
                    }
                };
                renderedRefreshButton = card.render();
            }
            if (renderedRefreshButton) {
                $6EfR6.clearElementChildren(this._refreshButtonHostElement);
                this._refreshButtonHostElement.appendChild(renderedRefreshButton);
                this._refreshButtonHostElement.style.removeProperty("display");
            }
        }
    };
    AdaptiveApplet.prototype.createActivityRequest = function(action, trigger, consecutiveActions) {
        var _this = this;
        if (this.card) {
            var request_1 = new $f5772db44fd5e3e2$var$ActivityRequest(action, trigger, consecutiveActions);
            request_1.onSend = function(sender) {
                sender.attemptNumber++;
                _this.internalSendActivityRequestAsync(request_1);
            };
            var cancel = this.onPrepareActivityRequest ? !this.onPrepareActivityRequest(this, request_1, action) : false;
            return cancel ? undefined : request_1;
        } else throw new Error("createActivityRequest: no card has been set.");
    };
    AdaptiveApplet.prototype.createMagicCodeInputCard = function(attemptNumber) {
        var payload = {
            type: "AdaptiveCard",
            version: "1.0",
            body: [
                {
                    type: "TextBlock",
                    color: "attention",
                    text: attemptNumber === 1 ? undefined : "That didn't work... let's try again.",
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "TextBlock",
                    text: 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"',
                    wrap: true,
                    horizontalAlignment: "center"
                },
                {
                    type: "Input.Text",
                    id: "magicCode",
                    placeholder: "Enter magic code"
                },
                {
                    type: "ActionSet",
                    horizontalAlignment: "center",
                    actions: [
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._submitMagicCodeActionId,
                            title: "Submit"
                        },
                        {
                            type: "Action.Submit",
                            id: AdaptiveApplet._cancelMagicCodeAuthActionId,
                            title: "Cancel"
                        }
                    ]
                }
            ]
        };
        var card = new $iBTKZ.AdaptiveCard();
        card.parse(payload);
        return card;
    };
    AdaptiveApplet.prototype.cancelAutomaticRefresh = function() {
        if (this._allowAutomaticCardUpdate) $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Warning, "Automatic card refresh has been cancelled as a result of the user interacting with the card.");
        this._allowAutomaticCardUpdate = false;
    };
    AdaptiveApplet.prototype.createSerializationContext = function() {
        return this.onCreateSerializationContext ? this.onCreateSerializationContext(this) : new $iBTKZ.SerializationContext();
    };
    AdaptiveApplet.prototype.internalSetCard = function(payload, consecutiveActions) {
        var _this = this;
        if (typeof payload === "object" && payload["type"] === "AdaptiveCard") this._cardPayload = payload;
        if (this._cardPayload) try {
            var card = new $iBTKZ.AdaptiveCard();
            if (this.hostConfig) card.hostConfig = this.hostConfig;
            var serializationContext = this.createSerializationContext();
            card.parse(this._cardPayload, serializationContext);
            var doChangeCard = this.onCardChanging ? this.onCardChanging(this, this._cardPayload) : true;
            if (doChangeCard) {
                this._card = card;
                if (this._card.authentication && this._card.authentication.tokenExchangeResource && this.onPrefetchSSOToken) this.onPrefetchSSOToken(this, this._card.authentication.tokenExchangeResource);
                this._card.onExecuteAction = function(action) {
                    // If the user takes an action, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                    _this.internalExecuteAction(action, $3iICS.ActivityRequestTrigger.Manual, 0);
                };
                this._card.onInputValueChanged = function(input) {
                    var _a, _b, _c;
                    // If the user modifies an input, cancel any pending automatic refresh
                    _this.cancelAutomaticRefresh();
                    if (input instanceof $iBTKZ.ChoiceSetInput && input.isDynamicTypeahead()) {
                        var filter = input.getFilterForDynamicSearch();
                        if (filter) {
                            var dataQueryAction = new $iBTKZ.DataQuery();
                            dataQueryAction.filter = filter;
                            dataQueryAction.dataset = ((_a = input.choicesData) === null || _a === void 0 ? void 0 : _a.dataset) || "";
                            dataQueryAction.count = (_b = input.choicesData) === null || _b === void 0 ? void 0 : _b.count;
                            dataQueryAction.skip = (_c = input.choicesData) === null || _c === void 0 ? void 0 : _c.skip;
                            _this._choiceSet = input;
                            _this.internalExecuteAction(dataQueryAction, $3iICS.ActivityRequestTrigger.Manual, 0 // consecutiveActions
                            );
                        }
                    }
                };
                this._card.render();
                if (this._card.renderedElement) {
                    this.displayCard(this._card);
                    if (this.onCardChanged) this.onCardChanged(this);
                    if (this._card.refresh) {
                        if ($krmaK.GlobalSettings.applets.refresh.mode === $4uYwi.RefreshMode.Automatic && consecutiveActions < $krmaK.GlobalSettings.applets.refresh.maximumConsecutiveAutomaticRefreshes) {
                            if ($krmaK.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes <= 0) {
                                $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Info, "Triggering automatic card refresh number " + (consecutiveActions + 1));
                                this.internalExecuteAction(this._card.refresh.action, $3iICS.ActivityRequestTrigger.Automatic, consecutiveActions + 1);
                            } else {
                                $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Info, "Scheduling automatic card refresh number " + (consecutiveActions + 1) + " in " + $krmaK.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes + "ms");
                                var action_1 = this._card.refresh.action;
                                this._allowAutomaticCardUpdate = true;
                                window.setTimeout(function() {
                                    if (_this._allowAutomaticCardUpdate) _this.internalExecuteAction(action_1, $3iICS.ActivityRequestTrigger.Automatic, consecutiveActions + 1);
                                }, $krmaK.GlobalSettings.applets.refresh.timeBetweenAutomaticRefreshes);
                            }
                        } else if ($krmaK.GlobalSettings.applets.refresh.mode !== $4uYwi.RefreshMode.Disabled) {
                            if (consecutiveActions > 0) $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Warning, "Stopping automatic refreshes after " + consecutiveActions + " consecutive refreshes.");
                            else $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Warning, "The card has a refresh section, but automatic refreshes are disabled.");
                            if ($krmaK.GlobalSettings.applets.refresh.allowManualRefreshesAfterAutomaticRefreshes || $krmaK.GlobalSettings.applets.refresh.mode === $4uYwi.RefreshMode.Manual) {
                                $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Info, "Showing manual refresh button.");
                                this.showManualRefreshButton(this._card.refresh.action);
                            }
                        }
                    }
                }
            }
        } catch (error) {
            // Ignore all errors
            $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Error, "setCard: " + error);
        }
    };
    AdaptiveApplet.prototype.internalExecuteAction = function(action, trigger, consecutiveActions) {
        if (action instanceof $iBTKZ.UniversalAction) {
            if (this.channelAdapter) {
                var request = this.createActivityRequest(action, trigger, consecutiveActions);
                if (request) request.retryAsync();
            } else throw new Error("internalExecuteAction: No channel adapter set.");
        }
        if (this.onAction) this.onAction(this, action);
    };
    AdaptiveApplet.prototype.createProgressOverlay = function(request) {
        if (!this._progressOverlay) {
            if (this.onCreateProgressOverlay) this._progressOverlay = this.onCreateProgressOverlay(this, request);
            else {
                this._progressOverlay = document.createElement("div");
                this._progressOverlay.className = "aaf-progress-overlay";
                var spinner = document.createElement("div");
                spinner.className = "aaf-spinner";
                spinner.style.width = "28px";
                spinner.style.height = "28px";
                this._progressOverlay.appendChild(spinner);
            }
        }
        return this._progressOverlay;
    };
    AdaptiveApplet.prototype.removeProgressOverlay = function(request) {
        if (this.onRemoveProgressOverlay) this.onRemoveProgressOverlay(this, request);
        if (this._progressOverlay !== undefined) {
            this.renderedElement.removeChild(this._progressOverlay);
            this._progressOverlay = undefined;
        }
    };
    AdaptiveApplet.prototype.activityRequestSucceeded = function(response, parsedContent) {
        if (this.onActivityRequestSucceeded) this.onActivityRequestSucceeded(this, response, parsedContent);
    };
    AdaptiveApplet.prototype.activityRequestFailed = function(response) {
        return this.onActivityRequestFailed ? this.onActivityRequestFailed(this, response) : $krmaK.GlobalSettings.applets.defaultTimeBetweenRetryAttempts;
    };
    AdaptiveApplet.prototype.showAuthCodeInputDialog = function(request) {
        var _this = this;
        var showBuiltInAuthCodeInputCard = this.onShowAuthCodeInputDialog ? this.onShowAuthCodeInputDialog(this, request) : true;
        if (showBuiltInAuthCodeInputCard) {
            var authCodeInputCard = this.createMagicCodeInputCard(request.attemptNumber);
            authCodeInputCard.render();
            authCodeInputCard.onExecuteAction = function(submitMagicCodeAction) {
                if (_this.card && submitMagicCodeAction instanceof $iBTKZ.SubmitAction) switch(submitMagicCodeAction.id){
                    case AdaptiveApplet._submitMagicCodeActionId:
                        var authCode = undefined;
                        if (submitMagicCodeAction.data && typeof submitMagicCodeAction.data["magicCode"] === "string") authCode = submitMagicCodeAction.data["magicCode"];
                        if (authCode) {
                            _this.displayCard(_this.card);
                            request.authCode = authCode;
                            request.retryAsync();
                        } else alert("Please enter the magic code you received.");
                        break;
                    case AdaptiveApplet._cancelMagicCodeAuthActionId:
                        $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Warning, "Authentication cancelled by user.");
                        _this.displayCard(_this.card);
                        break;
                    default:
                        $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Error, "Unexpected action taken from magic code input card (id = " + submitMagicCodeAction.id + ")");
                        alert($luP4B.Strings.magicCodeInputCard.somethingWentWrong());
                        break;
                }
            };
            this.displayCard(authCodeInputCard);
        }
    };
    AdaptiveApplet.prototype.internalSendActivityRequestAsync = function(request) {
        return $f5772db44fd5e3e2$var$__awaiter(this, void 0, void 0, function() {
            var action;
            return $f5772db44fd5e3e2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendActivityRequestAsync: channelAdapter is not set.");
                        action = request.action;
                        if (!(action instanceof $iBTKZ.ExecuteAction)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.internalSendExecuteRequestAsync(request)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(action instanceof $iBTKZ.DataQuery)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.internalSendDataQueryRequestAsync(request)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        throw new Error("internalSendActivityRequestAsync: Unhandled Action Type");
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.internalSendExecuteRequestAsync = function(request) {
        return $f5772db44fd5e3e2$var$__awaiter(this, void 0, void 0, function() {
            var overlay, done, _loop_1, this_1, state_1;
            return $f5772db44fd5e3e2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendExecuteRequestAsync: channelAdapter is not set.");
                        overlay = this.createProgressOverlay(request);
                        if (overlay !== undefined) this.renderedElement.appendChild(overlay);
                        done = false;
                        _loop_1 = function() {
                            var response, error_1, parsedContent, retryIn_1, attemptOAuth, left, top_1;
                            return $f5772db44fd5e3e2$var$__generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        response = undefined;
                                        if (request.attemptNumber === 1) $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Info, "Sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        else $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Info, "Re-sending activity request to channel (attempt " + request.attemptNumber + ")");
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this_1.channelAdapter.sendRequestAsync(request)
                                        ];
                                    case 2:
                                        response = _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 3:
                                        error_1 = _b.sent();
                                        $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Error, "Activity request failed: " + error_1);
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 4:
                                        if (!response) return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                        if (!(response instanceof $3iICS.SuccessResponse)) return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                        this_1.removeProgressOverlay(request);
                                        if (response.rawContent === undefined) throw new Error("internalSendExecuteRequestAsync: Action.Execute result is undefined");
                                        parsedContent = response.rawContent;
                                        try {
                                            parsedContent = JSON.parse(response.rawContent);
                                        } catch (_c) {
                                        // Leave parseContent as is
                                        }
                                        if (typeof parsedContent === "string") {
                                            $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Info, "The activity request returned a string after " + request.attemptNumber + " attempt(s).");
                                            this_1.activityRequestSucceeded(response, parsedContent);
                                        } else if (typeof parsedContent === "object" && parsedContent["type"] === "AdaptiveCard") {
                                            $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Info, "The activity request returned an Adaptive Card after " + request.attemptNumber + " attempt(s).");
                                            this_1.internalSetCard(parsedContent, request.consecutiveActions);
                                            this_1.activityRequestSucceeded(response, this_1.card);
                                        } else throw new Error("internalSendExecuteRequestAsync: Action.Execute result is of unsupported type (" + typeof response.rawContent + ")");
                                        done = true;
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 5:
                                        if (!(response instanceof $3iICS.ErrorResponse)) return [
                                            3 /*break*/ ,
                                            9
                                        ];
                                        retryIn_1 = this_1.activityRequestFailed(response);
                                        if (!(retryIn_1 >= 0 && request.attemptNumber < $krmaK.GlobalSettings.applets.maximumRetryAttempts)) return [
                                            3 /*break*/ ,
                                            7
                                        ];
                                        $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Warning, "Activity request failed: ".concat(response.error.message, ". Retrying in ").concat(retryIn_1, "ms"));
                                        request.attemptNumber++;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve, _reject) {
                                                window.setTimeout(function() {
                                                    resolve();
                                                }, retryIn_1);
                                            })
                                        ];
                                    case 6:
                                        _b.sent();
                                        return [
                                            3 /*break*/ ,
                                            8
                                        ];
                                    case 7:
                                        $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Error, "Activity request failed: ".concat(response.error.message, ". Giving up after ").concat(request.attemptNumber, " attempt(s)"));
                                        this_1.removeProgressOverlay(request);
                                        done = true;
                                        _b.label = 8;
                                    case 8:
                                        return [
                                            3 /*break*/ ,
                                            10
                                        ];
                                    case 9:
                                        if (response instanceof $3iICS.LoginRequestResponse) {
                                            $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Info, "The activity request returned a LoginRequestResponse after " + request.attemptNumber + " attempt(s).");
                                            if (request.attemptNumber <= $krmaK.GlobalSettings.applets.maximumRetryAttempts) {
                                                attemptOAuth = true;
                                                if (response.tokenExchangeResource && this_1.onSSOTokenNeeded) // Attempt to use SSO. The host will return true if it can handle SSO, in which case
                                                // we bypass OAuth
                                                attemptOAuth = !this_1.onSSOTokenNeeded(this_1, request, response.tokenExchangeResource);
                                                if (attemptOAuth) {
                                                    // Attempt to use OAuth
                                                    this_1.removeProgressOverlay(request);
                                                    if (response.signinButton === undefined) throw new Error("internalSendExecuteRequestAsync: the login request doesn't contain a valid signin URL.");
                                                    $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Info, "Login required at " + response.signinButton.value);
                                                    if (this_1.onShowSigninPrompt) // Bypass the built-in auth prompt if the host app handles it
                                                    this_1.onShowSigninPrompt(this_1, request, response.signinButton);
                                                    else {
                                                        this_1.showAuthCodeInputDialog(request);
                                                        left = window.screenX + (window.outerWidth - $krmaK.GlobalSettings.applets.authPromptWidth) / 2;
                                                        top_1 = window.screenY + (window.outerHeight - $krmaK.GlobalSettings.applets.authPromptHeight) / 2;
                                                        window.open(response.signinButton.value, response.signinButton.title ? response.signinButton.title : "Sign in", "width=".concat($krmaK.GlobalSettings.applets.authPromptWidth, ",height=").concat($krmaK.GlobalSettings.applets.authPromptHeight, ",left=").concat(left, ",top=").concat(top_1));
                                                    }
                                                }
                                            } else {
                                                $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Error, "Authentication failed. Giving up after " + request.attemptNumber + " attempt(s)");
                                                alert($luP4B.Strings.magicCodeInputCard.authenticationFailed());
                                            }
                                            return [
                                                2 /*return*/ ,
                                                "break"
                                            ];
                                        } else throw new Error("Unhandled response type: " + JSON.stringify(response));
                                        _b.label = 10;
                                    case 10:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 1;
                    case 1:
                        if (!!done) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 2:
                        state_1 = _a.sent();
                        if (state_1 === "break") return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.internalSendDataQueryRequestAsync = function(request) {
        return $f5772db44fd5e3e2$var$__awaiter(this, void 0, void 0, function() {
            var filter, response, error_2, rawResponse, parsedResponse;
            return $f5772db44fd5e3e2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.channelAdapter) throw new Error("internalSendDataQueryRequestAsync: channel adapter not set");
                        filter = request.action.filter;
                        if (!this._choiceSet) return [
                            3 /*break*/ ,
                            5
                        ];
                        this._choiceSet.showLoadingIndicator();
                        response = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.channelAdapter.sendRequestAsync(request)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        this._choiceSet.showErrorIndicator(filter, "Unable to load");
                        $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Error, "Activity request failed: " + error_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (response) {
                            if (response instanceof $3iICS.SuccessResponse) {
                                rawResponse = response.rawContent;
                                if (rawResponse) {
                                    parsedResponse = void 0;
                                    try {
                                        parsedResponse = JSON.parse(rawResponse);
                                    } catch (error) {
                                        this._choiceSet.showErrorIndicator(filter, "Unable to load");
                                        throw new Error("internalSendDataQueryRequestAsync: Cannot parse response object: " + rawResponse);
                                    }
                                    if (typeof parsedResponse === "object") {
                                        this._choiceSet.renderChoices(filter, parsedResponse);
                                        this.activityRequestSucceeded(response, rawResponse);
                                    } else {
                                        this._choiceSet.showErrorIndicator(filter, "Error loading results");
                                        throw new Error("internalSendDataQueryRequestAsync: Data.Query result is of unsupported type (" + typeof rawResponse + ")");
                                    }
                                } else {
                                    this._choiceSet.showErrorIndicator(filter, "Unable to load");
                                    throw new Error("internalSendDataQueryRequestAsync: Data.Query result is undefined");
                                }
                            } else if (response instanceof $3iICS.ErrorResponse) {
                                this._choiceSet.showErrorIndicator(filter, response.error.message || "Error loading results");
                                $f5772db44fd5e3e2$var$logEvent($4uYwi.LogLevel.Error, "Activity request failed: ".concat(response.error.message, "."));
                                this.activityRequestFailed(response);
                            } else {
                                this._choiceSet.showErrorIndicator(filter, "Unable to load");
                                throw new Error("Unhandled response type: " + JSON.stringify(response));
                            }
                        } else this._choiceSet.removeLoadingIndicator();
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AdaptiveApplet.prototype.refreshCard = function() {
        if (this._card && this._card.refresh) this.internalExecuteAction(this._card.refresh.action, $3iICS.ActivityRequestTrigger.Manual, 0);
    };
    AdaptiveApplet.prototype.setCard = function(payload) {
        this.internalSetCard(payload, 0);
    };
    Object.defineProperty(AdaptiveApplet.prototype, "card", {
        get: function() {
            return this._card;
        },
        enumerable: false,
        configurable: true
    });
    AdaptiveApplet._submitMagicCodeActionId = "submitMagicCode";
    AdaptiveApplet._cancelMagicCodeAuthActionId = "cancelMagicCodeAuth";
    return AdaptiveApplet;
}();
module.exports.AdaptiveApplet = $f5772db44fd5e3e2$var$AdaptiveApplet;

});

parcelRegister("7NOBO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5coaL = parcelRequire("5coaL");

var $k4O0d = parcelRequire("k4O0d");

var $5iJYK = parcelRequire("5iJYK");

var $jkpFf = parcelRequire("jkpFf");

var $CZiwH = parcelRequire("CZiwH");

var $datUV = parcelRequire("datUV");

var $hUwbq = parcelRequire("hUwbq");
function $5ae45de56ee53880$var$createFormatter(options) {
    switch(options.platform){
        case "amazon-alexa":
            return new $k4O0d.AmazonAlexaSsmlFormatter(options);
        case "amazon-polly":
            return new $5iJYK.AmazonPollySsmlFormatter(options);
        case "amazon-polly-neural":
            return new $jkpFf.AmazonPollyNeuralSsmlFormatter(options);
        case "google-assistant":
            return new $CZiwH.GoogleAssistantSsmlFormatter(options);
        case "samsung-bixby":
            return new $datUV.SamsungBixbySsmlFormatter(options);
        case "microsoft-azure":
            return new $hUwbq.MicrosoftAzureSsmlFormatter(options);
        default:
            return new $5coaL.TextFormatter(options);
    }
}
module.exports.createFormatter = $5ae45de56ee53880$var$createFormatter;
function $5ae45de56ee53880$var$createTextFormatter(options) {
    return new $5coaL.TextFormatter(options);
}
module.exports.createTextFormatter = $5ae45de56ee53880$var$createTextFormatter;

});
parcelRegister("5coaL", function(module, exports) {
"use strict";
var $3c90d2eab5406be5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $29zcL = parcelRequire("29zcL");
var $3c90d2eab5406be5$var$TextFormatter = /** @class */ function(_super) {
    $3c90d2eab5406be5$var$__extends(TextFormatter, _super);
    function TextFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        return _this;
    }
    TextFormatter.prototype.format = function(ast) {
        var lines = this.formatFromAst(ast, []);
        var txt = lines.join("").trim();
        // replace multiple whitespace with a single space
        // tslint:disable-next-line: no-regex-spaces
        txt = txt.replace(/  +/g, " ");
        return txt;
    };
    TextFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                this.processAst(ast.children, lines);
                return lines;
            case "paragraph":
                this.processAst(ast.children, lines);
                return lines;
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return TextFormatter;
}($29zcL.FormatterBase);
module.exports.TextFormatter = $3c90d2eab5406be5$var$TextFormatter;

});
parcelRegister("29zcL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1917bb0094d6703e$var$FormatterBase = /** @class */ function() {
    function FormatterBase(options) {
        this.options = options;
        this.options = options;
    }
    // Adds each element of the array as markdown
    FormatterBase.prototype.addArray = function(ast, lines) {
        for(var _i = 0, ast_1 = ast; _i < ast_1.length; _i++){
            var child = ast_1[_i];
            this.formatFromAst(child, lines);
        }
        return lines;
    };
    FormatterBase.prototype.processAst = function(ast, lines) {
        if (ast instanceof Array) this.addArray(ast, lines);
        else this.formatFromAst(ast, lines);
    };
    return FormatterBase;
}();
module.exports.FormatterBase = $1917bb0094d6703e$var$FormatterBase;

});


parcelRegister("k4O0d", function(module, exports) {
"use strict";
var $e9daf7ce44a21a40$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fEgP3 = parcelRequire("fEgP3");
var $e9daf7ce44a21a40$var$AmazonAlexaSsmlFormatter = /** @class */ function(_super) {
    $e9daf7ce44a21a40$var$__extends(AmazonAlexaSsmlFormatter, _super);
    function AmazonAlexaSsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.validVoices = {
            "Ivy": "en-US",
            "Joanna": "en-US",
            "Joey": "en-US",
            "Justin": "en-US",
            "Kendra": "en-US",
            "Kimberly": "en-US",
            "Matthew": "en-US",
            "Salli": "en-US",
            "Nicole": "en-AU",
            "Russell": "en-AU",
            "Amy": "en-GB",
            "Brian": "en-GB",
            "Emma": "en-GB",
            "Aditi": "en-IN",
            "Raveena": "en-IN",
            "Hans": "de-DE",
            "Marlene": "de-DE",
            "Vicki": "de-DE",
            "Conchita": "es-ES",
            "Enrique": "es-ES",
            "Carla": "it-IT",
            "Giorgio": "it-IT",
            "Mizuki": "ja-JP",
            "Takumi": "ja-JP",
            "Celine": "fr-FR",
            "Lea": "fr-FR",
            "Mathieu": "fr-FR"
        };
        _this.validEmotionIntensity = [
            "low",
            "medium",
            "high"
        ];
        _this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        _this.modifierKeyToSsmlTagMappings.voice = "voice";
        _this.modifierKeyToSsmlTagMappings.dj = "amazon:domain";
        _this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain";
        _this.modifierKeyToSsmlTagMappings.excited = "amazon:emotion";
        _this.modifierKeyToSsmlTagMappings.disappointed = "amazon:emotion";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    AmazonAlexaSsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "emphasis":
                            textModifierObject.tag(ssmlTag, {
                                level: value || "moderate"
                            });
                            break;
                        case "address":
                        case "characters":
                        case "expletive":
                        case "fraction":
                        case "interjection":
                        case "number":
                        case "ordinal":
                        case "telephone":
                        case "unit":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            });
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            });
                            break;
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                name: "whispered"
                            });
                            break;
                        case "ipa":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            });
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            });
                            break;
                        case "voice":
                            textModifierObject.voiceTag(key, value);
                            break;
                        case "excited":
                        case "disappointed":
                            var intensity = (value || "medium").toLowerCase();
                            if (this.validEmotionIntensity.includes(intensity)) {
                                textModifierObject.tag(ssmlTag, {
                                    "name": key,
                                    "intensity": intensity
                                });
                                break;
                            }
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonAlexaSsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "lang":
                        sectionObject.tag(ssmlTag, {
                            "xml:lang": value
                        });
                        break;
                    case "voice":
                        sectionObject.voiceTag(key, value);
                        break;
                    case "dj":
                        sectionObject.tag(ssmlTag, {
                            "name": "music"
                        });
                        break;
                    case "newscaster":
                        sectionObject.tag(ssmlTag, {
                            "name": "news"
                        });
                        break;
                    case "defaults":
                        break;
                    case "excited":
                    case "disappointed":
                        var intensity = (value || "medium").toLowerCase();
                        if (this.validEmotionIntensity.includes(intensity)) {
                            sectionObject.tag(ssmlTag, {
                                "name": key,
                                "intensity": intensity
                            });
                            break;
                        }
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonAlexaSsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "shortEmphasisModerate":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "moderate"
                });
            case "shortEmphasisStrong":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "strong"
                });
            case "shortEmphasisNone":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "none"
                });
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "reduced"
                });
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            case "audio":
                var url = ast.children[0].allText.replace(/&/g, "&amp;");
                return this.addTagWithAttrs(lines, null, "audio", {
                    src: url
                });
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
                var text = this.options.escapeXmlSymbols ? this.escapeXmlCharacters(ast.allText) : ast.allText;
                lines.push(text);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return AmazonAlexaSsmlFormatter;
}($fEgP3.SsmlFormatterBase);
module.exports.AmazonAlexaSsmlFormatter = $e9daf7ce44a21a40$var$AmazonAlexaSsmlFormatter;

});
parcelRegister("fEgP3", function(module, exports) {
"use strict";
var $b647a40889ff30f8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b647a40889ff30f8$var$__assign = module.exports && module.exports.__assign || function() {
    $b647a40889ff30f8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b647a40889ff30f8$var$__assign.apply(this, arguments);
};
var $b647a40889ff30f8$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $29zcL = parcelRequire("29zcL");
var $b647a40889ff30f8$var$TagsObject = /** @class */ function() {
    function TagsObject(base) {
        this.base = base;
        this.tags = {};
        this.text = "";
    }
    TagsObject.prototype.tag = function(tag, attrs, augment, ssmlTagSortOrder) {
        if (augment === void 0) augment = false;
        if (ssmlTagSortOrder === void 0) ssmlTagSortOrder = this.base.ssmlTagSortOrder;
        var sortId = ssmlTagSortOrder.indexOf(tag);
        if (!this.tags[tag]) this.tags[tag] = {
            sortId: sortId,
            attrs: null
        };
        if (augment) this.tags[tag].attrs = $b647a40889ff30f8$var$__assign($b647a40889ff30f8$var$__assign({}, this.tags[tag].attrs), attrs);
        else this.tags[tag].attrs = attrs;
    };
    TagsObject.prototype.voiceTagNamed = function(voices, name) {
        var _this = this;
        var info = voices && voices[name];
        if (info) {
            if (typeof info !== "object") info = {
                voice: {
                    "name": name
                }
            };
            Object.keys(info).forEach(function(tag) {
                var attributes = info[tag];
                _this.tag(tag, attributes);
            });
            return true;
        }
        return false;
    };
    TagsObject.prototype.voiceTag = function(tag, value) {
        var name = this.base.sentenceCase(value || "device");
        var handled = this.voiceTagNamed(this.base.options && this.base.options.voices, name) || this.voiceTagNamed(this.base.validVoices, name);
    };
    return TagsObject;
}();
module.exports.TagsObject = $b647a40889ff30f8$var$TagsObject;
var $b647a40889ff30f8$var$SsmlFormatterBase = /** @class */ function(_super) {
    $b647a40889ff30f8$var$__extends(SsmlFormatterBase, _super);
    function SsmlFormatterBase(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.sectionTags = [];
        _this.modifierKeyMappings = {
            "chars": "characters",
            "cardinal": "number",
            "digits": "characters",
            "bleep": "expletive",
            "phone": "telephone",
            "vol": "volume"
        };
        _this.ssmlTagSortOrder = [
            "emphasis",
            "say-as",
            "prosody",
            "amazon:domain",
            "amazon:effect",
            "amazon:emotion",
            "voice",
            "lang",
            "sub",
            "phoneme"
        ];
        _this.modifierKeyToSsmlTagMappings = {
            "emphasis": "emphasis",
            "address": "say-as",
            "number": "say-as",
            "characters": "say-as",
            "expletive": "say-as",
            "fraction": "say-as",
            "interjection": "say-as",
            "ordinal": "say-as",
            "telephone": "say-as",
            "unit": "say-as",
            "time": "say-as",
            "date": "say-as",
            "whisper": null,
            "sub": "sub",
            "ipa": "phoneme",
            "rate": "prosody",
            "pitch": "prosody",
            "volume": "prosody",
            "drc": null,
            "timbre": null,
            "lang": null,
            "voice": null,
            "dj": null,
            "defaults": null,
            "newscaster": null,
            "excited": null,
            "disappointed": null
        };
        return _this;
    }
    SsmlFormatterBase.prototype.format = function(ast) {
        var lines = this.formatFromAst(ast, []);
        return lines.join("");
    };
    SsmlFormatterBase.prototype.addSectionStartTag = function(tagsSortedAsc, so, lines) {
        this.sectionTags = $b647a40889ff30f8$var$__spreadArrays(tagsSortedAsc).reverse();
        for(var index = 0; index < tagsSortedAsc.length; index++){
            var tag = tagsSortedAsc[index];
            var attrs = so.tags[tag].attrs;
            lines.push("\n");
            lines.push(this.startTag(tag, attrs, false));
        }
    };
    SsmlFormatterBase.prototype.addSectionEndTag = function(lines) {
        if (this.sectionTags.length > 0) // add previous end tag(s)
        for(var index = 0; index < this.sectionTags.length; index++){
            var tag = this.sectionTags[index];
            lines.push(this.endTag(tag, false));
            lines.push("\n");
        }
    };
    // Adds tagged content
    SsmlFormatterBase.prototype.addTag = function(tag, ast, newLine, newLineAfterEnd, attr, lines) {
        lines.push(this.startTag(tag, attr, newLine));
        this.processAst(ast, lines);
        lines.push(this.endTag(tag, newLine));
        if (newLineAfterEnd) lines.push("\n");
        return lines;
    };
    SsmlFormatterBase.prototype.addSpeakTag = function(ast, newLine, newLineAfterEnd, attr, lines) {
        lines.push(this.startTag("speak", attr, newLine));
        this.processAst(ast, lines);
        this.addSectionEndTag(lines);
        lines.push(this.endTag("speak", newLine));
        if (newLineAfterEnd) lines.push("\n");
        return lines;
    };
    SsmlFormatterBase.prototype.addComment = function(commentText, lines) {
        lines.push("<!-- " + commentText + " -->\n");
        return lines;
    };
    // Returns the SSML for a start tag
    SsmlFormatterBase.prototype.startTag = function(tag, attr, newLine) {
        if (newLine === void 0) newLine = false;
        var attrStr = "";
        if (attr) attrStr = " " + Object.keys(attr).map(function(k) {
            return k + '="' + attr[k] + '"';
        }).join(" ");
        return "<" + tag + attrStr + ">" + (newLine ? "\n" : "");
    };
    // Returns the SSML for an end tag
    SsmlFormatterBase.prototype.endTag = function(tag, newLine) {
        if (newLine === void 0) newLine = false;
        return (newLine ? "\n" : "") + "</" + tag + ">";
    // return '</' + tag + '>';
    };
    SsmlFormatterBase.prototype.voidTag = function(tag, attr) {
        var attrStr = "";
        if (attr) attrStr = " " + Object.keys(attr).map(function(k) {
            return k + '="' + attr[k] + '"';
        }).join(" ");
        return "<" + tag + attrStr + "/>";
    };
    SsmlFormatterBase.prototype.addTagWithAttrs = function(lines, text, tag, attrs, forceEndTag) {
        if (forceEndTag === void 0) forceEndTag = false;
        if (text || forceEndTag) {
            lines.push(this.startTag(tag, attrs));
            if (text) lines.push(text);
            lines.push(this.endTag(tag, false));
        } else lines.push(this.voidTag(tag, attrs));
        return lines;
    };
    SsmlFormatterBase.prototype.getTagWithAttrs = function(text, tag, attrs) {
        var lines = [];
        if (text) {
            lines.push(this.startTag(tag, attrs));
            lines.push(text);
            lines.push(this.endTag(tag, false));
        } else lines.push(this.voidTag(tag, attrs));
        return lines.join("");
    };
    SsmlFormatterBase.prototype.sentenceCase = function(text) {
        return text.replace(/[a-z]/i, function(letter) {
            return letter.toUpperCase();
        }).trim();
    };
    SsmlFormatterBase.prototype.escapeXmlCharacters = function(unescaped) {
        // Only process once (by unescaping)
        var revPattern = Object.keys(SsmlFormatterBase.XML_UNESCAPE_MAPPING).join("|") + "]";
        var reversed = unescaped.replace(new RegExp(revPattern, "g"), function(s) {
            return SsmlFormatterBase.XML_UNESCAPE_MAPPING[s];
        });
        // Escape XML characters
        var pattern = "[" + Object.keys(SsmlFormatterBase.XML_ESCAPE_MAPPING).join("") + "]";
        var escaped = reversed.replace(new RegExp(pattern, "g"), function(s) {
            return SsmlFormatterBase.XML_ESCAPE_MAPPING[s];
        });
        // console.log([unescaped, reversed, escaped].join('\n'));
        return escaped;
    };
    SsmlFormatterBase.XML_ESCAPE_MAPPING = {
        "<": "&lt;",
        ">": "&gt;",
        "&": "&amp;",
        '"': "&quot;",
        "'": "&apos;"
    };
    SsmlFormatterBase.XML_UNESCAPE_MAPPING = function swapJSON(dictionary) {
        return Object.keys(dictionary).reduce(function(acc, key) {
            acc[dictionary[key]] = key;
            return acc;
        }, {});
    }(SsmlFormatterBase.XML_ESCAPE_MAPPING);
    return SsmlFormatterBase;
}($29zcL.FormatterBase);
module.exports.SsmlFormatterBase = $b647a40889ff30f8$var$SsmlFormatterBase;

});


parcelRegister("5iJYK", function(module, exports) {
"use strict";
var $3dc24c9e2377b1ce$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fEgP3 = parcelRequire("fEgP3");
var $3dc24c9e2377b1ce$var$AmazonPollySsmlFormatter = /** @class */ function(_super) {
    $3dc24c9e2377b1ce$var$__extends(AmazonPollySsmlFormatter, _super);
    function AmazonPollySsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.timbre = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.cardinal = "say-as";
        _this.modifierKeyToSsmlTagMappings.digits = "say-as";
        _this.modifierKeyToSsmlTagMappings.drc = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        _this.modifierKeyMappings.digits = "digits";
        _this.modifierKeyMappings.cardinal = "cardinal";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    AmazonPollySsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "emphasis":
                            textModifierObject.tag(ssmlTag, {
                                level: value || "moderate"
                            });
                            break;
                        case "address":
                        case "cardinal":
                        case "characters":
                        case "digits":
                        case "expletive":
                        case "fraction":
                        case "number":
                        case "ordinal":
                        case "telephone":
                        case "unit":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            });
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            });
                            break;
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                name: "whispered"
                            });
                            break;
                        case "ipa":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            });
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        case "timbre":
                            textModifierObject.tag(ssmlTag, {
                                "vocal-tract-length": value
                            });
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            });
                            break;
                        case "drc":
                            textModifierObject.tag(ssmlTag, {
                                "name": key
                            });
                            break;
                        case "voice":
                        case "excited":
                        case "disappointed":
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonPollySsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "lang":
                        sectionObject.tag(ssmlTag, {
                            "xml:lang": value
                        });
                        break;
                    case "defaults":
                        break;
                    case "voice":
                    case "dj":
                    case "newscaster":
                    case "excited":
                    case "disappointed":
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonPollySsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "markTag":
                var name = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "mark", {
                    name: name
                });
            case "shortEmphasisModerate":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "moderate"
                });
            case "shortEmphasisStrong":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "strong"
                });
            case "shortEmphasisNone":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "none"
                });
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "reduced"
                });
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return AmazonPollySsmlFormatter;
}($fEgP3.SsmlFormatterBase);
module.exports.AmazonPollySsmlFormatter = $3dc24c9e2377b1ce$var$AmazonPollySsmlFormatter;

});

parcelRegister("jkpFf", function(module, exports) {
"use strict";
var $e123caf3f98e42fb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fEgP3 = parcelRequire("fEgP3");
var $e123caf3f98e42fb$var$AmazonPollyNeuralSsmlFormatter = /** @class */ function(_super) {
    $e123caf3f98e42fb$var$__extends(AmazonPollyNeuralSsmlFormatter, _super);
    function AmazonPollyNeuralSsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.modifierKeyToSsmlTagMappings.cardinal = "say-as";
        _this.modifierKeyToSsmlTagMappings.digits = "say-as";
        _this.modifierKeyToSsmlTagMappings.drc = "amazon:effect";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        _this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain";
        _this.modifierKeyMappings.digits = "digits";
        _this.modifierKeyMappings.cardinal = "cardinal";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    AmazonPollyNeuralSsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "address":
                        case "cardinal":
                        case "characters":
                        case "digits":
                        case "expletive":
                        case "fraction":
                        case "number":
                        case "ordinal":
                        case "telephone":
                        case "unit":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            });
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            });
                            break;
                        case "ipa":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            });
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            });
                            break;
                        case "drc":
                            textModifierObject.tag(ssmlTag, {
                                "name": key
                            });
                            break;
                        // unavailable tags
                        case "excited":
                        case "disappointed":
                        case "emphasis":
                        case "interjection":
                        case "voice":
                        case "whisper":
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonPollyNeuralSsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "lang":
                        sectionObject.tag(ssmlTag, {
                            "xml:lang": value
                        });
                        break;
                    case "newscaster":
                        sectionObject.tag(ssmlTag, {
                            "name": "news"
                        });
                        break;
                    case "defaults":
                        break;
                    case "voice":
                    case "dj":
                    case "excited":
                    case "disappointed":
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    AmazonPollyNeuralSsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Amazon Polly", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "markTag":
                var name = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "mark", {
                    name: name
                });
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                lines.push(ast.allText.replace(/\+/g, ""));
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return AmazonPollyNeuralSsmlFormatter;
}($fEgP3.SsmlFormatterBase);
module.exports.AmazonPollyNeuralSsmlFormatter = $e123caf3f98e42fb$var$AmazonPollyNeuralSsmlFormatter;

});

parcelRegister("CZiwH", function(module, exports) {
"use strict";
var $07531931762669a4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fEgP3 = parcelRequire("fEgP3");
var $07531931762669a4$var$GoogleAssistantSsmlFormatter = /** @class */ function(_super) {
    $07531931762669a4$var$__extends(GoogleAssistantSsmlFormatter, _super);
    function GoogleAssistantSsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.validVoices = {
            "Ivy": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-US"
                }
            },
            "Joanna": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-US"
                }
            },
            "Joey": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-US"
                }
            },
            "Justin": {
                voice: {
                    gender: "male",
                    variant: 2,
                    language: "en-US"
                }
            },
            "Kendra": {
                voice: {
                    gender: "female",
                    variant: 3,
                    language: "en-US"
                }
            },
            "Kimberly": {
                voice: {
                    gender: "female",
                    variant: 4,
                    language: "en-US"
                }
            },
            "Matthew": {
                voice: {
                    gender: "male",
                    variant: 3,
                    language: "en-US"
                }
            },
            "Salli": {
                voice: {
                    gender: "male",
                    variant: 4,
                    language: "en-US"
                }
            },
            "Nicole": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-AU"
                }
            },
            "Russell": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-AU"
                }
            },
            "Amy": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-GB"
                }
            },
            "Brian": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "en-GB"
                }
            },
            "Emma": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-GB"
                }
            },
            "Aditi": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "en-IN"
                }
            },
            "Raveena": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "en-IN"
                }
            },
            "Hans": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "de-DE"
                }
            },
            "Marlene": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "de-DE"
                }
            },
            "Vicki": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "de-DE"
                }
            },
            "Conchita": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "es-ES"
                }
            },
            "Enrique": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "es-ES"
                }
            },
            "Carla": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "it-IT"
                }
            },
            "Giorgio": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "it-IT"
                }
            },
            "Mizuki": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            "Takumi": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "ja-JP"
                }
            },
            "Celine": {
                voice: {
                    gender: "female",
                    variant: 1,
                    language: "fr-FR"
                }
            },
            "Lea": {
                voice: {
                    gender: "female",
                    variant: 2,
                    language: "fr-FR"
                }
            },
            "Mathieu": {
                voice: {
                    gender: "male",
                    variant: 1,
                    language: "fr-FR"
                }
            }
        };
        _this.modifierKeyToSsmlTagMappings.interjection = null;
        _this.modifierKeyToSsmlTagMappings.whisper = "prosody";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    GoogleAssistantSsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "emphasis":
                            textModifierObject.tag(ssmlTag, {
                                level: value || "moderate"
                            });
                            break;
                        case "address":
                        case "characters":
                        case "expletive":
                        case "fraction":
                        case "number":
                        case "ordinal":
                        case "telephone":
                        case "unit":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            });
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            });
                            break;
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                volume: "x-soft",
                                rate: "slow"
                            });
                            break;
                        case "ipa":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            });
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            });
                            break;
                        case "voice":
                            textModifierObject.voiceTag(key, value);
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    GoogleAssistantSsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "lang":
                        sectionObject.tag(ssmlTag, {
                            "xml:lang": value
                        });
                        break;
                    case "voice":
                        sectionObject.voiceTag(key, value);
                        break;
                    case "defaults":
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    GoogleAssistantSsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Google Assistant", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "markTag":
                var name = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "mark", {
                    name: name
                });
            case "shortEmphasisModerate":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "moderate"
                });
            case "shortEmphasisStrong":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "strong"
                });
            case "shortEmphasisNone":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "none"
                });
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                return this.addTagWithAttrs(lines, text, "emphasis", {
                    level: "reduced"
                });
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                if (tmo_1.textOnly) {
                    // Quick return if tag is not supported
                    lines.push(tmo_1.text);
                    return lines;
                }
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            case "audio":
                var url = ast.children[0].allText.replace(/&/g, "&amp;");
                return this.addTagWithAttrs(lines, null, "audio", {
                    src: url
                });
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return GoogleAssistantSsmlFormatter;
}($fEgP3.SsmlFormatterBase);
module.exports.GoogleAssistantSsmlFormatter = $07531931762669a4$var$GoogleAssistantSsmlFormatter;

});

parcelRegister("datUV", function(module, exports) {
"use strict";
var $99636a758975a0e4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fEgP3 = parcelRequire("fEgP3");
var $99636a758975a0e4$var$SamsungBixbySsmlFormatter = /** @class */ function(_super) {
    $99636a758975a0e4$var$__extends(SamsungBixbySsmlFormatter, _super);
    function SamsungBixbySsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.modifierKeyToSsmlTagMappings.emphasis = null;
        _this.modifierKeyToSsmlTagMappings.address = null;
        _this.modifierKeyToSsmlTagMappings.number = "say-as";
        _this.modifierKeyToSsmlTagMappings.characters = "say-as";
        _this.modifierKeyToSsmlTagMappings.expletive = null;
        _this.modifierKeyToSsmlTagMappings.fraction = "say-as";
        _this.modifierKeyToSsmlTagMappings.interjection = null;
        _this.modifierKeyToSsmlTagMappings.ordinal = "say-as";
        _this.modifierKeyToSsmlTagMappings.telephone = null;
        _this.modifierKeyToSsmlTagMappings.unit = null;
        _this.modifierKeyToSsmlTagMappings.time = null;
        _this.modifierKeyToSsmlTagMappings.date = null;
        _this.modifierKeyToSsmlTagMappings.sub = "sub";
        _this.modifierKeyToSsmlTagMappings.ipa = null;
        _this.modifierKeyToSsmlTagMappings.rate = "prosody";
        _this.modifierKeyToSsmlTagMappings.pitch = "prosody";
        _this.modifierKeyToSsmlTagMappings.volume = "prosody";
        _this.modifierKeyToSsmlTagMappings.whisper = "prosody";
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    SamsungBixbySsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        // case 'emphasis': {
                        //   if (!textModifierObject.tags[ssmlTag]) {
                        //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                        //   }
                        //   textModifierObject.tags[ssmlTag].attrs = { level: value || 'moderate' };
                        //   break;
                        // }
                        // case 'address':
                        // case 'expletive':
                        // case 'telephone':
                        // case 'unit':
                        case "fraction":
                        case "ordinal":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            });
                            break;
                        case "number":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": "cardinal"
                            });
                            break;
                        case "characters":
                            var attrValue = "digits";
                            if (isNaN(textModifierObject.text)) attrValue = "spell-out";
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": attrValue
                            });
                            break;
                        // case 'date': {
                        //   if (!textModifierObject.tags[ssmlTag]) {
                        //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                        //   }
                        //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'ymd' };
                        //   break;
                        // }
                        // case 'time': {
                        //   if (!textModifierObject.tags[ssmlTag]) {
                        //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                        //   }
                        //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'hms12' };
                        //   break;
                        // }
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                volume: "x-soft",
                                rate: "slow"
                            });
                            break;
                        // case 'ipa': {
                        //   // Google Assistant does not support <phoneme> tag
                        //   if (!textModifierObject.tags[ssmlTag]) {
                        //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
                        //   }
                        //   textModifierObject['textOnly'] = true;
                        //   break;
                        // }
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            });
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true);
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    SamsungBixbySsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Samsung Bixby", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                if (text) lines.push(text);
                return lines;
            // case 'shortEmphasisStrong': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'strong' });
            // }
            // case 'shortEmphasisNone': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'none' });
            // }
            // case 'shortEmphasisReduced': {
            //   const text = ast.children[0].allText;
            //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'reduced' });
            // }
            // case 'textModifier': {
            //   const tmo = this.getTextModifierObject(ast);
            //   if (tmo.textOnly) {
            //     // Quick return if tag is not supported
            //     lines.push(tmo.text)
            //     return lines
            //   }
            //   const tagsSortedDesc = Object.keys(tmo.tags).sort((a: any, b: any) => { return tmo.tags[b].sortId - tmo.tags[a].sortId });
            //   let inner = tmo.text;
            //   for (let index = 0; index < tagsSortedDesc.length; index++) {
            //     const tag = tagsSortedDesc[index];
            //     const attrs = tmo.tags[tag].attrs;
            //     inner = this.getTagWithAttrs(inner, tag, attrs);
            //   }
            //   lines.push(inner);
            //   return lines;
            // }
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                if (tmo_1.textOnly) {
                    // Quick return if tag is not supported
                    lines.push(tmo_1.text);
                    return lines;
                }
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "audio":
                var url = ast.children[0].allText.replace(/&/g, "&amp;");
                return this.addTagWithAttrs(lines, null, "audio", {
                    src: url
                }, true);
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                lines.push(ast.allText);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    return SamsungBixbySsmlFormatter;
}($fEgP3.SsmlFormatterBase);
module.exports.SamsungBixbySsmlFormatter = $99636a758975a0e4$var$SamsungBixbySsmlFormatter;

});

parcelRegister("hUwbq", function(module, exports) {
"use strict";
var $d0a0a18ab9e0b046$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fEgP3 = parcelRequire("fEgP3");
var $d0a0a18ab9e0b046$var$MicrosoftAzureSsmlFormatter = /** @class */ function(_super) {
    $d0a0a18ab9e0b046$var$__extends(MicrosoftAzureSsmlFormatter, _super);
    function MicrosoftAzureSsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.modifierKeyToSsmlTagMappings.emphasis = "emphasis";
        _this.modifierKeyToSsmlTagMappings.address = "say-as";
        _this.modifierKeyToSsmlTagMappings.number = "say-as";
        _this.modifierKeyToSsmlTagMappings.characters = "say-as";
        _this.modifierKeyToSsmlTagMappings.expletive = null;
        _this.modifierKeyToSsmlTagMappings.fraction = "say-as";
        _this.modifierKeyToSsmlTagMappings.interjection = null;
        _this.modifierKeyToSsmlTagMappings.ordinal = "say-as";
        _this.modifierKeyToSsmlTagMappings.telephone = "say-as";
        _this.modifierKeyToSsmlTagMappings.unit = null;
        _this.modifierKeyToSsmlTagMappings.time = "say-as";
        _this.modifierKeyToSsmlTagMappings.date = "say-as";
        _this.modifierKeyToSsmlTagMappings.sub = "sub";
        _this.modifierKeyToSsmlTagMappings.paragraph = "p";
        _this.modifierKeyToSsmlTagMappings.sentence = "s";
        _this.modifierKeyToSsmlTagMappings.lang = "lang";
        _this.modifierKeyToSsmlTagMappings.voice = "voice";
        // Phoneme attributes
        _this.modifierKeyToSsmlTagMappings.ipa = "phoneme";
        _this.modifierKeyToSsmlTagMappings.sapi = "phoneme";
        _this.modifierKeyToSsmlTagMappings.ups = "phoneme";
        // Prosody attributes
        _this.modifierKeyToSsmlTagMappings.pitch = "prosody";
        _this.modifierKeyToSsmlTagMappings.contour = "prosody";
        _this.modifierKeyToSsmlTagMappings.range = "prosody";
        _this.modifierKeyToSsmlTagMappings.rate = "prosody";
        _this.modifierKeyToSsmlTagMappings.volume = "prosody";
        _this.modifierKeyToSsmlTagMappings.whisper = "prosody";
        // mstts specifics
        _this.modifierKeyToSsmlTagMappings.emotion = "mstts:express-as";
        _this.ssmlTagSortOrder = [
            "voice",
            "lang",
            "p",
            "s",
            "emphasis",
            "say-as",
            "mstts:express-as",
            "prosody",
            "sub",
            "phoneme"
        ];
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    MicrosoftAzureSsmlFormatter.prototype.getTextModifierObject = function(ast) {
        var textModifierObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            switch(child.name){
                case "plainText":
                case "plainTextSpecialChars":
                case "plainTextEmphasis":
                case "plainTextPhone":
                case "plainTextModifier":
                    textModifierObject["text"] = child.allText;
                    break;
                case "textModifierKeyOptionalValue":
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : "";
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch(key){
                        case "address":
                        case "fraction":
                        case "ordinal":
                        case "telephone":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "number":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": "cardinal"
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "characters":
                            var attrValue = "digits";
                            if (isNaN(textModifierObject.text)) attrValue = "characters";
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": attrValue
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "date":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "ymd"
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "time":
                            textModifierObject.tag(ssmlTag, {
                                "interpret-as": key,
                                format: value || "hms12"
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "whisper":
                            textModifierObject.tag(ssmlTag, {
                                volume: "x-soft",
                                rate: "slow"
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "ipa":
                        case "sapi":
                        case "ups":
                            textModifierObject.tag(ssmlTag, {
                                alphabet: key,
                                ph: value
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "sub":
                            textModifierObject.tag(ssmlTag, {
                                alias: value
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "volume":
                        case "rate":
                        case "pitch":
                            var attrs = {};
                            attrs[key] = value || "medium";
                            textModifierObject.tag(ssmlTag, attrs, true, this.ssmlTagSortOrder);
                            break;
                        case "lang":
                            textModifierObject.tag(ssmlTag, {
                                "xml:lang": value
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "voice":
                            // Voice name must be as follows (case insensitive, the examples give the common writing with case) :
                            // <language>-<CULTURE>-<VoiceName> (ex: en-US-GuyNeural, en-US-JennyNeural)
                            var name = this.sentenceCase(value || "device");
                            if (name != "Device") textModifierObject.tag(ssmlTag, {
                                "name": name
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "emotion":
                            // The 'value' field can contain up to 2 data, separated by a space. Let's explode the value string
                            var attrsArray = value.split(" ");
                            var attrs = {};
                            // In order, we get 'style' first, then 'styledegree' or 'role' from the value
                            switch(attrsArray.length){
                                case 2:
                                    var parsed = parseInt(attrsArray[1]);
                                    // If the result is a number, it's the 'styledegree' attribute, either way it's the 'role' one
                                    if (isNaN(parsed)) attrs["role"] = attrsArray[1];
                                    else attrs["styledegree"] = attrsArray[1];
                                case 1:
                                    attrs["style"] = attrsArray[0];
                                    break;
                                default:
                                    break;
                            }
                            textModifierObject.tag(ssmlTag, attrs, true, this.ssmlTagSortOrder);
                            break;
                        case "emphasis":
                            textModifierObject.tag(ssmlTag, {
                                "level": value
                            }, false, this.ssmlTagSortOrder);
                            break;
                        case "paragraph":
                            textModifierObject.tag(ssmlTag, null, false, this.ssmlTagSortOrder);
                            break;
                        case "sentence":
                            textModifierObject.tag(ssmlTag, null, false, this.ssmlTagSortOrder);
                            break;
                        default:
                    }
                    break;
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    MicrosoftAzureSsmlFormatter.prototype.getSectionObject = function(ast) {
        var sectionObject = new $fEgP3.TagsObject(this);
        for(var index = 0; index < ast.children.length; index++){
            var child = ast.children[index];
            if (child.name === "sectionModifierKeyOptionalValue") {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : "";
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch(key){
                    case "voice":
                        // Voice name must be as follows (case insensitive, the examples give the common writing with case) :
                        // <language>-<CULTURE>-<VoiceName> (ex: en-US-GuyNeural, en-US-JennyNeural)
                        var name = this.sentenceCase(value || "device");
                        if (name != "Device") sectionObject.tag(ssmlTag, {
                            "name": name
                        }, false, this.ssmlTagSortOrder);
                        break;
                    case "defaults":
                        break;
                    case "emotion":
                        sectionObject.tag(ssmlTag, {
                            "style": value
                        }, false, this.ssmlTagSortOrder);
                        break;
                    default:
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    MicrosoftAzureSsmlFormatter.prototype.formatFromAst = function(ast, lines) {
        if (lines === void 0) lines = [];
        switch(ast.name){
            case "document":
                if (this.options.includeFormatterComment) this.addComment("Converted from Speech Markdown to SSML for Microsoft Azure", lines);
                if (this.options.includeSpeakTag) return this.addSpeakTag(ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "paragraph":
                if (this.options.includeParagraphTag) return this.addTag("p", ast.children, true, false, null, lines);
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            case "shortBreak":
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "break", {
                    time: time
                });
            case "break":
                var val = ast.children[0].allText;
                var attrs = {};
                switch(ast.children[0].children[0].name){
                    case "breakStrengthValue":
                        attrs = {
                            strength: val
                        };
                        break;
                    case "time":
                        attrs = {
                            time: val
                        };
                        break;
                }
                return this.addTagWithAttrs(lines, null, "break", attrs);
            case "silence":
                // 2 attributes, space-separated : type and value
                // type can be : Leading, Tailing or Sentenceboundary
                // value in seconds or milliseconds (ex : 1s, 200ms) less than 5 seconds
                var attrsArray = ast.children[0].allText.split(" ");
                var attrs = {
                    "type": attrsArray[0],
                    "value": attrsArray[1]
                };
                return this.addTagWithAttrs(lines, null, "mstts:silence", attrs);
            case "backgroundAudio":
                // 1 to 4 attributes, space-separated : src (mandatory), volume, fadein, fadeout
                var attrsArray = ast.children[0].allText.split(" ");
                var attrs = {};
                var attributes = [
                    "src",
                    "volume",
                    "fadein",
                    "fadeout"
                ];
                for(var i = 0; i < attrsArray.length; i++)attrs[attributes[i]] = attrsArray[i];
                return this.addTagWithAttrs(lines, null, "mstts:backgroundaudio", attrs);
            case "lexicon":
                var uri = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "lexicon", {
                    uri: uri
                });
            case "bookmark":
                var mark = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, "bookmark", {
                    mark: mark
                });
            case "shortEmphasisModerate":
            case "shortEmphasisStrong":
            case "shortEmphasisNone":
            case "shortEmphasisReduced":
                var text = ast.children[0].allText;
                if (text) lines.push(text);
                return lines;
            case "textModifier":
                var tmo_1 = this.getTextModifierObject(ast);
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function(a, b) {
                    return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId;
                });
                var inner = tmo_1.text;
                for(var index = 0; index < tagsSortedDesc.length; index++){
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    if (tag === "voice" || tag === "lang") {
                        var previousTag = index < tagsSortedDesc.length - 1 ? tagsSortedDesc[index + 1] : "";
                        inner = this.getVoiceOrLangTagWithAttrs(inner, tag, attrs, previousTag);
                    } else inner = this.getTagWithAttrs(inner, tag, attrs);
                }
                lines.push(inner);
                return lines;
            case "audio":
                var url = ast.children[0].allText.replace(/&/g, "&amp;");
                return this.addTagWithAttrs(lines, null, "audio", {
                    src: url
                }, false);
            case "simpleLine":
                this.processAst(ast.children, lines);
                return lines;
            case "lineEnd":
                lines.push(ast.allText);
                return lines;
            case "emptyLine":
                if (this.options.preserveEmptyLines) lines.push(ast.allText);
                return lines;
            case "plainText":
            case "plainTextSpecialChars":
            case "plainTextEmphasis":
            case "plainTextPhone":
            case "plainTextModifier":
                lines.push(ast.allText);
                return lines;
            case "section":
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function(a, b) {
                    return so_1.tags[a].sortId - so_1.tags[b].sortId;
                });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            default:
                this.processAst(ast.children, lines);
                return lines;
        }
    };
    MicrosoftAzureSsmlFormatter.prototype.getVoiceOrLangTagWithAttrs = function(text, tag, attrs, previousTag) {
        var lines = [];
        if (text) {
            lines.push(this.startVoiceOrLangTag(tag, attrs, previousTag));
            lines.push(text);
            lines.push(this.endVoiceOrLangTag(tag, false, previousTag));
        } else lines.push(this.voidTag(tag, attrs));
        return lines.join("");
    };
    // Returns the SSML for a start tag
    MicrosoftAzureSsmlFormatter.prototype.startVoiceOrLangTag = function(tag, attr, previousTag, newLine) {
        if (newLine === void 0) newLine = false;
        var attrStr = "";
        var prefix = "";
        switch(tag){
            case "voice":
                // If a global 'voice' tag is opened at the root of the SSML file, we have to close it and re-open it every time another 'voice' tag opens
                if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice) {
                    prefix = "</voice>";
                    // If there is a global lang, let's open a new tag for this lang
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang) prefix = "</lang>" + prefix;
                }
                break;
            case "lang":
                // If the previous tag was a 'voice' one, we use the basic behaviour
                if (!(previousTag && previousTag === "voice")) {
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang) prefix = "</lang>";
                }
                break;
            default:
                break;
        }
        if (attr) attrStr = " " + Object.keys(attr).map(function(k) {
            return k + '="' + attr[k] + '"';
        }).join(" ");
        return prefix + "<" + tag + attrStr + ">" + (newLine ? "\n" : "");
    };
    // Returns the SSML for an end tag
    MicrosoftAzureSsmlFormatter.prototype.endVoiceOrLangTag = function(tag, newLine, previousTag) {
        if (newLine === void 0) newLine = false;
        var suffix = "";
        switch(tag){
            case "voice":
                // If a global 'voice' tag is opened at the root of the SSML file, we have to re-open it every time another 'voice' tag ends
                if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice) {
                    suffix = '<voice name="' + this.options.globalVoiceAndLang.voice + '">';
                    // If a global 'lang' tag is opened at the root of the SSML file, we have to re-open it every time a 'voice' tag ends
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang) suffix += '<lang xml:lang="' + this.options.globalVoiceAndLang.lang + '">';
                }
                break;
            case "lang":
                // If the previous tag was a 'voice' one, we use the basic behaviour
                if (!(previousTag && previousTag === "voice")) {
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && tag === "lang") suffix = '<lang xml:lang="' + this.options.globalVoiceAndLang.lang + '">';
                }
                break;
            default:
                break;
        }
        return (newLine ? "\n" : "") + "</" + tag + ">" + suffix;
    };
    return MicrosoftAzureSsmlFormatter;
}($fEgP3.SsmlFormatterBase);
module.exports.MicrosoftAzureSsmlFormatter = $d0a0a18ab9e0b046$var$MicrosoftAzureSsmlFormatter;

});


parcelRegister("bkcrI", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $83eb377eec737973$export$2b8d127b894957b9, (v) => $83eb377eec737973$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $83eb377eec737973$export$cea3a54a6425200c, (v) => $83eb377eec737973$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $83eb377eec737973$export$a7c73072b1a182ae, (v) => $83eb377eec737973$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $83eb377eec737973$export$9f27bc3417b4524d, (v) => $83eb377eec737973$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $83eb377eec737973$export$db77ccec0bb4ccac, (v) => $83eb377eec737973$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $83eb377eec737973$export$8392c0c9d3dcbd35, (v) => $83eb377eec737973$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $83eb377eec737973$export$ffb0004e005737fa, (v) => $83eb377eec737973$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $83eb377eec737973$export$b624eff549462981, (v) => $83eb377eec737973$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $83eb377eec737973$export$7897aa7841a5380c, (v) => $83eb377eec737973$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $83eb377eec737973$export$602eac185826482c, (v) => $83eb377eec737973$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $83eb377eec737973$export$e2c29f18771995cb, (v) => $83eb377eec737973$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $83eb377eec737973$export$5f8d39834fd61797, (v) => $83eb377eec737973$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $83eb377eec737973$export$74bf444e3cd11ea5, (v) => $83eb377eec737973$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $83eb377eec737973$export$92387174baf9b227, (v) => $83eb377eec737973$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $83eb377eec737973$export$ec112efeb987d9c6, (v) => $83eb377eec737973$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $83eb377eec737973$export$b706b080d889d2c9, (v) => $83eb377eec737973$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $83eb377eec737973$export$5be5a87408f70ddc, (v) => $83eb377eec737973$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $83eb377eec737973$export$45a5e7f76e0caa8d, (v) => $83eb377eec737973$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $83eb377eec737973$export$455c2e768291efa6, (v) => $83eb377eec737973$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $83eb377eec737973$export$9522e17588c12572, (v) => $83eb377eec737973$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $83eb377eec737973$export$2110ac352bb060b9, (v) => $83eb377eec737973$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $83eb377eec737973$export$56885ab8b9c456ab, (v) => $83eb377eec737973$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $83eb377eec737973$export$d927fcb6adf8f9de, (v) => $83eb377eec737973$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $83eb377eec737973$export$b82d16f27459e05a, (v) => $83eb377eec737973$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $83eb377eec737973$export$522c17b4f5e123e8, (v) => $83eb377eec737973$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $83eb377eec737973$export$1aabd8a0274ecfd6, (v) => $83eb377eec737973$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $83eb377eec737973$export$9b621391a187a31a, (v) => $83eb377eec737973$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $83eb377eec737973$export$f5bbd400c2f4426f, (v) => $83eb377eec737973$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $83eb377eec737973$export$2b8d127b894957b9;
var $83eb377eec737973$export$cea3a54a6425200c;
var $83eb377eec737973$export$a7c73072b1a182ae;
var $83eb377eec737973$export$9f27bc3417b4524d;
var $83eb377eec737973$export$db77ccec0bb4ccac;
var $83eb377eec737973$export$8392c0c9d3dcbd35;
var $83eb377eec737973$export$ffb0004e005737fa;
var $83eb377eec737973$export$b624eff549462981;
var $83eb377eec737973$export$7897aa7841a5380c;
var $83eb377eec737973$export$602eac185826482c;
var $83eb377eec737973$export$e2c29f18771995cb;
var $83eb377eec737973$export$5f8d39834fd61797;
var $83eb377eec737973$export$74bf444e3cd11ea5;
var $83eb377eec737973$export$92387174baf9b227;
var $83eb377eec737973$export$ec112efeb987d9c6;
var $83eb377eec737973$export$b706b080d889d2c9;
var $83eb377eec737973$export$5be5a87408f70ddc;
var $83eb377eec737973$export$45a5e7f76e0caa8d;
var $83eb377eec737973$export$455c2e768291efa6;
var $83eb377eec737973$export$9522e17588c12572;
var $83eb377eec737973$export$2110ac352bb060b9;
var $83eb377eec737973$export$56885ab8b9c456ab;
var $83eb377eec737973$export$d927fcb6adf8f9de;
var $83eb377eec737973$export$b82d16f27459e05a;
var $83eb377eec737973$export$522c17b4f5e123e8;
var $83eb377eec737973$export$1aabd8a0274ecfd6;
var $83eb377eec737973$export$9b621391a187a31a;
var $83eb377eec737973$export$f5bbd400c2f4426f;
"use strict";
var $83eb377eec737973$var$b = "function" === typeof Symbol && Symbol.for, $83eb377eec737973$var$c = $83eb377eec737973$var$b ? Symbol.for("react.element") : 60103, $83eb377eec737973$var$d = $83eb377eec737973$var$b ? Symbol.for("react.portal") : 60106, $83eb377eec737973$var$e = $83eb377eec737973$var$b ? Symbol.for("react.fragment") : 60107, $83eb377eec737973$var$f = $83eb377eec737973$var$b ? Symbol.for("react.strict_mode") : 60108, $83eb377eec737973$var$g = $83eb377eec737973$var$b ? Symbol.for("react.profiler") : 60114, $83eb377eec737973$var$h = $83eb377eec737973$var$b ? Symbol.for("react.provider") : 60109, $83eb377eec737973$var$k = $83eb377eec737973$var$b ? Symbol.for("react.context") : 60110, $83eb377eec737973$var$l = $83eb377eec737973$var$b ? Symbol.for("react.async_mode") : 60111, $83eb377eec737973$var$m = $83eb377eec737973$var$b ? Symbol.for("react.concurrent_mode") : 60111, $83eb377eec737973$var$n = $83eb377eec737973$var$b ? Symbol.for("react.forward_ref") : 60112, $83eb377eec737973$var$p = $83eb377eec737973$var$b ? Symbol.for("react.suspense") : 60113, $83eb377eec737973$var$q = $83eb377eec737973$var$b ? Symbol.for("react.suspense_list") : 60120, $83eb377eec737973$var$r = $83eb377eec737973$var$b ? Symbol.for("react.memo") : 60115, $83eb377eec737973$var$t = $83eb377eec737973$var$b ? Symbol.for("react.lazy") : 60116, $83eb377eec737973$var$v = $83eb377eec737973$var$b ? Symbol.for("react.block") : 60121, $83eb377eec737973$var$w = $83eb377eec737973$var$b ? Symbol.for("react.fundamental") : 60117, $83eb377eec737973$var$x = $83eb377eec737973$var$b ? Symbol.for("react.responder") : 60118, $83eb377eec737973$var$y = $83eb377eec737973$var$b ? Symbol.for("react.scope") : 60119;
function $83eb377eec737973$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $83eb377eec737973$var$c:
                switch(a = a.type, a){
                    case $83eb377eec737973$var$l:
                    case $83eb377eec737973$var$m:
                    case $83eb377eec737973$var$e:
                    case $83eb377eec737973$var$g:
                    case $83eb377eec737973$var$f:
                    case $83eb377eec737973$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $83eb377eec737973$var$k:
                            case $83eb377eec737973$var$n:
                            case $83eb377eec737973$var$t:
                            case $83eb377eec737973$var$r:
                            case $83eb377eec737973$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $83eb377eec737973$var$d:
                return u;
        }
    }
}
function $83eb377eec737973$var$A(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$m;
}
$83eb377eec737973$export$2b8d127b894957b9 = $83eb377eec737973$var$l;
$83eb377eec737973$export$cea3a54a6425200c = $83eb377eec737973$var$m;
$83eb377eec737973$export$a7c73072b1a182ae = $83eb377eec737973$var$k;
$83eb377eec737973$export$9f27bc3417b4524d = $83eb377eec737973$var$h;
$83eb377eec737973$export$db77ccec0bb4ccac = $83eb377eec737973$var$c;
$83eb377eec737973$export$8392c0c9d3dcbd35 = $83eb377eec737973$var$n;
$83eb377eec737973$export$ffb0004e005737fa = $83eb377eec737973$var$e;
$83eb377eec737973$export$b624eff549462981 = $83eb377eec737973$var$t;
$83eb377eec737973$export$7897aa7841a5380c = $83eb377eec737973$var$r;
$83eb377eec737973$export$602eac185826482c = $83eb377eec737973$var$d;
$83eb377eec737973$export$e2c29f18771995cb = $83eb377eec737973$var$g;
$83eb377eec737973$export$5f8d39834fd61797 = $83eb377eec737973$var$f;
$83eb377eec737973$export$74bf444e3cd11ea5 = $83eb377eec737973$var$p;
$83eb377eec737973$export$92387174baf9b227 = function(a) {
    return $83eb377eec737973$var$A(a) || $83eb377eec737973$var$z(a) === $83eb377eec737973$var$l;
};
$83eb377eec737973$export$ec112efeb987d9c6 = $83eb377eec737973$var$A;
$83eb377eec737973$export$b706b080d889d2c9 = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$k;
};
$83eb377eec737973$export$5be5a87408f70ddc = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$h;
};
$83eb377eec737973$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $83eb377eec737973$var$c;
};
$83eb377eec737973$export$455c2e768291efa6 = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$n;
};
$83eb377eec737973$export$9522e17588c12572 = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$e;
};
$83eb377eec737973$export$2110ac352bb060b9 = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$t;
};
$83eb377eec737973$export$56885ab8b9c456ab = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$r;
};
$83eb377eec737973$export$d927fcb6adf8f9de = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$d;
};
$83eb377eec737973$export$b82d16f27459e05a = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$g;
};
$83eb377eec737973$export$522c17b4f5e123e8 = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$f;
};
$83eb377eec737973$export$1aabd8a0274ecfd6 = function(a) {
    return $83eb377eec737973$var$z(a) === $83eb377eec737973$var$p;
};
$83eb377eec737973$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $83eb377eec737973$var$e || a === $83eb377eec737973$var$m || a === $83eb377eec737973$var$g || a === $83eb377eec737973$var$f || a === $83eb377eec737973$var$p || a === $83eb377eec737973$var$q || "object" === typeof a && null !== a && (a.$$typeof === $83eb377eec737973$var$t || a.$$typeof === $83eb377eec737973$var$r || a.$$typeof === $83eb377eec737973$var$h || a.$$typeof === $83eb377eec737973$var$k || a.$$typeof === $83eb377eec737973$var$n || a.$$typeof === $83eb377eec737973$var$w || a.$$typeof === $83eb377eec737973$var$x || a.$$typeof === $83eb377eec737973$var$y || a.$$typeof === $83eb377eec737973$var$v);
};
$83eb377eec737973$export$f5bbd400c2f4426f = $83eb377eec737973$var$z;

});

parcelRegister("3EbSx", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $2a7e525c9456ffee$export$a7c73072b1a182ae, (v) => $2a7e525c9456ffee$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $2a7e525c9456ffee$export$9f27bc3417b4524d, (v) => $2a7e525c9456ffee$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $2a7e525c9456ffee$export$db77ccec0bb4ccac, (v) => $2a7e525c9456ffee$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $2a7e525c9456ffee$export$8392c0c9d3dcbd35, (v) => $2a7e525c9456ffee$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $2a7e525c9456ffee$export$ffb0004e005737fa, (v) => $2a7e525c9456ffee$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $2a7e525c9456ffee$export$b624eff549462981, (v) => $2a7e525c9456ffee$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $2a7e525c9456ffee$export$7897aa7841a5380c, (v) => $2a7e525c9456ffee$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $2a7e525c9456ffee$export$602eac185826482c, (v) => $2a7e525c9456ffee$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $2a7e525c9456ffee$export$e2c29f18771995cb, (v) => $2a7e525c9456ffee$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $2a7e525c9456ffee$export$5f8d39834fd61797, (v) => $2a7e525c9456ffee$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2a7e525c9456ffee$export$74bf444e3cd11ea5, (v) => $2a7e525c9456ffee$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $2a7e525c9456ffee$export$998bcd577473dd93, (v) => $2a7e525c9456ffee$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $2a7e525c9456ffee$export$92387174baf9b227, (v) => $2a7e525c9456ffee$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $2a7e525c9456ffee$export$ec112efeb987d9c6, (v) => $2a7e525c9456ffee$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $2a7e525c9456ffee$export$b706b080d889d2c9, (v) => $2a7e525c9456ffee$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $2a7e525c9456ffee$export$5be5a87408f70ddc, (v) => $2a7e525c9456ffee$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $2a7e525c9456ffee$export$45a5e7f76e0caa8d, (v) => $2a7e525c9456ffee$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $2a7e525c9456ffee$export$455c2e768291efa6, (v) => $2a7e525c9456ffee$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $2a7e525c9456ffee$export$9522e17588c12572, (v) => $2a7e525c9456ffee$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $2a7e525c9456ffee$export$2110ac352bb060b9, (v) => $2a7e525c9456ffee$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $2a7e525c9456ffee$export$56885ab8b9c456ab, (v) => $2a7e525c9456ffee$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $2a7e525c9456ffee$export$d927fcb6adf8f9de, (v) => $2a7e525c9456ffee$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $2a7e525c9456ffee$export$b82d16f27459e05a, (v) => $2a7e525c9456ffee$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $2a7e525c9456ffee$export$522c17b4f5e123e8, (v) => $2a7e525c9456ffee$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $2a7e525c9456ffee$export$1aabd8a0274ecfd6, (v) => $2a7e525c9456ffee$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $2a7e525c9456ffee$export$3d6c20d97e46b957, (v) => $2a7e525c9456ffee$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $2a7e525c9456ffee$export$9b621391a187a31a, (v) => $2a7e525c9456ffee$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $2a7e525c9456ffee$export$f5bbd400c2f4426f, (v) => $2a7e525c9456ffee$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2a7e525c9456ffee$export$a7c73072b1a182ae;
var $2a7e525c9456ffee$export$9f27bc3417b4524d;
var $2a7e525c9456ffee$export$db77ccec0bb4ccac;
var $2a7e525c9456ffee$export$8392c0c9d3dcbd35;
var $2a7e525c9456ffee$export$ffb0004e005737fa;
var $2a7e525c9456ffee$export$b624eff549462981;
var $2a7e525c9456ffee$export$7897aa7841a5380c;
var $2a7e525c9456ffee$export$602eac185826482c;
var $2a7e525c9456ffee$export$e2c29f18771995cb;
var $2a7e525c9456ffee$export$5f8d39834fd61797;
var $2a7e525c9456ffee$export$74bf444e3cd11ea5;
var $2a7e525c9456ffee$export$998bcd577473dd93;
var $2a7e525c9456ffee$export$92387174baf9b227;
var $2a7e525c9456ffee$export$ec112efeb987d9c6;
var $2a7e525c9456ffee$export$b706b080d889d2c9;
var $2a7e525c9456ffee$export$5be5a87408f70ddc;
var $2a7e525c9456ffee$export$45a5e7f76e0caa8d;
var $2a7e525c9456ffee$export$455c2e768291efa6;
var $2a7e525c9456ffee$export$9522e17588c12572;
var $2a7e525c9456ffee$export$2110ac352bb060b9;
var $2a7e525c9456ffee$export$56885ab8b9c456ab;
var $2a7e525c9456ffee$export$d927fcb6adf8f9de;
var $2a7e525c9456ffee$export$b82d16f27459e05a;
var $2a7e525c9456ffee$export$522c17b4f5e123e8;
var $2a7e525c9456ffee$export$1aabd8a0274ecfd6;
var $2a7e525c9456ffee$export$3d6c20d97e46b957;
var $2a7e525c9456ffee$export$9b621391a187a31a;
var $2a7e525c9456ffee$export$f5bbd400c2f4426f;
"use strict";
var $2a7e525c9456ffee$var$b = Symbol.for("react.element"), $2a7e525c9456ffee$var$c = Symbol.for("react.portal"), $2a7e525c9456ffee$var$d = Symbol.for("react.fragment"), $2a7e525c9456ffee$var$e = Symbol.for("react.strict_mode"), $2a7e525c9456ffee$var$f = Symbol.for("react.profiler"), $2a7e525c9456ffee$var$g = Symbol.for("react.provider"), $2a7e525c9456ffee$var$h = Symbol.for("react.context"), $2a7e525c9456ffee$var$k = Symbol.for("react.server_context"), $2a7e525c9456ffee$var$l = Symbol.for("react.forward_ref"), $2a7e525c9456ffee$var$m = Symbol.for("react.suspense"), $2a7e525c9456ffee$var$n = Symbol.for("react.suspense_list"), $2a7e525c9456ffee$var$p = Symbol.for("react.memo"), $2a7e525c9456ffee$var$q = Symbol.for("react.lazy"), $2a7e525c9456ffee$var$t = Symbol.for("react.offscreen"), $2a7e525c9456ffee$var$u;
$2a7e525c9456ffee$var$u = Symbol.for("react.module.reference");
function $2a7e525c9456ffee$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $2a7e525c9456ffee$var$b:
                switch(a = a.type, a){
                    case $2a7e525c9456ffee$var$d:
                    case $2a7e525c9456ffee$var$f:
                    case $2a7e525c9456ffee$var$e:
                    case $2a7e525c9456ffee$var$m:
                    case $2a7e525c9456ffee$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2a7e525c9456ffee$var$k:
                            case $2a7e525c9456ffee$var$h:
                            case $2a7e525c9456ffee$var$l:
                            case $2a7e525c9456ffee$var$q:
                            case $2a7e525c9456ffee$var$p:
                            case $2a7e525c9456ffee$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $2a7e525c9456ffee$var$c:
                return r;
        }
    }
}
$2a7e525c9456ffee$export$a7c73072b1a182ae = $2a7e525c9456ffee$var$h;
$2a7e525c9456ffee$export$9f27bc3417b4524d = $2a7e525c9456ffee$var$g;
$2a7e525c9456ffee$export$db77ccec0bb4ccac = $2a7e525c9456ffee$var$b;
$2a7e525c9456ffee$export$8392c0c9d3dcbd35 = $2a7e525c9456ffee$var$l;
$2a7e525c9456ffee$export$ffb0004e005737fa = $2a7e525c9456ffee$var$d;
$2a7e525c9456ffee$export$b624eff549462981 = $2a7e525c9456ffee$var$q;
$2a7e525c9456ffee$export$7897aa7841a5380c = $2a7e525c9456ffee$var$p;
$2a7e525c9456ffee$export$602eac185826482c = $2a7e525c9456ffee$var$c;
$2a7e525c9456ffee$export$e2c29f18771995cb = $2a7e525c9456ffee$var$f;
$2a7e525c9456ffee$export$5f8d39834fd61797 = $2a7e525c9456ffee$var$e;
$2a7e525c9456ffee$export$74bf444e3cd11ea5 = $2a7e525c9456ffee$var$m;
$2a7e525c9456ffee$export$998bcd577473dd93 = $2a7e525c9456ffee$var$n;
$2a7e525c9456ffee$export$92387174baf9b227 = function() {
    return !1;
};
$2a7e525c9456ffee$export$ec112efeb987d9c6 = function() {
    return !1;
};
$2a7e525c9456ffee$export$b706b080d889d2c9 = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$h;
};
$2a7e525c9456ffee$export$5be5a87408f70ddc = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$g;
};
$2a7e525c9456ffee$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2a7e525c9456ffee$var$b;
};
$2a7e525c9456ffee$export$455c2e768291efa6 = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$l;
};
$2a7e525c9456ffee$export$9522e17588c12572 = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$d;
};
$2a7e525c9456ffee$export$2110ac352bb060b9 = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$q;
};
$2a7e525c9456ffee$export$56885ab8b9c456ab = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$p;
};
$2a7e525c9456ffee$export$d927fcb6adf8f9de = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$c;
};
$2a7e525c9456ffee$export$b82d16f27459e05a = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$f;
};
$2a7e525c9456ffee$export$522c17b4f5e123e8 = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$e;
};
$2a7e525c9456ffee$export$1aabd8a0274ecfd6 = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$m;
};
$2a7e525c9456ffee$export$3d6c20d97e46b957 = function(a) {
    return $2a7e525c9456ffee$var$v(a) === $2a7e525c9456ffee$var$n;
};
$2a7e525c9456ffee$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2a7e525c9456ffee$var$d || a === $2a7e525c9456ffee$var$f || a === $2a7e525c9456ffee$var$e || a === $2a7e525c9456ffee$var$m || a === $2a7e525c9456ffee$var$n || a === $2a7e525c9456ffee$var$t || "object" === typeof a && null !== a && (a.$$typeof === $2a7e525c9456ffee$var$q || a.$$typeof === $2a7e525c9456ffee$var$p || a.$$typeof === $2a7e525c9456ffee$var$g || a.$$typeof === $2a7e525c9456ffee$var$h || a.$$typeof === $2a7e525c9456ffee$var$l || a.$$typeof === $2a7e525c9456ffee$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$2a7e525c9456ffee$export$f5bbd400c2f4426f = $2a7e525c9456ffee$var$v;

});

parcelRegister("69iRJ", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $47a237aa70583599$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $47a237aa70583599$export$2e2bcd8739ae039 = fn;

});

parcelRegister("fAU6C", function(module, exports) {

$parcel$export(module.exports, "Player", () => Player);

var $lT7pJ = parcelRequire("lT7pJ");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var extendStatics = function(t, e) {
    return (extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    })(t, e);
};
function __extends(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    extendStatics(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}
var __assign = function() {
    return (__assign = Object.assign || function(t) {
        for(var e, r = 1, i = arguments.length; r < i; r++)for(var a in e = arguments[r])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
        return t;
    }).apply(this, arguments);
};
function __rest(t, e) {
    var r = {};
    for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (r[i] = t[i]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(i = Object.getOwnPropertySymbols(t); a < i.length; a++)e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[a]) && (r[i[a]] = t[i[a]]);
    }
    return r;
}
function __decorate(t, e, r, i) {
    var a, s = arguments.length, n = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, r) : i;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n = Reflect.decorate(t, e, r, i);
    else for(var o = t.length - 1; o >= 0; o--)(a = t[o]) && (n = (s < 3 ? a(n) : s > 3 ? a(e, r, n) : a(e, r)) || n);
    return s > 3 && n && Object.defineProperty(e, r, n), n;
}
function __param(t, e) {
    return function(r, i) {
        e(r, i, t);
    };
}
function __metadata(t, e) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
}
function __awaiter(t, e, r, i) {
    return new (r || (r = Promise))(function(a, s) {
        function n(t) {
            try {
                h(i.next(t));
            } catch (t) {
                s(t);
            }
        }
        function o(t) {
            try {
                h(i.throw(t));
            } catch (t) {
                s(t);
            }
        }
        function h(t) {
            var e;
            t.done ? a(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(n, o);
        }
        h((i = i.apply(t, e || [])).next());
    });
}
function __generator(t, e) {
    var r, i, a, s, n = {
        label: 0,
        sent: function() {
            if (1 & a[0]) throw a[1];
            return a[1];
        },
        trys: [],
        ops: []
    };
    return s = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function() {
        return this;
    }), s;
    function o(s) {
        return function(o) {
            return function(s) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; n;)try {
                    if (r = 1, i && (a = 2 & s[0] ? i.return : s[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, s[1])).done) return a;
                    switch(i = 0, a && (s = [
                        2 & s[0],
                        a.value
                    ]), s[0]){
                        case 0:
                        case 1:
                            a = s;
                            break;
                        case 4:
                            return n.label++, {
                                value: s[1],
                                done: !1
                            };
                        case 5:
                            n.label++, i = s[1], s = [
                                0
                            ];
                            continue;
                        case 7:
                            s = n.ops.pop(), n.trys.pop();
                            continue;
                        default:
                            if (!(a = n.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                n = 0;
                                continue;
                            }
                            if (3 === s[0] && (!a || s[1] > a[0] && s[1] < a[3])) {
                                n.label = s[1];
                                break;
                            }
                            if (6 === s[0] && n.label < a[1]) {
                                n.label = a[1], a = s;
                                break;
                            }
                            if (a && n.label < a[2]) {
                                n.label = a[2], n.ops.push(s);
                                break;
                            }
                            a[2] && n.ops.pop(), n.trys.pop();
                            continue;
                    }
                    s = e.call(t, n);
                } catch (t) {
                    s = [
                        6,
                        t
                    ], i = 0;
                } finally{
                    r = a = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                };
            }([
                s,
                o
            ]);
        };
    }
}
var __createBinding = Object.create ? function(t, e, r, i) {
    void 0 === i && (i = r), Object.defineProperty(t, i, {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    });
} : function(t, e, r, i) {
    void 0 === i && (i = r), t[i] = e[r];
};
function __exportStar(t, e) {
    for(var r in t)"default" === r || Object.prototype.hasOwnProperty.call(e, r) || __createBinding(e, t, r);
}
function __values(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], i = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && i >= t.length && (t = void 0), {
                value: t && t[i++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var i, a, s = r.call(t), n = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(i = s.next()).done;)n.push(i.value);
    } catch (t) {
        a = {
            error: t
        };
    } finally{
        try {
            i && !i.done && (r = s.return) && r.call(s);
        } finally{
            if (a) throw a.error;
        }
    }
    return n;
}
function __spread() {
    for(var t = [], e = 0; e < arguments.length; e++)t = t.concat(__read(arguments[e]));
    return t;
}
function __spreadArrays() {
    for(var t = 0, e = 0, r = arguments.length; e < r; e++)t += arguments[e].length;
    var i = Array(t), a = 0;
    for(e = 0; e < r; e++)for(var s = arguments[e], n = 0, o = s.length; n < o; n++, a++)i[a] = s[n];
    return i;
}
function __spreadArray(t, e, r) {
    if (r || 2 === arguments.length) for(var i, a = 0, s = e.length; a < s; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
    return t.concat(i || Array.prototype.slice.call(e));
}
function __await(t) {
    return this instanceof __await ? (this.v = t, this) : new __await(t);
}
function __asyncGenerator(t, e, r) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var i, a = r.apply(t, e || []), s = [];
    return i = {}, n("next"), n("throw"), n("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function n(t) {
        a[t] && (i[t] = function(e) {
            return new Promise(function(r, i) {
                s.push([
                    t,
                    e,
                    r,
                    i
                ]) > 1 || o(t, e);
            });
        });
    }
    function o(t, e) {
        try {
            (r = a[t](e)).value instanceof __await ? Promise.resolve(r.value.v).then(h, l) : p(s[0][2], r);
        } catch (t) {
            p(s[0][3], t);
        }
        var r;
    }
    function h(t) {
        o("next", t);
    }
    function l(t) {
        o("throw", t);
    }
    function p(t, e) {
        t(e), s.shift(), s.length && o(s[0][0], s[0][1]);
    }
}
function __asyncDelegator(t) {
    var e, r;
    return e = {}, i("next"), i("throw", function(t) {
        throw t;
    }), i("return"), e[Symbol.iterator] = function() {
        return this;
    }, e;
    function i(i, a) {
        e[i] = t[i] ? function(e) {
            return (r = !r) ? {
                value: __await(t[i](e)),
                done: "return" === i
            } : a ? a(e) : e;
        } : a;
    }
}
function __asyncValues(t) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var e, r = t[Symbol.asyncIterator];
    return r ? r.call(t) : (t = "function" == typeof __values ? __values(t) : t[Symbol.iterator](), e = {}, i("next"), i("throw"), i("return"), e[Symbol.asyncIterator] = function() {
        return this;
    }, e);
    function i(r) {
        e[r] = t[r] && function(e) {
            return new Promise(function(i, a) {
                (function(t, e, r, i) {
                    Promise.resolve(i).then(function(e) {
                        t({
                            value: e,
                            done: r
                        });
                    }, e);
                })(i, a, (e = t[r](e)).done, e.value);
            });
        };
    }
}
function __makeTemplateObject(t, e) {
    return Object.defineProperty ? Object.defineProperty(t, "raw", {
        value: e
    }) : t.raw = e, t;
}
var __setModuleDefault = Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
};
function __importStar(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for(var r in t)"default" !== r && Object.prototype.hasOwnProperty.call(t, r) && __createBinding(e, t, r);
    return __setModuleDefault(e, t), e;
}
function __importDefault(t) {
    return t && t.__esModule ? t : {
        default: t
    };
}
function __classPrivateFieldGet(t, e, r, i) {
    if ("a" === r && !i) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? i : "a" === r ? i.call(t) : i ? i.value : e.get(t);
}
function __classPrivateFieldSet(t, e, r, i, a) {
    if ("m" === i) throw new TypeError("Private method is not writable");
    if ("a" === i && !a) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof e ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === i ? a.call(t, r) : a ? a.value = r : e.set(t, r), r;
}
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function unwrapExports(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function createCommonjsModule(t, e) {
    return t(e = {
        exports: {}
    }, e.exports), e.exports;
}
function getCjsExportFromNamespace(t) {
    return t && t.default || t;
}
function commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var lottie = createCommonjsModule(function(module, exports) {
    "undefined" != typeof navigator && function(t, e) {
        module.exports = e();
    }(0, function() {
        var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
            _useWebWorker = !!t;
        }, getWebWorker = function() {
            return _useWebWorker;
        }, setLocationHref = function(t) {
            locationHref = t;
        }, getLocationHref = function() {
            return locationHref;
        };
        function createTag(t) {
            return document.createElement(t);
        }
        function extendPrototype(t, e) {
            var r, i, a = t.length;
            for(r = 0; r < a; r += 1)for(var s in i = t[r].prototype)Object.prototype.hasOwnProperty.call(i, s) && (e.prototype[s] = i[s]);
        }
        function getDescriptor(t, e) {
            return Object.getOwnPropertyDescriptor(t, e);
        }
        function createProxyFunction(t) {
            function e() {}
            return e.prototype = t, e;
        }
        var audioControllerFactory = function() {
            function t(t) {
                this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
            }
            return t.prototype = {
                addAudio: function(t) {
                    this.audios.push(t);
                },
                pause: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].pause();
                },
                resume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].resume();
                },
                setRate: function(t) {
                    var e, r = this.audios.length;
                    for(e = 0; e < r; e += 1)this.audios[e].setRate(t);
                },
                createAudio: function(t) {
                    return this.audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
                        src: [
                            t
                        ]
                    }) : {
                        isPlaying: !1,
                        play: function() {
                            this.isPlaying = !0;
                        },
                        seek: function() {
                            this.isPlaying = !1;
                        },
                        playing: function() {},
                        rate: function() {},
                        setVolume: function() {}
                    };
                },
                setAudioFactory: function(t) {
                    this.audioFactory = t;
                },
                setVolume: function(t) {
                    this._volume = t, this._updateVolume();
                },
                mute: function() {
                    this._isMuted = !0, this._updateVolume();
                },
                unmute: function() {
                    this._isMuted = !1, this._updateVolume();
                },
                getVolume: function() {
                    return this._volume;
                },
                _updateVolume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
                }
            }, function() {
                return new t;
            };
        }(), createTypedArray = function() {
            function t(t, e) {
                var r, i = 0, a = [];
                switch(t){
                    case "int16":
                    case "uint8c":
                        r = 1;
                        break;
                    default:
                        r = 1.1;
                }
                for(i = 0; i < e; i += 1)a.push(r);
                return a;
            }
            return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(e, r) {
                return "float32" === e ? new Float32Array(r) : "int16" === e ? new Int16Array(r) : "uint8c" === e ? new Uint8ClampedArray(r) : t(e, r);
            } : t;
        }();
        function createSizedArray(t) {
            return Array.apply(null, {
                length: t
            });
        }
        function _typeof$6(t) {
            return (_typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), _shouldRoundValues = !1, bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
        function ProjectInterface$1() {
            return {};
        }
        !function() {
            var t, e = [
                "abs",
                "acos",
                "acosh",
                "asin",
                "asinh",
                "atan",
                "atanh",
                "atan2",
                "ceil",
                "cbrt",
                "expm1",
                "clz32",
                "cos",
                "cosh",
                "exp",
                "floor",
                "fround",
                "hypot",
                "imul",
                "log",
                "log1p",
                "log2",
                "log10",
                "max",
                "min",
                "pow",
                "random",
                "round",
                "sign",
                "sin",
                "sinh",
                "sqrt",
                "tan",
                "tanh",
                "trunc",
                "E",
                "LN10",
                "LN2",
                "LOG10E",
                "LOG2E",
                "PI",
                "SQRT1_2",
                "SQRT2"
            ], r = e.length;
            for(t = 0; t < r; t += 1)BMMath[e[t]] = Math[e[t]];
        }(), BMMath.random = Math.random, BMMath.abs = function(t) {
            if ("object" === _typeof$6(t) && t.length) {
                var e, r = createSizedArray(t.length), i = t.length;
                for(e = 0; e < i; e += 1)r[e] = Math.abs(t[e]);
                return r;
            }
            return Math.abs(t);
        };
        var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
        function roundValues(t) {
            _shouldRoundValues = !!t;
        }
        function bmRnd(t) {
            return _shouldRoundValues ? Math.round(t) : t;
        }
        function styleDiv(t) {
            t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = "0 0", t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = "visible", t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = "preserve-3d", t.style.webkitTransformStyle = "preserve-3d", t.style.mozTransformStyle = "preserve-3d";
        }
        function BMEnterFrameEvent(t, e, r, i) {
            this.type = t, this.currentTime = e, this.totalTime = r, this.direction = i < 0 ? -1 : 1;
        }
        function BMCompleteEvent(t, e) {
            this.type = t, this.direction = e < 0 ? -1 : 1;
        }
        function BMCompleteLoopEvent(t, e, r, i) {
            this.type = t, this.currentLoop = r, this.totalLoops = e, this.direction = i < 0 ? -1 : 1;
        }
        function BMSegmentStartEvent(t, e, r) {
            this.type = t, this.firstFrame = e, this.totalFrames = r;
        }
        function BMDestroyEvent(t, e) {
            this.type = t, this.target = e;
        }
        function BMRenderFrameErrorEvent(t, e) {
            this.type = "renderFrameError", this.nativeError = t, this.currentTime = e;
        }
        function BMConfigErrorEvent(t) {
            this.type = "configError", this.nativeError = t;
        }
        function BMAnimationConfigErrorEvent(t, e) {
            this.type = t, this.nativeError = e;
        }
        var createElementID = (_count = 0, function() {
            return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }), _count;
        function HSVtoRGB(t, e, r) {
            var i, a, s, n, o, h, l, p;
            switch(h = r * (1 - e), l = r * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e), p = r * (1 - (1 - o) * e), n % 6){
                case 0:
                    i = r, a = p, s = h;
                    break;
                case 1:
                    i = l, a = r, s = h;
                    break;
                case 2:
                    i = h, a = r, s = p;
                    break;
                case 3:
                    i = h, a = l, s = r;
                    break;
                case 4:
                    i = p, a = h, s = r;
                    break;
                case 5:
                    i = r, a = h, s = l;
            }
            return [
                i,
                a,
                s
            ];
        }
        function RGBtoHSV(t, e, r) {
            var i, a = Math.max(t, e, r), s = Math.min(t, e, r), n = a - s, o = 0 === a ? 0 : n / a, h = a / 255;
            switch(a){
                case s:
                    i = 0;
                    break;
                case t:
                    i = e - r + n * (e < r ? 6 : 0), i /= 6 * n;
                    break;
                case e:
                    i = r - t + 2 * n, i /= 6 * n;
                    break;
                case r:
                    i = t - e + 4 * n, i /= 6 * n;
            }
            return [
                i,
                o,
                h
            ];
        }
        function addSaturationToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[1] += e, r[1] > 1 ? r[1] = 1 : r[1] <= 0 && (r[1] = 0), HSVtoRGB(r[0], r[1], r[2]);
        }
        function addBrightnessToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[2] += e, r[2] > 1 ? r[2] = 1 : r[2] < 0 && (r[2] = 0), HSVtoRGB(r[0], r[1], r[2]);
        }
        function addHueToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[0] += e / 360, r[0] > 1 ? r[0] -= 1 : r[0] < 0 && (r[0] += 1), HSVtoRGB(r[0], r[1], r[2]);
        }
        var rgbToHex = function() {
            var t, e, r = [];
            for(t = 0; t < 256; t += 1)e = t.toString(16), r[t] = 1 === e.length ? "0" + e : e;
            return function(t, e, i) {
                return t < 0 && (t = 0), e < 0 && (e = 0), i < 0 && (i = 0), "#" + r[t] + r[e] + r[i];
            };
        }(), setSubframeEnabled = function(t) {
            subframeEnabled = !!t;
        }, getSubframeEnabled = function() {
            return subframeEnabled;
        }, setExpressionsPlugin = function(t) {
            expressionsPlugin = t;
        }, getExpressionsPlugin = function() {
            return expressionsPlugin;
        }, setExpressionInterfaces = function(t) {
            expressionsInterfaces = t;
        }, getExpressionInterfaces = function() {
            return expressionsInterfaces;
        }, setDefaultCurveSegments = function(t) {
            defaultCurveSegments = t;
        }, getDefaultCurveSegments = function() {
            return defaultCurveSegments;
        }, setIdPrefix = function(t) {
            idPrefix$1 = t;
        }, getIdPrefix = function() {
            return idPrefix$1;
        };
        function createNS(t) {
            return document.createElementNS(svgNS, t);
        }
        function _typeof$5(t) {
            return (_typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var dataManager = function() {
            var t, e, r = 1, i = [], a = {
                onmessage: function() {},
                postMessage: function(e) {
                    t({
                        data: e
                    });
                }
            }, s = {
                postMessage: function(t) {
                    a.onmessage({
                        data: t
                    });
                }
            };
            function n() {
                e || ((e = function(e) {
                    if (window.Worker && window.Blob && getWebWorker()) {
                        var r = new Blob([
                            "var _workerSelf = self; self.onmessage = ",
                            e.toString()
                        ], {
                            type: "text/javascript"
                        }), i = URL.createObjectURL(r);
                        return new Worker(i);
                    }
                    return t = e, a;
                }(function(t) {
                    if (s.dataManager || (s.dataManager = function() {
                        function t(a, s) {
                            var n, o, h, l, p, c, m = a.length;
                            for(o = 0; o < m; o += 1)if ("ks" in (n = a[o]) && !n.completed) {
                                if (n.completed = !0, n.hasMask) {
                                    var d = n.masksProperties;
                                    for(l = d.length, h = 0; h < l; h += 1)if (d[h].pt.k.i) i(d[h].pt.k);
                                    else for(c = d[h].pt.k.length, p = 0; p < c; p += 1)d[h].pt.k[p].s && i(d[h].pt.k[p].s[0]), d[h].pt.k[p].e && i(d[h].pt.k[p].e[0]);
                                }
                                0 === n.ty ? (n.layers = e(n.refId, s), t(n.layers, s)) : 4 === n.ty ? r(n.shapes) : 5 === n.ty && f(n);
                            }
                        }
                        function e(t, e) {
                            var r = function(t, e) {
                                for(var r = 0, i = e.length; r < i;){
                                    if (e[r].id === t) return e[r];
                                    r += 1;
                                }
                                return null;
                            }(t, e);
                            return r ? r.layers.__used ? JSON.parse(JSON.stringify(r.layers)) : (r.layers.__used = !0, r.layers) : null;
                        }
                        function r(t) {
                            var e, a, s;
                            for(e = t.length - 1; e >= 0; e -= 1)if ("sh" === t[e].ty) {
                                if (t[e].ks.k.i) i(t[e].ks.k);
                                else for(s = t[e].ks.k.length, a = 0; a < s; a += 1)t[e].ks.k[a].s && i(t[e].ks.k[a].s[0]), t[e].ks.k[a].e && i(t[e].ks.k[a].e[0]);
                            } else "gr" === t[e].ty && r(t[e].it);
                        }
                        function i(t) {
                            var e, r = t.i.length;
                            for(e = 0; e < r; e += 1)t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
                        }
                        function a(t, e) {
                            var r = e ? e.split(".") : [
                                100,
                                100,
                                100
                            ];
                            return t[0] > r[0] || !(r[0] > t[0]) && (t[1] > r[1] || !(r[1] > t[1]) && (t[2] > r[2] || !(r[2] > t[2]) && null));
                        }
                        var s, n = function() {
                            var t = [
                                4,
                                4,
                                14
                            ];
                            function e(t) {
                                var e, r, i, a = t.length;
                                for(e = 0; e < a; e += 1)5 === t[e].ty && (r = t[e], i = void 0, i = r.t.d, r.t.d = {
                                    k: [
                                        {
                                            s: i,
                                            t: 0
                                        }
                                    ]
                                });
                            }
                            return function(r) {
                                if (a(t, r.v) && (e(r.layers), r.assets)) {
                                    var i, s = r.assets.length;
                                    for(i = 0; i < s; i += 1)r.assets[i].layers && e(r.assets[i].layers);
                                }
                            };
                        }(), o = (s = [
                            4,
                            7,
                            99
                        ], function(t) {
                            if (t.chars && !a(s, t.v)) {
                                var e, i = t.chars.length;
                                for(e = 0; e < i; e += 1){
                                    var n = t.chars[e];
                                    n.data && n.data.shapes && (r(n.data.shapes), n.data.ip = 0, n.data.op = 99999, n.data.st = 0, n.data.sr = 1, n.data.ks = {
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        }
                                    }, t.chars[e].t || (n.data.shapes.push({
                                        ty: "no"
                                    }), n.data.shapes[0].it.push({
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        },
                                        sk: {
                                            k: 0,
                                            a: 0
                                        },
                                        sa: {
                                            k: 0,
                                            a: 0
                                        },
                                        ty: "tr"
                                    })));
                                }
                            }
                        }), h = function() {
                            var t = [
                                5,
                                7,
                                15
                            ];
                            function e(t) {
                                var e, r, i, a = t.length;
                                for(e = 0; e < a; e += 1)5 === t[e].ty && (r = t[e], i = void 0, "number" == typeof (i = r.t.p).a && (i.a = {
                                    a: 0,
                                    k: i.a
                                }), "number" == typeof i.p && (i.p = {
                                    a: 0,
                                    k: i.p
                                }), "number" == typeof i.r && (i.r = {
                                    a: 0,
                                    k: i.r
                                }));
                            }
                            return function(r) {
                                if (a(t, r.v) && (e(r.layers), r.assets)) {
                                    var i, s = r.assets.length;
                                    for(i = 0; i < s; i += 1)r.assets[i].layers && e(r.assets[i].layers);
                                }
                            };
                        }(), l = function() {
                            var t = [
                                4,
                                1,
                                9
                            ];
                            function e(t) {
                                var r, i, a, s = t.length;
                                for(r = 0; r < s; r += 1)if ("gr" === t[r].ty) e(t[r].it);
                                else if ("fl" === t[r].ty || "st" === t[r].ty) {
                                    if (t[r].c.k && t[r].c.k[0].i) for(a = t[r].c.k.length, i = 0; i < a; i += 1)t[r].c.k[i].s && (t[r].c.k[i].s[0] /= 255, t[r].c.k[i].s[1] /= 255, t[r].c.k[i].s[2] /= 255, t[r].c.k[i].s[3] /= 255), t[r].c.k[i].e && (t[r].c.k[i].e[0] /= 255, t[r].c.k[i].e[1] /= 255, t[r].c.k[i].e[2] /= 255, t[r].c.k[i].e[3] /= 255);
                                    else t[r].c.k[0] /= 255, t[r].c.k[1] /= 255, t[r].c.k[2] /= 255, t[r].c.k[3] /= 255;
                                }
                            }
                            function r(t) {
                                var r, i = t.length;
                                for(r = 0; r < i; r += 1)4 === t[r].ty && e(t[r].shapes);
                            }
                            return function(e) {
                                if (a(t, e.v) && (r(e.layers), e.assets)) {
                                    var i, s = e.assets.length;
                                    for(i = 0; i < s; i += 1)e.assets[i].layers && r(e.assets[i].layers);
                                }
                            };
                        }(), p = function() {
                            var t = [
                                4,
                                4,
                                18
                            ];
                            function e(t) {
                                var r, i, a;
                                for(r = t.length - 1; r >= 0; r -= 1)if ("sh" === t[r].ty) {
                                    if (t[r].ks.k.i) t[r].ks.k.c = t[r].closed;
                                    else for(a = t[r].ks.k.length, i = 0; i < a; i += 1)t[r].ks.k[i].s && (t[r].ks.k[i].s[0].c = t[r].closed), t[r].ks.k[i].e && (t[r].ks.k[i].e[0].c = t[r].closed);
                                } else "gr" === t[r].ty && e(t[r].it);
                            }
                            function r(t) {
                                var r, i, a, s, n, o, h = t.length;
                                for(i = 0; i < h; i += 1){
                                    if ((r = t[i]).hasMask) {
                                        var l = r.masksProperties;
                                        for(s = l.length, a = 0; a < s; a += 1)if (l[a].pt.k.i) l[a].pt.k.c = l[a].cl;
                                        else for(o = l[a].pt.k.length, n = 0; n < o; n += 1)l[a].pt.k[n].s && (l[a].pt.k[n].s[0].c = l[a].cl), l[a].pt.k[n].e && (l[a].pt.k[n].e[0].c = l[a].cl);
                                    }
                                    4 === r.ty && e(r.shapes);
                                }
                            }
                            return function(e) {
                                if (a(t, e.v) && (r(e.layers), e.assets)) {
                                    var i, s = e.assets.length;
                                    for(i = 0; i < s; i += 1)e.assets[i].layers && r(e.assets[i].layers);
                                }
                            };
                        }();
                        function f(t) {
                            0 === t.t.a.length && t.t.p;
                        }
                        var c = {
                            completeData: function(r) {
                                r.__complete || (l(r), n(r), o(r), h(r), p(r), t(r.layers, r.assets), function(r, i) {
                                    if (r) {
                                        var a = 0, s = r.length;
                                        for(a = 0; a < s; a += 1)1 === r[a].t && (r[a].data.layers = e(r[a].data.refId, i), t(r[a].data.layers, i));
                                    }
                                }(r.chars, r.assets), r.__complete = !0);
                            }
                        };
                        return c.checkColors = l, c.checkChars = o, c.checkPathProperties = h, c.checkShapes = p, c.completeLayers = t, c;
                    }()), s.assetLoader || (s.assetLoader = function() {
                        function t(t) {
                            var e = t.getResponseHeader("content-type");
                            return e && "json" === t.responseType && -1 !== e.indexOf("json") || t.response && "object" === _typeof$5(t.response) ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
                        }
                        return {
                            load: function(e, r, i, a) {
                                var s, n = new XMLHttpRequest;
                                try {
                                    n.responseType = "json";
                                } catch (t) {}
                                n.onreadystatechange = function() {
                                    if (4 === n.readyState) {
                                        if (200 === n.status) s = t(n), i(s);
                                        else try {
                                            s = t(n), i(s);
                                        } catch (t) {
                                            a && a(t);
                                        }
                                    }
                                };
                                try {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), e, !0);
                                } catch (t) {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), r + "/" + e, !0);
                                }
                                n.send();
                            }
                        };
                    }()), "loadAnimation" === t.data.type) s.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        s.dataManager.completeData(e), s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        s.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                    else if ("complete" === t.data.type) {
                        var e = t.data.animation;
                        s.dataManager.completeData(e), s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    } else "loadData" === t.data.type && s.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        s.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                })).onmessage = function(t) {
                    var e = t.data, r = e.id, a = i[r];
                    i[r] = null, "success" === e.status ? a.onComplete(e.payload) : a.onError && a.onError();
                });
            }
            function o(t, e) {
                var a = "processId_" + (r += 1);
                return i[a] = {
                    onComplete: t,
                    onError: e
                }, a;
            }
            return {
                loadAnimation: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "loadAnimation",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a
                    });
                },
                loadData: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "loadData",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a
                    });
                },
                completeAnimation: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "complete",
                        animation: t,
                        id: a
                    });
                }
            };
        }(), ImagePreloader = function() {
            var t = function() {
                var t = createTag("canvas");
                t.width = 1, t.height = 1;
                var e = t.getContext("2d");
                return e.fillStyle = "rgba(0,0,0,0)", e.fillRect(0, 0, 1, 1), t;
            }();
            function e() {
                this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function r() {
                this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function i(t, e, r) {
                var i = "";
                if (t.e) i = t.p;
                else if (e) {
                    var a = t.p;
                    -1 !== a.indexOf("images/") && (a = a.split("/")[1]), i = e + a;
                } else i = r, i += t.u ? t.u : "", i += t.p;
                return i;
            }
            function a(t) {
                var e = 0, r = setInterval((function() {
                    (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(r)), e += 1;
                }).bind(this), 50);
            }
            function s(t) {
                var e = {
                    assetData: t
                }, r = i(t, this.assetsPath, this.path);
                return dataManager.loadData(r, (function(t) {
                    e.img = t, this._footageLoaded();
                }).bind(this), (function() {
                    e.img = {}, this._footageLoaded();
                }).bind(this)), e;
            }
            function n() {
                this._imageLoaded = e.bind(this), this._footageLoaded = r.bind(this), this.testImageLoaded = a.bind(this), this.createFootageData = s.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
            }
            return n.prototype = {
                loadAssets: function(t, e) {
                    var r;
                    this.imagesLoadedCb = e;
                    var i = t.length;
                    for(r = 0; r < i; r += 1)t[r].layers || (t[r].t && "seq" !== t[r].t ? 3 === t[r].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t[r]))) : (this.totalImages += 1, this.images.push(this._createImageData(t[r]))));
                },
                setAssetsPath: function(t) {
                    this.assetsPath = t || "";
                },
                setPath: function(t) {
                    this.path = t || "";
                },
                loadedImages: function() {
                    return this.totalImages === this.loadedAssets;
                },
                loadedFootages: function() {
                    return this.totalFootages === this.loadedFootagesCount;
                },
                destroy: function() {
                    this.imagesLoadedCb = null, this.images.length = 0;
                },
                getAsset: function(t) {
                    for(var e = 0, r = this.images.length; e < r;){
                        if (this.images[e].assetData === t) return this.images[e].img;
                        e += 1;
                    }
                    return null;
                },
                createImgData: function(e) {
                    var r = i(e, this.assetsPath, this.path), a = createTag("img");
                    a.crossOrigin = "anonymous", a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", (function() {
                        s.img = t, this._imageLoaded();
                    }).bind(this), !1), a.src = r;
                    var s = {
                        img: a,
                        assetData: e
                    };
                    return s;
                },
                createImageData: function(e) {
                    var r = i(e, this.assetsPath, this.path), a = createNS("image");
                    isSafari ? this.testImageLoaded(a) : a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", (function() {
                        s.img = t, this._imageLoaded();
                    }).bind(this), !1), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), this._elementHelper.append ? this._elementHelper.append(a) : this._elementHelper.appendChild(a);
                    var s = {
                        img: a,
                        assetData: e
                    };
                    return s;
                },
                imageLoaded: e,
                footageLoaded: r,
                setCacheType: function(t, e) {
                    "svg" === t ? (this._elementHelper = e, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
                }
            }, n;
        }();
        function BaseEvent() {}
        BaseEvent.prototype = {
            triggerEvent: function(t, e) {
                if (this._cbs[t]) for(var r = this._cbs[t], i = 0; i < r.length; i += 1)r[i](e);
            },
            addEventListener: function(t, e) {
                return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e), (function() {
                    this.removeEventListener(t, e);
                }).bind(this);
            },
            removeEventListener: function(t, e) {
                if (e) {
                    if (this._cbs[t]) {
                        for(var r = 0, i = this._cbs[t].length; r < i;)this._cbs[t][r] === e && (this._cbs[t].splice(r, 1), r -= 1, i -= 1), r += 1;
                        this._cbs[t].length || (this._cbs[t] = null);
                    }
                } else this._cbs[t] = null;
            }
        };
        var markerParser = function() {
            function t(t) {
                for(var e, r = t.split("\r\n"), i = {}, a = 0, s = 0; s < r.length; s += 1)2 === (e = r[s].split(":")).length && (i[e[0]] = e[1].trim(), a += 1);
                if (0 === a) throw new Error;
                return i;
            }
            return function(e) {
                for(var r = [], i = 0; i < e.length; i += 1){
                    var a = e[i], s = {
                        time: a.tm,
                        duration: a.dr
                    };
                    try {
                        s.payload = JSON.parse(e[i].cm);
                    } catch (r) {
                        try {
                            s.payload = t(e[i].cm);
                        } catch (t) {
                            s.payload = {
                                name: e[i].cm
                            };
                        }
                    }
                    r.push(s);
                }
                return r;
            };
        }(), ProjectInterface = function() {
            function t(t) {
                this.compositions.push(t);
            }
            return function() {
                function e(t) {
                    for(var e = 0, r = this.compositions.length; e < r;){
                        if (this.compositions[e].data && this.compositions[e].data.nm === t) return this.compositions[e].prepareFrame && this.compositions[e].data.xt && this.compositions[e].prepareFrame(this.currentFrame), this.compositions[e].compInterface;
                        e += 1;
                    }
                    return null;
                }
                return e.compositions = [], e.currentFrame = 0, e.registerComposition = t, e;
            };
        }(), renderers = {}, registerRenderer = function(t, e) {
            renderers[t] = e;
        };
        function getRenderer(t) {
            return renderers[t];
        }
        function _typeof$4(t) {
            return (_typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var AnimationItem = function() {
            this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
        };
        extendPrototype([
            BaseEvent
        ], AnimationItem), AnimationItem.prototype.setParams = function(t) {
            (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
            var e = "svg";
            t.animType ? e = t.animType : t.renderer && (e = t.renderer);
            var r = getRenderer(e);
            this.renderer = new r(this, t.rendererSettings), this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? this.loop = !0 : !1 === t.loop ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
        }, AnimationItem.prototype.onSetupError = function() {
            this.trigger("data_failed");
        }, AnimationItem.prototype.setupAnimation = function(t) {
            dataManager.completeAnimation(t, this.configAnimation);
        }, AnimationItem.prototype.setData = function(t, e) {
            e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
            var r = {
                wrapper: t,
                animationData: e
            }, i = t.attributes;
            r.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", r.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : "canvas";
            var a = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
            "false" === a ? r.loop = !1 : "true" === a ? r.loop = !0 : "" !== a && (r.loop = parseInt(a, 10));
            var s = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : !i.getNamedItem("bm-autoplay") || i.getNamedItem("bm-autoplay").value;
            r.autoplay = "false" !== s, r.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "", "false" === (i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "") && (r.prerender = !1), this.setParams(r);
        }, AnimationItem.prototype.includeLayers = function(t) {
            t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
            var e, r, i = this.animationData.layers, a = i.length, s = t.layers, n = s.length;
            for(r = 0; r < n; r += 1)for(e = 0; e < a;){
                if (i[e].id === s[r].id) {
                    i[e] = s[r];
                    break;
                }
                e += 1;
            }
            if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for(a = t.assets.length, e = 0; e < a; e += 1)this.animationData.assets.push(t.assets[e]);
            this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
        }, AnimationItem.prototype.onSegmentComplete = function(t) {
            this.animationData = t;
            var e = getExpressionsPlugin();
            e && e.initExpressions(this), this.loadNextSegment();
        }, AnimationItem.prototype.loadNextSegment = function() {
            var t = this.animationData.segments;
            if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
            var e = t.shift();
            this.timeCompleted = e.time * this.frameRate;
            var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
            this.segmentPos += 1, dataManager.loadData(r, this.includeLayers.bind(this), (function() {
                this.trigger("data_failed");
            }).bind(this));
        }, AnimationItem.prototype.loadSegments = function() {
            this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
        }, AnimationItem.prototype.imagesLoaded = function() {
            this.trigger("loaded_images"), this.checkLoaded();
        }, AnimationItem.prototype.preloadImages = function() {
            this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
        }, AnimationItem.prototype.configAnimation = function(t) {
            if (this.renderer) try {
                this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = markerParser(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
            } catch (t) {
                this.triggerConfigError(t);
            }
        }, AnimationItem.prototype.waitForFontsLoaded = function() {
            this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
        }, AnimationItem.prototype.checkLoaded = function() {
            if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                this.isLoaded = !0;
                var t = getExpressionsPlugin();
                t && t.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
                    this.trigger("DOMLoaded");
                }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
            }
        }, AnimationItem.prototype.resize = function(t, e) {
            var r = "number" == typeof t ? t : void 0, i = "number" == typeof e ? e : void 0;
            this.renderer.updateContainerSize(r, i);
        }, AnimationItem.prototype.setSubframe = function(t) {
            this.isSubframeEnabled = !!t;
        }, AnimationItem.prototype.gotoFrame = function() {
            this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
        }, AnimationItem.prototype.renderFrame = function() {
            if (!1 !== this.isLoaded && this.renderer) try {
                this.renderer.renderFrame(this.currentFrame + this.firstFrame);
            } catch (t) {
                this.triggerRenderFrameError(t);
            }
        }, AnimationItem.prototype.play = function(t) {
            t && this.name !== t || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_pause"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
        }, AnimationItem.prototype.pause = function(t) {
            t && this.name !== t || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_play"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
        }, AnimationItem.prototype.togglePause = function(t) {
            t && this.name !== t || (!0 === this.isPaused ? this.play() : this.pause());
        }, AnimationItem.prototype.stop = function(t) {
            t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
        }, AnimationItem.prototype.getMarkerData = function(t) {
            for(var e, r = 0; r < this.markers.length; r += 1)if ((e = this.markers[r]).payload && e.payload.name === t) return e;
            return null;
        }, AnimationItem.prototype.goToAndStop = function(t, e, r) {
            if (!r || this.name === r) {
                var i = Number(t);
                if (isNaN(i)) {
                    var a = this.getMarkerData(t);
                    a && this.goToAndStop(a.time, !0);
                } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                this.pause();
            }
        }, AnimationItem.prototype.goToAndPlay = function(t, e, r) {
            if (!r || this.name === r) {
                var i = Number(t);
                if (isNaN(i)) {
                    var a = this.getMarkerData(t);
                    a && (a.duration ? this.playSegments([
                        a.time,
                        a.time + a.duration
                    ], !0) : this.goToAndStop(a.time, !0));
                } else this.goToAndStop(i, e, r);
                this.play();
            }
        }, AnimationItem.prototype.advanceTime = function(t) {
            if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                var e = this.currentRawFrame + t * this.frameModifier, r = !1;
                e >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (r = !0, e = this.totalFrames - 1) : e < 0 ? this.checkSegments(e % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (r = !0, e = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e), r && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
            }
        }, AnimationItem.prototype.adjustSegment = function(t, e) {
            this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(.001 + e)), this.trigger("segmentStart");
        }, AnimationItem.prototype.setSegment = function(t, e) {
            var r = -1;
            this.isPaused && (this.currentRawFrame + this.firstFrame < t ? r = t : this.currentRawFrame + this.firstFrame > e && (r = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, -1 !== r && this.goToAndStop(r, !0);
        }, AnimationItem.prototype.playSegments = function(t, e) {
            if (e && (this.segments.length = 0), "object" === _typeof$4(t[0])) {
                var r, i = t.length;
                for(r = 0; r < i; r += 1)this.segments.push(t[r]);
            } else this.segments.push(t);
            this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
        }, AnimationItem.prototype.resetSegments = function(t) {
            this.segments.length = 0, this.segments.push([
                this.animationData.ip,
                this.animationData.op
            ]), t && this.checkSegments(0);
        }, AnimationItem.prototype.checkSegments = function(t) {
            return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
        }, AnimationItem.prototype.destroy = function(t) {
            t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
        }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
            this.currentRawFrame = t, this.gotoFrame();
        }, AnimationItem.prototype.setSpeed = function(t) {
            this.playSpeed = t, this.updaFrameModifier();
        }, AnimationItem.prototype.setDirection = function(t) {
            this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
        }, AnimationItem.prototype.setLoop = function(t) {
            this.loop = t;
        }, AnimationItem.prototype.setVolume = function(t, e) {
            e && this.name !== e || this.audioController.setVolume(t);
        }, AnimationItem.prototype.getVolume = function() {
            return this.audioController.getVolume();
        }, AnimationItem.prototype.mute = function(t) {
            t && this.name !== t || this.audioController.mute();
        }, AnimationItem.prototype.unmute = function(t) {
            t && this.name !== t || this.audioController.unmute();
        }, AnimationItem.prototype.updaFrameModifier = function() {
            this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
        }, AnimationItem.prototype.getPath = function() {
            return this.path;
        }, AnimationItem.prototype.getAssetsPath = function(t) {
            var e = "";
            if (t.e) e = t.p;
            else if (this.assetsPath) {
                var r = t.p;
                -1 !== r.indexOf("images/") && (r = r.split("/")[1]), e = this.assetsPath + r;
            } else e = this.path, e += t.u ? t.u : "", e += t.p;
            return e;
        }, AnimationItem.prototype.getAssetData = function(t) {
            for(var e = 0, r = this.assets.length; e < r;){
                if (t === this.assets[e].id) return this.assets[e];
                e += 1;
            }
            return null;
        }, AnimationItem.prototype.hide = function() {
            this.renderer.hide();
        }, AnimationItem.prototype.show = function() {
            this.renderer.show();
        }, AnimationItem.prototype.getDuration = function(t) {
            return t ? this.totalFrames : this.totalFrames / this.frameRate;
        }, AnimationItem.prototype.updateDocumentData = function(t, e, r) {
            try {
                this.renderer.getElementByPath(t).updateDocumentData(e, r);
            } catch (t) {}
        }, AnimationItem.prototype.trigger = function(t) {
            if (this._cbs && this._cbs[t]) switch(t){
                case "enterFrame":
                    this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
                    break;
                case "drawnFrame":
                    this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
                    break;
                case "loopComplete":
                    this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
                    break;
                case "complete":
                    this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
                    break;
                case "segmentStart":
                    this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
                    break;
                case "destroy":
                    this.triggerEvent(t, new BMDestroyEvent(t, this));
                    break;
                default:
                    this.triggerEvent(t);
            }
            "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
        }, AnimationItem.prototype.triggerRenderFrameError = function(t) {
            var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        }, AnimationItem.prototype.triggerConfigError = function(t) {
            var e = new BMConfigErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        };
        var animationManager = function() {
            var t = {}, e = [], r = 0, i = 0, a = 0, s = !0, n = !1;
            function o(t) {
                for(var r = 0, a = t.target; r < i;)e[r].animation === a && (e.splice(r, 1), r -= 1, i -= 1, a.isPaused || p()), r += 1;
            }
            function h(t, r) {
                if (!t) return null;
                for(var a = 0; a < i;){
                    if (e[a].elem === t && null !== e[a].elem) return e[a].animation;
                    a += 1;
                }
                var s = new AnimationItem;
                return f(s, t), s.setData(t, r), s;
            }
            function l() {
                a += 1, d();
            }
            function p() {
                a -= 1;
            }
            function f(t, r) {
                t.addEventListener("destroy", o), t.addEventListener("_active", l), t.addEventListener("_idle", p), e.push({
                    elem: r,
                    animation: t
                }), i += 1;
            }
            function c(t) {
                var o, h = t - r;
                for(o = 0; o < i; o += 1)e[o].animation.advanceTime(h);
                r = t, a && !n ? window.requestAnimationFrame(c) : s = !0;
            }
            function m(t) {
                r = t, window.requestAnimationFrame(c);
            }
            function d() {
                !n && a && s && (window.requestAnimationFrame(m), s = !1);
            }
            return t.registerAnimation = h, t.loadAnimation = function(t) {
                var e = new AnimationItem;
                return f(e, null), e.setParams(t), e;
            }, t.setSpeed = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setSpeed(t, r);
            }, t.setDirection = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setDirection(t, r);
            }, t.play = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.play(t);
            }, t.pause = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.pause(t);
            }, t.stop = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.stop(t);
            }, t.togglePause = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.togglePause(t);
            }, t.searchAnimations = function(t, e, r) {
                var i, a = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), s = a.length;
                for(i = 0; i < s; i += 1)r && a[i].setAttribute("data-bm-type", r), h(a[i], t);
                if (e && 0 === s) {
                    r || (r = "svg");
                    var n = document.getElementsByTagName("body")[0];
                    n.innerText = "";
                    var o = createTag("div");
                    o.style.width = "100%", o.style.height = "100%", o.setAttribute("data-bm-type", r), n.appendChild(o), h(o, t);
                }
            }, t.resize = function() {
                var t;
                for(t = 0; t < i; t += 1)e[t].animation.resize();
            }, t.goToAndStop = function(t, r, a) {
                var s;
                for(s = 0; s < i; s += 1)e[s].animation.goToAndStop(t, r, a);
            }, t.destroy = function(t) {
                var r;
                for(r = i - 1; r >= 0; r -= 1)e[r].animation.destroy(t);
            }, t.freeze = function() {
                n = !0;
            }, t.unfreeze = function() {
                n = !1, d();
            }, t.setVolume = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setVolume(t, r);
            }, t.mute = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.mute(t);
            }, t.unmute = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.unmute(t);
            }, t.getRegisteredAnimations = function() {
                var t, r = e.length, i = [];
                for(t = 0; t < r; t += 1)i.push(e[t].animation);
                return i;
            }, t;
        }(), BezierFactory = function() {
            var t = {
                getBezierEasing: function(t, r, i, a, s) {
                    var n = s || ("bez_" + t + "_" + r + "_" + i + "_" + a).replace(/\./g, "p");
                    if (e[n]) return e[n];
                    var o = new h([
                        t,
                        r,
                        i,
                        a
                    ]);
                    return e[n] = o, o;
                }
            }, e = {};
            var r = "function" == typeof Float32Array;
            function i(t, e) {
                return 1 - 3 * e + 3 * t;
            }
            function a(t, e) {
                return 3 * e - 6 * t;
            }
            function s(t) {
                return 3 * t;
            }
            function n(t, e, r) {
                return ((i(e, r) * t + a(e, r)) * t + s(e)) * t;
            }
            function o(t, e, r) {
                return 3 * i(e, r) * t * t + 2 * a(e, r) * t + s(e);
            }
            function h(t) {
                this._p = t, this._mSampleValues = r ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
            }
            return h.prototype = {
                get: function(t) {
                    var e = this._p[0], r = this._p[1], i = this._p[2], a = this._p[3];
                    return this._precomputed || this._precompute(), e === r && i === a ? t : 0 === t ? 0 : 1 === t ? 1 : n(this._getTForX(t), r, a);
                },
                _precompute: function() {
                    var t = this._p[0], e = this._p[1], r = this._p[2], i = this._p[3];
                    this._precomputed = !0, t === e && r === i || this._calcSampleValues();
                },
                _calcSampleValues: function() {
                    for(var t = this._p[0], e = this._p[2], r = 0; r < 11; ++r)this._mSampleValues[r] = n(.1 * r, t, e);
                },
                _getTForX: function(t) {
                    for(var e = this._p[0], r = this._p[2], i = this._mSampleValues, a = 0, s = 1; 10 !== s && i[s] <= t; ++s)a += .1;
                    var h = a + .1 * ((t - i[--s]) / (i[s + 1] - i[s])), l = o(h, e, r);
                    return l >= .001 ? function(t, e, r, i) {
                        for(var a = 0; a < 4; ++a){
                            var s = o(e, r, i);
                            if (0 === s) return e;
                            e -= (n(e, r, i) - t) / s;
                        }
                        return e;
                    }(t, h, e, r) : 0 === l ? h : function(t, e, r, i, a) {
                        var s, o, h = 0;
                        do (s = n(o = e + (r - e) / 2, i, a) - t) > 0 ? r = o : e = o;
                        while (Math.abs(s) > 1e-7 && ++h < 10);
                        return o;
                    }(t, a, a + .1, e, r);
                }
            }, t;
        }(), pooling = {
            double: function(t) {
                return t.concat(createSizedArray(t.length));
            }
        }, poolFactory = function(t, e, r) {
            var i = 0, a = t, s = createSizedArray(a);
            return {
                newElement: function() {
                    return i ? s[i -= 1] : e();
                },
                release: function(t) {
                    i === a && (s = pooling.double(s), a *= 2), r && r(t), s[i] = t, i += 1;
                }
            };
        }, bezierLengthPool = poolFactory(8, function() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }), segmentsLengthPool = poolFactory(8, function() {
            return {
                lengths: [],
                totalLength: 0
            };
        }, function(t) {
            var e, r = t.lengths.length;
            for(e = 0; e < r; e += 1)bezierLengthPool.release(t.lengths[e]);
            t.lengths.length = 0;
        });
        function bezFunction() {
            var t = Math;
            function e(t, e, r, i, a, s) {
                var n = t * i + e * a + r * s - a * i - s * t - r * e;
                return n > -0.001 && n < .001;
            }
            var r = function(t, e, r, i) {
                var a, s, n, o, h, l, p = getDefaultCurveSegments(), f = 0, c = [], m = [], d = bezierLengthPool.newElement();
                for(n = r.length, a = 0; a < p; a += 1){
                    for(h = a / (p - 1), l = 0, s = 0; s < n; s += 1)o = bmPow(1 - h, 3) * t[s] + 3 * bmPow(1 - h, 2) * h * r[s] + 3 * (1 - h) * bmPow(h, 2) * i[s] + bmPow(h, 3) * e[s], c[s] = o, null !== m[s] && (l += bmPow(c[s] - m[s], 2)), m[s] = c[s];
                    l && (f += l = bmSqrt(l)), d.percents[a] = h, d.lengths[a] = f;
                }
                return d.addedLength = f, d;
            };
            function i(t) {
                this.segmentLength = 0, this.points = new Array(t);
            }
            function a(t, e) {
                this.partialLength = t, this.point = e;
            }
            var s, n = (s = {}, function(t, r, n, o) {
                var h = (t[0] + "_" + t[1] + "_" + r[0] + "_" + r[1] + "_" + n[0] + "_" + n[1] + "_" + o[0] + "_" + o[1]).replace(/\./g, "p");
                if (!s[h]) {
                    var l, p, f, c, m, d, u, y = getDefaultCurveSegments(), g = 0, v = null;
                    2 === t.length && (t[0] !== r[0] || t[1] !== r[1]) && e(t[0], t[1], r[0], r[1], t[0] + n[0], t[1] + n[1]) && e(t[0], t[1], r[0], r[1], r[0] + o[0], r[1] + o[1]) && (y = 2);
                    var b = new i(y);
                    for(f = n.length, l = 0; l < y; l += 1){
                        for(u = createSizedArray(f), m = l / (y - 1), d = 0, p = 0; p < f; p += 1)c = bmPow(1 - m, 3) * t[p] + 3 * bmPow(1 - m, 2) * m * (t[p] + n[p]) + 3 * (1 - m) * bmPow(m, 2) * (r[p] + o[p]) + bmPow(m, 3) * r[p], u[p] = c, null !== v && (d += bmPow(u[p] - v[p], 2));
                        g += d = bmSqrt(d), b.points[l] = new a(d, u), v = u;
                    }
                    b.segmentLength = g, s[h] = b;
                }
                return s[h];
            });
            function o(t, e) {
                var r = e.percents, i = e.lengths, a = r.length, s = bmFloor((a - 1) * t), n = t * e.addedLength, o = 0;
                if (s === a - 1 || 0 === s || n === i[s]) return r[s];
                for(var h = i[s] > n ? -1 : 1, l = !0; l;)if (i[s] <= n && i[s + 1] > n ? (o = (n - i[s]) / (i[s + 1] - i[s]), l = !1) : s += h, s < 0 || s >= a - 1) {
                    if (s === a - 1) return r[s];
                    l = !1;
                }
                return r[s] + (r[s + 1] - r[s]) * o;
            }
            var h = createTypedArray("float32", 8);
            return {
                getSegmentsLength: function(t) {
                    var e, i = segmentsLengthPool.newElement(), a = t.c, s = t.v, n = t.o, o = t.i, h = t._length, l = i.lengths, p = 0;
                    for(e = 0; e < h - 1; e += 1)l[e] = r(s[e], s[e + 1], n[e], o[e + 1]), p += l[e].addedLength;
                    return a && h && (l[e] = r(s[e], s[0], n[e], o[0]), p += l[e].addedLength), i.totalLength = p, i;
                },
                getNewSegment: function(e, r, i, a, s, n, l) {
                    s < 0 ? s = 0 : s > 1 && (s = 1);
                    var p, f = o(s, l), c = o(n = n > 1 ? 1 : n, l), m = e.length, d = 1 - f, u = 1 - c, y = d * d * d, g = f * d * d * 3, v = f * f * d * 3, b = f * f * f, x = d * d * u, P = f * d * u + d * f * u + d * d * c, E = f * f * u + d * f * c + f * d * c, S = f * f * c, C = d * u * u, _ = f * u * u + d * c * u + d * u * c, A = f * c * u + d * c * c + f * u * c, k = f * c * c, w = u * u * u, T = c * u * u + u * c * u + u * u * c, M = c * c * u + u * c * c + c * u * c, D = c * c * c;
                    for(p = 0; p < m; p += 1)h[4 * p] = t.round(1e3 * (y * e[p] + g * i[p] + v * a[p] + b * r[p])) / 1e3, h[4 * p + 1] = t.round(1e3 * (x * e[p] + P * i[p] + E * a[p] + S * r[p])) / 1e3, h[4 * p + 2] = t.round(1e3 * (C * e[p] + _ * i[p] + A * a[p] + k * r[p])) / 1e3, h[4 * p + 3] = t.round(1e3 * (w * e[p] + T * i[p] + M * a[p] + D * r[p])) / 1e3;
                    return h;
                },
                getPointInSegment: function(e, r, i, a, s, n) {
                    var h = o(s, n), l = 1 - h;
                    return [
                        t.round(1e3 * (l * l * l * e[0] + (h * l * l + l * h * l + l * l * h) * i[0] + (h * h * l + l * h * h + h * l * h) * a[0] + h * h * h * r[0])) / 1e3,
                        t.round(1e3 * (l * l * l * e[1] + (h * l * l + l * h * l + l * l * h) * i[1] + (h * h * l + l * h * h + h * l * h) * a[1] + h * h * h * r[1])) / 1e3
                    ];
                },
                buildBezierData: n,
                pointOnLine2D: e,
                pointOnLine3D: function(r, i, a, s, n, o, h, l, p) {
                    if (0 === a && 0 === o && 0 === p) return e(r, i, s, n, h, l);
                    var f, c = t.sqrt(t.pow(s - r, 2) + t.pow(n - i, 2) + t.pow(o - a, 2)), m = t.sqrt(t.pow(h - r, 2) + t.pow(l - i, 2) + t.pow(p - a, 2)), d = t.sqrt(t.pow(h - s, 2) + t.pow(l - n, 2) + t.pow(p - o, 2));
                    return (f = c > m ? c > d ? c - m - d : d - m - c : d > m ? d - m - c : m - c - d) > -0.0001 && f < 1e-4;
                }
            };
        }
        var bez = bezFunction(), PropertyFactory = function() {
            var t = initialDefaultFrame, e = Math.abs;
            function r(t, e) {
                var r, a = this.offsetTime;
                "multidimensional" === this.propType && (r = createTypedArray("float32", this.pv.length));
                for(var s, n, o, h, l, p, f, c, m, d = e.lastIndex, u = d, y = this.keyframes.length - 1, g = !0; g;){
                    if (s = this.keyframes[u], n = this.keyframes[u + 1], u === y - 1 && t >= n.t - a) {
                        s.h && (s = n), d = 0;
                        break;
                    }
                    if (n.t - a > t) {
                        d = u;
                        break;
                    }
                    u < y - 1 ? u += 1 : (d = 0, g = !1);
                }
                o = this.keyframesMetadata[u] || {};
                var v, b = n.t - a, x = s.t - a;
                if (s.to) {
                    o.bezierData || (o.bezierData = bez.buildBezierData(s.s, n.s || s.e, s.to, s.ti));
                    var P = o.bezierData;
                    if (t >= b || t < x) {
                        var E = t >= b ? P.points.length - 1 : 0;
                        for(l = P.points[E].point.length, h = 0; h < l; h += 1)r[h] = P.points[E].point[h];
                    } else {
                        o.__fnct ? m = o.__fnct : (m = BezierFactory.getBezierEasing(s.o.x, s.o.y, s.i.x, s.i.y, s.n).get, o.__fnct = m), p = m((t - x) / (b - x));
                        var S, C = P.segmentLength * p, _ = e.lastFrame < t && e._lastKeyframeIndex === u ? e._lastAddedLength : 0;
                        for(c = e.lastFrame < t && e._lastKeyframeIndex === u ? e._lastPoint : 0, g = !0, f = P.points.length; g;){
                            if (_ += P.points[c].partialLength, 0 === C || 0 === p || c === P.points.length - 1) {
                                for(l = P.points[c].point.length, h = 0; h < l; h += 1)r[h] = P.points[c].point[h];
                                break;
                            }
                            if (C >= _ && C < _ + P.points[c + 1].partialLength) {
                                for(S = (C - _) / P.points[c + 1].partialLength, l = P.points[c].point.length, h = 0; h < l; h += 1)r[h] = P.points[c].point[h] + (P.points[c + 1].point[h] - P.points[c].point[h]) * S;
                                break;
                            }
                            c < f - 1 ? c += 1 : g = !1;
                        }
                        e._lastPoint = c, e._lastAddedLength = _ - P.points[c].partialLength, e._lastKeyframeIndex = u;
                    }
                } else {
                    var A, k, w, T, M;
                    if (y = s.s.length, v = n.s || s.e, this.sh && 1 !== s.h) {
                        if (t >= b) r[0] = v[0], r[1] = v[1], r[2] = v[2];
                        else if (t <= x) r[0] = s.s[0], r[1] = s.s[1], r[2] = s.s[2];
                        else !function(t, e) {
                            var r = e[0], i = e[1], a = e[2], s = e[3], n = Math.atan2(2 * i * s - 2 * r * a, 1 - 2 * i * i - 2 * a * a), o = Math.asin(2 * r * i + 2 * a * s), h = Math.atan2(2 * r * s - 2 * i * a, 1 - 2 * r * r - 2 * a * a);
                            t[0] = n / degToRads, t[1] = o / degToRads, t[2] = h / degToRads;
                        }(r, function(t, e, r) {
                            var i, a, s, n, o, h = [], l = t[0], p = t[1], f = t[2], c = t[3], m = e[0], d = e[1], u = e[2], y = e[3];
                            (a = l * m + p * d + f * u + c * y) < 0 && (a = -a, m = -m, d = -d, u = -u, y = -y);
                            1 - a > 1e-6 ? (i = Math.acos(a), s = Math.sin(i), n = Math.sin((1 - r) * i) / s, o = Math.sin(r * i) / s) : (n = 1 - r, o = r);
                            return h[0] = n * l + o * m, h[1] = n * p + o * d, h[2] = n * f + o * u, h[3] = n * c + o * y, h;
                        }(i(s.s), i(v), (t - x) / (b - x)));
                    } else for(u = 0; u < y; u += 1)1 !== s.h && (t >= b ? p = 1 : t < x ? p = 0 : (s.o.x.constructor === Array ? (o.__fnct || (o.__fnct = []), o.__fnct[u] ? m = o.__fnct[u] : (A = void 0 === s.o.x[u] ? s.o.x[0] : s.o.x[u], k = void 0 === s.o.y[u] ? s.o.y[0] : s.o.y[u], w = void 0 === s.i.x[u] ? s.i.x[0] : s.i.x[u], T = void 0 === s.i.y[u] ? s.i.y[0] : s.i.y[u], m = BezierFactory.getBezierEasing(A, k, w, T).get, o.__fnct[u] = m)) : o.__fnct ? m = o.__fnct : (A = s.o.x, k = s.o.y, w = s.i.x, T = s.i.y, m = BezierFactory.getBezierEasing(A, k, w, T).get, s.keyframeMetadata = m), p = m((t - x) / (b - x)))), v = n.s || s.e, M = 1 === s.h ? s.s[u] : s.s[u] + (v[u] - s.s[u]) * p, "multidimensional" === this.propType ? r[u] = M : r = M;
                }
                return e.lastIndex = d, r;
            }
            function i(t) {
                var e = t[0] * degToRads, r = t[1] * degToRads, i = t[2] * degToRads, a = Math.cos(e / 2), s = Math.cos(r / 2), n = Math.cos(i / 2), o = Math.sin(e / 2), h = Math.sin(r / 2), l = Math.sin(i / 2);
                return [
                    o * h * n + a * s * l,
                    o * s * n + a * h * l,
                    a * h * n - o * s * l,
                    a * s * n - o * h * l
                ];
            }
            function a() {
                var e = this.comp.renderedFrame - this.offsetTime, r = this.keyframes[0].t - this.offsetTime, i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
                if (!(e === this._caching.lastFrame || this._caching.lastFrame !== t && (this._caching.lastFrame >= i && e >= i || this._caching.lastFrame < r && e < r))) {
                    this._caching.lastFrame >= e && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                    var a = this.interpolateValue(e, this._caching);
                    this.pv = a;
                }
                return this._caching.lastFrame = e, this.pv;
            }
            function s(t) {
                var r;
                if ("unidimensional" === this.propType) r = t * this.mult, e(this.v - r) > 1e-5 && (this.v = r, this._mdf = !0);
                else for(var i = 0, a = this.v.length; i < a;)r = t[i] * this.mult, e(this.v[i] - r) > 1e-5 && (this.v[i] = r, this._mdf = !0), i += 1;
            }
            function n() {
                if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                    if (this.lock) this.setVValue(this.pv);
                    else {
                        var t;
                        this.lock = !0, this._mdf = this._isFirstFrame;
                        var e = this.effectsSequence.length, r = this.kf ? this.pv : this.data.k;
                        for(t = 0; t < e; t += 1)r = this.effectsSequence[t](r);
                        this.setVValue(r), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                    }
                }
            }
            function o(t) {
                this.effectsSequence.push(t), this.container.addDynamicProperty(this);
            }
            function h(t, e, r, i) {
                this.propType = "unidimensional", this.mult = r || 1, this.data = e, this.v = r ? e.k * r : e.k, this.pv = e.k, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = n, this.setVValue = s, this.addEffect = o;
            }
            function l(t, e, r, i) {
                var a;
                this.propType = "multidimensional", this.mult = r || 1, this.data = e, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
                var h = e.k.length;
                for(this.v = createTypedArray("float32", h), this.pv = createTypedArray("float32", h), this.vel = createTypedArray("float32", h), a = 0; a < h; a += 1)this.v[a] = e.k[a] * this.mult, this.pv[a] = e.k[a];
                this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = n, this.setVValue = s, this.addEffect = o;
            }
            function p(e, i, h, l) {
                this.propType = "unidimensional", this.keyframes = i.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.frameId = -1, this._caching = {
                    lastFrame: t,
                    lastIndex: 0,
                    value: 0,
                    _lastKeyframeIndex: -1
                }, this.k = !0, this.kf = !0, this.data = i, this.mult = h || 1, this.elem = e, this.container = l, this.comp = e.comp, this.v = t, this.pv = t, this._isFirstFrame = !0, this.getValue = n, this.setVValue = s, this.interpolateValue = r, this.effectsSequence = [
                    a.bind(this)
                ], this.addEffect = o;
            }
            function f(e, i, h, l) {
                var p;
                this.propType = "multidimensional";
                var f, c, m, d, u = i.k.length;
                for(p = 0; p < u - 1; p += 1)i.k[p].to && i.k[p].s && i.k[p + 1] && i.k[p + 1].s && (f = i.k[p].s, c = i.k[p + 1].s, m = i.k[p].to, d = i.k[p].ti, (2 === f.length && (f[0] !== c[0] || f[1] !== c[1]) && bez.pointOnLine2D(f[0], f[1], c[0], c[1], f[0] + m[0], f[1] + m[1]) && bez.pointOnLine2D(f[0], f[1], c[0], c[1], c[0] + d[0], c[1] + d[1]) || 3 === f.length && (f[0] !== c[0] || f[1] !== c[1] || f[2] !== c[2]) && bez.pointOnLine3D(f[0], f[1], f[2], c[0], c[1], c[2], f[0] + m[0], f[1] + m[1], f[2] + m[2]) && bez.pointOnLine3D(f[0], f[1], f[2], c[0], c[1], c[2], c[0] + d[0], c[1] + d[1], c[2] + d[2])) && (i.k[p].to = null, i.k[p].ti = null), f[0] === c[0] && f[1] === c[1] && 0 === m[0] && 0 === m[1] && 0 === d[0] && 0 === d[1] && (2 === f.length || f[2] === c[2] && 0 === m[2] && 0 === d[2]) && (i.k[p].to = null, i.k[p].ti = null));
                this.effectsSequence = [
                    a.bind(this)
                ], this.data = i, this.keyframes = i.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = h || 1, this.elem = e, this.container = l, this.comp = e.comp, this.getValue = n, this.setVValue = s, this.interpolateValue = r, this.frameId = -1;
                var y = i.k[0].s.length;
                for(this.v = createTypedArray("float32", y), this.pv = createTypedArray("float32", y), p = 0; p < y; p += 1)this.v[p] = t, this.pv[p] = t;
                this._caching = {
                    lastFrame: t,
                    lastIndex: 0,
                    value: createTypedArray("float32", y)
                }, this.addEffect = o;
            }
            return {
                getProp: function(t, e, r, i, a) {
                    var s;
                    if (e.k.length) {
                        if ("number" == typeof e.k[0]) s = new l(t, e, i, a);
                        else switch(r){
                            case 0:
                                s = new p(t, e, i, a);
                                break;
                            case 1:
                                s = new f(t, e, i, a);
                        }
                    } else s = new h(t, e, i, a);
                    return s.effectsSequence.length && a.addDynamicProperty(s), s;
                }
            };
        }();
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
            },
            iterateDynamicProperties: function() {
                var t;
                this._mdf = !1;
                var e = this.dynamicProperties.length;
                for(t = 0; t < e; t += 1)this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
            },
            initDynamicPropertyContainer: function(t) {
                this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
            }
        };
        var pointPool = poolFactory(8, function() {
            return createTypedArray("float32", 2);
        });
        function ShapePath() {
            this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
        }
        ShapePath.prototype.setPathData = function(t, e) {
            this.c = t, this.setLength(e);
            for(var r = 0; r < e;)this.v[r] = pointPool.newElement(), this.o[r] = pointPool.newElement(), this.i[r] = pointPool.newElement(), r += 1;
        }, ShapePath.prototype.setLength = function(t) {
            for(; this._maxLength < t;)this.doubleArrayLength();
            this._length = t;
        }, ShapePath.prototype.doubleArrayLength = function() {
            this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
        }, ShapePath.prototype.setXYAt = function(t, e, r, i, a) {
            var s;
            switch(this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), r){
                case "v":
                    s = this.v;
                    break;
                case "i":
                    s = this.i;
                    break;
                case "o":
                    s = this.o;
                    break;
                default:
                    s = [];
            }
            (!s[i] || s[i] && !a) && (s[i] = pointPool.newElement()), s[i][0] = t, s[i][1] = e;
        }, ShapePath.prototype.setTripleAt = function(t, e, r, i, a, s, n, o) {
            this.setXYAt(t, e, "v", n, o), this.setXYAt(r, i, "o", n, o), this.setXYAt(a, s, "i", n, o);
        }, ShapePath.prototype.reverse = function() {
            var t = new ShapePath;
            t.setPathData(this.c, this._length);
            var e = this.v, r = this.o, i = this.i, a = 0;
            this.c && (t.setTripleAt(e[0][0], e[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1), a = 1);
            var s, n = this._length - 1, o = this._length;
            for(s = a; s < o; s += 1)t.setTripleAt(e[n][0], e[n][1], i[n][0], i[n][1], r[n][0], r[n][1], s, !1), n -= 1;
            return t;
        }, ShapePath.prototype.length = function() {
            return this._length;
        };
        var shapePool = (factory = poolFactory(4, function() {
            return new ShapePath;
        }, function(t) {
            var e, r = t._length;
            for(e = 0; e < r; e += 1)pointPool.release(t.v[e]), pointPool.release(t.i[e]), pointPool.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
            t._length = 0, t.c = !1;
        }), factory.clone = function(t) {
            var e, r = factory.newElement(), i = void 0 === t._length ? t.v.length : t._length;
            for(r.setLength(i), r.c = t.c, e = 0; e < i; e += 1)r.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
            return r;
        }, factory), factory;
        function ShapeCollection() {
            this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
        }
        ShapeCollection.prototype.addShape = function(t) {
            this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
        }, ShapeCollection.prototype.releaseShapes = function() {
            var t;
            for(t = 0; t < this._length; t += 1)shapePool.release(this.shapes[t]);
            this._length = 0;
        };
        var shapeCollectionPool = (ob = {
            newShapeCollection: function() {
                return _length ? pool[_length -= 1] : new ShapeCollection;
            },
            release: function(t) {
                var e, r = t._length;
                for(e = 0; e < r; e += 1)shapePool.release(t.shapes[e]);
                t._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = t, _length += 1;
            }
        }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = function() {
            function t(t, e, r) {
                var i, a, s, n, o, h, l, p, f, c = r.lastIndex, m = this.keyframes;
                if (t < m[0].t - this.offsetTime) i = m[0].s[0], s = !0, c = 0;
                else if (t >= m[m.length - 1].t - this.offsetTime) i = m[m.length - 1].s ? m[m.length - 1].s[0] : m[m.length - 2].e[0], s = !0;
                else {
                    for(var d, u, y, g = c, v = m.length - 1, b = !0; b && (d = m[g], !((u = m[g + 1]).t - this.offsetTime > t));)g < v - 1 ? g += 1 : b = !1;
                    if (y = this.keyframesMetadata[g] || {}, c = g, !(s = 1 === d.h)) {
                        if (t >= u.t - this.offsetTime) p = 1;
                        else if (t < d.t - this.offsetTime) p = 0;
                        else {
                            var x;
                            y.__fnct ? x = y.__fnct : (x = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y).get, y.__fnct = x), p = x((t - (d.t - this.offsetTime)) / (u.t - this.offsetTime - (d.t - this.offsetTime)));
                        }
                        a = u.s ? u.s[0] : d.e[0];
                    }
                    i = d.s[0];
                }
                for(h = e._length, l = i.i[0].length, r.lastIndex = c, n = 0; n < h; n += 1)for(o = 0; o < l; o += 1)f = s ? i.i[n][o] : i.i[n][o] + (a.i[n][o] - i.i[n][o]) * p, e.i[n][o] = f, f = s ? i.o[n][o] : i.o[n][o] + (a.o[n][o] - i.o[n][o]) * p, e.o[n][o] = f, f = s ? i.v[n][o] : i.v[n][o] + (a.v[n][o] - i.v[n][o]) * p, e.v[n][o] = f;
            }
            function e() {
                var t = this.comp.renderedFrame - this.offsetTime, e = this.keyframes[0].t - this.offsetTime, r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, i = this._caching.lastFrame;
                return -999999 !== i && (i < e && t < e || i > r && t > r) || (this._caching.lastIndex = i < t ? this._caching.lastIndex : 0, this.interpolateShape(t, this.pv, this._caching)), this._caching.lastFrame = t, this.pv;
            }
            function r() {
                this.paths = this.localShapeCollection;
            }
            function i(t) {
                (function(t, e) {
                    if (t._length !== e._length || t.c !== e.c) return !1;
                    var r, i = t._length;
                    for(r = 0; r < i; r += 1)if (t.v[r][0] !== e.v[r][0] || t.v[r][1] !== e.v[r][1] || t.o[r][0] !== e.o[r][0] || t.o[r][1] !== e.o[r][1] || t.i[r][0] !== e.i[r][0] || t.i[r][1] !== e.i[r][1]) return !1;
                    return !0;
                })(this.v, t) || (this.v = shapePool.clone(t), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
            }
            function a() {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this.effectsSequence.length) {
                        if (this.lock) this.setVValue(this.pv);
                        else {
                            var t, e;
                            this.lock = !0, this._mdf = !1, t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                            var r = this.effectsSequence.length;
                            for(e = 0; e < r; e += 1)t = this.effectsSequence[e](t);
                            this.setVValue(t), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                        }
                    } else this._mdf = !1;
                }
            }
            function s(t, e, i) {
                this.propType = "shape", this.comp = t.comp, this.container = t, this.elem = t, this.data = e, this.k = !1, this.kf = !1, this._mdf = !1;
                var a = 3 === i ? e.pt.k : e.ks.k;
                this.v = shapePool.clone(a), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = r, this.effectsSequence = [];
            }
            function n(t) {
                this.effectsSequence.push(t), this.container.addDynamicProperty(this);
            }
            function o(t, i, a) {
                this.propType = "shape", this.comp = t.comp, this.elem = t, this.container = t, this.offsetTime = t.data.st, this.keyframes = 3 === a ? i.pt.k : i.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                var s = this.keyframes[0].s[0].i.length;
                this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, s), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = -999999, this.reset = r, this._caching = {
                    lastFrame: -999999,
                    lastIndex: 0
                }, this.effectsSequence = [
                    e.bind(this)
                ];
            }
            s.prototype.interpolateShape = t, s.prototype.getValue = a, s.prototype.setVValue = i, s.prototype.addEffect = n, o.prototype.getValue = a, o.prototype.interpolateShape = t, o.prototype.setVValue = i, o.prototype.addEffect = n;
            var h = function() {
                var t = roundCorner;
                function e(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e.d, this.elem = t, this.comp = t.comp, this.frameId = -1, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
                }
                return e.prototype = {
                    reset: r,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                    },
                    convertEllToPath: function() {
                        var e = this.p.v[0], r = this.p.v[1], i = this.s.v[0] / 2, a = this.s.v[1] / 2, s = 3 !== this.d, n = this.v;
                        n.v[0][0] = e, n.v[0][1] = r - a, n.v[1][0] = s ? e + i : e - i, n.v[1][1] = r, n.v[2][0] = e, n.v[2][1] = r + a, n.v[3][0] = s ? e - i : e + i, n.v[3][1] = r, n.i[0][0] = s ? e - i * t : e + i * t, n.i[0][1] = r - a, n.i[1][0] = s ? e + i : e - i, n.i[1][1] = r - a * t, n.i[2][0] = s ? e + i * t : e - i * t, n.i[2][1] = r + a, n.i[3][0] = s ? e - i : e + i, n.i[3][1] = r + a * t, n.o[0][0] = s ? e + i * t : e - i * t, n.o[0][1] = r - a, n.o[1][0] = s ? e + i : e - i, n.o[1][1] = r + a * t, n.o[2][0] = s ? e - i * t : e + i * t, n.o[2][1] = r + a, n.o[3][0] = s ? e - i : e + i, n.o[3][1] = r - a * t;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], e), e;
            }(), l = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t, this.comp = t.comp, this.data = e, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? (this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this), this.is = PropertyFactory.getProp(t, e.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t, e.or, 0, 0, this), this.os = PropertyFactory.getProp(t, e.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
                }
                return t.prototype = {
                    reset: r,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                    },
                    convertStarToPath: function() {
                        var t, e, r, i, a = 2 * Math.floor(this.pt.v), s = 2 * Math.PI / a, n = !0, o = this.or.v, h = this.ir.v, l = this.os.v, p = this.is.v, f = 2 * Math.PI * o / (2 * a), c = 2 * Math.PI * h / (2 * a), m = -Math.PI / 2;
                        m += this.r.v;
                        var d = 3 === this.data.d ? -1 : 1;
                        for(this.v._length = 0, t = 0; t < a; t += 1){
                            r = n ? l : p, i = n ? f : c;
                            var u = (e = n ? o : h) * Math.cos(m), y = e * Math.sin(m), g = 0 === u && 0 === y ? 0 : y / Math.sqrt(u * u + y * y), v = 0 === u && 0 === y ? 0 : -u / Math.sqrt(u * u + y * y);
                            u += +this.p.v[0], y += +this.p.v[1], this.v.setTripleAt(u, y, u - g * i * r * d, y - v * i * r * d, u + g * i * r * d, y + v * i * r * d, t, !0), n = !n, m += s * d;
                        }
                    },
                    convertPolygonToPath: function() {
                        var t, e = Math.floor(this.pt.v), r = 2 * Math.PI / e, i = this.or.v, a = this.os.v, s = 2 * Math.PI * i / (4 * e), n = .5 * -Math.PI, o = 3 === this.data.d ? -1 : 1;
                        for(n += this.r.v, this.v._length = 0, t = 0; t < e; t += 1){
                            var h = i * Math.cos(n), l = i * Math.sin(n), p = 0 === h && 0 === l ? 0 : l / Math.sqrt(h * h + l * l), f = 0 === h && 0 === l ? 0 : -h / Math.sqrt(h * h + l * l);
                            h += +this.p.v[0], l += +this.p.v[1], this.v.setTripleAt(h, l, h - p * s * a * o, l - f * s * a * o, h + p * s * a * o, l + f * s * a * o, t, !0), n += r * o;
                        }
                        this.paths.length = 0, this.paths[0] = this.v;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }(), p = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t, this.comp = t.comp, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
                }
                return t.prototype = {
                    convertRectToPath: function() {
                        var t = this.p.v[0], e = this.p.v[1], r = this.s.v[0] / 2, i = this.s.v[1] / 2, a = bmMin(r, i, this.r.v), s = a * (1 - roundCorner);
                        this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t + r, e - i + a, t + r, e - i + a, t + r, e - i + s, 0, !0), this.v.setTripleAt(t + r, e + i - a, t + r, e + i - s, t + r, e + i - a, 1, !0), 0 !== a ? (this.v.setTripleAt(t + r - a, e + i, t + r - a, e + i, t + r - s, e + i, 2, !0), this.v.setTripleAt(t - r + a, e + i, t - r + s, e + i, t - r + a, e + i, 3, !0), this.v.setTripleAt(t - r, e + i - a, t - r, e + i - a, t - r, e + i - s, 4, !0), this.v.setTripleAt(t - r, e - i + a, t - r, e - i + s, t - r, e - i + a, 5, !0), this.v.setTripleAt(t - r + a, e - i, t - r + a, e - i, t - r + s, e - i, 6, !0), this.v.setTripleAt(t + r - a, e - i, t + r - s, e - i, t + r - a, e - i, 7, !0)) : (this.v.setTripleAt(t - r, e + i, t - r + s, e + i, t - r, e + i, 2), this.v.setTripleAt(t - r, e - i, t - r, e - i + s, t - r, e - i, 3))) : (this.v.setTripleAt(t + r, e - i + a, t + r, e - i + s, t + r, e - i + a, 0, !0), 0 !== a ? (this.v.setTripleAt(t + r - a, e - i, t + r - a, e - i, t + r - s, e - i, 1, !0), this.v.setTripleAt(t - r + a, e - i, t - r + s, e - i, t - r + a, e - i, 2, !0), this.v.setTripleAt(t - r, e - i + a, t - r, e - i + a, t - r, e - i + s, 3, !0), this.v.setTripleAt(t - r, e + i - a, t - r, e + i - s, t - r, e + i - a, 4, !0), this.v.setTripleAt(t - r + a, e + i, t - r + a, e + i, t - r + s, e + i, 5, !0), this.v.setTripleAt(t + r - a, e + i, t + r - s, e + i, t + r - a, e + i, 6, !0), this.v.setTripleAt(t + r, e + i - a, t + r, e + i - a, t + r, e + i - s, 7, !0)) : (this.v.setTripleAt(t - r, e - i, t - r + s, e - i, t - r, e - i, 1, !0), this.v.setTripleAt(t - r, e + i, t - r, e + i - s, t - r, e + i, 2, !0), this.v.setTripleAt(t + r, e + i, t + r - s, e + i, t + r, e + i, 3, !0)));
                    },
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                    },
                    reset: r
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }();
            var f = {
                getShapeProp: function(t, e, r) {
                    var i;
                    return 3 === r || 4 === r ? i = (3 === r ? e.pt : e.ks).k.length ? new o(t, e, r) : new s(t, e, r) : 5 === r ? i = new p(t, e) : 6 === r ? i = new h(t, e) : 7 === r && (i = new l(t, e)), i.k && t.addDynamicProperty(i), i;
                },
                getConstructorFunction: function() {
                    return s;
                },
                getKeyframedConstructorFunction: function() {
                    return o;
                }
            };
            return f;
        }(), Matrix = function() {
            var t = Math.cos, e = Math.sin, r = Math.tan, i = Math.round;
            function a() {
                return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
            }
            function s(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, -a, 0, 0, a, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function n(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(1, 0, 0, 0, 0, i, -a, 0, 0, a, i, 0, 0, 0, 0, 1);
            }
            function o(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, 0, a, 0, 0, 1, 0, 0, -a, 0, i, 0, 0, 0, 0, 1);
            }
            function h(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, -a, 0, 0, a, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function l(t, e) {
                return this._t(1, e, t, 1, 0, 0);
            }
            function p(t, e) {
                return this.shear(r(t), r(e));
            }
            function f(i, a) {
                var s = t(a), n = e(a);
                return this._t(s, n, 0, 0, -n, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r(i), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(s, -n, 0, 0, n, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function c(t, e, r) {
                return r || 0 === r || (r = 1), 1 === t && 1 === e && 1 === r ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1);
            }
            function m(t, e, r, i, a, s, n, o, h, l, p, f, c, m, d, u) {
                return this.props[0] = t, this.props[1] = e, this.props[2] = r, this.props[3] = i, this.props[4] = a, this.props[5] = s, this.props[6] = n, this.props[7] = o, this.props[8] = h, this.props[9] = l, this.props[10] = p, this.props[11] = f, this.props[12] = c, this.props[13] = m, this.props[14] = d, this.props[15] = u, this;
            }
            function d(t, e, r) {
                return r = r || 0, 0 !== t || 0 !== e || 0 !== r ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r, 1) : this;
            }
            function u(t, e, r, i, a, s, n, o, h, l, p, f, c, m, d, u) {
                var y = this.props;
                if (1 === t && 0 === e && 0 === r && 0 === i && 0 === a && 1 === s && 0 === n && 0 === o && 0 === h && 0 === l && 1 === p && 0 === f) return y[12] = y[12] * t + y[15] * c, y[13] = y[13] * s + y[15] * m, y[14] = y[14] * p + y[15] * d, y[15] *= u, this._identityCalculated = !1, this;
                var g = y[0], v = y[1], b = y[2], x = y[3], P = y[4], E = y[5], S = y[6], C = y[7], _ = y[8], A = y[9], k = y[10], w = y[11], T = y[12], M = y[13], D = y[14], F = y[15];
                return y[0] = g * t + v * a + b * h + x * c, y[1] = g * e + v * s + b * l + x * m, y[2] = g * r + v * n + b * p + x * d, y[3] = g * i + v * o + b * f + x * u, y[4] = P * t + E * a + S * h + C * c, y[5] = P * e + E * s + S * l + C * m, y[6] = P * r + E * n + S * p + C * d, y[7] = P * i + E * o + S * f + C * u, y[8] = _ * t + A * a + k * h + w * c, y[9] = _ * e + A * s + k * l + w * m, y[10] = _ * r + A * n + k * p + w * d, y[11] = _ * i + A * o + k * f + w * u, y[12] = T * t + M * a + D * h + F * c, y[13] = T * e + M * s + D * l + F * m, y[14] = T * r + M * n + D * p + F * d, y[15] = T * i + M * o + D * f + F * u, this._identityCalculated = !1, this;
            }
            function y() {
                return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
            }
            function g(t) {
                for(var e = 0; e < 16;){
                    if (t.props[e] !== this.props[e]) return !1;
                    e += 1;
                }
                return !0;
            }
            function v(t) {
                var e;
                for(e = 0; e < 16; e += 1)t.props[e] = this.props[e];
                return t;
            }
            function b(t) {
                var e;
                for(e = 0; e < 16; e += 1)this.props[e] = t[e];
            }
            function x(t, e, r) {
                return {
                    x: t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                    y: t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                    z: t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14]
                };
            }
            function P(t, e, r) {
                return t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12];
            }
            function E(t, e, r) {
                return t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13];
            }
            function S(t, e, r) {
                return t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14];
            }
            function C() {
                var t = this.props[0] * this.props[5] - this.props[1] * this.props[4], e = this.props[5] / t, r = -this.props[1] / t, i = -this.props[4] / t, a = this.props[0] / t, s = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t, n = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t, o = new Matrix;
                return o.props[0] = e, o.props[1] = r, o.props[4] = i, o.props[5] = a, o.props[12] = s, o.props[13] = n, o;
            }
            function _(t) {
                return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
            }
            function A(t) {
                var e, r = t.length, i = [];
                for(e = 0; e < r; e += 1)i[e] = _(t[e]);
                return i;
            }
            function k(t, e, r) {
                var i = createTypedArray("float32", 6);
                if (this.isIdentity()) i[0] = t[0], i[1] = t[1], i[2] = e[0], i[3] = e[1], i[4] = r[0], i[5] = r[1];
                else {
                    var a = this.props[0], s = this.props[1], n = this.props[4], o = this.props[5], h = this.props[12], l = this.props[13];
                    i[0] = t[0] * a + t[1] * n + h, i[1] = t[0] * s + t[1] * o + l, i[2] = e[0] * a + e[1] * n + h, i[3] = e[0] * s + e[1] * o + l, i[4] = r[0] * a + r[1] * n + h, i[5] = r[0] * s + r[1] * o + l;
                }
                return i;
            }
            function w(t, e, r) {
                return this.isIdentity() ? [
                    t,
                    e,
                    r
                ] : [
                    t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                    t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                    t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14]
                ];
            }
            function T(t, e) {
                if (this.isIdentity()) return t + "," + e;
                var r = this.props;
                return Math.round(100 * (t * r[0] + e * r[4] + r[12])) / 100 + "," + Math.round(100 * (t * r[1] + e * r[5] + r[13])) / 100;
            }
            function M() {
                for(var t = 0, e = this.props, r = "matrix3d("; t < 16;)r += i(1e4 * e[t]) / 1e4, r += 15 === t ? ")" : ",", t += 1;
                return r;
            }
            function D(t) {
                return t < 1e-6 && t > 0 || t > -0.000001 && t < 0 ? i(1e4 * t) / 1e4 : t;
            }
            function F() {
                var t = this.props;
                return "matrix(" + D(t[0]) + "," + D(t[1]) + "," + D(t[4]) + "," + D(t[5]) + "," + D(t[12]) + "," + D(t[13]) + ")";
            }
            return function() {
                this.reset = a, this.rotate = s, this.rotateX = n, this.rotateY = o, this.rotateZ = h, this.skew = p, this.skewFromAxis = f, this.shear = l, this.scale = c, this.setTransform = m, this.translate = d, this.transform = u, this.applyToPoint = x, this.applyToX = P, this.applyToY = E, this.applyToZ = S, this.applyToPointArray = w, this.applyToTriplePoints = k, this.applyToPointStringified = T, this.toCSS = M, this.to2dCSS = F, this.clone = v, this.cloneFromProps = b, this.equals = g, this.inversePoints = A, this.inversePoint = _, this.getInverseMatrix = C, this._t = this.transform, this.isIdentity = y, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
            };
        }();
        function _typeof$3(t) {
            return (_typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var lottie = {}, standalone = "__[STANDALONE]__", animationData = "__[ANIMATIONDATA]__", renderer = "";
        function setLocation(t) {
            setLocationHref(t);
        }
        function searchAnimations() {
            !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
        }
        function setSubframeRendering(t) {
            setSubframeEnabled(t);
        }
        function setPrefix(t) {
            setIdPrefix(t);
        }
        function loadAnimation(t) {
            return !0 === standalone && (t.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t);
        }
        function setQuality(t) {
            if ("string" == typeof t) switch(t){
                case "high":
                    setDefaultCurveSegments(200);
                    break;
                default:
                case "medium":
                    setDefaultCurveSegments(50);
                    break;
                case "low":
                    setDefaultCurveSegments(10);
            }
            else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
            getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
        }
        function inBrowser() {
            return "undefined" != typeof navigator;
        }
        function installPlugin(t, e) {
            "expressions" === t && setExpressionsPlugin(e);
        }
        function getFactory(t) {
            switch(t){
                case "propertyFactory":
                    return PropertyFactory;
                case "shapePropertyFactory":
                    return ShapePropertyFactory;
                case "matrix":
                    return Matrix;
                default:
                    return null;
            }
        }
        function checkReady() {
            "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
        }
        function getQueryVariable(t) {
            for(var e = queryString.split("&"), r = 0; r < e.length; r += 1){
                var i = e[r].split("=");
                if (decodeURIComponent(i[0]) == t) return decodeURIComponent(i[1]);
            }
            return null;
        }
        lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.10.2";
        var queryString = "";
        if (standalone) {
            var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", renderer = getQueryVariable("renderer");
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
            "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
        } catch (t) {}
        var ShapeModifiers = function() {
            var t = {}, e = {};
            return t.registerModifier = function(t, r) {
                e[t] || (e[t] = r);
            }, t.getModifier = function(t, r, i) {
                return new e[t](r, i);
            }, t;
        }();
        function ShapeModifier() {}
        function TrimModifier() {}
        function PuckerAndBloatModifier() {}
        ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t) {
            if (!this.closed) {
                t.sh.container.addDynamicProperty(t.sh);
                var e = {
                    shape: t.sh,
                    data: t,
                    localShapeCollection: shapeCollectionPool.newShapeCollection()
                };
                this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
            }
        }, ShapeModifier.prototype.init = function(t, e) {
            this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, ShapeModifier.prototype.processKeys = function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
        }, extendPrototype([
            DynamicPropertyContainer
        ], ShapeModifier), extendPrototype([
            ShapeModifier
        ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t, e) {
            this.s = PropertyFactory.getProp(t, e.s, 0, .01, this), this.e = PropertyFactory.getProp(t, e.e, 0, .01, this), this.o = PropertyFactory.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
        }, TrimModifier.prototype.addShapeToModifier = function(t) {
            t.pathsData = [];
        }, TrimModifier.prototype.calculateShapeEdges = function(t, e, r, i, a) {
            var s = [];
            e <= 1 ? s.push({
                s: t,
                e: e
            }) : t >= 1 ? s.push({
                s: t - 1,
                e: e - 1
            }) : (s.push({
                s: t,
                e: 1
            }), s.push({
                s: 0,
                e: e - 1
            }));
            var n, o, h = [], l = s.length;
            for(n = 0; n < l; n += 1){
                var p, f;
                if (!((o = s[n]).e * a < i || o.s * a > i + r)) p = o.s * a <= i ? 0 : (o.s * a - i) / r, f = o.e * a >= i + r ? 1 : (o.e * a - i) / r, h.push([
                    p,
                    f
                ]);
            }
            return h.length || h.push([
                0,
                0
            ]), h;
        }, TrimModifier.prototype.releasePathsData = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)segmentsLengthPool.release(t[e]);
            return t.length = 0, t;
        }, TrimModifier.prototype.processShapes = function(t) {
            var e, r, i, a;
            if (this._mdf || t) {
                var s = this.o.v % 360 / 360;
                if (s < 0 && (s += 1), (e = this.s.v > 1 ? 1 + s : this.s.v < 0 ? 0 + s : this.s.v + s) > (r = this.e.v > 1 ? 1 + s : this.e.v < 0 ? 0 + s : this.e.v + s)) {
                    var n = e;
                    e = r, r = n;
                }
                e = 1e-4 * Math.round(1e4 * e), r = 1e-4 * Math.round(1e4 * r), this.sValue = e, this.eValue = r;
            } else e = this.sValue, r = this.eValue;
            var o, h, l, p, f, c = this.shapes.length, m = 0;
            if (r === e) for(a = 0; a < c; a += 1)this.shapes[a].localShapeCollection.releaseShapes(), this.shapes[a].shape._mdf = !0, this.shapes[a].shape.paths = this.shapes[a].localShapeCollection, this._mdf && (this.shapes[a].pathsData.length = 0);
            else if (1 === r && 0 === e || 0 === r && 1 === e) {
                if (this._mdf) for(a = 0; a < c; a += 1)this.shapes[a].pathsData.length = 0, this.shapes[a].shape._mdf = !0;
            } else {
                var d, u, y = [];
                for(a = 0; a < c; a += 1)if ((d = this.shapes[a]).shape._mdf || this._mdf || t || 2 === this.m) {
                    if (h = (i = d.shape.paths)._length, f = 0, !d.shape._mdf && d.pathsData.length) f = d.totalShapeLength;
                    else {
                        for(l = this.releasePathsData(d.pathsData), o = 0; o < h; o += 1)p = bez.getSegmentsLength(i.shapes[o]), l.push(p), f += p.totalLength;
                        d.totalShapeLength = f, d.pathsData = l;
                    }
                    m += f, d.shape._mdf = !0;
                } else d.shape.paths = d.localShapeCollection;
                var g, v = e, b = r, x = 0;
                for(a = c - 1; a >= 0; a -= 1)if ((d = this.shapes[a]).shape._mdf) {
                    for((u = d.localShapeCollection).releaseShapes(), 2 === this.m && c > 1 ? (g = this.calculateShapeEdges(e, r, d.totalShapeLength, x, m), x += d.totalShapeLength) : g = [
                        [
                            v,
                            b
                        ]
                    ], h = g.length, o = 0; o < h; o += 1){
                        v = g[o][0], b = g[o][1], y.length = 0, b <= 1 ? y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength * b
                        }) : v >= 1 ? y.push({
                            s: d.totalShapeLength * (v - 1),
                            e: d.totalShapeLength * (b - 1)
                        }) : (y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength
                        }), y.push({
                            s: 0,
                            e: d.totalShapeLength * (b - 1)
                        }));
                        var P = this.addShapes(d, y[0]);
                        if (y[0].s !== y[0].e) {
                            if (y.length > 1) {
                                if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                                    var E = P.pop();
                                    this.addPaths(P, u), P = this.addShapes(d, y[1], E);
                                } else this.addPaths(P, u), P = this.addShapes(d, y[1]);
                            }
                            this.addPaths(P, u);
                        }
                    }
                    d.shape.paths = u;
                }
            }
        }, TrimModifier.prototype.addPaths = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)e.addShape(t[r]);
        }, TrimModifier.prototype.addSegment = function(t, e, r, i, a, s, n) {
            a.setXYAt(e[0], e[1], "o", s), a.setXYAt(r[0], r[1], "i", s + 1), n && a.setXYAt(t[0], t[1], "v", s), a.setXYAt(i[0], i[1], "v", s + 1);
        }, TrimModifier.prototype.addSegmentFromArray = function(t, e, r, i) {
            e.setXYAt(t[1], t[5], "o", r), e.setXYAt(t[2], t[6], "i", r + 1), i && e.setXYAt(t[0], t[4], "v", r), e.setXYAt(t[3], t[7], "v", r + 1);
        }, TrimModifier.prototype.addShapes = function(t, e, r) {
            var i, a, s, n, o, h, l, p, f = t.pathsData, c = t.shape.paths.shapes, m = t.shape.paths._length, d = 0, u = [], y = !0;
            for(r ? (o = r._length, p = r._length) : (r = shapePool.newElement(), o = 0, p = 0), u.push(r), i = 0; i < m; i += 1){
                for(h = f[i].lengths, r.c = c[i].c, s = c[i].c ? h.length : h.length + 1, a = 1; a < s; a += 1)if (d + (n = h[a - 1]).addedLength < e.s) d += n.addedLength, r.c = !1;
                else {
                    if (d > e.e) {
                        r.c = !1;
                        break;
                    }
                    e.s <= d && e.e >= d + n.addedLength ? (this.addSegment(c[i].v[a - 1], c[i].o[a - 1], c[i].i[a], c[i].v[a], r, o, y), y = !1) : (l = bez.getNewSegment(c[i].v[a - 1], c[i].v[a], c[i].o[a - 1], c[i].i[a], (e.s - d) / n.addedLength, (e.e - d) / n.addedLength, h[a - 1]), this.addSegmentFromArray(l, r, o, y), y = !1, r.c = !1), d += n.addedLength, o += 1;
                }
                if (c[i].c && h.length) {
                    if (n = h[a - 1], d <= e.e) {
                        var g = h[a - 1].addedLength;
                        e.s <= d && e.e >= d + g ? (this.addSegment(c[i].v[a - 1], c[i].o[a - 1], c[i].i[0], c[i].v[0], r, o, y), y = !1) : (l = bez.getNewSegment(c[i].v[a - 1], c[i].v[0], c[i].o[a - 1], c[i].i[0], (e.s - d) / g, (e.e - d) / g, h[a - 1]), this.addSegmentFromArray(l, r, o, y), y = !1, r.c = !1);
                    } else r.c = !1;
                    d += n.addedLength, o += 1;
                }
                if (r._length && (r.setXYAt(r.v[p][0], r.v[p][1], "i", p), r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], "o", r._length - 1)), d > e.e) break;
                i < m - 1 && (r = shapePool.newElement(), y = !0, u.push(r), o = 0);
            }
            return u;
        }, extendPrototype([
            ShapeModifier
        ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
        }, PuckerAndBloatModifier.prototype.processPath = function(t, e) {
            var r = e / 100, i = [
                0,
                0
            ], a = t._length, s = 0;
            for(s = 0; s < a; s += 1)i[0] += t.v[s][0], i[1] += t.v[s][1];
            i[0] /= a, i[1] /= a;
            var n, o, h, l, p, f, c = shapePool.newElement();
            for(c.c = t.c, s = 0; s < a; s += 1)n = t.v[s][0] + (i[0] - t.v[s][0]) * r, o = t.v[s][1] + (i[1] - t.v[s][1]) * r, h = t.o[s][0] + (i[0] - t.o[s][0]) * -r, l = t.o[s][1] + (i[1] - t.o[s][1]) * -r, p = t.i[s][0] + (i[0] - t.i[s][0]) * -r, f = t.i[s][1] + (i[1] - t.i[s][1]) * -r, c.setTripleAt(n, o, h, l, p, f, s);
            return c;
        }, PuckerAndBloatModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amount.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var TransformPropertyFactory = function() {
            var t = [
                0,
                0
            ];
            function e(t, e, r) {
                if (this.elem = t, this.frameId = -1, this.propType = "transform", this.data = e, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(r || t), e.p && e.p.s ? (this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this), e.p.z && (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t, e.p || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), e.rx) {
                    if (this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this), e.or.k[0].ti) {
                        var i, a = e.or.k.length;
                        for(i = 0; i < a; i += 1)e.or.k[i].to = null, e.or.k[i].ti = null;
                    }
                    this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this), this.or.sh = !0;
                } else this.r = PropertyFactory.getProp(t, e.r || {
                    k: 0
                }, 0, degToRads, this);
                e.sk && (this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t, e.a || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s || {
                    k: [
                        100,
                        100,
                        100
                    ]
                }, 1, .01, this), e.o ? this.o = PropertyFactory.getProp(t, e.o, 0, .01, t) : this.o = {
                    _mdf: !1,
                    v: 1
                }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
            }
            return e.prototype = {
                applyToMatrix: function(t) {
                    var e = this._mdf;
                    this.iterateDynamicProperties(), this._mdf = this._mdf || e, this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                },
                getValue: function(e) {
                    if (this.elem.globalData.frameId !== this.frameId) {
                        if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e) {
                            var r;
                            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                var i, a;
                                if (r = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (i = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / r, 0), a = this.p.getValueAtTime(this.p.keyframes[0].t / r, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (i = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r, 0), a = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / r, 0)) : (i = this.p.pv, a = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / r, this.p.offsetTime));
                                else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                    i = [], a = [];
                                    var s = this.px, n = this.py;
                                    s._caching.lastFrame + s.offsetTime <= s.keyframes[0].t ? (i[0] = s.getValueAtTime((s.keyframes[0].t + .01) / r, 0), i[1] = n.getValueAtTime((n.keyframes[0].t + .01) / r, 0), a[0] = s.getValueAtTime(s.keyframes[0].t / r, 0), a[1] = n.getValueAtTime(n.keyframes[0].t / r, 0)) : s._caching.lastFrame + s.offsetTime >= s.keyframes[s.keyframes.length - 1].t ? (i[0] = s.getValueAtTime(s.keyframes[s.keyframes.length - 1].t / r, 0), i[1] = n.getValueAtTime(n.keyframes[n.keyframes.length - 1].t / r, 0), a[0] = s.getValueAtTime((s.keyframes[s.keyframes.length - 1].t - .01) / r, 0), a[1] = n.getValueAtTime((n.keyframes[n.keyframes.length - 1].t - .01) / r, 0)) : (i = [
                                        s.pv,
                                        n.pv
                                    ], a[0] = s.getValueAtTime((s._caching.lastFrame + s.offsetTime - .01) / r, s.offsetTime), a[1] = n.getValueAtTime((n._caching.lastFrame + n.offsetTime - .01) / r, n.offsetTime));
                                } else i = a = t;
                                this.v.rotate(-Math.atan2(i[1] - a[1], i[0] - a[0]));
                            }
                            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                    }
                },
                precalculateMatrix: function() {
                    if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                        if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                        }
                        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                    }
                },
                autoOrient: function() {}
            }, extendPrototype([
                DynamicPropertyContainer
            ], e), e.prototype.addDynamicProperty = function(t) {
                this._addDynamicProperty(t), this.elem.addDynamicProperty(t), this._isDirty = !0;
            }, e.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
                getTransformProperty: function(t, r, i) {
                    return new e(t, r, i);
                }
            };
        }();
        function RepeaterModifier() {}
        function RoundCornersModifier() {}
        function floatEqual(t, e) {
            return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
        }
        function floatZero(t) {
            return Math.abs(t) <= 1e-5;
        }
        function lerp(t, e, r) {
            return t * (1 - r) + e * r;
        }
        function lerpPoint(t, e, r) {
            return [
                lerp(t[0], e[0], r),
                lerp(t[1], e[1], r)
            ];
        }
        function quadRoots(t, e, r) {
            if (0 === t) return [];
            var i = e * e - 4 * t * r;
            if (i < 0) return [];
            var a = -e / (2 * t);
            if (0 === i) return [
                a
            ];
            var s = Math.sqrt(i) / (2 * t);
            return [
                a - s,
                a + s
            ];
        }
        function polynomialCoefficients(t, e, r, i) {
            return [
                3 * e - t - 3 * r + i,
                3 * t - 6 * e + 3 * r,
                -3 * t + 3 * e,
                t
            ];
        }
        function singlePoint(t) {
            return new PolynomialBezier(t, t, t, t, !1);
        }
        function PolynomialBezier(t, e, r, i, a) {
            a && pointEqual(t, e) && (e = lerpPoint(t, i, 1 / 3)), a && pointEqual(r, i) && (r = lerpPoint(t, i, 2 / 3));
            var s = polynomialCoefficients(t[0], e[0], r[0], i[0]), n = polynomialCoefficients(t[1], e[1], r[1], i[1]);
            this.a = [
                s[0],
                n[0]
            ], this.b = [
                s[1],
                n[1]
            ], this.c = [
                s[2],
                n[2]
            ], this.d = [
                s[3],
                n[3]
            ], this.points = [
                t,
                e,
                r,
                i
            ];
        }
        function extrema(t, e) {
            var r = t.points[0][e], i = t.points[t.points.length - 1][e];
            if (r > i) {
                var a = i;
                i = r, r = a;
            }
            for(var s = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), n = 0; n < s.length; n += 1)if (s[n] > 0 && s[n] < 1) {
                var o = t.point(s[n])[e];
                o < r ? r = o : o > i && (i = o);
            }
            return {
                min: r,
                max: i
            };
        }
        function intersectData(t, e, r) {
            var i = t.boundingBox();
            return {
                cx: i.cx,
                cy: i.cy,
                width: i.width,
                height: i.height,
                bez: t,
                t: (e + r) / 2,
                t1: e,
                t2: r
            };
        }
        function splitData(t) {
            var e = t.bez.split(.5);
            return [
                intersectData(e[0], t.t1, t.t),
                intersectData(e[1], t.t, t.t2)
            ];
        }
        function boxIntersect(t, e) {
            return 2 * Math.abs(t.cx - e.cx) < t.width + e.width && 2 * Math.abs(t.cy - e.cy) < t.height + e.height;
        }
        function intersectsImpl(t, e, r, i, a, s) {
            if (boxIntersect(t, e)) {
                if (r >= s || t.width <= i && t.height <= i && e.width <= i && e.height <= i) a.push([
                    t.t,
                    e.t
                ]);
                else {
                    var n = splitData(t), o = splitData(e);
                    intersectsImpl(n[0], o[0], r + 1, i, a, s), intersectsImpl(n[0], o[1], r + 1, i, a, s), intersectsImpl(n[1], o[0], r + 1, i, a, s), intersectsImpl(n[1], o[1], r + 1, i, a, s);
                }
            }
        }
        function crossProduct(t, e) {
            return [
                t[1] * e[2] - t[2] * e[1],
                t[2] * e[0] - t[0] * e[2],
                t[0] * e[1] - t[1] * e[0]
            ];
        }
        function lineIntersection(t, e, r, i) {
            var a = [
                t[0],
                t[1],
                1
            ], s = [
                e[0],
                e[1],
                1
            ], n = [
                r[0],
                r[1],
                1
            ], o = [
                i[0],
                i[1],
                1
            ], h = crossProduct(crossProduct(a, s), crossProduct(n, o));
            return floatZero(h[2]) ? null : [
                h[0] / h[2],
                h[1] / h[2]
            ];
        }
        function polarOffset(t, e, r) {
            return [
                t[0] + Math.cos(e) * r,
                t[1] - Math.sin(e) * r
            ];
        }
        function pointDistance(t, e) {
            return Math.hypot(t[0] - e[0], t[1] - e[1]);
        }
        function pointEqual(t, e) {
            return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
        }
        function ZigZagModifier() {}
        function setPoint(t, e, r, i, a, s, n) {
            var o = r - Math.PI / 2, h = r + Math.PI / 2, l = e[0] + Math.cos(r) * i * a, p = e[1] - Math.sin(r) * i * a;
            t.setTripleAt(l, p, l + Math.cos(o) * s, p - Math.sin(o) * s, l + Math.cos(h) * n, p - Math.sin(h) * n, t.length());
        }
        function getPerpendicularVector(t, e) {
            var r = [
                e[0] - t[0],
                e[1] - t[1]
            ], i = .5 * -Math.PI;
            return [
                Math.cos(i) * r[0] - Math.sin(i) * r[1],
                Math.sin(i) * r[0] + Math.cos(i) * r[1]
            ];
        }
        function getProjectingAngle(t, e) {
            var r = 0 === e ? t.length() - 1 : e - 1, i = (e + 1) % t.length(), a = getPerpendicularVector(t.v[r], t.v[i]);
            return Math.atan2(0, 1) - Math.atan2(a[1], a[0]);
        }
        function zigZagCorner(t, e, r, i, a, s, n) {
            var o = getProjectingAngle(e, r), h = e.v[r % e._length], l = e.v[0 === r ? e._length - 1 : r - 1], p = e.v[(r + 1) % e._length], f = 2 === s ? Math.sqrt(Math.pow(h[0] - l[0], 2) + Math.pow(h[1] - l[1], 2)) : 0, c = 2 === s ? Math.sqrt(Math.pow(h[0] - p[0], 2) + Math.pow(h[1] - p[1], 2)) : 0;
            setPoint(t, e.v[r % e._length], o, n, i, c / (2 * (a + 1)), f / (2 * (a + 1)), s);
        }
        function zigZagSegment(t, e, r, i, a, s) {
            for(var n = 0; n < i; n += 1){
                var o = (n + 1) / (i + 1), h = 2 === a ? Math.sqrt(Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2)) : 0, l = e.normalAngle(o);
                setPoint(t, e.point(o), l, s, r, h / (2 * (i + 1)), h / (2 * (i + 1)), a), s = -s;
            }
            return s;
        }
        function linearOffset(t, e, r) {
            var i = Math.atan2(e[0] - t[0], e[1] - t[1]);
            return [
                polarOffset(t, i, r),
                polarOffset(e, i, r)
            ];
        }
        function offsetSegment(t, e) {
            var r, i, a, s, n, o, h;
            r = (h = linearOffset(t.points[0], t.points[1], e))[0], i = h[1], a = (h = linearOffset(t.points[1], t.points[2], e))[0], s = h[1], n = (h = linearOffset(t.points[2], t.points[3], e))[0], o = h[1];
            var l = lineIntersection(r, i, a, s);
            null === l && (l = i);
            var p = lineIntersection(n, o, a, s);
            return null === p && (p = n), new PolynomialBezier(r, l, p, o);
        }
        function joinLines(t, e, r, i, a) {
            var s = e.points[3], n = r.points[0];
            if (3 === i) return s;
            if (pointEqual(s, n)) return s;
            if (2 === i) {
                var o = -e.tangentAngle(1), h = -r.tangentAngle(0) + Math.PI, l = lineIntersection(s, polarOffset(s, o + Math.PI / 2, 100), n, polarOffset(n, o + Math.PI / 2, 100)), p = l ? pointDistance(l, s) : pointDistance(s, n) / 2, f = polarOffset(s, o, 2 * p * roundCorner);
                return t.setXYAt(f[0], f[1], "o", t.length() - 1), f = polarOffset(n, h, 2 * p * roundCorner), t.setTripleAt(n[0], n[1], n[0], n[1], f[0], f[1], t.length()), n;
            }
            var c = lineIntersection(pointEqual(s, e.points[2]) ? e.points[0] : e.points[2], s, n, pointEqual(n, r.points[1]) ? r.points[3] : r.points[1]);
            return c && pointDistance(c, s) < a ? (t.setTripleAt(c[0], c[1], c[0], c[1], c[0], c[1], t.length()), c) : s;
        }
        function getIntersection(t, e) {
            var r = t.intersections(e);
            return r.length && floatEqual(r[0][0], 1) && r.shift(), r.length ? r[0] : null;
        }
        function pruneSegmentIntersection(t, e) {
            var r = t.slice(), i = e.slice(), a = getIntersection(t[t.length - 1], e[0]);
            return a && (r[t.length - 1] = t[t.length - 1].split(a[0])[0], i[0] = e[0].split(a[1])[1]), t.length > 1 && e.length > 1 && (a = getIntersection(t[0], e[e.length - 1])) ? [
                [
                    t[0].split(a[0])[0]
                ],
                [
                    e[e.length - 1].split(a[1])[1]
                ]
            ] : [
                r,
                i
            ];
        }
        function pruneIntersections(t) {
            for(var e, r = 1; r < t.length; r += 1)e = pruneSegmentIntersection(t[r - 1], t[r]), t[r - 1] = e[0], t[r] = e[1];
            return t.length > 1 && (e = pruneSegmentIntersection(t[t.length - 1], t[0]), t[t.length - 1] = e[0], t[0] = e[1]), t;
        }
        function offsetSegmentSplit(t, e) {
            var r, i, a, s, n = t.inflectionPoints();
            if (0 === n.length) return [
                offsetSegment(t, e)
            ];
            if (1 === n.length || floatEqual(n[1], 1)) return r = (a = t.split(n[0]))[0], i = a[1], [
                offsetSegment(r, e),
                offsetSegment(i, e)
            ];
            r = (a = t.split(n[0]))[0];
            var o = (n[1] - n[0]) / (1 - n[0]);
            return s = (a = a[1].split(o))[0], i = a[1], [
                offsetSegment(r, e),
                offsetSegment(s, e),
                offsetSegment(i, e)
            ];
        }
        function OffsetPathModifier() {}
        function getFontProperties(t) {
            for(var e = t.fStyle ? t.fStyle.split(" ") : [], r = "normal", i = "normal", a = e.length, s = 0; s < a; s += 1)switch(e[s].toLowerCase()){
                case "italic":
                    i = "italic";
                    break;
                case "bold":
                    r = "700";
                    break;
                case "black":
                    r = "900";
                    break;
                case "medium":
                    r = "500";
                    break;
                case "regular":
                case "normal":
                    r = "400";
                    break;
                case "light":
                case "thin":
                    r = "200";
            }
            return {
                style: i,
                weight: t.fWeight || r
            };
        }
        extendPrototype([
            ShapeModifier
        ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t, e.c, 0, null, this), this.o = PropertyFactory.getProp(t, e.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this), this.so = PropertyFactory.getProp(t, e.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, .01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
        }, RepeaterModifier.prototype.applyTransforms = function(t, e, r, i, a, s) {
            var n = s ? -1 : 1, o = i.s.v[0] + (1 - i.s.v[0]) * (1 - a), h = i.s.v[1] + (1 - i.s.v[1]) * (1 - a);
            t.translate(i.p.v[0] * n * a, i.p.v[1] * n * a, i.p.v[2]), e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), e.rotate(-i.r.v * n * a), e.translate(i.a.v[0], i.a.v[1], i.a.v[2]), r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), r.scale(s ? 1 / o : o, s ? 1 / h : h), r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
        }, RepeaterModifier.prototype.init = function(t, e, r, i) {
            for(this.elem = t, this.arr = e, this.pos = r, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[r]); r > 0;)r -= 1, this._elements.unshift(e[r]);
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, RepeaterModifier.prototype.resetElements = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it);
        }, RepeaterModifier.prototype.cloneElements = function(t) {
            var e = JSON.parse(JSON.stringify(t));
            return this.resetElements(e), e;
        }, RepeaterModifier.prototype.changeGroupRender = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)t[r]._render = e, "gr" === t[r].ty && this.changeGroupRender(t[r].it, e);
        }, RepeaterModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n = !1;
            if (this._mdf || t) {
                var o, h = Math.ceil(this.c.v);
                if (this._groups.length < h) {
                    for(; this._groups.length < h;){
                        var l = {
                            it: this.cloneElements(this._elements),
                            ty: "gr"
                        };
                        l.it.push({
                            a: {
                                a: 0,
                                ix: 1,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            nm: "Transform",
                            o: {
                                a: 0,
                                ix: 7,
                                k: 100
                            },
                            p: {
                                a: 0,
                                ix: 2,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            r: {
                                a: 1,
                                ix: 6,
                                k: [
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 0
                                    },
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 1
                                    }
                                ]
                            },
                            s: {
                                a: 0,
                                ix: 3,
                                k: [
                                    100,
                                    100
                                ]
                            },
                            sa: {
                                a: 0,
                                ix: 5,
                                k: 0
                            },
                            sk: {
                                a: 0,
                                ix: 4,
                                k: 0
                            },
                            ty: "tr"
                        }), this.arr.splice(0, 0, l), this._groups.splice(0, 0, l), this._currentCopies += 1;
                    }
                    this.elem.reloadShapes(), n = !0;
                }
                for(s = 0, i = 0; i <= this._groups.length - 1; i += 1){
                    if (o = s < h, this._groups[i]._render = o, this.changeGroupRender(this._groups[i].it, o), !o) {
                        var p = this.elemsData[i].it, f = p[p.length - 1];
                        0 !== f.transform.op.v ? (f.transform.op._mdf = !0, f.transform.op.v = 0) : f.transform.op._mdf = !1;
                    }
                    s += 1;
                }
                this._currentCopies = h;
                var c = this.o.v, m = c % 1, d = c > 0 ? Math.floor(c) : Math.ceil(c), u = this.pMatrix.props, y = this.rMatrix.props, g = this.sMatrix.props;
                this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                var v, b, x = 0;
                if (c > 0) {
                    for(; x < d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), x += 1;
                    m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, m, !1), x += m);
                } else if (c < 0) {
                    for(; x > d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), x -= 1;
                    m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -m, !0), x -= m);
                }
                for(i = 1 === this.data.m ? 0 : this._currentCopies - 1, a = 1 === this.data.m ? 1 : -1, s = this._currentCopies; s;){
                    if (b = (r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)), 0 !== x) {
                        for((0 !== i && 1 === a || i !== this._currentCopies - 1 && -1 === a) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), this.matrix.transform(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7], u[8], u[9], u[10], u[11], u[12], u[13], u[14], u[15]), v = 0; v < b; v += 1)r[v] = this.matrix.props[v];
                        this.matrix.reset();
                    } else for(this.matrix.reset(), v = 0; v < b; v += 1)r[v] = this.matrix.props[v];
                    x += 1, s -= 1, i += a;
                }
            } else for(s = this._currentCopies, i = 0, a = 1; s;)r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, s -= 1, i += a;
            return n;
        }, RepeaterModifier.prototype.addShape = function() {}, extendPrototype([
            ShapeModifier
        ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
        }, RoundCornersModifier.prototype.processPath = function(t, e) {
            var r, i = shapePool.newElement();
            i.c = t.c;
            var a, s, n, o, h, l, p, f, c, m, d, u, y = t._length, g = 0;
            for(r = 0; r < y; r += 1)a = t.v[r], n = t.o[r], s = t.i[r], a[0] === n[0] && a[1] === n[1] && a[0] === s[0] && a[1] === s[1] ? 0 !== r && r !== y - 1 || t.c ? (o = 0 === r ? t.v[y - 1] : t.v[r - 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = d = a[0] + (o[0] - a[0]) * l, f = u = a[1] - (a[1] - o[1]) * l, c = p - (p - a[0]) * roundCorner, m = f - (f - a[1]) * roundCorner, i.setTripleAt(p, f, c, m, d, u, g), g += 1, o = r === y - 1 ? t.v[0] : t.v[r + 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = c = a[0] + (o[0] - a[0]) * l, f = m = a[1] + (o[1] - a[1]) * l, d = p - (p - a[0]) * roundCorner, u = f - (f - a[1]) * roundCorner, i.setTripleAt(p, f, c, m, d, u, g), g += 1) : (i.setTripleAt(a[0], a[1], n[0], n[1], s[0], s[1], g), g += 1) : (i.setTripleAt(t.v[r][0], t.v[r][1], t.o[r][0], t.o[r][1], t.i[r][0], t.i[r][1], g), g += 1);
            return i;
        }, RoundCornersModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.rd.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, PolynomialBezier.prototype.point = function(t) {
            return [
                ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
                ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
            ];
        }, PolynomialBezier.prototype.derivative = function(t) {
            return [
                (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
                (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
            ];
        }, PolynomialBezier.prototype.tangentAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[1], e[0]);
        }, PolynomialBezier.prototype.normalAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[0], e[1]);
        }, PolynomialBezier.prototype.inflectionPoints = function() {
            var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(t)) return [];
            var e = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t, r = e * e - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
            if (r < 0) return [];
            var i = Math.sqrt(r);
            return floatZero(i) ? i > 0 && i < 1 ? [
                e
            ] : [] : [
                e - i,
                e + i
            ].filter(function(t) {
                return t > 0 && t < 1;
            });
        }, PolynomialBezier.prototype.split = function(t) {
            if (t <= 0) return [
                singlePoint(this.points[0]),
                this
            ];
            if (t >= 1) return [
                this,
                singlePoint(this.points[this.points.length - 1])
            ];
            var e = lerpPoint(this.points[0], this.points[1], t), r = lerpPoint(this.points[1], this.points[2], t), i = lerpPoint(this.points[2], this.points[3], t), a = lerpPoint(e, r, t), s = lerpPoint(r, i, t), n = lerpPoint(a, s, t);
            return [
                new PolynomialBezier(this.points[0], e, a, n, !0),
                new PolynomialBezier(n, s, i, this.points[3], !0)
            ];
        }, PolynomialBezier.prototype.bounds = function() {
            return {
                x: extrema(this, 0),
                y: extrema(this, 1)
            };
        }, PolynomialBezier.prototype.boundingBox = function() {
            var t = this.bounds();
            return {
                left: t.x.min,
                right: t.x.max,
                top: t.y.min,
                bottom: t.y.max,
                width: t.x.max - t.x.min,
                height: t.y.max - t.y.min,
                cx: (t.x.max + t.x.min) / 2,
                cy: (t.y.max + t.y.min) / 2
            };
        }, PolynomialBezier.prototype.intersections = function(t, e, r) {
            void 0 === e && (e = 2), void 0 === r && (r = 7);
            var i = [];
            return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, i, r), i;
        }, PolynomialBezier.shapeSegment = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[e], t.o[e], t.i[r], t.v[r], !0);
        }, PolynomialBezier.shapeSegmentInverted = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[r], t.i[r], t.o[e], t.v[e], !0);
        }, extendPrototype([
            ShapeModifier
        ], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this), this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this), this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length;
        }, ZigZagModifier.prototype.processPath = function(t, e, r, i) {
            var a = t._length, s = shapePool.newElement();
            if (s.c = t.c, t.c || (a -= 1), 0 === a) return s;
            var n = -1, o = PolynomialBezier.shapeSegment(t, 0);
            zigZagCorner(s, t, 0, e, r, i, n);
            for(var h = 0; h < a; h += 1)n = zigZagSegment(s, o, e, r, i, -n), o = h !== a - 1 || t.c ? PolynomialBezier.shapeSegment(t, (h + 1) % a) : null, zigZagCorner(s, t, h + 1, e, r, i, n);
            return s;
        }, ZigZagModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), p = this.pointsType.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h, l, p));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, extendPrototype([
            ShapeModifier
        ], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this), this.lineJoin = e.lj, this._isAnimated = 0 !== this.amount.effectsSequence.length;
        }, OffsetPathModifier.prototype.processPath = function(t, e, r, i) {
            var a = shapePool.newElement();
            a.c = t.c;
            var s, n, o, h = t.length();
            t.c || (h -= 1);
            var l = [];
            for(s = 0; s < h; s += 1)o = PolynomialBezier.shapeSegment(t, s), l.push(offsetSegmentSplit(o, e));
            if (!t.c) for(s = h - 1; s >= 0; s -= 1)o = PolynomialBezier.shapeSegmentInverted(t, s), l.push(offsetSegmentSplit(o, e));
            l = pruneIntersections(l);
            var p = null, f = null;
            for(s = 0; s < l.length; s += 1){
                var c = l[s];
                for(f && (p = joinLines(a, f, c[0], r, i)), f = c[c.length - 1], n = 0; n < c.length; n += 1)o = c[n], p && pointEqual(o.points[0], p) ? a.setXYAt(o.points[1][0], o.points[1][1], "o", a.length() - 1) : a.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], a.length()), a.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], a.length()), p = o.points[3];
            }
            return l.length && joinLines(a, f, l[0][0], r, i), a;
        }, OffsetPathModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amount.v, l = this.miterLimit.v, p = this.lineJoin;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h, p, l));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var FontManager = function() {
            var t = {
                w: 0,
                size: 0,
                shapes: [],
                data: {
                    shapes: []
                }
            }, e = [];
            e = e.concat([
                2304,
                2305,
                2306,
                2307,
                2362,
                2363,
                2364,
                2364,
                2366,
                2367,
                2368,
                2369,
                2370,
                2371,
                2372,
                2373,
                2374,
                2375,
                2376,
                2377,
                2378,
                2379,
                2380,
                2381,
                2382,
                2383,
                2387,
                2388,
                2389,
                2390,
                2391,
                2402,
                2403
            ]);
            var r = [
                "d83cdffb",
                "d83cdffc",
                "d83cdffd",
                "d83cdffe",
                "d83cdfff"
            ], i = [
                65039,
                8205
            ];
            function a(t, e) {
                var r = createTag("span");
                r.setAttribute("aria-hidden", !0), r.style.fontFamily = e;
                var i = createTag("span");
                i.innerText = "giItT1WQy@!-/#", r.style.position = "absolute", r.style.left = "-10000px", r.style.top = "-10000px", r.style.fontSize = "300px", r.style.fontVariant = "normal", r.style.fontStyle = "normal", r.style.fontWeight = "normal", r.style.letterSpacing = "0", r.appendChild(i), document.body.appendChild(r);
                var a = i.offsetWidth;
                return i.style.fontFamily = function(t) {
                    var e, r = t.split(","), i = r.length, a = [];
                    for(e = 0; e < i; e += 1)"sans-serif" !== r[e] && "monospace" !== r[e] && a.push(r[e]);
                    return a.join(",");
                }(t) + ", " + e, {
                    node: i,
                    w: a,
                    parent: r
                };
            }
            function s(t, e) {
                var r, i = document.body && e ? "svg" : "canvas", a = getFontProperties(t);
                if ("svg" === i) {
                    var s = createNS("text");
                    s.style.fontSize = "100px", s.setAttribute("font-family", t.fFamily), s.setAttribute("font-style", a.style), s.setAttribute("font-weight", a.weight), s.textContent = "1", t.fClass ? (s.style.fontFamily = "inherit", s.setAttribute("class", t.fClass)) : s.style.fontFamily = t.fFamily, e.appendChild(s), r = s;
                } else {
                    var n = new OffscreenCanvas(500, 500).getContext("2d");
                    n.font = a.style + " " + a.weight + " 100px " + t.fFamily, r = n;
                }
                return {
                    measureText: function(t) {
                        return "svg" === i ? (r.textContent = t, r.getComputedTextLength()) : r.measureText(t).width;
                    }
                };
            }
            var n = function() {
                this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
            };
            return n.isModifier = function(t, e) {
                var i = t.toString(16) + e.toString(16);
                return -1 !== r.indexOf(i);
            }, n.isZeroWidthJoiner = function(t, e) {
                return e ? t === i[0] && e === i[1] : t === i[1];
            }, n.isCombinedCharacter = function(t) {
                return -1 !== e.indexOf(t);
            }, n.prototype = {
                addChars: function(t) {
                    if (t) {
                        var e;
                        this.chars || (this.chars = []);
                        var r, i, a = t.length, s = this.chars.length;
                        for(e = 0; e < a; e += 1){
                            for(r = 0, i = !1; r < s;)this.chars[r].style === t[e].style && this.chars[r].fFamily === t[e].fFamily && this.chars[r].ch === t[e].ch && (i = !0), r += 1;
                            i || (this.chars.push(t[e]), s += 1);
                        }
                    }
                },
                addFonts: function(t, e) {
                    if (t) {
                        if (this.chars) return this.isLoaded = !0, void (this.fonts = t.list);
                        if (!document.body) return this.isLoaded = !0, t.list.forEach(function(t) {
                            t.helper = s(t), t.cache = {};
                        }), void (this.fonts = t.list);
                        var r, i = t.list, n = i.length, o = n;
                        for(r = 0; r < n; r += 1){
                            var h, l, p = !0;
                            if (i[r].loaded = !1, i[r].monoCase = a(i[r].fFamily, "monospace"), i[r].sansCase = a(i[r].fFamily, "sans-serif"), i[r].fPath) {
                                if ("p" === i[r].fOrigin || 3 === i[r].origin) {
                                    if ((h = document.querySelectorAll('style[f-forigin="p"][f-family="' + i[r].fFamily + '"], style[f-origin="3"][f-family="' + i[r].fFamily + '"]')).length > 0 && (p = !1), p) {
                                        var f = createTag("style");
                                        f.setAttribute("f-forigin", i[r].fOrigin), f.setAttribute("f-origin", i[r].origin), f.setAttribute("f-family", i[r].fFamily), f.type = "text/css", f.innerText = "@font-face {font-family: " + i[r].fFamily + "; font-style: normal; src: url('" + i[r].fPath + "');}", e.appendChild(f);
                                    }
                                } else if ("g" === i[r].fOrigin || 1 === i[r].origin) {
                                    for(h = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l = 0; l < h.length; l += 1)-1 !== h[l].href.indexOf(i[r].fPath) && (p = !1);
                                    if (p) {
                                        var c = createTag("link");
                                        c.setAttribute("f-forigin", i[r].fOrigin), c.setAttribute("f-origin", i[r].origin), c.type = "text/css", c.rel = "stylesheet", c.href = i[r].fPath, document.body.appendChild(c);
                                    }
                                } else if ("t" === i[r].fOrigin || 2 === i[r].origin) {
                                    for(h = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l = 0; l < h.length; l += 1)i[r].fPath === h[l].src && (p = !1);
                                    if (p) {
                                        var m = createTag("link");
                                        m.setAttribute("f-forigin", i[r].fOrigin), m.setAttribute("f-origin", i[r].origin), m.setAttribute("rel", "stylesheet"), m.setAttribute("href", i[r].fPath), e.appendChild(m);
                                    }
                                }
                            } else i[r].loaded = !0, o -= 1;
                            i[r].helper = s(i[r], e), i[r].cache = {}, this.fonts.push(i[r]);
                        }
                        0 === o ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                    } else this.isLoaded = !0;
                },
                getCharData: function(e, r, i) {
                    for(var a = 0, s = this.chars.length; a < s;){
                        if (this.chars[a].ch === e && this.chars[a].style === r && this.chars[a].fFamily === i) return this.chars[a];
                        a += 1;
                    }
                    return ("string" == typeof e && 13 !== e.charCodeAt(0) || !e) && console && console.warn && !this._warned && (this._warned = !0), t;
                },
                getFontByName: function(t) {
                    for(var e = 0, r = this.fonts.length; e < r;){
                        if (this.fonts[e].fName === t) return this.fonts[e];
                        e += 1;
                    }
                    return this.fonts[0];
                },
                measureText: function(t, e, r) {
                    var i = this.getFontByName(e), a = t.charCodeAt(0);
                    if (!i.cache[a + 1]) {
                        var s = i.helper;
                        if (" " === t) {
                            var n = s.measureText("|" + t + "|"), o = s.measureText("||");
                            i.cache[a + 1] = (n - o) / 100;
                        } else i.cache[a + 1] = s.measureText(t) / 100;
                    }
                    return i.cache[a + 1] * r;
                },
                checkLoadedFonts: function() {
                    var t, e, r, i = this.fonts.length, a = i;
                    for(t = 0; t < i; t += 1)this.fonts[t].loaded ? a -= 1 : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin ? this.fonts[t].loaded = !0 : (e = this.fonts[t].monoCase.node, r = this.fonts[t].monoCase.w, e.offsetWidth !== r ? (a -= 1, this.fonts[t].loaded = !0) : (e = this.fonts[t].sansCase.node, r = this.fonts[t].sansCase.w, e.offsetWidth !== r && (a -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
                    0 !== a && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                },
                setIsLoaded: function() {
                    this.isLoaded = !0;
                }
            }, n;
        }();
        function RenderableElement() {}
        RenderableElement.prototype = {
            initRenderable: function() {
                this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
            },
            addRenderableComponent: function(t) {
                -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
            },
            removeRenderableComponent: function(t) {
                -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
            },
            prepareRenderableFrame: function(t) {
                this.checkLayerLimits(t);
            },
            checkTransparency: function() {
                this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
            },
            checkLayerLimits: function(t) {
                this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
            },
            renderRenderable: function() {
                var t, e = this.renderableComponents.length;
                for(t = 0; t < e; t += 1)this.renderableComponents[t].renderFrame(this._isFirstFrame);
            },
            sourceRectAtTime: function() {
                return {
                    top: 0,
                    left: 0,
                    width: 100,
                    height: 100
                };
            },
            getLayerSize: function() {
                return 5 === this.data.ty ? {
                    w: this.data.textData.width,
                    h: this.data.textData.height
                } : {
                    w: this.data.width,
                    h: this.data.height
                };
            }
        };
        var getBlendMode = (blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        }, function(t) {
            return blendModeEnums[t] || "";
        }), blendModeEnums;
        function SliderEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function AngleEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function ColorEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
        }
        function PointEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
        }
        function LayerIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function MaskIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function CheckboxEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function NoValueEffect() {
            this.p = {};
        }
        function EffectsManager(t, e) {
            var r, i = t.ef || [];
            this.effectElements = [];
            var a, s = i.length;
            for(r = 0; r < s; r += 1)a = new GroupEffect(i[r], e), this.effectElements.push(a);
        }
        function GroupEffect(t, e) {
            this.init(t, e);
        }
        function BaseElement() {}
        function FrameElement() {}
        function FootageElement(t, e, r) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.footageData = e.imageLoader.getAsset(this.assetData), this.initBaseData(t, e, r);
        }
        function AudioElement(t, e, r) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, r), this._isPlaying = !1, this._canPlay = !1;
            var i = this.globalData.getAssetsPath(this.assetData);
            this.audio = this.globalData.audioController.createAudio(i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            }, this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : {
                k: [
                    100
                ]
            }, 1, .01, this);
        }
        function BaseRenderer() {}
        function TransformElement() {}
        function MaskElement(t, e, r) {
            this.data = t, this.element = e, this.globalData = r, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
            var i, a, s = this.globalData.defs, n = this.masksProperties ? this.masksProperties.length : 0;
            this.viewData = createSizedArray(n), this.solidPath = "";
            var o, h, l, p, f, c, m = this.masksProperties, d = 0, u = [], y = createElementID(), g = "clipPath", v = "clip-path";
            for(i = 0; i < n; i += 1)if (("a" !== m[i].mode && "n" !== m[i].mode || m[i].inv || 100 !== m[i].o.k || m[i].o.x) && (g = "mask", v = "mask"), "s" !== m[i].mode && "i" !== m[i].mode || 0 !== d ? l = null : ((l = createNS("rect")).setAttribute("fill", "#ffffff"), l.setAttribute("width", this.element.comp.data.w || 0), l.setAttribute("height", this.element.comp.data.h || 0), u.push(l)), a = createNS("path"), "n" === m[i].mode) this.viewData[i] = {
                op: PropertyFactory.getProp(this.element, m[i].o, 0, .01, this.element),
                prop: ShapePropertyFactory.getShapeProp(this.element, m[i], 3),
                elem: a,
                lastPath: ""
            }, s.appendChild(a);
            else {
                var b;
                if (d += 1, a.setAttribute("fill", "s" === m[i].mode ? "#000000" : "#ffffff"), a.setAttribute("clip-rule", "nonzero"), 0 !== m[i].x.k ? (g = "mask", v = "mask", c = PropertyFactory.getProp(this.element, m[i].x, 0, null, this.element), b = createElementID(), (p = createNS("filter")).setAttribute("id", b), (f = createNS("feMorphology")).setAttribute("operator", "erode"), f.setAttribute("in", "SourceGraphic"), f.setAttribute("radius", "0"), p.appendChild(f), s.appendChild(p), a.setAttribute("stroke", "s" === m[i].mode ? "#000000" : "#ffffff")) : (f = null, c = null), this.storedData[i] = {
                    elem: a,
                    x: c,
                    expan: f,
                    lastPath: "",
                    lastOperator: "",
                    filterId: b,
                    lastRadius: 0
                }, "i" === m[i].mode) {
                    h = u.length;
                    var x = createNS("g");
                    for(o = 0; o < h; o += 1)x.appendChild(u[o]);
                    var P = createNS("mask");
                    P.setAttribute("mask-type", "alpha"), P.setAttribute("id", y + "_" + d), P.appendChild(a), s.appendChild(P), x.setAttribute("mask", "url(" + getLocationHref() + "#" + y + "_" + d + ")"), u.length = 0, u.push(x);
                } else u.push(a);
                m[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i] = {
                    elem: a,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, m[i].o, 0, .01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, m[i], 3),
                    invRect: l
                }, this.viewData[i].prop.k || this.drawPath(m[i], this.viewData[i].prop.v, this.viewData[i]);
            }
            for(this.maskElement = createNS(g), n = u.length, i = 0; i < n; i += 1)this.maskElement.appendChild(u[i]);
            d > 0 && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute(v, "url(" + getLocationHref() + "#" + y + ")"), s.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
        }
        extendPrototype([
            DynamicPropertyContainer
        ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t, e) {
            var r;
            this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(e);
            var i, a = this.data.ef.length, s = this.data.ef;
            for(r = 0; r < a; r += 1){
                switch(i = null, s[r].ty){
                    case 0:
                        i = new SliderEffect(s[r], e, this);
                        break;
                    case 1:
                        i = new AngleEffect(s[r], e, this);
                        break;
                    case 2:
                        i = new ColorEffect(s[r], e, this);
                        break;
                    case 3:
                        i = new PointEffect(s[r], e, this);
                        break;
                    case 4:
                    case 7:
                        i = new CheckboxEffect(s[r], e, this);
                        break;
                    case 10:
                        i = new LayerIndexEffect(s[r], e, this);
                        break;
                    case 11:
                        i = new MaskIndexEffect(s[r], e, this);
                        break;
                    case 5:
                        i = new EffectsManager(s[r], e, this);
                        break;
                    default:
                        i = new NoValueEffect(s[r], e, this);
                }
                i && this.effectElements.push(i);
            }
        }, BaseElement.prototype = {
            checkMasks: function() {
                if (!this.data.hasMask) return !1;
                for(var t = 0, e = this.data.masksProperties.length; t < e;){
                    if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
                    t += 1;
                }
                return !1;
            },
            initExpressions: function() {
                var t = getExpressionInterfaces();
                if (t) {
                    var e = t("layer"), r = t("effects"), i = t("shape"), a = t("text"), s = t("comp");
                    this.layerInterface = e(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                    var n = r.createEffectsInterface(this, this.layerInterface);
                    this.layerInterface.registerEffectsInterface(n), 0 === this.data.ty || this.data.xt ? this.compInterface = s(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = i(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = a(this), this.layerInterface.text = this.layerInterface.textInterface);
                }
            },
            setBlendMode: function() {
                var t = getBlendMode(this.data.bm);
                (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
            },
            initBaseData: function(t, e, r) {
                this.globalData = e, this.comp = r, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
            },
            getType: function() {
                return this.type;
            },
            sourceRectAtTime: function() {}
        }, FrameElement.prototype = {
            initFrame: function() {
                this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
            },
            prepareProperties: function(t, e) {
                var r, i = this.dynamicProperties.length;
                for(r = 0; r < i; r += 1)(e || this._isParent && "transform" === this.dynamicProperties[r].propType) && (this.dynamicProperties[r].getValue(), this.dynamicProperties[r]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
            },
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
            }
        }, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], FootageElement), FootageElement.prototype.getBaseElement = function() {
            return null;
        }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
            var t = getExpressionInterfaces();
            if (t) {
                var e = t("footage");
                this.layerInterface = e(this);
            }
        }, FootageElement.prototype.getFootageData = function() {
            return this.footageData;
        }, AudioElement.prototype.prepareFrame = function(t) {
            if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;
            else {
                var e = this.tm.v;
                this._currentTime = e;
            }
            this._volume = this.lv.v[0];
            var r = this._volume * this._volumeMultiplier;
            this._previousVolume !== r && (this._previousVolume = r, this.audio.volume(r));
        }, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], AudioElement), AudioElement.prototype.renderFrame = function() {
            this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
        }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
            this.audio.pause(), this._isPlaying = !1;
        }, AudioElement.prototype.pause = function() {
            this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
        }, AudioElement.prototype.resume = function() {
            this._canPlay = !0;
        }, AudioElement.prototype.setRate = function(t) {
            this.audio.rate(t);
        }, AudioElement.prototype.volume = function(t) {
            this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
        }, AudioElement.prototype.getBaseElement = function() {
            return null;
        }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, BaseRenderer.prototype.checkLayers = function(t) {
            var e, r, i = this.layers.length;
            for(this.completeLayers = !0, e = i - 1; e >= 0; e -= 1)this.elements[e] || (r = this.layers[e]).ip - r.st <= t - this.layers[e].st && r.op - r.st > t - this.layers[e].st && this.buildItem(e), this.completeLayers = !!this.elements[e] && this.completeLayers;
            this.checkPendingElements();
        }, BaseRenderer.prototype.createItem = function(t) {
            switch(t.ty){
                case 2:
                    return this.createImage(t);
                case 0:
                    return this.createComp(t);
                case 1:
                    return this.createSolid(t);
                case 3:
                    return this.createNull(t);
                case 4:
                    return this.createShape(t);
                case 5:
                    return this.createText(t);
                case 6:
                    return this.createAudio(t);
                case 13:
                    return this.createCamera(t);
                case 15:
                    return this.createFootage(t);
                default:
                    return this.createNull(t);
            }
        }, BaseRenderer.prototype.createCamera = function() {
            throw new Error("You're using a 3d camera. Try the html renderer.");
        }, BaseRenderer.prototype.createAudio = function(t) {
            return new AudioElement(t, this.globalData, this);
        }, BaseRenderer.prototype.createFootage = function(t) {
            return new FootageElement(t, this.globalData, this);
        }, BaseRenderer.prototype.buildAllItems = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.buildItem(t);
            this.checkPendingElements();
        }, BaseRenderer.prototype.includeLayers = function(t) {
            var e;
            this.completeLayers = !1;
            var r, i = t.length, a = this.layers.length;
            for(e = 0; e < i; e += 1)for(r = 0; r < a;){
                if (this.layers[r].id === t[e].id) {
                    this.layers[r] = t[e];
                    break;
                }
                r += 1;
            }
        }, BaseRenderer.prototype.setProjectInterface = function(t) {
            this.globalData.projectInterface = t;
        }, BaseRenderer.prototype.initItems = function() {
            this.globalData.progressiveLoad || this.buildAllItems();
        }, BaseRenderer.prototype.buildElementParenting = function(t, e, r) {
            for(var i = this.elements, a = this.layers, s = 0, n = a.length; s < n;)a[s].ind == e && (i[s] && !0 !== i[s] ? (r.push(i[s]), i[s].setAsParent(), void 0 !== a[s].parent ? this.buildElementParenting(t, a[s].parent, r) : t.setHierarchy(r)) : (this.buildItem(s), this.addPendingElement(t))), s += 1;
        }, BaseRenderer.prototype.addPendingElement = function(t) {
            this.pendingElements.push(t);
        }, BaseRenderer.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)if (t[e].xt) {
                var i = this.createComp(t[e]);
                i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
            }
        }, BaseRenderer.prototype.getElementById = function(t) {
            var e, r = this.elements.length;
            for(e = 0; e < r; e += 1)if (this.elements[e].data.ind === t) return this.elements[e];
            return null;
        }, BaseRenderer.prototype.getElementByPath = function(t) {
            var e, r = t.shift();
            if ("number" == typeof r) e = this.elements[r];
            else {
                var i, a = this.elements.length;
                for(i = 0; i < a; i += 1)if (this.elements[i].data.nm === r) {
                    e = this.elements[i];
                    break;
                }
            }
            return 0 === t.length ? e : e.getElementByPath(t);
        }, BaseRenderer.prototype.setupGlobalData = function(t, e) {
            this.globalData.fontManager = new FontManager, this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
                w: t.w,
                h: t.h
            };
        }, TransformElement.prototype = {
            initTransform: function() {
                this.finalTransform = {
                    mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                        o: 0
                    },
                    _matMdf: !1,
                    _opMdf: !1,
                    mat: new Matrix
                }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
            },
            renderTransform: function() {
                if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                    var t, e = this.finalTransform.mat, r = 0, i = this.hierarchy.length;
                    if (!this.finalTransform._matMdf) for(; r < i;){
                        if (this.hierarchy[r].finalTransform.mProp._mdf) {
                            this.finalTransform._matMdf = !0;
                            break;
                        }
                        r += 1;
                    }
                    if (this.finalTransform._matMdf) for(t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), r = 0; r < i; r += 1)t = this.hierarchy[r].finalTransform.mProp.v.props, e.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
                }
            },
            globalToLocal: function(t) {
                var e = [];
                e.push(this.finalTransform);
                for(var r, i = !0, a = this.comp; i;)a.finalTransform ? (a.data.hasMask && e.splice(0, 0, a.finalTransform), a = a.comp) : i = !1;
                var s, n = e.length;
                for(r = 0; r < n; r += 1)s = e[r].mat.applyToPointArray(0, 0, 0), t = [
                    t[0] - s[0],
                    t[1] - s[1],
                    0
                ];
                return t;
            },
            mHelper: new Matrix
        }, MaskElement.prototype.getMaskProperty = function(t) {
            return this.viewData[t].prop;
        }, MaskElement.prototype.renderFrame = function(t) {
            var e, r = this.element.finalTransform.mat, i = this.masksProperties.length;
            for(e = 0; e < i; e += 1)if ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]), (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v), "n" !== this.masksProperties[e].mode && (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", r.getInverseMatrix().to2dCSS()), this.storedData[e].x && (this.storedData[e].x._mdf || t))) {
                var a = this.storedData[e].expan;
                this.storedData[e].x.v < 0 ? ("erode" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "erode", this.storedData[e].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e].filterId + ")")), a.setAttribute("radius", -this.storedData[e].x.v)) : ("dilate" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "dilate", this.storedData[e].elem.setAttribute("filter", null)), this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
            }
        }, MaskElement.prototype.getMaskelement = function() {
            return this.maskElement;
        }, MaskElement.prototype.createLayerSolidPath = function() {
            var t = "M0,0 ";
            return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
        }, MaskElement.prototype.drawPath = function(t, e, r) {
            var i, a, s = " M" + e.v[0][0] + "," + e.v[0][1];
            for(a = e._length, i = 1; i < a; i += 1)s += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[i][0] + "," + e.i[i][1] + " " + e.v[i][0] + "," + e.v[i][1];
            if (e.c && a > 1 && (s += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), r.lastPath !== s) {
                var n = "";
                r.elem && (e.c && (n = t.inv ? this.solidPath + s : s), r.elem.setAttribute("d", n)), r.lastPath = s;
            }
        }, MaskElement.prototype.destroy = function() {
            this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
        };
        var filtersFactory = function() {
            var t = {};
            return t.createFilter = function(t, e) {
                var r = createNS("filter");
                r.setAttribute("id", t), !0 !== e && (r.setAttribute("filterUnits", "objectBoundingBox"), r.setAttribute("x", "0%"), r.setAttribute("y", "0%"), r.setAttribute("width", "100%"), r.setAttribute("height", "100%"));
                return r;
            }, t.createAlphaToLuminanceFilter = function() {
                var t = createNS("feColorMatrix");
                return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
            }, t;
        }(), featureSupport = function() {
            var t = {
                maskType: !0,
                svgLumaHidden: !0,
                offscreenCanvas: "undefined" != typeof OffscreenCanvas
            };
            return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
        }(), registeredEffects = {}, idPrefix = "filter_result_";
        function SVGEffects(t) {
            var e, r, i = "SourceGraphic", a = t.data.ef ? t.data.ef.length : 0, s = createElementID(), n = filtersFactory.createFilter(s, !0), o = 0;
            for(this.filters = [], e = 0; e < a; e += 1){
                r = null;
                var h = t.data.ef[e].ty;
                if (registeredEffects[h]) r = new registeredEffects[h].effect(n, t.effectsManager.effectElements[e], t, idPrefix + o, i), i = idPrefix + o, registeredEffects[h].countsAsEffect && (o += 1);
                r && this.filters.push(r);
            }
            o && (t.globalData.defs.appendChild(n), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")")), this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect(t, e, r) {
            registeredEffects[t] = {
                effect: e,
                countsAsEffect: r
            };
        }
        function SVGBaseElement() {}
        function HierarchyElement() {}
        function RenderableDOMElement() {}
        function IImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.initElement(t, e, r), this.sourceRect = {
                top: 0,
                left: 0,
                width: this.assetData.w,
                height: this.assetData.h
            };
        }
        function ProcessedElement(t, e) {
            this.elem = t, this.pos = e;
        }
        function IShapeElement() {}
        SVGEffects.prototype.renderFrame = function(t) {
            var e, r = this.filters.length;
            for(e = 0; e < r; e += 1)this.filters[e].renderFrame(t);
        }, SVGBaseElement.prototype = {
            initRendererElement: function() {
                this.layerElement = createNS("g");
            },
            createContainerElements: function() {
                this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                var t = null;
                if (this.data.td) {
                    this.matteMasks = {};
                    var e = createNS("g");
                    e.setAttribute("id", this.layerId), e.appendChild(this.layerElement), t = e, this.globalData.defs.appendChild(e);
                } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                    var r = createNS("clipPath"), i = createNS("path");
                    i.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var a = createElementID();
                    if (r.setAttribute("id", a), r.appendChild(i), this.globalData.defs.appendChild(r), this.checkMasks()) {
                        var s = createNS("g");
                        s.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), s.appendChild(this.layerElement), this.transformedElement = s, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                    } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")");
                }
                0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
            },
            destroyBaseElement: function() {
                this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
            },
            getBaseElement: function() {
                return this.data.hd ? null : this.baseElement;
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this);
            },
            getMatte: function(t) {
                if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
                    var e, r, i, a, s = this.layerId + "_" + t;
                    if (1 === t || 3 === t) {
                        var n = createNS("mask");
                        n.setAttribute("id", s), n.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), n.appendChild(i), this.globalData.defs.appendChild(n), featureSupport.maskType || 1 !== t || (n.setAttribute("mask-type", "luminance"), e = createElementID(), r = filtersFactory.createFilter(e), this.globalData.defs.appendChild(r), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (a = createNS("g")).appendChild(i), n.appendChild(a), a.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"));
                    } else if (2 === t) {
                        var o = createNS("mask");
                        o.setAttribute("id", s), o.setAttribute("mask-type", "alpha");
                        var h = createNS("g");
                        o.appendChild(h), e = createElementID(), r = filtersFactory.createFilter(e);
                        var l = createNS("feComponentTransfer");
                        l.setAttribute("in", "SourceGraphic"), r.appendChild(l);
                        var p = createNS("feFuncA");
                        p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), l.appendChild(p), this.globalData.defs.appendChild(r);
                        var f = createNS("rect");
                        f.setAttribute("width", this.comp.data.w), f.setAttribute("height", this.comp.data.h), f.setAttribute("x", "0"), f.setAttribute("y", "0"), f.setAttribute("fill", "#ffffff"), f.setAttribute("opacity", "0"), h.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"), h.appendChild(f), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h.appendChild(i), featureSupport.maskType || (o.setAttribute("mask-type", "luminance"), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), a = createNS("g"), h.appendChild(f), a.appendChild(this.layerElement), h.appendChild(a)), this.globalData.defs.appendChild(o);
                    }
                    this.matteMasks[t] = s;
                }
                return this.matteMasks[t];
            },
            setMatte: function(t) {
                this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
            }
        }, HierarchyElement.prototype = {
            initHierarchy: function() {
                this.hierarchy = [], this._isParent = !1, this.checkParenting();
            },
            setHierarchy: function(t) {
                this.hierarchy = t;
            },
            setAsParent: function() {
                this._isParent = !0;
            },
            checkParenting: function() {
                void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
            }
        }, extendPrototype([
            RenderableElement,
            createProxyFunction({
                initElement: function(t, e, r) {
                    this.initFrame(), this.initBaseData(t, e, r), this.initTransform(t, e, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
                },
                hide: function() {
                    this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
                },
                show: function() {
                    this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
                },
                renderFrame: function() {
                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                },
                renderInnerContent: function() {},
                prepareFrame: function(t) {
                    this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
                },
                destroy: function() {
                    this.innerElem = null, this.destroyBaseElement();
                }
            })
        ], RenderableDOMElement), extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], IImageElement), IImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData);
            this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
        }, IImageElement.prototype.sourceRectAtTime = function() {
            return this.sourceRect;
        }, IShapeElement.prototype = {
            addShapeToModifiers: function(t) {
                var e, r = this.shapeModifiers.length;
                for(e = 0; e < r; e += 1)this.shapeModifiers[e].addShape(t);
            },
            isShapeInAnimatedModifiers: function(t) {
                for(var e = this.shapeModifiers.length; 0 < e;)if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                return !1;
            },
            renderModifiers: function() {
                if (this.shapeModifiers.length) {
                    var t, e = this.shapes.length;
                    for(t = 0; t < e; t += 1)this.shapes[t].sh.reset();
                    for(t = (e = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
                }
            },
            searchProcessedElement: function(t) {
                for(var e = this.processedElements, r = 0, i = e.length; r < i;){
                    if (e[r].elem === t) return e[r].pos;
                    r += 1;
                }
                return 0;
            },
            addProcessedElement: function(t, e) {
                for(var r = this.processedElements, i = r.length; i;)if (r[i -= 1].elem === t) return void (r[i].pos = e);
                r.push(new ProcessedElement(t, e));
            },
            prepareFrame: function(t) {
                this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
            }
        };
        var lineCapEnum = {
            1: "butt",
            2: "round",
            3: "square"
        }, lineJoinEnum = {
            1: "miter",
            2: "round",
            3: "bevel"
        };
        function SVGShapeData(t, e, r) {
            this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = r, this.lvl = e, this._isAnimated = !!r.k;
            for(var i = 0, a = t.length; i < a;){
                if (t[i].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break;
                }
                i += 1;
            }
        }
        function SVGStyleData(t, e) {
            this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = !0 === t.hd, this.pElem = createNS("path"), this.msElem = null;
        }
        function DashProperty(t, e, r, i) {
            var a;
            this.elem = t, this.frameId = -1, this.dataProps = createSizedArray(e.length), this.renderer = r, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e.length ? e.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i);
            var s, n = e.length || 0;
            for(a = 0; a < n; a += 1)s = PropertyFactory.getProp(t, e[a].v, 0, 0, this), this.k = s.k || this.k, this.dataProps[a] = {
                n: e[a].n,
                p: s
            };
            this.k || this.getValue(!0), this._isAnimated = this.k;
        }
        function SVGStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r, this._isAnimated = !!this._isAnimated;
        }
        function SVGFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r;
        }
        function SVGNoStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = r;
        }
        function GradientProperty(t, e, r) {
            this.data = e, this.c = createTypedArray("uint8c", 4 * e.p);
            var i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
            this.o = createTypedArray("float32", i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i, this.initDynamicPropertyContainer(r), this.prop = PropertyFactory.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
        }
        function SVGGradientFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, r);
        }
        function SVGGradientStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.initGradientData(t, e, r), this._isAnimated = !!this._isAnimated;
        }
        function ShapeGroupData() {
            this.it = [], this.prevViewData = [], this.gr = createNS("g");
        }
        function SVGTransformData(t, e, r) {
            this.transform = {
                mProps: t,
                op: e,
                container: r
            }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
        }
        SVGShapeData.prototype.setAsAnimated = function() {
            this._isAnimated = !0;
        }, SVGStyleData.prototype.reset = function() {
            this.d = "", this._mdf = !1;
        }, DashProperty.prototype.getValue = function(t) {
            if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
                var e = 0, r = this.dataProps.length;
                for("svg" === this.renderer && (this.dashStr = ""), e = 0; e < r; e += 1)"o" !== this.dataProps[e].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], DashProperty), extendPrototype([
            DynamicPropertyContainer
        ], SVGStrokeStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGFillStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t, e) {
            for(var r = 0, i = this.o.length / 2; r < i;){
                if (Math.abs(t[4 * r] - t[4 * e + 2 * r]) > .01) return !1;
                r += 1;
            }
            return !0;
        }, GradientProperty.prototype.checkCollapsable = function() {
            if (this.o.length / 2 != this.c.length / 4) return !1;
            if (this.data.k.k[0].s) for(var t = 0, e = this.data.k.k.length; t < e;){
                if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                t += 1;
            }
            else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
            return !0;
        }, GradientProperty.prototype.getValue = function(t) {
            if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
                var e, r, i, a = 4 * this.data.p;
                for(e = 0; e < a; e += 1)r = e % 4 == 0 ? 100 : 255, i = Math.round(this.prop.v[e] * r), this.c[e] !== i && (this.c[e] = i, this._cmdf = !t);
                if (this.o.length) for(a = this.prop.v.length, e = 4 * this.data.p; e < a; e += 1)r = e % 2 == 0 ? 100 : 1, i = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e], this.o[e - 4 * this.data.p] !== i && (this.o[e - 4 * this.data.p] = i, this._omdf = !t);
                this._mdf = !t;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t, e, r) {
            this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.s = PropertyFactory.getProp(t, e.s, 1, null, this), this.e = PropertyFactory.getProp(t, e.e, 1, null, this), this.h = PropertyFactory.getProp(t, e.h || {
                k: 0
            }, 0, .01, this), this.a = PropertyFactory.getProp(t, e.a || {
                k: 0
            }, 0, degToRads, this), this.g = new GradientProperty(t, e.g, this), this.style = r, this.stops = [], this.setGradientData(r.pElem, e), this.setGradientOpacity(e, r), this._isAnimated = !!this._isAnimated;
        }, SVGGradientFillStyleData.prototype.setGradientData = function(t, e) {
            var r = createElementID(), i = createNS(1 === e.t ? "linearGradient" : "radialGradient");
            i.setAttribute("id", r), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
            var a, s, n, o = [];
            for(n = 4 * e.g.p, s = 0; s < n; s += 4)a = createNS("stop"), i.appendChild(a), o.push(a);
            t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r + ")"), this.gf = i, this.cst = o;
        }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, e) {
            if (this.g._hasOpacity && !this.g._collapsable) {
                var r, i, a, s = createNS("mask"), n = createNS("path");
                s.appendChild(n);
                var o = createElementID(), h = createElementID();
                s.setAttribute("id", h);
                var l = createNS(1 === t.t ? "linearGradient" : "radialGradient");
                l.setAttribute("id", o), l.setAttribute("spreadMethod", "pad"), l.setAttribute("gradientUnits", "userSpaceOnUse"), a = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
                var p = this.stops;
                for(i = 4 * t.g.p; i < a; i += 2)(r = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l.appendChild(r), p.push(r);
                n.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o + ")"), "gs" === t.ty && (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), 1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)), this.of = l, this.ms = s, this.ost = p, this.maskId = h, e.msElem = n;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], SVGGradientFillStyleData), extendPrototype([
            SVGGradientFillStyleData,
            DynamicPropertyContainer
        ], SVGGradientStrokeStyleData);
        var buildShapeString = function(t, e, r, i) {
            if (0 === e) return "";
            var a, s = t.o, n = t.i, o = t.v, h = " M" + i.applyToPointStringified(o[0][0], o[0][1]);
            for(a = 1; a < e; a += 1)h += " C" + i.applyToPointStringified(s[a - 1][0], s[a - 1][1]) + " " + i.applyToPointStringified(n[a][0], n[a][1]) + " " + i.applyToPointStringified(o[a][0], o[a][1]);
            return r && e && (h += " C" + i.applyToPointStringified(s[a - 1][0], s[a - 1][1]) + " " + i.applyToPointStringified(n[0][0], n[0][1]) + " " + i.applyToPointStringified(o[0][0], o[0][1]), h += "z"), h;
        }, SVGElementsRenderer = function() {
            var t = new Matrix, e = new Matrix;
            function r(t, e, r) {
                (r || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (r || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
            }
            function i() {}
            function a(r, i, a) {
                var s, n, o, h, l, p, f, c, m, d, u, y = i.styles.length, g = i.lvl;
                for(p = 0; p < y; p += 1){
                    if (h = i.sh._mdf || a, i.styles[p].lvl < g) {
                        for(c = e.reset(), d = g - i.styles[p].lvl, u = i.transformers.length - 1; !h && d > 0;)h = i.transformers[u].mProps._mdf || h, d -= 1, u -= 1;
                        if (h) for(d = g - i.styles[p].lvl, u = i.transformers.length - 1; d > 0;)m = i.transformers[u].mProps.v.props, c.transform(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11], m[12], m[13], m[14], m[15]), d -= 1, u -= 1;
                    } else c = t;
                    if (n = (f = i.sh.paths)._length, h) {
                        for(o = "", s = 0; s < n; s += 1)(l = f.shapes[s]) && l._length && (o += buildShapeString(l, l._length, l.c, c));
                        i.caches[p] = o;
                    } else o = i.caches[p];
                    i.styles[p].d += !0 === r.hd ? "" : o, i.styles[p]._mdf = h || i.styles[p]._mdf;
                }
            }
            function s(t, e, r) {
                var i = e.style;
                (e.c._mdf || r) && i.pElem.setAttribute("fill", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r) && i.pElem.setAttribute("fill-opacity", e.o.v);
            }
            function n(t, e, r) {
                o(t, e, r), h(t, e, r);
            }
            function o(t, e, r) {
                var i, a, s, n, o, h = e.gf, l = e.g._hasOpacity, p = e.s.v, f = e.e.v;
                if (e.o._mdf || r) {
                    var c = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                    e.style.pElem.setAttribute(c, e.o.v);
                }
                if (e.s._mdf || r) {
                    var m = 1 === t.t ? "x1" : "cx", d = "x1" === m ? "y1" : "cy";
                    h.setAttribute(m, p[0]), h.setAttribute(d, p[1]), l && !e.g._collapsable && (e.of.setAttribute(m, p[0]), e.of.setAttribute(d, p[1]));
                }
                if (e.g._cmdf || r) {
                    i = e.cst;
                    var u = e.g.c;
                    for(s = i.length, a = 0; a < s; a += 1)(n = i[a]).setAttribute("offset", u[4 * a] + "%"), n.setAttribute("stop-color", "rgb(" + u[4 * a + 1] + "," + u[4 * a + 2] + "," + u[4 * a + 3] + ")");
                }
                if (l && (e.g._omdf || r)) {
                    var y = e.g.o;
                    for(s = (i = e.g._collapsable ? e.cst : e.ost).length, a = 0; a < s; a += 1)n = i[a], e.g._collapsable || n.setAttribute("offset", y[2 * a] + "%"), n.setAttribute("stop-opacity", y[2 * a + 1]);
                }
                if (1 === t.t) (e.e._mdf || r) && (h.setAttribute("x2", f[0]), h.setAttribute("y2", f[1]), l && !e.g._collapsable && (e.of.setAttribute("x2", f[0]), e.of.setAttribute("y2", f[1])));
                else if ((e.s._mdf || e.e._mdf || r) && (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)), h.setAttribute("r", o), l && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || r) {
                    o || (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)));
                    var g = Math.atan2(f[1] - p[1], f[0] - p[0]), v = e.h.v;
                    v >= 1 ? v = .99 : v <= -1 && (v = -0.99);
                    var b = o * v, x = Math.cos(g + e.a.v) * b + p[0], P = Math.sin(g + e.a.v) * b + p[1];
                    h.setAttribute("fx", x), h.setAttribute("fy", P), l && !e.g._collapsable && (e.of.setAttribute("fx", x), e.of.setAttribute("fy", P));
                }
            }
            function h(t, e, r) {
                var i = e.style, a = e.d;
                a && (a._mdf || r) && a.dashStr && (i.pElem.setAttribute("stroke-dasharray", a.dashStr), i.pElem.setAttribute("stroke-dashoffset", a.dashoffset[0])), e.c && (e.c._mdf || r) && i.pElem.setAttribute("stroke", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r) && i.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || r) && (i.pElem.setAttribute("stroke-width", e.w.v), i.msElem && i.msElem.setAttribute("stroke-width", e.w.v));
            }
            return {
                createRenderFunction: function(t) {
                    switch(t.ty){
                        case "fl":
                            return s;
                        case "gf":
                            return o;
                        case "gs":
                            return n;
                        case "st":
                            return h;
                        case "sh":
                        case "el":
                        case "rc":
                        case "sr":
                            return a;
                        case "tr":
                            return r;
                        case "no":
                            return i;
                        default:
                            return null;
                    }
                }
            };
        }();
        function SVGShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, r), this.prevViewData = [];
        }
        function LetterProps(t, e, r, i, a, s) {
            this.o = t, this.sw = e, this.sc = r, this.fc = i, this.m = a, this.p = s, this._mdf = {
                o: !0,
                sw: !!e,
                sc: !!r,
                fc: !!i,
                m: !0,
                p: !0
            };
        }
        function TextProperty(t, e) {
            this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                ascent: 0,
                boxWidth: this.defaultBoxWidth,
                f: "",
                fStyle: "",
                fWeight: "",
                fc: "",
                j: "",
                justifyOffset: "",
                l: [],
                lh: 0,
                lineWidths: [],
                ls: "",
                of: "",
                s: "",
                sc: "",
                sw: 0,
                t: 0,
                tr: 0,
                sz: 0,
                ps: null,
                fillColorAnim: !1,
                strokeColorAnim: !1,
                strokeWidthAnim: !1,
                yOffset: 0,
                finalSize: 0,
                finalText: [],
                finalLineHeight: 0,
                __complete: !1
            }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
        }, SVGShapeElement.prototype.filterUniqueShapes = function() {
            var t, e, r, i, a = this.shapes.length, s = this.stylesList.length, n = [], o = !1;
            for(r = 0; r < s; r += 1){
                for(i = this.stylesList[r], o = !1, n.length = 0, t = 0; t < a; t += 1)-1 !== (e = this.shapes[t]).styles.indexOf(i) && (n.push(e), o = e._isAnimated || o);
                n.length > 1 && o && this.setShapesAsAnimated(n);
            }
        }, SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e].setAsAnimated();
        }, SVGShapeElement.prototype.createStyleElement = function(t, e) {
            var r, i = new SVGStyleData(t, e), a = i.pElem;
            if ("st" === t.ty) r = new SVGStrokeStyleData(this, t, i);
            else if ("fl" === t.ty) r = new SVGFillStyleData(this, t, i);
            else if ("gf" === t.ty || "gs" === t.ty) r = new ("gf" === t.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, i), this.globalData.defs.appendChild(r.gf), r.maskId && (this.globalData.defs.appendChild(r.ms), this.globalData.defs.appendChild(r.of), a.setAttribute("mask", "url(" + getLocationHref() + "#" + r.maskId + ")"));
            else "no" === t.ty && (r = new SVGNoStyleData(this, t, i));
            return "st" !== t.ty && "gs" !== t.ty || (a.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), a.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), a.setAttribute("fill-opacity", "0"), 1 === t.lj && a.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && a.setAttribute("fill-rule", "evenodd"), t.ln && a.setAttribute("id", t.ln), t.cl && a.setAttribute("class", t.cl), t.bm && (a.style["mix-blend-mode"] = getBlendMode(t.bm)), this.stylesList.push(i), this.addToAnimatedContents(t, r), r;
        }, SVGShapeElement.prototype.createGroupElement = function(t) {
            var e = new ShapeGroupData;
            return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), e;
        }, SVGShapeElement.prototype.createTransformElement = function(t, e) {
            var r = TransformPropertyFactory.getTransformProperty(this, t, this), i = new SVGTransformData(r, r.o, e);
            return this.addToAnimatedContents(t, i), i;
        }, SVGShapeElement.prototype.createShapeElement = function(t, e, r) {
            var i = 4;
            "rc" === t.ty ? i = 5 : "el" === t.ty ? i = 6 : "sr" === t.ty && (i = 7);
            var a = new SVGShapeData(e, r, ShapePropertyFactory.getShapeProp(this, t, i, this));
            return this.shapes.push(a), this.addShapeToModifiers(a), this.addToAnimatedContents(t, a), a;
        }, SVGShapeElement.prototype.addToAnimatedContents = function(t, e) {
            for(var r = 0, i = this.animatedContents.length; r < i;){
                if (this.animatedContents[r].element === e) return;
                r += 1;
            }
            this.animatedContents.push({
                fn: SVGElementsRenderer.createRenderFunction(t),
                element: e,
                data: t
            });
        }, SVGShapeElement.prototype.setElementStyles = function(t) {
            var e, r = t.styles, i = this.stylesList.length;
            for(e = 0; e < i; e += 1)this.stylesList[e].closed || r.push(this.stylesList[e]);
        }, SVGShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers();
        }, SVGShapeElement.prototype.searchShapes = function(t, e, r, i, a, s, n) {
            var o, h, l, p, f, c, m = [].concat(s), d = t.length - 1, u = [], y = [];
            for(o = d; o >= 0; o -= 1){
                if ((c = this.searchProcessedElement(t[o])) ? e[o] = r[c - 1] : t[o]._render = n, "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty) c ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], a), t[o]._render && e[o].style.pElem.parentNode !== i && i.appendChild(e[o].style.pElem), u.push(e[o].style);
                else if ("gr" === t[o].ty) {
                    if (c) for(l = e[o].it.length, h = 0; h < l; h += 1)e[o].prevViewData[h] = e[o].it[h];
                    else e[o] = this.createGroupElement(t[o]);
                    this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, a + 1, m, n), t[o]._render && e[o].gr.parentNode !== i && i.appendChild(e[o].gr);
                } else "tr" === t[o].ty ? (c || (e[o] = this.createTransformElement(t[o], i)), p = e[o].transform, m.push(p)) : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty ? (c || (e[o] = this.createShapeElement(t[o], m, a)), this.setElementStyles(e[o])) : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty || "zz" === t[o].ty || "op" === t[o].ty ? (c ? (f = e[o]).closed = !1 : ((f = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]), e[o] = f, this.shapeModifiers.push(f)), y.push(f)) : "rp" === t[o].ty && (c ? (f = e[o]).closed = !0 : (f = ShapeModifiers.getModifier(t[o].ty), e[o] = f, f.init(this, t, o, e), this.shapeModifiers.push(f), n = !1), y.push(f));
                this.addProcessedElement(t[o], o + 1);
            }
            for(d = u.length, o = 0; o < d; o += 1)u[o].closed = !0;
            for(d = y.length, o = 0; o < d; o += 1)y[o].closed = !0;
        }, SVGShapeElement.prototype.renderInnerContent = function() {
            var t;
            this.renderModifiers();
            var e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].reset();
            for(this.renderShape(), t = 0; t < e; t += 1)(this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
        }, SVGShapeElement.prototype.renderShape = function() {
            var t, e, r = this.animatedContents.length;
            for(t = 0; t < r; t += 1)e = this.animatedContents[t], (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
        }, SVGShapeElement.prototype.destroy = function() {
            this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
        }, LetterProps.prototype.update = function(t, e, r, i, a, s) {
            this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
            var n = !1;
            return this.o !== t && (this.o = t, this._mdf.o = !0, n = !0), this.sw !== e && (this.sw = e, this._mdf.sw = !0, n = !0), this.sc !== r && (this.sc = r, this._mdf.sc = !0, n = !0), this.fc !== i && (this.fc = i, this._mdf.fc = !0, n = !0), this.m !== a && (this.m = a, this._mdf.m = !0, n = !0), !s.length || this.p[0] === s[0] && this.p[1] === s[1] && this.p[4] === s[4] && this.p[5] === s[5] && this.p[12] === s[12] && this.p[13] === s[13] || (this.p = s, this._mdf.p = !0, n = !0), n;
        }, TextProperty.prototype.defaultBoxWidth = [
            0,
            0
        ], TextProperty.prototype.copyData = function(t, e) {
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t;
        }, TextProperty.prototype.setCurrentData = function(t) {
            t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
        }, TextProperty.prototype.searchProperty = function() {
            return this.searchKeyframes();
        }, TextProperty.prototype.searchKeyframes = function() {
            return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
        }, TextProperty.prototype.addEffect = function(t) {
            this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.getValue = function(t) {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
                this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                var e = this.currentData, r = this.keysIndex;
                if (this.lock) this.setCurrentData(this.currentData);
                else {
                    var i;
                    this.lock = !0, this._mdf = !1;
                    var a = this.effectsSequence.length, s = t || this.data.d.k[this.keysIndex].s;
                    for(i = 0; i < a; i += 1)s = r !== this.keysIndex ? this.effectsSequence[i](s, s.t) : this.effectsSequence[i](this.currentData, s.t);
                    e !== s && this.setCurrentData(s), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }, TextProperty.prototype.getKeyframeValue = function() {
            for(var t = this.data.d.k, e = this.elem.comp.renderedFrame, r = 0, i = t.length; r <= i - 1 && !(r === i - 1 || t[r + 1].t > e);)r += 1;
            return this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s;
        }, TextProperty.prototype.buildFinalText = function(t) {
            for(var e, r, i = [], a = 0, s = t.length, n = !1; a < s;)e = t.charCodeAt(a), FontManager.isCombinedCharacter(e) ? i[i.length - 1] += t.charAt(a) : e >= 55296 && e <= 56319 ? (r = t.charCodeAt(a + 1)) >= 56320 && r <= 57343 ? (n || FontManager.isModifier(e, r) ? (i[i.length - 1] += t.substr(a, 2), n = !1) : i.push(t.substr(a, 2)), a += 1) : i.push(t.charAt(a)) : e > 56319 ? (r = t.charCodeAt(a + 1), FontManager.isZeroWidthJoiner(e, r) ? (n = !0, i[i.length - 1] += t.substr(a, 2), a += 1) : i.push(t.charAt(a))) : FontManager.isZeroWidthJoiner(e) ? (i[i.length - 1] += t.charAt(a), n = !0) : i.push(t.charAt(a)), a += 1;
            return i;
        }, TextProperty.prototype.completeTextData = function(t) {
            t.__complete = !0;
            var e, r, i, a, s, n, o, h = this.elem.globalData.fontManager, l = this.data, p = [], f = 0, c = l.m.g, m = 0, d = 0, u = 0, y = [], g = 0, v = 0, b = h.getFontByName(t.f), x = 0, P = getFontProperties(b);
            t.fWeight = P.weight, t.fStyle = P.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), r = t.finalText.length, t.finalLineHeight = t.lh;
            var E, S = t.tr / 1e3 * t.finalSize;
            if (t.sz) for(var C, _, A = !0, k = t.sz[0], w = t.sz[1]; A;){
                C = 0, g = 0, r = (_ = this.buildFinalText(t.t)).length, S = t.tr / 1e3 * t.finalSize;
                var T = -1;
                for(e = 0; e < r; e += 1)E = _[e].charCodeAt(0), i = !1, " " === _[e] ? T = e : 13 !== E && 3 !== E || (g = 0, i = !0, C += t.finalLineHeight || 1.2 * t.finalSize), h.chars ? (o = h.getCharData(_[e], b.fStyle, b.fFamily), x = i ? 0 : o.w * t.finalSize / 100) : x = h.measureText(_[e], t.f, t.finalSize), g + x > k && " " !== _[e] ? (-1 === T ? r += 1 : e = T, C += t.finalLineHeight || 1.2 * t.finalSize, _.splice(e, T === e ? 1 : 0, "\r"), T = -1, g = 0) : (g += x, g += S);
                C += b.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && w < C ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = _, r = t.finalText.length, A = !1);
            }
            g = -S, x = 0;
            var M, D = 0;
            for(e = 0; e < r; e += 1)if (i = !1, 13 === (E = (M = t.finalText[e]).charCodeAt(0)) || 3 === E ? (D = 0, y.push(g), v = g > v ? g : v, g = -2 * S, a = "", i = !0, u += 1) : a = M, h.chars ? (o = h.getCharData(M, b.fStyle, h.getFontByName(t.f).fFamily), x = i ? 0 : o.w * t.finalSize / 100) : x = h.measureText(a, t.f, t.finalSize), " " === M ? D += x + S : (g += x + S + D, D = 0), p.push({
                l: x,
                an: x,
                add: m,
                n: i,
                anIndexes: [],
                val: a,
                line: u,
                animatorJustifyOffset: 0
            }), 2 == c) {
                if (m += x, "" === a || " " === a || e === r - 1) {
                    for("" !== a && " " !== a || (m -= x); d <= e;)p[d].an = m, p[d].ind = f, p[d].extra = x, d += 1;
                    f += 1, m = 0;
                }
            } else if (3 == c) {
                if (m += x, "" === a || e === r - 1) {
                    for("" === a && (m -= x); d <= e;)p[d].an = m, p[d].ind = f, p[d].extra = x, d += 1;
                    m = 0, f += 1;
                }
            } else p[f].ind = f, p[f].extra = 0, f += 1;
            if (t.l = p, v = g > v ? g : v, y.push(g), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;
            else switch(t.boxWidth = v, t.j){
                case 1:
                    t.justifyOffset = -t.boxWidth;
                    break;
                case 2:
                    t.justifyOffset = -t.boxWidth / 2;
                    break;
                default:
                    t.justifyOffset = 0;
            }
            t.lineWidths = y;
            var F, I, R, B, V = l.a;
            n = V.length;
            var L = [];
            for(s = 0; s < n; s += 1){
                for((F = V[s]).a.sc && (t.strokeColorAnim = !0), F.a.sw && (t.strokeWidthAnim = !0), (F.a.fc || F.a.fh || F.a.fs || F.a.fb) && (t.fillColorAnim = !0), B = 0, R = F.s.b, e = 0; e < r; e += 1)(I = p[e]).anIndexes[s] = B, (1 == R && "" !== I.val || 2 == R && "" !== I.val && " " !== I.val || 3 == R && (I.n || " " == I.val || e == r - 1) || 4 == R && (I.n || e == r - 1)) && (1 === F.s.rn && L.push(B), B += 1);
                l.a[s].s.totalChars = B;
                var z, G = -1;
                if (1 === F.s.rn) for(e = 0; e < r; e += 1)G != (I = p[e]).anIndexes[s] && (G = I.anIndexes[s], z = L.splice(Math.floor(Math.random() * L.length), 1)[0]), I.anIndexes[s] = z;
            }
            t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100;
        }, TextProperty.prototype.updateDocumentData = function(t, e) {
            e = void 0 === e ? this.keysIndex : e;
            var r = this.copyData({}, this.data.d.k[e].s);
            r = this.copyData(r, t), this.data.d.k[e].s = r, this.recalculate(e), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.recalculate = function(t) {
            var e = this.data.d.k[t].s;
            e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e);
        }, TextProperty.prototype.canResizeFont = function(t) {
            this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.setMinimumFontSize = function(t) {
            this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        };
        var TextSelectorProp = function() {
            var t = Math.max, e = Math.min, r = Math.floor;
            function i(t, e) {
                this._currentTextLength = -1, this.k = !1, this.data = e, this.elem = t, this.comp = t.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t), this.s = PropertyFactory.getProp(t, e.s || {
                    k: 0
                }, 0, 0, this), this.e = "e" in e ? PropertyFactory.getProp(t, e.e, 0, 0, this) : {
                    v: 100
                }, this.o = PropertyFactory.getProp(t, e.o || {
                    k: 0
                }, 0, 0, this), this.xe = PropertyFactory.getProp(t, e.xe || {
                    k: 0
                }, 0, 0, this), this.ne = PropertyFactory.getProp(t, e.ne || {
                    k: 0
                }, 0, 0, this), this.sm = PropertyFactory.getProp(t, e.sm || {
                    k: 100
                }, 0, 0, this), this.a = PropertyFactory.getProp(t, e.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
            }
            return i.prototype = {
                getMult: function(i) {
                    this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                    var a = 0, s = 0, n = 1, o = 1;
                    this.ne.v > 0 ? a = this.ne.v / 100 : s = -this.ne.v / 100, this.xe.v > 0 ? n = 1 - this.xe.v / 100 : o = 1 + this.xe.v / 100;
                    var h = BezierFactory.getBezierEasing(a, s, n, o).get, l = 0, p = this.finalS, f = this.finalE, c = this.data.sh;
                    if (2 === c) l = h(l = f === p ? i >= f ? 1 : 0 : t(0, e(.5 / (f - p) + (i - p) / (f - p), 1)));
                    else if (3 === c) l = h(l = f === p ? i >= f ? 0 : 1 : 1 - t(0, e(.5 / (f - p) + (i - p) / (f - p), 1)));
                    else if (4 === c) f === p ? l = 0 : (l = t(0, e(.5 / (f - p) + (i - p) / (f - p), 1))) < .5 ? l *= 2 : l = 1 - 2 * (l - .5), l = h(l);
                    else if (5 === c) {
                        if (f === p) l = 0;
                        else {
                            var m = f - p, d = -m / 2 + (i = e(t(0, i + .5 - p), f - p)), u = m / 2;
                            l = Math.sqrt(1 - d * d / (u * u));
                        }
                        l = h(l);
                    } else 6 === c ? (f === p ? l = 0 : (i = e(t(0, i + .5 - p), f - p), l = (1 + Math.cos(Math.PI + 2 * Math.PI * i / (f - p))) / 2), l = h(l)) : (i >= r(p) && (l = t(0, e(i - p < 0 ? e(f, 1) - (p - i) : f - i, 1))), l = h(l));
                    if (100 !== this.sm.v) {
                        var y = .01 * this.sm.v;
                        0 === y && (y = 1e-8);
                        var g = .5 - .5 * y;
                        l < g ? l = 0 : (l = (l - g) / y) > 1 && (l = 1);
                    }
                    return l * this.a.v;
                },
                getValue: function(t) {
                    this.iterateDynamicProperties(), this._mdf = t || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                    var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars, r = this.o.v / e, i = this.s.v / e + r, a = this.e.v / e + r;
                    if (i > a) {
                        var s = i;
                        i = a, a = s;
                    }
                    this.finalS = i, this.finalE = a;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], i), {
                getTextSelectorProp: function(t, e, r) {
                    return new i(t, e, r);
                }
            };
        }();
        function TextAnimatorDataProperty(t, e, r) {
            var i = {
                propType: !1
            }, a = PropertyFactory.getProp, s = e.a;
            this.a = {
                r: s.r ? a(t, s.r, 0, degToRads, r) : i,
                rx: s.rx ? a(t, s.rx, 0, degToRads, r) : i,
                ry: s.ry ? a(t, s.ry, 0, degToRads, r) : i,
                sk: s.sk ? a(t, s.sk, 0, degToRads, r) : i,
                sa: s.sa ? a(t, s.sa, 0, degToRads, r) : i,
                s: s.s ? a(t, s.s, 1, .01, r) : i,
                a: s.a ? a(t, s.a, 1, 0, r) : i,
                o: s.o ? a(t, s.o, 0, .01, r) : i,
                p: s.p ? a(t, s.p, 1, 0, r) : i,
                sw: s.sw ? a(t, s.sw, 0, 0, r) : i,
                sc: s.sc ? a(t, s.sc, 1, 0, r) : i,
                fc: s.fc ? a(t, s.fc, 1, 0, r) : i,
                fh: s.fh ? a(t, s.fh, 0, 0, r) : i,
                fs: s.fs ? a(t, s.fs, 0, .01, r) : i,
                fb: s.fb ? a(t, s.fb, 0, .01, r) : i,
                t: s.t ? a(t, s.t, 0, 0, r) : i
            }, this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r), this.s.t = e.s.t;
        }
        function TextAnimatorProperty(t, e, r) {
            this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = r, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                alignment: {}
            }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r);
        }
        function ITextElement() {}
        TextAnimatorProperty.prototype.searchProperties = function() {
            var t, e, r = this._textData.a.length, i = PropertyFactory.getProp;
            for(t = 0; t < r; t += 1)e = this._textData.a[t], this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, e, this);
            this._textData.p && "m" in this._textData.p ? (this._pathData = {
                a: i(this._elem, this._textData.p.a, 0, 0, this),
                f: i(this._elem, this._textData.p.f, 0, 0, this),
                l: i(this._elem, this._textData.p.l, 0, 0, this),
                r: i(this._elem, this._textData.p.r, 0, 0, this),
                p: i(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this);
        }, TextAnimatorProperty.prototype.getMeasures = function(t, e) {
            if (this.lettersChangedFlag = e, this._mdf || this._isFirstFrame || e || this._hasMaskedPath && this._pathData.m._mdf) {
                this._isFirstFrame = !1;
                var r, i, a, s, n, o, h, l, p, f, c, m, d, u, y, g, v, b, x, P = this._moreOptions.alignment.v, E = this._animatorsData, S = this._textData, C = this.mHelper, _ = this._renderType, A = this.renderedLetters.length, k = t.l;
                if (this._hasMaskedPath) {
                    if (x = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                        var w, T = x.v;
                        for(this._pathData.r.v && (T = T.reverse()), n = {
                            tLength: 0,
                            segments: []
                        }, s = T._length - 1, g = 0, a = 0; a < s; a += 1)w = bez.buildBezierData(T.v[a], T.v[a + 1], [
                            T.o[a][0] - T.v[a][0],
                            T.o[a][1] - T.v[a][1]
                        ], [
                            T.i[a + 1][0] - T.v[a + 1][0],
                            T.i[a + 1][1] - T.v[a + 1][1]
                        ]), n.tLength += w.segmentLength, n.segments.push(w), g += w.segmentLength;
                        a = s, x.v.c && (w = bez.buildBezierData(T.v[a], T.v[0], [
                            T.o[a][0] - T.v[a][0],
                            T.o[a][1] - T.v[a][1]
                        ], [
                            T.i[0][0] - T.v[0][0],
                            T.i[0][1] - T.v[0][1]
                        ]), n.tLength += w.segmentLength, n.segments.push(w), g += w.segmentLength), this._pathData.pi = n;
                    }
                    if (n = this._pathData.pi, o = this._pathData.f.v, c = 0, f = 1, l = 0, p = !0, u = n.segments, o < 0 && x.v.c) for(n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength), f = (d = u[c = u.length - 1].points).length - 1; o < 0;)o += d[f].partialLength, (f -= 1) < 0 && (f = (d = u[c -= 1].points).length - 1);
                    m = (d = u[c].points)[f - 1], y = (h = d[f]).partialLength;
                }
                s = k.length, r = 0, i = 0;
                var M, D, F, I, R, B = 1.2 * t.finalSize * .714, V = !0;
                F = E.length;
                var L, z, G, O, N, H, j, q, W, $, Y, X, Z = -1, K = o, J = c, U = f, Q = -1, tt = "", et = this.defaultPropsArray;
                if (2 === t.j || 1 === t.j) {
                    var rt = 0, it = 0, at = 2 === t.j ? -0.5 : -1, st = 0, nt = !0;
                    for(a = 0; a < s; a += 1)if (k[a].n) {
                        for(rt && (rt += it); st < a;)k[st].animatorJustifyOffset = rt, st += 1;
                        rt = 0, nt = !0;
                    } else {
                        for(D = 0; D < F; D += 1)(M = E[D].a).t.propType && (nt && 2 === t.j && (it += M.t.v * at), (R = E[D].s.getMult(k[a].anIndexes[D], S.a[D].s.totalChars)).length ? rt += M.t.v * R[0] * at : rt += M.t.v * R * at);
                        nt = !1;
                    }
                    for(rt && (rt += it); st < a;)k[st].animatorJustifyOffset = rt, st += 1;
                }
                for(a = 0; a < s; a += 1){
                    if (C.reset(), O = 1, k[a].n) r = 0, i += t.yOffset, i += V ? 1 : 0, o = K, V = !1, this._hasMaskedPath && (f = U, m = (d = u[c = J].points)[f - 1], y = (h = d[f]).partialLength, l = 0), tt = "", Y = "", W = "", X = "", et = this.defaultPropsArray;
                    else {
                        if (this._hasMaskedPath) {
                            if (Q !== k[a].line) {
                                switch(t.j){
                                    case 1:
                                        o += g - t.lineWidths[k[a].line];
                                        break;
                                    case 2:
                                        o += (g - t.lineWidths[k[a].line]) / 2;
                                }
                                Q = k[a].line;
                            }
                            Z !== k[a].ind && (k[Z] && (o += k[Z].extra), o += k[a].an / 2, Z = k[a].ind), o += P[0] * k[a].an * .005;
                            var ot = 0;
                            for(D = 0; D < F; D += 1)(M = E[D].a).p.propType && ((R = E[D].s.getMult(k[a].anIndexes[D], S.a[D].s.totalChars)).length ? ot += M.p.v[0] * R[0] : ot += M.p.v[0] * R), M.a.propType && ((R = E[D].s.getMult(k[a].anIndexes[D], S.a[D].s.totalChars)).length ? ot += M.a.v[0] * R[0] : ot += M.a.v[0] * R);
                            for(p = !0, this._pathData.a.v && (o = .5 * k[0].an + (g - this._pathData.f.v - .5 * k[0].an - .5 * k[k.length - 1].an) * Z / (s - 1), o += this._pathData.f.v); p;)l + y >= o + ot || !d ? (v = (o + ot - l) / h.partialLength, z = m.point[0] + (h.point[0] - m.point[0]) * v, G = m.point[1] + (h.point[1] - m.point[1]) * v, C.translate(-P[0] * k[a].an * .005, -P[1] * B * .01), p = !1) : d && (l += h.partialLength, (f += 1) >= d.length && (f = 0, u[c += 1] ? d = u[c].points : x.v.c ? (f = 0, d = u[c = 0].points) : (l -= h.partialLength, d = null)), d && (m = h, y = (h = d[f]).partialLength));
                            L = k[a].an / 2 - k[a].add, C.translate(-L, 0, 0);
                        } else L = k[a].an / 2 - k[a].add, C.translate(-L, 0, 0), C.translate(-P[0] * k[a].an * .005, -P[1] * B * .01, 0);
                        for(D = 0; D < F; D += 1)(M = E[D].a).t.propType && (R = E[D].s.getMult(k[a].anIndexes[D], S.a[D].s.totalChars), 0 === r && 0 === t.j || (this._hasMaskedPath ? R.length ? o += M.t.v * R[0] : o += M.t.v * R : R.length ? r += M.t.v * R[0] : r += M.t.v * R));
                        for(t.strokeWidthAnim && (H = t.sw || 0), t.strokeColorAnim && (N = t.sc ? [
                            t.sc[0],
                            t.sc[1],
                            t.sc[2]
                        ] : [
                            0,
                            0,
                            0
                        ]), t.fillColorAnim && t.fc && (j = [
                            t.fc[0],
                            t.fc[1],
                            t.fc[2]
                        ]), D = 0; D < F; D += 1)(M = E[D].a).a.propType && ((R = E[D].s.getMult(k[a].anIndexes[D], S.a[D].s.totalChars)).length ? C.translate(-M.a.v[0] * R[0], -M.a.v[1] * R[1], M.a.v[2] * R[2]) : C.translate(-M.a.v[0] * R, -M.a.v[1] * R, M.a.v[2] * R));
                        for(D = 0; D < F; D += 1)(M = E[D].a).s.propType && ((R = E[D].s.getMult(k[a].anIndexes[D], S.a[D].s.totalChars)).length ? C.scale(1 + (M.s.v[0] - 1) * R[0], 1 + (M.s.v[1] - 1) * R[1], 1) : C.scale(1 + (M.s.v[0] - 1) * R, 1 + (M.s.v[1] - 1) * R, 1));
                        for(D = 0; D < F; D += 1){
                            if (M = E[D].a, R = E[D].s.getMult(k[a].anIndexes[D], S.a[D].s.totalChars), M.sk.propType && (R.length ? C.skewFromAxis(-M.sk.v * R[0], M.sa.v * R[1]) : C.skewFromAxis(-M.sk.v * R, M.sa.v * R)), M.r.propType && (R.length ? C.rotateZ(-M.r.v * R[2]) : C.rotateZ(-M.r.v * R)), M.ry.propType && (R.length ? C.rotateY(M.ry.v * R[1]) : C.rotateY(M.ry.v * R)), M.rx.propType && (R.length ? C.rotateX(M.rx.v * R[0]) : C.rotateX(M.rx.v * R)), M.o.propType && (R.length ? O += (M.o.v * R[0] - O) * R[0] : O += (M.o.v * R - O) * R), t.strokeWidthAnim && M.sw.propType && (R.length ? H += M.sw.v * R[0] : H += M.sw.v * R), t.strokeColorAnim && M.sc.propType) for(q = 0; q < 3; q += 1)R.length ? N[q] += (M.sc.v[q] - N[q]) * R[0] : N[q] += (M.sc.v[q] - N[q]) * R;
                            if (t.fillColorAnim && t.fc) {
                                if (M.fc.propType) for(q = 0; q < 3; q += 1)R.length ? j[q] += (M.fc.v[q] - j[q]) * R[0] : j[q] += (M.fc.v[q] - j[q]) * R;
                                M.fh.propType && (j = R.length ? addHueToRGB(j, M.fh.v * R[0]) : addHueToRGB(j, M.fh.v * R)), M.fs.propType && (j = R.length ? addSaturationToRGB(j, M.fs.v * R[0]) : addSaturationToRGB(j, M.fs.v * R)), M.fb.propType && (j = R.length ? addBrightnessToRGB(j, M.fb.v * R[0]) : addBrightnessToRGB(j, M.fb.v * R));
                            }
                        }
                        for(D = 0; D < F; D += 1)(M = E[D].a).p.propType && (R = E[D].s.getMult(k[a].anIndexes[D], S.a[D].s.totalChars), this._hasMaskedPath ? R.length ? C.translate(0, M.p.v[1] * R[0], -M.p.v[2] * R[1]) : C.translate(0, M.p.v[1] * R, -M.p.v[2] * R) : R.length ? C.translate(M.p.v[0] * R[0], M.p.v[1] * R[1], -M.p.v[2] * R[2]) : C.translate(M.p.v[0] * R, M.p.v[1] * R, -M.p.v[2] * R));
                        if (t.strokeWidthAnim && (W = H < 0 ? 0 : H), t.strokeColorAnim && ($ = "rgb(" + Math.round(255 * N[0]) + "," + Math.round(255 * N[1]) + "," + Math.round(255 * N[2]) + ")"), t.fillColorAnim && t.fc && (Y = "rgb(" + Math.round(255 * j[0]) + "," + Math.round(255 * j[1]) + "," + Math.round(255 * j[2]) + ")"), this._hasMaskedPath) {
                            if (C.translate(0, -t.ls), C.translate(0, P[1] * B * .01 + i, 0), this._pathData.p.v) {
                                b = (h.point[1] - m.point[1]) / (h.point[0] - m.point[0]);
                                var ht = 180 * Math.atan(b) / Math.PI;
                                h.point[0] < m.point[0] && (ht += 180), C.rotate(-ht * Math.PI / 180);
                            }
                            C.translate(z, G, 0), o -= P[0] * k[a].an * .005, k[a + 1] && Z !== k[a + 1].ind && (o += k[a].an / 2, o += .001 * t.tr * t.finalSize);
                        } else {
                            switch(C.translate(r, i, 0), t.ps && C.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j){
                                case 1:
                                    C.translate(k[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[k[a].line]), 0, 0);
                                    break;
                                case 2:
                                    C.translate(k[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[k[a].line]) / 2, 0, 0);
                            }
                            C.translate(0, -t.ls), C.translate(L, 0, 0), C.translate(P[0] * k[a].an * .005, P[1] * B * .01, 0), r += k[a].l + .001 * t.tr * t.finalSize;
                        }
                        "html" === _ ? tt = C.toCSS() : "svg" === _ ? tt = C.to2dCSS() : et = [
                            C.props[0],
                            C.props[1],
                            C.props[2],
                            C.props[3],
                            C.props[4],
                            C.props[5],
                            C.props[6],
                            C.props[7],
                            C.props[8],
                            C.props[9],
                            C.props[10],
                            C.props[11],
                            C.props[12],
                            C.props[13],
                            C.props[14],
                            C.props[15]
                        ], X = O;
                    }
                    A <= a ? (I = new LetterProps(X, W, $, Y, tt, et), this.renderedLetters.push(I), A += 1, this.lettersChangedFlag = !0) : (I = this.renderedLetters[a], this.lettersChangedFlag = I.update(X, W, $, Y, tt, et) || this.lettersChangedFlag);
                }
            }
        }, TextAnimatorProperty.prototype.getValue = function() {
            this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
        }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
            DynamicPropertyContainer
        ], TextAnimatorProperty), ITextElement.prototype.initElement = function(t, e, r) {
            this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, r), this.textProperty = new TextProperty(this, t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this), this.initTransform(t, e, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
        }, ITextElement.prototype.prepareFrame = function(t) {
            this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
        }, ITextElement.prototype.createPathShape = function(t, e) {
            var r, i, a = e.length, s = "";
            for(r = 0; r < a; r += 1)"sh" === e[r].ty && (i = e[r].ks.k, s += buildShapeString(i, i.i.length, !0, t));
            return s;
        }, ITextElement.prototype.updateDocumentData = function(t, e) {
            this.textProperty.updateDocumentData(t, e);
        }, ITextElement.prototype.canResizeFont = function(t) {
            this.textProperty.canResizeFont(t);
        }, ITextElement.prototype.setMinimumFontSize = function(t) {
            this.textProperty.setMinimumFontSize(t);
        }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t, e, r, i, a) {
            switch(t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j){
                case 1:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]), 0, 0);
                    break;
                case 2:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]) / 2, 0, 0);
            }
            e.translate(i, a, 0);
        }, ITextElement.prototype.buildColor = function(t) {
            return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
        }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {};
        var emptyShapeData = {
            shapes: []
        };
        function SVGTextLottieElement(t, e, r) {
            this.textSpans = [], this.renderType = "svg", this.initElement(t, e, r);
        }
        function ISolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function NullElement(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initFrame(), this.initTransform(t, e, r), this.initHierarchy();
        }
        function SVGRendererBase() {}
        function ICompElement() {}
        function SVGCompElement(t, e, r) {
            this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function SVGRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
            var r = "";
            if (e && e.title) {
                var i = createNS("title"), a = createElementID();
                i.setAttribute("id", a), i.textContent = e.title, this.svgElement.appendChild(i), r += a;
            }
            if (e && e.description) {
                var s = createNS("desc"), n = createElementID();
                s.setAttribute("id", n), s.textContent = e.description, this.svgElement.appendChild(s), r += " " + n;
            }
            r && this.svgElement.setAttribute("aria-labelledby", r);
            var o = createNS("defs");
            this.svgElement.appendChild(o);
            var h = createNS("g");
            this.svgElement.appendChild(h), this.layerElement = h, this.renderConfig = {
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                progressiveLoad: e && e.progressiveLoad || !1,
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                viewBoxOnly: e && e.viewBoxOnly || !1,
                viewBoxSize: e && e.viewBoxSize || !1,
                className: e && e.className || "",
                id: e && e.id || "",
                focusable: e && e.focusable,
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "100%",
                    height: e && e.filterSize && e.filterSize.height || "100%",
                    x: e && e.filterSize && e.filterSize.x || "0%",
                    y: e && e.filterSize && e.filterSize.y || "0%"
                },
                width: e && e.width,
                height: e && e.height,
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                defs: o,
                renderConfig: this.renderConfig
            }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
        }
        function CVContextData() {
            var t;
            this.saved = [], this.cArrPos = 0, this.cTr = new Matrix, this.cO = 1;
            for(this.savedOp = createTypedArray("float32", 15), t = 0; t < 15; t += 1)this.saved[t] = createTypedArray("float32", 16);
            this._length = 15;
        }
        function ShapeTransformManager() {
            this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
            this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
        }, SVGTextLottieElement.prototype.buildTextContents = function(t) {
            for(var e = 0, r = t.length, i = [], a = ""; e < r;)t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (i.push(a), a = "") : a += t[e], e += 1;
            return i.push(a), i;
        }, SVGTextLottieElement.prototype.buildShapeData = function(t, e) {
            if (t.shapes && t.shapes.length) {
                var r = t.shapes[0];
                if (r.it) {
                    var i = r.it[r.it.length - 1];
                    i.s && (i.s.k[0] = e, i.s.k[1] = e);
                }
            }
            return t;
        }, SVGTextLottieElement.prototype.buildNewText = function() {
            var t, e;
            this.addDynamicProperty(this);
            var r = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(r ? r.l.length : 0), r.fc ? this.layerElement.setAttribute("fill", this.buildColor(r.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)), this.layerElement.setAttribute("stroke-width", r.sw)), this.layerElement.setAttribute("font-size", r.finalSize);
            var i = this.globalData.fontManager.getFontByName(r.f);
            if (i.fClass) this.layerElement.setAttribute("class", i.fClass);
            else {
                this.layerElement.setAttribute("font-family", i.fFamily);
                var a = r.fWeight, s = r.fStyle;
                this.layerElement.setAttribute("font-style", s), this.layerElement.setAttribute("font-weight", a);
            }
            this.layerElement.setAttribute("aria-label", r.t);
            var n, o = r.l || [], h = !!this.globalData.fontManager.chars;
            e = o.length;
            var l = this.mHelper, p = this.data.singleShape, f = 0, c = 0, m = !0, d = .001 * r.tr * r.finalSize;
            if (!p || h || r.sz) {
                var u, y = this.textSpans.length;
                for(t = 0; t < e; t += 1){
                    if (this.textSpans[t] || (this.textSpans[t] = {
                        span: null,
                        childSpan: null,
                        glyph: null
                    }), !h || !p || 0 === t) {
                        if (n = y > t ? this.textSpans[t].span : createNS(h ? "g" : "text"), y <= t) {
                            if (n.setAttribute("stroke-linecap", "butt"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = n, h) {
                                var g = createNS("g");
                                n.appendChild(g), this.textSpans[t].childSpan = g;
                            }
                            this.textSpans[t].span = n, this.layerElement.appendChild(n);
                        }
                        n.style.display = "inherit";
                    }
                    if (l.reset(), p && (o[t].n && (f = -d, c += r.yOffset, c += m ? 1 : 0, m = !1), this.applyTextPropertiesToMatrix(r, l, o[t].line, f, c), f += o[t].l || 0, f += d), h) {
                        var v;
                        if (1 === (u = this.globalData.fontManager.getCharData(r.finalText[t], i.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily)).t) v = new SVGCompElement(u.data, this.globalData, this);
                        else {
                            var b = emptyShapeData;
                            u.data && u.data.shapes && (b = this.buildShapeData(u.data, r.finalSize)), v = new SVGShapeElement(b, this.globalData, this);
                        }
                        if (this.textSpans[t].glyph) {
                            var x = this.textSpans[t].glyph;
                            this.textSpans[t].childSpan.removeChild(x.layerElement), x.destroy();
                        }
                        this.textSpans[t].glyph = v, v._debug = !0, v.prepareFrame(0), v.renderFrame(), this.textSpans[t].childSpan.appendChild(v.layerElement), 1 === u.t && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")");
                    } else p && n.setAttribute("transform", "translate(" + l.props[12] + "," + l.props[13] + ")"), n.textContent = o[t].val, n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                }
                p && n && n.setAttribute("d", "");
            } else {
                var P = this.textContainer, E = "start";
                switch(r.j){
                    case 1:
                        E = "end";
                        break;
                    case 2:
                        E = "middle";
                        break;
                    default:
                        E = "start";
                }
                P.setAttribute("text-anchor", E), P.setAttribute("letter-spacing", d);
                var S = this.buildTextContents(r.finalText);
                for(e = S.length, c = r.ps ? r.ps[1] + r.ascent : 0, t = 0; t < e; t += 1)(n = this.textSpans[t].span || createNS("tspan")).textContent = S[t], n.setAttribute("x", 0), n.setAttribute("y", c), n.style.display = "inherit", P.appendChild(n), this.textSpans[t] || (this.textSpans[t] = {
                    span: null,
                    glyph: null
                }), this.textSpans[t].span = n, c += r.finalLineHeight;
                this.layerElement.appendChild(P);
            }
            for(; t < this.textSpans.length;)this.textSpans[t].span.style.display = "none", t += 1;
            this._sizeChanged = !0;
        }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
            if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                this._sizeChanged = !1;
                var t = this.layerElement.getBBox();
                this.bbox = {
                    top: t.y,
                    left: t.x,
                    width: t.width,
                    height: t.height
                };
            }
            return this.bbox;
        }, SVGTextLottieElement.prototype.getValue = function() {
            var t, e, r = this.textSpans.length;
            for(this.renderedFrame = this.comp.renderedFrame, t = 0; t < r; t += 1)(e = this.textSpans[t].glyph) && (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0));
        }, SVGTextLottieElement.prototype.renderInnerContent = function() {
            if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                var t, e;
                this._sizeChanged = !0;
                var r, i, a, s = this.textAnimator.renderedLetters, n = this.textProperty.currentData.l;
                for(e = n.length, t = 0; t < e; t += 1)n[t].n || (r = s[t], i = this.textSpans[t].span, (a = this.textSpans[t].glyph) && a.renderFrame(), r._mdf.m && i.setAttribute("transform", r.m), r._mdf.o && i.setAttribute("opacity", r.o), r._mdf.sw && i.setAttribute("stroke-width", r.sw), r._mdf.sc && i.setAttribute("stroke", r.sc), r._mdf.fc && i.setAttribute("fill", r.fc));
            }
        }, extendPrototype([
            IImageElement
        ], ISolidElement), ISolidElement.prototype.createContent = function() {
            var t = createNS("rect");
            t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
        }, NullElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
            return null;
        }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement
        ], NullElement), extendPrototype([
            BaseRenderer
        ], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t) {
            return new NullElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createShape = function(t) {
            return new SVGShapeElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createText = function(t) {
            return new SVGTextLottieElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createImage = function(t) {
            return new IImageElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createSolid = function(t) {
            return new ISolidElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.configAnimation = function(t) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
            var e = this.globalData.defs;
            this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
            var r = createNS("clipPath"), i = createNS("rect");
            i.setAttribute("width", t.w), i.setAttribute("height", t.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
            var a = createElementID();
            r.setAttribute("id", a), r.appendChild(i), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), e.appendChild(r), this.layers = t.layers, this.elements = createSizedArray(t.layers.length);
        }, SVGRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, SVGRendererBase.prototype.updateContainerSize = function() {}, SVGRendererBase.prototype.findIndexByInd = function(t) {
            var e = 0, r = this.layers.length;
            for(e = 0; e < r; e += 1)if (this.layers[e].ind === t) return e;
            return -1;
        }, SVGRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                e[t] = !0;
                var r = this.createItem(this.layers[t]);
                if (e[t] = r, getExpressionsPlugin() && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(r), r.initExpressions()), this.appendElementInPos(r, t), this.layers[t].tt) {
                    var i = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                    if (-1 === i) return;
                    if (this.elements[i] && !0 !== this.elements[i]) {
                        var a = e[i].getMatte(this.layers[t].tt);
                        r.setMatte(a);
                    } else this.buildItem(i), this.addPendingElement(r);
                }
            }
        }, SVGRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;){
                var t = this.pendingElements.pop();
                if (t.checkParenting(), t.data.tt) for(var e = 0, r = this.elements.length; e < r;){
                    if (this.elements[e] === t) {
                        var i = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1, a = this.elements[i].getMatte(this.layers[e].tt);
                        t.setMatte(a);
                        break;
                    }
                    e += 1;
                }
            }
        }, SVGRendererBase.prototype.renderFrame = function(t) {
            if (this.renderedFrame !== t && !this.destroyed) {
                var e;
                null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
                var r = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), e = r - 1; e >= 0; e -= 1)(this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                if (this.globalData._mdf) for(e = 0; e < r; e += 1)(this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
            }
        }, SVGRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                for(var i, a = 0; a < e;)this.elements[a] && !0 !== this.elements[a] && this.elements[a].getBaseElement() && (i = this.elements[a].getBaseElement()), a += 1;
                i ? this.layerElement.insertBefore(r, i) : this.layerElement.appendChild(r);
            }
        }, SVGRendererBase.prototype.hide = function() {
            this.layerElement.style.display = "none";
        }, SVGRendererBase.prototype.show = function() {
            this.layerElement.style.display = "block";
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], ICompElement), ICompElement.prototype.initElement = function(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initTransform(t, e, r), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e.progressiveLoad || this.buildAllItems(), this.hide();
        }, ICompElement.prototype.prepareFrame = function(t) {
            if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
                if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                else {
                    var e = this.tm.v;
                    e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e;
                }
                var r, i = this.elements.length;
                for(this.completeLayers || this.checkLayers(this.renderedFrame), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st), this.elements[r]._mdf && (this._mdf = !0));
            }
        }, ICompElement.prototype.renderInnerContent = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, ICompElement.prototype.setElements = function(t) {
            this.elements = t;
        }, ICompElement.prototype.getElements = function() {
            return this.elements;
        }, ICompElement.prototype.destroyElements = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy();
        }, ICompElement.prototype.destroy = function() {
            this.destroyElements(), this.destroyBaseElement();
        }, extendPrototype([
            SVGRendererBase,
            ICompElement,
            SVGBaseElement
        ], SVGCompElement), SVGCompElement.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            SVGRendererBase
        ], SVGRenderer), SVGRenderer.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, CVContextData.prototype.duplicate = function() {
            var t = 2 * this._length, e = this.savedOp;
            this.savedOp = createTypedArray("float32", t), this.savedOp.set(e);
            var r = 0;
            for(r = this._length; r < t; r += 1)this.saved[r] = createTypedArray("float32", 16);
            this._length = t;
        }, CVContextData.prototype.reset = function() {
            this.cArrPos = 0, this.cTr.reset(), this.cO = 1;
        }, CVContextData.prototype.popTransform = function() {
            var t, e = this.saved[this.cArrPos], r = this.cTr.props;
            for(t = 0; t < 16; t += 1)r[t] = e[t];
            return e;
        }, CVContextData.prototype.popOpacity = function() {
            var t = this.savedOp[this.cArrPos];
            return this.cO = t, t;
        }, CVContextData.prototype.pop = function() {
            return this.cArrPos -= 1, {
                transform: this.popTransform(),
                opacity: this.popOpacity()
            };
        }, CVContextData.prototype.push = function() {
            var t, e = this.cTr.props;
            this._length <= this.cArrPos && this.duplicate();
            var r = this.saved[this.cArrPos];
            for(t = 0; t < 16; t += 1)r[t] = e[t];
            this.savedOp[this.cArrPos] = this.cO, this.cArrPos += 1;
        }, CVContextData.prototype.getTransform = function() {
            return this.cTr;
        }, CVContextData.prototype.getOpacity = function() {
            return this.cO;
        }, CVContextData.prototype.setOpacity = function(t) {
            this.cO = t;
        }, ShapeTransformManager.prototype = {
            addTransformSequence: function(t) {
                var e, r = t.length, i = "_";
                for(e = 0; e < r; e += 1)i += t[e].transform.key + "_";
                var a = this.sequences[i];
                return a || (a = {
                    transforms: [].concat(t),
                    finalTransform: new Matrix,
                    _mdf: !1
                }, this.sequences[i] = a, this.sequenceList.push(a)), a;
            },
            processSequence: function(t, e) {
                for(var r, i = 0, a = t.transforms.length, s = e; i < a && !e;){
                    if (t.transforms[i].transform.mProps._mdf) {
                        s = !0;
                        break;
                    }
                    i += 1;
                }
                if (s) for(t.finalTransform.reset(), i = a - 1; i >= 0; i -= 1)r = t.transforms[i].transform.mProps.v.props, t.finalTransform.transform(r[0], r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8], r[9], r[10], r[11], r[12], r[13], r[14], r[15]);
                t._mdf = s;
            },
            processSequences: function(t) {
                var e, r = this.sequenceList.length;
                for(e = 0; e < r; e += 1)this.processSequence(this.sequenceList[e], t);
            },
            getNewKey: function() {
                return this.transform_key_count += 1, "_" + this.transform_key_count;
            }
        };
        var lumaLoader = function() {
            var t = "__lottie_element_luma_buffer", e = null, r = null, i = null;
            function a() {
                var a, s, n;
                e || (a = createNS("svg"), s = createNS("filter"), n = createNS("feColorMatrix"), s.setAttribute("id", t), n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), s.appendChild(n), a.appendChild(s), a.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (a.style.display = "none"), i = a, document.body.appendChild(i), e = createTag("canvas"), (r = e.getContext("2d")).filter = "url(#" + t + ")", r.fillStyle = "rgba(0,0,0,0)", r.fillRect(0, 0, 1, 1));
            }
            return {
                load: a,
                get: function(i) {
                    return e || a(), e.width = i.width, e.height = i.height, r.filter = "url(#" + t + ")", e;
                }
            };
        };
        function createCanvas(t, e) {
            if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t, e);
            var r = createTag("canvas");
            return r.width = t, r.height = e, r;
        }
        var assetLoader = {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
        function CVEffects() {}
        function CVMaskElement(t, e) {
            var r;
            this.data = t, this.element = e, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
            var i = this.masksProperties.length, a = !1;
            for(r = 0; r < i; r += 1)"n" !== this.masksProperties[r].mode && (a = !0), this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3);
            this.hasMasks = a, a && this.element.addRenderableComponent(this);
        }
        function CVBaseElement() {}
        CVEffects.prototype.renderFrame = function() {}, CVMaskElement.prototype.renderFrame = function() {
            if (this.hasMasks) {
                var t, e, r, i, a = this.element.finalTransform.mat, s = this.element.canvasContext, n = this.masksProperties.length;
                for(s.beginPath(), t = 0; t < n; t += 1)if ("n" !== this.masksProperties[t].mode) {
                    var o;
                    this.masksProperties[t].inv && (s.moveTo(0, 0), s.lineTo(this.element.globalData.compSize.w, 0), s.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), s.lineTo(0, this.element.globalData.compSize.h), s.lineTo(0, 0)), i = this.viewData[t].v, e = a.applyToPointArray(i.v[0][0], i.v[0][1], 0), s.moveTo(e[0], e[1]);
                    var h = i._length;
                    for(o = 1; o < h; o += 1)r = a.applyToTriplePoints(i.o[o - 1], i.i[o], i.v[o]), s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                    r = a.applyToTriplePoints(i.o[o - 1], i.i[0], i.v[0]), s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                }
                this.element.globalData.renderer.save(!0), s.clip();
            }
        }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
            this.element = null;
        };
        var operationsMap = {
            1: "source-in",
            2: "source-out",
            3: "source-in",
            4: "source-out"
        };
        function CVShapeData(t, e, r, i) {
            this.styledShapes = [], this.tr = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var a, s = 4;
            "rc" === e.ty ? s = 5 : "el" === e.ty ? s = 6 : "sr" === e.ty && (s = 7), this.sh = ShapePropertyFactory.getShapeProp(t, e, s, t);
            var n, o = r.length;
            for(a = 0; a < o; a += 1)r[a].closed || (n = {
                transforms: i.addTransformSequence(r[a].transforms),
                trNodes: []
            }, this.styledShapes.push(n), r[a].elements.push(n));
        }
        function CVShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t, e, r);
        }
        function CVTextElement(t, e, r) {
            this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
                fill: "rgba(0,0,0,0)",
                stroke: "rgba(0,0,0,0)",
                sWidth: 0,
                fValue: ""
            }, this.initElement(t, e, r);
        }
        function CVImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.img = e.imageLoader.getAsset(this.assetData), this.initElement(t, e, r);
        }
        function CVSolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function CanvasRendererBase(t, e) {
            this.animationItem = t, this.renderConfig = {
                clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                context: e && e.context || null,
                progressiveLoad: e && e.progressiveLoad || !1,
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                className: e && e.className || "",
                id: e && e.id || ""
            }, this.renderConfig.dpr = e && e.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e && e.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas";
        }
        function CVCompElement(t, e, r) {
            this.completeLayers = !1, this.layers = t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function CanvasRenderer(t, e) {
            this.animationItem = t, this.renderConfig = {
                clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                context: e && e.context || null,
                progressiveLoad: e && e.progressiveLoad || !1,
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                className: e && e.className || "",
                id: e && e.id || "",
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.renderConfig.dpr = e && e.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e && e.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas";
        }
        function HBaseElement() {}
        function HSolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function HShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t, e, r), this.prevViewData = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            };
        }
        function HTextElement(t, e, r) {
            this.textSpans = [], this.textPaths = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            }, this.renderType = "svg", this.isMasked = !1, this.initElement(t, e, r);
        }
        function HCameraElement(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initHierarchy();
            var i = PropertyFactory.getProp;
            if (this.pe = i(this, t.pe, 0, 0, this), t.ks.p.s ? (this.px = i(this, t.ks.p.x, 1, 0, this), this.py = i(this, t.ks.p.y, 1, 0, this), this.pz = i(this, t.ks.p.z, 1, 0, this)) : this.p = i(this, t.ks.p, 1, 0, this), t.ks.a && (this.a = i(this, t.ks.a, 1, 0, this)), t.ks.or.k.length && t.ks.or.k[0].to) {
                var a, s = t.ks.or.k.length;
                for(a = 0; a < s; a += 1)t.ks.or.k[a].to = null, t.ks.or.k[a].ti = null;
            }
            this.or = i(this, t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i(this, t.ks.rx, 0, degToRads, this), this.ry = i(this, t.ks.ry, 0, degToRads, this), this.rz = i(this, t.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
                mProp: this
            };
        }
        function HImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.initElement(t, e, r);
        }
        function HybridRendererBase(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                }
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        function HCompElement(t, e, r) {
            this.layers = t.layers, this.supports3d = !t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function HybridRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                },
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        CVBaseElement.prototype = {
            createElements: function() {},
            initRendererElement: function() {},
            createContainerElements: function() {
                if (this.data.tt >= 1) {
                    this.buffers = [];
                    var t = this.globalData.canvasContext, e = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(e);
                    var r = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(r), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
                }
                this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this);
            },
            createContent: function() {},
            setBlendMode: function() {
                var t = this.globalData;
                if (t.blendMode !== this.data.bm) {
                    t.blendMode = this.data.bm;
                    var e = getBlendMode(this.data.bm);
                    t.canvasContext.globalCompositeOperation = e;
                }
            },
            createRenderableComponents: function() {
                this.maskManager = new CVMaskElement(this.data, this);
            },
            hideElement: function() {
                this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
            },
            showElement: function() {
                this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
            },
            clearCanvas: function(t) {
                t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
            },
            prepareLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[0].getContext("2d");
                    this.clearCanvas(t), t.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
                }
            },
            exitLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[1], e = t.getContext("2d");
                    if (this.clearCanvas(e), e.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
                        var r = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                        r.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(r, 0, 0);
                    }
                    this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
                }
            },
            renderFrame: function(t) {
                if (!this.hidden && !this.data.hd && (1 !== this.data.td || t)) {
                    this.renderTransform(), this.renderRenderable(), this.setBlendMode();
                    var e = 0 === this.data.ty;
                    this.prepareLayer(), this.globalData.renderer.save(e), this.globalData.renderer.ctxTransform(this.finalTransform.mat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v), this.renderInnerContent(), this.globalData.renderer.restore(e), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
                }
            },
            destroy: function() {
                this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
            },
            mHelper: new Matrix
        }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1
        }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
        }, CVShapeElement.prototype.createStyleElement = function(t, e) {
            var r = {
                data: t,
                type: t.ty,
                preTransforms: this.transformsManager.addTransformSequence(e),
                transforms: [],
                elements: [],
                closed: !0 === t.hd
            }, i = {};
            if ("fl" === t.ty || "st" === t.ty ? (i.c = PropertyFactory.getProp(this, t.c, 1, 255, this), i.c.k || (r.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")")) : "gf" !== t.ty && "gs" !== t.ty || (i.s = PropertyFactory.getProp(this, t.s, 1, null, this), i.e = PropertyFactory.getProp(this, t.e, 1, null, this), i.h = PropertyFactory.getProp(this, t.h || {
                k: 0
            }, 0, .01, this), i.a = PropertyFactory.getProp(this, t.a || {
                k: 0
            }, 0, degToRads, this), i.g = new GradientProperty(this, t.g, this)), i.o = PropertyFactory.getProp(this, t.o, 0, .01, this), "st" === t.ty || "gs" === t.ty) {
                if (r.lc = lineCapEnum[t.lc || 2], r.lj = lineJoinEnum[t.lj || 2], 1 == t.lj && (r.ml = t.ml), i.w = PropertyFactory.getProp(this, t.w, 0, null, this), i.w.k || (r.wi = i.w.v), t.d) {
                    var a = new DashProperty(this, t.d, "canvas", this);
                    i.d = a, i.d.k || (r.da = i.d.dashArray, r.do = i.d.dashoffset[0]);
                }
            } else r.r = 2 === t.r ? "evenodd" : "nonzero";
            return this.stylesList.push(r), i.style = r, i;
        }, CVShapeElement.prototype.createGroupElement = function() {
            return {
                it: [],
                prevViewData: []
            };
        }, CVShapeElement.prototype.createTransformElement = function(t) {
            return {
                transform: {
                    opacity: 1,
                    _opMdf: !1,
                    key: this.transformsManager.getNewKey(),
                    op: PropertyFactory.getProp(this, t.o, 0, .01, this),
                    mProps: TransformPropertyFactory.getTransformProperty(this, t, this)
                }
            };
        }, CVShapeElement.prototype.createShapeElement = function(t) {
            var e = new CVShapeData(this, t, this.stylesList, this.transformsManager);
            return this.shapes.push(e), this.addShapeToModifiers(e), e;
        }, CVShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
        }, CVShapeElement.prototype.addTransformToStyleList = function(t) {
            var e, r = this.stylesList.length;
            for(e = 0; e < r; e += 1)this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
        }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
            var t, e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].closed || this.stylesList[t].transforms.pop();
        }, CVShapeElement.prototype.closeStyles = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e].closed = !0;
        }, CVShapeElement.prototype.searchShapes = function(t, e, r, i, a) {
            var s, n, o, h, l, p, f = t.length - 1, c = [], m = [], d = [].concat(a);
            for(s = f; s >= 0; s -= 1){
                if ((h = this.searchProcessedElement(t[s])) ? e[s] = r[h - 1] : t[s]._shouldRender = i, "fl" === t[s].ty || "st" === t[s].ty || "gf" === t[s].ty || "gs" === t[s].ty) h ? e[s].style.closed = !1 : e[s] = this.createStyleElement(t[s], d), c.push(e[s].style);
                else if ("gr" === t[s].ty) {
                    if (h) for(o = e[s].it.length, n = 0; n < o; n += 1)e[s].prevViewData[n] = e[s].it[n];
                    else e[s] = this.createGroupElement(t[s]);
                    this.searchShapes(t[s].it, e[s].it, e[s].prevViewData, i, d);
                } else "tr" === t[s].ty ? (h || (p = this.createTransformElement(t[s]), e[s] = p), d.push(e[s]), this.addTransformToStyleList(e[s])) : "sh" === t[s].ty || "rc" === t[s].ty || "el" === t[s].ty || "sr" === t[s].ty ? h || (e[s] = this.createShapeElement(t[s])) : "tm" === t[s].ty || "rd" === t[s].ty || "pb" === t[s].ty || "zz" === t[s].ty || "op" === t[s].ty ? (h ? (l = e[s]).closed = !1 : ((l = ShapeModifiers.getModifier(t[s].ty)).init(this, t[s]), e[s] = l, this.shapeModifiers.push(l)), m.push(l)) : "rp" === t[s].ty && (h ? (l = e[s]).closed = !0 : (l = ShapeModifiers.getModifier(t[s].ty), e[s] = l, l.init(this, t, s, e), this.shapeModifiers.push(l), i = !1), m.push(l));
                this.addProcessedElement(t[s], s + 1);
            }
            for(this.removeTransformFromStyleList(), this.closeStyles(c), f = m.length, s = 0; s < f; s += 1)m[s].closed = !0;
        }, CVShapeElement.prototype.renderInnerContent = function() {
            this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
        }, CVShapeElement.prototype.renderShapeTransform = function(t, e) {
            (t._opMdf || e.op._mdf || this._isFirstFrame) && (e.opacity = t.opacity, e.opacity *= e.op.v, e._opMdf = !0);
        }, CVShapeElement.prototype.drawLayer = function() {
            var t, e, r, i, a, s, n, o, h, l = this.stylesList.length, p = this.globalData.renderer, f = this.globalData.canvasContext;
            for(t = 0; t < l; t += 1)if (("st" !== (o = (h = this.stylesList[t]).type) && "gs" !== o || 0 !== h.wi) && h.data._shouldRender && 0 !== h.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                for(p.save(), s = h.elements, "st" === o || "gs" === o ? (f.strokeStyle = "st" === o ? h.co : h.grd, f.lineWidth = h.wi, f.lineCap = h.lc, f.lineJoin = h.lj, f.miterLimit = h.ml || 0) : f.fillStyle = "fl" === o ? h.co : h.grd, p.ctxOpacity(h.coOp), "st" !== o && "gs" !== o && f.beginPath(), p.ctxTransform(h.preTransforms.finalTransform.props), r = s.length, e = 0; e < r; e += 1){
                    for("st" !== o && "gs" !== o || (f.beginPath(), h.da && (f.setLineDash(h.da), f.lineDashOffset = h.do)), a = (n = s[e].trNodes).length, i = 0; i < a; i += 1)"m" === n[i].t ? f.moveTo(n[i].p[0], n[i].p[1]) : "c" === n[i].t ? f.bezierCurveTo(n[i].pts[0], n[i].pts[1], n[i].pts[2], n[i].pts[3], n[i].pts[4], n[i].pts[5]) : f.closePath();
                    "st" !== o && "gs" !== o || (f.stroke(), h.da && f.setLineDash(this.dashResetter));
                }
                "st" !== o && "gs" !== o && f.fill(h.r), p.restore();
            }
        }, CVShapeElement.prototype.renderShape = function(t, e, r, i) {
            var a, s;
            for(s = t, a = e.length - 1; a >= 0; a -= 1)"tr" === e[a].ty ? (s = r[a].transform, this.renderShapeTransform(t, s)) : "sh" === e[a].ty || "el" === e[a].ty || "rc" === e[a].ty || "sr" === e[a].ty ? this.renderPath(e[a], r[a]) : "fl" === e[a].ty ? this.renderFill(e[a], r[a], s) : "st" === e[a].ty ? this.renderStroke(e[a], r[a], s) : "gf" === e[a].ty || "gs" === e[a].ty ? this.renderGradientFill(e[a], r[a], s) : "gr" === e[a].ty ? this.renderShape(s, e[a].it, r[a].it) : e[a].ty;
            i && this.drawLayer();
        }, CVShapeElement.prototype.renderStyledShape = function(t, e) {
            if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                var r, i, a, s = t.trNodes, n = e.paths, o = n._length;
                s.length = 0;
                var h = t.transforms.finalTransform;
                for(a = 0; a < o; a += 1){
                    var l = n.shapes[a];
                    if (l && l.v) {
                        for(i = l._length, r = 1; r < i; r += 1)1 === r && s.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), s.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r - 1], l.i[r], l.v[r])
                        });
                        1 === i && s.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), l.c && i && (s.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r - 1], l.i[0], l.v[0])
                        }), s.push({
                            t: "z"
                        }));
                    }
                }
                t.trNodes = s;
            }
        }, CVShapeElement.prototype.renderPath = function(t, e) {
            if (!0 !== t.hd && t._shouldRender) {
                var r, i = e.styledShapes.length;
                for(r = 0; r < i; r += 1)this.renderStyledShape(e.styledShapes[r], e.sh);
            }
        }, CVShapeElement.prototype.renderFill = function(t, e, r) {
            var i = e.style;
            (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity);
        }, CVShapeElement.prototype.renderGradientFill = function(t, e, r) {
            var i, a = e.style;
            if (!a.grd || e.g._mdf || e.s._mdf || e.e._mdf || 1 !== t.t && (e.h._mdf || e.a._mdf)) {
                var s, n = this.globalData.canvasContext, o = e.s.v, h = e.e.v;
                if (1 === t.t) i = n.createLinearGradient(o[0], o[1], h[0], h[1]);
                else {
                    var l = Math.sqrt(Math.pow(o[0] - h[0], 2) + Math.pow(o[1] - h[1], 2)), p = Math.atan2(h[1] - o[1], h[0] - o[0]), f = e.h.v;
                    f >= 1 ? f = .99 : f <= -1 && (f = -0.99);
                    var c = l * f, m = Math.cos(p + e.a.v) * c + o[0], d = Math.sin(p + e.a.v) * c + o[1];
                    i = n.createRadialGradient(m, d, 0, o[0], o[1], l);
                }
                var u = t.g.p, y = e.g.c, g = 1;
                for(s = 0; s < u; s += 1)e.g._hasOpacity && e.g._collapsable && (g = e.g.o[2 * s + 1]), i.addColorStop(y[4 * s] / 100, "rgba(" + y[4 * s + 1] + "," + y[4 * s + 2] + "," + y[4 * s + 3] + "," + g + ")");
                a.grd = i;
            }
            a.coOp = e.o.v * r.opacity;
        }, CVShapeElement.prototype.renderStroke = function(t, e, r) {
            var i = e.style, a = e.d;
            a && (a._mdf || this._isFirstFrame) && (i.da = a.dashArray, i.do = a.dashoffset[0]), (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity), (e.w._mdf || this._isFirstFrame) && (i.wi = e.w.v);
        }, CVShapeElement.prototype.destroy = function() {
            this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement,
            ITextElement
        ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = !1;
            t.fc ? (e = !0, this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e;
            var r = !1;
            t.sc && (r = !0, this.values.stroke = this.buildColor(t.sc), this.values.sWidth = t.sw);
            var i, a, s, n, o, h, l, p, f, c, m, d, u = this.globalData.fontManager.getFontByName(t.f), y = t.l, g = this.mHelper;
            this.stroke = r, this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, a = t.finalText.length;
            var v = this.data.singleShape, b = .001 * t.tr * t.finalSize, x = 0, P = 0, E = !0, S = 0;
            for(i = 0; i < a; i += 1){
                n = (s = this.globalData.fontManager.getCharData(t.finalText[i], u.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily)) && s.data || {}, g.reset(), v && y[i].n && (x = -b, P += t.yOffset, P += E ? 1 : 0, E = !1), f = (l = n.shapes ? n.shapes[0].it : []).length, g.scale(t.finalSize / 100, t.finalSize / 100), v && this.applyTextPropertiesToMatrix(t, g, y[i].line, x, P), m = createSizedArray(f - 1);
                var C = 0;
                for(p = 0; p < f; p += 1)if ("sh" === l[p].ty) {
                    for(h = l[p].ks.k.i.length, c = l[p].ks.k, d = [], o = 1; o < h; o += 1)1 === o && d.push(g.applyToX(c.v[0][0], c.v[0][1], 0), g.applyToY(c.v[0][0], c.v[0][1], 0)), d.push(g.applyToX(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToY(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToX(c.i[o][0], c.i[o][1], 0), g.applyToY(c.i[o][0], c.i[o][1], 0), g.applyToX(c.v[o][0], c.v[o][1], 0), g.applyToY(c.v[o][0], c.v[o][1], 0));
                    d.push(g.applyToX(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToY(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToX(c.i[0][0], c.i[0][1], 0), g.applyToY(c.i[0][0], c.i[0][1], 0), g.applyToX(c.v[0][0], c.v[0][1], 0), g.applyToY(c.v[0][0], c.v[0][1], 0)), m[C] = d, C += 1;
                }
                v && (x += y[i].l, x += b), this.textSpans[S] ? this.textSpans[S].elem = m : this.textSpans[S] = {
                    elem: m
                }, S += 1;
            }
        }, CVTextElement.prototype.renderInnerContent = function() {
            var t, e, r, i, a, s, n = this.canvasContext;
            n.font = this.values.fValue, n.lineCap = "butt", n.lineJoin = "miter", n.miterLimit = 4, this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            var o, h = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
            e = l.length;
            var p, f, c = null, m = null, d = null;
            for(t = 0; t < e; t += 1)if (!l[t].n) {
                if ((o = h[t]) && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(o.p), this.globalData.renderer.ctxOpacity(o.o)), this.fill) {
                    for(o && o.fc ? c !== o.fc && (c = o.fc, n.fillStyle = o.fc) : c !== this.values.fill && (c = this.values.fill, n.fillStyle = this.values.fill), i = (p = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1)for(s = (f = p[r]).length, this.globalData.canvasContext.moveTo(f[0], f[1]), a = 2; a < s; a += 6)this.globalData.canvasContext.bezierCurveTo(f[a], f[a + 1], f[a + 2], f[a + 3], f[a + 4], f[a + 5]);
                    this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
                }
                if (this.stroke) {
                    for(o && o.sw ? d !== o.sw && (d = o.sw, n.lineWidth = o.sw) : d !== this.values.sWidth && (d = this.values.sWidth, n.lineWidth = this.values.sWidth), o && o.sc ? m !== o.sc && (m = o.sc, n.strokeStyle = o.sc) : m !== this.values.stroke && (m = this.values.stroke, n.strokeStyle = this.values.stroke), i = (p = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1)for(s = (f = p[r]).length, this.globalData.canvasContext.moveTo(f[0], f[1]), a = 2; a < s; a += 6)this.globalData.canvasContext.bezierCurveTo(f[a], f[a + 1], f[a + 2], f[a + 3], f[a + 4], f[a + 5]);
                    this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
                }
                o && this.globalData.renderer.restore();
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
            if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                var t = createTag("canvas");
                t.width = this.assetData.w, t.height = this.assetData.h;
                var e, r, i = t.getContext("2d"), a = this.img.width, s = this.img.height, n = a / s, o = this.assetData.w / this.assetData.h, h = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                n > o && "xMidYMid slice" === h || n < o && "xMidYMid slice" !== h ? e = (r = s) * o : r = (e = a) / o, i.drawImage(this.img, (a - e) / 2, (s - r) / 2, e, r, 0, 0, this.assetData.w, this.assetData.h), this.img = t;
            }
        }, CVImageElement.prototype.renderInnerContent = function() {
            this.canvasContext.drawImage(this.img, 0, 0);
        }, CVImageElement.prototype.destroy = function() {
            this.img = null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
            var t = this.canvasContext;
            t.fillStyle = this.data.sc, t.fillRect(0, 0, this.data.sw, this.data.sh);
        }, extendPrototype([
            BaseRenderer
        ], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t) {
            return new CVShapeElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createText = function(t) {
            return new CVTextElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createImage = function(t) {
            return new CVImageElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createSolid = function(t) {
            return new CVSolidElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t) {
            if (1 !== t[0] || 0 !== t[1] || 0 !== t[4] || 1 !== t[5] || 0 !== t[12] || 0 !== t[13]) {
                if (this.renderConfig.clearCanvas) {
                    this.transformMat.cloneFromProps(t);
                    var e = this.contextData.getTransform(), r = e.props;
                    this.transformMat.transform(r[0], r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8], r[9], r[10], r[11], r[12], r[13], r[14], r[15]), e.cloneFromProps(this.transformMat.props);
                    var i = e.props;
                    this.canvasContext.setTransform(i[0], i[1], i[4], i[5], i[12], i[13]);
                } else this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
            }
        }, CanvasRendererBase.prototype.ctxOpacity = function(t) {
            var e = this.contextData.getOpacity();
            if (!this.renderConfig.clearCanvas) return this.canvasContext.globalAlpha *= t < 0 ? 0 : t, void (this.globalData.currentGlobalAlpha = e);
            e *= t < 0 ? 0 : t, this.contextData.setOpacity(e), this.globalData.currentGlobalAlpha !== e && (this.canvasContext.globalAlpha = e, this.globalData.currentGlobalAlpha = e);
        }, CanvasRendererBase.prototype.reset = function() {
            this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.save = function(t) {
            this.renderConfig.clearCanvas ? (t && this.canvasContext.save(), this.contextData.push()) : this.canvasContext.save();
        }, CanvasRendererBase.prototype.restore = function(t) {
            if (this.renderConfig.clearCanvas) {
                t && (this.canvasContext.restore(), this.globalData.blendMode = "source-over");
                var e = this.contextData.pop(), r = e.transform, i = e.opacity;
                this.canvasContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]), this.globalData.currentGlobalAlpha !== i && (this.canvasContext.globalAlpha = i, this.globalData.currentGlobalAlpha = i);
            } else this.canvasContext.restore();
        }, CanvasRendererBase.prototype.configAnimation = function(t) {
            if (this.animationItem.wrapper) {
                this.animationItem.container = createTag("canvas");
                var e = this.animationItem.container.style;
                e.width = "100%", e.height = "100%";
                var r = "0px 0px 0px";
                e.transformOrigin = r, e.mozTransformOrigin = r, e.webkitTransformOrigin = r, e["-webkit-transform"] = r, e.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
            } else this.canvasContext = this.renderConfig.context;
            this.data = t, this.layers = t.layers, this.transformCanvas = {
                w: t.w,
                h: t.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0
            }, this.setupGlobalData(t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t.layers.length), this.updateContainerSize();
        }, CanvasRendererBase.prototype.updateContainerSize = function(t, e) {
            var r, i, a, s;
            if (this.reset(), t ? (r = t, i = e, this.canvasContext.canvas.width = r, this.canvasContext.canvas.height = i) : (this.animationItem.wrapper && this.animationItem.container ? (r = this.animationItem.wrapper.offsetWidth, i = this.animationItem.wrapper.offsetHeight) : (r = this.canvasContext.canvas.width, i = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r * this.renderConfig.dpr, this.canvasContext.canvas.height = i * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
                var n = this.renderConfig.preserveAspectRatio.split(" "), o = n[1] || "meet", h = n[0] || "xMidYMid", l = h.substr(0, 4), p = h.substr(4);
                a = r / i, (s = this.transformCanvas.w / this.transformCanvas.h) > a && "meet" === o || s < a && "slice" === o ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === l && (s < a && "meet" === o || s > a && "slice" === o) ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === l && (s < a && "meet" === o || s > a && "slice" === o) ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === p && (s > a && "meet" === o || s < a && "slice" === o) ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === p && (s > a && "meet" === o || s < a && "slice" === o) ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
            } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
            this.transformCanvas.props = [
                this.transformCanvas.sx,
                0,
                0,
                0,
                0,
                this.transformCanvas.sy,
                0,
                0,
                0,
                0,
                1,
                0,
                this.transformCanvas.tx,
                this.transformCanvas.ty,
                0,
                1
            ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
        }, CanvasRendererBase.prototype.destroy = function() {
            var t;
            for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t = (this.layers ? this.layers.length : 0) - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy();
            this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
        }, CanvasRendererBase.prototype.renderFrame = function(t, e) {
            if ((this.renderedFrame !== t || !0 !== this.renderConfig.clearCanvas || e) && !this.destroyed && -1 !== t) {
                var r;
                this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e, this.globalData.projectInterface.currentFrame = t;
                var i = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), r = 0; r < i; r += 1)(this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
                if (this.globalData._mdf) {
                    for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
                    !0 !== this.renderConfig.clearCanvas && this.restore();
                }
            }
        }, CanvasRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                var r = this.createItem(this.layers[t], this, this.globalData);
                e[t] = r, r.initExpressions();
            }
        }, CanvasRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, CanvasRendererBase.prototype.hide = function() {
            this.animationItem.container.style.display = "none";
        }, CanvasRendererBase.prototype.show = function() {
            this.animationItem.container.style.display = "block";
        }, extendPrototype([
            CanvasRendererBase,
            ICompElement,
            CVBaseElement
        ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
            var t, e = this.canvasContext;
            for(e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip(), t = this.layers.length - 1; t >= 0; t -= 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, CVCompElement.prototype.destroy = function() {
            var t;
            for(t = this.layers.length - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy();
            this.layers = null, this.elements = null;
        }, CVCompElement.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, extendPrototype([
            CanvasRendererBase
        ], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, HBaseElement.prototype = {
            checkBlendMode: function() {},
            initRendererElement: function() {
                this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
            },
            createContainerElements: function() {
                this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                var t = this.transformedElement ? this.transformedElement.style : {};
                if (this.finalTransform._matMdf) {
                    var e = this.finalTransform.mat.toCSS();
                    t.transform = e, t.webkitTransform = e;
                }
                this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
            },
            renderFrame: function() {
                this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
            },
            destroy: function() {
                this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData);
            },
            addEffects: function() {},
            setMatte: function() {}
        }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], HSolidElement), HSolidElement.prototype.createContent = function() {
            var t;
            this.data.hasMask ? ((t = createNS("rect")).setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t = createTag("div")).style.width = this.data.sw + "px", t.style.height = this.data.sh + "px", t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t);
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HSolidElement,
            SVGShapeElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
            var t;
            if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t = this.svgElement;
            else {
                t = createNS("svg");
                var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                t.setAttribute("width", e.w), t.setAttribute("height", e.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
            }
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t;
        }, HShapeElement.prototype.getTransformedPoint = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)e = t[r].mProps.v.applyToPointArray(e[0], e[1], 0);
            return e;
        }, HShapeElement.prototype.calculateShapeBoundingBox = function(t, e) {
            var r, i, a, s, n, o = t.sh.v, h = t.transformers, l = o._length;
            if (!(l <= 1)) {
                for(r = 0; r < l - 1; r += 1)i = this.getTransformedPoint(h, o.v[r]), a = this.getTransformedPoint(h, o.o[r]), s = this.getTransformedPoint(h, o.i[r + 1]), n = this.getTransformedPoint(h, o.v[r + 1]), this.checkBounds(i, a, s, n, e);
                o.c && (i = this.getTransformedPoint(h, o.v[r]), a = this.getTransformedPoint(h, o.o[r]), s = this.getTransformedPoint(h, o.i[0]), n = this.getTransformedPoint(h, o.v[0]), this.checkBounds(i, a, s, n, e));
            }
        }, HShapeElement.prototype.checkBounds = function(t, e, r, i, a) {
            this.getBoundsOfCurve(t, e, r, i);
            var s = this.shapeBoundingBox;
            a.x = bmMin(s.left, a.x), a.xMax = bmMax(s.right, a.xMax), a.y = bmMin(s.top, a.y), a.yMax = bmMax(s.bottom, a.yMax);
        }, HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0
        }, HShapeElement.prototype.getBoundsOfCurve = function(t, e, r, i) {
            for(var a, s, n, o, h, l, p, f = [
                [
                    t[0],
                    i[0]
                ],
                [
                    t[1],
                    i[1]
                ]
            ], c = 0; c < 2; ++c)s = 6 * t[c] - 12 * e[c] + 6 * r[c], a = -3 * t[c] + 9 * e[c] - 9 * r[c] + 3 * i[c], n = 3 * e[c] - 3 * t[c], s |= 0, n |= 0, 0 === (a |= 0) && 0 === s || (0 === a ? (o = -n / s) > 0 && o < 1 && f[c].push(this.calculateF(o, t, e, r, i, c)) : (h = s * s - 4 * n * a) >= 0 && ((l = (-s + bmSqrt(h)) / (2 * a)) > 0 && l < 1 && f[c].push(this.calculateF(l, t, e, r, i, c)), (p = (-s - bmSqrt(h)) / (2 * a)) > 0 && p < 1 && f[c].push(this.calculateF(p, t, e, r, i, c))));
            this.shapeBoundingBox.left = bmMin.apply(null, f[0]), this.shapeBoundingBox.top = bmMin.apply(null, f[1]), this.shapeBoundingBox.right = bmMax.apply(null, f[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, f[1]);
        }, HShapeElement.prototype.calculateF = function(t, e, r, i, a, s) {
            return bmPow(1 - t, 3) * e[s] + 3 * bmPow(1 - t, 2) * t * r[s] + 3 * (1 - t) * bmPow(t, 2) * i[s] + bmPow(t, 3) * a[s];
        }, HShapeElement.prototype.calculateBoundingBox = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)t[r] && t[r].sh ? this.calculateShapeBoundingBox(t[r], e) : t[r] && t[r].it ? this.calculateBoundingBox(t[r].it, e) : t[r] && t[r].style && t[r].w && this.expandStrokeBoundingBox(t[r].w, e);
        }, HShapeElement.prototype.expandStrokeBoundingBox = function(t, e) {
            var r = 0;
            if (t.keyframes) {
                for(var i = 0; i < t.keyframes.length; i += 1){
                    var a = t.keyframes[i].s;
                    a > r && (r = a);
                }
                r *= t.mult;
            } else r = t.v * t.mult;
            e.x -= r, e.xMax += r, e.y -= r, e.yMax += r;
        }, HShapeElement.prototype.currentBoxContains = function(t) {
            return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
        }, HShapeElement.prototype.renderInnerContent = function() {
            if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
                var t = this.tempBoundingBox, e = 999999;
                if (t.x = e, t.xMax = -e, t.y = e, t.yMax = -e, this.calculateBoundingBox(this.itemsData, t), t.width = t.xMax < t.x ? 0 : t.xMax - t.x, t.height = t.yMax < t.y ? 0 : t.yMax - t.y, this.currentBoxContains(t)) return;
                var r = !1;
                if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width, this.shapeCont.setAttribute("width", t.width), r = !0), this.currentBBox.h !== t.height && (this.currentBBox.h = t.height, this.shapeCont.setAttribute("height", t.height), r = !0), r || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
                    this.currentBBox.w = t.width, this.currentBBox.h = t.height, this.currentBBox.x = t.x, this.currentBBox.y = t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                    var i = this.shapeCont.style, a = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    i.transform = a, i.webkitTransform = a;
                }
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], HTextElement), HTextElement.prototype.createContent = function() {
            if (this.isMasked = this.checkMasks(), this.isMasked) {
                this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                var t = createNS("g");
                this.maskedElement.appendChild(t), this.innerElem = t;
            } else this.renderType = "html", this.innerElem = this.layerElement;
            this.checkParenting();
        }, HTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = this.innerElem.style, r = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
            e.fill = r, e.color = r, t.sc && (e.stroke = this.buildColor(t.sc), e.strokeWidth = t.sw + "px");
            var i, a, s = this.globalData.fontManager.getFontByName(t.f);
            if (!this.globalData.fontManager.chars) {
                if (e.fontSize = t.finalSize + "px", e.lineHeight = t.finalSize + "px", s.fClass) this.innerElem.className = s.fClass;
                else {
                    e.fontFamily = s.fFamily;
                    var n = t.fWeight, o = t.fStyle;
                    e.fontStyle = o, e.fontWeight = n;
                }
            }
            var h, l, p, f = t.l;
            a = f.length;
            var c, m = this.mHelper, d = "", u = 0;
            for(i = 0; i < a; i += 1){
                if (this.globalData.fontManager.chars ? (this.textPaths[u] ? h = this.textPaths[u] : ((h = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h.setAttribute("stroke-linejoin", lineJoinEnum[2]), h.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[u] ? p = (l = this.textSpans[u]).children[0] : ((l = createTag("div")).style.lineHeight = 0, (p = createNS("svg")).appendChild(h), styleDiv(l)))) : this.isMasked ? h = this.textPaths[u] ? this.textPaths[u] : createNS("text") : this.textSpans[u] ? (l = this.textSpans[u], h = this.textPaths[u]) : (styleDiv(l = createTag("span")), styleDiv(h = createTag("span")), l.appendChild(h)), this.globalData.fontManager.chars) {
                    var y, g = this.globalData.fontManager.getCharData(t.finalText[i], s.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
                    if (y = g ? g.data : null, m.reset(), y && y.shapes && y.shapes.length && (c = y.shapes[0].it, m.scale(t.finalSize / 100, t.finalSize / 100), d = this.createPathShape(m, c), h.setAttribute("d", d)), this.isMasked) this.innerElem.appendChild(h);
                    else {
                        if (this.innerElem.appendChild(l), y && y.shapes) {
                            document.body.appendChild(p);
                            var v = p.getBBox();
                            p.setAttribute("width", v.width + 2), p.setAttribute("height", v.height + 2), p.setAttribute("viewBox", v.x - 1 + " " + (v.y - 1) + " " + (v.width + 2) + " " + (v.height + 2));
                            var b = p.style, x = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)";
                            b.transform = x, b.webkitTransform = x, f[i].yOffset = v.y - 1;
                        } else p.setAttribute("width", 1), p.setAttribute("height", 1);
                        l.appendChild(p);
                    }
                } else if (h.textContent = f[i].val, h.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h);
                else {
                    this.innerElem.appendChild(l);
                    var P = h.style, E = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
                    P.transform = E, P.webkitTransform = E;
                }
                this.isMasked ? this.textSpans[u] = h : this.textSpans[u] = l, this.textSpans[u].style.display = "block", this.textPaths[u] = h, u += 1;
            }
            for(; u < this.textSpans.length;)this.textSpans[u].style.display = "none", u += 1;
        }, HTextElement.prototype.renderInnerContent = function() {
            var t;
            if (this.data.singleShape) {
                if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                if (this.isMasked && this.finalTransform._matMdf) {
                    this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t = this.svgElement.style;
                    var e = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                    t.transform = e, t.webkitTransform = e;
                }
            }
            if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                var r, i, a, s, n, o = 0, h = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
                for(i = l.length, r = 0; r < i; r += 1)l[r].n ? o += 1 : (s = this.textSpans[r], n = this.textPaths[r], a = h[o], o += 1, a._mdf.m && (this.isMasked ? s.setAttribute("transform", a.m) : (s.style.webkitTransform = a.m, s.style.transform = a.m)), s.style.opacity = a.o, a.sw && a._mdf.sw && n.setAttribute("stroke-width", a.sw), a.sc && a._mdf.sc && n.setAttribute("stroke", a.sc), a.fc && a._mdf.fc && (n.setAttribute("fill", a.fc), n.style.color = a.fc));
                if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var p = this.innerElem.getBBox();
                    this.currentBBox.w !== p.width && (this.currentBBox.w = p.width, this.svgElement.setAttribute("width", p.width)), this.currentBBox.h !== p.height && (this.currentBBox.h = p.height, this.svgElement.setAttribute("height", p.height));
                    if (this.currentBBox.w !== p.width + 2 || this.currentBBox.h !== p.height + 2 || this.currentBBox.x !== p.x - 1 || this.currentBBox.y !== p.y - 1) {
                        this.currentBBox.w = p.width + 2, this.currentBBox.h = p.height + 2, this.currentBBox.x = p.x - 1, this.currentBBox.y = p.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t = this.svgElement.style;
                        var f = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        t.transform = f, t.webkitTransform = f;
                    }
                }
            }
        }, extendPrototype([
            BaseElement,
            FrameElement,
            HierarchyElement
        ], HCameraElement), HCameraElement.prototype.setup = function() {
            var t, e, r, i, a = this.comp.threeDElements.length;
            for(t = 0; t < a; t += 1)if ("3d" === (e = this.comp.threeDElements[t]).type) {
                r = e.perspectiveElem.style, i = e.container.style;
                var s = this.pe.v + "px", n = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                r.perspective = s, r.webkitPerspective = s, i.transformOrigin = "0px 0px 0px", i.mozTransformOrigin = "0px 0px 0px", i.webkitTransformOrigin = "0px 0px 0px", r.transform = n, r.webkitTransform = n;
            }
        }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
            var t, e, r = this._isFirstFrame;
            if (this.hierarchy) for(e = this.hierarchy.length, t = 0; t < e; t += 1)r = this.hierarchy[t].finalTransform.mProp._mdf || r;
            if (r || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                if (this.mat.reset(), this.hierarchy) for(t = e = this.hierarchy.length - 1; t >= 0; t -= 1){
                    var i = this.hierarchy[t].finalTransform.mProp;
                    this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]), this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]), this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v), this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]), this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
                }
                if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                    var a;
                    a = this.p ? [
                        this.p.v[0] - this.a.v[0],
                        this.p.v[1] - this.a.v[1],
                        this.p.v[2] - this.a.v[2]
                    ] : [
                        this.px.v - this.a.v[0],
                        this.py.v - this.a.v[1],
                        this.pz.v - this.a.v[2]
                    ];
                    var s = Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2)), n = [
                        a[0] / s,
                        a[1] / s,
                        a[2] / s
                    ], o = Math.sqrt(n[2] * n[2] + n[0] * n[0]), h = Math.atan2(n[1], o), l = Math.atan2(n[0], -n[2]);
                    this.mat.rotateY(l).rotateX(-h);
                }
                this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
                var p = !this._prevMat.equals(this.mat);
                if ((p || this.pe._mdf) && this.comp.threeDElements) {
                    var f, c, m;
                    for(e = this.comp.threeDElements.length, t = 0; t < e; t += 1)if ("3d" === (f = this.comp.threeDElements[t]).type) {
                        if (p) {
                            var d = this.mat.toCSS();
                            (m = f.container.style).transform = d, m.webkitTransform = d;
                        }
                        this.pe._mdf && ((c = f.perspectiveElem.style).perspective = this.pe.v + "px", c.webkitPerspective = this.pe.v + "px");
                    }
                    this.mat.clone(this._prevMat);
                }
            }
            this._isFirstFrame = !1;
        }, HCameraElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
            return null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HSolidElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HImageElement), HImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData), e = new Image;
            this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e), e.crossOrigin = "anonymous", e.src = t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
        }, extendPrototype([
            BaseRenderer
        ], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, HybridRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                var i = this.layers[e];
                if (i.ddd && this.supports3d) this.addTo3dContainer(r, e);
                else if (this.threeDElements) this.addTo3dContainer(r, e);
                else {
                    for(var a, s, n = 0; n < e;)this.elements[n] && !0 !== this.elements[n] && this.elements[n].getBaseElement && (s = this.elements[n], a = (this.layers[n].ddd ? this.getThreeDContainerByPos(n) : s.getBaseElement()) || a), n += 1;
                    a ? i.ddd && this.supports3d || this.layerElement.insertBefore(r, a) : i.ddd && this.supports3d || this.layerElement.appendChild(r);
                }
            }
        }, HybridRendererBase.prototype.createShape = function(t) {
            return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createText = function(t) {
            return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createCamera = function(t) {
            return this.camera = new HCameraElement(t, this.globalData, this), this.camera;
        }, HybridRendererBase.prototype.createImage = function(t) {
            return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createSolid = function(t) {
            return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
            for(var e = 0, r = this.threeDElements.length; e < r;){
                if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t) return this.threeDElements[e].perspectiveElem;
                e += 1;
            }
            return null;
        }, HybridRendererBase.prototype.createThreeDContainer = function(t, e) {
            var r, i, a = createTag("div");
            styleDiv(a);
            var s = createTag("div");
            if (styleDiv(s), "3d" === e) {
                (r = a.style).width = this.globalData.compSize.w + "px", r.height = this.globalData.compSize.h + "px";
                r.webkitTransformOrigin = "50% 50%", r.mozTransformOrigin = "50% 50%", r.transformOrigin = "50% 50%";
                var n = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                (i = s.style).transform = n, i.webkitTransform = n;
            }
            a.appendChild(s);
            var o = {
                container: s,
                perspectiveElem: a,
                startPos: t,
                endPos: t,
                type: e
            };
            return this.threeDElements.push(o), o;
        }, HybridRendererBase.prototype.build3dContainers = function() {
            var t, e, r = this.layers.length, i = "";
            for(t = 0; t < r; t += 1)this.layers[t].ddd && 3 !== this.layers[t].ty ? ("3d" !== i && (i = "3d", e = this.createThreeDContainer(t, "3d")), e.endPos = Math.max(e.endPos, t)) : ("2d" !== i && (i = "2d", e = this.createThreeDContainer(t, "2d")), e.endPos = Math.max(e.endPos, t));
            for(t = (r = this.threeDElements.length) - 1; t >= 0; t -= 1)this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
        }, HybridRendererBase.prototype.addTo3dContainer = function(t, e) {
            for(var r = 0, i = this.threeDElements.length; r < i;){
                if (e <= this.threeDElements[r].endPos) {
                    for(var a, s = this.threeDElements[r].startPos; s < e;)this.elements[s] && this.elements[s].getBaseElement && (a = this.elements[s].getBaseElement()), s += 1;
                    a ? this.threeDElements[r].container.insertBefore(t, a) : this.threeDElements[r].container.appendChild(t);
                    break;
                }
                r += 1;
            }
        }, HybridRendererBase.prototype.configAnimation = function(t) {
            var e = createTag("div"), r = this.animationItem.wrapper, i = e.style;
            i.width = t.w + "px", i.height = t.h + "px", this.resizerElem = e, styleDiv(e), i.transformStyle = "flat", i.mozTransformStyle = "flat", i.webkitTransformStyle = "flat", this.renderConfig.className && e.setAttribute("class", this.renderConfig.className), r.appendChild(e), i.overflow = "hidden";
            var a = createNS("svg");
            a.setAttribute("width", "1"), a.setAttribute("height", "1"), styleDiv(a), this.resizerElem.appendChild(a);
            var s = createNS("defs");
            a.appendChild(s), this.data = t, this.setupGlobalData(t, a), this.globalData.defs = s, this.layers = t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
        }, HybridRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, HybridRendererBase.prototype.updateContainerSize = function() {
            var t, e, r, i, a = this.animationItem.wrapper.offsetWidth, s = this.animationItem.wrapper.offsetHeight, n = a / s;
            this.globalData.compSize.w / this.globalData.compSize.h > n ? (t = a / this.globalData.compSize.w, e = a / this.globalData.compSize.w, r = 0, i = (s - this.globalData.compSize.h * (a / this.globalData.compSize.w)) / 2) : (t = s / this.globalData.compSize.h, e = s / this.globalData.compSize.h, r = (a - this.globalData.compSize.w * (s / this.globalData.compSize.h)) / 2, i = 0);
            var o = this.resizerElem.style;
            o.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + e + ",0,0,0,0,1,0," + r + "," + i + ",0,1)", o.transform = o.webkitTransform;
        }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
            this.resizerElem.style.display = "none";
        }, HybridRendererBase.prototype.show = function() {
            this.resizerElem.style.display = "block";
        }, HybridRendererBase.prototype.initItems = function() {
            if (this.buildAllItems(), this.camera) this.camera.setup();
            else {
                var t, e = this.globalData.compSize.w, r = this.globalData.compSize.h, i = this.threeDElements.length;
                for(t = 0; t < i; t += 1){
                    var a = this.threeDElements[t].perspectiveElem.style;
                    a.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2)) + "px", a.perspective = a.webkitPerspective;
                }
            }
        }, HybridRendererBase.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length, i = createTag("div");
            for(e = 0; e < r; e += 1)if (t[e].xt) {
                var a = this.createComp(t[e], i, this.globalData.comp, null);
                a.initExpressions(), this.globalData.projectInterface.registerComposition(a);
            }
        }, extendPrototype([
            HybridRendererBase,
            ICompElement,
            HBaseElement
        ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
            this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
        }, HCompElement.prototype.addTo3dContainer = function(t, e) {
            for(var r, i = 0; i < e;)this.elements[i] && this.elements[i].getBaseElement && (r = this.elements[i].getBaseElement()), i += 1;
            r ? this.layerElement.insertBefore(t, r) : this.layerElement.appendChild(t);
        }, HCompElement.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            HybridRendererBase
        ], HybridRenderer), HybridRenderer.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        };
        var CompExpressionInterface = function(t) {
            function e(e) {
                for(var r = 0, i = t.layers.length; r < i;){
                    if (t.layers[r].nm === e || t.layers[r].ind === e) return t.elements[r].layerInterface;
                    r += 1;
                }
                return null;
            }
            return Object.defineProperty(e, "_name", {
                value: t.data.nm
            }), e.layer = e, e.pixelAspect = 1, e.height = t.data.h || t.globalData.compSize.h, e.width = t.data.w || t.globalData.compSize.w, e.pixelAspect = 1, e.frameDuration = 1 / t.globalData.frameRate, e.displayStartTime = 0, e.numLayers = t.layers.length, e;
        }, Expressions = function() {
            var t = {};
            return t.initExpressions = function(t) {
                var e = 0, r = [];
                t.renderer.compInterface = CompExpressionInterface(t.renderer), t.renderer.globalData.projectInterface.registerComposition(t.renderer), t.renderer.globalData.pushExpression = function() {
                    e += 1;
                }, t.renderer.globalData.popExpression = function() {
                    0 === (e -= 1) && function() {
                        var t, e = r.length;
                        for(t = 0; t < e; t += 1)r[t].release();
                        r.length = 0;
                    }();
                }, t.renderer.globalData.registerExpressionProperty = function(t) {
                    -1 === r.indexOf(t) && r.push(t);
                };
            }, t;
        }(), MaskManagerInterface = function() {
            function t(t, e) {
                this._mask = t, this._data = e;
            }
            Object.defineProperty(t.prototype, "maskPath", {
                get: function() {
                    return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                }
            }), Object.defineProperty(t.prototype, "maskOpacity", {
                get: function() {
                    return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                }
            });
            return function(e) {
                var r, i = createSizedArray(e.viewData.length), a = e.viewData.length;
                for(r = 0; r < a; r += 1)i[r] = new t(e.viewData[r], e.masksProperties[r]);
                return function(t) {
                    for(r = 0; r < a;){
                        if (e.masksProperties[r].nm === t) return i[r];
                        r += 1;
                    }
                    return null;
                };
            };
        }(), ExpressionPropertyInterface = function() {
            var t = {
                pv: 0,
                v: 0,
                mult: 1
            }, e = {
                pv: [
                    0,
                    0,
                    0
                ],
                v: [
                    0,
                    0,
                    0
                ],
                mult: 1
            };
            function r(t, e, r) {
                Object.defineProperty(t, "velocity", {
                    get: function() {
                        return e.getVelocityAtTime(e.comp.currentFrame);
                    }
                }), t.numKeys = e.keyframes ? e.keyframes.length : 0, t.key = function(i) {
                    if (!t.numKeys) return 0;
                    var a = "";
                    a = "s" in e.keyframes[i - 1] ? e.keyframes[i - 1].s : "e" in e.keyframes[i - 2] ? e.keyframes[i - 2].e : e.keyframes[i - 2].s;
                    var s = "unidimensional" === r ? new Number(a) : Object.assign({}, a);
                    return s.time = e.keyframes[i - 1].t / e.elem.comp.globalData.frameRate, s.value = "unidimensional" === r ? a[0] : a, s;
                }, t.valueAtTime = e.getValueAtTime, t.speedAtTime = e.getSpeedAtTime, t.velocityAtTime = e.getVelocityAtTime, t.propertyGroup = e.propertyGroup;
            }
            function i() {
                return t;
            }
            return function(a) {
                return a ? "unidimensional" === a.propType ? function(e) {
                    e && "pv" in e || (e = t);
                    var i = 1 / e.mult, a = e.pv * i, s = new Number(a);
                    return s.value = a, r(s, e, "unidimensional"), function() {
                        return e.k && e.getValue(), a = e.v * i, s.value !== a && ((s = new Number(a)).value = a, r(s, e, "unidimensional")), s;
                    };
                }(a) : function(t) {
                    t && "pv" in t || (t = e);
                    var i = 1 / t.mult, a = t.data && t.data.l || t.pv.length, s = createTypedArray("float32", a), n = createTypedArray("float32", a);
                    return s.value = n, r(s, t, "multidimensional"), function() {
                        t.k && t.getValue();
                        for(var e = 0; e < a; e += 1)n[e] = t.v[e] * i, s[e] = n[e];
                        return s;
                    };
                }(a) : i;
            };
        }(), TransformExpressionInterface = function(t) {
            function e(t) {
                switch(t){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return e.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return e.rotation;
                    case "ADBE Rotate X":
                        return e.xRotation;
                    case "ADBE Rotate Y":
                        return e.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return e.position;
                    case "ADBE Position_0":
                        return e.xPosition;
                    case "ADBE Position_1":
                        return e.yPosition;
                    case "ADBE Position_2":
                        return e.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return e.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return e.opacity;
                    default:
                        return null;
                }
            }
            var r, i, a, s;
            return Object.defineProperty(e, "rotation", {
                get: ExpressionPropertyInterface(t.r || t.rz)
            }), Object.defineProperty(e, "zRotation", {
                get: ExpressionPropertyInterface(t.rz || t.r)
            }), Object.defineProperty(e, "xRotation", {
                get: ExpressionPropertyInterface(t.rx)
            }), Object.defineProperty(e, "yRotation", {
                get: ExpressionPropertyInterface(t.ry)
            }), Object.defineProperty(e, "scale", {
                get: ExpressionPropertyInterface(t.s)
            }), t.p ? s = ExpressionPropertyInterface(t.p) : (r = ExpressionPropertyInterface(t.px), i = ExpressionPropertyInterface(t.py), t.pz && (a = ExpressionPropertyInterface(t.pz))), Object.defineProperty(e, "position", {
                get: function() {
                    return t.p ? s() : [
                        r(),
                        i(),
                        a ? a() : 0
                    ];
                }
            }), Object.defineProperty(e, "xPosition", {
                get: ExpressionPropertyInterface(t.px)
            }), Object.defineProperty(e, "yPosition", {
                get: ExpressionPropertyInterface(t.py)
            }), Object.defineProperty(e, "zPosition", {
                get: ExpressionPropertyInterface(t.pz)
            }), Object.defineProperty(e, "anchorPoint", {
                get: ExpressionPropertyInterface(t.a)
            }), Object.defineProperty(e, "opacity", {
                get: ExpressionPropertyInterface(t.o)
            }), Object.defineProperty(e, "skew", {
                get: ExpressionPropertyInterface(t.sk)
            }), Object.defineProperty(e, "skewAxis", {
                get: ExpressionPropertyInterface(t.sa)
            }), Object.defineProperty(e, "orientation", {
                get: ExpressionPropertyInterface(t.or)
            }), e;
        }, LayerExpressionInterface = function() {
            function t(t) {
                var e = new Matrix;
                void 0 !== t ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e) : this._elem.finalTransform.mProp.applyToMatrix(e);
                return e;
            }
            function e(t, e) {
                var r = this.getMatrix(e);
                return r.props[12] = 0, r.props[13] = 0, r.props[14] = 0, this.applyPoint(r, t);
            }
            function r(t, e) {
                var r = this.getMatrix(e);
                return this.applyPoint(r, t);
            }
            function i(t, e) {
                var r = this.getMatrix(e);
                return r.props[12] = 0, r.props[13] = 0, r.props[14] = 0, this.invertPoint(r, t);
            }
            function a(t, e) {
                var r = this.getMatrix(e);
                return this.invertPoint(r, t);
            }
            function s(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                }
                return t.applyToPointArray(e[0], e[1], e[2] || 0);
            }
            function n(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                }
                return t.inversePoint(e);
            }
            function o(t) {
                var e = new Matrix;
                if (e.reset(), this._elem.finalTransform.mProp.applyToMatrix(e), this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(e);
                    return e.inversePoint(t);
                }
                return e.inversePoint(t);
            }
            function h() {
                return [
                    1,
                    1,
                    1,
                    1
                ];
            }
            return function(l) {
                var p;
                function f(t) {
                    switch(t){
                        case "ADBE Root Vectors Group":
                        case "Contents":
                        case 2:
                            return f.shapeInterface;
                        case 1:
                        case 6:
                        case "Transform":
                        case "transform":
                        case "ADBE Transform Group":
                            return p;
                        case 4:
                        case "ADBE Effect Parade":
                        case "effects":
                        case "Effects":
                            return f.effect;
                        case "ADBE Text Properties":
                            return f.textInterface;
                        default:
                            return null;
                    }
                }
                f.getMatrix = t, f.invertPoint = n, f.applyPoint = s, f.toWorld = r, f.toWorldVec = e, f.fromWorld = a, f.fromWorldVec = i, f.toComp = r, f.fromComp = o, f.sampleImage = h, f.sourceRectAtTime = l.sourceRectAtTime.bind(l), f._elem = l;
                var c = getDescriptor(p = TransformExpressionInterface(l.finalTransform.mProp), "anchorPoint");
                return Object.defineProperties(f, {
                    hasParent: {
                        get: function() {
                            return l.hierarchy.length;
                        }
                    },
                    parent: {
                        get: function() {
                            return l.hierarchy[0].layerInterface;
                        }
                    },
                    rotation: getDescriptor(p, "rotation"),
                    scale: getDescriptor(p, "scale"),
                    position: getDescriptor(p, "position"),
                    opacity: getDescriptor(p, "opacity"),
                    anchorPoint: c,
                    anchor_point: c,
                    transform: {
                        get: function() {
                            return p;
                        }
                    },
                    active: {
                        get: function() {
                            return l.isInRange;
                        }
                    }
                }), f.startTime = l.data.st, f.index = l.data.ind, f.source = l.data.refId, f.height = 0 === l.data.ty ? l.data.h : 100, f.width = 0 === l.data.ty ? l.data.w : 100, f.inPoint = l.data.ip / l.comp.globalData.frameRate, f.outPoint = l.data.op / l.comp.globalData.frameRate, f._name = l.data.nm, f.registerMaskInterface = function(t) {
                    f.mask = new MaskManagerInterface(t, l);
                }, f.registerEffectsInterface = function(t) {
                    f.effect = t;
                }, f;
            };
        }(), propertyGroupFactory = function(t, e) {
            return function(r) {
                return (r = void 0 === r ? 1 : r) <= 0 ? t : e(r - 1);
            };
        }, PropertyInterface = function(t, e) {
            var r = {
                _name: t
            };
            return function(t) {
                return (t = void 0 === t ? 1 : t) <= 0 ? r : e(t - 1);
            };
        }, EffectsExpressionInterface = function() {
            function t(r, i, a, s) {
                function n(t) {
                    for(var e = r.ef, i = 0, a = e.length; i < a;){
                        if (t === e[i].nm || t === e[i].mn || t === e[i].ix) return 5 === e[i].ty ? l[i] : l[i]();
                        i += 1;
                    }
                    throw new Error;
                }
                var o, h = propertyGroupFactory(n, a), l = [], p = r.ef.length;
                for(o = 0; o < p; o += 1)5 === r.ef[o].ty ? l.push(t(r.ef[o], i.effectElements[o], i.effectElements[o].propertyGroup, s)) : l.push(e(i.effectElements[o], r.ef[o].ty, s, h));
                return "ADBE Color Control" === r.mn && Object.defineProperty(n, "color", {
                    get: function() {
                        return l[0]();
                    }
                }), Object.defineProperties(n, {
                    numProperties: {
                        get: function() {
                            return r.np;
                        }
                    },
                    _name: {
                        value: r.nm
                    },
                    propertyGroup: {
                        value: h
                    }
                }), n.enabled = 0 !== r.en, n.active = n.enabled, n;
            }
            function e(t, e, r, i) {
                var a = ExpressionPropertyInterface(t.p);
                return t.p.setGroupProperty && t.p.setGroupProperty(PropertyInterface("", i)), function() {
                    return 10 === e ? r.comp.compInterface(t.p.v) : a();
                };
            }
            return {
                createEffectsInterface: function(e, r) {
                    if (e.effectsManager) {
                        var i, a = [], s = e.data.ef, n = e.effectsManager.effectElements.length;
                        for(i = 0; i < n; i += 1)a.push(t(s[i], e.effectsManager.effectElements[i], r, e));
                        var o = e.data.ef || [], h = function(t) {
                            for(i = 0, n = o.length; i < n;){
                                if (t === o[i].nm || t === o[i].mn || t === o[i].ix) return a[i];
                                i += 1;
                            }
                            return null;
                        };
                        return Object.defineProperty(h, "numProperties", {
                            get: function() {
                                return o.length;
                            }
                        }), h;
                    }
                    return null;
                }
            };
        }(), ShapePathInterface = function(t, e, r) {
            var i = e.sh;
            function a(t) {
                return "Shape" === t || "shape" === t || "Path" === t || "path" === t || "ADBE Vector Shape" === t || 2 === t ? a.path : null;
            }
            var s = propertyGroupFactory(a, r);
            return i.setGroupProperty(PropertyInterface("Path", s)), Object.defineProperties(a, {
                path: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                shape: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                _name: {
                    value: t.nm
                },
                ix: {
                    value: t.ix
                },
                propertyIndex: {
                    value: t.ix
                },
                mn: {
                    value: t.mn
                },
                propertyGroup: {
                    value: r
                }
            }), a;
        }, ShapeExpressionInterface = function() {
            function t(t, o, m) {
                var d, u = [], y = t ? t.length : 0;
                for(d = 0; d < y; d += 1)"gr" === t[d].ty ? u.push(e(t[d], o[d], m)) : "fl" === t[d].ty ? u.push(r(t[d], o[d], m)) : "st" === t[d].ty ? u.push(s(t[d], o[d], m)) : "tm" === t[d].ty ? u.push(n(t[d], o[d], m)) : "tr" === t[d].ty || ("el" === t[d].ty ? u.push(h(t[d], o[d], m)) : "sr" === t[d].ty ? u.push(l(t[d], o[d], m)) : "sh" === t[d].ty ? u.push(ShapePathInterface(t[d], o[d], m)) : "rc" === t[d].ty ? u.push(p(t[d], o[d], m)) : "rd" === t[d].ty ? u.push(f(t[d], o[d], m)) : "rp" === t[d].ty ? u.push(c(t[d], o[d], m)) : "gf" === t[d].ty ? u.push(i(t[d], o[d], m)) : u.push(a(t[d], o[d])));
                return u;
            }
            function e(e, r, i) {
                var a = function(t) {
                    switch(t){
                        case "ADBE Vectors Group":
                        case "Contents":
                        case 2:
                            return a.content;
                        default:
                            return a.transform;
                    }
                };
                a.propertyGroup = propertyGroupFactory(a, i);
                var s = function(e, r, i) {
                    var a, s = function(t) {
                        for(var e = 0, r = a.length; e < r;){
                            if (a[e]._name === t || a[e].mn === t || a[e].propertyIndex === t || a[e].ix === t || a[e].ind === t) return a[e];
                            e += 1;
                        }
                        return "number" == typeof t ? a[t - 1] : null;
                    };
                    s.propertyGroup = propertyGroupFactory(s, i), a = t(e.it, r.it, s.propertyGroup), s.numProperties = a.length;
                    var n = o(e.it[e.it.length - 1], r.it[r.it.length - 1], s.propertyGroup);
                    return s.transform = n, s.propertyIndex = e.cix, s._name = e.nm, s;
                }(e, r, a.propertyGroup), n = o(e.it[e.it.length - 1], r.it[r.it.length - 1], a.propertyGroup);
                return a.content = s, a.transform = n, Object.defineProperty(a, "_name", {
                    get: function() {
                        return e.nm;
                    }
                }), a.numProperties = e.np, a.propertyIndex = e.ix, a.nm = e.nm, a.mn = e.mn, a;
            }
            function r(t, e, r) {
                function i(t) {
                    return "Color" === t || "color" === t ? i.color : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", r)), e.o.setGroupProperty(PropertyInterface("Opacity", r)), i;
            }
            function i(t, e, r) {
                function i(t) {
                    return "Start Point" === t || "start point" === t ? i.startPoint : "End Point" === t || "end point" === t ? i.endPoint : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    startPoint: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    endPoint: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    type: {
                        get: function() {
                            return "a";
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.s.setGroupProperty(PropertyInterface("Start Point", r)), e.e.setGroupProperty(PropertyInterface("End Point", r)), e.o.setGroupProperty(PropertyInterface("Opacity", r)), i;
            }
            function a() {
                return function() {
                    return null;
                };
            }
            function s(t, e, r) {
                var i, a = propertyGroupFactory(l, r), s = propertyGroupFactory(h, a);
                function n(r) {
                    Object.defineProperty(h, t.d[r].nm, {
                        get: ExpressionPropertyInterface(e.d.dataProps[r].p)
                    });
                }
                var o = t.d ? t.d.length : 0, h = {};
                for(i = 0; i < o; i += 1)n(i), e.d.dataProps[i].p.setGroupProperty(s);
                function l(t) {
                    return "Color" === t || "color" === t ? l.color : "Opacity" === t || "opacity" === t ? l.opacity : "Stroke Width" === t || "stroke width" === t ? l.strokeWidth : null;
                }
                return Object.defineProperties(l, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    strokeWidth: {
                        get: ExpressionPropertyInterface(e.w)
                    },
                    dash: {
                        get: function() {
                            return h;
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", a)), e.o.setGroupProperty(PropertyInterface("Opacity", a)), e.w.setGroupProperty(PropertyInterface("Stroke Width", a)), l;
            }
            function n(t, e, r) {
                function i(e) {
                    return e === t.e.ix || "End" === e || "end" === e ? i.end : e === t.s.ix ? i.start : e === t.o.ix ? i.offset : null;
                }
                var a = propertyGroupFactory(i, r);
                return i.propertyIndex = t.ix, e.s.setGroupProperty(PropertyInterface("Start", a)), e.e.setGroupProperty(PropertyInterface("End", a)), e.o.setGroupProperty(PropertyInterface("Offset", a)), i.propertyIndex = t.ix, i.propertyGroup = r, Object.defineProperties(i, {
                    start: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    end: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function o(t, e, r) {
                function i(e) {
                    return t.a.ix === e || "Anchor Point" === e ? i.anchorPoint : t.o.ix === e || "Opacity" === e ? i.opacity : t.p.ix === e || "Position" === e ? i.position : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e ? i.rotation : t.s.ix === e || "Scale" === e ? i.scale : t.sk && t.sk.ix === e || "Skew" === e ? i.skew : t.sa && t.sa.ix === e || "Skew Axis" === e ? i.skewAxis : null;
                }
                var a = propertyGroupFactory(i, r);
                return e.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", a)), e.transform.mProps.p.setGroupProperty(PropertyInterface("Position", a)), e.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", a)), e.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", a)), e.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", a)), e.transform.mProps.sk && (e.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", a)), e.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", a))), e.transform.op.setGroupProperty(PropertyInterface("Opacity", a)), Object.defineProperties(i, {
                    opacity: {
                        get: ExpressionPropertyInterface(e.transform.mProps.o)
                    },
                    position: {
                        get: ExpressionPropertyInterface(e.transform.mProps.p)
                    },
                    anchorPoint: {
                        get: ExpressionPropertyInterface(e.transform.mProps.a)
                    },
                    scale: {
                        get: ExpressionPropertyInterface(e.transform.mProps.s)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(e.transform.mProps.r)
                    },
                    skew: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sk)
                    },
                    skewAxis: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sa)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.ty = "tr", i.mn = t.mn, i.propertyGroup = r, i;
            }
            function h(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.s.ix === e ? i.size : null;
                }
                var a = propertyGroupFactory(i, r);
                i.propertyIndex = t.ix;
                var s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return s.s.setGroupProperty(PropertyInterface("Size", a)), s.p.setGroupProperty(PropertyInterface("Position", a)), Object.defineProperties(i, {
                    size: {
                        get: ExpressionPropertyInterface(s.s)
                    },
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function l(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.rotation : t.pt.ix === e ? i.points : t.or.ix === e || "ADBE Vector Star Outer Radius" === e ? i.outerRadius : t.os.ix === e ? i.outerRoundness : !t.ir || t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e ? t.is && t.is.ix === e ? i.innerRoundness : null : i.innerRadius;
                }
                var a = propertyGroupFactory(i, r), s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, s.or.setGroupProperty(PropertyInterface("Outer Radius", a)), s.os.setGroupProperty(PropertyInterface("Outer Roundness", a)), s.pt.setGroupProperty(PropertyInterface("Points", a)), s.p.setGroupProperty(PropertyInterface("Position", a)), s.r.setGroupProperty(PropertyInterface("Rotation", a)), t.ir && (s.ir.setGroupProperty(PropertyInterface("Inner Radius", a)), s.is.setGroupProperty(PropertyInterface("Inner Roundness", a))), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(s.r)
                    },
                    points: {
                        get: ExpressionPropertyInterface(s.pt)
                    },
                    outerRadius: {
                        get: ExpressionPropertyInterface(s.or)
                    },
                    outerRoundness: {
                        get: ExpressionPropertyInterface(s.os)
                    },
                    innerRadius: {
                        get: ExpressionPropertyInterface(s.ir)
                    },
                    innerRoundness: {
                        get: ExpressionPropertyInterface(s.is)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function p(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.roundness : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e ? i.size : null;
                }
                var a = propertyGroupFactory(i, r), s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, s.p.setGroupProperty(PropertyInterface("Position", a)), s.s.setGroupProperty(PropertyInterface("Size", a)), s.r.setGroupProperty(PropertyInterface("Rotation", a)), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    roundness: {
                        get: ExpressionPropertyInterface(s.r)
                    },
                    size: {
                        get: ExpressionPropertyInterface(s.s)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function f(t, e, r) {
                function i(e) {
                    return t.r.ix === e || "Round Corners 1" === e ? i.radius : null;
                }
                var a = propertyGroupFactory(i, r), s = e;
                return i.propertyIndex = t.ix, s.rd.setGroupProperty(PropertyInterface("Radius", a)), Object.defineProperties(i, {
                    radius: {
                        get: ExpressionPropertyInterface(s.rd)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function c(t, e, r) {
                function i(e) {
                    return t.c.ix === e || "Copies" === e ? i.copies : t.o.ix === e || "Offset" === e ? i.offset : null;
                }
                var a = propertyGroupFactory(i, r), s = e;
                return i.propertyIndex = t.ix, s.c.setGroupProperty(PropertyInterface("Copies", a)), s.o.setGroupProperty(PropertyInterface("Offset", a)), Object.defineProperties(i, {
                    copies: {
                        get: ExpressionPropertyInterface(s.c)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(s.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            return function(e, r, i) {
                var a;
                function s(t) {
                    if ("number" == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? i : a[t - 1];
                    for(var e = 0, r = a.length; e < r;){
                        if (a[e]._name === t) return a[e];
                        e += 1;
                    }
                    return null;
                }
                return s.propertyGroup = propertyGroupFactory(s, function() {
                    return i;
                }), a = t(e, r, s.propertyGroup), s.numProperties = a.length, s._name = "Contents", s;
            };
        }(), TextExpressionInterface = function(t) {
            var e, r;
            function i(t) {
                switch(t){
                    case "ADBE Text Document":
                        return i.sourceText;
                    default:
                        return null;
                }
            }
            return Object.defineProperty(i, "sourceText", {
                get: function() {
                    t.textProperty.getValue();
                    var i = t.textProperty.currentData.t;
                    return i !== e && (e = t.textProperty.currentData.t, (r = new String(i)).value = i || new String(i), Object.defineProperty(r, "style", {
                        get: function() {
                            return {
                                fillColor: t.textProperty.currentData.fc
                            };
                        }
                    })), r;
                }
            }), i;
        };
        function _typeof$2(t) {
            return (_typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var FootageInterface = (dataInterfaceFactory = function(t) {
            function e(t) {
                return "Outline" === t ? e.outlineInterface() : null;
            }
            return e._name = "Outline", e.outlineInterface = function(t) {
                var e = "", r = t.getFootageData();
                function i(t) {
                    if (r[t]) return e = t, "object" === _typeof$2(r = r[t]) ? i : r;
                    var a = t.indexOf(e);
                    if (-1 !== a) {
                        var s = parseInt(t.substr(a + e.length), 10);
                        return "object" === _typeof$2(r = r[s]) ? i : r;
                    }
                    return "";
                }
                return function() {
                    return e = "", r = t.getFootageData(), i;
                };
            }(t), e;
        }, function(t) {
            function e(t) {
                return "Data" === t ? e.dataInterface : null;
            }
            return e._name = "Data", e.dataInterface = dataInterfaceFactory(t), e;
        }), dataInterfaceFactory, interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface
        };
        function getInterface(t) {
            return interfaces[t] || null;
        }
        function _typeof$1(t) {
            return (_typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        function seedRandom(t, e) {
            var r = this, i = e.pow(256, 6), a = e.pow(2, 52), s = 2 * a;
            function n(t) {
                var e, r = t.length, i = this, a = 0, s = i.i = i.j = 0, n = i.S = [];
                for(r || (t = [
                    r++
                ]); a < 256;)n[a] = a++;
                for(a = 0; a < 256; a++)n[a] = n[s = 255 & s + t[a % r] + (e = n[a])], n[s] = e;
                i.g = function(t) {
                    for(var e, r = 0, a = i.i, s = i.j, n = i.S; t--;)e = n[a = 255 & a + 1], r = 256 * r + n[255 & (n[a] = n[s = 255 & s + e]) + (n[s] = e)];
                    return i.i = a, i.j = s, r;
                };
            }
            function o(t, e) {
                return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
            }
            function h(t, e) {
                for(var r, i = t + "", a = 0; a < i.length;)e[255 & a] = 255 & (r ^= 19 * e[255 & a]) + i.charCodeAt(a++);
                return l(e);
            }
            function l(t) {
                return String.fromCharCode.apply(0, t);
            }
            e.seedrandom = function(p, f, c) {
                var m = [], d = h(function t(e, r) {
                    var i, a = [], s = _typeof$1(e);
                    if (r && "object" == s) for(i in e)try {
                        a.push(t(e[i], r - 1));
                    } catch (t) {}
                    return a.length ? a : "string" == s ? e : e + "\0";
                }((f = !0 === f ? {
                    entropy: !0
                } : f || {}).entropy ? [
                    p,
                    l(t)
                ] : null === p ? function() {
                    try {
                        var e = new Uint8Array(256);
                        return (r.crypto || r.msCrypto).getRandomValues(e), l(e);
                    } catch (e) {
                        var i = r.navigator, a = i && i.plugins;
                        return [
                            +new Date,
                            r,
                            a,
                            r.screen,
                            l(t)
                        ];
                    }
                }() : p, 3), m), u = new n(m), y = function() {
                    for(var t = u.g(6), e = i, r = 0; t < a;)t = 256 * (t + r), e *= 256, r = u.g(1);
                    for(; t >= s;)t /= 2, e /= 2, r >>>= 1;
                    return (t + r) / e;
                };
                return y.int32 = function() {
                    return 0 | u.g(4);
                }, y.quick = function() {
                    return u.g(4) / 4294967296;
                }, y.double = y, h(l(u.S), t), (f.pass || c || function(t, r, i, a) {
                    return a && (a.S && o(a, u), t.state = function() {
                        return o(u, {});
                    }), i ? (e.random = t, r) : t;
                })(y, d, "global" in f ? f.global : this == e, f.state);
            }, h(e.random(), t);
        }
        function initialize$2(t) {
            seedRandom([], t);
        }
        var propTypes = {
            SHAPE: "shape"
        };
        function _typeof(t) {
            return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var ExpressionManager = function() {
            var ob = {}, Math1 = BMMath, window1 = null, document1 = null, XMLHttpRequest1 = null, fetch1 = null, frames = null;
            function $bm_isInstanceOfArray(t) {
                return t.constructor === Array || t.constructor === Float32Array;
            }
            function isNumerable(t, e) {
                return "number" === t || "boolean" === t || "string" === t || e instanceof Number;
            }
            function $bm_neg(t) {
                var e = _typeof(t);
                if ("number" === e || "boolean" === e || t instanceof Number) return -t;
                if ($bm_isInstanceOfArray(t)) {
                    var r, i = t.length, a = [];
                    for(r = 0; r < i; r += 1)a[r] = -t[r];
                    return a;
                }
                return t.propType ? t.v : -t;
            }
            initialize$2(BMMath);
            var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
            function sum(t, e) {
                var r = _typeof(t), i = _typeof(e);
                if ("string" === r || "string" === i) return t + e;
                if (isNumerable(r, t) && isNumerable(i, e)) return t + e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] += e, t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t + e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var a = 0, s = t.length, n = e.length, o = []; a < s || a < n;)("number" == typeof t[a] || t[a] instanceof Number) && ("number" == typeof e[a] || e[a] instanceof Number) ? o[a] = t[a] + e[a] : o[a] = void 0 === e[a] ? t[a] : t[a] || e[a], a += 1;
                    return o;
                }
                return 0;
            }
            var add = sum;
            function sub(t, e) {
                var r = _typeof(t), i = _typeof(e);
                if (isNumerable(r, t) && isNumerable(i, e)) return "string" === r && (t = parseInt(t, 10)), "string" === i && (e = parseInt(e, 10)), t - e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] -= e, t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t - e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var a = 0, s = t.length, n = e.length, o = []; a < s || a < n;)("number" == typeof t[a] || t[a] instanceof Number) && ("number" == typeof e[a] || e[a] instanceof Number) ? o[a] = t[a] - e[a] : o[a] = void 0 === e[a] ? t[a] : t[a] || e[a], a += 1;
                    return o;
                }
                return 0;
            }
            function mul(t, e) {
                var r, i, a, s = _typeof(t), n = _typeof(e);
                if (isNumerable(s, t) && isNumerable(n, e)) return t * e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(a = t.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t[i] * e;
                    return r;
                }
                if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                    for(a = e.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t * e[i];
                    return r;
                }
                return 0;
            }
            function div(t, e) {
                var r, i, a, s = _typeof(t), n = _typeof(e);
                if (isNumerable(s, t) && isNumerable(n, e)) return t / e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(a = t.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t[i] / e;
                    return r;
                }
                if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                    for(a = e.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t / e[i];
                    return r;
                }
                return 0;
            }
            function mod(t, e) {
                return "string" == typeof t && (t = parseInt(t, 10)), "string" == typeof e && (e = parseInt(e, 10)), t % e;
            }
            var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
            function clamp(t, e, r) {
                if (e > r) {
                    var i = r;
                    r = e, e = i;
                }
                return Math1.min(Math1.max(t, e), r);
            }
            function radiansToDegrees(t) {
                return t / degToRads;
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(t) {
                return t * degToRads;
            }
            var degrees_to_radians = radiansToDegrees, helperLengthArray = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            function length(t, e) {
                if ("number" == typeof t || t instanceof Number) return e = e || 0, Math1.abs(t - e);
                var r;
                e || (e = helperLengthArray);
                var i = Math1.min(t.length, e.length), a = 0;
                for(r = 0; r < i; r += 1)a += Math1.pow(e[r] - t[r], 2);
                return Math1.sqrt(a);
            }
            function normalize(t) {
                return div(t, length(t));
            }
            function rgbToHsl(t) {
                var e, r, i = t[0], a = t[1], s = t[2], n = Math1.max(i, a, s), o = Math1.min(i, a, s), h = (n + o) / 2;
                if (n === o) e = 0, r = 0;
                else {
                    var l = n - o;
                    switch(r = h > .5 ? l / (2 - n - o) : l / (n + o), n){
                        case i:
                            e = (a - s) / l + (a < s ? 6 : 0);
                            break;
                        case a:
                            e = (s - i) / l + 2;
                            break;
                        case s:
                            e = (i - a) / l + 4;
                    }
                    e /= 6;
                }
                return [
                    e,
                    r,
                    h,
                    t[3]
                ];
            }
            function hue2rgb(t, e, r) {
                return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
            }
            function hslToRgb(t) {
                var e, r, i, a = t[0], s = t[1], n = t[2];
                if (0 === s) e = n, i = n, r = n;
                else {
                    var o = n < .5 ? n * (1 + s) : n + s - n * s, h = 2 * n - o;
                    e = hue2rgb(h, o, a + 1 / 3), r = hue2rgb(h, o, a), i = hue2rgb(h, o, a - 1 / 3);
                }
                return [
                    e,
                    r,
                    i,
                    t[3]
                ];
            }
            function linear(t, e, r, i, a) {
                if (void 0 !== i && void 0 !== a || (i = e, a = r, e = 0, r = 1), r < e) {
                    var s = r;
                    r = e, e = s;
                }
                if (t <= e) return i;
                if (t >= r) return a;
                var n, o = r === e ? 0 : (t - e) / (r - e);
                if (!i.length) return i + (a - i) * o;
                var h = i.length, l = createTypedArray("float32", h);
                for(n = 0; n < h; n += 1)l[n] = i[n] + (a[n] - i[n]) * o;
                return l;
            }
            function random(t, e) {
                if (void 0 === e && (void 0 === t ? (t = 0, e = 1) : (e = t, t = void 0)), e.length) {
                    var r, i = e.length;
                    t || (t = createTypedArray("float32", i));
                    var a = createTypedArray("float32", i), s = BMMath.random();
                    for(r = 0; r < i; r += 1)a[r] = t[r] + s * (e[r] - t[r]);
                    return a;
                }
                return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
            }
            function createPath(t, e, r, i) {
                var a, s = t.length, n = shapePool.newElement();
                n.setPathData(!!i, s);
                var o, h, l = [
                    0,
                    0
                ];
                for(a = 0; a < s; a += 1)o = e && e[a] ? e[a] : l, h = r && r[a] ? r[a] : l, n.setTripleAt(t[a][0], t[a][1], h[0] + t[a][0], h[1] + t[a][1], o[0] + t[a][0], o[1] + t[a][1], a, !0);
                return n;
            }
            function initiateExpression(elem, data, property) {
                function noOp(t) {
                    return t;
                }
                if (!elem.globalData.renderConfig.runExpressions) return noOp;
                var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                    get: function() {
                        return thisProperty.v;
                    }
                }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
                var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t, e) {
                    var r, i, a = this.pv.length ? this.pv.length : 1, s = createTypedArray("float32", a);
                    var n = Math1.floor(5 * time);
                    for(r = 0, i = 0; r < n;){
                        for(i = 0; i < a; i += 1)s[i] += -e + 2 * e * BMMath.random();
                        r += 1;
                    }
                    var o = 5 * time, h = o - Math1.floor(o), l = createTypedArray("float32", a);
                    if (a > 1) {
                        for(i = 0; i < a; i += 1)l[i] = this.pv[i] + s[i] + (-e + 2 * e * BMMath.random()) * h;
                        return l;
                    }
                    return this.pv + s[0] + (-e + 2 * e * BMMath.random()) * h;
                }).bind(this);
                function loopInDuration(t, e) {
                    return loopIn(t, e, !0);
                }
                function loopOutDuration(t, e) {
                    return loopOut(t, e, !0);
                }
                thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
                function lookAt(t, e) {
                    var r = [
                        e[0] - t[0],
                        e[1] - t[1],
                        e[2] - t[2]
                    ], i = Math1.atan2(r[0], Math1.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads;
                    return [
                        -Math1.atan2(r[1], r[2]) / degToRads,
                        i,
                        0
                    ];
                }
                function easeOut(t, e, r, i, a) {
                    return applyEase(easeOutBez, t, e, r, i, a);
                }
                function easeIn(t, e, r, i, a) {
                    return applyEase(easeInBez, t, e, r, i, a);
                }
                function ease(t, e, r, i, a) {
                    return applyEase(easeInOutBez, t, e, r, i, a);
                }
                function applyEase(t, e, r, i, a, s) {
                    void 0 === a ? (a = r, s = i) : e = (e - r) / (i - r), e > 1 ? e = 1 : e < 0 && (e = 0);
                    var n = t(e);
                    if ($bm_isInstanceOfArray(a)) {
                        var o, h = a.length, l = createTypedArray("float32", h);
                        for(o = 0; o < h; o += 1)l[o] = (s[o] - a[o]) * n + a[o];
                        return l;
                    }
                    return (s - a) * n + a;
                }
                function nearestKey(t) {
                    var e, r, i, a = data.k.length;
                    if (data.k.length && "number" != typeof data.k[0]) {
                        if (r = -1, (t *= elem.comp.globalData.frameRate) < data.k[0].t) r = 1, i = data.k[0].t;
                        else {
                            for(e = 0; e < a - 1; e += 1){
                                if (t === data.k[e].t) {
                                    r = e + 1, i = data.k[e].t;
                                    break;
                                }
                                if (t > data.k[e].t && t < data.k[e + 1].t) {
                                    t - data.k[e].t > data.k[e + 1].t - t ? (r = e + 2, i = data.k[e + 1].t) : (r = e + 1, i = data.k[e].t);
                                    break;
                                }
                            }
                            -1 === r && (r = e + 1, i = data.k[e].t);
                        }
                    } else r = 0, i = 0;
                    var s = {};
                    return s.index = r, s.time = i / elem.comp.globalData.frameRate, s;
                }
                function key(t) {
                    var e, r, i;
                    if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t);
                    t -= 1, e = {
                        time: data.k[t].t / elem.comp.globalData.frameRate,
                        value: []
                    };
                    var a = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
                    for(i = a.length, r = 0; r < i; r += 1)e[r] = a[r], e.value[r] = a[r];
                    return e;
                }
                function framesToTime(t, e) {
                    return e || (e = elem.comp.globalData.frameRate), t / e;
                }
                function timeToFrames(t, e) {
                    return t || 0 === t || (t = time), e || (e = elem.comp.globalData.frameRate), t * e;
                }
                function seedRandom(t) {
                    BMMath.seedrandom(randSeed + t);
                }
                function sourceRectAtTime() {
                    return elem.sourceRectAtTime();
                }
                function substring(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substring(t) : value.substring(t, e) : "";
                }
                function substr(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substr(t) : value.substr(t, e) : "";
                }
                function posterizeTime(t) {
                    time = 0 === t ? 0 : Math1.floor(time * t) / t, value = valueAtTime(time);
                }
                var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = Math1.floor(1e6 * Math1.random()), globalData = elem.globalData;
                function executeExpression(t) {
                    return value = t, this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
                }
                return executeExpression.__preventDeadCodeRemoval = [
                    $bm_transform,
                    anchorPoint,
                    time,
                    velocity,
                    inPoint,
                    outPoint,
                    width,
                    height,
                    name,
                    loop_in,
                    loop_out,
                    smooth,
                    toComp,
                    fromCompToSurface,
                    toWorld,
                    fromWorld,
                    mask,
                    position,
                    rotation,
                    scale,
                    thisComp,
                    numKeys,
                    active,
                    wiggle,
                    loopInDuration,
                    loopOutDuration,
                    comp,
                    lookAt,
                    easeOut,
                    easeIn,
                    ease,
                    nearestKey,
                    key,
                    text,
                    textIndex,
                    textTotal,
                    selectorValue,
                    framesToTime,
                    timeToFrames,
                    sourceRectAtTime,
                    substring,
                    substr,
                    posterizeTime,
                    index,
                    globalData
                ], executeExpression;
            }
            return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [
                window1,
                document1,
                XMLHttpRequest1,
                fetch1,
                frames,
                $bm_neg,
                add,
                $bm_sum,
                $bm_sub,
                $bm_mul,
                $bm_div,
                $bm_mod,
                clamp,
                radians_to_degrees,
                degreesToRadians,
                degrees_to_radians,
                normalize,
                rgbToHsl,
                hslToRgb,
                linear,
                random,
                createPath
            ], ob;
        }(), expressionHelpers = {
            searchExpressions: function(t, e, r) {
                e.x && (r.k = !0, r.x = !0, r.initiateExpression = ExpressionManager.initiateExpression, r.effectsSequence.push(r.initiateExpression(t, e, r).bind(r)));
            },
            getSpeedAtTime: function(t) {
                var e = this.getValueAtTime(t), r = this.getValueAtTime(t + -0.01), i = 0;
                if (e.length) {
                    var a;
                    for(a = 0; a < e.length; a += 1)i += Math.pow(r[a] - e[a], 2);
                    i = 100 * Math.sqrt(i);
                } else i = 0;
                return i;
            },
            getVelocityAtTime: function(t) {
                if (void 0 !== this.vel) return this.vel;
                var e, r, i = this.getValueAtTime(t), a = this.getValueAtTime(t + -0.001);
                if (i.length) for(e = createTypedArray("float32", i.length), r = 0; r < i.length; r += 1)e[r] = (a[r] - i[r]) / -0.001;
                else e = (a - i) / -0.001;
                return e;
            },
            getValueAtTime: function(t) {
                return t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime), this._cachingAtTime.lastFrame = t), this._cachingAtTime.value;
            },
            getStaticValueAtTime: function() {
                return this.pv;
            },
            setGroupProperty: function(t) {
                this.propertyGroup = t;
            }
        };
        function addPropertyDecorator() {
            function t(t, e, r) {
                if (!this.k || !this.keyframes) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, a, s, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[l.length - 1].t;
                if (h <= p) return this.pv;
                if (r ? a = p - (i = e ? Math.abs(p - this.elem.comp.globalData.frameRate * e) : Math.max(0, p - this.elem.data.ip)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = p - (a = l[l.length - 1 - e].t)), "pingpong" === t) {
                    if (Math.floor((h - a) / i) % 2 != 0) return this.getValueAtTime((i - (h - a) % i + a) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var f = this.getValueAtTime(a / this.comp.globalData.frameRate, 0), c = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), m = this.getValueAtTime(((h - a) % i + a) / this.comp.globalData.frameRate, 0), d = Math.floor((h - a) / i);
                        if (this.pv.length) {
                            for(n = (o = new Array(f.length)).length, s = 0; s < n; s += 1)o[s] = (c[s] - f[s]) * d + m[s];
                            return o;
                        }
                        return (c - f) * d + m;
                    }
                    if ("continue" === t) {
                        var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p - .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(u.length)).length, s = 0; s < n; s += 1)o[s] = u[s] + (u[s] - y[s]) * ((h - p) / this.comp.globalData.frameRate) / 5e-4;
                            return o;
                        }
                        return u + (h - p) / .001 * (u - y);
                    }
                }
                return this.getValueAtTime(((h - a) % i + a) / this.comp.globalData.frameRate, 0);
            }
            function e(t, e, r) {
                if (!this.k) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, a, s, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[0].t;
                if (h >= p) return this.pv;
                if (r ? a = p + (i = e ? Math.abs(this.elem.comp.globalData.frameRate * e) : Math.max(0, this.elem.data.op - p)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = (a = l[e].t) - p), "pingpong" === t) {
                    if (Math.floor((p - h) / i) % 2 == 0) return this.getValueAtTime(((p - h) % i + p) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var f = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), c = this.getValueAtTime(a / this.comp.globalData.frameRate, 0), m = this.getValueAtTime((i - (p - h) % i + p) / this.comp.globalData.frameRate, 0), d = Math.floor((p - h) / i) + 1;
                        if (this.pv.length) {
                            for(n = (o = new Array(f.length)).length, s = 0; s < n; s += 1)o[s] = m[s] - (c[s] - f[s]) * d;
                            return o;
                        }
                        return m - (c - f) * d;
                    }
                    if ("continue" === t) {
                        var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p + .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(u.length)).length, s = 0; s < n; s += 1)o[s] = u[s] + (u[s] - y[s]) * (p - h) / .001;
                            return o;
                        }
                        return u + (u - y) * (p - h) / .001;
                    }
                }
                return this.getValueAtTime((i - ((p - h) % i + p)) / this.comp.globalData.frameRate, 0);
            }
            function r(t, e) {
                if (!this.k) return this.pv;
                if (t = .5 * (t || .4), (e = Math.floor(e || 5)) <= 1) return this.pv;
                var r, i, a = this.comp.renderedFrame / this.comp.globalData.frameRate, s = a - t, n = e > 1 ? (a + t - s) / (e - 1) : 1, o = 0, h = 0;
                for(r = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o < e;){
                    if (i = this.getValueAtTime(s + o * n), this.pv.length) for(h = 0; h < this.pv.length; h += 1)r[h] += i[h];
                    else r += i;
                    o += 1;
                }
                if (this.pv.length) for(h = 0; h < this.pv.length; h += 1)r[h] /= e;
                else r /= e;
                return r;
            }
            function i(t) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var e = this._transformCachingAtTime.v;
                if (e.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                    var r = this.a.getValueAtTime(t);
                    e.translate(-r[0] * this.a.mult, -r[1] * this.a.mult, r[2] * this.a.mult);
                }
                if (this.appliedTransformations < 2) {
                    var i = this.s.getValueAtTime(t);
                    e.scale(i[0] * this.s.mult, i[1] * this.s.mult, i[2] * this.s.mult);
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var a = this.sk.getValueAtTime(t), s = this.sa.getValueAtTime(t);
                    e.skewFromAxis(-a * this.sk.mult, s * this.sa.mult);
                }
                if (this.r && this.appliedTransformations < 4) {
                    var n = this.r.getValueAtTime(t);
                    e.rotate(-n * this.r.mult);
                } else if (!this.r && this.appliedTransformations < 4) {
                    var o = this.rz.getValueAtTime(t), h = this.ry.getValueAtTime(t), l = this.rx.getValueAtTime(t), p = this.or.getValueAtTime(t);
                    e.rotateZ(-o * this.rz.mult).rotateY(h * this.ry.mult).rotateX(l * this.rx.mult).rotateZ(-p[2] * this.or.mult).rotateY(p[1] * this.or.mult).rotateX(p[0] * this.or.mult);
                }
                if (this.data.p && this.data.p.s) {
                    var f = this.px.getValueAtTime(t), c = this.py.getValueAtTime(t);
                    if (this.data.p.z) {
                        var m = this.pz.getValueAtTime(t);
                        e.translate(f * this.px.mult, c * this.py.mult, -m * this.pz.mult);
                    } else e.translate(f * this.px.mult, c * this.py.mult, 0);
                } else {
                    var d = this.p.getValueAtTime(t);
                    e.translate(d[0] * this.p.mult, d[1] * this.p.mult, -d[2] * this.p.mult);
                }
                return e;
            }
            function a() {
                return this.v.clone(new Matrix);
            }
            var s = TransformPropertyFactory.getTransformProperty;
            TransformPropertyFactory.getTransformProperty = function(t, e, r) {
                var n = s(t, e, r);
                return n.dynamicProperties.length ? n.getValueAtTime = i.bind(n) : n.getValueAtTime = a.bind(n), n.setGroupProperty = expressionHelpers.setGroupProperty, n;
            };
            var n = PropertyFactory.getProp;
            PropertyFactory.getProp = function(i, a, s, o, h) {
                var l = n(i, a, s, o, h);
                l.kf ? l.getValueAtTime = expressionHelpers.getValueAtTime.bind(l) : l.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l), l.setGroupProperty = expressionHelpers.setGroupProperty, l.loopOut = t, l.loopIn = e, l.smooth = r, l.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l), l.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l), l.numKeys = 1 === a.a ? a.k.length : 0, l.propertyIndex = a.ix;
                var p = 0;
                return 0 !== s && (p = createTypedArray("float32", 1 === a.a ? a.k[0].s.length : a.k.length)), l._cachingAtTime = {
                    lastFrame: initialDefaultFrame,
                    lastIndex: 0,
                    value: p
                }, expressionHelpers.searchExpressions(i, a, l), l.k && h.addDynamicProperty(l), l;
            };
            var o = ShapePropertyFactory.getConstructorFunction(), h = ShapePropertyFactory.getKeyframedConstructorFunction();
            function l() {}
            l.prototype = {
                vertices: function(t, e) {
                    this.k && this.getValue();
                    var r, i = this.v;
                    void 0 !== e && (i = this.getValueAtTime(e, 0));
                    var a = i._length, s = i[t], n = i.v, o = createSizedArray(a);
                    for(r = 0; r < a; r += 1)o[r] = "i" === t || "o" === t ? [
                        s[r][0] - n[r][0],
                        s[r][1] - n[r][1]
                    ] : [
                        s[r][0],
                        s[r][1]
                    ];
                    return o;
                },
                points: function(t) {
                    return this.vertices("v", t);
                },
                inTangents: function(t) {
                    return this.vertices("i", t);
                },
                outTangents: function(t) {
                    return this.vertices("o", t);
                },
                isClosed: function() {
                    return this.v.c;
                },
                pointOnPath: function(t, e) {
                    var r = this.v;
                    void 0 !== e && (r = this.getValueAtTime(e, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r));
                    for(var i, a = this._segmentsLength, s = a.lengths, n = a.totalLength * t, o = 0, h = s.length, l = 0; o < h;){
                        if (l + s[o].addedLength > n) {
                            var p = o, f = r.c && o === h - 1 ? 0 : o + 1, c = (n - l) / s[o].addedLength;
                            i = bez.getPointInSegment(r.v[p], r.v[f], r.o[p], r.i[f], c, s[o]);
                            break;
                        }
                        l += s[o].addedLength, o += 1;
                    }
                    return i || (i = r.c ? [
                        r.v[0][0],
                        r.v[0][1]
                    ] : [
                        r.v[r._length - 1][0],
                        r.v[r._length - 1][1]
                    ]), i;
                },
                vectorOnPath: function(t, e, r) {
                    1 == t ? t = this.v.c : 0 == t && (t = .999);
                    var i = this.pointOnPath(t, e), a = this.pointOnPath(t + .001, e), s = a[0] - i[0], n = a[1] - i[1], o = Math.sqrt(Math.pow(s, 2) + Math.pow(n, 2));
                    return 0 === o ? [
                        0,
                        0
                    ] : "tangent" === r ? [
                        s / o,
                        n / o
                    ] : [
                        -n / o,
                        s / o
                    ];
                },
                tangentOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "tangent");
                },
                normalOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "normal");
                },
                setGroupProperty: expressionHelpers.setGroupProperty,
                getValueAtTime: expressionHelpers.getStaticValueAtTime
            }, extendPrototype([
                l
            ], o), extendPrototype([
                l
            ], h), h.prototype.getValueAtTime = function(t) {
                return this._cachingAtTime || (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame
                }), t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t, this.interpolateShape(t, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
            }, h.prototype.initiateExpression = ExpressionManager.initiateExpression;
            var p = ShapePropertyFactory.getShapeProp;
            ShapePropertyFactory.getShapeProp = function(t, e, r, i, a) {
                var s = p(t, e, r, i, a);
                return s.propertyIndex = e.ix, s.lock = !1, 3 === r ? expressionHelpers.searchExpressions(t, e.pt, s) : 4 === r && expressionHelpers.searchExpressions(t, e.ks, s), s.k && t.addDynamicProperty(s), s;
            };
        }
        function initialize$1() {
            addPropertyDecorator();
        }
        function addDecorator() {
            TextProperty.prototype.getExpressionValue = function(t, e) {
                var r = this.calculateExpression(e);
                if (t.t !== r) {
                    var i = {};
                    return this.copyData(i, t), i.t = r.toString(), i.__complete = !1, i;
                }
                return t;
            }, TextProperty.prototype.searchProperty = function() {
                var t = this.searchKeyframes(), e = this.searchExpressions();
                return this.kf = t || e, this.kf;
            }, TextProperty.prototype.searchExpressions = function() {
                return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
            };
        }
        function initialize() {
            addDecorator();
        }
        function SVGComposableEffect() {}
        SVGComposableEffect.prototype = {
            createMergeNode: function(t, e) {
                var r, i, a = createNS("feMerge");
                for(a.setAttribute("result", t), i = 0; i < e.length; i += 1)(r = createNS("feMergeNode")).setAttribute("in", e[i]), a.appendChild(r), a.appendChild(r);
                return a;
            }
        };
        var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
        function SVGTintFilter(t, e, r, i, a) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = s, s.setAttribute("result", i + "_tint_1"), t.appendChild(s), (s = createNS("feColorMatrix")).setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", i + "_tint_2"), t.appendChild(s), this.matrixFilter = s;
            var n = this.createMergeNode(i, [
                a,
                i + "_tint_1",
                i + "_tint_2"
            ]);
            t.appendChild(n);
        }
        function SVGFillFilter(t, e, r, i) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", i), t.appendChild(a), this.matrixFilter = a;
        }
        function SVGStrokeEffect(t, e, r) {
            this.initialized = !1, this.filterManager = e, this.elem = r, this.paths = [];
        }
        function SVGTritoneFilter(t, e, r, i) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t.appendChild(a);
            var s = createNS("feComponentTransfer");
            s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("result", i), this.matrixFilter = s;
            var n = createNS("feFuncR");
            n.setAttribute("type", "table"), s.appendChild(n), this.feFuncR = n;
            var o = createNS("feFuncG");
            o.setAttribute("type", "table"), s.appendChild(o), this.feFuncG = o;
            var h = createNS("feFuncB");
            h.setAttribute("type", "table"), s.appendChild(h), this.feFuncB = h, t.appendChild(s);
        }
        function SVGProLevelsFilter(t, e, r, i) {
            this.filterManager = e;
            var a = this.filterManager.effectElements, s = createNS("feComponentTransfer");
            (a[10].p.k || 0 !== a[10].p.v || a[11].p.k || 1 !== a[11].p.v || a[12].p.k || 1 !== a[12].p.v || a[13].p.k || 0 !== a[13].p.v || a[14].p.k || 1 !== a[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", s)), (a[17].p.k || 0 !== a[17].p.v || a[18].p.k || 1 !== a[18].p.v || a[19].p.k || 1 !== a[19].p.v || a[20].p.k || 0 !== a[20].p.v || a[21].p.k || 1 !== a[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", s)), (a[24].p.k || 0 !== a[24].p.v || a[25].p.k || 1 !== a[25].p.v || a[26].p.k || 1 !== a[26].p.v || a[27].p.k || 0 !== a[27].p.v || a[28].p.k || 1 !== a[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", s)), (a[31].p.k || 0 !== a[31].p.v || a[32].p.k || 1 !== a[32].p.v || a[33].p.k || 1 !== a[33].p.v || a[34].p.k || 0 !== a[34].p.v || a[35].p.k || 1 !== a[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", s)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (s.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(s)), (a[3].p.k || 0 !== a[3].p.v || a[4].p.k || 1 !== a[4].p.v || a[5].p.k || 1 !== a[5].p.v || a[6].p.k || 0 !== a[6].p.v || a[7].p.k || 1 !== a[7].p.v) && ((s = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("result", i), t.appendChild(s), this.feFuncRComposed = this.createFeFunc("feFuncR", s), this.feFuncGComposed = this.createFeFunc("feFuncG", s), this.feFuncBComposed = this.createFeFunc("feFuncB", s));
        }
        function SVGDropShadowEffect(t, e, r, i, a) {
            var s = e.container.globalData.renderConfig.filterSize, n = e.data.fs || s;
            t.setAttribute("x", n.x || s.x), t.setAttribute("y", n.y || s.y), t.setAttribute("width", n.width || s.width), t.setAttribute("height", n.height || s.height), this.filterManager = e;
            var o = createNS("feGaussianBlur");
            o.setAttribute("in", "SourceAlpha"), o.setAttribute("result", i + "_drop_shadow_1"), o.setAttribute("stdDeviation", "0"), this.feGaussianBlur = o, t.appendChild(o);
            var h = createNS("feOffset");
            h.setAttribute("dx", "25"), h.setAttribute("dy", "0"), h.setAttribute("in", i + "_drop_shadow_1"), h.setAttribute("result", i + "_drop_shadow_2"), this.feOffset = h, t.appendChild(h);
            var l = createNS("feFlood");
            l.setAttribute("flood-color", "#00ff00"), l.setAttribute("flood-opacity", "1"), l.setAttribute("result", i + "_drop_shadow_3"), this.feFlood = l, t.appendChild(l);
            var p = createNS("feComposite");
            p.setAttribute("in", i + "_drop_shadow_3"), p.setAttribute("in2", i + "_drop_shadow_2"), p.setAttribute("operator", "in"), p.setAttribute("result", i + "_drop_shadow_4"), t.appendChild(p);
            var f = this.createMergeNode(i, [
                i + "_drop_shadow_4",
                a
            ]);
            t.appendChild(f);
        }
        extendPrototype([
            SVGComposableEffect
        ], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v / 100;
                this.linearFilter.setAttribute("values", linearFilterValue + " " + i + " 0"), this.matrixFilter.setAttribute("values", r[0] - e[0] + " 0 0 0 " + e[0] + " " + (r[1] - e[1]) + " 0 0 0 " + e[1] + " " + (r[2] - e[2]) + " 0 0 0 " + e[2] + " 0 0 0 1 0");
            }
        }, SVGFillFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[2].p.v, r = this.filterManager.effectElements[6].p.v;
                this.matrixFilter.setAttribute("values", "0 0 0 0 " + e[0] + " 0 0 0 0 " + e[1] + " 0 0 0 0 " + e[2] + " 0 0 0 " + r + " 0");
            }
        }, SVGStrokeEffect.prototype.initialize = function() {
            var t, e, r, i, a = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            for(1 === this.filterManager.effectElements[1].p.v ? (i = this.elem.maskManager.masksProperties.length, r = 0) : i = (r = this.filterManager.effectElements[0].p.v - 1) + 1, (e = createNS("g")).setAttribute("fill", "none"), e.setAttribute("stroke-linecap", "round"), e.setAttribute("stroke-dashoffset", 1); r < i; r += 1)t = createNS("path"), e.appendChild(t), this.paths.push({
                p: t,
                m: r
            });
            if (3 === this.filterManager.effectElements[10].p.v) {
                var s = createNS("mask"), n = createElementID();
                s.setAttribute("id", n), s.setAttribute("mask-type", "alpha"), s.appendChild(e), this.elem.globalData.defs.appendChild(s);
                var o = createNS("g");
                for(o.setAttribute("mask", "url(" + getLocationHref() + "#" + n + ")"); a[0];)o.appendChild(a[0]);
                this.elem.layerElement.appendChild(o), this.masker = s, e.setAttribute("stroke", "#fff");
            } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                if (2 === this.filterManager.effectElements[10].p.v) for(a = this.elem.layerElement.children || this.elem.layerElement.childNodes; a.length;)this.elem.layerElement.removeChild(a[0]);
                this.elem.layerElement.appendChild(e), this.elem.layerElement.removeAttribute("mask"), e.setAttribute("stroke", "#fff");
            }
            this.initialized = !0, this.pathMasker = e;
        }, SVGStrokeEffect.prototype.renderFrame = function(t) {
            var e;
            this.initialized || this.initialize();
            var r, i, a = this.paths.length;
            for(e = 0; e < a; e += 1)if (-1 !== this.paths[e].m && (r = this.elem.maskManager.viewData[this.paths[e].m], i = this.paths[e].p, (t || this.filterManager._mdf || r.prop._mdf) && i.setAttribute("d", r.lastPath), t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || r.prop._mdf)) {
                var s;
                if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                    var n = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h = i.getTotalLength();
                    s = "0 0 0 " + h * n + " ";
                    var l, p = h * (o - n), f = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, c = Math.floor(p / f);
                    for(l = 0; l < c; l += 1)s += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                    s += "0 " + 10 * h + " 0 0";
                } else s = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
                i.setAttribute("stroke-dasharray", s);
            }
            if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t || this.filterManager.effectElements[3].p._mdf)) {
                var m = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * m[0]) + "," + bmFloor(255 * m[1]) + "," + bmFloor(255 * m[2]) + ")");
            }
        }, SVGTritoneFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v, a = i[0] + " " + r[0] + " " + e[0], s = i[1] + " " + r[1] + " " + e[1], n = i[2] + " " + r[2] + " " + e[2];
                this.feFuncR.setAttribute("tableValues", a), this.feFuncG.setAttribute("tableValues", s), this.feFuncB.setAttribute("tableValues", n);
            }
        }, SVGProLevelsFilter.prototype.createFeFunc = function(t, e) {
            var r = createNS(t);
            return r.setAttribute("type", "table"), e.appendChild(r), r;
        }, SVGProLevelsFilter.prototype.getTableValue = function(t, e, r, i, a) {
            for(var s, n, o = 0, h = Math.min(t, e), l = Math.max(t, e), p = Array.call(null, {
                length: 256
            }), f = 0, c = a - i, m = e - t; o <= 256;)n = (s = o / 256) <= h ? m < 0 ? a : i : s >= l ? m < 0 ? i : a : i + c * Math.pow((s - t) / m, 1 / r), p[f] = n, f += 1, o += 256 / 255;
            return p.join(" ");
        }, SVGProLevelsFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e, r = this.filterManager.effectElements;
                this.feFuncRComposed && (t || r[3].p._mdf || r[4].p._mdf || r[5].p._mdf || r[6].p._mdf || r[7].p._mdf) && (e = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e), this.feFuncGComposed.setAttribute("tableValues", e), this.feFuncBComposed.setAttribute("tableValues", e)), this.feFuncR && (t || r[10].p._mdf || r[11].p._mdf || r[12].p._mdf || r[13].p._mdf || r[14].p._mdf) && (e = this.getTableValue(r[10].p.v, r[11].p.v, r[12].p.v, r[13].p.v, r[14].p.v), this.feFuncR.setAttribute("tableValues", e)), this.feFuncG && (t || r[17].p._mdf || r[18].p._mdf || r[19].p._mdf || r[20].p._mdf || r[21].p._mdf) && (e = this.getTableValue(r[17].p.v, r[18].p.v, r[19].p.v, r[20].p.v, r[21].p.v), this.feFuncG.setAttribute("tableValues", e)), this.feFuncB && (t || r[24].p._mdf || r[25].p._mdf || r[26].p._mdf || r[27].p._mdf || r[28].p._mdf) && (e = this.getTableValue(r[24].p.v, r[25].p.v, r[26].p.v, r[27].p.v, r[28].p.v), this.feFuncB.setAttribute("tableValues", e)), this.feFuncA && (t || r[31].p._mdf || r[32].p._mdf || r[33].p._mdf || r[34].p._mdf || r[35].p._mdf) && (e = this.getTableValue(r[31].p.v, r[32].p.v, r[33].p.v, r[34].p.v, r[35].p.v), this.feFuncA.setAttribute("tableValues", e));
            }
        }, extendPrototype([
            SVGComposableEffect
        ], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf) {
                    var e = this.filterManager.effectElements[0].p.v;
                    this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e[0]), Math.round(255 * e[1]), Math.round(255 * e[2])));
                }
                if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                    var r = this.filterManager.effectElements[3].p.v, i = (this.filterManager.effectElements[2].p.v - 90) * degToRads, a = r * Math.cos(i), s = r * Math.sin(i);
                    this.feOffset.setAttribute("dx", a), this.feOffset.setAttribute("dy", s);
                }
            }
        };
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(t, e, r) {
            this.initialized = !1, this.filterManager = e, this.filterElem = t, this.elem = r, r.matteElement = createNS("g"), r.matteElement.appendChild(r.layerElement), r.matteElement.appendChild(r.transformedElement), r.baseElement = r.matteElement;
        }
        function SVGGaussianBlurEffect(t, e, r, i) {
            t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), this.filterManager = e;
            var a = createNS("feGaussianBlur");
            a.setAttribute("result", i), t.appendChild(a), this.feGaussianBlur = a;
        }
        return SVGMatte3Effect.prototype.findSymbol = function(t) {
            for(var e = 0, r = _svgMatteSymbols.length; e < r;){
                if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
                e += 1;
            }
            return null;
        }, SVGMatte3Effect.prototype.replaceInParent = function(t, e) {
            var r = t.layerElement.parentNode;
            if (r) {
                for(var i, a = r.children, s = 0, n = a.length; s < n && a[s] !== t.layerElement;)s += 1;
                s <= n - 2 && (i = a[s + 1]);
                var o = createNS("use");
                o.setAttribute("href", "#" + e), i ? r.insertBefore(o, i) : r.appendChild(o);
            }
        }, SVGMatte3Effect.prototype.setElementAsMask = function(t, e) {
            if (!this.findSymbol(e)) {
                var r = createElementID(), i = createNS("mask");
                i.setAttribute("id", e.layerId), i.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e);
                var a = t.globalData.defs;
                a.appendChild(i);
                var s = createNS("symbol");
                s.setAttribute("id", r), this.replaceInParent(e, r), s.appendChild(e.layerElement), a.appendChild(s);
                var n = createNS("use");
                n.setAttribute("href", "#" + r), i.appendChild(n), e.data.hd = !1, e.show();
            }
            t.setMatte(e.layerId);
        }, SVGMatte3Effect.prototype.initialize = function() {
            for(var t = this.filterManager.effectElements[0].p.v, e = this.elem.comp.elements, r = 0, i = e.length; r < i;)e[r] && e[r].data.ind === t && this.setElementAsMask(this.elem, e[r]), r += 1;
            this.initialized = !0;
        }, SVGMatte3Effect.prototype.renderFrame = function() {
            this.initialized || this.initialize();
        }, SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = .3 * this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = 3 == r ? 0 : e, a = 2 == r ? 0 : e;
                this.feGaussianBlur.setAttribute("stdDeviation", i + " " + a);
                var s = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                this.feGaussianBlur.setAttribute("edgeMode", s);
            }
        }, registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect(20, SVGTintFilter, !0), registerEffect(21, SVGFillFilter, !0), registerEffect(22, SVGStrokeEffect, !1), registerEffect(23, SVGTritoneFilter, !0), registerEffect(24, SVGProLevelsFilter, !0), registerEffect(25, SVGDropShadowEffect, !0), registerEffect(28, SVGMatte3Effect, !1), registerEffect(29, SVGGaussianBlurEffect, !0), lottie;
    });
}), REACT_LOTTIE_PLAYER_VERSION = "3.5.3", LOTTIE_WEB_VERSION = "^5.10.2", PlayerState, PlayerEvent;
function parseSrc(t) {
    if ("object" == typeof t) return t;
    try {
        return JSON.parse(t);
    } catch (t) {}
    try {
        return new URL(t).toString();
    } catch (t) {}
    return t;
}
!function(t) {
    t.Loading = "loading", t.Playing = "playing", t.Paused = "paused", t.Stopped = "stopped", t.Frozen = "frozen", t.Error = "error";
}(PlayerState || (PlayerState = {})), function(t) {
    t.Load = "load", t.InstanceSaved = "instanceSaved", t.Error = "error", t.Ready = "ready", t.Play = "play", t.Pause = "pause", t.Stop = "stop", t.Freeze = "freeze", t.Loop = "loop", t.Complete = "complete", t.Frame = "frame";
}(PlayerEvent || (PlayerEvent = {}));
var defaultOptions = {
    clearCanvas: !1,
    hideOnTransparent: !0,
    progressiveLoad: !0
}, Player = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.container = null, r.unmounted = !1, r.handleBgChange = function(t) {
            r.setState({
                background: t
            });
        }, r.triggerDownload = function(t, e) {
            var r = document.createElement("a");
            r.href = t, r.download = e, document.body.appendChild(r), r.click(), document.body.removeChild(r);
        }, r.snapshot = function(t) {
            var e;
            void 0 === t && (t = !0);
            var i = r.props.id ? r.props.id : "lottie", a = document.getElementById(i);
            if ("svg" === r.props.renderer) {
                if (a) {
                    var s = a.querySelector("svg");
                    if (s) {
                        var n = (new XMLSerializer).serializeToString(s);
                        e = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(n);
                    }
                }
                t && r.triggerDownload(e, "snapshot.svg");
            } else if ("canvas" === r.props.renderer) {
                if (a) {
                    var o = a.querySelector("canvas");
                    o && (e = o.toDataURL("image/png"));
                }
                t && r.triggerDownload(e, "snapshot.png");
            }
            return e;
        }, "undefined" != typeof window && (window.lottie = lottie), r.state = {
            animationData: null,
            background: "transparent",
            containerRef: $lT7pJ.createRef(),
            debug: !0,
            instance: null,
            playerState: PlayerState.Loading,
            seeker: 0
        }, r;
    }
    return __extends(e, t), e.getDerivedStateFromProps = function(t, e) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(r) {
                return t.background !== e.background ? [
                    2,
                    {
                        background: t.background
                    }
                ] : [
                    2,
                    null
                ];
            });
        });
    }, e.prototype.getVersions = function() {
        return {
            lottieWebVersion: LOTTIE_WEB_VERSION,
            lottiePlayerVersion: REACT_LOTTIE_PLAYER_VERSION
        };
    }, e.prototype.componentDidMount = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.unmounted ? [
                            3,
                            2
                        ] : [
                            4,
                            this.createLottie()
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.componentWillUnmount = function() {
        this.unmounted = !0, this.state.instance && this.state.instance.destroy();
    }, e.prototype.componentDidUpdate = function(t) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.props.src === t.src ? [
                            3,
                            2
                        ] : (this.state.instance && this.state.instance.destroy(), [
                            4,
                            this.createLottie()
                        ]);
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.render = function() {
        var t = this, e = this.props, r = e.children, i = e.loop, a = e.style, s = e.onBackgroundChange, n = e.className, o = this.state, h = o.animationData, l = o.instance, p = o.playerState, f = o.seeker, c = o.debug, m = o.background;
        return $lT7pJ.createElement("div", {
            className: "lf-player-container"
        }, this.state.playerState === PlayerState.Error ? $lT7pJ.createElement("div", {
            className: "lf-error"
        }, $lT7pJ.createElement("span", {
            "aria-label": "error-symbol",
            role: "img"
        }, "\u26A0\uFE0F")) : $lT7pJ.createElement("div", {
            id: this.props.id ? this.props.id : "lottie",
            ref: function(e) {
                return t.container = e;
            },
            style: __assign({
                background: m,
                margin: "0 auto",
                outline: "none",
                overflow: "hidden"
            }, a),
            className: n
        }), $lT7pJ.Children.map(r, function(e) {
            return $lT7pJ.isValidElement(e) ? $lT7pJ.cloneElement(e, {
                animationData: h,
                background: m,
                debug: c,
                instance: l,
                loop: i,
                pause: function() {
                    return t.pause();
                },
                play: function() {
                    return t.play();
                },
                playerState: p,
                seeker: f,
                setBackground: function(e) {
                    t.setState({
                        background: e
                    }), "function" == typeof s && s(e);
                },
                setSeeker: function(e, r) {
                    return t.setSeeker(e, r);
                },
                stop: function() {
                    return t.stop();
                },
                toggleDebug: function() {
                    return t.toggleDebug();
                },
                setLoop: function(e) {
                    return t.setLoop(e);
                },
                colorChangedEvent: function(e) {
                    t.handleBgChange(e);
                },
                snapshot: function() {
                    t.snapshot();
                }
            }) : null;
        }));
    }, e.prototype.toggleDebug = function() {
        this.setState({
            debug: !this.state.debug
        });
    }, e.prototype.createLottie = function() {
        return __awaiter(this, void 0, void 0, function() {
            var t, e, r, i, a, s, n, o, h, l, p, f, c, m, d = this;
            return __generator(this, function(u) {
                switch(u.label){
                    case 0:
                        if (t = this.props, e = t.autoplay, r = t.direction, i = t.loop, a = t.lottieRef, s = t.renderer, n = t.speed, o = t.src, h = t.background, l = t.rendererSettings, p = t.hover, f = this.state.instance, !o || !this.container) return [
                            2
                        ];
                        u.label = 1;
                    case 1:
                        return u.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]), "string" != typeof (c = parseSrc(o)) ? [
                            3,
                            4
                        ] : [
                            4,
                            fetch(c).catch(function() {
                                throw d.setState({
                                    playerState: PlayerState.Error
                                }), d.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 2:
                        return [
                            4,
                            u.sent().json().catch(function() {
                                throw d.setState({
                                    playerState: PlayerState.Error
                                }), d.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 3:
                        c = u.sent(), u.label = 4;
                    case 4:
                        return f && f.destroy(), m = lottie.loadAnimation({
                            rendererSettings: l || defaultOptions,
                            animationData: c,
                            autoplay: e || !1,
                            container: this.container,
                            loop: i || !1,
                            renderer: s
                        }), n && m.setSpeed(n), this.setState({
                            animationData: c
                        }), this.setState({
                            instance: m
                        }, function() {
                            d.triggerEvent(PlayerEvent.InstanceSaved), "function" == typeof a && a(m), e && d.play();
                        }), m.addEventListener("enterFrame", function() {
                            d.triggerEvent(PlayerEvent.Frame), d.setState({
                                seeker: Math.floor(m.currentFrame)
                            });
                        }), m.addEventListener("DOMLoaded", function() {
                            d.triggerEvent(PlayerEvent.Load);
                        }), m.addEventListener("data_ready", function() {
                            d.triggerEvent(PlayerEvent.Ready);
                        }), m.addEventListener("data_failed", function() {
                            d.setState({
                                playerState: PlayerState.Error
                            }), d.triggerEvent(PlayerEvent.Error);
                        }), m.addEventListener("loopComplete", function() {
                            d.triggerEvent(PlayerEvent.Loop);
                        }), m.addEventListener("complete", function() {
                            d.triggerEvent(PlayerEvent.Complete), d.setState({
                                playerState: PlayerState.Paused
                            }), d.props.keepLastFrame && !d.props.loop || d.setSeeker(0);
                        }), this.container && (this.container.addEventListener("mouseenter", function() {
                            p && d.state.playerState !== PlayerState.Playing && (d.props.keepLastFrame && d.stop(), d.play());
                        }), this.container.addEventListener("mouseleave", function() {
                            p && d.state.playerState === PlayerState.Playing && d.stop();
                        })), n && this.setPlayerSpeed(n), r && this.setPlayerDirection(r), h && this.setState({
                            background: h
                        }), [
                            3,
                            6
                        ];
                    case 5:
                        return u.sent(), this.setState({
                            playerState: PlayerState.Error
                        }), this.triggerEvent(PlayerEvent.Error), [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.play = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Play), t.play(), this.setState({
            playerState: PlayerState.Playing
        }));
    }, e.prototype.pause = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Pause), t.pause(), this.setState({
            playerState: PlayerState.Paused
        }));
    }, e.prototype.stop = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Stop), t.stop(), this.setState({
            playerState: PlayerState.Stopped
        }));
    }, e.prototype.setPlayerSpeed = function(t) {
        var e = this.state.instance;
        e && e.setSpeed(t);
    }, e.prototype.setPlayerDirection = function(t) {
        var e = this.state.instance;
        e && e.setDirection(t);
    }, e.prototype.setSeeker = function(t, e) {
        void 0 === e && (e = !1);
        var r = this.state, i = r.instance, a = r.playerState;
        i && (e && a === PlayerState.Playing ? i.goToAndPlay(t, !0) : (i.goToAndStop(t, !0), this.triggerEvent(PlayerEvent.Pause), this.setState({
            playerState: PlayerState.Paused
        })));
    }, e.prototype.setLoop = function(t) {
        var e = this.state.instance;
        e && (e.loop = t, this.setState({
            instance: e
        }));
    }, e.prototype.triggerEvent = function(t) {
        var e = this.props.onEvent;
        e && e(t);
    }, e.defaultProps = {
        loop: !1
    }, e;
}($lT7pJ.Component);
function styleInject(t, e) {
    void 0 === e && (e = {});
    var r = e.insertAt;
    if (t && "undefined" != typeof document) {
        var i = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
        a.type = "text/css", "top" === r && i.firstChild ? i.insertBefore(a, i.firstChild) : i.appendChild(a), a.styleSheet ? a.styleSheet.cssText = t : a.appendChild(document.createTextNode(t));
    }
}
var css_248z = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '\u297C';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n", stylesheet = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '\u297C';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n";
styleInject(css_248z);
var ColorPicker = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.state = {
            red: 0,
            green: 0,
            blue: 0,
            rgba: null,
            hex: "#000000",
            colorComponents: []
        }, e.handleChange = function(t, r) {
            if ("r" === t) {
                var i = "#" + (256 | r).toString(16).slice(1) + (256 | e.state.green).toString(16).slice(1) + (256 | e.state.blue).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            } else if ("g" === t) {
                i = "#" + (256 | e.state.red).toString(16).slice(1) + (256 | r).toString(16).slice(1) + (256 | e.state.blue).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            } else if ("b" === t) {
                i = "#" + (256 | e.state.red).toString(16).slice(1) + (256 | e.state.green).toString(16).slice(1) + (256 | r).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            }
        }, e.parseColor = function(t) {
            var r;
            if ("string" == typeof t) {
                if ("#" === t[0]) {
                    var i = 4 === t.length ? [
                        t.slice(1, 2),
                        t.slice(2, 3),
                        t.slice(3, 4)
                    ].map(function(t) {
                        return parseInt("" + t + t, 16);
                    }) : [
                        t.slice(1, 3),
                        t.slice(3, 5),
                        t.slice(5, 7)
                    ].map(function(t) {
                        return parseInt(t, 16);
                    });
                    e.setState({
                        colorComponents: i
                    });
                } else if (t.startsWith("rgb")) void 0 !== (i = null === (r = t.match(/\d+/g)) || void 0 === r ? void 0 : r.map(function(t) {
                    return parseInt(t);
                })) && e.setState({
                    colorComponents: i
                });
                e.state.colorComponents.length && (e.setState({
                    red: e.state.colorComponents[0]
                }), e.setState({
                    green: e.state.colorComponents[1]
                }), e.setState({
                    blue: e.state.colorComponents[2]
                }));
            }
        }, e;
    }
    return __extends(e, t), e.prototype.componentDidUpdate = function(t, e) {
        return this.props.colorChangedEvent && this.state.hex !== e.hex && this.props.colorChangedEvent(this.state.hex), !0;
    }, e.prototype.render = function() {
        var t = this;
        return $lT7pJ.createElement("div", {
            className: "lf-color-picker"
        }, $lT7pJ.createElement("div", {
            className: "lf-color-selectors"
        }, $lT7pJ.createElement("div", {
            className: "lf-color-component"
        }, $lT7pJ.createElement("strong", null, "Red"), $lT7pJ.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e) {
                t.setState({
                    red: e.target.value
                }), t.handleChange("r", e.target.value);
            }
        }), $lT7pJ.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e) {
                t.setState({
                    red: e.target.value
                }), t.handleChange("r", e.target.value);
            }
        })), $lT7pJ.createElement("div", {
            className: "lf-color-component"
        }, $lT7pJ.createElement("strong", null, "Green"), $lT7pJ.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e) {
                t.setState({
                    green: e.target.value
                }), t.handleChange("g", e.target.value);
            }
        }), $lT7pJ.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e) {
                t.setState({
                    green: e.target.value
                }), t.handleChange("g", e.target.value);
            }
        })), $lT7pJ.createElement("div", {
            className: "lf-color-component"
        }, $lT7pJ.createElement("strong", null, "Blue"), $lT7pJ.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e) {
                t.setState({
                    blue: e.target.value
                }), t.handleChange("b", e.target.value);
            }
        }), $lT7pJ.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e) {
                t.setState({
                    blue: e.target.value
                }), t.handleChange("b", e.target.value);
            }
        }))), $lT7pJ.createElement("div", {
            className: "lf-color-preview"
        }, $lT7pJ.createElement("div", {
            className: "lf-preview",
            style: {
                background: "rgb(" + this.state.red + ", " + this.state.green + ", " + this.state.blue + ")"
            }
        }), $lT7pJ.createElement("div", null, $lT7pJ.createElement("input", {
            className: "lf-text-input",
            type: "text",
            value: this.state.hex,
            onChange: function(e) {
                t.setState({
                    hex: e.target.value
                }), t.parseColor(e.target.value);
            }
        }))));
    }, e;
}($lT7pJ.Component), Popover = function(t) {
    var e = t.children, r = t.icon, i = (0, $lT7pJ.useState)(null), a = i[0], s = i[1], n = (0, $lT7pJ.useState)(null), o = n[0], h = n[1], l = (0, $lT7pJ.useState)(null), p = l[0], f = l[1], c = (0, $lT7pJ.useState)(!1), m = c[0], d = c[1];
    (0, $lT7pJ.useEffect)(function() {
        if (a && o) {
            var t = a.getBoundingClientRect(), e = o.getBoundingClientRect(), r = t.left + e.width > window.innerWidth ? -1 : 0;
            f(r);
        }
    }, [
        p,
        o,
        a
    ]);
    return $lT7pJ.createElement("div", {
        className: "lf-popover",
        onMouseOver: function() {
            d(!0);
        },
        onMouseLeave: function() {
            d(!1);
        },
        ref: function(t) {
            s(t);
        }
    }, $lT7pJ.createElement("div", {
        className: " lf-player-btn"
    }, r), $lT7pJ.createElement("div", {
        className: "lf-popover-content",
        ref: function(t) {
            h(t);
        },
        style: {
            bottom: "22px",
            right: "0px",
            zIndex: 2,
            visibility: m ? "visible" : "hidden"
        }
    }, e));
}, Seeker = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.inputRef = $lT7pJ.createRef(), r.handleChange = function() {
            return function(t) {
                var e = t.target.value, i = Math.floor(e / 100 * r.props.max);
                r.props.onChange(i);
            };
        }, r.state = {
            value: 0
        }, r;
    }
    return __extends(e, t), e.prototype.render = function() {
        var t = this.props.value / this.props.max * 100, e = {
            backgroundImage: "-webkit-gradient(linear, left top, right top, color-stop(" + t + "%, rgba(15, 204, 206, 0.4)), color-stop(" + t + "%, #DAE1E7))"
        }, r = {
            position: "absolute",
            left: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        }, i = {
            position: "absolute",
            right: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        };
        return $lT7pJ.createElement("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                marginRight: "5px",
                marginLeft: "5px",
                position: "relative"
            }
        }, $lT7pJ.createElement("input", {
            ref: this.inputRef,
            id: "track",
            className: "lf-progress",
            name: "progress",
            "aria-label": "progress",
            type: "range",
            min: "0",
            max: "100",
            step: "0.1",
            value: t,
            onInput: this.handleChange(),
            onChange: this.handleChange(),
            style: e
        }), this.props.showLabels && $lT7pJ.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between"
            }
        }, $lT7pJ.createElement("div", {
            style: r
        }, this.props.min), $lT7pJ.createElement("div", {
            style: i
        }, this.props.max)));
    }, e;
}($lT7pJ.Component), ControlButtonStyle = {
    display: "inline-flex",
    cursor: "pointer"
}, Controls = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.state = {
            activeFrame: 0,
            mouseDown: !1
        }, r;
    }
    return __extends(e, t), e.prototype.render = function() {
        var t = this, e = this.props, r = e.instance, i = e.playerState, a = e.seeker, s = e.setLoop, n = e.setSeeker, o = e.play, h = e.pause, l = e.stop, p = e.visible, f = e.buttons;
        if (!r) return null;
        if (!p) return null;
        var c = !f || f.includes("play"), m = !f || f.includes("stop"), d = !f || f.includes("repeat"), u = !f || f.includes("frame"), y = !f || f.includes("background"), g = !f || f.includes("snapshot"), v = {
            width: 14,
            height: 14,
            viewBox: "0 0 24 24"
        }, b = Math.round(r.currentFrame);
        return $lT7pJ.createElement("div", {
            className: "lf-player-controls",
            style: {
                display: "flex",
                justifyContent: "space-between",
                height: "60px",
                alignItems: "center",
                backgroundColor: this.props.transparentTheme ? "transparent" : this.props.darkTheme ? "#3C3C3C" : "#ffffff",
                paddingLeft: "10px",
                paddingRight: "10px"
            }
        }, c && $lT7pJ.createElement("div", {
            role: "button",
            "aria-label": i === PlayerState.Playing ? PlayerEvent.Pause : PlayerEvent.Play,
            tabIndex: 0,
            onClick: function() {
                i === PlayerState.Playing ? "function" == typeof h && h() : "function" == typeof o && o();
            },
            onKeyDown: function() {
                i === PlayerState.Playing ? "function" == typeof h && h() : "function" == typeof o && o();
            },
            className: "lf-player-btn",
            style: ControlButtonStyle
        }, i === PlayerState.Playing ? $lT7pJ.createElement("svg", __assign({}, v), $lT7pJ.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "14",
            y: ".5"
        }), $lT7pJ.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "2",
            y: ".5"
        })) : $lT7pJ.createElement("svg", __assign({}, v), $lT7pJ.createElement("path", {
            d: "M2 3.4C2 1.9 3.5 1 4.8 1.8l16.5 9.6c1.2.7 1.2 2.5 0 3.2L4.8 24.2C3.5 25 2 24.1 2 22.6V3.4z"
        }))), m && $lT7pJ.createElement("div", {
            tabIndex: 0,
            role: "button",
            "aria-label": PlayerEvent.Stop,
            onClick: function() {
                return l && l();
            },
            onKeyDown: function() {
                return l && l();
            },
            className: i === PlayerState.Stopped ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $lT7pJ.createElement("svg", __assign({}, v), $lT7pJ.createElement("path", {
            d: "M2 3.667A1.67 1.67 0 0 1 3.667 2h16.666A1.67 1.67 0 0 1 22 3.667v16.666A1.67 1.67 0 0 1 20.333\n            22H3.667A1.67 1.67 0 0 1 2 20.333z"
        }))), $lT7pJ.createElement(Seeker, {
            min: 0,
            step: 1,
            max: r ? r.totalFrames : 1,
            value: a || 0,
            onChange: function(e) {
                n && t.setState({
                    activeFrame: e
                }, function() {
                    n(e, !1);
                });
            },
            onChangeEnd: function(e) {
                n && t.setState({
                    activeFrame: e
                }, function() {
                    n(e, !1);
                });
            },
            showLabels: this.props.showLabels,
            darkTheme: this.props.darkTheme
        }), u && $lT7pJ.createElement("div", {
            role: "button",
            className: "lf-player-btn-container"
        }, $lT7pJ.createElement("input", {
            style: {
                outline: "none",
                border: this.props.darkTheme ? "1px #505050 solid" : "1px #ccc solid",
                borderRadius: "3px",
                width: "40px",
                textAlign: "center",
                backgroundColor: this.props.darkTheme ? "#505050" : "#ffffff",
                color: this.props.darkTheme ? "#B9B9B9" : "#999",
                fontSize: "0.7rem",
                padding: "0",
                fontFamily: "inherit"
            },
            type: "text",
            value: b,
            readOnly: !0
        })), d && $lT7pJ.createElement("div", {
            role: "button",
            "aria-label": PlayerEvent.Loop,
            tabIndex: 0,
            onClick: function() {
                r && s && s(!r.loop);
            },
            onKeyDown: function() {
                r && s && s(!r.loop);
            },
            className: r.loop ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $lT7pJ.createElement("svg", __assign({}, v), $lT7pJ.createElement("path", {
            d: "M12.5 16.8137h-.13v1.8939h4.9696c3.6455 0 6.6113-2.9658 6.6113-6.6116\n            0-3.64549-2.9658-6.61131-6.6113-6.61131-.5231 0-.947.42391-.947.94696 0 .52304.4239.94696.947.94696 2.6011 0\n            4.7174 2.11634 4.7174 4.71739 0 2.6014-2.1166 4.7177-4.7174 4.7177H12.5zM13.6025\n            5.61469v-.13H7.48137C3.83582 5.48469.87 8.45051.87 12.096c0 3.6509 3.17269 6.6117 6.81304 6.6117.52304 0\n            .94696-.424.94696-.947 0-.5231-.42392-.947-.94696-.947-2.60804 0-4.91907-2.1231-4.91907-4.7176 0-2.60115\n            2.11634-4.71744 4.7174-4.71744h6.12113V5.61469z",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }), $lT7pJ.createElement("path", {
            d: "M11.1482\n            2.20355h0l-.001-.00116c-.3412-.40061-.9405-.44558-1.33668-.0996h-.00001c-.39526.34519-.43936.94795-.09898\n            1.34767l2.51487 3.03683-2.51894 3.06468c-.33872.40088-.29282 1.00363.10347\n            1.34723l.08517-.0982-.08517.0982c.17853.1549.39807.2308.61647.2308.2671 0 .5328-.114.72-.3347h0l.0011-.0014\n            3.0435-3.68655.0006-.00068c.3035-.35872.3025-.88754-.0019-1.24526l-3.0425-3.65786zM13.9453\n            21.7965h0l.001.0011c.3413.4006.9407.4456 1.337.0996h0c.3953-.3452.4395-.9479.099-1.3477l-2.5154-3.0368\n            2.5195-3.0647c.3388-.4008.2929-1.0036-.1035-1.3472l-.0852.0982.0852-.0982c-.1786-.1549-.3981-.2308-.6166-.2308-.2671\n            0-.5329.114-.7202.3347h0l-.0011.0014-3.0442\n            3.6865c-.0001.0003-.0003.0005-.0005.0007-.3036.3587-.3027.8876.0019 1.2453l3.0431 3.6579z",
            fill: "#8795A1",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }))), y && $lT7pJ.createElement(Popover, {
            icon: $lT7pJ.createElement("svg", __assign({}, v), $lT7pJ.createElement("path", {
                d: "M12 3.1L6.1 8.6a7.6 7.6 0 00-2.2 4 7.2 7.2 0 00.4 4.4 7.9 7.9 0 003 3.5 8.7 8.7 0 004.7 1.3c1.6 0\n            3.2-.5 4.6-1.3s2.4-2 3-3.5a7.2 7.2 0 00.5-4.5 7.6 7.6 0 00-2.2-4L12 3.2zM12 0l7.5 7a9.8 9.8 0 013 5.1\n            9.3 9.3 0 01-.6 5.8c-.9 1.8-2.2 3.3-4 4.4A11.2 11.2 0 0112 24a11.2 11.2 0\n            01-6-1.7c-1.7-1-3-2.6-3.9-4.4a9.3 9.3 0 01-.6-5.8c.4-2 1.5-3.7 3-5L12 0zM6 14h12c0 1.5-.7 3-1.8 4s-2.6\n            1.6-4.2 1.6S9 19 7.8 18s-1.7-2.5-1.7-4z"
            }))
        }, $lT7pJ.createElement("div", {
            slot: "content",
            className: "lf-popover popover-background"
        }, $lT7pJ.createElement(ColorPicker, {
            colorChangedEvent: this.props.colorChangedEvent
        }))), g && $lT7pJ.createElement(Popover, {
            icon: $lT7pJ.createElement("svg", __assign({}, v), $lT7pJ.createElement("path", {
                clipRule: "evenodd",
                d: "M0 3.01A2.983 2.983 0 012.983.027H16.99a2.983 2.983 0 012.983 2.983v14.008a2.982 2.982 0 01-2.983\n              2.983H2.983A2.983 2.983 0 010 17.018zm2.983-.941a.941.941 0 00-.942.94v14.01c0\n              .52.422.94.942.94H16.99a.94.94 0 00.941-.94V3.008a.941.941 0 00-.94-.94H2.981z",
                fillRule: "evenodd"
            }), $lT7pJ.createElement("path", {
                d: "M12.229 7.945l-2.07 4.598-2.586-2.605-2.414 2.758v2.146h9.656V11.93z"
            }), $lT7pJ.createElement("circle", {
                cx: "7.444",
                cy: "6.513",
                r: "2.032"
            }), $lT7pJ.createElement("path", {
                d: "M9.561 23.916h11.25a2.929 2.929 0 002.926-2.927V9.954a1.06 1.06 0 10-2.122 0v11.035a.805.805 0\n              01-.803.804H9.562a1.061 1.061 0 100 2.123z",
                stroke: "#8795a1",
                strokeWidth: ".215"
            }))
        }, $lT7pJ.createElement("div", {
            slot: "content",
            className: "lf-popover lf-popover-snapshot",
            onWheel: function(t) {
                n && n(b + (t.deltaY > 0 ? -1 : 1), !1);
            }
        }, $lT7pJ.createElement("h5", null, "Frame ", b), $lT7pJ.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download SVG"), $lT7pJ.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download PNG"), $lT7pJ.createElement("i", {
            className: "lf-note"
        }, "Scroll with mousewheel to find exact frame"))));
    }, e;
}($lT7pJ.Component);

});

parcelRegister("9GcjX", function(module, exports) {

var $hIXGI = parcelRequire("hIXGI");

var $cBXue = parcelRequire("cBXue");
var $70c197f8914c1458$require$Buffer = $cBXue.Buffer;










/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = root.pdfjsLib = factory();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.getModificationDate = getModificationDate;
                exports.getUuid = getUuid;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isNodeJS = void 0;
                exports.normalizeUnicode = normalizeUnicode;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                const isNodeJS = typeof $hIXGI === "object" && $hIXGI + "" === "[object process]" && !$hIXGI.versions.nw && !($hIXGI.versions.electron && $hIXGI.type && $hIXGI.type !== "browser");
                exports.isNodeJS = isNodeJS;
                const IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                const FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                const MAX_IMAGE_SIZE_TO_CACHE = 10e6;
                exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
                const LINE_FACTOR = 1.35;
                exports.LINE_FACTOR = LINE_FACTOR;
                const LINE_DESCENT_FACTOR = 0.35;
                exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
                const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
                exports.BASELINE_FACTOR = BASELINE_FACTOR;
                const RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                const AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                const AnnotationEditorPrefix = "pdfjs_internal_editor_";
                exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
                const AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports.AnnotationEditorType = AnnotationEditorType;
                const AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
                const PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                const TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                const ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                const AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                const AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                const AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                const AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                const AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                const AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                const DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                const PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                const VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                const CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                exports.CMapCompressionType = CMapCompressionType;
                const OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                const PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                let verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function _isValidProtocol(url) {
                    switch(url?.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url, baseUrl = null, options = null) {
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                const dots = url.match(/\./g);
                                if (dots?.length >= 2) url = `http://${url}`;
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch  {}
                        }
                        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch  {}
                    return null;
                }
                function shadow(obj, prop, value, nonSerializable = false) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: !nonSerializable,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                const BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                class PasswordException extends BaseException {
                    constructor(msg, code){
                        super(msg, "PasswordException");
                        this.code = code;
                    }
                }
                exports.PasswordException = PasswordException;
                class UnknownErrorException extends BaseException {
                    constructor(msg, details){
                        super(msg, "UnknownErrorException");
                        this.details = details;
                    }
                }
                exports.UnknownErrorException = UnknownErrorException;
                class InvalidPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "InvalidPDFException");
                    }
                }
                exports.InvalidPDFException = InvalidPDFException;
                class MissingPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "MissingPDFException");
                    }
                }
                exports.MissingPDFException = MissingPDFException;
                class UnexpectedResponseException extends BaseException {
                    constructor(msg, status){
                        super(msg, "UnexpectedResponseException");
                        this.status = status;
                    }
                }
                exports.UnexpectedResponseException = UnexpectedResponseException;
                class FormatError extends BaseException {
                    constructor(msg){
                        super(msg, "FormatError");
                    }
                }
                exports.FormatError = FormatError;
                class AbortException extends BaseException {
                    constructor(msg){
                        super(msg, "AbortException");
                    }
                }
                exports.AbortException = AbortException;
                function bytesToString(bytes) {
                    if (typeof bytes !== "object" || bytes?.length === undefined) unreachable("Invalid argument for bytesToString");
                    const length = bytes.length;
                    const MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    const strBuf = [];
                    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        const chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    if (typeof str !== "string") unreachable("Invalid argument for stringToBytes");
                    const length = str.length;
                    const bytes = new Uint8Array(length);
                    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    const obj = Object.create(null);
                    for (const [key, value] of map)obj[key] = value;
                    return obj;
                }
                function isLittleEndian() {
                    const buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch  {
                        return false;
                    }
                }
                class FeatureTest {
                    static get isLittleEndian() {
                        return shadow(this, "isLittleEndian", isLittleEndian());
                    }
                    static get isEvalSupported() {
                        return shadow(this, "isEvalSupported", isEvalSupported());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                    }
                    static get platform() {
                        if (typeof navigator === "undefined") return shadow(this, "platform", {
                            isWin: false,
                            isMac: false
                        });
                        return shadow(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                    }
                }
                exports.FeatureTest = FeatureTest;
                const hexNumbers = [
                    ...Array(256).keys()
                ].map((n)=>n.toString(16).padStart(2, "0"));
                class Util {
                    static makeHexColor(r, g, b) {
                        return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
                    }
                    static scaleMinMax(transform, minMax) {
                        let temp;
                        if (transform[0]) {
                            if (transform[0] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[0];
                            minMax[1] *= transform[0];
                            if (transform[3] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[3];
                            minMax[3] *= transform[3];
                        } else {
                            temp = minMax[0];
                            minMax[0] = minMax[2];
                            minMax[2] = temp;
                            temp = minMax[1];
                            minMax[1] = minMax[3];
                            minMax[3] = temp;
                            if (transform[1] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[1];
                            minMax[3] *= transform[1];
                            if (transform[2] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[2];
                            minMax[1] *= transform[2];
                        }
                        minMax[0] += transform[4];
                        minMax[1] += transform[4];
                        minMax[2] += transform[5];
                        minMax[3] += transform[5];
                    }
                    static transform(m1, m2) {
                        return [
                            m1[0] * m2[0] + m1[2] * m2[1],
                            m1[1] * m2[0] + m1[3] * m2[1],
                            m1[0] * m2[2] + m1[2] * m2[3],
                            m1[1] * m2[2] + m1[3] * m2[3],
                            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                        ];
                    }
                    static applyTransform(p, m) {
                        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                        return [
                            xt,
                            yt
                        ];
                    }
                    static applyInverseTransform(p, m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                        return [
                            xt,
                            yt
                        ];
                    }
                    static getAxialAlignedBoundingBox(r, m) {
                        const p1 = this.applyTransform(r, m);
                        const p2 = this.applyTransform(r.slice(2, 4), m);
                        const p3 = this.applyTransform([
                            r[0],
                            r[3]
                        ], m);
                        const p4 = this.applyTransform([
                            r[2],
                            r[1]
                        ], m);
                        return [
                            Math.min(p1[0], p2[0], p3[0], p4[0]),
                            Math.min(p1[1], p2[1], p3[1], p4[1]),
                            Math.max(p1[0], p2[0], p3[0], p4[0]),
                            Math.max(p1[1], p2[1], p3[1], p4[1])
                        ];
                    }
                    static inverseTransform(m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / d,
                            -m[1] / d,
                            -m[2] / d,
                            m[0] / d,
                            (m[2] * m[5] - m[4] * m[3]) / d,
                            (m[4] * m[1] - m[5] * m[0]) / d
                        ];
                    }
                    static singularValueDecompose2dScale(m) {
                        const transpose = [
                            m[0],
                            m[2],
                            m[1],
                            m[3]
                        ];
                        const a = m[0] * transpose[0] + m[1] * transpose[2];
                        const b = m[0] * transpose[1] + m[1] * transpose[3];
                        const c = m[2] * transpose[0] + m[3] * transpose[2];
                        const d = m[2] * transpose[1] + m[3] * transpose[3];
                        const first = (a + d) / 2;
                        const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                        const sx = first + second || 1;
                        const sy = first - second || 1;
                        return [
                            Math.sqrt(sx),
                            Math.sqrt(sy)
                        ];
                    }
                    static normalizeRect(rect) {
                        const r = rect.slice(0);
                        if (rect[0] > rect[2]) {
                            r[0] = rect[2];
                            r[2] = rect[0];
                        }
                        if (rect[1] > rect[3]) {
                            r[1] = rect[3];
                            r[3] = rect[1];
                        }
                        return r;
                    }
                    static intersect(rect1, rect2) {
                        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                        if (xLow > xHigh) return null;
                        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                        if (yLow > yHigh) return null;
                        return [
                            xLow,
                            yLow,
                            xHigh,
                            yHigh
                        ];
                    }
                    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                        const tvalues = [], bounds = [
                            [],
                            []
                        ];
                        let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                        for(let i = 0; i < 2; ++i){
                            if (i === 0) {
                                b = 6 * x0 - 12 * x1 + 6 * x2;
                                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                c = 3 * x1 - 3 * x0;
                            } else {
                                b = 6 * y0 - 12 * y1 + 6 * y2;
                                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                c = 3 * y1 - 3 * y0;
                            }
                            if (Math.abs(a) < 1e-12) {
                                if (Math.abs(b) < 1e-12) continue;
                                t = -c / b;
                                if (0 < t && t < 1) tvalues.push(t);
                                continue;
                            }
                            b2ac = b * b - 4 * c * a;
                            sqrtb2ac = Math.sqrt(b2ac);
                            if (b2ac < 0) continue;
                            t1 = (-b + sqrtb2ac) / (2 * a);
                            if (0 < t1 && t1 < 1) tvalues.push(t1);
                            t2 = (-b - sqrtb2ac) / (2 * a);
                            if (0 < t2 && t2 < 1) tvalues.push(t2);
                        }
                        let j = tvalues.length, mt;
                        const jlen = j;
                        while(j--){
                            t = tvalues[j];
                            mt = 1 - t;
                            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                        }
                        bounds[0][jlen] = x0;
                        bounds[1][jlen] = y0;
                        bounds[0][jlen + 1] = x3;
                        bounds[1][jlen + 1] = y3;
                        bounds[0].length = bounds[1].length = jlen + 2;
                        return [
                            Math.min(...bounds[0]),
                            Math.min(...bounds[1]),
                            Math.max(...bounds[0]),
                            Math.max(...bounds[1])
                        ];
                    }
                }
                exports.Util = Util;
                const PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    if (str[0] >= "\xef") {
                        let encoding;
                        if (str[0] === "\xfe" && str[1] === "\xff") encoding = "utf-16be";
                        else if (str[0] === "\xff" && str[1] === "\xfe") encoding = "utf-16le";
                        else if (str[0] === "\xef" && str[1] === "\xbb" && str[2] === "\xbf") encoding = "utf-8";
                        if (encoding) try {
                            const decoder = new TextDecoder(encoding, {
                                fatal: true
                            });
                            const buffer = stringToBytes(str);
                            return decoder.decode(buffer);
                        } catch (ex) {
                            warn(`stringToPDFString: "${ex}".`);
                        }
                    }
                    const strBuf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && v?.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(let i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate(date = new Date()) {
                    const buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                class PromiseCapability {
                    #settled = false;
                    constructor(){
                        this.promise = new Promise((resolve, reject)=>{
                            this.resolve = (data)=>{
                                this.#settled = true;
                                resolve(data);
                            };
                            this.reject = (reason)=>{
                                this.#settled = true;
                                reject(reason);
                            };
                        });
                    }
                    get settled() {
                        return this.#settled;
                    }
                }
                exports.PromiseCapability = PromiseCapability;
                let NormalizeRegex = null;
                let NormalizationMap = null;
                function normalizeUnicode(str) {
                    if (!NormalizeRegex) {
                        NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                        NormalizationMap = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str.replaceAll(NormalizeRegex, (_, p1, p2)=>{
                        return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                    });
                }
                function getUuid() {
                    if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") return crypto.randomUUID();
                    const buf = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") crypto.getRandomValues(buf);
                    else for(let i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
                    return bytesToString(buf);
                }
                const AnnotationPrefix = "pdfjs_internal_id_";
                exports.AnnotationPrefix = AnnotationPrefix;
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                Object.defineProperty(exports, "SVGGraphics", {
                    enumerable: true,
                    get: function() {
                        return _displaySvg.SVGGraphics;
                    }
                });
                exports.build = void 0;
                exports.getDocument = getDocument;
                exports.version = void 0;
                var _util = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _display_utils = __w_pdfjs_require__(6);
                var _font_loader = __w_pdfjs_require__(9);
                var _displayNode_utils = __w_pdfjs_require__(10);
                var _canvas = __w_pdfjs_require__(11);
                var _worker_options = __w_pdfjs_require__(14);
                var _message_handler = __w_pdfjs_require__(15);
                var _metadata = __w_pdfjs_require__(16);
                var _optional_content_config = __w_pdfjs_require__(17);
                var _transport_stream = __w_pdfjs_require__(18);
                var _displayFetch_stream = __w_pdfjs_require__(19);
                var _displayNetwork = __w_pdfjs_require__(22);
                var _displayNode_stream = __w_pdfjs_require__(23);
                var _displaySvg = __w_pdfjs_require__(24);
                var _xfa_text = __w_pdfjs_require__(25);
                const DEFAULT_RANGE_CHUNK_SIZE = 65536;
                const RENDERING_CANCELLED_TIMEOUT = 100;
                const DELAYED_CLEANUP_TIMEOUT = 5000;
                const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
                exports.DefaultFilterFactory = DefaultFilterFactory;
                const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                function getDocument(src) {
                    if (typeof src === "string" || src instanceof URL) src = {
                        url: src
                    };
                    else if ((0, _util.isArrayBuffer)(src)) src = {
                        data: src
                    };
                    if (typeof src !== "object") throw new Error("Invalid parameter in getDocument, need parameter object.");
                    if (!src.url && !src.data && !src.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                    const task = new PDFDocumentLoadingTask();
                    const { docId } = task;
                    const url = src.url ? getUrlProp(src.url) : null;
                    const data = src.data ? getDataProp(src.data) : null;
                    const httpHeaders = src.httpHeaders || null;
                    const withCredentials = src.withCredentials === true;
                    const password = src.password ?? null;
                    const rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
                    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
                    let worker = src.worker instanceof PDFWorker ? src.worker : null;
                    const verbosity = src.verbosity;
                    const docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
                    const cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
                    const cMapPacked = src.cMapPacked !== false;
                    const CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
                    const standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
                    const StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    const ignoreErrors = src.stopAtErrors !== true;
                    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
                    const isEvalSupported = src.isEvalSupported !== false;
                    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_util.isNodeJS;
                    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
                    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _util.isNodeJS;
                    const fontExtraProperties = src.fontExtraProperties === true;
                    const enableXfa = src.enableXfa === true;
                    const ownerDocument = src.ownerDocument || globalThis.document;
                    const disableRange = src.disableRange === true;
                    const disableStream = src.disableStream === true;
                    const disableAutoFetch = src.disableAutoFetch === true;
                    const pdfBug = src.pdfBug === true;
                    const length = rangeTransport ? rangeTransport.length : src.length ?? NaN;
                    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_util.isNodeJS && !disableFontFace;
                    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
                    const canvasFactory = src.canvasFactory || new DefaultCanvasFactory({
                        ownerDocument: ownerDocument
                    });
                    const filterFactory = src.filterFactory || new DefaultFilterFactory({
                        docId: docId,
                        ownerDocument: ownerDocument
                    });
                    const styleElement = null;
                    (0, _util.setVerbosityLevel)(verbosity);
                    const transportFactory = {
                        canvasFactory: canvasFactory,
                        filterFactory: filterFactory
                    };
                    if (!useWorkerFetch) {
                        transportFactory.cMapReaderFactory = new CMapReaderFactory({
                            baseUrl: cMapUrl,
                            isCompressed: cMapPacked
                        });
                        transportFactory.standardFontDataFactory = new StandardFontDataFactory({
                            baseUrl: standardFontDataUrl
                        });
                    }
                    if (!worker) {
                        const workerParams = {
                            verbosity: verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                        task._worker = worker;
                    }
                    const fetchDocParams = {
                        docId: docId,
                        apiVersion: "3.11.174",
                        data: data,
                        password: password,
                        disableAutoFetch: disableAutoFetch,
                        rangeChunkSize: rangeChunkSize,
                        length: length,
                        docBaseUrl: docBaseUrl,
                        enableXfa: enableXfa,
                        evaluatorOptions: {
                            maxImageSize: maxImageSize,
                            disableFontFace: disableFontFace,
                            ignoreErrors: ignoreErrors,
                            isEvalSupported: isEvalSupported,
                            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
                            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
                            fontExtraProperties: fontExtraProperties,
                            useSystemFonts: useSystemFonts,
                            cMapUrl: useWorkerFetch ? cMapUrl : null,
                            standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
                        }
                    };
                    const transportParams = {
                        ignoreErrors: ignoreErrors,
                        isEvalSupported: isEvalSupported,
                        disableFontFace: disableFontFace,
                        fontExtraProperties: fontExtraProperties,
                        enableXfa: enableXfa,
                        ownerDocument: ownerDocument,
                        disableAutoFetch: disableAutoFetch,
                        pdfBug: pdfBug,
                        styleElement: styleElement
                    };
                    worker.promise.then(function() {
                        if (task.destroyed) throw new Error("Loading aborted");
                        const workerIdPromise = _fetchDocument(worker, fetchDocParams);
                        const networkStreamPromise = new Promise(function(resolve) {
                            let networkStream;
                            if (rangeTransport) networkStream = new _transport_stream.PDFDataTransportStream({
                                length: length,
                                initialData: rangeTransport.initialData,
                                progressiveDone: rangeTransport.progressiveDone,
                                contentDispositionFilename: rangeTransport.contentDispositionFilename,
                                disableRange: disableRange,
                                disableStream: disableStream
                            }, rangeTransport);
                            else if (!data) {
                                const createPDFNetworkStream = (params)=>{
                                    if (_util.isNodeJS) return new _displayNode_stream.PDFNodeStream(params);
                                    return (0, _display_utils.isValidFetchUrl)(params.url) ? new _displayFetch_stream.PDFFetchStream(params) : new _displayNetwork.PDFNetworkStream(params);
                                };
                                networkStream = createPDFNetworkStream({
                                    url: url,
                                    length: length,
                                    httpHeaders: httpHeaders,
                                    withCredentials: withCredentials,
                                    rangeChunkSize: rangeChunkSize,
                                    disableRange: disableRange,
                                    disableStream: disableStream
                                });
                            }
                            resolve(networkStream);
                        });
                        return Promise.all([
                            workerIdPromise,
                            networkStreamPromise
                        ]).then(function([workerId, networkStream]) {
                            if (task.destroyed) throw new Error("Loading aborted");
                            const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
                            const transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
                            task._transport = transport;
                            messageHandler.send("Ready", null);
                        });
                    }).catch(task._capability.reject);
                    return task;
                }
                async function _fetchDocument(worker, source) {
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    const workerId = await worker.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [
                        source.data.buffer
                    ] : null);
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    return workerId;
                }
                function getUrlProp(val) {
                    if (val instanceof URL) return val.href;
                    try {
                        return new URL(val, window.location).href;
                    } catch  {
                        if (_util.isNodeJS && typeof val === "string") return val;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                }
                function getDataProp(val) {
                    if (_util.isNodeJS && typeof $70c197f8914c1458$require$Buffer !== "undefined" && val instanceof $70c197f8914c1458$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
                    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
                    if (typeof val === "string") return (0, _util.stringToBytes)(val);
                    if (typeof val === "object" && !isNaN(val?.length) || (0, _util.isArrayBuffer)(val)) return new Uint8Array(val);
                    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                }
                class PDFDocumentLoadingTask {
                    static #docId = 0;
                    constructor(){
                        this._capability = new _util.PromiseCapability();
                        this._transport = null;
                        this._worker = null;
                        this.docId = `d${PDFDocumentLoadingTask.#docId++}`;
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    async destroy() {
                        this.destroyed = true;
                        try {
                            if (this._worker?.port) this._worker._pendingDestroy = true;
                            await this._transport?.destroy();
                        } catch (ex) {
                            if (this._worker?.port) delete this._worker._pendingDestroy;
                            throw ex;
                        }
                        this._transport = null;
                        if (this._worker) {
                            this._worker.destroy();
                            this._worker = null;
                        }
                    }
                }
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                class PDFDataRangeTransport {
                    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
                        this.length = length;
                        this.initialData = initialData;
                        this.progressiveDone = progressiveDone;
                        this.contentDispositionFilename = contentDispositionFilename;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = new _util.PromiseCapability();
                    }
                    addRangeListener(listener) {
                        this._rangeListeners.push(listener);
                    }
                    addProgressListener(listener) {
                        this._progressListeners.push(listener);
                    }
                    addProgressiveReadListener(listener) {
                        this._progressiveReadListeners.push(listener);
                    }
                    addProgressiveDoneListener(listener) {
                        this._progressiveDoneListeners.push(listener);
                    }
                    onDataRange(begin, chunk) {
                        for (const listener of this._rangeListeners)listener(begin, chunk);
                    }
                    onDataProgress(loaded, total) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressListeners)listener(loaded, total);
                        });
                    }
                    onDataProgressiveRead(chunk) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveReadListeners)listener(chunk);
                        });
                    }
                    onDataProgressiveDone() {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveDoneListeners)listener();
                        });
                    }
                    transportReady() {
                        this._readyCapability.resolve();
                    }
                    requestDataRange(begin, end) {
                        (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                    }
                    abort() {}
                }
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                class PDFDocumentProxy {
                    constructor(pdfInfo, transport){
                        this._pdfInfo = pdfInfo;
                        this._transport = transport;
                        Object.defineProperty(this, "getJavaScript", {
                            value: ()=>{
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                                return this.getJSActions().then((js)=>{
                                    if (!js) return js;
                                    const jsArr = [];
                                    for(const name in js)jsArr.push(...js[name]);
                                    return jsArr;
                                });
                            }
                        });
                    }
                    get annotationStorage() {
                        return this._transport.annotationStorage;
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get numPages() {
                        return this._pdfInfo.numPages;
                    }
                    get fingerprints() {
                        return this._pdfInfo.fingerprints;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    get allXfaHtml() {
                        return this._transport._htmlForXfa;
                    }
                    getPage(pageNumber) {
                        return this._transport.getPage(pageNumber);
                    }
                    getPageIndex(ref) {
                        return this._transport.getPageIndex(ref);
                    }
                    getDestinations() {
                        return this._transport.getDestinations();
                    }
                    getDestination(id) {
                        return this._transport.getDestination(id);
                    }
                    getPageLabels() {
                        return this._transport.getPageLabels();
                    }
                    getPageLayout() {
                        return this._transport.getPageLayout();
                    }
                    getPageMode() {
                        return this._transport.getPageMode();
                    }
                    getViewerPreferences() {
                        return this._transport.getViewerPreferences();
                    }
                    getOpenAction() {
                        return this._transport.getOpenAction();
                    }
                    getAttachments() {
                        return this._transport.getAttachments();
                    }
                    getJSActions() {
                        return this._transport.getDocJSActions();
                    }
                    getOutline() {
                        return this._transport.getOutline();
                    }
                    getOptionalContentConfig() {
                        return this._transport.getOptionalContentConfig();
                    }
                    getPermissions() {
                        return this._transport.getPermissions();
                    }
                    getMetadata() {
                        return this._transport.getMetadata();
                    }
                    getMarkInfo() {
                        return this._transport.getMarkInfo();
                    }
                    getData() {
                        return this._transport.getData();
                    }
                    saveDocument() {
                        return this._transport.saveDocument();
                    }
                    getDownloadInfo() {
                        return this._transport.downloadInfoCapability.promise;
                    }
                    cleanup(keepLoadedFonts = false) {
                        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                    }
                    destroy() {
                        return this.loadingTask.destroy();
                    }
                    get loadingParams() {
                        return this._transport.loadingParams;
                    }
                    get loadingTask() {
                        return this._transport.loadingTask;
                    }
                    getFieldObjects() {
                        return this._transport.getFieldObjects();
                    }
                    hasJSActions() {
                        return this._transport.hasJSActions();
                    }
                    getCalculationOrderIds() {
                        return this._transport.getCalculationOrderIds();
                    }
                }
                exports.PDFDocumentProxy = PDFDocumentProxy;
                class PDFPageProxy {
                    #delayedCleanupTimeout = null;
                    #pendingCleanup = false;
                    constructor(pageIndex, pageInfo, transport, pdfBug = false){
                        this._pageIndex = pageIndex;
                        this._pageInfo = pageInfo;
                        this._transport = transport;
                        this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug;
                        this.commonObjs = transport.commonObjs;
                        this.objs = new PDFObjects();
                        this._maybeCleanupAfterRender = false;
                        this._intentStates = new Map();
                        this.destroyed = false;
                    }
                    get pageNumber() {
                        return this._pageIndex + 1;
                    }
                    get rotate() {
                        return this._pageInfo.rotate;
                    }
                    get ref() {
                        return this._pageInfo.ref;
                    }
                    get userUnit() {
                        return this._pageInfo.userUnit;
                    }
                    get view() {
                        return this._pageInfo.view;
                    }
                    getViewport({ scale, rotation = this.rotate, offsetX = 0, offsetY = 0, dontFlip = false } = {}) {
                        return new _display_utils.PageViewport({
                            viewBox: this.view,
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    getAnnotations({ intent = "display" } = {}) {
                        const intentArgs = this._transport.getRenderingIntent(intent);
                        return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                    }
                    getJSActions() {
                        return this._transport.getPageJSActions(this._pageIndex);
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    async getXfa() {
                        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
                    }
                    render({ canvasContext, viewport, intent = "display", annotationMode = _util.AnnotationMode.ENABLE, transform = null, background = null, optionalContentConfigPromise = null, annotationCanvasMap = null, pageColors = null, printAnnotationStorage = null }) {
                        this._stats?.time("Overall");
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        if (!optionalContentConfigPromise) optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        const intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                        if (!intentState.displayReadyCapability) {
                            intentState.displayReadyCapability = new _util.PromiseCapability();
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        const complete = (error)=>{
                            intentState.renderTasks.delete(internalRenderTask);
                            if (this._maybeCleanupAfterRender || intentPrint) this.#pendingCleanup = true;
                            this.#tryCleanup(!intentPrint);
                            if (error) {
                                internalRenderTask.capability.reject(error);
                                this._abortOperatorList({
                                    intentState: intentState,
                                    reason: error instanceof Error ? error : new Error(error)
                                });
                            } else internalRenderTask.capability.resolve();
                            this._stats?.timeEnd("Rendering");
                            this._stats?.timeEnd("Overall");
                        };
                        const internalRenderTask = new InternalRenderTask({
                            callback: complete,
                            params: {
                                canvasContext: canvasContext,
                                viewport: viewport,
                                transform: transform,
                                background: background
                            },
                            objs: this.objs,
                            commonObjs: this.commonObjs,
                            annotationCanvasMap: annotationCanvasMap,
                            operatorList: intentState.operatorList,
                            pageIndex: this._pageIndex,
                            canvasFactory: this._transport.canvasFactory,
                            filterFactory: this._transport.filterFactory,
                            useRequestAnimationFrame: !intentPrint,
                            pdfBug: this._pdfBug,
                            pageColors: pageColors
                        });
                        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
                        const renderTask = internalRenderTask.task;
                        Promise.all([
                            intentState.displayReadyCapability.promise,
                            optionalContentConfigPromise
                        ]).then(([transparency, optionalContentConfig])=>{
                            if (this.destroyed) {
                                complete();
                                return;
                            }
                            this._stats?.time("Rendering");
                            internalRenderTask.initializeGraphics({
                                transparency: transparency,
                                optionalContentConfig: optionalContentConfig
                            });
                            internalRenderTask.operatorListChanged();
                        }).catch(complete);
                        return renderTask;
                    }
                    getOperatorList({ intent = "display", annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null } = {}) {
                        function operatorListChanged() {
                            if (intentState.operatorList.lastChunk) {
                                intentState.opListReadCapability.resolve(intentState.operatorList);
                                intentState.renderTasks.delete(opListTask);
                            }
                        }
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        let opListTask;
                        if (!intentState.opListReadCapability) {
                            opListTask = Object.create(null);
                            opListTask.operatorListChanged = operatorListChanged;
                            intentState.opListReadCapability = new _util.PromiseCapability();
                            (intentState.renderTasks ||= new Set()).add(opListTask);
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        return intentState.opListReadCapability.promise;
                    }
                    streamTextContent({ includeMarkedContent = false, disableNormalization = false } = {}) {
                        const TEXT_CONTENT_CHUNK_SIZE = 100;
                        return this._transport.messageHandler.sendWithStream("GetTextContent", {
                            pageIndex: this._pageIndex,
                            includeMarkedContent: includeMarkedContent === true,
                            disableNormalization: disableNormalization === true
                        }, {
                            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                            size (textContent) {
                                return textContent.items.length;
                            }
                        });
                    }
                    getTextContent(params = {}) {
                        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>{
                            return _xfa_text.XfaText.textContent(xfa);
                        });
                        const readableStream = this.streamTextContent(params);
                        return new Promise(function(resolve, reject) {
                            function pump() {
                                reader.read().then(function({ value, done }) {
                                    if (done) {
                                        resolve(textContent);
                                        return;
                                    }
                                    Object.assign(textContent.styles, value.styles);
                                    textContent.items.push(...value.items);
                                    pump();
                                }, reject);
                            }
                            const reader = readableStream.getReader();
                            const textContent = {
                                items: [],
                                styles: Object.create(null)
                            };
                            pump();
                        });
                    }
                    getStructTree() {
                        return this._transport.getStructTree(this._pageIndex);
                    }
                    _destroy() {
                        this.destroyed = true;
                        const waitOn = [];
                        for (const intentState of this._intentStates.values()){
                            this._abortOperatorList({
                                intentState: intentState,
                                reason: new Error("Page was destroyed."),
                                force: true
                            });
                            if (intentState.opListReadCapability) continue;
                            for (const internalRenderTask of intentState.renderTasks){
                                waitOn.push(internalRenderTask.completed);
                                internalRenderTask.cancel();
                            }
                        }
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        return Promise.all(waitOn);
                    }
                    cleanup(resetStats = false) {
                        this.#pendingCleanup = true;
                        const success = this.#tryCleanup(false);
                        if (resetStats && success) this._stats &&= new _display_utils.StatTimer();
                        return success;
                    }
                    #tryCleanup(delayed = false) {
                        this.#abortDelayedCleanup();
                        if (!this.#pendingCleanup || this.destroyed) return false;
                        if (delayed) {
                            this.#delayedCleanupTimeout = setTimeout(()=>{
                                this.#delayedCleanupTimeout = null;
                                this.#tryCleanup(false);
                            }, DELAYED_CLEANUP_TIMEOUT);
                            return false;
                        }
                        for (const { renderTasks, operatorList } of this._intentStates.values()){
                            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
                        }
                        this._intentStates.clear();
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        return true;
                    }
                    #abortDelayedCleanup() {
                        if (this.#delayedCleanupTimeout) {
                            clearTimeout(this.#delayedCleanupTimeout);
                            this.#delayedCleanupTimeout = null;
                        }
                    }
                    _startRenderPage(transparency, cacheKey) {
                        const intentState = this._intentStates.get(cacheKey);
                        if (!intentState) return;
                        this._stats?.timeEnd("Page Request");
                        intentState.displayReadyCapability?.resolve(transparency);
                    }
                    _renderPageChunk(operatorListChunk, intentState) {
                        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
                            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                        }
                        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
                        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                        if (operatorListChunk.lastChunk) this.#tryCleanup(true);
                    }
                    _pumpOperatorList({ renderingIntent, cacheKey, annotationStorageSerializable }) {
                        const { map, transfers } = annotationStorageSerializable;
                        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                            pageIndex: this._pageIndex,
                            intent: renderingIntent,
                            cacheKey: cacheKey,
                            annotationStorage: map
                        }, transfers);
                        const reader = readableStream.getReader();
                        const intentState = this._intentStates.get(cacheKey);
                        intentState.streamReader = reader;
                        const pump = ()=>{
                            reader.read().then(({ value, done })=>{
                                if (done) {
                                    intentState.streamReader = null;
                                    return;
                                }
                                if (this._transport.destroyed) return;
                                this._renderPageChunk(value, intentState);
                                pump();
                            }, (reason)=>{
                                intentState.streamReader = null;
                                if (this._transport.destroyed) return;
                                if (intentState.operatorList) {
                                    intentState.operatorList.lastChunk = true;
                                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                                    this.#tryCleanup(true);
                                }
                                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                                else throw reason;
                            });
                        };
                        pump();
                    }
                    _abortOperatorList({ intentState, reason, force = false }) {
                        if (!intentState.streamReader) return;
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        if (!force) {
                            if (intentState.renderTasks.size > 0) return;
                            if (reason instanceof _display_utils.RenderingCancelledException) {
                                let delay = RENDERING_CANCELLED_TIMEOUT;
                                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                                    intentState.streamReaderCancelTimeout = null;
                                    this._abortOperatorList({
                                        intentState: intentState,
                                        reason: reason,
                                        force: true
                                    });
                                }, delay);
                                return;
                            }
                        }
                        intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(()=>{});
                        intentState.streamReader = null;
                        if (this._transport.destroyed) return;
                        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
                            this._intentStates.delete(curCacheKey);
                            break;
                        }
                        this.cleanup();
                    }
                    get stats() {
                        return this._stats;
                    }
                }
                exports.PDFPageProxy = PDFPageProxy;
                class LoopbackPort {
                    #listeners = new Set();
                    #deferred = Promise.resolve();
                    postMessage(obj, transfer) {
                        const event = {
                            data: structuredClone(obj, transfer ? {
                                transfer: transfer
                            } : null)
                        };
                        this.#deferred.then(()=>{
                            for (const listener of this.#listeners)listener.call(this, event);
                        });
                    }
                    addEventListener(name, listener) {
                        this.#listeners.add(listener);
                    }
                    removeEventListener(name, listener) {
                        this.#listeners.delete(listener);
                    }
                    terminate() {
                        this.#listeners.clear();
                    }
                }
                exports.LoopbackPort = LoopbackPort;
                const PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                exports.PDFWorkerUtil = PDFWorkerUtil;
                if (_util.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if (typeof document === "object") {
                    const pdfjsFilePath = document?.currentScript?.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
                    let base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch  {
                        return false;
                    }
                    const other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                };
                PDFWorkerUtil.createCDNWrapper = function(url) {
                    const wrapper = `importScripts("${url}");`;
                    return URL.createObjectURL(new Blob([
                        wrapper
                    ]));
                };
                class PDFWorker {
                    static #workerPorts;
                    constructor({ name = null, port = null, verbosity = (0, _util.getVerbosityLevel)() } = {}){
                        this.name = name;
                        this.destroyed = false;
                        this.verbosity = verbosity;
                        this._readyCapability = new _util.PromiseCapability();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port) {
                            if (PDFWorker.#workerPorts?.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
                            (PDFWorker.#workerPorts ||= new WeakMap()).set(port, this);
                            this._initializeFromPort(port);
                            return;
                        }
                        this._initialize();
                    }
                    get promise() {
                        return this._readyCapability.promise;
                    }
                    get port() {
                        return this._port;
                    }
                    get messageHandler() {
                        return this._messageHandler;
                    }
                    _initializeFromPort(port) {
                        this._port = port;
                        this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                        this._messageHandler.on("ready", function() {});
                        this._readyCapability.resolve();
                        this._messageHandler.send("configure", {
                            verbosity: this.verbosity
                        });
                    }
                    _initialize() {
                        if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                            let { workerSrc } = PDFWorker;
                            try {
                                if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                                const worker = new Worker(workerSrc);
                                const messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                                const terminateEarly = ()=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    messageHandler.destroy();
                                    worker.terminate();
                                    if (this.destroyed) this._readyCapability.reject(new Error("Worker was destroyed"));
                                    else this._setupFakeWorker();
                                };
                                const onWorkerError = ()=>{
                                    if (!this._webWorker) terminateEarly();
                                };
                                worker.addEventListener("error", onWorkerError);
                                messageHandler.on("test", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    if (data) {
                                        this._messageHandler = messageHandler;
                                        this._port = worker;
                                        this._webWorker = worker;
                                        this._readyCapability.resolve();
                                        messageHandler.send("configure", {
                                            verbosity: this.verbosity
                                        });
                                    } else {
                                        this._setupFakeWorker();
                                        messageHandler.destroy();
                                        worker.terminate();
                                    }
                                });
                                messageHandler.on("ready", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    try {
                                        sendTest();
                                    } catch  {
                                        this._setupFakeWorker();
                                    }
                                });
                                const sendTest = ()=>{
                                    const testObj = new Uint8Array();
                                    messageHandler.send("test", testObj, [
                                        testObj.buffer
                                    ]);
                                };
                                sendTest();
                                return;
                            } catch  {
                                (0, _util.info)("The worker has been disabled.");
                            }
                        }
                        this._setupFakeWorker();
                    }
                    _setupFakeWorker() {
                        if (!PDFWorkerUtil.isWorkerDisabled) {
                            (0, _util.warn)("Setting up fake worker.");
                            PDFWorkerUtil.isWorkerDisabled = true;
                        }
                        PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
                            if (this.destroyed) {
                                this._readyCapability.reject(new Error("Worker was destroyed"));
                                return;
                            }
                            const port = new LoopbackPort();
                            this._port = port;
                            const id = `fake${PDFWorkerUtil.fakeWorkerId++}`;
                            const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                            WorkerMessageHandler.setup(workerHandler, port);
                            const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                            this._messageHandler = messageHandler;
                            this._readyCapability.resolve();
                            messageHandler.send("configure", {
                                verbosity: this.verbosity
                            });
                        }).catch((reason)=>{
                            this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
                        });
                    }
                    destroy() {
                        this.destroyed = true;
                        if (this._webWorker) {
                            this._webWorker.terminate();
                            this._webWorker = null;
                        }
                        PDFWorker.#workerPorts?.delete(this._port);
                        this._port = null;
                        if (this._messageHandler) {
                            this._messageHandler.destroy();
                            this._messageHandler = null;
                        }
                    }
                    static fromPort(params) {
                        if (!params?.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
                        const cachedPort = this.#workerPorts?.get(params.port);
                        if (cachedPort) {
                            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                            return cachedPort;
                        }
                        return new PDFWorker(params);
                    }
                    static get workerSrc() {
                        if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                        if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                            if (!_util.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                            return PDFWorkerUtil.fallbackWorkerSrc;
                        }
                        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                    }
                    static get _mainThreadWorkerMessageHandler() {
                        try {
                            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                        } catch  {
                            return null;
                        }
                    }
                    static get _setupFakeWorkerGlobal() {
                        const loader = async ()=>{
                            const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                            if (mainWorkerMessageHandler) return mainWorkerMessageHandler;
                            if (_util.isNodeJS && true) {
                                const worker = eval("require")(this.workerSrc);
                                return worker.WorkerMessageHandler;
                            }
                            await (0, _display_utils.loadScript)(this.workerSrc);
                            return window.pdfjsWorker.WorkerMessageHandler;
                        };
                        return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                    }
                }
                exports.PDFWorker = PDFWorker;
                class WorkerTransport {
                    #methodPromises = new Map();
                    #pageCache = new Map();
                    #pagePromises = new Map();
                    #passwordCapability = null;
                    constructor(messageHandler, loadingTask, networkStream, params, factory){
                        this.messageHandler = messageHandler;
                        this.loadingTask = loadingTask;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            ownerDocument: params.ownerDocument,
                            styleElement: params.styleElement
                        });
                        this._params = params;
                        this.canvasFactory = factory.canvasFactory;
                        this.filterFactory = factory.filterFactory;
                        this.cMapReaderFactory = factory.cMapReaderFactory;
                        this.standardFontDataFactory = factory.standardFontDataFactory;
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._networkStream = networkStream;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = new _util.PromiseCapability();
                        this.setupMessageHandler();
                    }
                    #cacheSimpleMethod(name, data = null) {
                        const cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, data);
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    get annotationStorage() {
                        return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                    }
                    getRenderingIntent(intent, annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null, isOpList = false) {
                        let renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                        let annotationStorageSerializable = _annotation_storage.SerializableEmpty;
                        switch(intent){
                            case "any":
                                renderingIntent = _util.RenderingIntentFlag.ANY;
                                break;
                            case "display":
                                break;
                            case "print":
                                renderingIntent = _util.RenderingIntentFlag.PRINT;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent}`);
                        }
                        switch(annotationMode){
                            case _util.AnnotationMode.DISABLE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                break;
                            case _util.AnnotationMode.ENABLE:
                                break;
                            case _util.AnnotationMode.ENABLE_FORMS:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                break;
                            case _util.AnnotationMode.ENABLE_STORAGE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                const annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                                annotationStorageSerializable = annotationStorage.serializable;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
                        }
                        if (isOpList) renderingIntent += _util.RenderingIntentFlag.OPLIST;
                        return {
                            renderingIntent: renderingIntent,
                            cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
                            annotationStorageSerializable: annotationStorageSerializable
                        };
                    }
                    destroy() {
                        if (this.destroyCapability) return this.destroyCapability.promise;
                        this.destroyed = true;
                        this.destroyCapability = new _util.PromiseCapability();
                        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
                        const waitOn = [];
                        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
                        this.#pageCache.clear();
                        this.#pagePromises.clear();
                        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
                        waitOn.push(terminated);
                        Promise.all(waitOn).then(()=>{
                            this.commonObjs.clear();
                            this.fontLoader.clear();
                            this.#methodPromises.clear();
                            this.filterFactory.destroy();
                            this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                            if (this.messageHandler) {
                                this.messageHandler.destroy();
                                this.messageHandler = null;
                            }
                            this.destroyCapability.resolve();
                        }, this.destroyCapability.reject);
                        return this.destroyCapability.promise;
                    }
                    setupMessageHandler() {
                        const { messageHandler, loadingTask } = this;
                        messageHandler.on("GetReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                            this._fullReader = this._networkStream.getFullReader();
                            this._fullReader.onProgress = (evt)=>{
                                this._lastProgress = {
                                    loaded: evt.loaded,
                                    total: evt.total
                                };
                            };
                            sink.onPull = ()=>{
                                this._fullReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                this._fullReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("ReaderHeadersReady", (data)=>{
                            const headersCapability = new _util.PromiseCapability();
                            const fullReader = this._fullReader;
                            fullReader.headersReady.then(()=>{
                                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                                    if (this._lastProgress) loadingTask.onProgress?.(this._lastProgress);
                                    fullReader.onProgress = (evt)=>{
                                        loadingTask.onProgress?.({
                                            loaded: evt.loaded,
                                            total: evt.total
                                        });
                                    };
                                }
                                headersCapability.resolve({
                                    isStreamingSupported: fullReader.isStreamingSupported,
                                    isRangeSupported: fullReader.isRangeSupported,
                                    contentLength: fullReader.contentLength
                                });
                            }, headersCapability.reject);
                            return headersCapability.promise;
                        });
                        messageHandler.on("GetRangeReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                            const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
                            if (!rangeReader) {
                                sink.close();
                                return;
                            }
                            sink.onPull = ()=>{
                                rangeReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                rangeReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("GetDoc", ({ pdfInfo })=>{
                            this._numPages = pdfInfo.numPages;
                            this._htmlForXfa = pdfInfo.htmlForXfa;
                            delete pdfInfo.htmlForXfa;
                            loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
                        });
                        messageHandler.on("DocException", function(ex) {
                            let reason;
                            switch(ex.name){
                                case "PasswordException":
                                    reason = new _util.PasswordException(ex.message, ex.code);
                                    break;
                                case "InvalidPDFException":
                                    reason = new _util.InvalidPDFException(ex.message);
                                    break;
                                case "MissingPDFException":
                                    reason = new _util.MissingPDFException(ex.message);
                                    break;
                                case "UnexpectedResponseException":
                                    reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                                    break;
                                case "UnknownErrorException":
                                    reason = new _util.UnknownErrorException(ex.message, ex.details);
                                    break;
                                default:
                                    (0, _util.unreachable)("DocException - expected a valid Error.");
                            }
                            loadingTask._capability.reject(reason);
                        });
                        messageHandler.on("PasswordRequest", (exception)=>{
                            this.#passwordCapability = new _util.PromiseCapability();
                            if (loadingTask.onPassword) {
                                const updatePassword = (password)=>{
                                    if (password instanceof Error) this.#passwordCapability.reject(password);
                                    else this.#passwordCapability.resolve({
                                        password: password
                                    });
                                };
                                try {
                                    loadingTask.onPassword(updatePassword, exception.code);
                                } catch (ex) {
                                    this.#passwordCapability.reject(ex);
                                }
                            } else this.#passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                            return this.#passwordCapability.promise;
                        });
                        messageHandler.on("DataLoaded", (data)=>{
                            loadingTask.onProgress?.({
                                loaded: data.length,
                                total: data.length
                            });
                            this.downloadInfoCapability.resolve(data);
                        });
                        messageHandler.on("StartRenderPage", (data)=>{
                            if (this.destroyed) return;
                            const page = this.#pageCache.get(data.pageIndex);
                            page._startRenderPage(data.transparency, data.cacheKey);
                        });
                        messageHandler.on("commonobj", ([id, type, exportedData])=>{
                            if (this.destroyed) return;
                            if (this.commonObjs.has(id)) return;
                            switch(type){
                                case "Font":
                                    const params = this._params;
                                    if ("error" in exportedData) {
                                        const exportedError = exportedData.error;
                                        (0, _util.warn)(`Error during font loading: ${exportedError}`);
                                        this.commonObjs.resolve(id, exportedError);
                                        break;
                                    }
                                    const inspectFont = params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                                    const font = new _font_loader.FontFaceObject(exportedData, {
                                        isEvalSupported: params.isEvalSupported,
                                        disableFontFace: params.disableFontFace,
                                        ignoreErrors: params.ignoreErrors,
                                        inspectFont: inspectFont
                                    });
                                    this.fontLoader.bind(font).catch((reason)=>{
                                        return messageHandler.sendWithPromise("FontFallback", {
                                            id: id
                                        });
                                    }).finally(()=>{
                                        if (!params.fontExtraProperties && font.data) font.data = null;
                                        this.commonObjs.resolve(id, font);
                                    });
                                    break;
                                case "FontPath":
                                case "Image":
                                case "Pattern":
                                    this.commonObjs.resolve(id, exportedData);
                                    break;
                                default:
                                    throw new Error(`Got unknown common object type ${type}`);
                            }
                        });
                        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
                            if (this.destroyed) return;
                            const pageProxy = this.#pageCache.get(pageIndex);
                            if (pageProxy.objs.has(id)) return;
                            switch(type){
                                case "Image":
                                    pageProxy.objs.resolve(id, imageData);
                                    if (imageData) {
                                        let length;
                                        if (imageData.bitmap) {
                                            const { width, height } = imageData;
                                            length = width * height * 4;
                                        } else length = imageData.data?.length || 0;
                                        if (length > _util.MAX_IMAGE_SIZE_TO_CACHE) pageProxy._maybeCleanupAfterRender = true;
                                    }
                                    break;
                                case "Pattern":
                                    pageProxy.objs.resolve(id, imageData);
                                    break;
                                default:
                                    throw new Error(`Got unknown object type ${type}`);
                            }
                        });
                        messageHandler.on("DocProgress", (data)=>{
                            if (this.destroyed) return;
                            loadingTask.onProgress?.({
                                loaded: data.loaded,
                                total: data.total
                            });
                        });
                        messageHandler.on("FetchBuiltInCMap", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.cMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.cMapReaderFactory.fetch(data);
                        });
                        messageHandler.on("FetchStandardFontData", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.standardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.standardFontDataFactory.fetch(data);
                        });
                    }
                    getData() {
                        return this.messageHandler.sendWithPromise("GetData", null);
                    }
                    saveDocument() {
                        if (this.annotationStorage.size <= 0) (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                        const { map, transfers } = this.annotationStorage.serializable;
                        return this.messageHandler.sendWithPromise("SaveDocument", {
                            isPureXfa: !!this._htmlForXfa,
                            numPages: this._numPages,
                            annotationStorage: map,
                            filename: this._fullReader?.filename ?? null
                        }, transfers).finally(()=>{
                            this.annotationStorage.resetModified();
                        });
                    }
                    getPage(pageNumber) {
                        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
                        const pageIndex = pageNumber - 1, cachedPromise = this.#pagePromises.get(pageIndex);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise("GetPage", {
                            pageIndex: pageIndex
                        }).then((pageInfo)=>{
                            if (this.destroyed) throw new Error("Transport destroyed");
                            const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
                            this.#pageCache.set(pageIndex, page);
                            return page;
                        });
                        this.#pagePromises.set(pageIndex, promise);
                        return promise;
                    }
                    getPageIndex(ref) {
                        if (typeof ref !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) return Promise.reject(new Error("Invalid pageIndex request."));
                        return this.messageHandler.sendWithPromise("GetPageIndex", {
                            num: ref.num,
                            gen: ref.gen
                        });
                    }
                    getAnnotations(pageIndex, intent) {
                        return this.messageHandler.sendWithPromise("GetAnnotations", {
                            pageIndex: pageIndex,
                            intent: intent
                        });
                    }
                    getFieldObjects() {
                        return this.#cacheSimpleMethod("GetFieldObjects");
                    }
                    hasJSActions() {
                        return this.#cacheSimpleMethod("HasJSActions");
                    }
                    getCalculationOrderIds() {
                        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                    }
                    getDestinations() {
                        return this.messageHandler.sendWithPromise("GetDestinations", null);
                    }
                    getDestination(id) {
                        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
                        return this.messageHandler.sendWithPromise("GetDestination", {
                            id: id
                        });
                    }
                    getPageLabels() {
                        return this.messageHandler.sendWithPromise("GetPageLabels", null);
                    }
                    getPageLayout() {
                        return this.messageHandler.sendWithPromise("GetPageLayout", null);
                    }
                    getPageMode() {
                        return this.messageHandler.sendWithPromise("GetPageMode", null);
                    }
                    getViewerPreferences() {
                        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                    }
                    getOpenAction() {
                        return this.messageHandler.sendWithPromise("GetOpenAction", null);
                    }
                    getAttachments() {
                        return this.messageHandler.sendWithPromise("GetAttachments", null);
                    }
                    getDocJSActions() {
                        return this.#cacheSimpleMethod("GetDocJSActions");
                    }
                    getPageJSActions(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetPageJSActions", {
                            pageIndex: pageIndex
                        });
                    }
                    getStructTree(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetStructTree", {
                            pageIndex: pageIndex
                        });
                    }
                    getOutline() {
                        return this.messageHandler.sendWithPromise("GetOutline", null);
                    }
                    getOptionalContentConfig() {
                        return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results)=>{
                            return new _optional_content_config.OptionalContentConfig(results);
                        });
                    }
                    getPermissions() {
                        return this.messageHandler.sendWithPromise("GetPermissions", null);
                    }
                    getMetadata() {
                        const name = "GetMetadata", cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, null).then((results)=>{
                            return {
                                info: results[0],
                                metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                                contentDispositionFilename: this._fullReader?.filename ?? null,
                                contentLength: this._fullReader?.contentLength ?? null
                            };
                        });
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    getMarkInfo() {
                        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                    }
                    async startCleanup(keepLoadedFonts = false) {
                        if (this.destroyed) return;
                        await this.messageHandler.sendWithPromise("Cleanup", null);
                        for (const page of this.#pageCache.values()){
                            const cleanupSuccessful = page.cleanup();
                            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
                        }
                        this.commonObjs.clear();
                        if (!keepLoadedFonts) this.fontLoader.clear();
                        this.#methodPromises.clear();
                        this.filterFactory.destroy(true);
                    }
                    get loadingParams() {
                        const { disableAutoFetch, enableXfa } = this._params;
                        return (0, _util.shadow)(this, "loadingParams", {
                            disableAutoFetch: disableAutoFetch,
                            enableXfa: enableXfa
                        });
                    }
                }
                class PDFObjects {
                    #objs = Object.create(null);
                    #ensureObj(objId) {
                        return this.#objs[objId] ||= {
                            capability: new _util.PromiseCapability(),
                            data: null
                        };
                    }
                    get(objId, callback = null) {
                        if (callback) {
                            const obj = this.#ensureObj(objId);
                            obj.capability.promise.then(()=>callback(obj.data));
                            return null;
                        }
                        const obj = this.#objs[objId];
                        if (!obj?.capability.settled) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
                        return obj.data;
                    }
                    has(objId) {
                        const obj = this.#objs[objId];
                        return obj?.capability.settled || false;
                    }
                    resolve(objId, data = null) {
                        const obj = this.#ensureObj(objId);
                        obj.data = data;
                        obj.capability.resolve();
                    }
                    clear() {
                        for(const objId in this.#objs){
                            const { data } = this.#objs[objId];
                            data?.bitmap?.close();
                        }
                        this.#objs = Object.create(null);
                    }
                }
                class RenderTask {
                    #internalRenderTask = null;
                    constructor(internalRenderTask){
                        this.#internalRenderTask = internalRenderTask;
                        this.onContinue = null;
                    }
                    get promise() {
                        return this.#internalRenderTask.capability.promise;
                    }
                    cancel(extraDelay = 0) {
                        this.#internalRenderTask.cancel(null, extraDelay);
                    }
                    get separateAnnots() {
                        const { separateAnnots } = this.#internalRenderTask.operatorList;
                        if (!separateAnnots) return false;
                        const { annotationCanvasMap } = this.#internalRenderTask;
                        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
                    }
                }
                exports.RenderTask = RenderTask;
                class InternalRenderTask {
                    static #canvasInUse = new WeakSet();
                    constructor({ callback, params, objs, commonObjs, annotationCanvasMap, operatorList, pageIndex, canvasFactory, filterFactory, useRequestAnimationFrame = false, pdfBug = false, pageColors = null }){
                        this.callback = callback;
                        this.params = params;
                        this.objs = objs;
                        this.commonObjs = commonObjs;
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList;
                        this._pageIndex = pageIndex;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this._pdfBug = pdfBug;
                        this.pageColors = pageColors;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = new _util.PromiseCapability();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params.canvasContext.canvas;
                    }
                    get completed() {
                        return this.capability.promise.catch(function() {});
                    }
                    initializeGraphics({ transparency = false, optionalContentConfig }) {
                        if (this.cancelled) return;
                        if (this._canvas) {
                            if (InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                            InternalRenderTask.#canvasInUse.add(this._canvas);
                        }
                        if (this._pdfBug && globalThis.StepperManager?.enabled) {
                            this.stepper = globalThis.StepperManager.create(this._pageIndex);
                            this.stepper.init(this.operatorList);
                            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                        }
                        const { canvasContext, viewport, transform, background } = this.params;
                        this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                            optionalContentConfig: optionalContentConfig
                        }, this.annotationCanvasMap, this.pageColors);
                        this.gfx.beginDrawing({
                            transform: transform,
                            viewport: viewport,
                            transparency: transparency,
                            background: background
                        });
                        this.operatorListIdx = 0;
                        this.graphicsReady = true;
                        this.graphicsReadyCallback?.();
                    }
                    cancel(error = null, extraDelay = 0) {
                        this.running = false;
                        this.cancelled = true;
                        this.gfx?.endDrawing();
                        InternalRenderTask.#canvasInUse.delete(this._canvas);
                        this.callback(error || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
                    }
                    operatorListChanged() {
                        if (!this.graphicsReady) {
                            this.graphicsReadyCallback ||= this._continueBound;
                            return;
                        }
                        this.stepper?.updateOperatorList(this.operatorList);
                        if (this.running) return;
                        this._continue();
                    }
                    _continue() {
                        this.running = true;
                        if (this.cancelled) return;
                        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                        else this._scheduleNext();
                    }
                    _scheduleNext() {
                        if (this._useRequestAnimationFrame) window.requestAnimationFrame(()=>{
                            this._nextBound().catch(this._cancelBound);
                        });
                        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                    }
                    async _next() {
                        if (this.cancelled) return;
                        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                        if (this.operatorListIdx === this.operatorList.argsArray.length) {
                            this.running = false;
                            if (this.operatorList.lastChunk) {
                                this.gfx.endDrawing();
                                InternalRenderTask.#canvasInUse.delete(this._canvas);
                                this.callback();
                            }
                        }
                    }
                }
                const version = "3.11.174";
                exports.version = version;
                const build = "ce8716743";
                exports.build = build;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SerializableEmpty = exports.PrintAnnotationStorage = exports.AnnotationStorage = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _murmurhash = __w_pdfjs_require__(8);
                const SerializableEmpty = Object.freeze({
                    map: null,
                    hash: "",
                    transfers: undefined
                });
                exports.SerializableEmpty = SerializableEmpty;
                class AnnotationStorage {
                    #modified = false;
                    #storage = new Map();
                    constructor(){
                        this.onSetModified = null;
                        this.onResetModified = null;
                        this.onAnnotationEditor = null;
                    }
                    getValue(key, defaultValue) {
                        const value = this.#storage.get(key);
                        if (value === undefined) return defaultValue;
                        return Object.assign(defaultValue, value);
                    }
                    getRawValue(key) {
                        return this.#storage.get(key);
                    }
                    remove(key) {
                        this.#storage.delete(key);
                        if (this.#storage.size === 0) this.resetModified();
                        if (typeof this.onAnnotationEditor === "function") {
                            for (const value of this.#storage.values()){
                                if (value instanceof _editor.AnnotationEditor) return;
                            }
                            this.onAnnotationEditor(null);
                        }
                    }
                    setValue(key, value) {
                        const obj = this.#storage.get(key);
                        let modified = false;
                        if (obj !== undefined) {
                            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                                modified = true;
                                obj[entry] = val;
                            }
                        } else {
                            modified = true;
                            this.#storage.set(key, value);
                        }
                        if (modified) this.#setModified();
                        if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
                    }
                    has(key) {
                        return this.#storage.has(key);
                    }
                    getAll() {
                        return this.#storage.size > 0 ? (0, _util.objectFromMap)(this.#storage) : null;
                    }
                    setAll(obj) {
                        for (const [key, val] of Object.entries(obj))this.setValue(key, val);
                    }
                    get size() {
                        return this.#storage.size;
                    }
                    #setModified() {
                        if (!this.#modified) {
                            this.#modified = true;
                            if (typeof this.onSetModified === "function") this.onSetModified();
                        }
                    }
                    resetModified() {
                        if (this.#modified) {
                            this.#modified = false;
                            if (typeof this.onResetModified === "function") this.onResetModified();
                        }
                    }
                    get print() {
                        return new PrintAnnotationStorage(this);
                    }
                    get serializable() {
                        if (this.#storage.size === 0) return SerializableEmpty;
                        const map = new Map(), hash = new _murmurhash.MurmurHash3_64(), transfers = [];
                        const context = Object.create(null);
                        let hasBitmap = false;
                        for (const [key, val] of this.#storage){
                            const serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context) : val;
                            if (serialized) {
                                map.set(key, serialized);
                                hash.update(`${key}:${JSON.stringify(serialized)}`);
                                hasBitmap ||= !!serialized.bitmap;
                            }
                        }
                        if (hasBitmap) {
                            for (const value of map.values())if (value.bitmap) transfers.push(value.bitmap);
                        }
                        return map.size > 0 ? {
                            map: map,
                            hash: hash.hexdigest(),
                            transfers: transfers
                        } : SerializableEmpty;
                    }
                }
                exports.AnnotationStorage = AnnotationStorage;
                class PrintAnnotationStorage extends AnnotationStorage {
                    #serializable;
                    constructor(parent){
                        super();
                        const { map, hash, transfers } = parent.serializable;
                        const clone = structuredClone(map, transfers ? {
                            transfer: transfers
                        } : null);
                        this.#serializable = {
                            map: clone,
                            hash: hash,
                            transfers: transfers
                        };
                    }
                    get print() {
                        (0, _util.unreachable)("Should not call PrintAnnotationStorage.print");
                    }
                    get serializable() {
                        return this.#serializable;
                    }
                }
                exports.PrintAnnotationStorage = PrintAnnotationStorage;
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditor = void 0;
                var _tools = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class AnnotationEditor {
                    #altText = "";
                    #altTextDecorative = false;
                    #altTextButton = null;
                    #altTextTooltip = null;
                    #altTextTooltipTimeout = null;
                    #keepAspectRatio = false;
                    #resizersDiv = null;
                    #boundFocusin = this.focusin.bind(this);
                    #boundFocusout = this.focusout.bind(this);
                    #hasBeenClicked = false;
                    #isEditing = false;
                    #isInEditMode = false;
                    _initialOptions = Object.create(null);
                    _uiManager = null;
                    _focusEventsAllowed = true;
                    _l10nPromise = null;
                    #isDraggable = false;
                    #zIndex = AnnotationEditor._zIndex++;
                    static _borderLineWidth = -1;
                    static _colorManager = new _tools.ColorManager();
                    static _zIndex = 1;
                    static SMALL_EDITOR_SIZE = 0;
                    constructor(parameters){
                        if (this.constructor === AnnotationEditor) (0, _util.unreachable)("Cannot initialize AnnotationEditor.");
                        this.parent = parameters.parent;
                        this.id = parameters.id;
                        this.width = this.height = null;
                        this.pageIndex = parameters.parent.pageIndex;
                        this.name = parameters.name;
                        this.div = null;
                        this._uiManager = parameters.uiManager;
                        this.annotationElementId = null;
                        this._willKeepAspectRatio = false;
                        this._initialOptions.isCentered = parameters.isCentered;
                        this._structTreeParentId = null;
                        const { rotation, rawDims: { pageWidth, pageHeight, pageX, pageY } } = this.parent.viewport;
                        this.rotation = rotation;
                        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
                        this.pageDimensions = [
                            pageWidth,
                            pageHeight
                        ];
                        this.pageTranslation = [
                            pageX,
                            pageY
                        ];
                        const [width, height] = this.parentDimensions;
                        this.x = parameters.x / width;
                        this.y = parameters.y / height;
                        this.isAttachedToDOM = false;
                        this.deleted = false;
                    }
                    get editorType() {
                        return Object.getPrototypeOf(this).constructor._type;
                    }
                    static get _defaultLineColor() {
                        return (0, _util.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                    }
                    static deleteAnnotationElement(editor) {
                        const fakeEditor = new FakeEditor({
                            id: editor.parent.getNextId(),
                            parent: editor.parent,
                            uiManager: editor._uiManager
                        });
                        fakeEditor.annotationElementId = editor.annotationElementId;
                        fakeEditor.deleted = true;
                        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
                    }
                    static initialize(l10n, options = null) {
                        AnnotationEditor._l10nPromise ||= new Map([
                            "editor_alt_text_button_label",
                            "editor_alt_text_edit_button_label",
                            "editor_alt_text_decorative_tooltip"
                        ].map((str)=>[
                                str,
                                l10n.get(str)
                            ]));
                        if (options?.strings) for (const str of options.strings)AnnotationEditor._l10nPromise.set(str, l10n.get(str));
                        if (AnnotationEditor._borderLineWidth !== -1) return;
                        const style = getComputedStyle(document.documentElement);
                        AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
                    }
                    static updateDefaultParams(_type, _value) {}
                    static get defaultPropertiesToUpdate() {
                        return [];
                    }
                    static isHandlingMimeForPasting(mime) {
                        return false;
                    }
                    static paste(item, parent) {
                        (0, _util.unreachable)("Not implemented");
                    }
                    get propertiesToUpdate() {
                        return [];
                    }
                    get _isDraggable() {
                        return this.#isDraggable;
                    }
                    set _isDraggable(value) {
                        this.#isDraggable = value;
                        this.div?.classList.toggle("draggable", value);
                    }
                    center() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        switch(this.parentRotation){
                            case 90:
                                this.x -= this.height * pageHeight / (pageWidth * 2);
                                this.y += this.width * pageWidth / (pageHeight * 2);
                                break;
                            case 180:
                                this.x += this.width / 2;
                                this.y += this.height / 2;
                                break;
                            case 270:
                                this.x += this.height * pageHeight / (pageWidth * 2);
                                this.y -= this.width * pageWidth / (pageHeight * 2);
                                break;
                            default:
                                this.x -= this.width / 2;
                                this.y -= this.height / 2;
                                break;
                        }
                        this.fixAndSetPosition();
                    }
                    addCommands(params) {
                        this._uiManager.addCommands(params);
                    }
                    get currentLayer() {
                        return this._uiManager.currentLayer;
                    }
                    setInBackground() {
                        this.div.style.zIndex = 0;
                    }
                    setInForeground() {
                        this.div.style.zIndex = this.#zIndex;
                    }
                    setParent(parent) {
                        if (parent !== null) {
                            this.pageIndex = parent.pageIndex;
                            this.pageDimensions = parent.pageDimensions;
                        }
                        this.parent = parent;
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.#hasBeenClicked) this.parent.setSelected(this);
                        else this.#hasBeenClicked = false;
                    }
                    focusout(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.isAttachedToDOM) return;
                        const target = event.relatedTarget;
                        if (target?.closest(`#${this.id}`)) return;
                        event.preventDefault();
                        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
                    }
                    commitOrRemove() {
                        if (this.isEmpty()) this.remove();
                        else this.commit();
                    }
                    commit() {
                        this.addToAnnotationStorage();
                    }
                    addToAnnotationStorage() {
                        this._uiManager.addToAnnotationStorage(this);
                    }
                    setAt(x, y, tx, ty) {
                        const [width, height] = this.parentDimensions;
                        [tx, ty] = this.screenToPageTranslation(tx, ty);
                        this.x = (x + tx) / width;
                        this.y = (y + ty) / height;
                        this.fixAndSetPosition();
                    }
                    #translate([width, height], x, y) {
                        [x, y] = this.screenToPageTranslation(x, y);
                        this.x += x / width;
                        this.y += y / height;
                        this.fixAndSetPosition();
                    }
                    translate(x, y) {
                        this.#translate(this.parentDimensions, x, y);
                    }
                    translateInPage(x, y) {
                        this.#translate(this.pageDimensions, x, y);
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    drag(tx, ty) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.x += tx / parentWidth;
                        this.y += ty / parentHeight;
                        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                            const { x, y } = this.div.getBoundingClientRect();
                            if (this.parent.findNewParent(this, x, y)) {
                                this.x -= Math.floor(this.x);
                                this.y -= Math.floor(this.y);
                            }
                        }
                        let { x, y } = this;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        this.div.style.left = `${(100 * x).toFixed(2)}%`;
                        this.div.style.top = `${(100 * y).toFixed(2)}%`;
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    #getBaseTranslation() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const { _borderLineWidth } = AnnotationEditor;
                        const x = _borderLineWidth / parentWidth;
                        const y = _borderLineWidth / parentHeight;
                        switch(this.rotation){
                            case 90:
                                return [
                                    -x,
                                    y
                                ];
                            case 180:
                                return [
                                    x,
                                    y
                                ];
                            case 270:
                                return [
                                    x,
                                    -y
                                ];
                            default:
                                return [
                                    -x,
                                    -y
                                ];
                        }
                    }
                    fixAndSetPosition() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        let { x, y, width, height } = this;
                        width *= pageWidth;
                        height *= pageHeight;
                        x *= pageWidth;
                        y *= pageHeight;
                        switch(this.rotation){
                            case 0:
                                x = Math.max(0, Math.min(pageWidth - width, x));
                                y = Math.max(0, Math.min(pageHeight - height, y));
                                break;
                            case 90:
                                x = Math.max(0, Math.min(pageWidth - height, x));
                                y = Math.min(pageHeight, Math.max(width, y));
                                break;
                            case 180:
                                x = Math.min(pageWidth, Math.max(width, x));
                                y = Math.min(pageHeight, Math.max(height, y));
                                break;
                            case 270:
                                x = Math.min(pageWidth, Math.max(height, x));
                                y = Math.max(0, Math.min(pageHeight - width, y));
                                break;
                        }
                        this.x = x /= pageWidth;
                        this.y = y /= pageHeight;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        const { style } = this.div;
                        style.left = `${(100 * x).toFixed(2)}%`;
                        style.top = `${(100 * y).toFixed(2)}%`;
                        this.moveInDOM();
                    }
                    static #rotatePoint(x, y, angle) {
                        switch(angle){
                            case 90:
                                return [
                                    y,
                                    -x
                                ];
                            case 180:
                                return [
                                    -x,
                                    -y
                                ];
                            case 270:
                                return [
                                    -y,
                                    x
                                ];
                            default:
                                return [
                                    x,
                                    y
                                ];
                        }
                    }
                    screenToPageTranslation(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
                    }
                    pageTranslationToScreen(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
                    }
                    #getRotationMatrix(rotation) {
                        switch(rotation){
                            case 90:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        -pageWidth / pageHeight,
                                        pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            case 180:
                                return [
                                    -1,
                                    0,
                                    0,
                                    -1
                                ];
                            case 270:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        pageWidth / pageHeight,
                                        -pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            default:
                                return [
                                    1,
                                    0,
                                    0,
                                    1
                                ];
                        }
                    }
                    get parentScale() {
                        return this._uiManager.viewParameters.realScale;
                    }
                    get parentRotation() {
                        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                    }
                    get parentDimensions() {
                        const { parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
                        const scaledWidth = pageWidth * parentScale;
                        const scaledHeight = pageHeight * parentScale;
                        return _util.FeatureTest.isCSSRoundSupported ? [
                            Math.round(scaledWidth),
                            Math.round(scaledHeight)
                        ] : [
                            scaledWidth,
                            scaledHeight
                        ];
                    }
                    setDims(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio) this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
                        this.#altTextButton?.classList.toggle("small", width < AnnotationEditor.SMALL_EDITOR_SIZE || height < AnnotationEditor.SMALL_EDITOR_SIZE);
                    }
                    fixDims() {
                        const { style } = this.div;
                        const { height, width } = style;
                        const widthPercent = width.endsWith("%");
                        const heightPercent = !this.#keepAspectRatio && height.endsWith("%");
                        if (widthPercent && heightPercent) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (!widthPercent) style.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio && !heightPercent) style.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
                    }
                    getInitialTranslation() {
                        return [
                            0,
                            0
                        ];
                    }
                    #createResizers() {
                        if (this.#resizersDiv) return;
                        this.#resizersDiv = document.createElement("div");
                        this.#resizersDiv.classList.add("resizers");
                        const classes = [
                            "topLeft",
                            "topRight",
                            "bottomRight",
                            "bottomLeft"
                        ];
                        if (!this._willKeepAspectRatio) classes.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                        for (const name of classes){
                            const div = document.createElement("div");
                            this.#resizersDiv.append(div);
                            div.classList.add("resizer", name);
                            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name));
                            div.addEventListener("contextmenu", _display_utils.noContextMenu);
                        }
                        this.div.prepend(this.#resizersDiv);
                    }
                    #resizerPointerdown(name, event) {
                        event.preventDefault();
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        const boundResizerPointermove = this.#resizerPointermove.bind(this, name);
                        const savedDraggable = this._isDraggable;
                        this._isDraggable = false;
                        const pointerMoveOptions = {
                            passive: true,
                            capture: true
                        };
                        window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const savedParentCursor = this.parent.div.style.cursor;
                        const savedCursor = this.div.style.cursor;
                        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
                        const pointerUpCallback = ()=>{
                            this._isDraggable = savedDraggable;
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                            this.parent.div.style.cursor = savedParentCursor;
                            this.div.style.cursor = savedCursor;
                            const newX = this.x;
                            const newY = this.y;
                            const newWidth = this.width;
                            const newHeight = this.height;
                            if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
                            this.addCommands({
                                cmd: ()=>{
                                    this.width = newWidth;
                                    this.height = newHeight;
                                    this.x = newX;
                                    this.y = newY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                                    this.fixAndSetPosition();
                                },
                                undo: ()=>{
                                    this.width = savedWidth;
                                    this.height = savedHeight;
                                    this.x = savedX;
                                    this.y = savedY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                                    this.fixAndSetPosition();
                                },
                                mustExec: true
                            });
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    #resizerPointermove(name, event) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
                        const minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
                        const round = (x)=>Math.round(x * 10000) / 10000;
                        const rotationMatrix = this.#getRotationMatrix(this.rotation);
                        const transf = (x, y)=>[
                                rotationMatrix[0] * x + rotationMatrix[2] * y,
                                rotationMatrix[1] * x + rotationMatrix[3] * y
                            ];
                        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
                        const invTransf = (x, y)=>[
                                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                                invRotationMatrix[1] * x + invRotationMatrix[3] * y
                            ];
                        let getPoint;
                        let getOpposite;
                        let isDiagonal = false;
                        let isHorizontal = false;
                        switch(name){
                            case "topLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h
                                    ];
                                break;
                            case "topMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                break;
                            case "topRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h
                                    ];
                                break;
                            case "middleRight":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                break;
                            case "bottomRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        0
                                    ];
                                break;
                            case "bottomMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                break;
                            case "bottomLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        0
                                    ];
                                break;
                            case "middleLeft":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                break;
                        }
                        const point = getPoint(savedWidth, savedHeight);
                        const oppositePoint = getOpposite(savedWidth, savedHeight);
                        let transfOppositePoint = transf(...oppositePoint);
                        const oppositeX = round(savedX + transfOppositePoint[0]);
                        const oppositeY = round(savedY + transfOppositePoint[1]);
                        let ratioX = 1;
                        let ratioY = 1;
                        let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
                        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
                        if (isDiagonal) {
                            const oldDiag = Math.hypot(savedWidth, savedHeight);
                            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
                        } else if (isHorizontal) ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
                        else ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
                        const newWidth = round(savedWidth * ratioX);
                        const newHeight = round(savedHeight * ratioY);
                        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
                        const newX = oppositeX - transfOppositePoint[0];
                        const newY = oppositeY - transfOppositePoint[1];
                        this.width = newWidth;
                        this.height = newHeight;
                        this.x = newX;
                        this.y = newY;
                        this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                        this.fixAndSetPosition();
                    }
                    async addAltTextButton() {
                        if (this.#altTextButton) return;
                        const altText = this.#altTextButton = document.createElement("button");
                        altText.className = "altText";
                        const msg = await AnnotationEditor._l10nPromise.get("editor_alt_text_button_label");
                        altText.textContent = msg;
                        altText.setAttribute("aria-label", msg);
                        altText.tabIndex = "0";
                        altText.addEventListener("contextmenu", _display_utils.noContextMenu);
                        altText.addEventListener("pointerdown", (event)=>event.stopPropagation());
                        altText.addEventListener("click", (event)=>{
                            event.preventDefault();
                            this._uiManager.editAltText(this);
                        }, {
                            capture: true
                        });
                        altText.addEventListener("keydown", (event)=>{
                            if (event.target === altText && event.key === "Enter") {
                                event.preventDefault();
                                this._uiManager.editAltText(this);
                            }
                        });
                        this.#setAltTextButtonState();
                        this.div.append(altText);
                        if (!AnnotationEditor.SMALL_EDITOR_SIZE) {
                            const PERCENT = 40;
                            AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
                        }
                    }
                    async #setAltTextButtonState() {
                        const button = this.#altTextButton;
                        if (!button) return;
                        if (!this.#altText && !this.#altTextDecorative) {
                            button.classList.remove("done");
                            this.#altTextTooltip?.remove();
                            return;
                        }
                        AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then((msg)=>{
                            button.setAttribute("aria-label", msg);
                        });
                        let tooltip = this.#altTextTooltip;
                        if (!tooltip) {
                            this.#altTextTooltip = tooltip = document.createElement("span");
                            tooltip.className = "tooltip";
                            tooltip.setAttribute("role", "tooltip");
                            const id = tooltip.id = `alt-text-tooltip-${this.id}`;
                            button.setAttribute("aria-describedby", id);
                            const DELAY_TO_SHOW_TOOLTIP = 100;
                            button.addEventListener("mouseenter", ()=>{
                                this.#altTextTooltipTimeout = setTimeout(()=>{
                                    this.#altTextTooltipTimeout = null;
                                    this.#altTextTooltip.classList.add("show");
                                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                                        source: this,
                                        details: {
                                            type: "editing",
                                            subtype: this.editorType,
                                            data: {
                                                action: "alt_text_tooltip"
                                            }
                                        }
                                    });
                                }, DELAY_TO_SHOW_TOOLTIP);
                            });
                            button.addEventListener("mouseleave", ()=>{
                                clearTimeout(this.#altTextTooltipTimeout);
                                this.#altTextTooltipTimeout = null;
                                this.#altTextTooltip?.classList.remove("show");
                            });
                        }
                        button.classList.add("done");
                        tooltip.innerText = this.#altTextDecorative ? await AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#altText;
                        if (!tooltip.parentNode) button.append(tooltip);
                    }
                    getClientDimensions() {
                        return this.div.getBoundingClientRect();
                    }
                    get altTextData() {
                        return {
                            altText: this.#altText,
                            decorative: this.#altTextDecorative
                        };
                    }
                    set altTextData({ altText, decorative }) {
                        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
                        this.#altText = altText;
                        this.#altTextDecorative = decorative;
                        this.#setAltTextButtonState();
                    }
                    render() {
                        this.div = document.createElement("div");
                        this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                        this.div.className = this.name;
                        this.div.setAttribute("id", this.id);
                        this.div.setAttribute("tabIndex", 0);
                        this.setInForeground();
                        this.div.addEventListener("focusin", this.#boundFocusin);
                        this.div.addEventListener("focusout", this.#boundFocusout);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (this.parentRotation % 180 !== 0) {
                            this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
                            this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
                        }
                        const [tx, ty] = this.getInitialTranslation();
                        this.translate(tx, ty);
                        (0, _tools.bindEvents)(this, this.div, [
                            "pointerdown"
                        ]);
                        return this.div;
                    }
                    pointerdown(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) {
                            event.preventDefault();
                            return;
                        }
                        this.#hasBeenClicked = true;
                        this.#setUpDragSession(event);
                    }
                    #setUpDragSession(event) {
                        if (!this._isDraggable) return;
                        const isSelected = this._uiManager.isSelected(this);
                        this._uiManager.setUpDragSession();
                        let pointerMoveOptions, pointerMoveCallback;
                        if (isSelected) {
                            pointerMoveOptions = {
                                passive: true,
                                capture: true
                            };
                            pointerMoveCallback = (e)=>{
                                const [tx, ty] = this.screenToPageTranslation(e.movementX, e.movementY);
                                this._uiManager.dragSelectedEditors(tx, ty);
                            };
                            window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                        }
                        const pointerUpCallback = ()=>{
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            if (isSelected) window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                            this.#hasBeenClicked = false;
                            if (!this._uiManager.endDragSession()) {
                                const { isMac } = _util.FeatureTest.platform;
                                if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
                                else this.parent.setSelected(this);
                            }
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    moveInDOM() {
                        this.parent?.moveEditorInDOM(this);
                    }
                    _setParentAndPosition(parent, x, y) {
                        parent.changeParent(this);
                        this.x = x;
                        this.y = y;
                        this.fixAndSetPosition();
                    }
                    getRect(tx, ty) {
                        const scale = this.parentScale;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const [pageX, pageY] = this.pageTranslation;
                        const shiftX = tx / scale;
                        const shiftY = ty / scale;
                        const x = this.x * pageWidth;
                        const y = this.y * pageHeight;
                        const width = this.width * pageWidth;
                        const height = this.height * pageHeight;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x + shiftX + pageX,
                                    pageHeight - y - shiftY - height + pageY,
                                    x + shiftX + width + pageX,
                                    pageHeight - y - shiftY + pageY
                                ];
                            case 90:
                                return [
                                    x + shiftY + pageX,
                                    pageHeight - y + shiftX + pageY,
                                    x + shiftY + height + pageX,
                                    pageHeight - y + shiftX + width + pageY
                                ];
                            case 180:
                                return [
                                    x - shiftX - width + pageX,
                                    pageHeight - y + shiftY + pageY,
                                    x - shiftX + pageX,
                                    pageHeight - y + shiftY + height + pageY
                                ];
                            case 270:
                                return [
                                    x - shiftY - height + pageX,
                                    pageHeight - y - shiftX - width + pageY,
                                    x - shiftY + pageX,
                                    pageHeight - y - shiftX + pageY
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    getRectInCurrentCoords(rect, pageHeight) {
                        const [x1, y1, x2, y2] = rect;
                        const width = x2 - x1;
                        const height = y2 - y1;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x1,
                                    pageHeight - y2,
                                    width,
                                    height
                                ];
                            case 90:
                                return [
                                    x1,
                                    pageHeight - y1,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    x2,
                                    pageHeight - y1,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    x2,
                                    pageHeight - y2,
                                    height,
                                    width
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    onceAdded() {}
                    isEmpty() {
                        return false;
                    }
                    enableEditMode() {
                        this.#isInEditMode = true;
                    }
                    disableEditMode() {
                        this.#isInEditMode = false;
                    }
                    isInEditMode() {
                        return this.#isInEditMode;
                    }
                    shouldGetKeyboardEvents() {
                        return false;
                    }
                    needsToBeRebuilt() {
                        return this.div && !this.isAttachedToDOM;
                    }
                    rebuild() {
                        this.div?.addEventListener("focusin", this.#boundFocusin);
                        this.div?.addEventListener("focusout", this.#boundFocusout);
                    }
                    serialize(isForCopying = false, context = null) {
                        (0, _util.unreachable)("An editor must be serializable");
                    }
                    static deserialize(data, parent, uiManager) {
                        const editor = new this.prototype.constructor({
                            parent: parent,
                            id: parent.getNextId(),
                            uiManager: uiManager
                        });
                        editor.rotation = data.rotation;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
                        editor.x = x / pageWidth;
                        editor.y = y / pageHeight;
                        editor.width = width / pageWidth;
                        editor.height = height / pageHeight;
                        return editor;
                    }
                    remove() {
                        this.div.removeEventListener("focusin", this.#boundFocusin);
                        this.div.removeEventListener("focusout", this.#boundFocusout);
                        if (!this.isEmpty()) this.commit();
                        if (this.parent) this.parent.remove(this);
                        else this._uiManager.removeEditor(this);
                        this.#altTextButton?.remove();
                        this.#altTextButton = null;
                        this.#altTextTooltip = null;
                    }
                    get isResizable() {
                        return false;
                    }
                    makeResizable() {
                        if (this.isResizable) {
                            this.#createResizers();
                            this.#resizersDiv.classList.remove("hidden");
                        }
                    }
                    select() {
                        this.makeResizable();
                        this.div?.classList.add("selectedEditor");
                    }
                    unselect() {
                        this.#resizersDiv?.classList.add("hidden");
                        this.div?.classList.remove("selectedEditor");
                        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus();
                    }
                    updateParams(type, value) {}
                    disableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = true;
                    }
                    enableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = false;
                    }
                    enterInEditMode() {}
                    get contentDiv() {
                        return this.div;
                    }
                    get isEditing() {
                        return this.#isEditing;
                    }
                    set isEditing(value) {
                        this.#isEditing = value;
                        if (!this.parent) return;
                        if (value) {
                            this.parent.setSelected(this);
                            this.parent.setActiveEditor(this);
                        } else this.parent.setActiveEditor(null);
                    }
                    setAspectRatio(width, height) {
                        this.#keepAspectRatio = true;
                        const aspectRatio = width / height;
                        const { style } = this.div;
                        style.aspectRatio = aspectRatio;
                        style.height = "auto";
                    }
                    static get MIN_SIZE() {
                        return 16;
                    }
                }
                exports.AnnotationEditor = AnnotationEditor;
                class FakeEditor extends AnnotationEditor {
                    constructor(params){
                        super(params);
                        this.annotationElementId = params.annotationElementId;
                        this.deleted = true;
                    }
                    serialize() {
                        return {
                            id: this.annotationElementId,
                            deleted: true,
                            pageIndex: this.pageIndex
                        };
                    }
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.KeyboardManager = exports.CommandManager = exports.ColorManager = exports.AnnotationEditorUIManager = void 0;
                exports.bindEvents = bindEvents;
                exports.opacityToHex = opacityToHex;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                function bindEvents(obj, element, names) {
                    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
                }
                function opacityToHex(opacity) {
                    return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
                }
                class IdManager {
                    #id = 0;
                    getId() {
                        return `${_util.AnnotationEditorPrefix}${this.#id++}`;
                    }
                }
                class ImageManager {
                    #baseId = (0, _util.getUuid)();
                    #id = 0;
                    #cache = null;
                    static get _isSVGFittingCanvas() {
                        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
                        const canvas = new OffscreenCanvas(1, 3);
                        const ctx = canvas.getContext("2d");
                        const image = new Image();
                        image.src = svg;
                        const promise = image.decode().then(()=>{
                            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                        });
                        return (0, _util.shadow)(this, "_isSVGFittingCanvas", promise);
                    }
                    async #get(key, rawData) {
                        this.#cache ||= new Map();
                        let data = this.#cache.get(key);
                        if (data === null) return null;
                        if (data?.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        try {
                            data ||= {
                                bitmap: null,
                                id: `image_${this.#baseId}_${this.#id++}`,
                                refCounter: 0,
                                isSvg: false
                            };
                            let image;
                            if (typeof rawData === "string") {
                                data.url = rawData;
                                const response = await fetch(rawData);
                                if (!response.ok) throw new Error(response.statusText);
                                image = await response.blob();
                            } else image = data.file = rawData;
                            if (image.type === "image/svg+xml") {
                                const mustRemoveAspectRatioPromise = ImageManager._isSVGFittingCanvas;
                                const fileReader = new FileReader();
                                const imageElement = new Image();
                                const imagePromise = new Promise((resolve, reject)=>{
                                    imageElement.onload = ()=>{
                                        data.bitmap = imageElement;
                                        data.isSvg = true;
                                        resolve();
                                    };
                                    fileReader.onload = async ()=>{
                                        const url = data.svgUrl = fileReader.result;
                                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                                    };
                                    imageElement.onerror = fileReader.onerror = reject;
                                });
                                fileReader.readAsDataURL(image);
                                await imagePromise;
                            } else data.bitmap = await createImageBitmap(image);
                            data.refCounter = 1;
                        } catch (e) {
                            console.error(e);
                            data = null;
                        }
                        this.#cache.set(key, data);
                        if (data) this.#cache.set(data.id, data);
                        return data;
                    }
                    async getFromFile(file) {
                        const { lastModified, name, size, type } = file;
                        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
                    }
                    async getFromUrl(url) {
                        return this.#get(url, url);
                    }
                    async getFromId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return null;
                        if (data.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        if (data.file) return this.getFromFile(data.file);
                        return this.getFromUrl(data.url);
                    }
                    getSvgUrl(id) {
                        const data = this.#cache.get(id);
                        if (!data?.isSvg) return null;
                        return data.svgUrl;
                    }
                    deleteId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return;
                        data.refCounter -= 1;
                        if (data.refCounter !== 0) return;
                        data.bitmap = null;
                    }
                    isValidId(id) {
                        return id.startsWith(`image_${this.#baseId}_`);
                    }
                }
                class CommandManager {
                    #commands = [];
                    #locked = false;
                    #maxSize;
                    #position = -1;
                    constructor(maxSize = 128){
                        this.#maxSize = maxSize;
                    }
                    add({ cmd, undo, mustExec, type = NaN, overwriteIfSameType = false, keepUndo = false }) {
                        if (mustExec) cmd();
                        if (this.#locked) return;
                        const save = {
                            cmd: cmd,
                            undo: undo,
                            type: type
                        };
                        if (this.#position === -1) {
                            if (this.#commands.length > 0) this.#commands.length = 0;
                            this.#position = 0;
                            this.#commands.push(save);
                            return;
                        }
                        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
                            if (keepUndo) save.undo = this.#commands[this.#position].undo;
                            this.#commands[this.#position] = save;
                            return;
                        }
                        const next = this.#position + 1;
                        if (next === this.#maxSize) this.#commands.splice(0, 1);
                        else {
                            this.#position = next;
                            if (next < this.#commands.length) this.#commands.splice(next);
                        }
                        this.#commands.push(save);
                    }
                    undo() {
                        if (this.#position === -1) return;
                        this.#locked = true;
                        this.#commands[this.#position].undo();
                        this.#locked = false;
                        this.#position -= 1;
                    }
                    redo() {
                        if (this.#position < this.#commands.length - 1) {
                            this.#position += 1;
                            this.#locked = true;
                            this.#commands[this.#position].cmd();
                            this.#locked = false;
                        }
                    }
                    hasSomethingToUndo() {
                        return this.#position !== -1;
                    }
                    hasSomethingToRedo() {
                        return this.#position < this.#commands.length - 1;
                    }
                    destroy() {
                        this.#commands = null;
                    }
                }
                exports.CommandManager = CommandManager;
                class KeyboardManager {
                    constructor(callbacks){
                        this.buffer = [];
                        this.callbacks = new Map();
                        this.allKeys = new Set();
                        const { isMac } = _util.FeatureTest.platform;
                        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
                            const isMacKey = key.startsWith("mac+");
                            if (isMac && isMacKey) {
                                this.callbacks.set(key.slice(4), {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            } else if (!isMac && !isMacKey) {
                                this.callbacks.set(key, {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            }
                        }
                    }
                    #serialize(event) {
                        if (event.altKey) this.buffer.push("alt");
                        if (event.ctrlKey) this.buffer.push("ctrl");
                        if (event.metaKey) this.buffer.push("meta");
                        if (event.shiftKey) this.buffer.push("shift");
                        this.buffer.push(event.key);
                        const str = this.buffer.join("+");
                        this.buffer.length = 0;
                        return str;
                    }
                    exec(self, event) {
                        if (!this.allKeys.has(event.key)) return;
                        const info = this.callbacks.get(this.#serialize(event));
                        if (!info) return;
                        const { callback, options: { bubbles = false, args = [], checker = null } } = info;
                        if (checker && !checker(self, event)) return;
                        callback.bind(self, ...args)();
                        if (!bubbles) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }
                }
                exports.KeyboardManager = KeyboardManager;
                class ColorManager {
                    static _colorsMapping = new Map([
                        [
                            "CanvasText",
                            [
                                0,
                                0,
                                0
                            ]
                        ],
                        [
                            "Canvas",
                            [
                                255,
                                255,
                                255
                            ]
                        ]
                    ]);
                    get _colors() {
                        const colors = new Map([
                            [
                                "CanvasText",
                                null
                            ],
                            [
                                "Canvas",
                                null
                            ]
                        ]);
                        (0, _display_utils.getColorValues)(colors);
                        return (0, _util.shadow)(this, "_colors", colors);
                    }
                    convert(color) {
                        const rgb = (0, _display_utils.getRGB)(color);
                        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
                        for (const [name, RGB] of this._colors){
                            if (RGB.every((x, i)=>x === rgb[i])) return ColorManager._colorsMapping.get(name);
                        }
                        return rgb;
                    }
                    getHexCode(name) {
                        const rgb = this._colors.get(name);
                        if (!rgb) return name;
                        return _util.Util.makeHexColor(...rgb);
                    }
                }
                exports.ColorManager = ColorManager;
                class AnnotationEditorUIManager {
                    #activeEditor = null;
                    #allEditors = new Map();
                    #allLayers = new Map();
                    #altTextManager = null;
                    #annotationStorage = null;
                    #commandManager = new CommandManager();
                    #currentPageIndex = 0;
                    #deletedAnnotationsElementIds = new Set();
                    #draggingEditors = null;
                    #editorTypes = null;
                    #editorsToRescale = new Set();
                    #filterFactory = null;
                    #idManager = new IdManager();
                    #isEnabled = false;
                    #isWaiting = false;
                    #lastActiveElement = null;
                    #mode = _util.AnnotationEditorType.NONE;
                    #selectedEditors = new Set();
                    #pageColors = null;
                    #boundBlur = this.blur.bind(this);
                    #boundFocus = this.focus.bind(this);
                    #boundCopy = this.copy.bind(this);
                    #boundCut = this.cut.bind(this);
                    #boundPaste = this.paste.bind(this);
                    #boundKeydown = this.keydown.bind(this);
                    #boundOnEditingAction = this.onEditingAction.bind(this);
                    #boundOnPageChanging = this.onPageChanging.bind(this);
                    #boundOnScaleChanging = this.onScaleChanging.bind(this);
                    #boundOnRotationChanging = this.onRotationChanging.bind(this);
                    #previousStates = {
                        isEditing: false,
                        isEmpty: true,
                        hasSomethingToUndo: false,
                        hasSomethingToRedo: false,
                        hasSelectedEditor: false
                    };
                    #translation = [
                        0,
                        0
                    ];
                    #translationTimeoutId = null;
                    #container = null;
                    #viewer = null;
                    static TRANSLATE_SMALL = 1;
                    static TRANSLATE_BIG = 10;
                    static get _keyboardManager() {
                        const proto = AnnotationEditorUIManager.prototype;
                        const arrowChecker = (self)=>{
                            const { activeElement } = document;
                            return activeElement && self.#container.contains(activeElement) && self.hasSomethingToControl();
                        };
                        const small = this.TRANSLATE_SMALL;
                        const big = this.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new KeyboardManager([
                            [
                                [
                                    "ctrl+a",
                                    "mac+meta+a"
                                ],
                                proto.selectAll
                            ],
                            [
                                [
                                    "ctrl+z",
                                    "mac+meta+z"
                                ],
                                proto.undo
                            ],
                            [
                                [
                                    "ctrl+y",
                                    "ctrl+shift+z",
                                    "mac+meta+shift+z",
                                    "ctrl+shift+Z",
                                    "mac+meta+shift+Z"
                                ],
                                proto.redo
                            ],
                            [
                                [
                                    "Backspace",
                                    "alt+Backspace",
                                    "ctrl+Backspace",
                                    "shift+Backspace",
                                    "mac+Backspace",
                                    "mac+alt+Backspace",
                                    "mac+ctrl+Backspace",
                                    "Delete",
                                    "ctrl+Delete",
                                    "shift+Delete",
                                    "mac+Delete"
                                ],
                                proto.delete
                            ],
                            [
                                [
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.unselectAll
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors){
                        this.#container = container;
                        this.#viewer = viewer;
                        this.#altTextManager = altTextManager;
                        this._eventBus = eventBus;
                        this._eventBus._on("editingaction", this.#boundOnEditingAction);
                        this._eventBus._on("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._on("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._on("rotationchanging", this.#boundOnRotationChanging);
                        this.#annotationStorage = pdfDocument.annotationStorage;
                        this.#filterFactory = pdfDocument.filterFactory;
                        this.#pageColors = pageColors;
                        this.viewParameters = {
                            realScale: _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS,
                            rotation: 0
                        };
                    }
                    destroy() {
                        this.#removeKeyboardManager();
                        this.#removeFocusManager();
                        this._eventBus._off("editingaction", this.#boundOnEditingAction);
                        this._eventBus._off("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._off("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._off("rotationchanging", this.#boundOnRotationChanging);
                        for (const layer of this.#allLayers.values())layer.destroy();
                        this.#allLayers.clear();
                        this.#allEditors.clear();
                        this.#editorsToRescale.clear();
                        this.#activeEditor = null;
                        this.#selectedEditors.clear();
                        this.#commandManager.destroy();
                        this.#altTextManager.destroy();
                    }
                    get hcmFilter() {
                        return (0, _util.shadow)(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
                    }
                    get direction() {
                        return (0, _util.shadow)(this, "direction", getComputedStyle(this.#container).direction);
                    }
                    editAltText(editor) {
                        this.#altTextManager?.editAltText(this, editor);
                    }
                    onPageChanging({ pageNumber }) {
                        this.#currentPageIndex = pageNumber - 1;
                    }
                    focusMainContainer() {
                        this.#container.focus();
                    }
                    findParent(x, y) {
                        for (const layer of this.#allLayers.values()){
                            const { x: layerX, y: layerY, width, height } = layer.div.getBoundingClientRect();
                            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
                        }
                        return null;
                    }
                    disableUserSelect(value = false) {
                        this.#viewer.classList.toggle("noUserSelect", value);
                    }
                    addShouldRescale(editor) {
                        this.#editorsToRescale.add(editor);
                    }
                    removeShouldRescale(editor) {
                        this.#editorsToRescale.delete(editor);
                    }
                    onScaleChanging({ scale }) {
                        this.commitOrRemove();
                        this.viewParameters.realScale = scale * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS;
                        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
                    }
                    onRotationChanging({ pagesRotation }) {
                        this.commitOrRemove();
                        this.viewParameters.rotation = pagesRotation;
                    }
                    addToAnnotationStorage(editor) {
                        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
                    }
                    #addFocusManager() {
                        window.addEventListener("focus", this.#boundFocus);
                        window.addEventListener("blur", this.#boundBlur);
                    }
                    #removeFocusManager() {
                        window.removeEventListener("focus", this.#boundFocus);
                        window.removeEventListener("blur", this.#boundBlur);
                    }
                    blur() {
                        if (!this.hasSelection) return;
                        const { activeElement } = document;
                        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
                            this.#lastActiveElement = [
                                editor,
                                activeElement
                            ];
                            editor._focusEventsAllowed = false;
                            break;
                        }
                    }
                    focus() {
                        if (!this.#lastActiveElement) return;
                        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
                        this.#lastActiveElement = null;
                        lastActiveElement.addEventListener("focusin", ()=>{
                            lastEditor._focusEventsAllowed = true;
                        }, {
                            once: true
                        });
                        lastActiveElement.focus();
                    }
                    #addKeyboardManager() {
                        window.addEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #removeKeyboardManager() {
                        window.removeEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #addCopyPasteListeners() {
                        document.addEventListener("copy", this.#boundCopy);
                        document.addEventListener("cut", this.#boundCut);
                        document.addEventListener("paste", this.#boundPaste);
                    }
                    #removeCopyPasteListeners() {
                        document.removeEventListener("copy", this.#boundCopy);
                        document.removeEventListener("cut", this.#boundCut);
                        document.removeEventListener("paste", this.#boundPaste);
                    }
                    addEditListeners() {
                        this.#addKeyboardManager();
                        this.#addCopyPasteListeners();
                    }
                    removeEditListeners() {
                        this.#removeKeyboardManager();
                        this.#removeCopyPasteListeners();
                    }
                    copy(event) {
                        event.preventDefault();
                        this.#activeEditor?.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [];
                        for (const editor of this.#selectedEditors){
                            const serialized = editor.serialize(true);
                            if (serialized) editors.push(serialized);
                        }
                        if (editors.length === 0) return;
                        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
                    }
                    cut(event) {
                        this.copy(event);
                        this.delete();
                    }
                    paste(event) {
                        event.preventDefault();
                        const { clipboardData } = event;
                        for (const item of clipboardData.items){
                            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                                editorType.paste(item, this.currentLayer);
                                return;
                            }
                        }
                        let data = clipboardData.getData("application/pdfjs");
                        if (!data) return;
                        try {
                            data = JSON.parse(data);
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                            return;
                        }
                        if (!Array.isArray(data)) return;
                        this.unselectAll();
                        const layer = this.currentLayer;
                        try {
                            const newEditors = [];
                            for (const editor of data){
                                const deserializedEditor = layer.deserialize(editor);
                                if (!deserializedEditor) return;
                                newEditors.push(deserializedEditor);
                            }
                            const cmd = ()=>{
                                for (const editor of newEditors)this.#addEditorToLayer(editor);
                                this.#selectEditors(newEditors);
                            };
                            const undo = ()=>{
                                for (const editor of newEditors)editor.remove();
                            };
                            this.addCommands({
                                cmd: cmd,
                                undo: undo,
                                mustExec: true
                            });
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                        }
                    }
                    keydown(event) {
                        if (!this.getActive()?.shouldGetKeyboardEvents()) AnnotationEditorUIManager._keyboardManager.exec(this, event);
                    }
                    onEditingAction(details) {
                        if ([
                            "undo",
                            "redo",
                            "delete",
                            "selectAll"
                        ].includes(details.name)) this[details.name]();
                    }
                    #dispatchUpdateStates(details) {
                        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
                        if (hasChanged) this._eventBus.dispatch("annotationeditorstateschanged", {
                            source: this,
                            details: Object.assign(this.#previousStates, details)
                        });
                    }
                    #dispatchUpdateUI(details) {
                        this._eventBus.dispatch("annotationeditorparamschanged", {
                            source: this,
                            details: details
                        });
                    }
                    setEditingState(isEditing) {
                        if (isEditing) {
                            this.#addFocusManager();
                            this.#addKeyboardManager();
                            this.#addCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: this.#mode !== _util.AnnotationEditorType.NONE,
                                isEmpty: this.#isEmpty(),
                                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                                hasSelectedEditor: false
                            });
                        } else {
                            this.#removeFocusManager();
                            this.#removeKeyboardManager();
                            this.#removeCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: false
                            });
                            this.disableUserSelect(false);
                        }
                    }
                    registerEditorTypes(types) {
                        if (this.#editorTypes) return;
                        this.#editorTypes = types;
                        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
                    }
                    getId() {
                        return this.#idManager.getId();
                    }
                    get currentLayer() {
                        return this.#allLayers.get(this.#currentPageIndex);
                    }
                    getLayer(pageIndex) {
                        return this.#allLayers.get(pageIndex);
                    }
                    get currentPageIndex() {
                        return this.#currentPageIndex;
                    }
                    addLayer(layer) {
                        this.#allLayers.set(layer.pageIndex, layer);
                        if (this.#isEnabled) layer.enable();
                        else layer.disable();
                    }
                    removeLayer(layer) {
                        this.#allLayers.delete(layer.pageIndex);
                    }
                    updateMode(mode, editId = null) {
                        if (this.#mode === mode) return;
                        this.#mode = mode;
                        if (mode === _util.AnnotationEditorType.NONE) {
                            this.setEditingState(false);
                            this.#disableAll();
                            return;
                        }
                        this.setEditingState(true);
                        this.#enableAll();
                        this.unselectAll();
                        for (const layer of this.#allLayers.values())layer.updateMode(mode);
                        if (!editId) return;
                        for (const editor of this.#allEditors.values())if (editor.annotationElementId === editId) {
                            this.setSelected(editor);
                            editor.enterInEditMode();
                            break;
                        }
                    }
                    updateToolbar(mode) {
                        if (mode === this.#mode) return;
                        this._eventBus.dispatch("switchannotationeditormode", {
                            source: this,
                            mode: mode
                        });
                    }
                    updateParams(type, value) {
                        if (!this.#editorTypes) return;
                        if (type === _util.AnnotationEditorParamsType.CREATE) {
                            this.currentLayer.addNewEditor(type);
                            return;
                        }
                        for (const editor of this.#selectedEditors)editor.updateParams(type, value);
                        for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
                    }
                    enableWaiting(mustWait = false) {
                        if (this.#isWaiting === mustWait) return;
                        this.#isWaiting = mustWait;
                        for (const layer of this.#allLayers.values()){
                            if (mustWait) layer.disableClick();
                            else layer.enableClick();
                            layer.div.classList.toggle("waiting", mustWait);
                        }
                    }
                    #enableAll() {
                        if (!this.#isEnabled) {
                            this.#isEnabled = true;
                            for (const layer of this.#allLayers.values())layer.enable();
                        }
                    }
                    #disableAll() {
                        this.unselectAll();
                        if (this.#isEnabled) {
                            this.#isEnabled = false;
                            for (const layer of this.#allLayers.values())layer.disable();
                        }
                    }
                    getEditors(pageIndex) {
                        const editors = [];
                        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) editors.push(editor);
                        return editors;
                    }
                    getEditor(id) {
                        return this.#allEditors.get(id);
                    }
                    addEditor(editor) {
                        this.#allEditors.set(editor.id, editor);
                    }
                    removeEditor(editor) {
                        this.#allEditors.delete(editor.id);
                        this.unselect(editor);
                        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
                    }
                    addDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
                        editor.deleted = true;
                    }
                    isDeletedAnnotationElement(annotationElementId) {
                        return this.#deletedAnnotationsElementIds.has(annotationElementId);
                    }
                    removeDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
                        editor.deleted = false;
                    }
                    #addEditorToLayer(editor) {
                        const layer = this.#allLayers.get(editor.pageIndex);
                        if (layer) layer.addOrRebuild(editor);
                        else this.addEditor(editor);
                    }
                    setActiveEditor(editor) {
                        if (this.#activeEditor === editor) return;
                        this.#activeEditor = editor;
                        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
                    }
                    toggleSelected(editor) {
                        if (this.#selectedEditors.has(editor)) {
                            this.#selectedEditors.delete(editor);
                            editor.unselect();
                            this.#dispatchUpdateStates({
                                hasSelectedEditor: this.hasSelection
                            });
                            return;
                        }
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    setSelected(editor) {
                        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
                        this.#selectedEditors.clear();
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    isSelected(editor) {
                        return this.#selectedEditors.has(editor);
                    }
                    unselect(editor) {
                        editor.unselect();
                        this.#selectedEditors.delete(editor);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: this.hasSelection
                        });
                    }
                    get hasSelection() {
                        return this.#selectedEditors.size !== 0;
                    }
                    undo() {
                        this.#commandManager.undo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                            hasSomethingToRedo: true,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    redo() {
                        this.#commandManager.redo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                            isEmpty: this.#isEmpty()
                        });
                    }
                    addCommands(params) {
                        this.#commandManager.add(params);
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: false,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    #isEmpty() {
                        if (this.#allEditors.size === 0) return true;
                        if (this.#allEditors.size === 1) {
                            for (const editor of this.#allEditors.values())return editor.isEmpty();
                        }
                        return false;
                    }
                    delete() {
                        this.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const cmd = ()=>{
                            for (const editor of editors)editor.remove();
                        };
                        const undo = ()=>{
                            for (const editor of editors)this.#addEditorToLayer(editor);
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    commitOrRemove() {
                        this.#activeEditor?.commitOrRemove();
                    }
                    hasSomethingToControl() {
                        return this.#activeEditor || this.hasSelection;
                    }
                    #selectEditors(editors) {
                        this.#selectedEditors.clear();
                        for (const editor of editors){
                            if (editor.isEmpty()) continue;
                            this.#selectedEditors.add(editor);
                            editor.select();
                        }
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    selectAll() {
                        for (const editor of this.#selectedEditors)editor.commit();
                        this.#selectEditors(this.#allEditors.values());
                    }
                    unselectAll() {
                        if (this.#activeEditor) {
                            this.#activeEditor.commitOrRemove();
                            return;
                        }
                        if (!this.hasSelection) return;
                        for (const editor of this.#selectedEditors)editor.unselect();
                        this.#selectedEditors.clear();
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: false
                        });
                    }
                    translateSelectedEditors(x, y, noCommit = false) {
                        if (!noCommit) this.commitOrRemove();
                        if (!this.hasSelection) return;
                        this.#translation[0] += x;
                        this.#translation[1] += y;
                        const [totalX, totalY] = this.#translation;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const TIME_TO_WAIT = 1000;
                        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
                        this.#translationTimeoutId = setTimeout(()=>{
                            this.#translationTimeoutId = null;
                            this.#translation[0] = this.#translation[1] = 0;
                            this.addCommands({
                                cmd: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(totalX, totalY);
                                },
                                undo: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(-totalX, -totalY);
                                },
                                mustExec: false
                            });
                        }, TIME_TO_WAIT);
                        for (const editor of editors)editor.translateInPage(x, y);
                    }
                    setUpDragSession() {
                        if (!this.hasSelection) return;
                        this.disableUserSelect(true);
                        this.#draggingEditors = new Map();
                        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
                            savedX: editor.x,
                            savedY: editor.y,
                            savedPageIndex: editor.pageIndex,
                            newX: 0,
                            newY: 0,
                            newPageIndex: -1
                        });
                    }
                    endDragSession() {
                        if (!this.#draggingEditors) return false;
                        this.disableUserSelect(false);
                        const map = this.#draggingEditors;
                        this.#draggingEditors = null;
                        let mustBeAddedInUndoStack = false;
                        for (const [{ x, y, pageIndex }, value] of map){
                            value.newX = x;
                            value.newY = y;
                            value.newPageIndex = pageIndex;
                            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
                        }
                        if (!mustBeAddedInUndoStack) return false;
                        const move = (editor, x, y, pageIndex)=>{
                            if (this.#allEditors.has(editor.id)) {
                                const parent = this.#allLayers.get(pageIndex);
                                if (parent) editor._setParentAndPosition(parent, x, y);
                                else {
                                    editor.pageIndex = pageIndex;
                                    editor.x = x;
                                    editor.y = y;
                                }
                            }
                        };
                        this.addCommands({
                            cmd: ()=>{
                                for (const [editor, { newX, newY, newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
                            },
                            undo: ()=>{
                                for (const [editor, { savedX, savedY, savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
                            },
                            mustExec: true
                        });
                        return true;
                    }
                    dragSelectedEditors(tx, ty) {
                        if (!this.#draggingEditors) return;
                        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
                    }
                    rebuild(editor) {
                        if (editor.parent === null) {
                            const parent = this.getLayer(editor.pageIndex);
                            if (parent) {
                                parent.changeParent(editor);
                                parent.addOrRebuild(editor);
                            } else {
                                this.addEditor(editor);
                                this.addToAnnotationStorage(editor);
                                editor.rebuild();
                            }
                        } else editor.parent.addOrRebuild(editor);
                    }
                    isActive(editor) {
                        return this.#activeEditor === editor;
                    }
                    getActive() {
                        return this.#activeEditor;
                    }
                    getMode() {
                        return this.#mode;
                    }
                    get imageManager() {
                        return (0, _util.shadow)(this, "imageManager", new ImageManager());
                    }
                }
                exports.AnnotationEditorUIManager = AnnotationEditorUIManager;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMFilterFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
                exports.deprecated = deprecated;
                exports.getColorValues = getColorValues;
                exports.getCurrentTransform = getCurrentTransform;
                exports.getCurrentTransformInverse = getCurrentTransformInverse;
                exports.getFilenameFromUrl = getFilenameFromUrl;
                exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
                exports.getRGB = getRGB;
                exports.getXfaPageViewport = getXfaPageViewport;
                exports.isDataScheme = isDataScheme;
                exports.isPdfFile = isPdfFile;
                exports.isValidFetchUrl = isValidFetchUrl;
                exports.loadScript = loadScript;
                exports.noContextMenu = noContextMenu;
                exports.setLayerDimensions = setLayerDimensions;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const SVG_NS = "http://www.w3.org/2000/svg";
                class PixelsPerInch {
                    static CSS = 96.0;
                    static PDF = 72.0;
                    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
                }
                exports.PixelsPerInch = PixelsPerInch;
                class DOMFilterFactory extends _base_factory.BaseFilterFactory {
                    #_cache;
                    #_defs;
                    #docId;
                    #document;
                    #hcmFilter;
                    #hcmKey;
                    #hcmUrl;
                    #hcmHighlightFilter;
                    #hcmHighlightKey;
                    #hcmHighlightUrl;
                    #id = 0;
                    constructor({ docId, ownerDocument = globalThis.document } = {}){
                        super();
                        this.#docId = docId;
                        this.#document = ownerDocument;
                    }
                    get #cache() {
                        return this.#_cache ||= new Map();
                    }
                    get #defs() {
                        if (!this.#_defs) {
                            const div = this.#document.createElement("div");
                            const { style } = div;
                            style.visibility = "hidden";
                            style.contain = "strict";
                            style.width = style.height = 0;
                            style.position = "absolute";
                            style.top = style.left = 0;
                            style.zIndex = -1;
                            const svg = this.#document.createElementNS(SVG_NS, "svg");
                            svg.setAttribute("width", 0);
                            svg.setAttribute("height", 0);
                            this.#_defs = this.#document.createElementNS(SVG_NS, "defs");
                            div.append(svg);
                            svg.append(this.#_defs);
                            this.#document.body.append(div);
                        }
                        return this.#_defs;
                    }
                    addFilter(maps) {
                        if (!maps) return "none";
                        let value = this.#cache.get(maps);
                        if (value) return value;
                        let tableR, tableG, tableB, key;
                        if (maps.length === 1) {
                            const mapR = maps[0];
                            const buffer = new Array(256);
                            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
                            key = tableR = tableG = tableB = buffer.join(",");
                        } else {
                            const [mapR, mapG, mapB] = maps;
                            const bufferR = new Array(256);
                            const bufferG = new Array(256);
                            const bufferB = new Array(256);
                            for(let i = 0; i < 256; i++){
                                bufferR[i] = mapR[i] / 255;
                                bufferG[i] = mapG[i] / 255;
                                bufferB[i] = mapB[i] / 255;
                            }
                            tableR = bufferR.join(",");
                            tableG = bufferG.join(",");
                            tableB = bufferB.join(",");
                            key = `${tableR}${tableG}${tableB}`;
                        }
                        value = this.#cache.get(key);
                        if (value) {
                            this.#cache.set(maps, value);
                            return value;
                        }
                        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
                        const url = `url(#${id})`;
                        this.#cache.set(maps, url);
                        this.#cache.set(key, url);
                        const filter = this.#createFilter(id);
                        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
                        return url;
                    }
                    addHCMFilter(fgColor, bgColor) {
                        const key = `${fgColor}-${bgColor}`;
                        if (this.#hcmKey === key) return this.#hcmUrl;
                        this.#hcmKey = key;
                        this.#hcmUrl = "none";
                        this.#hcmFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmUrl;
                        const fgRGB = this.#getRGB(fgColor);
                        fgColor = _util.Util.makeHexColor(...fgRGB);
                        const bgRGB = this.#getRGB(bgColor);
                        bgColor = _util.Util.makeHexColor(...bgRGB);
                        this.#defs.style.color = "";
                        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return this.#hcmUrl;
                        const map = new Array(256);
                        for(let i = 0; i <= 255; i++){
                            const x = i / 255;
                            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
                        }
                        const table = map.join(",");
                        const id = `g_${this.#docId}_hcm_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addTransferMapConversion(table, table, table, filter);
                        this.#addGrayConversion(filter);
                        const getSteps = (c, n)=>{
                            const start = fgRGB[c] / 255;
                            const end = bgRGB[c] / 255;
                            const arr = new Array(n + 1);
                            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
                            return arr.join(",");
                        };
                        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
                        this.#hcmUrl = `url(#${id})`;
                        return this.#hcmUrl;
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
                        if (this.#hcmHighlightKey === key) return this.#hcmHighlightUrl;
                        this.#hcmHighlightKey = key;
                        this.#hcmHighlightUrl = "none";
                        this.#hcmHighlightFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmHighlightUrl;
                        const [fgRGB, bgRGB] = [
                            fgColor,
                            bgColor
                        ].map(this.#getRGB.bind(this));
                        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
                        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
                        let [newFgRGB, newBgRGB] = [
                            newFgColor,
                            newBgColor
                        ].map(this.#getRGB.bind(this));
                        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
                            bgGray,
                            fgGray,
                            newBgRGB,
                            newFgRGB
                        ];
                        this.#defs.style.color = "";
                        const getSteps = (fg, bg, n)=>{
                            const arr = new Array(256);
                            const step = (bgGray - fgGray) / n;
                            const newStart = fg / 255;
                            const newStep = (bg - fg) / (255 * n);
                            let prev = 0;
                            for(let i = 0; i <= n; i++){
                                const k = Math.round(fgGray + i * step);
                                const value = newStart + i * newStep;
                                for(let j = prev; j <= k; j++)arr[j] = value;
                                prev = k + 1;
                            }
                            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
                            return arr.join(",");
                        };
                        const id = `g_${this.#docId}_hcm_highlight_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addGrayConversion(filter);
                        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
                        this.#hcmHighlightUrl = `url(#${id})`;
                        return this.#hcmHighlightUrl;
                    }
                    destroy(keepHCM = false) {
                        if (keepHCM && (this.#hcmUrl || this.#hcmHighlightUrl)) return;
                        if (this.#_defs) {
                            this.#_defs.parentNode.parentNode.remove();
                            this.#_defs = null;
                        }
                        if (this.#_cache) {
                            this.#_cache.clear();
                            this.#_cache = null;
                        }
                        this.#id = 0;
                    }
                    #addGrayConversion(filter) {
                        const feColorMatrix = this.#document.createElementNS(SVG_NS, "feColorMatrix");
                        feColorMatrix.setAttribute("type", "matrix");
                        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                        filter.append(feColorMatrix);
                    }
                    #createFilter(id) {
                        const filter = this.#document.createElementNS(SVG_NS, "filter");
                        filter.setAttribute("color-interpolation-filters", "sRGB");
                        filter.setAttribute("id", id);
                        this.#defs.append(filter);
                        return filter;
                    }
                    #appendFeFunc(feComponentTransfer, func, table) {
                        const feFunc = this.#document.createElementNS(SVG_NS, func);
                        feFunc.setAttribute("type", "discrete");
                        feFunc.setAttribute("tableValues", table);
                        feComponentTransfer.append(feFunc);
                    }
                    #addTransferMapConversion(rTable, gTable, bTable, filter) {
                        const feComponentTransfer = this.#document.createElementNS(SVG_NS, "feComponentTransfer");
                        filter.append(feComponentTransfer);
                        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
                    }
                    #getRGB(color) {
                        this.#defs.style.color = color;
                        return getRGB(getComputedStyle(this.#defs).getPropertyValue("color"));
                    }
                }
                exports.DOMFilterFactory = DOMFilterFactory;
                class DOMCanvasFactory extends _base_factory.BaseCanvasFactory {
                    constructor({ ownerDocument = globalThis.document } = {}){
                        super();
                        this._document = ownerDocument;
                    }
                    _createCanvas(width, height) {
                        const canvas = this._document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;
                        return canvas;
                    }
                }
                exports.DOMCanvasFactory = DOMCanvasFactory;
                async function fetchData(url, asTypedArray = false) {
                    if (isValidFetchUrl(url, document.baseURI)) {
                        const response = await fetch(url);
                        if (!response.ok) throw new Error(response.statusText);
                        return asTypedArray ? new Uint8Array(await response.arrayBuffer()) : (0, _util.stringToBytes)(await response.text());
                    }
                    return new Promise((resolve, reject)=>{
                        const request = new XMLHttpRequest();
                        request.open("GET", url, true);
                        if (asTypedArray) request.responseType = "arraybuffer";
                        request.onreadystatechange = ()=>{
                            if (request.readyState !== XMLHttpRequest.DONE) return;
                            if (request.status === 200 || request.status === 0) {
                                let data;
                                if (asTypedArray && request.response) data = new Uint8Array(request.response);
                                else if (!asTypedArray && request.responseText) data = (0, _util.stringToBytes)(request.responseText);
                                if (data) {
                                    resolve(data);
                                    return;
                                }
                            }
                            reject(new Error(request.statusText));
                        };
                        request.send(null);
                    });
                }
                class DOMCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url, this.isCompressed).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
                class DOMStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url, true);
                    }
                }
                exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
                class DOMSVGFactory extends _base_factory.BaseSVGFactory {
                    _createSVG(type) {
                        return document.createElementNS(SVG_NS, type);
                    }
                }
                exports.DOMSVGFactory = DOMSVGFactory;
                class PageViewport {
                    constructor({ viewBox, scale, rotation, offsetX = 0, offsetY = 0, dontFlip = false }){
                        this.viewBox = viewBox;
                        this.scale = scale;
                        this.rotation = rotation;
                        this.offsetX = offsetX;
                        this.offsetY = offsetY;
                        const centerX = (viewBox[2] + viewBox[0]) / 2;
                        const centerY = (viewBox[3] + viewBox[1]) / 2;
                        let rotateA, rotateB, rotateC, rotateD;
                        rotation %= 360;
                        if (rotation < 0) rotation += 360;
                        switch(rotation){
                            case 180:
                                rotateA = -1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = 1;
                                break;
                            case 90:
                                rotateA = 0;
                                rotateB = 1;
                                rotateC = 1;
                                rotateD = 0;
                                break;
                            case 270:
                                rotateA = 0;
                                rotateB = -1;
                                rotateC = -1;
                                rotateD = 0;
                                break;
                            case 0:
                                rotateA = 1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip) {
                            rotateC = -rotateC;
                            rotateD = -rotateD;
                        }
                        let offsetCanvasX, offsetCanvasY;
                        let width, height;
                        if (rotateA === 0) {
                            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                            width = (viewBox[3] - viewBox[1]) * scale;
                            height = (viewBox[2] - viewBox[0]) * scale;
                        } else {
                            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                            width = (viewBox[2] - viewBox[0]) * scale;
                            height = (viewBox[3] - viewBox[1]) * scale;
                        }
                        this.transform = [
                            rotateA * scale,
                            rotateB * scale,
                            rotateC * scale,
                            rotateD * scale,
                            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
                            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
                        ];
                        this.width = width;
                        this.height = height;
                    }
                    get rawDims() {
                        const { viewBox } = this;
                        return (0, _util.shadow)(this, "rawDims", {
                            pageWidth: viewBox[2] - viewBox[0],
                            pageHeight: viewBox[3] - viewBox[1],
                            pageX: viewBox[0],
                            pageY: viewBox[1]
                        });
                    }
                    clone({ scale = this.scale, rotation = this.rotation, offsetX = this.offsetX, offsetY = this.offsetY, dontFlip = false } = {}) {
                        return new PageViewport({
                            viewBox: this.viewBox.slice(),
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    convertToViewportPoint(x, y) {
                        return _util.Util.applyTransform([
                            x,
                            y
                        ], this.transform);
                    }
                    convertToViewportRectangle(rect) {
                        const topLeft = _util.Util.applyTransform([
                            rect[0],
                            rect[1]
                        ], this.transform);
                        const bottomRight = _util.Util.applyTransform([
                            rect[2],
                            rect[3]
                        ], this.transform);
                        return [
                            topLeft[0],
                            topLeft[1],
                            bottomRight[0],
                            bottomRight[1]
                        ];
                    }
                    convertToPdfPoint(x, y) {
                        return _util.Util.applyInverseTransform([
                            x,
                            y
                        ], this.transform);
                    }
                }
                exports.PageViewport = PageViewport;
                class RenderingCancelledException extends _util.BaseException {
                    constructor(msg, extraDelay = 0){
                        super(msg, "RenderingCancelledException");
                        this.extraDelay = extraDelay;
                    }
                }
                exports.RenderingCancelledException = RenderingCancelledException;
                function isDataScheme(url) {
                    const ii = url.length;
                    let i = 0;
                    while(i < ii && url[i].trim() === "")i++;
                    return url.substring(i, i + 5).toLowerCase() === "data:";
                }
                function isPdfFile(filename) {
                    return typeof filename === "string" && /\.pdf$/i.test(filename);
                }
                function getFilenameFromUrl(url, onlyStripPath = false) {
                    if (!onlyStripPath) [url] = url.split(/[#?]/, 1);
                    return url.substring(url.lastIndexOf("/") + 1);
                }
                function getPdfFilenameFromUrl(url, defaultFilename = "document.pdf") {
                    if (typeof url !== "string") return defaultFilename;
                    if (isDataScheme(url)) {
                        (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename;
                    }
                    const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    const splitURI = reURI.exec(url);
                    let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                    if (suggestedFilename) {
                        suggestedFilename = suggestedFilename[0];
                        if (suggestedFilename.includes("%")) try {
                            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                        } catch  {}
                    }
                    return suggestedFilename || defaultFilename;
                }
                class StatTimer {
                    started = Object.create(null);
                    times = [];
                    time(name) {
                        if (name in this.started) (0, _util.warn)(`Timer is already running for ${name}`);
                        this.started[name] = Date.now();
                    }
                    timeEnd(name) {
                        if (!(name in this.started)) (0, _util.warn)(`Timer has not been started for ${name}`);
                        this.times.push({
                            name: name,
                            start: this.started[name],
                            end: Date.now()
                        });
                        delete this.started[name];
                    }
                    toString() {
                        const outBuf = [];
                        let longest = 0;
                        for (const { name } of this.times)longest = Math.max(name.length, longest);
                        for (const { name, start, end } of this.times)outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
                        return outBuf.join("");
                    }
                }
                exports.StatTimer = StatTimer;
                function isValidFetchUrl(url, baseUrl) {
                    try {
                        const { protocol } = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        return protocol === "http:" || protocol === "https:";
                    } catch  {
                        return false;
                    }
                }
                function noContextMenu(e) {
                    e.preventDefault();
                }
                function loadScript(src, removeScriptElement = false) {
                    return new Promise((resolve, reject)=>{
                        const script = document.createElement("script");
                        script.src = src;
                        script.onload = function(evt) {
                            if (removeScriptElement) script.remove();
                            resolve(evt);
                        };
                        script.onerror = function() {
                            reject(new Error(`Cannot load script at: ${script.src}`));
                        };
                        (document.head || document.documentElement).append(script);
                    });
                }
                function deprecated(details) {
                    console.log("Deprecated API usage: " + details);
                }
                let pdfDateStringRegex;
                class PDFDateString {
                    static toDateObject(input) {
                        if (!input || typeof input !== "string") return null;
                        pdfDateStringRegex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                        const matches = pdfDateStringRegex.exec(input);
                        if (!matches) return null;
                        const year = parseInt(matches[1], 10);
                        let month = parseInt(matches[2], 10);
                        month = month >= 1 && month <= 12 ? month - 1 : 0;
                        let day = parseInt(matches[3], 10);
                        day = day >= 1 && day <= 31 ? day : 1;
                        let hour = parseInt(matches[4], 10);
                        hour = hour >= 0 && hour <= 23 ? hour : 0;
                        let minute = parseInt(matches[5], 10);
                        minute = minute >= 0 && minute <= 59 ? minute : 0;
                        let second = parseInt(matches[6], 10);
                        second = second >= 0 && second <= 59 ? second : 0;
                        const universalTimeRelation = matches[7] || "Z";
                        let offsetHour = parseInt(matches[8], 10);
                        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                        let offsetMinute = parseInt(matches[9], 10) || 0;
                        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                        if (universalTimeRelation === "-") {
                            hour += offsetHour;
                            minute += offsetMinute;
                        } else if (universalTimeRelation === "+") {
                            hour -= offsetHour;
                            minute -= offsetMinute;
                        }
                        return new Date(Date.UTC(year, month, day, hour, minute, second));
                    }
                }
                exports.PDFDateString = PDFDateString;
                function getXfaPageViewport(xfaPage, { scale = 1, rotation = 0 }) {
                    const { width, height } = xfaPage.attributes.style;
                    const viewBox = [
                        0,
                        0,
                        parseInt(width),
                        parseInt(height)
                    ];
                    return new PageViewport({
                        viewBox: viewBox,
                        scale: scale,
                        rotation: rotation
                    });
                }
                function getRGB(color) {
                    if (color.startsWith("#")) {
                        const colorRGB = parseInt(color.slice(1), 16);
                        return [
                            (colorRGB & 0xff0000) >> 16,
                            (colorRGB & 0x00ff00) >> 8,
                            colorRGB & 0x0000ff
                        ];
                    }
                    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
                    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map((x)=>parseInt(x)).slice(0, 3);
                    (0, _util.warn)(`Not a valid color format: "${color}"`);
                    return [
                        0,
                        0,
                        0
                    ];
                }
                function getColorValues(colors) {
                    const span = document.createElement("span");
                    span.style.visibility = "hidden";
                    document.body.append(span);
                    for (const name of colors.keys()){
                        span.style.color = name;
                        const computedColor = window.getComputedStyle(span).color;
                        colors.set(name, getRGB(computedColor));
                    }
                    span.remove();
                }
                function getCurrentTransform(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function getCurrentTransformInverse(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform().invertSelf();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function setLayerDimensions(div, viewport, mustFlip = false, mustRotate = true) {
                    if (viewport instanceof PageViewport) {
                        const { pageWidth, pageHeight } = viewport.rawDims;
                        const { style } = div;
                        const useRound = _util.FeatureTest.isCSSRoundSupported;
                        const w = `var(--scale-factor) * ${pageWidth}px`, h = `var(--scale-factor) * ${pageHeight}px`;
                        const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`, heightStr = useRound ? `round(${h}, 1px)` : `calc(${h})`;
                        if (!mustFlip || viewport.rotation % 180 === 0) {
                            style.width = widthStr;
                            style.height = heightStr;
                        } else {
                            style.width = heightStr;
                            style.height = widthStr;
                        }
                    }
                    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
                }
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseFilterFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
                var _util = __w_pdfjs_require__(1);
                class BaseFilterFactory {
                    constructor(){
                        if (this.constructor === BaseFilterFactory) (0, _util.unreachable)("Cannot initialize BaseFilterFactory.");
                    }
                    addFilter(maps) {
                        return "none";
                    }
                    addHCMFilter(fgColor, bgColor) {
                        return "none";
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        return "none";
                    }
                    destroy(keepHCM = false) {}
                }
                exports.BaseFilterFactory = BaseFilterFactory;
                class BaseCanvasFactory {
                    constructor(){
                        if (this.constructor === BaseCanvasFactory) (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    create(width, height) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        const canvas = this._createCanvas(width, height);
                        return {
                            canvas: canvas,
                            context: canvas.getContext("2d")
                        };
                    }
                    reset(canvasAndContext, width, height) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        canvasAndContext.canvas.width = width;
                        canvasAndContext.canvas.height = height;
                    }
                    destroy(canvasAndContext) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        canvasAndContext.canvas.width = 0;
                        canvasAndContext.canvas.height = 0;
                        canvasAndContext.canvas = null;
                        canvasAndContext.context = null;
                    }
                    _createCanvas(width, height) {
                        (0, _util.unreachable)("Abstract method `_createCanvas` called.");
                    }
                }
                exports.BaseCanvasFactory = BaseCanvasFactory;
                class BaseCMapReaderFactory {
                    constructor({ baseUrl = null, isCompressed = true }){
                        if (this.constructor === BaseCMapReaderFactory) (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl;
                        this.isCompressed = isCompressed;
                    }
                    async fetch({ name }) {
                        if (!this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                        if (!name) throw new Error("CMap name must be specified.");
                        const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                        const compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                        return this._fetchData(url, compressionType).catch((reason)=>{
                            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
                        });
                    }
                    _fetchData(url, compressionType) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
                class BaseStandardFontDataFactory {
                    constructor({ baseUrl = null }){
                        if (this.constructor === BaseStandardFontDataFactory) (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl;
                    }
                    async fetch({ filename }) {
                        if (!this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                        if (!filename) throw new Error("Font filename must be specified.");
                        const url = `${this.baseUrl}${filename}`;
                        return this._fetchData(url).catch((reason)=>{
                            throw new Error(`Unable to load font data at: ${url}`);
                        });
                    }
                    _fetchData(url) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
                class BaseSVGFactory {
                    constructor(){
                        if (this.constructor === BaseSVGFactory) (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    create(width, height, skipDimensions = false) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
                        const svg = this._createSVG("svg:svg");
                        svg.setAttribute("version", "1.1");
                        if (!skipDimensions) {
                            svg.setAttribute("width", `${width}px`);
                            svg.setAttribute("height", `${height}px`);
                        }
                        svg.setAttribute("preserveAspectRatio", "none");
                        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
                        return svg;
                    }
                    createElement(type) {
                        if (typeof type !== "string") throw new Error("Invalid SVG element type");
                        return this._createSVG(type);
                    }
                    _createSVG(type) {
                        (0, _util.unreachable)("Abstract method `_createSVG` called.");
                    }
                }
                exports.BaseSVGFactory = BaseSVGFactory;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(1);
                const SEED = 0xc3d2e1f0;
                const MASK_HIGH = 0xffff0000;
                const MASK_LOW = 0xffff;
                class MurmurHash3_64 {
                    constructor(seed){
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                    update(input) {
                        let data, length;
                        if (typeof input === "string") {
                            data = new Uint8Array(input.length * 2);
                            length = 0;
                            for(let i = 0, ii = input.length; i < ii; i++){
                                const code = input.charCodeAt(i);
                                if (code <= 0xff) data[length++] = code;
                                else {
                                    data[length++] = code >>> 8;
                                    data[length++] = code & 0xff;
                                }
                            }
                        } else if ((0, _util.isArrayBuffer)(input)) {
                            data = input.slice();
                            length = data.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts = length >> 2;
                        const tailLength = length - blockCounts * 4;
                        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                        let k1 = 0, k2 = 0;
                        let h1 = this.h1, h2 = this.h2;
                        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
                        const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                        for(let i = 0; i < blockCounts; i++)if (i & 1) {
                            k1 = dataUint32[i];
                            k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                            k1 = k1 << 15 | k1 >>> 17;
                            k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                            h1 ^= k1;
                            h1 = h1 << 13 | h1 >>> 19;
                            h1 = h1 * 5 + 0xe6546b64;
                        } else {
                            k2 = dataUint32[i];
                            k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                            k2 = k2 << 15 | k2 >>> 17;
                            k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                            h2 ^= k2;
                            h2 = h2 << 13 | h2 >>> 19;
                            h2 = h2 * 5 + 0xe6546b64;
                        }
                        k1 = 0;
                        switch(tailLength){
                            case 3:
                                k1 ^= data[blockCounts * 4 + 2] << 16;
                            case 2:
                                k1 ^= data[blockCounts * 4 + 1] << 8;
                            case 1:
                                k1 ^= data[blockCounts * 4];
                                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                k1 = k1 << 15 | k1 >>> 17;
                                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                if (blockCounts & 1) h1 ^= k1;
                                else h2 ^= k1;
                        }
                        this.h1 = h1;
                        this.h2 = h2;
                    }
                    hexdigest() {
                        let h1 = this.h1, h2 = this.h2;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                    }
                }
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontLoader = exports.FontFaceObject = void 0;
                var _util = __w_pdfjs_require__(1);
                class FontLoader {
                    #systemFonts = new Set();
                    constructor({ ownerDocument = globalThis.document, styleElement = null }){
                        this._document = ownerDocument;
                        this.nativeFontFaces = new Set();
                        this.styleElement = null;
                        this.loadingRequests = [];
                        this.loadTestFontId = 0;
                    }
                    addNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.add(nativeFontFace);
                        this._document.fonts.add(nativeFontFace);
                    }
                    removeNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.delete(nativeFontFace);
                        this._document.fonts.delete(nativeFontFace);
                    }
                    insertRule(rule) {
                        if (!this.styleElement) {
                            this.styleElement = this._document.createElement("style");
                            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                        }
                        const styleSheet = this.styleElement.sheet;
                        styleSheet.insertRule(rule, styleSheet.cssRules.length);
                    }
                    clear() {
                        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
                        this.nativeFontFaces.clear();
                        this.#systemFonts.clear();
                        if (this.styleElement) {
                            this.styleElement.remove();
                            this.styleElement = null;
                        }
                    }
                    async loadSystemFont(info) {
                        if (!info || this.#systemFonts.has(info.loadedName)) return;
                        (0, _util.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                        if (this.isFontLoadingAPISupported) {
                            const { loadedName, src, style } = info;
                            const fontFace = new FontFace(loadedName, src, style);
                            this.addNativeFontFace(fontFace);
                            try {
                                await fontFace.load();
                                this.#systemFonts.add(loadedName);
                            } catch  {
                                (0, _util.warn)(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                                this.removeNativeFontFace(fontFace);
                            }
                            return;
                        }
                        (0, _util.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                    }
                    async bind(font) {
                        if (font.attached || font.missingFile && !font.systemFontInfo) return;
                        font.attached = true;
                        if (font.systemFontInfo) {
                            await this.loadSystemFont(font.systemFontInfo);
                            return;
                        }
                        if (this.isFontLoadingAPISupported) {
                            const nativeFontFace = font.createNativeFontFace();
                            if (nativeFontFace) {
                                this.addNativeFontFace(nativeFontFace);
                                try {
                                    await nativeFontFace.loaded;
                                } catch (ex) {
                                    (0, _util.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                                    font.disableFontFace = true;
                                    throw ex;
                                }
                            }
                            return;
                        }
                        const rule = font.createFontFaceRule();
                        if (rule) {
                            this.insertRule(rule);
                            if (this.isSyncFontLoadingSupported) return;
                            await new Promise((resolve)=>{
                                const request = this._queueLoadingCallback(resolve);
                                this._prepareFontLoadEvent(font, request);
                            });
                        }
                    }
                    get isFontLoadingAPISupported() {
                        const hasFonts = !!this._document?.fonts;
                        return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                    }
                    get isSyncFontLoadingSupported() {
                        let supported = false;
                        if (_util.isNodeJS) supported = true;
                        else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) supported = true;
                        return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
                    }
                    _queueLoadingCallback(callback) {
                        function completeRequest() {
                            (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
                            request.done = true;
                            while(loadingRequests.length > 0 && loadingRequests[0].done){
                                const otherRequest = loadingRequests.shift();
                                setTimeout(otherRequest.callback, 0);
                            }
                        }
                        const { loadingRequests } = this;
                        const request = {
                            done: false,
                            complete: completeRequest,
                            callback: callback
                        };
                        loadingRequests.push(request);
                        return request;
                    }
                    get _loadTestFont() {
                        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                        return (0, _util.shadow)(this, "_loadTestFont", testFont);
                    }
                    _prepareFontLoadEvent(font, request) {
                        function int32(data, offset) {
                            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
                        }
                        function spliceString(s, offset, remove, insert) {
                            const chunk1 = s.substring(0, offset);
                            const chunk2 = s.substring(offset + remove);
                            return chunk1 + insert + chunk2;
                        }
                        let i, ii;
                        const canvas = this._document.createElement("canvas");
                        canvas.width = 1;
                        canvas.height = 1;
                        const ctx = canvas.getContext("2d");
                        let called = 0;
                        function isFontReady(name, callback) {
                            if (++called > 30) {
                                (0, _util.warn)("Load test font never loaded.");
                                callback();
                                return;
                            }
                            ctx.font = "30px " + name;
                            ctx.fillText(".", 0, 20);
                            const imageData = ctx.getImageData(0, 0, 1, 1);
                            if (imageData.data[3] > 0) {
                                callback();
                                return;
                            }
                            setTimeout(isFontReady.bind(null, name, callback));
                        }
                        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
                        let data = this._loadTestFont;
                        const COMMENT_OFFSET = 976;
                        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                        const CFF_CHECKSUM_OFFSET = 16;
                        const XXXX_VALUE = 0x58585858;
                        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
                        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
                        const url = `url(data:font/opentype;base64,${btoa(data)});`;
                        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
                        this.insertRule(rule);
                        const div = this._document.createElement("div");
                        div.style.visibility = "hidden";
                        div.style.width = div.style.height = "10px";
                        div.style.position = "absolute";
                        div.style.top = div.style.left = "0px";
                        for (const name of [
                            font.loadedName,
                            loadTestFontId
                        ]){
                            const span = this._document.createElement("span");
                            span.textContent = "Hi";
                            span.style.fontFamily = name;
                            div.append(span);
                        }
                        this._document.body.append(div);
                        isFontReady(loadTestFontId, ()=>{
                            div.remove();
                            request.complete();
                        });
                    }
                }
                exports.FontLoader = FontLoader;
                class FontFaceObject {
                    constructor(translatedData, { isEvalSupported = true, disableFontFace = false, ignoreErrors = false, inspectFont = null }){
                        this.compiledGlyphs = Object.create(null);
                        for(const i in translatedData)this[i] = translatedData[i];
                        this.isEvalSupported = isEvalSupported !== false;
                        this.disableFontFace = disableFontFace === true;
                        this.ignoreErrors = ignoreErrors === true;
                        this._inspectFont = inspectFont;
                    }
                    createNativeFontFace() {
                        if (!this.data || this.disableFontFace) return null;
                        let nativeFontFace;
                        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
                        else {
                            const css = {
                                weight: this.cssFontInfo.fontWeight
                            };
                            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                        }
                        this._inspectFont?.(this);
                        return nativeFontFace;
                    }
                    createFontFaceRule() {
                        if (!this.data || this.disableFontFace) return null;
                        const data = (0, _util.bytesToString)(this.data);
                        const url = `url(data:${this.mimetype};base64,${btoa(data)});`;
                        let rule;
                        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
                        else {
                            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
                            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
                        }
                        this._inspectFont?.(this, url);
                        return rule;
                    }
                    getPathGenerator(objs, character) {
                        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
                        let cmds;
                        try {
                            cmds = objs.get(this.loadedName + "_path_" + character);
                        } catch (ex) {
                            if (!this.ignoreErrors) throw ex;
                            (0, _util.warn)(`getPathGenerator - ignoring character: "${ex}".`);
                            return this.compiledGlyphs[character] = function(c, size) {};
                        }
                        if (this.isEvalSupported && _util.FeatureTest.isEvalSupported) {
                            const jsBuf = [];
                            for (const current of cmds){
                                const args = current.args !== undefined ? current.args.join(",") : "";
                                jsBuf.push("c.", current.cmd, "(", args, ");\n");
                            }
                            return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                        }
                        return this.compiledGlyphs[character] = function(c, size) {
                            for (const current of cmds){
                                if (current.cmd === "scale") current.args = [
                                    size,
                                    -size
                                ];
                                c[current.cmd].apply(c, current.args);
                            }
                        };
                    }
                }
                exports.FontFaceObject = FontFaceObject;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NodeStandardFontDataFactory = exports.NodeFilterFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const fetchData = function(url) {
                    return new Promise((resolve, reject)=>{
                        const fs = (parcelRequire("67wIF"));
                        fs.readFile(url, (error, data)=>{
                            if (error || !data) {
                                reject(new Error(error));
                                return;
                            }
                            resolve(new Uint8Array(data));
                        });
                    });
                };
                class NodeFilterFactory extends _base_factory.BaseFilterFactory {
                }
                exports.NodeFilterFactory = NodeFilterFactory;
                class NodeCanvasFactory extends _base_factory.BaseCanvasFactory {
                    _createCanvas(width, height) {
                        const Canvas = (parcelRequire("67wIF"));
                        return Canvas.createCanvas(width, height);
                    }
                }
                exports.NodeCanvasFactory = NodeCanvasFactory;
                class NodeCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
                class NodeStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url);
                    }
                }
                exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CanvasGraphics = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _pattern_helper = __w_pdfjs_require__(12);
                var _image_utils = __w_pdfjs_require__(13);
                const MIN_FONT_SIZE = 16;
                const MAX_FONT_SIZE = 100;
                const MAX_GROUP_SIZE = 4096;
                const EXECUTION_TIME = 15;
                const EXECUTION_STEPS = 10;
                const MAX_SIZE_TO_COMPILE = 1000;
                const FULL_CHUNK_HEIGHT = 16;
                function mirrorContextOperations(ctx, destCtx) {
                    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx.__originalSave = ctx.save;
                    ctx.__originalRestore = ctx.restore;
                    ctx.__originalRotate = ctx.rotate;
                    ctx.__originalScale = ctx.scale;
                    ctx.__originalTranslate = ctx.translate;
                    ctx.__originalTransform = ctx.transform;
                    ctx.__originalSetTransform = ctx.setTransform;
                    ctx.__originalResetTransform = ctx.resetTransform;
                    ctx.__originalClip = ctx.clip;
                    ctx.__originalMoveTo = ctx.moveTo;
                    ctx.__originalLineTo = ctx.lineTo;
                    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                    ctx.__originalRect = ctx.rect;
                    ctx.__originalClosePath = ctx.closePath;
                    ctx.__originalBeginPath = ctx.beginPath;
                    ctx._removeMirroring = ()=>{
                        ctx.save = ctx.__originalSave;
                        ctx.restore = ctx.__originalRestore;
                        ctx.rotate = ctx.__originalRotate;
                        ctx.scale = ctx.__originalScale;
                        ctx.translate = ctx.__originalTranslate;
                        ctx.transform = ctx.__originalTransform;
                        ctx.setTransform = ctx.__originalSetTransform;
                        ctx.resetTransform = ctx.__originalResetTransform;
                        ctx.clip = ctx.__originalClip;
                        ctx.moveTo = ctx.__originalMoveTo;
                        ctx.lineTo = ctx.__originalLineTo;
                        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                        ctx.rect = ctx.__originalRect;
                        ctx.closePath = ctx.__originalClosePath;
                        ctx.beginPath = ctx.__originalBeginPath;
                        delete ctx._removeMirroring;
                    };
                    ctx.save = function ctxSave() {
                        destCtx.save();
                        this.__originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        destCtx.restore();
                        this.__originalRestore();
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        destCtx.translate(x, y);
                        this.__originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        destCtx.scale(x, y);
                        this.__originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        destCtx.transform(a, b, c, d, e, f);
                        this.__originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        destCtx.setTransform(a, b, c, d, e, f);
                        this.__originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        destCtx.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        destCtx.rotate(angle);
                        this.__originalRotate(angle);
                    };
                    ctx.clip = function ctxRotate(rule) {
                        destCtx.clip(rule);
                        this.__originalClip(rule);
                    };
                    ctx.moveTo = function(x, y) {
                        destCtx.moveTo(x, y);
                        this.__originalMoveTo(x, y);
                    };
                    ctx.lineTo = function(x, y) {
                        destCtx.lineTo(x, y);
                        this.__originalLineTo(x, y);
                    };
                    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    };
                    ctx.rect = function(x, y, width, height) {
                        destCtx.rect(x, y, width, height);
                        this.__originalRect(x, y, width, height);
                    };
                    ctx.closePath = function() {
                        destCtx.closePath();
                        this.__originalClosePath();
                    };
                    ctx.beginPath = function() {
                        destCtx.beginPath();
                        this.__originalBeginPath();
                    };
                }
                class CachedCanvases {
                    constructor(canvasFactory){
                        this.canvasFactory = canvasFactory;
                        this.cache = Object.create(null);
                    }
                    getCanvas(id, width, height) {
                        let canvasEntry;
                        if (this.cache[id] !== undefined) {
                            canvasEntry = this.cache[id];
                            this.canvasFactory.reset(canvasEntry, width, height);
                        } else {
                            canvasEntry = this.canvasFactory.create(width, height);
                            this.cache[id] = canvasEntry;
                        }
                        return canvasEntry;
                    }
                    delete(id) {
                        delete this.cache[id];
                    }
                    clear() {
                        for(const id in this.cache){
                            const canvasEntry = this.cache[id];
                            this.canvasFactory.destroy(canvasEntry);
                            delete this.cache[id];
                        }
                    }
                }
                function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
                    const [a, b, c, d, tx, ty] = (0, _display_utils.getCurrentTransform)(ctx);
                    if (b === 0 && c === 0) {
                        const tlX = destX * a + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destY * d + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destX + destW) * a + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destY + destH) * d + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rWidth,
                            rHeight
                        ];
                    }
                    if (a === 0 && d === 0) {
                        const tlX = destY * c + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destX * b + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destY + destH) * c + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destX + destW) * b + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rHeight,
                            rWidth
                        ];
                    }
                    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
                    const scaleX = Math.hypot(a, b);
                    const scaleY = Math.hypot(c, d);
                    return [
                        scaleX * destW,
                        scaleY * destH
                    ];
                }
                function compileType3Glyph(imgData) {
                    const { width, height } = imgData;
                    if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) return null;
                    const POINT_TO_PROCESS_LIMIT = 1000;
                    const POINT_TYPES = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    const width1 = width + 1;
                    let points = new Uint8Array(width1 * (height + 1));
                    let i, j, j0;
                    const lineSize = width + 7 & -8;
                    let data = new Uint8Array(lineSize * height), pos = 0;
                    for (const elem of imgData.data){
                        let mask = 128;
                        while(mask > 0){
                            data[pos++] = elem & mask ? 0 : 255;
                            mask >>= 1;
                        }
                    }
                    let count = 0;
                    pos = 0;
                    if (data[pos] !== 0) {
                        points[0] = 1;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j] = data[pos] ? 2 : 1;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j] = 2;
                        ++count;
                    }
                    for(i = 1; i < height; i++){
                        pos = i * lineSize;
                        j0 = i * width1;
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0] = data[pos] ? 1 : 8;
                            ++count;
                        }
                        let sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
                        for(j = 1; j < width; j++){
                            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
                            if (POINT_TYPES[sum]) {
                                points[j0 + j] = POINT_TYPES[sum];
                                ++count;
                            }
                            pos++;
                        }
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0 + j] = data[pos] ? 2 : 4;
                            ++count;
                        }
                        if (count > POINT_TO_PROCESS_LIMIT) return null;
                    }
                    pos = lineSize * (height - 1);
                    j0 = i * width1;
                    if (data[pos] !== 0) {
                        points[j0] = 8;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j0 + j] = data[pos] ? 4 : 8;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j0 + j] = 4;
                        ++count;
                    }
                    if (count > POINT_TO_PROCESS_LIMIT) return null;
                    const steps = new Int32Array([
                        0,
                        width1,
                        -1,
                        0,
                        -width1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    const path = new Path2D();
                    for(i = 0; count && i <= height; i++){
                        let p = i * width1;
                        const end = p + width;
                        while(p < end && !points[p])p++;
                        if (p === end) continue;
                        path.moveTo(p % width1, i);
                        const p0 = p;
                        let type = points[p];
                        do {
                            const step = steps[type];
                            do p += step;
                            while (!points[p]);
                            const pp = points[p];
                            if (pp !== 5 && pp !== 10) {
                                type = pp;
                                points[p] = 0;
                            } else {
                                type = pp & 0x33 * type >> 4;
                                points[p] &= type >> 2 | type << 2;
                            }
                            path.lineTo(p % width1, p / width1 | 0);
                            if (!points[p]) --count;
                        }while (p0 !== p);
                        --i;
                    }
                    data = null;
                    points = null;
                    const drawOutline = function(c) {
                        c.save();
                        c.scale(1 / width, -1 / height);
                        c.translate(0, -height);
                        c.fill(path);
                        c.beginPath();
                        c.restore();
                    };
                    return drawOutline;
                }
                class CanvasExtraState {
                    constructor(width, height){
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = "none";
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width,
                            height
                        ]);
                    }
                    clone() {
                        const clone = Object.create(this);
                        clone.clipBox = this.clipBox.slice();
                        return clone;
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                    updatePathMinMax(transform, x, y) {
                        [x, y] = _util.Util.applyTransform([
                            x,
                            y
                        ], transform);
                        this.minX = Math.min(this.minX, x);
                        this.minY = Math.min(this.minY, y);
                        this.maxX = Math.max(this.maxX, x);
                        this.maxY = Math.max(this.maxY, y);
                    }
                    updateRectMinMax(transform, rect) {
                        const p1 = _util.Util.applyTransform(rect, transform);
                        const p2 = _util.Util.applyTransform(rect.slice(2), transform);
                        this.minX = Math.min(this.minX, p1[0], p2[0]);
                        this.minY = Math.min(this.minY, p1[1], p2[1]);
                        this.maxX = Math.max(this.maxX, p1[0], p2[0]);
                        this.maxY = Math.max(this.maxY, p1[1], p2[1]);
                    }
                    updateScalingPathMinMax(transform, minMax) {
                        _util.Util.scaleMinMax(transform, minMax);
                        this.minX = Math.min(this.minX, minMax[0]);
                        this.maxX = Math.max(this.maxX, minMax[1]);
                        this.minY = Math.min(this.minY, minMax[2]);
                        this.maxY = Math.max(this.maxY, minMax[3]);
                    }
                    updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
                        const box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                        if (minMax) {
                            minMax[0] = Math.min(minMax[0], box[0], box[2]);
                            minMax[1] = Math.max(minMax[1], box[0], box[2]);
                            minMax[2] = Math.min(minMax[2], box[1], box[3]);
                            minMax[3] = Math.max(minMax[3], box[1], box[3]);
                            return;
                        }
                        this.updateRectMinMax(transform, box);
                    }
                    getPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        const box = [
                            this.minX,
                            this.minY,
                            this.maxX,
                            this.maxY
                        ];
                        if (pathType === _pattern_helper.PathType.STROKE) {
                            if (!transform) (0, _util.unreachable)("Stroke bounding box must include transform.");
                            const scale = _util.Util.singularValueDecompose2dScale(transform);
                            const xStrokePad = scale[0] * this.lineWidth / 2;
                            const yStrokePad = scale[1] * this.lineWidth / 2;
                            box[0] -= xStrokePad;
                            box[1] -= yStrokePad;
                            box[2] += xStrokePad;
                            box[3] += yStrokePad;
                        }
                        return box;
                    }
                    updateClipFromPath() {
                        const intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
                        this.startNewPathAndClipBox(intersect || [
                            0,
                            0,
                            0,
                            0
                        ]);
                    }
                    isEmptyClip() {
                        return this.minX === Infinity;
                    }
                    startNewPathAndClipBox(box) {
                        this.clipBox = box;
                        this.minX = Infinity;
                        this.minY = Infinity;
                        this.maxX = 0;
                        this.maxY = 0;
                    }
                    getClippedPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                    }
                }
                function putBinaryImageData(ctx, imgData) {
                    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                        ctx.putImageData(imgData, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0, destPos;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    let i, j, thisChunkHeight, elemsInThisChunk;
                    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
                        const srcLength = src.byteLength;
                        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                        const dest32DataLength = dest32.length;
                        const fullSrcDiff = width + 7 >> 3;
                        const white = 0xffffffff;
                        const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                        for(i = 0; i < totalChunks; i++){
                            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                            destPos = 0;
                            for(j = 0; j < thisChunkHeight; j++){
                                const srcDiff = srcLength - srcPos;
                                let k = 0;
                                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                                const kEndUnrolled = kEnd & -8;
                                let mask = 0;
                                let srcByte = 0;
                                for(; k < kEndUnrolled; k += 8){
                                    srcByte = src[srcPos++];
                                    dest32[destPos++] = srcByte & 128 ? white : black;
                                    dest32[destPos++] = srcByte & 64 ? white : black;
                                    dest32[destPos++] = srcByte & 32 ? white : black;
                                    dest32[destPos++] = srcByte & 16 ? white : black;
                                    dest32[destPos++] = srcByte & 8 ? white : black;
                                    dest32[destPos++] = srcByte & 4 ? white : black;
                                    dest32[destPos++] = srcByte & 2 ? white : black;
                                    dest32[destPos++] = srcByte & 1 ? white : black;
                                }
                                for(; k < kEnd; k++){
                                    if (mask === 0) {
                                        srcByte = src[srcPos++];
                                        mask = 128;
                                    }
                                    dest32[destPos++] = srcByte & mask ? white : black;
                                    mask >>= 1;
                                }
                            }
                            while(destPos < dest32DataLength)dest32[destPos++] = 0;
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
                        j = 0;
                        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                        for(i = 0; i < fullChunks; i++){
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            srcPos += elemsInThisChunk;
                            ctx.putImageData(chunkImgData, 0, j);
                            j += FULL_CHUNK_HEIGHT;
                        }
                        if (i < totalChunks) {
                            elemsInThisChunk = width * partialChunkHeight * 4;
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            ctx.putImageData(chunkImgData, 0, j);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
                        thisChunkHeight = FULL_CHUNK_HEIGHT;
                        elemsInThisChunk = width * thisChunkHeight;
                        for(i = 0; i < totalChunks; i++){
                            if (i >= fullChunks) {
                                thisChunkHeight = partialChunkHeight;
                                elemsInThisChunk = width * thisChunkHeight;
                            }
                            destPos = 0;
                            for(j = elemsInThisChunk; j--;){
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = 255;
                            }
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else throw new Error(`bad image kind: ${imgData.kind}`);
                }
                function putBinaryImageMask(ctx, imgData) {
                    if (imgData.bitmap) {
                        ctx.drawImage(imgData.bitmap, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    for(let i = 0; i < totalChunks; i++){
                        const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                        ({ srcPos } = (0, _image_utils.convertBlackAndWhiteToRGBA)({
                            src: src,
                            srcPos: srcPos,
                            dest: dest,
                            width: width,
                            height: thisChunkHeight,
                            nonBlackColor: 0
                        }));
                        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                    }
                }
                function copyCtxState(sourceCtx, destCtx) {
                    const properties = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font",
                        "filter"
                    ];
                    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
                    if (sourceCtx.setLineDash !== undefined) {
                        destCtx.setLineDash(sourceCtx.getLineDash());
                        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                    }
                }
                function resetCtxToDefault(ctx) {
                    ctx.strokeStyle = ctx.fillStyle = "#000000";
                    ctx.fillRule = "nonzero";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = 1;
                    ctx.lineCap = "butt";
                    ctx.lineJoin = "miter";
                    ctx.miterLimit = 10;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.font = "10px sans-serif";
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                        ctx.lineDashOffset = 0;
                    }
                    if (!_util.isNodeJS) {
                        const { filter } = ctx;
                        if (filter !== "none" && filter !== "") ctx.filter = "none";
                    }
                }
                function composeSMaskBackdrop(bytes, r0, g0, b0) {
                    const length = bytes.length;
                    for(let i = 3; i < length; i += 4){
                        const alpha = bytes[i];
                        if (alpha === 0) {
                            bytes[i - 3] = r0;
                            bytes[i - 2] = g0;
                            bytes[i - 1] = b0;
                        } else if (alpha < 255) {
                            const alpha_ = 255 - alpha;
                            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                        }
                    }
                }
                function composeSMaskAlpha(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    const scale = 1 / 255;
                    for(let i = 3; i < length; i += 4){
                        const alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                        layerData[i] = layerData[i] * alpha * scale | 0;
                    }
                }
                function composeSMaskLuminosity(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    for(let i = 3; i < length; i += 4){
                        const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                        layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                    }
                }
                function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                    const hasBackdrop = !!backdrop;
                    const r0 = hasBackdrop ? backdrop[0] : 0;
                    const g0 = hasBackdrop ? backdrop[1] : 0;
                    const b0 = hasBackdrop ? backdrop[2] : 0;
                    const composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
                    const PIXELS_TO_PROCESS = 1048576;
                    const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                    for(let row = 0; row < height; row += chunkSize){
                        const chunkHeight = Math.min(chunkSize, height - row);
                        const maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                        const layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                        if (hasBackdrop) composeSMaskBackdrop(maskData.data, r0, g0, b0);
                        composeFn(maskData.data, layerData.data, transferMap);
                        layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                    }
                }
                function composeSMask(ctx, smask, layerCtx, layerBox) {
                    const layerOffsetX = layerBox[0];
                    const layerOffsetY = layerBox[1];
                    const layerWidth = layerBox[2] - layerOffsetX;
                    const layerHeight = layerBox[3] - layerOffsetY;
                    if (layerWidth === 0 || layerHeight === 0) return;
                    genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                    ctx.save();
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.drawImage(layerCtx.canvas, 0, 0);
                    ctx.restore();
                }
                function getImageSmoothingEnabled(transform, interpolate) {
                    const scale = _util.Util.singularValueDecompose2dScale(transform);
                    scale[0] = Math.fround(scale[0]);
                    scale[1] = Math.fround(scale[1]);
                    const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate !== undefined) return interpolate;
                    else if (scale[0] <= actualScale || scale[1] <= actualScale) return true;
                    return false;
                }
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const NORMAL_CLIP = {};
                const EO_CLIP = {};
                class CanvasGraphics {
                    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig, markedContentStack = null }, annotationCanvasMap, pageColors){
                        this.ctx = canvasCtx;
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = markedContentStack || [];
                        this.optionalContentConfig = optionalContentConfig;
                        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        this.pageColors = pageColors;
                        this._cachedScaleForStroking = [
                            -1,
                            0
                        ];
                        this._cachedGetSinglePixelWidth = null;
                        this._cachedBitmapsMap = new Map();
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    beginDrawing({ transform, viewport, transparency = false, background = null }) {
                        const width = this.ctx.canvas.width;
                        const height = this.ctx.canvas.height;
                        const savedFillStyle = this.ctx.fillStyle;
                        this.ctx.fillStyle = background || "#ffffff";
                        this.ctx.fillRect(0, 0, width, height);
                        this.ctx.fillStyle = savedFillStyle;
                        if (transparency) {
                            const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
                            this.compositeCtx = this.ctx;
                            this.transparentCanvas = transparentCanvas.canvas;
                            this.ctx = transparentCanvas.context;
                            this.ctx.save();
                            this.ctx.transform(...(0, _display_utils.getCurrentTransform)(this.compositeCtx));
                        }
                        this.ctx.save();
                        resetCtxToDefault(this.ctx);
                        if (transform) {
                            this.ctx.transform(...transform);
                            this.outputScaleX = transform[0];
                            this.outputScaleY = transform[0];
                        }
                        this.ctx.transform(...viewport.transform);
                        this.viewportScale = viewport.scale;
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                    }
                    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        let i = executionStartIdx || 0;
                        const argsArrayLen = argsArray.length;
                        if (argsArrayLen === i) return i;
                        const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                        const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                        let steps = 0;
                        const commonObjs = this.commonObjs;
                        const objs = this.objs;
                        let fnId;
                        while(true){
                            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                                stepper.breakIt(i, continueCallback);
                                return i;
                            }
                            fnId = fnArray[i];
                            if (fnId !== _util.OPS.dependency) this[fnId].apply(this, argsArray[i]);
                            else for (const depObjId of argsArray[i]){
                                const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                                if (!objsPool.has(depObjId)) {
                                    objsPool.get(depObjId, continueCallback);
                                    return i;
                                }
                            }
                            i++;
                            if (i === argsArrayLen) return i;
                            if (chunkOperations && ++steps > EXECUTION_STEPS) {
                                if (Date.now() > endTime) {
                                    continueCallback();
                                    return i;
                                }
                                steps = 0;
                            }
                        }
                    }
                    #restoreInitialState() {
                        while(this.stateStack.length || this.inSMaskMode)this.restore();
                        this.ctx.restore();
                        if (this.transparentCanvas) {
                            this.ctx = this.compositeCtx;
                            this.ctx.save();
                            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                            this.ctx.drawImage(this.transparentCanvas, 0, 0);
                            this.ctx.restore();
                            this.transparentCanvas = null;
                        }
                    }
                    endDrawing() {
                        this.#restoreInitialState();
                        this.cachedCanvases.clear();
                        this.cachedPatterns.clear();
                        for (const cache of this._cachedBitmapsMap.values()){
                            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
                            cache.clear();
                        }
                        this._cachedBitmapsMap.clear();
                        this.#drawFilter();
                    }
                    #drawFilter() {
                        if (this.pageColors) {
                            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                            if (hcmFilterId !== "none") {
                                const savedFilter = this.ctx.filter;
                                this.ctx.filter = hcmFilterId;
                                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                                this.ctx.filter = savedFilter;
                            }
                        }
                    }
                    _scaleImage(img, inverseTransform) {
                        const width = img.width;
                        const height = img.height;
                        let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                        let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                        let paintWidth = width, paintHeight = height;
                        let tmpCanvasId = "prescale1";
                        let tmpCanvas, tmpCtx;
                        while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
                            let newWidth = paintWidth, newHeight = paintHeight;
                            if (widthScale > 2 && paintWidth > 1) {
                                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                                widthScale /= paintWidth / newWidth;
                            }
                            if (heightScale > 2 && paintHeight > 1) {
                                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                                heightScale /= paintHeight / newHeight;
                            }
                            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                            tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, newWidth, newHeight);
                            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                            img = tmpCanvas.canvas;
                            paintWidth = newWidth;
                            paintHeight = newHeight;
                            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                        }
                        return {
                            img: img,
                            paintWidth: paintWidth,
                            paintHeight: paintHeight
                        };
                    }
                    _createMaskCanvas(img) {
                        const ctx = this.ctx;
                        const { width, height } = img;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        let cache, cacheKey, scaled, maskCanvas;
                        if ((img.bitmap || img.data) && img.count > 1) {
                            const mainKey = img.bitmap || img.data.buffer;
                            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                                currentTransform.slice(0, 4),
                                fillColor
                            ]);
                            cache = this._cachedBitmapsMap.get(mainKey);
                            if (!cache) {
                                cache = new Map();
                                this._cachedBitmapsMap.set(mainKey, cache);
                            }
                            const cachedImage = cache.get(cacheKey);
                            if (cachedImage && !isPatternFill) {
                                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                                return {
                                    canvas: cachedImage,
                                    offsetX: offsetX,
                                    offsetY: offsetY
                                };
                            }
                            scaled = cachedImage;
                        }
                        if (!scaled) {
                            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            putBinaryImageMask(maskCanvas.context, img);
                        }
                        let maskToCanvas = _util.Util.transform(currentTransform, [
                            1 / width,
                            0,
                            0,
                            -1 / height,
                            0,
                            0
                        ]);
                        maskToCanvas = _util.Util.transform(maskToCanvas, [
                            1,
                            0,
                            0,
                            1,
                            0,
                            -height
                        ]);
                        const cord1 = _util.Util.applyTransform([
                            0,
                            0
                        ], maskToCanvas);
                        const cord2 = _util.Util.applyTransform([
                            width,
                            height
                        ], maskToCanvas);
                        const rect = _util.Util.normalizeRect([
                            cord1[0],
                            cord1[1],
                            cord2[0],
                            cord2[1]
                        ]);
                        const drawnWidth = Math.round(rect[2] - rect[0]) || 1;
                        const drawnHeight = Math.round(rect[3] - rect[1]) || 1;
                        const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
                        const fillCtx = fillCanvas.context;
                        const offsetX = Math.min(cord1[0], cord2[0]);
                        const offsetY = Math.min(cord1[1], cord2[1]);
                        fillCtx.translate(-offsetX, -offsetY);
                        fillCtx.transform(...maskToCanvas);
                        if (!scaled) {
                            scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils.getCurrentTransformInverse)(fillCtx));
                            scaled = scaled.img;
                            if (cache && isPatternFill) cache.set(cacheKey, scaled);
                        }
                        fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(fillCtx), img.interpolate);
                        drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
                        fillCtx.globalCompositeOperation = "source-in";
                        const inverse = _util.Util.transform((0, _display_utils.getCurrentTransformInverse)(fillCtx), [
                            1,
                            0,
                            0,
                            1,
                            -offsetX,
                            -offsetY
                        ]);
                        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                        fillCtx.fillRect(0, 0, width, height);
                        if (cache && !isPatternFill) {
                            this.cachedCanvases.delete("fillCanvas");
                            cache.set(cacheKey, fillCanvas.canvas);
                        }
                        return {
                            canvas: fillCanvas.canvas,
                            offsetX: Math.round(offsetX),
                            offsetY: Math.round(offsetY)
                        };
                    }
                    setLineWidth(width) {
                        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
                        this.current.lineWidth = width;
                        this.ctx.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.ctx.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.ctx.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.ctx.miterLimit = limit;
                    }
                    setDash(dashArray, dashPhase) {
                        const ctx = this.ctx;
                        if (ctx.setLineDash !== undefined) {
                            ctx.setLineDash(dashArray);
                            ctx.lineDashOffset = dashPhase;
                        }
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value[0], value[1]);
                                break;
                            case "CA":
                                this.current.strokeAlpha = value;
                                break;
                            case "ca":
                                this.current.fillAlpha = value;
                                this.ctx.globalAlpha = value;
                                break;
                            case "BM":
                                this.ctx.globalCompositeOperation = value;
                                break;
                            case "SMask":
                                this.current.activeSMask = value ? this.tempSMask : null;
                                this.tempSMask = null;
                                this.checkSMaskState();
                                break;
                            case "TR":
                                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                                break;
                        }
                    }
                    get inSMaskMode() {
                        return !!this.suspendedCtx;
                    }
                    checkSMaskState() {
                        const inSMaskMode = this.inSMaskMode;
                        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
                        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
                    }
                    beginSMaskMode() {
                        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
                        const drawnWidth = this.ctx.canvas.width;
                        const drawnHeight = this.ctx.canvas.height;
                        const cacheId = "smaskGroupAt" + this.groupLevel;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        this.suspendedCtx = this.ctx;
                        this.ctx = scratchCanvas.context;
                        const ctx = this.ctx;
                        ctx.setTransform(...(0, _display_utils.getCurrentTransform)(this.suspendedCtx));
                        copyCtxState(this.suspendedCtx, ctx);
                        mirrorContextOperations(ctx, this.suspendedCtx);
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                    }
                    endSMaskMode() {
                        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
                        this.ctx._removeMirroring();
                        copyCtxState(this.ctx, this.suspendedCtx);
                        this.ctx = this.suspendedCtx;
                        this.suspendedCtx = null;
                    }
                    compose(dirtyBox) {
                        if (!this.current.activeSMask) return;
                        if (!dirtyBox) dirtyBox = [
                            0,
                            0,
                            this.ctx.canvas.width,
                            this.ctx.canvas.height
                        ];
                        else {
                            dirtyBox[0] = Math.floor(dirtyBox[0]);
                            dirtyBox[1] = Math.floor(dirtyBox[1]);
                            dirtyBox[2] = Math.ceil(dirtyBox[2]);
                            dirtyBox[3] = Math.ceil(dirtyBox[3]);
                        }
                        const smask = this.current.activeSMask;
                        const suspendedCtx = this.suspendedCtx;
                        composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                        this.ctx.save();
                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                        this.ctx.restore();
                    }
                    save() {
                        if (this.inSMaskMode) {
                            copyCtxState(this.ctx, this.suspendedCtx);
                            this.suspendedCtx.save();
                        } else this.ctx.save();
                        const old = this.current;
                        this.stateStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        if (this.stateStack.length === 0 && this.inSMaskMode) this.endSMaskMode();
                        if (this.stateStack.length !== 0) {
                            this.current = this.stateStack.pop();
                            if (this.inSMaskMode) {
                                this.suspendedCtx.restore();
                                copyCtxState(this.suspendedCtx, this.ctx);
                            } else this.ctx.restore();
                            this.checkSMaskState();
                            this.pendingClip = null;
                            this._cachedScaleForStroking[0] = -1;
                            this._cachedGetSinglePixelWidth = null;
                        }
                    }
                    transform(a, b, c, d, e, f) {
                        this.ctx.transform(a, b, c, d, e, f);
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                    }
                    constructPath(ops, args, minMax) {
                        const ctx = this.ctx;
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let startX, startY;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
                        const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
                        for(let i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                ctx.moveTo(x, y);
                                if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                                else {
                                    ctx.lineTo(xw, y);
                                    ctx.lineTo(xw, yh);
                                    ctx.lineTo(x, yh);
                                }
                                if (!isScalingMatrix) current.updateRectMinMax(currentTransform, [
                                    x,
                                    y,
                                    xw,
                                    yh
                                ]);
                                ctx.closePath();
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.moveTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.lineTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.curveTo:
                                startX = x;
                                startY = y;
                                x = args[j + 4];
                                y = args[j + 5];
                                ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                startX = x;
                                startY = y;
                                ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                startX = x;
                                startY = y;
                                x = args[j + 2];
                                y = args[j + 3];
                                ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                ctx.closePath();
                                break;
                        }
                        if (isScalingMatrix) current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
                        current.setCurrentPoint(x, y);
                    }
                    closePath() {
                        this.ctx.closePath();
                    }
                    stroke(consumePath = true) {
                        const ctx = this.ctx;
                        const strokeColor = this.current.strokeColor;
                        ctx.globalAlpha = this.current.strokeAlpha;
                        if (this.contentVisible) {
                            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                                ctx.save();
                                ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
                                this.rescaleAndStroke(false);
                                ctx.restore();
                            } else this.rescaleAndStroke(true);
                        }
                        if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
                        ctx.globalAlpha = this.current.fillAlpha;
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    fill(consumePath = true) {
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        let needRestore = false;
                        if (isPatternFill) {
                            ctx.save();
                            ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            needRestore = true;
                        }
                        const intersect = this.current.getClippedPathBoundingBox();
                        if (this.contentVisible && intersect !== null) {
                            if (this.pendingEOFill) {
                                ctx.fill("evenodd");
                                this.pendingEOFill = false;
                            } else ctx.fill();
                        }
                        if (needRestore) ctx.restore();
                        if (consumePath) this.consumePath(intersect);
                    }
                    eoFill() {
                        this.pendingEOFill = true;
                        this.fill();
                    }
                    fillStroke() {
                        this.fill(false);
                        this.stroke(false);
                        this.consumePath();
                    }
                    eoFillStroke() {
                        this.pendingEOFill = true;
                        this.fillStroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.pendingEOFill = true;
                        this.closePath();
                        this.fillStroke();
                    }
                    endPath() {
                        this.consumePath();
                    }
                    clip() {
                        this.pendingClip = NORMAL_CLIP;
                    }
                    eoClip() {
                        this.pendingClip = EO_CLIP;
                    }
                    beginText() {
                        this.current.textMatrix = _util.IDENTITY_MATRIX;
                        this.current.textMatrixScale = 1;
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    endText() {
                        const paths = this.pendingTextPaths;
                        const ctx = this.ctx;
                        if (paths === undefined) {
                            ctx.beginPath();
                            return;
                        }
                        ctx.save();
                        ctx.beginPath();
                        for (const path of paths){
                            ctx.setTransform(...path.transform);
                            ctx.translate(path.x, path.y);
                            path.addToPath(ctx, path.fontSize);
                        }
                        ctx.restore();
                        ctx.clip();
                        ctx.beginPath();
                        delete this.pendingTextPaths;
                    }
                    setCharSpacing(spacing) {
                        this.current.charSpacing = spacing;
                    }
                    setWordSpacing(spacing) {
                        this.current.wordSpacing = spacing;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setFont(fontRefName, size) {
                        const fontObj = this.commonObjs.get(fontRefName);
                        const current = this.current;
                        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) (0, _util.warn)("Invalid font matrix for font " + fontRefName);
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        this.current.font = fontObj;
                        this.current.fontSize = size;
                        if (fontObj.isType3Font) return;
                        const name = fontObj.loadedName || "sans-serif";
                        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        let browserFontSize = size;
                        if (size < MIN_FONT_SIZE) browserFontSize = MIN_FONT_SIZE;
                        else if (size > MAX_FONT_SIZE) browserFontSize = MAX_FONT_SIZE;
                        this.current.fontSizeScale = size / browserFontSize;
                        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
                    }
                    setTextRenderingMode(mode) {
                        this.current.textRenderingMode = mode;
                    }
                    setTextRise(rise) {
                        this.current.textRise = rise;
                    }
                    moveText(x, y) {
                        this.current.x = this.current.lineX += x;
                        this.current.y = this.current.lineY += y;
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        this.current.textMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.current.textMatrixScale = Math.hypot(a, b);
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    paintChar(character, x, y, patternTransform) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const textRenderingMode = current.textRenderingMode;
                        const fontSize = current.fontSize / current.fontSizeScale;
                        const fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        const isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                        const patternFill = current.patternFill && !font.missingFile;
                        let addToPath;
                        if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
                        if (font.disableFontFace || patternFill) {
                            ctx.save();
                            ctx.translate(x, y);
                            ctx.beginPath();
                            addToPath(ctx, fontSize);
                            if (patternTransform) ctx.setTransform(...patternTransform);
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fill();
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.stroke();
                            ctx.restore();
                        } else {
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.strokeText(character, x, y);
                        }
                        if (isAddToPathSet) {
                            const paths = this.pendingTextPaths ||= [];
                            paths.push({
                                transform: (0, _display_utils.getCurrentTransform)(ctx),
                                x: x,
                                y: y,
                                fontSize: fontSize,
                                addToPath: addToPath
                            });
                        }
                    }
                    get isFontSubpixelAAEnabled() {
                        const { context: ctx } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                        ctx.scale(1.5, 1);
                        ctx.fillText("I", 0, 10);
                        const data = ctx.getImageData(0, 0, 10, 10).data;
                        let enabled = false;
                        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
                            enabled = true;
                            break;
                        }
                        return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        if (font.isType3Font) return this.showType3Text(glyphs);
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return undefined;
                        const ctx = this.ctx;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const glyphsLength = glyphs.length;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        const simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y + current.textRise);
                        if (fontDirection > 0) ctx.scale(textHScale, -1);
                        else ctx.scale(textHScale, 1);
                        let patternTransform;
                        if (current.patternFill) {
                            ctx.save();
                            const pattern = current.fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            patternTransform = (0, _display_utils.getCurrentTransform)(ctx);
                            ctx.restore();
                            ctx.fillStyle = pattern;
                        }
                        let lineWidth = current.lineWidth;
                        const scale = current.textMatrixScale;
                        if (scale === 0 || lineWidth === 0) {
                            const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
                        } else lineWidth /= scale;
                        if (fontSizeScale !== 1.0) {
                            ctx.scale(fontSizeScale, fontSizeScale);
                            lineWidth /= fontSizeScale;
                        }
                        ctx.lineWidth = lineWidth;
                        if (font.isInvalidPDFjsFont) {
                            const chars = [];
                            let width = 0;
                            for (const glyph of glyphs){
                                chars.push(glyph.unicode);
                                width += glyph.width;
                            }
                            ctx.fillText(chars.join(""), 0, 0);
                            current.x += width * widthAdvanceScale * textHScale;
                            ctx.restore();
                            this.compose();
                            return undefined;
                        }
                        let x = 0, i;
                        for(i = 0; i < glyphsLength; ++i){
                            const glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            let restoreNeeded = false;
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            const accent = glyph.accent;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (font.remeasure && width > 0) {
                                const measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                                    const characterScaleX = width / measuredWidth;
                                    restoreNeeded = true;
                                    ctx.save();
                                    ctx.scale(characterScaleX, 1);
                                    scaledX /= characterScaleX;
                                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                            }
                            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                                if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                                else {
                                    this.paintChar(character, scaledX, scaledY, patternTransform);
                                    if (accent) {
                                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                                    }
                                }
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                            if (restoreNeeded) ctx.restore();
                        }
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        ctx.restore();
                        this.compose();
                        return undefined;
                    }
                    showType3Text(glyphs) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        const fontDirection = current.fontDirection;
                        const spacingDir = font.vertical ? 1 : -1;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const textHScale = current.textHScale * fontDirection;
                        const fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        const glyphsLength = glyphs.length;
                        const isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
                        let i, glyph, width, spacingLength;
                        if (isTextInvisible || fontSize === 0) return;
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y);
                        ctx.scale(textHScale, fontDirection);
                        for(i = 0; i < glyphsLength; ++i){
                            glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                spacingLength = spacingDir * glyph * fontSize / 1000;
                                this.ctx.translate(spacingLength, 0);
                                current.x += spacingLength * textHScale;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const operatorList = font.charProcOperatorList[glyph.operatorListId];
                            if (!operatorList) {
                                (0, _util.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
                                continue;
                            }
                            if (this.contentVisible) {
                                this.processingType3 = glyph;
                                this.save();
                                ctx.scale(fontSize, fontSize);
                                ctx.transform(...fontMatrix);
                                this.executeOperatorList(operatorList);
                                this.restore();
                            }
                            const transformed = _util.Util.applyTransform([
                                glyph.width,
                                0
                            ], fontMatrix);
                            width = transformed[0] * fontSize + spacing;
                            ctx.translate(width, 0);
                            current.x += width * textHScale;
                        }
                        ctx.restore();
                        this.processingType3 = null;
                    }
                    setCharWidth(xWidth, yWidth) {}
                    setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                        this.ctx.rect(llx, lly, urx - llx, ury - lly);
                        this.ctx.clip();
                        this.endPath();
                    }
                    getColorN_Pattern(IR) {
                        let pattern;
                        if (IR[0] === "TilingPattern") {
                            const color = IR[1];
                            const baseTransform = this.baseTransform || (0, _display_utils.getCurrentTransform)(this.ctx);
                            const canvasGraphicsFactory = {
                                createCanvasGraphics: (ctx)=>{
                                    return new CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                                        optionalContentConfig: this.optionalContentConfig,
                                        markedContentStack: this.markedContentStack
                                    });
                                }
                            };
                            pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                        } else pattern = this._getPattern(IR[1], IR[2]);
                        return pattern;
                    }
                    setStrokeColorN() {
                        this.current.strokeColor = this.getColorN_Pattern(arguments);
                    }
                    setFillColorN() {
                        this.current.fillColor = this.getColorN_Pattern(arguments);
                        this.current.patternFill = true;
                    }
                    setStrokeRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.strokeStyle = color;
                        this.current.strokeColor = color;
                    }
                    setFillRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.fillStyle = color;
                        this.current.fillColor = color;
                        this.current.patternFill = false;
                    }
                    _getPattern(objId, matrix = null) {
                        let pattern;
                        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
                        else {
                            pattern = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
                            this.cachedPatterns.set(objId, pattern);
                        }
                        if (matrix) pattern.matrix = matrix;
                        return pattern;
                    }
                    shadingFill(objId) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        this.save();
                        const pattern = this._getPattern(objId);
                        ctx.fillStyle = pattern.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
                        const inv = (0, _display_utils.getCurrentTransformInverse)(ctx);
                        if (inv) {
                            const { width, height } = ctx.canvas;
                            const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                width,
                                height
                            ], inv);
                            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                        this.compose(this.current.getClippedPathBoundingBox());
                        this.restore();
                    }
                    beginInlineImage() {
                        (0, _util.unreachable)("Should not call beginInlineImage");
                    }
                    beginImageData() {
                        (0, _util.unreachable)("Should not call beginImageData");
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (!this.contentVisible) return;
                        this.save();
                        this.baseTransformStack.push(this.baseTransform);
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(...matrix);
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            this.ctx.rect(bbox[0], bbox[1], width, height);
                            this.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(this.ctx), bbox);
                            this.clip();
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {
                        if (!this.contentVisible) return;
                        this.restore();
                        this.baseTransform = this.baseTransformStack.pop();
                    }
                    beginGroup(group) {
                        if (!this.contentVisible) return;
                        this.save();
                        if (this.inSMaskMode) {
                            this.endSMaskMode();
                            this.current.activeSMask = null;
                        }
                        const currentCtx = this.ctx;
                        if (!group.isolated) (0, _util.info)("TODO: Support non-isolated groups.");
                        if (group.knockout) (0, _util.warn)("Knockout groups not supported.");
                        const currentTransform = (0, _display_utils.getCurrentTransform)(currentCtx);
                        if (group.matrix) currentCtx.transform(...group.matrix);
                        if (!group.bbox) throw new Error("Bounding box is required.");
                        let bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils.getCurrentTransform)(currentCtx));
                        const canvasBounds = [
                            0,
                            0,
                            currentCtx.canvas.width,
                            currentCtx.canvas.height
                        ];
                        bounds = _util.Util.intersect(bounds, canvasBounds) || [
                            0,
                            0,
                            0,
                            0
                        ];
                        const offsetX = Math.floor(bounds[0]);
                        const offsetY = Math.floor(bounds[1]);
                        let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                        let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                        let scaleX = 1, scaleY = 1;
                        if (drawnWidth > MAX_GROUP_SIZE) {
                            scaleX = drawnWidth / MAX_GROUP_SIZE;
                            drawnWidth = MAX_GROUP_SIZE;
                        }
                        if (drawnHeight > MAX_GROUP_SIZE) {
                            scaleY = drawnHeight / MAX_GROUP_SIZE;
                            drawnHeight = MAX_GROUP_SIZE;
                        }
                        this.current.startNewPathAndClipBox([
                            0,
                            0,
                            drawnWidth,
                            drawnHeight
                        ]);
                        let cacheId = "groupAt" + this.groupLevel;
                        if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        const groupCtx = scratchCanvas.context;
                        groupCtx.scale(1 / scaleX, 1 / scaleY);
                        groupCtx.translate(-offsetX, -offsetY);
                        groupCtx.transform(...currentTransform);
                        if (group.smask) this.smaskStack.push({
                            canvas: scratchCanvas.canvas,
                            context: groupCtx,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            scaleX: scaleX,
                            scaleY: scaleY,
                            subtype: group.smask.subtype,
                            backdrop: group.smask.backdrop,
                            transferMap: group.smask.transferMap || null,
                            startTransformInverse: null
                        });
                        else {
                            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                            currentCtx.translate(offsetX, offsetY);
                            currentCtx.scale(scaleX, scaleY);
                            currentCtx.save();
                        }
                        copyCtxState(currentCtx, groupCtx);
                        this.ctx = groupCtx;
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                        this.groupStack.push(currentCtx);
                        this.groupLevel++;
                    }
                    endGroup(group) {
                        if (!this.contentVisible) return;
                        this.groupLevel--;
                        const groupCtx = this.ctx;
                        const ctx = this.groupStack.pop();
                        this.ctx = ctx;
                        this.ctx.imageSmoothingEnabled = false;
                        if (group.smask) {
                            this.tempSMask = this.smaskStack.pop();
                            this.restore();
                        } else {
                            this.ctx.restore();
                            const currentMtx = (0, _display_utils.getCurrentTransform)(this.ctx);
                            this.restore();
                            this.ctx.save();
                            this.ctx.setTransform(...currentMtx);
                            const dirtyBox = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                groupCtx.canvas.width,
                                groupCtx.canvas.height
                            ], currentMtx);
                            this.ctx.drawImage(groupCtx.canvas, 0, 0);
                            this.ctx.restore();
                            this.compose(dirtyBox);
                        }
                    }
                    beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                        this.#restoreInitialState();
                        resetCtxToDefault(this.ctx);
                        this.ctx.save();
                        this.save();
                        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
                        if (Array.isArray(rect) && rect.length === 4) {
                            const width = rect[2] - rect[0];
                            const height = rect[3] - rect[1];
                            if (hasOwnCanvas && this.annotationCanvasMap) {
                                transform = transform.slice();
                                transform[4] -= rect[0];
                                transform[5] -= rect[1];
                                rect = rect.slice();
                                rect[0] = rect[1] = 0;
                                rect[2] = width;
                                rect[3] = height;
                                const [scaleX, scaleY] = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(this.ctx));
                                const { viewportScale } = this;
                                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                                const { canvas, context } = this.annotationCanvas;
                                this.annotationCanvasMap.set(id, canvas);
                                this.annotationCanvas.savedCtx = this.ctx;
                                this.ctx = context;
                                this.ctx.save();
                                this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                                resetCtxToDefault(this.ctx);
                            } else {
                                resetCtxToDefault(this.ctx);
                                this.ctx.rect(rect[0], rect[1], width, height);
                                this.ctx.clip();
                                this.endPath();
                            }
                        }
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.transform(...transform);
                        this.transform(...matrix);
                    }
                    endAnnotation() {
                        if (this.annotationCanvas) {
                            this.ctx.restore();
                            this.#drawFilter();
                            this.ctx = this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas;
                        }
                    }
                    paintImageMaskXObject(img) {
                        if (!this.contentVisible) return;
                        const count = img.count;
                        img = this.getObject(img.data, img);
                        img.count = count;
                        const ctx = this.ctx;
                        const glyph = this.processingType3;
                        if (glyph) {
                            if (glyph.compiled === undefined) glyph.compiled = compileType3Glyph(img);
                            if (glyph.compiled) {
                                glyph.compiled(ctx);
                                return;
                            }
                        }
                        const mask = this._createMaskCanvas(img);
                        const maskCanvas = mask.canvas;
                        ctx.save();
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectRepeat(img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
                        if (!this.contentVisible) return;
                        img = this.getObject(img.data, img);
                        const ctx = this.ctx;
                        ctx.save();
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                        const mask = this._createMaskCanvas(img);
                        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
                        for(let i = 0, ii = positions.length; i < ii; i += 2){
                            const trans = _util.Util.transform(currentTransform, [
                                scaleX,
                                skewX,
                                skewY,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ]);
                            const [x, y] = _util.Util.applyTransform([
                                0,
                                0
                            ], trans);
                            ctx.drawImage(mask.canvas, x, y);
                        }
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectGroup(images) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        for (const image of images){
                            const { data, width, height, transform } = image;
                            const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            const maskCtx = maskCanvas.context;
                            maskCtx.save();
                            const img = this.getObject(data, image);
                            putBinaryImageMask(maskCtx, img);
                            maskCtx.globalCompositeOperation = "source-in";
                            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
                            maskCtx.fillRect(0, 0, width, height);
                            maskCtx.restore();
                            ctx.save();
                            ctx.transform(...transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintImageXObject(objId) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        const width = imgData.width;
                        const height = imgData.height;
                        const map = [];
                        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
                            transform: [
                                scaleX,
                                0,
                                0,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ],
                            x: 0,
                            y: 0,
                            w: width,
                            h: height
                        });
                        this.paintInlineImageXObjectGroup(imgData, map);
                    }
                    applyTransferMapsToCanvas(ctx) {
                        if (this.current.transferMaps !== "none") {
                            ctx.filter = this.current.transferMaps;
                            ctx.drawImage(ctx.canvas, 0, 0);
                            ctx.filter = "none";
                        }
                        return ctx.canvas;
                    }
                    applyTransferMapsToBitmap(imgData) {
                        if (this.current.transferMaps === "none") return imgData.bitmap;
                        const { bitmap, width, height } = imgData;
                        const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                        const tmpCtx = tmpCanvas.context;
                        tmpCtx.filter = this.current.transferMaps;
                        tmpCtx.drawImage(bitmap, 0, 0);
                        tmpCtx.filter = "none";
                        return tmpCanvas.canvas;
                    }
                    paintInlineImageXObject(imgData) {
                        if (!this.contentVisible) return;
                        const width = imgData.width;
                        const height = imgData.height;
                        const ctx = this.ctx;
                        this.save();
                        if (!_util.isNodeJS) {
                            const { filter } = ctx;
                            if (filter !== "none" && filter !== "") ctx.filter = "none";
                        }
                        ctx.scale(1 / width, -1 / height);
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
                        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
                        else {
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        const scaled = this._scaleImage(imgToPaint, (0, _display_utils.getCurrentTransformInverse)(ctx));
                        ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(ctx), imgData.interpolate);
                        drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                        this.compose();
                        this.restore();
                    }
                    paintInlineImageXObjectGroup(imgData, map) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = imgData.bitmap;
                        else {
                            const w = imgData.width;
                            const h = imgData.height;
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        for (const entry of map){
                            ctx.save();
                            ctx.transform(...entry.transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintSolidColorImageMask() {
                        if (!this.contentVisible) return;
                        this.ctx.fillRect(0, 0, 1, 1);
                        this.compose();
                    }
                    markPoint(tag) {}
                    markPointProps(tag, properties) {}
                    beginMarkedContent(tag) {
                        this.markedContentStack.push({
                            visible: true
                        });
                    }
                    beginMarkedContentProps(tag, properties) {
                        if (tag === "OC") this.markedContentStack.push({
                            visible: this.optionalContentConfig.isVisible(properties)
                        });
                        else this.markedContentStack.push({
                            visible: true
                        });
                        this.contentVisible = this.isContentVisible();
                    }
                    endMarkedContent() {
                        this.markedContentStack.pop();
                        this.contentVisible = this.isContentVisible();
                    }
                    beginCompat() {}
                    endCompat() {}
                    consumePath(clipBox) {
                        const isEmpty = this.current.isEmptyClip();
                        if (this.pendingClip) this.current.updateClipFromPath();
                        if (!this.pendingClip) this.compose(clipBox);
                        const ctx = this.ctx;
                        if (this.pendingClip) {
                            if (!isEmpty) {
                                if (this.pendingClip === EO_CLIP) ctx.clip("evenodd");
                                else ctx.clip();
                            }
                            this.pendingClip = null;
                        }
                        this.current.startNewPathAndClipBox(this.current.clipBox);
                        ctx.beginPath();
                    }
                    getSinglePixelWidth() {
                        if (!this._cachedGetSinglePixelWidth) {
                            const m = (0, _display_utils.getCurrentTransform)(this.ctx);
                            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
                            else {
                                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                                const normX = Math.hypot(m[0], m[2]);
                                const normY = Math.hypot(m[1], m[3]);
                                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
                            }
                        }
                        return this._cachedGetSinglePixelWidth;
                    }
                    getScaleForStroking() {
                        if (this._cachedScaleForStroking[0] === -1) {
                            const { lineWidth } = this.current;
                            const { a, b, c, d } = this.ctx.getTransform();
                            let scaleX, scaleY;
                            if (b === 0 && c === 0) {
                                const normX = Math.abs(a);
                                const normY = Math.abs(d);
                                if (normX === normY) {
                                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                                    else {
                                        const scaledLineWidth = normX * lineWidth;
                                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                                    }
                                } else if (lineWidth === 0) {
                                    scaleX = 1 / normX;
                                    scaleY = 1 / normY;
                                } else {
                                    const scaledXLineWidth = normX * lineWidth;
                                    const scaledYLineWidth = normY * lineWidth;
                                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                                }
                            } else {
                                const absDet = Math.abs(a * d - b * c);
                                const normX = Math.hypot(a, b);
                                const normY = Math.hypot(c, d);
                                if (lineWidth === 0) {
                                    scaleX = normY / absDet;
                                    scaleY = normX / absDet;
                                } else {
                                    const baseArea = lineWidth * absDet;
                                    scaleX = normY > baseArea ? normY / baseArea : 1;
                                    scaleY = normX > baseArea ? normX / baseArea : 1;
                                }
                            }
                            this._cachedScaleForStroking[0] = scaleX;
                            this._cachedScaleForStroking[1] = scaleY;
                        }
                        return this._cachedScaleForStroking;
                    }
                    rescaleAndStroke(saveRestore) {
                        const { ctx } = this;
                        const { lineWidth } = this.current;
                        const [scaleX, scaleY] = this.getScaleForStroking();
                        ctx.lineWidth = lineWidth || 1;
                        if (scaleX === 1 && scaleY === 1) {
                            ctx.stroke();
                            return;
                        }
                        const dashes = ctx.getLineDash();
                        if (saveRestore) ctx.save();
                        ctx.scale(scaleX, scaleY);
                        if (dashes.length > 0) {
                            const scale = Math.max(scaleX, scaleY);
                            ctx.setLineDash(dashes.map((x)=>x / scale));
                            ctx.lineDashOffset /= scale;
                        }
                        ctx.stroke();
                        if (saveRestore) ctx.restore();
                    }
                    isContentVisible() {
                        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
                            if (!this.markedContentStack[i].visible) return false;
                        }
                        return true;
                    }
                }
                exports.CanvasGraphics = CanvasGraphics;
                for(const op in _util.OPS)if (CanvasGraphics.prototype[op] !== undefined) CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TilingPattern = exports.PathType = void 0;
                exports.getShadingPattern = getShadingPattern;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const PathType = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports.PathType = PathType;
                function applyBoundingBox(ctx, bbox) {
                    if (!bbox) return;
                    const width = bbox[2] - bbox[0];
                    const height = bbox[3] - bbox[1];
                    const region = new Path2D();
                    region.rect(bbox[0], bbox[1], width, height);
                    ctx.clip(region);
                }
                class BaseShadingPattern {
                    constructor(){
                        if (this.constructor === BaseShadingPattern) (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    getPattern() {
                        (0, _util.unreachable)("Abstract method `getPattern` called.");
                    }
                }
                class RadialAxialShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._type = IR[1];
                        this._bbox = IR[2];
                        this._colorStops = IR[3];
                        this._p0 = IR[4];
                        this._p1 = IR[5];
                        this._r0 = IR[6];
                        this._r1 = IR[7];
                        this.matrix = null;
                    }
                    _createGradient(ctx) {
                        let grad;
                        if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                        else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
                        return grad;
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let pattern;
                        if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils.getCurrentTransform)(ctx)) || [
                                0,
                                0,
                                0,
                                0
                            ];
                            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                            const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                            const tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.beginPath();
                            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                            inverse = _util.Util.transform(inverse, [
                                1,
                                0,
                                0,
                                1,
                                ownerBBox[0],
                                ownerBBox[1]
                            ]);
                            tmpCtx.transform(...owner.baseTransform);
                            if (this.matrix) tmpCtx.transform(...this.matrix);
                            applyBoundingBox(tmpCtx, this._bbox);
                            tmpCtx.fillStyle = this._createGradient(tmpCtx);
                            tmpCtx.fill();
                            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                            const domMatrix = new DOMMatrix(inverse);
                            pattern.setTransform(domMatrix);
                        } else {
                            applyBoundingBox(ctx, this._bbox);
                            pattern = this._createGradient(ctx);
                        }
                        return pattern;
                    }
                }
                function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
                    const coords = context.coords, colors = context.colors;
                    const bytes = data.data, rowSize = data.width * 4;
                    let tmp;
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    if (coords[p2 + 1] > coords[p3 + 1]) {
                        tmp = p2;
                        p2 = p3;
                        p3 = tmp;
                        tmp = c2;
                        c2 = c3;
                        c3 = tmp;
                    }
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    const x1 = (coords[p1] + context.offsetX) * context.scaleX;
                    const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                    const x2 = (coords[p2] + context.offsetX) * context.scaleX;
                    const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                    const x3 = (coords[p3] + context.offsetX) * context.scaleX;
                    const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                    if (y1 >= y3) return;
                    const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                    const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                    const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                    const minY = Math.round(y1), maxY = Math.round(y3);
                    let xa, car, cag, cab;
                    let xb, cbr, cbg, cbb;
                    for(let y = minY; y <= maxY; y++){
                        if (y < y2) {
                            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
                            xa = x1 - (x1 - x2) * k;
                            car = c1r - (c1r - c2r) * k;
                            cag = c1g - (c1g - c2g) * k;
                            cab = c1b - (c1b - c2b) * k;
                        } else {
                            let k;
                            if (y > y3) k = 1;
                            else if (y2 === y3) k = 0;
                            else k = (y2 - y) / (y2 - y3);
                            xa = x2 - (x2 - x3) * k;
                            car = c2r - (c2r - c3r) * k;
                            cag = c2g - (c2g - c3g) * k;
                            cab = c2b - (c2b - c3b) * k;
                        }
                        let k;
                        if (y < y1) k = 0;
                        else if (y > y3) k = 1;
                        else k = (y1 - y) / (y1 - y3);
                        xb = x1 - (x1 - x3) * k;
                        cbr = c1r - (c1r - c3r) * k;
                        cbg = c1g - (c1g - c3g) * k;
                        cbb = c1b - (c1b - c3b) * k;
                        const x1_ = Math.round(Math.min(xa, xb));
                        const x2_ = Math.round(Math.max(xa, xb));
                        let j = rowSize * y + x1_ * 4;
                        for(let x = x1_; x <= x2_; x++){
                            k = (xa - x) / (xa - xb);
                            if (k < 0) k = 0;
                            else if (k > 1) k = 1;
                            bytes[j++] = car - (car - cbr) * k | 0;
                            bytes[j++] = cag - (cag - cbg) * k | 0;
                            bytes[j++] = cab - (cab - cbb) * k | 0;
                            bytes[j++] = 255;
                        }
                    }
                }
                function drawFigure(data, figure, context) {
                    const ps = figure.coords;
                    const cs = figure.colors;
                    let i, ii;
                    switch(figure.type){
                        case "lattice":
                            const verticesPerRow = figure.verticesPerRow;
                            const rows = Math.floor(ps.length / verticesPerRow) - 1;
                            const cols = verticesPerRow - 1;
                            for(i = 0; i < rows; i++){
                                let q = i * verticesPerRow;
                                for(let j = 0; j < cols; j++, q++){
                                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i = 0, ii = ps.length; i < ii; i += 3)drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                class MeshShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._coords = IR[2];
                        this._colors = IR[3];
                        this._figures = IR[4];
                        this._bounds = IR[5];
                        this._bbox = IR[7];
                        this._background = IR[8];
                        this.matrix = null;
                    }
                    _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                        const EXPECTED_SCALE = 1.1;
                        const MAX_PATTERN_SIZE = 3000;
                        const BORDER_SIZE = 2;
                        const offsetX = Math.floor(this._bounds[0]);
                        const offsetY = Math.floor(this._bounds[1]);
                        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const scaleX = boundsWidth / width;
                        const scaleY = boundsHeight / height;
                        const context = {
                            coords: this._coords,
                            colors: this._colors,
                            offsetX: -offsetX,
                            offsetY: -offsetY,
                            scaleX: 1 / scaleX,
                            scaleY: 1 / scaleY
                        };
                        const paddedWidth = width + BORDER_SIZE * 2;
                        const paddedHeight = height + BORDER_SIZE * 2;
                        const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                        const tmpCtx = tmpCanvas.context;
                        const data = tmpCtx.createImageData(width, height);
                        if (backgroundColor) {
                            const bytes = data.data;
                            for(let i = 0, ii = bytes.length; i < ii; i += 4){
                                bytes[i] = backgroundColor[0];
                                bytes[i + 1] = backgroundColor[1];
                                bytes[i + 2] = backgroundColor[2];
                                bytes[i + 3] = 255;
                            }
                        }
                        for (const figure of this._figures)drawFigure(data, figure, context);
                        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
                        const canvas = tmpCanvas.canvas;
                        return {
                            canvas: canvas,
                            offsetX: offsetX - BORDER_SIZE * scaleX,
                            offsetY: offsetY - BORDER_SIZE * scaleY,
                            scaleX: scaleX,
                            scaleY: scaleY
                        };
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        applyBoundingBox(ctx, this._bbox);
                        let scale;
                        if (pathType === PathType.SHADING) scale = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(ctx));
                        else {
                            scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                            if (this.matrix) {
                                const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                scale = [
                                    scale[0] * matrixScale[0],
                                    scale[1] * matrixScale[1]
                                ];
                            }
                        }
                        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                        if (pathType !== PathType.SHADING) {
                            ctx.setTransform(...owner.baseTransform);
                            if (this.matrix) ctx.transform(...this.matrix);
                        }
                        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                    }
                }
                class DummyShadingPattern extends BaseShadingPattern {
                    getPattern() {
                        return "hotpink";
                    }
                }
                function getShadingPattern(IR) {
                    switch(IR[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern(IR);
                        case "Mesh":
                            return new MeshShadingPattern(IR);
                        case "Dummy":
                            return new DummyShadingPattern();
                    }
                    throw new Error(`Unknown IR type: ${IR[0]}`);
                }
                const PaintType = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                class TilingPattern {
                    static MAX_PATTERN_SIZE = 3000;
                    constructor(IR, color, ctx, canvasGraphicsFactory, baseTransform){
                        this.operatorList = IR[2];
                        this.matrix = IR[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR[4];
                        this.xstep = IR[5];
                        this.ystep = IR[6];
                        this.paintType = IR[7];
                        this.tilingType = IR[8];
                        this.color = color;
                        this.ctx = ctx;
                        this.canvasGraphicsFactory = canvasGraphicsFactory;
                        this.baseTransform = baseTransform;
                    }
                    createPatternCanvas(owner) {
                        const operatorList = this.operatorList;
                        const bbox = this.bbox;
                        const xstep = this.xstep;
                        const ystep = this.ystep;
                        const paintType = this.paintType;
                        const tilingType = this.tilingType;
                        const color = this.color;
                        const canvasGraphicsFactory = this.canvasGraphicsFactory;
                        (0, _util.info)("TilingType: " + tilingType);
                        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                        const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                        const curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
                        const combinedScale = [
                            matrixScale[0] * curMatrixScale[0],
                            matrixScale[1] * curMatrixScale[1]
                        ];
                        const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                        const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                        const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                        const tmpCtx = tmpCanvas.context;
                        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                        graphics.groupLevel = owner.groupLevel;
                        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                        let adjustedX0 = x0;
                        let adjustedY0 = y0;
                        let adjustedX1 = x1;
                        let adjustedY1 = y1;
                        if (x0 < 0) {
                            adjustedX0 = 0;
                            adjustedX1 += Math.abs(x0);
                        }
                        if (y0 < 0) {
                            adjustedY0 = 0;
                            adjustedY1 += Math.abs(y0);
                        }
                        tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                        graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                        tmpCtx.save();
                        this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                        graphics.baseTransform = (0, _display_utils.getCurrentTransform)(graphics.ctx);
                        graphics.executeOperatorList(operatorList);
                        graphics.endDrawing();
                        return {
                            canvas: tmpCanvas.canvas,
                            scaleX: dimx.scale,
                            scaleY: dimy.scale,
                            offsetX: adjustedX0,
                            offsetY: adjustedY0
                        };
                    }
                    getSizeAndScale(step, realOutputSize, scale) {
                        step = Math.abs(step);
                        const maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                        let size = Math.ceil(step * scale);
                        if (size >= maxSize) size = maxSize;
                        else scale = size / step;
                        return {
                            scale: scale,
                            size: size
                        };
                    }
                    clipBbox(graphics, x0, y0, x1, y1) {
                        const bboxWidth = x1 - x0;
                        const bboxHeight = y1 - y0;
                        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                        graphics.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(graphics.ctx), [
                            x0,
                            y0,
                            x1,
                            y1
                        ]);
                        graphics.clip();
                        graphics.endPath();
                    }
                    setFillAndStrokeStyleToContext(graphics, paintType, color) {
                        const context = graphics.ctx, current = graphics.current;
                        switch(paintType){
                            case PaintType.COLORED:
                                const ctx = this.ctx;
                                context.fillStyle = ctx.fillStyle;
                                context.strokeStyle = ctx.strokeStyle;
                                current.fillColor = ctx.fillStyle;
                                current.strokeColor = ctx.strokeStyle;
                                break;
                            case PaintType.UNCOLORED:
                                const cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                                context.fillStyle = cssColor;
                                context.strokeStyle = cssColor;
                                current.fillColor = cssColor;
                                current.strokeColor = cssColor;
                                break;
                            default:
                                throw new _util.FormatError(`Unsupported paint type: ${paintType}`);
                        }
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let matrix = inverse;
                        if (pathType !== PathType.SHADING) {
                            matrix = _util.Util.transform(matrix, owner.baseTransform);
                            if (this.matrix) matrix = _util.Util.transform(matrix, this.matrix);
                        }
                        const temporaryPatternCanvas = this.createPatternCanvas(owner);
                        let domMatrix = new DOMMatrix(matrix);
                        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                        pattern.setTransform(domMatrix);
                        return pattern;
                    }
                }
                exports.TilingPattern = TilingPattern;
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                exports.convertToRGBA = convertToRGBA;
                exports.grayToRGBA = grayToRGBA;
                var _util = __w_pdfjs_require__(1);
                function convertToRGBA(params) {
                    switch(params.kind){
                        case _util.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(params);
                        case _util.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA(params);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA({ src, srcPos = 0, dest, width, height, nonBlackColor = 0xffffffff, inverseDecode = false }) {
                    const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    const [zeroMapping, oneMapping] = inverseDecode ? [
                        nonBlackColor,
                        black
                    ] : [
                        black,
                        nonBlackColor
                    ];
                    const widthInSource = width >> 3;
                    const widthRemainder = width & 7;
                    const srcLength = src.length;
                    dest = new Uint32Array(dest.buffer);
                    let destPos = 0;
                    for(let i = 0; i < height; i++){
                        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
                            const elem = srcPos < srcLength ? src[srcPos] : 255;
                            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
                        }
                        if (widthRemainder === 0) continue;
                        const elem = srcPos < srcLength ? src[srcPos++] : 255;
                        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function convertRGBToRGBA({ src, srcPos = 0, dest, destPos = 0, width, height }) {
                    let i = 0;
                    const len32 = src.length >> 2;
                    const src32 = new Uint32Array(src.buffer, srcPos, len32);
                    if (_util.FeatureTest.isLittleEndian) {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff000000;
                            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
                            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
                            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
                    } else {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff;
                            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
                            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
                            dest[destPos + 3] = s3 << 8 | 0xff;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function grayToRGBA(src, dest) {
                    if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
                    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlobalWorkerOptions = void 0;
                const GlobalWorkerOptions = Object.create(null);
                exports.GlobalWorkerOptions = GlobalWorkerOptions;
                GlobalWorkerOptions.workerPort = null;
                GlobalWorkerOptions.workerSrc = "";
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(1);
                const CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                class MessageHandler {
                    constructor(sourceName, targetName, comObj){
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event)=>{
                            const data = event.data;
                            if (data.targetName !== this.sourceName) return;
                            if (data.stream) {
                                this.#processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                const callbackId = data.callbackId;
                                const capability = this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                                delete this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action = this.actionHandler[data.action];
                            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
                            if (data.callbackId) {
                                const cbSourceName = this.sourceName;
                                const cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                this.#createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName, handler) {
                        const ah = this.actionHandler;
                        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
                        ah[actionName] = handler;
                    }
                    send(actionName, data, transfers) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName,
                            data: data
                        }, transfers);
                    }
                    sendWithPromise(actionName, data, transfers) {
                        const callbackId = this.callbackId++;
                        const capability = new _util.PromiseCapability();
                        this.callbackCapabilities[callbackId] = capability;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName,
                                callbackId: callbackId,
                                data: data
                            }, transfers);
                        } catch (ex) {
                            capability.reject(ex);
                        }
                        return capability.promise;
                    }
                    sendWithStream(actionName, data, queueingStrategy, transfers) {
                        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                        return new ReadableStream({
                            start: (controller)=>{
                                const startCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId] = {
                                    controller: controller,
                                    startCall: startCapability,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    action: actionName,
                                    streamId: streamId,
                                    data: data,
                                    desiredSize: controller.desiredSize
                                }, transfers);
                                return startCapability.promise;
                            },
                            pull: (controller)=>{
                                const pullCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].pullCall = pullCapability;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL,
                                    streamId: streamId,
                                    desiredSize: controller.desiredSize
                                });
                                return pullCapability.promise;
                            },
                            cancel: (reason)=>{
                                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                const cancelCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].cancelCall = cancelCapability;
                                this.streamControllers[streamId].isClosed = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                                return cancelCapability.promise;
                            }
                        }, queueingStrategy);
                    }
                    #createStreamSink(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const self = this, action = this.actionHandler[data.action];
                        const streamSink = {
                            enqueue (chunk, size = 1, transfers) {
                                if (this.isCancelled) return;
                                const lastDesiredSize = this.desiredSize;
                                this.desiredSize -= size;
                                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = new _util.PromiseCapability();
                                    this.ready = this.sinkCapability.promise;
                                }
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ENQUEUE,
                                    streamId: streamId,
                                    chunk: chunk
                                }, transfers);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CLOSE,
                                    streamId: streamId
                                });
                                delete self.streamSinks[streamId];
                            },
                            error (reason) {
                                (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ERROR,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            },
                            sinkCapability: new _util.PromiseCapability(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data.desiredSize,
                            ready: null
                        };
                        streamSink.sinkCapability.resolve();
                        streamSink.ready = streamSink.sinkCapability.promise;
                        this.streamSinks[streamId] = streamSink;
                        new Promise(function(resolve) {
                            resolve(action(data.data, streamSink));
                        }).then(function() {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                success: true
                            });
                        }, function(reason) {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        });
                    }
                    #processStreamMessage(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                        switch(data.stream){
                            case StreamKind.START_COMPLETE:
                                if (data.success) streamController.startCall.resolve();
                                else streamController.startCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL_COMPLETE:
                                if (data.success) streamController.pullCall.resolve();
                                else streamController.pullCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL:
                                if (!streamSink) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                    break;
                                }
                                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                                streamSink.desiredSize = data.desiredSize;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onPull?.());
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                break;
                            case StreamKind.ENQUEUE:
                                (0, _util.assert)(streamController, "enqueue should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.controller.enqueue(data.chunk);
                                break;
                            case StreamKind.CLOSE:
                                (0, _util.assert)(streamController, "close should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.isClosed = true;
                                streamController.controller.close();
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.ERROR:
                                (0, _util.assert)(streamController, "error should have stream controller");
                                streamController.controller.error(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL_COMPLETE:
                                if (data.success) streamController.cancelCall.resolve();
                                else streamController.cancelCall.reject(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL:
                                if (!streamSink) break;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onCancel?.(wrapReason(data.reason)));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                streamSink.sinkCapability.reject(wrapReason(data.reason));
                                streamSink.isCancelled = true;
                                delete this.streamSinks[streamId];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async #deleteStreamController(streamController, streamId) {
                        await Promise.allSettled([
                            streamController.startCall?.promise,
                            streamController.pullCall?.promise,
                            streamController.cancelCall?.promise
                        ]);
                        delete this.streamControllers[streamId];
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Metadata = void 0;
                var _util = __w_pdfjs_require__(1);
                class Metadata {
                    #metadataMap;
                    #data;
                    constructor({ parsedData, rawData }){
                        this.#metadataMap = parsedData;
                        this.#data = rawData;
                    }
                    getRaw() {
                        return this.#data;
                    }
                    get(name) {
                        return this.#metadataMap.get(name) ?? null;
                    }
                    getAll() {
                        return (0, _util.objectFromMap)(this.#metadataMap);
                    }
                    has(name) {
                        return this.#metadataMap.has(name);
                    }
                }
                exports.Metadata = Metadata;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OptionalContentConfig = void 0;
                var _util = __w_pdfjs_require__(1);
                var _murmurhash = __w_pdfjs_require__(8);
                const INTERNAL = Symbol("INTERNAL");
                class OptionalContentGroup {
                    #visible = true;
                    constructor(name, intent){
                        this.name = name;
                        this.intent = intent;
                    }
                    get visible() {
                        return this.#visible;
                    }
                    _setVisible(internal, visible) {
                        if (internal !== INTERNAL) (0, _util.unreachable)("Internal method `_setVisible` called.");
                        this.#visible = visible;
                    }
                }
                class OptionalContentConfig {
                    #cachedGetHash = null;
                    #groups = new Map();
                    #initialHash = null;
                    #order = null;
                    constructor(data){
                        this.name = null;
                        this.creator = null;
                        if (data === null) return;
                        this.name = data.name;
                        this.creator = data.creator;
                        this.#order = data.order;
                        for (const group of data.groups)this.#groups.set(group.id, new OptionalContentGroup(group.name, group.intent));
                        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible(INTERNAL, false);
                        for (const on of data.on)this.#groups.get(on)._setVisible(INTERNAL, true);
                        for (const off of data.off)this.#groups.get(off)._setVisible(INTERNAL, false);
                        this.#initialHash = this.getHash();
                    }
                    #evaluateVisibilityExpression(array) {
                        const length = array.length;
                        if (length < 2) return true;
                        const operator = array[0];
                        for(let i = 1; i < length; i++){
                            const element = array[i];
                            let state;
                            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
                            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
                            else {
                                (0, _util.warn)(`Optional content group not found: ${element}`);
                                return true;
                            }
                            switch(operator){
                                case "And":
                                    if (!state) return false;
                                    break;
                                case "Or":
                                    if (state) return true;
                                    break;
                                case "Not":
                                    return !state;
                                default:
                                    return true;
                            }
                        }
                        return operator === "And";
                    }
                    isVisible(group) {
                        if (this.#groups.size === 0) return true;
                        if (!group) {
                            (0, _util.warn)("Optional content group not defined.");
                            return true;
                        }
                        if (group.type === "OCG") {
                            if (!this.#groups.has(group.id)) {
                                (0, _util.warn)(`Optional content group not found: ${group.id}`);
                                return true;
                            }
                            return this.#groups.get(group.id).visible;
                        } else if (group.type === "OCMD") {
                            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
                            if (!group.policy || group.policy === "AnyOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return false;
                                }
                                return true;
                            } else if (group.policy === "AnyOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return false;
                                }
                                return true;
                            }
                            (0, _util.warn)(`Unknown optional content policy ${group.policy}.`);
                            return true;
                        }
                        (0, _util.warn)(`Unknown group type ${group.type}.`);
                        return true;
                    }
                    setVisibility(id, visible = true) {
                        if (!this.#groups.has(id)) {
                            (0, _util.warn)(`Optional content group not found: ${id}`);
                            return;
                        }
                        this.#groups.get(id)._setVisible(INTERNAL, !!visible);
                        this.#cachedGetHash = null;
                    }
                    get hasInitialVisibility() {
                        return this.#initialHash === null || this.getHash() === this.#initialHash;
                    }
                    getOrder() {
                        if (!this.#groups.size) return null;
                        if (this.#order) return this.#order.slice();
                        return [
                            ...this.#groups.keys()
                        ];
                    }
                    getGroups() {
                        return this.#groups.size > 0 ? (0, _util.objectFromMap)(this.#groups) : null;
                    }
                    getGroup(id) {
                        return this.#groups.get(id) || null;
                    }
                    getHash() {
                        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
                        const hash = new _murmurhash.MurmurHash3_64();
                        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
                        return this.#cachedGetHash = hash.hexdigest();
                    }
                }
                exports.OptionalContentConfig = OptionalContentConfig;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDataTransportStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class PDFDataTransportStream {
                    constructor({ length, initialData, progressiveDone = false, contentDispositionFilename = null, disableRange = false, disableStream = false }, pdfDataRangeTransport){
                        (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = progressiveDone;
                        this._contentDispositionFilename = contentDispositionFilename;
                        if (initialData?.length > 0) {
                            const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
                            this._queuedChunks.push(buffer);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport;
                        this._isStreamingSupported = !disableStream;
                        this._isRangeSupported = !disableRange;
                        this._contentLength = length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
                            this._onReceiveData({
                                begin: begin,
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener((loaded, total)=>{
                            this._onProgress({
                                loaded: loaded,
                                total: total
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
                            this._onReceiveData({
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(()=>{
                            this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _onReceiveData({ begin, chunk }) {
                        const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
                        if (begin === undefined) {
                            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
                            else this._queuedChunks.push(buffer);
                        } else {
                            const found = this._rangeReaders.some(function(rangeReader) {
                                if (rangeReader._begin !== begin) return false;
                                rangeReader._enqueue(buffer);
                                return true;
                            });
                            (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                        }
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    _onProgress(evt) {
                        if (evt.total === undefined) this._rangeReaders[0]?.onProgress?.({
                            loaded: evt.loaded
                        });
                        else this._fullRequestReader?.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.total
                        });
                    }
                    _onProgressiveDone() {
                        this._fullRequestReader?.progressiveDone();
                        this._progressiveDone = true;
                    }
                    _removeRangeReader(reader) {
                        const i = this._rangeReaders.indexOf(reader);
                        if (i >= 0) this._rangeReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                        const queuedChunks = this._queuedChunks;
                        this._queuedChunks = null;
                        return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                        this._pdfDataRangeTransport.requestDataRange(begin, end);
                        this._rangeReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeReaders.slice(0))reader.cancel(reason);
                        this._pdfDataRangeTransport.abort();
                    }
                }
                exports.PDFDataTransportStream = PDFDataTransportStream;
                class PDFDataTransportStreamReader {
                    constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null){
                        this._stream = stream;
                        this._done = progressiveDone || false;
                        this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                        this._queuedChunks = queuedChunks || [];
                        this._loaded = 0;
                        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunks.push(chunk);
                        this._loaded += chunk.byteLength;
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._stream._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._stream._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._stream._contentLength;
                    }
                    async read() {
                        if (this._queuedChunks.length > 0) {
                            const chunk = this._queuedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    progressiveDone() {
                        if (this._done) return;
                        this._done = true;
                    }
                }
                class PDFDataTransportStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._begin = begin;
                        this._end = end;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length === 0) this._queuedChunk = chunk;
                        else {
                            const requestsCapability = this._requests.shift();
                            requestsCapability.resolve({
                                value: chunk,
                                done: false
                            });
                            for (const requestCapability of this._requests)requestCapability.resolve({
                                value: undefined,
                                done: true
                            });
                            this._requests.length = 0;
                        }
                        this._done = true;
                        this._stream._removeRangeReader(this);
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._queuedChunk) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._stream._removeRangeReader(this);
                    }
                }
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFFetchStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                function createFetchOptions(headers, withCredentials, abortController) {
                    return {
                        method: "GET",
                        headers: headers,
                        signal: abortController.signal,
                        mode: "cors",
                        credentials: withCredentials ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders(httpHeaders) {
                    const headers = new Headers();
                    for(const property in httpHeaders){
                        const value = httpHeaders[property];
                        if (value === undefined) continue;
                        headers.append(property, value);
                    }
                    return headers;
                }
                function getArrayBuffer(val) {
                    if (val instanceof Uint8Array) return val.buffer;
                    if (val instanceof ArrayBuffer) return val;
                    (0, _util.warn)(`getArrayBuffer - unexpected data format: ${val}`);
                    return new Uint8Array(val).buffer;
                }
                class PDFFetchStream {
                    constructor(source){
                        this.source = source;
                        this.isHttp = /^https?:/i.test(source.url);
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFFetchStreamReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFFetchStreamRangeReader(this, begin, end);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFFetchStream = PDFFetchStream;
                class PDFFetchStreamReader {
                    constructor(stream){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._contentLength = source.length;
                        this._headersCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._abortController = new AbortController();
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._headers = createHeaders(this._stream.httpHeaders);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._reader = response.body.getReader();
                            this._headersCapability.resolve();
                            const getResponseHeader = (name)=>{
                                return response.headers.get(name);
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: this._stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new _util.AbortException("Streaming is disabled."));
                        }).catch(this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._headersCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
                class PDFFetchStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._readCapability = new _util.PromiseCapability();
                        this._isStreamingSupported = !source.disableStream;
                        this._abortController = new AbortController();
                        this._headers = createHeaders(this._stream.httpHeaders);
                        this._headers.append("Range", `bytes=${begin}-${end - 1}`);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._readCapability.resolve();
                            this._reader = response.body.getReader();
                        }).catch(this._readCapability.reject);
                        this.onProgress = null;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createResponseStatusError = createResponseStatusError;
                exports.extractFilenameFromHeader = extractFilenameFromHeader;
                exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
                exports.validateResponseStatus = validateResponseStatus;
                var _util = __w_pdfjs_require__(1);
                var _content_disposition = __w_pdfjs_require__(21);
                var _display_utils = __w_pdfjs_require__(6);
                function validateRangeRequestCapabilities({ getResponseHeader, isHttp, rangeChunkSize, disableRange }) {
                    const returnValues = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    const length = parseInt(getResponseHeader("Content-Length"), 10);
                    if (!Number.isInteger(length)) return returnValues;
                    returnValues.suggestedLength = length;
                    if (length <= 2 * rangeChunkSize) return returnValues;
                    if (disableRange || !isHttp) return returnValues;
                    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
                    const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                    if (contentEncoding !== "identity") return returnValues;
                    returnValues.allowRangeRequests = true;
                    return returnValues;
                }
                function extractFilenameFromHeader(getResponseHeader) {
                    const contentDisposition = getResponseHeader("Content-Disposition");
                    if (contentDisposition) {
                        let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                        if (filename.includes("%")) try {
                            filename = decodeURIComponent(filename);
                        } catch  {}
                        if ((0, _display_utils.isPdfFile)(filename)) return filename;
                    }
                    return null;
                }
                function createResponseStatusError(status, url) {
                    if (status === 404 || status === 0 && url.startsWith("file:")) return new _util.MissingPDFException('Missing PDF "' + url + '".');
                    return new _util.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status);
                }
                function validateResponseStatus(status) {
                    return status === 200 || status === 206;
                }
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
                var _util = __w_pdfjs_require__(1);
                function getFilenameFromContentDispositionHeader(contentDisposition) {
                    let needsEncodingFixup = true;
                    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = unescape(filename);
                        filename = rfc5987decode(filename);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    tmp = rfc2231getparam(contentDisposition);
                    if (tmp) {
                        const filename = rfc2047decode(tmp);
                        return fixupEncoding(filename);
                    }
                    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    function toParamRegExp(attributePattern, flags) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
                    }
                    function textdecode(encoding, value) {
                        if (encoding) {
                            if (!/^[\x00-\xFF]+$/.test(value)) return value;
                            try {
                                const decoder = new TextDecoder(encoding, {
                                    fatal: true
                                });
                                const buffer = (0, _util.stringToBytes)(value);
                                value = decoder.decode(buffer);
                                needsEncodingFixup = false;
                            } catch  {}
                        }
                        return value;
                    }
                    function fixupEncoding(value) {
                        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                            value = textdecode("utf-8", value);
                            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
                        }
                        return value;
                    }
                    function rfc2231getparam(contentDispositionStr) {
                        const matches = [];
                        let match;
                        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match = iter.exec(contentDispositionStr)) !== null){
                            let [, n, quot, part] = match;
                            n = parseInt(n, 10);
                            if (n in matches) {
                                if (n === 0) break;
                                continue;
                            }
                            matches[n] = [
                                quot,
                                part
                            ];
                        }
                        const parts = [];
                        for(let n = 0; n < matches.length; ++n){
                            if (!(n in matches)) break;
                            let [quot, part] = matches[n];
                            part = rfc2616unquote(part);
                            if (quot) {
                                part = unescape(part);
                                if (n === 0) part = rfc5987decode(part);
                            }
                            parts.push(part);
                        }
                        return parts.join("");
                    }
                    function rfc2616unquote(value) {
                        if (value.startsWith('"')) {
                            const parts = value.slice(1).split('\\"');
                            for(let i = 0; i < parts.length; ++i){
                                const quotindex = parts[i].indexOf('"');
                                if (quotindex !== -1) {
                                    parts[i] = parts[i].slice(0, quotindex);
                                    parts.length = i + 1;
                                }
                                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
                            }
                            value = parts.join('"');
                        }
                        return value;
                    }
                    function rfc5987decode(extvalue) {
                        const encodingend = extvalue.indexOf("'");
                        if (encodingend === -1) return extvalue;
                        const encoding = extvalue.slice(0, encodingend);
                        const langvalue = extvalue.slice(encodingend + 1);
                        const value = langvalue.replace(/^[^']*'/, "");
                        return textdecode(encoding, value);
                    }
                    function rfc2047decode(value) {
                        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
                        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                            if (encoding === "q" || encoding === "Q") {
                                text = text.replaceAll("_", " ");
                                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                                    return String.fromCharCode(parseInt(hex, 16));
                                });
                                return textdecode(charset, text);
                            }
                            try {
                                text = atob(text);
                            } catch  {}
                            return textdecode(charset, text);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNetworkStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const OK_RESPONSE = 200;
                const PARTIAL_CONTENT_RESPONSE = 206;
                function getArrayBuffer(xhr) {
                    const data = xhr.response;
                    if (typeof data !== "string") return data;
                    return (0, _util.stringToBytes)(data).buffer;
                }
                class NetworkManager {
                    constructor(url, args = {}){
                        this.url = url;
                        this.isHttp = /^https?:/i.test(url);
                        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
                        this.withCredentials = args.withCredentials || false;
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    requestRange(begin, end, listeners) {
                        const args = {
                            begin: begin,
                            end: end
                        };
                        for(const prop in listeners)args[prop] = listeners[prop];
                        return this.request(args);
                    }
                    requestFull(listeners) {
                        return this.request(listeners);
                    }
                    request(args) {
                        const xhr = new XMLHttpRequest();
                        const xhrId = this.currXhrId++;
                        const pendingRequest = this.pendingRequests[xhrId] = {
                            xhr: xhr
                        };
                        xhr.open("GET", this.url);
                        xhr.withCredentials = this.withCredentials;
                        for(const property in this.httpHeaders){
                            const value = this.httpHeaders[property];
                            if (value === undefined) continue;
                            xhr.setRequestHeader(property, value);
                        }
                        if (this.isHttp && "begin" in args && "end" in args) {
                            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
                            pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                        } else pendingRequest.expectedStatus = OK_RESPONSE;
                        xhr.responseType = "arraybuffer";
                        if (args.onError) xhr.onerror = function(evt) {
                            args.onError(xhr.status);
                        };
                        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                        xhr.onprogress = this.onProgress.bind(this, xhrId);
                        pendingRequest.onHeadersReceived = args.onHeadersReceived;
                        pendingRequest.onDone = args.onDone;
                        pendingRequest.onError = args.onError;
                        pendingRequest.onProgress = args.onProgress;
                        xhr.send(null);
                        return xhrId;
                    }
                    onProgress(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        pendingRequest.onProgress?.(evt);
                    }
                    onStateChange(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        const xhr = pendingRequest.xhr;
                        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                            pendingRequest.onHeadersReceived();
                            delete pendingRequest.onHeadersReceived;
                        }
                        if (xhr.readyState !== 4) return;
                        if (!(xhrId in this.pendingRequests)) return;
                        delete this.pendingRequests[xhrId];
                        if (xhr.status === 0 && this.isHttp) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const xhrStatus = xhr.status || OK_RESPONSE;
                        const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const chunk = getArrayBuffer(xhr);
                        if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                            const rangeHeader = xhr.getResponseHeader("Content-Range");
                            const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                            pendingRequest.onDone({
                                begin: parseInt(matches[1], 10),
                                chunk: chunk
                            });
                        } else if (chunk) pendingRequest.onDone({
                            begin: 0,
                            chunk: chunk
                        });
                        else pendingRequest.onError?.(xhr.status);
                    }
                    getRequestXhr(xhrId) {
                        return this.pendingRequests[xhrId].xhr;
                    }
                    isPendingRequest(xhrId) {
                        return xhrId in this.pendingRequests;
                    }
                    abortRequest(xhrId) {
                        const xhr = this.pendingRequests[xhrId].xhr;
                        delete this.pendingRequests[xhrId];
                        xhr.abort();
                    }
                }
                class PDFNetworkStream {
                    constructor(source){
                        this._source = source;
                        this._manager = new NetworkManager(source.url, {
                            httpHeaders: source.httpHeaders,
                            withCredentials: source.withCredentials
                        });
                        this._rangeChunkSize = source.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _onRangeRequestReaderClosed(reader) {
                        const i = this._rangeRequestReaders.indexOf(reader);
                        if (i >= 0) this._rangeRequestReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNetworkStream = PDFNetworkStream;
                class PDFNetworkStreamFullRequestReader {
                    constructor(manager, source){
                        this._manager = manager;
                        const args = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source.url;
                        this._fullRequestId = manager.requestFull(args);
                        this._headersReceivedCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._contentLength = source.length;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _onHeadersReceived() {
                        const fullRequestXhrId = this._fullRequestId;
                        const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                        const getResponseHeader = (name)=>{
                            return fullRequestXhr.getResponseHeader(name);
                        };
                        const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                            getResponseHeader: getResponseHeader,
                            isHttp: this._manager.isHttp,
                            rangeChunkSize: this._rangeChunkSize,
                            disableRange: this._disableRange
                        });
                        if (allowRangeRequests) this._isRangeSupported = true;
                        this._contentLength = suggestedLength || this._contentLength;
                        this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
                        this._headersReceivedCapability.resolve();
                    }
                    _onDone(data) {
                        if (data) {
                            if (this._requests.length > 0) {
                                const requestCapability = this._requests.shift();
                                requestCapability.resolve({
                                    value: data.chunk,
                                    done: false
                                });
                            } else this._cachedChunks.push(data.chunk);
                        }
                        this._done = true;
                        if (this._cachedChunks.length > 0) return;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        this._headersReceivedCapability.reject(this._storedError);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._cachedChunks.length = 0;
                    }
                    _onProgress(evt) {
                        this.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.lengthComputable ? evt.total : this._contentLength
                        });
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get headersReady() {
                        return this._headersReceivedCapability.promise;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._cachedChunks.length > 0) {
                            const chunk = this._cachedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        this._headersReceivedCapability.reject(reason);
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                        this._fullRequestReader = null;
                    }
                }
                class PDFNetworkStreamRangeRequestReader {
                    constructor(manager, begin, end){
                        this._manager = manager;
                        const args = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager.url;
                        this._requestId = manager.requestRange(begin, end, args);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _close() {
                        this.onClosed?.(this);
                    }
                    _onDone(data) {
                        const chunk = data.chunk;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunk = chunk;
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._close();
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._queuedChunk = null;
                    }
                    _onProgress(evt) {
                        if (!this.isStreamingSupported) this.onProgress?.({
                            loaded: evt.loaded
                        });
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._queuedChunk !== null) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                        this._close();
                    }
                }
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNodeStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl(sourceUrl) {
                    const url = (parcelRequire("67wIF"));
                    const parsedUrl = url.parse(sourceUrl);
                    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse(`file:///${sourceUrl}`);
                    if (!parsedUrl.host) parsedUrl.protocol = "file:";
                    return parsedUrl;
                }
                class PDFNodeStream {
                    constructor(source){
                        this.source = source;
                        this.url = parseUrl(source.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                        this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(start, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                        this._rangeRequestReaders.push(rangeReader);
                        return rangeReader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNodeStream = PDFNodeStream;
                class BaseFullReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        const source = stream.source;
                        this._contentLength = source.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        this._headersCapability = new _util.PromiseCapability();
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util.AbortException("streaming is disabled"));
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                class BaseRangeReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        const source = stream.source;
                        this._isStreamingSupported = !source.disableStream;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                function createRequestOptions(parsedUrl, headers) {
                    return {
                        protocol: parsedUrl.protocol,
                        auth: parsedUrl.auth,
                        host: parsedUrl.hostname,
                        port: parsedUrl.port,
                        path: parsedUrl.path,
                        method: "GET",
                        headers: headers
                    };
                }
                class PDFNodeStreamFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._headersCapability.resolve();
                            this._setReadableStream(response);
                            const getResponseHeader = (name)=>{
                                return this._readableStream.headers[name.toLowerCase()];
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("67wIF"));
                            this._request = http.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("67wIF"));
                            this._request = https.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                            this._headersCapability.reject(reason);
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        this._httpHeaders = {};
                        for(const property in stream.httpHeaders){
                            const value = stream.httpHeaders[property];
                            if (value === undefined) continue;
                            this._httpHeaders[property] = value;
                        }
                        this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                return;
                            }
                            this._setReadableStream(response);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("67wIF"));
                            this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("67wIF"));
                            this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamFsFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("67wIF"));
                        fs.lstat(path, (error, stat)=>{
                            if (error) {
                                if (error.code === "ENOENT") error = new _util.MissingPDFException(`Missing PDF "${path}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._contentLength = stat.size;
                            this._setReadableStream(fs.createReadStream(path));
                            this._headersCapability.resolve();
                        });
                    }
                }
                class PDFNodeStreamFsRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("67wIF"));
                        this._setReadableStream(fs.createReadStream(path, {
                            start: start,
                            end: end - 1
                        }));
                    }
                }
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SVGGraphics = void 0;
                var _display_utils = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(1);
                const SVG_DEFAULTS = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                const XML_NS = "http://www.w3.org/XML/1998/namespace";
                const XLINK_NS = "http://www.w3.org/1999/xlink";
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const createObjectURL = function(data, contentType = "", forceDataSchema = false) {
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    let buffer = `data:${contentType};base64,`;
                    for(let i = 0, ii = data.length; i < ii; i += 3){
                        const b1 = data[i] & 0xff;
                        const b2 = data[i + 1] & 0xff;
                        const b3 = data[i + 2] & 0xff;
                        const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        const d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        const d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                };
                const convertImgDataToPng = function() {
                    const PNG_HEADER = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    const CHUNK_WRAPPER_SIZE = 12;
                    const crcTable = new Int32Array(256);
                    for(let i = 0; i < 256; i++){
                        let c = i;
                        for(let h = 0; h < 8; h++)c = c & 1 ? 0xedb88320 ^ c >> 1 & 0x7fffffff : c >> 1 & 0x7fffffff;
                        crcTable[i] = c;
                    }
                    function crc32(data, start, end) {
                        let crc = -1;
                        for(let i = start; i < end; i++){
                            const a = (crc ^ data[i]) & 0xff;
                            const b = crcTable[a];
                            crc = crc >>> 8 ^ b;
                        }
                        return crc ^ -1;
                    }
                    function writePngChunk(type, body, data, offset) {
                        let p = offset;
                        const len = body.length;
                        data[p] = len >> 24 & 0xff;
                        data[p + 1] = len >> 16 & 0xff;
                        data[p + 2] = len >> 8 & 0xff;
                        data[p + 3] = len & 0xff;
                        p += 4;
                        data[p] = type.charCodeAt(0) & 0xff;
                        data[p + 1] = type.charCodeAt(1) & 0xff;
                        data[p + 2] = type.charCodeAt(2) & 0xff;
                        data[p + 3] = type.charCodeAt(3) & 0xff;
                        p += 4;
                        data.set(body, p);
                        p += body.length;
                        const crc = crc32(data, offset + 4, p);
                        data[p] = crc >> 24 & 0xff;
                        data[p + 1] = crc >> 16 & 0xff;
                        data[p + 2] = crc >> 8 & 0xff;
                        data[p + 3] = crc & 0xff;
                    }
                    function adler32(data, start, end) {
                        let a = 1;
                        let b = 0;
                        for(let i = start; i < end; ++i){
                            a = (a + (data[i] & 0xff)) % 65521;
                            b = (b + a) % 65521;
                        }
                        return b << 16 | a;
                    }
                    function deflateSync(literals) {
                        if (!_util.isNodeJS) return deflateSyncUncompressed(literals);
                        try {
                            const input = parseInt($hIXGI.versions.node) >= 8 ? literals : $70c197f8914c1458$require$Buffer.from(literals);
                            const output = (parcelRequire("67wIF")).deflateSync(input, {
                                level: 9
                            });
                            return output instanceof Uint8Array ? output : new Uint8Array(output);
                        } catch (e) {
                            (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                        }
                        return deflateSyncUncompressed(literals);
                    }
                    function deflateSyncUncompressed(literals) {
                        let len = literals.length;
                        const maxBlockLength = 0xffff;
                        const deflateBlocks = Math.ceil(len / maxBlockLength);
                        const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                        let pi = 0;
                        idat[pi++] = 0x78;
                        idat[pi++] = 0x9c;
                        let pos = 0;
                        while(len > maxBlockLength){
                            idat[pi++] = 0x00;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0x00;
                            idat[pi++] = 0x00;
                            idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                            pi += maxBlockLength;
                            pos += maxBlockLength;
                            len -= maxBlockLength;
                        }
                        idat[pi++] = 0x01;
                        idat[pi++] = len & 0xff;
                        idat[pi++] = len >> 8 & 0xff;
                        idat[pi++] = ~len & 255;
                        idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
                        idat.set(literals.subarray(pos), pi);
                        pi += literals.length - pos;
                        const adler = adler32(literals, 0, literals.length);
                        idat[pi++] = adler >> 24 & 0xff;
                        idat[pi++] = adler >> 16 & 0xff;
                        idat[pi++] = adler >> 8 & 0xff;
                        idat[pi++] = adler & 0xff;
                        return idat;
                    }
                    function encode(imgData, kind, forceDataSchema, isMask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        let bitDepth, colorType, lineSize;
                        const bytes = imgData.data;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                colorType = 0;
                                bitDepth = 1;
                                lineSize = width + 7 >> 3;
                                break;
                            case _util.ImageKind.RGB_24BPP:
                                colorType = 2;
                                bitDepth = 8;
                                lineSize = width * 3;
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                colorType = 6;
                                bitDepth = 8;
                                lineSize = width * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        const literals = new Uint8Array((1 + lineSize) * height);
                        let offsetLiterals = 0, offsetBytes = 0;
                        for(let y = 0; y < height; ++y){
                            literals[offsetLiterals++] = 0;
                            literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                            offsetBytes += lineSize;
                            offsetLiterals += lineSize;
                        }
                        if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
                            offsetLiterals = 0;
                            for(let y = 0; y < height; y++){
                                offsetLiterals++;
                                for(let i = 0; i < lineSize; i++)literals[offsetLiterals++] ^= 0xff;
                            }
                        }
                        const ihdr = new Uint8Array([
                            width >> 24 & 0xff,
                            width >> 16 & 0xff,
                            width >> 8 & 0xff,
                            width & 0xff,
                            height >> 24 & 0xff,
                            height >> 16 & 0xff,
                            height >> 8 & 0xff,
                            height & 0xff,
                            bitDepth,
                            colorType,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        const idat = deflateSync(literals);
                        const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                        const data = new Uint8Array(pngLength);
                        let offset = 0;
                        data.set(PNG_HEADER, offset);
                        offset += PNG_HEADER.length;
                        writePngChunk("IHDR", ihdr, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                        writePngChunk("IDATA", idat, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + idat.length;
                        writePngChunk("IEND", new Uint8Array(0), data, offset);
                        return createObjectURL(data, "image/png", forceDataSchema);
                    }
                    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
                        const kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                        return encode(imgData, kind, forceDataSchema, isMask);
                    };
                }();
                class SVGExtraState {
                    constructor(){
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    clone() {
                        return Object.create(this);
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                }
                function opListToTree(opList) {
                    let opTree = [];
                    const tmp = [];
                    for (const opListElement of opList){
                        if (opListElement.fn === "save") {
                            opTree.push({
                                fnId: 92,
                                fn: "group",
                                items: []
                            });
                            tmp.push(opTree);
                            opTree = opTree.at(-1).items;
                            continue;
                        }
                        if (opListElement.fn === "restore") opTree = tmp.pop();
                        else opTree.push(opListElement);
                    }
                    return opTree;
                }
                function pf(value) {
                    if (Number.isInteger(value)) return value.toString();
                    const s = value.toFixed(10);
                    let i = s.length - 1;
                    if (s[i] !== "0") return s;
                    do i--;
                    while (s[i] === "0");
                    return s.substring(0, s[i] === "." ? i : i + 1);
                }
                function pm(m) {
                    if (m[4] === 0 && m[5] === 0) {
                        if (m[1] === 0 && m[2] === 0) {
                            if (m[0] === 1 && m[3] === 1) return "";
                            return `scale(${pf(m[0])} ${pf(m[3])})`;
                        }
                        if (m[0] === m[3] && m[1] === -m[2]) {
                            const a = Math.acos(m[0]) * 180 / Math.PI;
                            return `rotate(${pf(a)})`;
                        }
                    } else if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) return `translate(${pf(m[4])} ${pf(m[5])})`;
                    return `matrix(${pf(m[0])} ${pf(m[1])} ${pf(m[2])} ${pf(m[3])} ${pf(m[4])} ` + `${pf(m[5])})`;
                }
                let clipCount = 0;
                let maskCount = 0;
                let shadingCount = 0;
                class SVGGraphics {
                    constructor(commonObjs, objs, forceDataSchema = false){
                        (0, _display_utils.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                        this.svgFactory = new _display_utils.DOMSVGFactory();
                        this.current = new SVGExtraState();
                        this.transformMatrix = _util.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema;
                        this._operatorIdMapping = [];
                        for(const op in _util.OPS)this._operatorIdMapping[_util.OPS[op]] = op;
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    save() {
                        this.transformStack.push(this.transformMatrix);
                        const old = this.current;
                        this.extraStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        this.transformMatrix = this.transformStack.pop();
                        this.current = this.extraStack.pop();
                        this.pendingClip = null;
                        this.tgrp = null;
                    }
                    group(items) {
                        this.save();
                        this.executeOpTree(items);
                        this.restore();
                    }
                    loadDependencies(operatorList) {
                        const fnArray = operatorList.fnArray;
                        const argsArray = operatorList.argsArray;
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            if (fnArray[i] !== _util.OPS.dependency) continue;
                            for (const obj of argsArray[i]){
                                const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
                                const promise = new Promise((resolve)=>{
                                    objsPool.get(obj, resolve);
                                });
                                this.current.dependencies.push(promise);
                            }
                        }
                        return Promise.all(this.current.dependencies);
                    }
                    transform(a, b, c, d, e, f) {
                        const transformMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
                        this.tgrp = null;
                    }
                    getSVG(operatorList, viewport) {
                        this.viewport = viewport;
                        const svgElement = this._initialize(viewport);
                        return this.loadDependencies(operatorList).then(()=>{
                            this.transformMatrix = _util.IDENTITY_MATRIX;
                            this.executeOpTree(this.convertOpList(operatorList));
                            return svgElement;
                        });
                    }
                    convertOpList(operatorList) {
                        const operatorIdMapping = this._operatorIdMapping;
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        const opList = [];
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            const fnId = fnArray[i];
                            opList.push({
                                fnId: fnId,
                                fn: operatorIdMapping[fnId],
                                args: argsArray[i]
                            });
                        }
                        return opListToTree(opList);
                    }
                    executeOpTree(opTree) {
                        for (const opTreeElement of opTree){
                            const fn = opTreeElement.fn;
                            const fnId = opTreeElement.fnId;
                            const args = opTreeElement.args;
                            switch(fnId | 0){
                                case _util.OPS.beginText:
                                    this.beginText();
                                    break;
                                case _util.OPS.dependency:
                                    break;
                                case _util.OPS.setLeading:
                                    this.setLeading(args);
                                    break;
                                case _util.OPS.setLeadingMoveText:
                                    this.setLeadingMoveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setFont:
                                    this.setFont(args);
                                    break;
                                case _util.OPS.showText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.showSpacedText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.endText:
                                    this.endText();
                                    break;
                                case _util.OPS.moveText:
                                    this.moveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setCharSpacing:
                                    this.setCharSpacing(args[0]);
                                    break;
                                case _util.OPS.setWordSpacing:
                                    this.setWordSpacing(args[0]);
                                    break;
                                case _util.OPS.setHScale:
                                    this.setHScale(args[0]);
                                    break;
                                case _util.OPS.setTextMatrix:
                                    this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.setTextRise:
                                    this.setTextRise(args[0]);
                                    break;
                                case _util.OPS.setTextRenderingMode:
                                    this.setTextRenderingMode(args[0]);
                                    break;
                                case _util.OPS.setLineWidth:
                                    this.setLineWidth(args[0]);
                                    break;
                                case _util.OPS.setLineJoin:
                                    this.setLineJoin(args[0]);
                                    break;
                                case _util.OPS.setLineCap:
                                    this.setLineCap(args[0]);
                                    break;
                                case _util.OPS.setMiterLimit:
                                    this.setMiterLimit(args[0]);
                                    break;
                                case _util.OPS.setFillRGBColor:
                                    this.setFillRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeRGBColor:
                                    this.setStrokeRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeColorN:
                                    this.setStrokeColorN(args);
                                    break;
                                case _util.OPS.setFillColorN:
                                    this.setFillColorN(args);
                                    break;
                                case _util.OPS.shadingFill:
                                    this.shadingFill(args[0]);
                                    break;
                                case _util.OPS.setDash:
                                    this.setDash(args[0], args[1]);
                                    break;
                                case _util.OPS.setRenderingIntent:
                                    this.setRenderingIntent(args[0]);
                                    break;
                                case _util.OPS.setFlatness:
                                    this.setFlatness(args[0]);
                                    break;
                                case _util.OPS.setGState:
                                    this.setGState(args[0]);
                                    break;
                                case _util.OPS.fill:
                                    this.fill();
                                    break;
                                case _util.OPS.eoFill:
                                    this.eoFill();
                                    break;
                                case _util.OPS.stroke:
                                    this.stroke();
                                    break;
                                case _util.OPS.fillStroke:
                                    this.fillStroke();
                                    break;
                                case _util.OPS.eoFillStroke:
                                    this.eoFillStroke();
                                    break;
                                case _util.OPS.clip:
                                    this.clip("nonzero");
                                    break;
                                case _util.OPS.eoClip:
                                    this.clip("evenodd");
                                    break;
                                case _util.OPS.paintSolidColorImageMask:
                                    this.paintSolidColorImageMask();
                                    break;
                                case _util.OPS.paintImageXObject:
                                    this.paintImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintInlineImageXObject:
                                    this.paintInlineImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintImageMaskXObject:
                                    this.paintImageMaskXObject(args[0]);
                                    break;
                                case _util.OPS.paintFormXObjectBegin:
                                    this.paintFormXObjectBegin(args[0], args[1]);
                                    break;
                                case _util.OPS.paintFormXObjectEnd:
                                    this.paintFormXObjectEnd();
                                    break;
                                case _util.OPS.closePath:
                                    this.closePath();
                                    break;
                                case _util.OPS.closeStroke:
                                    this.closeStroke();
                                    break;
                                case _util.OPS.closeFillStroke:
                                    this.closeFillStroke();
                                    break;
                                case _util.OPS.closeEOFillStroke:
                                    this.closeEOFillStroke();
                                    break;
                                case _util.OPS.nextLine:
                                    this.nextLine();
                                    break;
                                case _util.OPS.transform:
                                    this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.constructPath:
                                    this.constructPath(args[0], args[1]);
                                    break;
                                case _util.OPS.endPath:
                                    this.endPath();
                                    break;
                                case 92:
                                    this.group(opTreeElement.items);
                                    break;
                                default:
                                    (0, _util.warn)(`Unimplemented operator ${fn}`);
                                    break;
                            }
                        }
                    }
                    setWordSpacing(wordSpacing) {
                        this.current.wordSpacing = wordSpacing;
                    }
                    setCharSpacing(charSpacing) {
                        this.current.charSpacing = charSpacing;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        const current = this.current;
                        current.textMatrix = current.lineMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        current.textMatrixScale = Math.hypot(a, b);
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtElement.append(current.tspan);
                    }
                    beginText() {
                        const current = this.current;
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.textMatrix = _util.IDENTITY_MATRIX;
                        current.lineMatrix = _util.IDENTITY_MATRIX;
                        current.textMatrixScale = 1;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtgrp = this.svgFactory.createElement("svg:g");
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    moveText(x, y) {
                        const current = this.current;
                        current.x = current.lineX += x;
                        current.y = current.lineY += y;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        let x = 0;
                        for (const glyph of glyphs){
                            if (glyph === null) {
                                x += fontDirection * wordSpacing;
                                continue;
                            } else if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                let vx;
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                                vx = -vx * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (glyph.isInFont || font.missingFile) {
                                current.xcoords.push(current.x + scaledX);
                                if (vertical) current.ycoords.push(-current.y + scaledY);
                                current.tspan.textContent += character;
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                        }
                        current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                        if (vertical) current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                        else current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                        const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            if (current.fillColor !== SVG_DEFAULTS.fillColor) current.tspan.setAttributeNS(null, "fill", current.fillColor);
                            if (current.fillAlpha < 1) current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                        } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) current.tspan.setAttributeNS(null, "fill", "transparent");
                        else current.tspan.setAttributeNS(null, "fill", "none");
                        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            const lineWidthScale = 1 / (current.textMatrixScale || 1);
                            this._setStrokeAttributes(current.tspan, lineWidthScale);
                        }
                        let textMatrix = current.textMatrix;
                        if (current.textRise !== 0) {
                            textMatrix = textMatrix.slice();
                            textMatrix[5] += current.textRise;
                        }
                        current.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
                        current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                        current.txtElement.append(current.tspan);
                        current.txtgrp.append(current.txtElement);
                        this._ensureTransformGroup().append(current.txtElement);
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    addFontStyle(fontObj) {
                        if (!fontObj.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                        if (!this.cssStyle) {
                            this.cssStyle = this.svgFactory.createElement("svg:style");
                            this.cssStyle.setAttributeNS(null, "type", "text/css");
                            this.defs.append(this.cssStyle);
                        }
                        const url = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                        this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}";` + ` src: url(${url}); }\n`;
                    }
                    setFont(details) {
                        const current = this.current;
                        const fontObj = this.commonObjs.get(details[0]);
                        let size = details[1];
                        current.font = fontObj;
                        if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                            this.addFontStyle(fontObj);
                            this.embeddedFonts[fontObj.loadedName] = fontObj;
                        }
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        current.fontSize = size;
                        current.fontFamily = fontObj.loadedName;
                        current.fontWeight = bold;
                        current.fontStyle = italic;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    endText() {
                        const current = this.current;
                        if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement?.hasChildNodes()) {
                            current.element = current.txtElement;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    setLineWidth(width) {
                        if (width > 0) this.current.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.current.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.current.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.current.miterLimit = limit;
                    }
                    setStrokeAlpha(strokeAlpha) {
                        this.current.strokeAlpha = strokeAlpha;
                    }
                    setStrokeRGBColor(r, g, b) {
                        this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
                    }
                    setFillAlpha(fillAlpha) {
                        this.current.fillAlpha = fillAlpha;
                    }
                    setFillRGBColor(r, g, b) {
                        this.current.fillColor = _util.Util.makeHexColor(r, g, b);
                        this.current.tspan = this.svgFactory.createElement("svg:tspan");
                        this.current.xcoords = [];
                        this.current.ycoords = [];
                    }
                    setStrokeColorN(args) {
                        this.current.strokeColor = this._makeColorN_Pattern(args);
                    }
                    setFillColorN(args) {
                        this.current.fillColor = this._makeColorN_Pattern(args);
                    }
                    shadingFill(args) {
                        const { width, height } = this.viewport;
                        const inv = _util.Util.inverseTransform(this.transformMatrix);
                        const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                            0,
                            0,
                            width,
                            height
                        ], inv);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", x0);
                        rect.setAttributeNS(null, "y", y0);
                        rect.setAttributeNS(null, "width", x1 - x0);
                        rect.setAttributeNS(null, "height", y1 - y0);
                        rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                        if (this.current.fillAlpha < 1) rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                        this._ensureTransformGroup().append(rect);
                    }
                    _makeColorN_Pattern(args) {
                        if (args[0] === "TilingPattern") return this._makeTilingPattern(args);
                        return this._makeShadingPattern(args);
                    }
                    _makeTilingPattern(args) {
                        const color = args[1];
                        const operatorList = args[2];
                        const matrix = args[3] || _util.IDENTITY_MATRIX;
                        const [x0, y0, x1, y1] = args[4];
                        const xstep = args[5];
                        const ystep = args[6];
                        const paintType = args[7];
                        const tilingId = `shading${shadingCount++}`;
                        const [tx0, ty0, tx1, ty1] = _util.Util.normalizeRect([
                            ..._util.Util.applyTransform([
                                x0,
                                y0
                            ], matrix),
                            ..._util.Util.applyTransform([
                                x1,
                                y1
                            ], matrix)
                        ]);
                        const [xscale, yscale] = _util.Util.singularValueDecompose2dScale(matrix);
                        const txstep = xstep * xscale;
                        const tystep = ystep * yscale;
                        const tiling = this.svgFactory.createElement("svg:pattern");
                        tiling.setAttributeNS(null, "id", tilingId);
                        tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                        tiling.setAttributeNS(null, "width", txstep);
                        tiling.setAttributeNS(null, "height", tystep);
                        tiling.setAttributeNS(null, "x", `${tx0}`);
                        tiling.setAttributeNS(null, "y", `${ty0}`);
                        const svg = this.svg;
                        const transformMatrix = this.transformMatrix;
                        const fillColor = this.current.fillColor;
                        const strokeColor = this.current.strokeColor;
                        const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                        this.svg = bbox;
                        this.transformMatrix = matrix;
                        if (paintType === 2) {
                            const cssColor = _util.Util.makeHexColor(...color);
                            this.current.fillColor = cssColor;
                            this.current.strokeColor = cssColor;
                        }
                        this.executeOpTree(this.convertOpList(operatorList));
                        this.svg = svg;
                        this.transformMatrix = transformMatrix;
                        this.current.fillColor = fillColor;
                        this.current.strokeColor = strokeColor;
                        tiling.append(bbox.childNodes[0]);
                        this.defs.append(tiling);
                        return `url(#${tilingId})`;
                    }
                    _makeShadingPattern(args) {
                        if (typeof args === "string") args = this.objs.get(args);
                        switch(args[0]){
                            case "RadialAxial":
                                const shadingId = `shading${shadingCount++}`;
                                const colorStops = args[3];
                                let gradient;
                                switch(args[1]){
                                    case "axial":
                                        const point0 = args[4];
                                        const point1 = args[5];
                                        gradient = this.svgFactory.createElement("svg:linearGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "x1", point0[0]);
                                        gradient.setAttributeNS(null, "y1", point0[1]);
                                        gradient.setAttributeNS(null, "x2", point1[0]);
                                        gradient.setAttributeNS(null, "y2", point1[1]);
                                        break;
                                    case "radial":
                                        const focalPoint = args[4];
                                        const circlePoint = args[5];
                                        const focalRadius = args[6];
                                        const circleRadius = args[7];
                                        gradient = this.svgFactory.createElement("svg:radialGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "cx", circlePoint[0]);
                                        gradient.setAttributeNS(null, "cy", circlePoint[1]);
                                        gradient.setAttributeNS(null, "r", circleRadius);
                                        gradient.setAttributeNS(null, "fx", focalPoint[0]);
                                        gradient.setAttributeNS(null, "fy", focalPoint[1]);
                                        gradient.setAttributeNS(null, "fr", focalRadius);
                                        break;
                                    default:
                                        throw new Error(`Unknown RadialAxial type: ${args[1]}`);
                                }
                                for (const colorStop of colorStops){
                                    const stop = this.svgFactory.createElement("svg:stop");
                                    stop.setAttributeNS(null, "offset", colorStop[0]);
                                    stop.setAttributeNS(null, "stop-color", colorStop[1]);
                                    gradient.append(stop);
                                }
                                this.defs.append(gradient);
                                return `url(#${shadingId})`;
                            case "Mesh":
                                (0, _util.warn)("Unimplemented pattern Mesh");
                                return null;
                            case "Dummy":
                                return "hotpink";
                            default:
                                throw new Error(`Unknown IR type: ${args[0]}`);
                        }
                    }
                    setDash(dashArray, dashPhase) {
                        this.current.dashArray = dashArray;
                        this.current.dashPhase = dashPhase;
                    }
                    constructPath(ops, args) {
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let d = [];
                        let j = 0;
                        for (const op of ops)switch(op | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("M", pf(x), pf(y));
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("L", pf(x), pf(y));
                                break;
                            case _util.OPS.curveTo:
                                x = args[j + 4];
                                y = args[j + 5];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                x = args[j + 2];
                                y = args[j + 3];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                d.push("Z");
                                break;
                        }
                        d = d.join(" ");
                        if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) d = current.path.getAttributeNS(null, "d") + d;
                        else {
                            current.path = this.svgFactory.createElement("svg:path");
                            this._ensureTransformGroup().append(current.path);
                        }
                        current.path.setAttributeNS(null, "d", d);
                        current.path.setAttributeNS(null, "fill", "none");
                        current.element = current.path;
                        current.setCurrentPoint(x, y);
                    }
                    endPath() {
                        const current = this.current;
                        current.path = null;
                        if (!this.pendingClip) return;
                        if (!current.element) {
                            this.pendingClip = null;
                            return;
                        }
                        const clipId = `clippath${clipCount++}`;
                        const clipPath = this.svgFactory.createElement("svg:clipPath");
                        clipPath.setAttributeNS(null, "id", clipId);
                        clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                        const clipElement = current.element.cloneNode(true);
                        if (this.pendingClip === "evenodd") clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                        else clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                        this.pendingClip = null;
                        clipPath.append(clipElement);
                        this.defs.append(clipPath);
                        if (current.activeClipUrl) {
                            current.clipGroup = null;
                            for (const prev of this.extraStack)prev.clipGroup = null;
                            clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                        }
                        current.activeClipUrl = `url(#${clipId})`;
                        this.tgrp = null;
                    }
                    clip(type) {
                        this.pendingClip = type;
                    }
                    closePath() {
                        const current = this.current;
                        if (current.path) {
                            const d = `${current.path.getAttributeNS(null, "d")}Z`;
                            current.path.setAttributeNS(null, "d", d);
                        }
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setTextRise(textRise) {
                        this.current.textRise = textRise;
                    }
                    setTextRenderingMode(textRenderingMode) {
                        this.current.textRenderingMode = textRenderingMode;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value);
                                break;
                            case "CA":
                                this.setStrokeAlpha(value);
                                break;
                            case "ca":
                                this.setFillAlpha(value);
                                break;
                            default:
                                (0, _util.warn)(`Unimplemented graphic state operator ${key}`);
                                break;
                        }
                    }
                    fill() {
                        const current = this.current;
                        if (current.element) {
                            current.element.setAttributeNS(null, "fill", current.fillColor);
                            current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                            this.endPath();
                        }
                    }
                    stroke() {
                        const current = this.current;
                        if (current.element) {
                            this._setStrokeAttributes(current.element);
                            current.element.setAttributeNS(null, "fill", "none");
                            this.endPath();
                        }
                    }
                    _setStrokeAttributes(element, lineWidthScale = 1) {
                        const current = this.current;
                        let dashArray = current.dashArray;
                        if (lineWidthScale !== 1 && dashArray.length > 0) dashArray = dashArray.map(function(value) {
                            return lineWidthScale * value;
                        });
                        element.setAttributeNS(null, "stroke", current.strokeColor);
                        element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                        element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                        element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                        element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                        element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                        element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                        element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                    }
                    eoFill() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fill();
                    }
                    fillStroke() {
                        this.stroke();
                        this.fill();
                    }
                    eoFillStroke() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fillStroke();
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.closePath();
                        this.eoFillStroke();
                    }
                    paintSolidColorImageMask() {
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", "1px");
                        rect.setAttributeNS(null, "height", "1px");
                        rect.setAttributeNS(null, "fill", this.current.fillColor);
                        this._ensureTransformGroup().append(rect);
                    }
                    paintImageXObject(objId) {
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)(`Dependent image with object ID ${objId} is not ready yet`);
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintInlineImageXObject(imgData, mask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                        const cliprect = this.svgFactory.createElement("svg:rect");
                        cliprect.setAttributeNS(null, "x", "0");
                        cliprect.setAttributeNS(null, "y", "0");
                        cliprect.setAttributeNS(null, "width", pf(width));
                        cliprect.setAttributeNS(null, "height", pf(height));
                        this.current.element = cliprect;
                        this.clip("nonzero");
                        const imgEl = this.svgFactory.createElement("svg:image");
                        imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                        imgEl.setAttributeNS(null, "x", "0");
                        imgEl.setAttributeNS(null, "y", pf(-height));
                        imgEl.setAttributeNS(null, "width", pf(width) + "px");
                        imgEl.setAttributeNS(null, "height", pf(height) + "px");
                        imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width)} ${pf(-1 / height)})`);
                        if (mask) mask.append(imgEl);
                        else this._ensureTransformGroup().append(imgEl);
                    }
                    paintImageMaskXObject(img) {
                        const imgData = this.getObject(img.data, img);
                        if (imgData.bitmap) {
                            (0, _util.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                            return;
                        }
                        const current = this.current;
                        const width = imgData.width;
                        const height = imgData.height;
                        const fillColor = current.fillColor;
                        current.maskId = `mask${maskCount++}`;
                        const mask = this.svgFactory.createElement("svg:mask");
                        mask.setAttributeNS(null, "id", current.maskId);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", pf(width));
                        rect.setAttributeNS(null, "height", pf(height));
                        rect.setAttributeNS(null, "fill", fillColor);
                        rect.setAttributeNS(null, "mask", `url(#${current.maskId})`);
                        this.defs.append(mask);
                        this._ensureTransformGroup().append(rect);
                        this.paintInlineImageXObject(imgData, mask);
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            const cliprect = this.svgFactory.createElement("svg:rect");
                            cliprect.setAttributeNS(null, "x", bbox[0]);
                            cliprect.setAttributeNS(null, "y", bbox[1]);
                            cliprect.setAttributeNS(null, "width", pf(width));
                            cliprect.setAttributeNS(null, "height", pf(height));
                            this.current.element = cliprect;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {}
                    _initialize(viewport) {
                        const svg = this.svgFactory.create(viewport.width, viewport.height);
                        const definitions = this.svgFactory.createElement("svg:defs");
                        svg.append(definitions);
                        this.defs = definitions;
                        const rootGroup = this.svgFactory.createElement("svg:g");
                        rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                        svg.append(rootGroup);
                        this.svg = rootGroup;
                        return svg;
                    }
                    _ensureClipGroup() {
                        if (!this.current.clipGroup) {
                            const clipGroup = this.svgFactory.createElement("svg:g");
                            clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                            this.svg.append(clipGroup);
                            this.current.clipGroup = clipGroup;
                        }
                        return this.current.clipGroup;
                    }
                    _ensureTransformGroup() {
                        if (!this.tgrp) {
                            this.tgrp = this.svgFactory.createElement("svg:g");
                            this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                            if (this.current.activeClipUrl) this._ensureClipGroup().append(this.tgrp);
                            else this.svg.append(this.tgrp);
                        }
                        return this.tgrp;
                    }
                }
                exports.SVGGraphics = SVGGraphics;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaText = void 0;
                class XfaText {
                    static textContent(xfa) {
                        const items = [];
                        const output = {
                            items: items,
                            styles: Object.create(null)
                        };
                        function walk(node) {
                            if (!node) return;
                            let str = null;
                            const name = node.name;
                            if (name === "#text") str = node.value;
                            else if (!XfaText.shouldBuildText(name)) return;
                            else if (node?.attributes?.textContent) str = node.attributes.textContent;
                            else if (node.value) str = node.value;
                            if (str !== null) items.push({
                                str: str
                            });
                            if (!node.children) return;
                            for (const child of node.children)walk(child);
                        }
                        walk(xfa);
                        return output;
                    }
                    static shouldBuildText(name) {
                        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                    }
                }
                exports.XfaText = XfaText;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextLayerRenderTask = void 0;
                exports.renderTextLayer = renderTextLayer;
                exports.updateTextLayer = updateTextLayer;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const MAX_TEXT_DIVS_TO_RENDER = 100000;
                const DEFAULT_FONT_SIZE = 30;
                const DEFAULT_FONT_ASCENT = 0.8;
                const ascentCache = new Map();
                function getCtx(size, isOffscreenCanvasSupported) {
                    let ctx;
                    if (isOffscreenCanvasSupported && _util.FeatureTest.isOffscreenCanvasSupported) ctx = new OffscreenCanvas(size, size).getContext("2d", {
                        alpha: false
                    });
                    else {
                        const canvas = document.createElement("canvas");
                        canvas.width = canvas.height = size;
                        ctx = canvas.getContext("2d", {
                            alpha: false
                        });
                    }
                    return ctx;
                }
                function getAscent(fontFamily, isOffscreenCanvasSupported) {
                    const cachedAscent = ascentCache.get(fontFamily);
                    if (cachedAscent) return cachedAscent;
                    const ctx = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
                    ctx.font = `${DEFAULT_FONT_SIZE}px ${fontFamily}`;
                    const metrics = ctx.measureText("");
                    let ascent = metrics.fontBoundingBoxAscent;
                    let descent = Math.abs(metrics.fontBoundingBoxDescent);
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        ctx.canvas.width = ctx.canvas.height = 0;
                        return ratio;
                    }
                    ctx.strokeStyle = "red";
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("g", 0, 0);
                    let pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    descent = 0;
                    for(let i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
                        descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
                    pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    ascent = 0;
                    for(let i = 0, ii = pixels.length; i < ii; i += 4)if (pixels[i] > 0) {
                        ascent = DEFAULT_FONT_SIZE - Math.floor(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.canvas.width = ctx.canvas.height = 0;
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        return ratio;
                    }
                    ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                    return DEFAULT_FONT_ASCENT;
                }
                function appendText(task, geom, styles) {
                    const textDiv = document.createElement("span");
                    const textDivProperties = {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL,
                        fontSize: 0
                    };
                    task._textDivs.push(textDiv);
                    const tx = _util.Util.transform(task._transform, geom.transform);
                    let angle = Math.atan2(tx[1], tx[0]);
                    const style = styles[geom.fontName];
                    if (style.vertical) angle += Math.PI / 2;
                    const fontHeight = Math.hypot(tx[2], tx[3]);
                    const fontAscent = fontHeight * getAscent(style.fontFamily, task._isOffscreenCanvasSupported);
                    let left, top;
                    if (angle === 0) {
                        left = tx[4];
                        top = tx[5] - fontAscent;
                    } else {
                        left = tx[4] + fontAscent * Math.sin(angle);
                        top = tx[5] - fontAscent * Math.cos(angle);
                    }
                    const scaleFactorStr = "calc(var(--scale-factor)*";
                    const divStyle = textDiv.style;
                    if (task._container === task._rootContainer) {
                        divStyle.left = `${(100 * left / task._pageWidth).toFixed(2)}%`;
                        divStyle.top = `${(100 * top / task._pageHeight).toFixed(2)}%`;
                    } else {
                        divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
                        divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
                    }
                    divStyle.fontSize = `${scaleFactorStr}${fontHeight.toFixed(2)}px)`;
                    divStyle.fontFamily = style.fontFamily;
                    textDivProperties.fontSize = fontHeight;
                    textDiv.setAttribute("role", "presentation");
                    textDiv.textContent = geom.str;
                    textDiv.dir = geom.dir;
                    if (task._fontInspectorEnabled) textDiv.dataset.fontName = geom.fontName;
                    if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
                    let shouldScaleText = false;
                    if (geom.str.length > 1) shouldScaleText = true;
                    else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                        const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                        if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
                    }
                    if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
                    task._textDivProperties.set(textDiv, textDivProperties);
                    if (task._isReadableStream) task._layoutText(textDiv);
                }
                function layout(params) {
                    const { div, scale, properties, ctx, prevFontSize, prevFontFamily } = params;
                    const { style } = div;
                    let transform = "";
                    if (properties.canvasWidth !== 0 && properties.hasText) {
                        const { fontFamily } = style;
                        const { canvasWidth, fontSize } = properties;
                        if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                            ctx.font = `${fontSize * scale}px ${fontFamily}`;
                            params.prevFontSize = fontSize;
                            params.prevFontFamily = fontFamily;
                        }
                        const { width } = ctx.measureText(div.textContent);
                        if (width > 0) transform = `scaleX(${canvasWidth * scale / width})`;
                    }
                    if (properties.angle !== 0) transform = `rotate(${properties.angle}deg) ${transform}`;
                    if (transform.length > 0) style.transform = transform;
                }
                function render(task) {
                    if (task._canceled) return;
                    const textDivs = task._textDivs;
                    const capability = task._capability;
                    const textDivsLength = textDivs.length;
                    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                        capability.resolve();
                        return;
                    }
                    if (!task._isReadableStream) for (const textDiv of textDivs)task._layoutText(textDiv);
                    capability.resolve();
                }
                class TextLayerRenderTask {
                    constructor({ textContentSource, container, viewport, textDivs, textDivProperties, textContentItemsStr, isOffscreenCanvasSupported }){
                        this._textContentSource = textContentSource;
                        this._isReadableStream = textContentSource instanceof ReadableStream;
                        this._container = this._rootContainer = container;
                        this._textDivs = textDivs || [];
                        this._textContentItemsStr = textContentItemsStr || [];
                        this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
                        this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
                        this._reader = null;
                        this._textDivProperties = textDivProperties || new WeakMap();
                        this._canceled = false;
                        this._capability = new _util.PromiseCapability();
                        this._layoutTextParams = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: viewport.scale * (globalThis.devicePixelRatio || 1),
                            properties: null,
                            ctx: getCtx(0, isOffscreenCanvasSupported)
                        };
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        this._transform = [
                            1,
                            0,
                            0,
                            -1,
                            -pageX,
                            pageY + pageHeight
                        ];
                        this._pageWidth = pageWidth;
                        this._pageHeight = pageHeight;
                        (0, _display_utils.setLayerDimensions)(container, viewport);
                        this._capability.promise.finally(()=>{
                            this._layoutTextParams = null;
                        }).catch(()=>{});
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    cancel() {
                        this._canceled = true;
                        if (this._reader) {
                            this._reader.cancel(new _util.AbortException("TextLayer task cancelled.")).catch(()=>{});
                            this._reader = null;
                        }
                        this._capability.reject(new _util.AbortException("TextLayer task cancelled."));
                    }
                    _processItems(items, styleCache) {
                        for (const item of items){
                            if (item.str === undefined) {
                                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                                    const parent = this._container;
                                    this._container = document.createElement("span");
                                    this._container.classList.add("markedContent");
                                    if (item.id !== null) this._container.setAttribute("id", `${item.id}`);
                                    parent.append(this._container);
                                } else if (item.type === "endMarkedContent") this._container = this._container.parentNode;
                                continue;
                            }
                            this._textContentItemsStr.push(item.str);
                            appendText(this, item, styleCache);
                        }
                    }
                    _layoutText(textDiv) {
                        const textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
                        this._layoutTextParams.div = textDiv;
                        layout(this._layoutTextParams);
                        if (textDivProperties.hasText) this._container.append(textDiv);
                        if (textDivProperties.hasEOL) {
                            const br = document.createElement("br");
                            br.setAttribute("role", "presentation");
                            this._container.append(br);
                        }
                    }
                    _render() {
                        const capability = new _util.PromiseCapability();
                        let styleCache = Object.create(null);
                        if (this._isReadableStream) {
                            const pump = ()=>{
                                this._reader.read().then(({ value, done })=>{
                                    if (done) {
                                        capability.resolve();
                                        return;
                                    }
                                    Object.assign(styleCache, value.styles);
                                    this._processItems(value.items, styleCache);
                                    pump();
                                }, capability.reject);
                            };
                            this._reader = this._textContentSource.getReader();
                            pump();
                        } else if (this._textContentSource) {
                            const { items, styles } = this._textContentSource;
                            this._processItems(items, styles);
                            capability.resolve();
                        } else throw new Error('No "textContentSource" parameter specified.');
                        capability.promise.then(()=>{
                            styleCache = null;
                            render(this);
                        }, this._capability.reject);
                    }
                }
                exports.TextLayerRenderTask = TextLayerRenderTask;
                function renderTextLayer(params) {
                    if (!params.textContentSource && (params.textContent || params.textContentStream)) {
                        (0, _display_utils.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                        params.textContentSource = params.textContent || params.textContentStream;
                    }
                    const { container, viewport } = params;
                    const style = getComputedStyle(container);
                    const visibility = style.getPropertyValue("visibility");
                    const scaleFactor = parseFloat(style.getPropertyValue("--scale-factor"));
                    if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
                    const task = new TextLayerRenderTask(params);
                    task._render();
                    return task;
                }
                function updateTextLayer({ container, viewport, textDivs, textDivProperties, isOffscreenCanvasSupported, mustRotate = true, mustRescale = true }) {
                    if (mustRotate) (0, _display_utils.setLayerDimensions)(container, {
                        rotation: viewport.rotation
                    });
                    if (mustRescale) {
                        const ctx = getCtx(0, isOffscreenCanvasSupported);
                        const scale = viewport.scale * (globalThis.devicePixelRatio || 1);
                        const params = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: scale,
                            properties: null,
                            ctx: ctx
                        };
                        for (const div of textDivs){
                            params.properties = textDivProperties.get(div);
                            params.div = div;
                            layout(params);
                        }
                    }
                }
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditorLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _freetext = __w_pdfjs_require__(28);
                var _ink = __w_pdfjs_require__(33);
                var _display_utils = __w_pdfjs_require__(6);
                var _stamp = __w_pdfjs_require__(34);
                class AnnotationEditorLayer {
                    #accessibilityManager;
                    #allowClick = false;
                    #annotationLayer = null;
                    #boundPointerup = this.pointerup.bind(this);
                    #boundPointerdown = this.pointerdown.bind(this);
                    #editors = new Map();
                    #hadPointerDown = false;
                    #isCleaningUp = false;
                    #isDisabling = false;
                    #uiManager;
                    static _initialized = false;
                    constructor({ uiManager, pageIndex, div, accessibilityManager, annotationLayer, viewport, l10n }){
                        const editorTypes = [
                            _freetext.FreeTextEditor,
                            _ink.InkEditor,
                            _stamp.StampEditor
                        ];
                        if (!AnnotationEditorLayer._initialized) {
                            AnnotationEditorLayer._initialized = true;
                            for (const editorType of editorTypes)editorType.initialize(l10n);
                        }
                        uiManager.registerEditorTypes(editorTypes);
                        this.#uiManager = uiManager;
                        this.pageIndex = pageIndex;
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationLayer = annotationLayer;
                        this.viewport = viewport;
                        this.#uiManager.addLayer(this);
                    }
                    get isEmpty() {
                        return this.#editors.size === 0;
                    }
                    updateToolbar(mode) {
                        this.#uiManager.updateToolbar(mode);
                    }
                    updateMode(mode = this.#uiManager.getMode()) {
                        this.#cleanup();
                        if (mode === _util.AnnotationEditorType.INK) {
                            this.addInkEditorIfNeeded(false);
                            this.disableClick();
                        } else this.enableClick();
                        if (mode !== _util.AnnotationEditorType.NONE) {
                            this.div.classList.toggle("freeTextEditing", mode === _util.AnnotationEditorType.FREETEXT);
                            this.div.classList.toggle("inkEditing", mode === _util.AnnotationEditorType.INK);
                            this.div.classList.toggle("stampEditing", mode === _util.AnnotationEditorType.STAMP);
                            this.div.hidden = false;
                        }
                    }
                    addInkEditorIfNeeded(isCommitting) {
                        if (!isCommitting && this.#uiManager.getMode() !== _util.AnnotationEditorType.INK) return;
                        if (!isCommitting) {
                            for (const editor of this.#editors.values())if (editor.isEmpty()) {
                                editor.setInBackground();
                                return;
                            }
                        }
                        const editor = this.#createAndAddNewEditor({
                            offsetX: 0,
                            offsetY: 0
                        }, false);
                        editor.setInBackground();
                    }
                    setEditingState(isEditing) {
                        this.#uiManager.setEditingState(isEditing);
                    }
                    addCommands(params) {
                        this.#uiManager.addCommands(params);
                    }
                    enable() {
                        this.div.style.pointerEvents = "auto";
                        const annotationElementIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.enableEditing();
                            if (editor.annotationElementId) annotationElementIds.add(editor.annotationElementId);
                        }
                        if (!this.#annotationLayer) return;
                        const editables = this.#annotationLayer.getEditableAnnotations();
                        for (const editable of editables){
                            editable.hide();
                            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
                            if (annotationElementIds.has(editable.data.id)) continue;
                            const editor = this.deserialize(editable);
                            if (!editor) continue;
                            this.addOrRebuild(editor);
                            editor.enableEditing();
                        }
                    }
                    disable() {
                        this.#isDisabling = true;
                        this.div.style.pointerEvents = "none";
                        const hiddenAnnotationIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.disableEditing();
                            if (!editor.annotationElementId || editor.serialize() !== null) {
                                hiddenAnnotationIds.add(editor.annotationElementId);
                                continue;
                            }
                            this.getEditableAnnotation(editor.annotationElementId)?.show();
                            editor.remove();
                        }
                        if (this.#annotationLayer) {
                            const editables = this.#annotationLayer.getEditableAnnotations();
                            for (const editable of editables){
                                const { id } = editable.data;
                                if (hiddenAnnotationIds.has(id) || this.#uiManager.isDeletedAnnotationElement(id)) continue;
                                editable.show();
                            }
                        }
                        this.#cleanup();
                        if (this.isEmpty) this.div.hidden = true;
                        this.#isDisabling = false;
                    }
                    getEditableAnnotation(id) {
                        return this.#annotationLayer?.getEditableAnnotation(id) || null;
                    }
                    setActiveEditor(editor) {
                        const currentActive = this.#uiManager.getActive();
                        if (currentActive === editor) return;
                        this.#uiManager.setActiveEditor(editor);
                    }
                    enableClick() {
                        this.div.addEventListener("pointerdown", this.#boundPointerdown);
                        this.div.addEventListener("pointerup", this.#boundPointerup);
                    }
                    disableClick() {
                        this.div.removeEventListener("pointerdown", this.#boundPointerdown);
                        this.div.removeEventListener("pointerup", this.#boundPointerup);
                    }
                    attach(editor) {
                        this.#editors.set(editor.id, editor);
                        const { annotationElementId } = editor;
                        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
                    }
                    detach(editor) {
                        this.#editors.delete(editor.id);
                        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
                    }
                    remove(editor) {
                        this.detach(editor);
                        this.#uiManager.removeEditor(editor);
                        if (editor.div.contains(document.activeElement)) setTimeout(()=>{
                            this.#uiManager.focusMainContainer();
                        }, 0);
                        editor.div.remove();
                        editor.isAttachedToDOM = false;
                        if (!this.#isCleaningUp) this.addInkEditorIfNeeded(false);
                    }
                    changeParent(editor) {
                        if (editor.parent === this) return;
                        if (editor.annotationElementId) {
                            this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
                            _editor.AnnotationEditor.deleteAnnotationElement(editor);
                            editor.annotationElementId = null;
                        }
                        this.attach(editor);
                        editor.parent?.detach(editor);
                        editor.setParent(this);
                        if (editor.div && editor.isAttachedToDOM) {
                            editor.div.remove();
                            this.div.append(editor.div);
                        }
                    }
                    add(editor) {
                        this.changeParent(editor);
                        this.#uiManager.addEditor(editor);
                        this.attach(editor);
                        if (!editor.isAttachedToDOM) {
                            const div = editor.render();
                            this.div.append(div);
                            editor.isAttachedToDOM = true;
                        }
                        editor.fixAndSetPosition();
                        editor.onceAdded();
                        this.#uiManager.addToAnnotationStorage(editor);
                    }
                    moveEditorInDOM(editor) {
                        if (!editor.isAttachedToDOM) return;
                        const { activeElement } = document;
                        if (editor.div.contains(activeElement)) {
                            editor._focusEventsAllowed = false;
                            setTimeout(()=>{
                                if (!editor.div.contains(document.activeElement)) {
                                    editor.div.addEventListener("focusin", ()=>{
                                        editor._focusEventsAllowed = true;
                                    }, {
                                        once: true
                                    });
                                    activeElement.focus();
                                } else editor._focusEventsAllowed = true;
                            }, 0);
                        }
                        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
                    }
                    addOrRebuild(editor) {
                        if (editor.needsToBeRebuilt()) editor.rebuild();
                        else this.add(editor);
                    }
                    addUndoableEditor(editor) {
                        const cmd = ()=>editor._uiManager.rebuild(editor);
                        const undo = ()=>{
                            editor.remove();
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: false
                        });
                    }
                    getNextId() {
                        return this.#uiManager.getId();
                    }
                    #createNewEditor(params) {
                        switch(this.#uiManager.getMode()){
                            case _util.AnnotationEditorType.FREETEXT:
                                return new _freetext.FreeTextEditor(params);
                            case _util.AnnotationEditorType.INK:
                                return new _ink.InkEditor(params);
                            case _util.AnnotationEditorType.STAMP:
                                return new _stamp.StampEditor(params);
                        }
                        return null;
                    }
                    pasteEditor(mode, params) {
                        this.#uiManager.updateToolbar(mode);
                        this.#uiManager.updateMode(mode);
                        const { offsetX, offsetY } = this.#getCenterPoint();
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: offsetX,
                            y: offsetY,
                            uiManager: this.#uiManager,
                            isCentered: true,
                            ...params
                        });
                        if (editor) this.add(editor);
                    }
                    deserialize(data) {
                        switch(data.annotationType ?? data.annotationEditorType){
                            case _util.AnnotationEditorType.FREETEXT:
                                return _freetext.FreeTextEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.INK:
                                return _ink.InkEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.STAMP:
                                return _stamp.StampEditor.deserialize(data, this, this.#uiManager);
                        }
                        return null;
                    }
                    #createAndAddNewEditor(event, isCentered) {
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: event.offsetX,
                            y: event.offsetY,
                            uiManager: this.#uiManager,
                            isCentered: isCentered
                        });
                        if (editor) this.add(editor);
                        return editor;
                    }
                    #getCenterPoint() {
                        const { x, y, width, height } = this.div.getBoundingClientRect();
                        const tlX = Math.max(0, x);
                        const tlY = Math.max(0, y);
                        const brX = Math.min(window.innerWidth, x + width);
                        const brY = Math.min(window.innerHeight, y + height);
                        const centerX = (tlX + brX) / 2 - x;
                        const centerY = (tlY + brY) / 2 - y;
                        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
                            centerX,
                            centerY
                        ] : [
                            centerY,
                            centerX
                        ];
                        return {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                    }
                    addNewEditor() {
                        this.#createAndAddNewEditor(this.#getCenterPoint(), true);
                    }
                    setSelected(editor) {
                        this.#uiManager.setSelected(editor);
                    }
                    toggleSelected(editor) {
                        this.#uiManager.toggleSelected(editor);
                    }
                    isSelected(editor) {
                        return this.#uiManager.isSelected(editor);
                    }
                    unselect(editor) {
                        this.#uiManager.unselect(editor);
                    }
                    pointerup(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        if (!this.#hadPointerDown) return;
                        this.#hadPointerDown = false;
                        if (!this.#allowClick) {
                            this.#allowClick = true;
                            return;
                        }
                        if (this.#uiManager.getMode() === _util.AnnotationEditorType.STAMP) {
                            this.#uiManager.unselectAll();
                            return;
                        }
                        this.#createAndAddNewEditor(event, false);
                    }
                    pointerdown(event) {
                        if (this.#hadPointerDown) {
                            this.#hadPointerDown = false;
                            return;
                        }
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        this.#hadPointerDown = true;
                        const editor = this.#uiManager.getActive();
                        this.#allowClick = !editor || editor.isEmpty();
                    }
                    findNewParent(editor, x, y) {
                        const layer = this.#uiManager.findParent(x, y);
                        if (layer === null || layer === this) return false;
                        layer.changeParent(editor);
                        return true;
                    }
                    destroy() {
                        if (this.#uiManager.getActive()?.parent === this) {
                            this.#uiManager.commitOrRemove();
                            this.#uiManager.setActiveEditor(null);
                        }
                        for (const editor of this.#editors.values()){
                            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                            editor.setParent(null);
                            editor.isAttachedToDOM = false;
                            editor.div.remove();
                        }
                        this.div = null;
                        this.#editors.clear();
                        this.#uiManager.removeLayer(this);
                    }
                    #cleanup() {
                        this.#isCleaningUp = true;
                        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
                        this.#isCleaningUp = false;
                    }
                    render({ viewport }) {
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, viewport);
                        for (const editor of this.#uiManager.getEditors(this.pageIndex))this.add(editor);
                        this.updateMode();
                    }
                    update({ viewport }) {
                        this.#uiManager.commitOrRemove();
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, {
                            rotation: viewport.rotation
                        });
                        this.updateMode();
                    }
                    get pageDimensions() {
                        const { pageWidth, pageHeight } = this.viewport.rawDims;
                        return [
                            pageWidth,
                            pageHeight
                        ];
                    }
                }
                exports.AnnotationEditorLayer = AnnotationEditorLayer;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FreeTextEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _tools = __w_pdfjs_require__(5);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                class FreeTextEditor extends _editor.AnnotationEditor {
                    #boundEditorDivBlur = this.editorDivBlur.bind(this);
                    #boundEditorDivFocus = this.editorDivFocus.bind(this);
                    #boundEditorDivInput = this.editorDivInput.bind(this);
                    #boundEditorDivKeydown = this.editorDivKeydown.bind(this);
                    #color;
                    #content = "";
                    #editorDivId = `${this.id}-editor`;
                    #fontSize;
                    #initialData = null;
                    static _freeTextDefaultContent = "";
                    static _internalPadding = 0;
                    static _defaultColor = null;
                    static _defaultFontSize = 10;
                    static get _keyboardManager() {
                        const proto = FreeTextEditor.prototype;
                        const arrowChecker = (self)=>self.isEmpty();
                        const small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
                        const big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([
                            [
                                [
                                    "ctrl+s",
                                    "mac+meta+s",
                                    "ctrl+p",
                                    "mac+meta+p"
                                ],
                                proto.commitOrRemove,
                                {
                                    bubbles: true
                                }
                            ],
                            [
                                [
                                    "ctrl+Enter",
                                    "mac+meta+Enter",
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.commitOrRemove
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    static _type = "freetext";
                    constructor(params){
                        super({
                            ...params,
                            name: "freeTextEditor"
                        });
                        this.#color = params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                        this.#fontSize = params.fontSize || FreeTextEditor._defaultFontSize;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "free_text2_default_content",
                                "editor_free_text2_aria_label"
                            ]
                        });
                        const style = getComputedStyle(document.documentElement);
                        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                FreeTextEditor._defaultFontSize = value;
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                FreeTextEditor._defaultColor = value;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                this.#updateFontSize(value);
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                this.#updateColor(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                FreeTextEditor._defaultFontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                this.#fontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                this.#color
                            ]
                        ];
                    }
                    #updateFontSize(fontSize) {
                        const setFontsize = (size)=>{
                            this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
                            this.translate(0, -(size - this.#fontSize) * this.parentScale);
                            this.#fontSize = size;
                            this.#setEditorDimensions();
                        };
                        const savedFontsize = this.#fontSize;
                        this.addCommands({
                            cmd: ()=>{
                                setFontsize(fontSize);
                            },
                            undo: ()=>{
                                setFontsize(savedFontsize);
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.#color;
                        this.addCommands({
                            cmd: ()=>{
                                this.#color = this.editorDiv.style.color = color;
                            },
                            undo: ()=>{
                                this.#color = this.editorDiv.style.color = savedColor;
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    _translateEmpty(x, y) {
                        this._uiManager.translateSelectedEditors(x, y, true);
                    }
                    getInitialTranslation() {
                        const scale = this.parentScale;
                        return [
                            -FreeTextEditor._internalPadding * scale,
                            -(FreeTextEditor._internalPadding + this.#fontSize) * scale
                        ];
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    enableEditMode() {
                        if (this.isInEditMode()) return;
                        this.parent.setEditingState(false);
                        this.parent.updateToolbar(_util.AnnotationEditorType.FREETEXT);
                        super.enableEditMode();
                        this.overlayDiv.classList.remove("enabled");
                        this.editorDiv.contentEditable = true;
                        this._isDraggable = false;
                        this.div.removeAttribute("aria-activedescendant");
                        this.editorDiv.addEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.addEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.addEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.addEventListener("input", this.#boundEditorDivInput);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode()) return;
                        this.parent.setEditingState(true);
                        super.disableEditMode();
                        this.overlayDiv.classList.add("enabled");
                        this.editorDiv.contentEditable = false;
                        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
                        this._isDraggable = true;
                        this.editorDiv.removeEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.removeEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.removeEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.removeEventListener("input", this.#boundEditorDivInput);
                        this.div.focus({
                            preventScroll: true
                        });
                        this.isEditing = false;
                        this.parent.div.classList.add("freeTextEditing");
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        if (event.target !== this.editorDiv) this.editorDiv.focus();
                    }
                    onceAdded() {
                        if (this.width) {
                            this.#cheatInitialRect();
                            return;
                        }
                        this.enableEditMode();
                        this.editorDiv.focus();
                        if (this._initialOptions?.isCentered) this.center();
                        this._initialOptions = null;
                    }
                    isEmpty() {
                        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
                    }
                    remove() {
                        this.isEditing = false;
                        if (this.parent) {
                            this.parent.setEditingState(true);
                            this.parent.div.classList.add("freeTextEditing");
                        }
                        super.remove();
                    }
                    #extractText() {
                        const divs = this.editorDiv.getElementsByTagName("div");
                        if (divs.length === 0) return this.editorDiv.innerText;
                        const buffer = [];
                        for (const div of divs)buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
                        return buffer.join("\n");
                    }
                    #setEditorDimensions() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        let rect;
                        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
                        else {
                            const { currentLayer, div } = this;
                            const savedDisplay = div.style.display;
                            div.style.display = "hidden";
                            currentLayer.div.append(this.div);
                            rect = div.getBoundingClientRect();
                            div.remove();
                            div.style.display = savedDisplay;
                        }
                        if (this.rotation % 180 === this.parentRotation % 180) {
                            this.width = rect.width / parentWidth;
                            this.height = rect.height / parentHeight;
                        } else {
                            this.width = rect.height / parentWidth;
                            this.height = rect.width / parentHeight;
                        }
                        this.fixAndSetPosition();
                    }
                    commit() {
                        if (!this.isInEditMode()) return;
                        super.commit();
                        this.disableEditMode();
                        const savedText = this.#content;
                        const newText = this.#content = this.#extractText().trimEnd();
                        if (savedText === newText) return;
                        const setText = (text)=>{
                            this.#content = text;
                            if (!text) {
                                this.remove();
                                return;
                            }
                            this.#setContent();
                            this._uiManager.rebuild(this);
                            this.#setEditorDimensions();
                        };
                        this.addCommands({
                            cmd: ()=>{
                                setText(newText);
                            },
                            undo: ()=>{
                                setText(savedText);
                            },
                            mustExec: false
                        });
                        this.#setEditorDimensions();
                    }
                    shouldGetKeyboardEvents() {
                        return this.isInEditMode();
                    }
                    enterInEditMode() {
                        this.enableEditMode();
                        this.editorDiv.focus();
                    }
                    dblclick(event) {
                        this.enterInEditMode();
                    }
                    keydown(event) {
                        if (event.target === this.div && event.key === "Enter") {
                            this.enterInEditMode();
                            event.preventDefault();
                        }
                    }
                    editorDivKeydown(event) {
                        FreeTextEditor._keyboardManager.exec(this, event);
                    }
                    editorDivFocus(event) {
                        this.isEditing = true;
                    }
                    editorDivBlur(event) {
                        this.isEditing = false;
                    }
                    editorDivInput(event) {
                        this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
                    }
                    disableEditing() {
                        this.editorDiv.setAttribute("role", "comment");
                        this.editorDiv.removeAttribute("aria-multiline");
                    }
                    enableEditing() {
                        this.editorDiv.setAttribute("role", "textbox");
                        this.editorDiv.setAttribute("aria-multiline", true);
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.editorDiv = document.createElement("div");
                        this.editorDiv.className = "internal";
                        this.editorDiv.setAttribute("id", this.#editorDivId);
                        this.enableEditing();
                        _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((msg)=>this.editorDiv?.setAttribute("aria-label", msg));
                        _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((msg)=>this.editorDiv?.setAttribute("default-content", msg));
                        this.editorDiv.contentEditable = true;
                        const { style } = this.editorDiv;
                        style.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
                        style.color = this.#color;
                        this.div.append(this.editorDiv);
                        this.overlayDiv = document.createElement("div");
                        this.overlayDiv.classList.add("overlay", "enabled");
                        this.div.append(this.overlayDiv);
                        (0, _tools.bindEvents)(this, this.div, [
                            "dblclick",
                            "keydown"
                        ]);
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            if (this.annotationElementId) {
                                const { position } = this.#initialData;
                                let [tx, ty] = this.getInitialTranslation();
                                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                                const [pageWidth, pageHeight] = this.pageDimensions;
                                const [pageX, pageY] = this.pageTranslation;
                                let posX, posY;
                                switch(this.rotation){
                                    case 0:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                                        break;
                                    case 90:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            ty,
                                            -tx
                                        ];
                                        break;
                                    case 180:
                                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            -tx,
                                            -ty
                                        ];
                                        break;
                                    case 270:
                                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                                        [tx, ty] = [
                                            -ty,
                                            tx
                                        ];
                                        break;
                                }
                                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
                            } else this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#setContent();
                            this._isDraggable = true;
                            this.editorDiv.contentEditable = false;
                        } else {
                            this._isDraggable = false;
                            this.editorDiv.contentEditable = true;
                        }
                        return this.div;
                    }
                    #setContent() {
                        this.editorDiv.replaceChildren();
                        if (!this.#content) return;
                        for (const line of this.#content.split("\n")){
                            const div = document.createElement("div");
                            div.append(line ? document.createTextNode(line) : document.createElement("br"));
                            this.editorDiv.append(div);
                        }
                    }
                    get contentDiv() {
                        return this.editorDiv;
                    }
                    static deserialize(data, parent, uiManager) {
                        let initialData = null;
                        if (data instanceof _annotation_layer.FreeTextAnnotationElement) {
                            const { data: { defaultAppearanceData: { fontSize, fontColor }, rect, rotation, id }, textContent, textPosition, parent: { page: { pageNumber } } } = data;
                            if (!textContent || textContent.length === 0) return null;
                            initialData = data = {
                                annotationType: _util.AnnotationEditorType.FREETEXT,
                                color: Array.from(fontColor),
                                fontSize: fontSize,
                                value: textContent.join("\n"),
                                position: textPosition,
                                pageIndex: pageNumber - 1,
                                rect: rect,
                                rotation: rotation,
                                id: id,
                                deleted: false
                            };
                        }
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.#fontSize = data.fontSize;
                        editor.#color = _util.Util.makeHexColor(...data.color);
                        editor.#content = data.value;
                        editor.annotationElementId = data.id || null;
                        editor.#initialData = initialData;
                        return editor;
                    }
                    serialize(isForCopying = false) {
                        if (this.isEmpty()) return null;
                        if (this.deleted) return {
                            pageIndex: this.pageIndex,
                            id: this.annotationElementId,
                            deleted: true
                        };
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        const rect = this.getRect(padding, padding);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#color);
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.FREETEXT,
                            color: color,
                            fontSize: this.#fontSize,
                            value: this.#content,
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) return serialized;
                        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
                        serialized.id = this.annotationElementId;
                        return serialized;
                    }
                    #hasElementChanged(serialized) {
                        const { value, fontSize, color, rect, pageIndex } = this.#initialData;
                        return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some((x, i)=>Math.abs(x - rect[i]) >= 1) || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
                    }
                    #cheatInitialRect(delayed = false) {
                        if (!this.annotationElementId) return;
                        this.#setEditorDimensions();
                        if (!delayed && (this.width === 0 || this.height === 0)) {
                            setTimeout(()=>this.#cheatInitialRect(true), 0);
                            return;
                        }
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        this.#initialData.rect = this.getRect(padding, padding);
                    }
                }
                exports.FreeTextEditor = FreeTextEditor;
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampAnnotationElement = exports.InkAnnotationElement = exports.FreeTextAnnotationElement = exports.AnnotationLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _scripting_utils = __w_pdfjs_require__(30);
                var _displayL10n_utils = __w_pdfjs_require__(31);
                var _xfa_layer = __w_pdfjs_require__(32);
                const DEFAULT_TAB_INDEX = 1000;
                const DEFAULT_FONT_SIZE = 9;
                const GetElementsByNameSet = new WeakSet();
                function getRectDims(rect) {
                    return {
                        width: rect[2] - rect[0],
                        height: rect[3] - rect[1]
                    };
                }
                class AnnotationElementFactory {
                    static create(parameters) {
                        const subtype = parameters.data.annotationType;
                        switch(subtype){
                            case _util.AnnotationType.LINK:
                                return new LinkAnnotationElement(parameters);
                            case _util.AnnotationType.TEXT:
                                return new TextAnnotationElement(parameters);
                            case _util.AnnotationType.WIDGET:
                                const fieldType = parameters.data.fieldType;
                                switch(fieldType){
                                    case "Tx":
                                        return new TextWidgetAnnotationElement(parameters);
                                    case "Btn":
                                        if (parameters.data.radioButton) return new RadioButtonWidgetAnnotationElement(parameters);
                                        else if (parameters.data.checkBox) return new CheckboxWidgetAnnotationElement(parameters);
                                        return new PushButtonWidgetAnnotationElement(parameters);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotationElement(parameters);
                                    case "Sig":
                                        return new SignatureWidgetAnnotationElement(parameters);
                                }
                                return new WidgetAnnotationElement(parameters);
                            case _util.AnnotationType.POPUP:
                                return new PopupAnnotationElement(parameters);
                            case _util.AnnotationType.FREETEXT:
                                return new FreeTextAnnotationElement(parameters);
                            case _util.AnnotationType.LINE:
                                return new LineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUARE:
                                return new SquareAnnotationElement(parameters);
                            case _util.AnnotationType.CIRCLE:
                                return new CircleAnnotationElement(parameters);
                            case _util.AnnotationType.POLYLINE:
                                return new PolylineAnnotationElement(parameters);
                            case _util.AnnotationType.CARET:
                                return new CaretAnnotationElement(parameters);
                            case _util.AnnotationType.INK:
                                return new InkAnnotationElement(parameters);
                            case _util.AnnotationType.POLYGON:
                                return new PolygonAnnotationElement(parameters);
                            case _util.AnnotationType.HIGHLIGHT:
                                return new HighlightAnnotationElement(parameters);
                            case _util.AnnotationType.UNDERLINE:
                                return new UnderlineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUIGGLY:
                                return new SquigglyAnnotationElement(parameters);
                            case _util.AnnotationType.STRIKEOUT:
                                return new StrikeOutAnnotationElement(parameters);
                            case _util.AnnotationType.STAMP:
                                return new StampAnnotationElement(parameters);
                            case _util.AnnotationType.FILEATTACHMENT:
                                return new FileAttachmentAnnotationElement(parameters);
                            default:
                                return new AnnotationElement(parameters);
                        }
                    }
                }
                class AnnotationElement {
                    #hasBorder = false;
                    constructor(parameters, { isRenderable = false, ignoreBorder = false, createQuadrilaterals = false } = {}){
                        this.isRenderable = isRenderable;
                        this.data = parameters.data;
                        this.layer = parameters.layer;
                        this.linkService = parameters.linkService;
                        this.downloadManager = parameters.downloadManager;
                        this.imageResourcesPath = parameters.imageResourcesPath;
                        this.renderForms = parameters.renderForms;
                        this.svgFactory = parameters.svgFactory;
                        this.annotationStorage = parameters.annotationStorage;
                        this.enableScripting = parameters.enableScripting;
                        this.hasJSActions = parameters.hasJSActions;
                        this._fieldObjects = parameters.fieldObjects;
                        this.parent = parameters.parent;
                        if (isRenderable) this.container = this._createContainer(ignoreBorder);
                        if (createQuadrilaterals) this._createQuadrilaterals();
                    }
                    static _hasPopupData({ titleObj, contentsObj, richText }) {
                        return !!(titleObj?.str || contentsObj?.str || richText?.str);
                    }
                    get hasPopupData() {
                        return AnnotationElement._hasPopupData(this.data);
                    }
                    _createContainer(ignoreBorder) {
                        const { data, parent: { page, viewport } } = this;
                        const container = document.createElement("section");
                        container.setAttribute("data-annotation-id", data.id);
                        if (!(this instanceof WidgetAnnotationElement)) container.tabIndex = DEFAULT_TAB_INDEX;
                        container.style.zIndex = this.parent.zIndex++;
                        if (this.data.popupRef) container.setAttribute("aria-haspopup", "dialog");
                        if (data.noRotate) container.classList.add("norotate");
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        if (!data.rect || this instanceof PopupAnnotationElement) {
                            const { rotation } = data;
                            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
                            return container;
                        }
                        const { width, height } = getRectDims(data.rect);
                        const rect = _util.Util.normalizeRect([
                            data.rect[0],
                            page.view[3] - data.rect[1] + page.view[1],
                            data.rect[2],
                            page.view[3] - data.rect[3] + page.view[1]
                        ]);
                        if (!ignoreBorder && data.borderStyle.width > 0) {
                            container.style.borderWidth = `${data.borderStyle.width}px`;
                            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
                            const verticalRadius = data.borderStyle.verticalCornerRadius;
                            if (horizontalRadius > 0 || verticalRadius > 0) {
                                const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                                const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            }
                            switch(data.borderStyle.style){
                                case _util.AnnotationBorderStyleType.SOLID:
                                    container.style.borderStyle = "solid";
                                    break;
                                case _util.AnnotationBorderStyleType.DASHED:
                                    container.style.borderStyle = "dashed";
                                    break;
                                case _util.AnnotationBorderStyleType.BEVELED:
                                    (0, _util.warn)("Unimplemented border style: beveled");
                                    break;
                                case _util.AnnotationBorderStyleType.INSET:
                                    (0, _util.warn)("Unimplemented border style: inset");
                                    break;
                                case _util.AnnotationBorderStyleType.UNDERLINE:
                                    container.style.borderBottomStyle = "solid";
                                    break;
                                default:
                                    break;
                            }
                            const borderColor = data.borderColor || null;
                            if (borderColor) {
                                this.#hasBorder = true;
                                container.style.borderColor = _util.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
                            } else container.style.borderWidth = 0;
                        }
                        container.style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
                        container.style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
                        const { rotation } = data;
                        if (data.hasOwnCanvas || rotation === 0) {
                            container.style.width = `${100 * width / pageWidth}%`;
                            container.style.height = `${100 * height / pageHeight}%`;
                        } else this.setRotation(rotation, container);
                        return container;
                    }
                    setRotation(angle, container = this.container) {
                        if (!this.data.rect) return;
                        const { pageWidth, pageHeight } = this.parent.viewport.rawDims;
                        const { width, height } = getRectDims(this.data.rect);
                        let elementWidth, elementHeight;
                        if (angle % 180 === 0) {
                            elementWidth = 100 * width / pageWidth;
                            elementHeight = 100 * height / pageHeight;
                        } else {
                            elementWidth = 100 * height / pageWidth;
                            elementHeight = 100 * width / pageHeight;
                        }
                        container.style.width = `${elementWidth}%`;
                        container.style.height = `${elementHeight}%`;
                        container.setAttribute("data-main-rotation", (360 - angle) % 360);
                    }
                    get _commonActions() {
                        const setColor = (jsName, styleName, event)=>{
                            const color = event.detail[jsName];
                            const colorType = color[0];
                            const colorArray = color.slice(1);
                            event.target.style[styleName] = _scripting_utils.ColorConverters[`${colorType}_HTML`](colorArray);
                            this.annotationStorage.setValue(this.data.id, {
                                [styleName]: _scripting_utils.ColorConverters[`${colorType}_rgb`](colorArray)
                            });
                        };
                        return (0, _util.shadow)(this, "_commonActions", {
                            display: (event)=>{
                                const { display } = event.detail;
                                const hidden = display % 2 === 1;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noView: hidden,
                                    noPrint: display === 1 || display === 2
                                });
                            },
                            print: (event)=>{
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: !event.detail.print
                                });
                            },
                            hidden: (event)=>{
                                const { hidden } = event.detail;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: hidden,
                                    noView: hidden
                                });
                            },
                            focus: (event)=>{
                                setTimeout(()=>event.target.focus({
                                        preventScroll: false
                                    }), 0);
                            },
                            userName: (event)=>{
                                event.target.title = event.detail.userName;
                            },
                            readonly: (event)=>{
                                event.target.disabled = event.detail.readonly;
                            },
                            required: (event)=>{
                                this._setRequired(event.target, event.detail.required);
                            },
                            bgColor: (event)=>{
                                setColor("bgColor", "backgroundColor", event);
                            },
                            fillColor: (event)=>{
                                setColor("fillColor", "backgroundColor", event);
                            },
                            fgColor: (event)=>{
                                setColor("fgColor", "color", event);
                            },
                            textColor: (event)=>{
                                setColor("textColor", "color", event);
                            },
                            borderColor: (event)=>{
                                setColor("borderColor", "borderColor", event);
                            },
                            strokeColor: (event)=>{
                                setColor("strokeColor", "borderColor", event);
                            },
                            rotation: (event)=>{
                                const angle = event.detail.rotation;
                                this.setRotation(angle);
                                this.annotationStorage.setValue(this.data.id, {
                                    rotation: angle
                                });
                            }
                        });
                    }
                    _dispatchEventFromSandbox(actions, jsEvent) {
                        const commonActions = this._commonActions;
                        for (const name of Object.keys(jsEvent.detail)){
                            const action = actions[name] || commonActions[name];
                            action?.(jsEvent);
                        }
                    }
                    _setDefaultPropertiesFromJS(element) {
                        if (!this.enableScripting) return;
                        const storedData = this.annotationStorage.getRawValue(this.data.id);
                        if (!storedData) return;
                        const commonActions = this._commonActions;
                        for (const [actionName, detail] of Object.entries(storedData)){
                            const action = commonActions[actionName];
                            if (action) {
                                const eventProxy = {
                                    detail: {
                                        [actionName]: detail
                                    },
                                    target: element
                                };
                                action(eventProxy);
                                delete storedData[actionName];
                            }
                        }
                    }
                    _createQuadrilaterals() {
                        if (!this.container) return;
                        const { quadPoints } = this.data;
                        if (!quadPoints) return;
                        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect;
                        if (quadPoints.length === 1) {
                            const [, { x: trX, y: trY }, { x: blX, y: blY }] = quadPoints[0];
                            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
                        }
                        const { style } = this.container;
                        let svgBuffer;
                        if (this.#hasBorder) {
                            const { borderColor, borderWidth } = style;
                            style.borderWidth = 0;
                            svgBuffer = [
                                "url('data:image/svg+xml;utf8,",
                                `<svg xmlns="http://www.w3.org/2000/svg"`,
                                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
                            ];
                            this.container.classList.add("hasBorder");
                        }
                        const width = rectTrX - rectBlX;
                        const height = rectTrY - rectBlY;
                        const { svgFactory } = this;
                        const svg = svgFactory.createElement("svg");
                        svg.classList.add("quadrilateralsContainer");
                        svg.setAttribute("width", 0);
                        svg.setAttribute("height", 0);
                        const defs = svgFactory.createElement("defs");
                        svg.append(defs);
                        const clipPath = svgFactory.createElement("clipPath");
                        const id = `clippath_${this.data.id}`;
                        clipPath.setAttribute("id", id);
                        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                        defs.append(clipPath);
                        for (const [, { x: trX, y: trY }, { x: blX, y: blY }] of quadPoints){
                            const rect = svgFactory.createElement("rect");
                            const x = (blX - rectBlX) / width;
                            const y = (rectTrY - trY) / height;
                            const rectWidth = (trX - blX) / width;
                            const rectHeight = (trY - blY) / height;
                            rect.setAttribute("x", x);
                            rect.setAttribute("y", y);
                            rect.setAttribute("width", rectWidth);
                            rect.setAttribute("height", rectHeight);
                            clipPath.append(rect);
                            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
                        }
                        if (this.#hasBorder) {
                            svgBuffer.push(`</g></svg>')`);
                            style.backgroundImage = svgBuffer.join("");
                        }
                        this.container.append(svg);
                        this.container.style.clipPath = `url(#${id})`;
                    }
                    _createPopup() {
                        const { container, data } = this;
                        container.setAttribute("aria-haspopup", "dialog");
                        const popup = new PopupAnnotationElement({
                            data: {
                                color: data.color,
                                titleObj: data.titleObj,
                                modificationDate: data.modificationDate,
                                contentsObj: data.contentsObj,
                                richText: data.richText,
                                parentRect: data.rect,
                                borderStyle: 0,
                                id: `popup_${data.id}`,
                                rotation: data.rotation
                            },
                            parent: this.parent,
                            elements: [
                                this
                            ]
                        });
                        this.parent.div.append(popup.render());
                    }
                    render() {
                        (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
                    }
                    _getElementsByName(name, skipId = null) {
                        const fields = [];
                        if (this._fieldObjects) {
                            const fieldObj = this._fieldObjects[name];
                            if (fieldObj) for (const { page, id, exportValues } of fieldObj){
                                if (page === -1) continue;
                                if (id === skipId) continue;
                                const exportValue = typeof exportValues === "string" ? exportValues : null;
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (domElement && !GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_getElementsByName - element not allowed: ${id}`);
                                    continue;
                                }
                                fields.push({
                                    id: id,
                                    exportValue: exportValue,
                                    domElement: domElement
                                });
                            }
                            return fields;
                        }
                        for (const domElement of document.getElementsByName(name)){
                            const { exportValue } = domElement;
                            const id = domElement.getAttribute("data-element-id");
                            if (id === skipId) continue;
                            if (!GetElementsByNameSet.has(domElement)) continue;
                            fields.push({
                                id: id,
                                exportValue: exportValue,
                                domElement: domElement
                            });
                        }
                        return fields;
                    }
                    show() {
                        if (this.container) this.container.hidden = false;
                        this.popup?.maybeShow();
                    }
                    hide() {
                        if (this.container) this.container.hidden = true;
                        this.popup?.forceHide();
                    }
                    getElementsToTriggerPopup() {
                        return this.container;
                    }
                    addHighlightArea() {
                        const triggers = this.getElementsToTriggerPopup();
                        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
                        else triggers.classList.add("highlightArea");
                    }
                    _editOnDoubleClick() {
                        const { annotationEditorType: mode, data: { id: editId } } = this;
                        this.container.addEventListener("dblclick", ()=>{
                            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                                source: this,
                                mode: mode,
                                editId: editId
                            });
                        });
                    }
                }
                class LinkAnnotationElement extends AnnotationElement {
                    constructor(parameters, options = null){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: !!options?.ignoreBorder,
                            createQuadrilaterals: true
                        });
                        this.isTooltipOnly = parameters.data.isTooltipOnly;
                    }
                    render() {
                        const { data, linkService } = this;
                        const link = document.createElement("a");
                        link.setAttribute("data-element-id", data.id);
                        let isBound = false;
                        if (data.url) {
                            linkService.addLinkAttributes(link, data.url, data.newWindow);
                            isBound = true;
                        } else if (data.action) {
                            this._bindNamedAction(link, data.action);
                            isBound = true;
                        } else if (data.attachment) {
                            this._bindAttachment(link, data.attachment);
                            isBound = true;
                        } else if (data.setOCGState) {
                            this.#bindSetOCGState(link, data.setOCGState);
                            isBound = true;
                        } else if (data.dest) {
                            this._bindLink(link, data.dest);
                            isBound = true;
                        } else {
                            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                this._bindJSAction(link, data);
                                isBound = true;
                            }
                            if (data.resetForm) {
                                this._bindResetFormAction(link, data.resetForm);
                                isBound = true;
                            } else if (this.isTooltipOnly && !isBound) {
                                this._bindLink(link, "");
                                isBound = true;
                            }
                        }
                        this.container.classList.add("linkAnnotation");
                        if (isBound) this.container.append(link);
                        return this.container;
                    }
                    #setInternalLink() {
                        this.container.setAttribute("data-internal-link", "");
                    }
                    _bindLink(link, destination) {
                        link.href = this.linkService.getDestinationHash(destination);
                        link.onclick = ()=>{
                            if (destination) this.linkService.goToDestination(destination);
                            return false;
                        };
                        if (destination || destination === "") this.#setInternalLink();
                    }
                    _bindNamedAction(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeNamedAction(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindAttachment(link, attachment) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.downloadManager?.openOrDownloadData(this.container, attachment.content, attachment.filename);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    #bindSetOCGState(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeSetOCGState(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindJSAction(link, data) {
                        link.href = this.linkService.getAnchorUrl("");
                        const map = new Map([
                            [
                                "Action",
                                "onclick"
                            ],
                            [
                                "Mouse Up",
                                "onmouseup"
                            ],
                            [
                                "Mouse Down",
                                "onmousedown"
                            ]
                        ]);
                        for (const name of Object.keys(data.actions)){
                            const jsName = map.get(name);
                            if (!jsName) continue;
                            link[jsName] = ()=>{
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: data.id,
                                        name: name
                                    }
                                });
                                return false;
                            };
                        }
                        if (!link.onclick) link.onclick = ()=>false;
                        this.#setInternalLink();
                    }
                    _bindResetFormAction(link, resetForm) {
                        const otherClickAction = link.onclick;
                        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
                        this.#setInternalLink();
                        if (!this._fieldObjects) {
                            (0, _util.warn)(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
                            if (!otherClickAction) link.onclick = ()=>false;
                            return;
                        }
                        link.onclick = ()=>{
                            otherClickAction?.();
                            const { fields: resetFormFields, refs: resetFormRefs, include } = resetForm;
                            const allFields = [];
                            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                                const fieldIds = new Set(resetFormRefs);
                                for (const fieldName of resetFormFields){
                                    const fields = this._fieldObjects[fieldName] || [];
                                    for (const { id } of fields)fieldIds.add(id);
                                }
                                for (const fields of Object.values(this._fieldObjects)){
                                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                                }
                            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
                            const storage = this.annotationStorage;
                            const allIds = [];
                            for (const field of allFields){
                                const { id } = field;
                                allIds.push(id);
                                switch(field.type){
                                    case "text":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "checkbox":
                                    case "radiobutton":
                                        {
                                            const value = field.defaultValue === field.exportValues;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "combobox":
                                    case "listbox":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    default:
                                        continue;
                                }
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (!domElement) continue;
                                else if (!GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_bindResetFormAction - element not allowed: ${id}`);
                                    continue;
                                }
                                domElement.dispatchEvent(new Event("resetform"));
                            }
                            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: "app",
                                    ids: allIds,
                                    name: "ResetForm"
                                }
                            });
                            return false;
                        };
                    }
                }
                class TextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                    }
                    render() {
                        this.container.classList.add("textAnnotation");
                        const image = document.createElement("img");
                        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                        image.alt = "[{{type}} Annotation]";
                        image.dataset.l10nId = "text_annotation_type";
                        image.dataset.l10nArgs = JSON.stringify({
                            type: this.data.name
                        });
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.append(image);
                        return this.container;
                    }
                }
                class WidgetAnnotationElement extends AnnotationElement {
                    render() {
                        if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                        return this.container;
                    }
                    showElementAndHideCanvas(element) {
                        if (this.data.hasOwnCanvas) {
                            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
                            element.hidden = false;
                        }
                    }
                    _getKeyModifier(event) {
                        const { isWin, isMac } = _util.FeatureTest.platform;
                        return isWin && event.ctrlKey || isMac && event.metaKey;
                    }
                    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
                        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event),
                                    shift: event.shiftKey,
                                    modifier: this._getKeyModifier(event)
                                }
                            });
                        });
                        else element.addEventListener(baseName, (event)=>{
                            if (baseName === "blur") {
                                if (!elementData.focused || !event.relatedTarget) return;
                                elementData.focused = false;
                            } else if (baseName === "focus") {
                                if (elementData.focused) return;
                                elementData.focused = true;
                            }
                            if (!valueGetter) return;
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event)
                                }
                            });
                        });
                    }
                    _setEventListeners(element, elementData, names, getter) {
                        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
                            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                                focused: false
                            };
                            this._setEventListener(element, elementData, baseName, eventName, getter);
                            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
                            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
                        }
                    }
                    _setBackgroundColor(element) {
                        const color = this.data.backgroundColor || null;
                        element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
                    }
                    _setTextStyle(element) {
                        const TEXT_ALIGNMENT = [
                            "left",
                            "center",
                            "right"
                        ];
                        const { fontColor } = this.data.defaultAppearanceData;
                        const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
                        const style = element.style;
                        let computedFontSize;
                        const BORDER_SIZE = 2;
                        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
                        if (this.data.multiLine) {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            const numberOfLines = Math.round(height / (_util.LINE_FACTOR * fontSize)) || 1;
                            const lineHeight = height / numberOfLines;
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util.LINE_FACTOR));
                        } else {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / _util.LINE_FACTOR));
                        }
                        style.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
                        style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                    }
                    _setRequired(element, isRequired) {
                        if (isRequired) element.setAttribute("required", true);
                        else element.removeAttribute("required");
                        element.setAttribute("aria-required", isRequired);
                    }
                }
                class TextWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        const isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                        super(parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    setPropertyOnSiblings(base, key, value, keyInStorage) {
                        const storage = this.annotationStorage;
                        for (const element of this._getElementsByName(base.name, base.id)){
                            if (element.domElement) element.domElement[key] = value;
                            storage.setValue(element.id, {
                                [keyInStorage]: value
                            });
                        }
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        this.container.classList.add("textWidgetAnnotation");
                        let element = null;
                        if (this.renderForms) {
                            const storedData = storage.getValue(id, {
                                value: this.data.fieldValue
                            });
                            let textContent = storedData.value || "";
                            const maxLen = storage.getValue(id, {
                                charLimit: this.data.maxLen
                            }).charLimit;
                            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
                            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
                            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
                            const elementData = {
                                userValue: textContent,
                                formattedValue: fieldFormattedValues,
                                lastCommittedValue: null,
                                commitKey: 1,
                                focused: false
                            };
                            if (this.data.multiLine) {
                                element = document.createElement("textarea");
                                element.textContent = fieldFormattedValues ?? textContent;
                                if (this.data.doNotScroll) element.style.overflowY = "hidden";
                            } else {
                                element = document.createElement("input");
                                element.type = "text";
                                element.setAttribute("value", fieldFormattedValues ?? textContent);
                                if (this.data.doNotScroll) element.style.overflowX = "hidden";
                            }
                            if (this.data.hasOwnCanvas) element.hidden = true;
                            GetElementsByNameSet.add(element);
                            element.setAttribute("data-element-id", id);
                            element.disabled = this.data.readOnly;
                            element.name = this.data.fieldName;
                            element.tabIndex = DEFAULT_TAB_INDEX;
                            this._setRequired(element, this.data.required);
                            if (maxLen) element.maxLength = maxLen;
                            element.addEventListener("input", (event)=>{
                                storage.setValue(id, {
                                    value: event.target.value
                                });
                                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                                elementData.formattedValue = null;
                            });
                            element.addEventListener("resetform", (event)=>{
                                const defaultValue = this.data.defaultFieldValue ?? "";
                                element.value = elementData.userValue = defaultValue;
                                elementData.formattedValue = null;
                            });
                            let blurListener = (event)=>{
                                const { formattedValue } = elementData;
                                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                                event.target.scrollLeft = 0;
                            };
                            if (this.enableScripting && this.hasJSActions) {
                                element.addEventListener("focus", (event)=>{
                                    if (elementData.focused) return;
                                    const { target } = event;
                                    if (elementData.userValue) target.value = elementData.userValue;
                                    elementData.lastCommittedValue = target.value;
                                    elementData.commitKey = 1;
                                    elementData.focused = true;
                                });
                                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                    this.showElementAndHideCanvas(jsEvent.target);
                                    const actions = {
                                        value (event) {
                                            elementData.userValue = event.detail.value ?? "";
                                            storage.setValue(id, {
                                                value: elementData.userValue.toString()
                                            });
                                            event.target.value = elementData.userValue;
                                        },
                                        formattedValue (event) {
                                            const { formattedValue } = event.detail;
                                            elementData.formattedValue = formattedValue;
                                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                                            storage.setValue(id, {
                                                formattedValue: formattedValue
                                            });
                                        },
                                        selRange (event) {
                                            event.target.setSelectionRange(...event.detail.selRange);
                                        },
                                        charLimit: (event)=>{
                                            const { charLimit } = event.detail;
                                            const { target } = event;
                                            if (charLimit === 0) {
                                                target.removeAttribute("maxLength");
                                                return;
                                            }
                                            target.setAttribute("maxLength", charLimit);
                                            let value = elementData.userValue;
                                            if (!value || value.length <= charLimit) return;
                                            value = value.slice(0, charLimit);
                                            target.value = elementData.userValue = value;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                                source: this,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: value,
                                                    willCommit: true,
                                                    commitKey: 1,
                                                    selStart: target.selectionStart,
                                                    selEnd: target.selectionEnd
                                                }
                                            });
                                        }
                                    };
                                    this._dispatchEventFromSandbox(actions, jsEvent);
                                });
                                element.addEventListener("keydown", (event)=>{
                                    elementData.commitKey = 1;
                                    let commitKey = -1;
                                    if (event.key === "Escape") commitKey = 0;
                                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                                    else if (event.key === "Tab") elementData.commitKey = 3;
                                    if (commitKey === -1) return;
                                    const { value } = event.target;
                                    if (elementData.lastCommittedValue === value) return;
                                    elementData.lastCommittedValue = value;
                                    elementData.userValue = value;
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                });
                                const _blurListener = blurListener;
                                blurListener = null;
                                element.addEventListener("blur", (event)=>{
                                    if (!elementData.focused || !event.relatedTarget) return;
                                    elementData.focused = false;
                                    const { value } = event.target;
                                    elementData.userValue = value;
                                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: elementData.commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                    _blurListener(event);
                                });
                                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                                    elementData.lastCommittedValue = null;
                                    const { data, target } = event;
                                    const { value, selectionStart, selectionEnd } = target;
                                    let selStart = selectionStart, selEnd = selectionEnd;
                                    switch(event.inputType){
                                        case "deleteWordBackward":
                                            {
                                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                                if (match) selStart -= match[0].length;
                                                break;
                                            }
                                        case "deleteWordForward":
                                            {
                                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                                if (match) selEnd += match[0].length;
                                                break;
                                            }
                                        case "deleteContentBackward":
                                            if (selectionStart === selectionEnd) selStart -= 1;
                                            break;
                                        case "deleteContentForward":
                                            if (selectionStart === selectionEnd) selEnd += 1;
                                            break;
                                    }
                                    event.preventDefault();
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            change: data || "",
                                            willCommit: false,
                                            selStart: selStart,
                                            selEnd: selEnd
                                        }
                                    });
                                });
                                this._setEventListeners(element, elementData, [
                                    [
                                        "focus",
                                        "Focus"
                                    ],
                                    [
                                        "blur",
                                        "Blur"
                                    ],
                                    [
                                        "mousedown",
                                        "Mouse Down"
                                    ],
                                    [
                                        "mouseenter",
                                        "Mouse Enter"
                                    ],
                                    [
                                        "mouseleave",
                                        "Mouse Exit"
                                    ],
                                    [
                                        "mouseup",
                                        "Mouse Up"
                                    ]
                                ], (event)=>event.target.value);
                            }
                            if (blurListener) element.addEventListener("blur", blurListener);
                            if (this.data.comb) {
                                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                                const combWidth = fieldWidth / maxLen;
                                element.classList.add("comb");
                                element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
                            }
                        } else {
                            element = document.createElement("div");
                            element.textContent = this.data.fieldValue;
                            element.style.verticalAlign = "middle";
                            element.style.display = "table-cell";
                        }
                        this._setTextStyle(element);
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: !!parameters.data.hasOwnCanvas
                        });
                    }
                }
                class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.exportValue === data.fieldValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== "Off";
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "checkbox";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.setAttribute("exportValue", data.exportValue);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const checkbox of this._getElementsByName(name, id)){
                                const curChecked = checked && checkbox.exportValue === data.exportValue;
                                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                                storage.setValue(checkbox.id, {
                                    value: curChecked
                                });
                            }
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue || "Off";
                            event.target.checked = defaultValue === data.exportValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        event.target.checked = event.detail.value !== "Off";
                                        storage.setValue(id, {
                                            value: event.target.checked
                                        });
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.fieldValue === data.buttonValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== data.buttonValue;
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "radio";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                                value: false
                            });
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue;
                            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            const pdfButtonValue = data.buttonValue;
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value: (event)=>{
                                        const checked = pdfButtonValue === event.detail.value;
                                        for (const radio of this._getElementsByName(event.target.name)){
                                            const curChecked = checked && radio.id === id;
                                            if (radio.domElement) radio.domElement.checked = curChecked;
                                            storage.setValue(radio.id, {
                                                value: curChecked
                                            });
                                        }
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            ignoreBorder: parameters.data.hasAppearance
                        });
                    }
                    render() {
                        const container = super.render();
                        container.classList.add("buttonWidgetAnnotation", "pushButton");
                        if (this.data.alternativeText) container.title = this.data.alternativeText;
                        const linkElement = container.lastChild;
                        if (this.enableScripting && this.hasJSActions && linkElement) {
                            this._setDefaultPropertiesFromJS(linkElement);
                            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                this._dispatchEventFromSandbox({}, jsEvent);
                            });
                        }
                        return container;
                    }
                }
                class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("choiceWidgetAnnotation");
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        const storedData = storage.getValue(id, {
                            value: this.data.fieldValue
                        });
                        const selectElement = document.createElement("select");
                        GetElementsByNameSet.add(selectElement);
                        selectElement.setAttribute("data-element-id", id);
                        selectElement.disabled = this.data.readOnly;
                        this._setRequired(selectElement, this.data.required);
                        selectElement.name = this.data.fieldName;
                        selectElement.tabIndex = DEFAULT_TAB_INDEX;
                        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
                        if (!this.data.combo) {
                            selectElement.size = this.data.options.length;
                            if (this.data.multiSelect) selectElement.multiple = true;
                        }
                        selectElement.addEventListener("resetform", (event)=>{
                            const defaultValue = this.data.defaultFieldValue;
                            for (const option of selectElement.options)option.selected = option.value === defaultValue;
                        });
                        for (const option of this.data.options){
                            const optionElement = document.createElement("option");
                            optionElement.textContent = option.displayValue;
                            optionElement.value = option.exportValue;
                            if (storedData.value.includes(option.exportValue)) {
                                optionElement.setAttribute("selected", true);
                                addAnEmptyEntry = false;
                            }
                            selectElement.append(optionElement);
                        }
                        let removeEmptyEntry = null;
                        if (addAnEmptyEntry) {
                            const noneOptionElement = document.createElement("option");
                            noneOptionElement.value = " ";
                            noneOptionElement.setAttribute("hidden", true);
                            noneOptionElement.setAttribute("selected", true);
                            selectElement.prepend(noneOptionElement);
                            removeEmptyEntry = ()=>{
                                noneOptionElement.remove();
                                selectElement.removeEventListener("input", removeEmptyEntry);
                                removeEmptyEntry = null;
                            };
                            selectElement.addEventListener("input", removeEmptyEntry);
                        }
                        const getValue = (isExport)=>{
                            const name = isExport ? "value" : "textContent";
                            const { options, multiple } = selectElement;
                            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
                        };
                        let selectedValues = getValue(false);
                        const getItems = (event)=>{
                            const options = event.target.options;
                            return Array.prototype.map.call(options, (option)=>{
                                return {
                                    displayValue: option.textContent,
                                    exportValue: option.value
                                };
                            });
                        };
                        if (this.enableScripting && this.hasJSActions) {
                            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        removeEmptyEntry?.();
                                        const value = event.detail.value;
                                        const values = new Set(Array.isArray(value) ? value : [
                                            value
                                        ]);
                                        for (const option of selectElement.options)option.selected = values.has(option.value);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    multipleSelection (event) {
                                        selectElement.multiple = true;
                                    },
                                    remove (event) {
                                        const options = selectElement.options;
                                        const index = event.detail.remove;
                                        options[index].selected = false;
                                        selectElement.remove(index);
                                        if (options.length > 0) {
                                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                                            if (i === -1) options[0].selected = true;
                                        }
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    clear (event) {
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        storage.setValue(id, {
                                            value: null,
                                            items: []
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    insert (event) {
                                        const { index, displayValue, exportValue } = event.detail.insert;
                                        const selectChild = selectElement.children[index];
                                        const optionElement = document.createElement("option");
                                        optionElement.textContent = displayValue;
                                        optionElement.value = exportValue;
                                        if (selectChild) selectChild.before(optionElement);
                                        else selectElement.append(optionElement);
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    items (event) {
                                        const { items } = event.detail;
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        for (const item of items){
                                            const { displayValue, exportValue } = item;
                                            const optionElement = document.createElement("option");
                                            optionElement.textContent = displayValue;
                                            optionElement.value = exportValue;
                                            selectElement.append(optionElement);
                                        }
                                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    indices (event) {
                                        const indices = new Set(event.detail.indices);
                                        for (const option of event.target.options)option.selected = indices.has(option.index);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    editable (event) {
                                        event.target.disabled = !event.detail.editable;
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            selectElement.addEventListener("input", (event)=>{
                                const exportValue = getValue(true);
                                storage.setValue(id, {
                                    value: exportValue
                                });
                                event.preventDefault();
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: id,
                                        name: "Keystroke",
                                        value: selectedValues,
                                        changeEx: exportValue,
                                        willCommit: false,
                                        commitKey: 1,
                                        keyDown: false
                                    }
                                });
                            });
                            this._setEventListeners(selectElement, null, [
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ],
                                [
                                    "input",
                                    "Action"
                                ],
                                [
                                    "input",
                                    "Validate"
                                ]
                            ], (event)=>event.target.value);
                        } else selectElement.addEventListener("input", function(event) {
                            storage.setValue(id, {
                                value: getValue(true)
                            });
                        });
                        if (this.data.combo) this._setTextStyle(selectElement);
                        this._setBackgroundColor(selectElement);
                        this._setDefaultPropertiesFromJS(selectElement);
                        this.container.append(selectElement);
                        return this.container;
                    }
                }
                class PopupAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        const { data, elements } = parameters;
                        super(parameters, {
                            isRenderable: AnnotationElement._hasPopupData(data)
                        });
                        this.elements = elements;
                    }
                    render() {
                        this.container.classList.add("popupAnnotation");
                        const popup = new PopupElement({
                            container: this.container,
                            color: this.data.color,
                            titleObj: this.data.titleObj,
                            modificationDate: this.data.modificationDate,
                            contentsObj: this.data.contentsObj,
                            richText: this.data.richText,
                            rect: this.data.rect,
                            parentRect: this.data.parentRect || null,
                            parent: this.parent,
                            elements: this.elements,
                            open: this.data.open
                        });
                        const elementIds = [];
                        for (const element of this.elements){
                            element.popup = popup;
                            elementIds.push(element.data.id);
                            element.addHighlightArea();
                        }
                        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${_util.AnnotationPrefix}${id}`).join(","));
                        return this.container;
                    }
                }
                class PopupElement {
                    #dateTimePromise = null;
                    #boundKeyDown = this.#keyDown.bind(this);
                    #boundHide = this.#hide.bind(this);
                    #boundShow = this.#show.bind(this);
                    #boundToggle = this.#toggle.bind(this);
                    #color = null;
                    #container = null;
                    #contentsObj = null;
                    #elements = null;
                    #parent = null;
                    #parentRect = null;
                    #pinned = false;
                    #popup = null;
                    #rect = null;
                    #richText = null;
                    #titleObj = null;
                    #wasVisible = false;
                    constructor({ container, color, elements, titleObj, modificationDate, contentsObj, richText, parent, rect, parentRect, open }){
                        this.#container = container;
                        this.#titleObj = titleObj;
                        this.#contentsObj = contentsObj;
                        this.#richText = richText;
                        this.#parent = parent;
                        this.#color = color;
                        this.#rect = rect;
                        this.#parentRect = parentRect;
                        this.#elements = elements;
                        const dateObject = _display_utils.PDFDateString.toDateObject(modificationDate);
                        if (dateObject) this.#dateTimePromise = parent.l10n.get("annotation_date_string", {
                            date: dateObject.toLocaleDateString(),
                            time: dateObject.toLocaleTimeString()
                        });
                        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
                        for (const element of this.trigger){
                            element.addEventListener("click", this.#boundToggle);
                            element.addEventListener("mouseenter", this.#boundShow);
                            element.addEventListener("mouseleave", this.#boundHide);
                            element.classList.add("popupTriggerArea");
                        }
                        for (const element of elements)element.container?.addEventListener("keydown", this.#boundKeyDown);
                        this.#container.hidden = true;
                        if (open) this.#toggle();
                    }
                    render() {
                        if (this.#popup) return;
                        const { page: { view }, viewport: { rawDims: { pageWidth, pageHeight, pageX, pageY } } } = this.#parent;
                        const popup = this.#popup = document.createElement("div");
                        popup.className = "popup";
                        if (this.#color) {
                            const baseColor = popup.style.outlineColor = _util.Util.makeHexColor(...this.#color);
                            if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
                            else {
                                const BACKGROUND_ENLIGHT = 0.7;
                                popup.style.backgroundColor = _util.Util.makeHexColor(...this.#color.map((c)=>Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
                            }
                        }
                        const header = document.createElement("span");
                        header.className = "header";
                        const title = document.createElement("h1");
                        header.append(title);
                        ({ dir: title.dir, str: title.textContent } = this.#titleObj);
                        popup.append(header);
                        if (this.#dateTimePromise) {
                            const modificationDate = document.createElement("span");
                            modificationDate.classList.add("popupDate");
                            this.#dateTimePromise.then((localized)=>{
                                modificationDate.textContent = localized;
                            });
                            header.append(modificationDate);
                        }
                        const contentsObj = this.#contentsObj;
                        const richText = this.#richText;
                        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) {
                            _xfa_layer.XfaLayer.render({
                                xfaHtml: richText.html,
                                intent: "richText",
                                div: popup
                            });
                            popup.lastChild.classList.add("richText", "popupContent");
                        } else {
                            const contents = this._formatContents(contentsObj);
                            popup.append(contents);
                        }
                        let useParentRect = !!this.#parentRect;
                        let rect = useParentRect ? this.#parentRect : this.#rect;
                        for (const element of this.#elements)if (!rect || _util.Util.intersect(element.data.rect, rect) !== null) {
                            rect = element.data.rect;
                            useParentRect = true;
                            break;
                        }
                        const normalizedRect = _util.Util.normalizeRect([
                            rect[0],
                            view[3] - rect[1] + view[1],
                            rect[2],
                            view[3] - rect[3] + view[1]
                        ]);
                        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
                        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
                        const popupLeft = normalizedRect[0] + parentWidth;
                        const popupTop = normalizedRect[1];
                        const { style } = this.#container;
                        style.left = `${100 * (popupLeft - pageX) / pageWidth}%`;
                        style.top = `${100 * (popupTop - pageY) / pageHeight}%`;
                        this.#container.append(popup);
                    }
                    _formatContents({ str, dir }) {
                        const p = document.createElement("p");
                        p.classList.add("popupContent");
                        p.dir = dir;
                        const lines = str.split(/(?:\r\n?|\n)/);
                        for(let i = 0, ii = lines.length; i < ii; ++i){
                            const line = lines[i];
                            p.append(document.createTextNode(line));
                            if (i < ii - 1) p.append(document.createElement("br"));
                        }
                        return p;
                    }
                    #keyDown(event) {
                        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
                        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
                    }
                    #toggle() {
                        this.#pinned = !this.#pinned;
                        if (this.#pinned) {
                            this.#show();
                            this.#container.addEventListener("click", this.#boundToggle);
                            this.#container.addEventListener("keydown", this.#boundKeyDown);
                        } else {
                            this.#hide();
                            this.#container.removeEventListener("click", this.#boundToggle);
                            this.#container.removeEventListener("keydown", this.#boundKeyDown);
                        }
                    }
                    #show() {
                        if (!this.#popup) this.render();
                        if (!this.isVisible) {
                            this.#container.hidden = false;
                            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
                        } else if (this.#pinned) this.#container.classList.add("focused");
                    }
                    #hide() {
                        this.#container.classList.remove("focused");
                        if (this.#pinned || !this.isVisible) return;
                        this.#container.hidden = true;
                        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
                    }
                    forceHide() {
                        this.#wasVisible = this.isVisible;
                        if (!this.#wasVisible) return;
                        this.#container.hidden = true;
                    }
                    maybeShow() {
                        if (!this.#wasVisible) return;
                        this.#wasVisible = false;
                        this.#container.hidden = false;
                    }
                    get isVisible() {
                        return this.#container.hidden === false;
                    }
                }
                class FreeTextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.textContent = parameters.data.textContent;
                        this.textPosition = parameters.data.textPosition;
                        this.annotationEditorType = _util.AnnotationEditorType.FREETEXT;
                    }
                    render() {
                        this.container.classList.add("freeTextAnnotation");
                        if (this.textContent) {
                            const content = document.createElement("div");
                            content.classList.add("annotationTextContent");
                            content.setAttribute("role", "comment");
                            for (const line of this.textContent){
                                const lineSpan = document.createElement("span");
                                lineSpan.textContent = line;
                                content.append(lineSpan);
                            }
                            this.container.append(content);
                        }
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this._editOnDoubleClick();
                        return this.container;
                    }
                }
                exports.FreeTextAnnotationElement = FreeTextAnnotationElement;
                class LineAnnotationElement extends AnnotationElement {
                    #line = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("lineAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const line = this.#line = this.svgFactory.createElement("svg:line");
                        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
                        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
                        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
                        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
                        line.setAttribute("stroke-width", data.borderStyle.width || 1);
                        line.setAttribute("stroke", "transparent");
                        line.setAttribute("fill", "transparent");
                        svg.append(line);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#line;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class SquareAnnotationElement extends AnnotationElement {
                    #square = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("squareAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const square = this.#square = this.svgFactory.createElement("svg:rect");
                        square.setAttribute("x", borderWidth / 2);
                        square.setAttribute("y", borderWidth / 2);
                        square.setAttribute("width", width - borderWidth);
                        square.setAttribute("height", height - borderWidth);
                        square.setAttribute("stroke-width", borderWidth || 1);
                        square.setAttribute("stroke", "transparent");
                        square.setAttribute("fill", "transparent");
                        svg.append(square);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#square;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class CircleAnnotationElement extends AnnotationElement {
                    #circle = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("circleAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
                        circle.setAttribute("cx", width / 2);
                        circle.setAttribute("cy", height / 2);
                        circle.setAttribute("rx", width / 2 - borderWidth / 2);
                        circle.setAttribute("ry", height / 2 - borderWidth / 2);
                        circle.setAttribute("stroke-width", borderWidth || 1);
                        circle.setAttribute("stroke", "transparent");
                        circle.setAttribute("fill", "transparent");
                        svg.append(circle);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#circle;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolylineAnnotationElement extends AnnotationElement {
                    #polyline = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "polylineAnnotation";
                        this.svgElementName = "svg:polyline";
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        let points = [];
                        for (const coordinate of data.vertices){
                            const x = coordinate.x - data.rect[0];
                            const y = data.rect[3] - coordinate.y;
                            points.push(x + "," + y);
                        }
                        points = points.join(" ");
                        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
                        polyline.setAttribute("points", points);
                        polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                        polyline.setAttribute("stroke", "transparent");
                        polyline.setAttribute("fill", "transparent");
                        svg.append(polyline);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polyline;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolygonAnnotationElement extends PolylineAnnotationElement {
                    constructor(parameters){
                        super(parameters);
                        this.containerClassName = "polygonAnnotation";
                        this.svgElementName = "svg:polygon";
                    }
                }
                class CaretAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("caretAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                class InkAnnotationElement extends AnnotationElement {
                    #polylines = [];
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "inkAnnotation";
                        this.svgElementName = "svg:polyline";
                        this.annotationEditorType = _util.AnnotationEditorType.INK;
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        for (const inkList of data.inkLists){
                            let points = [];
                            for (const coordinate of inkList){
                                const x = coordinate.x - data.rect[0];
                                const y = data.rect[3] - coordinate.y;
                                points.push(`${x},${y}`);
                            }
                            points = points.join(" ");
                            const polyline = this.svgFactory.createElement(this.svgElementName);
                            this.#polylines.push(polyline);
                            polyline.setAttribute("points", points);
                            polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                            polyline.setAttribute("stroke", "transparent");
                            polyline.setAttribute("fill", "transparent");
                            if (!data.popupRef && this.hasPopupData) this._createPopup();
                            svg.append(polyline);
                        }
                        this.container.append(svg);
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polylines;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                exports.InkAnnotationElement = InkAnnotationElement;
                class HighlightAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("highlightAnnotation");
                        return this.container;
                    }
                }
                class UnderlineAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("underlineAnnotation");
                        return this.container;
                    }
                }
                class SquigglyAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("squigglyAnnotation");
                        return this.container;
                    }
                }
                class StrikeOutAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("strikeoutAnnotation");
                        return this.container;
                    }
                }
                class StampAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("stampAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                exports.StampAnnotationElement = StampAnnotationElement;
                class FileAttachmentAnnotationElement extends AnnotationElement {
                    #trigger = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                        const { filename, content } = this.data.file;
                        this.filename = (0, _display_utils.getFilenameFromUrl)(filename, true);
                        this.content = content;
                        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                            source: this,
                            filename: filename,
                            content: content
                        });
                    }
                    render() {
                        this.container.classList.add("fileAttachmentAnnotation");
                        const { container, data } = this;
                        let trigger;
                        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
                        else {
                            trigger = document.createElement("img");
                            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
                            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
                        }
                        trigger.addEventListener("dblclick", this.#download.bind(this));
                        this.#trigger = trigger;
                        const { isMac } = _util.FeatureTest.platform;
                        container.addEventListener("keydown", (evt)=>{
                            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
                        });
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        else trigger.classList.add("popupTriggerArea");
                        container.append(trigger);
                        return container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#trigger;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    #download() {
                        this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
                    }
                }
                class AnnotationLayer {
                    #accessibilityManager = null;
                    #annotationCanvasMap = null;
                    #editableAnnotations = new Map();
                    constructor({ div, accessibilityManager, annotationCanvasMap, l10n, page, viewport }){
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationCanvasMap = annotationCanvasMap;
                        this.l10n = l10n;
                        this.page = page;
                        this.viewport = viewport;
                        this.zIndex = 0;
                        this.l10n ||= _displayL10n_utils.NullL10n;
                    }
                    #appendElement(element, id) {
                        const contentElement = element.firstChild || element;
                        contentElement.id = `${_util.AnnotationPrefix}${id}`;
                        this.div.append(element);
                        this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
                    }
                    async render(params) {
                        const { annotations } = params;
                        const layer = this.div;
                        (0, _display_utils.setLayerDimensions)(layer, this.viewport);
                        const popupToElements = new Map();
                        const elementParams = {
                            data: null,
                            layer: layer,
                            linkService: params.linkService,
                            downloadManager: params.downloadManager,
                            imageResourcesPath: params.imageResourcesPath || "",
                            renderForms: params.renderForms !== false,
                            svgFactory: new _display_utils.DOMSVGFactory(),
                            annotationStorage: params.annotationStorage || new _annotation_storage.AnnotationStorage(),
                            enableScripting: params.enableScripting === true,
                            hasJSActions: params.hasJSActions,
                            fieldObjects: params.fieldObjects,
                            parent: this,
                            elements: null
                        };
                        for (const data of annotations){
                            if (data.noHTML) continue;
                            const isPopupAnnotation = data.annotationType === _util.AnnotationType.POPUP;
                            if (!isPopupAnnotation) {
                                const { width, height } = getRectDims(data.rect);
                                if (width <= 0 || height <= 0) continue;
                            } else {
                                const elements = popupToElements.get(data.id);
                                if (!elements) continue;
                                elementParams.elements = elements;
                            }
                            elementParams.data = data;
                            const element = AnnotationElementFactory.create(elementParams);
                            if (!element.isRenderable) continue;
                            if (!isPopupAnnotation && data.popupRef) {
                                const elements = popupToElements.get(data.popupRef);
                                if (!elements) popupToElements.set(data.popupRef, [
                                    element
                                ]);
                                else elements.push(element);
                            }
                            if (element.annotationEditorType > 0) this.#editableAnnotations.set(element.data.id, element);
                            const rendered = element.render();
                            if (data.hidden) rendered.style.visibility = "hidden";
                            this.#appendElement(rendered, data.id);
                        }
                        this.#setAnnotationCanvasMap();
                        await this.l10n.translate(layer);
                    }
                    update({ viewport }) {
                        const layer = this.div;
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(layer, {
                            rotation: viewport.rotation
                        });
                        this.#setAnnotationCanvasMap();
                        layer.hidden = false;
                    }
                    #setAnnotationCanvasMap() {
                        if (!this.#annotationCanvasMap) return;
                        const layer = this.div;
                        for (const [id, canvas] of this.#annotationCanvasMap){
                            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
                            if (!element) continue;
                            const { firstChild } = element;
                            if (!firstChild) element.append(canvas);
                            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
                            else firstChild.before(canvas);
                        }
                        this.#annotationCanvasMap.clear();
                    }
                    getEditableAnnotations() {
                        return Array.from(this.#editableAnnotations.values());
                    }
                    getEditableAnnotation(id) {
                        return this.#editableAnnotations.get(id);
                    }
                }
                exports.AnnotationLayer = AnnotationLayer;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorConverters = void 0;
                function makeColorComp(n) {
                    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
                }
                function scaleAndClamp(x) {
                    return Math.max(0, Math.min(255, 255 * x));
                }
                class ColorConverters {
                    static CMYK_G([c, y, m, k]) {
                        return [
                            "G",
                            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
                        ];
                    }
                    static G_CMYK([g]) {
                        return [
                            "CMYK",
                            0,
                            0,
                            0,
                            1 - g
                        ];
                    }
                    static G_RGB([g]) {
                        return [
                            "RGB",
                            g,
                            g,
                            g
                        ];
                    }
                    static G_rgb([g]) {
                        g = scaleAndClamp(g);
                        return [
                            g,
                            g,
                            g
                        ];
                    }
                    static G_HTML([g]) {
                        const G = makeColorComp(g);
                        return `#${G}${G}${G}`;
                    }
                    static RGB_G([r, g, b]) {
                        return [
                            "G",
                            0.3 * r + 0.59 * g + 0.11 * b
                        ];
                    }
                    static RGB_rgb(color) {
                        return color.map(scaleAndClamp);
                    }
                    static RGB_HTML(color) {
                        return `#${color.map(makeColorComp).join("")}`;
                    }
                    static T_HTML() {
                        return "#00000000";
                    }
                    static T_rgb() {
                        return [
                            null
                        ];
                    }
                    static CMYK_RGB([c, y, m, k]) {
                        return [
                            "RGB",
                            1 - Math.min(1, c + k),
                            1 - Math.min(1, m + k),
                            1 - Math.min(1, y + k)
                        ];
                    }
                    static CMYK_rgb([c, y, m, k]) {
                        return [
                            scaleAndClamp(1 - Math.min(1, c + k)),
                            scaleAndClamp(1 - Math.min(1, m + k)),
                            scaleAndClamp(1 - Math.min(1, y + k))
                        ];
                    }
                    static CMYK_HTML(components) {
                        const rgb = this.CMYK_RGB(components).slice(1);
                        return this.RGB_HTML(rgb);
                    }
                    static RGB_CMYK([r, g, b]) {
                        const c = 1 - r;
                        const m = 1 - g;
                        const y = 1 - b;
                        const k = Math.min(c, m, y);
                        return [
                            "CMYK",
                            c,
                            m,
                            y,
                            k
                        ];
                    }
                }
                exports.ColorConverters = ColorConverters;
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NullL10n = void 0;
                exports.getL10nFallback = getL10nFallback;
                const DEFAULT_L10N_STRINGS = {
                    of_pages: "of {{pagesCount}}",
                    page_of_pages: "({{pageNumber}} of {{pagesCount}})",
                    document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
                    document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
                    document_properties_date_string: "{{date}}, {{time}}",
                    document_properties_page_size_unit_inches: "in",
                    document_properties_page_size_unit_millimeters: "mm",
                    document_properties_page_size_orientation_portrait: "portrait",
                    document_properties_page_size_orientation_landscape: "landscape",
                    document_properties_page_size_name_a3: "A3",
                    document_properties_page_size_name_a4: "A4",
                    document_properties_page_size_name_letter: "Letter",
                    document_properties_page_size_name_legal: "Legal",
                    document_properties_page_size_dimension_string: "{{width}} \xd7 {{height}} {{unit}} ({{orientation}})",
                    document_properties_page_size_dimension_name_string: "{{width}} \xd7 {{height}} {{unit}} ({{name}}, {{orientation}})",
                    document_properties_linearized_yes: "Yes",
                    document_properties_linearized_no: "No",
                    additional_layers: "Additional Layers",
                    page_landmark: "Page {{page}}",
                    thumb_page_title: "Page {{page}}",
                    thumb_page_canvas: "Thumbnail of Page {{page}}",
                    find_reached_top: "Reached top of document, continued from bottom",
                    find_reached_bottom: "Reached end of document, continued from top",
                    "find_match_count[one]": "{{current}} of {{total}} match",
                    "find_match_count[other]": "{{current}} of {{total}} matches",
                    "find_match_count_limit[one]": "More than {{limit}} match",
                    "find_match_count_limit[other]": "More than {{limit}} matches",
                    find_not_found: "Phrase not found",
                    page_scale_width: "Page Width",
                    page_scale_fit: "Page Fit",
                    page_scale_auto: "Automatic Zoom",
                    page_scale_actual: "Actual Size",
                    page_scale_percent: "{{scale}}%",
                    loading_error: "An error occurred while loading the PDF.",
                    invalid_file_error: "Invalid or corrupted PDF file.",
                    missing_file_error: "Missing PDF file.",
                    unexpected_response_error: "Unexpected server response.",
                    rendering_error: "An error occurred while rendering the page.",
                    annotation_date_string: "{{date}}, {{time}}",
                    printing_not_supported: "Warning: Printing is not fully supported by this browser.",
                    printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
                    web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
                    free_text2_default_content: "Start typing\u2026",
                    editor_free_text2_aria_label: "Text Editor",
                    editor_ink2_aria_label: "Draw Editor",
                    editor_ink_canvas_aria_label: "User-created image",
                    editor_alt_text_button_label: "Alt text",
                    editor_alt_text_edit_button_label: "Edit alt text",
                    editor_alt_text_decorative_tooltip: "Marked as decorative"
                };
                DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
                function getL10nFallback(key, args) {
                    switch(key){
                        case "find_match_count":
                            key = `find_match_count[${args.total === 1 ? "one" : "other"}]`;
                            break;
                        case "find_match_count_limit":
                            key = `find_match_count_limit[${args.limit === 1 ? "one" : "other"}]`;
                            break;
                    }
                    return DEFAULT_L10N_STRINGS[key] || "";
                }
                function formatL10nValue(text, args) {
                    if (!args) return text;
                    return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all, name)=>{
                        return name in args ? args[name] : "{{" + name + "}}";
                    });
                }
                const NullL10n = {
                    async getLanguage () {
                        return "en-us";
                    },
                    async getDirection () {
                        return "ltr";
                    },
                    async get (key, args = null, fallback = getL10nFallback(key, args)) {
                        return formatL10nValue(fallback, args);
                    },
                    async translate (element) {}
                };
                exports.NullL10n = NullL10n;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaLayer = void 0;
                var _xfa_text = __w_pdfjs_require__(25);
                class XfaLayer {
                    static setupStorage(html, id, element, storage, intent) {
                        const storedData = storage.getValue(id, {
                            value: null
                        });
                        switch(element.name){
                            case "textarea":
                                if (storedData.value !== null) html.textContent = storedData.value;
                                if (intent === "print") break;
                                html.addEventListener("input", (event)=>{
                                    storage.setValue(id, {
                                        value: event.target.value
                                    });
                                });
                                break;
                            case "input":
                                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                                    if (intent === "print") break;
                                    html.addEventListener("change", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                                        });
                                    });
                                } else {
                                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                                    if (intent === "print") break;
                                    html.addEventListener("input", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.value
                                        });
                                    });
                                }
                                break;
                            case "select":
                                if (storedData.value !== null) {
                                    html.setAttribute("value", storedData.value);
                                    for (const option of element.children){
                                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                                    }
                                }
                                html.addEventListener("input", (event)=>{
                                    const options = event.target.options;
                                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                                    storage.setValue(id, {
                                        value: value
                                    });
                                });
                                break;
                        }
                    }
                    static setAttributes({ html, element, storage = null, intent, linkService }) {
                        const { attributes } = element;
                        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
                        for (const [key, value] of Object.entries(attributes)){
                            if (value === null || value === undefined) continue;
                            switch(key){
                                case "class":
                                    if (value.length) html.setAttribute(key, value.join(" "));
                                    break;
                                case "dataId":
                                    break;
                                case "id":
                                    html.setAttribute("data-element-id", value);
                                    break;
                                case "style":
                                    Object.assign(html.style, value);
                                    break;
                                case "textContent":
                                    html.textContent = value;
                                    break;
                                default:
                                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
                            }
                        }
                        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
                        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
                    }
                    static render(parameters) {
                        const storage = parameters.annotationStorage;
                        const linkService = parameters.linkService;
                        const root = parameters.xfaHtml;
                        const intent = parameters.intent || "display";
                        const rootHtml = document.createElement(root.name);
                        if (root.attributes) this.setAttributes({
                            html: rootHtml,
                            element: root,
                            intent: intent,
                            linkService: linkService
                        });
                        const stack = [
                            [
                                root,
                                -1,
                                rootHtml
                            ]
                        ];
                        const rootDiv = parameters.div;
                        rootDiv.append(rootHtml);
                        if (parameters.viewport) {
                            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                            rootDiv.style.transform = transform;
                        }
                        if (intent !== "richText") rootDiv.setAttribute("class", "xfaLayer xfaFont");
                        const textDivs = [];
                        while(stack.length > 0){
                            const [parent, i, html] = stack.at(-1);
                            if (i + 1 === parent.children.length) {
                                stack.pop();
                                continue;
                            }
                            const child = parent.children[++stack.at(-1)[1]];
                            if (child === null) continue;
                            const { name } = child;
                            if (name === "#text") {
                                const node = document.createTextNode(child.value);
                                textDivs.push(node);
                                html.append(node);
                                continue;
                            }
                            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
                            html.append(childHtml);
                            if (child.attributes) this.setAttributes({
                                html: childHtml,
                                element: child,
                                storage: storage,
                                intent: intent,
                                linkService: linkService
                            });
                            if (child.children && child.children.length > 0) stack.push([
                                child,
                                -1,
                                childHtml
                            ]);
                            else if (child.value) {
                                const node = document.createTextNode(child.value);
                                if (_xfa_text.XfaText.shouldBuildText(name)) textDivs.push(node);
                                childHtml.append(node);
                            }
                        }
                        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
                        return {
                            textDivs: textDivs
                        };
                    }
                    static update(parameters) {
                        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                        parameters.div.style.transform = transform;
                        parameters.div.hidden = false;
                    }
                }
                exports.XfaLayer = XfaLayer;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.InkEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _display_utils = __w_pdfjs_require__(6);
                var _tools = __w_pdfjs_require__(5);
                class InkEditor extends _editor.AnnotationEditor {
                    #baseHeight = 0;
                    #baseWidth = 0;
                    #boundCanvasPointermove = this.canvasPointermove.bind(this);
                    #boundCanvasPointerleave = this.canvasPointerleave.bind(this);
                    #boundCanvasPointerup = this.canvasPointerup.bind(this);
                    #boundCanvasPointerdown = this.canvasPointerdown.bind(this);
                    #currentPath2D = new Path2D();
                    #disableEditing = false;
                    #hasSomethingToDraw = false;
                    #isCanvasInitialized = false;
                    #observer = null;
                    #realWidth = 0;
                    #realHeight = 0;
                    #requestFrameCallback = null;
                    static _defaultColor = null;
                    static _defaultOpacity = 1;
                    static _defaultThickness = 1;
                    static _type = "ink";
                    constructor(params){
                        super({
                            ...params,
                            name: "inkEditor"
                        });
                        this.color = params.color || null;
                        this.thickness = params.thickness || null;
                        this.opacity = params.opacity || null;
                        this.paths = [];
                        this.bezierPath2D = [];
                        this.allRawPaths = [];
                        this.currentPath = [];
                        this.scaleFactor = 1;
                        this.translationX = this.translationY = 0;
                        this.x = 0;
                        this.y = 0;
                        this._willKeepAspectRatio = true;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "editor_ink_canvas_aria_label",
                                "editor_ink2_aria_label"
                            ]
                        });
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                InkEditor._defaultThickness = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                InkEditor._defaultColor = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                InkEditor._defaultOpacity = value / 100;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                this.#updateThickness(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                this.#updateColor(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                this.#updateOpacity(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(InkEditor._defaultOpacity * 100)
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                this.thickness || InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(100 * (this.opacity ?? InkEditor._defaultOpacity))
                            ]
                        ];
                    }
                    #updateThickness(thickness) {
                        const savedThickness = this.thickness;
                        this.addCommands({
                            cmd: ()=>{
                                this.thickness = thickness;
                                this.#fitToContent();
                            },
                            undo: ()=>{
                                this.thickness = savedThickness;
                                this.#fitToContent();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_THICKNESS,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.color;
                        this.addCommands({
                            cmd: ()=>{
                                this.color = color;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.color = savedColor;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateOpacity(opacity) {
                        opacity /= 100;
                        const savedOpacity = this.opacity;
                        this.addCommands({
                            cmd: ()=>{
                                this.opacity = opacity;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.opacity = savedOpacity;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_OPACITY,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.canvas) {
                            this.#createCanvas();
                            this.#createObserver();
                        }
                        if (!this.isAttachedToDOM) {
                            this.parent.add(this);
                            this.#setCanvasDims();
                        }
                        this.#fitToContent();
                    }
                    remove() {
                        if (this.canvas === null) return;
                        if (!this.isEmpty()) this.commit();
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.remove();
                        this.canvas = null;
                        this.#observer.disconnect();
                        this.#observer = null;
                        super.remove();
                    }
                    setParent(parent) {
                        if (!this.parent && parent) this._uiManager.removeShouldRescale(this);
                        else if (this.parent && parent === null) this._uiManager.addShouldRescale(this);
                        super.setParent(parent);
                    }
                    onScaleChanging() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const width = this.width * parentWidth;
                        const height = this.height * parentHeight;
                        this.setDimensions(width, height);
                    }
                    enableEditMode() {
                        if (this.#disableEditing || this.canvas === null) return;
                        super.enableEditMode();
                        this._isDraggable = false;
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode() || this.canvas === null) return;
                        super.disableEditMode();
                        this._isDraggable = !this.isEmpty();
                        this.div.classList.remove("editing");
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    onceAdded() {
                        this._isDraggable = !this.isEmpty();
                    }
                    isEmpty() {
                        return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
                    }
                    #getInitialBBox() {
                        const { parentRotation, parentDimensions: [width, height] } = this;
                        switch(parentRotation){
                            case 90:
                                return [
                                    0,
                                    height,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    width,
                                    height,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    width,
                                    0,
                                    height,
                                    width
                                ];
                            default:
                                return [
                                    0,
                                    0,
                                    width,
                                    height
                                ];
                        }
                    }
                    #setStroke() {
                        const { ctx, color, opacity, thickness, parentScale, scaleFactor } = this;
                        ctx.lineWidth = thickness * parentScale / scaleFactor;
                        ctx.lineCap = "round";
                        ctx.lineJoin = "round";
                        ctx.miterLimit = 10;
                        ctx.strokeStyle = `${color}${(0, _tools.opacityToHex)(opacity)}`;
                    }
                    #startDrawing(x, y) {
                        this.canvas.addEventListener("contextmenu", _display_utils.noContextMenu);
                        this.canvas.addEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.addEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.addEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                        this.isEditing = true;
                        if (!this.#isCanvasInitialized) {
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.thickness ||= InkEditor._defaultThickness;
                            this.color ||= InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                            this.opacity ??= InkEditor._defaultOpacity;
                        }
                        this.currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = false;
                        this.#setStroke();
                        this.#requestFrameCallback = ()=>{
                            this.#drawPoints();
                            if (this.#requestFrameCallback) window.requestAnimationFrame(this.#requestFrameCallback);
                        };
                        window.requestAnimationFrame(this.#requestFrameCallback);
                    }
                    #draw(x, y) {
                        const [lastX, lastY] = this.currentPath.at(-1);
                        if (this.currentPath.length > 1 && x === lastX && y === lastY) return;
                        const currentPath = this.currentPath;
                        let path2D = this.#currentPath2D;
                        currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = true;
                        if (currentPath.length <= 2) {
                            path2D.moveTo(...currentPath[0]);
                            path2D.lineTo(x, y);
                            return;
                        }
                        if (currentPath.length === 3) {
                            this.#currentPath2D = path2D = new Path2D();
                            path2D.moveTo(...currentPath[0]);
                        }
                        this.#makeBezierCurve(path2D, ...currentPath.at(-3), ...currentPath.at(-2), x, y);
                    }
                    #endPath() {
                        if (this.currentPath.length === 0) return;
                        const lastPoint = this.currentPath.at(-1);
                        this.#currentPath2D.lineTo(...lastPoint);
                    }
                    #stopDrawing(x, y) {
                        this.#requestFrameCallback = null;
                        x = Math.min(Math.max(x, 0), this.canvas.width);
                        y = Math.min(Math.max(y, 0), this.canvas.height);
                        this.#draw(x, y);
                        this.#endPath();
                        let bezier;
                        if (this.currentPath.length !== 1) bezier = this.#generateBezierPoints();
                        else {
                            const xy = [
                                x,
                                y
                            ];
                            bezier = [
                                [
                                    xy,
                                    xy.slice(),
                                    xy.slice(),
                                    xy
                                ]
                            ];
                        }
                        const path2D = this.#currentPath2D;
                        const currentPath = this.currentPath;
                        this.currentPath = [];
                        this.#currentPath2D = new Path2D();
                        const cmd = ()=>{
                            this.allRawPaths.push(currentPath);
                            this.paths.push(bezier);
                            this.bezierPath2D.push(path2D);
                            this.rebuild();
                        };
                        const undo = ()=>{
                            this.allRawPaths.pop();
                            this.paths.pop();
                            this.bezierPath2D.pop();
                            if (this.paths.length === 0) this.remove();
                            else {
                                if (!this.canvas) {
                                    this.#createCanvas();
                                    this.#createObserver();
                                }
                                this.#fitToContent();
                            }
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    #drawPoints() {
                        if (!this.#hasSomethingToDraw) return;
                        this.#hasSomethingToDraw = false;
                        const thickness = Math.ceil(this.thickness * this.parentScale);
                        const lastPoints = this.currentPath.slice(-3);
                        const x = lastPoints.map((xy)=>xy[0]);
                        const y = lastPoints.map((xy)=>xy[1]);
                        const xMin = Math.min(...x) - thickness;
                        const xMax = Math.max(...x) + thickness;
                        const yMin = Math.min(...y) - thickness;
                        const yMax = Math.max(...y) + thickness;
                        const { ctx } = this;
                        ctx.save();
                        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                        ctx.stroke(this.#currentPath2D);
                        ctx.restore();
                    }
                    #makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
                        const prevX = (x0 + x1) / 2;
                        const prevY = (y0 + y1) / 2;
                        const x3 = (x1 + x2) / 2;
                        const y3 = (y1 + y2) / 2;
                        path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
                    }
                    #generateBezierPoints() {
                        const path = this.currentPath;
                        if (path.length <= 2) return [
                            [
                                path[0],
                                path[0],
                                path.at(-1),
                                path.at(-1)
                            ]
                        ];
                        const bezierPoints = [];
                        let i;
                        let [x0, y0] = path[0];
                        for(i = 1; i < path.length - 2; i++){
                            const [x1, y1] = path[i];
                            const [x2, y2] = path[i + 1];
                            const x3 = (x1 + x2) / 2;
                            const y3 = (y1 + y2) / 2;
                            const control1 = [
                                x0 + 2 * (x1 - x0) / 3,
                                y0 + 2 * (y1 - y0) / 3
                            ];
                            const control2 = [
                                x3 + 2 * (x1 - x3) / 3,
                                y3 + 2 * (y1 - y3) / 3
                            ];
                            bezierPoints.push([
                                [
                                    x0,
                                    y0
                                ],
                                control1,
                                control2,
                                [
                                    x3,
                                    y3
                                ]
                            ]);
                            [x0, y0] = [
                                x3,
                                y3
                            ];
                        }
                        const [x1, y1] = path[i];
                        const [x2, y2] = path[i + 1];
                        const control1 = [
                            x0 + 2 * (x1 - x0) / 3,
                            y0 + 2 * (y1 - y0) / 3
                        ];
                        const control2 = [
                            x2 + 2 * (x1 - x2) / 3,
                            y2 + 2 * (y1 - y2) / 3
                        ];
                        bezierPoints.push([
                            [
                                x0,
                                y0
                            ],
                            control1,
                            control2,
                            [
                                x2,
                                y2
                            ]
                        ]);
                        return bezierPoints;
                    }
                    #redraw() {
                        if (this.isEmpty()) {
                            this.#updateTransform();
                            return;
                        }
                        this.#setStroke();
                        const { canvas, ctx } = this;
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        this.#updateTransform();
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                    }
                    commit() {
                        if (this.#disableEditing) return;
                        super.commit();
                        this.isEditing = false;
                        this.disableEditMode();
                        this.setInForeground();
                        this.#disableEditing = true;
                        this.div.classList.add("disabled");
                        this.#fitToContent(true);
                        this.makeResizable();
                        this.parent.addInkEditorIfNeeded(true);
                        this.moveInDOM();
                        this.div.focus({
                            preventScroll: true
                        });
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        this.enableEditMode();
                    }
                    canvasPointerdown(event) {
                        if (event.button !== 0 || !this.isInEditMode() || this.#disableEditing) return;
                        this.setInForeground();
                        event.preventDefault();
                        if (event.type !== "mouse") this.div.focus();
                        this.#startDrawing(event.offsetX, event.offsetY);
                    }
                    canvasPointermove(event) {
                        event.preventDefault();
                        this.#draw(event.offsetX, event.offsetY);
                    }
                    canvasPointerup(event) {
                        event.preventDefault();
                        this.#endDrawing(event);
                    }
                    canvasPointerleave(event) {
                        this.#endDrawing(event);
                    }
                    #endDrawing(event) {
                        this.canvas.removeEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.removeEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.removeEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                        setTimeout(()=>{
                            this.canvas.removeEventListener("contextmenu", _display_utils.noContextMenu);
                        }, 10);
                        this.#stopDrawing(event.offsetX, event.offsetY);
                        this.addToAnnotationStorage();
                        this.setInBackground();
                    }
                    #createCanvas() {
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.className = "inkEditorCanvas";
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((msg)=>this.canvas?.setAttribute("aria-label", msg));
                        this.div.append(this.canvas);
                        this.ctx = this.canvas.getContext("2d");
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    get isResizable() {
                        return !this.isEmpty() && this.#disableEditing;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((msg)=>this.div?.setAttribute("aria-label", msg));
                        const [x, y, w, h] = this.#getInitialBBox();
                        this.setAt(x, y, 0, 0);
                        this.setDims(w, h);
                        this.#createCanvas();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.setDims(this.width * parentWidth, this.height * parentHeight);
                            this.#redraw();
                            this.div.classList.add("disabled");
                        } else {
                            this.div.classList.add("editing");
                            this.enableEditMode();
                        }
                        this.#createObserver();
                        return this.div;
                    }
                    #setCanvasDims() {
                        if (!this.#isCanvasInitialized) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.canvas.width = Math.ceil(this.width * parentWidth);
                        this.canvas.height = Math.ceil(this.height * parentHeight);
                        this.#updateTransform();
                    }
                    setDimensions(width, height) {
                        const roundedWidth = Math.round(width);
                        const roundedHeight = Math.round(height);
                        if (this.#realWidth === roundedWidth && this.#realHeight === roundedHeight) return;
                        this.#realWidth = roundedWidth;
                        this.#realHeight = roundedHeight;
                        this.canvas.style.visibility = "hidden";
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.fixAndSetPosition();
                        if (this.#disableEditing) this.#setScaleFactor(width, height);
                        this.#setCanvasDims();
                        this.#redraw();
                        this.canvas.style.visibility = "visible";
                        this.fixDims();
                    }
                    #setScaleFactor(width, height) {
                        const padding = this.#getPadding();
                        const scaleFactorW = (width - padding) / this.#baseWidth;
                        const scaleFactorH = (height - padding) / this.#baseHeight;
                        this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
                    }
                    #updateTransform() {
                        const padding = this.#getPadding() / 2;
                        this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
                    }
                    static #buildPath2D(bezier) {
                        const path2D = new Path2D();
                        for(let i = 0, ii = bezier.length; i < ii; i++){
                            const [first, control1, control2, second] = bezier[i];
                            if (i === 0) path2D.moveTo(...first);
                            path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
                        }
                        return path2D;
                    }
                    static #toPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] += blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] + blX;
                                    points[i + 1] = x + blY;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] += blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trX - points[i + 1];
                                    points[i + 1] = trY - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    static #fromPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] -= blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] - blY;
                                    points[i + 1] = x - blX;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] -= blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trY - points[i + 1];
                                    points[i + 1] = trX - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    #serializePaths(s, tx, ty, rect) {
                        const paths = [];
                        const padding = this.thickness / 2;
                        const shiftX = s * tx + padding;
                        const shiftY = s * ty + padding;
                        for (const bezier of this.paths){
                            const buffer = [];
                            const points = [];
                            for(let j = 0, jj = bezier.length; j < jj; j++){
                                const [first, control1, control2, second] = bezier[j];
                                const p10 = s * first[0] + shiftX;
                                const p11 = s * first[1] + shiftY;
                                const p20 = s * control1[0] + shiftX;
                                const p21 = s * control1[1] + shiftY;
                                const p30 = s * control2[0] + shiftX;
                                const p31 = s * control2[1] + shiftY;
                                const p40 = s * second[0] + shiftX;
                                const p41 = s * second[1] + shiftY;
                                if (j === 0) {
                                    buffer.push(p10, p11);
                                    points.push(p10, p11);
                                }
                                buffer.push(p20, p21, p30, p31, p40, p41);
                                points.push(p20, p21);
                                if (j === jj - 1) points.push(p40, p41);
                            }
                            paths.push({
                                bezier: InkEditor.#toPDFCoordinates(buffer, rect, this.rotation),
                                points: InkEditor.#toPDFCoordinates(points, rect, this.rotation)
                            });
                        }
                        return paths;
                    }
                    #getBbox() {
                        let xMin = Infinity;
                        let xMax = -Infinity;
                        let yMin = Infinity;
                        let yMax = -Infinity;
                        for (const path of this.paths)for (const [first, control1, control2, second] of path){
                            const bbox = _util.Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
                            xMin = Math.min(xMin, bbox[0]);
                            yMin = Math.min(yMin, bbox[1]);
                            xMax = Math.max(xMax, bbox[2]);
                            yMax = Math.max(yMax, bbox[3]);
                        }
                        return [
                            xMin,
                            yMin,
                            xMax,
                            yMax
                        ];
                    }
                    #getPadding() {
                        return this.#disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
                    }
                    #fitToContent(firstTime = false) {
                        if (this.isEmpty()) return;
                        if (!this.#disableEditing) {
                            this.#redraw();
                            return;
                        }
                        const bbox = this.#getBbox();
                        const padding = this.#getPadding();
                        this.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        this.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        const width = Math.ceil(padding + this.#baseWidth * this.scaleFactor);
                        const height = Math.ceil(padding + this.#baseHeight * this.scaleFactor);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setAspectRatio(width, height);
                        const prevTranslationX = this.translationX;
                        const prevTranslationY = this.translationY;
                        this.translationX = -bbox[0];
                        this.translationY = -bbox[1];
                        this.#setCanvasDims();
                        this.#redraw();
                        this.#realWidth = width;
                        this.#realHeight = height;
                        this.setDims(width, height);
                        const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
                        this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.InkAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.thickness = data.thickness;
                        editor.color = _util.Util.makeHexColor(...data.color);
                        editor.opacity = data.opacity;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const width = editor.width * pageWidth;
                        const height = editor.height * pageHeight;
                        const scaleFactor = editor.parentScale;
                        const padding = data.thickness / 2;
                        editor.#disableEditing = true;
                        editor.#realWidth = Math.round(width);
                        editor.#realHeight = Math.round(height);
                        const { paths, rect, rotation } = data;
                        for (let { bezier } of paths){
                            bezier = InkEditor.#fromPDFCoordinates(bezier, rect, rotation);
                            const path = [];
                            editor.paths.push(path);
                            let p0 = scaleFactor * (bezier[0] - padding);
                            let p1 = scaleFactor * (bezier[1] - padding);
                            for(let i = 2, ii = bezier.length; i < ii; i += 6){
                                const p10 = scaleFactor * (bezier[i] - padding);
                                const p11 = scaleFactor * (bezier[i + 1] - padding);
                                const p20 = scaleFactor * (bezier[i + 2] - padding);
                                const p21 = scaleFactor * (bezier[i + 3] - padding);
                                const p30 = scaleFactor * (bezier[i + 4] - padding);
                                const p31 = scaleFactor * (bezier[i + 5] - padding);
                                path.push([
                                    [
                                        p0,
                                        p1
                                    ],
                                    [
                                        p10,
                                        p11
                                    ],
                                    [
                                        p20,
                                        p21
                                    ],
                                    [
                                        p30,
                                        p31
                                    ]
                                ]);
                                p0 = p30;
                                p1 = p31;
                            }
                            const path2D = this.#buildPath2D(path);
                            editor.bezierPath2D.push(path2D);
                        }
                        const bbox = editor.#getBbox();
                        editor.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        editor.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        editor.#setScaleFactor(width, height);
                        return editor;
                    }
                    serialize() {
                        if (this.isEmpty()) return null;
                        const rect = this.getRect(0, 0);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                        return {
                            annotationType: _util.AnnotationEditorType.INK,
                            color: color,
                            thickness: this.thickness,
                            opacity: this.opacity,
                            paths: this.#serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                    }
                }
                exports.InkEditor = InkEditor;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_layer = __w_pdfjs_require__(29);
                class StampEditor extends _editor.AnnotationEditor {
                    #bitmap = null;
                    #bitmapId = null;
                    #bitmapPromise = null;
                    #bitmapUrl = null;
                    #bitmapFile = null;
                    #canvas = null;
                    #observer = null;
                    #resizeTimeoutId = null;
                    #isSvg = false;
                    #hasBeenAddedInUndoStack = false;
                    static _type = "stamp";
                    constructor(params){
                        super({
                            ...params,
                            name: "stampEditor"
                        });
                        this.#bitmapUrl = params.bitmapUrl;
                        this.#bitmapFile = params.bitmapFile;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n);
                    }
                    static get supportedTypes() {
                        const types = [
                            "apng",
                            "avif",
                            "bmp",
                            "gif",
                            "jpeg",
                            "png",
                            "svg+xml",
                            "webp",
                            "x-icon"
                        ];
                        return (0, _util.shadow)(this, "supportedTypes", types.map((type)=>`image/${type}`));
                    }
                    static get supportedTypesStr() {
                        return (0, _util.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
                    }
                    static isHandlingMimeForPasting(mime) {
                        return this.supportedTypes.includes(mime);
                    }
                    static paste(item, parent) {
                        parent.pasteEditor(_util.AnnotationEditorType.STAMP, {
                            bitmapFile: item.getAsFile()
                        });
                    }
                    #getBitmapFetched(data, fromId = false) {
                        if (!data) {
                            this.remove();
                            return;
                        }
                        this.#bitmap = data.bitmap;
                        if (!fromId) {
                            this.#bitmapId = data.id;
                            this.#isSvg = data.isSvg;
                        }
                        this.#createCanvas();
                    }
                    #getBitmapDone() {
                        this.#bitmapPromise = null;
                        this._uiManager.enableWaiting(false);
                        if (this.#canvas) this.div.focus();
                    }
                    #getBitmap() {
                        if (this.#bitmapId) {
                            this._uiManager.enableWaiting(true);
                            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapUrl) {
                            const url = this.#bitmapUrl;
                            this.#bitmapUrl = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapFile) {
                            const file = this.#bitmapFile;
                            this.#bitmapFile = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        const input = document.createElement("input");
                        input.type = "file";
                        input.accept = StampEditor.supportedTypesStr;
                        this.#bitmapPromise = new Promise((resolve)=>{
                            input.addEventListener("change", async ()=>{
                                if (!input.files || input.files.length === 0) this.remove();
                                else {
                                    this._uiManager.enableWaiting(true);
                                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                                    this.#getBitmapFetched(data);
                                }
                                resolve();
                            });
                            input.addEventListener("cancel", ()=>{
                                this.remove();
                                resolve();
                            });
                        }).finally(()=>this.#getBitmapDone());
                        input.click();
                    }
                    remove() {
                        if (this.#bitmapId) {
                            this.#bitmap = null;
                            this._uiManager.imageManager.deleteId(this.#bitmapId);
                            this.#canvas?.remove();
                            this.#canvas = null;
                            this.#observer?.disconnect();
                            this.#observer = null;
                        }
                        super.remove();
                    }
                    rebuild() {
                        if (!this.parent) {
                            if (this.#bitmapId) this.#getBitmap();
                            return;
                        }
                        super.rebuild();
                        if (this.div === null) return;
                        if (this.#bitmapId) this.#getBitmap();
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    onceAdded() {
                        this._isDraggable = true;
                        this.div.focus();
                    }
                    isEmpty() {
                        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile);
                    }
                    get isResizable() {
                        return true;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.div.hidden = true;
                        if (this.#bitmap) this.#createCanvas();
                        else this.#getBitmap();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                        }
                        return this.div;
                    }
                    #createCanvas() {
                        const { div } = this;
                        let { width, height } = this.#bitmap;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const MAX_RATIO = 0.75;
                        if (this.width) {
                            width = this.width * pageWidth;
                            height = this.height * pageHeight;
                        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
                            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
                            width *= factor;
                            height *= factor;
                        }
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
                        this._uiManager.enableWaiting(false);
                        const canvas = this.#canvas = document.createElement("canvas");
                        div.append(canvas);
                        div.hidden = false;
                        this.#drawBitmap(width, height);
                        this.#createObserver();
                        if (!this.#hasBeenAddedInUndoStack) {
                            this.parent.addUndoableEditor(this);
                            this.#hasBeenAddedInUndoStack = true;
                        }
                        this._uiManager._eventBus.dispatch("reporttelemetry", {
                            source: this,
                            details: {
                                type: "editing",
                                subtype: this.editorType,
                                data: {
                                    action: "inserted_image"
                                }
                            }
                        });
                        this.addAltTextButton();
                    }
                    #setDimensions(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setDims(width, height);
                        if (this._initialOptions?.isCentered) this.center();
                        else this.fixAndSetPosition();
                        this._initialOptions = null;
                        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
                        const TIME_TO_WAIT = 200;
                        this.#resizeTimeoutId = setTimeout(()=>{
                            this.#resizeTimeoutId = null;
                            this.#drawBitmap(width, height);
                        }, TIME_TO_WAIT);
                    }
                    #scaleBitmap(width, height) {
                        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
                        let newWidth = bitmapWidth;
                        let newHeight = bitmapHeight;
                        let bitmap = this.#bitmap;
                        while(newWidth > 2 * width || newHeight > 2 * height){
                            const prevWidth = newWidth;
                            const prevHeight = newHeight;
                            if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
                            if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
                            const offscreen = new OffscreenCanvas(newWidth, newHeight);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                            bitmap = offscreen.transferToImageBitmap();
                        }
                        return bitmap;
                    }
                    #drawBitmap(width, height) {
                        width = Math.ceil(width);
                        height = Math.ceil(height);
                        const canvas = this.#canvas;
                        if (!canvas || canvas.width === width && canvas.height === height) return;
                        canvas.width = width;
                        canvas.height = height;
                        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(width, height);
                        const ctx = canvas.getContext("2d");
                        ctx.filter = this._uiManager.hcmFilter;
                        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
                    }
                    #serializeBitmap(toUrl) {
                        if (toUrl) {
                            if (this.#isSvg) {
                                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                                if (url) return url;
                            }
                            const canvas = document.createElement("canvas");
                            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0);
                            return canvas.toDataURL();
                        }
                        if (this.#isSvg) {
                            const [pageWidth, pageHeight] = this.pageDimensions;
                            const width = Math.round(this.width * pageWidth * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const height = Math.round(this.height * pageHeight * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const offscreen = new OffscreenCanvas(width, height);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
                            return offscreen.transferToImageBitmap();
                        }
                        return structuredClone(this.#bitmap);
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.#setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.StampAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        const { rect, bitmapUrl, bitmapId, isSvg, accessibilityData } = data;
                        if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) editor.#bitmapId = bitmapId;
                        else editor.#bitmapUrl = bitmapUrl;
                        editor.#isSvg = isSvg;
                        const [parentWidth, parentHeight] = editor.pageDimensions;
                        editor.width = (rect[2] - rect[0]) / parentWidth;
                        editor.height = (rect[3] - rect[1]) / parentHeight;
                        if (accessibilityData) editor.altTextData = accessibilityData;
                        return editor;
                    }
                    serialize(isForCopying = false, context = null) {
                        if (this.isEmpty()) return null;
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.STAMP,
                            bitmapId: this.#bitmapId,
                            pageIndex: this.pageIndex,
                            rect: this.getRect(0, 0),
                            rotation: this.rotation,
                            isSvg: this.#isSvg,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) {
                            serialized.bitmapUrl = this.#serializeBitmap(true);
                            serialized.accessibilityData = this.altTextData;
                            return serialized;
                        }
                        const { decorative, altText } = this.altTextData;
                        if (!decorative && altText) serialized.accessibilityData = {
                            type: "Figure",
                            alt: altText
                        };
                        if (context === null) return serialized;
                        context.stamps ||= new Map();
                        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
                        if (!context.stamps.has(this.#bitmapId)) {
                            context.stamps.set(this.#bitmapId, {
                                area: area,
                                serialized: serialized
                            });
                            serialized.bitmap = this.#serializeBitmap(false);
                        } else if (this.#isSvg) {
                            const prevData = context.stamps.get(this.#bitmapId);
                            if (area > prevData.area) {
                                prevData.area = area;
                                prevData.serialized.bitmap.close();
                                prevData.serialized.bitmap = this.#serializeBitmap(false);
                            }
                        }
                        return serialized;
                    }
                }
                exports.StampEditor = StampEditor;
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "AbortException", {
                enumerable: true,
                get: function() {
                    return _util.AbortException;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_editor_layer.AnnotationEditorLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorParamsType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorParamsType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorUIManager", {
                enumerable: true,
                get: function() {
                    return _tools.AnnotationEditorUIManager;
                }
            });
            Object.defineProperty(exports, "AnnotationLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_layer.AnnotationLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationMode", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationMode;
                }
            });
            Object.defineProperty(exports, "CMapCompressionType", {
                enumerable: true,
                get: function() {
                    return _util.CMapCompressionType;
                }
            });
            Object.defineProperty(exports, "DOMSVGFactory", {
                enumerable: true,
                get: function() {
                    return _display_utils.DOMSVGFactory;
                }
            });
            Object.defineProperty(exports, "FeatureTest", {
                enumerable: true,
                get: function() {
                    return _util.FeatureTest;
                }
            });
            Object.defineProperty(exports, "GlobalWorkerOptions", {
                enumerable: true,
                get: function() {
                    return _worker_options.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports, "ImageKind", {
                enumerable: true,
                get: function() {
                    return _util.ImageKind;
                }
            });
            Object.defineProperty(exports, "InvalidPDFException", {
                enumerable: true,
                get: function() {
                    return _util.InvalidPDFException;
                }
            });
            Object.defineProperty(exports, "MissingPDFException", {
                enumerable: true,
                get: function() {
                    return _util.MissingPDFException;
                }
            });
            Object.defineProperty(exports, "OPS", {
                enumerable: true,
                get: function() {
                    return _util.OPS;
                }
            });
            Object.defineProperty(exports, "PDFDataRangeTransport", {
                enumerable: true,
                get: function() {
                    return _api.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports, "PDFDateString", {
                enumerable: true,
                get: function() {
                    return _display_utils.PDFDateString;
                }
            });
            Object.defineProperty(exports, "PDFWorker", {
                enumerable: true,
                get: function() {
                    return _api.PDFWorker;
                }
            });
            Object.defineProperty(exports, "PasswordResponses", {
                enumerable: true,
                get: function() {
                    return _util.PasswordResponses;
                }
            });
            Object.defineProperty(exports, "PermissionFlag", {
                enumerable: true,
                get: function() {
                    return _util.PermissionFlag;
                }
            });
            Object.defineProperty(exports, "PixelsPerInch", {
                enumerable: true,
                get: function() {
                    return _display_utils.PixelsPerInch;
                }
            });
            Object.defineProperty(exports, "PromiseCapability", {
                enumerable: true,
                get: function() {
                    return _util.PromiseCapability;
                }
            });
            Object.defineProperty(exports, "RenderingCancelledException", {
                enumerable: true,
                get: function() {
                    return _display_utils.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function() {
                    return _api.SVGGraphics;
                }
            });
            Object.defineProperty(exports, "UnexpectedResponseException", {
                enumerable: true,
                get: function() {
                    return _util.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports, "Util", {
                enumerable: true,
                get: function() {
                    return _util.Util;
                }
            });
            Object.defineProperty(exports, "VerbosityLevel", {
                enumerable: true,
                get: function() {
                    return _util.VerbosityLevel;
                }
            });
            Object.defineProperty(exports, "XfaLayer", {
                enumerable: true,
                get: function() {
                    return _xfa_layer.XfaLayer;
                }
            });
            Object.defineProperty(exports, "build", {
                enumerable: true,
                get: function() {
                    return _api.build;
                }
            });
            Object.defineProperty(exports, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function() {
                    return _util.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports, "getDocument", {
                enumerable: true,
                get: function() {
                    return _api.getDocument;
                }
            });
            Object.defineProperty(exports, "getFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getXfaPageViewport", {
                enumerable: true,
                get: function() {
                    return _display_utils.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports, "isDataScheme", {
                enumerable: true,
                get: function() {
                    return _display_utils.isDataScheme;
                }
            });
            Object.defineProperty(exports, "isPdfFile", {
                enumerable: true,
                get: function() {
                    return _display_utils.isPdfFile;
                }
            });
            Object.defineProperty(exports, "loadScript", {
                enumerable: true,
                get: function() {
                    return _display_utils.loadScript;
                }
            });
            Object.defineProperty(exports, "noContextMenu", {
                enumerable: true,
                get: function() {
                    return _display_utils.noContextMenu;
                }
            });
            Object.defineProperty(exports, "normalizeUnicode", {
                enumerable: true,
                get: function() {
                    return _util.normalizeUnicode;
                }
            });
            Object.defineProperty(exports, "renderTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.renderTextLayer;
                }
            });
            Object.defineProperty(exports, "setLayerDimensions", {
                enumerable: true,
                get: function() {
                    return _display_utils.setLayerDimensions;
                }
            });
            Object.defineProperty(exports, "shadow", {
                enumerable: true,
                get: function() {
                    return _util.shadow;
                }
            });
            Object.defineProperty(exports, "updateTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.updateTextLayer;
                }
            });
            Object.defineProperty(exports, "version", {
                enumerable: true,
                get: function() {
                    return _api.version;
                }
            });
            var _util = __w_pdfjs_require__(1);
            var _api = __w_pdfjs_require__(2);
            var _display_utils = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(26);
            var _annotation_editor_layer = __w_pdfjs_require__(27);
            var _tools = __w_pdfjs_require__(5);
            var _annotation_layer = __w_pdfjs_require__(29);
            var _worker_options = __w_pdfjs_require__(14);
            var _xfa_layer = __w_pdfjs_require__(32);
            const pdfjsVersion = "3.11.174";
            const pdfjsBuild = "ce8716743";
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRegister("hIXGI", function(module, exports) {
// shim for using process in browser
var $ce74d88631dafa59$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ce74d88631dafa59$var$cachedSetTimeout;
var $ce74d88631dafa59$var$cachedClearTimeout;
function $ce74d88631dafa59$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ce74d88631dafa59$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ce74d88631dafa59$var$cachedSetTimeout = setTimeout;
        else $ce74d88631dafa59$var$cachedSetTimeout = $ce74d88631dafa59$var$defaultSetTimout;
    } catch (e) {
        $ce74d88631dafa59$var$cachedSetTimeout = $ce74d88631dafa59$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ce74d88631dafa59$var$cachedClearTimeout = clearTimeout;
        else $ce74d88631dafa59$var$cachedClearTimeout = $ce74d88631dafa59$var$defaultClearTimeout;
    } catch (e) {
        $ce74d88631dafa59$var$cachedClearTimeout = $ce74d88631dafa59$var$defaultClearTimeout;
    }
})();
function $ce74d88631dafa59$var$runTimeout(fun) {
    if ($ce74d88631dafa59$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ce74d88631dafa59$var$cachedSetTimeout === $ce74d88631dafa59$var$defaultSetTimout || !$ce74d88631dafa59$var$cachedSetTimeout) && setTimeout) {
        $ce74d88631dafa59$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ce74d88631dafa59$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ce74d88631dafa59$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ce74d88631dafa59$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ce74d88631dafa59$var$runClearTimeout(marker) {
    if ($ce74d88631dafa59$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ce74d88631dafa59$var$cachedClearTimeout === $ce74d88631dafa59$var$defaultClearTimeout || !$ce74d88631dafa59$var$cachedClearTimeout) && clearTimeout) {
        $ce74d88631dafa59$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ce74d88631dafa59$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ce74d88631dafa59$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ce74d88631dafa59$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ce74d88631dafa59$var$queue = [];
var $ce74d88631dafa59$var$draining = false;
var $ce74d88631dafa59$var$currentQueue;
var $ce74d88631dafa59$var$queueIndex = -1;
function $ce74d88631dafa59$var$cleanUpNextTick() {
    if (!$ce74d88631dafa59$var$draining || !$ce74d88631dafa59$var$currentQueue) return;
    $ce74d88631dafa59$var$draining = false;
    if ($ce74d88631dafa59$var$currentQueue.length) $ce74d88631dafa59$var$queue = $ce74d88631dafa59$var$currentQueue.concat($ce74d88631dafa59$var$queue);
    else $ce74d88631dafa59$var$queueIndex = -1;
    if ($ce74d88631dafa59$var$queue.length) $ce74d88631dafa59$var$drainQueue();
}
function $ce74d88631dafa59$var$drainQueue() {
    if ($ce74d88631dafa59$var$draining) return;
    var timeout = $ce74d88631dafa59$var$runTimeout($ce74d88631dafa59$var$cleanUpNextTick);
    $ce74d88631dafa59$var$draining = true;
    var len = $ce74d88631dafa59$var$queue.length;
    while(len){
        $ce74d88631dafa59$var$currentQueue = $ce74d88631dafa59$var$queue;
        $ce74d88631dafa59$var$queue = [];
        while(++$ce74d88631dafa59$var$queueIndex < len)if ($ce74d88631dafa59$var$currentQueue) $ce74d88631dafa59$var$currentQueue[$ce74d88631dafa59$var$queueIndex].run();
        $ce74d88631dafa59$var$queueIndex = -1;
        len = $ce74d88631dafa59$var$queue.length;
    }
    $ce74d88631dafa59$var$currentQueue = null;
    $ce74d88631dafa59$var$draining = false;
    $ce74d88631dafa59$var$runClearTimeout(timeout);
}
$ce74d88631dafa59$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ce74d88631dafa59$var$queue.push(new $ce74d88631dafa59$var$Item(fun, args));
    if ($ce74d88631dafa59$var$queue.length === 1 && !$ce74d88631dafa59$var$draining) $ce74d88631dafa59$var$runTimeout($ce74d88631dafa59$var$drainQueue);
};
// v8 likes predictible objects
function $ce74d88631dafa59$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ce74d88631dafa59$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ce74d88631dafa59$var$process.title = "browser";
$ce74d88631dafa59$var$process.browser = true;
$ce74d88631dafa59$var$process.env = {};
$ce74d88631dafa59$var$process.argv = [];
$ce74d88631dafa59$var$process.version = ""; // empty string to avoid regexp issues
$ce74d88631dafa59$var$process.versions = {};
function $ce74d88631dafa59$var$noop() {}
$ce74d88631dafa59$var$process.on = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.addListener = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.once = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.off = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.removeListener = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.removeAllListeners = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.emit = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.prependListener = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.prependOnceListener = $ce74d88631dafa59$var$noop;
$ce74d88631dafa59$var$process.listeners = function(name) {
    return [];
};
$ce74d88631dafa59$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ce74d88631dafa59$var$process.cwd = function() {
    return "/";
};
$ce74d88631dafa59$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ce74d88631dafa59$var$process.umask = function() {
    return 0;
};

});

parcelRegister("cBXue", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $92e7158efb4d49dd$export$a143d493d941bafc, (v) => $92e7158efb4d49dd$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $92e7158efb4d49dd$export$f99ded8fe4b79145, (v) => $92e7158efb4d49dd$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $92e7158efb4d49dd$export$a143d493d941bafc;
var $92e7158efb4d49dd$export$e4cf37d7f6fb9e0a;
var $92e7158efb4d49dd$export$f99ded8fe4b79145;
var $92e7158efb4d49dd$export$599f31c3813fae4d;
"use strict";

var $4nf3l = parcelRequire("4nf3l");

var $iL6rd = parcelRequire("iL6rd");
var $92e7158efb4d49dd$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$92e7158efb4d49dd$export$a143d493d941bafc = $92e7158efb4d49dd$var$Buffer;
$92e7158efb4d49dd$export$e4cf37d7f6fb9e0a = $92e7158efb4d49dd$var$SlowBuffer;
$92e7158efb4d49dd$export$f99ded8fe4b79145 = 50;
var $92e7158efb4d49dd$var$K_MAX_LENGTH = 0x7fffffff;
$92e7158efb4d49dd$export$599f31c3813fae4d = $92e7158efb4d49dd$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $92e7158efb4d49dd$var$Buffer.TYPED_ARRAY_SUPPORT = $92e7158efb4d49dd$var$typedArraySupport();
if (!$92e7158efb4d49dd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $92e7158efb4d49dd$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($92e7158efb4d49dd$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$92e7158efb4d49dd$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($92e7158efb4d49dd$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$92e7158efb4d49dd$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $92e7158efb4d49dd$var$createBuffer(length) {
    if (length > $92e7158efb4d49dd$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $92e7158efb4d49dd$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $92e7158efb4d49dd$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $92e7158efb4d49dd$var$allocUnsafe(arg);
    }
    return $92e7158efb4d49dd$var$from(arg, encodingOrOffset, length);
}
$92e7158efb4d49dd$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $92e7158efb4d49dd$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $92e7158efb4d49dd$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $92e7158efb4d49dd$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($92e7158efb4d49dd$var$isInstance(value, ArrayBuffer) || value && $92e7158efb4d49dd$var$isInstance(value.buffer, ArrayBuffer)) return $92e7158efb4d49dd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($92e7158efb4d49dd$var$isInstance(value, SharedArrayBuffer) || value && $92e7158efb4d49dd$var$isInstance(value.buffer, SharedArrayBuffer))) return $92e7158efb4d49dd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $92e7158efb4d49dd$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $92e7158efb4d49dd$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $92e7158efb4d49dd$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $92e7158efb4d49dd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $92e7158efb4d49dd$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($92e7158efb4d49dd$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($92e7158efb4d49dd$var$Buffer, Uint8Array);
function $92e7158efb4d49dd$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $92e7158efb4d49dd$var$alloc(size, fill, encoding) {
    $92e7158efb4d49dd$var$assertSize(size);
    if (size <= 0) return $92e7158efb4d49dd$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $92e7158efb4d49dd$var$createBuffer(size).fill(fill, encoding) : $92e7158efb4d49dd$var$createBuffer(size).fill(fill);
    return $92e7158efb4d49dd$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $92e7158efb4d49dd$var$Buffer.alloc = function(size, fill, encoding) {
    return $92e7158efb4d49dd$var$alloc(size, fill, encoding);
};
function $92e7158efb4d49dd$var$allocUnsafe(size) {
    $92e7158efb4d49dd$var$assertSize(size);
    return $92e7158efb4d49dd$var$createBuffer(size < 0 ? 0 : $92e7158efb4d49dd$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $92e7158efb4d49dd$var$Buffer.allocUnsafe = function(size) {
    return $92e7158efb4d49dd$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $92e7158efb4d49dd$var$Buffer.allocUnsafeSlow = function(size) {
    return $92e7158efb4d49dd$var$allocUnsafe(size);
};
function $92e7158efb4d49dd$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$92e7158efb4d49dd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $92e7158efb4d49dd$var$byteLength(string, encoding) | 0;
    var buf = $92e7158efb4d49dd$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $92e7158efb4d49dd$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $92e7158efb4d49dd$var$checked(array.length) | 0;
    var buf = $92e7158efb4d49dd$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $92e7158efb4d49dd$var$fromArrayView(arrayView) {
    if ($92e7158efb4d49dd$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $92e7158efb4d49dd$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $92e7158efb4d49dd$var$fromArrayLike(arrayView);
}
function $92e7158efb4d49dd$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $92e7158efb4d49dd$var$Buffer.prototype);
    return buf;
}
function $92e7158efb4d49dd$var$fromObject(obj) {
    if ($92e7158efb4d49dd$var$Buffer.isBuffer(obj)) {
        var len = $92e7158efb4d49dd$var$checked(obj.length) | 0;
        var buf = $92e7158efb4d49dd$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $92e7158efb4d49dd$var$numberIsNaN(obj.length)) return $92e7158efb4d49dd$var$createBuffer(0);
        return $92e7158efb4d49dd$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $92e7158efb4d49dd$var$fromArrayLike(obj.data);
}
function $92e7158efb4d49dd$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $92e7158efb4d49dd$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $92e7158efb4d49dd$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $92e7158efb4d49dd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $92e7158efb4d49dd$var$Buffer.alloc(+length);
}
$92e7158efb4d49dd$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $92e7158efb4d49dd$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$92e7158efb4d49dd$var$Buffer.compare = function compare(a, b) {
    if ($92e7158efb4d49dd$var$isInstance(a, Uint8Array)) a = $92e7158efb4d49dd$var$Buffer.from(a, a.offset, a.byteLength);
    if ($92e7158efb4d49dd$var$isInstance(b, Uint8Array)) b = $92e7158efb4d49dd$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(a) || !$92e7158efb4d49dd$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$92e7158efb4d49dd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$92e7158efb4d49dd$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $92e7158efb4d49dd$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $92e7158efb4d49dd$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($92e7158efb4d49dd$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $92e7158efb4d49dd$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$92e7158efb4d49dd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $92e7158efb4d49dd$var$byteLength(string, encoding) {
    if ($92e7158efb4d49dd$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $92e7158efb4d49dd$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $92e7158efb4d49dd$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $92e7158efb4d49dd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $92e7158efb4d49dd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$92e7158efb4d49dd$var$Buffer.byteLength = $92e7158efb4d49dd$var$byteLength;
function $92e7158efb4d49dd$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $92e7158efb4d49dd$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $92e7158efb4d49dd$var$utf8Slice(this, start, end);
        case "ascii":
            return $92e7158efb4d49dd$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $92e7158efb4d49dd$var$latin1Slice(this, start, end);
        case "base64":
            return $92e7158efb4d49dd$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $92e7158efb4d49dd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$92e7158efb4d49dd$var$Buffer.prototype._isBuffer = true;
function $92e7158efb4d49dd$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$92e7158efb4d49dd$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$92e7158efb4d49dd$var$swap(this, i, i + 1);
    return this;
};
$92e7158efb4d49dd$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $92e7158efb4d49dd$var$swap(this, i, i + 3);
        $92e7158efb4d49dd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$92e7158efb4d49dd$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $92e7158efb4d49dd$var$swap(this, i, i + 7);
        $92e7158efb4d49dd$var$swap(this, i + 1, i + 6);
        $92e7158efb4d49dd$var$swap(this, i + 2, i + 5);
        $92e7158efb4d49dd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$92e7158efb4d49dd$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $92e7158efb4d49dd$var$utf8Slice(this, 0, length);
    return $92e7158efb4d49dd$var$slowToString.apply(this, arguments);
};
$92e7158efb4d49dd$var$Buffer.prototype.toLocaleString = $92e7158efb4d49dd$var$Buffer.prototype.toString;
$92e7158efb4d49dd$var$Buffer.prototype.equals = function equals(b) {
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $92e7158efb4d49dd$var$Buffer.compare(this, b) === 0;
};
$92e7158efb4d49dd$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $92e7158efb4d49dd$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($92e7158efb4d49dd$var$customInspectSymbol) $92e7158efb4d49dd$var$Buffer.prototype[$92e7158efb4d49dd$var$customInspectSymbol] = $92e7158efb4d49dd$var$Buffer.prototype.inspect;
$92e7158efb4d49dd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($92e7158efb4d49dd$var$isInstance(target, Uint8Array)) target = $92e7158efb4d49dd$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $92e7158efb4d49dd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($92e7158efb4d49dd$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $92e7158efb4d49dd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($92e7158efb4d49dd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $92e7158efb4d49dd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $92e7158efb4d49dd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $92e7158efb4d49dd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$92e7158efb4d49dd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$92e7158efb4d49dd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $92e7158efb4d49dd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$92e7158efb4d49dd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $92e7158efb4d49dd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $92e7158efb4d49dd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($92e7158efb4d49dd$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $92e7158efb4d49dd$var$utf8Write(buf, string, offset, length) {
    return $92e7158efb4d49dd$var$blitBuffer($92e7158efb4d49dd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $92e7158efb4d49dd$var$asciiWrite(buf, string, offset, length) {
    return $92e7158efb4d49dd$var$blitBuffer($92e7158efb4d49dd$var$asciiToBytes(string), buf, offset, length);
}
function $92e7158efb4d49dd$var$base64Write(buf, string, offset, length) {
    return $92e7158efb4d49dd$var$blitBuffer($92e7158efb4d49dd$var$base64ToBytes(string), buf, offset, length);
}
function $92e7158efb4d49dd$var$ucs2Write(buf, string, offset, length) {
    return $92e7158efb4d49dd$var$blitBuffer($92e7158efb4d49dd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$92e7158efb4d49dd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $92e7158efb4d49dd$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $92e7158efb4d49dd$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $92e7158efb4d49dd$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $92e7158efb4d49dd$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $92e7158efb4d49dd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$92e7158efb4d49dd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $92e7158efb4d49dd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4nf3l.fromByteArray(buf);
    else return $4nf3l.fromByteArray(buf.slice(start, end));
}
function $92e7158efb4d49dd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $92e7158efb4d49dd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $92e7158efb4d49dd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $92e7158efb4d49dd$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $92e7158efb4d49dd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $92e7158efb4d49dd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $92e7158efb4d49dd$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $92e7158efb4d49dd$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $92e7158efb4d49dd$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $92e7158efb4d49dd$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $92e7158efb4d49dd$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$92e7158efb4d49dd$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $92e7158efb4d49dd$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $92e7158efb4d49dd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$92e7158efb4d49dd$var$Buffer.prototype.readUintLE = $92e7158efb4d49dd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readUintBE = $92e7158efb4d49dd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint8 = $92e7158efb4d49dd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint16LE = $92e7158efb4d49dd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint16BE = $92e7158efb4d49dd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint32LE = $92e7158efb4d49dd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$92e7158efb4d49dd$var$Buffer.prototype.readUint32BE = $92e7158efb4d49dd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$92e7158efb4d49dd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$92e7158efb4d49dd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$92e7158efb4d49dd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return $iL6rd.read(this, offset, true, 23, 4);
};
$92e7158efb4d49dd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 4, this.length);
    return $iL6rd.read(this, offset, false, 23, 4);
};
$92e7158efb4d49dd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 8, this.length);
    return $iL6rd.read(this, offset, true, 52, 8);
};
$92e7158efb4d49dd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkOffset(offset, 8, this.length);
    return $iL6rd.read(this, offset, false, 52, 8);
};
function $92e7158efb4d49dd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$92e7158efb4d49dd$var$Buffer.prototype.writeUintLE = $92e7158efb4d49dd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $92e7158efb4d49dd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUintBE = $92e7158efb4d49dd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $92e7158efb4d49dd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint8 = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint16LE = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint16BE = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint32LE = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeUint32BE = $92e7158efb4d49dd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $92e7158efb4d49dd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $92e7158efb4d49dd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$92e7158efb4d49dd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $92e7158efb4d49dd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $92e7158efb4d49dd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $iL6rd.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$92e7158efb4d49dd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $92e7158efb4d49dd$var$writeFloat(this, value, offset, true, noAssert);
};
$92e7158efb4d49dd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $92e7158efb4d49dd$var$writeFloat(this, value, offset, false, noAssert);
};
function $92e7158efb4d49dd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92e7158efb4d49dd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $iL6rd.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$92e7158efb4d49dd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $92e7158efb4d49dd$var$writeDouble(this, value, offset, true, noAssert);
};
$92e7158efb4d49dd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $92e7158efb4d49dd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$92e7158efb4d49dd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$92e7158efb4d49dd$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$92e7158efb4d49dd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$92e7158efb4d49dd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $92e7158efb4d49dd$var$Buffer.isBuffer(val) ? val : $92e7158efb4d49dd$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $92e7158efb4d49dd$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $92e7158efb4d49dd$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($92e7158efb4d49dd$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $92e7158efb4d49dd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $92e7158efb4d49dd$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $92e7158efb4d49dd$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $92e7158efb4d49dd$var$base64ToBytes(str) {
    return $4nf3l.toByteArray($92e7158efb4d49dd$var$base64clean(str));
}
function $92e7158efb4d49dd$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $92e7158efb4d49dd$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $92e7158efb4d49dd$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $92e7158efb4d49dd$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("4nf3l", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $32f4fca1571d79cf$export$d622b2ad8d90c771, (v) => $32f4fca1571d79cf$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $32f4fca1571d79cf$export$6100ba28696e12de, (v) => $32f4fca1571d79cf$export$6100ba28696e12de = v);
var $32f4fca1571d79cf$export$a48f0734ac7c2329;
var $32f4fca1571d79cf$export$d622b2ad8d90c771;
var $32f4fca1571d79cf$export$6100ba28696e12de;
"use strict";
$32f4fca1571d79cf$export$a48f0734ac7c2329 = $32f4fca1571d79cf$var$byteLength;
$32f4fca1571d79cf$export$d622b2ad8d90c771 = $32f4fca1571d79cf$var$toByteArray;
$32f4fca1571d79cf$export$6100ba28696e12de = $32f4fca1571d79cf$var$fromByteArray;
var $32f4fca1571d79cf$var$lookup = [];
var $32f4fca1571d79cf$var$revLookup = [];
var $32f4fca1571d79cf$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $32f4fca1571d79cf$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $32f4fca1571d79cf$var$i = 0, $32f4fca1571d79cf$var$len = $32f4fca1571d79cf$var$code.length; $32f4fca1571d79cf$var$i < $32f4fca1571d79cf$var$len; ++$32f4fca1571d79cf$var$i){
    $32f4fca1571d79cf$var$lookup[$32f4fca1571d79cf$var$i] = $32f4fca1571d79cf$var$code[$32f4fca1571d79cf$var$i];
    $32f4fca1571d79cf$var$revLookup[$32f4fca1571d79cf$var$code.charCodeAt($32f4fca1571d79cf$var$i)] = $32f4fca1571d79cf$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$32f4fca1571d79cf$var$revLookup["-".charCodeAt(0)] = 62;
$32f4fca1571d79cf$var$revLookup["_".charCodeAt(0)] = 63;
function $32f4fca1571d79cf$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $32f4fca1571d79cf$var$byteLength(b64) {
    var lens = $32f4fca1571d79cf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $32f4fca1571d79cf$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $32f4fca1571d79cf$var$toByteArray(b64) {
    var tmp;
    var lens = $32f4fca1571d79cf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $32f4fca1571d79cf$var$Arr($32f4fca1571d79cf$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i)] << 18 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i)] << 2 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i)] << 10 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $32f4fca1571d79cf$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $32f4fca1571d79cf$var$tripletToBase64(num) {
    return $32f4fca1571d79cf$var$lookup[num >> 18 & 0x3F] + $32f4fca1571d79cf$var$lookup[num >> 12 & 0x3F] + $32f4fca1571d79cf$var$lookup[num >> 6 & 0x3F] + $32f4fca1571d79cf$var$lookup[num & 0x3F];
}
function $32f4fca1571d79cf$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($32f4fca1571d79cf$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $32f4fca1571d79cf$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($32f4fca1571d79cf$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($32f4fca1571d79cf$var$lookup[tmp >> 2] + $32f4fca1571d79cf$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($32f4fca1571d79cf$var$lookup[tmp >> 10] + $32f4fca1571d79cf$var$lookup[tmp >> 4 & 0x3F] + $32f4fca1571d79cf$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("iL6rd", function(module, exports) {

$parcel$export(module.exports, "read", () => $da819c3c1253403e$export$aafa59e2e03f2942, (v) => $da819c3c1253403e$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $da819c3c1253403e$export$68d8715fc104d294, (v) => $da819c3c1253403e$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $da819c3c1253403e$export$aafa59e2e03f2942;
var $da819c3c1253403e$export$68d8715fc104d294;
$da819c3c1253403e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$da819c3c1253403e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("67wIF", function(module, exports) {
"use strict";

});


parcelRegister("iEwv0", function(module, exports) {
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.37", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("2hgcV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveSubscriptionKeyAuthentication = void 0;

var $3wpON = parcelRequire("3wpON");

var $bPVwM = parcelRequire("bPVwM");

var $9ej08 = parcelRequire("9ej08");
/**
 * @class
 */ class $1a89bdca1f942de7$var$CognitiveSubscriptionKeyAuthentication {
    /**
     * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
     * @constructor
     * @param {string} subscriptionKey - The subscription key
     */ constructor(subscriptionKey){
        if (!subscriptionKey) throw new $3wpON.ArgumentNullError("subscriptionKey");
        this.privAuthInfo = new $9ej08.AuthInfo($bPVwM.HeaderNames.AuthKey, subscriptionKey);
    }
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetch(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    }
    /**
     * Fetches the subscription key.
     * @member
     * @function
     * @public
     * @param {string} authFetchEventId - The id to fetch.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchOnExpiry(authFetchEventId) {
        return Promise.resolve(this.privAuthInfo);
    }
}
module.exports.CognitiveSubscriptionKeyAuthentication = $1a89bdca1f942de7$var$CognitiveSubscriptionKeyAuthentication;

});
parcelRegister("3wpON", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $2908634055280787$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2908634055280787$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $2908634055280787$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2908634055280787$var$__exportStar((parcelRequire("fJn7z")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("eSeaR")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("gHTPR")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("5o3nj")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("j3dpT")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("9Viyf")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("6tpyr")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("gTOjC")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("i0XQk")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("lDeiB")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("fwuJG")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("2KmoS")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("gIMfM")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("3ItQs")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("2mhTC")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("jdyCy")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("3B33Q")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("2Rtjl")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("ffANk")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("5yhYp")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("kA6l5")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("ixkFx")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("3tNF7")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("iEpNT")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("8OkBp")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("giDJW")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("j2gOb")), module.exports);

var $6kHRL = parcelRequire("6kHRL");
Object.defineProperty(module.exports, "TranslationStatus", {
    enumerable: true,
    get: function() {
        return $6kHRL.TranslationStatus;
    }
});

$2908634055280787$var$__exportStar((parcelRequire("4K7xf")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("h3fm0")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("9rKNp")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("7L9ww")), module.exports);

$2908634055280787$var$__exportStar((parcelRequire("fG2zh")), module.exports);

});
parcelRegister("fJn7z", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamNodeErrorEvent = module.exports.AudioStreamNodeDetachedEvent = module.exports.AudioStreamNodeAttachedEvent = module.exports.AudioStreamNodeAttachingEvent = module.exports.AudioStreamNodeEvent = module.exports.AudioSourceErrorEvent = module.exports.AudioSourceOffEvent = module.exports.AudioSourceReadyEvent = module.exports.AudioSourceInitializingEvent = module.exports.AudioSourceEvent = void 0;

var $ixkFx = parcelRequire("ixkFx");
class $b73cfe5c29a0a506$var$AudioSourceEvent extends $ixkFx.PlatformEvent {
    constructor(eventName, audioSourceId, eventType = $ixkFx.EventType.Info){
        super(eventName, eventType);
        this.privAudioSourceId = audioSourceId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
}
module.exports.AudioSourceEvent = $b73cfe5c29a0a506$var$AudioSourceEvent;
class $b73cfe5c29a0a506$var$AudioSourceInitializingEvent extends $b73cfe5c29a0a506$var$AudioSourceEvent {
    constructor(audioSourceId){
        super("AudioSourceInitializingEvent", audioSourceId);
    }
}
module.exports.AudioSourceInitializingEvent = $b73cfe5c29a0a506$var$AudioSourceInitializingEvent;
class $b73cfe5c29a0a506$var$AudioSourceReadyEvent extends $b73cfe5c29a0a506$var$AudioSourceEvent {
    constructor(audioSourceId){
        super("AudioSourceReadyEvent", audioSourceId);
    }
}
module.exports.AudioSourceReadyEvent = $b73cfe5c29a0a506$var$AudioSourceReadyEvent;
class $b73cfe5c29a0a506$var$AudioSourceOffEvent extends $b73cfe5c29a0a506$var$AudioSourceEvent {
    constructor(audioSourceId){
        super("AudioSourceOffEvent", audioSourceId);
    }
}
module.exports.AudioSourceOffEvent = $b73cfe5c29a0a506$var$AudioSourceOffEvent;
class $b73cfe5c29a0a506$var$AudioSourceErrorEvent extends $b73cfe5c29a0a506$var$AudioSourceEvent {
    constructor(audioSourceId, error){
        super("AudioSourceErrorEvent", audioSourceId, $ixkFx.EventType.Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
module.exports.AudioSourceErrorEvent = $b73cfe5c29a0a506$var$AudioSourceErrorEvent;
class $b73cfe5c29a0a506$var$AudioStreamNodeEvent extends $b73cfe5c29a0a506$var$AudioSourceEvent {
    constructor(eventName, audioSourceId, audioNodeId){
        super(eventName, audioSourceId);
        this.privAudioNodeId = audioNodeId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
module.exports.AudioStreamNodeEvent = $b73cfe5c29a0a506$var$AudioStreamNodeEvent;
class $b73cfe5c29a0a506$var$AudioStreamNodeAttachingEvent extends $b73cfe5c29a0a506$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId);
    }
}
module.exports.AudioStreamNodeAttachingEvent = $b73cfe5c29a0a506$var$AudioStreamNodeAttachingEvent;
class $b73cfe5c29a0a506$var$AudioStreamNodeAttachedEvent extends $b73cfe5c29a0a506$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId);
    }
}
module.exports.AudioStreamNodeAttachedEvent = $b73cfe5c29a0a506$var$AudioStreamNodeAttachedEvent;
class $b73cfe5c29a0a506$var$AudioStreamNodeDetachedEvent extends $b73cfe5c29a0a506$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId){
        super("AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId);
    }
}
module.exports.AudioStreamNodeDetachedEvent = $b73cfe5c29a0a506$var$AudioStreamNodeDetachedEvent;
class $b73cfe5c29a0a506$var$AudioStreamNodeErrorEvent extends $b73cfe5c29a0a506$var$AudioStreamNodeEvent {
    constructor(audioSourceId, audioNodeId, error){
        super("AudioStreamNodeErrorEvent", audioSourceId, audioNodeId);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
module.exports.AudioStreamNodeErrorEvent = $b73cfe5c29a0a506$var$AudioStreamNodeErrorEvent;

});
parcelRegister("ixkFx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlatformEvent = module.exports.EventType = void 0;

var $lDeiB = parcelRequire("lDeiB");
var $d7eb577b5737788c$var$EventType;
(function(EventType) {
    EventType[EventType["Debug"] = 0] = "Debug";
    EventType[EventType["Info"] = 1] = "Info";
    EventType[EventType["Warning"] = 2] = "Warning";
    EventType[EventType["Error"] = 3] = "Error";
    EventType[EventType["None"] = 4] = "None";
})($d7eb577b5737788c$var$EventType = module.exports.EventType || (module.exports.EventType = {}));
class $d7eb577b5737788c$var$PlatformEvent {
    constructor(eventName, eventType){
        this.privName = eventName;
        this.privEventId = $lDeiB.createNoDashGuid();
        this.privEventTime = new Date().toISOString();
        this.privEventType = eventType;
        this.privMetadata = {};
    }
    get name() {
        return this.privName;
    }
    get eventId() {
        return this.privEventId;
    }
    get eventTime() {
        return this.privEventTime;
    }
    get eventType() {
        return this.privEventType;
    }
    get metadata() {
        return this.privMetadata;
    }
}
module.exports.PlatformEvent = $d7eb577b5737788c$var$PlatformEvent;

});
parcelRegister("lDeiB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNoDashGuid = module.exports.createGuid = void 0;

var $lVxbe = parcelRequire("lVxbe");
const $fbf854fc4817e09c$var$createGuid = ()=>$lVxbe.default();
module.exports.createGuid = $fbf854fc4817e09c$var$createGuid;
const $fbf854fc4817e09c$var$createNoDashGuid = ()=>$fbf854fc4817e09c$var$createGuid().replace(new RegExp("-", "g"), "").toUpperCase();
module.exports.createNoDashGuid = $fbf854fc4817e09c$var$createNoDashGuid;

});
parcelRegister("lVxbe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff68a8bdbf6da3d0$export$2e2bcd8739ae039);

var $hp0d1 = parcelRequire("hp0d1");

var $5oP7C = parcelRequire("5oP7C");

var $9XvqX = parcelRequire("9XvqX");
function $ff68a8bdbf6da3d0$var$v4(options, buf, offset) {
    if ((0, $hp0d1.default).randomUUID && !buf && !options) return (0, $hp0d1.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $5oP7C.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $9XvqX.unsafeStringify)(rnds);
}
var $ff68a8bdbf6da3d0$export$2e2bcd8739ae039 = $ff68a8bdbf6da3d0$var$v4;

});
parcelRegister("hp0d1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cab4eefef0bf3b81$export$2e2bcd8739ae039);
const $cab4eefef0bf3b81$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $cab4eefef0bf3b81$export$2e2bcd8739ae039 = {
    randomUUID: $cab4eefef0bf3b81$var$randomUUID
};

});

parcelRegister("5oP7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ee6d9632afdbcb1$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $3ee6d9632afdbcb1$var$getRandomValues;
const $3ee6d9632afdbcb1$var$rnds8 = new Uint8Array(16);
function $3ee6d9632afdbcb1$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$3ee6d9632afdbcb1$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $3ee6d9632afdbcb1$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$3ee6d9632afdbcb1$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $3ee6d9632afdbcb1$var$getRandomValues($3ee6d9632afdbcb1$var$rnds8);
}

});

parcelRegister("9XvqX", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $740201dc67dd3d90$export$8fb373d660548968);

var $6L7cg = parcelRequire("6L7cg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $740201dc67dd3d90$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$740201dc67dd3d90$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $740201dc67dd3d90$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $740201dc67dd3d90$var$byteToHex[arr[offset + 0]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 1]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 2]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 3]] + "-" + $740201dc67dd3d90$var$byteToHex[arr[offset + 4]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 5]] + "-" + $740201dc67dd3d90$var$byteToHex[arr[offset + 6]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 7]] + "-" + $740201dc67dd3d90$var$byteToHex[arr[offset + 8]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 9]] + "-" + $740201dc67dd3d90$var$byteToHex[arr[offset + 10]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 11]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 12]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 13]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 14]] + $740201dc67dd3d90$var$byteToHex[arr[offset + 15]];
}
function $740201dc67dd3d90$var$stringify(arr, offset = 0) {
    const uuid = $740201dc67dd3d90$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $6L7cg.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $740201dc67dd3d90$export$2e2bcd8739ae039 = $740201dc67dd3d90$var$stringify;

});
parcelRegister("6L7cg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ebcb701bfc46cf8$export$2e2bcd8739ae039);

var $5R76s = parcelRequire("5R76s");
function $4ebcb701bfc46cf8$var$validate(uuid) {
    return typeof uuid === "string" && (0, $5R76s.default).test(uuid);
}
var $4ebcb701bfc46cf8$export$2e2bcd8739ae039 = $4ebcb701bfc46cf8$var$validate;

});
parcelRegister("5R76s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4437698a0a52edc7$export$2e2bcd8739ae039);
var $4437698a0a52edc7$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});







parcelRegister("eSeaR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageSentEvent = module.exports.ConnectionMessageReceivedEvent = module.exports.ConnectionEstablishErrorEvent = module.exports.ConnectionErrorEvent = module.exports.ConnectionClosedEvent = module.exports.ConnectionEstablishedEvent = module.exports.ConnectionStartEvent = module.exports.ConnectionEvent = module.exports.ServiceEvent = void 0;

var $ixkFx = parcelRequire("ixkFx");
class $ad411a81f493d711$var$ServiceEvent extends $ixkFx.PlatformEvent {
    constructor(eventName, jsonstring, eventType = $ixkFx.EventType.Info){
        super(eventName, eventType);
        this.privJsonResult = jsonstring;
    }
    get jsonString() {
        return this.privJsonResult;
    }
}
module.exports.ServiceEvent = $ad411a81f493d711$var$ServiceEvent;
class $ad411a81f493d711$var$ConnectionEvent extends $ixkFx.PlatformEvent {
    constructor(eventName, connectionId, eventType = $ixkFx.EventType.Info){
        super(eventName, eventType);
        this.privConnectionId = connectionId;
    }
    get connectionId() {
        return this.privConnectionId;
    }
}
module.exports.ConnectionEvent = $ad411a81f493d711$var$ConnectionEvent;
class $ad411a81f493d711$var$ConnectionStartEvent extends $ad411a81f493d711$var$ConnectionEvent {
    constructor(connectionId, uri, headers){
        super("ConnectionStartEvent", connectionId);
        this.privUri = uri;
        this.privHeaders = headers;
    }
    get uri() {
        return this.privUri;
    }
    get headers() {
        return this.privHeaders;
    }
}
module.exports.ConnectionStartEvent = $ad411a81f493d711$var$ConnectionStartEvent;
class $ad411a81f493d711$var$ConnectionEstablishedEvent extends $ad411a81f493d711$var$ConnectionEvent {
    constructor(connectionId){
        super("ConnectionEstablishedEvent", connectionId);
    }
}
module.exports.ConnectionEstablishedEvent = $ad411a81f493d711$var$ConnectionEstablishedEvent;
class $ad411a81f493d711$var$ConnectionClosedEvent extends $ad411a81f493d711$var$ConnectionEvent {
    constructor(connectionId, statusCode, reason){
        super("ConnectionClosedEvent", connectionId, $ixkFx.EventType.Debug);
        this.privReason = reason;
        this.privStatusCode = statusCode;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
module.exports.ConnectionClosedEvent = $ad411a81f493d711$var$ConnectionClosedEvent;
class $ad411a81f493d711$var$ConnectionErrorEvent extends $ad411a81f493d711$var$ConnectionEvent {
    constructor(connectionId, message, type){
        super("ConnectionErrorEvent", connectionId, $ixkFx.EventType.Debug);
        this.privMessage = message;
        this.privType = type;
    }
    get message() {
        return this.privMessage;
    }
    get type() {
        return this.privType;
    }
}
module.exports.ConnectionErrorEvent = $ad411a81f493d711$var$ConnectionErrorEvent;
class $ad411a81f493d711$var$ConnectionEstablishErrorEvent extends $ad411a81f493d711$var$ConnectionEvent {
    constructor(connectionId, statuscode, reason){
        super("ConnectionEstablishErrorEvent", connectionId, $ixkFx.EventType.Error);
        this.privStatusCode = statuscode;
        this.privReason = reason;
    }
    get reason() {
        return this.privReason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
}
module.exports.ConnectionEstablishErrorEvent = $ad411a81f493d711$var$ConnectionEstablishErrorEvent;
class $ad411a81f493d711$var$ConnectionMessageReceivedEvent extends $ad411a81f493d711$var$ConnectionEvent {
    constructor(connectionId, networkReceivedTimeISO, message){
        super("ConnectionMessageReceivedEvent", connectionId);
        this.privNetworkReceivedTime = networkReceivedTimeISO;
        this.privMessage = message;
    }
    get networkReceivedTime() {
        return this.privNetworkReceivedTime;
    }
    get message() {
        return this.privMessage;
    }
}
module.exports.ConnectionMessageReceivedEvent = $ad411a81f493d711$var$ConnectionMessageReceivedEvent;
class $ad411a81f493d711$var$ConnectionMessageSentEvent extends $ad411a81f493d711$var$ConnectionEvent {
    constructor(connectionId, networkSentTimeISO, message){
        super("ConnectionMessageSentEvent", connectionId);
        this.privNetworkSentTime = networkSentTimeISO;
        this.privMessage = message;
    }
    get networkSentTime() {
        return this.privNetworkSentTime;
    }
    get message() {
        return this.privMessage;
    }
}
module.exports.ConnectionMessageSentEvent = $ad411a81f493d711$var$ConnectionMessageSentEvent;

});

parcelRegister("gHTPR", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-return */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessage = module.exports.MessageType = void 0;

var $6tpyr = parcelRequire("6tpyr");

var $lDeiB = parcelRequire("lDeiB");
var $c29bf9418bdefcb9$var$MessageType;
(function(MessageType) {
    MessageType[MessageType["Text"] = 0] = "Text";
    MessageType[MessageType["Binary"] = 1] = "Binary";
})($c29bf9418bdefcb9$var$MessageType = module.exports.MessageType || (module.exports.MessageType = {}));
class $c29bf9418bdefcb9$var$ConnectionMessage {
    constructor(messageType, body, headers, id){
        this.privBody = null;
        if (messageType === $c29bf9418bdefcb9$var$MessageType.Text && body && !(typeof body === "string")) throw new $6tpyr.InvalidOperationError("Payload must be a string");
        if (messageType === $c29bf9418bdefcb9$var$MessageType.Binary && body && !(body instanceof ArrayBuffer)) throw new $6tpyr.InvalidOperationError("Payload must be ArrayBuffer");
        this.privMessageType = messageType;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.privBody = body;
        this.privHeaders = headers ? headers : {};
        this.privId = id ? id : $lDeiB.createNoDashGuid();
        switch(this.messageType){
            case $c29bf9418bdefcb9$var$MessageType.Binary:
                this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
                break;
            case $c29bf9418bdefcb9$var$MessageType.Text:
                this.privSize = this.textBody.length;
        }
    }
    get messageType() {
        return this.privMessageType;
    }
    get headers() {
        return this.privHeaders;
    }
    get body() {
        return this.privBody;
    }
    get textBody() {
        if (this.privMessageType === $c29bf9418bdefcb9$var$MessageType.Binary) throw new $6tpyr.InvalidOperationError("Not supported for binary message");
        return this.privBody;
    }
    get binaryBody() {
        if (this.privMessageType === $c29bf9418bdefcb9$var$MessageType.Text) throw new $6tpyr.InvalidOperationError("Not supported for text message");
        return this.privBody;
    }
    get id() {
        return this.privId;
    }
}
module.exports.ConnectionMessage = $c29bf9418bdefcb9$var$ConnectionMessage;

});
parcelRegister("6tpyr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectDisposedError = module.exports.InvalidOperationError = module.exports.ArgumentNullError = void 0;
/* eslint-disable max-classes-per-file */ /**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class ArgumentNullError
 * @extends {Error}
 */ class $4b694614548492fa$var$ArgumentNullError extends Error {
    /**
     * Creates an instance of ArgumentNullError.
     *
     * @param {string} argumentName - Name of the argument that is null
     *
     * @memberOf ArgumentNullError
     */ constructor(argumentName){
        super(argumentName);
        this.name = "ArgumentNull";
        this.message = argumentName;
    }
}
module.exports.ArgumentNullError = $4b694614548492fa$var$ArgumentNullError;
/**
 * The error that is thrown when an invalid operation is performed in the code.
 *
 * @export
 * @class InvalidOperationError
 * @extends {Error}
 */ class $4b694614548492fa$var$InvalidOperationError extends Error {
    /**
     * Creates an instance of InvalidOperationError.
     *
     * @param {string} error - The error
     *
     * @memberOf InvalidOperationError
     */ constructor(error){
        super(error);
        this.name = "InvalidOperation";
        this.message = error;
    }
}
module.exports.InvalidOperationError = $4b694614548492fa$var$InvalidOperationError;
/**
 * The error that is thrown when an object is disposed.
 *
 * @export
 * @class ObjectDisposedError
 * @extends {Error}
 */ class $4b694614548492fa$var$ObjectDisposedError extends Error {
    /**
     * Creates an instance of ObjectDisposedError.
     *
     * @param {string} objectName - The object that is disposed
     * @param {string} error - The error
     *
     * @memberOf ObjectDisposedError
     */ constructor(objectName, error){
        super(error);
        this.name = objectName + "ObjectDisposed";
        this.message = error;
    }
}
module.exports.ObjectDisposedError = $4b694614548492fa$var$ObjectDisposedError;

});


parcelRegister("5o3nj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionOpenResponse = void 0;
class $3ec1cfdf6ceeb272$var$ConnectionOpenResponse {
    constructor(statusCode, reason){
        this.privStatusCode = statusCode;
        this.privReason = reason;
    }
    get statusCode() {
        return this.privStatusCode;
    }
    get reason() {
        return this.privReason;
    }
}
module.exports.ConnectionOpenResponse = $3ec1cfdf6ceeb272$var$ConnectionOpenResponse;

});

parcelRegister("j3dpT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeferralMap = void 0;
/**
 * The error that is thrown when an argument passed in is null.
 *
 * @export
 * @class DefferalMap
 */ class $dde8b4626c24ba8c$var$DeferralMap {
    constructor(){
        this.privMap = {};
    }
    add(id, deferral) {
        this.privMap[id] = deferral;
    }
    getId(id) {
        return this.privMap[id];
    }
    complete(id, result) {
        try {
            this.privMap[id].resolve(result);
        } catch (error) {
            this.privMap[id].reject(error);
        } finally{
            this.privMap[id] = undefined;
        }
    }
}
module.exports.DeferralMap = $dde8b4626c24ba8c$var$DeferralMap;

});

parcelRegister("9Viyf", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendingAgentContextMessageEvent = module.exports.DialogEvent = void 0;

var $ixkFx = parcelRequire("ixkFx");
class $01dd499c5479eccd$var$DialogEvent extends $ixkFx.PlatformEvent {
    constructor(eventName, eventType = $ixkFx.EventType.Info){
        super(eventName, eventType);
    }
}
module.exports.DialogEvent = $01dd499c5479eccd$var$DialogEvent;
class $01dd499c5479eccd$var$SendingAgentContextMessageEvent extends $01dd499c5479eccd$var$DialogEvent {
    constructor(agentConfig){
        super("SendingAgentContextMessageEvent");
        this.privAgentConfig = agentConfig;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
}
module.exports.SendingAgentContextMessageEvent = $01dd499c5479eccd$var$SendingAgentContextMessageEvent;

});

parcelRegister("gTOjC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = void 0;

var $6tpyr = parcelRequire("6tpyr");

var $i0XQk = parcelRequire("i0XQk");
class $c4d8cff95a384752$var$Events {
    static setEventSource(eventSource) {
        if (!eventSource) throw new $6tpyr.ArgumentNullError("eventSource");
        $c4d8cff95a384752$var$Events.privInstance = eventSource;
    }
    static get instance() {
        return $c4d8cff95a384752$var$Events.privInstance;
    }
}
module.exports.Events = $c4d8cff95a384752$var$Events;
$c4d8cff95a384752$var$Events.privInstance = new $i0XQk.EventSource();

});
parcelRegister("i0XQk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSource = void 0;

var $6tpyr = parcelRequire("6tpyr");

var $lDeiB = parcelRequire("lDeiB");
class $d1d6a5ab1f299f11$var$EventSource {
    constructor(metadata){
        this.privEventListeners = {};
        this.privIsDisposed = false;
        this.privConsoleListener = undefined;
        this.privMetadata = metadata;
    }
    onEvent(event) {
        if (this.isDisposed()) throw new $6tpyr.ObjectDisposedError("EventSource");
        if (this.metadata) {
            for(const paramName in this.metadata)if (paramName) {
                if (event.metadata) {
                    if (!event.metadata[paramName]) event.metadata[paramName] = this.metadata[paramName];
                }
            }
        }
        for(const eventId in this.privEventListeners)if (eventId && this.privEventListeners[eventId]) this.privEventListeners[eventId](event);
    }
    attach(onEventCallback) {
        const id = $lDeiB.createNoDashGuid();
        this.privEventListeners[id] = onEventCallback;
        return {
            detach: ()=>{
                delete this.privEventListeners[id];
                return Promise.resolve();
            }
        };
    }
    attachListener(listener) {
        return this.attach((e)=>listener.onEvent(e));
    }
    attachConsoleListener(listener) {
        if (!!this.privConsoleListener) this.privConsoleListener.detach(); // Detach implementation for eventListeners is synchronous
        this.privConsoleListener = this.attach((e)=>listener.onEvent(e));
        return this.privConsoleListener;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        this.privEventListeners = null;
        this.privIsDisposed = true;
    }
    get metadata() {
        return this.privMetadata;
    }
}
module.exports.EventSource = $d1d6a5ab1f299f11$var$EventSource;

});


parcelRegister("fwuJG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2KmoS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionState = void 0;
var $200140e43a5acdb2$var$ConnectionState;
(function(ConnectionState) {
    ConnectionState[ConnectionState["None"] = 0] = "None";
    ConnectionState[ConnectionState["Connected"] = 1] = "Connected";
    ConnectionState[ConnectionState["Connecting"] = 2] = "Connecting";
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
})($200140e43a5acdb2$var$ConnectionState = module.exports.ConnectionState || (module.exports.ConnectionState = {}));

});

parcelRegister("gIMfM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3ItQs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2mhTC", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jdyCy", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3B33Q", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2Rtjl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ffANk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5yhYp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kA6l5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.List = void 0;

var $6tpyr = parcelRequire("6tpyr");
class $efbc164134b8275e$var$List {
    constructor(list){
        this.privSubscriptionIdCounter = 0;
        this.privAddSubscriptions = {};
        this.privRemoveSubscriptions = {};
        this.privDisposedSubscriptions = {};
        this.privDisposeReason = null;
        this.privList = [];
        // copy the list rather than taking as is.
        if (list) for (const item of list)this.privList.push(item);
    }
    get(itemIndex) {
        this.throwIfDisposed();
        return this.privList[itemIndex];
    }
    first() {
        return this.get(0);
    }
    last() {
        return this.get(this.length() - 1);
    }
    add(item) {
        this.throwIfDisposed();
        this.insertAt(this.privList.length, item);
    }
    insertAt(index, item) {
        this.throwIfDisposed();
        if (index === 0) this.privList.unshift(item);
        else if (index === this.privList.length) this.privList.push(item);
        else this.privList.splice(index, 0, item);
        this.triggerSubscriptions(this.privAddSubscriptions);
    }
    removeFirst() {
        this.throwIfDisposed();
        return this.removeAt(0);
    }
    removeLast() {
        this.throwIfDisposed();
        return this.removeAt(this.length() - 1);
    }
    removeAt(index) {
        this.throwIfDisposed();
        return this.remove(index, 1)[0];
    }
    remove(index, count) {
        this.throwIfDisposed();
        const removedElements = this.privList.splice(index, count);
        this.triggerSubscriptions(this.privRemoveSubscriptions);
        return removedElements;
    }
    clear() {
        this.throwIfDisposed();
        this.remove(0, this.length());
    }
    length() {
        this.throwIfDisposed();
        return this.privList.length;
    }
    onAdded(addedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privAddSubscriptions[subscriptionId] = addedCallback;
        return {
            detach: ()=>{
                delete this.privAddSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onRemoved(removedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privRemoveSubscriptions[subscriptionId] = removedCallback;
        return {
            detach: ()=>{
                delete this.privRemoveSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    onDisposed(disposedCallback) {
        this.throwIfDisposed();
        const subscriptionId = this.privSubscriptionIdCounter++;
        this.privDisposedSubscriptions[subscriptionId] = disposedCallback;
        return {
            detach: ()=>{
                delete this.privDisposedSubscriptions[subscriptionId];
                return Promise.resolve();
            }
        };
    }
    join(seperator) {
        this.throwIfDisposed();
        return this.privList.join(seperator);
    }
    toArray() {
        const cloneCopy = Array();
        this.privList.forEach((val)=>{
            cloneCopy.push(val);
        });
        return cloneCopy;
    }
    any(callback) {
        this.throwIfDisposed();
        if (callback) return this.where(callback).length() > 0;
        else return this.length() > 0;
    }
    all(callback) {
        this.throwIfDisposed();
        return this.where(callback).length() === this.length();
    }
    forEach(callback) {
        this.throwIfDisposed();
        for(let i = 0; i < this.length(); i++)callback(this.privList[i], i);
    }
    select(callback) {
        this.throwIfDisposed();
        const selectList = [];
        for(let i = 0; i < this.privList.length; i++)selectList.push(callback(this.privList[i], i));
        return new $efbc164134b8275e$var$List(selectList);
    }
    where(callback) {
        this.throwIfDisposed();
        const filteredList = new $efbc164134b8275e$var$List();
        for(let i = 0; i < this.privList.length; i++)if (callback(this.privList[i], i)) filteredList.add(this.privList[i]);
        return filteredList;
    }
    orderBy(compareFn) {
        this.throwIfDisposed();
        const clonedArray = this.toArray();
        const orderedArray = clonedArray.sort(compareFn);
        return new $efbc164134b8275e$var$List(orderedArray);
    }
    orderByDesc(compareFn) {
        this.throwIfDisposed();
        return this.orderBy((a, b)=>compareFn(b, a));
    }
    clone() {
        this.throwIfDisposed();
        return new $efbc164134b8275e$var$List(this.toArray());
    }
    concat(list) {
        this.throwIfDisposed();
        return new $efbc164134b8275e$var$List(this.privList.concat(list.toArray()));
    }
    concatArray(array) {
        this.throwIfDisposed();
        return new $efbc164134b8275e$var$List(this.privList.concat(array));
    }
    isDisposed() {
        return this.privList == null;
    }
    dispose(reason) {
        if (!this.isDisposed()) {
            this.privDisposeReason = reason;
            this.privList = null;
            this.privAddSubscriptions = null;
            this.privRemoveSubscriptions = null;
            this.triggerSubscriptions(this.privDisposedSubscriptions);
        }
    }
    throwIfDisposed() {
        if (this.isDisposed()) throw new $6tpyr.ObjectDisposedError("List", this.privDisposeReason);
    }
    triggerSubscriptions(subscriptions) {
        if (subscriptions) {
            for(const subscriptionId in subscriptions)if (subscriptionId) subscriptions[subscriptionId]();
        }
    }
}
module.exports.List = $efbc164134b8275e$var$List;

});

parcelRegister("3tNF7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.marshalPromiseToCallbacks = module.exports.Sink = module.exports.Deferred = module.exports.PromiseResultEventSource = module.exports.PromiseResult = module.exports.PromiseState = void 0;
/* eslint-disable max-classes-per-file, @typescript-eslint/typedef */ var $288a9a655df5014b$var$PromiseState;
(function(PromiseState) {
    PromiseState[PromiseState["None"] = 0] = "None";
    PromiseState[PromiseState["Resolved"] = 1] = "Resolved";
    PromiseState[PromiseState["Rejected"] = 2] = "Rejected";
})($288a9a655df5014b$var$PromiseState = module.exports.PromiseState || (module.exports.PromiseState = {}));
class $288a9a655df5014b$var$PromiseResult {
    constructor(promiseResultEventSource){
        this.throwIfError = ()=>{
            if (this.isError) throw this.error;
        };
        promiseResultEventSource.on((result)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = false;
                this.privResult = result;
            }
        }, (error)=>{
            if (!this.privIsCompleted) {
                this.privIsCompleted = true;
                this.privIsError = true;
                this.privError = error;
            }
        });
    }
    get isCompleted() {
        return this.privIsCompleted;
    }
    get isError() {
        return this.privIsError;
    }
    get error() {
        return this.privError;
    }
    get result() {
        return this.privResult;
    }
}
module.exports.PromiseResult = $288a9a655df5014b$var$PromiseResult;
class $288a9a655df5014b$var$PromiseResultEventSource {
    constructor(){
        this.setResult = (result)=>{
            this.privOnSetResult(result);
        };
        this.setError = (error)=>{
            this.privOnSetError(error);
        };
        this.on = (onSetResult, onSetError)=>{
            this.privOnSetResult = onSetResult;
            this.privOnSetError = onSetError;
        };
    }
}
module.exports.PromiseResultEventSource = $288a9a655df5014b$var$PromiseResultEventSource;
class $288a9a655df5014b$var$Deferred {
    constructor(){
        this.resolve = (result)=>{
            this.privResolve(result);
            return this;
        };
        this.reject = (error)=>{
            this.privReject(error);
            return this;
        };
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.privPromise = new Promise((resolve, reject)=>{
            this.privResolve = resolve;
            this.privReject = reject;
        });
    }
    get promise() {
        return this.privPromise;
    }
}
module.exports.Deferred = $288a9a655df5014b$var$Deferred;
class $288a9a655df5014b$var$Sink {
    constructor(){
        this.privState = $288a9a655df5014b$var$PromiseState.None;
        this.privPromiseResult = null;
        this.privPromiseResultEvents = null;
        this.privSuccessHandlers = [];
        this.privErrorHandlers = [];
        this.privPromiseResultEvents = new $288a9a655df5014b$var$PromiseResultEventSource();
        this.privPromiseResult = new $288a9a655df5014b$var$PromiseResult(this.privPromiseResultEvents);
    }
    get state() {
        return this.privState;
    }
    get result() {
        return this.privPromiseResult;
    }
    resolve(result) {
        if (this.privState !== $288a9a655df5014b$var$PromiseState.None) throw new Error("'Cannot resolve a completed promise'");
        this.privState = $288a9a655df5014b$var$PromiseState.Resolved;
        this.privPromiseResultEvents.setResult(result);
        for(let i = 0; i < this.privSuccessHandlers.length; i++)this.executeSuccessCallback(result, this.privSuccessHandlers[i], this.privErrorHandlers[i]);
        this.detachHandlers();
    }
    reject(error) {
        if (this.privState !== $288a9a655df5014b$var$PromiseState.None) throw new Error("'Cannot reject a completed promise'");
        this.privState = $288a9a655df5014b$var$PromiseState.Rejected;
        this.privPromiseResultEvents.setError(error);
        for (const errorHandler of this.privErrorHandlers)this.executeErrorCallback(error, errorHandler);
        this.detachHandlers();
    }
    on(successCallback, errorCallback) {
        if (successCallback == null) // eslint-disable-next-line @typescript-eslint/no-empty-function
        successCallback = ()=>{};
        if (this.privState === $288a9a655df5014b$var$PromiseState.None) {
            this.privSuccessHandlers.push(successCallback);
            this.privErrorHandlers.push(errorCallback);
        } else {
            if (this.privState === $288a9a655df5014b$var$PromiseState.Resolved) this.executeSuccessCallback(this.privPromiseResult.result, successCallback, errorCallback);
            else if (this.privState === $288a9a655df5014b$var$PromiseState.Rejected) this.executeErrorCallback(this.privPromiseResult.error, errorCallback);
            this.detachHandlers();
        }
    }
    executeSuccessCallback(result, successCallback, errorCallback) {
        try {
            successCallback(result);
        } catch (e) {
            this.executeErrorCallback(`'Unhandled callback error: ${e}'`, errorCallback);
        }
    }
    executeErrorCallback(error, errorCallback) {
        if (errorCallback) try {
            errorCallback(error);
        } catch (e) {
            throw new Error(`'Unhandled callback error: ${e}. InnerError: ${error}'`);
        }
        else throw new Error(`'Unhandled error: ${error}'`);
    }
    detachHandlers() {
        this.privErrorHandlers = [];
        this.privSuccessHandlers = [];
    }
}
module.exports.Sink = $288a9a655df5014b$var$Sink;
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function $288a9a655df5014b$var$marshalPromiseToCallbacks(promise, cb, err) {
    promise.then((val)=>{
        try {
            if (!!cb) cb(val);
        } catch (error) {
            if (!!err) try {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            // eslint-disable-next-line no-empty
            } catch (error) {}
        }
    }, (error)=>{
        if (!!err) try {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        // eslint-disable-next-line no-empty
        } catch (error) {}
    });
}
module.exports.marshalPromiseToCallbacks = $288a9a655df5014b$var$marshalPromiseToCallbacks;

});

parcelRegister("iEpNT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Queue = void 0;

var $6tpyr = parcelRequire("6tpyr");

var $kA6l5 = parcelRequire("kA6l5");

var $3tNF7 = parcelRequire("3tNF7");
var $d93ffa878660fe10$var$SubscriberType;
(function(SubscriberType) {
    SubscriberType[SubscriberType["Dequeue"] = 0] = "Dequeue";
    SubscriberType[SubscriberType["Peek"] = 1] = "Peek";
})($d93ffa878660fe10$var$SubscriberType || ($d93ffa878660fe10$var$SubscriberType = {}));
class $d93ffa878660fe10$var$Queue {
    constructor(list){
        this.privPromiseStore = new $kA6l5.List();
        this.privIsDrainInProgress = false;
        this.privIsDisposing = false;
        this.privDisposeReason = null;
        this.privList = list ? list : new $kA6l5.List();
        this.privDetachables = [];
        this.privSubscribers = new $kA6l5.List();
        this.privDetachables.push(this.privList.onAdded(()=>this.drain()));
    }
    enqueue(item) {
        this.throwIfDispose();
        this.enqueueFromPromise(new Promise((resolve)=>resolve(item)));
    }
    enqueueFromPromise(promise) {
        this.throwIfDispose();
        promise.then((val)=>{
            this.privList.add(val);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        }, ()=>{});
    }
    dequeue() {
        this.throwIfDispose();
        const deferredSubscriber = new $3tNF7.Deferred();
        if (this.privSubscribers) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $d93ffa878660fe10$var$SubscriberType.Dequeue
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    peek() {
        this.throwIfDispose();
        const deferredSubscriber = new $3tNF7.Deferred();
        const subs = this.privSubscribers;
        if (subs) {
            this.privSubscribers.add({
                deferral: deferredSubscriber,
                type: $d93ffa878660fe10$var$SubscriberType.Peek
            });
            this.drain();
        }
        return deferredSubscriber.promise;
    }
    length() {
        this.throwIfDispose();
        return this.privList.length();
    }
    isDisposed() {
        return this.privSubscribers == null;
    }
    async drainAndDispose(pendingItemProcessor, reason) {
        if (!this.isDisposed() && !this.privIsDisposing) {
            this.privDisposeReason = reason;
            this.privIsDisposing = true;
            const subs = this.privSubscribers;
            if (subs) {
                while(subs.length() > 0){
                    const subscriber = subs.removeFirst();
                    // TODO: this needs work (Resolve(null) instead?).
                    subscriber.deferral.resolve(undefined);
                // subscriber.deferral.reject("Disposed");
                }
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privSubscribers === subs) this.privSubscribers = subs;
            }
            for (const detachable of this.privDetachables)await detachable.detach();
            if (this.privPromiseStore.length() > 0 && pendingItemProcessor) {
                const promiseArray = [];
                this.privPromiseStore.toArray().forEach((wrapper)=>{
                    promiseArray.push(wrapper);
                });
                return Promise.all(promiseArray).finally(()=>{
                    this.privSubscribers = null;
                    this.privList.forEach((item)=>{
                        pendingItemProcessor(item);
                    });
                    this.privList = null;
                    return;
                }).then();
            } else {
                this.privSubscribers = null;
                this.privList = null;
            }
        }
    }
    async dispose(reason) {
        await this.drainAndDispose(null, reason);
    }
    drain() {
        if (!this.privIsDrainInProgress && !this.privIsDisposing) {
            this.privIsDrainInProgress = true;
            const subs = this.privSubscribers;
            const lists = this.privList;
            if (subs && lists) {
                while(lists.length() > 0 && subs.length() > 0 && !this.privIsDisposing){
                    const subscriber = subs.removeFirst();
                    if (subscriber.type === $d93ffa878660fe10$var$SubscriberType.Peek) subscriber.deferral.resolve(lists.first());
                    else {
                        const dequeuedItem = lists.removeFirst();
                        subscriber.deferral.resolve(dequeuedItem);
                    }
                }
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privSubscribers === subs) this.privSubscribers = subs;
                // note: this block assumes cooperative multitasking, i.e.,
                // between the if-statement and the assignment there are no
                // thread switches.
                // Reason is that between the initial const = this.; and this
                // point there is the derral.resolve() operation that might have
                // caused recursive calls to the Queue, especially, calling
                // Dispose() on the queue alredy (which would reset the var
                // here to null!).
                // That should generally hold true for javascript...
                if (this.privList === lists) this.privList = lists;
            }
            this.privIsDrainInProgress = false;
        }
    }
    throwIfDispose() {
        if (this.isDisposed()) {
            if (this.privDisposeReason) throw new $6tpyr.InvalidOperationError(this.privDisposeReason);
            throw new $6tpyr.ObjectDisposedError("Queue");
        } else if (this.privIsDisposing) throw new $6tpyr.InvalidOperationError("Queue disposing");
    }
}
module.exports.Queue = $d93ffa878660fe10$var$Queue;

});

parcelRegister("8OkBp", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawWebsocketMessage = void 0;

var $gHTPR = parcelRequire("gHTPR");

var $6tpyr = parcelRequire("6tpyr");

var $lDeiB = parcelRequire("lDeiB");
class $66a2f97040a6506d$var$RawWebsocketMessage {
    constructor(messageType, payload, id){
        this.privPayload = null;
        if (!payload) throw new $6tpyr.ArgumentNullError("payload");
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (messageType === $gHTPR.MessageType.Binary && Object.getPrototypeOf(payload).constructor.name !== "ArrayBuffer") throw new $6tpyr.InvalidOperationError("Payload must be ArrayBuffer");
        if (messageType === $gHTPR.MessageType.Text && !(typeof payload === "string")) throw new $6tpyr.InvalidOperationError("Payload must be a string");
        this.privMessageType = messageType;
        this.privPayload = payload;
        this.privId = id ? id : $lDeiB.createNoDashGuid();
    }
    get messageType() {
        return this.privMessageType;
    }
    get payload() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.privPayload;
    }
    get textContent() {
        if (this.privMessageType === $gHTPR.MessageType.Binary) throw new $6tpyr.InvalidOperationError("Not supported for binary message");
        return this.privPayload;
    }
    get binaryContent() {
        if (this.privMessageType === $gHTPR.MessageType.Text) throw new $6tpyr.InvalidOperationError("Not supported for text message");
        return this.privPayload;
    }
    get id() {
        return this.privId;
    }
}
module.exports.RawWebsocketMessage = $66a2f97040a6506d$var$RawWebsocketMessage;

});

parcelRegister("giDJW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RiffPcmEncoder = void 0;
class $bddd274d230922d6$var$RiffPcmEncoder {
    constructor(actualSampleRate, desiredSampleRate){
        this.privActualSampleRate = actualSampleRate;
        this.privDesiredSampleRate = desiredSampleRate;
    }
    encode(actualAudioFrame) {
        const audioFrame = this.downSampleAudioFrame(actualAudioFrame, this.privActualSampleRate, this.privDesiredSampleRate);
        if (!audioFrame) return null;
        const audioLength = audioFrame.length * 2;
        const buffer = new ArrayBuffer(audioLength);
        const view = new DataView(buffer);
        this.floatTo16BitPCM(view, 0, audioFrame);
        return buffer;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
    floatTo16BitPCM(view, offset, input) {
        for(let i = 0; i < input.length; i++, offset += 2){
            const s = Math.max(-1, Math.min(1, input[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
    }
    downSampleAudioFrame(srcFrame, srcRate, dstRate) {
        if (!srcFrame) return null;
        if (dstRate === srcRate || dstRate > srcRate) return srcFrame;
        const ratio = srcRate / dstRate;
        const dstLength = Math.round(srcFrame.length / ratio);
        const dstFrame = new Float32Array(dstLength);
        let srcOffset = 0;
        let dstOffset = 0;
        while(dstOffset < dstLength){
            const nextSrcOffset = Math.round((dstOffset + 1) * ratio);
            let accum = 0;
            let count = 0;
            while(srcOffset < nextSrcOffset && srcOffset < srcFrame.length){
                accum += srcFrame[srcOffset++];
                count++;
            }
            dstFrame[dstOffset++] = accum / count;
        }
        return dstFrame;
    }
}
module.exports.RiffPcmEncoder = $bddd274d230922d6$var$RiffPcmEncoder;

});

parcelRegister("j2gOb", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Stream = void 0;

var $6tpyr = parcelRequire("6tpyr");

var $lDeiB = parcelRequire("lDeiB");

var $iEpNT = parcelRequire("iEpNT");
class $ddbb3e0af87eb7a3$var$Stream {
    constructor(streamId){
        this.privIsWriteEnded = false;
        this.privIsReadEnded = false;
        this.privId = streamId ? streamId : $lDeiB.createNoDashGuid();
        this.privReaderQueue = new $iEpNT.Queue();
    }
    get isClosed() {
        return this.privIsWriteEnded;
    }
    get isReadEnded() {
        return this.privIsReadEnded;
    }
    get id() {
        return this.privId;
    }
    close() {
        if (!this.privIsWriteEnded) {
            this.writeStreamChunk({
                buffer: null,
                isEnd: true,
                timeReceived: Date.now()
            });
            this.privIsWriteEnded = true;
        }
    }
    writeStreamChunk(streamChunk) {
        this.throwIfClosed();
        if (!this.privReaderQueue.isDisposed()) try {
            this.privReaderQueue.enqueue(streamChunk);
        } catch (e) {
        // Do nothing
        }
    }
    read() {
        if (this.privIsReadEnded) throw new $6tpyr.InvalidOperationError("Stream read has already finished");
        return this.privReaderQueue.dequeue().then(async (streamChunk)=>{
            if (streamChunk === undefined || streamChunk.isEnd) await this.privReaderQueue.dispose("End of stream reached");
            return streamChunk;
        });
    }
    readEnded() {
        if (!this.privIsReadEnded) {
            this.privIsReadEnded = true;
            this.privReaderQueue = new $iEpNT.Queue();
        }
    }
    throwIfClosed() {
        if (this.privIsWriteEnded) throw new $6tpyr.InvalidOperationError("Stream closed");
    }
}
module.exports.Stream = $ddbb3e0af87eb7a3$var$Stream;

});

parcelRegister("6kHRL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationStatus = void 0;
/**
 * Defines translation status.
 * @class TranslationStatus
 */ var $49c6a34204547334$var$TranslationStatus;
(function(TranslationStatus) {
    /**
     * @member TranslationStatus.Success
     */ TranslationStatus[TranslationStatus["Success"] = 0] = "Success";
    /**
     * @member TranslationStatus.Error
     */ TranslationStatus[TranslationStatus["Error"] = 1] = "Error";
})($49c6a34204547334$var$TranslationStatus = module.exports.TranslationStatus || (module.exports.TranslationStatus = {}));

});

parcelRegister("4K7xf", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChunkedArrayBufferStream = void 0;

var $3wpON = parcelRequire("3wpON");
class $37414da78b00c613$var$ChunkedArrayBufferStream extends $3wpON.Stream {
    constructor(targetChunkSize, streamId){
        super(streamId);
        this.privTargetChunkSize = targetChunkSize;
        this.privNextBufferReadyBytes = 0;
    }
    writeStreamChunk(chunk) {
        // No pending write, and the buffer is the right size so write it.
        if (chunk.isEnd || 0 === this.privNextBufferReadyBytes && chunk.buffer.byteLength === this.privTargetChunkSize) {
            super.writeStreamChunk(chunk);
            return;
        }
        let bytesCopiedFromBuffer = 0;
        while(bytesCopiedFromBuffer < chunk.buffer.byteLength){
            // Fill the next buffer.
            if (undefined === this.privNextBufferToWrite) {
                this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize);
                this.privNextBufferStartTime = chunk.timeReceived;
            }
            // Find out how many bytes we can copy into the read buffer.
            const bytesToCopy = Math.min(chunk.buffer.byteLength - bytesCopiedFromBuffer, this.privTargetChunkSize - this.privNextBufferReadyBytes);
            const targetView = new Uint8Array(this.privNextBufferToWrite);
            const sourceView = new Uint8Array(chunk.buffer.slice(bytesCopiedFromBuffer, bytesToCopy + bytesCopiedFromBuffer));
            targetView.set(sourceView, this.privNextBufferReadyBytes);
            this.privNextBufferReadyBytes += bytesToCopy;
            bytesCopiedFromBuffer += bytesToCopy;
            // Are we ready to write?
            if (this.privNextBufferReadyBytes === this.privTargetChunkSize) {
                super.writeStreamChunk({
                    buffer: this.privNextBufferToWrite,
                    isEnd: false,
                    timeReceived: this.privNextBufferStartTime
                });
                this.privNextBufferReadyBytes = 0;
                this.privNextBufferToWrite = undefined;
            }
        }
    }
    close() {
        // Send whatever is pending, then close the base class.
        if (0 !== this.privNextBufferReadyBytes && !this.isClosed) super.writeStreamChunk({
            buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
            isEnd: false,
            timeReceived: this.privNextBufferStartTime
        });
        super.close();
    }
}
module.exports.ChunkedArrayBufferStream = $37414da78b00c613$var$ChunkedArrayBufferStream;

});

parcelRegister("h3fm0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9rKNp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
class $6e0aef5f50bdce06$var$Timeout {
    static load() {
        // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
        const scheduledTimeoutFunctions = new Map([
            [
                0,
                ()=>{}
            ]
        ]); // eslint-disable-line @typescript-eslint/no-empty-function
        const unhandledRequests = new Map();
        // eslint-disable-next-line
        const workerScript = `!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`;
        const workerUrl = "data:text/javascript;base64," + btoa(workerScript);
        const worker = new Worker(workerUrl);
        worker.addEventListener("message", ({ data: data })=>{
            if ($6e0aef5f50bdce06$var$Timeout.isCallNotification(data)) {
                const { params: { timerId: timerId } } = data;
                const idOrFunc = scheduledTimeoutFunctions.get(timerId);
                if (typeof idOrFunc === "number") {
                    const unhandledTimerId = unhandledRequests.get(idOrFunc);
                    if (unhandledTimerId === undefined || unhandledTimerId !== timerId) throw new Error("The timer is in an undefined state.");
                } else if (typeof idOrFunc !== "undefined") {
                    idOrFunc();
                    // A timeout can be safely deleted because it is only called once.
                    scheduledTimeoutFunctions.delete(timerId);
                } else throw new Error("The timer is in an undefined state.");
            } else if ($6e0aef5f50bdce06$var$Timeout.isClearResponse(data)) {
                const { id: id } = data;
                const unhandledTimerId = unhandledRequests.get(id);
                if (unhandledTimerId === undefined) throw new Error("The timer is in an undefined state.");
                unhandledRequests.delete(id);
                scheduledTimeoutFunctions.delete(unhandledTimerId);
            } else {
                const { error: { message: message } } = data;
                throw new Error(message);
            }
        });
        const clearTimeout = (timerId)=>{
            const id = Math.random();
            unhandledRequests.set(id, timerId);
            scheduledTimeoutFunctions.set(timerId, id);
            worker.postMessage({
                id: id,
                method: "clear",
                params: {
                    timerId: timerId
                }
            });
        };
        const setTimeout = (func, delay)=>{
            const timerId = Math.random();
            scheduledTimeoutFunctions.set(timerId, func);
            worker.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: delay,
                    now: performance.now(),
                    timerId: timerId
                }
            });
            return timerId;
        };
        return {
            clearTimeout: clearTimeout,
            setTimeout: setTimeout
        };
    }
    static loadWorkerTimers() {
        return ()=>{
            if ($6e0aef5f50bdce06$var$Timeout.workerTimers !== null) return $6e0aef5f50bdce06$var$Timeout.workerTimers;
            $6e0aef5f50bdce06$var$Timeout.workerTimers = $6e0aef5f50bdce06$var$Timeout.load();
            return $6e0aef5f50bdce06$var$Timeout.workerTimers;
        };
    }
    static isCallNotification(message) {
        return message.method !== undefined && message.method === "call";
    }
    static isClearResponse(message) {
        return message.error === null && typeof message.id === "number";
    }
}
module.exports.Timeout = $6e0aef5f50bdce06$var$Timeout;
$6e0aef5f50bdce06$var$Timeout.workerTimers = null;
$6e0aef5f50bdce06$var$Timeout.clearTimeout = (timerId)=>$6e0aef5f50bdce06$var$Timeout.timers().clearTimeout(timerId);
$6e0aef5f50bdce06$var$Timeout.setTimeout = (func, delay)=>$6e0aef5f50bdce06$var$Timeout.timers().setTimeout(func, delay);
$6e0aef5f50bdce06$var$Timeout.timers = $6e0aef5f50bdce06$var$Timeout.loadWorkerTimers();

});

parcelRegister("7L9ww", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OCSPCacheUpdateErrorEvent = module.exports.OCSPResponseRetrievedEvent = module.exports.OCSPCacheFetchErrorEvent = module.exports.OCSPVerificationFailedEvent = module.exports.OCSPCacheHitEvent = module.exports.OCSPCacheEntryNeedsRefreshEvent = module.exports.OCSPCacheEntryExpiredEvent = module.exports.OCSPWSUpgradeStartedEvent = module.exports.OCSPStapleReceivedEvent = module.exports.OCSPCacheUpdateCompleteEvent = module.exports.OCSPDiskCacheStoreEvent = module.exports.OCSPMemoryCacheStoreEvent = module.exports.OCSPCacheUpdateNeededEvent = module.exports.OCSPDiskCacheHitEvent = module.exports.OCSPCacheMissEvent = module.exports.OCSPMemoryCacheHitEvent = module.exports.OCSPEvent = void 0;

var $ixkFx = parcelRequire("ixkFx");
class $5a644f5c4e0b6c6e$var$OCSPEvent extends $ixkFx.PlatformEvent {
    constructor(eventName, eventType, signature){
        super(eventName, eventType);
        this.privSignature = signature;
    }
}
module.exports.OCSPEvent = $5a644f5c4e0b6c6e$var$OCSPEvent;
class $5a644f5c4e0b6c6e$var$OCSPMemoryCacheHitEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(signature){
        super("OCSPMemoryCacheHitEvent", $ixkFx.EventType.Debug, signature);
    }
}
module.exports.OCSPMemoryCacheHitEvent = $5a644f5c4e0b6c6e$var$OCSPMemoryCacheHitEvent;
class $5a644f5c4e0b6c6e$var$OCSPCacheMissEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(signature){
        super("OCSPCacheMissEvent", $ixkFx.EventType.Debug, signature);
    }
}
module.exports.OCSPCacheMissEvent = $5a644f5c4e0b6c6e$var$OCSPCacheMissEvent;
class $5a644f5c4e0b6c6e$var$OCSPDiskCacheHitEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(signature){
        super("OCSPDiskCacheHitEvent", $ixkFx.EventType.Debug, signature);
    }
}
module.exports.OCSPDiskCacheHitEvent = $5a644f5c4e0b6c6e$var$OCSPDiskCacheHitEvent;
class $5a644f5c4e0b6c6e$var$OCSPCacheUpdateNeededEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(signature){
        super("OCSPCacheUpdateNeededEvent", $ixkFx.EventType.Debug, signature);
    }
}
module.exports.OCSPCacheUpdateNeededEvent = $5a644f5c4e0b6c6e$var$OCSPCacheUpdateNeededEvent;
class $5a644f5c4e0b6c6e$var$OCSPMemoryCacheStoreEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(signature){
        super("OCSPMemoryCacheStoreEvent", $ixkFx.EventType.Debug, signature);
    }
}
module.exports.OCSPMemoryCacheStoreEvent = $5a644f5c4e0b6c6e$var$OCSPMemoryCacheStoreEvent;
class $5a644f5c4e0b6c6e$var$OCSPDiskCacheStoreEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(signature){
        super("OCSPDiskCacheStoreEvent", $ixkFx.EventType.Debug, signature);
    }
}
module.exports.OCSPDiskCacheStoreEvent = $5a644f5c4e0b6c6e$var$OCSPDiskCacheStoreEvent;
class $5a644f5c4e0b6c6e$var$OCSPCacheUpdateCompleteEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(signature){
        super("OCSPCacheUpdateCompleteEvent", $ixkFx.EventType.Debug, signature);
    }
}
module.exports.OCSPCacheUpdateCompleteEvent = $5a644f5c4e0b6c6e$var$OCSPCacheUpdateCompleteEvent;
class $5a644f5c4e0b6c6e$var$OCSPStapleReceivedEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(){
        super("OCSPStapleReceivedEvent", $ixkFx.EventType.Debug, "");
    }
}
module.exports.OCSPStapleReceivedEvent = $5a644f5c4e0b6c6e$var$OCSPStapleReceivedEvent;
class $5a644f5c4e0b6c6e$var$OCSPWSUpgradeStartedEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(serialNumber){
        super("OCSPWSUpgradeStartedEvent", $ixkFx.EventType.Debug, serialNumber);
    }
}
module.exports.OCSPWSUpgradeStartedEvent = $5a644f5c4e0b6c6e$var$OCSPWSUpgradeStartedEvent;
class $5a644f5c4e0b6c6e$var$OCSPCacheEntryExpiredEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(serialNumber, expireTime){
        super("OCSPCacheEntryExpiredEvent", $ixkFx.EventType.Debug, serialNumber);
        this.privExpireTime = expireTime;
    }
}
module.exports.OCSPCacheEntryExpiredEvent = $5a644f5c4e0b6c6e$var$OCSPCacheEntryExpiredEvent;
class $5a644f5c4e0b6c6e$var$OCSPCacheEntryNeedsRefreshEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(serialNumber, startTime, expireTime){
        super("OCSPCacheEntryNeedsRefreshEvent", $ixkFx.EventType.Debug, serialNumber);
        this.privExpireTime = expireTime;
        this.privStartTime = startTime;
    }
}
module.exports.OCSPCacheEntryNeedsRefreshEvent = $5a644f5c4e0b6c6e$var$OCSPCacheEntryNeedsRefreshEvent;
class $5a644f5c4e0b6c6e$var$OCSPCacheHitEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(serialNumber, startTime, expireTime){
        super("OCSPCacheHitEvent", $ixkFx.EventType.Debug, serialNumber);
        this.privExpireTime = expireTime;
        this.privExpireTimeString = new Date(expireTime).toLocaleDateString();
        this.privStartTime = startTime;
        this.privStartTimeString = new Date(startTime).toLocaleTimeString();
    }
}
module.exports.OCSPCacheHitEvent = $5a644f5c4e0b6c6e$var$OCSPCacheHitEvent;
class $5a644f5c4e0b6c6e$var$OCSPVerificationFailedEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(serialNumber, error){
        super("OCSPVerificationFailedEvent", $ixkFx.EventType.Debug, serialNumber);
        this.privError = error;
    }
}
module.exports.OCSPVerificationFailedEvent = $5a644f5c4e0b6c6e$var$OCSPVerificationFailedEvent;
class $5a644f5c4e0b6c6e$var$OCSPCacheFetchErrorEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(serialNumber, error){
        super("OCSPCacheFetchErrorEvent", $ixkFx.EventType.Debug, serialNumber);
        this.privError = error;
    }
}
module.exports.OCSPCacheFetchErrorEvent = $5a644f5c4e0b6c6e$var$OCSPCacheFetchErrorEvent;
class $5a644f5c4e0b6c6e$var$OCSPResponseRetrievedEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(serialNumber){
        super("OCSPResponseRetrievedEvent", $ixkFx.EventType.Debug, serialNumber);
    }
}
module.exports.OCSPResponseRetrievedEvent = $5a644f5c4e0b6c6e$var$OCSPResponseRetrievedEvent;
class $5a644f5c4e0b6c6e$var$OCSPCacheUpdateErrorEvent extends $5a644f5c4e0b6c6e$var$OCSPEvent {
    constructor(serialNumber, error){
        super("OCSPCacheUpdateErrorEvent", $ixkFx.EventType.Debug, serialNumber);
        this.privError = error;
    }
}
module.exports.OCSPCacheUpdateErrorEvent = $5a644f5c4e0b6c6e$var$OCSPCacheUpdateErrorEvent;

});

parcelRegister("fG2zh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackgroundEvent = void 0;

var $3wpON = parcelRequire("3wpON");
class $b69cc538be7174fd$var$BackgroundEvent extends $3wpON.PlatformEvent {
    constructor(error){
        super("BackgroundEvent", $3wpON.EventType.Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
module.exports.BackgroundEvent = $b69cc538be7174fd$var$BackgroundEvent;

});


parcelRegister("bPVwM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeaderNames = void 0;
class $89e114ec53245ba6$var$HeaderNames {
}
module.exports.HeaderNames = $89e114ec53245ba6$var$HeaderNames;
$89e114ec53245ba6$var$HeaderNames.AuthKey = "Ocp-Apim-Subscription-Key";
$89e114ec53245ba6$var$HeaderNames.Authorization = "Authorization";
$89e114ec53245ba6$var$HeaderNames.SpIDAuthKey = "Apim-Subscription-Id";
$89e114ec53245ba6$var$HeaderNames.ConnectionId = "X-ConnectionId";
$89e114ec53245ba6$var$HeaderNames.ContentType = "Content-Type";
$89e114ec53245ba6$var$HeaderNames.CustomCommandsAppId = "X-CommandsAppId";
$89e114ec53245ba6$var$HeaderNames.Path = "Path";
$89e114ec53245ba6$var$HeaderNames.RequestId = "X-RequestId";
$89e114ec53245ba6$var$HeaderNames.RequestStreamId = "X-StreamId";
$89e114ec53245ba6$var$HeaderNames.RequestTimestamp = "X-Timestamp";

});

parcelRegister("9ej08", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthInfo = void 0;
class $6b842913504f5f31$var$AuthInfo {
    constructor(headerName, token){
        this.privHeaderName = headerName;
        this.privToken = token;
    }
    get headerName() {
        return this.privHeaderName;
    }
    get token() {
        return this.privToken;
    }
}
module.exports.AuthInfo = $6b842913504f5f31$var$AuthInfo;

});


parcelRegister("cQDn4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CognitiveTokenAuthentication = void 0;

var $3wpON = parcelRequire("3wpON");

var $9ej08 = parcelRequire("9ej08");

var $bPVwM = parcelRequire("bPVwM");
class $95a8e1ab4844fa95$var$CognitiveTokenAuthentication {
    constructor(fetchCallback, fetchOnExpiryCallback){
        if (!fetchCallback) throw new $3wpON.ArgumentNullError("fetchCallback");
        if (!fetchOnExpiryCallback) throw new $3wpON.ArgumentNullError("fetchOnExpiryCallback");
        this.privFetchCallback = fetchCallback;
        this.privFetchOnExpiryCallback = fetchOnExpiryCallback;
    }
    fetch(authFetchEventId) {
        return this.privFetchCallback(authFetchEventId).then((token)=>new $9ej08.AuthInfo($bPVwM.HeaderNames.Authorization, token === undefined ? undefined : $95a8e1ab4844fa95$var$CognitiveTokenAuthentication.privTokenPrefix + token));
    }
    fetchOnExpiry(authFetchEventId) {
        return this.privFetchOnExpiryCallback(authFetchEventId).then((token)=>new $9ej08.AuthInfo($bPVwM.HeaderNames.Authorization, token === undefined ? undefined : $95a8e1ab4844fa95$var$CognitiveTokenAuthentication.privTokenPrefix + token));
    }
}
module.exports.CognitiveTokenAuthentication = $95a8e1ab4844fa95$var$CognitiveTokenAuthentication;
$95a8e1ab4844fa95$var$CognitiveTokenAuthentication.privTokenPrefix = "Bearer ";

});

parcelRegister("5tpEI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("24Zak", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("21P1w", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $hVlip = parcelRequire("hVlip");

var $lAVhN = parcelRequire("lAVhN");

var $imJeu = parcelRequire("imJeu");

var $bPVwM = parcelRequire("bPVwM");
class $17a340fe4387739a$var$IntentConnectionFactory extends $lAVhN.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint);
        if (!endpoint) {
            const region = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_IntentRegion);
            const hostSuffix = $lAVhN.ConnectionFactoryBase.getHostSuffix(region);
            const host = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".sr.speech" + hostSuffix);
            endpoint = host + "/speech/recognition/interactive/cognitiveservices/v1";
        }
        const queryParams = {
            format: "simple",
            language: config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(config, queryParams, endpoint);
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$bPVwM.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($hVlip.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $gvLMV.WebsocketConnection(endpoint, queryParams, headers, new $imJeu.WebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
    getSpeechRegionFromIntentRegion(intentRegion) {
        switch(intentRegion){
            case "West US":
            case "US West":
            case "westus":
                return "uswest";
            case "West US 2":
            case "US West 2":
            case "westus2":
                return "uswest2";
            case "South Central US":
            case "US South Central":
            case "southcentralus":
                return "ussouthcentral";
            case "West Central US":
            case "US West Central":
            case "westcentralus":
                return "uswestcentral";
            case "East US":
            case "US East":
            case "eastus":
                return "useast";
            case "East US 2":
            case "US East 2":
            case "eastus2":
                return "useast2";
            case "West Europe":
            case "Europe West":
            case "westeurope":
                return "europewest";
            case "North Europe":
            case "Europe North":
            case "northeurope":
                return "europenorth";
            case "Brazil South":
            case "South Brazil":
            case "southbrazil":
                return "brazilsouth";
            case "Australia East":
            case "East Australia":
            case "eastaustralia":
                return "australiaeast";
            case "Southeast Asia":
            case "Asia Southeast":
            case "southeastasia":
                return "asiasoutheast";
            case "East Asia":
            case "Asia East":
            case "eastasia":
                return "asiaeast";
            default:
                return intentRegion;
        }
    }
}
module.exports.IntentConnectionFactory = $17a340fe4387739a$var$IntentConnectionFactory;

});
parcelRegister("gvLMV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $c0549c4d66f13f62$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c0549c4d66f13f62$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $c0549c4d66f13f62$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c0549c4d66f13f62$var$__exportStar((parcelRequire("a8adL")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("1SOPA")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("g7HQn")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("9e5t1")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("hdrov")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("lJrvI")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("ednVg")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("1o04d")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("fU1HM")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("cnQZS")), module.exports);

$c0549c4d66f13f62$var$__exportStar((parcelRequire("cqhfk")), module.exports);

});
parcelRegister("a8adL", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $7602946f8916167a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7602946f8916167a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7602946f8916167a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $7602946f8916167a$var$__createBinding(result, mod, k);
    }
    $7602946f8916167a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleLoggingListener = void 0;

const $7602946f8916167a$var$fs = $7602946f8916167a$var$__importStar((parcelRequire("67wIF")));

var $jq0kE = parcelRequire("jq0kE");

var $56OOs = parcelRequire("56OOs");
class $7602946f8916167a$var$ConsoleLoggingListener {
    constructor(logLevelFilter = $jq0kE.LogLevel.None){
        this.privLogPath = undefined;
        this.privEnableConsoleOutput = true;
        this.privLogLevelFilter = logLevelFilter;
    }
    set logPath(path) {
        $56OOs.Contracts.throwIfNullOrUndefined($7602946f8916167a$var$fs.openSync, "\nFile System access not available");
        this.privLogPath = path;
    }
    set enableConsoleOutput(enableOutput) {
        this.privEnableConsoleOutput = enableOutput;
    }
    onEvent(event) {
        if (event.eventType >= this.privLogLevelFilter) {
            const log = this.toString(event);
            if (!!this.logCallback) this.logCallback(log);
            if (!!this.privLogPath) $7602946f8916167a$var$fs.writeFileSync(this.privLogPath, log + "\n", {
                flag: "a+"
            });
            if (this.privEnableConsoleOutput) switch(event.eventType){
                case $jq0kE.LogLevel.Debug:
                    // eslint-disable-next-line no-console
                    console.debug(log);
                    break;
                case $jq0kE.LogLevel.Info:
                    // eslint-disable-next-line no-console
                    console.info(log);
                    break;
                case $jq0kE.LogLevel.Warning:
                    // eslint-disable-next-line no-console
                    console.warn(log);
                    break;
                case $jq0kE.LogLevel.Error:
                    // eslint-disable-next-line no-console
                    console.error(log);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.log(log);
                    break;
            }
        }
    }
    toString(event) {
        const logFragments = [
            `${event.eventTime}`,
            `${event.name}`
        ];
        const e = event;
        for(const prop in e)if (prop && event.hasOwnProperty(prop) && prop !== "eventTime" && prop !== "eventType" && prop !== "eventId" && prop !== "name" && prop !== "constructor") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const value = e[prop];
            let valueToLog = "<NULL>";
            if (value !== undefined && value !== null) {
                if (typeof value === "number" || typeof value === "string") valueToLog = value.toString();
                else valueToLog = JSON.stringify(value);
            }
            logFragments.push(`${prop}: ${valueToLog}`);
        }
        return logFragments.join(" | ");
    }
}
module.exports.ConsoleLoggingListener = $7602946f8916167a$var$ConsoleLoggingListener;

});
parcelRegister("jq0kE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogLevel = void 0;

var $3wpON = parcelRequire("3wpON");
Object.defineProperty(module.exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return $3wpON.EventType;
    }
});

});

parcelRegister("56OOs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contracts = void 0;
/**
 * @class Contracts
 * @private
 */ class $3b84eda6a673dbe0$var$Contracts {
    static throwIfNullOrUndefined(param, name) {
        if (param === undefined || param === null) throw new Error("throwIfNullOrUndefined:" + name);
    }
    static throwIfNull(param, name) {
        if (param === null) throw new Error("throwIfNull:" + name);
    }
    static throwIfNullOrWhitespace(param, name) {
        $3b84eda6a673dbe0$var$Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).trim().length < 1) throw new Error("throwIfNullOrWhitespace:" + name);
    }
    static throwIfNullOrTooLong(param, name, maxLength) {
        $3b84eda6a673dbe0$var$Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).length > maxLength) throw new Error("throwIfNullOrTooLong:" + name + " (more than " + maxLength.toString() + " characters)");
    }
    static throwIfNullOrTooShort(param, name, minLength) {
        $3b84eda6a673dbe0$var$Contracts.throwIfNullOrUndefined(param, name);
        if (("" + param).length < minLength) throw new Error("throwIfNullOrTooShort:" + name + " (less than " + minLength.toString() + " characters)");
    }
    static throwIfDisposed(isDisposed) {
        if (isDisposed) throw new Error("the object is already disposed");
    }
    static throwIfArrayEmptyOrWhitespace(array, name) {
        $3b84eda6a673dbe0$var$Contracts.throwIfNullOrUndefined(array, name);
        if (array.length === 0) throw new Error("throwIfArrayEmptyOrWhitespace:" + name);
        for (const item of array)$3b84eda6a673dbe0$var$Contracts.throwIfNullOrWhitespace(item, name);
    }
    static throwIfFileDoesNotExist(param, name) {
        $3b84eda6a673dbe0$var$Contracts.throwIfNullOrWhitespace(param, name);
    // TODO check for file existence.
    }
    static throwIfNotUndefined(param, name) {
        if (param !== undefined) throw new Error("throwIfNotUndefined:" + name);
    }
}
module.exports.Contracts = $3b84eda6a673dbe0$var$Contracts;

});


parcelRegister("1SOPA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("g7HQn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MicAudioSource = module.exports.AudioWorkletSourceURLPropertyName = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $d3s41 = parcelRequire("d3s41");
module.exports.AudioWorkletSourceURLPropertyName = "MICROPHONE-WorkletSourceUrl";
class $bbcf4f43dd2bb791$var$MicAudioSource {
    constructor(privRecorder, deviceId, audioSourceId, mediaStream){
        this.privRecorder = privRecorder;
        this.deviceId = deviceId;
        this.privStreams = {};
        this.privOutputChunkSize = $bbcf4f43dd2bb791$var$MicAudioSource.AUDIOFORMAT.avgBytesPerSec / 10;
        this.privId = audioSourceId ? audioSourceId : $3wpON.createNoDashGuid();
        this.privEvents = new $3wpON.EventSource();
        this.privMediaStream = mediaStream || null;
        this.privIsClosing = false;
    }
    get format() {
        return Promise.resolve($bbcf4f43dd2bb791$var$MicAudioSource.AUDIOFORMAT);
    }
    turnOn() {
        if (this.privInitializeDeferral) return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new $3wpON.Deferred();
        try {
            this.createAudioContext();
        } catch (error) {
            if (error instanceof Error) {
                const typedError = error;
                this.privInitializeDeferral.reject(typedError.name + ": " + typedError.message);
            } else this.privInitializeDeferral.reject(error);
            return this.privInitializeDeferral.promise;
        }
        const nav = window.navigator;
        let getUserMedia = // eslint-disable-next-line
        nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;
        if (!!nav.mediaDevices) getUserMedia = (constraints, successCallback, errorCallback)=>{
            nav.mediaDevices.getUserMedia(constraints).then(successCallback).catch(errorCallback);
        };
        if (!getUserMedia) {
            const errorMsg = "Browser does not support getUserMedia.";
            this.privInitializeDeferral.reject(errorMsg);
            this.onEvent(new $3wpON.AudioSourceErrorEvent(errorMsg, "")); // mic initialized error - no streamid at this point
        } else {
            const next = ()=>{
                this.onEvent(new $3wpON.AudioSourceInitializingEvent(this.privId)); // no stream id
                if (this.privMediaStream && this.privMediaStream.active) {
                    this.onEvent(new $3wpON.AudioSourceReadyEvent(this.privId));
                    this.privInitializeDeferral.resolve();
                } else getUserMedia({
                    audio: this.deviceId ? {
                        deviceId: this.deviceId
                    } : true,
                    video: false
                }, (mediaStream)=>{
                    this.privMediaStream = mediaStream;
                    this.onEvent(new $3wpON.AudioSourceReadyEvent(this.privId));
                    this.privInitializeDeferral.resolve();
                }, (error)=>{
                    const errorMsg = `Error occurred during microphone initialization: ${error}`;
                    this.privInitializeDeferral.reject(errorMsg);
                    this.onEvent(new $3wpON.AudioSourceErrorEvent(this.privId, errorMsg));
                });
            };
            if (this.privContext.state === "suspended") // NOTE: On iOS, the Web Audio API requires sounds to be triggered from an explicit user action.
            // https://github.com/WebAudio/web-audio-api/issues/790
            this.privContext.resume().then(next).catch((reason)=>{
                this.privInitializeDeferral.reject(`Failed to initialize audio context: ${reason}`);
            });
            else next();
        }
        return this.privInitializeDeferral.promise;
    }
    id() {
        return this.privId;
    }
    attach(audioNodeId) {
        this.onEvent(new $3wpON.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        return this.listen(audioNodeId).then((stream)=>{
            this.onEvent(new $3wpON.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
            return {
                detach: async ()=>{
                    stream.readEnded();
                    delete this.privStreams[audioNodeId];
                    this.onEvent(new $3wpON.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                    return this.turnOff();
                },
                id: ()=>audioNodeId,
                read: ()=>stream.read()
            };
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new $3wpON.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
        }
    }
    async turnOff() {
        for(const streamId in this.privStreams)if (streamId) {
            const stream = this.privStreams[streamId];
            if (stream) stream.close();
        }
        this.onEvent(new $3wpON.AudioSourceOffEvent(this.privId)); // no stream now
        if (this.privInitializeDeferral) {
            // Correctly handle when browser forces mic off before turnOn() completes
            // eslint-disable-next-line @typescript-eslint/await-thenable
            await this.privInitializeDeferral;
            this.privInitializeDeferral = null;
        }
        await this.destroyAudioContext();
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.getMicrophoneLabel().then((label)=>({
                bitspersample: $bbcf4f43dd2bb791$var$MicAudioSource.AUDIOFORMAT.bitsPerSample,
                channelcount: $bbcf4f43dd2bb791$var$MicAudioSource.AUDIOFORMAT.channels,
                connectivity: $imJeu.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: label,
                samplerate: $bbcf4f43dd2bb791$var$MicAudioSource.AUDIOFORMAT.samplesPerSec,
                type: $imJeu.type.Microphones
            }));
    }
    setProperty(name, value) {
        if (name === module.exports.AudioWorkletSourceURLPropertyName) this.privRecorder.setWorkletUrl(value);
        else throw new Error("Property '" + name + "' is not supported on Microphone.");
    }
    getMicrophoneLabel() {
        const defaultMicrophoneName = "microphone";
        // If we did this already, return the value.
        if (this.privMicrophoneLabel !== undefined) return Promise.resolve(this.privMicrophoneLabel);
        // If the stream isn't currently running, we can't query devices because security.
        if (this.privMediaStream === undefined || !this.privMediaStream.active) return Promise.resolve(defaultMicrophoneName);
        // Setup a default
        this.privMicrophoneLabel = defaultMicrophoneName;
        // Get the id of the device running the audio track.
        const microphoneDeviceId = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        // If the browser doesn't support getting the device ID, set a default and return.
        if (undefined === microphoneDeviceId) return Promise.resolve(this.privMicrophoneLabel);
        const deferred = new $3wpON.Deferred();
        // Enumerate the media devices.
        navigator.mediaDevices.enumerateDevices().then((devices)=>{
            for (const device of devices)if (device.deviceId === microphoneDeviceId) {
                // Found the device
                this.privMicrophoneLabel = device.label;
                break;
            }
            deferred.resolve(this.privMicrophoneLabel);
        }, ()=>deferred.resolve(this.privMicrophoneLabel));
        return deferred.promise;
    }
    async listen(audioNodeId) {
        await this.turnOn();
        const stream = new $3wpON.ChunkedArrayBufferStream(this.privOutputChunkSize, audioNodeId);
        this.privStreams[audioNodeId] = stream;
        try {
            this.privRecorder.record(this.privContext, this.privMediaStream, stream);
        } catch (error) {
            this.onEvent(new $3wpON.AudioStreamNodeErrorEvent(this.privId, audioNodeId, error));
            throw error;
        }
        const result = stream;
        return result;
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $3wpON.Events.instance.onEvent(event);
    }
    createAudioContext() {
        if (!!this.privContext) return;
        this.privContext = $d3s41.AudioStreamFormatImpl.getAudioContext($bbcf4f43dd2bb791$var$MicAudioSource.AUDIOFORMAT.samplesPerSec);
    }
    async destroyAudioContext() {
        if (!this.privContext) return;
        this.privRecorder.releaseMediaResources(this.privContext);
        // This pattern brought to you by a bug in the TypeScript compiler where it
        // confuses the ("close" in this.privContext) with this.privContext always being null as the alternate.
        // https://github.com/Microsoft/TypeScript/issues/11498
        let hasClose = false;
        if ("close" in this.privContext) hasClose = true;
        if (hasClose) {
            if (!this.privIsClosing) {
                // The audio context close may take enough time that the close is called twice
                this.privIsClosing = true;
                await this.privContext.close();
                this.privContext = null;
                this.privIsClosing = false;
            }
        } else if (null !== this.privContext && this.privContext.state === "running") // Suspend actually takes a callback, but analogous to the
        // resume method, it'll be only fired if suspend is called
        // in a direct response to a user action. The later is not always
        // the case, as TurnOff is also called, when we receive an
        // end-of-speech message from the service. So, doing a best effort
        // fire-and-forget here.
        await this.privContext.suspend();
    }
}
module.exports.MicAudioSource = $bbcf4f43dd2bb791$var$MicAudioSource;
$bbcf4f43dd2bb791$var$MicAudioSource.AUDIOFORMAT = $d3s41.AudioStreamFormat.getDefaultInputFormat();

});
parcelRegister("imJeu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $d5ed5e5d8c0c96ec$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d5ed5e5d8c0c96ec$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $d5ed5e5d8c0c96ec$var$__createBinding(exports, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = module.exports.ForceDictationPropertyName = module.exports.ServicePropertiesPropertyName = module.exports.CancellationErrorCodePropertyName = module.exports.OutputFormatPropertyName = void 0;

// Make sure not to export internal modules.
//
$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("2hgcV")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("cQDn4")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("9ej08")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("5tpEI")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("24Zak")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("21P1w")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("02s6V")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("5RXpn")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("es4No")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("bNvq2")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("at0sa")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("8IRrx")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("bUMxs")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("01nRs")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("ixRYc")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("bF6u5")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("6npKJ")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("fsTEg")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("5q35L")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("fLkdD")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("513Bk")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("bkrTl")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("9wjMV")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("4Ifyz")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("4LzST")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("gMYFW")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("7PgT6")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("jM5su")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("h0No0")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("fIBUW")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("8qsM9")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("7DZiw")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("18tcP")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("1LHbr")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("kW06q")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("a5z6q")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("dys7m")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("2b9RH")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("8rWDZ")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("7C08p")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("ek6Kx")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("fq2Pq")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("j5PEd")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("2Cd6W")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("cuN42")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("9Jg7R")), module.exports);

var $ebFzi = parcelRequire("ebFzi");
Object.defineProperty(module.exports, "AvatarSynthesisAdapter", {
    enumerable: true,
    get: function() {
        return $ebFzi.AvatarSynthesisAdapter;
    }
});

var $ilqLB = parcelRequire("ilqLB");
Object.defineProperty(module.exports, "SpeechSynthesisAdapter", {
    enumerable: true,
    get: function() {
        return $ilqLB.SpeechSynthesisAdapter;
    }
});

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("93Adk")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("03DhA")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("6Qyuv")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("aX3O2")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("gBiLO")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("lMc82")), module.exports);

$d5ed5e5d8c0c96ec$var$__exportStar((parcelRequire("8kYhu")), module.exports);
module.exports.OutputFormatPropertyName = "OutputFormat";
module.exports.CancellationErrorCodePropertyName = "CancellationErrorCode";
module.exports.ServicePropertiesPropertyName = "ServiceProperties";
module.exports.ForceDictationPropertyName = "ForceDictation";
module.exports.AutoDetectSourceLanguagesOpenRangeOptionName = "OpenRange";

});
parcelRegister("02s6V", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileConnectionFactory = module.exports.SpeakerRecognitionConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $hVlip = parcelRequire("hVlip");

var $lAVhN = parcelRequire("lAVhN");

var $imJeu = parcelRequire("imJeu");

var $bPVwM = parcelRequire("bPVwM");
class $0075fe34661dac20$var$SpeakerRecognitionConnectionFactoryBase extends $lAVhN.ConnectionFactoryBase {
    create(config, authInfo, endpointPath, connectionId) {
        let endpoint = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint);
        if (!endpoint) {
            const region = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region);
            const hostSuffix = $lAVhN.ConnectionFactoryBase.getHostSuffix(region);
            const host = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, `wss://${region}.spr-frontend.speech${hostSuffix}`);
            const scenario = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_SpeakerIdMode, "TextIndependentIdentification");
            endpoint = `${host}/speaker/ws/${this.scenarioToPath(scenario)}/${endpointPath}`;
        }
        const queryParams = {
            format: "simple",
            language: config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage)
        };
        this.setCommonUrlParams(config, queryParams, endpoint);
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$bPVwM.HeaderNames.ConnectionId] = connectionId;
        headers[$bPVwM.HeaderNames.SpIDAuthKey] = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Key);
        config.parameters.setProperty($hVlip.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $gvLMV.WebsocketConnection(endpoint, queryParams, headers, new $imJeu.WebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
    scenarioToPath(mode) {
        switch(mode){
            case "TextIndependentVerification":
            case "2":
                return "verification/text-independent";
            case "TextDependentVerification":
            case "1":
                return "verification/text-dependent";
            default:
                return "identification/text-independent";
        }
    }
}
class $0075fe34661dac20$var$SpeakerRecognitionConnectionFactory extends $0075fe34661dac20$var$SpeakerRecognitionConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        return super.create(config, authInfo, "recognition", connectionId);
    }
}
module.exports.SpeakerRecognitionConnectionFactory = $0075fe34661dac20$var$SpeakerRecognitionConnectionFactory;
class $0075fe34661dac20$var$VoiceProfileConnectionFactory extends $0075fe34661dac20$var$SpeakerRecognitionConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        return super.create(config, authInfo, "profile", connectionId);
    }
}
module.exports.VoiceProfileConnectionFactory = $0075fe34661dac20$var$VoiceProfileConnectionFactory;

});
parcelRegister("hVlip", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $a5hpj = parcelRequire("a5hpj");
Object.defineProperty(module.exports, "AudioConfig", {
    enumerable: true,
    get: function() {
        return $a5hpj.AudioConfig;
    }
});

var $d3s41 = parcelRequire("d3s41");
Object.defineProperty(module.exports, "AudioStreamFormat", {
    enumerable: true,
    get: function() {
        return $d3s41.AudioStreamFormat;
    }
});
Object.defineProperty(module.exports, "AudioFormatTag", {
    enumerable: true,
    get: function() {
        return $d3s41.AudioFormatTag;
    }
});

var $gfg7l = parcelRequire("gfg7l");
Object.defineProperty(module.exports, "AudioInputStream", {
    enumerable: true,
    get: function() {
        return $gfg7l.AudioInputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioInputStream", {
    enumerable: true,
    get: function() {
        return $gfg7l.PullAudioInputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioInputStream", {
    enumerable: true,
    get: function() {
        return $gfg7l.PushAudioInputStream;
    }
});

var $9QXyd = parcelRequire("9QXyd");
Object.defineProperty(module.exports, "AudioOutputStream", {
    enumerable: true,
    get: function() {
        return $9QXyd.AudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PullAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $9QXyd.PullAudioOutputStream;
    }
});
Object.defineProperty(module.exports, "PushAudioOutputStream", {
    enumerable: true,
    get: function() {
        return $9QXyd.PushAudioOutputStream;
    }
});

var $61VNj = parcelRequire("61VNj");
Object.defineProperty(module.exports, "CancellationReason", {
    enumerable: true,
    get: function() {
        return $61VNj.CancellationReason;
    }
});

var $22mC5 = parcelRequire("22mC5");
Object.defineProperty(module.exports, "PullAudioInputStreamCallback", {
    enumerable: true,
    get: function() {
        return $22mC5.PullAudioInputStreamCallback;
    }
});

var $3fLsh = parcelRequire("3fLsh");
Object.defineProperty(module.exports, "PushAudioOutputStreamCallback", {
    enumerable: true,
    get: function() {
        return $3fLsh.PushAudioOutputStreamCallback;
    }
});

var $kAZw5 = parcelRequire("kAZw5");
Object.defineProperty(module.exports, "KeywordRecognitionModel", {
    enumerable: true,
    get: function() {
        return $kAZw5.KeywordRecognitionModel;
    }
});

var $8LjTB = parcelRequire("8LjTB");
Object.defineProperty(module.exports, "SessionEventArgs", {
    enumerable: true,
    get: function() {
        return $8LjTB.SessionEventArgs;
    }
});

var $lb7dE = parcelRequire("lb7dE");
Object.defineProperty(module.exports, "RecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $lb7dE.RecognitionEventArgs;
    }
});

var $dcae8 = parcelRequire("dcae8");
Object.defineProperty(module.exports, "OutputFormat", {
    enumerable: true,
    get: function() {
        return $dcae8.OutputFormat;
    }
});

var $f7gre = parcelRequire("f7gre");
Object.defineProperty(module.exports, "IntentRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $f7gre.IntentRecognitionEventArgs;
    }
});

var $dzj2U = parcelRequire("dzj2U");
Object.defineProperty(module.exports, "RecognitionResult", {
    enumerable: true,
    get: function() {
        return $dzj2U.RecognitionResult;
    }
});

var $8msMz = parcelRequire("8msMz");
Object.defineProperty(module.exports, "SpeechRecognitionResult", {
    enumerable: true,
    get: function() {
        return $8msMz.SpeechRecognitionResult;
    }
});

var $2fW0F = parcelRequire("2fW0F");
Object.defineProperty(module.exports, "IntentRecognitionResult", {
    enumerable: true,
    get: function() {
        return $2fW0F.IntentRecognitionResult;
    }
});

var $fhft3 = parcelRequire("fhft3");
Object.defineProperty(module.exports, "LanguageUnderstandingModel", {
    enumerable: true,
    get: function() {
        return $fhft3.LanguageUnderstandingModel;
    }
});

var $lw8yB = parcelRequire("lw8yB");
Object.defineProperty(module.exports, "SpeechRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $lw8yB.SpeechRecognitionEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriptionEventArgs", {
    enumerable: true,
    get: function() {
        return $lw8yB.ConversationTranscriptionEventArgs;
    }
});
Object.defineProperty(module.exports, "MeetingTranscriptionEventArgs", {
    enumerable: true,
    get: function() {
        return $lw8yB.MeetingTranscriptionEventArgs;
    }
});

var $8lDRn = parcelRequire("8lDRn");
Object.defineProperty(module.exports, "SpeechRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $8lDRn.SpeechRecognitionCanceledEventArgs;
    }
});

var $8QD8u = parcelRequire("8QD8u");
Object.defineProperty(module.exports, "TranslationRecognitionEventArgs", {
    enumerable: true,
    get: function() {
        return $8QD8u.TranslationRecognitionEventArgs;
    }
});

var $cDUUT = parcelRequire("cDUUT");
Object.defineProperty(module.exports, "TranslationSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $cDUUT.TranslationSynthesisEventArgs;
    }
});

var $5puUG = parcelRequire("5puUG");
Object.defineProperty(module.exports, "TranslationRecognitionResult", {
    enumerable: true,
    get: function() {
        return $5puUG.TranslationRecognitionResult;
    }
});

var $2PGZh = parcelRequire("2PGZh");
Object.defineProperty(module.exports, "TranslationSynthesisResult", {
    enumerable: true,
    get: function() {
        return $2PGZh.TranslationSynthesisResult;
    }
});

var $kaYEN = parcelRequire("kaYEN");
Object.defineProperty(module.exports, "ResultReason", {
    enumerable: true,
    get: function() {
        return $kaYEN.ResultReason;
    }
});

var $5F3oF = parcelRequire("5F3oF");
Object.defineProperty(module.exports, "SpeechConfig", {
    enumerable: true,
    get: function() {
        return $5F3oF.SpeechConfig;
    }
});
Object.defineProperty(module.exports, "SpeechConfigImpl", {
    enumerable: true,
    get: function() {
        return $5F3oF.SpeechConfigImpl;
    }
});

var $5EyVz = parcelRequire("5EyVz");
Object.defineProperty(module.exports, "SpeechTranslationConfig", {
    enumerable: true,
    get: function() {
        return $5EyVz.SpeechTranslationConfig;
    }
});
Object.defineProperty(module.exports, "SpeechTranslationConfigImpl", {
    enumerable: true,
    get: function() {
        return $5EyVz.SpeechTranslationConfigImpl;
    }
});

var $bNuGp = parcelRequire("bNuGp");
Object.defineProperty(module.exports, "PropertyCollection", {
    enumerable: true,
    get: function() {
        return $bNuGp.PropertyCollection;
    }
});

var $feDHl = parcelRequire("feDHl");
Object.defineProperty(module.exports, "PropertyId", {
    enumerable: true,
    get: function() {
        return $feDHl.PropertyId;
    }
});

var $kibP0 = parcelRequire("kibP0");
Object.defineProperty(module.exports, "Recognizer", {
    enumerable: true,
    get: function() {
        return $kibP0.Recognizer;
    }
});

var $9DPT6 = parcelRequire("9DPT6");
Object.defineProperty(module.exports, "SpeechRecognizer", {
    enumerable: true,
    get: function() {
        return $9DPT6.SpeechRecognizer;
    }
});

var $dbgTD = parcelRequire("dbgTD");
Object.defineProperty(module.exports, "IntentRecognizer", {
    enumerable: true,
    get: function() {
        return $dbgTD.IntentRecognizer;
    }
});

var $c3AkX = parcelRequire("c3AkX");
Object.defineProperty(module.exports, "VoiceProfileType", {
    enumerable: true,
    get: function() {
        return $c3AkX.VoiceProfileType;
    }
});

var $1XDDB = parcelRequire("1XDDB");
Object.defineProperty(module.exports, "TranslationRecognizer", {
    enumerable: true,
    get: function() {
        return $1XDDB.TranslationRecognizer;
    }
});

var $Lxqat = parcelRequire("Lxqat");
Object.defineProperty(module.exports, "Translations", {
    enumerable: true,
    get: function() {
        return $Lxqat.Translations;
    }
});

var $hX5Dh = parcelRequire("hX5Dh");
Object.defineProperty(module.exports, "NoMatchReason", {
    enumerable: true,
    get: function() {
        return $hX5Dh.NoMatchReason;
    }
});

var $484RK = parcelRequire("484RK");
Object.defineProperty(module.exports, "NoMatchDetails", {
    enumerable: true,
    get: function() {
        return $484RK.NoMatchDetails;
    }
});

var $1m3VG = parcelRequire("1m3VG");
Object.defineProperty(module.exports, "TranslationRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $1m3VG.TranslationRecognitionCanceledEventArgs;
    }
});

var $96YYT = parcelRequire("96YYT");
Object.defineProperty(module.exports, "IntentRecognitionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $96YYT.IntentRecognitionCanceledEventArgs;
    }
});

var $3RqHo = parcelRequire("3RqHo");
Object.defineProperty(module.exports, "CancellationDetailsBase", {
    enumerable: true,
    get: function() {
        return $3RqHo.CancellationDetailsBase;
    }
});

var $csUhv = parcelRequire("csUhv");
Object.defineProperty(module.exports, "CancellationDetails", {
    enumerable: true,
    get: function() {
        return $csUhv.CancellationDetails;
    }
});

var $4LpiT = parcelRequire("4LpiT");
Object.defineProperty(module.exports, "CancellationErrorCode", {
    enumerable: true,
    get: function() {
        return $4LpiT.CancellationErrorCode;
    }
});

var $jqMnK = parcelRequire("jqMnK");
Object.defineProperty(module.exports, "ConnectionEventArgs", {
    enumerable: true,
    get: function() {
        return $jqMnK.ConnectionEventArgs;
    }
});

var $7j8bo = parcelRequire("7j8bo");
Object.defineProperty(module.exports, "ServiceEventArgs", {
    enumerable: true,
    get: function() {
        return $7j8bo.ServiceEventArgs;
    }
});

var $iDyMW = parcelRequire("iDyMW");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function() {
        return $iDyMW.Connection;
    }
});

var $2mEF6 = parcelRequire("2mEF6");
Object.defineProperty(module.exports, "PhraseListGrammar", {
    enumerable: true,
    get: function() {
        return $2mEF6.PhraseListGrammar;
    }
});

var $atIoA = parcelRequire("atIoA");
Object.defineProperty(module.exports, "DialogServiceConfig", {
    enumerable: true,
    get: function() {
        return $atIoA.DialogServiceConfig;
    }
});

var $8JVb4 = parcelRequire("8JVb4");
Object.defineProperty(module.exports, "BotFrameworkConfig", {
    enumerable: true,
    get: function() {
        return $8JVb4.BotFrameworkConfig;
    }
});

var $7tZol = parcelRequire("7tZol");
Object.defineProperty(module.exports, "CustomCommandsConfig", {
    enumerable: true,
    get: function() {
        return $7tZol.CustomCommandsConfig;
    }
});

var $leOQ2 = parcelRequire("leOQ2");
Object.defineProperty(module.exports, "DialogServiceConnector", {
    enumerable: true,
    get: function() {
        return $leOQ2.DialogServiceConnector;
    }
});

var $1tS1M = parcelRequire("1tS1M");
Object.defineProperty(module.exports, "ActivityReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $1tS1M.ActivityReceivedEventArgs;
    }
});

var $5jY75 = parcelRequire("5jY75");
Object.defineProperty(module.exports, "TurnStatusReceivedEventArgs", {
    enumerable: true,
    get: function() {
        return $5jY75.TurnStatusReceivedEventArgs;
    }
});

var $3nVAY = parcelRequire("3nVAY");
Object.defineProperty(module.exports, "ServicePropertyChannel", {
    enumerable: true,
    get: function() {
        return $3nVAY.ServicePropertyChannel;
    }
});

var $50bUf = parcelRequire("50bUf");
Object.defineProperty(module.exports, "ProfanityOption", {
    enumerable: true,
    get: function() {
        return $50bUf.ProfanityOption;
    }
});

var $4aLB9 = parcelRequire("4aLB9");
Object.defineProperty(module.exports, "BaseAudioPlayer", {
    enumerable: true,
    get: function() {
        return $4aLB9.BaseAudioPlayer;
    }
});

var $2V778 = parcelRequire("2V778");
Object.defineProperty(module.exports, "ConnectionMessageEventArgs", {
    enumerable: true,
    get: function() {
        return $2V778.ConnectionMessageEventArgs;
    }
});

var $dT9Ew = parcelRequire("dT9Ew");
Object.defineProperty(module.exports, "ConnectionMessage", {
    enumerable: true,
    get: function() {
        return $dT9Ew.ConnectionMessage;
    }
});

var $bA1R2 = parcelRequire("bA1R2");
Object.defineProperty(module.exports, "VoiceProfile", {
    enumerable: true,
    get: function() {
        return $bA1R2.VoiceProfile;
    }
});

var $iF0Jc = parcelRequire("iF0Jc");
Object.defineProperty(module.exports, "VoiceProfileEnrollmentResult", {
    enumerable: true,
    get: function() {
        return $iF0Jc.VoiceProfileEnrollmentResult;
    }
});
Object.defineProperty(module.exports, "VoiceProfileEnrollmentCancellationDetails", {
    enumerable: true,
    get: function() {
        return $iF0Jc.VoiceProfileEnrollmentCancellationDetails;
    }
});

var $3gSwY = parcelRequire("3gSwY");
Object.defineProperty(module.exports, "VoiceProfileResult", {
    enumerable: true,
    get: function() {
        return $3gSwY.VoiceProfileResult;
    }
});
Object.defineProperty(module.exports, "VoiceProfileCancellationDetails", {
    enumerable: true,
    get: function() {
        return $3gSwY.VoiceProfileCancellationDetails;
    }
});

var $caGV8 = parcelRequire("caGV8");
Object.defineProperty(module.exports, "VoiceProfilePhraseResult", {
    enumerable: true,
    get: function() {
        return $caGV8.VoiceProfilePhraseResult;
    }
});

var $4TMTZ = parcelRequire("4TMTZ");
Object.defineProperty(module.exports, "VoiceProfileClient", {
    enumerable: true,
    get: function() {
        return $4TMTZ.VoiceProfileClient;
    }
});

var $4dtL3 = parcelRequire("4dtL3");
Object.defineProperty(module.exports, "SpeakerRecognizer", {
    enumerable: true,
    get: function() {
        return $4dtL3.SpeakerRecognizer;
    }
});

var $7Jd62 = parcelRequire("7Jd62");
Object.defineProperty(module.exports, "SpeakerIdentificationModel", {
    enumerable: true,
    get: function() {
        return $7Jd62.SpeakerIdentificationModel;
    }
});

var $7b6vs = parcelRequire("7b6vs");
Object.defineProperty(module.exports, "SpeakerVerificationModel", {
    enumerable: true,
    get: function() {
        return $7b6vs.SpeakerVerificationModel;
    }
});

var $axnB6 = parcelRequire("axnB6");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $axnB6.AutoDetectSourceLanguageConfig;
    }
});

var $gslJ7 = parcelRequire("gslJ7");
Object.defineProperty(module.exports, "AutoDetectSourceLanguageResult", {
    enumerable: true,
    get: function() {
        return $gslJ7.AutoDetectSourceLanguageResult;
    }
});

var $gDezv = parcelRequire("gDezv");
Object.defineProperty(module.exports, "SourceLanguageConfig", {
    enumerable: true,
    get: function() {
        return $gDezv.SourceLanguageConfig;
    }
});

var $86Knn = parcelRequire("86Knn");
Object.defineProperty(module.exports, "SpeakerRecognitionResult", {
    enumerable: true,
    get: function() {
        return $86Knn.SpeakerRecognitionResult;
    }
});
Object.defineProperty(module.exports, "SpeakerRecognitionResultType", {
    enumerable: true,
    get: function() {
        return $86Knn.SpeakerRecognitionResultType;
    }
});
Object.defineProperty(module.exports, "SpeakerRecognitionCancellationDetails", {
    enumerable: true,
    get: function() {
        return $86Knn.SpeakerRecognitionCancellationDetails;
    }
});

var $8hU6U = parcelRequire("8hU6U");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $8hU6U.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $8hU6U.ConversationExpirationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $8hU6U.ConversationParticipantsChangedEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $8hU6U.ConversationTranslationCanceledEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $8hU6U.ConversationTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $8hU6U.ConversationTranslationResult;
    }
});
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $8hU6U.ConversationTranslator;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $8hU6U.ConversationTranscriber;
    }
});
Object.defineProperty(module.exports, "ConversationTranscriptionResult", {
    enumerable: true,
    get: function() {
        return $8hU6U.ConversationTranscriptionResult;
    }
});
Object.defineProperty(module.exports, "Meeting", {
    enumerable: true,
    get: function() {
        return $8hU6U.Meeting;
    }
});
Object.defineProperty(module.exports, "MeetingTranscriber", {
    enumerable: true,
    get: function() {
        return $8hU6U.MeetingTranscriber;
    }
});
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $8hU6U.Participant;
    }
});
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $8hU6U.ParticipantChangedReason;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $8hU6U.User;
    }
});

var $gOb2m = parcelRequire("gOb2m");
Object.defineProperty(module.exports, "Synthesizer", {
    enumerable: true,
    get: function() {
        return $gOb2m.Synthesizer;
    }
});

var $YNmLN = parcelRequire("YNmLN");
Object.defineProperty(module.exports, "SpeechSynthesisOutputFormat", {
    enumerable: true,
    get: function() {
        return $YNmLN.SpeechSynthesisOutputFormat;
    }
});

var $6XrDK = parcelRequire("6XrDK");
Object.defineProperty(module.exports, "SpeechSynthesizer", {
    enumerable: true,
    get: function() {
        return $6XrDK.SpeechSynthesizer;
    }
});

var $45udZ = parcelRequire("45udZ");
Object.defineProperty(module.exports, "SynthesisResult", {
    enumerable: true,
    get: function() {
        return $45udZ.SynthesisResult;
    }
});

var $6u1NO = parcelRequire("6u1NO");
Object.defineProperty(module.exports, "SpeechSynthesisResult", {
    enumerable: true,
    get: function() {
        return $6u1NO.SpeechSynthesisResult;
    }
});

var $8QCaW = parcelRequire("8QCaW");
Object.defineProperty(module.exports, "SpeechSynthesisEventArgs", {
    enumerable: true,
    get: function() {
        return $8QCaW.SpeechSynthesisEventArgs;
    }
});

var $8xaKx = parcelRequire("8xaKx");
Object.defineProperty(module.exports, "SpeechSynthesisWordBoundaryEventArgs", {
    enumerable: true,
    get: function() {
        return $8xaKx.SpeechSynthesisWordBoundaryEventArgs;
    }
});

var $3MWBI = parcelRequire("3MWBI");
Object.defineProperty(module.exports, "SpeechSynthesisBookmarkEventArgs", {
    enumerable: true,
    get: function() {
        return $3MWBI.SpeechSynthesisBookmarkEventArgs;
    }
});

var $d4ICM = parcelRequire("d4ICM");
Object.defineProperty(module.exports, "SpeechSynthesisVisemeEventArgs", {
    enumerable: true,
    get: function() {
        return $d4ICM.SpeechSynthesisVisemeEventArgs;
    }
});

var $i8rup = parcelRequire("i8rup");
Object.defineProperty(module.exports, "SpeechSynthesisBoundaryType", {
    enumerable: true,
    get: function() {
        return $i8rup.SpeechSynthesisBoundaryType;
    }
});

var $d9PZL = parcelRequire("d9PZL");
Object.defineProperty(module.exports, "SynthesisVoicesResult", {
    enumerable: true,
    get: function() {
        return $d9PZL.SynthesisVoicesResult;
    }
});

var $8xKFP = parcelRequire("8xKFP");
Object.defineProperty(module.exports, "VoiceInfo", {
    enumerable: true,
    get: function() {
        return $8xKFP.VoiceInfo;
    }
});

var $cHtxA = parcelRequire("cHtxA");
Object.defineProperty(module.exports, "SpeakerAudioDestination", {
    enumerable: true,
    get: function() {
        return $cHtxA.SpeakerAudioDestination;
    }
});

var $4QJl0 = parcelRequire("4QJl0");
Object.defineProperty(module.exports, "ConversationTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $4QJl0.ConversationTranscriptionCanceledEventArgs;
    }
});

var $lsy1t = parcelRequire("lsy1t");
Object.defineProperty(module.exports, "MeetingTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $lsy1t.MeetingTranscriptionCanceledEventArgs;
    }
});

var $1WcB6 = parcelRequire("1WcB6");
Object.defineProperty(module.exports, "PronunciationAssessmentGradingSystem", {
    enumerable: true,
    get: function() {
        return $1WcB6.PronunciationAssessmentGradingSystem;
    }
});

var $jKHVl = parcelRequire("jKHVl");
Object.defineProperty(module.exports, "PronunciationAssessmentGranularity", {
    enumerable: true,
    get: function() {
        return $jKHVl.PronunciationAssessmentGranularity;
    }
});

var $gbCaE = parcelRequire("gbCaE");
Object.defineProperty(module.exports, "PronunciationAssessmentConfig", {
    enumerable: true,
    get: function() {
        return $gbCaE.PronunciationAssessmentConfig;
    }
});

var $htB7x = parcelRequire("htB7x");
Object.defineProperty(module.exports, "PronunciationAssessmentResult", {
    enumerable: true,
    get: function() {
        return $htB7x.PronunciationAssessmentResult;
    }
});

var $ehgcV = parcelRequire("ehgcV");
Object.defineProperty(module.exports, "LanguageIdMode", {
    enumerable: true,
    get: function() {
        return $ehgcV.LanguageIdMode;
    }
});

var $bzKTc = parcelRequire("bzKTc");
Object.defineProperty(module.exports, "AvatarConfig", {
    enumerable: true,
    get: function() {
        return $bzKTc.AvatarConfig;
    }
});

var $4dbGQ = parcelRequire("4dbGQ");
Object.defineProperty(module.exports, "AvatarEventArgs", {
    enumerable: true,
    get: function() {
        return $4dbGQ.AvatarEventArgs;
    }
});

var $1zhvp = parcelRequire("1zhvp");
Object.defineProperty(module.exports, "AvatarSynthesizer", {
    enumerable: true,
    get: function() {
        return $1zhvp.AvatarSynthesizer;
    }
});

var $6winM = parcelRequire("6winM");
Object.defineProperty(module.exports, "AvatarVideoFormat", {
    enumerable: true,
    get: function() {
        return $6winM.AvatarVideoFormat;
    }
});
Object.defineProperty(module.exports, "Coordinate", {
    enumerable: true,
    get: function() {
        return $6winM.Coordinate;
    }
});

var $cUVMM = parcelRequire("cUVMM");
Object.defineProperty(module.exports, "AvatarWebRTCConnectionResult", {
    enumerable: true,
    get: function() {
        return $cUVMM.AvatarWebRTCConnectionResult;
    }
});

var $lfuQq = parcelRequire("lfuQq");
Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return $lfuQq.Diagnostics;
    }
});

var $jq0kE = parcelRequire("jq0kE");
Object.defineProperty(module.exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return $jq0kE.LogLevel;
    }
});

});
parcelRegister("a5hpj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputConfigImpl = module.exports.AudioConfigImpl = module.exports.AudioConfig = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $ejNtg = parcelRequire("ejNtg");

var $gfg7l = parcelRequire("gfg7l");

var $9QXyd = parcelRequire("9QXyd");
/**
 * Represents audio input configuration used for specifying what type of input to use (microphone, file, stream).
 * @class AudioConfig
 * Updated in version 1.11.0
 */ class $7577dfbbb2e3bc1e$var$AudioConfig {
    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromDefaultMicrophoneInput() {
        const pcmRecorder = new $gvLMV.PcmRecorder(true);
        return new $7577dfbbb2e3bc1e$var$AudioConfigImpl(new $gvLMV.MicAudioSource(pcmRecorder));
    }
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     * Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromMicrophoneInput(deviceId) {
        const pcmRecorder = new $gvLMV.PcmRecorder(true);
        return new $7577dfbbb2e3bc1e$var$AudioConfigImpl(new $gvLMV.MicAudioSource(pcmRecorder, deviceId));
    }
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromWavFileInput(file, name = "unnamedBuffer.wav") {
        return new $7577dfbbb2e3bc1e$var$AudioConfigImpl(new $gvLMV.FileAudioSource(file, name));
    }
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
     * stream. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */ static fromStreamInput(audioStream) {
        if (audioStream instanceof $hVlip.PullAudioInputStreamCallback) return new $7577dfbbb2e3bc1e$var$AudioConfigImpl(new $gfg7l.PullAudioInputStreamImpl(audioStream));
        if (audioStream instanceof $hVlip.AudioInputStream) return new $7577dfbbb2e3bc1e$var$AudioConfigImpl(audioStream);
        if (typeof MediaStream !== "undefined" && audioStream instanceof MediaStream) {
            const pcmRecorder = new $gvLMV.PcmRecorder(false);
            return new $7577dfbbb2e3bc1e$var$AudioConfigImpl(new $gvLMV.MicAudioSource(pcmRecorder, null, null, audioStream));
        }
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromDefaultSpeakerOutput() {
        return new $7577dfbbb2e3bc1e$var$AudioOutputConfigImpl(new $hVlip.SpeakerAudioDestination());
    }
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */ static fromSpeakerOutput(player) {
        if (player === undefined) return $7577dfbbb2e3bc1e$var$AudioConfig.fromDefaultSpeakerOutput();
        if (player instanceof $hVlip.SpeakerAudioDestination) return new $7577dfbbb2e3bc1e$var$AudioOutputConfigImpl(player);
        throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromAudioFileOutput(filename) {
        return new $7577dfbbb2e3bc1e$var$AudioOutputConfigImpl(new $ejNtg.AudioFileWriter(filename));
    }
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     * stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */ static fromStreamOutput(audioStream) {
        if (audioStream instanceof $hVlip.PushAudioOutputStreamCallback) return new $7577dfbbb2e3bc1e$var$AudioOutputConfigImpl(new $9QXyd.PushAudioOutputStreamImpl(audioStream));
        if (audioStream instanceof $hVlip.PushAudioOutputStream) return new $7577dfbbb2e3bc1e$var$AudioOutputConfigImpl(audioStream);
        if (audioStream instanceof $hVlip.PullAudioOutputStream) return new $7577dfbbb2e3bc1e$var$AudioOutputConfigImpl(audioStream);
        throw new Error("Not Supported Type");
    }
}
module.exports.AudioConfig = $7577dfbbb2e3bc1e$var$AudioConfig;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class AudioConfigImpl
 */ class $7577dfbbb2e3bc1e$var$AudioConfigImpl extends $7577dfbbb2e3bc1e$var$AudioConfig {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioSource} source - An audio source.
     */ constructor(source){
        super();
        this.privSource = source;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privSource.format;
    }
    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        this.privSource.turnOff().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
    }
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */ id() {
        return this.privSource.id();
    }
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOn() {
        return this.privSource.turnOn();
    }
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */ attach(audioNodeId) {
        return this.privSource.attach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */ detach(audioNodeId) {
        return this.privSource.detach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */ turnOff() {
        return this.privSource.turnOff();
    }
    /**
     * @member AudioConfigImpl.prototype.events
     * @function
     * @public
     * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
     */ get events() {
        return this.privSource.events;
    }
    setProperty(name, value) {
        $56OOs.Contracts.throwIfNull(value, "value");
        if (undefined !== this.privSource.setProperty) this.privSource.setProperty(name, value);
        else throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(name, def) {
        if (undefined !== this.privSource.getProperty) return this.privSource.getProperty(name, def);
        else throw new Error("This AudioConfig instance does not support getting properties.");
        return def;
    }
    get deviceInfo() {
        return this.privSource.deviceInfo;
    }
}
module.exports.AudioConfigImpl = $7577dfbbb2e3bc1e$var$AudioConfigImpl;
class $7577dfbbb2e3bc1e$var$AudioOutputConfigImpl extends $7577dfbbb2e3bc1e$var$AudioConfig {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioDestination} destination - An audio destination.
     */ constructor(destination){
        super();
        this.privDestination = destination;
    }
    set format(format) {
        this.privDestination.format = format;
    }
    write(buffer) {
        this.privDestination.write(buffer);
    }
    close() {
        this.privDestination.close();
    }
    id() {
        return this.privDestination.id();
    }
    setProperty() {
        throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty() {
        throw new Error("This AudioConfig instance does not support getting properties.");
    }
}
module.exports.AudioOutputConfigImpl = $7577dfbbb2e3bc1e$var$AudioOutputConfigImpl;

});
parcelRegister("ejNtg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a6c936f2a8f7bf49$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a6c936f2a8f7bf49$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a6c936f2a8f7bf49$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $a6c936f2a8f7bf49$var$__createBinding(result, mod, k);
    }
    $a6c936f2a8f7bf49$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioFileWriter = void 0;

const $a6c936f2a8f7bf49$var$fs = $a6c936f2a8f7bf49$var$__importStar((parcelRequire("67wIF")));

var $56OOs = parcelRequire("56OOs");
class $a6c936f2a8f7bf49$var$AudioFileWriter {
    constructor(filename){
        $56OOs.Contracts.throwIfNullOrUndefined($a6c936f2a8f7bf49$var$fs.openSync, "\nFile System access not available, please use Push or PullAudioOutputStream");
        this.privFd = $a6c936f2a8f7bf49$var$fs.openSync(filename, "w");
    }
    set format(format) {
        $56OOs.Contracts.throwIfNotUndefined(this.privAudioFormat, "format is already set");
        this.privAudioFormat = format;
        let headerOffset = 0;
        if (this.privAudioFormat.hasHeader) headerOffset = this.privAudioFormat.header.byteLength;
        if (this.privFd !== undefined) this.privWriteStream = $a6c936f2a8f7bf49$var$fs.createWriteStream("", {
            fd: this.privFd,
            start: headerOffset,
            autoClose: false
        });
    }
    write(buffer) {
        $56OOs.Contracts.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing.");
        if (this.privWriteStream !== undefined) this.privWriteStream.write(new Uint8Array(buffer.slice(0)));
    }
    close() {
        if (this.privFd !== undefined) {
            this.privWriteStream.on("finish", ()=>{
                if (this.privAudioFormat.hasHeader) {
                    this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten);
                    $a6c936f2a8f7bf49$var$fs.writeSync(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0);
                }
                $a6c936f2a8f7bf49$var$fs.closeSync(this.privFd);
                this.privFd = undefined;
            });
            this.privWriteStream.end();
        }
    }
    id() {
        return this.privId;
    }
}
module.exports.AudioFileWriter = $a6c936f2a8f7bf49$var$AudioFileWriter;

});

parcelRegister("gfg7l", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $bd3a8ca6d19fdee6$require$Buffer = $cBXue.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamImpl = module.exports.PullAudioInputStream = module.exports.PushAudioInputStreamImpl = module.exports.PushAudioInputStream = module.exports.AudioInputStream = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $lDeiB = parcelRequire("lDeiB");

var $hVlip = parcelRequire("hVlip");

var $d3s41 = parcelRequire("d3s41");
/**
 * Represents audio input stream used for custom audio input configurations.
 * @class AudioInputStream
 */ class $bd3a8ca6d19fdee6$var$AudioInputStream {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member AudioInputStream.createPushStream
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The audio input stream being created.
     */ static createPushStream(format) {
        return $bd3a8ca6d19fdee6$var$PushAudioInputStream.create(format);
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     * PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     * the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */ static createPullStream(callback, format) {
        return $bd3a8ca6d19fdee6$var$PullAudioInputStream.create(callback, format);
    // throw new Error("Oops");
    }
}
module.exports.AudioInputStream = $bd3a8ca6d19fdee6$var$AudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @class PushAudioInputStream
 */ class $bd3a8ca6d19fdee6$var$PushAudioInputStream extends $bd3a8ca6d19fdee6$var$AudioInputStream {
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     * push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */ static create(format) {
        return new $bd3a8ca6d19fdee6$var$PushAudioInputStreamImpl(format);
    }
}
module.exports.PushAudioInputStream = $bd3a8ca6d19fdee6$var$PushAudioInputStream;
/**
 * Represents memory backed push audio input stream used for custom audio input configurations.
 * @private
 * @class PushAudioInputStreamImpl
 */ class $bd3a8ca6d19fdee6$var$PushAudioInputStreamImpl extends $bd3a8ca6d19fdee6$var$PushAudioInputStream {
    /**
     * Creates and initalizes an instance with the given values.
     * @constructor
     * @param {AudioStreamFormat} format - The audio stream format.
     */ constructor(format){
        super();
        if (format === undefined) this.privFormat = $d3s41.AudioStreamFormatImpl.getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new $3wpON.EventSource();
        this.privId = $lDeiB.createNoDashGuid();
        this.privStream = new $3wpON.ChunkedArrayBufferStream(this.privFormat.avgBytesPerSec / 10);
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $3wpON.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $3wpON.AudioSourceReadyEvent(this.privId));
        return;
    }
    async attach(audioNodeId) {
        this.onEvent(new $3wpON.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        await this.turnOn();
        const stream = this.privStream;
        this.onEvent(new $3wpON.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
        return {
            detach: async ()=>{
                this.onEvent(new $3wpON.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                return this.turnOff();
            },
            id: ()=>audioNodeId,
            read: ()=>stream.read()
        };
    }
    detach(audioNodeId) {
        this.onEvent(new $3wpON.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $imJeu.connectivity.Unknown,
            manufacturer: "Speech SDK",
            model: "PushStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $imJeu.type.Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $3wpON.Events.instance.onEvent(event);
    }
    toBuffer(arrayBuffer) {
        const buf = $bd3a8ca6d19fdee6$require$Buffer.alloc(arrayBuffer.byteLength);
        const view = new Uint8Array(arrayBuffer);
        for(let i = 0; i < buf.length; ++i)buf[i] = view[i];
        return buf;
    }
}
module.exports.PushAudioInputStreamImpl = $bd3a8ca6d19fdee6$var$PushAudioInputStreamImpl;
/*
 * Represents audio input stream used for custom audio input configurations.
 * @class PullAudioInputStream
 */ class $bd3a8ca6d19fdee6$var$PullAudioInputStream extends $bd3a8ca6d19fdee6$var$AudioInputStream {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @member PullAudioInputStream.create
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The push audio input stream being created.
     */ static create(callback, format) {
        return new $bd3a8ca6d19fdee6$var$PullAudioInputStreamImpl(callback, format);
    }
}
module.exports.PullAudioInputStream = $bd3a8ca6d19fdee6$var$PullAudioInputStream;
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class PullAudioInputStreamImpl
 */ class $bd3a8ca6d19fdee6$var$PullAudioInputStreamImpl extends $bd3a8ca6d19fdee6$var$PullAudioInputStream {
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @constructor
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     */ constructor(callback, format){
        super();
        if (undefined === format) this.privFormat = $hVlip.AudioStreamFormat.getDefaultInputFormat();
        else this.privFormat = format;
        this.privEvents = new $3wpON.EventSource();
        this.privId = $lDeiB.createNoDashGuid();
        this.privCallback = callback;
        this.privIsClosed = false;
        this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
    /**
     * Format information for the audio
     */ get format() {
        return Promise.resolve(this.privFormat);
    }
    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privIsClosed = true;
        this.privCallback.close();
    }
    id() {
        return this.privId;
    }
    turnOn() {
        this.onEvent(new $3wpON.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $3wpON.AudioSourceReadyEvent(this.privId));
        return;
    }
    async attach(audioNodeId) {
        this.onEvent(new $3wpON.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        await this.turnOn();
        this.onEvent(new $3wpON.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
        return {
            detach: ()=>{
                this.privCallback.close();
                this.onEvent(new $3wpON.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                return this.turnOff();
            },
            id: ()=>audioNodeId,
            read: ()=>{
                let totalBytes = 0;
                let transmitBuff;
                // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
                while(totalBytes < this.privBufferSize){
                    // Sizing the read buffer to the delta between the perfect size and what's left means we won't ever get too much
                    // data back.
                    const readBuff = new ArrayBuffer(this.privBufferSize - totalBytes);
                    const pulledBytes = this.privCallback.read(readBuff);
                    // If there is no return buffer yet defined, set the return buffer to the that was just populated.
                    // This was, if we have enough data there's no copy penalty, but if we don't we have a buffer that's the
                    // preferred size allocated.
                    if (undefined === transmitBuff) transmitBuff = readBuff;
                    else {
                        // Not the first bite at the apple, so fill the return buffer with the data we got back.
                        const intView = new Int8Array(transmitBuff);
                        intView.set(new Int8Array(readBuff), totalBytes);
                    }
                    // If there are no bytes to read, just break out and be done.
                    if (0 === pulledBytes) break;
                    totalBytes += pulledBytes;
                }
                return Promise.resolve({
                    buffer: transmitBuff.slice(0, totalBytes),
                    isEnd: this.privIsClosed || totalBytes === 0,
                    timeReceived: Date.now()
                });
            }
        };
    }
    detach(audioNodeId) {
        this.onEvent(new $3wpON.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
    }
    turnOff() {
        return;
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return Promise.resolve({
            bitspersample: this.privFormat.bitsPerSample,
            channelcount: this.privFormat.channels,
            connectivity: $imJeu.connectivity.Unknown,
            manufacturer: "Speech SDK",
            model: "PullStream",
            samplerate: this.privFormat.samplesPerSec,
            type: $imJeu.type.Stream
        });
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $3wpON.Events.instance.onEvent(event);
    }
}
module.exports.PullAudioInputStreamImpl = $bd3a8ca6d19fdee6$var$PullAudioInputStreamImpl;

});
parcelRegister("d3s41", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioStreamFormatImpl = module.exports.AudioStreamFormat = module.exports.AudioFormatTag = void 0;
// eslint-disable-next-line max-classes-per-file
var $981153103f24383e$var$AudioFormatTag;
(function(AudioFormatTag) {
    AudioFormatTag[AudioFormatTag["PCM"] = 1] = "PCM";
    AudioFormatTag[AudioFormatTag["MuLaw"] = 2] = "MuLaw";
    AudioFormatTag[AudioFormatTag["Siren"] = 3] = "Siren";
    AudioFormatTag[AudioFormatTag["MP3"] = 4] = "MP3";
    AudioFormatTag[AudioFormatTag["SILKSkype"] = 5] = "SILKSkype";
    AudioFormatTag[AudioFormatTag["OGG_OPUS"] = 6] = "OGG_OPUS";
    AudioFormatTag[AudioFormatTag["WEBM_OPUS"] = 7] = "WEBM_OPUS";
    AudioFormatTag[AudioFormatTag["ALaw"] = 8] = "ALaw";
    AudioFormatTag[AudioFormatTag["FLAC"] = 9] = "FLAC";
    AudioFormatTag[AudioFormatTag["OPUS"] = 10] = "OPUS";
})($981153103f24383e$var$AudioFormatTag = module.exports.AudioFormatTag || (module.exports.AudioFormatTag = {}));
/**
 * Represents audio stream format used for custom audio input configurations.
 * @class AudioStreamFormat
 */ class $981153103f24383e$var$AudioStreamFormat {
    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getDefaultInputFormat() {
        return $981153103f24383e$var$AudioStreamFormatImpl.getDefaultInputFormat();
    }
    /**
     * Creates an audio stream format object with the specified format characteristics.
     * @member AudioStreamFormat.getWaveFormat
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormat(samplesPerSecond, bitsPerSample, channels, format) {
        return new $981153103f24383e$var$AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels, format);
    }
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */ static getWaveFormatPCM(samplesPerSecond, bitsPerSample, channels) {
        return new $981153103f24383e$var$AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels);
    }
}
module.exports.AudioStreamFormat = $981153103f24383e$var$AudioStreamFormat;
/**
 * @private
 * @class AudioStreamFormatImpl
 */ class $981153103f24383e$var$AudioStreamFormatImpl extends $981153103f24383e$var$AudioStreamFormat {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {number} channels - Number of channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     */ constructor(samplesPerSec = 16000, bitsPerSample = 16, channels = 1, format = $981153103f24383e$var$AudioFormatTag.PCM){
        super();
        let isWavFormat = true;
        /* 1 for PCM; 6 for alaw; 7 for mulaw */ switch(format){
            case $981153103f24383e$var$AudioFormatTag.PCM:
                this.formatTag = 1;
                break;
            case $981153103f24383e$var$AudioFormatTag.ALaw:
                this.formatTag = 6;
                break;
            case $981153103f24383e$var$AudioFormatTag.MuLaw:
                this.formatTag = 7;
                break;
            default:
                isWavFormat = false;
        }
        this.bitsPerSample = bitsPerSample;
        this.samplesPerSec = samplesPerSec;
        this.channels = channels;
        this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8);
        this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8);
        if (isWavFormat) {
            this.privHeader = new ArrayBuffer(44);
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
            const view = new DataView(this.privHeader);
            /* RIFF identifier */ this.setString(view, 0, "RIFF");
            /* file length */ view.setUint32(4, 0, true);
            /* RIFF type & Format */ this.setString(view, 8, "WAVEfmt ");
            /* format chunk length */ view.setUint32(16, 16, true);
            /* audio format */ view.setUint16(20, this.formatTag, true);
            /* channel count */ view.setUint16(22, this.channels, true);
            /* sample rate */ view.setUint32(24, this.samplesPerSec, true);
            /* byte rate (sample rate * block align) */ view.setUint32(28, this.avgBytesPerSec, true);
            /* block align (channel count * bytes per sample) */ view.setUint16(32, this.channels * (this.bitsPerSample / 8), true);
            /* bits per sample */ view.setUint16(34, this.bitsPerSample, true);
            /* data chunk identifier */ this.setString(view, 36, "data");
            /* data chunk length */ view.setUint32(40, 0, true);
        }
    }
    /**
     * Retrieves the default input format.
     * @member AudioStreamFormatImpl.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormatImpl} The default input format.
     */ static getDefaultInputFormat() {
        return new $981153103f24383e$var$AudioStreamFormatImpl();
    }
    /**
     * Creates an audio context appropriate to current browser
     * @member AudioStreamFormatImpl.getAudioContext
     * @function
     * @public
     * @returns {AudioContext} An audio context instance
     */ /* eslint-disable */ static getAudioContext(sampleRate) {
        // Workaround for Speech SDK bug in Safari.
        const AudioContext = window.AudioContext // our preferred impl
         || window.webkitAudioContext // fallback, mostly when on Safari
         || false; // could not find.
        // https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
        if (!!AudioContext) {
            if (sampleRate !== undefined && navigator.mediaDevices.getSupportedConstraints().sampleRate) return new AudioContext({
                sampleRate: sampleRate
            });
            else return new AudioContext();
        } else throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    /* eslint-enable */ /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    get header() {
        return this.privHeader;
    }
    setString(view, offset, str) {
        for(let i = 0; i < str.length; i++)view.setUint8(offset + i, str.charCodeAt(i));
    }
}
module.exports.AudioStreamFormatImpl = $981153103f24383e$var$AudioStreamFormatImpl;

});


parcelRegister("9QXyd", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamImpl = module.exports.PushAudioOutputStream = module.exports.PullAudioOutputStreamImpl = module.exports.PullAudioOutputStream = module.exports.AudioOutputStream = void 0;

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $iZxsX = parcelRequire("iZxsX");
/**
 * Represents audio output stream used for custom audio output configurations.
 * @class AudioOutputStream
 */ class $72c729ede6bc43fc$var$AudioOutputStream {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member AudioOutputStream.createPullStream
     * @function
     * @public
     * @returns {PullAudioOutputStream} The audio output stream being created.
     */ static createPullStream() {
        return $72c729ede6bc43fc$var$PullAudioOutputStream.create();
    }
}
module.exports.AudioOutputStream = $72c729ede6bc43fc$var$AudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @class PullAudioOutputStream
 */ class $72c729ede6bc43fc$var$PullAudioOutputStream extends $72c729ede6bc43fc$var$AudioOutputStream {
    /**
     * Creates a memory backed PullAudioOutputStream with the specified audio format.
     * @member PullAudioOutputStream.create
     * @function
     * @public
     * @returns {PullAudioOutputStream} The push audio output stream being created.
     */ static create() {
        return new $72c729ede6bc43fc$var$PullAudioOutputStreamImpl();
    }
}
module.exports.PullAudioOutputStream = $72c729ede6bc43fc$var$PullAudioOutputStream;
/**
 * Represents memory backed push audio output stream used for custom audio output configurations.
 * @private
 * @class PullAudioOutputStreamImpl
 */ class $72c729ede6bc43fc$var$PullAudioOutputStreamImpl extends $72c729ede6bc43fc$var$PullAudioOutputStream {
    /**
     * Creates and initializes an instance with the given values.
     * @constructor
     */ constructor(){
        super();
        this.privId = $3wpON.createNoDashGuid();
        this.privStream = new $3wpON.Stream();
    }
    /**
     * Sets the format information to the stream. For internal use only.
     * @param {AudioStreamFormat} format - the format to be set.
     */ set format(format) {
        if (format === undefined || format === null) this.privFormat = $iZxsX.AudioOutputFormatImpl.getDefaultOutputFormat();
        this.privFormat = format;
    }
    /**
     * Format information for the audio
     */ get format() {
        return this.privFormat;
    }
    /**
     * Checks if the stream is closed
     * @member PullAudioOutputStreamImpl.prototype.isClosed
     * @property
     * @public
     */ get isClosed() {
        return this.privStream.isClosed;
    }
    /**
     * Gets the id of the stream
     * @member PullAudioOutputStreamImpl.prototype.id
     * @property
     * @public
     */ id() {
        return this.privId;
    }
    /**
     * Reads audio data from the internal buffer.
     * @member PullAudioOutputStreamImpl.prototype.read
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
     * @returns {Promise<number>} - Audio buffer length has been read.
     */ async read(dataBuffer) {
        const intView = new Int8Array(dataBuffer);
        let totalBytes = 0;
        if (this.privLastChunkView !== undefined) {
            if (this.privLastChunkView.length > dataBuffer.byteLength) {
                intView.set(this.privLastChunkView.slice(0, dataBuffer.byteLength));
                this.privLastChunkView = this.privLastChunkView.slice(dataBuffer.byteLength);
                return Promise.resolve(dataBuffer.byteLength);
            }
            intView.set(this.privLastChunkView);
            totalBytes = this.privLastChunkView.length;
            this.privLastChunkView = undefined;
        }
        // Until we have the minimum number of bytes to send in a transmission, keep asking for more.
        while(totalBytes < dataBuffer.byteLength && !this.privStream.isReadEnded){
            const chunk = await this.privStream.read();
            if (chunk !== undefined && !chunk.isEnd) {
                let tmpBuffer;
                if (chunk.buffer.byteLength > dataBuffer.byteLength - totalBytes) {
                    tmpBuffer = chunk.buffer.slice(0, dataBuffer.byteLength - totalBytes);
                    this.privLastChunkView = new Int8Array(chunk.buffer.slice(dataBuffer.byteLength - totalBytes));
                } else tmpBuffer = chunk.buffer;
                intView.set(new Int8Array(tmpBuffer), totalBytes);
                totalBytes += tmpBuffer.byteLength;
            } else this.privStream.readEnded();
        }
        return totalBytes;
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PullAudioOutputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */ write(dataBuffer) {
        $56OOs.Contracts.throwIfNullOrUndefined(this.privStream, "must set format before writing");
        this.privStream.writeStreamChunk({
            buffer: dataBuffer,
            isEnd: false,
            timeReceived: Date.now()
        });
    }
    /**
     * Closes the stream.
     * @member PullAudioOutputStreamImpl.prototype.close
     * @function
     * @public
     */ close() {
        this.privStream.close();
    }
}
module.exports.PullAudioOutputStreamImpl = $72c729ede6bc43fc$var$PullAudioOutputStreamImpl;
/*
 * Represents audio output stream used for custom audio output configurations.
 * @class PushAudioOutputStream
 */ class $72c729ede6bc43fc$var$PushAudioOutputStream extends $72c729ede6bc43fc$var$AudioOutputStream {
    /**
     * Creates and initializes and instance.
     * @constructor
     */ constructor(){
        super();
    }
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * write() and close() methods.
     * @member PushAudioOutputStream.create
     * @function
     * @public
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     * @returns {PushAudioOutputStream} The push audio output stream being created.
     */ static create(callback) {
        return new $72c729ede6bc43fc$var$PushAudioOutputStreamImpl(callback);
    }
}
module.exports.PushAudioOutputStream = $72c729ede6bc43fc$var$PushAudioOutputStream;
/**
 * Represents audio output stream used for custom audio output configurations.
 * @private
 * @class PushAudioOutputStreamImpl
 */ class $72c729ede6bc43fc$var$PushAudioOutputStreamImpl extends $72c729ede6bc43fc$var$PushAudioOutputStream {
    /**
     * Creates a PushAudioOutputStream that delegates to the specified callback interface for
     * read() and close() methods.
     * @constructor
     * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
     * derived from PushAudioOutputStreamCallback
     */ constructor(callback){
        super();
        this.privId = $3wpON.createNoDashGuid();
        this.privCallback = callback;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set format(format) {}
    write(buffer) {
        if (!!this.privCallback.write) this.privCallback.write(buffer);
    }
    close() {
        if (!!this.privCallback.close) this.privCallback.close();
    }
    id() {
        return this.privId;
    }
}
module.exports.PushAudioOutputStreamImpl = $72c729ede6bc43fc$var$PushAudioOutputStreamImpl;

});
parcelRegister("iZxsX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioOutputFormatImpl = void 0;

var $YNmLN = parcelRequire("YNmLN");

var $d3s41 = parcelRequire("d3s41");
/**
 * @private
 * @class AudioOutputFormatImpl
 * Updated in version 1.17.0
 */ // eslint-disable-next-line max-classes-per-file
class $dd37e22856b483c5$var$AudioOutputFormatImpl extends $d3s41.AudioStreamFormatImpl {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param formatTag
     * @param {number} channels - Number of channels.
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} avgBytesPerSec - Average bytes per second.
     * @param {number} blockAlign - Block alignment.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {string} audioFormatString - Audio format string
     * @param {string} requestAudioFormatString - Audio format string sent to service.
     * @param {boolean} hasHeader - If the format has header or not.
     */ constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, audioFormatString, requestAudioFormatString, hasHeader){
        super(samplesPerSec, bitsPerSample, channels, formatTag);
        this.formatTag = formatTag;
        this.avgBytesPerSec = avgBytesPerSec;
        this.blockAlign = blockAlign;
        this.priAudioFormatString = audioFormatString;
        this.priRequestAudioFormatString = requestAudioFormatString;
        this.priHasHeader = hasHeader;
    }
    static fromSpeechSynthesisOutputFormat(speechSynthesisOutputFormat) {
        if (speechSynthesisOutputFormat === undefined) return $dd37e22856b483c5$var$AudioOutputFormatImpl.getDefaultOutputFormat();
        return $dd37e22856b483c5$var$AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString($dd37e22856b483c5$var$AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString[speechSynthesisOutputFormat]);
    }
    static fromSpeechSynthesisOutputFormatString(speechSynthesisOutputFormatString) {
        switch(speechSynthesisOutputFormatString){
            case "raw-8khz-8bit-mono-mulaw":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-16khz-16kbps-mono-siren":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, "audio-16khz-16kbps-mono-siren", true);
            case "audio-16khz-16kbps-mono-siren":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-32kbitrate-mono-mp3":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MP3, 1, 16000, 4096, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-128kbitrate-mono-mp3":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MP3, 1, 16000, 16384, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-64kbitrate-mono-mp3":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MP3, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-48kbitrate-mono-mp3":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MP3, 1, 24000, 6144, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-96kbitrate-mono-mp3":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MP3, 1, 24000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-160kbitrate-mono-mp3":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MP3, 1, 24000, 20480, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-16khz-16bit-mono-truesilk":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.SILKSkype, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", true);
            case "riff-24khz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", true);
            case "riff-8khz-8bit-mono-mulaw":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-mulaw", true);
            case "raw-16khz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, "raw-16khz-16bit-mono-pcm", false);
            case "raw-24khz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", false);
            case "raw-8khz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", false);
            case "ogg-16khz-16bit-mono-opus":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.OGG_OPUS, 1, 16000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-24khz-16bit-mono-opus":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.OGG_OPUS, 1, 24000, 8192, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-48khz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", false);
            case "riff-48khz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 48000, 96000, 2, 16, speechSynthesisOutputFormatString, "raw-48khz-16bit-mono-pcm", true);
            case "audio-48khz-96kbitrate-mono-mp3":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MP3, 1, 48000, 12288, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-192kbitrate-mono-mp3":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.MP3, 1, 48000, 24576, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "ogg-48khz-16bit-mono-opus":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.OGG_OPUS, 1, 48000, 12000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-16khz-16bit-mono-opus":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.WEBM_OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-mono-opus":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.WEBM_OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "webm-24khz-16bit-24kbps-mono-opus":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.WEBM_OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-16khz-16bit-32kbps-mono-opus":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.OPUS, 1, 16000, 4000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-48kbps-mono-opus":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.OPUS, 1, 24000, 6000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-24kbps-mono-opus":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.OPUS, 1, 24000, 3000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-24khz-16bit-mono-flac":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.FLAC, 1, 24000, 24000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "audio-48khz-16bit-mono-flac":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.FLAC, 1, 48000, 30000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-24khz-16bit-mono-truesilk":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.SILKSkype, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "raw-8khz-8bit-mono-alaw":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-8khz-8bit-mono-alaw":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.ALaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-alaw", true);
            case "raw-22050hz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-22050hz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, speechSynthesisOutputFormatString, "raw-22050hz-16bit-mono-pcm", true);
            case "raw-44100hz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);
            case "riff-44100hz-16bit-mono-pcm":
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, speechSynthesisOutputFormatString, "raw-44100hz-16bit-mono-pcm", true);
            case "riff-16khz-16bit-mono-pcm":
            default:
                return new $dd37e22856b483c5$var$AudioOutputFormatImpl($d3s41.AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", true);
        }
    }
    static getDefaultOutputFormat() {
        return $dd37e22856b483c5$var$AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(typeof window !== "undefined" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
    }
    /**
     * Specifies if this audio output format has a header
     * @boolean AudioOutputFormatImpl.prototype.hasHeader
     * @function
     * @public
     */ get hasHeader() {
        return this.priHasHeader;
    }
    /**
     * Specifies the header of this format
     * @ArrayBuffer AudioOutputFormatImpl.prototype.header
     * @function
     * @public
     */ get header() {
        if (this.hasHeader) return this.privHeader;
        return undefined;
    }
    /**
     * Updates the header based on the audio length
     * @member AudioOutputFormatImpl.updateHeader
     * @function
     * @public
     * @param {number} audioLength - the audio length
     */ updateHeader(audioLength) {
        if (this.priHasHeader) {
            const view = new DataView(this.privHeader);
            view.setUint32(4, audioLength + this.privHeader.byteLength - 8, true);
            view.setUint32(40, audioLength, true);
        }
    }
    /**
     * Specifies the audio format string to be sent to the service
     * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
     * @function
     * @public
     */ get requestAudioFormatString() {
        return this.priRequestAudioFormatString;
    }
    /**
     * Adds audio header
     * @param audio the raw audio without header
     * @returns the audio with header if applicable
     */ addHeader(audio) {
        if (!this.hasHeader) return audio;
        this.updateHeader(audio.byteLength);
        const tmp = new Uint8Array(audio.byteLength + this.header.byteLength);
        tmp.set(new Uint8Array(this.header), 0);
        tmp.set(new Uint8Array(audio), this.header.byteLength);
        return tmp.buffer;
    }
}
module.exports.AudioOutputFormatImpl = $dd37e22856b483c5$var$AudioOutputFormatImpl;
$dd37e22856b483c5$var$AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString = {
    [$YNmLN.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
    [$YNmLN.SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
    [$YNmLN.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
    [$YNmLN.SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
    [$YNmLN.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
    [$YNmLN.SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
    [$YNmLN.SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
    [$YNmLN.SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
    [$YNmLN.SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
    [$YNmLN.SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
    [$YNmLN.SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus]: "webm-24khz-16bit-24kbps-mono-opus",
    [$YNmLN.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
    [$YNmLN.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
    [$YNmLN.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus]: "audio-16khz-16bit-32kbps-mono-opus",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus]: "audio-24khz-16bit-48kbps-mono-opus",
    [$YNmLN.SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus]: "audio-24khz-16bit-24kbps-mono-opus",
    [$YNmLN.SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm]: "raw-22050hz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm]: "riff-22050hz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm]: "raw-44100hz-16bit-mono-pcm",
    [$YNmLN.SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm]: "riff-44100hz-16bit-mono-pcm"
};

});
parcelRegister("YNmLN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisOutputFormat = void 0;
/**
 * Define speech synthesis audio output formats.
 * @enum SpeechSynthesisOutputFormat
 * Updated in version 1.17.0
 */ var $0b6be5d268d35afb$var$SpeechSynthesisOutputFormat;
(function(SpeechSynthesisOutputFormat) {
    /**
     * raw-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw,
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoMULaw"] = 0] = "Raw8Khz8BitMonoMULaw";
    /**
     * riff-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16KbpsMonoSiren"] = 1] = "Riff16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-16kbps-mono-siren
     * @note Unsupported by the service. Do not use this value.
     * @member SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16KbpsMonoSiren"] = 2] = "Audio16Khz16KbpsMonoSiren";
    /**
     * audio-16khz-32kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz32KBitRateMonoMp3"] = 3] = "Audio16Khz32KBitRateMonoMp3";
    /**
     * audio-16khz-128kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz128KBitRateMonoMp3"] = 4] = "Audio16Khz128KBitRateMonoMp3";
    /**
     * audio-16khz-64kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz64KBitRateMonoMp3"] = 5] = "Audio16Khz64KBitRateMonoMp3";
    /**
     * audio-24khz-48kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz48KBitRateMonoMp3"] = 6] = "Audio24Khz48KBitRateMonoMp3";
    /**
     * audio-24khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz96KBitRateMonoMp3"] = 7] = "Audio24Khz96KBitRateMonoMp3";
    /**
     * audio-24khz-160kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz160KBitRateMonoMp3"] = 8] = "Audio24Khz160KBitRateMonoMp3";
    /**
     * raw-16khz-16bit-mono-truesilk
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoTrueSilk"] = 9] = "Raw16Khz16BitMonoTrueSilk";
    /**
     * riff-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff16Khz16BitMonoPcm"] = 10] = "Riff16Khz16BitMonoPcm";
    /**
     * riff-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz16BitMonoPcm"] = 11] = "Riff8Khz16BitMonoPcm";
    /**
     * riff-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff24Khz16BitMonoPcm"] = 12] = "Riff24Khz16BitMonoPcm";
    /**
     * riff-8khz-8bit-mono-mulaw
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoMULaw"] = 13] = "Riff8Khz8BitMonoMULaw";
    /**
     * raw-16khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw16Khz16BitMonoPcm"] = 14] = "Raw16Khz16BitMonoPcm";
    /**
     * raw-24khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoPcm"] = 15] = "Raw24Khz16BitMonoPcm";
    /**
     * raw-8khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz16BitMonoPcm"] = 16] = "Raw8Khz16BitMonoPcm";
    /**
     * ogg-16khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg16Khz16BitMonoOpus"] = 17] = "Ogg16Khz16BitMonoOpus";
    /**
     * ogg-24khz-16bit-mono-opus
     * @member SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg24Khz16BitMonoOpus"] = 18] = "Ogg24Khz16BitMonoOpus";
    /**
     * raw-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw48Khz16BitMonoPcm"] = 19] = "Raw48Khz16BitMonoPcm";
    /**
     * riff-48khz-16bit-mono-pcm
     * @member SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff48Khz16BitMonoPcm"] = 20] = "Riff48Khz16BitMonoPcm";
    /**
     * audio-48khz-96kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz96KBitRateMonoMp3"] = 21] = "Audio48Khz96KBitRateMonoMp3";
    /**
     * audio-48khz-192kbitrate-mono-mp3
     * @member SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio48Khz192KBitRateMonoMp3"] = 22] = "Audio48Khz192KBitRateMonoMp3";
    /**
     * ogg-48khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Ogg48Khz16BitMonoOpus"] = 23] = "Ogg48Khz16BitMonoOpus";
    /**
     * webm-16khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm16Khz16BitMonoOpus"] = 24] = "Webm16Khz16BitMonoOpus";
    /**
     * webm-24khz-16bit-mono-opus
     * Added in version 1.16.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16BitMonoOpus"] = 25] = "Webm24Khz16BitMonoOpus";
    /**
     * raw-24khz-16bit-mono-truesilk
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw24Khz16BitMonoTrueSilk"] = 26] = "Raw24Khz16BitMonoTrueSilk";
    /**
     * raw-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw8Khz8BitMonoALaw"] = 27] = "Raw8Khz8BitMonoALaw";
    /**
     * riff-8khz-8bit-mono-alaw
     * Added in version 1.17.0
     * @member SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff8Khz8BitMonoALaw"] = 28] = "Riff8Khz8BitMonoALaw";
    /**
     * webm-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec in a webm container, with bitrate of 24kbps, optimized for IoT scenario.
     * Added in version 1.19.0
     * @member SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Webm24Khz16Bit24KbpsMonoOpus"] = 29] = "Webm24Khz16Bit24KbpsMonoOpus";
    /**
     * audio-16khz-16bit-32kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 32kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio16Khz16Bit32KbpsMonoOpus"] = 30] = "Audio16Khz16Bit32KbpsMonoOpus";
    /**
     * audio-24khz-16bit-48kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 48kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit48KbpsMonoOpus"] = 31] = "Audio24Khz16Bit48KbpsMonoOpus";
    /**
     * audio-24khz-16bit-24kbps-mono-opus
     * Audio compressed by OPUS codec without container, with bitrate of 24kbps.
     * Added in version 1.20.0
     * @member SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Audio24Khz16Bit24KbpsMonoOpus"] = 32] = "Audio24Khz16Bit24KbpsMonoOpus";
    /**
     * raw-22050hz-16bit-mono-pcm
     * Raw PCM audio at 22050Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw22050Hz16BitMonoPcm"] = 33] = "Raw22050Hz16BitMonoPcm";
    /**
     * riff-22050hz-16bit-mono-pcm
     * PCM audio at 22050Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff22050Hz16BitMonoPcm"] = 34] = "Riff22050Hz16BitMonoPcm";
    /**
     * raw-44100hz-16bit-mono-pcm
     * Raw PCM audio at 44100Hz sampling rate and 16-bit depth.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Raw44100Hz16BitMonoPcm"] = 35] = "Raw44100Hz16BitMonoPcm";
    /**
     * riff-44100hz-16bit-mono-pcm
     * PCM audio at 44100Hz sampling rate and 16-bit depth, with RIFF header.
     * Added in version 1.22.0
     * @member SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm
     */ SpeechSynthesisOutputFormat[SpeechSynthesisOutputFormat["Riff44100Hz16BitMonoPcm"] = 36] = "Riff44100Hz16BitMonoPcm";
})($0b6be5d268d35afb$var$SpeechSynthesisOutputFormat = module.exports.SpeechSynthesisOutputFormat || (module.exports.SpeechSynthesisOutputFormat = {}));

});




parcelRegister("61VNj", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationReason = void 0;
/**
 * Defines the possible reasons a recognition result might be canceled.
 * @class CancellationReason
 */ var $463faad09a4241fd$var$CancellationReason;
(function(CancellationReason) {
    /**
     * Indicates that an error occurred during speech recognition.
     * @member CancellationReason.Error
     */ CancellationReason[CancellationReason["Error"] = 0] = "Error";
    /**
     * Indicates that the end of the audio stream was reached.
     * @member CancellationReason.EndOfStream
     */ CancellationReason[CancellationReason["EndOfStream"] = 1] = "EndOfStream";
})($463faad09a4241fd$var$CancellationReason = module.exports.CancellationReason || (module.exports.CancellationReason = {}));

});

parcelRegister("22mC5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PullAudioInputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (read() and close()) for
 * custom audio input streams).
 * @class PullAudioInputStreamCallback
 */ class $17bd4f37f48ea8ad$var$PullAudioInputStreamCallback {
}
module.exports.PullAudioInputStreamCallback = $17bd4f37f48ea8ad$var$PullAudioInputStreamCallback;

});

parcelRegister("3fLsh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushAudioOutputStreamCallback = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/**
 * An abstract base class that defines callback methods (write() and close()) for
 * custom audio output streams).
 * @class PushAudioOutputStreamCallback
 */ class $25e7956c9de76703$var$PushAudioOutputStreamCallback {
}
module.exports.PushAudioOutputStreamCallback = $25e7956c9de76703$var$PushAudioOutputStreamCallback;

});

parcelRegister("kAZw5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeywordRecognitionModel = void 0;

var $56OOs = parcelRequire("56OOs");
/**
 * Represents a keyword recognition model for recognizing when
 * the user says a keyword to initiate further speech recognition.
 * @class KeywordRecognitionModel
 */ class $efe6e35784446424$var$KeywordRecognitionModel {
    /**
     * Create and initializes a new instance.
     * @constructor
     */ constructor(){
        this.privDisposed = false;
        return;
    }
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromFile
     * @function
     * @public
     * @param {string} fileName - A string that represents file name for the keyword recognition model.
     * Note, the file can point to a zip file in which case the model
     * will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ static fromFile(fileName) {
        $56OOs.Contracts.throwIfFileDoesNotExist(fileName, "fileName");
        throw new Error("Not yet implemented.");
    }
    /**
     * Creates a keyword recognition model using the specified filename.
     * @member KeywordRecognitionModel.fromStream
     * @function
     * @public
     * @param {string} file - A File that represents file for the keyword recognition model.
     * Note, the file can point to a zip file in which case the model will be extracted from the zip.
     * @returns {KeywordRecognitionModel} The keyword recognition model being created.
     */ static fromStream(file) {
        $56OOs.Contracts.throwIfNull(file, "file");
        throw new Error("Not yet implemented.");
    }
    /**
     * Dispose of associated resources.
     * @member KeywordRecognitionModel.prototype.close
     * @function
     * @public
     */ close() {
        if (this.privDisposed) return;
        this.privDisposed = true;
    }
}
module.exports.KeywordRecognitionModel = $efe6e35784446424$var$KeywordRecognitionModel;

});

parcelRegister("8LjTB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SessionEventArgs = void 0;
/**
 * Defines content for session events like SessionStarted/Stopped, SoundStarted/Stopped.
 * @class SessionEventArgs
 */ class $661225697402102e$var$SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionId - The session id.
     */ constructor(sessionId){
        this.privSessionId = sessionId;
    }
    /**
     * Represents the session identifier.
     * @member SessionEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} Represents the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
}
module.exports.SessionEventArgs = $661225697402102e$var$SessionEventArgs;

});

parcelRegister("lb7dE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines payload for session events like Speech Start/End Detected
 * @class
 */ class $f6b039a3c7525ff0$var$RecognitionEventArgs extends $hVlip.SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(offset, sessionId){
        super(sessionId);
        this.privOffset = offset;
    }
    /**
     * Represents the message offset
     * @member RecognitionEventArgs.prototype.offset
     * @function
     * @public
     */ get offset() {
        return this.privOffset;
    }
}
module.exports.RecognitionEventArgs = $f6b039a3c7525ff0$var$RecognitionEventArgs;

});

parcelRegister("dcae8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OutputFormat = void 0;
/**
 * Define Speech Recognizer output formats.
 * @class OutputFormat
 */ var $99b4543e00aa8c53$var$OutputFormat;
(function(OutputFormat) {
    /**
     * @member OutputFormat.Simple
     */ OutputFormat[OutputFormat["Simple"] = 0] = "Simple";
    /**
     * @member OutputFormat.Detailed
     */ OutputFormat[OutputFormat["Detailed"] = 1] = "Detailed";
})($99b4543e00aa8c53$var$OutputFormat = module.exports.OutputFormat || (module.exports.OutputFormat = {}));

});

parcelRegister("f7gre", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Intent recognition result event arguments.
 * @class
 */ class $b01442c3de726aa2$var$IntentRecognitionEventArgs extends $hVlip.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param result - The result of the intent recognition.
     * @param offset - The offset.
     * @param sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Represents the intent recognition result.
     * @member IntentRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {IntentRecognitionResult} Represents the intent recognition result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.IntentRecognitionEventArgs = $b01442c3de726aa2$var$IntentRecognitionEventArgs;

});

parcelRegister("dzj2U", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionResult = void 0;
/**
 * Defines result of speech recognition.
 * @class RecognitionResult
 */ class $9e0d51615f8d3cea$var$RecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privText = text;
        this.privDuration = duration;
        this.privOffset = offset;
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
        this.privErrorDetails = errorDetails;
        this.privJson = json;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member RecognitionResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member RecognitionResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * Presents the recognized text in the result.
     * @member RecognitionResult.prototype.text
     * @function
     * @public
     * @returns {string} Presents the recognized text in the result.
     */ get text() {
        return this.privText;
    }
    /**
     * Duration of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.duration
     * @function
     * @public
     * @returns {number} Duration of recognized speech in 100 nano second increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Offset of recognized speech in 100 nano second increments.
     * @member RecognitionResult.prototype.offset
     * @function
     * @public
     * @returns {number} Offset of recognized speech in 100 nano second increments.
     */ get offset() {
        return this.privOffset;
    }
    /**
     * Primary Language detected.
     * @member RecognitionResult.prototype.language
     * @function
     * @public
     * @returns {string} language detected.
     */ get language() {
        return this.privLanguage;
    }
    /**
     * Primary Language detection confidence (Unknown, Low, Medium, High).
     * @member RecognitionResult.prototype.languageDetectionConfidence
     * @function
     * @public
     * @returns {string} detection confidence strength.
     */ get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member RecognitionResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * A string containing Json serialized recognition result as it was received from the service.
     * @member RecognitionResult.prototype.json
     * @function
     * @private
     * @returns {string} Json serialized representation of the result.
     */ get json() {
        return this.privJson;
    }
    /**
     * The set of properties exposed in the result.
     * @member RecognitionResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}
module.exports.RecognitionResult = $9e0d51615f8d3cea$var$RecognitionResult;

});

parcelRegister("8msMz", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionResult = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines result of speech recognition.
 * @class SpeechRecognitionResult
 */ class $6166b465c248c2b4$var$SpeechRecognitionResult extends $hVlip.RecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription, if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties);
        this.privSpeakerId = speakerId;
    }
    /**
     * speaker id from conversation transcription/id scenarios
     * @member SpeechRecognitionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */ get speakerId() {
        return this.privSpeakerId;
    }
}
module.exports.SpeechRecognitionResult = $6166b465c248c2b4$var$SpeechRecognitionResult;

});

parcelRegister("2fW0F", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionResult = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Intent recognition result.
 * @class
 */ class $1a49fb07eec5aeb5$var$IntentRecognitionResult extends $hVlip.SpeechRecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param intentId - The intent id.
     * @param resultId - The result id.
     * @param reason - The reason.
     * @param text - The recognized text.
     * @param duration - The duration.
     * @param offset - The offset into the stream.
     * @param language - Primary Language detected, if provided.
     * @param languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param errorDetails - Error details, if provided.
     * @param json - Additional Json, if provided.
     * @param properties - Additional properties, if provided.
     */ constructor(intentId, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties);
        this.privIntentId = intentId;
    }
    /**
     * A String that represents the intent identifier being recognized.
     * @member IntentRecognitionResult.prototype.intentId
     * @function
     * @public
     * @returns {string} A String that represents the intent identifier being recognized.
     */ get intentId() {
        return this.privIntentId;
    }
}
module.exports.IntentRecognitionResult = $1a49fb07eec5aeb5$var$IntentRecognitionResult;

});

parcelRegister("fhft3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageUnderstandingModelImpl = module.exports.LanguageUnderstandingModel = void 0;

var $56OOs = parcelRequire("56OOs");
/**
 * Language understanding model
 * @class LanguageUnderstandingModel
 */ class $b1f4711b3461fea7$var$LanguageUnderstandingModel {
    /**
     * Creates and initializes a new instance
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Creates an language understanding model using the specified endpoint.
     * @member LanguageUnderstandingModel.fromEndpoint
     * @function
     * @public
     * @param {URL} uri - A String that represents the endpoint of the language understanding model.
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ static fromEndpoint(uri) {
        $56OOs.Contracts.throwIfNull(uri, "uri");
        $56OOs.Contracts.throwIfNullOrWhitespace(uri.hostname, "uri");
        const langModelImp = new $b1f4711b3461fea7$var$LanguageUnderstandingModelImpl();
        // Need to extract the app ID from the URL.
        // URL is in the format: https://<region>.api.cognitive.microsoft.com/luis/v2.0/apps/<Guid>?subscription-key=<key>&timezoneOffset=-360
        // Start tearing the string apart.
        // region can be extracted from the host name.
        const firstDot = uri.host.indexOf(".");
        if (-1 === firstDot) throw new Error("Could not determine region from endpoint");
        langModelImp.region = uri.host.substr(0, firstDot);
        // Now the app ID.
        const lastSegment = uri.pathname.lastIndexOf("/") + 1;
        if (-1 === lastSegment) throw new Error("Could not determine appId from endpoint");
        langModelImp.appId = uri.pathname.substr(lastSegment);
        // And finally the key.
        langModelImp.subscriptionKey = uri.searchParams.get("subscription-key");
        if (undefined === langModelImp.subscriptionKey) throw new Error("Could not determine subscription key from endpoint");
        return langModelImp;
    }
    /**
     * Creates an language understanding model using the application id of Language Understanding service.
     * @member LanguageUnderstandingModel.fromAppId
     * @function
     * @public
     * @param {string} appId - A String that represents the application id of Language Understanding service.
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ static fromAppId(appId) {
        $56OOs.Contracts.throwIfNullOrWhitespace(appId, "appId");
        const langModelImp = new $b1f4711b3461fea7$var$LanguageUnderstandingModelImpl();
        langModelImp.appId = appId;
        return langModelImp;
    }
    /**
     * Creates a language understanding model using hostname, subscription key and application
     * id of Language Understanding service.
     * @member LanguageUnderstandingModel.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - A String that represents the subscription key of
     * Language Understanding service.
     * @param {string} appId - A String that represents the application id of Language
     * Understanding service.
     * @param {LanguageUnderstandingModel} region - A String that represents the region
     * of the Language Understanding service (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {LanguageUnderstandingModel} The language understanding model being created.
     */ static fromSubscription(subscriptionKey, appId, region) {
        $56OOs.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $56OOs.Contracts.throwIfNullOrWhitespace(appId, "appId");
        $56OOs.Contracts.throwIfNullOrWhitespace(region, "region");
        const langModelImp = new $b1f4711b3461fea7$var$LanguageUnderstandingModelImpl();
        langModelImp.appId = appId;
        langModelImp.region = region;
        langModelImp.subscriptionKey = subscriptionKey;
        return langModelImp;
    }
}
module.exports.LanguageUnderstandingModel = $b1f4711b3461fea7$var$LanguageUnderstandingModel;
/**
 * @private
 * @class LanguageUnderstandingModelImpl
 */ class $b1f4711b3461fea7$var$LanguageUnderstandingModelImpl extends $b1f4711b3461fea7$var$LanguageUnderstandingModel {
}
module.exports.LanguageUnderstandingModelImpl = $b1f4711b3461fea7$var$LanguageUnderstandingModelImpl;

});

parcelRegister("lw8yB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriptionEventArgs = module.exports.ConversationTranscriptionEventArgs = module.exports.SpeechRecognitionEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines contents of speech recognizing/recognized event.
 * @class SpeechRecognitionEventArgs
 */ class $faa3396ab7f97268$var$SpeechRecognitionEventArgs extends $hVlip.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechRecognitionResult} result - The speech recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @member SpeechRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.SpeechRecognitionEventArgs = $faa3396ab7f97268$var$SpeechRecognitionEventArgs;
/**
 * Defines contents of conversation transcribed/transcribing event.
 * @class ConversationTranscriptionEventArgs
 */ class $faa3396ab7f97268$var$ConversationTranscriptionEventArgs extends $hVlip.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranscriptionResult} result - The conversation transcription result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the transcription result.
     * @member ConversationTranscription1EventArgs.prototype.result
     * @function
     * @public
     * @returns {ConversationTranscriptionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.ConversationTranscriptionEventArgs = $faa3396ab7f97268$var$ConversationTranscriptionEventArgs;
/**
 * Defines contents of meeting transcribed/transcribing event.
 * @class MeetingTranscriptionEventArgs
 */ class $faa3396ab7f97268$var$MeetingTranscriptionEventArgs extends $faa3396ab7f97268$var$SpeechRecognitionEventArgs {
}
module.exports.MeetingTranscriptionEventArgs = $faa3396ab7f97268$var$MeetingTranscriptionEventArgs;

});

parcelRegister("8lDRn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognitionCanceledEventArgs = void 0;

var $6sMHZ = parcelRequire("6sMHZ");
class $613f343d3396ab2d$var$SpeechRecognitionCanceledEventArgs extends $6sMHZ.CancellationEventArgsBase {
}
module.exports.SpeechRecognitionCanceledEventArgs = $613f343d3396ab2d$var$SpeechRecognitionCanceledEventArgs;

});
parcelRegister("6sMHZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationEventArgsBase = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines content of a CancellationEvent.
 * @class CancellationEventArgsBase
 */ class $4b4b2417c32163d9$var$CancellationEventArgsBase extends $hVlip.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(reason, errorDetails, errorCode, offset, sessionId){
        super(offset, sessionId);
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member CancellationEventArgsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful operation.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful operation, provides details of the occurred error.
     * @member CancellationEventArgsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}
module.exports.CancellationEventArgsBase = $4b4b2417c32163d9$var$CancellationEventArgsBase;

});


parcelRegister("8QD8u", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Translation text result event arguments.
 * @class TranslationRecognitionEventArgs
 */ class $671189a264bbdbcf$var$TranslationRecognitionEventArgs extends $hVlip.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationRecognitionResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.TranslationRecognitionEventArgs = $671189a264bbdbcf$var$TranslationRecognitionEventArgs;

});

parcelRegister("cDUUT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Translation Synthesis event arguments
 * @class TranslationSynthesisEventArgs
 */ class $93454700d69ae091$var$TranslationSynthesisEventArgs extends $hVlip.SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationSynthesisResult} result - The translation synthesis result.
     * @param {string} sessionId - The session id.
     */ constructor(result, sessionId){
        super(sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the translation synthesis result.
     * @member TranslationSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.TranslationSynthesisEventArgs = $93454700d69ae091$var$TranslationSynthesisEventArgs;

});

parcelRegister("5puUG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionResult = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Translation text result.
 * @class TranslationRecognitionResult
 */ class $3f0744440b6d6052$var$TranslationRecognitionResult extends $hVlip.SpeechRecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {Translations} translations - The translations.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(translations, resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, undefined, errorDetails, json, properties);
        this.privTranslations = translations;
    }
    static fromSpeechRecognitionResult(result) {
        return new $3f0744440b6d6052$var$TranslationRecognitionResult(undefined, result.resultId, result.reason, result.text, result.duration, result.offset, result.language, result.languageDetectionConfidence, result.errorDetails, result.json, result.properties);
    }
    /**
     * Presents the translation results. Each item in the dictionary represents
     * a translation result in one of target languages, where the key is the name
     * of the target language, in BCP-47 format, and the value is the translation
     * text in the specified language.
     * @member TranslationRecognitionResult.prototype.translations
     * @function
     * @public
     * @returns {Translations} the current translation map that holds all translations requested.
     */ get translations() {
        return this.privTranslations;
    }
}
module.exports.TranslationRecognitionResult = $3f0744440b6d6052$var$TranslationRecognitionResult;

});

parcelRegister("2PGZh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisResult = void 0;
/**
 * Defines translation synthesis result, i.e. the voice output of the translated
 * text in the target language.
 * @class TranslationSynthesisResult
 */ class $2101b09cc4b45049$var$TranslationSynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ResultReason} reason - The synthesis reason.
     * @param {ArrayBuffer} audio - The audio data.
     */ constructor(reason, audio){
        this.privReason = reason;
        this.privAudio = audio;
    }
    /**
     * Translated text in the target language.
     * @member TranslationSynthesisResult.prototype.audio
     * @function
     * @public
     * @returns {ArrayBuffer} Translated audio in the target language.
     */ get audio() {
        return this.privAudio;
    }
    /**
     * The synthesis status.
     * @member TranslationSynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} The synthesis status.
     */ get reason() {
        return this.privReason;
    }
}
module.exports.TranslationSynthesisResult = $2101b09cc4b45049$var$TranslationSynthesisResult;

});

parcelRegister("kaYEN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResultReason = void 0;
/**
 * Defines the possible reasons a recognition result might be generated.
 * @class ResultReason
 */ var $eb03cb0355d088c8$var$ResultReason;
(function(ResultReason) {
    /**
     * Indicates speech could not be recognized. More details
     * can be found in the NoMatchDetails object.
     * @member ResultReason.NoMatch
     */ ResultReason[ResultReason["NoMatch"] = 0] = "NoMatch";
    /**
     * Indicates that the recognition was canceled. More details
     * can be found using the CancellationDetails object.
     * @member ResultReason.Canceled
     */ ResultReason[ResultReason["Canceled"] = 1] = "Canceled";
    /**
     * Indicates the speech result contains hypothesis text.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizingSpeech"] = 2] = "RecognizingSpeech";
    /**
     * Indicates the speech result contains final text that has been recognized.
     * Speech Recognition is now complete for this phrase.
     * @member ResultReason.RecognizedSpeech
     */ ResultReason[ResultReason["RecognizedSpeech"] = 3] = "RecognizedSpeech";
    /**
     * Indicates the speech result contains a finalized acceptance of a provided keyword.
     * Speech recognition will continue unless otherwise configured.
     * @member ResultReason.RecognizedKeyword
     */ ResultReason[ResultReason["RecognizedKeyword"] = 4] = "RecognizedKeyword";
    /**
     * Indicates the intent result contains hypothesis text and intent.
     * @member ResultReason.RecognizingIntent
     */ ResultReason[ResultReason["RecognizingIntent"] = 5] = "RecognizingIntent";
    /**
     * Indicates the intent result contains final text and intent.
     * Speech Recognition and Intent determination are now complete for this phrase.
     * @member ResultReason.RecognizedIntent
     */ ResultReason[ResultReason["RecognizedIntent"] = 6] = "RecognizedIntent";
    /**
     * Indicates the translation result contains hypothesis text and its translation(s).
     * @member ResultReason.TranslatingSpeech
     */ ResultReason[ResultReason["TranslatingSpeech"] = 7] = "TranslatingSpeech";
    /**
     * Indicates the translation result contains final text and corresponding translation(s).
     * Speech Recognition and Translation are now complete for this phrase.
     * @member ResultReason.TranslatedSpeech
     */ ResultReason[ResultReason["TranslatedSpeech"] = 8] = "TranslatedSpeech";
    /**
     * Indicates the synthesized audio result contains a non-zero amount of audio data
     * @member ResultReason.SynthesizingAudio
     */ ResultReason[ResultReason["SynthesizingAudio"] = 9] = "SynthesizingAudio";
    /**
     * Indicates the synthesized audio is now complete for this phrase.
     * @member ResultReason.SynthesizingAudioCompleted
     */ ResultReason[ResultReason["SynthesizingAudioCompleted"] = 10] = "SynthesizingAudioCompleted";
    /**
     * Indicates the speech synthesis is now started
     * @member ResultReason.SynthesizingAudioStarted
     */ ResultReason[ResultReason["SynthesizingAudioStarted"] = 11] = "SynthesizingAudioStarted";
    /**
     * Indicates the voice profile is being enrolled and customers need to send more audio to create a voice profile.
     * @member ResultReason.EnrollingVoiceProfile
     */ ResultReason[ResultReason["EnrollingVoiceProfile"] = 12] = "EnrollingVoiceProfile";
    /**
     * Indicates the voice profile has been enrolled.
     * @member ResultReason.EnrolledVoiceProfile
     */ ResultReason[ResultReason["EnrolledVoiceProfile"] = 13] = "EnrolledVoiceProfile";
    /**
     * Indicates successful identification of some speakers.
     * @member ResultReason.RecognizedSpeakers
     */ ResultReason[ResultReason["RecognizedSpeakers"] = 14] = "RecognizedSpeakers";
    /**
     * Indicates successfully verified one speaker.
     * @member ResultReason.RecognizedSpeaker
     */ ResultReason[ResultReason["RecognizedSpeaker"] = 15] = "RecognizedSpeaker";
    /**
     * Indicates a voice profile has been reset successfully.
     * @member ResultReason.ResetVoiceProfile
     */ ResultReason[ResultReason["ResetVoiceProfile"] = 16] = "ResetVoiceProfile";
    /**
     * Indicates a voice profile has been deleted successfully.
     * @member ResultReason.DeletedVoiceProfile
     */ ResultReason[ResultReason["DeletedVoiceProfile"] = 17] = "DeletedVoiceProfile";
    /**
     * Indicates synthesis voices list has been successfully retrieved.
     * @member ResultReason.VoicesListRetrieved
     */ ResultReason[ResultReason["VoicesListRetrieved"] = 18] = "VoicesListRetrieved";
    /**
     * Indicates the transcription result contains hypothesis text and its translation(s) for
     * other participants in the conversation.
     * @member ResultReason.TranslatingParticipantSpeech
     */ ResultReason[ResultReason["TranslatingParticipantSpeech"] = 19] = "TranslatingParticipantSpeech";
    /**
     * Indicates the transcription result contains final text and corresponding translation(s)
     * for other participants in the conversation. Speech Recognition and Translation are now
     * complete for this phrase.
     * @member ResultReason.TranslatedParticipantSpeech
     */ ResultReason[ResultReason["TranslatedParticipantSpeech"] = 20] = "TranslatedParticipantSpeech";
    /**
     * <summary>
     * Indicates the transcription result contains the instant message and corresponding
     * translation(s).
     * @member ResultReason.TranslatedInstantMessage
     */ ResultReason[ResultReason["TranslatedInstantMessage"] = 21] = "TranslatedInstantMessage";
    /**
     * Indicates the transcription result contains the instant message for other participants
     * in the conversation and corresponding translation(s).
     * @member ResultReason.TranslatedParticipantInstantMessage
     */ ResultReason[ResultReason["TranslatedParticipantInstantMessage"] = 22] = "TranslatedParticipantInstantMessage";
})($eb03cb0355d088c8$var$ResultReason = module.exports.ResultReason || (module.exports.ResultReason = {}));

});

parcelRegister("5F3oF", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConfigImpl = module.exports.SpeechConfig = void 0;

var $imJeu = parcelRequire("imJeu");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Speech configuration.
 * @class SpeechConfig
 */ class $41f36aa6e41f9cf9$var$SpeechConfig {
    /**
     * Creates and initializes an instance.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * @member SpeechConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} The speech factory
     */ static fromSubscription(subscriptionKey, region) {
        $56OOs.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $56OOs.Contracts.throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $41f36aa6e41f9cf9$var$SpeechConfigImpl();
        speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_IntentRegion, region);
        speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
     * SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
     * and the effective language is "de-DE". Only the parameters that are not specified in the
     * endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        $56OOs.Contracts.throwIfNull(endpoint, "endpoint");
        const speechImpl = new $41f36aa6e41f9cf9$var$SpeechConfigImpl();
        speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        if (undefined !== subscriptionKey) speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromHost(hostName, subscriptionKey) {
        $56OOs.Contracts.throwIfNull(hostName, "hostName");
        const speechImpl = new $41f36aa6e41f9cf9$var$SpeechConfigImpl();
        speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech factory with specified initial authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
     * to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
     * the new token value will not apply to recognizers that have already been created. For recognizers
     * that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The initial authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromAuthorizationToken(authorizationToken, region) {
        $56OOs.Contracts.throwIfNull(authorizationToken, "authorizationToken");
        $56OOs.Contracts.throwIfNullOrWhitespace(region, "region");
        const speechImpl = new $41f36aa6e41f9cf9$var$SpeechConfigImpl();
        speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_Region, region);
        speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_IntentRegion, region);
        speechImpl.authorizationToken = authorizationToken;
        return speechImpl;
    }
    /**
     * Closes the configuration.
     * @member SpeechConfig.prototype.close
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    close() {}
}
module.exports.SpeechConfig = $41f36aa6e41f9cf9$var$SpeechConfig;
/**
 * @public
 * @class SpeechConfigImpl
 */ class $41f36aa6e41f9cf9$var$SpeechConfigImpl extends $41f36aa6e41f9cf9$var$SpeechConfig {
    constructor(){
        super();
        this.privProperties = new $hVlip.PropertyCollection();
        this.speechRecognitionLanguage = "en-US"; // Should we have a default?
        this.outputFormat = $hVlip.OutputFormat.Simple;
    }
    get properties() {
        return this.privProperties;
    }
    get endPoint() {
        return new URL(this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
        return this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_Key);
    }
    get region() {
        return this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region);
    }
    get authorizationToken() {
        return this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(value) {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    get speechRecognitionLanguage() {
        return this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(value) {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage, value);
    }
    get autoDetectSourceLanguages() {
        return this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(value) {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, value);
    }
    get outputFormat() {
        return $hVlip.OutputFormat[this.privProperties.getProperty($imJeu.OutputFormatPropertyName, undefined)];
    }
    set outputFormat(value) {
        this.privProperties.setProperty($imJeu.OutputFormatPropertyName, $hVlip.OutputFormat[value]);
    }
    get endpointId() {
        return this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId);
    }
    set endpointId(value) {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId, value);
    }
    setProperty(name, value) {
        $56OOs.Contracts.throwIfNull(value, "value");
        this.privProperties.setProperty(name, value);
    }
    getProperty(name, def) {
        return this.privProperties.getProperty(name, def);
    }
    setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privProperties.getProperty($imJeu.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty($imJeu.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    }
    setProfanity(profanity) {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceResponse_ProfanityOption, $hVlip.ProfanityOption[profanity]);
    }
    enableAudioLogging() {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privProperties.setProperty($imJeu.ForceDictationPropertyName, "true");
    }
    clone() {
        const ret = new $41f36aa6e41f9cf9$var$SpeechConfigImpl();
        ret.privProperties = this.privProperties.clone();
        return ret;
    }
    get speechSynthesisLanguage() {
        return this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(language) {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_SynthLanguage, language);
    }
    get speechSynthesisVoiceName() {
        return this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(voice) {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_SynthVoice, voice);
    }
    get speechSynthesisOutputFormat() {
        return $hVlip.SpeechSynthesisOutputFormat[this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
    }
    set speechSynthesisOutputFormat(format) {
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_SynthOutputFormat, $hVlip.SpeechSynthesisOutputFormat[format]);
    }
}
module.exports.SpeechConfigImpl = $41f36aa6e41f9cf9$var$SpeechConfigImpl;

});

parcelRegister("5EyVz", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechTranslationConfigImpl = module.exports.SpeechTranslationConfig = void 0;

var $imJeu = parcelRequire("imJeu");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Speech translation configuration.
 * @class SpeechTranslationConfig
 */ class $41dbc8124d33e351$var$SpeechTranslationConfig extends $hVlip.SpeechConfig {
    /**
     * Creates an instance of recognizer config.
     */ constructor(){
        super();
    }
    /**
     * Static instance of SpeechTranslationConfig returned by passing a subscription key and service region.
     * @member SpeechTranslationConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ static fromSubscription(subscriptionKey, region) {
        $56OOs.Contracts.throwIfNullOrWhitespace(subscriptionKey, "subscriptionKey");
        $56OOs.Contracts.throwIfNullOrWhitespace(region, "region");
        const ret = new $41dbc8124d33e351$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        ret.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    }
    /**
     * Static instance of SpeechTranslationConfig returned by passing authorization token and service region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by setting the property authorizationToken with a new
     * valid token. Otherwise, all the recognizers created by this SpeechTranslationConfig instance
     * will encounter errors during recognition.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply
     * to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechTranslationConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */ static fromAuthorizationToken(authorizationToken, region) {
        $56OOs.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $56OOs.Contracts.throwIfNullOrWhitespace(region, "region");
        const ret = new $41dbc8124d33e351$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        ret.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_Region, region);
        return ret;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */ static fromHost(hostName, subscriptionKey) {
        $56OOs.Contracts.throwIfNull(hostName, "hostName");
        const speechImpl = new $41dbc8124d33e351$var$SpeechTranslationConfigImpl();
        speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_Host, hostName.protocol + "//" + hostName.hostname + (hostName.port === "" ? "" : ":" + hostName.port));
        if (undefined !== subscriptionKey) speechImpl.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return speechImpl;
    }
    /**
     * Creates an instance of the speech translation config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or paramters.
     * Note: The query properties specified in the endpoint URL are not changed, even if they are
     * set by any other APIs. For example, if language is defined in the uri as query parameter
     * "language=de-DE", and also set by the speechRecognitionLanguage property, the language
     * setting in uri takes precedence, and the effective language is "de-DE".
     * Only the properties that are not specified in the endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechTranslationConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key.
     * @returns {SpeechTranslationConfig} A speech config instance.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        $56OOs.Contracts.throwIfNull(endpoint, "endpoint");
        $56OOs.Contracts.throwIfNull(subscriptionKey, "subscriptionKey");
        const ret = new $41dbc8124d33e351$var$SpeechTranslationConfigImpl();
        ret.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, endpoint.href);
        ret.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return ret;
    }
}
module.exports.SpeechTranslationConfig = $41dbc8124d33e351$var$SpeechTranslationConfig;
/**
 * @private
 * @class SpeechTranslationConfigImpl
 */ class $41dbc8124d33e351$var$SpeechTranslationConfigImpl extends $41dbc8124d33e351$var$SpeechTranslationConfig {
    constructor(){
        super();
        this.privSpeechProperties = new $hVlip.PropertyCollection();
        this.outputFormat = $hVlip.OutputFormat.Simple;
    }
    /**
     * Gets/Sets the authorization token.
     * If this is set, subscription key is ignored.
     * User needs to make sure the provided authorization token is valid and not expired.
     * @member SpeechTranslationConfigImpl.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - The authorization token.
     */ set authorizationToken(value) {
        $56OOs.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    /**
     * Sets the speech recognition language.
     * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The authorization token.
     */ set speechRecognitionLanguage(value) {
        $56OOs.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage, value);
    }
    /**
     * Gets the speech recognition language.
     * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @return {string} The speechRecognitionLanguage.
     */ get speechRecognitionLanguage() {
        return this.privSpeechProperties.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
    /**
     * @member SpeechTranslationConfigImpl.prototype.subscriptionKey
     * @function
     * @public
     */ get subscriptionKey() {
        return this.privSpeechProperties.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_Key]);
    }
    /**
     * Gets the output format
     * @member SpeechTranslationConfigImpl.prototype.outputFormat
     * @function
     * @public
     */ get outputFormat() {
        // eslint-disable-next-line
        return $hVlip.OutputFormat[this.privSpeechProperties.getProperty($imJeu.OutputFormatPropertyName, undefined)];
    }
    /**
     * Gets/Sets the output format
     * @member SpeechTranslationConfigImpl.prototype.outputFormat
     * @function
     * @public
     */ set outputFormat(value) {
        this.privSpeechProperties.setProperty($imJeu.OutputFormatPropertyName, $hVlip.OutputFormat[value]);
    }
    /**
     * Gets the endpoint id.
     * @member SpeechTranslationConfigImpl.prototype.endpointId
     * @function
     * @public
     */ get endpointId() {
        return this.privSpeechProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId);
    }
    /**
     * Gets/Sets the endpoint id.
     * @member SpeechTranslationConfigImpl.prototype.endpointId
     * @function
     * @public
     */ set endpointId(value) {
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId, value);
    }
    /**
     * Add a (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.addTargetLanguage
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */ addTargetLanguage(value) {
        $56OOs.Contracts.throwIfNullOrWhitespace(value, "value");
        const languages = this.targetLanguages;
        if (!languages.includes(value)) {
            languages.push(value);
            this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
        }
    }
    /**
     * Gets the (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.targetLanguages
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */ get targetLanguages() {
        if (this.privSpeechProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) return this.privSpeechProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
        else return [];
    }
    /**
     * Gets the voice name.
     * @member SpeechTranslationConfigImpl.prototype.voiceName
     * @function
     * @public
     */ get voiceName() {
        return this.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_TranslationVoice]);
    }
    /**
     * Gets/Sets the voice of the translated language, enable voice synthesis output.
     * @member SpeechTranslationConfigImpl.prototype.voiceName
     * @function
     * @public
     * @param {string} value - The name of the voice.
     */ set voiceName(value) {
        $56OOs.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationVoice, value);
    }
    /**
     * Provides the region.
     * @member SpeechTranslationConfigImpl.prototype.region
     * @function
     * @public
     * @returns {string} The region.
     */ get region() {
        return this.privSpeechProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region);
    }
    setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_ProxyHostName], proxyHostName);
        this.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_ProxyPort], proxyPort);
        this.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_ProxyUserName], proxyUserName);
        this.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_ProxyPassword], proxyPassword);
    }
    /**
     * Gets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {string} name - The name of the property.
     * @param {string} def - The default value of the property in case it is not set.
     * @returns {string} The value of the property.
     */ getProperty(name, def) {
        return this.privSpeechProperties.getProperty(name, def);
    }
    /**
     * Gets/Sets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {string | PropertyId} name - The name of the property to set.
     * @param {string} value - The value of the property.
     */ setProperty(name, value) {
        this.privSpeechProperties.setProperty(name, value);
    }
    /**
     * Provides access to custom properties.
     * @member SpeechTranslationConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */ get properties() {
        return this.privSpeechProperties;
    }
    /**
     * Dispose of associated resources.
     * @member SpeechTranslationConfigImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privSpeechProperties.getProperty($imJeu.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privSpeechProperties.setProperty($imJeu.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    }
    setProfanity(profanity) {
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceResponse_ProfanityOption, $hVlip.ProfanityOption[profanity]);
    }
    enableAudioLogging() {
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
        this.privSpeechProperties.setProperty($imJeu.ForceDictationPropertyName, "true");
    }
    get speechSynthesisLanguage() {
        return this.privSpeechProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(language) {
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_SynthLanguage, language);
    }
    get speechSynthesisVoiceName() {
        return this.privSpeechProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(voice) {
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_SynthVoice, voice);
    }
    get speechSynthesisOutputFormat() {
        // eslint-disable-next-line
        return $hVlip.SpeechSynthesisOutputFormat[this.privSpeechProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)];
    }
    set speechSynthesisOutputFormat(format) {
        this.privSpeechProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_SynthOutputFormat, $hVlip.SpeechSynthesisOutputFormat[format]);
    }
}
module.exports.SpeechTranslationConfigImpl = $41dbc8124d33e351$var$SpeechTranslationConfigImpl;

});

parcelRegister("bNuGp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyCollection = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Represents collection of properties and their values.
 * @class PropertyCollection
 */ class $896c12530ce0489f$var$PropertyCollection {
    constructor(){
        this.privKeys = [];
        this.privValues = [];
    }
    /**
     * Returns the property value in type String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member PropertyCollection.prototype.getProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string | number | boolean} def - The default value which is returned if the parameter
     * is not available in the collection.
     * @returns {string} value of the parameter.
     */ getProperty(key, def) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $hVlip.PropertyId[key];
        for(let n = 0; n < this.privKeys.length; n++){
            if (this.privKeys[n] === keyToUse) return this.privValues[n];
        }
        if (def === undefined) return undefined;
        return String(def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member PropertyCollection.prototype.setProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ setProperty(key, value) {
        let keyToUse;
        if (typeof key === "string") keyToUse = key;
        else keyToUse = $hVlip.PropertyId[key];
        for(let n = 0; n < this.privKeys.length; n++)if (this.privKeys[n] === keyToUse) {
            this.privValues[n] = value;
            return;
        }
        this.privKeys.push(keyToUse);
        this.privValues.push(value);
    }
    /**
     * Clones the collection.
     * @member PropertyCollection.prototype.clone
     * @function
     * @public
     * @returns {PropertyCollection} A copy of the collection.
     */ clone() {
        const clonedMap = new $896c12530ce0489f$var$PropertyCollection();
        for(let n = 0; n < this.privKeys.length; n++){
            clonedMap.privKeys.push(this.privKeys[n]);
            clonedMap.privValues.push(this.privValues[n]);
        }
        return clonedMap;
    }
    /**
     * Merges this set of properties into another, no overwrites.
     * @member PropertyCollection.prototype.mergeTo
     * @function
     * @public
     * @param {PropertyCollection}  destinationCollection - The collection to merge into.
     */ mergeTo(destinationCollection) {
        this.privKeys.forEach((key)=>{
            if (destinationCollection.getProperty(key, undefined) === undefined) {
                const value = this.getProperty(key);
                destinationCollection.setProperty(key, value);
            }
        });
    }
    /**
     * Get the keys in Property Collection.
     * @member PropertyCollection.prototype.keys
     * @function
     * @public
     * @returns {string []} Keys in the collection.
     */ get keys() {
        return this.privKeys;
    }
}
module.exports.PropertyCollection = $896c12530ce0489f$var$PropertyCollection;

});

parcelRegister("feDHl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyId = void 0;
/**
 * Defines speech property ids.
 * @class PropertyId
 */ var $b176f507e943e617$var$PropertyId;
(function(PropertyId) {
    /**
     * The Cognitive Services Speech Service subscription Key. If you are using an intent recognizer, you need to
     * specify the LUIS endpoint key for your particular LUIS app. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]].
     * @member PropertyId.SpeechServiceConnection_Key
     */ PropertyId[PropertyId["SpeechServiceConnection_Key"] = 0] = "SpeechServiceConnection_Key";
    /**
     * The Cognitive Services Speech Service endpoint (url). Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.fromEndpoint]].
     * NOTE: This endpoint is not the same as the endpoint used to obtain an access token.
     * @member PropertyId.SpeechServiceConnection_Endpoint
     */ PropertyId[PropertyId["SpeechServiceConnection_Endpoint"] = 1] = "SpeechServiceConnection_Endpoint";
    /**
     * The Cognitive Services Speech Service region. Under normal circumstances, you shouldn't have to
     * use this property directly.
     * Instead, use [[SpeechConfig.fromSubscription]], [[SpeechConfig.fromEndpoint]], [[SpeechConfig.fromAuthorizationToken]].
     * @member PropertyId.SpeechServiceConnection_Region
     */ PropertyId[PropertyId["SpeechServiceConnection_Region"] = 2] = "SpeechServiceConnection_Region";
    /**
     * The Cognitive Services Speech Service authorization token (aka access token). Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromAuthorizationToken]], [[SpeechRecognizer.authorizationToken]],
     * [[IntentRecognizer.authorizationToken]], [[TranslationRecognizer.authorizationToken]], [[SpeakerRecognizer.authorizationToken]].
     * @member PropertyId.SpeechServiceAuthorization_Token
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Token"] = 3] = "SpeechServiceAuthorization_Token";
    /**
     * The Cognitive Services Speech Service authorization type. Currently unused.
     * @member PropertyId.SpeechServiceAuthorization_Type
     */ PropertyId[PropertyId["SpeechServiceAuthorization_Type"] = 4] = "SpeechServiceAuthorization_Type";
    /**
     * The Cognitive Services Speech Service endpoint id. Under normal circumstances, you shouldn't
     * have to use this property directly.
     * Instead, use [[SpeechConfig.endpointId]].
     * NOTE: The endpoint id is available in the Speech Portal, listed under Endpoint Details.
     * @member PropertyId.SpeechServiceConnection_EndpointId
     */ PropertyId[PropertyId["SpeechServiceConnection_EndpointId"] = 5] = "SpeechServiceConnection_EndpointId";
    /**
     * The list of comma separated languages (BCP-47 format) used as target translation languages. Under normal circumstances,
     * you shouldn't have to use this property directly.
     * Instead use [[SpeechTranslationConfig.addTargetLanguage]],
     * [[SpeechTranslationConfig.targetLanguages]], [[TranslationRecognizer.targetLanguages]].
     * @member PropertyId.SpeechServiceConnection_TranslationToLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationToLanguages"] = 6] = "SpeechServiceConnection_TranslationToLanguages";
    /**
     * The name of the Cognitive Service Text to Speech Service Voice. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead, use [[SpeechTranslationConfig.voiceName]].
     * NOTE: Valid voice names can be found <a href="https://aka.ms/csspeech/voicenames">here</a>.
     * @member PropertyId.SpeechServiceConnection_TranslationVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationVoice"] = 7] = "SpeechServiceConnection_TranslationVoice";
    /**
     * Translation features.
     * @member PropertyId.SpeechServiceConnection_TranslationFeatures
     */ PropertyId[PropertyId["SpeechServiceConnection_TranslationFeatures"] = 8] = "SpeechServiceConnection_TranslationFeatures";
    /**
     * The Language Understanding Service Region. Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[LanguageUnderstandingModel]].
     * @member PropertyId.SpeechServiceConnection_IntentRegion
     */ PropertyId[PropertyId["SpeechServiceConnection_IntentRegion"] = 9] = "SpeechServiceConnection_IntentRegion";
    /**
     * The host name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyHostName"] = 10] = "SpeechServiceConnection_ProxyHostName";
    /**
     * The port of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPort"] = 11] = "SpeechServiceConnection_ProxyPort";
    /**
     * The user name of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyUserName"] = 12] = "SpeechServiceConnection_ProxyUserName";
    /**
     * The password of the proxy server used to connect to the Cognitive Services Speech Service. Only relevant in Node.js environments.
     * You shouldn't have to use this property directly.
     * Instead use <see cref="SpeechConfig.SetProxy(string,int,string,string)"/>.
     * Added in version 1.4.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_ProxyPassword"] = 13] = "SpeechServiceConnection_ProxyPassword";
    /**
     * The Cognitive Services Speech Service recognition Mode. Can be "INTERACTIVE", "CONVERSATION", "DICTATION".
     * This property is intended to be read-only. The SDK is using it internally.
     * @member PropertyId.SpeechServiceConnection_RecoMode
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoMode"] = 14] = "SpeechServiceConnection_RecoMode";
    /**
     * The spoken language to be recognized (in BCP-47 format). Under normal circumstances, you shouldn't have to use this property
     * directly.
     * Instead, use [[SpeechConfig.speechRecognitionLanguage]].
     * @member PropertyId.SpeechServiceConnection_RecoLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_RecoLanguage"] = 15] = "SpeechServiceConnection_RecoLanguage";
    /**
     * The session id. This id is a universally unique identifier (aka UUID) representing a specific binding of an audio input stream
     * and the underlying speech recognition instance to which it is bound. Under normal circumstances, you shouldn't have to use this
     * property directly.
     * Instead use [[SessionEventArgs.sessionId]].
     * @member PropertyId.Speech_SessionId
     */ PropertyId[PropertyId["Speech_SessionId"] = 16] = "Speech_SessionId";
    /**
     * The spoken language to be synthesized (e.g. en-US)
     * @member PropertyId.SpeechServiceConnection_SynthLanguage
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthLanguage"] = 17] = "SpeechServiceConnection_SynthLanguage";
    /**
     * The name of the TTS voice to be used for speech synthesis
     * @member PropertyId.SpeechServiceConnection_SynthVoice
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthVoice"] = 18] = "SpeechServiceConnection_SynthVoice";
    /**
     * The string to specify TTS output audio format
     * @member PropertyId.SpeechServiceConnection_SynthOutputFormat
     */ PropertyId[PropertyId["SpeechServiceConnection_SynthOutputFormat"] = 19] = "SpeechServiceConnection_SynthOutputFormat";
    /**
     * The list of comma separated languages used as possible source languages
     * Added in version 1.13.0
     * @member PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages
     */ PropertyId[PropertyId["SpeechServiceConnection_AutoDetectSourceLanguages"] = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages";
    /**
     * The requested Cognitive Services Speech Service response output format (simple or detailed). Under normal circumstances, you shouldn't have
     * to use this property directly.
     * Instead use [[SpeechConfig.outputFormat]].
     * @member PropertyId.SpeechServiceResponse_RequestDetailedResultTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestDetailedResultTrueFalse"] = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse";
    /**
     * The requested Cognitive Services Speech Service response output profanity level. Currently unused.
     * @member PropertyId.SpeechServiceResponse_RequestProfanityFilterTrueFalse
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestProfanityFilterTrueFalse"] = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse";
    /**
     * The Cognitive Services Speech Service response output (in JSON format). This property is available on recognition result objects only.
     * @member PropertyId.SpeechServiceResponse_JsonResult
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonResult"] = 23] = "SpeechServiceResponse_JsonResult";
    /**
     * The Cognitive Services Speech Service error details (in JSON format). Under normal circumstances, you shouldn't have to
     * use this property directly. Instead use [[CancellationDetails.errorDetails]].
     * @member PropertyId.SpeechServiceResponse_JsonErrorDetails
     */ PropertyId[PropertyId["SpeechServiceResponse_JsonErrorDetails"] = 24] = "SpeechServiceResponse_JsonErrorDetails";
    /**
     * The cancellation reason. Currently unused.
     * @member PropertyId.CancellationDetails_Reason
     */ PropertyId[PropertyId["CancellationDetails_Reason"] = 25] = "CancellationDetails_Reason";
    /**
     * The cancellation text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonText
     */ PropertyId[PropertyId["CancellationDetails_ReasonText"] = 26] = "CancellationDetails_ReasonText";
    /**
     * The Cancellation detailed text. Currently unused.
     * @member PropertyId.CancellationDetails_ReasonDetailedText
     */ PropertyId[PropertyId["CancellationDetails_ReasonDetailedText"] = 27] = "CancellationDetails_ReasonDetailedText";
    /**
     * The Language Understanding Service response output (in JSON format). Available via [[IntentRecognitionResult]]
     * @member PropertyId.LanguageUnderstandingServiceResponse_JsonResult
     */ PropertyId[PropertyId["LanguageUnderstandingServiceResponse_JsonResult"] = 28] = "LanguageUnderstandingServiceResponse_JsonResult";
    /**
     * The URL string built from speech configuration.
     * This property is intended to be read-only. The SDK is using it internally.
     * NOTE: Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceConnection_Url"] = 29] = "SpeechServiceConnection_Url";
    /**
     * The initial silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_InitialSilenceTimeoutMs"] = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs";
    /**
     * The end silence timeout value (in milliseconds) used by the service.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EndSilenceTimeoutMs"] = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs";
    /**
     * A duration of detected silence, measured in milliseconds, after which speech-to-text will determine a spoken
     * phrase has ended and generate a final Recognized result. Configuring this timeout may be helpful in situations
     * where spoken input is significantly faster or slower than usual and default segmentation behavior consistently
     * yields results that are too long or too short. Segmentation timeout values that are inappropriately high or low
     * can negatively affect speech-to-text accuracy; this property should be carefully configured and the resulting
     * behavior should be thoroughly validated as intended.
     *
     * For more information about timeout configuration that includes discussion of default behaviors, please visit
     * https://aka.ms/csspeech/timeouts.
     *
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["Speech_SegmentationSilenceTimeoutMs"] = 32] = "Speech_SegmentationSilenceTimeoutMs";
    /**
     * A boolean value specifying whether audio logging is enabled in the service or not.
     * Audio and content logs are stored either in Microsoft-owned storage, or in your own storage account linked
     * to your Cognitive Services subscription (Bring Your Own Storage (BYOS) enabled Speech resource).
     * The logs will be removed after 30 days.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceConnection_EnableAudioLogging"] = 33] = "SpeechServiceConnection_EnableAudioLogging";
    /**
     * The speech service connection language identifier mode.
     * Can be "AtStart" (the default), or "Continuous". See Language
     * Identification document https://aka.ms/speech/lid?pivots=programming-language-javascript
     * for more details.
     * Added in 1.25.0
     **/ PropertyId[PropertyId["SpeechServiceConnection_LanguageIdMode"] = 34] = "SpeechServiceConnection_LanguageIdMode";
    /**
     * A string value representing the desired endpoint version to target for Speech Recognition.
     * Added in version 1.21.0
     */ PropertyId[PropertyId["SpeechServiceConnection_RecognitionEndpointVersion"] = 35] = "SpeechServiceConnection_RecognitionEndpointVersion";
    /**
    /**
     * A string value the current speaker recognition scenario/mode (TextIndependentIdentification, etc.).
     * Added in version 1.23.0
     */ PropertyId[PropertyId["SpeechServiceConnection_SpeakerIdMode"] = 36] = "SpeechServiceConnection_SpeakerIdMode";
    /**
     * The requested Cognitive Services Speech Service response output profanity setting.
     * Allowed values are "masked", "removed", and "raw".
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_ProfanityOption"] = 37] = "SpeechServiceResponse_ProfanityOption";
    /**
     * A string value specifying which post processing option should be used by service.
     * Allowed values are "TrueText".
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_PostProcessingOption"] = 38] = "SpeechServiceResponse_PostProcessingOption";
    /**
     * A boolean value specifying whether to include word-level timestamps in the response result.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordLevelTimestamps"] = 39] = "SpeechServiceResponse_RequestWordLevelTimestamps";
    /**
     * The number of times a word has to be in partial results to be returned.
     * Added in version 1.7.0
     */ PropertyId[PropertyId["SpeechServiceResponse_StablePartialResultThreshold"] = 40] = "SpeechServiceResponse_StablePartialResultThreshold";
    /**
     * A string value specifying the output format option in the response result. Internal use only.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_OutputFormatOption"] = 41] = "SpeechServiceResponse_OutputFormatOption";
    /**
     * A boolean value to request for stabilizing translation partial results by omitting words in the end.
     * Added in version 1.7.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_TranslationRequestStablePartialResult"] = 42] = "SpeechServiceResponse_TranslationRequestStablePartialResult";
    /**
     * A boolean value specifying whether to request WordBoundary events.
     * @member PropertyId.SpeechServiceResponse_RequestWordBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestWordBoundary"] = 43] = "SpeechServiceResponse_RequestWordBoundary";
    /**
     * A boolean value specifying whether to request punctuation boundary in WordBoundary Events. Default is true.
     * @member PropertyId.SpeechServiceResponse_RequestPunctuationBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestPunctuationBoundary"] = 44] = "SpeechServiceResponse_RequestPunctuationBoundary";
    /**
     * A boolean value specifying whether to request sentence boundary in WordBoundary Events. Default is false.
     * @member PropertyId.SpeechServiceResponse_RequestSentenceBoundary
     * Added in version 1.21.0.
     */ PropertyId[PropertyId["SpeechServiceResponse_RequestSentenceBoundary"] = 45] = "SpeechServiceResponse_RequestSentenceBoundary";
    /**
     * Identifier used to connect to the backend service.
     * @member PropertyId.Conversation_ApplicationId
     */ PropertyId[PropertyId["Conversation_ApplicationId"] = 46] = "Conversation_ApplicationId";
    /**
     * Type of dialog backend to connect to.
     * @member PropertyId.Conversation_DialogType
     */ PropertyId[PropertyId["Conversation_DialogType"] = 47] = "Conversation_DialogType";
    /**
     * Silence timeout for listening
     * @member PropertyId.Conversation_Initial_Silence_Timeout
     */ PropertyId[PropertyId["Conversation_Initial_Silence_Timeout"] = 48] = "Conversation_Initial_Silence_Timeout";
    /**
     * From Id to add to speech recognition activities.
     * @member PropertyId.Conversation_From_Id
     */ PropertyId[PropertyId["Conversation_From_Id"] = 49] = "Conversation_From_Id";
    /**
     * ConversationId for the session.
     * @member PropertyId.Conversation_Conversation_Id
     */ PropertyId[PropertyId["Conversation_Conversation_Id"] = 50] = "Conversation_Conversation_Id";
    /**
     * Comma separated list of custom voice deployment ids.
     * @member PropertyId.Conversation_Custom_Voice_Deployment_Ids
     */ PropertyId[PropertyId["Conversation_Custom_Voice_Deployment_Ids"] = 51] = "Conversation_Custom_Voice_Deployment_Ids";
    /**
     * Speech activity template, stamp properties from the template on the activity generated by the service for speech.
     * @member PropertyId.Conversation_Speech_Activity_Template
     * Added in version 1.10.0.
     */ PropertyId[PropertyId["Conversation_Speech_Activity_Template"] = 52] = "Conversation_Speech_Activity_Template";
    /**
     * Enables or disables the receipt of turn status messages as obtained on the turnStatusReceived event.
     * @member PropertyId.Conversation_Request_Bot_Status_Messages
     * Added in version 1.15.0.
     */ PropertyId[PropertyId["Conversation_Request_Bot_Status_Messages"] = 53] = "Conversation_Request_Bot_Status_Messages";
    /**
     * Specifies the connection ID to be provided in the Agent configuration message, e.g. a Direct Line token for
     * channel authentication.
     * Added in version 1.15.1.
     */ PropertyId[PropertyId["Conversation_Agent_Connection_Id"] = 54] = "Conversation_Agent_Connection_Id";
    /**
     * The Cognitive Services Speech Service host (url). Under normal circumstances, you shouldn't have to use this property directly.
     * Instead, use [[SpeechConfig.fromHost]].
     */ PropertyId[PropertyId["SpeechServiceConnection_Host"] = 55] = "SpeechServiceConnection_Host";
    /**
     * Set the host for service calls to the Conversation Translator REST management and websocket calls.
     */ PropertyId[PropertyId["ConversationTranslator_Host"] = 56] = "ConversationTranslator_Host";
    /**
     * Optionally set the the host's display name.
     * Used when joining a conversation.
     */ PropertyId[PropertyId["ConversationTranslator_Name"] = 57] = "ConversationTranslator_Name";
    /**
     * Optionally set a value for the X-CorrelationId request header.
     * Used for troubleshooting errors in the server logs. It should be a valid guid.
     */ PropertyId[PropertyId["ConversationTranslator_CorrelationId"] = 58] = "ConversationTranslator_CorrelationId";
    /**
     * Set the conversation token to be sent to the speech service. This enables the
     * service to service call from the speech service to the Conversation Translator service for relaying
     * recognitions. For internal use.
     */ PropertyId[PropertyId["ConversationTranslator_Token"] = 59] = "ConversationTranslator_Token";
    /**
     * The reference text of the audio for pronunciation evaluation.
     * For this and the following pronunciation assessment parameters, see
     * https://docs.microsoft.com/azure/cognitive-services/speech-service/rest-speech-to-text#pronunciation-assessment-parameters for details.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_ReferenceText"] = 60] = "PronunciationAssessment_ReferenceText";
    /**
     * The point system for pronunciation score calibration (FivePoint or HundredMark).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_GradingSystem"] = 61] = "PronunciationAssessment_GradingSystem";
    /**
     * The pronunciation evaluation granularity (Phoneme, Word, or FullText).
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Granularity"] = 62] = "PronunciationAssessment_Granularity";
    /**
     * Defines if enable miscue calculation.
     * With this enabled, the pronounced words will be compared to the reference text,
     * and will be marked with omission/insertion based on the comparison. The default setting is False.
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_EnableMiscue"] = 63] = "PronunciationAssessment_EnableMiscue";
    /**
     * The json string of pronunciation assessment parameters
     * Under normal circumstances, you shouldn't have to use this property directly.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Json"] = 64] = "PronunciationAssessment_Json";
    /**
     * Pronunciation assessment parameters.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.15.0
     */ PropertyId[PropertyId["PronunciationAssessment_Params"] = 65] = "PronunciationAssessment_Params";
    /**
     * Version of Speaker Recognition API to use.
     * Added in version 1.18.0
     */ PropertyId[PropertyId["SpeakerRecognition_Api_Version"] = 66] = "SpeakerRecognition_Api_Version";
    /**
     * Specifies whether to allow load of data URL for web worker
     * Allowed values are "off" and "on". Default is "on".
     * Added in version 1.32.0
     */ PropertyId[PropertyId["WebWorkerLoadType"] = 67] = "WebWorkerLoadType";
    /**
     * Talking avatar service WebRTC session description protocol.
     * This property is intended to be read-only. The SDK is using it internally.
     * Added in version 1.33.0
     */ PropertyId[PropertyId["TalkingAvatarService_WebRTC_SDP"] = 68] = "TalkingAvatarService_WebRTC_SDP";
})($b176f507e943e617$var$PropertyId = module.exports.PropertyId || (module.exports.PropertyId = {}));

});

parcelRegister("kibP0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Defines the base class Recognizer which mainly contains common event handlers.
 * @class Recognizer
 */ class $ec5ea89a39ef510f$var$Recognizer {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
     * @param {PropertyCollection} properties - A set of properties to set on the recognizer
     * @param {IConnectionFactory} connectionFactory - The factory class used to create a custom IConnection for the recognizer
     */ constructor(audioConfig, properties, connectionFactory){
        this.audioConfig = audioConfig !== undefined ? audioConfig : $hVlip.AudioConfig.fromDefaultMicrophoneInput();
        this.privDisposed = false;
        this.privProperties = properties.clone();
        this.privConnectionFactory = connectionFactory;
        this.implCommonRecognizerSetup();
    }
    /**
     * Dispose of associated resources.
     * @member Recognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposed);
        $3wpON.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privReco;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Recognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ async dispose(disposing) {
        if (this.privDisposed) return;
        this.privDisposed = true;
        if (disposing) {
            if (this.privReco) {
                await this.privReco.audioSource.turnOff();
                await this.privReco.dispose();
            }
        }
    }
    /**
     * This method returns the current state of the telemetry setting.
     * @member Recognizer.prototype.telemetryEnabled
     * @function
     * @public
     * @returns true if the telemetry is enabled, false otherwise.
     */ static get telemetryEnabled() {
        return $imJeu.ServiceRecognizerBase.telemetryDataEnabled;
    }
    /**
     * This method globally enables or disables telemetry.
     * @member Recognizer.prototype.enableTelemetry
     * @function
     * @public
     * @param enabled - Global setting for telemetry collection.
     * If set to true, telemetry information like microphone errors,
     * recognition errors are collected and sent to Microsoft.
     * If set to false, no telemetry is sent to Microsoft.
     */ static enableTelemetry(enabled) {
        $imJeu.ServiceRecognizerBase.telemetryDataEnabled = enabled;
    }
    // Does the generic recognizer setup that is common across all recognizer types.
    implCommonRecognizerSetup() {
        let osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        let osName = "unknown";
        let osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        const recognizerConfig = this.createRecognizerConfig(new $imJeu.SpeechServiceConfig(new $imJeu.Context(new $imJeu.OS(osPlatform, osName, osVersion))));
        this.privReco = this.createServiceRecognizer($ec5ea89a39ef510f$var$Recognizer.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, recognizerConfig);
    }
    async recognizeOnceAsyncImpl(recognitionMode) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposed);
        const ret = new $3wpON.Deferred();
        await this.implRecognizerStop();
        await this.privReco.recognize(recognitionMode, ret.resolve, ret.reject);
        const result = await ret.promise;
        await this.implRecognizerStop();
        return result;
    }
    async startContinuousRecognitionAsyncImpl(recognitionMode) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposed);
        await this.implRecognizerStop();
        await this.privReco.recognize(recognitionMode, undefined, undefined);
    }
    async stopContinuousRecognitionAsyncImpl() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposed);
        await this.implRecognizerStop();
    }
    async implRecognizerStop() {
        if (this.privReco) await this.privReco.stopRecognizing();
        return;
    }
    static getAuthFromProperties(properties) {
        const subscriptionKey = properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_Key, undefined);
        const authentication = subscriptionKey && subscriptionKey !== "" ? new $imJeu.CognitiveSubscriptionKeyAuthentication(subscriptionKey) : new $imJeu.CognitiveTokenAuthentication(()=>{
            const authorizationToken = properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, ()=>{
            const authorizationToken = properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        return authentication;
    }
}
module.exports.Recognizer = $ec5ea89a39ef510f$var$Recognizer;

});

parcelRegister("9DPT6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechRecognizer = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Performs speech recognition from microphone, file, or other audio input streams, and gets transcribed text as result.
 * @class SpeechRecognizer
 */ class $7050016bdd3a35ad$var$SpeechRecognizer extends $hVlip.Recognizer {
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        const speechConfigImpl = speechConfig;
        $56OOs.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        $56OOs.Contracts.throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage), $hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechConfigImpl.properties, new $imJeu.SpeechConnectionFactory());
        this.privDisposedRecognizer = false;
    }
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        const recognizer = new $7050016bdd3a35ad$var$SpeechRecognizer(speechConfig, audioConfig);
        return recognizer;
    }
    /**
     * Gets the endpoint id of a customized speech model that is used for speech recognition.
     * @member SpeechRecognizer.prototype.endpointId
     * @function
     * @public
     * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
     */ get endpointId() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $56OOs.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * Gets the spoken language of recognition.
     * @member SpeechRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */ get speechRecognitionLanguage() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of recognition.
     * @member SpeechRecognizer.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of recognition.
     */ get outputFormat() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        if (this.properties.getProperty($imJeu.OutputFormatPropertyName, $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]) === $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]) return $hVlip.OutputFormat.Simple;
        else return $hVlip.OutputFormat.Detailed;
    }
    /**
     * The collection of properties and their values defined for this SpeechRecognizer.
     * @member SpeechRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Starts speech recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition
     * like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member SpeechRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the SpeechRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ recognizeOnceAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($imJeu.RecognitionMode.Interactive), cb, err);
    }
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startContinuousRecognitionAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($imJeu.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops continuous speech recognition.
     * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopContinuousRecognitionAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * Starts speech recognition with keyword spotting, until
     * stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model The keyword recognition model that
     * specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startKeywordRecognitionAsync(model, cb, err) {
        $56OOs.Contracts.throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    }
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopKeywordRecognitionAsync(cb) {
        if (!!cb) cb();
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member SpeechRecognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $3wpON.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (disposing) {
            this.privDisposedRecognizer = true;
            await this.implRecognizerStop();
        }
        await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $imJeu.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new $imJeu.SpeechServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
}
module.exports.SpeechRecognizer = $7050016bdd3a35ad$var$SpeechRecognizer;

});

parcelRegister("dbgTD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognizer = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Intent recognizer.
 * @class
 */ class $998968ad9b4775a1$var$IntentRecognizer extends $hVlip.Recognizer {
    /**
     * Initializes an instance of the IntentRecognizer.
     * @constructor
     * @param {SpeechConfig} speechConfig - The set of configuration properties.
     * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        $56OOs.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        const configImpl = speechConfig;
        $56OOs.Contracts.throwIfNullOrUndefined(configImpl, "speechConfig");
        super(audioConfig, configImpl.properties, new $imJeu.IntentConnectionFactory());
        this.privAddedIntents = [];
        this.privAddedLmIntents = {};
        this.privDisposedIntentRecognizer = false;
        this.privProperties = configImpl.properties;
        $56OOs.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage), $hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
    /**
     * Gets the spoken language of recognition.
     * @member IntentRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} the spoken language of recognition.
     */ get speechRecognitionLanguage() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member IntentRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key for the Intent recognizer.
     * @member IntentRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - Authorization token.
     */ set authorizationToken(value) {
        this.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    /**
     * The collection of properties and their values defined for this IntentRecognizer.
     * @member IntentRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their
     * values defined for this IntentRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Starts intent recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text and intent as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition like command or query.
     * For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member IntentRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the recognition has finished with an IntentRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */ recognizeOnceAsync(cb, err) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        if (Object.keys(this.privAddedLmIntents).length !== 0 || undefined !== this.privUmbrellaIntent) {
            const context = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", context.Intent);
            this.privReco.dynamicGrammar.addReferenceGrammar(context.ReferenceGrammars);
            const intentReco = this.privReco;
            intentReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $3wpON.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($imJeu.RecognitionMode.Interactive), cb, err);
    }
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member IntentRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startContinuousRecognitionAsync(cb, err) {
        if (Object.keys(this.privAddedLmIntents).length !== 0 || undefined !== this.privUmbrellaIntent) {
            const context = this.buildSpeechContext();
            this.privReco.speechContext.setSection("intent", context.Intent);
            this.privReco.dynamicGrammar.addReferenceGrammar(context.ReferenceGrammars);
            const intentReco = this.privReco;
            intentReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
        }
        $3wpON.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($imJeu.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops continuous intent recognition.
     * @member IntentRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopContinuousRecognitionAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * Starts speech recognition with keyword spotting, until stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     * This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model - The keyword recognition model that specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */ startKeywordRecognitionAsync(model, cb, err) {
        $56OOs.Contracts.throwIfNull(model, "model");
        if (!!err) err("Not yet implemented.");
    }
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     * This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopKeywordRecognitionAsync(cb, err) {
        if (!!cb) try {
            cb();
        } catch (e) {
            if (!!err) err(e);
        }
    }
    /**
     * Adds a phrase that should be recognized as intent.
     * @member IntentRecognizer.prototype.addIntent
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent to be recognized.
     * @param {string} phrase - A String that specifies the phrase representing the intent.
     */ addIntent(simplePhrase, intentId) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $56OOs.Contracts.throwIfNullOrWhitespace(intentId, "intentId");
        $56OOs.Contracts.throwIfNullOrWhitespace(simplePhrase, "simplePhrase");
        this.privAddedIntents.push([
            intentId,
            simplePhrase
        ]);
    }
    /**
     * Adds an intent from Language Understanding service for recognition.
     * @member IntentRecognizer.prototype.addIntentWithLanguageModel
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent
     * to be recognized. Ignored if intentName is empty.
     * @param {string} model - The intent model from Language Understanding service.
     * @param {string} intentName - The intent name defined in the intent model. If it
     * is empty, all intent names defined in the model will be added.
     */ addIntentWithLanguageModel(intentId, model, intentName) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $56OOs.Contracts.throwIfNullOrWhitespace(intentId, "intentId");
        $56OOs.Contracts.throwIfNull(model, "model");
        const modelImpl = model;
        $56OOs.Contracts.throwIfNullOrWhitespace(modelImpl.appId, "model.appId");
        this.privAddedLmIntents[intentId] = new $imJeu.AddedLmIntent(modelImpl, intentName);
    }
    /**
     * @summary Adds all intents from the specified Language Understanding Model.
     * @member IntentRecognizer.prototype.addAllIntents
     * @function
     * @public
     * @function
     * @public
     * @param {LanguageUnderstandingModel} model - The language understanding model containing the intents.
     * @param {string} intentId - A custom id String to be returned in the IntentRecognitionResult's getIntentId() method.
     */ addAllIntents(model, intentId) {
        $56OOs.Contracts.throwIfNull(model, "model");
        const modelImpl = model;
        $56OOs.Contracts.throwIfNullOrWhitespace(modelImpl.appId, "model.appId");
        this.privUmbrellaIntent = new $imJeu.AddedLmIntent(modelImpl, intentId);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member IntentRecognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer);
        $3wpON.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    createRecognizerConfig(speechConfig) {
        return new $imJeu.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioImpl = audioConfig;
        return new $imJeu.IntentServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    }
    async dispose(disposing) {
        if (this.privDisposedIntentRecognizer) return;
        if (disposing) {
            this.privDisposedIntentRecognizer = true;
            await super.dispose(disposing);
        }
    }
    buildSpeechContext() {
        let appId;
        let region;
        let subscriptionKey;
        const refGrammers = [];
        if (undefined !== this.privUmbrellaIntent) {
            appId = this.privUmbrellaIntent.modelImpl.appId;
            region = this.privUmbrellaIntent.modelImpl.region;
            subscriptionKey = this.privUmbrellaIntent.modelImpl.subscriptionKey;
        }
        // Build the reference grammer array.
        for (const intentId of Object.keys(this.privAddedLmIntents)){
            const addedLmIntent = this.privAddedLmIntents[intentId];
            // validate all the same model, region, and key...
            if (appId === undefined) appId = addedLmIntent.modelImpl.appId;
            else {
                if (appId !== addedLmIntent.modelImpl.appId) throw new Error("Intents must all be from the same LUIS model");
            }
            if (region === undefined) region = addedLmIntent.modelImpl.region;
            else {
                if (region !== addedLmIntent.modelImpl.region) throw new Error("Intents must all be from the same LUIS model in a single region");
            }
            if (subscriptionKey === undefined) subscriptionKey = addedLmIntent.modelImpl.subscriptionKey;
            else {
                if (subscriptionKey !== addedLmIntent.modelImpl.subscriptionKey) throw new Error("Intents must all use the same subscription key");
            }
            const grammer = "luis/" + appId + "-PRODUCTION#" + intentId;
            refGrammers.push(grammer);
        }
        return {
            Intent: {
                id: appId,
                key: subscriptionKey === undefined ? this.privProperties.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_Key]) : subscriptionKey,
                provider: "LUIS"
            },
            ReferenceGrammars: undefined === this.privUmbrellaIntent ? refGrammers : [
                "luis/" + appId + "-PRODUCTION"
            ]
        };
    }
}
module.exports.IntentRecognizer = $998968ad9b4775a1$var$IntentRecognizer;

});

parcelRegister("c3AkX", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileType = void 0;
/**
 * Output format
 * @class VoiceProfileType
 */ var $8c71f39f4edc0ee0$var$VoiceProfileType;
(function(VoiceProfileType) {
    /**
     * Text independent speaker identification
     * @member VoiceProfileType.TextIndependentIdentification
     */ VoiceProfileType[VoiceProfileType["TextIndependentIdentification"] = 0] = "TextIndependentIdentification";
    /**
     * Text dependent speaker verification
     * @member VoiceProfileType.TextDependentVerification
     */ VoiceProfileType[VoiceProfileType["TextDependentVerification"] = 1] = "TextDependentVerification";
    /**
     * Text independent speaker verification
     * @member VoiceProfileType.TextIndependentVerification
     */ VoiceProfileType[VoiceProfileType["TextIndependentVerification"] = 2] = "TextIndependentVerification";
})($8c71f39f4edc0ee0$var$VoiceProfileType = module.exports.VoiceProfileType || (module.exports.VoiceProfileType = {}));

});

parcelRegister("1XDDB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognizer = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $iDyMW = parcelRequire("iDyMW");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Translation recognizer
 * @class TranslationRecognizer
 */ class $16da0c5e945ffe07$var$TranslationRecognizer extends $hVlip.Recognizer {
    /**
     * Initializes an instance of the TranslationRecognizer.
     * @constructor
     * @param {SpeechTranslationConfig} speechConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     * @param {IConnectionFactory} connectionFactory - An optional connection factory to use to generate the endpoint URIs, headers to set, etc...
     */ constructor(speechConfig, audioConfig, connectionFactory){
        const configImpl = speechConfig;
        $56OOs.Contracts.throwIfNull(configImpl, "speechConfig");
        super(audioConfig, configImpl.properties, connectionFactory || new $imJeu.TranslationConnectionFactory());
        this.privDisposedTranslationRecognizer = false;
        if (this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationVoice, undefined) !== undefined) $56OOs.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationVoice), $hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_TranslationVoice]);
        $56OOs.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages), $hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages]);
        $56OOs.Contracts.throwIfNullOrWhitespace(this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage), $hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
    /**
     * TranslationRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechTranslationConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechTranslationConfigImpl = speechTranslationConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechTranslationConfigImpl.properties);
        return new $16da0c5e945ffe07$var$TranslationRecognizer(speechTranslationConfig, audioConfig);
    }
    /**
     * Gets the language name that was set when the recognizer was created.
     * @member TranslationRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} Gets the language name that was set when the recognizer was created.
     */ get speechRecognitionLanguage() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets target languages for translation that were set when the recognizer was created.
     * The language is specified in BCP-47 format. The translation will provide translated text for each of language.
     * @member TranslationRecognizer.prototype.targetLanguages
     * @function
     * @public
     * @returns {string[]} Gets target languages for translation that were set when the recognizer was created.
     */ get targetLanguages() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
    }
    /**
     * Gets the name of output voice.
     * @member TranslationRecognizer.prototype.voiceName
     * @function
     * @public
     * @returns {string} the name of output voice.
     */ get voiceName() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
    }
    /**
     * The collection of properties and their values defined for this TranslationRecognizer.
     * @member TranslationRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this TranslationRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member TranslationRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member TranslationRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - Authorization token.
     */ set authorizationToken(value) {
        this.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, value);
    }
    /**
     * Starts recognition and translation, and stops after the first utterance is recognized.
     * The task returns the translation text as result.
     * Note: recognizeOnceAsync returns when the first utterance has been recognized, so it is suitable only
     * for single shot recognition like command or query. For long-running recognition,
     * use startContinuousRecognitionAsync() instead.
     * @member TranslationRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the translation has completed.
     * @param err - Callback invoked in case of an error.
     */ recognizeOnceAsync(cb, err) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        $3wpON.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl($imJeu.RecognitionMode.Interactive), cb, err);
    }
    /**
     * Starts recognition and translation, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive translation results.
     * @member TranslationRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has started.
     * @param err - Callback invoked in case of an error.
     */ startContinuousRecognitionAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($imJeu.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops continuous recognition and translation.
     * @member TranslationRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopContinuousRecognitionAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * dynamically remove a language from list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.removeTargetLanguage
     * @function
     * @param lang - language to be removed
     * @public
     */ removeTargetLanguage(lang) {
        $56OOs.Contracts.throwIfNullOrUndefined(lang, "language to be removed");
        if (this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) {
            const languages = this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            const index = languages.indexOf(lang);
            if (index > -1) {
                languages.splice(index, 1);
                this.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
                this.updateLanguages(languages);
            }
        }
    }
    /**
     * dynamically add a language to list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.addTargetLanguage
     * @function
     * @param lang - language to be added
     * @public
     */ addTargetLanguage(lang) {
        $56OOs.Contracts.throwIfNullOrUndefined(lang, "language to be added");
        let languages = [];
        if (this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined) !== undefined) {
            languages = this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
            if (!languages.includes(lang)) {
                languages.push(lang);
                this.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages, languages.join(","));
            }
        } else {
            this.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages, lang);
            languages = [
                lang
            ];
        }
        this.updateLanguages(languages);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member TranslationRecognizer.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer);
        $3wpON.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * handles ConnectionEstablishedEvent for conversation translation scenarios.
     * @member TranslationRecognizer.prototype.onConnection
     * @function
     * @public
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    onConnection() {}
    async dispose(disposing) {
        if (this.privDisposedTranslationRecognizer) return;
        this.privDisposedTranslationRecognizer = true;
        if (disposing) {
            await this.implRecognizerStop();
            await super.dispose(disposing);
        }
    }
    createRecognizerConfig(speechConfig) {
        return new $imJeu.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new $imJeu.TranslationServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
    updateLanguages(languages) {
        const conn = $iDyMW.Connection.fromRecognizer(this);
        if (!!conn) {
            conn.setMessageProperty("speech.context", "translationcontext", {
                to: languages
            });
            conn.sendMessageAsync("event", JSON.stringify({
                id: "translation",
                name: "updateLanguage",
                to: languages
            }));
        }
    }
}
module.exports.TranslationRecognizer = $16da0c5e945ffe07$var$TranslationRecognizer;

});
parcelRegister("iDyMW", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $dT9Ew = parcelRequire("dT9Ew");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Connection is a proxy class for managing connection to the speech service of the specified Recognizer.
 * By default, a Recognizer autonomously manages connection to service when needed.
 * The Connection class provides additional methods for users to explicitly open or close a connection and
 * to subscribe to connection status changes.
 * The use of Connection is optional, and mainly for scenarios where fine tuning of application
 * behavior based on connection status is needed. Users can optionally call Open() to manually set up a connection
 * in advance before starting recognition on the Recognizer associated with this Connection.
 * If the Recognizer needs to connect or disconnect to service, it will
 * setup or shutdown the connection independently. In this case the Connection will be notified by change of connection
 * status via Connected/Disconnected events.
 * Added in version 1.2.1.
 */ class $d916dabddd9cfc59$var$Connection {
    /**
     * Gets the Connection instance from the specified recognizer.
     * @param recognizer The recognizer associated with the connection.
     * @return The Connection instance of the recognizer.
     */ static fromRecognizer(recognizer) {
        const recoBase = recognizer.internalData;
        const ret = new $d916dabddd9cfc59$var$Connection();
        ret.privInternalData = recoBase;
        ret.setupEvents();
        return ret;
    }
    /**
     * Gets the Connection instance from the specified synthesizer.
     * @param synthesizer The synthesizer associated with the connection.
     * @return The Connection instance of the synthesizer.
     */ static fromSynthesizer(synthesizer) {
        const synthBase = synthesizer.internalData;
        const ret = new $d916dabddd9cfc59$var$Connection();
        ret.privInternalData = synthBase;
        ret.setupEvents();
        return ret;
    }
    /**
     * Starts to set up connection to the service.
     * Users can optionally call openConnection() to manually set up a connection in advance before starting recognition on the
     * Recognizer associated with this Connection. After starting recognition, calling Open() will have no effect
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     */ openConnection(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.privInternalData.connect(), cb, err);
    }
    /**
     * Closes the connection the service.
     * Users can optionally call closeConnection() to manually shutdown the connection of the associated Recognizer.
     *
     * If closeConnection() is called during recognition, recognition will fail and cancel with an error.
     */ closeConnection(cb, err) {
        if (this.privInternalData instanceof $imJeu.SynthesisAdapterBase) throw new Error("Disconnecting a synthesizer's connection is currently not supported");
        else $3wpON.marshalPromiseToCallbacks(this.privInternalData.disconnect(), cb, err);
    }
    /**
     * Appends a parameter in a message to service.
     * Added in version 1.12.1.
     * @param path The path of the network message.
     * @param propertyName Name of the property
     * @param propertyValue Value of the property. This is a json string.
     */ setMessageProperty(path, propertyName, propertyValue) {
        $56OOs.Contracts.throwIfNullOrWhitespace(propertyName, "propertyName");
        if (this.privInternalData instanceof $imJeu.ServiceRecognizerBase) {
            if (path.toLowerCase() !== "speech.context") throw new Error("Only speech.context message property sets are currently supported for recognizer");
            else this.privInternalData.speechContext.setSection(propertyName, propertyValue);
        } else if (this.privInternalData instanceof $imJeu.SynthesisAdapterBase) {
            if (path.toLowerCase() !== "synthesis.context") throw new Error("Only synthesis.context message property sets are currently supported for synthesizer");
            else this.privInternalData.synthesisContext.setSection(propertyName, propertyValue);
        }
    }
    /**
     * Sends a message to the speech service.
     * Added in version 1.13.0.
     * @param path The WebSocket path of the message
     * @param payload The payload of the message. This is a json string or a ArrayBuffer.
     * @param success A callback to indicate success.
     * @param error A callback to indicate an error.
     */ sendMessageAsync(path, payload, success, error) {
        $3wpON.marshalPromiseToCallbacks(this.privInternalData.sendNetworkMessage(path, payload), success, error);
    }
    /**
     * Dispose of associated resources.
     */ close() {
    /* eslint-disable no-empty */ }
    setupEvents() {
        this.privEventListener = this.privInternalData.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionEstablishedEvent") {
                if (!!this.connected) this.connected(new $hVlip.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionClosedEvent") {
                if (!!this.disconnected) this.disconnected(new $hVlip.ConnectionEventArgs(connectionEvent.connectionId));
            } else if (connectionEvent.name === "ConnectionMessageSentEvent") {
                if (!!this.messageSent) this.messageSent(new $hVlip.ConnectionMessageEventArgs(new $dT9Ew.ConnectionMessageImpl(connectionEvent.message)));
            } else if (connectionEvent.name === "ConnectionMessageReceivedEvent") {
                if (!!this.messageReceived) this.messageReceived(new $hVlip.ConnectionMessageEventArgs(new $dT9Ew.ConnectionMessageImpl(connectionEvent.message)));
            }
        });
        this.privServiceEventListener = this.privInternalData.serviceEvents.attach((e)=>{
            if (!!this.receivedServiceMessage) this.receivedServiceMessage(new $hVlip.ServiceEventArgs(e.jsonString, e.name));
        });
    }
}
module.exports.Connection = $d916dabddd9cfc59$var$Connection;

});
parcelRegister("dT9Ew", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageImpl = module.exports.ConnectionMessage = void 0;

var $bPVwM = parcelRequire("bPVwM");

var $3wpON = parcelRequire("3wpON");

var $bNuGp = parcelRequire("bNuGp");

var $feDHl = parcelRequire("feDHl");
/**
 * ConnectionMessage represents implementation specific messages sent to and received from
 * the speech service. These messages are provided for debugging purposes and should not
 * be used for production use cases with the Azure Cognitive Services Speech Service.
 * Messages sent to and received from the Speech Service are subject to change without
 * notice. This includes message contents, headers, payloads, ordering, etc.
 * Added in version 1.11.0.
 */ class $a1c7e63c29869220$var$ConnectionMessage {
}
module.exports.ConnectionMessage = $a1c7e63c29869220$var$ConnectionMessage;
class $a1c7e63c29869220$var$ConnectionMessageImpl {
    constructor(message){
        this.privConnectionMessage = message;
        this.privProperties = new $bNuGp.PropertyCollection();
        if (!!this.privConnectionMessage.headers[$bPVwM.HeaderNames.ConnectionId]) this.privProperties.setProperty($feDHl.PropertyId.Speech_SessionId, this.privConnectionMessage.headers[$bPVwM.HeaderNames.ConnectionId]);
        Object.keys(this.privConnectionMessage.headers).forEach((header)=>{
            this.privProperties.setProperty(header, this.privConnectionMessage.headers[header]);
        });
    }
    /**
     * The message path.
     */ get path() {
        return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find((key)=>key.toLowerCase() === "path".toLowerCase())];
    }
    /**
     * Checks to see if the ConnectionMessage is a text message.
     * See also IsBinaryMessage().
     */ get isTextMessage() {
        return this.privConnectionMessage.messageType === $3wpON.MessageType.Text;
    }
    /**
     * Checks to see if the ConnectionMessage is a binary message.
     * See also GetBinaryMessage().
     */ get isBinaryMessage() {
        return this.privConnectionMessage.messageType === $3wpON.MessageType.Binary;
    }
    /**
     * Gets the text message payload. Typically the text message content-type is
     * application/json. To determine other content-types use
     * Properties.GetProperty("Content-Type").
     */ get TextMessage() {
        return this.privConnectionMessage.textBody;
    }
    /**
     * Gets the binary message payload.
     */ get binaryMessage() {
        return this.privConnectionMessage.binaryBody;
    }
    /**
     * A collection of properties and their values defined for this <see cref="ConnectionMessage"/>.
     * Message headers can be accessed via this collection (e.g. "Content-Type").
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Returns a string that represents the connection message.
     */ toString() {
        return "";
    }
}
module.exports.ConnectionMessageImpl = $a1c7e63c29869220$var$ConnectionMessageImpl;

});



parcelRegister("Lxqat", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Translations = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Represents collection of parameters and their values.
 * @class Translations
 */ class $08ee50a0bb9200fe$var$Translations {
    constructor(){
        // Use an PropertyCollection internally, just wrapping it to hide the | enum syntax it has.
        this.privMap = new $hVlip.PropertyCollection();
    }
    /**
     * Get the languages in the object in a String array.
     * @member Translations.prototype.languages
     * @function
     * @public
     * @returns {string[]} languages in translations object.
     */ get languages() {
        return this.privMap.keys;
    }
    /**
     * Returns the parameter value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member Translations.prototype.get
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter is not available in the collection.
     * @returns {string} value of the parameter.
     */ get(key, def) {
        return this.privMap.getProperty(key, def);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member Translations.prototype.set
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */ set(key, value) {
        this.privMap.setProperty(key, value);
    }
}
module.exports.Translations = $08ee50a0bb9200fe$var$Translations;

});

parcelRegister("hX5Dh", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchReason = void 0;
/**
 * Defines the possible reasons a recognition result might not be recognized.
 * @class NoMatchReason
 */ var $d11c50d66cd0d6cd$var$NoMatchReason;
(function(NoMatchReason) {
    /**
     * Indicates that speech was detected, but not recognized.
     * @member NoMatchReason.NotRecognized
     */ NoMatchReason[NoMatchReason["NotRecognized"] = 0] = "NotRecognized";
    /**
     * Indicates that the start of the audio stream contained only silence,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialSilenceTimeout
     */ NoMatchReason[NoMatchReason["InitialSilenceTimeout"] = 1] = "InitialSilenceTimeout";
    /**
     * Indicates that the start of the audio stream contained only noise,
     * and the service timed out waiting for speech.
     * @member NoMatchReason.InitialBabbleTimeout
     */ NoMatchReason[NoMatchReason["InitialBabbleTimeout"] = 2] = "InitialBabbleTimeout";
})($d11c50d66cd0d6cd$var$NoMatchReason = module.exports.NoMatchReason || (module.exports.NoMatchReason = {}));

});

parcelRegister("484RK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoMatchDetails = void 0;

var $imJeu = parcelRequire("imJeu");

var $hVlip = parcelRequire("hVlip");
/**
 * Contains detailed information for NoMatch recognition results.
 * @class NoMatchDetails
 */ class $301baf0ea347f260$var$NoMatchDetails {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {NoMatchReason} reason - The no-match reason.
     */ constructor(reason){
        this.privReason = reason;
    }
    /**
     * Creates an instance of NoMatchDetails object for the NoMatch SpeechRecognitionResults.
     * @member NoMatchDetails.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult | IntentRecognitionResult | TranslationRecognitionResult}
     * result - The recognition result that was not recognized.
     * @returns {NoMatchDetails} The no match details object being created.
     */ static fromResult(result) {
        const simpleSpeech = $imJeu.SimpleSpeechPhrase.fromJSON(result.json);
        let reason = $hVlip.NoMatchReason.NotRecognized;
        switch(simpleSpeech.RecognitionStatus){
            case $imJeu.RecognitionStatus.BabbleTimeout:
                reason = $hVlip.NoMatchReason.InitialBabbleTimeout;
                break;
            case $imJeu.RecognitionStatus.InitialSilenceTimeout:
                reason = $hVlip.NoMatchReason.InitialSilenceTimeout;
                break;
            default:
                reason = $hVlip.NoMatchReason.NotRecognized;
                break;
        }
        return new $301baf0ea347f260$var$NoMatchDetails(reason);
    }
    /**
     * The reason the recognition was canceled.
     * @member NoMatchDetails.prototype.reason
     * @function
     * @public
     * @returns {NoMatchReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
}
module.exports.NoMatchDetails = $301baf0ea347f260$var$NoMatchDetails;

});

parcelRegister("1m3VG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationRecognitionCanceledEventArgs = void 0;
/**
 * Define payload of speech recognition canceled result events.
 * @class TranslationRecognitionCanceledEventArgs
 */ class $0fcae4cae71493fd$var$TranslationRecognitionCanceledEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} sessionid - The session id.
     * @param {CancellationReason} cancellationReason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {TranslationRecognitionResult} result - The result.
     */ constructor(sessionid, cancellationReason, errorDetails, errorCode, result){
        this.privCancelReason = cancellationReason;
        this.privErrorDetails = errorDetails;
        this.privResult = result;
        this.privSessionId = sessionid;
        this.privErrorCode = errorCode;
    }
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionCanceledEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
    /**
     * Specifies the session identifier.
     * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
     * @function
     * @public
     * @returns {string} the session identifier.
     */ get sessionId() {
        return this.privSessionId;
    }
    /**
     * The reason the recognition was canceled.
     * @member TranslationRecognitionCanceledEventArgs.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privCancelReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}
module.exports.TranslationRecognitionCanceledEventArgs = $0fcae4cae71493fd$var$TranslationRecognitionCanceledEventArgs;

});

parcelRegister("96YYT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentRecognitionCanceledEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Define payload of intent recognition canceled result events.
 * @class IntentRecognitionCanceledEventArgs
 */ class $6a23fa2e5f970977$var$IntentRecognitionCanceledEventArgs extends $hVlip.IntentRecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} result - The result of the intent recognition.
     * @param {string} offset - The offset.
     * @param {IntentRecognitionResult} sessionId - The session id.
     */ constructor(reason, errorDetails, errorCode, result, offset, sessionId){
        super(result, offset, sessionId);
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member IntentRecognitionCanceledEventArgs.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get errorCode() {
        return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member IntentRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
}
module.exports.IntentRecognitionCanceledEventArgs = $6a23fa2e5f970977$var$IntentRecognitionCanceledEventArgs;

});

parcelRegister("3RqHo", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetailsBase = void 0;
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetailsBase
 */ class $2cfb0828d26b776d$var$CancellationDetailsBase {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - The error details, if provided.
     */ constructor(reason, errorDetails, errorCode){
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privErrorCode = errorCode;
    }
    /**
     * The reason the recognition was canceled.
     * @member CancellationDetailsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */ get reason() {
        return this.privReason;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member CancellationDetailsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */ get ErrorCode() {
        return this.privErrorCode;
    }
}
module.exports.CancellationDetailsBase = $2cfb0828d26b776d$var$CancellationDetailsBase;

});

parcelRegister("csUhv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationDetails = void 0;

var $imJeu = parcelRequire("imJeu");

var $3RqHo = parcelRequire("3RqHo");

var $hVlip = parcelRequire("hVlip");
/**
 * Contains detailed information about why a result was canceled.
 * @class CancellationDetails
 */ class $9133c1d8dd370d4b$var$CancellationDetails extends $3RqHo.CancellationDetailsBase {
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
    /**
     * Creates an instance of CancellationDetails object for the canceled RecognitionResult.
     * @member CancellationDetails.fromResult
     * @function
     * @public
     * @param {RecognitionResult | SpeechSynthesisResult} result - The result that was canceled.
     * @returns {CancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        let reason = $hVlip.CancellationReason.Error;
        let errorCode = $hVlip.CancellationErrorCode.NoError;
        if (result instanceof $hVlip.RecognitionResult && !!result.json) {
            const simpleSpeech = $imJeu.SimpleSpeechPhrase.fromJSON(result.json);
            reason = $imJeu.EnumTranslation.implTranslateCancelResult(simpleSpeech.RecognitionStatus);
        }
        if (!!result.properties) errorCode = $hVlip.CancellationErrorCode[result.properties.getProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[$hVlip.CancellationErrorCode.NoError])];
        return new $9133c1d8dd370d4b$var$CancellationDetails(reason, result.errorDetails || $imJeu.EnumTranslation.implTranslateErrorDetails(errorCode), errorCode);
    }
}
module.exports.CancellationDetails = $9133c1d8dd370d4b$var$CancellationDetails;

});

parcelRegister("4LpiT", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationErrorCode = void 0;
/**
 * Defines error code in case that CancellationReason is Error.
 * Added in version 1.1.0.
 */ var $377f2dfcb206ab0f$var$CancellationErrorCode;
(function(CancellationErrorCode) {
    /**
     * Indicates that no error occurred during speech recognition.
     */ CancellationErrorCode[CancellationErrorCode["NoError"] = 0] = "NoError";
    /**
     * Indicates an authentication error.
     */ CancellationErrorCode[CancellationErrorCode["AuthenticationFailure"] = 1] = "AuthenticationFailure";
    /**
     * Indicates that one or more recognition parameters are invalid.
     */ CancellationErrorCode[CancellationErrorCode["BadRequestParameters"] = 2] = "BadRequestParameters";
    /**
     * Indicates that the number of parallel requests exceeded the number of allowed
     * concurrent transcriptions for the subscription.
     */ CancellationErrorCode[CancellationErrorCode["TooManyRequests"] = 3] = "TooManyRequests";
    /**
     * Indicates a connection error.
     */ CancellationErrorCode[CancellationErrorCode["ConnectionFailure"] = 4] = "ConnectionFailure";
    /**
     * Indicates a time-out error when waiting for response from service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceTimeout"] = 5] = "ServiceTimeout";
    /**
     * Indicates that an error is returned by the service.
     */ CancellationErrorCode[CancellationErrorCode["ServiceError"] = 6] = "ServiceError";
    /**
     * Indicates an unexpected runtime error.
     */ CancellationErrorCode[CancellationErrorCode["RuntimeError"] = 7] = "RuntimeError";
    /**
     * Indicates an quota overrun on existing key.
     */ CancellationErrorCode[CancellationErrorCode["Forbidden"] = 8] = "Forbidden";
})($377f2dfcb206ab0f$var$CancellationErrorCode = module.exports.CancellationErrorCode || (module.exports.CancellationErrorCode = {}));

});

parcelRegister("jqMnK", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines payload for connection events like Connected/Disconnected.
 * Added in version 1.2.0
 */ class $e255f9b4c85af21c$var$ConnectionEventArgs extends $hVlip.SessionEventArgs {
}
module.exports.ConnectionEventArgs = $e255f9b4c85af21c$var$ConnectionEventArgs;

});

parcelRegister("7j8bo", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines payload for any Service message event
 * Added in version 1.9.0
 */ class $5520a7b0d71ebe7b$var$ServiceEventArgs extends $hVlip.SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} json - json payload of the USP message.
     */ constructor(json, name, sessionId){
        super(sessionId);
        this.privJsonResult = json;
        this.privEventName = name;
    }
    get jsonString() {
        return this.privJsonResult;
    }
    get eventName() {
        return this.privEventName;
    }
}
module.exports.ServiceEventArgs = $5520a7b0d71ebe7b$var$ServiceEventArgs;

});

parcelRegister("2mEF6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PhraseListGrammar = void 0;
/**
 * Allows additions of new phrases to improve speech recognition.
 *
 * Phrases added to the recognizer are effective at the start of the next recognition, or the next time the SpeechSDK must reconnect
 * to the speech service.
 */ class $1b8d2d7417deceee$var$PhraseListGrammar {
    constructor(recogBase){
        this.privGrammerBuilder = recogBase.dynamicGrammar;
    }
    /**
     * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
     * @param recognizer The recognizer to add phrase lists to.
     */ static fromRecognizer(recognizer) {
        const recoBase = recognizer.internalData;
        return new $1b8d2d7417deceee$var$PhraseListGrammar(recoBase);
    }
    /**
     * Adds a single phrase to the current recognizer.
     * @param phrase Phrase to add.
     */ addPhrase(phrase) {
        this.privGrammerBuilder.addPhrase(phrase);
    }
    /**
     * Adds multiple phrases to the current recognizer.
     * @param phrases Array of phrases to add.
     */ addPhrases(phrases) {
        this.privGrammerBuilder.addPhrase(phrases);
    }
    /**
     * Clears all phrases added to the current recognizer.
     */ clear() {
        this.privGrammerBuilder.clearPhrases();
    }
}
module.exports.PhraseListGrammar = $1b8d2d7417deceee$var$PhraseListGrammar;

});

parcelRegister("atIoA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConfigImpl = module.exports.DialogServiceConfig = void 0;

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Class that defines base configurations for dialog service connector
 * @class DialogServiceConfig
 */ class $7a0f0cdbf612e548$var$DialogServiceConfig {
    /**
     * Creates an instance of DialogService config.
     * @constructor
     */ constructor(){
        return;
    }
    /**
     * Sets the corresponding backend application identifier.
     * @member DialogServiceConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    set applicationId(value) {}
    static get DialogTypes() {
        return {
            BotFramework: "bot_framework",
            CustomCommands: "custom_commands"
        };
    }
}
module.exports.DialogServiceConfig = $7a0f0cdbf612e548$var$DialogServiceConfig;
/**
 * Dialog Service configuration.
 * @class DialogServiceConfigImpl
 */ class $7a0f0cdbf612e548$var$DialogServiceConfigImpl extends $7a0f0cdbf612e548$var$DialogServiceConfig {
    /**
     * Creates an instance of dialogService config.
     */ constructor(){
        super();
        this.privSpeechConfig = new $hVlip.SpeechConfigImpl();
    }
    /**
     * Provides access to custom properties.
     * @member DialogServiceConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */ get properties() {
        return this.privSpeechConfig.properties;
    }
    /**
     * Gets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     */ get speechRecognitionLanguage() {
        return this.privSpeechConfig.speechRecognitionLanguage;
    }
    /**
     * Sets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The language to set.
     */ set speechRecognitionLanguage(value) {
        $56OOs.Contracts.throwIfNullOrWhitespace(value, "value");
        this.privSpeechConfig.speechRecognitionLanguage = value;
    }
    get outputFormat() {
        return this.privSpeechConfig.outputFormat;
    }
    set outputFormat(value) {
        this.privSpeechConfig.outputFormat = value;
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to set.
     * @param {string} value - The value.
     */ setProperty(name, value) {
        this.privSpeechConfig.setProperty(name, value);
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to get.
     * @param {string} def - The default value to return in case the property is not known.
     * @returns {string} The current value, or provided default, of the given property.
     */ getProperty(name, def) {
        return this.privSpeechConfig.getProperty(name);
    }
    /**
     * Sets the proxy configuration.
     * Only relevant in Node.js environments.
     * Added in version 1.4.0.
     * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
     * @param proxyPort The port number of the proxy server.
     * @param proxyUserName The user name of the proxy server.
     * @param proxyPassword The password of the proxy server.
     */ setProxy(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
        this.setProperty($hVlip.PropertyId.SpeechServiceConnection_ProxyHostName, proxyHostName);
        this.setProperty($hVlip.PropertyId.SpeechServiceConnection_ProxyPort, `${proxyPort}`);
        if (proxyUserName) this.setProperty($hVlip.PropertyId.SpeechServiceConnection_ProxyUserName, proxyUserName);
        if (proxyPassword) this.setProperty($hVlip.PropertyId.SpeechServiceConnection_ProxyPassword, proxyPassword);
    }
    setServiceProperty(name, value, channel) {
        this.privSpeechConfig.setServiceProperty(name, value);
    }
    /**
     * Dispose of associated resources.
     * @member DialogServiceConfigImpl.prototype.close
     * @function
     * @public
     */ close() {
        return;
    }
}
module.exports.DialogServiceConfigImpl = $7a0f0cdbf612e548$var$DialogServiceConfigImpl;

});

parcelRegister("8JVb4", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BotFrameworkConfig = void 0;

var $56OOs = parcelRequire("56OOs");

var $atIoA = parcelRequire("atIoA");

var $hVlip = parcelRequire("hVlip");
/**
 * Class that defines configurations for the dialog service connector object for using a Bot Framework backend.
 * @class BotFrameworkConfig
 */ class $65cee0f773d0d869$var$BotFrameworkConfig extends $atIoA.DialogServiceConfigImpl {
    /**
     * Creates an instance of BotFrameworkConfig.
     */ constructor(){
        super();
    }
    /**
     * Creates a bot framework configuration instance with the provided subscription information.
     * @member BotFrameworkConfig.fromSubscription
     * @function
     * @public
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromSubscription(subscription, region, botId) {
        $56OOs.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $56OOs.Contracts.throwIfNullOrWhitespace(region, "region");
        const botFrameworkConfig = new $atIoA.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($hVlip.PropertyId.Conversation_DialogType, $atIoA.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscription);
        botFrameworkConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($hVlip.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    }
    /**
     * Creates a bot framework configuration instance for the specified authorization token and region.
     * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
     * caller must refresh it by setting the authorizationToken property on the corresponding
     * DialogServiceConnector instance created with this config. The contents of configuration objects are copied
     * when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
     * original configuration's authorization token. Create a new configuration instance or set the
     * SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
     * further DialogServiceConnectors.
     * @member BotFrameworkConfig.fromAuthorizationToken
     * @function
     * @public
     * @param authorizationToken The authorization token associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromAuthorizationToken(authorizationToken, region, botId) {
        $56OOs.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $56OOs.Contracts.throwIfNullOrWhitespace(region, "region");
        const botFrameworkConfig = new $atIoA.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($hVlip.PropertyId.Conversation_DialogType, $atIoA.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        botFrameworkConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Region, region);
        if (botId) botFrameworkConfig.setProperty($hVlip.PropertyId.Conversation_ApplicationId, botId);
        return botFrameworkConfig;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-default service host. The standard resource path will be
     * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
     * property on the created BotFrameworkConfig instance.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromHost
     * @function
     * @public
     * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
     * wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
     * wss://{host}.convai.speech.azure.us.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */ static fromHost(host, subscriptionKey, botId) {
        $56OOs.Contracts.throwIfNullOrUndefined(host, "host");
        const resolvedHost = host instanceof URL ? host : new URL(`wss://${host}.convai.speech.azure.us`);
        $56OOs.Contracts.throwIfNullOrUndefined(resolvedHost, "resolvedHost");
        const botFrameworkConfig = new $atIoA.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($hVlip.PropertyId.Conversation_DialogType, $atIoA.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Host, resolvedHost.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
     * use the authorization token.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
     */ static fromEndpoint(endpoint, subscriptionKey) {
        $56OOs.Contracts.throwIfNull(endpoint, "endpoint");
        const botFrameworkConfig = new $atIoA.DialogServiceConfigImpl();
        botFrameworkConfig.setProperty($hVlip.PropertyId.Conversation_DialogType, $atIoA.DialogServiceConfig.DialogTypes.BotFramework);
        botFrameworkConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, endpoint.toString());
        if (undefined !== subscriptionKey) botFrameworkConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscriptionKey);
        return botFrameworkConfig;
    }
}
module.exports.BotFrameworkConfig = $65cee0f773d0d869$var$BotFrameworkConfig;

});

parcelRegister("7tZol", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomCommandsConfig = void 0;

var $56OOs = parcelRequire("56OOs");

var $atIoA = parcelRequire("atIoA");

var $hVlip = parcelRequire("hVlip");
/**
 * Class that defines configurations for the dialog service connector object for using a CustomCommands backend.
 * @class CustomCommandsConfig
 */ class $572adcf6fa847cc8$var$CustomCommandsConfig extends $atIoA.DialogServiceConfigImpl {
    /**
     * Creates an instance of CustomCommandsConfig.
     */ constructor(){
        super();
    }
    /**
     * Creates an instance of the bot framework config with the specified subscription and region.
     * @member CustomCommandsConfig.fromSubscription
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new bot framework config.
     */ static fromSubscription(applicationId, subscription, region) {
        $56OOs.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(subscription, "subscription");
        $56OOs.Contracts.throwIfNullOrWhitespace(region, "region");
        const customCommandsConfig = new $atIoA.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($hVlip.PropertyId.Conversation_DialogType, $atIoA.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($hVlip.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Key, subscription);
        customCommandsConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    }
    /**
     * Creates an instance of the bot framework config with the specified Speech Commands application id, authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member CustomCommandsConfig.fromAuthorizationToken
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param authorizationToken The authorization token associated with the application.
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new speech commands config.
     */ static fromAuthorizationToken(applicationId, authorizationToken, region) {
        $56OOs.Contracts.throwIfNullOrWhitespace(applicationId, "applicationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(authorizationToken, "authorizationToken");
        $56OOs.Contracts.throwIfNullOrWhitespace(region, "region");
        const customCommandsConfig = new $atIoA.DialogServiceConfigImpl();
        customCommandsConfig.setProperty($hVlip.PropertyId.Conversation_DialogType, $atIoA.DialogServiceConfig.DialogTypes.CustomCommands);
        customCommandsConfig.setProperty($hVlip.PropertyId.Conversation_ApplicationId, applicationId);
        customCommandsConfig.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, authorizationToken);
        customCommandsConfig.setProperty($hVlip.PropertyId.SpeechServiceConnection_Region, region);
        return customCommandsConfig;
    }
    /**
     * Sets the corresponding backend application identifier.
     * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */ set applicationId(value) {
        $56OOs.Contracts.throwIfNullOrWhitespace(value, "value");
        this.setProperty($hVlip.PropertyId.Conversation_ApplicationId, value);
    }
    /**
     * Gets the corresponding backend application identifier.
     * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to get.
     */ get applicationId() {
        return this.getProperty($hVlip.PropertyId.Conversation_ApplicationId);
    }
}
module.exports.CustomCommandsConfig = $572adcf6fa847cc8$var$CustomCommandsConfig;

});

parcelRegister("leOQ2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceConnector = void 0;

var $9oOZ6 = parcelRequire("9oOZ6");

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $feDHl = parcelRequire("feDHl");
/**
 * Dialog Service Connector
 * @class DialogServiceConnector
 */ class $f76257318f609288$var$DialogServiceConnector extends $hVlip.Recognizer {
    /**
     * Initializes an instance of the DialogServiceConnector.
     * @constructor
     * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     */ constructor(dialogConfig, audioConfig){
        const dialogServiceConfigImpl = dialogConfig;
        $56OOs.Contracts.throwIfNull(dialogConfig, "dialogConfig");
        super(audioConfig, dialogServiceConfigImpl.properties, new $9oOZ6.DialogConnectionFactory());
        this.isTurnComplete = true;
        this.privIsDisposed = false;
        this.privProperties = dialogServiceConfigImpl.properties.clone();
        const agentConfig = this.buildAgentConfig();
        this.privReco.agentConfig.set(agentConfig);
    }
    /**
     * Starts a connection to the service.
     * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     * @member DialogServiceConnector.prototype.connect
     * @function
     * @public
     */ connect(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.privReco.connect(), cb, err);
    }
    /**
     * Closes the connection the service.
     * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
     *
     * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
     */ disconnect(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.privReco.disconnect(), cb, err);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($feDHl.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Sets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $56OOs.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($feDHl.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this DialogServiceConnector.
     * @member DialogServiceConnector.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
     */ get properties() {
        return this.privProperties;
    }
    /** Gets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be empty
     */ get speechActivityTemplate() {
        return this.properties.getProperty($feDHl.PropertyId.Conversation_Speech_Activity_Template);
    }
    /** Sets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be null or empty.
     * Note: it has to be a valid Json object.
     */ set speechActivityTemplate(speechActivityTemplate) {
        this.properties.setProperty($feDHl.PropertyId.Conversation_Speech_Activity_Template, speechActivityTemplate);
    }
    /**
     * Starts recognition and stops after the first utterance is recognized.
     * @member DialogServiceConnector.prototype.listenOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the reco has completed.
     * @param err - Callback invoked in case of an error.
     */ listenOnceAsync(cb, err) {
        if (this.isTurnComplete) {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            const callbackHolder = async ()=>{
                await this.privReco.connect();
                await this.implRecognizerStop();
                this.isTurnComplete = false;
                const ret = new $3wpON.Deferred();
                await this.privReco.recognize($imJeu.RecognitionMode.Conversation, ret.resolve, ret.reject);
                const e = await ret.promise;
                await this.implRecognizerStop();
                return e;
            };
            const retPromise = callbackHolder();
            retPromise.catch(()=>{
                // Destroy the recognizer.
                // We've done all we can here.
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                this.dispose(true).catch(()=>{});
            });
            $3wpON.marshalPromiseToCallbacks(retPromise.finally(()=>{
                this.isTurnComplete = true;
            }), cb, err);
        }
    }
    sendActivityAsync(activity, cb, errCb) {
        $3wpON.marshalPromiseToCallbacks(this.privReco.sendMessage(activity), cb, errCb);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member DialogServiceConnector.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
        $3wpON.marshalPromiseToCallbacks(this.dispose(true), cb, err);
    }
    async dispose(disposing) {
        if (this.privIsDisposed) return;
        if (disposing) {
            this.privIsDisposed = true;
            await this.implRecognizerStop();
            await super.dispose(disposing);
        }
    }
    createRecognizerConfig(speechConfig) {
        return new $imJeu.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioSource = audioConfig;
        return new $imJeu.DialogServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    }
    buildAgentConfig() {
        const communicationType = this.properties.getProperty("Conversation_Communication_Type", "Default");
        return {
            botInfo: {
                commType: communicationType,
                commandsCulture: undefined,
                connectionId: this.properties.getProperty($feDHl.PropertyId.Conversation_Agent_Connection_Id),
                conversationId: this.properties.getProperty($feDHl.PropertyId.Conversation_Conversation_Id, undefined),
                fromId: this.properties.getProperty($feDHl.PropertyId.Conversation_From_Id, undefined),
                ttsAudioFormat: this.properties.getProperty($feDHl.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)
            },
            version: 0.2
        };
    }
}
module.exports.DialogServiceConnector = $f76257318f609288$var$DialogServiceConnector;

});
parcelRegister("9oOZ6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $imJeu = parcelRequire("imJeu");

var $hVlip = parcelRequire("hVlip");

var $lAVhN = parcelRequire("lAVhN");

var $imJeu = parcelRequire("imJeu");

var $bPVwM = parcelRequire("bPVwM");

var $luvuO = parcelRequire("luvuO");
class $6d7de7684101c1f5$var$DialogConnectionFactory extends $lAVhN.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        const applicationId = config.parameters.getProperty($hVlip.PropertyId.Conversation_ApplicationId, "");
        const dialogType = config.parameters.getProperty($hVlip.PropertyId.Conversation_DialogType);
        const region = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region);
        const language = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage, "en-US");
        const requestTurnStatus = config.parameters.getProperty($hVlip.PropertyId.Conversation_Request_Bot_Status_Messages, "true");
        const queryParams = {};
        queryParams[$bPVwM.HeaderNames.ConnectionId] = connectionId;
        queryParams[$luvuO.QueryParameterNames.Format] = config.parameters.getProperty($imJeu.OutputFormatPropertyName, $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]).toLowerCase();
        queryParams[$luvuO.QueryParameterNames.Language] = language;
        queryParams[$luvuO.QueryParameterNames.RequestBotStatusMessages] = requestTurnStatus;
        if (applicationId) {
            queryParams[$luvuO.QueryParameterNames.BotId] = applicationId;
            if (dialogType === $hVlip.DialogServiceConfig.DialogTypes.CustomCommands) queryParams[$bPVwM.HeaderNames.CustomCommandsAppId] = applicationId;
        }
        const resourceInfix = dialogType === $hVlip.DialogServiceConfig.DialogTypes.CustomCommands ? "commands/" : "";
        const version = dialogType === $hVlip.DialogServiceConfig.DialogTypes.CustomCommands ? "v1" : dialogType === $hVlip.DialogServiceConfig.DialogTypes.BotFramework ? "v3" : "v0";
        const headers = {};
        if (authInfo.token != null && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        // The URL used for connection is chosen in a priority order of specification:
        //  1. If a custom endpoint is provided, that URL is used verbatim.
        //  2. If a custom host is provided (e.g. "wss://my.custom.endpoint.com:1123"), a URL is constructed from it.
        //  3. If no custom connection details are provided, a URL is constructed from default values.
        let endpoint = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, "");
        if (!endpoint) {
            const hostSuffix = $lAVhN.ConnectionFactoryBase.getHostSuffix(region);
            const host = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, `wss://${region}.${$6d7de7684101c1f5$var$DialogConnectionFactory.BaseUrl}${hostSuffix}`);
            const standardizedHost = host.endsWith("/") ? host : host + "/";
            endpoint = `${standardizedHost}${resourceInfix}${$6d7de7684101c1f5$var$DialogConnectionFactory.ApiKey}/${version}`;
        }
        this.setCommonUrlParams(config, queryParams, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $gvLMV.WebsocketConnection(endpoint, queryParams, headers, new $imJeu.WebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
}
module.exports.DialogConnectionFactory = $6d7de7684101c1f5$var$DialogConnectionFactory;
$6d7de7684101c1f5$var$DialogConnectionFactory.ApiKey = "api";
$6d7de7684101c1f5$var$DialogConnectionFactory.BaseUrl = "convai.speech";

});
parcelRegister("lAVhN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionFactoryBase = void 0;

var $imJeu = parcelRequire("imJeu");

var $hVlip = parcelRequire("hVlip");

var $luvuO = parcelRequire("luvuO");
class $fb896599a392c326$var$ConnectionFactoryBase {
    static getHostSuffix(region) {
        if (!!region) {
            if (region.toLowerCase().startsWith("china")) return ".azure.cn";
            if (region.toLowerCase().startsWith("usgov")) return ".azure.us";
        }
        return ".microsoft.com";
    }
    setCommonUrlParams(config, queryParams, endpoint) {
        const propertyIdToParameterMap = new Map([
            [
                $hVlip.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                $luvuO.QueryParameterNames.SegmentationSilenceTimeoutMs
            ],
            [
                $hVlip.PropertyId.SpeechServiceConnection_EnableAudioLogging,
                $luvuO.QueryParameterNames.EnableAudioLogging
            ],
            [
                $hVlip.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs,
                $luvuO.QueryParameterNames.EndSilenceTimeoutMs
            ],
            [
                $hVlip.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $luvuO.QueryParameterNames.InitialSilenceTimeoutMs
            ],
            [
                $hVlip.PropertyId.SpeechServiceResponse_PostProcessingOption,
                $luvuO.QueryParameterNames.Postprocessing
            ],
            [
                $hVlip.PropertyId.SpeechServiceResponse_ProfanityOption,
                $luvuO.QueryParameterNames.Profanity
            ],
            [
                $hVlip.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps,
                $luvuO.QueryParameterNames.EnableWordLevelTimestamps
            ],
            [
                $hVlip.PropertyId.SpeechServiceResponse_StablePartialResultThreshold,
                $luvuO.QueryParameterNames.StableIntermediateThreshold
            ]
        ]);
        propertyIdToParameterMap.forEach((parameterName, propertyId)=>{
            this.setUrlParameter(propertyId, parameterName, config, queryParams, endpoint);
        });
        const serviceProperties = JSON.parse(config.parameters.getProperty($imJeu.ServicePropertiesPropertyName, "{}"));
        Object.keys(serviceProperties).forEach((value)=>{
            queryParams[value] = serviceProperties[value];
        });
    }
    setUrlParameter(propId, parameterName, config, queryParams, endpoint) {
        const value = config.parameters.getProperty(propId, undefined);
        // FIXME: The .search() check will incorrectly match parameter name anywhere in the string
        //        including e.g. the path portion, or even as a substring of other query parameters
        if (value && (!endpoint || endpoint.search(parameterName) === -1)) queryParams[parameterName] = value.toLocaleLowerCase();
    }
}
module.exports.ConnectionFactoryBase = $fb896599a392c326$var$ConnectionFactoryBase;

});
parcelRegister("luvuO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryParameterNames = void 0;
class $fa54d4c2dee756a8$var$QueryParameterNames {
}
module.exports.QueryParameterNames = $fa54d4c2dee756a8$var$QueryParameterNames;
$fa54d4c2dee756a8$var$QueryParameterNames.BotId = "botid";
$fa54d4c2dee756a8$var$QueryParameterNames.CustomSpeechDeploymentId = "cid";
$fa54d4c2dee756a8$var$QueryParameterNames.CustomVoiceDeploymentId = "deploymentId";
$fa54d4c2dee756a8$var$QueryParameterNames.EnableAudioLogging = "storeAudio";
$fa54d4c2dee756a8$var$QueryParameterNames.EnableLanguageId = "lidEnabled";
$fa54d4c2dee756a8$var$QueryParameterNames.EnableWordLevelTimestamps = "wordLevelTimestamps";
$fa54d4c2dee756a8$var$QueryParameterNames.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
$fa54d4c2dee756a8$var$QueryParameterNames.SegmentationSilenceTimeoutMs = "segmentationSilenceTimeoutMs";
$fa54d4c2dee756a8$var$QueryParameterNames.Format = "format";
$fa54d4c2dee756a8$var$QueryParameterNames.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
$fa54d4c2dee756a8$var$QueryParameterNames.Language = "language";
$fa54d4c2dee756a8$var$QueryParameterNames.Profanity = "profanity";
$fa54d4c2dee756a8$var$QueryParameterNames.RequestBotStatusMessages = "enableBotMessageStatus";
$fa54d4c2dee756a8$var$QueryParameterNames.StableIntermediateThreshold = "stableIntermediateThreshold";
$fa54d4c2dee756a8$var$QueryParameterNames.StableTranslation = "stableTranslation";
$fa54d4c2dee756a8$var$QueryParameterNames.TestHooks = "testhooks";
$fa54d4c2dee756a8$var$QueryParameterNames.Postprocessing = "postprocessing";
$fa54d4c2dee756a8$var$QueryParameterNames.CtsMeetingId = "meetingId";
$fa54d4c2dee756a8$var$QueryParameterNames.CtsDeviceId = "deviceId";
$fa54d4c2dee756a8$var$QueryParameterNames.CtsIsParticipant = "isParticipant";
$fa54d4c2dee756a8$var$QueryParameterNames.EnableAvatar = "enableTalkingAvatar";

});




parcelRegister("1tS1M", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActivityReceivedEventArgs = void 0;
/**
 * Defines contents of received message/events.
 * @class ActivityReceivedEventArgs
 */ class $114268a8fee89805$var$ActivityReceivedEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {any} activity - The activity..
     */ constructor(activity, audioStream){
        this.privActivity = activity;
        this.privAudioStream = audioStream;
    }
    /**
     * Gets the received activity
     * @member ActivityReceivedEventArgs.prototype.activity
     * @function
     * @public
     * @returns {any} the received activity.
     */ get activity() {
        return this.privActivity;
    }
    get audioStream() {
        return this.privAudioStream;
    }
}
module.exports.ActivityReceivedEventArgs = $114268a8fee89805$var$ActivityReceivedEventArgs;

});

parcelRegister("5jY75", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusReceivedEventArgs = void 0;

var $brUjo = parcelRequire("brUjo");
/**
 * Defines contents of received message/events.
 * @class TurnStatusReceivedEventArgs
 */ class $3dfd5b594883424a$var$TurnStatusReceivedEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} turnStatus - The JSON-encoded turn status message.
     */ constructor(turnStatus){
        this.privTurnStatus = $brUjo.TurnStatusResponsePayload.fromJSON(turnStatus);
    }
    /**
     * Gets the interaction identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.interactionId
     * @function
     * @public
     * @returns {any} the received interaction id.
     */ get interactionId() {
        return this.privTurnStatus.interactionId;
    }
    /**
     * Gets the conversation identifier associated with this turn status event.
     * @member TurnStatusReceivedEventArgs.prototype.conversationId
     * @function
     * @public
     * @returns {any} the received conversation id.
     */ get conversationId() {
        return this.privTurnStatus.conversationId;
    }
    /**
     * Gets the received turn status code.
     * @member TurnStatusReceivedEventArgs.prototype.statusCode
     * @function
     * @public
     * @returns {number} the received turn status.
     */ get statusCode() {
        return this.privTurnStatus.statusCode; // eslint-disable-line @typescript-eslint/no-unsafe-return
    }
}
module.exports.TurnStatusReceivedEventArgs = $3dfd5b594883424a$var$TurnStatusReceivedEventArgs;

});
parcelRegister("brUjo", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnStatusResponsePayload = void 0;
class $855de5af3958cef1$var$TurnStatusResponsePayload {
    constructor(json){
        this.privMessageStatusResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $855de5af3958cef1$var$TurnStatusResponsePayload(json);
    }
    get interactionId() {
        return this.privMessageStatusResponse.interactionId;
    }
    get conversationId() {
        return this.privMessageStatusResponse.conversationId;
    }
    get statusCode() {
        // Payloads may contain a limited set of textual representations or a numeric status
        // code. The textual values are here converted into numeric ones.
        switch(this.privMessageStatusResponse.statusCode){
            case "Success":
                return 200;
            case "Failed":
                return 400;
            case "TimedOut":
                return 429;
            default:
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return this.privMessageStatusResponse.statusCode;
        }
    }
}
module.exports.TurnStatusResponsePayload = $855de5af3958cef1$var$TurnStatusResponsePayload;

});


parcelRegister("3nVAY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServicePropertyChannel = void 0;
/**
 * Defines channels used to pass property settings to service.
 * Added in version 1.7.0.
 */ var $277032529583f2b0$var$ServicePropertyChannel;
(function(ServicePropertyChannel) {
    /**
     * Uses URI query parameter to pass property settings to service.
     */ ServicePropertyChannel[ServicePropertyChannel["UriQueryParameter"] = 0] = "UriQueryParameter";
})($277032529583f2b0$var$ServicePropertyChannel = module.exports.ServicePropertyChannel || (module.exports.ServicePropertyChannel = {}));

});

parcelRegister("50bUf", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProfanityOption = void 0;
/**
 * Profanity option.
 * Added in version 1.7.0.
 */ var $3a46302a7a48d807$var$ProfanityOption;
(function(ProfanityOption) {
    ProfanityOption[ProfanityOption["Masked"] = 0] = "Masked";
    ProfanityOption[ProfanityOption["Removed"] = 1] = "Removed";
    ProfanityOption[ProfanityOption["Raw"] = 2] = "Raw";
})($3a46302a7a48d807$var$ProfanityOption = module.exports.ProfanityOption || (module.exports.ProfanityOption = {}));

});

parcelRegister("4aLB9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAudioPlayer = void 0;

var $6tpyr = parcelRequire("6tpyr");

var $hVlip = parcelRequire("hVlip");

var $d3s41 = parcelRequire("d3s41");
/**
 * Base audio player class
 * TODO: Plays only PCM for now.
 * @class
 */ class $309d049a139efb5b$var$BaseAudioPlayer {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {AudioStreamFormat} audioFormat audio stream format recognized by the player.
     */ constructor(audioFormat){
        this.audioContext = null;
        this.gainNode = null;
        this.autoUpdateBufferTimer = 0;
        if (audioFormat === undefined) audioFormat = $hVlip.AudioStreamFormat.getDefaultInputFormat();
        this.init(audioFormat);
    }
    /**
     * play Audio sample
     * @param newAudioData audio data to be played.
     */ playAudioSample(newAudioData, cb, err) {
        try {
            this.ensureInitializedContext();
            const audioData = this.formatAudioData(newAudioData);
            const newSamplesData = new Float32Array(this.samples.length + audioData.length);
            newSamplesData.set(this.samples, 0);
            newSamplesData.set(audioData, this.samples.length);
            this.samples = newSamplesData;
            if (!!cb) cb();
        } catch (e) {
            if (!!err) err(e);
        }
    }
    /**
     * stops audio and clears the buffers
     */ stopAudio(cb, err) {
        if (this.audioContext !== null) {
            this.samples = new Float32Array();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            clearInterval(this.autoUpdateBufferTimer);
            this.audioContext.close().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
            this.audioContext = null;
        }
    }
    init(audioFormat) {
        this.audioFormat = audioFormat;
        this.samples = new Float32Array();
    }
    ensureInitializedContext() {
        if (this.audioContext === null) {
            this.createAudioContext();
            const timerPeriod = 200;
            this.autoUpdateBufferTimer = setInterval(()=>{
                this.updateAudioBuffer();
            }, timerPeriod);
        }
    }
    createAudioContext() {
        // new ((window as any).AudioContext || (window as any).webkitAudioContext)();
        this.audioContext = $d3s41.AudioStreamFormatImpl.getAudioContext();
        // TODO: Various examples shows this gain node, it does not seem to be needed unless we plan
        // to control the volume, not likely
        this.gainNode = this.audioContext.createGain();
        this.gainNode.gain.value = 1;
        this.gainNode.connect(this.audioContext.destination);
        this.startTime = this.audioContext.currentTime;
    }
    formatAudioData(audioData) {
        switch(this.audioFormat.bitsPerSample){
            case 8:
                return this.formatArrayBuffer(new Int8Array(audioData), 128);
            case 16:
                return this.formatArrayBuffer(new Int16Array(audioData), 32768);
            case 32:
                return this.formatArrayBuffer(new Int32Array(audioData), 2147483648);
            default:
                throw new $6tpyr.InvalidOperationError("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
        }
    }
    formatArrayBuffer(audioData, maxValue) {
        const float32Data = new Float32Array(audioData.length);
        for(let i = 0; i < audioData.length; i++)float32Data[i] = audioData[i] / maxValue;
        return float32Data;
    }
    updateAudioBuffer() {
        if (this.samples.length === 0) return;
        const channelCount = this.audioFormat.channels;
        const bufferSource = this.audioContext.createBufferSource();
        const frameCount = this.samples.length / channelCount;
        const audioBuffer = this.audioContext.createBuffer(channelCount, frameCount, this.audioFormat.samplesPerSec);
        // TODO: Should we do the conversion in the pushAudioSample instead?
        for(let channel = 0; channel < channelCount; channel++){
            // Fill in individual channel data
            let channelOffset = channel;
            const audioData = audioBuffer.getChannelData(channel);
            for(let i = 0; i < this.samples.length; i++, channelOffset += channelCount)audioData[i] = this.samples[channelOffset];
        }
        if (this.startTime < this.audioContext.currentTime) this.startTime = this.audioContext.currentTime;
        bufferSource.buffer = audioBuffer;
        bufferSource.connect(this.gainNode);
        bufferSource.start(this.startTime);
        // Make sure we play the next sample after the current one.
        this.startTime += audioBuffer.duration;
        // Clear the samples for the next pushed data.
        this.samples = new Float32Array();
    }
    async playAudio(audioData) {
        if (this.audioContext === null) this.createAudioContext();
        const source = this.audioContext.createBufferSource();
        const destination = this.audioContext.destination;
        await this.audioContext.decodeAudioData(audioData, (newBuffer)=>{
            source.buffer = newBuffer;
            source.connect(destination);
            source.start(0);
        });
    }
}
module.exports.BaseAudioPlayer = $309d049a139efb5b$var$BaseAudioPlayer;

});

parcelRegister("2V778", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionMessageEventArgs = void 0;
class $22066c5476785e08$var$ConnectionMessageEventArgs {
    constructor(message){
        this.privConnectionMessage = message;
    }
    /**
     * Gets the <see cref="ConnectionMessage"/> associated with this <see cref="ConnectionMessageEventArgs"/>.
     */ get message() {
        return this.privConnectionMessage;
    }
    /**
     * Returns a string that represents the connection message event.
     */ toString() {
        return "Message: " + this.privConnectionMessage.toString();
    }
}
module.exports.ConnectionMessageEventArgs = $22066c5476785e08$var$ConnectionMessageEventArgs;

});

parcelRegister("bA1R2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfile = void 0;
/**
 * Defines Voice Profile class for Speaker Recognition
 * @class VoiceProfile
 */ class $86e47ec3000aa8aa$var$VoiceProfile {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} profileId - profileId of this Voice Profile.
     * @param {VoiceProfileType} profileType - profileType of this Voice Profile.
     */ constructor(profileId, profileType){
        this.privId = profileId;
        this.privProfileType = profileType;
    }
    /**
     * profileId of this Voice Profile instance
     * @member VoiceProfile.prototype.profileId
     * @function
     * @public
     * @returns {string} profileId of this Voice Profile instance.
     */ get profileId() {
        return this.privId;
    }
    /**
     * profileType of this Voice Profile instance
     * @member VoiceProfile.prototype.profileType
     * @function
     * @public
     * @returns {VoiceProfileType} profile type of this Voice Profile instance.
     */ get profileType() {
        return this.privProfileType;
    }
}
module.exports.VoiceProfile = $86e47ec3000aa8aa$var$VoiceProfile;

});

parcelRegister("iF0Jc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileEnrollmentCancellationDetails = module.exports.VoiceProfileEnrollmentResult = void 0;

var $imJeu = parcelRequire("imJeu");

var $hVlip = parcelRequire("hVlip");
/**
 * Output format
 * @class VoiceProfileEnrollmentResult
 */ class $d95c9edffa4d00ba$var$VoiceProfileEnrollmentResult {
    constructor(reason, json, statusText){
        this.privReason = reason;
        this.privProperties = new $hVlip.PropertyCollection();
        if (this.privReason !== $hVlip.ResultReason.Canceled) {
            if (!!json) {
                this.privDetails = JSON.parse(json);
                if (this.privDetails.enrollmentStatus.toLowerCase() === "enrolling") this.privReason = $hVlip.ResultReason.EnrollingVoiceProfile;
            }
        } else {
            this.privErrorDetails = statusText;
            this.privProperties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[$hVlip.CancellationErrorCode.ServiceError]);
        }
    }
    get reason() {
        return this.privReason;
    }
    get enrollmentsCount() {
        return this.privDetails.enrollmentsCount;
    }
    get enrollmentsLength() {
        return this.privDetails.enrollmentsLength;
    }
    get properties() {
        return this.privProperties;
    }
    get enrollmentResultDetails() {
        return this.privDetails;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    static FromIdentificationProfileList(json) {
        const results = [];
        for (const item of json.value){
            const reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? $hVlip.ResultReason.EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? $hVlip.ResultReason.EnrolledVoiceProfile : $hVlip.ResultReason.Canceled;
            const result = new $d95c9edffa4d00ba$var$VoiceProfileEnrollmentResult(reason, null, null);
            result.privDetails = this.getIdentificationDetails(item);
            results.push(result);
        }
        return results;
    }
    static FromVerificationProfileList(json) {
        const results = [];
        for (const item of json.value){
            const reason = item.enrollmentStatus.toLowerCase() === "enrolling" ? $hVlip.ResultReason.EnrollingVoiceProfile : item.enrollmentStatus.toLowerCase() === "enrolled" ? $hVlip.ResultReason.EnrolledVoiceProfile : $hVlip.ResultReason.Canceled;
            const result = new $d95c9edffa4d00ba$var$VoiceProfileEnrollmentResult(reason, null, null);
            result.privDetails = this.getVerificationDetails(item);
            results.push(result);
        }
        return results;
    }
    static getIdentificationDetails(json) {
        return {
            audioLength: json.audioLength ? parseFloat(json.audioLength) : 0,
            audioSpeechLength: json.audioSpeechLength ? parseFloat(json.audioSpeechLength) : 0,
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsCount: json.enrollmentsCount || 0,
            enrollmentsLength: json.enrollmentsLength ? parseFloat(json.enrollmentsLength) : 0,
            enrollmentsSpeechLength: json.enrollmentsSpeechLength ? parseFloat(json.enrollmentsSpeechLength) : 0,
            profileId: json.profileId || json.identificationProfileId,
            remainingEnrollmentsSpeechLength: json.remainingEnrollmentsSpeechLength ? parseFloat(json.remainingEnrollmentsSpeechLength) : 0
        };
    }
    static getVerificationDetails(json) {
        return {
            audioLength: json.audioLength ? parseFloat(json.audioLength) : 0,
            audioSpeechLength: json.audioSpeechLength ? parseFloat(json.audioSpeechLength) : 0,
            enrollmentStatus: json.enrollmentStatus,
            enrollmentsCount: json.enrollmentsCount,
            enrollmentsLength: json.enrollmentsLength ? parseFloat(json.enrollmentsLength) : 0,
            enrollmentsSpeechLength: json.enrollmentsSpeechLength ? parseFloat(json.enrollmentsSpeechLength) : 0,
            profileId: json.profileId || json.verificationProfileId,
            remainingEnrollmentsCount: json.remainingEnrollments || json.remainingEnrollmentsCount,
            remainingEnrollmentsSpeechLength: json.remainingEnrollmentsSpeechLength ? parseFloat(json.remainingEnrollmentsSpeechLength) : 0
        };
    }
}
module.exports.VoiceProfileEnrollmentResult = $d95c9edffa4d00ba$var$VoiceProfileEnrollmentResult;
/**
 * @class VoiceProfileEnrollmentCancellationDetails
 */ class $d95c9edffa4d00ba$var$VoiceProfileEnrollmentCancellationDetails extends $hVlip.CancellationDetailsBase {
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
    /**
     * Creates an instance of VoiceProfileEnrollmentCancellationDetails object for the canceled VoiceProfileEnrollmentResult.
     * @member VoiceProfileEnrollmentCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileEnrollmentResult} result - The result that was canceled.
     * @returns {VoiceProfileEnrollmentCancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        const reason = $hVlip.CancellationReason.Error;
        let errorCode = $hVlip.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $hVlip.CancellationErrorCode[result.properties.getProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[$hVlip.CancellationErrorCode.NoError])]; //eslint-disable-line
        return new $d95c9edffa4d00ba$var$VoiceProfileEnrollmentCancellationDetails(reason, result.errorDetails, errorCode);
    }
}
module.exports.VoiceProfileEnrollmentCancellationDetails = $d95c9edffa4d00ba$var$VoiceProfileEnrollmentCancellationDetails;

});

parcelRegister("3gSwY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileCancellationDetails = module.exports.VoiceProfileResult = void 0;

var $imJeu = parcelRequire("imJeu");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Output format
 * @class VoiceProfileResult
 */ class $261d2a6d236aee41$var$VoiceProfileResult {
    constructor(reason, statusText){
        this.privReason = reason;
        this.privProperties = new $hVlip.PropertyCollection();
        if (reason === $hVlip.ResultReason.Canceled) {
            $56OOs.Contracts.throwIfNullOrUndefined(statusText, "statusText");
            this.privErrorDetails = statusText;
            this.privProperties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[$hVlip.CancellationErrorCode.ServiceError]);
        }
    }
    get reason() {
        return this.privReason;
    }
    get properties() {
        return this.privProperties;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
}
module.exports.VoiceProfileResult = $261d2a6d236aee41$var$VoiceProfileResult;
/**
 * @class VoiceProfileCancellationDetails
 */ class $261d2a6d236aee41$var$VoiceProfileCancellationDetails extends $hVlip.CancellationDetailsBase {
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
    /**
     * Creates an instance of VoiceProfileCancellationDetails object for the canceled VoiceProfileResult.
     * @member VoiceProfileCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileResult} result - The result that was canceled.
     * @returns {VoiceProfileCancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        const reason = $hVlip.CancellationReason.Error;
        let errorCode = $hVlip.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $hVlip.CancellationErrorCode[result.properties.getProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[$hVlip.CancellationErrorCode.NoError])]; //eslint-disable-line
        return new $261d2a6d236aee41$var$VoiceProfileCancellationDetails(reason, result.errorDetails, errorCode);
    }
}
module.exports.VoiceProfileCancellationDetails = $261d2a6d236aee41$var$VoiceProfileCancellationDetails;

});

parcelRegister("caGV8", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfilePhraseResult = void 0;

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Output format
 * @class VoiceProfilePhraseResult
 */ class $8dc7b65749f6f0bb$var$VoiceProfilePhraseResult extends $hVlip.VoiceProfileResult {
    constructor(reason, statusText, type, phraseArray){
        super(reason, statusText);
        this.privPhrases = [];
        $56OOs.Contracts.throwIfNullOrUndefined(phraseArray, "phrase array");
        this.privType = type;
        if (!!phraseArray && !!phraseArray[0]) this.privPhrases = phraseArray;
    }
    get phrases() {
        return this.privPhrases;
    }
    get type() {
        return this.privType;
    }
}
module.exports.VoiceProfilePhraseResult = $8dc7b65749f6f0bb$var$VoiceProfilePhraseResult;

});

parcelRegister("4TMTZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceProfileClient = void 0;

var $imJeu = parcelRequire("imJeu");

var $a5hpj = parcelRequire("a5hpj");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Defines VoiceProfileClient class for Speaker Recognition
 * Handles operations from user for Voice Profile operations (e.g. createProfile, deleteProfile)
 * @class VoiceProfileClient
 */ class $39123b6edd15e48c$var$VoiceProfileClient extends $hVlip.Recognizer {
    /**
     * VoiceProfileClient constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer (authentication key, region, &c)
     */ constructor(speechConfig){
        $56OOs.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        const speechConfigImpl = speechConfig;
        $56OOs.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        super($a5hpj.AudioConfig.fromStreamInput($hVlip.AudioInputStream.createPushStream()), speechConfigImpl.properties, new $imJeu.VoiceProfileConnectionFactory());
        this.privProperties = speechConfigImpl.properties.clone();
        this.privVoiceAdapter = this.privReco;
        this.privDisposedVoiceAdapter = false;
    }
    /**
     * The collection of properties and their values defined for this VoiceProfileClient.
     * @member VoiceProfileClient.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this VoiceProfileClient.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member VoiceProfileClient.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member VoiceProfileClient.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $56OOs.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.createProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType Type of Voice Profile to be created
     * @param {string} lang Language string (locale) for Voice Profile
     * @return {Promise<VoiceProfile>} - Promise of a VoiceProfile.
     */ async createProfileAsync(profileType, lang) {
        const profileIds = await this.privVoiceAdapter.createProfile(profileType, lang);
        return new $hVlip.VoiceProfile(profileIds[0], profileType);
    }
    /**
     * Get current information of a voice profile
     * @member VoiceProfileClient.prototype.retrieveEnrollmentResultAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to retrieve info for
     * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
     */ async retrieveEnrollmentResultAsync(profile) {
        return this.privVoiceAdapter.retrieveEnrollmentResult(profile);
    }
    /**
     * Get all voice profiles on account with given voice profile type
     * @member VoiceProfileClient.prototype.getAllProfilesAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType profile type (identification/verification) for which to list profiles
     * @return {Promise<VoiceProfileEnrollmentResult[]>} - Promise of an array of VoiceProfileEnrollmentResults.
     */ async getAllProfilesAsync(profileType) {
        return this.privVoiceAdapter.getAllProfiles(profileType);
    /*
        const result: { json: { value: EnrollmentResultJSON[] } } = await this.privAdapter.getProfiles(profileType);
        if (profileType === VoiceProfileType.TextIndependentIdentification) {
            return VoiceProfileEnrollmentResult.FromIdentificationProfileList(result.json);
        }
        return VoiceProfileEnrollmentResult.FromVerificationProfileList(result.json);
        */ }
    /**
     * Get valid authorization phrases for voice profile enrollment
     * @member VoiceProfileClient.prototype.getActivationPhrasesAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType Profile Type to get activation phrases for
     * @param {string} lang Language string (locale) for Voice Profile
     */ async getActivationPhrasesAsync(profileType, lang) {
        return this.privVoiceAdapter.getActivationPhrases(profileType, lang);
    }
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.enrollProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to create enrollment for
     * @param {AudioConfig} audioConfig source info from which to create enrollment
     * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
     */ async enrollProfileAsync(profile, audioConfig) {
        const configImpl = audioConfig;
        $56OOs.Contracts.throwIfNullOrUndefined(configImpl, "audioConfig");
        this.audioConfig = audioConfig;
        this.privVoiceAdapter.SpeakerAudioSource = configImpl;
        return this.privVoiceAdapter.enrollProfile(profile);
    }
    /**
     * Delete a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.deleteProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to be deleted
     * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
     */ async deleteProfileAsync(profile) {
        return this.privVoiceAdapter.deleteProfile(profile);
    }
    /**
     * Remove all enrollments for a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.resetProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to be reset
     * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
     */ async resetProfileAsync(profile) {
        return this.privVoiceAdapter.resetProfile(profile);
    }
    /**
     * Clean up object and close underlying connection
     * @member VoiceProfileClient.prototype.close
     * @function
     * @async
     * @public
     */ async close() {
        await this.dispose(true);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioImpl = audioConfig;
        return new $imJeu.VoiceServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    }
    async dispose(disposing) {
        if (this.privDisposedVoiceAdapter) return;
        this.privDisposedVoiceAdapter = true;
        if (disposing) await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $imJeu.RecognizerConfig(speechConfig, this.properties);
    }
    getResult(result, successReason) {
        const response = new $hVlip.VoiceProfileResult(result.ok ? successReason : $hVlip.ResultReason.Canceled, result.statusText);
        return response;
    }
}
module.exports.VoiceProfileClient = $39123b6edd15e48c$var$VoiceProfileClient;

});

parcelRegister("4dtL3", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognizer = void 0;

var $imJeu = parcelRequire("imJeu");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Defines SpeakerRecognizer class for Speaker Recognition
 * Handles operations from user for Voice Profile operations (e.g. createProfile, deleteProfile)
 * @class SpeakerRecognizer
 */ class $311f75a67cb5ca63$var$SpeakerRecognizer extends $hVlip.Recognizer {
    /**
     * Initializes an instance of the SpeakerRecognizer.
     * @constructor
     * @param {SpeechConfig} speechConfig - The set of configuration properties.
     * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        $56OOs.Contracts.throwIfNullOrUndefined(speechConfig, "speechConfig");
        const configImpl = speechConfig;
        $56OOs.Contracts.throwIfNullOrUndefined(configImpl, "speechConfig");
        super(audioConfig, configImpl.properties, new $imJeu.SpeakerRecognitionConnectionFactory());
        this.privAudioConfigImpl = audioConfig;
        $56OOs.Contracts.throwIfNull(this.privAudioConfigImpl, "audioConfig");
        this.privDisposedSpeakerRecognizer = false;
        this.privProperties = configImpl.properties;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member SpeakerRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member SpeakerRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $56OOs.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this SpeakerRecognizer.
     * @member SpeakerRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeakerRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Get recognition result for model using given audio
     * @member SpeakerRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @async
     * @param {SpeakerIdentificationModel | SpeakerVerificationModel} model Model containing Voice Profiles to be identified
     * @param cb - Callback invoked once result is returned.
     * @param err - Callback invoked in case of an error.
     */ async recognizeOnceAsync(model) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer);
        return this.recognizeSpeakerOnceAsyncImpl(model);
    }
    /**
     * Included for compatibility
     * @member SpeakerRecognizer.prototype.close
     * @function
     * @public
     * @async
     */ async close() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer);
        await this.dispose(true);
    }
    async recognizeSpeakerOnceAsyncImpl(model) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer);
        await this.implRecognizerStop();
        const result = await this.privReco.recognizeSpeaker(model);
        await this.implRecognizerStop();
        return result;
    }
    async implRecognizerStop() {
        if (this.privReco) await this.privReco.stopRecognizing();
        return;
    }
    createRecognizerConfig(speechConfig) {
        return new $imJeu.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioImpl = audioConfig;
        return new $imJeu.SpeakerServiceRecognizer(authentication, connectionFactory, audioImpl, recognizerConfig, this);
    }
    async dispose(disposing) {
        if (this.privDisposedSpeakerRecognizer) return;
        if (disposing) {
            this.privDisposedSpeakerRecognizer = true;
            await super.dispose(disposing);
        }
    }
}
module.exports.SpeakerRecognizer = $311f75a67cb5ca63$var$SpeakerRecognizer;

});

parcelRegister("7Jd62", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerIdentificationModel = void 0;

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Defines SpeakerIdentificationModel class for Speaker Recognition
 * Model contains a set of profiles against which to identify speaker(s)
 * @class SpeakerIdentificationModel
 */ class $5a06e50e2bb02849$var$SpeakerIdentificationModel {
    constructor(profiles){
        this.privVoiceProfiles = [];
        this.privProfileIds = [];
        $56OOs.Contracts.throwIfNullOrUndefined(profiles, "VoiceProfiles");
        if (profiles.length === 0) throw new Error("Empty Voice Profiles array");
        for (const profile of profiles){
            if (profile.profileType !== $hVlip.VoiceProfileType.TextIndependentIdentification) throw new Error("Identification model can only be created from Identification profile: " + profile.profileId);
            this.privVoiceProfiles.push(profile);
            this.privProfileIds.push(profile.profileId);
        }
    }
    static fromProfiles(profiles) {
        return new $5a06e50e2bb02849$var$SpeakerIdentificationModel(profiles);
    }
    get voiceProfileIds() {
        return this.privProfileIds.join(",");
    }
    get profileIds() {
        return this.privProfileIds;
    }
    get scenario() {
        return "TextIndependentIdentification";
    }
}
module.exports.SpeakerIdentificationModel = $5a06e50e2bb02849$var$SpeakerIdentificationModel;

});

parcelRegister("7b6vs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerVerificationModel = void 0;

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Defines SpeakerVerificationModel class for Speaker Recognition
 * Model contains a profile against which to verify a speaker
 * @class SpeakerVerificationModel
 */ class $539e9b8346d41984$var$SpeakerVerificationModel {
    constructor(profile){
        $56OOs.Contracts.throwIfNullOrUndefined(profile, "VoiceProfile");
        if (profile.profileType === $hVlip.VoiceProfileType.TextIndependentIdentification) throw new Error("Verification model cannot be created from Identification profile");
        this.privVoiceProfile = profile;
    }
    static fromProfile(profile) {
        return new $539e9b8346d41984$var$SpeakerVerificationModel(profile);
    }
    get voiceProfile() {
        return this.privVoiceProfile;
    }
    get profileIds() {
        return [
            this.voiceProfile.profileId
        ];
    }
    get scenario() {
        if (this.voiceProfile.profileType === $hVlip.VoiceProfileType.TextDependentVerification) return "TextDependentVerification";
        else return "TextIndependentVerification";
    }
}
module.exports.SpeakerVerificationModel = $539e9b8346d41984$var$SpeakerVerificationModel;

});

parcelRegister("axnB6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageConfig = void 0;

var $imJeu = parcelRequire("imJeu");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $ehgcV = parcelRequire("ehgcV");
/**
 * Language auto detect configuration.
 * @class AutoDetectSourceLanguageConfig
 * Added in version 1.13.0.
 */ class $7abf4a620bf15c0d$var$AutoDetectSourceLanguageConfig {
    constructor(){
        this.privProperties = new $hVlip.PropertyCollection();
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart");
        this.privLanguageIdMode = $ehgcV.LanguageIdMode.AtStart;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromOpenRange
     * @function
     * @public
     * Only [[SpeechSynthesizer]] supports source language auto detection from open range,
     * for [[Recognizer]], please use AutoDetectSourceLanguageConfig with specific source languages.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with open range.
     */ static fromOpenRange() {
        const config = new $7abf4a620bf15c0d$var$AutoDetectSourceLanguageConfig();
        config.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, $imJeu.AutoDetectSourceLanguagesOpenRangeOptionName);
        return config;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromLanguages
     * @function
     * @public
     * @param {string[]} languages Comma-separated string of languages (eg. "en-US,fr-FR") to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given languages.
     */ static fromLanguages(languages) {
        $56OOs.Contracts.throwIfArrayEmptyOrWhitespace(languages, "languages");
        const config = new $7abf4a620bf15c0d$var$AutoDetectSourceLanguageConfig();
        config.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, languages.join());
        return config;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs
     * @function
     * @public
     * @param {SourceLanguageConfig[]} configs SourceLanguageConfigs to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given SourceLanguageConfigs.
     */ static fromSourceLanguageConfigs(configs) {
        if (configs.length < 1) throw new Error("Expected non-empty SourceLanguageConfig array.");
        const autoConfig = new $7abf4a620bf15c0d$var$AutoDetectSourceLanguageConfig();
        const langs = [];
        configs.forEach((config)=>{
            langs.push(config.language);
            if (config.endpointId !== undefined && config.endpointId !== "") {
                const customProperty = config.language + $hVlip.PropertyId.SpeechServiceConnection_EndpointId.toString();
                autoConfig.properties.setProperty(customProperty, config.endpointId);
            }
        });
        autoConfig.properties.setProperty($hVlip.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, langs.join());
        return autoConfig;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.prototype.properties
     * @function
     * @public
     * @return {PropertyCollection} Properties of the config.
     * @summary Gets an auto detected language config properties
     */ get properties() {
        return this.privProperties;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.prototype.mode
     * @function
     * @public
     * @param {LanguageIdMode} mode LID mode desired.
     * @summary Sets LID operation to desired mode
     */ set mode(mode) {
        if (mode === $ehgcV.LanguageIdMode.Continuous) {
            this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2");
            this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_LanguageIdMode, "Continuous");
        } else {
            this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "1");
            this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart");
        }
        this.privLanguageIdMode = mode;
    }
}
module.exports.AutoDetectSourceLanguageConfig = $7abf4a620bf15c0d$var$AutoDetectSourceLanguageConfig;

});
parcelRegister("ehgcV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LanguageIdMode = void 0;
/**
 * Language Identification mode
 * @class LanguageIdMode
 */ var $a64f39b55d38a68e$var$LanguageIdMode;
(function(LanguageIdMode) {
    /**
     * Detect language at audio start
     * @member LanguageIdMode.AtStart
     */ LanguageIdMode[LanguageIdMode["AtStart"] = 0] = "AtStart";
    /**
     * Continuously detect language
     * @member LanguageIdMode.Continuous
     */ LanguageIdMode[LanguageIdMode["Continuous"] = 1] = "Continuous";
})($a64f39b55d38a68e$var$LanguageIdMode = module.exports.LanguageIdMode || (module.exports.LanguageIdMode = {}));

});


parcelRegister("gslJ7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AutoDetectSourceLanguageResult = void 0;

var $56OOs = parcelRequire("56OOs");
/**
 * Output format
 * @class AutoDetectSourceLanguageResult
 */ class $bfb01d564cc820a8$var$AutoDetectSourceLanguageResult {
    constructor(language, languageDetectionConfidence){
        $56OOs.Contracts.throwIfNullOrUndefined(language, "language");
        $56OOs.Contracts.throwIfNullOrUndefined(languageDetectionConfidence, "languageDetectionConfidence");
        this.privLanguage = language;
        this.privLanguageDetectionConfidence = languageDetectionConfidence;
    }
    /**
     * Creates an instance of AutoDetectSourceLanguageResult object from a SpeechRecognitionResult instance.
     * @member AutoDetectSourceLanguageResult.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult} result - The recognition result.
     * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
     */ static fromResult(result) {
        return new $bfb01d564cc820a8$var$AutoDetectSourceLanguageResult(result.language, result.languageDetectionConfidence);
    }
    /**
     * Creates an instance of AutoDetectSourceLanguageResult object from a ConversationTranscriptionResult instance.
     * @member AutoDetectSourceLanguageResult.fromConversationTranscriptionResult
     * @function
     * @public
     * @param {ConversationTranscriptionResult} result - The transcription result.
     * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
     */ static fromConversationTranscriptionResult(result) {
        return new $bfb01d564cc820a8$var$AutoDetectSourceLanguageResult(result.language, result.languageDetectionConfidence);
    }
    get language() {
        return this.privLanguage;
    }
    get languageDetectionConfidence() {
        return this.privLanguageDetectionConfidence;
    }
}
module.exports.AutoDetectSourceLanguageResult = $bfb01d564cc820a8$var$AutoDetectSourceLanguageResult;

});

parcelRegister("gDezv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SourceLanguageConfig = void 0;

var $56OOs = parcelRequire("56OOs");
/**
 * Source Language configuration.
 * @class SourceLanguageConfig
 */ class $c1bb977da45b3b94$var$SourceLanguageConfig {
    constructor(language, endpointId){
        $56OOs.Contracts.throwIfNullOrUndefined(language, "language");
        this.privLanguage = language;
        this.privEndpointId = endpointId;
    }
    /**
     * @member SourceLanguageConfig.fromLanguage
     * @function
     * @public
     * @param {string} language language (eg. "en-US") value of config.
     * @param {string?} endpointId endpointId of model bound to given language of config.
     * @return {SourceLanguageConfig} Instance of SourceLanguageConfig
     * @summary Creates an instance of the SourceLanguageConfig with the given language and optional endpointId.
     * Added in version 1.13.0.
     */ static fromLanguage(language, endpointId) {
        return new $c1bb977da45b3b94$var$SourceLanguageConfig(language, endpointId);
    }
    get language() {
        return this.privLanguage;
    }
    get endpointId() {
        return this.privEndpointId;
    }
}
module.exports.SourceLanguageConfig = $c1bb977da45b3b94$var$SourceLanguageConfig;

});

parcelRegister("86Knn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognitionCancellationDetails = module.exports.SpeakerRecognitionResult = module.exports.SpeakerRecognitionResultType = void 0;

var $imJeu = parcelRequire("imJeu");

var $hVlip = parcelRequire("hVlip");
var $5e72db96e281873e$var$SpeakerRecognitionResultType;
(function(SpeakerRecognitionResultType) {
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Verify"] = 0] = "Verify";
    SpeakerRecognitionResultType[SpeakerRecognitionResultType["Identify"] = 1] = "Identify";
})($5e72db96e281873e$var$SpeakerRecognitionResultType = module.exports.SpeakerRecognitionResultType || (module.exports.SpeakerRecognitionResultType = {}));
/**
 * Output format
 * @class SpeakerRecognitionResult
 */ class $5e72db96e281873e$var$SpeakerRecognitionResult {
    constructor(response, resultReason = $hVlip.ResultReason.RecognizedSpeaker, cancellationErrorCode = $hVlip.CancellationErrorCode.NoError, errorDetails = ""){
        this.privProperties = new $hVlip.PropertyCollection();
        const resultType = response.scenario === "TextIndependentIdentification" ? $5e72db96e281873e$var$SpeakerRecognitionResultType.Identify : $5e72db96e281873e$var$SpeakerRecognitionResultType.Verify;
        this.privReason = resultReason;
        if (this.privReason !== $hVlip.ResultReason.Canceled) {
            if (resultType === $5e72db96e281873e$var$SpeakerRecognitionResultType.Identify) {
                this.privProfileId = response.identificationResult.identifiedProfile.profileId;
                this.privScore = response.identificationResult.identifiedProfile.score;
                this.privReason = $hVlip.ResultReason.RecognizedSpeakers;
            } else {
                this.privScore = response.verificationResult.score;
                if (response.verificationResult.recognitionResult.toLowerCase() !== "accept") this.privReason = $hVlip.ResultReason.NoMatch;
                if (response.verificationResult.profileId !== undefined && response.verificationResult.profileId !== "") this.privProfileId = response.verificationResult.profileId;
            }
        } else {
            this.privErrorDetails = errorDetails;
            this.privProperties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[cancellationErrorCode]);
        }
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, JSON.stringify(response));
    }
    get properties() {
        return this.privProperties;
    }
    get reason() {
        return this.privReason;
    }
    get profileId() {
        return this.privProfileId;
    }
    get errorDetails() {
        return this.privErrorDetails;
    }
    get score() {
        return this.privScore;
    }
}
module.exports.SpeakerRecognitionResult = $5e72db96e281873e$var$SpeakerRecognitionResult;
/**
 * @class SpeakerRecognitionCancellationDetails
 */ class $5e72db96e281873e$var$SpeakerRecognitionCancellationDetails extends $hVlip.CancellationDetailsBase {
    constructor(reason, errorDetails, errorCode){
        super(reason, errorDetails, errorCode);
    }
    /**
     * Creates an instance of SpeakerRecognitionCancellationDetails object for the canceled SpeakerRecognitionResult
     * @member SpeakerRecognitionCancellationDetails.fromResult
     * @function
     * @public
     * @param {SpeakerRecognitionResult} result - The result that was canceled.
     * @returns {SpeakerRecognitionCancellationDetails} The cancellation details object being created.
     */ static fromResult(result) {
        const reason = $hVlip.CancellationReason.Error;
        let errorCode = $hVlip.CancellationErrorCode.NoError;
        if (!!result.properties) errorCode = $hVlip.CancellationErrorCode[result.properties.getProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[$hVlip.CancellationErrorCode.NoError])];
        return new $5e72db96e281873e$var$SpeakerRecognitionCancellationDetails(reason, result.errorDetails, errorCode);
    }
}
module.exports.SpeakerRecognitionCancellationDetails = $5e72db96e281873e$var$SpeakerRecognitionCancellationDetails;

});

parcelRegister("8hU6U", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5QB9Z = parcelRequire("5QB9Z");
Object.defineProperty(module.exports, "Conversation", {
    enumerable: true,
    get: function() {
        return $5QB9Z.Conversation;
    }
});
Object.defineProperty(module.exports, "ConversationImpl", {
    enumerable: true,
    get: function() {
        return $5QB9Z.ConversationImpl;
    }
});

var $kshBJ = parcelRequire("kshBJ");
Object.defineProperty(module.exports, "ConversationCommon", {
    enumerable: true,
    get: function() {
        return $kshBJ.ConversationCommon;
    }
});

var $kN9wz = parcelRequire("kN9wz");
Object.defineProperty(module.exports, "ConversationExpirationEventArgs", {
    enumerable: true,
    get: function() {
        return $kN9wz.ConversationExpirationEventArgs;
    }
});

var $cumFV = parcelRequire("cumFV");
Object.defineProperty(module.exports, "ConversationParticipantsChangedEventArgs", {
    enumerable: true,
    get: function() {
        return $cumFV.ConversationParticipantsChangedEventArgs;
    }
});

var $lXVwN = parcelRequire("lXVwN");
Object.defineProperty(module.exports, "ConversationTranslationCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $lXVwN.ConversationTranslationCanceledEventArgs;
    }
});

var $3esY9 = parcelRequire("3esY9");
Object.defineProperty(module.exports, "ConversationTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $3esY9.ConversationTranslationEventArgs;
    }
});

var $9DZ3C = parcelRequire("9DZ3C");
Object.defineProperty(module.exports, "ConversationTranslationResult", {
    enumerable: true,
    get: function() {
        return $9DZ3C.ConversationTranslationResult;
    }
});

var $l2kVY = parcelRequire("l2kVY");
Object.defineProperty(module.exports, "ConversationTranslator", {
    enumerable: true,
    get: function() {
        return $l2kVY.ConversationTranslator;
    }
});

var $2WrCG = parcelRequire("2WrCG");
Object.defineProperty(module.exports, "ConversationTranscriber", {
    enumerable: true,
    get: function() {
        return $2WrCG.ConversationTranscriber;
    }
});

var $blCur = parcelRequire("blCur");
Object.defineProperty(module.exports, "Participant", {
    enumerable: true,
    get: function() {
        return $blCur.Participant;
    }
});
Object.defineProperty(module.exports, "User", {
    enumerable: true,
    get: function() {
        return $blCur.User;
    }
});

var $h10C7 = parcelRequire("h10C7");
Object.defineProperty(module.exports, "ParticipantChangedReason", {
    enumerable: true,
    get: function() {
        return $h10C7.ParticipantChangedReason;
    }
});

var $bHcQR = parcelRequire("bHcQR");
Object.defineProperty(module.exports, "Meeting", {
    enumerable: true,
    get: function() {
        return $bHcQR.Meeting;
    }
});
Object.defineProperty(module.exports, "MeetingImpl", {
    enumerable: true,
    get: function() {
        return $bHcQR.MeetingImpl;
    }
});

var $6QpVH = parcelRequire("6QpVH");
Object.defineProperty(module.exports, "MeetingTranscriptionCanceledEventArgs", {
    enumerable: true,
    get: function() {
        return $6QpVH.MeetingTranscriptionCanceledEventArgs;
    }
});

var $etz6e = parcelRequire("etz6e");
Object.defineProperty(module.exports, "MeetingTranscriber", {
    enumerable: true,
    get: function() {
        return $etz6e.MeetingTranscriber;
    }
});

var $2pASc = parcelRequire("2pASc");
Object.defineProperty(module.exports, "ConversationTranscriptionResult", {
    enumerable: true,
    get: function() {
        return $2pASc.ConversationTranscriptionResult;
    }
});

});
parcelRegister("5QB9Z", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationImpl = module.exports.Conversation = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
class $441ea2514bf18a99$var$Conversation {
    constructor(){
        return;
    }
    /**
     * Create a conversation
     * @param speechConfig
     * @param cb
     * @param err
     */ static createConversationAsync(speechConfig, arg2, arg3, arg4) {
        $56OOs.Contracts.throwIfNullOrUndefined(speechConfig, $imJeu.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config"));
        $56OOs.Contracts.throwIfNullOrUndefined(speechConfig.region, $imJeu.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region"));
        if (!speechConfig.subscriptionKey && !speechConfig.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceAuthorization_Token])) $56OOs.Contracts.throwIfNullOrUndefined(speechConfig.subscriptionKey, $imJeu.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        let conversationImpl;
        let cb;
        let err;
        if (typeof arg2 === "string") {
            conversationImpl = new $441ea2514bf18a99$var$ConversationImpl(speechConfig, arg2);
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            $3wpON.marshalPromiseToCallbacks((async ()=>{})(), arg3, arg4);
        } else {
            conversationImpl = new $441ea2514bf18a99$var$ConversationImpl(speechConfig);
            cb = arg2;
            err = arg3;
            conversationImpl.createConversationAsync(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        }
        return conversationImpl;
    }
}
module.exports.Conversation = $441ea2514bf18a99$var$Conversation;
class $441ea2514bf18a99$var$ConversationImpl extends $441ea2514bf18a99$var$Conversation {
    /**
     * Create a conversation impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */ constructor(speechConfig, id){
        super();
        this.privErrors = $imJeu.ConversationConnectionConfig.restErrors;
        /** websocket callbacks */ /* eslint-disable @typescript-eslint/typedef */ this.onConnected = (e)=>{
            this.privIsConnected = true;
            try {
                if (!!this.privConversationTranslator?.sessionStarted) this.privConversationTranslator.sessionStarted(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onDisconnected = (e)=>{
            try {
                if (!!this.privConversationTranslator?.sessionStopped) this.privConversationTranslator.sessionStopped(this.privConversationTranslator, e);
            } catch (e) {
            //
            } finally{
                this.close(false);
            }
        };
        this.onCanceled = (r, e)=>{
            try {
                if (!!this.privConversationTranslator?.canceled) this.privConversationTranslator.canceled(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onParticipantUpdateCommandReceived = (r, e)=>{
            try {
                const updatedParticipant = this.privParticipants.getParticipant(e.id);
                if (updatedParticipant !== undefined) {
                    switch(e.key){
                        case $imJeu.ConversationTranslatorCommandTypes.changeNickname:
                            updatedParticipant.displayName = e.value;
                            break;
                        case $imJeu.ConversationTranslatorCommandTypes.setUseTTS:
                            updatedParticipant.isUsingTts = e.value;
                            break;
                        case $imJeu.ConversationTranslatorCommandTypes.setProfanityFiltering:
                            updatedParticipant.profanity = e.value;
                            break;
                        case $imJeu.ConversationTranslatorCommandTypes.setMute:
                            updatedParticipant.isMuted = e.value;
                            break;
                        case $imJeu.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                            updatedParticipant.translateToLanguages = e.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(updatedParticipant);
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.Updated, [
                        this.toParticipant(updatedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onLockRoomCommandReceived = ()=>{
        // TODO
        };
        this.onMuteAllCommandReceived = (r, e)=>{
            try {
                this.privParticipants.participants.forEach((p)=>p.isMuted = p.isHost ? false : e.isMuted);
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.Updated, this.toParticipants(false), e.sessionId));
            } catch (e) {
            //
            }
        };
        this.onParticipantJoinCommandReceived = (r, e)=>{
            try {
                const newParticipant = this.privParticipants.addOrUpdateParticipant(e.participant);
                if (newParticipant !== undefined) {
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.JoinedConversation, [
                        this.toParticipant(newParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantLeaveCommandReceived = (r, e)=>{
            try {
                const ejectedParticipant = this.privParticipants.getParticipant(e.participant.id);
                if (ejectedParticipant !== undefined) {
                    // remove the participant from the internal participants list
                    this.privParticipants.deleteParticipant(e.participant.id);
                    if (!!this.privConversationTranslator) // notify subscribers that the participant has left the conversation
                    this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.LeftConversation, [
                        this.toParticipant(ejectedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onTranslationReceived = (r, e)=>{
            try {
                switch(e.command){
                    case $imJeu.ConversationTranslatorMessageTypes.final:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribed(this.privConversationTranslator, new $hVlip.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $imJeu.ConversationTranslatorMessageTypes.partial:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribing(this.privConversationTranslator, new $hVlip.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $imJeu.ConversationTranslatorMessageTypes.instantMessage:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $hVlip.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantsListReceived = (r, e)=>{
            try {
                // check if the session token needs to be updated
                if (e.sessionToken !== undefined && e.sessionToken !== null) this.privRoom.token = e.sessionToken;
                // save the participants
                this.privParticipants.participants = [
                    ...e.participants
                ];
                // enable the conversation
                if (this.privParticipants.me !== undefined) this.privIsReady = true;
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.JoinedConversation, this.toParticipants(true), e.sessionId));
                // if this is the host, update the nickname if needed
                if (this.me.isHost) {
                    const nickname = this.privConversationTranslator?.properties.getProperty($hVlip.PropertyId.ConversationTranslator_Name);
                    if (nickname !== undefined && nickname.length > 0 && nickname !== this.me.displayName) // issue a change nickname request
                    this.changeNicknameAsync(nickname);
                }
            } catch (e) {
            //
            }
        };
        this.onConversationExpiration = (r, e)=>{
            try {
                if (!!this.privConversationTranslator) this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.privIsConnected = false;
        this.privIsDisposed = false;
        this.privConversationId = "";
        this.privProperties = new $hVlip.PropertyCollection();
        this.privManager = new $imJeu.ConversationManager();
        // check the speech language
        const language = speechConfig.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!language) speechConfig.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage], $imJeu.ConversationConnectionConfig.defaultLanguageCode);
        this.privLanguage = speechConfig.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!id) {
            // check the target language(s)
            if (speechConfig.targetLanguages.length === 0) speechConfig.addTargetLanguage(this.privLanguage);
            // check the profanity setting: speech and conversationTranslator should be in sync
            const profanity = speechConfig.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceResponse_ProfanityOption]);
            if (!profanity) speechConfig.setProfanity($hVlip.ProfanityOption.Masked);
            // check the nickname: it should pass this regex: ^\w+([\s-][\w\(\)]+)*$"
            // TODO: specify the regex required. Nicknames must be unique or get the duplicate nickname error
            // TODO: check what the max length is and if a truncation is required or if the service handles it without an error
            let hostNickname = speechConfig.getProperty($hVlip.PropertyId[$hVlip.PropertyId.ConversationTranslator_Name]);
            if (hostNickname === undefined || hostNickname === null) hostNickname = "Host";
            $56OOs.Contracts.throwIfNullOrTooLong(hostNickname, "nickname", 50);
            $56OOs.Contracts.throwIfNullOrTooShort(hostNickname, "nickname", 2);
            speechConfig.setProperty($hVlip.PropertyId[$hVlip.PropertyId.ConversationTranslator_Name], hostNickname);
        } else this.privConversationId = id;
        // save the speech config for future usage
        this.privConfig = speechConfig;
        // save the config properties
        const configImpl = speechConfig;
        $56OOs.Contracts.throwIfNull(configImpl, "speechConfig");
        this.privProperties = configImpl.properties.clone();
        this.privIsConnected = false;
        this.privParticipants = new $imJeu.InternalParticipants();
        this.privIsReady = false;
        this.privTextMessageMaxLength = 1000;
    }
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer; // this.privConnection;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the conversation Id
    get conversationId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        return this.privParticipants.me?.isHost ? false : this.privParticipants.me?.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(true);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get conversationInfo() {
        const convId = this.conversationId;
        const p = this.participants.map((part)=>({
                id: part.id,
                preferredLanguage: part.preferredLanguage,
                voice: part.voice
            }));
        const props = {};
        for (const key of $imJeu.ConversationConnectionConfig.transcriptionEventKeys){
            const val = this.properties.getProperty(key, "");
            if (val !== "") props[key] = val;
        }
        const info = {
            id: convId,
            participants: p,
            conversationProperties: props
        };
        return info;
    }
    get canSend() {
        return this.privIsConnected && !this.privParticipants.me?.isMuted;
    }
    get canSendAsHost() {
        return this.privIsConnected && this.privParticipants.me?.isHost;
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(value) {
        $56OOs.Contracts.throwIfNullOrWhitespace(value, "authorizationToken");
        this.privToken = value;
    }
    set conversationTranslator(conversationTranslator) {
        this.privConversationTranslator = conversationTranslator;
    }
    onToken(token) {
        this.privConversationTranslator.onToken(token);
    }
    /**
     * Create a new conversation as Host
     * @param cb
     * @param err
     */ createConversationAsync(cb, err) {
        try {
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            this.privManager.createOrJoin(this.privProperties, undefined, (room)=>{
                if (!room) this.handleError(new Error(this.privErrors.permissionDeniedConnect), err);
                this.privRoom = room;
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Starts a new conversation as host.
     * @param cb
     * @param err
     */ startConversationAsync(cb, err) {
        try {
            // check if there is already a recognizer
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            // check if there is conversation data available
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect);
            // connect to the conversation websocket
            this.privParticipants.meId = this.privRoom.participantId;
            this.privConversationRecognizer = $imJeu.ConversationRecognizerFactory.fromConfig(this, this.privConfig);
            // Because ConversationTranslator manually sets up and manages the connection, Conversation
            // has to forward serviceRecognizer connection events that usually get passed automatically
            this.privConversationRecognizer.connected = this.onConnected;
            this.privConversationRecognizer.disconnected = this.onDisconnected;
            this.privConversationRecognizer.canceled = this.onCanceled;
            this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived;
            this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived;
            this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived;
            this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived;
            this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived;
            this.privConversationRecognizer.translationReceived = this.onTranslationReceived;
            this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived;
            this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration;
            this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Join a conversation as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */ addParticipantAsync(participant, cb, err) {
        $56OOs.Contracts.throwIfNullOrUndefined(participant, "Participant");
        $3wpON.marshalPromiseToCallbacks(this.addParticipantImplAsync(participant), cb, err);
    }
    /**
     * Join a conversation as a participant.
     * @param conversation
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */ joinConversationAsync(conversationId, nickname, lang, cb, err) {
        try {
            // TODO
            // if (!!this.privConversationRecognizer) {
            //     throw new Error(this.privErrors.permissionDeniedStart);
            // }
            $56OOs.Contracts.throwIfNullOrWhitespace(conversationId, this.privErrors.invalidArgs.replace("{arg}", "conversationId"));
            $56OOs.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $56OOs.Contracts.throwIfNullOrWhitespace(lang, this.privErrors.invalidArgs.replace("{arg}", "language"));
            // join the conversation
            this.privManager.createOrJoin(this.privProperties, conversationId, (room)=>{
                $56OOs.Contracts.throwIfNullOrUndefined(room, this.privErrors.permissionDeniedConnect);
                this.privRoom = room;
                this.privConfig.authorizationToken = room.cognitiveSpeechAuthToken;
                // join callback
                if (!!cb) cb(room.cognitiveSpeechAuthToken);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Deletes a conversation
     * @param cb
     * @param err
     */ deleteConversationAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.deleteConversationImplAsync(), cb, err);
    }
    async deleteConversationImplAsync() {
        $56OOs.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect);
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect);
        await this.privManager.leave(this.privProperties, this.privRoom.token);
        this.dispose();
    }
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */ endConversationAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.endConversationImplAsync(), cb, err);
    }
    endConversationImplAsync() {
        return this.close(true);
    }
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */ lockConversationAsync(cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute the conversation
     * @param cb
     * @param err
     */ muteAllParticipantsAsync(cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend);
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the user's permissions
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ muteParticipantAsync(userId, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */ removeParticipantAsync(userId, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            if (!!this.privTranscriberRecognizer && userId.hasOwnProperty("id")) // Assume this is a transcription participant
            $3wpON.marshalPromiseToCallbacks(this.removeParticipantImplAsync(userId), cb, err);
            else {
                $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
                $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
                if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), err);
                let participantId = "";
                if (typeof userId === "string") participantId = userId;
                else if (userId.hasOwnProperty("id")) {
                    const participant = userId;
                    participantId = participant.id;
                } else if (userId.hasOwnProperty("userId")) {
                    const user = userId;
                    participantId = user.userId;
                }
                $56OOs.Contracts.throwIfNullOrWhitespace(participantId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
                // check the participant exists
                const index = this.participants.findIndex((p)=>p.id === participantId);
                if (index === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
                if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getEjectCommand(participantId), ()=>{
                    this.handleCallback(cb, err);
                }, (error)=>{
                    this.handleError(error, err);
                });
            }
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unlock the conversation
     * @param cb
     * @param err
     */ unlockConversationAsync(cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute all participants in the conversation
     * @param cb
     * @param err
     */ unmuteAllParticipantsAsync(cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */ unmuteParticipantAsync(userId, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ sendTextMessageAsync(message, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", "message"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // TODO: is a max length check required?
            if (message.length > this.privTextMessageMaxLength) this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMessageCommand(message), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Set translated to languages
     * @param {string[]} languages - languages to translate to
     * @param cb
     * @param err
     */ setTranslatedLanguagesAsync(languages, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfArrayEmptyOrWhitespace(languages, this.privErrors.invalidArgs.replace("{arg}", "languages"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(languages), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Change nickname
     * @param {string} nickname - new nickname for the room
     * @param cb
     * @param err
     */ changeNicknameAsync(nickname, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(nickname), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        if (this.isDisposed) return;
        this.privIsDisposed = true;
        if (!!this.config) this.config.close();
        this.privConfig = undefined;
        this.privLanguage = undefined;
        this.privProperties = undefined;
        this.privRoom = undefined;
        this.privToken = undefined;
        this.privManager = undefined;
        this.privIsConnected = false;
        this.privIsReady = false;
        this.privParticipants = undefined;
    }
    async connectTranscriberRecognizer(recognizer) {
        if (!!this.privTranscriberRecognizer) await this.privTranscriberRecognizer.close();
        await recognizer.enforceAudioGating();
        this.privTranscriberRecognizer = recognizer;
        this.privTranscriberRecognizer.conversation = this;
    }
    getKeepAlive() {
        const nickname = !!this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(participant) {
        const newParticipant = this.privParticipants.addOrUpdateParticipant(participant);
        if (newParticipant !== undefined) {
            if (!!this.privTranscriberRecognizer) {
                const conversationInfo = this.conversationInfo;
                conversationInfo.participants = [
                    participant
                ];
                return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "join");
            }
        }
    }
    removeParticipantImplAsync(participant) {
        this.privParticipants.deleteParticipant(participant.id);
        const conversationInfo = this.conversationInfo;
        conversationInfo.participants = [
            participant
        ];
        return this.privTranscriberRecognizer.pushConversationEvent(conversationInfo, "leave");
    }
    async close(dispose) {
        try {
            this.privIsConnected = false;
            await this.privConversationRecognizer?.close();
            this.privConversationRecognizer = undefined;
            if (!!this.privConversationTranslator) this.privConversationTranslator.dispose();
        } catch (e) {
            // ignore error
            throw e;
        }
        if (dispose) this.dispose();
    }
    /** Helpers */ handleCallback(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    }
    handleError(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    }
    /** Participant Helpers */ toParticipants(includeHost) {
        const participants = this.privParticipants.participants.map((p)=>this.toParticipant(p));
        if (!includeHost) return participants.filter((p)=>p.isHost === false);
        else return participants;
    }
    toParticipant(p) {
        return new $hVlip.Participant(p.id, p.avatar, p.displayName, p.isHost, p.isMuted, p.isUsingTts, p.preferredLanguage, p.voice);
    }
    getMuteAllCommand(isMuted) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getMuteCommand(participantId, isMuted) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getLockCommand(isLocked) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: isLocked
        });
    }
    getEjectCommand(participantId) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(languages) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: languages
        });
    }
    getChangeNicknameCommand(nickname) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.changeNickname,
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: nickname
        });
    }
    getMessageCommand(message) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        $56OOs.Contracts.throwIfNullOrWhitespace(message, "message");
        return JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: message,
            type: $imJeu.ConversationTranslatorMessageTypes.instantMessage
        });
    }
}
module.exports.ConversationImpl = $441ea2514bf18a99$var$ConversationImpl;

});

parcelRegister("kshBJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationCommon = void 0;
class $ee4414aa2a862348$var$ConversationCommon {
    constructor(audioConfig){
        this.privAudioConfig = audioConfig;
    }
    handleCallback(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    }
    handleError(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    }
}
module.exports.ConversationCommon = $ee4414aa2a862348$var$ConversationCommon;

});

parcelRegister("kN9wz", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationExpirationEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
class $f22fc59bcbe5679e$var$ConversationExpirationEventArgs extends $hVlip.SessionEventArgs {
    constructor(expirationTime, sessionId){
        super(sessionId);
        this.privExpirationTime = expirationTime;
    }
    /** How much longer until the conversation expires (in minutes). */ get expirationTime() {
        return this.privExpirationTime;
    }
}
module.exports.ConversationExpirationEventArgs = $f22fc59bcbe5679e$var$ConversationExpirationEventArgs;

});

parcelRegister("cumFV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationParticipantsChangedEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
class $9179e039697b1acf$var$ConversationParticipantsChangedEventArgs extends $hVlip.SessionEventArgs {
    constructor(reason, participants, sessionId){
        super(sessionId);
        this.privReason = reason;
        this.privParticipant = participants;
    }
    get reason() {
        return this.privReason;
    }
    get participants() {
        return this.privParticipant;
    }
}
module.exports.ConversationParticipantsChangedEventArgs = $9179e039697b1acf$var$ConversationParticipantsChangedEventArgs;

});

parcelRegister("lXVwN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationCanceledEventArgs = void 0;

var $6sMHZ = parcelRequire("6sMHZ");
class $ffdbbb7eb82015ef$var$ConversationTranslationCanceledEventArgs extends $6sMHZ.CancellationEventArgsBase {
}
module.exports.ConversationTranslationCanceledEventArgs = $ffdbbb7eb82015ef$var$ConversationTranslationCanceledEventArgs;

});

parcelRegister("3esY9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
class $25a926996abd7f42$var$ConversationTranslationEventArgs extends $hVlip.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranslationResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */ constructor(result, offset, sessionId){
        super(offset, sessionId);
        this.privResult = result;
    }
    /**
     * Specifies the recognition result.
     * @returns {ConversationTranslationResult} the recognition result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.ConversationTranslationEventArgs = $25a926996abd7f42$var$ConversationTranslationEventArgs;

});

parcelRegister("9DZ3C", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslationResult = void 0;

var $5puUG = parcelRequire("5puUG");
class $70571e524d9a4ce8$var$ConversationTranslationResult extends $5puUG.TranslationRecognitionResult {
    constructor(participantId, translations, originalLanguage, resultId, reason, text, duration, offset, errorDetails, json, properties){
        super(translations, resultId, reason, text, duration, offset, undefined, undefined, errorDetails, json, properties);
        this.privId = participantId;
        this.privOrigLang = originalLanguage;
    }
    /**
     * The unique identifier for the participant this result is for.
     */ get participantId() {
        return this.privId;
    }
    /**
     * The original language this result was in.
     */ get originalLang() {
        return this.privOrigLang;
    }
}
module.exports.ConversationTranslationResult = $70571e524d9a4ce8$var$ConversationTranslationResult;

});

parcelRegister("l2kVY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslator = module.exports.SpeechState = void 0;

var $imJeu = parcelRequire("imJeu");

var $h5yDK = parcelRequire("h5yDK");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $5QB9Z = parcelRequire("5QB9Z");

var $8hU6U = parcelRequire("8hU6U");
var $f50a05f4e923bedd$var$SpeechState;
(function(SpeechState) {
    SpeechState[SpeechState["Inactive"] = 0] = "Inactive";
    SpeechState[SpeechState["Connecting"] = 1] = "Connecting";
    SpeechState[SpeechState["Connected"] = 2] = "Connected";
})($f50a05f4e923bedd$var$SpeechState = module.exports.SpeechState || (module.exports.SpeechState = {}));
// child class of TranslationRecognizer meant only for use with ConversationTranslator
class $f50a05f4e923bedd$var$ConversationTranslationRecognizer extends $hVlip.TranslationRecognizer {
    constructor(speechConfig, audioConfig, translator, convGetter){
        super(speechConfig, audioConfig, new $h5yDK.ConversationTranslatorConnectionFactory(convGetter));
        this.privSpeechState = $f50a05f4e923bedd$var$SpeechState.Inactive;
        if (!!translator) {
            this.privTranslator = translator;
            this.sessionStarted = ()=>{
                this.privSpeechState = $f50a05f4e923bedd$var$SpeechState.Connected;
            };
            this.sessionStopped = ()=>{
                this.privSpeechState = $f50a05f4e923bedd$var$SpeechState.Inactive;
            };
            this.recognizing = (tr, e)=>{
                if (!!this.privTranslator.recognizing) this.privTranslator.recognizing(this.privTranslator, e);
            };
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.recognized = async (tr, e)=>{
                // if there is an error connecting to the conversation service from the speech service the error will be returned in the ErrorDetails field.
                if (e.result?.errorDetails) {
                    await this.cancelSpeech();
                    // TODO: format the error message contained in 'errorDetails'
                    this.fireCancelEvent(e.result.errorDetails);
                } else if (!!this.privTranslator.recognized) this.privTranslator.recognized(this.privTranslator, e);
                return;
            };
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.canceled = async ()=>{
                if (this.privSpeechState !== $f50a05f4e923bedd$var$SpeechState.Inactive) try {
                    await this.cancelSpeech();
                } catch (error) {
                    this.privSpeechState = $f50a05f4e923bedd$var$SpeechState.Inactive;
                }
            };
        }
    }
    get state() {
        return this.privSpeechState;
    }
    set state(newState) {
        this.privSpeechState = newState;
    }
    set authentication(token) {
        this.privReco.authentication = token;
    }
    onConnection() {
        this.privSpeechState = $f50a05f4e923bedd$var$SpeechState.Connected;
    }
    async onCancelSpeech() {
        this.privSpeechState = $f50a05f4e923bedd$var$SpeechState.Inactive;
        await this.cancelSpeech();
    }
    /**
     * Fire a cancel event
     * @param error
     */ fireCancelEvent(error) {
        try {
            if (!!this.privTranslator.canceled) {
                const cancelEvent = new $8hU6U.ConversationTranslationCanceledEventArgs($hVlip.CancellationReason.Error, error, $hVlip.CancellationErrorCode.RuntimeError);
                this.privTranslator.canceled(this.privTranslator, cancelEvent);
            }
        } catch (e) {
        //
        }
    }
    async cancelSpeech() {
        try {
            this.stopContinuousRecognitionAsync();
            await this.privReco?.disconnect();
            this.privSpeechState = $f50a05f4e923bedd$var$SpeechState.Inactive;
        } catch (e) {
        // ignore the error
        }
    }
}
/**
 * Join, leave or connect to a conversation.
 */ class $f50a05f4e923bedd$var$ConversationTranslator extends $8hU6U.ConversationCommon {
    constructor(audioConfig){
        super(audioConfig);
        this.privErrors = $imJeu.ConversationConnectionConfig.restErrors;
        this.privIsDisposed = false;
        this.privIsSpeaking = false;
        this.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345";
        this.privPlaceholderRegion = "westus";
        this.privProperties = new $hVlip.PropertyCollection();
    }
    get properties() {
        return this.privProperties;
    }
    get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    get participants() {
        return this.privConversation?.participants;
    }
    get canSpeak() {
        // is there a Conversation websocket available and has the Recognizer been set up
        if (!this.privConversation.isConnected || !this.privCTRecognizer) return false;
        // is the user already speaking
        if (this.privIsSpeaking || this.privCTRecognizer.state === $f50a05f4e923bedd$var$SpeechState.Connected || this.privCTRecognizer.state === $f50a05f4e923bedd$var$SpeechState.Connecting) return false;
        // is the user muted
        if (this.privConversation.isMutedByHost) return false;
        return true;
    }
    onToken(token) {
        this.privCTRecognizer.authentication = token;
    }
    setServiceProperty(name, value) {
        const currentProperties = JSON.parse(this.privProperties.getProperty($imJeu.ServicePropertiesPropertyName, "{}"));
        currentProperties[name] = value;
        this.privProperties.setProperty($imJeu.ServicePropertiesPropertyName, JSON.stringify(currentProperties));
    }
    joinConversationAsync(conversation, nickname, param1, param2, param3) {
        try {
            if (typeof conversation === "string") {
                $56OOs.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $56OOs.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                if (!!this.privConversation) this.handleError(new Error(this.privErrors.permissionDeniedStart), param3);
                let lang = param1;
                if (lang === undefined || lang === null || lang === "") lang = $imJeu.ConversationConnectionConfig.defaultLanguageCode;
                // create a placeholder config
                this.privSpeechTranslationConfig = $hVlip.SpeechTranslationConfig.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion);
                this.privSpeechTranslationConfig.setProfanity($hVlip.ProfanityOption.Masked);
                this.privSpeechTranslationConfig.addTargetLanguage(lang);
                this.privSpeechTranslationConfig.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage], lang);
                this.privSpeechTranslationConfig.setProperty($hVlip.PropertyId[$hVlip.PropertyId.ConversationTranslator_Name], nickname);
                const propertyIdsToCopy = [
                    $hVlip.PropertyId.SpeechServiceConnection_Host,
                    $hVlip.PropertyId.ConversationTranslator_Host,
                    $hVlip.PropertyId.SpeechServiceConnection_Endpoint,
                    $hVlip.PropertyId.SpeechServiceConnection_ProxyHostName,
                    $hVlip.PropertyId.SpeechServiceConnection_ProxyPassword,
                    $hVlip.PropertyId.SpeechServiceConnection_ProxyPort,
                    $hVlip.PropertyId.SpeechServiceConnection_ProxyUserName,
                    "ConversationTranslator_MultiChannelAudio",
                    "ConversationTranslator_Region"
                ];
                for (const prop of propertyIdsToCopy){
                    const value = this.privProperties.getProperty(prop);
                    if (value) {
                        const key = typeof prop === "string" ? prop : $hVlip.PropertyId[prop];
                        this.privSpeechTranslationConfig.setProperty(key, value);
                    }
                }
                const currentProperties = JSON.parse(this.privProperties.getProperty($imJeu.ServicePropertiesPropertyName, "{}"));
                for (const prop of Object.keys(currentProperties))this.privSpeechTranslationConfig.setServiceProperty(prop, currentProperties[prop], $hVlip.ServicePropertyChannel.UriQueryParameter);
                // join the conversation
                this.privConversation = new $5QB9Z.ConversationImpl(this.privSpeechTranslationConfig);
                this.privConversation.conversationTranslator = this;
                this.privConversation.joinConversationAsync(conversation, nickname, lang, (result)=>{
                    if (!result) this.handleError(new Error(this.privErrors.permissionDeniedConnect), param3);
                    this.privSpeechTranslationConfig.authorizationToken = result;
                    this.privConversation.room.isHost = false;
                    // connect to the ws
                    this.privConversation.startConversationAsync(()=>{
                        this.handleCallback(param2, param3);
                    }, (error)=>{
                        this.handleError(error, param3);
                    });
                }, (error)=>{
                    this.handleError(error, param3);
                });
            } else if (typeof conversation === "object") {
                $56OOs.Contracts.throwIfNullOrUndefined(conversation, this.privErrors.invalidArgs.replace("{arg}", "conversation id"));
                $56OOs.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
                // save the nickname
                this.privProperties.setProperty($hVlip.PropertyId.ConversationTranslator_Name, nickname);
                // ref the conversation object
                this.privConversation = conversation;
                // ref the conversation translator object
                this.privConversation.conversationTranslator = this;
                this.privConversation.room.isHost = true;
                $56OOs.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect);
                $56OOs.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                this.privSpeechTranslationConfig = conversation.config;
                this.handleCallback(param1, param2);
            } else this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), param2);
        } catch (error) {
            this.handleError(error, typeof param1 === "string" ? param3 : param2);
        }
    }
    /**
     * Leave the conversation
     * @param cb
     * @param err
     */ leaveConversationAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks((async ()=>{
            // stop the speech websocket
            await this.cancelSpeech();
            // stop the websocket
            await this.privConversation.endConversationImplAsync();
            // https delete request
            await this.privConversation.deleteConversationImplAsync();
            this.dispose();
        })(), cb, err);
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ sendTextMessageAsync(message, cb, err) {
        try {
            $56OOs.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
            $56OOs.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", message));
            this.privConversation.sendTextMessageAsync(message, cb, err);
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Start speaking
     * @param cb
     * @param err
     */ startTranscribingAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks((async ()=>{
            try {
                $56OOs.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend);
                $56OOs.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect);
                if (this.privCTRecognizer === undefined) await this.connectTranslatorRecognizer();
                $56OOs.Contracts.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend);
                if (!this.canSpeak) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
                await this.startContinuousRecognition();
                this.privIsSpeaking = true;
            } catch (error) {
                this.privIsSpeaking = false;
                await this.cancelSpeech();
                throw error;
            }
        })(), cb, err);
    }
    /**
     * Stop speaking
     * @param cb
     * @param err
     */ stopTranscribingAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks((async ()=>{
            try {
                if (!this.privIsSpeaking) {
                    // stop speech
                    await this.cancelSpeech();
                    return;
                }
                // stop the recognition but leave the websocket open
                this.privIsSpeaking = false;
                await new Promise((resolve, reject)=>{
                    this.privCTRecognizer.stopContinuousRecognitionAsync(resolve, reject);
                });
            } catch (error) {
                await this.cancelSpeech();
            }
        })(), cb, err);
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose(reason, success, err) {
        $3wpON.marshalPromiseToCallbacks((async ()=>{
            if (this.isDisposed && !this.privIsSpeaking) return;
            await this.cancelSpeech();
            this.privIsDisposed = true;
            this.privSpeechTranslationConfig.close();
            this.privSpeechRecognitionLanguage = undefined;
            this.privProperties = undefined;
            this.privAudioConfig = undefined;
            this.privSpeechTranslationConfig = undefined;
            this.privConversation.dispose();
            this.privConversation = undefined;
        })(), success, err);
    }
    /**
     * Cancel the speech websocket
     */ async cancelSpeech() {
        try {
            this.privIsSpeaking = false;
            await this.privCTRecognizer?.onCancelSpeech();
            this.privCTRecognizer = undefined;
        } catch (e) {
        // ignore the error
        }
    }
    /**
     * Connect to the speech translation recognizer.
     * Currently there is no language validation performed before sending the SpeechLanguage code to the service.
     * If it's an invalid language the raw error will be: 'Error during WebSocket handshake: Unexpected response code: 400'
     * e.g. pass in 'fr' instead of 'fr-FR', or a text-only language 'cy'
     */ async connectTranslatorRecognizer() {
        try {
            if (this.privAudioConfig === undefined) this.privAudioConfig = $hVlip.AudioConfig.fromDefaultMicrophoneInput();
            // clear the temp subscription key if it's a participant joining
            if (this.privSpeechTranslationConfig.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_Key]) === this.privPlaceholderKey) this.privSpeechTranslationConfig.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_Key], "");
            const convGetter = ()=>this.privConversation;
            this.privCTRecognizer = new $f50a05f4e923bedd$var$ConversationTranslationRecognizer(this.privSpeechTranslationConfig, this.privAudioConfig, this, convGetter);
        } catch (error) {
            await this.cancelSpeech();
            throw error;
        }
    }
    /**
     * Handle the start speaking request
     */ startContinuousRecognition() {
        return new Promise((resolve, reject)=>{
            this.privCTRecognizer.startContinuousRecognitionAsync(resolve, reject);
        });
    }
}
module.exports.ConversationTranslator = $f50a05f4e923bedd$var$ConversationTranslator;

});
parcelRegister("h5yDK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $4nh4E = parcelRequire("4nh4E");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $bPVwM = parcelRequire("bPVwM");

var $luvuO = parcelRequire("luvuO");

var $lAVhN = parcelRequire("lAVhN");

var $imJeu = parcelRequire("imJeu");
/**
 * Connection factory for the conversation translator. Handles connecting to the regular translator endpoint,
 * as well as the virtual microphone array transcription endpoint
 */ class $c70dc61cd9ed0574$var$ConversationTranslatorConnectionFactory extends $lAVhN.ConnectionFactoryBase {
    constructor(convGetter){
        super();
        $56OOs.Contracts.throwIfNullOrUndefined(convGetter, "convGetter");
        this.privConvGetter = convGetter;
    }
    create(config, authInfo, connectionId) {
        const isVirtMicArrayEndpoint = config.parameters.getProperty("ConversationTranslator_MultiChannelAudio", "").toUpperCase() === "TRUE";
        const convInfo = this.privConvGetter().room;
        const region = convInfo.cognitiveSpeechRegion || config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region, "");
        const replacementValues = {
            hostSuffix: $lAVhN.ConnectionFactoryBase.getHostSuffix(region),
            path: $c70dc61cd9ed0574$var$ConversationTranslatorConnectionFactory.CTS_VIRT_MIC_PATH,
            region: encodeURIComponent(region)
        };
        replacementValues[$luvuO.QueryParameterNames.Language] = encodeURIComponent(config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage, ""));
        replacementValues[$luvuO.QueryParameterNames.CtsMeetingId] = encodeURIComponent(convInfo.roomId);
        replacementValues[$luvuO.QueryParameterNames.CtsDeviceId] = encodeURIComponent(convInfo.participantId);
        replacementValues[$luvuO.QueryParameterNames.CtsIsParticipant] = convInfo.isHost ? "" : "&" + $luvuO.QueryParameterNames.CtsIsParticipant;
        let endpointUrl = "";
        const queryParams = {};
        const headers = {};
        if (isVirtMicArrayEndpoint) {
            // connecting to the conversation transcription virtual microphone array endpoint
            endpointUrl = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint);
            if (!endpointUrl) {
                const hostName = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, "transcribe.{region}.cts.speech{hostSuffix}");
                endpointUrl = "wss://" + hostName + "{path}";
            }
            // because the region can change during a session, we support being passed a format string which we can then
            // replace with the correct information.
            endpointUrl = $4nh4E.StringUtils.formatString(endpointUrl, replacementValues);
            const parsedUrl = new URL(endpointUrl);
            parsedUrl.searchParams.forEach((val, key)=>{
                queryParams[key] = val;
            });
            const connFactory = new $imJeu.TranscriberConnectionFactory();
            connFactory.setQueryParams(queryParams, config, endpointUrl);
            // Some query parameters are required for the CTS endpoint, let's explicity set them here
            queryParams[$luvuO.QueryParameterNames.CtsMeetingId] = replacementValues[$luvuO.QueryParameterNames.CtsMeetingId];
            queryParams[$luvuO.QueryParameterNames.CtsDeviceId] = replacementValues[$luvuO.QueryParameterNames.CtsDeviceId];
            if (!convInfo.isHost) queryParams[$luvuO.QueryParameterNames.CtsIsParticipant] = ""; // this doesn't have a value so set to an empty string
            if (!($luvuO.QueryParameterNames.Format in queryParams)) queryParams[$luvuO.QueryParameterNames.Format] = "simple";
            parsedUrl.searchParams.forEach((val, key)=>{
                parsedUrl.searchParams.set(key, queryParams[key]);
                delete queryParams[key];
            });
            endpointUrl = parsedUrl.toString();
        } else {
            // connecting to regular translation endpoint
            const connFactory = new $imJeu.TranslationConnectionFactory();
            endpointUrl = connFactory.getEndpointUrl(config, true);
            endpointUrl = $4nh4E.StringUtils.formatString(endpointUrl, replacementValues);
            connFactory.setQueryParams(queryParams, config, endpointUrl);
        }
        headers[$bPVwM.HeaderNames.ConnectionId] = connectionId;
        headers[$gvLMV.RestConfigBase.configParams.token] = convInfo.token;
        if (!!authInfo.token) headers[authInfo.headerName] = authInfo.token;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "").toUpperCase() === "TRUE";
        return new $gvLMV.WebsocketConnection(endpointUrl, queryParams, headers, new $imJeu.WebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
}
module.exports.ConversationTranslatorConnectionFactory = $c70dc61cd9ed0574$var$ConversationTranslatorConnectionFactory;
$c70dc61cd9ed0574$var$ConversationTranslatorConnectionFactory.CTS_VIRT_MIC_PATH = "/speech/recognition/dynamicaudio";

});
parcelRegister("4nh4E", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StringUtils = void 0;
/**
 * String helper functions
 */ class $32f68deed254a6ea$var$StringUtils {
    /**
     * Formats a string by replacing the named {keys} in the string with the values contained in the replacement dictionary.
     * @param format The format string that contains the parts to replace surrounded by {}. For example: "wss://{region}.cts.speech.microsoft.com".
     * If your string needs to contain a { or } you can use the {{ and }} escape sequences respectively.
     * @param replacements The dictionary of replacements. If a replacement is not found, it is replaced with an empty string
     * @returns The formatted string. If you pass in a null or undefined format string, an empty string will be returned
     */ static formatString(format, replacements) {
        if (!format) return "";
        if (!replacements) return format;
        let formatted = "";
        let key = "";
        const appendToFormatted = (str)=>{
            formatted += str;
        };
        const appendToKey = (str)=>{
            key += str;
        };
        let appendFunc = appendToFormatted;
        for(let i = 0; i < format.length; i++){
            const c = format[i];
            const next = i + 1 < format.length ? format[i + 1] : "";
            switch(c){
                case "{":
                    if (next === "{") {
                        appendFunc("{");
                        i++;
                    } else appendFunc = appendToKey;
                    break;
                case "}":
                    if (next === "}") {
                        appendFunc("}");
                        i++;
                    } else {
                        if (replacements.hasOwnProperty(key)) formatted += replacements[key];
                        appendFunc = appendToFormatted;
                        key = "";
                    }
                    break;
                default:
                    appendFunc(c);
                    break;
            }
        }
        return formatted;
    }
}
module.exports.StringUtils = $32f68deed254a6ea$var$StringUtils;

});



parcelRegister("2WrCG", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriber = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Performs speech recognition with speaker separation from microphone, file, or other audio input streams, and gets transcribed text as result.
 * @class ConversationTranscriber
 */ class $22466ce2c0a0f135$var$ConversationTranscriber extends $hVlip.Recognizer {
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(speechConfig, audioConfig){
        const speechConfigImpl = speechConfig;
        $56OOs.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        $56OOs.Contracts.throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage), $hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechConfigImpl.properties, new $imJeu.ConversationTranscriberConnectionFactory());
        this.privProperties.setProperty($hVlip.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2");
        this.privDisposedRecognizer = false;
    }
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        const recognizer = new $22466ce2c0a0f135$var$ConversationTranscriber(speechConfig, audioConfig);
        return recognizer;
    }
    /**
     * Gets the endpoint id of a customized speech model that is used for transcription.
     * @member ConversationTranscriber.prototype.endpointId
     * @function
     * @public
     * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
     */ get endpointId() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member ConversationTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member ConversationTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $56OOs.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * Gets the spoken language of transcription.
     * @member ConversationTranscriber.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of transcription.
     */ get speechRecognitionLanguage() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of transcription.
     * @member ConversationTranscriber.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of transcription.
     */ get outputFormat() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        if (this.properties.getProperty($imJeu.OutputFormatPropertyName, $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]) === $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]) return $hVlip.OutputFormat.Simple;
        else return $hVlip.OutputFormat.Detailed;
    }
    /**
     * The collection of properties and their values defined for this conversation transcriber.
     * @member ConversationTranscriber.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Starts conversation transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member ConversationTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ startTranscribingAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($imJeu.RecognitionMode.Conversation), cb, err);
    }
    /**
     * Stops conversation transcription.
     * @member ConversationTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has stopped.
     * @param err - Callback invoked in case of an error.
     */ stopTranscribingAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member ConversationTranscriber.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $3wpON.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (disposing) {
            this.privDisposedRecognizer = true;
            await this.implRecognizerStop();
        }
        await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $imJeu.RecognizerConfig(speechConfig, this.privProperties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        recognizerConfig.isSpeakerDiarizationEnabled = true;
        return new $imJeu.ConversationTranscriptionServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
}
module.exports.ConversationTranscriber = $22466ce2c0a0f135$var$ConversationTranscriber;

});

parcelRegister("blCur", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Participant = module.exports.User = void 0;

var $hVlip = parcelRequire("hVlip");
class $842f832c6e042fdd$var$User {
    constructor(userId){
        this.privUserId = userId;
    }
    get userId() {
        return this.privUserId;
    }
}
module.exports.User = $842f832c6e042fdd$var$User;
class $842f832c6e042fdd$var$Participant {
    constructor(id, avatar, displayName, isHost, isMuted, isUsingTts, preferredLanguage, voice){
        this.privId = id;
        this.privAvatar = avatar;
        this.privDisplayName = displayName;
        this.privIsHost = isHost;
        this.privIsMuted = isMuted;
        this.privIsUsingTts = isUsingTts;
        this.privPreferredLanguage = preferredLanguage;
        this.privVoice = voice;
        this.privProperties = new $hVlip.PropertyCollection();
    }
    get avatar() {
        return this.privAvatar;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get id() {
        return this.privId;
    }
    get preferredLanguage() {
        return this.privPreferredLanguage;
    }
    get isHost() {
        return this.privIsHost;
    }
    get isMuted() {
        return this.privIsMuted;
    }
    get isUsingTts() {
        return this.privIsUsingTts;
    }
    get voice() {
        return this.privVoice;
    }
    get properties() {
        return this.privProperties;
    }
    static From(id, language, voice) {
        return new $842f832c6e042fdd$var$Participant(id, "", id, false, false, false, language, voice);
    }
}
module.exports.Participant = $842f832c6e042fdd$var$Participant;

});

parcelRegister("h10C7", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantChangedReason = void 0;
var $c63301881236fb7b$var$ParticipantChangedReason;
(function(ParticipantChangedReason) {
    /** Participant has joined the conversation. */ ParticipantChangedReason[ParticipantChangedReason["JoinedConversation"] = 0] = "JoinedConversation";
    /** Participant has left the conversation. This could be voluntary, or involuntary
     * (e.g. they are experiencing networking issues).
     */ ParticipantChangedReason[ParticipantChangedReason["LeftConversation"] = 1] = "LeftConversation";
    /** The participants' state has changed (e.g. they became muted, changed their nickname). */ ParticipantChangedReason[ParticipantChangedReason["Updated"] = 2] = "Updated";
})($c63301881236fb7b$var$ParticipantChangedReason = module.exports.ParticipantChangedReason || (module.exports.ParticipantChangedReason = {}));

});

parcelRegister("bHcQR", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingImpl = module.exports.Meeting = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
class $883dadf17ff30e9c$var$Meeting {
    constructor(){
        return;
    }
    /**
     * Create a meeting
     * @param speechConfig
     * @param meetingId
     * @param cb
     * @param err
     */ static createMeetingAsync(speechConfig, meetingId, arg3, arg4) {
        $56OOs.Contracts.throwIfNullOrUndefined(speechConfig, $imJeu.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config"));
        $56OOs.Contracts.throwIfNullOrUndefined(speechConfig.region, $imJeu.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region"));
        $56OOs.Contracts.throwIfNull(meetingId, "meetingId");
        if (meetingId.length === 0) throw new Error("meetingId cannot be empty");
        if (!speechConfig.subscriptionKey && !speechConfig.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceAuthorization_Token])) $56OOs.Contracts.throwIfNullOrUndefined(speechConfig.subscriptionKey, $imJeu.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
        const meetingImpl = new $883dadf17ff30e9c$var$MeetingImpl(speechConfig, meetingId);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        $3wpON.marshalPromiseToCallbacks((async ()=>{})(), arg3, arg4);
        return meetingImpl;
    }
}
module.exports.Meeting = $883dadf17ff30e9c$var$Meeting;
class $883dadf17ff30e9c$var$MeetingImpl extends $883dadf17ff30e9c$var$Meeting {
    /**
     * Create a Meeting impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */ constructor(speechConfig, id){
        super();
        this.privErrors = $imJeu.ConversationConnectionConfig.restErrors;
        /** websocket callbacks */ /* eslint-disable @typescript-eslint/typedef */ this.onConnected = (e)=>{
            this.privIsConnected = true;
            try {
                if (!!this.privConversationTranslator?.sessionStarted) this.privConversationTranslator.sessionStarted(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onDisconnected = (e)=>{
            try {
                if (!!this.privConversationTranslator?.sessionStopped) this.privConversationTranslator.sessionStopped(this.privConversationTranslator, e);
            } catch (e) {
            //
            } finally{
                this.close(false);
            }
        };
        this.onCanceled = (r, e)=>{
            try {
                if (!!this.privConversationTranslator?.canceled) this.privConversationTranslator.canceled(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.onParticipantUpdateCommandReceived = (r, e)=>{
            try {
                const updatedParticipant = this.privParticipants.getParticipant(e.id);
                if (updatedParticipant !== undefined) {
                    switch(e.key){
                        case $imJeu.ConversationTranslatorCommandTypes.changeNickname:
                            updatedParticipant.displayName = e.value;
                            break;
                        case $imJeu.ConversationTranslatorCommandTypes.setUseTTS:
                            updatedParticipant.isUsingTts = e.value;
                            break;
                        case $imJeu.ConversationTranslatorCommandTypes.setProfanityFiltering:
                            updatedParticipant.profanity = e.value;
                            break;
                        case $imJeu.ConversationTranslatorCommandTypes.setMute:
                            updatedParticipant.isMuted = e.value;
                            break;
                        case $imJeu.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                            updatedParticipant.translateToLanguages = e.value;
                            break;
                    }
                    this.privParticipants.addOrUpdateParticipant(updatedParticipant);
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.Updated, [
                        this.toParticipant(updatedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onLockRoomCommandReceived = ()=>{
        // TODO
        };
        this.onMuteAllCommandReceived = (r, e)=>{
            try {
                this.privParticipants.participants.forEach((p)=>p.isMuted = p.isHost ? false : e.isMuted);
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.Updated, this.toParticipants(false), e.sessionId));
            } catch (e) {
            //
            }
        };
        this.onParticipantJoinCommandReceived = (r, e)=>{
            try {
                const newParticipant = this.privParticipants.addOrUpdateParticipant(e.participant);
                if (newParticipant !== undefined) {
                    if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.JoinedConversation, [
                        this.toParticipant(newParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantLeaveCommandReceived = (r, e)=>{
            try {
                const ejectedParticipant = this.privParticipants.getParticipant(e.participant.id);
                if (ejectedParticipant !== undefined) {
                    // remove the participant from the internal participants list
                    this.privParticipants.deleteParticipant(e.participant.id);
                    if (!!this.privConversationTranslator) // notify subscribers that the participant has left the conversation
                    this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.LeftConversation, [
                        this.toParticipant(ejectedParticipant)
                    ], e.sessionId));
                }
            } catch (e) {
            //
            }
        };
        this.onTranslationReceived = (r, e)=>{
            try {
                switch(e.command){
                    case $imJeu.ConversationTranslatorMessageTypes.final:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribed(this.privConversationTranslator, new $hVlip.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $imJeu.ConversationTranslatorMessageTypes.partial:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.transcribing(this.privConversationTranslator, new $hVlip.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                    case $imJeu.ConversationTranslatorMessageTypes.instantMessage:
                        if (!!this.privConversationTranslator) this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new $hVlip.ConversationTranslationEventArgs(e.payload, undefined, e.sessionId));
                        break;
                }
            } catch (e) {
            //
            }
        };
        this.onParticipantsListReceived = (r, e)=>{
            try {
                // check if the session token needs to be updated
                if (e.sessionToken !== undefined && e.sessionToken !== null) this.privRoom.token = e.sessionToken;
                // save the participants
                this.privParticipants.participants = [
                    ...e.participants
                ];
                // enable the conversation
                if (this.privParticipants.me !== undefined) this.privIsReady = true;
                if (!!this.privConversationTranslator) this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new $hVlip.ConversationParticipantsChangedEventArgs($hVlip.ParticipantChangedReason.JoinedConversation, this.toParticipants(true), e.sessionId));
                // if this is the host, update the nickname if needed
                if (this.me.isHost) {
                    const nickname = this.privConversationTranslator?.properties.getProperty($hVlip.PropertyId.ConversationTranslator_Name);
                    if (nickname !== undefined && nickname.length > 0 && nickname !== this.me.displayName) // issue a change nickname request
                    this.changeNicknameAsync(nickname);
                }
            } catch (e) {
            //
            }
        };
        this.onConversationExpiration = (r, e)=>{
            try {
                if (!!this.privConversationTranslator) this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, e);
            } catch (e) {
            //
            }
        };
        this.privIsConnected = false;
        this.privIsDisposed = false;
        this.privConversationId = "";
        this.privProperties = new $hVlip.PropertyCollection();
        this.privManager = new $imJeu.ConversationManager();
        // check the speech language
        const language = speechConfig.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
        if (!language) speechConfig.setProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage], $imJeu.ConversationConnectionConfig.defaultLanguageCode);
        this.privLanguage = speechConfig.getProperty($hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
        this.privConversationId = id;
        // save the speech config for future usage
        this.privConfig = speechConfig;
        // save the config properties
        const configImpl = speechConfig;
        $56OOs.Contracts.throwIfNull(configImpl, "speechConfig");
        this.privProperties = configImpl.properties.clone();
        this.privIsConnected = false;
        this.privParticipants = new $imJeu.InternalParticipants();
        this.privIsReady = false;
        this.privTextMessageMaxLength = 1000;
    }
    // get the internal data about a conversation
    get room() {
        return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
        return this.privConversationRecognizer; // this.privConnection;
    }
    // get the config
    get config() {
        return this.privConfig;
    }
    // get the meeting Id
    get meetingId() {
        return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
        return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
        return this.privLanguage;
    }
    get isMutedByHost() {
        return this.privParticipants.me?.isHost ? false : this.privParticipants.me?.isMuted;
    }
    get isConnected() {
        return this.privIsConnected && this.privIsReady;
    }
    get participants() {
        return this.toParticipants(true);
    }
    get me() {
        return this.toParticipant(this.privParticipants.me);
    }
    get host() {
        return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
        return this.privTranscriberRecognizer;
    }
    get meetingInfo() {
        const convId = this.meetingId;
        const p = this.participants.map((part)=>({
                id: part.id,
                preferredLanguage: part.preferredLanguage,
                voice: part.voice
            }));
        const props = {};
        for (const key of $imJeu.ConversationConnectionConfig.transcriptionEventKeys){
            const val = this.properties.getProperty(key, "");
            if (val !== "") props[key] = val;
        }
        const info = {
            id: convId,
            participants: p,
            meetingProperties: props
        };
        return info;
    }
    get canSend() {
        return this.privIsConnected && !this.privParticipants.me?.isMuted;
    }
    get canSendAsHost() {
        return this.privIsConnected && this.privParticipants.me?.isHost;
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
        return this.privToken;
    }
    set authorizationToken(value) {
        $56OOs.Contracts.throwIfNullOrWhitespace(value, "authorizationToken");
        this.privToken = value;
    }
    /**
     * Create a new meeting as Host
     * @param cb
     * @param err
     */ createMeetingAsync(cb, err) {
        try {
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            this.privManager.createOrJoin(this.privProperties, undefined, (room)=>{
                if (!room) this.handleError(new Error(this.privErrors.permissionDeniedConnect), err);
                this.privRoom = room;
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Starts a new meeting as host.
     * @param cb
     * @param err
     */ startMeetingAsync(cb, err) {
        try {
            // check if there is already a recognizer
            if (!!this.privConversationRecognizer) this.handleError(new Error(this.privErrors.permissionDeniedStart), err);
            // check if there is conversation data available
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect);
            // connect to the conversation websocket
            this.privParticipants.meId = this.privRoom.participantId;
            // Because ConversationTranslator manually sets up and manages the connection, Conversation
            // has to forward serviceRecognizer connection events that usually get passed automatically
            this.privConversationRecognizer.connected = this.onConnected;
            this.privConversationRecognizer.disconnected = this.onDisconnected;
            this.privConversationRecognizer.canceled = this.onCanceled;
            this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived;
            this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived;
            this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived;
            this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived;
            this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived;
            this.privConversationRecognizer.translationReceived = this.onTranslationReceived;
            this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived;
            this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration;
            this.privConversationRecognizer.connect(this.privRoom.token, ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Join a meeting as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */ addParticipantAsync(participant, cb, err) {
        $56OOs.Contracts.throwIfNullOrUndefined(participant, "Participant");
        $3wpON.marshalPromiseToCallbacks(this.addParticipantImplAsync(participant), cb, err);
    }
    /**
     * Join a meeting as a participant.
     * @param meeting
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */ joinMeetingAsync(meetingId, nickname, lang, cb, err) {
        try {
            // TODO
            // if (!!this.privConversationRecognizer) {
            //     throw new Error(this.privErrors.permissionDeniedStart);
            // }
            $56OOs.Contracts.throwIfNullOrWhitespace(meetingId, this.privErrors.invalidArgs.replace("{arg}", "conversationId"));
            $56OOs.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $56OOs.Contracts.throwIfNullOrWhitespace(lang, this.privErrors.invalidArgs.replace("{arg}", "language"));
            // join the conversation
            this.privManager.createOrJoin(this.privProperties, meetingId, (room)=>{
                $56OOs.Contracts.throwIfNullOrUndefined(room, this.privErrors.permissionDeniedConnect);
                this.privRoom = room;
                this.privConfig.authorizationToken = room.cognitiveSpeechAuthToken;
                // join callback
                if (!!cb) cb(room.cognitiveSpeechAuthToken);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Deletes a meeting
     * @param cb
     * @param err
     */ deleteMeetingAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.deleteMeetingImplAsync(), cb, err);
    }
    async deleteMeetingImplAsync() {
        $56OOs.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect);
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect);
        await this.privManager.leave(this.privProperties, this.privRoom.token);
        this.dispose();
    }
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */ endMeetingAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.endMeetingImplAsync(), cb, err);
    }
    endMeetingImplAsync() {
        return this.close(true);
    }
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */ lockMeetingAsync(cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute the meeting
     * @param cb
     * @param err
     */ muteAllParticipantsAsync(cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend);
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the user's permissions
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to mute a participant in the meeting
     * @param userId
     * @param cb
     * @param err
     */ muteParticipantAsync(userId, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, true), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */ removeParticipantAsync(userId, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            if (!!this.privTranscriberRecognizer && userId.hasOwnProperty("id")) // Assume this is a transcription participant
            $3wpON.marshalPromiseToCallbacks(this.removeParticipantImplAsync(userId), cb, err);
            else {
                $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
                $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
                if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), err);
                let participantId = "";
                if (typeof userId === "string") participantId = userId;
                else if (userId.hasOwnProperty("id")) {
                    const participant = userId;
                    participantId = participant.id;
                } else if (userId.hasOwnProperty("userId")) {
                    const user = userId;
                    participantId = user.userId;
                }
                $56OOs.Contracts.throwIfNullOrWhitespace(participantId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
                // check the participant exists
                const index = this.participants.findIndex((p)=>p.id === participantId);
                if (index === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
                if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getEjectCommand(participantId), ()=>{
                    this.handleCallback(cb, err);
                }, (error)=>{
                    this.handleError(error, err);
                });
            }
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unlock the meeting
     * @param cb
     * @param err
     */ unlockMeetingAsync(cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getLockCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute all participants in the meeting
     * @param cb
     * @param err
     */ unmuteAllParticipantsAsync(cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSendAsHost) this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Issues a request to unmute a participant in the meeting
     * @param userId
     * @param cb
     * @param err
     */ unmuteParticipantAsync(userId, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrWhitespace(userId, this.privErrors.invalidArgs.replace("{arg}", "userId"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            // check the connection is open (host + participant can perform the mute command)
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // if not host, check the participant is not muting another participant
            if (!this.me.isHost && this.me.id !== userId) this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), err);
            // check the user exists
            const exists = this.privParticipants.getParticipantIndex(userId);
            if (exists === -1) this.handleError(new Error(this.privErrors.invalidParticipantRequest), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMuteCommand(userId, false), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */ sendTextMessageAsync(message, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrWhitespace(message, this.privErrors.invalidArgs.replace("{arg}", "message"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            // TODO: is a max length check required?
            if (message.length > this.privTextMessageMaxLength) this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getMessageCommand(message), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Set translated to languages
     * @param {string[]} languages - languages to translate to
     * @param cb
     * @param err
     */ setTranslatedLanguagesAsync(languages, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfArrayEmptyOrWhitespace(languages, this.privErrors.invalidArgs.replace("{arg}", "languages"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(languages), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    /**
     * Change nickname
     * @param {string} nickname - new nickname for the room
     * @param cb
     * @param err
     */ changeNicknameAsync(nickname, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed());
            $56OOs.Contracts.throwIfNullOrWhitespace(nickname, this.privErrors.invalidArgs.replace("{arg}", "nickname"));
            $56OOs.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend);
            if (!this.canSend) this.handleError(new Error(this.privErrors.permissionDeniedSend), err);
            if (!!this.privConversationRecognizer) this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(nickname), ()=>{
                this.handleCallback(cb, err);
            }, (error)=>{
                this.handleError(error, err);
            });
        } catch (error) {
            this.handleError(error, err);
        }
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    dispose() {
        if (this.isDisposed) return;
        this.privIsDisposed = true;
        if (!!this.config) this.config.close();
        this.privConfig = undefined;
        this.privLanguage = undefined;
        this.privProperties = undefined;
        this.privRoom = undefined;
        this.privToken = undefined;
        this.privManager = undefined;
        this.privIsConnected = false;
        this.privIsReady = false;
        this.privParticipants = undefined;
    }
    async connectTranscriberRecognizer(recognizer) {
        if (!!this.privTranscriberRecognizer) await this.privTranscriberRecognizer.close();
        await recognizer.enforceAudioGating();
        this.privTranscriberRecognizer = recognizer;
        this.privTranscriberRecognizer.meeting = this;
    }
    getKeepAlive() {
        const nickname = !!this.me ? this.me.displayName : "default_nickname";
        return JSON.stringify({
            id: "0",
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.keepAlive
        });
    }
    /* eslint-enable @typescript-eslint/typedef */ addParticipantImplAsync(participant) {
        const newParticipant = this.privParticipants.addOrUpdateParticipant(participant);
        if (newParticipant !== undefined) {
            if (!!this.privTranscriberRecognizer) {
                const meetingInfo = this.meetingInfo;
                meetingInfo.participants = [
                    participant
                ];
                return this.privTranscriberRecognizer.pushMeetingEvent(meetingInfo, "join");
            }
        }
    }
    removeParticipantImplAsync(participant) {
        this.privParticipants.deleteParticipant(participant.id);
        const meetingInfo = this.meetingInfo;
        meetingInfo.participants = [
            participant
        ];
        return this.privTranscriberRecognizer.pushMeetingEvent(meetingInfo, "leave");
    }
    async close(dispose) {
        try {
            this.privIsConnected = false;
            await this.privConversationRecognizer?.close();
            this.privConversationRecognizer = undefined;
            if (!!this.privConversationTranslator) this.privConversationTranslator.dispose();
        } catch (e) {
            // ignore error
            throw e;
        }
        if (dispose) this.dispose();
    }
    /** Helpers */ handleCallback(cb, err) {
        if (!!cb) {
            try {
                cb();
            } catch (e) {
                if (!!err) err(e);
            }
            cb = undefined;
        }
    }
    handleError(error, err) {
        if (!!err) {
            if (error instanceof Error) {
                const typedError = error;
                err(typedError.name + ": " + typedError.message);
            } else err(error);
        }
    }
    /** Participant Helpers */ toParticipants(includeHost) {
        const participants = this.privParticipants.participants.map((p)=>this.toParticipant(p));
        if (!includeHost) return participants.filter((p)=>p.isHost === false);
        else return participants;
    }
    toParticipant(p) {
        return new $hVlip.Participant(p.id, p.avatar, p.displayName, p.isHost, p.isMuted, p.isUsingTts, p.preferredLanguage, p.voice);
    }
    getMuteAllCommand(isMuted) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingd");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.setMuteAll,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getMuteCommand(participantId, isMuted) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId");
        $56OOs.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.setMute,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: isMuted
        });
    }
    getLockCommand(isLocked) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.setLockState,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: isLocked
        });
    }
    getEjectCommand(participantId) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $56OOs.Contracts.throwIfNullOrWhitespace(participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.ejectParticipant,
            // eslint-disable-next-line object-shorthand
            participantId: participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand
        });
    }
    getSetTranslateToLanguagesCommand(languages) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.setTranslateToLanguages,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: languages
        });
    }
    getChangeNicknameCommand(nickname) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $56OOs.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        return JSON.stringify({
            command: $imJeu.ConversationTranslatorCommandTypes.changeNickname,
            nickname: nickname,
            participantId: this.privRoom.participantId,
            roomid: this.privRoom.roomId,
            type: $imJeu.ConversationTranslatorMessageTypes.participantCommand,
            value: nickname
        });
    }
    getMessageCommand(message) {
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId");
        $56OOs.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId");
        $56OOs.Contracts.throwIfNullOrWhitespace(message, "message");
        return JSON.stringify({
            participantId: this.privRoom.participantId,
            roomId: this.privRoom.roomId,
            text: message,
            type: $imJeu.ConversationTranslatorMessageTypes.instantMessage
        });
    }
}
module.exports.MeetingImpl = $883dadf17ff30e9c$var$MeetingImpl;

});

parcelRegister("6QpVH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Multi-device Conversation is a Preview feature.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriptionCanceledEventArgs = void 0;

var $6sMHZ = parcelRequire("6sMHZ");
class $4fbbb67ee9fa192d$var$MeetingTranscriptionCanceledEventArgs extends $6sMHZ.CancellationEventArgsBase {
}
module.exports.MeetingTranscriptionCanceledEventArgs = $4fbbb67ee9fa192d$var$MeetingTranscriptionCanceledEventArgs;

});

parcelRegister("etz6e", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriber = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $8hU6U = parcelRequire("8hU6U");
class $a89f002bbb9a2a1a$var$MeetingTranscriber {
    /**
     * MeetingTranscriber constructor.
     * @constructor
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */ constructor(audioConfig){
        this.privAudioConfig = audioConfig;
        this.privProperties = new $hVlip.PropertyCollection();
        this.privRecognizer = undefined;
        this.privDisposedRecognizer = false;
    }
    /**
     * Gets the spoken language of recognition.
     * @member MeetingTranscriber.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */ get speechRecognitionLanguage() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * The collection of properties and their values defined for this MeetingTranscriber.
     * @member MeetingTranscriber.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this MeetingTranscriber.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privRecognizer.internalData;
    }
    /**
     * @Deprecated
     * @Obsolete
     * Please use the Connection.fromRecognizer pattern to obtain a connection object
     */ get connection() {
        return $hVlip.Connection.fromRecognizer(this.privRecognizer);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member MeetingTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member MeetingTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $56OOs.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * @param {Meeting} meeting - meeting to be recognized
     */ joinMeetingAsync(meeting, cb, err) {
        /* eslint-disable no-console */ // console.log(">> MeetingTranscriber::joinMeetingAsync");
        /* eslint-enable no-console */ const meetingImpl = meeting;
        $56OOs.Contracts.throwIfNullOrUndefined($8hU6U.MeetingImpl, "Meeting");
        // ref the meeting object
        // create recognizer and subscribe to recognizer events
        this.privRecognizer = new $imJeu.TranscriberRecognizer(meeting.config, this.privAudioConfig);
        $56OOs.Contracts.throwIfNullOrUndefined(this.privRecognizer, "Recognizer");
        this.privRecognizer.connectMeetingCallbacks(this);
        $3wpON.marshalPromiseToCallbacks(meetingImpl.connectTranscriberRecognizer(this.privRecognizer), cb, err);
    }
    /**
     * Starts meeting transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member MeetingTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ startTranscribingAsync(cb, err) {
        this.privRecognizer.startContinuousRecognitionAsync(cb, err);
    }
    /**
     * Starts meeting transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member MeetingTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */ stopTranscribingAsync(cb, err) {
        this.privRecognizer.stopContinuousRecognitionAsync(cb, err);
    }
    /**
     * Leave the current meeting. After this is called, you will no longer receive any events.
     */ leaveMeetingAsync(cb, err) {
        this.privRecognizer.disconnectCallbacks();
        // eslint-disable-next-line
        $3wpON.marshalPromiseToCallbacks((async ()=>{
            return;
        })(), cb, err);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member MeetingTranscriber.prototype.close
     * @function
     * @public
     */ close(cb, errorCb) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        $3wpON.marshalPromiseToCallbacks(this.dispose(true), cb, errorCb);
    }
    /**
     * Disposes any resources held by the object.
     * @member MeetingTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (!!this.privRecognizer) {
            await this.privRecognizer.close();
            this.privRecognizer = undefined;
        }
        if (disposing) this.privDisposedRecognizer = true;
    }
}
module.exports.MeetingTranscriber = $a89f002bbb9a2a1a$var$MeetingTranscriber;

});

parcelRegister("2pASc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionResult = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines result of conversation transcription.
 * @class ConversationTranscriptionResult
 */ class $1c1a84cc124880a9$var$ConversationTranscriptionResult extends $hVlip.RecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, text, duration, offset, language, languageDetectionConfidence, speakerId, errorDetails, json, properties){
        super(resultId, reason, text, duration, offset, language, languageDetectionConfidence, errorDetails, json, properties);
        this.privSpeakerId = speakerId;
    }
    /**
     * speaker id
     * @member ConversationTranscriptionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */ get speakerId() {
        return this.privSpeakerId;
    }
}
module.exports.ConversationTranscriptionResult = $1c1a84cc124880a9$var$ConversationTranscriptionResult;

});


parcelRegister("gOb2m", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisRequest = module.exports.Synthesizer = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
class $c3c9e09732167051$var$Synthesizer {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {SpeechConfig} speechConfig - The speech config to initialize the synthesizer.
     */ constructor(speechConfig){
        const speechConfigImpl = speechConfig;
        $56OOs.Contracts.throwIfNull(speechConfigImpl, "speechConfig");
        this.privProperties = speechConfigImpl.properties.clone();
        this.privDisposed = false;
        this.privSynthesizing = false;
        this.synthesisRequestQueue = new $3wpON.Queue();
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */ get authorizationToken() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */ set authorizationToken(token) {
        $56OOs.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * The collection of properties and their values defined for this Synthesizer.
     * @member Synthesizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
     */ get properties() {
        return this.privProperties;
    }
    /**
     * Indicates if auto detect source language is enabled
     * @member Synthesizer.prototype.autoDetectSourceLanguage
     * @function
     * @public
     * @returns {boolean} if auto detect source language is enabled
     */ get autoDetectSourceLanguage() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages) === $imJeu.AutoDetectSourceLanguagesOpenRangeOptionName;
    }
    buildSsml(text) {
        const languageToDefaultVoice = {
            ["af-ZA"]: "af-ZA-AdriNeural",
            ["am-ET"]: "am-ET-AmehaNeural",
            ["ar-AE"]: "ar-AE-FatimaNeural",
            ["ar-BH"]: "ar-BH-AliNeural",
            ["ar-DZ"]: "ar-DZ-AminaNeural",
            ["ar-EG"]: "ar-EG-SalmaNeural",
            ["ar-IQ"]: "ar-IQ-BasselNeural",
            ["ar-JO"]: "ar-JO-SanaNeural",
            ["ar-KW"]: "ar-KW-FahedNeural",
            ["ar-LY"]: "ar-LY-ImanNeural",
            ["ar-MA"]: "ar-MA-JamalNeural",
            ["ar-QA"]: "ar-QA-AmalNeural",
            ["ar-SA"]: "ar-SA-HamedNeural",
            ["ar-SY"]: "ar-SY-AmanyNeural",
            ["ar-TN"]: "ar-TN-HediNeural",
            ["ar-YE"]: "ar-YE-MaryamNeural",
            ["bg-BG"]: "bg-BG-BorislavNeural",
            ["bn-BD"]: "bn-BD-NabanitaNeural",
            ["bn-IN"]: "bn-IN-BashkarNeural",
            ["ca-ES"]: "ca-ES-JoanaNeural",
            ["cs-CZ"]: "cs-CZ-AntoninNeural",
            ["cy-GB"]: "cy-GB-AledNeural",
            ["da-DK"]: "da-DK-ChristelNeural",
            ["de-AT"]: "de-AT-IngridNeural",
            ["de-CH"]: "de-CH-JanNeural",
            ["de-DE"]: "de-DE-KatjaNeural",
            ["el-GR"]: "el-GR-AthinaNeural",
            ["en-AU"]: "en-AU-NatashaNeural",
            ["en-CA"]: "en-CA-ClaraNeural",
            ["en-GB"]: "en-GB-LibbyNeural",
            ["en-HK"]: "en-HK-SamNeural",
            ["en-IE"]: "en-IE-ConnorNeural",
            ["en-IN"]: "en-IN-NeerjaNeural",
            ["en-KE"]: "en-KE-AsiliaNeural",
            ["en-NG"]: "en-NG-AbeoNeural",
            ["en-NZ"]: "en-NZ-MitchellNeural",
            ["en-PH"]: "en-PH-JamesNeural",
            ["en-SG"]: "en-SG-LunaNeural",
            ["en-TZ"]: "en-TZ-ElimuNeural",
            ["en-US"]: "en-US-JennyNeural",
            ["en-ZA"]: "en-ZA-LeahNeural",
            ["es-AR"]: "es-AR-ElenaNeural",
            ["es-BO"]: "es-BO-MarceloNeural",
            ["es-CL"]: "es-CL-CatalinaNeural",
            ["es-CO"]: "es-CO-GonzaloNeural",
            ["es-CR"]: "es-CR-JuanNeural",
            ["es-CU"]: "es-CU-BelkysNeural",
            ["es-DO"]: "es-DO-EmilioNeural",
            ["es-EC"]: "es-EC-AndreaNeural",
            ["es-ES"]: "es-ES-AlvaroNeural",
            ["es-GQ"]: "es-GQ-JavierNeural",
            ["es-GT"]: "es-GT-AndresNeural",
            ["es-HN"]: "es-HN-CarlosNeural",
            ["es-MX"]: "es-MX-DaliaNeural",
            ["es-NI"]: "es-NI-FedericoNeural",
            ["es-PA"]: "es-PA-MargaritaNeural",
            ["es-PE"]: "es-PE-AlexNeural",
            ["es-PR"]: "es-PR-KarinaNeural",
            ["es-PY"]: "es-PY-MarioNeural",
            ["es-SV"]: "es-SV-LorenaNeural",
            ["es-US"]: "es-US-AlonsoNeural",
            ["es-UY"]: "es-UY-MateoNeural",
            ["es-VE"]: "es-VE-PaolaNeural",
            ["et-EE"]: "et-EE-AnuNeural",
            ["fa-IR"]: "fa-IR-DilaraNeural",
            ["fi-FI"]: "fi-FI-SelmaNeural",
            ["fil-PH"]: "fil-PH-AngeloNeural",
            ["fr-BE"]: "fr-BE-CharlineNeural",
            ["fr-CA"]: "fr-CA-SylvieNeural",
            ["fr-CH"]: "fr-CH-ArianeNeural",
            ["fr-FR"]: "fr-FR-DeniseNeural",
            ["ga-IE"]: "ga-IE-ColmNeural",
            ["gl-ES"]: "gl-ES-RoiNeural",
            ["gu-IN"]: "gu-IN-DhwaniNeural",
            ["he-IL"]: "he-IL-AvriNeural",
            ["hi-IN"]: "hi-IN-MadhurNeural",
            ["hr-HR"]: "hr-HR-GabrijelaNeural",
            ["hu-HU"]: "hu-HU-NoemiNeural",
            ["id-ID"]: "id-ID-ArdiNeural",
            ["is-IS"]: "is-IS-GudrunNeural",
            ["it-IT"]: "it-IT-IsabellaNeural",
            ["ja-JP"]: "ja-JP-NanamiNeural",
            ["jv-ID"]: "jv-ID-DimasNeural",
            ["kk-KZ"]: "kk-KZ-AigulNeural",
            ["km-KH"]: "km-KH-PisethNeural",
            ["kn-IN"]: "kn-IN-GaganNeural",
            ["ko-KR"]: "ko-KR-SunHiNeural",
            ["lo-LA"]: "lo-LA-ChanthavongNeural",
            ["lt-LT"]: "lt-LT-LeonasNeural",
            ["lv-LV"]: "lv-LV-EveritaNeural",
            ["mk-MK"]: "mk-MK-AleksandarNeural",
            ["ml-IN"]: "ml-IN-MidhunNeural",
            ["mr-IN"]: "mr-IN-AarohiNeural",
            ["ms-MY"]: "ms-MY-OsmanNeural",
            ["mt-MT"]: "mt-MT-GraceNeural",
            ["my-MM"]: "my-MM-NilarNeural",
            ["nb-NO"]: "nb-NO-PernilleNeural",
            ["nl-BE"]: "nl-BE-ArnaudNeural",
            ["nl-NL"]: "nl-NL-ColetteNeural",
            ["pl-PL"]: "pl-PL-AgnieszkaNeural",
            ["ps-AF"]: "ps-AF-GulNawazNeural",
            ["pt-BR"]: "pt-BR-FranciscaNeural",
            ["pt-PT"]: "pt-PT-DuarteNeural",
            ["ro-RO"]: "ro-RO-AlinaNeural",
            ["ru-RU"]: "ru-RU-SvetlanaNeural",
            ["si-LK"]: "si-LK-SameeraNeural",
            ["sk-SK"]: "sk-SK-LukasNeural",
            ["sl-SI"]: "sl-SI-PetraNeural",
            ["so-SO"]: "so-SO-MuuseNeural",
            ["sr-RS"]: "sr-RS-NicholasNeural",
            ["su-ID"]: "su-ID-JajangNeural",
            ["sv-SE"]: "sv-SE-SofieNeural",
            ["sw-KE"]: "sw-KE-RafikiNeural",
            ["sw-TZ"]: "sw-TZ-DaudiNeural",
            ["ta-IN"]: "ta-IN-PallaviNeural",
            ["ta-LK"]: "ta-LK-KumarNeural",
            ["ta-SG"]: "ta-SG-AnbuNeural",
            ["te-IN"]: "te-IN-MohanNeural",
            ["th-TH"]: "th-TH-PremwadeeNeural",
            ["tr-TR"]: "tr-TR-AhmetNeural",
            ["uk-UA"]: "uk-UA-OstapNeural",
            ["ur-IN"]: "ur-IN-GulNeural",
            ["ur-PK"]: "ur-PK-AsadNeural",
            ["uz-UZ"]: "uz-UZ-MadinaNeural",
            ["vi-VN"]: "vi-VN-HoaiMyNeural",
            ["zh-CN"]: "zh-CN-XiaoxiaoNeural",
            ["zh-HK"]: "zh-HK-HiuMaanNeural",
            ["zh-TW"]: "zh-TW-HsiaoChenNeural",
            ["zu-ZA"]: "zu-ZA-ThandoNeural"
        };
        let language = this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthLanguage, "en-US");
        let voice = this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthVoice, "");
        let ssml = $c3c9e09732167051$var$Synthesizer.XMLEncode(text);
        if (this.autoDetectSourceLanguage) language = "en-US";
        else voice = voice || languageToDefaultVoice[language];
        if (voice) ssml = `<voice name='${voice}'>${ssml}</voice>`;
        ssml = `<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='${language}'>${ssml}</speak>`;
        return ssml;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Synthesizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */ async dispose(disposing) {
        if (this.privDisposed) return;
        if (disposing) {
            if (this.privAdapter) await this.privAdapter.dispose();
        }
        this.privDisposed = true;
    }
    async adapterSpeak() {
        if (!this.privDisposed && !this.privSynthesizing) {
            this.privSynthesizing = true;
            const request = await this.synthesisRequestQueue.dequeue();
            return this.privAdapter.Speak(request.text, request.isSSML, request.requestId, request.cb, request.err, request.dataStream);
        }
    }
    createSynthesizerConfig(speechConfig) {
        return new $imJeu.SynthesizerConfig(speechConfig, this.privProperties);
    }
    // Does the generic synthesizer setup that is common across all synthesizer types.
    implCommonSynthesizeSetup() {
        let osPlatform = typeof window !== "undefined" ? "Browser" : "Node";
        let osName = "unknown";
        let osVersion = "unknown";
        if (typeof navigator !== "undefined") {
            osPlatform = osPlatform + "/" + navigator.platform;
            osName = navigator.userAgent;
            osVersion = navigator.appVersion;
        }
        const synthesizerConfig = this.createSynthesizerConfig(new $imJeu.SpeechServiceConfig(new $imJeu.Context(new $imJeu.OS(osPlatform, osName, osVersion))));
        const subscriptionKey = this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceConnection_Key, undefined);
        const authentication = subscriptionKey && subscriptionKey !== "" ? new $imJeu.CognitiveSubscriptionKeyAuthentication(subscriptionKey) : new $imJeu.CognitiveTokenAuthentication(()=>{
            const authorizationToken = this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        }, ()=>{
            const authorizationToken = this.privProperties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, undefined);
            return Promise.resolve(authorizationToken);
        });
        this.privAdapter = this.createSynthesisAdapter(authentication, this.privConnectionFactory, synthesizerConfig);
        this.privRestAdapter = this.createRestSynthesisAdapter(authentication, synthesizerConfig);
    }
    static XMLEncode(text) {
        return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    }
}
module.exports.Synthesizer = $c3c9e09732167051$var$Synthesizer;
class $c3c9e09732167051$var$SynthesisRequest {
    constructor(requestId, text, isSSML, cb, err, dataStream){
        this.requestId = requestId;
        this.text = text;
        this.isSSML = isSSML;
        this.cb = cb;
        this.err = err;
        this.dataStream = dataStream;
    }
}
module.exports.SynthesisRequest = $c3c9e09732167051$var$SynthesisRequest;

});

parcelRegister("6XrDK", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesizer = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $ejNtg = parcelRequire("ejNtg");

var $iZxsX = parcelRequire("iZxsX");

var $9QXyd = parcelRequire("9QXyd");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $gOb2m = parcelRequire("gOb2m");
/**
 * Defines the class SpeechSynthesizer for text to speech.
 * Updated in version 1.16.0
 * @class SpeechSynthesizer
 */ class $510db181c519a97f$var$SpeechSynthesizer extends $hVlip.Synthesizer {
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer.
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer.
     */ constructor(speechConfig, audioConfig){
        super(speechConfig);
        if (audioConfig !== null) {
            if (audioConfig === undefined) this.audioConfig = typeof window === "undefined" ? undefined : $hVlip.AudioConfig.fromDefaultSpeakerOutput();
            else this.audioConfig = audioConfig;
        }
        this.privConnectionFactory = new $imJeu.SpeechSynthesisConnectionFactory();
        this.implCommonSynthesizeSetup();
    }
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this synthesizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the synthesizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer
     */ static FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig) {
        const speechConfigImpl = speechConfig;
        autoDetectSourceLanguageConfig.properties.mergeTo(speechConfigImpl.properties);
        return new $510db181c519a97f$var$SpeechSynthesizer(speechConfig, audioConfig);
    }
    /**
     * Executes speech synthesis on plain text.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param text - Text to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ speakTextAsync(text, cb, err, stream) {
        this.speakImpl(text, false, cb, err, stream);
    }
    /**
     * Executes speech synthesis on SSML.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param ssml - SSML to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */ speakSsmlAsync(ssml, cb, err, stream) {
        this.speakImpl(ssml, true, cb, err, stream);
    }
    /**
     * Get list of synthesis voices available.
     * The task returns the synthesis voice result.
     * @member SpeechSynthesizer.prototype.getVoicesAsync
     * @function
     * @async
     * @public
     * @param locale - Locale of voices in BCP-47 format; if left empty, get all available voices.
     * @return {Promise<SynthesisVoicesResult>} - Promise of a SynthesisVoicesResult.
     */ async getVoicesAsync(locale = "") {
        return this.getVoices(locale);
    }
    /**
     * Dispose of associated resources.
     * @member SpeechSynthesizer.prototype.close
     * @function
     * @public
     */ close(cb, err) {
        $56OOs.Contracts.throwIfDisposed(this.privDisposed);
        $3wpON.marshalPromiseToCallbacks(this.dispose(true), cb, err);
    }
    /**
     * @Internal
     * Do not use externally, object returned will change without warning or notice.
     */ get internalData() {
        return this.privAdapter;
    }
    //
    // ################################################################################################################
    // IMPLEMENTATION.
    // ################################################################################################################
    //
    // Creates the synthesis adapter
    createSynthesisAdapter(authentication, connectionFactory, synthesizerConfig) {
        return new $imJeu.SpeechSynthesisAdapter(authentication, connectionFactory, synthesizerConfig, this, this.audioConfig);
    }
    createRestSynthesisAdapter(authentication, synthesizerConfig) {
        return new $imJeu.SynthesisRestAdapter(synthesizerConfig, authentication);
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup();
        this.privAdapter.audioOutputFormat = $iZxsX.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat($hVlip.SpeechSynthesisOutputFormat[this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)]);
    }
    speakImpl(text, IsSsml, cb, err, dataStream) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privDisposed);
            const requestId = $3wpON.createNoDashGuid();
            let audioDestination;
            if (dataStream instanceof $hVlip.PushAudioOutputStreamCallback) audioDestination = new $9QXyd.PushAudioOutputStreamImpl(dataStream);
            else if (dataStream instanceof $hVlip.PullAudioOutputStream) audioDestination = dataStream;
            else if (dataStream !== undefined) audioDestination = new $ejNtg.AudioFileWriter(dataStream);
            else audioDestination = undefined;
            this.synthesisRequestQueue.enqueue(new $gOb2m.SynthesisRequest(requestId, text, IsSsml, (e)=>{
                this.privSynthesizing = false;
                if (!!cb) try {
                    cb(e);
                } catch (e) {
                    if (!!err) err(e);
                }
                cb = undefined;
                /* eslint-disable no-empty */ this.adapterSpeak().catch(()=>{});
            }, (e)=>{
                if (!!err) err(e);
            }, audioDestination));
            /* eslint-disable no-empty-function */ this.adapterSpeak().catch(()=>{});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the synthesizer.
            /* eslint-disable no-empty */ this.dispose(true).catch(()=>{});
        }
    }
    async getVoices(locale) {
        const requestId = $3wpON.createNoDashGuid();
        const response = await this.privRestAdapter.getVoicesList(requestId);
        if (response.ok && Array.isArray(response.json)) {
            let json = response.json;
            if (!!locale && locale.length > 0) json = json.filter((item)=>!!item.Locale && item.Locale.toLowerCase() === locale.toLowerCase());
            return new $hVlip.SynthesisVoicesResult(requestId, json, undefined);
        } else return new $hVlip.SynthesisVoicesResult(requestId, undefined, `Error: ${response.status}: ${response.statusText}`);
    }
}
module.exports.SpeechSynthesizer = $510db181c519a97f$var$SpeechSynthesizer;

});

parcelRegister("45udZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisResult = void 0;
/**
 * Base class for synthesis results
 * @class SynthesisResult
 * Added in version 1.20.0
 */ class $2f9f130379784afd$var$SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(resultId, reason, errorDetails, properties){
        this.privResultId = resultId;
        this.privReason = reason;
        this.privErrorDetails = errorDetails;
        this.privProperties = properties;
    }
    /**
     * Specifies the result identifier.
     * @member SynthesisResult.prototype.resultId
     * @function
     * @public
     * @returns {string} Specifies the result identifier.
     */ get resultId() {
        return this.privResultId;
    }
    /**
     * Specifies status of the result.
     * @member SynthesisResult.prototype.reason
     * @function
     * @public
     * @returns {ResultReason} Specifies status of the result.
     */ get reason() {
        return this.privReason;
    }
    /**
     * In case of an unsuccessful synthesis, provides details of the occurred error.
     * @member SynthesisResult.prototype.errorDetails
     * @function
     * @public
     * @returns {string} a brief description of an error.
     */ get errorDetails() {
        return this.privErrorDetails;
    }
    /**
     * The set of properties exposed in the result.
     * @member SynthesisResult.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The set of properties exposed in the result.
     */ get properties() {
        return this.privProperties;
    }
}
module.exports.SynthesisResult = $2f9f130379784afd$var$SynthesisResult;

});

parcelRegister("6u1NO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisResult = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines result of speech synthesis.
 * @class SpeechSynthesisResult
 * Added in version 1.11.0
 */ class $4b86f1584175e550$var$SpeechSynthesisResult extends $hVlip.SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {ArrayBuffer} audioData - The synthesized audio binary.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     * @param {number} audioDuration - The audio duration.
     */ constructor(resultId, reason, audioData, errorDetails, properties, audioDuration){
        super(resultId, reason, errorDetails, properties);
        this.privAudioData = audioData;
        this.privAudioDuration = audioDuration;
    }
    /**
     * The synthesized audio data
     * @member SpeechSynthesisResult.prototype.audioData
     * @function
     * @public
     * @returns {ArrayBuffer} The synthesized audio data.
     */ get audioData() {
        return this.privAudioData;
    }
    /**
     * The time duration of synthesized audio, in ticks (100 nanoseconds).
     * @member SpeechSynthesisResult.prototype.audioDuration
     * @function
     * @public
     * @returns {number} The time duration of synthesized audio.
     */ get audioDuration() {
        return this.privAudioDuration;
    }
}
module.exports.SpeechSynthesisResult = $4b86f1584175e550$var$SpeechSynthesisResult;

});

parcelRegister("8QCaW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisEventArgs = void 0;
/**
 * Defines contents of speech synthesis events.
 * @class SpeechSynthesisEventArgs
 * Added in version 1.11.0
 */ class $6710cae3f684c40e$var$SpeechSynthesisEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechSynthesisResult} result - The speech synthesis result.
     */ constructor(result){
        this.privResult = result;
    }
    /**
     * Specifies the synthesis result.
     * @member SpeechSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechSynthesisResult} the synthesis result.
     */ get result() {
        return this.privResult;
    }
}
module.exports.SpeechSynthesisEventArgs = $6710cae3f684c40e$var$SpeechSynthesisEventArgs;

});

parcelRegister("8xaKx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisWordBoundaryEventArgs = void 0;
/**
 * Defines contents of speech synthesis word boundary event.
 * @class SpeechSynthesisWordBoundaryEventArgs
 * Added in version 1.11.0
 */ class $6369be70e1ce9d7c$var$SpeechSynthesisWordBoundaryEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} duration - The audio duration.
     * @param {string} text - The text.
     * @param {number} wordLength - The length of the word.
     * @param {number} textOffset - The text offset.
     * @param {SpeechSynthesisBoundaryType} boundaryType - The boundary type
     */ constructor(audioOffset, duration, text, wordLength, textOffset, boundaryType){
        this.privAudioOffset = audioOffset;
        this.privDuration = duration;
        this.privText = text;
        this.privWordLength = wordLength;
        this.privTextOffset = textOffset;
        this.privBoundaryType = boundaryType;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the duration, in ticks (100 nanoseconds).
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.duration
     * @function
     * @public
     * @returns {number} Duration in 100 nanosecond increments.
     */ get duration() {
        return this.privDuration;
    }
    /**
     * Specifies the text of the word boundary event.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the text.
     */ get text() {
        return this.privText;
    }
    /**
     * Specifies the word length
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
     * @function
     * @public
     * @returns {number} the word length
     */ get wordLength() {
        return this.privWordLength;
    }
    /**
     * Specifies the text offset.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
     * @function
     * @public
     * @returns {number} the text offset.
     */ get textOffset() {
        return this.privTextOffset;
    }
    /**
     * Specifies the boundary type.
     * @member SpeechSynthesisWordBoundaryEventArgs.prototype.boundaryType
     * @function
     * @public
     * @returns {SpeechSynthesisBoundaryType} the boundary type.
     */ get boundaryType() {
        return this.privBoundaryType;
    }
}
module.exports.SpeechSynthesisWordBoundaryEventArgs = $6369be70e1ce9d7c$var$SpeechSynthesisWordBoundaryEventArgs;

});

parcelRegister("3MWBI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisBookmarkEventArgs = void 0;
/**
 * Defines contents of speech synthesis bookmark event.
 * @class SpeechSynthesisBookmarkEventArgs
 * Added in version 1.16.0
 */ class $2c2350fc37658541$var$SpeechSynthesisBookmarkEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} text - The bookmark text.
     */ constructor(audioOffset, text){
        this.privAudioOffset = audioOffset;
        this.privText = text;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the bookmark.
     * @member SpeechSynthesisBookmarkEventArgs.prototype.text
     * @function
     * @public
     * @returns {string} the bookmark text.
     */ get text() {
        return this.privText;
    }
}
module.exports.SpeechSynthesisBookmarkEventArgs = $2c2350fc37658541$var$SpeechSynthesisBookmarkEventArgs;

});

parcelRegister("d4ICM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisVisemeEventArgs = void 0;
/**
 * Defines contents of speech synthesis viseme event.
 * @class SpeechSynthesisVisemeEventArgs
 * Added in version 1.16.0
 */ class $984e43936bd07e27$var$SpeechSynthesisVisemeEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {number} visemeId - The viseme ID.
     * @param {string} animation - The animation, could be in svg or other format.
     */ constructor(audioOffset, visemeId, animation){
        this.privAudioOffset = audioOffset;
        this.privVisemeId = visemeId;
        this.privAnimation = animation;
    }
    /**
     * Specifies the audio offset.
     * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
     * @function
     * @public
     * @returns {number} the audio offset.
     */ get audioOffset() {
        return this.privAudioOffset;
    }
    /**
     * Specifies the viseme ID.
     * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
     * @function
     * @public
     * @returns {number} the viseme ID.
     */ get visemeId() {
        return this.privVisemeId;
    }
    /**
     * Specifies the animation.
     * @member SpeechSynthesisVisemeEventArgs.prototype.animation
     * @function
     * @public
     * @returns {string} the animation, could be in svg or other format.
     */ get animation() {
        return this.privAnimation;
    }
}
module.exports.SpeechSynthesisVisemeEventArgs = $984e43936bd07e27$var$SpeechSynthesisVisemeEventArgs;

});

parcelRegister("i8rup", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisBoundaryType = void 0;
/**
 * Defines the boundary type of speech synthesis boundary event.
 * @class SpeechSynthesisBoundaryType
 * Added in version 1.21.0
 */ var $d33e4c300e6b9673$var$SpeechSynthesisBoundaryType;
(function(SpeechSynthesisBoundaryType) {
    /**
     * Indicates the boundary text is a word.
     * @member SpeechSynthesisBoundaryType.Word
     */ SpeechSynthesisBoundaryType["Word"] = "WordBoundary";
    /**
     * Indicates the boundary text is a punctuation.
     * @member SpeechSynthesisBoundaryType.Punctuation
     */ SpeechSynthesisBoundaryType["Punctuation"] = "PunctuationBoundary";
    /**
     * Indicates the boundary text is a sentence.
     * @member SpeechSynthesisBoundaryType.Sentence
     */ SpeechSynthesisBoundaryType["Sentence"] = "SentenceBoundary";
})($d33e4c300e6b9673$var$SpeechSynthesisBoundaryType = module.exports.SpeechSynthesisBoundaryType || (module.exports.SpeechSynthesisBoundaryType = {}));

});

parcelRegister("d9PZL", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisVoicesResult = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines result of speech synthesis.
 * @class SynthesisVoicesResult
 * Added in version 1.20.0
 */ class $994472c9af71bc3d$var$SynthesisVoicesResult extends $hVlip.SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param requestId - result id for request.
     * @param json - json payload from endpoint.
     */ constructor(requestId, json, errorDetails){
        if (Array.isArray(json)) {
            super(requestId, $hVlip.ResultReason.VoicesListRetrieved, undefined, new $hVlip.PropertyCollection());
            this.privVoices = [];
            for (const item of json)this.privVoices.push(new $hVlip.VoiceInfo(item));
        } else super(requestId, $hVlip.ResultReason.Canceled, errorDetails ? errorDetails : "Error information unavailable", new $hVlip.PropertyCollection());
    }
    /**
     * The list of voices
     * @member SynthesisVoicesResult.prototype.voices
     * @function
     * @public
     * @returns {VoiceInfo[]} List of synthesized voices.
     */ get voices() {
        return this.privVoices;
    }
}
module.exports.SynthesisVoicesResult = $994472c9af71bc3d$var$SynthesisVoicesResult;

});

parcelRegister("8xKFP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceInfo = module.exports.SynthesisVoiceType = module.exports.SynthesisVoiceGender = void 0;
/**
 * Defines the gender of synthesis voices.
 * Added in version 1.20.0.
 */ var $63859c32636e38d5$var$SynthesisVoiceGender;
(function(SynthesisVoiceGender) {
    /** Gender unknown */ SynthesisVoiceGender[SynthesisVoiceGender["Unknown"] = 0] = "Unknown";
    /** Female voice */ SynthesisVoiceGender[SynthesisVoiceGender["Female"] = 1] = "Female";
    /** Male voice */ SynthesisVoiceGender[SynthesisVoiceGender["Male"] = 2] = "Male";
    /** Neutral voice */ SynthesisVoiceGender[SynthesisVoiceGender["Neutral"] = 3] = "Neutral";
})($63859c32636e38d5$var$SynthesisVoiceGender = module.exports.SynthesisVoiceGender || (module.exports.SynthesisVoiceGender = {}));
var $63859c32636e38d5$var$SynthesisVoiceType;
(function(SynthesisVoiceType) {
    SynthesisVoiceType[SynthesisVoiceType["OnlineNeural"] = 1] = "OnlineNeural";
    SynthesisVoiceType[SynthesisVoiceType["OnlineStandard"] = 2] = "OnlineStandard";
    SynthesisVoiceType[SynthesisVoiceType["OfflineNeural"] = 3] = "OfflineNeural";
    SynthesisVoiceType[SynthesisVoiceType["OfflineStandard"] = 4] = "OfflineStandard";
})($63859c32636e38d5$var$SynthesisVoiceType = module.exports.SynthesisVoiceType || (module.exports.SynthesisVoiceType = {}));
const $63859c32636e38d5$var$GENDER_LOOKUP = {
    [$63859c32636e38d5$var$SynthesisVoiceGender[$63859c32636e38d5$var$SynthesisVoiceGender.Neutral]]: $63859c32636e38d5$var$SynthesisVoiceGender.Neutral,
    [$63859c32636e38d5$var$SynthesisVoiceGender[$63859c32636e38d5$var$SynthesisVoiceGender.Male]]: $63859c32636e38d5$var$SynthesisVoiceGender.Male,
    [$63859c32636e38d5$var$SynthesisVoiceGender[$63859c32636e38d5$var$SynthesisVoiceGender.Female]]: $63859c32636e38d5$var$SynthesisVoiceGender.Female
};
/**
 * Information about Speech Synthesis voice
 * Added in version 1.20.0.
 * @class VoiceInfo
 */ class $63859c32636e38d5$var$VoiceInfo {
    constructor(json){
        this.privStyleList = [];
        if (!!json) {
            this.privName = json.Name;
            this.privLocale = json.Locale;
            this.privShortName = json.ShortName;
            this.privLocaleName = json.LocaleName;
            this.privDisplayName = json.DisplayName;
            this.privLocalName = json.LocalName;
            this.privVoiceType = json.VoiceType.endsWith("Standard") ? $63859c32636e38d5$var$SynthesisVoiceType.OnlineStandard : $63859c32636e38d5$var$SynthesisVoiceType.OnlineNeural;
            this.privGender = $63859c32636e38d5$var$GENDER_LOOKUP[json.Gender] || $63859c32636e38d5$var$SynthesisVoiceGender.Unknown;
            if (!!json.StyleList && Array.isArray(json.StyleList)) for (const style of json.StyleList)this.privStyleList.push(style);
            this.privSampleRateHertz = json.SampleRateHertz;
            this.privStatus = json.Status;
            if (json.ExtendedPropertyMap) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privExtendedPropertyMap = json.ExtendedPropertyMap;
            this.privWordsPerMinute = json.WordsPerMinute;
            if (Array.isArray(json.SecondaryLocaleList)) this.privSecondaryLocaleList = [
                ...json.SecondaryLocaleList
            ];
            if (Array.isArray(json.RolePlayList)) this.privRolePlayList = [
                ...json.RolePlayList
            ];
        }
    }
    get name() {
        return this.privName;
    }
    get locale() {
        return this.privLocale;
    }
    get shortName() {
        return this.privShortName;
    }
    get displayName() {
        return this.privDisplayName;
    }
    get localName() {
        return this.privLocalName;
    }
    get localeName() {
        return this.privLocaleName;
    }
    get gender() {
        return this.privGender;
    }
    get voiceType() {
        return this.privVoiceType;
    }
    get styleList() {
        return this.privStyleList;
    }
    get sampleRateHertz() {
        return this.privSampleRateHertz;
    }
    get status() {
        return this.privStatus;
    }
    get extendedPropertyMap() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.privExtendedPropertyMap;
    }
    get wordsPerMinute() {
        return this.privWordsPerMinute;
    }
    get secondaryLocaleList() {
        return this.privSecondaryLocaleList;
    }
    get rolePlayList() {
        return this.privRolePlayList;
    }
}
module.exports.VoiceInfo = $63859c32636e38d5$var$VoiceInfo;

});

parcelRegister("cHtxA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerAudioDestination = void 0;

var $3wpON = parcelRequire("3wpON");

var $9QXyd = parcelRequire("9QXyd");

var $d3s41 = parcelRequire("d3s41");
const $93f06a55eb4ed719$var$MediaDurationPlaceholderSeconds = 1800;
const $93f06a55eb4ed719$var$AudioFormatToMimeType = {
    [$d3s41.AudioFormatTag.PCM]: "audio/wav",
    [$d3s41.AudioFormatTag.MuLaw]: "audio/x-wav",
    [$d3s41.AudioFormatTag.MP3]: "audio/mpeg",
    [$d3s41.AudioFormatTag.OGG_OPUS]: "audio/ogg",
    [$d3s41.AudioFormatTag.WEBM_OPUS]: "audio/webm; codecs=opus",
    [$d3s41.AudioFormatTag.ALaw]: "audio/x-wav",
    [$d3s41.AudioFormatTag.FLAC]: "audio/flac"
};
/**
 * Represents the speaker playback audio destination, which only works in browser.
 * Note: the SDK will try to use <a href="https://www.w3.org/TR/media-source/">Media Source Extensions</a> to play audio.
 * Mp3 format has better supports on Microsoft Edge, Chrome and Safari (desktop), so, it's better to specify mp3 format for playback.
 * @class SpeakerAudioDestination
 * Updated in version 1.17.0
 */ class $93f06a55eb4ed719$var$SpeakerAudioDestination {
    constructor(audioDestinationId){
        this.privPlaybackStarted = false;
        this.privAppendingToBuffer = false;
        this.privMediaSourceOpened = false;
        this.privBytesReceived = 0;
        this.privId = audioDestinationId ? audioDestinationId : $3wpON.createNoDashGuid();
        this.privIsPaused = false;
        this.privIsClosed = false;
    }
    id() {
        return this.privId;
    }
    write(buffer, cb, err) {
        if (this.privAudioBuffer !== undefined) {
            this.privAudioBuffer.push(buffer);
            this.updateSourceBuffer().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        } else if (this.privAudioOutputStream !== undefined) {
            this.privAudioOutputStream.write(buffer);
            this.privBytesReceived += buffer.byteLength;
        }
    }
    close(cb, err) {
        this.privIsClosed = true;
        if (this.privSourceBuffer !== undefined) this.handleSourceBufferUpdateEnd().then(()=>{
            if (!!cb) cb();
        }, (error)=>{
            if (!!err) err(error);
        });
        else if (this.privAudioOutputStream !== undefined && typeof window !== "undefined") {
            if ((this.privFormat.formatTag === $d3s41.AudioFormatTag.PCM || this.privFormat.formatTag === $d3s41.AudioFormatTag.MuLaw || this.privFormat.formatTag === $d3s41.AudioFormatTag.ALaw) && this.privFormat.hasHeader === false) {
                // eslint-disable-next-line no-console
                console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header.");
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            } else {
                let receivedAudio = new ArrayBuffer(this.privBytesReceived);
                this.privAudioOutputStream.read(receivedAudio).then(()=>{
                    receivedAudio = this.privFormat.addHeader(receivedAudio);
                    const audioBlob = new Blob([
                        receivedAudio
                    ], {
                        type: $93f06a55eb4ed719$var$AudioFormatToMimeType[this.privFormat.formatTag]
                    });
                    this.privAudio.src = window.URL.createObjectURL(audioBlob);
                    this.notifyPlayback().then(()=>{
                        if (!!cb) cb();
                    }, (error)=>{
                        if (!!err) err(error);
                    });
                }, (error)=>{
                    if (!!err) err(error);
                });
            }
        } else // unsupported format, call onAudioEnd directly.
        if (!!this.onAudioEnd) this.onAudioEnd(this);
    }
    set format(format) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (typeof AudioContext !== "undefined" || typeof window !== "undefined" && typeof window.webkitAudioContext !== "undefined") {
            this.privFormat = format;
            const mimeType = $93f06a55eb4ed719$var$AudioFormatToMimeType[this.privFormat.formatTag];
            if (mimeType === undefined) // eslint-disable-next-line no-console
            console.warn(`Unknown mimeType for format ${$d3s41.AudioFormatTag[this.privFormat.formatTag]}; playback is not supported.`);
            else if (typeof MediaSource !== "undefined" && MediaSource.isTypeSupported(mimeType)) {
                this.privAudio = new Audio();
                this.privAudioBuffer = [];
                this.privMediaSource = new MediaSource();
                this.privAudio.src = URL.createObjectURL(this.privMediaSource);
                this.privAudio.load();
                this.privMediaSource.onsourceopen = ()=>{
                    this.privMediaSourceOpened = true;
                    this.privMediaSource.duration = $93f06a55eb4ed719$var$MediaDurationPlaceholderSeconds;
                    this.privSourceBuffer = this.privMediaSource.addSourceBuffer(mimeType);
                    this.privSourceBuffer.onupdate = ()=>{
                        this.updateSourceBuffer().catch((reason)=>{
                            $3wpON.Events.instance.onEvent(new $3wpON.BackgroundEvent(reason));
                        });
                    };
                    this.privSourceBuffer.onupdateend = ()=>{
                        this.handleSourceBufferUpdateEnd().catch((reason)=>{
                            $3wpON.Events.instance.onEvent(new $3wpON.BackgroundEvent(reason));
                        });
                    };
                    this.privSourceBuffer.onupdatestart = ()=>{
                        this.privAppendingToBuffer = false;
                    };
                };
                this.updateSourceBuffer().catch((reason)=>{
                    $3wpON.Events.instance.onEvent(new $3wpON.BackgroundEvent(reason));
                });
            } else {
                // eslint-disable-next-line no-console
                console.warn(`Format ${$d3s41.AudioFormatTag[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`);
                this.privAudioOutputStream = new $9QXyd.PullAudioOutputStreamImpl();
                this.privAudioOutputStream.format = this.privFormat;
                this.privAudio = new Audio();
            }
        }
    }
    get volume() {
        return this.privAudio?.volume ?? -1;
    }
    set volume(volume) {
        if (!!this.privAudio) this.privAudio.volume = volume;
    }
    mute() {
        if (!!this.privAudio) this.privAudio.muted = true;
    }
    unmute() {
        if (!!this.privAudio) this.privAudio.muted = false;
    }
    get isClosed() {
        return this.privIsClosed;
    }
    get currentTime() {
        if (this.privAudio !== undefined) return this.privAudio.currentTime;
        return -1;
    }
    pause() {
        if (!this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.pause();
            this.privIsPaused = true;
        }
    }
    resume(cb, err) {
        if (this.privIsPaused && this.privAudio !== undefined) {
            this.privAudio.play().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
            this.privIsPaused = false;
        }
    }
    get internalAudio() {
        return this.privAudio;
    }
    async updateSourceBuffer() {
        if (this.privAudioBuffer !== undefined && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
            this.privAppendingToBuffer = true;
            const binary = this.privAudioBuffer.shift();
            try {
                this.privSourceBuffer.appendBuffer(binary);
            } catch (error) {
                this.privAudioBuffer.unshift(binary);
                // eslint-disable-next-line no-console
                console.log("buffer filled, pausing addition of binaries until space is made");
                return;
            }
            await this.notifyPlayback();
        } else if (this.canEndStream()) await this.handleSourceBufferUpdateEnd();
    }
    async handleSourceBufferUpdateEnd() {
        if (this.canEndStream() && this.sourceBufferAvailable()) {
            this.privMediaSource.endOfStream();
            await this.notifyPlayback();
        }
    }
    async notifyPlayback() {
        if (!this.privPlaybackStarted && this.privAudio !== undefined) {
            this.privPlaybackStarted = true;
            if (!!this.onAudioStart) this.onAudioStart(this);
            this.privAudio.onended = ()=>{
                if (!!this.onAudioEnd) this.onAudioEnd(this);
            };
            if (!this.privIsPaused) await this.privAudio.play();
        }
    }
    canEndStream() {
        return this.isClosed && this.privSourceBuffer !== undefined && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
    sourceBufferAvailable() {
        return this.privSourceBuffer !== undefined && !this.privSourceBuffer.updating;
    }
}
module.exports.SpeakerAudioDestination = $93f06a55eb4ed719$var$SpeakerAudioDestination;

});

parcelRegister("4QJl0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionCanceledEventArgs = void 0;

var $6sMHZ = parcelRequire("6sMHZ");
/**
 * Defines content of a RecognitionErrorEvent.
 * @class ConversationTranscriptionCanceledEventArgs
 */ class $387f2fdf28cb7c52$var$ConversationTranscriptionCanceledEventArgs extends $6sMHZ.CancellationEventArgsBase {
}
module.exports.ConversationTranscriptionCanceledEventArgs = $387f2fdf28cb7c52$var$ConversationTranscriptionCanceledEventArgs;

});

parcelRegister("lsy1t", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeetingTranscriptionCanceledEventArgs = void 0;

var $6sMHZ = parcelRequire("6sMHZ");
/**
 * Defines content of a MeetingTranscriptionCanceledEvent.
 * @class MeetingTranscriptionCanceledEventArgs
 */ class $f9f69ab87e012b8e$var$MeetingTranscriptionCanceledEventArgs extends $6sMHZ.CancellationEventArgsBase {
}
module.exports.MeetingTranscriptionCanceledEventArgs = $f9f69ab87e012b8e$var$MeetingTranscriptionCanceledEventArgs;

});

parcelRegister("1WcB6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGradingSystem = void 0;
/**
 * Defines the point system for pronunciation score calibration; default value is FivePoint.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGradingSystem
 */ var $1694facbcb98dc2e$var$PronunciationAssessmentGradingSystem;
(function(PronunciationAssessmentGradingSystem) {
    /**
     * Five point calibration
     * @member PronunciationAssessmentGradingSystem.FivePoint
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["FivePoint"] = 1] = "FivePoint";
    /**
     * Hundred mark
     * @member PronunciationAssessmentGradingSystem.HundredMark
     */ PronunciationAssessmentGradingSystem[PronunciationAssessmentGradingSystem["HundredMark"] = 2] = "HundredMark";
})($1694facbcb98dc2e$var$PronunciationAssessmentGradingSystem = module.exports.PronunciationAssessmentGradingSystem || (module.exports.PronunciationAssessmentGradingSystem = {}));

});

parcelRegister("jKHVl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentGranularity = void 0;
/**
 * Defines the pronunciation evaluation granularity; default value is Phoneme.
 * Added in version 1.15.0
 * @class PronunciationAssessmentGranularity
 */ var $e6146292c13ad8ec$var$PronunciationAssessmentGranularity;
(function(PronunciationAssessmentGranularity) {
    /**
     * Shows the score on the full text, word and phoneme level
     * @member PronunciationAssessmentGranularity.Phoneme
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Phoneme"] = 1] = "Phoneme";
    /**
     * Shows the score on the full text and word level
     * @member PronunciationAssessmentGranularity.Word
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["Word"] = 2] = "Word";
    /**
     * Shows the score on the full text level only
     * @member PronunciationAssessmentGranularity.FullText
     */ PronunciationAssessmentGranularity[PronunciationAssessmentGranularity["FullText"] = 3] = "FullText";
})($e6146292c13ad8ec$var$PronunciationAssessmentGranularity = module.exports.PronunciationAssessmentGranularity || (module.exports.PronunciationAssessmentGranularity = {}));

});

parcelRegister("gbCaE", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentConfig = void 0;

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Pronunciation assessment configuration.
 * @class PronunciationAssessmentConfig
 * Added in version 1.15.0.
 */ class $bc8b48525f0072af$var$PronunciationAssessmentConfig {
    /**
     * PronunciationAssessmentConfig constructor.
     * @constructor
     * @param {string} referenceText
     * @param gradingSystem
     * @param granularity
     * @param enableMiscue
     */ constructor(referenceText, gradingSystem = $hVlip.PronunciationAssessmentGradingSystem.FivePoint, granularity = $hVlip.PronunciationAssessmentGranularity.Phoneme, enableMiscue = false){
        $56OOs.Contracts.throwIfNullOrUndefined(referenceText, "referenceText");
        this.privProperties = new $hVlip.PropertyCollection();
        this.privProperties.setProperty($hVlip.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
        this.privProperties.setProperty($hVlip.PropertyId.PronunciationAssessment_GradingSystem, $hVlip.PronunciationAssessmentGradingSystem[gradingSystem]);
        this.privProperties.setProperty($hVlip.PropertyId.PronunciationAssessment_Granularity, $hVlip.PronunciationAssessmentGranularity[granularity]);
        this.privProperties.setProperty($hVlip.PropertyId.PronunciationAssessment_EnableMiscue, String(enableMiscue));
    }
    /**
     * @member PronunciationAssessmentConfig.fromJSON
     * @function
     * @public
     * @param {string} json The json string containing the pronunciation assessment parameters.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentConfig from json.
     * This method is designed to support the pronunciation assessment parameters still in preview.
     * Under normal circumstances, use the constructor instead.
     */ static fromJSON(json) {
        $56OOs.Contracts.throwIfNullOrUndefined(json, "json");
        const config = new $bc8b48525f0072af$var$PronunciationAssessmentConfig("");
        config.privProperties = new $hVlip.PropertyCollection();
        config.properties.setProperty($hVlip.PropertyId.PronunciationAssessment_Json, json);
        return config;
    }
    toJSON() {
        this.updateJson();
        return this.privProperties.getProperty($hVlip.PropertyId.PronunciationAssessment_Params);
    }
    applyTo(recognizer) {
        this.updateJson();
        const recoBase = recognizer.internalData;
        recoBase.expectContentAssessmentResponse = !!this.privContentAssessmentTopic;
        recoBase.speechContext.setPronunciationAssessmentParams(this.properties.getProperty($hVlip.PropertyId.PronunciationAssessment_Params), this.privContentAssessmentTopic, recoBase.isSpeakerDiarizationEnabled);
    }
    /**
     * Gets the reference text.
     * @member PronunciationAssessmentConfig.prototype.referenceText
     * @function
     * @public
     * @returns {string} Reference text.
     */ get referenceText() {
        return this.properties.getProperty($hVlip.PropertyId.PronunciationAssessment_ReferenceText);
    }
    /**
     * Gets/Sets the reference text.
     * @member PronunciationAssessmentConfig.prototype.referenceText
     * @function
     * @public
     * @param {string} referenceText - Reference text.
     */ set referenceText(referenceText) {
        $56OOs.Contracts.throwIfNullOrWhitespace(referenceText, "referenceText");
        this.properties.setProperty($hVlip.PropertyId.PronunciationAssessment_ReferenceText, referenceText);
    }
    /**
     * Sets the phoneme alphabet.
     * The valid values are "SAPI" (default) and "IPA".
     * Added in version 1.20.0
     * @member PronunciationAssessmentConfig.prototype.phonemeAlphabet
     * @function
     * @public
     * @param {string} phonemeAlphabet - Phoneme alphabet.
     */ set phonemeAlphabet(phonemeAlphabet) {
        $56OOs.Contracts.throwIfNullOrWhitespace(phonemeAlphabet, "phonemeAlphabet");
        this.privPhonemeAlphabet = phonemeAlphabet;
    }
    /**
     * Sets the boolean enableMiscue property.
     * Added in version 1.26.0
     * @member PronunciationAssessmentConfig.prototype.enableMiscue
     * @function
     * @public
     * @param {boolean} enableMiscue - enable miscue.
     */ set enableMiscue(enableMiscue) {
        const enableMiscueString = enableMiscue ? "true" : "false";
        this.properties.setProperty($hVlip.PropertyId.PronunciationAssessment_EnableMiscue, enableMiscueString);
    }
    /**
     * Gets the boolean enableMiscue property.
     * Added in version 1.26.0
     * @member PronunciationAssessmentConfig.prototype.enableMiscue
     * @function
     * @public
     * @return {boolean} enableMiscue - enable miscue.
     */ get enableMiscue() {
        const enableMiscueString = this.properties.getProperty($hVlip.PropertyId.PronunciationAssessment_EnableMiscue, "false");
        return enableMiscueString.toLowerCase() === "true";
    }
    /**
     * Sets the nbest phoneme count
     * Added in version 1.20.0
     * @member PronunciationAssessmentConfig.prototype.nbestPhonemeCount
     * @function
     * @public
     * @param {number} nbestPhonemeCount - NBest phoneme count.
     */ set nbestPhonemeCount(nbestPhonemeCount) {
        this.privNBestPhonemeCount = nbestPhonemeCount;
    }
    /**
     * Enables the prosody assessment.
     * Added in version 1.34.0
     * @member PronunciationAssessmentConfig.prototype.enableProsodyAssessment
     * @function
     * @public
     * @param {boolean} enableProsodyAssessment - enable prosody assessment.
     */ set enableProsodyAssessment(enableProsodyAssessment) {
        this.privEnableProsodyAssessment = enableProsodyAssessment;
    }
    /**
     * Enables content assessment and sets the topic.
     * Added in version 1.34.0
     * @member PronunciationAssessmentConfig.prototype.enableContentAssessmentWithTopic
     * @function
     * @public
     * @param {string} topic - Topic for content assessment.
     */ enableContentAssessmentWithTopic(topic) {
        this.privContentAssessmentTopic = topic;
    }
    /**
     * @member PronunciationAssessmentConfig.prototype.properties
     * @function
     * @public
     * @return {PropertyCollection} Properties of the config.
     * @summary Gets a pronunciation assessment config properties
     */ get properties() {
        return this.privProperties;
    }
    updateJson() {
        const jsonString = this.privProperties.getProperty($hVlip.PropertyId.PronunciationAssessment_Json, "{}");
        const paramsJson = JSON.parse(jsonString);
        const referenceText = this.privProperties.getProperty($hVlip.PropertyId.PronunciationAssessment_ReferenceText);
        if (referenceText) paramsJson.referenceText = referenceText;
        const gradingSystem = this.privProperties.getProperty($hVlip.PropertyId.PronunciationAssessment_GradingSystem);
        if (gradingSystem) paramsJson.gradingSystem = gradingSystem;
        const granularity = this.privProperties.getProperty($hVlip.PropertyId.PronunciationAssessment_Granularity);
        if (granularity) paramsJson.granularity = granularity;
        if (this.privPhonemeAlphabet) paramsJson.phonemeAlphabet = this.privPhonemeAlphabet;
        if (this.privNBestPhonemeCount) paramsJson.nbestPhonemeCount = this.privNBestPhonemeCount;
        paramsJson.enableProsodyAssessment = this.privEnableProsodyAssessment;
        // always set dimension to Comprehensive
        paramsJson.dimension = "Comprehensive";
        const enableMiscueString = this.privProperties.getProperty($hVlip.PropertyId.PronunciationAssessment_EnableMiscue);
        if (enableMiscueString) paramsJson.enableMiscue = this.enableMiscue;
        this.privProperties.setProperty($hVlip.PropertyId.PronunciationAssessment_Params, JSON.stringify(paramsJson));
    }
}
module.exports.PronunciationAssessmentConfig = $bc8b48525f0072af$var$PronunciationAssessmentConfig;

});

parcelRegister("htB7x", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PronunciationAssessmentResult = module.exports.ContentAssessmentResult = void 0;

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
class $cb91f073d64b88d9$var$ContentAssessmentResult {
    /**
     * @Internal
     * Do not use externally.
     */ constructor(detailResult){
        this.privPronJson = detailResult;
    }
    /**
     * Correctness in using grammar and variety of sentence patterns.
     * Grammatical errors are jointly evaluated by lexical accuracy,
     * grammatical accuracy and diversity of sentence structures.
     * @member ContentAssessmentResult.prototype.grammarScore
     * @function
     * @public
     * @returns {number} Grammar score.
     */ get grammarScore() {
        return this.privPronJson.ContentAssessment.GrammarScore;
    }
    /**
     * Proficiency in lexical usage. It evaluates the speaker's effective usage
     * of words and their appropriateness within the given context to express
     * ideas accurately, as well as level of lexical complexity.
     * @member ContentAssessmentResult.prototype.vocabularyScore
     * @function
     * @public
     * @returns {number} Vocabulary score.
     */ get vocabularyScore() {
        return this.privPronJson.ContentAssessment.VocabularyScore;
    }
    /**
     * Level of understanding and engagement with the topic, which provides
     * insights into the speaker’s ability to express their thoughts and ideas
     * effectively and the ability to engage with the topic.
     * @member ContentAssessmentResult.prototype.topicScore
     * @function
     * @public
     * @returns {number} Topic score.
     */ get topicScore() {
        return this.privPronJson.ContentAssessment.TopicScore;
    }
}
module.exports.ContentAssessmentResult = $cb91f073d64b88d9$var$ContentAssessmentResult;
/**
 * Pronunciation assessment results.
 * @class PronunciationAssessmentResult
 * Added in version 1.15.0.
 */ class $cb91f073d64b88d9$var$PronunciationAssessmentResult {
    constructor(jsonString){
        const j = JSON.parse(jsonString);
        $56OOs.Contracts.throwIfNullOrUndefined(j.NBest[0], "NBest");
        this.privPronJson = j.NBest[0];
    }
    /**
     * @member PronunciationAssessmentResult.fromResult
     * @function
     * @public
     * @param {RecognitionResult} result The recognition result.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentResult from recognition result.
     */ static fromResult(result) {
        $56OOs.Contracts.throwIfNullOrUndefined(result, "result");
        const json = result.properties.getProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult);
        $56OOs.Contracts.throwIfNullOrUndefined(json, "json");
        return new $cb91f073d64b88d9$var$PronunciationAssessmentResult(json);
    }
    /**
     * Gets the detail result of pronunciation assessment.
     * @member PronunciationAssessmentConfig.prototype.detailResult
     * @function
     * @public
     * @returns {DetailResult} detail result.
     */ get detailResult() {
        return this.privPronJson;
    }
    /**
     * The score indicating the pronunciation accuracy of the given speech, which indicates
     * how closely the phonemes match a native speaker's pronunciation.
     * @member PronunciationAssessmentResult.prototype.accuracyScore
     * @function
     * @public
     * @returns {number} Accuracy score.
     */ get accuracyScore() {
        return this.detailResult.PronunciationAssessment?.AccuracyScore;
    }
    /**
     * The overall score indicating the pronunciation quality of the given speech.
     * This is calculated from AccuracyScore, FluencyScore and CompletenessScore with weight.
     * @member PronunciationAssessmentResult.prototype.pronunciationScore
     * @function
     * @public
     * @returns {number} Pronunciation score.
     */ get pronunciationScore() {
        return this.detailResult.PronunciationAssessment?.PronScore;
    }
    /**
     * The score indicating the completeness of the given speech by calculating the ratio of pronounced words towards entire input.
     * @member PronunciationAssessmentResult.prototype.completenessScore
     * @function
     * @public
     * @returns {number} Completeness score.
     */ get completenessScore() {
        return this.detailResult.PronunciationAssessment?.CompletenessScore;
    }
    /**
     * The score indicating the fluency of the given speech.
     * @member PronunciationAssessmentResult.prototype.fluencyScore
     * @function
     * @public
     * @returns {number} Fluency score.
     */ get fluencyScore() {
        return this.detailResult.PronunciationAssessment?.FluencyScore;
    }
    /**
     * The prosody score, which indicates how nature of the given speech, including stress, intonation, speaking speed and rhythm.
     * @member PronunciationAssessmentResult.prototype.prosodyScore
     * @function
     * @public
     * @returns {number} Prosody score.
     */ get prosodyScore() {
        return this.detailResult.PronunciationAssessment?.ProsodyScore;
    }
    /**
     * The concent assessment result.
     * Only available when content assessment is enabled.
     * @member PronunciationAssessmentResult.prototype.contentAssessmentResult
     * @function
     * @public
     * @returns {ContentAssessmentResult} Content assessment result.
     */ get contentAssessmentResult() {
        if (this.detailResult.ContentAssessment === undefined) return undefined;
        return new $cb91f073d64b88d9$var$ContentAssessmentResult(this.detailResult);
    }
}
module.exports.PronunciationAssessmentResult = $cb91f073d64b88d9$var$PronunciationAssessmentResult;

});

parcelRegister("bzKTc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarConfig = void 0;

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");
/**
 * Defines the talking avatar configuration.
 * @class AvatarConfig
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change or have limited support.
 */ class $86d755d075278a6b$var$AvatarConfig {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} character - The avatar character.
     * @param {string} style - The avatar style.
     * @param {AvatarVideoFormat} videoFormat - The talking avatar output video format.
     */ constructor(character, style, videoFormat){
        this.privCustomized = false;
        $56OOs.Contracts.throwIfNullOrWhitespace(character, "character");
        this.character = character;
        this.style = style;
        if (videoFormat === undefined) videoFormat = new $hVlip.AvatarVideoFormat();
        this.videoFormat = videoFormat;
    }
    /**
     * Indicates if the talking avatar is customized.
     */ get customized() {
        return this.privCustomized;
    }
    /**
     * Sets if the talking avatar is customized.
     */ set customized(value) {
        this.privCustomized = value;
    }
    /**
     * Sets the background color.
     */ get backgroundColor() {
        return this.privBackgroundColor;
    }
    /**
     * Gets the background color.
     */ set backgroundColor(value) {
        this.privBackgroundColor = value;
    }
}
module.exports.AvatarConfig = $86d755d075278a6b$var$AvatarConfig;

});

parcelRegister("4dbGQ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarEventArgs = module.exports.AvatarEventTypes = void 0;
var $311171b892029e47$var$AvatarEventTypes;
(function(AvatarEventTypes) {
    AvatarEventTypes["SwitchedToSpeaking"] = "SwitchedToSpeaking";
    AvatarEventTypes["SwitchedToIdle"] = "SwitchedToIdle";
    AvatarEventTypes["SessionClosed"] = "SessionClosed";
})($311171b892029e47$var$AvatarEventTypes = module.exports.AvatarEventTypes || (module.exports.AvatarEventTypes = {}));
/**
 * Defines content for talking avatar events.
 * @class AvatarEventArgs
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change or have limited support.
 */ class $311171b892029e47$var$AvatarEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} description - The description of the event.
     */ constructor(audioOffset, description){
        this.privOffset = audioOffset;
        this.privDescription = description;
    }
    /**
     * The type of the event.
     * @public
     * @returns {AvatarEventTypes} The type of the event.
     */ get type() {
        return this.privType;
    }
    /**
     * The time offset associated with this event.
     * @public
     * @returns {number} The time offset associated with this event.
     */ get offset() {
        return this.privOffset;
    }
    /**
     * The description of the event.
     * @public
     * @returns {string} The description of the event.
     */ get description() {
        return this.privDescription;
    }
}
module.exports.AvatarEventArgs = $311171b892029e47$var$AvatarEventArgs;

});

parcelRegister("1zhvp", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarSynthesizer = void 0;

var $fsTEg = parcelRequire("fsTEg");

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $iZxsX = parcelRequire("iZxsX");

var $hVlip = parcelRequire("hVlip");

var $56OOs = parcelRequire("56OOs");

var $gOb2m = parcelRequire("gOb2m");
/**
 * Defines the avatar synthesizer.
 * @class AvatarSynthesizer
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change or have limited support.
 */ class $1246a3965ce882d8$var$AvatarSynthesizer extends $hVlip.Synthesizer {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechConfig} speechConfig - The speech config.
     * @param {AvatarConfig} avatarConfig - The talking avatar config.
     */ constructor(speechConfig, avatarConfig){
        super(speechConfig);
        $56OOs.Contracts.throwIfNullOrUndefined(avatarConfig, "avatarConfig");
        this.privConnectionFactory = new $fsTEg.SpeechSynthesisConnectionFactory();
        this.privAvatarConfig = avatarConfig;
        this.implCommonSynthesizeSetup();
    }
    implCommonSynthesizeSetup() {
        super.implCommonSynthesizeSetup();
        // The service checks the audio format setting while it ignores it in avatar synthesis.
        this.privAdapter.audioOutputFormat = $iZxsX.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat($hVlip.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm);
    }
    /**
     * Starts the talking avatar session and establishes the WebRTC connection.
     * @member AvatarSynthesizer.prototype.startAvatarAsync
     * @function
     * @public
     * @param {AvatarWebRTCConnectionInfo} peerConnection - The peer connection.
     * @returns {Promise<SynthesisResult>} The promise of the connection result.
     */ async startAvatarAsync(peerConnection) {
        $56OOs.Contracts.throwIfNullOrUndefined(peerConnection, "peerConnection");
        this.privIceServers = peerConnection.getConfiguration().iceServers;
        $56OOs.Contracts.throwIfNullOrUndefined(this.privIceServers, "Ice servers must be set.");
        const iceGatheringDone = new $3wpON.Deferred();
        // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/icegatheringstatechange_event
        peerConnection.onicegatheringstatechange = ()=>{
            $3wpON.Events.instance.onEvent(new $3wpON.PlatformEvent("peer connection: ice gathering state: " + peerConnection.iceGatheringState, $3wpON.EventType.Debug));
            if (peerConnection.iceGatheringState === "complete") {
                $3wpON.Events.instance.onEvent(new $3wpON.PlatformEvent("peer connection: ice gathering complete.", $3wpON.EventType.Info));
                iceGatheringDone.resolve();
            }
        };
        peerConnection.onicecandidate = (event)=>{
            if (event.candidate) $3wpON.Events.instance.onEvent(new $3wpON.PlatformEvent("peer connection: ice candidate: " + event.candidate.candidate, $3wpON.EventType.Debug));
            else {
                $3wpON.Events.instance.onEvent(new $3wpON.PlatformEvent("peer connection: ice candidate: complete", $3wpON.EventType.Debug));
                iceGatheringDone.resolve();
            }
        };
        // Set a timeout for ice gathering, currently 2 seconds.
        setTimeout(()=>{
            if (peerConnection.iceGatheringState !== "complete") {
                $3wpON.Events.instance.onEvent(new $3wpON.PlatformEvent("peer connection: ice gathering timeout.", $3wpON.EventType.Warning));
                iceGatheringDone.resolve();
            }
        }, 2000);
        const sdp = await peerConnection.createOffer();
        await peerConnection.setLocalDescription(sdp);
        await iceGatheringDone.promise;
        $3wpON.Events.instance.onEvent(new $3wpON.PlatformEvent("peer connection: got local SDP.", $3wpON.EventType.Info));
        this.privProperties.setProperty($hVlip.PropertyId.TalkingAvatarService_WebRTC_SDP, JSON.stringify(peerConnection.localDescription));
        const result = await this.speak("", false);
        if (result.reason !== $hVlip.ResultReason.SynthesizingAudioCompleted) return new $hVlip.SynthesisResult(result.resultId, result.reason, result.errorDetails, result.properties);
        const sdpAnswerString = atob(result.properties.getProperty($hVlip.PropertyId.TalkingAvatarService_WebRTC_SDP));
        const sdpAnswer = new RTCSessionDescription(JSON.parse(sdpAnswerString));
        await peerConnection.setRemoteDescription(sdpAnswer);
        return new $hVlip.SynthesisResult(result.resultId, result.reason, undefined, result.properties);
    }
    /**
     * Speaks plain text asynchronously. The rendered audio and video will be sent via the WebRTC connection.
     * @member AvatarSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param {string} text - The plain text to speak.
     * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
     */ async speakTextAsync(text) {
        const r = await this.speak(text, false);
        return new $hVlip.SynthesisResult(r.resultId, r.reason, r.errorDetails, r.properties);
    }
    /**
     * Speaks SSML asynchronously. The rendered audio and video will be sent via the WebRTC connection.
     * @member AvatarSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param {string} ssml - The SSML text to speak.
     * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
     */ async speakSsmlAsync(ssml) {
        const r = await this.speak(ssml, true);
        return new $hVlip.SynthesisResult(r.resultId, r.reason, r.errorDetails, r.properties);
    }
    /**
     * Speaks text asynchronously. The avatar will switch to idle state.
     * @member AvatarSynthesizer.prototype.stopSpeakingAsync
     * @function
     * @public
     * @returns {Promise<void>} The promise of the void result.
     */ async stopSpeakingAsync() {
        while(this.synthesisRequestQueue.length() > 0){
            const request = await this.synthesisRequestQueue.dequeue();
            request.err("Synthesis is canceled by user.");
        }
        return this.privAdapter.stopSpeaking();
    }
    /**
     * Stops the talking avatar session and closes the WebRTC connection.
     * For now, this is the same as close().
     * You need to create a new AvatarSynthesizer instance to start a new session.
     * @member AvatarSynthesizer.prototype.stopAvatarAsync
     * @function
     * @public
     * @returns {Promise<void>} The promise of the void result.
     */ async stopAvatarAsync() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposed);
        return this.dispose(true);
    }
    /**
     * Dispose of associated resources.
     * @member AvatarSynthesizer.prototype.close
     * @function
     * @public
     */ async close() {
        if (this.privDisposed) return;
        return this.dispose(true);
    }
    /**
     * Gets the ICE servers. Internal use only.
     */ get iceServers() {
        return this.privIceServers;
    }
    // Creates the synthesis adapter
    createSynthesisAdapter(authentication, connectionFactory, synthesizerConfig) {
        return new $imJeu.AvatarSynthesisAdapter(authentication, connectionFactory, synthesizerConfig, this, this.privAvatarConfig);
    }
    createRestSynthesisAdapter(_authentication, _synthesizerConfig) {
        return undefined;
    }
    createSynthesizerConfig(speechConfig) {
        const config = super.createSynthesizerConfig(speechConfig);
        config.avatarEnabled = true;
        return config;
    }
    async speak(text, isSSML) {
        const requestId = $3wpON.createNoDashGuid();
        const deferredResult = new $3wpON.Deferred();
        this.synthesisRequestQueue.enqueue(new $gOb2m.SynthesisRequest(requestId, text, isSSML, (e)=>{
            deferredResult.resolve(e);
            this.privSynthesizing = false;
            this.adapterSpeak();
        }, (e)=>{
            deferredResult.reject(e);
            this.privSynthesizing = false;
        }));
        this.adapterSpeak();
        return deferredResult.promise;
    }
}
module.exports.AvatarSynthesizer = $1246a3965ce882d8$var$AvatarSynthesizer;

});
parcelRegister("fsTEg", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $hVlip = parcelRequire("hVlip");

var $lAVhN = parcelRequire("lAVhN");

var $imJeu = parcelRequire("imJeu");

var $bPVwM = parcelRequire("bPVwM");

var $luvuO = parcelRequire("luvuO");
class $b424a32d4c3ea7e6$var$SpeechSynthesisConnectionFactory {
    constructor(){
        this.synthesisUri = "/cognitiveservices/websocket/v1";
    }
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region, undefined);
        const hostSuffix = $lAVhN.ConnectionFactoryBase.getHostSuffix(region);
        const endpointId = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const hostPrefix = endpointId === undefined ? "tts" : "voice";
        const host = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, "wss://" + region + "." + hostPrefix + ".speech" + hostSuffix);
        const queryParams = {};
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$bPVwM.HeaderNames.ConnectionId] = connectionId;
        if (endpointId !== undefined && endpointId !== "") {
            if (!endpoint || endpoint.search($luvuO.QueryParameterNames.CustomVoiceDeploymentId) === -1) queryParams[$luvuO.QueryParameterNames.CustomVoiceDeploymentId] = endpointId;
        }
        if (config.avatarEnabled) {
            if (!endpoint || endpoint.search($luvuO.QueryParameterNames.EnableAvatar) === -1) queryParams[$luvuO.QueryParameterNames.EnableAvatar] = "true";
        }
        if (!endpoint) endpoint = host + this.synthesisUri;
        config.parameters.setProperty($hVlip.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $gvLMV.WebsocketConnection(endpoint, queryParams, headers, new $imJeu.WebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromParameters(config.parameters), enableCompression, connectionId);
    }
}
module.exports.SpeechSynthesisConnectionFactory = $b424a32d4c3ea7e6$var$SpeechSynthesisConnectionFactory;

});


parcelRegister("6winM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarVideoFormat = module.exports.Coordinate = void 0;
/* eslint-disable max-classes-per-file */ /**
 * Defines a coordinate in 2D space.
 * @class Coordinate
 * Added in version 1.33.0
 */ class $4bf3fd9ccb32efc5$var$Coordinate {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
}
module.exports.Coordinate = $4bf3fd9ccb32efc5$var$Coordinate;
/**
 * Defines the avatar output video format.
 * @class AvatarVideoFormat
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change in the future.
 */ class $4bf3fd9ccb32efc5$var$AvatarVideoFormat {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} codec - The video codec.
     * @param {number} bitrate - The video bitrate.
     * @param {number} width - The video width.
     * @param {number} height - The video height.
     */ constructor(codec = "H264", bitrate = 2000000, width = 1920, height = 1080){
        this.codec = codec;
        this.bitrate = bitrate;
        this.width = width;
        this.height = height;
    }
    /**
     * Sets the video crop range.
     */ setCropRange(topLeft, bottomRight) {
        this.cropRange = {
            bottomRight: bottomRight,
            topLeft: topLeft
        };
    }
}
module.exports.AvatarVideoFormat = $4bf3fd9ccb32efc5$var$AvatarVideoFormat;

});

parcelRegister("cUVMM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarWebRTCConnectionResult = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Defines the avatar WebRTC connection result.
 * @class AvatarWebRTCConnectionResult
 * Added in version 1.33.0
 *
 * @experimental This feature is experimental and might change in the future.
 */ class $96778a0b0fa7263a$var$AvatarWebRTCConnectionResult extends $hVlip.SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {RTCSessionDescriptionInit} SDPAnswer - The SDP answer of WebRTC connection.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */ constructor(SDPAnswer, resultId, reason, errorDetails, properties){
        super(resultId, reason, errorDetails, properties);
        this.privSDPAnswer = SDPAnswer;
    }
    /**
     * Specifies SDP (Session Description Protocol) answer of WebRTC connection.
     * @member AvatarWebRTCConnectionResult.prototype.SDPAnswer
     * @function
     * @public
     * @returns {RTCSessionDescriptionInit} Specifies the SDP answer of WebRTC connection.
     */ get SDPAnswer() {
        return this.privSDPAnswer;
    }
}
module.exports.AvatarWebRTCConnectionResult = $96778a0b0fa7263a$var$AvatarWebRTCConnectionResult;

});

parcelRegister("lfuQq", function(module, exports) {
"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $3wpON = parcelRequire("3wpON");
/**
 * Defines diagnostics API for managing console output
 * Added in version 1.21.0
 */ class $f782eccc5af1bf8e$var$Diagnostics {
    static SetLoggingLevel(logLevel) {
        this.privListener = new $gvLMV.ConsoleLoggingListener(logLevel);
        $3wpON.Events.instance.attachConsoleListener(this.privListener);
    }
    static StartConsoleOutput() {
        if (!!this.privListener) this.privListener.enableConsoleOutput = true;
    }
    static StopConsoleOutput() {
        if (!!this.privListener) this.privListener.enableConsoleOutput = false;
    }
    static SetLogOutputPath(path) {
        if (typeof window === "undefined") {
            if (!!this.privListener) this.privListener.logPath = path;
        } else throw new Error("File system logging not available in browser.");
    }
    static set onLogOutput(callback) {
        if (!!this.privListener) this.privListener.logCallback = callback;
    }
}
module.exports.Diagnostics = $f782eccc5af1bf8e$var$Diagnostics;
$f782eccc5af1bf8e$var$Diagnostics.privListener = undefined;

});



parcelRegister("5RXpn", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionEndedEvent = module.exports.RecognitionCompletionStatus = module.exports.RecognitionStartedEvent = module.exports.ConnectingToServiceEvent = module.exports.ListeningStartedEvent = module.exports.RecognitionTriggeredEvent = module.exports.SpeechRecognitionEvent = void 0;

var $3wpON = parcelRequire("3wpON");
class $445ffc40588b8143$var$SpeechRecognitionEvent extends $3wpON.PlatformEvent {
    constructor(eventName, requestId, sessionId, eventType = $3wpON.EventType.Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
        this.privSessionId = sessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
module.exports.SpeechRecognitionEvent = $445ffc40588b8143$var$SpeechRecognitionEvent;
class $445ffc40588b8143$var$RecognitionTriggeredEvent extends $445ffc40588b8143$var$SpeechRecognitionEvent {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("RecognitionTriggeredEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
module.exports.RecognitionTriggeredEvent = $445ffc40588b8143$var$RecognitionTriggeredEvent;
class $445ffc40588b8143$var$ListeningStartedEvent extends $445ffc40588b8143$var$SpeechRecognitionEvent {
    constructor(requestId, sessionId, audioSourceId, audioNodeId){
        super("ListeningStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
}
module.exports.ListeningStartedEvent = $445ffc40588b8143$var$ListeningStartedEvent;
class $445ffc40588b8143$var$ConnectingToServiceEvent extends $445ffc40588b8143$var$SpeechRecognitionEvent {
    constructor(requestId, authFetchEventid, sessionId){
        super("ConnectingToServiceEvent", requestId, sessionId);
        this.privAuthFetchEventid = authFetchEventid;
    }
    get authFetchEventid() {
        return this.privAuthFetchEventid;
    }
}
module.exports.ConnectingToServiceEvent = $445ffc40588b8143$var$ConnectingToServiceEvent;
class $445ffc40588b8143$var$RecognitionStartedEvent extends $445ffc40588b8143$var$SpeechRecognitionEvent {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId){
        super("RecognitionStartedEvent", requestId, sessionId);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
module.exports.RecognitionStartedEvent = $445ffc40588b8143$var$RecognitionStartedEvent;
var $445ffc40588b8143$var$RecognitionCompletionStatus;
(function(RecognitionCompletionStatus) {
    RecognitionCompletionStatus[RecognitionCompletionStatus["Success"] = 0] = "Success";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceError"] = 1] = "AudioSourceError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceTimeout"] = 2] = "AudioSourceTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchError"] = 3] = "AuthTokenFetchError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchTimeout"] = 4] = "AuthTokenFetchTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnAuthorized"] = 5] = "UnAuthorized";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectTimeout"] = 6] = "ConnectTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectError"] = 7] = "ConnectError";
    RecognitionCompletionStatus[RecognitionCompletionStatus["ClientRecognitionActivityTimeout"] = 8] = "ClientRecognitionActivityTimeout";
    RecognitionCompletionStatus[RecognitionCompletionStatus["UnknownError"] = 9] = "UnknownError";
})($445ffc40588b8143$var$RecognitionCompletionStatus = module.exports.RecognitionCompletionStatus || (module.exports.RecognitionCompletionStatus = {}));
class $445ffc40588b8143$var$RecognitionEndedEvent extends $445ffc40588b8143$var$SpeechRecognitionEvent {
    constructor(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId, serviceTag, status, error){
        super("RecognitionEndedEvent", requestId, sessionId, status === $445ffc40588b8143$var$RecognitionCompletionStatus.Success ? $3wpON.EventType.Info : $3wpON.EventType.Error);
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privAuthFetchEventId = authFetchEventId;
        this.privStatus = status;
        this.privError = error;
        this.privServiceTag = serviceTag;
    }
    get audioSourceId() {
        return this.privAudioSourceId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
    get serviceTag() {
        return this.privServiceTag;
    }
    get status() {
        return this.privStatus;
    }
    get error() {
        return this.privError;
    }
}
module.exports.RecognitionEndedEvent = $445ffc40588b8143$var$RecognitionEndedEvent;

});

parcelRegister("es4No", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceRecognizerBase = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $3wpON = parcelRequire("3wpON");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");

var $l6AmD = parcelRequire("l6AmD");
class $a8576686b1d1b6e2$var$ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        // A promise for a connection, but one that has not had the speech context sent yet.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionPromise = undefined;
        this.privSetTimeout = setTimeout;
        this.privIsLiveAudio = false;
        this.privAverageBytesPerMs = 0;
        this.privEnableSpeakerId = false;
        this.privExpectContentAssessmentResponse = false;
        this.recognizeOverride = undefined;
        this.recognizeSpeaker = undefined;
        this.disconnectOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.sendPrePayloadJSONOverride = undefined;
        this.postConnectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        this.handleSpeechPhraseMessage = undefined;
        this.handleSpeechHypothesisMessage = undefined;
        if (!authentication) throw new $3wpON.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $3wpON.ArgumentNullError("connectionFactory");
        if (!audioSource) throw new $3wpON.ArgumentNullError("audioSource");
        if (!recognizerConfig) throw new $3wpON.ArgumentNullError("recognizerConfig");
        this.privEnableSpeakerId = recognizerConfig.isSpeakerDiarizationEnabled;
        this.privMustReportEndOfStream = false;
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privAudioSource = audioSource;
        this.privRecognizerConfig = recognizerConfig;
        this.privIsDisposed = false;
        this.privRecognizer = recognizer;
        this.privRequestSession = new $imJeu.RequestSession(this.privAudioSource.id());
        this.privConnectionEvents = new $3wpON.EventSource();
        this.privServiceEvents = new $3wpON.EventSource();
        this.privDynamicGrammar = new $imJeu.DynamicGrammarBuilder();
        this.privSpeechContext = new $imJeu.SpeechContext(this.privDynamicGrammar);
        this.privAgentConfig = new $imJeu.AgentConfig();
        const webWorkerLoadType = this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.WebWorkerLoadType, "on").toLowerCase();
        if (webWorkerLoadType === "on" && typeof Blob !== "undefined" && typeof Worker !== "undefined") this.privSetTimeout = $3wpON.Timeout.setTimeout;
        else if (typeof window !== "undefined") // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.privSetTimeout = window.setTimeout.bind(window);
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode === 1003 || connectionClosedEvent.statusCode === 1007 || connectionClosedEvent.statusCode === 1002 || connectionClosedEvent.statusCode === 4000 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) this.cancelRecognitionLocal($hVlip.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $hVlip.CancellationErrorCode.BadRequestParameters : $hVlip.CancellationErrorCode.ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
        if (this.privEnableSpeakerId) this.privDiarizationSessionId = $3wpON.createNoDashGuid();
        this.setLanguageIdJson();
        this.setOutputDetailLevelJson();
    }
    setTranslationJson() {
        const targetLanguages = this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined);
        if (targetLanguages !== undefined) {
            const languages = targetLanguages.split(",");
            const translationVoice = this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
            const action = translationVoice !== undefined ? "Synthesize" : "None";
            this.privSpeechContext.setSection("translation", {
                onSuccess: {
                    action: action
                },
                output: {
                    interimResults: {
                        mode: "Always"
                    }
                },
                targetLanguages: languages
            });
            if (translationVoice !== undefined) {
                const languageToVoiceMap = {};
                for (const lang of languages)languageToVoiceMap[lang] = translationVoice;
                this.privSpeechContext.setSection("synthesis", {
                    defaultVoices: languageToVoiceMap
                });
            }
        }
    }
    setSpeechSegmentationTimeoutJson() {
        const speechSegmentationTimeout = this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.Speech_SegmentationSilenceTimeoutMs, undefined);
        if (speechSegmentationTimeout !== undefined) {
            const mode = this.recognitionMode === $imJeu.RecognitionMode.Conversation ? "CONVERSATION" : this.recognitionMode === $imJeu.RecognitionMode.Dictation ? "DICTATION" : "INTERACTIVE";
            const segmentationSilenceTimeoutMs = parseInt(speechSegmentationTimeout, 10);
            const phraseDetection = this.privSpeechContext.getSection("phraseDetection");
            phraseDetection.mode = mode;
            phraseDetection[mode] = {
                segmentation: {
                    mode: "Custom",
                    segmentationSilenceTimeoutMs: segmentationSilenceTimeoutMs
                }
            };
            this.privSpeechContext.setSection("phraseDetection", phraseDetection);
        }
    }
    setLanguageIdJson() {
        const phraseDetection = this.privSpeechContext.getSection("phraseDetection");
        if (this.privRecognizerConfig.autoDetectSourceLanguages !== undefined) {
            const sourceLanguages = this.privRecognizerConfig.autoDetectSourceLanguages.split(",");
            let speechContextLidMode;
            if (this.privRecognizerConfig.languageIdMode === "Continuous") speechContextLidMode = "DetectContinuous";
            else speechContextLidMode = "DetectAtAudioStart";
            this.privSpeechContext.setSection("languageId", {
                Priority: "PrioritizeLatency",
                languages: sourceLanguages,
                mode: speechContextLidMode,
                onSuccess: {
                    action: "Recognize"
                },
                onUnknown: {
                    action: "None"
                }
            });
            this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "Auto"
                },
                phraseResults: {
                    resultType: "Always"
                }
            });
            const customModels = this.privRecognizerConfig.sourceLanguageModels;
            if (customModels !== undefined) {
                phraseDetection.customModels = customModels;
                phraseDetection.onInterim = {
                    action: "None"
                };
                phraseDetection.onSuccess = {
                    action: "None"
                };
            }
        }
        const targetLanguages = this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages, undefined);
        if (targetLanguages !== undefined) {
            phraseDetection.onInterim = {
                action: "Translate"
            };
            phraseDetection.onSuccess = {
                action: "Translate"
            };
            this.privSpeechContext.setSection("phraseOutput", {
                interimResults: {
                    resultType: "None"
                },
                phraseResults: {
                    resultType: "None"
                }
            });
        }
        this.privSpeechContext.setSection("phraseDetection", phraseDetection);
    }
    setOutputDetailLevelJson() {
        if (this.privEnableSpeakerId) {
            const requestWordLevelTimestamps = this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase();
            if (requestWordLevelTimestamps === "true") this.privSpeechContext.setWordLevelTimings();
            else {
                const outputFormat = this.privRecognizerConfig.parameters.getProperty($imJeu.OutputFormatPropertyName, $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]).toLowerCase();
                if (outputFormat === $hVlip.OutputFormat[$hVlip.OutputFormat.Detailed].toLocaleLowerCase()) this.privSpeechContext.setDetailedOutputFormat();
            }
        }
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    get audioSource() {
        return this.privAudioSource;
    }
    get speechContext() {
        return this.privSpeechContext;
    }
    get dynamicGrammar() {
        return this.privDynamicGrammar;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    set conversationTranslatorToken(token) {
        this.privRecognizerConfig.parameters.setProperty($hVlip.PropertyId.ConversationTranslator_Token, token);
    }
    set voiceProfileType(type) {
        this.privRecognizerConfig.parameters.setProperty($hVlip.PropertyId.SpeechServiceConnection_SpeakerIdMode, type);
    }
    set authentication(auth) {
        this.privAuthentication = auth;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    async dispose(reason) {
        this.privIsDisposed = true;
        if (this.privConnectionConfigurationPromise !== undefined) try {
            const connection = await this.privConnectionConfigurationPromise;
            await connection.dispose(reason);
        } catch (error) {
            // The connection is in a bad state. But we're trying to kill it, so...
            return;
        }
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    get recognitionMode() {
        return this.privRecognizerConfig.recognitionMode;
    }
    async recognize(recoMode, successCallback, errorCallBack) {
        if (this.recognizeOverride !== undefined) {
            await this.recognizeOverride(recoMode, successCallback, errorCallBack);
            return;
        }
        // Clear the existing configuration promise to force a re-transmission of config and context.
        this.privConnectionConfigurationPromise = undefined;
        this.privRecognizerConfig.recognitionMode = recoMode;
        this.setSpeechSegmentationTimeoutJson();
        this.setTranslationJson();
        this.privSuccessCallback = successCallback;
        this.privErrorCallback = errorCallBack;
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        let audioNode;
        try {
            const audioStreamNode = await this.audioSource.attach(this.privRequestSession.audioNodeId);
            const format = await this.audioSource.format;
            const deviceInfo = await this.audioSource.deviceInfo;
            this.privIsLiveAudio = deviceInfo.type && deviceInfo.type === $imJeu.type.Microphones;
            audioNode = new $gvLMV.ReplayableAudioNode(audioStreamNode, format.avgBytesPerSec);
            await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
            this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
                source: deviceInfo
            };
        } catch (error) {
            await this.privRequestSession.onStopRecognizing();
            throw error;
        }
        try {
            await conPromise;
        } catch (error) {
            await this.cancelRecognitionLocal($hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.ConnectionFailure, error);
            return;
        }
        const sessionStartEventArgs = new $hVlip.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        this.receiveMessage();
        const audioSendPromise = this.sendAudio(audioNode);
        audioSendPromise.catch(async (error)=>{
            await this.cancelRecognitionLocal($hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.RuntimeError, error);
        });
        return;
    }
    async stopRecognizing() {
        if (this.privRequestSession.isRecognizing) try {
            await this.audioSource.turnOff();
            await this.sendFinalAudio();
            await this.privRequestSession.onStopRecognizing();
            await this.privRequestSession.turnCompletionPromise;
        } finally{
            await this.privRequestSession.dispose();
        }
        return;
    }
    async connect() {
        await this.connectImpl();
        return Promise.resolve();
    }
    connectAsync(cb, err) {
        this.connectImpl().then(()=>{
            try {
                if (!!cb) cb();
            } catch (e) {
                if (!!err) err(e);
            }
        }, (reason)=>{
            try {
                if (!!err) err(reason);
            /* eslint-disable no-empty */ } catch (error) {}
        });
    }
    async disconnect() {
        await this.cancelRecognitionLocal($hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.NoError, "Disconnecting");
        if (this.disconnectOverride !== undefined) await this.disconnectOverride();
        if (this.privConnectionPromise !== undefined) try {
            await (await this.privConnectionPromise).dispose();
        } catch (error) {}
        this.privConnectionPromise = undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendMessage(message) {
        return;
    }
    async sendNetworkMessage(path, payload) {
        const type = typeof payload === "string" ? $3wpON.MessageType.Text : $3wpON.MessageType.Binary;
        const contentType = typeof payload === "string" ? "application/json" : "";
        const connection = await this.fetchConnection();
        return connection.send(new $l6AmD.SpeechConnectionMessage(type, path, this.privRequestSession.requestId, contentType, payload));
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set expectContentAssessmentResponse(value) {
        this.privExpectContentAssessmentResponse = value;
    }
    async sendTelemetryData() {
        const telemetryData = this.privRequestSession.getTelemetry();
        if ($a8576686b1d1b6e2$var$ServiceRecognizerBase.telemetryDataEnabled !== true || this.privIsDisposed || null === telemetryData) return;
        if (!!$a8576686b1d1b6e2$var$ServiceRecognizerBase.telemetryData) try {
            $a8576686b1d1b6e2$var$ServiceRecognizerBase.telemetryData(telemetryData);
        /* eslint-disable no-empty */ } catch  {}
        const connection = await this.fetchConnection();
        await connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "telemetry", this.privRequestSession.requestId, "application/json", telemetryData));
    }
    // Cancels recognition.
    async cancelRecognitionLocal(cancellationReason, errorCode, error) {
        if (!!this.privRequestSession.isRecognizing) {
            await this.privRequestSession.onStopRecognizing();
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, cancellationReason, errorCode, error);
        }
    }
    async receiveMessage() {
        try {
            if (this.privIsDisposed) // We're done.
            return;
            let connection = await this.fetchConnection();
            const message = await connection.read();
            if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
            // indicates we are draining the queue and it came with no message;
            if (!message) return this.receiveMessage();
            this.privServiceHasSentMessage = true;
            const connectionMessage = $l6AmD.SpeechConnectionMessage.fromConnectionMessage(message);
            if (connectionMessage.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                case "turn.start":
                    this.privMustReportEndOfStream = true;
                    this.privRequestSession.onServiceTurnStartResponse();
                    break;
                case "speech.startdetected":
                    const speechStartDetected = $imJeu.SpeechDetected.fromJSON(connectionMessage.textBody);
                    const speechStartEventArgs = new $hVlip.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                    if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                    break;
                case "speech.enddetected":
                    let json;
                    if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                    else // If the request was empty, the JSON returned is empty.
                    json = "{ Offset: 0 }";
                    const speechStopDetected = $imJeu.SpeechDetected.fromJSON(json);
                    const speechStopEventArgs = new $hVlip.RecognitionEventArgs(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                    if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                    break;
                case "turn.end":
                    await this.sendTelemetryData();
                    if (this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream) {
                        this.privMustReportEndOfStream = false;
                        await this.cancelRecognitionLocal($hVlip.CancellationReason.EndOfStream, $hVlip.CancellationErrorCode.NoError, undefined);
                    }
                    const sessionStopEventArgs = new $hVlip.SessionEventArgs(this.privRequestSession.sessionId);
                    await this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition);
                    if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                        if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                        return;
                    } else {
                        connection = await this.fetchConnection();
                        await this.sendPrePayloadJSON(connection);
                    }
                    break;
                default:
                    if (!await this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                    {
                        if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $3wpON.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                    }
            }
            return this.receiveMessage();
        } catch (error) {
            return null;
        }
    }
    updateSpeakerDiarizationAudioOffset() {
        const bytesSent = this.privRequestSession.recognitionBytesSent;
        const audioOffsetMs = bytesSent / this.privAverageBytesPerMs;
        this.privSpeechContext.setSpeakerDiarizationAudioOffsetMs(audioOffsetMs);
    }
    sendSpeechContext(connection, generateNewRequestId) {
        if (this.privEnableSpeakerId) this.updateSpeakerDiarizationAudioOffset();
        const speechContextJson = this.speechContext.toJSON();
        if (generateNewRequestId) this.privRequestSession.onSpeechContext();
        if (speechContextJson) return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "speech.context", this.privRequestSession.requestId, "application/json", speechContextJson));
        return;
    }
    noOp() {
        // operation not supported
        return;
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    async sendPrePayloadJSON(connection, generateNewRequestId = true) {
        if (this.sendPrePayloadJSONOverride !== undefined) return this.sendPrePayloadJSONOverride(connection);
        await this.sendSpeechContext(connection, generateNewRequestId);
        await this.sendWaveHeader(connection);
        return;
    }
    async sendWaveHeader(connection) {
        const format = await this.audioSource.format;
        // this.writeBufferToConsole(format.header);
        return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", format.header));
    }
    // Establishes a websocket connection to the end point.
    connectImpl() {
        if (this.privConnectionPromise !== undefined) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === $3wpON.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = undefined;
            this.privServiceHasSentMessage = false;
            return this.connectImpl();
        });
        this.privConnectionPromise = this.retryableConnect();
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        if (this.postConnectImplOverride !== undefined) return this.postConnectImplOverride(this.privConnectionPromise);
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, requestSession, SpeechServiceConfigJson) {
        requestSession.onSpeechContext();
        // filter out anything that is not required for the service to work.
        if ($a8576686b1d1b6e2$var$ServiceRecognizerBase.telemetryDataEnabled !== true) {
            const withTelemetry = JSON.parse(SpeechServiceConfigJson);
            const replacement = {
                context: {
                    system: withTelemetry.context.system
                }
            };
            SpeechServiceConfigJson = JSON.stringify(replacement);
        }
        if (this.privRecognizerConfig.parameters.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() === "true") {
            const json = JSON.parse(SpeechServiceConfigJson);
            json.context.DisableReferenceChannel = "True";
            json.context.MicSpec = "1_0_0";
            SpeechServiceConfigJson = JSON.stringify(json);
        }
        if (SpeechServiceConfigJson) return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "speech.config", requestSession.requestId, "application/json", SpeechServiceConfigJson));
        return;
    }
    async fetchConnection() {
        if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
            if (connection.state() === $3wpON.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                this.privServiceHasSentMessage = false;
                return this.fetchConnection();
            }
            return this.privConnectionConfigurationPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionConfigurationPromise = undefined;
            this.privServiceHasSentMessage = false;
            return this.fetchConnection();
        });
        this.privConnectionConfigurationPromise = this.configureConnection();
        return await this.privConnectionConfigurationPromise;
    }
    async sendAudio(audioStreamNode) {
        const audioFormat = await this.audioSource.format;
        this.privAverageBytesPerMs = audioFormat.avgBytesPerSec / 1000;
        // The time we last sent data to the service.
        let nextSendTime = Date.now();
        // Max amount to send before we start to throttle
        const fastLaneSizeMs = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000");
        const maxSendUnthrottledBytes = audioFormat.avgBytesPerSec / 1000 * parseInt(fastLaneSizeMs, 10);
        const startRecogNumber = this.privRequestSession.recogNumber;
        const readAndUploadCycle = async ()=>{
            // If speech is done, stop sending audio.
            if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                const connection = await this.fetchConnection();
                const audioStreamChunk = await audioStreamNode.read();
                // we have a new audio chunk to upload.
                if (this.privRequestSession.isSpeechEnded) // If service already recognized audio end then don't send any more audio
                return;
                let payload;
                let sendDelay;
                if (!audioStreamChunk || audioStreamChunk.isEnd) {
                    payload = null;
                    sendDelay = 0;
                } else {
                    payload = audioStreamChunk.buffer;
                    this.privRequestSession.onAudioSent(payload.byteLength);
                    if (maxSendUnthrottledBytes >= this.privRequestSession.bytesSent) sendDelay = 0;
                    else sendDelay = Math.max(0, nextSendTime - Date.now());
                }
                if (0 !== sendDelay) await this.delay(sendDelay);
                if (payload !== null) nextSendTime = Date.now() + payload.byteLength * 1000 / (audioFormat.avgBytesPerSec * 2);
                // Are we still alive?
                if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === startRecogNumber) {
                    connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Binary, "audio", this.privRequestSession.requestId, null, payload)).catch(()=>{
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(()=>{});
                    });
                    if (!audioStreamChunk?.isEnd) // this.writeBufferToConsole(payload);
                    // Regardless of success or failure, schedule the next upload.
                    // If the underlying connection was broken, the next cycle will
                    // get a new connection and re-transmit missing audio automatically.
                    return readAndUploadCycle();
                    else // the audio stream has been closed, no need to schedule next
                    // read-upload cycle.
                    if (!this.privIsLiveAudio) this.privRequestSession.onSpeechEnded();
                }
            }
        };
        return readAndUploadCycle();
    }
    async retryableConnect() {
        let isUnAuthorized = false;
        this.privAuthFetchEventId = $3wpON.createNoDashGuid();
        const sessionId = this.privRequestSession.sessionId;
        this.privConnectionId = sessionId !== undefined ? sessionId : $3wpON.createNoDashGuid();
        this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
        let lastStatusCode = 0;
        let lastReason = "";
        while(this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount){
            // Get the auth information for the connection. This is a bit of overkill for the current API surface, but leaving the plumbing in place to be able to raise a developer-customer
            // facing event when a connection fails to let them try and provide new auth information.
            const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
            const auth = await authPromise;
            await this.privRequestSession.onAuthCompleted(false);
            // Create the connection
            const connection = this.privConnectionFactory.create(this.privRecognizerConfig, auth, this.privConnectionId);
            // Attach the telemetry handlers.
            this.privRequestSession.listenForServiceTelemetry(connection.events);
            // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
            // it'll stop sending events.
            connection.events.attach((event)=>{
                this.connectionEvents.onEvent(event);
            });
            const response = await connection.open();
            // 200 == everything is fine.
            if (response.statusCode === 200) {
                await this.privRequestSession.onConnectionEstablishCompleted(response.statusCode);
                return Promise.resolve(connection);
            } else if (response.statusCode === 1006) isUnAuthorized = true;
            lastStatusCode = response.statusCode;
            lastReason = response.reason;
            this.privRequestSession.onRetryConnection();
        }
        await this.privRequestSession.onConnectionEstablishCompleted(lastStatusCode, lastReason);
        return Promise.reject(`Unable to contact server. StatusCode: ${lastStatusCode}, ${this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint)} Reason: ${lastReason}`);
    }
    delay(delayMs) {
        return new Promise((resolve)=>this.privSetTimeout(resolve, delayMs));
    }
    writeBufferToConsole(buffer) {
        let out = "Buffer Size: ";
        if (null === buffer) out += "null";
        else {
            const readView = new Uint8Array(buffer);
            out += `${buffer.byteLength}\r\n`;
            for(let i = 0; i < buffer.byteLength; i++){
                out += readView[i].toString(16).padStart(2, "0") + " ";
                if ((i + 1) % 16 === 0) {
                    // eslint-disable-next-line no-console
                    console.info(out);
                    out = "";
                }
            }
        }
        // eslint-disable-next-line no-console
        console.info(out);
    }
    async sendFinalAudio() {
        const connection = await this.fetchConnection();
        await connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Binary, "audio", this.privRequestSession.requestId, null, null));
        return;
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configureConnection() {
        const connection = await this.connectImpl();
        if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
        await this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
        await this.sendPrePayloadJSON(connection, false);
        return connection;
    }
}
module.exports.ServiceRecognizerBase = $a8576686b1d1b6e2$var$ServiceRecognizerBase;
$a8576686b1d1b6e2$var$ServiceRecognizerBase.telemetryDataEnabled = true;

});
parcelRegister("l6AmD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionMessage = void 0;

var $3wpON = parcelRequire("3wpON");

var $bPVwM = parcelRequire("bPVwM");
class $f5d65da9e6d936b1$var$SpeechConnectionMessage extends $3wpON.ConnectionMessage {
    constructor(messageType, path, requestId, contentType, body, streamId, additionalHeaders, id){
        if (!path) throw new $3wpON.ArgumentNullError("path");
        if (!requestId) throw new $3wpON.ArgumentNullError("requestId");
        const headers = {};
        headers[$bPVwM.HeaderNames.Path] = path;
        headers[$bPVwM.HeaderNames.RequestId] = requestId;
        headers[$bPVwM.HeaderNames.RequestTimestamp] = new Date().toISOString();
        if (contentType) headers[$bPVwM.HeaderNames.ContentType] = contentType;
        if (streamId) headers[$bPVwM.HeaderNames.RequestStreamId] = streamId;
        if (additionalHeaders) {
            for(const headerName in additionalHeaders)if (headerName) headers[headerName] = additionalHeaders[headerName];
        }
        if (id) super(messageType, body, headers, id);
        else super(messageType, body, headers);
        this.privPath = path;
        this.privRequestId = requestId;
        this.privContentType = contentType;
        this.privStreamId = streamId;
        this.privAdditionalHeaders = additionalHeaders;
    }
    get path() {
        return this.privPath;
    }
    get requestId() {
        return this.privRequestId;
    }
    get contentType() {
        return this.privContentType;
    }
    get streamId() {
        return this.privStreamId;
    }
    get additionalHeaders() {
        return this.privAdditionalHeaders;
    }
    static fromConnectionMessage(message) {
        let path = null;
        let requestId = null;
        let contentType = null;
        // let requestTimestamp = null;
        let streamId = null;
        const additionalHeaders = {};
        if (message.headers) {
            for(const headerName in message.headers)if (headerName) {
                if (headerName.toLowerCase() === $bPVwM.HeaderNames.Path.toLowerCase()) path = message.headers[headerName];
                else if (headerName.toLowerCase() === $bPVwM.HeaderNames.RequestId.toLowerCase()) requestId = message.headers[headerName];
                else if (headerName.toLowerCase() === $bPVwM.HeaderNames.ContentType.toLowerCase()) contentType = message.headers[headerName];
                else if (headerName.toLowerCase() === $bPVwM.HeaderNames.RequestStreamId.toLowerCase()) streamId = message.headers[headerName];
                else additionalHeaders[headerName] = message.headers[headerName];
            }
        }
        return new $f5d65da9e6d936b1$var$SpeechConnectionMessage(message.messageType, path, requestId, contentType, message.body, streamId, additionalHeaders, message.id);
    }
}
module.exports.SpeechConnectionMessage = $f5d65da9e6d936b1$var$SpeechConnectionMessage;

});


parcelRegister("bNvq2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationServiceRecognizer = void 0;

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
class $896ca477924a147c$var$ConversationServiceRecognizer extends $imJeu.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.handleSpeechPhraseMessage = async (textBody)=>this.handleSpeechPhrase(textBody);
        this.handleSpeechHypothesisMessage = (textBody)=>this.handleSpeechHypothesis(textBody);
    }
    processTypeSpecificMessages(connectionMessage) {
        return;
    }
    handleRecognizedCallback(result, offset, sessionId) {
        return;
    }
    handleRecognizingCallback(result, duration, sessionId) {
        return;
    }
    async processSpeechMessages(connectionMessage) {
        let processed = false;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
            case "speech.fragment":
                if (!!this.handleSpeechHypothesisMessage) this.handleSpeechHypothesisMessage(connectionMessage.textBody);
                processed = true;
                break;
            case "speech.phrase":
                if (!!this.handleSpeechPhraseMessage) await this.handleSpeechPhraseMessage(connectionMessage.textBody);
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {}
    async handleSpeechPhrase(textBody) {
        const simple = $imJeu.SimpleSpeechPhrase.fromJSON(textBody);
        const resultReason = $imJeu.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
        let result;
        const resultProps = new $hVlip.PropertyCollection();
        resultProps.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, textBody);
        const simpleOffset = simple.Offset + this.privRequestSession.currentTurnAudioOffset;
        let offset = simpleOffset;
        this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
        if ($hVlip.ResultReason.Canceled === resultReason) {
            const cancelReason = $imJeu.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
            const cancellationErrorCode = $imJeu.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
            await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $imJeu.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
        } else if (!(this.privRequestSession.isSpeechEnded && resultReason === $hVlip.ResultReason.NoMatch && simple.RecognitionStatus !== $imJeu.RecognitionStatus.InitialSilenceTimeout)) {
            if (this.privRecognizerConfig.parameters.getProperty($imJeu.OutputFormatPropertyName) === $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]) result = new $hVlip.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simpleOffset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, textBody, resultProps);
            else {
                const detailed = $imJeu.DetailedSpeechPhrase.fromJSON(textBody);
                const totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                const offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                result = new $hVlip.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.Text, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, detailed.SpeakerId, undefined, offsetCorrectedJson, resultProps);
                offset = result.offset;
            }
            this.handleRecognizedCallback(result, offset, this.privRequestSession.sessionId);
        }
    }
    handleSpeechHypothesis(textBody) {
        const hypothesis = $imJeu.SpeechHypothesis.fromJSON(textBody);
        const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
        const resultProps = new $hVlip.PropertyCollection();
        resultProps.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, textBody);
        const result = new $hVlip.SpeechRecognitionResult(this.privRequestSession.requestId, $hVlip.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, hypothesis.SpeakerId, undefined, textBody, resultProps);
        this.privRequestSession.onHypothesis(offset);
        this.handleRecognizingCallback(result, hypothesis.Duration, this.privRequestSession.sessionId);
    }
}
module.exports.ConversationServiceRecognizer = $896ca477924a147c$var$ConversationServiceRecognizer;

});

parcelRegister("at0sa", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognizerConfig = module.exports.SpeechResultFormat = module.exports.RecognitionMode = void 0;

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
var $79ecf6d58b1ad502$var$RecognitionMode;
(function(RecognitionMode) {
    RecognitionMode[RecognitionMode["Interactive"] = 0] = "Interactive";
    RecognitionMode[RecognitionMode["Conversation"] = 1] = "Conversation";
    RecognitionMode[RecognitionMode["Dictation"] = 2] = "Dictation";
})($79ecf6d58b1ad502$var$RecognitionMode = module.exports.RecognitionMode || (module.exports.RecognitionMode = {}));
var $79ecf6d58b1ad502$var$SpeechResultFormat;
(function(SpeechResultFormat) {
    SpeechResultFormat[SpeechResultFormat["Simple"] = 0] = "Simple";
    SpeechResultFormat[SpeechResultFormat["Detailed"] = 1] = "Detailed";
})($79ecf6d58b1ad502$var$SpeechResultFormat = module.exports.SpeechResultFormat || (module.exports.SpeechResultFormat = {}));
class $79ecf6d58b1ad502$var$RecognizerConfig {
    constructor(speechServiceConfig, parameters){
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $imJeu.SpeechServiceConfig(new $imJeu.Context(null));
        this.privParameters = parameters;
        this.privMaxRetryCount = parseInt(parameters.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10);
        this.privLanguageIdMode = parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_LanguageIdMode, undefined);
        this.privEnableSpeakerId = false;
    }
    get parameters() {
        return this.privParameters;
    }
    get recognitionMode() {
        return this.privRecognitionMode;
    }
    set recognitionMode(value) {
        this.privRecognitionMode = value;
        this.privRecognitionActivityTimeout = value === $79ecf6d58b1ad502$var$RecognitionMode.Interactive ? 8000 : 25000;
        this.privSpeechServiceConfig.Recognition = $79ecf6d58b1ad502$var$RecognitionMode[value];
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
    get recognitionActivityTimeout() {
        return this.privRecognitionActivityTimeout;
    }
    get isContinuousRecognition() {
        return this.privRecognitionMode !== $79ecf6d58b1ad502$var$RecognitionMode.Interactive;
    }
    get languageIdMode() {
        return this.privLanguageIdMode;
    }
    get autoDetectSourceLanguages() {
        return this.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, undefined);
    }
    get recognitionEndpointVersion() {
        return this.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, undefined);
    }
    get sourceLanguageModels() {
        const models = [];
        let modelsExist = false;
        if (this.autoDetectSourceLanguages !== undefined) for (const language of this.autoDetectSourceLanguages.split(",")){
            const customProperty = language + $hVlip.PropertyId.SpeechServiceConnection_EndpointId.toString();
            const modelId = this.parameters.getProperty(customProperty, undefined);
            if (modelId !== undefined) {
                models.push({
                    language: language,
                    endpoint: modelId
                });
                modelsExist = true;
            } else models.push({
                language: language,
                endpoint: ""
            });
        }
        return modelsExist ? models : undefined;
    }
    get maxRetryCount() {
        return this.privMaxRetryCount;
    }
    get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
    }
    set isSpeakerDiarizationEnabled(value) {
        this.privEnableSpeakerId = value;
    }
}
module.exports.RecognizerConfig = $79ecf6d58b1ad502$var$RecognizerConfig;

});

parcelRegister("8IRrx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bUMxs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageFormatter = void 0;

var $3wpON = parcelRequire("3wpON");
const $8aca93698b4e1f53$var$CRLF = "\r\n";
class $8aca93698b4e1f53$var$WebsocketMessageFormatter {
    toConnectionMessage(message) {
        const deferral = new $3wpON.Deferred();
        try {
            if (message.messageType === $3wpON.MessageType.Text) {
                const textMessage = message.textContent;
                let headers = {};
                let body = null;
                if (textMessage) {
                    const headerBodySplit = textMessage.split("\r\n\r\n");
                    if (headerBodySplit && headerBodySplit.length > 0) {
                        headers = this.parseHeaders(headerBodySplit[0]);
                        if (headerBodySplit.length > 1) body = headerBodySplit[1];
                    }
                }
                deferral.resolve(new $3wpON.ConnectionMessage(message.messageType, body, headers, message.id));
            } else if (message.messageType === $3wpON.MessageType.Binary) {
                const binaryMessage = message.binaryContent;
                let headers = {};
                let body = null;
                if (!binaryMessage || binaryMessage.byteLength < 2) throw new Error("Invalid binary message format. Header length missing.");
                const dataView = new DataView(binaryMessage);
                const headerLength = dataView.getInt16(0);
                if (binaryMessage.byteLength < headerLength + 2) throw new Error("Invalid binary message format. Header content missing.");
                let headersString = "";
                for(let i = 0; i < headerLength; i++)headersString += String.fromCharCode(dataView.getInt8(i + 2));
                headers = this.parseHeaders(headersString);
                if (binaryMessage.byteLength > headerLength + 2) body = binaryMessage.slice(2 + headerLength);
                deferral.resolve(new $3wpON.ConnectionMessage(message.messageType, body, headers, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. Error: ${e}`);
        }
        return deferral.promise;
    }
    fromConnectionMessage(message) {
        const deferral = new $3wpON.Deferred();
        try {
            if (message.messageType === $3wpON.MessageType.Text) {
                const payload = `${this.makeHeaders(message)}${$8aca93698b4e1f53$var$CRLF}${message.textBody ? message.textBody : ""}`;
                deferral.resolve(new $3wpON.RawWebsocketMessage($3wpON.MessageType.Text, payload, message.id));
            } else if (message.messageType === $3wpON.MessageType.Binary) {
                const headersString = this.makeHeaders(message);
                const content = message.binaryBody;
                const headerBuffer = this.stringToArrayBuffer(headersString);
                const headerInt8Array = new Int8Array(headerBuffer);
                const headerLength = headerInt8Array.byteLength;
                const payloadInt8Array = new Int8Array(2 + headerLength + (content ? content.byteLength : 0));
                payloadInt8Array[0] = headerLength >> 8 & 0xff;
                payloadInt8Array[1] = headerLength & 0xff;
                payloadInt8Array.set(headerInt8Array, 2);
                if (content) {
                    const bodyInt8Array = new Int8Array(content);
                    payloadInt8Array.set(bodyInt8Array, 2 + headerLength);
                }
                const payload = payloadInt8Array.buffer;
                deferral.resolve(new $3wpON.RawWebsocketMessage($3wpON.MessageType.Binary, payload, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. ${e}`);
        }
        return deferral.promise;
    }
    makeHeaders(message) {
        let headersString = "";
        if (message.headers) {
            for(const header in message.headers)if (header) headersString += `${header}: ${message.headers[header]}${$8aca93698b4e1f53$var$CRLF}`;
        }
        return headersString;
    }
    parseHeaders(headersString) {
        const headers = {};
        if (headersString) {
            const headerMatches = headersString.match(/[^\r\n]+/g);
            if (headers) {
                for (const header of headerMatches)if (header) {
                    const separatorIndex = header.indexOf(":");
                    const headerName = separatorIndex > 0 ? header.substr(0, separatorIndex).trim().toLowerCase() : header;
                    const headerValue = separatorIndex > 0 && header.length > separatorIndex + 1 ? header.substr(separatorIndex + 1).trim() : "";
                    headers[headerName] = headerValue;
                }
            }
        }
        return headers;
    }
    stringToArrayBuffer(str) {
        const buffer = new ArrayBuffer(str.length);
        const view = new DataView(buffer);
        for(let i = 0; i < str.length; i++)view.setUint8(i, str.charCodeAt(i));
        return buffer;
    }
}
module.exports.WebsocketMessageFormatter = $8aca93698b4e1f53$var$WebsocketMessageFormatter;

});

parcelRegister("01nRs", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $imJeu = parcelRequire("imJeu");

var $hVlip = parcelRequire("hVlip");

var $lAVhN = parcelRequire("lAVhN");

var $imJeu = parcelRequire("imJeu");

var $bPVwM = parcelRequire("bPVwM");

var $luvuO = parcelRequire("luvuO");
class $00429a78a6fe9eaf$var$SpeechConnectionFactory extends $lAVhN.ConnectionFactoryBase {
    constructor(){
        super(...arguments);
        this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1";
        this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1";
        this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1";
        this.universalUri = "/speech/universal/v";
    }
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region, undefined);
        const hostSuffix = $lAVhN.ConnectionFactoryBase.getHostSuffix(region);
        const host = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".stt.speech" + hostSuffix);
        const queryParams = {};
        const endpointId = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId) {
            if (!endpoint || endpoint.search($luvuO.QueryParameterNames.CustomSpeechDeploymentId) === -1) queryParams[$luvuO.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        } else if (language) {
            if (!endpoint || endpoint.search($luvuO.QueryParameterNames.Language) === -1) queryParams[$luvuO.QueryParameterNames.Language] = language;
        }
        if (!endpoint || endpoint.search($luvuO.QueryParameterNames.Format) === -1) queryParams[$luvuO.QueryParameterNames.Format] = config.parameters.getProperty($imJeu.OutputFormatPropertyName, $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]).toLowerCase();
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$luvuO.QueryParameterNames.EnableLanguageId] = "true";
        this.setCommonUrlParams(config, queryParams, endpoint);
        if (!endpoint) switch(config.recognitionMode){
            case $imJeu.RecognitionMode.Conversation:
                if (config.parameters.getProperty($imJeu.ForceDictationPropertyName, "false") === "true") endpoint = host + this.dictationRelativeUri;
                else if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = `${host}${this.universalUri}${config.recognitionEndpointVersion}`;
                else endpoint = host + this.conversationRelativeUri;
                break;
            case $imJeu.RecognitionMode.Dictation:
                endpoint = host + this.dictationRelativeUri;
                break;
            default:
                if (config.recognitionEndpointVersion !== undefined && parseInt(config.recognitionEndpointVersion, 10) > 1) endpoint = `${host}${this.universalUri}${config.recognitionEndpointVersion}`;
                else endpoint = host + this.interactiveRelativeUri; // default is interactive
                break;
        }
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$bPVwM.HeaderNames.ConnectionId] = connectionId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        const webSocketConnection = new $gvLMV.WebsocketConnection(endpoint, queryParams, headers, new $imJeu.WebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        // Set the value of SpeechServiceConnection_Url to webSocketConnection.uri (and not to `endpoint`), since this value is the final
        // URI that was used to make the connection (including query parameters).
        const uri = webSocketConnection.uri;
        config.parameters.setProperty($hVlip.PropertyId.SpeechServiceConnection_Url, uri);
        return webSocketConnection;
    }
}
module.exports.SpeechConnectionFactory = $00429a78a6fe9eaf$var$SpeechConnectionFactory;

});

parcelRegister("ixRYc", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriberConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");

var $lAVhN = parcelRequire("lAVhN");

var $imJeu = parcelRequire("imJeu");

var $bPVwM = parcelRequire("bPVwM");

var $luvuO = parcelRequire("luvuO");
class $d8052c61f404541f$var$ConversationTranscriberConnectionFactory extends $lAVhN.ConnectionFactoryBase {
    constructor(){
        super(...arguments);
        this.universalUri = "/speech/universal/v2";
    }
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region, undefined);
        const hostSuffix = $lAVhN.ConnectionFactoryBase.getHostSuffix(region);
        const host = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, "wss://" + region + ".stt.speech" + hostSuffix);
        const queryParams = {};
        const endpointId = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId) {
            if (!endpoint || endpoint.search($luvuO.QueryParameterNames.CustomSpeechDeploymentId) === -1) queryParams[$luvuO.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        } else if (language) {
            if (!endpoint || endpoint.search($luvuO.QueryParameterNames.Language) === -1) queryParams[$luvuO.QueryParameterNames.Language] = language;
        }
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$luvuO.QueryParameterNames.EnableLanguageId] = "true";
        this.setV2UrlParams(config, queryParams, endpoint);
        if (!endpoint) endpoint = `${host}${this.universalUri}`;
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$bPVwM.HeaderNames.ConnectionId] = connectionId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        const webSocketConnection = new $gvLMV.WebsocketConnection(endpoint, queryParams, headers, new $imJeu.WebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
        // Set the value of SpeechServiceConnection_Url to webSocketConnection.uri (and not to `endpoint`), since this value is the final
        // URI that was used to make the connection (including query parameters).
        const uri = webSocketConnection.uri;
        config.parameters.setProperty($hVlip.PropertyId.SpeechServiceConnection_Url, uri);
        return webSocketConnection;
    }
    setV2UrlParams(config, queryParams, endpoint) {
        const propertyIdToParameterMap = new Map([
            [
                $hVlip.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                $luvuO.QueryParameterNames.SegmentationSilenceTimeoutMs
            ],
            [
                $hVlip.PropertyId.SpeechServiceConnection_EnableAudioLogging,
                $luvuO.QueryParameterNames.EnableAudioLogging
            ],
            [
                $hVlip.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs,
                $luvuO.QueryParameterNames.EndSilenceTimeoutMs
            ],
            [
                $hVlip.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs,
                $luvuO.QueryParameterNames.InitialSilenceTimeoutMs
            ],
            [
                $hVlip.PropertyId.SpeechServiceResponse_PostProcessingOption,
                $luvuO.QueryParameterNames.Postprocessing
            ],
            [
                $hVlip.PropertyId.SpeechServiceResponse_ProfanityOption,
                $luvuO.QueryParameterNames.Profanity
            ],
            [
                $hVlip.PropertyId.SpeechServiceResponse_StablePartialResultThreshold,
                $luvuO.QueryParameterNames.StableIntermediateThreshold
            ]
        ]);
        propertyIdToParameterMap.forEach((parameterName, propertyId)=>{
            this.setUrlParameter(propertyId, parameterName, config, queryParams, endpoint);
        });
        const serviceProperties = JSON.parse(config.parameters.getProperty($imJeu.ServicePropertiesPropertyName, "{}"));
        Object.keys(serviceProperties).forEach((value)=>{
            queryParams[value] = serviceProperties[value];
        });
    }
}
module.exports.ConversationTranscriberConnectionFactory = $d8052c61f404541f$var$ConversationTranscriberConnectionFactory;

});

parcelRegister("bF6u5", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $hVlip = parcelRequire("hVlip");

var $lAVhN = parcelRequire("lAVhN");

var $imJeu = parcelRequire("imJeu");

var $bPVwM = parcelRequire("bPVwM");

var $luvuO = parcelRequire("luvuO");
class $87d88daaae0da10c$var$TranscriberConnectionFactory extends $lAVhN.ConnectionFactoryBase {
    constructor(){
        super(...arguments);
        this.multiaudioRelativeUri = "/speech/recognition/multiaudio";
    }
    create(config, authInfo, connectionId) {
        let endpoint = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        const region = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region, "centralus");
        const hostSuffix = $lAVhN.ConnectionFactoryBase.getHostSuffix(region);
        const hostDefault = "wss://transcribe." + region + ".cts.speech" + hostSuffix + this.multiaudioRelativeUri;
        const host = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, hostDefault);
        const queryParams = {};
        this.setQueryParams(queryParams, config, endpoint);
        if (!endpoint) endpoint = host;
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$bPVwM.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($hVlip.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $gvLMV.WebsocketConnection(endpoint, queryParams, headers, new $imJeu.WebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
    setQueryParams(queryParams, config, endpointUrl) {
        const endpointId = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_EndpointId, undefined);
        const language = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);
        if (endpointId && !($luvuO.QueryParameterNames.CustomSpeechDeploymentId in queryParams)) queryParams[$luvuO.QueryParameterNames.CustomSpeechDeploymentId] = endpointId;
        if (language && !($luvuO.QueryParameterNames.Language in queryParams)) queryParams[$luvuO.QueryParameterNames.Language] = language;
        const wordLevelTimings = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true";
        const detailed = config.parameters.getProperty($imJeu.OutputFormatPropertyName, $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]) !== $hVlip.OutputFormat[$hVlip.OutputFormat.Simple];
        if (wordLevelTimings || detailed) queryParams[$luvuO.QueryParameterNames.Format] = $hVlip.OutputFormat[$hVlip.OutputFormat.Detailed].toLowerCase();
        this.setCommonUrlParams(config, queryParams, endpointUrl);
    }
}
module.exports.TranscriberConnectionFactory = $87d88daaae0da10c$var$TranscriberConnectionFactory;

});

parcelRegister("6npKJ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $4nh4E = parcelRequire("4nh4E");

var $hVlip = parcelRequire("hVlip");

var $lAVhN = parcelRequire("lAVhN");

var $imJeu = parcelRequire("imJeu");

var $bPVwM = parcelRequire("bPVwM");

var $luvuO = parcelRequire("luvuO");
class $4a48ddfe83cffd1d$var$TranslationConnectionFactory extends $lAVhN.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        const endpoint = this.getEndpointUrl(config);
        const queryParams = {};
        if (config.autoDetectSourceLanguages !== undefined) queryParams[$luvuO.QueryParameterNames.EnableLanguageId] = "true";
        this.setQueryParams(queryParams, config, endpoint);
        const headers = {};
        if (authInfo.token !== undefined && authInfo.token !== "") headers[authInfo.headerName] = authInfo.token;
        headers[$bPVwM.HeaderNames.ConnectionId] = connectionId;
        config.parameters.setProperty($hVlip.PropertyId.SpeechServiceConnection_Url, endpoint);
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $gvLMV.WebsocketConnection(endpoint, queryParams, headers, new $imJeu.WebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
    getEndpointUrl(config, returnRegionPlaceholder) {
        const region = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region);
        const hostSuffix = $lAVhN.ConnectionFactoryBase.getHostSuffix(region);
        let endpointUrl = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        if (!endpointUrl) {
            if (config.autoDetectSourceLanguages !== undefined) {
                const host = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, "wss://{region}.stt.speech" + hostSuffix);
                endpointUrl = host + "/speech/universal/v2";
            } else {
                const host = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, "wss://{region}.s2s.speech" + hostSuffix);
                endpointUrl = host + "/speech/translation/cognitiveservices/v1";
            }
        }
        if (returnRegionPlaceholder === true) return endpointUrl;
        return $4nh4E.StringUtils.formatString(endpointUrl, {
            region: region
        });
    }
    setQueryParams(queryParams, config, endpointUrl) {
        queryParams.from = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage);
        queryParams.to = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationToLanguages);
        queryParams.scenario = config.recognitionMode === $imJeu.RecognitionMode.Interactive ? "interactive" : config.recognitionMode === $imJeu.RecognitionMode.Conversation ? "conversation" : "";
        this.setCommonUrlParams(config, queryParams, endpointUrl);
        this.setUrlParameter($hVlip.PropertyId.SpeechServiceResponse_TranslationRequestStablePartialResult, $luvuO.QueryParameterNames.StableTranslation, config, queryParams, endpointUrl);
        const translationVoice = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_TranslationVoice, undefined);
        if (translationVoice !== undefined) {
            queryParams.voice = translationVoice;
            queryParams.features = "texttospeech";
        }
    }
}
module.exports.TranslationConnectionFactory = $4a48ddfe83cffd1d$var$TranslationConnectionFactory;

});

parcelRegister("5q35L", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnumTranslation = void 0;

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
class $3f21c7786250ca86$var$EnumTranslation {
    static implTranslateRecognitionResult(recognitionStatus, expectEndOfDictation = false) {
        let reason = $hVlip.ResultReason.Canceled;
        switch(recognitionStatus){
            case $imJeu.RecognitionStatus.Success:
                reason = $hVlip.ResultReason.RecognizedSpeech;
                break;
            case $imJeu.RecognitionStatus.EndOfDictation:
                // If we need the result in EndOfDictation (typically some session level result),
                // translate into RecognizedSpeech, otherwise NoMatch
                reason = expectEndOfDictation ? $hVlip.ResultReason.RecognizedSpeech : $hVlip.ResultReason.NoMatch;
                break;
            case $imJeu.RecognitionStatus.NoMatch:
            case $imJeu.RecognitionStatus.InitialSilenceTimeout:
            case $imJeu.RecognitionStatus.BabbleTimeout:
                reason = $hVlip.ResultReason.NoMatch;
                break;
            case $imJeu.RecognitionStatus.Error:
            case $imJeu.RecognitionStatus.BadRequest:
            case $imJeu.RecognitionStatus.Forbidden:
            default:
                reason = $hVlip.ResultReason.Canceled;
                break;
        }
        return reason;
    }
    static implTranslateCancelResult(recognitionStatus) {
        let reason = $hVlip.CancellationReason.EndOfStream;
        switch(recognitionStatus){
            case $imJeu.RecognitionStatus.Success:
            case $imJeu.RecognitionStatus.EndOfDictation:
            case $imJeu.RecognitionStatus.NoMatch:
                reason = $hVlip.CancellationReason.EndOfStream;
                break;
            case $imJeu.RecognitionStatus.InitialSilenceTimeout:
            case $imJeu.RecognitionStatus.BabbleTimeout:
            case $imJeu.RecognitionStatus.Error:
            case $imJeu.RecognitionStatus.BadRequest:
            case $imJeu.RecognitionStatus.Forbidden:
            default:
                reason = $hVlip.CancellationReason.Error;
                break;
        }
        return reason;
    }
    static implTranslateCancelErrorCode(recognitionStatus) {
        let reason = $hVlip.CancellationErrorCode.NoError;
        switch(recognitionStatus){
            case $imJeu.RecognitionStatus.Error:
                reason = $hVlip.CancellationErrorCode.ServiceError;
                break;
            case $imJeu.RecognitionStatus.TooManyRequests:
                reason = $hVlip.CancellationErrorCode.TooManyRequests;
                break;
            case $imJeu.RecognitionStatus.BadRequest:
                reason = $hVlip.CancellationErrorCode.BadRequestParameters;
                break;
            case $imJeu.RecognitionStatus.Forbidden:
                reason = $hVlip.CancellationErrorCode.Forbidden;
                break;
            default:
                reason = $hVlip.CancellationErrorCode.NoError;
                break;
        }
        return reason;
    }
    static implTranslateErrorDetails(cancellationErrorCode) {
        let errorDetails = "The speech service encountered an internal error and could not continue.";
        switch(cancellationErrorCode){
            case $hVlip.CancellationErrorCode.Forbidden:
                errorDetails = "The recognizer is using a free subscription that ran out of quota.";
                break;
            case $hVlip.CancellationErrorCode.BadRequestParameters:
                errorDetails = "Invalid parameter or unsupported audio format in the request.";
                break;
            case $hVlip.CancellationErrorCode.TooManyRequests:
                errorDetails = "The number of parallel requests exceeded the number of allowed concurrent transcriptions.";
                break;
            default:
                break;
        }
        return errorDetails;
    }
}
module.exports.EnumTranslation = $3f21c7786250ca86$var$EnumTranslation;

});

parcelRegister("fLkdD", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionStatus = module.exports.SynthesisStatus = void 0;
/**
 * @class SynthesisStatus
 * @private
 */ var $b79aedd898cf308f$var$SynthesisStatus;
(function(SynthesisStatus) {
    /**
     * The response contains valid audio data.
     * @member SynthesisStatus.Success
     */ SynthesisStatus[SynthesisStatus["Success"] = 0] = "Success";
    /**
     * Indicates the end of audio data. No valid audio data is included in the message.
     * @member SynthesisStatus.SynthesisEnd
     */ SynthesisStatus[SynthesisStatus["SynthesisEnd"] = 1] = "SynthesisEnd";
    /**
     * Indicates an error occurred during synthesis data processing.
     * @member SynthesisStatus.Error
     */ SynthesisStatus[SynthesisStatus["Error"] = 2] = "Error";
})($b79aedd898cf308f$var$SynthesisStatus = module.exports.SynthesisStatus || (module.exports.SynthesisStatus = {}));
var $b79aedd898cf308f$var$RecognitionStatus;
(function(RecognitionStatus) {
    RecognitionStatus[RecognitionStatus["Success"] = 0] = "Success";
    RecognitionStatus[RecognitionStatus["NoMatch"] = 1] = "NoMatch";
    RecognitionStatus[RecognitionStatus["InitialSilenceTimeout"] = 2] = "InitialSilenceTimeout";
    RecognitionStatus[RecognitionStatus["BabbleTimeout"] = 3] = "BabbleTimeout";
    RecognitionStatus[RecognitionStatus["Error"] = 4] = "Error";
    RecognitionStatus[RecognitionStatus["EndOfDictation"] = 5] = "EndOfDictation";
    RecognitionStatus[RecognitionStatus["TooManyRequests"] = 6] = "TooManyRequests";
    RecognitionStatus[RecognitionStatus["BadRequest"] = 7] = "BadRequest";
    RecognitionStatus[RecognitionStatus["Forbidden"] = 8] = "Forbidden";
})($b79aedd898cf308f$var$RecognitionStatus = module.exports.RecognitionStatus || (module.exports.RecognitionStatus = {}));

});

parcelRegister("513Bk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationSynthesisEnd = void 0;

var $imJeu = parcelRequire("imJeu");
class $3a6fd6dbb3850db6$var$TranslationSynthesisEnd {
    constructor(json){
        this.privSynthesisEnd = JSON.parse(json);
        if (!!this.privSynthesisEnd.SynthesisStatus) this.privSynthesisEnd.SynthesisStatus = $imJeu.SynthesisStatus[this.privSynthesisEnd.SynthesisStatus];
        if (!!this.privSynthesisEnd.Status) this.privSynthesisEnd.SynthesisStatus = $imJeu.SynthesisStatus[this.privSynthesisEnd.Status];
    }
    static fromJSON(json) {
        return new $3a6fd6dbb3850db6$var$TranslationSynthesisEnd(json);
    }
    get SynthesisStatus() {
        return this.privSynthesisEnd.SynthesisStatus;
    }
    get FailureReason() {
        return this.privSynthesisEnd.FailureReason;
    }
}
module.exports.TranslationSynthesisEnd = $3a6fd6dbb3850db6$var$TranslationSynthesisEnd;

});

parcelRegister("bkrTl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationHypothesis = void 0;

var $56OOs = parcelRequire("56OOs");

var $6kHRL = parcelRequire("6kHRL");
class $83f732b0b2a89b7f$var$TranslationHypothesis {
    constructor(hypothesis){
        this.privTranslationHypothesis = hypothesis;
        this.privTranslationHypothesis.Translation.TranslationStatus = $6kHRL.TranslationStatus[this.privTranslationHypothesis.Translation.TranslationStatus];
    }
    static fromJSON(json) {
        return new $83f732b0b2a89b7f$var$TranslationHypothesis(JSON.parse(json));
    }
    static fromTranslationResponse(translationHypothesis) {
        $56OOs.Contracts.throwIfNullOrUndefined(translationHypothesis, "translationHypothesis");
        const hypothesis = translationHypothesis.SpeechHypothesis;
        translationHypothesis.SpeechHypothesis = undefined;
        hypothesis.Translation = translationHypothesis;
        return new $83f732b0b2a89b7f$var$TranslationHypothesis(hypothesis);
    }
    get Duration() {
        return this.privTranslationHypothesis.Duration;
    }
    get Offset() {
        return this.privTranslationHypothesis.Offset;
    }
    get Text() {
        return this.privTranslationHypothesis.Text;
    }
    get Translation() {
        return this.privTranslationHypothesis.Translation;
    }
    get Language() {
        return this.privTranslationHypothesis.PrimaryLanguage?.Language;
    }
}
module.exports.TranslationHypothesis = $83f732b0b2a89b7f$var$TranslationHypothesis;

});

parcelRegister("9wjMV", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationPhrase = void 0;

var $56OOs = parcelRequire("56OOs");

var $imJeu = parcelRequire("imJeu");

var $6kHRL = parcelRequire("6kHRL");
class $6ee673b34b2b23c7$var$TranslationPhrase {
    constructor(phrase){
        this.privTranslationPhrase = phrase;
        this.privTranslationPhrase.RecognitionStatus = $imJeu.RecognitionStatus[this.privTranslationPhrase.RecognitionStatus];
        if (this.privTranslationPhrase.Translation !== undefined) this.privTranslationPhrase.Translation.TranslationStatus = $6kHRL.TranslationStatus[this.privTranslationPhrase.Translation.TranslationStatus];
    }
    static fromJSON(json) {
        return new $6ee673b34b2b23c7$var$TranslationPhrase(JSON.parse(json));
    }
    static fromTranslationResponse(translationResponse) {
        $56OOs.Contracts.throwIfNullOrUndefined(translationResponse, "translationResponse");
        const phrase = translationResponse.SpeechPhrase;
        translationResponse.SpeechPhrase = undefined;
        phrase.Translation = translationResponse;
        phrase.Text = phrase.DisplayText;
        return new $6ee673b34b2b23c7$var$TranslationPhrase(phrase);
    }
    get RecognitionStatus() {
        return this.privTranslationPhrase.RecognitionStatus;
    }
    get Offset() {
        return this.privTranslationPhrase.Offset;
    }
    get Duration() {
        return this.privTranslationPhrase.Duration;
    }
    get Text() {
        return this.privTranslationPhrase.Text;
    }
    get Language() {
        return this.privTranslationPhrase.PrimaryLanguage?.Language;
    }
    get Confidence() {
        return this.privTranslationPhrase.PrimaryLanguage?.Confidence;
    }
    get Translation() {
        return this.privTranslationPhrase.Translation;
    }
}
module.exports.TranslationPhrase = $6ee673b34b2b23c7$var$TranslationPhrase;

});

parcelRegister("4Ifyz", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranslationServiceRecognizer = void 0;

var $3wpON = parcelRequire("3wpON");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
// eslint-disable-next-line max-classes-per-file
class $36e756b1e9b9f8f8$var$TranslationServiceRecognizer extends $imJeu.ConversationServiceRecognizer {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, translationRecognizer);
        this.privTranslationRecognizer = translationRecognizer;
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionEstablishedEvent") this.privTranslationRecognizer.onConnection();
        });
    }
    async processTypeSpecificMessages(connectionMessage) {
        const resultProps = new $hVlip.PropertyCollection();
        let processed = await this.processSpeechMessages(connectionMessage);
        if (processed) return true;
        const handleTranslationPhrase = async (translatedPhrase)=>{
            this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset + translatedPhrase.Duration);
            if (translatedPhrase.RecognitionStatus === $imJeu.RecognitionStatus.Success) {
                // OK, the recognition was successful. How'd the translation do?
                const result = this.fireEventForResult(translatedPhrase, resultProps);
                if (!!this.privTranslationRecognizer.recognized) try {
                    this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, result);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                // report result to promise.
                if (!!this.privSuccessCallback) {
                    try {
                        this.privSuccessCallback(result.result);
                    } catch (e) {
                        if (!!this.privErrorCallback) this.privErrorCallback(e);
                    }
                    // Only invoke the call back once.
                    // and if it's successful don't invoke the
                    // error after that.
                    this.privSuccessCallback = undefined;
                    this.privErrorCallback = undefined;
                }
            } else {
                const reason = $imJeu.EnumTranslation.implTranslateRecognitionResult(translatedPhrase.RecognitionStatus);
                const result = new $hVlip.TranslationRecognitionResult(undefined, this.privRequestSession.requestId, reason, translatedPhrase.Text, translatedPhrase.Duration, this.privRequestSession.currentTurnAudioOffset + translatedPhrase.Offset, translatedPhrase.Language, translatedPhrase.Confidence, undefined, connectionMessage.textBody, resultProps);
                if (reason === $hVlip.ResultReason.Canceled) {
                    const cancelReason = $imJeu.EnumTranslation.implTranslateCancelResult(translatedPhrase.RecognitionStatus);
                    const cancellationErrorCode = $imJeu.EnumTranslation.implTranslateCancelErrorCode(translatedPhrase.RecognitionStatus);
                    await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $imJeu.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
                } else {
                    if (!(this.privRequestSession.isSpeechEnded && reason === $hVlip.ResultReason.NoMatch && translatedPhrase.RecognitionStatus !== $imJeu.RecognitionStatus.InitialSilenceTimeout)) {
                        const ev = new $hVlip.TranslationRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                        if (!!this.privTranslationRecognizer.recognized) try {
                            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
                        /* eslint-disable no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                    }
                    // report result to promise.
                    if (!!this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(result);
                        } catch (e) {
                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        this.privSuccessCallback = undefined;
                        this.privErrorCallback = undefined;
                    }
                }
                processed = true;
            }
        };
        const handleTranslationHypothesis = (hypothesis, resultProperties)=>{
            const result = this.fireEventForResult(hypothesis, resultProperties);
            this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + result.offset);
            if (!!this.privTranslationRecognizer.recognizing) try {
                this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, result);
            /* eslint-disable no-empty */ } catch (error) {
            // Not going to let errors in the event handler
            // trip things up.
            }
            processed = true;
        };
        if (connectionMessage.messageType === $3wpON.MessageType.Text) resultProps.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "translation.hypothesis":
                handleTranslationHypothesis($imJeu.TranslationHypothesis.fromJSON(connectionMessage.textBody), resultProps);
                break;
            case "translation.response":
                const phrase = JSON.parse(connectionMessage.textBody);
                if (!!phrase.SpeechPhrase) await handleTranslationPhrase($imJeu.TranslationPhrase.fromTranslationResponse(phrase));
                else {
                    const hypothesis = JSON.parse(connectionMessage.textBody);
                    if (!!hypothesis.SpeechHypothesis) handleTranslationHypothesis($imJeu.TranslationHypothesis.fromTranslationResponse(hypothesis), resultProps);
                }
                break;
            case "translation.phrase":
                await handleTranslationPhrase($imJeu.TranslationPhrase.fromJSON(connectionMessage.textBody));
                break;
            case "translation.synthesis":
                this.sendSynthesisAudio(connectionMessage.binaryBody, this.privRequestSession.sessionId);
                processed = true;
                break;
            case "audio.end":
            case "translation.synthesis.end":
                const synthEnd = $imJeu.TranslationSynthesisEnd.fromJSON(connectionMessage.textBody);
                switch(synthEnd.SynthesisStatus){
                    case $imJeu.SynthesisStatus.Error:
                        if (!!this.privTranslationRecognizer.synthesizing) {
                            const result = new $hVlip.TranslationSynthesisResult($hVlip.ResultReason.Canceled, undefined);
                            const retEvent = new $hVlip.TranslationSynthesisEventArgs(result, this.privRequestSession.sessionId);
                            try {
                                this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
                            /* eslint-disable no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        if (!!this.privTranslationRecognizer.canceled) {
                            // And raise a canceled event to send the rich(er) error message back.
                            const canceledResult = new $hVlip.TranslationRecognitionCanceledEventArgs(this.privRequestSession.sessionId, $hVlip.CancellationReason.Error, synthEnd.FailureReason, $hVlip.CancellationErrorCode.ServiceError, null);
                            try {
                                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, canceledResult);
                            /* eslint-disable no-empty */ } catch (error) {
                            // Not going to let errors in the event handler
                            // trip things up.
                            }
                        }
                        break;
                    case $imJeu.SynthesisStatus.Success:
                        this.sendSynthesisAudio(undefined, this.privRequestSession.sessionId);
                        break;
                    default:
                        break;
                }
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $hVlip.PropertyCollection();
        properties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[errorCode]);
        if (!!this.privTranslationRecognizer.canceled) {
            const cancelEvent = new $hVlip.TranslationRecognitionCanceledEventArgs(sessionId, cancellationReason, error, errorCode, undefined);
            try {
                this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $hVlip.TranslationRecognitionResult(undefined, requestId, $hVlip.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                /* eslint-disable no-empty */ this.privSuccessCallback = undefined;
            } catch  {}
        }
    }
    handleRecognizingCallback(result, duration, sessionId) {
        try {
            const ev = new $hVlip.TranslationRecognitionEventArgs($hVlip.TranslationRecognitionResult.fromSpeechRecognitionResult(result), duration, sessionId);
            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    handleRecognizedCallback(result, offset, sessionId) {
        try {
            const ev = new $hVlip.TranslationRecognitionEventArgs($hVlip.TranslationRecognitionResult.fromSpeechRecognitionResult(result), offset, sessionId);
            this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, ev);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    fireEventForResult(serviceResult, properties) {
        let translations;
        if (undefined !== serviceResult.Translation.Translations) {
            translations = new $hVlip.Translations();
            for (const translation of serviceResult.Translation.Translations)translations.set(translation.Language, translation.Text || translation.DisplayText);
        }
        let resultReason;
        let confidence;
        if (serviceResult instanceof $imJeu.TranslationPhrase) {
            if (!!serviceResult.Translation && serviceResult.Translation.TranslationStatus === $3wpON.TranslationStatus.Success) resultReason = $hVlip.ResultReason.TranslatedSpeech;
            else resultReason = $hVlip.ResultReason.RecognizedSpeech;
            confidence = serviceResult.Confidence;
        } else resultReason = $hVlip.ResultReason.TranslatingSpeech;
        const language = serviceResult.Language;
        const offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        const result = new $hVlip.TranslationRecognitionResult(translations, this.privRequestSession.requestId, resultReason, serviceResult.Text, serviceResult.Duration, offset, language, confidence, serviceResult.Translation.FailureReason, JSON.stringify(serviceResult), properties);
        const ev = new $hVlip.TranslationRecognitionEventArgs(result, offset, this.privRequestSession.sessionId);
        return ev;
    }
    sendSynthesisAudio(audio, sessionId) {
        const reason = undefined === audio ? $hVlip.ResultReason.SynthesizingAudioCompleted : $hVlip.ResultReason.SynthesizingAudio;
        const result = new $hVlip.TranslationSynthesisResult(reason, audio);
        const retEvent = new $hVlip.TranslationSynthesisEventArgs(result, sessionId);
        if (!!this.privTranslationRecognizer.synthesizing) try {
            this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, retEvent);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
}
module.exports.TranslationServiceRecognizer = $36e756b1e9b9f8f8$var$TranslationServiceRecognizer;

});

parcelRegister("4LzST", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechDetected = void 0;
class $37876314be7b402d$var$SpeechDetected {
    constructor(json){
        this.privSpeechStartDetected = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $37876314be7b402d$var$SpeechDetected(json);
    }
    get Offset() {
        return this.privSpeechStartDetected.Offset;
    }
}
module.exports.SpeechDetected = $37876314be7b402d$var$SpeechDetected;

});

parcelRegister("gMYFW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechHypothesis = void 0;
class $c39031f06a9f0bb4$var$SpeechHypothesis {
    constructor(json){
        this.privSpeechHypothesis = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $c39031f06a9f0bb4$var$SpeechHypothesis(json);
    }
    get Text() {
        return this.privSpeechHypothesis.Text;
    }
    get Offset() {
        return this.privSpeechHypothesis.Offset;
    }
    get Duration() {
        return this.privSpeechHypothesis.Duration;
    }
    get Language() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSpeechHypothesis.PrimaryLanguage === undefined ? undefined : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSpeechHypothesis.SpeakerId;
    }
}
module.exports.SpeechHypothesis = $c39031f06a9f0bb4$var$SpeechHypothesis;

});

parcelRegister("7PgT6", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechKeyword = void 0;
class $5b2a65661d95b90a$var$SpeechKeyword {
    constructor(json){
        this.privSpeechKeyword = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $5b2a65661d95b90a$var$SpeechKeyword(json);
    }
    get Status() {
        return this.privSpeechKeyword.Status;
    }
    get Text() {
        return this.privSpeechKeyword.Text;
    }
    get Offset() {
        return this.privSpeechKeyword.Offset;
    }
    get Duration() {
        return this.privSpeechKeyword.Duration;
    }
}
module.exports.SpeechKeyword = $5b2a65661d95b90a$var$SpeechKeyword;

});

parcelRegister("jM5su", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechServiceRecognizer = void 0;

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
// eslint-disable-next-line max-classes-per-file
class $e656bbf5442708cd$var$SpeechServiceRecognizer extends $imJeu.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, speechRecognizer);
        this.privSpeechRecognizer = speechRecognizer;
    }
    async processTypeSpecificMessages(connectionMessage) {
        let result;
        const resultProps = new $hVlip.PropertyCollection();
        resultProps.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        let processed = false;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
            case "speech.fragment":
                const hypothesis = $imJeu.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                result = new $hVlip.SpeechRecognitionResult(this.privRequestSession.requestId, $hVlip.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(offset);
                const ev = new $hVlip.SpeechRecognitionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                if (!!this.privSpeechRecognizer.recognizing) try {
                    this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.phrase":
                const simple = $imJeu.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                const resultReason = $imJeu.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus, this.privExpectContentAssessmentResponse);
                this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                if ($hVlip.ResultReason.Canceled === resultReason) {
                    const cancelReason = $imJeu.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                    const cancellationErrorCode = $imJeu.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
                    await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $imJeu.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
                } else {
                    if (!(this.privRequestSession.isSpeechEnded && resultReason === $hVlip.ResultReason.NoMatch && simple.RecognitionStatus !== $imJeu.RecognitionStatus.InitialSilenceTimeout)) {
                        if (this.privRecognizerConfig.parameters.getProperty($imJeu.OutputFormatPropertyName) === $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]) result = new $hVlip.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                        else {
                            const detailed = $imJeu.DetailedSpeechPhrase.fromJSON(connectionMessage.textBody);
                            const totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                            const offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                            result = new $hVlip.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === $imJeu.RecognitionStatus.Success ? detailed.NBest[0].Display : undefined, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, undefined, undefined, offsetCorrectedJson, resultProps);
                        }
                        const event = new $hVlip.SpeechRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                        if (!!this.privSpeechRecognizer.recognized) try {
                            this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, event);
                        /* eslint-disable no-empty */ } catch (error) {
                        // Not going to let errors in the event handler
                        // trip things up.
                        }
                    }
                    if (!!this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(result);
                        } catch (e) {
                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        this.privSuccessCallback = undefined;
                        this.privErrorCallback = undefined;
                    }
                }
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $hVlip.PropertyCollection();
        properties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[errorCode]);
        if (!!this.privSpeechRecognizer.canceled) {
            const cancelEvent = new $hVlip.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $hVlip.SpeechRecognitionResult(requestId, $hVlip.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch  {}
        }
    }
}
module.exports.SpeechServiceRecognizer = $e656bbf5442708cd$var$SpeechServiceRecognizer;

});

parcelRegister("h0No0", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranscriptionServiceRecognizer = void 0;

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
// eslint-disable-next-line max-classes-per-file
class $c628bed3dfa14cbb$var$ConversationTranscriptionServiceRecognizer extends $imJeu.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, conversationTranscriber){
        super(authentication, connectionFactory, audioSource, recognizerConfig, conversationTranscriber);
        this.privConversationTranscriber = conversationTranscriber;
        this.setSpeakerDiarizationJson();
    }
    setSpeakerDiarizationJson() {
        if (this.privEnableSpeakerId) {
            const phraseDetection = this.privSpeechContext.getSection("phraseDetection");
            phraseDetection.mode = "Conversation";
            const speakerDiarization = {};
            speakerDiarization.mode = "Anonymous";
            speakerDiarization.audioSessionId = this.privDiarizationSessionId;
            speakerDiarization.audioOffsetMs = 0;
            phraseDetection.speakerDiarization = speakerDiarization;
            this.privSpeechContext.setSection("phraseDetection", phraseDetection);
        }
    }
    async processTypeSpecificMessages(connectionMessage) {
        let result;
        const resultProps = new $hVlip.PropertyCollection();
        resultProps.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        let processed = false;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
            case "speech.fragment":
                const hypothesis = $imJeu.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                result = new $hVlip.ConversationTranscriptionResult(this.privRequestSession.requestId, $hVlip.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(offset);
                const ev = new $hVlip.ConversationTranscriptionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                if (!!this.privConversationTranscriber.transcribing) try {
                    this.privConversationTranscriber.transcribing(this.privConversationTranscriber, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.phrase":
                const simple = $imJeu.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                const resultReason = $imJeu.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus);
                this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + simple.Offset + simple.Duration);
                if ($hVlip.ResultReason.Canceled === resultReason) {
                    const cancelReason = $imJeu.EnumTranslation.implTranslateCancelResult(simple.RecognitionStatus);
                    const cancellationErrorCode = $imJeu.EnumTranslation.implTranslateCancelErrorCode(simple.RecognitionStatus);
                    await this.cancelRecognitionLocal(cancelReason, cancellationErrorCode, $imJeu.EnumTranslation.implTranslateErrorDetails(cancellationErrorCode));
                } else if (!(this.privRequestSession.isSpeechEnded && resultReason === $hVlip.ResultReason.NoMatch && simple.RecognitionStatus !== $imJeu.RecognitionStatus.InitialSilenceTimeout)) {
                    if (this.privRecognizerConfig.parameters.getProperty($imJeu.OutputFormatPropertyName) === $hVlip.OutputFormat[$hVlip.OutputFormat.Simple]) result = new $hVlip.ConversationTranscriptionResult(this.privRequestSession.requestId, resultReason, simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, simple.SpeakerId, undefined, connectionMessage.textBody, resultProps);
                    else {
                        const detailed = $imJeu.DetailedSpeechPhrase.fromJSON(connectionMessage.textBody);
                        const totalOffset = detailed.Offset + this.privRequestSession.currentTurnAudioOffset;
                        const offsetCorrectedJson = detailed.getJsonWithCorrectedOffsets(totalOffset);
                        result = new $hVlip.ConversationTranscriptionResult(this.privRequestSession.requestId, resultReason, detailed.RecognitionStatus === $imJeu.RecognitionStatus.Success ? detailed.NBest[0].Display : undefined, detailed.Duration, totalOffset, detailed.Language, detailed.LanguageDetectionConfidence, simple.SpeakerId, undefined, offsetCorrectedJson, resultProps);
                    }
                    const event = new $hVlip.ConversationTranscriptionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                    if (!!this.privConversationTranscriber.transcribed) try {
                        this.privConversationTranscriber.transcribed(this.privConversationTranscriber, event);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            default:
                break;
        }
        return processed;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $hVlip.PropertyCollection();
        properties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[errorCode]);
        if (!!this.privConversationTranscriber.canceled) {
            const cancelEvent = new $hVlip.ConversationTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privConversationTranscriber.canceled(this.privConversationTranscriber, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
    }
}
module.exports.ConversationTranscriptionServiceRecognizer = $c628bed3dfa14cbb$var$ConversationTranscriptionServiceRecognizer;

});

parcelRegister("fIBUW", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriptionServiceRecognizer = void 0;

var $3wpON = parcelRequire("3wpON");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");

var $l6AmD = parcelRequire("l6AmD");
// eslint-disable-next-line max-classes-per-file
class $b71860adda34f82c$var$TranscriptionServiceRecognizer extends $imJeu.ConversationServiceRecognizer {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, transcriber){
        super(authentication, connectionFactory, audioSource, recognizerConfig, transcriber);
        this.privTranscriberRecognizer = transcriber;
        this.sendPrePayloadJSONOverride = (connection)=>this.sendTranscriptionStartJSON(connection);
        if (this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps) === "true") this.privSpeechContext.setWordLevelTimings();
    }
    async sendSpeechEventAsync(info, command) {
        if (!!this.privRequestSession.isRecognizing) {
            const connection = await this.fetchConnection();
            await this.sendSpeechEvent(connection, this.createSpeechEventPayload(info, command));
        }
    }
    async sendMeetingSpeechEventAsync(info, command) {
        if (!!this.privRequestSession.isRecognizing) {
            const connection = await this.fetchConnection();
            await this.sendSpeechEvent(connection, this.createMeetingSpeechEventPayload(info, command));
        }
    }
    processTypeSpecificMessages(connectionMessage) {
        return this.processSpeechMessages(connectionMessage);
    }
    handleRecognizedCallback(result, offset, sessionId) {
        try {
            const event = new $hVlip.SpeechRecognitionEventArgs(result, offset, sessionId);
            this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, event);
            if (!!this.privSuccessCallback) {
                try {
                    this.privSuccessCallback(result);
                } catch (e) {
                    if (!!this.privErrorCallback) this.privErrorCallback(e);
                }
                // Only invoke the call back once.
                // and if it's successful don't invoke the
                // error after that.
                this.privSuccessCallback = undefined;
                this.privErrorCallback = undefined;
            }
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    handleRecognizingCallback(result, duration, sessionId) {
        try {
            const ev = new $hVlip.SpeechRecognitionEventArgs(result, duration, sessionId);
            this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, ev);
        /* eslint-disable no-empty */ } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $hVlip.PropertyCollection();
        properties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[errorCode]);
        if (this.privTranscriberRecognizer.IsMeetingRecognizer()) {
            if (!!this.privTranscriberRecognizer.canceled) {
                const cancelEvent = new $hVlip.MeetingTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
                try {
                    this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
                /* eslint-disable no-empty */ } catch  {}
            }
        } else if (!!this.privTranscriberRecognizer.canceled) {
            const cancelEvent = new $hVlip.ConversationTranscriptionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $hVlip.SpeechRecognitionResult(requestId, $hVlip.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch  {}
        }
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    async sendTranscriptionStartJSON(connection) {
        await this.sendSpeechContext(connection, true);
        if (this.privTranscriberRecognizer.IsMeetingRecognizer()) {
            const info = this.privTranscriberRecognizer.getMeetingInfo();
            const payload = this.createMeetingSpeechEventPayload(info, "start");
            await this.sendSpeechEvent(connection, payload);
        } else {
            const info = this.privTranscriberRecognizer.getConversationInfo();
            const payload = this.createSpeechEventPayload(info, "start");
            await this.sendSpeechEvent(connection, payload);
        }
        await this.sendWaveHeader(connection);
        return;
    }
    sendSpeechEvent(connection, payload) {
        const speechEventJson = JSON.stringify(payload);
        if (speechEventJson) return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "speech.event", this.privRequestSession.requestId, "application/json", speechEventJson));
        return;
    }
    createSpeechEventPayload(info, command) {
        const eventDict = {
            id: "meeting",
            name: command,
            meeting: info.conversationProperties
        };
        eventDict.meeting.id = info.id;
        eventDict.meeting.attendees = info.participants;
        return eventDict;
    }
    createMeetingSpeechEventPayload(info, command) {
        const eventDict = {
            id: "meeting",
            name: command,
            meeting: info.meetingProperties
        };
        eventDict.meeting.id = info.id;
        eventDict.meeting.attendees = info.participants;
        return eventDict;
    }
}
module.exports.TranscriptionServiceRecognizer = $b71860adda34f82c$var$TranscriptionServiceRecognizer;

});

parcelRegister("8qsM9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DetailedSpeechPhrase = void 0;

var $imJeu = parcelRequire("imJeu");
class $622712a7699a4ed9$var$DetailedSpeechPhrase {
    constructor(json){
        this.privDetailedSpeechPhrase = JSON.parse(json);
        this.privDetailedSpeechPhrase.RecognitionStatus = $imJeu.RecognitionStatus[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(json) {
        return new $622712a7699a4ed9$var$DetailedSpeechPhrase(json);
    }
    getJsonWithCorrectedOffsets(baseOffset) {
        if (!!this.privDetailedSpeechPhrase.NBest) {
            let firstWordOffset;
            for (const phrase of this.privDetailedSpeechPhrase.NBest)if (!!phrase.Words && !!phrase.Words[0]) {
                firstWordOffset = phrase.Words[0].Offset;
                break;
            }
            if (!!firstWordOffset && firstWordOffset < baseOffset) {
                const offset = baseOffset - firstWordOffset;
                for (const details of this.privDetailedSpeechPhrase.NBest){
                    if (!!details.Words) for (const word of details.Words)word.Offset += offset;
                    if (!!details.DisplayWords) for (const word of details.DisplayWords)word.Offset += offset;
                }
            }
        }
        return JSON.stringify(this.privDetailedSpeechPhrase);
    }
    get RecognitionStatus() {
        return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
        return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
        return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
        return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privDetailedSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get Text() {
        if (!!this.privDetailedSpeechPhrase.NBest && this.privDetailedSpeechPhrase.NBest[0]) return this.privDetailedSpeechPhrase.NBest[0].Display || this.privDetailedSpeechPhrase.NBest[0].DisplayText;
        return this.privDetailedSpeechPhrase.DisplayText;
    }
    get SpeakerId() {
        return this.privDetailedSpeechPhrase.SpeakerId;
    }
}
module.exports.DetailedSpeechPhrase = $622712a7699a4ed9$var$DetailedSpeechPhrase;

});

parcelRegister("7DZiw", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleSpeechPhrase = void 0;

var $imJeu = parcelRequire("imJeu");
class $590bb95f91a16551$var$SimpleSpeechPhrase {
    constructor(json){
        this.privSimpleSpeechPhrase = JSON.parse(json);
        this.privSimpleSpeechPhrase.RecognitionStatus = $imJeu.RecognitionStatus[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(json) {
        return new $590bb95f91a16551$var$SimpleSpeechPhrase(json);
    }
    get RecognitionStatus() {
        return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
        return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
        return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
        return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
        return this.privSimpleSpeechPhrase.PrimaryLanguage === undefined ? undefined : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
        return this.privSimpleSpeechPhrase.SpeakerId;
    }
}
module.exports.SimpleSpeechPhrase = $590bb95f91a16551$var$SimpleSpeechPhrase;

});

parcelRegister("18tcP", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AddedLmIntent = void 0;
/**
 * @class AddedLmIntent
 */ // eslint-disable-next-line max-classes-per-file
class $0d3d3180d5a63496$var$AddedLmIntent {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param modelImpl - The model.
     * @param intentName - The intent name.
     */ constructor(modelImpl, intentName){
        this.modelImpl = modelImpl;
        this.intentName = intentName;
    }
}
module.exports.AddedLmIntent = $0d3d3180d5a63496$var$AddedLmIntent;

});

parcelRegister("1LHbr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentServiceRecognizer = void 0;

var $3wpON = parcelRequire("3wpON");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
// eslint-disable-next-line max-classes-per-file
class $149bad9a08428e12$var$IntentServiceRecognizer extends $imJeu.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.privIntentRecognizer = recognizer;
        this.privIntentDataSent = false;
    }
    setIntents(addedIntents, umbrellaIntent) {
        this.privAddedLmIntents = addedIntents;
        this.privUmbrellaIntent = umbrellaIntent;
        this.privIntentDataSent = true;
    }
    processTypeSpecificMessages(connectionMessage) {
        let result;
        let ev;
        let processed = false;
        const resultProps = new $hVlip.PropertyCollection();
        if (connectionMessage.messageType === $3wpON.MessageType.Text) resultProps.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "speech.hypothesis":
                const speechHypothesis = $imJeu.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                result = new $hVlip.IntentRecognitionResult(undefined, this.privRequestSession.requestId, $hVlip.ResultReason.RecognizingIntent, speechHypothesis.Text, speechHypothesis.Duration, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, speechHypothesis.Language, speechHypothesis.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(result.offset);
                ev = new $hVlip.IntentRecognitionEventArgs(result, speechHypothesis.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                if (!!this.privIntentRecognizer.recognizing) try {
                    this.privIntentRecognizer.recognizing(this.privIntentRecognizer, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.phrase":
                const simple = $imJeu.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                result = new $hVlip.IntentRecognitionResult(undefined, this.privRequestSession.requestId, $imJeu.EnumTranslation.implTranslateRecognitionResult(simple.RecognitionStatus), simple.DisplayText, simple.Duration, simple.Offset + this.privRequestSession.currentTurnAudioOffset, simple.Language, simple.LanguageDetectionConfidence, undefined, connectionMessage.textBody, resultProps);
                ev = new $hVlip.IntentRecognitionEventArgs(result, result.offset, this.privRequestSession.sessionId);
                const sendEvent = ()=>{
                    if (!!this.privIntentRecognizer.recognized) try {
                        this.privIntentRecognizer.recognized(this.privIntentRecognizer, ev);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                    // report result to promise.
                    if (!!this.privSuccessCallback) {
                        try {
                            this.privSuccessCallback(result);
                        } catch (e) {
                            if (!!this.privErrorCallback) this.privErrorCallback(e);
                        }
                        // Only invoke the call back once.
                        // and if it's successful don't invoke the
                        // error after that.
                        this.privSuccessCallback = undefined;
                        this.privErrorCallback = undefined;
                    }
                };
                // If intent data was sent, the terminal result for this recognizer is an intent being found.
                // If no intent data was sent, the terminal event is speech recognition being successful.
                if (false === this.privIntentDataSent || $hVlip.ResultReason.NoMatch === ev.result.reason) {
                    // Advance the buffers.
                    this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                    sendEvent();
                } else // Squirrel away the args, when the response event arrives it will build upon them
                // and then return
                this.privPendingIntentArgs = ev;
                processed = true;
                break;
            case "response":
                // Response from LUIS
                ev = this.privPendingIntentArgs;
                this.privPendingIntentArgs = undefined;
                if (undefined === ev) {
                    if ("" === connectionMessage.textBody) // This condition happens if there is nothing but silence in the
                    // audio sent to the service.
                    return;
                    // Odd... Not sure this can happen
                    ev = new $hVlip.IntentRecognitionEventArgs(new $hVlip.IntentRecognitionResult(), 0, this.privRequestSession.sessionId);
                }
                const intentResponse = $imJeu.IntentResponse.fromJSON(connectionMessage.textBody);
                // If LUIS didn't return anything, send the existing event, else
                // modify it to show the match.
                // See if the intent found is in the list of intents asked for.
                if (null !== intentResponse && !!intentResponse.topScoringIntent && !!intentResponse.topScoringIntent.intent) {
                    let addedIntent = this.privAddedLmIntents[intentResponse.topScoringIntent.intent];
                    if (this.privUmbrellaIntent !== undefined) addedIntent = this.privUmbrellaIntent;
                    if (!!addedIntent) {
                        const intentId = addedIntent === undefined || addedIntent.intentName === undefined ? intentResponse.topScoringIntent.intent : addedIntent.intentName;
                        let reason = ev.result.reason;
                        if (undefined !== intentId) reason = $hVlip.ResultReason.RecognizedIntent;
                        // make sure, properties is set.
                        const properties = undefined !== ev.result.properties ? ev.result.properties : new $hVlip.PropertyCollection();
                        properties.setProperty($hVlip.PropertyId.LanguageUnderstandingServiceResponse_JsonResult, connectionMessage.textBody);
                        ev = new $hVlip.IntentRecognitionEventArgs(new $hVlip.IntentRecognitionResult(intentId, ev.result.resultId, reason, ev.result.text, ev.result.duration, ev.result.offset, undefined, undefined, ev.result.errorDetails, ev.result.json, properties), ev.offset, ev.sessionId);
                    }
                }
                this.privRequestSession.onPhraseRecognized(ev.offset + ev.result.duration);
                if (!!this.privIntentRecognizer.recognized) try {
                    this.privIntentRecognizer.recognized(this.privIntentRecognizer, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                // report result to promise.
                if (!!this.privSuccessCallback) {
                    try {
                        this.privSuccessCallback(ev.result);
                    } catch (e) {
                        if (!!this.privErrorCallback) this.privErrorCallback(e);
                    }
                    // Only invoke the call back once.
                    // and if it's successful don't invoke the
                    // error after that.
                    this.privSuccessCallback = undefined;
                    this.privErrorCallback = undefined;
                }
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new $3wpON.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $hVlip.PropertyCollection();
        properties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[errorCode]);
        if (!!this.privIntentRecognizer.canceled) {
            const cancelEvent = new $hVlip.IntentRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, undefined, sessionId);
            try {
                this.privIntentRecognizer.canceled(this.privIntentRecognizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
        if (!!this.privSuccessCallback) {
            const result = new $hVlip.IntentRecognitionResult(undefined, requestId, $hVlip.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
            try {
                this.privSuccessCallback(result);
                this.privSuccessCallback = undefined;
            /* eslint-disable no-empty */ } catch  {}
        }
    }
}
module.exports.IntentServiceRecognizer = $149bad9a08428e12$var$IntentServiceRecognizer;

});

parcelRegister("kW06q", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntentResponse = void 0;
class $f3d94dd455ce73d4$var$IntentResponse {
    constructor(json){
        if (json === "") this.privIntentResponse = {};
        else this.privIntentResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $f3d94dd455ce73d4$var$IntentResponse(json);
    }
    get query() {
        return this.privIntentResponse.query;
    }
    get topScoringIntent() {
        return this.privIntentResponse.topScoringIntent;
    }
    get entities() {
        return this.privIntentResponse.entities;
    }
}
module.exports.IntentResponse = $f3d94dd455ce73d4$var$IntentResponse;

});

parcelRegister("a5z6q", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
/* eslint-disable max-classes-per-file */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dys7m", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RequestSession = void 0;

var $3wpON = parcelRequire("3wpON");

var $5RXpn = parcelRequire("5RXpn");

var $1tWQv = parcelRequire("1tWQv");
class $9de442ec5ec8e448$var$RequestSession {
    constructor(audioSourceId){
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privIsAudioNodeDetached = false;
        this.privIsRecognizing = false;
        this.privIsSpeechEnded = false;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privHypothesisReceived = false;
        this.privBytesSent = 0;
        this.privRecognitionBytesSent = 0;
        this.privRecogNumber = 0;
        this.privInTurn = false;
        this.privConnectionAttempts = 0;
        this.privAudioSourceId = audioSourceId;
        this.privRequestId = $3wpON.createNoDashGuid();
        this.privAudioNodeId = $3wpON.createNoDashGuid();
        this.privTurnDeferral = new $3wpON.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get audioNodeId() {
        return this.privAudioNodeId;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSpeechEnded() {
        return this.privIsSpeechEnded;
    }
    get isRecognizing() {
        return this.privIsRecognizing;
    }
    get currentTurnAudioOffset() {
        return this.privTurnStartAudioOffset;
    }
    get recogNumber() {
        return this.privRecogNumber;
    }
    get numConnectionAttempts() {
        return this.privConnectionAttempts;
    }
    // The number of bytes sent for the current connection.
    // Counter is reset to 0 each time a connection is established.
    get bytesSent() {
        return this.privBytesSent;
    }
    // The number of bytes sent for the current recognition.
    // Counter is reset to 0 each time recognition is started.
    get recognitionBytesSent() {
        return this.privRecognitionBytesSent;
    }
    listenForServiceTelemetry(eventSource) {
        if (!!this.privServiceTelemetryListener) this.privDetachables.push(eventSource.attachListener(this.privServiceTelemetryListener));
    }
    startNewRecognition() {
        this.privRecognitionBytesSent = 0;
        this.privIsSpeechEnded = false;
        this.privIsRecognizing = true;
        this.privTurnStartAudioOffset = 0;
        this.privLastRecoOffset = 0;
        this.privRecogNumber++;
        this.privServiceTelemetryListener = new $1tWQv.ServiceTelemetryListener(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId);
        this.onEvent(new $5RXpn.RecognitionTriggeredEvent(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    async onAudioSourceAttachCompleted(audioNode, isError) {
        this.privAudioNode = audioNode;
        this.privIsAudioNodeDetached = false;
        if (isError) await this.onComplete();
        else this.onEvent(new $5RXpn.ListeningStartedEvent(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
    }
    onPreConnectionStart(authFetchEventId, connectionId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.privSessionId = connectionId;
        this.onEvent(new $5RXpn.ConnectingToServiceEvent(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
    }
    async onAuthCompleted(isError) {
        if (isError) await this.onComplete();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async onConnectionEstablishCompleted(statusCode, reason) {
        if (statusCode === 200) {
            this.onEvent(new $5RXpn.RecognitionStartedEvent(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId));
            if (!!this.privAudioNode) this.privAudioNode.replay();
            this.privTurnStartAudioOffset = this.privLastRecoOffset;
            this.privBytesSent = 0;
            return;
        } else if (statusCode === 403) await this.onComplete();
    }
    async onServiceTurnEndResponse(continuousRecognition) {
        this.privTurnDeferral.resolve();
        if (!continuousRecognition || this.isSpeechEnded) {
            await this.onComplete();
            this.privInTurn = false;
        } else {
            // Start a new request set.
            this.privTurnStartAudioOffset = this.privLastRecoOffset;
            this.privAudioNode.replay();
        }
    }
    onSpeechContext() {
        this.privRequestId = $3wpON.createNoDashGuid();
    }
    onServiceTurnStartResponse() {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new $3wpON.Deferred();
    }
    onHypothesis(offset) {
        if (!this.privHypothesisReceived) {
            this.privHypothesisReceived = true;
            this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(offset));
        }
    }
    onPhraseRecognized(offset) {
        this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(offset));
        this.onServiceRecognized(offset);
    }
    onServiceRecognized(offset) {
        this.privLastRecoOffset = offset;
        this.privHypothesisReceived = false;
        this.privAudioNode.shrinkBuffers(offset);
        this.privConnectionAttempts = 0;
    }
    onAudioSent(bytesSent) {
        this.privBytesSent += bytesSent;
        this.privRecognitionBytesSent += bytesSent;
    }
    onRetryConnection() {
        this.privConnectionAttempts++;
    }
    async dispose() {
        if (!this.privIsDisposed) {
            // we should have completed by now. If we did not its an unknown error.
            this.privIsDisposed = true;
            for (const detachable of this.privDetachables)await detachable.detach();
            if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.dispose();
            this.privIsRecognizing = false;
        }
    }
    getTelemetry() {
        if (this.privServiceTelemetryListener.hasTelemetry) return this.privServiceTelemetryListener.getTelemetry();
        else return null;
    }
    async onStopRecognizing() {
        await this.onComplete();
    }
    // Should be called with the audioNode for this session has indicated that it is out of speech.
    onSpeechEnded() {
        this.privIsSpeechEnded = true;
    }
    onEvent(event) {
        if (!!this.privServiceTelemetryListener) this.privServiceTelemetryListener.onEvent(event);
        $3wpON.Events.instance.onEvent(event);
    }
    async onComplete() {
        if (!!this.privIsRecognizing) {
            this.privIsRecognizing = false;
            await this.detachAudioNode();
        }
    }
    async detachAudioNode() {
        if (!this.privIsAudioNodeDetached) {
            this.privIsAudioNodeDetached = true;
            if (this.privAudioNode) await this.privAudioNode.detach();
        }
    }
}
module.exports.RequestSession = $9de442ec5ec8e448$var$RequestSession;

});
parcelRegister("1tWQv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceTelemetryListener = void 0;

var $3wpON = parcelRequire("3wpON");

var $5RXpn = parcelRequire("5RXpn");
class $11462573eefea426$var$ServiceTelemetryListener {
    constructor(requestId, audioSourceId, audioNodeId){
        this.privIsDisposed = false;
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privRequestId = requestId;
        this.privAudioSourceId = audioSourceId;
        this.privAudioNodeId = audioNodeId;
        this.privReceivedMessages = {};
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
    }
    phraseReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privPhraseLatencies.push(Date.now() - audioReceivedTime);
    }
    hypothesisReceived(audioReceivedTime) {
        if (audioReceivedTime > 0) this.privHypothesisLatencies.push(Date.now() - audioReceivedTime);
    }
    onEvent(e) {
        if (this.privIsDisposed) return;
        if (e instanceof $5RXpn.RecognitionTriggeredEvent && e.requestId === this.privRequestId) this.privListeningTriggerMetric = {
            End: e.eventTime,
            Name: "ListeningTrigger",
            Start: e.eventTime
        };
        if (e instanceof $3wpON.AudioStreamNodeAttachingEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof $3wpON.AudioStreamNodeAttachedEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) this.privMicStartTime = e.eventTime;
        if (e instanceof $3wpON.AudioSourceErrorEvent && e.audioSourceId === this.privAudioSourceId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $3wpON.AudioStreamNodeErrorEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Error: e.error,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $3wpON.AudioStreamNodeDetachedEvent && e.audioSourceId === this.privAudioSourceId && e.audioNodeId === this.privAudioNodeId) {
            if (!this.privMicMetric) this.privMicMetric = {
                End: e.eventTime,
                Name: "Microphone",
                Start: this.privMicStartTime
            };
        }
        if (e instanceof $5RXpn.ConnectingToServiceEvent && e.requestId === this.privRequestId) this.privConnectionId = e.sessionId;
        if (e instanceof $3wpON.ConnectionStartEvent && e.connectionId === this.privConnectionId) this.privConnectionStartTime = e.eventTime;
        if (e instanceof $3wpON.ConnectionEstablishedEvent && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof $3wpON.ConnectionEstablishErrorEvent && e.connectionId === this.privConnectionId) {
            if (!this.privConnectionEstablishMetric) this.privConnectionEstablishMetric = {
                End: e.eventTime,
                Error: this.getConnectionError(e.statusCode),
                Id: this.privConnectionId,
                Name: "Connection",
                Start: this.privConnectionStartTime
            };
        }
        if (e instanceof $3wpON.ConnectionMessageReceivedEvent && e.connectionId === this.privConnectionId) {
            if (e.message && e.message.headers && e.message.headers.path) {
                if (!this.privReceivedMessages[e.message.headers.path]) this.privReceivedMessages[e.message.headers.path] = new Array();
                const maxMessagesToSend = 50;
                if (this.privReceivedMessages[e.message.headers.path].length < maxMessagesToSend) this.privReceivedMessages[e.message.headers.path].push(e.networkReceivedTime);
            }
        }
    }
    getTelemetry() {
        const metrics = new Array();
        if (this.privListeningTriggerMetric) metrics.push(this.privListeningTriggerMetric);
        if (this.privMicMetric) metrics.push(this.privMicMetric);
        if (this.privConnectionEstablishMetric) metrics.push(this.privConnectionEstablishMetric);
        if (this.privPhraseLatencies.length > 0) metrics.push({
            PhraseLatencyMs: this.privPhraseLatencies
        });
        if (this.privHypothesisLatencies.length > 0) metrics.push({
            FirstHypothesisLatencyMs: this.privHypothesisLatencies
        });
        const telemetry = {
            Metrics: metrics,
            ReceivedMessages: this.privReceivedMessages
        };
        const json = JSON.stringify(telemetry);
        // We dont want to send the same telemetry again. So clean those out.
        this.privReceivedMessages = {};
        this.privListeningTriggerMetric = null;
        this.privMicMetric = null;
        this.privConnectionEstablishMetric = null;
        this.privPhraseLatencies = [];
        this.privHypothesisLatencies = [];
        return json;
    }
    // Determines if there are any telemetry events to send to the service.
    get hasTelemetry() {
        return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
    }
    dispose() {
        this.privIsDisposed = true;
    }
    getConnectionError(statusCode) {
        /*
        -- Websocket status codes --
        NormalClosure = 1000,
        EndpointUnavailable = 1001,
        ProtocolError = 1002,
        InvalidMessageType = 1003,
        Empty = 1005,
        InvalidPayloadData = 1007,
        PolicyViolation = 1008,
        MessageTooBig = 1009,
        MandatoryExtension = 1010,
        InternalServerError = 1011
        */ switch(statusCode){
            case 400:
            case 1002:
            case 1003:
            case 1005:
            case 1007:
            case 1008:
            case 1009:
                return "BadRequest";
            case 401:
                return "Unauthorized";
            case 403:
                return "Forbidden";
            case 503:
            case 1001:
                return "ServerUnavailable";
            case 500:
            case 1011:
                return "ServerError";
            case 408:
            case 504:
                return "Timeout";
            default:
                return "statuscode:" + statusCode.toString();
        }
    }
}
module.exports.ServiceTelemetryListener = $11462573eefea426$var$ServiceTelemetryListener;

});


parcelRegister("2b9RH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechContext = void 0;
/**
 * Represents the JSON used in the speech.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $196442e1a7849d11$var$SpeechContext {
    constructor(dynamicGrammar){
        this.privContext = {};
        this.privDynamicGrammar = dynamicGrammar;
    }
    /**
     * Gets a section of the speech.context object.
     * @param sectionName Name of the section to get.
     * @return string or Context JSON serializable object that represents the value.
     */ getSection(sectionName) {
        return this.privContext[sectionName] || {};
    }
    /**
     * Adds a section to the speech.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * @Internal
     * This is only used by pronunciation assessment config.
     * Do not use externally, object returned will change without warning or notice.
     */ setPronunciationAssessmentParams(params, contentAssessmentTopic, isSpeakerDiarizationEnabled = false) {
        if (this.privContext.phraseDetection === undefined) this.privContext.phraseDetection = {
            enrichment: {
                pronunciationAssessment: {}
            }
        };
        if (this.privContext.phraseDetection.enrichment === undefined) this.privContext.phraseDetection.enrichment = {
            pronunciationAssessment: {}
        };
        this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(params);
        if (isSpeakerDiarizationEnabled) this.privContext.phraseDetection.mode = "Conversation";
        this.setWordLevelTimings();
        this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment");
        if (this.privContext.phraseOutput.detailed.options.indexOf("SNR") === -1) this.privContext.phraseOutput.detailed.options.push("SNR");
        if (!!contentAssessmentTopic) {
            this.privContext.phraseDetection.enrichment.contentAssessment = {
                topic: contentAssessmentTopic
            };
            this.privContext.phraseOutput.detailed.options.push("ContentAssessment");
        }
    }
    setDetailedOutputFormat() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = "Detailed";
    }
    setWordLevelTimings() {
        if (this.privContext.phraseOutput === undefined) this.privContext.phraseOutput = {
            detailed: {
                options: []
            },
            format: {}
        };
        if (this.privContext.phraseOutput.detailed === undefined) this.privContext.phraseOutput.detailed = {
            options: []
        };
        this.privContext.phraseOutput.format = "Detailed";
        if (this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1) this.privContext.phraseOutput.detailed.options.push("WordTimings");
    }
    setSpeakerDiarizationAudioOffsetMs(audioOffsetMs) {
        this.privContext.phraseDetection.speakerDiarization.audioOffsetMs = audioOffsetMs;
    }
    toJSON() {
        const dgi = this.privDynamicGrammar.generateGrammarObject();
        this.setSection("dgi", dgi);
        const ret = JSON.stringify(this.privContext);
        return ret;
    }
}
module.exports.SpeechContext = $196442e1a7849d11$var$SpeechContext;

});

parcelRegister("8rWDZ", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DynamicGrammarBuilder = void 0;
/**
 * Responsible for building the object to be sent to the speech service to support dynamic grammars.
 * @class DynamicGrammarBuilder
 */ class $626e55d0354444a1$var$DynamicGrammarBuilder {
    // Adds one more reference phrases to the dynamic grammar to send.
    // All added phrases are generic phrases.
    addPhrase(phrase) {
        if (!this.privPhrases) this.privPhrases = [];
        if (phrase instanceof Array) this.privPhrases = this.privPhrases.concat(phrase);
        else this.privPhrases.push(phrase);
    }
    // Clears all phrases stored in the current object.
    clearPhrases() {
        this.privPhrases = undefined;
    }
    // Adds one or more reference grammars to the current grammar.
    addReferenceGrammar(grammar) {
        if (!this.privGrammars) this.privGrammars = [];
        if (grammar instanceof Array) this.privGrammars = this.privGrammars.concat(grammar);
        else this.privGrammars.push(grammar);
    }
    // clears all grammars stored on the recognizer.
    clearGrammars() {
        this.privGrammars = undefined;
    }
    // Generates an object that represents the dynamic grammar used by the Speech Service.
    // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
    // of a DynamicGrammarBuilder
    generateGrammarObject() {
        if (this.privGrammars === undefined && this.privPhrases === undefined) return undefined;
        const retObj = {};
        retObj.ReferenceGrammars = this.privGrammars;
        if (undefined !== this.privPhrases && 0 !== this.privPhrases.length) {
            const retPhrases = [];
            this.privPhrases.forEach((value)=>{
                retPhrases.push({
                    Text: value
                });
            });
            retObj.Groups = [
                {
                    Type: "Generic",
                    Items: retPhrases
                }
            ];
        }
        return retObj;
    }
}
module.exports.DynamicGrammarBuilder = $626e55d0354444a1$var$DynamicGrammarBuilder;

});

parcelRegister("7C08p", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ek6Kx", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceAdapter = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $9Viyf = parcelRequire("9Viyf");

var $3wpON = parcelRequire("3wpON");

var $iZxsX = parcelRequire("iZxsX");

var $hVlip = parcelRequire("hVlip");

var $lePx9 = parcelRequire("lePx9");

var $imJeu = parcelRequire("imJeu");

var $h3qnH = parcelRequire("h3qnH");

var $l6AmD = parcelRequire("l6AmD");
class $a6d82b443562c4e8$var$DialogServiceAdapter extends $imJeu.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector){
        super(authentication, connectionFactory, audioSource, recognizerConfig, dialogServiceConnector);
        this.privEvents = new $3wpON.EventSource();
        this.privDialogServiceConnector = dialogServiceConnector;
        this.receiveMessageOverride = ()=>this.receiveDialogMessageOverride();
        this.privTurnStateManager = new $lePx9.DialogServiceTurnStateManager();
        this.recognizeOverride = (recoMode, successCallback, errorCallback)=>this.listenOnce(recoMode, successCallback, errorCallback);
        this.postConnectImplOverride = (connection)=>this.dialogConnectImpl(connection);
        this.configConnectionOverride = (connection)=>this.configConnection(connection);
        this.disconnectOverride = ()=>this.privDisconnect();
        this.privDialogAudioSource = audioSource;
        this.agentConfigSent = false;
        this.privLastResult = null;
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") this.terminateMessageLoop = true;
        });
    }
    async sendMessage(message) {
        const interactionGuid = $3wpON.createGuid();
        const requestId = $3wpON.createNoDashGuid();
        const agentMessage = {
            context: {
                interactionId: interactionGuid
            },
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            messagePayload: JSON.parse(message),
            version: 0.5
        };
        const agentMessageJson = JSON.stringify(agentMessage);
        const connection = await this.fetchConnection();
        await connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "agent", requestId, "application/json", agentMessageJson));
    }
    async privDisconnect() {
        await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.NoError, "Disconnecting");
        this.terminateMessageLoop = true;
        this.agentConfigSent = false;
        return;
    }
    processTypeSpecificMessages(connectionMessage) {
        const resultProps = new $hVlip.PropertyCollection();
        if (connectionMessage.messageType === $3wpON.MessageType.Text) resultProps.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        let result;
        let processed;
        switch(connectionMessage.path.toLowerCase()){
            case "speech.phrase":
                const speechPhrase = $imJeu.SimpleSpeechPhrase.fromJSON(connectionMessage.textBody);
                this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + speechPhrase.Offset + speechPhrase.Duration);
                if (speechPhrase.RecognitionStatus !== $imJeu.RecognitionStatus.TooManyRequests && speechPhrase.RecognitionStatus !== $imJeu.RecognitionStatus.Error) {
                    const args = this.fireEventForResult(speechPhrase, resultProps);
                    this.privLastResult = args.result;
                    if (!!this.privDialogServiceConnector.recognized) try {
                        this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, args);
                    /* eslint-disable no-empty */ } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            case "speech.hypothesis":
                const hypothesis = $imJeu.SpeechHypothesis.fromJSON(connectionMessage.textBody);
                const offset = hypothesis.Offset + this.privRequestSession.currentTurnAudioOffset;
                result = new $hVlip.SpeechRecognitionResult(this.privRequestSession.requestId, $hVlip.ResultReason.RecognizingSpeech, hypothesis.Text, hypothesis.Duration, offset, hypothesis.Language, hypothesis.LanguageDetectionConfidence, undefined, undefined, connectionMessage.textBody, resultProps);
                this.privRequestSession.onHypothesis(offset);
                const ev = new $hVlip.SpeechRecognitionEventArgs(result, hypothesis.Duration, this.privRequestSession.sessionId);
                if (!!this.privDialogServiceConnector.recognizing) try {
                    this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, ev);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "speech.keyword":
                const keyword = $imJeu.SpeechKeyword.fromJSON(connectionMessage.textBody);
                result = new $hVlip.SpeechRecognitionResult(this.privRequestSession.requestId, keyword.Status === "Accepted" ? $hVlip.ResultReason.RecognizedKeyword : $hVlip.ResultReason.NoMatch, keyword.Text, keyword.Duration, keyword.Offset, undefined, undefined, undefined, undefined, connectionMessage.textBody, resultProps);
                if (keyword.Status !== "Accepted") this.privLastResult = result;
                const event = new $hVlip.SpeechRecognitionEventArgs(result, result.duration, result.resultId);
                if (!!this.privDialogServiceConnector.recognized) try {
                    this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, event);
                /* eslint-disable no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                processed = true;
                break;
            case "audio":
                {
                    const audioRequestId = connectionMessage.requestId.toUpperCase();
                    const turn = this.privTurnStateManager.GetTurn(audioRequestId);
                    try {
                        // Empty binary message signals end of stream.
                        if (!connectionMessage.binaryBody) turn.endAudioStream();
                        else turn.audioStream.write(connectionMessage.binaryBody);
                    } catch (error) {
                    // Not going to let errors in the event handler
                    // trip things up.
                    }
                }
                processed = true;
                break;
            case "response":
                this.handleResponseMessage(connectionMessage);
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new $3wpON.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    async cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        this.terminateMessageLoop = true;
        if (!!this.privRequestSession.isRecognizing) await this.privRequestSession.onStopRecognizing();
        if (!!this.privDialogServiceConnector.canceled) {
            const properties = new $hVlip.PropertyCollection();
            properties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[errorCode]);
            const cancelEvent = new $hVlip.SpeechRecognitionCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
            try {
                this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
            if (!!this.privSuccessCallback) {
                const result = new $hVlip.SpeechRecognitionResult(undefined, $hVlip.ResultReason.Canceled, undefined, undefined, undefined, undefined, undefined, undefined, error, undefined, properties);
                try {
                    this.privSuccessCallback(result);
                    this.privSuccessCallback = undefined;
                /* eslint-disable no-empty */ } catch  {}
            }
        }
    }
    async listenOnce(recoMode, successCallback, errorCallback) {
        this.privRecognizerConfig.recognitionMode = recoMode;
        this.privSuccessCallback = successCallback;
        this.privErrorCallback = errorCallback;
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events);
        this.privRecognizerConfig.parameters.setProperty($hVlip.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        const preAudioPromise = this.sendPreAudioMessages();
        const node = await this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId);
        const format = await this.privDialogAudioSource.format;
        const deviceInfo = await this.privDialogAudioSource.deviceInfo;
        const audioNode = new $gvLMV.ReplayableAudioNode(node, format.avgBytesPerSec);
        await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
            source: deviceInfo
        };
        try {
            await conPromise;
            await preAudioPromise;
        } catch (error) {
            await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.ConnectionFailure, error);
            return Promise.resolve();
        }
        const sessionStartEventArgs = new $hVlip.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        const audioSendPromise = this.sendAudio(audioNode);
        // /* eslint-disable no-empty */
        audioSendPromise.then(()=>{}, async (error)=>{
            await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.RuntimeError, error);
        });
    }
    // Establishes a websocket connection to the end point.
    dialogConnectImpl(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    }
    receiveDialogMessageOverride() {
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        const communicationCustodian = new $3wpON.Deferred();
        const loop = async ()=>{
            try {
                const isDisposed = this.isDisposed();
                const terminateMessageLoop = !this.isDisposed() && this.terminateMessageLoop;
                if (isDisposed || terminateMessageLoop) {
                    // We're done.
                    communicationCustodian.resolve(undefined);
                    return;
                }
                const connection = await this.fetchConnection();
                const message = await connection.read();
                if (!message) return loop();
                const connectionMessage = $l6AmD.SpeechConnectionMessage.fromConnectionMessage(message);
                switch(connectionMessage.path.toLowerCase()){
                    case "turn.start":
                        {
                            const turnRequestId = connectionMessage.requestId.toUpperCase();
                            const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            // turn started by the service
                            if (turnRequestId !== audioSessionReqId) this.privTurnStateManager.StartTurn(turnRequestId);
                            else this.privRequestSession.onServiceTurnStartResponse();
                        }
                        break;
                    case "speech.startdetected":
                        const speechStartDetected = $imJeu.SpeechDetected.fromJSON(connectionMessage.textBody);
                        const speechStartEventArgs = new $hVlip.RecognitionEventArgs(speechStartDetected.Offset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechStartDetected) this.privRecognizer.speechStartDetected(this.privRecognizer, speechStartEventArgs);
                        break;
                    case "speech.enddetected":
                        let json;
                        if (connectionMessage.textBody.length > 0) json = connectionMessage.textBody;
                        else // If the request was empty, the JSON returned is empty.
                        json = "{ Offset: 0 }";
                        const speechStopDetected = $imJeu.SpeechDetected.fromJSON(json);
                        this.privRequestSession.onServiceRecognized(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset);
                        const speechStopEventArgs = new $hVlip.RecognitionEventArgs(speechStopDetected.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
                        if (!!this.privRecognizer.speechEndDetected) this.privRecognizer.speechEndDetected(this.privRecognizer, speechStopEventArgs);
                        break;
                    case "turn.end":
                        {
                            const turnEndRequestId = connectionMessage.requestId.toUpperCase();
                            const audioSessionReqId = this.privRequestSession.requestId.toUpperCase();
                            // turn started by the service
                            if (turnEndRequestId !== audioSessionReqId) this.privTurnStateManager.CompleteTurn(turnEndRequestId);
                            else {
                                // Audio session turn
                                const sessionStopEventArgs = new $hVlip.SessionEventArgs(this.privRequestSession.sessionId);
                                await this.privRequestSession.onServiceTurnEndResponse(false);
                                if (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                                    if (!!this.privRecognizer.sessionStopped) this.privRecognizer.sessionStopped(this.privRecognizer, sessionStopEventArgs);
                                }
                                // report result to promise.
                                if (!!this.privSuccessCallback && this.privLastResult) {
                                    try {
                                        this.privSuccessCallback(this.privLastResult);
                                        this.privLastResult = null;
                                    } catch (e) {
                                        if (!!this.privErrorCallback) this.privErrorCallback(e);
                                    }
                                    // Only invoke the call back once.
                                    // and if it's successful don't invoke the
                                    // error after that.
                                    this.privSuccessCallback = undefined;
                                    this.privErrorCallback = undefined;
                                }
                            }
                        }
                        break;
                    default:
                        try {
                            const processed = await this.processTypeSpecificMessages(connectionMessage);
                            if (!processed) {
                                if (!!this.serviceEvents) this.serviceEvents.onEvent(new $3wpON.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                            }
                        } catch (e) {
                        //
                        }
                }
                const ret = loop();
                return ret;
            } catch (error) {
                this.terminateMessageLoop = true;
                communicationCustodian.resolve();
            }
        };
        loop().catch((reason)=>{
            $3wpON.Events.instance.onEvent(new $3wpON.BackgroundEvent(reason));
        });
        return communicationCustodian.promise;
    }
    async startMessageLoop() {
        this.terminateMessageLoop = false;
        try {
            await this.receiveDialogMessageOverride();
        } catch (error) {
            await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.RuntimeError, error);
        }
        return Promise.resolve();
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configConnection(connection) {
        if (this.terminateMessageLoop) {
            this.terminateMessageLoop = false;
            return Promise.reject("Connection to service terminated.");
        }
        await this.sendSpeechServiceConfig(connection, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize());
        await this.sendAgentConfig(connection);
        return connection;
    }
    async sendPreAudioMessages() {
        const connection = await this.fetchConnection();
        this.addKeywordContextData();
        await this.sendSpeechContext(connection, true);
        await this.sendAgentContext(connection);
        await this.sendWaveHeader(connection);
    }
    sendAgentConfig(connection) {
        if (this.agentConfig && !this.agentConfigSent) {
            if (this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.Conversation_DialogType) === $hVlip.DialogServiceConfig.DialogTypes.CustomCommands) {
                const config = this.agentConfig.get();
                config.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage, "en-us");
                this.agentConfig.set(config);
            }
            this.onEvent(new $9Viyf.SendingAgentContextMessageEvent(this.agentConfig));
            const agentConfigJson = this.agentConfig.toJsonString();
            // guard against sending this multiple times on one connection
            this.agentConfigSent = true;
            return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "agent.config", this.privRequestSession.requestId, "application/json", agentConfigJson));
        }
        return;
    }
    sendAgentContext(connection) {
        const guid = $3wpON.createGuid();
        const speechActivityTemplate = this.privDialogServiceConnector.properties.getProperty($hVlip.PropertyId.Conversation_Speech_Activity_Template);
        const agentContext = {
            channelData: "",
            context: {
                interactionId: guid
            },
            messagePayload: speechActivityTemplate,
            version: 0.5
        };
        const agentContextJson = JSON.stringify(agentContext);
        return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", agentContextJson));
    }
    fireEventForResult(serviceResult, properties) {
        const resultReason = $imJeu.EnumTranslation.implTranslateRecognitionResult(serviceResult.RecognitionStatus);
        const offset = serviceResult.Offset + this.privRequestSession.currentTurnAudioOffset;
        const result = new $hVlip.SpeechRecognitionResult(this.privRequestSession.requestId, resultReason, serviceResult.DisplayText, serviceResult.Duration, offset, serviceResult.Language, serviceResult.LanguageDetectionConfidence, undefined, undefined, JSON.stringify(serviceResult), properties);
        const ev = new $hVlip.SpeechRecognitionEventArgs(result, offset, this.privRequestSession.sessionId);
        return ev;
    }
    handleResponseMessage(responseMessage) {
        // "response" messages can contain either "message" (activity) or "MessageStatus" data. Fire the appropriate
        // event according to the message type that's specified.
        const responsePayload = JSON.parse(responseMessage.textBody);
        switch(responsePayload.messageType.toLowerCase()){
            case "message":
                const responseRequestId = responseMessage.requestId.toUpperCase();
                const activityPayload = $h3qnH.ActivityPayloadResponse.fromJSON(responseMessage.textBody);
                const turn = this.privTurnStateManager.GetTurn(responseRequestId);
                // update the conversation Id
                if (activityPayload.conversationId) {
                    const updateAgentConfig = this.agentConfig.get();
                    updateAgentConfig.botInfo.conversationId = activityPayload.conversationId;
                    this.agentConfig.set(updateAgentConfig);
                }
                const pullAudioOutputStream = turn.processActivityPayload(activityPayload, $iZxsX.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_SynthOutputFormat, undefined)));
                const activity = new $hVlip.ActivityReceivedEventArgs(activityPayload.messagePayload, pullAudioOutputStream);
                if (!!this.privDialogServiceConnector.activityReceived) try {
                    this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, activity);
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            case "messagestatus":
                if (!!this.privDialogServiceConnector.turnStatusReceived) try {
                    this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new $hVlip.TurnStatusReceivedEventArgs(responseMessage.textBody));
                /* eslint-disable-next-line no-empty */ } catch (error) {
                // Not going to let errors in the event handler
                // trip things up.
                }
                break;
            default:
                $3wpON.Events.instance.onEvent(new $3wpON.BackgroundEvent(`Unexpected response of type ${responsePayload.messageType}. Ignoring.`));
                break;
        }
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $3wpON.Events.instance.onEvent(event);
    }
    addKeywordContextData() {
        const keywordPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
        if (keywordPropertyValue === undefined) return;
        const keywordOffsetPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets");
        const keywordDurationPropertyValue = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations");
        const keywords = keywordPropertyValue.split(";");
        const keywordOffsets = keywordOffsetPropertyValue === undefined ? [] : keywordOffsetPropertyValue.split(";");
        const keywordDurations = keywordDurationPropertyValue === undefined ? [] : keywordDurationPropertyValue.split(";");
        const keywordDefinitionArray = [];
        for(let i = 0; i < keywords.length; i++){
            const definition = {};
            definition.text = keywords[i];
            if (i < keywordOffsets.length) definition.offset = Number(keywordOffsets[i]);
            if (i < keywordDurations.length) definition.duration = Number(keywordDurations[i]);
            keywordDefinitionArray.push(definition);
        }
        this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword");
        this.speechContext.setSection("keywordDetection", [
            {
                clientDetectedKeywords: keywordDefinitionArray,
                onReject: {
                    action: "EndOfTurn"
                },
                type: "startTrigger"
            }
        ]);
    }
}
module.exports.DialogServiceAdapter = $a6d82b443562c4e8$var$DialogServiceAdapter;

});
parcelRegister("lePx9", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnStateManager = void 0;

var $6tpyr = parcelRequire("6tpyr");

var $2T6go = parcelRequire("2T6go");
class $f762e14d8c2a7ab1$var$DialogServiceTurnStateManager {
    constructor(){
        this.privTurnMap = new Map();
        return;
    }
    StartTurn(id) {
        if (this.privTurnMap.has(id)) throw new $6tpyr.InvalidOperationError("Service error: There is already a turn with id:" + id);
        const turnState = new $2T6go.DialogServiceTurnState(this, id);
        this.privTurnMap.set(id, turnState);
        return this.privTurnMap.get(id);
    }
    GetTurn(id) {
        return this.privTurnMap.get(id);
    }
    CompleteTurn(id) {
        if (!this.privTurnMap.has(id)) throw new $6tpyr.InvalidOperationError("Service error: Received turn end for an unknown turn id:" + id);
        const turnState = this.privTurnMap.get(id);
        turnState.complete();
        this.privTurnMap.delete(id);
        return turnState;
    }
}
module.exports.DialogServiceTurnStateManager = $f762e14d8c2a7ab1$var$DialogServiceTurnStateManager;

});
parcelRegister("2T6go", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogServiceTurnState = void 0;

var $iZxsX = parcelRequire("iZxsX");

var $9QXyd = parcelRequire("9QXyd");

var $h3qnH = parcelRequire("h3qnH");
class $21a5939e87df979a$var$DialogServiceTurnState {
    constructor(manager, requestId){
        this.privRequestId = requestId;
        this.privIsCompleted = false;
        this.privAudioStream = null;
        this.privTurnManager = manager;
        this.resetTurnEndTimeout();
    }
    get audioStream() {
        // Called when is needed to stream.
        this.resetTurnEndTimeout();
        return this.privAudioStream;
    }
    processActivityPayload(payload, audioFormat) {
        if (payload.messageDataStreamType === $h3qnH.MessageDataStreamType.TextToSpeechAudio) {
            this.privAudioStream = $9QXyd.AudioOutputStream.createPullStream();
            this.privAudioStream.format = audioFormat !== undefined ? audioFormat : $iZxsX.AudioOutputFormatImpl.getDefaultOutputFormat();
        }
        return this.privAudioStream;
    }
    endAudioStream() {
        if (this.privAudioStream !== null && !this.privAudioStream.isClosed) this.privAudioStream.close();
    }
    complete() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.endAudioStream();
    }
    resetTurnEndTimeout() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this.privTimeoutToken);
        this.privTimeoutToken = setTimeout(()=>{
            this.privTurnManager.CompleteTurn(this.privRequestId);
            return;
        }, 2000);
    }
}
module.exports.DialogServiceTurnState = $21a5939e87df979a$var$DialogServiceTurnState;

});
parcelRegister("h3qnH", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageDataStreamType = module.exports.ActivityPayloadResponse = void 0;
class $c6a72e40fdff3ab6$var$ActivityPayloadResponse {
    constructor(json){
        this.privActivityResponse = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $c6a72e40fdff3ab6$var$ActivityPayloadResponse(json);
    }
    get conversationId() {
        return this.privActivityResponse.conversationId;
    }
    get messageDataStreamType() {
        return this.privActivityResponse.messageDataStreamType;
    }
    get messagePayload() {
        return this.privActivityResponse.messagePayload;
    }
    get version() {
        return this.privActivityResponse.version;
    }
}
module.exports.ActivityPayloadResponse = $c6a72e40fdff3ab6$var$ActivityPayloadResponse;
var $c6a72e40fdff3ab6$var$MessageDataStreamType;
(function(MessageDataStreamType) {
    MessageDataStreamType[MessageDataStreamType["None"] = 0] = "None";
    MessageDataStreamType[MessageDataStreamType["TextToSpeechAudio"] = 1] = "TextToSpeechAudio";
})($c6a72e40fdff3ab6$var$MessageDataStreamType = module.exports.MessageDataStreamType || (module.exports.MessageDataStreamType = {}));

});




parcelRegister("fq2Pq", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AgentConfig = void 0;
/**
 * Represents the JSON used in the agent.config message sent to the speech service.
 */ class $02e59abf8e58f6a0$var$AgentConfig {
    toJsonString() {
        return JSON.stringify(this.iPrivConfig);
    }
    get() {
        return this.iPrivConfig;
    }
    /**
     * Setter for the agent.config object.
     * @param value a JSON serializable object.
     */ set(value) {
        this.iPrivConfig = value;
    }
}
module.exports.AgentConfig = $02e59abf8e58f6a0$var$AgentConfig;

});

parcelRegister("j5PEd", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $34ePr = parcelRequire("34ePr");
Object.defineProperty(module.exports, "ConversationManager", {
    enumerable: true,
    get: function() {
        return $34ePr.ConversationManager;
    }
});

var $jW1mr = parcelRequire("jW1mr");
Object.defineProperty(module.exports, "ConversationConnectionConfig", {
    enumerable: true,
    get: function() {
        return $jW1mr.ConversationConnectionConfig;
    }
});

var $fMEgY = parcelRequire("fMEgY");
Object.defineProperty(module.exports, "ConversationRecognizerFactory", {
    enumerable: true,
    get: function() {
        return $fMEgY.ConversationRecognizerFactory;
    }
});

var $fVTxP = parcelRequire("fVTxP");
Object.defineProperty(module.exports, "TranscriberRecognizer", {
    enumerable: true,
    get: function() {
        return $fVTxP.TranscriberRecognizer;
    }
});

var $1SOQg = parcelRequire("1SOQg");
Object.defineProperty(module.exports, "ConversationReceivedTranslationEventArgs", {
    enumerable: true,
    get: function() {
        return $1SOQg.ConversationReceivedTranslationEventArgs;
    }
});
Object.defineProperty(module.exports, "LockRoomEventArgs", {
    enumerable: true,
    get: function() {
        return $1SOQg.LockRoomEventArgs;
    }
});
Object.defineProperty(module.exports, "MuteAllEventArgs", {
    enumerable: true,
    get: function() {
        return $1SOQg.MuteAllEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantAttributeEventArgs", {
    enumerable: true,
    get: function() {
        return $1SOQg.ParticipantAttributeEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantEventArgs", {
    enumerable: true,
    get: function() {
        return $1SOQg.ParticipantEventArgs;
    }
});
Object.defineProperty(module.exports, "ParticipantsListEventArgs", {
    enumerable: true,
    get: function() {
        return $1SOQg.ParticipantsListEventArgs;
    }
});

var $jIPhY = parcelRequire("jIPhY");
Object.defineProperty(module.exports, "ConversationTranslatorCommandTypes", {
    enumerable: true,
    get: function() {
        return $jIPhY.ConversationTranslatorCommandTypes;
    }
});
Object.defineProperty(module.exports, "ConversationTranslatorMessageTypes", {
    enumerable: true,
    get: function() {
        return $jIPhY.ConversationTranslatorMessageTypes;
    }
});
Object.defineProperty(module.exports, "InternalParticipants", {
    enumerable: true,
    get: function() {
        return $jIPhY.InternalParticipants;
    }
});

});
parcelRegister("34ePr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationManager = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $jW1mr = parcelRequire("jW1mr");
class $23bd3f7ffd00c5ee$var$ConversationManager {
    constructor(){
        //
        this.privRequestParams = $jW1mr.ConversationConnectionConfig.configParams;
        this.privErrors = $jW1mr.ConversationConnectionConfig.restErrors;
        this.privHost = $jW1mr.ConversationConnectionConfig.host;
        this.privApiVersion = $jW1mr.ConversationConnectionConfig.apiVersion;
        this.privRestPath = $jW1mr.ConversationConnectionConfig.restPath;
        this.privRestAdapter = new $gvLMV.RestMessageAdapter({});
    }
    /**
     * Make a POST request to the Conversation Manager service endpoint to create or join a conversation.
     * @param args
     * @param conversationCode
     * @param callback
     * @param errorCallback
     */ createOrJoin(args, conversationCode, cb, err) {
        try {
            $56OOs.Contracts.throwIfNullOrUndefined(args, "args");
            const languageCode = args.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage, $jW1mr.ConversationConnectionConfig.defaultLanguageCode);
            const nickname = args.getProperty($hVlip.PropertyId.ConversationTranslator_Name, "conversation_host");
            const endpointHost = args.getProperty($hVlip.PropertyId.ConversationTranslator_Host, this.privHost);
            const correlationId = args.getProperty($hVlip.PropertyId.ConversationTranslator_CorrelationId);
            const subscriptionKey = args.getProperty($hVlip.PropertyId.SpeechServiceConnection_Key);
            const subscriptionRegion = args.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region);
            const authToken = args.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
            $56OOs.Contracts.throwIfNullOrWhitespace(languageCode, "languageCode");
            $56OOs.Contracts.throwIfNullOrWhitespace(nickname, "nickname");
            $56OOs.Contracts.throwIfNullOrWhitespace(endpointHost, "endpointHost");
            const queryParams = {};
            queryParams[this.privRequestParams.apiVersion] = this.privApiVersion;
            queryParams[this.privRequestParams.languageCode] = languageCode;
            queryParams[this.privRequestParams.nickname] = nickname;
            const headers = {};
            if (correlationId) headers[this.privRequestParams.correlationId] = correlationId;
            headers[this.privRequestParams.clientAppId] = $jW1mr.ConversationConnectionConfig.clientAppId;
            if (conversationCode !== undefined) queryParams[this.privRequestParams.roomId] = conversationCode;
            else {
                $56OOs.Contracts.throwIfNullOrUndefined(subscriptionRegion, this.privErrors.authInvalidSubscriptionRegion);
                headers[this.privRequestParams.subscriptionRegion] = subscriptionRegion;
                if (subscriptionKey) headers[this.privRequestParams.subscriptionKey] = subscriptionKey;
                else if (authToken) headers[this.privRequestParams.authorization] = `Bearer ${authToken}`;
                else $56OOs.Contracts.throwIfNullOrUndefined(subscriptionKey, this.privErrors.authInvalidSubscriptionKey);
            }
            const config = {};
            config.headers = headers;
            this.privRestAdapter.options = config;
            const endpoint = `https://${endpointHost}${this.privRestPath}`;
            // TODO: support a proxy and certificate validation
            this.privRestAdapter.request($gvLMV.RestRequestType.Post, endpoint, queryParams, null).then((response)=>{
                const requestId = $gvLMV.RestMessageAdapter.extractHeaderValue(this.privRequestParams.requestId, response.headers);
                if (!response.ok) {
                    if (!!err) {
                        // get the error
                        let errorMessage = this.privErrors.invalidCreateJoinConversationResponse.replace("{status}", response.status.toString());
                        let errMessageRaw;
                        try {
                            errMessageRaw = JSON.parse(response.data);
                            errorMessage += ` [${errMessageRaw.error.code}: ${errMessageRaw.error.message}]`;
                        } catch (e) {
                            errorMessage += ` [${response.data}]`;
                        }
                        if (requestId) errorMessage += ` ${requestId}`;
                        err(errorMessage);
                    }
                    return;
                }
                const conversation = JSON.parse(response.data);
                if (conversation) conversation.requestId = requestId;
                if (!!cb) {
                    try {
                        cb(conversation);
                    } catch (e) {
                        if (!!err) err(e);
                    }
                    cb = undefined;
                }
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            }).catch(()=>{});
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    }
    /**
     * Make a DELETE request to the Conversation Manager service endpoint to leave the conversation.
     * @param args
     * @param sessionToken
     * @param callback
     */ leave(args, sessionToken) {
        return new Promise((resolve, reject)=>{
            try {
                $56OOs.Contracts.throwIfNullOrUndefined(args, this.privErrors.invalidArgs.replace("{arg}", "config"));
                $56OOs.Contracts.throwIfNullOrWhitespace(sessionToken, this.privErrors.invalidArgs.replace("{arg}", "token"));
                const endpointHost = args.getProperty($hVlip.PropertyId.ConversationTranslator_Host, this.privHost);
                const correlationId = args.getProperty($hVlip.PropertyId.ConversationTranslator_CorrelationId);
                const queryParams = {};
                queryParams[this.privRequestParams.apiVersion] = this.privApiVersion;
                queryParams[this.privRequestParams.sessionToken] = sessionToken;
                const headers = {};
                if (correlationId) headers[this.privRequestParams.correlationId] = correlationId;
                const config = {};
                config.headers = headers;
                this.privRestAdapter.options = config;
                const endpoint = `https://${endpointHost}${this.privRestPath}`;
                // TODO: support a proxy and certificate validation
                this.privRestAdapter.request($gvLMV.RestRequestType.Delete, endpoint, queryParams, null).then((response)=>{
                    response.ok;
                    resolve();
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                }).catch(()=>{});
            } catch (error) {
                if (error instanceof Error) {
                    const typedError = error;
                    reject(typedError.name + ": " + typedError.message);
                } else reject(error);
            }
        });
    }
}
module.exports.ConversationManager = $23bd3f7ffd00c5ee$var$ConversationManager;

});
parcelRegister("jW1mr", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionConfig = void 0;

var $cqhfk = parcelRequire("cqhfk");
class $e8347d56ebdf0815$var$ConversationConnectionConfig extends $cqhfk.RestConfigBase {
    static get host() {
        return $e8347d56ebdf0815$var$ConversationConnectionConfig.privHost;
    }
    static get apiVersion() {
        return $e8347d56ebdf0815$var$ConversationConnectionConfig.privApiVersion;
    }
    static get clientAppId() {
        return $e8347d56ebdf0815$var$ConversationConnectionConfig.privClientAppId;
    }
    static get defaultLanguageCode() {
        return $e8347d56ebdf0815$var$ConversationConnectionConfig.privDefaultLanguageCode;
    }
    static get restPath() {
        return $e8347d56ebdf0815$var$ConversationConnectionConfig.privRestPath;
    }
    static get webSocketPath() {
        return $e8347d56ebdf0815$var$ConversationConnectionConfig.privWebSocketPath;
    }
    static get transcriptionEventKeys() {
        return $e8347d56ebdf0815$var$ConversationConnectionConfig.privTranscriptionEventKeys;
    }
}
module.exports.ConversationConnectionConfig = $e8347d56ebdf0815$var$ConversationConnectionConfig;
$e8347d56ebdf0815$var$ConversationConnectionConfig.privHost = "dev.microsofttranslator.com";
$e8347d56ebdf0815$var$ConversationConnectionConfig.privRestPath = "/capito/room";
$e8347d56ebdf0815$var$ConversationConnectionConfig.privApiVersion = "2.0";
$e8347d56ebdf0815$var$ConversationConnectionConfig.privDefaultLanguageCode = "en-US";
$e8347d56ebdf0815$var$ConversationConnectionConfig.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15";
$e8347d56ebdf0815$var$ConversationConnectionConfig.privWebSocketPath = "/capito/translate";
$e8347d56ebdf0815$var$ConversationConnectionConfig.privTranscriptionEventKeys = [
    "iCalUid",
    "callId",
    "organizer",
    "FLAC",
    "MTUri",
    "DifferentiateGuestSpeakers",
    "audiorecording",
    "Threadid",
    "OrganizerMri",
    "OrganizerTenantId",
    "UserToken"
];

});
parcelRegister("cqhfk", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestConfigBase = void 0;
class $90b54a803e7a81c3$var$RestConfigBase {
    static get requestOptions() {
        return $90b54a803e7a81c3$var$RestConfigBase.privDefaultRequestOptions;
    }
    static get configParams() {
        return $90b54a803e7a81c3$var$RestConfigBase.privDefaultParams;
    }
    static get restErrors() {
        return $90b54a803e7a81c3$var$RestConfigBase.privRestErrors;
    }
}
module.exports.RestConfigBase = $90b54a803e7a81c3$var$RestConfigBase;
$90b54a803e7a81c3$var$RestConfigBase.privDefaultRequestOptions = {
    headers: {
        Accept: "application/json"
    },
    ignoreCache: false,
    timeout: 10000
};
$90b54a803e7a81c3$var$RestConfigBase.privRestErrors = {
    authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
    authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
    invalidArgs: "Required input not found: {arg}.",
    invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
    invalidParticipantRequest: "The requested participant was not found.",
    permissionDeniedConnect: "Required credentials not found.",
    permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
    permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
    permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
    permissionDeniedStart: "Invalid operation: there is already an active conversation."
};
$90b54a803e7a81c3$var$RestConfigBase.privDefaultParams = {
    apiVersion: "api-version",
    authorization: "Authorization",
    clientAppId: "X-ClientAppId",
    contentTypeKey: "Content-Type",
    correlationId: "X-CorrelationId",
    languageCode: "language",
    nickname: "nickname",
    profanity: "profanity",
    requestId: "X-RequestId",
    roomId: "roomid",
    sessionToken: "token",
    subscriptionKey: "Ocp-Apim-Subscription-Key",
    subscriptionRegion: "Ocp-Apim-Subscription-Region",
    token: "X-CapitoToken"
};

});



parcelRegister("fMEgY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorRecognizer = module.exports.ConversationRecognizerFactory = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $3y56s = parcelRequire("3y56s");

var $lSroU = parcelRequire("lSroU");
class $b7da940d182caab0$var$ConversationRecognizerFactory {
    static fromConfig(conversation, speechConfig, audioConfig) {
        return new $b7da940d182caab0$var$ConversationTranslatorRecognizer(conversation, speechConfig, audioConfig);
    }
}
module.exports.ConversationRecognizerFactory = $b7da940d182caab0$var$ConversationRecognizerFactory;
/**
 * Sends messages to the Conversation Translator websocket and listens for incoming events containing websocket messages.
 * Based off the recognizers in the SDK folder.
 */ class $b7da940d182caab0$var$ConversationTranslatorRecognizer extends $hVlip.Recognizer {
    constructor(conversation, speechConfig, audioConfig){
        const serviceConfigImpl = speechConfig;
        $56OOs.Contracts.throwIfNull(serviceConfigImpl, "speechConfig");
        const conversationImpl = conversation;
        $56OOs.Contracts.throwIfNull(conversationImpl, "conversationImpl");
        super(audioConfig, serviceConfigImpl.properties, new $3y56s.ConversationConnectionFactory());
        this.privConversation = conversationImpl;
        this.privIsDisposed = false;
        this.privProperties = serviceConfigImpl.properties.clone();
        this.privConnection = $hVlip.Connection.fromRecognizer(this);
        const webWorkerLoadType = this.privProperties.getProperty($hVlip.PropertyId.WebWorkerLoadType, "on").toLowerCase();
        if (webWorkerLoadType === "on" && typeof Blob !== "undefined" && typeof Worker !== "undefined") {
            this.privSetTimeout = $3wpON.Timeout.setTimeout;
            this.privClearTimeout = $3wpON.Timeout.clearTimeout;
        } else if (typeof window !== "undefined") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privSetTimeout = window.setTimeout.bind(window);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.privClearTimeout = window.clearTimeout.bind(window);
        } else {
            this.privSetTimeout = setTimeout;
            this.privClearTimeout = clearTimeout;
        }
    }
    set connected(cb) {
        this.privConnection.connected = cb;
    }
    set disconnected(cb) {
        this.privConnection.disconnected = cb;
    }
    /**
     * Return the speech language used by the recognizer
     */ get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
    }
    /**
     * Return the properties for the recognizer
     */ get properties() {
        return this.privProperties;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    /**
     * Connect to the recognizer
     * @param token
     */ connect(token, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            $56OOs.Contracts.throwIfNullOrWhitespace(token, "token");
            this.privReco.conversationTranslatorToken = token;
            this.resetConversationTimeout();
            this.privReco.connectAsync(cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
        }
    }
    /**
     * Disconnect from the recognizer
     */ disconnect(cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privClearTimeout(this.privTimeoutToken);
            this.privReco.disconnect().then(()=>{
                if (!!cb) cb();
            }, (error)=>{
                if (!!err) err(error);
            });
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch((reason)=>{
                $3wpON.Events.instance.onEvent(new $3wpON.BackgroundEvent(reason));
            });
        }
    }
    /**
     * Send the mute all participants command to the websocket
     * @param conversationId
     * @param participantId
     * @param isMuted
     */ sendRequest(command, cb, err) {
        try {
            $56OOs.Contracts.throwIfDisposed(this.privIsDisposed);
            this.sendMessage(command, cb, err);
        } catch (error) {
            if (!!err) {
                if (error instanceof Error) {
                    const typedError = error;
                    err(typedError.name + ": " + typedError.message);
                } else err(error);
            }
            // Destroy the recognizer.
            this.dispose(true).catch((reason)=>{
                $3wpON.Events.instance.onEvent(new $3wpON.BackgroundEvent(reason));
            });
        }
    }
    /**
     * Handle update of service auth token (#694)
     */ onToken(token) {
        this.privConversation.onToken(token);
    }
    /**
     * Close and dispose the recognizer
     */ async close() {
        if (!this.privIsDisposed) {
            if (!!this.privConnection) {
                this.privConnection.closeConnection();
                this.privConnection.close();
            }
            this.privConnection = undefined;
            await this.dispose(true);
        }
    }
    /**
     * Dispose the recognizer
     * @param disposing
     */ async dispose(disposing) {
        if (this.privIsDisposed) return;
        if (disposing) {
            if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privClearTimeout(this.privTimeoutToken);
            this.privIsDisposed = true;
            if (!!this.privConnection) {
                this.privConnection.closeConnection();
                this.privConnection.close();
                this.privConnection = undefined;
            }
            await super.dispose(disposing);
        }
    }
    /**
     * Create the config for the recognizer
     * @param speechConfig
     */ createRecognizerConfig(speechConfig) {
        return new $imJeu.RecognizerConfig(speechConfig, this.privProperties);
    }
    /**
     * Create the service recognizer.
     * The audio source is redundnant here but is required by the implementation.
     * @param authentication
     * @param connectionFactory
     * @param audioConfig
     * @param recognizerConfig
     */ createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const audioSource = audioConfig;
        return new $lSroU.ConversationServiceAdapter(authentication, connectionFactory, audioSource, recognizerConfig, this);
    }
    sendMessage(msg, cb, err) {
        const withAsync = this.privReco;
        const PromiseToEmptyCallback = (promise, cb, err)=>{
            if (promise !== undefined) promise.then(()=>{
                try {
                    if (!!cb) cb();
                } catch (e) {
                    if (!!err) err(`'Unhandled error on promise callback: ${e}'`);
                }
            }, (reason)=>{
                try {
                    if (!!err) err(reason);
                // eslint-disable-next-line no-empty
                } catch (error) {}
            });
            else if (!!err) err("Null promise");
        };
        PromiseToEmptyCallback(withAsync.sendMessageAsync(msg), cb, err);
        this.resetConversationTimeout();
    }
    resetConversationTimeout() {
        if (this.privTimeoutToken !== undefined) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.privClearTimeout(this.privTimeoutToken);
        this.privTimeoutToken = this.privSetTimeout(()=>{
            this.sendRequest(this.privConversation.getKeepAlive());
        }, 60000);
    }
}
module.exports.ConversationTranslatorRecognizer = $b7da940d182caab0$var$ConversationTranslatorRecognizer;

});
parcelRegister("3y56s", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionFactory = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $lAVhN = parcelRequire("lAVhN");

var $jW1mr = parcelRequire("jW1mr");

var $9QgRN = parcelRequire("9QgRN");
/**
 * Create a connection to the Conversation Translator websocket for sending instant messages and commands, and for receiving translated messages.
 * The conversation must already have been started or joined.
 */ class $2958816eeff8fc9b$var$ConversationConnectionFactory extends $lAVhN.ConnectionFactoryBase {
    create(config, authInfo, connectionId) {
        const endpointHost = config.parameters.getProperty($hVlip.PropertyId.ConversationTranslator_Host, $jW1mr.ConversationConnectionConfig.host);
        const correlationId = config.parameters.getProperty($hVlip.PropertyId.ConversationTranslator_CorrelationId, $3wpON.createGuid());
        const endpoint = `wss://${endpointHost}${$jW1mr.ConversationConnectionConfig.webSocketPath}`;
        const token = config.parameters.getProperty($hVlip.PropertyId.ConversationTranslator_Token, undefined);
        $56OOs.Contracts.throwIfNullOrUndefined(token, "token");
        const queryParams = {};
        queryParams[$jW1mr.ConversationConnectionConfig.configParams.apiVersion] = $jW1mr.ConversationConnectionConfig.apiVersion;
        queryParams[$jW1mr.ConversationConnectionConfig.configParams.token] = token;
        queryParams[$jW1mr.ConversationConnectionConfig.configParams.correlationId] = correlationId;
        const enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
        return new $gvLMV.WebsocketConnection(endpoint, queryParams, {}, new $9QgRN.ConversationWebsocketMessageFormatter(), $gvLMV.ProxyInfo.fromRecognizerConfig(config), enableCompression, connectionId);
    }
}
module.exports.ConversationConnectionFactory = $2958816eeff8fc9b$var$ConversationConnectionFactory;

});
parcelRegister("9QgRN", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationWebsocketMessageFormatter = void 0;

var $3wpON = parcelRequire("3wpON");

var $g0s5p = parcelRequire("g0s5p");
/**
 * Based off WebsocketMessageFormatter. The messages for Conversation Translator have some variations from the Speech messages.
 */ class $72a60dc8228b6cff$var$ConversationWebsocketMessageFormatter {
    /**
     * Format incoming messages: text (speech partial/final, IM) or binary (tts)
     */ toConnectionMessage(message) {
        const deferral = new $3wpON.Deferred();
        try {
            if (message.messageType === $3wpON.MessageType.Text) {
                const incomingMessage = new $g0s5p.ConversationConnectionMessage(message.messageType, message.textContent, {}, message.id);
                deferral.resolve(incomingMessage);
            } else if (message.messageType === $3wpON.MessageType.Binary) deferral.resolve(new $g0s5p.ConversationConnectionMessage(message.messageType, message.binaryContent, undefined, message.id));
        } catch (e) {
            deferral.reject(`Error formatting the message. Error: ${e}`);
        }
        return deferral.promise;
    }
    /**
     * Format outgoing messages: text (commands or IM)
     */ fromConnectionMessage(message) {
        const deferral = new $3wpON.Deferred();
        try {
            if (message.messageType === $3wpON.MessageType.Text) {
                const payload = `${message.textBody ? message.textBody : ""}`;
                deferral.resolve(new $3wpON.RawWebsocketMessage($3wpON.MessageType.Text, payload, message.id));
            }
        } catch (e) {
            deferral.reject(`Error formatting the message. ${e}`);
        }
        return deferral.promise;
    }
}
module.exports.ConversationWebsocketMessageFormatter = $72a60dc8228b6cff$var$ConversationWebsocketMessageFormatter;

});
parcelRegister("g0s5p", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationConnectionMessage = void 0;

var $3wpON = parcelRequire("3wpON");
class $ba726ecae84b6c6f$var$ConversationConnectionMessage extends $3wpON.ConnectionMessage {
    constructor(messageType, body, headers, id){
        super(messageType, body, headers, id);
        const json = JSON.parse(this.textBody);
        if (json.type !== undefined) this.privConversationMessageType = json.type;
    }
    get conversationMessageType() {
        return this.privConversationMessageType;
    }
}
module.exports.ConversationConnectionMessage = $ba726ecae84b6c6f$var$ConversationConnectionMessage;

});



parcelRegister("lSroU", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationServiceAdapter = void 0;

var $3wpON = parcelRequire("3wpON");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");

var $g0s5p = parcelRequire("g0s5p");

var $bTeVl = parcelRequire("bTeVl");

var $1SOQg = parcelRequire("1SOQg");

var $jIPhY = parcelRequire("jIPhY");

var $bTyt4 = parcelRequire("bTyt4");
/**
 * The service adapter handles sending and receiving messages to the Conversation Translator websocket.
 */ class $fed3e5574a1f2a3e$var$ConversationServiceAdapter extends $imJeu.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector){
        super(authentication, connectionFactory, audioSource, recognizerConfig, conversationServiceConnector);
        this.privConnectionConfigPromise = undefined;
        this.privLastPartialUtteranceId = "";
        this.privConversationServiceConnector = conversationServiceConnector;
        this.privConversationAuthentication = authentication;
        this.receiveMessageOverride = ()=>this.receiveConversationMessageOverride();
        this.recognizeOverride = ()=>this.noOp();
        this.postConnectImplOverride = (connection)=>this.conversationConnectImpl(connection);
        this.configConnectionOverride = ()=>this.configConnection();
        this.disconnectOverride = ()=>this.privDisconnect();
        this.privConversationRequestSession = new $bTeVl.ConversationRequestSession($3wpON.createNoDashGuid());
        this.privConversationConnectionFactory = connectionFactory;
        this.privConversationIsDisposed = false;
    }
    isDisposed() {
        return super.isDisposed() || this.privConversationIsDisposed;
    }
    async dispose(reason) {
        this.privConversationIsDisposed = true;
        if (this.privConnectionConfigPromise !== undefined) {
            const connection = await this.privConnectionConfigPromise;
            await connection.dispose(reason);
        }
        await super.dispose(reason);
    }
    async sendMessage(message) {
        const connection = await this.fetchConnection();
        return connection.send(new $g0s5p.ConversationConnectionMessage($3wpON.MessageType.Text, message));
    }
    async sendMessageAsync(message) {
        const connection = await this.fetchConnection();
        await connection.send(new $g0s5p.ConversationConnectionMessage($3wpON.MessageType.Text, message));
    }
    privDisconnect() {
        if (this.terminateMessageLoop) return;
        this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.NoError, "Disconnecting");
        this.terminateMessageLoop = true;
        return Promise.resolve();
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async processTypeSpecificMessages() {
        return true;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        this.terminateMessageLoop = true;
        const cancelEvent = new $hVlip.ConversationTranslationCanceledEventArgs(cancellationReason, error, errorCode, undefined, sessionId);
        try {
            if (!!this.privConversationServiceConnector.canceled) this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, cancelEvent);
        } catch  {
        // continue on error
        }
    }
    /**
     * Establishes a websocket connection to the end point.
     */ async conversationConnectImpl(connection) {
        this.privConnectionLoop = this.startMessageLoop();
        return connection;
    }
    /**
     * Process incoming websocket messages
     */ async receiveConversationMessageOverride() {
        if (this.isDisposed() || this.terminateMessageLoop) return Promise.resolve();
        // we won't rely on the cascading promises of the connection since we want to continually be available to receive messages
        const communicationCustodian = new $3wpON.Deferred();
        try {
            const connection = await this.fetchConnection();
            const message = await connection.read();
            if (this.isDisposed() || this.terminateMessageLoop) {
                // We're done.
                communicationCustodian.resolve();
                return Promise.resolve();
            }
            if (!message) return this.receiveConversationMessageOverride();
            const sessionId = this.privConversationRequestSession.sessionId;
            const conversationMessageType = message.conversationMessageType.toLowerCase();
            let sendFinal = false;
            try {
                switch(conversationMessageType){
                    case "info":
                    case "participant_command":
                    case "command":
                        const commandPayload = $bTyt4.CommandResponsePayload.fromJSON(message.textBody);
                        switch(commandPayload.command.toLowerCase()){
                            /**
                             * 'ParticpantList' is the first message sent to the user after the websocket connection has opened.
                             * The consuming client must wait for this message to arrive
                             * before starting to send their own data.
                             */ case "participantlist":
                                const participantsPayload = $bTyt4.ParticipantsListPayloadResponse.fromJSON(message.textBody);
                                const participantsResult = participantsPayload.participants.map((p)=>{
                                    const participant = {
                                        avatar: p.avatar,
                                        displayName: p.nickname,
                                        id: p.participantId,
                                        isHost: p.ishost,
                                        isMuted: p.ismuted,
                                        isUsingTts: p.usetts,
                                        preferredLanguage: p.locale
                                    };
                                    return participant;
                                });
                                if (!!this.privConversationServiceConnector.participantsListReceived) this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new $1SOQg.ParticipantsListEventArgs(participantsPayload.roomid, participantsPayload.token, participantsPayload.translateTo, participantsPayload.profanityFilter, participantsPayload.roomProfanityFilter, participantsPayload.roomLocked, participantsPayload.muteAll, participantsResult, sessionId));
                                break;
                            /**
                             * 'SetTranslateToLanguages' represents the list of languages being used in the Conversation by all users(?).
                             * This is sent at the start of the Conversation
                             */ case "settranslatetolanguages":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1SOQg.ParticipantAttributeEventArgs(commandPayload.participantId, $jIPhY.ConversationTranslatorCommandTypes.setTranslateToLanguages, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetProfanityFiltering' lets the client set the level of profanity filtering.
                             * If sent by the participant the setting will effect only their own profanity level.
                             * If sent by the host, the setting will effect all participants including the host.
                             * Note: the profanity filters differ from Speech Service (?): 'marked', 'raw', 'removed', 'tagged'
                             */ case "setprofanityfiltering":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1SOQg.ParticipantAttributeEventArgs(commandPayload.participantId, $jIPhY.ConversationTranslatorCommandTypes.setProfanityFiltering, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetMute' is sent if the participant has been muted by the host.
                             * Check the 'participantId' to determine if the current user has been muted.
                             */ case "setmute":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1SOQg.ParticipantAttributeEventArgs(commandPayload.participantId, $jIPhY.ConversationTranslatorCommandTypes.setMute, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetMuteAll' is sent if the Conversation has been muted by the host.
                             */ case "setmuteall":
                                if (!!this.privConversationServiceConnector.muteAllCommandReceived) this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new $1SOQg.MuteAllEventArgs(commandPayload.value, sessionId));
                                break;
                            /**
                             * 'RoomExpirationWarning' is sent towards the end of the Conversation session to give a timeout warning.
                             */ case "roomexpirationwarning":
                                if (!!this.privConversationServiceConnector.conversationExpiration) this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new $hVlip.ConversationExpirationEventArgs(commandPayload.value, this.privConversationRequestSession.sessionId));
                                break;
                            /**
                             * 'SetUseTts' is sent as a confirmation if the user requests TTS to be turned on or off.
                             */ case "setusetts":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1SOQg.ParticipantAttributeEventArgs(commandPayload.participantId, $jIPhY.ConversationTranslatorCommandTypes.setUseTTS, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'SetLockState' is set if the host has locked or unlocked the Conversation.
                             */ case "setlockstate":
                                if (!!this.privConversationServiceConnector.lockRoomCommandReceived) this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new $1SOQg.LockRoomEventArgs(commandPayload.value, sessionId));
                                break;
                            /**
                             * 'ChangeNickname' is received if a user changes their display name.
                             * Any cached particpiants list should be updated to reflect the display name.
                             */ case "changenickname":
                                if (!!this.privConversationServiceConnector.participantUpdateCommandReceived) this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new $1SOQg.ParticipantAttributeEventArgs(commandPayload.participantId, $jIPhY.ConversationTranslatorCommandTypes.changeNickname, commandPayload.value, sessionId));
                                break;
                            /**
                             * 'JoinSession' is sent when a user joins the Conversation.
                             */ case "joinsession":
                                const joinParticipantPayload = $bTyt4.ParticipantPayloadResponse.fromJSON(message.textBody);
                                const joiningParticipant = {
                                    avatar: joinParticipantPayload.avatar,
                                    displayName: joinParticipantPayload.nickname,
                                    id: joinParticipantPayload.participantId,
                                    isHost: joinParticipantPayload.ishost,
                                    isMuted: joinParticipantPayload.ismuted,
                                    isUsingTts: joinParticipantPayload.usetts,
                                    preferredLanguage: joinParticipantPayload.locale
                                };
                                if (!!this.privConversationServiceConnector.participantJoinCommandReceived) this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new $1SOQg.ParticipantEventArgs(joiningParticipant, sessionId));
                                break;
                            /**
                             * 'LeaveSession' is sent when a user leaves the Conversation'.
                             */ case "leavesession":
                                const leavingParticipant = {
                                    id: commandPayload.participantId
                                };
                                if (!!this.privConversationServiceConnector.participantLeaveCommandReceived) this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new $1SOQg.ParticipantEventArgs(leavingParticipant, sessionId));
                                break;
                            /**
                             * 'DisconnectSession' is sent when a user is disconnected from the session (e.g. network problem).
                             * Check the 'ParticipantId' to check whether the message is for the current user.
                             */ case "disconnectsession":
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const disconnectParticipant = {
                                    id: commandPayload.participantId
                                };
                                break;
                            case "token":
                                const token = new $imJeu.CognitiveTokenAuthentication(()=>{
                                    const authorizationToken = commandPayload.token;
                                    return Promise.resolve(authorizationToken);
                                }, ()=>{
                                    const authorizationToken = commandPayload.token;
                                    return Promise.resolve(authorizationToken);
                                });
                                this.authentication = token;
                                this.privConversationServiceConnector.onToken(token);
                                break;
                            /**
                             * Message not recognized.
                             */ default:
                                break;
                        }
                        break;
                    /**
                     * 'partial' (or 'hypothesis') represents a unfinalized speech message.
                     */ case "partial":
                    /**
                     * 'final' (or 'phrase') represents a finalized speech message.
                     */ case "final":
                        const speechPayload = $bTyt4.SpeechResponsePayload.fromJSON(message.textBody);
                        const conversationResultReason = conversationMessageType === "final" ? $hVlip.ResultReason.TranslatedParticipantSpeech : $hVlip.ResultReason.TranslatingParticipantSpeech;
                        const speechResult = new $hVlip.ConversationTranslationResult(speechPayload.participantId, this.getTranslations(speechPayload.translations), speechPayload.language, speechPayload.id, conversationResultReason, speechPayload.recognition, undefined, undefined, message.textBody, undefined);
                        if (speechPayload.isFinal) {
                            // check the length, sometimes empty finals are returned
                            if (speechResult.text !== undefined && speechResult.text.length > 0) sendFinal = true;
                            else if (speechPayload.id === this.privLastPartialUtteranceId) // send final as normal. We had a non-empty partial for this same utterance
                            // so sending the empty final is important
                            sendFinal = true;
                            if (sendFinal) {
                                if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $1SOQg.ConversationReceivedTranslationEventArgs($jIPhY.ConversationTranslatorMessageTypes.final, speechResult, sessionId));
                            }
                        } else if (speechResult.text !== undefined) {
                            this.privLastPartialUtteranceId = speechPayload.id;
                            if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $1SOQg.ConversationReceivedTranslationEventArgs($jIPhY.ConversationTranslatorMessageTypes.partial, speechResult, sessionId));
                        }
                        break;
                    /**
                     * "translated_message" is a text message or instant message (IM).
                     */ case "translated_message":
                        const textPayload = $bTyt4.TextResponsePayload.fromJSON(message.textBody);
                        // TODO: (Native parity) a result reason should be set based whether the participantId is ours or not
                        const textResult = new $hVlip.ConversationTranslationResult(textPayload.participantId, this.getTranslations(textPayload.translations), textPayload.language, undefined, undefined, textPayload.originalText, undefined, undefined, undefined, message.textBody, undefined);
                        if (!!this.privConversationServiceConnector.translationReceived) this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new $1SOQg.ConversationReceivedTranslationEventArgs($jIPhY.ConversationTranslatorMessageTypes.instantMessage, textResult, sessionId));
                        break;
                    default:
                        break;
                }
            } catch (e) {
            // continue
            }
            return this.receiveConversationMessageOverride();
        } catch (e) {
            this.terminateMessageLoop = true;
        }
        return communicationCustodian.promise;
    }
    async startMessageLoop() {
        if (this.isDisposed()) return Promise.resolve();
        this.terminateMessageLoop = false;
        const messageRetrievalPromise = this.receiveConversationMessageOverride();
        try {
            const r = await messageRetrievalPromise;
            return r;
        } catch (error) {
            this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.RuntimeError, error);
            return null;
        }
    }
    // Takes an established websocket connection to the endpoint
    configConnection() {
        if (this.isDisposed()) return Promise.resolve(undefined);
        if (this.privConnectionConfigPromise !== undefined) return this.privConnectionConfigPromise.then((connection)=>{
            if (connection.state() === $3wpON.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionConfigPromise = undefined;
                return this.configConnection();
            }
            return this.privConnectionConfigPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionConfigPromise = undefined;
            return this.configConnection();
        });
        if (this.terminateMessageLoop) return Promise.resolve(undefined);
        this.privConnectionConfigPromise = this.connectImpl().then((connection)=>connection);
        return this.privConnectionConfigPromise;
    }
    getTranslations(serviceResultTranslations) {
        let translations;
        if (undefined !== serviceResultTranslations) {
            translations = new $hVlip.Translations();
            for (const translation of serviceResultTranslations)translations.set(translation.lang, translation.translation);
        }
        return translations;
    }
}
module.exports.ConversationServiceAdapter = $fed3e5574a1f2a3e$var$ConversationServiceAdapter;

});
parcelRegister("bTeVl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationRequestSession = void 0;

var $3wpON = parcelRequire("3wpON");
/**
 * Placeholder class for the Conversation Request Session. Based off RequestSession.
 * TODO: define what telemetry is required.
 */ class $8a8068560e1660ab$var$ConversationRequestSession {
    constructor(sessionId){
        this.privIsDisposed = false;
        this.privDetachables = new Array();
        this.privSessionId = sessionId;
        this.privRequestId = $3wpON.createNoDashGuid();
        this.privRequestCompletionDeferral = new $3wpON.Deferred();
    }
    get sessionId() {
        return this.privSessionId;
    }
    get requestId() {
        return this.privRequestId;
    }
    get completionPromise() {
        return this.privRequestCompletionDeferral.promise;
    }
    onPreConnectionStart(authFetchEventId, connectionId) {
        this.privSessionId = connectionId;
    }
    onAuthCompleted(isError) {
        if (isError) this.onComplete();
    }
    onConnectionEstablishCompleted(statusCode) {
        if (statusCode === 200) return;
        else if (statusCode === 403) this.onComplete();
    }
    onServiceTurnEndResponse(continuousRecognition) {
        if (!continuousRecognition) this.onComplete();
        else this.privRequestId = $3wpON.createNoDashGuid();
    }
    async dispose() {
        if (!this.privIsDisposed) {
            // we should have completed by now. If we did not its an unknown error.
            this.privIsDisposed = true;
            for (const detachable of this.privDetachables)await detachable.detach();
        }
    }
    onComplete() {
    //
    }
}
module.exports.ConversationRequestSession = $8a8068560e1660ab$var$ConversationRequestSession;

});

parcelRegister("1SOQg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationReceivedTranslationEventArgs = module.exports.ParticipantsListEventArgs = module.exports.ParticipantAttributeEventArgs = module.exports.ParticipantEventArgs = module.exports.LockRoomEventArgs = module.exports.MuteAllEventArgs = void 0;

var $hVlip = parcelRequire("hVlip");
class $15f245c3f61955b0$var$MuteAllEventArgs extends $hVlip.SessionEventArgs {
    constructor(isMuted, sessionId){
        super(sessionId);
        this.privIsMuted = isMuted;
    }
    get isMuted() {
        return this.privIsMuted;
    }
}
module.exports.MuteAllEventArgs = $15f245c3f61955b0$var$MuteAllEventArgs;
class $15f245c3f61955b0$var$LockRoomEventArgs extends $hVlip.SessionEventArgs {
    constructor(isLocked, sessionId){
        super(sessionId);
        this.privIsLocked = isLocked;
    }
    get isMuted() {
        return this.privIsLocked;
    }
}
module.exports.LockRoomEventArgs = $15f245c3f61955b0$var$LockRoomEventArgs;
class $15f245c3f61955b0$var$ParticipantEventArgs extends $hVlip.SessionEventArgs {
    constructor(participant, sessionId){
        super(sessionId);
        this.privParticipant = participant;
    }
    get participant() {
        return this.privParticipant;
    }
}
module.exports.ParticipantEventArgs = $15f245c3f61955b0$var$ParticipantEventArgs;
class $15f245c3f61955b0$var$ParticipantAttributeEventArgs extends $hVlip.SessionEventArgs {
    constructor(participantId, key, value, sessionId){
        super(sessionId);
        this.privKey = key;
        this.privValue = value;
        this.privParticipantId = participantId;
    }
    get value() {
        return this.privValue;
    }
    get key() {
        return this.privKey;
    }
    get id() {
        return this.privParticipantId;
    }
}
module.exports.ParticipantAttributeEventArgs = $15f245c3f61955b0$var$ParticipantAttributeEventArgs;
class $15f245c3f61955b0$var$ParticipantsListEventArgs extends $hVlip.SessionEventArgs {
    constructor(conversationId, token, translateTo, profanityFilter, roomProfanityFilter, isRoomLocked, isMuteAll, participants, sessionId){
        super(sessionId);
        this.privRoomId = conversationId;
        this.privSessionToken = token;
        this.privTranslateTo = translateTo;
        this.privProfanityFilter = profanityFilter;
        this.privRoomProfanityFilter = roomProfanityFilter;
        this.privIsRoomLocked = isRoomLocked;
        this.privIsRoomLocked = isMuteAll;
        this.privParticipants = participants;
    }
    get sessionToken() {
        return this.privSessionToken;
    }
    get conversationId() {
        return this.privRoomId;
    }
    get translateTo() {
        return this.privTranslateTo;
    }
    get profanityFilter() {
        return this.privProfanityFilter;
    }
    get roomProfanityFilter() {
        return this.privRoomProfanityFilter;
    }
    get isRoomLocked() {
        return this.privIsRoomLocked;
    }
    get isMuteAll() {
        return this.privIsMuteAll;
    }
    get participants() {
        return this.privParticipants;
    }
}
module.exports.ParticipantsListEventArgs = $15f245c3f61955b0$var$ParticipantsListEventArgs;
class $15f245c3f61955b0$var$ConversationReceivedTranslationEventArgs {
    constructor(command, payload, sessionId){
        this.privPayload = payload;
        this.privCommand = command;
        this.privSessionId = sessionId;
    }
    get payload() {
        return this.privPayload;
    }
    get command() {
        return this.privCommand;
    }
    get sessionId() {
        return this.privSessionId;
    }
}
module.exports.ConversationReceivedTranslationEventArgs = $15f245c3f61955b0$var$ConversationReceivedTranslationEventArgs;

});

parcelRegister("jIPhY", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConversationTranslatorCommandTypes = module.exports.ConversationTranslatorMessageTypes = module.exports.InternalParticipants = void 0;
/** Users participating in the conversation */ class $e5b9e9434a97831e$var$InternalParticipants {
    constructor(participants = [], meId){
        this.participants = participants;
        this.meId = meId;
    }
    /**
     * Add or update a participant
     * @param value
     */ addOrUpdateParticipant(value) {
        if (value === undefined) return;
        const exists = this.getParticipantIndex(value.id);
        if (exists > -1) this.participants.splice(exists, 1, value);
        else this.participants.push(value);
        // ensure it was added ok
        return this.getParticipant(value.id);
    }
    /**
     * Find the participant's position in the participants list.
     * @param id
     */ getParticipantIndex(id) {
        return this.participants.findIndex((p)=>p.id === id);
    }
    /**
     * Find the participant by id.
     * @param id
     */ getParticipant(id) {
        return this.participants.find((p)=>p.id === id);
    }
    /**
     * Remove a participant from the participants list.
     */ deleteParticipant(id) {
        this.participants = this.participants.filter((p)=>p.id !== id);
    }
    /**
     * Helper to return the conversation host.
     */ get host() {
        return this.participants.find((p)=>p.isHost === true);
    }
    /**
     * Helper to return the current user.
     */ get me() {
        return this.getParticipant(this.meId);
    }
}
module.exports.InternalParticipants = $e5b9e9434a97831e$var$InternalParticipants;
/**
 * List of command message types
 */ module.exports.ConversationTranslatorMessageTypes = {
    command: "command",
    final: "final",
    info: "info",
    instantMessage: "instant_message",
    keepAlive: "keep_alive",
    partial: "partial",
    participantCommand: "participant_command",
    translatedMessage: "translated_message"
};
/**
 * List of command types
 */ module.exports.ConversationTranslatorCommandTypes = {
    changeNickname: "ChangeNickname",
    disconnectSession: "DisconnectSession",
    ejectParticipant: "EjectParticipant",
    instant_message: "instant_message",
    joinSession: "JoinSession",
    leaveSession: "LeaveSession",
    participantList: "ParticipantList",
    roomExpirationWarning: "RoomExpirationWarning",
    setLockState: "SetLockState",
    setMute: "SetMute",
    setMuteAll: "SetMuteAll",
    setProfanityFiltering: "SetProfanityFiltering",
    setTranslateToLanguages: "SetTranslateToLanguages",
    setUseTTS: "SetUseTTS"
};

});

parcelRegister("bTyt4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $vlSmo = parcelRequire("vlSmo");
Object.defineProperty(module.exports, "CommandResponsePayload", {
    enumerable: true,
    get: function() {
        return $vlSmo.CommandResponsePayload;
    }
});

var $5SfYv = parcelRequire("5SfYv");
Object.defineProperty(module.exports, "ParticipantsListPayloadResponse", {
    enumerable: true,
    get: function() {
        return $5SfYv.ParticipantsListPayloadResponse;
    }
});
Object.defineProperty(module.exports, "ParticipantPayloadResponse", {
    enumerable: true,
    get: function() {
        return $5SfYv.ParticipantPayloadResponse;
    }
});

var $7ZlBl = parcelRequire("7ZlBl");
Object.defineProperty(module.exports, "SpeechResponsePayload", {
    enumerable: true,
    get: function() {
        return $7ZlBl.SpeechResponsePayload;
    }
});
Object.defineProperty(module.exports, "TextResponsePayload", {
    enumerable: true,
    get: function() {
        return $7ZlBl.TextResponsePayload;
    }
});

});
parcelRegister("vlSmo", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommandResponsePayload = void 0;
const $05e3dd70468e7287$var$parseCommandResponse = (json)=>JSON.parse(json);
class $05e3dd70468e7287$var$CommandResponsePayload {
    constructor(json){
        this.privCommandResponse = $05e3dd70468e7287$var$parseCommandResponse(json);
    }
    get type() {
        return this.privCommandResponse.type;
    }
    get command() {
        return this.privCommandResponse.command;
    }
    get id() {
        return this.privCommandResponse.id;
    }
    get nickname() {
        return this.privCommandResponse.nickname;
    }
    get participantId() {
        return this.privCommandResponse.participantId;
    }
    get roomid() {
        return this.privCommandResponse.roomid;
    }
    get value() {
        return this.privCommandResponse.value;
    }
    get token() {
        return this.privCommandResponse.token;
    }
    static fromJSON(json) {
        return new $05e3dd70468e7287$var$CommandResponsePayload(json);
    }
}
module.exports.CommandResponsePayload = $05e3dd70468e7287$var$CommandResponsePayload;

});

parcelRegister("5SfYv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParticipantPayloadResponse = module.exports.ParticipantsListPayloadResponse = void 0;
const $446e632da1892c3c$var$parseListResponse = (json)=>JSON.parse(json);
const $446e632da1892c3c$var$parseParticipantResponse = (json)=>JSON.parse(json);
class $446e632da1892c3c$var$ParticipantsListPayloadResponse {
    constructor(json){
        this.privParticipantsPayloadResponse = $446e632da1892c3c$var$parseListResponse(json);
    }
    get roomid() {
        return this.privParticipantsPayloadResponse.roomid;
    }
    get id() {
        return this.privParticipantsPayloadResponse.id;
    }
    get command() {
        return this.privParticipantsPayloadResponse.command;
    }
    get participants() {
        return this.privParticipantsPayloadResponse.participants;
    }
    get token() {
        return this.privParticipantsPayloadResponse.token;
    }
    get translateTo() {
        return this.privParticipantsPayloadResponse.translateTo;
    }
    get profanityFilter() {
        return this.privParticipantsPayloadResponse.profanityFilter;
    }
    get roomProfanityFilter() {
        return this.privParticipantsPayloadResponse.roomProfanityFilter;
    }
    get roomLocked() {
        return this.privParticipantsPayloadResponse.roomLocked;
    }
    get muteAll() {
        return this.privParticipantsPayloadResponse.muteAll;
    }
    get type() {
        return this.privParticipantsPayloadResponse.type;
    }
    static fromJSON(json) {
        return new $446e632da1892c3c$var$ParticipantsListPayloadResponse(json);
    }
}
module.exports.ParticipantsListPayloadResponse = $446e632da1892c3c$var$ParticipantsListPayloadResponse;
class $446e632da1892c3c$var$ParticipantPayloadResponse {
    constructor(json){
        this.privParticipantPayloadResponse = $446e632da1892c3c$var$parseParticipantResponse(json);
    }
    get nickname() {
        return this.privParticipantPayloadResponse.nickname;
    }
    get locale() {
        return this.privParticipantPayloadResponse.locale;
    }
    get usetts() {
        return this.privParticipantPayloadResponse.usetts;
    }
    get ismuted() {
        return this.privParticipantPayloadResponse.ismuted;
    }
    get ishost() {
        return this.privParticipantPayloadResponse.ishost;
    }
    get participantId() {
        return this.privParticipantPayloadResponse.participantId;
    }
    get avatar() {
        return this.privParticipantPayloadResponse.avatar;
    }
    static fromJSON(json) {
        return new $446e632da1892c3c$var$ParticipantPayloadResponse(json);
    }
}
module.exports.ParticipantPayloadResponse = $446e632da1892c3c$var$ParticipantPayloadResponse;

});

parcelRegister("7ZlBl", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextResponsePayload = module.exports.SpeechResponsePayload = void 0;
const $5d0efc7b5ad89e0e$var$parseSpeechResponse = (json)=>JSON.parse(json);
const $5d0efc7b5ad89e0e$var$parseTextResponse = (json)=>JSON.parse(json);
class $5d0efc7b5ad89e0e$var$SpeechResponsePayload {
    constructor(json){
        this.privSpeechResponse = $5d0efc7b5ad89e0e$var$parseSpeechResponse(json);
    }
    get recognition() {
        return this.privSpeechResponse.recognition;
    }
    get translations() {
        return this.privSpeechResponse.translations;
    }
    get id() {
        return this.privSpeechResponse.id;
    }
    get language() {
        return this.privSpeechResponse.language;
    }
    get nickname() {
        return this.privSpeechResponse.nickname;
    }
    get participantId() {
        return this.privSpeechResponse.participantId;
    }
    get roomid() {
        return this.privSpeechResponse.roomid;
    }
    get timestamp() {
        return this.privSpeechResponse.timestamp;
    }
    get type() {
        return this.privSpeechResponse.type;
    }
    get isFinal() {
        return this.privSpeechResponse.type === "final";
    }
    static fromJSON(json) {
        return new $5d0efc7b5ad89e0e$var$SpeechResponsePayload(json);
    }
}
module.exports.SpeechResponsePayload = $5d0efc7b5ad89e0e$var$SpeechResponsePayload;
class $5d0efc7b5ad89e0e$var$TextResponsePayload {
    constructor(json){
        this.privTextResponse = $5d0efc7b5ad89e0e$var$parseTextResponse(json);
    }
    get originalText() {
        return this.privTextResponse.originalText;
    }
    get translations() {
        return this.privTextResponse.translations;
    }
    get id() {
        return this.privTextResponse.id;
    }
    get language() {
        return this.privTextResponse.language;
    }
    get nickname() {
        return this.privTextResponse.nickname;
    }
    get participantId() {
        return this.privTextResponse.participantId;
    }
    get roomid() {
        return this.privTextResponse.roomid;
    }
    get timestamp() {
        return this.privTextResponse.timestamp;
    }
    get type() {
        return this.privTextResponse.type;
    }
    static fromJSON(json) {
        return new $5d0efc7b5ad89e0e$var$TextResponsePayload(json);
    }
}
module.exports.TextResponsePayload = $5d0efc7b5ad89e0e$var$TextResponsePayload;

});




parcelRegister("fVTxP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TranscriberRecognizer = void 0;

var $3wpON = parcelRequire("3wpON");

var $56OOs = parcelRequire("56OOs");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
class $b99743ea915d7c13$var$TranscriberRecognizer extends $hVlip.Recognizer {
    /**
     * TranscriberRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - Non-audio configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An audio configuration associated with the recognizer
     */ constructor(speechTranslationConfig, audioConfig){
        const speechTranslationConfigImpl = speechTranslationConfig;
        $56OOs.Contracts.throwIfNull(speechTranslationConfigImpl, "speechTranslationConfig");
        const audioConfigImpl = audioConfig;
        $56OOs.Contracts.throwIfNull(audioConfigImpl, "audioConfigImpl");
        $56OOs.Contracts.throwIfNullOrWhitespace(speechTranslationConfigImpl.speechRecognitionLanguage, $hVlip.PropertyId[$hVlip.PropertyId.SpeechServiceConnection_RecoLanguage]);
        super(audioConfig, speechTranslationConfigImpl.properties, new $imJeu.TranscriberConnectionFactory());
        this.privDisposedRecognizer = false;
        this.isMeetingRecognizer = false;
    }
    get speechRecognitionLanguage() {
        $56OOs.Contracts.throwIfDisposed(this.privDisposedRecognizer);
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    get properties() {
        return this.privProperties;
    }
    get authorizationToken() {
        return this.properties.getProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(token) {
        $56OOs.Contracts.throwIfNullOrWhitespace(token, "token");
        this.properties.setProperty($hVlip.PropertyId.SpeechServiceAuthorization_Token, token);
    }
    set conversation(c) {
        $56OOs.Contracts.throwIfNullOrUndefined(c, "Conversation");
        this.isMeetingRecognizer = false;
        this.privConversation = c;
    }
    getConversationInfo() {
        $56OOs.Contracts.throwIfNullOrUndefined(this.privConversation, "Conversation");
        return this.privConversation.conversationInfo;
    }
    set meeting(m) {
        $56OOs.Contracts.throwIfNullOrUndefined(m, "Meeting");
        this.isMeetingRecognizer = true;
        this.privMeeting = m;
    }
    getMeetingInfo() {
        $56OOs.Contracts.throwIfNullOrUndefined(this.privMeeting, "Meeting");
        return this.privMeeting.meetingInfo;
    }
    IsMeetingRecognizer() {
        return this.isMeetingRecognizer;
    }
    startContinuousRecognitionAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl($imJeu.RecognitionMode.Conversation), cb, err);
    }
    stopContinuousRecognitionAsync(cb, err) {
        $3wpON.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), cb, err);
    }
    async close() {
        if (!this.privDisposedRecognizer) await this.dispose(true);
    }
    // Push async join/leave conversation message via serviceRecognizer
    async pushConversationEvent(conversationInfo, command) {
        const reco = this.privReco;
        $56OOs.Contracts.throwIfNullOrUndefined(reco, "serviceRecognizer");
        await reco.sendSpeechEventAsync(conversationInfo, command);
    }
    // Push async join/leave meeting message via serviceRecognizer
    async pushMeetingEvent(meetingInfo, command) {
        const reco = this.privReco;
        $56OOs.Contracts.throwIfNullOrUndefined(reco, "serviceRecognizer");
        await reco.sendMeetingSpeechEventAsync(meetingInfo, command);
    }
    async enforceAudioGating() {
        const audioConfigImpl = this.audioConfig;
        const format = await audioConfigImpl.format;
        const channels = format.channels;
        if (channels === 1) {
            if (this.properties.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() !== "true") throw new Error("Single channel audio configuration for MeetingTranscriber is currently under private preview, please contact diarizationrequest@microsoft.com for more details");
        } else if (channels !== 8) throw new Error(`Unsupported audio configuration: Detected ${channels}-channel audio`);
        return;
    }
    connectMeetingCallbacks(transcriber) {
        this.isMeetingRecognizer = true;
        this.canceled = (s, e)=>{
            if (!!transcriber.canceled) transcriber.canceled(transcriber, e);
        };
        this.recognizing = (s, e)=>{
            if (!!transcriber.transcribing) transcriber.transcribing(transcriber, e);
        };
        this.recognized = (s, e)=>{
            if (!!transcriber.transcribed) transcriber.transcribed(transcriber, e);
        };
        this.sessionStarted = (s, e)=>{
            if (!!transcriber.sessionStarted) transcriber.sessionStarted(transcriber, e);
        };
        this.sessionStopped = (s, e)=>{
            if (!!transcriber.sessionStopped) transcriber.sessionStopped(transcriber, e);
        };
    }
    disconnectCallbacks() {
        this.canceled = undefined;
        this.recognizing = undefined;
        this.recognized = undefined;
        this.sessionStarted = undefined;
        this.sessionStopped = undefined;
    }
    /**
     * Disposes any resources held by the object.
     * @member ConversationTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */ async dispose(disposing) {
        if (this.privDisposedRecognizer) return;
        if (disposing) {
            this.privDisposedRecognizer = true;
            await this.implRecognizerStop();
        }
        await super.dispose(disposing);
    }
    createRecognizerConfig(speechConfig) {
        return new $imJeu.RecognizerConfig(speechConfig, this.properties);
    }
    createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
        const configImpl = audioConfig;
        return new $imJeu.TranscriptionServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
}
module.exports.TranscriberRecognizer = $b99743ea915d7c13$var$TranscriberRecognizer;

});


parcelRegister("2Cd6W", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAudioMetadata = module.exports.MetadataType = void 0;
var $1e794cf1fae7052f$var$MetadataType;
(function(MetadataType) {
    MetadataType["WordBoundary"] = "WordBoundary";
    MetadataType["Bookmark"] = "Bookmark";
    MetadataType["Viseme"] = "Viseme";
    MetadataType["SentenceBoundary"] = "SentenceBoundary";
    MetadataType["SessionEnd"] = "SessionEnd";
    MetadataType["AvatarSignal"] = "TalkingAvatarSignal";
})($1e794cf1fae7052f$var$MetadataType = module.exports.MetadataType || (module.exports.MetadataType = {}));
class $1e794cf1fae7052f$var$SynthesisAudioMetadata {
    constructor(json){
        this.privSynthesisAudioMetadata = JSON.parse(json);
    }
    static fromJSON(json) {
        return new $1e794cf1fae7052f$var$SynthesisAudioMetadata(json);
    }
    get Metadata() {
        return this.privSynthesisAudioMetadata.Metadata;
    }
}
module.exports.SynthesisAudioMetadata = $1e794cf1fae7052f$var$SynthesisAudioMetadata;

});

parcelRegister("cuN42", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisTurn = void 0;

var $3wpON = parcelRequire("3wpON");

var $9QXyd = parcelRequire("9QXyd");

var $hVlip = parcelRequire("hVlip");

var $2Cd6W = parcelRequire("2Cd6W");

var $cPRYm = parcelRequire("cPRYm");
class $918e588276cce66f$var$SynthesisTurn {
    constructor(){
        this.privIsDisposed = false;
        this.privIsSynthesizing = false;
        this.privIsSynthesisEnded = false;
        this.privBytesReceived = 0;
        this.privInTurn = false;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privRequestId = $3wpON.createNoDashGuid();
        this.privTurnDeferral = new $3wpON.Deferred();
        // We're not in a turn, so resolve.
        this.privTurnDeferral.resolve();
    }
    get requestId() {
        return this.privRequestId;
    }
    get streamId() {
        return this.privStreamId;
    }
    set streamId(value) {
        this.privStreamId = value;
    }
    get audioOutputFormat() {
        return this.privAudioOutputFormat;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    get turnCompletionPromise() {
        return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
        return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
        return this.privIsSynthesizing;
    }
    get currentTextOffset() {
        return this.privTextOffset;
    }
    get currentSentenceOffset() {
        return this.privSentenceOffset;
    }
    // The number of bytes received for current turn
    get bytesReceived() {
        return this.privBytesReceived;
    }
    get audioDuration() {
        return this.privAudioDuration;
    }
    get extraProperties() {
        if (!!this.privWebRTCSDP) {
            const properties = new $hVlip.PropertyCollection();
            properties.setProperty($hVlip.PropertyId.TalkingAvatarService_WebRTC_SDP, this.privWebRTCSDP);
            return properties;
        }
        return undefined;
    }
    async getAllReceivedAudio() {
        if (!!this.privReceivedAudio) return Promise.resolve(this.privReceivedAudio);
        if (!this.privIsSynthesisEnded) return null;
        await this.readAllAudioFromStream();
        return Promise.resolve(this.privReceivedAudio);
    }
    async getAllReceivedAudioWithHeader() {
        if (!!this.privReceivedAudioWithHeader) return this.privReceivedAudioWithHeader;
        if (!this.privIsSynthesisEnded) return null;
        if (this.audioOutputFormat.hasHeader) {
            const audio = await this.getAllReceivedAudio();
            this.privReceivedAudioWithHeader = this.audioOutputFormat.addHeader(audio);
            return this.privReceivedAudioWithHeader;
        } else return this.getAllReceivedAudio();
    }
    startNewSynthesis(requestId, rawText, isSSML, audioDestination) {
        this.privIsSynthesisEnded = false;
        this.privIsSynthesizing = true;
        this.privRequestId = requestId;
        this.privRawText = rawText;
        this.privIsSSML = isSSML;
        this.privAudioOutputStream = new $9QXyd.PullAudioOutputStreamImpl();
        this.privAudioOutputStream.format = this.privAudioOutputFormat;
        this.privReceivedAudio = null;
        this.privReceivedAudioWithHeader = null;
        this.privBytesReceived = 0;
        this.privTextOffset = 0;
        this.privNextSearchTextIndex = 0;
        this.privSentenceOffset = 0;
        this.privNextSearchSentenceIndex = 0;
        this.privPartialVisemeAnimation = "";
        this.privWebRTCSDP = "";
        if (audioDestination !== undefined) {
            this.privTurnAudioDestination = audioDestination;
            this.privTurnAudioDestination.format = this.privAudioOutputFormat;
        }
        this.onEvent(new $cPRYm.SynthesisTriggeredEvent(this.requestId, undefined, audioDestination === undefined ? undefined : audioDestination.id()));
    }
    onPreConnectionStart(authFetchEventId) {
        this.privAuthFetchEventId = authFetchEventId;
        this.onEvent(new $cPRYm.ConnectingToSynthesisServiceEvent(this.privRequestId, this.privAuthFetchEventId));
    }
    onAuthCompleted(isError) {
        if (isError) this.onComplete();
    }
    onConnectionEstablishCompleted(statusCode) {
        if (statusCode === 200) {
            this.onEvent(new $cPRYm.SynthesisStartedEvent(this.requestId, this.privAuthFetchEventId));
            this.privBytesReceived = 0;
            return;
        } else if (statusCode === 403) this.onComplete();
    }
    onServiceResponseMessage(responseJson) {
        const response = JSON.parse(responseJson);
        this.streamId = response.audio.streamId;
    }
    onServiceTurnEndResponse() {
        this.privInTurn = false;
        this.privTurnDeferral.resolve();
        this.onComplete();
    }
    onServiceTurnStartResponse(responseJson) {
        if (!!this.privTurnDeferral && !!this.privInTurn) {
            // What? How are we starting a turn with another not done?
            this.privTurnDeferral.reject("Another turn started before current completed.");
            // Avoid UnhandledPromiseRejection if privTurnDeferral is not being awaited
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this.privTurnDeferral.promise.then().catch(()=>{});
        }
        this.privInTurn = true;
        this.privTurnDeferral = new $3wpON.Deferred();
        const response = JSON.parse(responseJson);
        if (!!response.webrtc) this.privWebRTCSDP = response.webrtc.connectionString;
    }
    onAudioChunkReceived(data) {
        if (this.isSynthesizing) {
            this.privAudioOutputStream.write(data);
            this.privBytesReceived += data.byteLength;
            if (this.privTurnAudioDestination !== undefined) this.privTurnAudioDestination.write(data);
        }
    }
    onTextBoundaryEvent(metadata) {
        this.updateTextOffset(metadata.Data.text.Text, metadata.Type);
    }
    onVisemeMetadataReceived(metadata) {
        if (metadata.Data.AnimationChunk !== undefined) this.privPartialVisemeAnimation += metadata.Data.AnimationChunk;
    }
    onSessionEnd(metadata) {
        this.privAudioDuration = metadata.Data.Offset;
    }
    async constructSynthesisResult() {
        const audioBuffer = await this.getAllReceivedAudioWithHeader();
        return new $hVlip.SpeechSynthesisResult(this.requestId, $hVlip.ResultReason.SynthesizingAudioCompleted, audioBuffer, undefined, this.extraProperties, this.audioDuration);
    }
    dispose() {
        if (!this.privIsDisposed) // we should have completed by now. If we did not its an unknown error.
        this.privIsDisposed = true;
    }
    onStopSynthesizing() {
        this.onComplete();
    }
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */ getAndClearVisemeAnimation() {
        const animation = this.privPartialVisemeAnimation;
        this.privPartialVisemeAnimation = "";
        return animation;
    }
    onEvent(event) {
        $3wpON.Events.instance.onEvent(event);
    }
    /**
     * Check if the text is an XML(SSML) tag
     * @param text
     * @private
     */ static isXmlTag(text) {
        return text.length >= 2 && text[0] === "<" && text[text.length - 1] === ">";
    }
    updateTextOffset(text, type) {
        if (type === $2Cd6W.MetadataType.WordBoundary) {
            this.privTextOffset = this.privRawText.indexOf(text, this.privNextSearchTextIndex);
            if (this.privTextOffset >= 0) {
                this.privNextSearchTextIndex = this.privTextOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privTextOffset) && !$918e588276cce66f$var$SynthesisTurn.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        } else {
            this.privSentenceOffset = this.privRawText.indexOf(text, this.privNextSearchSentenceIndex);
            if (this.privSentenceOffset >= 0) {
                this.privNextSearchSentenceIndex = this.privSentenceOffset + text.length;
                if (this.privIsSSML) {
                    if (this.withinXmlTag(this.privSentenceOffset) && !$918e588276cce66f$var$SynthesisTurn.isXmlTag(text)) this.updateTextOffset(text, type);
                }
            }
        }
    }
    onComplete() {
        if (this.privIsSynthesizing) {
            this.privIsSynthesizing = false;
            this.privIsSynthesisEnded = true;
            this.privAudioOutputStream.close();
            this.privInTurn = false;
            if (this.privTurnAudioDestination !== undefined) {
                this.privTurnAudioDestination.close();
                this.privTurnAudioDestination = undefined;
            }
        }
    }
    async readAllAudioFromStream() {
        if (this.privIsSynthesisEnded) {
            this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
            try {
                await this.privAudioOutputStream.read(this.privReceivedAudio);
            } catch (e) {
                this.privReceivedAudio = new ArrayBuffer(0);
            }
        }
    }
    /**
     * Check if current idx is in XML(SSML) tag
     * @param idx
     * @private
     */ withinXmlTag(idx) {
        return this.privRawText.indexOf("<", idx + 1) > this.privRawText.indexOf(">", idx + 1);
    }
}
module.exports.SynthesisTurn = $918e588276cce66f$var$SynthesisTurn;

});
parcelRegister("cPRYm", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisStartedEvent = module.exports.ConnectingToSynthesisServiceEvent = module.exports.SynthesisTriggeredEvent = module.exports.SpeechSynthesisEvent = void 0;

var $3wpON = parcelRequire("3wpON");
class $95841d41bbab05d8$var$SpeechSynthesisEvent extends $3wpON.PlatformEvent {
    constructor(eventName, requestId, eventType = $3wpON.EventType.Info){
        super(eventName, eventType);
        this.privRequestId = requestId;
    }
    get requestId() {
        return this.privRequestId;
    }
}
module.exports.SpeechSynthesisEvent = $95841d41bbab05d8$var$SpeechSynthesisEvent;
class $95841d41bbab05d8$var$SynthesisTriggeredEvent extends $95841d41bbab05d8$var$SpeechSynthesisEvent {
    constructor(requestId, sessionAudioDestinationId, turnAudioDestinationId){
        super("SynthesisTriggeredEvent", requestId);
        this.privSessionAudioDestinationId = sessionAudioDestinationId;
        this.privTurnAudioDestinationId = turnAudioDestinationId;
    }
    get audioSessionDestinationId() {
        return this.privSessionAudioDestinationId;
    }
    get audioTurnDestinationId() {
        return this.privTurnAudioDestinationId;
    }
}
module.exports.SynthesisTriggeredEvent = $95841d41bbab05d8$var$SynthesisTriggeredEvent;
class $95841d41bbab05d8$var$ConnectingToSynthesisServiceEvent extends $95841d41bbab05d8$var$SpeechSynthesisEvent {
    constructor(requestId, authFetchEventId){
        super("ConnectingToSynthesisServiceEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
module.exports.ConnectingToSynthesisServiceEvent = $95841d41bbab05d8$var$ConnectingToSynthesisServiceEvent;
class $95841d41bbab05d8$var$SynthesisStartedEvent extends $95841d41bbab05d8$var$SpeechSynthesisEvent {
    constructor(requestId, authFetchEventId){
        super("SynthesisStartedEvent", requestId);
        this.privAuthFetchEventId = authFetchEventId;
    }
    get authFetchEventId() {
        return this.privAuthFetchEventId;
    }
}
module.exports.SynthesisStartedEvent = $95841d41bbab05d8$var$SynthesisStartedEvent;

});


parcelRegister("9Jg7R", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisAdapterBase = void 0;

var $3wpON = parcelRequire("3wpON");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");

var $l6AmD = parcelRequire("l6AmD");
class $7154d33ec50f90cd$var$SynthesisAdapterBase {
    constructor(authentication, connectionFactory, synthesizerConfig, audioDestination){
        this.speakOverride = undefined;
        this.receiveMessageOverride = undefined;
        this.connectImplOverride = undefined;
        this.configConnectionOverride = undefined;
        // A promise for a configured connection.
        // Do not consume directly, call fetchConnection instead.
        this.privConnectionConfigurationPromise = undefined;
        if (!authentication) throw new $3wpON.ArgumentNullError("authentication");
        if (!connectionFactory) throw new $3wpON.ArgumentNullError("connectionFactory");
        if (!synthesizerConfig) throw new $3wpON.ArgumentNullError("synthesizerConfig");
        this.privAuthentication = authentication;
        this.privConnectionFactory = connectionFactory;
        this.privSynthesizerConfig = synthesizerConfig;
        this.privIsDisposed = false;
        this.privSessionAudioDestination = audioDestination;
        this.privSynthesisTurn = new $imJeu.SynthesisTurn();
        this.privConnectionEvents = new $3wpON.EventSource();
        this.privServiceEvents = new $3wpON.EventSource();
        this.privSynthesisContext = new $imJeu.SynthesisContext();
        this.privAgentConfig = new $imJeu.AgentConfig();
        this.connectionEvents.attach((connectionEvent)=>{
            if (connectionEvent.name === "ConnectionClosedEvent") {
                const connectionClosedEvent = connectionEvent;
                if (connectionClosedEvent.statusCode !== 1000) this.cancelSynthesisLocal($hVlip.CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? $hVlip.CancellationErrorCode.BadRequestParameters : $hVlip.CancellationErrorCode.ConnectionFailure, `${connectionClosedEvent.reason} websocket error code: ${connectionClosedEvent.statusCode}`);
            }
        });
    }
    get synthesisContext() {
        return this.privSynthesisContext;
    }
    get agentConfig() {
        return this.privAgentConfig;
    }
    get connectionEvents() {
        return this.privConnectionEvents;
    }
    get serviceEvents() {
        return this.privServiceEvents;
    }
    set activityTemplate(messagePayload) {
        this.privActivityTemplate = messagePayload;
    }
    get activityTemplate() {
        return this.privActivityTemplate;
    }
    set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
        this.privSynthesisTurn.audioOutputFormat = format;
        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.format = format;
        if (this.synthesisContext !== undefined) this.synthesisContext.audioOutputFormat = format;
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    async dispose(reason) {
        this.privIsDisposed = true;
        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.close();
        if (this.privConnectionConfigurationPromise !== undefined) {
            const connection = await this.privConnectionConfigurationPromise;
            await connection.dispose(reason);
        }
    }
    async connect() {
        await this.connectImpl();
    }
    async sendNetworkMessage(path, payload) {
        const type = typeof payload === "string" ? $3wpON.MessageType.Text : $3wpON.MessageType.Binary;
        const contentType = typeof payload === "string" ? "application/json" : "";
        const connection = await this.fetchConnection();
        return connection.send(new $l6AmD.SpeechConnectionMessage(type, path, this.privSynthesisTurn.requestId, contentType, payload));
    }
    async Speak(text, isSSML, requestId, successCallback, errorCallBack, audioDestination) {
        let ssml;
        if (isSSML) ssml = text;
        else ssml = this.privSynthesizer.buildSsml(text);
        if (this.speakOverride !== undefined) return this.speakOverride(ssml, requestId, successCallback, errorCallBack);
        this.privSuccessCallback = successCallback;
        this.privErrorCallback = errorCallBack;
        this.privSynthesisTurn.startNewSynthesis(requestId, text, isSSML, audioDestination);
        try {
            await this.connectImpl();
            const connection = await this.fetchConnection();
            await this.sendSynthesisContext(connection);
            await this.sendSsmlMessage(connection, ssml, requestId);
            this.onSynthesisStarted(requestId);
            this.receiveMessage();
        } catch (e) {
            this.cancelSynthesisLocal($hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.ConnectionFailure, e);
            return Promise.reject(e);
        }
    }
    async stopSpeaking() {
        await this.connectImpl();
        const connection = await this.fetchConnection();
        return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "synthesis.control", this.privSynthesisTurn.requestId, "application/json", JSON.stringify({
            action: "stop"
        })));
    }
    // Cancels synthesis.
    cancelSynthesis(requestId, _cancellationReason, errorCode, error) {
        const properties = new $hVlip.PropertyCollection();
        properties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[errorCode]);
        const result = new $hVlip.SpeechSynthesisResult(requestId, $hVlip.ResultReason.Canceled, undefined, error, properties);
        this.onSynthesisCancelled(result);
        if (!!this.privSuccessCallback) try {
            this.privSuccessCallback(result);
        /* eslint-disable no-empty */ } catch  {}
    }
    // Cancels synthesis.
    cancelSynthesisLocal(cancellationReason, errorCode, error) {
        if (!!this.privSynthesisTurn.isSynthesizing) {
            this.privSynthesisTurn.onStopSynthesizing();
            this.cancelSynthesis(this.privSynthesisTurn.requestId, cancellationReason, errorCode, error);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processTypeSpecificMessages(_connectionMessage) {
        return true;
    }
    async receiveMessage() {
        try {
            const connection = await this.fetchConnection();
            const message = await connection.read();
            if (this.receiveMessageOverride !== undefined) return this.receiveMessageOverride();
            if (this.privIsDisposed) // We're done.
            return;
            // indicates we are draining the queue and it came with no message;
            if (!message) {
                if (!this.privSynthesisTurn.isSynthesizing) return;
                else return this.receiveMessage();
            }
            const connectionMessage = $l6AmD.SpeechConnectionMessage.fromConnectionMessage(message);
            if (connectionMessage.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase()) switch(connectionMessage.path.toLowerCase()){
                case "turn.start":
                    this.privSynthesisTurn.onServiceTurnStartResponse(connectionMessage.textBody);
                    break;
                case "response":
                    this.privSynthesisTurn.onServiceResponseMessage(connectionMessage.textBody);
                    break;
                case "audio":
                    if (this.privSynthesisTurn.streamId.toLowerCase() === connectionMessage.streamId.toLowerCase() && !!connectionMessage.binaryBody) {
                        this.privSynthesisTurn.onAudioChunkReceived(connectionMessage.binaryBody);
                        this.onSynthesizing(connectionMessage.binaryBody);
                        if (this.privSessionAudioDestination !== undefined) this.privSessionAudioDestination.write(connectionMessage.binaryBody);
                    }
                    break;
                case "audio.metadata":
                    const metadataList = $imJeu.SynthesisAudioMetadata.fromJSON(connectionMessage.textBody).Metadata;
                    for (const metadata of metadataList)switch(metadata.Type){
                        case $imJeu.MetadataType.WordBoundary:
                        case $imJeu.MetadataType.SentenceBoundary:
                            this.privSynthesisTurn.onTextBoundaryEvent(metadata);
                            const wordBoundaryEventArgs = new $hVlip.SpeechSynthesisWordBoundaryEventArgs(metadata.Data.Offset, metadata.Data.Duration, metadata.Data.text.Text, metadata.Data.text.Length, metadata.Type === $imJeu.MetadataType.WordBoundary ? this.privSynthesisTurn.currentTextOffset : this.privSynthesisTurn.currentSentenceOffset, metadata.Data.text.BoundaryType);
                            this.onWordBoundary(wordBoundaryEventArgs);
                            break;
                        case $imJeu.MetadataType.Bookmark:
                            const bookmarkEventArgs = new $hVlip.SpeechSynthesisBookmarkEventArgs(metadata.Data.Offset, metadata.Data.Bookmark);
                            this.onBookmarkReached(bookmarkEventArgs);
                            break;
                        case $imJeu.MetadataType.Viseme:
                            this.privSynthesisTurn.onVisemeMetadataReceived(metadata);
                            if (metadata.Data.IsLastAnimation) {
                                const visemeEventArgs = new $hVlip.SpeechSynthesisVisemeEventArgs(metadata.Data.Offset, metadata.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                                this.onVisemeReceived(visemeEventArgs);
                            }
                            break;
                        case $imJeu.MetadataType.AvatarSignal:
                            this.onAvatarEvent(metadata);
                            break;
                        case $imJeu.MetadataType.SessionEnd:
                            this.privSynthesisTurn.onSessionEnd(metadata);
                            break;
                    }
                    break;
                case "turn.end":
                    this.privSynthesisTurn.onServiceTurnEndResponse();
                    let result;
                    try {
                        result = await this.privSynthesisTurn.constructSynthesisResult();
                        if (!!this.privSuccessCallback) this.privSuccessCallback(result);
                    } catch (error) {
                        if (!!this.privErrorCallback) this.privErrorCallback(error);
                    }
                    this.onSynthesisCompleted(result);
                    break;
                default:
                    if (!this.processTypeSpecificMessages(connectionMessage)) // here are some messages that the derived class has not processed, dispatch them to connect class
                    {
                        if (!!this.privServiceEvents) this.serviceEvents.onEvent(new $3wpON.ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                    }
            }
            return this.receiveMessage();
        } catch (e) {
        // TODO: What goes here?
        }
    }
    sendSynthesisContext(connection) {
        this.setSynthesisContextSynthesisSection();
        const synthesisContextJson = this.synthesisContext.toJSON();
        if (synthesisContextJson) return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", synthesisContextJson));
        return;
    }
    setSpeechConfigSynthesisSection() {
        return;
    }
    connectImpl(isUnAuthorized = false) {
        if (this.privConnectionPromise != null) return this.privConnectionPromise.then((connection)=>{
            if (connection.state() === $3wpON.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionPromise = null;
                return this.connectImpl();
            }
            return this.privConnectionPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionPromise = null;
            return this.connectImpl();
        });
        this.privAuthFetchEventId = $3wpON.createNoDashGuid();
        this.privConnectionId = $3wpON.createNoDashGuid();
        this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId);
        const authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
        this.privConnectionPromise = authPromise.then(async (result)=>{
            this.privSynthesisTurn.onAuthCompleted(false);
            const connection = this.privConnectionFactory.create(this.privSynthesizerConfig, result, this.privConnectionId);
            // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
            // it'll stop sending events.
            connection.events.attach((event)=>{
                this.connectionEvents.onEvent(event);
            });
            const response = await connection.open();
            if (response.statusCode === 200) {
                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                return Promise.resolve(connection);
            } else if (response.statusCode === 403 && !isUnAuthorized) return this.connectImpl(true);
            else {
                this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);
                return Promise.reject(`Unable to contact server. StatusCode: ${response.statusCode},
                    ${this.privSynthesizerConfig.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Url)} Reason: ${response.reason}`);
            }
        }, (error)=>{
            this.privSynthesisTurn.onAuthCompleted(true);
            throw new Error(error);
        });
        // Attach an empty handler to allow the promise to run in the background while
        // other startup events happen. It'll eventually be awaited on.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.privConnectionPromise.catch(()=>{});
        return this.privConnectionPromise;
    }
    sendSpeechServiceConfig(connection, SpeechServiceConfigJson) {
        if (SpeechServiceConfigJson) return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", SpeechServiceConfigJson));
    }
    sendSsmlMessage(connection, ssml, requestId) {
        return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "ssml", requestId, "application/ssml+xml", ssml));
    }
    async fetchConnection() {
        if (this.privConnectionConfigurationPromise !== undefined) return this.privConnectionConfigurationPromise.then((connection)=>{
            if (connection.state() === $3wpON.ConnectionState.Disconnected) {
                this.privConnectionId = null;
                this.privConnectionConfigurationPromise = undefined;
                return this.fetchConnection();
            }
            return this.privConnectionConfigurationPromise;
        }, ()=>{
            this.privConnectionId = null;
            this.privConnectionConfigurationPromise = undefined;
            return this.fetchConnection();
        });
        this.privConnectionConfigurationPromise = this.configureConnection();
        return await this.privConnectionConfigurationPromise;
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configureConnection() {
        const connection = await this.connectImpl();
        if (this.configConnectionOverride !== undefined) return this.configConnectionOverride(connection);
        this.setSpeechConfigSynthesisSection();
        await this.sendSpeechServiceConfig(connection, this.privSynthesizerConfig.SpeechServiceConfig.serialize());
        return connection;
    }
    onAvatarEvent(_metadata) {
        return;
    }
    onSynthesisStarted(_requestId) {
        return;
    }
    onSynthesizing(_audio) {
        return;
    }
    onSynthesisCancelled(_result) {
        return;
    }
    onSynthesisCompleted(_result) {
        return;
    }
    onWordBoundary(_wordBoundaryEventArgs) {
        return;
    }
    onVisemeReceived(_visemeEventArgs) {
        return;
    }
    onBookmarkReached(_bookmarkEventArgs) {
        return;
    }
}
module.exports.SynthesisAdapterBase = $7154d33ec50f90cd$var$SynthesisAdapterBase;
$7154d33ec50f90cd$var$SynthesisAdapterBase.telemetryDataEnabled = true;

});

parcelRegister("ebFzi", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarSynthesisAdapter = void 0;

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
class $a542565c72a35863$var$AvatarSynthesisAdapter extends $imJeu.SynthesisAdapterBase {
    constructor(authentication, connectionFactory, synthesizerConfig, avatarSynthesizer, avatarConfig){
        super(authentication, connectionFactory, synthesizerConfig, undefined);
        this.privAvatarSynthesizer = avatarSynthesizer;
        this.privSynthesizer = avatarSynthesizer;
        this.privAvatarConfig = avatarConfig;
    }
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(undefined);
    }
    setSpeechConfigSynthesisSection() {
        this.privSynthesizerConfig.synthesisVideoSection = {
            format: {
                bitrate: this.privAvatarConfig.videoFormat?.bitrate,
                codec: this.privAvatarConfig.videoFormat?.codec,
                crop: {
                    bottomRight: {
                        x: this.privAvatarConfig.videoFormat?.cropRange?.bottomRight?.x,
                        y: this.privAvatarConfig.videoFormat?.cropRange?.bottomRight?.y
                    },
                    topLeft: {
                        x: this.privAvatarConfig.videoFormat?.cropRange?.topLeft?.x,
                        y: this.privAvatarConfig.videoFormat?.cropRange?.topLeft?.y
                    }
                },
                resolution: {
                    height: this.privAvatarConfig.videoFormat?.height,
                    width: this.privAvatarConfig.videoFormat?.width
                }
            },
            protocol: {
                name: "WebRTC",
                webrtcConfig: {
                    clientDescription: btoa(this.privSynthesizerConfig.parameters.getProperty($hVlip.PropertyId.TalkingAvatarService_WebRTC_SDP)),
                    iceServers: this.privAvatarSynthesizer.iceServers
                }
            },
            talkingAvatar: {
                background: {
                    color: this.privAvatarConfig.backgroundColor
                },
                character: this.privAvatarConfig.character,
                customized: this.privAvatarConfig.customized,
                style: this.privAvatarConfig.style
            }
        };
    }
    onAvatarEvent(metadata) {
        if (!!this.privAvatarSynthesizer.avatarEventReceived) {
            const avatarEventArgs = new $hVlip.AvatarEventArgs(metadata.Data.Offset, metadata.Data.Name);
            try {
                this.privAvatarSynthesizer.avatarEventReceived(this.privAvatarSynthesizer, avatarEventArgs);
            } catch (error) {
            // Not going to let errors in the event handler
            // trip things up.
            }
        }
    }
}
module.exports.AvatarSynthesisAdapter = $a542565c72a35863$var$AvatarSynthesisAdapter;

});

parcelRegister("ilqLB", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeechSynthesisAdapter = void 0;

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");
class $d5aef37d9f3031e2$var$SpeechSynthesisAdapter extends $imJeu.SynthesisAdapterBase {
    constructor(authentication, connectionFactory, synthesizerConfig, speechSynthesizer, audioDestination){
        super(authentication, connectionFactory, synthesizerConfig, audioDestination);
        this.privSpeechSynthesizer = speechSynthesizer;
        this.privSynthesizer = speechSynthesizer;
    }
    setSynthesisContextSynthesisSection() {
        this.privSynthesisContext.setSynthesisSection(this.privSpeechSynthesizer);
    }
    onSynthesisStarted(requestId) {
        const synthesisStartEventArgs = new $hVlip.SpeechSynthesisEventArgs(new $hVlip.SpeechSynthesisResult(requestId, $hVlip.ResultReason.SynthesizingAudioStarted));
        if (!!this.privSpeechSynthesizer.synthesisStarted) this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, synthesisStartEventArgs);
    }
    onSynthesizing(audio) {
        if (!!this.privSpeechSynthesizer.synthesizing) try {
            const audioWithHeader = this.privSynthesisTurn.audioOutputFormat.addHeader(audio);
            const ev = new $hVlip.SpeechSynthesisEventArgs(new $hVlip.SpeechSynthesisResult(this.privSynthesisTurn.requestId, $hVlip.ResultReason.SynthesizingAudio, audioWithHeader));
            this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, ev);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onSynthesisCancelled(result) {
        if (!!this.privSpeechSynthesizer.SynthesisCanceled) {
            const cancelEvent = new $hVlip.SpeechSynthesisEventArgs(result);
            try {
                this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, cancelEvent);
            /* eslint-disable no-empty */ } catch  {}
        }
    }
    onSynthesisCompleted(result) {
        if (this.privSpeechSynthesizer.synthesisCompleted) try {
            this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new $hVlip.SpeechSynthesisEventArgs(result));
        } catch (e) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onWordBoundary(wordBoundaryEventArgs) {
        if (!!this.privSpeechSynthesizer.wordBoundary) try {
            this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, wordBoundaryEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onVisemeReceived(visemeEventArgs) {
        if (!!this.privSpeechSynthesizer.visemeReceived) try {
            this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, visemeEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
    onBookmarkReached(bookmarkEventArgs) {
        if (!!this.privSpeechSynthesizer.bookmarkReached) try {
            this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, bookmarkEventArgs);
        } catch (error) {
        // Not going to let errors in the event handler
        // trip things up.
        }
    }
}
module.exports.SpeechSynthesisAdapter = $d5aef37d9f3031e2$var$SpeechSynthesisAdapter;

});

parcelRegister("93Adk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisRestAdapter = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $hVlip = parcelRequire("hVlip");

var $lAVhN = parcelRequire("lAVhN");

var $bPVwM = parcelRequire("bPVwM");
/**
 * Implements methods for speaker recognition classes, sending requests to endpoint
 * and parsing response into expected format
 * @class SynthesisRestAdapter
 */ class $69807c31d084ba2d$var$SynthesisRestAdapter {
    constructor(config, authentication){
        let endpoint = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Endpoint, undefined);
        if (!endpoint) {
            const region = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Region, "westus");
            const hostSuffix = $lAVhN.ConnectionFactoryBase.getHostSuffix(region);
            endpoint = config.parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_Host, `https://${region}.tts.speech${hostSuffix}`);
        }
        this.privUri = `${endpoint}/cognitiveservices/voices/list`;
        const options = $gvLMV.RestConfigBase.requestOptions;
        this.privRestAdapter = new $gvLMV.RestMessageAdapter(options);
        this.privAuthentication = authentication;
    }
    /**
     * Sends list voices request to endpoint.
     * @function
     * @public
     * @param connectionId - guid for connectionId
     * @returns {Promise<IRestResponse>} rest response to status request
     */ getVoicesList(connectionId) {
        this.privRestAdapter.setHeaders($bPVwM.HeaderNames.ConnectionId, connectionId);
        return this.privAuthentication.fetch(connectionId).then((authInfo)=>{
            this.privRestAdapter.setHeaders(authInfo.headerName, authInfo.token);
            return this.privRestAdapter.request($gvLMV.RestRequestType.Get, this.privUri);
        });
    }
}
module.exports.SynthesisRestAdapter = $69807c31d084ba2d$var$SynthesisRestAdapter;

});

parcelRegister("03DhA", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesizerConfig = module.exports.SynthesisServiceType = void 0;

var $imJeu = parcelRequire("imJeu");
var $00aec0a4d247a8e3$var$SynthesisServiceType;
(function(SynthesisServiceType) {
    SynthesisServiceType[SynthesisServiceType["Standard"] = 0] = "Standard";
    SynthesisServiceType[SynthesisServiceType["Custom"] = 1] = "Custom";
})($00aec0a4d247a8e3$var$SynthesisServiceType = module.exports.SynthesisServiceType || (module.exports.SynthesisServiceType = {}));
class $00aec0a4d247a8e3$var$SynthesizerConfig {
    constructor(speechServiceConfig, parameters){
        this.privSynthesisServiceType = $00aec0a4d247a8e3$var$SynthesisServiceType.Standard;
        this.avatarEnabled = false;
        this.privSpeechServiceConfig = speechServiceConfig ? speechServiceConfig : new $imJeu.SpeechServiceConfig(new $imJeu.Context(null));
        this.privParameters = parameters;
    }
    get parameters() {
        return this.privParameters;
    }
    get synthesisServiceType() {
        return this.privSynthesisServiceType;
    }
    set synthesisServiceType(value) {
        this.privSynthesisServiceType = value;
    }
    set synthesisVideoSection(value) {
        this.privSpeechServiceConfig.Context.synthesis = {
            video: value
        };
    }
    get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
    }
}
module.exports.SynthesizerConfig = $00aec0a4d247a8e3$var$SynthesizerConfig;

});

parcelRegister("6Qyuv", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SynthesisContext = void 0;

var $hVlip = parcelRequire("hVlip");
/**
 * Represents the JSON used in the synthesis.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */ class $4fc25a9a99c32f5e$var$SynthesisContext {
    constructor(){
        this.privContext = {};
    }
    /**
     * Adds a section to the synthesis.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */ setSection(sectionName, value) {
        this.privContext[sectionName] = value;
    }
    /**
     * Sets the audio output format for synthesis context generation.
     * @param format {AudioOutputFormatImpl} the output format
     */ set audioOutputFormat(format) {
        this.privAudioOutputFormat = format;
    }
    toJSON() {
        return JSON.stringify(this.privContext);
    }
    setSynthesisSection(speechSynthesizer) {
        const synthesisSection = this.buildSynthesisContext(speechSynthesizer);
        this.setSection("synthesis", synthesisSection);
    }
    buildSynthesisContext(speechSynthesizer) {
        return {
            audio: {
                metadataOptions: {
                    bookmarkEnabled: !!speechSynthesizer?.bookmarkReached,
                    punctuationBoundaryEnabled: speechSynthesizer?.properties.getProperty($hVlip.PropertyId.SpeechServiceResponse_RequestPunctuationBoundary, !!speechSynthesizer?.wordBoundary),
                    sentenceBoundaryEnabled: speechSynthesizer?.properties.getProperty($hVlip.PropertyId.SpeechServiceResponse_RequestSentenceBoundary, false),
                    sessionEndEnabled: true,
                    visemeEnabled: !!speechSynthesizer?.visemeReceived,
                    wordBoundaryEnabled: speechSynthesizer?.properties.getProperty($hVlip.PropertyId.SpeechServiceResponse_RequestWordBoundary, !!speechSynthesizer?.wordBoundary)
                },
                outputFormat: this.privAudioOutputFormat.requestAudioFormatString
            },
            language: {
                autoDetection: speechSynthesizer?.autoDetectSourceLanguage
            }
        };
    }
}
module.exports.SynthesisContext = $4fc25a9a99c32f5e$var$SynthesisContext;

});

parcelRegister("aX3O2", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerRecognitionConfig = void 0;

var $imJeu = parcelRequire("imJeu");
class $7f925ddf2311a32a$var$SpeakerRecognitionConfig {
    constructor(context, parameters){
        this.privContext = context ? context : new $imJeu.Context(null);
        this.privParameters = parameters;
    }
    get parameters() {
        return this.privParameters;
    }
    get Context() {
        return this.privContext;
    }
}
module.exports.SpeakerRecognitionConfig = $7f925ddf2311a32a$var$SpeakerRecognitionConfig;

});

parcelRegister("gBiLO", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpeakerServiceRecognizer = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $3wpON = parcelRequire("3wpON");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");

var $l6AmD = parcelRequire("l6AmD");
// eslint-disable-next-line max-classes-per-file
class $c15ea968a4c8d2c0$var$SpeakerServiceRecognizer extends $imJeu.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.privSpeakerRecognizer = recognizer;
        this.privSpeakerAudioSource = audioSource;
        this.recognizeSpeaker = (model)=>this.recognizeSpeakerOnce(model);
        this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
    processTypeSpecificMessages(connectionMessage) {
        let processed = false;
        const resultProps = new $hVlip.PropertyCollection();
        if (connectionMessage.messageType === $3wpON.MessageType.Text) resultProps.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            case "speaker.response":
                const response = JSON.parse(connectionMessage.textBody);
                let result;
                if (response.status.statusCode.toLowerCase() !== "success") result = new $hVlip.SpeakerRecognitionResult(response, $hVlip.ResultReason.Canceled, $hVlip.CancellationErrorCode.ServiceError, response.status.reason);
                else result = new $hVlip.SpeakerRecognitionResult(response, $hVlip.ResultReason.RecognizedSpeaker);
                if (!!this.privResultDeferral) this.privResultDeferral.resolve(result);
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new $3wpON.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $hVlip.PropertyCollection();
        properties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[errorCode]);
        if (!!this.privResultDeferral) {
            const result = new $hVlip.SpeakerRecognitionResult({
                scenario: this.privSpeakerModel.scenario,
                status: {
                    statusCode: error,
                    reason: error
                }
            }, $hVlip.ResultReason.Canceled, errorCode, error);
            try {
                this.privResultDeferral.resolve(result);
            } catch (error) {
                this.privResultDeferral.reject(error);
            }
        }
    }
    async recognizeSpeakerOnce(model) {
        this.privSpeakerModel = model;
        this.voiceProfileType = model.scenario;
        if (!this.privResultDeferral) this.privResultDeferral = new $3wpON.Deferred();
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events);
        this.privRecognizerConfig.parameters.setProperty($hVlip.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        const preAudioPromise = this.sendPreAudioMessages(this.extractSpeakerContext(model));
        const node = await this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId);
        const format = await this.privSpeakerAudioSource.format;
        const deviceInfo = await this.privSpeakerAudioSource.deviceInfo;
        const audioNode = new $gvLMV.ReplayableAudioNode(node, format.avgBytesPerSec);
        await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
            source: deviceInfo
        };
        try {
            await conPromise;
            await preAudioPromise;
        } catch (err) {
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.ConnectionFailure, err);
        }
        const sessionStartEventArgs = new $hVlip.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        this.receiveMessage();
        const audioSendPromise = this.sendAudio(audioNode);
        // /* eslint-disable no-empty */
        audioSendPromise.then(()=>{}, (error)=>{
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.RuntimeError, error);
        });
        return this.privResultDeferral.promise;
    }
    async sendPreAudioMessages(context) {
        const connection = await this.fetchConnection();
        await this.sendSpeakerRecognition(connection, context);
    // await this.sendWaveHeader(connection);
    }
    async sendSpeakerRecognition(connection, context) {
        const speakerContextJson = JSON.stringify(context);
        return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "speaker.context", this.privRequestSession.requestId, "application/json; charset=utf-8", speakerContextJson));
    }
    extractSpeakerContext(model) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: model.profileIds,
            scenario: model.scenario
        };
    }
}
module.exports.SpeakerServiceRecognizer = $c15ea968a4c8d2c0$var$SpeakerServiceRecognizer;

});

parcelRegister("lMc82", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoiceServiceRecognizer = void 0;

var $gvLMV = parcelRequire("gvLMV");

var $3wpON = parcelRequire("3wpON");

var $hVlip = parcelRequire("hVlip");

var $imJeu = parcelRequire("imJeu");

var $l6AmD = parcelRequire("l6AmD");
// eslint-disable-next-line max-classes-per-file
class $fda77d29ba09ddcd$var$VoiceServiceRecognizer extends $imJeu.ServiceRecognizerBase {
    constructor(authentication, connectionFactory, audioSource, recognizerConfig, recognizer){
        super(authentication, connectionFactory, audioSource, recognizerConfig, recognizer);
        this.privDeferralMap = new $3wpON.DeferralMap();
        this.privSpeakerAudioSource = audioSource;
        this.sendPrePayloadJSONOverride = ()=>this.noOp();
    }
    set SpeakerAudioSource(audioSource) {
        this.privSpeakerAudioSource = audioSource;
    }
    processTypeSpecificMessages(connectionMessage) {
        let processed = false;
        const resultProps = new $hVlip.PropertyCollection();
        if (connectionMessage.messageType === $3wpON.MessageType.Text) resultProps.setProperty($hVlip.PropertyId.SpeechServiceResponse_JsonResult, connectionMessage.textBody);
        switch(connectionMessage.path.toLowerCase()){
            // Profile management response for create, fetch, delete, reset
            case "speaker.profiles":
                const response = JSON.parse(connectionMessage.textBody);
                switch(response.operation.toLowerCase()){
                    case "create":
                        this.handleCreateResponse(response, connectionMessage.requestId);
                        break;
                    case "delete":
                    case "reset":
                        this.handleResultResponse(response, connectionMessage.requestId);
                        break;
                    case "fetch":
                        const enrollmentResponse = JSON.parse(connectionMessage.textBody);
                        this.handleFetchResponse(enrollmentResponse, connectionMessage.requestId);
                        break;
                    default:
                        break;
                }
                processed = true;
                break;
            // Activation and authorization phrase response
            case "speaker.phrases":
                const phraseResponse = JSON.parse(connectionMessage.textBody);
                this.handlePhrasesResponse(phraseResponse, connectionMessage.requestId);
                processed = true;
                break;
            // Enrollment response
            case "speaker.profile.enrollment":
                const enrollmentResponse1 = JSON.parse(connectionMessage.textBody);
                const result = new $hVlip.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(!!enrollmentResponse1.enrollment ? enrollmentResponse1.enrollment.enrollmentStatus : enrollmentResponse1.status.statusCode), !!enrollmentResponse1.enrollment ? JSON.stringify(enrollmentResponse1.enrollment) : undefined, enrollmentResponse1.status.reason);
                if (!!this.privDeferralMap.getId(connectionMessage.requestId)) this.privDeferralMap.complete(connectionMessage.requestId, result);
                this.privRequestSession.onSpeechEnded();
                processed = true;
                break;
            default:
                break;
        }
        const defferal = new $3wpON.Deferred();
        defferal.resolve(processed);
        return defferal.promise;
    }
    // Cancels recognition.
    cancelRecognition(sessionId, requestId, cancellationReason, errorCode, error) {
        const properties = new $hVlip.PropertyCollection();
        // const enrollmentResponse: EnrollmentResponse = JSON.parse(connectionMessage.textBody) as EnrollmentResponse;
        properties.setProperty($imJeu.CancellationErrorCodePropertyName, $hVlip.CancellationErrorCode[errorCode]);
        const result = new $hVlip.VoiceProfileEnrollmentResult($hVlip.ResultReason.Canceled, error, error);
        if (!!this.privDeferralMap.getId(requestId)) this.privDeferralMap.complete(requestId, result);
    }
    async createProfile(profileType, locale) {
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        this.voiceProfileType = profileType.toString();
        const conPromise = this.connectImpl();
        try {
            const createProfileDeferral = new $3wpON.Deferred();
            await conPromise;
            await this.sendCreateProfile(createProfileDeferral, profileType, locale);
            this.receiveMessage();
            return createProfileDeferral.promise;
        } catch (err) {
            throw err;
        }
    }
    async resetProfile(profile) {
        this.voiceProfileType = profile.profileType.toString();
        return this.sendCommonRequest("reset", profile.profileType, profile);
    }
    async deleteProfile(profile) {
        this.voiceProfileType = profile.profileType.toString();
        return this.sendCommonRequest("delete", profile.profileType, profile);
    }
    async retrieveEnrollmentResult(profile) {
        this.voiceProfileType = profile.profileType.toString();
        this.privExpectedProfileId = profile.profileId;
        return this.sendCommonRequest("fetch", profile.profileType, profile);
    }
    async getAllProfiles(profileType) {
        this.voiceProfileType = profileType.toString();
        return this.sendCommonRequest("fetch", profileType);
    }
    async getActivationPhrases(profileType, lang) {
        this.voiceProfileType = profileType.toString();
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        try {
            const getPhrasesDeferral = new $3wpON.Deferred();
            await conPromise;
            await this.sendPhrasesRequest(getPhrasesDeferral, profileType, lang);
            this.receiveMessage();
            return getPhrasesDeferral.promise;
        } catch (err) {
            throw err;
        }
    }
    async enrollProfile(profile) {
        this.voiceProfileType = profile.profileType.toString();
        const enrollmentDeferral = new $3wpON.Deferred();
        this.privRequestSession.startNewRecognition();
        this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events);
        this.privRecognizerConfig.parameters.setProperty($hVlip.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        const preAudioPromise = this.sendPreAudioMessages(profile, enrollmentDeferral);
        const node = await this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId);
        const format = await this.privSpeakerAudioSource.format;
        const deviceInfo = await this.privSpeakerAudioSource.deviceInfo;
        const audioNode = new $gvLMV.ReplayableAudioNode(node, format.avgBytesPerSec);
        await this.privRequestSession.onAudioSourceAttachCompleted(audioNode, false);
        this.privRecognizerConfig.SpeechServiceConfig.Context.audio = {
            source: deviceInfo
        };
        try {
            await conPromise;
            await preAudioPromise;
        } catch (err) {
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.ConnectionFailure, err);
        }
        const sessionStartEventArgs = new $hVlip.SessionEventArgs(this.privRequestSession.sessionId);
        if (!!this.privRecognizer.sessionStarted) this.privRecognizer.sessionStarted(this.privRecognizer, sessionStartEventArgs);
        this.receiveMessage();
        const audioSendPromise = this.sendAudio(audioNode);
        // /* eslint-disable no-empty */
        audioSendPromise.then(()=>{}, (error)=>{
            this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, $hVlip.CancellationReason.Error, $hVlip.CancellationErrorCode.RuntimeError, error);
        });
        return enrollmentDeferral.promise;
    }
    async sendPreAudioMessages(profile, enrollmentDeferral) {
        const connection = await this.fetchConnection();
        this.privRequestSession.onSpeechContext();
        this.privDeferralMap.add(this.privRequestSession.requestId, enrollmentDeferral);
        await this.sendBaseRequest(connection, "enroll", this.scenarioFrom(profile.profileType), profile);
    }
    async sendPhrasesRequest(getPhrasesDeferral, profileType, locale) {
        const connection = await this.fetchConnection();
        this.privRequestSession.onSpeechContext();
        this.privDeferralMap.add(this.privRequestSession.requestId, getPhrasesDeferral);
        const scenario = this.scenarioFrom(profileType);
        const profileCreateRequest = {
            locale: locale,
            scenario: scenario
        };
        return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "speaker.profile.phrases", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileCreateRequest)));
    }
    async sendCreateProfile(createProfileDeferral, profileType, locale) {
        const connection = await this.fetchConnection();
        this.privRequestSession.onSpeechContext();
        this.privDeferralMap.add(this.privRequestSession.requestId, createProfileDeferral);
        const scenario = profileType === $hVlip.VoiceProfileType.TextIndependentIdentification ? "TextIndependentIdentification" : profileType === $hVlip.VoiceProfileType.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
        const profileCreateRequest = {
            locale: locale,
            number: "1",
            scenario: scenario
        };
        return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, "speaker.profile.create", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileCreateRequest)));
    }
    async sendCommonRequest(operation, profileType, profile) {
        // Start the connection to the service. The promise this will create is stored and will be used by configureConnection().
        const conPromise = this.connectImpl();
        try {
            const deferral = new $3wpON.Deferred();
            this.privRequestSession.onSpeechContext();
            await conPromise;
            const connection = await this.fetchConnection();
            this.privDeferralMap.add(this.privRequestSession.requestId, deferral);
            await this.sendBaseRequest(connection, operation, this.scenarioFrom(profileType), profile);
            this.receiveMessage();
            return deferral.promise;
        } catch (err) {
            throw err;
        }
    }
    async sendBaseRequest(connection, operation, scenario, profile) {
        const profileRequest = {
            scenario: scenario
        };
        if (!!profile) profileRequest.profileIds = [
            profile.profileId
        ];
        else profileRequest.maxPageSize = -1;
        return connection.send(new $l6AmD.SpeechConnectionMessage($3wpON.MessageType.Text, `speaker.profile.${operation}`, this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(profileRequest)));
    }
    extractSpeakerContext(model) {
        return {
            features: {
                interimResult: "enabled",
                progressiveDetection: "disabled"
            },
            profileIds: model.profileIds,
            scenario: model.scenario
        };
    }
    handlePhrasesResponse(response, requestId) {
        if (!!this.privDeferralMap.getId(requestId)) {
            if (response.status.statusCode.toLowerCase() !== "success") {
                const reason = $hVlip.ResultReason.Canceled;
                const result = new $hVlip.VoiceProfilePhraseResult(reason, response.status.statusCode, response.passPhraseType, []);
                this.privDeferralMap.complete(requestId, result);
            } else if (!!response.phrases && response.phrases.length > 0) {
                const reason = $hVlip.ResultReason.EnrollingVoiceProfile;
                const result = new $hVlip.VoiceProfilePhraseResult(reason, response.status.statusCode, response.passPhraseType, response.phrases);
                this.privDeferralMap.complete(requestId, result);
            } else throw new Error("Voice Profile get activation phrases failed, no phrases received");
        } else throw new Error(`Voice Profile get activation phrases request for requestID ${requestId} not found`);
    }
    handleCreateResponse(response, requestId) {
        if (!!response.profiles && response.profiles.length > 0) {
            if (!!this.privDeferralMap.getId(requestId)) {
                const profileIds = response.profiles.map((profile)=>profile.profileId);
                this.privDeferralMap.complete(requestId, profileIds);
            } else throw new Error(`Voice Profile create request for requestID ${requestId} not found`);
        } else throw new Error("Voice Profile create failed, no profile id received");
    }
    handleResultResponse(response, requestId) {
        if (!!this.privDeferralMap.getId(requestId)) {
            const successReason = response.operation.toLowerCase() === "delete" ? $hVlip.ResultReason.DeletedVoiceProfile : $hVlip.ResultReason.ResetVoiceProfile;
            const reason = response.status.statusCode.toLowerCase() === "success" ? successReason : $hVlip.ResultReason.Canceled;
            const result = new $hVlip.VoiceProfileResult(reason, `statusCode: ${response.status.statusCode}, errorDetails: ${response.status.reason}`);
            this.privDeferralMap.complete(requestId, result);
        } else throw new Error(`Voice Profile create request for requestID ${requestId} not found`);
    }
    handleFetchResponse(enrollmentResponse, requestId) {
        if (!!this.privDeferralMap.getId(requestId) && !!enrollmentResponse.profiles[0]) {
            if (!!this.privExpectedProfileId && enrollmentResponse.profiles.length === 1 && enrollmentResponse.profiles[0].profileId === this.privExpectedProfileId) {
                this.privExpectedProfileId = undefined;
                const profileInfo = enrollmentResponse.profiles[0];
                const result = new $hVlip.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(profileInfo.enrollmentStatus), JSON.stringify(profileInfo), enrollmentResponse.status.reason);
                this.privDeferralMap.complete(requestId, result);
            } else if (enrollmentResponse.profiles.length > 0) {
                const iProfiles = enrollmentResponse.profiles;
                const profileResults = [];
                for (const profile of iProfiles)profileResults.push(new $hVlip.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(profile.enrollmentStatus), JSON.stringify(profile), enrollmentResponse.status.reason));
                this.privDeferralMap.complete(requestId, profileResults);
            }
        } else throw new Error(`Voice Profile fetch request for requestID ${requestId} not found`);
    }
    enrollmentReasonFrom(statusCode) {
        switch(statusCode.toLowerCase()){
            case "enrolled":
                return $hVlip.ResultReason.EnrolledVoiceProfile;
            case "invalidlocale":
            case "invalidphrase":
            case "invalidaudioformat":
            case "invalidscenario":
            case "invalidprofilecount":
            case "invalidoperation":
            case "audiotooshort":
            case "audiotoolong":
            case "toomanyenrollments":
            case "storageconflict":
            case "profilenotfound":
            case "incompatibleprofiles":
            case "incompleteenrollment":
                return $hVlip.ResultReason.Canceled;
            default:
                return $hVlip.ResultReason.EnrollingVoiceProfile;
        }
    }
    scenarioFrom(profileType) {
        return profileType === $hVlip.VoiceProfileType.TextIndependentIdentification ? "TextIndependentIdentification" : profileType === $hVlip.VoiceProfileType.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
    }
}
module.exports.VoiceServiceRecognizer = $fda77d29ba09ddcd$var$VoiceServiceRecognizer;

});

parcelRegister("8kYhu", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.type = module.exports.connectivity = module.exports.Device = module.exports.OS = module.exports.System = module.exports.Context = module.exports.SpeechServiceConfig = void 0;
/* eslint-disable max-classes-per-file */ // The config is serialized and sent as the Speech.Config
class $611ef389e78e77e3$var$SpeechServiceConfig {
    constructor(context){
        this.context = context;
    }
    serialize() {
        return JSON.stringify(this, (key, value)=>{
            if (value && typeof value === "object" && !Array.isArray(value)) {
                const replacement = {};
                for(const k in value)if (Object.hasOwnProperty.call(value, k)) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                return replacement;
            }
            return value;
        });
    }
    get Context() {
        return this.context;
    }
    get Recognition() {
        return this.recognition;
    }
    set Recognition(value) {
        this.recognition = value.toLowerCase();
    }
}
module.exports.SpeechServiceConfig = $611ef389e78e77e3$var$SpeechServiceConfig;
class $611ef389e78e77e3$var$Context {
    constructor(os){
        this.system = new $611ef389e78e77e3$var$System();
        this.os = os;
    }
}
module.exports.Context = $611ef389e78e77e3$var$Context;
class $611ef389e78e77e3$var$System {
    constructor(){
        // Note: below will be patched for official builds.
        const SPEECHSDK_CLIENTSDK_VERSION = "1.36.0";
        this.name = "SpeechSDK";
        this.version = SPEECHSDK_CLIENTSDK_VERSION;
        this.build = "JavaScript";
        this.lang = "JavaScript";
    }
}
module.exports.System = $611ef389e78e77e3$var$System;
class $611ef389e78e77e3$var$OS {
    constructor(platform, name, version){
        this.platform = platform;
        this.name = name;
        this.version = version;
    }
}
module.exports.OS = $611ef389e78e77e3$var$OS;
class $611ef389e78e77e3$var$Device {
    constructor(manufacturer, model, version){
        this.manufacturer = manufacturer;
        this.model = model;
        this.version = version;
    }
}
module.exports.Device = $611ef389e78e77e3$var$Device;
var $611ef389e78e77e3$var$connectivity;
(function(connectivity) {
    connectivity["Bluetooth"] = "Bluetooth";
    connectivity["Wired"] = "Wired";
    connectivity["WiFi"] = "WiFi";
    connectivity["Cellular"] = "Cellular";
    connectivity["InBuilt"] = "InBuilt";
    connectivity["Unknown"] = "Unknown";
})($611ef389e78e77e3$var$connectivity = module.exports.connectivity || (module.exports.connectivity = {}));
var $611ef389e78e77e3$var$type;
(function(type) {
    type["Phone"] = "Phone";
    type["Speaker"] = "Speaker";
    type["Car"] = "Car";
    type["Headset"] = "Headset";
    type["Thermostat"] = "Thermostat";
    type["Microphones"] = "Microphones";
    type["Deskphone"] = "Deskphone";
    type["RemoteControl"] = "RemoteControl";
    type["Unknown"] = "Unknown";
    type["File"] = "File";
    type["Stream"] = "Stream";
})($611ef389e78e77e3$var$type = module.exports.type || (module.exports.type = {}));

});



parcelRegister("9e5t1", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FileAudioSource = void 0;

var $imJeu = parcelRequire("imJeu");

var $3wpON = parcelRequire("3wpON");

var $d3s41 = parcelRequire("d3s41");
class $6b79a981cb2a8dce$var$FileAudioSource {
    constructor(file, filename, audioSourceId){
        this.privStreams = {};
        this.privHeaderEnd = 44;
        this.privId = audioSourceId ? audioSourceId : $3wpON.createNoDashGuid();
        this.privEvents = new $3wpON.EventSource();
        this.privSource = file;
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && this.privSource instanceof Blob) this.privFilename = file.name;
        else this.privFilename = filename || "unknown.wav";
        // Read the header.
        this.privAudioFormatPromise = this.readHeader();
    }
    get format() {
        return this.privAudioFormatPromise;
    }
    turnOn() {
        if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
            const errorMsg = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
            this.onEvent(new $3wpON.AudioSourceErrorEvent(errorMsg, ""));
            return Promise.reject(errorMsg);
        }
        this.onEvent(new $3wpON.AudioSourceInitializingEvent(this.privId)); // no stream id
        this.onEvent(new $3wpON.AudioSourceReadyEvent(this.privId));
        return;
    }
    id() {
        return this.privId;
    }
    async attach(audioNodeId) {
        this.onEvent(new $3wpON.AudioStreamNodeAttachingEvent(this.privId, audioNodeId));
        const stream = await this.upload(audioNodeId);
        this.onEvent(new $3wpON.AudioStreamNodeAttachedEvent(this.privId, audioNodeId));
        return Promise.resolve({
            detach: async ()=>{
                stream.readEnded();
                delete this.privStreams[audioNodeId];
                this.onEvent(new $3wpON.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
                await this.turnOff();
            },
            id: ()=>audioNodeId,
            read: ()=>stream.read()
        });
    }
    detach(audioNodeId) {
        if (audioNodeId && this.privStreams[audioNodeId]) {
            this.privStreams[audioNodeId].close();
            delete this.privStreams[audioNodeId];
            this.onEvent(new $3wpON.AudioStreamNodeDetachedEvent(this.privId, audioNodeId));
        }
    }
    turnOff() {
        for(const streamId in this.privStreams)if (streamId) {
            const stream = this.privStreams[streamId];
            if (stream && !stream.isClosed) stream.close();
        }
        this.onEvent(new $3wpON.AudioSourceOffEvent(this.privId)); // no stream now
        return Promise.resolve();
    }
    get events() {
        return this.privEvents;
    }
    get deviceInfo() {
        return this.privAudioFormatPromise.then((result)=>Promise.resolve({
                bitspersample: result.bitsPerSample,
                channelcount: result.channels,
                connectivity: $imJeu.connectivity.Unknown,
                manufacturer: "Speech SDK",
                model: "File",
                samplerate: result.samplesPerSec,
                type: $imJeu.type.File
            }));
    }
    readHeader() {
        // Read the wave header.
        const maxHeaderSize = 4296;
        const header = this.privSource.slice(0, maxHeaderSize);
        const headerResult = new $3wpON.Deferred();
        const processHeader = (header)=>{
            const view = new DataView(header);
            const getWord = (index)=>String.fromCharCode(view.getUint8(index), view.getUint8(index + 1), view.getUint8(index + 2), view.getUint8(index + 3));
            // RIFF 4 bytes.
            if ("RIFF" !== getWord(0)) {
                headerResult.reject("Invalid WAV header in file, RIFF was not found");
                return;
            }
            // length, 4 bytes
            // RIFF Type & fmt 8 bytes
            if ("WAVE" !== getWord(8) || "fmt " !== getWord(12)) {
                headerResult.reject("Invalid WAV header in file, WAVEfmt was not found");
                return;
            }
            const formatSize = view.getInt32(16, true);
            const channelCount = view.getUint16(22, true);
            const sampleRate = view.getUint32(24, true);
            const bitsPerSample = view.getUint16(34, true);
            // Confirm if header is 44 bytes long.
            let pos = 36 + Math.max(formatSize - 16, 0);
            for(; getWord(pos) !== "data"; pos += 2)if (pos > maxHeaderSize - 8) {
                headerResult.reject("Invalid WAV header in file, data block was not found");
                return;
            }
            this.privHeaderEnd = pos + 8;
            headerResult.resolve($d3s41.AudioStreamFormat.getWaveFormatPCM(sampleRate, bitsPerSample, channelCount));
        };
        if (typeof window !== "undefined" && typeof Blob !== "undefined" && header instanceof Blob) {
            const reader = new FileReader();
            reader.onload = (event)=>{
                const header = event.target.result;
                processHeader(header);
            };
            reader.readAsArrayBuffer(header);
        } else {
            const h = header;
            processHeader(h.buffer.slice(h.byteOffset, h.byteOffset + h.byteLength));
        }
        return headerResult.promise;
    }
    async upload(audioNodeId) {
        const onerror = (error)=>{
            const errorMsg = `Error occurred while processing '${this.privFilename}'. ${error}`;
            this.onEvent(new $3wpON.AudioStreamNodeErrorEvent(this.privId, audioNodeId, errorMsg));
            throw new Error(errorMsg);
        };
        try {
            await this.turnOn();
            const format = await this.privAudioFormatPromise;
            const stream = new $3wpON.ChunkedArrayBufferStream(format.avgBytesPerSec / 10, audioNodeId);
            this.privStreams[audioNodeId] = stream;
            const chunk = this.privSource.slice(this.privHeaderEnd);
            const processFile = (buff)=>{
                if (stream.isClosed) return; // output stream was closed (somebody called TurnOff). We're done here.
                stream.writeStreamChunk({
                    buffer: buff,
                    isEnd: false,
                    timeReceived: Date.now()
                });
                stream.close();
            };
            if (typeof window !== "undefined" && typeof Blob !== "undefined" && chunk instanceof Blob) {
                const reader = new FileReader();
                reader.onerror = (ev)=>onerror(ev.toString());
                reader.onload = (event)=>{
                    const fileBuffer = event.target.result;
                    processFile(fileBuffer);
                };
                reader.readAsArrayBuffer(chunk);
            } else {
                const c = chunk;
                processFile(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
            }
            return stream;
        } catch (e) {
            onerror(e);
        }
    }
    onEvent(event) {
        this.privEvents.onEvent(event);
        $3wpON.Events.instance.onEvent(event);
    }
}
module.exports.FileAudioSource = $6b79a981cb2a8dce$var$FileAudioSource;

});

parcelRegister("hdrov", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PcmRecorder = void 0;

var $3wpON = parcelRequire("3wpON");
class $c888e678151baa52$var$PcmRecorder {
    constructor(stopInputOnRelease){
        this.privStopInputOnRelease = stopInputOnRelease;
    }
    record(context, mediaStream, outputStream) {
        const desiredSampleRate = 16000;
        const waveStreamEncoder = new $3wpON.RiffPcmEncoder(context.sampleRate, desiredSampleRate);
        const micInput = context.createMediaStreamSource(mediaStream);
        const attachScriptProcessor = ()=>{
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            const scriptNode = (()=>{
                let bufferSize = 0;
                try {
                    return context.createScriptProcessor(bufferSize, 1, 1);
                } catch (error) {
                    // Webkit (<= version 31) requires a valid bufferSize.
                    bufferSize = 2048;
                    let audioSampleRate = context.sampleRate;
                    while(bufferSize < 16384 && audioSampleRate >= 2 * desiredSampleRate){
                        bufferSize <<= 1;
                        audioSampleRate >>= 1;
                    }
                    return context.createScriptProcessor(bufferSize, 1, 1);
                }
            })();
            scriptNode.onaudioprocess = (event)=>{
                const inputFrame = event.inputBuffer.getChannelData(0);
                if (outputStream && !outputStream.isClosed) {
                    const waveFrame = waveStreamEncoder.encode(inputFrame);
                    if (!!waveFrame) outputStream.writeStreamChunk({
                        buffer: waveFrame,
                        isEnd: false,
                        timeReceived: Date.now()
                    });
                }
            };
            micInput.connect(scriptNode);
            scriptNode.connect(context.destination);
            this.privMediaResources = {
                scriptProcessorNode: scriptNode,
                source: micInput,
                stream: mediaStream
            };
        };
        // https://webaudio.github.io/web-audio-api/#audioworklet
        // Using AudioWorklet to improve audio quality and avoid audio glitches due to blocking the UI thread
        const skipAudioWorklet = !!this.privSpeechProcessorScript && this.privSpeechProcessorScript.toLowerCase() === "ignore";
        if (!!context.audioWorklet && !skipAudioWorklet) {
            if (!this.privSpeechProcessorScript) {
                const workletScript = `class SP extends AudioWorkletProcessor {
                    constructor(options) {
                      super(options);
                    }
                    process(inputs, outputs) {
                      const input = inputs[0];
                      const output = [];
                      for (let channel = 0; channel < input.length; channel += 1) {
                        output[channel] = input[channel];
                      }
                      this.port.postMessage(output[0]);
                      return true;
                    }
                  }
                  registerProcessor('speech-processor', SP);`;
                const blob = new Blob([
                    workletScript
                ], {
                    type: "application/javascript; charset=utf-8"
                });
                this.privSpeechProcessorScript = URL.createObjectURL(blob);
            }
            context.audioWorklet.addModule(this.privSpeechProcessorScript).then(()=>{
                const workletNode = new AudioWorkletNode(context, "speech-processor");
                workletNode.port.onmessage = (ev)=>{
                    const inputFrame = ev.data;
                    if (outputStream && !outputStream.isClosed) {
                        const waveFrame = waveStreamEncoder.encode(inputFrame);
                        if (!!waveFrame) outputStream.writeStreamChunk({
                            buffer: waveFrame,
                            isEnd: false,
                            timeReceived: Date.now()
                        });
                    }
                };
                micInput.connect(workletNode);
                workletNode.connect(context.destination);
                this.privMediaResources = {
                    scriptProcessorNode: workletNode,
                    source: micInput,
                    stream: mediaStream
                };
            }).catch(()=>{
                attachScriptProcessor();
            });
        } else try {
            attachScriptProcessor();
        } catch (err) {
            throw new Error(`Unable to start audio worklet node for PCMRecorder: ${err}`);
        }
    }
    releaseMediaResources(context) {
        if (this.privMediaResources) {
            if (this.privMediaResources.scriptProcessorNode) {
                this.privMediaResources.scriptProcessorNode.disconnect(context.destination);
                this.privMediaResources.scriptProcessorNode = null;
            }
            if (this.privMediaResources.source) {
                this.privMediaResources.source.disconnect();
                if (this.privStopInputOnRelease) this.privMediaResources.stream.getTracks().forEach((track)=>track.stop());
                this.privMediaResources.source = null;
            }
        }
    }
    setWorkletUrl(url) {
        this.privSpeechProcessorScript = url;
    }
}
module.exports.PcmRecorder = $c888e678151baa52$var$PcmRecorder;

});

parcelRegister("lJrvI", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketConnection = void 0;

var $3wpON = parcelRequire("3wpON");

var $ednVg = parcelRequire("ednVg");
class $fd2323f2223477dd$var$WebsocketConnection {
    constructor(uri, queryParameters, headers, messageFormatter, proxyInfo, enableCompression = false, connectionId){
        this.privIsDisposed = false;
        if (!uri) throw new $3wpON.ArgumentNullError("uri");
        if (!messageFormatter) throw new $3wpON.ArgumentNullError("messageFormatter");
        this.privMessageFormatter = messageFormatter;
        let queryParams = "";
        let i = 0;
        if (queryParameters) {
            for(const paramName in queryParameters)if (paramName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const key = encodeURIComponent(paramName);
                queryParams += key;
                let val = queryParameters[paramName];
                if (val) {
                    val = encodeURIComponent(val);
                    queryParams += `=${val}`;
                }
                i++;
            }
        }
        if (headers) {
            for(const headerName in headers)if (headerName) {
                queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
                const val = encodeURIComponent(headers[headerName]);
                queryParams += `${headerName}=${val}`;
                i++;
            }
        }
        this.privUri = uri + queryParams;
        this.privId = connectionId ? connectionId : $3wpON.createNoDashGuid();
        this.privConnectionMessageAdapter = new $ednVg.WebsocketMessageAdapter(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers, enableCompression);
    }
    async dispose() {
        this.privIsDisposed = true;
        if (this.privConnectionMessageAdapter) await this.privConnectionMessageAdapter.close();
    }
    isDisposed() {
        return this.privIsDisposed;
    }
    get id() {
        return this.privId;
    }
    get uri() {
        return this.privUri;
    }
    state() {
        return this.privConnectionMessageAdapter.state;
    }
    open() {
        return this.privConnectionMessageAdapter.open();
    }
    send(message) {
        return this.privConnectionMessageAdapter.send(message);
    }
    read() {
        return this.privConnectionMessageAdapter.read();
    }
    get events() {
        return this.privConnectionMessageAdapter.events;
    }
}
module.exports.WebsocketConnection = $fd2323f2223477dd$var$WebsocketConnection;

});
parcelRegister("ednVg", function(module, exports) {

var $cBXue = parcelRequire("cBXue");
var $a594d621aa67cf0e$require$Buffer = $cBXue.Buffer;
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $a594d621aa67cf0e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a594d621aa67cf0e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a594d621aa67cf0e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $a594d621aa67cf0e$var$__createBinding(result, mod, k);
    }
    $a594d621aa67cf0e$var$__setModuleDefault(result, mod);
    return result;
};
var $a594d621aa67cf0e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketMessageAdapter = void 0;

const $a594d621aa67cf0e$var$net = $a594d621aa67cf0e$var$__importStar((parcelRequire("67wIF")));

const $a594d621aa67cf0e$var$tls = $a594d621aa67cf0e$var$__importStar((parcelRequire("67wIF")));

const $a594d621aa67cf0e$var$agent_base_1 = $a594d621aa67cf0e$var$__importDefault((parcelRequire("67wIF")));

const $a594d621aa67cf0e$var$https_proxy_agent_1 = $a594d621aa67cf0e$var$__importDefault((parcelRequire("67wIF")));

const $a594d621aa67cf0e$var$ws_1 = $a594d621aa67cf0e$var$__importDefault((parcelRequire("67wIF")));

var $bPVwM = parcelRequire("bPVwM");

var $3wpON = parcelRequire("3wpON");
class $a594d621aa67cf0e$var$WebsocketMessageAdapter {
    constructor(uri, connectionId, messageFormatter, proxyInfo, headers, enableCompression){
        if (!uri) throw new $3wpON.ArgumentNullError("uri");
        if (!messageFormatter) throw new $3wpON.ArgumentNullError("messageFormatter");
        this.proxyInfo = proxyInfo;
        this.privConnectionEvents = new $3wpON.EventSource();
        this.privConnectionId = connectionId;
        this.privMessageFormatter = messageFormatter;
        this.privConnectionState = $3wpON.ConnectionState.None;
        this.privUri = uri;
        this.privHeaders = headers;
        this.privEnableCompression = enableCompression;
        // Add the connection ID to the headers
        this.privHeaders[$bPVwM.HeaderNames.ConnectionId] = this.privConnectionId;
        this.privLastErrorReceived = "";
    }
    get state() {
        return this.privConnectionState;
    }
    open() {
        if (this.privConnectionState === $3wpON.ConnectionState.Disconnected) return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
        if (this.privConnectionEstablishDeferral) return this.privConnectionEstablishDeferral.promise;
        this.privConnectionEstablishDeferral = new $3wpON.Deferred();
        this.privCertificateValidatedDeferral = new $3wpON.Deferred();
        this.privConnectionState = $3wpON.ConnectionState.Connecting;
        try {
            if (typeof WebSocket !== "undefined" && !$a594d621aa67cf0e$var$WebsocketMessageAdapter.forceNpmWebSocket) {
                // Browser handles cert checks.
                this.privCertificateValidatedDeferral.resolve();
                this.privWebsocketClient = new WebSocket(this.privUri);
            } else {
                const options = {
                    headers: this.privHeaders,
                    perMessageDeflate: this.privEnableCompression
                };
                // The ocsp library will handle validation for us and fail the connection if needed.
                this.privCertificateValidatedDeferral.resolve();
                options.agent = this.getAgent();
                // Workaround for https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/465
                // Which is root caused by https://github.com/TooTallNate/node-agent-base/issues/61
                const uri = new URL(this.privUri);
                let protocol = uri.protocol;
                if (protocol?.toLocaleLowerCase() === "wss:") protocol = "https:";
                else if (protocol?.toLocaleLowerCase() === "ws:") protocol = "http:";
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                options.agent.protocol = protocol;
                this.privWebsocketClient = new $a594d621aa67cf0e$var$ws_1.default(this.privUri, options);
            }
            this.privWebsocketClient.binaryType = "arraybuffer";
            this.privReceivingMessageQueue = new $3wpON.Queue();
            this.privDisconnectDeferral = new $3wpON.Deferred();
            this.privSendMessageQueue = new $3wpON.Queue();
            this.processSendQueue().catch((reason)=>{
                $3wpON.Events.instance.onEvent(new $3wpON.BackgroundEvent(reason));
            });
        } catch (error) {
            this.privConnectionEstablishDeferral.resolve(new $3wpON.ConnectionOpenResponse(500, error));
            return this.privConnectionEstablishDeferral.promise;
        }
        this.onEvent(new $3wpON.ConnectionStartEvent(this.privConnectionId, this.privUri));
        this.privWebsocketClient.onopen = ()=>{
            this.privCertificateValidatedDeferral.promise.then(()=>{
                this.privConnectionState = $3wpON.ConnectionState.Connected;
                this.onEvent(new $3wpON.ConnectionEstablishedEvent(this.privConnectionId));
                this.privConnectionEstablishDeferral.resolve(new $3wpON.ConnectionOpenResponse(200, ""));
            }, (error)=>{
                this.privConnectionEstablishDeferral.reject(error);
            });
        };
        this.privWebsocketClient.onerror = (e)=>{
            this.onEvent(new $3wpON.ConnectionErrorEvent(this.privConnectionId, e.message, e.type));
            this.privLastErrorReceived = e.message;
        };
        this.privWebsocketClient.onclose = (e)=>{
            if (this.privConnectionState === $3wpON.ConnectionState.Connecting) {
                this.privConnectionState = $3wpON.ConnectionState.Disconnected;
                // this.onEvent(new ConnectionEstablishErrorEvent(this.connectionId, e.code, e.reason));
                this.privConnectionEstablishDeferral.resolve(new $3wpON.ConnectionOpenResponse(e.code, e.reason + " " + this.privLastErrorReceived));
            } else {
                this.privConnectionState = $3wpON.ConnectionState.Disconnected;
                this.privWebsocketClient = null;
                this.onEvent(new $3wpON.ConnectionClosedEvent(this.privConnectionId, e.code, e.reason));
            }
            this.onClose(e.code, e.reason).catch((reason)=>{
                $3wpON.Events.instance.onEvent(new $3wpON.BackgroundEvent(reason));
            });
        };
        this.privWebsocketClient.onmessage = (e)=>{
            const networkReceivedTime = new Date().toISOString();
            if (this.privConnectionState === $3wpON.ConnectionState.Connected) {
                const deferred = new $3wpON.Deferred();
                // let id = ++this.idCounter;
                this.privReceivingMessageQueue.enqueueFromPromise(deferred.promise);
                if (e.data instanceof ArrayBuffer) {
                    const rawMessage = new $3wpON.RawWebsocketMessage($3wpON.MessageType.Binary, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new $3wpON.ConnectionMessageReceivedEvent(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid binary message format. Error: ${error}`);
                    });
                } else {
                    const rawMessage = new $3wpON.RawWebsocketMessage($3wpON.MessageType.Text, e.data);
                    this.privMessageFormatter.toConnectionMessage(rawMessage).then((connectionMessage)=>{
                        this.onEvent(new $3wpON.ConnectionMessageReceivedEvent(this.privConnectionId, networkReceivedTime, connectionMessage));
                        deferred.resolve(connectionMessage);
                    }, (error)=>{
                        // TODO: Events for these ?
                        deferred.reject(`Invalid text message format. Error: ${error}`);
                    });
                }
            }
        };
        return this.privConnectionEstablishDeferral.promise;
    }
    send(message) {
        if (this.privConnectionState !== $3wpON.ConnectionState.Connected) return Promise.reject(`Cannot send on connection that is in ${$3wpON.ConnectionState[this.privConnectionState]} state`);
        const messageSendStatusDeferral = new $3wpON.Deferred();
        const messageSendDeferral = new $3wpON.Deferred();
        this.privSendMessageQueue.enqueueFromPromise(messageSendDeferral.promise);
        this.privMessageFormatter.fromConnectionMessage(message).then((rawMessage)=>{
            messageSendDeferral.resolve({
                Message: message,
                RawWebsocketMessage: rawMessage,
                sendStatusDeferral: messageSendStatusDeferral
            });
        }, (error)=>{
            messageSendDeferral.reject(`Error formatting the message. ${error}`);
        });
        return messageSendStatusDeferral.promise;
    }
    read() {
        if (this.privConnectionState !== $3wpON.ConnectionState.Connected) return Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`);
        return this.privReceivingMessageQueue.dequeue();
    }
    close(reason) {
        if (this.privWebsocketClient) {
            if (this.privConnectionState !== $3wpON.ConnectionState.Disconnected) this.privWebsocketClient.close(1000, reason ? reason : "Normal closure by client");
        } else return Promise.resolve();
        return this.privDisconnectDeferral.promise;
    }
    get events() {
        return this.privConnectionEvents;
    }
    sendRawMessage(sendItem) {
        try {
            // indicates we are draining the queue and it came with no message;
            if (!sendItem) return Promise.resolve();
            this.onEvent(new $3wpON.ConnectionMessageSentEvent(this.privConnectionId, new Date().toISOString(), sendItem.Message));
            // add a check for the ws readystate in order to stop the red console error 'WebSocket is already in CLOSING or CLOSED state' appearing
            if (this.isWebsocketOpen) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.privWebsocketClient.send(sendItem.RawWebsocketMessage.payload);
            else return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + sendItem.Message.id + " " + new Error().stack);
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(`websocket send error: ${e}`);
        }
    }
    async onClose(code, reason) {
        const closeReason = `Connection closed. ${code}: ${reason}`;
        this.privConnectionState = $3wpON.ConnectionState.Disconnected;
        this.privDisconnectDeferral.resolve();
        await this.privReceivingMessageQueue.drainAndDispose(()=>{
        // TODO: Events for these ?
        // Logger.instance.onEvent(new LoggingEvent(LogType.Warning, null, `Failed to process received message. Reason: ${closeReason}, Message: ${JSON.stringify(pendingReceiveItem)}`));
        }, closeReason);
        await this.privSendMessageQueue.drainAndDispose((pendingSendItem)=>{
            pendingSendItem.sendStatusDeferral.reject(closeReason);
        }, closeReason);
    }
    async processSendQueue() {
        while(true){
            const itemToSend = this.privSendMessageQueue.dequeue();
            const sendItem = await itemToSend;
            // indicates we are draining the queue and it came with no message;
            if (!sendItem) return;
            try {
                await this.sendRawMessage(sendItem);
                sendItem.sendStatusDeferral.resolve();
            } catch (sendError) {
                sendItem.sendStatusDeferral.reject(sendError);
            }
        }
    }
    onEvent(event) {
        this.privConnectionEvents.onEvent(event);
        $3wpON.Events.instance.onEvent(event);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAgent() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const agent = new $a594d621aa67cf0e$var$agent_base_1.default.Agent(this.createConnection);
        if (this.proxyInfo !== undefined && this.proxyInfo.HostName !== undefined && this.proxyInfo.Port > 0) agent.proxyInfo = this.proxyInfo;
        return agent;
    }
    static GetProxyAgent(proxyInfo) {
        const httpProxyOptions = {
            host: proxyInfo.HostName,
            port: proxyInfo.Port
        };
        if (!!proxyInfo.UserName) httpProxyOptions.headers = {
            "Proxy-Authentication": "Basic " + new $a594d621aa67cf0e$require$Buffer(`${proxyInfo.UserName}:${proxyInfo.Password === undefined ? "" : proxyInfo.Password}`).toString("base64")
        };
        else httpProxyOptions.headers = {};
        httpProxyOptions.headers.requestOCSP = "true";
        const httpProxyAgent = new $a594d621aa67cf0e$var$https_proxy_agent_1.default(httpProxyOptions);
        return httpProxyAgent;
    }
    createConnection(request, options) {
        let socketPromise;
        options = {
            ...options,
            requestOCSP: true,
            servername: options.host
        };
        if (!!this.proxyInfo) {
            const httpProxyAgent = $a594d621aa67cf0e$var$WebsocketMessageAdapter.GetProxyAgent(this.proxyInfo);
            const baseAgent = httpProxyAgent;
            socketPromise = new Promise((resolve, reject)=>{
                baseAgent.callback(request, options, (error, socket)=>{
                    if (!!error) reject(error);
                    else resolve(socket);
                });
            });
        } else if (!!options.secureEndpoint) socketPromise = Promise.resolve($a594d621aa67cf0e$var$tls.connect(options));
        else socketPromise = Promise.resolve($a594d621aa67cf0e$var$net.connect(options));
        return socketPromise;
    }
    get isWebsocketOpen() {
        return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
    }
}
module.exports.WebsocketMessageAdapter = $a594d621aa67cf0e$var$WebsocketMessageAdapter;
$a594d621aa67cf0e$var$WebsocketMessageAdapter.forceNpmWebSocket = false;

});


parcelRegister("1o04d", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReplayableAudioNode = void 0;
class $1028159fdef9c5f7$var$ReplayableAudioNode {
    constructor(audioSource, bytesPerSecond){
        this.privBuffers = [];
        this.privReplayOffset = 0;
        this.privLastShrinkOffset = 0;
        this.privBufferStartOffset = 0;
        this.privBufferSerial = 0;
        this.privBufferedBytes = 0;
        this.privReplay = false;
        this.privLastChunkAcquiredTime = 0;
        this.privAudioNode = audioSource;
        this.privBytesPerSecond = bytesPerSecond;
    }
    id() {
        return this.privAudioNode.id();
    }
    // Reads and returns the next chunk of audio buffer.
    // If replay of existing buffers are needed, read() will first seek and replay
    // existing content, and upoin completion it will read new content from the underlying
    // audio node, saving that content into the replayable buffers.
    read() {
        // if there is a replay request to honor.
        if (!!this.privReplay && this.privBuffers.length !== 0) {
            // Find the start point in the buffers.
            // Offsets are in 100ns increments.
            // So how many bytes do we need to seek to get the right offset?
            const offsetToSeek = this.privReplayOffset - this.privBufferStartOffset;
            let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
            if (0 !== bytesToSeek % 2) bytesToSeek++;
            let i = 0;
            while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
            if (i < this.privBuffers.length) {
                const retVal = this.privBuffers[i].chunk.buffer.slice(bytesToSeek);
                this.privReplayOffset += retVal.byteLength / this.privBytesPerSecond * 1e+7;
                // If we've reached the end of the buffers, stop replaying.
                if (i === this.privBuffers.length - 1) this.privReplay = false;
                return Promise.resolve({
                    buffer: retVal,
                    isEnd: false,
                    timeReceived: this.privBuffers[i].chunk.timeReceived
                });
            }
        }
        return this.privAudioNode.read().then((result)=>{
            if (result && result.buffer) {
                this.privBuffers.push(new $1028159fdef9c5f7$var$BufferEntry(result, this.privBufferSerial++, this.privBufferedBytes));
                this.privBufferedBytes += result.buffer.byteLength;
            }
            return result;
        });
    }
    detach() {
        this.privBuffers = undefined;
        return this.privAudioNode.detach();
    }
    replay() {
        if (this.privBuffers && 0 !== this.privBuffers.length) {
            this.privReplay = true;
            this.privReplayOffset = this.privLastShrinkOffset;
        }
    }
    // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.
    shrinkBuffers(offset) {
        if (this.privBuffers === undefined || this.privBuffers.length === 0) return;
        this.privLastShrinkOffset = offset;
        // Find the start point in the buffers.
        // Offsets are in 100ns increments.
        // So how many bytes do we need to seek to get the right offset?
        const offsetToSeek = offset - this.privBufferStartOffset;
        let bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
        let i = 0;
        while(i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength)bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
        this.privBufferStartOffset = Math.round(offset - bytesToSeek / this.privBytesPerSecond * 1e+7);
        this.privBuffers = this.privBuffers.slice(i);
    }
    // Finds the time a buffer of audio was first seen by offset.
    findTimeAtOffset(offset) {
        if (offset < this.privBufferStartOffset || this.privBuffers === undefined) return 0;
        for (const value of this.privBuffers){
            const startOffset = value.byteOffset / this.privBytesPerSecond * 1e7;
            const endOffset = startOffset + value.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
            if (offset >= startOffset && offset <= endOffset) return value.chunk.timeReceived;
        }
        return 0;
    }
}
module.exports.ReplayableAudioNode = $1028159fdef9c5f7$var$ReplayableAudioNode;
// Primary use of this class is to help debugging problems with the replay
// code. If the memory cost of alloc / dealloc gets too much, drop it and just use
// the ArrayBuffer directly.
class $1028159fdef9c5f7$var$BufferEntry {
    constructor(chunk, serial, byteOffset){
        this.chunk = chunk;
        this.serial = serial;
        this.byteOffset = byteOffset;
    }
}

});

parcelRegister("fU1HM", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyInfo = void 0;

var $hVlip = parcelRequire("hVlip");
class $b93d68941776d1b1$var$ProxyInfo {
    constructor(proxyHostName, proxyPort, proxyUserName, proxyPassword){
        this.privProxyHostName = proxyHostName;
        this.privProxyPort = proxyPort;
        this.privProxyUserName = proxyUserName;
        this.privProxyPassword = proxyPassword;
    }
    static fromParameters(parameters) {
        return new $b93d68941776d1b1$var$ProxyInfo(parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_ProxyHostName), parseInt(parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_ProxyPort), 10), parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_ProxyUserName), parameters.getProperty($hVlip.PropertyId.SpeechServiceConnection_ProxyPassword));
    }
    static fromRecognizerConfig(config) {
        return this.fromParameters(config.parameters);
    }
    get HostName() {
        return this.privProxyHostName;
    }
    get Port() {
        return this.privProxyPort;
    }
    get UserName() {
        return this.privProxyUserName;
    }
    get Password() {
        return this.privProxyPassword;
    }
}
module.exports.ProxyInfo = $b93d68941776d1b1$var$ProxyInfo;

});

parcelRegister("cnQZS", function(module, exports) {
"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var $9040be1d261aa93b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestMessageAdapter = module.exports.RestRequestType = void 0;

const $9040be1d261aa93b$var$bent_1 = $9040be1d261aa93b$var$__importDefault((parcelRequire("8mE3b")));

var $3wpON = parcelRequire("3wpON");
var $9040be1d261aa93b$var$RestRequestType;
(function(RestRequestType) {
    RestRequestType["Get"] = "GET";
    RestRequestType["Post"] = "POST";
    RestRequestType["Delete"] = "DELETE";
    RestRequestType["File"] = "file";
})($9040be1d261aa93b$var$RestRequestType = module.exports.RestRequestType || (module.exports.RestRequestType = {}));
// accept rest operations via request method and return abstracted objects from server response
class $9040be1d261aa93b$var$RestMessageAdapter {
    constructor(configParams){
        if (!configParams) throw new $3wpON.ArgumentNullError("configParams");
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    static extractHeaderValue(headerKey, headers) {
        let headerValue = "";
        try {
            const arr = headers.trim().split(/[\r\n]+/);
            const headerMap = {};
            arr.forEach((line)=>{
                const parts = line.split(": ");
                const header = parts.shift().toLowerCase();
                const value = parts.join(": ");
                headerMap[header] = value;
            });
            headerValue = headerMap[headerKey.toLowerCase()];
        } catch (e) {
        // ignore the error
        }
        return headerValue;
    }
    set options(configParams) {
        this.privHeaders = configParams.headers;
        this.privIgnoreCache = configParams.ignoreCache;
    }
    setHeaders(key, value) {
        this.privHeaders[key] = value;
    }
    request(method, uri, queryParams = {}, body = null) {
        const responseReceivedDeferral = new $3wpON.Deferred();
        const requestCommand = method === $9040be1d261aa93b$var$RestRequestType.File ? "POST" : method;
        const handleRestResponse = (data, j = {})=>{
            const d = data;
            return {
                data: JSON.stringify(j),
                headers: JSON.stringify(data.headers),
                json: j,
                ok: data.statusCode >= 200 && data.statusCode < 300,
                status: data.statusCode,
                statusText: j.error ? j.error.message : d.statusText ? d.statusText : d.statusMessage
            };
        };
        const send = (postData)=>{
            const sendRequest = $9040be1d261aa93b$var$bent_1.default(uri, requestCommand, this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404);
            const params = this.queryParams(queryParams) === "" ? "" : `?${this.queryParams(queryParams)}`;
            sendRequest(params, postData).then(async (data)=>{
                if (method === $9040be1d261aa93b$var$RestRequestType.Delete || data.statusCode === 204) // No JSON from Delete and reset (204) operations
                responseReceivedDeferral.resolve(handleRestResponse(data));
                else try {
                    const j = await data.json();
                    responseReceivedDeferral.resolve(handleRestResponse(data, j));
                } catch  {
                    responseReceivedDeferral.resolve(handleRestResponse(data));
                }
            }).catch((error)=>{
                responseReceivedDeferral.reject(error);
            });
        };
        if (this.privIgnoreCache) this.privHeaders["Cache-Control"] = "no-cache";
        if (method === $9040be1d261aa93b$var$RestRequestType.Post && body) {
            this.privHeaders["content-type"] = "application/json";
            this.privHeaders["Content-Type"] = "application/json";
        }
        send(body);
        return responseReceivedDeferral.promise;
    }
    queryParams(params = {}) {
        return Object.keys(params).map((k)=>encodeURIComponent(k) + "=" + encodeURIComponent(params[k])).join("&");
    }
}
module.exports.RestMessageAdapter = $9040be1d261aa93b$var$RestMessageAdapter;

});
parcelRegister("8mE3b", function(module, exports) {
"use strict";

var $HYeBn = parcelRequire("HYeBn");
class $616f71fbc3f2b41b$var$StatusError extends Error {
    constructor(res, ...params){
        super(...params);
        if (Error.captureStackTrace) Error.captureStackTrace(this, $616f71fbc3f2b41b$var$StatusError);
        this.name = "StatusError";
        this.message = res.statusMessage;
        this.statusCode = res.status;
        this.res = res;
        this.json = res.json.bind(res);
        this.text = res.text.bind(res);
        this.arrayBuffer = res.arrayBuffer.bind(res);
        let buffer;
        const get = ()=>{
            if (!buffer) buffer = this.arrayBuffer();
            return buffer;
        };
        Object.defineProperty(this, "responseBody", {
            get: get
        });
        // match Node.js headers object
        this.headers = {};
        for (const [key, value] of res.headers.entries())this.headers[key.toLowerCase()] = value;
    }
}
const $616f71fbc3f2b41b$var$mkrequest = (statusCodes, method, encoding, headers, baseurl)=>async (_url, body, _headers = {})=>{
        _url = baseurl + (_url || "");
        let parsed = new URL(_url);
        if (!headers) headers = {};
        if (parsed.username) {
            headers.Authorization = "Basic " + btoa(parsed.username + ":" + parsed.password);
            parsed = new URL(parsed.protocol + "//" + parsed.host + parsed.pathname + parsed.search);
        }
        if (parsed.protocol !== "https:" && parsed.protocol !== "http:") throw new Error(`Unknown protocol, ${parsed.protocol}`);
        if (body) {
            if (body instanceof ArrayBuffer || ArrayBuffer.isView(body) || typeof body === "string") ;
            else if (typeof body === "object") {
                body = JSON.stringify(body);
                headers["Content-Type"] = "application/json";
            } else throw new Error("Unknown body type.");
        }
        _headers = new Headers({
            ...headers || {},
            ..._headers
        });
        const resp = await fetch(parsed, {
            method: method,
            headers: _headers,
            body: body
        });
        resp.statusCode = resp.status;
        if (!statusCodes.has(resp.status)) throw new $616f71fbc3f2b41b$var$StatusError(resp);
        if (encoding === "json") return resp.json();
        else if (encoding === "buffer") return resp.arrayBuffer();
        else if (encoding === "string") return resp.text();
        else return resp;
    };
module.exports = $HYeBn($616f71fbc3f2b41b$var$mkrequest);

});
parcelRegister("HYeBn", function(module, exports) {
"use strict";
const $0842bd963597b4bd$var$encodings = new Set([
    "json",
    "buffer",
    "string"
]);
module.exports = (mkrequest)=>(...args)=>{
        const statusCodes = new Set();
        let method;
        let encoding;
        let headers;
        let baseurl = "";
        args.forEach((arg)=>{
            if (typeof arg === "string") {
                if (arg.toUpperCase() === arg) {
                    if (method) {
                        const msg = `Can't set method to ${arg}, already set to ${method}.`;
                        throw new Error(msg);
                    } else method = arg;
                } else if (arg.startsWith("http:") || arg.startsWith("https:")) baseurl = arg;
                else {
                    if ($0842bd963597b4bd$var$encodings.has(arg)) encoding = arg;
                    else throw new Error(`Unknown encoding, ${arg}`);
                }
            } else if (typeof arg === "number") statusCodes.add(arg);
            else if (typeof arg === "object") {
                if (Array.isArray(arg) || arg instanceof Set) arg.forEach((code)=>statusCodes.add(code));
                else {
                    if (headers) throw new Error("Cannot set headers twice.");
                    headers = arg;
                }
            } else throw new Error(`Unknown type: ${typeof arg}`);
        });
        if (!method) method = "GET";
        if (statusCodes.size === 0) statusCodes.add(200);
        return mkrequest(statusCodes, method, encoding, headers, baseurl);
    };

});





parcelRegister("lQpuE", function(module, exports) {
"use strict";

var $kquUW = parcelRequire("kquUW");
parcelRequire("4dRhZ");
module.exports = $kquUW;

});
parcelRegister("kquUW", function(module, exports) {
"use strict";
parcelRequire("enVAw");
parcelRequire("ibslp");
parcelRequire("l6fHX");
parcelRequire("hEXW9");
parcelRequire("hg8N4");
parcelRequire("4Vefw");
parcelRequire("kG6Xj");
parcelRequire("53EsF");
parcelRequire("bFp9b");

var $Coo2X = parcelRequire("Coo2X");
module.exports = $Coo2X.Promise;

});
parcelRegister("enVAw", function(module, exports) {
"use strict";
parcelRequire("fjxPa");

});
parcelRegister("fjxPa", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $d3z84 = parcelRequire("d3z84");

var $jWAOX = parcelRequire("jWAOX");

var $islHO = parcelRequire("islHO");

var $ii0lQ = parcelRequire("ii0lQ");

var $eB5VD = parcelRequire("eB5VD");

var $ecDbR = parcelRequire("ecDbR");

var $lTzse = parcelRequire("lTzse");

var $iHPDa = parcelRequire("iHPDa");

var $5asq9 = parcelRequire("5asq9");

var $hdk2G = parcelRequire("hdk2G");

var $6ABIb = parcelRequire("6ABIb");

var $eDVzk = parcelRequire("eDVzk");
var $b262de291bbb99d3$var$TO_STRING_TAG = $eDVzk("toStringTag");
var $b262de291bbb99d3$var$$Error = Error;
var $b262de291bbb99d3$var$push = [].push;
var $b262de291bbb99d3$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $d3z84($b262de291bbb99d3$var$AggregateErrorPrototype, this);
    var that;
    if ($islHO) that = $islHO(new $b262de291bbb99d3$var$$Error(), isInstance ? $jWAOX(this) : $b262de291bbb99d3$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $eB5VD($b262de291bbb99d3$var$AggregateErrorPrototype);
        $ecDbR(that, $b262de291bbb99d3$var$TO_STRING_TAG, "Error");
    }
    if (message !== undefined) $ecDbR(that, "message", $6ABIb(message));
    $5asq9(that, $b262de291bbb99d3$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $iHPDa(that, arguments[2]);
    var errorsArray = [];
    $hdk2G(errors, $b262de291bbb99d3$var$push, {
        that: errorsArray
    });
    $ecDbR(that, "errors", errorsArray);
    return that;
};
if ($islHO) $islHO($b262de291bbb99d3$var$$AggregateError, $b262de291bbb99d3$var$$Error);
else $ii0lQ($b262de291bbb99d3$var$$AggregateError, $b262de291bbb99d3$var$$Error, {
    name: true
});
var $b262de291bbb99d3$var$AggregateErrorPrototype = $b262de291bbb99d3$var$$AggregateError.prototype = $eB5VD($b262de291bbb99d3$var$$Error.prototype, {
    constructor: $lTzse(1, $b262de291bbb99d3$var$$AggregateError),
    message: $lTzse(1, ""),
    name: $lTzse(1, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$cdFQY({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $b262de291bbb99d3$var$$AggregateError
});

});
parcelRegister("cdFQY", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $gyz4Q = parcelRequire("gyz4Q");

var $8U5A2 = parcelRequire("8U5A2");

var $b6m5G = parcelRequire("b6m5G");

var $ecn8s = parcelRequire("ecn8s");
var $8e572a2855145f51$require$getOwnPropertyDescriptor = $ecn8s.f;

var $9YuS6 = parcelRequire("9YuS6");

var $Coo2X = parcelRequire("Coo2X");

var $6RDFO = parcelRequire("6RDFO");

var $ecDbR = parcelRequire("ecDbR");

var $5yW2J = parcelRequire("5yW2J");

var $8e572a2855145f51$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $gyz4Q(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $hABpZ : STATIC ? $hABpZ[TARGET] : $hABpZ[TARGET] && $hABpZ[TARGET].prototype;
    var target = GLOBAL ? $Coo2X : $Coo2X[TARGET] || $ecDbR($Coo2X, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $9YuS6(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $5yW2J(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $8e572a2855145f51$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (!FORCED && !PROTO && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $6RDFO(sourceProperty, $hABpZ);
        else if (options.wrap && USE_NATIVE) resultProperty = $8e572a2855145f51$var$wrapConstructor(sourceProperty);
        else if (PROTO && $b6m5G(sourceProperty)) resultProperty = $8U5A2(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $ecDbR(resultProperty, "sham", true);
        $ecDbR(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + "Prototype";
            if (!$5yW2J($Coo2X, VIRTUAL_PROTOTYPE)) $ecDbR($Coo2X, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $ecDbR($Coo2X[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $ecDbR(targetPrototype, key, sourceProperty);
        }
    }
};

});
parcelRegister("hABpZ", function(module, exports) {
"use strict";
var $cce2d2f57402338b$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$cce2d2f57402338b$var$check(typeof globalThis == "object" && globalThis) || $cce2d2f57402338b$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$cce2d2f57402338b$var$check(typeof self == "object" && self) || $cce2d2f57402338b$var$check(typeof $parcel$global == "object" && $parcel$global) || $cce2d2f57402338b$var$check(typeof module.exports == "object" && module.exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

});

parcelRegister("gyz4Q", function(module, exports) {
"use strict";

var $bGPRT = parcelRequire("bGPRT");
var $c0db07ea7cf594e8$var$FunctionPrototype = Function.prototype;
var $c0db07ea7cf594e8$var$apply = $c0db07ea7cf594e8$var$FunctionPrototype.apply;
var $c0db07ea7cf594e8$var$call = $c0db07ea7cf594e8$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || ($bGPRT ? $c0db07ea7cf594e8$var$call.bind($c0db07ea7cf594e8$var$apply) : function() {
    return $c0db07ea7cf594e8$var$call.apply($c0db07ea7cf594e8$var$apply, arguments);
});

});
parcelRegister("bGPRT", function(module, exports) {
"use strict";

var $exTxt = parcelRequire("exTxt");
module.exports = !$exTxt(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

});
parcelRegister("exTxt", function(module, exports) {
"use strict";
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});



parcelRegister("8U5A2", function(module, exports) {
"use strict";

var $6pTth = parcelRequire("6pTth");

var $5LwUI = parcelRequire("5LwUI");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($6pTth(fn) === "Function") return $5LwUI(fn);
};

});
parcelRegister("6pTth", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");
var $4ac01b528b65395a$var$toString = $5LwUI({}.toString);
var $4ac01b528b65395a$var$stringSlice = $5LwUI("".slice);
module.exports = function(it) {
    return $4ac01b528b65395a$var$stringSlice($4ac01b528b65395a$var$toString(it), 8, -1);
};

});
parcelRegister("5LwUI", function(module, exports) {
"use strict";

var $bGPRT = parcelRequire("bGPRT");
var $432adf8d1e054ec9$var$FunctionPrototype = Function.prototype;
var $432adf8d1e054ec9$var$call = $432adf8d1e054ec9$var$FunctionPrototype.call;
var $432adf8d1e054ec9$var$uncurryThisWithBind = $bGPRT && $432adf8d1e054ec9$var$FunctionPrototype.bind.bind($432adf8d1e054ec9$var$call, $432adf8d1e054ec9$var$call);
module.exports = $bGPRT ? $432adf8d1e054ec9$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $432adf8d1e054ec9$var$call.apply(fn, arguments);
    };
};

});



parcelRegister("b6m5G", function(module, exports) {
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $815163fd63d91673$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof $815163fd63d91673$var$documentAll == "undefined" && $815163fd63d91673$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $815163fd63d91673$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};

});

parcelRegister("ecn8s", function(module, exports) {

$parcel$export(module.exports, "f", () => $a56421ddcdf789e1$export$2d1720544b23b823, (v) => $a56421ddcdf789e1$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $a56421ddcdf789e1$export$2d1720544b23b823;
"use strict";

var $bRpwd = parcelRequire("bRpwd");

var $gEnMf = parcelRequire("gEnMf");

var $juvGx = parcelRequire("juvGx");

var $lTzse = parcelRequire("lTzse");

var $2qc3O = parcelRequire("2qc3O");

var $1HCkX = parcelRequire("1HCkX");

var $5yW2J = parcelRequire("5yW2J");

var $g9cQK = parcelRequire("g9cQK");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $a56421ddcdf789e1$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$a56421ddcdf789e1$export$2d1720544b23b823 = $bRpwd ? $a56421ddcdf789e1$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $2qc3O(O);
    P = $1HCkX(P);
    if ($g9cQK) try {
        return $a56421ddcdf789e1$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($5yW2J(O, P)) return $lTzse(!$gEnMf($juvGx.f, O, P), O[P]);
};

});
parcelRegister("bRpwd", function(module, exports) {
"use strict";

var $exTxt = parcelRequire("exTxt");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$exTxt(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

});

parcelRegister("gEnMf", function(module, exports) {
"use strict";

var $bGPRT = parcelRequire("bGPRT");
var $c1f2d36a0e815ab6$var$call = Function.prototype.call;
module.exports = $bGPRT ? $c1f2d36a0e815ab6$var$call.bind($c1f2d36a0e815ab6$var$call) : function() {
    return $c1f2d36a0e815ab6$var$call.apply($c1f2d36a0e815ab6$var$call, arguments);
};

});

parcelRegister("juvGx", function(module, exports) {

$parcel$export(module.exports, "f", () => $e30965a9a6f94730$export$2d1720544b23b823, (v) => $e30965a9a6f94730$export$2d1720544b23b823 = v);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $e30965a9a6f94730$export$2d1720544b23b823;
"use strict";
var $e30965a9a6f94730$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $e30965a9a6f94730$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $e30965a9a6f94730$var$NASHORN_BUG = $e30965a9a6f94730$var$getOwnPropertyDescriptor && !$e30965a9a6f94730$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$e30965a9a6f94730$export$2d1720544b23b823 = $e30965a9a6f94730$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $e30965a9a6f94730$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $e30965a9a6f94730$var$$propertyIsEnumerable;

});

parcelRegister("lTzse", function(module, exports) {
"use strict";
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRegister("2qc3O", function(module, exports) {
"use strict";

var $6Dtay = parcelRequire("6Dtay");

var $8LSRP = parcelRequire("8LSRP");
module.exports = function(it) {
    return $6Dtay($8LSRP(it));
};

});
parcelRegister("6Dtay", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");

var $exTxt = parcelRequire("exTxt");

var $6pTth = parcelRequire("6pTth");
var $4d4d02f927cc84f3$var$$Object = Object;
var $4d4d02f927cc84f3$var$split = $5LwUI("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $exTxt(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$4d4d02f927cc84f3$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $6pTth(it) === "String" ? $4d4d02f927cc84f3$var$split(it, "") : $4d4d02f927cc84f3$var$$Object(it);
} : $4d4d02f927cc84f3$var$$Object;

});

parcelRegister("8LSRP", function(module, exports) {
"use strict";

var $3CYAe = parcelRequire("3CYAe");
var $662d45fff134fa63$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($3CYAe(it)) throw new $662d45fff134fa63$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRegister("3CYAe", function(module, exports) {
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRegister("1HCkX", function(module, exports) {
"use strict";

var $jGL6G = parcelRequire("jGL6G");

var $7A8QC = parcelRequire("7A8QC");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $jGL6G(argument, "string");
    return $7A8QC(key) ? key : key + "";
};

});
parcelRegister("jGL6G", function(module, exports) {
"use strict";

var $gEnMf = parcelRequire("gEnMf");

var $lN83c = parcelRequire("lN83c");

var $7A8QC = parcelRequire("7A8QC");

var $3OFND = parcelRequire("3OFND");

var $3j1QG = parcelRequire("3j1QG");

var $eDVzk = parcelRequire("eDVzk");
var $e5567b005175068a$var$$TypeError = TypeError;
var $e5567b005175068a$var$TO_PRIMITIVE = $eDVzk("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$lN83c(input) || $7A8QC(input)) return input;
    var exoticToPrim = $3OFND(input, $e5567b005175068a$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $gEnMf(exoticToPrim, input, pref);
        if (!$lN83c(result) || $7A8QC(result)) return result;
        throw new $e5567b005175068a$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $3j1QG(input, pref);
};

});
parcelRegister("lN83c", function(module, exports) {
"use strict";

var $b6m5G = parcelRequire("b6m5G");
module.exports = function(it) {
    return typeof it == "object" ? it !== null : $b6m5G(it);
};

});

parcelRegister("7A8QC", function(module, exports) {
"use strict";

var $9kIUQ = parcelRequire("9kIUQ");

var $b6m5G = parcelRequire("b6m5G");

var $d3z84 = parcelRequire("d3z84");

var $cknNs = parcelRequire("cknNs");
var $5852c22e971342fd$var$$Object = Object;
module.exports = $cknNs ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $9kIUQ("Symbol");
    return $b6m5G($Symbol) && $d3z84($Symbol.prototype, $5852c22e971342fd$var$$Object(it));
};

});
parcelRegister("9kIUQ", function(module, exports) {
"use strict";

var $Coo2X = parcelRequire("Coo2X");

var $hABpZ = parcelRequire("hABpZ");

var $b6m5G = parcelRequire("b6m5G");
var $6cb8d2a71a3d4e8e$var$aFunction = function(variable) {
    return $b6m5G(variable) ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $6cb8d2a71a3d4e8e$var$aFunction($Coo2X[namespace]) || $6cb8d2a71a3d4e8e$var$aFunction($hABpZ[namespace]) : $Coo2X[namespace] && $Coo2X[namespace][method] || $hABpZ[namespace] && $hABpZ[namespace][method];
};

});
parcelRegister("Coo2X", function(module, exports) {
"use strict";
module.exports = {};

});


parcelRegister("d3z84", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");
module.exports = $5LwUI({}.isPrototypeOf);

});

parcelRegister("cknNs", function(module, exports) {
"use strict";

var $l2Aa1 = parcelRequire("l2Aa1");
module.exports = $l2Aa1 && !Symbol.sham && typeof Symbol.iterator == "symbol";

});
parcelRegister("l2Aa1", function(module, exports) {
"use strict";

var $1LlCj = parcelRequire("1LlCj");

var $exTxt = parcelRequire("exTxt");

var $hABpZ = parcelRequire("hABpZ");
var $f515d59b7c56e2db$var$$String = $hABpZ.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$exTxt(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$f515d59b7c56e2db$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $1LlCj && $1LlCj < 41;
});

});
parcelRegister("1LlCj", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $EDqfj = parcelRequire("EDqfj");
var $148af2ec3997e5c9$var$process = $hABpZ.process;
var $148af2ec3997e5c9$var$Deno = $hABpZ.Deno;
var $148af2ec3997e5c9$var$versions = $148af2ec3997e5c9$var$process && $148af2ec3997e5c9$var$process.versions || $148af2ec3997e5c9$var$Deno && $148af2ec3997e5c9$var$Deno.version;
var $148af2ec3997e5c9$var$v8 = $148af2ec3997e5c9$var$versions && $148af2ec3997e5c9$var$versions.v8;
var $148af2ec3997e5c9$var$match, $148af2ec3997e5c9$var$version;
if ($148af2ec3997e5c9$var$v8) {
    $148af2ec3997e5c9$var$match = $148af2ec3997e5c9$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $148af2ec3997e5c9$var$version = $148af2ec3997e5c9$var$match[0] > 0 && $148af2ec3997e5c9$var$match[0] < 4 ? 1 : +($148af2ec3997e5c9$var$match[0] + $148af2ec3997e5c9$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$148af2ec3997e5c9$var$version && $EDqfj) {
    $148af2ec3997e5c9$var$match = $EDqfj.match(/Edge\/(\d+)/);
    if (!$148af2ec3997e5c9$var$match || $148af2ec3997e5c9$var$match[1] >= 74) {
        $148af2ec3997e5c9$var$match = $EDqfj.match(/Chrome\/(\d+)/);
        if ($148af2ec3997e5c9$var$match) $148af2ec3997e5c9$var$version = +$148af2ec3997e5c9$var$match[1];
    }
}
module.exports = $148af2ec3997e5c9$var$version;

});
parcelRegister("EDqfj", function(module, exports) {
"use strict";
module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";

});





parcelRegister("3OFND", function(module, exports) {
"use strict";

var $iExYP = parcelRequire("iExYP");

var $3CYAe = parcelRequire("3CYAe");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $3CYAe(func) ? undefined : $iExYP(func);
};

});
parcelRegister("iExYP", function(module, exports) {
"use strict";

var $b6m5G = parcelRequire("b6m5G");

var $iVkkU = parcelRequire("iVkkU");
var $d946522d6fc9c266$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($b6m5G(argument)) return argument;
    throw new $d946522d6fc9c266$var$$TypeError($iVkkU(argument) + " is not a function");
};

});
parcelRegister("iVkkU", function(module, exports) {
"use strict";
var $dc6d53323ee3ce13$var$$String = String;
module.exports = function(argument) {
    try {
        return $dc6d53323ee3ce13$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};

});



parcelRegister("3j1QG", function(module, exports) {
"use strict";

var $gEnMf = parcelRequire("gEnMf");

var $b6m5G = parcelRequire("b6m5G");

var $lN83c = parcelRequire("lN83c");
var $2684948aee58856a$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $b6m5G(fn = input.toString) && !$lN83c(val = $gEnMf(fn, input))) return val;
    if ($b6m5G(fn = input.valueOf) && !$lN83c(val = $gEnMf(fn, input))) return val;
    if (pref !== "string" && $b6m5G(fn = input.toString) && !$lN83c(val = $gEnMf(fn, input))) return val;
    throw new $2684948aee58856a$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRegister("eDVzk", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $hl006 = parcelRequire("hl006");

var $5yW2J = parcelRequire("5yW2J");

var $3tb1A = parcelRequire("3tb1A");

var $l2Aa1 = parcelRequire("l2Aa1");

var $cknNs = parcelRequire("cknNs");
var $aa915d265588d527$var$Symbol = $hABpZ.Symbol;
var $aa915d265588d527$var$WellKnownSymbolsStore = $hl006("wks");
var $aa915d265588d527$var$createWellKnownSymbol = $cknNs ? $aa915d265588d527$var$Symbol["for"] || $aa915d265588d527$var$Symbol : $aa915d265588d527$var$Symbol && $aa915d265588d527$var$Symbol.withoutSetter || $3tb1A;
module.exports = function(name) {
    if (!$5yW2J($aa915d265588d527$var$WellKnownSymbolsStore, name)) $aa915d265588d527$var$WellKnownSymbolsStore[name] = $l2Aa1 && $5yW2J($aa915d265588d527$var$Symbol, name) ? $aa915d265588d527$var$Symbol[name] : $aa915d265588d527$var$createWellKnownSymbol("Symbol." + name);
    return $aa915d265588d527$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("hl006", function(module, exports) {
"use strict";

var $7pQ1s = parcelRequire("7pQ1s");
module.exports = function(key, value) {
    return $7pQ1s[key] || ($7pQ1s[key] = value || {});
};

});
parcelRegister("7pQ1s", function(module, exports) {
"use strict";

var $jzBcD = parcelRequire("jzBcD");

var $hABpZ = parcelRequire("hABpZ");

var $4xmxR = parcelRequire("4xmxR");
var $566338cdfc19da4b$var$SHARED = "__core-js_shared__";
var $566338cdfc19da4b$var$store = module.exports = $hABpZ[$566338cdfc19da4b$var$SHARED] || $4xmxR($566338cdfc19da4b$var$SHARED, {});
($566338cdfc19da4b$var$store.versions || ($566338cdfc19da4b$var$store.versions = [])).push({
    version: "3.36.0",
    mode: $jzBcD ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.36.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

});
parcelRegister("jzBcD", function(module, exports) {
"use strict";
module.exports = true;

});

parcelRegister("4xmxR", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $34dbbb7dc3e562cd$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $34dbbb7dc3e562cd$var$defineProperty($hABpZ, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $hABpZ[key] = value;
    }
    return value;
};

});



parcelRegister("5yW2J", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");

var $98l3K = parcelRequire("98l3K");
var $40cd26de00d6b66c$var$hasOwnProperty = $5LwUI({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $40cd26de00d6b66c$var$hasOwnProperty($98l3K(it), key);
};

});
parcelRegister("98l3K", function(module, exports) {
"use strict";

var $8LSRP = parcelRequire("8LSRP");
var $6a653267912c834c$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $6a653267912c834c$var$$Object($8LSRP(argument));
};

});


parcelRegister("3tb1A", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");
var $286ca1cf4eb556a3$var$id = 0;
var $286ca1cf4eb556a3$var$postfix = Math.random();
var $286ca1cf4eb556a3$var$toString = $5LwUI(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $286ca1cf4eb556a3$var$toString(++$286ca1cf4eb556a3$var$id + $286ca1cf4eb556a3$var$postfix, 36);
};

});




parcelRegister("g9cQK", function(module, exports) {
"use strict";

var $bRpwd = parcelRequire("bRpwd");

var $exTxt = parcelRequire("exTxt");

var $aJpuL = parcelRequire("aJpuL");
// Thanks to IE8 for its funny defineProperty
module.exports = !$bRpwd && !$exTxt(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($aJpuL("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

});
parcelRegister("aJpuL", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $lN83c = parcelRequire("lN83c");
var $7d01e22f5a53f147$var$document = $hABpZ.document;
// typeof document.createElement is 'object' in old IE
var $7d01e22f5a53f147$var$EXISTS = $lN83c($7d01e22f5a53f147$var$document) && $lN83c($7d01e22f5a53f147$var$document.createElement);
module.exports = function(it) {
    return $7d01e22f5a53f147$var$EXISTS ? $7d01e22f5a53f147$var$document.createElement(it) : {};
};

});



parcelRegister("9YuS6", function(module, exports) {
"use strict";

var $exTxt = parcelRequire("exTxt");

var $b6m5G = parcelRequire("b6m5G");
var $7431aa1f54b19152$var$replacement = /#|\.prototype\./;
var $7431aa1f54b19152$var$isForced = function(feature, detection) {
    var value = $7431aa1f54b19152$var$data[$7431aa1f54b19152$var$normalize(feature)];
    return value === $7431aa1f54b19152$var$POLYFILL ? true : value === $7431aa1f54b19152$var$NATIVE ? false : $b6m5G(detection) ? $exTxt(detection) : !!detection;
};
var $7431aa1f54b19152$var$normalize = $7431aa1f54b19152$var$isForced.normalize = function(string) {
    return String(string).replace($7431aa1f54b19152$var$replacement, ".").toLowerCase();
};
var $7431aa1f54b19152$var$data = $7431aa1f54b19152$var$isForced.data = {};
var $7431aa1f54b19152$var$NATIVE = $7431aa1f54b19152$var$isForced.NATIVE = "N";
var $7431aa1f54b19152$var$POLYFILL = $7431aa1f54b19152$var$isForced.POLYFILL = "P";
module.exports = $7431aa1f54b19152$var$isForced;

});

parcelRegister("6RDFO", function(module, exports) {
"use strict";

var $8U5A2 = parcelRequire("8U5A2");

var $iExYP = parcelRequire("iExYP");

var $bGPRT = parcelRequire("bGPRT");
var $4ff6779e3f99e758$var$bind = $8U5A2($8U5A2.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $iExYP(fn);
    return that === undefined ? fn : $bGPRT ? $4ff6779e3f99e758$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});

parcelRegister("ecDbR", function(module, exports) {
"use strict";

var $bRpwd = parcelRequire("bRpwd");

var $lbReU = parcelRequire("lbReU");

var $lTzse = parcelRequire("lTzse");
module.exports = $bRpwd ? function(object, key, value) {
    return $lbReU.f(object, key, $lTzse(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("lbReU", function(module, exports) {

$parcel$export(module.exports, "f", () => $f6d3ec51414ff3d9$export$2d1720544b23b823, (v) => $f6d3ec51414ff3d9$export$2d1720544b23b823 = v);
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $f6d3ec51414ff3d9$export$2d1720544b23b823;
"use strict";

var $bRpwd = parcelRequire("bRpwd");

var $g9cQK = parcelRequire("g9cQK");

var $hfPRi = parcelRequire("hfPRi");

var $grMRt = parcelRequire("grMRt");

var $1HCkX = parcelRequire("1HCkX");
var $f6d3ec51414ff3d9$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $f6d3ec51414ff3d9$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $f6d3ec51414ff3d9$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f6d3ec51414ff3d9$var$ENUMERABLE = "enumerable";
var $f6d3ec51414ff3d9$var$CONFIGURABLE = "configurable";
var $f6d3ec51414ff3d9$var$WRITABLE = "writable";
$f6d3ec51414ff3d9$export$2d1720544b23b823 = $bRpwd ? $hfPRi ? function defineProperty(O, P, Attributes) {
    $grMRt(O);
    P = $1HCkX(P);
    $grMRt(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $f6d3ec51414ff3d9$var$WRITABLE in Attributes && !Attributes[$f6d3ec51414ff3d9$var$WRITABLE]) {
        var current = $f6d3ec51414ff3d9$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$f6d3ec51414ff3d9$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $f6d3ec51414ff3d9$var$CONFIGURABLE in Attributes ? Attributes[$f6d3ec51414ff3d9$var$CONFIGURABLE] : current[$f6d3ec51414ff3d9$var$CONFIGURABLE],
                enumerable: $f6d3ec51414ff3d9$var$ENUMERABLE in Attributes ? Attributes[$f6d3ec51414ff3d9$var$ENUMERABLE] : current[$f6d3ec51414ff3d9$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $f6d3ec51414ff3d9$var$$defineProperty(O, P, Attributes);
} : $f6d3ec51414ff3d9$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $grMRt(O);
    P = $1HCkX(P);
    $grMRt(Attributes);
    if ($g9cQK) try {
        return $f6d3ec51414ff3d9$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $f6d3ec51414ff3d9$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("hfPRi", function(module, exports) {
"use strict";

var $bRpwd = parcelRequire("bRpwd");

var $exTxt = parcelRequire("exTxt");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $bRpwd && $exTxt(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});

});

parcelRegister("grMRt", function(module, exports) {
"use strict";

var $lN83c = parcelRequire("lN83c");
var $bf9511d847cfee79$var$$String = String;
var $bf9511d847cfee79$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($lN83c(argument)) return argument;
    throw new $bf9511d847cfee79$var$$TypeError($bf9511d847cfee79$var$$String(argument) + " is not an object");
};

});




parcelRegister("jWAOX", function(module, exports) {
"use strict";

var $5yW2J = parcelRequire("5yW2J");

var $b6m5G = parcelRequire("b6m5G");

var $98l3K = parcelRequire("98l3K");

var $8LZim = parcelRequire("8LZim");

var $5ZOtZ = parcelRequire("5ZOtZ");
var $e84ffef9c8ec6345$var$IE_PROTO = $8LZim("IE_PROTO");
var $e84ffef9c8ec6345$var$$Object = Object;
var $e84ffef9c8ec6345$var$ObjectPrototype = $e84ffef9c8ec6345$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $5ZOtZ ? $e84ffef9c8ec6345$var$$Object.getPrototypeOf : function(O) {
    var object = $98l3K(O);
    if ($5yW2J(object, $e84ffef9c8ec6345$var$IE_PROTO)) return object[$e84ffef9c8ec6345$var$IE_PROTO];
    var constructor = object.constructor;
    if ($b6m5G(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $e84ffef9c8ec6345$var$$Object ? $e84ffef9c8ec6345$var$ObjectPrototype : null;
};

});
parcelRegister("8LZim", function(module, exports) {
"use strict";

var $hl006 = parcelRequire("hl006");

var $3tb1A = parcelRequire("3tb1A");
var $01a5f8d0563b79d3$var$keys = $hl006("keys");
module.exports = function(key) {
    return $01a5f8d0563b79d3$var$keys[key] || ($01a5f8d0563b79d3$var$keys[key] = $3tb1A(key));
};

});

parcelRegister("5ZOtZ", function(module, exports) {
"use strict";

var $exTxt = parcelRequire("exTxt");
module.exports = !$exTxt(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});


parcelRegister("islHO", function(module, exports) {
"use strict";

var $gMBvf = parcelRequire("gMBvf");

var $grMRt = parcelRequire("grMRt");

var $dRQjX = parcelRequire("dRQjX");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $gMBvf(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $grMRt(O);
        $dRQjX(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRegister("gMBvf", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");

var $iExYP = parcelRequire("iExYP");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $5LwUI($iExYP(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRegister("dRQjX", function(module, exports) {
"use strict";

var $fqboM = parcelRequire("fqboM");
var $a188cf71a221ecda$var$$String = String;
var $a188cf71a221ecda$var$$TypeError = TypeError;
module.exports = function(argument) {
    if ($fqboM(argument)) return argument;
    throw new $a188cf71a221ecda$var$$TypeError("Can't set " + $a188cf71a221ecda$var$$String(argument) + " as a prototype");
};

});
parcelRegister("fqboM", function(module, exports) {
"use strict";

var $lN83c = parcelRequire("lN83c");
module.exports = function(argument) {
    return $lN83c(argument) || argument === null;
};

});



parcelRegister("ii0lQ", function(module, exports) {
"use strict";

var $5yW2J = parcelRequire("5yW2J");

var $h0Ej0 = parcelRequire("h0Ej0");

var $ecn8s = parcelRequire("ecn8s");

var $lbReU = parcelRequire("lbReU");
module.exports = function(target, source, exceptions) {
    var keys = $h0Ej0(source);
    var defineProperty = $lbReU.f;
    var getOwnPropertyDescriptor = $ecn8s.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$5yW2J(target, key) && !(exceptions && $5yW2J(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRegister("h0Ej0", function(module, exports) {
"use strict";

var $9kIUQ = parcelRequire("9kIUQ");

var $5LwUI = parcelRequire("5LwUI");

var $dYn8N = parcelRequire("dYn8N");

var $a4hd5 = parcelRequire("a4hd5");

var $grMRt = parcelRequire("grMRt");
var $c621b39b73a78cb8$var$concat = $5LwUI([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $9kIUQ("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $dYn8N.f($grMRt(it));
    var getOwnPropertySymbols = $a4hd5.f;
    return getOwnPropertySymbols ? $c621b39b73a78cb8$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRegister("dYn8N", function(module, exports) {

$parcel$export(module.exports, "f", () => $a2c2d44361d5a77d$export$2d1720544b23b823, (v) => $a2c2d44361d5a77d$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $a2c2d44361d5a77d$export$2d1720544b23b823;
"use strict";

var $dHgS1 = parcelRequire("dHgS1");

var $cKiQH = parcelRequire("cKiQH");
var $a2c2d44361d5a77d$var$hiddenKeys = $cKiQH.concat("length", "prototype");
$a2c2d44361d5a77d$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $dHgS1(O, $a2c2d44361d5a77d$var$hiddenKeys);
};

});
parcelRegister("dHgS1", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");

var $5yW2J = parcelRequire("5yW2J");

var $2qc3O = parcelRequire("2qc3O");

var $8H31y = parcelRequire("8H31y");
var $9f8c609ceb89bbc5$require$indexOf = $8H31y.indexOf;

var $i7Xpa = parcelRequire("i7Xpa");
var $9f8c609ceb89bbc5$var$push = $5LwUI([].push);
module.exports = function(object, names) {
    var O = $2qc3O(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$5yW2J($i7Xpa, key) && $5yW2J(O, key) && $9f8c609ceb89bbc5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($5yW2J(O, key = names[i++])) ~$9f8c609ceb89bbc5$require$indexOf(result, key) || $9f8c609ceb89bbc5$var$push(result, key);
    return result;
};

});
parcelRegister("8H31y", function(module, exports) {
"use strict";

var $2qc3O = parcelRequire("2qc3O");

var $gdyqR = parcelRequire("gdyqR");

var $1KacB = parcelRequire("1KacB");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $6544af6136e7a803$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $2qc3O($this);
        var length = $1KacB(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $gdyqR(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $6544af6136e7a803$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $6544af6136e7a803$var$createMethod(false)
};

});
parcelRegister("gdyqR", function(module, exports) {
"use strict";

var $eurCa = parcelRequire("eurCa");
var $bce891c1453c37dd$var$max = Math.max;
var $bce891c1453c37dd$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $eurCa(index);
    return integer < 0 ? $bce891c1453c37dd$var$max(integer + length, 0) : $bce891c1453c37dd$var$min(integer, length);
};

});
parcelRegister("eurCa", function(module, exports) {
"use strict";

var $dGO1F = parcelRequire("dGO1F");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $dGO1F(number);
};

});
parcelRegister("dGO1F", function(module, exports) {
"use strict";
var $9f7600aecb2b502e$var$ceil = Math.ceil;
var $9f7600aecb2b502e$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $9f7600aecb2b502e$var$floor : $9f7600aecb2b502e$var$ceil)(n);
};

});



parcelRegister("1KacB", function(module, exports) {
"use strict";

var $lYcyT = parcelRequire("lYcyT");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $lYcyT(obj.length);
};

});
parcelRegister("lYcyT", function(module, exports) {
"use strict";

var $eurCa = parcelRequire("eurCa");
var $ffe8f219752c8b52$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = $eurCa(argument);
    return len > 0 ? $ffe8f219752c8b52$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});



parcelRegister("i7Xpa", function(module, exports) {
"use strict";
module.exports = {};

});


parcelRegister("cKiQH", function(module, exports) {
"use strict";
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

});


parcelRegister("a4hd5", function(module, exports) {

$parcel$export(module.exports, "f", () => $7547a0a9d223aa3f$export$2d1720544b23b823, (v) => $7547a0a9d223aa3f$export$2d1720544b23b823 = v);
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $7547a0a9d223aa3f$export$2d1720544b23b823;
"use strict";
$7547a0a9d223aa3f$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRegister("eB5VD", function(module, exports) {
"use strict";

var $grMRt = parcelRequire("grMRt");

var $iFKLQ = parcelRequire("iFKLQ");

var $cKiQH = parcelRequire("cKiQH");

var $i7Xpa = parcelRequire("i7Xpa");

var $c3nBV = parcelRequire("c3nBV");

var $aJpuL = parcelRequire("aJpuL");

var $8LZim = parcelRequire("8LZim");
var $aa091eac16a29b35$var$GT = ">";
var $aa091eac16a29b35$var$LT = "<";
var $aa091eac16a29b35$var$PROTOTYPE = "prototype";
var $aa091eac16a29b35$var$SCRIPT = "script";
var $aa091eac16a29b35$var$IE_PROTO = $8LZim("IE_PROTO");
var $aa091eac16a29b35$var$EmptyConstructor = function() {};
var $aa091eac16a29b35$var$scriptTag = function(content) {
    return $aa091eac16a29b35$var$LT + $aa091eac16a29b35$var$SCRIPT + $aa091eac16a29b35$var$GT + content + $aa091eac16a29b35$var$LT + "/" + $aa091eac16a29b35$var$SCRIPT + $aa091eac16a29b35$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $aa091eac16a29b35$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($aa091eac16a29b35$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $aa091eac16a29b35$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $aJpuL("iframe");
    var JS = "java" + $aa091eac16a29b35$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $c3nBV.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($aa091eac16a29b35$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $aa091eac16a29b35$var$activeXDocument;
var $aa091eac16a29b35$var$NullProtoObject = function() {
    try {
        $aa091eac16a29b35$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $aa091eac16a29b35$var$NullProtoObject = typeof document != "undefined" ? document.domain && $aa091eac16a29b35$var$activeXDocument ? $aa091eac16a29b35$var$NullProtoObjectViaActiveX($aa091eac16a29b35$var$activeXDocument) // old IE
     : $aa091eac16a29b35$var$NullProtoObjectViaIFrame() : $aa091eac16a29b35$var$NullProtoObjectViaActiveX($aa091eac16a29b35$var$activeXDocument); // WSH
    var length = $cKiQH.length;
    while(length--)delete $aa091eac16a29b35$var$NullProtoObject[$aa091eac16a29b35$var$PROTOTYPE][$cKiQH[length]];
    return $aa091eac16a29b35$var$NullProtoObject();
};
$i7Xpa[$aa091eac16a29b35$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $aa091eac16a29b35$var$EmptyConstructor[$aa091eac16a29b35$var$PROTOTYPE] = $grMRt(O);
        result = new $aa091eac16a29b35$var$EmptyConstructor();
        $aa091eac16a29b35$var$EmptyConstructor[$aa091eac16a29b35$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$aa091eac16a29b35$var$IE_PROTO] = O;
    } else result = $aa091eac16a29b35$var$NullProtoObject();
    return Properties === undefined ? result : $iFKLQ.f(result, Properties);
};

});
parcelRegister("iFKLQ", function(module, exports) {

$parcel$export(module.exports, "f", () => $d98055fd906696e0$export$2d1720544b23b823, (v) => $d98055fd906696e0$export$2d1720544b23b823 = v);
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $d98055fd906696e0$export$2d1720544b23b823;
"use strict";

var $bRpwd = parcelRequire("bRpwd");

var $hfPRi = parcelRequire("hfPRi");

var $lbReU = parcelRequire("lbReU");

var $grMRt = parcelRequire("grMRt");

var $2qc3O = parcelRequire("2qc3O");

var $lizGR = parcelRequire("lizGR");
$d98055fd906696e0$export$2d1720544b23b823 = $bRpwd && !$hfPRi ? Object.defineProperties : function defineProperties(O, Properties) {
    $grMRt(O);
    var props = $2qc3O(Properties);
    var keys = $lizGR(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$lbReU.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRegister("lizGR", function(module, exports) {
"use strict";

var $dHgS1 = parcelRequire("dHgS1");

var $cKiQH = parcelRequire("cKiQH");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $dHgS1(O, $cKiQH);
};

});


parcelRegister("c3nBV", function(module, exports) {
"use strict";

var $9kIUQ = parcelRequire("9kIUQ");
module.exports = $9kIUQ("document", "documentElement");

});


parcelRegister("iHPDa", function(module, exports) {
"use strict";

var $lN83c = parcelRequire("lN83c");

var $ecDbR = parcelRequire("ecDbR");
// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function(O, options) {
    if ($lN83c(options) && "cause" in options) $ecDbR(O, "cause", options.cause);
};

});

parcelRegister("5asq9", function(module, exports) {
"use strict";

var $ecDbR = parcelRequire("ecDbR");

var $hFq00 = parcelRequire("hFq00");

var $hrqlx = parcelRequire("hrqlx");
// non-standard V8
var $3c33eeb9288fccb3$var$captureStackTrace = Error.captureStackTrace;
module.exports = function(error, C, stack, dropEntries) {
    if ($hrqlx) {
        if ($3c33eeb9288fccb3$var$captureStackTrace) $3c33eeb9288fccb3$var$captureStackTrace(error, C);
        else $ecDbR(error, "stack", $hFq00(stack, dropEntries));
    }
};

});
parcelRegister("hFq00", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");
var $cdca6ee262a15b50$var$$Error = Error;
var $cdca6ee262a15b50$var$replace = $5LwUI("".replace);
var $cdca6ee262a15b50$var$TEST = function(arg) {
    return String(new $cdca6ee262a15b50$var$$Error(arg).stack);
}("zxcasd");
// eslint-disable-next-line redos/no-vulnerable -- safe
var $cdca6ee262a15b50$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $cdca6ee262a15b50$var$IS_V8_OR_CHAKRA_STACK = $cdca6ee262a15b50$var$V8_OR_CHAKRA_STACK_ENTRY.test($cdca6ee262a15b50$var$TEST);
module.exports = function(stack, dropEntries) {
    if ($cdca6ee262a15b50$var$IS_V8_OR_CHAKRA_STACK && typeof stack == "string" && !$cdca6ee262a15b50$var$$Error.prepareStackTrace) while(dropEntries--)stack = $cdca6ee262a15b50$var$replace(stack, $cdca6ee262a15b50$var$V8_OR_CHAKRA_STACK_ENTRY, "");
    return stack;
};

});

parcelRegister("hrqlx", function(module, exports) {
"use strict";

var $exTxt = parcelRequire("exTxt");

var $lTzse = parcelRequire("lTzse");
module.exports = !$exTxt(function() {
    var error = new Error("a");
    if (!("stack" in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, "stack", $lTzse(1, 7));
    return error.stack !== 7;
});

});


parcelRegister("hdk2G", function(module, exports) {
"use strict";

var $6RDFO = parcelRequire("6RDFO");

var $gEnMf = parcelRequire("gEnMf");

var $grMRt = parcelRequire("grMRt");

var $iVkkU = parcelRequire("iVkkU");

var $hGBkA = parcelRequire("hGBkA");

var $1KacB = parcelRequire("1KacB");

var $d3z84 = parcelRequire("d3z84");

var $arLvK = parcelRequire("arLvK");

var $c3PFC = parcelRequire("c3PFC");

var $32dkQ = parcelRequire("32dkQ");
var $c8833287b870c09d$var$$TypeError = TypeError;
var $c8833287b870c09d$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $c8833287b870c09d$var$ResultPrototype = $c8833287b870c09d$var$Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $6RDFO(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $32dkQ(iterator, "normal", condition);
        return new $c8833287b870c09d$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $grMRt(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $c3PFC(iterable);
        if (!iterFn) throw new $c8833287b870c09d$var$$TypeError($iVkkU(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($hGBkA(iterFn)) {
            for(index = 0, length = $1KacB(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $d3z84($c8833287b870c09d$var$ResultPrototype, result)) return result;
            }
            return new $c8833287b870c09d$var$Result(false);
        }
        iterator = $arLvK(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $gEnMf(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $32dkQ(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $d3z84($c8833287b870c09d$var$ResultPrototype, result)) return result;
    }
    return new $c8833287b870c09d$var$Result(false);
};

});
parcelRegister("hGBkA", function(module, exports) {
"use strict";

var $eDVzk = parcelRequire("eDVzk");

var $3kOCp = parcelRequire("3kOCp");
var $ce03510feb410aec$var$ITERATOR = $eDVzk("iterator");
var $ce03510feb410aec$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($3kOCp.Array === it || $ce03510feb410aec$var$ArrayPrototype[$ce03510feb410aec$var$ITERATOR] === it);
};

});
parcelRegister("3kOCp", function(module, exports) {
"use strict";
module.exports = {};

});


parcelRegister("arLvK", function(module, exports) {
"use strict";

var $gEnMf = parcelRequire("gEnMf");

var $iExYP = parcelRequire("iExYP");

var $grMRt = parcelRequire("grMRt");

var $iVkkU = parcelRequire("iVkkU");

var $c3PFC = parcelRequire("c3PFC");
var $79b147af43899ab5$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $c3PFC(argument) : usingIterator;
    if ($iExYP(iteratorMethod)) return $grMRt($gEnMf(iteratorMethod, argument));
    throw new $79b147af43899ab5$var$$TypeError($iVkkU(argument) + " is not iterable");
};

});
parcelRegister("c3PFC", function(module, exports) {
"use strict";

var $axoNj = parcelRequire("axoNj");

var $3OFND = parcelRequire("3OFND");

var $3CYAe = parcelRequire("3CYAe");

var $3kOCp = parcelRequire("3kOCp");

var $eDVzk = parcelRequire("eDVzk");
var $8c7dd88048dc02c8$var$ITERATOR = $eDVzk("iterator");
module.exports = function(it) {
    if (!$3CYAe(it)) return $3OFND(it, $8c7dd88048dc02c8$var$ITERATOR) || $3OFND(it, "@@iterator") || $3kOCp[$axoNj(it)];
};

});
parcelRegister("axoNj", function(module, exports) {
"use strict";

var $dV9JU = parcelRequire("dV9JU");

var $b6m5G = parcelRequire("b6m5G");

var $6pTth = parcelRequire("6pTth");

var $eDVzk = parcelRequire("eDVzk");
var $7ac0381e7468aad9$var$TO_STRING_TAG = $eDVzk("toStringTag");
var $7ac0381e7468aad9$var$$Object = Object;
// ES3 wrong here
var $7ac0381e7468aad9$var$CORRECT_ARGUMENTS = $6pTth(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $7ac0381e7468aad9$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $dV9JU ? $6pTth : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $7ac0381e7468aad9$var$tryGet(O = $7ac0381e7468aad9$var$$Object(it), $7ac0381e7468aad9$var$TO_STRING_TAG)) == "string" ? tag : $7ac0381e7468aad9$var$CORRECT_ARGUMENTS ? $6pTth(O) : (result = $6pTth(O)) === "Object" && $b6m5G(O.callee) ? "Arguments" : result;
};

});
parcelRegister("dV9JU", function(module, exports) {
"use strict";

var $eDVzk = parcelRequire("eDVzk");
var $a22827451a74ea75$var$TO_STRING_TAG = $eDVzk("toStringTag");
var $a22827451a74ea75$var$test = {};
$a22827451a74ea75$var$test[$a22827451a74ea75$var$TO_STRING_TAG] = "z";
module.exports = String($a22827451a74ea75$var$test) === "[object z]";

});




parcelRegister("32dkQ", function(module, exports) {
"use strict";

var $gEnMf = parcelRequire("gEnMf");

var $grMRt = parcelRequire("grMRt");

var $3OFND = parcelRequire("3OFND");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $grMRt(iterator);
    try {
        innerResult = $3OFND(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $gEnMf(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $grMRt(innerResult);
    return value;
};

});


parcelRegister("6ABIb", function(module, exports) {
"use strict";

var $jI5pt = parcelRequire("jI5pt");
module.exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? "" : $default : $jI5pt(argument);
};

});
parcelRegister("jI5pt", function(module, exports) {
"use strict";

var $axoNj = parcelRequire("axoNj");
var $e59652a9c2b0496d$var$$String = String;
module.exports = function(argument) {
    if ($axoNj(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $e59652a9c2b0496d$var$$String(argument);
};

});




parcelRegister("ibslp", function(module, exports) {
"use strict";

var $2qc3O = parcelRequire("2qc3O");

var $b49jL = parcelRequire("b49jL");

var $3kOCp = parcelRequire("3kOCp");

var $5JWSj = parcelRequire("5JWSj");

var $lbReU = parcelRequire("lbReU");
var $d3cf3da83af4169e$require$defineProperty = $lbReU.f;

var $fhKt3 = parcelRequire("fhKt3");

var $bLWJq = parcelRequire("bLWJq");

var $jzBcD = parcelRequire("jzBcD");

var $bRpwd = parcelRequire("bRpwd");
var $d3cf3da83af4169e$var$ARRAY_ITERATOR = "Array Iterator";
var $d3cf3da83af4169e$var$setInternalState = $5JWSj.set;
var $d3cf3da83af4169e$var$getInternalState = $5JWSj.getterFor($d3cf3da83af4169e$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $fhKt3(Array, "Array", function(iterated, kind) {
    $d3cf3da83af4169e$var$setInternalState(this, {
        type: $d3cf3da83af4169e$var$ARRAY_ITERATOR,
        target: $2qc3O(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $d3cf3da83af4169e$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $bLWJq(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return $bLWJq(index, false);
        case "values":
            return $bLWJq(target[index], false);
    }
    return $bLWJq([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $d3cf3da83af4169e$var$values = $3kOCp.Arguments = $3kOCp.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$b49jL("keys");
$b49jL("values");
$b49jL("entries");
// V8 ~ Chrome 45- bug
if (!$jzBcD && $bRpwd && $d3cf3da83af4169e$var$values.name !== "values") try {
    $d3cf3da83af4169e$require$defineProperty($d3cf3da83af4169e$var$values, "name", {
        value: "values"
    });
} catch (error) {}

});
parcelRegister("b49jL", function(module, exports) {
"use strict";
module.exports = function() {};

});

parcelRegister("5JWSj", function(module, exports) {
"use strict";

var $4veic = parcelRequire("4veic");

var $hABpZ = parcelRequire("hABpZ");

var $lN83c = parcelRequire("lN83c");

var $ecDbR = parcelRequire("ecDbR");

var $5yW2J = parcelRequire("5yW2J");

var $7pQ1s = parcelRequire("7pQ1s");

var $8LZim = parcelRequire("8LZim");

var $i7Xpa = parcelRequire("i7Xpa");
var $42ded30dfbcb7f11$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $42ded30dfbcb7f11$var$TypeError = $hABpZ.TypeError;
var $42ded30dfbcb7f11$var$WeakMap = $hABpZ.WeakMap;
var $42ded30dfbcb7f11$var$set, $42ded30dfbcb7f11$var$get, $42ded30dfbcb7f11$var$has;
var $42ded30dfbcb7f11$var$enforce = function(it) {
    return $42ded30dfbcb7f11$var$has(it) ? $42ded30dfbcb7f11$var$get(it) : $42ded30dfbcb7f11$var$set(it, {});
};
var $42ded30dfbcb7f11$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$lN83c(it) || (state = $42ded30dfbcb7f11$var$get(it)).type !== TYPE) throw new $42ded30dfbcb7f11$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($4veic || $7pQ1s.state) {
    var $42ded30dfbcb7f11$var$store = $7pQ1s.state || ($7pQ1s.state = new $42ded30dfbcb7f11$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $42ded30dfbcb7f11$var$store.get = $42ded30dfbcb7f11$var$store.get;
    $42ded30dfbcb7f11$var$store.has = $42ded30dfbcb7f11$var$store.has;
    $42ded30dfbcb7f11$var$store.set = $42ded30dfbcb7f11$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $42ded30dfbcb7f11$var$set = function(it, metadata) {
        if ($42ded30dfbcb7f11$var$store.has(it)) throw new $42ded30dfbcb7f11$var$TypeError($42ded30dfbcb7f11$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $42ded30dfbcb7f11$var$store.set(it, metadata);
        return metadata;
    };
    $42ded30dfbcb7f11$var$get = function(it) {
        return $42ded30dfbcb7f11$var$store.get(it) || {};
    };
    $42ded30dfbcb7f11$var$has = function(it) {
        return $42ded30dfbcb7f11$var$store.has(it);
    };
} else {
    var $42ded30dfbcb7f11$var$STATE = $8LZim("state");
    $i7Xpa[$42ded30dfbcb7f11$var$STATE] = true;
    $42ded30dfbcb7f11$var$set = function(it, metadata) {
        if ($5yW2J(it, $42ded30dfbcb7f11$var$STATE)) throw new $42ded30dfbcb7f11$var$TypeError($42ded30dfbcb7f11$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $ecDbR(it, $42ded30dfbcb7f11$var$STATE, metadata);
        return metadata;
    };
    $42ded30dfbcb7f11$var$get = function(it) {
        return $5yW2J(it, $42ded30dfbcb7f11$var$STATE) ? it[$42ded30dfbcb7f11$var$STATE] : {};
    };
    $42ded30dfbcb7f11$var$has = function(it) {
        return $5yW2J(it, $42ded30dfbcb7f11$var$STATE);
    };
}
module.exports = {
    set: $42ded30dfbcb7f11$var$set,
    get: $42ded30dfbcb7f11$var$get,
    has: $42ded30dfbcb7f11$var$has,
    enforce: $42ded30dfbcb7f11$var$enforce,
    getterFor: $42ded30dfbcb7f11$var$getterFor
};

});
parcelRegister("4veic", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $b6m5G = parcelRequire("b6m5G");
var $347524dc9b49d1b6$var$WeakMap = $hABpZ.WeakMap;
module.exports = $b6m5G($347524dc9b49d1b6$var$WeakMap) && /native code/.test(String($347524dc9b49d1b6$var$WeakMap));

});


parcelRegister("fhKt3", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $gEnMf = parcelRequire("gEnMf");

var $jzBcD = parcelRequire("jzBcD");

var $kjMZO = parcelRequire("kjMZO");

var $b6m5G = parcelRequire("b6m5G");

var $eAeje = parcelRequire("eAeje");

var $jWAOX = parcelRequire("jWAOX");

var $islHO = parcelRequire("islHO");

var $gNVUk = parcelRequire("gNVUk");

var $ecDbR = parcelRequire("ecDbR");

var $cstRO = parcelRequire("cstRO");

var $eDVzk = parcelRequire("eDVzk");

var $3kOCp = parcelRequire("3kOCp");

var $fkvjB = parcelRequire("fkvjB");
var $b20c7d0b429388a4$var$PROPER_FUNCTION_NAME = $kjMZO.PROPER;
var $b20c7d0b429388a4$var$CONFIGURABLE_FUNCTION_NAME = $kjMZO.CONFIGURABLE;
var $b20c7d0b429388a4$var$IteratorPrototype = $fkvjB.IteratorPrototype;
var $b20c7d0b429388a4$var$BUGGY_SAFARI_ITERATORS = $fkvjB.BUGGY_SAFARI_ITERATORS;
var $b20c7d0b429388a4$var$ITERATOR = $eDVzk("iterator");
var $b20c7d0b429388a4$var$KEYS = "keys";
var $b20c7d0b429388a4$var$VALUES = "values";
var $b20c7d0b429388a4$var$ENTRIES = "entries";
var $b20c7d0b429388a4$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $eAeje(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$b20c7d0b429388a4$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $b20c7d0b429388a4$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $b20c7d0b429388a4$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $b20c7d0b429388a4$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$b20c7d0b429388a4$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$b20c7d0b429388a4$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $jWAOX(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$jzBcD && $jWAOX(CurrentIteratorPrototype) !== $b20c7d0b429388a4$var$IteratorPrototype) {
                if ($islHO) $islHO(CurrentIteratorPrototype, $b20c7d0b429388a4$var$IteratorPrototype);
                else if (!$b6m5G(CurrentIteratorPrototype[$b20c7d0b429388a4$var$ITERATOR])) $cstRO(CurrentIteratorPrototype, $b20c7d0b429388a4$var$ITERATOR, $b20c7d0b429388a4$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $gNVUk(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($jzBcD) $3kOCp[TO_STRING_TAG] = $b20c7d0b429388a4$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($b20c7d0b429388a4$var$PROPER_FUNCTION_NAME && DEFAULT === $b20c7d0b429388a4$var$VALUES && nativeIterator && nativeIterator.name !== $b20c7d0b429388a4$var$VALUES) {
        if (!$jzBcD && $b20c7d0b429388a4$var$CONFIGURABLE_FUNCTION_NAME) $ecDbR(IterablePrototype, "name", $b20c7d0b429388a4$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $gEnMf(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($b20c7d0b429388a4$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($b20c7d0b429388a4$var$KEYS),
            entries: getIterationMethod($b20c7d0b429388a4$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($b20c7d0b429388a4$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $cstRO(IterablePrototype, KEY, methods[KEY]);
        } else $cdFQY({
            target: NAME,
            proto: true,
            forced: $b20c7d0b429388a4$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$jzBcD || FORCED) && IterablePrototype[$b20c7d0b429388a4$var$ITERATOR] !== defaultIterator) $cstRO(IterablePrototype, $b20c7d0b429388a4$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $3kOCp[NAME] = defaultIterator;
    return methods;
};

});
parcelRegister("kjMZO", function(module, exports) {
"use strict";

var $bRpwd = parcelRequire("bRpwd");

var $5yW2J = parcelRequire("5yW2J");
var $ecab96943632d59f$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ecab96943632d59f$var$getDescriptor = $bRpwd && Object.getOwnPropertyDescriptor;
var $ecab96943632d59f$var$EXISTS = $5yW2J($ecab96943632d59f$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $ecab96943632d59f$var$PROPER = $ecab96943632d59f$var$EXISTS && (function something() {}).name === "something";
var $ecab96943632d59f$var$CONFIGURABLE = $ecab96943632d59f$var$EXISTS && (!$bRpwd || $bRpwd && $ecab96943632d59f$var$getDescriptor($ecab96943632d59f$var$FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: $ecab96943632d59f$var$EXISTS,
    PROPER: $ecab96943632d59f$var$PROPER,
    CONFIGURABLE: $ecab96943632d59f$var$CONFIGURABLE
};

});

parcelRegister("eAeje", function(module, exports) {
"use strict";

var $fkvjB = parcelRequire("fkvjB");
var $a9df86fa57a7e781$require$IteratorPrototype = $fkvjB.IteratorPrototype;

var $eB5VD = parcelRequire("eB5VD");

var $lTzse = parcelRequire("lTzse");

var $gNVUk = parcelRequire("gNVUk");

var $3kOCp = parcelRequire("3kOCp");
var $a9df86fa57a7e781$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $eB5VD($a9df86fa57a7e781$require$IteratorPrototype, {
        next: $lTzse(+!ENUMERABLE_NEXT, next)
    });
    $gNVUk(IteratorConstructor, TO_STRING_TAG, false, true);
    $3kOCp[TO_STRING_TAG] = $a9df86fa57a7e781$var$returnThis;
    return IteratorConstructor;
};

});
parcelRegister("fkvjB", function(module, exports) {
"use strict";

var $exTxt = parcelRequire("exTxt");

var $b6m5G = parcelRequire("b6m5G");

var $lN83c = parcelRequire("lN83c");

var $eB5VD = parcelRequire("eB5VD");

var $jWAOX = parcelRequire("jWAOX");

var $cstRO = parcelRequire("cstRO");

var $eDVzk = parcelRequire("eDVzk");

var $jzBcD = parcelRequire("jzBcD");
var $b29103cfe45ae2dc$var$ITERATOR = $eDVzk("iterator");
var $b29103cfe45ae2dc$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $b29103cfe45ae2dc$var$IteratorPrototype, $b29103cfe45ae2dc$var$PrototypeOfArrayIteratorPrototype, $b29103cfe45ae2dc$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $b29103cfe45ae2dc$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $b29103cfe45ae2dc$var$arrayIterator)) $b29103cfe45ae2dc$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $b29103cfe45ae2dc$var$PrototypeOfArrayIteratorPrototype = $jWAOX($jWAOX($b29103cfe45ae2dc$var$arrayIterator));
        if ($b29103cfe45ae2dc$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $b29103cfe45ae2dc$var$IteratorPrototype = $b29103cfe45ae2dc$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $b29103cfe45ae2dc$var$NEW_ITERATOR_PROTOTYPE = !$lN83c($b29103cfe45ae2dc$var$IteratorPrototype) || $exTxt(function() {
    var test = {};
    // FF44- legacy iterators case
    return $b29103cfe45ae2dc$var$IteratorPrototype[$b29103cfe45ae2dc$var$ITERATOR].call(test) !== test;
});
if ($b29103cfe45ae2dc$var$NEW_ITERATOR_PROTOTYPE) $b29103cfe45ae2dc$var$IteratorPrototype = {};
else if ($jzBcD) $b29103cfe45ae2dc$var$IteratorPrototype = $eB5VD($b29103cfe45ae2dc$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$b6m5G($b29103cfe45ae2dc$var$IteratorPrototype[$b29103cfe45ae2dc$var$ITERATOR])) $cstRO($b29103cfe45ae2dc$var$IteratorPrototype, $b29103cfe45ae2dc$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $b29103cfe45ae2dc$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $b29103cfe45ae2dc$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRegister("cstRO", function(module, exports) {
"use strict";

var $ecDbR = parcelRequire("ecDbR");
module.exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $ecDbR(target, key, value);
    return target;
};

});


parcelRegister("gNVUk", function(module, exports) {
"use strict";

var $dV9JU = parcelRequire("dV9JU");

var $lbReU = parcelRequire("lbReU");
var $c3be2428b58b5ee3$require$defineProperty = $lbReU.f;

var $ecDbR = parcelRequire("ecDbR");

var $5yW2J = parcelRequire("5yW2J");

var $cvc91 = parcelRequire("cvc91");

var $eDVzk = parcelRequire("eDVzk");
var $c3be2428b58b5ee3$var$TO_STRING_TAG = $eDVzk("toStringTag");
module.exports = function(it, TAG, STATIC, SET_METHOD) {
    var target = STATIC ? it : it && it.prototype;
    if (target) {
        if (!$5yW2J(target, $c3be2428b58b5ee3$var$TO_STRING_TAG)) $c3be2428b58b5ee3$require$defineProperty(target, $c3be2428b58b5ee3$var$TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$dV9JU) $ecDbR(target, "toString", $cvc91);
    }
};

});
parcelRegister("cvc91", function(module, exports) {
"use strict";

var $dV9JU = parcelRequire("dV9JU");

var $axoNj = parcelRequire("axoNj");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $dV9JU ? ({}).toString : function toString() {
    return "[object " + $axoNj(this) + "]";
};

});




parcelRegister("bLWJq", function(module, exports) {
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRegister("l6fHX", function(module, exports) {
// empty

});

parcelRegister("hEXW9", function(module, exports) {
"use strict";
parcelRequire("472LL");
parcelRequire("fwxHx");
parcelRequire("dWYBu");
parcelRequire("NGorT");
parcelRequire("kfWNF");
parcelRequire("1YCI5");

});
parcelRegister("472LL", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $jzBcD = parcelRequire("jzBcD");

var $dfKU4 = parcelRequire("dfKU4");

var $hABpZ = parcelRequire("hABpZ");

var $gEnMf = parcelRequire("gEnMf");

var $cstRO = parcelRequire("cstRO");

var $islHO = parcelRequire("islHO");

var $gNVUk = parcelRequire("gNVUk");

var $aLKaU = parcelRequire("aLKaU");

var $iExYP = parcelRequire("iExYP");

var $b6m5G = parcelRequire("b6m5G");

var $lN83c = parcelRequire("lN83c");

var $4zsVt = parcelRequire("4zsVt");

var $aXgKe = parcelRequire("aXgKe");

var $hNQSh = parcelRequire("hNQSh");
var $2fe9f6d61edc4499$require$task = $hNQSh.set;

var $dMdLb = parcelRequire("dMdLb");

var $hhXWH = parcelRequire("hhXWH");

var $axveU = parcelRequire("axveU");

var $4qE8n = parcelRequire("4qE8n");

var $5JWSj = parcelRequire("5JWSj");

var $244a1 = parcelRequire("244a1");

var $evhT8 = parcelRequire("evhT8");

var $cLDUH = parcelRequire("cLDUH");
var $2fe9f6d61edc4499$var$PROMISE = "Promise";
var $2fe9f6d61edc4499$var$FORCED_PROMISE_CONSTRUCTOR = $evhT8.CONSTRUCTOR;
var $2fe9f6d61edc4499$var$NATIVE_PROMISE_REJECTION_EVENT = $evhT8.REJECTION_EVENT;
var $2fe9f6d61edc4499$var$NATIVE_PROMISE_SUBCLASSING = $evhT8.SUBCLASSING;
var $2fe9f6d61edc4499$var$getInternalPromiseState = $5JWSj.getterFor($2fe9f6d61edc4499$var$PROMISE);
var $2fe9f6d61edc4499$var$setInternalState = $5JWSj.set;
var $2fe9f6d61edc4499$var$NativePromisePrototype = $244a1 && $244a1.prototype;
var $2fe9f6d61edc4499$var$PromiseConstructor = $244a1;
var $2fe9f6d61edc4499$var$PromisePrototype = $2fe9f6d61edc4499$var$NativePromisePrototype;
var $2fe9f6d61edc4499$var$TypeError = $hABpZ.TypeError;
var $2fe9f6d61edc4499$var$document = $hABpZ.document;
var $2fe9f6d61edc4499$var$process = $hABpZ.process;
var $2fe9f6d61edc4499$var$newPromiseCapability = $cLDUH.f;
var $2fe9f6d61edc4499$var$newGenericPromiseCapability = $2fe9f6d61edc4499$var$newPromiseCapability;
var $2fe9f6d61edc4499$var$DISPATCH_EVENT = !!($2fe9f6d61edc4499$var$document && $2fe9f6d61edc4499$var$document.createEvent && $hABpZ.dispatchEvent);
var $2fe9f6d61edc4499$var$UNHANDLED_REJECTION = "unhandledrejection";
var $2fe9f6d61edc4499$var$REJECTION_HANDLED = "rejectionhandled";
var $2fe9f6d61edc4499$var$PENDING = 0;
var $2fe9f6d61edc4499$var$FULFILLED = 1;
var $2fe9f6d61edc4499$var$REJECTED = 2;
var $2fe9f6d61edc4499$var$HANDLED = 1;
var $2fe9f6d61edc4499$var$UNHANDLED = 2;
var $2fe9f6d61edc4499$var$Internal, $2fe9f6d61edc4499$var$OwnPromiseCapability, $2fe9f6d61edc4499$var$PromiseWrapper, $2fe9f6d61edc4499$var$nativeThen;
// helpers
var $2fe9f6d61edc4499$var$isThenable = function(it) {
    var then;
    return $lN83c(it) && $b6m5G(then = it.then) ? then : false;
};
var $2fe9f6d61edc4499$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === $2fe9f6d61edc4499$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $2fe9f6d61edc4499$var$UNHANDLED) $2fe9f6d61edc4499$var$onHandleUnhandled(state);
                state.rejection = $2fe9f6d61edc4499$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $2fe9f6d61edc4499$var$TypeError("Promise-chain cycle"));
            else if (then = $2fe9f6d61edc4499$var$isThenable(result)) $gEnMf(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $2fe9f6d61edc4499$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $dMdLb(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$2fe9f6d61edc4499$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $2fe9f6d61edc4499$var$onUnhandled(state);
    });
};
var $2fe9f6d61edc4499$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($2fe9f6d61edc4499$var$DISPATCH_EVENT) {
        event = $2fe9f6d61edc4499$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $hABpZ.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$2fe9f6d61edc4499$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $hABpZ["on" + name])) handler(event);
    else if (name === $2fe9f6d61edc4499$var$UNHANDLED_REJECTION) $hhXWH("Unhandled promise rejection", reason);
};
var $2fe9f6d61edc4499$var$onUnhandled = function(state) {
    $gEnMf($2fe9f6d61edc4499$require$task, $hABpZ, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $2fe9f6d61edc4499$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $axveU(function() {
                if ($dfKU4) $2fe9f6d61edc4499$var$process.emit("unhandledRejection", value, promise);
                else $2fe9f6d61edc4499$var$dispatchEvent($2fe9f6d61edc4499$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $dfKU4 || $2fe9f6d61edc4499$var$isUnhandled(state) ? $2fe9f6d61edc4499$var$UNHANDLED : $2fe9f6d61edc4499$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $2fe9f6d61edc4499$var$isUnhandled = function(state) {
    return state.rejection !== $2fe9f6d61edc4499$var$HANDLED && !state.parent;
};
var $2fe9f6d61edc4499$var$onHandleUnhandled = function(state) {
    $gEnMf($2fe9f6d61edc4499$require$task, $hABpZ, function() {
        var promise = state.facade;
        if ($dfKU4) $2fe9f6d61edc4499$var$process.emit("rejectionHandled", promise);
        else $2fe9f6d61edc4499$var$dispatchEvent($2fe9f6d61edc4499$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $2fe9f6d61edc4499$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $2fe9f6d61edc4499$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $2fe9f6d61edc4499$var$REJECTED;
    $2fe9f6d61edc4499$var$notify(state, true);
};
var $2fe9f6d61edc4499$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $2fe9f6d61edc4499$var$TypeError("Promise can't be resolved itself");
        var then = $2fe9f6d61edc4499$var$isThenable(value);
        if (then) $dMdLb(function() {
            var wrapper = {
                done: false
            };
            try {
                $gEnMf(then, value, $2fe9f6d61edc4499$var$bind($2fe9f6d61edc4499$var$internalResolve, wrapper, state), $2fe9f6d61edc4499$var$bind($2fe9f6d61edc4499$var$internalReject, wrapper, state));
            } catch (error) {
                $2fe9f6d61edc4499$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $2fe9f6d61edc4499$var$FULFILLED;
            $2fe9f6d61edc4499$var$notify(state, false);
        }
    } catch (error) {
        $2fe9f6d61edc4499$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($2fe9f6d61edc4499$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $2fe9f6d61edc4499$var$PromiseConstructor = function Promise(executor) {
        $4zsVt(this, $2fe9f6d61edc4499$var$PromisePrototype);
        $iExYP(executor);
        $gEnMf($2fe9f6d61edc4499$var$Internal, this);
        var state = $2fe9f6d61edc4499$var$getInternalPromiseState(this);
        try {
            executor($2fe9f6d61edc4499$var$bind($2fe9f6d61edc4499$var$internalResolve, state), $2fe9f6d61edc4499$var$bind($2fe9f6d61edc4499$var$internalReject, state));
        } catch (error) {
            $2fe9f6d61edc4499$var$internalReject(state, error);
        }
    };
    $2fe9f6d61edc4499$var$PromisePrototype = $2fe9f6d61edc4499$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $2fe9f6d61edc4499$var$Internal = function Promise(executor) {
        $2fe9f6d61edc4499$var$setInternalState(this, {
            type: $2fe9f6d61edc4499$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $4qE8n(),
            rejection: false,
            state: $2fe9f6d61edc4499$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $2fe9f6d61edc4499$var$Internal.prototype = $cstRO($2fe9f6d61edc4499$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $2fe9f6d61edc4499$var$getInternalPromiseState(this);
        var reaction = $2fe9f6d61edc4499$var$newPromiseCapability($aXgKe(this, $2fe9f6d61edc4499$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $b6m5G(onFulfilled) ? onFulfilled : true;
        reaction.fail = $b6m5G(onRejected) && onRejected;
        reaction.domain = $dfKU4 ? $2fe9f6d61edc4499$var$process.domain : undefined;
        if (state.state === $2fe9f6d61edc4499$var$PENDING) state.reactions.add(reaction);
        else $dMdLb(function() {
            $2fe9f6d61edc4499$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $2fe9f6d61edc4499$var$OwnPromiseCapability = function() {
        var promise = new $2fe9f6d61edc4499$var$Internal();
        var state = $2fe9f6d61edc4499$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $2fe9f6d61edc4499$var$bind($2fe9f6d61edc4499$var$internalResolve, state);
        this.reject = $2fe9f6d61edc4499$var$bind($2fe9f6d61edc4499$var$internalReject, state);
    };
    $cLDUH.f = $2fe9f6d61edc4499$var$newPromiseCapability = function(C) {
        return C === $2fe9f6d61edc4499$var$PromiseConstructor || C === $2fe9f6d61edc4499$var$PromiseWrapper ? new $2fe9f6d61edc4499$var$OwnPromiseCapability(C) : $2fe9f6d61edc4499$var$newGenericPromiseCapability(C);
    };
    if (!$jzBcD && $b6m5G($244a1) && $2fe9f6d61edc4499$var$NativePromisePrototype !== Object.prototype) {
        $2fe9f6d61edc4499$var$nativeThen = $2fe9f6d61edc4499$var$NativePromisePrototype.then;
        if (!$2fe9f6d61edc4499$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $cstRO($2fe9f6d61edc4499$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $2fe9f6d61edc4499$var$PromiseConstructor(function(resolve, reject) {
                $gEnMf($2fe9f6d61edc4499$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $2fe9f6d61edc4499$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($islHO) $islHO($2fe9f6d61edc4499$var$NativePromisePrototype, $2fe9f6d61edc4499$var$PromisePrototype);
    }
}
$cdFQY({
    global: true,
    constructor: true,
    wrap: true,
    forced: $2fe9f6d61edc4499$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $2fe9f6d61edc4499$var$PromiseConstructor
});
$gNVUk($2fe9f6d61edc4499$var$PromiseConstructor, $2fe9f6d61edc4499$var$PROMISE, false, true);
$aLKaU($2fe9f6d61edc4499$var$PROMISE);

});
parcelRegister("dfKU4", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $6pTth = parcelRequire("6pTth");
module.exports = $6pTth($hABpZ.process) === "process";

});

parcelRegister("aLKaU", function(module, exports) {
"use strict";

var $9kIUQ = parcelRequire("9kIUQ");

var $2Kigj = parcelRequire("2Kigj");

var $eDVzk = parcelRequire("eDVzk");

var $bRpwd = parcelRequire("bRpwd");
var $7d721c8771e495f6$var$SPECIES = $eDVzk("species");
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $9kIUQ(CONSTRUCTOR_NAME);
    if ($bRpwd && Constructor && !Constructor[$7d721c8771e495f6$var$SPECIES]) $2Kigj(Constructor, $7d721c8771e495f6$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});
parcelRegister("2Kigj", function(module, exports) {
"use strict";

var $lbReU = parcelRequire("lbReU");
module.exports = function(target, name, descriptor) {
    return $lbReU.f(target, name, descriptor);
};

});


parcelRegister("4zsVt", function(module, exports) {
"use strict";

var $d3z84 = parcelRequire("d3z84");
var $3540de6d3f634ffc$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($d3z84(Prototype, it)) return it;
    throw new $3540de6d3f634ffc$var$$TypeError("Incorrect invocation");
};

});

parcelRegister("aXgKe", function(module, exports) {
"use strict";

var $grMRt = parcelRequire("grMRt");

var $50nPv = parcelRequire("50nPv");

var $3CYAe = parcelRequire("3CYAe");

var $eDVzk = parcelRequire("eDVzk");
var $7f9c67383e985071$var$SPECIES = $eDVzk("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $grMRt(O).constructor;
    var S;
    return C === undefined || $3CYAe(S = $grMRt(C)[$7f9c67383e985071$var$SPECIES]) ? defaultConstructor : $50nPv(S);
};

});
parcelRegister("50nPv", function(module, exports) {
"use strict";

var $gl6kt = parcelRequire("gl6kt");

var $iVkkU = parcelRequire("iVkkU");
var $3a4f6ff3ce438df3$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if ($gl6kt(argument)) return argument;
    throw new $3a4f6ff3ce438df3$var$$TypeError($iVkkU(argument) + " is not a constructor");
};

});
parcelRegister("gl6kt", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");

var $exTxt = parcelRequire("exTxt");

var $b6m5G = parcelRequire("b6m5G");

var $axoNj = parcelRequire("axoNj");

var $9kIUQ = parcelRequire("9kIUQ");

var $3niFn = parcelRequire("3niFn");
var $be53845b86118381$var$noop = function() {};
var $be53845b86118381$var$construct = $9kIUQ("Reflect", "construct");
var $be53845b86118381$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $be53845b86118381$var$exec = $5LwUI($be53845b86118381$var$constructorRegExp.exec);
var $be53845b86118381$var$INCORRECT_TO_STRING = !$be53845b86118381$var$constructorRegExp.test($be53845b86118381$var$noop);
var $be53845b86118381$var$isConstructorModern = function isConstructor(argument) {
    if (!$b6m5G(argument)) return false;
    try {
        $be53845b86118381$var$construct($be53845b86118381$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $be53845b86118381$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$b6m5G(argument)) return false;
    switch($axoNj(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $be53845b86118381$var$INCORRECT_TO_STRING || !!$be53845b86118381$var$exec($be53845b86118381$var$constructorRegExp, $3niFn(argument));
    } catch (error) {
        return true;
    }
};
$be53845b86118381$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$be53845b86118381$var$construct || $exTxt(function() {
    var called;
    return $be53845b86118381$var$isConstructorModern($be53845b86118381$var$isConstructorModern.call) || !$be53845b86118381$var$isConstructorModern(Object) || !$be53845b86118381$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $be53845b86118381$var$isConstructorLegacy : $be53845b86118381$var$isConstructorModern;

});
parcelRegister("3niFn", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");

var $b6m5G = parcelRequire("b6m5G");

var $7pQ1s = parcelRequire("7pQ1s");
var $2751ffd2437f52cb$var$functionToString = $5LwUI(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$b6m5G($7pQ1s.inspectSource)) $7pQ1s.inspectSource = function(it) {
    return $2751ffd2437f52cb$var$functionToString(it);
};
module.exports = $7pQ1s.inspectSource;

});




parcelRegister("hNQSh", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $gyz4Q = parcelRequire("gyz4Q");

var $6RDFO = parcelRequire("6RDFO");

var $b6m5G = parcelRequire("b6m5G");

var $5yW2J = parcelRequire("5yW2J");

var $exTxt = parcelRequire("exTxt");

var $c3nBV = parcelRequire("c3nBV");

var $nQwcI = parcelRequire("nQwcI");

var $aJpuL = parcelRequire("aJpuL");

var $6PMGA = parcelRequire("6PMGA");

var $5KLvv = parcelRequire("5KLvv");

var $dfKU4 = parcelRequire("dfKU4");
var $cf6007047bacca92$var$set = $hABpZ.setImmediate;
var $cf6007047bacca92$var$clear = $hABpZ.clearImmediate;
var $cf6007047bacca92$var$process = $hABpZ.process;
var $cf6007047bacca92$var$Dispatch = $hABpZ.Dispatch;
var $cf6007047bacca92$var$Function = $hABpZ.Function;
var $cf6007047bacca92$var$MessageChannel = $hABpZ.MessageChannel;
var $cf6007047bacca92$var$String = $hABpZ.String;
var $cf6007047bacca92$var$counter = 0;
var $cf6007047bacca92$var$queue = {};
var $cf6007047bacca92$var$ONREADYSTATECHANGE = "onreadystatechange";
var $cf6007047bacca92$var$$location, $cf6007047bacca92$var$defer, $cf6007047bacca92$var$channel, $cf6007047bacca92$var$port;
$exTxt(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $cf6007047bacca92$var$$location = $hABpZ.location;
});
var $cf6007047bacca92$var$run = function(id) {
    if ($5yW2J($cf6007047bacca92$var$queue, id)) {
        var fn = $cf6007047bacca92$var$queue[id];
        delete $cf6007047bacca92$var$queue[id];
        fn();
    }
};
var $cf6007047bacca92$var$runner = function(id) {
    return function() {
        $cf6007047bacca92$var$run(id);
    };
};
var $cf6007047bacca92$var$eventListener = function(event) {
    $cf6007047bacca92$var$run(event.data);
};
var $cf6007047bacca92$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $hABpZ.postMessage($cf6007047bacca92$var$String(id), $cf6007047bacca92$var$$location.protocol + "//" + $cf6007047bacca92$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$cf6007047bacca92$var$set || !$cf6007047bacca92$var$clear) {
    $cf6007047bacca92$var$set = function setImmediate(handler) {
        $6PMGA(arguments.length, 1);
        var fn = $b6m5G(handler) ? handler : $cf6007047bacca92$var$Function(handler);
        var args = $nQwcI(arguments, 1);
        $cf6007047bacca92$var$queue[++$cf6007047bacca92$var$counter] = function() {
            $gyz4Q(fn, undefined, args);
        };
        $cf6007047bacca92$var$defer($cf6007047bacca92$var$counter);
        return $cf6007047bacca92$var$counter;
    };
    $cf6007047bacca92$var$clear = function clearImmediate(id) {
        delete $cf6007047bacca92$var$queue[id];
    };
    // Node.js 0.8-
    if ($dfKU4) $cf6007047bacca92$var$defer = function(id) {
        $cf6007047bacca92$var$process.nextTick($cf6007047bacca92$var$runner(id));
    };
    else if ($cf6007047bacca92$var$Dispatch && $cf6007047bacca92$var$Dispatch.now) $cf6007047bacca92$var$defer = function(id) {
        $cf6007047bacca92$var$Dispatch.now($cf6007047bacca92$var$runner(id));
    };
    else if ($cf6007047bacca92$var$MessageChannel && !$5KLvv) {
        $cf6007047bacca92$var$channel = new $cf6007047bacca92$var$MessageChannel();
        $cf6007047bacca92$var$port = $cf6007047bacca92$var$channel.port2;
        $cf6007047bacca92$var$channel.port1.onmessage = $cf6007047bacca92$var$eventListener;
        $cf6007047bacca92$var$defer = $6RDFO($cf6007047bacca92$var$port.postMessage, $cf6007047bacca92$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($hABpZ.addEventListener && $b6m5G($hABpZ.postMessage) && !$hABpZ.importScripts && $cf6007047bacca92$var$$location && $cf6007047bacca92$var$$location.protocol !== "file:" && !$exTxt($cf6007047bacca92$var$globalPostMessageDefer)) {
        $cf6007047bacca92$var$defer = $cf6007047bacca92$var$globalPostMessageDefer;
        $hABpZ.addEventListener("message", $cf6007047bacca92$var$eventListener, false);
    // IE8-
    } else if ($cf6007047bacca92$var$ONREADYSTATECHANGE in $aJpuL("script")) $cf6007047bacca92$var$defer = function(id) {
        $c3nBV.appendChild($aJpuL("script"))[$cf6007047bacca92$var$ONREADYSTATECHANGE] = function() {
            $c3nBV.removeChild(this);
            $cf6007047bacca92$var$run(id);
        };
    };
    else $cf6007047bacca92$var$defer = function(id) {
        setTimeout($cf6007047bacca92$var$runner(id), 0);
    };
}
module.exports = {
    set: $cf6007047bacca92$var$set,
    clear: $cf6007047bacca92$var$clear
};

});
parcelRegister("nQwcI", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");
module.exports = $5LwUI([].slice);

});

parcelRegister("6PMGA", function(module, exports) {
"use strict";
var $4f9d457e3cb59793$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $4f9d457e3cb59793$var$$TypeError("Not enough arguments");
    return passed;
};

});

parcelRegister("5KLvv", function(module, exports) {
"use strict";

var $EDqfj = parcelRequire("EDqfj");
// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($EDqfj);

});


parcelRegister("dMdLb", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $3FBEO = parcelRequire("3FBEO");

var $6RDFO = parcelRequire("6RDFO");

var $hNQSh = parcelRequire("hNQSh");
var $a07a6e82a74e0162$require$macrotask = $hNQSh.set;

var $4qE8n = parcelRequire("4qE8n");

var $5KLvv = parcelRequire("5KLvv");

var $4GGdp = parcelRequire("4GGdp");

var $gn3hB = parcelRequire("gn3hB");

var $dfKU4 = parcelRequire("dfKU4");
var $a07a6e82a74e0162$var$MutationObserver = $hABpZ.MutationObserver || $hABpZ.WebKitMutationObserver;
var $a07a6e82a74e0162$var$document = $hABpZ.document;
var $a07a6e82a74e0162$var$process = $hABpZ.process;
var $a07a6e82a74e0162$var$Promise = $hABpZ.Promise;
var $a07a6e82a74e0162$var$microtask = $3FBEO("queueMicrotask");
var $a07a6e82a74e0162$var$notify, $a07a6e82a74e0162$var$toggle, $a07a6e82a74e0162$var$node, $a07a6e82a74e0162$var$promise, $a07a6e82a74e0162$var$then;
// modern engines have queueMicrotask method
if (!$a07a6e82a74e0162$var$microtask) {
    var $a07a6e82a74e0162$var$queue = new $4qE8n();
    var $a07a6e82a74e0162$var$flush = function() {
        var parent, fn;
        if ($dfKU4 && (parent = $a07a6e82a74e0162$var$process.domain)) parent.exit();
        while(fn = $a07a6e82a74e0162$var$queue.get())try {
            fn();
        } catch (error) {
            if ($a07a6e82a74e0162$var$queue.head) $a07a6e82a74e0162$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$5KLvv && !$dfKU4 && !$gn3hB && $a07a6e82a74e0162$var$MutationObserver && $a07a6e82a74e0162$var$document) {
        $a07a6e82a74e0162$var$toggle = true;
        $a07a6e82a74e0162$var$node = $a07a6e82a74e0162$var$document.createTextNode("");
        new $a07a6e82a74e0162$var$MutationObserver($a07a6e82a74e0162$var$flush).observe($a07a6e82a74e0162$var$node, {
            characterData: true
        });
        $a07a6e82a74e0162$var$notify = function() {
            $a07a6e82a74e0162$var$node.data = $a07a6e82a74e0162$var$toggle = !$a07a6e82a74e0162$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$4GGdp && $a07a6e82a74e0162$var$Promise && $a07a6e82a74e0162$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $a07a6e82a74e0162$var$promise = $a07a6e82a74e0162$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $a07a6e82a74e0162$var$promise.constructor = $a07a6e82a74e0162$var$Promise;
        $a07a6e82a74e0162$var$then = $6RDFO($a07a6e82a74e0162$var$promise.then, $a07a6e82a74e0162$var$promise);
        $a07a6e82a74e0162$var$notify = function() {
            $a07a6e82a74e0162$var$then($a07a6e82a74e0162$var$flush);
        };
    // Node.js without promises
    } else if ($dfKU4) $a07a6e82a74e0162$var$notify = function() {
        $a07a6e82a74e0162$var$process.nextTick($a07a6e82a74e0162$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $a07a6e82a74e0162$require$macrotask = $6RDFO($a07a6e82a74e0162$require$macrotask, $hABpZ);
        $a07a6e82a74e0162$var$notify = function() {
            $a07a6e82a74e0162$require$macrotask($a07a6e82a74e0162$var$flush);
        };
    }
    $a07a6e82a74e0162$var$microtask = function(fn) {
        if (!$a07a6e82a74e0162$var$queue.head) $a07a6e82a74e0162$var$notify();
        $a07a6e82a74e0162$var$queue.add(fn);
    };
}
module.exports = $a07a6e82a74e0162$var$microtask;

});
parcelRegister("3FBEO", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $bRpwd = parcelRequire("bRpwd");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2ac2695f6e769469$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
module.exports = function(name) {
    if (!$bRpwd) return $hABpZ[name];
    var descriptor = $2ac2695f6e769469$var$getOwnPropertyDescriptor($hABpZ, name);
    return descriptor && descriptor.value;
};

});

parcelRegister("4qE8n", function(module, exports) {
"use strict";
var $3398b8e7aa1a1040$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$3398b8e7aa1a1040$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
module.exports = $3398b8e7aa1a1040$var$Queue;

});

parcelRegister("4GGdp", function(module, exports) {
"use strict";

var $EDqfj = parcelRequire("EDqfj");
module.exports = /ipad|iphone|ipod/i.test($EDqfj) && typeof Pebble != "undefined";

});

parcelRegister("gn3hB", function(module, exports) {
"use strict";

var $EDqfj = parcelRequire("EDqfj");
module.exports = /web0s(?!.*chrome)/i.test($EDqfj);

});


parcelRegister("hhXWH", function(module, exports) {
"use strict";
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

});

parcelRegister("axveU", function(module, exports) {
"use strict";
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRegister("244a1", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");
module.exports = $hABpZ.Promise;

});

parcelRegister("evhT8", function(module, exports) {
"use strict";

var $hABpZ = parcelRequire("hABpZ");

var $244a1 = parcelRequire("244a1");

var $b6m5G = parcelRequire("b6m5G");

var $9YuS6 = parcelRequire("9YuS6");

var $3niFn = parcelRequire("3niFn");

var $eDVzk = parcelRequire("eDVzk");

var $Iy8CV = parcelRequire("Iy8CV");

var $kCGn4 = parcelRequire("kCGn4");

var $jzBcD = parcelRequire("jzBcD");

var $1LlCj = parcelRequire("1LlCj");
var $a8f1d6334a613e6d$var$NativePromisePrototype = $244a1 && $244a1.prototype;
var $a8f1d6334a613e6d$var$SPECIES = $eDVzk("species");
var $a8f1d6334a613e6d$var$SUBCLASSING = false;
var $a8f1d6334a613e6d$var$NATIVE_PROMISE_REJECTION_EVENT = $b6m5G($hABpZ.PromiseRejectionEvent);
var $a8f1d6334a613e6d$var$FORCED_PROMISE_CONSTRUCTOR = $9YuS6("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $3niFn($244a1);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($244a1);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $1LlCj === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($jzBcD && !($a8f1d6334a613e6d$var$NativePromisePrototype["catch"] && $a8f1d6334a613e6d$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$1LlCj || $1LlCj < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $244a1(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$a8f1d6334a613e6d$var$SPECIES] = FakePromise;
        $a8f1d6334a613e6d$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$a8f1d6334a613e6d$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($Iy8CV || $kCGn4) && !$a8f1d6334a613e6d$var$NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
    CONSTRUCTOR: $a8f1d6334a613e6d$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $a8f1d6334a613e6d$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $a8f1d6334a613e6d$var$SUBCLASSING
};

});
parcelRegister("Iy8CV", function(module, exports) {
"use strict";

var $kCGn4 = parcelRequire("kCGn4");

var $dfKU4 = parcelRequire("dfKU4");
module.exports = !$kCGn4 && !$dfKU4 && typeof window == "object" && typeof document == "object";

});
parcelRegister("kCGn4", function(module, exports) {
"use strict";
/* global Deno -- Deno case */ module.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";

});



parcelRegister("cLDUH", function(module, exports) {

$parcel$export(module.exports, "f", () => $94b8d5d4efeb86b4$export$2d1720544b23b823, (v) => $94b8d5d4efeb86b4$export$2d1720544b23b823 = v);
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $94b8d5d4efeb86b4$export$2d1720544b23b823;
"use strict";

var $iExYP = parcelRequire("iExYP");
var $94b8d5d4efeb86b4$var$$TypeError = TypeError;
var $94b8d5d4efeb86b4$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $94b8d5d4efeb86b4$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $iExYP(resolve);
    this.reject = $iExYP(reject);
};
$94b8d5d4efeb86b4$export$2d1720544b23b823 = function(C) {
    return new $94b8d5d4efeb86b4$var$PromiseCapability(C);
};

});


parcelRegister("fwxHx", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $gEnMf = parcelRequire("gEnMf");

var $iExYP = parcelRequire("iExYP");

var $cLDUH = parcelRequire("cLDUH");

var $axveU = parcelRequire("axveU");

var $hdk2G = parcelRequire("hdk2G");

var $41n7l = parcelRequire("41n7l");
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$cdFQY({
    target: "Promise",
    stat: true,
    forced: $41n7l
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $cLDUH.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $axveU(function() {
            var $promiseResolve = $iExYP(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $hdk2G(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $gEnMf($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRegister("41n7l", function(module, exports) {
"use strict";

var $244a1 = parcelRequire("244a1");

var $dhhiQ = parcelRequire("dhhiQ");

var $evhT8 = parcelRequire("evhT8");
var $2ed9300f28d6ab67$require$FORCED_PROMISE_CONSTRUCTOR = $evhT8.CONSTRUCTOR;
module.exports = $2ed9300f28d6ab67$require$FORCED_PROMISE_CONSTRUCTOR || !$dhhiQ(function(iterable) {
    $244a1.all(iterable).then(undefined, function() {});
});

});
parcelRegister("dhhiQ", function(module, exports) {
"use strict";

var $eDVzk = parcelRequire("eDVzk");
var $9aaa48ec48a5ae21$var$ITERATOR = $eDVzk("iterator");
var $9aaa48ec48a5ae21$var$SAFE_CLOSING = false;
try {
    var $9aaa48ec48a5ae21$var$called = 0;
    var $9aaa48ec48a5ae21$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$9aaa48ec48a5ae21$var$called++
            };
        },
        "return": function() {
            $9aaa48ec48a5ae21$var$SAFE_CLOSING = true;
        }
    };
    $9aaa48ec48a5ae21$var$iteratorWithReturn[$9aaa48ec48a5ae21$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($9aaa48ec48a5ae21$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$9aaa48ec48a5ae21$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$9aaa48ec48a5ae21$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});



parcelRegister("dWYBu", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $jzBcD = parcelRequire("jzBcD");

var $evhT8 = parcelRequire("evhT8");
var $a27fb3be64b6edf1$require$FORCED_PROMISE_CONSTRUCTOR = $evhT8.CONSTRUCTOR;

var $244a1 = parcelRequire("244a1");

var $9kIUQ = parcelRequire("9kIUQ");

var $b6m5G = parcelRequire("b6m5G");

var $cstRO = parcelRequire("cstRO");
var $a27fb3be64b6edf1$var$NativePromisePrototype = $244a1 && $244a1.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$cdFQY({
    target: "Promise",
    proto: true,
    forced: $a27fb3be64b6edf1$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$jzBcD && $b6m5G($244a1)) {
    var $a27fb3be64b6edf1$var$method = $9kIUQ("Promise").prototype["catch"];
    if ($a27fb3be64b6edf1$var$NativePromisePrototype["catch"] !== $a27fb3be64b6edf1$var$method) $cstRO($a27fb3be64b6edf1$var$NativePromisePrototype, "catch", $a27fb3be64b6edf1$var$method, {
        unsafe: true
    });
}

});

parcelRegister("NGorT", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $gEnMf = parcelRequire("gEnMf");

var $iExYP = parcelRequire("iExYP");

var $cLDUH = parcelRequire("cLDUH");

var $axveU = parcelRequire("axveU");

var $hdk2G = parcelRequire("hdk2G");

var $41n7l = parcelRequire("41n7l");
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$cdFQY({
    target: "Promise",
    stat: true,
    forced: $41n7l
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $cLDUH.f(C);
        var reject = capability.reject;
        var result = $axveU(function() {
            var $promiseResolve = $iExYP(C.resolve);
            $hdk2G(iterable, function(promise) {
                $gEnMf($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("kfWNF", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $cLDUH = parcelRequire("cLDUH");

var $evhT8 = parcelRequire("evhT8");
var $ebf2d1d275e42af0$require$FORCED_PROMISE_CONSTRUCTOR = $evhT8.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$cdFQY({
    target: "Promise",
    stat: true,
    forced: $ebf2d1d275e42af0$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $cLDUH.f(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});

});

parcelRegister("1YCI5", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $9kIUQ = parcelRequire("9kIUQ");

var $jzBcD = parcelRequire("jzBcD");

var $244a1 = parcelRequire("244a1");

var $evhT8 = parcelRequire("evhT8");
var $17096c0e4527e1ee$require$FORCED_PROMISE_CONSTRUCTOR = $evhT8.CONSTRUCTOR;

var $ipgUE = parcelRequire("ipgUE");
var $17096c0e4527e1ee$var$PromiseConstructorWrapper = $9kIUQ("Promise");
var $17096c0e4527e1ee$var$CHECK_WRAPPER = $jzBcD && !$17096c0e4527e1ee$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$cdFQY({
    target: "Promise",
    stat: true,
    forced: $jzBcD || $17096c0e4527e1ee$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $ipgUE($17096c0e4527e1ee$var$CHECK_WRAPPER && this === $17096c0e4527e1ee$var$PromiseConstructorWrapper ? $244a1 : this, x);
    }
});

});
parcelRegister("ipgUE", function(module, exports) {
"use strict";

var $grMRt = parcelRequire("grMRt");

var $lN83c = parcelRequire("lN83c");

var $cLDUH = parcelRequire("cLDUH");
module.exports = function(C, x) {
    $grMRt(C);
    if ($lN83c(x) && x.constructor === C) return x;
    var promiseCapability = $cLDUH.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});



parcelRegister("hg8N4", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $gEnMf = parcelRequire("gEnMf");

var $iExYP = parcelRequire("iExYP");

var $cLDUH = parcelRequire("cLDUH");

var $axveU = parcelRequire("axveU");

var $hdk2G = parcelRequire("hdk2G");

var $41n7l = parcelRequire("41n7l");
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$cdFQY({
    target: "Promise",
    stat: true,
    forced: $41n7l
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $cLDUH.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $axveU(function() {
            var promiseResolve = $iExYP(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $hdk2G(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $gEnMf(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("4Vefw", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $gEnMf = parcelRequire("gEnMf");

var $iExYP = parcelRequire("iExYP");

var $9kIUQ = parcelRequire("9kIUQ");

var $cLDUH = parcelRequire("cLDUH");

var $axveU = parcelRequire("axveU");

var $hdk2G = parcelRequire("hdk2G");

var $41n7l = parcelRequire("41n7l");
var $395789e8ef2f8015$var$PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$cdFQY({
    target: "Promise",
    stat: true,
    forced: $41n7l
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $9kIUQ("AggregateError");
        var capability = $cLDUH.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $axveU(function() {
            var promiseResolve = $iExYP(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $hdk2G(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $gEnMf(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $395789e8ef2f8015$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $395789e8ef2f8015$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("kG6Xj", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $cLDUH = parcelRequire("cLDUH");
// `Promise.withResolvers` method
// https://github.com/tc39/proposal-promise-with-resolvers
$cdFQY({
    target: "Promise",
    stat: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = $cLDUH.f(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});

});

parcelRegister("53EsF", function(module, exports) {
"use strict";

var $cdFQY = parcelRequire("cdFQY");

var $jzBcD = parcelRequire("jzBcD");

var $244a1 = parcelRequire("244a1");

var $exTxt = parcelRequire("exTxt");

var $9kIUQ = parcelRequire("9kIUQ");

var $b6m5G = parcelRequire("b6m5G");

var $aXgKe = parcelRequire("aXgKe");

var $ipgUE = parcelRequire("ipgUE");

var $cstRO = parcelRequire("cstRO");
var $3aec9e5bb051f98e$var$NativePromisePrototype = $244a1 && $244a1.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $3aec9e5bb051f98e$var$NON_GENERIC = !!$244a1 && $exTxt(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $3aec9e5bb051f98e$var$NativePromisePrototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$cdFQY({
    target: "Promise",
    proto: true,
    real: true,
    forced: $3aec9e5bb051f98e$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $aXgKe(this, $9kIUQ("Promise"));
        var isFunction = $b6m5G(onFinally);
        return this.then(isFunction ? function(x) {
            return $ipgUE(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $ipgUE(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$jzBcD && $b6m5G($244a1)) {
    var $3aec9e5bb051f98e$var$method = $9kIUQ("Promise").prototype["finally"];
    if ($3aec9e5bb051f98e$var$NativePromisePrototype["finally"] !== $3aec9e5bb051f98e$var$method) $cstRO($3aec9e5bb051f98e$var$NativePromisePrototype, "finally", $3aec9e5bb051f98e$var$method, {
        unsafe: true
    });
}

});

parcelRegister("bFp9b", function(module, exports) {
"use strict";

var $9SZjp = parcelRequire("9SZjp");
var $87e707c38274fff1$require$charAt = $9SZjp.charAt;

var $jI5pt = parcelRequire("jI5pt");

var $5JWSj = parcelRequire("5JWSj");

var $fhKt3 = parcelRequire("fhKt3");

var $bLWJq = parcelRequire("bLWJq");
var $87e707c38274fff1$var$STRING_ITERATOR = "String Iterator";
var $87e707c38274fff1$var$setInternalState = $5JWSj.set;
var $87e707c38274fff1$var$getInternalState = $5JWSj.getterFor($87e707c38274fff1$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$fhKt3(String, "String", function(iterated) {
    $87e707c38274fff1$var$setInternalState(this, {
        type: $87e707c38274fff1$var$STRING_ITERATOR,
        string: $jI5pt(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $87e707c38274fff1$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $bLWJq(undefined, true);
    point = $87e707c38274fff1$require$charAt(string, index);
    state.index += point.length;
    return $bLWJq(point, false);
});

});
parcelRegister("9SZjp", function(module, exports) {
"use strict";

var $5LwUI = parcelRequire("5LwUI");

var $eurCa = parcelRequire("eurCa");

var $jI5pt = parcelRequire("jI5pt");

var $8LSRP = parcelRequire("8LSRP");
var $7328b781d443c461$var$charAt = $5LwUI("".charAt);
var $7328b781d443c461$var$charCodeAt = $5LwUI("".charCodeAt);
var $7328b781d443c461$var$stringSlice = $5LwUI("".slice);
var $7328b781d443c461$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $jI5pt($8LSRP($this));
        var position = $eurCa(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $7328b781d443c461$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $7328b781d443c461$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $7328b781d443c461$var$charAt(S, position) : first : CONVERT_TO_STRING ? $7328b781d443c461$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $7328b781d443c461$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $7328b781d443c461$var$createMethod(true)
};

});



parcelRegister("4dRhZ", function(module, exports) {
"use strict";
parcelRequire("ibslp");

var $lpqB7 = parcelRequire("lpqB7");

var $hABpZ = parcelRequire("hABpZ");

var $gNVUk = parcelRequire("gNVUk");

var $3kOCp = parcelRequire("3kOCp");
for(var $3131b66f58dce259$var$COLLECTION_NAME in $lpqB7){
    $gNVUk($hABpZ[$3131b66f58dce259$var$COLLECTION_NAME], $3131b66f58dce259$var$COLLECTION_NAME);
    $3kOCp[$3131b66f58dce259$var$COLLECTION_NAME] = $3kOCp.Array;
}

});
parcelRegister("lpqB7", function(module, exports) {
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});



parcelRegister("3xqnv", function(module, exports) {
// shim for using process in browser
var $2938ea49d0a7f762$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2938ea49d0a7f762$var$cachedSetTimeout;
var $2938ea49d0a7f762$var$cachedClearTimeout;
function $2938ea49d0a7f762$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $2938ea49d0a7f762$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $2938ea49d0a7f762$var$cachedSetTimeout = setTimeout;
        else $2938ea49d0a7f762$var$cachedSetTimeout = $2938ea49d0a7f762$var$defaultSetTimout;
    } catch (e) {
        $2938ea49d0a7f762$var$cachedSetTimeout = $2938ea49d0a7f762$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $2938ea49d0a7f762$var$cachedClearTimeout = clearTimeout;
        else $2938ea49d0a7f762$var$cachedClearTimeout = $2938ea49d0a7f762$var$defaultClearTimeout;
    } catch (e) {
        $2938ea49d0a7f762$var$cachedClearTimeout = $2938ea49d0a7f762$var$defaultClearTimeout;
    }
})();
function $2938ea49d0a7f762$var$runTimeout(fun) {
    if ($2938ea49d0a7f762$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2938ea49d0a7f762$var$cachedSetTimeout === $2938ea49d0a7f762$var$defaultSetTimout || !$2938ea49d0a7f762$var$cachedSetTimeout) && setTimeout) {
        $2938ea49d0a7f762$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2938ea49d0a7f762$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2938ea49d0a7f762$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2938ea49d0a7f762$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2938ea49d0a7f762$var$runClearTimeout(marker) {
    if ($2938ea49d0a7f762$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2938ea49d0a7f762$var$cachedClearTimeout === $2938ea49d0a7f762$var$defaultClearTimeout || !$2938ea49d0a7f762$var$cachedClearTimeout) && clearTimeout) {
        $2938ea49d0a7f762$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2938ea49d0a7f762$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2938ea49d0a7f762$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2938ea49d0a7f762$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2938ea49d0a7f762$var$queue = [];
var $2938ea49d0a7f762$var$draining = false;
var $2938ea49d0a7f762$var$currentQueue;
var $2938ea49d0a7f762$var$queueIndex = -1;
function $2938ea49d0a7f762$var$cleanUpNextTick() {
    if (!$2938ea49d0a7f762$var$draining || !$2938ea49d0a7f762$var$currentQueue) return;
    $2938ea49d0a7f762$var$draining = false;
    if ($2938ea49d0a7f762$var$currentQueue.length) $2938ea49d0a7f762$var$queue = $2938ea49d0a7f762$var$currentQueue.concat($2938ea49d0a7f762$var$queue);
    else $2938ea49d0a7f762$var$queueIndex = -1;
    if ($2938ea49d0a7f762$var$queue.length) $2938ea49d0a7f762$var$drainQueue();
}
function $2938ea49d0a7f762$var$drainQueue() {
    if ($2938ea49d0a7f762$var$draining) return;
    var timeout = $2938ea49d0a7f762$var$runTimeout($2938ea49d0a7f762$var$cleanUpNextTick);
    $2938ea49d0a7f762$var$draining = true;
    var len = $2938ea49d0a7f762$var$queue.length;
    while(len){
        $2938ea49d0a7f762$var$currentQueue = $2938ea49d0a7f762$var$queue;
        $2938ea49d0a7f762$var$queue = [];
        while(++$2938ea49d0a7f762$var$queueIndex < len)if ($2938ea49d0a7f762$var$currentQueue) $2938ea49d0a7f762$var$currentQueue[$2938ea49d0a7f762$var$queueIndex].run();
        $2938ea49d0a7f762$var$queueIndex = -1;
        len = $2938ea49d0a7f762$var$queue.length;
    }
    $2938ea49d0a7f762$var$currentQueue = null;
    $2938ea49d0a7f762$var$draining = false;
    $2938ea49d0a7f762$var$runClearTimeout(timeout);
}
$2938ea49d0a7f762$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2938ea49d0a7f762$var$queue.push(new $2938ea49d0a7f762$var$Item(fun, args));
    if ($2938ea49d0a7f762$var$queue.length === 1 && !$2938ea49d0a7f762$var$draining) $2938ea49d0a7f762$var$runTimeout($2938ea49d0a7f762$var$drainQueue);
};
// v8 likes predictible objects
function $2938ea49d0a7f762$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2938ea49d0a7f762$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2938ea49d0a7f762$var$process.title = "browser";
$2938ea49d0a7f762$var$process.browser = true;
$2938ea49d0a7f762$var$process.env = {};
$2938ea49d0a7f762$var$process.argv = [];
$2938ea49d0a7f762$var$process.version = ""; // empty string to avoid regexp issues
$2938ea49d0a7f762$var$process.versions = {};
function $2938ea49d0a7f762$var$noop() {}
$2938ea49d0a7f762$var$process.on = $2938ea49d0a7f762$var$noop;
$2938ea49d0a7f762$var$process.addListener = $2938ea49d0a7f762$var$noop;
$2938ea49d0a7f762$var$process.once = $2938ea49d0a7f762$var$noop;
$2938ea49d0a7f762$var$process.off = $2938ea49d0a7f762$var$noop;
$2938ea49d0a7f762$var$process.removeListener = $2938ea49d0a7f762$var$noop;
$2938ea49d0a7f762$var$process.removeAllListeners = $2938ea49d0a7f762$var$noop;
$2938ea49d0a7f762$var$process.emit = $2938ea49d0a7f762$var$noop;
$2938ea49d0a7f762$var$process.prependListener = $2938ea49d0a7f762$var$noop;
$2938ea49d0a7f762$var$process.prependOnceListener = $2938ea49d0a7f762$var$noop;
$2938ea49d0a7f762$var$process.listeners = function(name) {
    return [];
};
$2938ea49d0a7f762$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$2938ea49d0a7f762$var$process.cwd = function() {
    return "/";
};
$2938ea49d0a7f762$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$2938ea49d0a7f762$var$process.umask = function() {
    return 0;
};

});

parcelRegister("fQN0Y", function(module, exports) {

$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $b8a1bba90962262f$export$f99ded8fe4b79145, (v) => $b8a1bba90962262f$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $b8a1bba90962262f$export$a143d493d941bafc;
var $b8a1bba90962262f$export$e4cf37d7f6fb9e0a;
var $b8a1bba90962262f$export$f99ded8fe4b79145;
var $b8a1bba90962262f$export$599f31c3813fae4d;
"use strict";

var $btSY6 = parcelRequire("btSY6");

var $idpWM = parcelRequire("idpWM");
var $b8a1bba90962262f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$b8a1bba90962262f$export$a143d493d941bafc = $b8a1bba90962262f$var$Buffer;
$b8a1bba90962262f$export$e4cf37d7f6fb9e0a = $b8a1bba90962262f$var$SlowBuffer;
$b8a1bba90962262f$export$f99ded8fe4b79145 = 50;
var $b8a1bba90962262f$var$K_MAX_LENGTH = 0x7fffffff;
$b8a1bba90962262f$export$599f31c3813fae4d = $b8a1bba90962262f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $b8a1bba90962262f$var$Buffer.TYPED_ARRAY_SUPPORT = $b8a1bba90962262f$var$typedArraySupport();
if (!$b8a1bba90962262f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $b8a1bba90962262f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($b8a1bba90962262f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$b8a1bba90962262f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($b8a1bba90962262f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$b8a1bba90962262f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $b8a1bba90962262f$var$createBuffer(length) {
    if (length > $b8a1bba90962262f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $b8a1bba90962262f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $b8a1bba90962262f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $b8a1bba90962262f$var$allocUnsafe(arg);
    }
    return $b8a1bba90962262f$var$from(arg, encodingOrOffset, length);
}
$b8a1bba90962262f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $b8a1bba90962262f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $b8a1bba90962262f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $b8a1bba90962262f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($b8a1bba90962262f$var$isInstance(value, ArrayBuffer) || value && $b8a1bba90962262f$var$isInstance(value.buffer, ArrayBuffer)) return $b8a1bba90962262f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($b8a1bba90962262f$var$isInstance(value, SharedArrayBuffer) || value && $b8a1bba90962262f$var$isInstance(value.buffer, SharedArrayBuffer))) return $b8a1bba90962262f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $b8a1bba90962262f$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $b8a1bba90962262f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $b8a1bba90962262f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $b8a1bba90962262f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $b8a1bba90962262f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($b8a1bba90962262f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($b8a1bba90962262f$var$Buffer, Uint8Array);
function $b8a1bba90962262f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $b8a1bba90962262f$var$alloc(size, fill, encoding) {
    $b8a1bba90962262f$var$assertSize(size);
    if (size <= 0) return $b8a1bba90962262f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $b8a1bba90962262f$var$createBuffer(size).fill(fill, encoding) : $b8a1bba90962262f$var$createBuffer(size).fill(fill);
    return $b8a1bba90962262f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $b8a1bba90962262f$var$Buffer.alloc = function(size, fill, encoding) {
    return $b8a1bba90962262f$var$alloc(size, fill, encoding);
};
function $b8a1bba90962262f$var$allocUnsafe(size) {
    $b8a1bba90962262f$var$assertSize(size);
    return $b8a1bba90962262f$var$createBuffer(size < 0 ? 0 : $b8a1bba90962262f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $b8a1bba90962262f$var$Buffer.allocUnsafe = function(size) {
    return $b8a1bba90962262f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $b8a1bba90962262f$var$Buffer.allocUnsafeSlow = function(size) {
    return $b8a1bba90962262f$var$allocUnsafe(size);
};
function $b8a1bba90962262f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$b8a1bba90962262f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $b8a1bba90962262f$var$byteLength(string, encoding) | 0;
    var buf = $b8a1bba90962262f$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $b8a1bba90962262f$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $b8a1bba90962262f$var$checked(array.length) | 0;
    var buf = $b8a1bba90962262f$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $b8a1bba90962262f$var$fromArrayView(arrayView) {
    if ($b8a1bba90962262f$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $b8a1bba90962262f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $b8a1bba90962262f$var$fromArrayLike(arrayView);
}
function $b8a1bba90962262f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $b8a1bba90962262f$var$Buffer.prototype);
    return buf;
}
function $b8a1bba90962262f$var$fromObject(obj) {
    if ($b8a1bba90962262f$var$Buffer.isBuffer(obj)) {
        var len = $b8a1bba90962262f$var$checked(obj.length) | 0;
        var buf = $b8a1bba90962262f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $b8a1bba90962262f$var$numberIsNaN(obj.length)) return $b8a1bba90962262f$var$createBuffer(0);
        return $b8a1bba90962262f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $b8a1bba90962262f$var$fromArrayLike(obj.data);
}
function $b8a1bba90962262f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $b8a1bba90962262f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $b8a1bba90962262f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $b8a1bba90962262f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $b8a1bba90962262f$var$Buffer.alloc(+length);
}
$b8a1bba90962262f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $b8a1bba90962262f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$b8a1bba90962262f$var$Buffer.compare = function compare(a, b) {
    if ($b8a1bba90962262f$var$isInstance(a, Uint8Array)) a = $b8a1bba90962262f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($b8a1bba90962262f$var$isInstance(b, Uint8Array)) b = $b8a1bba90962262f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$b8a1bba90962262f$var$Buffer.isBuffer(a) || !$b8a1bba90962262f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$b8a1bba90962262f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$b8a1bba90962262f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $b8a1bba90962262f$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $b8a1bba90962262f$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($b8a1bba90962262f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $b8a1bba90962262f$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$b8a1bba90962262f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $b8a1bba90962262f$var$byteLength(string, encoding) {
    if ($b8a1bba90962262f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $b8a1bba90962262f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $b8a1bba90962262f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $b8a1bba90962262f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $b8a1bba90962262f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$b8a1bba90962262f$var$Buffer.byteLength = $b8a1bba90962262f$var$byteLength;
function $b8a1bba90962262f$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $b8a1bba90962262f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $b8a1bba90962262f$var$utf8Slice(this, start, end);
        case "ascii":
            return $b8a1bba90962262f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $b8a1bba90962262f$var$latin1Slice(this, start, end);
        case "base64":
            return $b8a1bba90962262f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b8a1bba90962262f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$b8a1bba90962262f$var$Buffer.prototype._isBuffer = true;
function $b8a1bba90962262f$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$b8a1bba90962262f$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$b8a1bba90962262f$var$swap(this, i, i + 1);
    return this;
};
$b8a1bba90962262f$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $b8a1bba90962262f$var$swap(this, i, i + 3);
        $b8a1bba90962262f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$b8a1bba90962262f$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $b8a1bba90962262f$var$swap(this, i, i + 7);
        $b8a1bba90962262f$var$swap(this, i + 1, i + 6);
        $b8a1bba90962262f$var$swap(this, i + 2, i + 5);
        $b8a1bba90962262f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$b8a1bba90962262f$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $b8a1bba90962262f$var$utf8Slice(this, 0, length);
    return $b8a1bba90962262f$var$slowToString.apply(this, arguments);
};
$b8a1bba90962262f$var$Buffer.prototype.toLocaleString = $b8a1bba90962262f$var$Buffer.prototype.toString;
$b8a1bba90962262f$var$Buffer.prototype.equals = function equals(b) {
    if (!$b8a1bba90962262f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $b8a1bba90962262f$var$Buffer.compare(this, b) === 0;
};
$b8a1bba90962262f$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $b8a1bba90962262f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($b8a1bba90962262f$var$customInspectSymbol) $b8a1bba90962262f$var$Buffer.prototype[$b8a1bba90962262f$var$customInspectSymbol] = $b8a1bba90962262f$var$Buffer.prototype.inspect;
$b8a1bba90962262f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($b8a1bba90962262f$var$isInstance(target, Uint8Array)) target = $b8a1bba90962262f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$b8a1bba90962262f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $b8a1bba90962262f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($b8a1bba90962262f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $b8a1bba90962262f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($b8a1bba90962262f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $b8a1bba90962262f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $b8a1bba90962262f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $b8a1bba90962262f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$b8a1bba90962262f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$b8a1bba90962262f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $b8a1bba90962262f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$b8a1bba90962262f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $b8a1bba90962262f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $b8a1bba90962262f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($b8a1bba90962262f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $b8a1bba90962262f$var$utf8Write(buf, string, offset, length) {
    return $b8a1bba90962262f$var$blitBuffer($b8a1bba90962262f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $b8a1bba90962262f$var$asciiWrite(buf, string, offset, length) {
    return $b8a1bba90962262f$var$blitBuffer($b8a1bba90962262f$var$asciiToBytes(string), buf, offset, length);
}
function $b8a1bba90962262f$var$base64Write(buf, string, offset, length) {
    return $b8a1bba90962262f$var$blitBuffer($b8a1bba90962262f$var$base64ToBytes(string), buf, offset, length);
}
function $b8a1bba90962262f$var$ucs2Write(buf, string, offset, length) {
    return $b8a1bba90962262f$var$blitBuffer($b8a1bba90962262f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$b8a1bba90962262f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $b8a1bba90962262f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $b8a1bba90962262f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $b8a1bba90962262f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $b8a1bba90962262f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b8a1bba90962262f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$b8a1bba90962262f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $b8a1bba90962262f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $btSY6.fromByteArray(buf);
    else return $btSY6.fromByteArray(buf.slice(start, end));
}
function $b8a1bba90962262f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $b8a1bba90962262f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $b8a1bba90962262f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $b8a1bba90962262f$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $b8a1bba90962262f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $b8a1bba90962262f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $b8a1bba90962262f$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $b8a1bba90962262f$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $b8a1bba90962262f$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $b8a1bba90962262f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $b8a1bba90962262f$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$b8a1bba90962262f$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $b8a1bba90962262f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $b8a1bba90962262f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$b8a1bba90962262f$var$Buffer.prototype.readUintLE = $b8a1bba90962262f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$b8a1bba90962262f$var$Buffer.prototype.readUintBE = $b8a1bba90962262f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$b8a1bba90962262f$var$Buffer.prototype.readUint8 = $b8a1bba90962262f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$b8a1bba90962262f$var$Buffer.prototype.readUint16LE = $b8a1bba90962262f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$b8a1bba90962262f$var$Buffer.prototype.readUint16BE = $b8a1bba90962262f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$b8a1bba90962262f$var$Buffer.prototype.readUint32LE = $b8a1bba90962262f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$b8a1bba90962262f$var$Buffer.prototype.readUint32BE = $b8a1bba90962262f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$b8a1bba90962262f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b8a1bba90962262f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b8a1bba90962262f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$b8a1bba90962262f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b8a1bba90962262f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b8a1bba90962262f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$b8a1bba90962262f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$b8a1bba90962262f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 4, this.length);
    return $idpWM.read(this, offset, true, 23, 4);
};
$b8a1bba90962262f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 4, this.length);
    return $idpWM.read(this, offset, false, 23, 4);
};
$b8a1bba90962262f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 8, this.length);
    return $idpWM.read(this, offset, true, 52, 8);
};
$b8a1bba90962262f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkOffset(offset, 8, this.length);
    return $idpWM.read(this, offset, false, 52, 8);
};
function $b8a1bba90962262f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$b8a1bba90962262f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$b8a1bba90962262f$var$Buffer.prototype.writeUintLE = $b8a1bba90962262f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b8a1bba90962262f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b8a1bba90962262f$var$Buffer.prototype.writeUintBE = $b8a1bba90962262f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b8a1bba90962262f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b8a1bba90962262f$var$Buffer.prototype.writeUint8 = $b8a1bba90962262f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$b8a1bba90962262f$var$Buffer.prototype.writeUint16LE = $b8a1bba90962262f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b8a1bba90962262f$var$Buffer.prototype.writeUint16BE = $b8a1bba90962262f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b8a1bba90962262f$var$Buffer.prototype.writeUint32LE = $b8a1bba90962262f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$b8a1bba90962262f$var$Buffer.prototype.writeUint32BE = $b8a1bba90962262f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$b8a1bba90962262f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $b8a1bba90962262f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b8a1bba90962262f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $b8a1bba90962262f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b8a1bba90962262f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$b8a1bba90962262f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b8a1bba90962262f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b8a1bba90962262f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$b8a1bba90962262f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $b8a1bba90962262f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $b8a1bba90962262f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $idpWM.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$b8a1bba90962262f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $b8a1bba90962262f$var$writeFloat(this, value, offset, true, noAssert);
};
$b8a1bba90962262f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $b8a1bba90962262f$var$writeFloat(this, value, offset, false, noAssert);
};
function $b8a1bba90962262f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b8a1bba90962262f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $idpWM.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$b8a1bba90962262f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $b8a1bba90962262f$var$writeDouble(this, value, offset, true, noAssert);
};
$b8a1bba90962262f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $b8a1bba90962262f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$b8a1bba90962262f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$b8a1bba90962262f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$b8a1bba90962262f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$b8a1bba90962262f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $b8a1bba90962262f$var$Buffer.isBuffer(val) ? val : $b8a1bba90962262f$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $b8a1bba90962262f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $b8a1bba90962262f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($b8a1bba90962262f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $b8a1bba90962262f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $b8a1bba90962262f$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $b8a1bba90962262f$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $b8a1bba90962262f$var$base64ToBytes(str) {
    return $btSY6.toByteArray($b8a1bba90962262f$var$base64clean(str));
}
function $b8a1bba90962262f$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $b8a1bba90962262f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $b8a1bba90962262f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $b8a1bba90962262f$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("btSY6", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $85bd0ab7f855b0fb$export$d622b2ad8d90c771, (v) => $85bd0ab7f855b0fb$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $85bd0ab7f855b0fb$export$6100ba28696e12de, (v) => $85bd0ab7f855b0fb$export$6100ba28696e12de = v);
var $85bd0ab7f855b0fb$export$a48f0734ac7c2329;
var $85bd0ab7f855b0fb$export$d622b2ad8d90c771;
var $85bd0ab7f855b0fb$export$6100ba28696e12de;
"use strict";
$85bd0ab7f855b0fb$export$a48f0734ac7c2329 = $85bd0ab7f855b0fb$var$byteLength;
$85bd0ab7f855b0fb$export$d622b2ad8d90c771 = $85bd0ab7f855b0fb$var$toByteArray;
$85bd0ab7f855b0fb$export$6100ba28696e12de = $85bd0ab7f855b0fb$var$fromByteArray;
var $85bd0ab7f855b0fb$var$lookup = [];
var $85bd0ab7f855b0fb$var$revLookup = [];
var $85bd0ab7f855b0fb$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $85bd0ab7f855b0fb$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $85bd0ab7f855b0fb$var$i = 0, $85bd0ab7f855b0fb$var$len = $85bd0ab7f855b0fb$var$code.length; $85bd0ab7f855b0fb$var$i < $85bd0ab7f855b0fb$var$len; ++$85bd0ab7f855b0fb$var$i){
    $85bd0ab7f855b0fb$var$lookup[$85bd0ab7f855b0fb$var$i] = $85bd0ab7f855b0fb$var$code[$85bd0ab7f855b0fb$var$i];
    $85bd0ab7f855b0fb$var$revLookup[$85bd0ab7f855b0fb$var$code.charCodeAt($85bd0ab7f855b0fb$var$i)] = $85bd0ab7f855b0fb$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$85bd0ab7f855b0fb$var$revLookup["-".charCodeAt(0)] = 62;
$85bd0ab7f855b0fb$var$revLookup["_".charCodeAt(0)] = 63;
function $85bd0ab7f855b0fb$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $85bd0ab7f855b0fb$var$byteLength(b64) {
    var lens = $85bd0ab7f855b0fb$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $85bd0ab7f855b0fb$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $85bd0ab7f855b0fb$var$toByteArray(b64) {
    var tmp;
    var lens = $85bd0ab7f855b0fb$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $85bd0ab7f855b0fb$var$Arr($85bd0ab7f855b0fb$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $85bd0ab7f855b0fb$var$revLookup[b64.charCodeAt(i)] << 18 | $85bd0ab7f855b0fb$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $85bd0ab7f855b0fb$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $85bd0ab7f855b0fb$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $85bd0ab7f855b0fb$var$revLookup[b64.charCodeAt(i)] << 2 | $85bd0ab7f855b0fb$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $85bd0ab7f855b0fb$var$revLookup[b64.charCodeAt(i)] << 10 | $85bd0ab7f855b0fb$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $85bd0ab7f855b0fb$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $85bd0ab7f855b0fb$var$tripletToBase64(num) {
    return $85bd0ab7f855b0fb$var$lookup[num >> 18 & 0x3F] + $85bd0ab7f855b0fb$var$lookup[num >> 12 & 0x3F] + $85bd0ab7f855b0fb$var$lookup[num >> 6 & 0x3F] + $85bd0ab7f855b0fb$var$lookup[num & 0x3F];
}
function $85bd0ab7f855b0fb$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($85bd0ab7f855b0fb$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $85bd0ab7f855b0fb$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($85bd0ab7f855b0fb$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($85bd0ab7f855b0fb$var$lookup[tmp >> 2] + $85bd0ab7f855b0fb$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($85bd0ab7f855b0fb$var$lookup[tmp >> 10] + $85bd0ab7f855b0fb$var$lookup[tmp >> 4 & 0x3F] + $85bd0ab7f855b0fb$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("idpWM", function(module, exports) {

$parcel$export(module.exports, "read", () => $d42d916e816ee951$export$aafa59e2e03f2942, (v) => $d42d916e816ee951$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $d42d916e816ee951$export$68d8715fc104d294, (v) => $d42d916e816ee951$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $d42d916e816ee951$export$aafa59e2e03f2942;
var $d42d916e816ee951$export$68d8715fc104d294;
$d42d916e816ee951$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$d42d916e816ee951$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


var $335c456281ac340f$exports = {};


(parcelRequire("fbycL")).register((parcelRequire("ghbiQ")).getBundleURL("3ufsE"), JSON.parse('["3ufsE","index.js","3s7vm","marker-shadow.8f26ed1f.png","f4Ga2","background.bf75fd73.webp","92ztr","layers.760a0456.png","fHzNM","layers-2x.b7b89169.png","ius7p","marker-icon.3f7d3721.png","crXmN","index.css"]'));

var $ee253cdb7e062133$exports = {};
"use strict";

$ee253cdb7e062133$exports = (parcelRequire("8qmxs"));


parcelRequire("lT7pJ");
var $8bc84ab6fef2cb4e$export$882461b6382ed46c;
var $8bc84ab6fef2cb4e$export$757ceba2d55c277e;
"use strict";
var $104722dc8dfafae7$exports = {};
"use strict";
function $104722dc8dfafae7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($104722dc8dfafae7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$104722dc8dfafae7$var$checkDCE();

$104722dc8dfafae7$exports = (parcelRequire("1E5eb"));


var $8bc84ab6fef2cb4e$var$i;
$8bc84ab6fef2cb4e$export$882461b6382ed46c = $104722dc8dfafae7$exports.createRoot;
$8bc84ab6fef2cb4e$export$757ceba2d55c277e = $104722dc8dfafae7$exports.hydrateRoot;


function $717da5514a866660$export$2e2bcd8739ae039(RetorikAgent, props, element) {
    const root = (0, $8bc84ab6fef2cb4e$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)(RetorikAgent, {
        ...props
    }));
}



parcelRequire("lT7pJ");

function $69bffc2b72abf404$export$2e2bcd8739ae039(RetorikWidget, props, element) {
    const root = (0, $8bc84ab6fef2cb4e$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)(RetorikWidget, {
        ...props
    }));
}



parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");

var $0e6b0d5a9628b095$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0e6b0d5a9628b095$var$ReactIs, $0e6b0d5a9628b095$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$0e6b0d5a9628b095$exports = (parcelRequire("1C9lN"))();


var $1048fd584ae862d4$var$s = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $1048fd584ae862d4$var$f(e, r) {
    return e(r = {
        exports: {}
    }, r.exports), r.exports;
}
var $1048fd584ae862d4$var$p = $1048fd584ae862d4$var$f(function(e) {
    !function(r) {
        var t = function(e, r, n) {
            if (!i(r) || s(r) || f(r) || p(r) || u(r)) return r;
            var o, a = 0, c = 0;
            if (l(r)) for(o = [], c = r.length; a < c; a++)o.push(t(e, r[a], n));
            else for(var d in o = {}, r)Object.prototype.hasOwnProperty.call(r, d) && (o[e(d, n)] = t(e, r[d], n));
            return o;
        }, n = function(e) {
            return d(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(e, r) {
                return r ? r.toUpperCase() : "";
            })).substr(0, 1).toLowerCase() + e.substr(1);
        }, o = function(e) {
            var r = n(e);
            return r.substr(0, 1).toUpperCase() + r.substr(1);
        }, a = function(e, r) {
            return (function(e, r) {
                var t = (r = r || {}).separator || "_", n = r.split || /(?=[A-Z])/;
                return e.split(n).join(t);
            })(e, r).toLowerCase();
        }, c = Object.prototype.toString, u = function(e) {
            return "function" == typeof e;
        }, i = function(e) {
            return e === Object(e);
        }, l = function(e) {
            return "[object Array]" == c.call(e);
        }, s = function(e) {
            return "[object Date]" == c.call(e);
        }, f = function(e) {
            return "[object RegExp]" == c.call(e);
        }, p = function(e) {
            return "[object Boolean]" == c.call(e);
        }, d = function(e) {
            return (e -= 0) == e;
        }, y = function(e, r) {
            var t = r && "process" in r ? r.process : r;
            return "function" != typeof t ? e : function(r, n) {
                return t(r, e, n);
            };
        }, h = {
            camelize: n,
            decamelize: a,
            pascalize: o,
            depascalize: a,
            camelizeKeys: function(e, r) {
                return t(y(n, r), e);
            },
            decamelizeKeys: function(e, r) {
                return t(y(a, r), e, r);
            },
            pascalizeKeys: function(e, r) {
                return t(y(o, r), e);
            },
            depascalizeKeys: function() {
                return this.decamelizeKeys.apply(this, arguments);
            }
        };
        e.exports ? e.exports = h : r.humps = h;
    }($1048fd584ae862d4$var$s);
}).decamelize, $1048fd584ae862d4$var$d = $1048fd584ae862d4$var$f(function(e) {
    function r() {
        return e.exports = r = Object.assign || function(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = arguments[r];
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }
            return e;
        }, r.apply(this, arguments);
    }
    e.exports = r;
});
var $1048fd584ae862d4$var$y = function(e) {
    if (Array.isArray(e)) return e;
};
var $1048fd584ae862d4$var$h = function(e, r) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var t = [], n = !0, o = !1, a = void 0;
        try {
            for(var c, u = e[Symbol.iterator](); !(n = (c = u.next()).done) && (t.push(c.value), !r || t.length !== r); n = !0);
        } catch (e) {
            o = !0, a = e;
        } finally{
            try {
                n || null == u.return || u.return();
            } finally{
                if (o) throw a;
            }
        }
        return t;
    }
};
var $1048fd584ae862d4$var$v = function(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
    return n;
};
var $1048fd584ae862d4$var$m = function(e, r) {
    if (e) {
        if ("string" == typeof e) return $1048fd584ae862d4$var$v(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1048fd584ae862d4$var$v(e, r) : void 0;
    }
};
var $1048fd584ae862d4$var$b = function() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var $1048fd584ae862d4$var$g = function(e, r) {
    return $1048fd584ae862d4$var$y(e) || $1048fd584ae862d4$var$h(e, r) || $1048fd584ae862d4$var$m(e, r) || $1048fd584ae862d4$var$b();
};
var $1048fd584ae862d4$var$S = function(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
    return o;
};
var $1048fd584ae862d4$var$w = function(e, r) {
    if (null == e) return {};
    var t, n, o = $1048fd584ae862d4$var$S(e, r);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(n = 0; n < a.length; n++)t = a[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
    return o;
};
var $1048fd584ae862d4$var$O = (0, $lT7pJ.createContext)(null);
function $1048fd584ae862d4$var$j(e) {
    var r = e.root, t = e.children;
    return (0, $104722dc8dfafae7$exports.createPortal)(t, r);
}
function $1048fd584ae862d4$var$x(n) {
    var u = (0, $lT7pJ.forwardRef)(function(o, u) {
        var i, l, s = o.mode, f = o.delegatesFocus, p = o.styleSheets, y = o.ssr, h = o.children, v = $1048fd584ae862d4$var$w(o, [
            "mode",
            "delegatesFocus",
            "styleSheets",
            "ssr",
            "children"
        ]), m = (l = (0, $lT7pJ.useRef)((i = u) && i.current), (0, $lT7pJ.useEffect)(function() {
            i && (i.current = l.current);
        }, [
            i
        ]), l), b = (0, $lT7pJ.useState)(null), S = $1048fd584ae862d4$var$g(b, 2), x = S[0], z = S[1], E = "node_".concat(s).concat(f);
        return (0, $lT7pJ.useLayoutEffect)(function() {
            if (m.current) try {
                if ("function" == typeof u && u(m.current), y) {
                    var e = m.current.shadowRoot;
                    return void z(e);
                }
                var r = m.current.attachShadow({
                    mode: s,
                    delegatesFocus: f
                });
                p.length > 0 && (r.adoptedStyleSheets = p), z(r);
            } catch (e) {
                !function(e) {
                    var r = e.error, t = e.styleSheets, n = e.root;
                    switch(r.name){
                        case "NotSupportedError":
                            t.length > 0 && (n.adoptedStyleSheets = t);
                            break;
                        default:
                            throw r;
                    }
                }({
                    error: e,
                    styleSheets: p,
                    root: x
                });
            }
        }, [
            u,
            m,
            p
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement(n.tag, $1048fd584ae862d4$var$d({
            key: E,
            ref: m
        }, v), (x || y) && (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement($1048fd584ae862d4$var$O.Provider, {
            value: x
        }, y ? (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("template", {
            shadowroot: "open"
        }, n.render({
            root: x,
            ssr: y,
            children: h
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement($1048fd584ae862d4$var$j, {
            root: x
        }, n.render({
            root: x,
            ssr: y,
            children: h
        })))));
    });
    return u.propTypes = {
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOf([
            "open",
            "closed"
        ]),
        delegatesFocus: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        styleSheets: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(globalThis.CSSStyleSheet)),
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).node
    }, u.defaultProps = {
        mode: "open",
        delegatesFocus: !1,
        styleSheets: [],
        ssr: !1,
        children: null
    }, u;
}
$1048fd584ae862d4$var$j.propTypes = {
    root: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).node
}, $1048fd584ae862d4$var$j.defaultProps = {
    children: null
};
var $1048fd584ae862d4$var$z = new Map;
function $1048fd584ae862d4$export$64d45095031fa749() {
    return (0, $lT7pJ.useContext)($1048fd584ae862d4$var$O);
}
function $1048fd584ae862d4$export$7865d0c7f908de6b() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core", t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(e) {
        return e.children;
    };
    return new Proxy(e, {
        get: function(e, n) {
            var o = $1048fd584ae862d4$var$p(n, {
                separator: "-"
            }), a = "".concat(r, "-").concat(o);
            return $1048fd584ae862d4$var$z.has(a) || $1048fd584ae862d4$var$z.set(a, $1048fd584ae862d4$var$x({
                tag: o,
                render: t
            })), $1048fd584ae862d4$var$z.get(a);
        }
    });
}
var $1048fd584ae862d4$var$P = $1048fd584ae862d4$export$7865d0c7f908de6b();
var $1048fd584ae862d4$export$2e2bcd8739ae039 = $1048fd584ae862d4$var$P;


parcelRequire("lT7pJ");
var $227de6ae7c8b1320$exports = {};
$227de6ae7c8b1320$exports = "*,:before,:after{box-sizing:border-box;border:0 solid}:before,:after{--tw-content:\"\"}html,:host{-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent;font-family:Calibri,sans-serif;line-height:1.5}body{line-height:inherit;margin:0}hr{color:inherit;border-top-width:1px;height:0}abbr:where([title]){text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-feature-settings:normal;font-variation-settings:normal;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-feature-settings:inherit;font-variation-settings:inherit;font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:#0000;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}dialog{padding:0}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after,::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.rf-pointer-events-none{pointer-events:none}.rf-pointer-events-auto{pointer-events:auto}.rf-visible{visibility:visible}.rf-invisible{visibility:hidden}.rf-fixed{position:fixed}.rf-absolute{position:absolute}.rf-relative{position:relative}.-rf-left-6{left:-1.5rem}.-rf-top-2{top:-.5rem}.-rf-top-4{top:-1rem}.-rf-top-6{top:-1.5rem}.-rf-top-\\[1\\.15rem\\]{top:-1.15rem}.rf-bottom-0{bottom:0}.rf-bottom-1{bottom:.25rem}.rf-bottom-1\\/4{bottom:25%}.rf-bottom-10{bottom:2.5rem}.rf-bottom-16{bottom:4rem}.rf-bottom-2{bottom:.5rem}.rf-bottom-4{bottom:1rem}.rf-bottom-40{bottom:10rem}.rf-left-0{left:0}.rf-left-1{left:.25rem}.rf-left-1\\/2{left:50%}.rf-left-2{left:.5rem}.rf-left-4{left:1rem}.rf-left-8{left:2rem}.rf-right-0{right:0}.rf-right-1{right:.25rem}.rf-right-2{right:.5rem}.rf-right-3{right:.75rem}.rf-right-4{right:1rem}.rf-right-6{right:1.5rem}.rf-right-8{right:2rem}.rf-top-0{top:0}.rf-top-1{top:.25rem}.rf-top-1\\/2{top:50%}.rf-top-1\\/3{top:33.3333%}.rf-top-110{top:110%}.rf-top-2{top:.5rem}.rf-top-4{top:1rem}.rf-top-\\[0\\.125rem\\]{top:.125rem}.rf-z-background{z-index:0}.rf-z-chatbot{z-index:10}.rf-z-detailedPOI{z-index:2}.rf-z-dropdown{z-index:30}.rf-z-exitwidget{z-index:55}.rf-z-menu{z-index:40}.rf-z-modal{z-index:50}.rf-z-overlay{z-index:40}.rf-z-ui{z-index:20}.rf-z-util{z-index:1}.rf-col-span-2{grid-column:span 2/span 2}.rf-col-span-3{grid-column:span 3/span 3}.rf-col-span-6{grid-column:span 6/span 6}.rf-col-span-full{grid-column:1/-1}.rf-col-start-1{grid-column-start:1}.rf-col-start-2{grid-column-start:2}.rf-col-start-4{grid-column-start:4}.rf-col-start-5{grid-column-start:5}.rf-col-end-13{grid-column-end:13}.rf-col-end-2{grid-column-end:2}.rf-col-end-9{grid-column-end:9}.rf-row-span-1{grid-row:span 1/span 1}.rf-row-span-2{grid-row:span 2/span 2}.rf-row-span-3{grid-row:span 3/span 3}.rf-row-span-5{grid-row:span 5/span 5}.rf-row-span-6{grid-row:span 6/span 6}.rf-row-span-9{grid-row:span 9/span 9}.rf-row-span-full{grid-row:1/-1}.rf-row-start-1{grid-row-start:1}.rf-row-start-12{grid-row-start:12}.rf-row-start-2{grid-row-start:2}.rf-row-start-3{grid-row-start:3}.rf-row-start-4{grid-row-start:4}.rf-row-start-6{grid-row-start:6}.rf-row-start-9{grid-row-start:9}.rf-row-end-12{grid-row-end:12}.rf-row-end-13{grid-row-end:13}.rf-row-end-2{grid-row-end:2}.rf-row-end-3{grid-row-end:3}.rf-row-end-4{grid-row-end:4}.rf-row-end-5{grid-row-end:5}.rf-float-right{float:right}.rf-m-0{margin:0}.rf-m-4{margin:1rem}.rf-m-auto{margin:auto}.-rf-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.rf-mx-0{margin-left:0;margin-right:0}.rf-mx-2{margin-left:.5rem;margin-right:.5rem}.rf-mx-3{margin-left:.75rem;margin-right:.75rem}.rf-mx-8{margin-left:2rem;margin-right:2rem}.rf-mx-auto{margin-left:auto;margin-right:auto}.rf-my-1{margin-top:.25rem;margin-bottom:.25rem}.rf-my-2{margin-top:.5rem;margin-bottom:.5rem}.rf-my-4{margin-top:1rem;margin-bottom:1rem}.rf-my-auto{margin-top:auto;margin-bottom:auto}.-rf-mb-4{margin-bottom:-1rem}.-rf-ml-2{margin-left:-.5rem}.rf-mb-0{margin-bottom:0}.rf-mb-1{margin-bottom:.25rem}.rf-mb-12{margin-bottom:3rem}.rf-mb-16{margin-bottom:4rem}.rf-mb-2{margin-bottom:.5rem}.rf-mb-26{margin-bottom:6.5rem}.rf-mb-28{margin-bottom:7rem}.rf-mb-3{margin-bottom:.75rem}.rf-mb-30{margin-bottom:7.5rem}.rf-mb-4{margin-bottom:1rem}.rf-mb-5{margin-bottom:1.25rem}.rf-mb-6{margin-bottom:1.5rem}.rf-mb-8{margin-bottom:2rem}.rf-ml-1{margin-left:.25rem}.rf-ml-2{margin-left:.5rem}.rf-ml-4{margin-left:1rem}.rf-ml-6{margin-left:1.5rem}.rf-mr-1{margin-right:.25rem}.rf-mr-2{margin-right:.5rem}.rf-mr-3{margin-right:.75rem}.rf-mr-4{margin-right:1rem}.rf-mr-5{margin-right:1.25rem}.rf-mt-1{margin-top:.25rem}.rf-mt-10{margin-top:2.5rem}.rf-mt-2{margin-top:.5rem}.rf-mt-4{margin-top:1rem}.rf-mt-5{margin-top:1.25rem}.rf-mt-8{margin-top:2rem}.rf-mt-\\[0\\.2rem\\]{margin-top:.2rem}.rf-mt-auto{margin-top:auto}.rf-line-clamp-1{-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-2{-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-inline{display:inline}.rf-flex{display:flex}.rf-grid{display:grid}.rf-hidden{display:none}.rf-aspect-\\[4\\/3\\]{aspect-ratio:4/3}.rf-aspect-square{aspect-ratio:1}.rf-aspect-video{aspect-ratio:16/9}.rf-h-0{height:0}.rf-h-1{height:.25rem}.rf-h-1\\/2{height:50%}.rf-h-1\\/3{height:33.3333%}.rf-h-12{height:3rem}.rf-h-14{height:3.5rem}.rf-h-16{height:4rem}.rf-h-18{height:4.5rem}.rf-h-2{height:.5rem}.rf-h-2\\/3{height:66.6667%}.rf-h-2\\/5{height:40%}.rf-h-24{height:6rem}.rf-h-3{height:.75rem}.rf-h-3\\/10{height:30%}.rf-h-32{height:8rem}.rf-h-36{height:9rem}.rf-h-4{height:1rem}.rf-h-48{height:12rem}.rf-h-5{height:1.25rem}.rf-h-6{height:1.5rem}.rf-h-7{height:1.75rem}.rf-h-8{height:2rem}.rf-h-9{height:2.25rem}.rf-h-\\[0\\.875rem\\]{height:.875rem}.rf-h-\\[1\\.25rem\\]{height:1.25rem}.rf-h-\\[calc\\(50vw-3rem\\)\\]{height:calc(50vw - 3rem)}.rf-h-fit{height:fit-content}.rf-h-full{height:100%}.rf-h-max{height:max-content}.rf-h-screen{height:100vh}.rf-max-h-12{max-height:3rem}.rf-max-h-28{max-height:7rem}.rf-max-h-4\\/5{max-height:80%}.rf-max-h-48{max-height:12rem}.rf-max-h-6{max-height:1.5rem}.rf-max-h-8{max-height:2rem}.rf-max-h-full{max-height:100%}.rf-max-h-qrcode{max-height:120px}.rf-max-h-screen{max-height:100vh}.rf-min-h-12{min-height:3rem}.rf-min-h-16{min-height:4rem}.rf-min-h-2\\/5{min-height:40%}.rf-min-h-6{min-height:1.5rem}.rf-min-h-8{min-height:2rem}.rf-min-h-full{min-height:100%}.rf-min-h-inherit{min-height:inherit}.rf-w-0{width:0}.rf-w-1\\/2{width:50%}.rf-w-1\\/3{width:33.3333%}.rf-w-1\\/4{width:25%}.rf-w-11\\/12{width:91.6667%}.rf-w-12{width:3rem}.rf-w-16{width:4rem}.rf-w-18{width:4.5rem}.rf-w-2{width:.5rem}.rf-w-2\\/3{width:66.6667%}.rf-w-20{width:5rem}.rf-w-24{width:6rem}.rf-w-3{width:.75rem}.rf-w-3\\/20{width:15%}.rf-w-3\\/4{width:75%}.rf-w-3\\/5{width:60%}.rf-w-32{width:8rem}.rf-w-36{width:9rem}.rf-w-4{width:1rem}.rf-w-4\\/9{width:45%}.rf-w-48{width:12rem}.rf-w-5{width:1.25rem}.rf-w-6{width:1.5rem}.rf-w-7{width:1.75rem}.rf-w-8{width:2rem}.rf-w-9{width:2.25rem}.rf-w-\\[45\\%\\]{width:45%}.rf-w-\\[45ch\\]{width:45ch}.rf-w-\\[90\\%\\]{width:90%}.rf-w-\\[calc\\(100\\%-3rem\\)\\]{width:calc(100% - 3rem)}.rf-w-fit{width:fit-content}.rf-w-full{width:100%}.rf-w-max{width:max-content}.rf-w-screen{width:100vw}.rf-min-w-11\\/12{min-width:91.7%}.rf-min-w-12{min-width:3rem}.rf-min-w-24{min-width:6rem}.rf-min-w-3\\/20{min-width:15%}.rf-min-w-6{min-width:1.5rem}.rf-min-w-7{min-width:1.75rem}.rf-min-w-\\[45\\%\\]{min-width:45%}.rf-min-w-full{min-width:100%}.rf-max-w-1\\/2{max-width:50%}.rf-max-w-16{max-width:4rem}.rf-max-w-3\\/20{max-width:15%}.rf-max-w-6{max-width:1.5rem}.rf-max-w-7\\/10{max-width:70%}.rf-max-w-\\[100vw\\]{max-width:100vw}.rf-max-w-\\[45\\%\\]{max-width:45%}.rf-max-w-\\[70vw\\]{max-width:70vw}.rf-max-w-\\[calc\\(100\\%-2rem\\)\\]{max-width:calc(100% - 2rem)}.rf-max-w-full{max-width:100%}.rf-max-w-none{max-width:none}.rf-flex-1{flex:1}.rf-flex-\\[0_0_40\\%\\]{flex:0 0 40%}.rf-flex-\\[2_1_0\\%\\]{flex:2}.rf-flex-\\[4_1_0\\%\\]{flex:4}.rf-origin-center{transform-origin:50%}.-rf-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.-rf-translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf--translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-translate-x-1{--tw-translate-x:.25rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-translate-x-5{--tw-translate-x:1.25rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf--rotate-90{--tw-rotate:-90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-rotate-0{--tw-rotate:0deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-rotate-180{--tw-rotate:180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-rotate-90{--tw-rotate:90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-scale-0{--tw-scale-x:0;--tw-scale-y:0;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}@keyframes rf-blink{0%,to{opacity:.2}50%{opacity:1}}.rf-animate-blink{animation:1.4s infinite both rf-blink}@keyframes rf-fadeIn{0%{opacity:0}to{opacity:1}}.rf-animate-fadeIn{animation:.5s .2s backwards rf-fadeIn}@keyframes rf-hScroll{0%{transform:translate(0)}to{transform:translate(calc(-100% - 2rem))}}.rf-animate-hScroll{animation:20s linear infinite rf-hScroll}@keyframes rf-loader{0%{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}40%{box-shadow:0 1.5rem 0 -.3rem var(--rf-color-loader-animation)}80%{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}to{box-shadow:0 1.5rem 0 -1.5rem var(--rf-color-loader-animation)}}.rf-animate-loader{animation:1.8s ease-in-out -.16s infinite both rf-loader}.rf-animate-loaderFadeIn{animation:2s rf-fadeIn}@keyframes rf-fadeOut{0%{opacity:1}to{opacity:0}}.rf-animate-loaderFadeOut{animation:1s rf-fadeOut}@keyframes rf-loaderMedium{0%{box-shadow:0 .75rem 0 -.75rem var(--rf-color-loader-animation)}40%{box-shadow:0 .75rem 0 -.25rem var(--rf-color-loader-animation)}80%{box-shadow:0 .75rem 0 -.75rem var(--rf-color-loader-animation)}to{box-shadow:0 .75rem 0 -.75rem var(--rf-color-loader-animation)}}.rf-animate-loaderMedium{animation:1.8s ease-in-out -.16s infinite both rf-loaderMedium}@keyframes rf-loaderMini{0%{box-shadow:0 .5rem 0 -.5rem var(--rf-color-loader-animation)}40%{box-shadow:0 .5rem 0 -.1rem var(--rf-color-loader-animation)}80%{box-shadow:0 .5rem 0 -.5rem var(--rf-color-loader-animation)}to{box-shadow:0 .5rem 0 -.5rem var(--rf-color-loader-animation)}}.rf-animate-loaderMini{animation:1.8s ease-in-out -.16s infinite both rf-loaderMini}@keyframes rf-slideBottom{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:matrix(1,0,0,1,0,0)}}.rf-animate-slideBottom{animation:.5s .2s backwards rf-slideBottom}@keyframes rf-spin{to{transform:rotate(360deg)}}.rf-animate-spin{animation:1s linear infinite rf-spin}.rf-cursor-pointer{cursor:pointer}.rf-select-none{user-select:none}.rf-resize-none{resize:none}.rf-scroll-pb-4{scroll-padding-bottom:1rem}.rf-grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.rf-grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.rf-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.rf-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.rf-grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.rf-grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.rf-grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.rf-grid-cols-\\[repeat\\(2\\,30\\%\\)\\]{grid-template-columns:repeat(2,30%)}.rf-grid-cols-\\[repeat\\(2\\,45\\%\\)\\]{grid-template-columns:repeat(2,45%)}.rf-grid-cols-\\[repeat\\(3\\,31\\%\\)\\]{grid-template-columns:repeat(3,31%)}.rf-grid-cols-headerContainer{grid-template-columns:7rem 1fr 1fr 1fr}.rf-grid-cols-printingPreview{grid-template-columns:minmax(0,1fr) 3rem}.rf-grid-cols-routes{grid-template-columns:repeat(3,max-content)}.rf-grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.rf-grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.rf-grid-rows-3{grid-template-rows:repeat(3,minmax(0,1fr))}.rf-grid-rows-4{grid-template-rows:repeat(4,minmax(0,1fr))}.rf-grid-rows-5{grid-template-rows:repeat(5,minmax(0,1fr))}.rf-grid-rows-container{grid-template-rows:repeat(12,minmax(0,1fr))}.rf-grid-rows-headerContainer{grid-template-rows:repeat(3,minmax(0,1fr))}.rf-flex-row{flex-direction:row}.rf-flex-col{flex-direction:column}.rf-flex-col-reverse{flex-direction:column-reverse}.rf-flex-wrap{flex-wrap:wrap}.rf-flex-nowrap{flex-wrap:nowrap}.rf-content-around{align-content:space-around}.rf-items-start{align-items:flex-start}.rf-items-end{align-items:flex-end}.rf-items-center{align-items:center}.rf-justify-start{justify-content:flex-start}.rf-justify-end{justify-content:flex-end}.rf-justify-center{justify-content:center}.rf-justify-between{justify-content:space-between}.rf-justify-around{justify-content:space-around}.rf-justify-evenly{justify-content:space-evenly}.rf-gap-1{gap:.25rem}.rf-gap-12{gap:3rem}.rf-gap-2{gap:.5rem}.rf-gap-3{gap:.75rem}.rf-gap-4{gap:1rem}.rf-gap-5{gap:1.25rem}.rf-gap-8{gap:2rem}.rf-gap-9{gap:2.25rem}.rf-gap-\\[10\\%\\]{gap:10%}.rf-gap-x-\\[3\\.5\\%\\]{column-gap:3.5%}.rf-divide-x>:not([hidden])~:not([hidden]){--tw-divide-x-reverse:0;border-right-width:calc(1px*var(--tw-divide-x-reverse));border-left-width:calc(1px*calc(1 - var(--tw-divide-x-reverse)))}.rf-self-auto{align-self:auto}.rf-self-start{align-self:flex-start}.rf-self-end{align-self:flex-end}.rf-self-center{align-self:center}.rf-justify-self-start{justify-self:start}.rf-justify-self-end{justify-self:end}.rf-justify-self-center{justify-self:center}.rf-overflow-hidden{overflow:hidden}.rf-overflow-clip{overflow:clip}.rf-overflow-x-auto{overflow-x:auto}.rf-overflow-y-auto{overflow-y:auto}.rf-overflow-x-hidden{overflow-x:hidden}.rf-overflow-y-hidden{overflow-y:hidden}.rf-overflow-y-clip{overflow-y:clip}.rf-overflow-y-visible{overflow-y:visible}.rf-overflow-x-scroll{overflow-x:scroll}.rf-overflow-y-scroll{overflow-y:scroll}.rf-truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.rf-whitespace-nowrap{white-space:nowrap}.rf-rounded{border-radius:.3125rem}.rf-rounded-6{border-radius:1.5rem}.rf-rounded-8{border-radius:2rem}.rf-rounded-\\[20px\\]{border-radius:20px}.rf-rounded-half{border-radius:50%}.rf-rounded-lg{border-radius:.5rem}.rf-rounded-max{border-radius:100%}.rf-rounded-b{border-bottom-right-radius:.3125rem;border-bottom-left-radius:.3125rem}.rf-rounded-l-lg{border-top-left-radius:.5rem;border-bottom-left-radius:.5rem}.rf-border{border-width:1px}.rf-border-0{border-width:0}.rf-border-2{border-width:2px}.rf-border-y{border-top-width:1px;border-bottom-width:1px}.rf-border-b{border-bottom-width:1px}.rf-border-b-2{border-bottom-width:2px}.rf-border-l{border-left-width:1px}.rf-border-r{border-right-width:1px}.rf-border-t{border-top-width:1px}.rf-border-t-0{border-top-width:0}.rf-border-none{border-style:none}.rf-border-\\[\\#00000029\\]{border-color:#00000029}.rf-border-\\[\\#9FA2AA\\]{--tw-border-opacity:1;border-color:rgb(159 162 170/var(--tw-border-opacity))}.rf-border-\\[\\#C7C6C6\\]{--tw-border-opacity:1;border-color:rgb(199 198 198/var(--tw-border-opacity))}.rf-border-\\[\\#F0F0F0\\]{--tw-border-opacity:1;border-color:rgb(240 240 240/var(--tw-border-opacity))}.rf-border-black{border-color:var(--rf-color-black)}.rf-border-cardButtonBorderDefault{border-color:var(--rf-color-cardButtonBorderDefault)}.rf-border-cardButtonBorderHover{border-color:var(--rf-color-cardButtonBorderHover)}.rf-border-cardFrameBorder{border-color:var(--rf-color-cardFrameBorder)}.rf-border-formInputButtonBorderDefault{border-color:var(--rf-color-formInputButtonBorderDefault)}.rf-border-formInputButtonBorderHover{border-color:var(--rf-color-formInputButtonBorderHover)}.rf-border-formInputRadioCheckboxCheckedBorder{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder)}.rf-border-formInputRadioCheckboxUncheckedBorder{border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder)}.rf-border-gray{--tw-border-opacity:1;border-color:rgb(128 128 128/var(--tw-border-opacity))}.rf-border-menuBorder{--tw-border-opacity:1;border-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-border-primary{border-color:var(--rf-color-primary)}.rf-border-red-700{--tw-border-opacity:1;border-color:rgb(185 28 28/var(--tw-border-opacity))}.rf-border-secondary{border-color:var(--rf-color-secondary)}.rf-border-templateCheckboxBorder{--tw-border-opacity:1;border-color:rgb(112 112 112/var(--tw-border-opacity))}.rf-border-trueblack{--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity))}.rf-border-truewhite{--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity))}.rf-border-x-primary{border-left-color:var(--rf-color-primary);border-right-color:var(--rf-color-primary)}.rf-border-y-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity));border-bottom-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-border-b-\\[\\#C4C5C8\\]{--tw-border-opacity:1;border-bottom-color:rgb(196 197 200/var(--tw-border-opacity))}.rf-border-b-black{border-bottom-color:var(--rf-color-black)}.rf-border-b-menuBorder{--tw-border-opacity:1;border-bottom-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-border-b-silver{--tw-border-opacity:1;border-bottom-color:rgb(192 192 192/var(--tw-border-opacity))}.rf-border-b-transparent{border-bottom-color:#0000}.rf-border-l-menuBorder{--tw-border-opacity:1;border-left-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-border-r-silver{--tw-border-opacity:1;border-right-color:rgb(192 192 192/var(--tw-border-opacity))}.rf-border-t-\\[\\#CBC9C9\\]{--tw-border-opacity:1;border-top-color:rgb(203 201 201/var(--tw-border-opacity))}.rf-border-t-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity))}.rf-bg-\\[\\#00000050\\]{background-color:#00000050}.rf-bg-\\[\\#F0F0F0\\]{--tw-bg-opacity:1;background-color:rgb(240 240 240/var(--tw-bg-opacity))}.rf-bg-\\[\\#F8F8F8\\]{--tw-bg-opacity:1;background-color:rgb(248 248 248/var(--tw-bg-opacity))}.rf-bg-black{background-color:var(--rf-color-black)}.rf-bg-blue-500{--tw-bg-opacity:1;background-color:rgb(59 130 246/var(--tw-bg-opacity))}.rf-bg-cardButtonBackgroundDefault{background-color:var(--rf-color-cardButtonBackgroundDefault)}.rf-bg-cardButtonBackgroundHover{background-color:var(--rf-color-cardButtonBackgroundHover)}.rf-bg-cardFrameBackground{background-color:var(--rf-color-cardFrameBackground)}.rf-bg-formInputButtonBackgroundDefault{background-color:var(--rf-color-formInputButtonBackgroundDefault)}.rf-bg-formInputButtonBackgroundHover{background-color:var(--rf-color-formInputButtonBackgroundHover)}.rf-bg-formInputRadioCheckboxUncheckedBackground{background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground)}.rf-bg-gray{--tw-bg-opacity:1;background-color:rgb(128 128 128/var(--tw-bg-opacity))}.rf-bg-primary{background-color:var(--rf-color-primary)}.rf-bg-red-600{--tw-bg-opacity:1;background-color:rgb(220 38 38/var(--tw-bg-opacity))}.rf-bg-secondary{background-color:var(--rf-color-secondary)}.rf-bg-silver{--tw-bg-opacity:1;background-color:rgb(192 192 192/var(--tw-bg-opacity))}.rf-bg-templateBackground{--tw-bg-opacity:1;background-color:rgb(241 241 241/var(--tw-bg-opacity))}.rf-bg-templateEmptyCard{--tw-bg-opacity:1;background-color:rgb(232 231 231/var(--tw-bg-opacity))}.rf-bg-textModePanelBackground{background-color:var(--rf-color-textModePanelBackground)}.rf-bg-transparent{background-color:#0000}.rf-bg-truewhite{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.rf-bg-vocalModeSubtitlesBackground{background-color:var(--rf-color-vocalModeSubtitlesBackground)}.rf-bg-white{--tw-bg-opacity:1;background-color:rgb(247 243 246/var(--tw-bg-opacity))}.rf-bg-opacity-30{--tw-bg-opacity:.3}.rf-bg-opacity-50{--tw-bg-opacity:.5}.rf-bg-opacity-80{--tw-bg-opacity:.8}.rf-object-cover{object-fit:cover}.rf-p-0{padding:0}.rf-p-1{padding:.25rem}.rf-p-2{padding:.5rem}.rf-p-3{padding:.75rem}.rf-p-4{padding:1rem}.rf-p-6{padding:1.5rem}.rf-p-\\[25px\\]{padding:25px}.rf-p-\\[7px_12px\\]{padding:7px 12px}.rf-px-1{padding-left:.25rem;padding-right:.25rem}.rf-px-2{padding-left:.5rem;padding-right:.5rem}.rf-px-3{padding-left:.75rem;padding-right:.75rem}.rf-px-4{padding-left:1rem;padding-right:1rem}.rf-px-5,.rf-px-6{padding-left:1.5rem;padding-right:1.5rem}.rf-px-8{padding-left:2rem;padding-right:2rem}.rf-py-0{padding-top:0;padding-bottom:0}.rf-py-1{padding-top:.25rem;padding-bottom:.25rem}.rf-py-12{padding-top:3rem;padding-bottom:3rem}.rf-py-2{padding-top:.5rem;padding-bottom:.5rem}.rf-py-3{padding-top:.75rem;padding-bottom:.75rem}.rf-py-4{padding-top:1rem;padding-bottom:1rem}.rf-py-6{padding-top:1.5rem;padding-bottom:1.5rem}.rf-pb-10{padding-bottom:2.5rem}.rf-pb-12{padding-bottom:3rem}.rf-pb-14{padding-bottom:3.5rem}.rf-pb-2{padding-bottom:.5rem}.rf-pb-3{padding-bottom:.75rem}.rf-pb-4{padding-bottom:1rem}.rf-pb-5,.rf-pb-6{padding-bottom:1.5rem}.rf-pb-8{padding-bottom:2rem}.rf-pb-\\[15vh\\]{padding-bottom:15vh}.rf-pl-0{padding-left:0}.rf-pl-1{padding-left:.25rem}.rf-pl-2{padding-left:.5rem}.rf-pl-4{padding-left:1rem}.rf-pl-6{padding-left:1.5rem}.rf-pl-8{padding-left:2rem}.rf-pr-0{padding-right:0}.rf-pr-1{padding-right:.25rem}.rf-pr-2{padding-right:.5rem}.rf-pr-4{padding-right:1rem}.rf-pr-40{padding-right:10rem}.rf-pt-1{padding-top:.25rem}.rf-pt-11\\/20{padding-top:55%}.rf-pt-12{padding-top:3rem}.rf-pt-14{padding-top:3.5rem}.rf-pt-2{padding-top:.5rem}.rf-pt-24{padding-top:6rem}.rf-pt-3{padding-top:.75rem}.rf-pt-4{padding-top:1rem}.rf-pt-6{padding-top:1.5rem}.rf-pt-8{padding-top:2rem}.rf-pt-\\[25vh\\]{padding-top:25vh}.rf-pt-\\[26vh\\]{padding-top:26vh}.rf-text-left{text-align:left}.rf-text-center{text-align:center}.rf-text-right{text-align:right}.rf-font-default{font-family:Calibri,sans-serif}.rf-text-2xl{font-size:1.5rem;line-height:2rem}.rf-text-3xl{font-size:1.875rem;line-height:2.25rem}.rf-text-4xl{font-size:2.25rem;line-height:2.5rem}.rf-text-5xl{font-size:3rem;line-height:1}.rf-text-7xl{font-size:4.5rem;line-height:1}.rf-text-8xl{font-size:6rem;line-height:1}.rf-text-\\[0\\.5rem\\]{font-size:.5rem}.rf-text-base{font-size:1rem;line-height:1.5rem}.rf-text-basecustom{font-size:1rem;line-height:1.3rem}.rf-text-lgcustom{font-size:1.125rem;line-height:1.5rem}.rf-text-sm{font-size:.875rem;line-height:1.25rem}.rf-text-xl{font-size:1.25rem;line-height:1.75rem}.rf-text-xs{font-size:.75rem;line-height:1rem}.rf-text-xsl{font-size:.7rem;line-height:1rem}.rf-text-xsm{font-size:.6rem}.rf-font-bold{font-weight:600}.rf-font-medium{font-weight:300}.rf-font-semibold{font-weight:400}.rf-uppercase{text-transform:uppercase}.rf-capitalize{text-transform:capitalize}.rf-normal-case{text-transform:none}.rf-italic{font-style:italic}.rf-text-\\[\\#575F6B\\]{--tw-text-opacity:1;color:rgb(87 95 107/var(--tw-text-opacity))}.rf-text-\\[\\#9A9A9A\\]{--tw-text-opacity:1;color:rgb(154 154 154/var(--tw-text-opacity))}.rf-text-\\[\\#A4A7AF\\]{--tw-text-opacity:1;color:rgb(164 167 175/var(--tw-text-opacity))}.rf-text-black{color:var(--rf-color-black)}.rf-text-cardButtonTextDefault{color:var(--rf-color-cardButtonTextDefault)}.rf-text-cardFrameText{color:var(--rf-color-cardFrameText)}.rf-text-formInputButtonTextDefault{color:var(--rf-color-formInputButtonTextDefault)}.rf-text-formInputButtonTextHover{color:var(--rf-color-formInputButtonTextHover)}.rf-text-formInputRadioCheckboxUncheckedBackground{color:var(--rf-color-formInputRadioCheckboxUncheckedBackground)}.rf-text-formInputTextDefault{color:var(--rf-color-formInputTextDefault)}.rf-text-gray{--tw-text-opacity:1;color:rgb(128 128 128/var(--tw-text-opacity))}.rf-text-lightgray{--tw-text-opacity:1;color:rgb(129 129 129/var(--tw-text-opacity))}.rf-text-primary{color:var(--rf-color-primary)}.rf-text-red-700{--tw-text-opacity:1;color:rgb(185 28 28/var(--tw-text-opacity))}.rf-text-secondary{color:var(--rf-color-secondary)}.rf-text-textModePanelConversationBot{color:var(--rf-color-textModePanelConversationBot)}.rf-text-textModePanelConversationUser{color:var(--rf-color-textModePanelConversationUser)}.rf-text-trueblack{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}.rf-text-truewhite{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.rf-text-vocalModeSubtitlesText{color:var(--rf-color-vocalModeSubtitlesText)}.rf-text-white{--tw-text-opacity:1;color:rgb(247 243 246/var(--tw-text-opacity))}.rf-underline{text-decoration-line:underline}.rf-shadow-\\[-3px_-3px_10px_\\#00000099\\]{--tw-shadow:-3px -3px 10px #0009;--tw-shadow-colored:-3px -3px 10px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_0_15px_0_silver\\]{--tw-shadow:0 0 15px 0 silver;--tw-shadow-colored:0 0 15px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_0_20px_1px_\\#A4A7AF80\\]{--tw-shadow:0 0 20px 1px #a4a7af80;--tw-shadow-colored:0 0 20px 1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_0_3px_6px_\\#00000029\\]{--tw-shadow:0 0 3px 6px #00000029;--tw-shadow-colored:0 0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_\\#00000029\\]{--tw-shadow:0 3px 6px #00000029;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_\\#606267\\]{--tw-shadow:0 3px 6px #606267;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_3px_6px_rgba\\(0\\,0\\,0\\,0\\.16\\)\\]{--tw-shadow:0 3px 6px #00000029;--tw-shadow-colored:0 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[0_6px_6px_\\#00000029\\]{--tw-shadow:0 6px 6px #00000029;--tw-shadow-colored:0 6px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[20px_3px_20px_\\#00000029\\]{--tw-shadow:20px 3px 20px #00000029;--tw-shadow-colored:20px 3px 20px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[3px_3px_16px_\\#00000029\\]{--tw-shadow:3px 3px 16px #00000029;--tw-shadow-colored:3px 3px 16px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[3px_3px_6px_\\#00000029\\]{--tw-shadow:3px 3px 6px #00000029;--tw-shadow-colored:3px 3px 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[inset_0_0_6px_\\#0000003B\\]{--tw-shadow:inset 0 0 6px #0000003b;--tw-shadow-colored:inset 0 0 6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-shadow-\\[inset_0_12px_12px_-12px_\\#00000029\\,inset_0_-12px_12px_-12px_\\#00000029\\]{--tw-shadow:inset 0 12px 12px -12px #00000029,inset 0 -12px 12px -12px #00000029;--tw-shadow-colored:inset 0 12px 12px -12px var(--tw-shadow-color),inset 0 -12px 12px -12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.rf-outline-none{outline-offset:2px;outline:2px solid #0000}.rf-blur-background{--tw-blur:blur(var(--rf-blur-background));filter:var(--tw-blur)var(--tw-brightness)var(--tw-contrast)var(--tw-grayscale)var(--tw-hue-rotate)var(--tw-invert)var(--tw-saturate)var(--tw-sepia)var(--tw-drop-shadow)}.rf-filter{filter:var(--tw-blur)var(--tw-brightness)var(--tw-contrast)var(--tw-grayscale)var(--tw-hue-rotate)var(--tw-invert)var(--tw-saturate)var(--tw-sepia)var(--tw-drop-shadow)}.rf-transition-all{transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.rf-transition-transform{transition-property:transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.rf-text-shadow-black{text-shadow:2px 0 5px #000,-2px 0 5px #000,0 2px 5px #000,0 -2px 5px #000}.rf-capitalize-first:first-letter{text-transform:uppercase}ol{padding-left:2rem;list-style-type:decimal}ul{padding-left:2rem;list-style-type:disc}#retorik-container.rf-portrait:not(.rf-large) .ac-image{max-width:100px}.rf-glass-background,#retorik-container.portrait .portrait\\:rf-glass-background{background-color:var(--rf-color-black);--tw-bg-opacity:.62;--tw-backdrop-blur:blur(8px);backdrop-filter:var(--tw-backdrop-blur)var(--tw-backdrop-brightness)var(--tw-backdrop-contrast)var(--tw-backdrop-grayscale)var(--tw-backdrop-hue-rotate)var(--tw-backdrop-invert)var(--tw-backdrop-opacity)var(--tw-backdrop-saturate)var(--tw-backdrop-sepia)}.rf-loader:before{content:\"\";border-radius:50%;width:1.5rem;height:1.5rem;animation:1.8s ease-in-out -.32s infinite both rf-loader;display:block;position:absolute;right:1.5rem}.rf-loader:after{content:\"\";border-radius:50%;width:1.5rem;height:1.5rem;animation:1.8s ease-in-out infinite both rf-loader;display:block;position:absolute;left:1.5rem}.rf-loader-medium:before{content:\"\";border-radius:50%;width:1rem;height:1rem;animation:1.8s ease-in-out -.32s infinite both rf-loaderMedium;display:block;position:absolute;right:1rem}.rf-loader-medium:after{content:\"\";border-radius:50%;width:1rem;height:1rem;animation:1.8s ease-in-out infinite both rf-loaderMedium;display:block;position:absolute;left:1rem}.rf-loader-mini:before{content:\"\";border-radius:50%;width:.5rem;height:.5rem;animation:1.8s ease-in-out -.32s infinite both rf-loaderMini;display:block;position:absolute;right:.5rem}.rf-loader-mini:after{content:\"\";border-radius:50%;width:.5rem;height:.5rem;animation:1.8s ease-in-out infinite both rf-loaderMini;display:block;position:absolute;left:.5rem}.rf-loader-microphone:before,.rf-loader-microphone:after{content:\"\";--tw-border-opacity:1;border:6px solid #0000;border-top-color:rgb(128 128 128/var(--tw-border-opacity));border-radius:100%;width:100%;height:100%;position:absolute;top:0;left:0}.rf-loader-microphone:before{z-index:1;animation:1s linear infinite rf-spin}.rf-loader-microphone:after{--tw-border-opacity:1;border-color:rgb(204 204 204/var(--tw-border-opacity))}.rf-touch-action-none{touch-action:none}.rf-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none}.rf-title-extralarge-bold-size-auto{font-size:2.25rem;font-weight:600;line-height:2.5rem}#retorik-container.rf-large .rf-title-extralarge-bold-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-title-extralarge-bold-size-auto{font-size:3.75rem;line-height:1}.rf-title-extralarge-size-auto{font-size:2.25rem;font-weight:400;line-height:2.5rem}#retorik-container.rf-large .rf-title-extralarge-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-title-extralarge-size-auto{font-size:3.75rem;line-height:1}.rf-title-large-size-auto{font-size:1.5rem;font-weight:400;line-height:2rem}#retorik-container.rf-large .rf-title-large-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large.rf-portrait .rf-title-large-size-auto{font-size:3rem;line-height:1}.rf-title-large-bold-size-auto{font-size:1.875rem;font-weight:600;line-height:2.25rem}#retorik-container.rf-large .rf-title-large-bold-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large.rf-portrait .rf-title-large-bold-size-auto{font-size:3rem;line-height:1}.rf-title-size-auto{font-size:1.5rem;font-weight:400;line-height:2rem}#retorik-container.rf-large .rf-title-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-title-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-title-bold-size-auto{font-size:1.5rem;font-weight:600;line-height:2rem}#retorik-container.rf-large .rf-title-bold-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-title-bold-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-subtitle-size-auto{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-subtitle-size-auto{font-size:1.25rem;line-height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-subtitle-size-auto{font-size:1.5rem;line-height:2rem}.rf-text-extralarge-size-auto{font-size:2.25rem;line-height:2.5rem}#retorik-container.rf-large .rf-text-extralarge-size-auto{font-size:3rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-text-extralarge-size-auto{font-size:3.75rem;line-height:1}.rf-text-verylarge-size-auto{font-size:1.5rem;line-height:2rem}#retorik-container.rf-large .rf-text-verylarge-size-auto{font-size:3.75rem;line-height:1}#retorik-container.rf-large.rf-portrait .rf-text-verylarge-size-auto{font-size:4.5rem;line-height:1}.rf-text-large-size-auto{font-size:1.5rem;line-height:2rem}#retorik-container.rf-large .rf-text-large-size-auto{font-size:1.875rem;line-height:2.25rem}#retorik-container.rf-large.rf-portrait .rf-text-large-size-auto{font-size:2.25rem;line-height:2.5rem}.rf-text-medium-size-auto{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large .rf-text-medium-size-auto{font-size:1.125rem;line-height:1.5rem}.rf-text-size-auto{font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-text-size-auto{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-text-size-auto{font-size:1.125rem;line-height:1.5rem}.rf-text-small-size-auto{font-size:.875rem;line-height:1rem}#retorik-container.rf-large .rf-text-small-size-auto{font-size:1rem;line-height:1.1rem}.rf-small-size-auto{font-size:.6rem}#retorik-container.rf-large .rf-small-size-auto{font-size:.75rem;line-height:1rem}#retorik-container.rf-large.rf-portrait .rf-small-size-auto{font-size:.875rem;line-height:1.25rem}.rf-line-clamp-unknown{hyphens:auto;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-1{hyphens:auto;-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-2{hyphens:auto;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-3{hyphens:auto;-webkit-line-clamp:3;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-4{hyphens:auto;-webkit-line-clamp:4;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-5{hyphens:auto;-webkit-line-clamp:5;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-6{hyphens:auto;-webkit-line-clamp:6;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-7{hyphens:auto;-webkit-line-clamp:7;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-8{hyphens:auto;-webkit-line-clamp:8;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-9{hyphens:auto;-webkit-line-clamp:9;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-line-clamp-10{hyphens:auto;-webkit-line-clamp:10;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.rf-overflow-wrap{overflow-wrap:anywhere}.rf-height-fill-available{height:stretch}.rf-width-fill-available{width:stretch}.rf-animation-delay-2{animation-delay:.2s}.rf-animation-delay-4{animation-delay:.4s}.rf-scrollbar-thin{scrollbar-width:thin;scrollbar-color:var(--rf-color-secondary)transparent}.rf-scrollbar-thin::-webkit-scrollbar{width:.2rem;height:.2rem;margin:.25rem 0}.rf-scrollbar-thin::-webkit-scrollbar-thumb{background-color:var(--rf-color-secondary);border-radius:.5rem}.rf-scrollbar-x-custom::-webkit-scrollbar{background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:2rem;height:.5rem}.rf-scrollbar-x-custom::-webkit-scrollbar-thumb{background-color:var(--rf-color-primary);border-radius:2rem}.rf-scrollbar-hidden{scrollbar-width:none}.rf-scrollbar-hidden::-webkit-scrollbar{display:none}.rf-opacity-gradient-b{-webkit-mask-image:linear-gradient(#000 50%,#0000 100%)}.rf-opacity-gradient-b-thin{-webkit-mask-image:linear-gradient(#797676 84%,#0000 100%)}.rf-opacity-gradient-l{-webkit-mask-image:linear-gradient(270deg,#000 75%,gray 80%,#0000 85%)}.rf-opacity-gradient-l-thin{-webkit-mask-image:linear-gradient(270deg,#000 90%,gray 95%,#0000 100%)}.rf-opacity-gradient-h{-webkit-mask-image:linear-gradient(90deg,#0000 0%,6%,#000,94%,#0000 100%)}.rf-card-button{border-width:1px;border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardButtonBackgroundDefault);color:var(--rf-color-cardButtonTextDefault);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button{padding:.5rem 1rem}.rf-card-button:hover{cursor:pointer;border-color:var(--rf-color-cardButtonBorderHover);background-color:var(--rf-color-cardButtonBackgroundHover);color:var(--rf-color-cardButtonTextHover)}.rf-card-button-clicked{background-color:var(--rf-color-cardButtonBackgroundDefault);border-width:1px;border-color:#0000;padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .rf-card-button-clicked{padding-top:.5rem;padding-bottom:.5rem}.rf-card-button-secondary{border-width:1px;border-color:var(--rf-color-secondary);color:var(--rf-color-secondary);background-color:#0000;border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-secondary{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-secondary{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-secondary{padding:.5rem 1rem}.rf-card-button-secondary:hover{cursor:pointer;border-color:var(--rf-color-secondary);background-color:var(--rf-color-secondary);--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.rf-card-button-discover{border-width:1px;border-color:var(--rf-color-cardButtonDiscoverBorderDefault);background-color:var(--rf-color-cardButtonDiscoverBackgroundDefault);color:var(--rf-color-cardButtonDiscoverTextDefault);border-radius:.3125rem;padding:.5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-discover{padding-top:.75rem;padding-bottom:.75rem}.rf-card-button-discover:hover{cursor:pointer;border-color:var(--rf-color-cardButtonDiscoverBorderHover);background-color:var(--rf-color-cardButtonDiscoverBackgroundHover);color:var(--rf-color-cardButtonDiscoverTextHover)}.rf-card-button-history{cursor:default;border-width:1px;border-color:var(--rf-color-cardButtonBorderDefault);background-color:var(--rf-color-cardButtonBackgroundDefault);color:var(--rf-color-cardButtonTextDefault);border-radius:.3125rem;padding:.25rem .5rem;font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .rf-card-button-history{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large.rf-portrait .rf-card-button-history{font-size:1.125rem;line-height:1.5rem}#retorik-container.rf-large .rf-card-button-history{padding:.5rem 1rem}.lf-player-container{align-items:flex-end;width:100%;height:100%;display:flex;overflow:hidden}.rf-input-label{text-overflow:ellipsis;color:var(--rf-color-formInputTextDefault);margin-top:.1rem;margin-left:.75rem;overflow-x:hidden}#retorik-container.rf-large .rf-input-label{margin-top:.25rem}#retorik-container.rf-large.rf-portrait .rf-input-label{margin-top:.2rem}.rf-radio-custom{-webkit-appearance:none;appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:50%;place-content:center;width:1.5rem;min-width:1.5rem;height:1.5rem;margin:0;display:grid}.rf-radio-custom:checked{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}#retorik-container.rf-large .rf-radio-custom{width:1.75rem;min-width:1.75rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-radio-custom{width:2rem;min-width:2rem;height:2rem}.rf-radio-custom:before{content:\"\";--tw-scale-x:0;--tw-scale-y:0;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y));background-color:var(--rf-color-formInputRadioCheckboxCheckedItem);border-radius:50%;width:.5rem;height:.5rem;transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}#retorik-container.rf-large .rf-radio-custom:before{width:.75rem;height:.75rem}#retorik-container.rf-large.rf-portrait .rf-radio-custom:before{width:1rem;height:1rem}.rf-radio-custom:checked:before{--tw-scale-x:1;--tw-scale-y:1;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-input-hidden{-webkit-appearance:none;appearance:none;margin:0}.rf-checkbox-custom{-webkit-appearance:none;appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:.3125rem;place-content:center;width:1.5rem;min-width:1.5rem;height:1.5rem;margin:0;display:grid}#retorik-container.rf-large .rf-checkbox-custom{width:1.75rem;min-width:1.75rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-checkbox-custom{width:2rem;min-width:2rem;height:2rem}.rf-checkbox-custom:checked{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}.rf-toggle-custom{-webkit-appearance:none;appearance:none;background-color:var(--rf-color-black);border-radius:1.5rem;width:3rem;min-width:3rem;height:1.5rem;margin:0;position:relative}.rf-toggle-custom:checked{background-color:var(--rf-color-primary)}#retorik-container.rf-large .rf-toggle-custom{border-radius:1.75rem;width:3.5rem;min-width:3.5rem;height:1.75rem}#retorik-container.rf-large.rf-portrait .rf-toggle-custom{border-radius:2rem;width:4rem;min-width:4rem;height:2rem}.rf-toggle-custom:before{content:\"\";--tw-translate-x:0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y));--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-radius:50%;width:1rem;height:1rem;transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1);position:absolute;top:.25rem;left:.25rem}#retorik-container.rf-large .rf-toggle-custom:before{width:1.25rem;height:1.25rem}#retorik-container.rf-large.rf-portrait .rf-toggle-custom:before{width:1.5rem;height:1.5rem}.rf-toggle-custom:checked:before{--tw-translate-x:1.5rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}#retorik-container.rf-large .rf-toggle-custom:checked:before{--tw-translate-x:1.75rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}#retorik-container.rf-large.rf-portrait .rf-toggle-custom:checked:before{--tw-translate-x:2rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y))rotate(var(--tw-rotate))skewX(var(--tw-skew-x))skewY(var(--tw-skew-y))scaleX(var(--tw-scale-x))scaleY(var(--tw-scale-y))}.rf-select-custom{-webkit-appearance:none;appearance:none;border-width:2px;border-color:var(--rf-color-formInputRadioCheckboxUncheckedBorder);background-color:var(--rf-color-formInputRadioCheckboxUncheckedBackground);border-radius:.3125rem;margin:0;padding:1rem}.rf-select-custom:hover{cursor:pointer}.rf-select-custom:focus-visible{border-color:var(--rf-color-formInputRadioCheckboxCheckedBorder)}.rf-slider-custom{-webkit-appearance:none;-moz-appearance:none;outline-offset:2px;border-radius:.5rem;outline:2px solid #0000;width:100%;height:.25rem;display:block;position:relative}.rf-slider-custom::-webkit-slider-runnable-track{-webkit-appearance:none}.rf-slider-custom::-moz-track{-moz-appearance:none}.rf-slider-custom::-ms-track{appearance:none}.rf-slider-custom::-webkit-slider-thumb{-webkit-appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-webkit-slider-thumb:hover{cursor:pointer}.rf-slider-custom::-moz-range-thumb{-webkit-appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-moz-range-thumb:hover{cursor:pointer}.rf-slider-custom::-ms-thumb{appearance:none;--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-style:none;border-radius:50%;width:1.5rem;height:1.5rem;margin-top:-.2rem}.rf-slider-custom::-ms-thumb:hover{cursor:pointer}.rf-likert-custom{cursor:pointer;outline-offset:2px;-webkit-text-stroke-width:1px;-webkit-text-stroke-color:white;background-color:#0000;border-style:none;outline:2px solid #0000}.svgButtonMenu>svg *{fill:var(--fill)}.webchat__css-custom-properties{width:100%;height:100%}.placeholder\\:rf-text-black::placeholder{color:var(--rf-color-black)}.placeholder\\:rf-opacity-100::placeholder{opacity:1}.hover\\:rf-cursor-pointer:hover{cursor:pointer}.hover\\:rf-border-truewhite:hover{--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity))}.hover\\:rf-bg-formInputRadioCheckboxCheckedBackground:hover{background-color:var(--rf-color-formInputRadioCheckboxCheckedBackground)}.hover\\:rf-bg-truewhite:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.hover\\:rf-text-formInputRadioCheckboxCheckedItem:hover{color:var(--rf-color-formInputRadioCheckboxCheckedItem)}.hover\\:rf-text-truewhite:hover{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.hover\\:rf-shadow-\\[inset_0_0_12px_\\#00000029\\]:hover{--tw-shadow:inset 0 0 12px #00000029;--tw-shadow-colored:inset 0 0 12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}#retorik-container.rf-portrait .vertical\\:rf-col-span-full{grid-column:1/-1}#retorik-container.rf-portrait .vertical\\:rf-col-start-1{grid-column-start:1}#retorik-container.rf-portrait .vertical\\:rf-row-span-1{grid-row:span 1/span 1}#retorik-container.rf-portrait .vertical\\:rf-row-start-11{grid-row-start:11}#retorik-container.rf-portrait .vertical\\:rf-row-end-13{grid-row-end:13}#retorik-container.rf-portrait .vertical\\:rf-w-5\\/6{width:83.3333%}#retorik-container.rf-portrait .vertical\\:rf-w-9\\/10{width:90%}#retorik-container.rf-portrait .vertical\\:rf-w-full{width:100%}#retorik-container.rf-portrait .vertical\\:rf-flex-col{flex-direction:column}#retorik-container.rf-portrait .vertical\\:rf-items-center{align-items:center}#retorik-container.rf-portrait .vertical\\:rf-overflow-x-auto{overflow-x:auto}#retorik-container.rf-portrait .vertical\\:rf-border-r-0{border-right-width:0}#retorik-container.rf-portrait .vertical\\:rf-py-1{padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-portrait .vertical\\:rf-pl-0{padding-left:0}#retorik-container.rf-portrait .vertical\\:rf-pr-0{padding-right:0}#retorik-container.rf-large .large\\:rf-absolute{position:absolute}#retorik-container.rf-large .large\\:rf-left-4{left:1rem}#retorik-container.rf-large .large\\:rf-top-8{top:2rem}#retorik-container.rf-large .large\\:rf-col-start-5{grid-column-start:5}#retorik-container.rf-large .large\\:rf-col-end-6{grid-column-end:6}#retorik-container.rf-large .large\\:rf-col-end-9{grid-column-end:9}#retorik-container.rf-large .large\\:rf-row-span-full{grid-row:1/-1}#retorik-container.rf-large .large\\:rf-row-start-10{grid-row-start:10}#retorik-container.rf-large .large\\:rf-row-start-5{grid-row-start:5}#retorik-container.rf-large .large\\:rf-m-8{margin:2rem}#retorik-container.rf-large .large\\:rf-my-0{margin-top:0;margin-bottom:0}#retorik-container.rf-large .large\\:rf-my-3{margin-top:.75rem;margin-bottom:.75rem}#retorik-container.rf-large .large\\:rf-mb-0{margin-bottom:0}#retorik-container.rf-large .large\\:rf-mb-4{margin-bottom:1rem}#retorik-container.rf-large .large\\:rf-mb-6{margin-bottom:1.5rem}#retorik-container.rf-large .large\\:rf-ml-0{margin-left:0}#retorik-container.rf-large .large\\:rf-ml-12{margin-left:3rem}#retorik-container.rf-large .large\\:rf-ml-4{margin-left:1rem}#retorik-container.rf-large .large\\:rf-ml-8{margin-left:2rem}#retorik-container.rf-large .large\\:rf-mr-3{margin-right:.75rem}#retorik-container.rf-large .large\\:rf-mr-30{margin-right:7.5rem}#retorik-container.rf-large .large\\:rf-mt-0{margin-top:0}#retorik-container.rf-large .large\\:rf-mt-20{margin-top:5rem}#retorik-container.rf-large .large\\:rf-mt-3{margin-top:.75rem}#retorik-container.rf-large .large\\:rf-mt-\\[20vh\\]{margin-top:20vh}#retorik-container.rf-large .large\\:rf-block{display:block}#retorik-container.rf-large .large\\:rf-flex{display:flex}#retorik-container.rf-large .large\\:rf-hidden{display:none}#retorik-container.rf-large .large\\:rf-aspect-video{aspect-ratio:16/9}#retorik-container.rf-large .large\\:rf-h-16{height:4rem}#retorik-container.rf-large .large\\:rf-h-3\\/5{height:60%}#retorik-container.rf-large .large\\:rf-h-4{height:1rem}#retorik-container.rf-large .large\\:rf-h-5{height:1.25rem}#retorik-container.rf-large .large\\:rf-h-6{height:1.5rem}#retorik-container.rf-large .large\\:rf-h-8{height:2rem}#retorik-container.rf-large .large\\:rf-h-\\[1\\.3rem\\]{height:1.3rem}#retorik-container.rf-large .large\\:rf-h-\\[60vh\\]{height:60vh}#retorik-container.rf-large .large\\:rf-h-auto{height:auto}#retorik-container.rf-large .large\\:rf-h-full{height:100%}#retorik-container.rf-large .large\\:rf-max-h-28{max-height:7rem}#retorik-container.rf-large .large\\:rf-max-h-\\[2\\.3rem\\]{max-height:2.3rem}#retorik-container.rf-large .large\\:rf-min-h-\\[2\\.3rem\\]{min-height:2.3rem}#retorik-container.rf-large .large\\:rf-w-1\\/8{width:12.5%}#retorik-container.rf-large .large\\:rf-w-14{width:3.5rem}#retorik-container.rf-large .large\\:rf-w-16{width:4rem}#retorik-container.rf-large .large\\:rf-w-3\\/5{width:60%}#retorik-container.rf-large .large\\:rf-w-4{width:1rem}#retorik-container.rf-large .large\\:rf-w-5{width:1.25rem}#retorik-container.rf-large .large\\:rf-w-6{width:1.5rem}#retorik-container.rf-large .large\\:rf-w-8{width:2rem}#retorik-container.rf-large .large\\:rf-w-fit{width:fit-content}#retorik-container.rf-large .large\\:rf-w-full{width:100%}#retorik-container.rf-large .large\\:rf-min-w-1\\/2{min-width:50%}#retorik-container.rf-large .large\\:rf-min-w-1\\/8{min-width:12.5%}#retorik-container.rf-large .large\\:rf-min-w-16{min-width:4rem}#retorik-container.rf-large .large\\:rf-min-w-3\\/5{min-width:60%}#retorik-container.rf-large .large\\:rf-min-w-8{min-width:2rem}#retorik-container.rf-large .large\\:rf-max-w-1\\/8{max-width:12.5%}#retorik-container.rf-large .large\\:rf-max-w-\\[12rem\\]{max-width:12rem}#retorik-container.rf-large .large\\:rf-max-w-full{max-width:100%}#retorik-container.rf-large .large\\:rf-grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}#retorik-container.rf-large .large\\:rf-flex-row{flex-direction:row}#retorik-container.rf-large .large\\:rf-flex-col{flex-direction:column}#retorik-container.rf-large .large\\:rf-items-baseline{align-items:baseline}#retorik-container.rf-large .large\\:rf-justify-start{justify-content:flex-start}#retorik-container.rf-large .large\\:rf-gap-1{gap:.25rem}#retorik-container.rf-large .large\\:rf-gap-3{gap:.75rem}#retorik-container.rf-large .large\\:rf-gap-4{gap:1rem}#retorik-container.rf-large .large\\:rf-gap-6{gap:1.5rem}#retorik-container.rf-large .large\\:rf-overflow-y-scroll{overflow-y:scroll}#retorik-container.rf-large .large\\:rf-border-t-0{border-top-width:0}#retorik-container.rf-large .large\\:rf-bg-truewhite{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}#retorik-container.rf-large .large\\:rf-p-4{padding:1rem}#retorik-container.rf-large .large\\:rf-p-\\[25px\\]{padding:25px}#retorik-container.rf-large .large\\:rf-p-min1{padding:.1rem}#retorik-container.rf-large .large\\:rf-px-0{padding-left:0;padding-right:0}#retorik-container.rf-large .large\\:rf-px-16{padding-left:4rem;padding-right:4rem}#retorik-container.rf-large .large\\:rf-px-4{padding-left:1rem;padding-right:1rem}#retorik-container.rf-large .large\\:rf-px-5,#retorik-container.rf-large .large\\:rf-px-6{padding-left:1.5rem;padding-right:1.5rem}#retorik-container.rf-large .large\\:rf-px-8{padding-left:2rem;padding-right:2rem}#retorik-container.rf-large .large\\:rf-py-0{padding-top:0;padding-bottom:0}#retorik-container.rf-large .large\\:rf-py-1{padding-top:.25rem;padding-bottom:.25rem}#retorik-container.rf-large .large\\:rf-py-2{padding-top:.5rem;padding-bottom:.5rem}#retorik-container.rf-large .large\\:rf-py-3{padding-top:.75rem;padding-bottom:.75rem}#retorik-container.rf-large .large\\:rf-py-4{padding-top:1rem;padding-bottom:1rem}#retorik-container.rf-large .large\\:rf-pb-16{padding-bottom:4rem}#retorik-container.rf-large .large\\:rf-pl-12{padding-left:3rem}#retorik-container.rf-large .large\\:rf-pl-4{padding-left:1rem}#retorik-container.rf-large .large\\:rf-pr-4{padding-right:1rem}#retorik-container.rf-large .large\\:rf-pt-16{padding-top:4rem}#retorik-container.rf-large .large\\:rf-pt-3{padding-top:.75rem}#retorik-container.rf-large .large\\:rf-text-5xl{font-size:3rem;line-height:1}#retorik-container.rf-large .large\\:rf-text-6xl{font-size:3.75rem;line-height:1}#retorik-container.rf-large .large\\:rf-text-base{font-size:1rem;line-height:1.5rem}#retorik-container.rf-large .large\\:rf-text-basecustom{font-size:1rem;line-height:1.3rem}#retorik-container.rf-large .large\\:rf-text-sm{font-size:.875rem;line-height:1.25rem}#retorik-container.rf-large .large\\:rf-uppercase{text-transform:uppercase}#retorik-container.rf-tactile .tactile\\:rf-h-4{height:1rem}#retorik-container.rf-tactile .tactile\\:rf-h-6{height:1.5rem}#retorik-container.rf-tactile .tactile\\:rf-w-6{width:1.5rem}#retorik-container.rf-tactile .tactile\\:rf-pt-1\\/5{padding-top:20%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-bottom-\\[25vh\\]{bottom:25vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-left-4{left:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-top-4{top:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-span-full{grid-column:1/-1}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-start-1{grid-column-start:1}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-start-2{grid-column-start:2}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-end-8{grid-column-end:8}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-col-end-9{grid-column-end:9}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-span-4{grid-row:span 4/span 4}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-span-6{grid-row:span 6/span 6}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-start-5{grid-row-start:5}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-start-7{grid-row-start:7}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-end-11{grid-row-end:11}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-row-end-7{grid-row-end:7}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-4{margin-top:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-\\[20vh\\]{margin-top:20vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-mt-\\[25vh\\]{margin-top:25vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-block{display:block}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-hidden{display:none}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-1\\/2{height:50%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-14{height:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-24{height:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-6{height:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-h-\\[50vh\\]{height:50vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-11\\/12{max-height:91.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-36{max-height:9rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-\\[18vh\\]{max-height:18vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-h-\\[30vh\\]{max-height:30vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-1\\/2{width:50%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-14{width:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-16{width:4rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-24{width:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-3\\/5{width:60%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-4\\/9{width:45%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-6{width:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-w-full{width:100%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-14{min-width:3.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-24{min-width:6rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-min-w-4\\/9{min-width:45%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-w-2\\/3{max-width:66.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-max-w-\\[60\\%\\]{max-width:60%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-flex-row{flex-direction:row}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-justify-center{justify-content:center}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-gap-6{gap:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-self-end{align-self:flex-end}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-border-t{border-top-width:1px}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-border-t-menuBorder{--tw-border-opacity:1;border-top-color:rgb(224 225 231/var(--tw-border-opacity))}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-py-4{padding-top:1rem;padding-bottom:1rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-py-5{padding-top:1.5rem;padding-bottom:1.5rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pl-0{padding-left:0}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-8{padding-top:2rem}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-\\[16\\.67\\%\\]{padding-top:16.67%}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-pt-\\[20vh\\]{padding-top:20vh}#retorik-container.rf-large.rf-portrait .large-vertical\\:rf-text-basecustomuppercase{font-size:1rem;line-height:1.1rem}#retorik-container.rf-large.rf-tactile .large-tactile\\:rf-mt-0{margin-top:0}#retorik-container.rf-large.rf-tactile .large-tactile\\:rf-flex{display:flex}#retorik-container.rf-large.rf-tactile .large-tactile\\:rf-hidden{display:none}#retorik-container.rf-large:not(.rf-portrait) .desktop\\:rf-h-full{height:100%}@media (height<=700px) and (width<=300px){.small-mobile\\:rf-row-span-6{grid-row:span 6/span 6}.small-mobile\\:rf-row-span-7{grid-row:span 7/span 7}.small-mobile\\:rf-row-start-5{grid-row-start:5}}";


var $c2d0c3cf9dc6c8cf$exports = {};
$c2d0c3cf9dc6c8cf$exports = "*,:before,:after,::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.ses-pointer-events-none{pointer-events:none}.ses-invisible{visibility:hidden}.ses-relative{position:relative}.ses-col-span-1{grid-column:span 1/span 1}.ses-col-start-1{grid-column-start:1}.ses-row-span-1{grid-row:span 1/span 1}.ses-row-start-1{grid-row-start:1}.ses-grid{display:grid}.ses-h-full{height:100%}.ses-max-h-screen{max-height:100vh}.ses-w-full{width:100%}.ses-max-w-none{max-width:none}.ses-items-start{align-items:flex-start}.ses-justify-center{justify-content:center}.ses-self-start{align-self:flex-start}.ses-justify-self-center{justify-self:center}.ses-overflow-hidden{overflow:hidden}.ses-object-cover{object-fit:cover}.animation-delay-2{ses-animation-delay:.2s}.animation-delay-4{ses-animation-delay:.4s}.opacity-gradient{-webkit-mask-image:linear-gradient(#0000 0%,6%,#000,94%,#0000 100%)}";


var $ea70e5eb0a588495$exports = {};
$ea70e5eb0a588495$exports = ".leaflet-pane,.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile-container,.leaflet-pane>svg,.leaflet-pane>canvas,.leaflet-zoom-box,.leaflet-image-layer,.leaflet-layer{position:absolute;top:0;left:0}.leaflet-container{overflow:hidden}.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow{-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-tile::selection{background:0 0}.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}.leaflet-safari .leaflet-tile-container{-webkit-transform-origin:0 0;width:1600px;height:1600px}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container .leaflet-overlay-pane svg{max-width:none!important;max-height:none!important}.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-shadow-pane img,.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer,.leaflet-container .leaflet-tile{width:auto;padding:0;max-width:none!important;max-height:none!important}.leaflet-container img.leaflet-tile{mix-blend-mode:plus-lighter}.leaflet-container.leaflet-touch-zoom{-ms-touch-action:pan-x pan-y;touch-action:pan-x pan-y}.leaflet-container.leaflet-touch-drag{-ms-touch-action:pinch-zoom;touch-action:none;touch-action:pinch-zoom}.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom{-ms-touch-action:none;touch-action:none}.leaflet-container{-webkit-tap-highlight-color:transparent}.leaflet-container a{-webkit-tap-highlight-color:#33b5e566}.leaflet-tile{filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{-moz-box-sizing:border-box;box-sizing:border-box;z-index:800;width:0;height:0}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-pane{z-index:400}.leaflet-tile-pane{z-index:200}.leaflet-overlay-pane{z-index:400}.leaflet-shadow-pane{z-index:500}.leaflet-marker-pane{z-index:600}.leaflet-tooltip-pane{z-index:650}.leaflet-popup-pane{z-index:700}.leaflet-map-pane canvas{z-index:100}.leaflet-map-pane svg{z-index:200}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{z-index:800;pointer-events:visiblePainted;pointer-events:auto;position:relative}.leaflet-top,.leaflet-bottom{z-index:1000;pointer-events:none;position:absolute}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-control{float:left;clear:both}.leaflet-right .leaflet-control{float:right}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-right .leaflet-control{margin-right:10px}.leaflet-fade-anim .leaflet-popup{opacity:0;-webkit-transition:opacity .2s linear;-moz-transition:opacity .2s linear;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}.leaflet-zoom-animated{-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}svg.leaflet-zoom-animated{will-change:transform}.leaflet-zoom-anim .leaflet-zoom-animated{-webkit-transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);-moz-transition:-moz-transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1)}.leaflet-zoom-anim .leaflet-tile,.leaflet-pan-anim .leaflet-tile{-webkit-transition:none;-moz-transition:none;transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-interactive{cursor:pointer}.leaflet-grab{cursor:-webkit-grab;cursor:-moz-grab;cursor:grab}.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}.leaflet-popup-pane,.leaflet-control{cursor:auto}.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-image-layer,.leaflet-pane>svg path,.leaflet-tile-container{pointer-events:none}.leaflet-marker-icon.leaflet-interactive,.leaflet-image-layer.leaflet-interactive,.leaflet-pane>svg path.leaflet-interactive,svg.leaflet-image-layer.leaflet-interactive path{pointer-events:visiblePainted;pointer-events:auto}.leaflet-container{outline-offset:1px;background:#ddd}.leaflet-container a{color:#0078a8}.leaflet-zoom-box{background:#ffffff80;border:2px dotted #38f}.leaflet-container{font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:.75rem;line-height:1.5}.leaflet-bar{border-radius:4px;box-shadow:0 1px 5px #000000a6}.leaflet-bar a{text-align:center;color:#000;background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;text-decoration:none;display:block}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover,.leaflet-bar a:focus{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom:none;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.leaflet-bar a.leaflet-disabled{cursor:default;color:#bbb;background-color:#f4f4f4}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-touch .leaflet-bar a:first-child{border-top-left-radius:2px;border-top-right-radius:2px}.leaflet-touch .leaflet-bar a:last-child{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{text-indent:1px;font:700 18px Lucida Console,Monaco,monospace}.leaflet-touch .leaflet-control-zoom-in,.leaflet-touch .leaflet-control-zoom-out{font-size:22px}.leaflet-control-layers{background:#fff;border-radius:5px;box-shadow:0 1px 5px #0006}.leaflet-control-layers-toggle{background-image:url(layers.760a0456.png);width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(layers-2x.b7b89169.png);background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers .leaflet-control-layers-list,.leaflet-control-layers-expanded .leaflet-control-layers-toggle{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{color:#333;background:#fff;padding:6px 10px 6px 6px}.leaflet-control-layers-scrollbar{padding-right:5px;overflow:hidden scroll}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{font-size:1.08333em;display:block}.leaflet-control-layers-separator{border-top:1px solid #ddd;height:0;margin:5px -10px 5px -6px}.leaflet-default-icon-path{background-image:url(marker-icon.3f7d3721.png)}.leaflet-container .leaflet-control-attribution{background:#fffc;margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{color:#333;padding:0 5px;line-height:1.4}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover,.leaflet-control-attribution a:focus{text-decoration:underline}.leaflet-attribution-flag{width:1em;height:.6669em;vertical-align:baseline!important;display:inline!important}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{white-space:nowrap;-moz-box-sizing:border-box;box-sizing:border-box;text-shadow:1px 1px #fff;background:#fffc;border:2px solid #777;border-top:none;padding:2px 5px 1px;line-height:1.1}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{box-shadow:none}.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{background-clip:padding-box;border:2px solid #0003}.leaflet-popup{text-align:center;margin-bottom:20px;position:absolute}.leaflet-popup-content-wrapper{text-align:left;border-radius:12px;padding:1px}.leaflet-popup-content{min-height:1px;margin:13px 24px 13px 20px;font-size:1.08333em;line-height:1.3}.leaflet-popup-content p{margin:1.3em 0}.leaflet-popup-tip-container{pointer-events:none;width:40px;height:20px;margin-top:-1px;margin-left:-20px;position:absolute;left:50%;overflow:hidden}.leaflet-popup-tip{pointer-events:auto;width:17px;height:17px;margin:-10px auto 0;padding:1px;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{color:#333;background:#fff;box-shadow:0 3px 14px #0006}.leaflet-container a.leaflet-popup-close-button{text-align:center;color:#757575;background:0 0;border:none;width:24px;height:24px;font:16px/24px Tahoma,Verdana,sans-serif;text-decoration:none;position:absolute;top:0;right:0}.leaflet-container a.leaflet-popup-close-button:hover,.leaflet-container a.leaflet-popup-close-button:focus{color:#585858}.leaflet-popup-scrolled{overflow:auto}.leaflet-oldie .leaflet-popup-content-wrapper{-ms-zoom:1}.leaflet-oldie .leaflet-popup-tip{-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";filter:progid:DXImageTransform.Microsoft.Matrix(M11=.707107,M12=.707107,M21=-.707107,M22=.707107);width:24px;margin:0 auto}.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.leaflet-tooltip{color:#222;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;background-color:#fff;border:1px solid #fff;border-radius:3px;padding:6px;position:absolute;box-shadow:0 1px 3px #0006}.leaflet-tooltip.leaflet-interactive{cursor:pointer;pointer-events:auto}.leaflet-tooltip-top:before,.leaflet-tooltip-bottom:before,.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{pointer-events:none;content:\"\";background:0 0;border:6px solid #0000;position:absolute}.leaflet-tooltip-bottom{margin-top:6px}.leaflet-tooltip-top{margin-top:-6px}.leaflet-tooltip-bottom:before,.leaflet-tooltip-top:before{margin-left:-6px;left:50%}.leaflet-tooltip-top:before{border-top-color:#fff;margin-bottom:-12px;bottom:0}.leaflet-tooltip-bottom:before{border-bottom-color:#fff;margin-top:-12px;margin-left:-6px;top:0}.leaflet-tooltip-left{margin-left:-6px}.leaflet-tooltip-right{margin-left:6px}.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{margin-top:-6px;top:50%}.leaflet-tooltip-left:before{border-left-color:#fff;margin-right:-12px;right:0}.leaflet-tooltip-right:before{border-right-color:#fff;margin-left:-12px;left:0}@media print{.leaflet-control{-webkit-print-color-adjust:exact;print-color-adjust:exact}}";


var $45d43a6de0968f42$export$3b4d92ba873f009a;
(function($45d43a6de0968f42$export$3b4d92ba873f009a) {
    $45d43a6de0968f42$export$3b4d92ba873f009a[$45d43a6de0968f42$export$3b4d92ba873f009a["home"] = 1] = "home";
    $45d43a6de0968f42$export$3b4d92ba873f009a[$45d43a6de0968f42$export$3b4d92ba873f009a["news"] = 2] = "news";
    $45d43a6de0968f42$export$3b4d92ba873f009a[$45d43a6de0968f42$export$3b4d92ba873f009a["weather"] = 3] = "weather";
    $45d43a6de0968f42$export$3b4d92ba873f009a[$45d43a6de0968f42$export$3b4d92ba873f009a["emergency"] = 4] = "emergency";
})($45d43a6de0968f42$export$3b4d92ba873f009a || ($45d43a6de0968f42$export$3b4d92ba873f009a = {}));
var $45d43a6de0968f42$export$c5a4c3ea2d78493c;
(function($45d43a6de0968f42$export$c5a4c3ea2d78493c) {
    $45d43a6de0968f42$export$c5a4c3ea2d78493c[$45d43a6de0968f42$export$c5a4c3ea2d78493c["history"] = 1000] = "history";
    $45d43a6de0968f42$export$c5a4c3ea2d78493c[$45d43a6de0968f42$export$c5a4c3ea2d78493c["tutorial"] = 1001] = "tutorial";
})($45d43a6de0968f42$export$c5a4c3ea2d78493c || ($45d43a6de0968f42$export$c5a4c3ea2d78493c = {}));
var $45d43a6de0968f42$export$22b261e08140d6b2;
(function($45d43a6de0968f42$export$22b261e08140d6b2) {
    $45d43a6de0968f42$export$22b261e08140d6b2["eat"] = "where to eat";
    $45d43a6de0968f42$export$22b261e08140d6b2["sleep"] = "where to sleep";
    $45d43a6de0968f42$export$22b261e08140d6b2["see"] = "what to see";
    $45d43a6de0968f42$export$22b261e08140d6b2["do"] = "what to do";
    $45d43a6de0968f42$export$22b261e08140d6b2["localproducts"] = "local products";
    $45d43a6de0968f42$export$22b261e08140d6b2["services"] = "services";
    $45d43a6de0968f42$export$22b261e08140d6b2["agenda"] = "events";
    $45d43a6de0968f42$export$22b261e08140d6b2["occupant"] = "occupant";
})($45d43a6de0968f42$export$22b261e08140d6b2 || ($45d43a6de0968f42$export$22b261e08140d6b2 = {}));
var $45d43a6de0968f42$export$a31c5a03aaeee5f;
(function($45d43a6de0968f42$export$a31c5a03aaeee5f) {
    $45d43a6de0968f42$export$a31c5a03aaeee5f[$45d43a6de0968f42$export$a31c5a03aaeee5f["agent"] = 1] = "agent";
    $45d43a6de0968f42$export$a31c5a03aaeee5f[$45d43a6de0968f42$export$a31c5a03aaeee5f["widget"] = 2] = "widget";
    $45d43a6de0968f42$export$a31c5a03aaeee5f[$45d43a6de0968f42$export$a31c5a03aaeee5f["news"] = 3] = "news";
})($45d43a6de0968f42$export$a31c5a03aaeee5f || ($45d43a6de0968f42$export$a31c5a03aaeee5f = {}));
var $45d43a6de0968f42$export$f05d0fed0593ead7;
(function($45d43a6de0968f42$export$f05d0fed0593ead7) {
    $45d43a6de0968f42$export$f05d0fed0593ead7[$45d43a6de0968f42$export$f05d0fed0593ead7["none"] = 1] = "none";
    $45d43a6de0968f42$export$f05d0fed0593ead7[$45d43a6de0968f42$export$f05d0fed0593ead7["history"] = 2] = "history";
    $45d43a6de0968f42$export$f05d0fed0593ead7[$45d43a6de0968f42$export$f05d0fed0593ead7["languages"] = 3] = "languages";
    $45d43a6de0968f42$export$f05d0fed0593ead7[$45d43a6de0968f42$export$f05d0fed0593ead7["weather"] = 4] = "weather";
    $45d43a6de0968f42$export$f05d0fed0593ead7[$45d43a6de0968f42$export$f05d0fed0593ead7["emergency"] = 5] = "emergency";
    $45d43a6de0968f42$export$f05d0fed0593ead7[$45d43a6de0968f42$export$f05d0fed0593ead7["custom"] = 6] = "custom";
})($45d43a6de0968f42$export$f05d0fed0593ead7 || ($45d43a6de0968f42$export$f05d0fed0593ead7 = {}));
var $45d43a6de0968f42$export$950556173b6cbecb;
(function($45d43a6de0968f42$export$950556173b6cbecb) {
    $45d43a6de0968f42$export$950556173b6cbecb[$45d43a6de0968f42$export$950556173b6cbecb["background"] = 1] = "background";
    $45d43a6de0968f42$export$950556173b6cbecb[$45d43a6de0968f42$export$950556173b6cbecb["util"] = 2] = "util";
    $45d43a6de0968f42$export$950556173b6cbecb[$45d43a6de0968f42$export$950556173b6cbecb["chatbot"] = 3] = "chatbot";
    $45d43a6de0968f42$export$950556173b6cbecb[$45d43a6de0968f42$export$950556173b6cbecb["ui"] = 4] = "ui";
    $45d43a6de0968f42$export$950556173b6cbecb[$45d43a6de0968f42$export$950556173b6cbecb["dropdown"] = 5] = "dropdown";
    $45d43a6de0968f42$export$950556173b6cbecb[$45d43a6de0968f42$export$950556173b6cbecb["overlay"] = 6] = "overlay";
    $45d43a6de0968f42$export$950556173b6cbecb[$45d43a6de0968f42$export$950556173b6cbecb["menu"] = 7] = "menu";
    $45d43a6de0968f42$export$950556173b6cbecb[$45d43a6de0968f42$export$950556173b6cbecb["modal"] = 8] = "modal";
    $45d43a6de0968f42$export$950556173b6cbecb[$45d43a6de0968f42$export$950556173b6cbecb["exitwidget"] = 9] = "exitwidget";
})($45d43a6de0968f42$export$950556173b6cbecb || ($45d43a6de0968f42$export$950556173b6cbecb = {}));
var $45d43a6de0968f42$export$ec1e04e4e5ef8233;
(function($45d43a6de0968f42$export$ec1e04e4e5ef8233) {
    $45d43a6de0968f42$export$ec1e04e4e5ef8233[$45d43a6de0968f42$export$ec1e04e4e5ef8233["mobile"] = 1] = "mobile";
    $45d43a6de0968f42$export$ec1e04e4e5ef8233[$45d43a6de0968f42$export$ec1e04e4e5ef8233["borne"] = 2] = "borne";
    $45d43a6de0968f42$export$ec1e04e4e5ef8233[$45d43a6de0968f42$export$ec1e04e4e5ef8233["landscape"] = 3] = "landscape";
    $45d43a6de0968f42$export$ec1e04e4e5ef8233[$45d43a6de0968f42$export$ec1e04e4e5ef8233["widget"] = 4] = "widget";
    $45d43a6de0968f42$export$ec1e04e4e5ef8233[$45d43a6de0968f42$export$ec1e04e4e5ef8233["widgetLandscape"] = 5] = "widgetLandscape";
    $45d43a6de0968f42$export$ec1e04e4e5ef8233[$45d43a6de0968f42$export$ec1e04e4e5ef8233["widgetBorne"] = 6] = "widgetBorne";
})($45d43a6de0968f42$export$ec1e04e4e5ef8233 || ($45d43a6de0968f42$export$ec1e04e4e5ef8233 = {}));
var $45d43a6de0968f42$export$bd7313a2f8345cae;
(function($45d43a6de0968f42$export$bd7313a2f8345cae) {
    $45d43a6de0968f42$export$bd7313a2f8345cae[$45d43a6de0968f42$export$bd7313a2f8345cae["loader"] = 1] = "loader";
    $45d43a6de0968f42$export$bd7313a2f8345cae[$45d43a6de0968f42$export$bd7313a2f8345cae["locale"] = 2] = "locale";
    $45d43a6de0968f42$export$bd7313a2f8345cae[$45d43a6de0968f42$export$bd7313a2f8345cae["supported"] = 3] = "supported";
    $45d43a6de0968f42$export$bd7313a2f8345cae[$45d43a6de0968f42$export$bd7313a2f8345cae["store"] = 4] = "store";
    $45d43a6de0968f42$export$bd7313a2f8345cae[$45d43a6de0968f42$export$bd7313a2f8345cae["directline"] = 5] = "directline";
    $45d43a6de0968f42$export$bd7313a2f8345cae[$45d43a6de0968f42$export$bd7313a2f8345cae["ponyfill"] = 6] = "ponyfill";
    $45d43a6de0968f42$export$bd7313a2f8345cae[$45d43a6de0968f42$export$bd7313a2f8345cae["agentdata"] = 7] = "agentdata";
})($45d43a6de0968f42$export$bd7313a2f8345cae || ($45d43a6de0968f42$export$bd7313a2f8345cae = {}));
var $45d43a6de0968f42$export$9484bbecc3c49a2e;
(function($45d43a6de0968f42$export$9484bbecc3c49a2e) {
    $45d43a6de0968f42$export$9484bbecc3c49a2e[$45d43a6de0968f42$export$9484bbecc3c49a2e["vocal"] = 1] = "vocal";
    $45d43a6de0968f42$export$9484bbecc3c49a2e[$45d43a6de0968f42$export$9484bbecc3c49a2e["text"] = 2] = "text";
    $45d43a6de0968f42$export$9484bbecc3c49a2e[$45d43a6de0968f42$export$9484bbecc3c49a2e["dashboard"] = 3] = "dashboard";
})($45d43a6de0968f42$export$9484bbecc3c49a2e || ($45d43a6de0968f42$export$9484bbecc3c49a2e = {}));
var $45d43a6de0968f42$export$13807d9ee5a34a42;
(function($45d43a6de0968f42$export$13807d9ee5a34a42) {
    $45d43a6de0968f42$export$13807d9ee5a34a42[$45d43a6de0968f42$export$13807d9ee5a34a42["top"] = 1] = "top";
    $45d43a6de0968f42$export$13807d9ee5a34a42[$45d43a6de0968f42$export$13807d9ee5a34a42["right"] = 2] = "right";
    $45d43a6de0968f42$export$13807d9ee5a34a42[$45d43a6de0968f42$export$13807d9ee5a34a42["bottom"] = 3] = "bottom";
    $45d43a6de0968f42$export$13807d9ee5a34a42[$45d43a6de0968f42$export$13807d9ee5a34a42["left"] = 4] = "left";
})($45d43a6de0968f42$export$13807d9ee5a34a42 || ($45d43a6de0968f42$export$13807d9ee5a34a42 = {}));
var $45d43a6de0968f42$export$4f7cd669585dc69f;
(function($45d43a6de0968f42$export$4f7cd669585dc69f) {
    $45d43a6de0968f42$export$4f7cd669585dc69f[$45d43a6de0968f42$export$4f7cd669585dc69f["DetailViewOpen"] = 1] = "DetailViewOpen";
    $45d43a6de0968f42$export$4f7cd669585dc69f[$45d43a6de0968f42$export$4f7cd669585dc69f["DetailViewClose"] = 2] = "DetailViewClose";
    $45d43a6de0968f42$export$4f7cd669585dc69f[$45d43a6de0968f42$export$4f7cd669585dc69f["SpeechStarted"] = 3] = "SpeechStarted";
    $45d43a6de0968f42$export$4f7cd669585dc69f[$45d43a6de0968f42$export$4f7cd669585dc69f["SpeechEnded"] = 4] = "SpeechEnded";
})($45d43a6de0968f42$export$4f7cd669585dc69f || ($45d43a6de0968f42$export$4f7cd669585dc69f = {}));
var $45d43a6de0968f42$export$3f0071308968cd80;
(function($45d43a6de0968f42$export$3f0071308968cd80) {
    $45d43a6de0968f42$export$3f0071308968cd80[$45d43a6de0968f42$export$3f0071308968cd80["Initializing"] = 1] = "Initializing";
    $45d43a6de0968f42$export$3f0071308968cd80[$45d43a6de0968f42$export$3f0071308968cd80["Listening"] = 2] = "Listening";
    $45d43a6de0968f42$export$3f0071308968cd80[$45d43a6de0968f42$export$3f0071308968cd80["Closing"] = 3] = "Closing";
    $45d43a6de0968f42$export$3f0071308968cd80[$45d43a6de0968f42$export$3f0071308968cd80["ForceClosing"] = 4] = "ForceClosing";
    $45d43a6de0968f42$export$3f0071308968cd80[$45d43a6de0968f42$export$3f0071308968cd80["Closed"] = 5] = "Closed";
})($45d43a6de0968f42$export$3f0071308968cd80 || ($45d43a6de0968f42$export$3f0071308968cd80 = {}));
var $45d43a6de0968f42$export$3565eb3d00ca5a74;
(function($45d43a6de0968f42$export$3565eb3d00ca5a74) {
    $45d43a6de0968f42$export$3565eb3d00ca5a74[$45d43a6de0968f42$export$3565eb3d00ca5a74["Home"] = 1] = "Home";
    $45d43a6de0968f42$export$3565eb3d00ca5a74[$45d43a6de0968f42$export$3565eb3d00ca5a74["News"] = 2] = "News";
})($45d43a6de0968f42$export$3565eb3d00ca5a74 || ($45d43a6de0968f42$export$3565eb3d00ca5a74 = {}));
var $45d43a6de0968f42$export$f0cfc93288d9ec06;
(function($45d43a6de0968f42$export$f0cfc93288d9ec06) {
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Regret"] = "regret";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Dislike"] = "dislike";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Distress"] = "distress";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Fear"] = "fear";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Sadness"] = "sadness";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Shame"] = "shame";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Contempt"] = "contempt";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Disgust"] = "disgust";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Guilt"] = "guilt";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Anger"] = "anger";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Frustration"] = "frustration";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Pride"] = "pride";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Love"] = "love";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Relief"] = "relief";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Joy"] = "joy";
    $45d43a6de0968f42$export$f0cfc93288d9ec06["Hope"] = "hope";
})($45d43a6de0968f42$export$f0cfc93288d9ec06 || ($45d43a6de0968f42$export$f0cfc93288d9ec06 = {}));
var $45d43a6de0968f42$export$a2a634340dd7e3e3;
(function($45d43a6de0968f42$export$a2a634340dd7e3e3) {
    $45d43a6de0968f42$export$a2a634340dd7e3e3[$45d43a6de0968f42$export$a2a634340dd7e3e3["small"] = 0] = "small";
    $45d43a6de0968f42$export$a2a634340dd7e3e3[$45d43a6de0968f42$export$a2a634340dd7e3e3["medium"] = 1] = "medium";
    $45d43a6de0968f42$export$a2a634340dd7e3e3[$45d43a6de0968f42$export$a2a634340dd7e3e3["large"] = 2] = "large";
})($45d43a6de0968f42$export$a2a634340dd7e3e3 || ($45d43a6de0968f42$export$a2a634340dd7e3e3 = {}));
var $45d43a6de0968f42$export$972614fc43112105;
(function($45d43a6de0968f42$export$972614fc43112105) {
    $45d43a6de0968f42$export$972614fc43112105[$45d43a6de0968f42$export$972614fc43112105["none"] = 0] = "none";
    $45d43a6de0968f42$export$972614fc43112105[$45d43a6de0968f42$export$972614fc43112105["normal"] = 1] = "normal";
    $45d43a6de0968f42$export$972614fc43112105[$45d43a6de0968f42$export$972614fc43112105["carousel"] = 2] = "carousel";
    $45d43a6de0968f42$export$972614fc43112105[$45d43a6de0968f42$export$972614fc43112105["grid"] = 3] = "grid";
    $45d43a6de0968f42$export$972614fc43112105[$45d43a6de0968f42$export$972614fc43112105["carouselgrid"] = 4] = "carouselgrid";
    $45d43a6de0968f42$export$972614fc43112105[$45d43a6de0968f42$export$972614fc43112105["list"] = 5] = "list";
})($45d43a6de0968f42$export$972614fc43112105 || ($45d43a6de0968f42$export$972614fc43112105 = {}));
var $45d43a6de0968f42$export$e4a712fff93fb00f;
(function($45d43a6de0968f42$export$e4a712fff93fb00f) {
    $45d43a6de0968f42$export$e4a712fff93fb00f["message"] = "message";
    $45d43a6de0968f42$export$e4a712fff93fb00f["event"] = "event";
    $45d43a6de0968f42$export$e4a712fff93fb00f["url"] = "url";
    $45d43a6de0968f42$export$e4a712fff93fb00f["internal"] = "internal";
})($45d43a6de0968f42$export$e4a712fff93fb00f || ($45d43a6de0968f42$export$e4a712fff93fb00f = {}));


const $bbe458fac496c294$export$2e65b7c7134e01f0 = 600;
const $bbe458fac496c294$export$91e4bf93df95a062 = 1500;
const $bbe458fac496c294$export$66b40c15080ce99b = "https://cdn.retorik.ai";
const $bbe458fac496c294$export$2475544086fd222b = `${$bbe458fac496c294$export$66b40c15080ce99b}/spiritenginehtml5/characters`;
const $bbe458fac496c294$export$f718170a6537817b = `${$bbe458fac496c294$export$66b40c15080ce99b}/retorik-framework/imagefiles`;
const $bbe458fac496c294$export$eefca12493f9e9b9 = `${$bbe458fac496c294$export$66b40c15080ce99b}/retorik-framework/audiofiles`;
const $bbe458fac496c294$export$c398bfda6cfa19ff = "https://studio.retorik.ai";
const $bbe458fac496c294$export$9adff68f093278ec = "https://dev.studio.retorik.ai";
const $bbe458fac496c294$export$409889737849a04f = "https://preview.studio.retorik.ai";
const $bbe458fac496c294$export$a4481ccc388fce2a = "https://experimental.studio.retorik.ai";
const $bbe458fac496c294$export$9a9d93503cb8eba5 = "https://management.retorik.ai";
const $bbe458fac496c294$export$9679f5e7d9635332 = "https://dev.management.retorik.ai";
const $bbe458fac496c294$export$d775aabd593372b1 = "https://staging.management.retorik.ai";
const $bbe458fac496c294$export$9683c9c18296186 = "/api/getOGData";
const $bbe458fac496c294$export$d6542303192de6db = "https://api.openrouteservice.org/v2/directions";
const $bbe458fac496c294$export$6f60da16472d34a7 = "5b3ce3597851110001cf62483cfd6bd46f934b7d96f108a35e0f08b8";
const $bbe458fac496c294$export$dc91bcad81fffb1f = "https://api.open-meteo.com/v1/forecast?";
const $bbe458fac496c294$export$68b4ac416ba801c6 = "&daily=weathercode,temperature_2m_max,temperature_2m_min&timezone=auto&current_weather=true";
const $bbe458fac496c294$export$d9e38c0112bbdae6 = "K2.ContentFields.WebChat/api/GetWebchatToken";
const $bbe458fac496c294$export$1ca3e229e23d7f42 = "api/hospitality/Emergency";
const $bbe458fac496c294$export$1e8c600abff9ea62 = "https://telemetry.retorik.ai/otlp-http/v1/traces";
const $bbe458fac496c294$export$f3c31933b33f3693 = "https://www.google.com/maps/dir/?api=1&";
const $bbe458fac496c294$export$8828fbbb6034a09b = {
    default: "fr-FR",
    all: [
        "fr-FR"
    ]
};
const $bbe458fac496c294$export$9bbca248acc786d3 = [
    {
        view: (0, $45d43a6de0968f42$export$3b4d92ba873f009a).home,
        indice: 1
    },
    {
        view: (0, $45d43a6de0968f42$export$3b4d92ba873f009a).emergency,
        indice: 2
    }
];
const $bbe458fac496c294$export$890576ebf405f6b7 = [
    {
        view: (0, $45d43a6de0968f42$export$c5a4c3ea2d78493c).history,
        indice: 1
    },
    {
        view: (0, $45d43a6de0968f42$export$c5a4c3ea2d78493c).tutorial,
        indice: 2
    }
];
const $bbe458fac496c294$export$78f16669b353a880 = [
    (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile,
    (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget
];
const $bbe458fac496c294$export$909f4c209eb70365 = [
    (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget,
    (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetBorne,
    (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetLandscape
];
const $bbe458fac496c294$export$baf53ca377ebf861 = [
    (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).landscape,
    (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetLandscape
];
const $bbe458fac496c294$export$a8576d98c9c928de = [
    (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).borne,
    (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetBorne
];
const $bbe458fac496c294$export$c0da64553318f2cb = {
    primary: "#00D7FF",
    secondary: "#1999B1",
    black: "#101219",
    whereToEatColor: "#FC952E",
    whereToSleepColor: "#9F007D",
    tobeSeenColor: "#76AB2A",
    tobeDoneColor: "#E23C2A",
    localProductsColor: "#AFB942",
    servicesColor: "#00C8BC",
    agendaColor: "#865DA2",
    occupantColor: "#6DEDBC"
};
const $bbe458fac496c294$export$6a32bf5257e620e1 = [
    "davi.closewindow",
    "setuser",
    "davi.gdprconsent"
];


const $15bfb737ffe6480e$export$e56d88b19b5c9fbf = {
    noimage: `${(0, $bbe458fac496c294$export$f718170a6537817b)}/no-image.png`,
    logoRetorikBlack: `${(0, $bbe458fac496c294$export$f718170a6537817b)}/logo_RETORIK_black.png`,
    logoRetorikWhite: `${(0, $bbe458fac496c294$export$f718170a6537817b)}/logo_RETORIK_white.png`,
    mapDeparture: `${(0, $bbe458fac496c294$export$f718170a6537817b)}/Leaflet/map_departure.png`,
    mapArrival: `${(0, $bbe458fac496c294$export$f718170a6537817b)}/Leaflet/map_arrival.png`,
    leaMini: `${(0, $bbe458fac496c294$export$f718170a6537817b)}/lea_mini.png`
};


var $7283d4ae4f1ab968$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($7283d4ae4f1ab968$exports);
})($7283d4ae4f1ab968$exports, function(exports) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports.Bounds = Bounds;
    exports.Browser = Browser;
    exports.CRS = CRS;
    exports.Canvas = Canvas;
    exports.Circle = Circle;
    exports.CircleMarker = CircleMarker;
    exports.Class = Class;
    exports.Control = Control;
    exports.DivIcon = DivIcon;
    exports.DivOverlay = DivOverlay;
    exports.DomEvent = DomEvent;
    exports.DomUtil = DomUtil;
    exports.Draggable = Draggable;
    exports.Evented = Evented;
    exports.FeatureGroup = FeatureGroup;
    exports.GeoJSON = GeoJSON;
    exports.GridLayer = GridLayer;
    exports.Handler = Handler;
    exports.Icon = Icon;
    exports.ImageOverlay = ImageOverlay;
    exports.LatLng = LatLng;
    exports.LatLngBounds = LatLngBounds;
    exports.Layer = Layer;
    exports.LayerGroup = LayerGroup;
    exports.LineUtil = LineUtil;
    exports.Map = Map;
    exports.Marker = Marker;
    exports.Mixin = Mixin;
    exports.Path = Path;
    exports.Point = Point;
    exports.PolyUtil = PolyUtil;
    exports.Polygon = Polygon;
    exports.Polyline = Polyline;
    exports.Popup = Popup;
    exports.PosAnimation = PosAnimation;
    exports.Projection = index;
    exports.Rectangle = Rectangle;
    exports.Renderer = Renderer;
    exports.SVG = SVG;
    exports.SVGOverlay = SVGOverlay;
    exports.TileLayer = TileLayer;
    exports.Tooltip = Tooltip;
    exports.Transformation = Transformation;
    exports.Util = Util;
    exports.VideoOverlay = VideoOverlay;
    exports.bind = bind;
    exports.bounds = toBounds;
    exports.canvas = canvas;
    exports.circle = circle;
    exports.circleMarker = circleMarker;
    exports.control = control;
    exports.divIcon = divIcon;
    exports.extend = extend;
    exports.featureGroup = featureGroup;
    exports.geoJSON = geoJSON;
    exports.geoJson = geoJson;
    exports.gridLayer = gridLayer;
    exports.icon = icon;
    exports.imageOverlay = imageOverlay;
    exports.latLng = toLatLng;
    exports.latLngBounds = toLatLngBounds;
    exports.layerGroup = layerGroup;
    exports.map = createMap;
    exports.marker = marker;
    exports.point = toPoint;
    exports.polygon = polygon;
    exports.polyline = polyline;
    exports.popup = popup;
    exports.rectangle = rectangle;
    exports.setOptions = setOptions;
    exports.stamp = stamp;
    exports.svg = svg;
    exports.svgOverlay = svgOverlay;
    exports.tileLayer = tileLayer;
    exports.tooltip = tooltip;
    exports.transformation = toTransformation;
    exports.version = version;
    exports.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports;
});


var $ea792a137d117a0b$exports = {};

$ea792a137d117a0b$exports = (parcelRequire("ghbiQ")).getBundleURL("3ufsE") + "marker-shadow.8f26ed1f.png";


/**
 * STORYBOOK : there is a conflict between parcel and webpack. Here we use bundle-text from parcel and it's not recognized in webpack, that is used in storybook.
 * To prevent conflict, you need to comment the 3 imports unsign 'bundle-text' above, and the 3 'style' tags in the HTML below.
 */ const $ec2ce1c4441090f2$var$DefaultIcon = (0, (/*@__PURE__*/$parcel$interopDefault($7283d4ae4f1ab968$exports))).icon({
    iconUrl: `${(0, $15bfb737ffe6480e$export$e56d88b19b5c9fbf).mapArrival}`,
    shadowUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ea792a137d117a0b$exports))),
    iconSize: [
        32,
        41
    ],
    iconAnchor: [
        10,
        41
    ]
});
(0, (/*@__PURE__*/$parcel$interopDefault($7283d4ae4f1ab968$exports))).Marker.prototype.options.icon = $ec2ce1c4441090f2$var$DefaultIcon;
const $ec2ce1c4441090f2$var$ShadowRoot = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $1048fd584ae862d4$export$2e2bcd8739ae039).div, {
        id: "retorik-shadow",
        className: "rf-w-full rf-h-full",
        style: {
            position: "relative",
            overscrollBehaviorY: "contain"
        },
        children: [
            children,
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("style", {
                type: "text/css",
                children: `${$227de6ae7c8b1320$exports}`
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("style", {
                type: "text/css",
                children: `${$c2d0c3cf9dc6c8cf$exports}`
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("style", {
                type: "text/css",
                children: `${$ea70e5eb0a588495$exports}`
            })
        ]
    });
};
var $ec2ce1c4441090f2$export$2e2bcd8739ae039 = $ec2ce1c4441090f2$var$ShadowRoot;





var $lT7pJ = parcelRequire("lT7pJ");
/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");
var $dbdd077456dd22ff$exports = {};
"use strict";

var $1PoM0 = parcelRequire("1PoM0");

var $kKXRo = parcelRequire("kKXRo");
Object.defineProperty($dbdd077456dd22ff$exports, "__esModule", {
    value: true
});
Object.defineProperty($dbdd077456dd22ff$exports, "DirectLineStreaming", {
    enumerable: true,
    get: function get() {
        return $b0e81407e9f785f6$exports.DirectLineStreaming;
    }
});
$dbdd077456dd22ff$exports.DirectLine = $dbdd077456dd22ff$exports.ConnectionStatus = void 0;

var $dbdd077456dd22ff$var$_objectWithoutProperties2 = $1PoM0((parcelRequire("NHqNP")));

var $dbdd077456dd22ff$var$_classCallCheck2 = $1PoM0((parcelRequire("2Ao05")));

var $dbdd077456dd22ff$var$_createClass2 = $1PoM0((parcelRequire("awXxO")));

var $dbdd077456dd22ff$var$_defineProperty2 = $1PoM0((parcelRequire("k9YyE")));
var $b767c3230e66af32$exports = {};
var $e8b2c3d1d93a88fd$exports = {};
"use strict";
var $91c0ad260ce40c60$exports = {};
var $25cda8ae230c77ba$exports = {};
var $25cda8ae230c77ba$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$25cda8ae230c77ba$exports = // eslint-disable-next-line es/no-global-this -- safe
$25cda8ae230c77ba$var$check(typeof globalThis == "object" && globalThis) || $25cda8ae230c77ba$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$25cda8ae230c77ba$var$check(typeof self == "object" && self) || $25cda8ae230c77ba$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $4e4ba6ef18114099$export$2d1720544b23b823;
var $3254c1b9470feded$exports = {};
var $219b7317e5481db9$exports = {};
$219b7317e5481db9$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$3254c1b9470feded$exports = !$219b7317e5481db9$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $795cefcc4750bcb6$export$2d1720544b23b823;
"use strict";
var $795cefcc4750bcb6$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $795cefcc4750bcb6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $795cefcc4750bcb6$var$NASHORN_BUG = $795cefcc4750bcb6$var$getOwnPropertyDescriptor && !$795cefcc4750bcb6$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$795cefcc4750bcb6$export$2d1720544b23b823 = $795cefcc4750bcb6$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $795cefcc4750bcb6$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $795cefcc4750bcb6$var$$propertyIsEnumerable;


var $ae11c51bca431a68$exports = {};
$ae11c51bca431a68$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $be742d7cb838f108$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $4266bdc6c54a6409$exports = {};

var $4d0a8e0ef6f877c2$exports = {};
var $4d0a8e0ef6f877c2$var$toString = {}.toString;
$4d0a8e0ef6f877c2$exports = function(it) {
    return $4d0a8e0ef6f877c2$var$toString.call(it).slice(8, -1);
};


var $4266bdc6c54a6409$var$split = "".split;
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$4266bdc6c54a6409$exports = $219b7317e5481db9$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $4d0a8e0ef6f877c2$exports(it) == "String" ? $4266bdc6c54a6409$var$split.call(it, "") : Object(it);
} : Object;


var $a3f27e0d56606666$exports = {};
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$a3f27e0d56606666$exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};


$be742d7cb838f108$exports = function(it) {
    return $4266bdc6c54a6409$exports($a3f27e0d56606666$exports(it));
};


var $9ef650c6109b4d9b$exports = {};
var $0b91f8553256226d$exports = {};
$0b91f8553256226d$exports = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};


// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
$9ef650c6109b4d9b$exports = function(input, PREFERRED_STRING) {
    if (!$0b91f8553256226d$exports(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$0b91f8553256226d$exports(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == "function" && !$0b91f8553256226d$exports(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$0b91f8553256226d$exports(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
};


var $3d88f2b414199ee1$exports = {};
var $a3e649951b26abf3$exports = {};

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a3e649951b26abf3$exports = function(argument) {
    return Object($a3f27e0d56606666$exports(argument));
};


var $3d88f2b414199ee1$var$hasOwnProperty = {}.hasOwnProperty;
$3d88f2b414199ee1$exports = Object.hasOwn || function hasOwn(it, key) {
    return $3d88f2b414199ee1$var$hasOwnProperty.call($a3e649951b26abf3$exports(it), key);
};


var $68549ac8ab46ef5b$exports = {};


var $98b8654f8c2ab5a4$exports = {};


var $98b8654f8c2ab5a4$var$document = $25cda8ae230c77ba$exports.document;
// typeof document.createElement is 'object' in old IE
var $98b8654f8c2ab5a4$var$EXISTS = $0b91f8553256226d$exports($98b8654f8c2ab5a4$var$document) && $0b91f8553256226d$exports($98b8654f8c2ab5a4$var$document.createElement);
$98b8654f8c2ab5a4$exports = function(it) {
    return $98b8654f8c2ab5a4$var$EXISTS ? $98b8654f8c2ab5a4$var$document.createElement(it) : {};
};


// Thank's IE8 for his funny defineProperty
$68549ac8ab46ef5b$exports = !$3254c1b9470feded$exports && !$219b7317e5481db9$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
    return Object.defineProperty($98b8654f8c2ab5a4$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $4e4ba6ef18114099$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$4e4ba6ef18114099$export$2d1720544b23b823 = $3254c1b9470feded$exports ? $4e4ba6ef18114099$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $be742d7cb838f108$exports(O);
    P = $9ef650c6109b4d9b$exports(P, true);
    if ($68549ac8ab46ef5b$exports) try {
        return $4e4ba6ef18114099$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($3d88f2b414199ee1$exports(O, P)) return $ae11c51bca431a68$exports(!$795cefcc4750bcb6$export$2d1720544b23b823.call(O, P), O[P]);
};


var $91c0ad260ce40c60$require$getOwnPropertyDescriptor = $4e4ba6ef18114099$export$2d1720544b23b823;
var $fd02b894e75f7276$exports = {};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $ebc0fb67b62346bc$export$2d1720544b23b823;


var $0fd7d46079e2c0ac$exports = {};

$0fd7d46079e2c0ac$exports = function(it) {
    if (!$0b91f8553256226d$exports(it)) throw TypeError(String(it) + " is not an object");
    return it;
};



// eslint-disable-next-line es/no-object-defineproperty -- safe
var $ebc0fb67b62346bc$var$$defineProperty = Object.defineProperty;
$ebc0fb67b62346bc$export$2d1720544b23b823 = $3254c1b9470feded$exports ? $ebc0fb67b62346bc$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $0fd7d46079e2c0ac$exports(O);
    P = $9ef650c6109b4d9b$exports(P, true);
    $0fd7d46079e2c0ac$exports(Attributes);
    if ($68549ac8ab46ef5b$exports) try {
        return $ebc0fb67b62346bc$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$fd02b894e75f7276$exports = $3254c1b9470feded$exports ? function(object, key, value) {
    return $ebc0fb67b62346bc$export$2d1720544b23b823(object, key, $ae11c51bca431a68$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $11f7892e297683ed$exports = {};



var $0af709249cfbdbf0$exports = {};


$0af709249cfbdbf0$exports = function(key, value) {
    try {
        $fd02b894e75f7276$exports($25cda8ae230c77ba$exports, key, value);
    } catch (error) {
        $25cda8ae230c77ba$exports[key] = value;
    }
    return value;
};


var $b1dbb19f067ce8d0$exports = {};
var $069cb64ec8f25772$exports = {};


var $069cb64ec8f25772$var$SHARED = "__core-js_shared__";
var $069cb64ec8f25772$var$store = $25cda8ae230c77ba$exports[$069cb64ec8f25772$var$SHARED] || $0af709249cfbdbf0$exports($069cb64ec8f25772$var$SHARED, {});
$069cb64ec8f25772$exports = $069cb64ec8f25772$var$store;


var $b1dbb19f067ce8d0$var$functionToString = Function.toString;
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof $069cb64ec8f25772$exports.inspectSource != "function") $069cb64ec8f25772$exports.inspectSource = function(it) {
    return $b1dbb19f067ce8d0$var$functionToString.call(it);
};
$b1dbb19f067ce8d0$exports = $069cb64ec8f25772$exports.inspectSource;


var $a4bed47222a45a53$exports = {};
var $0d5f30ab5b24ce54$exports = {};


var $0d5f30ab5b24ce54$var$WeakMap = $25cda8ae230c77ba$exports.WeakMap;
$0d5f30ab5b24ce54$exports = typeof $0d5f30ab5b24ce54$var$WeakMap === "function" && /native code/.test($b1dbb19f067ce8d0$exports($0d5f30ab5b24ce54$var$WeakMap));







var $b6ca72970e9795f3$exports = {};
var $be1017df7726abaf$exports = {};
var $e4c776601bc56394$exports = {};
$e4c776601bc56394$exports = false;



($be1017df7726abaf$exports = function(key, value) {
    return $069cb64ec8f25772$exports[key] || ($069cb64ec8f25772$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.15.2",
    mode: $e4c776601bc56394$exports ? "pure" : "global",
    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
});


var $57283036d65e4ec4$exports = {};
var $57283036d65e4ec4$var$id = 0;
var $57283036d65e4ec4$var$postfix = Math.random();
$57283036d65e4ec4$exports = function(key) {
    return "Symbol(" + String(key === undefined ? "" : key) + ")_" + (++$57283036d65e4ec4$var$id + $57283036d65e4ec4$var$postfix).toString(36);
};


var $b6ca72970e9795f3$var$keys = $be1017df7726abaf$exports("keys");
$b6ca72970e9795f3$exports = function(key) {
    return $b6ca72970e9795f3$var$keys[key] || ($b6ca72970e9795f3$var$keys[key] = $57283036d65e4ec4$exports(key));
};


var $62c2c46dcf1b41de$exports = {};
$62c2c46dcf1b41de$exports = {};


var $a4bed47222a45a53$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $a4bed47222a45a53$var$WeakMap = $25cda8ae230c77ba$exports.WeakMap;
var $a4bed47222a45a53$var$set, $a4bed47222a45a53$var$get, $a4bed47222a45a53$var$has;
var $a4bed47222a45a53$var$enforce = function(it) {
    return $a4bed47222a45a53$var$has(it) ? $a4bed47222a45a53$var$get(it) : $a4bed47222a45a53$var$set(it, {});
};
var $a4bed47222a45a53$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$0b91f8553256226d$exports(it) || (state = $a4bed47222a45a53$var$get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($0d5f30ab5b24ce54$exports || $069cb64ec8f25772$exports.state) {
    var $a4bed47222a45a53$var$store = $069cb64ec8f25772$exports.state || ($069cb64ec8f25772$exports.state = new $a4bed47222a45a53$var$WeakMap());
    var $a4bed47222a45a53$var$wmget = $a4bed47222a45a53$var$store.get;
    var $a4bed47222a45a53$var$wmhas = $a4bed47222a45a53$var$store.has;
    var $a4bed47222a45a53$var$wmset = $a4bed47222a45a53$var$store.set;
    $a4bed47222a45a53$var$set = function(it, metadata) {
        if ($a4bed47222a45a53$var$wmhas.call($a4bed47222a45a53$var$store, it)) throw new TypeError($a4bed47222a45a53$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $a4bed47222a45a53$var$wmset.call($a4bed47222a45a53$var$store, it, metadata);
        return metadata;
    };
    $a4bed47222a45a53$var$get = function(it) {
        return $a4bed47222a45a53$var$wmget.call($a4bed47222a45a53$var$store, it) || {};
    };
    $a4bed47222a45a53$var$has = function(it) {
        return $a4bed47222a45a53$var$wmhas.call($a4bed47222a45a53$var$store, it);
    };
} else {
    var $a4bed47222a45a53$var$STATE = $b6ca72970e9795f3$exports("state");
    $62c2c46dcf1b41de$exports[$a4bed47222a45a53$var$STATE] = true;
    $a4bed47222a45a53$var$set = function(it, metadata) {
        if ($3d88f2b414199ee1$exports(it, $a4bed47222a45a53$var$STATE)) throw new TypeError($a4bed47222a45a53$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $fd02b894e75f7276$exports(it, $a4bed47222a45a53$var$STATE, metadata);
        return metadata;
    };
    $a4bed47222a45a53$var$get = function(it) {
        return $3d88f2b414199ee1$exports(it, $a4bed47222a45a53$var$STATE) ? it[$a4bed47222a45a53$var$STATE] : {};
    };
    $a4bed47222a45a53$var$has = function(it) {
        return $3d88f2b414199ee1$exports(it, $a4bed47222a45a53$var$STATE);
    };
}
$a4bed47222a45a53$exports = {
    set: $a4bed47222a45a53$var$set,
    get: $a4bed47222a45a53$var$get,
    has: $a4bed47222a45a53$var$has,
    enforce: $a4bed47222a45a53$var$enforce,
    getterFor: $a4bed47222a45a53$var$getterFor
};


var $11f7892e297683ed$var$getInternalState = $a4bed47222a45a53$exports.get;
var $11f7892e297683ed$var$enforceInternalState = $a4bed47222a45a53$exports.enforce;
var $11f7892e297683ed$var$TEMPLATE = String(String).split("String");
($11f7892e297683ed$exports = function(O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var state;
    if (typeof value == "function") {
        if (typeof key == "string" && !$3d88f2b414199ee1$exports(value, "name")) $fd02b894e75f7276$exports(value, "name", key);
        state = $11f7892e297683ed$var$enforceInternalState(value);
        if (!state.source) state.source = $11f7892e297683ed$var$TEMPLATE.join(typeof key == "string" ? key : "");
    }
    if (O === $25cda8ae230c77ba$exports) {
        if (simple) O[key] = value;
        else $0af709249cfbdbf0$exports(key, value);
        return;
    } else if (!unsafe) delete O[key];
    else if (!noTargetGet && O[key]) simple = true;
    if (simple) O[key] = value;
    else $fd02b894e75f7276$exports(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, "toString", function toString() {
    return typeof this == "function" && $11f7892e297683ed$var$getInternalState(this).source || $b1dbb19f067ce8d0$exports(this);
});



var $3c37d2cc263ce1e1$exports = {};

var $89609e7f401550e0$exports = {};
var $585215ba854ca762$exports = {};
var $80def7ac7d076d06$exports = {};

$80def7ac7d076d06$exports = $25cda8ae230c77ba$exports;



var $585215ba854ca762$var$aFunction = function(variable) {
    return typeof variable == "function" ? variable : undefined;
};
$585215ba854ca762$exports = function(namespace, method) {
    return arguments.length < 2 ? $585215ba854ca762$var$aFunction($80def7ac7d076d06$exports[namespace]) || $585215ba854ca762$var$aFunction($25cda8ae230c77ba$exports[namespace]) : $80def7ac7d076d06$exports[namespace] && $80def7ac7d076d06$exports[namespace][method] || $25cda8ae230c77ba$exports[namespace] && $25cda8ae230c77ba$exports[namespace][method];
};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $17921cdea2b59493$export$2d1720544b23b823;
var $b38d960463c1d052$exports = {};


var $6026b4b8bf8eada5$exports = {};

var $81afa0424e1c90d0$exports = {};
var $2c3be2da3921c029$exports = {};
var $2c3be2da3921c029$var$ceil = Math.ceil;
var $2c3be2da3921c029$var$floor = Math.floor;
// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
$2c3be2da3921c029$exports = function(argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? $2c3be2da3921c029$var$floor : $2c3be2da3921c029$var$ceil)(argument);
};


var $81afa0424e1c90d0$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$81afa0424e1c90d0$exports = function(argument) {
    return argument > 0 ? $81afa0424e1c90d0$var$min($2c3be2da3921c029$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


var $ccda597f74037854$exports = {};

var $ccda597f74037854$var$max = Math.max;
var $ccda597f74037854$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$ccda597f74037854$exports = function(index, length) {
    var integer = $2c3be2da3921c029$exports(index);
    return integer < 0 ? $ccda597f74037854$var$max(integer + length, 0) : $ccda597f74037854$var$min(integer, length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $6026b4b8bf8eada5$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $be742d7cb838f108$exports($this);
        var length = $81afa0424e1c90d0$exports(O.length);
        var index = $ccda597f74037854$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$6026b4b8bf8eada5$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $6026b4b8bf8eada5$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $6026b4b8bf8eada5$var$createMethod(false)
};


var $b38d960463c1d052$require$indexOf = $6026b4b8bf8eada5$exports.indexOf;

$b38d960463c1d052$exports = function(object, names) {
    var O = $be742d7cb838f108$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$3d88f2b414199ee1$exports($62c2c46dcf1b41de$exports, key) && $3d88f2b414199ee1$exports(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($3d88f2b414199ee1$exports(O, key = names[i++])) ~$b38d960463c1d052$require$indexOf(result, key) || result.push(key);
    return result;
};


var $dba612fa68cd6967$exports = {};
// IE8- don't enum bug keys
$dba612fa68cd6967$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $17921cdea2b59493$var$hiddenKeys = $dba612fa68cd6967$exports.concat("length", "prototype");
$17921cdea2b59493$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $b38d960463c1d052$exports(O, $17921cdea2b59493$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $d5c4f1cd52d88950$export$2d1720544b23b823;
$d5c4f1cd52d88950$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



// all object keys, includes non-enumerable and symbols
$89609e7f401550e0$exports = $585215ba854ca762$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $17921cdea2b59493$export$2d1720544b23b823($0fd7d46079e2c0ac$exports(it));
    var getOwnPropertySymbols = $d5c4f1cd52d88950$export$2d1720544b23b823;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};




$3c37d2cc263ce1e1$exports = function(target, source) {
    var keys = $89609e7f401550e0$exports(source);
    var defineProperty = $ebc0fb67b62346bc$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $4e4ba6ef18114099$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$3d88f2b414199ee1$exports(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $e52890ae3b2dc1d7$exports = {};

var $e52890ae3b2dc1d7$var$replacement = /#|\.prototype\./;
var $e52890ae3b2dc1d7$var$isForced = function(feature, detection) {
    var value = $e52890ae3b2dc1d7$var$data[$e52890ae3b2dc1d7$var$normalize(feature)];
    return value == $e52890ae3b2dc1d7$var$POLYFILL ? true : value == $e52890ae3b2dc1d7$var$NATIVE ? false : typeof detection == "function" ? $219b7317e5481db9$exports(detection) : !!detection;
};
var $e52890ae3b2dc1d7$var$normalize = $e52890ae3b2dc1d7$var$isForced.normalize = function(string) {
    return String(string).replace($e52890ae3b2dc1d7$var$replacement, ".").toLowerCase();
};
var $e52890ae3b2dc1d7$var$data = $e52890ae3b2dc1d7$var$isForced.data = {};
var $e52890ae3b2dc1d7$var$NATIVE = $e52890ae3b2dc1d7$var$isForced.NATIVE = "N";
var $e52890ae3b2dc1d7$var$POLYFILL = $e52890ae3b2dc1d7$var$isForced.POLYFILL = "P";
$e52890ae3b2dc1d7$exports = $e52890ae3b2dc1d7$var$isForced;


/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ $91c0ad260ce40c60$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $25cda8ae230c77ba$exports;
    else if (STATIC) target = $25cda8ae230c77ba$exports[TARGET] || $0af709249cfbdbf0$exports(TARGET, {});
    else target = ($25cda8ae230c77ba$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $91c0ad260ce40c60$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $e52890ae3b2dc1d7$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty === typeof targetProperty) continue;
            $3c37d2cc263ce1e1$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $fd02b894e75f7276$exports(sourceProperty, "sham", true);
        // extend global
        $11f7892e297683ed$exports(target, key, sourceProperty, options);
    }
};


var $cebabf84b7624bf0$exports = {};



var $a548464c18176b5d$exports = {};

$a548464c18176b5d$exports = !$219b7317e5481db9$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $cebabf84b7624bf0$var$IE_PROTO = $b6ca72970e9795f3$exports("IE_PROTO");
var $cebabf84b7624bf0$var$ObjectPrototype = Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$cebabf84b7624bf0$exports = $a548464c18176b5d$exports ? Object.getPrototypeOf : function(O) {
    O = $a3e649951b26abf3$exports(O);
    if ($3d88f2b414199ee1$exports(O, $cebabf84b7624bf0$var$IE_PROTO)) return O[$cebabf84b7624bf0$var$IE_PROTO];
    if (typeof O.constructor == "function" && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $cebabf84b7624bf0$var$ObjectPrototype : null;
};


var $289b3823d17d13d6$exports = {};
/* eslint-disable no-proto -- safe */ 
var $75ae01727e4918c6$exports = {};

$75ae01727e4918c6$exports = function(it) {
    if (!$0b91f8553256226d$exports(it) && it !== null) throw TypeError("Can't set " + String(it) + " as a prototype");
    return it;
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$289b3823d17d13d6$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        setter = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set;
        setter.call(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $0fd7d46079e2c0ac$exports(O);
        $75ae01727e4918c6$exports(proto);
        if (CORRECT_SETTER) setter.call(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);


var $3a9cf24895febf8a$exports = {};

var $ce9a98f0dbc8d8f1$exports = {};



var $b0119168b3ed987e$exports = {};


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$b0119168b3ed987e$exports = Object.keys || function keys(O) {
    return $b38d960463c1d052$exports(O, $dba612fa68cd6967$exports);
};


// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$ce9a98f0dbc8d8f1$exports = $3254c1b9470feded$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $0fd7d46079e2c0ac$exports(O);
    var keys = $b0119168b3ed987e$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$ebc0fb67b62346bc$export$2d1720544b23b823(O, key = keys[index++], Properties[key]);
    return O;
};




var $18dee3de4fbac6b3$exports = {};

$18dee3de4fbac6b3$exports = $585215ba854ca762$exports("document", "documentElement");




var $3a9cf24895febf8a$var$GT = ">";
var $3a9cf24895febf8a$var$LT = "<";
var $3a9cf24895febf8a$var$PROTOTYPE = "prototype";
var $3a9cf24895febf8a$var$SCRIPT = "script";
var $3a9cf24895febf8a$var$IE_PROTO = $b6ca72970e9795f3$exports("IE_PROTO");
var $3a9cf24895febf8a$var$EmptyConstructor = function() {};
var $3a9cf24895febf8a$var$scriptTag = function(content) {
    return $3a9cf24895febf8a$var$LT + $3a9cf24895febf8a$var$SCRIPT + $3a9cf24895febf8a$var$GT + content + $3a9cf24895febf8a$var$LT + "/" + $3a9cf24895febf8a$var$SCRIPT + $3a9cf24895febf8a$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $3a9cf24895febf8a$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($3a9cf24895febf8a$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $3a9cf24895febf8a$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $98b8654f8c2ab5a4$exports("iframe");
    var JS = "java" + $3a9cf24895febf8a$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $18dee3de4fbac6b3$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($3a9cf24895febf8a$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $3a9cf24895febf8a$var$activeXDocument;
var $3a9cf24895febf8a$var$NullProtoObject = function() {
    try {
        /* global ActiveXObject -- old IE */ $3a9cf24895febf8a$var$activeXDocument = document.domain && new ActiveXObject("htmlfile");
    } catch (error) {}
    $3a9cf24895febf8a$var$NullProtoObject = $3a9cf24895febf8a$var$activeXDocument ? $3a9cf24895febf8a$var$NullProtoObjectViaActiveX($3a9cf24895febf8a$var$activeXDocument) : $3a9cf24895febf8a$var$NullProtoObjectViaIFrame();
    var length = $dba612fa68cd6967$exports.length;
    while(length--)delete $3a9cf24895febf8a$var$NullProtoObject[$3a9cf24895febf8a$var$PROTOTYPE][$dba612fa68cd6967$exports[length]];
    return $3a9cf24895febf8a$var$NullProtoObject();
};
$62c2c46dcf1b41de$exports[$3a9cf24895febf8a$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$3a9cf24895febf8a$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $3a9cf24895febf8a$var$EmptyConstructor[$3a9cf24895febf8a$var$PROTOTYPE] = $0fd7d46079e2c0ac$exports(O);
        result = new $3a9cf24895febf8a$var$EmptyConstructor();
        $3a9cf24895febf8a$var$EmptyConstructor[$3a9cf24895febf8a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$3a9cf24895febf8a$var$IE_PROTO] = O;
    } else result = $3a9cf24895febf8a$var$NullProtoObject();
    return Properties === undefined ? result : $ce9a98f0dbc8d8f1$exports(result, Properties);
};




var $36f4ae876634e5cb$exports = {};

var $99d42471ca7e5689$exports = {};
var $aa3bb503d83c56f6$exports = {};




var $50ffe9fc55fc41ba$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $64f9b20aff84ed6d$exports = {};

var $8ff09a363b0eb8c8$exports = {};

$8ff09a363b0eb8c8$exports = $585215ba854ca762$exports("navigator", "userAgent") || "";


var $64f9b20aff84ed6d$var$process = $25cda8ae230c77ba$exports.process;
var $64f9b20aff84ed6d$var$versions = $64f9b20aff84ed6d$var$process && $64f9b20aff84ed6d$var$process.versions;
var $64f9b20aff84ed6d$var$v8 = $64f9b20aff84ed6d$var$versions && $64f9b20aff84ed6d$var$versions.v8;
var $64f9b20aff84ed6d$var$match, $64f9b20aff84ed6d$var$version;
if ($64f9b20aff84ed6d$var$v8) {
    $64f9b20aff84ed6d$var$match = $64f9b20aff84ed6d$var$v8.split(".");
    $64f9b20aff84ed6d$var$version = $64f9b20aff84ed6d$var$match[0] < 4 ? 1 : $64f9b20aff84ed6d$var$match[0] + $64f9b20aff84ed6d$var$match[1];
} else if ($8ff09a363b0eb8c8$exports) {
    $64f9b20aff84ed6d$var$match = $8ff09a363b0eb8c8$exports.match(/Edge\/(\d+)/);
    if (!$64f9b20aff84ed6d$var$match || $64f9b20aff84ed6d$var$match[1] >= 74) {
        $64f9b20aff84ed6d$var$match = $8ff09a363b0eb8c8$exports.match(/Chrome\/(\d+)/);
        if ($64f9b20aff84ed6d$var$match) $64f9b20aff84ed6d$var$version = $64f9b20aff84ed6d$var$match[1];
    }
}
$64f9b20aff84ed6d$exports = $64f9b20aff84ed6d$var$version && +$64f9b20aff84ed6d$var$version;



// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$50ffe9fc55fc41ba$exports = !!Object.getOwnPropertySymbols && !$219b7317e5481db9$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $64f9b20aff84ed6d$exports && $64f9b20aff84ed6d$exports < 41;
});


var $329d2909ec25f1fe$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ 
$329d2909ec25f1fe$exports = $50ffe9fc55fc41ba$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $aa3bb503d83c56f6$var$WellKnownSymbolsStore = $be1017df7726abaf$exports("wks");
var $aa3bb503d83c56f6$var$Symbol = $25cda8ae230c77ba$exports.Symbol;
var $aa3bb503d83c56f6$var$createWellKnownSymbol = $329d2909ec25f1fe$exports ? $aa3bb503d83c56f6$var$Symbol : $aa3bb503d83c56f6$var$Symbol && $aa3bb503d83c56f6$var$Symbol.withoutSetter || $57283036d65e4ec4$exports;
$aa3bb503d83c56f6$exports = function(name) {
    if (!$3d88f2b414199ee1$exports($aa3bb503d83c56f6$var$WellKnownSymbolsStore, name) || !($50ffe9fc55fc41ba$exports || typeof $aa3bb503d83c56f6$var$WellKnownSymbolsStore[name] == "string")) {
        if ($50ffe9fc55fc41ba$exports && $3d88f2b414199ee1$exports($aa3bb503d83c56f6$var$Symbol, name)) $aa3bb503d83c56f6$var$WellKnownSymbolsStore[name] = $aa3bb503d83c56f6$var$Symbol[name];
        else $aa3bb503d83c56f6$var$WellKnownSymbolsStore[name] = $aa3bb503d83c56f6$var$createWellKnownSymbol("Symbol." + name);
    }
    return $aa3bb503d83c56f6$var$WellKnownSymbolsStore[name];
};


var $938bb9b1b9970d80$exports = {};
$938bb9b1b9970d80$exports = {};


var $99d42471ca7e5689$var$ITERATOR = $aa3bb503d83c56f6$exports("iterator");
var $99d42471ca7e5689$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$99d42471ca7e5689$exports = function(it) {
    return it !== undefined && ($938bb9b1b9970d80$exports.Array === it || $99d42471ca7e5689$var$ArrayPrototype[$99d42471ca7e5689$var$ITERATOR] === it);
};



var $df6a2596c52dbc09$exports = {};
var $594e9b0474f6973f$exports = {};
$594e9b0474f6973f$exports = function(it) {
    if (typeof it != "function") throw TypeError(String(it) + " is not a function");
    return it;
};


// optional / simple context binding
$df6a2596c52dbc09$exports = function(fn, that, length) {
    $594e9b0474f6973f$exports(fn);
    if (that === undefined) return fn;
    switch(length){
        case 0:
            return function() {
                return fn.call(that);
            };
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};


var $0eee892478f4223f$exports = {};
var $11f81157a827158f$exports = {};
var $af40c850447833a2$exports = {};

var $af40c850447833a2$var$TO_STRING_TAG = $aa3bb503d83c56f6$exports("toStringTag");
var $af40c850447833a2$var$test = {};
$af40c850447833a2$var$test[$af40c850447833a2$var$TO_STRING_TAG] = "z";
$af40c850447833a2$exports = String($af40c850447833a2$var$test) === "[object z]";




var $11f81157a827158f$var$TO_STRING_TAG = $aa3bb503d83c56f6$exports("toStringTag");
// ES3 wrong here
var $11f81157a827158f$var$CORRECT_ARGUMENTS = $4d0a8e0ef6f877c2$exports(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $11f81157a827158f$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$11f81157a827158f$exports = $af40c850447833a2$exports ? $4d0a8e0ef6f877c2$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $11f81157a827158f$var$tryGet(O = Object(it), $11f81157a827158f$var$TO_STRING_TAG)) == "string" ? tag : $11f81157a827158f$var$CORRECT_ARGUMENTS ? $4d0a8e0ef6f877c2$exports(O) : (result = $4d0a8e0ef6f877c2$exports(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : result;
};




var $0eee892478f4223f$var$ITERATOR = $aa3bb503d83c56f6$exports("iterator");
$0eee892478f4223f$exports = function(it) {
    if (it != undefined) return it[$0eee892478f4223f$var$ITERATOR] || it["@@iterator"] || $938bb9b1b9970d80$exports[$11f81157a827158f$exports(it)];
};


var $a9c30ec58c8eeec7$exports = {};

$a9c30ec58c8eeec7$exports = function(iterator) {
    var returnMethod = iterator["return"];
    if (returnMethod !== undefined) return $0fd7d46079e2c0ac$exports(returnMethod.call(iterator)).value;
};


var $36f4ae876634e5cb$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
$36f4ae876634e5cb$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $df6a2596c52dbc09$exports(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $a9c30ec58c8eeec7$exports(iterator);
        return new $36f4ae876634e5cb$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $0fd7d46079e2c0ac$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $0eee892478f4223f$exports(iterable);
        if (typeof iterFn != "function") throw TypeError("Target is not iterable");
        // optimisation for array iterators
        if ($99d42471ca7e5689$exports(iterFn)) {
            for(index = 0, length = $81afa0424e1c90d0$exports(iterable.length); length > index; index++){
                result = callFn(iterable[index]);
                if (result && result instanceof $36f4ae876634e5cb$var$Result) return result;
            }
            return new $36f4ae876634e5cb$var$Result(false);
        }
        iterator = iterFn.call(iterable);
    }
    next = iterator.next;
    while(!(step = next.call(iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $a9c30ec58c8eeec7$exports(iterator);
            throw error;
        }
        if (typeof result == "object" && result && result instanceof $36f4ae876634e5cb$var$Result) return result;
    }
    return new $36f4ae876634e5cb$var$Result(false);
};


var $821abde5c7bf8fd7$var$$AggregateError = function AggregateError(errors, message) {
    var that = this;
    if (!(that instanceof $821abde5c7bf8fd7$var$$AggregateError)) return new $821abde5c7bf8fd7$var$$AggregateError(errors, message);
    if ($289b3823d17d13d6$exports) // eslint-disable-next-line unicorn/error-message -- expected
    that = $289b3823d17d13d6$exports(new Error(undefined), $cebabf84b7624bf0$exports(that));
    if (message !== undefined) $fd02b894e75f7276$exports(that, "message", String(message));
    var errorsArray = [];
    $36f4ae876634e5cb$exports(errors, errorsArray.push, {
        that: errorsArray
    });
    $fd02b894e75f7276$exports(that, "errors", errorsArray);
    return that;
};
$821abde5c7bf8fd7$var$$AggregateError.prototype = $3a9cf24895febf8a$exports(Error.prototype, {
    constructor: $ae11c51bca431a68$exports(5, $821abde5c7bf8fd7$var$$AggregateError),
    message: $ae11c51bca431a68$exports(5, ""),
    name: $ae11c51bca431a68$exports(5, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$91c0ad260ce40c60$exports({
    global: true
}, {
    AggregateError: $821abde5c7bf8fd7$var$$AggregateError
});




var $8d0598a2da75538f$exports = {};
"use strict";


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$8d0598a2da75538f$exports = $af40c850447833a2$exports ? ({}).toString : function toString() {
    return "[object " + $11f81157a827158f$exports(this) + "]";
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$af40c850447833a2$exports) $11f7892e297683ed$exports(Object.prototype, "toString", $8d0598a2da75538f$exports, {
    unsafe: true
});


"use strict";




var $a4c69ecda2cf7976$exports = {};

$a4c69ecda2cf7976$exports = $25cda8ae230c77ba$exports.Promise;



var $34c6c2c680730057$exports = {};

$34c6c2c680730057$exports = function(target, src, options) {
    for(var key in src)$11f7892e297683ed$exports(target, key, src[key], options);
    return target;
};



var $50023f2225ca7d17$exports = {};

var $50023f2225ca7d17$require$defineProperty = $ebc0fb67b62346bc$export$2d1720544b23b823;


var $50023f2225ca7d17$var$TO_STRING_TAG = $aa3bb503d83c56f6$exports("toStringTag");
$50023f2225ca7d17$exports = function(it, TAG, STATIC) {
    if (it && !$3d88f2b414199ee1$exports(it = STATIC ? it : it.prototype, $50023f2225ca7d17$var$TO_STRING_TAG)) $50023f2225ca7d17$require$defineProperty(it, $50023f2225ca7d17$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};


var $65de1c35bbaee3fa$exports = {};
"use strict";




var $65de1c35bbaee3fa$var$SPECIES = $aa3bb503d83c56f6$exports("species");
$65de1c35bbaee3fa$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $585215ba854ca762$exports(CONSTRUCTOR_NAME);
    var defineProperty = $ebc0fb67b62346bc$export$2d1720544b23b823;
    if ($3254c1b9470feded$exports && Constructor && !Constructor[$65de1c35bbaee3fa$var$SPECIES]) defineProperty(Constructor, $65de1c35bbaee3fa$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};




var $15583c16d5fd8cbe$exports = {};
$15583c16d5fd8cbe$exports = function(it, Constructor, name) {
    if (!(it instanceof Constructor)) throw TypeError("Incorrect " + (name ? name + " " : "") + "invocation");
    return it;
};




var $dbcab8dd24d06dfb$exports = {};

var $dbcab8dd24d06dfb$var$ITERATOR = $aa3bb503d83c56f6$exports("iterator");
var $dbcab8dd24d06dfb$var$SAFE_CLOSING = false;
try {
    var $dbcab8dd24d06dfb$var$called = 0;
    var $dbcab8dd24d06dfb$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$dbcab8dd24d06dfb$var$called++
            };
        },
        "return": function() {
            $dbcab8dd24d06dfb$var$SAFE_CLOSING = true;
        }
    };
    $dbcab8dd24d06dfb$var$iteratorWithReturn[$dbcab8dd24d06dfb$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($dbcab8dd24d06dfb$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$dbcab8dd24d06dfb$exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$dbcab8dd24d06dfb$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$dbcab8dd24d06dfb$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $9a28f071c836a05f$exports = {};



var $9a28f071c836a05f$var$SPECIES = $aa3bb503d83c56f6$exports("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$9a28f071c836a05f$exports = function(O, defaultConstructor) {
    var C = $0fd7d46079e2c0ac$exports(O).constructor;
    var S;
    return C === undefined || (S = $0fd7d46079e2c0ac$exports(C)[$9a28f071c836a05f$var$SPECIES]) == undefined ? defaultConstructor : $594e9b0474f6973f$exports(S);
};


var $d8ea1b90ee5d387e$exports = {};





var $cecc07e06c302317$exports = {};

$cecc07e06c302317$exports = /(?:iphone|ipod|ipad).*applewebkit/i.test($8ff09a363b0eb8c8$exports);


var $36163f3dfb318557$exports = {};


$36163f3dfb318557$exports = $4d0a8e0ef6f877c2$exports($25cda8ae230c77ba$exports.process) == "process";


var $d8ea1b90ee5d387e$var$location = $25cda8ae230c77ba$exports.location;
var $d8ea1b90ee5d387e$var$set = $25cda8ae230c77ba$exports.setImmediate;
var $d8ea1b90ee5d387e$var$clear = $25cda8ae230c77ba$exports.clearImmediate;
var $d8ea1b90ee5d387e$var$process = $25cda8ae230c77ba$exports.process;
var $d8ea1b90ee5d387e$var$MessageChannel = $25cda8ae230c77ba$exports.MessageChannel;
var $d8ea1b90ee5d387e$var$Dispatch = $25cda8ae230c77ba$exports.Dispatch;
var $d8ea1b90ee5d387e$var$counter = 0;
var $d8ea1b90ee5d387e$var$queue = {};
var $d8ea1b90ee5d387e$var$ONREADYSTATECHANGE = "onreadystatechange";
var $d8ea1b90ee5d387e$var$defer, $d8ea1b90ee5d387e$var$channel, $d8ea1b90ee5d387e$var$port;
var $d8ea1b90ee5d387e$var$run = function(id) {
    // eslint-disable-next-line no-prototype-builtins -- safe
    if ($d8ea1b90ee5d387e$var$queue.hasOwnProperty(id)) {
        var fn = $d8ea1b90ee5d387e$var$queue[id];
        delete $d8ea1b90ee5d387e$var$queue[id];
        fn();
    }
};
var $d8ea1b90ee5d387e$var$runner = function(id) {
    return function() {
        $d8ea1b90ee5d387e$var$run(id);
    };
};
var $d8ea1b90ee5d387e$var$listener = function(event) {
    $d8ea1b90ee5d387e$var$run(event.data);
};
var $d8ea1b90ee5d387e$var$post = function(id) {
    // old engines have not location.origin
    $25cda8ae230c77ba$exports.postMessage(id + "", $d8ea1b90ee5d387e$var$location.protocol + "//" + $d8ea1b90ee5d387e$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$d8ea1b90ee5d387e$var$set || !$d8ea1b90ee5d387e$var$clear) {
    $d8ea1b90ee5d387e$var$set = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $d8ea1b90ee5d387e$var$queue[++$d8ea1b90ee5d387e$var$counter] = function() {
            // eslint-disable-next-line no-new-func -- spec requirement
            (typeof fn == "function" ? fn : Function(fn)).apply(undefined, args);
        };
        $d8ea1b90ee5d387e$var$defer($d8ea1b90ee5d387e$var$counter);
        return $d8ea1b90ee5d387e$var$counter;
    };
    $d8ea1b90ee5d387e$var$clear = function clearImmediate(id) {
        delete $d8ea1b90ee5d387e$var$queue[id];
    };
    // Node.js 0.8-
    if ($36163f3dfb318557$exports) $d8ea1b90ee5d387e$var$defer = function(id) {
        $d8ea1b90ee5d387e$var$process.nextTick($d8ea1b90ee5d387e$var$runner(id));
    };
    else if ($d8ea1b90ee5d387e$var$Dispatch && $d8ea1b90ee5d387e$var$Dispatch.now) $d8ea1b90ee5d387e$var$defer = function(id) {
        $d8ea1b90ee5d387e$var$Dispatch.now($d8ea1b90ee5d387e$var$runner(id));
    };
    else if ($d8ea1b90ee5d387e$var$MessageChannel && !$cecc07e06c302317$exports) {
        $d8ea1b90ee5d387e$var$channel = new $d8ea1b90ee5d387e$var$MessageChannel();
        $d8ea1b90ee5d387e$var$port = $d8ea1b90ee5d387e$var$channel.port2;
        $d8ea1b90ee5d387e$var$channel.port1.onmessage = $d8ea1b90ee5d387e$var$listener;
        $d8ea1b90ee5d387e$var$defer = $df6a2596c52dbc09$exports($d8ea1b90ee5d387e$var$port.postMessage, $d8ea1b90ee5d387e$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($25cda8ae230c77ba$exports.addEventListener && typeof postMessage == "function" && !$25cda8ae230c77ba$exports.importScripts && $d8ea1b90ee5d387e$var$location && $d8ea1b90ee5d387e$var$location.protocol !== "file:" && !$219b7317e5481db9$exports($d8ea1b90ee5d387e$var$post)) {
        $d8ea1b90ee5d387e$var$defer = $d8ea1b90ee5d387e$var$post;
        $25cda8ae230c77ba$exports.addEventListener("message", $d8ea1b90ee5d387e$var$listener, false);
    // IE8-
    } else if ($d8ea1b90ee5d387e$var$ONREADYSTATECHANGE in $98b8654f8c2ab5a4$exports("script")) $d8ea1b90ee5d387e$var$defer = function(id) {
        $18dee3de4fbac6b3$exports.appendChild($98b8654f8c2ab5a4$exports("script"))[$d8ea1b90ee5d387e$var$ONREADYSTATECHANGE] = function() {
            $18dee3de4fbac6b3$exports.removeChild(this);
            $d8ea1b90ee5d387e$var$run(id);
        };
    };
    else $d8ea1b90ee5d387e$var$defer = function(id) {
        setTimeout($d8ea1b90ee5d387e$var$runner(id), 0);
    };
}
$d8ea1b90ee5d387e$exports = {
    set: $d8ea1b90ee5d387e$var$set,
    clear: $d8ea1b90ee5d387e$var$clear
};


var $650a8da11f16668f$require$task = $d8ea1b90ee5d387e$exports.set;
var $2d44e5fa014dbed3$exports = {};


var $2d44e5fa014dbed3$require$getOwnPropertyDescriptor = $4e4ba6ef18114099$export$2d1720544b23b823;

var $2d44e5fa014dbed3$require$macrotask = $d8ea1b90ee5d387e$exports.set;

var $6eec07107b3ac01d$exports = {};

$6eec07107b3ac01d$exports = /web0s(?!.*chrome)/i.test($8ff09a363b0eb8c8$exports);



var $2d44e5fa014dbed3$var$MutationObserver = $25cda8ae230c77ba$exports.MutationObserver || $25cda8ae230c77ba$exports.WebKitMutationObserver;
var $2d44e5fa014dbed3$var$document = $25cda8ae230c77ba$exports.document;
var $2d44e5fa014dbed3$var$process = $25cda8ae230c77ba$exports.process;
var $2d44e5fa014dbed3$var$Promise = $25cda8ae230c77ba$exports.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $2d44e5fa014dbed3$var$queueMicrotaskDescriptor = $2d44e5fa014dbed3$require$getOwnPropertyDescriptor($25cda8ae230c77ba$exports, "queueMicrotask");
var $2d44e5fa014dbed3$var$queueMicrotask = $2d44e5fa014dbed3$var$queueMicrotaskDescriptor && $2d44e5fa014dbed3$var$queueMicrotaskDescriptor.value;
var $2d44e5fa014dbed3$var$flush, $2d44e5fa014dbed3$var$head, $2d44e5fa014dbed3$var$last, $2d44e5fa014dbed3$var$notify, $2d44e5fa014dbed3$var$toggle, $2d44e5fa014dbed3$var$node, $2d44e5fa014dbed3$var$promise, $2d44e5fa014dbed3$var$then;
// modern engines have queueMicrotask method
if (!$2d44e5fa014dbed3$var$queueMicrotask) {
    $2d44e5fa014dbed3$var$flush = function() {
        var parent, fn;
        if ($36163f3dfb318557$exports && (parent = $2d44e5fa014dbed3$var$process.domain)) parent.exit();
        while($2d44e5fa014dbed3$var$head){
            fn = $2d44e5fa014dbed3$var$head.fn;
            $2d44e5fa014dbed3$var$head = $2d44e5fa014dbed3$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($2d44e5fa014dbed3$var$head) $2d44e5fa014dbed3$var$notify();
                else $2d44e5fa014dbed3$var$last = undefined;
                throw error;
            }
        }
        $2d44e5fa014dbed3$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$cecc07e06c302317$exports && !$36163f3dfb318557$exports && !$6eec07107b3ac01d$exports && $2d44e5fa014dbed3$var$MutationObserver && $2d44e5fa014dbed3$var$document) {
        $2d44e5fa014dbed3$var$toggle = true;
        $2d44e5fa014dbed3$var$node = $2d44e5fa014dbed3$var$document.createTextNode("");
        new $2d44e5fa014dbed3$var$MutationObserver($2d44e5fa014dbed3$var$flush).observe($2d44e5fa014dbed3$var$node, {
            characterData: true
        });
        $2d44e5fa014dbed3$var$notify = function() {
            $2d44e5fa014dbed3$var$node.data = $2d44e5fa014dbed3$var$toggle = !$2d44e5fa014dbed3$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($2d44e5fa014dbed3$var$Promise && $2d44e5fa014dbed3$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $2d44e5fa014dbed3$var$promise = $2d44e5fa014dbed3$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $2d44e5fa014dbed3$var$promise.constructor = $2d44e5fa014dbed3$var$Promise;
        $2d44e5fa014dbed3$var$then = $2d44e5fa014dbed3$var$promise.then;
        $2d44e5fa014dbed3$var$notify = function() {
            $2d44e5fa014dbed3$var$then.call($2d44e5fa014dbed3$var$promise, $2d44e5fa014dbed3$var$flush);
        };
    // Node.js without promises
    } else if ($36163f3dfb318557$exports) $2d44e5fa014dbed3$var$notify = function() {
        $2d44e5fa014dbed3$var$process.nextTick($2d44e5fa014dbed3$var$flush);
    };
    else $2d44e5fa014dbed3$var$notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $2d44e5fa014dbed3$require$macrotask.call($25cda8ae230c77ba$exports, $2d44e5fa014dbed3$var$flush);
    };
}
$2d44e5fa014dbed3$exports = $2d44e5fa014dbed3$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($2d44e5fa014dbed3$var$last) $2d44e5fa014dbed3$var$last.next = task;
    if (!$2d44e5fa014dbed3$var$head) {
        $2d44e5fa014dbed3$var$head = task;
        $2d44e5fa014dbed3$var$notify();
    }
    $2d44e5fa014dbed3$var$last = task;
};


var $b917184952484b41$exports = {};


// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $c773686a123d2c7c$export$2d1720544b23b823;
"use strict";

var $c773686a123d2c7c$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $594e9b0474f6973f$exports(resolve);
    this.reject = $594e9b0474f6973f$exports(reject);
};
$c773686a123d2c7c$export$2d1720544b23b823 = function(C) {
    return new $c773686a123d2c7c$var$PromiseCapability(C);
};


$b917184952484b41$exports = function(C, x) {
    $0fd7d46079e2c0ac$exports(C);
    if ($0b91f8553256226d$exports(x) && x.constructor === C) return x;
    var promiseCapability = $c773686a123d2c7c$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $585d21327bcd9735$exports = {};

$585d21327bcd9735$exports = function(a, b) {
    var console = $25cda8ae230c77ba$exports.console;
    if (console && console.error) arguments.length === 1 ? console.error(a) : console.error(a, b);
};



var $61177c978cbb6c70$exports = {};
$61177c978cbb6c70$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};





var $edde4bf2a40d9811$exports = {};
$edde4bf2a40d9811$exports = typeof window == "object";




var $650a8da11f16668f$var$SPECIES = $aa3bb503d83c56f6$exports("species");
var $650a8da11f16668f$var$PROMISE = "Promise";
var $650a8da11f16668f$var$getInternalState = $a4bed47222a45a53$exports.get;
var $650a8da11f16668f$var$setInternalState = $a4bed47222a45a53$exports.set;
var $650a8da11f16668f$var$getInternalPromiseState = $a4bed47222a45a53$exports.getterFor($650a8da11f16668f$var$PROMISE);
var $650a8da11f16668f$var$NativePromisePrototype = $a4c69ecda2cf7976$exports && $a4c69ecda2cf7976$exports.prototype;
var $650a8da11f16668f$var$PromiseConstructor = $a4c69ecda2cf7976$exports;
var $650a8da11f16668f$var$PromiseConstructorPrototype = $650a8da11f16668f$var$NativePromisePrototype;
var $650a8da11f16668f$var$TypeError = $25cda8ae230c77ba$exports.TypeError;
var $650a8da11f16668f$var$document = $25cda8ae230c77ba$exports.document;
var $650a8da11f16668f$var$process = $25cda8ae230c77ba$exports.process;
var $650a8da11f16668f$var$newPromiseCapability = $c773686a123d2c7c$export$2d1720544b23b823;
var $650a8da11f16668f$var$newGenericPromiseCapability = $650a8da11f16668f$var$newPromiseCapability;
var $650a8da11f16668f$var$DISPATCH_EVENT = !!($650a8da11f16668f$var$document && $650a8da11f16668f$var$document.createEvent && $25cda8ae230c77ba$exports.dispatchEvent);
var $650a8da11f16668f$var$NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == "function";
var $650a8da11f16668f$var$UNHANDLED_REJECTION = "unhandledrejection";
var $650a8da11f16668f$var$REJECTION_HANDLED = "rejectionhandled";
var $650a8da11f16668f$var$PENDING = 0;
var $650a8da11f16668f$var$FULFILLED = 1;
var $650a8da11f16668f$var$REJECTED = 2;
var $650a8da11f16668f$var$HANDLED = 1;
var $650a8da11f16668f$var$UNHANDLED = 2;
var $650a8da11f16668f$var$SUBCLASSING = false;
var $650a8da11f16668f$var$Internal, $650a8da11f16668f$var$OwnPromiseCapability, $650a8da11f16668f$var$PromiseWrapper, $650a8da11f16668f$var$nativeThen;
var $650a8da11f16668f$var$FORCED = $e52890ae3b2dc1d7$exports($650a8da11f16668f$var$PROMISE, function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $b1dbb19f067ce8d0$exports($650a8da11f16668f$var$PromiseConstructor);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($650a8da11f16668f$var$PromiseConstructor);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $64f9b20aff84ed6d$exports === 66) return true;
    // We need Promise#finally in the pure version for preventing prototype pollution
    if ($e4c776601bc56394$exports && !$650a8da11f16668f$var$PromiseConstructorPrototype["finally"]) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($64f9b20aff84ed6d$exports >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $650a8da11f16668f$var$PromiseConstructor(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$650a8da11f16668f$var$SPECIES] = FakePromise;
    $650a8da11f16668f$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$650a8da11f16668f$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $edde4bf2a40d9811$exports && !$650a8da11f16668f$var$NATIVE_REJECTION_EVENT;
});
var $650a8da11f16668f$var$INCORRECT_ITERATION = $650a8da11f16668f$var$FORCED || !$dbcab8dd24d06dfb$exports(function(iterable) {
    $650a8da11f16668f$var$PromiseConstructor.all(iterable)["catch"](function() {});
});
// helpers
var $650a8da11f16668f$var$isThenable = function(it) {
    var then;
    return $0b91f8553256226d$exports(it) && typeof (then = it.then) == "function" ? then : false;
};
var $650a8da11f16668f$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    var chain = state.reactions;
    $2d44e5fa014dbed3$exports(function() {
        var value = state.value;
        var ok = state.state == $650a8da11f16668f$var$FULFILLED;
        var index = 0;
        // variable length - can't use forEach
        while(chain.length > index){
            var reaction = chain[index++];
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (state.rejection === $650a8da11f16668f$var$UNHANDLED) $650a8da11f16668f$var$onHandleUnhandled(state);
                        state.rejection = $650a8da11f16668f$var$HANDLED;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // can throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($650a8da11f16668f$var$TypeError("Promise-chain cycle"));
                    else if (then = $650a8da11f16668f$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (error) {
                if (domain && !exited) domain.exit();
                reject(error);
            }
        }
        state.reactions = [];
        state.notified = false;
        if (isReject && !state.rejection) $650a8da11f16668f$var$onUnhandled(state);
    });
};
var $650a8da11f16668f$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($650a8da11f16668f$var$DISPATCH_EVENT) {
        event = $650a8da11f16668f$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $25cda8ae230c77ba$exports.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$650a8da11f16668f$var$NATIVE_REJECTION_EVENT && (handler = $25cda8ae230c77ba$exports["on" + name])) handler(event);
    else if (name === $650a8da11f16668f$var$UNHANDLED_REJECTION) $585d21327bcd9735$exports("Unhandled promise rejection", reason);
};
var $650a8da11f16668f$var$onUnhandled = function(state) {
    $650a8da11f16668f$require$task.call($25cda8ae230c77ba$exports, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $650a8da11f16668f$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $61177c978cbb6c70$exports(function() {
                if ($36163f3dfb318557$exports) $650a8da11f16668f$var$process.emit("unhandledRejection", value, promise);
                else $650a8da11f16668f$var$dispatchEvent($650a8da11f16668f$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $36163f3dfb318557$exports || $650a8da11f16668f$var$isUnhandled(state) ? $650a8da11f16668f$var$UNHANDLED : $650a8da11f16668f$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $650a8da11f16668f$var$isUnhandled = function(state) {
    return state.rejection !== $650a8da11f16668f$var$HANDLED && !state.parent;
};
var $650a8da11f16668f$var$onHandleUnhandled = function(state) {
    $650a8da11f16668f$require$task.call($25cda8ae230c77ba$exports, function() {
        var promise = state.facade;
        if ($36163f3dfb318557$exports) $650a8da11f16668f$var$process.emit("rejectionHandled", promise);
        else $650a8da11f16668f$var$dispatchEvent($650a8da11f16668f$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $650a8da11f16668f$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $650a8da11f16668f$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $650a8da11f16668f$var$REJECTED;
    $650a8da11f16668f$var$notify(state, true);
};
var $650a8da11f16668f$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $650a8da11f16668f$var$TypeError("Promise can't be resolved itself");
        var then = $650a8da11f16668f$var$isThenable(value);
        if (then) $2d44e5fa014dbed3$exports(function() {
            var wrapper = {
                done: false
            };
            try {
                then.call(value, $650a8da11f16668f$var$bind($650a8da11f16668f$var$internalResolve, wrapper, state), $650a8da11f16668f$var$bind($650a8da11f16668f$var$internalReject, wrapper, state));
            } catch (error) {
                $650a8da11f16668f$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $650a8da11f16668f$var$FULFILLED;
            $650a8da11f16668f$var$notify(state, false);
        }
    } catch (error) {
        $650a8da11f16668f$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($650a8da11f16668f$var$FORCED) {
    // 25.4.3.1 Promise(executor)
    $650a8da11f16668f$var$PromiseConstructor = function Promise(executor) {
        $15583c16d5fd8cbe$exports(this, $650a8da11f16668f$var$PromiseConstructor, $650a8da11f16668f$var$PROMISE);
        $594e9b0474f6973f$exports(executor);
        $650a8da11f16668f$var$Internal.call(this);
        var state = $650a8da11f16668f$var$getInternalState(this);
        try {
            executor($650a8da11f16668f$var$bind($650a8da11f16668f$var$internalResolve, state), $650a8da11f16668f$var$bind($650a8da11f16668f$var$internalReject, state));
        } catch (error) {
            $650a8da11f16668f$var$internalReject(state, error);
        }
    };
    $650a8da11f16668f$var$PromiseConstructorPrototype = $650a8da11f16668f$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $650a8da11f16668f$var$Internal = function Promise(executor) {
        $650a8da11f16668f$var$setInternalState(this, {
            type: $650a8da11f16668f$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: [],
            rejection: false,
            state: $650a8da11f16668f$var$PENDING,
            value: undefined
        });
    };
    $650a8da11f16668f$var$Internal.prototype = $34c6c2c680730057$exports($650a8da11f16668f$var$PromiseConstructorPrototype, {
        // `Promise.prototype.then` method
        // https://tc39.es/ecma262/#sec-promise.prototype.then
        then: function then(onFulfilled, onRejected) {
            var state = $650a8da11f16668f$var$getInternalPromiseState(this);
            var reaction = $650a8da11f16668f$var$newPromiseCapability($9a28f071c836a05f$exports(this, $650a8da11f16668f$var$PromiseConstructor));
            reaction.ok = typeof onFulfilled == "function" ? onFulfilled : true;
            reaction.fail = typeof onRejected == "function" && onRejected;
            reaction.domain = $36163f3dfb318557$exports ? $650a8da11f16668f$var$process.domain : undefined;
            state.parent = true;
            state.reactions.push(reaction);
            if (state.state != $650a8da11f16668f$var$PENDING) $650a8da11f16668f$var$notify(state, false);
            return reaction.promise;
        },
        // `Promise.prototype.catch` method
        // https://tc39.es/ecma262/#sec-promise.prototype.catch
        "catch": function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $650a8da11f16668f$var$OwnPromiseCapability = function() {
        var promise = new $650a8da11f16668f$var$Internal();
        var state = $650a8da11f16668f$var$getInternalState(promise);
        this.promise = promise;
        this.resolve = $650a8da11f16668f$var$bind($650a8da11f16668f$var$internalResolve, state);
        this.reject = $650a8da11f16668f$var$bind($650a8da11f16668f$var$internalReject, state);
    };
    $c773686a123d2c7c$export$2d1720544b23b823 = $650a8da11f16668f$var$newPromiseCapability = function(C) {
        return C === $650a8da11f16668f$var$PromiseConstructor || C === $650a8da11f16668f$var$PromiseWrapper ? new $650a8da11f16668f$var$OwnPromiseCapability(C) : $650a8da11f16668f$var$newGenericPromiseCapability(C);
    };
    if (!$e4c776601bc56394$exports && typeof $a4c69ecda2cf7976$exports == "function" && $650a8da11f16668f$var$NativePromisePrototype !== Object.prototype) {
        $650a8da11f16668f$var$nativeThen = $650a8da11f16668f$var$NativePromisePrototype.then;
        if (!$650a8da11f16668f$var$SUBCLASSING) {
            // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
            $11f7892e297683ed$exports($650a8da11f16668f$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
                var that = this;
                return new $650a8da11f16668f$var$PromiseConstructor(function(resolve, reject) {
                    $650a8da11f16668f$var$nativeThen.call(that, resolve, reject);
                }).then(onFulfilled, onRejected);
            // https://github.com/zloirock/core-js/issues/640
            }, {
                unsafe: true
            });
            // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
            $11f7892e297683ed$exports($650a8da11f16668f$var$NativePromisePrototype, "catch", $650a8da11f16668f$var$PromiseConstructorPrototype["catch"], {
                unsafe: true
            });
        }
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $650a8da11f16668f$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($289b3823d17d13d6$exports) $289b3823d17d13d6$exports($650a8da11f16668f$var$NativePromisePrototype, $650a8da11f16668f$var$PromiseConstructorPrototype);
    }
}
$91c0ad260ce40c60$exports({
    global: true,
    wrap: true,
    forced: $650a8da11f16668f$var$FORCED
}, {
    Promise: $650a8da11f16668f$var$PromiseConstructor
});
$50023f2225ca7d17$exports($650a8da11f16668f$var$PromiseConstructor, $650a8da11f16668f$var$PROMISE, false, true);
$65de1c35bbaee3fa$exports($650a8da11f16668f$var$PROMISE);
$650a8da11f16668f$var$PromiseWrapper = $585215ba854ca762$exports($650a8da11f16668f$var$PROMISE);
// statics
$91c0ad260ce40c60$exports({
    target: $650a8da11f16668f$var$PROMISE,
    stat: true,
    forced: $650a8da11f16668f$var$FORCED
}, {
    // `Promise.reject` method
    // https://tc39.es/ecma262/#sec-promise.reject
    reject: function reject(r) {
        var capability = $650a8da11f16668f$var$newPromiseCapability(this);
        capability.reject.call(undefined, r);
        return capability.promise;
    }
});
$91c0ad260ce40c60$exports({
    target: $650a8da11f16668f$var$PROMISE,
    stat: true,
    forced: $e4c776601bc56394$exports || $650a8da11f16668f$var$FORCED
}, {
    // `Promise.resolve` method
    // https://tc39.es/ecma262/#sec-promise.resolve
    resolve: function resolve(x) {
        return $b917184952484b41$exports($e4c776601bc56394$exports && this === $650a8da11f16668f$var$PromiseWrapper ? $650a8da11f16668f$var$PromiseConstructor : this, x);
    }
});
$91c0ad260ce40c60$exports({
    target: $650a8da11f16668f$var$PROMISE,
    stat: true,
    forced: $650a8da11f16668f$var$INCORRECT_ITERATION
}, {
    // `Promise.all` method
    // https://tc39.es/ecma262/#sec-promise.all
    all: function all(iterable) {
        var C = this;
        var capability = $650a8da11f16668f$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $61177c978cbb6c70$exports(function() {
            var $promiseResolve = $594e9b0474f6973f$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $36f4ae876634e5cb$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                $promiseResolve.call(C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    },
    // `Promise.race` method
    // https://tc39.es/ecma262/#sec-promise.race
    race: function race(iterable) {
        var C = this;
        var capability = $650a8da11f16668f$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $61177c978cbb6c70$exports(function() {
            var $promiseResolve = $594e9b0474f6973f$exports(C.resolve);
            $36f4ae876634e5cb$exports(iterable, function(promise) {
                $promiseResolve.call(C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";





// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$91c0ad260ce40c60$exports({
    target: "Promise",
    stat: true
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $c773686a123d2c7c$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $61177c978cbb6c70$exports(function() {
            var promiseResolve = $594e9b0474f6973f$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $36f4ae876634e5cb$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                promiseResolve.call(C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";






var $54f573c9496f5971$var$PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$91c0ad260ce40c60$exports({
    target: "Promise",
    stat: true
}, {
    any: function any(iterable) {
        var C = this;
        var capability = $c773686a123d2c7c$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $61177c978cbb6c70$exports(function() {
            var promiseResolve = $594e9b0474f6973f$exports(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $36f4ae876634e5cb$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                errors.push(undefined);
                remaining++;
                promiseResolve.call(C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new ($585215ba854ca762$exports("AggregateError"))(errors, $54f573c9496f5971$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new ($585215ba854ca762$exports("AggregateError"))(errors, $54f573c9496f5971$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";








// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $a2ff074ff2bd7c2d$var$NON_GENERIC = !!$a4c69ecda2cf7976$exports && $219b7317e5481db9$exports(function() {
    $a4c69ecda2cf7976$exports.prototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$91c0ad260ce40c60$exports({
    target: "Promise",
    proto: true,
    real: true,
    forced: $a2ff074ff2bd7c2d$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $9a28f071c836a05f$exports(this, $585215ba854ca762$exports("Promise"));
        var isFunction = typeof onFinally == "function";
        return this.then(isFunction ? function(x) {
            return $b917184952484b41$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $b917184952484b41$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$e4c776601bc56394$exports && typeof $a4c69ecda2cf7976$exports == "function") {
    var $a2ff074ff2bd7c2d$var$method = $585215ba854ca762$exports("Promise").prototype["finally"];
    if ($a4c69ecda2cf7976$exports.prototype["finally"] !== $a2ff074ff2bd7c2d$var$method) $11f7892e297683ed$exports($a4c69ecda2cf7976$exports.prototype, "finally", $a2ff074ff2bd7c2d$var$method, {
        unsafe: true
    });
}


"use strict";
var $68cd9a32dc47fe30$exports = {};


// `String.prototype.{ codePointAt, at }` methods implementation
var $68cd9a32dc47fe30$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = String($a3f27e0d56606666$exports($this));
        var position = $2c3be2da3921c029$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = S.charCodeAt(position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$68cd9a32dc47fe30$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $68cd9a32dc47fe30$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $68cd9a32dc47fe30$var$createMethod(true)
};


var $5d058d9d1791ad42$require$charAt = $68cd9a32dc47fe30$exports.charAt;

var $0e7e643391cb3531$exports = {};
"use strict";

var $7da9214c633970dc$exports = {};
"use strict";
var $c8185b51f0150def$exports = {};
"use strict";






var $c8185b51f0150def$var$ITERATOR = $aa3bb503d83c56f6$exports("iterator");
var $c8185b51f0150def$var$BUGGY_SAFARI_ITERATORS = false;
var $c8185b51f0150def$var$returnThis = function() {
    return this;
};
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $c8185b51f0150def$var$IteratorPrototype, $c8185b51f0150def$var$PrototypeOfArrayIteratorPrototype, $c8185b51f0150def$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $c8185b51f0150def$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $c8185b51f0150def$var$arrayIterator)) $c8185b51f0150def$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $c8185b51f0150def$var$PrototypeOfArrayIteratorPrototype = $cebabf84b7624bf0$exports($cebabf84b7624bf0$exports($c8185b51f0150def$var$arrayIterator));
        if ($c8185b51f0150def$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $c8185b51f0150def$var$IteratorPrototype = $c8185b51f0150def$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $c8185b51f0150def$var$NEW_ITERATOR_PROTOTYPE = $c8185b51f0150def$var$IteratorPrototype == undefined || $219b7317e5481db9$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $c8185b51f0150def$var$IteratorPrototype[$c8185b51f0150def$var$ITERATOR].call(test) !== test;
});
if ($c8185b51f0150def$var$NEW_ITERATOR_PROTOTYPE) $c8185b51f0150def$var$IteratorPrototype = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ((!$e4c776601bc56394$exports || $c8185b51f0150def$var$NEW_ITERATOR_PROTOTYPE) && !$3d88f2b414199ee1$exports($c8185b51f0150def$var$IteratorPrototype, $c8185b51f0150def$var$ITERATOR)) $fd02b894e75f7276$exports($c8185b51f0150def$var$IteratorPrototype, $c8185b51f0150def$var$ITERATOR, $c8185b51f0150def$var$returnThis);
$c8185b51f0150def$exports = {
    IteratorPrototype: $c8185b51f0150def$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $c8185b51f0150def$var$BUGGY_SAFARI_ITERATORS
};


var $7da9214c633970dc$require$IteratorPrototype = $c8185b51f0150def$exports.IteratorPrototype;




var $7da9214c633970dc$var$returnThis = function() {
    return this;
};
$7da9214c633970dc$exports = function(IteratorConstructor, NAME, next) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $3a9cf24895febf8a$exports($7da9214c633970dc$require$IteratorPrototype, {
        next: $ae11c51bca431a68$exports(1, next)
    });
    $50023f2225ca7d17$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $938bb9b1b9970d80$exports[TO_STRING_TAG] = $7da9214c633970dc$var$returnThis;
    return IteratorConstructor;
};











var $0e7e643391cb3531$var$IteratorPrototype = $c8185b51f0150def$exports.IteratorPrototype;
var $0e7e643391cb3531$var$BUGGY_SAFARI_ITERATORS = $c8185b51f0150def$exports.BUGGY_SAFARI_ITERATORS;
var $0e7e643391cb3531$var$ITERATOR = $aa3bb503d83c56f6$exports("iterator");
var $0e7e643391cb3531$var$KEYS = "keys";
var $0e7e643391cb3531$var$VALUES = "values";
var $0e7e643391cb3531$var$ENTRIES = "entries";
var $0e7e643391cb3531$var$returnThis = function() {
    return this;
};
$0e7e643391cb3531$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $7da9214c633970dc$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$0e7e643391cb3531$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $0e7e643391cb3531$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $0e7e643391cb3531$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $0e7e643391cb3531$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$0e7e643391cb3531$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$0e7e643391cb3531$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $cebabf84b7624bf0$exports(anyNativeIterator.call(new Iterable()));
        if ($0e7e643391cb3531$var$IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$e4c776601bc56394$exports && $cebabf84b7624bf0$exports(CurrentIteratorPrototype) !== $0e7e643391cb3531$var$IteratorPrototype) {
                if ($289b3823d17d13d6$exports) $289b3823d17d13d6$exports(CurrentIteratorPrototype, $0e7e643391cb3531$var$IteratorPrototype);
                else if (typeof CurrentIteratorPrototype[$0e7e643391cb3531$var$ITERATOR] != "function") $fd02b894e75f7276$exports(CurrentIteratorPrototype, $0e7e643391cb3531$var$ITERATOR, $0e7e643391cb3531$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $50023f2225ca7d17$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($e4c776601bc56394$exports) $938bb9b1b9970d80$exports[TO_STRING_TAG] = $0e7e643391cb3531$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if (DEFAULT == $0e7e643391cb3531$var$VALUES && nativeIterator && nativeIterator.name !== $0e7e643391cb3531$var$VALUES) {
        INCORRECT_VALUES_NAME = true;
        defaultIterator = function values() {
            return nativeIterator.call(this);
        };
    }
    // define iterator
    if ((!$e4c776601bc56394$exports || FORCED) && IterablePrototype[$0e7e643391cb3531$var$ITERATOR] !== defaultIterator) $fd02b894e75f7276$exports(IterablePrototype, $0e7e643391cb3531$var$ITERATOR, defaultIterator);
    $938bb9b1b9970d80$exports[NAME] = defaultIterator;
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($0e7e643391cb3531$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($0e7e643391cb3531$var$KEYS),
            entries: getIterationMethod($0e7e643391cb3531$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($0e7e643391cb3531$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $11f7892e297683ed$exports(IterablePrototype, KEY, methods[KEY]);
        } else $91c0ad260ce40c60$exports({
            target: NAME,
            proto: true,
            forced: $0e7e643391cb3531$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    return methods;
};


var $5d058d9d1791ad42$var$STRING_ITERATOR = "String Iterator";
var $5d058d9d1791ad42$var$setInternalState = $a4bed47222a45a53$exports.set;
var $5d058d9d1791ad42$var$getInternalState = $a4bed47222a45a53$exports.getterFor($5d058d9d1791ad42$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$0e7e643391cb3531$exports(String, "String", function(iterated) {
    $5d058d9d1791ad42$var$setInternalState(this, {
        type: $5d058d9d1791ad42$var$STRING_ITERATOR,
        string: String(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $5d058d9d1791ad42$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return {
        value: undefined,
        done: true
    };
    point = $5d058d9d1791ad42$require$charAt(string, index);
    state.index += point.length;
    return {
        value: point,
        done: false
    };
});



var $c2beb69c36d08d9e$exports = {};
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$c2beb69c36d08d9e$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $b970fa90a1be97c5$exports = {};
"use strict";

var $8d92e6835f23e9a7$exports = {};



var $8d92e6835f23e9a7$var$UNSCOPABLES = $aa3bb503d83c56f6$exports("unscopables");
var $8d92e6835f23e9a7$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($8d92e6835f23e9a7$var$ArrayPrototype[$8d92e6835f23e9a7$var$UNSCOPABLES] == undefined) $ebc0fb67b62346bc$export$2d1720544b23b823($8d92e6835f23e9a7$var$ArrayPrototype, $8d92e6835f23e9a7$var$UNSCOPABLES, {
    configurable: true,
    value: $3a9cf24895febf8a$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$8d92e6835f23e9a7$exports = function(key) {
    $8d92e6835f23e9a7$var$ArrayPrototype[$8d92e6835f23e9a7$var$UNSCOPABLES][key] = true;
};





var $b970fa90a1be97c5$var$ARRAY_ITERATOR = "Array Iterator";
var $b970fa90a1be97c5$var$setInternalState = $a4bed47222a45a53$exports.set;
var $b970fa90a1be97c5$var$getInternalState = $a4bed47222a45a53$exports.getterFor($b970fa90a1be97c5$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$b970fa90a1be97c5$exports = $0e7e643391cb3531$exports(Array, "Array", function(iterated, kind) {
    $b970fa90a1be97c5$var$setInternalState(this, {
        type: $b970fa90a1be97c5$var$ARRAY_ITERATOR,
        target: $be742d7cb838f108$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $b970fa90a1be97c5$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
$938bb9b1b9970d80$exports.Arguments = $938bb9b1b9970d80$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$8d92e6835f23e9a7$exports("keys");
$8d92e6835f23e9a7$exports("values");
$8d92e6835f23e9a7$exports("entries");




var $47420441d149946a$var$ITERATOR = $aa3bb503d83c56f6$exports("iterator");
var $47420441d149946a$var$TO_STRING_TAG = $aa3bb503d83c56f6$exports("toStringTag");
var $47420441d149946a$var$ArrayValues = $b970fa90a1be97c5$exports.values;
for(var $47420441d149946a$var$COLLECTION_NAME in $c2beb69c36d08d9e$exports){
    var $47420441d149946a$var$Collection = $25cda8ae230c77ba$exports[$47420441d149946a$var$COLLECTION_NAME];
    var $47420441d149946a$var$CollectionPrototype = $47420441d149946a$var$Collection && $47420441d149946a$var$Collection.prototype;
    if ($47420441d149946a$var$CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if ($47420441d149946a$var$CollectionPrototype[$47420441d149946a$var$ITERATOR] !== $47420441d149946a$var$ArrayValues) try {
            $fd02b894e75f7276$exports($47420441d149946a$var$CollectionPrototype, $47420441d149946a$var$ITERATOR, $47420441d149946a$var$ArrayValues);
        } catch (error) {
            $47420441d149946a$var$CollectionPrototype[$47420441d149946a$var$ITERATOR] = $47420441d149946a$var$ArrayValues;
        }
        if (!$47420441d149946a$var$CollectionPrototype[$47420441d149946a$var$TO_STRING_TAG]) $fd02b894e75f7276$exports($47420441d149946a$var$CollectionPrototype, $47420441d149946a$var$TO_STRING_TAG, $47420441d149946a$var$COLLECTION_NAME);
        if ($c2beb69c36d08d9e$exports[$47420441d149946a$var$COLLECTION_NAME]) for(var $47420441d149946a$var$METHOD_NAME in $b970fa90a1be97c5$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if ($47420441d149946a$var$CollectionPrototype[$47420441d149946a$var$METHOD_NAME] !== $b970fa90a1be97c5$exports[$47420441d149946a$var$METHOD_NAME]) try {
                $fd02b894e75f7276$exports($47420441d149946a$var$CollectionPrototype, $47420441d149946a$var$METHOD_NAME, $b970fa90a1be97c5$exports[$47420441d149946a$var$METHOD_NAME]);
            } catch (error) {
                $47420441d149946a$var$CollectionPrototype[$47420441d149946a$var$METHOD_NAME] = $b970fa90a1be97c5$exports[$47420441d149946a$var$METHOD_NAME];
            }
        }
    }
}



$e8b2c3d1d93a88fd$exports = $80def7ac7d076d06$exports.Promise;


// TODO: Remove from `core-js@4`



// TODO: Remove from `core-js@4`



"use strict";



// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$91c0ad260ce40c60$exports({
    target: "Promise",
    stat: true
}, {
    "try": function(callbackfn) {
        var promiseCapability = $c773686a123d2c7c$export$2d1720544b23b823(this);
        var result = $61177c978cbb6c70$exports(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});


// TODO: Remove from `core-js@4`



$b767c3230e66af32$exports = $e8b2c3d1d93a88fd$exports;


var $d9c046c375b5ec77$exports = {};
/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */ (function(self) {
    "use strict";
    var nativeURLSearchParams = function() {
        // #41 Fix issue in RN
        try {
            if (self.URLSearchParams && new self.URLSearchParams("foo=bar").get("foo") === "bar") return self.URLSearchParams;
        } catch (e) {}
        return null;
    }(), isSupportObjectConstructor = nativeURLSearchParams && new nativeURLSearchParams({
        a: 1
    }).toString() === "a=1", // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
    decodesPlusesCorrectly = nativeURLSearchParams && new nativeURLSearchParams("s=%2B").get("s") === "+", __URLSearchParams__ = "__URLSearchParams__", // Fix bug in Edge which cannot encode ' &' correctly
    encodesAmpersandsCorrectly = nativeURLSearchParams ? function() {
        var ampersandTest = new nativeURLSearchParams();
        ampersandTest.append("s", " &");
        return ampersandTest.toString() === "s=+%26";
    }() : true, prototype = URLSearchParamsPolyfill.prototype, iterable = !!(self.Symbol && self.Symbol.iterator);
    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) return;
    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */ function URLSearchParamsPolyfill(search) {
        search = search || "";
        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) search = search.toString();
        this[__URLSearchParams__] = parseToDict(search);
    }
    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */ prototype.append = function(name, value) {
        appendTo(this[__URLSearchParams__], name, value);
    };
    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */ prototype["delete"] = function(name) {
        delete this[__URLSearchParams__][name];
    };
    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */ prototype.get = function(name) {
        var dict = this[__URLSearchParams__];
        return this.has(name) ? dict[name][0] : null;
    };
    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */ prototype.getAll = function(name) {
        var dict = this[__URLSearchParams__];
        return this.has(name) ? dict[name].slice(0) : [];
    };
    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */ prototype.has = function(name) {
        return hasOwnProperty(this[__URLSearchParams__], name);
    };
    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */ prototype.set = function set(name, value) {
        this[__URLSearchParams__][name] = [
            "" + value
        ];
    };
    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */ prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for(key in dict){
            name = encode(key);
            for(i = 0, value = dict[key]; i < value.length; i++)query.push(name + "=" + encode(value[i]));
        }
        return query.join("&");
    };
    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = !forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy;
    var propValue;
    if (useProxy) {
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        propValue = new Proxy(nativeURLSearchParams, {
            construct: function(target, args) {
                return new target(new URLSearchParamsPolyfill(args[0]).toString());
            }
        });
        // Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
        propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
    } else propValue = URLSearchParamsPolyfill;
    /*
     * Apply polifill to global object and append other prototype into it
     */ Object.defineProperty(self, "URLSearchParams", {
        value: propValue
    });
    var USPProto = self.URLSearchParams.prototype;
    USPProto.polyfill = true;
    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */ USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };
    /**
     * Sort all name-value pairs
     */ USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for(k in dict)keys.push(k);
        keys.sort();
        for(i = 0; i < keys.length; i++)this["delete"](keys[i]);
        for(i = 0; i < keys.length; i++){
            var key = keys[i], values = dict[key];
            for(j = 0; j < values.length; j++)this.append(key, values[j]);
        }
    };
    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */ USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };
    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */ USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };
    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */ USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([
                name,
                item
            ]);
        });
        return makeIterator(items);
    };
    if (iterable) USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    function encode(str) {
        var replace = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\0"
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }
    function decode(str) {
        return str.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/ig, function(match) {
            return decodeURIComponent(match);
        });
    }
    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {
                    done: value === undefined,
                    value: value
                };
            }
        };
        if (iterable) iterator[self.Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function parseToDict(search) {
        var dict = {};
        if (typeof search === "object") {
            // if `search` is an array, treat it as a sequence
            if (isArray(search)) for(var i = 0; i < search.length; i++){
                var item = search[i];
                if (isArray(item) && item.length === 2) appendTo(dict, item[0], item[1]);
                else throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
            }
            else {
                for(var key in search)if (search.hasOwnProperty(key)) appendTo(dict, key, search[key]);
            }
        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) search = search.slice(1);
            var pairs = search.split("&");
            for(var j = 0; j < pairs.length; j++){
                var value = pairs[j], index = value.indexOf("=");
                if (-1 < index) appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
                else if (value) appendTo(dict, decode(value), "");
            }
        }
        return dict;
    }
    function appendTo(dict, name, value) {
        var val = typeof value === "string" ? value : value !== null && value !== undefined && typeof value.toString === "function" ? value.toString() : JSON.stringify(value);
        // #47 Prevent using `hasOwnProperty` as a property name
        if (hasOwnProperty(dict, name)) dict[name].push(val);
        else dict[name] = [
            val
        ];
    }
    function isArray(val) {
        return !!val && "[object Array]" === Object.prototype.toString.call(val);
    }
    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : $d9c046c375b5ec77$exports);


var $0080f81ae5c35a5a$exports = {};
"use strict";
var $0080f81ae5c35a5a$var$__extends = $0080f81ae5c35a5a$exports && $0080f81ae5c35a5a$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $04e18b39e29a6954$exports = {};
"use strict";
var $04e18b39e29a6954$var$__extends = $04e18b39e29a6954$exports && $04e18b39e29a6954$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2Ioq1 = parcelRequire("2Ioq1");

var $7fWJJ = parcelRequire("7fWJJ");

var $8huxl = parcelRequire("8huxl");
var $602b16f35cd10c75$exports = {};
"use strict";
var $602b16f35cd10c75$var$__extends = $602b16f35cd10c75$exports && $602b16f35cd10c75$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $602b16f35cd10c75$var$ObjectUnsubscribedError = function(_super) {
    $602b16f35cd10c75$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, "object unsubscribed");
        this.name = err.name = "ObjectUnsubscribedError";
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
$602b16f35cd10c75$exports.ObjectUnsubscribedError = $602b16f35cd10c75$var$ObjectUnsubscribedError;


var $2c0994da0d70937e$exports = {};
"use strict";
var $2c0994da0d70937e$var$__extends = $2c0994da0d70937e$exports && $2c0994da0d70937e$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8huxl = parcelRequire("8huxl");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2c0994da0d70937e$var$SubjectSubscription = function(_super) {
    $2c0994da0d70937e$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($8huxl.Subscription);
$2c0994da0d70937e$exports.SubjectSubscription = $2c0994da0d70937e$var$SubjectSubscription;



var $fLDtq = parcelRequire("fLDtq");
/**
 * @class SubjectSubscriber<T>
 */ var $04e18b39e29a6954$var$SubjectSubscriber = function(_super) {
    $04e18b39e29a6954$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($7fWJJ.Subscriber);
$04e18b39e29a6954$exports.SubjectSubscriber = $04e18b39e29a6954$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $04e18b39e29a6954$var$Subject = function(_super) {
    $04e18b39e29a6954$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$fLDtq.rxSubscriber] = function() {
        return new $04e18b39e29a6954$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $04e18b39e29a6954$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $602b16f35cd10c75$exports.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $602b16f35cd10c75$exports.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $602b16f35cd10c75$exports.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $602b16f35cd10c75$exports.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $602b16f35cd10c75$exports.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $8huxl.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $8huxl.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $2c0994da0d70937e$exports.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $2Ioq1.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $04e18b39e29a6954$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($2Ioq1.Observable);
$04e18b39e29a6954$exports.Subject = $04e18b39e29a6954$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $04e18b39e29a6954$var$AnonymousSubject = function(_super) {
    $04e18b39e29a6954$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $8huxl.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($04e18b39e29a6954$var$Subject);
$04e18b39e29a6954$exports.AnonymousSubject = $04e18b39e29a6954$var$AnonymousSubject;



/**
 * @class BehaviorSubject<T>
 */ var $0080f81ae5c35a5a$var$BehaviorSubject = function(_super) {
    $0080f81ae5c35a5a$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $602b16f35cd10c75$exports.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($04e18b39e29a6954$exports.Subject);
$0080f81ae5c35a5a$exports.BehaviorSubject = $0080f81ae5c35a5a$var$BehaviorSubject;



var $2Ioq1 = parcelRequire("2Ioq1");

var $lDxEl = parcelRequire("lDxEl");

var $dbdd077456dd22ff$var$_jwtDecode = $dbdd077456dd22ff$var$_interopRequireWildcard((parcelRequire("dB0fk")));
"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $c1c5b4df785caef5$export$7f43fa37c3d8a0b3;
"use strict";
var $797e5bd70e6caf48$exports = {};
"use strict";
var $797e5bd70e6caf48$var$__extends = $797e5bd70e6caf48$exports && $797e5bd70e6caf48$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $a91b5c1163bee54d$exports = {};
"use strict";
var $a91b5c1163bee54d$var$__extends = $a91b5c1163bee54d$exports && $a91b5c1163bee54d$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7fWJJ = parcelRequire("7fWJJ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a91b5c1163bee54d$var$OuterSubscriber = function(_super) {
    $a91b5c1163bee54d$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($7fWJJ.Subscriber);
$a91b5c1163bee54d$exports.OuterSubscriber = $a91b5c1163bee54d$var$OuterSubscriber;


var $5418a1bab4b6cd43$export$d0604af3321cfb1b;
"use strict";

var $aBIZ8 = parcelRequire("aBIZ8");
var $48f3b8251b68f5a2$export$1e2f57719e155213;
"use strict";
$48f3b8251b68f5a2$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number";
};


var $d24d2f75493135bf$export$4369c812aac99591;
"use strict";
function $d24d2f75493135bf$var$isPromise(value) {
    return value && typeof value.subscribe !== "function" && typeof value.then === "function";
}
$d24d2f75493135bf$export$4369c812aac99591 = $d24d2f75493135bf$var$isPromise;



var $hKVxI = parcelRequire("hKVxI");

var $2Ioq1 = parcelRequire("2Ioq1");
var $b85413127e87fe01$export$77b88d321d1c84c6;
var $b85413127e87fe01$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $b85413127e87fe01$export$9785f547d3164dac;
"use strict";

var $aBIZ8 = parcelRequire("aBIZ8");
function $b85413127e87fe01$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (!Symbol.iterator) Symbol.iterator = Symbol("iterator polyfill");
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()["@@iterator"] === "function") return "@@iterator";
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== "entries" && key !== "size" && Map_1.prototype[key] === Map_1.prototype["entries"]) return key;
            }
        }
        return "@@iterator";
    }
}
$b85413127e87fe01$export$77b88d321d1c84c6 = $b85413127e87fe01$var$symbolIteratorPonyfill;
$b85413127e87fe01$export$6f58e2338da23f4d = $b85413127e87fe01$var$symbolIteratorPonyfill($aBIZ8.root);
$b85413127e87fe01$export$9785f547d3164dac = $b85413127e87fe01$export$6f58e2338da23f4d;


var $a4fb3d6abc3d6511$exports = {};
"use strict";
var $a4fb3d6abc3d6511$var$__extends = $a4fb3d6abc3d6511$exports && $a4fb3d6abc3d6511$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7fWJJ = parcelRequire("7fWJJ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a4fb3d6abc3d6511$var$InnerSubscriber = function(_super) {
    $a4fb3d6abc3d6511$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($7fWJJ.Subscriber);
$a4fb3d6abc3d6511$exports.InnerSubscriber = $a4fb3d6abc3d6511$var$InnerSubscriber;



var $kUXEd = parcelRequire("kUXEd");
function $5418a1bab4b6cd43$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $a4fb3d6abc3d6511$exports.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $2Ioq1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($48f3b8251b68f5a2$export$1e2f57719e155213(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($d24d2f75493135bf$export$4369c812aac99591(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $aBIZ8.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$b85413127e87fe01$export$6f58e2338da23f4d] === "function") {
        var iterator = result[$b85413127e87fe01$export$6f58e2338da23f4d]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$kUXEd.observable] === "function") {
        var obs = result[$kUXEd.observable]();
        if (typeof obs.subscribe !== "function") destination.error(new TypeError("Provided object does not correctly implement Symbol.observable"));
        else return obs.subscribe(new $a4fb3d6abc3d6511$exports.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $hKVxI.isObject(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        destination.error(new TypeError(msg));
    }
    return null;
}
$5418a1bab4b6cd43$export$d0604af3321cfb1b = $5418a1bab4b6cd43$var$subscribeToResult;


/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $797e5bd70e6caf48$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $797e5bd70e6caf48$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
$797e5bd70e6caf48$exports.catchError = $797e5bd70e6caf48$var$catchError;
var $797e5bd70e6caf48$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $797e5bd70e6caf48$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $797e5bd70e6caf48$var$CatchSubscriber = function(_super) {
    $797e5bd70e6caf48$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($5418a1bab4b6cd43$export$d0604af3321cfb1b(this, result));
        }
    };
    return CatchSubscriber;
}($a91b5c1163bee54d$exports.OuterSubscriber);


/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */ function $c1c5b4df785caef5$var$_catch(selector) {
    return $797e5bd70e6caf48$exports.catchError(selector)(this);
}
$c1c5b4df785caef5$export$7f43fa37c3d8a0b3 = $c1c5b4df785caef5$var$_catch;


$2Ioq1.Observable.prototype.catch = $c1c5b4df785caef5$export$7f43fa37c3d8a0b3;
$2Ioq1.Observable.prototype._catch = $c1c5b4df785caef5$export$7f43fa37c3d8a0b3;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $c2c4497e2dce13d0$export$77fa7d86f5204e8a;
"use strict";
var $1fccbac5d43eb2d3$exports = {};
"use strict";
var $1fccbac5d43eb2d3$var$__extends = $1fccbac5d43eb2d3$exports && $1fccbac5d43eb2d3$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $7c3690cf9d2f6c54$exports = {};
"use strict";
var $7c3690cf9d2f6c54$var$__extends = $7c3690cf9d2f6c54$exports && $7c3690cf9d2f6c54$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2Ioq1 = parcelRequire("2Ioq1");
var $0fc1aa8bce882c79$exports = {};
"use strict";
var $0fc1aa8bce882c79$var$__extends = $0fc1aa8bce882c79$exports && $0fc1aa8bce882c79$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2Ioq1 = parcelRequire("2Ioq1");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $0fc1aa8bce882c79$var$ScalarObservable = function(_super) {
    $0fc1aa8bce882c79$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($2Ioq1.Observable);
$0fc1aa8bce882c79$exports.ScalarObservable = $0fc1aa8bce882c79$var$ScalarObservable;


var $cf1bed4e1bc3a020$exports = {};
"use strict";
var $cf1bed4e1bc3a020$var$__extends = $cf1bed4e1bc3a020$exports && $cf1bed4e1bc3a020$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2Ioq1 = parcelRequire("2Ioq1");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $cf1bed4e1bc3a020$var$EmptyObservable = function(_super) {
    $cf1bed4e1bc3a020$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($2Ioq1.Observable);
$cf1bed4e1bc3a020$exports.EmptyObservable = $cf1bed4e1bc3a020$var$EmptyObservable;


var $326b2ab3e9e3f1ee$export$187e35932e88c15c;
"use strict";
function $326b2ab3e9e3f1ee$var$isScheduler(value) {
    return value && typeof value.schedule === "function";
}
$326b2ab3e9e3f1ee$export$187e35932e88c15c = $326b2ab3e9e3f1ee$var$isScheduler;


/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $7c3690cf9d2f6c54$var$ArrayObservable = function(_super) {
    $7c3690cf9d2f6c54$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($326b2ab3e9e3f1ee$export$187e35932e88c15c(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $0fc1aa8bce882c79$exports.ScalarObservable(array[0], scheduler);
        else return new $cf1bed4e1bc3a020$exports.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($2Ioq1.Observable);
$7c3690cf9d2f6c54$exports.ArrayObservable = $7c3690cf9d2f6c54$var$ArrayObservable;



var $6QitX = parcelRequire("6QitX");


var $1fccbac5d43eb2d3$var$none = {};
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $1fccbac5d43eb2d3$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === "function") project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $6QitX.isArray(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call(new $7c3690cf9d2f6c54$exports.ArrayObservable([
            source
        ].concat(observables)), new $1fccbac5d43eb2d3$var$CombineLatestOperator(project));
    };
}
$1fccbac5d43eb2d3$exports.combineLatest = $1fccbac5d43eb2d3$var$combineLatest;
var $1fccbac5d43eb2d3$var$CombineLatestOperator = function() {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1fccbac5d43eb2d3$var$CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}();
$1fccbac5d43eb2d3$exports.CombineLatestOperator = $1fccbac5d43eb2d3$var$CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1fccbac5d43eb2d3$var$CombineLatestSubscriber = function(_super) {
    $1fccbac5d43eb2d3$var$__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($1fccbac5d43eb2d3$var$none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add($5418a1bab4b6cd43$export$d0604af3321cfb1b(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $1fccbac5d43eb2d3$var$none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) this._tryProject(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function(values) {
        var result;
        try {
            result = this.project.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}($a91b5c1163bee54d$exports.OuterSubscriber);
$1fccbac5d43eb2d3$exports.CombineLatestSubscriber = $1fccbac5d43eb2d3$var$CombineLatestSubscriber;


/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $c2c4497e2dce13d0$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $1fccbac5d43eb2d3$exports.combineLatest.apply(void 0, observables)(this);
}
$c2c4497e2dce13d0$export$77fa7d86f5204e8a = $c2c4497e2dce13d0$var$combineLatest;


$2Ioq1.Observable.prototype.combineLatest = $c2c4497e2dce13d0$export$77fa7d86f5204e8a;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $cfd32bb55589a4f1$export$85b9a36db797e02b;
"use strict";

var $arYek = parcelRequire("arYek");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function $cfd32bb55589a4f1$var$count(predicate) {
    return $arYek.count(predicate)(this);
}
$cfd32bb55589a4f1$export$85b9a36db797e02b = $cfd32bb55589a4f1$var$count;


$2Ioq1.Observable.prototype.count = $cfd32bb55589a4f1$export$85b9a36db797e02b;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $9acd137bcafe9138$export$1391212d75b2ee65;
"use strict";

var $lDxEl = parcelRequire("lDxEl");

var $8CEnu = parcelRequire("8CEnu");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function $9acd137bcafe9138$var$delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $lDxEl.async;
    return $8CEnu.delay(delay, scheduler)(this);
}
$9acd137bcafe9138$export$1391212d75b2ee65 = $9acd137bcafe9138$var$delay;


$2Ioq1.Observable.prototype.delay = $9acd137bcafe9138$export$1391212d75b2ee65;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $991047b9fcac8d92$export$6e1c2ce23f3c9991;
"use strict";
var $b241cc1d2f9eb1e9$exports = {};
"use strict";
var $b241cc1d2f9eb1e9$var$__extends = $b241cc1d2f9eb1e9$exports && $b241cc1d2f9eb1e9$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7fWJJ = parcelRequire("7fWJJ");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $b241cc1d2f9eb1e9$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $b241cc1d2f9eb1e9$var$DoOperator(nextOrObserver, error, complete));
    };
}
$b241cc1d2f9eb1e9$exports.tap = $b241cc1d2f9eb1e9$var$tap;
var $b241cc1d2f9eb1e9$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b241cc1d2f9eb1e9$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b241cc1d2f9eb1e9$var$DoSubscriber = function(_super) {
    $b241cc1d2f9eb1e9$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $7fWJJ.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($7fWJJ.Subscriber);


/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */ function $991047b9fcac8d92$var$_do(nextOrObserver, error, complete) {
    return $b241cc1d2f9eb1e9$exports.tap(nextOrObserver, error, complete)(this);
}
$991047b9fcac8d92$export$6e1c2ce23f3c9991 = $991047b9fcac8d92$var$_do;


$2Ioq1.Observable.prototype.do = $991047b9fcac8d92$export$6e1c2ce23f3c9991;
$2Ioq1.Observable.prototype._do = $991047b9fcac8d92$export$6e1c2ce23f3c9991;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $c29d6826a3bded3b$export$3dea766d36a8935f;
"use strict";
var $cdecf19ed793b44d$exports = {};
"use strict";
var $cdecf19ed793b44d$var$__extends = $cdecf19ed793b44d$exports && $cdecf19ed793b44d$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7fWJJ = parcelRequire("7fWJJ");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $cdecf19ed793b44d$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $cdecf19ed793b44d$var$FilterOperator(predicate, thisArg));
    };
}
$cdecf19ed793b44d$exports.filter = $cdecf19ed793b44d$var$filter;
var $cdecf19ed793b44d$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $cdecf19ed793b44d$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $cdecf19ed793b44d$var$FilterSubscriber = function(_super) {
    $cdecf19ed793b44d$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($7fWJJ.Subscriber);


/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $c29d6826a3bded3b$var$filter(predicate, thisArg) {
    return $cdecf19ed793b44d$exports.filter(predicate, thisArg)(this);
}
$c29d6826a3bded3b$export$3dea766d36a8935f = $c29d6826a3bded3b$var$filter;


$2Ioq1.Observable.prototype.filter = $c29d6826a3bded3b$export$3dea766d36a8935f;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $c683e8caffc33276$export$871de8747c9eaa88;
"use strict";
var $24112ef0ed0b41c8$exports = {};
"use strict";
var $24112ef0ed0b41c8$var$__extends = $24112ef0ed0b41c8$exports && $24112ef0ed0b41c8$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7fWJJ = parcelRequire("7fWJJ");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $24112ef0ed0b41c8$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new $24112ef0ed0b41c8$var$MapOperator(project, thisArg));
    };
}
$24112ef0ed0b41c8$exports.map = $24112ef0ed0b41c8$var$map;
var $24112ef0ed0b41c8$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $24112ef0ed0b41c8$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
$24112ef0ed0b41c8$exports.MapOperator = $24112ef0ed0b41c8$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $24112ef0ed0b41c8$var$MapSubscriber = function(_super) {
    $24112ef0ed0b41c8$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($7fWJJ.Subscriber);


/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $c683e8caffc33276$var$map(project, thisArg) {
    return $24112ef0ed0b41c8$exports.map(project, thisArg)(this);
}
$c683e8caffc33276$export$871de8747c9eaa88 = $c683e8caffc33276$var$map;


$2Ioq1.Observable.prototype.map = $c683e8caffc33276$export$871de8747c9eaa88;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $5fc98d781db39252$export$6b9f6c0d32c093f9;
"use strict";
var $323ba94bd3c98fae$exports = {};
"use strict";
var $323ba94bd3c98fae$var$__extends = $323ba94bd3c98fae$exports && $323ba94bd3c98fae$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $323ba94bd3c98fae$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === "number") {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $323ba94bd3c98fae$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
$323ba94bd3c98fae$exports.mergeMap = $323ba94bd3c98fae$var$mergeMap;
var $323ba94bd3c98fae$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $323ba94bd3c98fae$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
$323ba94bd3c98fae$exports.MergeMapOperator = $323ba94bd3c98fae$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $323ba94bd3c98fae$var$MergeMapSubscriber = function(_super) {
    $323ba94bd3c98fae$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($5418a1bab4b6cd43$export$d0604af3321cfb1b(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($a91b5c1163bee54d$exports.OuterSubscriber);
$323ba94bd3c98fae$exports.MergeMapSubscriber = $323ba94bd3c98fae$var$MergeMapSubscriber;


/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $5fc98d781db39252$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $323ba94bd3c98fae$exports.mergeMap(project, resultSelector, concurrent)(this);
}
$5fc98d781db39252$export$6b9f6c0d32c093f9 = $5fc98d781db39252$var$mergeMap;


$2Ioq1.Observable.prototype.mergeMap = $5fc98d781db39252$export$6b9f6c0d32c093f9;
$2Ioq1.Observable.prototype.flatMap = $5fc98d781db39252$export$6b9f6c0d32c093f9;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $47835a002d0b7445$export$c28c8388be0ab31a;
"use strict";
var $2252b5b91f57b79a$export$c28c8388be0ab31a;
"use strict";

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $2252b5b91f57b79a$var$concatMap(project, resultSelector) {
    return $323ba94bd3c98fae$exports.mergeMap(project, resultSelector, 1);
}
$2252b5b91f57b79a$export$c28c8388be0ab31a = $2252b5b91f57b79a$var$concatMap;


/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $47835a002d0b7445$var$concatMap(project, resultSelector) {
    return $2252b5b91f57b79a$export$c28c8388be0ab31a(project, resultSelector)(this);
}
$47835a002d0b7445$export$c28c8388be0ab31a = $47835a002d0b7445$var$concatMap;


$2Ioq1.Observable.prototype.concatMap = $47835a002d0b7445$export$c28c8388be0ab31a;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $924020ff67a92130$export$1281551253cfee02;
"use strict";
var $e86a9411894db6b6$exports = {};
"use strict";
var $e86a9411894db6b6$var$__extends = $e86a9411894db6b6$exports && $e86a9411894db6b6$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


var $gCTjO = parcelRequire("gCTjO");

var $ieSGQ = parcelRequire("ieSGQ");


/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $e86a9411894db6b6$var$retryWhen(notifier) {
    return function(source) {
        return source.lift(new $e86a9411894db6b6$var$RetryWhenOperator(notifier, source));
    };
}
$e86a9411894db6b6$exports.retryWhen = $e86a9411894db6b6$var$retryWhen;
var $e86a9411894db6b6$var$RetryWhenOperator = function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e86a9411894db6b6$var$RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e86a9411894db6b6$var$RetryWhenSubscriber = function(_super) {
    $e86a9411894db6b6$var$__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new $04e18b39e29a6954$exports.Subject();
                retries = $gCTjO.tryCatch(this.notifier)(errors);
                if (retries === $ieSGQ.errorObject) return _super.prototype.error.call(this, $ieSGQ.errorObject.e);
                retriesSubscription = $5418a1bab4b6cd43$export$d0604af3321cfb1b(this, retries);
            } else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}($a91b5c1163bee54d$exports.OuterSubscriber);


/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $924020ff67a92130$var$retryWhen(notifier) {
    return $e86a9411894db6b6$exports.retryWhen(notifier)(this);
}
$924020ff67a92130$export$1281551253cfee02 = $924020ff67a92130$var$retryWhen;


$2Ioq1.Observable.prototype.retryWhen = $924020ff67a92130$export$1281551253cfee02;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $5afd9bcd52a5c740$export$ed80d9de1d9df928;
"use strict";
var $597fd0895a05c101$export$ed80d9de1d9df928;
"use strict";
var $f29c42048bc65acb$export$1364843af8d5a963;
var $f29c42048bc65acb$export$150d52413393bf2c;
"use strict";
var $c6fd105692200dad$exports = {};
"use strict";
var $c6fd105692200dad$var$__extends = $c6fd105692200dad$exports && $c6fd105692200dad$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


var $2Ioq1 = parcelRequire("2Ioq1");

var $7fWJJ = parcelRequire("7fWJJ");

var $8huxl = parcelRequire("8huxl");
var $6f9c9705fc6a2fe4$exports = {};
"use strict";
var $6f9c9705fc6a2fe4$var$__extends = $6f9c9705fc6a2fe4$exports && $6f9c9705fc6a2fe4$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7fWJJ = parcelRequire("7fWJJ");
function $6f9c9705fc6a2fe4$var$refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new $6f9c9705fc6a2fe4$var$RefCountOperator(source));
    };
}
$6f9c9705fc6a2fe4$exports.refCount = $6f9c9705fc6a2fe4$var$refCount;
var $6f9c9705fc6a2fe4$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $6f9c9705fc6a2fe4$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $6f9c9705fc6a2fe4$var$RefCountSubscriber = function(_super) {
    $6f9c9705fc6a2fe4$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($7fWJJ.Subscriber);


/**
 * @class ConnectableObservable<T>
 */ var $c6fd105692200dad$var$ConnectableObservable = function(_super) {
    $c6fd105692200dad$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new $8huxl.Subscription();
            connection.add(this.source.subscribe(new $c6fd105692200dad$var$ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = $8huxl.Subscription.EMPTY;
            } else this._connection = connection;
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $6f9c9705fc6a2fe4$exports.refCount()(this);
    };
    return ConnectableObservable;
}($2Ioq1.Observable);
$c6fd105692200dad$exports.ConnectableObservable = $c6fd105692200dad$var$ConnectableObservable;
var $c6fd105692200dad$var$connectableProto = $c6fd105692200dad$var$ConnectableObservable.prototype;
$c6fd105692200dad$exports.connectableObservableDescriptor = {
    operator: {
        value: null
    },
    _refCount: {
        value: 0,
        writable: true
    },
    _subject: {
        value: null,
        writable: true
    },
    _connection: {
        value: null,
        writable: true
    },
    _subscribe: {
        value: $c6fd105692200dad$var$connectableProto._subscribe
    },
    _isComplete: {
        value: $c6fd105692200dad$var$connectableProto._isComplete,
        writable: true
    },
    getSubject: {
        value: $c6fd105692200dad$var$connectableProto.getSubject
    },
    connect: {
        value: $c6fd105692200dad$var$connectableProto.connect
    },
    refCount: {
        value: $c6fd105692200dad$var$connectableProto.refCount
    }
};
var $c6fd105692200dad$var$ConnectableSubscriber = function(_super) {
    $c6fd105692200dad$var$__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}($04e18b39e29a6954$exports.SubjectSubscriber);
var $c6fd105692200dad$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $c6fd105692200dad$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $c6fd105692200dad$var$RefCountSubscriber = function(_super) {
    $c6fd105692200dad$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($7fWJJ.Subscriber);


/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */ function $f29c42048bc65acb$var$multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === "function") subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === "function") return source.lift(new $f29c42048bc65acb$var$MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, $c6fd105692200dad$exports.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
$f29c42048bc65acb$export$1364843af8d5a963 = $f29c42048bc65acb$var$multicast;
var $f29c42048bc65acb$var$MulticastOperator = function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();
$f29c42048bc65acb$export$150d52413393bf2c = $f29c42048bc65acb$var$MulticastOperator;




function $597fd0895a05c101$var$shareSubjectFactory() {
    return new $04e18b39e29a6954$exports.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $597fd0895a05c101$var$share() {
    return function(source) {
        return $6f9c9705fc6a2fe4$exports.refCount()($f29c42048bc65acb$export$1364843af8d5a963($597fd0895a05c101$var$shareSubjectFactory)(source));
    };
}
$597fd0895a05c101$export$ed80d9de1d9df928 = $597fd0895a05c101$var$share;


/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $5afd9bcd52a5c740$var$share() {
    return $597fd0895a05c101$export$ed80d9de1d9df928()(this);
}
$5afd9bcd52a5c740$export$ed80d9de1d9df928 = $5afd9bcd52a5c740$var$share;


$2Ioq1.Observable.prototype.share = $5afd9bcd52a5c740$export$ed80d9de1d9df928;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $384602ae1ec37bec$export$b7df5d561049483a;
"use strict";
var $b80956e5b6da9c2a$exports = {};
"use strict";
var $b80956e5b6da9c2a$var$__extends = $b80956e5b6da9c2a$exports && $b80956e5b6da9c2a$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7fWJJ = parcelRequire("7fWJJ");
var $a585f9ce80156162$exports = {};
"use strict";
var $a585f9ce80156162$var$__extends = $a585f9ce80156162$exports && $a585f9ce80156162$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $a585f9ce80156162$var$ArgumentOutOfRangeError = function(_super) {
    $a585f9ce80156162$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, "argument out of range");
        this.name = err.name = "ArgumentOutOfRangeError";
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
$a585f9ce80156162$exports.ArgumentOutOfRangeError = $a585f9ce80156162$var$ArgumentOutOfRangeError;



/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $b80956e5b6da9c2a$var$take(count) {
    return function(source) {
        if (count === 0) return new $cf1bed4e1bc3a020$exports.EmptyObservable();
        else return source.lift(new $b80956e5b6da9c2a$var$TakeOperator(count));
    };
}
$b80956e5b6da9c2a$exports.take = $b80956e5b6da9c2a$var$take;
var $b80956e5b6da9c2a$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $a585f9ce80156162$exports.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b80956e5b6da9c2a$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b80956e5b6da9c2a$var$TakeSubscriber = function(_super) {
    $b80956e5b6da9c2a$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($7fWJJ.Subscriber);


/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $384602ae1ec37bec$var$take(count) {
    return $b80956e5b6da9c2a$exports.take(count)(this);
}
$384602ae1ec37bec$export$b7df5d561049483a = $384602ae1ec37bec$var$take;


$2Ioq1.Observable.prototype.take = $384602ae1ec37bec$export$b7df5d561049483a;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $fbebd89dd360531a$export$e68fce4c5f453854;
"use strict";
var $767214ade649b18b$exports = {};
"use strict";
var $767214ade649b18b$var$__extends = $767214ade649b18b$exports && $767214ade649b18b$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aBIZ8 = parcelRequire("aBIZ8");

var $gCTjO = parcelRequire("gCTjO");

var $ieSGQ = parcelRequire("ieSGQ");

var $2Ioq1 = parcelRequire("2Ioq1");

var $7fWJJ = parcelRequire("7fWJJ");

function $767214ade649b18b$var$getCORSRequest() {
    if ($aBIZ8.root.XMLHttpRequest) return new $aBIZ8.root.XMLHttpRequest();
    else if (!!$aBIZ8.root.XDomainRequest) return new $aBIZ8.root.XDomainRequest();
    else throw new Error("CORS is not supported by your browser");
}
function $767214ade649b18b$var$getXMLHttpRequest() {
    if ($aBIZ8.root.XMLHttpRequest) return new $aBIZ8.root.XMLHttpRequest();
    else {
        var progId = void 0;
        try {
            var progIds = [
                "Msxml2.XMLHTTP",
                "Microsoft.XMLHTTP",
                "Msxml2.XMLHTTP.4.0"
            ];
            for(var i = 0; i < 3; i++)try {
                progId = progIds[i];
                new $aBIZ8.root.ActiveXObject(progId);
                break;
            } catch (e) {}
            return new $aBIZ8.root.ActiveXObject(progId);
        } catch (e) {
            throw new Error("XMLHttpRequest is not supported by your browser");
        }
    }
}
function $767214ade649b18b$var$ajaxGet(url, headers) {
    if (headers === void 0) headers = null;
    return new $767214ade649b18b$var$AjaxObservable({
        method: "GET",
        url: url,
        headers: headers
    });
}
$767214ade649b18b$exports.ajaxGet = $767214ade649b18b$var$ajaxGet;
function $767214ade649b18b$var$ajaxPost(url, body, headers) {
    return new $767214ade649b18b$var$AjaxObservable({
        method: "POST",
        url: url,
        body: body,
        headers: headers
    });
}
$767214ade649b18b$exports.ajaxPost = $767214ade649b18b$var$ajaxPost;
function $767214ade649b18b$var$ajaxDelete(url, headers) {
    return new $767214ade649b18b$var$AjaxObservable({
        method: "DELETE",
        url: url,
        headers: headers
    });
}
$767214ade649b18b$exports.ajaxDelete = $767214ade649b18b$var$ajaxDelete;
function $767214ade649b18b$var$ajaxPut(url, body, headers) {
    return new $767214ade649b18b$var$AjaxObservable({
        method: "PUT",
        url: url,
        body: body,
        headers: headers
    });
}
$767214ade649b18b$exports.ajaxPut = $767214ade649b18b$var$ajaxPut;
function $767214ade649b18b$var$ajaxPatch(url, body, headers) {
    return new $767214ade649b18b$var$AjaxObservable({
        method: "PATCH",
        url: url,
        body: body,
        headers: headers
    });
}
$767214ade649b18b$exports.ajaxPatch = $767214ade649b18b$var$ajaxPatch;
var $767214ade649b18b$var$mapResponse = $24112ef0ed0b41c8$exports.map(function(x, index) {
    return x.response;
});
function $767214ade649b18b$var$ajaxGetJSON(url, headers) {
    return $767214ade649b18b$var$mapResponse(new $767214ade649b18b$var$AjaxObservable({
        method: "GET",
        url: url,
        responseType: "json",
        headers: headers
    }));
}
$767214ade649b18b$exports.ajaxGetJSON = $767214ade649b18b$var$ajaxGetJSON;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $767214ade649b18b$var$AjaxObservable = function(_super) {
    $767214ade649b18b$var$__extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function() {
                return this.crossDomain ? $767214ade649b18b$var$getCORSRequest.call(this) : $767214ade649b18b$var$getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: "GET",
            responseType: "json",
            timeout: 0
        };
        if (typeof urlOrRequest === "string") request.url = urlOrRequest;
        else {
            for(var prop in urlOrRequest)if (urlOrRequest.hasOwnProperty(prop)) request[prop] = urlOrRequest[prop];
        }
        this.request = request;
    }
    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function(subscriber) {
        return new $767214ade649b18b$var$AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */ AjaxObservable.create = function() {
        var create = function(urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = $767214ade649b18b$var$ajaxGet;
        create.post = $767214ade649b18b$var$ajaxPost;
        create.delete = $767214ade649b18b$var$ajaxDelete;
        create.put = $767214ade649b18b$var$ajaxPut;
        create.patch = $767214ade649b18b$var$ajaxPatch;
        create.getJSON = $767214ade649b18b$var$ajaxGetJSON;
        return create;
    }();
    return AjaxObservable;
}($2Ioq1.Observable);
$767214ade649b18b$exports.AjaxObservable = $767214ade649b18b$var$AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $767214ade649b18b$var$AjaxSubscriber = function(_super) {
    $767214ade649b18b$var$__extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
        // ensure content type is set
        if (!("Content-Type" in headers) && !($aBIZ8.root.FormData && request.body instanceof $aBIZ8.root.FormData) && typeof request.body !== "undefined") headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers["Content-Type"]);
        this.send();
    }
    AjaxSubscriber.prototype.next = function(e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new $767214ade649b18b$var$AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function() {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = $gCTjO.tryCatch(createXHR).call(request);
        if (xhr === $ieSGQ.errorObject) this.error($ieSGQ.errorObject.e);
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) result = $gCTjO.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            else result = $gCTjO.tryCatch(xhr.open).call(xhr, method, url, async);
            if (result === $ieSGQ.errorObject) {
                this.error($ieSGQ.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ("withCredentials" in xhr) xhr.withCredentials = !!request.withCredentials;
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? $gCTjO.tryCatch(xhr.send).call(xhr, body) : $gCTjO.tryCatch(xhr.send).call(xhr);
            if (result === $ieSGQ.errorObject) {
                this.error($ieSGQ.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function(body, contentType) {
        if (!body || typeof body === "string") return body;
        else if ($aBIZ8.root.FormData && body instanceof $aBIZ8.root.FormData) return body;
        if (contentType) {
            var splitIndex = contentType.indexOf(";");
            if (splitIndex !== -1) contentType = contentType.substring(0, splitIndex);
        }
        switch(contentType){
            case "application/x-www-form-urlencoded":
                return Object.keys(body).map(function(key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
                }).join("&");
            case "application/json":
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function(xhr, headers) {
        for(var key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    };
    AjaxSubscriber.prototype.setupEvents = function(xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) progressSubscriber.error(e);
            subscriber.error(new $767214ade649b18b$var$AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && "withCredentials" in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function(e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if ($aBIZ8.root.XDomainRequest) xhr.onprogress = xhrProgress_1;
                else xhr.upload.onprogress = xhrProgress_1;
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function(e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) progressSubscriber.error(e);
                subscriber.error(new $767214ade649b18b$var$AjaxError("ajax error", this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = this.responseType === "text" ? this.response || this.responseText : this.response;
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) status_1 = response ? 200 : 0;
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) progressSubscriber.complete();
                    subscriber.next(e);
                    subscriber.complete();
                } else {
                    if (progressSubscriber) progressSubscriber.error(e);
                    subscriber.error(new $767214ade649b18b$var$AjaxError("ajax error " + status_1, this, request));
                }
            }
        }
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function() {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === "function") xhr.abort();
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}($7fWJJ.Subscriber);
$767214ade649b18b$exports.AjaxSubscriber = $767214ade649b18b$var$AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */ var $767214ade649b18b$var$AjaxResponse = function() {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $767214ade649b18b$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}();
$767214ade649b18b$exports.AjaxResponse = $767214ade649b18b$var$AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */ var $767214ade649b18b$var$AjaxError = function(_super) {
    $767214ade649b18b$var$__extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $767214ade649b18b$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxError;
}(Error);
$767214ade649b18b$exports.AjaxError = $767214ade649b18b$var$AjaxError;
function $767214ade649b18b$var$parseXhrResponse(responseType, xhr) {
    switch(responseType){
        case "json":
            if ("response" in xhr) //IE does not support json as responseType, parse it internally
            return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || "null");
            else // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return JSON.parse(xhr.responseText || "null");
        case "xml":
            return xhr.responseXML;
        case "text":
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return "response" in xhr ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */ var $767214ade649b18b$var$AjaxTimeoutError = function(_super) {
    $767214ade649b18b$var$__extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, "ajax timeout", xhr, request);
    }
    return AjaxTimeoutError;
}($767214ade649b18b$var$AjaxError);
$767214ade649b18b$exports.AjaxTimeoutError = $767214ade649b18b$var$AjaxTimeoutError;


$fbebd89dd360531a$export$e68fce4c5f453854 = $767214ade649b18b$exports.AjaxObservable.create;


$2Ioq1.Observable.ajax = $fbebd89dd360531a$export$e68fce4c5f453854;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $b9df8a0334f1c0ff$export$6e22c362a0406a2c;
"use strict";

$b9df8a0334f1c0ff$export$6e22c362a0406a2c = $cf1bed4e1bc3a020$exports.EmptyObservable.create;


$2Ioq1.Observable.empty = $b9df8a0334f1c0ff$export$6e22c362a0406a2c;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $607ac28e67f00f30$export$6788812c4e6611e6;
"use strict";
var $11f89d0e308b7f5b$exports = {};
"use strict";
var $11f89d0e308b7f5b$var$__extends = $11f89d0e308b7f5b$exports && $11f89d0e308b7f5b$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6QitX = parcelRequire("6QitX");


var $60daf17f439656b4$exports = {};
"use strict";
var $60daf17f439656b4$var$__extends = $60daf17f439656b4$exports && $60daf17f439656b4$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aBIZ8 = parcelRequire("aBIZ8");

var $2Ioq1 = parcelRequire("2Ioq1");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $60daf17f439656b4$var$PromiseObservable = function(_super) {
    $60daf17f439656b4$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $aBIZ8.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($60daf17f439656b4$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($60daf17f439656b4$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($60daf17f439656b4$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $aBIZ8.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($2Ioq1.Observable);
$60daf17f439656b4$exports.PromiseObservable = $60daf17f439656b4$var$PromiseObservable;
function $60daf17f439656b4$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $60daf17f439656b4$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}


var $2f33293a2dbbf1da$exports = {};
"use strict";
var $2f33293a2dbbf1da$var$__extends = $2f33293a2dbbf1da$exports && $2f33293a2dbbf1da$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aBIZ8 = parcelRequire("aBIZ8");

var $2Ioq1 = parcelRequire("2Ioq1");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $2f33293a2dbbf1da$var$IteratorObservable = function(_super) {
    $2f33293a2dbbf1da$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error("iterator cannot be null.");
        this.iterator = $2f33293a2dbbf1da$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === "function") iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === "function") iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($2Ioq1.Observable);
$2f33293a2dbbf1da$exports.IteratorObservable = $2f33293a2dbbf1da$var$IteratorObservable;
var $2f33293a2dbbf1da$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$b85413127e87fe01$export$6f58e2338da23f4d] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $2f33293a2dbbf1da$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $2f33293a2dbbf1da$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$b85413127e87fe01$export$6f58e2338da23f4d] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $2f33293a2dbbf1da$var$getIterator(obj) {
    var i = obj[$b85413127e87fe01$export$6f58e2338da23f4d];
    if (!i && typeof obj === "string") return new $2f33293a2dbbf1da$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $2f33293a2dbbf1da$var$ArrayIterator(obj);
    if (!i) throw new TypeError("object is not iterable");
    return obj[$b85413127e87fe01$export$6f58e2338da23f4d]();
}
var $2f33293a2dbbf1da$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $2f33293a2dbbf1da$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$2f33293a2dbbf1da$var$numberIsFinite(len)) return len;
    len = $2f33293a2dbbf1da$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $2f33293a2dbbf1da$var$maxSafeInteger) return $2f33293a2dbbf1da$var$maxSafeInteger;
    return len;
}
function $2f33293a2dbbf1da$var$numberIsFinite(value) {
    return typeof value === "number" && $aBIZ8.root.isFinite(value);
}
function $2f33293a2dbbf1da$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}



var $004c8b84c2ab15f1$exports = {};
"use strict";
var $004c8b84c2ab15f1$var$__extends = $004c8b84c2ab15f1$exports && $004c8b84c2ab15f1$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2Ioq1 = parcelRequire("2Ioq1");


/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $004c8b84c2ab15f1$var$ArrayLikeObservable = function(_super) {
    $004c8b84c2ab15f1$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $cf1bed4e1bc3a020$exports.EmptyObservable();
        else if (length === 1) return new $0fc1aa8bce882c79$exports.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($2Ioq1.Observable);
$004c8b84c2ab15f1$exports.ArrayLikeObservable = $004c8b84c2ab15f1$var$ArrayLikeObservable;




var $2Ioq1 = parcelRequire("2Ioq1");
var $7f5aabe590404010$exports = {};
"use strict";
var $7f5aabe590404010$var$__extends = $7f5aabe590404010$exports && $7f5aabe590404010$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7fWJJ = parcelRequire("7fWJJ");

var $7dD0d = parcelRequire("7dD0d");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $7f5aabe590404010$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $7f5aabe590404010$var$ObserveOnOperator(scheduler, delay));
    };
}
$7f5aabe590404010$exports.observeOn = $7f5aabe590404010$var$observeOn;
var $7f5aabe590404010$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7f5aabe590404010$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
$7f5aabe590404010$exports.ObserveOnOperator = $7f5aabe590404010$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7f5aabe590404010$var$ObserveOnSubscriber = function(_super) {
    $7f5aabe590404010$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $7f5aabe590404010$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($7dD0d.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($7dD0d.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($7dD0d.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($7fWJJ.Subscriber);
$7f5aabe590404010$exports.ObserveOnSubscriber = $7f5aabe590404010$var$ObserveOnSubscriber;
var $7f5aabe590404010$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
$7f5aabe590404010$exports.ObserveOnMessage = $7f5aabe590404010$var$ObserveOnMessage;



var $kUXEd = parcelRequire("kUXEd");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $11f89d0e308b7f5b$var$FromObservable = function(_super) {
    $11f89d0e308b7f5b$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$kUXEd.observable] === "function") {
                if (ish instanceof $2Ioq1.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($6QitX.isArray(ish)) return new $7c3690cf9d2f6c54$exports.ArrayObservable(ish, scheduler);
            else if ($d24d2f75493135bf$export$4369c812aac99591(ish)) return new $60daf17f439656b4$exports.PromiseObservable(ish, scheduler);
            else if (typeof ish[$b85413127e87fe01$export$6f58e2338da23f4d] === "function" || typeof ish === "string") return new $2f33293a2dbbf1da$exports.IteratorObservable(ish, scheduler);
            else if ($48f3b8251b68f5a2$export$1e2f57719e155213(ish)) return new $004c8b84c2ab15f1$exports.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + " is not observable");
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$kUXEd.observable]().subscribe(subscriber);
        else return ish[$kUXEd.observable]().subscribe(new $7f5aabe590404010$exports.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($2Ioq1.Observable);
$11f89d0e308b7f5b$exports.FromObservable = $11f89d0e308b7f5b$var$FromObservable;


$607ac28e67f00f30$export$6788812c4e6611e6 = $11f89d0e308b7f5b$exports.FromObservable.create;


$2Ioq1.Observable.from = $607ac28e67f00f30$export$6788812c4e6611e6;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $61ae7a7ca9dcf2c2$export$3174cdbf0a0cbc84;
"use strict";
var $fb7f97913410ced9$exports = {};
"use strict";
var $fb7f97913410ced9$var$__extends = $fb7f97913410ced9$exports && $fb7f97913410ced9$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $f8540721fd0752be$export$e90fb89750dba83f;
"use strict";

var $6QitX = parcelRequire("6QitX");
function $f8540721fd0752be$var$isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !$6QitX.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
$f8540721fd0752be$export$e90fb89750dba83f = $f8540721fd0752be$var$isNumeric;



var $2Ioq1 = parcelRequire("2Ioq1");

var $lDxEl = parcelRequire("lDxEl");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $fb7f97913410ced9$var$IntervalObservable = function(_super) {
    $fb7f97913410ced9$var$__extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $lDxEl.async;
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!$f8540721fd0752be$export$e90fb89750dba83f(period) || period < 0) this.period = 0;
        if (!scheduler || typeof scheduler.schedule !== "function") this.scheduler = $lDxEl.async;
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */ IntervalObservable.create = function(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $lDxEl.async;
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function(state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) return;
        state.index += 1;
        this.schedule(state, period);
    };
    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index,
            subscriber: subscriber,
            period: period
        }));
    };
    return IntervalObservable;
}($2Ioq1.Observable);
$fb7f97913410ced9$exports.IntervalObservable = $fb7f97913410ced9$var$IntervalObservable;


$61ae7a7ca9dcf2c2$export$3174cdbf0a0cbc84 = $fb7f97913410ced9$exports.IntervalObservable.create;


$2Ioq1.Observable.interval = $61ae7a7ca9dcf2c2$export$3174cdbf0a0cbc84;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $b9e08f4b4db409ea$export$ba255e9e49e00608;
"use strict";

$b9e08f4b4db409ea$export$ba255e9e49e00608 = $7c3690cf9d2f6c54$exports.ArrayObservable.of;


$2Ioq1.Observable.of = $b9e08f4b4db409ea$export$ba255e9e49e00608;


"use strict";

var $2Ioq1 = parcelRequire("2Ioq1");
var $f5b546c2682445cd$export$82a8af9b11518516;
"use strict";
var $e7f824bb69441868$exports = {};
"use strict";
var $e7f824bb69441868$var$__extends = $e7f824bb69441868$exports && $e7f824bb69441868$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2Ioq1 = parcelRequire("2Ioq1");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $e7f824bb69441868$var$ErrorObservable = function(_super) {
    $e7f824bb69441868$var$__extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */ ErrorObservable.create = function(error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function(arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function(subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) return scheduler.schedule(ErrorObservable.dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
        else subscriber.error(error);
    };
    return ErrorObservable;
}($2Ioq1.Observable);
$e7f824bb69441868$exports.ErrorObservable = $e7f824bb69441868$var$ErrorObservable;


$f5b546c2682445cd$export$82a8af9b11518516 = $e7f824bb69441868$exports.ErrorObservable.create;


$2Ioq1.Observable.throw = $f5b546c2682445cd$export$82a8af9b11518516;



var $dbdd077456dd22ff$var$_dedupeFilenames = $1PoM0((parcelRequire("aEvSz")));
var $b0e81407e9f785f6$exports = {};
"use strict";

var $1PoM0 = parcelRequire("1PoM0");

var $kKXRo = parcelRequire("kKXRo");
Object.defineProperty($b0e81407e9f785f6$exports, "__esModule", {
    value: true
});
$b0e81407e9f785f6$exports.DirectLineStreaming = void 0;

var $b0e81407e9f785f6$var$_objectWithoutProperties2 = $1PoM0((parcelRequire("NHqNP")));

var $b0e81407e9f785f6$var$_regenerator = $1PoM0((parcelRequire("kbZRJ")));

var $b0e81407e9f785f6$var$_classPrivateFieldGet2 = $1PoM0((parcelRequire("l2Sqt")));

var $b0e81407e9f785f6$var$_classPrivateFieldSet2 = $1PoM0((parcelRequire("c0mXe")));

var $b0e81407e9f785f6$var$_toConsumableArray2 = $1PoM0((parcelRequire("l1sDn")));

var $b0e81407e9f785f6$var$_asyncToGenerator2 = $1PoM0((parcelRequire("bH9fD")));

var $b0e81407e9f785f6$var$_classCallCheck2 = $1PoM0((parcelRequire("2Ao05")));

var $b0e81407e9f785f6$var$_createClass2 = $1PoM0((parcelRequire("awXxO")));

var $b0e81407e9f785f6$var$_defineProperty2 = $1PoM0((parcelRequire("k9YyE")));

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8a2aa373b87bfbc4$export$a143d493d941bafc;
var $8a2aa373b87bfbc4$export$e4cf37d7f6fb9e0a;
var $8a2aa373b87bfbc4$export$f99ded8fe4b79145;
var $8a2aa373b87bfbc4$export$599f31c3813fae4d;
"use strict";

var $btSY6 = parcelRequire("btSY6");

var $idpWM = parcelRequire("idpWM");
const $8a2aa373b87bfbc4$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8a2aa373b87bfbc4$export$a143d493d941bafc = $8a2aa373b87bfbc4$var$Buffer;
$8a2aa373b87bfbc4$export$e4cf37d7f6fb9e0a = $8a2aa373b87bfbc4$var$SlowBuffer;
$8a2aa373b87bfbc4$export$f99ded8fe4b79145 = 50;
const $8a2aa373b87bfbc4$var$K_MAX_LENGTH = 0x7fffffff;
$8a2aa373b87bfbc4$export$599f31c3813fae4d = $8a2aa373b87bfbc4$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8a2aa373b87bfbc4$var$Buffer.TYPED_ARRAY_SUPPORT = $8a2aa373b87bfbc4$var$typedArraySupport();
if (!$8a2aa373b87bfbc4$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8a2aa373b87bfbc4$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8a2aa373b87bfbc4$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$8a2aa373b87bfbc4$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8a2aa373b87bfbc4$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$8a2aa373b87bfbc4$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8a2aa373b87bfbc4$var$createBuffer(length) {
    if (length > $8a2aa373b87bfbc4$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8a2aa373b87bfbc4$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8a2aa373b87bfbc4$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8a2aa373b87bfbc4$var$allocUnsafe(arg);
    }
    return $8a2aa373b87bfbc4$var$from(arg, encodingOrOffset, length);
}
$8a2aa373b87bfbc4$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8a2aa373b87bfbc4$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8a2aa373b87bfbc4$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8a2aa373b87bfbc4$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8a2aa373b87bfbc4$var$isInstance(value, ArrayBuffer) || value && $8a2aa373b87bfbc4$var$isInstance(value.buffer, ArrayBuffer)) return $8a2aa373b87bfbc4$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8a2aa373b87bfbc4$var$isInstance(value, SharedArrayBuffer) || value && $8a2aa373b87bfbc4$var$isInstance(value.buffer, SharedArrayBuffer))) return $8a2aa373b87bfbc4$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8a2aa373b87bfbc4$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8a2aa373b87bfbc4$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8a2aa373b87bfbc4$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8a2aa373b87bfbc4$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8a2aa373b87bfbc4$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8a2aa373b87bfbc4$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8a2aa373b87bfbc4$var$Buffer, Uint8Array);
function $8a2aa373b87bfbc4$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8a2aa373b87bfbc4$var$alloc(size, fill, encoding) {
    $8a2aa373b87bfbc4$var$assertSize(size);
    if (size <= 0) return $8a2aa373b87bfbc4$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8a2aa373b87bfbc4$var$createBuffer(size).fill(fill, encoding) : $8a2aa373b87bfbc4$var$createBuffer(size).fill(fill);
    return $8a2aa373b87bfbc4$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8a2aa373b87bfbc4$var$Buffer.alloc = function(size, fill, encoding) {
    return $8a2aa373b87bfbc4$var$alloc(size, fill, encoding);
};
function $8a2aa373b87bfbc4$var$allocUnsafe(size) {
    $8a2aa373b87bfbc4$var$assertSize(size);
    return $8a2aa373b87bfbc4$var$createBuffer(size < 0 ? 0 : $8a2aa373b87bfbc4$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8a2aa373b87bfbc4$var$Buffer.allocUnsafe = function(size) {
    return $8a2aa373b87bfbc4$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8a2aa373b87bfbc4$var$Buffer.allocUnsafeSlow = function(size) {
    return $8a2aa373b87bfbc4$var$allocUnsafe(size);
};
function $8a2aa373b87bfbc4$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8a2aa373b87bfbc4$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $8a2aa373b87bfbc4$var$byteLength(string, encoding) | 0;
    let buf = $8a2aa373b87bfbc4$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8a2aa373b87bfbc4$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8a2aa373b87bfbc4$var$checked(array.length) | 0;
    const buf = $8a2aa373b87bfbc4$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8a2aa373b87bfbc4$var$fromArrayView(arrayView) {
    if ($8a2aa373b87bfbc4$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8a2aa373b87bfbc4$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8a2aa373b87bfbc4$var$fromArrayLike(arrayView);
}
function $8a2aa373b87bfbc4$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8a2aa373b87bfbc4$var$Buffer.prototype);
    return buf;
}
function $8a2aa373b87bfbc4$var$fromObject(obj) {
    if ($8a2aa373b87bfbc4$var$Buffer.isBuffer(obj)) {
        const len = $8a2aa373b87bfbc4$var$checked(obj.length) | 0;
        const buf = $8a2aa373b87bfbc4$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8a2aa373b87bfbc4$var$numberIsNaN(obj.length)) return $8a2aa373b87bfbc4$var$createBuffer(0);
        return $8a2aa373b87bfbc4$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8a2aa373b87bfbc4$var$fromArrayLike(obj.data);
}
function $8a2aa373b87bfbc4$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8a2aa373b87bfbc4$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8a2aa373b87bfbc4$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8a2aa373b87bfbc4$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8a2aa373b87bfbc4$var$Buffer.alloc(+length);
}
$8a2aa373b87bfbc4$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8a2aa373b87bfbc4$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8a2aa373b87bfbc4$var$Buffer.compare = function compare(a, b) {
    if ($8a2aa373b87bfbc4$var$isInstance(a, Uint8Array)) a = $8a2aa373b87bfbc4$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8a2aa373b87bfbc4$var$isInstance(b, Uint8Array)) b = $8a2aa373b87bfbc4$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8a2aa373b87bfbc4$var$Buffer.isBuffer(a) || !$8a2aa373b87bfbc4$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8a2aa373b87bfbc4$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8a2aa373b87bfbc4$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8a2aa373b87bfbc4$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8a2aa373b87bfbc4$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8a2aa373b87bfbc4$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8a2aa373b87bfbc4$var$Buffer.isBuffer(buf)) buf = $8a2aa373b87bfbc4$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8a2aa373b87bfbc4$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8a2aa373b87bfbc4$var$byteLength(string, encoding) {
    if ($8a2aa373b87bfbc4$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8a2aa373b87bfbc4$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8a2aa373b87bfbc4$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8a2aa373b87bfbc4$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8a2aa373b87bfbc4$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8a2aa373b87bfbc4$var$Buffer.byteLength = $8a2aa373b87bfbc4$var$byteLength;
function $8a2aa373b87bfbc4$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8a2aa373b87bfbc4$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8a2aa373b87bfbc4$var$utf8Slice(this, start, end);
        case "ascii":
            return $8a2aa373b87bfbc4$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8a2aa373b87bfbc4$var$latin1Slice(this, start, end);
        case "base64":
            return $8a2aa373b87bfbc4$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8a2aa373b87bfbc4$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8a2aa373b87bfbc4$var$Buffer.prototype._isBuffer = true;
function $8a2aa373b87bfbc4$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8a2aa373b87bfbc4$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$8a2aa373b87bfbc4$var$swap(this, i, i + 1);
    return this;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $8a2aa373b87bfbc4$var$swap(this, i, i + 3);
        $8a2aa373b87bfbc4$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $8a2aa373b87bfbc4$var$swap(this, i, i + 7);
        $8a2aa373b87bfbc4$var$swap(this, i + 1, i + 6);
        $8a2aa373b87bfbc4$var$swap(this, i + 2, i + 5);
        $8a2aa373b87bfbc4$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8a2aa373b87bfbc4$var$utf8Slice(this, 0, length);
    return $8a2aa373b87bfbc4$var$slowToString.apply(this, arguments);
};
$8a2aa373b87bfbc4$var$Buffer.prototype.toLocaleString = $8a2aa373b87bfbc4$var$Buffer.prototype.toString;
$8a2aa373b87bfbc4$var$Buffer.prototype.equals = function equals(b) {
    if (!$8a2aa373b87bfbc4$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8a2aa373b87bfbc4$var$Buffer.compare(this, b) === 0;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $8a2aa373b87bfbc4$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8a2aa373b87bfbc4$var$customInspectSymbol) $8a2aa373b87bfbc4$var$Buffer.prototype[$8a2aa373b87bfbc4$var$customInspectSymbol] = $8a2aa373b87bfbc4$var$Buffer.prototype.inspect;
$8a2aa373b87bfbc4$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8a2aa373b87bfbc4$var$isInstance(target, Uint8Array)) target = $8a2aa373b87bfbc4$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8a2aa373b87bfbc4$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8a2aa373b87bfbc4$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8a2aa373b87bfbc4$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8a2aa373b87bfbc4$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8a2aa373b87bfbc4$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8a2aa373b87bfbc4$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8a2aa373b87bfbc4$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8a2aa373b87bfbc4$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8a2aa373b87bfbc4$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8a2aa373b87bfbc4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8a2aa373b87bfbc4$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8a2aa373b87bfbc4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8a2aa373b87bfbc4$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8a2aa373b87bfbc4$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8a2aa373b87bfbc4$var$utf8Write(buf, string, offset, length) {
    return $8a2aa373b87bfbc4$var$blitBuffer($8a2aa373b87bfbc4$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8a2aa373b87bfbc4$var$asciiWrite(buf, string, offset, length) {
    return $8a2aa373b87bfbc4$var$blitBuffer($8a2aa373b87bfbc4$var$asciiToBytes(string), buf, offset, length);
}
function $8a2aa373b87bfbc4$var$base64Write(buf, string, offset, length) {
    return $8a2aa373b87bfbc4$var$blitBuffer($8a2aa373b87bfbc4$var$base64ToBytes(string), buf, offset, length);
}
function $8a2aa373b87bfbc4$var$ucs2Write(buf, string, offset, length) {
    return $8a2aa373b87bfbc4$var$blitBuffer($8a2aa373b87bfbc4$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8a2aa373b87bfbc4$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8a2aa373b87bfbc4$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8a2aa373b87bfbc4$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8a2aa373b87bfbc4$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8a2aa373b87bfbc4$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8a2aa373b87bfbc4$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8a2aa373b87bfbc4$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8a2aa373b87bfbc4$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $btSY6.fromByteArray(buf);
    else return $btSY6.fromByteArray(buf.slice(start, end));
}
function $8a2aa373b87bfbc4$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8a2aa373b87bfbc4$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8a2aa373b87bfbc4$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8a2aa373b87bfbc4$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8a2aa373b87bfbc4$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8a2aa373b87bfbc4$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8a2aa373b87bfbc4$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8a2aa373b87bfbc4$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8a2aa373b87bfbc4$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $8a2aa373b87bfbc4$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8a2aa373b87bfbc4$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8a2aa373b87bfbc4$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8a2aa373b87bfbc4$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8a2aa373b87bfbc4$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8a2aa373b87bfbc4$var$Buffer.prototype.readUintLE = $8a2aa373b87bfbc4$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readUintBE = $8a2aa373b87bfbc4$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readUint8 = $8a2aa373b87bfbc4$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readUint16LE = $8a2aa373b87bfbc4$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readUint16BE = $8a2aa373b87bfbc4$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readUint32LE = $8a2aa373b87bfbc4$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readUint32BE = $8a2aa373b87bfbc4$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readBigUInt64LE = $8a2aa373b87bfbc4$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8a2aa373b87bfbc4$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8a2aa373b87bfbc4$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8a2aa373b87bfbc4$var$Buffer.prototype.readBigUInt64BE = $8a2aa373b87bfbc4$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8a2aa373b87bfbc4$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8a2aa373b87bfbc4$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8a2aa373b87bfbc4$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readBigInt64LE = $8a2aa373b87bfbc4$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8a2aa373b87bfbc4$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8a2aa373b87bfbc4$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8a2aa373b87bfbc4$var$Buffer.prototype.readBigInt64BE = $8a2aa373b87bfbc4$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8a2aa373b87bfbc4$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8a2aa373b87bfbc4$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8a2aa373b87bfbc4$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 4, this.length);
    return $idpWM.read(this, offset, true, 23, 4);
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 4, this.length);
    return $idpWM.read(this, offset, false, 23, 4);
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 8, this.length);
    return $idpWM.read(this, offset, true, 52, 8);
};
$8a2aa373b87bfbc4$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkOffset(offset, 8, this.length);
    return $idpWM.read(this, offset, false, 52, 8);
};
function $8a2aa373b87bfbc4$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8a2aa373b87bfbc4$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8a2aa373b87bfbc4$var$Buffer.prototype.writeUintLE = $8a2aa373b87bfbc4$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8a2aa373b87bfbc4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeUintBE = $8a2aa373b87bfbc4$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8a2aa373b87bfbc4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeUint8 = $8a2aa373b87bfbc4$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeUint16LE = $8a2aa373b87bfbc4$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeUint16BE = $8a2aa373b87bfbc4$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeUint32LE = $8a2aa373b87bfbc4$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeUint32BE = $8a2aa373b87bfbc4$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8a2aa373b87bfbc4$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8a2aa373b87bfbc4$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8a2aa373b87bfbc4$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8a2aa373b87bfbc4$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8a2aa373b87bfbc4$var$Buffer.prototype.writeBigUInt64LE = $8a2aa373b87bfbc4$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8a2aa373b87bfbc4$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8a2aa373b87bfbc4$var$Buffer.prototype.writeBigUInt64BE = $8a2aa373b87bfbc4$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8a2aa373b87bfbc4$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8a2aa373b87bfbc4$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8a2aa373b87bfbc4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8a2aa373b87bfbc4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeBigInt64LE = $8a2aa373b87bfbc4$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8a2aa373b87bfbc4$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$8a2aa373b87bfbc4$var$Buffer.prototype.writeBigInt64BE = $8a2aa373b87bfbc4$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8a2aa373b87bfbc4$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $8a2aa373b87bfbc4$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8a2aa373b87bfbc4$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $idpWM.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8a2aa373b87bfbc4$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8a2aa373b87bfbc4$var$writeFloat(this, value, offset, true, noAssert);
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8a2aa373b87bfbc4$var$writeFloat(this, value, offset, false, noAssert);
};
function $8a2aa373b87bfbc4$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8a2aa373b87bfbc4$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $idpWM.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8a2aa373b87bfbc4$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8a2aa373b87bfbc4$var$writeDouble(this, value, offset, true, noAssert);
};
$8a2aa373b87bfbc4$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8a2aa373b87bfbc4$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8a2aa373b87bfbc4$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8a2aa373b87bfbc4$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8a2aa373b87bfbc4$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8a2aa373b87bfbc4$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8a2aa373b87bfbc4$var$Buffer.isBuffer(val) ? val : $8a2aa373b87bfbc4$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8a2aa373b87bfbc4$var$errors = {};
function $8a2aa373b87bfbc4$var$E(sym, getMessage, Base) {
    $8a2aa373b87bfbc4$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8a2aa373b87bfbc4$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$8a2aa373b87bfbc4$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8a2aa373b87bfbc4$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8a2aa373b87bfbc4$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8a2aa373b87bfbc4$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8a2aa373b87bfbc4$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8a2aa373b87bfbc4$var$checkBounds(buf, offset, byteLength) {
    $8a2aa373b87bfbc4$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8a2aa373b87bfbc4$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8a2aa373b87bfbc4$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8a2aa373b87bfbc4$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $8a2aa373b87bfbc4$var$checkBounds(buf, offset, byteLength);
}
function $8a2aa373b87bfbc4$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $8a2aa373b87bfbc4$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $8a2aa373b87bfbc4$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8a2aa373b87bfbc4$var$validateNumber(value, type);
        throw new $8a2aa373b87bfbc4$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $8a2aa373b87bfbc4$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8a2aa373b87bfbc4$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8a2aa373b87bfbc4$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8a2aa373b87bfbc4$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8a2aa373b87bfbc4$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8a2aa373b87bfbc4$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8a2aa373b87bfbc4$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8a2aa373b87bfbc4$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8a2aa373b87bfbc4$var$base64ToBytes(str) {
    return $btSY6.toByteArray($8a2aa373b87bfbc4$var$base64clean(str));
}
function $8a2aa373b87bfbc4$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8a2aa373b87bfbc4$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8a2aa373b87bfbc4$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8a2aa373b87bfbc4$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8a2aa373b87bfbc4$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $8a2aa373b87bfbc4$var$BufferBigIntNotDefined : fn;
}
function $8a2aa373b87bfbc4$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}



var $2Ioq1 = parcelRequire("2Ioq1");

var $b0e81407e9f785f6$var$BFSE = $b0e81407e9f785f6$var$_interopRequireWildcard((parcelRequire("lIM9r")));

var $b0e81407e9f785f6$var$_createDeferred = $1PoM0((parcelRequire("1TUrp")));

var $b0e81407e9f785f6$var$_crossFetch = $1PoM0((parcelRequire("cN33n")));


var $b0e81407e9f785f6$var$_WebSocketClientWithNetworkInformation = $1PoM0((parcelRequire("5RUcQ")));
var $b0e81407e9f785f6$var$_excluded = [
    "attachments"
];
function $b0e81407e9f785f6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b0e81407e9f785f6$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b0e81407e9f785f6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $kKXRo(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $b0e81407e9f785f6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $b0e81407e9f785f6$var$DIRECT_LINE_VERSION = "DirectLine/3.0";
var $b0e81407e9f785f6$var$MAX_RETRY_COUNT = 3;
var $b0e81407e9f785f6$var$refreshTokenLifetime = 1800000; //const refreshTokenLifetime = 5000;
// const timeout = 20 * 1000;
var $b0e81407e9f785f6$var$refreshTokenInterval = $b0e81407e9f785f6$var$refreshTokenLifetime / 2;
var $b0e81407e9f785f6$var$StreamHandler = /*#__PURE__*/ function() {
    function StreamHandler(s, c$, sq) {
        (0, $b0e81407e9f785f6$var$_classCallCheck2["default"])(this, StreamHandler);
        (0, $b0e81407e9f785f6$var$_defineProperty2["default"])(this, "activityQueue", []);
        this.subscriber = s;
        this.connectionStatus$ = c$;
        this.shouldQueue = sq;
    }
    (0, $b0e81407e9f785f6$var$_createClass2["default"])(StreamHandler, [
        {
            key: "setSubscriber",
            value: function setSubscriber(s) {
                this.subscriber = s;
            }
        },
        {
            key: "processRequest",
            value: function() {
                var _processRequest = (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee(request, logger) {
                    var streams, stream0, activitySetJson, activitySet, activity, attachments, stream, attachment, dataUri;
                    return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                streams = (0, $b0e81407e9f785f6$var$_toConsumableArray2["default"])(request.streams);
                                stream0 = streams.shift();
                                _context.next = 4;
                                return stream0.readAsString();
                            case 4:
                                activitySetJson = _context.sent;
                                activitySet = JSON.parse(activitySetJson);
                                if (!(activitySet.activities.length !== 1)) {
                                    _context.next = 9;
                                    break;
                                }
                                // Only one activity is expected in a set in streaming
                                this.subscriber.error(new Error("there should be exactly one activity"));
                                return _context.abrupt("return", $b0e81407e9f785f6$var$BFSE.StreamingResponse.create(500));
                            case 9:
                                activity = activitySet.activities[0];
                                if (!(streams.length > 0)) {
                                    _context.next = 21;
                                    break;
                                }
                                attachments = (0, $b0e81407e9f785f6$var$_toConsumableArray2["default"])(activity.attachments);
                            case 12:
                                if (!(stream = streams.shift())) {
                                    _context.next = 20;
                                    break;
                                }
                                _context.next = 15;
                                return stream.readAsString();
                            case 15:
                                attachment = _context.sent;
                                dataUri = "data:text/plain;base64," + attachment;
                                attachments.push({
                                    contentType: stream.contentType,
                                    contentUrl: dataUri
                                });
                                _context.next = 12;
                                break;
                            case 20:
                                activity.attachments = attachments;
                            case 21:
                                if (this.shouldQueue()) this.activityQueue.push(activity);
                                else this.subscriber.next(activity);
                                return _context.abrupt("return", $b0e81407e9f785f6$var$BFSE.StreamingResponse.create(200));
                            case 23:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function processRequest(_x, _x2) {
                    return _processRequest.apply(this, arguments);
                }
                return processRequest;
            }()
        },
        {
            key: "flush",
            value: function flush() {
                var _this = this;
                this.connectionStatus$.subscribe(function() {});
                this.activityQueue.forEach(function(a) {
                    return _this.subscriber.next(a);
                });
                this.activityQueue = [];
            }
        },
        {
            key: "end",
            value: function end() {
                this.subscriber.complete();
            }
        }
    ]);
    return StreamHandler;
}();
var $b0e81407e9f785f6$var$_networkInformation = /*#__PURE__*/ new WeakMap();
var $b0e81407e9f785f6$var$DirectLineStreaming = /*#__PURE__*/ function() {
    function DirectLineStreaming(options) {
        var _this2 = this;
        (0, $b0e81407e9f785f6$var$_classCallCheck2["default"])(this, DirectLineStreaming);
        (0, $b0e81407e9f785f6$var$_defineProperty2["default"])(this, "connectionStatus$", new $0080f81ae5c35a5a$exports.BehaviorSubject($dbdd077456dd22ff$exports.ConnectionStatus.Uninitialized));
        (0, $b0e81407e9f785f6$var$_defineProperty2["default"])(this, "_botAgent", "");
        $b0e81407e9f785f6$var$_networkInformation.set(this, {
            writable: true,
            value: void 0
        });
        // Rectifies `options.networkInformation`.
        var networkInformation = options === null || options === void 0 ? void 0 : options.networkInformation;
        if (typeof networkInformation === "undefined" || typeof networkInformation.addEventListener === "function" && typeof networkInformation.removeEventListener === "function" && typeof networkInformation.type === "string") (0, $b0e81407e9f785f6$var$_classPrivateFieldSet2["default"])(this, $b0e81407e9f785f6$var$_networkInformation, networkInformation);
        else console.warn('botframework-directlinejs: "networkInformation" option specified must be a `NetworkInformation`-like instance extending `EventTarget` interface with a `type` property returning a string.');
        this.token = options.token;
        this.refreshToken()["catch"](function() {
            _this2.connectionStatus$.next($dbdd077456dd22ff$exports.ConnectionStatus.ExpiredToken);
        });
        this.domain = options.domain;
        if (options.conversationId) this.conversationId = options.conversationId;
        this._botAgent = this.getBotAgent(options.botAgent);
        this.queueActivities = true;
        this.activity$ = $2Ioq1.Observable.create(/*#__PURE__*/ function() {
            var _ref = (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee2(subscriber) {
                return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _this2.activitySubscriber = subscriber;
                            _this2.theStreamHandler = new $b0e81407e9f785f6$var$StreamHandler(subscriber, _this2.connectionStatus$, function() {
                                return _this2.queueActivities;
                            }); // Resolving connectDeferred will kick-off the connection.
                            _this2.connectDeferred.resolve();
                        case 3:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x3) {
                return _ref.apply(this, arguments);
            };
        }()).share(); // connectWithRetryAsync() will create the connectDeferred object required in activity$.
        this.connectWithRetryAsync();
    }
    (0, $b0e81407e9f785f6$var$_createClass2["default"])(DirectLineStreaming, [
        {
            key: "reconnect",
            value: function reconnect(_ref2) {
                var conversationId = _ref2.conversationId, token = _ref2.token;
                if (this.connectionStatus$.getValue() === $dbdd077456dd22ff$exports.ConnectionStatus.Ended) throw new Error("Connection has ended.");
                this.conversationId = conversationId;
                this.token = token;
                this.connectDeferred.resolve();
            }
        },
        {
            key: "end",
            value: function end() {
                // Once end() is called, no reconnection can be made.
                this.activitySubscriber.complete();
                this.connectionStatus$.next($dbdd077456dd22ff$exports.ConnectionStatus.Ended);
                this.connectionStatus$.complete();
                this.streamConnection.disconnect();
            }
        },
        {
            key: "commonHeaders",
            value: function commonHeaders() {
                return {
                    Authorization: "Bearer ".concat(this.token),
                    "x-ms-bot-agent": this._botAgent
                };
            }
        },
        {
            key: "getBotAgent",
            value: function getBotAgent() {
                var customAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var clientAgent = "directlineStreaming";
                if (customAgent) clientAgent += "; ".concat(customAgent);
                return "".concat($b0e81407e9f785f6$var$DIRECT_LINE_VERSION, " (").concat(clientAgent, ")");
            }
        },
        {
            key: "refreshToken",
            value: function() {
                var _refreshToken = (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee3() {
                    var firstCall, retryCount, numberOfAttempts, res, _yield$res$json, token, _args3 = arguments;
                    return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                firstCall = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : true;
                                retryCount = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 0;
                                _context3.next = 4;
                                return this.waitUntilOnline();
                            case 4:
                                numberOfAttempts = 0;
                            case 5:
                                if (!(numberOfAttempts < $b0e81407e9f785f6$var$MAX_RETRY_COUNT)) {
                                    _context3.next = 30;
                                    break;
                                }
                                numberOfAttempts++;
                                _context3.next = 9;
                                return new Promise(function(r) {
                                    return setTimeout(r, $b0e81407e9f785f6$var$refreshTokenInterval);
                                });
                            case 9:
                                _context3.prev = 9;
                                _context3.next = 12;
                                return (0, $b0e81407e9f785f6$var$_crossFetch["default"])("".concat(this.domain, "/tokens/refresh"), {
                                    method: "POST",
                                    headers: this.commonHeaders()
                                });
                            case 12:
                                res = _context3.sent;
                                if (!res.ok) {
                                    _context3.next = 22;
                                    break;
                                }
                                numberOfAttempts = 0;
                                _context3.next = 17;
                                return res.json();
                            case 17:
                                _yield$res$json = _context3.sent;
                                token = _yield$res$json.token;
                                this.token = token;
                                _context3.next = 23;
                                break;
                            case 22:
                                if (res.status === 403 || res.status === 403) {
                                    console.error("Fatal error while refreshing the token: ".concat(res.status, " ").concat(res.statusText));
                                    this.streamConnection.disconnect();
                                } else console.warn("Refresh attempt #".concat(numberOfAttempts, " failed: ").concat(res.status, " ").concat(res.statusText));
                            case 23:
                                _context3.next = 28;
                                break;
                            case 25:
                                _context3.prev = 25;
                                _context3.t0 = _context3["catch"](9);
                                console.warn("Refresh attempt #".concat(numberOfAttempts, " threw an exception: ").concat(_context3.t0));
                            case 28:
                                _context3.next = 5;
                                break;
                            case 30:
                                console.error("Retries exhausted");
                                this.streamConnection.disconnect();
                            case 32:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this, [
                        [
                            9,
                            25
                        ]
                    ]);
                }));
                function refreshToken() {
                    return _refreshToken.apply(this, arguments);
                }
                return refreshToken;
            }()
        },
        {
            key: "postActivity",
            value: function postActivity(activity) {
                var _this3 = this;
                if (this.connectionStatus$.value === $dbdd077456dd22ff$exports.ConnectionStatus.Ended || this.connectionStatus$.value === $dbdd077456dd22ff$exports.ConnectionStatus.FailedToConnect) return $2Ioq1.Observable["throw"](new Error("Connection is closed"));
                if (activity.type === "message" && activity.attachments && activity.attachments.length > 0) return this.postMessageWithAttachments(activity);
                var resp$ = $2Ioq1.Observable.create(/*#__PURE__*/ function() {
                    var _ref3 = (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee4(subscriber) {
                        var request, resp, numberOfStreams, idString, _JSON$parse, id;
                        return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                            while(true)switch(_context4.prev = _context4.next){
                                case 0:
                                    request = $b0e81407e9f785f6$var$BFSE.StreamingRequest.create("POST", "/v3/directline/conversations/" + _this3.conversationId + "/activities");
                                    request.setBody(JSON.stringify(activity));
                                    _context4.prev = 2;
                                    _context4.next = 5;
                                    return _this3.streamConnection.send(request);
                                case 5:
                                    resp = _context4.sent;
                                    if (!(resp.statusCode !== 200)) {
                                        _context4.next = 8;
                                        break;
                                    }
                                    throw new Error("PostActivity returned " + resp.statusCode);
                                case 8:
                                    numberOfStreams = resp.streams.length;
                                    if (!(numberOfStreams !== 1)) {
                                        _context4.next = 11;
                                        break;
                                    }
                                    throw new Error("Expected one stream but got " + numberOfStreams);
                                case 11:
                                    _context4.next = 13;
                                    return resp.streams[0].readAsString();
                                case 13:
                                    idString = _context4.sent;
                                    _JSON$parse = JSON.parse(idString), id = _JSON$parse.Id;
                                    subscriber.next(id);
                                    return _context4.abrupt("return", subscriber.complete());
                                case 19:
                                    _context4.prev = 19;
                                    _context4.t0 = _context4["catch"](2);
                                    // If there is a network issue then its handled by
                                    // the disconnectionHandler. Everything else can
                                    // be retried
                                    console.warn(_context4.t0);
                                    _this3.streamConnection.disconnect();
                                    return _context4.abrupt("return", subscriber.error(_context4.t0));
                                case 24:
                                case "end":
                                    return _context4.stop();
                            }
                        }, _callee4, null, [
                            [
                                2,
                                19
                            ]
                        ]);
                    }));
                    return function(_x4) {
                        return _ref3.apply(this, arguments);
                    };
                }());
                return resp$;
            }
        },
        {
            key: "postMessageWithAttachments",
            value: function postMessageWithAttachments(message) {
                var _this4 = this;
                var attachments = message.attachments, messageWithoutAttachments = (0, $b0e81407e9f785f6$var$_objectWithoutProperties2["default"])(message, $b0e81407e9f785f6$var$_excluded);
                return $2Ioq1.Observable.create(function(subscriber) {
                    var httpContentList = [];
                    (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee6() {
                        var arrayBuffers, url, request, activityStream, resp, _yield$resp$streams$, id;
                        return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee6$(_context6) {
                            while(true)switch(_context6.prev = _context6.next){
                                case 0:
                                    _context6.prev = 0;
                                    _context6.next = 3;
                                    return Promise.all(attachments.map(/*#__PURE__*/ function() {
                                        var _ref5 = (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee5(attachment) {
                                            var media, res;
                                            return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee5$(_context5) {
                                                while(true)switch(_context5.prev = _context5.next){
                                                    case 0:
                                                        media = attachment;
                                                        _context5.next = 3;
                                                        return (0, $b0e81407e9f785f6$var$_crossFetch["default"])(media.contentUrl);
                                                    case 3:
                                                        res = _context5.sent;
                                                        if (!res.ok) {
                                                            _context5.next = 12;
                                                            break;
                                                        }
                                                        _context5.next = 7;
                                                        return res.arrayBuffer();
                                                    case 7:
                                                        _context5.t0 = _context5.sent;
                                                        _context5.t1 = media;
                                                        return _context5.abrupt("return", {
                                                            arrayBuffer: _context5.t0,
                                                            media: _context5.t1
                                                        });
                                                    case 12:
                                                        throw new Error("...");
                                                    case 13:
                                                    case "end":
                                                        return _context5.stop();
                                                }
                                            }, _callee5);
                                        }));
                                        return function(_x5) {
                                            return _ref5.apply(this, arguments);
                                        };
                                    }()));
                                case 3:
                                    arrayBuffers = _context6.sent;
                                    arrayBuffers.forEach(function(_ref6) {
                                        var arrayBuffer = _ref6.arrayBuffer, media = _ref6.media;
                                        var buffer = $8a2aa373b87bfbc4$export$a143d493d941bafc.from(arrayBuffer);
                                        var stream = new $b0e81407e9f785f6$var$BFSE.SubscribableStream();
                                        stream.write(buffer);
                                        var httpContent = new $b0e81407e9f785f6$var$BFSE.HttpContent({
                                            type: media.contentType,
                                            contentLength: buffer.length
                                        }, stream);
                                        httpContentList.push(httpContent);
                                    });
                                    url = "/v3/directline/conversations/".concat(_this4.conversationId, "/users/").concat(messageWithoutAttachments.from.id, "/upload");
                                    request = $b0e81407e9f785f6$var$BFSE.StreamingRequest.create("PUT", url);
                                    activityStream = new $b0e81407e9f785f6$var$BFSE.SubscribableStream();
                                    activityStream.write(JSON.stringify(messageWithoutAttachments), "utf-8");
                                    request.addStream(new $b0e81407e9f785f6$var$BFSE.HttpContent({
                                        type: "application/vnd.microsoft.activity",
                                        contentLength: activityStream.length
                                    }, activityStream));
                                    httpContentList.forEach(function(e) {
                                        return request.addStream(e);
                                    });
                                    _context6.next = 13;
                                    return _this4.streamConnection.send(request);
                                case 13:
                                    resp = _context6.sent;
                                    if (!(resp.streams && resp.streams.length !== 1)) {
                                        _context6.next = 18;
                                        break;
                                    }
                                    subscriber.error(new Error("Invalid stream count ".concat(resp.streams.length)));
                                    _context6.next = 24;
                                    break;
                                case 18:
                                    _context6.next = 20;
                                    return resp.streams[0].readAsJson();
                                case 20:
                                    _yield$resp$streams$ = _context6.sent;
                                    id = _yield$resp$streams$.Id;
                                    subscriber.next(id);
                                    subscriber.complete();
                                case 24:
                                    _context6.next = 29;
                                    break;
                                case 26:
                                    _context6.prev = 26;
                                    _context6.t0 = _context6["catch"](0);
                                    subscriber.error(_context6.t0);
                                case 29:
                                case "end":
                                    return _context6.stop();
                            }
                        }, _callee6, null, [
                            [
                                0,
                                26
                            ]
                        ]);
                    }))();
                });
            }
        },
        {
            key: "waitUntilOnline",
            value: function() {
                var _waitUntilOnline = (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee7() {
                    var _this5 = this;
                    return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                return _context7.abrupt("return", new Promise(function(resolve, reject) {
                                    _this5.connectionStatus$.subscribe(function(cs) {
                                        if (cs === $dbdd077456dd22ff$exports.ConnectionStatus.Online) return resolve();
                                    }, function(e) {
                                        return reject(e);
                                    });
                                }));
                            case 1:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7);
                }));
                function waitUntilOnline() {
                    return _waitUntilOnline.apply(this, arguments);
                }
                return waitUntilOnline;
            }()
        },
        {
            key: "connectAsync",
            value: function() {
                var _connectAsync = (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee9() {
                    var _this6 = this;
                    var re, params, abortController, urlSearchParams, wsUrl;
                    return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                re = new RegExp("^http(s?)");
                                if (re.test(this.domain)) {
                                    _context9.next = 3;
                                    break;
                                }
                                throw "Domain must begin with http or https";
                            case 3:
                                params = {
                                    token: this.token
                                };
                                if (this.conversationId) params["conversationId"] = this.conversationId;
                                abortController = new AbortController();
                                urlSearchParams = new URLSearchParams(params).toString();
                                wsUrl = "".concat(this.domain.replace(re, "ws$1"), "/conversations/connect?").concat(urlSearchParams); // This promise will resolve when it is disconnected.
                                return _context9.abrupt("return", new Promise(/*#__PURE__*/ function() {
                                    var _ref7 = (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee8(resolve, reject) {
                                        var request, response, responseString, conversation;
                                        return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee8$(_context8) {
                                            while(true)switch(_context8.prev = _context8.next){
                                                case 0:
                                                    _context8.prev = 0;
                                                    _this6.streamConnection = new $b0e81407e9f785f6$var$_WebSocketClientWithNetworkInformation["default"]({
                                                        disconnectionHandler: resolve,
                                                        networkInformation: (0, $b0e81407e9f785f6$var$_classPrivateFieldGet2["default"])(_this6, $b0e81407e9f785f6$var$_networkInformation),
                                                        requestHandler: {
                                                            processRequest: function processRequest(streamingRequest) {
                                                                // If `streamConnection` is still current, allow call to `processRequest()`, otherwise, ignore calls to `processRequest()`.
                                                                // This prevents zombie connections from sending us requests.
                                                                if (abortController.signal.aborted) throw new Error("Cannot process streaming request, `streamingConnection` should be disconnected.");
                                                                return _this6.theStreamHandler.processRequest(streamingRequest);
                                                            }
                                                        },
                                                        url: wsUrl
                                                    });
                                                    _this6.queueActivities = true;
                                                    _context8.next = 5;
                                                    return _this6.streamConnection.connect();
                                                case 5:
                                                    request = $b0e81407e9f785f6$var$BFSE.StreamingRequest.create("POST", "/v3/directline/conversations");
                                                    _context8.next = 8;
                                                    return _this6.streamConnection.send(request);
                                                case 8:
                                                    response = _context8.sent;
                                                    if (!(response.statusCode !== 200)) {
                                                        _context8.next = 11;
                                                        break;
                                                    }
                                                    throw new Error("Connection response code " + response.statusCode);
                                                case 11:
                                                    if (!(response.streams.length !== 1)) {
                                                        _context8.next = 13;
                                                        break;
                                                    }
                                                    throw new Error("Expected 1 stream but got " + response.streams.length);
                                                case 13:
                                                    _context8.next = 15;
                                                    return response.streams[0].readAsString();
                                                case 15:
                                                    responseString = _context8.sent;
                                                    conversation = JSON.parse(responseString);
                                                    _this6.conversationId = conversation.conversationId;
                                                    _this6.connectionStatus$.next($dbdd077456dd22ff$exports.ConnectionStatus.Online); // Wait until DL consumers have had a chance to be notified
                                                    // of the connection status change.
                                                    // This is specific to RxJS implementation of observable, which calling subscribe() after next() will still get the value.
                                                    _context8.next = 21;
                                                    return _this6.waitUntilOnline();
                                                case 21:
                                                    _this6.theStreamHandler.flush();
                                                    _this6.queueActivities = false;
                                                    _context8.next = 28;
                                                    break;
                                                case 25:
                                                    _context8.prev = 25;
                                                    _context8.t0 = _context8["catch"](0);
                                                    reject(_context8.t0);
                                                case 28:
                                                case "end":
                                                    return _context8.stop();
                                            }
                                        }, _callee8, null, [
                                            [
                                                0,
                                                25
                                            ]
                                        ]);
                                    }));
                                    return function(_x6, _x7) {
                                        return _ref7.apply(this, arguments);
                                    };
                                }())["finally"](function() {
                                    return abortController.abort();
                                }));
                            case 9:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function connectAsync() {
                    return _connectAsync.apply(this, arguments);
                }
                return connectAsync;
            }()
        },
        {
            key: "connectWithRetryAsync",
            value: function() {
                var _connectWithRetryAsync = (0, $b0e81407e9f785f6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b0e81407e9f785f6$var$_regenerator["default"].mark(function _callee10() {
                    var _this7 = this;
                    var numRetries, start;
                    return $b0e81407e9f785f6$var$_regenerator["default"].wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                _context10.next = 2;
                                return (this.connectDeferred = (0, $b0e81407e9f785f6$var$_createDeferred["default"])()).promise;
                            case 2:
                                numRetries = $b0e81407e9f785f6$var$MAX_RETRY_COUNT;
                                this.connectionStatus$.next($dbdd077456dd22ff$exports.ConnectionStatus.Connecting);
                            case 4:
                                if (!(numRetries > 0)) {
                                    _context10.next = 27;
                                    break;
                                }
                                numRetries--;
                                start = Date.now();
                                _context10.prev = 7;
                                _context10.next = 10;
                                return this.connectAsync();
                            case 10:
                                _context10.next = 15;
                                break;
                            case 12:
                                _context10.prev = 12;
                                _context10.t0 = _context10["catch"](7);
                                console.error(_context10.t0);
                            case 15:
                                if (!(this.connectionStatus$.getValue() === $dbdd077456dd22ff$exports.ConnectionStatus.Ended)) {
                                    _context10.next = 17;
                                    break;
                                }
                                return _context10.abrupt("return");
                            case 17:
                                // Make sure we don't signal ConnectionStatus.Connecting twice or more without an actual connection.
                                // Subsequent retries should be transparent.
                                if (this.connectionStatus$.getValue() !== $dbdd077456dd22ff$exports.ConnectionStatus.Connecting) this.connectionStatus$.next($dbdd077456dd22ff$exports.ConnectionStatus.Connecting);
                                 // If the current connection lasted for more than a minute, the previous connection is good, which means:
                                // - we should reset the retry counter, and;
                                // - we should reconnect immediately.
                                if (!(60000 < Date.now() - start)) {
                                    _context10.next = 22;
                                    break;
                                }
                                numRetries = $b0e81407e9f785f6$var$MAX_RETRY_COUNT;
                                _context10.next = 25;
                                break;
                            case 22:
                                if (!(numRetries > 0)) {
                                    _context10.next = 25;
                                    break;
                                }
                                _context10.next = 25;
                                return new Promise(function(r) {
                                    return setTimeout(r, _this7.getRetryDelay());
                                });
                            case 25:
                                _context10.next = 4;
                                break;
                            case 27:
                                // TODO: [TEST] Make sure FailedToConnect is reported immediately after last disconnection, should be no getRetryDelay().
                                // Failed to reconnect after multiple retries.
                                this.connectionStatus$.next($dbdd077456dd22ff$exports.ConnectionStatus.FailedToConnect);
                            case 28:
                                _context10.next = 0;
                                break;
                            case 30:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            7,
                            12
                        ]
                    ]);
                }));
                function connectWithRetryAsync() {
                    return _connectWithRetryAsync.apply(this, arguments);
                }
                return connectWithRetryAsync;
            }() // Returns the delay duration in milliseconds
        },
        {
            key: "getRetryDelay",
            value: function getRetryDelay() {
                return Math.floor(3000 + Math.random() * 12000);
            }
        }
    ]);
    return DirectLineStreaming;
}();
$b0e81407e9f785f6$exports.DirectLineStreaming = $b0e81407e9f785f6$var$DirectLineStreaming;


var $dbdd077456dd22ff$var$_excluded = [
    "contentUrl"
];
function $dbdd077456dd22ff$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($dbdd077456dd22ff$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $dbdd077456dd22ff$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $kKXRo(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $dbdd077456dd22ff$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $dbdd077456dd22ff$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dbdd077456dd22ff$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dbdd077456dd22ff$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dbdd077456dd22ff$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dbdd077456dd22ff$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $dbdd077456dd22ff$var$DIRECT_LINE_VERSION = "DirectLine/3.0";
// These types are specific to this client library, not to Direct Line 3.0
var $dbdd077456dd22ff$var$ConnectionStatus;
$dbdd077456dd22ff$exports.ConnectionStatus = $dbdd077456dd22ff$var$ConnectionStatus;
(function(ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Uninitialized"] = 0] = "Uninitialized";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Online"] = 2] = "Online";
    ConnectionStatus[ConnectionStatus["ExpiredToken"] = 3] = "ExpiredToken";
    ConnectionStatus[ConnectionStatus["FailedToConnect"] = 4] = "FailedToConnect";
    ConnectionStatus[ConnectionStatus["Ended"] = 5] = "Ended";
})($dbdd077456dd22ff$var$ConnectionStatus || ($dbdd077456dd22ff$exports.ConnectionStatus = $dbdd077456dd22ff$var$ConnectionStatus = {}));
var $dbdd077456dd22ff$var$wrapAjaxWithRetry = function wrapAjaxWithRetry(source, scheduler) {
    var notImplemented = function notImplemented() {
        throw new Error("not implemented");
    };
    var inner = function inner(response$) {
        return response$["catch"](function(err) {
            if (err.status === 429) {
                var retryAfterValue = err.xhr.getResponseHeader("Retry-After");
                var retryAfter = Number(retryAfterValue);
                if (!isNaN(retryAfter)) return $2Ioq1.Observable.timer(retryAfter, scheduler).flatMap(function(_) {
                    return $2Ioq1.Observable["throw"](err, scheduler);
                });
            }
            return $2Ioq1.Observable["throw"](err, scheduler);
        });
    };
    var outer = function outer(urlOrRequest) {
        return inner(source(urlOrRequest));
    };
    return Object.assign(outer, {
        get: function get(url, headers) {
            return notImplemented();
        },
        post: function post(url, body, headers) {
            return notImplemented();
        },
        put: function put(url, body, headers) {
            return notImplemented();
        },
        patch: function patch(url, body, headers) {
            return notImplemented();
        },
        "delete": function _delete(url, headers) {
            return notImplemented();
        },
        getJSON: function getJSON(url, headers) {
            return notImplemented();
        }
    });
};
var $dbdd077456dd22ff$var$makeServices = function makeServices(services) {
    var scheduler = services.scheduler || $lDxEl.async;
    return {
        scheduler: scheduler,
        ajax: $dbdd077456dd22ff$var$wrapAjaxWithRetry(services.ajax || $2Ioq1.Observable.ajax, scheduler),
        WebSocket: services.WebSocket || WebSocket,
        random: services.random || Math.random
    };
};
var $dbdd077456dd22ff$var$lifetimeRefreshToken = 1800000;
var $dbdd077456dd22ff$var$intervalRefreshToken = $dbdd077456dd22ff$var$lifetimeRefreshToken / 2;
var $dbdd077456dd22ff$var$POLLING_INTERVAL_LOWER_BOUND = 200; //ms
var $dbdd077456dd22ff$var$errorExpiredToken = new Error("expired token");
var $dbdd077456dd22ff$var$errorConversationEnded = new Error("conversation ended");
var $dbdd077456dd22ff$var$errorFailedToConnect = new Error("failed to connect");
var $dbdd077456dd22ff$var$konsole = {
    log: function log(message) {
        var _console;
        for(var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)optionalParams[_key - 1] = arguments[_key];
        if (typeof window !== "undefined" && window["botchatDebug"] && message) (_console = console).log.apply(_console, [
            message
        ].concat(optionalParams));
    }
};
var $dbdd077456dd22ff$var$DirectLine = /*#__PURE__*/ function() {
    function DirectLine(options) {
        (0, $dbdd077456dd22ff$var$_classCallCheck2["default"])(this, DirectLine);
        (0, $dbdd077456dd22ff$var$_defineProperty2["default"])(this, "connectionStatus$", new $0080f81ae5c35a5a$exports.BehaviorSubject($dbdd077456dd22ff$var$ConnectionStatus.Uninitialized));
        (0, $dbdd077456dd22ff$var$_defineProperty2["default"])(this, "domain", "https://directline.botframework.com/v3/directline");
        (0, $dbdd077456dd22ff$var$_defineProperty2["default"])(this, "watermark", "");
        (0, $dbdd077456dd22ff$var$_defineProperty2["default"])(this, "_botAgent", "");
        (0, $dbdd077456dd22ff$var$_defineProperty2["default"])(this, "timeout", 20000);
        (0, $dbdd077456dd22ff$var$_defineProperty2["default"])(this, "pollingInterval", 1000);
        this.secret = options.secret;
        this.token = options.secret || options.token;
        this.webSocket = (options.webSocket === undefined ? true : options.webSocket) && typeof WebSocket !== "undefined" && WebSocket !== undefined;
        if (options.conversationStartProperties && options.conversationStartProperties.locale) {
            if (Object.prototype.toString.call(options.conversationStartProperties.locale) === "[object String]") this.localeOnStartConversation = options.conversationStartProperties.locale;
            else console.warn("DirectLineJS: conversationStartProperties.locale was ignored: the locale name may be a BCP 47 language tag");
        }
        if (options.domain) this.domain = options.domain;
        if (options.conversationId) this.conversationId = options.conversationId;
        if (options.watermark) this.watermark = options.watermark;
        if (options.streamUrl) {
            if (options.token && options.conversationId) this.streamUrl = options.streamUrl;
            else console.warn("DirectLineJS: streamUrl was ignored: you need to provide a token and a conversationid");
        }
        if (options.timeout !== undefined) this.timeout = options.timeout;
        this.retries = ($dbdd077456dd22ff$var$lifetimeRefreshToken - $dbdd077456dd22ff$var$intervalRefreshToken) / this.timeout;
        this._botAgent = this.getBotAgent(options.botAgent);
        this.services = $dbdd077456dd22ff$var$makeServices(options);
        var parsedPollingInterval = ~~options.pollingInterval;
        if (parsedPollingInterval < $dbdd077456dd22ff$var$POLLING_INTERVAL_LOWER_BOUND) {
            if (typeof options.pollingInterval !== "undefined") console.warn("DirectLineJS: provided pollingInterval (".concat(options.pollingInterval, ") is under lower bound (200ms), using default of 1000ms"));
        } else this.pollingInterval = parsedPollingInterval;
        this.expiredTokenExhaustion = this.setConnectionStatusFallback($dbdd077456dd22ff$var$ConnectionStatus.ExpiredToken, $dbdd077456dd22ff$var$ConnectionStatus.FailedToConnect, 5);
        this.activity$ = (this.webSocket ? this.webSocketActivity$() : this.pollingGetActivity$()).share();
    } // Every time we're about to make a Direct Line REST call, we call this first to see check the current connection status.
    // Either throws an error (indicating an error state) or emits a null, indicating a (presumably) healthy connection
    (0, $dbdd077456dd22ff$var$_createClass2["default"])(DirectLine, [
        {
            key: "checkConnection",
            value: function checkConnection() {
                var _this = this;
                var once = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                var obs = this.connectionStatus$.flatMap(function(connectionStatus) {
                    if (connectionStatus === $dbdd077456dd22ff$var$ConnectionStatus.Uninitialized) {
                        _this.connectionStatus$.next($dbdd077456dd22ff$var$ConnectionStatus.Connecting); //if token and streamUrl are defined it means reconnect has already been done. Skipping it.
                        if (_this.token && _this.streamUrl) {
                            _this.connectionStatus$.next($dbdd077456dd22ff$var$ConnectionStatus.Online);
                            return $2Ioq1.Observable.of(connectionStatus, _this.services.scheduler);
                        } else return _this.startConversation()["do"](function(conversation) {
                            _this.conversationId = conversation.conversationId;
                            _this.token = _this.secret || conversation.token;
                            _this.streamUrl = conversation.streamUrl;
                            _this.referenceGrammarId = conversation.referenceGrammarId;
                            if (!_this.secret) _this.refreshTokenLoop();
                            _this.connectionStatus$.next($dbdd077456dd22ff$var$ConnectionStatus.Online);
                        }, function(error) {
                            _this.connectionStatus$.next($dbdd077456dd22ff$var$ConnectionStatus.FailedToConnect);
                        }).map(function(_) {
                            return connectionStatus;
                        });
                    } else return $2Ioq1.Observable.of(connectionStatus, _this.services.scheduler);
                }).filter(function(connectionStatus) {
                    return connectionStatus != $dbdd077456dd22ff$var$ConnectionStatus.Uninitialized && connectionStatus != $dbdd077456dd22ff$var$ConnectionStatus.Connecting;
                }).flatMap(function(connectionStatus) {
                    switch(connectionStatus){
                        case $dbdd077456dd22ff$var$ConnectionStatus.Ended:
                            return $2Ioq1.Observable["throw"]($dbdd077456dd22ff$var$errorConversationEnded, _this.services.scheduler);
                        case $dbdd077456dd22ff$var$ConnectionStatus.FailedToConnect:
                            return $2Ioq1.Observable["throw"]($dbdd077456dd22ff$var$errorFailedToConnect, _this.services.scheduler);
                        case $dbdd077456dd22ff$var$ConnectionStatus.ExpiredToken:
                            return $2Ioq1.Observable.of(connectionStatus, _this.services.scheduler);
                        default:
                            return $2Ioq1.Observable.of(connectionStatus, _this.services.scheduler);
                    }
                });
                return once ? obs.take(1) : obs;
            }
        },
        {
            key: "setConnectionStatusFallback",
            value: function setConnectionStatusFallback(connectionStatusFrom, connectionStatusTo) {
                var maxAttempts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
                maxAttempts--;
                var attempts = 0;
                var currStatus = null;
                return function(status) {
                    if (status === connectionStatusFrom && currStatus === status && attempts >= maxAttempts) {
                        attempts = 0;
                        return connectionStatusTo;
                    }
                    attempts++;
                    currStatus = status;
                    return status;
                };
            }
        },
        {
            key: "expiredToken",
            value: function expiredToken() {
                var connectionStatus = this.connectionStatus$.getValue();
                if (connectionStatus != $dbdd077456dd22ff$var$ConnectionStatus.Ended && connectionStatus != $dbdd077456dd22ff$var$ConnectionStatus.FailedToConnect) this.connectionStatus$.next($dbdd077456dd22ff$var$ConnectionStatus.ExpiredToken);
                var protectedConnectionStatus = this.expiredTokenExhaustion(this.connectionStatus$.getValue());
                this.connectionStatus$.next(protectedConnectionStatus);
            }
        },
        {
            key: "startConversation",
            value: function startConversation() {
                var _this2 = this;
                //if conversationid is set here, it means we need to call the reconnect api, else it is a new conversation
                var url = this.conversationId ? "".concat(this.domain, "/conversations/").concat(this.conversationId, "?watermark=").concat(this.watermark) : "".concat(this.domain, "/conversations");
                var method = this.conversationId ? "GET" : "POST";
                var body = this.conversationId ? undefined : {
                    user: {
                        id: this.userIdOnStartConversation
                    },
                    locale: this.localeOnStartConversation
                };
                return this.services.ajax({
                    method: method,
                    url: url,
                    body: body,
                    timeout: this.timeout,
                    headers: $dbdd077456dd22ff$var$_objectSpread({
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    }, this.commonHeaders())
                }) //      .do(ajaxResponse => konsole.log("conversation ajaxResponse", ajaxResponse.response))
                .map(function(ajaxResponse) {
                    return ajaxResponse.response;
                }).retryWhen(function(error$) {
                    return(// for everything else (timeouts), retry for a while
                    error$.mergeMap(function(error) {
                        return error.status >= 400 && error.status < 600 ? $2Ioq1.Observable["throw"](error, _this2.services.scheduler) : $2Ioq1.Observable.of(error, _this2.services.scheduler);
                    }).delay(_this2.timeout, _this2.services.scheduler).take(_this2.retries));
                });
            }
        },
        {
            key: "refreshTokenLoop",
            value: function refreshTokenLoop() {
                var _this3 = this;
                this.tokenRefreshSubscription = $2Ioq1.Observable.interval($dbdd077456dd22ff$var$intervalRefreshToken, this.services.scheduler).flatMap(function(_) {
                    return _this3.refreshToken();
                }).subscribe(function(token) {
                    $dbdd077456dd22ff$var$konsole.log("refreshing token", token, "at", new Date());
                    _this3.token = token;
                });
            }
        },
        {
            key: "refreshToken",
            value: function refreshToken() {
                var _this4 = this;
                return this.checkConnection(true).flatMap(function(_) {
                    return _this4.services.ajax({
                        method: "POST",
                        url: "".concat(_this4.domain, "/tokens/refresh"),
                        timeout: _this4.timeout,
                        headers: $dbdd077456dd22ff$var$_objectSpread({}, _this4.commonHeaders())
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response.token;
                    }).retryWhen(function(error$) {
                        return error$.mergeMap(function(error) {
                            if (error.status === 403) {
                                // if the token is expired there's no reason to keep trying
                                _this4.expiredToken();
                                return $2Ioq1.Observable["throw"](error, _this4.services.scheduler);
                            } else if (error.status === 404) // If the bot is gone, we should stop retrying
                            return $2Ioq1.Observable["throw"](error, _this4.services.scheduler);
                            return $2Ioq1.Observable.of(error, _this4.services.scheduler);
                        }).delay(_this4.timeout, _this4.services.scheduler).take(_this4.retries);
                    });
                });
            }
        },
        {
            key: "reconnect",
            value: function reconnect(conversation) {
                this.token = conversation.token;
                this.streamUrl = conversation.streamUrl;
                if (this.connectionStatus$.getValue() === $dbdd077456dd22ff$var$ConnectionStatus.ExpiredToken) this.connectionStatus$.next($dbdd077456dd22ff$var$ConnectionStatus.Online);
            }
        },
        {
            key: "end",
            value: function end() {
                if (this.tokenRefreshSubscription) this.tokenRefreshSubscription.unsubscribe();
                try {
                    this.connectionStatus$.next($dbdd077456dd22ff$var$ConnectionStatus.Ended);
                } catch (e) {
                    if (e === $dbdd077456dd22ff$var$errorConversationEnded) return;
                    throw e;
                }
            }
        },
        {
            key: "getSessionId",
            value: function getSessionId() {
                var _this5 = this;
                // If we're not connected to the bot, get connected
                // Will throw an error if we are not connected
                $dbdd077456dd22ff$var$konsole.log("getSessionId");
                return this.checkConnection(true).flatMap(function(_) {
                    return _this5.services.ajax({
                        method: "GET",
                        url: "".concat(_this5.domain, "/session/getsessionid"),
                        withCredentials: true,
                        timeout: _this5.timeout,
                        headers: $dbdd077456dd22ff$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, _this5.commonHeaders())
                    }).map(function(ajaxResponse) {
                        if (ajaxResponse && ajaxResponse.response && ajaxResponse.response.sessionId) {
                            $dbdd077456dd22ff$var$konsole.log("getSessionId response: " + ajaxResponse.response.sessionId);
                            return ajaxResponse.response.sessionId;
                        }
                        return "";
                    })["catch"](function(error) {
                        $dbdd077456dd22ff$var$konsole.log("getSessionId error: " + error.status);
                        return $2Ioq1.Observable.of("", _this5.services.scheduler);
                    });
                })["catch"](function(error) {
                    return _this5.catchExpiredToken(error);
                });
            }
        },
        {
            key: "postActivity",
            value: function postActivity(activity) {
                var _this6 = this;
                // If user id is set, check if it match activity.from.id and always override it in activity
                if (this.userIdOnStartConversation && activity.from && activity.from.id !== this.userIdOnStartConversation) {
                    console.warn("DirectLineJS: Activity.from.id does not match with user id, ignoring activity.from.id");
                    activity.from.id = this.userIdOnStartConversation;
                } // Use postMessageWithAttachments for messages with attachments that are local files (e.g. an image to upload)
                // Technically we could use it for *all* activities, but postActivity is much lighter weight
                // So, since WebChat is partially a reference implementation of Direct Line, we implement both.
                if (activity.type === "message" && activity.attachments && activity.attachments.length > 0) return this.postMessageWithAttachments(activity); // If we're not connected to the bot, get connected
                // Will throw an error if we are not connected
                $dbdd077456dd22ff$var$konsole.log("postActivity", activity);
                return this.checkConnection(true).flatMap(function(_) {
                    return _this6.services.ajax({
                        method: "POST",
                        url: "".concat(_this6.domain, "/conversations/").concat(_this6.conversationId, "/activities"),
                        body: activity,
                        timeout: _this6.timeout,
                        headers: $dbdd077456dd22ff$var$_objectSpread({
                            "Content-Type": "application/json"
                        }, _this6.commonHeaders())
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response.id;
                    })["catch"](function(error) {
                        return _this6.catchPostError(error);
                    });
                })["catch"](function(error) {
                    return _this6.catchExpiredToken(error);
                });
            }
        },
        {
            key: "postMessageWithAttachments",
            value: function postMessageWithAttachments(message) {
                var _this7 = this;
                var attachments = message.attachments; // We clean the attachments but making sure every attachment has unique name.
                // If the file do not have a name, Chrome will assign "blob" when it is appended to FormData.
                var attachmentNames = (0, $dbdd077456dd22ff$var$_dedupeFilenames["default"])(attachments.map(function(media) {
                    return media.name || "blob";
                }));
                var cleansedAttachments = attachments.map(function(attachment, index) {
                    return $dbdd077456dd22ff$var$_objectSpread($dbdd077456dd22ff$var$_objectSpread({}, attachment), {}, {
                        name: attachmentNames[index]
                    });
                });
                var formData; // If we're not connected to the bot, get connected
                // Will throw an error if we are not connected
                return this.checkConnection(true).flatMap(function(_) {
                    // To send this message to DirectLine we need to deconstruct it into a "template" activity
                    // and one blob for each attachment.
                    formData = new FormData();
                    formData.append("activity", new Blob([
                        JSON.stringify($dbdd077456dd22ff$var$_objectSpread($dbdd077456dd22ff$var$_objectSpread({}, message), {}, {
                            // Removing contentUrl from attachment, we will send it via multipart
                            attachments: cleansedAttachments.map(function(_ref) {
                                var string = _ref.contentUrl, others = (0, $dbdd077456dd22ff$var$_objectWithoutProperties2["default"])(_ref, $dbdd077456dd22ff$var$_excluded);
                                return $dbdd077456dd22ff$var$_objectSpread({}, others);
                            })
                        }))
                    ], {
                        type: "application/vnd.microsoft.activity"
                    }));
                    return $2Ioq1.Observable.from(cleansedAttachments, _this7.services.scheduler).flatMap(function(media) {
                        return _this7.services.ajax({
                            method: "GET",
                            url: media.contentUrl,
                            responseType: "arraybuffer"
                        })["do"](function(ajaxResponse) {
                            return formData.append("file", new Blob([
                                ajaxResponse.response
                            ], {
                                type: media.contentType
                            }), media.name);
                        });
                    }).count();
                }).flatMap(function(_) {
                    return _this7.services.ajax({
                        method: "POST",
                        url: "".concat(_this7.domain, "/conversations/").concat(_this7.conversationId, "/upload?userId=").concat(message.from.id),
                        body: formData,
                        timeout: _this7.timeout,
                        headers: $dbdd077456dd22ff$var$_objectSpread({}, _this7.commonHeaders())
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response.id;
                    })["catch"](function(error) {
                        return _this7.catchPostError(error);
                    });
                })["catch"](function(error) {
                    return _this7.catchPostError(error);
                });
            }
        },
        {
            key: "catchPostError",
            value: function catchPostError(error) {
                if (error.status === 403) this.expiredToken();
                else if (error.status >= 400 && error.status < 500) return $2Ioq1.Observable["throw"](error, this.services.scheduler);
                return $2Ioq1.Observable.of("retry", this.services.scheduler);
            }
        },
        {
            key: "catchExpiredToken",
            value: function catchExpiredToken(error) {
                return error === $dbdd077456dd22ff$var$errorExpiredToken ? $2Ioq1.Observable.of("retry", this.services.scheduler) : $2Ioq1.Observable["throw"](error, this.services.scheduler);
            }
        },
        {
            key: "pollingGetActivity$",
            value: function pollingGetActivity$() {
                var _this8 = this;
                var poller$ = $2Ioq1.Observable.create(function(subscriber) {
                    // A BehaviorSubject to trigger polling. Since it is a BehaviorSubject
                    // the first event is produced immediately.
                    var trigger$ = new $0080f81ae5c35a5a$exports.BehaviorSubject({}); // TODO: remove Date.now, use reactive interval to space out every request
                    trigger$.subscribe(function() {
                        if (_this8.connectionStatus$.getValue() === $dbdd077456dd22ff$var$ConnectionStatus.Online) {
                            var startTimestamp = Date.now();
                            _this8.services.ajax({
                                headers: $dbdd077456dd22ff$var$_objectSpread({
                                    Accept: "application/json"
                                }, _this8.commonHeaders()),
                                method: "GET",
                                url: "".concat(_this8.domain, "/conversations/").concat(_this8.conversationId, "/activities?watermark=").concat(_this8.watermark),
                                timeout: _this8.timeout
                            }).subscribe(function(result) {
                                subscriber.next(result);
                                setTimeout(function() {
                                    return trigger$.next(null);
                                }, Math.max(0, _this8.pollingInterval - Date.now() + startTimestamp));
                            }, function(error) {
                                switch(error.status){
                                    case 403:
                                        _this8.connectionStatus$.next($dbdd077456dd22ff$var$ConnectionStatus.ExpiredToken);
                                        setTimeout(function() {
                                            return trigger$.next(null);
                                        }, _this8.pollingInterval);
                                        break;
                                    case 404:
                                        _this8.connectionStatus$.next($dbdd077456dd22ff$var$ConnectionStatus.Ended);
                                        break;
                                    default:
                                        // propagate the error
                                        subscriber.error(error);
                                        break;
                                }
                            });
                        }
                    });
                });
                return this.checkConnection().flatMap(function(_) {
                    return poller$["catch"](function() {
                        return $2Ioq1.Observable.empty();
                    }).map(function(ajaxResponse) {
                        return ajaxResponse.response;
                    }).flatMap(function(activityGroup) {
                        return _this8.observableFromActivityGroup(activityGroup);
                    });
                });
            }
        },
        {
            key: "observableFromActivityGroup",
            value: function observableFromActivityGroup(activityGroup) {
                if (activityGroup.watermark) this.watermark = activityGroup.watermark;
                return $2Ioq1.Observable.from(activityGroup.activities, this.services.scheduler);
            }
        },
        {
            key: "webSocketActivity$",
            value: function webSocketActivity$() {
                var _this9 = this;
                return this.checkConnection().flatMap(function(_) {
                    return _this9.observableWebSocket() // WebSockets can be closed by the server or the browser. In the former case we need to
                    // retrieve a new streamUrl. In the latter case we could first retry with the current streamUrl,
                    // but it's simpler just to always fetch a new one.
                    .retryWhen(function(error$) {
                        return error$.delay(_this9.getRetryDelay(), _this9.services.scheduler).mergeMap(function(error) {
                            return _this9.reconnectToConversation();
                        });
                    });
                }).flatMap(function(activityGroup) {
                    return _this9.observableFromActivityGroup(activityGroup);
                });
            } // Returns the delay duration in milliseconds
        },
        {
            key: "getRetryDelay",
            value: function getRetryDelay() {
                return Math.floor(3000 + this.services.random() * 12000);
            } // Originally we used Observable.webSocket, but it's fairly opinionated and I ended up writing
        },
        {
            key: "observableWebSocket",
            value: function observableWebSocket() {
                var _this10 = this;
                return $2Ioq1.Observable.create(function(subscriber) {
                    $dbdd077456dd22ff$var$konsole.log("creating WebSocket", _this10.streamUrl);
                    var ws = new _this10.services.WebSocket(_this10.streamUrl);
                    var sub;
                    var closed;
                    ws.onopen = function(open) {
                        $dbdd077456dd22ff$var$konsole.log("WebSocket open", open); // Chrome is pretty bad at noticing when a WebSocket connection is broken.
                        // If we periodically ping the server with empty messages, it helps Chrome
                        // realize when connection breaks, and close the socket. We then throw an
                        // error, and that give us the opportunity to attempt to reconnect.
                        sub = $2Ioq1.Observable.interval(_this10.timeout, _this10.services.scheduler).subscribe(function(_) {
                            try {
                                ws.send("");
                            } catch (e) {
                                $dbdd077456dd22ff$var$konsole.log("Ping error", e);
                            }
                        });
                    };
                    ws.onclose = function(close) {
                        $dbdd077456dd22ff$var$konsole.log("WebSocket close", close);
                        if (sub) sub.unsubscribe(); // RxJS.retryWhen has a bug that would cause "error" signal to be sent after the observable is completed/errored.
                        // We need to guard against extraneous "error" signal to workaround the bug.
                        closed || subscriber.error(close);
                        closed = true;
                    };
                    ws.onerror = function(error) {
                        $dbdd077456dd22ff$var$konsole.log("WebSocket error", error);
                        if (sub) sub.unsubscribe(); // RxJS.retryWhen has a bug that would cause "error" signal to be sent after the observable is completed/errored.
                        // We need to guard against extraneous "error" signal to workaround the bug.
                        closed || subscriber.error(error);
                        closed = true;
                    };
                    ws.onmessage = function(message) {
                        return message.data && subscriber.next(JSON.parse(message.data));
                    }; // This is the 'unsubscribe' method, which is called when this observable is disposed.
                    // When the WebSocket closes itself, we throw an error, and this function is eventually called.
                    // When the observable is closed first (e.g. when tearing down a WebChat instance) then
                    // we need to manually close the WebSocket.
                    return function() {
                        if (ws.readyState === 0 || ws.readyState === 1) ws.close();
                    };
                });
            }
        },
        {
            key: "reconnectToConversation",
            value: function reconnectToConversation() {
                var _this11 = this;
                return this.checkConnection(true).flatMap(function(_) {
                    return _this11.services.ajax({
                        method: "GET",
                        url: "".concat(_this11.domain, "/conversations/").concat(_this11.conversationId, "?watermark=").concat(_this11.watermark),
                        timeout: _this11.timeout,
                        headers: $dbdd077456dd22ff$var$_objectSpread({
                            "Accept": "application/json"
                        }, _this11.commonHeaders())
                    })["do"](function(result) {
                        if (!_this11.secret) _this11.token = result.response.token;
                        _this11.streamUrl = result.response.streamUrl;
                    }).map(function(_) {
                        return null;
                    }).retryWhen(function(error$) {
                        return error$.mergeMap(function(error) {
                            if (error.status === 403) // token has expired. We can't recover from this here, but the embedding
                            // website might eventually call reconnect() with a new token and streamUrl.
                            _this11.expiredToken();
                            else if (error.status === 404) return $2Ioq1.Observable["throw"]($dbdd077456dd22ff$var$errorConversationEnded, _this11.services.scheduler);
                            return $2Ioq1.Observable.of(error, _this11.services.scheduler);
                        }).delay(_this11.timeout, _this11.services.scheduler).take(_this11.retries);
                    });
                });
            }
        },
        {
            key: "commonHeaders",
            value: function commonHeaders() {
                return {
                    "Authorization": "Bearer ".concat(this.token),
                    "x-ms-bot-agent": this._botAgent
                };
            }
        },
        {
            key: "getBotAgent",
            value: function getBotAgent() {
                var customAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var clientAgent = "directlinejs";
                if (customAgent) clientAgent += "; ".concat(customAgent);
                return "".concat($dbdd077456dd22ff$var$DIRECT_LINE_VERSION, " (").concat(clientAgent, " ").concat("0.15.5", ")");
            }
        },
        {
            key: "setUserId",
            value: function setUserId(userId) {
                if (this.connectionStatus$.getValue() === $dbdd077456dd22ff$var$ConnectionStatus.Online) throw new Error("DirectLineJS: It is connected, we cannot set user id.");
                var userIdFromToken = this.parseToken(this.token);
                if (userIdFromToken) return console.warn("DirectLineJS: user id is already set in token, will ignore this user id.");
                if (/^dl_/.test(userId)) return console.warn('DirectLineJS: user id prefixed with "dl_" is reserved and must be embedded into the Direct Line token to prevent forgery.');
                this.userIdOnStartConversation = userId;
            }
        },
        {
            key: "parseToken",
            value: function parseToken(token) {
                try {
                    var _ref2 = (0, $dbdd077456dd22ff$var$_jwtDecode["default"])(token), user = _ref2.user;
                    return user;
                } catch (e) {
                    if (e instanceof $dbdd077456dd22ff$var$_jwtDecode.InvalidTokenError) return undefined;
                }
            }
        }
    ]);
    return DirectLine;
}();
$dbdd077456dd22ff$exports.DirectLine = $dbdd077456dd22ff$var$DirectLine;


var $126de8f2db9c4dbc$exports = {};
"use strict";
var $5cfcc0fad430f5d7$exports = {};
"use strict";
var $5cfcc0fad430f5d7$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $5cfcc0fad430f5d7$var$createStore = function createStore(createState) {
    return createState ? $5cfcc0fad430f5d7$var$createStoreImpl(createState) : $5cfcc0fad430f5d7$var$createStoreImpl;
};
var $5cfcc0fad430f5d7$var$vanilla = function(createState) {
    return $5cfcc0fad430f5d7$var$createStore(createState);
};
$5cfcc0fad430f5d7$exports.createStore = $5cfcc0fad430f5d7$var$createStore;
$5cfcc0fad430f5d7$exports.default = $5cfcc0fad430f5d7$var$vanilla;
$5cfcc0fad430f5d7$exports = $5cfcc0fad430f5d7$var$vanilla;
$5cfcc0fad430f5d7$exports.createStore = $5cfcc0fad430f5d7$var$createStore;
$5cfcc0fad430f5d7$exports.default = $5cfcc0fad430f5d7$exports;



var $lT7pJ = parcelRequire("lT7pJ");
var $ddb9606c76ba24fe$exports = {};
"use strict";

$ddb9606c76ba24fe$exports = (parcelRequire("k4mfS"));


var $126de8f2db9c4dbc$var$useDebugValue = $lT7pJ.useDebugValue;
var $126de8f2db9c4dbc$var$useSyncExternalStoreWithSelector = $ddb9606c76ba24fe$exports.useSyncExternalStoreWithSelector;
var $126de8f2db9c4dbc$var$didWarnAboutEqualityFn = false;
var $126de8f2db9c4dbc$var$identity = function identity(arg) {
    return arg;
};
function $126de8f2db9c4dbc$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $126de8f2db9c4dbc$var$identity;
    var slice = $126de8f2db9c4dbc$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $126de8f2db9c4dbc$var$useDebugValue(slice);
    return slice;
}
var $126de8f2db9c4dbc$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $5cfcc0fad430f5d7$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $126de8f2db9c4dbc$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $126de8f2db9c4dbc$var$create = function create(createState) {
    return createState ? $126de8f2db9c4dbc$var$createImpl(createState) : $126de8f2db9c4dbc$var$createImpl;
};
var $126de8f2db9c4dbc$var$react = function(createState) {
    return $126de8f2db9c4dbc$var$create(createState);
};
$126de8f2db9c4dbc$exports.create = $126de8f2db9c4dbc$var$create;
$126de8f2db9c4dbc$exports.default = $126de8f2db9c4dbc$var$react;
$126de8f2db9c4dbc$exports.useStore = $126de8f2db9c4dbc$var$useStore;
Object.keys($5cfcc0fad430f5d7$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($126de8f2db9c4dbc$exports, k)) Object.defineProperty($126de8f2db9c4dbc$exports, k, {
        enumerable: true,
        get: function() {
            return $5cfcc0fad430f5d7$exports[k];
        }
    });
});
$126de8f2db9c4dbc$exports = $126de8f2db9c4dbc$var$react;
$126de8f2db9c4dbc$exports.create = $126de8f2db9c4dbc$var$create;
$126de8f2db9c4dbc$exports.useStore = $126de8f2db9c4dbc$var$useStore;
$126de8f2db9c4dbc$exports.createStore = $5cfcc0fad430f5d7$exports.createStore;
$126de8f2db9c4dbc$exports.default = $126de8f2db9c4dbc$exports;




const $1bda010252da638c$var$initialState = {
    fullScreenImage: undefined,
    lastListActivity: undefined,
    listClosed: false,
    listOpened: false,
    currentSubView: (0, $45d43a6de0968f42$export$f05d0fed0593ead7).none,
    currentCustomView: undefined,
    retorikEvent: undefined,
    displayAgent: true,
    activityToSend: undefined,
    currentNewsActivity: undefined,
    retorikNewsEnded: false,
    userIsTyping: false,
    userIsSwiping: false,
    askedForKioskParametersOpening: false,
    detailedAttachmentTriggers: [
        {
            type: "event",
            name: "hospitality.ShowPointOfInterest",
            linkedComponent: null
        },
        {
            type: "event",
            name: "hospitality.ShowContentItem",
            linkedComponent: null
        }
    ],
    modalFullscreenContent: null,
    printingCallback: null,
    GDPRDisplay: true,
    GDPRWindowData: undefined,
    GDPRUserConsent: false,
    unlockClickedButton: false,
    dashboardOpened: false
};
let $1bda010252da638c$var$timer = null;
const $1bda010252da638c$export$77e4cc5334565f28 = (0, $126de8f2db9c4dbc$exports.create)()(()=>{
    return $1bda010252da638c$var$initialState;
});
const $1bda010252da638c$export$4e062bd31c814155 = (src)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        fullScreenImage: src
    });
};
const $1bda010252da638c$export$e2194ce98b9711c9 = (id)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        lastListActivity: id
    });
};
const $1bda010252da638c$export$f03cfde7db70aa27 = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        listClosed: value
    });
};
const $1bda010252da638c$export$324bf243c7501c4d = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        listOpened: value
    });
};
const $1bda010252da638c$export$f0c096b4ecd7115d = (subview)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        currentSubView: subview
    });
};
const $1bda010252da638c$export$5a678fd51bd89633 = (customView)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        currentCustomView: customView
    });
};
const $1bda010252da638c$export$dcb32d000c0e0280 = (event)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        retorikEvent: event
    });
};
const $1bda010252da638c$export$ae67eb518a2aae74 = ()=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        displayAgent: true
    });
};
const $1bda010252da638c$export$e73dbd7ba351e3e = ()=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        displayAgent: false
    });
};
const $1bda010252da638c$export$d4c8c6daac289378 = (activity)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        activityToSend: activity
    });
};
const $1bda010252da638c$export$b5caa30733bcf64f = (activity)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        currentNewsActivity: activity
    });
};
const $1bda010252da638c$export$f052bdc826bb4a9e = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        retorikNewsEnded: value
    });
};
const $1bda010252da638c$export$4a471cf3284fc492 = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        userIsTyping: value
    });
};
const $1bda010252da638c$export$19e9368606a5170f = ()=>{
    $1bda010252da638c$var$timer && clearTimeout($1bda010252da638c$var$timer);
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        userIsSwiping: true
    });
    // Switch back to false after 2.5s (because test for typing indicator is done every 2s)
    $1bda010252da638c$var$timer = setTimeout(()=>{
        $1bda010252da638c$export$77e4cc5334565f28.setState({
            userIsSwiping: false
        });
    }, 2500);
};
const $1bda010252da638c$export$61008920e70c5e8a = ()=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        askedForKioskParametersOpening: true
    });
    setTimeout(()=>{
        $1bda010252da638c$export$77e4cc5334565f28.setState({
            askedForKioskParametersOpening: false
        });
    }, 50);
};
const $1bda010252da638c$export$d1f60bb847ecc604 = (value)=>{
    const currentTriggers = $1bda010252da638c$export$77e4cc5334565f28.getState().detailedAttachmentTriggers;
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        detailedAttachmentTriggers: [
            ...currentTriggers,
            value
        ]
    });
};
const $1bda010252da638c$export$4317154639841e84 = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        modalFullscreenContent: value
    });
};
const $1bda010252da638c$export$7f09d7ad7dbdcd2c = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        printingCallback: value
    });
};
const $1bda010252da638c$export$ff26692bd8e0fbbd = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        GDPRDisplay: value
    });
};
const $1bda010252da638c$export$2d640df2114a2d77 = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        GDPRWindowData: value
    });
};
const $1bda010252da638c$export$7a09e6b3c59f37ad = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        GDPRUserConsent: value
    });
};
const $1bda010252da638c$export$e49d67c72fb28d58 = ()=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        unlockClickedButton: true
    });
};
const $1bda010252da638c$export$5d55805fc8a86c05 = ()=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        unlockClickedButton: false
    });
};
const $1bda010252da638c$export$bbd7c92fc378d660 = (value)=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        dashboardOpened: value
    });
};
const $1bda010252da638c$export$93b55f822ac81934 = ()=>{
    $1bda010252da638c$export$77e4cc5334565f28.setState({
        ...$1bda010252da638c$var$initialState
    });
};





const $b8685bd729fa723f$var$initialState = {
    ponyfillCredentials: undefined,
    useContinuousRecognition: false,
    customVoice: undefined,
    voice: null,
    speaking: false,
    muted: false,
    cancel: false,
    boundaryData: [],
    currentReplyToId: undefined,
    currentPlaying: undefined,
    endedActivities: [],
    currentOrLastPlayedActivity: undefined,
    activeRecognitionState: (0, $45d43a6de0968f42$export$3f0071308968cd80).Closed,
    lastRecognitionInterim: "",
    streamingReplyToId: null,
    streamingQueue: [],
    streamingQueueForText: [],
    currentStreaming: null,
    streamingQueueFullLength: 0,
    streamingReplyToIdToIgnore: null,
    speechRecognitionDynamicGrammars: []
};
const $b8685bd729fa723f$export$f299240efcda25a2 = (0, $126de8f2db9c4dbc$exports.create)()(()=>{
    return $b8685bd729fa723f$var$initialState;
});
const $b8685bd729fa723f$export$3a8619c6095469fa = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        ponyfillCredentials: value
    });
};
const $b8685bd729fa723f$export$7161ba896835b3cd = (deviceType, options)=>{
    if (options?.enableContinuousRecognitionOnAllDevices) $b8685bd729fa723f$export$f299240efcda25a2.setState({
        useContinuousRecognition: true
    });
    else if (options?.enableContinuousRecognitionOn) switch(deviceType){
        case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile:
            $b8685bd729fa723f$export$f299240efcda25a2.setState({
                useContinuousRecognition: !!options.enableContinuousRecognitionOn.mobile
            });
            break;
        case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget:
            $b8685bd729fa723f$export$f299240efcda25a2.setState({
                useContinuousRecognition: !!options.enableContinuousRecognitionOn.widget
            });
            break;
        case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).landscape:
            $b8685bd729fa723f$export$f299240efcda25a2.setState({
                useContinuousRecognition: !!options.enableContinuousRecognitionOn.desktop
            });
            break;
        case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).borne:
            $b8685bd729fa723f$export$f299240efcda25a2.setState({
                useContinuousRecognition: !!options.enableContinuousRecognitionOn.borne
            });
            break;
        default:
            $b8685bd729fa723f$export$f299240efcda25a2.setState({
                useContinuousRecognition: false
            });
            break;
    }
    else $b8685bd729fa723f$export$f299240efcda25a2.setState({
        useContinuousRecognition: false
    });
};
const $b8685bd729fa723f$export$1311646333d3dfee = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        customVoice: value
    });
};
const $b8685bd729fa723f$export$f7fa6f9f21f4683c = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        voice: value
    });
};
const $b8685bd729fa723f$export$f5e94301cb5ae54b = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        speaking: value
    });
    (0, $1bda010252da638c$export$dcb32d000c0e0280)(value ? (0, $45d43a6de0968f42$export$4f7cd669585dc69f).SpeechStarted : (0, $45d43a6de0968f42$export$4f7cd669585dc69f).SpeechEnded);
};
const $b8685bd729fa723f$export$a1680ba91cc9be33 = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        muted: value
    });
};
const $b8685bd729fa723f$export$d0df6aec4e971f52 = (cancel)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        cancel: cancel
    });
};
const $b8685bd729fa723f$export$c24886139fddc386 = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        boundaryData: value
    });
};
const $b8685bd729fa723f$export$96a5fb7d9bf39b8a = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        currentReplyToId: value
    });
};
const $b8685bd729fa723f$export$b03f86112d469252 = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        currentPlaying: value
    });
    value && $b8685bd729fa723f$export$babd960d95248836(value);
};
const $b8685bd729fa723f$export$7cbdb517d05b0ba6 = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        endedActivities: value
    });
};
const $b8685bd729fa723f$export$babd960d95248836 = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        currentOrLastPlayedActivity: value
    });
};
const $b8685bd729fa723f$export$45913366c4ba414f = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        activeRecognitionState: value
    });
};
const $b8685bd729fa723f$export$a5c8d6d0ec4b5ccb = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        lastRecognitionInterim: value
    });
};
const $b8685bd729fa723f$export$614a80601162ec38 = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        streamingReplyToId: value
    });
};
const $b8685bd729fa723f$export$87afd75c41a617d7 = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        streamingQueue: value,
        streamingQueueForText: value
    });
};
const $b8685bd729fa723f$export$9a026d007e335fc0 = (value)=>{
    const idToIgnore = $b8685bd729fa723f$export$f299240efcda25a2.getState().streamingReplyToIdToIgnore;
    if (value.replyToId && value.replyToId !== idToIgnore) {
        // Set replyToId and new queue if replyToId is different from the current one
        if ($b8685bd729fa723f$export$f299240efcda25a2.getState().streamingReplyToId !== value.replyToId) $b8685bd729fa723f$export$f299240efcda25a2.setState({
            streamingQueueFullLength: 0,
            streamingReplyToId: value.replyToId,
            streamingQueue: [
                value
            ],
            streamingQueueForText: [
                value
            ]
        });
        else $b8685bd729fa723f$export$f299240efcda25a2.setState({
            streamingQueue: [
                ...$b8685bd729fa723f$export$f299240efcda25a2.getState().streamingQueue,
                value
            ],
            streamingQueueForText: [
                ...$b8685bd729fa723f$export$f299240efcda25a2.getState().streamingQueueForText,
                value
            ]
        });
    }
};
const $b8685bd729fa723f$export$eb50624bfd363865 = ()=>{
    const currentQueue = [
        ...$b8685bd729fa723f$export$f299240efcda25a2.getState().streamingQueue
    ];
    if (currentQueue.length) {
        currentQueue.splice(0, 1);
        $b8685bd729fa723f$export$f299240efcda25a2.setState({
            streamingQueue: [
                ...currentQueue
            ]
        });
    }
};
const $b8685bd729fa723f$export$8505d436556ca045 = (replyToId)=>{
    const currentId = $b8685bd729fa723f$export$f299240efcda25a2.getState().streamingReplyToId;
    currentId !== replyToId && $b8685bd729fa723f$export$c3296e37e9ef3fed();
};
const $b8685bd729fa723f$export$c3296e37e9ef3fed = ()=>{
    const currentId = $b8685bd729fa723f$export$f299240efcda25a2.getState().streamingReplyToId;
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        streamingReplyToId: null,
        streamingQueue: [],
        streamingQueueForText: [],
        currentStreaming: null,
        streamingQueueFullLength: 0,
        streamingReplyToIdToIgnore: currentId
    });
};
const $b8685bd729fa723f$export$d300d9470f5679ba = (value)=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        currentStreaming: value
    });
};
const $b8685bd729fa723f$export$e9ca045daeb00700 = (value, replyToId)=>{
    if (replyToId) {
        const currentStreamingId = $b8685bd729fa723f$export$f299240efcda25a2.getState().streamingReplyToId;
        replyToId === currentStreamingId && $b8685bd729fa723f$export$f299240efcda25a2.setState({
            streamingQueueFullLength: value
        });
    } else $b8685bd729fa723f$export$f299240efcda25a2.setState({
        streamingQueueFullLength: value
    });
};
const $b8685bd729fa723f$export$ec8986cae5ae5c2 = (value)=>{
    const currentGrammars = $b8685bd729fa723f$export$f299240efcda25a2.getState().speechRecognitionDynamicGrammars;
    // For each value, verifiy if it doesn't exist in the array yet
    if (Array.isArray(value)) {
        const valuesToAdd = [];
        value.forEach((val)=>{
            !currentGrammars.includes(val) && valuesToAdd.push(val);
        });
        valuesToAdd.length && $b8685bd729fa723f$export$f299240efcda25a2.setState({
            speechRecognitionDynamicGrammars: [
                ...currentGrammars,
                ...valuesToAdd
            ]
        });
    } else !currentGrammars.includes(value) && $b8685bd729fa723f$export$f299240efcda25a2.setState({
        speechRecognitionDynamicGrammars: [
            ...currentGrammars,
            value
        ]
    });
};
const $b8685bd729fa723f$export$b6d2196a3ce412d8 = ()=>{
    $b8685bd729fa723f$export$f299240efcda25a2.setState({
        ...$b8685bd729fa723f$var$initialState
    });
};






var // Get data from the json file located at the root of the folder at the address agentUrl
$2d2488a454cc7d3d$export$2e2bcd8739ae039 = async (agentUrl)=>{
    const responseData = await fetch(`${agentUrl}/manifest.json`).then((data)=>{
        return data.json();
    }).then((json)=>{
        return json;
    }).catch((error)=>{
        console.log(error);
        return null;
    });
    // Set urls to retrieve the animations and a portrait of the agent
    if (responseData !== null) {
        responseData.url = agentUrl;
        responseData.portrait = agentUrl + "/" + responseData.portrait;
    }
    return responseData;
};


const $7c69764370dcab43$var$defaultConfiguration = {
    subtitles: false
};
const $7c69764370dcab43$var$initialState = {
    configuration: $7c69764370dcab43$var$defaultConfiguration,
    addressData: {},
    canFocusSendBox: false,
    sendBoxRef: null,
    mode: (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text,
    baseAddress: "",
    subtitlesInConfiguration: false,
    displaySubtitles: false,
    agentData: undefined,
    loaderClosed: false,
    appAvailable: false,
    currentLayout: (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).agent,
    userAlreadySet: false,
    disableSound: false,
    isWaitingForResponse: false,
    skipLoader: false
};
let $7c69764370dcab43$var$timer = null;
const $7c69764370dcab43$export$bd22554f31e5f96f = (0, $126de8f2db9c4dbc$exports.create)()(()=>{
    return $7c69764370dcab43$var$initialState;
});
const $7c69764370dcab43$export$6a52175581b4d614 = (value)=>{
    console.log("Config change : ", value);
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        configuration: value
    });
};
const $7c69764370dcab43$export$8a3fb5da57940bc2 = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        addressData: value
    });
};
const $7c69764370dcab43$export$c26f98e9bd86d3e3 = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        sendBoxRef: value
    });
};
const $7c69764370dcab43$export$991fe9f1cce98a4b = ()=>{
    const sendBox = $7c69764370dcab43$export$bd22554f31e5f96f.getState().sendBoxRef;
    sendBox && document.activeElement !== sendBox && sendBox.focus();
};
const $7c69764370dcab43$export$bea4f7bfbef5d31e = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        canFocusSendBox: value
    });
};
const $7c69764370dcab43$export$ca8db8ed18ea1d2c = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        disableSound: value
    });
};
const $7c69764370dcab43$export$e8437af1f2483b8e = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        currentLayout: value
    });
};
const $7c69764370dcab43$export$702dee93694750db = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        userAlreadySet: value
    });
};
const $7c69764370dcab43$export$d4f039427a1beff1 = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        mode: value
    });
    $7c69764370dcab43$export$bd22554f31e5f96f.getState().subtitlesInConfiguration ? $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        displaySubtitles: true
    }) : $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        displaySubtitles: false
    });
    (0, $1bda010252da638c$export$e2194ce98b9711c9)(undefined);
    value !== (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text && (0, $1bda010252da638c$export$4a471cf3284fc492)(false);
    !$7c69764370dcab43$export$bd22554f31e5f96f.getState().disableSound && (0, $b8685bd729fa723f$export$a1680ba91cc9be33)(value === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text);
};
const $7c69764370dcab43$export$f70ece17ecf700a3 = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        baseAddress: value
    });
};
const $7c69764370dcab43$export$982d69b78a955aaf = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        loaderClosed: value
    });
};
const $7c69764370dcab43$export$a8ce9bbc5b910a21 = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        appAvailable: value
    });
};
const $7c69764370dcab43$export$f9f752f8a699b258 = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        subtitlesInConfiguration: value
    });
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        displaySubtitles: value && $7c69764370dcab43$export$bd22554f31e5f96f.getState().mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal
    });
};
const $7c69764370dcab43$export$708f3eb1d5828832 = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        displaySubtitles: value
    });
};
const $7c69764370dcab43$export$a72b80ff363563a1 = async (value)=>{
    const url = typeof value === "string" ? value : value.url;
    const data = await (0, $2d2488a454cc7d3d$export$2e2bcd8739ae039)(url);
    if (data) typeof value !== "string" && value.name && (data.name = value.name);
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        agentData: data
    });
};
const $7c69764370dcab43$export$b468e470fbb95f20 = (value)=>{
    if (value) !$7c69764370dcab43$var$timer && ($7c69764370dcab43$var$timer = setTimeout(()=>{
        $7c69764370dcab43$export$bd22554f31e5f96f.setState({
            isWaitingForResponse: value
        });
        $7c69764370dcab43$var$timer = null;
    }, 1000));
    else {
        $7c69764370dcab43$var$timer && clearTimeout($7c69764370dcab43$var$timer);
        $7c69764370dcab43$var$timer = null;
        $7c69764370dcab43$export$bd22554f31e5f96f.setState({
            isWaitingForResponse: value
        });
    }
};
const $7c69764370dcab43$export$575f08cc5f3ecd43 = (value)=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        skipLoader: value
    });
};
const $7c69764370dcab43$export$cd85ac4858c7290c = ()=>{
    $7c69764370dcab43$export$bd22554f31e5f96f.setState({
        ...$7c69764370dcab43$var$initialState
    });
};



var $d97a7c55f35040d9$exports = {};
"use strict";
var $d97a7c55f35040d9$var$__createBinding = $d97a7c55f35040d9$exports && $d97a7c55f35040d9$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d97a7c55f35040d9$var$__exportStar = $d97a7c55f35040d9$exports && $d97a7c55f35040d9$exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) $d97a7c55f35040d9$var$__createBinding(exports, m, p);
};
Object.defineProperty($d97a7c55f35040d9$exports, "__esModule", {
    value: true
});

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
$d97a7c55f35040d9$var$__exportStar((parcelRequire("luP4B")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("4uYwi")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("krmaK")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("6EfR6")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("dA5cX")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("8Pqcb")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("icYWo")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("4TaX1")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("hj3le")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("iBTKZ")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("5TiFc")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("3ojaG")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("hSHFV")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("3iICS")), $d97a7c55f35040d9$exports);

$d97a7c55f35040d9$var$__exportStar((parcelRequire("l4BEw")), $d97a7c55f35040d9$exports);


const $1b9b52b7d47c361d$var$color = "#00D7FF";
const $1b9b52b7d47c361d$var$white = "#F7F3F6";
const $1b9b52b7d47c361d$export$d30af3ec38729f1 = {
    hostCapabilities: {
        capabilities: null
    },
    choiceSetInputValueSeparator: ",",
    supportsInteractivity: true,
    fontTypes: {
        default: {
            fontFamily: '"Helvetica Neue", sans-serif',
            fontSizes: {
                small: 12,
                default: 16,
                medium: 20,
                large: 26,
                extraLarge: 33
            },
            fontWeights: {
                lighter: 200,
                default: 300,
                bolder: 400
            }
        },
        monospace: {
            fontFamily: '"Helvetica Neue", sans-serif',
            fontSizes: {
                small: 12,
                default: 16,
                medium: 20,
                large: 26,
                extraLarge: 33
            },
            fontWeights: {
                lighter: 200,
                default: 300,
                bolder: 400
            }
        }
    },
    spacing: {
        small: 8,
        default: 16,
        medium: 20,
        large: 30,
        extraLarge: 40,
        padding: 25
    },
    separator: {
        lineThickness: 1,
        lineColor: "transparent"
    },
    imageSizes: {
        small: 40,
        medium: 100,
        large: 160
    },
    containerStyles: {
        default: {
            foregroundColors: {
                default: {
                    default: `${$1b9b52b7d47c361d$var$white}`,
                    subtle: `${$1b9b52b7d47c361d$var$color}`,
                    highlightColors: {
                        default: `${$1b9b52b7d47c361d$var$color}`,
                        subtle: "#11000000"
                    }
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                accent: {
                    default: "#0063B1",
                    subtle: "#0063B1",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                good: {
                    default: "#54a254",
                    subtle: "#DD54a254",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                warning: {
                    default: "#c3ab23",
                    subtle: "#DDc3ab23",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                attention: {
                    default: "#FF0000",
                    subtle: "#DDFF0000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                }
            },
            backgroundColor: "transparent"
        },
        emphasis: {
            foregroundColors: {
                default: {
                    default: "#000000",
                    subtle: "#767676",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                dark: {
                    default: "#000000",
                    subtle: "#66000000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                light: {
                    default: "#FFFFFF",
                    subtle: "#33000000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                accent: {
                    default: "#2E89FC",
                    subtle: "#882E89FC",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                good: {
                    default: "#54a254",
                    subtle: "#DD54a254",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                warning: {
                    default: "#c3ab23",
                    subtle: "#DDc3ab23",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                },
                attention: {
                    default: "#FF0000",
                    subtle: "#DDFF0000",
                    highlightColors: {
                        default: "#22000000",
                        subtle: "#11000000"
                    }
                }
            },
            backgroundColor: "#F0F0F0"
        }
    },
    actions: {
        maxActions: 100,
        spacing: "Default",
        buttonSpacing: 0,
        showCard: {
            actionMode: "Inline",
            inlineTopMargin: 8,
            style: "emphasis"
        },
        preExpandSingleShowCardAction: false,
        actionsOrientation: "vertical",
        actionAlignment: "left",
        wrap: true
    },
    adaptiveCard: {
        allowCustomStyle: true
    },
    imageSet: {
        maxImageHeight: 100
    },
    media: {
        allowInlinePlayback: true
    },
    factSet: {
        title: {
            size: "Default",
            color: `${$1b9b52b7d47c361d$var$color}`,
            isSubtle: false,
            weight: "Bolder",
            wrap: true
        },
        value: {
            size: "Default",
            color: `${$1b9b52b7d47c361d$var$color}`,
            isSubtle: false,
            weight: "Default",
            wrap: true
        },
        spacing: 1000
    },
    cssClassNamePrefix: null,
    _legacyFontType: {
        fontFamily: "Helvetica Neue,sans-serif",
        fontSizes: {
            small: 12,
            default: 16,
            medium: 20,
            large: 26,
            extraLarge: 33
        },
        fontWeights: {
            lighter: 200,
            default: 400,
            bolder: 600
        }
    }
};


const $f14ca63c6a8d72ec$var$createAdaptiveCardHostConfig = (primary, cardBackground)=>{
    const template = (0, $1b9b52b7d47c361d$export$d30af3ec38729f1);
    template.containerStyles.default.foregroundColors.default.default = primary;
    template.containerStyles.default.backgroundColor = cardBackground;
    return template;
};
var $f14ca63c6a8d72ec$export$2e2bcd8739ae039 = $f14ca63c6a8d72ec$var$createAdaptiveCardHostConfig;


const $649c384b79ea2395$var$initialState = {
    adaptiveCardHostConfig: {},
    values: new Map(),
    currentId: undefined,
    currentToggleIds: [],
    currentValue: undefined,
    handleButtonClick: ()=>{}
};
const $649c384b79ea2395$export$a8a6e22a57e6f7d2 = (0, $126de8f2db9c4dbc$exports.create)()(()=>{
    return $649c384b79ea2395$var$initialState;
});
const $649c384b79ea2395$export$3d9e022b11902996 = (primary, background)=>{
    const customAdaptiveCardHostConfig = (0, $f14ca63c6a8d72ec$export$2e2bcd8739ae039)(primary, background);
    $649c384b79ea2395$export$a8a6e22a57e6f7d2.setState({
        adaptiveCardHostConfig: new (0, $d97a7c55f35040d9$exports.HostConfig)(customAdaptiveCardHostConfig)
    });
};
const $649c384b79ea2395$export$80746c6bc6142fc8 = (id, value)=>{
    console.log("Set value : ", id, value);
    const currentState = $649c384b79ea2395$export$a8a6e22a57e6f7d2.getState();
    if (id === currentState.currentId) {
        const currentValues = currentState.values;
        currentValues.set(id, value);
        $649c384b79ea2395$export$a8a6e22a57e6f7d2.setState({
            values: currentValues,
            currentValue: {
                [id]: value
            }
        });
    }
};
const $649c384b79ea2395$export$7fc8a028c7b38ace = (id, value)=>{
    const currentState = $649c384b79ea2395$export$a8a6e22a57e6f7d2.getState();
    if (currentState.currentToggleIds.includes(id)) {
        const currentValues = currentState.values;
        currentValues.set(id, value);
        const tempCurrentValue = currentState.currentValue || {};
        currentState.currentToggleIds.forEach((id)=>{
            const value = currentValues.get(id) || false;
            tempCurrentValue[id] = value;
        });
        $649c384b79ea2395$export$a8a6e22a57e6f7d2.setState({
            values: currentValues,
            currentValue: tempCurrentValue
        });
    }
};
const $649c384b79ea2395$export$a619c8fe018044c1 = (value)=>{
    $649c384b79ea2395$export$a8a6e22a57e6f7d2.setState({
        currentId: value
    });
    $649c384b79ea2395$export$98afaee6b1c7ef60();
};
const $649c384b79ea2395$export$ff456dc518e4aa26 = (id, defaultValue)=>{
    const currentState = $649c384b79ea2395$export$a8a6e22a57e6f7d2.getState();
    const currentValues = currentState.values;
    const currentToggleIds = currentState.currentToggleIds;
    currentValues.set(id, defaultValue);
    $649c384b79ea2395$export$a8a6e22a57e6f7d2.setState({
        values: currentValues,
        currentToggleIds: [
            ...currentToggleIds,
            id
        ]
    });
};
const $649c384b79ea2395$export$98afaee6b1c7ef60 = ()=>{
    $649c384b79ea2395$export$a8a6e22a57e6f7d2.setState({
        currentValue: undefined,
        currentToggleIds: []
    });
};
const $649c384b79ea2395$export$64bb98402f29970 = ()=>{
    $649c384b79ea2395$export$a8a6e22a57e6f7d2.setState({
        ...$649c384b79ea2395$var$initialState
    });
};







const $cf20bc7a6d166273$export$4aebf65ed07cf17b = {
    rgb: "rgb(112, 112, 112)"
};
const $cf20bc7a6d166273$export$d80fe84b82195dbd = {
    ...(0, $bbe458fac496c294$export$c0da64553318f2cb),
    companyName: "#000",
    loader: {
        animation: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
        background: "rgba(18,18,18,0.7)",
        text: "#FFF",
        toggle: {
            text: "#000",
            background: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            }
        }
    },
    card: {
        frame: {
            background: "#2B2B2B",
            border: "transparent",
            text: "#F7F3F6"
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            }
        },
        discoverButton: {
            background: {
                default: "#eaebf0",
                hover: "transparent"
            },
            border: {
                default: "transparent",
                hover: "#FFF"
            },
            text: {
                default: "#575F6B",
                hover: "#FFF"
            }
        }
    },
    textMode: {
        panel: {
            background: "rgba(255, 255, 255, 0.9)",
            border: "transparent",
            conversationUser: "#101219",
            conversationBot: "#1999B1"
        }
    },
    vocalMode: {
        subtitles: {
            text: "#FFF",
            background: "#000"
        }
    },
    formInput: {
        text: {
            default: (0, $bbe458fac496c294$export$c0da64553318f2cb).secondary,
            hover: "#FFF"
        },
        inputRadioCheckbox: {
            unchecked: {
                background: "#434141",
                border: "#818181"
            },
            checked: {
                background: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                border: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                item: "#000"
            }
        },
        inputButton: {
            background: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).black,
                hover: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary
            },
            border: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: "#FFF",
                hover: "#FFF"
            }
        },
        likert: {
            default: "transparent",
            hover: "#E8B712"
        }
    }
};
const $cf20bc7a6d166273$export$1196b7bf97f3d16c = {
    ...(0, $bbe458fac496c294$export$c0da64553318f2cb),
    companyName: "#000",
    loader: {
        animation: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
        background: "rgba(18,18,18,0.7)",
        text: "#FFF",
        toggle: {
            text: "#000",
            background: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            }
        }
    },
    card: {
        frame: {
            background: "#2B2B2B",
            border: "transparent",
            text: "#F7F3F6"
        },
        button: {
            background: {
                default: "transparent",
                hover: "transparent"
            },
            border: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            }
        },
        discoverButton: {
            background: {
                default: "#eaebf0",
                hover: "transparent"
            },
            border: {
                default: "transparent",
                hover: "#FFF"
            },
            text: {
                default: "#575F6B",
                hover: "#FFF"
            }
        }
    },
    textMode: {
        panel: {
            background: "rgba(255, 255, 255, 0.9)",
            border: "transparent",
            conversationUser: "#101219",
            conversationBot: "#1999B1"
        }
    },
    vocalMode: {
        subtitles: {
            text: "#FFF",
            background: "#000"
        }
    },
    formInput: {
        text: {
            default: (0, $bbe458fac496c294$export$c0da64553318f2cb).secondary,
            hover: "#FFF"
        },
        inputRadioCheckbox: {
            unchecked: {
                background: "#434141",
                border: "#818181"
            },
            checked: {
                background: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                border: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                item: "#000"
            }
        },
        inputButton: {
            background: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).black,
                hover: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary
            },
            border: {
                default: (0, $bbe458fac496c294$export$c0da64553318f2cb).primary,
                hover: "#FFF"
            },
            text: {
                default: "#FFF",
                hover: "#FFF"
            }
        },
        likert: {
            default: "transparent",
            hover: "#E8B712"
        }
    }
};


const $1c9be018817ca3e3$var$defaultConfiguration = {
    homeRoute: "home",
    views: {
        home: {
            background: {
                image: "",
                style: "image"
            }
        }
    }
};
const $1c9be018817ca3e3$var$initialState = {
    currentDeviceType: (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile,
    isMobile: false,
    isWidget: false,
    isLandscape: true,
    isBorne: false,
    themeColors: (0, $cf20bc7a6d166273$export$d80fe84b82195dbd),
    configurations: $1c9be018817ca3e3$var$defaultConfiguration,
    route: (0, $45d43a6de0968f42$export$3565eb3d00ca5a74).Home,
    currentHeight: 1080,
    currentWidth: 1920,
    isTactile: "ontouchstart" in window || navigator.maxTouchPoints > 0,
    isMobileLandscape: false,
    displayControls: true,
    showHomeAttachments: undefined,
    mediumLandscape: false
};
const $1c9be018817ca3e3$export$d13b2577cb75f2ad = (0, $126de8f2db9c4dbc$exports.create)()(()=>{
    return $1c9be018817ca3e3$var$initialState;
});
const $1c9be018817ca3e3$export$1ae69652bfc21d9e = (value)=>{
    $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        currentDeviceType: value,
        isMobile: (0, $bbe458fac496c294$export$78f16669b353a880).includes(value),
        isWidget: (0, $bbe458fac496c294$export$909f4c209eb70365).includes(value),
        isLandscape: (0, $bbe458fac496c294$export$baf53ca377ebf861).includes(value),
        isBorne: (0, $bbe458fac496c294$export$a8576d98c9c928de).includes(value)
    });
    $1c9be018817ca3e3$var$checkMobileLandscape();
};
const $1c9be018817ca3e3$export$2eb835c7cd21b3a5 = (value)=>{
    (0, $649c384b79ea2395$export$3d9e022b11902996)(value.primary, value.card.frame.background);
    $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        themeColors: value
    });
};
const $1c9be018817ca3e3$export$2115da3e844dc899 = (value)=>{
    $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        route: value
    });
};
const $1c9be018817ca3e3$export$bdf2213fff3cbdda = (value)=>{
    $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        configurations: value
    });
};
const $1c9be018817ca3e3$var$checkMobileLandscape = ()=>{
    const currentState = $1c9be018817ca3e3$export$d13b2577cb75f2ad.getState();
    if (currentState.currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile && currentState.currentHeight < currentState.currentWidth) $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        isMobileLandscape: true
    });
    else $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        isMobileLandscape: false
    });
};
const $1c9be018817ca3e3$export$7543d510ab87805c = (value)=>{
    $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        currentHeight: value
    });
    $1c9be018817ca3e3$var$checkMobileLandscape();
};
const $1c9be018817ca3e3$export$98fe782f0784b2c2 = (value)=>{
    $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        currentWidth: value,
        mediumLandscape: value < (0, $bbe458fac496c294$export$91e4bf93df95a062)
    });
    $1c9be018817ca3e3$var$checkMobileLandscape();
};
const $1c9be018817ca3e3$export$5d6d98eff8e04581 = (value)=>{
    $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        displayControls: value
    });
};
const $1c9be018817ca3e3$export$a6540370871e3c67 = (value)=>{
    $1c9be018817ca3e3$export$d13b2577cb75f2ad.setState({
        showHomeAttachments: value
    });
};


const $59de7fd3862e5431$export$bbfd0bb0baceb2f8 = "application/vnd.microsoft.card.adaptive";
const $59de7fd3862e5431$export$264354e75632a3ba = "application/vnd.microsoft.card.hero";
const $59de7fd3862e5431$export$7ff82c027074e396 = "application/vnd.davi.retorik.card.news";
const $59de7fd3862e5431$export$8c612ad42a82284 = "application/vnd.davi.retorik.card.poi";
const $59de7fd3862e5431$export$9399f66a54c38cac = "application/vnd.davi.retorik.card.empty";
const $59de7fd3862e5431$export$c50891df8986f6d9 = "application/vnd.davi.retorik.card.image";
const $59de7fd3862e5431$export$cce25171fe980112 = "application/vnd.davi.retorik.card.link";
const $59de7fd3862e5431$export$8ebd8d161896e63a = "application/vnd.davi.retorik.card.discover";
const $59de7fd3862e5431$export$a4f2f23a67537f78 = "application/vnd.davi.retorik.card.suggestion";
const $59de7fd3862e5431$export$2730c89e9ebd0948 = "application/vnd.davi.retorik.card.suggestedaction";
const $59de7fd3862e5431$export$25f48dcc671a4afe = "application/vnd.davi.retorik.card.grid";
const $59de7fd3862e5431$export$98515f55cf51a42d = "application/vnd.davi.retorik.card.tile";
const $59de7fd3862e5431$export$8180494a68c87622 = "application/vnd.davi.retorik.grid.title";



// Main parser class
var $e0c8ff411ba71ee2$exports = {};

$parcel$export($e0c8ff411ba71ee2$exports, "isString", () => $e0c8ff411ba71ee2$export$844ec244b1367d54);
$parcel$export($e0c8ff411ba71ee2$exports, "has", () => $e0c8ff411ba71ee2$export$a4f4bb6b1453fff5);
$parcel$export($e0c8ff411ba71ee2$exports, "assign", () => $e0c8ff411ba71ee2$export$e6e34fd1f2686227);
$parcel$export($e0c8ff411ba71ee2$exports, "arrayReplaceAt", () => $e0c8ff411ba71ee2$export$f78478f71955b6bc);
$parcel$export($e0c8ff411ba71ee2$exports, "isValidEntityCode", () => $e0c8ff411ba71ee2$export$644a8f5b13b2a36d);
$parcel$export($e0c8ff411ba71ee2$exports, "fromCodePoint", () => $e0c8ff411ba71ee2$export$73bfc63873071f74);
$parcel$export($e0c8ff411ba71ee2$exports, "unescapeMd", () => $e0c8ff411ba71ee2$export$5ccde1ea0c14bb03);
$parcel$export($e0c8ff411ba71ee2$exports, "unescapeAll", () => $e0c8ff411ba71ee2$export$db8a17c6655f7e2c);
$parcel$export($e0c8ff411ba71ee2$exports, "escapeHtml", () => $e0c8ff411ba71ee2$export$4cf11838cdc2a8a8);
$parcel$export($e0c8ff411ba71ee2$exports, "escapeRE", () => $e0c8ff411ba71ee2$export$bc616c8f7dc20d5d);
$parcel$export($e0c8ff411ba71ee2$exports, "isSpace", () => $e0c8ff411ba71ee2$export$1d5ccafae59b4926);
$parcel$export($e0c8ff411ba71ee2$exports, "isWhiteSpace", () => $e0c8ff411ba71ee2$export$3c52dd84024ae72c);
$parcel$export($e0c8ff411ba71ee2$exports, "isPunctChar", () => $e0c8ff411ba71ee2$export$4888a643af800fc1);
$parcel$export($e0c8ff411ba71ee2$exports, "isMdAsciiPunct", () => $e0c8ff411ba71ee2$export$829a0d33ae4e744);
$parcel$export($e0c8ff411ba71ee2$exports, "normalizeReference", () => $e0c8ff411ba71ee2$export$20ef46802c8744b);
$parcel$export($e0c8ff411ba71ee2$exports, "lib", () => $e0c8ff411ba71ee2$export$16c08b91f883959a);
// Utilities
//
var $65303f524e7150e5$exports = {};

$parcel$export($65303f524e7150e5$exports, "decode", () => $c84d8e4f87730cff$export$2e2bcd8739ae039);
$parcel$export($65303f524e7150e5$exports, "encode", () => $b94c6e091c4e2365$export$2e2bcd8739ae039);
$parcel$export($65303f524e7150e5$exports, "format", () => $2f3e76a23a986122$export$2e2bcd8739ae039);
$parcel$export($65303f524e7150e5$exports, "parse", () => $d0ed4f6c1763b0c0$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise */ const $c84d8e4f87730cff$var$decodeCache = {};
function $c84d8e4f87730cff$var$getDecodeCache(exclude) {
    let cache = $c84d8e4f87730cff$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $c84d8e4f87730cff$var$decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = "%" + ("0" + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $c84d8e4f87730cff$var$decode(string, exclude) {
    if (typeof exclude !== "string") exclude = $c84d8e4f87730cff$var$decode.defaultChars;
    const cache = $c84d8e4f87730cff$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = "";
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += "\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += "\uFFFD\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += "\uFFFD\uFFFD\uFFFD\uFFFD";
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += "\uFFFD";
        }
        return result;
    });
}
$c84d8e4f87730cff$var$decode.defaultChars = ";/?:@&=+$,#";
$c84d8e4f87730cff$var$decode.componentChars = "";
var $c84d8e4f87730cff$export$2e2bcd8739ae039 = $c84d8e4f87730cff$var$decode;


const $b94c6e091c4e2365$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $b94c6e091c4e2365$var$getEncodeCache(exclude) {
    let cache = $b94c6e091c4e2365$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $b94c6e091c4e2365$var$encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $b94c6e091c4e2365$var$encode(string, exclude, keepEscaped) {
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $b94c6e091c4e2365$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    const cache = $b94c6e091c4e2365$var$getEncodeCache(exclude);
    let result = "";
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$b94c6e091c4e2365$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$b94c6e091c4e2365$var$encode.componentChars = "-_.!~*'()";
var $b94c6e091c4e2365$export$2e2bcd8739ae039 = $b94c6e091c4e2365$var$encode;


function $2f3e76a23a986122$export$2e2bcd8739ae039(url) {
    let result = "";
    result += url.protocol || "";
    result += url.slashes ? "//" : "";
    result += url.auth ? url.auth + "@" : "";
    if (url.hostname && url.hostname.indexOf(":") !== -1) // ipv6 address
    result += "[" + url.hostname + "]";
    else result += url.hostname || "";
    result += url.port ? ":" + url.port : "";
    result += url.pathname || "";
    result += url.search || "";
    result += url.hash || "";
    return result;
}


// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $d0ed4f6c1763b0c0$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const $d0ed4f6c1763b0c0$var$protocolPattern = /^([a-z0-9.+-]+:)/i;
const $d0ed4f6c1763b0c0$var$portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const $d0ed4f6c1763b0c0$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const $d0ed4f6c1763b0c0$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
];
// RFC 2396: characters not allowed for various reasons.
const $d0ed4f6c1763b0c0$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($d0ed4f6c1763b0c0$var$delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const $d0ed4f6c1763b0c0$var$autoEscape = [
    "'"
].concat($d0ed4f6c1763b0c0$var$unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const $d0ed4f6c1763b0c0$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($d0ed4f6c1763b0c0$var$autoEscape);
const $d0ed4f6c1763b0c0$var$hostEndingChars = [
    "/",
    "?",
    "#"
];
const $d0ed4f6c1763b0c0$var$hostnameMaxLen = 255;
const $d0ed4f6c1763b0c0$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const $d0ed4f6c1763b0c0$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const $d0ed4f6c1763b0c0$var$hostlessProtocol = {
    javascript: true,
    "javascript:": true
};
// protocols that always contain a // bit.
const $d0ed4f6c1763b0c0$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
function $d0ed4f6c1763b0c0$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $d0ed4f6c1763b0c0$var$Url) return url;
    const u = new $d0ed4f6c1763b0c0$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$d0ed4f6c1763b0c0$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        const simplePath = $d0ed4f6c1763b0c0$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = $d0ed4f6c1763b0c0$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $d0ed4f6c1763b0c0$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$d0ed4f6c1763b0c0$var$hostlessProtocol[proto] && (slashes || proto && !$d0ed4f6c1763b0c0$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < $d0ed4f6c1763b0c0$var$hostEndingChars.length; i++){
            hec = rest.indexOf($d0ed4f6c1763b0c0$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < $d0ed4f6c1763b0c0$var$nonHostChars.length; i++){
            hec = rest.indexOf($d0ed4f6c1763b0c0$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ":") hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match($d0ed4f6c1763b0c0$var$hostnamePartPattern)) {
                    let newpart = "";
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($d0ed4f6c1763b0c0$var$hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match($d0ed4f6c1763b0c0$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $d0ed4f6c1763b0c0$var$hostnameMaxLen) this.hostname = "";
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($d0ed4f6c1763b0c0$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "";
    return this;
};
$d0ed4f6c1763b0c0$var$Url.prototype.parseHost = function(host) {
    let port = $d0ed4f6c1763b0c0$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
var $d0ed4f6c1763b0c0$export$2e2bcd8739ae039 = $d0ed4f6c1763b0c0$var$urlParse;




var $b9bb4966f08102b3$exports = {};

$parcel$export($b9bb4966f08102b3$exports, "Any", () => $54c1aa9fede7c8e9$export$2e2bcd8739ae039);
$parcel$export($b9bb4966f08102b3$exports, "Cc", () => $e65ba172a63885c1$export$2e2bcd8739ae039);
$parcel$export($b9bb4966f08102b3$exports, "Cf", () => $48102738876e059f$export$2e2bcd8739ae039);
$parcel$export($b9bb4966f08102b3$exports, "P", () => $c4e865db6ec62803$export$2e2bcd8739ae039);
$parcel$export($b9bb4966f08102b3$exports, "S", () => $efb89a030c0c6f80$export$2e2bcd8739ae039);
$parcel$export($b9bb4966f08102b3$exports, "Z", () => $57b69b347c18ef48$export$2e2bcd8739ae039);
var $54c1aa9fede7c8e9$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;


var $e65ba172a63885c1$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;


var $48102738876e059f$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;


var $c4e865db6ec62803$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;


var $efb89a030c0c6f80$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;


var $57b69b347c18ef48$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;




// Generated using scripts/write-decode-map.ts
var $0f9763d3f0ce38a4$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\0\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\0\0\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\0\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\0\0\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((c)=>c.charCodeAt(0)));


// Generated using scripts/write-decode-map.ts
var $fd5d2133496f8626$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\0\0\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));


// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $f2561b34a02445d9$var$_a;
const $f2561b34a02445d9$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $f2561b34a02445d9$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($f2561b34a02445d9$var$_a = String.fromCodePoint) !== null && $f2561b34a02445d9$var$_a !== void 0 ? $f2561b34a02445d9$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $f2561b34a02445d9$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $f2561b34a02445d9$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $f2561b34a02445d9$export$2e2bcd8739ae039(codePoint) {
    return $f2561b34a02445d9$export$73bfc63873071f74($f2561b34a02445d9$export$b978ab756102108a(codePoint));
}


var $d2f0648526fa33e2$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($d2f0648526fa33e2$var$CharCodes || ($d2f0648526fa33e2$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $d2f0648526fa33e2$var$TO_LOWER_BIT = 32;
var $d2f0648526fa33e2$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($d2f0648526fa33e2$export$6a4325c613e0faec || ($d2f0648526fa33e2$export$6a4325c613e0faec = {}));
function $d2f0648526fa33e2$var$isNumber(code) {
    return code >= $d2f0648526fa33e2$var$CharCodes.ZERO && code <= $d2f0648526fa33e2$var$CharCodes.NINE;
}
function $d2f0648526fa33e2$var$isHexadecimalCharacter(code) {
    return code >= $d2f0648526fa33e2$var$CharCodes.UPPER_A && code <= $d2f0648526fa33e2$var$CharCodes.UPPER_F || code >= $d2f0648526fa33e2$var$CharCodes.LOWER_A && code <= $d2f0648526fa33e2$var$CharCodes.LOWER_F;
}
function $d2f0648526fa33e2$var$isAsciiAlphaNumeric(code) {
    return code >= $d2f0648526fa33e2$var$CharCodes.UPPER_A && code <= $d2f0648526fa33e2$var$CharCodes.UPPER_Z || code >= $d2f0648526fa33e2$var$CharCodes.LOWER_A && code <= $d2f0648526fa33e2$var$CharCodes.LOWER_Z || $d2f0648526fa33e2$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $d2f0648526fa33e2$var$isEntityInAttributeInvalidEnd(code) {
    return code === $d2f0648526fa33e2$var$CharCodes.EQUALS || $d2f0648526fa33e2$var$isAsciiAlphaNumeric(code);
}
var $d2f0648526fa33e2$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($d2f0648526fa33e2$var$EntityDecoderState || ($d2f0648526fa33e2$var$EntityDecoderState = {}));
var $d2f0648526fa33e2$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($d2f0648526fa33e2$export$8c8f129ce60f53c || ($d2f0648526fa33e2$export$8c8f129ce60f53c = {}));
class $d2f0648526fa33e2$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $d2f0648526fa33e2$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $d2f0648526fa33e2$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $d2f0648526fa33e2$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $d2f0648526fa33e2$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $d2f0648526fa33e2$var$CharCodes.NUM) {
                    this.state = $d2f0648526fa33e2$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $d2f0648526fa33e2$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $d2f0648526fa33e2$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $d2f0648526fa33e2$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $d2f0648526fa33e2$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $d2f0648526fa33e2$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $d2f0648526fa33e2$var$TO_LOWER_BIT) === $d2f0648526fa33e2$var$CharCodes.LOWER_X) {
            this.state = $d2f0648526fa33e2$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $d2f0648526fa33e2$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($d2f0648526fa33e2$var$isNumber(char) || $d2f0648526fa33e2$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($d2f0648526fa33e2$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $d2f0648526fa33e2$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $d2f0648526fa33e2$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $f2561b34a02445d9$export$b978ab756102108a)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $d2f0648526fa33e2$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $d2f0648526fa33e2$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $d2f0648526fa33e2$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $d2f0648526fa33e2$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $d2f0648526fa33e2$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $d2f0648526fa33e2$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $d2f0648526fa33e2$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $d2f0648526fa33e2$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $d2f0648526fa33e2$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$d2f0648526fa33e2$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $d2f0648526fa33e2$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $d2f0648526fa33e2$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $d2f0648526fa33e2$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $d2f0648526fa33e2$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $d2f0648526fa33e2$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $d2f0648526fa33e2$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $d2f0648526fa33e2$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $d2f0648526fa33e2$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $f2561b34a02445d9$export$73bfc63873071f74)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $d2f0648526fa33e2$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $d2f0648526fa33e2$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $d2f0648526fa33e2$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $d2f0648526fa33e2$var$htmlDecoder = $d2f0648526fa33e2$var$getDecoder((0, $0f9763d3f0ce38a4$export$2e2bcd8739ae039));
const $d2f0648526fa33e2$var$xmlDecoder = $d2f0648526fa33e2$var$getDecoder((0, $fd5d2133496f8626$export$2e2bcd8739ae039));
function $d2f0648526fa33e2$export$f045cb747ce77a19(str, mode = $d2f0648526fa33e2$export$8c8f129ce60f53c.Legacy) {
    return $d2f0648526fa33e2$var$htmlDecoder(str, mode);
}
function $d2f0648526fa33e2$export$49f5e8089adb006a(str) {
    return $d2f0648526fa33e2$var$htmlDecoder(str, $d2f0648526fa33e2$export$8c8f129ce60f53c.Attribute);
}
function $d2f0648526fa33e2$export$da52f4371b3f37de(str) {
    return $d2f0648526fa33e2$var$htmlDecoder(str, $d2f0648526fa33e2$export$8c8f129ce60f53c.Strict);
}
function $d2f0648526fa33e2$export$88e3b9643a8bd06e(str) {
    return $d2f0648526fa33e2$var$xmlDecoder(str, $d2f0648526fa33e2$export$8c8f129ce60f53c.Strict);
}


// Generated using scripts/write-encode-map.ts
function $d004716817e7aebe$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$d004716817e7aebe$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $d004716817e7aebe$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $d004716817e7aebe$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $d004716817e7aebe$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $d004716817e7aebe$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));


const $6880c3481a1d3308$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $6880c3481a1d3308$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $6880c3481a1d3308$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $6880c3481a1d3308$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $6880c3481a1d3308$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $6880c3481a1d3308$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$6880c3481a1d3308$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $6880c3481a1d3308$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $6880c3481a1d3308$export$4e7f196112fea3c5 = $6880c3481a1d3308$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $6880c3481a1d3308$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $6880c3481a1d3308$export$9e081872deefdcb0 = $6880c3481a1d3308$var$getEscaper(/[&<>'"]/g, $6880c3481a1d3308$var$xmlCodeMap);
const $6880c3481a1d3308$export$30330f3d5eb70e11 = $6880c3481a1d3308$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $6880c3481a1d3308$export$96e6fc3a139b2555 = $6880c3481a1d3308$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));


const $90f262ed93b44491$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $90f262ed93b44491$export$f9d6449b9af28dc1(data) {
    return $90f262ed93b44491$var$encodeHTMLTrieRe($90f262ed93b44491$var$htmlReplacer, data);
}
function $90f262ed93b44491$export$e6e86c76506f1190(data) {
    return $90f262ed93b44491$var$encodeHTMLTrieRe((0, $6880c3481a1d3308$export$5699810ce3244ab8), data);
}
function $90f262ed93b44491$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $d004716817e7aebe$export$2e2bcd8739ae039).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $6880c3481a1d3308$export$e02688b8085d016b)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}



var $37f3a5500a2be2dc$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($37f3a5500a2be2dc$export$b8c86583d9718b50 || ($37f3a5500a2be2dc$export$b8c86583d9718b50 = {}));
var $37f3a5500a2be2dc$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($37f3a5500a2be2dc$export$1851b20d614eb756 || ($37f3a5500a2be2dc$export$1851b20d614eb756 = {}));
function $37f3a5500a2be2dc$export$2f872c0f2117be69(data, options = $37f3a5500a2be2dc$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $37f3a5500a2be2dc$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $d2f0648526fa33e2$export$f045cb747ce77a19)(data, mode);
    }
    return (0, $d2f0648526fa33e2$export$88e3b9643a8bd06e)(data);
}
function $37f3a5500a2be2dc$export$c94669f4c7d36be4(data, options = $37f3a5500a2be2dc$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $d2f0648526fa33e2$export$8c8f129ce60f53c).Strict;
    return $37f3a5500a2be2dc$export$2f872c0f2117be69(data, opts);
}
function $37f3a5500a2be2dc$export$c564cdbbe6da493(data, options = $37f3a5500a2be2dc$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $37f3a5500a2be2dc$export$1851b20d614eb756.UTF8) return (0, $6880c3481a1d3308$export$9e081872deefdcb0)(data);
    if (opts.mode === $37f3a5500a2be2dc$export$1851b20d614eb756.Attribute) return (0, $6880c3481a1d3308$export$30330f3d5eb70e11)(data);
    if (opts.mode === $37f3a5500a2be2dc$export$1851b20d614eb756.Text) return (0, $6880c3481a1d3308$export$96e6fc3a139b2555)(data);
    if (opts.level === $37f3a5500a2be2dc$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $37f3a5500a2be2dc$export$1851b20d614eb756.ASCII) return (0, $90f262ed93b44491$export$e6e86c76506f1190)(data);
        return (0, $90f262ed93b44491$export$f9d6449b9af28dc1)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $6880c3481a1d3308$export$18855ec5be97da16)(data);
}


function $e0c8ff411ba71ee2$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $e0c8ff411ba71ee2$export$844ec244b1367d54(obj) {
    return $e0c8ff411ba71ee2$var$_class(obj) === "[object String]";
}
const $e0c8ff411ba71ee2$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $e0c8ff411ba71ee2$export$a4f4bb6b1453fff5(object, key) {
    return $e0c8ff411ba71ee2$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $e0c8ff411ba71ee2$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $e0c8ff411ba71ee2$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $e0c8ff411ba71ee2$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $e0c8ff411ba71ee2$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $e0c8ff411ba71ee2$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $e0c8ff411ba71ee2$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $e0c8ff411ba71ee2$var$UNESCAPE_ALL_RE = new RegExp($e0c8ff411ba71ee2$var$UNESCAPE_MD_RE.source + "|" + $e0c8ff411ba71ee2$var$ENTITY_RE.source, "gi");
const $e0c8ff411ba71ee2$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $e0c8ff411ba71ee2$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $e0c8ff411ba71ee2$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($e0c8ff411ba71ee2$export$644a8f5b13b2a36d(code)) return $e0c8ff411ba71ee2$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $d2f0648526fa33e2$export$f045cb747ce77a19)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $e0c8ff411ba71ee2$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($e0c8ff411ba71ee2$var$UNESCAPE_MD_RE, "$1");
}
function $e0c8ff411ba71ee2$export$db8a17c6655f7e2c(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace($e0c8ff411ba71ee2$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $e0c8ff411ba71ee2$var$replaceEntityPattern(match, entity);
    });
}
const $e0c8ff411ba71ee2$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $e0c8ff411ba71ee2$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $e0c8ff411ba71ee2$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $e0c8ff411ba71ee2$var$replaceUnsafeChar(ch) {
    return $e0c8ff411ba71ee2$var$HTML_REPLACEMENTS[ch];
}
function $e0c8ff411ba71ee2$export$4cf11838cdc2a8a8(str) {
    if ($e0c8ff411ba71ee2$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($e0c8ff411ba71ee2$var$HTML_ESCAPE_REPLACE_RE, $e0c8ff411ba71ee2$var$replaceUnsafeChar);
    return str;
}
const $e0c8ff411ba71ee2$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $e0c8ff411ba71ee2$export$bc616c8f7dc20d5d(str) {
    return str.replace($e0c8ff411ba71ee2$var$REGEXP_ESCAPE_RE, "\\$&");
}
function $e0c8ff411ba71ee2$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $e0c8ff411ba71ee2$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $e0c8ff411ba71ee2$export$4888a643af800fc1(ch) {
    return $c4e865db6ec62803$export$2e2bcd8739ae039.test(ch) || $efb89a030c0c6f80$export$2e2bcd8739ae039.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $e0c8ff411ba71ee2$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $e0c8ff411ba71ee2$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $e0c8ff411ba71ee2$export$16c08b91f883959a = {
    mdurl: $65303f524e7150e5$exports,
    ucmicro: $b9bb4966f08102b3$exports
};


var $3910bbf62661125f$exports = {};

$parcel$export($3910bbf62661125f$exports, "parseLinkLabel", () => $c3348508e2868dc4$export$2e2bcd8739ae039);
$parcel$export($3910bbf62661125f$exports, "parseLinkDestination", () => $529153b6073101db$export$2e2bcd8739ae039);
$parcel$export($3910bbf62661125f$exports, "parseLinkTitle", () => $f04c397f26e33b5c$export$2e2bcd8739ae039);
// Just a shortcut for bulk export
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $c3348508e2868dc4$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}


// Parse link destination
//

function $529153b6073101db$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $e0c8ff411ba71ee2$export$db8a17c6655f7e2c)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $e0c8ff411ba71ee2$export$db8a17c6655f7e2c)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}


// Parse link title
//

function $f04c397f26e33b5c$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: "",
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $e0c8ff411ba71ee2$export$db8a17c6655f7e2c)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $e0c8ff411ba71ee2$export$db8a17c6655f7e2c)(str.slice(start, pos));
    return state;
}




/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
const $0f02e281ebaa1ebe$var$default_rules = {};
$0f02e281ebaa1ebe$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + (0, $e0c8ff411ba71ee2$export$4cf11838cdc2a8a8)(token.content) + "</code>";
};
$0f02e281ebaa1ebe$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + (0, $e0c8ff411ba71ee2$export$4cf11838cdc2a8a8)(tokens[idx].content) + "</code></pre>\n";
};
$0f02e281ebaa1ebe$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $e0c8ff411ba71ee2$export$db8a17c6655f7e2c)(token.info).trim() : "";
    let langName = "";
    let langAttrs = "";
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $e0c8ff411ba71ee2$export$4cf11838cdc2a8a8)(token.content);
    else highlighted = (0, $e0c8ff411ba71ee2$export$4cf11838cdc2a8a8)(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex("class");
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$0f02e281ebaa1ebe$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$0f02e281ebaa1ebe$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$0f02e281ebaa1ebe$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$0f02e281ebaa1ebe$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $e0c8ff411ba71ee2$export$4cf11838cdc2a8a8)(tokens[idx].content);
};
$0f02e281ebaa1ebe$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$0f02e281ebaa1ebe$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $0f02e281ebaa1ebe$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $e0c8ff411ba71ee2$export$e6e34fd1f2686227)({}, $0f02e281ebaa1ebe$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $0f02e281ebaa1ebe$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + (0, $e0c8ff411ba71ee2$export$4cf11838cdc2a8a8)(token.attrs[i][0]) + '="' + (0, $e0c8ff411ba71ee2$export$4cf11838cdc2a8a8)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $0f02e281ebaa1ebe$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = "";
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $0f02e281ebaa1ebe$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $0f02e281ebaa1ebe$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = "";
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case "text":
            result += tokens[i].content;
            break;
        case "image":
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case "html_inline":
        case "html_block":
            result += tokens[i].content;
            break;
        case "softbreak":
        case "hardbreak":
            result += "\n";
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $0f02e281ebaa1ebe$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $0f02e281ebaa1ebe$export$2e2bcd8739ae039 = $0f02e281ebaa1ebe$var$Renderer;


/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ /**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $1a81b3e3688ecd1d$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$1a81b3e3688ecd1d$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$1a81b3e3688ecd1d$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $1a81b3e3688ecd1d$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $1a81b3e3688ecd1d$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $1a81b3e3688ecd1d$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $1a81b3e3688ecd1d$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $1a81b3e3688ecd1d$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $1a81b3e3688ecd1d$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $1a81b3e3688ecd1d$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $1a81b3e3688ecd1d$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $1a81b3e3688ecd1d$export$2e2bcd8739ae039 = $1a81b3e3688ecd1d$var$Ruler;


// Core state object
//
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $3e76ca81421746f3$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $3e76ca81421746f3$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $3e76ca81421746f3$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $3e76ca81421746f3$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $3e76ca81421746f3$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $3e76ca81421746f3$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
var $3e76ca81421746f3$export$2e2bcd8739ae039 = $3e76ca81421746f3$var$Token;


function $109a516121045068$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md // link to parser instance
    ;
}
// re-export Token class to use in core rules
$109a516121045068$var$StateCore.prototype.Token = (0, $3e76ca81421746f3$export$2e2bcd8739ae039);
var $109a516121045068$export$2e2bcd8739ae039 = $109a516121045068$var$StateCore;


// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $53b43c6449fe15de$var$NEWLINES_RE = /\r\n?|\n/g;
const $53b43c6449fe15de$var$NULL_RE = /\0/g;
function $53b43c6449fe15de$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($53b43c6449fe15de$var$NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace($53b43c6449fe15de$var$NULL_RE, "\uFFFD");
    state.src = str;
}


function $7f3b554d3215267e$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}


function $1f13efa06f0ac78d$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}


// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

function $117bc0c4b5f23798$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $117bc0c4b5f23798$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $117bc0c4b5f23798$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if ($117bc0c4b5f23798$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($117bc0c4b5f23798$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === "text_special") links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token("link_open", "a", 1);
                    token_o.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = "linkify";
                    token_o.info = "auto";
                    nodes.push(token_o);
                    const token_t = new state.Token("text", "", 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token("link_close", "a", -1);
                    token_c.level = --level;
                    token_c.markup = "linkify";
                    token_c.info = "auto";
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $e0c8ff411ba71ee2$export$f78478f71955b6bc)(tokens, i, nodes);
            }
        }
    }
}


// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $3504f18ce8503fa8$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $3504f18ce8503fa8$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $3504f18ce8503fa8$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $3504f18ce8503fa8$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $3504f18ce8503fa8$var$replaceFn(match, name) {
    return $3504f18ce8503fa8$var$SCOPED_ABBR[name.toLowerCase()];
}
function $3504f18ce8503fa8$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace($3504f18ce8503fa8$var$SCOPED_ABBR_RE, $3504f18ce8503fa8$var$replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $3504f18ce8503fa8$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if ($3504f18ce8503fa8$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $3504f18ce8503fa8$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if ($3504f18ce8503fa8$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $3504f18ce8503fa8$var$replace_scoped(state.tokens[blkIdx].children);
        if ($3504f18ce8503fa8$var$RARE_RE.test(state.tokens[blkIdx].content)) $3504f18ce8503fa8$var$replace_rare(state.tokens[blkIdx].children);
    }
}


// Convert straight quotation marks to typographic ones
//

const $7a64be07246d8408$var$QUOTE_TEST_RE = /['"]/;
const $7a64be07246d8408$var$QUOTE_RE = /['"]/g;
const $7a64be07246d8408$var$APOSTROPHE = "\u2019" /* ’ */ ;
function $7a64be07246d8408$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $7a64be07246d8408$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $7a64be07246d8408$var$QUOTE_RE.lastIndex = pos;
            const t = $7a64be07246d8408$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $e0c8ff411ba71ee2$export$829a0d33ae4e744)(lastChar) || (0, $e0c8ff411ba71ee2$export$4888a643af800fc1)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $e0c8ff411ba71ee2$export$829a0d33ae4e744)(nextChar) || (0, $e0c8ff411ba71ee2$export$4888a643af800fc1)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $e0c8ff411ba71ee2$export$3c52dd84024ae72c)(lastChar);
            const isNextWhiteSpace = (0, $e0c8ff411ba71ee2$export$3c52dd84024ae72c)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $7a64be07246d8408$var$replaceAt(token.content, t.index, $7a64be07246d8408$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $7a64be07246d8408$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $7a64be07246d8408$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $7a64be07246d8408$var$replaceAt(token.content, t.index, $7a64be07246d8408$var$APOSTROPHE);
        }
    }
}
function $7a64be07246d8408$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !$7a64be07246d8408$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $7a64be07246d8408$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}


// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $2b621f14338e8369$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === "text_special") tokens[curr].type = "text";
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}


const $9780d61da816c228$var$_rules = [
    [
        "normalize",
        (0, $53b43c6449fe15de$export$2e2bcd8739ae039)
    ],
    [
        "block",
        (0, $7f3b554d3215267e$export$2e2bcd8739ae039)
    ],
    [
        "inline",
        (0, $1f13efa06f0ac78d$export$2e2bcd8739ae039)
    ],
    [
        "linkify",
        (0, $117bc0c4b5f23798$export$2e2bcd8739ae039)
    ],
    [
        "replacements",
        (0, $3504f18ce8503fa8$export$2e2bcd8739ae039)
    ],
    [
        "smartquotes",
        (0, $7a64be07246d8408$export$2e2bcd8739ae039)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        (0, $2b621f14338e8369$export$2e2bcd8739ae039)
    ]
];
/**
 * new Core()
 **/ function $9780d61da816c228$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $1a81b3e3688ecd1d$export$2e2bcd8739ae039)();
    for(let i = 0; i < $9780d61da816c228$var$_rules.length; i++)this.ruler.push($9780d61da816c228$var$_rules[i][0], $9780d61da816c228$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $9780d61da816c228$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules("");
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$9780d61da816c228$var$Core.prototype.State = (0, $109a516121045068$export$2e2bcd8739ae039);
var $9780d61da816c228$export$2e2bcd8739ae039 = $9780d61da816c228$var$Core;


/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
// Parser state class


function $397c92d2e2763d99$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = [] // line begin offsets for fast jumps
    ;
    this.eMarks = [] // line end offsets for fast jumps
    ;
    this.tShift = [] // offsets of the first non-space characters (tabs not expanded)
    ;
    this.sCount = [] // indents for each line (tabs expanded)
    ;
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0 // line index in src
    ;
    this.lineMax = 0 // lines count
    ;
    this.tight = false // loose/tight mode for lists
    ;
    this.ddIndent = -1 // indent of the current dd block (-1 if there isn't any)
    ;
    this.listIndent = -1 // indent of the current list block (-1 if there isn't any)
    ;
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1 // don't count last fake line
    ;
}
// Push new token to "stream".
//
$397c92d2e2763d99$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $3e76ca81421746f3$export$2e2bcd8739ae039)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level-- // closing tag
    ;
    token.level = this.level;
    if (nesting > 0) this.level++ // opening tag
    ;
    this.tokens.push(token);
    return token;
};
$397c92d2e2763d99$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$397c92d2e2763d99$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$397c92d2e2763d99$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$397c92d2e2763d99$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$397c92d2e2763d99$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$397c92d2e2763d99$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$397c92d2e2763d99$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return "";
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
$397c92d2e2763d99$var$StateBlock.prototype.Token = (0, $3e76ca81421746f3$export$2e2bcd8739ae039);
var $397c92d2e2763d99$export$2e2bcd8739ae039 = $397c92d2e2763d99$var$StateBlock;


// GFM table, https://github.github.com/gfm/#tables-extension-

// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $2f67b7dcdd6b0e4c$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $2f67b7dcdd6b0e4c$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $2f67b7dcdd6b0e4c$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = "";
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $2f67b7dcdd6b0e4c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) return false;
        pos++;
    }
    let lineText = $2f67b7dcdd6b0e4c$var$getLine(state, startLine + 1);
    let columns = lineText.split("|");
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $2f67b7dcdd6b0e4c$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $2f67b7dcdd6b0e4c$var$escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const token_to = state.push("table_open", "table", 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push("thead_open", "thead", 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push("tr_open", "tr", 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push("th_open", "th", 1);
        if (aligns[i]) token_ho.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        const token_il = state.push("inline", "", 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push("th_close", "th", -1);
    }
    state.push("tr_close", "tr", -1);
    state.push("thead_close", "thead", -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $2f67b7dcdd6b0e4c$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $2f67b7dcdd6b0e4c$var$escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $2f67b7dcdd6b0e4c$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push("tbody_open", "tbody", 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push("tr_open", "tr", 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push("td_open", "td", 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            const token_il = state.push("inline", "", 0);
            token_il.content = columns[i] ? columns[i].trim() : "";
            token_il.children = [];
            state.push("td_close", "td", -1);
        }
        state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}


// Code block (4 spaces padded)
function $2366a1cee34cf839$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
}


// fences (``` lang, ~~~ lang)
function $d523773edbe006b0$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}


// Block quotes

function $ebe358288ad20a06$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const oldParentType = state.parentType;
    state.parentType = "blockquote";
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push("blockquote_open", "blockquote", 1);
    token_o.markup = ">";
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push("blockquote_close", "blockquote", -1);
    token_c.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}


// Horizontal rule

function $4f5c4268aba41967$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}


// Lists

// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $eebe125f439d7c4c$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $eebe125f439d7c4c$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $eebe125f439d7c4c$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $eebe125f439d7c4c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $eebe125f439d7c4c$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $eebe125f439d7c4c$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules("list");
    const oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $eebe125f439d7c4c$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $eebe125f439d7c4c$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $eebe125f439d7c4c$var$markTightParagraphs(state, listTokIdx);
    return true;
}



function $b8ffd6add19c7798$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules("reference");
            const oldParentType = state.parentType;
            state.parentType = "reference";
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = "";
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $e0c8ff411ba71ee2$export$20ef46802c8744b)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}


// HTML block
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $4147f1b29dac0f19$export$2e2bcd8739ae039 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];


// Regexps to match html elements
const $e3d743a8108b5473$var$attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
const $e3d743a8108b5473$var$unquoted = "[^\"'=<>`\\x00-\\x20]+";
const $e3d743a8108b5473$var$single_quoted = "'[^']*'";
const $e3d743a8108b5473$var$double_quoted = '"[^"]*"';
const $e3d743a8108b5473$var$attr_value = "(?:" + $e3d743a8108b5473$var$unquoted + "|" + $e3d743a8108b5473$var$single_quoted + "|" + $e3d743a8108b5473$var$double_quoted + ")";
const $e3d743a8108b5473$var$attribute = "(?:\\s+" + $e3d743a8108b5473$var$attr_name + "(?:\\s*=\\s*" + $e3d743a8108b5473$var$attr_value + ")?)";
const $e3d743a8108b5473$var$open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + $e3d743a8108b5473$var$attribute + "*\\s*\\/?>";
const $e3d743a8108b5473$var$close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
const $e3d743a8108b5473$var$comment = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->";
const $e3d743a8108b5473$var$processing = "<[?][\\s\\S]*?[?]>";
const $e3d743a8108b5473$var$declaration = "<![A-Za-z][^>]*>";
const $e3d743a8108b5473$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
const $e3d743a8108b5473$export$6db61d2c3a16e419 = new RegExp("^(?:" + $e3d743a8108b5473$var$open_tag + "|" + $e3d743a8108b5473$var$close_tag + "|" + $e3d743a8108b5473$var$comment + "|" + $e3d743a8108b5473$var$processing + "|" + $e3d743a8108b5473$var$declaration + "|" + $e3d743a8108b5473$var$cdata + ")");
const $e3d743a8108b5473$export$cd48660d06f74639 = new RegExp("^(?:" + $e3d743a8108b5473$var$open_tag + "|" + $e3d743a8108b5473$var$close_tag + ")");


// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $1f6dac88d16de393$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + (0, $4147f1b29dac0f19$export$2e2bcd8739ae039).join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp((0, $e3d743a8108b5473$export$cd48660d06f74639).source + "\\s*$"),
        /^$/,
        false
    ]
];
function $1f6dac88d16de393$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $1f6dac88d16de393$var$HTML_SEQUENCES.length; i++){
        if ($1f6dac88d16de393$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $1f6dac88d16de393$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $1f6dac88d16de393$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$1f6dac88d16de393$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($1f6dac88d16de393$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}


// heading (#, ##, ...)

function $67e4b6faf18d71b4$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = "########".slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = "########".slice(0, level);
    return true;
}


// lheading (---, ===)
function $3b16c4f30e37d478$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = "paragraph" // use paragraph to match terminatorRules
    ;
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}


// Paragraph
function $d05a45e12d379805$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push("paragraph_open", "p", 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
}


const $9c3ac4c268ea1fcc$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (0, $2f67b7dcdd6b0e4c$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (0, $2366a1cee34cf839$export$2e2bcd8739ae039)
    ],
    [
        "fence",
        (0, $d523773edbe006b0$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (0, $ebe358288ad20a06$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (0, $4f5c4268aba41967$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (0, $eebe125f439d7c4c$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (0, $b8ffd6add19c7798$export$2e2bcd8739ae039)
    ],
    [
        "html_block",
        (0, $1f6dac88d16de393$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (0, $67e4b6faf18d71b4$export$2e2bcd8739ae039),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (0, $3b16c4f30e37d478$export$2e2bcd8739ae039)
    ],
    [
        "paragraph",
        (0, $d05a45e12d379805$export$2e2bcd8739ae039)
    ]
];
/**
 * new ParserBlock()
 **/ function $9c3ac4c268ea1fcc$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $1a81b3e3688ecd1d$export$2e2bcd8739ae039)();
    for(let i = 0; i < $9c3ac4c268ea1fcc$var$_rules.length; i++)this.ruler.push($9c3ac4c268ea1fcc$var$_rules[i][0], $9c3ac4c268ea1fcc$var$_rules[i][1], {
        alt: ($9c3ac4c268ea1fcc$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$9c3ac4c268ea1fcc$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error("none of the block rules matched");
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $9c3ac4c268ea1fcc$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$9c3ac4c268ea1fcc$var$ParserBlock.prototype.State = (0, $397c92d2e2763d99$export$2e2bcd8739ae039);
var $9c3ac4c268ea1fcc$export$2e2bcd8739ae039 = $9c3ac4c268ea1fcc$var$ParserBlock;


/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
// Inline parser state


function $b9e1295caa6c64b2$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$b9e1295caa6c64b2$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $3e76ca81421746f3$export$2e2bcd8739ae039)("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$b9e1295caa6c64b2$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $3e76ca81421746f3$export$2e2bcd8739ae039)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$b9e1295caa6c64b2$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $e0c8ff411ba71ee2$export$829a0d33ae4e744)(lastChar) || (0, $e0c8ff411ba71ee2$export$4888a643af800fc1)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $e0c8ff411ba71ee2$export$829a0d33ae4e744)(nextChar) || (0, $e0c8ff411ba71ee2$export$4888a643af800fc1)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $e0c8ff411ba71ee2$export$3c52dd84024ae72c)(lastChar);
    const isNextWhiteSpace = (0, $e0c8ff411ba71ee2$export$3c52dd84024ae72c)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$b9e1295caa6c64b2$var$StateInline.prototype.Token = (0, $3e76ca81421746f3$export$2e2bcd8739ae039);
var $b9e1295caa6c64b2$export$2e2bcd8739ae039 = $b9e1295caa6c64b2$var$StateInline;


// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $611ce3b55cec0597$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $611ce3b55cec0597$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$611ce3b55cec0597$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 


// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $3db5f1e2d58005c9$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $3db5f1e2d58005c9$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($3db5f1e2d58005c9$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, "");
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push("link_open", "a", 1);
        token_o.attrs = [
            [
                "href",
                fullUrl
            ]
        ];
        token_o.markup = "linkify";
        token_o.info = "auto";
        const token_t = state.push("text", "", 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push("link_close", "a", -1);
        token_c.markup = "linkify";
        token_c.info = "auto";
    }
    state.pos += url.length - proto.length;
    return true;
}


// Proceess '\n'

function $d1846519a2ea4317$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}


// Process escaped chars and hardbreaks

const $d3291ca5f2f57fd4$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$d3291ca5f2f57fd4$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $d3291ca5f2f57fd4$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $d3291ca5f2f57fd4$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push("hardbreak", "br", 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = "\\" + escapedStr;
    if (!silent) {
        const token = state.push("text_special", "", 0);
        if (ch1 < 256 && $d3291ca5f2f57fd4$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = "escape";
    }
    state.pos = pos + 1;
    return true;
}


// Parse backticks
function $77e774517a7982ed$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}


// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $77a54db40bb62e94$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $77a54db40bb62e94$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $77a54db40bb62e94$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $77a54db40bb62e94$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $77a54db40bb62e94$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $77a54db40bb62e94$export$2e2bcd8739ae039 = {
    tokenize: $77a54db40bb62e94$var$strikethrough_tokenize,
    postProcess: $77a54db40bb62e94$var$strikethrough_postProcess
};


// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $a0b3ba0e684864b4$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $a0b3ba0e684864b4$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? "strong_open" : "em_open";
        token_o.tag = isStrong ? "strong" : "em";
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = "";
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? "strong_close" : "em_close";
        token_c.tag = isStrong ? "strong" : "em";
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $a0b3ba0e684864b4$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $a0b3ba0e684864b4$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a0b3ba0e684864b4$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $a0b3ba0e684864b4$export$2e2bcd8739ae039 = {
    tokenize: $a0b3ba0e684864b4$var$emphasis_tokenize,
    postProcess: $a0b3ba0e684864b4$var$emphasis_post_process
};


// Process [link](<to> "stuff")

function $379455b275170e8f$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = "";
    let title = "";
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $e0c8ff411ba71ee2$export$20ef46802c8744b)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push("link_open", "a", 1);
        const attrs = [
            [
                "href",
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            "title",
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}


// Process ![image](<src> "title")

function $cca879a054ac4a46$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = "";
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $e0c8ff411ba71ee2$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $e0c8ff411ba71ee2$export$20ef46802c8744b)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push("image", "img", 0);
        const attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}


// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $e6f13999baaac1fd$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $e6f13999baaac1fd$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $e6f13999baaac1fd$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($e6f13999baaac1fd$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($e6f13999baaac1fd$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}


// Process html tags

function $ae3d737696ba9023$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $ae3d737696ba9023$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $ae3d737696ba9023$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $ae3d737696ba9023$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$ae3d737696ba9023$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $e3d743a8108b5473$export$6db61d2c3a16e419));
    if (!match) return false;
    if (!silent) {
        const token = state.push("html_inline", "", 0);
        token.content = match[0];
        if ($ae3d737696ba9023$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($ae3d737696ba9023$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}


// Process html entity - &#123;, &#xAF;, &quot;, ...


const $07efe40eb0836ff2$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $07efe40eb0836ff2$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $07efe40eb0836ff2$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($07efe40eb0836ff2$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push("text_special", "", 0);
                token.content = (0, $e0c8ff411ba71ee2$export$644a8f5b13b2a36d)(code) ? (0, $e0c8ff411ba71ee2$export$73bfc63873071f74)(code) : (0, $e0c8ff411ba71ee2$export$73bfc63873071f74)(0xFFFD);
                token.markup = match[0];
                token.info = "entity";
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($07efe40eb0836ff2$var$NAMED_RE);
        if (match) {
            const decoded = (0, $d2f0648526fa33e2$export$f045cb747ce77a19)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push("text_special", "", 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = "entity";
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}


// For each opening emphasis-like marker find a matching closing one
//
function $74648acc7d621dfa$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $74648acc7d621dfa$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $74648acc7d621dfa$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $74648acc7d621dfa$var$processDelimiters(tokens_meta[curr].delimiters);
}


// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $5274785bbc8fd18e$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level-- // closing tag
        ;
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++ // opening tag
        ;
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}


// Parser rules
const $b076ee6913a9e0f0$var$_rules = [
    [
        "text",
        (0, $611ce3b55cec0597$export$2e2bcd8739ae039)
    ],
    [
        "linkify",
        (0, $3db5f1e2d58005c9$export$2e2bcd8739ae039)
    ],
    [
        "newline",
        (0, $d1846519a2ea4317$export$2e2bcd8739ae039)
    ],
    [
        "escape",
        (0, $d3291ca5f2f57fd4$export$2e2bcd8739ae039)
    ],
    [
        "backticks",
        (0, $77e774517a7982ed$export$2e2bcd8739ae039)
    ],
    [
        "strikethrough",
        (0, $77a54db40bb62e94$export$2e2bcd8739ae039).tokenize
    ],
    [
        "emphasis",
        (0, $a0b3ba0e684864b4$export$2e2bcd8739ae039).tokenize
    ],
    [
        "link",
        (0, $379455b275170e8f$export$2e2bcd8739ae039)
    ],
    [
        "image",
        (0, $cca879a054ac4a46$export$2e2bcd8739ae039)
    ],
    [
        "autolink",
        (0, $e6f13999baaac1fd$export$2e2bcd8739ae039)
    ],
    [
        "html_inline",
        (0, $ae3d737696ba9023$export$2e2bcd8739ae039)
    ],
    [
        "entity",
        (0, $07efe40eb0836ff2$export$2e2bcd8739ae039)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $b076ee6913a9e0f0$var$_rules2 = [
    [
        "balance_pairs",
        (0, $74648acc7d621dfa$export$2e2bcd8739ae039)
    ],
    [
        "strikethrough",
        (0, $77a54db40bb62e94$export$2e2bcd8739ae039).postProcess
    ],
    [
        "emphasis",
        (0, $a0b3ba0e684864b4$export$2e2bcd8739ae039).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        (0, $5274785bbc8fd18e$export$2e2bcd8739ae039)
    ]
];
/**
 * new ParserInline()
 **/ function $b076ee6913a9e0f0$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $1a81b3e3688ecd1d$export$2e2bcd8739ae039)();
    for(let i = 0; i < $b076ee6913a9e0f0$var$_rules.length; i++)this.ruler.push($b076ee6913a9e0f0$var$_rules[i][0], $b076ee6913a9e0f0$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $1a81b3e3688ecd1d$export$2e2bcd8739ae039)();
    for(let i = 0; i < $b076ee6913a9e0f0$var$_rules2.length; i++)this.ruler2.push($b076ee6913a9e0f0$var$_rules2[i][0], $b076ee6913a9e0f0$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$b076ee6913a9e0f0$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$b076ee6913a9e0f0$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $b076ee6913a9e0f0$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules("");
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$b076ee6913a9e0f0$var$ParserInline.prototype.State = (0, $b9e1295caa6c64b2$export$2e2bcd8739ae039);
var $b076ee6913a9e0f0$export$2e2bcd8739ae039 = $b076ee6913a9e0f0$var$ParserInline;



function $a05d924b86ca0bd7$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $54c1aa9fede7c8e9$export$2e2bcd8739ae039).source;
    re.src_Cc = (0, $e65ba172a63885c1$export$2e2bcd8739ae039).source;
    re.src_Z = (0, $57b69b347c18ef48$export$2e2bcd8739ae039).source;
    re.src_P = (0, $c4e865db6ec62803$export$2e2bcd8739ae039).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")" + "(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + "|[-])|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.{2,}[a-zA-Z0-9%/&]|" + "\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + // allow `,,,` in paths
    ",(?!" + re.src_ZCc + "|$)|" + // allow `;` if not followed by space-like char
    ";(?!" + re.src_ZCc + "|$)|" + // allow `!!!` in paths, but not at the end
    "\\!+(?!" + re.src_ZCc + "|[!]|$)|" + "\\?(?!" + re.src_ZCc + "|[?]|$)" + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /* _root */  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
}


//
// Helpers
//
// Merge objects
//
function $d82d6b83b5911822$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d82d6b83b5911822$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d82d6b83b5911822$var$isString(obj) {
    return $d82d6b83b5911822$var$_class(obj) === "[object String]";
}
function $d82d6b83b5911822$var$isObject(obj) {
    return $d82d6b83b5911822$var$_class(obj) === "[object Object]";
}
function $d82d6b83b5911822$var$isRegExp(obj) {
    return $d82d6b83b5911822$var$_class(obj) === "[object RegExp]";
}
function $d82d6b83b5911822$var$isFunction(obj) {
    return $d82d6b83b5911822$var$_class(obj) === "[object Function]";
}
function $d82d6b83b5911822$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
//
const $d82d6b83b5911822$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d82d6b83b5911822$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $d82d6b83b5911822$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $d82d6b83b5911822$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $d82d6b83b5911822$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $d82d6b83b5911822$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
function $d82d6b83b5911822$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $d82d6b83b5911822$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d82d6b83b5911822$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $d82d6b83b5911822$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $a05d924b86ca0bd7$export$2e2bcd8739ae039)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d82d6b83b5911822$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d82d6b83b5911822$var$isObject(val)) {
            if ($d82d6b83b5911822$var$isRegExp(val.validate)) compiled.validate = $d82d6b83b5911822$var$createValidator(val.validate);
            else if ($d82d6b83b5911822$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d82d6b83b5911822$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d82d6b83b5911822$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d82d6b83b5911822$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $d82d6b83b5911822$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d82d6b83b5911822$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $d82d6b83b5911822$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d82d6b83b5911822$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d82d6b83b5911822$var$createMatch(self, shift) {
    const match = new $d82d6b83b5911822$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d82d6b83b5911822$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d82d6b83b5911822$var$LinkifyIt)) return new $d82d6b83b5911822$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d82d6b83b5911822$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d82d6b83b5911822$var$assign({}, $d82d6b83b5911822$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1 // Next scan position
    ;
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $d82d6b83b5911822$var$assign({}, $d82d6b83b5911822$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d82d6b83b5911822$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d82d6b83b5911822$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d82d6b83b5911822$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d82d6b83b5911822$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d82d6b83b5911822$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d82d6b83b5911822$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $d82d6b83b5911822$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d82d6b83b5911822$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d82d6b83b5911822$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d82d6b83b5911822$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $d82d6b83b5911822$export$2e2bcd8739ae039 = $d82d6b83b5911822$var$LinkifyIt;



"use strict";
/** Highest positive signed 32-bit float value */ const $e649afea0640d1d0$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $e649afea0640d1d0$var$base = 36;
const $e649afea0640d1d0$var$tMin = 1;
const $e649afea0640d1d0$var$tMax = 26;
const $e649afea0640d1d0$var$skew = 38;
const $e649afea0640d1d0$var$damp = 700;
const $e649afea0640d1d0$var$initialBias = 72;
const $e649afea0640d1d0$var$initialN = 128; // 0x80
const $e649afea0640d1d0$var$delimiter = "-"; // '\x2D'
/** Regular expressions */ const $e649afea0640d1d0$var$regexPunycode = /^xn--/;
const $e649afea0640d1d0$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $e649afea0640d1d0$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $e649afea0640d1d0$var$errors = {
    "overflow": "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
};
/** Convenience shortcuts */ const $e649afea0640d1d0$var$baseMinusTMin = $e649afea0640d1d0$var$base - $e649afea0640d1d0$var$tMin;
const $e649afea0640d1d0$var$floor = Math.floor;
const $e649afea0640d1d0$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $e649afea0640d1d0$var$error(type) {
    throw new RangeError($e649afea0640d1d0$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $e649afea0640d1d0$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $e649afea0640d1d0$var$mapDomain(domain, callback) {
    const parts = domain.split("@");
    let result = "";
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + "@";
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($e649afea0640d1d0$var$regexSeparators, ".");
    const labels = domain.split(".");
    const encoded = $e649afea0640d1d0$var$map(labels, callback).join(".");
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $e649afea0640d1d0$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $e649afea0640d1d0$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $e649afea0640d1d0$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $e649afea0640d1d0$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $e649afea0640d1d0$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $e649afea0640d1d0$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $e649afea0640d1d0$var$floor(delta / $e649afea0640d1d0$var$damp) : delta >> 1;
    delta += $e649afea0640d1d0$var$floor(delta / numPoints);
    for(; delta > $e649afea0640d1d0$var$baseMinusTMin * $e649afea0640d1d0$var$tMax >> 1; k += $e649afea0640d1d0$var$base)delta = $e649afea0640d1d0$var$floor(delta / $e649afea0640d1d0$var$baseMinusTMin);
    return $e649afea0640d1d0$var$floor(k + ($e649afea0640d1d0$var$baseMinusTMin + 1) * delta / (delta + $e649afea0640d1d0$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $e649afea0640d1d0$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $e649afea0640d1d0$var$initialN;
    let bias = $e649afea0640d1d0$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($e649afea0640d1d0$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $e649afea0640d1d0$var$error("not-basic");
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $e649afea0640d1d0$var$base;; k += $e649afea0640d1d0$var$base){
            if (index >= inputLength) $e649afea0640d1d0$var$error("invalid-input");
            const digit = $e649afea0640d1d0$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $e649afea0640d1d0$var$base) $e649afea0640d1d0$var$error("invalid-input");
            if (digit > $e649afea0640d1d0$var$floor(($e649afea0640d1d0$var$maxInt - i) / w)) $e649afea0640d1d0$var$error("overflow");
            i += digit * w;
            const t = k <= bias ? $e649afea0640d1d0$var$tMin : k >= bias + $e649afea0640d1d0$var$tMax ? $e649afea0640d1d0$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $e649afea0640d1d0$var$base - t;
            if (w > $e649afea0640d1d0$var$floor($e649afea0640d1d0$var$maxInt / baseMinusT)) $e649afea0640d1d0$var$error("overflow");
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $e649afea0640d1d0$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($e649afea0640d1d0$var$floor(i / out) > $e649afea0640d1d0$var$maxInt - n) $e649afea0640d1d0$var$error("overflow");
        n += $e649afea0640d1d0$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $e649afea0640d1d0$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $e649afea0640d1d0$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $e649afea0640d1d0$var$initialN;
    let delta = 0;
    let bias = $e649afea0640d1d0$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($e649afea0640d1d0$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($e649afea0640d1d0$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $e649afea0640d1d0$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $e649afea0640d1d0$var$floor(($e649afea0640d1d0$var$maxInt - delta) / handledCPCountPlusOne)) $e649afea0640d1d0$var$error("overflow");
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $e649afea0640d1d0$var$maxInt) $e649afea0640d1d0$var$error("overflow");
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $e649afea0640d1d0$var$base;; k += $e649afea0640d1d0$var$base){
                    const t = k <= bias ? $e649afea0640d1d0$var$tMin : k >= bias + $e649afea0640d1d0$var$tMax ? $e649afea0640d1d0$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $e649afea0640d1d0$var$base - t;
                    output.push($e649afea0640d1d0$var$stringFromCharCode($e649afea0640d1d0$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $e649afea0640d1d0$var$floor(qMinusT / baseMinusT);
                }
                output.push($e649afea0640d1d0$var$stringFromCharCode($e649afea0640d1d0$var$digitToBasic(q, 0)));
                bias = $e649afea0640d1d0$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join("");
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $e649afea0640d1d0$export$110c810e8727e62b = function(input) {
    return $e649afea0640d1d0$var$mapDomain(input, function(string) {
        return $e649afea0640d1d0$var$regexPunycode.test(string) ? $e649afea0640d1d0$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $e649afea0640d1d0$export$69111c4ea6e0c4a0 = function(input) {
    return $e649afea0640d1d0$var$mapDomain(input, function(string) {
        return $e649afea0640d1d0$var$regexNonASCII.test(string) ? "xn--" + $e649afea0640d1d0$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $e649afea0640d1d0$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ "version": "2.3.1",
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ "ucs2": {
        "decode": $e649afea0640d1d0$export$c1700176c90f250f,
        "encode": $e649afea0640d1d0$export$f999239d9b149395
    },
    "decode": $e649afea0640d1d0$export$2f872c0f2117be69,
    "encode": $e649afea0640d1d0$export$c564cdbbe6da493,
    "toASCII": $e649afea0640d1d0$export$69111c4ea6e0c4a0,
    "toUnicode": $e649afea0640d1d0$export$110c810e8727e62b
};
var $e649afea0640d1d0$export$2e2bcd8739ae039 = $e649afea0640d1d0$var$punycode;


// markdown-it default options
var $743941cfc289c674$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};


// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $c683691e7feff225$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
};


// Commonmark default options
var $8d67bcd91fa47a84$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
};


const $c1dfe7a9dc4f2ee7$var$config = {
    default: (0, $743941cfc289c674$export$2e2bcd8739ae039),
    zero: (0, $c683691e7feff225$export$2e2bcd8739ae039),
    commonmark: (0, $8d67bcd91fa47a84$export$2e2bcd8739ae039)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $c1dfe7a9dc4f2ee7$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $c1dfe7a9dc4f2ee7$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $c1dfe7a9dc4f2ee7$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $c1dfe7a9dc4f2ee7$var$BAD_PROTO_RE.test(str) ? $c1dfe7a9dc4f2ee7$var$GOOD_DATA_RE.test(str) : true;
}
const $c1dfe7a9dc4f2ee7$var$RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function $c1dfe7a9dc4f2ee7$var$normalizeLink(url) {
    const parsed = $d0ed4f6c1763b0c0$export$2e2bcd8739ae039(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $c1dfe7a9dc4f2ee7$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $e649afea0640d1d0$export$2e2bcd8739ae039).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $b94c6e091c4e2365$export$2e2bcd8739ae039($2f3e76a23a986122$export$2e2bcd8739ae039(parsed));
}
function $c1dfe7a9dc4f2ee7$var$normalizeLinkText(url) {
    const parsed = $d0ed4f6c1763b0c0$export$2e2bcd8739ae039(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $c1dfe7a9dc4f2ee7$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $e649afea0640d1d0$export$2e2bcd8739ae039).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $c84d8e4f87730cff$export$2e2bcd8739ae039($2f3e76a23a986122$export$2e2bcd8739ae039(parsed), $c84d8e4f87730cff$export$2e2bcd8739ae039.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $c1dfe7a9dc4f2ee7$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $c1dfe7a9dc4f2ee7$var$MarkdownIt)) return new $c1dfe7a9dc4f2ee7$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$e0c8ff411ba71ee2$exports.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $b076ee6913a9e0f0$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $9c3ac4c268ea1fcc$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $9780d61da816c228$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $0f02e281ebaa1ebe$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $d82d6b83b5911822$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $c1dfe7a9dc4f2ee7$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $c1dfe7a9dc4f2ee7$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $c1dfe7a9dc4f2ee7$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $e0c8ff411ba71ee2$exports;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $e0c8ff411ba71ee2$exports.assign({}, $3910bbf62661125f$exports);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $c1dfe7a9dc4f2ee7$var$MarkdownIt.prototype.set = function(options) {
    $e0c8ff411ba71ee2$exports.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $c1dfe7a9dc4f2ee7$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($e0c8ff411ba71ee2$exports.isString(presets)) {
        const presetName = presets;
        presets = $c1dfe7a9dc4f2ee7$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $c1dfe7a9dc4f2ee7$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $c1dfe7a9dc4f2ee7$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $c1dfe7a9dc4f2ee7$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $c1dfe7a9dc4f2ee7$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $c1dfe7a9dc4f2ee7$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $c1dfe7a9dc4f2ee7$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $c1dfe7a9dc4f2ee7$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $c1dfe7a9dc4f2ee7$export$2e2bcd8739ae039 = $c1dfe7a9dc4f2ee7$var$MarkdownIt;




var $71a0241bab23e208$exports = {};
"use strict";
Object.defineProperty($71a0241bab23e208$exports, "__esModule", {
    value: true
});
var $ab20793bc5258f1e$exports = {};
"use strict";
var $ab20793bc5258f1e$var$__assign = $ab20793bc5258f1e$exports && $ab20793bc5258f1e$exports.__assign || function() {
    $ab20793bc5258f1e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab20793bc5258f1e$var$__assign.apply(this, arguments);
};
var $ab20793bc5258f1e$var$__importStar = $ab20793bc5258f1e$exports && $ab20793bc5258f1e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty($ab20793bc5258f1e$exports, "__esModule", {
    value: true
});

var $ab20793bc5258f1e$var$factory = $ab20793bc5258f1e$var$__importStar((parcelRequire("7NOBO")));
var $06e6c416d5b86749$exports = {};
"use strict";
Object.defineProperty($06e6c416d5b86749$exports, "__esModule", {
    value: true
});
var $33f49ffb7e9b2285$exports = {};
// Myna Parsing Library
// Copyright (c) 2016 Christopher Diggins
// Usage permitted under terms of MIT License
"use strict";
var $33f49ffb7e9b2285$var$__extends = $33f49ffb7e9b2285$exports && $33f49ffb7e9b2285$exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
// A parsing combinator library for JavaScript/TypeScript based on the PEG formalism.
// For more information see http://www.github.com/cdiggins/myna-parser
var $33f49ffb7e9b2285$var$Myna;
(function(Myna) {
    // A parser error class
    var ParserError = function(_super) {
        $33f49ffb7e9b2285$var$__extends(ParserError, _super);
        function ParserError(message) {
            _super.call(this, message);
            this.type = "ParserError";
        }
        return ParserError;
    }(Error);
    Myna.ParserError = ParserError;
    //====================================================================================
    // Internal variables used by the Myna library
    // A lookup table of all grammars registered with the Myna module 
    Myna.grammars = {};
    // A lookup table of all named rules registered with the Myna module
    Myna.allRules = {};
    // A lookup table of parsing functions for each registered grammar  
    Myna.parsers = {};
    //===========================================================================
    // class ParseLocation
    // Used to indicate the location of the parser to the user in a pleasant way.
    var ParseLocation = function() {
        function ParseLocation(input, index) {
            this.input = input;
            this.index = index;
            this.lineNum = 0;
            this.colNum = 0;
            this.lineStart = 0;
            this.lineEnd = 0;
            var r1 = 0;
            var r2 = 1;
            for(var i = 0; i < this.index; ++i){
                if (this.input.charCodeAt(i) == 13) {
                    this.lineStart = i;
                    r1++;
                }
                if (this.input.charCodeAt(i) == 10) {
                    this.lineStart = i;
                    r2++;
                }
            }
            for(this.lineEnd = this.index; this.lineEnd < this.input.length; ++this.lineEnd){
                if (this.input.charCodeAt(this.lineEnd) == 13 || this.input.charCodeAt(this.lineEnd) == 10) break;
            }
            this.lineNum = r1 > r2 ? r1 : r2;
            this.colNum = this.index - this.lineStart;
            this.lineText = this.input.substring(this.lineStart, this.lineEnd);
            this.pointerText = Array(this.colNum).join(" ") + "^";
        }
        ParseLocation.prototype.toString = function() {
            return "Index " + this.index + ", Line " + this.lineNum + ", Column " + this.colNum + "\n" + this.lineText + "\n" + this.pointerText;
        };
        return ParseLocation;
    }();
    Myna.ParseLocation = ParseLocation;
    //===========================================================================
    // class ParseState
    // This stores the state of the parser and is passed to the parse and match functions.
    var ParseState = function() {
        function ParseState(input, index, nodes) {
            this.input = input;
            this.index = index;
            this.nodes = nodes;
            this.length = 0;
            this.rules = [];
            this.length = this.input.length;
        }
        Object.defineProperty(ParseState.prototype, "location", {
            // Returns an object that representation of the location. 
            get: function() {
                return new ParseLocation(this.input, this.index);
            },
            enumerable: true,
            configurable: true
        });
        return ParseState;
    }();
    Myna.ParseState = ParseState;
    // Represents a node in the generated parse tree. These nodes are returned by the Rule.parse function. If a Rule 
    // has the "_createAstNode" field set to true (because you created the rule using the ".ast" property), then the 
    // generated node will also be added to the constructed parse tree.   
    var AstNode = function() {
        // Constructs a new node associated with the given rule.  
        function AstNode(rule, input, start, end) {
            if (start === void 0) start = 0;
            if (end === void 0) end = -1;
            this.rule = rule;
            this.input = input;
            this.start = start;
            this.end = end;
            // The list of child nodes in the parse tree. 
            // This is not allocated unless used, to minimize memory consumption 
            this.children = null;
        }
        Object.defineProperty(AstNode.prototype, "name", {
            // Returns the name of the rule associated with this node
            get: function() {
                return this.rule != null ? this.rule.name : "unnamed";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "fullName", {
            // Returns the name of the rule, preceded by the grammar name, associated with this node
            get: function() {
                return this.rule != null ? this.rule.fullName : "unnamed";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "allText", {
            // Returns the parsed text associated with this node's start and end locations  
            get: function() {
                return this.input.slice(this.start, this.end);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "isLeaf", {
            // Returns true if this node has no children
            get: function() {
                return this.children == null || this.children.length == 0;
            },
            enumerable: true,
            configurable: true
        });
        // Returns the first child with the given name, or null if no named child is found. 
        AstNode.prototype.child = function(name) {
            if (this.children) for(var _i = 0, _a = this.children; _i < _a.length; _i++){
                var c = _a[_i];
                if (c.name == name) return c;
            }
            return null;
        };
        Object.defineProperty(AstNode.prototype, "_firstChildStart", {
            // The position of the first child, or the end position for the entire node if no children 
            get: function() {
                return this.isLeaf ? this.end : this.children[0].start;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "_lastChildEnd", {
            // The end position of the last child, or the end position for the entire node if no children 
            get: function() {
                return this.isLeaf ? this.end : this.children[0].end;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "beforeChildrenText", {
            // Returns the text before the children, or if no children returns the entire text. 
            get: function() {
                return this.input.slice(this.start, this._firstChildStart);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "afterChildrenText", {
            // Returns the text after the children, or if no children returns the empty string.
            get: function() {
                return this.input.slice(this._lastChildEnd, this.end);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AstNode.prototype, "allChildrenText", {
            // Returns the text from the beginning of the first child to the end of the last child.
            get: function() {
                return this.input.slice(this._firstChildStart, this._lastChildEnd);
            },
            enumerable: true,
            configurable: true
        });
        // Returns the AST as a string for debug and test purposes
        AstNode.prototype.toString = function() {
            var contents = this.isLeaf ? this.allText : this.children.map(function(c) {
                return c.toString();
            }).join(" ");
            return "(" + this.rule.name + ": " + contents + ")";
        };
        return AstNode;
    }();
    Myna.AstNode = AstNode;
    //===============================================================
    // class Rule
    // A Rule is both a rule in the PEG grammar and a parser. The parse function takes  
    // a particular parse location (in either a string, or array of tokens) and will return 
    // the location of the end of the parse if successful or null if not successful.  
    var Rule = function() {
        // Constructor
        // Note: child-rules are exposed as a public field
        function Rule(rules) {
            this.rules = rules;
            // Identifies individual rule
            this.name = "";
            // Identifies the grammar that this rule belongs to 
            this.grammarName = "";
            // Identifies types of rules. Rules can have "types" that are different than the class name
            this.type = "";
            // Used to provide access to the name of the class 
            this.className = "Rule";
            // Indicates whether generated nodes should be added to the abstract syntax tree
            this._createAstNode = false;
            // A parser function, computed in a rule's constructor. If successful returns either the original or a new 
            // ParseState object. If it fails it returns null.
            this.parser = null;
            // A lexer function, computed in a rule's constructor. The lexer may update the ParseState if successful.
            // If it fails it is required that the lexer restore the ParseState index to the previous state. 
            // Lexers should only update the index. 
            this.lexer = null;
        }
        // Creates a node with the given children. This is used to manually build parts of the AST.
        Rule.prototype.node = function(text) {
            if (text === void 0) text = "";
            var children = [];
            for(var _i = 1; _i < arguments.length; _i++)children[_i - 1] = arguments[_i];
            var r = new AstNode(this, text, 0, text.length);
            r.children = children;
            return r;
        };
        // Parses a string into an AST node
        Rule.prototype.parse = function(s) {
            return Myna.parse(this, s);
        };
        // Sets the name of the rule, and the grammar 
        // Warning: this modifies the rule, use "copy" first if you don't want to update the rule.
        Rule.prototype.setName = function(grammarName, ruleName) {
            this.grammarName = grammarName;
            this.name = ruleName;
            return this;
        };
        Object.defineProperty(Rule.prototype, "definition", {
            // Returns a default definition of the rule
            get: function() {
                return this.className + "(" + this.rules.map(function(r) {
                    return r.toString();
                }).join(", ") + ")";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "fullName", {
            // Returns the name of the rule preceded by the grammar name and a "."
            get: function() {
                return this.grammarName + "." + this.name;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "nameOrDefinition", {
            // Returns either the name of the rule, or it's definition
            get: function() {
                return this.name ? this.fullName : this.definition;
            },
            enumerable: true,
            configurable: true
        });
        // Returns a string representation of the rule 
        Rule.prototype.toString = function() {
            return this.nameOrDefinition;
        };
        Object.defineProperty(Rule.prototype, "firstChild", {
            // Returns the first child rule
            get: function() {
                return this.rules[0];
            },
            enumerable: true,
            configurable: true
        });
        // Sets the "type" associated with the rule. 
        // This is useful for tracking how a rule was created. 
        Rule.prototype.setType = function(type) {
            this.type = type;
            return this;
        };
        // Returns a copy of this rule with default values for all fields.  
        // Note: Every new rule class must override cloneImplemenation
        Rule.prototype.cloneImplementation = function() {
            throw new Error("Missing override for cloneImplementation");
        };
        Object.defineProperty(Rule.prototype, "copy", {
            // Returns a copy of this rule with all fields copied.  
            get: function() {
                var r = this.cloneImplementation();
                if (typeof r !== typeof this) throw new Error("Error in implementation of cloneImplementation: not returning object of correct type");
                r.name = this.name;
                r.grammarName = this.grammarName;
                r._createAstNode = this._createAstNode;
                return r;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "hasAstChildRule", {
            // Returns true if any of the child rules are "ast rules" meaning they create nodes in the parse tree.
            get: function() {
                return this.rules.filter(function(r) {
                    return r.createsAstNode;
                }).length > 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "createsAstNode", {
            // Returns true if this rule when parsed successfully will create a node in the parse tree. 
            // Some rules will override this function. 
            get: function() {
                return this._createAstNode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "nonAdvancing", {
            // Returns true if this rule doesn't advance the input
            get: function() {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        // Returns a string that describes the AST nodes created by this rule.
        // Will throw an exception if this is not a valid AST rule (this.isAstRule != true)
        Rule.prototype.astRuleDefn = function(inSeq, inChoice) {
            if (inSeq === void 0) inSeq = false;
            if (inChoice === void 0) inChoice = false;
            var rules = this.rules.filter(function(r) {
                return r.createsAstNode;
            });
            if (!rules.length) return this.name;
            if (rules.length == 1) {
                var result = rules[0].astRuleNameOrDefn(inSeq, inChoice);
                if (this instanceof Quantified) result += "[" + this.min + "," + this.max + "]";
                return result;
            }
            if (this instanceof Sequence) {
                var tmp = rules.map(function(r) {
                    return r.astRuleNameOrDefn(true, false);
                }).join(",");
                if (inSeq) return tmp;
                return "seq(" + tmp + ")";
            }
            if (this instanceof Choice) {
                var tmp = rules.map(function(r) {
                    return r.astRuleNameOrDefn(false, true);
                }).join(",");
                if (inChoice) return tmp;
                return "choice(" + tmp + ")";
            }
            throw new Error("Internal error: not a valid AST rule");
        };
        // Returns a string that is either the name of the AST parse node, or a definition 
        // (schema) describing the makeup of the rules. 
        Rule.prototype.astRuleNameOrDefn = function(inSeq, inChoice) {
            if (inSeq === void 0) inSeq = false;
            if (inChoice === void 0) inChoice = false;
            if (this._createAstNode) return this.name;
            return this.astRuleDefn(inSeq, inChoice);
        };
        Object.defineProperty(Rule.prototype, "opt", {
            //======================================================
            // Extensions to support method/property chaining. 
            // This is also known as a fluent API syntax
            get: function() {
                return opt(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "zeroOrMore", {
            get: function() {
                return zeroOrMore(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "oneOrMore", {
            get: function() {
                return oneOrMore(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "at", {
            get: function() {
                return at(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "not", {
            get: function() {
                return not(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "advance", {
            get: function() {
                return this.then(Myna.advance);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "ws", {
            get: function() {
                return this.then(Myna.ws);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "all", {
            get: function() {
                return this.then(Myna.all);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "end", {
            get: function() {
                return this.then(Myna.end);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "assert", {
            get: function() {
                return assert(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rule.prototype, "ast", {
            get: function() {
                return new AstRule(this);
            },
            enumerable: true,
            configurable: true
        });
        Rule.prototype.then = function(r) {
            return seq(this, r);
        };
        Rule.prototype.thenAt = function(r) {
            return this.then(at(r));
        };
        Rule.prototype.thenNot = function(r) {
            return this.then(not(r));
        };
        Rule.prototype.or = function(r) {
            return choice(this, r);
        };
        Rule.prototype.until = function(r) {
            return repeatWhileNot(this, r);
        };
        Rule.prototype.untilPast = function(r) {
            return repeatUntilPast(this, r);
        };
        Rule.prototype.repeat = function(count) {
            return repeat(this, count);
        };
        Rule.prototype.quantified = function(min, max) {
            return quantified(this, min, max);
        };
        Rule.prototype.delimited = function(delimiter) {
            return delimited(this, delimiter);
        };
        Rule.prototype.unless = function(r) {
            return unless(this, r);
        };
        return Rule;
    }();
    Myna.Rule = Rule;
    //===============================================================
    // Rule derived classes 
    // These are the core Rule classes of Myna. Normally you would not use theses directly but use the factory methods
    // If you fork this code, think twice before adding new classes here. Maybe you can implement your new Rule
    // in terms of functions or other low-level rules. Then you can be happy knowing that the same code is being 
    // re-used and tested all the time.  
    // Creates a node in the AST tree 
    var AstRule = function(_super) {
        $33f49ffb7e9b2285$var$__extends(AstRule, _super);
        function AstRule(r) {
            var _this = this;
            _super.call(this, [
                r
            ]);
            this.r = r;
            this.type = "ast";
            this.className = "AstRule";
            this._createAstNode = true;
            this.parser = function(p) {
                var originalIndex = p.index;
                var originalNodes = p.nodes;
                p.nodes = [];
                p.rules.push(_this);
                if (!r.parser(p)) {
                    p.rules.pop();
                    p.nodes = originalNodes;
                    p.index = originalIndex;
                    return false;
                } else {
                    p.rules.pop();
                    var node = new AstNode(_this, p.input, originalIndex, p.index);
                    node.children = p.nodes;
                    p.nodes = originalNodes;
                    p.nodes.push(node);
                    return true;
                }
            };
            this.lexer = r.lexer;
        }
        return AstRule;
    }(Rule);
    Myna.AstRule = AstRule;
    // Matches a series of rules in order. Succeeds only if all sub-rules succeed. 
    var Sequence = function(_super) {
        $33f49ffb7e9b2285$var$__extends(Sequence, _super);
        function Sequence(rule1, rule2) {
            _super.call(this, [
                rule1,
                rule2
            ]);
            this.rule1 = rule1;
            this.rule2 = rule2;
            this.type = "seq";
            this.className = "Sequence";
            this.parser = function(p) {
                var originalCount = p.nodes.length;
                var originalIndex = p.index;
                if (rule1.parser(p) === false) // The first parser will restore everything automatically 
                return false;
                if (rule2.parser(p) === false) {
                    // Any created nodes need to be popped off the list 
                    if (p.nodes.length !== originalCount) p.nodes.splice(-1, p.nodes.length - originalCount);
                    // Assure that the parser is restored to its original position 
                    p.index = originalIndex;
                    return false;
                }
                return true;
            };
            this.lexer = function(p) {
                var original = p.index;
                if (rule1.lexer(p) === false) return false;
                if (rule2.lexer(p) === false) {
                    p.index = original;
                    return false;
                }
                return true;
            };
            // When none of the child rules create a node, we can use the lexer to parse
            if (!this.createsAstNode) this.parser = this.lexer;
        }
        Object.defineProperty(Sequence.prototype, "definition", {
            get: function() {
                var result = this.rules.map(function(r) {
                    return r.toString();
                }).join(" ");
                if (this.rules.length > 1) result = "(" + result + ")";
                return result;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Sequence.prototype, "nonAdvancing", {
            get: function() {
                return this.rules.every(function(r) {
                    return r.nonAdvancing;
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Sequence.prototype, "createsAstNode", {
            get: function() {
                return this._createAstNode || this.hasAstChildRule;
            },
            enumerable: true,
            configurable: true
        });
        Sequence.prototype.cloneImplementation = function() {
            return new Sequence(this.rule1, this.rule2);
        };
        return Sequence;
    }(Rule);
    Myna.Sequence = Sequence;
    // Tries to match each rule in order until one succeeds. Succeeds if any of the sub-rules succeed. 
    var Choice = function(_super) {
        $33f49ffb7e9b2285$var$__extends(Choice, _super);
        function Choice(rule1, rule2) {
            _super.call(this, [
                rule1,
                rule2
            ]);
            this.rule1 = rule1;
            this.rule2 = rule2;
            this.type = "choice";
            this.className = "Choice";
            this.parser = function(p) {
                return rule1.parser(p) || rule2.parser(p);
            };
            this.lexer = function(p) {
                return rule1.lexer(p) || rule2.lexer(p);
            };
            // When none of the child rules create a node, we can use the lexer to parse
            if (!this.createsAstNode) this.parser = this.lexer;
        }
        Object.defineProperty(Choice.prototype, "definition", {
            get: function() {
                var result = this.rules.map(function(r) {
                    return r.toString();
                }).join(" / ");
                if (this.rules.length > 1) result = "(" + result + ")";
                return result;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Choice.prototype, "nonAdvancing", {
            get: function() {
                return this.rules.every(function(r) {
                    return r.nonAdvancing;
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Choice.prototype, "createsAstNode", {
            get: function() {
                return this._createAstNode || this.hasAstChildRule;
            },
            enumerable: true,
            configurable: true
        });
        Choice.prototype.cloneImplementation = function() {
            return new Choice(this.rule1, this.rule2);
        };
        return Choice;
    }(Rule);
    Myna.Choice = Choice;
    // A generalization of several rules such as zeroOrMore (0+), oneOrMore (1+), opt(0 or 1),
    // When matching with an unbounded upper limit set the maxium to  -1   
    var Quantified = function(_super) {
        $33f49ffb7e9b2285$var$__extends(Quantified, _super);
        function Quantified(rule, min, max) {
            var _this = this;
            if (min === void 0) min = 0;
            if (max === void 0) max = Infinity;
            _super.call(this, [
                rule
            ]);
            this.min = min;
            this.max = max;
            this.type = "quantified";
            this.className = "Quantified";
            if (max === Infinity && rule.nonAdvancing) throw new Error("Rule would create an infinite loop");
            this.parser = function(p) {
                var originalCount = p.nodes.length;
                var originalIndex = p.index;
                for(var i = 0; i < max; ++i){
                    // If parsing the rule fails, we return the last result, or failed 
                    // if the minimum number of matches is not met. 
                    if (rule.parser(p) === false) {
                        if (i >= min) return true;
                        // Any created nodes need to be popped off the list 
                        if (p.nodes.length !== originalCount) p.nodes.splice(-1, p.nodes.length - originalCount);
                        // Assure that the parser is restored to its original position 
                        p.index = originalIndex;
                        return false;
                    }
                    // Check for progress, to assure we aren't hitting an infinite loop  
                    debugAssert(max !== Infinity || p.index !== originalIndex, _this);
                }
                return true;
            };
            this.lexer = function(p) {
                var originalIndex = p.index;
                for(var i = 0; i < max; ++i){
                    if (rule.lexer(p) === false) {
                        if (i >= min) return true;
                        p.index = originalIndex;
                        return false;
                    }
                    // Check for progress, to assure we aren't hitting an infinite loop  
                    debugAssert(max !== Infinity || p.index !== originalIndex, _this, "Infinite loop");
                }
                return true;
            };
            // When none of the child rules create a node, we can use the lexer to parse
            if (!this.createsAstNode) this.parser = this.lexer;
        }
        Object.defineProperty(Quantified.prototype, "definition", {
            // Used for creating a human readable definition of the grammar.
            get: function() {
                if (this.min == 0 && this.max == 1) return this.firstChild.toString() + "?";
                if (this.min == 0 && this.max == Infinity) return this.firstChild.toString() + "*";
                if (this.min == 1 && this.max == Infinity) return this.firstChild.toString() + "+";
                return this.firstChild.toString() + "{" + this.min + "," + this.max + "}";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Quantified.prototype, "createsAstNode", {
            get: function() {
                return this._createAstNode || this.hasAstChildRule;
            },
            enumerable: true,
            configurable: true
        });
        Quantified.prototype.cloneImplementation = function() {
            return new Quantified(this.firstChild, this.min, this.max);
        };
        return Quantified;
    }(Rule);
    Myna.Quantified = Quantified;
    // Matches a child rule zero or once. 
    var Optional = function(_super) {
        $33f49ffb7e9b2285$var$__extends(Optional, _super);
        function Optional(rule) {
            _super.call(this, rule, 0, 1);
            this.type = "optional";
            this.className = "Optional";
            this.parser = function(p) {
                rule.parser(p);
                return true;
            };
            this.lexer = function(p) {
                rule.lexer(p);
                return true;
            };
            // When none of the child rules create a node, we can use the lexer to parse
            if (!this.createsAstNode) this.parser = this.lexer;
        }
        Object.defineProperty(Optional.prototype, "definition", {
            // Used for creating a human readable definition of the grammar.
            get: function() {
                return this.firstChild.toString() + "?";
            },
            enumerable: true,
            configurable: true
        });
        Optional.prototype.cloneImplementation = function() {
            return new Optional(this.firstChild);
        };
        return Optional;
    }(Quantified);
    Myna.Optional = Optional;
    // Advances the parser by one token unless at the end
    var Advance = function(_super) {
        $33f49ffb7e9b2285$var$__extends(Advance, _super);
        function Advance() {
            _super.call(this, []);
            this.type = "advance";
            this.className = "Advance";
            this.lexer = function(p) {
                return p.index < p.length ? ++p.index >= 0 : false;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(Advance.prototype, "definition", {
            get: function() {
                return "<advance>";
            },
            enumerable: true,
            configurable: true
        });
        Advance.prototype.cloneImplementation = function() {
            return new Advance();
        };
        return Advance;
    }(Rule);
    Myna.Advance = Advance;
    // Advances the parser by one token if the predicate is true.
    var AdvanceIf = function(_super) {
        $33f49ffb7e9b2285$var$__extends(AdvanceIf, _super);
        function AdvanceIf(condition) {
            _super.call(this, [
                condition
            ]);
            this.type = "advanceIf";
            this.className = "AdvanceIf";
            this.lexer = function(p) {
                return condition.lexer(p) && p.index < p.length ? ++p.index !== 0 : false;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(AdvanceIf.prototype, "definition", {
            get: function() {
                return "advanceIf(" + this.firstChild.toString() + ")";
            },
            enumerable: true,
            configurable: true
        });
        AdvanceIf.prototype.cloneImplementation = function() {
            return new AdvanceIf(this.firstChild);
        };
        return AdvanceIf;
    }(Rule);
    Myna.AdvanceIf = AdvanceIf;
    // Used to match a string in the input string, advances the token. 
    var Text = function(_super) {
        $33f49ffb7e9b2285$var$__extends(Text, _super);
        function Text(text) {
            _super.call(this, []);
            this.text = text;
            this.type = "text";
            this.className = "Text";
            var length = text.length;
            var vals = [];
            for(var i = 0; i < length; ++i)vals.push(text.charCodeAt(i));
            this.lexer = function(p) {
                var index = p.index;
                if (index + vals.length > p.input.length) return false;
                // TODO: consider pulling the sub-string out of the text.        
                for(var _i = 0, vals_1 = vals; _i < vals_1.length; _i++){
                    var val = vals_1[_i];
                    if (p.input.charCodeAt(index++) !== val) return false;
                }
                p.index = index;
                return true;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(Text.prototype, "definition", {
            get: function() {
                return '"' + escapeChars(this.text) + '"';
            },
            enumerable: true,
            configurable: true
        });
        Text.prototype.cloneImplementation = function() {
            return new Text(this.text);
        };
        return Text;
    }(Rule);
    Myna.Text = Text;
    // Used to match a string in the input string ignoring case, advances the token. 
    var AnyCaseText = function(_super) {
        $33f49ffb7e9b2285$var$__extends(AnyCaseText, _super);
        function AnyCaseText(text) {
            _super.call(this, []);
            this.text = text;
            this.type = "anyCaseText";
            this.className = "AnyCaseText";
            text = text.toLowerCase();
            this.text = text;
            var length = text.length;
            var vals = [];
            for(var i = 0; i < length; ++i)vals.push(text[i]);
            this.lexer = function(p) {
                var index = p.index;
                if (index + vals.length > p.input.length) return false;
                for(var _i = 0, vals_2 = vals; _i < vals_2.length; _i++){
                    var val = vals_2[_i];
                    if (p.input[index++].toLowerCase() !== val) return false;
                }
                p.index = index;
                return true;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(AnyCaseText.prototype, "definition", {
            get: function() {
                return 'AnyCase("' + escapeChars(this.text) + '")';
            },
            enumerable: true,
            configurable: true
        });
        AnyCaseText.prototype.cloneImplementation = function() {
            return new AnyCaseText(this.text);
        };
        return AnyCaseText;
    }(Rule);
    Myna.AnyCaseText = AnyCaseText;
    // Creates a rule that is defined from a function that generates the rule. 
    // This allows two rules to have a cyclic relation. 
    var Delay = function(_super) {
        $33f49ffb7e9b2285$var$__extends(Delay, _super);
        function Delay(fn) {
            _super.call(this, []);
            this.fn = fn;
            this.type = "delay";
            this.className = "Delay";
            var tmpParser = null;
            this.parser = function(p) {
                return (tmpParser ? tmpParser : tmpParser = fn().parser)(p);
            };
            var tmpLexer = null;
            this.lexer = function(p) {
                return (tmpLexer ? tmpLexer : tmpLexer = fn().lexer)(p);
            };
        }
        Delay.prototype.cloneImplementation = function() {
            return new Delay(this.fn);
        };
        Object.defineProperty(Delay.prototype, "definition", {
            get: function() {
                return "<delay>";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Delay.prototype, "createsAstNode", {
            // It is assumed that a delay function creates an AST node,
            get: function() {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        return Delay;
    }(Rule);
    Myna.Delay = Delay;
    //====================================================================================================================
    // Predicates don't advance the input 
    // Used to identify rules that do not advance the input
    var NonAdvancingRule = function(_super) {
        $33f49ffb7e9b2285$var$__extends(NonAdvancingRule, _super);
        function NonAdvancingRule(rules) {
            _super.call(this, rules);
            this.type = "charSet";
        }
        Object.defineProperty(NonAdvancingRule.prototype, "nonAdvancing", {
            get: function() {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        return NonAdvancingRule;
    }(Rule);
    Myna.NonAdvancingRule = NonAdvancingRule;
    // Returns true if the current token is in the token set. 
    var CharSet = function(_super) {
        $33f49ffb7e9b2285$var$__extends(CharSet, _super);
        function CharSet(chars) {
            _super.call(this, []);
            this.chars = chars;
            this.type = "charSet";
            this.className = "CharSet";
            var vals = [];
            var length = chars.length;
            for(var i = 0; i < length; ++i)vals[i] = chars.charCodeAt(i);
            this.lexer = function(p) {
                // TODO: Try this instead, could be faster.
                // chars.indexOf(p.input[p.index]) >= 0;
                return vals.indexOf(p.input.charCodeAt(p.index)) >= 0;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(CharSet.prototype, "definition", {
            get: function() {
                return "[" + escapeChars(this.chars) + "]";
            },
            enumerable: true,
            configurable: true
        });
        CharSet.prototype.cloneImplementation = function() {
            return new CharSet(this.chars);
        };
        return CharSet;
    }(NonAdvancingRule);
    Myna.CharSet = CharSet;
    // Returns true if the current token is within a range of characters, otherwise returns false
    var CharRange = function(_super) {
        $33f49ffb7e9b2285$var$__extends(CharRange, _super);
        function CharRange(min, max) {
            _super.call(this, []);
            this.min = min;
            this.max = max;
            this.type = "charRange";
            this.className = "CharRange";
            var minCode = min.charCodeAt(0);
            var maxCode = max.charCodeAt(0);
            this.lexer = function(p) {
                var code = p.input.charCodeAt(p.index);
                return code >= minCode && code <= maxCode;
            };
            this.parser = this.lexer;
        }
        Object.defineProperty(CharRange.prototype, "definition", {
            get: function() {
                return "[" + this.min + ".." + this.max + "]";
            },
            enumerable: true,
            configurable: true
        });
        CharRange.prototype.cloneImplementation = function() {
            return new CharRange(this.min, this.max);
        };
        return CharRange;
    }(NonAdvancingRule);
    Myna.CharRange = CharRange;
    // Returns true only if the child rule fails to match.
    var Not = function(_super) {
        $33f49ffb7e9b2285$var$__extends(Not, _super);
        function Not(rule) {
            _super.call(this, [
                rule
            ]);
            this.type = "not";
            this.className = "Not";
            var childLexer = rule.lexer;
            this.lexer = function(p) {
                if (p.index >= p.length) return true;
                var index = p.index;
                if (childLexer(p) === false) return true;
                p.index = index;
                return false;
            };
            this.parser = this.lexer;
        }
        Not.prototype.cloneImplementation = function() {
            return new Not(this.firstChild);
        };
        Object.defineProperty(Not.prototype, "definition", {
            get: function() {
                return "!" + this.firstChild.toString();
            },
            enumerable: true,
            configurable: true
        });
        return Not;
    }(NonAdvancingRule);
    Myna.Not = Not;
    // Returns true only if the child rule matches, but does not advance the parser
    var At = function(_super) {
        $33f49ffb7e9b2285$var$__extends(At, _super);
        function At(rule) {
            _super.call(this, [
                rule
            ]);
            this.type = "at";
            this.className = "At";
            var childLexer = rule.lexer;
            this.lexer = function(p) {
                var index = p.index;
                if (childLexer(p) === false) return false;
                p.index = index;
                return true;
            };
            this.parser = this.lexer;
        }
        At.prototype.cloneImplementation = function() {
            return new At(this.firstChild);
        };
        Object.defineProperty(At.prototype, "definition", {
            get: function() {
                return "&" + this.firstChild.toString();
            },
            enumerable: true,
            configurable: true
        });
        return At;
    }(NonAdvancingRule);
    Myna.At = At;
    // Uses a function to return true or not based on the behavior of the predicate rule
    var Predicate = function(_super) {
        $33f49ffb7e9b2285$var$__extends(Predicate, _super);
        function Predicate(fn) {
            _super.call(this, []);
            this.fn = fn;
            this.type = "predicate";
            this.className = "Predicate";
            this.lexer = fn;
            this.parser = this.lexer;
        }
        Predicate.prototype.cloneImplementation = function() {
            return new Predicate(this.fn);
        };
        Object.defineProperty(Predicate.prototype, "definition", {
            get: function() {
                return "<predicate>";
            },
            enumerable: true,
            configurable: true
        });
        return Predicate;
    }(NonAdvancingRule);
    Myna.Predicate = Predicate;
    //===============================================================
    // Rule creation function
    // Create a rule that matches the text 
    function text(text) {
        return new Text(text);
    }
    Myna.text = text;
    // Create a rule that matches the text 
    function textAnyCase(text) {
        return new AnyCaseText(text);
    }
    Myna.textAnyCase = textAnyCase;
    // Creates a rule that matches a series of rules in order, and succeeds if they all do
    function seq() {
        var rules = [];
        for(var _i = 0; _i < arguments.length; _i++)rules[_i - 0] = arguments[_i];
        var rs = rules.map(RuleTypeToRule);
        if (rs.length == 0) throw new Error("At least one rule is expected when calling `seq`");
        if (rs.length == 1) return rs[0];
        var rule1 = rs[0];
        var rule2 = seq.apply(void 0, rs.slice(1));
        if (rule1.nonAdvancing && rule2 instanceof Advance) return new AdvanceIf(rule1);
        else return new Sequence(rule1, rule2);
    }
    Myna.seq = seq;
    // Creates a rule that tries to match each rule in order, and succeeds if at least one does 
    function choice() {
        var rules = [];
        for(var _i = 0; _i < arguments.length; _i++)rules[_i - 0] = arguments[_i];
        var rs = rules.map(RuleTypeToRule);
        if (rs.length == 0) throw new Error("At least one rule is expected when calling `choice`");
        if (rs.length == 1) return rs[0];
        var rule1 = rs[0];
        var rule2 = choice.apply(void 0, rs.slice(1));
        if (rule1 instanceof AdvanceIf && rule2 instanceof AdvanceIf) return new AdvanceIf(choice(rule1.firstChild, rule2.firstChild));
        else return new Choice(rule1, rule2);
    }
    Myna.choice = choice;
    // Enables Rules to be defined in terms of variables that are defined later on.
    // This enables recursive rule definitions.  
    function delay(fxn) {
        return new Delay(fxn);
    }
    Myna.delay = delay;
    // Parses successfully if the given rule does not match the input at the current location  
    function not(rule) {
        return new Not(RuleTypeToRule(rule));
    }
    Myna.not = not;
    // Returns true if the rule successfully matches, but does not advance the parser index. 
    function at(rule) {
        return new At(RuleTypeToRule(rule));
    }
    Myna.at = at;
    // Attempts to apply a rule between min and max number of times inclusive. If the maximum is set to Infinity, 
    // it will attempt to match as many times as it can, but throw an exception if the parser does not advance 
    function quantified(rule, min, max) {
        if (min === void 0) min = 0;
        if (max === void 0) max = Infinity;
        if (min === 0 && max === 1) return new Optional(RuleTypeToRule(rule));
        else return new Quantified(RuleTypeToRule(rule), min, max);
    }
    Myna.quantified = quantified;
    // Attempts to apply the rule 0 or more times. Will always succeed unless the parser does not 
    // advance, in which case an exception is thrown.    
    function zeroOrMore(rule) {
        return quantified(rule).setType("zeroOrMore");
    }
    Myna.zeroOrMore = zeroOrMore;
    // Attempts to apply the rule 1 or more times. Will throw an exception if the parser does not advance.  
    function oneOrMore(rule) {
        return quantified(rule, 1).setType("oneOrMore");
    }
    Myna.oneOrMore = oneOrMore;
    // Attempts to match a rule 0 or 1 times. Always succeeds.   
    function opt(rule) {
        return quantified(rule, 0, 1).setType("optional");
    }
    Myna.opt = opt;
    // Attempts to apply a rule a precise number of times
    function repeat(rule, count) {
        return quantified(rule, count, count).setType("repeat");
    }
    Myna.repeat = repeat;
    // Returns true if one of the characters are present. Does not advances the parser position.
    function atChar(chars) {
        return new CharSet(chars);
    }
    Myna.atChar = atChar;
    // Returns true if none of the characters are present. Does not advances the parser position.
    function notAtChar(chars) {
        return atChar(chars).not;
    }
    Myna.notAtChar = notAtChar;
    // Advances parser if one of the characters are present.
    function char(chars) {
        return atChar(chars).advance;
    }
    Myna.char = char;
    // Advances parser if none of the characters are present.
    function notChar(chars) {
        return notAtChar(chars).advance;
    }
    Myna.notChar = notChar;
    // Advances if one of the characters are present, or returns false
    function atRange(min, max) {
        return new CharRange(min, max);
    }
    Myna.atRange = atRange;
    // Advances if one of the characters are present, or returns false
    function range(min, max) {
        return atRange(min, max).advance;
    }
    Myna.range = range;
    // Returns true if on of the characters are not in the range, but does not advance the parser position
    function notRange(min, max) {
        return range(min, max).not;
    }
    Myna.notRange = notRange;
    // Repeats a rule zero or more times, with a delimiter between each one. 
    function delimited(rule, delimiter) {
        return opt(seq(rule, seq(delimiter, rule).zeroOrMore)).setType("delimitedList");
    }
    Myna.delimited = delimited;
    // Executes the rule, if the condition is not true
    function unless(rule, condition) {
        return seq(not(condition), rule).setType("unless");
    }
    Myna.unless = unless;
    // Repeats the rule while the condition is not true
    function repeatWhileNot(body, condition) {
        return unless(body, condition).zeroOrMore.setType("repeatWhileNot");
    }
    Myna.repeatWhileNot = repeatWhileNot;
    // Repeats the rule while the condition is not true, but must execute at least once 
    function repeatOneOrMoreWhileNot(body, condition) {
        return not(condition).then(body).then(repeatWhileNot(body, condition)).setType("repeatOneOrMoreWhileNot");
    }
    Myna.repeatOneOrMoreWhileNot = repeatOneOrMoreWhileNot;
    // Repeats the rule until just after the condition is true once 
    function repeatUntilPast(body, condition) {
        return repeatWhileNot(body, condition).then(condition).setType("repeatUntilPast");
    }
    Myna.repeatUntilPast = repeatUntilPast;
    // Repeats the rule until just after the condition is true once but must execute at least once 
    function repeatOneOrMoreUntilPast(body, condition) {
        return not(condition).then(body).then(repeatUntilPast(body, condition)).setType("repeatOneOrMoreUntilPast");
    }
    Myna.repeatOneOrMoreUntilPast = repeatOneOrMoreUntilPast;
    // Advances the parse state while the rule is not true. 
    function advanceWhileNot(rule) {
        return repeatWhileNot(Myna.advance, rule).setType("advanceWhileNot");
    }
    Myna.advanceWhileNot = advanceWhileNot;
    // Advances the parse state while the rule is not true but must execute ast least once 
    function advanceOneOrMoreWhileNot(rule) {
        return repeatOneOrMoreWhileNot(Myna.advance, rule).setType("advanceOneOrMoreWhileNot");
    }
    Myna.advanceOneOrMoreWhileNot = advanceOneOrMoreWhileNot;
    // Advance the parser until just after the rule is executed 
    function advanceUntilPast(rule) {
        return repeatUntilPast(Myna.advance, rule).setType("advanceUntilPast");
    }
    Myna.advanceUntilPast = advanceUntilPast;
    // Advance the parser until just after the rule is executed, but must execute at least once  
    function advanceOneOrMoreUntilPast(rule) {
        return repeatOneOrMoreUntilPast(Myna.advance, rule).setType("advanceOneOrMoreUntilPast");
    }
    Myna.advanceOneOrMoreUntilPast = advanceOneOrMoreUntilPast;
    // Advances the parser unless the rule is true. 
    function advanceUnless(rule) {
        return Myna.advance.unless(rule).setType("advanceUnless");
    }
    Myna.advanceUnless = advanceUnless;
    // Parses successfully if  the predictate passes
    function predicate(fn) {
        return new Predicate(fn);
    }
    Myna.predicate = predicate;
    // Executes an action when arrived at and continues 
    function action(fn) {
        return predicate(function(p) {
            fn(p);
            return true;
        }).setType("action");
    }
    Myna.action = action;
    // Logs a message as an action 
    function log(msg) {
        if (msg === void 0) msg = "";
        return action(function(p) {
            console.log(msg);
        }).setType("log");
    }
    Myna.log = log;
    // Throw a Error if reached 
    function err(message) {
        return action(function(p) {
            var e = new ParserError(message + "\n" + p.location.toString());
            throw e;
        }).setType("err");
    }
    Myna.err = err;
    // Asserts that the rule is executed 
    // This has to be embedded in a function because the rule might be in a circular definition.  
    function assert(rule) {
        return choice(rule, err("Expected: " + RuleTypeToRule(rule)));
    }
    Myna.assert = assert;
    // If first part of a guarded sequence passes then each subsequent rule must pass as well 
    // otherwise an exception occurs. This helps create parsers that fail fast, and thus provide
    // better feedback for badly formed input.      
    function guardedSeq(condition) {
        var rules = [];
        for(var _i = 1; _i < arguments.length; _i++)rules[_i - 1] = arguments[_i];
        return seq(condition, seq.apply(void 0, rules.map(function(r) {
            return assert(r);
        }))).setType("guardedSeq");
    }
    Myna.guardedSeq = guardedSeq;
    // Parses the given rule surrounded by double quotes 
    function doubleQuoted(rule) {
        return guardedSeq('"', rule, assert('"')).setType("doubleQuoted");
    }
    Myna.doubleQuoted = doubleQuoted;
    // Parses a double quoted string, taking into account special escape rules
    function doubleQuotedString(escape) {
        return doubleQuoted(choice(escape, notChar('"').zeroOrMore)).setType("doubleQuotedString");
    }
    Myna.doubleQuotedString = doubleQuotedString;
    // Parses the given rule surrounded by single quotes 
    function singleQuoted(rule) {
        return guardedSeq("'", rule, assert("'")).setType("singleQuoted");
    }
    Myna.singleQuoted = singleQuoted;
    // Parses a singe quoted string, taking into account special escape rules
    function singleQuotedString(escape) {
        return singleQuoted(choice(escape, notChar("'").zeroOrMore)).setType("singleQuotedString");
    }
    Myna.singleQuotedString = singleQuotedString;
    // Parses the given rule surrounded by parentheses, and consumes whitespace  
    function parenthesized(rule) {
        return guardedSeq("(", Myna.ws, rule, Myna.ws, ")").setType("parenthesized");
    }
    Myna.parenthesized = parenthesized;
    // Parses the given rule surrounded by curly braces, and consumes whitespace 
    function braced(rule) {
        return guardedSeq("{", Myna.ws, rule, Myna.ws, "}").setType("braced");
    }
    Myna.braced = braced;
    // Parses the given rule surrounded by square brackets, and consumes whitespace 
    function bracketed(rule) {
        return guardedSeq("[", Myna.ws, rule, Myna.ws, "]").setType("bracketed");
    }
    Myna.bracketed = bracketed;
    // Parses the given rule surrounded by angle brackets, and consumes whitespace 
    function tagged(rule) {
        return guardedSeq("<", Myna.ws, rule, Myna.ws, ">").setType("tagged");
    }
    Myna.tagged = tagged;
    // A complete identifier, with no other letters or numbers
    function keyword(text) {
        return seq(text, not(Myna.identifierNext)).setType("keyword");
    }
    Myna.keyword = keyword;
    // A complete identifier, with no other letters or numbers, but case insensitive
    function keywordAnyCase(text) {
        return seq(textAnyCase(text), not(Myna.identifierNext)).setType("keywordAnyCase");
    }
    Myna.keywordAnyCase = keywordAnyCase;
    // Chooses one of a a list of identifiers
    function keywords() {
        var words = [];
        for(var _i = 0; _i < arguments.length; _i++)words[_i - 0] = arguments[_i];
        return choice.apply(void 0, words.map(keyword));
    }
    Myna.keywords = keywords;
    //===============================================================    
    // Core grammar rules 
    Myna.truePredicate = new Predicate(function(p) {
        return true;
    });
    Myna.falsePredicate = new Predicate(function(p) {
        return false;
    });
    Myna.end = new Predicate(function(p) {
        return p.index >= p.length;
    });
    Myna.notEnd = new Predicate(function(p) {
        return p.index < p.length;
    });
    Myna.advance = new Advance();
    Myna.all = Myna.advance.zeroOrMore;
    Myna.atLetterLower = atRange("a", "z");
    Myna.atLetterUpper = atRange("A", "Z");
    Myna.atLetter = choice(Myna.atLetterLower, Myna.atLetterUpper);
    Myna.atDigit = atRange("0", "9");
    Myna.atDigitNonZero = atRange("1", "9");
    Myna.atHexDigit = choice(Myna.atDigit, atRange("a", "f"), atRange("A", "F"));
    Myna.atBinaryDigit = atChar("01");
    Myna.atOctalDigit = atRange("0", "7");
    Myna.atAlphaNumeric = choice(Myna.atLetter, Myna.atDigit);
    Myna.atUnderscore = atChar("_");
    Myna.atSpace = atChar(" ");
    Myna.atTab = atChar("	");
    Myna.atWs = atChar(" 	\r\n\xa0\uFEFF");
    Myna.atIdentifierNext = choice(Myna.atAlphaNumeric, Myna.atUnderscore);
    Myna.letterLower = Myna.atLetterLower.advance;
    Myna.letterUpper = Myna.atLetterUpper.advance;
    Myna.letter = Myna.atLetter.advance;
    Myna.letters = Myna.letter.oneOrMore;
    Myna.digit = Myna.atDigit.advance;
    Myna.digitNonZero = Myna.atDigitNonZero.advance;
    Myna.digits = Myna.digit.oneOrMore;
    Myna.integer = char("0").or(Myna.digits);
    Myna.hexDigit = Myna.atHexDigit.advance;
    Myna.binaryDigit = Myna.atBinaryDigit.advance;
    Myna.octalDigit = Myna.atOctalDigit.advance;
    Myna.alphaNumeric = Myna.atAlphaNumeric.advance;
    Myna.underscore = Myna.atUnderscore.advance;
    Myna.identifierFirst = choice(Myna.atLetter, Myna.atUnderscore).advance;
    Myna.identifierNext = choice(Myna.atAlphaNumeric, Myna.atUnderscore).advance;
    Myna.identifier = seq(Myna.identifierFirst, Myna.identifierNext.zeroOrMore);
    Myna.hyphen = text("-");
    Myna.crlf = text("\r\n");
    Myna.newLine = choice(Myna.crlf, "\n");
    Myna.space = text(" ");
    Myna.tab = text("	");
    // JSON definition of white-space 
    Myna.ws = Myna.atWs.advance.zeroOrMore;
    //===============================================================
    // Parsing function 
    // Returns an array of nodes created by parsing the given rule repeatedly until 
    // it fails or the end of the input is arrived. One Astnode is created for each time 
    // the token is parsed successfully, whether or not it explicitly has the "_createAstNode" 
    // flag set explicitly. 
    function tokenize(r, s) {
        var result = this.parse(r.ast.zeroOrMore, s);
        return result ? result.children : [];
    }
    Myna.tokenize = tokenize;
    // Returns the root node of the abstract syntax tree created 
    // by parsing the rule.  
    function parse(r, s) {
        var p = new ParseState(s, 0, []);
        if (!(r instanceof AstRule)) r = r.ast;
        if (!r.parser(p)) return null;
        return p && p.nodes ? p.nodes[0] : null;
    }
    Myna.parse = parse;
    //===============================================================
    // Grammar functions 
    // The following are helper functions for grammar objects. A grammar is a loosely defined concept.
    // It is any JavaScript object where one or more member fields are instances of the Rule class.    
    // Returns all rules that belong to a specific grammar and that create AST nodes. 
    function grammarAstRules(grammarName) {
        return grammarRules(grammarName).filter(function(r) {
            return r._createAstNode;
        });
    }
    Myna.grammarAstRules = grammarAstRules;
    // Returns all rules that belong to a specific grammar
    function grammarRules(grammarName) {
        return allGrammarRules().filter(function(r) {
            return r.grammarName == grammarName;
        });
    }
    Myna.grammarRules = grammarRules;
    // Returns all rules as an array sorted by name.
    function allGrammarRules() {
        return Object.keys(Myna.allRules).sort().map(function(k) {
            return Myna.allRules[k];
        });
    }
    Myna.allGrammarRules = allGrammarRules;
    // Returns an array of names of the grammars
    function grammarNames() {
        return Object.keys(Myna.grammars).sort();
    }
    Myna.grammarNames = grammarNames;
    // Creates a string representation of a grammar 
    function grammarToString(grammarName) {
        return grammarRules(grammarName).map(function(r) {
            return r.fullName + " <- " + r.definition;
        }).join("\n");
    }
    Myna.grammarToString = grammarToString;
    // Creates a string representation of the AST schema generated by parsing the grammar 
    function astSchemaToString(grammarName) {
        return grammarAstRules(grammarName).map(function(r) {
            return r.name + " <- " + r.astRuleDefn();
        }).join("\n");
    }
    Myna.astSchemaToString = astSchemaToString;
    // Initializes and register a grammar object and all of the rules. 
    // Sets names for all of the rules from the name of the field it is associated with combined with the 
    // name of the grammar. Each rule is stored in Myna.rules and each grammar is stored in Myna.grammars. 
    function registerGrammar(grammarName, grammar, defaultRule) {
        for(var k in grammar)if (grammar[k] instanceof Rule) {
            var rule = grammar[k];
            rule.setName(grammarName, k);
            Myna.allRules[rule.fullName] = rule;
        }
        Myna.grammars[grammarName] = grammar;
        if (defaultRule) Myna.parsers[grammarName] = function(text) {
            return parse(defaultRule, text);
        };
        return grammar;
    }
    Myna.registerGrammar = registerGrammar;
    //===========================================================================
    // Utility functions
    // Replaces characters with the JSON escaped version
    function escapeChars(text) {
        var r = JSON.stringify(text);
        return r.slice(1, r.length - 1);
    }
    Myna.escapeChars = escapeChars;
    // Given a RuleType returns an instance of a Rule.
    function RuleTypeToRule(rule) {
        if (rule instanceof Rule) return rule;
        if (typeof rule === "string") return text(rule);
        if (typeof rule === "boolean") return rule ? Myna.truePredicate : Myna.falsePredicate;
        throw new Error("Invalid rule type: " + rule);
    }
    Myna.RuleTypeToRule = RuleTypeToRule;
    // These should be commented out in the filnal version 
    function debugAssert(condition, rule, message) {
        if (!condition) throw new Error("Error occured while parsing rule: " + rule.fullName + " " + (message || ""));
    }
    Myna.debugAssert = debugAssert;
    //===========================================================================
    // Initialization
    // The entire module is a grammar because it is an object that exposes rules as properties
    registerGrammar("core", Myna, null);
})($33f49ffb7e9b2285$var$Myna = $33f49ffb7e9b2285$exports.Myna || ($33f49ffb7e9b2285$exports.Myna = {}));
if (0, $33f49ffb7e9b2285$exports) {
    $33f49ffb7e9b2285$exports = $33f49ffb7e9b2285$var$Myna;
    // When importing from TypeScript the imports expect a "Myna" variable 
    $33f49ffb7e9b2285$exports.Myna = $33f49ffb7e9b2285$var$Myna;
}


var $725e2bcd7c9326f6$exports = {};
"use strict";
var $725e2bcd7c9326f6$var$__spreadArrays = $725e2bcd7c9326f6$exports && $725e2bcd7c9326f6$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($725e2bcd7c9326f6$exports, "__esModule", {
    value: true
});
// tslint:disable-next-line: max-func-body-length
function $725e2bcd7c9326f6$var$speechMarkdownGrammar(myna) {
    var m = myna;
    // Override parenthesis function to not use `.guardedSeq`
    // This sequence is too assertive, and may cause exceptions rather than just returning null
    m.parenthesized = function(rule) {
        return m.seq("(", m.ws, rule, m.ws, ")").setType("parenthesized");
    };
    // tslint:disable-next-line: typedef
    // tslint:disable-next-line: max-func-body-length
    var g = new function() {
        //         // Allows the "inline" to be referenced before it is defined.
        //         // This enables recursive definitions.
        //         this.inlineDelayed = m.delay(() => this.inline);
        //         this.boundedInline = function(begin: any, end: any) : any {
        // // tslint:disable-next-line: no-parameter-reassignment
        //             if (end === undefined) { end = begin; }
        //             return m.seq(begin, this.inlineDelayed.unless(end).zeroOrMore, end);
        //         }
        // Plain text
        var specialCharSet = "[]()";
        var specialCharSetEmphasis = "[]()*~`@#\\_!+-";
        var ws = m.char(" 	").oneOrMore;
        var optWs = ws.opt;
        var wsOrNewLine = ws.or(m.newLine);
        var nonSpecialChar = m.notChar(specialCharSetEmphasis).unless(m.newLine);
        var nonSpecialCharEmphasis = m.notChar(specialCharSet).unless(m.newLine);
        var quoteChar = m.notChar('"');
        /*
         xsd:token - XML Schema2 section 3.3.2
         token represents tokenized strings.
         The ·value space· of token is the set of strings that do not contain the
         carriage return (#xD), line feed (#xA) nor tab (#x9) characters, that have
         no leading or trailing spaces (#x20) and that have no internal sequences
         of two or more spaces. The ·lexical space· of token is the set of strings
         that do not contain the carriage return (#xD), line feed (#xA) nor
         tab (#x9) characters, that have no leading or trailing spaces (#x20) and
         that have no internal sequences of two or more spaces.
    
         This implementation plays very loose with the definition.
         */ this.xsdToken = m.choice(m.digits, m.letters, m.char(specialCharSetEmphasis)).oneOrMore.ast;
        this.plainText = m.choice(m.digits, m.letters, ws, nonSpecialChar).oneOrMore.ast;
        this.plainTextEmphasis = m.choice(m.digits, m.letters, ws, nonSpecialChar).oneOrMore.ast;
        var plainTextChoice = m.choice(m.digits, m.letters, ws, nonSpecialCharEmphasis);
        this.plainTextModifier = plainTextChoice.oneOrMore.ast;
        this.plainTextPhone = m.seq(m.parenthesized(m.digits), plainTextChoice.oneOrMore).ast;
        this.plainTextSpecialChars = m.choice(m.seq("(", plainTextChoice, ") "), m.seq("[", plainTextChoice, "] "), m.choice.apply(m, specialCharSetEmphasis.split("")).oneOrMore).oneOrMore.ast;
        // Audio
        this.urlSpecialChar = m.char(":/.-_~?#[]@!+,;%=()&");
        this.url = m.choice(m.digit, m.letter, this.urlSpecialChar).oneOrMore.ast;
        this.audio = m.seq("![", m.choice(m.singleQuoted(this.url), m.doubleQuoted(this.url)), "]").ast;
        // Break
        this.timeUnit = m.choice("s", "ms").ast;
        this.fraction = m.seq(".", m.digit.zeroOrMore);
        this.number = m.seq(m.integer, this.fraction.opt).ast;
        this.time = m.seq(this.number, this.timeUnit).ast;
        this.shortBreak = m.seq("[", this.time, "]").ast;
        // Silence
        this.silenceTypeValue = m.choice("Leading", "Tailing", "Sentenceboundary").ast;
        this.silenceData = m.seq(this.silenceTypeValue, " ", this.time).ast;
        this.silence = m.seq("[", "silence", ":", m.choice(m.singleQuoted(this.silenceData), m.doubleQuoted(this.silenceData)), "]").ast;
        // Backgroundaudio
        this.backgroundData = m.seq(" ", this.url);
        this.backgroundAudio = m.seq("[", "backgroundaudio", ":", m.choice(m.singleQuoted(m.seq(this.url, this.backgroundData.zeroOrMore).ast), m.doubleQuoted(m.seq(this.url, this.backgroundData.zeroOrMore).ast)), "]").ast;
        // Lexicon
        this.lexicon = m.seq("[", "lexicon", ":", m.choice(m.singleQuoted(this.url), m.doubleQuoted(this.url)), "]").ast;
        // Bookmark
        this.bookmarkChar = m.char(".-_");
        this.bookmarkString = m.choice(m.digit, m.letter, this.bookmarkChar).oneOrMore.ast;
        this.bookmark = m.seq("[", "bookmark", ":", m.choice(m.singleQuoted(this.bookmarkString), m.doubleQuoted(this.bookmarkString)), "]").ast;
        // this.string = m.choice(m.doubleQuotedString(), m.singleQuotedString()).ast;
        // Emphasis
        // The emphasis tag should be preluded and followed by a not-letter-character.
        // Otherwise an example like above would be captured.
        var notLetterChar = m.not(m.letters);
        this.shortEmphasisModerate = m.seq(notLetterChar, "+", this.plainTextEmphasis, "+", notLetterChar).ast;
        this.shortEmphasisStrong = m.seq(notLetterChar, "++", this.plainTextEmphasis, "++", notLetterChar).ast;
        this.shortEmphasisNone = m.seq(notLetterChar, "~", this.plainTextEmphasis, "~", notLetterChar).ast;
        this.shortEmphasisReduced = m.seq(notLetterChar, "-", this.plainTextEmphasis, "-", notLetterChar).ast;
        this.emphasis = m.choice(this.shortEmphasisModerate, this.shortEmphasisStrong, this.shortEmphasisNone, this.shortEmphasisReduced);
        // Modifier
        // (text)[key] or (text)[key;]
        // (text)[key:'value'] or (text)[key:'value';]
        // (text)[key: "value"] or (text)[key: "value";]
        // (text)[key:'value';key;key:"value"]
        var colon = m.char(":").ws;
        var semicolon = m.char(";").ws;
        this.textModifierKey = m.keywords("emphasis", "address", "number", "cardinal", "characters", "chars", "digits", "drc", "expletive", "bleep", "fraction", "interjection", "ordinal", "telephone", "phone", "unit", "time", "date", "whisper", "ipa", "sapi", "ups", "sub", "vol", "volume", "rate", "pitch", "contour", "range", "timbre", "lang", "voice", "excited", "disappointed", "emotion", "paragraph", "sentence").ast;
        // Special characters for <phoneme alphabet="ipa" ph="..."> tag
        var ipaPulmonicConsonants = [
            // Plosive
            "p",
            "b",
            "t",
            "d",
            "\u0288",
            "\u0256",
            "c",
            "\u025F",
            "k",
            "\u0261",
            "g",
            "q",
            "\u0262",
            "\u0294",
            // Nasal
            "m",
            "\u0271",
            "n",
            "\u0273",
            "\u0272",
            "\u014B",
            "\u0274",
            // Trill
            "\u0299",
            "r",
            "\u0280",
            // Tap or Flap
            "\u2C71",
            "\u027E",
            "\u027D",
            // Fricative
            "\u0278",
            "\u03B2",
            "f",
            "v",
            "\u03B8",
            "\xf0",
            "s",
            "z",
            "\u0283",
            "\u0292",
            "\u0282",
            "\u0290",
            "\xe7",
            "\u029D",
            "x",
            "\u0263",
            "\u03C7",
            "\u0281",
            "\u0127",
            "\u0295",
            "h",
            "\u0266",
            // Lateral fricative
            "\u026C",
            "\u026E",
            // Approximant
            "\u028B",
            "\u0279",
            "\u027B",
            "j",
            "\u0270",
            // Lateral approximant
            "l",
            "\u026D",
            "\u028E",
            "\u029F"
        ];
        var ipaNonPulmonicConsonants = [
            // Clicks
            "\u0298",
            "\u01C0",
            "\u01C3",
            "\u01C2",
            "\u01C1",
            // Voiced implosive
            "\u0253",
            "\u0257",
            "\u0284",
            "\u0260",
            "\u029B",
            // Ejectives (already existing chars + unicode char \u02BC)
            "\u02BC"
        ];
        var ipaVowels = [
            // Close
            "i",
            "y",
            "\u0268",
            "\u0289",
            "\u026F",
            "u",
            "\u026A",
            "\u028F",
            "\u028A",
            // Close-mid
            "e",
            "\xf8",
            "\u0258",
            "\u025A",
            "\u0275",
            "\u0264",
            "o",
            "\u0259",
            // Open-mid
            "\u025B",
            "\u0153",
            "\u025C",
            "\u025D",
            "\u025E",
            "\u028C",
            "\u0254",
            "\xe6",
            "\u0250",
            // Open
            "a",
            "\u0276",
            "\u0251",
            "\u0252"
        ];
        var ipaOtherSymbols = [
            "\u028D",
            "w",
            "\u0265",
            "\u029C",
            "\u02A2",
            "\u02A1",
            "\u0255",
            "\u0291",
            "\u027A",
            "\u0267",
            "\u0361",
            "\u035C" // char ͜
        ];
        var ipaDiacritics = [
            "\u0325",
            "\u030A",
            "\u032C",
            "\u02B0",
            "\u0339",
            "\u031C",
            "\u031F",
            "\u0320",
            "\u0308",
            "\u033D",
            "\u0329",
            "\u032F",
            "\u02DE",
            "\u0324",
            "\u0330",
            "\u033C",
            "\u02B7",
            "\u02B2",
            "\u02E0",
            "\u02E4",
            "\u0334",
            "\u031D",
            "\u031E",
            "\u0318",
            "\u0319",
            "\u032A",
            "\u033A",
            "\u033B",
            "\u0303",
            "\u207F",
            "\u02E1",
            "\u031A"
        ];
        var ipaSupraSegmentals = [
            "\u02C8",
            "\u02CC",
            "\u02D0",
            "\u02D1",
            "\u0306",
            "|",
            "\u2016",
            ".",
            "\u203F"
        ];
        var ipaTones = [
            "\u030B",
            "\u0301",
            "\u0304",
            "\u0300",
            "\u030F",
            "\u2193",
            "\u2191",
            "\u2197",
            "\u2198",
            "\u030C",
            "\u0302"
        ];
        var unicodeBlendedCharacters = [
            "\xe0",
            "\xe8",
            "\xec",
            "\xf2",
            "\xf9",
            "\xc0",
            "\xc8",
            "\xcc",
            "\xd2",
            "\xd9",
            "\xe1",
            "\xe9",
            "\xed",
            "\xf3",
            "\xfa",
            "\xfd",
            "\xc1",
            "\xc9",
            "\xcd",
            "\xd3",
            "\xda",
            "\xdd",
            "\xe2",
            "\xea",
            "\xee",
            "\xf4",
            "\xfb",
            "\xc2",
            "\xca",
            "\xce",
            "\xd4",
            "\xdb",
            "\xe4",
            "\xeb",
            "\xef",
            "\xf6",
            "\xfc",
            "\xff",
            "\xc4",
            "\xcb",
            "\xcf",
            "\xd6",
            "\xdc",
            "\u0178",
            "\xe3",
            "\xf1",
            "\xf5",
            "\xc3",
            "\xd1",
            "\xd5",
            "\xe5",
            "\xc5"
        ];
        var ipaOtherCharacters = [
            "\u0269",
            "\u026B",
            "\u0277",
            "\u027C",
            "\u027F",
            "\u0285",
            "\u0286",
            "\u0287",
            "\u0293",
            "\u0296",
            "\u0297",
            "\u029A",
            "\u029E",
            "\u02A0",
            "\u02A3",
            "\u02A4",
            "\u02A5",
            "\u02A6",
            "\u02A7",
            "\u02A8",
            "\u02A9",
            "\u02AA",
            "\u02AB",
            "\u02AC",
            "\u02AD",
            "\u02AE",
            "\u02AF"
        ];
        var ipaChars = $725e2bcd7c9326f6$var$__spreadArrays(ipaPulmonicConsonants, ipaNonPulmonicConsonants, ipaVowels, ipaOtherSymbols, ipaDiacritics, ipaSupraSegmentals, ipaTones, unicodeBlendedCharacters, ipaOtherCharacters);
        var percentChange = [
            "+",
            m.hyphen,
            m.digit,
            "%"
        ];
        this.textModifierText = m.choice.apply(m, $725e2bcd7c9326f6$var$__spreadArrays([
            m.digit,
            m.letter,
            m.hyphen,
            m.space
        ], ipaChars, percentChange)).oneOrMore.ast;
        this.textModifierTextDoubleQuote = m.choice.apply(m, $725e2bcd7c9326f6$var$__spreadArrays([
            m.digit,
            m.letter,
            m.hyphen,
            m.space
        ], ipaChars, percentChange, [
            "'"
        ])).oneOrMore.ast;
        this.textModifierValue = m.seq(colon, m.choice(m.singleQuoted(this.textModifierText), m.doubleQuoted(this.textModifierTextDoubleQuote)));
        this.textModifierKeyOptionalValue = m.seq(this.textModifierKey, this.textModifierValue.opt).ast;
        this.modifier = m.bracketed(m.delimited(this.textModifierKeyOptionalValue.ws, semicolon));
        var textText = m.parenthesized(this.plainTextModifier);
        var textTextPhone = m.parenthesized(this.plainTextPhone);
        this.textModifier = m.seq(m.choice(textText, textTextPhone), this.modifier).ast;
        // Section
        this.sectionModifierKey = m.keywords("lang", "voice", "defaults", "dj", "newscaster", "excited", "disappointed").ast;
        this.sectionModifierText = m.choice(m.digit, m.letter, m.hyphen).oneOrMore.ast;
        this.sectionModifierValue = m.seq(colon, m.choice(m.singleQuoted(this.sectionModifierText), m.doubleQuoted(this.sectionModifierText)));
        this.sectionModifierKeyOptionalValue = m.seq(this.sectionModifierKey, this.sectionModifierValue.opt).ast;
        this.sectionModifier = m.bracketed(m.delimited(this.sectionModifierKeyOptionalValue.ws, semicolon));
        this.section = m.seq("#", this.sectionModifier).ast;
        // values
        this.valueNone = "none";
        this.valueXWeak = "x-weak";
        this.valueWeak = "weak";
        this.valueMedium = "medium";
        this.valueStrong = "strong";
        this.valueXStrong = "x-strong";
        this.breakStrengthValue = m.keywords(this.valueNone, this.valueXWeak, this.valueWeak, this.valueMedium, this.valueStrong, this.valueXStrong).ast;
        this.breakValue = m.choice(this.breakStrengthValue, this.time).ast;
        this.break = m.seq("[", "break", ":", m.choice(m.singleQuoted(this.breakValue), m.doubleQuoted(this.breakValue)), "]").ast;
        this.markTag = m.seq("[", "mark", ":", m.choice(m.singleQuoted(this.xsdToken), m.doubleQuoted(this.xsdToken)), "]").ast;
        this.any = m.advance;
        this.inline = m.choice(this.backgroundAudio, this.lexicon, this.bookmark, this.textModifier, this.emphasis, this.shortBreak, this.silence, this.break, this.audio, this.markTag, this.plainTextSpecialChars, this.plainText, this.any).unless(m.newLine);
        this.lineEnd = m.newLine.or(m.assert(m.end)).ast;
        this.emptyLine = m.char(" 	").zeroOrMore.then(m.newLine).ast;
        this.restOfLine = m.seq(this.inline.zeroOrMore).then(this.lineEnd);
        this.simpleLine = m.seq(this.emptyLine.not, m.notEnd, this.restOfLine).ast;
        this.paragraph = this.simpleLine.oneOrMore.ast;
        this.content = m.choice(this.section, this.paragraph, this.emptyLine);
        this.document = this.content.zeroOrMore.ast;
    }();
    // Register the grammar, providing a name and the default parse rule
    return m.registerGrammar("speechmarkdown", g, g.document);
}
$725e2bcd7c9326f6$exports.speechMarkdownGrammar = $725e2bcd7c9326f6$var$speechMarkdownGrammar;


var $06e6c416d5b86749$var$SpeechMarkdownParser = /** @class */ function() {
    function SpeechMarkdownParser() {
        this.myna = $33f49ffb7e9b2285$exports.Myna;
        $725e2bcd7c9326f6$exports.speechMarkdownGrammar(this.myna);
        this.parser = this.myna.parsers.speechmarkdown;
    }
    SpeechMarkdownParser.prototype.parse = function(speechmarkdown) {
        // tslint:disable-next-line: no-unnecessary-local-variable
        return this.parser(speechmarkdown);
    };
    return SpeechMarkdownParser;
}();
$06e6c416d5b86749$exports.SpeechMarkdownParser = $06e6c416d5b86749$var$SpeechMarkdownParser;


var $ab20793bc5258f1e$var$SpeechMarkdown = /** @class */ function() {
    function SpeechMarkdown(options) {
        this.options = options;
        this.defaults = {
            includeFormatterComment: false,
            includeParagraphTag: false,
            includeSpeakTag: true,
            platform: "",
            preserveEmptyLines: true
        };
        this.options = $ab20793bc5258f1e$var$__assign($ab20793bc5258f1e$var$__assign({}, this.defaults), options);
    }
    Object.defineProperty(SpeechMarkdown.prototype, "Parser", {
        get: function() {
            if (!this.parser) this.parser = new $06e6c416d5b86749$exports.SpeechMarkdownParser();
            return this.parser;
        },
        enumerable: true,
        configurable: true
    });
    SpeechMarkdown.prototype.toText = function(speechmarkdown, options) {
        var methodOptions = $ab20793bc5258f1e$var$__assign($ab20793bc5258f1e$var$__assign({}, this.options), options);
        var ast = this.Parser.parse(speechmarkdown);
        var formatter = $ab20793bc5258f1e$var$factory.createTextFormatter(methodOptions);
        return formatter.format(ast);
    };
    SpeechMarkdown.prototype.toSSML = function(speechmarkdown, options) {
        var methodOptions = $ab20793bc5258f1e$var$__assign($ab20793bc5258f1e$var$__assign({}, this.options), options);
        var returnSSML = speechmarkdown;
        try {
            // If there are tags in the text included in other tags, we need to format several times to process all the tags
            // If we don't do that, therer is a chance that tags will remain unprocessed in the output
            do {
                var ast = this.Parser.parse(returnSSML);
                var formatter = $ab20793bc5258f1e$var$factory.createFormatter(methodOptions);
                returnSSML = formatter.format(ast);
            }while (returnSSML.includes(")["));
            // returnSSML now contains the core SSML, let's generate global tags if there is a need to
            // 'mstts:backgroundaudio' tag
            var backgroundAudiotag = "";
            if (returnSSML.includes("<mstts:backgroundaudio")) {
                var beginIndex = returnSSML.indexOf("<mstts:backgroundaudio");
                var endIndex = returnSSML.substring(beginIndex).indexOf("/>") + 2;
                backgroundAudiotag = returnSSML.substring(beginIndex, endIndex);
                returnSSML = returnSSML.replace(backgroundAudiotag, "");
            }
            // 'voice' tag
            var beginVoiceTag = "";
            var endVoiceTag = "";
            if (methodOptions.globalVoiceAndLang && methodOptions.globalVoiceAndLang.voice) {
                beginVoiceTag = '<voice name="' + methodOptions.globalVoiceAndLang.voice + '">';
                endVoiceTag = "</voice>";
            }
            // 'lang' tag
            var beginLangTag = "";
            var endLangTag = "";
            if (methodOptions.globalVoiceAndLang && methodOptions.globalVoiceAndLang.lang) {
                beginLangTag = '<lang xml:lang="' + methodOptions.globalVoiceAndLang.lang + '">';
                endLangTag = "</lang>";
            }
            var SSML = "" + (backgroundAudiotag + beginVoiceTag + beginLangTag + returnSSML + endLangTag + endVoiceTag);
            return SSML;
        } catch (error) {
            console.log("Error : ", error);
            return returnSSML;
        }
    };
    SpeechMarkdown.prototype.toAST = function(speechmarkdown) {
        return this.Parser.parse(speechmarkdown);
    };
    SpeechMarkdown.prototype.toASTString = function(speechmarkdown) {
        var ast = this.Parser.parse(speechmarkdown);
        return ast.toString();
    };
    return SpeechMarkdown;
}();
$ab20793bc5258f1e$exports.SpeechMarkdown = $ab20793bc5258f1e$var$SpeechMarkdown;


$71a0241bab23e208$exports.SpeechMarkdown = $ab20793bc5258f1e$exports.SpeechMarkdown;


const $86e1288ad17c6773$var$speechMarkdownParser = new (0, $71a0241bab23e208$exports.SpeechMarkdown)();
const $86e1288ad17c6773$export$d6c6ec86eedacfd9 = (text, speechMarkdownTagsPosition = [])=>{
    let res = "";
    // Myna parser used in speechmarkdown parsing can't deal with dashes which aren't in speechmarkdown tags properly.
    // Let's change them and put them back after treatment
    if (text.indexOf("-") !== -1) {
        const dashesOutsideSpeechmarkdown = [];
        for(let i = 0; i < text.length; i++)if (text[i] === "-") {
            let test = true;
            speechMarkdownTagsPosition.forEach((position)=>{
                if (i >= position[0] || i <= position[1]) test = false;
            });
            test && dashesOutsideSpeechmarkdown.push(i);
        }
        let textWithoutDashes = "";
        if (dashesOutsideSpeechmarkdown.length > 0) {
            for(let i = 0; i < dashesOutsideSpeechmarkdown.length; i++){
                textWithoutDashes += i === 0 ? text.substring(0, dashesOutsideSpeechmarkdown[i]) : text.substring(dashesOutsideSpeechmarkdown[i - 1] + 1, dashesOutsideSpeechmarkdown[i]);
                textWithoutDashes += "1xx1";
            }
            // Add the rest of the text (after the last dash)
            textWithoutDashes += text.substring(dashesOutsideSpeechmarkdown[dashesOutsideSpeechmarkdown.length - 1] + 1);
        }
        res = $86e1288ad17c6773$var$speechMarkdownParser.toText(textWithoutDashes);
        res = res.replaceAll("1xx1", "-");
    } else res = $86e1288ad17c6773$var$speechMarkdownParser.toText(text);
    // Remove phoneme tag
    res = res.replaceAll(/<\/?phoneme?[^>]+>|$/g, "");
    return res;
};
const $86e1288ad17c6773$export$f355fac925ad880f = (text)=>{
    const replacements = [];
    let textWithReplacements = text;
    // Get the indexes of all the occurences of ')['
    let indexes = [];
    let position = text.indexOf(")[");
    while(position !== -1){
        indexes.push(position);
        position = text.indexOf(")[", position + 1);
    }
    // If at least one occurence has been found escape all characters related
    if (indexes.length > 0) // Loop on indexes to get all indexes
    for(let i = 0; i < indexes.length; i++){
        // Get the opening parenthesis related to the closing one from the expression
        const openingParenthesisIndex = $86e1288ad17c6773$var$getOpeningParenthesis(text, indexes[i]);
        // Get the closing bracket related to the opening one from the expression
        const closingBracketIndex = text.substring(indexes[i]).indexOf("]") + indexes[i];
        const replacement = {
            // Use string for replacement as : 'replacement1x1'
            replacementString: `replacement${i}x${i}`,
            speechMarkdown: text.substring(openingParenthesisIndex, closingBracketIndex + 1)
        };
        replacements.push(replacement);
        textWithReplacements = textWithReplacements.replace(replacement.speechMarkdown, replacement.replacementString);
    }
    // In markdown links can be found as [...](...) so we need to find data between brackets without parentheses related to the closing bracket. Example : 'Hello. [1s] How are you ?'
    // Reset indexes array and set basic text to textWithReplacements to prevent searching again for brackets that have already been removed
    indexes = [];
    const tempText = textWithReplacements;
    position = tempText.indexOf("]");
    while(position !== -1){
        indexes.push(position);
        position = tempText.indexOf("]", position + 1);
    }
    if (indexes.length > 0) {
        for(let i = 0; i < indexes.length; i++)// If the index is the last character of the string, or if the next character isn't an opening parenthesis, it's ok
        if (indexes[i] === tempText.length - 1 || tempText.charAt(indexes[i] + 1) !== "(") {
            // Find the position of the previous opening bracket
            const openingBracketIndex = tempText.substring(0, indexes[i]).lastIndexOf("[");
            const replacement = {
                // Use string for replacement as : 'pause1x1'
                replacementString: `pause${i}x${i}`,
                speechMarkdown: tempText.substring(openingBracketIndex, indexes[i] + 1)
            };
            replacements.push(replacement);
            textWithReplacements = textWithReplacements.replace(replacement.speechMarkdown, replacement.replacementString);
        }
    }
    return {
        text: textWithReplacements,
        replacements: replacements
    };
};
const $86e1288ad17c6773$var$getOpeningParenthesis = (text, index)=>{
    let nbOpeningParenthesis = 0;
    let nbClosingParenthesis = 0;
    // Search from the end of the string for an equivalence between opening and ending parenthesis, to prevent error if the text to be
    // spoken contains parenthesis.
    for(let i = index; i > 0; i--){
        if (text.charAt(i) === ")") nbClosingParenthesis++;
        else if (text.charAt(i) === "(") {
            nbOpeningParenthesis++;
            if (nbClosingParenthesis === nbOpeningParenthesis) return i;
        }
    }
    return 0;
};


const $e621961b26da67d1$var$regexLink = /<\/?a([^>])+>/g;
const $e621961b26da67d1$var$regexImg = /<\/?img([^>])+>/g;
const $e621961b26da67d1$export$1b8fbc30fb87d9aa = (text, skipAttachments)=>{
    const md = new (0, $c1dfe7a9dc4f2ee7$export$2e2bcd8739ae039)({
        breaks: true,
        html: true,
        xhtmlOut: true,
        typographer: true,
        quotes: `""''`
    });
    let attachmentsToCreate = {
        images: [],
        urls: []
    };
    // text = `[backgroundaudio:"https://daviretorikcdnstorage.blob.core.windows.net/retorik-framework/audiofiles/audiotest.mp3 0.5 2000 1500"][silence:"Leading 1s"] ((Bonjour, comment  allez-vous)[sentence] ? (Bien, merci, et vous-même ?)[sentence;voice:"Fr-fR-jerOMeNeuRal"])[paragraph] (Je suis de (tomato)[ipa:"təˈmeɪtoʊ"] (sapi)[sapi:"iy eh n y uw eh s"] (ups)[ups:"JH AU"] retour (après avoir été remplacée)[emphasis:"strong"] par Brigitte.[silence:"Sentenceboundary 3s"] Au revoir)[voice:"fr-FR-DeniseNeural";emotion:"calm SeniorMale"] ![image](images/bertranges.jpg)`
    // text = `((Bonjour, comment allez-vous ?)[sentence] [1s] (Bien, et toi Jérôme, ça va ?)[sentence])[paragraph] (Bien, merci, et vous-même ?)[voice:"Fr-fR-jerOMeNeuRal"]. Tout-va-pour-le-mieux. (Hallo Denise, wie geht es dir heute ?)[rate:"slow";vol:"x-loud";lang:"de-DE"] (Bonjour, je suis de retour (ASAP)[characters] après avoir été remplacée par Brigitte.Merci)[voice:"fr-FR-DeniseNeural";vol:"loud"] ![image](images/bertranges.jpg)`
    // text = `(Como estas ?)[lang:"es-ES"][1s] Parti - pour le test - (greenage)[lang:"en-US"]. Mettons une image ![image](images/bertranges.jpg).[500ms] En anglais, (parce-que en Français ce n'est pas ça...) greenage se dit (greenage)[lang:"en-US"]. Fin de message (aufwiedersehen)[lang:"de-DE"]`
    // text = `(Le petit chien va dans sa niche car bien escalader archiduchesse long fiente)[ipa:"lə pəti ʃjɛ̃ va dɑ̃ sa niʃ kaʁ bjɛ̃ ɛskalade ar̥ʃidyʃɛːs lɔ̃ fjɑ̃t"]`
    const speechMarkdownReplacedData = (0, $86e1288ad17c6773$export$f355fac925ad880f)(text);
    if (!skipAttachments) {
        const parsed = md.parseInline(speechMarkdownReplacedData.text);
        parsed.length && (attachmentsToCreate = $e621961b26da67d1$var$createNewAttachments(parsed[0].children));
    }
    const textWithHtmlTags = md.render(text);
    // Strip html tags from rendered text
    const newText = $e621961b26da67d1$var$stripHtml(textWithHtmlTags);
    const speechMarkdownTagsPosition = [];
    speechMarkdownReplacedData.replacements.forEach((replacement)=>{
        const index = text.indexOf(replacement.speechMarkdown);
        speechMarkdownTagsPosition.push([
            index,
            index + replacement.speechMarkdown.length
        ]);
    });
    return {
        ...attachmentsToCreate,
        text: newText,
        htmlText: $e621961b26da67d1$var$stripHtmlLinkTags(textWithHtmlTags, speechMarkdownTagsPosition)
    };
};
/**
 * Removes speechmarkdown, <a href ...></a> and <img ... /> tags from the text and keeps the others
 * @param text : string
 * @returns string
 */ const $e621961b26da67d1$var$stripHtmlLinkTags = (text, speechMarkdownTagsPosition)=>{
    // Replace all characters replaced by mardkdown-it renderer (quotes, <, >)
    let newText = text.replaceAll("&quot;", '"');
    newText = newText.replaceAll("&lt;", "<");
    newText = newText.replaceAll("&gt;", ">");
    // Remove speechMarkdown tags, and link/images html tags
    newText = (0, $86e1288ad17c6773$export$d6c6ec86eedacfd9)(newText, speechMarkdownTagsPosition).replaceAll($e621961b26da67d1$var$regexLink, "");
    newText = newText.replaceAll($e621961b26da67d1$var$regexImg, "");
    return newText;
};
/**
 * Removes all html tags from the text
 * @param text : string
 * @returns string
 */ const $e621961b26da67d1$var$stripHtml = (text)=>{
    const temp = document.createElement("div");
    temp.innerHTML = text;
    return temp.textContent && temp.textContent !== "" ? temp.textContent : "";
};
const $e621961b26da67d1$var$getDataFromToken = (attributes, type)=>{
    // Check if there are attributes, then if one of these attributes contains data with the desired key, and finally if there is a value attached to this key
    const allData = attributes?.find((data)=>data.length > 1 && data[0] === type && data.length > 0 && data[1] !== "");
    if (allData && allData.length > 1) return allData[1];
    return type === "href" ? undefined : "";
};
const $e621961b26da67d1$var$createNewAttachments = (tokens)=>{
    const images = [];
    const urls = [];
    if (tokens && tokens.length > 0) for(let i = 0; i < tokens.length; i++){
        const attributes = tokens[i].attrs;
        switch(tokens[i].type){
            case "link_open":
                {
                    // Try to retrieve an URl from the href token
                    const url = $e621961b26da67d1$var$getDataFromToken(attributes, "href");
                    // If there is an URL, try to retrieve the text contained in the next token 'content' field
                    if (url) {
                        const title = $e621961b26da67d1$var$getDataFromToken(attributes, "title") || tokens[i + 1]?.content;
                        urls.push({
                            url: url,
                            title: title
                        });
                    }
                    break;
                }
            case "image":
                {
                    const url = $e621961b26da67d1$var$getDataFromToken(attributes, "src");
                    url && images.push({
                        url: url,
                        title: $e621961b26da67d1$var$getDataFromToken(attributes, "title"),
                        alt: $e621961b26da67d1$var$getDataFromToken(attributes, "alt")
                    });
                    break;
                }
            default:
                break;
        }
    }
    return {
        images: images,
        urls: urls
    };
};




const $2cf6d461af50dd62$var$addTextBlock = (text, type)=>{
    const textBlock = {
        type: "TextBlock",
        text: text,
        size: undefined,
        horizontalAlignment: undefined,
        wrap: true,
        maxLines: undefined
    };
    switch(type){
        case "title":
            textBlock.size = "large";
            break;
        case "subtitle":
            textBlock.size = "medium";
            break;
        case "text":
        default:
            break;
    }
    return textBlock;
};
const $2cf6d461af50dd62$var$addImage = (data)=>{
    const image = {
        type: "Image",
        url: "",
        size: "Large",
        altText: undefined,
        selectAction: undefined,
        horizontalAlignment: "Center"
    };
    image.url = data.url;
    image.altText = data.alt || "image";
    image.selectAction = data.tap && $2cf6d461af50dd62$var$addAction(data.tap);
    return {
        ...image
    };
};
const $2cf6d461af50dd62$var$addAction = (cardAction, includesOAuthButtons)=>{
    const action = {
        type: "Action.Submit",
        title: undefined,
        url: undefined,
        data: undefined,
        fullWidth: undefined,
        position: undefined,
        display: undefined
    };
    for(const val in cardAction)if (cardAction[val] && typeof cardAction[val] === "string") cardAction[val] = (0, $86e1288ad17c6773$export$d6c6ec86eedacfd9)(cardAction[val]);
    if (cardAction.type === "imBack" || cardAction.type === "messageBack" || cardAction.type === "postBack" || cardAction.type === "signin" && includesOAuthButtons) {
        action.type = "Action.Submit";
        action.data = cardAction.value || cardAction.title || null;
        action.title = cardAction.title || "";
    } else {
        action.type = "Action.OpenUrl";
        action.title = cardAction.title || "";
        action.url = cardAction.type === "call" ? `tel:${cardAction.value}` : cardAction.value;
    }
    const channelData = cardAction.channelData;
    if (channelData) {
        action.fullWidth = channelData.fullWidth;
        action.position = channelData.position;
        action.display = channelData.display;
    }
    return {
        ...action
    };
};
const $2cf6d461af50dd62$export$52053c22b954067e = (content)=>{
    const adaptiveCard = {
        contentType: (0, $59de7fd3862e5431$export$bbfd0bb0baceb2f8),
        content: {
            type: "AdaptiveCard",
            $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
            version: "1.5",
            body: [],
            text: undefined,
            speak: undefined,
            selectAction: undefined
        }
    };
    // Add texts first in order : title - subtitle - text
    let cardTexts = [];
    if (content.title) {
        const ti = $2cf6d461af50dd62$var$addTextBlock(content.title, "title");
        cardTexts = [
            ...cardTexts,
            {
                ...ti
            }
        ];
    }
    if (content.subtitle) {
        const st = $2cf6d461af50dd62$var$addTextBlock(content.subtitle, "subtitle");
        cardTexts = [
            ...cardTexts,
            {
                ...st
            }
        ];
    }
    if (content.text) {
        const txt = $2cf6d461af50dd62$var$addTextBlock(content.text, "text");
        cardTexts = [
            ...cardTexts,
            {
                ...txt
            }
        ];
        adaptiveCard.content.text = content.text;
    }
    // Set speak data so that the card is taken in account in the renderer
    if (content.speak || content.text) adaptiveCard.content.speak = content.speak || content.text;
    // Set body as Container with empty items
    adaptiveCard.content.body = [
        {
            type: "Container",
            items: []
        }
    ];
    // Add texts to items is there are some
    cardTexts.length > 0 && (adaptiveCard.content.body[0].items = [
        ...cardTexts
    ]);
    // Add Images if there are some
    let images = [];
    content.images && content.images.forEach((heroImage)=>{
        const image = $2cf6d461af50dd62$var$addImage(heroImage);
        images = [
            ...images,
            {
                ...image
            }
        ];
    });
    images.length > 0 && (adaptiveCard.content.body[0].items = [
        ...adaptiveCard.content.body[0].items,
        ...images
    ]);
    // Add actions if there are some
    let actions = [];
    content.buttons && content.buttons.forEach((button)=>{
        const action = $2cf6d461af50dd62$var$addAction(button);
        actions = [
            ...actions,
            {
                ...action
            }
        ];
    });
    if (actions.length > 0) {
        const actionSet = {
            type: "ActionSet",
            actions: [
                ...actions
            ]
        };
        adaptiveCard.content.body[0].items = [
            ...adaptiveCard.content.body[0].items,
            {
                ...actionSet
            }
        ];
    }
    // Tap action
    if (content.tap) {
        const tapAction = $2cf6d461af50dd62$var$addAction(content.tap);
        adaptiveCard.content.selectAction = {
            ...tapAction
        };
    }
    return {
        ...adaptiveCard
    };
};



const $58c3da5dd619bf21$export$4a92a69e5bfa5f9a = (attachments)=>{
    if (attachments && attachments.length > 0) {
        let tempAttachments = [];
        attachments.forEach((attachment)=>{
            if (attachment.contentType === (0, $59de7fd3862e5431$export$264354e75632a3ba)) {
                const heroToAdaptive = (0, $2cf6d461af50dd62$export$52053c22b954067e)({
                    ...attachment.content
                });
                tempAttachments = [
                    ...tempAttachments,
                    {
                        ...heroToAdaptive
                    }
                ];
            } else tempAttachments = [
                ...tempAttachments,
                {
                    ...attachment
                }
            ];
        });
        return tempAttachments;
    }
    return undefined;
};


var $33b99b026c95b649$exports = {};

$parcel$export($33b99b026c95b649$exports, "create", () => $33b99b026c95b649$export$185802fd694ee1f5, (v) => $33b99b026c95b649$export$185802fd694ee1f5 = v);
$parcel$export($33b99b026c95b649$exports, "toCanvas", () => $33b99b026c95b649$export$f87f6982d1fd4f81, (v) => $33b99b026c95b649$export$f87f6982d1fd4f81 = v);
$parcel$export($33b99b026c95b649$exports, "toDataURL", () => $33b99b026c95b649$export$723e4939e5a27c8, (v) => $33b99b026c95b649$export$723e4939e5a27c8 = v);
$parcel$export($33b99b026c95b649$exports, "toString", () => $33b99b026c95b649$export$f84e8e69fd4488a5, (v) => $33b99b026c95b649$export$f84e8e69fd4488a5 = v);
var $33b99b026c95b649$export$185802fd694ee1f5;
var $33b99b026c95b649$export$f87f6982d1fd4f81;
var $33b99b026c95b649$export$723e4939e5a27c8;
// only svg for now.
var $33b99b026c95b649$export$f84e8e69fd4488a5;
var $ee9ac4fa23f6500f$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$ee9ac4fa23f6500f$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $1453e664ce7fb243$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $91cdba58884d7234$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $91cdba58884d7234$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $91cdba58884d7234$export$ed1d66da50968976;
var $91cdba58884d7234$export$6733b14783f975c2;
var $91cdba58884d7234$export$ce5b1274f8597fa0;
var $91cdba58884d7234$export$43dd553ecded716d;
let $91cdba58884d7234$var$toSJISFunction;
const $91cdba58884d7234$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$91cdba58884d7234$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$91cdba58884d7234$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $91cdba58884d7234$var$CODEWORDS_COUNT[version];
};
$91cdba58884d7234$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$91cdba58884d7234$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $91cdba58884d7234$var$toSJISFunction = f;
};
$91cdba58884d7234$export$ce5b1274f8597fa0 = function() {
    return typeof $91cdba58884d7234$var$toSJISFunction !== "undefined";
};
$91cdba58884d7234$export$43dd553ecded716d = function toSJIS(kanji) {
    return $91cdba58884d7234$var$toSJISFunction(kanji);
};


var $1738c5e55a35086d$export$61196ced6d74a310;
var $1738c5e55a35086d$export$3a1a48c8f6ef640e;
var $1738c5e55a35086d$export$3722cfe417b6ed86;
var $1738c5e55a35086d$export$7f8ddf7c7c20b3cd;
var $1738c5e55a35086d$export$1ea939691cdc45b8;
var $1738c5e55a35086d$export$6788812c4e6611e6;
$1738c5e55a35086d$export$61196ced6d74a310 = {
    bit: 1
};
$1738c5e55a35086d$export$3a1a48c8f6ef640e = {
    bit: 0
};
$1738c5e55a35086d$export$3722cfe417b6ed86 = {
    bit: 3
};
$1738c5e55a35086d$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $1738c5e55a35086d$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $1738c5e55a35086d$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $1738c5e55a35086d$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $1738c5e55a35086d$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $1738c5e55a35086d$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$1738c5e55a35086d$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$1738c5e55a35086d$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($1738c5e55a35086d$export$1ea939691cdc45b8(value)) return value;
    try {
        return $1738c5e55a35086d$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $e4fceb8e6fc0e4bb$exports = {};
function $e4fceb8e6fc0e4bb$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$e4fceb8e6fc0e4bb$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$e4fceb8e6fc0e4bb$exports = $e4fceb8e6fc0e4bb$var$BitBuffer;


var $78c97781d6ab558d$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $78c97781d6ab558d$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $78c97781d6ab558d$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $78c97781d6ab558d$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $78c97781d6ab558d$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $78c97781d6ab558d$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$78c97781d6ab558d$exports = $78c97781d6ab558d$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $01184f84440d1b6a$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $01184f84440d1b6a$export$c39457c570f2b189;

var $01184f84440d1b6a$require$getSymbolSize = $91cdba58884d7234$export$8d4a06d3facd414b;
$01184f84440d1b6a$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $01184f84440d1b6a$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$01184f84440d1b6a$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $01184f84440d1b6a$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $eeba47650dad370e$export$c39457c570f2b189;

var $eeba47650dad370e$require$getSymbolSize = $91cdba58884d7234$export$8d4a06d3facd414b;
const $eeba47650dad370e$var$FINDER_PATTERN_SIZE = 7;
$eeba47650dad370e$export$c39457c570f2b189 = function getPositions(version) {
    const size = $eeba47650dad370e$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $eeba47650dad370e$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $eeba47650dad370e$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $fc0c14bf41116ea1$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $fc0c14bf41116ea1$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $fc0c14bf41116ea1$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $fc0c14bf41116ea1$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $fc0c14bf41116ea1$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $fc0c14bf41116ea1$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $fc0c14bf41116ea1$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $fc0c14bf41116ea1$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $fc0c14bf41116ea1$export$fe9625aaceb0e563;
$fc0c14bf41116ea1$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $fc0c14bf41116ea1$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$fc0c14bf41116ea1$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$fc0c14bf41116ea1$export$6788812c4e6611e6 = function from(value) {
    return $fc0c14bf41116ea1$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$fc0c14bf41116ea1$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $fc0c14bf41116ea1$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $fc0c14bf41116ea1$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $fc0c14bf41116ea1$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $fc0c14bf41116ea1$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$fc0c14bf41116ea1$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $fc0c14bf41116ea1$var$PenaltyScores.N2;
};
$fc0c14bf41116ea1$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $fc0c14bf41116ea1$var$PenaltyScores.N3;
};
$fc0c14bf41116ea1$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $fc0c14bf41116ea1$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $fc0c14bf41116ea1$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $fc0c14bf41116ea1$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $fc0c14bf41116ea1$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $fc0c14bf41116ea1$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $fc0c14bf41116ea1$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $fc0c14bf41116ea1$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $fc0c14bf41116ea1$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $fc0c14bf41116ea1$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $fc0c14bf41116ea1$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$fc0c14bf41116ea1$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $fc0c14bf41116ea1$var$getMaskAt(pattern, row, col));
    }
};
$fc0c14bf41116ea1$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($fc0c14bf41116ea1$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $fc0c14bf41116ea1$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $fc0c14bf41116ea1$export$a5fd3a02c14d0b3e(data) + $fc0c14bf41116ea1$export$9a9385107a518e46(data) + $fc0c14bf41116ea1$export$ade754353f0dc75e(data) + $fc0c14bf41116ea1$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $fc0c14bf41116ea1$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $754bb1c97a766809$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $754bb1c97a766809$export$683d1b3e8a1a8438;

const $754bb1c97a766809$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $754bb1c97a766809$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$754bb1c97a766809$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $1738c5e55a35086d$export$61196ced6d74a310:
            return $754bb1c97a766809$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $1738c5e55a35086d$export$3a1a48c8f6ef640e:
            return $754bb1c97a766809$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $1738c5e55a35086d$export$3722cfe417b6ed86:
            return $754bb1c97a766809$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $1738c5e55a35086d$export$7f8ddf7c7c20b3cd:
            return $754bb1c97a766809$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$754bb1c97a766809$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $1738c5e55a35086d$export$61196ced6d74a310:
            return $754bb1c97a766809$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $1738c5e55a35086d$export$3a1a48c8f6ef640e:
            return $754bb1c97a766809$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $1738c5e55a35086d$export$3722cfe417b6ed86:
            return $754bb1c97a766809$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $1738c5e55a35086d$export$7f8ddf7c7c20b3cd:
            return $754bb1c97a766809$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $820083685316331f$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $a2d59b5bd41d1f4c$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $a2d59b5bd41d1f4c$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $a2d59b5bd41d1f4c$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $6c7271f21014f2f8$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $6c7271f21014f2f8$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $6c7271f21014f2f8$export$6e3a27864ab166fe;
const $6c7271f21014f2f8$var$EXP_TABLE = new Uint8Array(512);
const $6c7271f21014f2f8$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $6c7271f21014f2f8$var$EXP_TABLE[i] = x;
        $6c7271f21014f2f8$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$6c7271f21014f2f8$var$EXP_TABLE[i] = $6c7271f21014f2f8$var$EXP_TABLE[i - 255];
})();
$6c7271f21014f2f8$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $6c7271f21014f2f8$var$LOG_TABLE[n];
};
$6c7271f21014f2f8$export$b310ec824aaee37f = function exp(n) {
    return $6c7271f21014f2f8$var$EXP_TABLE[n];
};
$6c7271f21014f2f8$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $6c7271f21014f2f8$var$EXP_TABLE[$6c7271f21014f2f8$var$LOG_TABLE[x] + $6c7271f21014f2f8$var$LOG_TABLE[y]];
};


$a2d59b5bd41d1f4c$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $6c7271f21014f2f8$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$a2d59b5bd41d1f4c$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $6c7271f21014f2f8$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$a2d59b5bd41d1f4c$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $a2d59b5bd41d1f4c$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $6c7271f21014f2f8$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $820083685316331f$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $820083685316331f$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $a2d59b5bd41d1f4c$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $820083685316331f$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $a2d59b5bd41d1f4c$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$820083685316331f$exports = $820083685316331f$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $b963f07dd79cf3c9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $b963f07dd79cf3c9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $b963f07dd79cf3c9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $b963f07dd79cf3c9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $cae377638d043a33$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $cae377638d043a33$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $cae377638d043a33$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $cae377638d043a33$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $cae377638d043a33$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $cae377638d043a33$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $cae377638d043a33$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $cae377638d043a33$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $cae377638d043a33$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $cae377638d043a33$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $782d8067d3452d88$export$1ea939691cdc45b8;
$782d8067d3452d88$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $b013213a73c94340$export$a4d452c2363c8e12;
var $b013213a73c94340$export$9df7c29d562bab83;
var $b013213a73c94340$export$8f4bf8f7eb581284;
var $b013213a73c94340$export$4d318981b5a83836;
var $b013213a73c94340$export$376a9ed239d6c1c8;
var $b013213a73c94340$export$175f16aef75a4569;
var $b013213a73c94340$export$50b7f9bf92c74274;
var $b013213a73c94340$export$4ba5f52893b4ac97;
const $b013213a73c94340$var$numeric = "[0-9]+";
const $b013213a73c94340$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $b013213a73c94340$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$b013213a73c94340$var$kanji = $b013213a73c94340$var$kanji.replace(/u/g, "\\u");
const $b013213a73c94340$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $b013213a73c94340$var$kanji + ")(?:.|[\r\n]))+";
$b013213a73c94340$export$a4d452c2363c8e12 = new RegExp($b013213a73c94340$var$kanji, "g");
$b013213a73c94340$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$b013213a73c94340$export$8f4bf8f7eb581284 = new RegExp($b013213a73c94340$var$byte, "g");
$b013213a73c94340$export$4d318981b5a83836 = new RegExp($b013213a73c94340$var$numeric, "g");
$b013213a73c94340$export$376a9ed239d6c1c8 = new RegExp($b013213a73c94340$var$alphanumeric, "g");
const $b013213a73c94340$var$TEST_KANJI = new RegExp("^" + $b013213a73c94340$var$kanji + "$");
const $b013213a73c94340$var$TEST_NUMERIC = new RegExp("^" + $b013213a73c94340$var$numeric + "$");
const $b013213a73c94340$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$b013213a73c94340$export$175f16aef75a4569 = function testKanji(str) {
    return $b013213a73c94340$var$TEST_KANJI.test(str);
};
$b013213a73c94340$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $b013213a73c94340$var$TEST_NUMERIC.test(str);
};
$b013213a73c94340$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $b013213a73c94340$var$TEST_ALPHANUMERIC.test(str);
};


$cae377638d043a33$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$cae377638d043a33$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$cae377638d043a33$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$cae377638d043a33$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$cae377638d043a33$export$bb410559a65d3418 = {
    bit: -1
};
$cae377638d043a33$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$782d8067d3452d88$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$cae377638d043a33$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($b013213a73c94340$export$50b7f9bf92c74274(dataStr)) return $cae377638d043a33$export$4d318981b5a83836;
    else if ($b013213a73c94340$export$4ba5f52893b4ac97(dataStr)) return $cae377638d043a33$export$376a9ed239d6c1c8;
    else if ($b013213a73c94340$export$175f16aef75a4569(dataStr)) return $cae377638d043a33$export$a4d452c2363c8e12;
    else return $cae377638d043a33$export$8f4bf8f7eb581284;
};
$cae377638d043a33$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$cae377638d043a33$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $cae377638d043a33$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $cae377638d043a33$export$4d318981b5a83836;
        case "alphanumeric":
            return $cae377638d043a33$export$376a9ed239d6c1c8;
        case "kanji":
            return $cae377638d043a33$export$a4d452c2363c8e12;
        case "byte":
            return $cae377638d043a33$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$cae377638d043a33$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($cae377638d043a33$export$1ea939691cdc45b8(value)) return value;
    try {
        return $cae377638d043a33$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $b963f07dd79cf3c9$var$G18 = 7973;
const $b963f07dd79cf3c9$var$G18_BCH = $91cdba58884d7234$export$ed1d66da50968976($b963f07dd79cf3c9$var$G18);
function $b963f07dd79cf3c9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $b963f07dd79cf3c9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $b963f07dd79cf3c9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $cae377638d043a33$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $b963f07dd79cf3c9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $b963f07dd79cf3c9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $b963f07dd79cf3c9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $b963f07dd79cf3c9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $b963f07dd79cf3c9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $cae377638d043a33$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$b963f07dd79cf3c9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($782d8067d3452d88$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$b963f07dd79cf3c9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$782d8067d3452d88$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $cae377638d043a33$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $91cdba58884d7234$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $754bb1c97a766809$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $cae377638d043a33$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $b963f07dd79cf3c9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $cae377638d043a33$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $cae377638d043a33$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $cae377638d043a33$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $cae377638d043a33$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$b963f07dd79cf3c9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $1738c5e55a35086d$export$6788812c4e6611e6(errorCorrectionLevel, $1738c5e55a35086d$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $b963f07dd79cf3c9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $b963f07dd79cf3c9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$b963f07dd79cf3c9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$782d8067d3452d88$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($91cdba58884d7234$export$ed1d66da50968976(d) - $b963f07dd79cf3c9$var$G18_BCH >= 0)d ^= $b963f07dd79cf3c9$var$G18 << $91cdba58884d7234$export$ed1d66da50968976(d) - $b963f07dd79cf3c9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $e0355ef3a2961387$export$eee5438974ef6f0e;

const $e0355ef3a2961387$var$G15 = 1335;
const $e0355ef3a2961387$var$G15_MASK = 21522;
const $e0355ef3a2961387$var$G15_BCH = $91cdba58884d7234$export$ed1d66da50968976($e0355ef3a2961387$var$G15);
$e0355ef3a2961387$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($91cdba58884d7234$export$ed1d66da50968976(d) - $e0355ef3a2961387$var$G15_BCH >= 0)d ^= $e0355ef3a2961387$var$G15 << $91cdba58884d7234$export$ed1d66da50968976(d) - $e0355ef3a2961387$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $e0355ef3a2961387$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $9163ae0bcc5021d7$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $9163ae0bcc5021d7$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $9163ae0bcc5021d7$export$89ab1afb9839589b;

var $b2e5522a9e09eea2$exports = {};

function $b2e5522a9e09eea2$var$NumericData(data) {
    this.mode = $cae377638d043a33$export$4d318981b5a83836;
    this.data = data.toString();
}
$b2e5522a9e09eea2$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$b2e5522a9e09eea2$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$b2e5522a9e09eea2$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $b2e5522a9e09eea2$var$NumericData.getBitsLength(this.data.length);
};
$b2e5522a9e09eea2$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$b2e5522a9e09eea2$exports = $b2e5522a9e09eea2$var$NumericData;


var $2d6518d0f871d255$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $2d6518d0f871d255$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $2d6518d0f871d255$var$AlphanumericData(data) {
    this.mode = $cae377638d043a33$export$376a9ed239d6c1c8;
    this.data = data;
}
$2d6518d0f871d255$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$2d6518d0f871d255$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$2d6518d0f871d255$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $2d6518d0f871d255$var$AlphanumericData.getBitsLength(this.data.length);
};
$2d6518d0f871d255$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $2d6518d0f871d255$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $2d6518d0f871d255$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($2d6518d0f871d255$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$2d6518d0f871d255$exports = $2d6518d0f871d255$var$AlphanumericData;


var $bc44aaa8c2e5ea5e$exports = {};
var $1a2098ba4541471e$exports = {};
"use strict";
$1a2098ba4541471e$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $bc44aaa8c2e5ea5e$var$ByteData(data) {
    this.mode = $cae377638d043a33$export$8f4bf8f7eb581284;
    if (typeof data === "string") data = $1a2098ba4541471e$exports(data);
    this.data = new Uint8Array(data);
}
$bc44aaa8c2e5ea5e$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$bc44aaa8c2e5ea5e$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$bc44aaa8c2e5ea5e$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $bc44aaa8c2e5ea5e$var$ByteData.getBitsLength(this.data.length);
};
$bc44aaa8c2e5ea5e$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$bc44aaa8c2e5ea5e$exports = $bc44aaa8c2e5ea5e$var$ByteData;


var $4a95fe11e01942c4$exports = {};


function $4a95fe11e01942c4$var$KanjiData(data) {
    this.mode = $cae377638d043a33$export$a4d452c2363c8e12;
    this.data = data;
}
$4a95fe11e01942c4$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$4a95fe11e01942c4$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$4a95fe11e01942c4$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $4a95fe11e01942c4$var$KanjiData.getBitsLength(this.data.length);
};
$4a95fe11e01942c4$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $91cdba58884d7234$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$4a95fe11e01942c4$exports = $4a95fe11e01942c4$var$KanjiData;




var $464c4f46984ed00b$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $464c4f46984ed00b$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $464c4f46984ed00b$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $464c4f46984ed00b$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $464c4f46984ed00b$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $464c4f46984ed00b$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$464c4f46984ed00b$exports = $464c4f46984ed00b$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $9163ae0bcc5021d7$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $9163ae0bcc5021d7$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $9163ae0bcc5021d7$var$getSegmentsFromString(dataStr) {
    const numSegs = $9163ae0bcc5021d7$var$getSegments($b013213a73c94340$export$4d318981b5a83836, $cae377638d043a33$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $9163ae0bcc5021d7$var$getSegments($b013213a73c94340$export$376a9ed239d6c1c8, $cae377638d043a33$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($91cdba58884d7234$export$ce5b1274f8597fa0()) {
        byteSegs = $9163ae0bcc5021d7$var$getSegments($b013213a73c94340$export$8f4bf8f7eb581284, $cae377638d043a33$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $9163ae0bcc5021d7$var$getSegments($b013213a73c94340$export$a4d452c2363c8e12, $cae377638d043a33$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $9163ae0bcc5021d7$var$getSegments($b013213a73c94340$export$9df7c29d562bab83, $cae377638d043a33$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $9163ae0bcc5021d7$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $cae377638d043a33$export$4d318981b5a83836:
            return $b2e5522a9e09eea2$exports.getBitsLength(length);
        case $cae377638d043a33$export$376a9ed239d6c1c8:
            return $2d6518d0f871d255$exports.getBitsLength(length);
        case $cae377638d043a33$export$a4d452c2363c8e12:
            return $4a95fe11e01942c4$exports.getBitsLength(length);
        case $cae377638d043a33$export$8f4bf8f7eb581284:
            return $bc44aaa8c2e5ea5e$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $9163ae0bcc5021d7$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $9163ae0bcc5021d7$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $cae377638d043a33$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $cae377638d043a33$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $cae377638d043a33$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $cae377638d043a33$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $cae377638d043a33$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $cae377638d043a33$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $cae377638d043a33$export$8f4bf8f7eb581284,
                        length: $9163ae0bcc5021d7$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $cae377638d043a33$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $cae377638d043a33$export$8f4bf8f7eb581284,
                        length: $9163ae0bcc5021d7$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $9163ae0bcc5021d7$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $9163ae0bcc5021d7$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $9163ae0bcc5021d7$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $9163ae0bcc5021d7$var$getSegmentBitsLength(node.length, node.mode) + 4 + $cae377638d043a33$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $9163ae0bcc5021d7$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $cae377638d043a33$export$1bd4c93ffb42e55e(data);
    mode = $cae377638d043a33$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $cae377638d043a33$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $cae377638d043a33$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $cae377638d043a33$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $cae377638d043a33$export$a4d452c2363c8e12 && !$91cdba58884d7234$export$ce5b1274f8597fa0()) mode = $cae377638d043a33$export$8f4bf8f7eb581284;
    switch(mode){
        case $cae377638d043a33$export$4d318981b5a83836:
            return new $b2e5522a9e09eea2$exports(data);
        case $cae377638d043a33$export$376a9ed239d6c1c8:
            return new $2d6518d0f871d255$exports(data);
        case $cae377638d043a33$export$a4d452c2363c8e12:
            return new $4a95fe11e01942c4$exports(data);
        case $cae377638d043a33$export$8f4bf8f7eb581284:
            return new $bc44aaa8c2e5ea5e$exports(data);
    }
}
$9163ae0bcc5021d7$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($9163ae0bcc5021d7$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($9163ae0bcc5021d7$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$9163ae0bcc5021d7$export$3004f64547af360e = function fromString(data, version) {
    const segs = $9163ae0bcc5021d7$var$getSegmentsFromString(data, $91cdba58884d7234$export$ce5b1274f8597fa0());
    const nodes = $9163ae0bcc5021d7$var$buildNodes(segs);
    const graph = $9163ae0bcc5021d7$var$buildGraph(nodes, version);
    const path = $464c4f46984ed00b$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $9163ae0bcc5021d7$export$571d59b505e6bb4e($9163ae0bcc5021d7$var$mergeSegments(optimizedSegs));
};
$9163ae0bcc5021d7$export$89ab1afb9839589b = function rawSplit(data) {
    return $9163ae0bcc5021d7$export$571d59b505e6bb4e($9163ae0bcc5021d7$var$getSegmentsFromString(data, $91cdba58884d7234$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $1453e664ce7fb243$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $eeba47650dad370e$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $1453e664ce7fb243$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $1453e664ce7fb243$var$setupAlignmentPattern(matrix, version) {
    const pos = $01184f84440d1b6a$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $1453e664ce7fb243$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $b963f07dd79cf3c9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $1453e664ce7fb243$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $e0355ef3a2961387$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $1453e664ce7fb243$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $1453e664ce7fb243$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $e4fceb8e6fc0e4bb$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $cae377638d043a33$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $91cdba58884d7234$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $754bb1c97a766809$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $1453e664ce7fb243$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $1453e664ce7fb243$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $91cdba58884d7234$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $754bb1c97a766809$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $754bb1c97a766809$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $820083685316331f$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $1453e664ce7fb243$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $9163ae0bcc5021d7$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $9163ae0bcc5021d7$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $b963f07dd79cf3c9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $9163ae0bcc5021d7$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $b963f07dd79cf3c9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $1453e664ce7fb243$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $91cdba58884d7234$export$8d4a06d3facd414b(version);
    const modules = new $78c97781d6ab558d$exports(moduleCount);
    // Add function modules
    $1453e664ce7fb243$var$setupFinderPattern(modules, version);
    $1453e664ce7fb243$var$setupTimingPattern(modules);
    $1453e664ce7fb243$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $1453e664ce7fb243$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $1453e664ce7fb243$var$setupVersionInfo(modules, version);
    // Add data codewords
    $1453e664ce7fb243$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $fc0c14bf41116ea1$export$fe9625aaceb0e563(modules, $1453e664ce7fb243$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $fc0c14bf41116ea1$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $1453e664ce7fb243$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$1453e664ce7fb243$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $1738c5e55a35086d$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $1738c5e55a35086d$export$6788812c4e6611e6(options.errorCorrectionLevel, $1738c5e55a35086d$export$3a1a48c8f6ef640e);
        version = $b963f07dd79cf3c9$export$6788812c4e6611e6(options.version);
        mask = $fc0c14bf41116ea1$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $91cdba58884d7234$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $1453e664ce7fb243$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $07b76ab999efe049$export$b3890eb0ae9dca99;
var $07b76ab999efe049$export$c3e5526bbaf70a25;
var $718d1fce2b181560$export$d2312e68e1f5ad00;
var $718d1fce2b181560$export$5cdac61cf538712e;
var $718d1fce2b181560$export$c3a1a1f268a8142b;
var $718d1fce2b181560$export$83136f57c739c5f3;
function $718d1fce2b181560$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$718d1fce2b181560$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $718d1fce2b181560$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $718d1fce2b181560$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$718d1fce2b181560$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$718d1fce2b181560$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $718d1fce2b181560$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$718d1fce2b181560$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $718d1fce2b181560$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $07b76ab999efe049$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $07b76ab999efe049$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$07b76ab999efe049$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $07b76ab999efe049$var$getCanvasElement();
    opts = $718d1fce2b181560$export$d2312e68e1f5ad00(opts);
    const size = $718d1fce2b181560$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $718d1fce2b181560$export$83136f57c739c5f3(image.data, qrData, opts);
    $07b76ab999efe049$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$07b76ab999efe049$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $07b76ab999efe049$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $a7f3b57b9e883dce$export$b3890eb0ae9dca99;

function $a7f3b57b9e883dce$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $a7f3b57b9e883dce$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $a7f3b57b9e883dce$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $a7f3b57b9e883dce$var$svgCmd("M", col + margin, 0.5 + row + margin) : $a7f3b57b9e883dce$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $a7f3b57b9e883dce$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$a7f3b57b9e883dce$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $718d1fce2b181560$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $a7f3b57b9e883dce$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $a7f3b57b9e883dce$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $a7f3b57b9e883dce$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $33b99b026c95b649$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$ee9ac4fa23f6500f$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $1453e664ce7fb243$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $1453e664ce7fb243$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$33b99b026c95b649$export$185802fd694ee1f5 = $1453e664ce7fb243$export$185802fd694ee1f5;
$33b99b026c95b649$export$f87f6982d1fd4f81 = $33b99b026c95b649$var$renderCanvas.bind(null, $07b76ab999efe049$export$b3890eb0ae9dca99);
$33b99b026c95b649$export$723e4939e5a27c8 = $33b99b026c95b649$var$renderCanvas.bind(null, $07b76ab999efe049$export$c3e5526bbaf70a25);
$33b99b026c95b649$export$f84e8e69fd4488a5 = $33b99b026c95b649$var$renderCanvas.bind(null, function(data, _, opts) {
    return $a7f3b57b9e883dce$export$b3890eb0ae9dca99(data, opts);
});



const $632cd86b6f39203f$var$createLinkAttachmentCard = async ({ url: url, title: title, download: download })=>{
    const qrcode = await (0, (/*@__PURE__*/$parcel$interopDefault($33b99b026c95b649$exports))).toDataURL(url);
    const hasTitle = title && !title.includes("pause0x0") && !title.includes("pause1x1") && !title.includes("pause2x2");
    return {
        contentType: (0, $59de7fd3862e5431$export$cce25171fe980112),
        content: {
            urlData: {
                url: url,
                title: hasTitle ? title : undefined,
                download: download
            },
            qrCode: qrcode
        }
    };
};
const $632cd86b6f39203f$export$bd1cb79b05472e01 = async (urlDataArray)=>{
    const splitAttachments = [];
    for (const data of urlDataArray){
        const qrcode = await (0, (/*@__PURE__*/$parcel$interopDefault($33b99b026c95b649$exports))).toDataURL(data.url);
        const newLinkAttachment = {
            contentType: (0, $59de7fd3862e5431$export$cce25171fe980112),
            content: {
                urlData: {
                    url: data.url,
                    title: data.title,
                    download: data.download
                },
                qrCode: qrcode
            }
        };
        splitAttachments.push(newLinkAttachment);
    }
    return splitAttachments;
};
var $632cd86b6f39203f$export$2e2bcd8739ae039 = $632cd86b6f39203f$var$createLinkAttachmentCard;




const $c894687bb01cc4b7$var$createImageAttachmentCard = async (imageData)=>{
    const naturalSize = await $c894687bb01cc4b7$var$getNaturalSize(imageData.url);
    let miniaturedDisplay = false;
    // If an error occured, we retrieve width = 0 and height = 0
    if (naturalSize.width === 0 && naturalSize.height === 0) imageData = {
        url: `${(0, $15bfb737ffe6480e$export$e56d88b19b5c9fbf).noimage}`,
        alt: "Image no found"
    };
    else miniaturedDisplay = naturalSize.width < 400 && naturalSize.height < 300;
    return {
        contentType: (0, $59de7fd3862e5431$export$c50891df8986f6d9),
        content: {
            ...imageData,
            isMiniature: miniaturedDisplay
        }
    };
};
const $c894687bb01cc4b7$var$getNaturalSize = async (url)=>{
    return new Promise((resolve)=>{
        const img = new Image();
        img.onload = ()=>resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        img.onerror = ()=>{
            resolve({
                width: 0,
                height: 0
            });
        };
        img.src = url;
    });
};
var $c894687bb01cc4b7$export$2e2bcd8739ae039 = $c894687bb01cc4b7$var$createImageAttachmentCard;



const $7ab95a468b948b84$var$processDirectLineIncomingActivity = (activity)=>{
    const dataToReturn = {
        speak: undefined,
        text: undefined,
        htmlText: undefined,
        images: [],
        urls: []
    };
    const usedImageURLs = [];
    const usedLinkURLs = [];
    // Deal with 'speak' field if present
    if (activity?.speak) {
        // Make all the treatments needed for markdown and speechmarkdown
        const data = (0, $e621961b26da67d1$export$1b8fbc30fb87d9aa)(activity.speak);
        dataToReturn.speak = data.text;
        dataToReturn.images = data.images;
        dataToReturn.urls = data.urls;
        // Add the used image URLs and link URLs to prevent doubles
        data.images.forEach((data)=>{
            usedImageURLs.push(data.url);
        });
        data.urls.forEach((data)=>{
            usedLinkURLs.push(data.url);
        });
    }
    // Deal with 'text' field if present
    if (activity?.text) {
        // Make all the treatments needed for markdown and speechmarkdown
        const data = (0, $e621961b26da67d1$export$1b8fbc30fb87d9aa)(activity.text);
        dataToReturn.text = data.text;
        dataToReturn.htmlText = data.htmlText;
        // Don't add images if they are already in the array (already extracted from the 'speak' field)
        data.images.forEach((image)=>{
            !usedImageURLs.includes(image.url) && dataToReturn.images.push(image);
        });
        // Don't add urls if they are already in the array (already extracted from the 'speak' field)
        data.urls.forEach((url)=>{
            !usedLinkURLs.includes(url.url) && dataToReturn.urls.push(url);
        });
    }
    return dataToReturn;
};
var $7ab95a468b948b84$export$2e2bcd8739ae039 = $7ab95a468b948b84$var$processDirectLineIncomingActivity;


const $d023474b51a6fd24$var$initialState = {
    activities: [],
    lastActivity: undefined,
    lastBotActivity: undefined,
    homeActivity: undefined,
    messageActivities: [],
    lastMessageActivity: undefined,
    eventActivities: [],
    lastEventActivity: undefined,
    botMessageActivities: [],
    lastBotMessageActivity: undefined,
    botEventActivities: [],
    lastBotEventActivity: undefined,
    userMessageActivities: [],
    lastUserMessageActivity: undefined,
    conversationId: null,
    watermark: 0,
    retrievingConversation: false,
    addRetorikNewsConversationIdInLocalStorage: undefined,
    cookies: [],
    queue: [],
    queueLock: false
};
const $d023474b51a6fd24$var$regexDataCommand = /(\{data-command=")[\p{L}\p{N}\p{Po}\p{Pd}\p{Pc}\s\u0027\u2019]+("\})(<br\s\/>)?/gu;
const $d023474b51a6fd24$export$b56465394e2b1287 = (0, $126de8f2db9c4dbc$exports.create)()(()=>{
    return $d023474b51a6fd24$var$initialState;
});
const $d023474b51a6fd24$var$checkCurrentConversationId = (value)=>{
    const currentConversationId = $d023474b51a6fd24$export$b56465394e2b1287.getState().conversationId;
    return !!(currentConversationId && value?.includes(currentConversationId));
};
const $d023474b51a6fd24$export$4365557467e67cdc = (value)=>{
    const currentState = $d023474b51a6fd24$export$b56465394e2b1287.getState();
    // Add current conversation id with tenant name in local storage if we are in a RetorikNews component.
    // This prevents creating a new conversation each time RetorikNews is launched (used in Retorik Kiosk).
    if (currentState.addRetorikNewsConversationIdInLocalStorage) {
        const dataToPutInlocalStorage = {
            conversationId: value,
            startedAt: Date.now()
        };
        localStorage.setItem(`Retorik.News.Conversation.${currentState.addRetorikNewsConversationIdInLocalStorage}`, JSON.stringify(dataToPutInlocalStorage));
        $d023474b51a6fd24$export$b56465394e2b1287.setState({
            addRetorikNewsConversationIdInLocalStorage: undefined
        });
    }
    // Check directline id to know if we have to reset the activities
    if (value && value !== currentState.conversationId) {
        currentState.conversationId === null ? $d023474b51a6fd24$export$b56465394e2b1287.setState({
            conversationId: value
        }) : $d023474b51a6fd24$export$b56465394e2b1287.setState({
            ...$d023474b51a6fd24$var$initialState,
            conversationId: value
        });
        // Set desired cookies once the conversation id is set / changed
        $d023474b51a6fd24$export$2472689afa4550f7();
    }
};
const $d023474b51a6fd24$var$processQueue = async ()=>{
    const currentQueue = $d023474b51a6fd24$export$b56465394e2b1287.getState().queue;
    if (currentQueue.length) {
        const currentActivity = currentQueue[0];
        currentActivity.type === "message" ? await $d023474b51a6fd24$var$processAddBotMessage(currentActivity) : await $d023474b51a6fd24$var$processAddBotEvent(currentActivity);
        // Remove the first element from the queue (the one that got processed above) and process the queue once again
        $d023474b51a6fd24$export$b56465394e2b1287.setState({
            queue: currentQueue.splice(1)
        });
        $d023474b51a6fd24$var$processQueue();
    } else $d023474b51a6fd24$export$b56465394e2b1287.setState({
        queueLock: false
    });
};
const $d023474b51a6fd24$var$processAddBotMessage = async (value)=>{
    (0, $649c384b79ea2395$export$a619c8fe018044c1)(undefined);
    const currentState = $d023474b51a6fd24$export$b56465394e2b1287.getState();
    const processedActivity = await $d023474b51a6fd24$var$processBotMessageActivity(value);
    // Set the home activity to be able to show its attachments when needed
    if (processedActivity.messageType === "welcome") $d023474b51a6fd24$export$b56465394e2b1287.setState({
        homeActivity: processedActivity
    });
    // If this activity is the one concluding a streaming, let's set the amount of streams previously generated
    if (!currentState.retrievingConversation && value.value?.streamingCount) (0, $b8685bd729fa723f$export$e9ca045daeb00700)(value.value.streamingCount, value.replyToId);
    const tempActivity = currentState.retrievingConversation ? undefined : processedActivity;
    $d023474b51a6fd24$export$b56465394e2b1287.setState({
        activities: [
            ...currentState.activities,
            processedActivity
        ],
        lastActivity: tempActivity,
        lastBotActivity: tempActivity,
        messageActivities: [
            ...currentState.messageActivities,
            processedActivity
        ],
        botMessageActivities: [
            ...currentState.botMessageActivities,
            processedActivity
        ],
        lastMessageActivity: tempActivity,
        lastBotMessageActivity: tempActivity,
        watermark: currentState.watermark + 1
    });
    Promise.resolve();
};
const $d023474b51a6fd24$export$2c98bb0c7fa688b3 = async (value)=>{
    const currentState = $d023474b51a6fd24$export$b56465394e2b1287.getState();
    if ($d023474b51a6fd24$var$checkCurrentConversationId(value.id)) {
        if (currentState.queueLock) $d023474b51a6fd24$export$b56465394e2b1287.setState({
            queue: [
                ...currentState.queue,
                value
            ]
        });
        else {
            $d023474b51a6fd24$export$b56465394e2b1287.setState({
                queueLock: true
            });
            await $d023474b51a6fd24$var$processAddBotMessage(value);
            (0, $1c9be018817ca3e3$export$a6540370871e3c67)(undefined);
            (0, $1bda010252da638c$export$f03cfde7db70aa27)(false);
            (0, $1bda010252da638c$export$e49d67c72fb28d58)();
            (0, $7c69764370dcab43$export$b468e470fbb95f20)(false);
            $d023474b51a6fd24$var$processQueue();
        }
    }
};
const $d023474b51a6fd24$var$processAddBotEvent = async (value)=>{
    const currentState = $d023474b51a6fd24$export$b56465394e2b1287.getState();
    $d023474b51a6fd24$export$b56465394e2b1287.setState({
        activities: [
            ...currentState.activities,
            value
        ],
        lastActivity: currentState.retrievingConversation ? undefined : value,
        lastBotActivity: currentState.retrievingConversation ? undefined : value,
        eventActivities: [
            ...currentState.eventActivities,
            value
        ],
        botEventActivities: [
            ...currentState.botEventActivities,
            value
        ],
        lastBotEventActivity: value,
        lastEventActivity: value,
        watermark: currentState.watermark + 1
    });
    Promise.resolve();
};
const $d023474b51a6fd24$export$bb2ccecd43d76d90 = async (value)=>{
    if ($d023474b51a6fd24$var$checkCurrentConversationId(value.id)) {
        const currentState = $d023474b51a6fd24$export$b56465394e2b1287.getState();
        if (value.name?.toLowerCase() === "davi.streammessageactivity") {
            if (value.text?.trim().length && !currentState.retrievingConversation) {
                (0, $7c69764370dcab43$export$b468e470fbb95f20)(false);
                // Create speak field from the text one
                const processedText = (0, $e621961b26da67d1$export$1b8fbc30fb87d9aa)(value.text, true);
                value.speak = processedText.text;
                (0, $1c9be018817ca3e3$export$a6540370871e3c67)(undefined);
                (0, $b8685bd729fa723f$export$9a026d007e335fc0)(value);
                (0, $1bda010252da638c$export$e49d67c72fb28d58)();
            }
        } else if (currentState.queueLock) $d023474b51a6fd24$export$b56465394e2b1287.setState({
            queue: [
                ...currentState.queue,
                value
            ]
        });
        else {
            $d023474b51a6fd24$export$b56465394e2b1287.setState({
                queueLock: true
            });
            await $d023474b51a6fd24$var$processAddBotEvent(value);
            (0, $1bda010252da638c$export$e49d67c72fb28d58)();
            (0, $7c69764370dcab43$export$b468e470fbb95f20)(false);
            $d023474b51a6fd24$var$processQueue();
        }
    }
};
const $d023474b51a6fd24$export$bf77ccf2b7638432 = async (value)=>{
    if ($d023474b51a6fd24$var$checkCurrentConversationId(value.id)) {
        (0, $7c69764370dcab43$export$b468e470fbb95f20)(true);
        const currentState = $d023474b51a6fd24$export$b56465394e2b1287.getState();
        $d023474b51a6fd24$export$b56465394e2b1287.setState({
            activities: [
                ...currentState.activities,
                value
            ],
            lastActivity: value,
            messageActivities: [
                ...currentState.messageActivities,
                value
            ],
            userMessageActivities: [
                ...currentState.userMessageActivities,
                value
            ],
            lastMessageActivity: value,
            lastUserMessageActivity: value,
            watermark: currentState.watermark + 1
        });
    }
};
const $d023474b51a6fd24$export$ff4f3927f89b50e8 = (value)=>{
    if ($d023474b51a6fd24$var$checkCurrentConversationId(value.id)) {
        // Only wait for response if the event is one that need it
        !(0, $bbe458fac496c294$export$6a32bf5257e620e1).find((eventName)=>value.name?.toLowerCase().includes(eventName)) && (0, $7c69764370dcab43$export$b468e470fbb95f20)(true);
        const currentState = $d023474b51a6fd24$export$b56465394e2b1287.getState();
        $d023474b51a6fd24$export$b56465394e2b1287.setState({
            activities: [
                ...currentState.activities,
                value
            ],
            lastActivity: value,
            lastEventActivity: value,
            eventActivities: [
                ...currentState.eventActivities,
                value
            ],
            watermark: currentState.watermark + 1
        });
    }
};
const $d023474b51a6fd24$export$d7e4f7861d387c67 = (value)=>{
    $d023474b51a6fd24$export$b56465394e2b1287.setState({
        retrievingConversation: value
    });
};
const $d023474b51a6fd24$export$3d2327b52759cec0 = (value)=>{
    $d023474b51a6fd24$export$b56465394e2b1287.setState({
        addRetorikNewsConversationIdInLocalStorage: value
    });
};
const $d023474b51a6fd24$export$ad1f3d930a6d4d42 = (value)=>{
    if (value) {
        const currentCookies = $d023474b51a6fd24$export$b56465394e2b1287.getState().cookies;
        $d023474b51a6fd24$export$b56465394e2b1287.setState({
            cookies: [
                ...currentCookies,
                value
            ]
        });
    }
};
const $d023474b51a6fd24$export$2472689afa4550f7 = ()=>{
    const cookies = $d023474b51a6fd24$export$b56465394e2b1287.getState().cookies;
    if (cookies.length) {
        cookies.forEach((cookie)=>{
            if (cookie.indexOf("<conversationId>") > -1) {
                const conversationId = $d023474b51a6fd24$export$b56465394e2b1287.getState().conversationId;
                if (conversationId) {
                    const processedCookie = cookie.replace("<conversationId>", conversationId);
                    document.cookie = processedCookie;
                }
            } else document.cookie = cookie;
        });
        $d023474b51a6fd24$export$b56465394e2b1287.setState({
            cookies: []
        });
    }
};
const $d023474b51a6fd24$export$b7b23f8e09258fa6 = ()=>{
    $d023474b51a6fd24$export$b56465394e2b1287.setState({
        ...$d023474b51a6fd24$var$initialState
    });
};
const $d023474b51a6fd24$var$processBotMessageActivity = async (activity)=>{
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f).getState().configuration.isUsedOnBorne;
    // If the application is used on a borne and there are attachments, check if a received attachment is a multi-link one.
    // If there is some, we need to split it in several attachments, one for each link.
    if (isUsedOnBorne && activity.attachments?.length) {
        let count = 0;
        const tempAttachments = [];
        for (const attachment of activity.attachments)if (attachment.contentType === (0, $59de7fd3862e5431$export$cce25171fe980112) && Array.isArray(attachment.content?.urlData)) {
            count++;
            const splitAttachments = await (0, $632cd86b6f39203f$export$bd1cb79b05472e01)(attachment.content.urlData);
            tempAttachments.push(...splitAttachments);
        } else tempAttachments.push(attachment);
        // If some attachments have been split, we replace the attachments in the activity
        count > 0 && (activity.attachments = tempAttachments);
        // Carousel display if there is more than 1 card
        count > 0 && activity.attachments.length > 1 && (activity.attachmentLayout = "carousel");
    }
    const processedData = (0, $7ab95a468b948b84$export$2e2bcd8739ae039)(activity);
    // Set processed speak, text and attachments if there are some
    processedData.speak && (activity.speak = processedData.speak);
    processedData.text && (activity.text = processedData.text);
    processedData.htmlText && (activity.htmlText = processedData.htmlText);
    // Check if there are cards to create from images
    if (processedData.images.length > 0) {
        // If there is no attachment field, create an empty one
        activity.attachments === undefined && (activity.attachments = []);
        // Create content from image data and add it to the attachments
        for (const image of processedData.images){
            const imageAttachment = await (0, $c894687bb01cc4b7$export$2e2bcd8739ae039)(image);
            activity.attachments.push(imageAttachment);
        }
        activity.attachments.length > 1 && (activity.attachmentLayout = "carousel");
    }
    // Check if there are cards to create from links
    if (processedData.urls.length > 0) {
        // If there is no attachment field, create an empty one
        activity.attachments === undefined && (activity.attachments = []);
        // Create content asynchonously from url data and add it to the attachments
        for (const url of processedData.urls){
            const fetchedAttachment = await (0, $632cd86b6f39203f$export$2e2bcd8739ae039)(url);
            activity.attachments.push(fetchedAttachment);
        }
        activity.attachments.length > 1 && (activity.attachmentLayout = "carousel");
    }
    // Transform herocards in adaptivecards
    const heroToAdaptiveAttachments = (0, $58c3da5dd619bf21$export$4a92a69e5bfa5f9a)(activity.attachments);
    heroToAdaptiveAttachments && (activity.attachments = [
        ...heroToAdaptiveAttachments
    ]);
    // Transform suggested actions into cards if the display isn't daviList
    if (activity.suggestedActions?.actions && activity.attachmentLayout?.toLowerCase() !== "davilist") {
        let actionsArray = [];
        activity.suggestedActions.actions.forEach((suggestedAction)=>{
            const action = {
                title: suggestedAction.title,
                action: suggestedAction.value
            };
            actionsArray = [
                ...actionsArray,
                action
            ];
        });
        const suggestedActionAttachment = {
            contentType: (0, $59de7fd3862e5431$export$2730c89e9ebd0948),
            content: {
                title: activity.text || "",
                actions: actionsArray
            }
        };
        // Create field attachments with the newly created one if no attachment yet, or add to existing ones
        activity.attachments === undefined ? activity.attachments = [
            suggestedActionAttachment
        ] : activity.attachments.push(suggestedActionAttachment);
    }
    // Deal with text containing [data command] data to make them usable in text mode
    if (activity?.text && activity.text.includes("{data-command=")) {
        const splitText = activity.text.split("{data-command=");
        const dataForAttachment = [];
        for(let i = 1; i < splitText.length; i++){
            const text = splitText[i - 1].substring(splitText[i - 1].lastIndexOf("\n") ? splitText[i - 1].lastIndexOf("\n") + 1 : 0).trim();
            const replacement = splitText[i].substring(0, splitText[i].indexOf("}")).replaceAll('"', "");
            dataForAttachment.push({
                text: text,
                differentTextToSend: replacement
            });
            // Remove text part from speak / text / htmlText
            activity.speak && (activity.speak = activity.speak.replace(text, ""));
            activity.text = activity.text.replace(text, "");
            activity.htmlText = activity.htmlText?.replace(text, "");
        }
        if (dataForAttachment.length > 0) {
            const suggestionAttachment = {
                contentType: (0, $59de7fd3862e5431$export$a4f2f23a67537f78),
                content: {
                    suggestions: dataForAttachment,
                    showTutorial: false
                }
            };
            // Create field attachment swith the newly created one if no attachment yet, or add to existing ones
            activity.attachments === undefined ? activity.attachments = [
                suggestionAttachment
            ] : activity.attachments.push(suggestionAttachment);
        }
        // Remove all [data command] from speak / text / htmlText
        activity.speak && (activity.speak = activity.speak.replaceAll($d023474b51a6fd24$var$regexDataCommand, ""));
        activity.text = activity.text.replaceAll($d023474b51a6fd24$var$regexDataCommand, "");
        activity.htmlText = activity.htmlText?.replaceAll($d023474b51a6fd24$var$regexDataCommand, "");
    }
    return activity;
};




var $10936a3e32e1d945$export$bbd16b9b30e132b3;
(function($10936a3e32e1d945$export$bbd16b9b30e132b3) {
    $10936a3e32e1d945$export$bbd16b9b30e132b3["UNKNOWN"] = "DIRECT_LINE/UNKNOWN";
    $10936a3e32e1d945$export$bbd16b9b30e132b3["INCOMING_ACTIVITY"] = "DIRECT_LINE/INCOMING_ACTIVITY";
    $10936a3e32e1d945$export$bbd16b9b30e132b3["POST_ACTIVITY"] = "DIRECT_LINE/POST_ACTIVITY";
    $10936a3e32e1d945$export$bbd16b9b30e132b3["POST_ACTIVITY_FULFILLED"] = "DIRECT_LINE/POST_ACTIVITY_FULFILLED";
    $10936a3e32e1d945$export$bbd16b9b30e132b3["SEND_MESSAGE"] = "WEB_CHAT/SEND_MESSAGE";
    $10936a3e32e1d945$export$bbd16b9b30e132b3["SEND_EVENT"] = "WEB_CHAT/SEND_EVENT";
    $10936a3e32e1d945$export$bbd16b9b30e132b3["TYPING"] = "WEB_CHAT/EMIT_TYPING_INDICATOR";
    $10936a3e32e1d945$export$bbd16b9b30e132b3["MARK"] = "WEB_CHAT/MARK_ACTIVITY";
    $10936a3e32e1d945$export$bbd16b9b30e132b3["SET_LANGUAGE"] = "WEB_CHAT/SET_LANGUAGE";
})($10936a3e32e1d945$export$bbd16b9b30e132b3 || ($10936a3e32e1d945$export$bbd16b9b30e132b3 = {}));
const $10936a3e32e1d945$export$741b3b19a0ba7556 = {
    0: "DIRECT_LINE/CONNECT",
    1: "DIRECT_LINE/CONNECT_PENDING",
    2: "DIRECT_LINE/CONNECT_FULFILLED",
    3: "DIRECT_LINE/EXPIRED_TOKEN",
    4: "DIRECT_LINE/CONNECT_FAILED",
    5: "DIRECT_LINE/CONNECT_ENDED"
};






const $e837502f2e0b0685$var$processBaseURI = (baseURI)=>{
    if (baseURI && baseURI.length > 0) {
        if (baseURI.indexOf(`/${(0, $bbe458fac496c294$export$d9e38c0112bbdae6)}`) > -1) baseURI = baseURI.replace(`/${(0, $bbe458fac496c294$export$d9e38c0112bbdae6)}`, "");
    }
    return baseURI;
};
var $e837502f2e0b0685$export$2e2bcd8739ae039 = $e837502f2e0b0685$var$processBaseURI;



const $a6ed223e0fdb911e$var$processPrefix = (prefix)=>{
    switch(prefix){
        case "dev":
            return 0, $bbe458fac496c294$export$9adff68f093278ec;
        case "staging":
        case "preview":
            return 0, $bbe458fac496c294$export$409889737849a04f;
        case "experimental":
            return 0, $bbe458fac496c294$export$a4481ccc388fce2a;
        default:
            return 0, $bbe458fac496c294$export$c398bfda6cfa19ff;
    }
};
var $a6ed223e0fdb911e$export$2e2bcd8739ae039 = $a6ed223e0fdb911e$var$processPrefix;


async function $13041c27a96c6593$export$2e2bcd8739ae039({ tenant: tenant, prefix: prefix, baseURI: baseURI }) {
    const fullAddress = `${baseURI && baseURI?.length > 0 ? (0, $e837502f2e0b0685$export$2e2bcd8739ae039)(baseURI) : (0, $a6ed223e0fdb911e$export$2e2bcd8739ae039)(prefix)}/${tenant ? tenant + "/" : ""}api/graphql?query={siteCultures{culture,default}}`;
    const languages = await fetch(fullAddress).then((res)=>res.json()).then((json)=>{
        return $13041c27a96c6593$var$processJson(json);
    }).catch((error)=>{
        console.log(error);
        return 0, $bbe458fac496c294$export$8828fbbb6034a09b;
    });
    return languages;
}
/* The data received from the fetch are as follows
{
  data: {
    siteCultures: [
      {
        culture: "fr-FR",
        default: true
      },
      {
        culture: "en-US",
        default: false
      },
      {
        culture: "de-DE",
        default: false
      }
    ]
  }
}
*/ const $13041c27a96c6593$var$processJson = (json)=>{
    if (!json.data?.siteCultures || !json.data.siteCultures?.length) return 0, $bbe458fac496c294$export$8828fbbb6034a09b;
    // Filter data to remove sitecultures without culture as <language>-<culture>
    const siteCultures = json.data.siteCultures.filter((siteCulture)=>siteCulture.culture?.includes("-"));
    const processedLanguages = {
        all: siteCultures.map((siteCulture)=>siteCulture.culture),
        default: siteCultures.find((siteCulture)=>siteCulture.default)?.culture || siteCultures[0].culture
    };
    return processedLanguages;
};


var $b5fbaa9e2139763f$exports = {};

$parcel$export($b5fbaa9e2139763f$exports, "ar_EG", () => (/*@__PURE__*/$parcel$interopDefault($ab529533f428086c$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "ar_SA", () => (/*@__PURE__*/$parcel$interopDefault($f3fd76c7f136d593$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "ca_ES", () => (/*@__PURE__*/$parcel$interopDefault($7292e60d28a28350$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "cs_CZ", () => (/*@__PURE__*/$parcel$interopDefault($d36ae826bd9e59be$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "da_DK", () => (/*@__PURE__*/$parcel$interopDefault($614e828340e39df0$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "de_AT", () => (/*@__PURE__*/$parcel$interopDefault($f016f7f606473c04$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "de_CH", () => (/*@__PURE__*/$parcel$interopDefault($1ab285038621486d$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "de_DE", () => (/*@__PURE__*/$parcel$interopDefault($03dad743eb12a740$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "en_CA", () => (/*@__PURE__*/$parcel$interopDefault($c9358d0b39b3a4e6$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "en_GB", () => (/*@__PURE__*/$parcel$interopDefault($99a1008962dadb2f$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "en_HK", () => (/*@__PURE__*/$parcel$interopDefault($fcd3f355214c65a9$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "en_IE", () => (/*@__PURE__*/$parcel$interopDefault($8a63153b37715e9f$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "en_IN", () => (/*@__PURE__*/$parcel$interopDefault($6c55475abaaf7953$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "en_US", () => (/*@__PURE__*/$parcel$interopDefault($146a27d0d7348c8f$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "es_ES", () => (/*@__PURE__*/$parcel$interopDefault($deebe3fffa664b94$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "es_MX", () => (/*@__PURE__*/$parcel$interopDefault($48a2135a74ecfbf7$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "fi_FI", () => (/*@__PURE__*/$parcel$interopDefault($375e79e4752e74e9$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "fr_BE", () => (/*@__PURE__*/$parcel$interopDefault($ef45527fb915fe31$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "fr_CA", () => (/*@__PURE__*/$parcel$interopDefault($ffd5f23dea726f50$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "fr_CH", () => (/*@__PURE__*/$parcel$interopDefault($5e029386ed40f19e$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "fr_FR", () => (/*@__PURE__*/$parcel$interopDefault($3af5e0a31f6d74a1$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "hi_IN", () => (/*@__PURE__*/$parcel$interopDefault($e433c4a4857d0f41$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "hu_HU", () => (/*@__PURE__*/$parcel$interopDefault($2de632c04f2593c0$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "id_ID", () => (/*@__PURE__*/$parcel$interopDefault($1cfd5d54fed2fa2e$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "it_IT", () => (/*@__PURE__*/$parcel$interopDefault($62f9aaaa306924ca$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "ja_JP", () => (/*@__PURE__*/$parcel$interopDefault($ce2c38c9bab3aa30$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "ko_KR", () => (/*@__PURE__*/$parcel$interopDefault($b39f24ced614226f$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "nb_NO", () => (/*@__PURE__*/$parcel$interopDefault($ede0ca3632345ca8$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "nl_BE", () => (/*@__PURE__*/$parcel$interopDefault($7d433ccee5b53141$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "nl_NL", () => (/*@__PURE__*/$parcel$interopDefault($4459987f50724095$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "pl_PL", () => (/*@__PURE__*/$parcel$interopDefault($fb57665a54fe923c$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "pt_BR", () => (/*@__PURE__*/$parcel$interopDefault($c7271d95c1c7c5e6$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "pt_PT", () => (/*@__PURE__*/$parcel$interopDefault($6ca0c53809a587dc$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "ru_RU", () => (/*@__PURE__*/$parcel$interopDefault($2182efbf0e72c4fc$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "sv_SE", () => (/*@__PURE__*/$parcel$interopDefault($9b81038127634bc3$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "th_TH", () => (/*@__PURE__*/$parcel$interopDefault($6dd0dc0dad4d5e5c$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "tr_TR", () => (/*@__PURE__*/$parcel$interopDefault($ed9701567b41642c$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "zh_CN", () => (/*@__PURE__*/$parcel$interopDefault($884c511669295af6$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "zh_HK", () => (/*@__PURE__*/$parcel$interopDefault($26dc78b95f4d9617$exports)));
$parcel$export($b5fbaa9e2139763f$exports, "zh_TW", () => (/*@__PURE__*/$parcel$interopDefault($b2b7d01ab532a25c$exports)));
/* eslint-disable camelcase */ var $ab529533f428086c$exports = {};
$ab529533f428086c$exports = JSON.parse('{"1":"\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629","2":"\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629","3":"\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633","4":"\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626","1000":"\u062A\u0627\u0631\u064A\u062E\u064A","1001":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","common":{"all":"\u0627\u0644\u062C\u0645\u064A\u0639","back":"\u062E\u0644\u0641","close":"\u0627\u063A\u0644\u0627\u0642","continue":"\u064A\u0643\u0645\u0644","download":"\u062A\u062D\u0645\u064A\u0644","downloadsheet":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","downloadsheetmobile":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","filter":"\u0645\u0646\u0642\u064A","history":"\u062A\u0627\u0631\u064A\u062E\u064A","lang":"\u0627\u0644\u0644\u063A\u0627\u062A","menu":"\u0627\u0644\u0642\u0627\u0626\u0645\u0629","mode":"\u0645\u0648\u0636\u0629","needhelp":"\u062A\u062D\u062A\u0627\u062C \u0645\u0633\u0627\u0639\u062F\u0629\u061F","parameters":"\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A","print":"\u0645\u0637\u0628\u0639\u0629","printsheet":"\u0627\u0637\u0628\u0639 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","result":"\u0646\u062A\u064A\u062C\u0629","results":"\u0646\u062A\u0627\u0626\u062C","singleLang":"\u0644\u063A\u0629","sound":"\u0647\u0627","submit":"\u064A\u064F\u0642\u062F\u0651\u0650\u0645","subtitle":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0639\u064A","tutorial":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","validate":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629"},"emergency":{"samu":".S.A.M.U","police":"\u0634\u0631\u0637\u0629","firefighter":"\u0631\u062C\u0627\u0644 \u0627\u0644\u0627\u0637\u0641\u0627\u0621","general":"\u0639\u0627\u0645","citypolice":"\u0627\u0644\u0634\u0631\u0637\u0629 \u0627\u0644\u0645\u062D\u0644\u064A\u0629","hospital":"\u0645\u0633\u062A\u0634\u0641\u0649","homeless":"\u0628\u0644\u0627 \u0645\u0623\u0648\u0649 (\u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u062C\u0627\u0646\u064A\u0629)","poison":"\u0645\u0631\u0643\u0632 \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u0633\u0645\u0648\u0645","emergency":"\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0637\u0648\u0627\u0631\u0626 \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A\u0629"},"error":{"title":"\u062D\u062F\u062B \u062E\u0637\u0623","button":"\u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"},"history":{"title":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629"},"inputs":{"choose":"\u0627\u062E\u062A\u0631 \u0625\u062C\u0627\u0628\u0629"},"language":{"change":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0644\u063A\u0629","select":"\u062D\u062F\u062F \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627"},"link":{"buttontext":"\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629","goto":"\u0627\u0630\u0647\u0628 \u0625\u0644\u0649 \u0627\u0644\u0639\u0646\u0648\u0627\u0646","click":"\u0627\u0646\u0642\u0631 \u0647\u0646\u0627","scanQR":"\u0639\u0646 \u0637\u0631\u064A\u0642 \u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629","scanQRTile":"\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0644\u0627\u0643\u062A\u0634\u0627\u0641"},"loader":{"loader":{"optimal":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","classic":"\u0644\u062A\u062C\u0631\u0628\u0629 \u0623\u0643\u062B\u0631 \u0643\u0644\u0627\u0633\u064A\u0643\u064A\u0629\u060C","vocal":"\u0623\u0646\u0627 \u0623\u062A\u062D\u062F\u062B \u0648\u062C\u0647\u0627 \u0644\u0648\u062C\u0647 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644.","text":"\u0623\u062A\u0648\u0627\u0635\u0644 \u0643\u062A\u0627\u0628\u064A\u064B\u0627 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644."},"modes":{"vocal":"\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A","text":"\u0648\u0636\u0639 \u0627\u0644\u0646\u0635"},"loaderValidation":"\u0627\u0628\u062F\u0623 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","locale":"\u0641\u062D\u0635 \u0627\u0644\u0644\u063A\u0629","supported":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0644\u063A\u0627\u062A \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629","addressdata":"\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"},"menu":{"message":"\u0623\u062F\u062E\u0644 \u0631\u0633\u0627\u0644\u062A\u0643","allowMicrophone":"\u0627\u0633\u0645\u062D \u0644\u0645\u062A\u0635\u0641\u062D\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629","backconversation":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","answer":" \u064A\u062C\u064A\u0628 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643"},"mobileLandscapePreventer":{"firstline":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","secondline":"\u0627\u0642\u0644\u0628 \u0634\u0627\u0634\u062A\u0643"},"news":{"warningtext":"\u0633\u062A\u062F\u062E\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0625\u062E\u0628\u0627\u0631\u064A\u0629\u060C \u0648\u0633\u064A\u062A\u0645 \u062A\u0646\u0634\u064A\u0637 \u0627\u0644\u0635\u0648\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643","live":"\u0645\u0628\u0627\u0634\u0631","continuous":"\u0644\u0646\u0643\u0645\u0644"},"poi":{"comment":"\u0631\u0623\u064A \u0627\u0644\u0639\u0645\u064A\u0644","route":"\u0637\u0631\u064A\u0642","nodata":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u064A\u0637\u0627\u0628\u0642 \u0628\u062D\u062B\u0643","openinghours":"\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644","prices":"\u0627\u0644\u0623\u0633\u0639\u0627\u0631","paymentmethods":"\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639","numberofplaces":"\u0639\u062F\u062F \u0627\u0644\u0623\u0645\u0627\u0643\u0646","openroutemobile":"\u0627\u0641\u062A\u062D \u0637\u0631\u064A\u0642 \u062E\u0631\u064A\u0637\u0629 \u062C\u0648\u062C\u0644 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","FoodEstablishment":"\u0623\u064A\u0646 \u062A\u0623\u0643\u0644","LodgingBusiness":"\u0623\u064A\u0646 \u062A\u0646\u0627\u0645","TouristDestination":"\u0645\u0627\u0630\u0627 \u062A\u0631\u0649","TouristAttraction":"\u0645\u0627 \u064A\u062C\u0628 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0647","Product":"\u0645\u0646\u062A\u062C\u0627\u062A \u0645\u062D\u0644\u064A\u0629","Service":"\u062E\u062F\u0645\u0627\u062A","Event":"\u0627\u0644\u0623\u062D\u062F\u0627\u062B","City":"\u0645\u062F\u0646","Wine":"\u0627\u0644\u0646\u0628\u064A\u0630"},"suggestion":{"consult":"\u0627\u0644\u062F\u0641\u0639","thetutorial":"\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A"},"template":{"reset":"\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u062C\u0645\u064A\u0639","showresults":"\u0639\u0631\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C","suggestiontitle":"\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u0627\u0644\u0628\u062D\u062B","reminder":"\u0644\u0627 \u062A\u0646\u0633\u0649 \\n \u0623\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643."}}');


var $f3fd76c7f136d593$exports = {};
$f3fd76c7f136d593$exports = JSON.parse('{"1":"\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629","2":"\u0642\u0646\u0627\u0629 \u0627\u062E\u0628\u0627\u0631\u064A\u0629 \u062D\u064A\u0629","3":"\u062A\u0642\u0631\u064A\u0631 \u062D\u0627\u0644\u0629 \u0623\u0644\u0637\u0642\u0633","4":"\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0637\u0648\u0627\u0631\u0626","1000":"\u062A\u0627\u0631\u064A\u062E\u064A","1001":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","common":{"all":"\u0627\u0644\u062C\u0645\u064A\u0639","back":"\u062E\u0644\u0641","close":"\u0627\u063A\u0644\u0627\u0642","continue":"\u064A\u0643\u0645\u0644","download":"\u062A\u062D\u0645\u064A\u0644","downloadsheet":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","downloadsheetmobile":"\u0642\u0645 \u0628\u062A\u0646\u0632\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","filter":"\u0645\u0646\u0642\u064A","history":"\u062A\u0627\u0631\u064A\u062E\u064A","lang":"\u0627\u0644\u0644\u063A\u0627\u062A","menu":"\u0627\u0644\u0642\u0627\u0626\u0645\u0629","mode":"\u0645\u0648\u0636\u0629","needhelp":"\u062A\u062D\u062A\u0627\u062C \u0645\u0633\u0627\u0639\u062F\u0629\u061F","parameters":"\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A","print":"\u0645\u0637\u0628\u0639\u0629","printsheet":"\u0627\u0637\u0628\u0639 \u0647\u0630\u0647 \u0627\u0644\u0648\u0631\u0642\u0629","result":"\u0646\u062A\u064A\u062C\u0629","results":"\u0646\u062A\u0627\u0626\u062C","singleLang":"\u0644\u063A\u0629","sound":"\u0647\u0627","submit":"\u064A\u064F\u0642\u062F\u0651\u0650\u0645","subtitle":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0631\u0639\u064A","tutorial":"\u062F\u0631\u0633 \u062A\u0639\u0644\u064A\u0645\u064A","validate":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629"},"emergency":{"samu":".S.A.M.U","police":"\u0634\u0631\u0637\u0629","firefighter":"\u0631\u062C\u0627\u0644 \u0627\u0644\u0627\u0637\u0641\u0627\u0621","general":"\u0639\u0627\u0645","citypolice":"\u0627\u0644\u0634\u0631\u0637\u0629 \u0627\u0644\u0645\u062D\u0644\u064A\u0629","hospital":"\u0645\u0633\u062A\u0634\u0641\u0649","homeless":"\u0628\u0644\u0627 \u0645\u0623\u0648\u0649 (\u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u062C\u0627\u0646\u064A\u0629)","poison":"\u0645\u0631\u0643\u0632 \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u0633\u0645\u0648\u0645","emergency":"\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0637\u0648\u0627\u0631\u0626 \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A\u0629"},"error":{"title":"\u062D\u062F\u062B \u062E\u0637\u0623","button":"\u0623\u0639\u062F \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"},"history":{"title":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629"},"inputs":{"choose":"\u0627\u062E\u062A\u0631 \u0625\u062C\u0627\u0628\u0629"},"language":{"change":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0644\u063A\u0629","select":"\u062D\u062F\u062F \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627"},"link":{"buttontext":"\u0639\u0631\u0636 \u0627\u0644\u0648\u062B\u064A\u0642\u0629","goto":"\u0627\u0630\u0647\u0628 \u0625\u0644\u0649 \u0627\u0644\u0639\u0646\u0648\u0627\u0646","click":"\u0627\u0646\u0642\u0631 \u0647\u0646\u0627","scanQR":"\u0639\u0646 \u0637\u0631\u064A\u0642 \u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629","scanQRTile":"\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0644\u0627\u0643\u062A\u0634\u0627\u0641"},"loader":{"loader":{"optimal":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","classic":"\u0644\u062A\u062C\u0631\u0628\u0629 \u0623\u0643\u062B\u0631 \u0643\u0644\u0627\u0633\u064A\u0643\u064A\u0629\u060C","vocal":"\u0623\u0646\u0627 \u0623\u062A\u062D\u062F\u062B \u0648\u062C\u0647\u0627 \u0644\u0648\u062C\u0647 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644.","text":"\u0623\u062A\u0648\u0627\u0635\u0644 \u0643\u062A\u0627\u0628\u064A\u064B\u0627 \u0645\u0639 \u0627\u0644\u0648\u0643\u064A\u0644."},"modes":{"vocal":"\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062A\u064A","text":"\u0648\u0636\u0639 \u0627\u0644\u0646\u0635"},"loaderValidation":"\u0627\u0628\u062F\u0623 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","locale":"\u0641\u062D\u0635 \u0627\u0644\u0644\u063A\u0629","supported":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0644\u063A\u0627\u062A \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629","addressdata":"\u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"},"menu":{"message":"\u0623\u062F\u062E\u0644 \u0631\u0633\u0627\u0644\u062A\u0643","allowMicrophone":"\u0627\u0633\u0645\u062D \u0644\u0645\u062A\u0635\u0641\u062D\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u064A\u0643\u0631\u0648\u0641\u0648\u0646 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629","backconversation":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629","answer":" \u064A\u062C\u064A\u0628 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643"},"mobileLandscapePreventer":{"firstline":"\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062C\u0631\u0628\u0629 \u0645\u062B\u0627\u0644\u064A\u0629\u060C","secondline":"\u0627\u0642\u0644\u0628 \u0634\u0627\u0634\u062A\u0643"},"news":{"warningtext":"\u0633\u062A\u062F\u062E\u0644 \u0625\u0644\u0649 \u0627\u0644\u0642\u0646\u0627\u0629 \u0627\u0644\u0625\u062E\u0628\u0627\u0631\u064A\u0629\u060C \u0648\u0633\u064A\u062A\u0645 \u062A\u0646\u0634\u064A\u0637 \u0627\u0644\u0635\u0648\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643","live":"\u0645\u0628\u0627\u0634\u0631","continuous":"\u0644\u0646\u0643\u0645\u0644"},"poi":{"comment":"\u0631\u0623\u064A \u0627\u0644\u0639\u0645\u064A\u0644","route":"\u0637\u0631\u064A\u0642","nodata":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649 \u064A\u0637\u0627\u0628\u0642 \u0628\u062D\u062B\u0643","openinghours":"\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644","prices":"\u0627\u0644\u0623\u0633\u0639\u0627\u0631","paymentmethods":"\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639","numberofplaces":"\u0639\u062F\u062F \u0627\u0644\u0623\u0645\u0627\u0643\u0646","openroutemobile":"\u0627\u0641\u062A\u062D \u0637\u0631\u064A\u0642 \u062E\u0631\u064A\u0637\u0629 \u062C\u0648\u062C\u0644 \u0639\u0644\u0649 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0630\u0643\u064A","FoodEstablishment":"\u0623\u064A\u0646 \u062A\u0623\u0643\u0644","LodgingBusiness":"\u0623\u064A\u0646 \u062A\u0646\u0627\u0645","TouristDestination":"\u0645\u0627\u0630\u0627 \u062A\u0631\u0649","TouristAttraction":"\u0645\u0627 \u064A\u062C\u0628 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0647","Product":"\u0645\u0646\u062A\u062C\u0627\u062A \u0645\u062D\u0644\u064A\u0629","Service":"\u062E\u062F\u0645\u0627\u062A","Event":"\u0627\u0644\u0623\u062D\u062F\u0627\u062B","City":"\u0645\u062F\u0646","Wine":"\u0627\u0644\u0646\u0628\u064A\u0630"},"suggestion":{"consult":"\u0627\u0644\u062F\u0641\u0639","thetutorial":"\u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A"},"template":{"reset":"\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u062C\u0645\u064A\u0639","showresults":"\u0639\u0631\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C","suggestiontitle":"\u0627\u0642\u062A\u0631\u0627\u062D\u0627\u062A \u0627\u0644\u0628\u062D\u062B","reminder":"\u0644\u0627 \u062A\u0646\u0633\u0649 \\n \u0623\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \u0639\u0644\u0649 \u0623\u0633\u0626\u0644\u062A\u0643."}}');


var $7292e60d28a28350$exports = {};
$7292e60d28a28350$exports = JSON.parse('{"1":"p\xe0gina d\'inici","2":"canal de not\xedcies en directe","3":"informe del temps","4":"N\xfameros d\'emerg\xe8ncia","1000":"hist\xf2ric","1001":"tutorial","common":{"all":"tots","back":"esquena","close":"tanca","continue":"continua","download":"descarregar","downloadsheet":"descarregar aquest full","downloadsheetmobile":"descarregueu aquest full al tel\xe8fon intel\xb7ligent","filter":"filtre","history":"hist\xf2ric","lang":"idiomes","menu":"men\xfa","mode":"moda","needhelp":"necessitar ajuda?","parameters":"configuracions","print":"imprimir","printsheet":"imprimeix aquest full","result":"resultat","results":"resultats","singleLang":"llenguatge","sound":"ella","subtitle":"subt\xedtol","submit":"presentar","tutorial":"tutorial","validate":"validar"},"emergency":{"samu":"S.A.M.U.","police":"policia","firefighter":"bombers","general":"general","citypolice":"Policia local","hospital":"Hospital","homeless":"Sense llar (trucada gratu\xefta)","poison":"Centre de control de ver\xed","emergency":"emerg\xe8ncies europees"},"error":{"title":"S\'ha produ\xeft un error","button":"Reinicieu l\'aplicaci\xf3"},"history":{"title":"historial de converses"},"inputs":{"choose":"Tria una resposta"},"language":{"change":"canviar l\'idioma","select":"seleccioneu l\'idioma que voleu utilitzar"},"link":{"buttontext":"Visualitza el document","goto":"V\xe9s a l\'adre\xe7a","click":"Clica aqu\xed","scanQR":"escanejant el QrCode","scanQRTile":"Escaneja el codi QR per descobrir"},"loader":{"loader":{"optimal":"Per a una experi\xe8ncia \xf2ptima,","classic":"Per a una experi\xe8ncia m\xe9s cl\xe0ssica,","vocal":"Parlo cara a cara amb l\'agent.","text":"Em comunico per escrit amb l\'agent."},"modes":{"vocal":"manera vocal","text":"mode text"},"loaderValidation":"Inicia la conversa","locale":"comprovant el llenguatge","supported":"comprovant els idiomes compatibles","addressdata":"recuperant dades"},"menu":{"message":"Introdu\xefu el vostre missatge","allowMicrophone":"Permeteu que el vostre navegador utilitzi el micr\xf2fon per continuar","backconversation":"tornar a la conversa","answer":" respon les teves preguntes"},"mobileLandscapePreventer":{"firstline":"Per a una experi\xe8ncia \xf2ptima,","secondline":"gira la pantalla"},"news":{"warningtext":"Accedeix al canal de not\xedcies, s\'activar\xe0 el so del teu dispositiu","live":"viu","continuous":"cont\xednuament"},"poi":{"comment":"revisi\xf3 del client","route":"carretera","nodata":"Cap contingut coincideix amb la teva cerca","openinghours":"Horari d\'obertura","prices":"Preus","paymentmethods":"M\xe8todes de Pagament","numberofplaces":"nombre de places","openroutemobile":"obre la ruta de Google Maps al tel\xe8fon intel\xb7ligent","FoodEstablishment":"On menjar","LodgingBusiness":"On dormir","TouristDestination":"Qu\xe8 veure","TouristAttraction":"Qu\xe8 fer","Product":"Productes locals","Service":"Serveis","Event":"Esdeveniments","City":"Ciutats","Wine":"Vins"},"suggestion":{"consult":"Fes una ullada","thetutorial":"el tutorial"},"template":{"reset":"restablir tot","showresults":"Mostra els resultats","suggestiontitle":"Cerca suggeriments","reminder":"No oblidis, \\n puc respondre les teves preguntes."}}');


var $d36ae826bd9e59be$exports = {};
$d36ae826bd9e59be$exports = JSON.parse('{"1":"domovsk\xe1 str\xe1nka","2":"\u017Eiv\xfd zpravodajsk\xfd kan\xe1l","3":"zpr\xe1va o po\u010Das\xed","4":"T\xeds\u0148ov\xe1 \u010D\xedsla","1000":"historick\xfd","1001":"tutorial","common":{"all":"v\u0161echno","back":"zadn\xed","close":"zav\u0159\xedt","continue":"pokra\u010Dovat","download":"sta\u017Een\xed","downloadsheet":"st\xe1hn\u011Bte si tento list","downloadsheetmobile":"st\xe1hn\u011Bte si tento list na smartphone","filter":"filtr","history":"historick\xfd","lang":"jazyky","menu":"j\xeddeln\xed l\xedstek","mode":"m\xf3da","needhelp":"pot\u0159ebovat pomoc?","parameters":"nastaven\xed","print":"tisk","printsheet":"tytiskn\u011Bte tento list","result":"v\xfdsledek","results":"v\xfdsledek","singleLang":"jazyk","sound":"jej\xed","submit":"p\u0159edlo\u017Eit","subtitle":"podtitulek","tutorial":"tutorial","validate":"ov\u011B\u0159it"},"emergency":{"samu":"S.A.M.U.","police":"POLICIE","firefighter":"hasi\u010Di","general":"v\u0161eobecn\xfd","citypolice":"M\xedstn\xed policie","hospital":"Nemocnice","homeless":"Bezdomovci (vol\xe1n\xed zdarma)","poison":"Poison Control Center","emergency":"evropsk\xe9 mimo\u0159\xe1dn\xe9 ud\xe1losti"},"error":{"title":"Do\u0161lo k chyb\u011B","button":"Znovu spus\u0165te aplikaci"},"history":{"title":"historie konverzace"},"inputs":{"choose":"Vyberte odpov\u011B\u010F"},"language":{"change":"zm\u011Bnit jazyk","select":"vyberte jazyk, kter\xfd chcete pou\u017E\xedvat"},"link":{"buttontext":"Zobrazit dokument","goto":"P\u0159ejd\u011Bte na adresu","click":"Klikn\u011Bte zde","scanQR":"skenov\xe1n\xedm QrCode","scanQRTile":"Naskenujte QR k\xf3d a objevte"},"loader":{"loader":{"optimal":"Pro optim\xe1ln\xed z\xe1\u017Eitek,","classic":"Pro klasi\u010Dt\u011Bj\u0161\xed z\xe1\u017Eitek,","vocal":"Mluv\xedm tv\xe1\u0159\xed v tv\xe1\u0159 s agentem.","text":"S jednatelem komunikuji p\xedsemn\u011B."},"modes":{"vocal":"hlasov\xfd re\u017Eim","text":"textov\xfd re\u017Eim"},"loaderValidation":"Zahajte konverzaci","locale":"kontrola jazyka","supported":"kontrola podporovan\xfdch jazyk\u016F","addressdata":"na\u010D\xedt\xe1n\xed dat"},"menu":{"message":"Zadejte svou zpr\xe1vu","allowMicrophone":"Chcete-li pokra\u010Dovat, povolte prohl\xed\u017Ee\u010Di pou\u017E\xedvat v\xe1\u0161 mikrofon","backconversation":"zp\u011Bt k rozhovoru","answer":" odpov\xedd\xe1 na va\u0161e ot\xe1zky"},"mobileLandscapePreventer":{"firstline":"Pro optim\xe1ln\xed z\xe1\u017Eitek,","secondline":"oto\u010Dte obrazovku"},"news":{"warningtext":"Vstoup\xedte do zpravodajsk\xe9ho kan\xe1lu, zvuk na va\u0161em za\u0159\xedzen\xed bude aktivov\xe1n","live":"\u017E\xedt","continuous":"nep\u0159etr\u017Eit\u011B"},"poi":{"comment":"z\xe1kaznick\xe1 recenze","route":"silnice","nodata":"Va\u0161emu vyhled\xe1v\xe1n\xed neodpov\xedd\xe1 \u017E\xe1dn\xfd obsah","openinghours":"Otev\xedrac\xed doba","prices":"Ceny","paymentmethods":"Platebn\xed metody","numberofplaces":"po\u010Det m\xedst","openroutemobile":"otev\u0159ete trasu Google Maps na smartphonu","FoodEstablishment":"Kde j\xedst","LodgingBusiness":"Kde sp\xe1t","TouristDestination":"Co vid\u011Bt","TouristAttraction":"Co d\u011Blat","Product":"M\xedstn\xed produkty","Service":"Slu\u017Eby","Event":"Ud\xe1losti","City":"M\u011Bsta","Wine":"V\xedna"},"suggestion":{"consult":"P\u0159ekontrolovat","thetutorial":"tutori\xe1l"},"template":{"reset":"resetovat v\u0161e","showresults":"Uka\u017E v\xfdsledky","suggestiontitle":"N\xe1vrhy vyhled\xe1v\xe1n\xed","reminder":"Nezapome\u0148te, \\n mohu odpov\u011Bd\u011Bt na va\u0161e ot\xe1zky."}}');


var $614e828340e39df0$exports = {};
$614e828340e39df0$exports = JSON.parse('{"1":"hjemmeside","2":"live nyhedskanal","3":"vejrudsigt","4":"N\xf8dnumre","1000":"historisk","1001":"tutorial","common":{"all":"alle","back":"tilbage","close":"t\xe6t","continue":"Blive ved","download":"Hent","downloadsheet":"download dette ark","downloadsheetmobile":"download dette ark p\xe5 smartphone","filter":"Filter","history":"historisk","lang":"SPROG","menu":"menu","mode":"mode","needhelp":"Brug for hj\xe6lp?","parameters":"indstillinger","print":"Print","printsheet":"Udskriv dette ark","result":"resultat","results":"resultater","singleLang":"Sprog","sound":"hende","submit":"indsend","subtitle":"undertekst","tutorial":"tutorial","validate":"validere"},"emergency":{"samu":"S.A.M.U.","police":"politi","firefighter":"brandm\xe6nd","general":"generel","citypolice":"Lokalt politi","hospital":"Hospital","homeless":"Hjeml\xf8s (gratis opkald)","poison":"Giftkontrolcenter","emergency":"europ\xe6iske n\xf8dsituationer"},"error":{"title":"Der opstod en fejl","button":"Genstart applikationen"},"history":{"title":"samtale historie"},"inputs":{"choose":"V\xe6lg et svar"},"language":{"change":"\xe6ndre sproget","select":"v\xe6lg det sprog, du vil bruge"},"link":{"buttontext":"Se dokumentet","goto":"G\xe5 til adressen","click":"Klik her","scanQR":"ved at scanne QRCoden","scanQRTile":"Scan QR-koden for at opdage"},"loader":{"loader":{"optimal":"For en optimal oplevelse,","classic":"For en mere klassisk oplevelse,","vocal":"Jeg taler ansigt til ansigt med agenten.","text":"Jeg kommunikerer skriftligt med agenten."},"modes":{"vocal":"vokal tilstand","text":"teksttilstand"},"loaderValidation":"Start samtale","locale":"kontrol af sprog","supported":"kontrol af underst\xf8ttede sprog","addressdata":"hente data"},"menu":{"message":"Indtast din besked","allowMicrophone":"Tillad din browser at bruge din mikrofon for at forts\xe6tte","backconversation":"tilbage til samtalen","answer":" svarer p\xe5 dine sp\xf8rgsm\xe5l"},"mobileLandscapePreventer":{"firstline":"For en optimal oplevelse,","secondline":"vend din sk\xe6rm"},"news":{"warningtext":"Du f\xe5r adgang til nyhedskanalen, lyden p\xe5 din enhed aktiveres","live":"Direkte","continuous":"l\xf8bende"},"poi":{"comment":"kundeanmeldelse","route":"vej","nodata":"Intet indhold matcher din s\xf8gning","openinghours":"\xc5bningstider","prices":"Priser","paymentmethods":"Betalingsmetoder","numberofplaces":"antal pladser","openroutemobile":"\xe5ben Google Map-rute p\xe5 smartphone","FoodEstablishment":"Hvor skal man spise","LodgingBusiness":"Hvor skal man sove","TouristDestination":"Hvad at se","TouristAttraction":"Hvad skal man g\xf8re","Product":"Lokale produkter","Service":"Tjenester","Event":"Begivenheder","City":"Byer","Wine":"Vine"},"suggestion":{"consult":"Tjek ud","thetutorial":"tutorialen"},"template":{"reset":"genstart alt","showresults":"Vis resultaterne","suggestiontitle":"S\xf8geforslag","reminder":"Glem ikke, \\n jeg kan svare p\xe5 dine sp\xf8rgsm\xe5l."}}');


var $f016f7f606473c04$exports = {};
$f016f7f606473c04$exports = JSON.parse('{"1":"Startseite","2":"Live-Infokanal","3":"Wetter","4":"Notrufnummern","1000":"Geschichte","1001":"anleitung","common":{"all":"alle","back":"zur\xfcck","close":"schlie\xdfen","continue":"Weiter","download":"herunterladen","downloadsheet":"Dieses Blatt herunterladen","downloadsheetmobile":"Laden Sie dieses Blatt auf Ihr Smartphone herunter","filter":"filter","history":"Verlauf","lang":"Sprachen","menu":"Men\xfc","mode":"Modus","needhelp":"Brauche Hilfe ?","parameters":"Parameter","print":"Ausdrucken","printsheet":"Blat ausdrucken","result":"Ergebnis","results":"Ergebnisse","singleLang":"Sprache","sound":"Ton","subtitle":"Untertitel","submit":"einreichen","tutorial":"Lernprogramm","validate":"validieren"},"emergency":{"samu":"samu","police":"polizei","firefighter":"feuerwehrleute","general":"allgemein","citypolice":"Lokale Polizeibeh\xf6rde","hospital":"Krankenhaus","homeless":"Obdachlos (kostenloser Anruf)","poison":"Giftkontrollzentrum","emergency":"Europ\xe4ische Notf\xe4lle"},"error":{"title":"Es ist ein Fehler aufgetreten","button":"Starten Sie die Anwendung erneut"},"history":{"title":"Chat-Verlauf"},"inputs":{"choose":"W\xe4hlen Sie eine Antwort"},"language":{"change":"die Sprache \xe4ndern","select":"W\xe4hlen Sie die gew\xfcnschte Sprache"},"link":{"buttontext":"Sehen Sie sich das Dokument an","goto":"Zur Adresse gehen","click":"klicken Sie hier","scanQR":"durch Scannen des QrCodes","scanQRTile":"Scannen Sie den QR-Code, um zu entdecken"},"loader":{"loader":{"optimal":"F\xfcr ein optimales Erlebnis,","classic":"F\xfcr ein eher klassisches Erlebnis,","vocal":"Ich kommuniziere durch Sprechen mit dem Agenten.","text":"Ich kommuniziere per Text mit dem Agenten."},"modes":{"vocal":"Vokal-Modus","text":"Textmodus"},"loaderValidation":"Gespr\xe4ch beginnen","locale":"Gebietsschema pr\xfcfen","supported":"Pr\xfcfung der unterst\xfctzten Gebietsschemata","store":"Speicher erstellen","directline":"Direktleitung verbinden","ponyfill":"ponyfilling","addressdata":"Abrufen von Daten"},"menu":{"message":"Geben Sie Ihre Nachricht ein","allowMicrophone":"Geben Sie Ihrem Browser die Erlaubnis, das Mikrofon zu benutzen, um fortzufahren","backconversation":"zur\xfcck zum Gespr\xe4ch","answer":" beantwortet Ihre Fragen"},"mobileLandscapePreventer":{"firstline":"F\xfcr ein optimales Erlebnis,","secondline":"drehen Sie Ihren Bildschirm um"},"news":{"warningtext":"Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Ger\xe4ts wird aktiviert","live":"live","continuous":"fortlaufend"},"poi":{"comment":"Kundenbewertung","route":"Route","nodata":"Kein Inhalt entspricht Ihrer Suche","openinghours":"\xd6ffnungszeiten","prices":"Preise","paymentmethods":"Zahlungsarten","numberofplaces":"Anzahl der Pl\xe4tze","openroutemobile":"\xd6ffnen Sie die Google Map-Route auf dem Smartphone","FoodEstablishment":"Wo sollen wir essen","LodgingBusiness":"Wo schlafen","TouristDestination":"Was zu sehen","TouristAttraction":"Was zu tun","Product":"Lokale Produkte","Service":"Dienstleistungen","Event":"Veranstaltungen","City":"St\xe4dte","Wine":"Weine"},"suggestion":{"consult":"Schauen Sie sich","thetutorial":"das Tutorial an"},"template":{"reset":"Filter zur\xfccksetzen","showresults":"Ergebnisse anzeigen","suggestiontitle":"Forschungsvorschl\xe4ge","reminder":"Vergessen Sie nicht :\\n Ich kann Ihre Fragen beantworten."}}');


var $1ab285038621486d$exports = {};
$1ab285038621486d$exports = JSON.parse('{"1":"Startseite","2":"Live-Infokanal","3":"Wetter","4":"Notrufnummern","1000":"Geschichte","1001":"anleitung","common":{"all":"alle","back":"zur\xfcck","close":"schlie\xdfen","continue":"Weiter","download":"herunterladen","downloadsheet":"Dieses Blatt herunterladen","downloadsheetmobile":"Laden Sie dieses Blatt auf Ihr Smartphone herunter","filter":"filter","history":"Verlauf","lang":"Sprachen","menu":"Men\xfc","mode":"Modus","needhelp":"Brauche Hilfe ?","parameters":"Parameter","print":"Ausdrucken","printsheet":"Blat ausdrucken","result":"Ergebnis","results":"Ergebnisse","singleLang":"Sprache","sound":"Ton","subtitle":"Untertitel","submit":"einreichen","tutorial":"Lernprogramm","validate":"validieren"},"emergency":{"samu":"samu","police":"polizei","firefighter":"feuerwehrleute","general":"allgemein","citypolice":"Lokale Polizeibeh\xf6rde","hospital":"Krankenhaus","homeless":"Obdachlos (kostenloser Anruf)","poison":"Giftkontrollzentrum","emergency":"Europ\xe4ische Notf\xe4lle"},"error":{"title":"Es ist ein Fehler aufgetreten","button":"Starten Sie die Anwendung erneut"},"history":{"title":"Chat-Verlauf"},"inputs":{"choose":"W\xe4hlen Sie eine Antwort"},"language":{"change":"die Sprache \xe4ndern","select":"W\xe4hlen Sie die gew\xfcnschte Sprache"},"link":{"buttontext":"Sehen Sie sich das Dokument an","goto":"Zur Adresse gehen","click":"klicken Sie hier","scanQR":"durch Scannen des QrCodes","scanQRTile":"Scannen Sie den QR-Code, um zu entdecken"},"loader":{"loader":{"optimal":"F\xfcr ein optimales Erlebnis,","classic":"F\xfcr ein eher klassisches Erlebnis,","vocal":"Ich kommuniziere durch Sprechen mit dem Agenten.","text":"Ich kommuniziere per Text mit dem Agenten."},"modes":{"vocal":"Vokal-Modus","text":"Textmodus"},"loaderValidation":"Gespr\xe4ch beginnen","locale":"Gebietsschema pr\xfcfen","supported":"Pr\xfcfung der unterst\xfctzten Gebietsschemata","store":"Speicher erstellen","directline":"Direktleitung verbinden","ponyfill":"ponyfilling","addressdata":"Abrufen von Daten"},"menu":{"message":"Geben Sie Ihre Nachricht ein","allowMicrophone":"Geben Sie Ihrem Browser die Erlaubnis, das Mikrofon zu benutzen, um fortzufahren","backconversation":"zur\xfcck zum Gespr\xe4ch","answer":" beantwortet Ihre Fragen"},"mobileLandscapePreventer":{"firstline":"F\xfcr ein optimales Erlebnis,","secondline":"drehen Sie Ihren Bildschirm um"},"news":{"warningtext":"Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Ger\xe4ts wird aktiviert","live":"live","continuous":"fortlaufend"},"poi":{"comment":"Kundenbewertung","route":"Route","nodata":"Kein Inhalt entspricht Ihrer Suche","openinghours":"\xd6ffnungszeiten","prices":"Preise","paymentmethods":"Zahlungsarten","numberofplaces":"Anzahl der Pl\xe4tze","openroutemobile":"\xd6ffnen Sie die Google Map-Route auf dem Smartphone","FoodEstablishment":"Wo sollen wir essen","LodgingBusiness":"Wo schlafen","TouristDestination":"Was zu sehen","TouristAttraction":"Was zu tun","Product":"Lokale Produkte","Service":"Dienstleistungen","Event":"Veranstaltungen","City":"St\xe4dte","Wine":"Weine"},"suggestion":{"consult":"Schauen Sie sich","thetutorial":"das Tutorial an"},"template":{"reset":"Filter zur\xfccksetzen","showresults":"Ergebnisse anzeigen","suggestiontitle":"Forschungsvorschl\xe4ge","reminder":"Vergessen Sie nicht :\\n Ich kann Ihre Fragen beantworten."}}');


var $03dad743eb12a740$exports = {};
$03dad743eb12a740$exports = JSON.parse('{"1":"Startseite","2":"Live-Infokanal","3":"Wetter","4":"Notrufnummern","1000":"Geschichte","1001":"anleitung","common":{"all":"alle","back":"zur\xfcck","close":"schlie\xdfen","continue":"Weiter","download":"herunterladen","downloadsheet":"Dieses Blatt herunterladen","downloadsheetmobile":"Laden Sie dieses Blatt auf Ihr Smartphone herunter","filter":"filter","history":"Verlauf","lang":"Sprachen","menu":"Men\xfc","mode":"Modus","needhelp":"Brauche Hilfe ?","parameters":"Parameter","print":"Ausdrucken","printsheet":"Blat ausdrucken","result":"Ergebnis","results":"Ergebnisse","singleLang":"Sprache","sound":"Ton","subtitle":"Untertitel","submit":"einreichen","tutorial":"Lernprogramm","validate":"validieren"},"emergency":{"samu":"samu","police":"polizei","firefighter":"feuerwehrleute","general":"allgemein","citypolice":"Lokale Polizeibeh\xf6rde","hospital":"Krankenhaus","homeless":"Obdachlos (kostenloser Anruf)","poison":"Giftkontrollzentrum","emergency":"Europ\xe4ische Notf\xe4lle"},"error":{"title":"Es ist ein Fehler aufgetreten","button":"Starten Sie die Anwendung erneut"},"history":{"title":"Chat-Verlauf"},"inputs":{"choose":"W\xe4hlen Sie eine Antwort"},"language":{"change":"die Sprache \xe4ndern","select":"W\xe4hlen Sie die gew\xfcnschte Sprache"},"link":{"buttontext":"Sehen Sie sich das Dokument an","goto":"Zur Adresse gehen","click":"klicken Sie hier","scanQR":"durch Scannen des QrCodes","scanQRTile":"Scannen Sie den QR-Code, um zu entdecken"},"loader":{"loader":{"optimal":"F\xfcr ein optimales Erlebnis,","classic":"F\xfcr ein eher klassisches Erlebnis,","vocal":"Ich kommuniziere durch Sprechen mit dem Agenten.","text":"Ich kommuniziere per Text mit dem Agenten."},"modes":{"vocal":"Vokal-Modus","text":"Textmodus"},"loaderValidation":"Gespr\xe4ch beginnen","locale":"Gebietsschema pr\xfcfen","supported":"Pr\xfcfung der unterst\xfctzten Gebietsschemata","store":"Speicher erstellen","directline":"Direktleitung verbinden","ponyfill":"ponyfilling","addressdata":"Abrufen von Daten"},"menu":{"message":"Geben Sie Ihre Nachricht ein","allowMicrophone":"Geben Sie Ihrem Browser die Erlaubnis, das Mikrofon zu benutzen, um fortzufahren","backconversation":"zur\xfcck zum Gespr\xe4ch","answer":" beantwortet Ihre Fragen"},"mobileLandscapePreventer":{"firstline":"F\xfcr ein optimales Erlebnis,","secondline":"drehen Sie Ihren Bildschirm um"},"news":{"warningtext":"Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Ger\xe4ts wird aktiviert","live":"live","continuous":"fortlaufend"},"poi":{"comment":"Kundenbewertung","route":"Route","nodata":"Kein Inhalt entspricht Ihrer Suche","openinghours":"\xd6ffnungszeiten","prices":"Preise","paymentmethods":"Zahlungsarten","numberofplaces":"Anzahl der Pl\xe4tze","openroutemobile":"\xd6ffnen Sie die Google Map-Route auf dem Smartphone","FoodEstablishment":"Wo sollen wir essen","LodgingBusiness":"Wo schlafen","TouristDestination":"Was zu sehen","TouristAttraction":"Was zu tun","Product":"Lokale Produkte","Service":"Dienstleistungen","Event":"Veranstaltungen","City":"St\xe4dte","Wine":"Weine"},"suggestion":{"consult":"Schauen Sie sich","thetutorial":"das Tutorial an"},"template":{"reset":"Filter zur\xfccksetzen","showresults":"Ergebnisse anzeigen","suggestiontitle":"Forschungsvorschl\xe4ge","reminder":"Vergessen Sie nicht :\\n Ich kann Ihre Fragen beantworten."}}');


var $c9358d0b39b3a4e6$exports = {};
$c9358d0b39b3a4e6$exports = JSON.parse('{"1":"home","2":"live info channel","3":"weather","4":"emergency numbers","1000":"history","1001":"tutorial","common":{"abort":"abort","all":"all","back":"back","close":"close","continue":"continue","download":"download","downloadsheet":"download this sheet","downloadsheetmobile":"download this sheet on smartphone","filter":"filter","history":"history","lang":"languages","menu":"menu","mode":"mode","needhelp":"Need help ?","parameters":"parameters","print":"print","printsheet":"print this sheet","result":"result","results":"results","singleLang":"language","sound":"sound","submit":"submit","subtitle":"subtitle","tutorial":"tutorial","validate":"validate"},"emergency":{"samu":"maeu","police":"police","firefighter":"firefighters","general":"general","citypolice":"Local police","hospital":"Hospital","homeless":"Homeless (free call)","poison":"Poison Control Center","emergency":"European emergencies"},"error":{"title":"An error occurred","button":"Launch the application again"},"history":{"title":"chat history"},"inputs":{"choose":"Choose an answer"},"language":{"change":"change the language","select":"select the language you want to use"},"link":{"buttontext":"View the document","goto":"Go to address","click":"Click here","scanQR":"by scanning the QrCode","scanQRTile":"Scan the QR Code to discover"},"loader":{"loader":{"optimal":"For an optimal experience,","classic":"For a more classical experience,","vocal":"I communicate by speaking with the agent.","text":"I communicate by text with the agent."},"modes":{"vocal":"vocal mode","text":"text mode"},"loaderValidation":"Start conversation","locale":"checking language","supported":"checking supported languages","addressdata":"retrieving data","store":"store","directline":"directline","ponyfill":"ponyfill"},"menu":{"message":"Enter your message","allowMicrophone":"Give your browser permission to use microphone to continue","backconversation":"back to the conversation","answer":" answers your questions"},"mobileLandscapePreventer":{"firstline":"For an optimal experience,","secondline":"flip your screen"},"news":{"warningtext":"You are about to access the information channel, the sound of your device will be activated","live":"live","continuous":"continuous"},"poi":{"comment":"customer review","route":"route","nodata":"No content corresponds to your search","openinghours":"Opening hours","prices":"Prices","paymentmethods":"Payment methods","numberofplaces":"number of places","openroutemobile":"open Google Maps route on smartphone","FoodEstablishment":"Where to eat","LodgingBusiness":"Where to sleep","TouristDestination":"What to see","TouristAttraction":"What to do","Product":"Local products","Service":"Services","Event":"Events","City":"Cities","Wine":"Wines"},"suggestion":{"consult":"Check out","thetutorial":"the tutorial"},"template":{"reset":"reset filters","showresults":"Show results","suggestiontitle":"Research suggestions","reminder":"Don\'t forget,\\n I can answer your questions."},"GDPR":{"title":"processing personal data transmitted to the bot","message":"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.","link":"open confidency policy","buttonAccept":"I understand and I accept","buttonRefuse":"I refuse","messageAccepted":"your acceptation has been saved","messageRefused":"your refusal has been saved"}}');


var $99a1008962dadb2f$exports = {};
$99a1008962dadb2f$exports = JSON.parse('{"1":"home","2":"live info channel","3":"weather","4":"emergency numbers","1000":"history","1001":"tutorial","common":{"abort":"abort","all":"all","back":"back","close":"close","continue":"continue","download":"download","downloadsheet":"download this sheet","downloadsheetmobile":"download this sheet on smartphone","filter":"filter","history":"history","lang":"languages","menu":"menu","mode":"mode","needhelp":"Need help ?","parameters":"parameters","print":"print","printsheet":"print this sheet","result":"result","results":"results","singleLang":"language","sound":"sound","submit":"submit","subtitle":"subtitle","tutorial":"tutorial","validate":"validate"},"emergency":{"samu":"maeu","police":"police","firefighter":"firefighters","general":"general","citypolice":"Local police","hospital":"Hospital","homeless":"Homeless (free call)","poison":"Poison Control Center","emergency":"European emergencies"},"error":{"title":"An error occurred","button":"Launch the application again"},"history":{"title":"chat history"},"inputs":{"choose":"Choose an answer"},"language":{"change":"change the language","select":"select the language you want to use"},"link":{"buttontext":"View the document","goto":"Go to address","click":"Click here","scanQR":"by scanning the QrCode","scanQRTile":"Scan the QR Code to discover"},"loader":{"loader":{"optimal":"For an optimal experience,","classic":"For a more classical experience,","vocal":"I communicate by speaking with the agent.","text":"I communicate by text with the agent."},"modes":{"vocal":"vocal mode","text":"text mode"},"loaderValidation":"Start conversation","locale":"checking language","supported":"checking supported languages","addressdata":"retrieving data","store":"store","directline":"directline","ponyfill":"ponyfill"},"menu":{"message":"Enter your message","allowMicrophone":"Give your browser permission to use microphone to continue","backconversation":"back to the conversation","answer":" answers your questions"},"mobileLandscapePreventer":{"firstline":"For an optimal experience,","secondline":"flip your screen"},"news":{"warningtext":"You are about to access the information channel, the sound of your device will be activated","live":"live","continuous":"continuous"},"poi":{"comment":"customer review","route":"route","nodata":"No content corresponds to your search","openinghours":"Opening hours","prices":"Prices","paymentmethods":"Payment methods","numberofplaces":"number of places","openroutemobile":"open Google Maps route on smartphone","FoodEstablishment":"Where to eat","LodgingBusiness":"Where to sleep","TouristDestination":"What to see","TouristAttraction":"What to do","Product":"Local products","Service":"Services","Event":"Events","City":"Cities","Wine":"Wines"},"suggestion":{"consult":"Check out","thetutorial":"the tutorial"},"template":{"reset":"reset filters","showresults":"Show results","suggestiontitle":"Research suggestions","reminder":"Don\'t forget,\\n I can answer your questions."},"GDPR":{"title":"processing personal data transmitted to the bot","message":"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.","link":"open confidency policy","buttonAccept":"I understand and I accept","buttonRefuse":"I refuse","messageAccepted":"your acceptation has been saved","messageRefused":"your refusal has been saved"}}');


var $fcd3f355214c65a9$exports = {};
$fcd3f355214c65a9$exports = JSON.parse('{"1":"home","2":"live info channel","3":"weather","4":"emergency numbers","1000":"history","1001":"tutorial","common":{"abort":"abort","all":"all","back":"back","close":"close","continue":"continue","download":"download","downloadsheet":"download this sheet","downloadsheetmobile":"download this sheet on smartphone","filter":"filter","history":"history","lang":"languages","menu":"menu","mode":"mode","needhelp":"Need help ?","parameters":"parameters","print":"print","printsheet":"print this sheet","result":"result","results":"results","singleLang":"language","sound":"sound","submit":"submit","subtitle":"subtitle","tutorial":"tutorial","validate":"validate"},"emergency":{"samu":"maeu","police":"police","firefighter":"firefighters","general":"general","citypolice":"Local police","hospital":"Hospital","homeless":"Homeless (free call)","poison":"Poison Control Center","emergency":"European emergencies"},"error":{"title":"An error occurred","button":"Launch the application again"},"history":{"title":"chat history"},"inputs":{"choose":"Choose an answer"},"language":{"change":"change the language","select":"select the language you want to use"},"link":{"buttontext":"View the document","goto":"Go to address","click":"Click here","scanQR":"by scanning the QrCode","scanQRTile":"Scan the QR Code to discover"},"loader":{"loader":{"optimal":"For an optimal experience,","classic":"For a more classical experience,","vocal":"I communicate by speaking with the agent.","text":"I communicate by text with the agent."},"modes":{"vocal":"vocal mode","text":"text mode"},"loaderValidation":"Start conversation","locale":"checking language","supported":"checking supported languages","addressdata":"retrieving data","store":"store","directline":"directline","ponyfill":"ponyfill"},"menu":{"message":"Enter your message","allowMicrophone":"Give your browser permission to use microphone to continue","backconversation":"back to the conversation","answer":" answers your questions"},"mobileLandscapePreventer":{"firstline":"For an optimal experience,","secondline":"flip your screen"},"news":{"warningtext":"You are about to access the information channel, the sound of your device will be activated","live":"live","continuous":"continuous"},"poi":{"comment":"customer review","route":"route","nodata":"No content corresponds to your search","openinghours":"Opening hours","prices":"Prices","paymentmethods":"Payment methods","numberofplaces":"number of places","openroutemobile":"open Google Maps route on smartphone","FoodEstablishment":"Where to eat","LodgingBusiness":"Where to sleep","TouristDestination":"What to see","TouristAttraction":"What to do","Product":"Local products","Service":"Services","Event":"Events","City":"Cities","Wine":"Wines"},"suggestion":{"consult":"Check out","thetutorial":"the tutorial"},"template":{"reset":"reset filters","showresults":"Show results","suggestiontitle":"Research suggestions","reminder":"Don\'t forget,\\n I can answer your questions."},"GDPR":{"title":"processing personal data transmitted to the bot","message":"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.","link":"open confidency policy","buttonAccept":"I understand and I accept","buttonRefuse":"I refuse","messageAccepted":"your acceptation has been saved","messageRefused":"your refusal has been saved"}}');


var $8a63153b37715e9f$exports = {};
$8a63153b37715e9f$exports = JSON.parse('{"1":"home","2":"live info channel","3":"weather","4":"emergency numbers","1000":"history","1001":"tutorial","common":{"abort":"abort","all":"all","back":"back","close":"close","continue":"continue","download":"download","downloadsheet":"download this sheet","downloadsheetmobile":"download this sheet on smartphone","filter":"filter","history":"history","lang":"languages","menu":"menu","mode":"mode","needhelp":"Need help ?","parameters":"parameters","print":"print","printsheet":"print this sheet","result":"result","results":"results","singleLang":"language","sound":"sound","submit":"submit","subtitle":"subtitle","tutorial":"tutorial","validate":"validate"},"emergency":{"samu":"maeu","police":"police","firefighter":"firefighters","general":"general","citypolice":"Local police","hospital":"Hospital","homeless":"Homeless (free call)","poison":"Poison Control Center","emergency":"European emergencies"},"error":{"title":"An error occurred","button":"Launch the application again"},"history":{"title":"chat history"},"inputs":{"choose":"Choose an answer"},"language":{"change":"change the language","select":"select the language you want to use"},"link":{"buttontext":"View the document","goto":"Go to address","click":"Click here","scanQR":"by scanning the QrCode","scanQRTile":"Scan the QR Code to discover"},"loader":{"loader":{"optimal":"For an optimal experience,","classic":"For a more classical experience,","vocal":"I communicate by speaking with the agent.","text":"I communicate by text with the agent."},"modes":{"vocal":"vocal mode","text":"text mode"},"loaderValidation":"Start conversation","locale":"checking language","supported":"checking supported languages","addressdata":"retrieving data","store":"store","directline":"directline","ponyfill":"ponyfill"},"menu":{"message":"Enter your message","allowMicrophone":"Give your browser permission to use microphone to continue","backconversation":"back to the conversation","answer":" answers your questions"},"mobileLandscapePreventer":{"firstline":"For an optimal experience,","secondline":"flip your screen"},"news":{"warningtext":"You are about to access the information channel, the sound of your device will be activated","live":"live","continuous":"continuous"},"poi":{"comment":"customer review","route":"route","nodata":"No content corresponds to your search","openinghours":"Opening hours","prices":"Prices","paymentmethods":"Payment methods","numberofplaces":"number of places","openroutemobile":"open Google Maps route on smartphone","FoodEstablishment":"Where to eat","LodgingBusiness":"Where to sleep","TouristDestination":"What to see","TouristAttraction":"What to do","Product":"Local products","Service":"Services","Event":"Events","City":"Cities","Wine":"Wines"},"suggestion":{"consult":"Check out","thetutorial":"the tutorial"},"template":{"reset":"reset filters","showresults":"Show results","suggestiontitle":"Research suggestions","reminder":"Don\'t forget,\\n I can answer your questions."},"GDPR":{"title":"processing personal data transmitted to the bot","message":"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.","link":"open confidency policy","buttonAccept":"I understand and I accept","buttonRefuse":"I refuse","messageAccepted":"your acceptation has been saved","messageRefused":"your refusal has been saved"}}');


var $6c55475abaaf7953$exports = {};
$6c55475abaaf7953$exports = JSON.parse('{"1":"home","2":"live info channel","3":"weather","4":"emergency numbers","1000":"history","1001":"tutorial","common":{"abort":"abort","all":"all","back":"back","close":"close","continue":"continue","download":"download","downloadsheet":"download this sheet","downloadsheetmobile":"download this sheet on smartphone","filter":"filter","history":"history","lang":"languages","menu":"menu","mode":"mode","needhelp":"Need help ?","parameters":"parameters","print":"print","printsheet":"print this sheet","result":"result","results":"results","singleLang":"language","sound":"sound","submit":"submit","subtitle":"subtitle","tutorial":"tutorial","validate":"validate"},"emergency":{"samu":"maeu","police":"police","firefighter":"firefighters","general":"general","citypolice":"Local police","hospital":"Hospital","homeless":"Homeless (free call)","poison":"Poison Control Center","emergency":"European emergencies"},"error":{"title":"An error occurred","button":"Launch the application again"},"history":{"title":"chat history"},"inputs":{"choose":"Choose an answer"},"language":{"change":"change the language","select":"select the language you want to use"},"link":{"buttontext":"View the document","goto":"Go to address","click":"Click here","scanQR":"by scanning the QrCode","scanQRTile":"Scan the QR Code to discover"},"loader":{"loader":{"optimal":"For an optimal experience,","classic":"For a more classical experience,","vocal":"I communicate by speaking with the agent.","text":"I communicate by text with the agent."},"modes":{"vocal":"vocal mode","text":"text mode"},"loaderValidation":"Start conversation","locale":"checking language","supported":"checking supported languages","addressdata":"retrieving data","store":"store","directline":"directline","ponyfill":"ponyfill"},"menu":{"message":"Enter your message","allowMicrophone":"Give your browser permission to use microphone to continue","backconversation":"back to the conversation","answer":" answers your questions"},"mobileLandscapePreventer":{"firstline":"For an optimal experience,","secondline":"flip your screen"},"news":{"warningtext":"You are about to access the information channel, the sound of your device will be activated","live":"live","continuous":"continuous"},"poi":{"comment":"customer review","route":"route","nodata":"No content corresponds to your search","openinghours":"Opening hours","prices":"Prices","paymentmethods":"Payment methods","numberofplaces":"number of places","openroutemobile":"open Google Maps route on smartphone","FoodEstablishment":"Where to eat","LodgingBusiness":"Where to sleep","TouristDestination":"What to see","TouristAttraction":"What to do","Product":"Local products","Service":"Services","Event":"Events","City":"Cities","Wine":"Wines"},"suggestion":{"consult":"Check out","thetutorial":"the tutorial"},"template":{"reset":"reset filters","showresults":"Show results","suggestiontitle":"Research suggestions","reminder":"Don\'t forget,\\n I can answer your questions."},"GDPR":{"title":"processing personal data transmitted to the bot","message":"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.","link":"open confidency policy","buttonAccept":"I understand and I accept","buttonRefuse":"I refuse","messageAccepted":"your acceptation has been saved","messageRefused":"your refusal has been saved"}}');


var $146a27d0d7348c8f$exports = {};
$146a27d0d7348c8f$exports = JSON.parse('{"1":"home","2":"live info channel","3":"weather","4":"emergency numbers","1000":"history","1001":"tutorial","common":{"abort":"abort","all":"all","back":"back","close":"close","continue":"continue","download":"download","downloadsheet":"download this sheet","downloadsheetmobile":"download this sheet on smartphone","filter":"filter","history":"history","lang":"languages","menu":"menu","mode":"mode","needhelp":"Need help ?","parameters":"parameters","print":"print","printsheet":"print this sheet","result":"result","results":"results","singleLang":"language","sound":"sound","submit":"submit","subtitle":"subtitle","tutorial":"tutorial","validate":"validate"},"emergency":{"samu":"maeu","police":"police","firefighter":"firefighters","general":"general","citypolice":"Local police","hospital":"Hospital","homeless":"Homeless (free call)","poison":"Poison Control Center","emergency":"European emergencies"},"error":{"title":"An error occurred","button":"Launch the application again"},"history":{"title":"chat history"},"inputs":{"choose":"Choose an answer","noaction":"Awaiting action"},"language":{"change":"change the language","select":"select the language you want to use"},"link":{"buttontext":"View the document","goto":"Go to address","click":"Click here","scanQR":"by scanning the QrCode","scanQRTile":"Scan the QR Code to discover"},"loader":{"loader":{"optimal":"For an optimal experience,","classic":"For a more classical experience,","vocal":"I communicate by speaking with the agent.","text":"I communicate by text with the agent."},"modes":{"vocal":"vocal mode","text":"text mode"},"loaderValidation":"Start conversation","locale":"checking language","supported":"checking supported languages","addressdata":"retrieving data","store":"store","directline":"directline","ponyfill":"ponyfill"},"menu":{"message":"Enter your message","allowMicrophone":"Give your browser permission to use microphone to continue","backconversation":"back to the conversation","answer":" answers your questions"},"mobileLandscapePreventer":{"firstline":"For an optimal experience,","secondline":"flip your screen"},"news":{"warningtext":"You are about to access the information channel, the sound of your device will be activated","live":"live","continuous":"continuous"},"poi":{"comment":"customer review","route":"route","nodata":"No content corresponds to your search","openinghours":"Opening hours","prices":"Prices","paymentmethods":"Payment methods","numberofplaces":"number of places","openroutemobile":"open Google Maps route on smartphone","FoodEstablishment":"Where to eat","LodgingBusiness":"Where to sleep","TouristDestination":"What to see","TouristAttraction":"What to do","Product":"Local products","Service":"Services","Event":"Events","City":"Cities","Wine":"Wines"},"suggestion":{"consult":"Check out","thetutorial":"the tutorial"},"template":{"reset":"reset filters","showresults":"Show results","suggestiontitle":"Research suggestions","reminder":"Don\'t forget,\\n I can answer your questions."},"GDPR":{"title":"processing personal data transmitted to the bot","message":"by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.\\n\\nYour conversations are kept 6 month before deletion.","link":"open confidency policy","buttonAccept":"I understand and I accept","buttonRefuse":"I refuse","messageAccepted":"your acceptation has been saved","messageRefused":"your refusal has been saved"}}');


var $deebe3fffa664b94$exports = {};
$deebe3fffa664b94$exports = JSON.parse('{"1":"inicio","2":"canal de informaci\xf3n en directo","3":"tiempo","4":"n\xfameros de emergencia","1000":"historia","1001":"tutorial","common":{"all":"todos","back":"volver","close":"cerrar","continue":"continuar","download":"descargar","downloadsheet":"descargar esta hoja","downloadsheetmobile":"descargar esta hoja en el tel\xe9fono inteligente","filter":"filtrar","history":"historia","lang":"idiomas","menu":"men\xfa","mode":"modo","needhelp":"necesitar ayuda ?","parameters":"par\xe1metros","print":"imprime","printsheet":"imprime esta hoja","result":"resultado","results":"resultados","singleLang":"idioma","sound":"sonido","submit":"enviar","subtitle":"subt\xedtulos","tutorial":"tutorial","validate":"valide"},"emergency":{"samu":"samu","police":"polic\xeda","firefighter":"bomberos","general":"general","citypolice":"Polic\xeda Local","hospital":"Hospital","homeless":"Personas sin hogar (llamada gratuita)","poison":"Centro de control de venenos","emergency":"Emergencias europeas"},"error":{"title":"Se ha producido un error","button":"Vuelva a iniciar la aplicaci\xf3n"},"history":{"title":"historial de chat"},"inputs":{"choose":"Elija una respuesta"},"language":{"change":"cambiar el idioma","select":"seleccione la lengua que desea utilizar"},"link":{"buttontext":"Ver el documento","goto":"Ir a la direcci\xf3n","click":"Haga clic aqu\xed","scanQR":"escaneando el QrCode","scanQRTile":"Escanea el c\xf3digo QR para descubrir"},"loader":{"loader":{"optimal":"Para una experiencia \xf3ptima,","classic":"Para una experiencia m\xe1s cl\xe1sica,","vocal":"Me comunico hablando con el agente.","text":"Me comunico por SMS con el agente."},"modes":{"vocal":"modo vocal","text":"modo texto"},"loaderValidation":"Iniciar conversaci\xf3n","locale":"comprobar configuraci\xf3n regional","supported":"comprobaci\xf3n de las configuraciones regionales admitidas","store":"crear tienda","directline":"conexi\xf3n directline","ponyfill":"creaci\xf3n del ponyfill","addressdata":"recuperar datos"},"menu":{"message":"Escriba su mensaje","allowMicrophone":"D\xe9 permiso a su navegador para utilizar el micr\xf3fono para continuar","backconversation":"volver a la conversaci\xf3n","answer":" responde a tus preguntas"},"mobileLandscapePreventer":{"firstline":"Para una experiencia \xf3ptima","secondline":"voltea la pantalla"},"news":{"warningtext":"Est\xe1 a punto de acceder al canal de informaci\xf3n, el sonido de su dispositivo se activar\xe1","live":"en directo","continuous":"continuo"},"poi":{"comment":"revisi\xf3n del cliente","route":"ruta","nodata":"Ning\xfan contenido corresponde a su b\xfasqueda","openinghours":"Horario de apertura","prices":"Precios","paymentmethods":"M\xe9todos de pago","numberofplaces":"numero de lugares","openroutemobile":"abrir la ruta de Google Maps en el tel\xe9fono inteligente","FoodEstablishment":"D\xf3nde comer","LodgingBusiness":"D\xf3nde dormir","TouristDestination":"Qu\xe9 ver","TouristAttraction":"Qu\xe9 hacer","Product":"Productos locales","Service":"Servicios","Event":"Eventos","City":"Ciudades","Wine":"Vinos"},"suggestion":{"consult":"Mira","thetutorial":"el tutorial"},"template":{"reset":"restablecer filtros","showresults":"Mostrar resultados","suggestiontitle":"Sugerencias de investigaci\xf3n","reminder":"No olvide :\\n puedo responder a sus preguntas."}}');


var $48a2135a74ecfbf7$exports = {};
$48a2135a74ecfbf7$exports = JSON.parse('{"1":"inicio","2":"canal de informaci\xf3n en directo","3":"tiempo","4":"n\xfameros de emergencia","1000":"historia","1001":"tutorial","common":{"all":"todos","back":"volver","close":"cerrar","continue":"continuar","download":"descargar","downloadsheet":"descargar esta hoja","downloadsheetmobile":"descargar esta hoja en el tel\xe9fono inteligente","filter":"filtrar","history":"historia","lang":"idiomas","menu":"men\xfa","mode":"modo","needhelp":"necesitar ayuda ?","parameters":"par\xe1metros","print":"imprime","printsheet":"imprime esta hoja","result":"resultado","results":"resultados","singleLang":"idioma","sound":"sonido","submit":"enviar","subtitle":"subt\xedtulos","tutorial":"tutorial","validate":"valide"},"emergency":{"samu":"samu","police":"polic\xeda","firefighter":"bomberos","general":"general","citypolice":"Polic\xeda Local","hospital":"Hospital","homeless":"Personas sin hogar (llamada gratuita)","poison":"Centro de control de venenos","emergency":"Emergencias europeas"},"error":{"title":"Se ha producido un error","button":"Vuelva a iniciar la aplicaci\xf3n"},"history":{"title":"historial de chat"},"inputs":{"choose":"Elija una respuesta"},"language":{"change":"cambiar el idioma","select":"seleccione la lengua que desea utilizar"},"link":{"buttontext":"Ver el documento","goto":"Ir a la direcci\xf3n","click":"Haga clic aqu\xed","scanQR":"escaneando el QrCode","scanQRTile":"Escanea el c\xf3digo QR para descubrir"},"loader":{"loader":{"optimal":"Para una experiencia \xf3ptima,","classic":"Para una experiencia m\xe1s cl\xe1sica,","vocal":"Me comunico hablando con el agente.","text":"Me comunico por SMS con el agente."},"modes":{"vocal":"modo vocal","text":"modo texto"},"loaderValidation":"Iniciar conversaci\xf3n","locale":"comprobar configuraci\xf3n regional","supported":"comprobaci\xf3n de las configuraciones regionales admitidas","store":"crear tienda","directline":"conexi\xf3n directline","ponyfill":"creaci\xf3n del ponyfill","addressdata":"recuperar datos"},"menu":{"message":"Escriba su mensaje","allowMicrophone":"D\xe9 permiso a su navegador para utilizar el micr\xf3fono para continuar","backconversation":"volver a la conversaci\xf3n","answer":" responde a tus preguntas"},"mobileLandscapePreventer":{"firstline":"Para una experiencia \xf3ptima","secondline":"voltea la pantalla"},"news":{"warningtext":"Est\xe1 a punto de acceder al canal de informaci\xf3n, el sonido de su dispositivo se activar\xe1","live":"en directo","continuous":"continuo"},"poi":{"comment":"revisi\xf3n del cliente","route":"ruta","nodata":"Ning\xfan contenido corresponde a su b\xfasqueda","openinghours":"Horario de apertura","prices":"Precios","paymentmethods":"M\xe9todos de pago","numberofplaces":"numero de lugares","openroutemobile":"abrir la ruta de Google Maps en el tel\xe9fono inteligente","FoodEstablishment":"D\xf3nde comer","LodgingBusiness":"D\xf3nde dormir","TouristDestination":"Qu\xe9 ver","TouristAttraction":"Qu\xe9 hacer","Product":"Productos locales","Service":"Servicios","Event":"Eventos","City":"Ciudades","Wine":"Vinos"},"suggestion":{"consult":"Mira","thetutorial":"el tutorial"},"template":{"reset":"restablecer filtros","showresults":"Mostrar resultados","suggestiontitle":"Sugerencias de investigaci\xf3n","reminder":"No olvide :\\n puedo responder a sus preguntas."}}');


var $375e79e4752e74e9$exports = {};
$375e79e4752e74e9$exports = JSON.parse('{"1":"kotisivu","2":"live-uutiskanava","3":"S\xe4\xe4tiedotus","4":"H\xe4t\xe4numerot","1000":"historiallinen","1001":"opetusohjelma","common":{"all":"kaikki","back":"takaisin","close":"kiinni","continue":"Jatkaa","download":"ladata","downloadsheet":"lataa t\xe4m\xe4 taulukko","downloadsheetmobile":"lataa t\xe4m\xe4 taulukko \xe4lypuhelimeen","filter":"Suodattaa","history":"historiallinen","lang":"KIELET","menu":"valikosta","mode":"muoti","needhelp":"Tarvitsetko apua?","parameters":"asetukset","print":"Tulosta","printsheet":"Tulosta t\xe4m\xe4 arkki","result":"tulos","results":"tuloksia","singleLang":"Kieli","sound":"h\xe4nen","submit":"L\xe4het\xe4","subtitle":"alaotsikko","tutorial":"opetusohjelma","validate":"vahvistaa"},"emergency":{"samu":"S.A.M.U.","police":"Poliisi","firefighter":"palomiehi\xe4","general":"yleist\xe4","citypolice":"Paikallinen poliisi","hospital":"Sairaala","homeless":"Asunnoton (ilmainen puhelu)","poison":"Poison Control Center","emergency":"Euroopan h\xe4t\xe4tilanteita"},"error":{"title":"Tapahtui virhe","button":"K\xe4ynnist\xe4 sovellus uudelleen"},"history":{"title":"keskusteluhistoria"},"inputs":{"choose":"Valitse vastaus"},"language":{"change":"vaihtaa kielt\xe4","select":"valitse kieli, jota haluat k\xe4ytt\xe4\xe4"},"link":{"buttontext":"N\xe4yt\xe4 asiakirja","goto":"Mene osoitteeseen","click":"Klikkaa t\xe4st\xe4","scanQR":"skannaamalla QR-koodin","scanQRTile":"Skannaa QR-koodi saadaksesi selville"},"loader":{"loader":{"optimal":"Optimaalisen kokemuksen saamiseksi","classic":"Klassisemman kokemuksen saamiseksi","vocal":"Puhun kasvotusten agentin kanssa.","text":"Olen yhteydess\xe4 v\xe4litt\xe4j\xe4\xe4n kirjallisesti."},"modes":{"vocal":"laulutila","text":"tekstitila"},"loaderValidation":"Aloita keskustelu","locale":"kielen tarkistaminen","supported":"tuettujen kielten tarkistaminen","addressdata":"tietojen hakeminen"},"menu":{"message":"Kirjoita viestisi","allowMicrophone":"Anna selaimen k\xe4ytt\xe4\xe4 mikrofonia jatkaaksesi","backconversation":"takaisin keskusteluun","answer":" vastaa kysymyksiisi"},"mobileLandscapePreventer":{"firstline":"Optimaalisen kokemuksen saamiseksi","secondline":"k\xe4\xe4nn\xe4 n\xe4ytt\xf6\xe4si"},"news":{"warningtext":"P\xe4\xe4set uutiskanavalle, laitteesi \xe4\xe4ni aktivoituu","live":"el\xe4\xe4","continuous":"jatkuvasti"},"poi":{"comment":"Asiakaspalaute","route":"tie","nodata":"Mik\xe4\xe4n sis\xe4lt\xf6 ei vastaa hakuasi","openinghours":"Aukioloajat","prices":"hinnat","paymentmethods":"Maksutavat","numberofplaces":"paikkojen m\xe4\xe4r\xe4","openroutemobile":"avaa Google Maps -reitti \xe4lypuhelimella","FoodEstablishment":"Miss\xe4 sy\xf6d\xe4","LodgingBusiness":"Miss\xe4 nukkua","TouristDestination":"Mit\xe4 n\xe4hd\xe4","TouristAttraction":"Mit\xe4 tehd\xe4","Product":"Paikalliset tuotteet","Service":"Palvelut","Event":"Tapahtumat","City":"kaupungit","Wine":"Viinit"},"suggestion":{"consult":"Tarkista","thetutorial":"opetusohjelma"},"template":{"reset":"nollaa kaikki","showresults":"N\xe4yt\xe4 tulokset","suggestiontitle":"Hakuehdotukset","reminder":"\xc4l\xe4 unohda, \\n voin vastata kysymyksiisi."}}');


var $ef45527fb915fe31$exports = {};
$ef45527fb915fe31$exports = JSON.parse('{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel","common":{"abort":"annuler","all":"tous","back":"retour","close":"fermer","continue":"continuer","download":"t\xe9l\xe9charger","downloadsheet":"t\xe9l\xe9charger cette fiche","downloadsheetmobile":"t\xe9l\xe9charger cette fiche sur mobile","filter":"filtrer","history":"historique","lang":"langues","menu":"menu","mode":"mode","needhelp":"besoin d\'aide ?","parameters":"param\xe8tres","print":"imprimer","printsheet":"imprimer cette fiche","result":"r\xe9sultat","results":"r\xe9sultats","singleLang":"langue","sound":"son","submit":"valider","subtitle":"sous-titre","tutorial":"tutoriel","validate":"valider"},"emergency":{"samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral","citypolice":"Police municipale","hospital":"H\xf4pital","homeless":"Sans abris (appel gratuit)","poison":"Centre anti-poison","emergency":"Urgences europ\xe9ennes"},"error":{"title":"une erreur est survenue","button":"Relancer l\'application"},"history":{"title":"historique de conversation"},"inputs":{"choose":"Choisissez une r\xe9ponse"},"language":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix"},"link":{"buttonText":"Voir le document","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode","scanQRTile":"Scanner le QR Code pour d\xe9couvrir"},"loader":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique,","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"modes":{"vocal":"mode vocal","text":"mode texte"},"loaderValidation":"D\xe9marrer la conversation","locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"menu":{"message":"Saisissez votre message","allowMicrophone":"Autorisez votre navigateur \xe0 utiliser votre micro pour continuer","backconversation":"retour \xe0 la conversation","answer":" r\xe9pond \xe0 vos questions"},"mobileLandscapePreventer":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"news":{"warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","live":"direct","continuous":"en continu"},"poi":{"comment":"avis clients","route":"y Aller","nodata":"Aucun contenu ne correspond \xe0 votre recherche","openinghours":"Horaires","prices":"Tarifs","paymentmethods":"Modes de paiement","numberofplaces":"nombre de couverts","openroutemobile":"ouvrir l\'itin\xe9raire Google Maps sur mobile","FoodEstablishment":"O\xf9 manger","LodgingBusiness":"O\xf9 dormir","TouristDestination":"A voir","TouristAttraction":"A faire","Product":"Produits locaux","Service":"Services","Event":"Ev\xe8nements","City":"Villes","Wine":"Vins"},"suggestion":{"consult":"Consultez","thetutorial":"le tutoriel"},"template":{"reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"GDPR":{"title":"traitement des donn\xe9es personnelles transmises au bot","message":"en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d\'analyse de l\'utilisation de l\'outil et d\'enrichissement de la base de connaissance.\\n\\nVos conversations sont conserv\xe9es 6 mois avant de faire l\'objet d\'une suppression.","link":"lien pour consulter les politiques de confidentialit\xe9","buttonAccept":"j\'ai compris et j\'accepte","buttonRefuse":"je refuse","messageAccepted":"votre consentement est bien pris en compte","messageRefused":"votre refus est bien pris en compte"}}');


var $ffd5f23dea726f50$exports = {};
$ffd5f23dea726f50$exports = JSON.parse('{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel","common":{"abort":"annuler","all":"tous","back":"retour","close":"fermer","continue":"continuer","download":"t\xe9l\xe9charger","downloadsheet":"t\xe9l\xe9charger cette fiche","downloadsheetmobile":"t\xe9l\xe9charger cette fiche sur mobile","filter":"filtrer","history":"historique","lang":"langues","menu":"menu","mode":"mode","needhelp":"besoin d\'aide ?","parameters":"param\xe8tres","print":"imprimer","printsheet":"imprimer cette fiche","result":"r\xe9sultat","results":"r\xe9sultats","singleLang":"langue","sound":"son","submit":"valider","subtitle":"sous-titre","tutorial":"tutoriel","validate":"valider"},"emergency":{"samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral","citypolice":"Police municipale","hospital":"H\xf4pital","homeless":"Sans abris (appel gratuit)","poison":"Centre anti-poison","emergency":"Urgences europ\xe9ennes"},"error":{"title":"une erreur est survenue","button":"Relancer l\'application"},"history":{"title":"historique de conversation"},"inputs":{"choose":"Choisissez une r\xe9ponse"},"language":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix"},"link":{"buttonText":"Voir le document","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode","scanQRTile":"Scanner le QR Code pour d\xe9couvrir"},"loader":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique,","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"modes":{"vocal":"mode vocal","text":"mode texte"},"loaderValidation":"D\xe9marrer la conversation","locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"menu":{"message":"Saisissez votre message","allowMicrophone":"Autorisez votre navigateur \xe0 utiliser votre micro pour continuer","backconversation":"retour \xe0 la conversation","answer":" r\xe9pond \xe0 vos questions"},"mobileLandscapePreventer":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"news":{"warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","live":"direct","continuous":"en continu"},"poi":{"comment":"avis clients","route":"y Aller","nodata":"Aucun contenu ne correspond \xe0 votre recherche","openinghours":"Horaires","prices":"Tarifs","paymentmethods":"Modes de paiement","numberofplaces":"nombre de couverts","openroutemobile":"ouvrir l\'itin\xe9raire Google Maps sur mobile","FoodEstablishment":"O\xf9 manger","LodgingBusiness":"O\xf9 dormir","TouristDestination":"A voir","TouristAttraction":"A faire","Product":"Produits locaux","Service":"Services","Event":"Ev\xe8nements","City":"Villes","Wine":"Vins"},"suggestion":{"consult":"Consultez","thetutorial":"le tutoriel"},"template":{"reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"GDPR":{"title":"traitement des donn\xe9es personnelles transmises au bot","message":"en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d\'analyse de l\'utilisation de l\'outil et d\'enrichissement de la base de connaissance.\\n\\nVos conversations sont conserv\xe9es 6 mois avant de faire l\'objet d\'une suppression.","link":"lien pour consulter les politiques de confidentialit\xe9","buttonAccept":"j\'ai compris et j\'accepte","buttonRefuse":"je refuse","messageAccepted":"votre consentement est bien pris en compte","messageRefused":"votre refus est bien pris en compte"}}');


var $5e029386ed40f19e$exports = {};
$5e029386ed40f19e$exports = JSON.parse('{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel","common":{"abort":"annuler","all":"tous","back":"retour","close":"fermer","continue":"continuer","download":"t\xe9l\xe9charger","downloadsheet":"t\xe9l\xe9charger cette fiche","downloadsheetmobile":"t\xe9l\xe9charger cette fiche sur mobile","filter":"filtrer","history":"historique","lang":"langues","menu":"menu","mode":"mode","needhelp":"besoin d\'aide ?","parameters":"param\xe8tres","print":"imprimer","printsheet":"imprimer cette fiche","result":"r\xe9sultat","results":"r\xe9sultats","singleLang":"langue","sound":"son","submit":"valider","subtitle":"sous-titre","tutorial":"tutoriel","validate":"valider"},"emergency":{"samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral","citypolice":"Police municipale","hospital":"H\xf4pital","homeless":"Sans abris (appel gratuit)","poison":"Centre anti-poison","emergency":"Urgences europ\xe9ennes"},"error":{"title":"une erreur est survenue","button":"Relancer l\'application"},"history":{"title":"historique de conversation"},"inputs":{"choose":"Choisissez une r\xe9ponse"},"language":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix"},"link":{"buttonText":"Voir le document","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode","scanQRTile":"Scanner le QR Code pour d\xe9couvrir"},"loader":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique,","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"modes":{"vocal":"mode vocal","text":"mode texte"},"loaderValidation":"D\xe9marrer la conversation","locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"menu":{"message":"Saisissez votre message","allowMicrophone":"Autorisez votre navigateur \xe0 utiliser votre micro pour continuer","backconversation":"retour \xe0 la conversation","answer":" r\xe9pond \xe0 vos questions"},"mobileLandscapePreventer":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"news":{"warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","live":"direct","continuous":"en continu"},"poi":{"comment":"avis clients","route":"y Aller","nodata":"Aucun contenu ne correspond \xe0 votre recherche","openinghours":"Horaires","prices":"Tarifs","paymentmethods":"Modes de paiement","numberofplaces":"nombre de couverts","openroutemobile":"ouvrir l\'itin\xe9raire Google Maps sur mobile","FoodEstablishment":"O\xf9 manger","LodgingBusiness":"O\xf9 dormir","TouristDestination":"A voir","TouristAttraction":"A faire","Product":"Produits locaux","Service":"Services","Event":"Ev\xe8nements","City":"Villes","Wine":"Vins"},"suggestion":{"consult":"Consultez","thetutorial":"le tutoriel"},"template":{"reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"GDPR":{"title":"traitement des donn\xe9es personnelles transmises au bot","message":"en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d\'analyse de l\'utilisation de l\'outil et d\'enrichissement de la base de connaissance.\\n\\nVos conversations sont conserv\xe9es 6 mois avant de faire l\'objet d\'une suppression.","link":"lien pour consulter les politiques de confidentialit\xe9","buttonAccept":"j\'ai compris et j\'accepte","buttonRefuse":"je refuse","messageAccepted":"votre consentement est bien pris en compte","messageRefused":"votre refus est bien pris en compte"}}');


var $3af5e0a31f6d74a1$exports = {};
$3af5e0a31f6d74a1$exports = JSON.parse('{"1":"accueil","2":"cha\xeene info live","3":"m\xe9t\xe9o","4":"num\xe9ros d\'urgence","1000":"historique","1001":"tutoriel","common":{"abort":"annuler","all":"tous","back":"retour","close":"fermer","continue":"continuer","download":"t\xe9l\xe9charger","downloadsheet":"t\xe9l\xe9charger cette fiche","downloadsheetmobile":"t\xe9l\xe9charger cette fiche sur mobile","filter":"filtrer","history":"historique","lang":"langues","menu":"menu","mode":"mode","needhelp":"besoin d\'aide ?","parameters":"param\xe8tres","print":"imprimer","printsheet":"imprimer cette fiche","result":"r\xe9sultat","results":"r\xe9sultats","singleLang":"langue","sound":"son","submit":"valider","subtitle":"sous-titre","tutorial":"tutoriel","validate":"valider"},"emergency":{"samu":"samu","police":"police","firefighter":"pompiers","general":"g\xe9n\xe9ral","citypolice":"Police municipale","hospital":"H\xf4pital","homeless":"Sans abris (appel gratuit)","poison":"Centre anti-poison","emergency":"Urgences europ\xe9ennes"},"error":{"title":"une erreur est survenue","button":"Relancer l\'application"},"history":{"title":"historique de conversation"},"inputs":{"choose":"Choisissez une r\xe9ponse","noaction":"Une action est attendue"},"language":{"change":"changer la langue","select":"s\xe9lectionnez la langue de votre choix"},"link":{"buttonText":"Voir le document","goto":"Acc\xe9der \xe0 l\'adresse","click":"Cliquez-ici","scanQR":"en scannant le QrCode","scanQRTile":"Scanner le QR Code pour d\xe9couvrir"},"loader":{"loader":{"optimal":"Pour une exp\xe9rience optimale,","classic":"Pour une exp\xe9rience plus classique,","vocal":"j\'\xe9change de vive voix avec l\'agent.","text":"j\'\xe9change \xe0 l\'\xe9crit avec l\'agent."},"modes":{"vocal":"mode vocal","text":"mode texte"},"loaderValidation":"D\xe9marrer la conversation","locale":"v\xe9rification de la langue","supported":"v\xe9rification des langues disponibles","store":"cr\xe9ation du store","directline":"connection au directline","ponyfill":"cr\xe9ation du ponyfill","addressdata":"r\xe9cup\xe9ration des donn\xe9es"},"menu":{"message":"Saisissez votre message","allowMicrophone":"Autorisez votre navigateur \xe0 utiliser votre micro pour continuer","backconversation":"retour \xe0 la conversation","answer":" r\xe9pond \xe0 vos questions"},"mobileLandscapePreventer":{"firstline":"Pour une exp\xe9rience optimale,","secondline":"basculez votre \xe9cran"},"news":{"warningtext":"Vous allez acc\xe9der \xe0 la cha\xeene info, le son de votre appareil va \xeatre activ\xe9","live":"direct","continuous":"en continu"},"poi":{"comment":"avis clients","route":"y Aller","nodata":"Aucun contenu ne correspond \xe0 votre recherche","openinghours":"Horaires","prices":"Tarifs","paymentmethods":"Modes de paiement","numberofplaces":"nombre de couverts","openroutemobile":"ouvrir l\'itin\xe9raire Google Maps sur mobile","FoodEstablishment":"O\xf9 manger","LodgingBusiness":"O\xf9 dormir","TouristDestination":"A voir","TouristAttraction":"A faire","Product":"Produits locaux","Service":"Services","Event":"Ev\xe8nements","City":"Villes","Wine":"Vins"},"suggestion":{"consult":"Consultez","thetutorial":"le tutoriel"},"template":{"reset":"effacer tout","showresults":"Afficher les r\xe9sultats","suggestiontitle":"Suggestions de recherches","reminder":"N\'oubliez pas,\\n je peux r\xe9pondre \xe0 vos questions."},"GDPR":{"title":"traitement des donn\xe9es personnelles transmises au bot","message":"en acceptant ce dialogue, vous consentez \xe0 ce que toutes les donn\xe9es transmises au chatbot soient exploit\xe9es \xe0 des fins d\'analyse de l\'utilisation de l\'outil et d\'enrichissement de la base de connaissance.\\n\\nVos conversations sont conserv\xe9es 6 mois avant de faire l\'objet d\'une suppression.","link":"lien pour consulter les politiques de confidentialit\xe9","buttonAccept":"j\'ai compris et j\'accepte","buttonRefuse":"je refuse","messageAccepted":"votre consentement est bien pris en compte","messageRefused":"votre refus est bien pris en compte"}}');


var $e433c4a4857d0f41$exports = {};
$e433c4a4857d0f41$exports = JSON.parse('{"1":"\u0939\u094B\u092E \u092A\u0947\u091C","2":"\u0932\u093E\u0907\u0935 \u0928\u094D\u092F\u0942\u091C\u093C \u091A\u0948\u0928\u0932","3":"\u092E\u094C\u0938\u092E \u0915\u0940 \u0930\u093F\u092A\u094B\u0930\u094D\u091F","4":"\u0906\u092A\u093E\u0924\u0915\u093E\u0932\u0940\u0928 \u0928\u0902\u092C\u0930","1000":"\u0910\u0924\u093F\u0939\u093E\u0938\u093F\u0915","1001":"\u091F\u094D\u092F\u0942\u091F\u094B\u0930\u093F\u092F\u0932","common":{"all":"\u0938\u092D\u0940","back":"\u092A\u0940\u091B\u0947","close":"\u092C\u0902\u0926 \u0915\u0930\u0928\u093E","continue":"\u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u093E","download":"\u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0928\u093E","downloadsheet":"\u0907\u0938 \u0936\u0940\u091F \u0915\u094B \u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0947\u0902","downloadsheetmobile":"\u0907\u0938 \u0936\u0940\u091F \u0915\u094B \u0938\u094D\u092E\u093E\u0930\u094D\u091F\u092B\u094B\u0928 \u092A\u0930 \u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0947\u0902","filter":"\u092B\u093C\u093F\u0932\u094D\u091F\u0930","history":"\u0910\u0924\u093F\u0939\u093E\u0938\u093F\u0915","lang":"\u092C\u094B\u0932\u0940","menu":"\u092E\u0947\u0928\u094D\u092F\u0942","mode":"\u092A\u0939\u0928\u093E\u0935\u093E","needhelp":"\u092E\u0926\u0926 \u0915\u0940 \u091C\u093C\u0930\u0942\u0930\u0924 \u0939\u0948?","parameters":"\u0938\u092E\u093E\u092F\u094B\u091C\u0928","print":"\u091B\u093E\u092A","printsheet":"\u0907\u0938 \u0936\u0940\u091F \u0915\u094B \u092A\u094D\u0930\u093F\u0902\u091F \u0915\u0930\u0947\u0902","result":"\u092A\u0930\u093F\u0923\u093E\u092E","results":"\u092A\u0930\u093F\u0923\u093E\u092E","singleLang":"\u092D\u093E\u0937\u093E","sound":"\u0909\u0938\u0915\u0940","submit":"\u091C\u092E\u093E \u0915\u0930\u0928\u093E","subtitle":"\u0909\u092A\u0936\u0940\u0930\u094D\u0937\u0915","tutorial":"\u091F\u094D\u092F\u0942\u091F\u094B\u0930\u093F\u092F\u0932","validate":"\u092E\u093E\u0928\u094D\u092F"},"emergency":{"samu":"\u090F\u0938.\u090F.\u090F\u092E.\u092F\u0942.","police":"\u092A\u0941\u0932\u093F\u0938","firefighter":"\u0905\u0917\u094D\u0928\u093F\u0936\u092E\u0928 \u0915\u0930\u094D\u092E\u0940","general":"\u091C\u0928\u0930\u0932","citypolice":"\u0938\u094D\u0925\u093E\u0928\u0940\u092F \u092A\u0941\u0932\u093F\u0938","hospital":"\u0905\u0938\u094D\u092A\u0924\u093E\u0932","homeless":"\u092C\u0947\u0918\u0930 (\u0928\u093F\u0903\u0936\u0941\u0932\u094D\u0915 \u0915\u0949\u0932)","poison":"\u091C\u093C\u0939\u0930 \u0928\u093F\u092F\u0902\u0924\u094D\u0930\u0923 \u0915\u0947\u0902\u0926\u094D\u0930","emergency":"\u092F\u0942\u0930\u094B\u092A\u0940\u092F \u0906\u092A\u093E\u0924\u0915\u093E\u0932"},"error":{"title":"\u090F\u0915 \u0917\u0932\u0924\u0940 \u0939\u0941\u0908 \u0939\u0948","button":"\u090F\u092A\u094D\u0932\u093F\u0915\u0947\u0936\u0928 \u0915\u094B \u092A\u0941\u0928\u0903 \u0932\u0949\u0928\u094D\u091A \u0915\u0930\u0947\u0902"},"history":{"title":"\u092C\u093E\u0924\u091A\u0940\u0924 \u0915\u093E \u0907\u0924\u093F\u0939\u093E\u0938"},"inputs":{"choose":"\u090F\u0915 \u0909\u0924\u094D\u0924\u0930 \u091A\u0941\u0928\u0947\u0902"},"language":{"change":"\u092D\u093E\u0937\u093E \u092C\u0926\u0932\u094B","select":"\u0935\u0939 \u092D\u093E\u0937\u093E \u091A\u0941\u0928\u0947\u0902 \u091C\u093F\u0938\u0915\u093E \u0906\u092A \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902"},"link":{"buttontext":"\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0926\u0947\u0916\u0947\u0902","goto":"\u092A\u0924\u0947 \u092A\u0930 \u091C\u093E\u090F\u0902","click":"\u092F\u0939\u093E\u0901 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902","scanQR":"QrCode \u0915\u094B \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0915\u0947","scanQRTile":"\u0915\u094D\u092F\u0942\u0906\u0930 \u0915\u094B\u0921 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902 \u0914\u0930 \u091C\u093E\u0928\u0947\u0902"},"loader":{"loader":{"optimal":"\u0938\u0930\u094D\u0935\u094B\u0924\u094D\u0924\u092E \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,","classic":"\u0905\u0927\u093F\u0915 \u0915\u094D\u0932\u093E\u0938\u093F\u0915 \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,","vocal":"\u092E\u0948\u0902 \u090F\u091C\u0947\u0902\u091F \u0938\u0947 \u0906\u092E\u0928\u0947-\u0938\u093E\u092E\u0928\u0947 \u092C\u093E\u0924 \u0915\u0930\u0924\u093E \u0939\u0942\u0902\u0964","text":"\u092E\u0948\u0902 \u090F\u091C\u0947\u0902\u091F \u0915\u0947 \u0938\u093E\u0925 \u0932\u093F\u0916\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0938\u0902\u0935\u093E\u0926 \u0915\u0930\u0924\u093E \u0939\u0942\u0902\u0964"},"modes":{"vocal":"\u0938\u094D\u0935\u0930 \u0935\u093F\u0927\u093E","text":"\u092A\u093E\u0920 \u092E\u094B\u0921"},"loaderValidation":"\u092C\u093E\u0924\u091A\u0940\u0924 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902","locale":"\u092D\u093E\u0937\u093E \u0915\u0940 \u091C\u093E\u0901\u091A \u0915\u0930\u0928\u093E","supported":"\u0938\u092E\u0930\u094D\u0925\u093F\u0924 \u092D\u093E\u0937\u093E\u0913\u0902 \u0915\u0940 \u091C\u093E\u0901\u091A \u0915\u0930\u0928\u093E","addressdata":"\u092A\u0941\u0928: \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0921\u0947\u091F\u093E"},"menu":{"message":"\u0905\u092A\u0928\u093E \u0938\u0902\u0926\u0947\u0936 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902","allowMicrophone":"\u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0905\u092A\u0928\u0947 \u092E\u093E\u0907\u0915\u094D\u0930\u094B\u092B\u093C\u094B\u0928 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0905\u0928\u0941\u092E\u0924\u093F \u0926\u0947\u0902","backconversation":"\u092C\u093E\u0924\u091A\u0940\u0924 \u092A\u0930 \u0935\u093E\u092A\u0938","answer":" \u0906\u092A\u0915\u0947 \u092A\u094D\u0930\u0936\u094D\u0928\u094B\u0902 \u0915\u093E \u0909\u0924\u094D\u0924\u0930 \u0926\u0947\u0924\u093E \u0939\u0948"},"mobileLandscapePreventer":{"firstline":"\u0938\u0930\u094D\u0935\u094B\u0924\u094D\u0924\u092E \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,","secondline":"\u0905\u092A\u0928\u0940 \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0932\u091F\u0947\u0902"},"news":{"warningtext":"\u0906\u092A \u0938\u092E\u093E\u091A\u093E\u0930 \u091A\u0948\u0928\u0932 \u0924\u0915 \u092A\u0939\u0941\u0902\u091A \u092A\u093E\u090F\u0902\u0917\u0947, \u0906\u092A\u0915\u0947 \u0921\u093F\u0935\u093E\u0907\u0938 \u092A\u0930 \u0927\u094D\u0935\u0928\u093F \u0938\u0915\u094D\u0930\u093F\u092F \u0939\u094B \u091C\u093E\u090F\u0917\u0940","live":"\u0930\u0939\u0928\u093E","continuous":"\u0932\u0917\u093E\u0924\u093E\u0930"},"poi":{"comment":"\u0917\u094D\u0930\u093E\u0939\u0915 \u0938\u092E\u0940\u0915\u094D\u0937\u093E","route":"\u0938\u0921\u093C\u0915","nodata":"\u0915\u094B\u0908 \u092D\u0940 \u0938\u093E\u092E\u0917\u094D\u0930\u0940 \u0906\u092A\u0915\u0940 \u0916\u094B\u091C \u0938\u0947 \u092E\u0947\u0932 \u0928\u0939\u0940\u0902 \u0916\u093E\u0924\u0940","openinghours":"\u0916\u0941\u0932\u0928\u0947 \u0915\u093E \u0938\u092E\u092F","prices":"\u0915\u0940\u092E\u0924\u094B\u0902","paymentmethods":"\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0940 \u0935\u093F\u0927\u093F","numberofplaces":"\u0938\u094D\u0925\u093E\u0928\u094B\u0902 \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E","openroutemobile":"\u0938\u094D\u092E\u093E\u0930\u094D\u091F\u092B\u094B\u0928 \u092A\u0930 \u0917\u0942\u0917\u0932 \u092E\u0948\u092A \u0930\u0942\u091F \u0916\u094B\u0932\u0947\u0902","FoodEstablishment":"\u0915\u0939\u093E\u0901 \u0916\u093E\u0928\u093E \u0939\u0948","LodgingBusiness":"\u0915\u0939\u093E\u0901 \u0938\u094B\u0928\u093E \u0939\u0948","TouristDestination":"\u0915\u094D\u092F\u093E \u0926\u0947\u0916\u0947\u0902","TouristAttraction":"\u0915\u094D\u092F\u093E \u0915\u0930\u0947\u0902","Product":"\u0938\u094D\u0925\u093E\u0928\u0940\u092F \u0909\u0924\u094D\u092A\u093E\u0926","Service":"\u0938\u0947\u0935\u093E\u090F\u0902","Event":"\u0906\u092F\u094B\u091C\u0928","City":"\u0936\u0939\u0930\u094B\u0902","Wine":"\u0935\u093E\u0907\u0928"},"suggestion":{"consult":"\u091A\u0947\u0915 \u0906\u0909\u091F","thetutorial":"\u091F\u094D\u092F\u0942\u091F\u094B\u0930\u093F\u092F\u0932"},"template":{"reset":"\u0938\u092D\u0940 \u0915\u094B \u092A\u0941\u0928\u0903 \u0924\u0948\u092F\u093E\u0930 \u0915\u0930\u0928\u093E","showresults":"\u092A\u0930\u093F\u0923\u093E\u092E \u0926\u093F\u0916\u093E\u090F\u0901","suggestiontitle":"\u0938\u0941\u091D\u093E\u0935 \u0916\u094B\u091C\u0947\u0902","reminder":"\u092E\u0924 \u092D\u0942\u0932\u093F\u090F, \\n \u092E\u0948\u0902 \u0906\u092A\u0915\u0947 \u092A\u094D\u0930\u0936\u094D\u0928\u094B\u0902 \u0915\u093E \u0909\u0924\u094D\u0924\u0930 \u0926\u0947 \u0938\u0915\u0924\u093E \u0939\u0942\u0901\u0964"}}');


var $2de632c04f2593c0$exports = {};
$2de632c04f2593c0$exports = JSON.parse('{"1":"kezd\u0151lap","2":"\xe9l\u0151 h\xedrcsatorna","3":"id\u0151j\xe1r\xe1s jelent\xe9s","4":"Seg\xe9lyh\xedv\xf3 sz\xe1mok","1000":"t\xf6rt\xe9nelmi","1001":"oktat\xf3anyag","common":{"all":"minden","continue":"Folytatni","download":"Let\xf6lt\xe9s","downloadsheet":"T\xf6ltse le ezt a lapot","downloadsheetmobile":"t\xf6ltse le ezt a lapot okostelefonra","filter":"Sz\u0171r\u0151","history":"t\xf6rt\xe9nelmi","lang":"NYELVEK","menu":"men\xfc","mode":"divat","needhelp":"Kell seg\xedts\xe9g?","parameters":"be\xe1ll\xedt\xe1sok","print":"Nyomtat\xe1s","printsheet":"Nyomtassa ki ezt a lapot","result":"eredm\xe9ny","results":"eredm\xe9nyek","singleLang":"nyelv","sound":"neki","submit":"Bek\xfcld\xe9s","subtitle":"felirat","tutorial":"oktat\xf3anyag","validate":"\xe9rv\xe9nyes\xedt"},"emergency":{"samu":"S.A.M.U.","police":"rend\u0151rs\xe9g","firefighter":"t\u0171zolt\xf3k","general":"t\xe1bornoki","citypolice":"Helyi rend\u0151rs\xe9g","hospital":"K\xf3rh\xe1z","homeless":"Hajl\xe9ktalanok (ingyenes h\xedv\xe1s)","poison":"M\xe9regellen\u0151rz\u0151 K\xf6zpont","emergency":"eur\xf3pai v\xe9szhelyzetek"},"error":{"title":"Hiba t\xf6rt\xe9nt","button":"Ind\xedtsa \xfajra az alkalmaz\xe1st"},"history":{"title":"besz\xe9lget\xe9s el\u0151zm\xe9nyei"},"inputs":{"choose":"V\xe1lasszon egy v\xe1laszt"},"language":{"change":"v\xe1ltoztassa meg a nyelvet","select":"v\xe1lassza ki a haszn\xe1lni k\xedv\xe1nt nyelvet"},"link":{"buttontext":"Tekintse meg a dokumentumot","goto":"Menjen a c\xedmre","click":"Kattints ide","scanQR":"a QR-k\xf3d beolvas\xe1s\xe1val","scanQRTile":"Olvassa be a QR-k\xf3dot a felfedez\xe9shez"},"loader":{"loader":{"optimal":"Az optim\xe1lis \xe9lm\xe9ny \xe9rdek\xe9ben","classic":"A klasszikusabb \xe9lm\xe9ny \xe9rdek\xe9ben","vocal":"N\xe9gyszemk\xf6zt besz\xe9lek az \xfcgyn\xf6kkel.","text":"\xcdr\xe1sban kommunik\xe1lok az \xfcgyn\xf6kkel."},"modes":{"vocal":"vok\xe1lis m\xf3d","text":"sz\xf6veges m\xf3d"},"loaderValidation":"Ind\xedtsa el a besz\xe9lget\xe9st","locale":"nyelv ellen\u0151rz\xe9se","supported":"t\xe1mogatott nyelvek ellen\u0151rz\xe9se","addressdata":"adatok lek\xe9r\xe9se"},"menu":{"message":"\xcdrja be \xfczenet\xe9t","allowMicrophone":"A folytat\xe1shoz enged\xe9lyezze b\xf6ng\xe9sz\u0151j\xe9nek a mikrofon haszn\xe1lat\xe1t","back":"vissza","backconversation":"vissza a besz\xe9lget\xe9shez","close":"Bez\xe1r\xe1s","answer":" v\xe1laszol a k\xe9rd\xe9seidre"},"mobileLandscapePreventer":{"firstline":"\u0938\u0930\u094D\u0935\u094B\u0924\u094D\u0924\u092E \u0905\u0928\u0941\u092D\u0935 \u0915\u0947 \u0932\u093F\u090F,","secondline":"\u0905\u092A\u0928\u0940 \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0932\u091F\u0947\u0902"},"news":{"warningtext":"Hozz\xe1f\xe9r a h\xedrcsatorn\xe1hoz, \xe9s a k\xe9sz\xfcl\xe9k hangja aktiv\xe1l\xf3dik","live":"\xe9l\u0151","continuous":"folyamatosan"},"poi":{"comment":"felhaszn\xe1l\xf3i \xe9rt\xe9kel\xe9s","route":"\xfat","nodata":"Egyetlen tartalom sem felel meg a keres\xe9snek","openinghours":"Nyitvatart\xe1si id\u0151","prices":"\xc1rak","paymentmethods":"Fizet\xe9si m\xf3dok","numberofplaces":"helyek sz\xe1ma","openroutemobile":"nyissa meg a Google Maps \xfatvonalat az okostelefonon","FoodEstablishment":"Hol tudok enni","LodgingBusiness":"Hol kell aludni","TouristDestination":"Mit kell l\xe1tni","TouristAttraction":"Mit kell tenni","Product":"Helyi term\xe9kek","Service":"Szolg\xe1ltat\xe1sok","Event":"Esem\xe9nyek","City":"V\xe1rosok","Wine":"Borok"},"suggestion":{"consult":"N\xe9zze meg","thetutorial":"az oktat\xf3anyag"},"template":{"reset":"minden vissza\xe1ll\xedt\xe1sa","showresults":"Mutasd meg az eredm\xe9nyeket","suggestiontitle":"Keres\xe9si javaslatok","reminder":"Ne felejtsd el, \\n tudok v\xe1laszolni a k\xe9rd\xe9seidre."}}');


var $1cfd5d54fed2fa2e$exports = {};
$1cfd5d54fed2fa2e$exports = JSON.parse('{"1":"halaman rumah","2":"saluran berita langsung","3":"laporan cuaca","4":"Nomor darurat","1000":"historis","1001":"tutorial","common":{"all":"semua","continue":"Melanjutkan","download":"unduh","downloadsheet":"unduh lembar ini","downloadsheetmobile":"unduh lembar ini di ponsel pintar","filter":"Saring","history":"historis","lang":"BAHASA","menu":"menu","mode":"mode","needhelp":"Butuh bantuan?","parameters":"pengaturan","print":"Mencetak","printsheet":"Cetak lembar ini","result":"hasil","results":"hasil","singleLang":"bahasa","sound":"dia","submit":"kirim","subtitle":"subjudul","tutorial":"tutorial","validate":"mengesahkan"},"emergency":{"samu":"S.A.M.U.","police":"POLISI","firefighter":"petugas pemadam kebakaran","general":"umum","citypolice":"Polisi setempat","hospital":"RSUD","homeless":"Tunawisma (panggilan gratis)","poison":"Pusat Pengendalian Racun","emergency":"keadaan darurat Eropa"},"error":{"title":"Sebuah kesalahan telah terjadi","button":"Luncurkan kembali aplikasi"},"history":{"title":"riwayat percakapan"},"inputs":{"choose":"Pilih jawaban"},"language":{"change":"mengubah bahasa","select":"pilih bahasa yang ingin Anda gunakan"},"link":{"buttontext":"Lihat dokumennya","goto":"Pergi ke alamat","click":"klik disini","scanQR":"dengan memindai QrCode","scanQRTile":"Pindai Kode QR untuk menemukan"},"loader":{"loader":{"optimal":"Untuk pengalaman optimal,","classic":"Untuk pengalaman yang lebih klasik,","vocal":"Saya berbicara tatap muka dengan agen.","text":"Saya berkomunikasi secara tertulis dengan agen."},"modes":{"vocal":"modus vokal","text":"modus teks"},"loaderValidation":"Mulai percakapan","locale":"memeriksa bahasa","supported":"memeriksa bahasa yang didukung","addressdata":"mengambil data"},"menu":{"message":"Masukkan pesan Anda","allowMicrophone":"Izinkan browser Anda menggunakan mikrofon untuk melanjutkan","back":"kembali","backconversation":"kembali ke percakapan","close":"menutup","answer":" menjawab pertanyaan Anda"},"mobileLandscapePreventer":{"firstline":"Untuk pengalaman optimal,","secondline":"balik layar Anda"},"news":{"warningtext":"Anda akan mengakses saluran berita, suara di perangkat Anda akan diaktifkan","live":"hidup","continuous":"terus menerus"},"poi":{"comment":"ulasan pelanggan","route":"jalan","nodata":"Tidak ada konten yang cocok dengan pencarian Anda","openinghours":"Jam buka","prices":"Harga","paymentmethods":"Cara Pembayaran","numberofplaces":"sejumlah tempat","openroutemobile":"buka rute Google Maps di smartphone","FoodEstablishment":"Tempat makan","LodgingBusiness":"Tempat tidur","TouristDestination":"Apa yang dilihat","TouristAttraction":"Apa yang harus dilakukan","Product":"Produk lokal","Service":"Jasa","Event":"Acara","City":"kota","Wine":"Anggur"},"suggestion":{"consult":"Periksa","thetutorial":"tutorialnya"},"template":{"reset":"atur ulang semua","showresults":"Tunjukkan hasilnya","suggestiontitle":"Saran pencarian","reminder":"Jangan lupa, \\n saya bisa menjawab pertanyaan Anda."}}');


var $62f9aaaa306924ca$exports = {};
$62f9aaaa306924ca$exports = JSON.parse('{"1":"pagina iniziale","2":"canale di notizie in diretta","3":"bollettino meteorologico","4":"Numeri di emergenza","1000":"storico","1001":"tutorial","common":{"all":"tutti","back":"Indietro","close":"chiudere","continue":"continuare","download":"scaricamento","downloadsheet":"scarica questa scheda","downloadsheetmobile":"scarica questa scheda sullo smartphone","filter":"Filtro","history":"storico","lang":"lingua","menu":"men\xf9","mode":"moda","needhelp":"Ho bisogno di aiuto?","parameters":"impostazioni","print":"Stampa","printsheet":"Stampa questo foglio","result":"risultato","results":"risultati","singleLang":"Lingua","sound":"suo","submit":"invia","subtitle":"sottotitolo","tutorial":"tutorial","validate":"convalidare"},"emergency":{"samu":"S.A.M.U.","police":"Polizia Stradale","firefighter":"vigili del fuoco","general":"generale","citypolice":"Polizia locale","hospital":"Ospedale","homeless":"Senzatetto (chiamata gratuita)","poison":"Centro antiveleni","emergency":"Emergenze europee"},"error":{"title":"C\'\xe8 stato un errore","button":"Riavviare l\'applicazione"},"history":{"title":"cronologia delle conversazioni"},"inputs":{"choose":"Scegli una risposta"},"language":{"change":"cambiare la lingua","select":"seleziona la lingua che desideri utilizzare"},"link":{"buttontext":"Visualizza il documento","goto":"Vai all\'indirizzo","click":"clicca qui","scanQR":"scansionando il QrCode","scanQRTile":"Scansiona il QR Code per scoprire"},"loader":{"loader":{"optimal":"Per un\'esperienza ottimale,","classic":"Per un\'esperienza pi\xf9 classica,","vocal":"Parlo faccia a faccia con l\'agente.","text":"Comunico per iscritto con l\'agente."},"modes":{"vocal":"modalit\xe0 vocale","text":"modalit\xe0 testo"},"loaderValidation":"Inizia la conversazione","locale":"controllo della lingua","supported":"verifica delle lingue supportate","addressdata":"recupero dati"},"menu":{"message":"Inserisci il tuo messaggio","allowMicrophone":"Consenti al tuo browser di utilizzare il microfono per continuare","backconversation":"torniamo alla conversazione","answer":" risponde alle tue domande"},"mobileLandscapePreventer":{"firstline":"Per un\'esperienza ottimale,","secondline":"capovolgi lo schermo"},"news":{"warningtext":"Accederai al canale delle notizie, l\'audio sul tuo dispositivo verr\xe0 attivato","live":"vivere","continuous":"continuamente"},"poi":{"comment":"recensione del cliente","route":"strada","nodata":"Nessun contenuto corrisponde alla tua ricerca","openinghours":"Orari di apertura","prices":"Prezzi","paymentmethods":"Modalit\xe0 di pagamento","numberofplaces":"numero di posti","openroutemobile":"apri il percorso di Google Maps sullo smartphone","FoodEstablishment":"Dove mangiare","LodgingBusiness":"Dove dormire","TouristDestination":"Cosa guardare","TouristAttraction":"Cosa fare","Product":"Prodotti locali","Service":"Servizi","Event":"Eventi","City":"Citt\xe0","Wine":"Vini"},"suggestion":{"consult":"Guardare","thetutorial":"il tutorial"},"template":{"reset":"resetta tutto","showresults":"Mostra i risultati","suggestiontitle":"Suggerimenti per la ricerca","reminder":"Non dimenticare, \\n posso rispondere alle tue domande."}}');


var $ce2c38c9bab3aa30$exports = {};
$ce2c38c9bab3aa30$exports = JSON.parse('{"1":"\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8","2":"\u30E9\u30A4\u30D6\u30CB\u30E5\u30FC\u30B9\u30C1\u30E3\u30F3\u30CD\u30EB","3":"\u5929\u6C17\u4E88\u5831","4":"\u7DCA\u6025\u96FB\u8A71\u756A\u53F7","1000":"\u6B74\u53F2\u7684\u306A","1001":"\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB","common":{"all":"\u5168\u3066","back":"\u623B\u308B","close":"\u8FD1\u3044","continue":"\u7D9A\u304F","download":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","downloadsheet":"\u3053\u306E\u30B7\u30FC\u30C8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","downloadsheetmobile":"\u3053\u306E\u30B7\u30FC\u30C8\u3092\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","history":"\u6B74\u53F2\u7684\u306A","lang":"\u8A00\u8A9E","menu":"\u30E1\u30CB\u30E5\u30FC","mode":"\u30D5\u30A1\u30C3\u30B7\u30E7\u30F3","needhelp":"\u52A9\u3051\u304C\u5FC5\u8981\uFF1F","parameters":"\u8A2D\u5B9A","print":"\u5370\u5237\u3059\u308B","printsheet":"\u3053\u306E\u30B7\u30FC\u30C8\u3092\u5370\u5237\u3059\u308B","result":"\u7D50\u679C","results":"\u7D50\u679C","singleLang":"\u8A00\u8A9E","sound":"\u5F7C\u5973","submit":"\u63D0\u51FA\u3059\u308B","subtitle":"\u5B57\u5E55","tutorial":"\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB","validate":"\u691C\u8A3C"},"emergency":{"samu":"S.A.M.U","police":"\u8B66\u5BDF","firefighter":"\u6D88\u9632\u58EB","general":"\u4E00\u822C\u7684\u306A","citypolice":"\u5730\u5143\u8B66\u5BDF","hospital":"\u75C5\u9662","homeless":"\u30DB\u30FC\u30E0\u30EC\u30B9\uFF08\u7121\u6599\u901A\u8A71\uFF09","poison":"\u6BD2\u7269\u7BA1\u7406\u30BB\u30F3\u30BF\u30FC","emergency":"\u30E8\u30FC\u30ED\u30C3\u30D1\u306E\u7DCA\u6025\u4E8B\u614B"},"error":{"title":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","button":"\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u518D\u8D77\u52D5\u3059\u308B"},"history":{"title":"\u4F1A\u8A71\u5C65\u6B74"},"inputs":{"choose":"\u7B54\u3048\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"},"language":{"change":"\u8A00\u8A9E\u3092\u5909\u3048\u308B","select":"\u4F7F\u7528\u3057\u305F\u3044\u8A00\u8A9E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"},"link":{"buttontext":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u898B\u308B","goto":"\u4F4F\u6240\u306B\u79FB\u52D5","click":"\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF","scanQR":"QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3059\u308B\u3053\u3068\u3067","scanQRTile":"QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u767A\u898B\u3059\u308B"},"loader":{"loader":{"optimal":"\u6700\u9069\u306A\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306B\u3001","classic":"\u3088\u308A\u30AF\u30E9\u30B7\u30C3\u30AF\u306A\u4F53\u9A13\u3092\u3059\u308B\u306B\u306F\u3001","vocal":"\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3068\u5BFE\u9762\u3067\u8A71\u3057\u307E\u3059\u3002","text":"\u79C1\u306F\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3068\u66F8\u9762\u3067\u3084\u308A\u53D6\u308A\u3057\u307E\u3059\u3002"},"modes":{"vocal":"\u30DC\u30FC\u30AB\u30EB\u30E2\u30FC\u30C9","text":"\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9"},"loaderValidation":"\u4F1A\u8A71\u3092\u958B\u59CB\u3059\u308B","locale":"\u8A00\u8A9E\u3092\u30C1\u30A7\u30C3\u30AF\u3059\u308B","supported":"\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u8A00\u8A9E\u3092\u78BA\u8A8D\u3059\u308B","addressdata":"\u30C7\u30FC\u30BF\u306E\u53D6\u5F97"},"menu":{"message":"\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","allowMicrophone":"\u7D9A\u884C\u3059\u308B\u306B\u306F\u30D6\u30E9\u30A6\u30B6\u306B\u30DE\u30A4\u30AF\u306E\u4F7F\u7528\u3092\u8A31\u53EF\u3057\u307E\u3059","backconversation":"\u4F1A\u8A71\u306B\u623B\u308A\u307E\u3059","answer":" \u3042\u306A\u305F\u306E\u8CEA\u554F\u306B\u7B54\u3048\u307E\u3059"},"mobileLandscapePreventer":{"firstline":"\u6700\u9069\u306A\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306B\u3001","secondline":"\u753B\u9762\u3092\u53CD\u8EE2\u3057\u3066\u304F\u3060\u3055\u3044"},"news":{"warningtext":"\u30CB\u30E5\u30FC\u30B9\u30C1\u30E3\u30F3\u30CD\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u3068\u3001\u30C7\u30D0\u30A4\u30B9\u306E\u30B5\u30A6\u30F3\u30C9\u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u306A\u308A\u307E\u3059","live":"\u30E9\u30A4\u30D6","continuous":"\u7D99\u7D9A\u7684\u306B"},"poi":{"comment":"\u30AB\u30B9\u30BF\u30DE\u30FC\u30EC\u30D3\u30E5\u30FC","route":"\u9053","nodata":"\u691C\u7D22\u306B\u4E00\u81F4\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u3042\u308A\u307E\u305B\u3093","openinghours":"\u55B6\u696D\u6642\u9593","prices":"\u4FA1\u683C","paymentmethods":"\u304A\u652F\u6255\u3044\u65B9\u6CD5","numberofplaces":"\u5834\u6240\u306E\u6570","openroutemobile":"\u30B9\u30DE\u30DB\u3067Google\u30DE\u30C3\u30D7\u306E\u30EB\u30FC\u30C8\u3092\u958B\u304F","FoodEstablishment":"\u3069\u3053\u3067\u98DF\u3079\u307E\u3059","LodgingBusiness":"\u3069\u3053\u3067\u5BDD\u308B\u304B","TouristDestination":"\u898B\u308B\u3079\u304D\u3082\u306E","TouristAttraction":"\u4F55\u3092\u3059\u308B\u304B","Product":"\u5730\u5143\u306E\u7279\u7523\u54C1","Service":"\u30B5\u30FC\u30D3\u30B9","Event":"\u30A4\u30D9\u30F3\u30C8","City":"\u90FD\u5E02","Wine":"\u30EF\u30A4\u30F3"},"suggestion":{"consult":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8","thetutorial":"\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB"},"template":{"reset":"\u3059\u3079\u3066\u30EA\u30BB\u30C3\u30C8","showresults":"\u7D50\u679C\u3092\u8868\u793A\u3059\u308B","suggestiontitle":"\u691C\u7D22\u5019\u88DC","reminder":"\u5FD8\u308C\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3001\\n \u3042\u306A\u305F\u306E\u8CEA\u554F\u306B\u7B54\u3048\u307E\u3059\u3002"}}');


var $b39f24ced614226f$exports = {};
$b39f24ced614226f$exports = JSON.parse('{"1":"\uD648\uD398\uC774\uC9C0","2":"\uB77C\uC774\uBE0C \uB274\uC2A4 \uCC44\uB110","3":"\uC77C\uAE30 \uC608\uBCF4","4":"\uAE34\uAE09 \uC804\uD654\uBC88\uD638","1000":"\uC5ED\uC0AC\uC801\uC778","1001":"\uC9C0\uB3C4 \uC2DC\uAC04","common":{"all":"\uBAA8\uB450","back":"\uB4A4\uCABD\uC5D0","close":"\uB2EB\uB2E4","continue":"\uACC4\uC18D\uD558\uB2E4","download":"\uB2E4\uC6B4\uB85C\uB4DC","downloadsheet":"\uC774 \uC2DC\uD2B8 \uB2E4\uC6B4\uB85C\uB4DC","downloadsheetmobile":"\uC774 \uC2DC\uD2B8\uB97C \uC2A4\uB9C8\uD2B8\uD3F0\uC5D0 \uB2E4\uC6B4\uB85C\uB4DC\uD558\uC138\uC694","filter":"\uD544\uD130","history":"\uC5ED\uC0AC\uC801\uC778","lang":"\uC5B8\uC5B4","menu":"\uBA54\uB274","mode":"\uD328\uC158","needhelp":"\uB3C4\uC6C0\uC774 \uD544\uC694\uD558\uB2E4?","parameters":"\uC124\uC815","print":"\uC778\uC1C4","printsheet":"\uC774 \uC2DC\uD2B8\uB97C \uC778\uC1C4\uD558\uC138\uC694","result":"\uACB0\uACFC","results":"\uACB0\uACFC","singleLang":"\uC5B8\uC5B4","sound":"\uADF8\uB140\uC758","submit":"\uC81C\uCD9C\uD558\uB2E4","subtitle":"\uBD80\uC81C","tutorial":"\uC9C0\uB3C4 \uC2DC\uAC04","validate":"\uD655\uC778"},"emergency":{"samu":"S.A.M.U.","police":"\uACBD\uCC30","firefighter":"\uC18C\uBC29\uAD00","general":"\uC77C\uBC18\uC801\uC778","hospital":"\uBCD1\uC6D0","homeless":"\uB178\uC219\uC790","poison":"\uB3C5\uADF9\uBB3C \uAD00\uB9AC \uC13C\uD130","emergency":"\uAE34\uAE09 \uC0C1\uD669"},"error":{"title":"\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4","button":"\uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC744 \uB2E4\uC2DC \uC2DC\uC791\uD558\uC138\uC694."},"history":{"title":"\uB300\uD654 \uAE30\uB85D"},"inputs":{"choose":"\uB2F5\uBCC0\uC744 \uC120\uD0DD\uD558\uC138\uC694"},"language":{"change":"\uC5B8\uC5B4\uB97C \uBC14\uAFD4\uB77C","select":"\uC0AC\uC6A9\uD558\uACE0 \uC2F6\uC740 \uC5B8\uC5B4\uB97C \uC120\uD0DD\uD558\uC138\uC694"},"link":{"buttontext":"\uBB38\uC11C \uBCF4\uAE30","goto":"\uC8FC\uC18C\uB85C \uC774\uB3D9","click":"\uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC138\uC694","scanQR":"QrCode\uB97C \uC2A4\uCE94\uD558\uC5EC","scanQRTile":"QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC5EC \uBC1C\uACAC\uD558\uB2E4"},"loader":{"loader":{"optimal":"\uCD5C\uC801\uC758 \uACBD\uD5D8\uC744 \uC704\uD574,","classic":"\uC880 \uB354 \uD074\uB798\uC2DD\uD55C \uACBD\uD5D8\uC744 \uC6D0\uD558\uC2E0\uB2E4\uBA74,","vocal":"\uC800\uB294 \uC0C1\uB2F4\uC6D0\uACFC \uC9C1\uC811 \uB300\uBA74\uD558\uC5EC \uC774\uC57C\uAE30\uD569\uB2C8\uB2E4.","text":"\uB098\uB294 \uB300\uB9AC\uC778\uACFC \uC11C\uBA74\uC73C\uB85C \uC758\uC0AC\uC18C\uD1B5\uD569\uB2C8\uB2E4."},"modes":{"vocal":"\uBCF4\uCEEC \uBAA8\uB4DC","text":"\uD14D\uC2A4\uD2B8 \uBAA8\uB4DC"},"loaderValidation":"\uB300\uD654 \uC2DC\uC791","locale":"\uC5B8\uC5B4 \uD655\uC778","supported":"\uC9C0\uC6D0\uB418\uB294 \uC5B8\uC5B4 \uD655\uC778","addressdata":"\uB370\uC774\uD130 \uAC80\uC0C9"},"menu":{"message":"\uBA54\uC2DC\uC9C0\uB97C \uC785\uB825\uD558\uC138\uC694","allowMicrophone":"\uACC4\uC18D\uD558\uB824\uBA74 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uB9C8\uC774\uD06C\uB97C \uC0AC\uC6A9\uD558\uB3C4\uB85D \uD5C8\uC6A9\uD558\uC138\uC694.","backconversation":"\uB300\uD654\uB85C \uB3CC\uC544\uAC00\uC11C","answer":" \uADC0\uD558\uC758 \uC9C8\uBB38\uC5D0 \uB2F5\uBCC0"},"mobileLandscapePreventer":{"firstline":"\uCD5C\uC801\uC758 \uACBD\uD5D8\uC744 \uC704\uD574,","secondline":"\uD654\uBA74\uC744 \uB4A4\uC9D1\uC5B4"},"news":{"warningtext":"\uB274\uC2A4 \uCC44\uB110\uC5D0 \uC811\uC18D\uD558\uAC8C \uB418\uBA70 \uAE30\uAE30\uC758 \uC18C\uB9AC\uAC00 \uD65C\uC131\uD654\uB429\uB2C8\uB2E4.","live":"\uC0B4\uB2E4","continuous":"\uACC4\uC18D\uD574\uC11C"},"poi":{"comment":"\uACE0\uAC1D \uB9AC\uBDF0","route":"\uB3C4\uB85C","nodata":"\uAC80\uC0C9\uC5B4\uC640 \uC77C\uCE58\uD558\uB294 \uCF58\uD150\uCE20\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.","openinghours":"\uAC1C\uAD00 \uC2DC\uAC04","prices":"\uBB3C\uAC00","paymentmethods":"\uACB0\uC81C \uBC29\uBC95","numberofplaces":"\uC7A5\uC18C\uC758 \uC218","openroutemobile":"\uC2A4\uB9C8\uD2B8\uD3F0\uC5D0\uC11C Google \uC9C0\uB3C4 \uACBD\uB85C \uC5F4\uAE30","FoodEstablishment":"\uBA39\uC744 \uACF3","LodgingBusiness":"\uC7A0\uC744 \uC798 \uACF3","TouristDestination":"\uBB34\uC5C7\uC744 \uBCFC \uAC83\uC778\uAC00","TouristAttraction":"\uD574\uC57C \uD560 \uC77C","Product":"\uC9C0\uC5ED\uC0C1\uD488","Service":"\uC11C\uBE44\uC2A4","Event":"\uC774\uBCA4\uD2B8","City":"\uB3C4\uC2DC","Wine":"\uC640\uC778"},"suggestion":{"consult":"\uD655\uC778\uD574 \uBCF4\uC138\uC694","thetutorial":"\uD29C\uD1A0\uB9AC\uC5BC"},"template":{"reset":"\uBAA8\uB450 \uCD08\uAE30\uD654","showresults":"\uACB0\uACFC \uD45C\uC2DC","suggestiontitle":"\uAC80\uC0C9 \uC81C\uC548","reminder":"\uC78A\uC9C0 \uB9C8\uC138\uC694. \\n \uC81C\uAC00 \uADC0\uD558\uC758 \uC9C8\uBB38\uC5D0 \uB2F5\uBCC0\uD574\uB4DC\uB9B4 \uC218 \uC788\uC2B5\uB2C8\uB2E4."}}');


var $ede0ca3632345ca8$exports = {};
$ede0ca3632345ca8$exports = JSON.parse('{"1":"hjemmeside","2":"direktesendt nyhetskanal","3":"V\xe6rmelding","4":"N\xf8dnumre","1000":"historisk","1001":"oppl\xe6ringen","common":{"all":"alle","back":"tilbake","close":"Lukk","continue":"Fortsette","download":"nedlasting","downloadsheet":"last ned dette arket","downloadsheetmobile":"last ned dette arket p\xe5 smarttelefonen","filter":"Filter","history":"historisk","lang":"spr\xe5kene","menu":"Meny","mode":"mote","needhelp":"Trenger hjelp?","parameters":"innstillinger","print":"Skrive ut","printsheet":"Skriv ut dette arket","result":"resultat","results":"resultater","singleLang":"spr\xe5k","sound":"henne","submit":"sende inn","subtitle":"undertekst","tutorial":"oppl\xe6ringen","validate":"\xe5 validere"},"emergency":{"samu":"S.A.M.U.","police":"politiet","firefighter":"brannmenn","general":"generell","hospital":"Sykehus","homeless":"Hjeml\xf8s","poison":"Giftkontrollsenter","emergency":"N\xf8dhjelp"},"error":{"title":"Det har oppst\xe5tt en feil","button":"Start applikasjonen p\xe5 nytt"},"history":{"title":"samtalehistorikk"},"inputs":{"choose":"Velg et svar"},"language":{"change":"endre spr\xe5ket","select":"velg spr\xe5ket du \xf8nsker"},"link":{"buttontext":"Se dokumentet","goto":"G\xe5 til adressen","click":"Klikk her","scanQR":"ved \xe5 skanne QRCode","scanQRTile":"Skann QR-koden for \xe5 oppdage"},"loader":{"loader":{"optimal":"For en optimal opplevelse,","classic":"For en mer klassisk opplevelse,","vocal":"Jeg snakker ansikt til ansikt med agenten.","text":"Jeg kommuniserer skriftlig med agenten."},"modes":{"vocal":"vokalmodus","text":"tekstmodus"},"loaderValidation":"Start samtale","locale":"sjekke spr\xe5k","supported":"sjekke st\xf8ttede spr\xe5k","addressdata":"henter data"},"menu":{"message":"Skriv inn meldingen din","allowMicrophone":"La nettleseren din bruke mikrofonen for \xe5 fortsette","backconversation":"tilbake til samtalen","answer":" svarer p\xe5 sp\xf8rsm\xe5lene dine"},"mobileLandscapePreventer":{"firstline":"For en optimal opplevelse,","secondline":"snu skjermen"},"news":{"warningtext":"Du f\xe5r tilgang til nyhetskanalen, lyden p\xe5 enheten din aktiveres","live":"bo","continuous":"kontinuerlig"},"poi":{"comment":"kundeanmeldelse","route":"vei","nodata":"Ingen innhold samsvarer med s\xf8ket ditt","openinghours":"\xc5pningstider","prices":"Priser","paymentmethods":"Betalingsmetoder","numberofplaces":"antall plasser","openroutemobile":"\xe5pne Google Maps-ruten p\xe5 smarttelefonen","FoodEstablishment":"Hvor skal vi spise","LodgingBusiness":"Hvor skal man sove","TouristDestination":"Hva er det \xe5 se","TouristAttraction":"Hva \xe5 gj\xf8re","Product":"Lokale produkter","Service":"Tjenester","Event":"arrangementer","City":"Byer","Wine":"Viner"},"suggestion":{"consult":"Sjekk ut","thetutorial":"oppl\xe6ringen"},"template":{"reset":"Tilbakestill alt","showresults":"Vis resultatene","suggestiontitle":"S\xf8keforslag","reminder":"Ikke glem, \\n jeg kan svare p\xe5 sp\xf8rsm\xe5lene dine."}}');


var $7d433ccee5b53141$exports = {};
$7d433ccee5b53141$exports = JSON.parse('{"1":"hjemmeside","2":"direktesendt nyhetskanal","3":"V\xe6rmelding","4":"N\xf8dnumre","1000":"historisk","1001":"tutorial","common":{"all":"alle","back":"rug","close":"sluiten","continue":"doorgaan","download":"downloaden","downloadsheet":"download dit blad","downloadsheetmobile":"download dit blad op uw smartphone","filter":"Filter","history":"historisch","lang":"TALEN","menu":"menu","mode":"mode","needhelp":"Hulp nodig?","parameters":"instellingen","print":"Afdrukken","printsheet":"Druk dit blad af","result":"resultaat","results":"resultaten","singleLang":"taal","sound":"zijn","submit":"indienen","subtitle":"ondertitel","tutorial":"zelfstudie","validate":"bevestigen"},"emergency":{"samu":"S.A.M.U.","police":"politie","firefighter":"brandweerlieden","general":"algemeen","hospital":"Ziekenhuis","homeless":"Dakloos","poison":"Vergifcontrolecentrum","emergency":"Hulpdiensten"},"error":{"title":"er is een fout opgetreden","button":"Start de applicatie opnieuw"},"history":{"title":"gespreksgeschiedenis"},"inputs":{"choose":"Kies een antwoord"},"language":{"change":"verander de taal","select":"selecteer de taal van uw keuze"},"link":{"buttontext":"Bekijk het document","goto":"Ga naar adres","click":"Klik hier","scanQR":"door de QRCode te scannen","scanQRTile":"Scan de QR-code om te ontdekken"},"loader":{"loader":{"optimal":"Voor een optimale ervaring,","classic":"Voor een meer klassieke ervaring,","vocal":"Ik spreek oog in oog met de agent.","text":"Ik communiceer schriftelijk met de makelaar."},"modes":{"vocal":"vocale modus","text":"tekstmodus"},"loaderValidation":"Begin een gesprek","locale":"taal controleren","supported":"ondersteunde talen controleren","addressdata":"het ophalen van gegevens"},"menu":{"message":"Voer uw bericht in","allowMicrophone":"Laat uw browser uw microfoon gebruiken om door te gaan","backconversation":"terug naar het gesprek","answer":" beantwoordt uw vragen"},"mobileLandscapePreventer":{"firstline":"Voor een optimale ervaring,","secondline":"draai je scherm om"},"news":{"warningtext":"U krijgt toegang tot de nieuwszender, het geluid op uw apparaat wordt geactiveerd","live":"live","continuous":"doorlopend"},"poi":{"comment":"klant beoordeling","route":"weg","nodata":"Er is geen inhoud die overeenkomt met uw zoekopdracht","openinghours":"Openingstijden","prices":"Prijzen","paymentmethods":"Betaalmethoden","numberofplaces":"aantal plaatsen","openroutemobile":"open Google Maps-route op smartphone","FoodEstablishment":"Waar te eten","LodgingBusiness":"Waar te slapen","TouristDestination":"Wat te zien","TouristAttraction":"Wat moeten we doen","Product":"Regionale producten","Service":"Diensten","Event":"Evenementen","City":"Steden","Wine":"Wijnen"},"suggestion":{"consult":"Uitchecken","thetutorial":"de tutorial"},"template":{"reset":"alles resetten","showresults":"Laat de resultaten zien","suggestiontitle":"Zoeksuggesties","reminder":"Vergeet niet dat ik je vragen kan beantwoorden."}}');


var $4459987f50724095$exports = {};
$4459987f50724095$exports = JSON.parse('{"1":"hjemmeside","2":"direktesendt nyhetskanal","3":"V\xe6rmelding","4":"N\xf8dnumre","1000":"historisk","1001":"tutorial","common":{"all":"alle","back":"rug","close":"sluiten","continue":"doorgaan","download":"downloaden","downloadsheet":"download dit blad","downloadsheetmobile":"download dit blad op uw smartphone","filter":"Filter","history":"historisch","lang":"TALEN","menu":"menu","mode":"mode","needhelp":"Hulp nodig?","parameters":"instellingen","print":"Afdrukken","printsheet":"Druk dit blad af","result":"resultaat","results":"resultaten","singleLang":"taal","sound":"zijn","submit":"indienen","subtitle":"ondertitel","tutorial":"zelfstudie","validate":"bevestigen"},"emergency":{"samu":"S.A.M.U.","police":"politie","firefighter":"brandweerlieden","general":"algemeen","hospital":"Ziekenhuis","homeless":"Dakloos","poison":"Vergifcontrolecentrum","emergency":"Hulpdiensten"},"error":{"title":"er is een fout opgetreden","button":"Start de applicatie opnieuw"},"history":{"title":"gespreksgeschiedenis"},"inputs":{"choose":"Kies een antwoord"},"language":{"change":"verander de taal","select":"selecteer de taal van uw keuze"},"link":{"buttontext":"Bekijk het document","goto":"Ga naar adres","click":"Klik hier","scanQR":"door de QRCode te scannen","scanQRTile":"Scan de QR-code om te ontdekken"},"loader":{"loader":{"optimal":"Voor een optimale ervaring,","classic":"Voor een meer klassieke ervaring,","vocal":"Ik spreek oog in oog met de agent.","text":"Ik communiceer schriftelijk met de makelaar."},"modes":{"vocal":"vocale modus","text":"tekstmodus"},"loaderValidation":"Begin een gesprek","locale":"taal controleren","supported":"ondersteunde talen controleren","addressdata":"het ophalen van gegevens"},"menu":{"message":"Voer uw bericht in","allowMicrophone":"Laat uw browser uw microfoon gebruiken om door te gaan","backconversation":"terug naar het gesprek","answer":" beantwoordt uw vragen"},"mobileLandscapePreventer":{"firstline":"Voor een optimale ervaring,","secondline":"draai je scherm om"},"news":{"warningtext":"U krijgt toegang tot de nieuwszender, het geluid op uw apparaat wordt geactiveerd","live":"live","continuous":"doorlopend"},"poi":{"comment":"klant beoordeling","route":"weg","nodata":"Er is geen inhoud die overeenkomt met uw zoekopdracht","openinghours":"Openingstijden","prices":"Prijzen","paymentmethods":"Betaalmethoden","numberofplaces":"aantal plaatsen","openroutemobile":"open Google Maps-route op smartphone","FoodEstablishment":"Waar te eten","LodgingBusiness":"Waar te slapen","TouristDestination":"Wat te zien","TouristAttraction":"Wat moeten we doen","Product":"Regionale producten","Service":"Diensten","Event":"Evenementen","City":"Steden","Wine":"Wijnen"},"suggestion":{"consult":"Uitchecken","thetutorial":"de tutorial"},"template":{"reset":"alles resetten","showresults":"Laat de resultaten zien","suggestiontitle":"Zoeksuggesties","reminder":"Vergeet niet dat ik je vragen kan beantwoorden."}}');


var $fb57665a54fe923c$exports = {};
$fb57665a54fe923c$exports = JSON.parse('{"1":"strona g\u0142\xf3wna","2":"kana\u0142 informacyjny na \u017Cywo","3":"pogoda","4":"numery alarmowe","1000":"historia","1001":"instrukta\u017C","common":{"all":"Wszystko","back":"z powrotem","close":"zamkn\u0105\u0107","continue":"Kontynuowa\u0107","download":"pobiera\u0107","downloadsheet":"pobierz ten arkusz","downloadsheetmobile":"pobierz ten arkusz na smartfonie","filter":"Filtr","history":"historyczny","lang":"J\u0119zyki","menu":"menu","mode":"moda","needhelp":"Potrzebuj\u0119 pomocy?","parameters":"ustawienia","print":"Wydrukowa\u0107","printsheet":"Wydrukuj ten arkusz","result":"wynik","results":"wyniki","singleLang":"j\u0119zyk","sound":"jej","submit":"sk\u0142ada\u0107","subtitle":"podtytu\u0142","tutorial":"instrukta\u017C","validate":"potwierdzi\u0107"},"emergency":{"samu":"S.A.M.U.","police":"Policja","firefighter":"stra\u017Cacy","general":"og\xf3lny","hospital":"Szpital","homeless":"Bezdomny","poison":"Centrum Kontroli Trucizn","emergency":"S\u0142u\u017Cby ratunkowe"},"error":{"title":"Wyst\u0105pi\u0142 b\u0142\u0105d","button":"Uruchom ponownie aplikacj\u0119"},"history":{"title":"Historia konwersacji"},"inputs":{"choose":"Wybierz odpowied\u017A"},"language":{"change":"zmieni\u0107 j\u0119zyk","select":"wybierz wybrany j\u0119zyk"},"link":{"buttontext":"Obejrzyj dokument","goto":"Przejd\u017A do adresu","click":"Kliknij tutaj","scanQR":"poprzez zeskanowanie kodu QR","scanQRTile":"Zeskanuj kod QR, aby odkry\u0107"},"loader":{"loader":{"optimal":"Aby uzyska\u0107 optymalne wra\u017Cenia,","classic":"Aby uzyska\u0107 bardziej klasyczne wra\u017Cenia,","vocal":"Rozmawiam twarz\u0105 w twarz z agentem.","text":"Komunikuj\u0119 si\u0119 pisemnie z agentem."},"modes":{"vocal":"tryb wokalny","text":"tryb tekstowy"},"loaderValidation":"Rozpocznij rozmow\u0119","locale":"sprawdzanie j\u0119zyka","supported":"sprawdzanie obs\u0142ugiwanych j\u0119zyk\xf3w","addressdata":"pobieranie danych"},"menu":{"message":"Wpisz swoj\u0105 wiadomo\u015B\u0107","allowMicrophone":"Aby kontynuowa\u0107, zezw\xf3l przegl\u0105darce na korzystanie z mikrofonu","backconversation":"wr\xf3\u0107 do rozmowy","answer":" odpowiada na Twoje pytania"},"mobileLandscapePreventer":{"firstline":"Aby uzyska\u0107 optymalne wra\u017Cenia,","secondline":"obr\xf3\u0107 ekran"},"news":{"warningtext":"Uzyskasz dost\u0119p do kana\u0142u informacyjnego, d\u017Awi\u0119k na Twoim urz\u0105dzeniu zostanie aktywowany","live":"na \u017Cywo","continuous":"bez przerwy"},"poi":{"comment":"Recenzja klienta","route":"droga","nodata":"\u017Badna tre\u015B\u0107 nie pasuje do Twojego wyszukiwania","openinghours":"Godziny otwarcia","prices":"Ceny","paymentmethods":"Metody P\u0142atno\u015Bci","numberofplaces":"liczba miejsc","openroutemobile":"otw\xf3rz tras\u0119 Map Google na smartfonie","FoodEstablishment":"Gdzie zje\u015B\u0107","LodgingBusiness":"Gdzie spa\u0107","TouristDestination":"Co zobaczy\u0107","TouristAttraction":"Co robi\u0107","Product":"Lokalne produkty","Service":"Us\u0142ugi","Event":"Wydarzenia","City":"Miasta","Wine":"Wina"},"suggestion":{"consult":"Wymeldowa\u0107 si\u0119","thetutorial":"samouczek"},"template":{"reset":"Zresetowa\u0107 wszystko","showresults":"Poka\u017C wyniki","suggestiontitle":"Wyszukaj sugestie","reminder":"Nie zapomnij, \\n, \u017Ce mog\u0119 odpowiedzie\u0107 na Twoje pytania."}}');


var $c7271d95c1c7c5e6$exports = {};
$c7271d95c1c7c5e6$exports = JSON.parse('{"1":"pagina inicial","2":"canal de informa\xe7\xf5es ao vivo","3":"clima","4":"N\xfameros de emerg\xeancia","1000":"hist\xf3ria","1001":"tutorial","common":{"all":"todos","back":"voltar","close":"fechar","continue":"continuar","download":"download","downloadsheet":"baixe esta planilha","downloadsheetmobile":"baixe esta planilha no smartphone","filter":"filtro","history":"hist\xf3rico","lang":"l\xednguas","menu":"card\xe1pio","mode":"moda","needhelp":"Preciso de ajuda?","parameters":"configura\xe7\xf5es","print":"Imprimir","printsheet":"Imprima esta folha","result":"resultado","results":"resultados","singleLang":"linguagem","sound":"dela","submit":"enviar","subtitle":"legenda","tutorial":"tutorial","validate":"validar"},"emergency":{"samu":"S.A.M.U.","police":"pol\xedcia","firefighter":"bombeiros","general":"general","hospital":"Hospital","homeless":"Morador de rua","poison":"Centro de Controle de Venenos","emergency":"Servi\xe7os de emerg\xeancia"},"error":{"title":"ocorreu um erro","button":"Reinicie o aplicativo"},"history":{"title":"hist\xf3rico de conversas"},"inputs":{"choose":"Escolha uma resposta"},"language":{"change":"alterar o idioma","select":"selecione o idioma de sua prefer\xeancia"},"link":{"buttontext":"Veja o documento","goto":"Ir para o endere\xe7o","click":"Clique aqui","scanQR":"digitalizando o QrCode","scanQRTile":"Escaneie o c\xf3digo QR para descobrir"},"loader":{"loader":{"optimal":"Para uma experi\xeancia ideal,","classic":"Para uma experi\xeancia mais cl\xe1ssica,","vocal":"Falo cara a cara com o agente.","text":"Eu me comunico por escrito com o agente."},"modes":{"vocal":"modo vocal","text":"modo de texto"},"loaderValidation":"Iniciar conversa","locale":"verificando o idioma","supported":"verificando idiomas suportados","addressdata":"recuperando dados"},"menu":{"message":"Digite sua mensagem","allowMicrophone":"Permita que seu navegador use seu microfone para continuar","backconversation":"de volta \xe0 conversa","answer":" responde \xe0s suas perguntas"},"mobileLandscapePreventer":{"firstline":"Para uma experi\xeancia ideal,","secondline":"vire sua tela"},"news":{"warningtext":"Voc\xea acessar\xe1 o canal de not\xedcias, o som do seu aparelho ser\xe1 ativado","live":"ao vivo","continuous":"continuamente"},"poi":{"comment":"avalia\xe7\xe3o do cliente","route":"estrada","nodata":"Nenhum conte\xfado corresponde \xe0 sua pesquisa","openinghours":"Hor\xe1rio de funcionamento","prices":"Pre\xe7os","paymentmethods":"M\xe9todos de Pagamento","numberofplaces":"n\xfamero de lugares","openroutemobile":"abra a rota do Google Maps no smartphone","FoodEstablishment":"Onde comer","LodgingBusiness":"Onde dormir","TouristDestination":"O que ver","TouristAttraction":"O que fazer","Product":"Produtos locais","Service":"Servi\xe7os","Event":"Eventos","City":"Cidades","Wine":"Vinhos"},"suggestion":{"consult":"Confira","thetutorial":"o tutorial"},"template":{"reset":"reiniciar tudo","showresults":"Mostrar os resultados","suggestiontitle":"Sugest\xf5es de pesquisa","reminder":"N\xe3o se esque\xe7a, \\n, posso responder \xe0s suas perguntas."}}');


var $6ca0c53809a587dc$exports = {};
$6ca0c53809a587dc$exports = JSON.parse('{"1":"pagina inicial","2":"canal de informa\xe7\xf5es ao vivo","3":"clima","4":"N\xfameros de emerg\xeancia","1000":"hist\xf3ria","1001":"tutorial","common":{"all":"todos","back":"voltar","close":"fechar","continue":"continuar","download":"download","downloadsheet":"baixe esta planilha","downloadsheetmobile":"baixe esta planilha no smartphone","filter":"filtro","history":"hist\xf3rico","lang":"l\xednguas","menu":"card\xe1pio","mode":"moda","needhelp":"Preciso de ajuda?","parameters":"configura\xe7\xf5es","print":"Imprimir","printsheet":"Imprima esta folha","result":"resultado","results":"resultados","singleLang":"linguagem","sound":"dela","submit":"enviar","subtitle":"legenda","tutorial":"tutorial","validate":"validar"},"emergency":{"samu":"S.A.M.U.","police":"pol\xedcia","firefighter":"bombeiros","general":"general","hospital":"Hospital","homeless":"Morador de rua","poison":"Centro de Controle de Venenos","emergency":"Servi\xe7os de emerg\xeancia"},"error":{"title":"ocorreu um erro","button":"Reinicie o aplicativo"},"history":{"title":"hist\xf3rico de conversas"},"inputs":{"choose":"Escolha uma resposta"},"language":{"change":"alterar o idioma","select":"selecione o idioma de sua prefer\xeancia"},"link":{"buttontext":"Veja o documento","goto":"Ir para o endere\xe7o","click":"Clique aqui","scanQR":"digitalizando o QrCode","scanQRTile":"Escaneie o c\xf3digo QR para descobrir"},"loader":{"loader":{"optimal":"Para uma experi\xeancia ideal,","classic":"Para uma experi\xeancia mais cl\xe1ssica,","vocal":"Falo cara a cara com o agente.","text":"Eu me comunico por escrito com o agente."},"modes":{"vocal":"modo vocal","text":"modo de texto"},"loaderValidation":"Iniciar conversa","locale":"verificando o idioma","supported":"verificando idiomas suportados","addressdata":"recuperando dados"},"menu":{"message":"Digite sua mensagem","allowMicrophone":"Permita que seu navegador use seu microfone para continuar","backconversation":"de volta \xe0 conversa","answer":" responde \xe0s suas perguntas"},"mobileLandscapePreventer":{"firstline":"Para uma experi\xeancia ideal,","secondline":"vire sua tela"},"news":{"warningtext":"Voc\xea acessar\xe1 o canal de not\xedcias, o som do seu aparelho ser\xe1 ativado","live":"ao vivo","continuous":"continuamente"},"poi":{"comment":"avalia\xe7\xe3o do cliente","route":"estrada","nodata":"Nenhum conte\xfado corresponde \xe0 sua pesquisa","openinghours":"Hor\xe1rio de funcionamento","prices":"Pre\xe7os","paymentmethods":"M\xe9todos de Pagamento","numberofplaces":"n\xfamero de lugares","openroutemobile":"abra a rota do Google Maps no smartphone","FoodEstablishment":"Onde comer","LodgingBusiness":"Onde dormir","TouristDestination":"O que ver","TouristAttraction":"O que fazer","Product":"Produtos locais","Service":"Servi\xe7os","Event":"Eventos","City":"Cidades","Wine":"Vinhos"},"suggestion":{"consult":"Confira","thetutorial":"o tutorial"},"template":{"reset":"reiniciar tudo","showresults":"Mostrar os resultados","suggestiontitle":"Sugest\xf5es de pesquisa","reminder":"N\xe3o se esque\xe7a, \\n, posso responder \xe0s suas perguntas."}}');


var $2182efbf0e72c4fc$exports = {};
$2182efbf0e72c4fc$exports = JSON.parse('{"1":"\u0434\u043E\u043C\u0430\u0448\u043D\u044F\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430","2":"\u043F\u0440\u044F\u043C\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043A\u0430\u043D\u0430\u043B","3":"\u043F\u043E\u0433\u043E\u0434\u0430","4":"\u043D\u043E\u043C\u0435\u0440\u0430 \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u043B\u0443\u0436\u0431","1000":"\u0438\u0441\u0442\u043E\u0440\u0438\u044F","1001":"\u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E","common":{"all":"\u0432\u0441\u0435","back":"\u043D\u0430\u0437\u0430\u0434","close":"\u0437\u0430\u043A\u0440\u044B\u0432\u0430\u0442\u044C","continue":"\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0442\u044C","download":"\u0421\u043A\u0430\u0447\u0430\u0442\u044C","downloadsheet":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u044D\u0442\u043E\u0442 \u043B\u0438\u0441\u0442","downloadsheetmobile":"\u0441\u043A\u0430\u0447\u0430\u0442\u044C \u044D\u0442\u043E\u0442 \u043B\u0438\u0441\u0442 \u043D\u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D","filter":"\u0424\u0438\u043B\u044C\u0442\u0440","history":"\u0438\u0441\u0442\u043E\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0439","lang":"\u042F\u0417\u042B\u041A\u0418","menu":"\u043C\u0435\u043D\u044E","mode":"\u043C\u043E\u0434\u0430","needhelp":"\u041D\u0443\u0436\u043D\u0430 \u043F\u043E\u043C\u043E\u0449\u044C?","parameters":"\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","print":"\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C","printsheet":"\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C \u044D\u0442\u043E\u0442 \u043B\u0438\u0441\u0442","result":"\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442","results":"\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B","singleLang":"\u044F\u0437\u044B\u043A","sound":"\u0437\u0432\u0443\u043A","submit":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C","subtitle":"\u0441\u0443\u0431\u0442\u0438\u0442\u0440\u044B","tutorial":"\u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E","validate":"\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"},"emergency":{"samu":"\u0421.\u0410.\u041C.\u0423.","police":"\u043F\u043E\u043B\u0438\u0446\u0438\u044F","firefighter":"\u043F\u043E\u0436\u0430\u0440\u043D\u044B\u0435","general":"\u043E\u0431\u0449\u0438\u0439","hospital":"\u0411\u043E\u043B\u044C\u043D\u0438\u0446\u0430","homeless":"\u0411\u0435\u0437\u0434\u043E\u043C\u043D\u044B\u0439","poison":"\u0422\u043E\u043A\u0441\u0438\u043A\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0446\u0435\u043D\u0442\u0440","emergency":"\u0410\u0432\u0430\u0440\u0438\u0439\u043D\u044B\u0435 \u0441\u043B\u0443\u0436\u0431\u044B"},"error":{"title":"\u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430","button":"\u041F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435"},"history":{"title":"\u0438\u0441\u0442\u043E\u0440\u0438\u044F \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u043E\u0432"},"inputs":{"choose":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0442\u0432\u0435\u0442"},"language":{"change":"\u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u044F\u0437\u044B\u043A","select":"\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u044F\u0437\u044B\u043A \u043F\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u0432\u044B\u0431\u043E\u0440\u0443"},"link":{"buttontext":"\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442","goto":"\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443","click":"\u043A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u0441\u044E\u0434\u0430","scanQR":"\u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0432 QrCode","scanQRTile":"\u0421\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u0443\u0437\u043D\u0430\u0442\u044C"},"loader":{"loader":{"optimal":"\u0414\u043B\u044F \u043E\u043F\u0442\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u043F\u044B\u0442\u0430,","classic":"\u0414\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u043A\u043B\u0430\u0441\u0441\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u043F\u044B\u0442\u0430,","vocal":"\u042F \u043E\u0431\u0449\u0430\u044E\u0441\u044C, \u0440\u0430\u0437\u0433\u043E\u0432\u0430\u0440\u0438\u0432\u0430\u044F \u0441 \u0430\u0433\u0435\u043D\u0442\u043E\u043C.","text":"\u042F \u043E\u0431\u0449\u0430\u044E\u0441\u044C \u043F\u043E \u0442\u0435\u043A\u0441\u0442\u0443 \u0441 \u0430\u0433\u0435\u043D\u0442\u043E\u043C."},"modes":{"vocal":"\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0439 \u0440\u0435\u0436\u0438\u043C","text":"\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439 \u0440\u0435\u0436\u0438\u043C"},"loaderValidation":"\u041D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440","locale":"\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u044F\u0437\u044B\u043A\u0430","supported":"\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u044B\u0445 \u044F\u0437\u044B\u043A\u043E\u0432","addressdata":"\u0418\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445"},"menu":{"message":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435","allowMicrophone":"\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0432\u0430\u0448\u0435\u043C\u0443 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0443 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.","backconversation":"\u0432\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u0443","answer":" \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u043D\u0430 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B"},"mobileLandscapePreventer":{"firstline":"\u0414\u043B\u044F \u043E\u043F\u0442\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u043F\u044B\u0442\u0430,","secondline":"\u043F\u0435\u0440\u0435\u0432\u0435\u0440\u043D\u0438\u0442\u0435 \u044D\u043A\u0440\u0430\u043D"},"news":{"warningtext":"\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043D\u043E\u0432\u043E\u0441\u0442\u043D\u043E\u043C\u0443 \u043A\u0430\u043D\u0430\u043B\u0443, \u0437\u0432\u0443\u043A \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 \u0431\u0443\u0434\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D.","live":"\u0436\u0438\u0442\u044C","continuous":"\u043D\u0435\u043F\u0440\u0435\u0440\u044B\u0432\u043D\u043E"},"poi":{"comment":"\u043E\u0442\u0437\u044B\u0432 \u043A\u043B\u0438\u0435\u043D\u0442\u0430","route":"\u0434\u043E\u0440\u043E\u0433\u0430","nodata":"\u041D\u0435\u0442 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443","openinghours":"\u0427\u0430\u0441\u044B \u0440\u0430\u0431\u043E\u0442\u044B","prices":"\u0426\u0435\u043D\u044B","paymentmethods":"\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u044B","numberofplaces":"\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043C\u0435\u0441\u0442","openroutemobile":"\u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442 Google Maps \u043D\u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D\u0435","FoodEstablishment":"\u0413\u0434\u0435 \u043F\u043E\u0435\u0441\u0442\u044C","LodgingBusiness":"\u0413\u0434\u0435 \u0441\u043F\u0430\u0442\u044C","TouristDestination":"\u0427\u0442\u043E \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C","TouristAttraction":"\u0427\u0442\u043E \u0434\u0435\u043B\u0430\u0442\u044C","Product":"\u041C\u0435\u0441\u0442\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u044B","Service":"\u0423\u0441\u043B\u0443\u0433\u0438","Event":"\u0421\u043E\u0431\u044B\u0442\u0438\u044F","City":"\u0413\u043E\u0440\u043E\u0434\u0430","Wine":"\u0412\u0438\u043D\u0430"},"suggestion":{"consult":"\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C","thetutorial":"\u0443\u0447\u0435\u0431\u043D\u0438\u043A"},"template":{"reset":"\u0441\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0435","showresults":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B","suggestiontitle":"\u041F\u043E\u0438\u0441\u043A\u043E\u0432\u044B\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F","reminder":"\u041D\u0435 \u0437\u0430\u0431\u044B\u0432\u0430\u0439, \\n \u042F \u043C\u043E\u0433\u0443 \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043D\u0430 \u0442\u0432\u043E\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B."}}');


var $9b81038127634bc3$exports = {};
$9b81038127634bc3$exports = JSON.parse('{"1":"doma\u010Da stran","2":"info kanal v \u017Eivo","3":"vreme","4":"\u0161tevilke za klic v sili","1000":"zgodovina","1001":"vadnica","common":{"all":"vse","close":"blizu","back":"nazaj","continue":"Nadaljuj","download":"prenesi","downloadsheet":"prenesite ta list","downloadsheetmobile":"prenesite ta list na pametni telefon","filter":"Filter","history":"zgodovinski","lang":"jezikov","menu":"meni","mode":"moda","needhelp":"Rabim pomo\u010D?","parameters":"nastavitve","print":"Tiskanje","printsheet":"Natisnite ta list","result":"rezultat","results":"rezultate","singleLang":"jezik","sound":"njo","submit":"Skicka in","subtitle":"podnaslov","tutorial":"vadnica","validate":"potrditi"},"emergency":{"samu":"S.A.M.U.","police":"polis","firefighter":"brandm\xe4n","general":"allm\xe4n","hospital":"Sjukhus","homeless":"Heml\xf6s","poison":"Giftkontrollcenter","emergency":"Akuttj\xe4nster"},"error":{"title":"Ett fel har uppst\xe5tt","button":"Starta om programmet"},"history":{"title":"zgodovino pogovorov"},"inputs":{"choose":"V\xe4lj ett svar"},"language":{"change":"spremenite jezik","select":"izberite jezik po va\u0161i izbiri"},"link":{"buttontext":"Oglejte si dokument","goto":"Pojdi na naslov","click":"Klikni tukaj","scanQR":"s skeniranjem QrCode","scanQRTile":"Skanna QR-koden f\xf6r att uppt\xe4cka"},"loader":{"loader":{"optimal":"Za optimalno izku\u0161njo,","classic":"Za bolj klasi\u010Dno izku\u0161njo,","vocal":"Z agentom se pogovarjam iz o\u010Di v o\u010Di.","text":"Pisno komuniciram z agentom."},"modes":{"vocal":"vokalni na\u010Din","text":"besedilni na\u010Din"},"loaderValidation":"Za\u010Dni pogovor","locale":"preverjanje jezika","supported":"preverjanje podprtih jezikov","addressdata":"pridobivanje podatkov"},"menu":{"message":"Vnesite svoje sporo\u010Dilo","allowMicrophone":"Za nadaljevanje dovolite brskalniku uporabo mikrofona","backconversation":"nazaj k pogovoru","answer":" odgovarja na va\u0161a vpra\u0161anja"},"mobileLandscapePreventer":{"firstline":"Za optimalno izku\u0161njo,","secondline":"obrnite zaslon"},"news":{"warningtext":"Dostopili boste do kanala z novicami, zvok na va\u0161i napravi bo aktiviran","live":"v \u017Eivo","continuous":"neprekinjeno"},"poi":{"comment":"pregled strank","route":"cesta","nodata":"Nobena vsebina se ne ujema z va\u0161im iskanjem","openinghours":"Odpiralni \u010Das","prices":"Cene","paymentmethods":"Na\u010Dini pla\u010Dila","numberofplaces":"\u0161tevilo mest","openroutemobile":"odprite Google Maps route na pametnem telefonu","FoodEstablishment":"Kje jesti","LodgingBusiness":"Kje spati","TouristDestination":"Kaj videti","TouristAttraction":"Kaj storiti","Product":"Lokalni izdelki","Service":"Storitve","Event":"Dogodki","City":"Mesta","Wine":"Vina"},"suggestion":{"consult":"Preveri","thetutorial":"vadnica"},"template":{"reset":"ponastavi vse","showresults":"Poka\u017Ei rezultate","suggestiontitle":"Predlogi za iskanje","reminder":"Ne pozabite, \\n lahko odgovorim na va\u0161a vpra\u0161anja."}}');


var $6dd0dc0dad4d5e5c$exports = {};
$6dd0dc0dad4d5e5c$exports = JSON.parse('{"1":"\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01","2":"\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E14","3":"\u0E2A\u0E20\u0E32\u0E1E\u0E2D\u0E32\u0E01\u0E32\u0E28","4":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E09\u0E38\u0E01\u0E40\u0E09\u0E34\u0E19","1000":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E28\u0E32\u0E2A\u0E15\u0E23\u0E4C","1001":"\u0E01\u0E27\u0E14\u0E27\u0E34\u0E0A\u0E32","common":{"all":"\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","back":"\u0E01\u0E25\u0E31\u0E1A","close":"\u0E1B\u0E34\u0E14","continue":"\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","download":"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14","downloadsheet":"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E19\u0E35\u0E49","downloadsheetmobile":"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E19\u0E35\u0E49\u0E1A\u0E19\u0E2A\u0E21\u0E32\u0E23\u0E4C\u0E17\u0E42\u0E1F\u0E19","filter":"\u0E01\u0E23\u0E2D\u0E07","history":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E28\u0E32\u0E2A\u0E15\u0E23\u0E4C","lang":"\u0E20\u0E32\u0E29\u0E32","menu":"\u0E40\u0E21\u0E19\u0E39","mode":"\u0E41\u0E1F\u0E0A\u0E31\u0E48\u0E19","needhelp":"\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D?","parameters":"\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32","print":"\u0E1E\u0E34\u0E21\u0E1E\u0E4C","printsheet":"\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E41\u0E1C\u0E48\u0E19\u0E19\u0E35\u0E49","result":"\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C","results":"\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C","singleLang":"\u0E20\u0E32\u0E29\u0E32","sound":"\u0E02\u0E2D\u0E07\u0E40\u0E18\u0E2D","submit":"\u0E2A\u0E48\u0E07","subtitle":"\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22","tutorial":"\u0E01\u0E27\u0E14\u0E27\u0E34\u0E0A\u0E32","validate":"\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A"},"emergency":{"samu":"S.A.M.U.","police":"\u0E15\u0E33\u0E23\u0E27\u0E08","firefighter":"\u0E19\u0E31\u0E01\u0E14\u0E31\u0E1A\u0E40\u0E1E\u0E25\u0E34\u0E07","general":"\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B","hospital":"\u0E42\u0E23\u0E07\u0E1E\u0E22\u0E32\u0E1A\u0E32\u0E25","homeless":"\u0E04\u0E19\u0E44\u0E23\u0E49\u0E1A\u0E49\u0E32\u0E19","poison":"\u0E28\u0E39\u0E19\u0E22\u0E4C\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E1E\u0E34\u0E29","emergency":"\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E09\u0E38\u0E01\u0E40\u0E09\u0E34\u0E19"},"error":{"title":"\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14","button":"\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07"},"history":{"title":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32"},"inputs":{"choose":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E33\u0E15\u0E2D\u0E1A"},"language":{"change":"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E20\u0E32\u0E29\u0E32","select":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E20\u0E32\u0E29\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23"},"link":{"buttontext":"\u0E14\u0E39\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23","goto":"\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48","click":"\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48","scanQR":"\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E41\u0E01\u0E19 QrCode","scanQRTile":"\u0E2A\u0E41\u0E01\u0E19\u0E23\u0E2B\u0E31\u0E2A QR \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E49\u0E19\u0E1E\u0E1A"},"loader":{"loader":{"optimal":"\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E14\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14","classic":"\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E04\u0E25\u0E32\u0E2A\u0E2A\u0E34\u0E01\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19","vocal":"\u0E09\u0E31\u0E19\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E1E\u0E39\u0E14\u0E04\u0E38\u0E22\u0E01\u0E31\u0E1A\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19","text":"\u0E09\u0E31\u0E19\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E17\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E01\u0E31\u0E1A\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19"},"modes":{"vocal":"\u0E42\u0E2B\u0E21\u0E14\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E1E\u0E39\u0E14","text":"\u0E42\u0E2B\u0E21\u0E14\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21"},"loaderValidation":"\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32","locale":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E20\u0E32\u0E29\u0E32","supported":"\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E20\u0E32\u0E29\u0E32\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A","addressdata":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E36\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25"},"menu":{"message":"\u0E1B\u0E49\u0E2D\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","allowMicrophone":"\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E44\u0E21\u0E42\u0E04\u0E23\u0E42\u0E1F\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","backconversation":"\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32","answer":" \u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"},"mobileLandscapePreventer":{"firstline":"\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E14\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14","secondline":"\u0E1E\u0E25\u0E34\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"},"news":{"warningtext":"\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E02\u0E48\u0E32\u0E27\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E1A\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19","live":"\u0E2A\u0E14","continuous":"\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E15\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07"},"poi":{"comment":"\u0E23\u0E35\u0E27\u0E34\u0E27\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32","route":"\u0E16\u0E19\u0E19","nodata":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","openinghours":"\u0E40\u0E27\u0E25\u0E32\u0E17\u0E33\u0E01\u0E32\u0E23","prices":"\u0E23\u0E32\u0E04\u0E32","paymentmethods":"\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19","numberofplaces":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48","openroutemobile":"\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07 Google Maps \u0E1A\u0E19\u0E2A\u0E21\u0E32\u0E23\u0E4C\u0E17\u0E42\u0E1F\u0E19","FoodEstablishment":"\u0E01\u0E34\u0E19\u0E17\u0E35\u0E48\u0E44\u0E2B\u0E19\u0E14\u0E35","LodgingBusiness":"\u0E19\u0E2D\u0E19\u0E44\u0E2B\u0E19.","TouristDestination":"\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E43\u0E2B\u0E49\u0E14\u0E39\u0E1A\u0E49\u0E32\u0E07","TouristAttraction":"\u0E08\u0E30\u0E17\u0E33\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23","Product":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07","Service":"\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23","Event":"\u0E01\u0E34\u0E08\u0E01\u0E23\u0E23\u0E21","City":"\u0E40\u0E21\u0E37\u0E2D\u0E07","Wine":"\u0E44\u0E27\u0E19\u0E4C"},"suggestion":{"consult":"\u0E40\u0E0A\u0E47\u0E04\u0E40\u0E2D\u0E32\u0E17\u0E4C","thetutorial":"\u0E1A\u0E17\u0E0A\u0E48\u0E27\u0E22\u0E2A\u0E2D\u0E19"},"template":{"reset":"\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","showresults":"\u0E41\u0E2A\u0E14\u0E07\u0E1C\u0E25","suggestiontitle":"\u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32","reminder":"\u0E2D\u0E22\u0E48\u0E32\u0E25\u0E37\u0E21 \\n \u0E09\u0E31\u0E19\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49"}}');


var $ed9701567b41642c$exports = {};
$ed9701567b41642c$exports = JSON.parse('{"1":"ana sayfa","2":"canl\u0131 bilgi kanal\u0131","3":"hava durumu","4":"Acil durum numaralar\u0131","1000":"tarih","1001":"\xf6\u011Fretici","common":{"all":"T\xfcm\xfc","back":"geri","close":"kapal\u0131","continue":"Devam etmek","download":"\u0130ndirmek","downloadsheet":"bu sayfay\u0131 indir","downloadsheetmobile":"bu sayfay\u0131 ak\u0131ll\u0131 telefonunuza indirin","filter":"Filtre","history":"tarihi","lang":"Diller","menu":"Men\xfc","mode":"moda","needhelp":"Yard\u0131ma m\u0131 ihtiyac\u0131n\u0131z var?","parameters":"ayarlar","print":"Yazd\u0131r","printsheet":"Bu sayfay\u0131 yazd\u0131r","result":"sonu\xe7","results":"sonu\xe7lar","singleLang":"dil","sound":"ses","submit":"g\xf6ndermek","subtitle":"alt yaz\u0131","tutorial":"\xf6\u011Fretici","validate":"Do\u011Frulamak"},"emergency":{"samu":"S.A.M.U.","police":"polis","firefighter":"itfaiyeciler","general":"genel","hospital":"Hastane","homeless":"Evsiz","poison":"Zehir kontrol Merkezi","emergency":"Acil servisler"},"error":{"title":"bir hata olu\u015Ftu","button":"Uygulamay\u0131 yeniden ba\u015Flat\u0131n"},"history":{"title":"konu\u015Fma ge\xe7mi\u015Fi"},"inputs":{"choose":"Bir cevap se\xe7in"},"language":{"change":"dili de\u011Fi\u015Ftir","select":"istedi\u011Finiz dili se\xe7in"},"link":{"buttontext":"Belgeyi g\xf6r\xfcnt\xfcle","goto":"Adrese git","click":"buraya t\u0131klay\u0131n","scanQR":"QrCode\'u tarayarak","scanQRTile":"Ke\u015Ffetmek i\xe7in QR Kodu\u2019nu tara"},"loader":{"loader":{"optimal":"Optimum bir deneyim i\xe7in,","classic":"Daha klasik bir deneyim i\xe7in,","vocal":"Temsilciyle konu\u015Farak ileti\u015Fim kuruyorum.","text":"Temsilciyle mesaj yoluyla ileti\u015Fim kuruyorum."},"modes":{"vocal":"vokal modu","text":"metin modu"},"loaderValidation":"Konu\u015Fmay\u0131 ba\u015Flat","locale":"dili kontrol etme","supported":"desteklenen dilleri kontrol etme","addressdata":"veri alma"},"menu":{"message":"Mesaj\u0131n\u0131z\u0131 girin","allowMicrophone":"Devam etmek i\xe7in taray\u0131c\u0131n\u0131z\u0131n mikrofonunuzu kullanmas\u0131na izin verin","backconversation":"konu\u015Fmaya geri d\xf6n","answer":" sorular\u0131n\u0131z\u0131 yan\u0131tl\u0131yor"},"mobileLandscapePreventer":{"firstline":"Optimum bir deneyim i\xe7in,","secondline":"ekran\u0131n\u0131 \xe7evir"},"news":{"warningtext":"Haber kanal\u0131na ula\u015Facaks\u0131n\u0131z, cihaz\u0131n\u0131zdaki ses aktif hale gelecektir","live":"canl\u0131","continuous":"devaml\u0131 olarak"},"poi":{"comment":"m\xfc\u015Fteri yorumu","route":"yol","nodata":"Araman\u0131zla e\u015Fle\u015Fen i\xe7erik yok","openinghours":"A\xe7\u0131l\u0131\u015F saatleri","prices":"Fiyat:% s","paymentmethods":"\xd6deme metodlar\u0131","numberofplaces":"yer say\u0131s\u0131","openroutemobile":"ak\u0131ll\u0131 telefonda Google Haritalar rotas\u0131n\u0131 a\xe7","FoodEstablishment":"Nerede yenir","LodgingBusiness":"Nerede uyumal\u0131","TouristDestination":"Ne g\xf6rmeli","TouristAttraction":"Ne yapal\u0131m","Product":"Yerel \xfcr\xfcnler","Service":"Hizmetler","Event":"Olaylar","City":"\u015Eehirler","Wine":"\u015Earaplar"},"suggestion":{"consult":"\xc7\u0131k\u0131\u015F yapmak","thetutorial":"\xf6\u011Fretici"},"template":{"reset":"hepsini s\u0131f\u0131rla","showresults":"Sonu\xe7lar\u0131 g\xf6ster","suggestiontitle":"\xd6nerileri ara","reminder":"Unutmay\u0131n, \\n sorular\u0131n\u0131z\u0131 cevaplayabilirim."}}');


var $884c511669295af6$exports = {};
$884c511669295af6$exports = JSON.parse('{"1":"\u4E3B\u9875","2":"\u5B9E\u65F6\u4FE1\u606F\u9891\u9053","3":"\u5929\u6C14","4":"\u7D27\u6025\u7535\u8BDD\u53F7\u7801","1000":"\u5386\u53F2","1001":"\u6559\u7A0B","common":{"all":"\u5168\u90E8","back":"\u540E\u9000","close":"\u5173\u95ED","continue":"\u7EE7\u7EED","download":"\u4E0B\u8F7D","downloadsheet":"\u4E0B\u8F7D\u6B64\u8868","downloadsheetmobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u4E0B\u8F7D\u6B64\u8868","filter":"\u7B5B\u9009","history":"\u5386\u53F2\u7684","lang":"\u8BED\u8A00","menu":"\u83DC\u5355","mode":"\u65F6\u5C1A","needhelp":"\u9700\u8981\u5E2E\u5FD9\uFF1F","parameters":"\u8BBE\u7F6E","print":"\u6253\u5370","printsheet":"\u6253\u5370\u6B64\u8868","result":"\u7ED3\u679C","results":"\u7ED3\u679C","singleLang":"\u8BED\u8A00","sound":"\u5979","submit":"\u63D0\u4EA4","subtitle":"\u5B57\u5E55","tutorial":"\u6559\u7A0B","validate":"\u8BC1\u5B9E"},"emergency":{"samu":"S.A.M.U.","police":"\u8B66\u5BDF","firefighter":"\u6D88\u9632\u5458","general":"\u5C06\u519B","hospital":"\u533B\u9662","homeless":"\u65E0\u5BB6\u53EF\u5F52","poison":"\u6BD2\u7269\u63A7\u5236\u4E2D\u5FC3","emergency":"\u7D27\u6025\u670D\u52A1"},"error":{"title":"\u53D1\u751F\u4E86\u9519\u8BEF","button":"\u91CD\u65B0\u542F\u52A8\u5E94\u7528\u7A0B\u5E8F"},"history":{"title":"\u5BF9\u8BDD\u5386\u53F2"},"inputs":{"choose":"\u9009\u62E9\u4E00\u4E2A\u7B54\u6848"},"language":{"change":"\u66F4\u6539\u8BED\u8A00","select":"\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u8BED\u8A00"},"link":{"buttontext":"\u67E5\u770B\u6587\u6863","goto":"\u524D\u5F80\u5730\u5740","click":"\u70B9\u51FB\u8FD9\u91CC","scanQR":"\u626B\u63CF\u4E8C\u7EF4\u7801","scanQRTile":"\u626B\u63CF\u4E8C\u7EF4\u7801\u4EE5\u53D1\u73B0"},"loader":{"loader":{"optimal":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","classic":"\u60F3\u8981\u66F4\u7ECF\u5178\u7684\u4F53\u9A8C\uFF0C","vocal":"\u6211\u901A\u8FC7\u4E0E\u4EE3\u7406\u4EBA\u4EA4\u8C08\u6765\u6C9F\u901A\u3002","text":"\u6211\u901A\u8FC7\u77ED\u4FE1\u4E0E\u4EE3\u7406\u4EBA\u6C9F\u901A\u3002"},"modes":{"vocal":"\u58F0\u97F3\u6A21\u5F0F","text":"\u6587\u672C\u6A21\u5F0F"},"loaderValidation":"\u5F00\u59CB\u5BF9\u8BDD","locale":"\u68C0\u67E5\u8BED\u8A00","supported":"\u68C0\u67E5\u652F\u6301\u7684\u8BED\u8A00","addressdata":"\u68C0\u7D22\u6570\u636E"},"menu":{"message":"\u8F93\u5165\u60A8\u7684\u7559\u8A00","allowMicrophone":"\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u4F7F\u7528\u60A8\u7684\u9EA6\u514B\u98CE\u4EE5\u7EE7\u7EED","backconversation":"\u56DE\u5230\u5BF9\u8BDD","answer":" \u56DE\u7B54\u4F60\u7684\u95EE\u9898"},"mobileLandscapePreventer":{"firstline":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","secondline":"\u7FFB\u8F6C\u4F60\u7684\u5C4F\u5E55"},"news":{"warningtext":"\u60A8\u5C06\u8BBF\u95EE\u65B0\u95FB\u9891\u9053\uFF0C\u8BBE\u5907\u4E0A\u7684\u58F0\u97F3\u5C06\u88AB\u6FC0\u6D3B","live":"\u5C45\u4F4F","continuous":"\u4E0D\u65AD\u5730"},"poi":{"comment":"\u5BA2\u6237\u8BC4\u8BBA","route":"\u8DEF","nodata":"\u6CA1\u6709\u5185\u5BB9\u7B26\u5408\u60A8\u7684\u641C\u7D22","openinghours":"\u8425\u4E1A\u65F6\u95F4","prices":"\u4EF7\u683C","paymentmethods":"\u652F\u4ED8\u65B9\u5F0F","numberofplaces":"\u540D\u989D","openroutemobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u6253\u5F00 Google \u5730\u56FE\u8DEF\u7EBF","FoodEstablishment":"\u53BB\u54EA\u91CC\u5403\u996D","LodgingBusiness":"\u7761\u89C9\u7684\u5730\u65B9","TouristDestination":"\u8BE5\u770B\u4EC0\u4E48","TouristAttraction":"\u8BE5\u600E\u4E48\u529E","Product":"\u571F\u7279\u4EA7","Service":"\u670D\u52A1","Event":"\u6D3B\u52A8","City":"\u57CE\u5E02","Wine":"\u8461\u8404\u9152"},"suggestion":{"consult":"\u67E5\u770B","thetutorial":"\u6559\u7A0B"},"template":{"reset":"\u91CD\u7F6E\u5168\u90E8","showresults":"\u663E\u793A\u7ED3\u679C","suggestiontitle":"\u641C\u7D22\u5EFA\u8BAE","reminder":"\u522B\u5FD8\u4E86\uFF0C\\n\u6211\u53EF\u4EE5\u56DE\u7B54\u4F60\u7684\u95EE\u9898\u3002"}}');


var $26dc78b95f4d9617$exports = {};
$26dc78b95f4d9617$exports = JSON.parse('{"1":"\u4E3B\u9875","2":"\u5B9E\u65F6\u4FE1\u606F\u9891\u9053","3":"\u5929\u6C14","4":"\u7D27\u6025\u7535\u8BDD\u53F7\u7801","1000":"\u5386\u53F2","1001":"\u6559\u7A0B","common":{"all":"\u5168\u90E8","back":"\u540E\u9000","close":"\u5173\u95ED","continue":"\u7EE7\u7EED","download":"\u4E0B\u8F7D","downloadsheet":"\u4E0B\u8F7D\u6B64\u8868","downloadsheetmobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u4E0B\u8F7D\u6B64\u8868","filter":"\u7B5B\u9009","history":"\u5386\u53F2\u7684","lang":"\u8BED\u8A00","menu":"\u83DC\u5355","mode":"\u65F6\u5C1A","needhelp":"\u9700\u8981\u5E2E\u5FD9\uFF1F","parameters":"\u8BBE\u7F6E","print":"\u6253\u5370","printsheet":"\u6253\u5370\u6B64\u8868","result":"\u7ED3\u679C","results":"\u7ED3\u679C","singleLang":"\u8BED\u8A00","sound":"\u5979","submit":"\u63D0\u4EA4","subtitle":"\u5B57\u5E55","tutorial":"\u6559\u7A0B","validate":"\u8BC1\u5B9E"},"emergency":{"samu":"S.A.M.U.","police":"\u8B66\u5BDF","firefighter":"\u6D88\u9632\u5458","general":"\u5C06\u519B","hospital":"\u533B\u9662","homeless":"\u65E0\u5BB6\u53EF\u5F52","poison":"\u6BD2\u7269\u63A7\u5236\u4E2D\u5FC3","emergency":"\u7D27\u6025\u670D\u52A1"},"error":{"title":"\u53D1\u751F\u4E86\u9519\u8BEF","button":"\u91CD\u65B0\u542F\u52A8\u5E94\u7528\u7A0B\u5E8F"},"history":{"title":"\u5BF9\u8BDD\u5386\u53F2"},"inputs":{"choose":"\u9009\u62E9\u4E00\u4E2A\u7B54\u6848"},"language":{"change":"\u66F4\u6539\u8BED\u8A00","select":"\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u8BED\u8A00"},"link":{"buttontext":"\u67E5\u770B\u6587\u6863","goto":"\u524D\u5F80\u5730\u5740","click":"\u70B9\u51FB\u8FD9\u91CC","scanQR":"\u626B\u63CF\u4E8C\u7EF4\u7801","scanQRTile":"\u6383\u63CF QR \u78BC\u4EE5\u767C\u73FE"},"loader":{"loader":{"optimal":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","classic":"\u60F3\u8981\u66F4\u7ECF\u5178\u7684\u4F53\u9A8C\uFF0C","vocal":"\u6211\u901A\u8FC7\u4E0E\u4EE3\u7406\u4EBA\u4EA4\u8C08\u6765\u6C9F\u901A\u3002","text":"\u6211\u901A\u8FC7\u77ED\u4FE1\u4E0E\u4EE3\u7406\u4EBA\u6C9F\u901A\u3002"},"modes":{"vocal":"\u58F0\u97F3\u6A21\u5F0F","text":"\u6587\u672C\u6A21\u5F0F"},"loaderValidation":"\u5F00\u59CB\u5BF9\u8BDD","locale":"\u68C0\u67E5\u8BED\u8A00","supported":"\u68C0\u67E5\u652F\u6301\u7684\u8BED\u8A00","addressdata":"\u68C0\u7D22\u6570\u636E"},"menu":{"message":"\u8F93\u5165\u60A8\u7684\u7559\u8A00","allowMicrophone":"\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u4F7F\u7528\u60A8\u7684\u9EA6\u514B\u98CE\u4EE5\u7EE7\u7EED","backconversation":"\u56DE\u5230\u5BF9\u8BDD","answer":" \u56DE\u7B54\u4F60\u7684\u95EE\u9898"},"mobileLandscapePreventer":{"firstline":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","secondline":"\u7FFB\u8F6C\u4F60\u7684\u5C4F\u5E55"},"news":{"warningtext":"\u60A8\u5C06\u8BBF\u95EE\u65B0\u95FB\u9891\u9053\uFF0C\u8BBE\u5907\u4E0A\u7684\u58F0\u97F3\u5C06\u88AB\u6FC0\u6D3B","live":"\u5C45\u4F4F","continuous":"\u4E0D\u65AD\u5730"},"poi":{"comment":"\u5BA2\u6237\u8BC4\u8BBA","route":"\u8DEF","nodata":"\u6CA1\u6709\u5185\u5BB9\u7B26\u5408\u60A8\u7684\u641C\u7D22","openinghours":"\u8425\u4E1A\u65F6\u95F4","prices":"\u4EF7\u683C","paymentmethods":"\u652F\u4ED8\u65B9\u5F0F","numberofplaces":"\u540D\u989D","openroutemobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u6253\u5F00 Google \u5730\u56FE\u8DEF\u7EBF","FoodEstablishment":"\u53BB\u54EA\u91CC\u5403\u996D","LodgingBusiness":"\u7761\u89C9\u7684\u5730\u65B9","TouristDestination":"\u8BE5\u770B\u4EC0\u4E48","TouristAttraction":"\u8BE5\u600E\u4E48\u529E","Product":"\u571F\u7279\u4EA7","Service":"\u670D\u52A1","Event":"\u6D3B\u52A8","City":"\u57CE\u5E02","Wine":"\u8461\u8404\u9152"},"suggestion":{"consult":"\u67E5\u770B","thetutorial":"\u6559\u7A0B"},"template":{"reset":"\u91CD\u7F6E\u5168\u90E8","showresults":"\u663E\u793A\u7ED3\u679C","suggestiontitle":"\u641C\u7D22\u5EFA\u8BAE","reminder":"\u522B\u5FD8\u4E86\uFF0C\\n\u6211\u53EF\u4EE5\u56DE\u7B54\u4F60\u7684\u95EE\u9898\u3002"}}');


var $b2b7d01ab532a25c$exports = {};
$b2b7d01ab532a25c$exports = JSON.parse('{"1":"\u4E3B\u9875","2":"\u5B9E\u65F6\u4FE1\u606F\u9891\u9053","3":"\u5929\u6C14","4":"\u7D27\u6025\u7535\u8BDD\u53F7\u7801","1000":"\u5386\u53F2","1001":"\u6559\u7A0B","common":{"all":"\u5168\u90E8","back":"\u540E\u9000","close":"\u5173\u95ED","continue":"\u7EE7\u7EED","download":"\u4E0B\u8F7D","downloadsheet":"\u4E0B\u8F7D\u6B64\u8868","downloadsheetmobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u4E0B\u8F7D\u6B64\u8868","filter":"\u7B5B\u9009","history":"\u5386\u53F2\u7684","lang":"\u8BED\u8A00","menu":"\u83DC\u5355","mode":"\u65F6\u5C1A","needhelp":"\u9700\u8981\u5E2E\u5FD9\uFF1F","parameters":"\u8BBE\u7F6E","print":"\u6253\u5370","printsheet":"\u6253\u5370\u6B64\u8868","result":"\u7ED3\u679C","results":"\u7ED3\u679C","singleLang":"\u8BED\u8A00","sound":"\u5979","submit":"\u63D0\u4EA4","subtitle":"\u5B57\u5E55","tutorial":"\u6559\u7A0B","validate":"\u8BC1\u5B9E"},"emergency":{"samu":"S.A.M.U.","police":"\u8B66\u5BDF","firefighter":"\u6D88\u9632\u5458","general":"\u5C06\u519B","hospital":"\u533B\u9662","homeless":"\u65E0\u5BB6\u53EF\u5F52","poison":"\u6BD2\u7269\u63A7\u5236\u4E2D\u5FC3","emergency":"\u7D27\u6025\u670D\u52A1"},"error":{"title":"\u53D1\u751F\u4E86\u9519\u8BEF","button":"\u91CD\u65B0\u542F\u52A8\u5E94\u7528\u7A0B\u5E8F"},"history":{"title":"\u5BF9\u8BDD\u5386\u53F2"},"inputs":{"choose":"\u9009\u62E9\u4E00\u4E2A\u7B54\u6848"},"language":{"change":"\u66F4\u6539\u8BED\u8A00","select":"\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u8BED\u8A00"},"link":{"buttontext":"\u67E5\u770B\u6587\u6863","goto":"\u524D\u5F80\u5730\u5740","click":"\u70B9\u51FB\u8FD9\u91CC","scanQR":"\u626B\u63CF\u4E8C\u7EF4\u7801","scanQRTile":"\u6383\u63CF QR \u78BC\u4EE5\u767C\u73FE"},"loader":{"loader":{"optimal":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","classic":"\u60F3\u8981\u66F4\u7ECF\u5178\u7684\u4F53\u9A8C\uFF0C","vocal":"\u6211\u901A\u8FC7\u4E0E\u4EE3\u7406\u4EBA\u4EA4\u8C08\u6765\u6C9F\u901A\u3002","text":"\u6211\u901A\u8FC7\u77ED\u4FE1\u4E0E\u4EE3\u7406\u4EBA\u6C9F\u901A\u3002"},"modes":{"vocal":"\u58F0\u97F3\u6A21\u5F0F","text":"\u6587\u672C\u6A21\u5F0F"},"loaderValidation":"\u5F00\u59CB\u5BF9\u8BDD","locale":"\u68C0\u67E5\u8BED\u8A00","supported":"\u68C0\u67E5\u652F\u6301\u7684\u8BED\u8A00","addressdata":"\u68C0\u7D22\u6570\u636E"},"menu":{"message":"\u8F93\u5165\u60A8\u7684\u7559\u8A00","allowMicrophone":"\u5141\u8BB8\u60A8\u7684\u6D4F\u89C8\u5668\u4F7F\u7528\u60A8\u7684\u9EA6\u514B\u98CE\u4EE5\u7EE7\u7EED","backconversation":"\u56DE\u5230\u5BF9\u8BDD","answer":" \u56DE\u7B54\u4F60\u7684\u95EE\u9898"},"mobileLandscapePreventer":{"firstline":"\u4E3A\u4E86\u83B7\u5F97\u6700\u4F73\u4F53\u9A8C\uFF0C","secondline":"\u7FFB\u8F6C\u4F60\u7684\u5C4F\u5E55"},"news":{"warningtext":"\u60A8\u5C06\u8BBF\u95EE\u65B0\u95FB\u9891\u9053\uFF0C\u8BBE\u5907\u4E0A\u7684\u58F0\u97F3\u5C06\u88AB\u6FC0\u6D3B","live":"\u5C45\u4F4F","continuous":"\u4E0D\u65AD\u5730"},"poi":{"comment":"\u5BA2\u6237\u8BC4\u8BBA","route":"\u8DEF","nodata":"\u6CA1\u6709\u5185\u5BB9\u7B26\u5408\u60A8\u7684\u641C\u7D22","openinghours":"\u8425\u4E1A\u65F6\u95F4","prices":"\u4EF7\u683C","paymentmethods":"\u652F\u4ED8\u65B9\u5F0F","numberofplaces":"\u540D\u989D","openroutemobile":"\u5728\u667A\u80FD\u624B\u673A\u4E0A\u6253\u5F00 Google \u5730\u56FE\u8DEF\u7EBF","FoodEstablishment":"\u53BB\u54EA\u91CC\u5403\u996D","LodgingBusiness":"\u7761\u89C9\u7684\u5730\u65B9","TouristDestination":"\u8BE5\u770B\u4EC0\u4E48","TouristAttraction":"\u8BE5\u600E\u4E48\u529E","Product":"\u571F\u7279\u4EA7","Service":"\u670D\u52A1","Event":"\u6D3B\u52A8","City":"\u57CE\u5E02","Wine":"\u8461\u8404\u9152"},"suggestion":{"consult":"\u67E5\u770B","thetutorial":"\u6559\u7A0B"},"template":{"reset":"\u91CD\u7F6E\u5168\u90E8","showresults":"\u663E\u793A\u7ED3\u679C","suggestiontitle":"\u641C\u7D22\u5EFA\u8BAE","reminder":"\u522B\u5FD8\u4E86\uFF0C\\n\u6211\u53EF\u4EE5\u56DE\u7B54\u4F60\u7684\u95EE\u9898\u3002"}}');




const $d0ec91114d7de49c$var$initialState = {
    locale: "",
    defaultLocale: "fr-FR",
    supported: [],
    defaultTranslations: $b5fbaa9e2139763f$exports.fr_FR,
    currentTranslations: $b5fbaa9e2139763f$exports.fr_FR
};
const $d0ec91114d7de49c$export$6650dace022cfacc = (0, $126de8f2db9c4dbc$exports.create)()(()=>{
    return $d0ec91114d7de49c$var$initialState;
});
const $d0ec91114d7de49c$export$180605366c04f0cd = ()=>{
    return $d0ec91114d7de49c$export$6650dace022cfacc((state)=>state.locale);
};
const $d0ec91114d7de49c$export$c8aadf3621e41efb = (locale)=>{
    $d0ec91114d7de49c$export$6650dace022cfacc.setState({
        locale: locale
    });
    const changeLocaleEvent = new CustomEvent("retorikChangeLocale", {
        detail: {
            locale: locale
        }
    });
    document.dispatchEvent(changeLocaleEvent);
    const defaultTranslation = $d0ec91114d7de49c$export$6650dace022cfacc.getState().defaultTranslations;
    const tempTranslation = $b5fbaa9e2139763f$exports[locale.replace("-", "_")];
    if (tempTranslation) $d0ec91114d7de49c$export$6650dace022cfacc.setState({
        currentTranslations: {
            ...defaultTranslation,
            ...tempTranslation
        }
    });
    else $d0ec91114d7de49c$export$6650dace022cfacc.setState({
        currentTranslations: defaultTranslation
    });
};
const $d0ec91114d7de49c$export$fe443f6e3680433 = async (addressData)=>{
    (0, $13041c27a96c6593$export$2e2bcd8739ae039)(addressData).then((languages)=>{
        $d0ec91114d7de49c$export$6650dace022cfacc.setState({
            defaultLocale: languages.default,
            supported: languages.all
        });
    });
};
const $d0ec91114d7de49c$export$3118ae18000e2700 = ()=>{
    $d0ec91114d7de49c$export$6650dace022cfacc.setState({
        ...$d0ec91114d7de49c$var$initialState
    });
};



const $48daba569ab8eaa5$var$activityMiddleware = (activity)=>{
    if (activity?.type === "message" && activity.attachments?.length && activity.attachments[0].contentType === "application/vnd.davi.retorik.card.suggestedaction" && activity.attachments[0].content?.title?.indexOf(activity.text) > -1) {
        // Hack for Suggested Action : Only show text in card, not in message
        activity.text = "";
        activity.htmlText = "";
    }
    return activity;
};
var $48daba569ab8eaa5$export$2e2bcd8739ae039 = $48daba569ab8eaa5$var$activityMiddleware;


const $0aecf0c32f1a48e0$var$initialState = {
    directLine: null,
    directLineStatus: (0, $dbdd077456dd22ff$exports.ConnectionStatus).Uninitialized,
    connectionStatusSubscription: null,
    activitySubscription: null,
    userId: "",
    externalActivityHandler: null,
    paginationToSend: 10,
    positionToSend: undefined,
    activityWatermark: 0
};
const $0aecf0c32f1a48e0$var$postActivityTypes = [
    (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).SEND_MESSAGE,
    (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).SEND_EVENT
];
const $0aecf0c32f1a48e0$export$7fdfbcbba5f19303 = (0, $126de8f2db9c4dbc$exports.create)()(()=>{
    return $0aecf0c32f1a48e0$var$initialState;
});
/**
 * Add a field in the 'from' part of the activity showing if it comes from the bot (backend) or the user
 * @param {Activity} activity incoming activity
 * @returns {RetorikActivity}
 */ const $0aecf0c32f1a48e0$var$patchActivityFromPart = (activity)=>{
    const userId = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState().userId;
    const tempActivity = activity;
    if (!activity.from) tempActivity.from = {
        ...tempActivity.from,
        role: "channel"
    };
    else if (!activity.from.role) {
        if (activity.from.id === userId) tempActivity.from = {
            ...tempActivity.from,
            role: "user"
        };
        else if (activity.from.id) tempActivity.from = {
            ...tempActivity.from,
            role: "bot"
        };
        else tempActivity.from = {
            ...tempActivity.from,
            role: "channel"
        };
    }
    return tempActivity;
};
const $0aecf0c32f1a48e0$var$checkIfHandlerAbortsActivity = (type, activity)=>{
    const handler = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState().externalActivityHandler;
    if (handler) {
        const action = {
            type: type,
            payload: {
                activity: activity
            }
        };
        if (handler(action)) {
            console.log("Retorik Framework > Aborted activity");
            return true;
        }
    }
    return false;
};
const $0aecf0c32f1a48e0$var$dispatchStatus = (status)=>{
    const handler = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState().externalActivityHandler;
    if (handler) {
        handler({
            type: (0, $10936a3e32e1d945$export$741b3b19a0ba7556)[status]
        });
        status === (0, $dbdd077456dd22ff$exports.ConnectionStatus).Online && handler({
            type: (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).SET_LANGUAGE
        });
    }
};
const $0aecf0c32f1a48e0$var$dispatchActivity = (activity)=>{
    const retrievingConversation = (0, $d023474b51a6fd24$export$b56465394e2b1287).getState().retrievingConversation;
    if (retrievingConversation) {
        // @ts-ignore
        const finalWatermark = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState().directLine?.watermark;
        if (!isNaN(parseInt(finalWatermark))) {
            const currentWatermark = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState().activityWatermark + 1;
            if (currentWatermark === parseInt(finalWatermark)) (0, $d023474b51a6fd24$export$d7e4f7861d387c67)(false);
            else $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.setState({
                activityWatermark: currentWatermark
            });
        }
    }
    activity.conversation && (0, $d023474b51a6fd24$export$4365557467e67cdc)(activity.conversation.id);
    // Patch 'from' part of the activity to distinct between 'bot', 'user and 'channel'
    const retorikActivity = (0, $48daba569ab8eaa5$export$2e2bcd8739ae039)($0aecf0c32f1a48e0$var$patchActivityFromPart(activity));
    let legacyType = (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).UNKNOWN;
    switch(retorikActivity.type){
        case "message":
            legacyType = retorikActivity.from.role === "user" ? (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).SEND_MESSAGE : (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).INCOMING_ACTIVITY;
            break;
        case "event":
            legacyType = retorikActivity.from.role === "user" ? (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).SEND_EVENT : (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).INCOMING_ACTIVITY;
            break;
        case "typing":
            legacyType = (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).TYPING;
            break;
    }
    // Let speechStore check if this activity has an impact on a curent streaming
    (0, $b8685bd729fa723f$export$8505d436556ca045)(retorikActivity.replyToId);
    switch(legacyType){
        case (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).SEND_EVENT:
            (0, $d023474b51a6fd24$export$ff4f3927f89b50e8)(retorikActivity);
            break;
        case (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).SEND_MESSAGE:
            (0, $d023474b51a6fd24$export$bf77ccf2b7638432)(retorikActivity);
            break;
        case (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).INCOMING_ACTIVITY:
            if (!$0aecf0c32f1a48e0$var$checkIfHandlerAbortsActivity(legacyType, activity)) {
                // Add data for better speech recognition if therer are some
                if (retorikActivity.channelData?.speechRecognitionGrammars) (0, $b8685bd729fa723f$export$ec8986cae5ae5c2)(retorikActivity.channelData?.speechRecognitionGrammars);
                if (retorikActivity.type === "event") (0, $d023474b51a6fd24$export$bb2ccecd43d76d90)(retorikActivity);
                else if (retorikActivity.type === "message") (0, $d023474b51a6fd24$export$2c98bb0c7fa688b3)(retorikActivity);
            }
            break;
    }
    // Send POST_ACTIVITY_FULFILLED if the legacy type is SEND_MESSAGE or SEND_EVENT
    if ($0aecf0c32f1a48e0$var$postActivityTypes.includes(legacyType)) $0aecf0c32f1a48e0$var$checkIfHandlerAbortsActivity((0, $10936a3e32e1d945$export$bbd16b9b30e132b3).POST_ACTIVITY_FULFILLED, activity);
};
const $0aecf0c32f1a48e0$var$subscribe = (value)=>{
    // Subscribe to connection status and activities if a value is provided
    const CSsubscription = value ? value.connectionStatus$.subscribe((newStatus)=>{
        $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.setState({
            directLineStatus: newStatus
        });
        $0aecf0c32f1a48e0$var$dispatchStatus(newStatus);
    }) : null;
    const Asubscription = value ? value.activity$.subscribe((activity)=>{
        activity.type !== "typing" && $0aecf0c32f1a48e0$var$dispatchActivity(activity);
    }) : null;
    $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.setState({
        directLine: value,
        connectionStatusSubscription: CSsubscription,
        activitySubscription: Asubscription
    });
};
const $0aecf0c32f1a48e0$var$unsubscribe = ()=>{
    // Unsubscribe existing subscriptions to connection status and activities
    const connectionStatusSubscription = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState().connectionStatusSubscription;
    const activitySubscription = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState().activitySubscription;
    connectionStatusSubscription && connectionStatusSubscription.unsubscribe();
    activitySubscription && activitySubscription.unsubscribe();
};
const $0aecf0c32f1a48e0$var$end = ()=>{
    const directLine = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState().directLine;
    directLine?.end();
};
const $0aecf0c32f1a48e0$export$18601f6b6afcab62 = (data)=>{
    // Send DIRECT_LINE/CONNECT before creating directline because if everything goes well it only sends DIRECT_LINE/CONNECT_FULFILLED
    data.externalActivityHandler?.({
        type: (0, $10936a3e32e1d945$export$741b3b19a0ba7556)[0]
    });
    const directLine = new (0, $dbdd077456dd22ff$exports.DirectLine)({
        ...data
    });
    $0aecf0c32f1a48e0$var$unsubscribe();
    $0aecf0c32f1a48e0$var$subscribe(directLine);
    data.userId && $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.setState({
        userId: data.userId
    });
    data.externalActivityHandler && $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.setState({
        externalActivityHandler: data.externalActivityHandler
    });
};
/**
 * Add usefull data in channelData part, containing pagination and position / location
 * @returns {DataAddedToChannelData}
 */ const $0aecf0c32f1a48e0$var$addDataInChannelData = ()=>{
    const currentState = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState();
    const dataAddedToChannelData = {
        pageSize: currentState.paginationToSend || 10
    };
    if (currentState.positionToSend && currentState.positionToSend.latitude && currentState.positionToSend.longitude) {
        dataAddedToChannelData.location = {
            latitude: currentState.positionToSend.latitude,
            longitude: currentState.positionToSend.longitude
        };
        dataAddedToChannelData.position = {
            latitude: currentState.positionToSend.latitude,
            longitude: currentState.positionToSend.longitude
        };
    }
    return dataAddedToChannelData;
};
const $0aecf0c32f1a48e0$export$465cb47180de50f0 = (text, value)=>{
    (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(true);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc).getState().locale;
    const currentState = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState();
    const tempActivity = {
        from: {
            id: currentState.userId
        },
        type: "message",
        channelData: $0aecf0c32f1a48e0$var$addDataInChannelData(),
        locale: locale
    };
    text && (tempActivity.text = text);
    value && (tempActivity.value = value);
    // Check if the activity should be stopped in the external activity handler if there is one
    if ($0aecf0c32f1a48e0$var$checkIfHandlerAbortsActivity((0, $10936a3e32e1d945$export$bbd16b9b30e132b3).POST_ACTIVITY, tempActivity)) return;
    if ($0aecf0c32f1a48e0$var$checkIfHandlerAbortsActivity((0, $10936a3e32e1d945$export$bbd16b9b30e132b3).SEND_MESSAGE, tempActivity)) return;
    currentState.directLine?.postActivity(tempActivity).subscribe();
};
const $0aecf0c32f1a48e0$export$7329bcdc3edcd90e = (name, value)=>{
    !name.toLowerCase().includes("davi.closewindow") && (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(true);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc).getState().locale;
    const currentState = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState();
    const tempEvent = {
        from: {
            id: currentState.userId
        },
        type: "event",
        channelData: $0aecf0c32f1a48e0$var$addDataInChannelData(),
        // @ts-ignore
        locale: locale,
        name: name,
        value: value
    };
    // Check if the event should be stopped in the external activity handler if there is one
    if ($0aecf0c32f1a48e0$var$checkIfHandlerAbortsActivity((0, $10936a3e32e1d945$export$bbd16b9b30e132b3).POST_ACTIVITY, tempEvent)) return;
    if ($0aecf0c32f1a48e0$var$checkIfHandlerAbortsActivity((0, $10936a3e32e1d945$export$bbd16b9b30e132b3).SEND_EVENT, tempEvent)) return;
    currentState.directLine?.postActivity({
        from: {
            id: currentState.userId
        },
        type: "event",
        channelData: $0aecf0c32f1a48e0$var$addDataInChannelData(),
        // @ts-ignore
        locale: locale,
        name: name,
        value: value
    }).subscribe();
};
const $0aecf0c32f1a48e0$export$81487d3d3f61cca3 = ()=>{
    const currentState = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState();
    currentState.directLine?.postActivity({
        from: {
            id: currentState.userId
        },
        type: "typing"
    }).subscribe();
};
const $0aecf0c32f1a48e0$export$fbb15aa7bdda31c9 = (value)=>{
    $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.setState({
        paginationToSend: value
    });
};
const $0aecf0c32f1a48e0$export$a607205d8a8f37a7 = (value)=>{
    $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.setState({
        positionToSend: value
    });
};
const $0aecf0c32f1a48e0$export$84857fb581760e7 = (id, speaking)=>{
    const handler = $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.getState().externalActivityHandler;
    if (handler) {
        const action = {
            type: (0, $10936a3e32e1d945$export$bbd16b9b30e132b3).MARK,
            payload: {
                activityID: id,
                name: "speak",
                value: speaking
            }
        };
        handler(action);
    }
};
const $0aecf0c32f1a48e0$export$8f3b2f6aa8e2c248 = ()=>{
    $0aecf0c32f1a48e0$var$unsubscribe();
    $0aecf0c32f1a48e0$var$end();
    $0aecf0c32f1a48e0$export$7fdfbcbba5f19303.setState({
        ...$0aecf0c32f1a48e0$var$initialState
    });
};






async function $8ebc7b039c1c3c0a$export$2ce265f68d021d6(key) {
    const data = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${key}`
        }
    };
    const res = await fetch("https://directline.botframework.com/v3/directline/tokens/generate", data);
    const { token: token } = await res.json();
    return token;
}
async function $8ebc7b039c1c3c0a$export$97c24bbbbbd7be8a(data) {
    // baseURI is used for retrocompatibility
    let fullAddress = "";
    if (data.baseURI) fullAddress = data.baseURI;
    else fullAddress = `${(0, $a6ed223e0fdb911e$export$2e2bcd8739ae039)(data.prefix)}/${data.tenant}/${0, $bbe458fac496c294$export$d9e38c0112bbdae6}`;
    const res = await fetch(fullAddress);
    const token = await res.json();
    return token;
}



var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");



const $4442d90d00cf976a$var$useToggleMicrophone = ()=>{
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const activeRecognitionState = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.activeRecognitionState);
    const toggleMicrophone = (0, $lT7pJ.useCallback)((fromExpectedInput)=>{
        if (mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text) (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).Closed);
        else switch(activeRecognitionState){
            // Do nothing if we are in a transition state
            case (0, $45d43a6de0968f42$export$3f0071308968cd80).Initializing:
            case (0, $45d43a6de0968f42$export$3f0071308968cd80).Closing:
                return;
            case (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening:
                (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).ForceClosing);
                (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(true);
                break;
            case (0, $45d43a6de0968f42$export$3f0071308968cd80).Closed:
                (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).Initializing);
                !fromExpectedInput && (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(true);
                break;
        }
    }, [
        mode,
        activeRecognitionState
    ]);
    return toggleMicrophone;
};
var $4442d90d00cf976a$export$2e2bcd8739ae039 = $4442d90d00cf976a$var$useToggleMicrophone;


var $466e951a072527cb$var$EventsReceived;
(function($466e951a072527cb$var$EventsReceived) {
    $466e951a072527cb$var$EventsReceived[$466e951a072527cb$var$EventsReceived["retorikSendActivity"] = 1] = "retorikSendActivity";
    $466e951a072527cb$var$EventsReceived[$466e951a072527cb$var$EventsReceived["retorikSendEvent"] = 2] = "retorikSendEvent";
    $466e951a072527cb$var$EventsReceived[$466e951a072527cb$var$EventsReceived["retorikStartListening"] = 3] = "retorikStartListening";
    $466e951a072527cb$var$EventsReceived[$466e951a072527cb$var$EventsReceived["retorikDisplaySubtitles"] = 4] = "retorikDisplaySubtitles";
})($466e951a072527cb$var$EventsReceived || ($466e951a072527cb$var$EventsReceived = {}));
const $466e951a072527cb$var$SendActivityEventListener = ({ isRetorikNews: isRetorikNews, hasConversationCookie: hasConversationCookie, userData: userData })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const activityToSend = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.activityToSend);
    const displayGDPR = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.GDPRDisplay);
    const userConsent = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.GDPRUserConsent);
    const loaderClosed = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.loaderClosed);
    const appAvailable = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.appAvailable);
    const skipWelcome = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.skipWelcome);
    const userAlreadySet = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.userAlreadySet);
    const toggleMicrophone = (0, $4442d90d00cf976a$export$2e2bcd8739ae039)();
    const [eventReceived, setEventReceived] = (0, $lT7pJ.useState)(null);
    (0, $lT7pJ.useEffect)(()=>{
        if (eventReceived) try {
            switch(eventReceived.type){
                case 1:
                    eventReceived.detail && (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, eventReceived.detail);
                    break;
                case 4:
                    eventReceived.detail && (0, $7c69764370dcab43$export$708f3eb1d5828832)(!!eventReceived.detail);
                    break;
                case 3:
                    toggleMicrophone();
                    break;
                case 2:
                    eventReceived.detail && (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)(eventReceived.detail.name, eventReceived.detail.value);
            }
        } catch (e) {
            console.warn("Retorik Framework > Error on event reception");
        }
    }, [
        eventReceived
    ]);
    const handleEvents = (event)=>{
        setEventReceived({
            type: $466e951a072527cb$var$EventsReceived[event.type],
            detail: event.detail
        });
    };
    (0, $lT7pJ.useEffect)(()=>{
        document.addEventListener("retorikSendActivity", handleEvents);
        document.addEventListener("retorikSendEvent", handleEvents);
        document.addEventListener("retorikStartListening", handleEvents);
        document.addEventListener("retorikDisplaySubtitles", handleEvents);
        return ()=>{
            document.removeEventListener("retorikSendActivity", handleEvents);
            document.removeEventListener("retorikStartListening", handleEvents);
            document.removeEventListener("retorikDisplaySubtitles", handleEvents);
        };
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        if (isRetorikNews || hasConversationCookie) (0, $7c69764370dcab43$export$702dee93694750db)(true);
        else if (!userAlreadySet && appAvailable && !displayGDPR) {
            (0, $7c69764370dcab43$export$702dee93694750db)(true);
            // Send mandatory events : setUser to start conversation, Davi.GDPRConsent for GDPR module
            (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("setUser", {
                user: {
                    ...userData,
                    gdprConsent: true
                },
                skipWelcome: !!skipWelcome
            });
            setTimeout(()=>{
                (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.GDPRConsent", {
                    userConsent: userConsent
                });
            }, 100);
        }
    }, [
        appAvailable,
        loaderClosed,
        displayGDPR
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (activityToSend) {
            if (activityToSend.type === "message" && activityToSend.text && typeof activityToSend.text !== "string") {
                const tempActivity = {
                    ...activityToSend
                };
                tempActivity.text = activityToSend.text[locale] || "";
                (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(tempActivity.text);
            } else (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, activityToSend.value || activityToSend);
            (0, $1bda010252da638c$export$d4c8c6daac289378)(undefined);
        }
    }, [
        activityToSend
    ]);
    return null;
};
var $466e951a072527cb$export$2e2bcd8739ae039 = $466e951a072527cb$var$SendActivityEventListener;


const $d712f7d262fd02fc$var$defaultUser = {
    name: "default",
    id: `defaultId_${Date.now()}`,
    username: "default",
    nom: "defaultName",
    prenom: "\xe0 vous",
    email: "",
    token: "",
    referrer: "",
    ipaddress: ""
};
const $d712f7d262fd02fc$var$RetorikComposer = ({ addressData: addressData, userData: userData, externalEventHandler: externalEventHandler, children: children, isRetorikNews: isRetorikNews })=>{
    const directLine = (0, $0aecf0c32f1a48e0$export$7fdfbcbba5f19303)((state)=>state.directLine);
    const connectionStatus = (0, $0aecf0c32f1a48e0$export$7fdfbcbba5f19303)((state)=>state.directLineStatus);
    const [directLineCreationdata, setDirectLineCreationData] = (0, $lT7pJ.useState)();
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const loaderClosed = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.loaderClosed);
    const agentData = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.agentData);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const supported = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.supported);
    const [hasConversationCookie, setHasConversationCookie] = (0, $lT7pJ.useState)(false);
    const processedUserData = (0, $lT7pJ.useMemo)(()=>{
        if (userData) return userData;
        else {
            const userIdFromCookie = document.cookie.split("; ").find((row)=>row.startsWith("retorikUserIdCookie="))?.split("=")[1];
            if (userIdFromCookie) return {
                ...$d712f7d262fd02fc$var$defaultUser,
                username: userIdFromCookie,
                id: userIdFromCookie
            };
            else {
                const id = `defaultId_${Date.now()}`;
                (0, $d023474b51a6fd24$export$ad1f3d930a6d4d42)(`retorikUserIdCookie=${id}`);
                return {
                    ...$d712f7d262fd02fc$var$defaultUser,
                    username: id,
                    id: id
                };
            }
        }
    }, [
        userData
    ]);
    const processDirectLine = async ()=>{
        (0, $8ebc7b039c1c3c0a$export$97c24bbbbbd7be8a)(addressData).then((token)=>{
            let test = true;
            if (isRetorikNews) {
                const fullTenantName = (addressData.baseURI || `${addressData.prefix || ""}${addressData.tenant}`).replace(/;|,|\s/g, "");
                const newsConversationData = localStorage.getItem(`Retorik.News.Conversation.${fullTenantName}`);
                if (newsConversationData) {
                    const data = JSON.parse(newsConversationData);
                    if (data?.conversationId) // 604800000 = number of milliseconds in 7 days
                    {
                        if (!isNaN(data.startedAt) && data.startedAt + 604800000 > Date.now()) {
                            setDirectLineCreationData({
                                token: token,
                                conversationId: data.conversationId
                            });
                            test = false;
                        }
                    }
                }
                test && (0, $d023474b51a6fd24$export$3d2327b52759cec0)(fullTenantName);
            } else if (configuration.enableConversationCookie !== false) {
                const conversationCookie = document.cookie.split("; ").find((row)=>row.startsWith("retorikConversationCookie="))?.split("=")[1];
                if (conversationCookie) {
                    const splitCookieData = conversationCookie.split("||");
                    if (splitCookieData.length === 2) {
                        const cookieConversationId = splitCookieData[0];
                        const cookieTenantName = splitCookieData[1];
                        const fullTenantName = (addressData.baseURI || `${addressData.prefix || ""}${addressData.tenant}`).replace(/;|,|\s/g, "");
                        if (cookieTenantName === fullTenantName) {
                            setDirectLineCreationData({
                                token: token,
                                conversationId: cookieConversationId,
                                watermark: "0"
                            });
                            // Tell the activity store that we will retrieve several activities from an existing conversation, so that it displays only the last one
                            (0, $d023474b51a6fd24$export$d7e4f7861d387c67)(true);
                            setHasConversationCookie(true);
                            test = false;
                        }
                    }
                } else {
                    const fullTenantName = (addressData.baseURI || `${addressData.prefix || ""}${addressData.tenant}`).replace(/;|,|\s/g, "");
                    const maxAge = configuration.conversationCookieMaxAge || 3600;
                    (0, $d023474b51a6fd24$export$ad1f3d930a6d4d42)(`retorikConversationCookie=<conversationId>||${fullTenantName}; max-age=${maxAge}`);
                }
            }
            test && setDirectLineCreationData({
                token: token
            });
        });
    };
    (0, $lT7pJ.useEffect)(()=>{
        if (directLineCreationdata && locale && processedUserData) !directLine && (0, $0aecf0c32f1a48e0$export$18601f6b6afcab62)({
            ...directLineCreationdata,
            conversationStartProperties: {
                locale: locale
            },
            userId: processedUserData.id,
            externalActivityHandler: externalEventHandler
        });
    }, [
        locale,
        directLineCreationdata,
        processedUserData
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        processDirectLine();
        return ()=>{
            console.log("Retorik Framework > Disconnect and end directline");
            (0, $0aecf0c32f1a48e0$export$8f3b2f6aa8e2c248)();
        };
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        if (locale && supported && agentData && connectionStatus === (0, $dbdd077456dd22ff$exports.ConnectionStatus).Online && (isRetorikNews || loaderClosed)) (0, $7c69764370dcab43$export$a8ce9bbc5b910a21)(true);
    }, [
        locale,
        supported,
        agentData,
        loaderClosed,
        connectionStatus
    ]);
    return directLine && agentData && processedUserData ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $466e951a072527cb$export$2e2bcd8739ae039), {
                isRetorikNews: isRetorikNews,
                hasConversationCookie: hasConversationCookie,
                userData: processedUserData
            }),
            children
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $d712f7d262fd02fc$export$2e2bcd8739ae039 = $d712f7d262fd02fc$var$RetorikComposer;




var $lT7pJ = parcelRequire("lT7pJ");





/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");




const $079f3ffaa96f1faa$export$d95eb9b67812311f = (0, $126de8f2db9c4dbc$exports.create)()(()=>{
    return {
        widgetDisplayType: "large",
        open: false,
        loaded: false
    };
});
const $079f3ffaa96f1faa$export$a1c83309c736819f = ()=>{
    $079f3ffaa96f1faa$export$d95eb9b67812311f.setState({
        open: true,
        loaded: true
    });
};
const $079f3ffaa96f1faa$export$d27f1b0993b666c = ()=>{
    $079f3ffaa96f1faa$export$d95eb9b67812311f.setState({
        open: false,
        loaded: true
    });
};
const $079f3ffaa96f1faa$export$77c0ba4d0d97cee5 = ()=>{
    const open = $079f3ffaa96f1faa$export$d95eb9b67812311f.getState().open;
    $079f3ffaa96f1faa$export$d95eb9b67812311f.setState({
        open: !open,
        loaded: true
    });
};
const $079f3ffaa96f1faa$export$f0e9d14ede4c01bd = ()=>{
    const displayType = $079f3ffaa96f1faa$export$d95eb9b67812311f.getState().widgetDisplayType;
    $079f3ffaa96f1faa$export$d95eb9b67812311f.setState({
        widgetDisplayType: displayType === "large" ? "thumbnail" : "large"
    });
};





var $lT7pJ = parcelRequire("lT7pJ");
var $4384aec9bdeb5926$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $4384aec9bdeb5926$exports = factory((parcelRequire("lT7pJ")));
})($4384aec9bdeb5926$exports, function(__WEBPACK_EXTERNAL_MODULE_react__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module) {
            /******/ var getter = module && module.__esModule ? /******/ function getDefault() {
                return module["default"];
            } : /******/ function getModuleExports() {
                return module;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./src/react-webcam.tsx");
    /******/ }({
        /***/ "./src/react-webcam.tsx": /*!******************************!*\
  !*** ./src/react-webcam.tsx ***!
  \******************************/ /*! exports provided: default */ /***/ function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __rest = function(s, e) {
                var t = {};
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                    for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                }
                return t;
            };
            // polyfill based on https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
            (function polyfillGetUserMedia() {
                if (typeof window === "undefined") return;
                // Older browsers might not implement mediaDevices at all, so we set an empty object first
                if (navigator.mediaDevices === undefined) navigator.mediaDevices = {};
                // Some browsers partially implement mediaDevices. We can't just assign an object
                // with getUserMedia as it would overwrite existing properties.
                // Here, we will just add the getUserMedia property if it's missing.
                if (navigator.mediaDevices.getUserMedia === undefined) navigator.mediaDevices.getUserMedia = function(constraints) {
                    // First get ahold of the legacy getUserMedia, if present
                    var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                    // Some browsers just don't implement it - return a rejected promise with an error
                    // to keep a consistent interface
                    if (!getUserMedia) return Promise.reject(new Error("getUserMedia is not implemented in this browser"));
                    // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                    return new Promise(function(resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                };
            })();
            function hasGetUserMedia() {
                return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
            }
            var Webcam = /** @class */ function(_super) {
                __extends(Webcam, _super);
                function Webcam(props) {
                    var _this = _super.call(this, props) || this;
                    _this.canvas = null;
                    _this.ctx = null;
                    _this.requestUserMediaId = 0;
                    _this.unmounted = false;
                    _this.state = {
                        hasUserMedia: false
                    };
                    return _this;
                }
                Webcam.prototype.componentDidMount = function() {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    if (!state.hasUserMedia) this.requestUserMedia();
                };
                Webcam.prototype.componentDidUpdate = function(nextProps) {
                    var props = this.props;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    var audioConstraintsChanged = JSON.stringify(nextProps.audioConstraints) !== JSON.stringify(props.audioConstraints);
                    var videoConstraintsChanged = JSON.stringify(nextProps.videoConstraints) !== JSON.stringify(props.videoConstraints);
                    var minScreenshotWidthChanged = nextProps.minScreenshotWidth !== props.minScreenshotWidth;
                    var minScreenshotHeightChanged = nextProps.minScreenshotHeight !== props.minScreenshotHeight;
                    if (videoConstraintsChanged || minScreenshotWidthChanged || minScreenshotHeightChanged) {
                        this.canvas = null;
                        this.ctx = null;
                    }
                    if (audioConstraintsChanged || videoConstraintsChanged) {
                        this.stopAndCleanup();
                        this.requestUserMedia();
                    }
                };
                Webcam.prototype.componentWillUnmount = function() {
                    this.unmounted = true;
                    this.stopAndCleanup();
                };
                Webcam.stopMediaStream = function(stream) {
                    if (stream) {
                        if (stream.getVideoTracks && stream.getAudioTracks) {
                            stream.getVideoTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                            stream.getAudioTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                        } else stream.stop();
                    }
                };
                Webcam.prototype.stopAndCleanup = function() {
                    var state = this.state;
                    if (state.hasUserMedia) {
                        Webcam.stopMediaStream(this.stream);
                        if (state.src) window.URL.revokeObjectURL(state.src);
                    }
                };
                Webcam.prototype.getScreenshot = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!state.hasUserMedia) return null;
                    var canvas = this.getCanvas(screenshotDimensions);
                    return canvas && canvas.toDataURL(props.screenshotFormat, props.screenshotQuality);
                };
                Webcam.prototype.getCanvas = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!this.video) return null;
                    if (!state.hasUserMedia || !this.video.videoHeight) return null;
                    if (!this.ctx) {
                        var canvasWidth = this.video.videoWidth;
                        var canvasHeight = this.video.videoHeight;
                        if (!this.props.forceScreenshotSourceSize) {
                            var aspectRatio = canvasWidth / canvasHeight;
                            canvasWidth = props.minScreenshotWidth || this.video.clientWidth;
                            canvasHeight = canvasWidth / aspectRatio;
                            if (props.minScreenshotHeight && canvasHeight < props.minScreenshotHeight) {
                                canvasHeight = props.minScreenshotHeight;
                                canvasWidth = canvasHeight * aspectRatio;
                            }
                        }
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvasWidth;
                        this.canvas.height = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvasHeight;
                        this.ctx = this.canvas.getContext("2d");
                    }
                    var _b = this, ctx = _b.ctx, canvas = _b.canvas;
                    if (ctx && canvas) {
                        // mirror the screenshot
                        if (props.mirrored) {
                            ctx.translate(canvas.width, 0);
                            ctx.scale(-1, 1);
                        }
                        ctx.imageSmoothingEnabled = props.imageSmoothing;
                        ctx.drawImage(this.video, 0, 0, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvas.width, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvas.height);
                        // invert mirroring
                        if (props.mirrored) {
                            ctx.scale(-1, 1);
                            ctx.translate(-canvas.width, 0);
                        }
                    }
                    return canvas;
                };
                Webcam.prototype.requestUserMedia = function() {
                    var _this = this;
                    var props = this.props;
                    var sourceSelected = function(audioConstraints, videoConstraints) {
                        var constraints = {
                            video: typeof videoConstraints !== "undefined" ? videoConstraints : true
                        };
                        if (props.audio) constraints.audio = typeof audioConstraints !== "undefined" ? audioConstraints : true;
                        _this.requestUserMediaId++;
                        var myRequestUserMediaId = _this.requestUserMediaId;
                        navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
                            if (_this.unmounted || myRequestUserMediaId !== _this.requestUserMediaId) Webcam.stopMediaStream(stream);
                            else _this.handleUserMedia(null, stream);
                        }).catch(function(e) {
                            _this.handleUserMedia(e);
                        });
                    };
                    if ("mediaDevices" in navigator) sourceSelected(props.audioConstraints, props.videoConstraints);
                    else {
                        var optionalSource_1 = function(id) {
                            return {
                                optional: [
                                    {
                                        sourceId: id
                                    }
                                ]
                            };
                        };
                        var constraintToSourceId_1 = function(constraint) {
                            var deviceId = constraint.deviceId;
                            if (typeof deviceId === "string") return deviceId;
                            if (Array.isArray(deviceId) && deviceId.length > 0) return deviceId[0];
                            if (typeof deviceId === "object" && deviceId.ideal) return deviceId.ideal;
                            return null;
                        };
                        // @ts-ignore: deprecated api
                        MediaStreamTrack.getSources(function(sources) {
                            var audioSource = null;
                            var videoSource = null;
                            sources.forEach(function(source) {
                                if (source.kind === "audio") audioSource = source.id;
                                else if (source.kind === "video") videoSource = source.id;
                            });
                            var audioSourceId = constraintToSourceId_1(props.audioConstraints);
                            if (audioSourceId) audioSource = audioSourceId;
                            var videoSourceId = constraintToSourceId_1(props.videoConstraints);
                            if (videoSourceId) videoSource = videoSourceId;
                            sourceSelected(optionalSource_1(audioSource), optionalSource_1(videoSource));
                        });
                    }
                };
                Webcam.prototype.handleUserMedia = function(err, stream) {
                    var props = this.props;
                    if (err || !stream) {
                        this.setState({
                            hasUserMedia: false
                        });
                        props.onUserMediaError(err);
                        return;
                    }
                    this.stream = stream;
                    try {
                        if (this.video) this.video.srcObject = stream;
                        this.setState({
                            hasUserMedia: true
                        });
                    } catch (error) {
                        this.setState({
                            hasUserMedia: true,
                            src: window.URL.createObjectURL(stream)
                        });
                    }
                    props.onUserMedia(stream);
                };
                Webcam.prototype.render = function() {
                    var _this = this;
                    var _a = this, state = _a.state, props = _a.props;
                    var audio = props.audio, forceScreenshotSourceSize = props.forceScreenshotSourceSize, onUserMedia = props.onUserMedia, onUserMediaError = props.onUserMediaError, screenshotFormat = props.screenshotFormat, screenshotQuality = props.screenshotQuality, minScreenshotWidth = props.minScreenshotWidth, minScreenshotHeight = props.minScreenshotHeight, audioConstraints = props.audioConstraints, videoConstraints = props.videoConstraints, imageSmoothing = props.imageSmoothing, mirrored = props.mirrored, _b = props.style, style = _b === void 0 ? {} : _b, rest = __rest(props, [
                        "audio",
                        "forceScreenshotSourceSize",
                        "onUserMedia",
                        "onUserMediaError",
                        "screenshotFormat",
                        "screenshotQuality",
                        "minScreenshotWidth",
                        "minScreenshotHeight",
                        "audioConstraints",
                        "videoConstraints",
                        "imageSmoothing",
                        "mirrored",
                        "style"
                    ]);
                    var videoStyle = mirrored ? __assign(__assign({}, style), {
                        transform: (style.transform || "") + " scaleX(-1)"
                    }) : style;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("video", __assign({
                        autoPlay: true,
                        src: state.src,
                        muted: !audio,
                        playsInline: true,
                        ref: function(ref) {
                            _this.video = ref;
                        },
                        style: videoStyle
                    }, rest));
                };
                Webcam.defaultProps = {
                    audio: false,
                    forceScreenshotSourceSize: false,
                    imageSmoothing: true,
                    mirrored: false,
                    onUserMedia: function() {
                        return undefined;
                    },
                    onUserMediaError: function() {
                        return undefined;
                    },
                    screenshotFormat: "image/webp",
                    screenshotQuality: 0.92
                };
                return Webcam;
            }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
            /* harmony default export */ __webpack_exports__["default"] = Webcam;
        /***/ },
        /***/ "react": /*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"} ***!
  \**************************************************************************************/ /*! no static exports found */ /***/ function(module, exports) {
            module.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/ }
    })["default"];
});




var $lT7pJ = parcelRequire("lT7pJ");
/**
 * Use javascript ResizeOberver object to catch element's resize and return current size
 * @param {React.RefObject<HTMLElement>} ref element for which we want to get the size when resized
 * @returns {Dimensions} dimension data (width, height)
 */ const $57fa40eeebe37d0d$var$useRefDimensions = (ref)=>{
    const [dimensions, setDimensions] = (0, $lT7pJ.useState)({
        width: 1,
        height: 1
    });
    const [observer, setObserver] = (0, $lT7pJ.useState)();
    const handleResizeObserverTick = (entries)=>{
        entries.length && entries[0].contentBoxSize.length && setDimensions({
            width: entries[0].contentBoxSize[0].inlineSize,
            height: entries[0].contentBoxSize[0].blockSize
        });
    };
    (0, $lT7pJ.useLayoutEffect)(()=>{
        if (!observer) {
            const obs = new ResizeObserver(handleResizeObserverTick);
            if (ref?.current) {
                obs.observe(ref.current);
                setObserver(obs);
            }
        }
        return ()=>{
            observer?.disconnect();
        };
    }, []);
    return dimensions;
};
var $57fa40eeebe37d0d$export$2e2bcd8739ae039 = $57fa40eeebe37d0d$var$useRefDimensions;




var $lT7pJ = parcelRequire("lT7pJ");

const $aade0efef655591c$var$BackgroundVideo = ({ source: source, style: style, loop: loop, muted: muted, onVideoEnded: onVideoEnded, onVideoCanPlay: onVideoCanPlay })=>{
    const currentHeight = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentHeight);
    const currentWidth = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentWidth);
    const videoRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.load();
            videoRef.current.play().catch((e)=>console.warn(e));
        }
    }, [
        videoRef
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("video", {
        ref: videoRef,
        id: "retorik-background-video",
        className: "rf-relative rf-col-span-full rf-row-span-full rf-object-cover rf-overflow-hidden rf-filter rf-blur-background",
        onEnded: onVideoEnded,
        onError: onVideoEnded,
        onCanPlay: onVideoCanPlay,
        autoPlay: true,
        loop: loop,
        muted: muted,
        playsInline: true,
        style: {
            ...style,
            height: currentHeight,
            width: currentWidth
        },
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("source", {
            src: source
        })
    });
};
var $aade0efef655591c$export$2e2bcd8739ae039 = $aade0efef655591c$var$BackgroundVideo;


const $9601c14c689c9e72$var$Background = ({ config: config, videoLoop: videoLoop, videoMuted: videoMuted, onVideoEnded: onVideoEnded, onVideoCanPlay: onVideoCanPlay })=>{
    const webcamRotation = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.configurations).webcamRotation;
    const [isWebcamAllowed, setIsWebcamAllowed] = (0, $lT7pJ.useState)(false);
    const imageRef = (0, $lT7pJ.useRef)(null);
    const dimensions = (0, $57fa40eeebe37d0d$export$2e2bcd8739ae039)(imageRef);
    const [source, setSource] = (0, $lT7pJ.useState)({});
    const [videoDimensions, setVideoDimensions] = (0, $lT7pJ.useState)(dimensions);
    const [rotation, setRotation] = (0, $lT7pJ.useState)("");
    const [webcamSizeStyle, setWebcamSizeStyle] = (0, $lT7pJ.useState)({});
    const blurValue = (0, $lT7pJ.useMemo)(()=>{
        return {
            "--rf-blur-background": config?.blur !== undefined ? `${config.blur}px` : "0"
        };
    }, [
        config?.blur
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (config.style === "webcam") {
            if (isWebcamAllowed) {
                if (config.webcam) switch(config.webcam){
                    case "back":
                        setSource({
                            facingMode: {
                                exact: "environment"
                            },
                            deviceId: undefined
                        });
                        break;
                    case "front":
                    case undefined:
                        setSource({
                            facingMode: "user",
                            deviceId: undefined
                        });
                        break;
                    default:
                        setSource({
                            facingMode: undefined,
                            deviceId: config.webcam
                        });
                }
            } else askForWebcamPermission();
        }
    }, [
        config,
        isWebcamAllowed
    ]);
    const askForWebcamPermission = async ()=>{
        navigator?.mediaDevices && navigator.mediaDevices.getUserMedia({
            video: true
        }).then(()=>{
            setIsWebcamAllowed(true);
        }).catch((error)=>{
            console.log(error);
            setIsWebcamAllowed(false);
        });
    };
    (0, $lT7pJ.useEffect)(()=>{
        if (config.style === "webcam") {
            if (!webcamRotation || webcamRotation % 180 === 0) setVideoDimensions(dimensions);
            else setVideoDimensions({
                height: dimensions.width,
                width: dimensions.height
            });
        }
    }, [
        dimensions
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        switch(webcamRotation){
            case 90:
                setRotation("rf-rotate-90 rf-origin-center");
                setWebcamSizeStyle({
                    width: "100vh",
                    height: "100vw"
                });
                break;
            case -90:
                setRotation("rf--rotate-90 rf-origin-center");
                setWebcamSizeStyle({
                    width: "100vh",
                    height: "100vw"
                });
                break;
            case 180:
                setRotation("rf-rotate-180 rf-origin-center");
                setWebcamSizeStyle({});
                break;
            default:
                setRotation("");
                setWebcamSizeStyle({});
                break;
        }
    }, [
        webcamRotation
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            config.image && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                ref: imageRef,
                src: config.image,
                alt: "background image",
                className: "rf-col-span-full rf-row-span-full rf-w-full rf-h-full rf-object-cover rf-filter rf-blur-background",
                style: blurValue
            }),
            config.style === "video" && config.video && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $aade0efef655591c$export$2e2bcd8739ae039), {
                source: config.video,
                loop: !!videoLoop,
                muted: !!videoMuted,
                onVideoEnded: onVideoEnded,
                onVideoCanPlay: onVideoCanPlay,
                style: blurValue
            }),
            config.style === "webcam" && isWebcamAllowed && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4384aec9bdeb5926$exports))), {
                className: `rf-relative rf-col-span-full rf-row-span-full rf-overflow-hidden rf-max-w-none rf-w-screen rf-h-screen rf-filter rf-blur-background rf-border rf-self-center rf-justify-self-center rf-object-cover ${rotation}`,
                ...videoDimensions,
                style: {
                    ...blurValue,
                    ...webcamSizeStyle
                },
                audio: false,
                videoConstraints: {
                    ...source,
                    ...videoDimensions
                }
            })
        ]
    });
};
var $9601c14c689c9e72$export$2e2bcd8739ae039 = $9601c14c689c9e72$var$Background;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");



/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");
// src/index.ts
// src/hooks/useChain.ts

var $lT7pJ = parcelRequire("lT7pJ");
var $bd140d0b30421f1c$var$__defProp = Object.defineProperty;
var $bd140d0b30421f1c$var$__export = (target, all)=>{
    for(var name in all)$bd140d0b30421f1c$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $bd140d0b30421f1c$export$cceeabf822b64fc0 = {};
$bd140d0b30421f1c$var$__export($bd140d0b30421f1c$export$cceeabf822b64fc0, {
    assign: ()=>$bd140d0b30421f1c$var$assign,
    colors: ()=>$bd140d0b30421f1c$var$colors,
    createStringInterpolator: ()=>$bd140d0b30421f1c$var$createStringInterpolator,
    skipAnimation: ()=>$bd140d0b30421f1c$var$skipAnimation,
    to: ()=>$bd140d0b30421f1c$var$to,
    willAdvance: ()=>$bd140d0b30421f1c$var$willAdvance
});
// ../rafz/dist/react-spring_rafz.modern.mjs
var $bd140d0b30421f1c$var$updateQueue = $bd140d0b30421f1c$var$makeQueue();
var $bd140d0b30421f1c$export$27f233d61a9e2fa4 = (fn)=>$bd140d0b30421f1c$var$schedule(fn, $bd140d0b30421f1c$var$updateQueue);
var $bd140d0b30421f1c$var$writeQueue = $bd140d0b30421f1c$var$makeQueue();
$bd140d0b30421f1c$export$27f233d61a9e2fa4.write = (fn)=>$bd140d0b30421f1c$var$schedule(fn, $bd140d0b30421f1c$var$writeQueue);
var $bd140d0b30421f1c$var$onStartQueue = $bd140d0b30421f1c$var$makeQueue();
$bd140d0b30421f1c$export$27f233d61a9e2fa4.onStart = (fn)=>$bd140d0b30421f1c$var$schedule(fn, $bd140d0b30421f1c$var$onStartQueue);
var $bd140d0b30421f1c$var$onFrameQueue = $bd140d0b30421f1c$var$makeQueue();
$bd140d0b30421f1c$export$27f233d61a9e2fa4.onFrame = (fn)=>$bd140d0b30421f1c$var$schedule(fn, $bd140d0b30421f1c$var$onFrameQueue);
var $bd140d0b30421f1c$var$onFinishQueue = $bd140d0b30421f1c$var$makeQueue();
$bd140d0b30421f1c$export$27f233d61a9e2fa4.onFinish = (fn)=>$bd140d0b30421f1c$var$schedule(fn, $bd140d0b30421f1c$var$onFinishQueue);
var $bd140d0b30421f1c$var$timeouts = [];
$bd140d0b30421f1c$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $bd140d0b30421f1c$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $bd140d0b30421f1c$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $bd140d0b30421f1c$var$timeouts.splice(i, 1);
        $bd140d0b30421f1c$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $bd140d0b30421f1c$var$timeouts.splice($bd140d0b30421f1c$var$findTimeout(time), 0, timeout);
    $bd140d0b30421f1c$var$pendingCount += 1;
    $bd140d0b30421f1c$var$start();
    return timeout;
};
var $bd140d0b30421f1c$var$findTimeout = (time)=>~(~$bd140d0b30421f1c$var$timeouts.findIndex((t)=>t.time > time) || ~$bd140d0b30421f1c$var$timeouts.length);
$bd140d0b30421f1c$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $bd140d0b30421f1c$var$onStartQueue.delete(fn);
    $bd140d0b30421f1c$var$onFrameQueue.delete(fn);
    $bd140d0b30421f1c$var$onFinishQueue.delete(fn);
    $bd140d0b30421f1c$var$updateQueue.delete(fn);
    $bd140d0b30421f1c$var$writeQueue.delete(fn);
};
$bd140d0b30421f1c$export$27f233d61a9e2fa4.sync = (fn)=>{
    $bd140d0b30421f1c$var$sync = true;
    $bd140d0b30421f1c$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $bd140d0b30421f1c$var$sync = false;
};
$bd140d0b30421f1c$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $bd140d0b30421f1c$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $bd140d0b30421f1c$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $bd140d0b30421f1c$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$bd140d0b30421f1c$export$27f233d61a9e2fa4.use = (impl)=>$bd140d0b30421f1c$var$nativeRaf = impl;
$bd140d0b30421f1c$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$bd140d0b30421f1c$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$bd140d0b30421f1c$export$27f233d61a9e2fa4.catch = console.error;
$bd140d0b30421f1c$export$27f233d61a9e2fa4.frameLoop = "always";
$bd140d0b30421f1c$export$27f233d61a9e2fa4.advance = ()=>{
    if ($bd140d0b30421f1c$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $bd140d0b30421f1c$var$update();
};
var $bd140d0b30421f1c$var$ts = -1;
var $bd140d0b30421f1c$var$pendingCount = 0;
var $bd140d0b30421f1c$var$sync = false;
function $bd140d0b30421f1c$var$schedule(fn, queue) {
    if ($bd140d0b30421f1c$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $bd140d0b30421f1c$var$start();
    }
}
function $bd140d0b30421f1c$var$start() {
    if ($bd140d0b30421f1c$var$ts < 0) {
        $bd140d0b30421f1c$var$ts = 0;
        if ($bd140d0b30421f1c$export$27f233d61a9e2fa4.frameLoop !== "demand") $bd140d0b30421f1c$var$nativeRaf($bd140d0b30421f1c$var$loop);
    }
}
function $bd140d0b30421f1c$var$stop() {
    $bd140d0b30421f1c$var$ts = -1;
}
function $bd140d0b30421f1c$var$loop() {
    if (~$bd140d0b30421f1c$var$ts) {
        $bd140d0b30421f1c$var$nativeRaf($bd140d0b30421f1c$var$loop);
        $bd140d0b30421f1c$export$27f233d61a9e2fa4.batchedUpdates($bd140d0b30421f1c$var$update);
    }
}
function $bd140d0b30421f1c$var$update() {
    const prevTs = $bd140d0b30421f1c$var$ts;
    $bd140d0b30421f1c$var$ts = $bd140d0b30421f1c$export$27f233d61a9e2fa4.now();
    const count = $bd140d0b30421f1c$var$findTimeout($bd140d0b30421f1c$var$ts);
    if (count) {
        $bd140d0b30421f1c$var$eachSafely($bd140d0b30421f1c$var$timeouts.splice(0, count), (t)=>t.handler());
        $bd140d0b30421f1c$var$pendingCount -= count;
    }
    if (!$bd140d0b30421f1c$var$pendingCount) {
        $bd140d0b30421f1c$var$stop();
        return;
    }
    $bd140d0b30421f1c$var$onStartQueue.flush();
    $bd140d0b30421f1c$var$updateQueue.flush(prevTs ? Math.min(64, $bd140d0b30421f1c$var$ts - prevTs) : 16.667);
    $bd140d0b30421f1c$var$onFrameQueue.flush();
    $bd140d0b30421f1c$var$writeQueue.flush();
    $bd140d0b30421f1c$var$onFinishQueue.flush();
}
function $bd140d0b30421f1c$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $bd140d0b30421f1c$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $bd140d0b30421f1c$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $bd140d0b30421f1c$var$pendingCount -= current.size;
                $bd140d0b30421f1c$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $bd140d0b30421f1c$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $bd140d0b30421f1c$var$eachSafely(values, each2) {
    values.forEach((value)=>{
        try {
            each2(value);
        } catch (e) {
            $bd140d0b30421f1c$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
// src/helpers.ts
function $bd140d0b30421f1c$export$8793edee2d425525() {}
var $bd140d0b30421f1c$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $bd140d0b30421f1c$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $bd140d0b30421f1c$export$248d38f6296296c5(a, b) {
    if ($bd140d0b30421f1c$export$226b3eccf92c9ed9.arr(a)) {
        if (!$bd140d0b30421f1c$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $bd140d0b30421f1c$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $bd140d0b30421f1c$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($bd140d0b30421f1c$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $bd140d0b30421f1c$export$45b10814cc054894 = (a)=>$bd140d0b30421f1c$export$226b3eccf92c9ed9.und(a) ? [] : $bd140d0b30421f1c$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $bd140d0b30421f1c$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $bd140d0b30421f1c$export$79b2f7037acddd43(items, iterator);
    }
}
var $bd140d0b30421f1c$export$7ba486852759e806 = (queue, ...args)=>$bd140d0b30421f1c$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $bd140d0b30421f1c$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $bd140d0b30421f1c$var$createStringInterpolator;
var $bd140d0b30421f1c$var$to;
var $bd140d0b30421f1c$var$colors = null;
var $bd140d0b30421f1c$var$skipAnimation = false;
var $bd140d0b30421f1c$var$willAdvance = $bd140d0b30421f1c$export$8793edee2d425525;
var $bd140d0b30421f1c$var$assign = (globals)=>{
    if (globals.to) $bd140d0b30421f1c$var$to = globals.to;
    if (globals.now) $bd140d0b30421f1c$export$27f233d61a9e2fa4.now = globals.now;
    if (globals.colors !== void 0) $bd140d0b30421f1c$var$colors = globals.colors;
    if (globals.skipAnimation != null) $bd140d0b30421f1c$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $bd140d0b30421f1c$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) $bd140d0b30421f1c$export$27f233d61a9e2fa4.use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) $bd140d0b30421f1c$export$27f233d61a9e2fa4.batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $bd140d0b30421f1c$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) $bd140d0b30421f1c$export$27f233d61a9e2fa4.frameLoop = globals.frameLoop;
};
// src/FrameLoop.ts
var $bd140d0b30421f1c$var$startQueue = /* @__PURE__ */ new Set();
var $bd140d0b30421f1c$var$currentFrame = [];
var $bd140d0b30421f1c$var$prevFrame = [];
var $bd140d0b30421f1c$var$priority = 0;
var $bd140d0b30421f1c$export$a57f5080a3bcc90a = {
    get idle () {
        return !$bd140d0b30421f1c$var$startQueue.size && !$bd140d0b30421f1c$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($bd140d0b30421f1c$var$priority > animation.priority) {
            $bd140d0b30421f1c$var$startQueue.add(animation);
            $bd140d0b30421f1c$export$27f233d61a9e2fa4.onStart($bd140d0b30421f1c$var$flushStartQueue);
        } else {
            $bd140d0b30421f1c$var$startSafely(animation);
            $bd140d0b30421f1c$export$27f233d61a9e2fa4($bd140d0b30421f1c$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $bd140d0b30421f1c$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($bd140d0b30421f1c$var$priority) $bd140d0b30421f1c$export$27f233d61a9e2fa4.onFrame(()=>$bd140d0b30421f1c$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $bd140d0b30421f1c$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $bd140d0b30421f1c$var$currentFrame.splice(prevIndex, 1);
                $bd140d0b30421f1c$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $bd140d0b30421f1c$var$currentFrame = [];
        $bd140d0b30421f1c$var$startQueue.clear();
    }
};
function $bd140d0b30421f1c$var$flushStartQueue() {
    $bd140d0b30421f1c$var$startQueue.forEach($bd140d0b30421f1c$var$startSafely);
    $bd140d0b30421f1c$var$startQueue.clear();
    $bd140d0b30421f1c$export$27f233d61a9e2fa4($bd140d0b30421f1c$var$advance);
}
function $bd140d0b30421f1c$var$startSafely(animation) {
    if (!$bd140d0b30421f1c$var$currentFrame.includes(animation)) $bd140d0b30421f1c$var$startUnsafely(animation);
}
function $bd140d0b30421f1c$var$startUnsafely(animation) {
    $bd140d0b30421f1c$var$currentFrame.splice($bd140d0b30421f1c$var$findIndex($bd140d0b30421f1c$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $bd140d0b30421f1c$var$advance(dt) {
    const nextFrame = $bd140d0b30421f1c$var$prevFrame;
    for(let i = 0; i < $bd140d0b30421f1c$var$currentFrame.length; i++){
        const animation = $bd140d0b30421f1c$var$currentFrame[i];
        $bd140d0b30421f1c$var$priority = animation.priority;
        if (!animation.idle) {
            $bd140d0b30421f1c$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $bd140d0b30421f1c$var$priority = 0;
    $bd140d0b30421f1c$var$prevFrame = $bd140d0b30421f1c$var$currentFrame;
    $bd140d0b30421f1c$var$prevFrame.length = 0;
    $bd140d0b30421f1c$var$currentFrame = nextFrame;
    return $bd140d0b30421f1c$var$currentFrame.length > 0;
}
function $bd140d0b30421f1c$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $bd140d0b30421f1c$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $bd140d0b30421f1c$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $bd140d0b30421f1c$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $bd140d0b30421f1c$var$PERCENTAGE = $bd140d0b30421f1c$var$NUMBER + "%";
function $bd140d0b30421f1c$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $bd140d0b30421f1c$export$8972dc0e6ad9238f = new RegExp("rgb" + $bd140d0b30421f1c$var$call($bd140d0b30421f1c$var$NUMBER, $bd140d0b30421f1c$var$NUMBER, $bd140d0b30421f1c$var$NUMBER));
var $bd140d0b30421f1c$export$4e46ac54fc82cf3b = new RegExp("rgba" + $bd140d0b30421f1c$var$call($bd140d0b30421f1c$var$NUMBER, $bd140d0b30421f1c$var$NUMBER, $bd140d0b30421f1c$var$NUMBER, $bd140d0b30421f1c$var$NUMBER));
var $bd140d0b30421f1c$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $bd140d0b30421f1c$var$call($bd140d0b30421f1c$var$NUMBER, $bd140d0b30421f1c$var$PERCENTAGE, $bd140d0b30421f1c$var$PERCENTAGE));
var $bd140d0b30421f1c$export$810b04175080204c = new RegExp("hsla" + $bd140d0b30421f1c$var$call($bd140d0b30421f1c$var$NUMBER, $bd140d0b30421f1c$var$PERCENTAGE, $bd140d0b30421f1c$var$PERCENTAGE, $bd140d0b30421f1c$var$NUMBER));
var $bd140d0b30421f1c$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $bd140d0b30421f1c$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $bd140d0b30421f1c$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $bd140d0b30421f1c$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $bd140d0b30421f1c$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $bd140d0b30421f1c$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($bd140d0b30421f1c$var$colors && $bd140d0b30421f1c$var$colors[color] !== void 0) return $bd140d0b30421f1c$var$colors[color];
    if (match = $bd140d0b30421f1c$export$8972dc0e6ad9238f.exec(color)) return ($bd140d0b30421f1c$var$parse255(match[1]) << 24 | // r
    $bd140d0b30421f1c$var$parse255(match[2]) << 16 | // g
    $bd140d0b30421f1c$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $bd140d0b30421f1c$export$4e46ac54fc82cf3b.exec(color)) return ($bd140d0b30421f1c$var$parse255(match[1]) << 24 | // r
    $bd140d0b30421f1c$var$parse255(match[2]) << 16 | // g
    $bd140d0b30421f1c$var$parse255(match[3]) << 8 | // b
    $bd140d0b30421f1c$var$parse1(match[4])) >>> // a
    0;
    if (match = $bd140d0b30421f1c$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $bd140d0b30421f1c$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $bd140d0b30421f1c$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $bd140d0b30421f1c$export$8f4a7c0bb78e6ea8.exec(color)) return ($bd140d0b30421f1c$var$hslToRgb($bd140d0b30421f1c$var$parse360(match[1]), // h
    $bd140d0b30421f1c$var$parsePercentage(match[2]), // s
    $bd140d0b30421f1c$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $bd140d0b30421f1c$export$810b04175080204c.exec(color)) return ($bd140d0b30421f1c$var$hslToRgb($bd140d0b30421f1c$var$parse360(match[1]), // h
    $bd140d0b30421f1c$var$parsePercentage(match[2]), // s
    $bd140d0b30421f1c$var$parsePercentage(match[3])) | $bd140d0b30421f1c$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $bd140d0b30421f1c$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $bd140d0b30421f1c$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $bd140d0b30421f1c$var$hue2rgb(p, q, h + 1 / 3);
    const g = $bd140d0b30421f1c$var$hue2rgb(p, q, h);
    const b = $bd140d0b30421f1c$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $bd140d0b30421f1c$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $bd140d0b30421f1c$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $bd140d0b30421f1c$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $bd140d0b30421f1c$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $bd140d0b30421f1c$export$61db176b839af1f(input) {
    let int32Color = $bd140d0b30421f1c$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $bd140d0b30421f1c$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($bd140d0b30421f1c$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($bd140d0b30421f1c$export$226b3eccf92c9ed9.arr(range)) return $bd140d0b30421f1c$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($bd140d0b30421f1c$export$226b3eccf92c9ed9.str(range.output[0])) return $bd140d0b30421f1c$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $bd140d0b30421f1c$var$findRange(input, inputRange);
        return $bd140d0b30421f1c$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $bd140d0b30421f1c$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $bd140d0b30421f1c$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $bd140d0b30421f1c$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $bd140d0b30421f1c$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $bd140d0b30421f1c$var$c1 = 1.70158;
var $bd140d0b30421f1c$var$c2 = $bd140d0b30421f1c$var$c1 * 1.525;
var $bd140d0b30421f1c$var$c3 = $bd140d0b30421f1c$var$c1 + 1;
var $bd140d0b30421f1c$var$c4 = 2 * Math.PI / 3;
var $bd140d0b30421f1c$var$c5 = 2 * Math.PI / 4.5;
var $bd140d0b30421f1c$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $bd140d0b30421f1c$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$bd140d0b30421f1c$var$c3 * x * x * x - $bd140d0b30421f1c$var$c1 * x * x,
    easeOutBack: (x)=>1 + $bd140d0b30421f1c$var$c3 * Math.pow(x - 1, 3) + $bd140d0b30421f1c$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($bd140d0b30421f1c$var$c2 + 1) * 2 * x - $bd140d0b30421f1c$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($bd140d0b30421f1c$var$c2 + 1) * (x * 2 - 2) + $bd140d0b30421f1c$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $bd140d0b30421f1c$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $bd140d0b30421f1c$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $bd140d0b30421f1c$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $bd140d0b30421f1c$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $bd140d0b30421f1c$var$bounceOut(1 - x),
    easeOutBounce: $bd140d0b30421f1c$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $bd140d0b30421f1c$var$bounceOut(1 - 2 * x)) / 2 : (1 + $bd140d0b30421f1c$var$bounceOut(2 * x - 1)) / 2,
    steps: $bd140d0b30421f1c$var$steps
};
// src/fluids.ts
var $bd140d0b30421f1c$var$$get = Symbol.for("FluidValue.get");
var $bd140d0b30421f1c$var$$observers = Symbol.for("FluidValue.observers");
var $bd140d0b30421f1c$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$bd140d0b30421f1c$var$$get]);
var $bd140d0b30421f1c$export$e37b7520edd66839 = (arg)=>arg && arg[$bd140d0b30421f1c$var$$get] ? arg[$bd140d0b30421f1c$var$$get]() : arg;
var $bd140d0b30421f1c$export$133f54e9f7cf1796 = (target)=>target[$bd140d0b30421f1c$var$$observers] || null;
function $bd140d0b30421f1c$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $bd140d0b30421f1c$export$31752c40a5fab62a(target, event) {
    const observers = target[$bd140d0b30421f1c$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $bd140d0b30421f1c$export$8cbca1207adce0c0(observer2, event);
    });
}
var $bd140d0b30421f1c$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $bd140d0b30421f1c$export$a3b4618659637aa3(this, get);
    }
};
$bd140d0b30421f1c$var$$get, $bd140d0b30421f1c$var$$observers;
var $bd140d0b30421f1c$export$a3b4618659637aa3 = (target, get)=>$bd140d0b30421f1c$var$setHidden(target, $bd140d0b30421f1c$var$$get, get);
function $bd140d0b30421f1c$export$72d604e3f8d000a5(target, observer2) {
    if (target[$bd140d0b30421f1c$var$$get]) {
        let observers = target[$bd140d0b30421f1c$var$$observers];
        if (!observers) $bd140d0b30421f1c$var$setHidden(target, $bd140d0b30421f1c$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $bd140d0b30421f1c$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$bd140d0b30421f1c$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$bd140d0b30421f1c$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $bd140d0b30421f1c$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $bd140d0b30421f1c$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $bd140d0b30421f1c$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $bd140d0b30421f1c$var$unitRegex = new RegExp(`(${$bd140d0b30421f1c$var$numberRegex.source})(%|[a-z]+)`, "i");
var $bd140d0b30421f1c$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $bd140d0b30421f1c$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $bd140d0b30421f1c$var$variableToRgba = (input)=>{
    const [token, fallback] = $bd140d0b30421f1c$var$parseCSSVariable(input);
    if (!token || $bd140d0b30421f1c$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $bd140d0b30421f1c$var$cssVariableRegex.test(fallback)) return $bd140d0b30421f1c$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $bd140d0b30421f1c$var$parseCSSVariable = (current)=>{
    const match = $bd140d0b30421f1c$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $bd140d0b30421f1c$var$namedColorRegex;
var $bd140d0b30421f1c$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $bd140d0b30421f1c$export$4759a013d387347a = (config)=>{
    if (!$bd140d0b30421f1c$var$namedColorRegex) $bd140d0b30421f1c$var$namedColorRegex = $bd140d0b30421f1c$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($bd140d0b30421f1c$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $bd140d0b30421f1c$export$e37b7520edd66839(value).replace($bd140d0b30421f1c$var$cssVariableRegex, $bd140d0b30421f1c$var$variableToRgba).replace($bd140d0b30421f1c$var$colorRegex, $bd140d0b30421f1c$export$61db176b839af1f).replace($bd140d0b30421f1c$var$namedColorRegex, $bd140d0b30421f1c$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($bd140d0b30421f1c$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$bd140d0b30421f1c$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$bd140d0b30421f1c$var$unitRegex.test(output[0]) && output.find((value)=>$bd140d0b30421f1c$var$unitRegex.test(value))?.replace($bd140d0b30421f1c$var$numberRegex, "");
        let i = 0;
        return output[0].replace($bd140d0b30421f1c$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($bd140d0b30421f1c$var$rgbaRegex, $bd140d0b30421f1c$var$rgbaRound);
    };
};
// src/deprecations.ts
var $bd140d0b30421f1c$export$82e9f45cca5ba907 = "react-spring: ";
var $bd140d0b30421f1c$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$bd140d0b30421f1c$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $bd140d0b30421f1c$var$warnInterpolate = $bd140d0b30421f1c$export$d2de3aaeafa91619(console.warn);
function $bd140d0b30421f1c$export$2abfcde8ae218ba8() {
    $bd140d0b30421f1c$var$warnInterpolate(`${$bd140d0b30421f1c$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $bd140d0b30421f1c$var$warnDirectCall = $bd140d0b30421f1c$export$d2de3aaeafa91619(console.warn);
function $bd140d0b30421f1c$export$d99d974913ad3b12() {
    $bd140d0b30421f1c$var$warnDirectCall(`${$bd140d0b30421f1c$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $bd140d0b30421f1c$export$75bed621f62abfa9(value) {
    return $bd140d0b30421f1c$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$bd140d0b30421f1c$export$48d7c418edadb60c() && $bd140d0b30421f1c$var$cssVariableRegex.test(value) || value in ($bd140d0b30421f1c$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $bd140d0b30421f1c$var$observer;
var $bd140d0b30421f1c$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $bd140d0b30421f1c$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $bd140d0b30421f1c$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $bd140d0b30421f1c$var$resizeElement(handler, target) {
    if (!$bd140d0b30421f1c$var$observer) {
        if (typeof ResizeObserver !== "undefined") $bd140d0b30421f1c$var$observer = new ResizeObserver($bd140d0b30421f1c$var$handleObservation);
    }
    let elementHandlers = $bd140d0b30421f1c$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $bd140d0b30421f1c$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($bd140d0b30421f1c$var$observer) $bd140d0b30421f1c$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $bd140d0b30421f1c$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $bd140d0b30421f1c$var$observer) $bd140d0b30421f1c$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $bd140d0b30421f1c$var$listeners = /* @__PURE__ */ new Set();
var $bd140d0b30421f1c$var$cleanupWindowResizeHandler;
var $bd140d0b30421f1c$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $bd140d0b30421f1c$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $bd140d0b30421f1c$var$resizeWindow = (callback)=>{
    $bd140d0b30421f1c$var$listeners.add(callback);
    if (!$bd140d0b30421f1c$var$cleanupWindowResizeHandler) $bd140d0b30421f1c$var$cleanupWindowResizeHandler = $bd140d0b30421f1c$var$createResizeHandler();
    return ()=>{
        $bd140d0b30421f1c$var$listeners.delete(callback);
        if (!$bd140d0b30421f1c$var$listeners.size && $bd140d0b30421f1c$var$cleanupWindowResizeHandler) {
            $bd140d0b30421f1c$var$cleanupWindowResizeHandler();
            $bd140d0b30421f1c$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $bd140d0b30421f1c$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $bd140d0b30421f1c$var$resizeWindow(callback);
    else return $bd140d0b30421f1c$var$resizeElement(callback, container);
};
// src/progress.ts
var $bd140d0b30421f1c$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $bd140d0b30421f1c$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $bd140d0b30421f1c$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $bd140d0b30421f1c$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
            axis.progress = $bd140d0b30421f1c$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $bd140d0b30421f1c$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $bd140d0b30421f1c$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $bd140d0b30421f1c$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $bd140d0b30421f1c$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $bd140d0b30421f1c$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $bd140d0b30421f1c$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $bd140d0b30421f1c$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $bd140d0b30421f1c$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$bd140d0b30421f1c$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $bd140d0b30421f1c$var$scrollListeners.set(container, listener);
        const target = $bd140d0b30421f1c$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $bd140d0b30421f1c$var$resizeListeners.set(container, $bd140d0b30421f1c$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $bd140d0b30421f1c$var$scrollListeners.get(container);
    $bd140d0b30421f1c$export$27f233d61a9e2fa4(animateScroll);
    return ()=>{
        $bd140d0b30421f1c$export$27f233d61a9e2fa4.cancel(animateScroll);
        const containerHandlers2 = $bd140d0b30421f1c$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $bd140d0b30421f1c$var$scrollListeners.get(container);
        $bd140d0b30421f1c$var$scrollListeners.delete(container);
        if (listener) {
            $bd140d0b30421f1c$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $bd140d0b30421f1c$var$resizeListeners.get(container)?.();
        }
    };
};
function $bd140d0b30421f1c$export$fe4300aa8eebea86(init) {
    const ref = (0, $lT7pJ.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $bd140d0b30421f1c$export$700979bc83e7db82 = $bd140d0b30421f1c$export$48d7c418edadb60c() ? (0, $lT7pJ.useEffect) : (0, $lT7pJ.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $bd140d0b30421f1c$var$useIsMounted = ()=>{
    const isMounted = (0, $lT7pJ.useRef)(false);
    $bd140d0b30421f1c$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $bd140d0b30421f1c$export$91db9bc4f8ac944a() {
    const update2 = (0, $lT7pJ.useState)()[1];
    const isMounted = $bd140d0b30421f1c$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update2(Math.random());
    };
}
function $bd140d0b30421f1c$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $lT7pJ.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $lT7pJ.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $bd140d0b30421f1c$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $lT7pJ.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $bd140d0b30421f1c$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $bd140d0b30421f1c$export$392544347a18b6ea = (effect)=>(0, $lT7pJ.useEffect)(effect, $bd140d0b30421f1c$var$emptyDeps);
var $bd140d0b30421f1c$var$emptyDeps = [];
function $bd140d0b30421f1c$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $lT7pJ.useRef)();
    (0, $lT7pJ.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $bd140d0b30421f1c$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $lT7pJ.useState)(null);
    $bd140d0b30421f1c$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $bd140d0b30421f1c$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        mql.addEventListener("change", handleMediaChange);
        return ()=>{
            mql.removeEventListener("change", handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $lT7pJ = parcelRequire("lT7pJ");
// src/Animated.ts


var $lT7pJ = parcelRequire("lT7pJ");
var $175602e263940ee8$var$$node = Symbol.for("Animated:node");
var $175602e263940ee8$export$3df5e165e801a70f = (value)=>!!value && value[$175602e263940ee8$var$$node] === value;
var $175602e263940ee8$export$6b63995194a3a9e4 = (owner)=>owner && owner[$175602e263940ee8$var$$node];
var $175602e263940ee8$export$b553cb5b22b81b04 = (owner, node)=>(0, $bd140d0b30421f1c$export$5c74248ea0e35446)(owner, $175602e263940ee8$var$$node, node);
var $175602e263940ee8$export$ccab2b64c5d440 = (owner)=>owner && owner[$175602e263940ee8$var$$node] && owner[$175602e263940ee8$var$$node].getPayload();
var $175602e263940ee8$export$31627395a3b18e54 = class {
    constructor(){
        $175602e263940ee8$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $175602e263940ee8$export$cb1e8f3c05d37ad5 = class extends $175602e263940ee8$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $175602e263940ee8$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $175602e263940ee8$export$f6c6c4cbd7fa5b93 = class extends $175602e263940ee8$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $bd140d0b30421f1c$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $175602e263940ee8$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $bd140d0b30421f1c$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $175602e263940ee8$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $175602e263940ee8$export$f1b0b9e366a6e2d4 = class extends $175602e263940ee8$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($175602e263940ee8$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $bd140d0b30421f1c$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($175602e263940ee8$var$TreeContext.dependencies && (0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(source)) $175602e263940ee8$var$TreeContext.dependencies.add(source);
        const payload = $175602e263940ee8$export$ccab2b64c5d440(source);
        if (payload) (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $175602e263940ee8$export$ede394683406942d = class extends $175602e263940ee8$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $175602e263940ee8$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($175602e263940ee8$var$makeAnimated));
        return true;
    }
};
function $175602e263940ee8$var$makeAnimated(value) {
    const nodeType = (0, $bd140d0b30421f1c$export$75bed621f62abfa9)(value) ? $175602e263940ee8$export$f6c6c4cbd7fa5b93 : $175602e263940ee8$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $175602e263940ee8$export$e6b77ddbe47b132e(value) {
    const parentNode = $175602e263940ee8$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(value) ? $175602e263940ee8$export$ede394683406942d : (0, $bd140d0b30421f1c$export$75bed621f62abfa9)(value) ? $175602e263940ee8$export$f6c6c4cbd7fa5b93 : $175602e263940ee8$export$cb1e8f3c05d37ad5;
}
var $175602e263940ee8$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $lT7pJ.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $lT7pJ.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $lT7pJ.useCallback)((value)=>{
            instanceRef.current = $175602e263940ee8$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $175602e263940ee8$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $bd140d0b30421f1c$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $175602e263940ee8$var$PropsObserver(callback, deps);
        const observerRef = (0, $lT7pJ.useRef)();
        (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(deps, (dep)=>(0, $bd140d0b30421f1c$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $bd140d0b30421f1c$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $lT7pJ.useEffect)(callback, []);
        (0, $bd140d0b30421f1c$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $bd140d0b30421f1c$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $lT7pJ.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $175602e263940ee8$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $175602e263940ee8$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $175602e263940ee8$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $175602e263940ee8$export$f1b0b9e366a6e2d4(props);
    $175602e263940ee8$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $175602e263940ee8$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $175602e263940ee8$var$cacheKey = Symbol.for("AnimatedComponent");
var $175602e263940ee8$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $175602e263940ee8$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $175602e263940ee8$var$getDisplayName(Component) || "Anonymous";
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $175602e263940ee8$var$withAnimated(Component, hostConfig));
        else Component = Component[$175602e263940ee8$var$cacheKey] || (Component[$175602e263940ee8$var$cacheKey] = $175602e263940ee8$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(components)) key = $175602e263940ee8$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $175602e263940ee8$var$getDisplayName = (arg)=>(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $0503d0f861979920$export$b24b633b1364b94b = class {
};


function $b3147ce4de9960c3$var$callProp(value, ...args) {
    return (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $b3147ce4de9960c3$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $bd140d0b30421f1c$export$45b10814cc054894)(value).includes(key)));
var $b3147ce4de9960c3$var$resolveProp = (prop, key)=>(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $b3147ce4de9960c3$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $b3147ce4de9960c3$var$noopTransform = (value)=>value;
var $b3147ce4de9960c3$var$getDefaultProps = (props, transform = $b3147ce4de9960c3$var$noopTransform)=>{
    let keys = $b3147ce4de9960c3$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $b3147ce4de9960c3$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $b3147ce4de9960c3$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $b3147ce4de9960c3$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$b3147ce4de9960c3$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $b3147ce4de9960c3$export$b971039a739bf227(props) {
    const to2 = $b3147ce4de9960c3$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $b3147ce4de9960c3$var$computeGoal(value) {
    value = (0, $bd140d0b30421f1c$export$e37b7520edd66839)(value);
    return (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(value) ? value.map($b3147ce4de9960c3$var$computeGoal) : (0, $bd140d0b30421f1c$export$75bed621f62abfa9)(value) ? (0, $bd140d0b30421f1c$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $b3147ce4de9960c3$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $b3147ce4de9960c3$var$isAsyncTo(to2) {
    return (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(to2) || (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(to2) && (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $b3147ce4de9960c3$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $b3147ce4de9960c3$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $b3147ce4de9960c3$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $b3147ce4de9960c3$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $bd140d0b30421f1c$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $b3147ce4de9960c3$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $b3147ce4de9960c3$var$defaults = {
    ...$b3147ce4de9960c3$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $bd140d0b30421f1c$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $b3147ce4de9960c3$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $b3147ce4de9960c3$var$defaults);
    }
};
function $b3147ce4de9960c3$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $b3147ce4de9960c3$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $b3147ce4de9960c3$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $b3147ce4de9960c3$var$defaults)if (config2[key] == null) config2[key] = $b3147ce4de9960c3$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $b3147ce4de9960c3$var$sanitizeConfig(config2, props) {
    if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props.tension) || !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props.damping) || !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $b3147ce4de9960c3$var$emptyArray = [];
var $b3147ce4de9960c3$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $b3147ce4de9960c3$var$emptyArray;
        this.toValues = null;
        this.fromValues = $b3147ce4de9960c3$var$emptyArray;
        this.config = new $b3147ce4de9960c3$var$AnimationConfig();
        this.immediate = false;
    }
};
function $b3147ce4de9960c3$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $b3147ce4de9960c3$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $b3147ce4de9960c3$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $b3147ce4de9960c3$var$matchProp(pause, key);
            delay = $b3147ce4de9960c3$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $bd140d0b30421f1c$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $b3147ce4de9960c3$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $b3147ce4de9960c3$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $b3147ce4de9960c3$var$getNoopResult(target.get()) : $b3147ce4de9960c3$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $b3147ce4de9960c3$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $b3147ce4de9960c3$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $b3147ce4de9960c3$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $b3147ce4de9960c3$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $b3147ce4de9960c3$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $b3147ce4de9960c3$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $b3147ce4de9960c3$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $b3147ce4de9960c3$export$d362d093fa99dc7();
            const skipAnimationSignal = new $b3147ce4de9960c3$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $bd140d0b30421f1c$export$cceeabf822b64fc0).skipAnimation) {
                    $b3147ce4de9960c3$var$stopAsync(state);
                    skipAnimationSignal.result = $b3147ce4de9960c3$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $bd140d0b30421f1c$export$cceeabf822b64fc0).skipAnimation) {
            $b3147ce4de9960c3$var$stopAsync(state);
            return $b3147ce4de9960c3$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $b3147ce4de9960c3$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $b3147ce4de9960c3$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $b3147ce4de9960c3$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(onRest)) (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $b3147ce4de9960c3$var$stopAsync(state, cancelId) {
    (0, $bd140d0b30421f1c$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $b3147ce4de9960c3$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $b3147ce4de9960c3$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $b3147ce4de9960c3$var$isFrameValue = (value)=>value instanceof $b3147ce4de9960c3$export$8229896f80e2495e;
var $b3147ce4de9960c3$var$nextId = 1;
var $b3147ce4de9960c3$export$8229896f80e2495e = class extends (0, $bd140d0b30421f1c$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $b3147ce4de9960c3$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $175602e263940ee8$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $bd140d0b30421f1c$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $bd140d0b30421f1c$export$2abfcde8ae218ba8)();
        return (0, $bd140d0b30421f1c$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $bd140d0b30421f1c$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $bd140d0b30421f1c$export$a57f5080a3bcc90a).sort(this);
        (0, $bd140d0b30421f1c$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $b3147ce4de9960c3$var$$P = Symbol.for("SpringPhase");
var $b3147ce4de9960c3$var$HAS_ANIMATED = 1;
var $b3147ce4de9960c3$var$IS_ANIMATING = 2;
var $b3147ce4de9960c3$var$IS_PAUSED = 4;
var $b3147ce4de9960c3$var$hasAnimated = (target)=>(target[$b3147ce4de9960c3$var$$P] & $b3147ce4de9960c3$var$HAS_ANIMATED) > 0;
var $b3147ce4de9960c3$var$isAnimating = (target)=>(target[$b3147ce4de9960c3$var$$P] & $b3147ce4de9960c3$var$IS_ANIMATING) > 0;
var $b3147ce4de9960c3$var$isPaused = (target)=>(target[$b3147ce4de9960c3$var$$P] & $b3147ce4de9960c3$var$IS_PAUSED) > 0;
var $b3147ce4de9960c3$var$setActiveBit = (target, active)=>active ? target[$b3147ce4de9960c3$var$$P] |= $b3147ce4de9960c3$var$IS_ANIMATING | $b3147ce4de9960c3$var$HAS_ANIMATED : target[$b3147ce4de9960c3$var$$P] &= ~$b3147ce4de9960c3$var$IS_ANIMATING;
var $b3147ce4de9960c3$var$setPausedBit = (target, paused)=>paused ? target[$b3147ce4de9960c3$var$$P] |= $b3147ce4de9960c3$var$IS_PAUSED : target[$b3147ce4de9960c3$var$$P] &= ~$b3147ce4de9960c3$var$IS_PAUSED;
// src/SpringValue.ts
var $b3147ce4de9960c3$export$5854d13427d5a954 = class extends $b3147ce4de9960c3$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $b3147ce4de9960c3$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(arg1) || !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($b3147ce4de9960c3$var$isAnimating(this) || this._state.asyncTo) || $b3147ce4de9960c3$var$isPaused(this);
    }
    get goal() {
        return (0, $bd140d0b30421f1c$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $175602e263940ee8$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $175602e263940ee8$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $b3147ce4de9960c3$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $b3147ce4de9960c3$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $b3147ce4de9960c3$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $175602e263940ee8$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $bd140d0b30421f1c$export$45b10814cc054894)((0, $bd140d0b30421f1c$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $175602e263940ee8$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $175602e263940ee8$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $bd140d0b30421f1c$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($b3147ce4de9960c3$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$b3147ce4de9960c3$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $b3147ce4de9960c3$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $b3147ce4de9960c3$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$b3147ce4de9960c3$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $bd140d0b30421f1c$export$e37b7520edd66839)(from);
            if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $175602e263940ee8$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $b3147ce4de9960c3$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $b3147ce4de9960c3$var$resolveProp(value, key) : value));
        $b3147ce4de9960c3$var$mergeActiveFn(this, props, "onProps");
        $b3147ce4de9960c3$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $b3147ce4de9960c3$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$b3147ce4de9960c3$var$isPaused(this)) {
                        $b3147ce4de9960c3$var$setPausedBit(this, true);
                        (0, $bd140d0b30421f1c$export$7ba486852759e806)(state.pauseQueue);
                        $b3147ce4de9960c3$var$sendEvent(this, "onPause", $b3147ce4de9960c3$var$getFinishedResult(this, $b3147ce4de9960c3$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($b3147ce4de9960c3$var$isPaused(this)) {
                        $b3147ce4de9960c3$var$setPausedBit(this, false);
                        if ($b3147ce4de9960c3$var$isAnimating(this)) this._resume();
                        (0, $bd140d0b30421f1c$export$7ba486852759e806)(state.resumeQueue);
                        $b3147ce4de9960c3$var$sendEvent(this, "onResume", $b3147ce4de9960c3$var$getFinishedResult(this, $b3147ce4de9960c3$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $b3147ce4de9960c3$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($b3147ce4de9960c3$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($b3147ce4de9960c3$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $bd140d0b30421f1c$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $bd140d0b30421f1c$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $bd140d0b30421f1c$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $b3147ce4de9960c3$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $b3147ce4de9960c3$var$mergeConfig(config2, $b3147ce4de9960c3$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $b3147ce4de9960c3$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $175602e263940ee8$export$6b63995194a3a9e4)(this);
        if (!node || (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(to2)) return resolve($b3147ce4de9960c3$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(from) && $b3147ce4de9960c3$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $b3147ce4de9960c3$var$computeGoal(to2);
        const isAnimatable = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).num(goal) || (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(goal) || (0, $bd140d0b30421f1c$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $b3147ce4de9960c3$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $175602e263940ee8$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$b3147ce4de9960c3$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $bd140d0b30421f1c$export$248d38f6296296c5)($b3147ce4de9960c3$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $bd140d0b30421f1c$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $bd140d0b30421f1c$export$248d38f6296296c5)(config2.decay, decay) || !(0, $bd140d0b30421f1c$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $b3147ce4de9960c3$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $175602e263940ee8$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $bd140d0b30421f1c$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $bd140d0b30421f1c$export$79b2f7037acddd43)($b3147ce4de9960c3$var$ACTIVE_EVENTS, (type)=>$b3147ce4de9960c3$var$mergeActiveFn(this, props, type));
                const result = $b3147ce4de9960c3$var$getFinishedResult(this, $b3147ce4de9960c3$var$checkFinished(this, prevTo));
                (0, $bd140d0b30421f1c$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $b3147ce4de9960c3$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($b3147ce4de9960c3$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($b3147ce4de9960c3$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($b3147ce4de9960c3$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $bd140d0b30421f1c$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $bd140d0b30421f1c$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(to2)) {
            (0, $bd140d0b30421f1c$export$72d604e3f8d000a5)(to2, this);
            if ($b3147ce4de9960c3$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(to2)) (0, $bd140d0b30421f1c$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $bd140d0b30421f1c$export$e37b7520edd66839)(arg);
        if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $175602e263940ee8$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $bd140d0b30421f1c$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $175602e263940ee8$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $175602e263940ee8$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $175602e263940ee8$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $b3147ce4de9960c3$var$sendEvent(this, "onStart", $b3147ce4de9960c3$var$getFinishedResult(this, $b3147ce4de9960c3$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $b3147ce4de9960c3$var$callProp(this.animation.onChange, value, this);
        }
        $b3147ce4de9960c3$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $175602e263940ee8$export$6b63995194a3a9e4)(this).reset((0, $bd140d0b30421f1c$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$b3147ce4de9960c3$var$isAnimating(this)) {
            $b3147ce4de9960c3$var$setActiveBit(this, true);
            if (!$b3147ce4de9960c3$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $bd140d0b30421f1c$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $bd140d0b30421f1c$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($b3147ce4de9960c3$var$isAnimating(this)) {
            $b3147ce4de9960c3$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $bd140d0b30421f1c$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $b3147ce4de9960c3$var$getCancelledResult(this.get()) : $b3147ce4de9960c3$var$getFinishedResult(this.get(), $b3147ce4de9960c3$var$checkFinished(this, goal ?? anim.to));
            (0, $bd140d0b30421f1c$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $b3147ce4de9960c3$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $b3147ce4de9960c3$var$checkFinished(target, to2) {
    const goal = $b3147ce4de9960c3$var$computeGoal(to2);
    const value = $b3147ce4de9960c3$var$computeGoal(target.get());
    return (0, $bd140d0b30421f1c$export$248d38f6296296c5)(value, goal);
}
function $b3147ce4de9960c3$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $b3147ce4de9960c3$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $b3147ce4de9960c3$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $b3147ce4de9960c3$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $b3147ce4de9960c3$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $b3147ce4de9960c3$var$createUpdate(props) {
    const { to: to2, from: from } = props = $b3147ce4de9960c3$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(to2)) $b3147ce4de9960c3$var$findDefined(to2, keys);
    if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(from)) $b3147ce4de9960c3$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $b3147ce4de9960c3$var$declareUpdate(props) {
    const update2 = $b3147ce4de9960c3$var$createUpdate(props);
    if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $b3147ce4de9960c3$var$getDefaultProps(update2);
    return update2;
}
function $b3147ce4de9960c3$var$findDefined(values, keys) {
    (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $b3147ce4de9960c3$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $b3147ce4de9960c3$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $b3147ce4de9960c3$var$getDefaultProp(props, type) ? $b3147ce4de9960c3$var$resolveProp(props[type], target.key) : void 0;
}
function $b3147ce4de9960c3$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $b3147ce4de9960c3$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $b3147ce4de9960c3$var$nextId2 = 1;
var $b3147ce4de9960c3$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $b3147ce4de9960c3$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($b3147ce4de9960c3$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $bd140d0b30421f1c$export$45b10814cc054894)(props).map($b3147ce4de9960c3$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $b3147ce4de9960c3$var$prepareKeys(this, queue);
        return $b3147ce4de9960c3$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)((0, $bd140d0b30421f1c$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $b3147ce4de9960c3$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)((0, $bd140d0b30421f1c$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)((0, $bd140d0b30421f1c$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $bd140d0b30421f1c$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $bd140d0b30421f1c$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $bd140d0b30421f1c$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $b3147ce4de9960c3$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$b3147ce4de9960c3$var$flushUpdate(ctrl, props))).then((results)=>$b3147ce4de9960c3$var$getCombinedResult(ctrl, results));
}
async function $b3147ce4de9960c3$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(to2) || (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $bd140d0b30421f1c$export$79b2f7037acddd43)($b3147ce4de9960c3$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $bd140d0b30421f1c$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $b3147ce4de9960c3$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($b3147ce4de9960c3$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $bd140d0b30421f1c$export$8793edee2d425525),
            resume: (0, $bd140d0b30421f1c$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $b3147ce4de9960c3$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($b3147ce4de9960c3$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($b3147ce4de9960c3$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $b3147ce4de9960c3$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $b3147ce4de9960c3$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $b3147ce4de9960c3$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $b3147ce4de9960c3$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $b3147ce4de9960c3$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $bd140d0b30421f1c$export$79b2f7037acddd43)((0, $bd140d0b30421f1c$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $b3147ce4de9960c3$var$createUpdate(props2);
        if (!(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $b3147ce4de9960c3$var$prepareSprings(springs, props2, (key)=>{
            return $b3147ce4de9960c3$var$createSpring(key);
        });
    });
    $b3147ce4de9960c3$var$setSprings(ctrl, springs);
    return springs;
}
function $b3147ce4de9960c3$var$setSprings(ctrl, springs) {
    (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $bd140d0b30421f1c$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $b3147ce4de9960c3$var$createSpring(key, observer) {
    const spring = new $b3147ce4de9960c3$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $bd140d0b30421f1c$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $b3147ce4de9960c3$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $b3147ce4de9960c3$var$prepareKeys(ctrl, queue) {
    (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(queue, (props)=>{
        $b3147ce4de9960c3$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $b3147ce4de9960c3$var$createSpring(key, ctrl);
        });
    });
}
var $b3147ce4de9960c3$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $lT7pJ.useContext)($b3147ce4de9960c3$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $bd140d0b30421f1c$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $b3147ce4de9960c3$var$ctx;
    return /* @__PURE__ */ $lT7pJ.createElement(Provider, {
        value: props
    }, children);
};
var $b3147ce4de9960c3$var$ctx = $b3147ce4de9960c3$var$makeContext($b3147ce4de9960c3$export$f12a216ec50d2cf1, {});
$b3147ce4de9960c3$export$f12a216ec50d2cf1.Provider = $b3147ce4de9960c3$var$ctx.Provider;
$b3147ce4de9960c3$export$f12a216ec50d2cf1.Consumer = $b3147ce4de9960c3$var$ctx.Consumer;
function $b3147ce4de9960c3$var$makeContext(target, init) {
    Object.assign(target, $lT7pJ.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $b3147ce4de9960c3$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $bd140d0b30421f1c$export$d99d974913ad3b12)();
        const results = [];
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $b3147ce4de9960c3$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $lT7pJ.useMemo)(()=>propsFn || arguments.length == 3 ? $b3147ce4de9960c3$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $lT7pJ.useRef)(0);
    const forceUpdate = (0, $bd140d0b30421f1c$export$91db9bc4f8ac944a)();
    const state = (0, $lT7pJ.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $b3147ce4de9960c3$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $b3147ce4de9960c3$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $b3147ce4de9960c3$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($b3147ce4de9960c3$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $lT7pJ.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $bd140d0b30421f1c$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $lT7pJ.useMemo)(()=>{
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $b3147ce4de9960c3$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $lT7pJ.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $b3147ce4de9960c3$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $b3147ce4de9960c3$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$b3147ce4de9960c3$var$getSprings(ctrl, updates[i]));
    const context = (0, $lT7pJ.useContext)($b3147ce4de9960c3$export$f12a216ec50d2cf1);
    const prevContext = (0, $bd140d0b30421f1c$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $b3147ce4de9960c3$var$hasProps(context);
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $b3147ce4de9960c3$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $bd140d0b30421f1c$export$392544347a18b6ea)(()=>()=>{
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $b3147ce4de9960c3$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $b3147ce4de9960c3$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $b3147ce4de9960c3$var$initSpringRef = ()=>$b3147ce4de9960c3$export$2471ae76e2946684();
var $b3147ce4de9960c3$export$564bff9c23cad2ca = ()=>(0, $lT7pJ.useState)($b3147ce4de9960c3$var$initSpringRef)[0];
var $b3147ce4de9960c3$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $bd140d0b30421f1c$export$fe4300aa8eebea86)(()=>new $b3147ce4de9960c3$export$5854d13427d5a954(initial, props));
    (0, $bd140d0b30421f1c$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $b3147ce4de9960c3$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $b3147ce4de9960c3$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $b3147ce4de9960c3$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $b3147ce4de9960c3$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $lT7pJ.useMemo)(()=>propsFn || arguments.length == 3 ? $b3147ce4de9960c3$export$2471ae76e2946684() : void 0, []);
    const items = (0, $bd140d0b30421f1c$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $lT7pJ.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $bd140d0b30421f1c$export$392544347a18b6ea)(()=>{
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $b3147ce4de9960c3$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $b3147ce4de9960c3$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>(0, $bd140d0b30421f1c$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $b3147ce4de9960c3$var$detachRefs(ctrl, ref);
            $b3147ce4de9960c3$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $b3147ce4de9960c3$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $bd140d0b30421f1c$export$91db9bc4f8ac944a)();
    const defaultProps = $b3147ce4de9960c3$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $lT7pJ.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $lT7pJ.useRef)(false);
    (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $b3147ce4de9960c3$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $b3147ce4de9960c3$var$callProp(to2, t.item, i);
        to2 = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).obj(to2) ? $b3147ce4de9960c3$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $b3147ce4de9960c3$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $b3147ce4de9960c3$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $b3147ce4de9960c3$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $b3147ce4de9960c3$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $b3147ce4de9960c3$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $lT7pJ.useContext)($b3147ce4de9960c3$export$f12a216ec50d2cf1);
    const prevContext = (0, $bd140d0b30421f1c$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $b3147ce4de9960c3$var$hasProps(context);
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $b3147ce4de9960c3$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $lT7pJ.createElement($lT7pJ.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $lT7pJ.createElement(elem.type, {
                ...elem.props,
                key: (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).str(t.key) || (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $b3147ce4de9960c3$var$nextKey = 1;
function $b3147ce4de9960c3$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $b3147ce4de9960c3$var$nextKey++;
        });
    }
    return (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(keys) ? items : (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $bd140d0b30421f1c$export$45b10814cc054894)(keys);
}
var $b3147ce4de9960c3$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $b3147ce4de9960c3$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $bd140d0b30421f1c$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $b3147ce4de9960c3$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $b3147ce4de9960c3$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $bd140d0b30421f1c$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $b3147ce4de9960c3$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $b3147ce4de9960c3$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $lT7pJ.useState)(false);
    const ref = (0, $lT7pJ.useRef)();
    const propsFn = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $b3147ce4de9960c3$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $bd140d0b30421f1c$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $b3147ce4de9960c3$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $b3147ce4de9960c3$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($b3147ce4de9960c3$export$c4af9125706c4d30(props));
}
function $b3147ce4de9960c3$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $b3147ce4de9960c3$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $b3147ce4de9960c3$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $b3147ce4de9960c3$export$7b286972b8d8ccbf(items, props)(children);
}
var $b3147ce4de9960c3$export$b0cc4f9860136880 = class extends $b3147ce4de9960c3$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $bd140d0b30421f1c$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $175602e263940ee8$export$e6b77ddbe47b132e)(value);
        (0, $175602e263940ee8$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $bd140d0b30421f1c$export$248d38f6296296c5)(value, oldValue)) {
            (0, $175602e263940ee8$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $b3147ce4de9960c3$var$checkIdle(this._active)) $b3147ce4de9960c3$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $bd140d0b30421f1c$export$e37b7520edd66839)) : (0, $bd140d0b30421f1c$export$45b10814cc054894)((0, $bd140d0b30421f1c$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$b3147ce4de9960c3$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $bd140d0b30421f1c$export$79b2f7037acddd43)((0, $175602e263940ee8$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $bd140d0b30421f1c$export$cceeabf822b64fc0).skipAnimation) {
                (0, $bd140d0b30421f1c$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $b3147ce4de9960c3$var$becomeIdle(this);
            } else (0, $bd140d0b30421f1c$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)((0, $bd140d0b30421f1c$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(source)) (0, $bd140d0b30421f1c$export$72d604e3f8d000a5)(source, this);
            if ($b3147ce4de9960c3$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)((0, $bd140d0b30421f1c$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(source)) (0, $bd140d0b30421f1c$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $b3147ce4de9960c3$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $bd140d0b30421f1c$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($b3147ce4de9960c3$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $b3147ce4de9960c3$var$isIdle(source) {
    return source.idle !== false;
}
function $b3147ce4de9960c3$var$checkIdle(active) {
    return !active.size || Array.from(active).every($b3147ce4de9960c3$var$isIdle);
}
function $b3147ce4de9960c3$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)((0, $175602e263940ee8$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $bd140d0b30421f1c$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $b3147ce4de9960c3$export$2c618a4308a30424 = (source, ...args)=>new $b3147ce4de9960c3$export$b0cc4f9860136880(source, args);
var $b3147ce4de9960c3$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $bd140d0b30421f1c$export$2abfcde8ae218ba8)(), new $b3147ce4de9960c3$export$b0cc4f9860136880(source, args));
(0, $bd140d0b30421f1c$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $bd140d0b30421f1c$export$4759a013d387347a,
    to: (source, args)=>new $b3147ce4de9960c3$export$b0cc4f9860136880(source, args)
});
var $b3147ce4de9960c3$export$722fbec263ad908a = (0, $bd140d0b30421f1c$export$a57f5080a3bcc90a).advance;





// src/applyAnimatedValues.ts
var $dc32a48dada8397f$var$isCustomPropRE = /^--/;
function $dc32a48dada8397f$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$dc32a48dada8397f$var$isCustomPropRE.test(name) && !($dc32a48dada8397f$var$isUnitlessNumber.hasOwnProperty(name) && $dc32a48dada8397f$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $dc32a48dada8397f$var$attributeCache = {};
function $dc32a48dada8397f$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $dc32a48dada8397f$var$attributeCache[name] || ($dc32a48dada8397f$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $dc32a48dada8397f$var$dangerousStyleValue(name, style[name]);
        if ($dc32a48dada8397f$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $dc32a48dada8397f$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $dc32a48dada8397f$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $dc32a48dada8397f$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$dc32a48dada8397f$var$isUnitlessNumber = Object.keys($dc32a48dada8397f$var$isUnitlessNumber).reduce((acc, prop)=>{
    $dc32a48dada8397f$var$prefixes.forEach((prefix)=>acc[$dc32a48dada8397f$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $dc32a48dada8397f$var$isUnitlessNumber);
var $dc32a48dada8397f$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $dc32a48dada8397f$var$pxTransforms = /^(translate)/;
var $dc32a48dada8397f$var$degTransforms = /^(rotate|skew)/;
var $dc32a48dada8397f$var$addUnit = (value, unit)=>(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $dc32a48dada8397f$var$isValueIdentity = (value, id)=>(0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$dc32a48dada8397f$var$isValueIdentity(v, id)) : (0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $dc32a48dada8397f$var$AnimatedStyle = class extends (0, $175602e263940ee8$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$dc32a48dada8397f$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $dc32a48dada8397f$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $bd140d0b30421f1c$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($dc32a48dada8397f$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $dc32a48dada8397f$var$pxTransforms.test(key) ? "px" : $dc32a48dada8397f$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $bd140d0b30421f1c$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$dc32a48dada8397f$var$addUnit(deg, unit)})`,
                        $dc32a48dada8397f$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$dc32a48dada8397f$var$addUnit(v, unit)).join(",")})`,
                        $dc32a48dada8397f$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $dc32a48dada8397f$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $dc32a48dada8397f$var$FluidTransform = class extends (0, $bd140d0b30421f1c$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $bd140d0b30421f1c$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $bd140d0b30421f1c$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $bd140d0b30421f1c$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $bd140d0b30421f1c$export$79b2f7037acddd43)(input, (value)=>(0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(value) && (0, $bd140d0b30421f1c$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $bd140d0b30421f1c$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $bd140d0b30421f1c$export$79b2f7037acddd43)(input, (value)=>(0, $bd140d0b30421f1c$export$57ea7e3a7f6280c7)(value) && (0, $bd140d0b30421f1c$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $bd140d0b30421f1c$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $dc32a48dada8397f$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $bd140d0b30421f1c$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $104722dc8dfafae7$exports.unstable_batchedUpdates),
    createStringInterpolator: $bd140d0b30421f1c$export$4759a013d387347a,
    colors: $bd140d0b30421f1c$export$8f45430ccf837300
});
var $dc32a48dada8397f$var$host = (0, $175602e263940ee8$export$4ee5c78f6dcbcef)($dc32a48dada8397f$var$primitives, {
    applyAnimatedValues: $dc32a48dada8397f$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $dc32a48dada8397f$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $dc32a48dada8397f$export$407448d2b89b1813 = $dc32a48dada8397f$var$host.animated;








var $lT7pJ = parcelRequire("lT7pJ");




var $lT7pJ = parcelRequire("lT7pJ");

const $3f55b239f06aa14f$var$Animation = ({ size: size })=>{
    const customClassName = (0, $lT7pJ.useMemo)(()=>{
        switch(size){
            case (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).small:
                return "rf-loader-mini rf-animate-loaderMini rf-h-2 -rf-top-2";
            case (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).medium:
                return "rf-loader-medium rf-animate-loaderMedium rf-h-4 -rf-top-4";
            case (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).large:
            default:
                return "rf-loader rf-animate-loader rf-h-6 -rf-top-6";
        }
    }, [
        size
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-relative ${customClassName} rf-rounded-half`
    });
};
var $3f55b239f06aa14f$export$2e2bcd8739ae039 = $3f55b239f06aa14f$var$Animation;


const $dfc989789a44be83$var$AnimationContainer = ({ classname: classname, subClassname: subClassname, size: size, useTextColor: useTextColor, triggerScroll: triggerScroll })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const processedClassName = (0, $lT7pJ.useMemo)(()=>{
        return classname || "rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center";
    }, [
        classname
    ]);
    const processedSubClassName = (0, $lT7pJ.useMemo)(()=>{
        return subClassname || "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6";
    }, [
        subClassname
    ]);
    const processedAnimationColor = (0, $lT7pJ.useMemo)(()=>{
        return {
            "--rf-color-loader-animation": useTextColor ? themeColors.textMode.panel.conversationBot : themeColors.card.frame.text
        };
    }, [
        themeColors,
        useTextColor
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        triggerScroll?.();
    }, []);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: processedClassName,
        style: {
            ...processedAnimationColor
        },
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            className: processedSubClassName,
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3f55b239f06aa14f$export$2e2bcd8739ae039), {
                size: size || (isMobile ? (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).medium : (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).large)
            })
        })
    });
};
var $dfc989789a44be83$export$2e2bcd8739ae039 = $dfc989789a44be83$var$AnimationContainer;


const $1b3e8b9ff8a47c6c$var$springDuration = 1050;
const $1b3e8b9ff8a47c6c$var$VoiceInput = ({ className: className })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const lastRecognitionInterim = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.lastRecognitionInterim);
    const isWaitingForResponse = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.isWaitingForResponse);
    const [remainingLastRecognitionInterim, setRemainingLastRecognitionInterim] = (0, $lT7pJ.useState)(null);
    const animationTimerRef = (0, $lT7pJ.useRef)();
    const [spring, api] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                opacity: 1
            }
        }));
    (0, $lT7pJ.useEffect)(()=>{
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        if (lastRecognitionInterim) setRemainingLastRecognitionInterim(lastRecognitionInterim);
        else if (remainingLastRecognitionInterim) {
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $1b3e8b9ff8a47c6c$var$springDuration
                }
            });
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
            animationTimerRef.current = setTimeout(()=>{
                api.set({
                    opacity: 1
                });
                setRemainingLastRecognitionInterim(null);
            }, $1b3e8b9ff8a47c6c$var$springDuration);
        }
    }, [
        lastRecognitionInterim
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: isWaitingForResponse ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $dfc989789a44be83$export$2e2bcd8739ae039), {
            classname: `rf-flex ${isMobile ? "rf-justify-center" : "rf-pl-8 rf-justify-start"} rf-py-3 rf-items-center`,
            subClassname: "rf-w-4 rf-h-4",
            size: (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).medium,
            useTextColor: true
        }) : remainingLastRecognitionInterim && (isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $dc32a48dada8397f$export$407448d2b89b1813).p, {
            className: className,
            style: {
                ...spring
            },
            children: remainingLastRecognitionInterim
        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $dc32a48dada8397f$export$407448d2b89b1813).div, {
            className: "rf-w-full rf-px-4 rf-py-3 rf-subtitle-size-auto rf-font-bold rf-text-truewhite rf-text-shadow-black",
            style: {
                ...spring
            },
            children: remainingLastRecognitionInterim
        }))
    });
};
var $1b3e8b9ff8a47c6c$export$2e2bcd8739ae039 = $1b3e8b9ff8a47c6c$var$VoiceInput;


/* eslint-disable react/self-closing-comp */ 

var $lT7pJ = parcelRequire("lT7pJ");






parcelRequire("lT7pJ");
const $1bb6c2a3a9b42097$var$CloseIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || "currentColor",
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 18L18 6M6 6l12 12"
        })
    });
};
var $1bb6c2a3a9b42097$export$2e2bcd8739ae039 = $1bb6c2a3a9b42097$var$CloseIcon;



parcelRequire("lT7pJ");
const $378d08b46762921f$var$DownloadIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        className: className || "rf-h-6 rf-w-6",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                d: "M20.75 14.38H16V.96c0-.53-.45-.96-1-.96s-1 .43-1 .96v13.42H9.25c-.19 0-.32.2-.22.36l5.75 9.52c.1.16.34.16.44 0l5.75-9.52c.09-.16-.03-.36-.22-.36z",
                fill: color || "currentColor"
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                d: "M29 19.76V27c0 1.1-.86 2-1.93 2H2.93C1.86 29 1 28.1 1 27v-7.24",
                fill: "none",
                stroke: color || "currentColor"
            })
        ]
    });
};
var $378d08b46762921f$export$2e2bcd8739ae039 = $378d08b46762921f$var$DownloadIcon;



parcelRequire("lT7pJ");
const $e1e0df67609bc0b5$var$FeatherCheckIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28.676",
        height: "20.419",
        viewBox: "0 0 28.676 20.419",
        className: className || "rf-w-4 rf-h-4",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M30.434,9l-16.8,16.8L6,18.163",
            transform: "translate(-3.879 -6.879)",
            fill: "none",
            stroke: color || "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "3"
        })
    });
};
var $e1e0df67609bc0b5$export$2e2bcd8739ae039 = $e1e0df67609bc0b5$var$FeatherCheckIcon;



parcelRequire("lT7pJ");
const $bfff57138dc1a66f$var$FeatherFilterIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.333",
        height: "13",
        viewBox: "0 0 14.333 13",
        className: className || "rf-w-6 rf-h-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M16.333,4.5H3l5.333,6.307v4.36L11,16.5V10.807Z",
            transform: "translate(-2.5 -4)",
            fill: "none",
            stroke: color || "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1"
        })
    });
};
var $bfff57138dc1a66f$export$2e2bcd8739ae039 = $bfff57138dc1a66f$var$FeatherFilterIcon;



parcelRequire("lT7pJ");
const $048e611f22f84ada$var$InfoWithCircleIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: className || "rf-h-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 33 33",
            className: "rf-h-full",
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                transform: "translate(-1.5 -1.5)",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M33,18A15,15,0,1,1,18,3,15,15,0,0,1,33,18Z",
                        fill: "none",
                        stroke: color || "#00d7ff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M18,24V18",
                        fill: "none",
                        stroke: color || "#00d7ff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M18,12h0",
                        fill: "none",
                        stroke: color || "#00d7ff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "3"
                    })
                ]
            })
        })
    });
};
var $048e611f22f84ada$export$2e2bcd8739ae039 = $048e611f22f84ada$var$InfoWithCircleIcon;



parcelRequire("lT7pJ");
const $e587bb5ec241b682$var$SendMessageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-w-6",
        viewBox: "0 0 23.207 23.207",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            transform: "translate(0.5 0.707)",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M28.6,3,16.5,15.1",
                    transform: "translate(-6.6 -3)",
                    fill: "none",
                    stroke: color || "#1999b1",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M25,3,17.3,25l-4.4-9.9L3,10.7Z",
                    transform: "translate(-3 -3)",
                    fill: "none",
                    stroke: color || "#1999b1",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
};
var $e587bb5ec241b682$export$2e2bcd8739ae039 = $e587bb5ec241b682$var$SendMessageIcon;



parcelRequire("lT7pJ");
const $699fdce34d546ff4$var$ZoomOutIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 37.91 37.91",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M29.773,4.5l4.844,4.844-6.087,6.044,2.991,2.991,6.044-6.087,4.844,4.844V4.5ZM4.5,17.137l4.844-4.844,6.044,6.087,2.991-2.991L12.293,9.344,17.137,4.5H4.5ZM17.137,42.41l-4.844-4.844,6.087-6.044-2.991-2.991L9.344,34.617,4.5,29.773V42.41ZM42.41,29.773l-4.844,4.844-6.044-6.087-2.991,2.991,6.087,6.044L29.773,42.41H42.41Z",
            transform: "translate(-4.5 -4.5)",
            fill: color || "#00d7ff"
        })
    });
};
var $699fdce34d546ff4$export$2e2bcd8739ae039 = $699fdce34d546ff4$var$ZoomOutIcon;



parcelRequire("lT7pJ");
const $fbd04c9fc08b5261$var$RetorikLogoIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 325 135",
        className: className || "rf-h-6 rf-w-6",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("rect", {
                x: "0",
                y: "-6",
                width: "325",
                height: "143",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M93.6,70.9V50.8c0-14.2-11.5-25.7-25.7-25.7h0c-14.2,0-25.7,11.5-25.7,25.7v20.1c0,14.2,11.5,25.7,25.7,25.7v0   h25.7l-13.3-3.2C88.2,89,93.6,80.6,93.6,70.9z M67.9,89.8C57.5,89.8,49,81.3,49,70.9V50.8c0-10.4,8.5-18.9,18.9-18.9   c10.4,0,18.9,8.5,18.9,18.9v20.1C86.8,81.3,78.3,89.8,67.9,89.8z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M67.9,82.6c-2.3,0-4.5-0.9-6.1-2.5c-0.7-0.7-0.7-1.9,0-2.6c0.7-0.7,1.9-0.7,2.6,0c0.9,0.9,2.2,1.4,3.5,1.4    c1.3,0,2.6-0.5,3.5-1.4c0.7-0.7,1.9-0.7,2.6,0c0.7,0.7,0.7,1.9,0,2.6C72.4,81.7,70.2,82.6,67.9,82.6z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M117.1,61.6V34.9h11.1c1.1,0,2.2,0.2,3.1,0.7c1,0.5,1.8,1.1,2.5,1.9c0.7,0.8,1.2,1.7,1.6,2.7   c0.4,1,0.6,2,0.6,3c0,1-0.2,1.9-0.5,2.8c-0.3,0.9-0.7,1.7-1.3,2.5c-0.6,0.7-1.2,1.3-2,1.8c-0.8,0.5-1.6,0.8-2.6,0.9l6.7,10.4h-2.2   l-6.5-10.1H119v10.1H117.1z M119,49.7h9.4c0.9,0,1.6-0.2,2.3-0.6c0.7-0.4,1.3-0.9,1.8-1.5c0.5-0.6,0.9-1.3,1.1-2.1   c0.3-0.8,0.4-1.6,0.4-2.4c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.7-1.5-1.3-2.1c-0.5-0.6-1.2-1.1-1.9-1.4c-0.7-0.4-1.5-0.5-2.3-0.5H119   V49.7z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M161.6,59.9v1.7h-17.8V34.9h17.5v1.7h-15.5v10.5h13.6v1.7h-13.6v11.1H161.6z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M187.8,36.6H178v25h-1.9v-25h-9.8v-1.7h21.5V36.6z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M203.7,61.8c-1.9,0-3.5-0.4-5.1-1.2c-1.5-0.8-2.8-1.8-4-3c-1.1-1.3-2-2.7-2.6-4.3c-0.6-1.6-0.9-3.3-0.9-5   c0-1.8,0.3-3.5,1-5.1c0.6-1.6,1.5-3.1,2.6-4.3c1.1-1.3,2.4-2.3,4-3c1.5-0.7,3.2-1.1,5-1.1c1.9,0,3.6,0.4,5.1,1.2   c1.5,0.8,2.9,1.8,4,3.1c1.1,1.3,1.9,2.7,2.5,4.3s0.9,3.3,0.9,4.9c0,1.8-0.3,3.5-1,5.2c-0.6,1.6-1.5,3.1-2.6,4.3   c-1.1,1.2-2.4,2.2-4,3C207.1,61.4,205.5,61.8,203.7,61.8z M193.1,48.2c0,1.5,0.3,3,0.8,4.4c0.5,1.4,1.2,2.7,2.2,3.8   c0.9,1.1,2.1,2,3.4,2.6c1.3,0.7,2.7,1,4.3,1c1.6,0,3.1-0.3,4.3-1c1.3-0.7,2.4-1.6,3.3-2.7c0.9-1.1,1.6-2.4,2.1-3.8   c0.5-1.4,0.8-2.8,0.8-4.3c0-1.5-0.3-3-0.8-4.4c-0.5-1.4-1.3-2.7-2.2-3.8c-0.9-1.1-2-2-3.3-2.6c-1.3-0.7-2.7-1-4.2-1   c-1.6,0-3.1,0.3-4.4,1S197,39,196,40.2c-0.9,1.1-1.6,2.4-2.1,3.8C193.4,45.4,193.1,46.8,193.1,48.2z",
                        id: "path19"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M223.7,61.6V34.9h11.1c1.1,0,2.2,0.2,3.1,0.7c1,0.5,1.8,1.1,2.5,1.9c0.7,0.8,1.2,1.7,1.6,2.7   c0.4,1,0.6,2,0.6,3c0,1-0.2,1.9-0.5,2.8c-0.3,0.9-0.7,1.7-1.3,2.5c-0.6,0.7-1.2,1.3-2,1.8c-0.8,0.5-1.6,0.8-2.6,0.9l6.7,10.4h-2.2   l-6.5-10.1h-8.7v10.1H223.7z M225.6,49.7h9.4c0.9,0,1.6-0.2,2.3-0.6c0.7-0.4,1.3-0.9,1.8-1.5c0.5-0.6,0.9-1.3,1.1-2.1   c0.3-0.8,0.4-1.6,0.4-2.4c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.7-1.5-1.3-2.1c-0.5-0.6-1.2-1.1-1.9-1.4c-0.7-0.4-1.5-0.5-2.3-0.5h-9.1   V49.7z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M250.5,61.6V34.9h1.9v26.7H250.5z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        fill: color || "#FFF",
                        d: "M261.7,61.6V34.9h1.9v16.2l15.6-16.2h2.2l-11.1,11.7l11.7,15h-2.2l-10.7-13.8l-5.5,5.6v8.2H261.7z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                                        fill: color || "#FFF",
                                        d: "M122.9,96.1c-1,0-1.9-0.3-2.7-0.8c-0.8-0.5-1.5-1.2-2-2v2.5h-1.1V78.4h1.2v7.7c0.6-0.9,1.3-1.6,2.1-2.1      c0.8-0.5,1.7-0.8,2.8-0.8c0.9,0,1.7,0.2,2.4,0.6c0.7,0.4,1.3,0.9,1.8,1.5c0.5,0.6,0.9,1.3,1.1,2.1c0.3,0.8,0.4,1.6,0.4,2.4      c0,0.9-0.2,1.7-0.5,2.4s-0.7,1.4-1.3,2c-0.5,0.6-1.2,1-1.9,1.4C124.5,95.9,123.7,96.1,122.9,96.1z M122.6,95      c0.7,0,1.4-0.2,2-0.5c0.6-0.3,1.1-0.7,1.6-1.2c0.4-0.5,0.8-1.1,1-1.7c0.2-0.6,0.4-1.3,0.4-2c0-0.7-0.1-1.4-0.3-2      c-0.2-0.6-0.6-1.2-1-1.7c-0.4-0.5-0.9-0.9-1.5-1.2c-0.6-0.3-1.2-0.5-1.9-0.5c-0.5,0-1,0.1-1.5,0.3c-0.5,0.2-0.9,0.4-1.3,0.7      c-0.4,0.3-0.7,0.7-1.1,1.1c-0.3,0.4-0.6,0.8-0.8,1.2v4.1c0,0.5,0.2,0.9,0.5,1.3c0.3,0.4,0.7,0.8,1.1,1.1      c0.4,0.3,0.9,0.5,1.4,0.7C121.7,95,122.2,95,122.6,95z"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                                        fill: color || "#FFF",
                                        d: "M133.3,100.1c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2      c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.3,0.3-0.7,0.5-1.2c0.2-0.5,0.5-1.2,0.9-2.1L131,83.5h1.2l4.9,11.3l4.6-11.3h1.2l-6.8,16.3      c-0.2,0.4-0.5,0.8-0.8,1c-0.4,0.2-0.9,0.4-1.6,0.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0V100.1z"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M213.9,95.9l0.4-0.3c1.4-1.2,2.1-2.7,2.1-4.6l0-8h-2.5V95.9z"
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("polygon", {
                            fill: color || "#FFF",
                            points: "202.9,93.3 196.9,83 193.9,83 201.4,95.9 201.4,95.9 204.4,95.9 204.4,95.9 212,83 208.9,83   "
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M174.1,87.5v3.9c0,2.5,2,4.5,4.5,4.5h8.9c0.7,0,1.4-0.2,2-0.5v0.4h2.5V83l-13.4,0    C176.1,83,174.1,85,174.1,87.5z M189.4,85.5v5.7c-0.1,1.2-1,2.1-2.2,2.1h-8.6c-1.2,0-2.2-1-2.2-2.3v-3.4c0-1.2,1-2.2,2.2-2.2    H189.4z"
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M171.3,75.2l-2.5-0.8v9.1c-0.6-0.3-1.3-0.5-2-0.5H158c-2.5,0-4.5,2-4.5,4.5v3.9c0,2.5,2,4.5,4.5,4.5l13.2,0    h1.4h0.3c-1-1.2-1.6-2.8-1.6-4.5L171.3,75.2z M168.8,93.4h-10.7c-1.2,0-2.2-1-2.2-2.2v-3.4c0-1.2,1-2.2,2.2-2.2h8.5    c1.1,0,2.1,0.9,2.1,2.1V93.4z"
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            fill: color || "#FFF",
                            d: "M215.1,80.6c0.3,0,0.6-0.1,0.9-0.4c0.3-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.3-0.6-0.4-0.9-0.4    c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.4,0.1,0.7,0.4,0.9C214.5,80.5,214.8,80.6,215.1,80.6z"
                        })
                    })
                ]
            })
        ]
    });
};
var $fbd04c9fc08b5261$export$2e2bcd8739ae039 = $fbd04c9fc08b5261$var$RetorikLogoIcon;



parcelRequire("lT7pJ");
const $3be42645e89159d9$var$FileIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 19.908 23.226",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M21.6,7.129a3.016,3.016,0,0,1,.622.985,2.991,2.991,0,0,1,.259,1.141V24.185a1.239,1.239,0,0,1-1.244,1.244H3.815a1.239,1.239,0,0,1-1.244-1.244V3.448A1.239,1.239,0,0,1,3.815,2.2H15.428a2.992,2.992,0,0,1,1.141.259,3.016,3.016,0,0,1,.985.622ZM15.843,3.966V8.839h4.873a1.416,1.416,0,0,0-.285-.531L16.374,4.251a1.416,1.416,0,0,0-.531-.285Zm4.977,19.8V10.5H15.428a1.239,1.239,0,0,1-1.244-1.244V3.862H4.23V23.77H20.82Z",
            transform: "translate(-2.571 -2.203)",
            fill: color || "#00d7ff"
        })
    });
};
var $3be42645e89159d9$export$2e2bcd8739ae039 = $3be42645e89159d9$var$FileIcon;




const $52c5220b9210ea92$var$SendTextBox = ({ className: className, withButton: withButton })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const canFocusSendBox = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.canFocusSendBox);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const [height, setHeight] = (0, $lT7pJ.useState)();
    const [message, setMessage] = (0, $lT7pJ.useState)("");
    const timerRef = (0, $lT7pJ.useRef)(null);
    const textareaRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        if (canFocusSendBox && textareaRef.current && document.activeElement !== textareaRef.current) textareaRef.current.focus();
    }, [
        textareaRef,
        canFocusSendBox
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (textareaRef.current) {
            (0, $7c69764370dcab43$export$c26f98e9bd86d3e3)(textareaRef.current);
            textareaRef.current.addEventListener("focusout", ()=>(0, $1bda010252da638c$export$4a471cf3284fc492)(false));
        }
        return ()=>{
            (0, $1bda010252da638c$export$4a471cf3284fc492)(false);
            timerRef?.current && clearTimeout(timerRef.current);
        };
    }, [
        textareaRef
    ]);
    const handleMessageChange = ()=>{
        timerRef?.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            (0, $1bda010252da638c$export$4a471cf3284fc492)(false);
        }, 1000);
    };
    const handleChange = (e)=>{
        (0, $1bda010252da638c$export$4a471cf3284fc492)(true);
        handleMessageChange();
        setMessage(e.currentTarget.value);
        textareaRef?.current && setHeight(`${textareaRef.current.scrollHeight}px`);
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" || e.key === "NumpadEnter") {
            e.preventDefault();
            e.stopPropagation();
            handleSend();
        }
    };
    const handleSend = ()=>{
        if (message.length > 0) {
            (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(message);
            setMessage("");
            setHeight(undefined);
            timerRef?.current && clearTimeout(timerRef.current);
            (0, $1bda010252da638c$export$4a471cf3284fc492)(false);
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-relative rf-min-h-12 rf-px-4 rf-text-base rf-pt-3 rf-pb-3 rf-flex rf-items-center rf-border rf-border-menuBorder rf-rounded-lg rf-bg-truewhite rf-shadow-[inset_0_0_6px_#0000003B] ${className}`,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("textarea", {
                ref: textareaRef,
                className: `rf-input-hidden rf-outline-none rf-bg-truewhite ${withButton ? "rf-w-[calc(100%-3rem)]" : "rf-w-full"} rf-resize-none rf-scrollbar-hidden ${isMobile && "placeholder:rf-text-black placeholder:rf-opacity-100"}`,
                value: message,
                placeholder: translation.menu.message,
                onKeyDown: (e)=>handleKeyDown(e),
                onChange: (e)=>handleChange(e),
                style: {
                    height: height || "1.5rem"
                }
            }),
            withButton && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                className: "rf-absolute rf-right-4 rf-h-5 rf-w-5",
                onClick: handleSend,
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e587bb5ec241b682$export$2e2bcd8739ae039), {
                    className: "rf-w-5",
                    color: themeColors.secondary
                })
            })
        ]
    });
};
var $52c5220b9210ea92$export$2e2bcd8739ae039 = $52c5220b9210ea92$var$SendTextBox;


const $6afb04002d627629$var$UserRequest = ()=>{
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const mediumLandscape = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.mediumLandscape);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isBorne = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isBorne);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: !isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            className: `rf-relative rf-h-full
            ${isBorne && mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? "rf-w-4/9" : "rf-w-3/5"}
            ${mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text && mediumLandscape ? "rf-col-start-4" : "rf-col-start-5"} rf-col-span-full rf-row-start-1 ${mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text ? "rf-row-end-4" : "rf-row-end-5"} rf-py-4
            large-vertical:rf-col-start-1 large-vertical:rf-col-span-full large-vertical:rf-row-start-5 large-vertical:rf-row-end-7
            large-vertical:rf-py-5
            rf-flex rf-flex-col rf-justify-self-center rf-justify-end rf-text-size-auto rf-text-trueblack`,
            id: "retorik-userRequest",
            children: mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $52c5220b9210ea92$export$2e2bcd8739ae039), {
                withButton: true
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1b3e8b9ff8a47c6c$export$2e2bcd8739ae039), {})
        })
    });
};
var $6afb04002d627629$export$2e2bcd8739ae039 = $6afb04002d627629$var$UserRequest;




var $lT7pJ = parcelRequire("lT7pJ");



var $lT7pJ = parcelRequire("lT7pJ");
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $lrWjX = parcelRequire("lrWjX");




// Default to a dummy "batch" implementation that just runs the callback
function $81d164f04098c8f4$var$defaultNoopBatch(callback) {
    callback();
}
let $81d164f04098c8f4$var$batch = $81d164f04098c8f4$var$defaultNoopBatch; // Allow injecting another batching function later
const $81d164f04098c8f4$export$4b9874722d0da7bc = (newBatch)=>$81d164f04098c8f4$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $81d164f04098c8f4$export$fc47d4c0ba3bd2c6 = ()=>$81d164f04098c8f4$var$batch;



var $lT7pJ = parcelRequire("lT7pJ");

var $lT7pJ = parcelRequire("lT7pJ");

var $lT7pJ = parcelRequire("lT7pJ");
const $fd924aa237d38dd3$var$ContextKey = Symbol.for(`react-redux-context`);
const $fd924aa237d38dd3$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $fd924aa237d38dd3$var$getContext() {
    var _gT$ContextKey;
    if (!$lT7pJ.createContext) return {};
    const contextMap = (_gT$ContextKey = $fd924aa237d38dd3$var$gT[$fd924aa237d38dd3$var$ContextKey]) != null ? _gT$ContextKey : $fd924aa237d38dd3$var$gT[$fd924aa237d38dd3$var$ContextKey] = new Map();
    let realContext = contextMap.get($lT7pJ.createContext);
    if (!realContext) {
        realContext = $lT7pJ.createContext(null);
        contextMap.set($lT7pJ.createContext, realContext);
    }
    return realContext;
}
const $fd924aa237d38dd3$export$cc80c08dc91f1c00 = /*#__PURE__*/ $fd924aa237d38dd3$var$getContext();
var $fd924aa237d38dd3$export$2e2bcd8739ae039 = $fd924aa237d38dd3$export$cc80c08dc91f1c00;


function $29215f933c0cd476$export$d4d6226d5fc61558(context = (0, $fd924aa237d38dd3$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $lT7pJ.useContext)(context);
        return contextValue;
    };
}
const $29215f933c0cd476$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $29215f933c0cd476$export$d4d6226d5fc61558();



const $8e165586b68c232b$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $e42221195eb7ebf5$var$useSyncExternalStoreWithSelector = (0, $8e165586b68c232b$export$20656a4825650bd0);
const $e42221195eb7ebf5$export$e2e6e3f3f3b782e3 = (fn)=>{
    $e42221195eb7ebf5$var$useSyncExternalStoreWithSelector = fn;
};
const $e42221195eb7ebf5$var$refEquality = (a, b)=>a === b;
function $e42221195eb7ebf5$export$2b53f90d2bd1cbfb(context = (0, $fd924aa237d38dd3$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $fd924aa237d38dd3$export$cc80c08dc91f1c00) ? (0, $29215f933c0cd476$export$c1275ca9a6fd3ec5) : (0, $29215f933c0cd476$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $e42221195eb7ebf5$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $lT7pJ.useRef)(true);
        const wrappedSelector = (0, $lT7pJ.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $e42221195eb7ebf5$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $lT7pJ.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $e42221195eb7ebf5$export$2105062e25df4afe = /*#__PURE__*/ $e42221195eb7ebf5$export$2b53f90d2bd1cbfb();


function $587e5c6aa7398891$export$2e2bcd8739ae039() {
    $587e5c6aa7398891$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $587e5c6aa7398891$export$2e2bcd8739ae039.apply(this, arguments);
}


function $0fbeb23e15019249$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $e698aa2b011b04d4$exports = {};
"use strict";
var $7a9ea794056ab2b4$exports = {};
"use strict";

$7a9ea794056ab2b4$exports = (parcelRequire("bkcrI"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $e698aa2b011b04d4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $e698aa2b011b04d4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $e698aa2b011b04d4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $e698aa2b011b04d4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $e698aa2b011b04d4$var$TYPE_STATICS = {};
$e698aa2b011b04d4$var$TYPE_STATICS[$7a9ea794056ab2b4$exports.ForwardRef] = $e698aa2b011b04d4$var$FORWARD_REF_STATICS;
$e698aa2b011b04d4$var$TYPE_STATICS[$7a9ea794056ab2b4$exports.Memo] = $e698aa2b011b04d4$var$MEMO_STATICS;
function $e698aa2b011b04d4$var$getStatics(component) {
    // React v16.11 and below
    if ($7a9ea794056ab2b4$exports.isMemo(component)) return $e698aa2b011b04d4$var$MEMO_STATICS;
     // React v16.12 and above
    return $e698aa2b011b04d4$var$TYPE_STATICS[component["$$typeof"]] || $e698aa2b011b04d4$var$REACT_STATICS;
}
var $e698aa2b011b04d4$var$defineProperty = Object.defineProperty;
var $e698aa2b011b04d4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $e698aa2b011b04d4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e698aa2b011b04d4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e698aa2b011b04d4$var$getPrototypeOf = Object.getPrototypeOf;
var $e698aa2b011b04d4$var$objectPrototype = Object.prototype;
function $e698aa2b011b04d4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($e698aa2b011b04d4$var$objectPrototype) {
            var inheritedComponent = $e698aa2b011b04d4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $e698aa2b011b04d4$var$objectPrototype) $e698aa2b011b04d4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $e698aa2b011b04d4$var$getOwnPropertyNames(sourceComponent);
        if ($e698aa2b011b04d4$var$getOwnPropertySymbols) keys = keys.concat($e698aa2b011b04d4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $e698aa2b011b04d4$var$getStatics(targetComponent);
        var sourceStatics = $e698aa2b011b04d4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$e698aa2b011b04d4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $e698aa2b011b04d4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $e698aa2b011b04d4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$e698aa2b011b04d4$exports = $e698aa2b011b04d4$var$hoistNonReactStatics;



var $lT7pJ = parcelRequire("lT7pJ");
var $389d0f106c6c8f00$exports = {};
"use strict";

$389d0f106c6c8f00$exports = (parcelRequire("3EbSx"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $74bd93e76d042e16$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $224979faede2b472$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $74bd93e76d042e16$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $224979faede2b472$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $224979faede2b472$var$verify(mapStateToProps, "mapStateToProps");
    $224979faede2b472$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $224979faede2b472$var$verify(mergeProps, "mergeProps");
}


const $689316f119f88b6d$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $689316f119f88b6d$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $689316f119f88b6d$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $0fbeb23e15019249$export$2e2bcd8739ae039)(_ref, $689316f119f88b6d$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $689316f119f88b6d$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $4e0a72c00cbfe430$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $2fe2e52a84e452ac$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $d3c1cf25ef4352d6$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $2fe2e52a84e452ac$export$2e2bcd8739ae039)(value)) (0, $74bd93e76d042e16$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $5e6f0f1f3d3b20f2$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $5e6f0f1f3d3b20f2$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $5e6f0f1f3d3b20f2$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $5e6f0f1f3d3b20f2$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $5e6f0f1f3d3b20f2$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $38e96d42e5ceab0b$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $6a107345010432af$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $5e6f0f1f3d3b20f2$export$710f7c60f68acd3e)((dispatch)=>(0, $4e0a72c00cbfe430$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $5e6f0f1f3d3b20f2$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $5e6f0f1f3d3b20f2$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $38e96d42e5ceab0b$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $50940a79f0e2f977$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $5e6f0f1f3d3b20f2$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $5e6f0f1f3d3b20f2$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $38e96d42e5ceab0b$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}





function $f1fbd13b67bb52b5$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $587e5c6aa7398891$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $f1fbd13b67bb52b5$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $f1fbd13b67bb52b5$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$f1fbd13b67bb52b5$export$691c327fc30bc857 : typeof mergeProps === "function" ? $f1fbd13b67bb52b5$export$5b105939c84b5234(mergeProps) : (0, $38e96d42e5ceab0b$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $a907e92a41145075$var$createListenerCollection() {
    const batch = (0, $81d164f04098c8f4$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $a907e92a41145075$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $a907e92a41145075$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $a907e92a41145075$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $a907e92a41145075$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $a907e92a41145075$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $lT7pJ = parcelRequire("lT7pJ");
const $91fb080613773207$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $91fb080613773207$export$700979bc83e7db82 = $91fb080613773207$export$71594e8a50f746f4 ? $lT7pJ.useLayoutEffect : $lT7pJ.useEffect;


function $de526b59c795dbbc$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $de526b59c795dbbc$export$2e2bcd8739ae039(objA, objB) {
    if ($de526b59c795dbbc$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$de526b59c795dbbc$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $b6008919e8edf073$var$_excluded = [
    "reactReduxForwardedRef"
];
let $b6008919e8edf073$var$useSyncExternalStore = (0, $8e165586b68c232b$export$20656a4825650bd0);
const $b6008919e8edf073$export$36d45daa6a4925b8 = (fn)=>{
    $b6008919e8edf073$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $b6008919e8edf073$var$EMPTY_ARRAY = [
    null,
    0
];
const $b6008919e8edf073$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $b6008919e8edf073$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $b6008919e8edf073$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $91fb080613773207$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $b6008919e8edf073$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $b6008919e8edf073$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $b6008919e8edf073$var$initStateUpdates = ()=>$b6008919e8edf073$var$EMPTY_ARRAY;
function $b6008919e8edf073$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $b6008919e8edf073$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $b6008919e8edf073$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $b6008919e8edf073$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $de526b59c795dbbc$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $de526b59c795dbbc$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $de526b59c795dbbc$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $fd924aa237d38dd3$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $50940a79f0e2f977$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $6a107345010432af$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $f1fbd13b67bb52b5$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $lT7pJ.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $0fbeb23e15019249$export$2e2bcd8739ae039)(props, $b6008919e8edf073$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $lT7pJ.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $389d0f106c6c8f00$exports.isContextConsumer)(/*#__PURE__*/ $lT7pJ.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $lT7pJ.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $lT7pJ.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $689316f119f88b6d$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $lT7pJ.useMemo(()=>{
                if (!shouldHandleStateChanges) return $b6008919e8edf073$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $a907e92a41145075$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $lT7pJ.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $587e5c6aa7398891$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $lT7pJ.useRef();
            const lastWrapperProps = $lT7pJ.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $lT7pJ.useRef();
            const renderIsScheduled = $lT7pJ.useRef(false);
            const isProcessingDispatch = $lT7pJ.useRef(false);
            const isMounted = $lT7pJ.useRef(false);
            const latestSubscriptionCallbackError = $lT7pJ.useRef();
            (0, $91fb080613773207$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $lT7pJ.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $lT7pJ.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $b6008919e8edf073$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $b6008919e8edf073$var$useIsomorphicLayoutEffectWithArgs($b6008919e8edf073$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $b6008919e8edf073$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $91fb080613773207$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $lT7pJ.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $lT7pJ.createElement(WrappedComponent, (0, $587e5c6aa7398891$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $lT7pJ.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $lT7pJ.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $lT7pJ.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $lT7pJ.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $lT7pJ.createElement(Connect, (0, $587e5c6aa7398891$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($e698aa2b011b04d4$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($e698aa2b011b04d4$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $b6008919e8edf073$export$2e2bcd8739ae039 = $b6008919e8edf073$var$connect;



var $lT7pJ = parcelRequire("lT7pJ");



function $33979021aa0c4ab4$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $lT7pJ.useMemo(()=>{
        const subscription = (0, $a907e92a41145075$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $lT7pJ.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $91fb080613773207$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $fd924aa237d38dd3$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $lT7pJ.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $33979021aa0c4ab4$export$2e2bcd8739ae039 = $33979021aa0c4ab4$var$Provider;







function $61fba475e36013cf$export$671dba69185d0304(context = (0, $fd924aa237d38dd3$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $fd924aa237d38dd3$export$cc80c08dc91f1c00) ? (0, $29215f933c0cd476$export$c1275ca9a6fd3ec5) : (0, $29215f933c0cd476$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $61fba475e36013cf$export$6ccbb43953eebf8 = /*#__PURE__*/ $61fba475e36013cf$export$671dba69185d0304();


function $c7d6d84a49836892$export$bc9b55530897c558(context = (0, $fd924aa237d38dd3$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $fd924aa237d38dd3$export$cc80c08dc91f1c00) ? (0, $61fba475e36013cf$export$6ccbb43953eebf8) : (0, $61fba475e36013cf$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $c7d6d84a49836892$export$8ad76b76a4c905f8 = /*#__PURE__*/ $c7d6d84a49836892$export$bc9b55530897c558();









(0, $e42221195eb7ebf5$export$e2e6e3f3f3b782e3)((0, $ddb9606c76ba24fe$exports.useSyncExternalStoreWithSelector));
(0, $b6008919e8edf073$export$36d45daa6a4925b8)((0, $lrWjX.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $81d164f04098c8f4$export$4b9874722d0da7bc)((0, $104722dc8dfafae7$exports.unstable_batchedUpdates));



var $69iRJ = parcelRequire("69iRJ");
function $5391dbc32743cf4f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5391dbc32743cf4f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5391dbc32743cf4f$export$2e2bcd8739ae039(o);
}



function $ffc9ff11eed8f674$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5391dbc32743cf4f$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5391dbc32743cf4f$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $e71b06bcadffc5b8$export$2e2bcd8739ae039(t) {
    var i = (0, $ffc9ff11eed8f674$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $5391dbc32743cf4f$export$2e2bcd8739ae039)(i) ? i : String(i);
}


function $d7f782ce5ad133b2$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $e71b06bcadffc5b8$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $193f24ec141756db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $193f24ec141756db$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $193f24ec141756db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d7f782ce5ad133b2$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $193f24ec141756db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $884a671d3b35252b$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $884a671d3b35252b$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $884a671d3b35252b$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $884a671d3b35252b$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $884a671d3b35252b$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $884a671d3b35252b$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $884a671d3b35252b$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $884a671d3b35252b$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $884a671d3b35252b$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($884a671d3b35252b$var$isDate(val)) return "date";
    if ($884a671d3b35252b$var$isError(val)) return "error";
    var constructorName = $884a671d3b35252b$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $884a671d3b35252b$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $884a671d3b35252b$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $884a671d3b35252b$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $884a671d3b35252b$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $884a671d3b35252b$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($884a671d3b35252b$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($884a671d3b35252b$var$formatProdErrorMessage(1));
        return enhancer($884a671d3b35252b$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($884a671d3b35252b$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($884a671d3b35252b$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($884a671d3b35252b$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($884a671d3b35252b$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($884a671d3b35252b$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$884a671d3b35252b$var$isPlainObject(action)) throw new Error($884a671d3b35252b$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($884a671d3b35252b$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($884a671d3b35252b$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($884a671d3b35252b$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $884a671d3b35252b$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($884a671d3b35252b$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$884a671d3b35252b$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $884a671d3b35252b$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$884a671d3b35252b$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $884a671d3b35252b$export$8928921ea2d3b126 = $884a671d3b35252b$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $884a671d3b35252b$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $884a671d3b35252b$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $884a671d3b35252b$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$884a671d3b35252b$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $884a671d3b35252b$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $884a671d3b35252b$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $884a671d3b35252b$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $884a671d3b35252b$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($884a671d3b35252b$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $884a671d3b35252b$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($884a671d3b35252b$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $884a671d3b35252b$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $884a671d3b35252b$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($884a671d3b35252b$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $884a671d3b35252b$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $884a671d3b35252b$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $884a671d3b35252b$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($884a671d3b35252b$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $884a671d3b35252b$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $884a671d3b35252b$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $884a671d3b35252b$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($884a671d3b35252b$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $884a671d3b35252b$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $193f24ec141756db$export$2e2bcd8739ae039)((0, $193f24ec141756db$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $0faa1881de89e544$var$NOT_FOUND = "NOT_FOUND";
function $0faa1881de89e544$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $0faa1881de89e544$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $0faa1881de89e544$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $0faa1881de89e544$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $0faa1881de89e544$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $0faa1881de89e544$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $0faa1881de89e544$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $0faa1881de89e544$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $0faa1881de89e544$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $0faa1881de89e544$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $0faa1881de89e544$var$createSingletonCache(comparator) : $0faa1881de89e544$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $0faa1881de89e544$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $b5281dd48a711d7e$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $b5281dd48a711d7e$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $b5281dd48a711d7e$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $b5281dd48a711d7e$export$595d22ed68ca2841 = /* #__PURE__ */ $b5281dd48a711d7e$export$5943f4447f6ef248((0, $0faa1881de89e544$export$281bff7f05488aa2));
var $b5281dd48a711d7e$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $b5281dd48a711d7e$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $13371c1f35bb1da8$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $13371c1f35bb1da8$var$thunk = $13371c1f35bb1da8$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$13371c1f35bb1da8$var$thunk.withExtraArgument = $13371c1f35bb1da8$var$createThunkMiddleware;
var $13371c1f35bb1da8$export$2e2bcd8739ae039 = $13371c1f35bb1da8$var$thunk;



var $hIXGI = parcelRequire("hIXGI");
var $4a2ece9b9e4a4aba$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4a2ece9b9e4a4aba$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4a2ece9b9e4a4aba$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $4a2ece9b9e4a4aba$var$__defProp = Object.defineProperty;
var $4a2ece9b9e4a4aba$var$__defProps = Object.defineProperties;
var $4a2ece9b9e4a4aba$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4a2ece9b9e4a4aba$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4a2ece9b9e4a4aba$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4a2ece9b9e4a4aba$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4a2ece9b9e4a4aba$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $4a2ece9b9e4a4aba$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $4a2ece9b9e4a4aba$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($4a2ece9b9e4a4aba$var$__hasOwnProp.call(b, prop)) $4a2ece9b9e4a4aba$var$__defNormalProp(a, prop, b[prop]);
    if ($4a2ece9b9e4a4aba$var$__getOwnPropSymbols) for(var _i = 0, _c = $4a2ece9b9e4a4aba$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($4a2ece9b9e4a4aba$var$__propIsEnum.call(b, prop)) $4a2ece9b9e4a4aba$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4a2ece9b9e4a4aba$var$__spreadProps = function(a, b) {
    return $4a2ece9b9e4a4aba$var$__defProps(a, $4a2ece9b9e4a4aba$var$__getOwnPropDescs(b));
};
var $4a2ece9b9e4a4aba$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $4a2ece9b9e4a4aba$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $b5281dd48a711d7e$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $4a2ece9b9e4a4aba$var$__spreadArray([
            (0, $69iRJ.isDraft)(value) ? (0, $69iRJ.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $4a2ece9b9e4a4aba$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $884a671d3b35252b$export$f672e0b6f7222cd7;
    return (0, $884a671d3b35252b$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $4a2ece9b9e4a4aba$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $4a2ece9b9e4a4aba$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $4a2ece9b9e4a4aba$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $4a2ece9b9e4a4aba$var$__spreadValues($4a2ece9b9e4a4aba$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $4a2ece9b9e4a4aba$export$b956e38827fca970(action) {
    return $4a2ece9b9e4a4aba$export$53b83ca8eaab0383(action) && "type" in action;
}
function $4a2ece9b9e4a4aba$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $4a2ece9b9e4a4aba$var$hasMatchFunction(action);
}
function $4a2ece9b9e4a4aba$export$ebd532f9034651f3(action) {
    return $4a2ece9b9e4a4aba$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($4a2ece9b9e4a4aba$var$isValidKey);
}
function $4a2ece9b9e4a4aba$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $4a2ece9b9e4a4aba$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $4a2ece9b9e4a4aba$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $4a2ece9b9e4a4aba$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $4a2ece9b9e4a4aba$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $4a2ece9b9e4a4aba$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $4a2ece9b9e4a4aba$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $4a2ece9b9e4a4aba$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $4a2ece9b9e4a4aba$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $4a2ece9b9e4a4aba$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $4a2ece9b9e4a4aba$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $4a2ece9b9e4a4aba$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $4a2ece9b9e4a4aba$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $4a2ece9b9e4a4aba$var$freezeDraftable(val) {
    return (0, $69iRJ.isDraftable)(val) ? (0, $69iRJ.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $4a2ece9b9e4a4aba$var$isProduction = true;
var $4a2ece9b9e4a4aba$var$prefix = "Invariant failed";
function $4a2ece9b9e4a4aba$var$invariant(condition, message) {
    if (condition) return;
    if ($4a2ece9b9e4a4aba$var$isProduction) throw new Error($4a2ece9b9e4a4aba$var$prefix);
    throw new Error($4a2ece9b9e4a4aba$var$prefix + ": " + (message || ""));
}
function $4a2ece9b9e4a4aba$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $4a2ece9b9e4a4aba$var$getSerialize(serializer, decycler), indent);
}
function $4a2ece9b9e4a4aba$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $4a2ece9b9e4a4aba$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $4a2ece9b9e4a4aba$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $4a2ece9b9e4a4aba$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $4a2ece9b9e4a4aba$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $4a2ece9b9e4a4aba$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $4a2ece9b9e4a4aba$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $4a2ece9b9e4a4aba$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $4a2ece9b9e4a4aba$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $4a2ece9b9e4a4aba$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $4a2ece9b9e4a4aba$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $4a2ece9b9e4a4aba$export$53b83ca8eaab0383(val);
}
function $4a2ece9b9e4a4aba$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $4a2ece9b9e4a4aba$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $4a2ece9b9e4a4aba$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $4a2ece9b9e4a4aba$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $4a2ece9b9e4a4aba$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$4a2ece9b9e4a4aba$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $4a2ece9b9e4a4aba$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $4a2ece9b9e4a4aba$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $4a2ece9b9e4a4aba$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $4a2ece9b9e4a4aba$export$36c1185aeee5b0a6(options);
    };
}
function $4a2ece9b9e4a4aba$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $4a2ece9b9e4a4aba$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($4a2ece9b9e4a4aba$var$isBoolean(thunk)) middlewareArray.push((0, $13371c1f35bb1da8$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $13371c1f35bb1da8$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $4a2ece9b9e4a4aba$var$IS_PRODUCTION = true;
function $4a2ece9b9e4a4aba$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $4a2ece9b9e4a4aba$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($4a2ece9b9e4a4aba$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $884a671d3b35252b$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$4a2ece9b9e4a4aba$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$4a2ece9b9e4a4aba$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $884a671d3b35252b$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $884a671d3b35252b$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $4a2ece9b9e4a4aba$var$composeWithDevTools($4a2ece9b9e4a4aba$var$__spreadValues({
        trace: !$4a2ece9b9e4a4aba$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $4a2ece9b9e4a4aba$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $4a2ece9b9e4a4aba$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $884a671d3b35252b$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $4a2ece9b9e4a4aba$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $4a2ece9b9e4a4aba$var$isStateFunction(x) {
    return typeof x === "function";
}
var $4a2ece9b9e4a4aba$var$hasWarnedAboutObjectNotation = false;
function $4a2ece9b9e4a4aba$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $4a2ece9b9e4a4aba$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($4a2ece9b9e4a4aba$var$isStateFunction(initialState)) getInitialState = function() {
        return $4a2ece9b9e4a4aba$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $4a2ece9b9e4a4aba$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $4a2ece9b9e4a4aba$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $69iRJ.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $69iRJ.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $69iRJ.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $4a2ece9b9e4a4aba$var$hasWarnedAboutObjectNotation2 = false;
function $4a2ece9b9e4a4aba$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $4a2ece9b9e4a4aba$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $hIXGI;
    var initialState = typeof options.initialState == "function" ? options.initialState : $4a2ece9b9e4a4aba$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $4a2ece9b9e4a4aba$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62(type, prepareCallback) : $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $4a2ece9b9e4a4aba$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $4a2ece9b9e4a4aba$var$__spreadValues($4a2ece9b9e4a4aba$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $4a2ece9b9e4a4aba$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $4a2ece9b9e4a4aba$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $4a2ece9b9e4a4aba$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($4a2ece9b9e4a4aba$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $4a2ece9b9e4a4aba$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $4a2ece9b9e4a4aba$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $4a2ece9b9e4a4aba$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $4a2ece9b9e4a4aba$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $4a2ece9b9e4a4aba$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $4a2ece9b9e4a4aba$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $4a2ece9b9e4a4aba$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $4a2ece9b9e4a4aba$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $4a2ece9b9e4a4aba$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $4a2ece9b9e4a4aba$var$createSingleArgumentStateOperator(mutator) {
    var operator = $4a2ece9b9e4a4aba$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $4a2ece9b9e4a4aba$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $4a2ece9b9e4a4aba$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $69iRJ.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $69iRJ.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $4a2ece9b9e4a4aba$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $4a2ece9b9e4a4aba$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $4a2ece9b9e4a4aba$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $4a2ece9b9e4a4aba$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $4a2ece9b9e4a4aba$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $4a2ece9b9e4a4aba$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $4a2ece9b9e4a4aba$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $4a2ece9b9e4a4aba$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $4a2ece9b9e4a4aba$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4a2ece9b9e4a4aba$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4a2ece9b9e4a4aba$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $4a2ece9b9e4a4aba$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $4a2ece9b9e4a4aba$var$__spreadValues($4a2ece9b9e4a4aba$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $4a2ece9b9e4a4aba$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $4a2ece9b9e4a4aba$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $4a2ece9b9e4a4aba$var$createStateOperator(addOneMutably),
        addMany: $4a2ece9b9e4a4aba$var$createStateOperator(addManyMutably),
        setOne: $4a2ece9b9e4a4aba$var$createStateOperator(setOneMutably),
        setMany: $4a2ece9b9e4a4aba$var$createStateOperator(setManyMutably),
        setAll: $4a2ece9b9e4a4aba$var$createStateOperator(setAllMutably),
        updateOne: $4a2ece9b9e4a4aba$var$createStateOperator(updateOneMutably),
        updateMany: $4a2ece9b9e4a4aba$var$createStateOperator(updateManyMutably),
        upsertOne: $4a2ece9b9e4a4aba$var$createStateOperator(upsertOneMutably),
        upsertMany: $4a2ece9b9e4a4aba$var$createStateOperator(upsertManyMutably),
        removeOne: $4a2ece9b9e4a4aba$var$createStateOperator(removeOneMutably),
        removeMany: $4a2ece9b9e4a4aba$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $4a2ece9b9e4a4aba$var$createSortedStateAdapter(selectId, sort) {
    var _c = $4a2ece9b9e4a4aba$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $4a2ece9b9e4a4aba$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($4a2ece9b9e4a4aba$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4a2ece9b9e4a4aba$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4a2ece9b9e4a4aba$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $4a2ece9b9e4a4aba$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $4a2ece9b9e4a4aba$var$createStateOperator(addOneMutably),
        updateOne: $4a2ece9b9e4a4aba$var$createStateOperator(updateOneMutably),
        upsertOne: $4a2ece9b9e4a4aba$var$createStateOperator(upsertOneMutably),
        setOne: $4a2ece9b9e4a4aba$var$createStateOperator(setOneMutably),
        setMany: $4a2ece9b9e4a4aba$var$createStateOperator(setManyMutably),
        setAll: $4a2ece9b9e4a4aba$var$createStateOperator(setAllMutably),
        addMany: $4a2ece9b9e4a4aba$var$createStateOperator(addManyMutably),
        updateMany: $4a2ece9b9e4a4aba$var$createStateOperator(updateManyMutably),
        upsertMany: $4a2ece9b9e4a4aba$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $4a2ece9b9e4a4aba$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $4a2ece9b9e4a4aba$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $4a2ece9b9e4a4aba$var$createInitialStateFactory();
    var selectorsFactory = $4a2ece9b9e4a4aba$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $4a2ece9b9e4a4aba$var$createSortedStateAdapter(selectId, sortComparer) : $4a2ece9b9e4a4aba$var$createUnsortedStateAdapter(selectId);
    return $4a2ece9b9e4a4aba$var$__spreadValues($4a2ece9b9e4a4aba$var$__spreadValues($4a2ece9b9e4a4aba$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $4a2ece9b9e4a4aba$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $4a2ece9b9e4a4aba$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $4a2ece9b9e4a4aba$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $4a2ece9b9e4a4aba$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $4a2ece9b9e4a4aba$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $4a2ece9b9e4a4aba$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $4a2ece9b9e4a4aba$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $4a2ece9b9e4a4aba$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $4a2ece9b9e4a4aba$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $4a2ece9b9e4a4aba$var$__spreadProps($4a2ece9b9e4a4aba$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $4a2ece9b9e4a4aba$var$__spreadProps($4a2ece9b9e4a4aba$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $4a2ece9b9e4a4aba$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $4a2ece9b9e4a4aba$var$__spreadProps($4a2ece9b9e4a4aba$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $4a2ece9b9e4a4aba$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $4a2ece9b9e4a4aba$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $4a2ece9b9e4a4aba$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$4a2ece9b9e4a4aba$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $4a2ece9b9e4a4aba$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $4a2ece9b9e4a4aba$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $4a2ece9b9e4a4aba$var$RejectWithValue) throw result;
                                                if (result instanceof $4a2ece9b9e4a4aba$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $4a2ece9b9e4a4aba$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($4a2ece9b9e4a4aba$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $4a2ece9b9e4a4aba$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $4a2ece9b9e4a4aba$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $4a2ece9b9e4a4aba$var$matches = function(matcher, action) {
    if ($4a2ece9b9e4a4aba$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $4a2ece9b9e4a4aba$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $4a2ece9b9e4a4aba$var$matches(matcher, action);
        });
    };
}
function $4a2ece9b9e4a4aba$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $4a2ece9b9e4a4aba$var$matches(matcher, action);
        });
    };
}
function $4a2ece9b9e4a4aba$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $4a2ece9b9e4a4aba$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $4a2ece9b9e4a4aba$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4a2ece9b9e4a4aba$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$4a2ece9b9e4a4aba$var$isAsyncThunkArray(asyncThunks)) return $4a2ece9b9e4a4aba$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $4a2ece9b9e4a4aba$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $4a2ece9b9e4a4aba$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4a2ece9b9e4a4aba$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$4a2ece9b9e4a4aba$var$isAsyncThunkArray(asyncThunks)) return $4a2ece9b9e4a4aba$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $4a2ece9b9e4a4aba$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $4a2ece9b9e4a4aba$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $4a2ece9b9e4a4aba$export$9dd1fb32974da385($4a2ece9b9e4a4aba$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$4a2ece9b9e4a4aba$var$isAsyncThunkArray(asyncThunks)) return $4a2ece9b9e4a4aba$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $4a2ece9b9e4a4aba$export$9dd1fb32974da385($4a2ece9b9e4a4aba$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $4a2ece9b9e4a4aba$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4a2ece9b9e4a4aba$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$4a2ece9b9e4a4aba$var$isAsyncThunkArray(asyncThunks)) return $4a2ece9b9e4a4aba$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $4a2ece9b9e4a4aba$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $4a2ece9b9e4a4aba$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4a2ece9b9e4a4aba$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$4a2ece9b9e4a4aba$var$isAsyncThunkArray(asyncThunks)) return $4a2ece9b9e4a4aba$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $4a2ece9b9e4a4aba$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $4a2ece9b9e4a4aba$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $4a2ece9b9e4a4aba$var$noop = function() {};
var $4a2ece9b9e4a4aba$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $4a2ece9b9e4a4aba$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $4a2ece9b9e4a4aba$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $4a2ece9b9e4a4aba$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $4a2ece9b9e4a4aba$var$task = "task";
var $4a2ece9b9e4a4aba$var$listener = "listener";
var $4a2ece9b9e4a4aba$var$completed = "completed";
var $4a2ece9b9e4a4aba$var$cancelled = "cancelled";
var $4a2ece9b9e4a4aba$var$taskCancelled = "task-" + $4a2ece9b9e4a4aba$var$cancelled;
var $4a2ece9b9e4a4aba$var$taskCompleted = "task-" + $4a2ece9b9e4a4aba$var$completed;
var $4a2ece9b9e4a4aba$var$listenerCancelled = $4a2ece9b9e4a4aba$var$listener + "-" + $4a2ece9b9e4a4aba$var$cancelled;
var $4a2ece9b9e4a4aba$var$listenerCompleted = $4a2ece9b9e4a4aba$var$listener + "-" + $4a2ece9b9e4a4aba$var$completed;
var $4a2ece9b9e4a4aba$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $4a2ece9b9e4a4aba$var$task + " " + $4a2ece9b9e4a4aba$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $4a2ece9b9e4a4aba$var$validateActive = function(signal) {
    if (signal.aborted) throw new $4a2ece9b9e4a4aba$export$cb1bdac908fed7f(signal.reason);
};
function $4a2ece9b9e4a4aba$var$raceWithSignal(signal, promise2) {
    var cleanup = $4a2ece9b9e4a4aba$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $4a2ece9b9e4a4aba$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $4a2ece9b9e4a4aba$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $4a2ece9b9e4a4aba$var$noop;
    });
}
var $4a2ece9b9e4a4aba$var$runTask = function(task2, cleanUp) {
    return $4a2ece9b9e4a4aba$var$__async(void 0, null, function() {
        var value, error_1;
        return $4a2ece9b9e4a4aba$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $4a2ece9b9e4a4aba$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $4a2ece9b9e4a4aba$var$createPause = function(signal) {
    return function(promise2) {
        return $4a2ece9b9e4a4aba$var$catchRejection($4a2ece9b9e4a4aba$var$raceWithSignal(signal, promise2).then(function(output) {
            $4a2ece9b9e4a4aba$var$validateActive(signal);
            return output;
        }));
    };
};
var $4a2ece9b9e4a4aba$var$createDelay = function(signal) {
    var pause = $4a2ece9b9e4a4aba$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $4a2ece9b9e4a4aba$var$assign = Object.assign;
var $4a2ece9b9e4a4aba$var$INTERNAL_NIL_TOKEN = {};
var $4a2ece9b9e4a4aba$var$alm = "listenerMiddleware";
var $4a2ece9b9e4a4aba$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $4a2ece9b9e4a4aba$var$addAbortSignalListener(parentAbortSignal, function() {
            return $4a2ece9b9e4a4aba$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $4a2ece9b9e4a4aba$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $4a2ece9b9e4a4aba$var$runTask(function() {
            return $4a2ece9b9e4a4aba$var$__async(void 0, null, function() {
                var result2;
                return $4a2ece9b9e4a4aba$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $4a2ece9b9e4a4aba$var$validateActive(parentAbortSignal);
                            $4a2ece9b9e4a4aba$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $4a2ece9b9e4a4aba$var$createPause(childAbortController.signal),
                                    delay: $4a2ece9b9e4a4aba$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $4a2ece9b9e4a4aba$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $4a2ece9b9e4a4aba$var$abortControllerWithReason(childAbortController, $4a2ece9b9e4a4aba$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $4a2ece9b9e4a4aba$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $4a2ece9b9e4a4aba$var$abortControllerWithReason(childAbortController, $4a2ece9b9e4a4aba$var$taskCancelled);
            }
        };
    };
};
var $4a2ece9b9e4a4aba$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $4a2ece9b9e4a4aba$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $4a2ece9b9e4a4aba$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $4a2ece9b9e4a4aba$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $4a2ece9b9e4a4aba$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $4a2ece9b9e4a4aba$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $4a2ece9b9e4a4aba$var$catchRejection(take(predicate, timeout));
    };
};
var $4a2ece9b9e4a4aba$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $4a2ece9b9e4a4aba$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $4a2ece9b9e4a4aba$var$createListenerEntry = function(options) {
    var _c = $4a2ece9b9e4a4aba$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $4a2ece9b9e4a4aba$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $4a2ece9b9e4a4aba$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $4a2ece9b9e4a4aba$var$abortControllerWithReason(controller, $4a2ece9b9e4a4aba$var$listenerCancelled);
    });
};
var $4a2ece9b9e4a4aba$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($4a2ece9b9e4a4aba$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $4a2ece9b9e4a4aba$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $4a2ece9b9e4a4aba$export$f03a6b845d3fb58b = $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62($4a2ece9b9e4a4aba$var$alm + "/add");
var $4a2ece9b9e4a4aba$export$b1b8022855fb2b71 = $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62($4a2ece9b9e4a4aba$var$alm + "/removeAll");
var $4a2ece9b9e4a4aba$export$b03e9483f936dccb = $4a2ece9b9e4a4aba$export$309c7a02b0b0bc62($4a2ece9b9e4a4aba$var$alm + "/remove");
var $4a2ece9b9e4a4aba$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $4a2ece9b9e4a4aba$var$__spreadArray([
        $4a2ece9b9e4a4aba$var$alm + "/error"
    ], args));
};
function $4a2ece9b9e4a4aba$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $4a2ece9b9e4a4aba$var$defaultErrorHandler : _c;
    $4a2ece9b9e4a4aba$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $4a2ece9b9e4a4aba$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $4a2ece9b9e4a4aba$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $4a2ece9b9e4a4aba$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $4a2ece9b9e4a4aba$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $4a2ece9b9e4a4aba$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $4a2ece9b9e4a4aba$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $4a2ece9b9e4a4aba$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $4a2ece9b9e4a4aba$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $4a2ece9b9e4a4aba$var$createDelay(internalTaskController.signal),
                                pause: $4a2ece9b9e4a4aba$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $4a2ece9b9e4a4aba$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $4a2ece9b9e4a4aba$var$abortControllerWithReason(controller, $4a2ece9b9e4a4aba$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $4a2ece9b9e4a4aba$export$cb1bdac908fed7f)) $4a2ece9b9e4a4aba$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $4a2ece9b9e4a4aba$var$abortControllerWithReason(internalTaskController, $4a2ece9b9e4a4aba$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $4a2ece9b9e4a4aba$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$4a2ece9b9e4a4aba$export$b956e38827fca970(action)) return next(action);
                if ($4a2ece9b9e4a4aba$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($4a2ece9b9e4a4aba$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($4a2ece9b9e4a4aba$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $4a2ece9b9e4a4aba$var$INTERNAL_NIL_TOKEN) throw new Error($4a2ece9b9e4a4aba$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $4a2ece9b9e4a4aba$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $4a2ece9b9e4a4aba$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $4a2ece9b9e4a4aba$export$8fb31c0f05df007b = "RTK_autoBatch";
var $4a2ece9b9e4a4aba$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$4a2ece9b9e4a4aba$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $4a2ece9b9e4a4aba$var$promise;
var $4a2ece9b9e4a4aba$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($4a2ece9b9e4a4aba$var$promise || ($4a2ece9b9e4a4aba$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $4a2ece9b9e4a4aba$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $4a2ece9b9e4a4aba$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $4a2ece9b9e4a4aba$var$createQueueWithTimer(10);
var $4a2ece9b9e4a4aba$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $4a2ece9b9e4a4aba$var$queueMicrotaskShim : options.type === "raf" ? $4a2ece9b9e4a4aba$var$rAF : options.type === "callback" ? options.queueNotification : $4a2ece9b9e4a4aba$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$4a2ece9b9e4a4aba$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $69iRJ.enableES5)();



/* eslint-disable prettier/prettier */ const $e30b8340b61c34a3$var$$1c4b483bd8e0f582$export$aeae6d33ee4c22ee = "093A49A9-4EF5-4D1D-9BC4-102361C87844";
const $e30b8340b61c34a3$var$$1c4b483bd8e0f582$export$864ea3475ee6ea44 = {
    Customer: {
        Name: "DAVI SAS"
    },
    Vendor: {
        Name: "DAVI SAS"
    },
    Licences: [
        {
            productid: "093A49A9-4EF5-4D1D-9BC4-102361C87844",
            expireAt: "2026-02-18"
        }
    ]
};
/* Error codes
0: no error
1: no licence
2: incorrect licence
3: no data for this product
4: outdated licence
*/ // Define the initial state using that type
const $e30b8340b61c34a3$var$$993360e742630fa4$var$initialState = {
    value: {
        licence: undefined,
        allowed: false,
        errorCode: 1
    }
};
const $e30b8340b61c34a3$var$$993360e742630fa4$export$9bf02b14ad6809a5 = (0, $4a2ece9b9e4a4aba$export$4d8d9bd83c24ae8b)({
    name: "licenceSlice",
    initialState: $e30b8340b61c34a3$var$$993360e742630fa4$var$initialState,
    reducers: {
        setLicence: (state, action)=>{
            state.value = {
                licence: action.payload,
                allowed: false,
                errorCode: 1
            };
        },
        checkLicence: (state)=>{
            // TODO Decrypt licence
            const decodedLicence = $e30b8340b61c34a3$var$$1c4b483bd8e0f582$export$864ea3475ee6ea44;
            // Check licence data validity
            const licence = state.value.licence;
            var errorCode = 0;
            // Check if the fields are present
            !(decodedLicence.Customer && decodedLicence.Customer.Name) && (errorCode = 2);
            !(decodedLicence.Vendor && decodedLicence.Vendor.Name) && (errorCode = 2);
            !decodedLicence.Licences && (errorCode = 2);
            var goodItem = null;
            if (errorCode === 0) {
                decodedLicence.Licences.length === 0 && (errorCode = 3);
                // Check if the product id is the same as the GUID for the SpiritEngineSprite
                goodItem = decodedLicence.Licences.find((item)=>item.productid === $e30b8340b61c34a3$var$$1c4b483bd8e0f582$export$aeae6d33ee4c22ee);
                !goodItem && (errorCode = 3);
            }
            if (errorCode === 0) {
                !goodItem?.expireAt && (errorCode = 2);
                // @ts-ignore
                const date = new Date(goodItem.expireAt).getTime();
                const now = Date.now();
                // Check if the timestamp retrieved is a number
                if (isNaN(date)) errorCode = 2;
                else date < now && (errorCode = 4);
            }
            state.value = {
                licence: licence,
                allowed: errorCode === 0,
                errorCode: errorCode
            };
        }
    }
});
const { setLicence: $e30b8340b61c34a3$var$$993360e742630fa4$export$5e2c75f54104f5e4, checkLicence: $e30b8340b61c34a3$var$$993360e742630fa4$export$bed470be7ed80787 } = $e30b8340b61c34a3$var$$993360e742630fa4$export$9bf02b14ad6809a5.actions;
var $e30b8340b61c34a3$var$$993360e742630fa4$export$2e2bcd8739ae039 = $e30b8340b61c34a3$var$$993360e742630fa4$export$9bf02b14ad6809a5.reducer;
const $e30b8340b61c34a3$var$$63565878075adc80$var$store = (0, $4a2ece9b9e4a4aba$export$7d8a5b498da695ac)({
    reducer: {
        licenceReducer: $e30b8340b61c34a3$var$$993360e742630fa4$export$2e2bcd8739ae039
    }
});
var $e30b8340b61c34a3$var$$63565878075adc80$export$2e2bcd8739ae039 = $e30b8340b61c34a3$var$$63565878075adc80$var$store;
/* eslint-disable no-unused-vars */ const $e30b8340b61c34a3$var$$65f6af6b2b4224a7$var$Video = (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).forwardRef(({ srcMp4: srcMp4, srcWebm: srcWebm, onEnded: onEnded }, ref)=>{
    return (0, $ee253cdb7e062133$exports.jsxs)("video", {
        ref: ref,
        className: "ses-invisible ses-col-start-1 ses-row-start-1 ses-col-span-1 ses-row-span-1 ses-max-w-none ses-self-start ses-justify-self-center ses-object-cover",
        muted: true,
        preload: "auto",
        onEnded: onEnded,
        playsInline: true,
        controls: false,
        children: [
            (0, $ee253cdb7e062133$exports.jsx)("source", {
                src: srcMp4,
                type: 'video/mp4; codecs="hvc1"'
            }),
            (0, $ee253cdb7e062133$exports.jsx)("source", {
                src: srcWebm,
                type: "video/webm"
            })
        ]
    });
});
var $e30b8340b61c34a3$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039 = $e30b8340b61c34a3$var$$65f6af6b2b4224a7$var$Video;
const $e30b8340b61c34a3$var$$01c612cb40aac877$var$getRandomInt = (max = 1)=>{
    return Math.ceil(Math.random() * max);
};
const $e30b8340b61c34a3$var$$01c612cb40aac877$var$fps = 40;
const $e30b8340b61c34a3$var$$01c612cb40aac877$var$Chatbot = ({ agentData: agentData, height: height, size: size, speak: speak, animationQueue: animationQueue, setAnimationQueue: setAnimationQueue })=>{
    const [allowSpeechAnimations, setAllowSpeechAnimations] = (0, $lT7pJ.useState)(true);
    const [speaking, setSpeaking] = (0, $lT7pJ.useState)(speak);
    const [moving, setMoving] = (0, $lT7pJ.useState)(true);
    const moveNS = (0, $lT7pJ.useRef)(null);
    const moveSP = (0, $lT7pJ.useRef)(null);
    const stillNS = (0, $lT7pJ.useRef)(null);
    const stillSP = (0, $lT7pJ.useRef)(null);
    const [currentStill, setCurrentStill] = (0, $lT7pJ.useState)("still1");
    const [currentMove, setCurrentMove] = (0, $lT7pJ.useState)("idle1");
    const [queue, setQueue] = (0, $lT7pJ.useState)([]);
    const [idleAndExplainFolder, setIdleAndExplainFolder] = (0, $lT7pJ.useState)("move");
    const [stillFolder, setStillFolder] = (0, $lT7pJ.useState)("still");
    const [trigger, setTrigger] = (0, $lT7pJ.useState)(false);
    const [visible, setVisible] = (0, $lT7pJ.useState)(document.hidden);
    const [windowResize, setWindowResize] = (0, $lT7pJ.useState)(false);
    const sizeInPxRef = (0, $lT7pJ.useRef)();
    const sizeInPx = (0, $lT7pJ.useMemo)(()=>{
        if (size) {
            if (typeof size === "number") return size;
            else {
                if (size.slice(-2).toLowerCase() === "vh") {
                    const num = parseInt(size.substring(0, size.length - 2));
                    return isNaN(num) ? window.innerHeight : num * window.innerHeight / 100;
                } else if (size.slice(-1) === "%") {
                    const num = parseInt(size.substring(0, size.length - 1));
                    return isNaN(num) ? window.innerHeight : num * window.innerHeight / 100;
                }
            }
        }
        return window.innerHeight;
    }, [
        size,
        windowResize
    ]);
    const canvasWidthRef = (0, $lT7pJ.useRef)();
    const canvasWidth = (0, $lT7pJ.useMemo)(()=>{
        return sizeInPx > window.innerWidth ? window.innerWidth : sizeInPx;
    }, [
        sizeInPx,
        windowResize
    ]);
    const canvasHeightRef = (0, $lT7pJ.useRef)();
    const canvasHeight = (0, $lT7pJ.useMemo)(()=>{
        let marginTop = 0;
        if (height) {
            if (typeof height === "number") marginTop = height;
            else {
                if (height.slice(-2).toLowerCase() === "vh") {
                    const num = parseInt(height.substring(0, height.length - 2));
                    marginTop = isNaN(num) ? 0 : Math.round(num * window.innerHeight / 100);
                } else if (height.slice(-1) === "%") {
                    const num = parseInt(height.substring(0, height.length - 1));
                    marginTop = isNaN(num) ? 0 : Math.round(num * window.innerHeight / 100);
                }
            }
        }
        return sizeInPx - marginTop > window.innerHeight ? window.innerHeight - marginTop : sizeInPx - marginTop;
    }, [
        sizeInPx,
        height,
        windowResize
    ]);
    const videoRef = (0, $lT7pJ.useRef)(null);
    const canvasRef = (0, $lT7pJ.useRef)(null);
    const imageSize = (0, $lT7pJ.useMemo)(()=>{
        const realSize = canvasHeight;
        if (realSize < 480) return "small";
        if (realSize < 1200) return "medium";
        return "large";
    }, [
        size,
        canvasHeight
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        sizeInPx && (sizeInPxRef.current = sizeInPx);
    }, [
        sizeInPx
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        canvasWidth && (canvasWidthRef.current = canvasWidth);
    }, [
        canvasWidth
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        canvasHeight && (canvasHeightRef.current = canvasHeight);
    }, [
        canvasHeight
    ]);
    // Function to set the minimum between screen height and width to use the right animations
    const detectSize = ()=>{
        setWindowResize((value)=>!value);
    };
    const onVisibilityChange = ()=>{
        setVisible(document.hidden);
    };
    (0, $lT7pJ.useEffect)(()=>{
        if (visible) {
            if (moving) {
                moveNS.current && moveNS.current.pause();
                moveSP.current && moveSP.current.pause();
            } else {
                stillNS.current && stillNS.current.pause();
                stillSP.current && stillSP.current.pause();
            }
        } else if (moving) {
            moveNS.current && moveNS.current.play().catch((e)=>console.warn(e));
            moveSP.current && moveSP.current.play().catch((e)=>console.warn(e));
        } else {
            stillNS.current && stillNS.current.play().catch((e)=>console.warn(e));
            stillSP.current && stillSP.current.play().catch((e)=>console.warn(e));
        }
    }, [
        visible
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        document.addEventListener("visibilitychange", onVisibilityChange, false);
        // cleanup this component
        return ()=>{
            window.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        setSpeaking(allowSpeechAnimations ? speak : false);
    }, [
        speak,
        allowSpeechAnimations
    ]);
    const computeFrame = ()=>{
        const canvas = canvasRef.current;
        if (videoRef.current && sizeInPxRef?.current && canvas && canvasWidthRef?.current && canvasHeightRef?.current) {
            const context = canvas.getContext("2d");
            if (context) {
                const ratio = videoRef.current.videoWidth / sizeInPxRef.current;
                // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Optimizing_canvas#avoid_floating-point_coordinates_and_use_integers_instead
                const left = Math.round((videoRef.current.videoWidth - canvasWidthRef.current * ratio) / 2);
                context.clearRect(0, 0, canvasWidthRef.current, canvasHeightRef.current);
                context.drawImage(videoRef.current, Math.round(left), 0, Math.round(canvasWidthRef.current * ratio), Math.round(canvasHeightRef.current * ratio), 0, 0, canvasWidthRef.current, canvasHeightRef.current);
            }
        }
    };
    (0, $lT7pJ.useEffect)(()=>{
        const timeoutDuration = Math.round(1000 / $e30b8340b61c34a3$var$$01c612cb40aac877$var$fps);
        let timer;
        const computeCallback = ()=>{
            computeFrame();
            timer = setTimeout(()=>{
                requestAnimationFrame(computeCallback);
            }, timeoutDuration);
        };
        timer = setTimeout(()=>{
            requestAnimationFrame(computeCallback);
        }, timeoutDuration);
        return ()=>clearTimeout(timer);
    }, [
        canvasWidth,
        canvasHeight
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (moving) setCurrentStill("still1");
        else if (speaking) setCurrentMove("explain1");
        else setCurrentMove("idle1");
    }, [
        agentData
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (animationQueue) {
            if (animationQueue.length === 0) setQueue([]);
            else {
                // Verify if the wanted animations shall exist from the data given in the manifest.json file
                const animationDataArray = checkQueue(animationQueue);
                if (animationDataArray.length > 0) {
                    setQueue(animationDataArray);
                    setTrigger(true);
                }
            }
        }
    }, [
        animationQueue
    ]);
    // Check if each element of the given queue has a match in the data from the manifest.json file loaded
    function checkQueue(queueToCheck) {
        var test = true;
        const dataToReturn = [];
        // Get the defined folders from the manifest
        const keys = agentData ? Object.keys(agentData.data) : [];
        // Parse each item to get an array with the name of the animation and its index
        queueToCheck.forEach((item)=>{
            const data = !isNaN(parseInt(item.substring(item.length - 2))) ? [
                item.substring(0, item.length - 2),
                parseInt(item.substring(item.length - 2))
            ] : !isNaN(parseInt(item.substring(item.length - 1))) ? [
                item.substring(0, item.length - 1),
                parseInt(item.substring(item.length - 1))
            ] : [
                item,
                -1
            ];
            const lowCase = data[0].toLowerCase();
            // Check if the folder exists in the manifest and if the index of the animation is lower than the max one
            if (keys.includes(lowCase) && agentData && agentData.data[lowCase] >= data[1]) dataToReturn.push(data);
            else {
                console.log("Wrong animation wanted : ", item);
                test = false;
            }
        });
        return test ? dataToReturn : [];
    }
    // Switch animation when not in a queue
    function switchAnimation(data) {
        var rand = 0;
        switch(data){
            case "idle":
                setIdleAndExplainFolder("move");
                rand = $e30b8340b61c34a3$var$$01c612cb40aac877$var$getRandomInt(agentData?.data.idle);
                break;
            case "explain":
                setIdleAndExplainFolder("move");
                rand = $e30b8340b61c34a3$var$$01c612cb40aac877$var$getRandomInt(agentData?.data.explain);
                break;
            case "still":
                setStillFolder("still");
                rand = $e30b8340b61c34a3$var$$01c612cb40aac877$var$getRandomInt(agentData?.data.still);
                break;
            default:
                break;
        }
        if (data === "still") {
            if (currentStill === `still${rand}`) rand === 1 ? setCurrentStill("still2") : setCurrentStill(`still${rand - 1}`);
            else setCurrentStill(`still${rand}`);
        } else if (currentMove === `${data}${rand}`) rand === 1 ? setCurrentMove(`${data}2`) : setCurrentMove(`${data}${rand - 1}`);
        else setCurrentMove(`${data}${rand}`);
    }
    // Switch animation when in a queue
    function switchQueue(still) {
        const item = queue[0];
        // Check if we are using an 'Explain' or 'Idle' animation. If so, the folder is 'Move'
        const folder = [
            "explain",
            "idle"
        ].includes(item[0].toLowerCase()) ? "move" : item[0];
        // Check if an animation index has been found. If not, use a random
        const animationToDisplay = item[1] === -1 ? `${item[0]}${$e30b8340b61c34a3$var$$01c612cb40aac877$var$getRandomInt(agentData?.data[item[0].toLowerCase()])}` : `${item[0]}${item[1]}`;
        if (still) {
            setStillFolder(folder);
            setCurrentStill(animationToDisplay);
        } else {
            setIdleAndExplainFolder(folder);
            setCurrentMove(animationToDisplay);
        }
        const newQueue = [
            ...queue
        ];
        newQueue.splice(0, 1);
        if (newQueue.length === 0) {
            console.log("Send empty queue");
            setAnimationQueue && setAnimationQueue([]);
        } else setQueue(newQueue);
    }
    // Handle changes of 'moving' and 'speaking' states
    function handleMovingOrSpeaking(movingChanged) {
        if (moving === true) {
            // If the 'moving' constant has changed launch moving animations and switch animations.
            // Either way, only change the displayed animation
            if (movingChanged) {
                moveSP.current && moveSP.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                moveNS.current && moveNS.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                queue.length > 0 ? switchQueue(true) : switchAnimation("still");
            }
            videoRef.current = speaking ? moveSP.current : moveNS.current;
        } else {
            if (movingChanged) {
                stillSP.current && stillSP.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                stillNS.current && stillNS.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                if (speaking) queue.length > 0 ? switchQueue(false) : switchAnimation("explain");
                else queue.length > 0 ? switchQueue(false) : switchAnimation("idle");
            }
            videoRef.current = speaking ? stillSP.current : stillNS.current;
        }
    }
    (0, $lT7pJ.useEffect)(()=>{
        handleMovingOrSpeaking(true);
    }, [
        moving
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        handleMovingOrSpeaking(false);
    }, [
        speaking
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (trigger) {
            switchQueue(!!moving);
            setTrigger(false);
        }
    }, [
        trigger
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        try {
            moveNS.current && moveNS.current.load();
            moveSP.current && moveSP.current.load();
        } catch (e) {
            console.warn(e);
        }
    }, [
        currentMove
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        try {
            stillSP.current && stillSP.current.load();
            stillNS.current && stillNS.current.load();
        } catch (e) {
            console.warn(e);
        }
    }, [
        currentStill
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        // Add event listener for screen resize to adjust videos size
        window.addEventListener("resize", detectSize);
        window.addEventListener("preventChatbotSpeakAnimationsEvent", ()=>{
            setAllowSpeechAnimations(false);
        });
        window.addEventListener("allowChatbotSpeakAnimationsEvent", ()=>{
            setAllowSpeechAnimations(true);
        });
        window.addEventListener("setSpeaking", (e)=>{
            setSpeaking(e.detail);
        });
        // Event listener handling external calls for playing (used for safari permissions issue)
        window.addEventListener("retorikSpiritEnginePlay", handleExternalCallForPlay);
        setTimeout(()=>{
            moveNS.current && moveNS.current.play().catch((e)=>{
                e !== null && console.warn(e);
            });
            moveSP.current && moveSP.current.play().catch((e)=>{
                e !== null && console.warn(e);
            });
        }, 500);
        return ()=>{
            // Remove event listeners on component unmount
            window.removeEventListener("resize", detectSize);
            window.removeEventListener("preventChatbotSpeakAnimationsEvent", ()=>setAllowSpeechAnimations(false));
            window.removeEventListener("allowChatbotSpeakAnimationsEvent", ()=>setAllowSpeechAnimations(true));
            window.removeEventListener("setSpeaking", (e)=>setSpeaking(e.detail));
            window.removeEventListener("retorikSpiritEnginePlay", handleExternalCallForPlay);
        };
    }, []);
    const handleEnd = ()=>{
        setMoving(!moving);
    };
    const handleAudioEnd = ()=>{
        document.dispatchEvent(new Event("retorikSpiritEngineAudioEnded"));
        setSpeaking(false);
    };
    const handleExternalCallForPlay = ()=>{
        if (moveNS.current && moveSP.current && stillNS.current) {
            if (!(moveNS.current.currentTime > 0 && !moveNS.current.paused && !moveNS.current.ended && moveNS.current.readyState > 2) && !(stillNS.current.currentTime > 0 && !stillNS.current.paused && !stillNS.current.ended && stillNS.current.readyState > 2)) {
                moveNS.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                moveSP.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
            }
        }
    };
    return (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "ses-relative ses-pointer-events-none ses-h-full ses-w-full ses-grid ses-justify-center ses-items-start ses-overflow-hidden",
        id: "retorik-animation",
        children: [
            (0, $ee253cdb7e062133$exports.jsx)("audio", {
                id: "spirit-engine-sprite-audio",
                onCanPlayThrough: ()=>setSpeaking(true),
                onEnded: handleAudioEnd,
                onError: handleAudioEnd
            }),
            (0, $ee253cdb7e062133$exports.jsx)("canvas", {
                id: "spirit-engine-sprite-canvas",
                className: "ses-col-start-1 ses-row-start-1 ses-col-span-1 ses-row-span-1 ses-max-h-screen ses-self-start ses-justify-self-center ses-object-cover",
                ref: canvasRef,
                height: canvasHeight,
                width: canvasWidth,
                style: {
                    marginTop: height || undefined
                }
            }),
            (0, $ee253cdb7e062133$exports.jsx)($e30b8340b61c34a3$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039, {
                ref: moveNS,
                onEnded: ()=>{},
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${idleAndExplainFolder}/ns/${currentMove}_ns.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${idleAndExplainFolder}/ns/${currentMove}_ns.webm`
            }),
            (0, $ee253cdb7e062133$exports.jsx)($e30b8340b61c34a3$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039, {
                ref: moveSP,
                onEnded: handleEnd,
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${idleAndExplainFolder}/sp/${currentMove}_sp.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${idleAndExplainFolder}/sp/${currentMove}_sp.webm`
            }),
            (0, $ee253cdb7e062133$exports.jsx)($e30b8340b61c34a3$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039, {
                ref: stillNS,
                onEnded: ()=>{},
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${stillFolder}/ns/${currentStill}_ns.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${stillFolder}/ns/${currentStill}_ns.webm`
            }),
            (0, $ee253cdb7e062133$exports.jsx)($e30b8340b61c34a3$var$$65f6af6b2b4224a7$export$2e2bcd8739ae039, {
                ref: stillSP,
                onEnded: handleEnd,
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${stillFolder}/sp/${currentStill}_sp.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${stillFolder}/sp/${currentStill}_sp.webm`
            })
        ]
    });
};
var $e30b8340b61c34a3$var$$01c612cb40aac877$export$2e2bcd8739ae039 = $e30b8340b61c34a3$var$$01c612cb40aac877$var$Chatbot;
const $e30b8340b61c34a3$var$$5ad02cede29c1661$var$Loader = (props)=>{
    const [message, setMessage] = (0, $lT7pJ.useState)();
    (0, $lT7pJ.useEffect)(()=>{
        switch(props.errorCode){
            case 1:
                setMessage("No licence found");
                break;
            case 2:
                setMessage("Invalid licence");
                break;
            case 3:
                setMessage("No data found for this product");
                break;
            case 4:
                setMessage("Licence expired");
                break;
            case 0:
            default:
                setMessage("");
                break;
        }
    }, [
        props.errorCode
    ]);
    return (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "relative h-full w-full flex flex-col justify-center items-center",
        children: [
            (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "mb-8 font-bold text-lg",
                children: message
            }),
            (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "border-box border-b border-t border-r animate-spin w-16 h-16 border-4 rounded-full"
            })
        ]
    });
};
var $e30b8340b61c34a3$var$$5ad02cede29c1661$export$2e2bcd8739ae039 = $e30b8340b61c34a3$var$$5ad02cede29c1661$var$Loader;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
const $e30b8340b61c34a3$var$$890729a126ff6e91$export$f51d452c10d5b956 = ()=>(0, $c7d6d84a49836892$export$8ad76b76a4c905f8)();
const $e30b8340b61c34a3$var$$890729a126ff6e91$export$a7347740d65f620b = (0, $e42221195eb7ebf5$export$2105062e25df4afe);
const $e30b8340b61c34a3$var$$890729a126ff6e91$export$5a120d91e5204be4 = ()=>$e30b8340b61c34a3$var$$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value.allowed);
const $e30b8340b61c34a3$var$$890729a126ff6e91$export$7b348fc9f96d3a4b = ()=>$e30b8340b61c34a3$var$$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value.licence);
const $e30b8340b61c34a3$var$$890729a126ff6e91$export$23745d1f9ed321fa = ()=>$e30b8340b61c34a3$var$$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value.errorCode);
const $e30b8340b61c34a3$var$$890729a126ff6e91$export$c1cf1cf4c5d51937 = ()=>$e30b8340b61c34a3$var$$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value);
const $e30b8340b61c34a3$var$$0604fad8b796cc31$var$DataRetriever = ({ licence: licence, agentData: agentData, height: height, size: size, speak: speak, animationQueue: animationQueue, setAnimationQueue: setAnimationQueue })=>{
    const dispatch = $e30b8340b61c34a3$var$$890729a126ff6e91$export$f51d452c10d5b956();
    const allowedByLicence = $e30b8340b61c34a3$var$$890729a126ff6e91$export$5a120d91e5204be4();
    const errorCode = $e30b8340b61c34a3$var$$890729a126ff6e91$export$23745d1f9ed321fa();
    (0, $lT7pJ.useEffect)(()=>{
        dispatch($e30b8340b61c34a3$var$$993360e742630fa4$export$bed470be7ed80787());
    }, [
        licence
    ]);
    return (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: allowedByLicence ? (0, $ee253cdb7e062133$exports.jsx)($e30b8340b61c34a3$var$$01c612cb40aac877$export$2e2bcd8739ae039, {
            agentData: agentData,
            height: height,
            size: size,
            speak: speak,
            animationQueue: animationQueue,
            setAnimationQueue: setAnimationQueue
        }) : (0, $ee253cdb7e062133$exports.jsx)($e30b8340b61c34a3$var$$5ad02cede29c1661$export$2e2bcd8739ae039, {
            errorCode: errorCode
        })
    });
};
var $e30b8340b61c34a3$var$$0604fad8b796cc31$export$2e2bcd8739ae039 = $e30b8340b61c34a3$var$$0604fad8b796cc31$var$DataRetriever;
const $e30b8340b61c34a3$var$$e3a2da95730ed7d6$var$ChatbotProvider = (props)=>{
    return (0, $ee253cdb7e062133$exports.jsx)((0, $33979021aa0c4ab4$export$2e2bcd8739ae039), {
        store: $e30b8340b61c34a3$var$$63565878075adc80$export$2e2bcd8739ae039,
        children: (0, $ee253cdb7e062133$exports.jsx)($e30b8340b61c34a3$var$$0604fad8b796cc31$export$2e2bcd8739ae039, {
            ...props
        })
    });
};
var $e30b8340b61c34a3$var$$e3a2da95730ed7d6$export$2e2bcd8739ae039 = $e30b8340b61c34a3$var$$e3a2da95730ed7d6$var$ChatbotProvider;
function $e30b8340b61c34a3$var$$0531a00fb289598f$export$2e2bcd8739ae039(RetorikSpiritEngineSprite, props, element) {
    const root = (0, $8bc84ab6fef2cb4e$export$882461b6382ed46c)(element);
    root.render((0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).StrictMode, {
        children: (0, $ee253cdb7e062133$exports.jsx)(RetorikSpiritEngineSprite, {
            ...props
        })
    }));
}
/* eslint-disable camelcase */ /* eslint-disable prettier/prettier */ const $e30b8340b61c34a3$var$$ba07c5dc2bd20c2a$var$authenticate = async (licence)=>{
    const sessionId = await fetch("https://paas.retorik.fr/rest?method=authentification", {
        method: "POST",
        headers: {
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            aLicence: licence
        })
    }).then((response)=>{
        return response.json();
    }).then((data)=>{
        if (data?.authentification?.status === "success") return data.authentification;
        return false;
    }).catch((error)=>{
        console.log(error);
        return false;
    });
    return sessionId;
};
const $e30b8340b61c34a3$var$$ba07c5dc2bd20c2a$var$sendMessage = async (licence, text)=>{
    const auth = await $e30b8340b61c34a3$var$$ba07c5dc2bd20c2a$var$authenticate(licence);
    if (auth.status === "success") {
        const requestData = {
            idSession: auth.response,
            aFormat: "mp3",
            aText: text
        };
        await fetch("https://paas.retorik.fr/rest?method=tts_send", {
            method: "POST",
            headers: {
                "Content-type": "application/json"
            },
            body: JSON.stringify(requestData)
        }).then((response)=>{
            return response.json();
        }).then((data)=>{
            if (data?.tts_send?.status === "success") $e30b8340b61c34a3$var$$ba07c5dc2bd20c2a$var$play(data?.tts_send.response);
            return data;
        }).catch((error)=>console.log(error));
    } else console.log("Authentication error");
};
const $e30b8340b61c34a3$var$$ba07c5dc2bd20c2a$var$play = (mp3)=>{
    const audioElement = document.getElementById("spirit-engine-sprite-audio");
    if (audioElement) {
        audioElement.src = mp3;
        audioElement.play();
    }
};
var $e30b8340b61c34a3$var$$ba07c5dc2bd20c2a$export$2e2bcd8739ae039 = $e30b8340b61c34a3$var$$ba07c5dc2bd20c2a$var$sendMessage;
const $e30b8340b61c34a3$export$7dc86772e2a8d289 = $e30b8340b61c34a3$var$$0531a00fb289598f$export$2e2bcd8739ae039.bind(null, $e30b8340b61c34a3$var$$e3a2da95730ed7d6$export$2e2bcd8739ae039);
var $e30b8340b61c34a3$export$2e2bcd8739ae039 = $e30b8340b61c34a3$var$$e3a2da95730ed7d6$export$2e2bcd8739ae039;
window.Retorik = {
    ...window.Retorik,
    sendMessage: $e30b8340b61c34a3$var$$ba07c5dc2bd20c2a$export$2e2bcd8739ae039,
    renderSpiritEngineSprite: $e30b8340b61c34a3$export$7dc86772e2a8d289
};





var $lT7pJ = parcelRequire("lT7pJ");

function $7d89afc948b8f6e5$export$2e2bcd8739ae039() {
    const lastBotActivity = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.lastBotActivity);
    const [animationQueue, setAnimationQueue] = (0, $lT7pJ.useState)();
    const handleEvent = (e)=>{
        e.detail && setAnimationQueue(e.detail.queue);
    };
    (0, $lT7pJ.useEffect)(()=>{
        document.addEventListener("sendPlayAnimationEvent", handleEvent);
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        if (lastBotActivity?.meta?.queue && lastBotActivity.meta.queue.length > 0) setAnimationQueue(lastBotActivity.meta.queue);
    }, [
        lastBotActivity
    ]);
    return animationQueue;
}




var $lT7pJ = parcelRequire("lT7pJ");



const $0f4f8fd5aa082b2d$var$Subtitle = ({ isSpeaking: isSpeaking, elapsedTime: elapsedTime })=>{
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const displaySubtitles = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.displaySubtitles);
    const boundaryData = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.boundaryData);
    const [sentenceToDisplay, setSentenceToDisplay] = (0, $lT7pJ.useState)("");
    const keepLastSentenceRef = (0, $lT7pJ.useRef)(null);
    // Generate an array of sentences from boundaryData
    const sentences = (0, $lT7pJ.useMemo)(()=>{
        // If no boundary data is available, return an empty array
        if (!boundaryData || boundaryData.length === 0) return [];
        // Prepare an array to store sentences and their durations
        const sentencesArray = [];
        let currentSentence = "";
        let currentStartTime = boundaryData[0].startTime / 10000;
        // Loop over each boundary data item
        for(let i = 0; i < boundaryData.length; i++){
            const boundary = boundaryData[i];
            // Prepare a string based on the word at the boundary
            let boundaryString = "";
            if ([
                ".",
                ",",
                "..."
            ].includes(boundary.word)) boundaryString = boundary.word;
            else if ([
                ":",
                ";",
                "!",
                "?"
            ].includes(boundary.word)) boundaryString = "\xa0" + boundary.word;
            else boundaryString = i === 0 ? boundary.word : " " + boundary.word;
            // Construct a new sentence
            const newSentence = currentSentence + boundaryString;
            // If it's the last boundary of the current array or the end of the boundaries (type 'EndBoundary')
            if (i === boundaryData.length - 1 || boundary.boundaryType === "EndBoundary") // If there is a sentence to push, add it to the array
            {
                if (newSentence.trim() !== "") sentencesArray.push({
                    sentence: newSentence,
                    startTime: currentStartTime
                });
            } else if (newSentence.length > 50) {
                // If the current word is a punctuation, add it even if it goes beyond 50 characters
                if (boundary.boundaryType === "PunctuationBoundary") {
                    if (newSentence.trim() !== "") sentencesArray.push({
                        sentence: newSentence,
                        startTime: currentStartTime
                    });
                    currentStartTime = boundaryData[i + 1].startTime / 10000;
                    currentSentence = "";
                } else {
                    if (newSentence.trim() !== "") sentencesArray.push({
                        sentence: currentSentence,
                        startTime: currentStartTime
                    });
                    currentStartTime = boundary.startTime / 10000;
                    currentSentence = boundary.word;
                }
            } else // Continue the current sentence
            currentSentence = newSentence;
        }
        return sentencesArray;
    }, [
        boundaryData
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (elapsedTime) {
            for(let i = sentences.length - 1; i >= 0; i--)if (sentences[i].startTime < elapsedTime) {
                setSentenceToDisplay(sentences[i].sentence);
                break;
            }
        }
    }, [
        elapsedTime
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        keepLastSentenceRef.current && clearTimeout(keepLastSentenceRef.current);
        if (!isSpeaking && sentenceToDisplay && keepLastSentenceRef) keepLastSentenceRef.current = setTimeout(()=>{
            setSentenceToDisplay("");
        }, 1500);
        return ()=>{
            keepLastSentenceRef.current && clearTimeout(keepLastSentenceRef.current);
        };
    }, [
        isSpeaking
    ]);
    return mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal && sentenceToDisplay && displaySubtitles ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-relative rf-col-start-1 vertical:rf-col-span-full rf-col-span-6 rf-row-start-9 rf-row-span-full vertical:rf-row-start-11 vertical:rf-row-span-1 large-vertical:rf-row-start-5 large-vertical:rf-row-end-7 rf-justify-self-center rf-self-center large-vertical:rf-self-end rf-overflow-y-auto rf-scrollbar-thin rf-w-1/2 vertical:rf-w-5/6 large-vertical:rf-w-4/9 rf-max-h-full rf-py-1 large:rf-py-4",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            className: "rf-relative rf-max-h-full rf-bg-vocalModeSubtitlesBackground rf-text-vocalModeSubtitlesText rf-justify-self-center rf-self-center rf-p-2 large:rf-p-4 rf-text-size-auto rf-text-center",
            id: "retorik-subtitles",
            children: sentenceToDisplay
        })
    }) : null;
};
var $0f4f8fd5aa082b2d$export$2e2bcd8739ae039 = $0f4f8fd5aa082b2d$var$Subtitle;


const $72e6042966e2e95a$var$intervalInMilliseconds = 100;
const $72e6042966e2e95a$var$ChatbotAndSubtitlesContainer = ({ className: className, chatbotData: chatbotData, showSubtitles: showSubtitles, isNewsView: isNewsView })=>{
    const agentData = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.agentData);
    const speaking = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.speaking);
    const boundaryData = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.boundaryData);
    const [speechIntervals, setSpeechIntervals] = (0, $lT7pJ.useState)([]);
    const [isSpeaking, setIsSpeaking] = (0, $lT7pJ.useState)(false);
    const [elapsedTime, setElapsedTime] = (0, $lT7pJ.useState)(0);
    const timerRef = (0, $lT7pJ.useRef)(null);
    const lastAnimationQueue = (0, $7d89afc948b8f6e5$export$2e2bcd8739ae039)();
    const [animationQueue, setAnimationQueue] = (0, $lT7pJ.useState)([]);
    (0, $lT7pJ.useEffect)(()=>{
        lastAnimationQueue && setAnimationQueue(lastAnimationQueue);
    }, [
        lastAnimationQueue
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (isNewsView) setIsSpeaking(speaking);
        else if (speaking && timerRef) {
            timerRef.current && clearInterval(timerRef.current);
            const now = Date.now();
            timerRef.current = setInterval(()=>{
                setElapsedTime(Date.now() - now);
            }, $72e6042966e2e95a$var$intervalInMilliseconds);
        } else {
            timerRef?.current && clearInterval(timerRef.current);
            setElapsedTime(0);
        }
        return ()=>{
            timerRef?.current && clearInterval(timerRef.current);
        };
    }, [
        speaking
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (boundaryData.length > 0) {
            const tempArray = [];
            /* This is the right thing to do, but animations can't keep up with too many starts and stops, so it isn't usable ATM
      boundaryData.forEach((boundary) => {
        if (boundary.boundaryType === 'WordBoundary') {
          if (tempArray.length > 0) {
            if (
              boundary.startTime / 10000 - tempArray[tempArray.length - 1] >
              50
            ) {
              tempArray.push(boundary.startTime / 10000)
              tempArray.push(boundary.endTime / 10000)
            } else {
              tempArray.pop()
              tempArray.push(boundary.endTime / 10000)
            }
          } else {
            tempArray.push(boundary.startTime / 10000)
            tempArray.push(boundary.endTime / 10000)
          }
        }
      })

      setSpeechIntervals(tempArray)
      */ // While animations can't keep up, let's just synchronize the beginning and the end of speech
            const firstWord = boundaryData.find((boundary)=>boundary.boundaryType === "WordBoundary");
            const lastWord = boundaryData.slice().reverse().find((boundary)=>boundary.boundaryType === "WordBoundary");
            if (firstWord && lastWord) {
                tempArray.push(firstWord.startTime / 10000);
                tempArray.push(lastWord.endTime / 10000);
            }
            setSpeechIntervals(tempArray);
        } else setSpeechIntervals([]);
    }, [
        boundaryData
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (elapsedTime && speechIntervals.length > 0) {
            let inside = false;
            for(let i = 0; i < speechIntervals.length; i++)if (speechIntervals[i] > elapsedTime) {
                inside = true;
                setIsSpeaking(!(i % 2 === 0));
                break;
            }
            !inside && setIsSpeaking(false);
        } else setIsSpeaking(false);
    }, [
        elapsedTime
    ]);
    return agentData ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e30b8340b61c34a3$export$2e2bcd8739ae039), {
                    licence: "licence",
                    agentData: agentData,
                    height: chatbotData?.height,
                    size: chatbotData?.size,
                    speak: isSpeaking,
                    animationQueue: animationQueue,
                    setAnimationQueue: setAnimationQueue
                })
            }),
            showSubtitles && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $0f4f8fd5aa082b2d$export$2e2bcd8739ae039), {
                isSpeaking: isSpeaking,
                elapsedTime: elapsedTime
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $72e6042966e2e95a$export$2e2bcd8739ae039 = $72e6042966e2e95a$var$ChatbotAndSubtitlesContainer;




var $lT7pJ = parcelRequire("lT7pJ");

const $39f3e48cc7ad4ecb$var$Logo = ({ className: className })=>{
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    return configuration.logo?.src ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `${className || "rf-absolute rf-m-4 large:rf-m-8 rf-top-0 rf-left-0"}`,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
            src: configuration.logo?.src,
            alt: "Logo",
            className: "rf-max-h-12 rf-max-w-16 large:rf-max-h-28 large:rf-max-w-[12rem] large-vertical:rf-max-h-36"
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $39f3e48cc7ad4ecb$export$2e2bcd8739ae039 = $39f3e48cc7ad4ecb$var$Logo;




var $lT7pJ = parcelRequire("lT7pJ");






parcelRequire("lT7pJ");

parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");




const $85aa0610edfbce8c$export$7c3e7489ecac4759 = (id, themeColors)=>{
    let color = themeColors.secondary;
    if (id) switch(id.toLowerCase()){
        case (0, $45d43a6de0968f42$export$22b261e08140d6b2).eat:
            color = themeColors.whereToEatColor;
            break;
        case (0, $45d43a6de0968f42$export$22b261e08140d6b2).sleep:
            color = themeColors.whereToSleepColor;
            break;
        case (0, $45d43a6de0968f42$export$22b261e08140d6b2).see:
            color = themeColors.tobeSeenColor;
            break;
        case (0, $45d43a6de0968f42$export$22b261e08140d6b2).do:
            color = themeColors.tobeDoneColor;
            break;
        case (0, $45d43a6de0968f42$export$22b261e08140d6b2).localproducts:
            color = themeColors.localProductsColor;
            break;
        case (0, $45d43a6de0968f42$export$22b261e08140d6b2).services:
            color = themeColors.servicesColor;
            break;
        case (0, $45d43a6de0968f42$export$22b261e08140d6b2).agenda:
            color = themeColors.agendaColor;
            break;
        case (0, $45d43a6de0968f42$export$22b261e08140d6b2).occupant:
            color = themeColors.occupantColor;
            break;
        default:
            color = themeColors.secondary;
            break;
    }
    return color;
};


const $ad61851cc46e2afe$var$ListContextDefaultValues = {
    content: undefined,
    filters: [],
    selectedFilters: [],
    loadingData: false,
    color: "",
    setContent: ()=>{},
    setSelectedFilters: ()=>{},
    resetFilters: ()=>{},
    processFiltersOnChange: ()=>{},
    setSuggestedFilter: ()=>{},
    setLoadingData: ()=>{}
};
const $ad61851cc46e2afe$export$52411773e0d6f15d = /*#__PURE__*/ (0, $lT7pJ.createContext)($ad61851cc46e2afe$var$ListContextDefaultValues);
function $ad61851cc46e2afe$export$f9763ecd339e95eb() {
    return (0, $lT7pJ.useContext)($ad61851cc46e2afe$export$52411773e0d6f15d);
}
function $ad61851cc46e2afe$export$9b0a72e5d41d62ec({ children: children }) {
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const timerForFilterSelectionListMode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.timerForFilterSelectionListMode);
    const [content, setContent] = (0, $lT7pJ.useState)();
    const [filters, setFilters] = (0, $lT7pJ.useState)([]);
    const [selectedFilters, setSelectedFilters] = (0, $lT7pJ.useState)([]);
    const [loadingData, setLoadingData] = (0, $lT7pJ.useState)(false);
    const color = (0, $lT7pJ.useMemo)(()=>{
        return (0, $85aa0610edfbce8c$export$7c3e7489ecac4759)(content?.channelData?.category?.id, themeColors);
    }, [
        content
    ]);
    const timerRef = (0, $lT7pJ.useRef)();
    const setSuggestedFilter = (filter)=>{
        setSelectedFilters([
            filter
        ]);
    };
    /**
   * On call :
   *  - set selectedFilters state to empty array
   *  - send postBack message with empty filters
   */ const resetFilters = ()=>{
        setSelectedFilters([]);
        (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, {
            filters: []
        });
    };
    /**
   * On call :
   *  - set selectedFilters and filters states to empty arrays
   */ const totalReset = ()=>{
        setSelectedFilters([]);
        setFilters([]);
    };
    const processFiltersOnChange = (data, full = false)=>{
        let tempFilters = [];
        timerRef?.current && clearTimeout(timerRef.current);
        if (selectedFilters.length > 0) {
            let remainingData = [
                ...data
            ];
            // Check on each selected filter to modify if necessary
            selectedFilters.forEach((selectedFilter)=>{
                let items = [
                    ...selectedFilter.filterItems
                ];
                data.forEach((filter)=>{
                    if (filter.id === selectedFilter.id) {
                        // Special treatment for calendar filter : only 1 value allowed
                        if (filter.id === "Event.DateRange") {
                            if (items.length > 0 && filter.filterItems.length > 0 && items[0] === filter.filterItems[0]) items = [];
                            else items = [
                                ...filter.filterItems
                            ];
                        } else // If the chosen filter is a full one and has already at least one item chosen, let's choose all its items
                        if (full) items = selectedFilter.filterItems.length === filter.filterItems.length ? [] : [
                            ...filter.filterItems
                        ];
                        else items = [
                            ...selectedFilter.filterItems,
                            ...filter.filterItems
                        ].filter((item)=>!(selectedFilter.filterItems.find((filterItem)=>item.name === filterItem.name && item.value === filterItem.value) !== undefined && filter.filterItems.find((filterItem)=>item.name === filterItem.name && item.value === filterItem.value) !== undefined));
                        // Let's remove this filter from remainingData because it has been processed
                        remainingData = remainingData.filter((fil)=>fil.id !== filter.id);
                    }
                });
                items.length > 0 && (tempFilters = [
                    ...tempFilters,
                    {
                        id: selectedFilter.id,
                        title: selectedFilter.title,
                        filterItems: items
                    }
                ]);
            });
            // If some filters weren't in the selected filters, we add them to the selected filters
            remainingData.length > 0 && (tempFilters = [
                ...tempFilters,
                ...remainingData
            ]);
        } else data.length > 0 && (tempFilters = data);
        setSelectedFilters(tempFilters);
        timerRef.current = setTimeout(()=>{
            (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, {
                filters: tempFilters
            });
            setLoadingData(true);
        }, timerForFilterSelectionListMode === undefined ? 1000 : timerForFilterSelectionListMode);
    };
    const value = (0, $lT7pJ.useMemo)(()=>({
            content: content,
            filters: filters,
            selectedFilters: selectedFilters,
            loadingData: loadingData,
            color: color,
            setContent: setContent,
            setSelectedFilters: setSelectedFilters,
            resetFilters: resetFilters,
            processFiltersOnChange: processFiltersOnChange,
            setSuggestedFilter: setSuggestedFilter,
            setLoadingData: setLoadingData
        }), [
        content,
        filters,
        selectedFilters,
        loadingData,
        color,
        setContent,
        setSelectedFilters,
        resetFilters,
        processFiltersOnChange,
        setSuggestedFilter,
        setLoadingData
    ]);
    /**
   * On content state change :
   *  - if there is no content, reset all filters and selected filters
   *  - if there is some content, set filters state with the content received or an empty array, and selectedFilters state with received data if there are some
   */ (0, $lT7pJ.useEffect)(()=>{
        if (content) {
            if (filters.length === 0 || content.channelData?.filters !== filters) setFilters(content.channelData?.filters || []);
            content.channelData?.selectedFilters && setSelectedFilters(content.channelData?.selectedFilters);
        } else totalReset();
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($ad61851cc46e2afe$export$52411773e0d6f15d.Provider, {
            value: value,
            children: children
        })
    });
}


const $250b0a7836dcf02d$var$ListContextProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ad61851cc46e2afe$export$9b0a72e5d41d62ec), {
        children: children
    });
};
var $250b0a7836dcf02d$export$2e2bcd8739ae039 = $250b0a7836dcf02d$var$ListContextProvider;




var $lT7pJ = parcelRequire("lT7pJ");




const $0fdc9a557a65290b$export$d07f57595c356899 = (text, locale = "fr-FR")=>{
    if (text && text.length > 0) {
        const first = text.charAt(0);
        const rest = text.slice(1);
        return first.toLocaleUpperCase(locale) + rest;
    }
    return "";
};




/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");


parcelRequire("lT7pJ");
const $e53ed9bcd08679c4$var$Desktop = ({ className: className, background: background, children: children })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-z-dropdown rf-relative rf-col-start-5 rf-col-end-13 rf-row-start-1 rf-row-span-full rf-w-3/5 rf-justify-self-center tactile:rf-pt-1/5 rf-flex rf-flex-col rf-justify-start rf-items-center rf-bg-templateBackground rf-shadow-[3px_3px_6px_#00000029] rf-overflow-y-scroll rf-scrollbar-hidden ${className}`,
        style: {
            background: background || ""
        },
        children: children
    });
};
var $e53ed9bcd08679c4$export$2e2bcd8739ae039 = $e53ed9bcd08679c4$var$Desktop;




var $lT7pJ = parcelRequire("lT7pJ");

const $8be45c55c8dfd1e6$var$FullScreen = ({ className: className, depth: depth, background: background, children: children })=>{
    const [zindex, setzindex] = (0, $lT7pJ.useState)("rf-z-ui");
    (0, $lT7pJ.useEffect)(()=>{
        switch(depth){
            case (0, $45d43a6de0968f42$export$950556173b6cbecb).background:
                setzindex("rf-z-background");
                break;
            case (0, $45d43a6de0968f42$export$950556173b6cbecb).util:
                setzindex("rf-z-util");
                break;
            case (0, $45d43a6de0968f42$export$950556173b6cbecb).chatbot:
                setzindex("rf-z-chatbot");
                break;
            case (0, $45d43a6de0968f42$export$950556173b6cbecb).ui:
                setzindex("rf-z-ui");
                break;
            case (0, $45d43a6de0968f42$export$950556173b6cbecb).dropdown:
                setzindex("rf-z-dropdown");
                break;
            case (0, $45d43a6de0968f42$export$950556173b6cbecb).overlay:
                setzindex("rf-z-overlay");
                break;
            case (0, $45d43a6de0968f42$export$950556173b6cbecb).modal:
                setzindex("rf-z-modal");
                break;
            case (0, $45d43a6de0968f42$export$950556173b6cbecb).exitwidget:
                setzindex("rf-z-exitwidget");
                break;
            case (0, $45d43a6de0968f42$export$950556173b6cbecb).menu:
                setzindex("rf-z-menu");
                break;
            default:
                setzindex("rf-z-dropdown");
                break;
        }
    }, [
        depth
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-relative ${zindex} rf-col-start-1 rf-col-span-full rf-row-start-1 rf-row-span-full rf-text-trueblack ${className}`,
        style: {
            background: background || "linear-gradient(to right bottom, #F8F8FC , #E1E2E8)"
        },
        children: children
    });
};
var $8be45c55c8dfd1e6$export$2e2bcd8739ae039 = $8be45c55c8dfd1e6$var$FullScreen;



parcelRequire("lT7pJ");


const $3a37d54dea28d7e8$var$FullScreenMobile = ({ className: className, depth: depth, background: background, children: children })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const displayControls = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.displayControls);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8be45c55c8dfd1e6$export$2e2bcd8739ae039), {
        className: `${isMobile && displayControls && "rf-mb-12"} rf-p-4 rf-flex rf-flex-col ${className}`,
        depth: depth,
        background: background || "#FFFFFF",
        children: children
    });
};
var $3a37d54dea28d7e8$export$2e2bcd8739ae039 = $3a37d54dea28d7e8$var$FullScreenMobile;



parcelRequire("lT7pJ");

const $1241df08e86bc062$var$FullScreenRemote = ({ className: className, background: background, onClick: onClick, animation: animation, children: children })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $dc32a48dada8397f$export$407448d2b89b1813).div, {
        className: `rf-z-util rf-relative rf-overflow-y-scroll rf-scrollbar-hidden rf-text-black rf-text-size-auto rf-bg-templateBackground large:rf-mr-30 rf-col-span-full rf-row-span-full ${className}`,
        style: {
            background: background || "",
            outline: "1px solid transparent",
            ...animation
        },
        onClick: onClick ? ()=>onClick() : ()=>{},
        children: children
    });
};
var $1241df08e86bc062$export$2e2bcd8739ae039 = $1241df08e86bc062$var$FullScreenRemote;





var $lT7pJ = parcelRequire("lT7pJ");
const $d0a650716ddf332c$var$Grid = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-grid rf-grid-cols-2 large:rf-grid-cols-5 large-vertical:rf-grid-cols-3 rf-gap-4 large:rf-gap-6",
        children: (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Children.map(children, (child)=>{
            return child;
        })
    });
};
var $d0a650716ddf332c$export$2e2bcd8739ae039 = $d0a650716ddf332c$var$Grid;



/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");






var $lT7pJ = parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");



const $7efb21d01742ced3$var$useCloseButtonTop = ()=>{
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const isTactile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isTactile);
    const [top, setTop] = (0, $lT7pJ.useState)(200);
    /**
   * On currentDeviceType change :
   *  - switch on currentDeviceType and check for tactile
   *  - set top state to the value in configuration if given, or a default one
   */ (0, $lT7pJ.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).landscape:
                if (isTactile) setTop(configuration.remote?.desktopTactile || "9.75rem");
                else setTop(configuration.remote?.desktop || "9.75rem");
                break;
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).borne:
                setTop(configuration.remote?.verticalTactile || "calc(50% - 11.25rem)");
                break;
            default:
                setTop(200);
                break;
        }
    }, [
        currentDeviceType
    ]);
    return top;
};
var $7efb21d01742ced3$export$2e2bcd8739ae039 = $7efb21d01742ced3$var$useCloseButtonTop;




var $lT7pJ = parcelRequire("lT7pJ");

parcelRequire("lT7pJ");
const $74d44cd7cee6f057$var$DashboardIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: color || "currentColor",
        className: className || "w-6",
        viewBox: "0 0 27.93 16.72",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M1.23 2.46a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23ZM1.23 9.59a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23ZM1.23 16.72a1.23 1.23 0 1 1 0-2.46h25.46a1.23 1.23 0 1 1 0 2.46H1.23Z"
        })
    });
};
var $74d44cd7cee6f057$export$2e2bcd8739ae039 = $74d44cd7cee6f057$var$DashboardIcon;



parcelRequire("lT7pJ");
const $9860c37d6755e19a$var$KeyboardIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 22.5 15",
        className: className || "w-6",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("filter", {
                    id: "Icon_awesome-keyboard",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M20.625,19.5H1.875A1.875,1.875,0,0,1,0,17.625V6.375A1.875,1.875,0,0,1,1.875,4.5h18.75A1.875,1.875,0,0,1,22.5,6.375v11.25A1.875,1.875,0,0,1,20.625,19.5ZM5,9.031V7.469A.469.469,0,0,0,4.531,7H2.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H4.531A.469.469,0,0,0,5,9.031Zm3.75,0V7.469A.469.469,0,0,0,8.281,7H6.719a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H8.281A.469.469,0,0,0,8.75,9.031Zm3.75,0V7.469A.469.469,0,0,0,12.031,7H10.469A.469.469,0,0,0,10,7.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,12.5,9.031Zm3.75,0V7.469A.469.469,0,0,0,15.781,7H14.219a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,16.25,9.031Zm3.75,0V7.469A.469.469,0,0,0,19.531,7H17.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,9.031ZM6.875,12.781V11.219a.469.469,0,0,0-.469-.469H4.844a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469H6.406A.469.469,0,0,0,6.875,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H8.594a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,10.625,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H12.344a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.562A.469.469,0,0,0,14.375,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H16.094a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,18.125,12.781ZM5,16.531V14.969a.469.469,0,0,0-.469-.469H2.969a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,2.969,17H4.531A.469.469,0,0,0,5,16.531Zm11.25,0V14.969a.469.469,0,0,0-.469-.469H6.719a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,6.719,17h9.063A.469.469,0,0,0,16.25,16.531Zm3.75,0V14.969a.469.469,0,0,0-.469-.469H17.969a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,16.531Z",
                        transform: "translate(0 -4.5)",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-keyboard)",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M20.625,19.5H1.875A1.875,1.875,0,0,1,0,17.625V6.375A1.875,1.875,0,0,1,1.875,4.5h18.75A1.875,1.875,0,0,1,22.5,6.375v11.25A1.875,1.875,0,0,1,20.625,19.5ZM5,9.031V7.469A.469.469,0,0,0,4.531,7H2.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H4.531A.469.469,0,0,0,5,9.031Zm3.75,0V7.469A.469.469,0,0,0,8.281,7H6.719a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469H8.281A.469.469,0,0,0,8.75,9.031Zm3.75,0V7.469A.469.469,0,0,0,12.031,7H10.469A.469.469,0,0,0,10,7.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,12.5,9.031Zm3.75,0V7.469A.469.469,0,0,0,15.781,7H14.219a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,16.25,9.031Zm3.75,0V7.469A.469.469,0,0,0,19.531,7H17.969a.469.469,0,0,0-.469.469V9.031a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,9.031ZM6.875,12.781V11.219a.469.469,0,0,0-.469-.469H4.844a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469H6.406A.469.469,0,0,0,6.875,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H8.594a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,10.625,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H12.344a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.562A.469.469,0,0,0,14.375,12.781Zm3.75,0V11.219a.469.469,0,0,0-.469-.469H16.094a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,18.125,12.781ZM5,16.531V14.969a.469.469,0,0,0-.469-.469H2.969a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,2.969,17H4.531A.469.469,0,0,0,5,16.531Zm11.25,0V14.969a.469.469,0,0,0-.469-.469H6.719a.469.469,0,0,0-.469.469v1.563A.469.469,0,0,0,6.719,17h9.063A.469.469,0,0,0,16.25,16.531Zm3.75,0V14.969a.469.469,0,0,0-.469-.469H17.969a.469.469,0,0,0-.469.469v1.563a.469.469,0,0,0,.469.469h1.563A.469.469,0,0,0,20,16.531Z",
                            transform: "translate(0 -4.5)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $9860c37d6755e19a$export$2e2bcd8739ae039 = $9860c37d6755e19a$var$KeyboardIcon;



parcelRequire("lT7pJ");
const $bc79d8ffc04dbc80$var$MicrophoneIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || "rf-h-6",
        viewBox: "0 0 14.426 20.983",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("filter", {
                    id: "Icon_awesome-microphone",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M7.213,14.426a3.934,3.934,0,0,0,3.934-3.934V3.934a3.934,3.934,0,1,0-7.869,0v6.557A3.934,3.934,0,0,0,7.213,14.426ZM13.77,7.869h-.656a.656.656,0,0,0-.656.656v1.967a5.252,5.252,0,0,1-5.77,5.22,5.405,5.405,0,0,1-4.722-5.454V8.524a.656.656,0,0,0-.656-.656H.656A.656.656,0,0,0,0,8.524V10.17a7.439,7.439,0,0,0,6.229,7.446v1.4h-2.3a.656.656,0,0,0-.656.656v.656a.656.656,0,0,0,.656.656h6.557a.656.656,0,0,0,.656-.656v-.656a.656.656,0,0,0-.656-.656H8.2V17.632a7.22,7.22,0,0,0,6.229-7.14V8.524A.656.656,0,0,0,13.77,7.869Z",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-microphone)",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M7.213,14.426a3.934,3.934,0,0,0,3.934-3.934V3.934a3.934,3.934,0,1,0-7.869,0v6.557A3.934,3.934,0,0,0,7.213,14.426ZM13.77,7.869h-.656a.656.656,0,0,0-.656.656v1.967a5.252,5.252,0,0,1-5.77,5.22,5.405,5.405,0,0,1-4.722-5.454V8.524a.656.656,0,0,0-.656-.656H.656A.656.656,0,0,0,0,8.524V10.17a7.439,7.439,0,0,0,6.229,7.446v1.4h-2.3a.656.656,0,0,0-.656.656v.656a.656.656,0,0,0,.656.656h6.557a.656.656,0,0,0,.656-.656v-.656a.656.656,0,0,0-.656-.656H8.2V17.632a7.22,7.22,0,0,0,6.229-7.14V8.524A.656.656,0,0,0,13.77,7.869Z",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $bc79d8ffc04dbc80$export$2e2bcd8739ae039 = $bc79d8ffc04dbc80$var$MicrophoneIcon;



parcelRequire("lT7pJ");
const $c134278dddcf92b2$var$MicrophoneIconOn = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-8",
        viewBox: "0 0 21.055 18.479",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            transform: "translate(-44.181 -45.388)",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("rect", {
                    width: "8.229",
                    height: "18.479",
                    rx: "2",
                    transform: "translate(44.181 45.388)",
                    fill: color || "#ff6462"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("rect", {
                    width: "8.229",
                    height: "18.479",
                    rx: "2",
                    transform: "translate(57.007 45.388)",
                    fill: color || "#ff6462"
                })
            ]
        })
    });
};
var $c134278dddcf92b2$export$2e2bcd8739ae039 = $c134278dddcf92b2$var$MicrophoneIconOn;



parcelRequire("lT7pJ");
const $d0fa713f2d51a0aa$var$MicrophoneIconOff = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 19 19",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("circle", {
            cx: "9.5",
            cy: "9.5",
            r: "9.5",
            fill: color || "#ff6462"
        })
    });
};
var $d0fa713f2d51a0aa$export$2e2bcd8739ae039 = $d0fa713f2d51a0aa$var$MicrophoneIconOff;






const $46ab1b43aa817fae$var$DashboardButton = ({ dashboardVisible: dashboardVisible, onClick: onClick })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const [label, setLabel] = (0, $lT7pJ.useState)("");
    (0, $lT7pJ.useEffect)(()=>{
        setLabel(dashboardVisible ? translation.common.close : translation.common.menu);
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        className: "rf-w-18 rf-h-18 rf-mb-6 rf-flex rf-flex-col rf-justify-center rf-items-center rf-bg-truewhite rf-text-xsm rf-text-trueblack rf-border rf-border-menuBorder rf-rounded-half hover:rf-cursor-pointer rf-shadow-[0_3px_6px_#606267]",
        "aria-label": label,
        // data-map used in interactive map to use this button externaly
        "data-map": dashboardVisible ? "fermer" : "dashboard",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-uppercase",
                children: label
            }),
            dashboardVisible ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1bb6c2a3a9b42097$export$2e2bcd8739ae039), {
                className: "rf-h-6 rf-w-6"
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $74d44cd7cee6f057$export$2e2bcd8739ae039), {
                className: "rf-h-6 rf-w-6"
            })
        ]
    });
};
var $46ab1b43aa817fae$export$2e2bcd8739ae039 = $46ab1b43aa817fae$var$DashboardButton;


const $861fac448a37f7dd$var$AbsoluteLargeClosingButton = ({ dashboardVisible: dashboardVisible, zIndexClassname: zIndexClassname, customComponent: customComponent, onClick: onClick })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const top = (0, $7efb21d01742ced3$export$2e2bcd8739ae039)();
    const [hidden, setHidden] = (0, $lT7pJ.useState)(false);
    const handleHideAndClose = ()=>{
        dashboardVisible && !customComponent && setHidden(true);
        onClick();
    };
    return isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-absolute ${hidden && "rf-hidden"} rf-w-24 rf-flex rf-justify-center rf-right-0 ${zIndexClassname}`,
        style: {
            top: top
        },
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $46ab1b43aa817fae$export$2e2bcd8739ae039), {
            dashboardVisible: dashboardVisible,
            onClick: handleHideAndClose
        })
    });
};
var $861fac448a37f7dd$export$2e2bcd8739ae039 = $861fac448a37f7dd$var$AbsoluteLargeClosingButton;


const $3976fc38b762a4bf$var$SubMenu = ({ background: background, onClick: onClick, children: children })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isLandscape = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isLandscape);
    const isBorne = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isBorne);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            !isMobile && onClick && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $861fac448a37f7dd$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                zIndexClassname: "rf-z-util",
                onClick: onClick
            }),
            isBorne ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $1241df08e86bc062$export$2e2bcd8739ae039), {
                className: "rf-z-dropdown rf-flex rf-flex-col rf-pt-[25vh] rf-pb-[15vh] rf-justify-start rf-items-center rf-shadow-[20px_3px_20px_#00000029] rf-overflow-y-scroll rf-scrollbar-hidden",
                background: background || "#FFFFFF",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $39f3e48cc7ad4ecb$export$2e2bcd8739ae039), {}),
                    children
                ]
            }) : isLandscape ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e53ed9bcd08679c4$export$2e2bcd8739ae039), {
                background: background || "#FFFFFF",
                children: children
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3a37d54dea28d7e8$export$2e2bcd8739ae039), {
                depth: (0, $45d43a6de0968f42$export$950556173b6cbecb).dropdown,
                children: children
            })
        ]
    });
};
var $3976fc38b762a4bf$export$2e2bcd8739ae039 = $3976fc38b762a4bf$var$SubMenu;



parcelRequire("lT7pJ");





parcelRequire("lT7pJ");


parcelRequire("lT7pJ");
const $491a12661fd84d1f$var$ArrowDownIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || "currentColor",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M14 11.18 24.6.58a2 2 0 0 1 2.82 0 2.02 2.02 0 0 1 0 2.84l-12 12a2 2 0 0 1-2.76.05L.58 3.44A2 2 0 0 1 3.41.6Z"
        })
    });
};
var $491a12661fd84d1f$export$2e2bcd8739ae039 = $491a12661fd84d1f$var$ArrowDownIcon;



parcelRequire("lT7pJ");
const $4b95d9624e850f76$var$ArrowIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43.776 39.197",
        className: className || "rf-h-6 rf-w-8",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            transform: "translate(9.939 -0.321) rotate(17)",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M28.156,0S31.392,28.156,0,28.156",
                    transform: "translate(5.721 0)",
                    fill: "none",
                    stroke: color || "#1999b1",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M0,0,8.8,8.8l8.8-8.8",
                    transform: "translate(8.688 18.779) rotate(81)",
                    fill: "none",
                    stroke: color || "#1999b1",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                })
            ]
        })
    });
};
var $4b95d9624e850f76$export$2e2bcd8739ae039 = $4b95d9624e850f76$var$ArrowIcon;



parcelRequire("lT7pJ");
const $cfe8bc90bdab329b$var$ArrowLeftIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || "currentColor",
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 17l-5-5m0 0l5-5m-5 5h12"
        })
    });
};
var $cfe8bc90bdab329b$export$2e2bcd8739ae039 = $cfe8bc90bdab329b$var$ArrowLeftIcon;



parcelRequire("lT7pJ");
const $4365628ed5afaad5$var$ArrowRightIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: color || "currentColor",
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13 7l5 5m0 0l-5 5m5-5H6"
        })
    });
};
var $4365628ed5afaad5$export$2e2bcd8739ae039 = $4365628ed5afaad5$var$ArrowRightIcon;



parcelRequire("lT7pJ");
const $f1e16fab284e9cc3$var$ArrowUpIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || "currentColor",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M14 4.83 3.4 15.43a2 2 0 0 1-2.82 0 2.02 2.02 0 0 1 0-2.84l12-12a2 2 0 0 1 2.76-.06l12.08 12.05a2 2 0 0 1-2.83 2.83Z"
        })
    });
};
var $f1e16fab284e9cc3$export$2e2bcd8739ae039 = $f1e16fab284e9cc3$var$ArrowUpIcon;




const $50f60202d3acc5ad$var$BackButton = ({ title: title, className: className, handleBack: handleBack })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        className: `rf-flex rf-flex-row rf-items-center ${className}`,
        onClick: handleBack,
        "aria-label": title,
        "data-map": "fermer",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $cfe8bc90bdab329b$export$2e2bcd8739ae039), {
                className: "rf-w-8"
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-ml-1",
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(title)
            })
        ]
    });
};
var $50f60202d3acc5ad$export$2e2bcd8739ae039 = $50f60202d3acc5ad$var$BackButton;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("lT7pJ");









var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");








parcelRequire("lT7pJ");

/* eslint-disable react/self-closing-comp */ 
parcelRequire("lT7pJ");
const $976e799b66e7a1ff$var$EmergencyIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            fill: color || "#1999B1",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M294.4,182.4h34.1v34.1c0,3.9,3.1,7,7,7h47c3.9,0,7-3.1,7-7v-34.1h34.1c3.9,0,7-3.1,7-7v-47c0-3.9-3.1-7-7-7h-34.1V87.3   c0-3.9-3.1-7-7-7h-47c-3.9,0-7,3.1-7,7v34.1h-34.1c-3.9,0-7,3.1-7,7v47C287.4,179.3,290.6,182.4,294.4,182.4z M301.4,135.4h34.1   c3.9,0,7-3.1,7-7V94.3h33v34.1c0,3.9,3.1,7,7,7h34.1v33h-34.1c-3.9,0-7,3.1-7,7v34.1h-33v-34.1c0-3.9-3.1-7-7-7h-34.1V135.4z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M218.1,285.1c0.1,3.8,3.2,6.8,6.9,6.8c0.9,0,95.2,1.1,133.1,1.1c78.5,0,142.5-63.9,142.5-142.5S436.7,8.2,358.1,8.2   c-78.5,0-142.5,63.9-142.5,142.5C215.7,186.8,218.1,284.2,218.1,285.1z M358.1,22.2c70.8,0,128.5,57.6,128.5,128.5   S429,279.1,358.1,279.1c-31.9,0-103.8-0.8-126.2-1c-0.5-22.8-2.3-97-2.3-127.4C229.7,79.8,287.3,22.2,358.1,22.2z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M191.5,94c1,0.5,2,0.7,3,0.7c2.6,0,5.1-1.5,6.3-4c0.2-0.4,21.5-45.1,51-70.9c2.9-2.5,3.2-7,0.7-9.9c-2.5-2.9-7-3.2-9.9-0.7   c-31.8,27.7-53.6,73.5-54.5,75.5C186.5,88.2,188,92.3,191.5,94z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M176.6,60.1c1.1,0.6,2.2,0.8,3.3,0.8c2.5,0,4.9-1.3,6.2-3.7c0.1-0.2,13.2-24.6,27.9-36.4c3-2.4,3.5-6.8,1.1-9.8   c-2.4-3-6.8-3.5-9.8-1.1c-16.9,13.6-30.9,39.6-31.5,40.7C171.9,54.1,173.2,58.3,176.6,60.1z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M490.2,255.8c-0.3,0.4-34.6,36.1-70.7,51.3c-3.6,1.5-5.2,5.6-3.7,9.2c1.1,2.7,3.7,4.3,6.5,4.3c0.9,0,1.8-0.2,2.7-0.5   c38.9-16.3,73.9-53,75.4-54.6c2.7-2.8,2.5-7.2-0.3-9.9S492.8,253,490.2,255.8z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M503.6,292.4c-2.7-2.8-7.1-2.9-9.9-0.2c-0.2,0.2-20.3,19.2-37.9,25.8c-3.6,1.4-5.5,5.4-4.1,9c1.1,2.8,3.7,4.5,6.6,4.5   c0.8,0,1.6-0.1,2.5-0.4c20.3-7.6,41.8-27.9,42.7-28.8C506.2,299.6,506.3,295.2,503.6,292.4z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M490.2,372.5c-1.6-0.5-40.7-13.2-71.4,4c-16,9-26.7,24.2-31.6,45.4c-12.9,55-48.2,58-85.6,52l17.2-10   c18.4-10.7,24.7-34.4,14-52.8L302.5,359c-10.7-18.4-34.4-24.7-52.8-14l-36.7,21.3c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0-6.4,4-17.1,1.6   c-12.6-2.7-32.6-14.3-56.7-53.7c-22-39.9-22.4-62.9-18.8-75.2c3.1-10.5,9.4-14.3,10.1-14.7c0.2-0.1,0.2-0.1,0.4-0.2l36.7-21.3   c18.4-10.7,24.7-34.4,14-52.8L151,98.2c-10.7-18.4-34.4-24.7-52.8-14L60.8,106c-0.1,0-0.2,0.1-0.2,0.1c-1.5,1-38.1,24.6-48.6,67   C-4,237.2,63,350,65.9,354.7c0.3,0.6,0.8,1.1,1.2,1.5c0.1,0.6,0.4,1.2,0.7,1.8c2.7,4.8,67.5,118.9,131,136.8   c42.1,11.8,80.7-8.2,82.3-9c0.1,0,0.2-0.1,0.2-0.1l2.4-1.4c0.7,0.5,1.6,0.9,2.5,1c12.3,2.5,25.9,4.8,39.4,4.8   c8.5,0,17-0.9,25.2-3.4c25.4-7.6,42.2-28.3,50-61.7c4-17.1,12.3-29.3,24.8-36.3c25.3-14.2,59.9-3.1,60.2-3c3.7,1.2,7.6-0.8,8.8-4.4   C495.9,377.7,493.9,373.8,490.2,372.5z M256.8,357.2c11.7-6.8,26.8-2.8,33.7,8.9l30.3,52.1c6.8,11.7,2.8,26.8-8.9,33.7l-9.5,5.5   c-39.1-34.5-52.5-80.7-55.8-94.2L256.8,357.2z M202.6,481.4C144.7,465.1,80.7,352.3,80,351.2c-0.4-0.6-0.8-1.2-1.3-1.7   c-0.2-0.7-0.4-1.4-0.8-2c-0.7-1.1-66.9-112.5-52.4-171c8.9-35.9,40.5-57.3,42.4-58.5l14.6-8.5c1.8,7,5.2,18,10.9,30.9   c1.6,3.5,5.7,5.1,9.2,3.6c0.2-0.1,0.5-0.2,0.7-0.4c3-1.8,4.3-5.6,2.9-8.9c-6.6-14.8-9.8-27-11.1-32.6l10.1-5.9   c11.7-6.8,26.8-2.8,33.7,8.9l30.3,52.1c6.8,11.7,2.8,26.8-8.9,33.7l-9.6,5.6c-11.1-9.9-21-21.4-29.5-34.5c-2.1-3.2-6.4-4.1-9.7-2   c-3.2,2.1-4.1,6.5-2,9.7c8.3,12.7,17.9,24.2,28.6,34.2l-14.2,8.2c-2.2,1.1-12.1,7-16.9,22.3c-6.6,21-0.5,49.1,18,83.7   c0.2,0.5,0.4,1,0.6,1.4c0.4,0.7,0.8,1.3,1.2,2c0.4,0.7,0.7,1.3,1.1,2c0.3,0.5,0.6,0.9,0.9,1.3c20.9,33.2,42.3,52.4,63.8,57.1   c15.7,3.4,25.7-2.3,27.7-3.6l13.7-7.9c4.7,18.1,19,60.2,55.7,94.3l-15.1,8.8C272.4,474.6,238.4,491.5,202.6,481.4z"
                })
            ]
        })
    });
};
var $976e799b66e7a1ff$export$2e2bcd8739ae039 = $976e799b66e7a1ff$var$EmergencyIcon;


/* eslint-disable react/self-closing-comp */ 
parcelRequire("lT7pJ");
const $b8da18b91031c7fa$var$HomeIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 25 25",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M39.908,31.05l-4.784-4.784V21.032a.312.312,0,0,0-.312-.312H31.887a.312.312,0,0,0-.312.312v1.685L27.72,18.861a.312.312,0,0,0-.441,0L15.091,31.05a.312.312,0,1,0,.441.441L17.925,29.1V42.483a.312.312,0,0,0,.312.312h6.825a.312.312,0,0,0,.312-.312V35.97h4.252v6.514a.312.312,0,0,0,.312.312h6.825a.312.312,0,0,0,.312-.312V29.1l2.393,2.393a.312.312,0,1,0,.441-.441ZM32.2,21.344h2.3v4.3l-2.3-2.3Zm4.252,20.827h-6.2V35.658a.312.312,0,0,0-.312-.312H25.062a.312.312,0,0,0-.312.312v6.514h-6.2v-13.7L27.5,19.523l4.167,4.167h0l2.925,2.925h0l1.859,1.859Z",
            transform: "translate(-15 -18.77)",
            fill: color || "#1999b1"
        })
    });
};
var $b8da18b91031c7fa$export$2e2bcd8739ae039 = $b8da18b91031c7fa$var$HomeIcon;


/* eslint-disable react/self-closing-comp */ 
parcelRequire("lT7pJ");
const $d413dc129fffc71b$var$InteractiveMapIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                fill: color || "#1999B1",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M256,93.297c-14.021,0-27.516,4.218-39.025,12.198c-3.402,2.359-4.262,7.05-1.921,10.478 c2.342,3.428,6.998,4.294,10.4,1.936c9.004-6.243,19.566-9.543,30.546-9.543c29.754,0,53.96,24.388,53.96,54.365 c0,29.977-24.206,54.366-53.96,54.366c-29.754,0-53.96-24.389-53.96-54.366c0-8.843,2.038-17.273,6.057-25.055 c1.906-3.692,0.482-8.241-3.182-10.161c-3.665-1.919-8.178-0.486-10.085,3.206c-5.067,9.812-7.746,20.881-7.746,32.01 C187.085,201.018,218,232.166,256,232.166s68.915-31.148,68.915-69.435C324.915,124.445,294,93.297,256,93.297z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                fill: color || "#1999B1",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M511.426,501.571l-73.804-178.665c-1.16-2.809-3.883-4.639-6.903-4.639h-73.547 c14.305-19.498,26.212-38.919,35.511-57.988c16.48-33.794,24.835-66.613,24.835-97.547C417.517,73.001,345.061,0,256,0 S94.483,73.001,94.483,162.731c0,30.934,8.355,63.754,24.835,97.547c9.298,19.069,21.205,38.491,35.511,57.988H81.282 c-3.02,0-5.744,1.831-6.903,4.639L24.087,444.651c-1.587,3.842,0.217,8.252,4.03,9.85c0.94,0.394,1.912,0.581,2.87,0.581 c2.93,0,5.711-1.746,6.906-4.641l7.176-17.372h50.906l-26.38,63.862H18.69l7.647-18.513c1.587-3.842-0.217-8.252-4.03-9.85 c-3.815-1.601-8.191,0.219-9.777,4.06L0.575,501.571c-0.961,2.325-0.705,4.981,0.683,7.075c1.386,2.095,3.72,3.354,6.22,3.354 h497.044c2.499,0,4.834-1.259,6.221-3.354C512.13,506.552,512.387,503.896,511.426,501.571z M109.439,162.731 c0-81.422,65.747-147.663,146.561-147.663S402.561,81.31,402.561,162.731c0,34.143-11.775,88.703-66.245,158.231 c-0.055,0.065-0.104,0.134-0.156,0.201c-2.782,3.547-5.672,7.132-8.681,10.757c-29.932,36.062-60.222,62.395-71.48,71.751 c-11.225-9.324-41.372-35.525-71.283-71.518c-3.084-3.711-6.042-7.38-8.889-11.01c-0.046-0.058-0.089-0.118-0.137-0.175 C121.222,251.445,109.439,196.887,109.439,162.731z M86.269,333.335h50.907l-18.568,44.948H67.702L86.269,333.335z M129.997,496.932l46.741-113.148l133.014,113.148H129.997z M332.935,496.932L332.935,496.932l-154.352-131.3 c-1.822-1.551-4.27-2.132-6.584-1.566c-2.316,0.565-4.228,2.21-5.143,4.427l-53.057,128.438H85.795l28.296-68.502 c0.961-2.325,0.705-4.98-0.683-7.075c-1.386-2.095-3.721-3.354-6.221-3.354H51.296l10.182-24.65h62.118 c3.02,0,5.744-1.831,6.903-4.639l22.876-55.377h12.978c2.253,2.83,4.543,5.661,6.894,8.491 c38.585,46.43,76.578,76.239,78.177,77.486c1.348,1.051,2.962,1.575,4.576,1.575s3.229-0.525,4.576-1.575 c0.879-0.685,12.757-10.009,29.673-25.96h84.681c4.13,0,7.478-3.373,7.478-7.534s-3.348-7.534-7.478-7.534h-69.269 c10.368-10.503,21.7-22.749,33.093-36.457c2.351-2.83,4.642-5.66,6.894-8.491h80.083l18.567,44.948h-39.457 c-4.13,0-7.478,3.373-7.478,7.534s3.347,7.534,7.478,7.534h45.681l10.182,24.65h-154.07c-3.121,0-5.913,1.952-7.006,4.898 c-1.091,2.946-0.253,6.265,2.104,8.326l75.133,65.707H332.935z M399.681,496.932l-73.024-63.862H466.93l26.381,63.862H399.681z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {})
        ]
    });
};
var $d413dc129fffc71b$export$2e2bcd8739ae039 = $d413dc129fffc71b$var$InteractiveMapIcon;


/* eslint-disable react/self-closing-comp */ 
parcelRequire("lT7pJ");
const $ccfe9e34fb93a0ee$var$NewsChannelIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 512 512",
        className: className || "rf-h-6 rf-w-6",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            fill: color || "#1999B1",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M500.9,13.5H325.3c-3.9,0-7,3.1-7,7v142.4c0,3.9,3.1,7,7,7h39.6v41.4c0,2.7,1.6,5.2,4,6.3c0.9,0.4,2,0.7,3,0.7   c1.6,0,3.2-0.6,4.5-1.6l55.5-46.8h68.9c3.9,0,7-3.1,7-7V20.5C507.9,16.6,504.8,13.5,500.9,13.5z M493.9,155.9h-64.5   c-1.6,0-3.2,0.6-4.5,1.6l-46,38.7v-33.4c0-3.9-3.1-7-7-7h-39.6V27.5h161.6V155.9z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M386.2,66h28.2c3.9,0,7-3.1,7-7s-3.1-7-7-7h-28.2c-3.9,0-7,3.1-7,7S382.3,66,386.2,66z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M436.7,66h32.6c3.9,0,7-3.1,7-7s-3.1-7-7-7h-32.6c-3.9,0-7,3.1-7,7S432.8,66,436.7,66z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M355.6,98.5h113.7c3.9,0,7-3.1,7-7s-3.1-7-7-7H355.6c-3.9,0-7,3.1-7,7S351.7,98.5,355.6,98.5z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M355.6,130.8h113.7c3.9,0,7-3.1,7-7s-3.1-7-7-7H355.6c-3.9,0-7,3.1-7,7S351.7,130.8,355.6,130.8z"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M335.4,277.7c-17-4.2-47.9-12.2-60.2-15.4c0.7-1.7,0.7-3.6-0.1-5.4c-0.9-2-2.6-3.5-4.7-4l-40.8-10.2v-12.9   c18.6-11.3,32.3-30.3,37-52.8h12.9c12.1,0,21.9-9.8,21.9-21.9s-9.8-21.9-21.9-21.9h-12c4.4-7.2,16.2-28.5,16.6-48.9   c0.4-26.5-29.5-49.5-37.6-53.3c-1.1-0.5-2.8-1.6-4.9-2.8c-10-5.9-28.6-16.9-50.6-16.9c-32.8,0.1-55.2,25-56.1,26.1   c-0.4,0.5-0.8,1-1,1.6C112,43.2,95.5,62.5,95.5,85.6c0,3.1,0.3,6.3,0.9,9.5c0.1,0.4,0.2,0.9,0.4,1.3l14.7,36.8h-9.8   c-12.1,0-21.9,9.8-21.9,21.9s9.8,21.9,21.9,21.9h12.9c4.7,22.5,18.4,41.5,36.9,52.8v12.9l-40.8,10.2c-2.1,0.5-3.9,2-4.7,4   c-0.8,1.8-0.8,3.8,0,5.5l-62.7,16.7c0,0-0.1,0-0.1,0c-1.1,0.3-26.8,8.1-26.8,42.2v140.6c0,0.3,0,0.6,0.1,0.8   c1.8,14.9,12.5,43,40.2,43h299.3c3.9,0,7-3.1,7-7l0-177.9C362.9,319.3,362.1,284.3,335.4,277.7z M258.1,264.3l-29.1,52l-25.1-27.9   c16.2-5.9,23.6-21.6,25.5-31.3L258.1,264.3z M287.4,155.1c0,4.4-3.5,7.9-7.9,7.9h-11.2c0-1,0.1-2.1,0.1-3.1c0-4.4-0.2-8.6-0.6-12.7   h11.7C283.9,147.2,287.4,150.7,287.4,155.1z M109.5,85.6c0-18.5,15.1-33.6,33.6-33.6c12.2,0,23.5,6.7,29.4,17.4   c1.9,3.4,6.1,4.6,9.5,2.7c3.4-1.9,4.6-6.1,2.7-9.5c-6.6-12-18-20.4-31.1-23.4c8-6.1,21.3-13.9,37.3-13.9c18.2,0,34,9.3,43.4,14.9   c2.5,1.5,4.4,2.6,6.1,3.4c5.1,2.4,29.8,21.3,29.6,40.4c-0.2,11.4-5.1,23.7-9.4,32.4c-2.6-6.8-5.8-13.6-9.8-20.7   c-1.1-2-3.1-3.3-5.4-3.5c-2.2-0.2-4.5,0.6-6,2.3c-0.2,0.2-20,22.1-49,22.2c-28.9-0.2-48.8-22-49-22.2c-1.5-1.7-3.7-2.6-6-2.3   c-2.3,0.2-4.3,1.5-5.4,3.5c-4.2,7.4-7.5,14.4-10.1,21.5l-10.1-25.4C109.7,89.8,109.5,87.6,109.5,85.6z M101.7,163   c-4.4,0-7.9-3.5-7.9-7.9s3.5-7.9,7.9-7.9h11.7c-0.4,4.1-0.6,8.3-0.6,12.7c0,1,0,2.1,0.1,3.1H101.7z M126.8,159.9   c0-17.8,3.5-33,11.5-49.3c9.5,7.9,27.7,19.9,51.7,20.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0   c24-0.3,42.3-12.3,51.7-20.2c8,16.3,11.5,31.5,11.5,49.3c0,36.8-28.6,66.8-63.8,67C155.4,226.7,126.8,196.7,126.8,159.9z   M189.5,240.9c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0,0.7,0c8.3-0.2,16.3-1.7,23.9-4.4v17.8   c-0.8,3.5-5.8,22.1-25,22.3c-19.3-0.2-24.3-18.9-25.1-22.3v-17.9C173,239.2,181.1,240.7,189.5,240.9z M151.8,257.1   c1.9,9.7,9.3,25.4,25.5,31.3l-25.1,27.9l-29.1-52L151.8,257.1z M209.4,445.8c2.1,0.8,8.2,4.2,8.2,16.5v29.4h-53.8v-45.9H209.4z   M208.3,369.8h-34.6v-15.2c0-9.5,7.8-17.3,17.3-17.3s17.3,7.8,17.3,17.3V369.8z M219.9,383.8V403H159v-19.3H219.9z M199.9,417v14.8   h-18.8V417H199.9z M348.9,491.7h-56.1V381.6c0-3.9-3.1-7-7-7s-7,3.1-7,7v110.1h-47.2v-29.4c0-13-5.1-20.5-9.3-24.5   c-3.2-3-6.4-4.5-8.4-5.2V417h13c3.9,0,7-3.1,7-7v-33.3c0-3.9-3.1-7-7-7h-4.6v-15.2c0-17.3-14-31.3-31.3-31.3s-31.3,14-31.3,31.3   v15.2H152c-3.9,0-7,3.1-7,7V410c0,3.9,3.1,7,7,7h15.2v14.8h-65.8v-49.8c0-3.9-3.1-7-7-7s-7,3.1-7,7v56.8c0,3.9,3.1,7,7,7h55.5v45.9   H56.6c-21.1,0-25.7-26.6-26.3-30.3V321.3c0-23.1,15.7-28.4,16.6-28.7l66-17.5l31.7,56.6c1.1,2,3.1,3.3,5.3,3.5c0.3,0,0.5,0,0.8,0   c2,0,3.9-0.8,5.2-2.3l34.5-38.4l34.5,38.4c1.3,1.5,3.2,2.3,5.2,2.3c0.3,0,0.5,0,0.8,0c2.2-0.2,4.2-1.6,5.3-3.5l31.8-56.7   c8.6,2.2,44.9,11.7,63.9,16.4c15.9,3.9,16.8,28.5,16.8,29.6V491.7z"
                })
            ]
        })
    });
};
var $ccfe9e34fb93a0ee$export$2e2bcd8739ae039 = $ccfe9e34fb93a0ee$var$NewsChannelIcon;


/* eslint-disable react/self-closing-comp */ 
parcelRequire("lT7pJ");
const $ee43ffc09b62205d$var$WeatherIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
            fill: color || "#1999B1",
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M439.2,385.3c0.7-3.5,1-7,1-10.6c0-31.2-25.4-56.5-56.5-56.5c-6.5,0-13,1.1-19.1,3.3c-1.4-3.6-3-7.1-4.8-10.4    C392,287.3,411,249.8,411,209.6c0-69.5-56.5-126-126-126c-69.5,0-126,56.5-126,126c0,5.7,0.4,11.3,1.1,16.9    c-16.7,9.5-30,24.6-37.2,43c-5.5-1.9-11.4-2.9-17.3-2.9c-29.1,0-52.7,23.6-52.7,52.7c0,3.2,0.3,6.4,0.9,9.5    c-20.8,10.3-34.5,31.8-34.5,55.3c0,34,27.6,61.6,61.6,61.6c0.7,0.2,1.4,0.3,2.1,0.3h26.1c2.9,15.6,10.3,29.9,21.6,41.4    c14.2,14.4,33,22.8,53.2,23.7c0.8,0.3,1.6,0.4,2.5,0.4h221.5c0.8,0,1.5-0.1,2.2-0.3c0,0,0.1,0,0.1,0c36.5,0,66.2-29.7,66.2-66.2    C476.6,419.5,461.8,396.3,439.2,385.3z M173.1,209.6c0-61.7,50.2-112,112-112s112,50.2,112,112c0,35.4-16.7,68.5-44.8,89.6    c-17-22.6-44-36.7-73.4-36.7c-0.1,0-0.1,0-0.2,0c-14.3-28.8-43.8-47.2-76.2-47.2c-10,0-19.7,1.8-28.8,5.1    C173.3,216.7,173.1,213.2,173.1,209.6z M85.4,432c-0.8-0.3-1.7-0.4-2.5-0.4c-0.6,0-1.2,0-1.8,0c-26.3,0-47.6-21.4-47.6-47.6    c0-19.8,12.5-37.8,31.1-44.7c3.5-1.3,5.4-5.1,4.3-8.6c-1.1-3.7-1.7-7.6-1.7-11.5c0-21.3,17.4-38.7,38.7-38.7    c6.3,0,12.6,1.6,18.2,4.5c1.9,1,4.1,1.1,6,0.3c1.9-0.8,3.4-2.5,4-4.5c8.6-30.4,36.8-51.6,68.4-51.6c25.2,0,48.2,13.3,61,34.5    c-42.5,7.2-75.1,43.8-76.2,88c-43.7,0.3-79.2,35.9-79.2,79.7c0,0.2,0,0.4,0,0.6H85.4z M410.3,497.2c-0.7,0-1.3,0-2-0.1    c-0.9,0-1.8,0.1-2.6,0.4H188.9c-0.7-0.2-1.4-0.4-2.2-0.4c-17.4-0.3-33.6-7.2-45.8-19.6c-12.2-12.4-18.9-28.8-18.9-46.1    c0-36.2,29.5-65.7,65.7-65.7c1.9,0,3.9,0.1,6,0.3c2,0.2,4-0.5,5.5-1.9s2.2-3.4,2.1-5.4c-0.1-1.6-0.1-3.1-0.1-4.5    c0-42.8,34.8-77.7,77.7-77.7c34.6,0,65.3,23.2,74.7,56.4c0.6,2,2,3.7,4,4.5c1.9,0.8,4.2,0.7,6-0.3c6.1-3.3,13-5,20-5    c23.5,0,42.5,19.1,42.5,42.5c0,4.3-0.6,8.6-1.9,12.6c-1.1,3.6,0.8,7.3,4.3,8.6c20.4,7.6,34.1,27.2,34.1,49    C462.6,473.8,439.2,497.2,410.3,497.2z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M485.4,203.6H443c-3.9,0-7,3.1-7,7s3.1,7,7,7h42.4c3.9,0,7-3.1,7-7S489.3,203.6,485.4,203.6z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M84.6,217.6h42.4c3.9,0,7-3.1,7-7s-3.1-7-7-7H84.6c-3.9,0-7,3.1-7,7S80.7,217.6,84.6,217.6z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M284.7,58.9c3.9,0,7-3.1,7-7V9.5c0-3.9-3.1-7-7-7s-7,3.1-7,7v42.4C277.7,55.7,280.8,58.9,284.7,58.9z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M360,79.4c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5l21.2-36.7c1.9-3.3,0.8-7.6-2.6-9.6    s-7.6-0.8-9.6,2.6l-21.2,36.7C355.5,73.2,356.7,77.4,360,79.4z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M199.7,76.8c1.3,2.2,3.6,3.5,6.1,3.5c1.2,0,2.4-0.3,3.5-0.9c3.3-1.9,4.5-6.2,2.6-9.6l-21.2-36.7    c-1.9-3.3-6.2-4.5-9.6-2.6s-4.5,6.2-2.6,9.6L199.7,76.8z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M107.8,116.6l36.7,21.2c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5c1.9-3.3,0.8-7.6-2.6-9.6l-36.7-21.2    c-3.3-1.9-7.6-0.8-9.6,2.6S104.5,114.7,107.8,116.6z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M422.3,138.7c1.2,0,2.4-0.3,3.5-0.9l36.7-21.2c3.3-1.9,4.5-6.2,2.6-9.6c-1.9-3.3-6.2-4.5-9.6-2.6l-36.7,21.2    c-3.3,1.9-4.5,6.2-2.6,9.6C417.5,137.5,419.9,138.7,422.3,138.7z"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M416.5,286.6c-1.9,3.3-0.8,7.6,2.6,9.6l36.7,21.2c1.1,0.6,2.3,0.9,3.5,0.9c2.4,0,4.8-1.3,6.1-3.5    c1.9-3.3,0.8-7.6-2.6-9.6l-36.7-21.2C422.8,282.1,418.5,283.3,416.5,286.6z"
                    })
                ]
            })
        })
    });
};
var $ee43ffc09b62205d$export$2e2bcd8739ae039 = $ee43ffc09b62205d$var$WeatherIcon;





parcelRequire("lT7pJ");
const $522cc0ac368b9533$var$BorneParametersIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M218.9,43.9l-2.6,13.3l-9.7,48.5c-15.6,6.1-29.6,14.7-42.3,25l-47.4-16.3l-12.8-4.1l-6.6,11.7L64.9,178 l-6.6,11.7l9.7,8.7l36.7,32.1c-1.3,8.4-3.1,16.7-3.1,25.5c0,8.8,1.7,17.1,3.1,25.5l-36.7,32.1l-9.7,8.7l6.6,11.7l32.6,56.1l6.6,11.7 l12.8-4.1l47.4-16.3c12.8,10.3,26.8,18.9,42.3,25l9.7,48.5l2.6,13.3h91.8l2.6-13.3l9.7-48.5c15.6-6.1,29.6-14.7,42.3-25l47.4,16.3 l12.8,4.1l6.6-11.7l32.6-56.1l6.6-11.7l-9.7-8.7l-36.7-32.1c1.3-8.4,3.1-16.7,3.1-25.5c0-8.8-1.7-17.1-3.1-25.5l36.7-32.1l9.7-8.7 l-6.6-11.7l-32.6-56.1l-6.6-11.7l-12.8,4.1l-47.4,16.3c-12.8-10.3-26.8-18.9-42.3-25l-9.7-48.5l-2.6-13.3H218.9z M245.4,76.5h38.8 l8.2,42.3l2,9.7l9.2,3.1c18.6,5.8,35.4,15.6,49.5,28.6l7.1,6.6l9.2-3.1l41.3-14.3l19.4,33.2l-32.6,29.1l-7.7,6.1l2.6,9.7 c2.1,9.3,3.1,18.8,3.1,28.6c0,9.8-1,19.3-3.1,28.6l-2,9.7l7.1,6.1l32.6,29.1l-19.4,33.2l-41.3-14.3l-9.2-3.1l-7.1,6.6 c-14.1,12.9-30.9,22.8-49.5,28.6l-9.2,3.1l-2,9.7l-8.2,42.3h-38.8l-8.2-42.3l-2-9.7l-9.2-3.1c-18.6-5.8-35.4-15.6-49.5-28.6 l-7.1-6.6l-9.2,3.1l-41.3,14.3l-19.4-33.2l32.6-29.1l7.7-6.1l-2.6-9.7c-2.1-9.3-3.1-18.8-3.1-28.6c0-9.8,1-19.3,3.1-28.6l2.6-9.7 l-7.7-6.1l-32.6-29.1l19.4-33.2l41.3,14.3l9.2,3.1l7.1-6.6c14.1-12.9,30.9-22.8,49.5-28.6l9.2-3.1l2-9.7L245.4,76.5z M264.8,174.4 c-44.9,0-81.6,36.7-81.6,81.6s36.7,81.6,81.6,81.6s81.6-36.7,81.6-81.6S309.7,174.4,264.8,174.4z M264.8,207.1c27.2,0,49,21.7,49,49 s-21.7,49-49,49c-27.2,0-49-21.7-49-49S237.6,207.1,264.8,207.1z",
            fill: color || "#95989E"
        })
    });
};
var $522cc0ac368b9533$export$2e2bcd8739ae039 = $522cc0ac368b9533$var$BorneParametersIcon;



parcelRequire("lT7pJ");
const $591d245090c72b16$var$HistoryIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || "rf-w-6 rf-flex-1",
        viewBox: "0 0 14 14",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("filter", {
                    id: "Icon_awesome-history",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M14.562,7.549A7,7,0,0,1,3.169,13.013a.677.677,0,0,1-.052-1.005l.318-.318a.679.679,0,0,1,.9-.056A5.194,5.194,0,1,0,4,3.778L5.437,5.211a.452.452,0,0,1-.319.771h-4.1A.452.452,0,0,1,.563,5.53v-4.1a.452.452,0,0,1,.771-.319L2.727,2.5A7,7,0,0,1,14.562,7.549ZM9.456,9.773l.277-.356a.677.677,0,0,0-.119-.951L8.466,7.572V4.627a.677.677,0,0,0-.677-.677H7.337a.677.677,0,0,0-.677.677V8.456L8.505,9.892A.677.677,0,0,0,9.456,9.773Z",
                        transform: "translate(-0.563 -0.563)",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_awesome-history)",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M14.562,7.549A7,7,0,0,1,3.169,13.013a.677.677,0,0,1-.052-1.005l.318-.318a.679.679,0,0,1,.9-.056A5.194,5.194,0,1,0,4,3.778L5.437,5.211a.452.452,0,0,1-.319.771h-4.1A.452.452,0,0,1,.563,5.53v-4.1a.452.452,0,0,1,.771-.319L2.727,2.5A7,7,0,0,1,14.562,7.549ZM9.456,9.773l.277-.356a.677.677,0,0,0-.119-.951L8.466,7.572V4.627a.677.677,0,0,0-.677-.677H7.337a.677.677,0,0,0-.677.677V8.456L8.505,9.892A.677.677,0,0,0,9.456,9.773Z",
                            transform: "translate(-0.56 -0.56)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $591d245090c72b16$export$2e2bcd8739ae039 = $591d245090c72b16$var$HistoryIcon;



parcelRequire("lT7pJ");
const $b442bb57964de031$var$LanguageIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "w-6",
        viewBox: "0 0 21 21",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M13.49,3A10.5,10.5,0,1,0,24,13.5,10.495,10.495,0,0,0,13.49,3Zm7.277,6.3h-3.1A16.432,16.432,0,0,0,16.22,5.562,8.431,8.431,0,0,1,20.766,9.3ZM13.5,5.142A14.791,14.791,0,0,1,15.505,9.3H11.494A14.791,14.791,0,0,1,13.5,5.142ZM5.373,15.6a8.213,8.213,0,0,1,0-4.2H8.922a17.341,17.341,0,0,0-.147,2.1,17.341,17.341,0,0,0,.147,2.1Zm.861,2.1h3.1a16.432,16.432,0,0,0,1.449,3.738A8.386,8.386,0,0,1,6.234,17.7Zm3.1-8.4h-3.1A8.386,8.386,0,0,1,10.78,5.562,16.432,16.432,0,0,0,9.331,9.3ZM13.5,21.858A14.791,14.791,0,0,1,11.494,17.7h4.011A14.791,14.791,0,0,1,13.5,21.858ZM15.957,15.6H11.043a15.448,15.448,0,0,1-.168-2.1,15.314,15.314,0,0,1,.168-2.1h4.914a15.314,15.314,0,0,1,.168,2.1A15.448,15.448,0,0,1,15.957,15.6Zm.262,5.838A16.431,16.431,0,0,0,17.668,17.7h3.1a8.431,8.431,0,0,1-4.546,3.738ZM18.078,15.6a17.341,17.341,0,0,0,.147-2.1,17.341,17.341,0,0,0-.147-2.1h3.549a8.213,8.213,0,0,1,0,4.2Z",
            transform: "translate(-3 -3)",
            fill: color || "#90939a"
        })
    });
};
var $b442bb57964de031$export$2e2bcd8739ae039 = $b442bb57964de031$var$LanguageIcon;



parcelRequire("lT7pJ");
const $a317150a7cafbd22$var$ParametersIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 27.005 27.012",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("filter", {
                    id: "Icon_ionic-ios-settings",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        d: "M29.276,18a3.475,3.475,0,0,1,2.229-3.242,13.774,13.774,0,0,0-1.667-4.016,3.522,3.522,0,0,1-1.414.3,3.467,3.467,0,0,1-3.172-4.881A13.733,13.733,0,0,0,21.245,4.5a3.472,3.472,0,0,1-6.484,0,13.774,13.774,0,0,0-4.016,1.667,3.467,3.467,0,0,1-3.172,4.881,3.407,3.407,0,0,1-1.414-.3A14.079,14.079,0,0,0,4.5,14.768a3.474,3.474,0,0,1,.007,6.484,13.774,13.774,0,0,0,1.667,4.016,3.469,3.469,0,0,1,4.578,4.578,13.855,13.855,0,0,0,4.016,1.667,3.466,3.466,0,0,1,6.47,0,13.774,13.774,0,0,0,4.016-1.667,3.472,3.472,0,0,1,4.578-4.578A13.855,13.855,0,0,0,31.5,21.252,3.492,3.492,0,0,1,29.276,18Zm-11.21,5.619A5.626,5.626,0,1,1,23.692,18,5.625,5.625,0,0,1,18.066,23.622Z",
                        transform: "translate(-4.5 -4.5)",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_ionic-ios-settings)",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M29.276,18a3.475,3.475,0,0,1,2.229-3.242,13.774,13.774,0,0,0-1.667-4.016,3.522,3.522,0,0,1-1.414.3,3.467,3.467,0,0,1-3.172-4.881A13.733,13.733,0,0,0,21.245,4.5a3.472,3.472,0,0,1-6.484,0,13.774,13.774,0,0,0-4.016,1.667,3.467,3.467,0,0,1-3.172,4.881,3.407,3.407,0,0,1-1.414-.3A14.079,14.079,0,0,0,4.5,14.768a3.474,3.474,0,0,1,.007,6.484,13.774,13.774,0,0,0,1.667,4.016,3.469,3.469,0,0,1,4.578,4.578,13.855,13.855,0,0,0,4.016,1.667,3.466,3.466,0,0,1,6.47,0,13.774,13.774,0,0,0,4.016-1.667,3.472,3.472,0,0,1,4.578-4.578A13.855,13.855,0,0,0,31.5,21.252,3.492,3.492,0,0,1,29.276,18Zm-11.21,5.619A5.626,5.626,0,1,1,23.692,18,5.625,5.625,0,0,1,18.066,23.622Z",
                            transform: "translate(-4.5 -4.5)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $a317150a7cafbd22$export$2e2bcd8739ae039 = $a317150a7cafbd22$var$ParametersIcon;



parcelRequire("lT7pJ");
const $81a87d6c2733c056$var$TutorialIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: className || "rf-h-6 rf-w-6",
        viewBox: "0 0 21.039 21.039",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("filter", {
                    id: "Icon_ionic-ios-help-buoy",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feOffset", {
                            dy: "3",
                            in: "SourceAlpha"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "3",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feFlood", {
                            floodOpacity: "0.161",
                            result: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "out",
                            in: "SourceGraphic",
                            in2: "blur"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in: "color"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("feComposite", {
                            operator: "in",
                            in2: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                "data-type": "innerShadowGroup",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                        id: "Icon_ionic-ios-help-buoy-2",
                        "data-name": "Icon ionic-ios-help-buoy",
                        d: "M13.894,3.375A10.519,10.519,0,1,0,24.414,13.894,10.518,10.518,0,0,0,13.894,3.375Zm2.761,1.841a9.126,9.126,0,0,1,5.917,5.917l-4.491.3a4.856,4.856,0,0,0-1.714-1.72Zm-9.2,2.24a9.038,9.038,0,0,1,3.677-2.24l.288,4.5a4.968,4.968,0,0,0-1.714,1.714l-4.5-.3A9.139,9.139,0,0,1,7.456,7.456Zm3.677,15.117a9.126,9.126,0,0,1-5.917-5.917l4.5-.288a4.9,4.9,0,0,0,1.709,1.709Zm2.761-5.239a3.439,3.439,0,1,1,3.439-3.439A3.443,3.443,0,0,1,13.894,17.333Zm6.438,3a9.072,9.072,0,0,1-3.677,2.24l-.3-4.5a4.872,4.872,0,0,0,1.725-1.73l4.491.3A9.056,9.056,0,0,1,20.332,20.332Z",
                        transform: "translate(-3.375 -3.375)",
                        fill: color || "#a4a7af"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                        transform: "matrix(1, 0, 0, 1, 0, 0)",
                        filter: "url(#Icon_ionic-ios-help-buoy)",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M13.894,3.375A10.519,10.519,0,1,0,24.414,13.894,10.518,10.518,0,0,0,13.894,3.375Zm2.761,1.841a9.126,9.126,0,0,1,5.917,5.917l-4.491.3a4.856,4.856,0,0,0-1.714-1.72Zm-9.2,2.24a9.038,9.038,0,0,1,3.677-2.24l.288,4.5a4.968,4.968,0,0,0-1.714,1.714l-4.5-.3A9.139,9.139,0,0,1,7.456,7.456Zm3.677,15.117a9.126,9.126,0,0,1-5.917-5.917l4.5-.288a4.9,4.9,0,0,0,1.709,1.709Zm2.761-5.239a3.439,3.439,0,1,1,3.439-3.439A3.443,3.443,0,0,1,13.894,17.333Zm6.438,3a9.072,9.072,0,0,1-3.677,2.24l-.3-4.5a4.872,4.872,0,0,0,1.725-1.73l4.491.3A9.056,9.056,0,0,1,20.332,20.332Z",
                            transform: "translate(-3.38 -3.38)",
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
};
var $81a87d6c2733c056$export$2e2bcd8739ae039 = $81a87d6c2733c056$var$TutorialIcon;




const $4a7d062b52b5ca6e$var$DisplayIcon = ({ view: view, icon: icon, className: className, color: color = "" })=>{
    if (view) return view === (0, $45d43a6de0968f42$export$3b4d92ba873f009a).home ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($b8da18b91031c7fa$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $45d43a6de0968f42$export$3b4d92ba873f009a).news ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($ccfe9e34fb93a0ee$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $45d43a6de0968f42$export$3b4d92ba873f009a).weather ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($ee43ffc09b62205d$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $45d43a6de0968f42$export$3b4d92ba873f009a).emergency ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($976e799b66e7a1ff$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $45d43a6de0968f42$export$c5a4c3ea2d78493c).history ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($591d245090c72b16$export$2e2bcd8739ae039, {
        className: className
    }) : view === (0, $45d43a6de0968f42$export$c5a4c3ea2d78493c).tutorial ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($81a87d6c2733c056$export$2e2bcd8739ae039, {
        className: className
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($d413dc129fffc71b$export$2e2bcd8739ae039, {
        className: className
    });
    else if (icon) return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `${className} ${color !== "" ? "svgButtonMenu" : ""}`,
        style: color !== "" ? {
            "--fill": color
        } : {},
        children: icon
    });
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {});
};
var $4a7d062b52b5ca6e$export$2e2bcd8739ae039 = $4a7d062b52b5ca6e$var$DisplayIcon;


function $eb8d760b8bfc59bf$var$instanceOfDisplayGeneratorProps(object) {
    return "view" in object && object.type === "BaseMenu";
}
function $eb8d760b8bfc59bf$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return "icon" in object && object.type === "CustomMenu";
}
const $eb8d760b8bfc59bf$var$DisplayGenerator = (props)=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const homeActivity = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.homeActivity);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const [label, setLabel] = (0, $lT7pJ.useState)("");
    const [colorButtonHandle, setColorButtonHandle] = (0, $lT7pJ.useState)("");
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $lT7pJ.useEffect)(()=>{
        if ($eb8d760b8bfc59bf$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($eb8d760b8bfc59bf$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === "string") setLabel(props.label);
            else if (props.label && typeof props.label === "object") setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        let colorButtonHandle = "";
        // Handle hospitality menu icon color
        if ($eb8d760b8bfc59bf$var$instanceOfCustomMenuDisplayGeneratorProps(props) && props.name) {
            if (props.name.toString().indexOf("whatToDo") > -1) colorButtonHandle = themeColors.tobeDoneColor;
            else if (props.name.toString().indexOf("localProducts") > -1) colorButtonHandle = themeColors.localProductsColor;
            else if (props.name.toString().indexOf("whereToEat") > -1) colorButtonHandle = themeColors.whereToEatColor;
            else if (props.name.toString().indexOf("whereToSleep") > -1) colorButtonHandle = themeColors.whereToSleepColor;
            else if (props.name.toString().indexOf("whatToSee") > -1) colorButtonHandle = themeColors.tobeSeenColor;
            else if (props.name.toString().indexOf("agenda") > -1) colorButtonHandle = themeColors.agendaColor;
            else if (props.name.toString().indexOf("services") > -1) colorButtonHandle = themeColors.servicesColor;
        }
        setColorButtonHandle(colorButtonHandle);
    }, [
        label
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($eb8d760b8bfc59bf$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $45d43a6de0968f42$export$3b4d92ba873f009a).home:
                homeActivity && (0, $1c9be018817ca3e3$export$a6540370871e3c67)(homeActivity);
                isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
                break;
            case (0, $45d43a6de0968f42$export$3b4d92ba873f009a).news:
                (0, $1c9be018817ca3e3$export$2115da3e844dc899)((0, $45d43a6de0968f42$export$3565eb3d00ca5a74).News);
                break;
            case (0, $45d43a6de0968f42$export$3b4d92ba873f009a).weather:
                (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).weather);
                break;
            case (0, $45d43a6de0968f42$export$3b4d92ba873f009a).emergency:
                (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).emergency);
                break;
        }
        else if ($eb8d760b8bfc59bf$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            // Display custom component if present
            if (props.customDisplay) (0, $1bda010252da638c$export$5a678fd51bd89633)({
                ...props
            });
        }
        props.handleClick && props.handleClick();
    };
    return (0, $bbe458fac496c294$export$78f16669b353a880).includes(props.device) ? /* On mobile / widget : display available views as lines */ /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        className: `rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && "rf-border-t rf-border-t-menuBorder"}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $eb8d760b8bfc59bf$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4a7d062b52b5ca6e$export$2e2bcd8739ae039), {
                view: props.view
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4a7d062b52b5ca6e$export$2e2bcd8739ae039), {
                icon: props.icon,
                className: "rf-max-h-6 rf-max-w-6 rf-flex rf-items-center",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-ml-4 rf-font-bold",
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(label, locale)
            })
        ]
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        className: "rf-h-36 rf-w-36 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: "linear-gradient(to left top, #F2F3F6, #E5E6EC)"
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $eb8d760b8bfc59bf$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4a7d062b52b5ca6e$export$2e2bcd8739ae039), {
                view: props.view,
                className: "rf-h-16"
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4a7d062b52b5ca6e$export$2e2bcd8739ae039), {
                icon: props.icon,
                className: "rf-h-16 rf-w-16 rf-flex",
                color: colorButtonHandle
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-uppercase rf-text-[#575F6B] rf-text-xs large-vertical:rf-text-basecustomuppercase",
                children: label
            })
        ]
    });
};
var $eb8d760b8bfc59bf$export$2e2bcd8739ae039 = $eb8d760b8bfc59bf$var$DisplayGenerator;


const $2b95f3ea208ceb3c$var$DisplayViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const [finalMenu, setFinalMenu] = (0, $lT7pJ.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseMenu
            if (Object.keys(currentMenu).includes("icon")) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $eb8d760b8bfc59bf$export$2e2bcd8739ae039), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined,
                    name: customCurrentMenu.name
                }));
            } else fullMenu.push(/*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $eb8d760b8bfc59bf$export$2e2bcd8739ae039), {
                type: "BaseMenu",
                indice: currentMenu.indice,
                view: currentMenu.view,
                device: currentDeviceType,
                handleClick: handleClick,
                conditionalHandleClick: conditionalHandleClick
            }));
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $lT7pJ.useEffect)(()=>{
        const tempFinalMenu = [];
        // Basic menu
        tempFinalMenu.push(buildMenu(configuration && configuration.baseMenu ? [
            ...configuration.baseMenu
        ] : [
            ...(0, $bbe458fac496c294$export$9bbca248acc786d3)
        ]));
        // Custom menus
        if (configuration && configuration.customMenu && configuration.customMenu.length > 0) {
            if (Array.isArray(configuration.customMenu[0])) configuration.customMenu.forEach((menuArray)=>{
                tempFinalMenu.push(buildMenu(menuArray));
            });
            else tempFinalMenu.push(buildMenu(configuration.customMenu));
        }
        setFinalMenu(tempFinalMenu);
    }, []);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: finalMenu.map((line, key)=>{
            return isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `${key === 0 && "rf-pb-4"} rf-flex rf-flex-col rf-items-center`,
                children: [
                    key !== 0 && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-h-6 -rf-mx-6 rf-width-fill-available rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                    }),
                    line.map((e, subkey)=>{
                        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                            children: e
                        }, subkey);
                    })
                ]
            }, key) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                children: line.map((e, subkey)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                        children: e
                    }, subkey);
                })
            }, key);
        })
    });
};
var $2b95f3ea208ceb3c$export$2e2bcd8739ae039 = $2b95f3ea208ceb3c$var$DisplayViews;




var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");







function $63995336ca7b3fa7$var$instanceOfDisplayGeneratorProps(object) {
    return "view" in object && object.type === "BaseMenu";
}
function $63995336ca7b3fa7$var$instanceOfCustomMenuDisplayGeneratorProps(object) {
    return "icon" in object && object.type === "CustomMenu";
}
const $63995336ca7b3fa7$var$DisplaySubGenerator = (props)=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const [label, setLabel] = (0, $lT7pJ.useState)("");
    /**
   * On component mount :
   *  - set label state depending on the locale
   */ (0, $lT7pJ.useEffect)(()=>{
        if ($63995336ca7b3fa7$var$instanceOfDisplayGeneratorProps(props)) setLabel(translation[props.view.toString()]);
        else if ($63995336ca7b3fa7$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            if (props.label && typeof props.label === "string") setLabel(props.label);
            else if (props.label && typeof props.label === "object") setLabel(props.label[locale]);
        }
    }, [
        locale
    ]);
    /**
   * On call :
   *  - switch on chosen view
   *  - either display an overlaying page or redirect to another view
   *  - if handleClick is defined, call it
   */ const handleClickOnCard = ()=>{
        if ($63995336ca7b3fa7$var$instanceOfDisplayGeneratorProps(props)) switch(props.view){
            case (0, $45d43a6de0968f42$export$c5a4c3ea2d78493c).history:
                (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).history);
                break;
            case (0, $45d43a6de0968f42$export$c5a4c3ea2d78493c).tutorial:
                console.log("Tutorial");
                break;
        }
        else if ($63995336ca7b3fa7$var$instanceOfCustomMenuDisplayGeneratorProps(props)) {
            // Call props' closing function in mobile mode if asked by the custom component
            isMobile && props.conditionalHandleClick && props.conditionalHandleClick();
            if (props.customDisplay) (0, $1bda010252da638c$export$5a678fd51bd89633)({
                ...props
            });
        }
        props.handleClick && props.handleClick();
    };
    return (0, $bbe458fac496c294$export$78f16669b353a880).includes(props.device) ? /* On mobile / widget : display available views as lines, without icons */ /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row rf-items-center ${props.indice !== 0 && "rf-border-t rf-border-t-menuBorder"}`,
        onClick: handleClickOnCard,
        "aria-label": label,
        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(label, locale)
    }) : /* On desktop / borne : display available views as buttons at the center of the screen */ /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        className: "rf-h-24 rf-w-24 rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-shadow-[3px_3px_16px_#00000029]",
        style: {
            background: "linear-gradient(to left top, #F2F3F6, #E5E6EC)"
        },
        onClick: handleClickOnCard,
        "aria-label": label,
        children: [
            $63995336ca7b3fa7$var$instanceOfDisplayGeneratorProps(props) ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4a7d062b52b5ca6e$export$2e2bcd8739ae039), {
                view: props.view,
                className: "rf-h-8"
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4a7d062b52b5ca6e$export$2e2bcd8739ae039), {
                icon: props.icon,
                className: "rf-h-8 rf-w-8 rf-flex"
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-uppercase rf-text-[#575F6B] rf-text-xs",
                children: label
            })
        ]
    });
};
var $63995336ca7b3fa7$export$2e2bcd8739ae039 = $63995336ca7b3fa7$var$DisplaySubGenerator;


const $c28665492b2d9d53$var$DisplaySubViews = ({ handleClick: handleClick, conditionalHandleClick: conditionalHandleClick })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const [subMenu, setSubMenu] = (0, $lT7pJ.useState)([]);
    const buildMenu = (menu)=>{
        let fullMenu = [];
        menu.forEach((currentMenu)=>{
            // If the menu has 'icon' as key, it's a CustomMenu. Otherwise it's a BaseSubMenu
            if (Object.keys(currentMenu).includes("icon")) {
                const customCurrentMenu = currentMenu;
                fullMenu.push(/*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $63995336ca7b3fa7$export$2e2bcd8739ae039), {
                    type: "CustomMenu",
                    indice: customCurrentMenu.indice,
                    label: customCurrentMenu.label,
                    icon: customCurrentMenu.icon,
                    device: currentDeviceType,
                    handleClick: ()=>{
                        if (customCurrentMenu.clickHandler) customCurrentMenu.clickHandler();
                        handleClick && handleClick();
                    },
                    customDisplay: customCurrentMenu.customDisplay,
                    conditionalHandleClick: customCurrentMenu.closeParametersOnClickInMobileMode ? conditionalHandleClick : undefined
                }));
            } else // In mobile mode, we only push custom items, base items (history / tutorial) have their own render
            !isMobile && fullMenu.push(/*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $63995336ca7b3fa7$export$2e2bcd8739ae039), {
                type: "BaseMenu",
                indice: currentMenu.indice,
                view: currentMenu.view,
                device: currentDeviceType,
                handleClick: handleClick
            }));
        });
        fullMenu = fullMenu.sort((a, b)=>a.props.indice - b.props.indice);
        return fullMenu;
    };
    (0, $lT7pJ.useEffect)(()=>{
        // Handle custom submenus
        if (configuration && configuration.subMenu) setSubMenu(buildMenu(configuration.subMenu));
        else setSubMenu(buildMenu((0, $bbe458fac496c294$export$890576ebf405f6b7)));
    }, []);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: subMenu.map((e, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: e
            }, key);
        })
    });
};
var $c28665492b2d9d53$export$2e2bcd8739ae039 = $c28665492b2d9d53$var$DisplaySubViews;




parcelRequire("lT7pJ");
var $28075852dfe716c9$exports = {};
$28075852dfe716c9$exports = JSON.parse('{"name":"@davi-ai/retorik-framework","version":"1.1.6","description":"Retorik Framework package","author":"DAVI","license":"MIT","repository":"none","main":"dist/index.js","module":"dist/index.modern.js","types":"dist/index.d.ts","source":"src/index.tsx","standalone":"standalone/index.js","targets":{"standalone":{"context":"browser","outputFormat":"esmodule","distDir":"standalone","includeNodeModules":{"@storybook/addon-actions":false,"@storybook/addon-essentials":false,"@storybook/addon-interactions":false,"@storybook/addon-links":false,"@storybook/addon-postcss":false,"@storybook/builder-webpack5":false,"@storybook/manager-webpack5":false,"@storybook/preset-create-react-app":false,"@storybook/react":false,"@storybook/testing-library":false,"@testing-library/jest-dom":false,"@testing-library/react":false,"@testing-library/react-hooks":false,"@testing-library/user-event":false,"eslint":false,"eslint-config-prettier":false,"eslint-config-standard":false,"eslint-config-standard-react":false,"eslint-plugin-import":false,"eslint-plugin-node":false,"eslint-plugin-prettier":false,"eslint-plugin-promise":false,"eslint-plugin-react":false,"eslint-plugin-standard":false,"jest-junit":false,"npm-run-all":false,"parcel":false,"prettier":false,"raw-loader":false,"react-docgen-typescript-plugin":false,"react-scripts":false,"react-test-renderer":false,"tailwindcss":false,"typescript":false}},"module":{"context":"browser","outputFormat":"esmodule","distDir":"dist"}},"engines":{"node":">=10"},"scripts":{"build":"parcel build","start":"parcel watch","test":"jest --env=jsdom --reporters=jest-junit","test-update-snapshots":"jest --env=jsdom --updateSnapshot","test-coverage":"jest --env=jsdom --reporters=jest-junit --coverage --coverageReporters=cobertura","report":"npx parcel build src/index.tsx --reporter @parcel/reporter-bundle-analyzer","credentials":"vsts-npm-auth -config .npmrc","storybook":"npm run build-tailwind && start-storybook -p 6006","build-storybook":"npm run build-tailwind && build-storybook","build-tailwind":"npx tailwindcss build -i ./src/tailwind.css -o ./.storybook/stories/styles.css"},"peerDependencies":{"react":"18","react-dom":"18"},"devDependencies":{"@babel/core":"^7.19.1","@babel/plugin-proposal-decorators":"^7.24.7","@babel/plugin-proposal-private-property-in-object":"^7.21.11","@babel/preset-env":"^7.25.4","@babel/preset-react":"^7.24.7","@babel/preset-typescript":"^7.24.7","@babel/runtime":"^7.23.8","@parcel/packager-ts":"^2.12.0","@parcel/reporter-bundle-analyzer":"^2.12.0","@parcel/reporter-sourcemap-visualiser":"^2.12.0","@parcel/transformer-inline-string":"^2.12.0","@parcel/transformer-typescript-types":"^2.12.0","@parcel/validator-eslint":"^2.12.0","@parcel/validator-typescript":"^2.12.0","@storybook/addon-actions":"^6.5.12","@storybook/addon-essentials":"^6.5.12","@storybook/addon-interactions":"^6.5.12","@storybook/addon-links":"^6.5.12","@storybook/addon-postcss":"^2.0.0","@storybook/builder-webpack5":"^6.5.12","@storybook/manager-webpack5":"^6.5.12","@storybook/preset-create-react-app":"^4.1.2","@storybook/react":"^6.5.12","@storybook/testing-library":"^0.0.13","@testing-library/jest-dom":"6.5.0","@testing-library/react":"16.0.1","@testing-library/react-hooks":"8.0.1","@testing-library/user-event":"14.5.2","@types/jest":"^27.5.1","@types/leaflet":"^1.8.0","@types/node":"^12.12.38","@types/react":"18","@types/react-dom":"18","@types/testing-library__jest-dom":"^5.14.5","@types/testing-library__react":"latest","@typescript-eslint/eslint-plugin":"^5.0","@typescript-eslint/parser":"^5.0","autoprefixer":"^10.4.7","babel-eslint":"^10.0.3","babel-jest":"^29.7.0","babel-loader":"^8.2.5","buffer":"^5.7.1","canvas":"^2.9.0","cross-env":"^7.0.2","crypto-browserify":"^3.12.0","eslint":"^7.32.0","eslint-config-prettier":"^6.7.0","eslint-config-standard":"^14.1.0","eslint-config-standard-react":"^9.2.0","eslint-plugin-import":"^2.18.2","eslint-plugin-node":"^11.0.0","eslint-plugin-prettier":"^3.1.1","eslint-plugin-promise":"^4.2.1","eslint-plugin-react":"^7.17.0","eslint-plugin-standard":"^4.0.1","https-browserify":"^1.0.0","jest":"^29.7.0","jest-environment-jsdom":"^29.7.0","jest-junit":"16.0.0","npm-run-all":"^4.1.5","parcel":"^2.12.0","postcss":"^8.4.14","postcss-url":"^10.1.3","prettier":"^2.0.4","process":"^0.11.10","punycode":"^1.4.1","querystring-es3":"^0.2.1","raw-loader":"^4.0.2","react":"^18","react-docgen-typescript-plugin":"^1.0.5","react-dom":"^18","react-scripts":"5.0.1","react-test-renderer":"^18.3.1","stream-browserify":"^3.0.0","stream-http":"^3.2.0","string_decoder":"^1.3.0","tailwindcss":"^3.1.0","typescript":"5.0","url":"^0.11.0","util":"^0.12.4"},"files":["dist"],"dependencies":{"@davi-ai/body-engine-sprite":"1.0.3","@davi-ai/retorik-weather":"1.0.0","@davi-ai/speechmarkdown-davi-js":"1.0.6","@davi-ai/web-speech-cognitive-services-davi":"2.0.8","@fluentui/react":"^8.103.3","@lottiefiles/react-lottie-player":"^3.4.1","@opentelemetry/api":"^1.4.1","@opentelemetry/exporter-trace-otlp-http":"^0.41.0","@opentelemetry/resources":"^1.15.0","@opentelemetry/sdk-trace-web":"^1.15.0","@opentelemetry/semantic-conventions":"^1.15.0","@react-spring/types":"^9.7.3","@react-spring/web":"^9.7.3","@swc/helpers":"^0.5.0","@types/geojson":"^7946.0.10","@types/jsdom":"^16.2.14","@use-gesture/react":"^10.2.15","adaptivecards":"3.0.1","botframework-directlinejs":"^0.15.5","classnames":"^2.3.1","leaflet":"^1.9.2","markdown-it":"14.1.0","pdfjs-dist":"3.11.174","postcss-copy":"^7.1.0","qrcode":"^1.5.1","react-device-detect":"^2.2.3","react-error-boundary":"^4.0.10","react-leaflet":"^4.1.0","react-pdf":"7.7.1","react-shadow":"^19.0.3","react-webcam":"^6.0.0","swiper":"^8.4.5","zustand":"^4.1.1"}}');


const $a06b445ba6af5422$var$Version = ({ isMobile: isMobile })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `${isMobile ? "rf-px-5 rf-pt-6 rf-text-xsm" : "rf-absolute rf-left-8 rf-bottom-2 rf-text-sm"} rf-text-[#A4A7AF] rf-text-sm`,
        children: `v ${(0, $28075852dfe716c9$exports.version)}`
    });
};
var $a06b445ba6af5422$export$2e2bcd8739ae039 = $a06b445ba6af5422$var$Version;


const $60271d033b85113a$var$Dashboard = ({ toggleDashboard: toggleDashboard })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.isUsedOnBorne);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const handleClick = ()=>{
        toggleDashboard && toggleDashboard();
    };
    /**
   * Called in borne mode to open retorik kiosk parameters
   */ const handleClickParameters = ()=>{
        (0, $1bda010252da638c$export$61008920e70c5e8a)();
        toggleDashboard && toggleDashboard();
    };
    return isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-px-5 rf-pt-4 rf-flex rf-flex-col rf-justify-start",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $2b95f3ea208ceb3c$export$2e2bcd8739ae039), {
            conditionalHandleClick: handleClick
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $8be45c55c8dfd1e6$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-justify-center rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $39f3e48cc7ad4ecb$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-relative rf-h-full rf-max-w-7/10 rf-flex rf-flex-col rf-items-start rf-gap-8",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-min-h-2/5 rf-py-4 rf-mt-auto rf-flex rf-flex-col rf-gap-8 rf-overflow-y-scroll rf-scrollbar-hidden",
                                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $2b95f3ea208ceb3c$export$2e2bcd8739ae039), {
                                    handleClick: toggleDashboard
                                })
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-h-3/10 rf-flex rf-flex-row rf-items-center rf-flex-wrap rf-gap-8",
                                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c28665492b2d9d53$export$2e2bcd8739ae039), {
                                    handleClick: toggleDashboard
                                })
                            })
                        ]
                    }),
                    isUsedOnBorne ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
                        // @ts-ignore
                        part: "retorik-framework-parameters",
                        className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-8 rf-flex rf-flex-row rf-items-center",
                        onClick: handleClickParameters,
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $522cc0ac368b9533$export$2e2bcd8739ae039), {
                                color: "#A4A7AF"
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                className: "rf-uppercase rf-ml-1 rf-text-xsl rf-text-[#A4A7AF]",
                                children: translation.common.parameters
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a06b445ba6af5422$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $861fac448a37f7dd$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                onClick: handleClick
            })
        ]
    });
};
var $60271d033b85113a$export$2e2bcd8739ae039 = $60271d033b85113a$var$Dashboard;



parcelRequire("lT7pJ");






var $lT7pJ = parcelRequire("lT7pJ");


var $9cdc7ea7128d4847$exports = {};
$9cdc7ea7128d4847$exports = JSON.parse('{"aa":"Qafar","aa-DJ":"Qafar (Yabuuti)","aa-ER":"Qafar (Eretria)","aa-ET":"Qafar (Otobbia)","af":"Afrikaans","af-NA":"Afrikaans (Namibi\xeb)","af-ZA":"Afrikaans (Suid-Afrika)","agq":"Aghem","agq-CM":"Aghem (K\xe0m\xe0l\xfb\u014B)","ak":"Akan","ak-GH":"Akan (Gaana)","am":"\u12A0\u121B\u122D\u129B","am-ET":"\u12A0\u121B\u122D\u129B (\u12A2\u1275\u12EE\u1335\u12EB)","ar":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629","ar-001":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0639\u0627\u0644\u0645)","ar-AE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629)","ar-BH":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0628\u062D\u0631\u064A\u0646)","ar-DJ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062C\u064A\u0628\u0648\u062A\u064A)","ar-DZ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u062C\u0632\u0627\u0626\u0631)","ar-EG":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0645\u0635\u0631)","ar-ER":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0625\u0631\u064A\u062A\u0631\u064A\u0627)","ar-IL":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0625\u0633\u0631\u0627\u0626\u064A\u0644)","ar-IQ":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0639\u0631\u0627\u0642)","ar-JO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0623\u0631\u062F\u0646)","ar-KM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631)","ar-KW":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0643\u0648\u064A\u062A)","ar-LB":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0644\u0628\u0646\u0627\u0646)","ar-LY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0644\u064A\u0628\u064A\u0627)","ar-MA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u063A\u0631\u0628\u064A\u0629)","ar-MR":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627)","arn":"Mapudungun","arn-CL":"Mapudungun (Chile)","ar-OM":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0639\u0645\u0627\u0646)","ar-PS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0644\u0637\u0629 \u0627\u0644\u0641\u0644\u0633\u0637\u064A\u0646\u064A\u0629)","ar-QA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0642\u0637\u0631)","ar-SA":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)","ar-SD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0633\u0648\u062F\u0627\u0646)","ar-SO":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u0635\u0648\u0645\u0627\u0644)","ar-SS":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646)","ar-SY":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0633\u0648\u0631\u064A\u0627)","ar-TD":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062A\u0634\u0627\u062F)","ar-TN":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u062A\u0648\u0646\u0633)","ar-YE":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 (\u0627\u0644\u064A\u0645\u0646)","as":"\u0985\u09B8\u09AE\u09C0\u09DF\u09BE","asa":"Kipare","asa-TZ":"Kipare (Tadhania)","as-IN":"\u0985\u09B8\u09AE\u09C0\u09DF\u09BE (\u09AD\u09BE\u09F0\u09A4)","ast":"asturianu","ast-ES":"asturianu (Espa\xf1a)","az":"az\u0259rbaycan","az-Cyrl":"\u0410\u0437\u04D9\u0440\u0431\u0430\u0458\u04B9\u0430\u043D \u0434\u0438\u043B\u0438","az-Cyrl-AZ":"\u0430\u0437\u04D9\u0440\u0431\u0430\u0458\u04B9\u0430\u043D (\u0410\u0437\u04D9\u0440\u0431\u0430\u0458\u04B9\u0430\u043D)","az-Latn":"az\u0259rbaycan","az-Latn-AZ":"az\u0259rbaycan (Az\u0259rbaycan)","ba":"\u0411\u0430\u0448\u04A1\u043E\u0440\u0442","ba-RU":"\u0411\u0430\u0448\u04A1\u043E\u0440\u0442 (\u0420\u04D9\u0441\u04D9\u0439)","bas":"\u0181\xe0s\xe0a","bas-CM":"\u0181\xe0s\xe0a (K\xe0m\u025B\u0300r\xfbn)","be":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F","be-BY":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)","bem":"Ichibemba","bem-ZM":"Ichibemba (Zambia)","bez":"Hibena","bez-TZ":"Hibena (Hutanzania)","bg":"\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438","bg-BG":"\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)","bin":"\u1EB8\u0300d\xf3","bin-NG":"\u1EB8\u0300d\xf3 (Nigeria)","bm":"bamanakan","bm-Latn":"bamanakan","bm-Latn-ML":"bamanakan (Mali)","bn":"\u09AC\u09BE\u0982\u09B2\u09BE","bn-BD":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)","bn-IN":"\u09AC\u09BE\u0982\u09B2\u09BE (\u09AD\u09BE\u09B0\u09A4)","bo":"\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42","bo-CN":"\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42 (\u0F40\u0FB2\u0F74\u0F44\u0F0B\u0F67\u0FAD\u0F0B\u0F58\u0F72\u0F0B\u0F51\u0F58\u0F44\u0F66\u0F0B\u0F66\u0FA4\u0FB1\u0F72\u0F0B\u0F58\u0F50\u0F74\u0F53\u0F0B\u0F62\u0F92\u0FB1\u0F63\u0F0B\u0F41\u0F56\u0F0D)","bo-IN":"\u0F56\u0F7C\u0F51\u0F0B\u0F66\u0F90\u0F51\u0F0B (\u0F62\u0F92\u0FB1\u0F0B\u0F42\u0F62\u0F0B)","br":"brezhoneg","br-FR":"brezhoneg (Fra\xf1s)","brx":"\u092C\u0921\u093C\u094B","brx-IN":"\u092C\u0921\u093C\u094B (\u092D\u093E\u0930\u0924)","bs":"bosanski","bs-Cyrl":"\u0431\u043E\u0441\u0430\u043D\u0441\u043A\u0438","bs-Cyrl-BA":"\u0431\u043E\u0441\u0430\u043D\u0441\u043A\u0438 (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)","bs-Latn":"bosanski","bs-Latn-BA":"bosanski (Bosna i Hercegovina)","byn":"\u1265\u120A\u1295","byn-ER":"\u1265\u120A\u1295 (\u12A4\u122D\u1275\u122B)","ca":"catal\xe0","ca-AD":"catal\xe0 (Andorra)","ca-ES":"catal\xe0 (catal\xe0)","ca-ES-valencia":"valenci\xe0 (Espanya)","ca-FR":"catal\xe0 (Fran\xe7a)","ca-IT":"catal\xe0 (It\xe0lia)","ce":"\u043D\u043E\u0445\u0447\u0438\u0439\u043D","ce-RU":"\u043D\u043E\u0445\u0447\u0438\u0439\u043D (\u0420\u043E\u0441\u0441\u0438)","cgg":"Rukiga","cgg-UG":"Rukiga (Uganda)","chr":"\u13E3\u13B3\u13A9","chr-Cher":"\u13E3\u13B3\u13A9","chr-Cher-US":"\u13E3\u13B3\u13A9 (\u13CC\u13CA \u13A2\u13F3\u13BE\u13B5\u13CD\u13D4\u13C5 \u13CD\u13A6\u13DA\u13A9)","co":"Corsu","co-FR":"Corsu (Francia)","cs":"\u010De\u0161tina","cs-CZ":"\u010De\u0161tina (\u010Cesko)","cu":"\u0446\u0435\u0440\u043A\u043E\u0432\u043D\u043E\u0441\u043B\u043E\u0432\u0435\u0301\u043D\u0441\u043A\u0457\u0439","cu-RU":"\u0446\u0435\u0440\u043A\u043E\u0432\u043D\u043E\u0441\u043B\u043E\u0432\u0435\u0301\u043D\u0441\u043A\u0457\u0439 (\u0440\u0461\u0441\u0441\u0456\u0301\u0430)","cy":"Cymraeg","cy-GB":"Cymraeg (Y Deyrnas Unedig)","da":"dansk","da-DK":"dansk (Danmark)","da-GL":"dansk (Gr\xf8nland)","dav":"Kitaita","dav-KE":"Kitaita (Kenya)","de":"Deutsch","de-AT":"Deutsch (\xd6sterreich)","de-BE":"Deutsch (Belgien)","de-CH":"Deutsch (Schweiz)","de-DE":"Deutsch (Deutschland)","de-IT":"Deutsch (Italien)","de-LI":"Deutsch (Liechtenstein)","de-LU":"Deutsch (Luxemburg)","dje":"Zarmaciine","dje-NE":"Zarmaciine (Ni\u017Eer)","dsb":"dolnoserb\u0161\u0107ina","dsb-DE":"dolnoserb\u0161\u0107ina (Nimska)","dua":"du\xe1l\xe1","dua-CM":"du\xe1l\xe1 (Cameroun)","dv":"\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0784\u07A6\u0790\u07B0","dv-MV":"\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0784\u07A6\u0790\u07B0 (\u078B\u07A8\u0788\u07AC\u0780\u07A8 \u0783\u07A7\u0787\u07B0\u0796\u07AC)","dyo":"joola","dyo-SN":"joola (Senegal)","dz":"\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41","dz-BT":"\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41 (\u0F60\u0F56\u0FB2\u0F74\u0F42)","ebu":"K\u0129embu","ebu-KE":"K\u0129embu (Kenya)","ee":"E\u028Begbe","ee-GH":"E\u028Begbe (Ghana nutome)","ee-TG":"E\u028Begbe (Togo nutome)","el":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC","el-CY":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)","el-GR":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)","en":"English","en-001":"English (World)","en-029":"English (Caribbean)","en-150":"English (Europe)","en-AG":"English (Antigua and Barbuda)","en-AI":"English (Anguilla)","en-AS":"English (American Samoa)","en-AT":"English (Austria)","en-AU":"English (Australia)","en-BB":"English (Barbados)","en-BE":"English (Belgium)","en-BI":"English (Burundi)","en-BM":"English (Bermuda)","en-BS":"English (Bahamas)","en-BW":"English (Botswana)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-CC":"English (Cocos (Keeling) Islands)","en-CH":"English (Switzerland)","en-CK":"English (Cook Islands)","en-CM":"English (Cameroon)","en-CX":"English (Christmas Island)","en-CY":"English (Cyprus)","en-DE":"English (Germany)","en-DK":"English (Denmark)","en-DM":"English (Dominica)","en-ER":"English (Eritrea)","en-FI":"English (Finland)","en-FJ":"English (Fiji)","en-FK":"English (Falkland Islands)","en-FM":"English (Micronesia)","en-GB":"English (United Kingdom)","en-GD":"English (Grenada)","en-GG":"English (Guernsey)","en-GH":"English (Ghana)","en-GI":"English (Gibraltar)","en-GM":"English (Gambia)","en-GU":"English (Guam)","en-GY":"English (Guyana)","en-HK":"English (Hong Kong SAR)","en-ID":"English (Indonesia)","en-IE":"English (Ireland)","en-IL":"English (Israel)","en-IM":"English (Isle of Man)","en-IN":"English (India)","en-IO":"English (British Indian Ocean Territory)","en-JE":"English (Jersey)","en-JM":"English (Jamaica)","en-KE":"English (Kenya)","en-KI":"English (Kiribati)","en-KN":"English (Saint Kitts and Nevis)","en-KY":"English (Cayman Islands)","en-LC":"English (Saint Lucia)","en-LR":"English (Liberia)","en-LS":"English (Lesotho)","en-MG":"English (Madagascar)","en-MH":"English (Marshall Islands)","en-MO":"English (Macao SAR)","en-MP":"English (Northern Mariana Islands)","en-MS":"English (Montserrat)","en-MT":"English (Malta)","en-MU":"English (Mauritius)","en-MW":"English (Malawi)","en-MY":"English (Malaysia)","en-NA":"English (Namibia)","en-NF":"English (Norfolk Island)","en-NG":"English (Nigeria)","en-NL":"English (Netherlands)","en-NR":"English (Nauru)","en-NU":"English (Niue)","en-NZ":"English (New Zealand)","en-PG":"English (Papua New Guinea)","en-PH":"English (Philippines)","en-PK":"English (Pakistan)","en-PN":"English (Pitcairn Islands)","en-PR":"English (Puerto Rico)","en-PW":"English (Palau)","en-RW":"English (Rwanda)","en-SB":"English (Solomon Islands)","en-SC":"English (Seychelles)","en-SD":"English (Sudan)","en-SE":"English (Sweden)","en-SG":"English (Singapore)","en-SH":"English (St Helena, Ascension, Tristan da Cunha)","en-SI":"English (Slovenia)","en-SL":"English (Sierra Leone)","en-SS":"English (South Sudan)","en-SX":"English (Sint Maarten)","en-SZ":"English (Swaziland)","en-TC":"English (Turks and Caicos Islands)","en-TK":"English (Tokelau)","en-TO":"English (Tonga)","en-TT":"English (Trinidad and Tobago)","en-TV":"English (Tuvalu)","en-TZ":"English (Tanzania)","en-UG":"English (Uganda)","en-UM":"English (U.S. Outlying Islands)","en-US":"English (United States)","en-VC":"English (Saint Vincent and the Grenadines)","en-VG":"English (British Virgin Islands)","en-VI":"English (U.S. Virgin Islands)","en-VU":"English (Vanuatu)","en-WS":"English (Samoa)","en-ZA":"English (South Africa)","en-ZM":"English (Zambia)","en-ZW":"English (Zimbabwe)","eo":"esperanto","eo-001":"esperanto (World)","es":"espa\xf1ol","es-419":"espa\xf1ol (Latinoam\xe9rica)","es-AR":"espa\xf1ol (Argentina)","es-BO":"espa\xf1ol (Bolivia)","es-BR":"espa\xf1ol (Brasil)","es-BZ":"espa\xf1ol (Belice)","es-CL":"espa\xf1ol (Chile)","es-CO":"espa\xf1ol (Colombia)","es-CR":"espa\xf1ol (Costa Rica)","es-CU":"espa\xf1ol (Cuba)","es-DO":"espa\xf1ol (Rep\xfablica Dominicana)","es-EC":"espa\xf1ol (Ecuador)","es-ES":"espa\xf1ol (Espa\xf1a, alfabetizaci\xf3n internacional)","es-GQ":"espa\xf1ol (Guinea Ecuatorial)","es-GT":"espa\xf1ol (Guatemala)","es-HN":"espa\xf1ol (Honduras)","es-MX":"espa\xf1ol (M\xe9xico)","es-NI":"espa\xf1ol (Nicaragua)","es-PA":"espa\xf1ol (Panam\xe1)","es-PE":"espa\xf1ol (Per\xfa)","es-PH":"espa\xf1ol (Filipinas)","es-PR":"espa\xf1ol (Puerto Rico)","es-PY":"espa\xf1ol (Paraguay)","es-SV":"espa\xf1ol (El Salvador)","es-US":"espa\xf1ol (Estados Unidos)","es-UY":"espa\xf1ol (Uruguay)","es-VE":"espa\xf1ol (Venezuela)","et":"eesti","et-EE":"eesti (Eesti)","eu":"euskara","eu-ES":"euskara (euskara)","ewo":"ewondo","ewo-CM":"ewondo (Kam\u0259r\xfan)","fa":"\u0641\u0627\u0631\u0633\u06CC","fa-IR":"\u0641\u0627\u0631\u0633\u06CC (\u0627\u06CC\u0631\u0627\u0646)","ff":"Fulah","ff-CM":"Pulaar (Kameruun)","ff-GN":"Pulaar (Gine)","ff-Latn":"Fulah","ff-Latn-SN":"Fulah (S\xe9n\xe9gal)","ff-MR":"Pulaar (Muritani)","ff-NG":"Pulaar (Nigeria)","fi":"suomi","fi-FI":"suomi (Suomi)","fil":"Filipino","fil-PH":"Filipino (Pilipinas)","fo":"f\xf8royskt","fo-DK":"f\xf8royskt (Danmark)","fo-FO":"f\xf8royskt (F\xf8royar)","fr":"fran\xe7ais","fr-029":"fran\xe7ais (cara\xefbes)","fr-BE":"fran\xe7ais (Belgique)","fr-BF":"fran\xe7ais (Burkina Faso)","fr-BI":"fran\xe7ais (Burundi)","fr-BJ":"fran\xe7ais (B\xe9nin)","fr-BL":"fran\xe7ais (Saint-Barth\xe9lemy)","fr-CA":"fran\xe7ais (Canada)","fr-CD":"fran\xe7ais (Congo, R\xe9publique d\xe9mocratique du)","fr-CF":"fran\xe7ais (R\xe9publique centrafricaine)","fr-CG":"fran\xe7ais (Congo)","fr-CH":"fran\xe7ais (Suisse)","fr-CI":"fran\xe7ais (C\xf4te d\u2019Ivoire)","fr-CM":"fran\xe7ais (Cameroun)","fr-DJ":"fran\xe7ais (Djibouti)","fr-DZ":"fran\xe7ais (Alg\xe9rie)","fr-FR":"fran\xe7ais (France)","fr-GA":"fran\xe7ais (Gabon)","fr-GF":"fran\xe7ais (Guyane fran\xe7aise)","fr-GN":"fran\xe7ais (Guin\xe9e)","fr-GP":"fran\xe7ais (Guadeloupe)","fr-GQ":"fran\xe7ais (Guin\xe9e \xe9quatoriale)","fr-HT":"fran\xe7ais (Ha\xefti)","fr-KM":"fran\xe7ais (Comores)","fr-LU":"fran\xe7ais (Luxembourg)","fr-MA":"fran\xe7ais (Maroc)","fr-MC":"fran\xe7ais (Monaco)","fr-MF":"fran\xe7ais (Saint-Martin)","fr-MG":"fran\xe7ais (Madagascar)","fr-ML":"fran\xe7ais (Mali)","fr-MQ":"fran\xe7ais (Martinique)","fr-MR":"fran\xe7ais (Mauritanie)","fr-MU":"fran\xe7ais (Maurice)","fr-NC":"fran\xe7ais (Nouvelle-Cal\xe9donie)","fr-NE":"fran\xe7ais (Niger)","fr-PF":"fran\xe7ais (Polyn\xe9sie fran\xe7aise)","fr-PM":"fran\xe7ais (Saint-Pierre-et-Miquelon)","fr-RE":"fran\xe7ais (La R\xe9union)","fr-RW":"fran\xe7ais (Rwanda)","fr-SC":"fran\xe7ais (Seychelles)","fr-SN":"fran\xe7ais (S\xe9n\xe9gal)","fr-SY":"fran\xe7ais (Syrie)","fr-TD":"fran\xe7ais (Tchad)","fr-TG":"fran\xe7ais (Togo)","fr-TN":"fran\xe7ais (Tunisie)","fr-VU":"fran\xe7ais (Vanuatu)","fr-WF":"fran\xe7ais (Wallis-et-Futuna)","fr-YT":"fran\xe7ais (Mayotte)","fur":"furlan","fur-IT":"furlan (Italie)","fy":"Frysk","fy-NL":"Frysk (Nederl\xe2n)","ga":"Gaeilge","ga-IE":"Gaeilge (\xc9ire)","gd":"G\xe0idhlig","gd-GB":"G\xe0idhlig (An R\xecoghachd Aonaichte)","gl":"galego","gl-ES":"galego (galego)","gn":"Ava\xf1e\u2019\u1EBD","gn-PY":"Ava\xf1e\u2019\u1EBD (Paragu\xe1i)","gsw":"Schwiizert\xfc\xfctsch","gsw-CH":"Schwiizert\xfc\xfctsch (Schwiiz)","gsw-FR":"Els\xe4ssisch (Fr\xe0nkrisch)","gsw-LI":"Schwiizert\xfc\xfctsch (Li\xe4chtescht\xe4i)","gu":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0","gu-IN":"\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0 (\u0AAD\u0ABE\u0AB0\u0AA4)","guz":"Ekegusii","guz-KE":"Ekegusii (Kenya)","gv":"Gaelg","gv-IM":"Gaelg (Ellan Vannin)","ha":"Hausa","ha-Latn":"Hausa","ha-Latn-GH":"Hausa (Gana)","ha-Latn-NE":"Hausa (Nijar)","ha-Latn-NG":"Hausa (Najeriya)","haw":"\u02BB\u014Clelo Hawai\u02BBi","haw-US":"\u02BB\u014Clelo Hawai\u02BBi (\u02BBAmelika Hui P\u016B \u02BBIa)","he":"\u05E2\u05D1\u05E8\u05D9\u05EA","he-IL":"\u05E2\u05D1\u05E8\u05D9\u05EA (\u05D9\u05E9\u05E8\u05D0\u05DC)","hi":"\u0939\u093F\u0928\u094D\u0926\u0940","hi-IN":"\u0939\u093F\u0928\u094D\u0926\u0940 (\u092D\u093E\u0930\u0924)","hr":"hrvatski","hr-BA":"hrvatski (Bosna i Hercegovina)","hr-HR":"hrvatski (Hrvatska)","hsb":"hornjoserb\u0161\u0107ina","hsb-DE":"hornjoserb\u0161\u0107ina (N\u011Bmska)","hu":"magyar","hu-HU":"magyar (Magyarorsz\xe1g)","hy":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576","hy-AM":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576 (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)","ia":"interlingua","ia-001":"interlingua (World)","ia-FR":"interlingua (Francia)","ibb":"Ibibio-Efik","ibb-NG":"Ibibio-Efik (Nigeria)","id":"Indonesia","id-ID":"Indonesia (Indonesia)","ig":"Igbo","ig-NG":"Igbo (Na\u1ECBj\u1ECBr\u1ECBa)","ii":"\uA188\uA320\uA071\uA0B7","ii-CN":"\uA188\uA320\uA071\uA0B7 (\uA34F\uA278\uA3D3\uA0B1\uA1ED\uA27C\uA1E9)","is":"\xedslenska","is-IS":"\xedslenska (\xcdsland)","it":"italiano","it-CH":"italiano (Svizzera)","it-IT":"italiano (Italia)","it-SM":"italiano (San Marino)","it-VA":"italiano (Citt\xe0 del Vaticano)","iu":"Inuktitut","iu-Cans":"\u1403\u14C4\u1483\u144E\u1450\u1466","iu-Cans-CA":"\u1403\u14C4\u1483\u144E\u1450\u1466 (\u1472\u14C7\u1455\u14A5)","iu-Latn":"Inuktitut","iu-Latn-CA":"Inuktitut (Kanatami)","ja":"\u65E5\u672C\u8A9E","ja-JP":"\u65E5\u672C\u8A9E (\u65E5\u672C)","jgo":"Nda\uA78Ca","jgo-CM":"Nda\uA78Ca (Kam\u025Bl\xfbn)","jmc":"Kimachame","jmc-TZ":"Kimachame (Tanzania)","jv":"Basa Jawa","jv-Java":"\uA9A7\uA9B1\uA997\uA9AE","jv-Java-ID":"\uA9A7\uA9B1\uA997\uA9AE (Indonesia)","jv-Latn":"Basa Jawa","jv-Latn-ID":"Basa Jawa (Indonesia)","ka":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8","kab":"Taqbaylit","kab-DZ":"Taqbaylit (Lezzayer)","ka-GE":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)","kam":"Kikamba","kam-KE":"Kikamba (Kenya)","kde":"Chimakonde","kde-TZ":"Chimakonde (Tanzania)","kea":"kabuverdianu","kea-CV":"kabuverdianu (Kabu Verdi)","khq":"Koyra ciini","khq-ML":"Koyra ciini (Maali)","ki":"Gikuyu","ki-KE":"Gikuyu (Kenya)","kk":"\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456","kkj":"kak\u0254","kkj-CM":"kak\u0254 (Kam\u025Brun)","kk-KZ":"\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456 (\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D)","kl":"kalaallisut","kl-GL":"kalaallisut (Kalaallit Nunaat)","kln":"Kalenjin","kln-KE":"Kalenjin (Emetab Kenya)","km":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A","km-KH":"\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)","kn":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1","kn-IN":"\u0C95\u0CA8\u0CCD\u0CA8\u0CA1 (\u0CAD\u0CBE\u0CB0\u0CA4)","ko":"\uD55C\uAD6D\uC5B4","kok":"\u0915\u094B\u0902\u0915\u0923\u0940","kok-IN":"\u0915\u094B\u0902\u0915\u0923\u0940 (\u092D\u093E\u0930\u0924)","ko-KP":"\uD55C\uAD6D\uC5B4 (\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D)","ko-KR":"\uD55C\uAD6D\uC5B4(\uB300\uD55C\uBBFC\uAD6D)","kr":"Kanuri","kr-NG":"Kanuri (Nigeria)","ks":"\u06A9\u0672\u0634\u064F\u0631","ks-Arab":"\u06A9\u0672\u0634\u064F\u0631","ks-Arab-IN":"\u06A9\u0672\u0634\u064F\u0631 (\u0627\u064E\u0631\u0628\u06CC)","ksb":"Kishambaa","ksb-TZ":"Kishambaa (Tanzania)","ks-Deva":"\u0915\u0949\u0936\u0941\u0930","ks-Deva-IN":"\u0915\u0949\u0936\u0941\u0930","ksf":"rikpa","ksf-CM":"rikpa (kam\u025Br\xfan)","ksh":"K\xf6lsch","ksh-DE":"K\xf6lsch (Do\xfctschland)","ku":"\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0646\u0627\u0648\u06D5\u0695\u0627\u0633\u062A","ku-Arab":"\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0646\u0627\u0648\u06D5\u0695\u0627\u0633\u062A","ku-Arab-IQ":"\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0646\u0627\u0648\u06D5\u0695\u0627\u0633\u062A (\u0639\u06CE\u0631\u0627\u0642)","ku-Arab-IR":"\u06A9\u0648\u0631\u062F\u06CC (\u0626\u06CE\u0631\u0627\u0646)","kw":"kernewek","kw-GB":"kernewek (Rywvaneth Unys)","ky":"\u041A\u044B\u0440\u0433\u044B\u0437","ky-KG":"\u041A\u044B\u0440\u0433\u044B\u0437 (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)","la":"lingua lat\u012Bna","la-001":"lingua lat\u012Bna (World)","lag":"K\u0268laangi","lag-TZ":"K\u0268laangi (Taansan\xeda)","lb":"L\xebtzebuergesch","lb-LU":"L\xebtzebuergesch (L\xebtzebuerg)","lg":"Luganda","lg-UG":"Luganda (Yuganda)","lkt":"Lak\u021F\xf3l\u02BCiyapi","lkt-US":"Lak\u021F\xf3l\u02BCiyapi (M\xedlaha\u014Bska T\u021Fam\xe1k\u021Fo\u010Dhe)","ln":"ling\xe1la","ln-AO":"ling\xe1la (Ang\xf3la)","ln-CD":"ling\xe1la (Republ\xedki ya Kong\xf3 Demokrat\xedki)","ln-CF":"ling\xe1la (Repibiki ya Afr\xedka ya K\xe1ti)","ln-CG":"ling\xe1la (Kongo)","lo":"\u0EA5\u0EB2\u0EA7","lo-LA":"\u0EA5\u0EB2\u0EA7 (\u0EA5\u0EB2\u0EA7)","lrc":"\u0644\u06CA\u0631\u06CC \u0634\u0648\u0645\u0627\u0644\u06CC","lrc-IQ":"\u0644\u06CA\u0631\u06CC \u0634\u0648\u0645\u0627\u0644\u06CC (Iraq)","lrc-IR":"\u0644\u06CA\u0631\u06CC \u0634\u0648\u0645\u0627\u0644\u06CC (Iran)","lt":"lietuvi\u0173","lt-LT":"lietuvi\u0173 (Lietuva)","lu":"Tshiluba","lu-CD":"Tshiluba (Ditunga wa Kongu)","luo":"Dholuo","luo-KE":"Dholuo (Kenya)","luy":"Luluhia","luy-KE":"Luluhia (Kenya)","lv":"latvie\u0161u","lv-LV":"latvie\u0161u (Latvija)","mas":"Maa","mas-KE":"Maa (Kenya)","mas-TZ":"Maa (Tansania)","mer":"K\u0129m\u0129r\u0169","mer-KE":"K\u0129m\u0129r\u0169 (Kenya)","mfe":"kreol morisien","mfe-MU":"kreol morisien (Moris)","mg":"Malagasy","mgh":"Makua","mgh-MZ":"Makua (Umozambiki)","mg-MG":"Malagasy (Madagasikara)","mgo":"meta\u02BC","mgo-CM":"meta\u02BC (Kamalun)","mi":"te reo M\u0101ori","mi-NZ":"te reo M\u0101ori (Aotearoa)","mk":"\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438","mk-MK":"\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 (\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)","ml":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02","ml-IN":"\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02 (\u0D07\u0D28\u0D4D\u0D24\u0D4D\u0D2F)","mn":"\u043C\u043E\u043D\u0433\u043E\u043B","mn-Cyrl":"\u043C\u043E\u043D\u0433\u043E\u043B","mni":"\u09AE\u09C8\u09A4\u09C8\u09B2\u09CB\u09A8\u09CD","mni-IN":"\u09AE\u09C8\u09A4\u09C8\u09B2\u09CB\u09A8\u09CD (India)","mn-MN":"\u043C\u043E\u043D\u0433\u043E\u043B (\u041C\u043E\u043D\u0433\u043E\u043B)","mn-Mong":"\u182E\u1823\u1829\u182D\u1823\u1824\u182F \u182C\u1821\u182F\u1821","mn-Mong-CN":"\u182E\u1823\u1829\u182D\u1823\u1824\u182F \u182C\u1821\u182F\u1821 (\u182A\u1826\u182D\u1826\u1833\u1821 \u1828\u1820\u1822\u1837\u1820\u182E\u1833\u1820\u182C\u1824 \u1833\u1824\u182E\u1833\u1820\u1833\u1824 \u1820\u1837\u1820\u1833 \u1823\u182F\u1823\u1830)","mn-Mong-MN":"\u182E\u1823\u1829\u182D\u1823\u182F \u182C\u1821\u182F\u1821 (\u182E\u1823\u1829\u182D\u1823\u182F \u1823\u182F\u1823\u1830)","moh":"Kanien\u2019k\xe9ha","moh-CA":"Kanien\'k\xe9ha","mr":"\u092E\u0930\u093E\u0920\u0940","mr-IN":"\u092E\u0930\u093E\u0920\u0940 (\u092D\u093E\u0930\u0924)","ms":"Melayu","ms-BN":"Melayu (Brunei)","ms-MY":"Melayu (Malaysia)","ms-SG":"Melayu (Singapura)","mt":"Malti","mt-MT":"Malti (Malta)","mua":"MUNDA\u014A","mua-CM":"MUNDA\u014A (kameru\u014B)","my":"\u1017\u1019\u102C","my-MM":"\u1019\u103C\u1014\u103A\u1019\u102C (\u1019\u103C\u1014\u103A\u1019\u102C)","mzn":"\u0645\u0627\u0632\u0631\u0648\u0646\u06CC","mzn-IR":"\u0645\u0627\u0632\u0631\u0648\u0646\u06CC (\u0627\u06CC\u0631\u0627\u0646)","naq":"Khoekhoegowab","naq-NA":"Khoekhoegowab (Namibiab)","nb":"norsk bokm\xe5l","nb-NO":"norsk bokm\xe5l (Norge)","nb-SJ":"norsk bokm\xe5l (Svalbard og Jan Mayen)","nd":"isiNdebele","nds":"Neddersass\u2019sch","nds-DE":"Neddersass\u2019sch (D\xfc\xfctschland)","nds-NL":"Neddersass\u2019sch (Nedderlannen)","nd-ZW":"isiNdebele (Zimbabwe)","ne":"\u0928\u0947\u092A\u093E\u0932\u0940","ne-IN":"\u0928\u0947\u092A\u093E\u0932\u0940 (\u092D\u093E\u0930\u0924)","ne-NP":"\u0928\u0947\u092A\u093E\u0932\u0940 (\u0928\u0947\u092A\u093E\u0932)","nl":"Nederlands","nl-AW":"Nederlands (Aruba)","nl-BE":"Nederlands (Belgi\xeb)","nl-BQ":"Nederlands (Bonaire, Sint Eustatius en Saba)","nl-CW":"Nederlands (Cura\xe7ao)","nl-NL":"Nederlands (Nederland)","nl-SR":"Nederlands (Suriname)","nl-SX":"Nederlands (Sint-Maarten)","nmg":"Kwasio","nmg-CM":"Kwasio (Kamerun)","nn":"nynorsk","nnh":"Shw\xf3\u014B\xf2 ngiemb\u0254\u0254n","nnh-CM":"Shw\xf3\u014B\xf2 ngiemb\u0254\u0254n (K\xe0mal\xfbm)","nn-NO":"nynorsk (Noreg)","no":"norsk","nqo":"\u07D2\u07DE\u07CF","nqo-GN":"\u07D2\u07DE\u07CF (\u07D6\u07CC\u07EC\u07E3\u07CD\u07EC \u07DE\u07CA\u07F2\u07D3\u07CD\u07F2)","nr":"isiNdebele","nr-ZA":"isiNdebele (South Africa)","nso":"Sesotho sa Leboa","nso-ZA":"Sesotho sa Leboa (Afrika Borwa)","nus":"Thok Nath","nus-SS":"Thok Nath (South Sudan)","nyn":"Runyankore","nyn-UG":"Runyankore (Uganda)","oc":"Occitan","oc-FR":"Occitan (Fran\xe7a)","om":"Oromoo","om-ET":"Oromoo (Itoophiyaa)","om-KE":"Oromoo (Keeniyaa)","or":"\u0B13\u0B5C\u0B3F\u0B06","or-IN":"\u0B13\u0B5C\u0B3F\u0B06 (\u0B2D\u0B3E\u0B30\u0B24)","os":"\u0438\u0440\u043E\u043D","os-GE":"\u0438\u0440\u043E\u043D (\u0413\u0443\u044B\u0440\u0434\u0437\u044B\u0441\u0442\u043E\u043D)","os-RU":"\u0438\u0440\u043E\u043D (\u0423\u04D5\u0440\u04D5\u0441\u0435)","pa":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40","pa-Arab":"\u067E\u0646\u062C\u0627\u0628\u06CC","pa-Arab-PK":"\u067E\u0646\u062C\u0627\u0628\u06CC (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)","pa-Guru":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40","pa-IN":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40 (\u0A2D\u0A3E\u0A30\u0A24)","pap":"Papiamentu","pap-029":"Papiamentu (Caribbean)","pl":"polski","pl-PL":"polski (Polska)","prg":"pr\u016Bsiskan","prg-001":"pr\u016Bsiskan (sw\u012Btai)","prs":"\u062F\u0631\u0649","prs-AF":"\u062F\u0631\u0649 (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)","ps":"\u067E\u069A\u062A\u0648","ps-AF":"\u067E\u069A\u062A\u0648 (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)","pt":"portugu\xeas","pt-AO":"portugu\xeas (Angola)","pt-BR":"portugu\xeas (Brasil)","pt-CH":"portugu\xeas (Su\xed\xe7a)","pt-CV":"portugu\xeas (Cabo Verde)","pt-GQ":"portugu\xeas (Guin\xe9 Equatorial)","pt-GW":"portugu\xeas (Guin\xe9-Bissau)","pt-LU":"portugu\xeas (Luxemburgo)","pt-MO":"portugu\xeas (RAE de Macau)","pt-MZ":"portugu\xeas (Mo\xe7ambique)","pt-PT":"portugu\xeas (Portugal)","pt-ST":"portugu\xeas (S\xe3o Tom\xe9 e Pr\xedncipe)","pt-TL":"portugu\xeas (Timor-Leste)","quc":"K\'iche\'","quc-Latn":"K\'iche\'","quc-Latn-GT":"K\'iche\' (Guatemala)","quz":"Runasimi","quz-BO":"Runasimi (Bolivia)","quz-EC":"Runasimi (Ecuador)","quz-PE":"Runasimi (Per\xfa)","rm":"rumantsch","rm-CH":"rumantsch (Svizra)","rn":"Ikirundi","rn-BI":"Ikirundi (Uburundi)","ro":"rom\xe2n\u0103","rof":"Kihorombo","rof-TZ":"Kihorombo (Tanzania)","ro-MD":"rom\xe2n\u0103 (Republica Moldova)","ro-RO":"rom\xe2n\u0103 (Rom\xe2nia)","ru":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439","ru-BY":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)","ru-KG":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F)","ru-KZ":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D)","ru-MD":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u041C\u043E\u043B\u0434\u043E\u0432\u0430)","ru-RU":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u0420\u043E\u0441\u0441\u0438\u044F)","ru-UA":"\u0440\u0443\u0441\u0441\u043A\u0438\u0439 (\u0423\u043A\u0440\u0430\u0438\u043D\u0430)","rw":"Kinyarwanda","rwk":"Kiruwa","rwk-TZ":"Kiruwa (Tanzania)","rw-RW":"Kinyarwanda (U Rwanda)","sa":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924","sah":"\u0421\u0430\u0445\u0430","sah-RU":"\u0421\u0430\u0445\u0430 (\u0420\u043E\u0441\u0441\u0438\u044F)","sa-IN":"\u0938\u0902\u0938\u094D\u0915\u0943\u0924 (\u092D\u093E\u0930\u0924\u092E\u094D)","saq":"Kisampur","saq-KE":"Kisampur (Kenya)","sbp":"Ishisangu","sbp-TZ":"Ishisangu (Tansaniya)","sd":"\u0633\u0646\u068C\u064A","sd-Arab":"\u0633\u0646\u068C\u064A","sd-Arab-PK":"\u0633\u0646\u068C\u064A (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)","sd-Deva":"\u0938\u093F\u0928\u094D\u0927\u0940","sd-Deva-IN":"\u0938\u093F\u0928\u094D\u0927\u0940 (India)","se":"davvis\xe1megiella","se-FI":"davvis\xe1megiella (Suopma)","seh":"sena","seh-MZ":"sena (Mo\xe7ambique)","se-NO":"davvis\xe1megiella (Norga)","ses":"Koyraboro senni","se-SE":"davvis\xe1megiella (Ruo\u0167\u0167a)","ses-ML":"Koyraboro senni (Maali)","sg":"S\xe4ng\xf6","sg-CF":"S\xe4ng\xf6 (K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka)","shi":"\u2D5C\u2D30\u2D5B\u2D4D\u2D43\u2D49\u2D5C","shi-Latn":"Tashel\u1E25iyt","shi-Latn-MA":"Tashel\u1E25iyt (lm\u0263rib)","shi-Tfng":"\u2D5C\u2D30\u2D5B\u2D4D\u2D43\u2D49\u2D5C","shi-Tfng-MA":"\u2D5C\u2D30\u2D5B\u2D4D\u2D43\u2D49\u2D5C (\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31)","si":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD","si-LK":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)","sk":"sloven\u010Dina","sk-SK":"sloven\u010Dina (Slovensko)","sl":"sloven\u0161\u010Dina","sl-SI":"sloven\u0161\u010Dina (Slovenija)","sma":"\xe5arjelsaemieng\xefele","sma-NO":"\xe5arjelsaemieng\xefele (N\xf6\xf6rje)","sma-SE":"\xe5arjelsaemieng\xefele (Sveerje)","smj":"julevus\xe1megiella","smj-NO":"julevus\xe1megiella (Vuodna)","smj-SE":"julevus\xe1megiella (Svierik)","smn":"anar\xe2\u0161kiel\xe2","smn-FI":"anar\xe2\u0161kiel\xe2 (Suom\xe2)","sms":"s\xe4\xe4\xb4m\u01E9i\xf5ll","sms-FI":"s\xe4\xe4\xb4m\u01E9i\xf5ll (L\xe4\xe4\xb4ddj\xe2nnam)","sn":"chiShona","sn-Latn":"chiShona (Latin)","sn-Latn-ZW":"chiShona (Zimbabwe)","so":"Soomaali","so-DJ":"Soomaali (Jabuuti)","so-ET":"Soomaali (Itoobiya)","so-KE":"Soomaali (Kiiniya)","so-SO":"Soomaali (Soomaaliya)","sq":"shqip","sq-AL":"shqip (Shqip\xebri)","sq-MK":"shqip (Republika e Maqedonis\xeb)","sq-XK":"shqip (Kosov\xeb)","sr":"srpski","sr-Cyrl":"\u0441\u0440\u043F\u0441\u043A\u0438","sr-Cyrl-BA":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)","sr-Cyrl-ME":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430)","sr-Cyrl-RS":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u0421\u0440\u0431\u0438\u0458\u0430)","sr-Cyrl-XK":"\u0441\u0440\u043F\u0441\u043A\u0438 (\u041A\u043E\u0441\u043E\u0432\u043E)","sr-Latn":"srpski","sr-Latn-BA":"srpski (Bosna i Hercegovina)","sr-Latn-ME":"srpski (Crna Gora)","sr-Latn-RS":"srpski (Srbija)","sr-Latn-XK":"srpski (Kosovo)","ss":"Siswati","ss-SZ":"siSwati (Swaziland)","ssy":"Saho","ssy-ER":"Saho (Eretria)","ss-ZA":"siSwati (South Africa)","st":"Sesotho","st-LS":"Sesotho (Lesotho)","st-ZA":"Sesotho (South Africa)","sv":"svenska","sv-AX":"svenska (\xc5land)","sv-FI":"svenska (Finland)","sv-SE":"svenska (Sverige)","sw":"Kiswahili","sw-CD":"Kiswahili (Jamhuri ya Kidemokrasia ya Kongo)","sw-KE":"Kiswahili (Kenya)","sw-TZ":"Kiswahili (Tanzania)","sw-UG":"Kiswahili (Uganda)","syr":"\u0723\u0718\u072A\u071D\u071D\u0710","syr-SY":"\u0723\u0718\u072A\u071D\u071D\u0710 (\u0723\u0718\u072A\u071D\u0710)","ta":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD","ta-IN":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE)","ta-LK":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8)","ta-MY":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0BAE\u0BB2\u0BC7\u0B9A\u0BBF\u0BAF\u0BBE)","ta-SG":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD (\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD)","te":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41","te-IN":"\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41 (\u0C2D\u0C3E\u0C30\u0C24 \u0C26\u0C47\u0C36\u0C02)","teo":"Kiteso","teo-KE":"Kiteso (Kenia)","teo-UG":"Kiteso (Uganda)","tg":"\u0422\u043E\u04B7\u0438\u043A\u04E3","tg-Cyrl":"\u0442\u043E\u04B7\u0438\u043A\u04E3","tg-Cyrl-TJ":"\u0442\u043E\u04B7\u0438\u043A\u04E3 (\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D)","th":"\u0E44\u0E17\u0E22","th-TH":"\u0E44\u0E17\u0E22 (\u0E44\u0E17\u0E22)","ti":"\u1275\u130D\u122D\u129B","ti-ER":"\u1275\u130D\u122D\u129B (\u12A4\u122D\u1275\u122B)","ti-ET":"\u1275\u130D\u122D\u129B (\u12A2\u1275\u12EE\u1335\u12EB)","tig":"\u1275\u130D\u1228","tig-ER":"\u1275\u130D\u1228 (\u12A4\u122D\u1275\u122B)","tk":"T\xfcrkmen dili","tk-TM":"T\xfcrkmen dili (T\xfcrkmenistan)","tn":"Setswana","tn-BW":"Setswana (Botswana)","tn-ZA":"Setswana (Aforika Borwa)","to":"lea fakatonga","to-TO":"lea fakatonga (Tonga)","tr":"T\xfcrk\xe7e","tr-CY":"T\xfcrk\xe7e (K\u0131br\u0131s)","tr-TR":"T\xfcrk\xe7e (T\xfcrkiye)","ts":"Xitsonga","ts-ZA":"Xitsonga (South Africa)","tt":"\u0422\u0430\u0442\u0430\u0440","tt-RU":"\u0422\u0430\u0442\u0430\u0440 (\u0420\u043E\u0441\u0441\u0438\u044F)","twq":"Tasawaq senni","twq-NE":"Tasawaq senni (Ni\u017Eer)","tzm":"Tamazi\u0263t n la\u1E6Dla\u1E63","tzm-Arab":"\u0623\u0637\u0644\u0633 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 \u0627\u0644\u062A\u0627\u0645\u0627\u0632\u064A\u062A\u064A\u0629","tzm-Arab-MA":"\u0623\u0637\u0644\u0633 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629 \u0627\u0644\u062A\u0627\u0645\u0627\u0632\u064A\u062A\u064A\u0629 (Morocco)","tzm-Latn":"Tamazi\u0263t n la\u1E6Dla\u1E63","tzm-Latn-DZ":"Tamazi\u0263t n la\u1E6Dla\u1E63 (Djaza\xefr)","tzm-Latn-MA":"Tamazi\u0263t n la\u1E6Dla\u1E63 (Me\u1E5B\u1E5Buk)","tzm-Tfng":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C","tzm-Tfng-MA":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C (\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31)","ug":"\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5","ug-CN":"\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5 (\u062C\u06C7\u06AD\u062E\u06C7\u0627 \u062E\u06D5\u0644\u0642 \u062C\u06C7\u0645\u06BE\u06C7\u0631\u0649\u064A\u0649\u062A\u0649)","uk":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430","uk-UA":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)","ur":"\u0627\u064F\u0631\u062F\u0648","ur-IN":"\u0627\u0631\u062F\u0648 (\u0628\u06BE\u0627\u0631\u062A)","ur-PK":"\u0627\u064F\u0631\u062F\u0648 (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)","uz":"o\u2018zbek","uz-Arab":"\u0627\u0648\u0632\u0628\u06CC\u06A9","uz-Arab-AF":"\u0627\u0648\u0632\u0628\u06CC\u06A9 (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)","uz-Cyrl":"\u045E\u0437\u0431\u0435\u043A\u0447\u0430","uz-Cyrl-UZ":"\u045E\u0437\u0431\u0435\u043A\u0447\u0430 (\u040E\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u043E\u043D)","uz-Latn":"o\u2018zbek","uz-Latn-UZ":"o\u2018zbek (O\u02BBzbekiston)","vai":"\uA559\uA524","vai-Latn":"Vai","vai-Latn-LR":"Vai (Laibhiya)","vai-Vaii":"\uA559\uA524","vai-Vaii-LR":"\uA559\uA524 (\uA55E\uA524\uA52B\uA569)","ve":"Tshiven\u1E13a","ve-ZA":"Tshiven\u1E13a (South Africa)","vi":"Ti\xea\u0301ng Vi\u1EC7t","vi-VN":"Ti\xea\u0301ng Vi\u1EC7t (Vi\u1EC7t Nam)","vo":"Volap\xfck","vo-001":"Volap\xfck (World)","vun":"Kyivunjo","vun-TZ":"Kyivunjo (Tanzania)","wae":"Walser","wae-CH":"Walser (Schwiz)","wal":"\u12C8\u120B\u12ED\u1273\u1271","wal-ET":"\u12C8\u120B\u12ED\u1273\u1271 (\u12A2\u1275\u12EE\u1335\u12EB)","wo":"Wolof","wo-SN":"Wolof (Senegaal)","xh":"isiXhosa","xh-ZA":"isiXhosa (eMzantsi Afrika)","xog":"Olusoga","xog-UG":"Olusoga (Yuganda)","yav":"nuasue","yav-CM":"nuasue (Kemel\xfan)","yi":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9","yi-001":"\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9 (\u05D5\u05D5\u05E2\u05DC\u05D8)","yo":"\xc8d\xe8 Yor\xf9b\xe1","yo-BJ":"\xc8d\xe8 Yor\xf9b\xe1 (Or\xedl\u025B\u0301\xe8de B\u025B\u0300n\u025B\u0300)","yo-NG":"\xc8d\xe8 Yor\xf9b\xe1 (Or\xedl\u1EB9\u0301\xe8de N\xe0\xecj\xedr\xed\xe0)","zgh":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C","zgh-Tfng":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C","zgh-Tfng-MA":"\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C (\u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31)","zh":"\u4E2D\u6587","zh-CHS":"\u4E2D\u6587(\u7B80\u4F53) \u65E7\u7248","zh-CHT":"\u4E2D\u6587(\u7E41\u9AD4) \u820A\u7248","zh-CN":"\u4E2D\u6587(\u4E2D\u56FD)","zh-Hans":"\u4E2D\u6587(\u7B80\u4F53)","zh-Hans-HK":"\u4E2D\u6587 (\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A)","zh-Hans-MO":"\u4E2D\u6587 (\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A)","zh-Hant":"\u4E2D\u6587(\u7E41\u9AD4)","zh-HK":"\u4E2D\u6587(\u9999\u6E2F\u7279\u5225\u884C\u653F\u5340)","zh-MO":"\u4E2D\u6587(\u6FB3\u9580\u7279\u5225\u884C\u653F\u5340)","zh-SG":"\u4E2D\u6587(\u65B0\u52A0\u5761)","zh-TW":"\u4E2D\u6587(\u53F0\u7063)","zu":"isiZulu","zu-ZA":"isiZulu (iNingizimu Afrika)"}');




parcelRequire("lT7pJ");
const $ac7dab0223ec91d1$var$ChevronLeftIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-4",
        viewBox: "0 0 7.414 12.828",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M1429.081,2861.407l5-5-5-5",
            transform: "translate(1435.081 2862.822) rotate(180)",
            fill: "none",
            stroke: color || "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};
var $ac7dab0223ec91d1$export$2e2bcd8739ae039 = $ac7dab0223ec91d1$var$ChevronLeftIcon;



parcelRequire("lT7pJ");
const $6d2bee83684dead6$var$ChevronRightIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "rf-h-6 rf-w-4",
        viewBox: "0 0 10.131 17.719",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M8.863,7.077l6.7-6.705a1.261,1.261,0,0,1,1.788,0,1.277,1.277,0,0,1,0,1.794L9.76,9.762A1.264,1.264,0,0,1,8.014,9.8L.369,2.171A1.266,1.266,0,0,1,2.158.377Z",
            transform: "translate(0 17.719) rotate(-90)",
            fill: color || "#818181"
        })
    });
};
var $6d2bee83684dead6$export$2e2bcd8739ae039 = $6d2bee83684dead6$var$ChevronRightIcon;



parcelRequire("lT7pJ");
const $ce7dbcfb769695da$var$ChevronUpIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 16.01",
        fill: color || "currentColor",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M14 4.83 3.4 15.43a2 2 0 0 1-2.82 0 2.02 2.02 0 0 1 0-2.84l12-12a2 2 0 0 1 2.76-.06l12.08 12.05a2 2 0 0 1-2.83 2.83Z"
        })
    });
};
var $ce7dbcfb769695da$export$2e2bcd8739ae039 = $ce7dbcfb769695da$var$ChevronUpIcon;




const $a582262af918f8da$var$ParameterButton = ({ title: title, color: color, icon: icon, onClick: onClick })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    return isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        className: `rf-w-full rf-py-4 rf-flex rf-flex-row ${icon === "lang" ? "rf-justify-between" : "rf-justify-start"} rf-items-center rf-border-t rf-border-t-menuBorder rf-capitalize`,
        onClick: onClick,
        "aria-label": title,
        children: [
            title,
            icon === "lang" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-flex rf-flex-row rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-mr-3 rf-text-lightgray rf-normal-case",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($9cdc7ea7128d4847$exports)))[locale]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6d2bee83684dead6$export$2e2bcd8739ae039), {
                        className: "rf-h-4"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        className: "rf-width-fill-available rf-mx-3 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg",
        style: {
            color: color || "#A4A7AF",
            background: "linear-gradient(to left top, #F2F3F6, #E5E6EC)",
            boxShadow: "2px 2px 6px #00000029"
        },
        onClick: onClick,
        "aria-label": title,
        children: [
            icon === "tutorial" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($81a87d6c2733c056$export$2e2bcd8739ae039, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === "history" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($591d245090c72b16$export$2e2bcd8739ae039, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : icon === "lang" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($b442bb57964de031$export$2e2bcd8739ae039, {
                className: "rf-h-3 tactile:rf-h-4",
                color: color
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-ml-1 rf-uppercase",
                children: title
            })
        ]
    });
};
var $a582262af918f8da$export$2e2bcd8739ae039 = $a582262af918f8da$var$ParameterButton;


const $23e1c54a8786b5d3$var$HistoryButton = ({ handleBack: handleBack })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    /**
   * On call :
   *  - call parent's handleBack method if defined
   *  - change RetorikContext's currentSubView state
   */ const handleClick = ()=>{
        handleBack && handleBack();
        (0, $1bda010252da638c$export$f0c096b4ecd7115d)(currentSubView === (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history ? (0, $45d43a6de0968f42$export$f05d0fed0593ead7).none : (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a582262af918f8da$export$2e2bcd8739ae039), {
        title: translation.history.title,
        icon: "history",
        color: currentSubView === (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history ? themeColors.secondary : "#A4A7AF",
        onClick: handleClick
    });
};
var $23e1c54a8786b5d3$export$2e2bcd8739ae039 = $23e1c54a8786b5d3$var$HistoryButton;




var $lT7pJ = parcelRequire("lT7pJ");






// Check if the locale in the current browser is in the array of available locales
const $276c77dad0300967$var$checkLocaleFromBrowser = (allLanguages)=>{
    const navLang = navigator?.language;
    if (navLang && allLanguages?.length) {
        let res;
        // Navigator language can be 2-chars
        if (navLang.length === 2) res = allLanguages.find((language)=>{
            return language.split("-")[1]?.toLowerCase() === navLang.toLowerCase();
        });
        else res = allLanguages.find((language)=>{
            return language.toLowerCase() === navLang.toLowerCase();
        });
        if (res) return res;
    }
    return undefined;
};
const $276c77dad0300967$export$d64c0ac95bb7fd72 = (languageData, localeConfig)=>{
    // Use browser locale if config doesn't prevent it
    if (localeConfig?.getDefaultFromBrowser !== false) {
        const browserLocale = $276c77dad0300967$var$checkLocaleFromBrowser(languageData.all);
        if (browserLocale) return browserLocale;
    }
    // Else, use default from languageData
    return languageData.default;
};
const $276c77dad0300967$export$91fc93b93c368955 = (locale)=>{
    const split = locale.split("-");
    return split.length > 0 ? split[1] : split[0];
};



const $dbc8e0777cd36249$var$LanguageButton = ()=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const supported = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.supported);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const [mainLocale, setMainLocale] = (0, $lT7pJ.useState)((0, $276c77dad0300967$export$91fc93b93c368955)(locale).toUpperCase());
    (0, $lT7pJ.useEffect)(()=>{
        setMainLocale((0, $276c77dad0300967$export$91fc93b93c368955)(locale).toUpperCase());
    }, [
        locale
    ]);
    /**
   * On call :
   *  - change RetorikContext's currentSubView state
   */ const handleClick = ()=>{
        (0, $1bda010252da638c$export$f0c096b4ecd7115d)(currentSubView === (0, $45d43a6de0968f42$export$f05d0fed0593ead7).languages ? (0, $45d43a6de0968f42$export$f05d0fed0593ead7).none : (0, $45d43a6de0968f42$export$f05d0fed0593ead7).languages);
    };
    return supported.length > 1 ? isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a582262af918f8da$export$2e2bcd8739ae039), {
        title: translation.common.lang,
        icon: "lang",
        color: currentSubView === (0, $45d43a6de0968f42$export$f05d0fed0593ead7).languages ? themeColors.secondary : "#A4A7AF",
        onClick: handleClick
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        className: "rf-absolute rf-min-w-24 rf-bottom-16 large-vertical:rf-bottom-[25vh] rf-right-0 rf-px-2 rf-flex rf-flex-row rf-items-center rf-rounded-l-lg",
        style: {
            background: "linear-gradient(#F8F8FC, #EDEEF3)"
        },
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-h-8 rf-mr-2",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                    className: "rf-h-full",
                    src: `https://flagsapi.com/${mainLocale}/flat/64.png`
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-start rf-text-xsm",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-text-trueblack",
                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.common.singleLang)
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-text-lightgray",
                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)((0, (/*@__PURE__*/$parcel$interopDefault($9cdc7ea7128d4847$exports)))[locale.split("-")[0]])
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $dbc8e0777cd36249$export$2e2bcd8739ae039 = $dbc8e0777cd36249$var$LanguageButton;




var $lT7pJ = parcelRequire("lT7pJ");

var $fAU6C = parcelRequire("fAU6C");






var $793fe2cc2712a172$exports = {};
$793fe2cc2712a172$exports = JSON.parse('{"v":"5.7.4","fr":29.9700012207031,"ip":0,"op":45.0000018328876,"w":256,"h":256,"nm":"vibe","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Calque de forme 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128,128,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,-10.25],[-49.5,103],[-92.5,39],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,65.5],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,31.25],[-49.5,103],[-92.5,81],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,18],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":16,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.247,87.636],[-49.5,62.5],[-92.5,8.144],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,10.5],[100.25,84.403],[54.75,36.25]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":23,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,51.758],[-49.5,103],[-92.5,48.989],[-129,-22],[-129.5,167.5],[128.75,171.75],[129.75,19.75],[100.25,93.847],[54.75,-2]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":31,"s":[{"i":[[30.504,0],[26.498,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,-34.148],[-49.5,39.75],[-92.5,90.277],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,33.052],[54.75,110]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":38,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.249,23.747],[-49.5,-21.5],[-92.5,115.754],[-129,62.5],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,90.836],[54.75,110]],"c":true}]},{"t":45.0000018328876,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,-10.25],[-49.5,103],[-92.5,39],[-129,128.25],[-129.5,167.5],[128.75,171.75],[129.75,127.75],[100.25,65.5],[54.75,110]],"c":true}]}],"ix":2},"nm":"Trac\xe9 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":19,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Contour 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":19,"ix":5},"r":1,"bm":0,"nm":"Fond 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformer "}],"nm":"Forme 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":45.0000018328876,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Calque de forme 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128,128,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.5,68.5],[-92.5,108.5],[-129,4.75],[-129.5,167.5],[128.75,171.75],[129.75,53],[100.25,110.5],[54.75,38.25]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,48.5],[-49.5,-11.5],[-92.5,44],[-129,116],[-129.5,167.5],[128.75,171.75],[129.75,125.5],[100.25,62.5],[54.749,95.5]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":16,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,27],[-49.502,94.547],[-92.5,55],[-129,-19.068],[-129.5,167.5],[128.75,171.75],[129.75,125],[100.25,110.5],[54.749,-63.236]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":23,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,70],[-49.501,1.079],[-92.5,120.5],[-129,57.802],[-129.5,167.5],[128.75,171.75],[129.75,-0.19],[100.25,65.5],[54.749,45.01]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":31,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,22.75],[-49.501,80.531],[-92.5,33],[-129,114.922],[-129.5,167.5],[128.75,171.75],[129.75,-17.129],[100.25,106.25],[54.747,69.109]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":38,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.501,68.115],[-92.5,106.017],[-129,129.414],[-129.5,167.5],[128.75,171.75],[129.75,63.44],[100.25,-1.2],[54.748,66.851]],"c":true}]},{"t":45.0000018328876,"s":[{"i":[[30.504,0],[26.499,-0.285],[23.25,0],[0,0],[0,-1],[0,0],[0,0],[20.501,0],[22.747,-0.37]],"o":[[-29.75,0],[-23.25,0.25],[-22.103,0],[0,0],[0,1],[0,0],[0,0],[-18.75,0],[-30.75,0.5]],"v":[[3.25,104.5],[-49.5,68.5],[-92.5,108.5],[-129,4.75],[-129.5,167.5],[128.75,171.75],[129.75,53],[100.25,110.5],[54.75,38.25]],"c":true}]}],"ix":2},"nm":"Trac\xe9 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":19,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Contour 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":19,"ix":5},"r":1,"bm":0,"nm":"Fond 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformer "}],"nm":"Forme 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":45.0000018328876,"st":0,"bm":0}],"markers":[]}');


const $ee1ff1273d831edb$var$getMicrophonePermission = async ()=>{
    try {
        return navigator.mediaDevices.getUserMedia({
            audio: true
        }).then((stream)=>{
            return !!stream;
        });
    } catch (error) {
        console.log(error);
        return false;
    }
};
var $ee1ff1273d831edb$export$2e2bcd8739ae039 = $ee1ff1273d831edb$var$getMicrophonePermission;




var $lT7pJ = parcelRequire("lT7pJ");

parcelRequire("lT7pJ");


const $e5699fc9e4e13353$var$CloseButton = ({ onClick: onClick, label: label, className: className, showLabel: showLabel })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        "aria-label": label || translation.common.close,
        onClick: onClick,
        className: `${className} rf-absolute rf-flex rf-flex-col rf-items-center rf-right-0 rf-top-0 rf-p-2`,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1bb6c2a3a9b42097$export$2e2bcd8739ae039), {
                className: "rf-h-6 rf-w-6"
            }),
            showLabel && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-text-[0.5rem] rf-uppercase",
                children: label || translation.common.close
            })
        ]
    });
};
var $e5699fc9e4e13353$export$2e2bcd8739ae039 = $e5699fc9e4e13353$var$CloseButton;


const $7b34f1b24b6db939$var$Modal = ({ isOpened: isOpened, onClose: onClose, colorClasses: colorClasses, children: children })=>{
    const modalRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        if (isOpened) modalRef.current && modalRef.current.showModal();
        else modalRef.current && modalRef.current.close();
    }, [
        isOpened
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("dialog", {
        onCancel: onClose,
        className: `rf-absolute backdrop:rf-bg-black/50 rf-left-0 rf-w-[45ch] rf-max-w-[70vw] rf-px-4 rf-rounded ${colorClasses || "rf-bg-truewhite rf-border rf-border-red-700 rf-text-red-700"} rf-font-semibold rf-text-center`,
        ref: modalRef,
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
            className: "rf-flex rf-flex-col rf-p-6",
            onClick: (event)=>event?.stopPropagation(),
            children: [
                children,
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e5699fc9e4e13353$export$2e2bcd8739ae039), {
                    onClick: onClose
                })
            ]
        })
    });
};
var $7b34f1b24b6db939$export$2e2bcd8739ae039 = $7b34f1b24b6db939$var$Modal;




parcelRequire("lT7pJ");
const $480c9cc8ce2ad08b$var$MicrophoneLoader = ()=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-h-full rf-bg-transparent",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            className: "rf-w-full rf-h-full rf-relative rf-rounded-max rf-mx-0 rf-my-auto rf-loader-microphone"
        })
    });
};
var $480c9cc8ce2ad08b$export$2e2bcd8739ae039 = $480c9cc8ce2ad08b$var$MicrophoneLoader;


const $5d2dd969319e03a9$var$MicrophoneButton = ({ openMicrophone: openMicrophone })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const activeRecognitionState = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.activeRecognitionState);
    const toggleMicrophone = (0, $4442d90d00cf976a$export$2e2bcd8739ae039)();
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const allowedRef = (0, $lT7pJ.useRef)(false);
    const [message, setMessage] = (0, $lT7pJ.useState)("");
    const [playerRef, setPlayerRef] = (0, $lT7pJ.useState)(null);
    const handleClick = ()=>{
        if (!allowedRef.current) askPermission();
        else toggleMicrophone();
    };
    (0, $lT7pJ.useEffect)(()=>{
        openMicrophone && handleClick();
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        if (playerRef) activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening ? playerRef.lottie.play() : playerRef.lottie.stop();
        (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).none);
        (0, $1bda010252da638c$export$4e062bd31c814155)(undefined);
    }, [
        activeRecognitionState,
        playerRef
    ]);
    const closeModal = ()=>{
        setMessage("");
    };
    const askPermission = ()=>{
        setMessage(translation.menu.allowMicrophone);
        return (0, $ee1ff1273d831edb$export$2e2bcd8739ae039)().then((permission)=>{
            allowedRef.current = permission;
            if (permission) {
                closeModal();
                toggleMicrophone();
            }
        }).catch(console.log);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
                className: `rf-relative large:rf-w-full large:rf-h-auto rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border ${activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening ? isMobile ? "rf-h-12 rf-border-[#00000029]" : "rf-border-[#00000029]" : isMobile ? "rf-h-8 rf-border-none" : "rf-border-menuBorder"} rf-rounded-half rf-overflow-hidden`,
                onClick: handleClick,
                "aria-label": "microphone",
                style: {
                    boxShadow: activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening ? "inset 0 0 6px 3px#00000029" : isMobile ? undefined : "0 0 20px 1px #A4A7AF80",
                    WebkitMaskImage: activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening ? "-webkit-radial-gradient(white, black)" : undefined
                },
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-absolute rf-h-full rf-w-full rf-flex rf-justify-end",
                        children: activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $fAU6C.Player), {
                            lottieRef: (instance)=>{
                                setPlayerRef({
                                    lottie: instance
                                });
                            },
                            loop: true,
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($793fe2cc2712a172$exports))),
                            className: "rf-w-full"
                        })
                    }),
                    activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($c134278dddcf92b2$export$2e2bcd8739ae039, {
                        className: "rf-h-3 rf-w-3 large:rf-h-4 large:rf-w-4"
                    }) : activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Closed ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($bc79d8ffc04dbc80$export$2e2bcd8739ae039, {
                        className: "rf-h-5 rf-w-5",
                        color: themeColors.secondary
                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $480c9cc8ce2ad08b$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $7b34f1b24b6db939$export$2e2bcd8739ae039), {
                isOpened: !!message,
                onClose: closeModal,
                children: message
            })
        ]
    });
};
var $5d2dd969319e03a9$export$2e2bcd8739ae039 = $5d2dd969319e03a9$var$MicrophoneButton;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");








var $lT7pJ = parcelRequire("lT7pJ");

var $04a0ad14abdfdd87$var$MediaTypes;
/**
 * Media types enum
 */ (function($04a0ad14abdfdd87$var$MediaTypes) {
    $04a0ad14abdfdd87$var$MediaTypes[$04a0ad14abdfdd87$var$MediaTypes["image"] = 1] = "image";
    $04a0ad14abdfdd87$var$MediaTypes[$04a0ad14abdfdd87$var$MediaTypes["video"] = 2] = "video";
})($04a0ad14abdfdd87$var$MediaTypes || ($04a0ad14abdfdd87$var$MediaTypes = {}));
const $04a0ad14abdfdd87$var$images = [
    "png",
    "gif",
    "jpg",
    "jpeg"
];
const $04a0ad14abdfdd87$var$videos = [
    "mp4",
    "webm",
    "3gp",
    "ogg"
];
const $04a0ad14abdfdd87$var$Carousel = ({ className: className, medias: medias, controls: controls, timer: timer, color: color, maxHeight: maxHeight })=>{
    const [currentIndex, setCurrentIndex] = (0, $lT7pJ.useState)(0);
    const [currentMedia, setCurrentMedia] = (0, $lT7pJ.useState)();
    const timerRef = (0, $lT7pJ.useRef)(null);
    /**
   * On medias state change :
   *  - clear timerRef interval if set
   *  - call startNewMedia to reset medias
   *  - if there are more than 1 media, set a timeout and launch it
   * On component unmount :
   *  - clear timerRef interval if set
   */ (0, $lT7pJ.useEffect)(()=>{
        // Clear interval
        timerRef.current && clearInterval(timerRef.current);
        // Call the reset function to set currentIndex and currentMedia states
        startNewMedias();
        // Launch timer only if there are more than 1 media
        if (medias.length > 1 && timer !== 0) timerRef.current = setTimeout(()=>{
            handleMore();
        }, timer || 3000);
        return ()=>timerRef.current && clearTimeout(timerRef.current);
    }, [
        medias
    ]);
    /**
   * On currentIndex state change :
   *  - check type of media in medias array at current index by calling checkType method
   *  - set currentMedia state
   */ (0, $lT7pJ.useEffect)(()=>{
        if (currentIndex !== undefined) {
            const index = currentIndex % medias.length;
            const type = checkType(medias[index].url);
            if (type) {
                setCurrentMedia({
                    ...medias[index],
                    type: type
                });
                // Reset timer only if there are more than 1 media
                if (medias.length > 1 && timer !== 0) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = setTimeout(()=>{
                        handleMore();
                    }, timer || 3000);
                }
            }
        }
    }, [
        currentIndex
    ]);
    /**
   * On call :
   *  - check if the currentIndex state is 0
   *  - if so, if we just update this state to 0 it will remain the same and won't change the currentMedia state. We just leave currentIndex as is and set currentMedia state instead.
   *  - otherwise, set the currentIndex state to 0
   */ const startNewMedias = ()=>{
        if (currentIndex === 0) {
            const type = checkType(medias[0].url);
            if (type) setCurrentMedia({
                ...medias[0],
                type: type
            });
        } else setCurrentIndex(0);
    };
    /**
   * On call :
   *  - retrieve the extension of the media
   *  - return if it's either an image, or a video, or null
   * @param src : string
   * @returns number | null
   */ const checkType = (src)=>{
        const extension = src.split(".").slice(-1)[0];
        return $04a0ad14abdfdd87$var$images.includes(extension.toLowerCase()) ? 1 : $04a0ad14abdfdd87$var$videos.includes(extension.toLowerCase()) ? 2 : null;
    };
    const handleChoice = (choice)=>{
        setCurrentIndex(choice);
    };
    const handleLess = ()=>{
        currentIndex === 0 ? setCurrentIndex(medias.length - 1) : setCurrentIndex((currentIndex)=>currentIndex - 1);
    };
    const handleMore = ()=>{
        currentIndex === medias.length - 1 ? setCurrentIndex(0) : setCurrentIndex((currentIndex)=>currentIndex + 1);
    };
    return currentMedia && currentMedia.type ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            currentMedia.type === 1 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                className: className,
                src: currentMedia.url,
                alt: currentMedia.alt || "image",
                style: {
                    maxHeight: maxHeight
                }
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("video", {
                className: className,
                style: {
                    maxHeight: maxHeight
                },
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("source", {
                    src: currentMedia.url
                })
            }),
            controls && medias.length > 1 && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-absolute rf-bottom-4 rf-left-1/2 -rf-translate-x-1/2 rf-flex rf-flex-row rf-items-center rf-gap-2",
                        children: medias.map((media, key)=>{
                            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-h-3 rf-w-3 rf-rounded-half rf-border rf-border-truewhite rf-cursor-pointer",
                                onClick: ()=>handleChoice(key),
                                style: {
                                    backgroundColor: currentIndex === key ? color : "transparent"
                                }
                            }, `${media.url}${key}`);
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-absolute rf-left-4 rf-top-1/2 -rf-translate-y-1/2 rf-cursor-pointer",
                        onClick: handleLess,
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ac7dab0223ec91d1$export$2e2bcd8739ae039), {
                            className: "rf-h-6 large:rf-h-8",
                            color: "#FFF"
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-absolute rf-right-4 rf-top-1/2 -rf-translate-y-1/2 rf-cursor-pointer",
                        onClick: handleMore,
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6d2bee83684dead6$export$2e2bcd8739ae039), {
                            className: "rf-h-6 large:rf-h-8",
                            color: "#FFF"
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $04a0ad14abdfdd87$export$2e2bcd8739ae039 = $04a0ad14abdfdd87$var$Carousel;




var $lT7pJ = parcelRequire("lT7pJ");
const $f5e9fcff3fab6870$var$Radio = ({ className: className, title: title, handleChange: handleChange, checked: checked })=>{
    const [transition, setTransition] = (0, $lT7pJ.useState)(checked ? "rf-scale-1" : "rf-scale-0");
    const handleToggle = ()=>{
        setTransition(checked ? "rf-scale-0" : "rf-scale-1");
        handleChange(title);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-flex rf-flex-row rf-items-center rf-justify-between hover:rf-cursor-pointer ${className}`,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-capitalize",
                children: title
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                className: `rf-relative rf-w-7 large:rf-w-8 large-vertical:rf-w-14 rf-min-w-7 large:rf-min-w-8 large-vertical:rf-min-w-14 rf-h-7 large:rf-h-8 large-vertical:rf-h-14 ${!checked && "rf-border rf-border-[#9FA2AA]"} rf-rounded-half`,
                style: {
                    background: checked ? "linear-gradient(to right, #1999B1, #0a4652)" : "#FFFFFF",
                    boxShadow: checked ? "-3px 3px 6px #00000029" : ""
                },
                onClick: handleToggle,
                "aria-label": title,
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: `rf-absolute rf-top-2 large-vertical:rf-top-4 rf-left-2 large-vertical:rf-left-4 rf-w-3 large:rf-w-4 large-vertical:rf-w-6 rf-h-3 large:rf-h-4 large-vertical:rf-h-6 rf-rounded-half rf-bg-[#F8F8F8] rf-transition-all ${transition}`
                })
            })
        ]
    });
};
var $f5e9fcff3fab6870$export$2e2bcd8739ae039 = $f5e9fcff3fab6870$var$Radio;






var $lT7pJ = parcelRequire("lT7pJ");
// The required distance between touchStart and touchEnd to be detected as a swipe
const $511208734c526421$var$minSwipeDistance = 30;
const $511208734c526421$var$Swiper = ({ direction: direction, onSwiping: onSwiping, onSwipeLeft: onSwipeLeft, onSwipeRight: onSwipeRight, onSwipeTop: onSwipeTop, onSwipeBottom: onSwipeBottom, className: className, children: children })=>{
    const [moveStart, setMoveStart] = (0, $lT7pJ.useState)(null);
    const [moveEnd, setMoveEnd] = (0, $lT7pJ.useState)(null);
    const [timeStart, setTimeStart] = (0, $lT7pJ.useState)(0);
    /**
   * On moveEnd state change :
   *  - set swiping distance to moveStart - moveEnd
   */ (0, $lT7pJ.useEffect)(()=>{
        if (moveStart && moveEnd) {
            const distance = moveStart - moveEnd;
            onSwiping(distance);
        }
    }, [
        moveEnd
    ]);
    /**
   * On PointerDown event fire :
   *  - set timeStart state to current timestamp
   *  - reset moveEnd state to null to prevent activation on single touch
   *  - set moveStart state with the current X or Y position depending on the direction prop
   * @param e : React.PointerEvent
   */ const onPointerDown = (e)=>{
        setTimeStart(Date.now());
        setMoveEnd(null);
        setMoveStart(direction === "horizontal" ? e.clientX : e.clientY);
    };
    /**
   * On PointerMove event fire :
   *  - set moveEnd state with the current X or Y position depending on the direction prop
   * @param e : React.PointerEvent
   */ const onPointerMove = (e)=>{
        setMoveEnd(direction === "horizontal" ? e.clientX : e.clientY);
    };
    /**
   * On PointerUp event fire :
   *  - calculate the distance between move start and end
   *  - prevent default behaviour and propagation of the event if the distance is large enough (prevent unwanted touch/click at the end of a slide)
   *  - call the parent method depending on the distance and the direction, or reset position if the distance is too small
   *  - reset moveStart state to null
   */ const onPointerUp = (e)=>{
        if (moveStart && moveEnd) {
            const elapsedTime = Date.now() - timeStart;
            const distance = moveStart - moveEnd;
            if (distance > $511208734c526421$var$minSwipeDistance) {
                e.preventDefault();
                e.stopPropagation();
                direction === "horizontal" ? onSwipeLeft(distance, elapsedTime) : onSwipeTop(distance, elapsedTime);
            } else if (distance < -$511208734c526421$var$minSwipeDistance) {
                e.preventDefault();
                e.stopPropagation();
                direction === "horizontal" ? onSwipeRight(distance, elapsedTime) : onSwipeBottom(distance, elapsedTime);
            } else onSwiping(0);
        }
        setMoveStart(null);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-relative rf-w-full rf-overflow-hidden ${className}`,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerUp,
        children: children
    });
};
var $511208734c526421$export$2e2bcd8739ae039 = $511208734c526421$var$Swiper;




var $lT7pJ = parcelRequire("lT7pJ");


const $11c705b4e72d4d88$var$Toggle = ({ className: className, title: title, handleChange: handleChange, defaultChecked: defaultChecked, lockInTextMode: lockInTextMode })=>{
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const [on, setOn] = (0, $lT7pJ.useState)(!!defaultChecked);
    const [transition, setTransition] = (0, $lT7pJ.useState)(on ? "rf-right-1" : "rf-left-1");
    (0, $lT7pJ.useEffect)(()=>{
        setOn(!!defaultChecked);
        setTransition(defaultChecked ? "rf-right-1" : "rf-left-1");
    }, [
        defaultChecked
    ]);
    const handleToggle = ()=>{
        if (!(lockInTextMode && mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text)) {
            setTransition(on ? "rf-translate-x-1" : "rf-translate-x-5");
            handleChange(!on);
            setOn(!on);
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-flex rf-flex-row large:rf-flex-col rf-items-center rf-justify-between large:rf-justify-start large:rf-gap-1 hover:rf-cursor-pointer ${className}`,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-capitalize large:rf-uppercase",
                children: title
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                className: "rf-relative rf-w-12 rf-min-w-12 rf-h-6 rf-rounded-6",
                style: {
                    background: "linear-gradient(to left, #E5E6EC, #F2F3F6)",
                    boxShadow: "inset 3px 3px 6px #00000029"
                },
                onClick: handleToggle,
                "aria-label": title,
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: `rf-absolute rf-top-1 rf-w-4 rf-h-4 rf-rounded-half ${on ? "rf-bg-secondary" : "rf-bg-[#F8F8F8]"} rf-transition-all ${transition}`,
                    style: {
                        boxShadow: on ? "-3px -3px 3px #00000029" : "3px 3px 3px #00000029"
                    }
                })
            })
        ]
    });
};
var $11c705b4e72d4d88$export$2e2bcd8739ae039 = $11c705b4e72d4d88$var$Toggle;




var $lT7pJ = parcelRequire("lT7pJ");
const $8ccc1fb03c665dc5$var$ToggleWithTexts = ({ texts: texts, colors: colors, handleChange: handleChange, defaultChecked: defaultChecked, showLeft: showLeft, showRight: showRight })=>{
    const [left, setLeft] = (0, $lT7pJ.useState)(!defaultChecked || defaultChecked === texts.leftId);
    /**
   * On call :
   *  - call parent method with either leftId or rightId depending on the leftSide parameter
   *  - set left state
   * @param leftSide : boolean
   */ const handleToggle = (leftSide)=>{
        handleChange(leftSide ? texts.leftId : texts.rightId);
        setLeft(leftSide);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-flex rf-flex-row rf-justify-between rf-text-size-auto rf-rounded-8 rf-cursor-pointer rf-select-none rf-shadow-[inset_0_12px_12px_-12px_#00000029,inset_0_-12px_12px_-12px_#00000029]",
        style: {
            background: "linear-gradient(to left, #CBCBCB 0%, #9A9797 50%, #4E4C4C 100%)",
            color: colors.text
        },
        children: [
            showLeft && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-px-4 rf-py-2 rf-uppercase rf-font-bold rf-border rf-rounded-8 ${left && "rf-shadow-[0_0_3px_6px_#00000029]"} `,
                style: {
                    background: left ? colors.background : "transparent",
                    borderColor: left ? colors.background : "transparent"
                },
                onClick: ()=>handleToggle(true),
                children: texts.left
            }),
            showRight && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-px-4 rf-py-2 rf-uppercase rf-font-bold rf-border rf-rounded-8 ${!left && "rf-shadow-[0_0_3px_6px_#00000029]"}`,
                style: {
                    background: left ? "transparent" : colors.background,
                    borderColor: left ? "transparent" : colors.background
                },
                onClick: ()=>handleToggle(false),
                children: texts.right
            })
        ]
    });
};
var $8ccc1fb03c665dc5$export$2e2bcd8739ae039 = $8ccc1fb03c665dc5$var$ToggleWithTexts;




var $lT7pJ = parcelRequire("lT7pJ");
const $3e5faa3ecd7b3792$var$Wheeler = ({ className: className, handleWheel: handleWheel, paramInHandle: paramInHandle, handleBoth: handleBoth, xAxisOnly: xAxisOnly, children: children })=>{
    const ref = (0, $lT7pJ.useRef)(null);
    /**
   * On mouse wheel :
   *  - check if the event has to be taken in account
   *  - if  yes, retrieve the wanted data
   *  - prevent event default
   *  - stop event propagation
   *  - call parent function with delta value and paramInHandle from props if defined
   * @param e : WheelEvent
   */ const internalHandleWheel = (e)=>{
        if (xAxisOnly && e.deltaY) return;
        const delta = handleBoth ? {
            x: e.deltaX,
            y: e.deltaY
        } : xAxisOnly ? e.deltaX : e.deltaY;
        e.preventDefault();
        e.stopImmediatePropagation();
        paramInHandle ? handleWheel(delta, paramInHandle) : handleWheel(delta);
    };
    /**
   * On ref change :
   *  - add wheel event listener, with passive = false to allow preventDefault in processing
   * On component unmount :
   *  - unbind wheel event listener
   */ (0, $lT7pJ.useEffect)(()=>{
        if (ref.current) ref.current.addEventListener("wheel", (e)=>internalHandleWheel(e), {
            passive: false
        });
        return ()=>{
            ref.current && ref.current.removeEventListener("wheel", (e)=>internalHandleWheel(e));
        };
    }, [
        ref.current
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: className,
        ref: ref,
        children: children
    });
};
var $3e5faa3ecd7b3792$export$2e2bcd8739ae039 = $3e5faa3ecd7b3792$var$Wheeler;





const $5d86e46c46aedee0$var$Parameters = ({ handleBack: handleBack })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const displaySubtitles = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.displaySubtitles);
    const disableSound = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.disableSound);
    const muted = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.muted);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const handleSoundChange = (val)=>{
        (0, $b8685bd729fa723f$export$a1680ba91cc9be33)(!val);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            !disableSound && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $11c705b4e72d4d88$export$2e2bcd8739ae039), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.sound,
                handleChange: handleSoundChange,
                defaultChecked: !muted
            }),
            isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-h-0 rf-w-full rf-border-t rf-border-t-menuBorder"
            }),
            mode !== (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $11c705b4e72d4d88$export$2e2bcd8739ae039), {
                className: "rf-py-3 large:rf-py-0",
                title: translation.common.subtitle,
                handleChange: (0, $7c69764370dcab43$export$708f3eb1d5828832),
                defaultChecked: displaySubtitles
            }),
            isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $dbc8e0777cd36249$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1eaa238f8167b05e$export$2e2bcd8739ae039), {
                        handleBack: handleBack
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $23e1c54a8786b5d3$export$2e2bcd8739ae039), {
                        handleBack: handleBack
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c28665492b2d9d53$export$2e2bcd8739ae039), {
                        handleClick: handleBack
                    })
                ]
            })
        ]
    });
};
var $5d86e46c46aedee0$export$2e2bcd8739ae039 = $5d86e46c46aedee0$var$Parameters;




parcelRequire("lT7pJ");


const $1eaa238f8167b05e$var$TutorialButton = ({ handleBack: handleBack })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const handleClick = ()=>{
        handleBack && handleBack();
        console.log("Launch tutorial");
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a582262af918f8da$export$2e2bcd8739ae039), {
        title: translation.common.tutorial,
        icon: "tutorial",
        onClick: handleClick
    });
};
var $1eaa238f8167b05e$export$2e2bcd8739ae039 = $1eaa238f8167b05e$var$TutorialButton;





const $1ed31e01939ae4c3$var$SubMenuClosing = ({ className: className, background: background, handleClose: handleClose, backIsConversation: backIsConversation, title: title, children: children })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $3976fc38b762a4bf$export$2e2bcd8739ae039), {
        background: background,
        onClick: handleClose,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                title: backIsConversation ? translation.menu.backconversation : isMobile ? translation.common.back : translation.menu.backconversation,
                handleBack: handleClose,
                className: "rf-relative large:rf-absolute large-tactile:rf-hidden rf-pb-6 large:rf-left-4 large:rf-top-8 rf-text-size-auto"
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `rf-w-full large:rf-w-fit large:rf-max-w-full large-vertical:rf-max-w-2/3 large:rf-px-6 rf-flex rf-flex-col large-vertical:rf-text-size-auto rf-overflow-y-scroll rf-scrollbar-hidden ${className}`,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                        title: translation.menu.backconversation,
                        handleBack: handleClose,
                        className: "rf-hidden large-tactile:rf-flex rf-pt-4 rf-pb-6"
                    }),
                    title && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "large:rf-mt-20 large-tactile:rf-mt-0 rf-mb-6 rf-title-bold-size-auto rf-font-bold",
                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(title, locale)
                    }),
                    children
                ]
            })
        ]
    });
};
var $1ed31e01939ae4c3$export$2e2bcd8739ae039 = $1ed31e01939ae4c3$var$SubMenuClosing;







const $e04e42ecbb2c2cfa$var$FullScreenRemoteClosing = ({ className: className, background: background, closeButtonClassName: closeButtonClassName, remoteCloseButtonZIndex: remoteCloseButtonZIndex, mobileReturnTitle: mobileReturnTitle, handleClose: handleClose, onClick: onClick, animation: animation, children: children })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isLandscape = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isLandscape);
    const isBorne = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isBorne);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $1241df08e86bc062$export$2e2bcd8739ae039), {
                className: className,
                background: background,
                onClick: onClick,
                animation: animation,
                children: [
                    isLandscape && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e5699fc9e4e13353$export$2e2bcd8739ae039), {
                        onClick: handleClose,
                        className: closeButtonClassName,
                        showLabel: true
                    }),
                    isMobile && mobileReturnTitle && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                        title: mobileReturnTitle,
                        handleBack: handleClose,
                        className: "rf-p-4 rf-text-size-auto"
                    }),
                    children
                ]
            }),
            isBorne && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $861fac448a37f7dd$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                zIndexClassname: remoteCloseButtonZIndex,
                onClick: handleClose
            })
        ]
    });
};
var $e04e42ecbb2c2cfa$export$2e2bcd8739ae039 = $e04e42ecbb2c2cfa$var$FullScreenRemoteClosing;



parcelRequire("lT7pJ");

const $8b5d7b52aee9fdc8$var$Title = ({ className: className, title: title, numberOfResults: numberOfResults })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-mb-4 rf-flex rf-flex-col rf-items-start rf-justify-center large:rf-flex-row large:rf-items-baseline large:rf-justify-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-text-3xl large:rf-text-5xl rf-font-bold",
                children: title
            }),
            numberOfResults !== undefined && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-text-gray large:rf-ml-4",
                children: [
                    numberOfResults,
                    " ",
                    numberOfResults > 1 ? translation.common.results : translation.common.result
                ]
            })
        ]
    });
};
var $8b5d7b52aee9fdc8$export$2e2bcd8739ae039 = $8b5d7b52aee9fdc8$var$Title;



parcelRequire("lT7pJ");


parcelRequire("lT7pJ");




const $d5b10366165cf143$var$ChosenItem = ({ className: className, filterItem: filterItem, parent: parent })=>{
    const { processFiltersOnChange: processFiltersOnChange } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-py-1 rf-text-size-auto rf-text-white rf-bg-gray hover:rf-cursor-pointer rf-rounded-lg rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
        onClick: ()=>processFiltersOnChange([
                {
                    ...parent,
                    filterItems: [
                        filterItem
                    ]
                }
            ]),
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-mr-2 large:rf-mr-3",
                children: parent.id === "Event.DateRange" ? `${filterItem.name.substring(8, 10)}/${filterItem.name.substring(5, 7)}/${filterItem.name.substring(0, 4)}` : (0, $0fdc9a557a65290b$export$d07f57595c356899)(filterItem.name, locale)
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1bb6c2a3a9b42097$export$2e2bcd8739ae039), {
                className: "rf-h-3 rf-w-3"
            })
        ]
    });
};
var $d5b10366165cf143$export$2e2bcd8739ae039 = $d5b10366165cf143$var$ChosenItem;




var $lT7pJ = parcelRequire("lT7pJ");






var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");

const $23b6030b65720212$var$CheckBox = ({ className: className, iconClassName: iconClassName, checked: checked, onClick: onClick })=>{
    const [bgColor, setBgColor] = (0, $lT7pJ.useState)(checked ? "rf-bg-secondary" : "rf-bg-truewhite");
    (0, $lT7pJ.useEffect)(()=>{
        setBgColor(checked ? "rf-bg-secondary" : "rf-bg-truewhite");
    }, [
        checked
    ]);
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onClick && onClick();
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-w-6 rf-h-6 rf-min-w-6 rf-min-h-6 rf-flex rf-justify-center rf-items-center rf-border rf-border-templateCheckboxBorder hover:rf-cursor-pointer ${bgColor} ${className}`,
        onClick: (e)=>handleClick(e),
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e1e0df67609bc0b5$export$2e2bcd8739ae039), {
            className: iconClassName
        })
    });
};
var $23b6030b65720212$export$2e2bcd8739ae039 = $23b6030b65720212$var$CheckBox;


const $c72f3ff7866c3fcc$var$SubFilter = ({ className: className, filterItem: filterItem, parent: parent })=>{
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    const checked = (0, $lT7pJ.useMemo)(()=>{
        if (selectedFilters.length) {
            const check = selectedFilters.filter((filter)=>filter.title === parent.title && filter.filterItems.find((item)=>item.name === filterItem.name && item.value === filterItem.value) !== undefined);
            return !!check.length;
        }
        return false;
    }, [
        selectedFilters
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-pt-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center ${className}`,
        children: [
            (0, $0fdc9a557a65290b$export$d07f57595c356899)(filterItem.name, locale),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $23b6030b65720212$export$2e2bcd8739ae039), {
                className: "rf-rounded large:rf-ml-8",
                iconClassName: "rf-w-4 rf-h-4 large:rf-p-min1 large:rf-w-6 large:rf-h-6",
                checked: checked,
                onClick: ()=>processFiltersOnChange([
                        {
                            ...parent,
                            filterItems: [
                                filterItem
                            ]
                        }
                    ])
            })
        ]
    });
};
var $c72f3ff7866c3fcc$export$2e2bcd8739ae039 = $c72f3ff7866c3fcc$var$SubFilter;



parcelRequire("lT7pJ");




const $a81b94cf3068bbeb$var$SubFilterAll = ({ className: className, fullParent: fullParent })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $d0ec91114d7de49c$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-py-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center ${className}`,
        children: [
            (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.common.all, locale),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $23b6030b65720212$export$2e2bcd8739ae039), {
                className: "rf-rounded large:rf-ml-8",
                iconClassName: "rf-w-4 rf-h-4 large:rf-p-min1 large:rf-w-6 large:rf-h-6",
                checked: selectedFilters.filter((filter)=>filter.title === fullParent.title && filter.filterItems.length === fullParent.filterItems.length).length === 1,
                onClick: ()=>processFiltersOnChange([
                        {
                            ...fullParent
                        }
                    ], true)
            })
        ]
    });
};
var $a81b94cf3068bbeb$export$2e2bcd8739ae039 = $a81b94cf3068bbeb$var$SubFilterAll;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("lT7pJ");



var $lT7pJ = parcelRequire("lT7pJ");



const $6b02161c48723176$export$ffedad9fbd47bff0 = (dateAsString)=>{
    if (dateAsString) {
        const resultFromLocal = $6b02161c48723176$var$processSplitDate(dateAsString.split("-"));
        if (resultFromLocal) return resultFromLocal;
    }
    const now = new Date();
    return [
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDate()
    ];
};
const $6b02161c48723176$var$processSplitDate = (splitDate)=>{
    if (splitDate.length === 3) {
        const year = parseInt(splitDate[0]);
        const month = parseInt(splitDate[1]);
        const day = parseInt(splitDate[2]);
        if (!isNaN(year) && !isNaN(month) && !isNaN(day)) return [
            year,
            month,
            day
        ];
    }
    return undefined;
};
const $6b02161c48723176$export$9e9b71dbaf488f87 = (month, locale)=>{
    const date = new Date(`2000-${month}-1`).toLocaleString(locale, {
        month: "long"
    });
    return date;
};





/**
 * Oddmonths used to calculate the max amount of days in a month
 */ const $ab605451f28d48cc$var$oddMonths = [
    4,
    6,
    9,
    11
];
const $ab605451f28d48cc$var$InputCalendar = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, handleChange: handleChange, isFilter: isFilter })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [year, setYear] = (0, $lT7pJ.useState)(new Date().getFullYear());
    const [month, setMonth] = (0, $lT7pJ.useState)(new Date().getMonth() + 1);
    const [day, setDay] = (0, $lT7pJ.useState)(new Date().getDate());
    const [maxYear, setMaxYear] = (0, $lT7pJ.useState)(0);
    const [minYear, setMinYear] = (0, $lT7pJ.useState)(100000);
    const [maxMonth, setMaxMonth] = (0, $lT7pJ.useState)(12);
    const [minMonth, setMinMonth] = (0, $lT7pJ.useState)(1);
    const [maxDay, setMaxDay] = (0, $lT7pJ.useState)(31);
    const [minDay, setMinDay] = (0, $lT7pJ.useState)(1);
    const [maxValueAsDate, setMaxValueAsDate] = (0, $lT7pJ.useState)(undefined);
    const [minValueAsDate, setMinValueAsDate] = (0, $lT7pJ.useState)(undefined);
    const [date, setDate] = (0, $lT7pJ.useState)(values.get(id) || `${year}-${month}-${day}`);
    /**
   * On month / year states change :
   *  - calculate and return the number of days of the current month
   */ const days = (0, $lT7pJ.useMemo)(()=>{
        if (month && year) {
            // If we check the february month, either 28 or 29 days depending on the year
            if (month === 2) return year % 4 === 0 ? 29 : 28;
            // 30 days for oddMonths, 31 otherwise
            return $ab605451f28d48cc$var$oddMonths.includes(month) ? 30 : 31;
        }
        return undefined;
    }, [
        month,
        year
    ]);
    /**
   * On month / year states change :
   *  - check which day is the first day of the month
   *  - return the number of days of week before the first one of the month
   */ const emptyDays = (0, $lT7pJ.useMemo)(()=>{
        const firstDay = new Date(year, month - 1, 1).toLocaleString("fr-FR", {
            weekday: "long"
        });
        switch(firstDay.toLowerCase()){
            case "lundi":
                return 0;
            case "mardi":
                return 1;
            case "mercredi":
                return 2;
            case "jeudi":
                return 3;
            case "vendredi":
                return 4;
            case "samedi":
                return 5;
            case "dimanche":
                return 6;
        }
        return 0;
    }, [
        month,
        year
    ]);
    const title = (0, $lT7pJ.useMemo)(()=>{
        const newDate = new Date(year, month - 1, 1);
        return (0, $0fdc9a557a65290b$export$d07f57595c356899)(new Date(newDate).toLocaleString(locale, {
            month: "long",
            year: "numeric"
        }));
    }, [
        month,
        year
    ]);
    /**
   * On locale change :
   *  - translate the days of week to display depending on the locale
   */ const daysOfWeek = (0, $lT7pJ.useMemo)(()=>{
        let tempArray = [];
        for(let i = 1; i < 8; i++){
            // First day of May 2023 is monday, let's get each day one after another beginning by monday
            const newDate = new Date(2023, 4, i);
            tempArray = [
                ...tempArray,
                (0, $0fdc9a557a65290b$export$d07f57595c356899)(newDate.toLocaleString(locale, {
                    weekday: "short"
                }))
            ];
        }
        return tempArray;
    }, [
        locale
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On component mount :
   *  - set day / month / year from localStorage value if there is one, current Date otherwise
   *  - set max values from props or current Date + 150 years otherwise
   */ (0, $lT7pJ.useEffect)(()=>{
        const dateAsArray = (0, $6b02161c48723176$export$ffedad9fbd47bff0)(values.get(id) || defaultValue);
        setYear(dateAsArray[0]);
        setMonth(dateAsArray[1]);
        setDay(dateAsArray[2]);
        setDate(`${dateAsArray[0]}-${dateAsArray[1]}-${dateAsArray[2]}`);
        // Set min and max years
        const now = new Date();
        if (maxValue) {
            const maxAsDate = new Date(maxValue);
            setMaxValueAsDate(maxAsDate);
            setMaxYear(maxAsDate.getFullYear());
            setMaxMonth(maxAsDate.getMonth() + 1);
            setMaxDay(maxAsDate.getDate());
        } else setMaxYear(now.getFullYear() + 150);
        if (minValue) {
            const minAsDate = new Date(minValue);
            setMinValueAsDate(minAsDate);
            setMinYear(minAsDate.getFullYear());
            setMinMonth(minAsDate.getMonth() + 1);
            setMinDay(minAsDate.getDate());
        } else setMinYear(now.getFullYear() - 150);
    }, []);
    /**
   * On day / month / year state change :
   *  - check if the date is in the boundaries of minDate / maxDate
   *  - set the value in localStorage
   */ (0, $lT7pJ.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        // Explode date to extract each value and substract 1 to the month (begins at 0 in js Date object)
        const dateAsArray = date.split("-");
        const newDate = new Date(parseInt(dateAsArray[0]), parseInt(dateAsArray[1]) - 1, parseInt(dateAsArray[2]));
        if (minValue && minValueAsDate && newDate < minValueAsDate) {
            setDay(minDay);
            setMonth(minMonth);
            setYear(minYear);
            setDate(minValue);
        } else if (maxValue && maxValueAsDate && newDate > maxValueAsDate) {
            setDay(maxDay);
            setMonth(maxMonth);
            setYear(maxYear);
            setDate(maxValue);
        } else // Save date
        id !== "filterCalendar" && (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, date);
    }, [
        date
    ]);
    const handlePreviousMonth = ()=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            if (year > minYear) {
                setMonth((month)=>month === 1 ? 12 : month - 1);
                month === 1 && setYear((year)=>year - 1);
            } else if (year === minYear && month > minMonth) month > 1 && setMonth((month)=>month - 1);
        }
    };
    const handleNextMonth = ()=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            if (year < maxYear) {
                setMonth((month)=>month === 12 ? 1 : month + 1);
                month === 12 && setYear((year)=>year + 1);
            } else if (year === maxYear && month < maxMonth) month < 12 && setMonth((month)=>month + 1);
        }
    };
    const handleClick = (value)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            setDay(value);
            setDate(`${year}-${month}-${value}`);
            id === "filterCalendar" && handleChange?.(`${year}-${month < 10 ? "0" : ""}${month}-${value < 10 ? "0" : ""}${value}`);
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-px-2 rf-flex rf-flex-col rf-rounded-lg ${isFilter ? "rf-text-trueblack" : "rf-text-truewhite"} rf-subtitle-size-auto rf-unselectable`,
        style: {
            background: isFilter ? "#FFF" : "rgba(0, 0, 0, 0.5)"
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-px-4 rf-py-6 rf-flex rf-flex-row rf-justify-between rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-4 rf-cursor-pointer",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handlePreviousMonth();
                        },
                        children: (year > minYear || year === minYear && month > minMonth) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ac7dab0223ec91d1$export$2e2bcd8739ae039), {
                            className: "rf-h-4",
                            color: isFilter ? "#000" : "#FFF"
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: `rf-width-fill-available rf-text-center rf-title-size-auto ${isFilter ? "rf-text-secondary" : "rf-text-primary"}`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-4 rf-cursor-pointer",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleNextMonth();
                        },
                        children: (year < maxYear || year === maxYear && month < maxMonth) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6d2bee83684dead6$export$2e2bcd8739ae039), {
                            className: "rf-h-4",
                            color: isFilter ? "#000" : "#FFF"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-py-6 rf-grid rf-grid-cols-7 rf-gap-4",
                children: [
                    daysOfWeek.map((weekDay, key)=>{
                        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-flex rf-justify-center rf-items-center rf-aspect-square",
                            children: weekDay
                        }, key);
                    }),
                    [
                        ...Array(emptyDays)
                    ].map((e, key)=>{
                        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-aspect-square",
                            children: e || "\u2800"
                        }, (key + 1) * 10);
                    }),
                    [
                        ...Array(days)
                    ].map((e, key)=>{
                        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: `rf-flex rf-justify-center rf-items-center rf-aspect-square ${key + 1 === day && parseInt(date.split("-")[1]) === month && parseInt(date.split("-")[0]) === year ? `rf-font-bold rf-text-trueblack ${isFilter ? "rf-bg-secondary" : "rf-bg-primary"} rf-rounded-half` : year === maxYear && month === maxMonth && key + 1 > maxDay ? "rf-text-formInputRadioCheckboxUncheckedBackground" : "rf-cursor-pointer"}`,
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                handleClick(key + 1);
                            },
                            children: e || key + 1
                        }, (key + 1) * 100);
                    })
                ]
            })
        ]
    });
};
var $ab605451f28d48cc$export$2e2bcd8739ae039 = $ab605451f28d48cc$var$InputCalendar;


const $74461afd89e8d881$var$SubFilterCalendar = ({ parent: parent })=>{
    const { selectedFilters: selectedFilters, processFiltersOnChange: processFiltersOnChange } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const handleCalendarChange = (newDate)=>{
        processFiltersOnChange([
            {
                ...parent,
                filterItems: [
                    {
                        name: newDate,
                        value: newDate
                    }
                ]
            }
        ]);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-pt-4 large:rf-py-1 rf-flex rf-justify-between rf-items-center",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ab605451f28d48cc$export$2e2bcd8739ae039), {
            id: "filterCalendar",
            handleChange: handleCalendarChange,
            defaultValue: selectedFilters.find((filter)=>filter.id === "Event.DateRange" && filter.filterItems.length > 0)?.filterItems[0].name.substring(0, 11),
            isFilter: true
        })
    });
};
var $74461afd89e8d881$export$2e2bcd8739ae039 = $74461afd89e8d881$var$SubFilterCalendar;


const $d8dc3cd269b7ac88$var$FilterItem = ({ className: className, identifier: identifier, opened: opened, filter: filter, closeOpenedFilters: closeOpenedFilters })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const [style, setStyle] = (0, $lT7pJ.useState)("");
    (0, $lT7pJ.useEffect)(()=>{
        opened ? setStyle("rf-bg-truewhite rf-text-black rf-border-black") : setStyle("rf-bg-templateBackground rf-text-gray rf-border-gray");
    }, [
        opened
    ]);
    const handleOpen = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        closeOpenedFilters(opened ? undefined : identifier);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-relative rf-mt-1",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `rf-px-4 rf-py-3 rf-mr-4 large-vertical:rf-py-4 ${style} rf-border rf-rounded-lg hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
                onClick: (e)=>handleOpen(e),
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-mr-3",
                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(filter.title, locale)
                    }),
                    opened ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $f1e16fab284e9cc3$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $491a12661fd84d1f$export$2e2bcd8739ae039), {})
                ]
            }),
            opened && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-absolute rf-left-0 rf-top-110 rf-z-util rf-w-max rf-py-1 rf-px-4 rf-text-black rf-border rf-rounded-lg rf-border-black rf-bg-truewhite rf-flex rf-flex-col rf-items-center rf-justify-center",
                style: {
                    transform: filter.id === "Event.DateRange" && !isMobile ? "translate(-20%, -20%) scale(0.6, 0.6)" : ""
                },
                children: filter.id === "Event.DateRange" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $74461afd89e8d881$export$2e2bcd8739ae039), {
                    parent: {
                        id: filter.id,
                        title: filter.title
                    }
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a81b94cf3068bbeb$export$2e2bcd8739ae039), {
                            fullParent: filter
                        }),
                        filter.filterItems.map((item, key)=>{
                            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c72f3ff7866c3fcc$export$2e2bcd8739ae039), {
                                filterItem: item,
                                parent: {
                                    id: filter.id,
                                    title: filter.title
                                }
                            }, key);
                        })
                    ]
                })
            })
        ]
    });
};
var $d8dc3cd269b7ac88$export$2e2bcd8739ae039 = $d8dc3cd269b7ac88$var$FilterItem;


const $b78685bbc4ab8f69$var$FilterLarge = ({ className: className, openedFilterKey: openedFilterKey, setOpenedFilterKey: setOpenedFilterKey })=>{
    const { filters: filters, selectedFilters: selectedFilters } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const closeOpenedFilters = (key)=>{
        setOpenedFilterKey(key);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-flex rf-flex-col rf-justify-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-relative rf-flex rf-flex-row rf-flex-wrap",
                children: filters.map((filter, key)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d8dc3cd269b7ac88$export$2e2bcd8739ae039), {
                        identifier: key + 1,
                        opened: (openedFilterKey && key + 1 === openedFilterKey) === true,
                        filter: filter,
                        closeOpenedFilters: closeOpenedFilters
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-flex rf-flex-row rf-my-2 rf-flex-wrap",
                children: selectedFilters?.map((chosenFilter, key1)=>{
                    return chosenFilter.filterItems.map((item, key2)=>{
                        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d5b10366165cf143$export$2e2bcd8739ae039), {
                            className: "rf-px-4 rf-mr-2 rf-mb-1",
                            filterItem: item,
                            parent: {
                                id: chosenFilter.id,
                                title: chosenFilter.title
                            }
                        }, `${key1}-${key2}`);
                    });
                })
            })
        ]
    });
};
var $b78685bbc4ab8f69$export$2e2bcd8739ae039 = $b78685bbc4ab8f69$var$FilterLarge;




var $lT7pJ = parcelRequire("lT7pJ");






var $lT7pJ = parcelRequire("lT7pJ");





parcelRequire("lT7pJ");


const $4bf4bc90c50ddab8$var$MobileUpperBand = ({ title: title, handleReset: handleReset, handleReturn: handleReturn })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-py-4 rf-px-4 rf-flex rf-justify-between rf-items-center rf-border-b rf-border-b-black",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
                className: "rf-flex rf-flex-row rf-items-center rf-text-size-auto",
                onClick: handleReturn,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $cfe8bc90bdab329b$export$2e2bcd8739ae039), {
                        className: "rf-w-8"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-ml-1",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-text-xsm rf-uppercase rf-text-secondary rf-underline",
                onClick: handleReset,
                children: translation.template.reset
            })
        ]
    });
};
var $4bf4bc90c50ddab8$export$2e2bcd8739ae039 = $4bf4bc90c50ddab8$var$MobileUpperBand;


const $39db927389ea96c0$var$MobileFilterPage = ({ close: close, resetFilters: resetFilters, setCurrentOpened: setCurrentOpened })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const { filters: filters, processFiltersOnChange: processFiltersOnChange } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const { locale: locale } = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    const handleSelectAllAndOpen = (filter)=>{
        processFiltersOnChange([
            filter
        ], true);
        setCurrentOpened(filter);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4bf4bc90c50ddab8$export$2e2bcd8739ae039), {
                title: translation.common.filter,
                handleReset: resetFilters,
                handleReturn: close
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-px-2",
                children: filters.map((filter, key)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: `rf-py-4 rf-text-xl rf-font-semibold rf-flex rf-justify-between rf-items-center rf-cursor-pointer ${key !== 0 && "rf-border-t rf-border-t-[#CBC9C9]"}`,
                        onClick: ()=>setCurrentOpened(filter),
                        children: [
                            (0, $0fdc9a557a65290b$export$d07f57595c356899)(filter.title, locale),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                className: "rf-flex rf-items-center",
                                children: [
                                    filter.id !== "Event.DateRange" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                        className: "rf-text-sm rf-text-gray rf-mr-5",
                                        onClick: ()=>handleSelectAllAndOpen(filter),
                                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.common.all, locale)
                                    }),
                                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6d2bee83684dead6$export$2e2bcd8739ae039), {
                                        className: "rf-h-5",
                                        color: "#000"
                                    })
                                ]
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
};
var $39db927389ea96c0$export$2e2bcd8739ae039 = $39db927389ea96c0$var$MobileFilterPage;




var $lT7pJ = parcelRequire("lT7pJ");






const $0e2f37c2f676d402$var$MobileSubFilterPage = ({ filter: filter, close: close, resetFilters: resetFilters })=>{
    const { locale: locale } = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>({
            locale: state.locale
        }));
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4bf4bc90c50ddab8$export$2e2bcd8739ae039), {
                title: (0, $0fdc9a557a65290b$export$d07f57595c356899)(filter.title, locale),
                handleReset: resetFilters,
                handleReturn: close
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-px-2",
                children: filter.id === "Event.DateRange" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $74461afd89e8d881$export$2e2bcd8739ae039), {
                    parent: {
                        id: filter.id,
                        title: filter.title
                    }
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a81b94cf3068bbeb$export$2e2bcd8739ae039), {
                            className: "rf-text-xl rf-border-b rf-border-b-silver",
                            fullParent: filter
                        }),
                        filter.filterItems.map((item, key)=>{
                            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c72f3ff7866c3fcc$export$2e2bcd8739ae039), {
                                className: "rf-text-xl",
                                filterItem: item,
                                parent: {
                                    id: filter.id,
                                    title: filter.title
                                }
                            }, key);
                        })
                    ]
                })
            })
        ]
    });
};
var $0e2f37c2f676d402$export$2e2bcd8739ae039 = $0e2f37c2f676d402$var$MobileSubFilterPage;



parcelRequire("lT7pJ");



const $ea4465c0efadb004$var$MobileDisplayResult = ({ onClick: onClick })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-w-full rf-pt-8 ${mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text ? "rf-mb-30" : "rf-mb-16"} rf-flex rf-justify-center rf-justify-self-end`,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
            className: "rf-py-4 rf-px-6 rf-font-bold rf-text-secondary rf-border-2 rf-rounded-lg rf-border-secondary",
            onClick: onClick,
            children: translation.template.showresults
        })
    });
};
var $ea4465c0efadb004$export$2e2bcd8739ae039 = $ea4465c0efadb004$var$MobileDisplayResult;



// Check if we should let the event propagate. For example leaflet events should pass to allow map panning
const $b5fe10956c349963$var$checkShouldPropagate = (e)=>{
    if (e.target) try {
        const className = e.target.className;
        return className && typeof className === "string" ? className.includes("leaflet") : false;
    } catch  {
        return false;
    }
    else return false;
};
const $b5fe10956c349963$var$handleStop = (e)=>{
    !$b5fe10956c349963$var$checkShouldPropagate(e) && e.cancelable && e.preventDefault();
};
const $b5fe10956c349963$var$handleRefStop = (e, ref)=>{
    if (!$b5fe10956c349963$var$checkShouldPropagate(e) && e.cancelable && ref.current) {
        const scrollHeight = ref.current.scrollHeight;
        const scrollTop = ref.current.scrollTop;
        const clientHeight = ref.current.clientHeight;
        // If no overflow, prevent event default
        if (scrollHeight === clientHeight) e.preventDefault();
        else if (e.type === "wheel") scrollTop === 0 ? e.deltaY < 0 && e.preventDefault() : scrollTop + clientHeight >= scrollHeight - 5 && e.deltaY > 0 && e.preventDefault();
        else if (e.type === "touchmove") {
            if (e.touches.length > 1) e.preventDefault();
            else {
                const positionInLocalStorage = localStorage.getItem("Retorik.Framework.TouchY");
                const origin = positionInLocalStorage ? parseInt(positionInLocalStorage) : null;
                if (origin && !isNaN(origin)) {
                    const currentY = e.touches.length > 0 ? e.touches[0].screenY : null;
                    if (currentY || currentY === 0) {
                        const deltaY = origin - currentY;
                        scrollTop === 0 ? deltaY < 0 && e.preventDefault() : scrollTop + clientHeight >= scrollHeight - 5 && deltaY > 0 && e.preventDefault();
                    } else e.preventDefault();
                } else e.preventDefault();
            }
        }
        e.stopImmediatePropagation();
    }
};
const $b5fe10956c349963$var$handleTouch = (e)=>{
    localStorage.setItem("Retorik.Framework.TouchY", `${e.touches[0].screenY}`);
    e.touches.length > 1 && !$b5fe10956c349963$var$checkShouldPropagate(e) && e.cancelable && e.preventDefault();
};
/**
 * Attach wheel | touch events on either a HTMLElement or a reference to a HTMLDivElement to prevent the propagation of this events to parent window.
 * @param {HTMLElement | null} element HTMLElement to which we will attach the events
 * @param {React.RefObject<HTMLDivElement>} ref reference to the HTMLDivElement to which we will attach the events
 * @param {AbortSignal} signal abort signal to remove events when needed
 */ const $b5fe10956c349963$var$preventEvents = (element, ref, signal)=>{
    // Add abort signal to options if present
    const options = signal ? {
        passive: false,
        signal: signal
    } : {
        passive: false
    };
    if (ref?.current) {
        try {
            ref.current.removeEventListener("wheel", (e)=>$b5fe10956c349963$var$handleRefStop(e, ref));
            ref.current.removeEventListener("touchstart", (e)=>$b5fe10956c349963$var$handleTouch(e));
            ref.current.removeEventListener("touchmove", (e)=>$b5fe10956c349963$var$handleRefStop(e, ref));
        } catch (err) {
            console.warn(err);
        }
        ref.current.addEventListener("wheel", (e)=>$b5fe10956c349963$var$handleRefStop(e, ref), options);
        ref.current.addEventListener("touchstart", (e)=>$b5fe10956c349963$var$handleTouch(e), options);
        ref.current.addEventListener("touchmove", (e)=>$b5fe10956c349963$var$handleRefStop(e, ref), options);
    } else if (element) {
        element.addEventListener("wheel", (e)=>$b5fe10956c349963$var$handleStop(e), options);
        element.addEventListener("touchstart", (e)=>$b5fe10956c349963$var$handleTouch(e), options);
        element.addEventListener("touchmove", (e)=>$b5fe10956c349963$var$handleStop(e), options);
    }
};
var $b5fe10956c349963$export$2e2bcd8739ae039 = $b5fe10956c349963$var$preventEvents;


const $a1830188b1d79c71$var$FilterMobile = ({ className: className, setFiltersOpened: setFiltersOpened, handleClose: handleClose, hasFilters: hasFilters })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const { resetFilters: resetFilters } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const [open, setOpen] = (0, $lT7pJ.useState)(false);
    const [currentOpened, setCurrentOpened] = (0, $lT7pJ.useState)(undefined);
    const divRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        if (divRef?.current) isWidget && (0, $b5fe10956c349963$export$2e2bcd8739ae039)(null, divRef);
    }, [
        divRef?.current
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        setFiltersOpened(open);
    }, [
        open
    ]);
    const handleClick = ()=>{
        setOpen(true);
    };
    const handleReturn = ()=>{
        setOpen(false);
    };
    const handleReset = ()=>{
        setOpen(false);
        resetFilters && resetFilters();
    };
    const closeCurrentSubFilters = ()=>{
        setCurrentOpened(undefined);
    };
    const handleDisplayResults = ()=>{
        setCurrentOpened(undefined);
        setOpen(false);
    };
    return !open ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `large:rf-hidden rf-w-full rf-py-4 rf-px-4 rf-flex rf-flex-row rf-justify-between rf-items-center rf-bg-truewhite rf-shadow-[0_0_15px_0_silver] ${className}`,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                title: translation.menu.backconversation,
                handleBack: handleClose,
                className: "rf-relative rf-text-size-auto"
            }),
            hasFilters && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
                className: "rf-px-4 rf-py-1 rf-flex rf-flex-row rf-items-center rf-border rf-rounded-lg rf-border-black",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $bfff57138dc1a66f$export$2e2bcd8739ae039), {
                        className: "rf-h-4 rf-w-4"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-ml-2",
                        children: translation.common.filter
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        ref: divRef,
        className: "rf-absolute rf-z-util large:rf-hidden rf-top-0 rf-left-0 rf-w-full rf-h-full rf-overflow-y-scroll rf-scrollbar-hidden rf-bg-truewhite rf-flex rf-flex-col rf-justify-between",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-flex rf-flex-col rf-justify-start rf-align-center",
                children: currentOpened ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $0e2f37c2f676d402$export$2e2bcd8739ae039), {
                    filter: currentOpened,
                    close: closeCurrentSubFilters,
                    resetFilters: handleReset
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $39db927389ea96c0$export$2e2bcd8739ae039), {
                    setCurrentOpened: setCurrentOpened,
                    close: handleReturn,
                    resetFilters: handleReset
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ea4465c0efadb004$export$2e2bcd8739ae039), {
                onClick: handleDisplayResults
            })
        ]
    });
};
var $a1830188b1d79c71$export$2e2bcd8739ae039 = $a1830188b1d79c71$var$FilterMobile;





var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");



function $c134542dee0be23e$export$2e2bcd8739ae039() {
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const [currentPagination, setCurrentPagination] = (0, $lT7pJ.useState)(10);
    (0, $lT7pJ.useEffect)(()=>{
        if (configuration && currentDeviceType) switch(currentDeviceType){
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).borne:
                setCurrentPagination(configuration.pagination?.borne || 15);
                break;
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).landscape:
                setCurrentPagination(configuration.pagination?.landscape || 20);
                break;
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile:
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget:
                setCurrentPagination(configuration.pagination?.mobile || 12);
                break;
            default:
                break;
        }
        else setCurrentPagination(10);
    }, [
        configuration,
        currentDeviceType
    ]);
    return currentPagination;
}






parcelRequire("lT7pJ");


parcelRequire("lT7pJ");

const $5d44f708beac5bc9$var$NewsAttachment = ({ title: title, subtitle: subtitle, text: text, media: media, height: height })=>{
    const medias = [];
    media && media.forEach((med)=>{
        medias.push({
            url: med.url,
            alt: med.profile || "media"
        });
    });
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-col rf-gap-4 rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText",
        style: {
            height: height,
            touchAction: "pan-y"
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-fit rf-px-2 rf-py-1 large:rf-py-2 rf-small-size-auto rf-uppercase rf-border rf-border-black rf-bg-black rf-text-primary",
                children: title
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-title-size-auto",
                children: subtitle
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-gap-3",
                children: [
                    medias.length > 0 && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-[45%] rf-min-w-[45%] rf-max-w-[45%] rf-flex rf-justify-center rf-aspect-square large:rf-aspect-video",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $04a0ad14abdfdd87$export$2e2bcd8739ae039), {
                            className: "rf-max-h-full rf-max-w-full rf-h-fit rf-w-fit",
                            medias: medias
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-line-clamp-7",
                        children: text
                    })
                ]
            })
        ]
    });
};
var $5d44f708beac5bc9$export$2e2bcd8739ae039 = $5d44f708beac5bc9$var$NewsAttachment;




var $lT7pJ = parcelRequire("lT7pJ");



parcelRequire("lT7pJ");
const $e2a871161dc94629$var$CommentsPennantIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72.258 45",
        className: className || "w-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            transform: "translate(-2203.071 -428.34)",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M11.129,3l2.512,5.089,5.617.821-4.064,3.959.959,5.593-5.024-2.642L6.105,18.461l.959-5.593L3,8.91l5.617-.821Z",
                    transform: "translate(2201.071 426.34)",
                    fill: "none",
                    stroke: color || "#ffffff",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M11.129,3l2.512,5.089,5.617.821-4.064,3.959.959,5.593-5.024-2.642L6.105,18.461l.959-5.593L3,8.91l5.617-.821Z",
                    transform: "translate(2255.071 426.34)",
                    fill: "none",
                    stroke: color || "#ffffff",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M28,11.225A5.775,5.775,0,1,1,22.225,17,5.774,5.774,0,0,1,28,11.225m0,24.75c8.167,0,16.775,4.015,16.775,5.775v3.025H11.225V41.75c0-1.76,8.608-5.775,16.775-5.775M28,6A11,11,0,1,0,39,17,11,11,0,0,0,28,6Zm0,24.75c-7.342,0-22,3.685-22,11V50H50V41.75C50,34.435,35.343,30.75,28,30.75Z",
                    transform: "translate(2211 423.34)",
                    fill: color || "#ffffff"
                })
            ]
        })
    });
};
var $e2a871161dc94629$export$2e2bcd8739ae039 = $e2a871161dc94629$var$CommentsPennantIcon;



parcelRequire("lT7pJ");
const $e196c2553a5ffe2c$var$FavoriteIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: className || "",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 72 72",
            className: "rf-h-full",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M413.444,281.927a24.4,24.4,0,1,0,24.4,24.4A24.4,24.4,0,0,0,413.444,281.927Zm12.233,30.989a51.118,51.118,0,0,1-9.936,9.6l-2.3,1.654-2.3-1.654a51.118,51.118,0,0,1-9.936-9.6,17.7,17.7,0,0,1-3.462-9.826,10.357,10.357,0,0,1,10.227-10.321h.095a10.267,10.267,0,0,1,5.373,1.514,10.271,10.271,0,0,1,5.373-1.514h.095a10.357,10.357,0,0,1,10.226,10.321A17.7,17.7,0,0,1,425.677,312.916Z",
                    transform: "translate(-380.234 -271.942)",
                    fill: "#0c89a2"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M428.741,308.235h-.057a6.436,6.436,0,0,0-5.373,2.941,6.435,6.435,0,0,0-5.373-2.941h-.057a6.394,6.394,0,0,0-6.335,6.391,13.766,13.766,0,0,0,2.7,7.505,47.374,47.374,0,0,0,9.06,8.727,47.369,47.369,0,0,0,9.061-8.727,13.765,13.765,0,0,0,2.7-7.505A6.394,6.394,0,0,0,428.741,308.235Z",
                    transform: "translate(-390.101 -283.478)",
                    fill: "#cb0038"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M379.123,306.092l.984-.568a3.667,3.667,0,1,1-4.851-1.228l.554,1a2.435,2.435,0,0,0-1.228,1.529,2.533,2.533,0,0,0,4.873,1.339A2.519,2.519,0,0,0,379.123,306.092Z",
                            transform: "translate(-373.354 -281.75)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M383.877,292.134a3.579,3.579,0,1,1-4.955,1.283A3.524,3.524,0,0,1,383.877,292.134Zm-.614,1.07a2.35,2.35,0,1,0,1.007,3.281A2.36,2.36,0,0,0,383.263,293.2Z",
                            transform: "translate(-375.577 -276.186)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M388.494,279.91l.851-.864,3.212,3.162a2.729,2.729,0,0,1-3.83,3.889l-3.211-3.163.85-.864,3.1,3.056a1.525,1.525,0,1,0,2.127-2.161Z",
                            transform: "translate(-378.687 -270.679)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M396.125,274.77l2.02-1.306a2.265,2.265,0,1,1,2.457,3.8l-1,.647,1.382,2.138-1.018.658Zm4.181-.008a1.092,1.092,0,0,0-1.664-.248l-.874.564,1.206,1.867.874-.565A1.092,1.092,0,0,0,400.306,274.762Z",
                            transform: "translate(-383.338 -268.046)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M418.982,268.841a3.387,3.387,0,0,1-2.494,4.305l-2.211.575-1.782-6.847,2.211-.576A3.387,3.387,0,0,1,418.982,268.841Zm-1.194.311a2.247,2.247,0,0,0-2.772-1.743l-1.056.275,1.2,4.617,1.057-.275A2.254,2.254,0,0,0,417.788,269.151Z",
                            transform: "translate(-390.516 -265.032)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M427.818,267.132l2.828-.109.044,1.151-2.827.11.073,1.9,3.132-.122.044,1.151-4.343.17-.275-7.07,4.282-.167.045,1.151-3.07.12Z",
                            transform: "translate(-396.655 -264.145)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M446.9,272.151l.56.988a3.666,3.666,0,1,1,1.268-4.839l-1.006.544a2.431,2.431,0,0,0-1.518-1.239,2.532,2.532,0,0,0-1.38,4.86A2.519,2.519,0,0,0,446.9,272.151Z",
                            transform: "translate(-403.416 -265.121)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M460.445,277.009a3.579,3.579,0,1,1-1.242-4.964A3.523,3.523,0,0,1,460.445,277.009Zm-1.064-.622a2.35,2.35,0,1,0-3.289.98A2.361,2.361,0,0,0,459.381,276.386Z",
                            transform: "translate(-408.594 -267.384)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M467.155,281.565l2.048,1.953-.8.834L466.36,282.4l-1.311,1.375,2.268,2.162-.8.834-3.145-3,4.882-5.12,3.1,2.957-.8.834-2.224-2.12Z",
                            transform: "translate(-412.827 -270.506)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M478.916,290.648l.678,1.006-3.737,2.52a2.729,2.729,0,0,1-3.052-4.525l3.738-2.521.678,1.006-3.612,2.435a1.525,1.525,0,1,0,1.7,2.514Z",
                            transform: "translate(-416.422 -274.223)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M482.854,299.49l.848,2.165a2.168,2.168,0,0,1-1.2,2.987,2.045,2.045,0,0,1-2.552-.694l-1.915,2.649-.516-1.317,1.873-2.535-.2-.518-2.485.973-.442-1.129Zm-.8,4c.649-.254.8-.835.518-1.56l-.351-.894-1.957.766.35.894C480.9,303.425,481.406,303.748,482.055,303.494Z",
                            transform: "translate(-418.479 -279.643)",
                            fill: "#161615"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                    transform: "translate(4.89 51.981)",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M384.888,365.352l-.9-1.038.58-.5a2.025,2.025,0,0,1-1.846-.74,3.084,3.084,0,0,1,4.657-4.019,2.09,2.09,0,0,1,.5,1.753l3.1-2.68.969,1.122Zm1.911-3.608a1.623,1.623,0,0,0-.294-1.589,1.695,1.695,0,0,0-2.562,2.211,1.621,1.621,0,0,0,1.529.524Z",
                            transform: "translate(-382.062 -357.324)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M397.773,372.316c-.066.09-.2.269-.337.442l-3.535-2.577a1.672,1.672,0,0,0,.629,1.927,2.359,2.359,0,0,0,1.648.467l-.057,1.335a3.75,3.75,0,0,1-2.392-.7,3.078,3.078,0,0,1-.733-4.342,2.949,2.949,0,1,1,4.777,3.452Zm-.893-1.293a1.481,1.481,0,0,0-2.346-1.71Z",
                            transform: "translate(-386.596 -361.465)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M412.418,369.575l1.391.51-3.215,8.768-1.391-.511Z",
                            transform: "translate(-393.963 -362.355)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M418.264,372.236l1.265.337-.784,2.936-1.265-.337Z",
                            transform: "translate(-397.592 -363.522)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M426.423,379.222c-.013.111-.039.331-.076.551l-4.344-.5a1.671,1.671,0,0,0,1.5,1.366,2.353,2.353,0,0,0,1.662-.407l.61,1.188a3.749,3.749,0,0,1-2.427.568,3.077,3.077,0,0,1-2.779-3.414,2.948,2.948,0,1,1,5.857.646Zm-1.414-.684a1.481,1.481,0,0,0-2.884-.33Zm.961-5.025-2.384,1.816-.842-1,2.343-1.895Z",
                            transform: "translate(-398.936 -363.608)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M438.911,378.258l.963,8.642-1.473.164-.382-3.425a2.092,2.092,0,0,1-1.561.933,3.084,3.084,0,0,1-.682-6.114,2.123,2.123,0,0,1,1.857.713l-.085-.761Zm-1.247,2.2a1.62,1.62,0,0,0-1.477-.655,1.694,1.694,0,0,0,.375,3.363,1.623,1.623,0,0,0,1.3-.965Z",
                            transform: "translate(-404.51 -366.163)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M447.021,379.887l-1.251-3.581,1.4-.489,1.117,3.2a1.053,1.053,0,0,0,1.5.783,1.442,1.442,0,0,0,.86-1.06l-1.288-3.686,1.4-.489,1.933,5.529-1.307.457-.281-.805a2.111,2.111,0,0,1-4.086.145Z",
                            transform: "translate(-409.996 -364.542)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M455.552,367.9a.976.976,0,1,1-.385,1.325A.97.97,0,0,1,455.552,367.9Zm.73,2.869,1.3-.714,2.819,5.132-1.3.714Z",
                            transform: "translate(-414.063 -361.567)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M463.272,367.506l.478.6a2.125,2.125,0,0,1,.809-1.818,3.086,3.086,0,0,1,3.842,4.807,2.089,2.089,0,0,1-1.764.445l2.152,2.694-1.159.926-5.43-6.8Zm2.462,2.9a1.625,1.625,0,0,0,1.6-.234,1.7,1.7,0,0,0-2.114-2.645,1.623,1.623,0,0,0-.582,1.509Z",
                            transform: "translate(-417.201 -360.651)",
                            fill: "#161615"
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                            d: "M478.073,357.422c.086.069.261.207.427.355l-2.719,3.423a1.67,1.67,0,0,0,1.95-.549,2.354,2.354,0,0,0,.535-1.626l1.332.111a3.751,3.751,0,0,1-.8,2.36,3.077,3.077,0,0,1-4.367.551,2.947,2.947,0,1,1,3.646-4.626Zm-1.327.837a1.481,1.481,0,0,0-1.806,2.273Z",
                            transform: "translate(-422.028 -356.717)",
                            fill: "#161615"
                        })
                    ]
                })
            ]
        })
    });
};
var $e196c2553a5ffe2c$export$2e2bcd8739ae039 = $e196c2553a5ffe2c$var$FavoriteIcon;



parcelRequire("lT7pJ");
const $a9b3588047086a07$var$FavoriteLightIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 56 55",
        className: className || "rf-h-full",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            transform: "translate(0.465 -0.307)",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("ellipse", {
                    cx: "28",
                    cy: "27.5",
                    rx: "28",
                    ry: "27.5",
                    transform: "translate(-0.465 0.307)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M449.065,485.074a24.475,24.475,0,1,0,24.476,24.476A24.475,24.475,0,0,0,449.065,485.074Zm12.272,31.086a51.307,51.307,0,0,1-9.969,9.625l-2.3,1.659-2.3-1.659a51.425,51.425,0,0,1-9.966-9.625,17.755,17.755,0,0,1-3.474-9.857,10.391,10.391,0,0,1,10.26-10.353h.1a10.28,10.28,0,0,1,5.387,1.52,10.291,10.291,0,0,1,5.39-1.52h.1A10.388,10.388,0,0,1,464.808,506.3,17.75,17.75,0,0,1,461.337,516.16Z",
                    transform: "translate(-421.48 -482.143)",
                    fill: "#0c89a2"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M445.93,489.861h-.056a6.46,6.46,0,0,0-5.39,2.947,6.45,6.45,0,0,0-5.387-2.947h-.059a6.412,6.412,0,0,0-6.353,6.409A13.817,13.817,0,0,0,431.4,503.8a47.5,47.5,0,0,0,9.086,8.752,47.479,47.479,0,0,0,9.09-8.752,13.817,13.817,0,0,0,2.712-7.529A6.413,6.413,0,0,0,445.93,489.861Z",
                    transform: "translate(-412.899 -472.11)",
                    fill: "#cb0038"
                })
            ]
        })
    });
};
var $a9b3588047086a07$export$2e2bcd8739ae039 = $a9b3588047086a07$var$FavoriteLightIcon;



parcelRequire("lT7pJ");
const $2e1dd88327c4752d$var$PhoneIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 40",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
            transform: "translate(-183.86 -57.462) rotate(-21)",
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                d: "M162.1,156.952a2.852,2.852,0,0,0,2.91-2.915V127.8a2.851,2.851,0,0,0-2.91-2.915H151.91A2.851,2.851,0,0,0,149,127.8v26.233a2.852,2.852,0,0,0,2.91,2.915ZM157,155.738a1.455,1.455,0,1,1,1.455-1.455A1.456,1.456,0,0,1,157,155.738Zm-2.183-29.072c0-.18.086-.322.194-.322h3.978c.106,0,.194.144.194.322v.086c0,.18-.087.322-.194.322h-3.978c-.106,0-.194-.144-.194-.322Zm-4.365,1.861h13.1V151.81h-13.1Zm0,0"
            })
        })
    });
};
var $2e1dd88327c4752d$export$2e2bcd8739ae039 = $2e1dd88327c4752d$var$PhoneIcon;



parcelRequire("lT7pJ");
const $be3ed64073db5571$var$PhotoCameraIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 67.258 60.532",
        className: className || "rf-w-6 rf-h-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            transform: "translate(15.629 13.766)",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M34.722,23.961A10.761,10.761,0,1,1,23.961,13.2,10.761,10.761,0,0,1,34.722,23.961Z",
                    transform: "translate(-5.961 -4.098)",
                    fill: color || "#f1f1f1"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M26.54,3,20.386,9.726H9.726A6.746,6.746,0,0,0,3,16.452V56.806a6.746,6.746,0,0,0,6.726,6.726H63.532a6.746,6.746,0,0,0,6.726-6.726V16.452a6.746,6.746,0,0,0-6.726-6.726H52.872L46.718,3ZM36.629,53.443A16.814,16.814,0,1,1,53.443,36.629,16.821,16.821,0,0,1,36.629,53.443Z",
                    transform: "translate(-18.629 -16.766)",
                    fill: color || "#f1f1f1"
                })
            ]
        })
    });
};
var $be3ed64073db5571$export$2e2bcd8739ae039 = $be3ed64073db5571$var$PhotoCameraIcon;



parcelRequire("lT7pJ");
const $8020f0ddfe1ce5ff$var$PrintIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24.578 24.578",
        className: className || "rf-h-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            transform: "translate(0.5 0.5)",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M9,11.252V3H23.147v8.252",
                    transform: "translate(-4.284 -3)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M7.716,24.11H5.358A2.358,2.358,0,0,1,3,21.752V15.858A2.358,2.358,0,0,1,5.358,13.5H24.221a2.358,2.358,0,0,1,2.358,2.358v5.895a2.358,2.358,0,0,1-2.358,2.358H21.863",
                    transform: "translate(-3 -5.248)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M9,21H23.147v9.431H9Z",
                    transform: "translate(-4.284 -6.853)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
};
var $8020f0ddfe1ce5ff$export$2e2bcd8739ae039 = $8020f0ddfe1ce5ff$var$PrintIcon;



parcelRequire("lT7pJ");
const $8c84d47da720aa29$var$RoundIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20.306 20.306",
        className: className || "rf-h-4",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
            transform: "translate(-2 -2)",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M21.306,12.153A9.153,9.153,0,1,1,12.153,3a9.153,9.153,0,0,1,9.153,9.153Z",
                    transform: "translate(0 0)",
                    fill: "none",
                    stroke: color || "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M18,21.661V18",
                    transform: "translate(-5.847 -5.847)",
                    fill: "none",
                    stroke: color || "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                    d: "M18,12h0",
                    transform: "translate(-5.847 -3.508)",
                    fill: "none",
                    stroke: color || "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2"
                })
            ]
        })
    });
};
var $8c84d47da720aa29$export$2e2bcd8739ae039 = $8c84d47da720aa29$var$RoundIcon;






var $lT7pJ = parcelRequire("lT7pJ");


const $8c31c39fe565a3e2$var$CommentsPennant = ({ className: className, customerReviews: customerReviews })=>{
    const { color: color } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const [widthInPx, setWidthInPx] = (0, $lT7pJ.useState)(0);
    const pennantRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        if (pennantRef.current) setWidthInPx(Math.ceil(pennantRef.current.offsetWidth / 2));
    }, [
        pennantRef
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `${className} rf-flex rf-flex-col rf-justify-center rf-text-white`,
        ref: pennantRef,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-center rf-p-1",
                style: {
                    backgroundColor: color
                },
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e2a871161dc94629$export$2e2bcd8739ae039), {
                        className: "rf-w-6 large:rf-w-8 rf-py-2 vertical:rf-py-1"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-font-bold rf-small-size-auto rf-text-center",
                        children: [
                            customerReviews,
                            "/10"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-0 rf-h-0 rf-border-t-0 rf-border-x-primary rf-border-b-transparent",
                style: {
                    borderLeftColor: color,
                    borderRightColor: color,
                    borderBottomWidth: widthInPx * 2 / 3,
                    borderLeftWidth: widthInPx,
                    borderRightWidth: widthInPx
                }
            })
        ]
    });
};
var $8c31c39fe565a3e2$export$2e2bcd8739ae039 = $8c31c39fe565a3e2$var$CommentsPennant;


const $a1a8df2de4f5d186$var$ReviewsAndFavorite = ({ reviews: reviews, favorite: favorite })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            reviews && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8c31c39fe565a3e2$export$2e2bcd8739ae039), {
                customerReviews: reviews,
                className: "rf-absolute rf-top-0 rf-right-2"
            }),
            favorite && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a9b3588047086a07$export$2e2bcd8739ae039), {
                className: "rf-absolute rf-h-6 large:rf-h-8 rf-bottom-2 rf-right-2"
            })
        ]
    });
};
const $a1a8df2de4f5d186$var$POIAttachment = ({ media: media, title: title, subtitle: subtitle, favorite: favorite, customerReviews: customerReviews, tap: tap, distance: distance })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const handleClick = ()=>{
        tap && (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, tap);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-rounded hover:rf-cursor-pointer",
        onClick: handleClick,
        children: [
            media && media[0]?.url ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-relative rf-w-full rf-rounded rf-aspect-video",
                style: {
                    backgroundImage: `url(${media[0].url.replaceAll("'", "%27")})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center"
                },
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($a1a8df2de4f5d186$var$ReviewsAndFavorite, {
                    reviews: customerReviews,
                    favorite: favorite
                })
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-relative rf-w-full rf-bg-silver rf-rounded rf-aspect-video",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $be3ed64073db5571$export$2e2bcd8739ae039), {
                        className: "rf-absolute rf-h-1/3 rf-top-1/3 rf-left-1/2 rf-transform -rf-translate-x-1/2"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($a1a8df2de4f5d186$var$ReviewsAndFavorite, {
                        reviews: customerReviews,
                        favorite: favorite
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                className: "rf-mt-2 rf-font-bold rf-line-clamp-2",
                style: {
                    color: themeColors.agendaColor
                },
                children: subtitle
            }),
            distance && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                className: "rf-mt-2 rf-font-bold rf-text-gray",
                children: `${(distance / 1000).toFixed(1)} km`
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                className: "rf-my-2 rf-font-bold rf-line-clamp-2",
                children: title || ""
            })
        ]
    });
};
var $a1a8df2de4f5d186$export$2e2bcd8739ae039 = $a1a8df2de4f5d186$var$POIAttachment;



parcelRequire("lT7pJ");
const $f1ef0a7797aa40fb$var$EmptyAttachment = ()=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-gap-2 rf-rounded",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            className: "rf-relative rf-w-full rf-bg-templateEmptyCard rf-rounded rf-aspect-video"
        })
    });
};
var $f1ef0a7797aa40fb$export$2e2bcd8739ae039 = $f1ef0a7797aa40fb$var$EmptyAttachment;




var $lT7pJ = parcelRequire("lT7pJ");




parcelRequire("lT7pJ");



const $603052b471735dfc$var$DisplayFullScreenButton = ({ url: url })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const handleClick = ()=>{
        (0, $1bda010252da638c$export$4e062bd31c814155)(url);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-absolute rf-right-2 rf-top-2 rf-p-2 rf-border rf-rounded-lg rf-bg-cardFrameBackground rf-bg-opacity-30 rf-border-cardButtonBorderDefault hover:rf-cursor-pointer",
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $699fdce34d546ff4$export$2e2bcd8739ae039), {
            className: "rf-h-4 rf-w-4 large:rf-h-6 large:rf-w-6",
            color: themeColors.card.button.text.default
        })
    });
};
var $603052b471735dfc$export$2e2bcd8739ae039 = $603052b471735dfc$var$DisplayFullScreenButton;


const $86b4dd20fa27be48$var$ImageAttachment = ({ url: url, title: title, alt: alt, isMiniature: isMiniature, height: height })=>{
    const displaySubtitles = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.displaySubtitles);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const currentHeight = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentHeight);
    const [maxHeight, setMaxHeight] = (0, $lT7pJ.useState)(0);
    (0, $lT7pJ.useEffect)(()=>{
        if (currentHeight && currentDeviceType) switch(currentDeviceType){
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile:
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget:
                setMaxHeight(Math.floor(currentHeight * (displaySubtitles ? 0.34 : 0.5)));
                break;
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).landscape:
                setMaxHeight(Math.floor(currentHeight * 0.67));
                break;
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).borne:
                setMaxHeight(Math.floor(currentHeight * 0.34));
                break;
            default:
                break;
        }
    }, [
        currentHeight,
        currentDeviceType,
        displaySubtitles
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-row rf-items-center rf-justify-center rf-rounded rf-bg-cardFrameBackground",
        style: {
            height: height,
            touchAction: "pan-y"
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $603052b471735dfc$export$2e2bcd8739ae039), {
                url: url
            }),
            isMiniature ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-1/4"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                        className: "rf-max-w-1/2",
                        src: url,
                        alt: alt || "image",
                        style: {
                            maxHeight: `calc(${maxHeight}px - 3rem)`
                        }
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-1/4"
                    })
                ]
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                className: "rf-max-w-full",
                src: url,
                alt: alt || "image",
                style: {
                    maxHeight: `calc(${maxHeight}px - 3rem)`
                }
            }),
            title && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-absolute rf-bottom-0 rf-py-2 rf-text-center rf-text-sm large:rf-text-base rf-text-cardFrameText rf-bg-cardFrameBackground rf-bg-opacity-80 rf-rounded-b rf-w-full",
                children: title
            })
        ]
    });
};
var $86b4dd20fa27be48$export$2e2bcd8739ae039 = $86b4dd20fa27be48$var$ImageAttachment;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");





const $412d46e5db76a0eb$export$2eb1c1cc4b12d451 = ({ translation: translation, isUsedOnBorne: isUsedOnBorne, data: data, fileName: fileName })=>{
    let textToDisplay = "";
    if (isUsedOnBorne) {
        if (data.download) {
            if (data.title) textToDisplay = `${translation.common.download} \u00ab ${fileName} \u00bb`;
            else textToDisplay = translation.common.download;
        } else textToDisplay = translation.link.goto;
        textToDisplay += ` ${translation.link.scanQR}`;
    } else if (data.download) {
        if (data.title) textToDisplay = `${translation.common.download} ${fileName}`;
        else textToDisplay = translation.common.download;
    } else textToDisplay = translation.link.click;
    return textToDisplay;
};



const $321ecf0344ece19a$export$a6f11fce0a840e6c = (url)=>{
    const [lastPart] = url.split("/").slice(-1);
    if (lastPart && lastPart.length > 4 && lastPart.includes(".")) return lastPart;
    return undefined;
};



parcelRequire("lT7pJ");


const $76460312b79c28bb$var$ClassicButton = ({ url: url, text: text, description: description, download: download })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-w-full rf-flex ${description ? "rf-justify-start" : "rf-justify-center"}`,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "rf-card-button rf-flex rf-flex-row rf-items-center",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-h-6 rf-w-6",
                    children: download ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $378d08b46762921f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4365628ed5afaad5$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-ml-2 rf-truncate",
                    children: text || ""
                })
            ]
        })
    });
};
var $76460312b79c28bb$export$2e2bcd8739ae039 = $76460312b79c28bb$var$ClassicButton;




var $lT7pJ = parcelRequire("lT7pJ");



const $33e594b7da788c68$var$BorderlessButton = ({ url: url, text: text, download: download })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const [hover, setHover] = (0, $lT7pJ.useState)(false);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-flex rf-justify-start",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-start rf-text-cardButtonTextDefault",
            onPointerEnter: ()=>setHover(true),
            onPointerLeave: ()=>setHover(false),
            onClick: ()=>setHover(true),
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: `rf-h-6 rf-w-6 rf-rounded ${hover ? "rf-bg-cardButtonBackgroundHover" : "rf-bg-cardButtonBackgroundDefault"}`,
                    children: download ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $378d08b46762921f$export$2e2bcd8739ae039), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4365628ed5afaad5$export$2e2bcd8739ae039), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    })
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-ml-4",
                    children: text || ""
                })
            ]
        })
    });
};
var $33e594b7da788c68$export$2e2bcd8739ae039 = $33e594b7da788c68$var$BorderlessButton;





var $lT7pJ = parcelRequire("lT7pJ");
const $afe82365b658f5fb$var$QRCodeComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).forwardRef(({ src: src, alt: alt }, ref)=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
        ref: ref,
        src: src,
        className: "rf-h-full rf-max-h-qrcode",
        alt: alt || "QR Code"
    });
});
var $afe82365b658f5fb$export$2e2bcd8739ae039 = $afe82365b658f5fb$var$QRCodeComponent;




var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");

var $34c68c68178c12ec$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $34c68c68178c12ec$export$84fe03429ed1b6d6 = [
    "onCopy",
    "onCut",
    "onPaste"
];
var $34c68c68178c12ec$export$dbc46161504615f7 = [
    "onCompositionEnd",
    "onCompositionStart",
    "onCompositionUpdate"
];
var $34c68c68178c12ec$export$fb6351c2666f0875 = [
    "onFocus",
    "onBlur"
];
var $34c68c68178c12ec$export$4e58c1a9761ed81a = [
    "onInput",
    "onInvalid",
    "onReset",
    "onSubmit"
];
var $34c68c68178c12ec$export$3bf7402f2a4eb3af = [
    "onLoad",
    "onError"
];
var $34c68c68178c12ec$export$409c4891d97f97cf = [
    "onKeyDown",
    "onKeyPress",
    "onKeyUp"
];
var $34c68c68178c12ec$export$6be5aa2386088264 = [
    "onAbort",
    "onCanPlay",
    "onCanPlayThrough",
    "onDurationChange",
    "onEmptied",
    "onEncrypted",
    "onEnded",
    "onError",
    "onLoadedData",
    "onLoadedMetadata",
    "onLoadStart",
    "onPause",
    "onPlay",
    "onPlaying",
    "onProgress",
    "onRateChange",
    "onSeeked",
    "onSeeking",
    "onStalled",
    "onSuspend",
    "onTimeUpdate",
    "onVolumeChange",
    "onWaiting"
];
var $34c68c68178c12ec$export$3a6e2b8954613992 = [
    "onClick",
    "onContextMenu",
    "onDoubleClick",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp"
];
var $34c68c68178c12ec$export$6c96379d5b8a2df7 = [
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop"
];
var $34c68c68178c12ec$export$d93346aa7735a637 = [
    "onSelect"
];
var $34c68c68178c12ec$export$fa367689c659e65c = [
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart"
];
var $34c68c68178c12ec$export$c731eab7619e00a0 = [
    "onPointerDown",
    "onPointerMove",
    "onPointerUp",
    "onPointerCancel",
    "onGotPointerCapture",
    "onLostPointerCapture",
    "onPointerEnter",
    "onPointerLeave",
    "onPointerOver",
    "onPointerOut"
];
var $34c68c68178c12ec$export$bac3087b5cb826f6 = [
    "onScroll"
];
var $34c68c68178c12ec$export$28298837799e00e8 = [
    "onWheel"
];
var $34c68c68178c12ec$export$6ff45424014e7407 = [
    "onAnimationStart",
    "onAnimationEnd",
    "onAnimationIteration"
];
var $34c68c68178c12ec$export$78878fc7bd50dc3e = [
    "onTransitionEnd"
];
var $34c68c68178c12ec$export$477a88c5b93a108d = [
    "onToggle"
];
var $34c68c68178c12ec$export$7212b61f9f58bd1 = [
    "onChange"
];
var $34c68c68178c12ec$export$59ef7197c4d7b9dc = $34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray($34c68c68178c12ec$var$__spreadArray([], $34c68c68178c12ec$export$84fe03429ed1b6d6, true), $34c68c68178c12ec$export$dbc46161504615f7, true), $34c68c68178c12ec$export$fb6351c2666f0875, true), $34c68c68178c12ec$export$4e58c1a9761ed81a, true), $34c68c68178c12ec$export$3bf7402f2a4eb3af, true), $34c68c68178c12ec$export$409c4891d97f97cf, true), $34c68c68178c12ec$export$6be5aa2386088264, true), $34c68c68178c12ec$export$3a6e2b8954613992, true), $34c68c68178c12ec$export$6c96379d5b8a2df7, true), $34c68c68178c12ec$export$d93346aa7735a637, true), $34c68c68178c12ec$export$fa367689c659e65c, true), $34c68c68178c12ec$export$c731eab7619e00a0, true), $34c68c68178c12ec$export$bac3087b5cb826f6, true), $34c68c68178c12ec$export$28298837799e00e8, true), $34c68c68178c12ec$export$6ff45424014e7407, true), $34c68c68178c12ec$export$78878fc7bd50dc3e, true), $34c68c68178c12ec$export$7212b61f9f58bd1, true), $34c68c68178c12ec$export$477a88c5b93a108d, true);
function $34c68c68178c12ec$export$2e2bcd8739ae039(props, getArgs) {
    var eventProps = {};
    $34c68c68178c12ec$export$59ef7197c4d7b9dc.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}


function $40732ba5c834a61e$export$2e2bcd8739ae039(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(value) {
            return !isCancelled && resolve(value);
        }).catch(function(error) {
            return !isCancelled && reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: function() {
            isCancelled = true;
        }
    };
}


function $4eca29e56ecefe31$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $4eca29e56ecefe31$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $4eca29e56ecefe31$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $4eca29e56ecefe31$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4eca29e56ecefe31$export$2e2bcd8739ae039 = $4eca29e56ecefe31$export$4f5d2d50c9deca37;


var $2aed2c497b6a5412$var$isProduction = true;
var $2aed2c497b6a5412$var$prefix = "Invariant failed";
function $2aed2c497b6a5412$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($2aed2c497b6a5412$var$isProduction) throw new Error($2aed2c497b6a5412$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($2aed2c497b6a5412$var$prefix, ": ").concat(provided) : $2aed2c497b6a5412$var$prefix;
    throw new Error(value);
}


var $1db38723adbcd089$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $1db38723adbcd089$var$__DEV__ = false;
var $1db38723adbcd089$var$warning = function() {};
if ($1db38723adbcd089$var$__DEV__) {
    var $1db38723adbcd089$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $1db38723adbcd089$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $1db38723adbcd089$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$1db38723adbcd089$exports = $1db38723adbcd089$var$warning;


var $ba29b9ffe2caefdb$var$has = Object.prototype.hasOwnProperty;
function $ba29b9ffe2caefdb$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($ba29b9ffe2caefdb$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $ba29b9ffe2caefdb$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $ba29b9ffe2caefdb$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === "object") {
                    tmp = $ba29b9ffe2caefdb$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === "object") {
                    tmp = $ba29b9ffe2caefdb$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$ba29b9ffe2caefdb$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($ba29b9ffe2caefdb$var$has.call(foo, ctor) && ++len && !$ba29b9ffe2caefdb$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$ba29b9ffe2caefdb$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $9GcjX = parcelRequire("9GcjX");
const $b5ae944e35783420$var$pdfjs = "default" in $9GcjX ? $9GcjX["default"] : $9GcjX;
var $b5ae944e35783420$export$2e2bcd8739ae039 = $b5ae944e35783420$var$pdfjs;



var $lT7pJ = parcelRequire("lT7pJ");
"use client";
var $b230659291ba3981$export$2e2bcd8739ae039 = (0, $lT7pJ.createContext)(null);



var $lT7pJ = parcelRequire("lT7pJ");
function $31339d565a044e37$export$2e2bcd8739ae039({ children: children, type: type }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("div", {
        className: `react-pdf__message react-pdf__message--${type}`
    }, children);
}


/* Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $76911c8e19adc63a$var$DEFAULT_LINK_REL = "noopener noreferrer nofollow";
class $76911c8e19adc63a$export$2e2bcd8739ae039 {
    constructor(){
        this.externalLinkEnabled = true;
        this.externalLinkRel = undefined;
        this.externalLinkTarget = undefined;
        this.isInPresentationMode = false;
        this.pdfDocument = undefined;
        this.pdfViewer = undefined;
    }
    setDocument(pdfDocument) {
        this.pdfDocument = pdfDocument;
    }
    setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }
    setExternalLinkRel(externalLinkRel) {
        this.externalLinkRel = externalLinkRel;
    }
    setExternalLinkTarget(externalLinkTarget) {
        this.externalLinkTarget = externalLinkTarget;
    }
    setHistory() {
    // Intentionally empty
    }
    get pagesCount() {
        return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
    get page() {
        (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
        return this.pdfViewer.currentPageNumber || 0;
    }
    set page(value) {
        (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
        this.pdfViewer.currentPageNumber = value;
    }
    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    get rotation() {
        return 0;
    }
    set rotation(value) {
    // Intentionally empty
    }
    goToDestination(dest) {
        return new Promise((resolve)=>{
            (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(this.pdfDocument, "PDF document not loaded.");
            (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(dest, "Destination is not specified.");
            if (typeof dest === "string") this.pdfDocument.getDestination(dest).then(resolve);
            else if (Array.isArray(dest)) resolve(dest);
            else dest.then(resolve);
        }).then((explicitDest)=>{
            (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(Array.isArray(explicitDest), `"${explicitDest}" is not a valid destination array.`);
            const destRef = explicitDest[0];
            new Promise((resolve)=>{
                (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(this.pdfDocument, "PDF document not loaded.");
                if (destRef instanceof Object) this.pdfDocument.getPageIndex(destRef).then((pageIndex)=>{
                    resolve(pageIndex);
                }).catch(()=>{
                    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(false, `"${destRef}" is not a valid page reference.`);
                });
                else if (typeof destRef === "number") resolve(destRef);
                else (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(false, `"${destRef}" is not a valid destination reference.`);
            }).then((pageIndex)=>{
                const pageNumber = pageIndex + 1;
                (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
                (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
                this.pdfViewer.scrollPageIntoView({
                    dest: explicitDest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            });
        });
    }
    navigateTo(dest) {
        this.goToDestination(dest);
    }
    goToPage(pageNumber) {
        const pageIndex = pageNumber - 1;
        (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
        (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
        this.pdfViewer.scrollPageIntoView({
            pageIndex: pageIndex,
            pageNumber: pageNumber
        });
    }
    addLinkAttributes(link, url, newWindow) {
        link.href = url;
        link.rel = this.externalLinkRel || $76911c8e19adc63a$var$DEFAULT_LINK_REL;
        link.target = newWindow ? "_blank" : this.externalLinkTarget || "";
    }
    getDestinationHash() {
        return "#";
    }
    getAnchorUrl() {
        return "#";
    }
    setHash() {
    // Intentionally empty
    }
    executeNamedAction() {
    // Intentionally empty
    }
    cachePageRef() {
    // Intentionally empty
    }
    isPageVisible() {
        return true;
    }
    isPageCached() {
        return true;
    }
    executeSetOCGState() {
    // Intentionally empty
    }
}


// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
const $958a8d2f15d4c2d7$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $958a8d2f15d4c2d7$export$2e2bcd8739ae039 = $958a8d2f15d4c2d7$var$PasswordResponses;




const $6a883133d725d0f3$export$4e09c449d6c407f7 = typeof document !== "undefined";
const $6a883133d725d0f3$export$d528e4159a0e221e = $6a883133d725d0f3$export$4e09c449d6c407f7 && window.location.protocol === "file:";
function $6a883133d725d0f3$export$4e62c701997796c1(variable) {
    return typeof variable !== "undefined";
}
function $6a883133d725d0f3$export$ef8866826b0b1f6d(variable) {
    return $6a883133d725d0f3$export$4e62c701997796c1(variable) && variable !== null;
}
function $6a883133d725d0f3$export$844ec244b1367d54(variable) {
    return typeof variable === "string";
}
function $6a883133d725d0f3$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $6a883133d725d0f3$export$5bcd6e94ed871c88(variable) {
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)($6a883133d725d0f3$export$4e09c449d6c407f7, "isBlob can only be used in a browser environment");
    return variable instanceof Blob;
}
function $6a883133d725d0f3$export$4d82193ef6a8d75c(variable) {
    return $6a883133d725d0f3$export$844ec244b1367d54(variable) && /^data:/.test(variable);
}
function $6a883133d725d0f3$export$c1553384119518c3(dataURI) {
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)($6a883133d725d0f3$export$4d82193ef6a8d75c(dataURI), "Invalid data URI.");
    const [headersString = "", dataString = ""] = dataURI.split(",");
    const headers = headersString.split(";");
    if (headers.indexOf("base64") !== -1) return atob(dataString);
    return unescape(dataString);
}
function $6a883133d725d0f3$export$cf4a949e5ad681d() {
    return $6a883133d725d0f3$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
const $6a883133d725d0f3$var$allowFileAccessFromFilesTip = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function $6a883133d725d0f3$export$84884c3182d1bdda() {
    (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(!$6a883133d725d0f3$export$d528e4159a0e221e, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${$6a883133d725d0f3$var$allowFileAccessFromFilesTip}`);
}
function $6a883133d725d0f3$export$e7ec4a9e2d586a77() {
    (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(!$6a883133d725d0f3$export$d528e4159a0e221e, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${$6a883133d725d0f3$var$allowFileAccessFromFilesTip}`);
}
function $6a883133d725d0f3$export$b8c3f1dffc289352(runningTask) {
    if (runningTask && runningTask.cancel) runningTask.cancel();
}
function $6a883133d725d0f3$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, "width", {
        get () {
            return this.view[2] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "height", {
        get () {
            return this.view[3] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "originalWidth", {
        get () {
            return this.view[2];
        },
        configurable: true
    });
    Object.defineProperty(page, "originalHeight", {
        get () {
            return this.view[3];
        },
        configurable: true
    });
    return page;
}
function $6a883133d725d0f3$export$99075c4d008e6ab1(error) {
    return error.name === "RenderingCancelledException";
}
function $6a883133d725d0f3$export$21fedb3a7a137f3d(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            if (!reader.result) return reject(new Error("Error while reading a file."));
            resolve(reader.result);
        };
        reader.onerror = (event)=>{
            if (!event.target) return reject(new Error("Error while reading a file."));
            const { error: error } = event.target;
            if (!error) return reject(new Error("Error while reading a file."));
            switch(error.code){
                case error.NOT_FOUND_ERR:
                    return reject(new Error("Error while reading a file: File not found."));
                case error.SECURITY_ERR:
                    return reject(new Error("Error while reading a file: Security error."));
                case error.ABORT_ERR:
                    return reject(new Error("Error while reading a file: Aborted."));
                default:
                    return reject(new Error("Error while reading a file."));
            }
        };
        reader.readAsArrayBuffer(file);
    });
}



var $lT7pJ = parcelRequire("lT7pJ");
function $fde22d935e3a5987$var$reducer(state, action) {
    switch(action.type){
        case "RESOLVE":
            return {
                value: action.value,
                error: undefined
            };
        case "REJECT":
            return {
                value: false,
                error: action.error
            };
        case "RESET":
            return {
                value: undefined,
                error: undefined
            };
        default:
            return state;
    }
}
function $fde22d935e3a5987$export$2e2bcd8739ae039() {
    return (0, $lT7pJ.useReducer)($fde22d935e3a5987$var$reducer, {
        value: undefined,
        error: undefined
    });
}







const { PDFDataRangeTransport: $5f256c83f1a297c6$var$PDFDataRangeTransport } = (0, $b5ae944e35783420$export$2e2bcd8739ae039);
const $5f256c83f1a297c6$export$1e08905474334888 = (()=>{
    const result = {};
    (0, $34c68c68178c12ec$export$59ef7197c4d7b9dc).forEach((eventName)=>{
        result[eventName] = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func;
    });
    return result;
})();
const $5f256c83f1a297c6$var$isTypedArray = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Int8Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Uint8Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Uint8ClampedArray),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Int16Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Uint16Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Int32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Uint32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Float32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Float64Array)
]);
const $5f256c83f1a297c6$var$fileTypes = [
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(ArrayBuffer),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(ArrayBuffer),
            (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number.isRequired),
            $5f256c83f1a297c6$var$isTypedArray
        ]).isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).shape({
        range: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf($5f256c83f1a297c6$var$PDFDataRangeTransport).isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).shape({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string.isRequired
    })
];
if (typeof Blob !== "undefined") $5f256c83f1a297c6$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf(Blob));
const $5f256c83f1a297c6$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string)
]);
const $5f256c83f1a297c6$export$be78b3111c50efdd = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOfType($5f256c83f1a297c6$var$fileTypes);
const $5f256c83f1a297c6$export$836c1083c8eb7ae = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).instanceOf((0, $76911c8e19adc63a$export$2e2bcd8739ae039));
const $5f256c83f1a297c6$export$4d23df922dd97db8 = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOf([
    "_self",
    "_blank",
    "_parent",
    "_top"
]);
const $5f256c83f1a297c6$export$61d82a1ff85c609a = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).shape({
    commonObjs: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).shape({}).isRequired,
    getAnnotations: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func.isRequired,
    getTextContent: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func.isRequired,
    getViewport: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func.isRequired,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func.isRequired
});
const $5f256c83f1a297c6$export$7b4c8bd6e6871332 = function isPageIndex(props, propName, componentName) {
    const { [propName]: pageIndex, pageNumber: pageNumber, pdf: pdf } = props;
    if (!(0, $6a883133d725d0f3$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $6a883133d725d0f3$export$4e62c701997796c1)(pageIndex)) {
        if (typeof pageIndex !== "number") return new Error(`\`${propName}\` of type \`${typeof pageIndex}\` supplied to \`${componentName}\`, expected \`number\`.`);
        if (pageIndex < 0) return new Error(`Expected \`${propName}\` to be greater or equal to 0.`);
        const { numPages: numPages } = pdf;
        if (pageIndex + 1 > numPages) return new Error(`Expected \`${propName}\` to be less or equal to ${numPages - 1}.`);
    } else if (!(0, $6a883133d725d0f3$export$4e62c701997796c1)(pageNumber)) return new Error(`\`${propName}\` not supplied. Either pageIndex or pageNumber must be supplied to \`${componentName}\`.`);
    // Everything is fine
    return null;
};
const $5f256c83f1a297c6$export$973e710208ddd50f = function isPageNumber(props, propName, componentName) {
    const { [propName]: pageNumber, pageIndex: pageIndex, pdf: pdf } = props;
    if (!(0, $6a883133d725d0f3$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $6a883133d725d0f3$export$4e62c701997796c1)(pageNumber)) {
        if (typeof pageNumber !== "number") return new Error(`\`${propName}\` of type \`${typeof pageNumber}\` supplied to \`${componentName}\`, expected \`number\`.`);
        if (pageNumber < 1) return new Error(`Expected \`${propName}\` to be greater or equal to 1.`);
        const { numPages: numPages } = pdf;
        if (pageNumber > numPages) return new Error(`Expected \`${propName}\` to be less or equal to ${numPages}.`);
    } else if (!(0, $6a883133d725d0f3$export$4e62c701997796c1)(pageIndex)) return new Error(`\`${propName}\` not supplied. Either pageIndex or pageNumber must be supplied to \`${componentName}\`.`);
    // Everything is fine
    return null;
};
const $5f256c83f1a297c6$export$d22001c6ab8dd37 = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOfType([
    // Ideally, this would be `PropTypes.instanceOf(PDFDocumentProxy)`, but it can't be imported.
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).any,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOf([
        false
    ])
]);
const $5f256c83f1a297c6$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).exact({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).any
    })
]);
const $5f256c83f1a297c6$export$70f0c3edbd58f82c = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOf([
    "canvas",
    "custom",
    "none",
    "svg"
]);
const $5f256c83f1a297c6$export$10b2580337f7e7c1 = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOf([
    0,
    90,
    180,
    270
]);


"use client";
var $2b9f28760947e06f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2b9f28760947e06f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const { PDFDataRangeTransport: $2b9f28760947e06f$var$PDFDataRangeTransport } = (0, $b5ae944e35783420$export$2e2bcd8739ae039);
const $2b9f28760947e06f$var$defaultOnPassword = (callback, reason)=>{
    switch(reason){
        case (0, $958a8d2f15d4c2d7$export$2e2bcd8739ae039).NEED_PASSWORD:
            {
                // eslint-disable-next-line no-alert
                const password = prompt("Enter the password to open this PDF file.");
                callback(password);
                break;
            }
        case (0, $958a8d2f15d4c2d7$export$2e2bcd8739ae039).INCORRECT_PASSWORD:
            {
                // eslint-disable-next-line no-alert
                const password = prompt("Invalid password. Please try again.");
                callback(password);
                break;
            }
        default:
    }
};
function $2b9f28760947e06f$var$isParameterObject(file) {
    return typeof file === "object" && file !== null && ("data" in file || "range" in file || "url" in file);
}
/**
 * Loads a document passed using `file` prop.
 */ const $2b9f28760947e06f$var$Document = (0, $lT7pJ.forwardRef)(function Document(_a, ref) {
    var { children: children, className: className, error: error = "Failed to load PDF file.", externalLinkRel: externalLinkRel, externalLinkTarget: externalLinkTarget, file: file, inputRef: inputRef, imageResourcesPath: imageResourcesPath, loading: loading = "Loading PDF\u2026", noData: noData = "No PDF file specified.", onItemClick: onItemClick, onLoadError: onLoadErrorProps, onLoadProgress: onLoadProgress, onLoadSuccess: onLoadSuccessProps, onPassword: onPassword = $2b9f28760947e06f$var$defaultOnPassword, onSourceError: onSourceErrorProps, onSourceSuccess: onSourceSuccessProps, options: options, renderMode: renderMode, rotate: rotate } = _a, otherProps = $2b9f28760947e06f$var$__rest(_a, [
        "children",
        "className",
        "error",
        "externalLinkRel",
        "externalLinkTarget",
        "file",
        "inputRef",
        "imageResourcesPath",
        "loading",
        "noData",
        "onItemClick",
        "onLoadError",
        "onLoadProgress",
        "onLoadSuccess",
        "onPassword",
        "onSourceError",
        "onSourceSuccess",
        "options",
        "renderMode",
        "rotate"
    ]);
    const [sourceState, sourceDispatch] = (0, $fde22d935e3a5987$export$2e2bcd8739ae039)();
    const { value: source, error: sourceError } = sourceState;
    const [pdfState, pdfDispatch] = (0, $fde22d935e3a5987$export$2e2bcd8739ae039)();
    const { value: pdf, error: pdfError } = pdfState;
    const linkService = (0, $lT7pJ.useRef)(new (0, $76911c8e19adc63a$export$2e2bcd8739ae039)());
    const pages = (0, $lT7pJ.useRef)([]);
    const prevFile = (0, $lT7pJ.useRef)();
    const prevOptions = (0, $lT7pJ.useRef)();
    (0, $lT7pJ.useEffect)(()=>{
        if (file && file !== prevFile.current && $2b9f28760947e06f$var$isParameterObject(file)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(!(0, $ba29b9ffe2caefdb$export$de8294bb3be0322f)(file, prevFile.current), `File prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "file" prop.`);
            prevFile.current = file;
        }
    }, [
        file
    ]);
    // Detect non-memoized changes in options prop
    (0, $lT7pJ.useEffect)(()=>{
        if (options && options !== prevOptions.current) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(!(0, $ba29b9ffe2caefdb$export$de8294bb3be0322f)(options, prevOptions.current), `Options prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "options" prop.`);
            prevOptions.current = options;
        }
    }, [
        options
    ]);
    const viewer = (0, $lT7pJ.useRef)({
        // Handling jumping to internal links target
        scrollPageIntoView: (args)=>{
            const { dest: dest, pageNumber: pageNumber, pageIndex: pageIndex = pageNumber - 1 } = args;
            // First, check if custom handling of onItemClick was provided
            if (onItemClick) {
                onItemClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
                return;
            }
            // If not, try to look for target page within the <Document>.
            const page = pages.current[pageIndex];
            if (page) {
                // Scroll to the page automatically
                page.scrollIntoView();
                return;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, `An internal link leading to page ${pageNumber} was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.`);
        }
    });
    (0, $lT7pJ.useImperativeHandle)(ref, ()=>({
            linkService: linkService,
            pages: pages,
            viewer: viewer
        }), []);
    /**
     * Called when a document source is resolved correctly
     */ function onSourceSuccess() {
        if (onSourceSuccessProps) onSourceSuccessProps();
    }
    /**
     * Called when a document source failed to be resolved correctly
     */ function onSourceError() {
        if (!sourceError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, sourceError.toString());
        if (onSourceErrorProps) onSourceErrorProps(sourceError);
    }
    function resetSource() {
        sourceDispatch({
            type: "RESET"
        });
    }
    (0, $lT7pJ.useEffect)(resetSource, [
        file,
        sourceDispatch
    ]);
    const findDocumentSource = (0, $lT7pJ.useCallback)(()=>$2b9f28760947e06f$var$__awaiter(this, void 0, void 0, function*() {
            if (!file) return null;
            // File is a string
            if (typeof file === "string") {
                if ((0, $6a883133d725d0f3$export$4d82193ef6a8d75c)(file)) {
                    const fileByteString = (0, $6a883133d725d0f3$export$c1553384119518c3)(file);
                    return {
                        data: fileByteString
                    };
                }
                (0, $6a883133d725d0f3$export$84884c3182d1bdda)();
                return {
                    url: file
                };
            }
            // File is PDFDataRangeTransport
            if (file instanceof $2b9f28760947e06f$var$PDFDataRangeTransport) return {
                range: file
            };
            // File is an ArrayBuffer
            if ((0, $6a883133d725d0f3$export$9dd3754ae86f0017)(file)) return {
                data: file
            };
            /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */ if (0, $6a883133d725d0f3$export$4e09c449d6c407f7) // File is a Blob
            {
                if ((0, $6a883133d725d0f3$export$5bcd6e94ed871c88)(file)) {
                    const data = yield (0, $6a883133d725d0f3$export$21fedb3a7a137f3d)(file);
                    return {
                        data: data
                    };
                }
            }
            // At this point, file must be an object
            (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(typeof file === "object", "Invalid parameter in file, need either Uint8Array, string or a parameter object");
            (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)($2b9f28760947e06f$var$isParameterObject(file), "Invalid parameter object: need either .data, .range or .url");
            // File .url is a string
            if ("url" in file && typeof file.url === "string") {
                if ((0, $6a883133d725d0f3$export$4d82193ef6a8d75c)(file.url)) {
                    const { url: url } = file, otherParams = $2b9f28760947e06f$var$__rest(file, [
                        "url"
                    ]);
                    const fileByteString = (0, $6a883133d725d0f3$export$c1553384119518c3)(url);
                    return Object.assign({
                        data: fileByteString
                    }, otherParams);
                }
                (0, $6a883133d725d0f3$export$84884c3182d1bdda)();
            }
            return file;
        }), [
        file
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        const cancellable = (0, $40732ba5c834a61e$export$2e2bcd8739ae039)(findDocumentSource());
        cancellable.promise.then((nextSource)=>{
            sourceDispatch({
                type: "RESOLVE",
                value: nextSource
            });
        }).catch((error)=>{
            sourceDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>{
            (0, $6a883133d725d0f3$export$b8c3f1dffc289352)(cancellable);
        };
    }, [
        findDocumentSource,
        sourceDispatch
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (typeof source === "undefined") return;
        if (source === false) {
            onSourceError();
            return;
        }
        onSourceSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        source
    ]);
    /**
     * Called when a document is read successfully
     */ function onLoadSuccess() {
        if (!pdf) // Impossible, but TypeScript doesn't know that
        return;
        if (onLoadSuccessProps) onLoadSuccessProps(pdf);
        pages.current = new Array(pdf.numPages);
        linkService.current.setDocument(pdf);
    }
    /**
     * Called when a document failed to read successfully
     */ function onLoadError() {
        if (!pdfError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, pdfError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pdfError);
    }
    function resetDocument() {
        pdfDispatch({
            type: "RESET"
        });
    }
    (0, $lT7pJ.useEffect)(resetDocument, [
        pdfDispatch,
        source
    ]);
    function loadDocument() {
        if (!source) return;
        const documentInitParams = options ? Object.assign(Object.assign({}, source), options) : source;
        const destroyable = (0, $b5ae944e35783420$export$2e2bcd8739ae039).getDocument(documentInitParams);
        if (onLoadProgress) destroyable.onProgress = onLoadProgress;
        if (onPassword) destroyable.onPassword = onPassword;
        const loadingTask = destroyable;
        loadingTask.promise.then((nextPdf)=>{
            pdfDispatch({
                type: "RESOLVE",
                value: nextPdf
            });
        }).catch((error)=>{
            if (loadingTask.destroyed) return;
            pdfDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>{
            loadingTask.destroy();
        };
    }
    (0, $lT7pJ.useEffect)(loadDocument, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        options,
        pdfDispatch,
        source
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (typeof pdf === "undefined") return;
        if (pdf === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        pdf
    ]);
    function setupLinkService() {
        linkService.current.setViewer(viewer.current);
        linkService.current.setExternalLinkRel(externalLinkRel);
        linkService.current.setExternalLinkTarget(externalLinkTarget);
    }
    (0, $lT7pJ.useEffect)(setupLinkService, [
        externalLinkRel,
        externalLinkTarget
    ]);
    function registerPage(pageIndex, ref) {
        pages.current[pageIndex] = ref;
    }
    function unregisterPage(pageIndex) {
        delete pages.current[pageIndex];
    }
    const childContext = (0, $lT7pJ.useMemo)(()=>({
            imageResourcesPath: imageResourcesPath,
            linkService: linkService.current,
            onItemClick: onItemClick,
            pdf: pdf,
            registerPage: registerPage,
            renderMode: renderMode,
            rotate: rotate,
            unregisterPage: unregisterPage
        }), [
        imageResourcesPath,
        onItemClick,
        pdf,
        renderMode,
        rotate
    ]);
    const eventProps = (0, $lT7pJ.useMemo)(()=>(0, $34c68c68178c12ec$export$2e2bcd8739ae039)(otherProps, ()=>pdf), [
        otherProps,
        pdf
    ]);
    function renderChildren() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $b230659291ba3981$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, children);
    }
    function renderContent() {
        if (!file) return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $31339d565a044e37$export$2e2bcd8739ae039), {
            type: "no-data"
        }, typeof noData === "function" ? noData() : noData);
        if (pdf === undefined || pdf === null) return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $31339d565a044e37$export$2e2bcd8739ae039), {
            type: "loading"
        }, typeof loading === "function" ? loading() : loading);
        if (pdf === false) return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $31339d565a044e37$export$2e2bcd8739ae039), {
            type: "error"
        }, typeof error === "function" ? error() : error);
        return renderChildren();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("div", Object.assign({
        className: (0, $4eca29e56ecefe31$export$2e2bcd8739ae039)("react-pdf__Document", className),
        ref: inputRef,
        style: {
            ["--scale-factor"]: "1"
        }
    }, eventProps), renderContent());
});
const $2b9f28760947e06f$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).node
]);
$2b9f28760947e06f$var$Document.propTypes = Object.assign(Object.assign({}, (0, $5f256c83f1a297c6$export$1e08905474334888)), {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).node,
    className: (0, $5f256c83f1a297c6$export$d53f3db2f43345df),
    error: $2b9f28760947e06f$var$isFunctionOrNode,
    externalLinkRel: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
    externalLinkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOf([
        "_self",
        "_blank",
        "_parent",
        "_top"
    ]),
    file: (0, $5f256c83f1a297c6$export$be78b3111c50efdd),
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
    inputRef: (0, $5f256c83f1a297c6$export$4f9f5282de18fc69),
    loading: $2b9f28760947e06f$var$isFunctionOrNode,
    noData: $2b9f28760947e06f$var$isFunctionOrNode,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onLoadProgress: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onPassword: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onSourceError: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onSourceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).shape({
        canvasFactory: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).any,
        canvasMaxAreaInBytes: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number,
        cMapPacked: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        CMapReaderFactory: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).any,
        cMapUrl: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
        disableAutoFetch: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        disableFontFace: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        disableRange: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        disableStream: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        docBaseUrl: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
        enableXfa: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        filterFactory: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).any,
        fontExtraProperties: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        httpHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).object,
        isEvalSupported: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        isOffscreenCanvasSupported: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        length: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number,
        maxImageSize: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number,
        ownerDocument: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).any,
        password: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
        pdfBug: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        rangeChunkSize: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number,
        StandardFontDataFactory: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).any,
        standardFontDataUrl: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
        stopAtErrors: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        useSystemFonts: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        useWorkerFetch: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        verbosity: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number,
        withCredentials: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
        worker: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).any
    }),
    rotate: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number
});
var $2b9f28760947e06f$export$2e2bcd8739ae039 = $2b9f28760947e06f$var$Document;


var $lT7pJ = parcelRequire("lT7pJ");




/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```jsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $93e1e2e742ff8643$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        filteredInputRefs.forEach(function(inputRef) {
            if (typeof inputRef === "function") inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        });
    };
}





var $lT7pJ = parcelRequire("lT7pJ");
"use client";
var $3c73d77167aadc69$export$2e2bcd8739ae039 = (0, $lT7pJ.createContext)(null);




var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");




var $lT7pJ = parcelRequire("lT7pJ");
// From pdfjs-dist/lib/web/struct_tree_layer_builder.js
const $6180e440a6a65fbc$export$789cd800273ee71a = {
    // Document level structure types
    Document: null,
    DocumentFragment: null,
    // Grouping level structure types
    Part: "group",
    Sect: "group",
    Div: "group",
    Aside: "note",
    NonStruct: "none",
    // Block level structure types
    P: null,
    // H<n>,
    H: "heading",
    Title: null,
    FENote: "note",
    // Sub-block level structure type
    Sub: "group",
    // General inline level structure types
    Lbl: null,
    Span: null,
    Em: null,
    Strong: null,
    Link: "link",
    Annot: "note",
    Form: "form",
    // Ruby and Warichu structure types
    Ruby: null,
    RB: null,
    RT: null,
    RP: null,
    Warichu: null,
    WT: null,
    WP: null,
    // List standard structure types
    L: "list",
    LI: "listitem",
    LBody: null,
    // Table standard structure types
    Table: "table",
    TR: "row",
    TH: "columnheader",
    TD: "cell",
    THead: "columnheader",
    TBody: null,
    TFoot: null,
    // Standard structure type Caption
    Caption: null,
    // Standard structure type Figure
    Figure: "figure",
    // Standard structure type Formula
    Formula: null,
    // standard structure type Artifact
    Artifact: null
};
const $6180e440a6a65fbc$export$4921bbe0701579e4 = /^H(\d+)$/;


function $5e8bb586e44ec1bb$export$80a007e7cc9dad0d(role) {
    return role in (0, $6180e440a6a65fbc$export$789cd800273ee71a);
}
function $5e8bb586e44ec1bb$export$9eeaf208d22fae4f(node) {
    return "children" in node;
}
function $5e8bb586e44ec1bb$export$3b7840712ba182f3(node) {
    if (!$5e8bb586e44ec1bb$export$9eeaf208d22fae4f(node)) return false;
    return node.children.length === 1 && 0 in node.children && "id" in node.children[0];
}
function $5e8bb586e44ec1bb$export$aa440a09c67191c2(node) {
    const attributes = {};
    if ($5e8bb586e44ec1bb$export$9eeaf208d22fae4f(node)) {
        const { role: role } = node;
        const matches = role.match((0, $6180e440a6a65fbc$export$4921bbe0701579e4));
        if (matches) {
            attributes.role = "heading";
            attributes["aria-level"] = Number(matches[1]);
        } else if ($5e8bb586e44ec1bb$export$80a007e7cc9dad0d(role)) {
            const htmlRole = (0, $6180e440a6a65fbc$export$789cd800273ee71a)[role];
            if (htmlRole) attributes.role = htmlRole;
        }
    }
    return attributes;
}
function $5e8bb586e44ec1bb$export$e86e6c9c68c5154c(node) {
    const attributes = {};
    if ($5e8bb586e44ec1bb$export$9eeaf208d22fae4f(node)) {
        if (node.alt !== undefined) attributes["aria-label"] = node.alt;
        if (node.lang !== undefined) attributes.lang = node.lang;
        if ($5e8bb586e44ec1bb$export$3b7840712ba182f3(node)) {
            const [child] = node.children;
            if (child) {
                const childAttributes = $5e8bb586e44ec1bb$export$e86e6c9c68c5154c(child);
                return Object.assign(Object.assign({}, attributes), childAttributes);
            }
        }
    } else if ("id" in node) attributes["aria-owns"] = node.id;
    return attributes;
}
function $5e8bb586e44ec1bb$export$fe94072fee8a6976(node) {
    if (!node) return null;
    return Object.assign(Object.assign({}, $5e8bb586e44ec1bb$export$aa440a09c67191c2(node)), $5e8bb586e44ec1bb$export$e86e6c9c68c5154c(node));
}


function $5f52abe07e1e15e3$export$2e2bcd8739ae039({ className: className, node: node }) {
    const attributes = (0, $lT7pJ.useMemo)(()=>(0, $5e8bb586e44ec1bb$export$fe94072fee8a6976)(node), [
        node
    ]);
    const children = (0, $lT7pJ.useMemo)(()=>{
        if (!(0, $5e8bb586e44ec1bb$export$9eeaf208d22fae4f)(node)) return null;
        if ((0, $5e8bb586e44ec1bb$export$3b7840712ba182f3)(node)) return null;
        return node.children.map((child, index)=>{
            return(// eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement($5f52abe07e1e15e3$export$2e2bcd8739ae039, {
                key: index,
                node: child
            }));
        });
    }, [
        node
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("span", Object.assign({
        className: className
    }, attributes), children);
}



var $lT7pJ = parcelRequire("lT7pJ");

function $0d0ac069a521e1a9$export$2e2bcd8739ae039() {
    return (0, $lT7pJ.useContext)((0, $3c73d77167aadc69$export$2e2bcd8739ae039));
}




function $5547155aa5cfc8f5$export$2e2bcd8739ae039() {
    const pageContext = (0, $0d0ac069a521e1a9$export$2e2bcd8739ae039)();
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const { onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps } = pageContext;
    const [structTreeState, structTreeDispatch] = (0, $fde22d935e3a5987$export$2e2bcd8739ae039)();
    const { value: structTree, error: structTreeError } = structTreeState;
    const { customTextRenderer: customTextRenderer, page: page } = pageContext;
    function onLoadSuccess() {
        if (!structTree) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetStructTreeSuccessProps) onGetStructTreeSuccessProps(structTree);
    }
    function onLoadError() {
        if (!structTreeError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, structTreeError.toString());
        if (onGetStructTreeErrorProps) onGetStructTreeErrorProps(structTreeError);
    }
    function resetAnnotations() {
        structTreeDispatch({
            type: "RESET"
        });
    }
    (0, $lT7pJ.useEffect)(resetAnnotations, [
        structTreeDispatch,
        page
    ]);
    function loadStructTree() {
        if (customTextRenderer) // TODO: Document why this is necessary
        return;
        if (!page) return;
        const cancellable = (0, $40732ba5c834a61e$export$2e2bcd8739ae039)(page.getStructTree());
        const runningTask = cancellable;
        cancellable.promise.then((nextStructTree)=>{
            structTreeDispatch({
                type: "RESOLVE",
                value: nextStructTree
            });
        }).catch((error)=>{
            structTreeDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>(0, $6a883133d725d0f3$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $lT7pJ.useEffect)(loadStructTree, [
        customTextRenderer,
        page,
        structTreeDispatch
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (structTree === undefined) return;
        if (structTree === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        structTree
    ]);
    if (!structTree) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $5f52abe07e1e15e3$export$2e2bcd8739ae039), {
        className: "react-pdf__Page__structTree structTree",
        node: structTree
    });
}




"use client";
const $6a8253cab29b78da$var$ANNOTATION_MODE = (0, $b5ae944e35783420$export$2e2bcd8739ae039).AnnotationMode;
function $6a8253cab29b78da$export$2e2bcd8739ae039(props) {
    const pageContext = (0, $0d0ac069a521e1a9$export$2e2bcd8739ae039)();
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const mergedProps = Object.assign(Object.assign({}, pageContext), props);
    const { _className: _className, canvasBackground: canvasBackground, devicePixelRatio: devicePixelRatio = (0, $6a883133d725d0f3$export$cf4a949e5ad681d)(), onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, page: page, renderForms: renderForms, renderTextLayer: renderTextLayer, rotate: rotate, scale: scale } = mergedProps;
    const { canvasRef: canvasRef } = props;
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(page, "Attempted to render page canvas, but no page was specified.");
    const canvasElement = (0, $lT7pJ.useRef)(null);
    /**
     * Called when a page is rendered successfully.
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $6a883133d725d0f3$export$8cc3f6b8d58bdda0)(page, scale));
    }
    /**
     * Called when a page fails to render.
     */ function onRenderError(error) {
        if ((0, $6a883133d725d0f3$export$99075c4d008e6ab1)(error)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, error.toString());
        if (onRenderErrorProps) onRenderErrorProps(error);
    }
    const renderViewport = (0, $lT7pJ.useMemo)(()=>page.getViewport({
            scale: scale * devicePixelRatio,
            rotation: rotate
        }), [
        devicePixelRatio,
        page,
        rotate,
        scale
    ]);
    const viewport = (0, $lT7pJ.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function drawPageOnCanvas() {
        if (!page) return;
        // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
        page.cleanup();
        const { current: canvas } = canvasElement;
        if (!canvas) return;
        canvas.width = renderViewport.width;
        canvas.height = renderViewport.height;
        canvas.style.width = `${Math.floor(viewport.width)}px`;
        canvas.style.height = `${Math.floor(viewport.height)}px`;
        canvas.style.visibility = "hidden";
        const renderContext = {
            annotationMode: renderForms ? $6a8253cab29b78da$var$ANNOTATION_MODE.ENABLE_FORMS : $6a8253cab29b78da$var$ANNOTATION_MODE.ENABLE,
            canvasContext: canvas.getContext("2d", {
                alpha: false
            }),
            viewport: renderViewport
        };
        if (canvasBackground) renderContext.background = canvasBackground;
        const cancellable = page.render(renderContext);
        const runningTask = cancellable;
        cancellable.promise.then(()=>{
            canvas.style.visibility = "";
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $6a883133d725d0f3$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $lT7pJ.useEffect)(drawPageOnCanvas, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        canvasBackground,
        canvasElement,
        devicePixelRatio,
        page,
        renderForms,
        renderViewport,
        viewport
    ]);
    const cleanup = (0, $lT7pJ.useCallback)(()=>{
        const { current: canvas } = canvasElement;
        /**
         * Zeroing the width and height cause most browsers to release graphics
         * resources immediately, which can greatly reduce memory consumption.
         */ if (canvas) {
            canvas.width = 0;
            canvas.height = 0;
        }
    }, [
        canvasElement
    ]);
    (0, $lT7pJ.useEffect)(()=>cleanup, [
        cleanup
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("canvas", {
        className: `${_className}__canvas`,
        dir: "ltr",
        ref: (0, $93e1e2e742ff8643$export$2e2bcd8739ae039)(canvasRef, canvasElement),
        style: {
            display: "block",
            userSelect: "none"
        }
    }, renderTextLayer ? (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $5547155aa5cfc8f5$export$2e2bcd8739ae039), null) : null);
}



var $lT7pJ = parcelRequire("lT7pJ");







function $da00acd9ca6eecd9$export$2e2bcd8739ae039() {
    const pageContext = (0, $0d0ac069a521e1a9$export$2e2bcd8739ae039)();
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const { _className: _className, onRenderSuccess: onRenderSuccessProps, onRenderError: onRenderErrorProps, page: page, rotate: rotate, scale: scale } = pageContext;
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(page, "Attempted to render page SVG, but no page was specified.");
    const [svgState, svgDispatch] = (0, $fde22d935e3a5987$export$2e2bcd8739ae039)();
    const { value: svg, error: svgError } = svgState;
    /**
     * Called when a page is rendered successfully
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $6a883133d725d0f3$export$8cc3f6b8d58bdda0)(page, scale));
    }
    /**
     * Called when a page fails to render
     */ function onRenderError() {
        if (!svgError) // Impossible, but TypeScript doesn't know that
        return;
        if ((0, $6a883133d725d0f3$export$99075c4d008e6ab1)(svgError)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, svgError.toString());
        if (onRenderErrorProps) onRenderErrorProps(svgError);
    }
    const viewport = (0, $lT7pJ.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function resetSVG() {
        svgDispatch({
            type: "RESET"
        });
    }
    (0, $lT7pJ.useEffect)(resetSVG, [
        page,
        svgDispatch,
        viewport
    ]);
    function renderSVG() {
        if (!page) return;
        const cancellable = (0, $40732ba5c834a61e$export$2e2bcd8739ae039)(page.getOperatorList());
        cancellable.promise.then((operatorList)=>{
            const svgGfx = new (0, $b5ae944e35783420$export$2e2bcd8739ae039).SVGGraphics(page.commonObjs, page.objs);
            svgGfx.getSVG(operatorList, viewport).then((nextSvg)=>{
                // See https://github.com/mozilla/pdf.js/issues/16745
                if (!(nextSvg instanceof SVGElement)) throw new Error("getSVG returned unexpected result.");
                svgDispatch({
                    type: "RESOLVE",
                    value: nextSvg
                });
            }).catch((error)=>{
                svgDispatch({
                    type: "REJECT",
                    error: error
                });
            });
        }).catch((error)=>{
            svgDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>(0, $6a883133d725d0f3$export$b8c3f1dffc289352)(cancellable);
    }
    (0, $lT7pJ.useEffect)(renderSVG, [
        page,
        svgDispatch,
        viewport
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (svg === undefined) return;
        if (svg === false) {
            onRenderError();
            return;
        }
        onRenderSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        svg
    ]);
    function drawPageOnContainer(element) {
        if (!element || !svg) return;
        // Append SVG element to the main container, if this hasn't been done already
        if (!element.firstElementChild) element.appendChild(svg);
        const { width: width, height: height } = viewport;
        svg.setAttribute("width", `${width}`);
        svg.setAttribute("height", `${height}`);
    }
    const { width: width, height: height } = viewport;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("div", {
        className: `${_className}__svg`,
        // Note: This cannot be shortened, as we need this function to be called with each render.
        ref: (ref)=>drawPageOnContainer(ref),
        style: {
            display: "block",
            backgroundColor: "white",
            overflow: "hidden",
            width: width,
            height: height,
            userSelect: "none"
        }
    });
}



var $lT7pJ = parcelRequire("lT7pJ");








"use client";
function $243be2567d5e6c07$var$isTextItem(item) {
    return "str" in item;
}
function $243be2567d5e6c07$export$2e2bcd8739ae039() {
    const pageContext = (0, $0d0ac069a521e1a9$export$2e2bcd8739ae039)();
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const { customTextRenderer: customTextRenderer, onGetTextError: onGetTextError, onGetTextSuccess: onGetTextSuccess, onRenderTextLayerError: onRenderTextLayerError, onRenderTextLayerSuccess: onRenderTextLayerSuccess, page: page, pageIndex: pageIndex, pageNumber: pageNumber, rotate: rotate, scale: scale } = pageContext;
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(page, "Attempted to load page text content, but no page was specified.");
    const [textContentState, textContentDispatch] = (0, $fde22d935e3a5987$export$2e2bcd8739ae039)();
    const { value: textContent, error: textContentError } = textContentState;
    const layerElement = (0, $lT7pJ.useRef)(null);
    const endElement = (0, $lT7pJ.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-text-layer"), 10) === 1, "TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer");
    /**
     * Called when a page text content is read successfully
     */ function onLoadSuccess() {
        if (!textContent) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetTextSuccess) onGetTextSuccess(textContent);
    }
    /**
     * Called when a page text content failed to read successfully
     */ function onLoadError() {
        if (!textContentError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, textContentError.toString());
        if (onGetTextError) onGetTextError(textContentError);
    }
    function resetTextContent() {
        textContentDispatch({
            type: "RESET"
        });
    }
    (0, $lT7pJ.useEffect)(resetTextContent, [
        page,
        textContentDispatch
    ]);
    function loadTextContent() {
        if (!page) return;
        const cancellable = (0, $40732ba5c834a61e$export$2e2bcd8739ae039)(page.getTextContent());
        const runningTask = cancellable;
        cancellable.promise.then((nextTextContent)=>{
            textContentDispatch({
                type: "RESOLVE",
                value: nextTextContent
            });
        }).catch((error)=>{
            textContentDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>(0, $6a883133d725d0f3$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $lT7pJ.useEffect)(loadTextContent, [
        page,
        textContentDispatch
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (textContent === undefined) return;
        if (textContent === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        textContent
    ]);
    /**
     * Called when a text layer is rendered successfully
     */ const onRenderSuccess = (0, $lT7pJ.useCallback)(()=>{
        if (onRenderTextLayerSuccess) onRenderTextLayerSuccess();
    }, [
        onRenderTextLayerSuccess
    ]);
    /**
     * Called when a text layer failed to render successfully
     */ const onRenderError = (0, $lT7pJ.useCallback)((error)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, error.toString());
        if (onRenderTextLayerError) onRenderTextLayerError(error);
    }, [
        onRenderTextLayerError
    ]);
    function onMouseDown() {
        const end = endElement.current;
        if (!end) return;
        end.classList.add("active");
    }
    function onMouseUp() {
        const end = endElement.current;
        if (!end) return;
        end.classList.remove("active");
    }
    const viewport = (0, $lT7pJ.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function renderTextLayer() {
        if (!page || !textContent) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        layer.innerHTML = "";
        const textContentSource = page.streamTextContent({
            includeMarkedContent: true
        });
        const parameters = {
            container: layer,
            textContentSource: textContentSource,
            viewport: viewport
        };
        const cancellable = (0, $b5ae944e35783420$export$2e2bcd8739ae039).renderTextLayer(parameters);
        const runningTask = cancellable;
        cancellable.promise.then(()=>{
            const end = document.createElement("div");
            end.className = "endOfContent";
            layer.append(end);
            endElement.current = end;
            const layerChildren = layer.querySelectorAll('[role="presentation"]');
            if (customTextRenderer) {
                let index = 0;
                textContent.items.forEach((item, itemIndex)=>{
                    if (!$243be2567d5e6c07$var$isTextItem(item)) return;
                    const child = layerChildren[index];
                    if (!child) return;
                    const content = customTextRenderer(Object.assign({
                        pageIndex: pageIndex,
                        pageNumber: pageNumber,
                        itemIndex: itemIndex
                    }, item));
                    child.innerHTML = content;
                    index += item.str && item.hasEOL ? 2 : 1;
                });
            }
            // Intentional immediate callback
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $6a883133d725d0f3$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $lT7pJ.useLayoutEffect)(renderTextLayer, [
        customTextRenderer,
        onRenderError,
        onRenderSuccess,
        page,
        pageIndex,
        pageNumber,
        textContent,
        viewport
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("div", {
        className: (0, $4eca29e56ecefe31$export$2e2bcd8739ae039)("react-pdf__Page__textContent", "textLayer"),
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        ref: layerElement
    }));
}



var $lT7pJ = parcelRequire("lT7pJ");






var $lT7pJ = parcelRequire("lT7pJ");

function $28c5847177342978$export$2e2bcd8739ae039() {
    return (0, $lT7pJ.useContext)((0, $b230659291ba3981$export$2e2bcd8739ae039));
}





"use client";
function $3f9ed924499e39f5$export$2e2bcd8739ae039() {
    const documentContext = (0, $28c5847177342978$export$2e2bcd8739ae039)();
    const pageContext = (0, $0d0ac069a521e1a9$export$2e2bcd8739ae039)();
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    const mergedProps = Object.assign(Object.assign({}, documentContext), pageContext);
    const { imageResourcesPath: imageResourcesPath, linkService: linkService, onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, page: page, pdf: pdf, renderForms: renderForms, rotate: rotate, scale: scale = 1 } = mergedProps;
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(pdf, "Attempted to load page annotations, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.");
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(page, "Attempted to load page annotations, but no page was specified.");
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(linkService, "Attempted to load page annotations, but no linkService was specified.");
    const [annotationsState, annotationsDispatch] = (0, $fde22d935e3a5987$export$2e2bcd8739ae039)();
    const { value: annotations, error: annotationsError } = annotationsState;
    const layerElement = (0, $lT7pJ.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-annotation-layer"), 10) === 1, "AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations");
    function onLoadSuccess() {
        if (!annotations) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetAnnotationsSuccessProps) onGetAnnotationsSuccessProps(annotations);
    }
    function onLoadError() {
        if (!annotationsError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, annotationsError.toString());
        if (onGetAnnotationsErrorProps) onGetAnnotationsErrorProps(annotationsError);
    }
    function resetAnnotations() {
        annotationsDispatch({
            type: "RESET"
        });
    }
    (0, $lT7pJ.useEffect)(resetAnnotations, [
        annotationsDispatch,
        page
    ]);
    function loadAnnotations() {
        if (!page) return;
        const cancellable = (0, $40732ba5c834a61e$export$2e2bcd8739ae039)(page.getAnnotations());
        const runningTask = cancellable;
        cancellable.promise.then((nextAnnotations)=>{
            annotationsDispatch({
                type: "RESOLVE",
                value: nextAnnotations
            });
        }).catch((error)=>{
            annotationsDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>{
            (0, $6a883133d725d0f3$export$b8c3f1dffc289352)(runningTask);
        };
    }
    (0, $lT7pJ.useEffect)(loadAnnotations, [
        annotationsDispatch,
        page,
        renderForms
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (annotations === undefined) return;
        if (annotations === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        annotations
    ]);
    function onRenderSuccess() {
        if (onRenderAnnotationLayerSuccessProps) onRenderAnnotationLayerSuccessProps();
    }
    function onRenderError(error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, `${error}`);
        if (onRenderAnnotationLayerErrorProps) onRenderAnnotationLayerErrorProps(error);
    }
    const viewport = (0, $lT7pJ.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    function renderAnnotationLayer() {
        if (!pdf || !page || !linkService || !annotations) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        const clonedViewport = viewport.clone({
            dontFlip: true
        });
        const annotationLayerParameters = {
            accessibilityManager: null,
            annotationCanvasMap: null,
            div: layer,
            l10n: null,
            page: page,
            viewport: clonedViewport
        };
        const renderParameters = {
            annotations: annotations,
            annotationStorage: pdf.annotationStorage,
            div: layer,
            // See https://github.com/mozilla/pdf.js/issues/17029
            downloadManager: null,
            imageResourcesPath: imageResourcesPath,
            linkService: linkService,
            page: page,
            renderForms: renderForms,
            viewport: clonedViewport
        };
        layer.innerHTML = "";
        try {
            new (0, $b5ae944e35783420$export$2e2bcd8739ae039).AnnotationLayer(annotationLayerParameters).render(renderParameters);
            // Intentional immediate callback
            onRenderSuccess();
        } catch (error) {
            onRenderError(error);
        }
        return ()=>{
        // TODO: Cancel running task?
        };
    }
    (0, $lT7pJ.useEffect)(renderAnnotationLayer, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        annotations,
        imageResourcesPath,
        linkService,
        page,
        renderForms,
        viewport
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("div", {
        className: (0, $4eca29e56ecefe31$export$2e2bcd8739ae039)("react-pdf__Page__annotations", "annotationLayer"),
        ref: layerElement
    });
}






"use client";
var $da91ea8433bc7591$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $da91ea8433bc7591$var$defaultScale = 1;
/**
 * Displays a page.
 *
 * Should be placed inside `<Document />`. Alternatively, it can have `pdf` prop passed, which can be obtained from `<Document />`'s `onLoadSuccess` callback function, however some advanced functions like linking between pages inside a document may not be working correctly.
 */ const $da91ea8433bc7591$var$Page = function Page(props) {
    const documentContext = (0, $28c5847177342978$export$2e2bcd8739ae039)();
    const mergedProps = Object.assign(Object.assign({}, documentContext), props);
    const { _className: _className = "react-pdf__Page", _enableRegisterUnregisterPage: _enableRegisterUnregisterPage = true, canvasBackground: canvasBackground, canvasRef: canvasRef, children: children, className: className, customRenderer: CustomRenderer, customTextRenderer: customTextRenderer, devicePixelRatio: devicePixelRatio, error: error = "Failed to load the page.", height: height, inputRef: inputRef, loading: loading = "Loading page\u2026", noData: noData = "No page specified.", onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps, onGetTextError: onGetTextErrorProps, onGetTextSuccess: onGetTextSuccessProps, onLoadError: onLoadErrorProps, onLoadSuccess: onLoadSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, onRenderTextLayerError: onRenderTextLayerErrorProps, onRenderTextLayerSuccess: onRenderTextLayerSuccessProps, pageIndex: pageIndexProps, pageNumber: pageNumberProps, pdf: pdf, registerPage: registerPage, renderAnnotationLayer: renderAnnotationLayerProps = true, renderForms: renderForms = false, renderMode: renderMode = "canvas", renderTextLayer: renderTextLayerProps = true, rotate: rotateProps, scale: scaleProps = $da91ea8433bc7591$var$defaultScale, unregisterPage: unregisterPage, width: width } = mergedProps, otherProps = $da91ea8433bc7591$var$__rest(mergedProps, [
        "_className",
        "_enableRegisterUnregisterPage",
        "canvasBackground",
        "canvasRef",
        "children",
        "className",
        "customRenderer",
        "customTextRenderer",
        "devicePixelRatio",
        "error",
        "height",
        "inputRef",
        "loading",
        "noData",
        "onGetAnnotationsError",
        "onGetAnnotationsSuccess",
        "onGetStructTreeError",
        "onGetStructTreeSuccess",
        "onGetTextError",
        "onGetTextSuccess",
        "onLoadError",
        "onLoadSuccess",
        "onRenderAnnotationLayerError",
        "onRenderAnnotationLayerSuccess",
        "onRenderError",
        "onRenderSuccess",
        "onRenderTextLayerError",
        "onRenderTextLayerSuccess",
        "pageIndex",
        "pageNumber",
        "pdf",
        "registerPage",
        "renderAnnotationLayer",
        "renderForms",
        "renderMode",
        "renderTextLayer",
        "rotate",
        "scale",
        "unregisterPage",
        "width"
    ]);
    const [pageState, pageDispatch] = (0, $fde22d935e3a5987$export$2e2bcd8739ae039)();
    const { value: page, error: pageError } = pageState;
    const pageElement = (0, $lT7pJ.useRef)(null);
    (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(pdf, "Attempted to load a page, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.");
    const pageIndex = (0, $6a883133d725d0f3$export$ef8866826b0b1f6d)(pageNumberProps) ? pageNumberProps - 1 : pageIndexProps !== null && pageIndexProps !== void 0 ? pageIndexProps : null;
    const pageNumber = pageNumberProps !== null && pageNumberProps !== void 0 ? pageNumberProps : (0, $6a883133d725d0f3$export$ef8866826b0b1f6d)(pageIndexProps) ? pageIndexProps + 1 : null;
    const rotate = rotateProps !== null && rotateProps !== void 0 ? rotateProps : page ? page.rotate : null;
    const scale = (0, $lT7pJ.useMemo)(()=>{
        if (!page) return null;
        // Be default, we'll render page at 100% * scale width.
        let pageScale = 1;
        // Passing scale explicitly null would cause the page not to render
        const scaleWithDefault = scaleProps !== null && scaleProps !== void 0 ? scaleProps : $da91ea8433bc7591$var$defaultScale;
        // If width/height is defined, calculate the scale of the page so it could be of desired width.
        if (width || height) {
            const viewport = page.getViewport({
                scale: 1,
                rotation: rotate
            });
            if (width) pageScale = width / viewport.width;
            else if (height) pageScale = height / viewport.height;
        }
        return scaleWithDefault * pageScale;
    }, [
        height,
        page,
        rotate,
        scaleProps,
        width
    ]);
    function hook() {
        return ()=>{
            if (!(0, $6a883133d725d0f3$export$ef8866826b0b1f6d)(pageIndex)) // Impossible, but TypeScript doesn't know that
            return;
            if (_enableRegisterUnregisterPage && unregisterPage) unregisterPage(pageIndex);
        };
    }
    (0, $lT7pJ.useEffect)(hook, [
        _enableRegisterUnregisterPage,
        pdf,
        pageIndex,
        unregisterPage
    ]);
    /**
     * Called when a page is loaded successfully
     */ function onLoadSuccess() {
        if (onLoadSuccessProps) {
            if (!page || !scale) // Impossible, but TypeScript doesn't know that
            return;
            onLoadSuccessProps((0, $6a883133d725d0f3$export$8cc3f6b8d58bdda0)(page, scale));
        }
        if (_enableRegisterUnregisterPage && registerPage) {
            if (!(0, $6a883133d725d0f3$export$ef8866826b0b1f6d)(pageIndex) || !pageElement.current) // Impossible, but TypeScript doesn't know that
            return;
            registerPage(pageIndex, pageElement.current);
        }
    }
    /**
     * Called when a page failed to load
     */ function onLoadError() {
        if (!pageError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($1db38723adbcd089$exports)))(false, pageError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pageError);
    }
    function resetPage() {
        pageDispatch({
            type: "RESET"
        });
    }
    (0, $lT7pJ.useEffect)(resetPage, [
        pageDispatch,
        pdf,
        pageIndex
    ]);
    function loadPage() {
        if (!pdf || !pageNumber) return;
        const cancellable = (0, $40732ba5c834a61e$export$2e2bcd8739ae039)(pdf.getPage(pageNumber));
        const runningTask = cancellable;
        cancellable.promise.then((nextPage)=>{
            pageDispatch({
                type: "RESOLVE",
                value: nextPage
            });
        }).catch((error)=>{
            pageDispatch({
                type: "REJECT",
                error: error
            });
        });
        return ()=>(0, $6a883133d725d0f3$export$b8c3f1dffc289352)(runningTask);
    }
    (0, $lT7pJ.useEffect)(loadPage, [
        pageDispatch,
        pdf,
        pageIndex,
        pageNumber,
        registerPage
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (page === undefined) return;
        if (page === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        page,
        scale
    ]);
    const childContext = (0, $lT7pJ.useMemo)(()=>// Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
        page && (0, $6a883133d725d0f3$export$ef8866826b0b1f6d)(pageIndex) && pageNumber && (0, $6a883133d725d0f3$export$ef8866826b0b1f6d)(rotate) && (0, $6a883133d725d0f3$export$ef8866826b0b1f6d)(scale) ? {
            _className: _className,
            canvasBackground: canvasBackground,
            customTextRenderer: customTextRenderer,
            devicePixelRatio: devicePixelRatio,
            onGetAnnotationsError: onGetAnnotationsErrorProps,
            onGetAnnotationsSuccess: onGetAnnotationsSuccessProps,
            onGetStructTreeError: onGetStructTreeErrorProps,
            onGetStructTreeSuccess: onGetStructTreeSuccessProps,
            onGetTextError: onGetTextErrorProps,
            onGetTextSuccess: onGetTextSuccessProps,
            onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps,
            onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps,
            onRenderError: onRenderErrorProps,
            onRenderSuccess: onRenderSuccessProps,
            onRenderTextLayerError: onRenderTextLayerErrorProps,
            onRenderTextLayerSuccess: onRenderTextLayerSuccessProps,
            page: page,
            pageIndex: pageIndex,
            pageNumber: pageNumber,
            renderForms: renderForms,
            renderTextLayer: renderTextLayerProps,
            rotate: rotate,
            scale: scale
        } : null, [
        _className,
        canvasBackground,
        customTextRenderer,
        devicePixelRatio,
        onGetAnnotationsErrorProps,
        onGetAnnotationsSuccessProps,
        onGetStructTreeErrorProps,
        onGetStructTreeSuccessProps,
        onGetTextErrorProps,
        onGetTextSuccessProps,
        onRenderAnnotationLayerErrorProps,
        onRenderAnnotationLayerSuccessProps,
        onRenderErrorProps,
        onRenderSuccessProps,
        onRenderTextLayerErrorProps,
        onRenderTextLayerSuccessProps,
        page,
        pageIndex,
        pageNumber,
        renderForms,
        renderTextLayerProps,
        rotate,
        scale
    ]);
    const eventProps = (0, $lT7pJ.useMemo)(()=>(0, $34c68c68178c12ec$export$2e2bcd8739ae039)(otherProps, ()=>page ? scale ? (0, $6a883133d725d0f3$export$8cc3f6b8d58bdda0)(page, scale) : undefined : page), [
        otherProps,
        page,
        scale
    ]);
    const pageKey = `${pageIndex}@${scale}/${rotate}`;
    const pageKeyNoScale = `${pageIndex}/${rotate}`;
    function renderMainLayer() {
        switch(renderMode){
            case "custom":
                (0, $2aed2c497b6a5412$export$2e2bcd8739ae039)(CustomRenderer, `renderMode was set to "custom", but no customRenderer was passed.`);
                return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement(CustomRenderer, {
                    key: `${pageKey}_custom`
                });
            case "none":
                return null;
            case "svg":
                return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $da00acd9ca6eecd9$export$2e2bcd8739ae039), {
                    key: `${pageKeyNoScale}_svg`
                });
            case "canvas":
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $6a8253cab29b78da$export$2e2bcd8739ae039), {
                    key: `${pageKey}_canvas`,
                    canvasRef: canvasRef
                });
        }
    }
    function renderTextLayer() {
        if (!renderTextLayerProps) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $243be2567d5e6c07$export$2e2bcd8739ae039), {
            key: `${pageKey}_text`
        });
    }
    function renderAnnotationLayer() {
        if (!renderAnnotationLayerProps) return null;
        /**
         * As of now, PDF.js 2.0.943 returns warnings on unimplemented annotations in SVG mode.
         * Therefore, as a fallback, we render "traditional" AnnotationLayer component.
         */ return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $3f9ed924499e39f5$export$2e2bcd8739ae039), {
            key: `${pageKey}_annotations`
        });
    }
    function renderChildren() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $3c73d77167aadc69$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, renderMainLayer(), renderTextLayer(), renderAnnotationLayer(), children);
    }
    function renderContent() {
        if (!pageNumber) return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $31339d565a044e37$export$2e2bcd8739ae039), {
            type: "no-data"
        }, typeof noData === "function" ? noData() : noData);
        if (pdf === null || page === undefined || page === null) return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $31339d565a044e37$export$2e2bcd8739ae039), {
            type: "loading"
        }, typeof loading === "function" ? loading() : loading);
        if (pdf === false || page === false) return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $31339d565a044e37$export$2e2bcd8739ae039), {
            type: "error"
        }, typeof error === "function" ? error() : error);
        return renderChildren();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("div", Object.assign({
        className: (0, $4eca29e56ecefe31$export$2e2bcd8739ae039)(_className, className),
        "data-page-number": pageNumber,
        ref: (0, $93e1e2e742ff8643$export$2e2bcd8739ae039)(inputRef, pageElement),
        style: {
            ["--scale-factor"]: `${scale}`,
            backgroundColor: canvasBackground || "white",
            position: "relative",
            minWidth: "min-content",
            minHeight: "min-content"
        }
    }, eventProps), renderContent());
};
const $da91ea8433bc7591$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).node
]);
$da91ea8433bc7591$var$Page.propTypes = Object.assign(Object.assign({}, (0, $5f256c83f1a297c6$export$1e08905474334888)), {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
    canvasRef: (0, $5f256c83f1a297c6$export$4f9f5282de18fc69),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).node,
    className: (0, $5f256c83f1a297c6$export$d53f3db2f43345df),
    customRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    devicePixelRatio: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number,
    error: $da91ea8433bc7591$var$isFunctionOrNode,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number,
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).string,
    inputRef: (0, $5f256c83f1a297c6$export$4f9f5282de18fc69),
    loading: $da91ea8433bc7591$var$isFunctionOrNode,
    noData: $da91ea8433bc7591$var$isFunctionOrNode,
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onRenderTextLayerError: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    onRenderTextLayerSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).func,
    pageIndex: (0, $5f256c83f1a297c6$export$7b4c8bd6e6871332),
    pageNumber: (0, $5f256c83f1a297c6$export$973e710208ddd50f),
    pdf: (0, $5f256c83f1a297c6$export$d22001c6ab8dd37),
    renderAnnotationLayer: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
    renderMode: (0, $5f256c83f1a297c6$export$70f0c3edbd58f82c),
    renderTextLayer: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).bool,
    rotate: (0, $5f256c83f1a297c6$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($0e6b0d5a9628b095$exports))).number
});
var $da91ea8433bc7591$export$2e2bcd8739ae039 = $da91ea8433bc7591$var$Page;



const $97fc7d6e74a4cfb9$var$PrintingPreview = ({ url: url, printingAllowed: printingAllowed })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const printingCallback = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.printingCallback);
    const [documentLoaded, setDocumentLoaded] = (0, $lT7pJ.useState)(false);
    const [numberOfPages, setNumberOfPages] = (0, $lT7pJ.useState)(0);
    const [pageNumber, setPageNumber] = (0, $lT7pJ.useState)(1);
    const onDocumentLoadSuccess = ({ numPages: numPages })=>{
        setNumberOfPages(numPages);
        setDocumentLoaded(true);
    };
    const handleClick = ()=>{
        console.log("Call printing and close preview");
        printingCallback?.(url);
        handleClose();
    };
    const handleClose = ()=>{
        (0, $1bda010252da638c$export$4317154639841e84)(null);
    };
    const changePage = (index)=>{
        setPageNumber((current)=>current + index);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-h-full large-vertical:rf-mt-[20vh] large-vertical:rf-h-1/2 rf-max-w-1/2 large-vertical:rf-max-w-[60%] rf-py-4 rf-flex rf-flex-col rf-gap-4",
        style: {
            visibility: documentLoaded ? "visible" : "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-grid rf-grid-cols-printingPreview rf-min-h-12 rf-h-12",
                children: [
                    printingAllowed ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
                        className: "rf-px-4 rf-py-1 rf-h-full rf-justify-self-center rf-flex rf-flex-row rf-items-center rf-gap-2 rf-font-bold rf-text-sm rf-rounded-lg rf-bg-truewhite",
                        onClick: handleClick,
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8020f0ddfe1ce5ff$export$2e2bcd8739ae039), {}),
                            translation.common.print
                        ]
                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        children: "\u2800"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                        className: "rf-h-full rf-w-12 rf-justify-self-end rf-flex rf-justify-center rf-items-center rf-rounded-lg rf-bg-truewhite",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1bb6c2a3a9b42097$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-relative rf-w-full rf-flex rf-flex-col rf-rounded-lg rf-overflow-y-scroll rf-scrollbar-thin",
                children: [
                    numberOfPages > 1 && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-w-full rf-px-4 rf-pt-3 rf-pb-2 rf-flex rf-flex-row rf-justify-between rf-items-center rf-bg-truewhite",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                                className: `${pageNumber <= 1 ? "rf-invisible" : "rf-visible"}`,
                                onClick: ()=>changePage(-1),
                                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ac7dab0223ec91d1$export$2e2bcd8739ae039), {
                                    className: "rf-h-4",
                                    color: "#000"
                                })
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                className: "rf-text-xl",
                                children: [
                                    pageNumber,
                                    " / ",
                                    numberOfPages
                                ]
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                                className: `${pageNumber >= numberOfPages ? "rf-invisible" : "rf-visible"}`,
                                onClick: ()=>changePage(1),
                                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6d2bee83684dead6$export$2e2bcd8739ae039), {
                                    className: "rf-h-4",
                                    color: "#000"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $2b9f28760947e06f$export$2e2bcd8739ae039), {
                        file: url,
                        onLoadSuccess: onDocumentLoadSuccess,
                        onLoadError: handleClose,
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $da91ea8433bc7591$export$2e2bcd8739ae039), {
                            pageNumber: pageNumber,
                            renderAnnotationLayer: false,
                            renderTextLayer: false
                        })
                    })
                ]
            })
        ]
    });
};
var $97fc7d6e74a4cfb9$export$2e2bcd8739ae039 = $97fc7d6e74a4cfb9$var$PrintingPreview;


const $76ac15eb6f5c5257$var$LinkAttachment = ({ urlData: urlData, fileName: fileName, qrCode: qrCode, description: description, height: height })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.isUsedOnBorne);
    const enableDocumentPrinting = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.enableDocumentPrinting);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    !fileName && (fileName = (0, $321ecf0344ece19a$export$a6f11fce0a840e6c)(urlData.url));
    const title = urlData.title || fileName;
    const [qrCodeData, setQrCodeData] = (0, $lT7pJ.useState)(qrCode);
    const [textToDisplay, setTextToDisplay] = (0, $lT7pJ.useState)("");
    (0, $lT7pJ.useEffect)(()=>{
        setTextToDisplay((0, $412d46e5db76a0eb$export$2eb1c1cc4b12d451)({
            translation: translation,
            isUsedOnBorne: isUsedOnBorne,
            data: urlData,
            fileName: fileName
        }));
    }, [
        isUsedOnBorne,
        locale,
        urlData
    ]);
    /**
   * On component creation :
   *  - call setQrCodeDataAsync only if used on a borne
   */ (0, $lT7pJ.useEffect)(()=>{
        !qrCode && isUsedOnBorne && setQrCodeDataAsync();
    }, []);
    /**
   * On call :
   *  - generate a qrcode as dataURL
   *  - set qrCodeData state with the data
   */ const setQrCodeDataAsync = async ()=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($33b99b026c95b649$exports))).toDataURL(urlData.url);
        setQrCodeData(qrCodeString);
    };
    const handleClick = ()=>{
        (0, $1bda010252da638c$export$4317154639841e84)(/*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $97fc7d6e74a4cfb9$export$2e2bcd8739ae039), {
            url: urlData.url,
            printingAllowed: !!enableDocumentPrinting
        }));
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-p-[25px] rf-flex rf-flex-col rf-items-center rf-gap-4 ${title || description ? "rf-justify-between" : "rf-justify-around"} rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin`,
        style: {
            height: height,
            touchAction: "pan-y"
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-w-full ${description ? "rf-text-left" : "rf-text-center"} rf-title-size-auto ${isUsedOnBorne ? "rf-truncate" : "rf-line-clamp-2"}`,
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(title)
            }),
            isUsedOnBorne ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    urlData.url.length > 4 && urlData.url.substring(urlData.url.length - 4) === ".pdf" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-full rf-pb-10 rf-flex rf-items-center rf-justify-center",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
                            className: "rf-px-4 rf-py-1 rf-flex rf-flex-row rf-gap-2 rf-items-center rf-border-2 rf-text-primary rf-border-primary hover:rf-text-truewhite hover:rf-border-truewhite rf-rounded-lg rf-text-sm rf-font-bold",
                            onClick: handleClick,
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3be42645e89159d9$export$2e2bcd8739ae039), {
                                    color: themeColors.primary
                                }),
                                translation.link.buttonText
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-center",
                        children: [
                            description && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                children: description
                            }),
                            qrCodeData && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $afe82365b658f5fb$export$2e2bcd8739ae039), {
                                src: qrCodeData
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-relative rf-text-center rf-mx-8 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $048e611f22f84ada$export$2e2bcd8739ae039), {
                                className: "rf-absolute rf-top-[0.125rem] -rf-left-6 rf-h-4"
                            }),
                            textToDisplay
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    description && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-mb-4",
                        children: description
                    }),
                    urlData.download && urlData.title && textToDisplay.length >= 40 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $33e594b7da788c68$export$2e2bcd8739ae039), {
                        url: urlData.url,
                        text: textToDisplay,
                        download: true
                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $76460312b79c28bb$export$2e2bcd8739ae039), {
                        url: urlData.url,
                        text: textToDisplay,
                        description: !!description,
                        download: !!urlData.download
                    })
                ]
            })
        ]
    });
};
var $76ac15eb6f5c5257$export$2e2bcd8739ae039 = $76ac15eb6f5c5257$var$LinkAttachment;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("lT7pJ");




const $d71785f3ab74c95b$var$MultiLinkAttachment = ({ urlData: urlData, title: title, description: description, height: height })=>{
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-p-[25px] rf-flex rf-flex-col rf-items-center rf-gap-2 ${title || description ? "rf-justify-between" : "rf-justify-around"} rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin`,
        style: {
            height: height,
            touchAction: "pan-y"
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-w-full rf-mb-4 ${description ? "rf-text-left" : "rf-text-center"} rf-title-size-auto ${configuration.isUsedOnBorne ? "rf-truncate" : "rf-line-clamp-2"}`,
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(title)
            }),
            description && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-mb-4",
                children: description
            }),
            urlData.map((data, key)=>{
                return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $33e594b7da788c68$export$2e2bcd8739ae039), {
                    url: data.url,
                    text: data.title || (0, $321ecf0344ece19a$export$a6f11fce0a840e6c)(data.url) || data.url,
                    download: !!data.download
                }, key);
            })
        ]
    });
};
var $d71785f3ab74c95b$export$2e2bcd8739ae039 = $d71785f3ab74c95b$var$MultiLinkAttachment;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");







const $419f537eee9dc09c$var$SuggestedActionAttachment = ({ title: title, actions: actions, history: history, height: height })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const unlockClickedButton = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.unlockClickedButton);
    const [clicked, setClicked] = (0, $lT7pJ.useState)(null);
    const animationColor = {
        "--rf-color-loader-animation": themeColors.card.button.text.default
    };
    (0, $lT7pJ.useEffect)(()=>{
        unlockClickedButton && setClicked(null);
    }, [
        unlockClickedButton
    ]);
    const handleClick = (value, index)=>{
        (0, $1bda010252da638c$export$5d55805fc8a86c05)();
        setClicked(index);
        (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(value);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-p-4 rf-flex rf-flex-col rf-items-center rf-justify-center rf-rounded rf-bg-cardFrameBackground",
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-pb-4 rf-text-center rf-text-cardFrameText rf-subtitle-size-auto",
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(title, locale)
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-pt-4 rf-flex rf-flex-row rf-justify-center rf-items-center rf-gap-4 rf-flex-wrap",
                children: actions.map((action, key)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                        className: clicked === key ? "rf-card-button-clicked" : "rf-card-button",
                        onClick: history ? ()=>{} : ()=>handleClick(action.action, key),
                        children: clicked === key ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-w-full rf-h-[1.25rem] large:rf-h-[1.3rem] rf-flex rf-justify-center rf-items-center",
                            style: {
                                ...animationColor
                            },
                            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-w-2 rf-h-2 large:rf-w-4 large:rf-h-4",
                                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3f55b239f06aa14f$export$2e2bcd8739ae039), {
                                    size: isMobile ? (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).small : (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).medium
                                })
                            })
                        }) : action.title || "?"
                    }, key);
                })
            })
        ]
    });
};
var $419f537eee9dc09c$export$2e2bcd8739ae039 = $419f537eee9dc09c$var$SuggestedActionAttachment;




var $lT7pJ = parcelRequire("lT7pJ");








var $lT7pJ = parcelRequire("lT7pJ");
const $5c904e8418a9f255$var$SvgColorChanger = ({ svgUrl: svgUrl, fillColor: fillColor, height: height })=>{
    const [modifiedSvg, setModifiedSvg] = (0, $lT7pJ.useState)(null);
    (0, $lT7pJ.useEffect)(()=>{
        // Fonction pour charger et modifier le contenu SVG
        const loadAndModifySvg = async ()=>{
            try {
                // Récupérez le contenu SVG via Fetch
                const response = await fetch(svgUrl);
                const svgContent = await response.text();
                // Modifiez le contenu SVG pour changer la couleur et la taille
                // Remove xml tag that can appear at the beginning of the data
                let modifiedSvgContent = svgContent.replace(/<!--[^>]+-->/g, "");
                // Remove comments that can appear inside the data
                modifiedSvgContent = modifiedSvgContent.replace(/<\?xml[^>]+>/g, "");
                if (fillColor) {
                    if (modifiedSvgContent.indexOf("fill=") === -1) {
                        // Add "fill" property to the svg if it does not exist and a fillColor was given
                        const firstSvgClosing = modifiedSvgContent.indexOf(">");
                        if (firstSvgClosing) {
                            // Get the first svg tag, add "fill=<fillColor>" inside and replace the content of the svg
                            const tempFirstSvgTag = modifiedSvgContent.substring(0, firstSvgClosing);
                            modifiedSvgContent = modifiedSvgContent.replace(modifiedSvgContent.substring(0, firstSvgClosing), `${tempFirstSvgTag} fill="${fillColor}"`);
                        }
                    } else modifiedSvgContent = modifiedSvgContent.replace(/fill="#[A-Fa-f0-9]+"/g, `fill="${fillColor}"`).replace(/fill='#[A-Fa-f0-9]+'/g, `fill='${fillColor}'`);
                    // Change the "stroke" data with the chosen color
                    modifiedSvgContent = modifiedSvgContent.replace(/stroke:[^;]+;/g, `stroke: ${fillColor};`);
                }
                if (height) {
                    // Remove width and change height by the one wanted in the first tag of the svg
                    const firstSvgClosing = modifiedSvgContent.indexOf(">");
                    if (firstSvgClosing) {
                        let tempFirstSvgTag = modifiedSvgContent.substring(0, firstSvgClosing).replace(/width="[^"]+"/, "").replace(/height="[^"]+"/, `height="${height}"`);
                        // Add "height" property if not present in the tag
                        tempFirstSvgTag.indexOf("height") === -1 && (tempFirstSvgTag = `${tempFirstSvgTag} height="${height}"`);
                        modifiedSvgContent = modifiedSvgContent.replace(modifiedSvgContent.substring(0, firstSvgClosing), tempFirstSvgTag);
                    }
                }
                // Mettez à jour l'état avec le SVG modifié
                setModifiedSvg(modifiedSvgContent);
            } catch (error) {
                console.error("Une erreur s'est produite lors de la r\xe9cup\xe9ration du SVG :", error);
            }
        };
        // Chargez et modifiez le SVG lorsque le composant est monté
        loadAndModifySvg();
    }, [
        svgUrl,
        fillColor
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {
        children: modifiedSvg && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            style: {
                height: height || "100%"
            },
            dangerouslySetInnerHTML: {
                __html: modifiedSvg
            }
        })
    });
};
var $5c904e8418a9f255$export$2e2bcd8739ae039 = $5c904e8418a9f255$var$SvgColorChanger;



const $4c2d9a98c98f9746$var$DiscoverAttachment = ({ title: title, mainButtons: mainButtons, recommandationButton: recommandationButton, history: history, height: height })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const unlockClickedButton = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.unlockClickedButton);
    const displayLayout = (0, $lT7pJ.useMemo)(()=>{
        if (mainButtons && mainButtons.length > 1) return `rf-w-full rf-grid rf-grid-cols-${mainButtons.length} rf-gap-2 large:rf-gap-4`;
        return "rf-w-1/2 rf-justify-self-center";
    }, [
        mainButtons
    ]);
    const [clicked, setClicked] = (0, $lT7pJ.useState)(false);
    const [discoverClicked, setDiscoverClicked] = (0, $lT7pJ.useState)(null);
    const animationColor = {
        "--rf-color-loader-animation": themeColors.card.button.text.default
    };
    const handleClick = (data, index)=>{
        if (discoverClicked === null || discoverClicked !== index) {
            (0, $1bda010252da638c$export$5d55805fc8a86c05)();
            let dataToSend = {};
            // @ts-ignore
            if (data.eventName) {
                const tempData = data;
                setClicked(true);
                dataToSend = {
                    type: "event",
                    name: tempData.eventName,
                    recommendationId: tempData.recommendationId
                };
            } else if (index !== undefined) {
                setDiscoverClicked(index);
                const tempData = data;
                dataToSend = {
                    type: "event",
                    name: tempData.EventName,
                    value: {
                        filterId: tempData.FilterId,
                        filterValue: tempData.FilterValue,
                        followingCardText: tempData.FollowingCardText,
                        identifier: tempData.Identifier
                    }
                };
            }
            (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, dataToSend);
        }
    };
    (0, $lT7pJ.useEffect)(()=>{
        if (unlockClickedButton) {
            setClicked(false);
            setDiscoverClicked(null);
        }
    }, [
        unlockClickedButton
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-flex rf-flex-col rf-items-center rf-justify-between rf-rounded rf-bg-cardFrameBackground large:rf-p-[25px] rf-p-4 ${history && "rf-pointer-events-none"} `,
        style: {
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-title-size-auto rf-mb-3 rf-text-center",
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(title, locale)
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-h-full ${displayLayout}`,
                children: mainButtons && mainButtons.length > 0 ? mainButtons.map((button, i)=>{
                    let colorButtonHandle = "";
                    if (button.EventName.indexOf("TouristAttractions") > -1) colorButtonHandle = themeColors.tobeDoneColor;
                    else if (button.EventName.indexOf("Products") > -1) colorButtonHandle = themeColors.localProductsColor;
                    else if (button.EventName.indexOf("FoodEstablishments") > -1) colorButtonHandle = themeColors.whereToEatColor;
                    else if (button.EventName.indexOf("LodgingBusinesses") > -1) colorButtonHandle = themeColors.whereToSleepColor;
                    else if (button.EventName.indexOf("TouristDestinations") > -1) colorButtonHandle = themeColors.tobeSeenColor;
                    else if (button.EventName.indexOf("Event") > -1) colorButtonHandle = themeColors.agendaColor;
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-relative rf-w-full rf-card-button-discover rf-rounded rf-flex rf-flex-col rf-gap-2 large:rf-gap-3 rf-items-center rf-justify-self-center",
                        onClick: ()=>handleClick(button, i),
                        style: {
                            boxShadow: "0px 0px 13px #0000009c"
                        },
                        children: discoverClicked === i ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center",
                            style: {
                                ...animationColor
                            },
                            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6",
                                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3f55b239f06aa14f$export$2e2bcd8739ae039), {
                                    size: isMobile ? (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).medium : (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).large
                                })
                            })
                        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                            children: [
                                button.MediaUrl.indexOf("svg") > -1 && colorButtonHandle !== "" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5c904e8418a9f255$export$2e2bcd8739ae039), {
                                    svgUrl: button.MediaUrl,
                                    height: "50px",
                                    fillColor: colorButtonHandle
                                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                                    src: button.MediaUrl,
                                    alt: button.Text,
                                    style: {
                                        height: "50px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                    className: "rf-h-full rf-flex rf-items-center rf-text-center rf-uppercase rf-font-bold large:rf-text-basecustom rf-text-xsl rf-overflow-wrap",
                                    children: button.Text
                                })
                            ]
                        })
                    }, i);
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {})
            }),
            recommandationButton && mainButtons && mainButtons.length > 1 && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-mt-4 rf-font-bold ${clicked ? "rf-card-button-clicked" : "rf-card-button"} rf-text-center rf-capitalize-first`,
                onClick: ()=>handleClick(recommandationButton),
                children: clicked ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-w-full rf-h-[1.25rem] large:rf-h-[1.3rem] rf-flex rf-justify-center rf-items-center",
                    style: {
                        ...animationColor
                    },
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3f55b239f06aa14f$export$2e2bcd8739ae039), {
                            size: isMobile ? (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).medium : (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).large
                        })
                    })
                }) : recommandationButton.text
            })
        ]
    });
};
var $4c2d9a98c98f9746$export$2e2bcd8739ae039 = $4c2d9a98c98f9746$var$DiscoverAttachment;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");




/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");






const $5f58b50f62d39ac1$var$BorderlessButtonMessage = ({ text: text, differentTextTosend: differentTextTosend })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const unlockClickedButton = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.unlockClickedButton);
    const [hover, setHover] = (0, $lT7pJ.useState)(false);
    const [clicked, setClicked] = (0, $lT7pJ.useState)(false);
    const animationColor = {
        "--rf-color-loader-animation": themeColors.card.button.text.default
    };
    const onClick = (text)=>{
        setClicked(true);
        (0, $1bda010252da638c$export$5d55805fc8a86c05)();
        (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(text);
    };
    (0, $lT7pJ.useEffect)(()=>{
        unlockClickedButton && setClicked(false);
    }, [
        unlockClickedButton
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-flex rf-justify-start rf-cursor-pointer",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
            className: "rf-w-full rf-flex rf-flex-row rf-items-center rf-justify-start rf-text-cardButtonTextDefault",
            onPointerEnter: ()=>setHover(true),
            onPointerLeave: ()=>setHover(false),
            onClick: ()=>{
                setHover(true);
                onClick(differentTextTosend || text);
            },
            children: [
                clicked ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-h-6 rf-w-6 rf-flex rf-justify-center rf-items-center",
                    style: {
                        ...animationColor
                    },
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-2 rf-h-2",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3f55b239f06aa14f$export$2e2bcd8739ae039), {
                            size: (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).small
                        })
                    })
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: `rf-h-6 rf-w-6 rf-rounded ${hover ? "rf-bg-cardButtonBackgroundHover" : "rf-bg-cardButtonBackgroundDefault"}`,
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4365628ed5afaad5$export$2e2bcd8739ae039), {
                        className: "rf-h-6 rf-p-1 rf-border rf-rounded rf-border-cardButtonBorderDefault",
                        color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                    })
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-ml-4",
                    children: text || ""
                })
            ]
        })
    });
};
var $5f58b50f62d39ac1$export$2e2bcd8739ae039 = $5f58b50f62d39ac1$var$BorderlessButtonMessage;



const $6270c193a5022885$var$SuggestionAttachment = ({ suggestions: suggestions, title: title, description: description, height: height, history: history, showTutorial: showTutorial })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const onTutorialClick = ()=>{
        // TODO
        console.log("show tutorial");
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full large:rf-p-[25px] rf-p-4 rf-flex rf-flex-col rf-items-center rf-gap-2 ${title || description ? "rf-justify-between" : "rf-justify-around"} rf-min-h-inherit rf-rounded rf-bg-cardFrameBackground rf-text-cardFrameText rf-overflow-y-scroll rf-scrollbar-thin ${history && "rf-pointer-events-none"} `,
        style: {
            height: height,
            touchAction: "pan-y"
        },
        children: [
            title && // Title on the left if there is a description, middle otherwise
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-w-full ${description ? "rf-text-left" : "rf-text-center"} rf-title-size-auto ${configuration.isUsedOnBorne ? "rf-truncate" : "rf-line-clamp-2"}`,
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(title)
            }),
            description && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-text-left rf-w-full",
                children: description
            }),
            suggestions?.map((data, key)=>{
                const text = typeof data === "string" ? data : data.text;
                const differentTextTosend = typeof data === "string" ? undefined : data.differentTextToSend || data.text;
                return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5f58b50f62d39ac1$export$2e2bcd8739ae039), {
                        text: text,
                        differentTextTosend: differentTextTosend
                    })
                }, key);
            }),
            showTutorial && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-text-left rf-w-full rf-flex rf-items-end rf-italic",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $048e611f22f84ada$export$2e2bcd8739ae039), {
                        className: "rf-pr-2 rf-h-6",
                        color: themeColors.card.button.text.default
                    }),
                    `${translation.common.needhelp} ${translation.suggestion.consult}`,
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("span", {
                        className: "rf-pl-1 rf-underline rf-cursor-pointer",
                        onClick: onTutorialClick,
                        children: translation.suggestion.thetutorial
                    })
                ]
            })
        ]
    });
};
var $6270c193a5022885$export$2e2bcd8739ae039 = $6270c193a5022885$var$SuggestionAttachment;




var $lT7pJ = parcelRequire("lT7pJ");














const $5e321a70190d29ee$var$springEnterDuration = 1000;
const $5e321a70190d29ee$var$springQrCodeDuration = 500;
const $5e321a70190d29ee$var$md = new (0, $c1dfe7a9dc4f2ee7$export$2e2bcd8739ae039)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    typographer: true,
    quotes: `""''`
});
const $5e321a70190d29ee$var$GridAttachment = ({ index: index, text: text, textColor: textColor, backgroundColor: backgroundColor, image: image, action: action, history: history })=>{
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.isUsedOnBorne);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const [qrCodeData, setQrCodeData] = (0, $lT7pJ.useState)(undefined);
    const fadeInTimerRef = (0, $lT7pJ.useRef)(null);
    const divRef = (0, $lT7pJ.useRef)(null);
    const tileDimensions = (0, $57fa40eeebe37d0d$export$2e2bcd8739ae039)(divRef);
    const height = (0, $lT7pJ.useMemo)(()=>{
        return tileDimensions.width * 0.75;
    }, [
        tileDimensions.width
    ]);
    const showImage = (0, $lT7pJ.useMemo)(()=>{
        return !!(image?.url && height > 80);
    }, [
        height,
        image
    ]);
    const nbLines = (0, $lT7pJ.useMemo)(()=>{
        if (!showImage) {
            const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const lineHeightInPx = remToPx * (isMobile ? 1 : 1.1);
            return Math.floor(height / lineHeightInPx);
        }
        return 2;
    }, [
        showImage,
        height
    ]);
    const lineClamp = (0, $lT7pJ.useMemo)(()=>{
        return showImage ? "rf-h-2/5 rf-line-clamp-2" : `rf-line-clamp-${nbLines}`;
    }, [
        nbLines,
        showImage
    ]);
    const maxHeight = (0, $lT7pJ.useMemo)(()=>{
        return showImage ? "rf-max-h-8 large:rf-max-h-[2.3rem]" : `rf-max-h-[${nbLines}rem] large:rf-max-h-[${nbLines * 1.1 + 0.1}rem]`;
    }, [
        nbLines,
        showImage
    ]);
    const [spring, api] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                transform: "translateX(0%)",
                opacity: 0
            }
        }));
    const [qrCodeSpring, qrCodeApi] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $lT7pJ.useEffect)(()=>{
        setTimeout(()=>{
            api.start({
                from: {
                    transform: "translateX(100%)",
                    opacity: 0
                },
                to: {
                    transform: "translateX(0%)",
                    opacity: 1
                },
                config: {
                    duration: $5e321a70190d29ee$var$springEnterDuration,
                    easing: (0, $bd140d0b30421f1c$export$15a0bf1b4bbacad8).easeInBack
                }
            });
        }, index * 200);
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        qrCodeData && qrCodeApi.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $5e321a70190d29ee$var$springQrCodeDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeData
    ]);
    const handleCloseQrCode = ()=>{
        qrCodeApi.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $5e321a70190d29ee$var$springQrCodeDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeData(undefined);
        }, $5e321a70190d29ee$var$springQrCodeDuration);
    };
    const setQrCodeDataAsync = async (url)=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($33b99b026c95b649$exports))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    const handleInternalAction = (value)=>{
        if (value?.name) switch(value.name.toLowerCase()){
            case "openmenu":
                (0, $1bda010252da638c$export$bbd7c92fc378d660)(true);
                break;
            case "openlanguage":
                (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).languages);
                break;
            case "openhistory":
                (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).history);
                break;
            case "opentutorial":
                console.log("Open tutorial");
                break;
            case "fullscreenimage":
                value.url && (0, $1bda010252da638c$export$4e062bd31c814155)(value.url);
                break;
        }
    };
    const handleClick = ()=>{
        switch(action.type){
            case (0, $45d43a6de0968f42$export$e4a712fff93fb00f).message:
                action.value?.text && (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(action.value.text);
                break;
            case (0, $45d43a6de0968f42$export$e4a712fff93fb00f).event:
                action.value?.name && (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)(action.value.name, action.value.value || null);
                break;
            case (0, $45d43a6de0968f42$export$e4a712fff93fb00f).url:
                if (action.value?.url) // Generate QR-code data on borne, open the URL otherwise
                isUsedOnBorne ? setQrCodeDataAsync(action.value.url) : window.open(action.value.url, "_blank", "noopener noreferrer");
                break;
            case (0, $45d43a6de0968f42$export$e4a712fff93fb00f).internal:
                handleInternalAction(action.value);
                break;
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $dc32a48dada8397f$export$407448d2b89b1813).div, {
        ref: divRef,
        className: `rf-relative rf-w-full ${history ? "rf-p-3 rf-pointer-events-none" : "rf-p-4"} rf-flex rf-flex-col ${image?.url ? "rf-justify-between" : "rf-justify-end"} rf-items-start rf-gap-[10%] ${isMobile ? "rf-border rf-border-[#F0F0F0]" : ""} hover:rf-shadow-[inset_0_0_12px_#00000029] hover:rf-cursor-pointer rf-rounded rf-shadow-[-3px_-3px_10px_#00000099] rf-overflow-hidden`,
        style: {
            height: `calc(${height}px + 1.5rem)`,
            color: textColor || "#575F6B",
            backgroundColor: backgroundColor || "#FFF",
            ...spring
        },
        onClick: handleClick,
        children: [
            showImage && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-h-1/2",
                children: image?.url && image.url.indexOf("svg") > -1 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5c904e8418a9f255$export$2e2bcd8739ae039), {
                    svgUrl: image.url,
                    height: "100%",
                    fillColor: image.color
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                    className: "rf-h-full",
                    src: image?.url
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-flex rf-min-h-8 large:rf-min-h-[2.3rem] ${lineClamp} rf-items-start rf-text-small-size-auto rf-text-left rf-overflow-y-hidden`,
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                    className: `${maxHeight} rf-overflow-y-clip`,
                    dangerouslySetInnerHTML: {
                        __html: $5e321a70190d29ee$var$md.renderInline(text)
                    }
                })
            }),
            qrCodeData && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $dc32a48dada8397f$export$407448d2b89b1813).div, {
                className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2 rf-p-2 rf-text-truewhite",
                style: {
                    background: "rgba(18,18,18,0.7)",
                    ...qrCodeSpring
                },
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e5699fc9e4e13353$export$2e2bcd8739ae039), {
                        onClick: handleCloseQrCode,
                        showLabel: false
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-px-8 rf-flex rf-flex-row rf-items-start rf-gap-1 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8c84d47da720aa29$export$2e2bcd8739ae039), {
                                color: "#FFF"
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-w-fit",
                                children: translation.link.scanQRTile
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $afe82365b658f5fb$export$2e2bcd8739ae039), {
                        src: qrCodeData
                    })
                ]
            })
        ]
    });
};
var $5e321a70190d29ee$export$2e2bcd8739ae039 = $5e321a70190d29ee$var$GridAttachment;




var $lT7pJ = parcelRequire("lT7pJ");


const $8eca7827097c8ba4$var$adaptiveCard = new $d97a7c55f35040d9$exports.AdaptiveCard();
const $8eca7827097c8ba4$var$AdaptiveCardAttachment = ({ content: content, height: height })=>{
    const adaptiveCardHostConfig = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.adaptiveCardHostConfig);
    const divRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        $8eca7827097c8ba4$var$adaptiveCard.hostConfig = adaptiveCardHostConfig;
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        content.minHeight = height ? `${height}px` : "0px";
        content.verticalContentAlignment = "Center";
        $8eca7827097c8ba4$var$adaptiveCard.parse(content);
        const htmlValue = $8eca7827097c8ba4$var$adaptiveCard.render();
        if (divRef.current) {
            divRef.current.firstChild?.remove();
            htmlValue && divRef.current.appendChild(htmlValue);
        }
    }, [
        content,
        height
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        ref: divRef
    });
};
var $8eca7827097c8ba4$export$2e2bcd8739ae039 = $8eca7827097c8ba4$var$AdaptiveCardAttachment;


const $6c276f4a56f91e17$var$renderAttachment = ({ attachment: attachment, history: history, height: height })=>{
    switch(attachment.contentType){
        case 0, $59de7fd3862e5431$export$7ff82c027074e396:
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5d44f708beac5bc9$export$2e2bcd8739ae039), {
                ...attachment.content,
                height: height
            });
        case 0, $59de7fd3862e5431$export$8c612ad42a82284:
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a1a8df2de4f5d186$export$2e2bcd8739ae039), {
                ...attachment.content
            });
        case 0, $59de7fd3862e5431$export$9399f66a54c38cac:
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $f1ef0a7797aa40fb$export$2e2bcd8739ae039), {});
        case 0, $59de7fd3862e5431$export$c50891df8986f6d9:
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $86b4dd20fa27be48$export$2e2bcd8739ae039), {
                ...attachment.content,
                height: height
            });
        case 0, $59de7fd3862e5431$export$cce25171fe980112:
            return Array.isArray(attachment.content.urlData) ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d71785f3ab74c95b$export$2e2bcd8739ae039), {
                ...attachment.content,
                height: height
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $76ac15eb6f5c5257$export$2e2bcd8739ae039), {
                ...attachment.content,
                height: height
            });
        case 0, $59de7fd3862e5431$export$2730c89e9ebd0948:
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $419f537eee9dc09c$export$2e2bcd8739ae039), {
                ...attachment.content,
                history: history,
                height: height
            });
        case 0, $59de7fd3862e5431$export$8ebd8d161896e63a:
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4c2d9a98c98f9746$export$2e2bcd8739ae039), {
                ...attachment.content,
                history: history,
                height: height
            });
        case 0, $59de7fd3862e5431$export$a4f2f23a67537f78:
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6270c193a5022885$export$2e2bcd8739ae039), {
                ...attachment.content,
                history: history,
                height: height
            });
        case 0, $59de7fd3862e5431$export$25f48dcc671a4afe:
        case 0, $59de7fd3862e5431$export$98515f55cf51a42d:
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5e321a70190d29ee$export$2e2bcd8739ae039), {
                ...attachment.content,
                history: history
            });
        default:
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8eca7827097c8ba4$export$2e2bcd8739ae039), {
                content: attachment.content,
                height: height
            });
    }
};
var $6c276f4a56f91e17$export$2e2bcd8739ae039 = $6c276f4a56f91e17$var$renderAttachment;




parcelRequire("lT7pJ");
const $83a1eb52d5b16844$var$Animation2 = ({ color: color, loaderColor: loaderColor, backgroundColor: backgroundColor })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("svg", {
        "aria-hidden": "true",
        className: "rf-inline rf-w-8 rf-h-8 rf-mr-2 rf-animate-spin ",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            backgroundColor: backgroundColor
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor",
                style: {
                    fill: color
                }
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill",
                style: {
                    fill: loaderColor
                }
            })
        ]
    });
};
var $83a1eb52d5b16844$export$2e2bcd8739ae039 = $83a1eb52d5b16844$var$Animation2;




var $lT7pJ = parcelRequire("lT7pJ");



const $514466c41d6b7fdd$var$useFullscreenImage = ()=>{
    const activities = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.botEventActivities);
    const { fullScreenImage: fullScreenImage } = (0, $1bda010252da638c$export$77e4cc5334565f28)();
    if (fullScreenImage) return fullScreenImage;
    if (activities && activities.length > 0) {
        const lastActivity = activities.slice(-1)[0];
        if (lastActivity.type === "event" && lastActivity.name === "hospitality.ShowImage" && lastActivity.value) return lastActivity.value;
    }
    return undefined;
};
var $514466c41d6b7fdd$export$2e2bcd8739ae039 = $514466c41d6b7fdd$var$useFullscreenImage;




parcelRequire("lT7pJ");
const $bd298cea0c2ad40c$var$ScrollButtonIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        className: className,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            id: "Icon_ionic-ios-arrow-down",
            fill: color,
            className: "st0",
            d: "M 49.948 29.033 L 13.413 65.414 C 10.792 68.035 6.323 68.188 3.702 65.414 C 3.702 65.414 3.702 65.414 3.702 65.414 C 1.081 62.639 1.081 58.322 3.702 55.702 L 45.015 14.388 C 47.636 11.767 51.798 11.767 54.573 14.233 L 96.195 55.856 C 98.97 58.477 98.97 62.947 96.195 65.568 C 93.574 68.343 89.103 68.343 86.484 65.568 L 49.948 29.033 Z"
        })
    });
};
var $bd298cea0c2ad40c$export$2e2bcd8739ae039 = $bd298cea0c2ad40c$var$ScrollButtonIcon;


const $aa3bf51137e07f42$var$ScrollButton = ({ direction: direction, display: display, scrollHandler: scrollHandler, setPreventScroll: setPreventScroll, className: className })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const fullScreenImage = (0, $514466c41d6b7fdd$export$2e2bcd8739ae039)();
    const divRef = (0, $lT7pJ.useRef)(null);
    const handleClick = ()=>{
        setPreventScroll(true);
        if (direction === "top") scrollHandler("top", "button");
        else scrollHandler("bottom", "button");
    };
    (0, $lT7pJ.useLayoutEffect)(()=>{
        divRef?.current && (0, $b5fe10956c349963$export$2e2bcd8739ae039)(divRef.current);
    });
    return display && !fullScreenImage ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        id: "ScrollButton",
        ref: divRef,
        className: className,
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $bd298cea0c2ad40c$export$2e2bcd8739ae039), {
            className: `${direction === "top" ? "rf-rotate-0" : "rf-rotate-180"}`,
            color: themeColors.primary
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {});
};
var $aa3bf51137e07f42$export$2e2bcd8739ae039 = $aa3bf51137e07f42$var$ScrollButton;


let $b6d28464c70bbdee$var$timer = null;
const $b6d28464c70bbdee$var$ListContainer = ({ hasFilterOrSuggestedAction: hasFilterOrSuggestedAction, numberOfResults: numberOfResults })=>{
    const { content: content, selectedFilters: selectedFilters, loadingData: loadingData, setLoadingData: setLoadingData } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const currentPagination = (0, $c134542dee0be23e$export$2e2bcd8739ae039)();
    const [contentToDisplay, setContentToDisplay] = (0, $lT7pJ.useState)([]);
    const [landscapeStyle, setLandscapeStyle] = (0, $lT7pJ.useState)("large:rf-h-3/5");
    const [limitToFill, setLimitToFill] = (0, $lT7pJ.useState)(0);
    const loadingRef = (0, $lT7pJ.useRef)(false);
    const scrollRef = (0, $lT7pJ.useRef)(null);
    const contentRef = (0, $lT7pJ.useRef)(null);
    const numberOfDisplayed = (0, $lT7pJ.useRef)();
    const [abortController, setAbortController] = (0, $lT7pJ.useState)(null);
    (0, $lT7pJ.useEffect)(()=>{
        setLandscapeStyle(hasFilterOrSuggestedAction ? "large:rf-h-[60vh]" : "");
    }, [
        hasFilterOrSuggestedAction
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        switch(currentDeviceType){
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).landscape:
                setLimitToFill(10);
                break;
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).borne:
                setLimitToFill(9);
                break;
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile:
            case (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget:
                setLimitToFill(0);
                break;
        }
    }, [
        currentDeviceType
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (content?.attachments && content.attachments.length > 0) {
            const filteredContent = content.attachments.filter((attachment)=>attachment.contentType === (0, $59de7fd3862e5431$export$8c612ad42a82284));
            if (content?.label === "Davi.NextPageContent") {
                // If we received new content to add to the current one, check for mobile and display all
                if (isMobile) {
                    // If the last attachment was added to get an even number, remove it before merging data
                    const oldAttachments = contentToDisplay[contentToDisplay.length - 1].contentType === (0, $59de7fd3862e5431$export$9399f66a54c38cac) ? [
                        ...contentToDisplay
                    ].slice(0, -1) : contentToDisplay;
                    const tempAttachments = [
                        ...oldAttachments,
                        ...filteredContent
                    ];
                    if (tempAttachments.length % 2 !== 0) setContentToDisplay([
                        ...tempAttachments,
                        {
                            contentType: (0, $59de7fd3862e5431$export$9399f66a54c38cac)
                        }
                    ]);
                    else setContentToDisplay(tempAttachments);
                } else setContentToDisplay([
                    ...contentToDisplay,
                    ...filteredContent
                ]);
            } else {
                // On a mobile device, if there is an odd number of attachments, we put a grey one at the end
                if (isMobile && filteredContent.length % 2 !== 0) setContentToDisplay([
                    ...filteredContent,
                    {
                        contentType: (0, $59de7fd3862e5431$export$9399f66a54c38cac)
                    }
                ]);
                else if (filteredContent.length < limitToFill) {
                    const tempAttachments = [
                        ...filteredContent
                    ];
                    let i = filteredContent.length;
                    while(i < limitToFill){
                        tempAttachments.push({
                            contentType: (0, $59de7fd3862e5431$export$9399f66a54c38cac)
                        });
                        i++;
                    }
                    setContentToDisplay(tempAttachments);
                } else setContentToDisplay(filteredContent);
            }
        } else setContentToDisplay([]);
    }, [
        content,
        limitToFill
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        loadingRef.current = loadingData;
    }, [
        loadingData
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        numberOfDisplayed.current = contentToDisplay.filter((item)=>item.contentType === (0, $59de7fd3862e5431$export$8c612ad42a82284)).length;
        content?.label !== "Davi.NextPageContent" && !isMobile ? $b6d28464c70bbdee$var$timer = setTimeout(()=>{
            scrollToRef();
        }, 100) : setLoadingData(false);
        return ()=>{
            $b6d28464c70bbdee$var$timer && clearTimeout($b6d28464c70bbdee$var$timer);
        };
    }, [
        contentToDisplay
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (contentRef?.current && isWidget) {
            if (currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetLandscape) {
                const ab = new AbortController();
                setAbortController(ab);
                (0, $b5fe10956c349963$export$2e2bcd8739ae039)(null, contentRef, ab.signal);
            } else {
                abortController?.abort();
                setAbortController(null);
            }
        }
    }, [
        contentRef?.current,
        currentDeviceType
    ]);
    /**
   * Click on 'see more' button in mobile mode or scroll to the end of the list in desktop / borne modes.
   * This will send a postback message with 'hospitality.pointOfInterest.nextPage' name to get new content
   */ const handleClick = ()=>{
        setLoadingData(true);
        numberOfDisplayed.current && (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, {
            name: "hospitality.pointOfInterest.nextPage",
            index: numberOfDisplayed.current < currentPagination ? 0 : numberOfDisplayed.current - (currentPagination - 2),
            filters: selectedFilters
        });
    };
    /**
   * Check if we need to call for next content
   */ const handleScroll = ()=>{
        if (contentRef?.current && contentRef.current.scrollTop + contentRef.current.clientHeight >= contentRef.current.scrollHeight - 5 && numberOfDisplayed?.current && numberOfDisplayed.current !== numberOfResults && !loadingRef.current) handleClick();
    };
    /**
   * Scroll to the scrollRef HTMLDivElement at the top of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
        setLoadingData(false);
    };
    return content ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                ref: contentRef,
                className: `rf-relative rf-w-full rf-mb-8 ${landscapeStyle} large-vertical:rf-h-[50vh] rf-overflow-y-visible large:rf-overflow-y-scroll rf-scrollbar-hidden ${!isMobile && "rf-opacity-gradient-b-thin"} rf-px-2 large:rf-px-0 rf-pb-8 large:rf-pb-16 ${loadingData && "rf-pointer-events-none"}`,
                onScroll: handleScroll,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        ref: scrollRef
                    }),
                    loadingData && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-absolute rf-z-util rf-w-full rf-flex rf-items-end rf-justify-center rf-bg-white rf-bg-opacity-50 rf-pointer-events-none",
                        style: {
                            height: contentRef?.current?.scrollHeight ? `${contentRef.current.scrollHeight}px` : "100%",
                            paddingBottom: contentRef?.current?.clientHeight ? `calc(${contentRef.current.clientHeight / 2}px - 6rem)` : "6rem"
                        },
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-w-6 rf-h-6 rf-mb-16",
                            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $83a1eb52d5b16844$export$2e2bcd8739ae039), {
                                color: "gray",
                                loaderColor: "#1999b1",
                                backgroundColor: "transparent"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d0a650716ddf332c$export$2e2bcd8739ae039), {
                        children: contentToDisplay.length === 0 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            children: translation.poi.nodata
                        }) : contentToDisplay.map((attachment, key)=>{
                            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                children: (0, $6c276f4a56f91e17$export$2e2bcd8739ae039)({
                                    attachment: attachment
                                })
                            }, key);
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-justify-end rf-gap-8",
                        children: [
                            numberOfDisplayed.current !== numberOfResults && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                                className: "rf-w-full rf-py-2 rf-bg-templateBackground rf-border rf-border-black rf-rounded rf-text-black",
                                onClick: handleClick,
                                children: "Voir plus"
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $aa3bf51137e07f42$export$2e2bcd8739ae039), {
                                direction: "top",
                                display: !!(numberOfDisplayed?.current && numberOfDisplayed.current > currentPagination),
                                scrollHandler: ()=>scrollToRef(),
                                setPreventScroll: ()=>{},
                                className: "rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                            })
                        ]
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $aa3bf51137e07f42$export$2e2bcd8739ae039), {
                direction: "top",
                display: !!(numberOfDisplayed?.current && numberOfDisplayed.current > currentPagination),
                scrollHandler: ()=>scrollToRef(),
                setPreventScroll: ()=>{},
                className: "rf-absolute rf-bottom-1/4 rf-right-3 rf-z-ui rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $b6d28464c70bbdee$export$2e2bcd8739ae039 = $b6d28464c70bbdee$var$ListContainer;



parcelRequire("lT7pJ");



parcelRequire("lT7pJ");



const $68391a2b20ecc996$var$VocalReminder = ({ className: className, handleClose: handleClose })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-start ${className}`,
        onClick: handleClose,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                src: (0, $15bfb737ffe6480e$export$e56d88b19b5c9fbf).leaMini,
                className: "rf-h-12"
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-align-start rf-justify-start",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-flex rf-flex-col rf-pl-2",
                        children: translation.template.reminder.split("\n").map((line, key)=>{
                            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                children: line
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4b95d9624e850f76$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $68391a2b20ecc996$export$2e2bcd8739ae039 = $68391a2b20ecc996$var$VocalReminder;



parcelRequire("lT7pJ");


const $a6e1aed523e89249$var$SuggestionsItem = ({ className: className, title: title, value: value, results: results, handleClick: handleClick })=>{
    const { locale: locale } = (0, $d0ec91114d7de49c$export$6650dace022cfacc)();
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        onClick: ()=>handleClick(value),
        className: `rf-h-fit rf-px-4 rf-py-3 rf-mr-4 rf-mb-4 large-vertical:rf-py-4 rf-border rf-rounded-lg rf-bg-templateBackground rf-text-black rf-border-black hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-center rf-justify-center ${className}`,
        "aria-label": title,
        children: [
            (0, $0fdc9a557a65290b$export$d07f57595c356899)(title, locale),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-ml-6 rf-text-gray",
                children: results || 0
            })
        ]
    });
};
var $a6e1aed523e89249$export$2e2bcd8739ae039 = $a6e1aed523e89249$var$SuggestionsItem;



const $2195f4e9b14321aa$var$Suggestions = ({ className: className, suggestions: suggestions, handleClose: handleClose })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const { setSuggestedFilter: setSuggestedFilter } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const handleClick = (value)=>{
        setSuggestedFilter(value);
        (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, {
            filters: [
                value
            ]
        });
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-flex rf-flex-col rf-items-start ${className}`,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-text-3xl large:rf-text-5xl rf-font-bold rf-mb-5",
                children: translation.template.suggestiontitle
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-flex rf-flex-row rf-flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-flex rf-flex-row rf-flex-wrap",
                        children: suggestions.map((suggestion, key)=>{
                            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a6e1aed523e89249$export$2e2bcd8739ae039), {
                                title: suggestion.title,
                                value: suggestion.value.filter,
                                results: suggestion.value.results !== undefined ? suggestion.value.results : "NC",
                                handleClick: handleClick
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $68391a2b20ecc996$export$2e2bcd8739ae039), {
                        handleClose: handleClose,
                        className: "large:rf-ml-12"
                    })
                ]
            })
        ]
    });
};
var $2195f4e9b14321aa$export$2e2bcd8739ae039 = $2195f4e9b14321aa$var$Suggestions;





const $31be23eb22ad1663$var$springEnterDuration = 1500;
const $31be23eb22ad1663$var$springLeaveDuration = 2500;
const $31be23eb22ad1663$var$List = ({ activity: activity, onClose: onClose })=>{
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const { content: content, filters: filters, selectedFilters: selectedFilters, setContent: setContent } = (0, $ad61851cc46e2afe$export$f9763ecd339e95eb)();
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const lastListActivity = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.lastListActivity);
    const [mobileFiltersOpened, setMobileFiltersOpened] = (0, $lT7pJ.useState)(false);
    const [largeFilterOpenedKey, setLargeFilterOpenedKey] = (0, $lT7pJ.useState)(undefined);
    const scrollRef = (0, $lT7pJ.useRef)(null);
    const [spring, api] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                transform: "translateX(0%)"
            }
        }));
    const timerRef = (0, $lT7pJ.useRef)(null);
    const divRef = (0, $lT7pJ.useRef)(null);
    const [abortController, setAbortController] = (0, $lT7pJ.useState)(null);
    const handleOpen = ()=>{
        (0, $1bda010252da638c$export$324bf243c7501c4d)(true);
        api.start({
            from: {
                transform: "translateX(-100%)"
            },
            to: {
                transform: "translateX(0%)"
            },
            config: {
                duration: $31be23eb22ad1663$var$springEnterDuration,
                easing: (0, $bd140d0b30421f1c$export$15a0bf1b4bbacad8).easeInBack
            }
        });
    };
    const handleClose = ()=>{
        (0, $1bda010252da638c$export$324bf243c7501c4d)(false);
        api.start({
            from: {
                transform: "translateX(0%)"
            },
            to: {
                transform: "translateX(-100%)"
            },
            config: {
                duration: $31be23eb22ad1663$var$springLeaveDuration,
                easing: (0, $bd140d0b30421f1c$export$15a0bf1b4bbacad8).easeOutExpo
            }
        });
        if (timerRef) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindow", null);
                (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindowList", null);
                onClose?.();
                setContent(undefined);
            }, $31be23eb22ad1663$var$springLeaveDuration);
        }
    };
    (0, $lT7pJ.useEffect)(()=>{
        if (activity && activity.id !== lastListActivity) {
            setContent(activity);
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                handleOpen();
            }
        }
        return ()=>{
            activity?.id && (0, $1bda010252da638c$export$e2194ce98b9711c9)(activity.id);
        };
    }, [
        activity
    ]);
    /**
   * On call :
   *  - scroll to the scrollRef HTML element at the top of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    };
    (0, $lT7pJ.useEffect)(()=>{
        if (divRef?.current && isWidget) {
            if (currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget) {
                const ab = new AbortController();
                setAbortController(ab);
                (0, $b5fe10956c349963$export$2e2bcd8739ae039)(null, divRef, ab.signal);
            } else {
                abortController?.abort();
                setAbortController(null);
            }
        }
    }, [
        divRef?.current,
        currentDeviceType
    ]);
    /**
   * On content change :
   *  - call scrollToRef method
   */ (0, $lT7pJ.useEffect)(()=>{
        const timer = content && isMobile && content.label !== "Davi.NextPageContent" ? setTimeout(()=>{
            scrollToRef();
        }, 100) : null;
        return ()=>{
            timer && clearTimeout(timer);
        };
    }, [
        content
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        handleOpen();
        return ()=>{
            (0, $1bda010252da638c$export$324bf243c7501c4d)(false);
            timerRef?.current && clearTimeout(timerRef.current);
        };
    }, []);
    return content ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $e04e42ecbb2c2cfa$export$2e2bcd8739ae039), {
        className: "large:rf-px-16 rf-flex rf-flex-col large:rf-h-full",
        handleClose: handleClose,
        onClick: isMobile ? ()=>{} : ()=>setLargeFilterOpenedKey(undefined),
        remoteCloseButtonZIndex: "rf-z-util",
        animation: spring,
        children: [
            isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a1830188b1d79c71$export$2e2bcd8739ae039), {
                setFiltersOpened: setMobileFiltersOpened,
                handleClose: handleClose,
                hasFilters: !!filters.length
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                ref: divRef,
                className: "rf-w-full rf-overflow-y-scroll rf-scrollbar-hidden",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        ref: scrollRef
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: `${mobileFiltersOpened ? "rf-hidden" : "rf-flex"} rf-flex-col rf-items-start large:rf-pt-16 large:rf-h-full large-vertical:rf-pt-[20vh]`,
                        children: [
                            content.text && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8b5d7b52aee9fdc8$export$2e2bcd8739ae039), {
                                className: "rf-ml-2 rf-mt-8 large:rf-ml-0 large:rf-mt-0",
                                title: (0, $0fdc9a557a65290b$export$d07f57595c356899)(content.text, locale),
                                numberOfResults: content.channelData?.numberOfResults || 0
                            }),
                            !isMobile && filters.length ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $b78685bbc4ab8f69$export$2e2bcd8739ae039), {
                                openedFilterKey: largeFilterOpenedKey,
                                setOpenedFilterKey: setLargeFilterOpenedKey
                            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}),
                            isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-flex rf-flex-row rf-mx-2 rf-gap-2 rf-mb-2 rf-flex-wrap",
                                children: selectedFilters?.map((chosenFilter, key1)=>{
                                    return chosenFilter.filterItems.map((item, key2)=>{
                                        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d5b10366165cf143$export$2e2bcd8739ae039), {
                                            className: "rf-px-2",
                                            filterItem: item,
                                            parent: {
                                                id: chosenFilter.id,
                                                title: chosenFilter.title
                                            }
                                        }, `${key1}-${key2}`);
                                    });
                                })
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $b6d28464c70bbdee$export$2e2bcd8739ae039), {
                                hasFilterOrSuggestedAction: filters.length > 0 || content.suggestedActions?.actions?.length > 0,
                                numberOfResults: content.channelData?.numberOfResults || 0
                            }),
                            content.suggestedActions?.actions?.length ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $2195f4e9b14321aa$export$2e2bcd8739ae039), {
                                className: "rf-px-2 large:rf-px-0 large:rf-mb-4",
                                suggestions: content.suggestedActions.actions,
                                handleClose: handleClose
                            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}),
                            isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text ? "rf-mb-28" : "rf-mb-16"
                            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {})
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $31be23eb22ad1663$export$2e2bcd8739ae039 = $31be23eb22ad1663$var$List;


const $33939e35968291bd$var$List = ({ activity: activity, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $250b0a7836dcf02d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $31be23eb22ad1663$export$2e2bcd8739ae039), {
            activity: activity,
            onClose: onClose
        })
    });
};
var $33939e35968291bd$export$2e2bcd8739ae039 = $33939e35968291bd$var$List;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");

const $c6e77507fdb45598$var$Card = ({ children: children, className: className, shadow: shadow = false })=>{
    const [scrollButtonDisplay, setScrollButtonDisplay] = (0, $lT7pJ.useState)(false);
    const [scrollButtonDirection, setScrollButtonDirection] = (0, $lT7pJ.useState)("bottom");
    const botEndRef = (0, $lT7pJ.useRef)(null);
    const cardRef = (0, $lT7pJ.useRef)(null);
    const scrollHandler = (to, from)=>{
        if (to === "bottom") setScrollButtonDirection("top");
        else setScrollButtonDirection("bottom");
        if (from === "button" && botEndRef && botEndRef.current !== null && to === "bottom") botEndRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
        else if (to === "top" && cardRef && cardRef.current) cardRef.current.children[1].scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    };
    const handleScroll = ()=>{
        if (cardRef.current) {
            const parentHeight = cardRef.current.parentElement?.clientHeight;
            const scrollHeight = cardRef.current.scrollHeight;
            const scrollTop = cardRef.current.scrollTop;
            // const offsetHeight = (cardRef.current as HTMLDivElement).offsetHeight
            const clientHeight = cardRef.current.clientHeight;
            if (parentHeight && scrollHeight > parentHeight) {
                if (scrollHeight - scrollTop < clientHeight + 10) {
                    setScrollButtonDisplay(true);
                    setScrollButtonDirection("top");
                } else {
                    setScrollButtonDisplay(true);
                    setScrollButtonDirection("bottom");
                }
            } else setScrollButtonDisplay(false);
        }
    };
    /**
   * On DragStart event call :
   *  - prevent default behaviour and stop propagation of the event
   *  - this is to prevent image dragging while trying to swipe in a carousel
   * @param e : React.DragEvent
   */ const handleDragStart = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    // Check scroll at component first render
    (0, $lT7pJ.useEffect)(()=>{
        const timer = setTimeout(()=>{
            handleScroll();
        }, 500);
        return ()=>timer && clearTimeout(timer);
    }, []);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-relative rf-max-h-full rf-flex rf-flex-col rf-text-size-auto rf-unselectable ${className}`,
        draggable: true,
        onDragStart: handleDragStart,
        style: {
            pointerEvents: "all"
        },
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
            className: `rf-w-full rf-max-h-full rf-rounded rf-border rf-border-cardFrameBorder rf-flex rf-flex-col rf-content-around rf-justify-start ${!shadow && "rf-overflow-y-auto rf-overflow-x-hidden"} rf-scrollbar-thin`,
            ref: cardRef,
            onScroll: ()=>handleScroll(),
            style: {
                touchAction: "pan-y"
            },
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $aa3bf51137e07f42$export$2e2bcd8739ae039), {
                    direction: scrollButtonDirection,
                    display: scrollButtonDisplay,
                    scrollHandler: scrollHandler,
                    setPreventScroll: ()=>{},
                    className: "rf-absolute rf-z-ui rf-bottom-1 rf-right-6 rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                }),
                children,
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    ref: botEndRef
                })
            ]
        })
    });
};
var $c6e77507fdb45598$export$2e2bcd8739ae039 = $c6e77507fdb45598$var$Card;


const $dd076293492e52d7$var$classNameText = "rf-max-h-full";
const $dd076293492e52d7$var$classNameVocal = "rf-w-11/12 large:rf-w-3/5 large-vertical:rf-w-4/9 rf-min-w-11/12 large:rf-min-w-3/5 large-vertical:rf-min-w-4/9 rf-max-h-full";
const $dd076293492e52d7$var$SingleCardContainer = ({ attachment: attachment, history: history })=>{
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const className = (0, $lT7pJ.useMemo)(()=>{
        return mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text ? $dd076293492e52d7$var$classNameText : $dd076293492e52d7$var$classNameVocal;
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c6e77507fdb45598$export$2e2bcd8739ae039), {
        className: history ? "rf-w-full" : className,
        children: (0, $6c276f4a56f91e17$export$2e2bcd8739ae039)({
            attachment: attachment,
            history: history
        })
    });
};
var $dd076293492e52d7$export$2e2bcd8739ae039 = $dd076293492e52d7$var$SingleCardContainer;




var $lT7pJ = parcelRequire("lT7pJ");

/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");








const $9b4e9811630d57f8$var$springEnterDuration = 1000;
// Cards' width coefficients depending on the mode and display type
const $9b4e9811630d57f8$var$widthCoefficients = {
    textAndVocalMobile: 0.9,
    textAndVocalMobileGrid: 0.45,
    vocalDesktop: 0.6,
    vocalBorne: 0.45
};
const $9b4e9811630d57f8$var$defaultTransitionDuration = "300ms";
const $9b4e9811630d57f8$var$velocityBreakpoint = 0.5;
const $9b4e9811630d57f8$var$Carousel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).forwardRef(({ direction: direction, history: history, draft: draft, grid: grid, gridTitle: gridTitle, children: children }, ref)=>{
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const forceMobileView = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.forceMobileView);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const showHomeAttachments = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.showHomeAttachments);
    const currentOrLastPlayedActivity = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.currentOrLastPlayedActivity);
    const nbCards = (0, $lT7pJ.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Children.count(children);
    }, [
        children
    ]);
    const gap = (0, $lT7pJ.useMemo)(()=>{
        return isMobile ? 0.3 : 1;
    }, [
        currentDeviceType
    ]);
    const coefficient = (0, $lT7pJ.useMemo)(()=>{
        return mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).landscape || currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetLandscape ? history ? $9b4e9811630d57f8$var$widthCoefficients.textAndVocalMobile : $9b4e9811630d57f8$var$widthCoefficients.vocalDesktop : currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).borne || currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetBorne ? history ? $9b4e9811630d57f8$var$widthCoefficients.vocalDesktop : $9b4e9811630d57f8$var$widthCoefficients.vocalBorne : grid ? $9b4e9811630d57f8$var$widthCoefficients.textAndVocalMobileGrid : $9b4e9811630d57f8$var$widthCoefficients.textAndVocalMobile : grid ? $9b4e9811630d57f8$var$widthCoefficients.textAndVocalMobileGrid : $9b4e9811630d57f8$var$widthCoefficients.textAndVocalMobile;
    }, [
        mode,
        currentDeviceType
    ]);
    const [cardWidth, setCardWidth] = (0, $lT7pJ.useState)(currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget || forceMobileView ? 400 * coefficient : window.innerWidth * coefficient);
    const [cardHeight, setCardHeight] = (0, $lT7pJ.useState)();
    const [currentCard, setCurrentCard] = (0, $lT7pJ.useState)(0);
    const [currentPadding, setCurrentPadding] = (0, $lT7pJ.useState)();
    const [translation, setTranslation] = (0, $lT7pJ.useState)("");
    const [transitionDuration, setTransitionDuration] = (0, $lT7pJ.useState)("1ms");
    const [gridTemplateColumn, setGridTemplateColumn] = (0, $lT7pJ.useState)(direction !== "vertical" ? `repeat(${nbCards}, ${cardWidth}px)` : "");
    const [gridTemplateRow, setGridTemplateRow] = (0, $lT7pJ.useState)(direction === "vertical" ? `repeat(${nbCards}, ${cardWidth * 10 / 16}px)` : "");
    const [enableTranslation, setEnableTranslation] = (0, $lT7pJ.useState)(true);
    const [wheeling, setWheeling] = (0, $lT7pJ.useState)(0);
    const divRef = (0, $lT7pJ.useRef)(null);
    const timerRef = (0, $lT7pJ.useRef)(null);
    const dimensions = (0, $57fa40eeebe37d0d$export$2e2bcd8739ae039)(divRef);
    const [spring, api] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                transform: "translateX(0%)"
            }
        }));
    (0, $lT7pJ.useEffect)(()=>{
        !draft && api.start({
            from: {
                transform: "translateX(100%)"
            },
            to: {
                transform: "translateX(0%)"
            },
            config: {
                duration: $9b4e9811630d57f8$var$springEnterDuration,
                easing: (0, $bd140d0b30421f1c$export$15a0bf1b4bbacad8).easeInBack
            }
        });
    }, [
        draft
    ]);
    /**
     * On cards container reference, mode / currentDeviceType states change :
     *  - calculate the cards' width depending on the coefficient
     *  - calculate the cards' height depending on the width (use a 16/10 format). Only used in vertical disposition
     *  - set the currentPadding state to have centered cards in horizontal disposition
     *  - set cardWidth, cardHeight and gridTemplateRow / gridTemplateColumn (depending on direction) states
     * On component unmount :
     *  - clear timeout
     */ (0, $lT7pJ.useEffect)(()=>{
        if (dimensions) {
            let newCardWidth = Math.floor(dimensions.width * coefficient);
            // Get the number of pixels contained in 1 rem multiplicated by the gap, used with grid elements
            const gapInPx = gap * parseFloat(getComputedStyle(document.documentElement).fontSize);
            if (forceMobileView && newCardWidth > 400) {
                newCardWidth = 400;
                setCurrentPadding(grid ? (dimensions.width - newCardWidth * 2 - gapInPx) / 2 : (dimensions.width - newCardWidth - 5 * (nbCards - 1)) / 2);
                if (nbCards * newCardWidth < dimensions.width) setEnableTranslation(false);
            } else setCurrentPadding(grid ? (dimensions.width - newCardWidth * 2 - gapInPx) / 2 : (1 - coefficient) * dimensions.width / 2);
            const newCardHeight = Math.ceil(newCardWidth * 10 / 16);
            // Space needed to center to cards
            // Cards' width (all dispositions) and height (only used in vertical disposition)
            setCardWidth(newCardWidth);
            setCardHeight(newCardHeight);
            direction === "vertical" ? setGridTemplateRow(`repeat(${nbCards}, ${newCardHeight}px)`) : setGridTemplateColumn(`repeat(${nbCards}, ${newCardWidth}px)`);
            setCurrentCard(0);
        }
        return ()=>timerRef && clearTimeout(timerRef.current);
    }, [
        dimensions,
        coefficient,
        nbCards,
        currentDeviceType,
        currentOrLastPlayedActivity?.id
    ]);
    /**
     * On currentCard, cardWidth, cardHeight, currentPadding states change :
     *  - set translation state depending on the direction
     */ (0, $lT7pJ.useEffect)(()=>{
        if (currentCard !== undefined && cardWidth !== undefined && cardHeight !== undefined && currentPadding !== undefined) direction === "vertical" ? setTranslation(`translateY(calc(-${currentCard * cardHeight}px - ${currentCard * gap}rem))`) : setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
    }, [
        currentCard,
        cardWidth,
        cardHeight,
        currentPadding
    ]);
    /**
     * On wheeling state change :
     *  - call either onSwipeRight or onSwipeLeft (with high values to enter the right part of the if condition), depending on the wheeling value (positive or negative)
     */ (0, $lT7pJ.useEffect)(()=>{
        wheeling && (wheeling > 0 ? onSwipeLeft(1000, 1000) : onSwipeRight(1000, 1000));
    }, [
        wheeling
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (showHomeAttachments) setCurrentCard(0);
    }, [
        showHomeAttachments
    ]);
    /**
     * On call :
     *  - set translation to its initial state
     */ const resetPosition = ()=>{
        cardWidth && setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px))`);
    };
    /**
     * On call :
     *  - simulate a bounce effect by translating 1/10 of the width of a card in a sense, and then back
     * @param left : boolean
     */ const bounce = (left)=>{
        if (cardWidth) {
            setTransitionDuration($9b4e9811630d57f8$var$defaultTransitionDuration);
            setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px ${left ? "-" : "+"} ${cardWidth / 10}px))`);
            timerRef && (timerRef.current = setTimeout(()=>{
                setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px`);
            }, 300));
        }
    };
    /**
     * On call :
     *  - check if the current card is not already the last one
     *  - check the distance of the swipe, if it's higher than half a card's width, add 1 to currentCard state
     *  - check the velocity of the swipe, if it's higher than the limit, add 1 to currentCard state by 0.1 velocity over the limit, otherwise add 1
     * @param distance : number
     * @param elpasedTime : number
     */ const onSwipeLeft = (distance, elapsedTime)=>{
        // Utils store util to show that the user is swiping
        (0, $1bda010252da638c$export$19e9368606a5170f)();
        const velocity = Math.abs(distance / elapsedTime);
        setTransitionDuration($9b4e9811630d57f8$var$defaultTransitionDuration);
        if (currentCard !== nbCards - 1 && cardWidth) {
            if (Math.abs(distance) > cardWidth / 2) setCurrentCard((card)=>card + 1);
            else {
                const velocityDifference = Math.round((velocity - $9b4e9811630d57f8$var$velocityBreakpoint) * 10);
                const nextCard = currentCard + (velocityDifference > 0 ? velocityDifference : 1);
                setCurrentCard(nextCard < nbCards ? nextCard : nbCards - 1);
            }
        } else distance === 1000 && elapsedTime === 1000 ? bounce(true) : resetPosition();
    };
    /**
     * On call :
     *  - check if the current card is not already the first one
     *  - check the distance of the swipe, if it's higher than half a card's width, substract 1 from currentCard state
     *  - check the velocity of the swipe, if it's higher than the limit, substract 1 to currentCard state by 0.1 velocity over the limit, otherwise substract 1
     * @param distance : number
     * @param elpasedTime : number
     */ const onSwipeRight = (distance, elapsedTime)=>{
        // Utils store util to show that the user is swiping
        (0, $1bda010252da638c$export$19e9368606a5170f)();
        const velocity = Math.abs(distance / elapsedTime);
        setTransitionDuration($9b4e9811630d57f8$var$defaultTransitionDuration);
        if (currentCard !== 0 && cardWidth) {
            if (Math.abs(distance) > cardWidth / 2) setCurrentCard((card)=>card - 1);
            else {
                const velocityDifference = Math.round((velocity - $9b4e9811630d57f8$var$velocityBreakpoint) * 10);
                const nextCard = currentCard - (velocityDifference > 0 ? velocityDifference : 1);
                setCurrentCard(nextCard >= 0 ? nextCard : 0);
            }
        } else distance === 1000 && elapsedTime === 1000 ? bounce() : resetPosition();
    };
    /**
     * On call :
     *  - check if the translation is available (inside allowed bounds)
     *  - if available, set transitionDuration state to '0ms' and then update translation state to the default distance - received distance param
     * @param distance : number
     */ const onSwiping = (distance)=>{
        const available = currentCard === 0 || currentCard === nbCards - 1 ? checkSwipingAvailable(distance, gap) : true;
        if (cardWidth !== undefined) {
            setTransitionDuration("0ms");
            if (available) {
                if (currentCard !== undefined && cardHeight !== undefined && currentPadding !== undefined) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px - ${distance}px))`);
            } else {
                const bounceLimit = cardWidth / 3;
                if (Math.abs(distance) <= bounceLimit / 2) setTranslation(`translateX(calc(-${currentCard * cardWidth}px - ${currentCard * gap}rem + ${currentPadding}px - ${distance * (1 - Math.abs(distance) / bounceLimit)}px))`);
            }
        }
    };
    /**
     * On call :
     *  - calculate the max length allowed
     *  - calculate the future length depending on the distance
     *  - check if the future length is inside the available bounds and return a boolean
     * @param distance : number
     * @param gap : number
     * @returns boolean
     */ const checkSwipingAvailable = (distance, gap)=>{
        if (currentCard !== undefined && cardWidth && currentPadding) {
            const maxLength = (nbCards - 1) * cardWidth + (nbCards - 1) * gap + currentPadding;
            const currentLength = currentCard * cardWidth + currentCard * gap * parseFloat(getComputedStyle(document.documentElement).fontSize) + currentPadding + distance;
            return !(currentLength < currentPadding || currentLength > maxLength);
        }
        return false;
    };
    /**
     * On call :
     *  - call onSwipeLeft method
     * @param distance : number
     */ const onSwipeTop = (distance, elapsedTime)=>{
        onSwipeLeft(distance, elapsedTime);
    };
    /**
     * On call :
     *  - call onSwipeRight method
     * @param distance : number
     */ const onSwipeBottom = (distance, elapsedTime)=>{
        onSwipeRight(distance, elapsedTime);
    };
    /**
     * On click event fire :
     *  - set transitionDuration state to default value
     *  - update currentCard state with the key parameter
     * @param key : number
     */ const handleClick = (key)=>{
        // Utils store util to show that the user is swiping
        (0, $1bda010252da638c$export$19e9368606a5170f)();
        setTransitionDuration($9b4e9811630d57f8$var$defaultTransitionDuration);
        setCurrentCard(key);
    };
    /**
     * On wheel event fire :
     *  - check which axis has been triggered (x or y) to get its value
     *  - set wheeling state to a positive or negative unique value (here Date.now() is used as unique)
     * @param delta : number
     */ const handleWheel = (delta)=>{
        if (delta !== undefined) {
            // Utils store util to show that the user is swiping
            (0, $1bda010252da638c$export$19e9368606a5170f)();
            setWheeling(delta > 0 ? Date.now() : -Date.now());
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            gridTitle && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-w-full rf-text-left rf-title-large-size-auto ${mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? "rf-text-truewhite rf-text-shadow-black" : "rf-text-textModePanelConversationBot"}`,
                style: {
                    paddingLeft: currentPadding
                },
                children: gridTitle
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $dc32a48dada8397f$export$407448d2b89b1813).div, {
                ref: divRef,
                className: "rf-w-full rf-flex rf-flex-col",
                style: {
                    visibility: draft ? "hidden" : "visible",
                    pointerEvents: "all",
                    ...spring
                },
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3e5faa3ecd7b3792$export$2e2bcd8739ae039), {
                        className: "rf-w-full",
                        handleWheel: handleWheel,
                        xAxisOnly: true,
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $511208734c526421$export$2e2bcd8739ae039), {
                            direction: direction || "horizontal",
                            onSwiping: onSwiping,
                            onSwipeLeft: onSwipeLeft,
                            onSwipeRight: onSwipeRight,
                            onSwipeTop: onSwipeTop,
                            onSwipeBottom: onSwipeBottom,
                            className: direction === "vertical" ? "rf-flex rf-justify-center" : mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal && !isMobile ? history ? "rf-opacity-gradient-l-thin" : "rf-opacity-gradient-l" : "",
                            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                ref: ref,
                                className: `rf-relative ${direction === "vertical" ? "rf-h-max" : "rf-w-max"} ${enableTranslation ? "" : "rf-m-auto"} rf-transition-transform`,
                                style: {
                                    display: "grid",
                                    gridTemplateColumns: direction === "vertical" ? `${cardWidth}px` : gridTemplateColumn,
                                    gridTemplateRows: gridTemplateRow,
                                    gap: isMobile ? "0.3rem" : "1rem",
                                    transitionTimingFunction: "linear",
                                    transitionDuration: transitionDuration,
                                    transform: enableTranslation ? translation : ""
                                },
                                children: children
                            })
                        })
                    }),
                    !draft && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-full rf-py-3 rf-flex rf-flex-row rf-justify-center rf-gap-1",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Children.map(children, (_child, key)=>{
                            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                                className: `rf-w-3 rf-h-3 rf-border rf-border-trueblack rf-rounded-half ${key === currentCard ? "rf-bg-primary" : "rf-bg-truewhite"}`,
                                onClick: ()=>handleClick(key)
                            }, key);
                        })
                    })
                ]
            })
        ]
    });
});
var $9b4e9811630d57f8$export$2e2bcd8739ae039 = $9b4e9811630d57f8$var$Carousel;



const $2f31a33c8dae5578$var$CarouselContainer = ({ title: title, attachments: attachments, history: history, grid: grid })=>{
    const [height, setHeight] = (0, $lT7pJ.useState)(0);
    const timerRef = (0, $lT7pJ.useRef)();
    const carouselRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useLayoutEffect)(()=>{
        setHeight(0);
        if (attachments.length && attachments?.length > 1) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                carouselRef.current && setHeight(carouselRef.current.clientHeight);
            }, 500);
        }
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        attachments
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $9b4e9811630d57f8$export$2e2bcd8739ae039), {
        ref: carouselRef,
        history: history,
        draft: height === 0,
        grid: grid,
        gridTitle: title,
        children: height === 0 ? attachments.map((attachment, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c6e77507fdb45598$export$2e2bcd8739ae039), {
                className: "rf-w-full",
                children: (0, $6c276f4a56f91e17$export$2e2bcd8739ae039)({
                    attachment: attachment,
                    history: history
                })
            }, key + 100);
        }) : attachments.map((attachment, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c6e77507fdb45598$export$2e2bcd8739ae039), {
                className: "rf-w-full",
                children: (0, $6c276f4a56f91e17$export$2e2bcd8739ae039)({
                    attachment: attachment,
                    history: history,
                    height: height
                })
            }, key);
        })
    });
};
var $2f31a33c8dae5578$export$2e2bcd8739ae039 = $2f31a33c8dae5578$var$CarouselContainer;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");




var $lT7pJ = parcelRequire("lT7pJ");




const $6249fbcbcf8eb3d7$var$Grid = ({ title: title, history: history, children: children })=>{
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const mainWidth = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentWidth);
    const mainHeight = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentHeight);
    const [classname, setClassname] = (0, $lT7pJ.useState)("");
    const gridContainerRef = (0, $lT7pJ.useRef)(null);
    const gridContainerDimensions = (0, $57fa40eeebe37d0d$export$2e2bcd8739ae039)(gridContainerRef);
    const nbCards = (0, $lT7pJ.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Children.count(children);
    }, [
        children
    ]);
    const rowGap = (0, $lT7pJ.useMemo)(()=>{
        return gridContainerDimensions.width * 0.035;
    }, [
        gridContainerDimensions.width
    ]);
    const maxHeight = (0, $lT7pJ.useMemo)(()=>{
        // 0.58 quite equals 7/12. This ratio prevents the container from overflowing vertically
        return mainHeight * 0.58;
    }, [
        mainHeight
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        switch(nbCards){
            case 2:
                setClassname("rf-grid-cols-[repeat(2,30%)] rf-grid-rows-1");
                break;
            case 3:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? "rf-grid-cols-[repeat(3,31%)] rf-grid-rows-1" : "rf-grid-cols-[repeat(2,45%)] rf-grid-rows-2");
                break;
            case 4:
                setClassname("rf-grid-cols-[repeat(2,30%)] rf-grid-rows-2");
                break;
            case 5:
            case 6:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? "rf-grid-cols-[repeat(3,31%)] rf-grid-rows-2" : "rf-grid-cols-[repeat(2,45%)] rf-grid-rows-3");
                break;
            case 7:
            case 8:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? "rf-grid-cols-[repeat(3,31%)] rf-grid-rows-3" : "rf-grid-cols-[repeat(2,45%)] rf-grid-rows-4");
                break;
            case 9:
                setClassname(mainHeight > mainWidth || mainHeight < mainWidth && mainWidth > 1200 ? "rf-grid-cols-[repeat(3,31%)] rf-grid-rows-3" : "rf-grid-cols-[repeat(2,45%)] rf-grid-rows-5");
                break;
            default:
                break;
        }
    }, [
        nbCards,
        mainWidth,
        mainHeight
    ]);
    return nbCards ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-flex rf-flex-col rf-gap-4 ${mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? `vertical:rf-w-9/10 rf-pl-4 ${history ? "rf-pr-0 large-vertical:rf-w-full" : "rf-pr-40 large-vertical:rf-w-3/5"} vertical:rf-pl-0 vertical:rf-pr-0` : "rf-px-4"} vertical:rf-items-center`,
        children: [
            title && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-w-full rf-text-left rf-title-large-size-auto ${!history && mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? "rf-text-truewhite rf-text-shadow-black" : "rf-text-textModePanelConversationBot"}`,
                children: title
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                ref: gridContainerRef,
                className: `rf-w-full rf-grid rf-justify-center rf-gap-x-[3.5%] ${classname}`,
                style: {
                    maxHeight: history || mainHeight > mainWidth ? "none" : maxHeight,
                    rowGap: rowGap
                },
                children: children
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $6249fbcbcf8eb3d7$export$2e2bcd8739ae039 = $6249fbcbcf8eb3d7$var$Grid;


const $066907a4edbe5410$var$GridContainer = ({ title: title, attachments: attachments, history: history })=>{
    const processedAttachments = (0, $lT7pJ.useMemo)(()=>{
        let tempAttachments = [
            ...attachments
        ];
        tempAttachments = tempAttachments.sort((a, b)=>a.content.index - b.content.index);
        return tempAttachments;
    }, [
        attachments
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6249fbcbcf8eb3d7$export$2e2bcd8739ae039), {
        title: title,
        history: history,
        children: processedAttachments.map((attachment, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c6e77507fdb45598$export$2e2bcd8739ae039), {
                className: "rf-w-full",
                shadow: true,
                children: (0, $6c276f4a56f91e17$export$2e2bcd8739ae039)({
                    attachment: attachment,
                    history: history
                })
            }, key);
        })
    });
};
var $066907a4edbe5410$export$2e2bcd8739ae039 = $066907a4edbe5410$var$GridContainer;


const $66e8c4d559e5bc15$var$Attachments = ({ activity: activity, display: display, history: history })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const attachments = (0, $lT7pJ.useMemo)(()=>{
        return activity?.attachments?.filter((attachment)=>attachment.contentType !== (0, $59de7fd3862e5431$export$8180494a68c87622)) || [];
    }, [
        activity
    ]);
    const checkDisplay = (attachmentLayout)=>{
        if (!attachments?.length) return (0, $45d43a6de0968f42$export$972614fc43112105).none;
        if (attachmentLayout) switch(attachmentLayout.toLowerCase()){
            case "davilist":
                return (0, $45d43a6de0968f42$export$972614fc43112105).none;
            case "carousel":
                return attachments.length > 1 ? (0, $45d43a6de0968f42$export$972614fc43112105).carousel : (0, $45d43a6de0968f42$export$972614fc43112105).normal;
            case "grid":
                // Grid display is not available in mobile mode
                return isMobile ? attachments.length > 1 ? (0, $45d43a6de0968f42$export$972614fc43112105).carouselgrid : (0, $45d43a6de0968f42$export$972614fc43112105).normal : (0, $45d43a6de0968f42$export$972614fc43112105).grid;
        }
        // If we have no attachment layout but attachment(s), we use none display by default is there are several attachments
        return attachments.length > 1 ? (0, $45d43a6de0968f42$export$972614fc43112105).none : (0, $45d43a6de0968f42$export$972614fc43112105).normal;
    };
    const currentDisplay = (0, $lT7pJ.useMemo)(()=>{
        return display || checkDisplay(activity.attachmentLayout);
    }, [
        attachments,
        display
    ]);
    return currentDisplay === (0, $45d43a6de0968f42$export$972614fc43112105).normal ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $dd076293492e52d7$export$2e2bcd8739ae039), {
        attachment: attachments[0],
        history: history
    }) : currentDisplay === (0, $45d43a6de0968f42$export$972614fc43112105).carousel || currentDisplay === (0, $45d43a6de0968f42$export$972614fc43112105).carouselgrid ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $2f31a33c8dae5578$export$2e2bcd8739ae039), {
        title: activity.attachments?.find((attachment)=>attachment.contentType === (0, $59de7fd3862e5431$export$8180494a68c87622))?.content?.text,
        attachments: attachments,
        history: history,
        grid: currentDisplay === (0, $45d43a6de0968f42$export$972614fc43112105).carouselgrid
    }) : currentDisplay === (0, $45d43a6de0968f42$export$972614fc43112105).grid ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $066907a4edbe5410$export$2e2bcd8739ae039), {
        title: activity.attachments?.find((attachment)=>attachment.contentType === (0, $59de7fd3862e5431$export$8180494a68c87622))?.content?.text,
        attachments: attachments,
        history: history
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $66e8c4d559e5bc15$export$2e2bcd8739ae039 = $66e8c4d559e5bc15$var$Attachments;


const $e2941dbc64a06bc6$var$BotResponse = ()=>{
    const showHomeAttachments = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.showHomeAttachments);
    const speaking = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.speaking);
    const lastRecognitionInterim = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.lastRecognitionInterim);
    const currentOrLastPlayedActivity = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.currentOrLastPlayedActivity);
    const displaySubtitles = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.displaySubtitles);
    const listClosed = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.listClosed);
    const rowSpanVertical = (0, $lT7pJ.useMemo)(()=>{
        return displaySubtitles && speaking ? "rf-row-span-5 small-mobile:rf-row-span-6" : "rf-row-span-6 small-mobile:rf-row-span-7";
    }, [
        displaySubtitles,
        speaking
    ]);
    const currentActivity = (0, $lT7pJ.useMemo)(()=>{
        return showHomeAttachments || currentOrLastPlayedActivity;
    }, [
        currentOrLastPlayedActivity,
        showHomeAttachments
    ]);
    const currentDisplay = (0, $lT7pJ.useMemo)(()=>{
        if (currentActivity) {
            if (currentActivity.attachmentLayout) switch(currentActivity.attachmentLayout.toLowerCase()){
                case "davilist":
                    return (0, $45d43a6de0968f42$export$972614fc43112105).list;
                case "carousel":
                    return currentActivity.attachments && currentActivity.attachments.length > 1 ? (0, $45d43a6de0968f42$export$972614fc43112105).carousel : (0, $45d43a6de0968f42$export$972614fc43112105).normal;
                case "grid":
                    return (0, $45d43a6de0968f42$export$972614fc43112105).grid;
            }
            // If we have no attachment layout but attachment(s), we use list display by default is there are several attachments
            if (currentActivity.attachments?.length) return currentActivity.attachments?.length > 1 ? (0, $45d43a6de0968f42$export$972614fc43112105).list : (0, $45d43a6de0968f42$export$972614fc43112105).normal;
        }
        return (0, $45d43a6de0968f42$export$972614fc43112105).none;
    }, [
        currentActivity
    ]);
    return currentDisplay === (0, $45d43a6de0968f42$export$972614fc43112105).none ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}) : currentDisplay === (0, $45d43a6de0968f42$export$972614fc43112105).list ? lastRecognitionInterim === "" && !listClosed ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $33939e35968291bd$export$2e2bcd8739ae039), {
        activity: currentActivity,
        onClose: ()=>(0, $1bda010252da638c$export$f03cfde7db70aa27)(true)
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        id: "retorik-botResponse",
        className: `rf-relative rf-w-full rf-h-full
        rf-col-start-1 large-vertical:rf-col-start-1 large:rf-col-start-5 rf-col-span-full
        rf-row-start-6 small-mobile:rf-row-start-5 large:rf-row-start-5 large-vertical:rf-row-start-7 ${rowSpanVertical} large:rf-row-span-full large-vertical:rf-row-span-4
        rf-overflow-y-scroll rf-scrollbar-thin
      `,
        children: currentActivity && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-items-center rf-gap-2",
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $66e8c4d559e5bc15$export$2e2bcd8739ae039), {
                activity: currentActivity
            })
        })
    });
};
var $e2941dbc64a06bc6$export$2e2bcd8739ae039 = $e2941dbc64a06bc6$var$BotResponse;



parcelRequire("lT7pJ");

const $e0a6053cfc8a3fb0$var$RetorikLogo = ()=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("a", {
        href: "https://davi.ai/retorik",
        title: "Retorik by Davi",
        target: "_blank",
        rel: "noreferrer",
        className: "rf-hidden large:rf-block rf-relative rf-col-start-1 rf-col-span-full rf-row-start-12 rf-row-span-1 rf-self-end rf-justify-self-start",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $fbd04c9fc08b5261$export$2e2bcd8739ae039), {
            className: "rf-ml-4 rf-mb-4 rf-h-14"
        })
    });
};
var $e0a6053cfc8a3fb0$export$2e2bcd8739ae039 = $e0a6053cfc8a3fb0$var$RetorikLogo;




var $lT7pJ = parcelRequire("lT7pJ");




const $d51d81730d27ba73$var$useShowEmergency = ()=>{
    const lastBotActivity = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.lastBotActivity);
    if (lastBotActivity && lastBotActivity.type === "event" && lastBotActivity.name === "Hospitality.ShowEmergency") return true;
    return false;
};
var $d51d81730d27ba73$export$2e2bcd8739ae039 = $d51d81730d27ba73$var$useShowEmergency;



const $cbc422a3399ec4d2$var$useShowMap = ()=>{
    const lastActivity = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.lastActivity);
    if (lastActivity?.type === "event" && lastActivity.name === "Hospitality.ShowMap") return true;
    return false;
};
var $cbc422a3399ec4d2$export$2e2bcd8739ae039 = $cbc422a3399ec4d2$var$useShowMap;



/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");



const $ac0c0a65dcd02bca$export$190bd3f548d0449 = (activity)=>{
    // Get answer's timestamp or create a new one if none present
    const timestamp = activity.localTimestamp || activity.timestamp || Date.now().toString();
    const newQuestion = {
        id: activity.id,
        type: "message",
        text: "",
        channelData: {
            "webchat:sequence-id": 1
        },
        timestamp: timestamp,
        localTimestamp: timestamp,
        from: {
            id: "bot",
            role: "bot"
        }
    };
    return newQuestion;
};



function $f17e7d6bc8355f6b$export$2e2bcd8739ae039() {
    const activities = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.messageActivities);
    // processedId contains the ids of the activities already processed (because useActivities gives duplicate activities with different state depending on if it's been spoken or not )
    const processedId = [];
    const history = [];
    activities.forEach((activity)=>{
        if (activity.id && !processedId.includes(activity.id)) {
            processedId.push(activity.id);
            // Check if this is a question or an answer (questions from the user don't have a replyToId field)
            if (activity.replyToId) {
                const question = history.find((historyItem)=>historyItem.question.id === activity.replyToId);
                if (question) question.answers.push(activity);
                else {
                    const newQuestion = (0, $ac0c0a65dcd02bca$export$190bd3f548d0449)(activity);
                    history.push({
                        question: newQuestion,
                        answers: [
                            activity
                        ]
                    });
                }
            } else if (activity.label === "Davi.BringupMessage" && activity.text) {
                const newQuestion = (0, $ac0c0a65dcd02bca$export$190bd3f548d0449)(activity);
                history.push({
                    question: newQuestion,
                    answers: [
                        activity
                    ]
                });
            } else history.push({
                question: activity,
                answers: []
            });
        }
    });
    return history;
}



/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");
/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");




const $c4a3843daa192a2a$var$HistoryQA = ({ activity: activity, isQuestion: isQuestion })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const time = activity.localTimestamp ? new Date(activity.localTimestamp) : activity.timestamp ? new Date(activity.timestamp) : new Date();
    return activity.text || !!activity.attachments?.length ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `${isMobile ? "rf-w-full" : "rf-max-w-full"} rf-flex rf-flex-col rf-gap-1`,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-text-[#9A9A9A]",
                children: time.toLocaleString(locale, {
                    hour: "numeric",
                    minute: "numeric"
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `${isQuestion ? "rf-text-textModePanelConversationUser" : "rf-text-textModePanelConversationBot"}`,
                children: [
                    activity.htmlText ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: activity.htmlText
                        }
                    }) : activity.text ? (0, $86e1288ad17c6773$export$d6c6ec86eedacfd9)(activity.text) : "",
                    !!activity.attachments?.length && !(activity.attachmentLayout && activity.attachmentLayout.toLowerCase() === "davilist") && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: `rf-w-full rf-min-h-16 rf-overflow-x-hidden rf-overflow-y-auto ${activity.text && "rf-pt-4"}`,
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $66e8c4d559e5bc15$export$2e2bcd8739ae039), {
                            activity: activity,
                            history: true
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $c4a3843daa192a2a$export$2e2bcd8739ae039 = $c4a3843daa192a2a$var$HistoryQA;


const $f3fba32c5bda8289$var$HistoryItem = ({ activity: activity })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-mb-4 rf-flex rf-flex-col rf-justify-start rf-items-start rf-gap-4 rf-text-size-auto",
        children: [
            activity?.question && activity.question.type === "message" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c4a3843daa192a2a$export$2e2bcd8739ae039), {
                activity: activity.question,
                isQuestion: true
            }),
            activity.answers.map((answer, j)=>{
                return answer.type === "message" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c4a3843daa192a2a$export$2e2bcd8739ae039), {
                    activity: answer,
                    isQuestion: false
                }, j) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
            })
        ]
    });
};
var $f3fba32c5bda8289$export$2e2bcd8739ae039 = $f3fba32c5bda8289$var$HistoryItem;





const $bf703c4fb92334f2$var$HistoryList = ()=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const isBorne = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isBorne);
    const activities = (0, $f17e7d6bc8355f6b$export$2e2bcd8739ae039)();
    const scrollRef = (0, $lT7pJ.useRef)(null);
    const divRef = (0, $lT7pJ.useRef)(null);
    /**
   * On call :
   *  - scroll to the scrollRef HTML element at the bottom of the view
   */ const scrollToRef = ()=>{
        if (scrollRef && scrollRef.current !== null) scrollRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    };
    /**
   * On component mount :
   *  - call scrollToRef method
   */ (0, $lT7pJ.useEffect)(()=>{
        setTimeout(()=>{
            scrollToRef();
        }, 200);
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        divRef?.current && isWidget && (0, $b5fe10956c349963$export$2e2bcd8739ae039)(null, divRef);
    }, [
        divRef?.current
    ]);
    const handleClose = ()=>{
        (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).none);
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindow", null);
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindowHistory", null);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1ed31e01939ae4c3$export$2e2bcd8739ae039), {
        handleClose: handleClose,
        backIsConversation: true,
        title: translation.history.title,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
            ref: divRef,
            className: `rf-pb-4 rf-overflow-y-scroll ${isBorne ? "rf-scrollbar-thin" : "rf-scrollbar-hidden"}`,
            children: [
                activities.map((activity, key)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $f3fba32c5bda8289$export$2e2bcd8739ae039), {
                        activity: activity
                    }, key);
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    ref: scrollRef
                })
            ]
        })
    });
};
var $bf703c4fb92334f2$export$2e2bcd8739ae039 = $bf703c4fb92334f2$var$HistoryList;




var $lT7pJ = parcelRequire("lT7pJ");









const $fcc47f5bf5a9a9b0$var$LanguageChoice = ()=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const supported = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.supported);
    const skipWelcome = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.skipWelcome);
    const [currentLanguage, setCurrentLanguage] = (0, $lT7pJ.useState)(locale);
    const handleClose = (changed)=>{
        (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).none);
        // Only send events when language has not been changed, either way it will collide with the TriggerWelcome event
        if (!changed) {
            (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindow", null);
            (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindowLanguages", null);
        }
    };
    const handleChange = (language)=>{
        setCurrentLanguage(language);
    };
    /**
   * Change current locale with the one selected if they are different.
   * Send a 'TriggerWelcome' event to get the welcome message in the new language.
   * @param language string
   */ const handleSelect = (language)=>{
        const changed = language !== locale;
        if (changed) {
            (0, $d0ec91114d7de49c$export$c8aadf3621e41efb)(language);
            !skipWelcome && setTimeout(()=>{
                (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("TriggerWelcome", undefined);
            }, 150);
        }
        handleClose(changed);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $1ed31e01939ae4c3$export$2e2bcd8739ae039), {
        handleClose: ()=>handleClose(false),
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "large:rf-mt-[20vh] large-tactile:rf-mt-0 rf-title-bold-size-auto rf-font-bold",
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.language.change, locale)
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-text-lightgray rf-pt-1 rf-pb-2",
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.language.select, locale)
            }),
            supported.map((language, key)=>{
                return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: `rf-w-full rf-py-4 rf-border-t rf-border-t-menuBorder ${key === 0 && "large:rf-border-t-0"}`,
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $f5e9fcff3fab6870$export$2e2bcd8739ae039), {
                        title: (0, (/*@__PURE__*/$parcel$interopDefault($9cdc7ea7128d4847$exports)))[language],
                        checked: language === currentLanguage,
                        handleChange: ()=>handleChange(language)
                    })
                }, key);
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-mt-8 rf-flex rf-justify-center",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                    className: "rf-px-8 rf-py-3 rf-text-secondary rf-font-bold rf-border-2 rf-border-secondary rf-rounded-lg",
                    onClick: ()=>handleSelect(currentLanguage),
                    children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.common.validate, locale)
                })
            })
        ]
    });
};
var $fcc47f5bf5a9a9b0$export$2e2bcd8739ae039 = $fcc47f5bf5a9a9b0$var$LanguageChoice;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");







var $lT7pJ = parcelRequire("lT7pJ");




const $6976beddfc478bd1$var$infoBannerContenTypes = [
    "foodestablishment",
    "event"
];
const $6976beddfc478bd1$var$categoryConversion = {
    FoodEstablishment: "Where to eat",
    LodgingBusiness: "Where to sleep",
    TouristDestination: "What to see",
    TouristAttraction: "What to do",
    Product: "Local products",
    Service: "Services",
    Event: "Events",
    City: "Cities",
    Wine: "Wines"
};
const $6976beddfc478bd1$var$getCategoryFromContentType = (contentType, translation)=>{
    if (contentType) return {
        id: $6976beddfc478bd1$var$categoryConversion[contentType],
        label: translation.poi[contentType]
    };
    return undefined;
};
const $6976beddfc478bd1$export$af5c868343ae916a = (data, translation)=>{
    if (data.id && data.content) try {
        const content = data.content;
        // Process medias
        const medias = [];
        content.Thing?.Image?.Paths && content.Thing.Image.Paths.length && content.Thing?.Image?.Paths?.forEach((path)=>{
            medias.push({
                url: `${data.baseAddress}media/${path}`
            });
        });
        // Processed address
        const address = {
            addressLocality: content.Place?.AddressLocality?.Text || "",
            postalCode: content.Place?.PostalCode?.Text || "",
            street: content.Place?.StreetAddress?.Text || ""
        };
        // Processed coordinates
        const coordinates = content.Place?.Latitude?.Value && content.Place?.Longitude?.Value ? {
            latitude: content.Place.Latitude.Value,
            longitude: content.Place.Longitude.Value
        } : undefined;
        // Processed review
        const review = {
            author: content.Review?.Author || content.Review?.AuthorCapacity ? {
                name: content.Review?.Author,
                capacity: content.Review?.AuthorCapacity
            } : undefined,
            comment: content.Review?.ReviewBody || "",
            picture: content.Review?.Picture ? {
                url: content.Review.Picture,
                description: content.Review.PictureDescription || ""
            } : undefined
        };
        // Process other informations
        const otherInformations = [];
        // Opening hours
        content.LocalBusiness?.OpeningHours?.Text && otherInformations.push({
            title: translation.poi.openinghours,
            content: content.LocalBusiness.OpeningHours.Text
        });
        // Prices
        content.LocalBusiness?.PriceRange?.Text && otherInformations.push({
            title: translation.poi.prices,
            content: content.LocalBusiness.PriceRange.Text
        });
        // Payment methods
        content.LocalBusiness?.PaymentAccepted?.Values && content.LocalBusiness.PaymentAccepted.Values.length && otherInformations.push({
            title: translation.poi.paymentmethods,
            content: content.LocalBusiness.PaymentAccepted.Values
        });
        // Process information banner
        let infoBanner;
        if (data.contentType && $6976beddfc478bd1$var$infoBannerContenTypes.includes(data.contentType.toLowerCase())) switch(data.contentType.toLowerCase()){
            case "foodestablishment":
                content.Place?.MaximumAttendeeCapacity?.Value && !isNaN(parseInt(content.Place?.MaximumAttendeeCapacity?.Value)) && (infoBanner = `${translation.poi.numberofplaces} ${parseInt(content.Place?.MaximumAttendeeCapacity?.Value)}`);
                break;
            case "event":
                if (content.Event && content.Event.StartDate?.Value && content.Event.EndDate?.value) {
                    const startDate = new Date(content.Event.StartDate.Value);
                    const endDate = new Date(content.Event.StartDate.Value);
                    if (content.Event.StartDate.Value === content.Event.EndDate.value) infoBanner = `Le ${startDate.toLocaleDateString(data.locale)}`;
                    else infoBanner = `Du ${startDate.toLocaleDateString(data.locale)} au ${endDate.toLocaleDateString(data.locale)}`;
                }
                break;
        }
        // Hack for Wines category -> TODO : remove it !
        let categoryWineTest = false;
        const categories = content.Thing?.Categories?.Values;
        const wineFilters = [
            "Blanc de blanc",
            "Ros\xe9 Champagne",
            "Vintages",
            "Cocktail Collection",
            "AUTHIGENE Collection"
        ];
        if (categories && categories.length) categories.forEach((category)=>wineFilters.includes(category) && (categoryWineTest = true));
        const mappedData = {
            identifier: data.id,
            title: content.Thing?.Name?.Text?.toString() || "",
            text: content.Thing?.Description?.Text?.toString() || "",
            addressStructured: address,
            contact: content.PointOfInterest?.Contact?.Text?.toString() || "",
            phoneNumber: content.Place?.Telephone?.Text ? content.Place.Telephone.Text.toString() : "",
            category: categoryWineTest ? {
                id: $6976beddfc478bd1$var$categoryConversion.Wine,
                label: translation.poi.Wine
            } : $6976beddfc478bd1$var$getCategoryFromContentType(content.contentType, translation),
            media: medias.length ? medias : undefined,
            customerReviews: content.Place?.AggregateRating?.Value,
            coordinates: coordinates,
            downloadUri: `${data.baseAddress}api/hospitality/${data.id}/pdf`,
            favorite: !!content.Thing?.Favorite?.Value,
            review: review,
            infoBanner: infoBanner,
            otherInformations: otherInformations
        };
        return mappedData;
    } catch (e) {
        console.log(e);
        return null;
    }
    return null;
};


const $0be8ce1c82668272$var$useShowPOI = ()=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const lastBotActivity = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.lastBotActivity);
    const triggers = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.detailedAttachmentTriggers);
    const baseAddress = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.baseAddress);
    const [result, setResult] = (0, $lT7pJ.useState)(undefined);
    (0, $lT7pJ.useEffect)(()=>{
        if (lastBotActivity && lastBotActivity.value && triggers.length > 0) {
            let result;
            triggers.forEach((trigger)=>{
                if (lastBotActivity.type === trigger.type) {
                    if (trigger.name && trigger.name === lastBotActivity.name) {
                        if (trigger.contentType) {
                            if (trigger.contentType === lastBotActivity.value?.contentType) {
                                lastBotActivity.value.content.template = trigger.linkedComponent;
                                result = lastBotActivity.value.content;
                            }
                        } else {
                            const data = {
                                id: lastBotActivity.value?.contentItemId,
                                content: lastBotActivity.value?.content,
                                contentType: lastBotActivity.value?.contentType,
                                baseAddress: baseAddress,
                                locale: locale
                            };
                            const checkData = (0, $6976beddfc478bd1$export$af5c868343ae916a)(data, translation);
                            if (checkData) result = {
                                ...checkData,
                                template: trigger.linkedComponent
                            };
                            else {
                                lastBotActivity.value.template = trigger.linkedComponent;
                                result = lastBotActivity.value;
                            }
                        }
                    } else if (trigger.label && trigger.label === lastBotActivity.label) {
                        if (trigger.contentType) {
                            if (trigger.contentType === lastBotActivity.value?.contentType) {
                                lastBotActivity.value.content.template = trigger.linkedComponent;
                                result = lastBotActivity.value.content;
                            }
                        } else {
                            lastBotActivity.value.template = trigger.linkedComponent;
                            result = lastBotActivity.value;
                        }
                    }
                }
            });
            setResult(result);
        }
    }, [
        lastBotActivity
    ]);
    return result;
};
var $0be8ce1c82668272$export$2e2bcd8739ae039 = $0be8ce1c82668272$var$useShowPOI;








var $lT7pJ = parcelRequire("lT7pJ");




var $lT7pJ = parcelRequire("lT7pJ");


const $a034ac289dc4dc35$var$CommentsPennant = ({ className: className, color: color, customerReviews: customerReviews })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const [widthInPx, setWidthInPx] = (0, $lT7pJ.useState)(0);
    const pennantRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        if (pennantRef.current) setWidthInPx(Math.ceil(pennantRef.current.offsetWidth / 2));
    }, [
        pennantRef
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `${className} rf-flex rf-flex-col rf-justify-center rf-text-white`,
        ref: pennantRef,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-center rf-p-2 rf-bg-primary",
                style: {
                    backgroundColor: color
                },
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e2a871161dc94629$export$2e2bcd8739ae039), {
                        className: "rf-w-12 large:rf-w-14 large-vertical:rf-w-16 rf-pb-2"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-flex-col rf-text-center rf-text-size-auto rf-uppercase",
                        children: translation.poi.comment.split(" ").map((word, index)=>{
                            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                children: word
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-font-bold rf-subtitle-size-auto",
                        children: [
                            customerReviews,
                            "/10"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-0 rf-h-0 rf-border-t-0 rf-border-x-primary rf-border-b-transparent",
                style: {
                    borderLeftColor: color,
                    borderRightColor: color,
                    borderBottomWidth: widthInPx * 2 / 3,
                    borderLeftWidth: widthInPx,
                    borderRightWidth: widthInPx
                }
            })
        ]
    });
};
var $a034ac289dc4dc35$export$2e2bcd8739ae039 = $a034ac289dc4dc35$var$CommentsPennant;




const $4f79c5c3994dafad$var$DetailedTitle = ({ category: category, title: title, infoBanner: infoBanner, color: color, customerReviews: customerReviews, favorite: favorite, handleClose: handleClose, setTitleHeight: setTitleHeight })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const titleRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        titleRef?.current && setTitleHeight(titleRef.current.clientHeight);
    }, [
        titleRef?.current
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        ref: titleRef,
        className: "rf-relative rf-pb-4 rf-flex-col rf-items-start rf-justify-center",
        children: [
            customerReviews && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a034ac289dc4dc35$export$2e2bcd8739ae039), {
                className: "rf-absolute rf-hidden large-vertical:rf-block rf-top-0 rf-right-0",
                color: color,
                customerReviews: customerReviews
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-justify-between rf-items-start",
                children: [
                    isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                        title: translation.common.back,
                        handleBack: handleClose,
                        className: "rf-relative rf-mt-4 rf-text-size-auto"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-uppercase rf-w-fit rf-py-2 large:rf-py-3 rf-px-4 rf-bg-black rf-text-primary",
                        style: {
                            color: color
                        },
                        children: category?.label || "category"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-py-6 rf-title-large-bold-size-auto large-vertical:rf-pt-[16.67%] rf-flex rf-flex-row rf-items-center rf-font-bold",
                children: [
                    favorite && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e196c2553a5ffe2c$export$2e2bcd8739ae039), {
                        className: "rf-h-16 rf-w-20 rf-pr-4"
                    }),
                    title || ""
                ]
            }),
            infoBanner && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-py-1 rf-px-4 rf-subtitle-size-auto rf-bg-primary rf-text-truewhite",
                style: {
                    backgroundColor: color
                },
                children: infoBanner
            })
        ]
    });
};
var $4f79c5c3994dafad$export$2e2bcd8739ae039 = $4f79c5c3994dafad$var$DetailedTitle;




var $lT7pJ = parcelRequire("lT7pJ");



parcelRequire("lT7pJ");



const $24f79abaafef1693$var$DownloadSheet = ({ className: className, url: url })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `${className} rf-w-full rf-flex`,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("a", {
            href: url,
            className: "rf-px-5 rf-py-3 rf-h-fit rf-flex rf-flex-row rf-items-center rf-mt-8 rf-mb-16 large:rf-my-0 rf-border-2 rf-border-black rf-rounded-lg hover:rf-bg-truewhite rf-cursor-pointer rf-font-bold",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $378d08b46762921f$export$2e2bcd8739ae039), {
                    className: "rf-h-6 rf-w-6 rf-mr-1"
                }),
                (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.common.downloadsheet, locale)
            ]
        })
    });
};
var $24f79abaafef1693$export$2e2bcd8739ae039 = $24f79abaafef1693$var$DownloadSheet;




var $lT7pJ = parcelRequire("lT7pJ");





/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("lT7pJ");




const $7f6fa88d57e27fac$var$PrintingButton = ({ url: url })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const handleClick = ()=>{
        (0, $1bda010252da638c$export$4317154639841e84)(/*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $97fc7d6e74a4cfb9$export$2e2bcd8739ae039), {
            url: url,
            printingAllowed: true
        }));
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
        className: "rf-px-4 rf-py-1 rf-flex rf-flex-row rf-items-center rf-gap-2 rf-font-bold rf-text-sm rf-border-2 rf-border-black rf-rounded-lg",
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8020f0ddfe1ce5ff$export$2e2bcd8739ae039), {}),
            translation.common.printsheet
        ]
    });
};
var $7f6fa88d57e27fac$export$2e2bcd8739ae039 = $7f6fa88d57e27fac$var$PrintingButton;



const $8d37fbba6b0b4644$var$DownloadQR = ({ url: url })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const enableDocumentPrinting = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.enableDocumentPrinting);
    const [qrCodeData, setQrCodeData] = (0, $lT7pJ.useState)(undefined);
    const imageRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        setQrCodeDataAsync();
    }, []);
    const setQrCodeDataAsync = async ()=>{
        const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($33b99b026c95b649$exports))).toDataURL(url);
        setQrCodeData(qrCodeString);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-flex rf-flex-row rf-items-start",
        children: [
            enableDocumentPrinting && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-justify-start",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $7f6fa88d57e27fac$export$2e2bcd8739ae039), {
                    url: url
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-center rf-text-center rf-gap-2 rf-font-bold rf-text-sm",
                style: {
                    width: enableDocumentPrinting ? "50%" : "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-flex rf-flex-row rf-items-start rf-gap-1 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8c84d47da720aa29$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-w-fit",
                                children: `${(0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.common.downloadsheetmobile, locale)} ${translation.link.scanQR}`
                            })
                        ]
                    }),
                    qrCodeData && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "large-vertical:rf-mt-4",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $afe82365b658f5fb$export$2e2bcd8739ae039), {
                            ref: imageRef,
                            src: qrCodeData
                        })
                    })
                ]
            })
        ]
    });
};
var $8d37fbba6b0b4644$export$2e2bcd8739ae039 = $8d37fbba6b0b4644$var$DownloadQR;


const $84dd544f402a63de$var$DownloadQRHeight = 200;
const $84dd544f402a63de$var$DownloadSheetHeight = 100;
const $84dd544f402a63de$var$DetailedText = ({ text: text, otherInformations: otherInformations, color: color, url: url, titleHeight: titleHeight })=>{
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.isUsedOnBorne);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isLandscape = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isLandscape);
    const currentHeight = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentHeight);
    const textRef = (0, $lT7pJ.useRef)(null);
    const otherInformationsRef = (0, $lT7pJ.useRef)(null);
    const [opacityStyle, setOpacityStyle] = (0, $lT7pJ.useState)("");
    const [otherOpacityStyle, setOtherOpacityStyle] = (0, $lT7pJ.useState)("");
    const processedText = (0, $lT7pJ.useMemo)(()=>{
        if (text) return text.replaceAll("\n", "<br>");
        return "";
    }, [
        text
    ]);
    const textContainerMaxHeight = (0, $lT7pJ.useMemo)(()=>{
        return currentHeight - titleHeight - (isUsedOnBorne ? $84dd544f402a63de$var$DownloadQRHeight : $84dd544f402a63de$var$DownloadSheetHeight);
    }, [
        titleHeight
    ]);
    const [textMaxHeight, setTextMaxHeight] = (0, $lT7pJ.useState)(0);
    const [otherInformationsMaxHeight, setOtherInformationsMaxHeight] = (0, $lT7pJ.useState)(0);
    (0, $lT7pJ.useEffect)(()=>{
        if (textRef?.current && otherInformationsRef?.current && textContainerMaxHeight && !isMobile) {
            const textHeight = isLandscape ? textContainerMaxHeight * 58 / 100 : currentHeight * 30 / 100;
            const otherInformationsHeight = isLandscape ? textContainerMaxHeight * 40 / 100 : currentHeight * 18 / 100;
            if (textRef.current.scrollHeight > textHeight) {
                if (otherInformationsRef.current.scrollHeight > otherInformationsHeight) {
                    setTextMaxHeight(textHeight);
                    setOtherInformationsMaxHeight(otherInformationsHeight);
                } else {
                    setTextMaxHeight(textContainerMaxHeight - otherInformationsRef.current.scrollHeight);
                    setOtherInformationsMaxHeight(otherInformationsHeight);
                }
            } else if (otherInformationsRef.current.scrollHeight > otherInformationsHeight) {
                setTextMaxHeight(textHeight);
                setOtherInformationsMaxHeight(textContainerMaxHeight - textRef.current.scrollHeight);
            } else {
                setTextMaxHeight(textHeight);
                setOtherInformationsMaxHeight(otherInformationsHeight);
            }
        }
    }, [
        textRef?.current,
        otherInformationsRef?.current,
        textContainerMaxHeight
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (textRef?.current && textMaxHeight) {
            if (!isMobile && textRef.current.scrollHeight > textMaxHeight && textRef.current.scrollHeight > textRef.current.clientHeight) handleScroll();
            else setOpacityStyle(undefined);
        }
    }, [
        textRef?.current,
        textMaxHeight
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (otherInformationsRef?.current && otherInformationsMaxHeight) {
            if (!isMobile && otherInformationsRef.current.scrollHeight > otherInformationsMaxHeight && otherInformationsRef.current.scrollHeight > otherInformationsRef.current.clientHeight) handleOtherScroll();
            else setOtherOpacityStyle(undefined);
        }
    }, [
        otherInformationsRef?.current,
        otherInformationsMaxHeight
    ]);
    /**
   * On call :
   *  - check if textRef.current is defined
   *  - set opacityStyle state depending on scroll height and current scrolling
   */ const handleScroll = ()=>{
        if (textRef.current) {
            const maxScroll = textRef.current.scrollHeight - textRef.current.offsetHeight;
            const percentage = Math.ceil(textRef.current.scrollTop / maxScroll * 40);
            setOpacityStyle(`linear-gradient(to bottom, black ${60 + percentage}%, transparent 100%)`);
        }
    };
    const handleOtherScroll = ()=>{
        if (otherInformationsRef.current) {
            const maxScroll = otherInformationsRef.current.scrollHeight - otherInformationsRef.current.offsetHeight;
            const percentage = Math.ceil(otherInformationsRef.current.scrollTop / maxScroll * 30);
            setOtherOpacityStyle(`linear-gradient(to bottom, black ${70 + percentage}%, transparent 100%)`);
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-flex rf-flex-col large:rf-pr-4 large:rf-min-w-1/2 rf-gap-4",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-col rf-items-start",
                style: {
                    maxHeight: isLandscape ? textContainerMaxHeight : undefined
                },
                children: [
                    processedText && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        ref: textRef,
                        className: "large-vertical:rf-max-h-[30vh] rf-font-medium rf-overflow-y-scroll rf-pb-4 rf-scroll-pb-4 rf-scrollbar-hidden",
                        style: {
                            WebkitMaskImage: opacityStyle,
                            maxHeight: textMaxHeight || undefined
                        },
                        onScroll: handleScroll,
                        dangerouslySetInnerHTML: {
                            __html: processedText
                        }
                    }),
                    otherInformations && otherInformations.length > 0 && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        ref: otherInformationsRef,
                        className: "large-vertical:rf-max-h-[18vh] rf-flex rf-flex-col rf-justify-start rf-text-lightgray rf-overflow-y-scroll rf-pb-4 rf-scroll-pb-4 rf-scrollbar-hidden",
                        style: {
                            WebkitMaskImage: otherOpacityStyle,
                            maxHeight: otherInformationsMaxHeight || undefined
                        },
                        onScroll: handleOtherScroll,
                        children: otherInformations.map((information, key)=>{
                            const tempContent = Array.isArray(information.content) ? information.content.join(" | ") : information.content;
                            const htmlContent = tempContent.replaceAll("\n", "<br>");
                            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                        className: "rf-mt-4",
                                        style: {
                                            color: color || "rgb(25, 153, 177)"
                                        },
                                        children: information.title
                                    }),
                                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: htmlContent
                                        }
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            }),
            isLandscape && url && (isUsedOnBorne ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8d37fbba6b0b4644$export$2e2bcd8739ae039), {
                url: url
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $24f79abaafef1693$export$2e2bcd8739ae039), {
                url: url
            }))
        ]
    });
};
var $84dd544f402a63de$export$2e2bcd8739ae039 = $84dd544f402a63de$var$DetailedText;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");



const $8df7f20134ca2df3$var$DetailedMedia = ({ media: media, review: review, color: color })=>{
    const [landscapeImage, setLandscapeImage] = (0, $lT7pJ.useState)(false);
    const [carouselMedia, setCarouselMedia] = (0, $lT7pJ.useState)([]);
    (0, $lT7pJ.useEffect)(()=>{
        if (media && media.length > 0) {
            let tempMedia = [];
            media.forEach((med)=>{
                med.url && (tempMedia = [
                    ...tempMedia,
                    {
                        url: med.url,
                        alt: med.title || "media"
                    }
                ]);
            });
            setCarouselMedia(tempMedia);
        }
    }, [
        media
    ]);
    /**
   * On review change :
   *  - check if the review contains a picture url
   *  - if so, create an Image with this url, and check if its width is larger than its height
   *  - set landscapeImage state with the result
   */ (0, $lT7pJ.useEffect)(()=>{
        if (review?.picture?.url) {
            const getImageData = async ()=>{
                const image = new Image();
                image.onload = ()=>{
                    setLandscapeImage(image.width > image.height);
                };
                image.src = review?.picture?.url || "";
            };
            getImageData();
        }
    }, [
        review
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "large:rf-min-w-1/2 large:rf-pl-4 rf-flex rf-flex-col rf-items-center",
        children: [
            carouselMedia && carouselMedia.length > 0 && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-relative rf-flex rf-justify-center rf-align-center rf-w-full rf-aspect-[4/3] rf-mb-4 rf-overflow-hidden",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $04a0ad14abdfdd87$export$2e2bcd8739ae039), {
                    className: "rf-min-h-full rf-min-w-full rf-object-cover",
                    medias: carouselMedia,
                    controls: true,
                    timer: 3000,
                    color: color
                })
            }),
            review && review.comment && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-p-4 large:rf-mb-4 rf-flex rf-flex-col rf-gap-4 rf-bg-truewhite rf-rounded-lg rf-shadow-[0_3px_6px_#00000029]",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-text-lightgray",
                        children: review.comment
                    }),
                    (review.picture || review.author) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-flex rf-flex-row rf-items-center",
                        children: [
                            review.picture && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-h-12 rf-w-12 rf-min-w-12 large:rf-h-16 large:rf-w-16 large:rf-min-w-16 large-vertical:rf-h-24 large-vertical:rf-w-24 large-vertical:rf-min-w-24 rf-mr-4 rf-flex rf-items-center rf-rounded-half rf-overflow-hidden",
                                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                                    src: review.picture.url || (0, $15bfb737ffe6480e$export$e56d88b19b5c9fbf).noimage,
                                    alt: review.picture.description || "auteur",
                                    className: landscapeImage ? "rf-h-full rf-max-w-none" : "rf-w-full"
                                })
                            }),
                            review.author && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                className: "rf-flex rf-flex-col rf-items-start",
                                children: [
                                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                        className: "rf-font-bold",
                                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(review.author.name || "")
                                    }),
                                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                        className: "rf-italic",
                                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(review.author.capacity || "")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $8df7f20134ca2df3$export$2e2bcd8739ae039 = $8df7f20134ca2df3$var$DetailedMedia;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");



parcelRequire("lT7pJ");

const $e4d6c6b34632c258$var$ShowPhoneNumber = ({ phoneNumber: phoneNumber })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-px-5 rf-py-3 rf-mb-8 rf-flex rf-flex-row rf-items-center rf-font-bold",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $2e1dd88327c4752d$export$2e2bcd8739ae039), {
                className: "rf-h-6 rf-w-6 rf-mr-2"
            }),
            phoneNumber
        ]
    });
};
var $e4d6c6b34632c258$export$2e2bcd8739ae039 = $e4d6c6b34632c258$var$ShowPhoneNumber;





var $lT7pJ = parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");
function $3fa833a1c77ee8fb$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $3fa833a1c77ee8fb$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $lT7pJ.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $lT7pJ.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $lT7pJ.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $lT7pJ.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}


var $lT7pJ = parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");
const $129e4d50a5682043$export$b8efcc4bff45e15b = 1;
function $129e4d50a5682043$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $129e4d50a5682043$export$b8efcc4bff45e15b,
        map: map
    });
}
function $129e4d50a5682043$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $129e4d50a5682043$export$7de1b54b0142048f = (0, $lT7pJ.createContext)(null);
const $129e4d50a5682043$export$a24c9fc2f87814b2 = $129e4d50a5682043$export$7de1b54b0142048f.Provider;
function $129e4d50a5682043$export$ea59151b8430a4e9() {
    const context = (0, $lT7pJ.useContext)($129e4d50a5682043$export$7de1b54b0142048f);
    if (context == null) throw new Error("No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>");
    return context;
}


function $d8c13b9b5c86bed1$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $lT7pJ.useImperativeHandle)(forwardedRef, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $129e4d50a5682043$export$a24c9fc2f87814b2), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $lT7pJ.forwardRef)(ContainerComponent);
}
function $d8c13b9b5c86bed1$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $lT7pJ.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $lT7pJ.useImperativeHandle)(forwardedRef, ()=>instance);
        (0, $lT7pJ.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $104722dc8dfafae7$exports.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $lT7pJ.forwardRef)(OverlayComponent);
}
function $d8c13b9b5c86bed1$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $lT7pJ.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $lT7pJ.forwardRef)(LeafComponent);
}



var $lT7pJ = parcelRequire("lT7pJ");

function $e3b2fba80031daa5$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $129e4d50a5682043$export$ea59151b8430a4e9)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $lT7pJ.useRef)(props.position);
        const { position: position } = props;
        (0, $lT7pJ.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $lT7pJ.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}




var $lT7pJ = parcelRequire("lT7pJ");

var $lT7pJ = parcelRequire("lT7pJ");
function $f83a866fe9f896bc$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $lT7pJ.useRef)(attribution);
    (0, $lT7pJ.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}




var $lT7pJ = parcelRequire("lT7pJ");
function $79a7504c7f715599$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $lT7pJ.useRef)();
    (0, $lT7pJ.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}


function $723b4031862bdf34$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}


function $ef703ebc1d4251e1$export$cd00a227f8cfb2c2(element, context) {
    (0, $lT7pJ.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $ef703ebc1d4251e1$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $129e4d50a5682043$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $723b4031862bdf34$export$6ee5d263358f5c0e)(props, context), context);
        (0, $f83a866fe9f896bc$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $79a7504c7f715599$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        $ef703ebc1d4251e1$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}






function $758cd1b33678c6ad$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $129e4d50a5682043$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $723b4031862bdf34$export$6ee5d263358f5c0e)(props, context), context);
        (0, $f83a866fe9f896bc$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $79a7504c7f715599$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}



var $lT7pJ = parcelRequire("lT7pJ");




function $b0c18e371ebf00c3$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $lT7pJ.useRef)();
    (0, $lT7pJ.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $b0c18e371ebf00c3$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $129e4d50a5682043$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $723b4031862bdf34$export$6ee5d263358f5c0e)(props, context), context);
        (0, $79a7504c7f715599$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        (0, $ef703ebc1d4251e1$export$cd00a227f8cfb2c2)(elementRef.current, context);
        $b0c18e371ebf00c3$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}


function $8bda42eeaaf9aca1$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $3fa833a1c77ee8fb$export$a080ff44e8067a44)(createInstance(props), context);
    }
    const useElement = (0, $3fa833a1c77ee8fb$export$2e66ec8a7fb1892f)(createElement);
    const useControl = (0, $e3b2fba80031daa5$export$28d24ab3914549cd)(useElement);
    return (0, $d8c13b9b5c86bed1$export$18af5c7a9e9b3664)(useControl);
}
function $8bda42eeaaf9aca1$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $3fa833a1c77ee8fb$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $ef703ebc1d4251e1$export$73f852c6a5abdefa)(useElement);
    return (0, $d8c13b9b5c86bed1$export$96eac748c3f41e82)(useLayer);
}
function $8bda42eeaaf9aca1$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $3fa833a1c77ee8fb$export$2e66ec8a7fb1892f)(createElement);
    const useOverlay = (0, $758cd1b33678c6ad$export$d5eca53b0accc0e0)(useElement, useLifecycle);
    return (0, $d8c13b9b5c86bed1$export$bc37ddc24ed05446)(useOverlay);
}
function $8bda42eeaaf9aca1$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $3fa833a1c77ee8fb$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const usePath = (0, $b0c18e371ebf00c3$export$5fea2fe6048fc3db)(useElement);
    return (0, $d8c13b9b5c86bed1$export$96eac748c3f41e82)(usePath);
}
function $8bda42eeaaf9aca1$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $3fa833a1c77ee8fb$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $ef703ebc1d4251e1$export$73f852c6a5abdefa)(useElement);
    return (0, $d8c13b9b5c86bed1$export$18af5c7a9e9b3664)(useLayer);
}



const $fef21e6ee02541f8$export$3a16e672cb3a069e = (0, $8bda42eeaaf9aca1$export$5e776dbe3c7d2790)(function createGeoJSON({ data: data, ...options }, ctx) {
    const geoJSON = new (0, $7283d4ae4f1ab968$exports.GeoJSON)(data, options);
    return (0, $3fa833a1c77ee8fb$export$a080ff44e8067a44)(geoJSON, (0, $129e4d50a5682043$export$9efaf186a2224858)(ctx, {
        overlayContainer: geoJSON
    }));
}, function updateGeoJSON(layer, props, prevProps) {
    if (props.style !== prevProps.style) {
        if (props.style == null) layer.resetStyle();
        else layer.setStyle(props.style);
    }
});




var $lT7pJ = parcelRequire("lT7pJ");
function $c72da9a52373c4d4$var$_extends() {
    $c72da9a52373c4d4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c72da9a52373c4d4$var$_extends.apply(this, arguments);
}
function $c72da9a52373c4d4$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $lT7pJ.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $lT7pJ.useState)(null);
    (0, $lT7pJ.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = (0, $lT7pJ.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new (0, $7283d4ae4f1ab968$exports.Map)(node, options);
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $129e4d50a5682043$export$fb237fa819e17281)(map));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement((0, $129e4d50a5682043$export$a24c9fc2f87814b2), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).createElement("div", $c72da9a52373c4d4$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}
const $c72da9a52373c4d4$export$23f3dfd47374502b = /*#__PURE__*/ (0, $lT7pJ.forwardRef)($c72da9a52373c4d4$var$MapContainerComponent);



const $3031ba457ef8c60f$export$e98856a975cab58e = (0, $8bda42eeaaf9aca1$export$8a4d5778bce4c3ac)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $7283d4ae4f1ab968$exports.Marker)(position, options);
    return (0, $3fa833a1c77ee8fb$export$a080ff44e8067a44)(marker, (0, $129e4d50a5682043$export$9efaf186a2224858)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});

function $94df09c97e40a611$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}



const $36ae39183e21cc8c$export$f52ee31d61d0b27b = (0, $8bda42eeaaf9aca1$export$4f432c6de5c4ddb8)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $7283d4ae4f1ab968$exports.TileLayer)(url, (0, $723b4031862bdf34$export$6ee5d263358f5c0e)(options, context));
    return (0, $3fa833a1c77ee8fb$export$a080ff44e8067a44)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $94df09c97e40a611$export$b39104a5f1b9296f)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});










var $lT7pJ = parcelRequire("lT7pJ");






parcelRequire("lT7pJ");
const $4a11048bd1f264c1$var$getDistanceAsString = (distance)=>{
    if (typeof distance !== "number") return "NC";
    if (distance <= 0) return "0 m";
    if (distance < 1) return `${distance * 100} cm`;
    if (distance < 1000) return `${distance} m`;
    if (distance >= 1000) return `${Math.ceil(distance / 1000) * 10 / 10} km`;
    return "NC";
};
var $4a11048bd1f264c1$export$2e2bcd8739ae039 = $4a11048bd1f264c1$var$getDistanceAsString;


const $346a7846cec44524$var$getTimeAsString = (time)=>{
    if (typeof time !== "number") return "NC";
    if (time < 1) return "NC";
    if (time < 60) return `${time} s`;
    if (time < 3600) return `${Math.ceil(time / 60)} min`;
    if (time === 3600) return `1 h`;
    if (time > 3600) {
        const hours = Math.floor(time / 3600);
        const minutes = Math.ceil((time - hours * 3600) / 60);
        return `${hours} h ${minutes === 60 ? 59 : minutes < 10 ? `0${minutes}` : minutes}`;
    }
    return "NC";
};
var $346a7846cec44524$export$2e2bcd8739ae039 = $346a7846cec44524$var$getTimeAsString;



parcelRequire("lT7pJ");
const $332f38e097c9576e$var$CyclingRegularIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 34.168 29.135",
        className: className || "rf-w-8 rf-h-8",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
            transform: "translate(0.5 -1.484)",
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
                d: "M20.5,6.789a2.645,2.645,0,1,0-2.645-2.645A2.653,2.653,0,0,0,20.5,6.789Zm-13.885,8.6a6.612,6.612,0,1,0,0,13.224,6.612,6.612,0,1,0,0-13.224Zm0,11.24a4.628,4.628,0,1,1,0-9.257,4.628,4.628,0,1,1,0,9.257ZM14.282,13.4l3.174-3.174,1.058,1.058a9.264,9.264,0,0,0,6.744,2.777V11.418A6.57,6.57,0,0,1,20.5,9.434L17.984,6.922a3.242,3.242,0,0,0-2.116-.793,2.219,2.219,0,0,0-1.851.793l-3.7,3.7a2.611,2.611,0,0,0-.793,1.851,2.219,2.219,0,0,0,.793,1.851l4.232,3.7v6.612h2.645v-8.2Zm10.843,1.984A6.612,6.612,0,1,0,31.737,22,6.548,6.548,0,0,0,25.125,15.385Zm0,11.24A4.628,4.628,0,1,1,29.753,22,4.685,4.685,0,0,1,25.125,26.625Z",
                transform: "translate(0 0.484)",
                fill: color || "#fff"
            })
        })
    });
};
var $332f38e097c9576e$export$2e2bcd8739ae039 = $332f38e097c9576e$var$CyclingRegularIcon;



parcelRequire("lT7pJ");
const $f623a2d925fec22a$var$DrivingCarIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 34.168 29.135",
        className: className || "rf-w-8 rf-h-8",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            id: "car",
            d: "M32.385,71.254H28.507L27.43,68.559A7.217,7.217,0,0,0,20.7,64H12.471a7.219,7.219,0,0,0-6.735,4.559L4.658,71.254H.781a.777.777,0,0,0-.754.966l.389,1.554a.777.777,0,0,0,.754.589h1.3a4.116,4.116,0,0,0-1.43,3.109V80.58A4.111,4.111,0,0,0,2.076,83.3v3.5a2.073,2.073,0,0,0,2.072,2.072H6.221A2.073,2.073,0,0,0,8.293,86.8V84.725h16.58V86.8a2.073,2.073,0,0,0,2.072,2.072h2.072A2.073,2.073,0,0,0,31.09,86.8V83.3a4.109,4.109,0,0,0,1.036-2.716V77.471A4.118,4.118,0,0,0,30.7,74.362H32a.777.777,0,0,0,.754-.589l.389-1.554a.778.778,0,0,0-.754-.966ZM9.584,70.1a3.109,3.109,0,0,1,2.887-1.954H20.7A3.109,3.109,0,0,1,23.582,70.1l1.291,3.227H8.293ZM6.221,80.567a2.066,2.066,0,1,1,0-4.132,3.987,3.987,0,0,1,3.109,3.1c0,1.24-1.865,1.033-3.109,1.033Zm20.725,0c-1.243,0-3.109.207-3.109-1.033a3.987,3.987,0,0,1,3.109-3.1,2.066,2.066,0,1,1,0,4.132Z",
            transform: "translate(0.501 -63.5)",
            fill: color || "#fff"
        })
    });
};
var $f623a2d925fec22a$export$2e2bcd8739ae039 = $f623a2d925fec22a$var$DrivingCarIcon;



parcelRequire("lT7pJ");
const $08c000f03b93b65a$var$FootWalkingIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-6 0 34.168 29.135",
        className: className || "rf-w-8 rf-h-8",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M11.4,5.249A2.625,2.625,0,1,0,8.772,2.625,2.625,2.625,0,0,0,11.4,5.249ZM16.564,13.4l-1.274-.645-.53-1.608A5.962,5.962,0,0,0,9.171,7c-1.968-.005-3.057.552-5.1,1.378A5.216,5.216,0,0,0,1.352,10.9l-.366.744a1.755,1.755,0,0,0,.776,2.346,1.726,1.726,0,0,0,2.324-.782l.366-.744a1.738,1.738,0,0,1,.9-.842l1.465-.591-.831,3.319A3.512,3.512,0,0,0,6.8,17.568l3.275,3.576a3.529,3.529,0,0,1,.815,1.515l1,4.008a1.75,1.75,0,0,0,3.4-.848l-1.214-4.866a3.5,3.5,0,0,0-.815-1.515l-2.488-2.718.94-3.756.3.9a3.487,3.487,0,0,0,1.733,2.023l1.274.645a1.726,1.726,0,0,0,2.324-.782,1.77,1.77,0,0,0-.782-2.351ZM4.048,21.1a3.393,3.393,0,0,1-.776,1.176L.538,25.01a1.75,1.75,0,1,0,2.472,2.477l3.248-3.248a3.554,3.554,0,0,0,.776-1.176l.738-1.848c-3.024-3.3-2.116-2.286-2.592-2.936L4.048,21.1Z",
            transform: "translate(0.612 0.5)",
            fill: color || "#fff"
        })
    });
};
var $08c000f03b93b65a$export$2e2bcd8739ae039 = $08c000f03b93b65a$var$FootWalkingIcon;



parcelRequire("lT7pJ");
const $e285b87843338f93$var$OpenLocationIcon = ({ className: className })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 29.771 29.771",
        className: className || "rf-w-6 rf-h-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M29.771,0,0,14.886l11.164,3.721,3.721,11.164Z"
        })
    });
};
var $e285b87843338f93$export$2e2bcd8739ae039 = $e285b87843338f93$var$OpenLocationIcon;



parcelRequire("lT7pJ");
const $de034fe410ad48ea$var$TriangleIcon = ({ className: className, color: color })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 12",
        className: className || "rf-w-3 rf-h-3",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M6.336,2.5a2,2,0,0,1,3.328,0l4.263,6.394A2,2,0,0,1,12.263,12H3.737A2,2,0,0,1,2.073,8.891Z",
            fill: color || "transparent"
        })
    });
};
var $de034fe410ad48ea$export$2e2bcd8739ae039 = $de034fe410ad48ea$var$TriangleIcon;




const $6c72606a401defb9$var$RoutesItem = ({ summary: summary, chosen: chosen, color: color, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-flex rf-flex-col rf-justify-end hover:rf-cursor-pointer",
        onClick: ()=>onClick(summary.type),
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
            className: "rf-h-full rf-flex rf-flex-row rf-gap-3 rf-items-center",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                    className: "rf-relative rf-flex rf-justify-center rf-items-center",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-absolute rf-w-9 rf-h-9 rf-rounded-max",
                            style: {
                                backgroundColor: chosen ? color : "#EFEDF0"
                            }
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-absolute rf-w-full -rf-top-[1.15rem] rf-flex rf-justify-center",
                            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($de034fe410ad48ea$export$2e2bcd8739ae039, {
                                className: "rf-w-2 rf-h-2",
                                color: chosen ? color : "transparent"
                            })
                        }),
                        summary.type === "drivingCar" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($f623a2d925fec22a$export$2e2bcd8739ae039, {
                            className: "rf-w-5 rf-z-util",
                            color: chosen ? "#FFF" : "#535252"
                        }),
                        summary.type === "cyclingRegular" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($332f38e097c9576e$export$2e2bcd8739ae039, {
                            className: "rf-w-6 rf-z-util",
                            color: chosen ? "#FFF" : "#535252"
                        }),
                        summary.type === "footWalking" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($08c000f03b93b65a$export$2e2bcd8739ae039, {
                            className: "rf-w-6 rf-z-util",
                            color: chosen ? "#FFF" : "#535252"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                    className: "rf-flex rf-flex-col rf-justify-center rf-items-start",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-whitespace-nowrap rf-font-bold",
                            children: (0, $346a7846cec44524$export$2e2bcd8739ae039)(summary?.duration)
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-whitespace-nowrap",
                            children: (0, $4a11048bd1f264c1$export$2e2bcd8739ae039)(summary?.distance)
                        })
                    ]
                })
            ]
        })
    });
};
var $6c72606a401defb9$export$2e2bcd8739ae039 = $6c72606a401defb9$var$RoutesItem;



const $c783930db8abad34$var$Routes = ({ coordinates: coordinates, setMapLayerData: setMapLayerData, color: color, setQrCodeUrl: setQrCodeUrl })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.isUsedOnBorne);
    const [drivingCar, setDrivingCar] = (0, $lT7pJ.useState)(undefined);
    const [cyclingRegular, setCyclingRegular] = (0, $lT7pJ.useState)(undefined);
    const [footWalking, setFootWalking] = (0, $lT7pJ.useState)(undefined);
    const [currentChosen, setCurrentChosen] = (0, $lT7pJ.useState)(undefined);
    const travelModeRef = (0, $lT7pJ.useRef)();
    /**
   * On component mount :
   *  - call methods to retrieve data from openroute API
   */ (0, $lT7pJ.useEffect)(()=>{
        calculateForProfile("driving-car");
        calculateForProfile("cycling-regular");
        calculateForProfile("foot-walking");
    }, []);
    /**
   * On currentChosen state change :
   *  - switch on currentChosen value to display the associated data on the map
   */ (0, $lT7pJ.useEffect)(()=>{
        switch(currentChosen){
            case "drivingCar":
                drivingCar && drivingCar.features && setMapLayerData(drivingCar);
                travelModeRef.current = "driving";
                break;
            case "cyclingRegular":
                cyclingRegular && cyclingRegular.features && setMapLayerData(cyclingRegular);
                travelModeRef.current = "bicycling";
                break;
            case "footWalking":
                footWalking && footWalking.features && setMapLayerData(footWalking);
                travelModeRef.current = "walking";
                break;
            default:
                break;
        }
    }, [
        currentChosen
    ]);
    /**
   * On drivingCar state change :
   *  - if driving car data were retrieved and no course has been chosen, set currentChosen state to 'driving-car'
   */ (0, $lT7pJ.useEffect)(()=>{
        drivingCar && !currentChosen && setCurrentChosen("drivingCar");
    }, [
        drivingCar
    ]);
    /**
   * On call :
   *  - call the openroute API to retrieve data for the current course
   * @param profile : string
   */ const calculateForProfile = async (profile)=>{
        const url = `${(0, $bbe458fac496c294$export$d6542303192de6db)}/${profile}/geojson`;
        const data = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: (0, $bbe458fac496c294$export$6f60da16472d34a7),
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                coordinates: coordinates
            })
        }).then((result)=>{
            return result.json();
        }).catch(()=>{
            return null;
        });
        if (data && !data.error) switch(profile){
            case "driving-car":
                setDrivingCar(data);
                break;
            case "cycling-regular":
                setCyclingRegular(data);
                break;
            case "foot-walking":
                setFootWalking(data);
                break;
            default:
                break;
        }
    };
    const handleClick = async ()=>{
        if (travelModeRef?.current && coordinates.length === 2) {
            // Create an URL to Google Maps with coordinates and travelling mode
            const coordinatesInUrl = `origin=${coordinates[0][1]},${coordinates[0][0]}&destination=${coordinates[1][1]},${coordinates[1][0]}`;
            const fullUrl = `${(0, $bbe458fac496c294$export$f3c31933b33f3693)}${coordinatesInUrl}&travelmode=${travelModeRef.current}`;
            if (isUsedOnBorne) {
                const url = await (0, (/*@__PURE__*/$parcel$interopDefault($33b99b026c95b649$exports))).toDataURL(fullUrl);
                setQrCodeUrl(url);
            } else // If we are not on a borne, open a new tab in browser
            window.open(fullUrl, "_blank");
        }
    };
    return drivingCar || cyclingRegular || footWalking ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-absolute rf-bottom-2 rf-w-full rf-flex rf-flex-row rf-gap-4 rf-justify-center",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-grid rf-grid-cols-routes rf-pl-6 rf-pr-4 rf-py-2 rf-gap-4 rf-rounded-lg rf-bg-truewhite rf-text-xs large:rf-text-sm rf-shadow-[0_6px_6px_#00000029]",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6c72606a401defb9$export$2e2bcd8739ae039), {
                        summary: {
                            type: "drivingCar",
                            distance: drivingCar?.features?.length ? drivingCar.features[0].properties?.summary?.distance : undefined,
                            duration: drivingCar?.features?.length ? drivingCar.features[0].properties?.summary?.duration : undefined
                        },
                        chosen: currentChosen === "drivingCar",
                        color: color,
                        onClick: setCurrentChosen
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6c72606a401defb9$export$2e2bcd8739ae039), {
                        summary: {
                            type: "cyclingRegular",
                            distance: cyclingRegular?.features?.length ? cyclingRegular.features[0].properties?.summary?.distance : undefined,
                            duration: cyclingRegular?.features?.length ? cyclingRegular.features[0].properties?.summary?.duration : undefined
                        },
                        chosen: currentChosen === "cyclingRegular",
                        color: color,
                        onClick: setCurrentChosen
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6c72606a401defb9$export$2e2bcd8739ae039), {
                        summary: {
                            type: "footWalking",
                            distance: footWalking?.features?.length ? footWalking.features[0].properties?.summary?.distance : undefined,
                            duration: footWalking?.features?.length ? footWalking.features[0].properties?.summary?.duration : undefined
                        },
                        chosen: currentChosen === "footWalking",
                        color: color,
                        onClick: setCurrentChosen
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
                className: "rf-aspect-square rf-w-3/20 rf-min-w-3/20 rf-max-w-3/20 large:rf-w-1/8 large:rf-min-w-1/8 large:rf-max-w-1/8 rf-overflow-y-hidden rf-p-1 rf-flex rf-flex-col rf-justify-evenly rf-items-center rf-border-2 rf-border-trueblack rf-rounded-lg rf-font-bold rf-text-xs large:rf-text-sm rf-bg-truewhite",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e285b87843338f93$export$2e2bcd8739ae039), {
                        className: "rf-w-5 rf-h-5"
                    }),
                    (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.poi.route, locale)
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $c783930db8abad34$export$2e2bcd8739ae039 = $c783930db8abad34$var$Routes;




var $lT7pJ = parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");
function $0a6de6b83a6aa6f9$export$86f8f9f08863e403() {
    return (0, $129e4d50a5682043$export$ea59151b8430a4e9)().map;
}
function $0a6de6b83a6aa6f9$export$4c2959913f5c7962(type, handler) {
    const map = $0a6de6b83a6aa6f9$export$86f8f9f08863e403();
    (0, $lT7pJ.useEffect)(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function $0a6de6b83a6aa6f9$export$1c51e2c234152172(handlers) {
    const map = $0a6de6b83a6aa6f9$export$86f8f9f08863e403();
    (0, $lT7pJ.useEffect)(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}


const $be20c82f0bb050a6$var$MapUser = ({ configurationPosition: configurationPosition, coordinates: coordinates, data: data })=>{
    const map = (0, $0a6de6b83a6aa6f9$export$86f8f9f08863e403)();
    (0, $lT7pJ.useEffect)(()=>{
        if (configurationPosition !== coordinates) {
            const coords1 = [
                ...configurationPosition
            ];
            const coords2 = [
                ...coordinates
            ];
            if (configurationPosition[0] > coordinates[0]) coords2[0] -= (configurationPosition[0] - coordinates[0]) / 2;
            else coords1[0] -= (coordinates[0] - configurationPosition[0]) / 2;
            map.flyToBounds([
                coords1,
                coords2
            ]);
        } else map.flyToBounds([
            configurationPosition,
            coordinates
        ]);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $be20c82f0bb050a6$export$2e2bcd8739ae039 = $be20c82f0bb050a6$var$MapUser;





const $ce256384e9c1081f$var$userIcon = (0, (/*@__PURE__*/$parcel$interopDefault($7283d4ae4f1ab968$exports))).icon({
    iconUrl: `${(0, $15bfb737ffe6480e$export$e56d88b19b5c9fbf).mapDeparture}`,
    shadowUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ea792a137d117a0b$exports))),
    iconSize: [
        32,
        41
    ],
    iconAnchor: [
        16,
        41
    ]
});
const $ce256384e9c1081f$var$springDuration = 500;
const $ce256384e9c1081f$var$Map = ({ latitude: latitude, longitude: longitude, color: color })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const [mapLayerData, setMapLayerData] = (0, $lT7pJ.useState)(undefined);
    const geoJsonLayer = (0, $lT7pJ.useRef)(null);
    const coordinates = configuration.position?.latitude && configuration.position?.longitude ? [
        [
            configuration.position.longitude,
            configuration.position.latitude
        ],
        [
            longitude,
            latitude
        ]
    ] : undefined;
    const [qrCodeUrl, setQrCodeUrl] = (0, $lT7pJ.useState)();
    const fadeInTimerRef = (0, $lT7pJ.useRef)(null);
    const [spring, api] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $lT7pJ.useEffect)(()=>{
        if (geoJsonLayer.current) mapLayerData && geoJsonLayer.current.clearLayers().addData(mapLayerData);
    }, [
        mapLayerData
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        qrCodeUrl && api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $ce256384e9c1081f$var$springDuration
            }
        });
        return ()=>{
            fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        };
    }, [
        qrCodeUrl
    ]);
    const handleCloseQrCode = ()=>{
        api.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $ce256384e9c1081f$var$springDuration
            }
        });
        fadeInTimerRef?.current && clearTimeout(fadeInTimerRef.current);
        fadeInTimerRef.current = setTimeout(()=>{
            setQrCodeUrl(null);
        }, $ce256384e9c1081f$var$springDuration);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $c72da9a52373c4d4$export$23f3dfd47374502b), {
                center: [
                    latitude,
                    longitude
                ],
                zoom: 12,
                scrollWheelZoom: false,
                style: {
                    height: "100%",
                    width: "100%",
                    zIndex: 0
                },
                attributionControl: false,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $36ae39183e21cc8c$export$f52ee31d61d0b27b), {
                        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3031ba457ef8c60f$export$e98856a975cab58e), {
                        position: [
                            latitude,
                            longitude
                        ]
                    }),
                    configuration.position?.latitude && configuration.position?.longitude && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3031ba457ef8c60f$export$e98856a975cab58e), {
                        position: [
                            configuration.position.latitude,
                            configuration.position.longitude
                        ],
                        icon: $ce256384e9c1081f$var$userIcon
                    }),
                    mapLayerData && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $fef21e6ee02541f8$export$3a16e672cb3a069e), {
                        ref: geoJsonLayer,
                        data: mapLayerData
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $be20c82f0bb050a6$export$2e2bcd8739ae039), {
                        configurationPosition: [
                            configuration.position?.latitude || latitude,
                            configuration.position?.longitude || longitude
                        ],
                        coordinates: [
                            latitude,
                            longitude
                        ],
                        data: mapLayerData
                    })
                ]
            }),
            coordinates && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c783930db8abad34$export$2e2bcd8739ae039), {
                coordinates: coordinates,
                setMapLayerData: setMapLayerData,
                color: color,
                setQrCodeUrl: setQrCodeUrl
            }),
            qrCodeUrl && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $dc32a48dada8397f$export$407448d2b89b1813).div, {
                className: "rf-absolute rf-h-full rf-w-full rf-top-0 rf-left-0 rf-z-ui rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4 rf-text-truewhite",
                style: {
                    background: "rgba(18,18,18,0.7)",
                    ...spring
                },
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e5699fc9e4e13353$export$2e2bcd8739ae039), {
                        onClick: handleCloseQrCode,
                        showLabel: false
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-flex rf-flex-row rf-items-start rf-gap-1 rf-text-truewhite rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8c84d47da720aa29$export$2e2bcd8739ae039), {
                                className: "rf-h-4 rf-mt-[0.2rem]",
                                color: "#FFF"
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                className: "rf-w-fit rf-flex rf-flex-col rf-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.poi.openroutemobile, locale)
                                    }),
                                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                        children: translation.link.scanQR
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $afe82365b658f5fb$export$2e2bcd8739ae039), {
                        src: qrCodeUrl
                    })
                ]
            })
        ]
    });
};
var $ce256384e9c1081f$export$2e2bcd8739ae039 = $ce256384e9c1081f$var$Map;




const $52df7c47a58bc49f$var$DetailedAddress = ({ address: address, phoneNumber: phoneNumber, coordinates: coordinates, color: color, customerReviews: customerReviews, url: url })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isLandscape = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isLandscape);
    const isBorne = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isBorne);
    const currentWidth = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentWidth);
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-relative rf-w-1/3 vertical:rf-w-full large:rf-bg-truewhite rf-flex rf-flex-col large-vertical:rf-flex-row",
        children: [
            customerReviews && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a034ac289dc4dc35$export$2e2bcd8739ae039), {
                className: "rf-absolute large-vertical:rf-hidden rf-top-0 rf-left-1/2 rf--translate-x-1/2",
                color: color,
                customerReviews: customerReviews
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `rf-px-6 rf-flex rf-flex-col large-vertical:rf-w-1/2 rf-items-center rf-text-center ${customerReviews ? isBorne ? "rf-bg-truewhite rf-justify-center" : "rf-bg-truewhite rf-justify-start" : "rf-justify-center"}`,
                style: {
                    height: isMobile ? customerReviews ? currentWidth : undefined : isLandscape ? coordinates && coordinates.latitude && coordinates.longitude ? "50%" : "100%" : "calc(50vw - 3rem)"
                },
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: customerReviews && !isBorne ? isLandscape ? "rf-pt-[26vh] rf-pb-12" : "rf-pt-11/20 rf-pb-12" : "rf-py-12",
                        children: address && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                            children: [
                                address.street && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                    children: address.street
                                }),
                                address.addressLocality && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                    children: address.postalCode ? `${address.postalCode} ${address.addressLocality}` : address.addressLocality
                                })
                            ]
                        })
                    }),
                    phoneNumber && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e4d6c6b34632c258$export$2e2bcd8739ae039), {
                        phoneNumber: phoneNumber
                    }),
                    coordinates && coordinates.latitude && coordinates.longitude && isBorne && url && (configuration.isUsedOnBorne ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8d37fbba6b0b4644$export$2e2bcd8739ae039), {
                        url: url
                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $24f79abaafef1693$export$2e2bcd8739ae039), {
                        className: "rf-justify-center",
                        url: url
                    }))
                ]
            }),
            coordinates && coordinates.latitude && coordinates.longitude ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-relative large-vertical:rf-w-1/2",
                style: {
                    height: isMobile ? currentWidth : isLandscape ? "50%" : "calc(50vw - 3rem)"
                },
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ce256384e9c1081f$export$2e2bcd8739ae039), {
                    latitude: coordinates.latitude,
                    longitude: coordinates.longitude,
                    color: color
                })
            }) : isBorne ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-flex rf-justify-center rf-items-center rf-h-[calc(50vw-3rem)] rf-w-1/2",
                children: url && (configuration.isUsedOnBorne ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8d37fbba6b0b4644$export$2e2bcd8739ae039), {
                    url: url
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $24f79abaafef1693$export$2e2bcd8739ae039), {
                    className: "rf-justify-center",
                    url: url
                }))
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {})
        ]
    });
};
var $52df7c47a58bc49f$export$2e2bcd8739ae039 = $52df7c47a58bc49f$var$DetailedAddress;



const $cd039b30e123ab91$var$springEnterDuration = 1500;
const $cd039b30e123ab91$var$springLeaveDuration = 2500;
const $cd039b30e123ab91$var$AttachmentDetails = ()=>{
    const detailedItemContent = (0, $0be8ce1c82668272$export$2e2bcd8739ae039)();
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.isUsedOnBorne);
    const baseAddress = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.baseAddress);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const [content, setContent] = (0, $lT7pJ.useState)(undefined);
    const [color, setColor] = (0, $lT7pJ.useState)(themeColors.secondary);
    const [titleHeight, setTitleHeight] = (0, $lT7pJ.useState)(0);
    const [spring, api] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                transform: "translateX(0%)"
            }
        }));
    const timerRef = (0, $lT7pJ.useRef)(null);
    const divRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        setContent(detailedItemContent);
        if (detailedItemContent) (0, $1bda010252da638c$export$dcb32d000c0e0280)((0, $45d43a6de0968f42$export$4f7cd669585dc69f).DetailViewOpen);
    }, [
        detailedItemContent
    ]);
    (0, $lT7pJ.useLayoutEffect)(()=>{
        if (divRef?.current) isWidget && (0, $b5fe10956c349963$export$2e2bcd8739ae039)(null, divRef);
    });
    (0, $lT7pJ.useEffect)(()=>{
        if (content) {
            content.category?.id && setColor((0, $85aa0610edfbce8c$export$7c3e7489ecac4759)(content.category.id, themeColors));
            api.start({
                from: {
                    transform: "translateX(-100%)"
                },
                to: {
                    transform: "translateX(0%)"
                },
                config: {
                    duration: $cd039b30e123ab91$var$springEnterDuration,
                    easing: (0, $bd140d0b30421f1c$export$15a0bf1b4bbacad8).easeInBack
                }
            });
        }
    }, [
        content
    ]);
    const handleClose = ()=>{
        api.start({
            from: {
                transform: "translateX(0%)"
            },
            to: {
                transform: "translateX(-100%)"
            },
            config: {
                duration: $cd039b30e123ab91$var$springLeaveDuration,
                easing: (0, $bd140d0b30421f1c$export$15a0bf1b4bbacad8).easeOutExpo
            }
        });
        if (timerRef) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindow", null);
                (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindowDetailed", null);
                setContent(undefined);
                (0, $1bda010252da638c$export$dcb32d000c0e0280)((0, $45d43a6de0968f42$export$4f7cd669585dc69f).DetailViewClose);
            }, $cd039b30e123ab91$var$springLeaveDuration);
        }
    };
    const sendPostBack = (value)=>{
        (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, value);
    };
    return content ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e04e42ecbb2c2cfa$export$2e2bcd8739ae039), {
        handleClose: handleClose,
        className: "rf-z-detailedPOI",
        closeButtonClassName: "rf-z-util",
        remoteCloseButtonZIndex: "rf-z-detailedPOI",
        animation: spring,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            ref: divRef,
            className: "rf-relative rf-flex rf-flex-row vertical:rf-flex-col rf-h-full rf-overflow-y-scroll rf-scrollbar-hidden",
            children: detailedItemContent?.template ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)(detailedItemContent.template, {
                    props: {
                        ...content,
                        locale: locale,
                        isUsedOnBorne: isUsedOnBorne,
                        baseAddress: baseAddress,
                        sendPostBack: sendPostBack
                    },
                    currentDeviceType: currentDeviceType,
                    handleClose: handleClose
                })
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-px-6 large:rf-px-8 rf-w-2/3 vertical:rf-w-full rf-mb-4 large:rf-mb-0 rf-flex rf-flex-col rf-border-r rf-border-r-silver vertical:rf-border-r-0",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4f79c5c3994dafad$export$2e2bcd8739ae039), {
                                category: content.category,
                                title: content.title,
                                infoBanner: content.infoBanner,
                                color: color,
                                customerReviews: content.customerReviews,
                                favorite: content.favorite,
                                handleClose: handleClose,
                                setTitleHeight: setTitleHeight
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                className: "rf-flex rf-flex-col large:rf-flex-row desktop:rf-h-full",
                                children: [
                                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $84dd544f402a63de$export$2e2bcd8739ae039), {
                                        text: content.text,
                                        otherInformations: content.otherInformations,
                                        color: color,
                                        url: content.downloadUri,
                                        titleHeight: titleHeight
                                    }),
                                    (content.media && content.media.length > 0 || content.review) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8df7f20134ca2df3$export$2e2bcd8739ae039), {
                                        media: content.media,
                                        review: content.review,
                                        color: color
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $52df7c47a58bc49f$export$2e2bcd8739ae039), {
                        address: content.addressStructured,
                        phoneNumber: content.phoneNumber,
                        coordinates: content.coordinates,
                        color: color,
                        customerReviews: content.customerReviews,
                        url: content.downloadUri
                    }),
                    isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text ? "rf-mb-28" : "rf-mb-16",
                        children: content.downloadUri && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $24f79abaafef1693$export$2e2bcd8739ae039), {
                            className: "rf-justify-center",
                            url: content.downloadUri
                        })
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $cd039b30e123ab91$export$2e2bcd8739ae039 = $cd039b30e123ab91$var$AttachmentDetails;




var $lT7pJ = parcelRequire("lT7pJ");







const $c53554168c48d654$var$FullScreenImage = ()=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const fullScreenImage = (0, $514466c41d6b7fdd$export$2e2bcd8739ae039)();
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const [content, setContent] = (0, $lT7pJ.useState)();
    (0, $lT7pJ.useEffect)(()=>{
        setContent(fullScreenImage);
    }, [
        fullScreenImage
    ]);
    const handleClose = ()=>{
        (0, $1bda010252da638c$export$4e062bd31c814155)(undefined);
    };
    return content ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e04e42ecbb2c2cfa$export$2e2bcd8739ae039), {
        handleClose: handleClose,
        mobileReturnTitle: translation.menu.backconversation,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            className: `rf-h-full rf-w-full ${isMobile ? mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text ? "rf-mb-28" : "rf-mb-16" : "rf-pt-12"} rf-px-8 rf-pb-12 rf-flex rf-justify-center rf-items-center`,
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                className: "rf-max-h-full rf-max-w-full",
                src: content
            })
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $c53554168c48d654$export$2e2bcd8739ae039 = $c53554168c48d654$var$FullScreenImage;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("lT7pJ");



var $lT7pJ = parcelRequire("lT7pJ");

let $baf701352c755b48$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233;
(function(DeviceType) {
    DeviceType[DeviceType["mobile"] = 1] = "mobile";
    DeviceType[DeviceType["borne"] = 2] = "borne";
    DeviceType[DeviceType["landscape"] = 3] = "landscape";
    DeviceType[DeviceType["widget"] = 4] = "widget";
})($baf701352c755b48$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233 || ($baf701352c755b48$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233 = {}));
const $baf701352c755b48$var$$91d4a798329bd0d3$export$7f608b480d9e7085 = {
    weekday: "long",
    month: "long",
    day: "numeric"
};
const $baf701352c755b48$var$$91d4a798329bd0d3$export$78f16669b353a880 = [
    $baf701352c755b48$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233.mobile,
    $baf701352c755b48$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233.widget
];
const $baf701352c755b48$var$$91d4a798329bd0d3$export$dc91bcad81fffb1f = "https://api.open-meteo.com/v1/forecast?";
const $baf701352c755b48$var$$91d4a798329bd0d3$export$68b4ac416ba801c6 = "&daily=weathercode,temperature_2m_max,temperature_2m_min&timezone=auto&current_weather=true";
const $baf701352c755b48$var$$d3351fce476b5d48$export$43a4b902cf54b66d = async (position)=>{
    if (position?.latitude && position?.longitude) {
        // Create the address to call the open-meteo API
        const fullAddress = `${$baf701352c755b48$var$$91d4a798329bd0d3$export$dc91bcad81fffb1f}latitude=${position.latitude}&longitude=${position.longitude}${$baf701352c755b48$var$$91d4a798329bd0d3$export$68b4ac416ba801c6}`;
        // Call the API
        const fetchedData = await fetch(fullAddress).then((result)=>{
            return result.json();
        }).catch((error)=>{
            console.log(error);
            return null;
        });
        if (fetchedData) return $baf701352c755b48$var$$d3351fce476b5d48$var$processFetchedData(fetchedData);
    }
    return null;
};
const $baf701352c755b48$var$$d3351fce476b5d48$var$processFetchedData = (data)=>{
    const current = {
        weather: data.current_weather.weathercode,
        temperature: {
            unit: data.daily_units.temperature_2m_max || "\xb0C",
            average: data.current_weather.temperature
        },
        time: data.current_weather.time
    };
    const prevision = [];
    // The first item is the current day, we will use the 6 next days
    for(let i = 1; i < 7; i++){
        const tempWeatherData = {
            day: data.daily.time[i],
            weather: data.daily.weathercode[i],
            temperature: {
                unit: data.daily_units.temperature_2m_max || "\xb0C",
                min: data.daily.temperature_2m_min[i],
                max: data.daily.temperature_2m_max[i]
            }
        };
        prevision.push(tempWeatherData);
    }
    const allData = {
        current: {
            ...current
        },
        prevision: [
            ...prevision
        ]
    };
    localStorage.setItem("Retorik.Weather.Data", JSON.stringify(allData));
    return allData;
};
const $baf701352c755b48$var$$379dc81df3dc7496$export$d07f57595c356899 = (text, locale = "fr-FR")=>{
    if (text.length > 0) {
        const first = text.charAt(0);
        const rest = text.slice(1);
        return first.toLocaleUpperCase(locale) + rest;
    }
    return "";
};
const $baf701352c755b48$var$$d73edfc5f2fb24d0$var$CloudIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M3.89,17.6c0-0.99,0.31-1.88,0.93-2.65s1.41-1.27,2.38-1.49c0.26-1.17,0.85-2.14,1.78-2.88c0.93-0.75,2-1.12,3.22-1.12 c1.18,0,2.24,0.36,3.16,1.09c0.93,0.73,1.53,1.66,1.8,2.8h0.27c1.18,0,2.18,0.41,3.01,1.24s1.25,1.83,1.25,3 c0,1.18-0.42,2.18-1.25,3.01s-1.83,1.25-3.01,1.25H8.16c-0.58,0-1.13-0.11-1.65-0.34S5.52,21,5.14,20.62 c-0.38-0.38-0.68-0.84-0.91-1.36S3.89,18.17,3.89,17.6z M5.34,17.6c0,0.76,0.28,1.42,0.82,1.96s1.21,0.82,1.99,0.82h9.28 c0.77,0,1.44-0.27,1.99-0.82c0.55-0.55,0.83-1.2,0.83-1.96c0-0.76-0.27-1.42-0.83-1.96c-0.55-0.54-1.21-0.82-1.99-0.82h-1.39 c-0.1,0-0.15-0.05-0.15-0.15l-0.07-0.49c-0.1-0.94-0.5-1.73-1.19-2.35s-1.51-0.93-2.45-0.93c-0.94,0-1.76,0.31-2.46,0.94 c-0.7,0.62-1.09,1.41-1.18,2.34l-0.07,0.42c0,0.1-0.05,0.15-0.16,0.15l-0.45,0.07c-0.72,0.06-1.32,0.36-1.81,0.89 C5.59,16.24,5.34,16.87,5.34,17.6z M14.19,8.88c-0.1,0.09-0.08,0.16,0.07,0.21c0.43,0.19,0.79,0.37,1.08,0.55 c0.11,0.03,0.19,0.02,0.22-0.03c0.61-0.57,1.31-0.86,2.12-0.86c0.81,0,1.5,0.27,2.1,0.81c0.59,0.54,0.92,1.21,0.99,2l0.09,0.64h1.42 c0.65,0,1.21,0.23,1.68,0.7c0.47,0.47,0.7,1.02,0.7,1.66c0,0.6-0.21,1.12-0.62,1.57s-0.92,0.7-1.53,0.77c-0.1,0-0.15,0.05-0.15,0.16 v1.13c0,0.11,0.05,0.16,0.15,0.16c1.01-0.06,1.86-0.46,2.55-1.19s1.04-1.6,1.04-2.6c0-1.06-0.37-1.96-1.12-2.7 c-0.75-0.75-1.65-1.12-2.7-1.12h-0.15c-0.26-1-0.81-1.82-1.65-2.47c-0.83-0.65-1.77-0.97-2.8-0.97C16.28,7.29,15.11,7.82,14.19,8.88 z"
        })
    });
};
var $baf701352c755b48$var$$d73edfc5f2fb24d0$export$2e2bcd8739ae039 = $baf701352c755b48$var$$d73edfc5f2fb24d0$var$CloudIcon;
const $baf701352c755b48$var$$b3a5251415e304a6$var$DrizzleIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M3.1,21.04c0-0.24,0.08-0.45,0.25-0.61s0.38-0.24,0.63-0.24h8.97c0.24,0,0.43,0.08,0.59,0.24c0.16,0.16,0.23,0.36,0.23,0.61 c0,0.24-0.08,0.44-0.24,0.6c-0.16,0.16-0.35,0.24-0.59,0.24H3.98c-0.25,0-0.46-0.08-0.63-0.24S3.1,21.27,3.1,21.04z M5.73,17.98 c0-0.24,0.09-0.44,0.27-0.6c0.14-0.15,0.34-0.23,0.59-0.23h9c0.23,0,0.42,0.08,0.58,0.23s0.23,0.35,0.23,0.59 c0,0.24-0.08,0.44-0.23,0.61c-0.15,0.17-0.35,0.25-0.58,0.25h-9c-0.23,0-0.43-0.09-0.6-0.26S5.73,18.21,5.73,17.98z M6.35,15.65 c0,0.09,0.06,0.14,0.17,0.14h1.43c0.09,0,0.17-0.05,0.23-0.14c0.23-0.54,0.57-0.99,1.04-1.35s0.99-0.56,1.58-0.6l0.54-0.07 c0.11,0,0.17-0.06,0.17-0.18l0.07-0.52c0.11-1.09,0.58-1.99,1.39-2.72c0.82-0.73,1.77-1.09,2.87-1.09c1.09,0,2.03,0.36,2.83,1.07 c0.8,0.72,1.27,1.62,1.41,2.7l0.07,0.59c0,0.11,0.06,0.16,0.18,0.16h1.6c0.91,0,1.68,0.32,2.32,0.96c0.64,0.64,0.96,1.41,0.96,2.32 c0,0.88-0.33,1.64-0.97,2.28c-0.65,0.65-1.42,0.97-2.31,0.97h-6.89c-0.12,0-0.18,0.06-0.18,0.17v1.34c0,0.12,0.06,0.18,0.18,0.18 h6.89c0.68,0,1.32-0.13,1.94-0.39s1.14-0.61,1.58-1.05s0.79-0.97,1.05-1.58s0.39-1.25,0.39-1.92c0-0.9-0.22-1.73-0.66-2.49 c-0.44-0.76-1.04-1.36-1.8-1.8c-0.76-0.44-1.6-0.66-2.5-0.66h-0.31c-0.33-1.34-1.03-2.44-2.1-3.3c-1.08-0.85-2.3-1.28-3.68-1.28 c-1.42,0-2.67,0.44-3.76,1.33c-1.09,0.88-1.78,2.01-2.08,3.39c-0.86,0.19-1.62,0.6-2.27,1.21s-1.1,1.35-1.36,2.22v0.02 C6.36,15.6,6.35,15.62,6.35,15.65z M7.5,24.13c0-0.24,0.09-0.44,0.26-0.6c0.15-0.16,0.35-0.23,0.59-0.23h8.99 c0.24,0,0.45,0.08,0.61,0.24c0.17,0.16,0.25,0.36,0.25,0.6c0,0.24-0.08,0.44-0.25,0.61c-0.17,0.17-0.37,0.25-0.61,0.25H8.35 c-0.23,0-0.43-0.08-0.6-0.25C7.58,24.57,7.5,24.37,7.5,24.13z"
        })
    });
};
var $baf701352c755b48$var$$b3a5251415e304a6$export$2e2bcd8739ae039 = $baf701352c755b48$var$$b3a5251415e304a6$var$DrizzleIcon;
const $baf701352c755b48$var$$cb12c9594bbf6bb4$var$DustIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M7.33,16.58c0-0.23,0.08-0.41,0.23-0.56c0.16-0.15,0.37-0.22,0.64-0.22h5.71c0.27,0,0.48,0.07,0.64,0.22 c0.16,0.15,0.23,0.33,0.23,0.56c0,0.27-0.08,0.49-0.23,0.64s-0.37,0.23-0.64,0.23H8.2c-0.27,0-0.48-0.08-0.64-0.23 S7.33,16.86,7.33,16.58z M7.33,10.67c0-0.22,0.08-0.41,0.23-0.55C7.72,9.97,7.93,9.9,8.2,9.9h2.96c0.27,0,0.48,0.07,0.64,0.22 c0.16,0.14,0.24,0.33,0.24,0.55c0,0.27-0.08,0.48-0.24,0.64c-0.16,0.16-0.37,0.24-0.64,0.24H8.2c-0.27,0-0.48-0.08-0.64-0.23 S7.33,10.94,7.33,10.67z M8.32,19.54c0-0.22,0.09-0.42,0.28-0.6c0.18-0.18,0.39-0.28,0.6-0.28c0.26,0,0.46,0.09,0.62,0.27 s0.24,0.38,0.24,0.61c0,0.27-0.08,0.49-0.23,0.65c-0.15,0.16-0.36,0.23-0.63,0.23c-0.23,0-0.44-0.08-0.61-0.24 C8.4,20.01,8.32,19.8,8.32,19.54z M9.74,13.61c0-0.23,0.07-0.44,0.22-0.61c0.15-0.18,0.33-0.27,0.54-0.27 c0.26,0,0.48,0.09,0.64,0.27c0.16,0.18,0.24,0.38,0.24,0.61c0,0.27-0.08,0.49-0.23,0.65c-0.16,0.16-0.37,0.23-0.65,0.23 c-0.23,0-0.41-0.08-0.55-0.24S9.74,13.88,9.74,13.61z M10.73,19.54c0-0.23,0.08-0.44,0.24-0.61s0.38-0.27,0.64-0.27h3.83l0.88,0.88 c0,0.26-0.09,0.47-0.27,0.64s-0.38,0.24-0.61,0.24h-3.83c-0.27,0-0.49-0.08-0.65-0.24S10.73,19.81,10.73,19.54z M12.05,13.61 c0-0.22,0.09-0.42,0.28-0.6c0.18-0.18,0.39-0.28,0.6-0.28h3.83c0.26,0,0.47,0.09,0.63,0.27c0.16,0.18,0.24,0.38,0.24,0.61 c0,0.27-0.08,0.49-0.23,0.65c-0.16,0.16-0.37,0.23-0.64,0.23h-3.83c-0.23,0-0.44-0.08-0.61-0.24 C12.14,14.09,12.05,13.88,12.05,13.61z M12.81,10.67c0-0.22,0.08-0.41,0.24-0.55c0.16-0.14,0.37-0.22,0.64-0.22h5.71 c0.23,0,0.43,0.08,0.61,0.23c0.18,0.15,0.27,0.33,0.27,0.54c0,0.26-0.09,0.48-0.27,0.64c-0.18,0.16-0.38,0.24-0.61,0.24h-5.71 c-0.27,0-0.49-0.08-0.65-0.24C12.88,11.15,12.81,10.94,12.81,10.67z M15.44,16.58c0-0.21,0.09-0.4,0.27-0.55 c0.18-0.15,0.38-0.23,0.61-0.23s0.43,0.08,0.61,0.23c0.18,0.15,0.27,0.34,0.27,0.55c0,0.26-0.09,0.47-0.27,0.63 c-0.18,0.16-0.38,0.24-0.61,0.24c-0.23,0-0.44-0.08-0.61-0.24C15.53,17.06,15.44,16.85,15.44,16.58z M16.98,19.54 c0-0.23,0.08-0.44,0.24-0.61c0.16-0.18,0.37-0.27,0.63-0.27h1.87c0.26,0,0.47,0.09,0.63,0.26c0.16,0.17,0.24,0.38,0.24,0.62 c0,0.27-0.08,0.49-0.23,0.65c-0.15,0.16-0.37,0.23-0.64,0.23h-1.87c-0.27,0-0.48-0.08-0.64-0.23 C17.06,20.03,16.98,19.81,16.98,19.54z M17.85,16.58c0-0.21,0.09-0.4,0.27-0.55c0.18-0.15,0.38-0.23,0.61-0.23h3.07 c0.22,0,0.4,0.08,0.54,0.23c0.14,0.15,0.22,0.33,0.22,0.55c0,0.27-0.07,0.48-0.21,0.64c-0.14,0.16-0.32,0.23-0.55,0.23h-3.07 c-0.23,0-0.44-0.08-0.61-0.24C17.94,17.06,17.85,16.85,17.85,16.58z M18.29,13.61c0-0.22,0.09-0.42,0.28-0.6 c0.18-0.18,0.39-0.28,0.6-0.28h1.96c0.21,0,0.39,0.09,0.54,0.27c0.15,0.18,0.23,0.38,0.23,0.61c0,0.27-0.07,0.48-0.22,0.64 c-0.14,0.16-0.33,0.24-0.55,0.24h-1.96c-0.23,0-0.44-0.08-0.61-0.24C18.38,14.09,18.29,13.88,18.29,13.61z M21.03,10.67 c0-0.22,0.07-0.4,0.22-0.55C21.4,9.97,21.58,9.9,21.8,9.9c0.27,0,0.48,0.07,0.64,0.22c0.16,0.14,0.24,0.33,0.24,0.55 c0,0.27-0.08,0.48-0.24,0.64c-0.16,0.16-0.37,0.24-0.64,0.24c-0.23,0-0.41-0.08-0.55-0.24C21.1,11.15,21.03,10.94,21.03,10.67z"
        })
    });
};
var $baf701352c755b48$var$$cb12c9594bbf6bb4$export$2e2bcd8739ae039 = $baf701352c755b48$var$$cb12c9594bbf6bb4$var$DustIcon;
const $baf701352c755b48$var$$718b047b0c60e4b6$var$FogIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M2.62,21.05c0-0.24,0.08-0.45,0.25-0.61c0.17-0.16,0.38-0.24,0.63-0.24h18.67c0.25,0,0.45,0.08,0.61,0.24 c0.16,0.16,0.24,0.36,0.24,0.61c0,0.23-0.08,0.43-0.25,0.58c-0.17,0.16-0.37,0.23-0.6,0.23H3.5c-0.25,0-0.46-0.08-0.63-0.23 C2.7,21.47,2.62,21.28,2.62,21.05z M5.24,17.91c0-0.24,0.09-0.44,0.26-0.6c0.15-0.15,0.35-0.23,0.59-0.23h18.67 c0.23,0,0.42,0.08,0.58,0.24c0.16,0.16,0.23,0.35,0.23,0.59c0,0.24-0.08,0.44-0.23,0.6c-0.16,0.17-0.35,0.25-0.58,0.25H6.09 c-0.24,0-0.44-0.08-0.6-0.25C5.32,18.34,5.24,18.14,5.24,17.91z M5.37,15.52c0,0.09,0.05,0.13,0.15,0.13h1.43 c0.06,0,0.13-0.05,0.2-0.16c0.24-0.52,0.59-0.94,1.06-1.27c0.47-0.33,0.99-0.52,1.55-0.56l0.55-0.07c0.11,0,0.17-0.06,0.17-0.18 l0.07-0.5c0.11-1.08,0.56-1.98,1.37-2.7c0.81-0.72,1.76-1.08,2.85-1.08c1.08,0,2.02,0.36,2.83,1.07c0.8,0.71,1.26,1.61,1.37,2.68 l0.08,0.57c0,0.11,0.07,0.17,0.2,0.17h1.59c0.64,0,1.23,0.17,1.76,0.52s0.92,0.8,1.18,1.37c0.07,0.11,0.14,0.16,0.21,0.16h1.43 c0.12,0,0.17-0.07,0.14-0.23c-0.29-1.02-0.88-1.86-1.74-2.51c-0.87-0.65-1.86-0.97-2.97-0.97h-0.32c-0.33-1.33-1.03-2.42-2.1-3.27 s-2.28-1.27-3.65-1.27c-1.4,0-2.64,0.44-3.73,1.32s-1.78,2-2.09,3.36c-0.85,0.2-1.6,0.6-2.24,1.21c-0.64,0.61-1.09,1.33-1.34,2.18 v-0.04C5.37,15.45,5.37,15.48,5.37,15.52z M6.98,24.11c0-0.24,0.09-0.43,0.26-0.59c0.15-0.15,0.35-0.23,0.6-0.23h18.68 c0.24,0,0.44,0.08,0.6,0.23c0.17,0.16,0.25,0.35,0.25,0.58c0,0.24-0.08,0.44-0.25,0.61c-0.17,0.17-0.37,0.25-0.6,0.25H7.84 c-0.23,0-0.43-0.09-0.6-0.26C7.07,24.55,6.98,24.34,6.98,24.11z"
        })
    });
};
var $baf701352c755b48$var$$718b047b0c60e4b6$export$2e2bcd8739ae039 = $baf701352c755b48$var$$718b047b0c60e4b6$var$FogIcon;
const $baf701352c755b48$var$$4659807d943ee20a$var$HeavyRainIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M4.64,16.91c0-1.15,0.36-2.17,1.08-3.07c0.72-0.9,1.63-1.47,2.73-1.73c0.31-1.36,1.02-2.48,2.11-3.36s2.34-1.31,3.75-1.31 c1.38,0,2.6,0.43,3.68,1.28c1.08,0.85,1.78,1.95,2.1,3.29h0.32c0.89,0,1.72,0.22,2.48,0.65s1.37,1.03,1.81,1.78 c0.44,0.75,0.67,1.58,0.67,2.47c0,0.88-0.21,1.69-0.63,2.44c-0.42,0.75-1,1.35-1.73,1.8c-0.73,0.45-1.53,0.69-2.4,0.71 c-0.13,0-0.2-0.06-0.2-0.17v-1.33c0-0.12,0.07-0.18,0.2-0.18c0.85-0.04,1.58-0.38,2.18-1.02s0.9-1.39,0.9-2.26s-0.33-1.62-0.98-2.26 s-1.42-0.96-2.31-0.96h-1.61c-0.12,0-0.18-0.06-0.18-0.17l-0.08-0.58c-0.11-1.08-0.58-1.99-1.39-2.71 c-0.82-0.73-1.76-1.09-2.85-1.09c-1.09,0-2.05,0.36-2.85,1.09c-0.81,0.73-1.26,1.63-1.36,2.71l-0.07,0.53c0,0.12-0.07,0.19-0.2,0.19 l-0.53,0.03c-0.83,0.1-1.53,0.46-2.1,1.07s-0.85,1.33-0.85,2.16c0,0.87,0.3,1.62,0.9,2.26s1.33,0.98,2.18,1.02 c0.11,0,0.17,0.06,0.17,0.18v1.33c0,0.11-0.06,0.17-0.17,0.17c-1.34-0.06-2.47-0.57-3.4-1.53S4.64,18.24,4.64,16.91z M9.99,23.6 c0-0.04,0.01-0.11,0.04-0.2l1.63-5.77c0.06-0.19,0.17-0.34,0.32-0.44c0.15-0.1,0.31-0.15,0.46-0.15c0.07,0,0.15,0.01,0.24,0.03 c0.24,0.04,0.42,0.17,0.54,0.37c0.12,0.2,0.15,0.42,0.08,0.67l-1.63,5.73c-0.12,0.43-0.4,0.64-0.82,0.64 c-0.04,0-0.07-0.01-0.11-0.02c-0.06-0.02-0.09-0.03-0.1-0.03c-0.22-0.06-0.38-0.17-0.49-0.33C10.04,23.93,9.99,23.77,9.99,23.6z M12.61,26.41l2.44-8.77c0.04-0.19,0.14-0.34,0.3-0.44c0.16-0.1,0.32-0.15,0.49-0.15c0.09,0,0.18,0.01,0.27,0.03 c0.22,0.06,0.38,0.19,0.49,0.39c0.11,0.2,0.13,0.41,0.07,0.64l-2.43,8.78c-0.04,0.17-0.13,0.31-0.29,0.43 c-0.16,0.12-0.32,0.18-0.51,0.18c-0.09,0-0.18-0.02-0.25-0.05c-0.2-0.05-0.37-0.18-0.52-0.39C12.56,26.88,12.54,26.67,12.61,26.41z M16.74,23.62c0-0.04,0.01-0.11,0.04-0.23l1.63-5.77c0.06-0.19,0.16-0.34,0.3-0.44c0.15-0.1,0.3-0.15,0.46-0.15 c0.08,0,0.17,0.01,0.26,0.03c0.21,0.06,0.36,0.16,0.46,0.31c0.1,0.15,0.15,0.31,0.15,0.47c0,0.03-0.01,0.08-0.02,0.14 s-0.02,0.1-0.02,0.12l-1.63,5.73c-0.04,0.19-0.13,0.35-0.28,0.46s-0.32,0.17-0.51,0.17l-0.24-0.05c-0.2-0.06-0.35-0.16-0.46-0.32 C16.79,23.94,16.74,23.78,16.74,23.62z"
        })
    });
};
var $baf701352c755b48$var$$4659807d943ee20a$export$2e2bcd8739ae039 = $baf701352c755b48$var$$4659807d943ee20a$var$HeavyRainIcon;
const $baf701352c755b48$var$$6fb07283996728c7$var$HeavySnowIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M4.64,16.95c0-1.16,0.35-2.18,1.06-3.08s1.62-1.48,2.74-1.76c0.31-1.36,1.01-2.48,2.1-3.36s2.34-1.31,3.75-1.31 c1.38,0,2.6,0.43,3.68,1.28c1.08,0.85,1.78,1.95,2.1,3.29h0.32c0.89,0,1.72,0.22,2.48,0.66c0.76,0.44,1.37,1.04,1.81,1.8 c0.44,0.76,0.67,1.59,0.67,2.48c0,1.32-0.46,2.47-1.39,3.42c-0.92,0.96-2.05,1.46-3.38,1.5c-0.13,0-0.2-0.06-0.2-0.17v-1.33 c0-0.12,0.07-0.18,0.2-0.18c0.85-0.04,1.58-0.38,2.18-1.02s0.9-1.38,0.9-2.23c0-0.89-0.32-1.65-0.97-2.3s-1.42-0.97-2.32-0.97h-1.61 c-0.12,0-0.18-0.06-0.18-0.17l-0.08-0.58c-0.11-1.08-0.58-1.99-1.39-2.72c-0.82-0.73-1.76-1.1-2.85-1.1c-1.1,0-2.05,0.37-2.86,1.11 c-0.81,0.74-1.27,1.65-1.37,2.75l-0.06,0.5c0,0.12-0.07,0.19-0.2,0.19l-0.53,0.07c-0.83,0.07-1.53,0.41-2.1,1.04 s-0.85,1.35-0.85,2.19c0,0.85,0.3,1.59,0.9,2.23s1.33,0.97,2.18,1.02c0.11,0,0.17,0.06,0.17,0.18v1.33c0,0.11-0.06,0.17-0.17,0.17 c-1.34-0.04-2.47-0.54-3.4-1.5C5.1,19.42,4.64,18.27,4.64,16.95z M10.14,24.65c0-0.23,0.08-0.43,0.25-0.6 c0.16-0.15,0.35-0.23,0.57-0.23c0.23,0,0.43,0.08,0.59,0.23s0.24,0.35,0.24,0.59c0,0.24-0.08,0.43-0.24,0.59 c-0.16,0.16-0.35,0.23-0.59,0.23c-0.23,0-0.43-0.08-0.59-0.23C10.22,25.08,10.14,24.88,10.14,24.65z M11,21.02 c0-0.22,0.08-0.42,0.24-0.58c0.16-0.16,0.35-0.24,0.59-0.24c0.23,0,0.43,0.08,0.59,0.24c0.16,0.16,0.24,0.36,0.24,0.58 c0,0.24-0.08,0.44-0.24,0.6c-0.16,0.17-0.35,0.25-0.59,0.25c-0.23,0-0.43-0.08-0.59-0.25C11.08,21.46,11,21.26,11,21.02z M12.9,26.61c0-0.23,0.08-0.43,0.25-0.61c0.16-0.16,0.35-0.24,0.57-0.24c0.24,0,0.44,0.08,0.61,0.25c0.17,0.17,0.25,0.37,0.25,0.6 s-0.08,0.43-0.25,0.59c-0.17,0.16-0.37,0.24-0.61,0.24c-0.23,0-0.42-0.08-0.58-0.24C12.99,27.03,12.9,26.84,12.9,26.61z M13.77,22.95c0-0.24,0.08-0.44,0.24-0.62c0.16-0.16,0.36-0.24,0.58-0.24c0.23,0,0.43,0.08,0.6,0.25c0.17,0.17,0.25,0.37,0.25,0.61 c0,0.23-0.08,0.43-0.25,0.6s-0.37,0.25-0.6,0.25c-0.23,0-0.42-0.08-0.58-0.25C13.85,23.38,13.77,23.18,13.77,22.95z M14.19,19.33 c0-0.23,0.08-0.43,0.25-0.6c0.18-0.16,0.37-0.24,0.57-0.24c0.24,0,0.44,0.08,0.61,0.25c0.17,0.17,0.25,0.36,0.25,0.6 c0,0.23-0.08,0.43-0.25,0.59c-0.17,0.16-0.37,0.24-0.61,0.24c-0.23,0-0.42-0.08-0.58-0.24C14.27,19.76,14.19,19.56,14.19,19.33z M16.56,24.65c0-0.23,0.08-0.43,0.24-0.6c0.16-0.15,0.36-0.23,0.6-0.23c0.24,0,0.43,0.08,0.59,0.23c0.16,0.16,0.23,0.35,0.23,0.59 c0,0.24-0.08,0.43-0.23,0.59c-0.16,0.16-0.35,0.23-0.59,0.23c-0.24,0-0.44-0.08-0.6-0.24C16.64,25.07,16.56,24.88,16.56,24.65z M17.41,21.02c0-0.22,0.08-0.41,0.25-0.58c0.17-0.17,0.37-0.25,0.6-0.25c0.23,0,0.43,0.08,0.59,0.24c0.16,0.16,0.24,0.36,0.24,0.58 c0,0.24-0.08,0.44-0.24,0.6c-0.16,0.17-0.35,0.25-0.59,0.25c-0.24,0-0.44-0.08-0.6-0.25C17.5,21.45,17.41,21.25,17.41,21.02z"
        })
    });
};
var $baf701352c755b48$var$$6fb07283996728c7$export$2e2bcd8739ae039 = $baf701352c755b48$var$$6fb07283996728c7$var$HeavySnowIcon;
const $baf701352c755b48$var$$01d90ce62fe7f810$var$HeavyWindIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M3.1,16.97c0,0.24,0.09,0.45,0.28,0.62c0.16,0.19,0.37,0.28,0.63,0.28H18.7c0.29,0,0.53,0.1,0.73,0.3 c0.2,0.2,0.3,0.45,0.3,0.74c0,0.29-0.1,0.53-0.3,0.72c-0.2,0.19-0.44,0.29-0.74,0.29c-0.29,0-0.54-0.1-0.73-0.29 c-0.16-0.18-0.36-0.26-0.6-0.26c-0.25,0-0.46,0.09-0.64,0.26s-0.27,0.38-0.27,0.61c0,0.25,0.09,0.46,0.28,0.63 c0.56,0.55,1.22,0.83,1.96,0.83c0.78,0,1.45-0.27,2.01-0.81c0.56-0.54,0.83-1.19,0.83-1.97s-0.28-1.44-0.84-2 c-0.56-0.56-1.23-0.84-2-0.84H4.01c-0.25,0-0.46,0.09-0.64,0.26C3.19,16.51,3.1,16.72,3.1,16.97z M3.1,13.69 c0,0.23,0.09,0.43,0.28,0.61c0.17,0.18,0.38,0.26,0.63,0.26h20.04c0.78,0,1.45-0.27,2.01-0.82c0.56-0.54,0.84-1.2,0.84-1.97 c0-0.77-0.28-1.44-0.84-1.99s-1.23-0.83-2.01-0.83c-0.77,0-1.42,0.27-1.95,0.8c-0.18,0.16-0.27,0.38-0.27,0.67 c0,0.26,0.09,0.47,0.26,0.63c0.17,0.16,0.38,0.24,0.63,0.24c0.24,0,0.45-0.08,0.63-0.24c0.19-0.21,0.42-0.31,0.7-0.31 c0.29,0,0.53,0.1,0.73,0.3c0.2,0.2,0.3,0.44,0.3,0.73c0,0.29-0.1,0.53-0.3,0.72c-0.2,0.19-0.44,0.29-0.73,0.29H4.01 c-0.25,0-0.46,0.09-0.64,0.26C3.19,13.23,3.1,13.44,3.1,13.69z"
        })
    });
};
var $baf701352c755b48$var$$01d90ce62fe7f810$export$2e2bcd8739ae039 = $baf701352c755b48$var$$01d90ce62fe7f810$var$HeavyWindIcon;
const $baf701352c755b48$var$$3bc16b70d32ea3e4$var$LowRainIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M4.64,16.91c0-1.15,0.36-2.17,1.08-3.07c0.72-0.9,1.63-1.47,2.73-1.73c0.31-1.36,1.01-2.48,2.1-3.35s2.35-1.31,3.76-1.31 c1.38,0,2.6,0.43,3.68,1.27c1.07,0.85,1.78,1.94,2.11,3.28h0.31c0.89,0,1.72,0.22,2.48,0.65s1.37,1.03,1.81,1.78 c0.44,0.75,0.67,1.58,0.67,2.47c0,1.34-0.46,2.49-1.38,3.45s-2.05,1.47-3.38,1.51c-0.13,0-0.2-0.06-0.2-0.17v-1.33 c0-0.12,0.07-0.18,0.2-0.18c0.86-0.04,1.58-0.38,2.18-1.02s0.9-1.39,0.9-2.26s-0.32-1.62-0.98-2.26c-0.65-0.64-1.42-0.96-2.31-0.96 h-1.6c-0.12,0-0.19-0.06-0.19-0.17l-0.07-0.58c-0.11-1.07-0.57-1.98-1.38-2.71c-0.82-0.73-1.77-1.1-2.85-1.1 c-1.09,0-2.05,0.36-2.86,1.09c-0.81,0.73-1.27,1.63-1.38,2.71l-0.06,0.54c0,0.12-0.07,0.18-0.2,0.18l-0.53,0.03 c-0.82,0.04-1.51,0.37-2.09,1s-0.86,1.37-0.86,2.22c0,0.87,0.3,1.62,0.9,2.26s1.33,0.98,2.18,1.02c0.11,0,0.17,0.06,0.17,0.18v1.33 c0,0.11-0.06,0.17-0.17,0.17c-1.34-0.06-2.47-0.57-3.4-1.53S4.64,18.24,4.64,16.91z M10.57,17.79c0-0.24,0.12-0.57,0.37-0.99 c0.24-0.42,0.47-0.75,0.68-1.01c0.21-0.24,0.34-0.38,0.38-0.42l0.36,0.4c0.26,0.28,0.5,0.61,0.72,1.02c0.22,0.4,0.33,0.74,0.33,1 c0,0.39-0.13,0.72-0.4,0.98c-0.27,0.26-0.6,0.39-1,0.39c-0.39,0-0.73-0.13-1.01-0.4C10.71,18.5,10.57,18.17,10.57,17.79z M13.55,21.78c0-0.28,0.08-0.59,0.24-0.96s0.35-0.7,0.59-1.02c0.18-0.26,0.4-0.54,0.67-0.84c0.26-0.3,0.46-0.52,0.6-0.65 c0.07-0.06,0.15-0.14,0.24-0.23l0.24,0.23c0.38,0.33,0.8,0.82,1.27,1.46c0.24,0.33,0.43,0.68,0.59,1.04s0.23,0.68,0.23,0.97 c0,0.64-0.23,1.19-0.68,1.65s-1.01,0.68-1.66,0.68c-0.64,0-1.19-0.23-1.65-0.67C13.77,22.98,13.55,22.43,13.55,21.78z M15.02,15.12 c0-0.42,0.32-0.95,0.97-1.6l0.24,0.25c0.18,0.21,0.33,0.45,0.48,0.71c0.14,0.26,0.22,0.47,0.22,0.64c0,0.26-0.09,0.48-0.28,0.66 c-0.18,0.18-0.4,0.28-0.66,0.28c-0.27,0-0.5-0.09-0.69-0.28C15.11,15.6,15.02,15.38,15.02,15.12z"
        })
    });
};
var $baf701352c755b48$var$$3bc16b70d32ea3e4$export$2e2bcd8739ae039 = $baf701352c755b48$var$$3bc16b70d32ea3e4$var$LowRainIcon;
const $baf701352c755b48$var$$a27f237fa4d0560c$var$LowSnowIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M7.46,14.41c0-0.19,0.07-0.36,0.2-0.5c0.13-0.14,0.29-0.21,0.48-0.21c0.19,0,0.36,0.07,0.49,0.21c0.13,0.14,0.2,0.3,0.2,0.5 c0,0.19-0.07,0.35-0.2,0.48c-0.13,0.13-0.3,0.2-0.48,0.2s-0.35-0.07-0.48-0.2C7.52,14.75,7.46,14.59,7.46,14.41z M9.44,14.41 c0-0.19,0.07-0.36,0.2-0.5c0.13-0.14,0.29-0.21,0.48-0.21h3.23l-2.28-2.28c-0.14-0.12-0.21-0.28-0.21-0.47 c0-0.19,0.07-0.35,0.21-0.49c0.14-0.14,0.3-0.21,0.49-0.21s0.35,0.07,0.49,0.21l2.27,2.27V9.52c0-0.19,0.07-0.36,0.21-0.5 s0.3-0.21,0.5-0.21c0.19,0,0.35,0.07,0.48,0.21c0.13,0.14,0.2,0.3,0.2,0.5v3.23l2.29-2.3c0.14-0.14,0.3-0.21,0.48-0.21 c0.18,0,0.35,0.07,0.49,0.21c0.12,0.14,0.18,0.3,0.18,0.49c0,0.19-0.06,0.35-0.18,0.47l-2.28,2.28h3.23c0.18,0,0.34,0.07,0.47,0.21 c0.13,0.14,0.2,0.3,0.2,0.5c0,0.18-0.07,0.34-0.2,0.47c-0.13,0.13-0.29,0.2-0.47,0.2h-3.23l2.29,2.29c0.12,0.12,0.18,0.28,0.18,0.47 s-0.06,0.35-0.18,0.49c-0.14,0.14-0.31,0.21-0.49,0.21c-0.18,0-0.35-0.07-0.48-0.21l-2.29-2.3v3.24c0,0.19-0.07,0.36-0.2,0.49 c-0.13,0.13-0.29,0.2-0.48,0.2c-0.19,0-0.36-0.07-0.5-0.2c-0.14-0.13-0.21-0.3-0.21-0.49v-3.22l-2.27,2.27 c-0.14,0.14-0.3,0.21-0.49,0.21s-0.35-0.07-0.49-0.21s-0.21-0.3-0.21-0.49s0.07-0.34,0.21-0.47l2.3-2.29h-3.24 c-0.19,0-0.35-0.07-0.48-0.2C9.5,14.75,9.44,14.59,9.44,14.41z M9.45,19.25c0-0.18,0.07-0.35,0.21-0.48 c0.12-0.14,0.28-0.21,0.47-0.21c0.19,0,0.35,0.07,0.49,0.21c0.14,0.14,0.21,0.3,0.21,0.48c0,0.18-0.07,0.35-0.21,0.48 c-0.14,0.14-0.3,0.21-0.49,0.21c-0.19,0-0.35-0.07-0.47-0.21C9.52,19.6,9.45,19.44,9.45,19.25z M9.45,9.54 c0-0.18,0.07-0.35,0.21-0.48c0.12-0.14,0.28-0.21,0.47-0.21c0.19,0,0.35,0.07,0.49,0.21c0.14,0.14,0.21,0.3,0.21,0.48 s-0.07,0.35-0.21,0.49c-0.14,0.14-0.3,0.21-0.49,0.21c-0.19,0-0.35-0.07-0.47-0.21C9.52,9.89,9.45,9.72,9.45,9.54z M14.3,21.25 c0-0.18,0.07-0.34,0.21-0.47c0.14-0.13,0.3-0.2,0.5-0.2c0.19,0,0.35,0.07,0.48,0.2c0.13,0.13,0.2,0.29,0.2,0.47 c0,0.19-0.07,0.36-0.2,0.49c-0.13,0.13-0.29,0.2-0.48,0.2c-0.19,0-0.36-0.07-0.5-0.2C14.37,21.61,14.3,21.45,14.3,21.25z M14.3,7.54 c0-0.19,0.07-0.36,0.21-0.49s0.3-0.2,0.5-0.2c0.19,0,0.35,0.07,0.48,0.2c0.13,0.13,0.2,0.3,0.2,0.49c0,0.18-0.07,0.34-0.2,0.47 c-0.13,0.13-0.29,0.2-0.48,0.2c-0.19,0-0.36-0.07-0.5-0.2C14.37,7.88,14.3,7.72,14.3,7.54z M19.17,19.25c0-0.18,0.07-0.35,0.21-0.48 c0.12-0.14,0.28-0.21,0.47-0.21c0.19,0,0.35,0.07,0.49,0.21c0.14,0.14,0.21,0.3,0.21,0.48c0,0.18-0.07,0.35-0.21,0.48 c-0.14,0.14-0.3,0.21-0.49,0.21c-0.19,0-0.35-0.07-0.47-0.21C19.24,19.6,19.17,19.44,19.17,19.25z M19.17,9.54 c0-0.18,0.07-0.35,0.21-0.48c0.12-0.14,0.28-0.21,0.47-0.21c0.19,0,0.35,0.07,0.49,0.21c0.14,0.14,0.21,0.3,0.21,0.48 s-0.07,0.35-0.21,0.49c-0.14,0.14-0.3,0.21-0.49,0.21c-0.19,0-0.35-0.07-0.47-0.21C19.24,9.89,19.17,9.72,19.17,9.54z M21.17,14.41 c0-0.19,0.07-0.36,0.2-0.5c0.13-0.14,0.3-0.21,0.49-0.21c0.18,0,0.34,0.07,0.47,0.21c0.13,0.14,0.2,0.3,0.2,0.5 c0,0.18-0.07,0.34-0.2,0.47c-0.13,0.13-0.29,0.2-0.47,0.2c-0.19,0-0.36-0.07-0.49-0.2C21.24,14.75,21.17,14.59,21.17,14.41z"
        })
    });
};
var $baf701352c755b48$var$$a27f237fa4d0560c$export$2e2bcd8739ae039 = $baf701352c755b48$var$$a27f237fa4d0560c$var$LowSnowIcon;
const $baf701352c755b48$var$$122feba17c252c93$var$MediumRainIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M4.6,16.93c0-1.16,0.36-2.18,1.09-3.08c0.72-0.9,1.65-1.48,2.78-1.73c0.29-1.38,0.98-2.5,2.07-3.39S12.88,7.4,14.3,7.4 c1.39,0,2.63,0.43,3.72,1.28c1.08,0.85,1.79,1.95,2.12,3.3h0.34c0.9,0,1.73,0.22,2.48,0.66c0.76,0.44,1.35,1.04,1.79,1.8 c0.43,0.76,0.65,1.59,0.65,2.49c0,1.34-0.46,2.48-1.37,3.44c-0.92,0.96-2.04,1.46-3.37,1.5c-0.12,0-0.18-0.06-0.18-0.17v-1.34 c0-0.11,0.06-0.17,0.18-0.17c0.84-0.07,1.57-0.42,2.17-1.05s0.9-1.37,0.9-2.22c0-0.89-0.32-1.66-0.96-2.31 c-0.64-0.64-1.4-0.97-2.29-0.97h-1.63c-0.12,0-0.19-0.06-0.22-0.18l-0.07-0.57c-0.07-0.71-0.3-1.36-0.7-1.94s-0.91-1.03-1.53-1.36 c-0.62-0.33-1.3-0.49-2.02-0.49c-1.1,0-2.05,0.36-2.86,1.09c-0.81,0.73-1.27,1.64-1.37,2.72l-0.07,0.54c0,0.09-0.05,0.14-0.16,0.14 L9.31,13.7c-0.84,0.07-1.55,0.41-2.11,1.03c-0.57,0.62-0.85,1.35-0.85,2.2c0,0.87,0.3,1.62,0.89,2.25c0.59,0.63,1.31,0.97,2.17,1.02 c0.12,0,0.18,0.06,0.18,0.17v1.34c0,0.11-0.06,0.17-0.18,0.17c-0.66-0.03-1.28-0.18-1.88-0.45S6.42,20.8,6,20.36 c-0.43-0.44-0.77-0.95-1.02-1.55S4.6,17.59,4.6,16.93z M10.02,23.7c0-0.03,0.01-0.08,0.02-0.13s0.02-0.09,0.02-0.11l0.27-1.03 c0.07-0.22,0.2-0.4,0.4-0.51c0.2-0.12,0.41-0.14,0.64-0.07c0.23,0.07,0.4,0.2,0.52,0.4c0.12,0.2,0.14,0.41,0.07,0.64l-0.24,1.01 c-0.13,0.44-0.38,0.66-0.76,0.66c-0.03,0-0.05,0-0.09,0c-0.03,0-0.07-0.01-0.11-0.01c-0.04-0.01-0.07-0.01-0.1-0.01 c-0.21-0.06-0.37-0.18-0.48-0.34S10.02,23.86,10.02,23.7z M11.34,18.88c0-0.02,0-0.06,0.01-0.11c0.01-0.05,0.01-0.08,0.01-0.09 l0.3-1.05c0.06-0.19,0.17-0.34,0.32-0.45c0.15-0.1,0.31-0.15,0.47-0.15c0.02,0,0.05,0,0.08,0c0.03,0,0.06,0.01,0.09,0.01 c0.03,0.01,0.06,0.01,0.08,0.01c0.23,0.07,0.4,0.2,0.51,0.4c0.12,0.2,0.14,0.41,0.07,0.64l-0.24,1c-0.07,0.28-0.2,0.47-0.4,0.59 s-0.42,0.12-0.65,0.02c-0.22-0.06-0.38-0.17-0.49-0.34S11.34,19.04,11.34,18.88z M12.57,26.83c0-0.03,0.01-0.07,0.02-0.13 s0.02-0.09,0.02-0.12l0.29-0.99c0.06-0.24,0.2-0.42,0.4-0.54c0.2-0.12,0.42-0.15,0.65-0.08c0.23,0.07,0.39,0.2,0.51,0.41 s0.13,0.42,0.07,0.65l-0.25,1.04c-0.11,0.41-0.37,0.61-0.8,0.61c-0.05,0-0.13-0.01-0.24-0.04c-0.22-0.04-0.38-0.14-0.49-0.3 C12.63,27.18,12.57,27.01,12.57,26.83z M13.91,22.06c0-0.06,0.01-0.14,0.04-0.25l0.27-1.03c0.07-0.23,0.2-0.4,0.41-0.51 c0.2-0.12,0.42-0.14,0.65-0.07c0.23,0.06,0.39,0.19,0.51,0.39c0.11,0.2,0.13,0.41,0.06,0.65l-0.24,0.99 c-0.13,0.45-0.37,0.68-0.72,0.68c-0.04,0-0.15-0.02-0.31-0.06c-0.22-0.04-0.38-0.14-0.49-0.3C13.97,22.4,13.91,22.23,13.91,22.06z M16.73,23.74c0-0.07,0.01-0.15,0.03-0.24l0.28-0.99c0.07-0.24,0.2-0.42,0.41-0.54s0.41-0.15,0.63-0.09 c0.23,0.07,0.41,0.2,0.53,0.41c0.12,0.2,0.15,0.41,0.09,0.63l-0.29,1.06c-0.1,0.41-0.36,0.61-0.79,0.61c-0.09,0-0.18-0.01-0.26-0.03 c-0.2-0.04-0.35-0.14-0.46-0.3C16.8,24.08,16.74,23.91,16.73,23.74z M18.11,18.98c0-0.03,0.02-0.12,0.05-0.26l0.3-1.03 c0.04-0.21,0.13-0.37,0.29-0.47c0.16-0.1,0.32-0.15,0.49-0.14c0.04-0.01,0.13,0,0.24,0.03c0.22,0.05,0.39,0.18,0.52,0.38 c0.12,0.17,0.14,0.38,0.07,0.65l-0.24,1.03c-0.13,0.43-0.38,0.65-0.76,0.65c-0.06,0-0.17-0.02-0.34-0.06 c-0.21-0.06-0.36-0.17-0.46-0.31C18.16,19.29,18.11,19.14,18.11,18.98z"
        })
    });
};
var $baf701352c755b48$var$$122feba17c252c93$export$2e2bcd8739ae039 = $baf701352c755b48$var$$122feba17c252c93$var$MediumRainIcon;
const $baf701352c755b48$var$$15b1561596c9c9ef$var$MediumSnowIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M4.64,16.95c0-1.16,0.35-2.18,1.06-3.08s1.62-1.48,2.74-1.76c0.31-1.36,1.01-2.48,2.1-3.36s2.34-1.31,3.75-1.31 c1.38,0,2.6,0.43,3.68,1.28c1.08,0.85,1.78,1.95,2.1,3.29h0.32c0.89,0,1.72,0.22,2.48,0.66c0.76,0.44,1.37,1.04,1.81,1.8 c0.44,0.76,0.67,1.59,0.67,2.48c0,1.32-0.46,2.47-1.39,3.42c-0.92,0.96-2.05,1.46-3.38,1.5c-0.13,0-0.2-0.06-0.2-0.17v-1.33 c0-0.12,0.07-0.18,0.2-0.18c0.85-0.04,1.58-0.38,2.18-1.02s0.9-1.38,0.9-2.23c0-0.89-0.32-1.65-0.97-2.3s-1.42-0.97-2.32-0.97h-1.61 c-0.12,0-0.18-0.06-0.18-0.17l-0.08-0.58c-0.11-1.08-0.58-1.99-1.39-2.72c-0.82-0.73-1.76-1.1-2.85-1.1c-1.1,0-2.05,0.37-2.86,1.11 c-0.81,0.74-1.27,1.65-1.37,2.75l-0.06,0.5c0,0.12-0.07,0.19-0.2,0.19l-0.53,0.07c-0.83,0.07-1.53,0.41-2.1,1.04 s-0.85,1.35-0.85,2.19c0,0.85,0.3,1.59,0.9,2.23s1.33,0.97,2.18,1.02c0.11,0,0.17,0.06,0.17,0.18v1.33c0,0.11-0.06,0.17-0.17,0.17 c-1.34-0.04-2.47-0.54-3.4-1.5C5.1,19.42,4.64,18.27,4.64,16.95z M11,21.02c0-0.22,0.08-0.42,0.24-0.58 c0.16-0.16,0.35-0.24,0.59-0.24c0.23,0,0.43,0.08,0.59,0.24c0.16,0.16,0.24,0.36,0.24,0.58c0,0.24-0.08,0.44-0.24,0.6 c-0.16,0.17-0.35,0.25-0.59,0.25c-0.23,0-0.43-0.08-0.59-0.25C11.08,21.46,11,21.26,11,21.02z M11,24.65c0-0.24,0.08-0.44,0.24-0.6 c0.16-0.15,0.35-0.23,0.58-0.23c0.23,0,0.43,0.08,0.59,0.23c0.16,0.16,0.24,0.35,0.24,0.59c0,0.24-0.08,0.43-0.24,0.59 c-0.16,0.16-0.35,0.23-0.59,0.23c-0.23,0-0.43-0.08-0.59-0.23C11.08,25.08,11,24.88,11,24.65z M14.19,22.95 c0-0.23,0.08-0.44,0.25-0.62c0.16-0.16,0.35-0.24,0.57-0.24c0.23,0,0.43,0.09,0.6,0.26c0.17,0.17,0.26,0.37,0.26,0.6 c0,0.23-0.08,0.43-0.25,0.6c-0.17,0.17-0.37,0.25-0.61,0.25c-0.23,0-0.42-0.08-0.58-0.25S14.19,23.18,14.19,22.95z M14.19,19.33 c0-0.23,0.08-0.43,0.25-0.6c0.18-0.16,0.37-0.24,0.57-0.24c0.24,0,0.44,0.08,0.61,0.25c0.17,0.17,0.25,0.36,0.25,0.6 c0,0.23-0.08,0.43-0.25,0.59c-0.17,0.16-0.37,0.24-0.61,0.24c-0.23,0-0.42-0.08-0.58-0.24C14.27,19.76,14.19,19.56,14.19,19.33z M14.19,26.61c0-0.23,0.08-0.43,0.25-0.61c0.16-0.16,0.35-0.24,0.57-0.24c0.24,0,0.44,0.08,0.61,0.25c0.17,0.17,0.25,0.37,0.25,0.6 s-0.08,0.43-0.25,0.59c-0.17,0.16-0.37,0.24-0.61,0.24c-0.23,0-0.42-0.08-0.58-0.24C14.27,27.03,14.19,26.84,14.19,26.61z M17.41,21.02c0-0.22,0.08-0.41,0.25-0.58c0.17-0.17,0.37-0.25,0.6-0.25c0.23,0,0.43,0.08,0.59,0.24c0.16,0.16,0.24,0.36,0.24,0.58 c0,0.24-0.08,0.44-0.24,0.6c-0.16,0.17-0.35,0.25-0.59,0.25c-0.24,0-0.44-0.08-0.6-0.25C17.5,21.45,17.41,21.25,17.41,21.02z M17.41,24.65c0-0.22,0.08-0.42,0.25-0.6c0.16-0.15,0.36-0.23,0.6-0.23c0.24,0,0.43,0.08,0.59,0.23s0.23,0.35,0.23,0.59 c0,0.24-0.08,0.43-0.23,0.59c-0.16,0.16-0.35,0.23-0.59,0.23c-0.24,0-0.44-0.08-0.6-0.24C17.5,25.07,17.41,24.88,17.41,24.65z"
        })
    });
};
var $baf701352c755b48$var$$15b1561596c9c9ef$export$2e2bcd8739ae039 = $baf701352c755b48$var$$15b1561596c9c9ef$var$MediumSnowIcon;
const $baf701352c755b48$var$$db27af05666c8ee5$var$SandStormIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M3.1,16.97c0,0.24,0.09,0.45,0.28,0.62c0.16,0.19,0.37,0.28,0.63,0.28H18.7c0.29,0,0.53,0.1,0.73,0.3 c0.2,0.2,0.3,0.45,0.3,0.74c0,0.29-0.1,0.53-0.3,0.72c-0.2,0.19-0.44,0.29-0.74,0.29c-0.29,0-0.54-0.1-0.73-0.29 c-0.16-0.18-0.36-0.26-0.6-0.26c-0.25,0-0.46,0.09-0.64,0.26s-0.27,0.38-0.27,0.61c0,0.25,0.09,0.46,0.28,0.63 c0.56,0.55,1.22,0.83,1.96,0.83c0.78,0,1.45-0.27,2.01-0.81c0.56-0.54,0.83-1.19,0.83-1.97s-0.28-1.44-0.84-2 c-0.56-0.56-1.23-0.84-2-0.84H4.01c-0.25,0-0.46,0.09-0.64,0.26C3.19,16.51,3.1,16.72,3.1,16.97z M3.1,13.69 c0,0.23,0.09,0.43,0.28,0.61c0.17,0.18,0.38,0.26,0.63,0.26h20.04c0.78,0,1.45-0.27,2.01-0.82c0.56-0.54,0.84-1.2,0.84-1.97 c0-0.77-0.28-1.44-0.84-1.99s-1.23-0.83-2.01-0.83c-0.77,0-1.42,0.27-1.95,0.8c-0.18,0.16-0.27,0.38-0.27,0.67 c0,0.26,0.09,0.47,0.26,0.63c0.17,0.16,0.38,0.24,0.63,0.24c0.24,0,0.45-0.08,0.63-0.24c0.19-0.21,0.42-0.31,0.7-0.31 c0.29,0,0.53,0.1,0.73,0.3c0.2,0.2,0.3,0.44,0.3,0.73c0,0.29-0.1,0.53-0.3,0.72c-0.2,0.19-0.44,0.29-0.73,0.29H4.01 c-0.25,0-0.46,0.09-0.64,0.26C3.19,13.23,3.1,13.44,3.1,13.69z M4.67,20.61c0,0.24,0.08,0.43,0.24,0.58 c0.16,0.16,0.36,0.24,0.58,0.24c0.24,0,0.45-0.08,0.62-0.23s0.25-0.35,0.25-0.59c0-0.23-0.09-0.43-0.26-0.6 c-0.17-0.17-0.38-0.25-0.61-0.25c-0.22,0-0.42,0.08-0.58,0.25C4.75,20.18,4.67,20.38,4.67,20.61z M5.62,10.68 c0,0.24,0.08,0.43,0.24,0.58c0.16,0.16,0.36,0.24,0.58,0.24c0.24,0,0.45-0.08,0.61-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.08-0.43-0.25-0.6C6.89,9.92,6.68,9.83,6.45,9.83c-0.22,0-0.42,0.08-0.58,0.25C5.7,10.25,5.62,10.45,5.62,10.68z M8.65,8.37c0,0.24,0.08,0.43,0.24,0.58C9.05,9.12,9.25,9.2,9.47,9.2c0.24,0,0.45-0.08,0.62-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6C9.92,7.61,9.71,7.53,9.47,7.53c-0.22,0-0.42,0.08-0.58,0.25C8.73,7.94,8.65,8.14,8.65,8.37z M8.74,19.97 c0,0.23,0.08,0.43,0.25,0.58c0.16,0.16,0.35,0.24,0.57,0.24c0.24,0,0.45-0.08,0.62-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6c-0.17-0.17-0.38-0.25-0.61-0.25c-0.22,0-0.42,0.08-0.58,0.25C8.82,19.54,8.74,19.74,8.74,19.97z M12.92,10.14c0,0.24,0.08,0.43,0.24,0.58c0.16,0.16,0.36,0.24,0.58,0.24c0.24,0,0.45-0.08,0.62-0.23s0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6c-0.17-0.17-0.38-0.25-0.61-0.25c-0.23,0-0.42,0.08-0.58,0.25C13,9.71,12.92,9.91,12.92,10.14z M13.24,21.13c0,0.23,0.08,0.42,0.25,0.58c0.16,0.16,0.35,0.24,0.57,0.24c0.24,0,0.45-0.08,0.62-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6c-0.17-0.17-0.38-0.25-0.61-0.25c-0.22,0-0.42,0.08-0.58,0.25S13.24,20.9,13.24,21.13z M17.72,9.98 c0,0.23,0.08,0.42,0.24,0.57c0.17,0.17,0.36,0.25,0.58,0.25c0.24,0,0.45-0.08,0.62-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.09-0.43-0.26-0.6c-0.17-0.17-0.38-0.25-0.61-0.25c-0.22,0-0.41,0.08-0.58,0.25C17.81,9.55,17.72,9.75,17.72,9.98z M22.81,17.04c0,0.24,0.08,0.43,0.24,0.58c0.16,0.16,0.36,0.24,0.58,0.24c0.24,0,0.45-0.08,0.61-0.23c0.17-0.16,0.25-0.35,0.25-0.59 c0-0.23-0.08-0.43-0.25-0.6c-0.17-0.17-0.37-0.25-0.61-0.25c-0.23,0-0.42,0.08-0.58,0.25C22.9,16.61,22.81,16.81,22.81,17.04z"
        })
    });
};
var $baf701352c755b48$var$$db27af05666c8ee5$export$2e2bcd8739ae039 = $baf701352c755b48$var$$db27af05666c8ee5$var$SandStormIcon;
const $baf701352c755b48$var$$11e053ad08a316e7$var$SmokeIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M6.34,12.48c0-0.94,0.3-1.78,0.89-2.52s1.34-1.21,2.25-1.41C9.73,7.43,10.3,6.5,11.2,5.78s1.92-1.08,3.08-1.08 c1.12,0,2.13,0.35,3.02,1.05c0.89,0.7,1.46,1.6,1.73,2.69h0.27c1.12,0,2.08,0.39,2.88,1.18c0.79,0.78,1.19,1.74,1.19,2.85 c0,0.6-0.12,1.17-0.37,1.7c-0.25,0.53-0.59,0.99-1.03,1.37v0.03c0,0.59-0.19,1.12-0.56,1.59c-0.37,0.47-0.84,0.76-1.4,0.89 c-0.14,0.62-0.45,1.15-0.91,1.58c-0.46,0.43-1.01,0.7-1.63,0.8c0.29,0.34,0.43,0.72,0.43,1.13c0,0.48-0.17,0.89-0.51,1.24 c-0.34,0.34-0.75,0.52-1.23,0.52c-0.48,0-0.89-0.17-1.23-0.52c-0.34-0.34-0.51-0.76-0.51-1.24c0-0.19,0.03-0.38,0.1-0.57h-0.1 c-0.58,0-1.08-0.21-1.5-0.63c-0.42-0.42-0.63-0.92-0.63-1.5c0-0.4,0.1-0.76,0.3-1.07c-0.52-0.29-0.89-0.7-1.12-1.25h-1.28v-0.01 c-1.07-0.07-1.98-0.49-2.73-1.27S6.34,13.56,6.34,12.48z M7.74,12.23c0,0.8,0.28,1.48,0.84,2.04s1.24,0.84,2.03,0.84 c0.49,0,0.95-0.11,1.37-0.34c0.12,0.74,0.47,1.36,1.04,1.86s1.25,0.74,2.02,0.74c0.87,0,1.61-0.31,2.22-0.92 c0.41,0.48,0.92,0.71,1.54,0.71c0.57,0,1.05-0.2,1.46-0.6c0.4-0.4,0.6-0.89,0.6-1.46c0.4-0.27,0.72-0.61,0.95-1.04 c0.23-0.42,0.35-0.88,0.35-1.37c0-0.79-0.28-1.47-0.85-2.02c-0.57-0.55-1.25-0.83-2.05-0.83c-0.56,0-1.07,0.15-1.53,0.44 c0.06-0.24,0.08-0.51,0.08-0.79c0-0.96-0.34-1.78-1.03-2.46c-0.69-0.68-1.52-1.01-2.49-1.01c-0.94,0-1.75,0.33-2.43,0.97 s-1.04,1.44-1.07,2.37c-0.02,0-0.05,0-0.08,0c-0.04,0-0.07,0-0.09,0c-0.79,0-1.46,0.28-2.03,0.84S7.74,11.45,7.74,12.23z"
        })
    });
};
var $baf701352c755b48$var$$11e053ad08a316e7$export$2e2bcd8739ae039 = $baf701352c755b48$var$$11e053ad08a316e7$var$SmokeIcon;
const $baf701352c755b48$var$$976a2f524e1d121b$var$SunIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M4.37,14.62c0-0.24,0.08-0.45,0.25-0.62c0.17-0.16,0.38-0.24,0.6-0.24h2.04c0.23,0,0.42,0.08,0.58,0.25 c0.15,0.17,0.23,0.37,0.23,0.61S8,15.06,7.85,15.23c-0.15,0.17-0.35,0.25-0.58,0.25H5.23c-0.23,0-0.43-0.08-0.6-0.25 C4.46,15.06,4.37,14.86,4.37,14.62z M7.23,21.55c0-0.23,0.08-0.43,0.23-0.61l1.47-1.43c0.15-0.16,0.35-0.23,0.59-0.23 c0.24,0,0.44,0.08,0.6,0.23s0.24,0.34,0.24,0.57c0,0.24-0.08,0.46-0.24,0.64L8.7,22.14c-0.41,0.32-0.82,0.32-1.23,0 C7.31,21.98,7.23,21.78,7.23,21.55z M7.23,7.71c0-0.23,0.08-0.43,0.23-0.61C7.66,6.93,7.87,6.85,8.1,6.85 c0.22,0,0.42,0.08,0.59,0.24l1.43,1.47c0.16,0.15,0.24,0.35,0.24,0.59c0,0.24-0.08,0.44-0.24,0.6s-0.36,0.24-0.6,0.24 c-0.24,0-0.44-0.08-0.59-0.24L7.47,8.32C7.31,8.16,7.23,7.95,7.23,7.71z M9.78,14.62c0-0.93,0.23-1.8,0.7-2.6s1.1-1.44,1.91-1.91 s1.67-0.7,2.6-0.7c0.7,0,1.37,0.14,2.02,0.42c0.64,0.28,1.2,0.65,1.66,1.12c0.47,0.47,0.84,1.02,1.11,1.66 c0.27,0.64,0.41,1.32,0.41,2.02c0,0.94-0.23,1.81-0.7,2.61c-0.47,0.8-1.1,1.43-1.9,1.9c-0.8,0.47-1.67,0.7-2.61,0.7 s-1.81-0.23-2.61-0.7c-0.8-0.47-1.43-1.1-1.9-1.9C10.02,16.43,9.78,15.56,9.78,14.62z M11.48,14.62c0,0.98,0.34,1.81,1.03,2.5 c0.68,0.69,1.51,1.04,2.49,1.04s1.81-0.35,2.5-1.04s1.04-1.52,1.04-2.5c0-0.96-0.35-1.78-1.04-2.47c-0.69-0.68-1.52-1.02-2.5-1.02 c-0.97,0-1.8,0.34-2.48,1.02C11.82,12.84,11.48,13.66,11.48,14.62z M14.14,22.4c0-0.24,0.08-0.44,0.25-0.6s0.37-0.24,0.6-0.24 c0.24,0,0.45,0.08,0.61,0.24s0.24,0.36,0.24,0.6v1.99c0,0.24-0.08,0.45-0.25,0.62c-0.17,0.17-0.37,0.25-0.6,0.25 s-0.44-0.08-0.6-0.25c-0.17-0.17-0.25-0.38-0.25-0.62V22.4z M14.14,6.9V4.86c0-0.23,0.08-0.43,0.25-0.6C14.56,4.09,14.76,4,15,4 s0.43,0.08,0.6,0.25c0.17,0.17,0.25,0.37,0.25,0.6V6.9c0,0.23-0.08,0.42-0.25,0.58S15.23,7.71,15,7.71s-0.44-0.08-0.6-0.23 S14.14,7.13,14.14,6.9z M19.66,20.08c0-0.23,0.08-0.42,0.23-0.56c0.15-0.16,0.34-0.23,0.56-0.23c0.24,0,0.44,0.08,0.6,0.23 l1.46,1.43c0.16,0.17,0.24,0.38,0.24,0.61c0,0.23-0.08,0.43-0.24,0.59c-0.4,0.31-0.8,0.31-1.2,0l-1.42-1.42 C19.74,20.55,19.66,20.34,19.66,20.08z M19.66,9.16c0-0.25,0.08-0.45,0.23-0.59l1.42-1.47c0.17-0.16,0.37-0.24,0.59-0.24 c0.24,0,0.44,0.08,0.6,0.25c0.17,0.17,0.25,0.37,0.25,0.6c0,0.25-0.08,0.46-0.24,0.62l-1.46,1.43c-0.18,0.16-0.38,0.24-0.6,0.24 c-0.23,0-0.41-0.08-0.56-0.24S19.66,9.4,19.66,9.16z M21.92,14.62c0-0.24,0.08-0.44,0.24-0.62c0.16-0.16,0.35-0.24,0.57-0.24h2.02 c0.23,0,0.43,0.09,0.6,0.26c0.17,0.17,0.26,0.37,0.26,0.6s-0.09,0.43-0.26,0.6c-0.17,0.17-0.37,0.25-0.6,0.25h-2.02 c-0.23,0-0.43-0.08-0.58-0.25S21.92,14.86,21.92,14.62z"
        })
    });
};
var $baf701352c755b48$var$$976a2f524e1d121b$export$2e2bcd8739ae039 = $baf701352c755b48$var$$976a2f524e1d121b$var$SunIcon;
const $baf701352c755b48$var$$947eb44583326c5d$var$SunCloudIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M1.56,16.9c0,0.9,0.22,1.73,0.66,2.49s1.04,1.36,1.8,1.8c0.76,0.44,1.58,0.66,2.47,0.66h10.83c0.89,0,1.72-0.22,2.48-0.66 c0.76-0.44,1.37-1.04,1.81-1.8c0.44-0.76,0.67-1.59,0.67-2.49c0-0.66-0.14-1.33-0.42-2C22.62,13.98,23,12.87,23,11.6 c0-0.71-0.14-1.39-0.41-2.04c-0.27-0.65-0.65-1.2-1.12-1.67C21,7.42,20.45,7.04,19.8,6.77c-0.65-0.28-1.33-0.41-2.04-0.41 c-1.48,0-2.77,0.58-3.88,1.74c-0.77-0.44-1.67-0.66-2.7-0.66c-1.41,0-2.65,0.44-3.73,1.31c-1.08,0.87-1.78,1.99-2.08,3.35 c-1.12,0.26-2.03,0.83-2.74,1.73S1.56,15.75,1.56,16.9z M3.27,16.9c0-0.84,0.28-1.56,0.84-2.17c0.56-0.61,1.26-0.96,2.1-1.06 l0.5-0.03c0.12,0,0.19-0.06,0.19-0.18l0.07-0.54c0.14-1.08,0.61-1.99,1.41-2.71c0.8-0.73,1.74-1.09,2.81-1.09 c1.1,0,2.06,0.37,2.87,1.1c0.82,0.73,1.27,1.63,1.37,2.71l0.07,0.58c0.02,0.11,0.09,0.17,0.21,0.17h1.61c0.88,0,1.64,0.32,2.28,0.96 c0.64,0.64,0.96,1.39,0.96,2.27c0,0.91-0.32,1.68-0.95,2.32c-0.63,0.64-1.4,0.96-2.28,0.96H6.49c-0.88,0-1.63-0.32-2.27-0.97 C3.59,18.57,3.27,17.8,3.27,16.9z M9.97,4.63c0,0.24,0.08,0.45,0.24,0.63l0.66,0.64c0.25,0.19,0.46,0.27,0.64,0.25 c0.21,0,0.39-0.09,0.55-0.26s0.24-0.38,0.24-0.62c0-0.24-0.09-0.44-0.26-0.59l-0.59-0.66c-0.18-0.16-0.38-0.24-0.61-0.24 c-0.24,0-0.45,0.08-0.62,0.25C10.05,4.19,9.97,4.39,9.97,4.63z M15.31,9.06c0.69-0.67,1.51-1,2.45-1c0.99,0,1.83,0.34,2.52,1.03 c0.69,0.69,1.04,1.52,1.04,2.51c0,0.62-0.17,1.24-0.51,1.84C19.84,12.48,18.68,12,17.32,12H17C16.75,10.91,16.19,9.93,15.31,9.06z M16.94,3.78c0,0.26,0.08,0.46,0.23,0.62s0.35,0.23,0.59,0.23c0.26,0,0.46-0.08,0.62-0.23c0.16-0.16,0.23-0.36,0.23-0.62V1.73 c0-0.24-0.08-0.43-0.24-0.59s-0.36-0.23-0.61-0.23c-0.24,0-0.43,0.08-0.59,0.23s-0.23,0.35-0.23,0.59V3.78z M22.46,6.07 c0,0.26,0.07,0.46,0.22,0.62c0.21,0.16,0.42,0.24,0.62,0.24c0.18,0,0.38-0.08,0.59-0.24l1.43-1.43c0.16-0.18,0.24-0.39,0.24-0.64 c0-0.24-0.08-0.44-0.24-0.6c-0.16-0.16-0.36-0.24-0.59-0.24c-0.24,0-0.43,0.08-0.58,0.24l-1.47,1.43 C22.53,5.64,22.46,5.84,22.46,6.07z M23.25,17.91c0,0.24,0.08,0.45,0.25,0.63l0.65,0.63c0.15,0.16,0.34,0.24,0.58,0.24 s0.44-0.08,0.6-0.25c0.16-0.17,0.24-0.37,0.24-0.62c0-0.22-0.08-0.42-0.24-0.58l-0.65-0.65c-0.16-0.16-0.35-0.24-0.57-0.24 c-0.24,0-0.44,0.08-0.6,0.24C23.34,17.47,23.25,17.67,23.25,17.91z M24.72,11.6c0,0.23,0.09,0.42,0.26,0.58 c0.16,0.16,0.37,0.24,0.61,0.24h2.04c0.23,0,0.42-0.08,0.58-0.23s0.23-0.35,0.23-0.59c0-0.24-0.08-0.44-0.23-0.6 s-0.35-0.25-0.58-0.25h-2.04c-0.24,0-0.44,0.08-0.61,0.25C24.8,11.17,24.72,11.37,24.72,11.6z"
        })
    });
};
var $baf701352c755b48$var$$947eb44583326c5d$export$2e2bcd8739ae039 = $baf701352c755b48$var$$947eb44583326c5d$var$SunCloudIcon;
const $baf701352c755b48$var$$76289450d1bd9fde$var$ThunderIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M7.96,24.51h0.39l6.88-10.18c0.09-0.18,0.04-0.27-0.15-0.27h-2.84l2.99-5.45c0.09-0.18,0.02-0.27-0.2-0.27h-3.81 c-0.11,0-0.2,0.06-0.29,0.18l-2.78,7.4c-0.02,0.18,0.04,0.27,0.19,0.27h2.75L7.96,24.51z M16.46,18.18h0.27l5.22-7.67 c0.05-0.08,0.06-0.15,0.04-0.2s-0.08-0.07-0.17-0.07h-2.1l2.18-4.03c0.12-0.2,0.06-0.3-0.18-0.3h-2.74c-0.13,0-0.23,0.06-0.3,0.19 l-2.08,5.48c-0.03,0.09-0.03,0.16,0.01,0.21c0.04,0.05,0.1,0.07,0.19,0.07h2.04L16.46,18.18z"
        })
    });
};
var $baf701352c755b48$var$$76289450d1bd9fde$export$2e2bcd8739ae039 = $baf701352c755b48$var$$76289450d1bd9fde$var$ThunderIcon;
const $baf701352c755b48$var$$8ca1468a3164388d$var$ThunderStormIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M4.63,16.91c0,1.11,0.33,2.1,0.99,2.97s1.52,1.47,2.58,1.79l-0.66,1.68c-0.03,0.14,0.02,0.22,0.14,0.22h2.13l-0.98,4.3h0.28 l3.92-5.75c0.04-0.04,0.04-0.09,0.01-0.14c-0.03-0.05-0.08-0.07-0.15-0.07h-2.18l2.48-4.64c0.07-0.14,0.02-0.22-0.14-0.22h-2.94 c-0.09,0-0.17,0.05-0.23,0.15l-1.07,2.87c-0.71-0.18-1.3-0.57-1.77-1.16c-0.47-0.59-0.7-1.26-0.7-2.01c0-0.83,0.28-1.55,0.85-2.17 c0.57-0.61,1.27-0.97,2.1-1.07l0.53-0.07c0.13,0,0.2-0.06,0.2-0.18l0.07-0.51c0.11-1.08,0.56-1.99,1.37-2.72 c0.81-0.73,1.76-1.1,2.85-1.1c1.09,0,2.04,0.37,2.85,1.1c0.82,0.73,1.28,1.64,1.4,2.72l0.07,0.58c0,0.11,0.06,0.17,0.18,0.17h1.6 c0.91,0,1.68,0.32,2.32,0.95c0.64,0.63,0.97,1.4,0.97,2.28c0,0.85-0.3,1.59-0.89,2.21c-0.59,0.62-1.33,0.97-2.2,1.04 c-0.13,0-0.2,0.06-0.2,0.18v1.37c0,0.11,0.07,0.17,0.2,0.17c1.33-0.04,2.46-0.55,3.39-1.51s1.39-2.11,1.39-3.45 c0-0.9-0.22-1.73-0.67-2.49c-0.44-0.76-1.05-1.36-1.81-1.8c-0.77-0.44-1.6-0.66-2.5-0.66H20.1c-0.33-1.33-1.04-2.42-2.11-3.26 s-2.3-1.27-3.68-1.27c-1.41,0-2.67,0.44-3.76,1.31s-1.79,1.99-2.1,3.36c-1.11,0.26-2.02,0.83-2.74,1.73S4.63,15.76,4.63,16.91z M12.77,26.62c0,0.39,0.19,0.65,0.58,0.77c0.01,0,0.05,0,0.11,0.01c0.06,0.01,0.11,0.01,0.14,0.01c0.17,0,0.33-0.05,0.49-0.15 c0.16-0.1,0.27-0.26,0.32-0.48l2.25-8.69c0.06-0.24,0.04-0.45-0.07-0.65c-0.11-0.19-0.27-0.32-0.5-0.39 c-0.17-0.02-0.26-0.03-0.26-0.03c-0.16,0-0.32,0.05-0.47,0.15c-0.15,0.1-0.26,0.25-0.31,0.45l-2.26,8.72 C12.78,26.44,12.77,26.53,12.77,26.62z M16.93,23.56c0,0.13,0.03,0.26,0.1,0.38c0.14,0.22,0.31,0.37,0.51,0.44 c0.11,0.03,0.21,0.05,0.3,0.05s0.2-0.02,0.32-0.08c0.21-0.09,0.35-0.28,0.42-0.57l1.44-5.67c0.03-0.14,0.05-0.23,0.05-0.27 c0-0.15-0.05-0.3-0.16-0.45s-0.26-0.26-0.46-0.32c-0.17-0.02-0.26-0.03-0.26-0.03c-0.17,0-0.33,0.05-0.47,0.15 c-0.14,0.1-0.24,0.25-0.3,0.45l-1.46,5.7c0,0.02,0,0.05-0.01,0.11C16.93,23.5,16.93,23.53,16.93,23.56z"
        })
    });
};
var $baf701352c755b48$var$$8ca1468a3164388d$export$2e2bcd8739ae039 = $baf701352c755b48$var$$8ca1468a3164388d$var$ThunderStormIcon;
const $baf701352c755b48$var$$32016b29b994233a$var$ThunderStormShowerIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M4.63,16.91c0,1.11,0.33,2.1,0.99,2.97s1.51,1.47,2.56,1.79l-0.65,1.68c-0.03,0.14,0.02,0.22,0.14,0.22h2.13l-1.04,3.78 h0.28l3.97-5.22c0.04-0.04,0.04-0.09,0.02-0.14s-0.07-0.07-0.14-0.07h-2.18l2.48-4.64c0.06-0.14,0.02-0.21-0.14-0.21h-2.94 c-0.09,0-0.17,0.05-0.22,0.14L8.8,20.08c-0.71-0.18-1.3-0.57-1.77-1.16c-0.47-0.59-0.7-1.26-0.7-2.01c0-0.83,0.28-1.55,0.84-2.16 s1.26-0.96,2.1-1.06l0.52-0.07c0.13,0,0.2-0.06,0.2-0.17l0.07-0.52c0.1-1.08,0.55-1.99,1.36-2.72c0.81-0.73,1.76-1.1,2.85-1.1 c1.09,0,2.04,0.37,2.85,1.1c0.82,0.73,1.28,1.64,1.4,2.72l0.06,0.58c0,0.12,0.06,0.18,0.19,0.18h1.61c0.91,0,1.68,0.32,2.32,0.95 c0.64,0.63,0.96,1.39,0.96,2.28c0,0.85-0.3,1.59-0.89,2.21c-0.59,0.62-1.32,0.96-2.19,1.03c-0.13,0-0.2,0.06-0.2,0.19v1.37 c0,0.11,0.07,0.17,0.2,0.17c0.65-0.02,1.27-0.17,1.86-0.44c0.59-0.27,1.1-0.63,1.52-1.07c0.42-0.44,0.76-0.96,1.01-1.57 c0.25-0.6,0.38-1.23,0.38-1.88c0-0.9-0.22-1.73-0.67-2.49c-0.45-0.76-1.05-1.36-1.81-1.8c-0.76-0.44-1.59-0.66-2.48-0.66h-0.32 c-0.33-1.33-1.03-2.42-2.11-3.26c-1.08-0.84-2.3-1.27-3.68-1.27c-1.41,0-2.67,0.44-3.76,1.31s-1.79,1.99-2.1,3.36 c-1.1,0.26-2.01,0.83-2.73,1.73S4.63,15.76,4.63,16.91z M12.79,26.77c0,0.16,0.05,0.31,0.15,0.46c0.1,0.15,0.26,0.26,0.46,0.32 c0.14,0.03,0.22,0.05,0.25,0.05c0.09,0,0.21-0.03,0.38-0.1c0.21-0.09,0.35-0.27,0.42-0.52l0.28-1.05c0.06-0.22,0.04-0.43-0.08-0.63 s-0.29-0.33-0.53-0.4c-0.22-0.06-0.43-0.04-0.63,0.08c-0.2,0.12-0.34,0.29-0.41,0.53l-0.27,1C12.8,26.68,12.79,26.77,12.79,26.77z M14.13,22c0,0.14,0.05,0.29,0.15,0.44c0.1,0.15,0.25,0.26,0.45,0.33c0.22,0.07,0.44,0.06,0.64-0.05s0.33-0.28,0.4-0.52l0.3-1.04 c0.06-0.22,0.03-0.43-0.08-0.63c-0.12-0.2-0.3-0.34-0.53-0.41c-0.23-0.06-0.44-0.04-0.65,0.08s-0.34,0.29-0.41,0.52l-0.24,1.01 C14.14,21.9,14.13,21.99,14.13,22z M16.95,23.65c0,0.17,0.05,0.34,0.16,0.51c0.11,0.17,0.27,0.28,0.47,0.35 c0.02,0,0.06,0.01,0.12,0.02c0.05,0.01,0.09,0.02,0.12,0.02c0.13,0,0.26-0.02,0.38-0.08c0.19-0.07,0.33-0.26,0.41-0.57l0.25-1.01 c0.07-0.23,0.05-0.45-0.06-0.66c-0.11-0.21-0.28-0.35-0.5-0.42c-0.25-0.06-0.48-0.03-0.68,0.08c-0.2,0.12-0.33,0.3-0.37,0.53 l-0.27,1.03C16.96,23.51,16.95,23.58,16.95,23.65z M18.31,18.86c-0.01,0.16,0.04,0.31,0.15,0.47c0.11,0.16,0.27,0.28,0.49,0.38 c0.08,0.04,0.16,0.06,0.26,0.06c0.11,0,0.22-0.03,0.34-0.08c0.21-0.1,0.35-0.29,0.44-0.57l0.29-1.03c0.02-0.13,0.03-0.2,0.03-0.22 c0-0.17-0.05-0.33-0.16-0.49s-0.27-0.27-0.49-0.33c-0.02,0-0.06-0.01-0.11-0.02C19.49,17,19.45,17,19.42,17 c-0.17,0-0.33,0.05-0.49,0.15c-0.16,0.1-0.27,0.26-0.33,0.48l-0.27,1.01C18.32,18.72,18.31,18.79,18.31,18.86z"
        })
    });
};
var $baf701352c755b48$var$$32016b29b994233a$export$2e2bcd8739ae039 = $baf701352c755b48$var$$32016b29b994233a$var$ThunderStormShowerIcon;
const $baf701352c755b48$var$$2d73a9e5e9c30df9$var$TornadoIcon = ({ className: className, color: color })=>{
    return (0, $ee253cdb7e062133$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30",
        className: className || "rf-h-16 rf-w-16",
        xmlSpace: "preserve",
        fill: color || "#1999B1",
        children: (0, $ee253cdb7e062133$exports.jsx)("path", {
            d: "M4.13,15.19c0,0.69,0.36,1.28,1.08,1.77c1.32,0.93,3.31,1.39,5.98,1.39c1.2,0,2.31-0.1,3.34-0.31 c1.08-0.23,1.97-0.6,2.65-1.1s1.03-1.08,1.03-1.76c0-0.21-0.04-0.41-0.12-0.62c1.39-0.34,2.48-0.8,3.27-1.38s1.19-1.25,1.19-2 c0-0.19-0.03-0.39-0.09-0.6c2.29-0.81,3.43-1.9,3.43-3.28c0-0.88-0.5-1.66-1.49-2.34c-1.95-1.3-4.81-1.95-8.58-1.95 c-1.78,0-3.39,0.16-4.83,0.47C9.42,3.8,8.16,4.3,7.2,4.98S5.76,6.44,5.76,7.31c0,0.52,0.16,0.99,0.48,1.42 c-1.18,0.67-1.77,1.49-1.77,2.46c0,0.75,0.37,1.41,1.1,1.98C4.61,13.73,4.13,14.4,4.13,15.19z M4.73,19.69 c0,0.73,0.45,1.31,1.35,1.72s2.04,0.62,3.41,0.62c1.39,0,2.53-0.21,3.44-0.62s1.36-0.99,1.36-1.72c0-0.27-0.09-0.5-0.26-0.69 s-0.4-0.28-0.67-0.28c-0.22,0-0.42,0.08-0.6,0.23s-0.29,0.35-0.34,0.57c-0.2,0.16-0.56,0.3-1.1,0.43s-1.15,0.2-1.83,0.2 c-1.1,0-2-0.16-2.68-0.47c0.16-0.16,0.24-0.36,0.26-0.6s-0.04-0.45-0.15-0.62c-0.16-0.21-0.36-0.35-0.61-0.4s-0.48,0-0.7,0.13 C5.02,18.6,4.73,19.09,4.73,19.69z M6.01,15.19c0-0.01,0.06-0.07,0.19-0.18c0.09-0.09,0.28-0.2,0.56-0.34s0.61-0.25,0.96-0.35 l0.12-0.06c1.62,0.54,3.51,0.81,5.67,0.81c0.95,0,1.81-0.05,2.58-0.16l0.26,0.23c-0.09,0.16-0.3,0.32-0.63,0.5 c-0.4,0.21-1.02,0.41-1.86,0.57s-1.73,0.25-2.67,0.25s-1.83-0.08-2.67-0.25s-1.47-0.36-1.88-0.57C6.3,15.5,6.09,15.35,6.01,15.19z M6.12,23.61c0,0.63,0.36,1.12,1.08,1.46s1.61,0.51,2.67,0.51c1.08,0,1.99-0.17,2.72-0.51s1.1-0.83,1.1-1.46 c0-0.25-0.09-0.48-0.28-0.67s-0.41-0.29-0.66-0.29c-0.47,0-0.78,0.24-0.92,0.72c-0.39,0.24-1.04,0.37-1.96,0.37 c-0.8,0-1.44-0.12-1.92-0.37c-0.15-0.48-0.45-0.72-0.92-0.72c-0.25,0-0.47,0.09-0.64,0.28S6.12,23.34,6.12,23.61z M6.33,11.19 c0-0.08,0.05-0.17,0.15-0.28c0.24-0.3,0.72-0.6,1.42-0.88c1.92,1.03,4.56,1.54,7.91,1.54c1.71,0,3.32-0.16,4.82-0.47v0.09 c0,0.15-0.09,0.3-0.28,0.45c-0.41,0.36-1.17,0.7-2.29,1.03c-1.21,0.36-2.73,0.54-4.56,0.54c-1.84,0-3.36-0.18-4.57-0.54 C7.77,12.35,7,12.01,6.61,11.65C6.42,11.5,6.33,11.35,6.33,11.19z M7.63,7.31c0-0.18,0.12-0.37,0.35-0.59 C8.43,6.3,9.33,5.9,10.66,5.51c1.43-0.42,3.14-0.63,5.14-0.63c2.01,0,3.74,0.21,5.19,0.63c1.35,0.39,2.24,0.8,2.68,1.22 c0.22,0.22,0.34,0.42,0.34,0.59s-0.11,0.35-0.34,0.56c-0.44,0.42-1.33,0.83-2.68,1.23c-1.45,0.42-3.17,0.63-5.19,0.63 c-2,0-3.72-0.21-5.14-0.63C9.32,8.71,8.42,8.3,7.98,7.87C7.75,7.66,7.63,7.48,7.63,7.31z"
        })
    });
};
var $baf701352c755b48$var$$2d73a9e5e9c30df9$export$2e2bcd8739ae039 = $baf701352c755b48$var$$2d73a9e5e9c30df9$var$TornadoIcon;
/**
 * Cf https://www.jodc.go.jp/data_format/weather-code.html for weather codes and their corresponding weathers
 * @param code : number
 */ const $baf701352c755b48$var$$1081c1897db35bfa$export$596264e6595ef029 = (code, className)=>{
    if (code === 0) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$976a2f524e1d121b$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 3) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$947eb44583326c5d$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 3) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$d73edfc5f2fb24d0$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 4) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$11e053ad08a316e7$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 5) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$718b047b0c60e4b6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 9) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$cb12c9594bbf6bb4$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 9) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$db27af05666c8ee5$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 13) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$718b047b0c60e4b6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 13) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$76289450d1bd9fde$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 17) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$3bc16b70d32ea3e4$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 17) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$8ca1468a3164388d$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 18) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$01d90ce62fe7f810$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 19) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$2d73a9e5e9c30df9$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 20) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$b3a5251415e304a6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 21 || code === 23) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$122feba17c252c93$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 22 || code === 24) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$15b1561596c9c9ef$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 28) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$4659807d943ee20a$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 28) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$718b047b0c60e4b6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 29) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$8ca1468a3164388d$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 36) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$db27af05666c8ee5$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 40) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$6fb07283996728c7$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 50) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$718b047b0c60e4b6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 60) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$b3a5251415e304a6$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 62) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$3bc16b70d32ea3e4$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 64) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$122feba17c252c93$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 66) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$4659807d943ee20a$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 66 || code === 68) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$3bc16b70d32ea3e4$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 67 || code === 69) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$122feba17c252c93$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 70 || code === 71 || code === 76 || code === 77 || code === 78 || code === 79) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$a27f237fa4d0560c$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 72 || code === 73) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$15b1561596c9c9ef$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code === 74 || code === 75) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$6fb07283996728c7$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 85) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$4659807d943ee20a$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 91) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$6fb07283996728c7$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 93) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$122feba17c252c93$export$2e2bcd8739ae039, {
        className: className
    });
    else if (code < 95) return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$15b1561596c9c9ef$export$2e2bcd8739ae039, {
        className: className
    });
    else return (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$32016b29b994233a$export$2e2bcd8739ae039, {
        className: className
    });
};
const $baf701352c755b48$var$$34b1838c227861bb$var$MobileWeather = ({ locale: locale, currentWeather: currentWeather, previsions: previsions })=>{
    return (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-py-4 rf-flex rf-flex-col rf-items-center rf-overflow-y-scroll rf-scrollbar-hidden",
        children: [
            (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-pb-4 rf-title-large-bold-size-auto",
                children: $baf701352c755b48$var$$379dc81df3dc7496$export$d07f57595c356899(new Date().toLocaleDateString(locale, $baf701352c755b48$var$$91d4a798329bd0d3$export$7f608b480d9e7085))
            }),
            (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-h-36 rf-w-36",
                children: $baf701352c755b48$var$$1081c1897db35bfa$export$596264e6595ef029(currentWeather.weather, "rf-h-full rf-w-full")
            }),
            (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-title-extralarge-size-auto",
                children: `${Math.round(currentWeather.temperature.average || 0)}${currentWeather.temperature.unit}`
            }),
            (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-mt-4 rf-grid rf-grid-cols-3 rf-items-center",
                children: previsions.map((prevision, key)=>{
                    return (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                        children: [
                            key !== 0 && (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-col-span-3 rf-border-t rf-border-t-menuBorder"
                            }),
                            (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-capitalize rf-font-bold",
                                children: $baf701352c755b48$var$$379dc81df3dc7496$export$d07f57595c356899(prevision.day ? new Date(prevision.day).toLocaleString(locale, {
                                    weekday: "long"
                                }) : "NC")
                            }),
                            (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-2 rf-flex rf-justify-center",
                                children: $baf701352c755b48$var$$1081c1897db35bfa$export$596264e6595ef029(prevision.weather, "rf-h-12")
                            }),
                            (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-flex rf-justify-end",
                                children: `${prevision.temperature.min}${prevision.temperature.unit} / ${prevision.temperature.max}${prevision.temperature.unit}`
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
};
var $baf701352c755b48$var$$34b1838c227861bb$export$2e2bcd8739ae039 = $baf701352c755b48$var$$34b1838c227861bb$var$MobileWeather;
/* eslint-disable react/jsx-boolean-value */ const $baf701352c755b48$var$$f7eebfb9f1239f75$var$LargeWeather = ({ locale: locale, currentWeather: currentWeather, previsions: previsions })=>{
    return (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-height-fill-available rf-flex rf-flex-col rf-justify-between rf-items-center",
        children: [
            (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-pb-4 rf-title-extralarge-bold-size-auto",
                children: $baf701352c755b48$var$$379dc81df3dc7496$export$d07f57595c356899(new Date().toLocaleDateString(locale, $baf701352c755b48$var$$91d4a798329bd0d3$export$7f608b480d9e7085))
            }),
            (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-flex rf-flex-col rf-items-center rf-gap-8",
                children: [
                    (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-h-64 rf-w-64",
                        children: $baf701352c755b48$var$$1081c1897db35bfa$export$596264e6595ef029(currentWeather.weather, "rf-h-full rf-w-full")
                    }),
                    (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-text-7xl",
                        children: `${Math.round(currentWeather.temperature.average || 0)}${currentWeather.temperature.unit}`
                    })
                ]
            }),
            (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-py-4",
                style: {
                    background: "linear-gradient(to left bottom, #F2F3F6, #E5E6EC)"
                },
                children: (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-w-full rf-grid rf-grid-cols-6 rf-text-size-auto",
                    children: previsions.map((prevision, key)=>{
                        return (0, $ee253cdb7e062133$exports.jsxs)("div", {
                            className: `rf-p-4 rf-flex rf-flex-col rf-gap-4 rf-items-center ${key > 0 && "rf-border-l rf-border-l-menuBorder"}`,
                            children: [
                                (0, $ee253cdb7e062133$exports.jsx)("div", {
                                    className: "rf-capitalize rf-subtitle-size-auto rf-font-bold",
                                    children: $baf701352c755b48$var$$379dc81df3dc7496$export$d07f57595c356899(prevision.day ? new Date(prevision.day).toLocaleDateString(locale, $baf701352c755b48$var$$91d4a798329bd0d3$export$7f608b480d9e7085) : "NC")
                                }),
                                $baf701352c755b48$var$$1081c1897db35bfa$export$596264e6595ef029(prevision.weather, "rf-h-24"),
                                (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                    className: "rf-flex rf-flex-col rf-gap-1 rf-items-center",
                                    children: [
                                        (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                            className: "rf-flex rf-flex-row rf-items-center",
                                            children: [
                                                (0, $ee253cdb7e062133$exports.jsx)("p", {
                                                    children: "Min."
                                                }),
                                                (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                                    className: "rf-font-bold rf-ml-1",
                                                    children: [
                                                        prevision.temperature.min,
                                                        prevision.temperature.unit
                                                    ]
                                                })
                                            ]
                                        }),
                                        (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                            className: "rf-flex rf-flex-row rf-items-center",
                                            children: [
                                                (0, $ee253cdb7e062133$exports.jsx)("p", {
                                                    children: "Max."
                                                }),
                                                (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                                    className: "rf-font-bold rf-ml-1",
                                                    children: [
                                                        prevision.temperature.max,
                                                        prevision.temperature.unit
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, key);
                    })
                })
            })
        ]
    });
};
var $baf701352c755b48$var$$f7eebfb9f1239f75$export$2e2bcd8739ae039 = $baf701352c755b48$var$$f7eebfb9f1239f75$var$LargeWeather;
/* eslint-disable react/jsx-boolean-value */ const $baf701352c755b48$var$$0d1f91f3dea4626d$var$LargeVerticalWeather = ({ locale: locale, currentWeather: currentWeather, previsions: previsions })=>{
    return (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-height-fill-available rf-flex rf-flex-col rf-items-center",
        children: [
            (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-h-1/2 rf-flex rf-flex-col rf-justify-end rf-items-center",
                children: [
                    (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-pb-4 rf-title-extralarge-bold-size-auto",
                        children: $baf701352c755b48$var$$379dc81df3dc7496$export$d07f57595c356899(new Date().toLocaleDateString(locale, $baf701352c755b48$var$$91d4a798329bd0d3$export$7f608b480d9e7085))
                    }),
                    (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-flex rf-flex-col rf-items-center rf-gap-8",
                        children: [
                            (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-h-64 rf-w-64",
                                children: $baf701352c755b48$var$$1081c1897db35bfa$export$596264e6595ef029(currentWeather.weather, "rf-h-full rf-w-full")
                            }),
                            (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-text-8xl",
                                children: `${Math.round(currentWeather.temperature.average || 0)}${currentWeather.temperature.unit}`
                            })
                        ]
                    })
                ]
            }),
            (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-h-1/2 rf-pt-24",
                children: (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-w-full rf-p-6",
                    style: {
                        background: "linear-gradient(to left bottom, #F2F3F6, #E5E6EC)"
                    },
                    children: (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-full rf-grid rf-grid-cols-3 rf-text-size-auto",
                        children: previsions.map((prevision, key)=>{
                            return (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                className: `rf-p-6 rf-flex rf-flex-col rf-gap-6 rf-items-center ${key > 0 && "rf-border-l rf-border-l-menuBorder"} ${key === 3 && "rf-border-l-0"} ${key > 2 && "rf-border-t rf-border-t-menuBorder"}`,
                                children: [
                                    (0, $ee253cdb7e062133$exports.jsx)("div", {
                                        className: "rf-capitalize rf-subtitle-size-auto rf-font-bold",
                                        children: $baf701352c755b48$var$$379dc81df3dc7496$export$d07f57595c356899(prevision.day ? new Date(prevision.day).toLocaleDateString(locale, $baf701352c755b48$var$$91d4a798329bd0d3$export$7f608b480d9e7085) : "NC")
                                    }),
                                    $baf701352c755b48$var$$1081c1897db35bfa$export$596264e6595ef029(prevision.weather, "rf-h-24"),
                                    (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                        className: "rf-flex rf-flex-col rf-gap-1 rf-items-center",
                                        children: [
                                            (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                                className: "rf-flex rf-flex-row rf-items-center",
                                                children: [
                                                    (0, $ee253cdb7e062133$exports.jsx)("p", {
                                                        children: "Min."
                                                    }),
                                                    (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                                        className: "rf-font-bold rf-ml-1",
                                                        children: [
                                                            prevision.temperature.min,
                                                            prevision.temperature.unit
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                                className: "rf-flex rf-flex-row rf-items-center",
                                                children: [
                                                    (0, $ee253cdb7e062133$exports.jsx)("p", {
                                                        children: "Max."
                                                    }),
                                                    (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                                        className: "rf-font-bold rf-ml-1",
                                                        children: [
                                                            prevision.temperature.max,
                                                            prevision.temperature.unit
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, key);
                        })
                    })
                })
            })
        ]
    });
};
var $baf701352c755b48$var$$0d1f91f3dea4626d$export$2e2bcd8739ae039 = $baf701352c755b48$var$$0d1f91f3dea4626d$var$LargeVerticalWeather;
const $baf701352c755b48$var$$c59e3f81c2dfc450$var$Weather = ({ locale: locale, position: position, deviceType: deviceType })=>{
    const [currentWeather, setCurrentWeather] = (0, $lT7pJ.useState)();
    const [previsions, setPrevisions] = (0, $lT7pJ.useState)([]);
    (0, $lT7pJ.useEffect)(()=>{
        const savedWeatherData = localStorage.getItem("Retorik.Weather.Data");
        if (savedWeatherData) {
            const dataFromLocalStorage = JSON.parse(localStorage.getItem("Retorik.Weather.Data") || "null");
            if (dataFromLocalStorage) {
                // Check if the data are more than 1-hour old, if so get new data
                const currentDateTime = Date.now();
                const oldDate = new Date(dataFromLocalStorage.current.time);
                if (currentDateTime - 3600000 > oldDate.getTime()) getWeatherData();
                else {
                    setCurrentWeather(dataFromLocalStorage.current);
                    setPrevisions(dataFromLocalStorage.prevision);
                }
            } else getWeatherData();
        } else getWeatherData();
    }, []);
    /**
   * On call :
   *  - try to get weather data from open-meteo API
   *  - if succeeded, fill currentWeather and previsions states with data
   */ const getWeatherData = async ()=>{
        if (position?.latitude && position?.longitude) {
            const fullWeatherData = await $baf701352c755b48$var$$d3351fce476b5d48$export$43a4b902cf54b66d(position);
            if (fullWeatherData) {
                setCurrentWeather(fullWeatherData.current);
                setPrevisions(fullWeatherData.prevision);
            }
        }
    };
    return currentWeather && previsions && previsions.length > 0 ? $baf701352c755b48$var$$91d4a798329bd0d3$export$78f16669b353a880.includes(deviceType) ? (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$34b1838c227861bb$export$2e2bcd8739ae039, {
        locale: locale || "fr-FR",
        currentWeather: currentWeather,
        previsions: previsions
    }) : deviceType !== $baf701352c755b48$var$$32e24fada5befcfe$export$ec1e04e4e5ef8233.borne ? (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$f7eebfb9f1239f75$export$2e2bcd8739ae039, {
        locale: locale || "fr-FR",
        currentWeather: currentWeather,
        previsions: previsions
    }) : (0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$var$$0d1f91f3dea4626d$export$2e2bcd8739ae039, {
        locale: locale || "fr-FR",
        currentWeather: currentWeather,
        previsions: previsions
    }) : (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $baf701352c755b48$export$e030160b7d850165 = $baf701352c755b48$var$$c59e3f81c2dfc450$var$Weather;
const $baf701352c755b48$var$$9214d57b8fee8e0a$var$renderWeather = (props, element)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($104722dc8dfafae7$exports))).render((0, $ee253cdb7e062133$exports.jsx)($baf701352c755b48$export$e030160b7d850165, {
        ...props
    }), element);
};
var $baf701352c755b48$export$6725c38767fd6246 = $baf701352c755b48$var$$9214d57b8fee8e0a$var$renderWeather;
var $baf701352c755b48$export$2e2bcd8739ae039 = $baf701352c755b48$export$e030160b7d850165;
window.Retorik = {
    ...window.Retorik,
    renderWeather: $baf701352c755b48$export$6725c38767fd6246
};











var $lT7pJ = parcelRequire("lT7pJ");




var $lT7pJ = parcelRequire("lT7pJ");



const $db08f64ca3ee7104$var$iconClassname = "rf-h-8 rf-w-8";
const $db08f64ca3ee7104$var$MobileIconAndTitle = ({ subView: subView, className: className })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `large:rf-hidden rf-py-2 rf-flex rf-flex-row rf-items-end ${className}`,
        children: [
            subView === (0, $45d43a6de0968f42$export$3b4d92ba873f009a).weather ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($ee43ffc09b62205d$export$2e2bcd8739ae039, {
                className: $db08f64ca3ee7104$var$iconClassname
            }) : subView === (0, $45d43a6de0968f42$export$3b4d92ba873f009a).emergency ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($976e799b66e7a1ff$export$2e2bcd8739ae039, {
                className: $db08f64ca3ee7104$var$iconClassname
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-ml-2 rf-capitalize rf-subtitle-size-auto",
                children: translation[subView]
            })
        ]
    });
};
var $db08f64ca3ee7104$export$2e2bcd8739ae039 = $db08f64ca3ee7104$var$MobileIconAndTitle;


const $42a1e2f79b1fec72$var$MobileTopContainer = ({ subView: subView, className: className, handleBack: handleBack })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                title: translation.common.back,
                className: "rf-text-sm",
                handleBack: handleBack
            }),
            subView && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $db08f64ca3ee7104$export$2e2bcd8739ae039), {
                subView: subView,
                className: className
            })
        ]
    });
};
var $42a1e2f79b1fec72$export$2e2bcd8739ae039 = $42a1e2f79b1fec72$var$MobileTopContainer;




var $lT7pJ = parcelRequire("lT7pJ");



const $6e47aa200e89bbef$var$iconClassname = "rf-h-16 rf-w-16 large-vertical:rf-h-24 large-vertical:rf-w-24";
const $6e47aa200e89bbef$var$LargeIconAndTitle = ({ subView: subView, className: className })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-hidden large:rf-flex rf-w-full rf-pt-4 large-vertical:rf-pt-8 rf-pl-4 large-vertical:rf-pl-0 rf-flex-row rf-justify-start large-vertical:rf-justify-center rf-items-center ${className}`,
        children: [
            subView === (0, $45d43a6de0968f42$export$3b4d92ba873f009a).weather ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($ee43ffc09b62205d$export$2e2bcd8739ae039, {
                className: $6e47aa200e89bbef$var$iconClassname
            }) : subView === (0, $45d43a6de0968f42$export$3b4d92ba873f009a).emergency ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($976e799b66e7a1ff$export$2e2bcd8739ae039, {
                className: $6e47aa200e89bbef$var$iconClassname
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-ml-2 rf-uppercase rf-text-[#575F6B] rf-subtitle-size-auto",
                children: translation[subView]
            })
        ]
    });
};
var $6e47aa200e89bbef$export$2e2bcd8739ae039 = $6e47aa200e89bbef$var$LargeIconAndTitle;



const $017178f22f9ef2d1$var$Weather = ({ handleClose: handleClose })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    /**
   * On call :
   *  - set RetorikContext's displayWeather state to false
   */ const handleBack = ()=>{
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindow", null);
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindowWeather", null);
        handleClose ? handleClose() : (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).none);
    };
    return isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $3a37d54dea28d7e8$export$2e2bcd8739ae039), {
        depth: (0, $45d43a6de0968f42$export$950556173b6cbecb).dropdown,
        background: "#FFFFFF",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $42a1e2f79b1fec72$export$2e2bcd8739ae039), {
                subView: (0, $45d43a6de0968f42$export$3b4d92ba873f009a).weather,
                className: "rf-border-b rf-border-b-menuBorder",
                handleBack: handleBack
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $baf701352c755b48$export$2e2bcd8739ae039), {
                locale: locale,
                deviceType: currentDeviceType,
                position: {
                    latitude: configuration.position?.latitude || 0,
                    longitude: configuration.position?.longitude || 0
                }
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $8be45c55c8dfd1e6$export$2e2bcd8739ae039), {
        depth: (0, $45d43a6de0968f42$export$950556173b6cbecb).dropdown,
        background: "linear-gradient(to right bottom, #F2F8F8FC , #F2E1E2E8)",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6e47aa200e89bbef$export$2e2bcd8739ae039), {
                        subView: (0, $45d43a6de0968f42$export$3b4d92ba873f009a).weather
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $baf701352c755b48$export$2e2bcd8739ae039), {
                        locale: locale,
                        deviceType: currentDeviceType,
                        position: {
                            latitude: configuration.position?.latitude || 0,
                            longitude: configuration.position?.longitude || 0
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $861fac448a37f7dd$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                onClick: handleBack
            })
        ]
    });
};
var $017178f22f9ef2d1$export$2e2bcd8739ae039 = $017178f22f9ef2d1$var$Weather;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");









const $5b85886c05f33cbf$var$iconClassname = "rf-h-16 rf-w-16 large-vertical:rf-h-24 large-vertical:rf-w-24";
const $5b85886c05f33cbf$var$iconClassnameMobile = "rf-h-8 rf-w-8";
const $5b85886c05f33cbf$var$CustomView = ({ customView: customView, title: title, icon: icon, externalComponents: externalComponents, display: display, setDisplayCustomComponent: setDisplayCustomComponent })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const displayControls = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.displayControls);
    const handleBack = ()=>{
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindow", null);
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)(title ? `Davi.CloseWindow${title.replace(/\s/g, "")}` : "Davi.CloseWindowCustom", null);
        (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).none);
        setDisplayCustomComponent(false);
    };
    const componentToDisplay = (0, $lT7pJ.useMemo)(()=>{
        if (customView?.length) {
            if (externalComponents) {
                const component = externalComponents.find((e)=>e.name === customView);
                if (component?.component) return component.component;
            }
        }
        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {});
    }, [
        customView
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $8be45c55c8dfd1e6$export$2e2bcd8739ae039), {
        className: `${!display && "rf-hidden"} ${isMobile && displayControls ? "rf-mb-12" : "rf-mb-0"}`,
        depth: (0, $45d43a6de0968f42$export$950556173b6cbecb).modal,
        background: "#FFFFFF",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-absolute rf-z-util rf-w-full rf-top-0 rf-left-0",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "large:rf-hidden rf-p-4 rf-flex rf-flex-col",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                                title: translation.common.back,
                                className: "rf-text-sm",
                                handleBack: handleBack
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                className: "large:rf-hidden rf-py-2 rf-flex rf-flex-row rf-items-end undefined",
                                children: [
                                    icon ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                        className: $5b85886c05f33cbf$var$iconClassnameMobile,
                                        children: [
                                            icon,
                                            " "
                                        ]
                                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {}),
                                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                        className: "rf-ml-2 rf-capitalize rf-subtitle-size-auto",
                                        children: title ? (0, $0fdc9a557a65290b$export$d07f57595c356899)(title, locale) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-hidden large:rf-flex rf-w-full rf-pt-4 large-vertical:rf-pt-8 rf-pl-4 large-vertical:rf-pl-0 rf-flex-row rf-justify-start large-vertical:rf-justify-center rf-items-center",
                        children: [
                            icon ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                className: $5b85886c05f33cbf$var$iconClassname,
                                children: [
                                    icon,
                                    " "
                                ]
                            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {}),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-ml-2 rf-uppercase rf-subtitle-size-auto",
                                children: title ? (0, $0fdc9a557a65290b$export$d07f57595c356899)(title, locale) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {})
                            })
                        ]
                    })
                ]
            }),
            componentToDisplay,
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $861fac448a37f7dd$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                customComponent: true,
                onClick: handleBack
            })
        ]
    });
};
var $5b85886c05f33cbf$export$2e2bcd8739ae039 = $5b85886c05f33cbf$var$CustomView;


/* eslint-disable react/jsx-boolean-value */ 
parcelRequire("lT7pJ");







var $lT7pJ = parcelRequire("lT7pJ");





async function $d7c9dc99116a96ed$export$cdd2c9f4b3acf5fb(data) {
    // baseURI is used for retrocompatibility
    let fullAddress = "";
    if (data.baseURI) fullAddress = data.baseURI;
    else fullAddress = `${(0, $a6ed223e0fdb911e$export$2e2bcd8739ae039)(data.prefix)}/${data.tenant}`;
    if (fullAddress.indexOf(`/${(0, $bbe458fac496c294$export$d9e38c0112bbdae6)}`) > -1) fullAddress = fullAddress.replace(`/${(0, $bbe458fac496c294$export$d9e38c0112bbdae6)}`, "");
    fullAddress += `/${0, $bbe458fac496c294$export$1ca3e229e23d7f42}`;
    const res = await fetch(fullAddress).then((emergencyData)=>{
        return emergencyData.json();
    }).catch(()=>{
        return null;
    });
    return res;
}






const $877fad763aeb479d$var$subView = (0, $45d43a6de0968f42$export$3b4d92ba873f009a).emergency;
const $877fad763aeb479d$export$6478e9f7582bd8fc = ()=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const addressData = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.addressData);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const [municipalPoliceNumber, setMunicipalPoliceNumber] = (0, $lT7pJ.useState)("");
    const [localHospitalName, setLocalHospitalName] = (0, $lT7pJ.useState)("");
    const [localHospitalNumber, setLocalHospitalNumber] = (0, $lT7pJ.useState)("");
    const [poisonControlNumber, setPoisonControlNumber] = (0, $lT7pJ.useState)("");
    const [loading, setLoading] = (0, $lT7pJ.useState)(true);
    const divRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        if (divRef?.current) isWidget && (0, $b5fe10956c349963$export$2e2bcd8739ae039)(null, divRef);
    }, [
        divRef?.current
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        const getData = async ()=>{
            const data = await (0, $d7c9dc99116a96ed$export$cdd2c9f4b3acf5fb)(addressData);
            if (data) {
                setMunicipalPoliceNumber(data.municipalPoliceNumber);
                setLocalHospitalName(data.localHospitalName);
                setLocalHospitalNumber(data.localHospitalNumber);
                setPoisonControlNumber(data.poisonControlNumber);
            }
            setLoading(false);
        };
        getData();
    }, [
        addressData
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $ee253cdb7e062133$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `rf-flex rf-flex-col rf-items-center ${isMobile ? "rf-justify-center rf-gap-2" : "rf-justify-end rf-flex-[2_1_0%] rf-gap-9"}`,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($976e799b66e7a1ff$export$2e2bcd8739ae039, {
                        className: "rf-h-9 rf-w-9 large:rf-h-16 large:rf-w-16"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("h3", {
                        className: "rf-text-verylarge-size-auto rf-font-bold rf-capitalize-first rf-text-center",
                        children: translation.emergency[$877fad763aeb479d$var$subView]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                ref: divRef,
                className: "rf-w-full rf-flex rf-flex-col rf-items-center rf-flex-[4_1_0%] rf-justify-evenly rf-h-full rf-pt-2 rf-overflow-y-scroll rf-scrollbar-hidden",
                style: {
                    background: isMobile ? "transparent" : "transparent linear-gradient(291deg, #F2F3F6 0%, #E5E6EC 100%) 0% 0% no-repeat padding-box",
                    boxShadow: isMobile ? "" : "#ffff -3px -3px 16px, rgb(0 0 0 / 25%) 0px 2px 10px 0px"
                },
                children: loading ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ee253cdb7e062133$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-6 rf-h-6 rf-mb-16",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $83a1eb52d5b16844$export$2e2bcd8739ae039), {
                            color: "gray",
                            loaderColor: "#1999b1",
                            backgroundColor: "transparent"
                        })
                    })
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $ee253cdb7e062133$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                            className: `rf-w-full rf-grid ${isMobile ? "rf-grid-cols-2 rf-gap-8 rf-mt-10 rf-mb-8" : "rf-grid-cols-4 rf-divide-x"} `,
                            style: {
                                padding: isMobile ? "" : "0 10%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                    className: "rf-flex rf-flex-col rf-items-center rf-gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                            className: "rf-text-xl rf-font-bold rf-uppercase",
                                            children: translation.emergency.samu
                                        }),
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                            className: "rf-text-5xl large:rf-text-6xl rf-font-bold",
                                            children: "15"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                    className: `rf-flex rf-flex-col rf-items-center ${isMobile ? "" : "rf-border-l rf-border-[#C7C6C6]"} rf-gap-2`,
                                    children: [
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                            className: "rf-text-xl rf-font-bold rf-uppercase",
                                            children: translation.emergency.police
                                        }),
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                            className: "rf-text-5xl large:rf-text-6xl rf-font-bold",
                                            children: "17"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                    className: `rf-flex rf-flex-col rf-items-center ${isMobile ? "" : "rf-border-l rf-border-[#C7C6C6]"} rf-gap-2`,
                                    children: [
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                            className: "rf-text-xl rf-font-bold rf-uppercase",
                                            children: translation.emergency.firefighter
                                        }),
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                            className: "rf-text-5xl large:rf-text-6xl rf-font-bold",
                                            children: "18"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                    className: `rf-flex rf-flex-col rf-items-center ${isMobile ? "" : "rf-border-l rf-border-[#C7C6C6]"} rf-gap-2`,
                                    children: [
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                            className: "rf-text-xl rf-font-bold rf-uppercase",
                                            children: translation.emergency.general
                                        }),
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                            className: "rf-text-5xl large:rf-text-6xl rf-font-bold",
                                            children: "112"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                            className: `rf-flex rf-items-start ${isMobile ? "rf-flex-col" : "rf-gap-12"} `,
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                    children: [
                                        municipalPoliceNumber?.length && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                `${translation.emergency.citypolice} : `,
                                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: municipalPoliceNumber
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                `${translation.emergency.homeless} : `,
                                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: "115"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                `${translation.emergency.emergency} : `,
                                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: "118"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                                    children: [
                                        localHospitalName?.length && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                `${translation.emergency.hospital} ${localHospitalName} : `,
                                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: localHospitalNumber
                                                })
                                            ]
                                        }),
                                        poisonControlNumber?.length && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("p", {
                                            className: "rf-text-xl rf-py-2",
                                            children: [
                                                `${translation.emergency.poison} : `,
                                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("span", {
                                                    className: "rf-font-bold",
                                                    children: poisonControlNumber
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            !isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-flex-1"
            })
        ]
    });
};



const $7cb3c34a871d4fe2$var$Emergency = ({ handleClose: handleClose })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const handleBack = ()=>{
        handleClose ? handleClose() : (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).none);
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindow", null);
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindowEmergency", null);
    };
    return isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1ed31e01939ae4c3$export$2e2bcd8739ae039), {
        handleClose: handleBack,
        backIsConversation: false,
        className: "rf-height-fill-available -rf-mb-4",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $877fad763aeb479d$export$6478e9f7582bd8fc), {})
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $8be45c55c8dfd1e6$export$2e2bcd8739ae039), {
        depth: (0, $45d43a6de0968f42$export$950556173b6cbecb).dropdown,
        background: "linear-gradient(to right bottom, #F2F8F8FC , #F2E1E2E8)",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center rf-justify-center rf-gap-12",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $877fad763aeb479d$export$6478e9f7582bd8fc), {})
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $861fac448a37f7dd$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                onClick: handleBack
            })
        ]
    });
};
var $7cb3c34a871d4fe2$export$2e2bcd8739ae039 = $7cb3c34a871d4fe2$var$Emergency;


const $caa3af5b745c8d74$var$SubViews = ({ externalComponents: externalComponents })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const currentCustomView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentCustomView);
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const showMap = (0, $cbc422a3399ec4d2$export$2e2bcd8739ae039)();
    const showEmergency = (0, $d51d81730d27ba73$export$2e2bcd8739ae039)();
    const [displayCustomComponent, setDisplayCustomComponent] = (0, $lT7pJ.useState)(true);
    const [customView, setCustomView] = (0, $lT7pJ.useState)(undefined);
    (0, $lT7pJ.useEffect)(()=>{
        if (currentCustomView) {
            let label = "";
            if (currentCustomView.label && typeof currentCustomView.label === "string") label = currentCustomView.label;
            else if (currentCustomView.label && typeof currentCustomView.label === "object") label = currentCustomView.label[locale];
            if (label && currentCustomView.customDisplay && currentCustomView.icon) setCustomView({
                view: currentCustomView.customDisplay,
                title: label,
                icon: currentCustomView.icon
            });
            (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).custom);
        }
    }, [
        currentCustomView
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (showMap && currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).custom) {
            if (externalComponents && externalComponents.length > 0) {
                const component = externalComponents?.find((e)=>e.name === "mapDisplay");
                if (component && component.component) {
                    if (configuration.baseMenu || configuration.customMenu) {
                        let allMenus = [];
                        configuration.baseMenu && // Filter on 'icon' key to get only CustomMenu items
                        (allMenus = [
                            ...configuration.baseMenu
                        ].filter((m)=>Object.keys(m).includes("icon")));
                        if (configuration.customMenu && configuration.customMenu.length > 0) {
                            if (Array.isArray(configuration.customMenu[0])) {
                                const tempCustomMenu = configuration.customMenu;
                                tempCustomMenu.forEach((menu)=>{
                                    allMenus = [
                                        ...allMenus,
                                        ...menu
                                    ];
                                });
                            } else allMenus = [
                                ...allMenus,
                                ...configuration.customMenu
                            ];
                        }
                        const customMenuMap = allMenus.find((c)=>c.customDisplay && c.customDisplay === "mapDisplay");
                        if (customMenuMap) {
                            if (customView && customView.view === customMenuMap.customDisplay) ;
                            else (0, $1bda010252da638c$export$5a678fd51bd89633)(customMenuMap);
                            (0, $1bda010252da638c$export$dcb32d000c0e0280)((0, $45d43a6de0968f42$export$4f7cd669585dc69f).DetailViewOpen);
                            (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).custom);
                            setDisplayCustomComponent(true);
                        }
                    }
                }
            }
        }
    }, [
        showMap
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (showEmergency) (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).emergency);
    }, [
        showEmergency
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $1bda010252da638c$export$e49d67c72fb28d58)();
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).none) (0, $1bda010252da638c$export$dcb32d000c0e0280)((0, $45d43a6de0968f42$export$4f7cd669585dc69f).DetailViewOpen);
        else (0, $1bda010252da638c$export$dcb32d000c0e0280)((0, $45d43a6de0968f42$export$4f7cd669585dc69f).DetailViewClose);
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).custom) setDisplayCustomComponent(false);
        else setDisplayCustomComponent(true);
    }, [
        currentSubView
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            currentSubView === (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $bf703c4fb92334f2$export$2e2bcd8739ae039), {}) : currentSubView === (0, $45d43a6de0968f42$export$f05d0fed0593ead7).languages ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $fcc47f5bf5a9a9b0$export$2e2bcd8739ae039), {}) : currentSubView === (0, $45d43a6de0968f42$export$f05d0fed0593ead7).weather ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $017178f22f9ef2d1$export$2e2bcd8739ae039), {}) : currentSubView === (0, $45d43a6de0968f42$export$f05d0fed0593ead7).emergency ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $7cb3c34a871d4fe2$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5b85886c05f33cbf$export$2e2bcd8739ae039), {
                display: displayCustomComponent,
                externalComponents: externalComponents,
                customView: customView?.view,
                title: customView?.title,
                icon: customView?.icon,
                setDisplayCustomComponent: setDisplayCustomComponent
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $cd039b30e123ab91$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c53554168c48d654$export$2e2bcd8739ae039), {})
        ]
    });
};
var $caa3af5b745c8d74$export$2e2bcd8739ae039 = $caa3af5b745c8d74$var$SubViews;




var $lT7pJ = parcelRequire("lT7pJ");





function $4ca988abfca5dd97$export$2e2bcd8739ae039() {
    const activities = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.messageActivities);
    // processedId contains the ids of the activities already processed (because useActivities gives duplicate activities with different state depending on if it's been spoken or not )
    const processedId = [];
    const history = [];
    activities.forEach((activity)=>{
        if (activity.id && !processedId.includes(activity.id)) {
            processedId.push(activity.id);
            // Check if this is a question or an answer (questions from the user don't have a replyToId field)
            if (activity.replyToId) {
                const question = history.find((historyItem)=>historyItem.question.id === activity.replyToId);
                if (question) question.answers.push(activity);
                else {
                    const newQuestion = (0, $ac0c0a65dcd02bca$export$190bd3f548d0449)(activity);
                    history.push({
                        question: newQuestion,
                        answers: [
                            activity
                        ]
                    });
                }
            } else // If the activity has a value, it is a need for further informations that don't need to be displayed
            if (!activity.value) {
                // Hack for Bringup Message to be displayed as bot message
                if (activity.label === "Davi.BringupMessage" && activity.text) {
                    const newQuestion = (0, $ac0c0a65dcd02bca$export$190bd3f548d0449)(activity);
                    history.push({
                        question: newQuestion,
                        answers: [
                            activity
                        ]
                    });
                } else history.push({
                    question: activity,
                    answers: []
                });
            }
        }
    });
    return history;
}


/**
 * Check if the activity data need a display as list to be triggered
 * @param activity : RetorikActivity
 * @returns boolean
 */ const $2b2c37498ea3e437$export$7c55936a30618336 = (activity)=>{
    return !!(activity?.attachmentLayout?.toLowerCase() === "davilist" || activity?.attachmentLayout !== "carousel" && activity?.attachmentLayout !== "grid" && activity?.attachments?.length && activity.attachments.length > 1);
};



/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");








parcelRequire("lT7pJ");


const $e38b23b7d302f7a2$var$ConversationHeader = ({ agentName: agentName = "L\xe9a", companyName: companyName, companyNameLocalized: companyNameLocalized, subCompanyMessage: subCompanyMessage, subCompanyMessageLocalized: subCompanyMessageLocalized, imageUrl: imageUrl = "" })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        id: "retorik-conversation-header",
        className: "rf-w-full rf-h-fit rf-grid rf-grid-cols-headerContainer rf-grid-rows-headerContainer rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-col-start-1 rf-col-end-2 rf-row-start-1 rf-row-end-4 rf-flex rf-items-center rf-px-2 rf-py-2",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                    src: imageUrl,
                    alt: "Agent",
                    className: "rf-w-full rf-max-h-28 rf-aspect-square rf-rounded-half rf-border-secondary rf-border-2 rf-bg-truewhite"
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-col-start-2 rf-col-span-full rf-row-start-1 rf-row-end-2 rf-flex rf-items-end rf-font-bold",
                style: {
                    color: themeColors.companyName
                },
                children: companyNameLocalized?.[locale] || companyName || "Davi"
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-col-start-2 rf-col-span-full rf-row-start-3 rf-row-end-4 rf-flex rf-items-start rf-text-sm rf-italic",
                children: subCompanyMessageLocalized?.[locale] || subCompanyMessage || `${agentName} ${translation.menu.answer}`
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-col-start-2 rf-col-span-full rf-row-start-2 rf-row-end-3 -rf-ml-2 rf-flex rf-items-center",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("hr", {
                    className: "rf-h-1 rf-bg-gray-200 rf-border-0 rf-w-full rf-shadow-[0_3px_6px_rgba(0,0,0,0.16)] rf-mb-1"
                })
            })
        ]
    });
};
var $e38b23b7d302f7a2$export$2e2bcd8739ae039 = $e38b23b7d302f7a2$var$ConversationHeader;




/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");



var $lT7pJ = parcelRequire("lT7pJ");








var $lT7pJ = parcelRequire("lT7pJ");





const $fb7be628244a50c4$var$interval = 150 // 20 // 25
;
const $fb7be628244a50c4$var$md = new (0, $c1dfe7a9dc4f2ee7$export$2e2bcd8739ae039)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    typographer: true,
    quotes: `""''`
});
const $fb7be628244a50c4$var$DisplayStreaming = ({ triggerScroll: triggerScroll, setStreamingEnded: setStreamingEnded, streamingActivity: streamingActivity, currentStreaming: currentStreaming, isMobile: isMobile })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const streamingQueue = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.streamingQueueForText);
    const streamingCount = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.streamingQueueFullLength);
    const forceMobileView = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.forceMobileView);
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $lT7pJ.useState)("");
    const [currentTextEnded, setCurrentTextEnded] = (0, $lT7pJ.useState)(true);
    const [currentQueueIndex, setCurrentQueueIndex] = (0, $lT7pJ.useState)(0);
    const time = (0, $lT7pJ.useMemo)(()=>{
        if (streamingQueue.length) {
            const answerTime = streamingQueue[0].localTimestamp ? new Date(streamingQueue[0].localTimestamp) : streamingQueue[0].timestamp ? new Date(streamingQueue[0].timestamp) : new Date();
            return answerTime;
        }
        return null;
    }, [
        streamingQueue
    ]);
    const intervalRef = (0, $lT7pJ.useRef)(null);
    const streamRef = (0, $lT7pJ.useRef)([]);
    const streamIndexRef = (0, $lT7pJ.useRef)(0);
    const previousTextRef = (0, $lT7pJ.useRef)([]);
    const handleNewStreaming = (text)=>{
        text = $fb7be628244a50c4$var$md.render(text);
        streamRef.current = text.split(" ");
        setCurrentTextEnded(false);
        intervalRef.current = setInterval(()=>{
            if (streamIndexRef.current < streamRef.current.length - 1) {
                const current = streamRef.current[streamIndexRef.current];
                setStreamingTextToDisplay((value)=>`${value} ${current}`);
                streamIndexRef.current = streamIndexRef.current + 1;
                streamIndexRef.current % 10 === 0 && triggerScroll();
            } else {
                setCurrentTextEnded(true);
                triggerScroll();
                intervalRef.current && clearInterval(intervalRef.current);
            }
        }, $fb7be628244a50c4$var$interval);
    };
    const resetData = ()=>{
        setCurrentQueueIndex(0);
        streamIndexRef.current = 0;
        previousTextRef.current = [];
        (0, $b8685bd729fa723f$export$e9ca045daeb00700)(0);
        intervalRef?.current && clearInterval(intervalRef.current);
    };
    (0, $lT7pJ.useEffect)(()=>{
        if (currentTextEnded && streamingQueue?.length) {
            if (streamingCount === 0 || currentQueueIndex < streamingCount) {
                if (streamingQueue.length > currentQueueIndex) {
                    setStreamingEnded(false);
                    let text = "";
                    for(let i = 0; i <= currentQueueIndex; i++)text = text + streamingQueue[i].text;
                    handleNewStreaming(text);
                    setCurrentQueueIndex((value)=>value + 1);
                }
            } else {
                let fullText = "";
                streamingQueue.forEach((activity)=>{
                    fullText = `${fullText} ${activity.text}`;
                });
                setStreamingTextToDisplay($fb7be628244a50c4$var$md.render(fullText));
                setStreamingEnded(true);
                resetData();
            }
        }
    }, [
        streamingQueue,
        currentTextEnded,
        streamingCount
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (!currentStreaming) {
            setCurrentTextEnded(true);
            setStreamingTextToDisplay("");
            resetData();
        }
    }, [
        currentStreaming
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        return ()=>{
            intervalRef?.current && clearInterval(intervalRef.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-text-textModePanelConversationBot rf-flex rf-flex-col rf-items-start rf-gap-2",
        children: [
            isMobile && time && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-px-4 rf-text-[#9A9A9A]",
                children: time.toLocaleString(locale, {
                    hour: "numeric",
                    minute: "numeric"
                })
            }),
            streamingTextToDisplay && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-px-4",
                dangerouslySetInnerHTML: {
                    __html: streamingTextToDisplay
                }
            }),
            currentQueueIndex === 0 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: !!streamingActivity?.attachments?.length && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: `${forceMobileView ? "rf-m-auto" : "rf-w-full"} ${streamingActivity.attachments.length <= 1 && "rf-px-4"}`,
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $66e8c4d559e5bc15$export$2e2bcd8739ae039), {
                        activity: streamingActivity
                    })
                })
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-px-4 rf-font-bold rf-animate-blink",
                children: "..."
            })
        ]
    });
};
var $fb7be628244a50c4$export$2e2bcd8739ae039 = $fb7be628244a50c4$var$DisplayStreaming;


const $e6f7f993e556a691$var$DisplayStandard = ({ botResponses: botResponses, isMobile: isMobile, triggerScroll: triggerScroll, canBeStreaming: canBeStreaming })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const currentStreaming = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.currentStreaming);
    const streamingId = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.streamingReplyToId);
    const forceMobileView = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.forceMobileView);
    const [streamingActivity, setStreamingActivity] = (0, $lT7pJ.useState)(undefined);
    const [streamingEnded, setStreamingEnded] = (0, $lT7pJ.useState)(false);
    const nonStreamingActivities = (0, $lT7pJ.useMemo)(()=>{
        if (streamingActivity) return botResponses.filter((act)=>act.id !== streamingActivity.id && act.replyToId === streamingActivity.replyToId);
        return botResponses;
    }, [
        streamingActivity,
        botResponses
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (botResponses.length && currentStreaming) setStreamingActivity(botResponses.find((act)=>act.replyToId === streamingId && act.value?.streamingCount));
        else setStreamingActivity(undefined);
    }, [
        botResponses,
        currentStreaming,
        streamingId
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            canBeStreaming && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $fb7be628244a50c4$export$2e2bcd8739ae039), {
                triggerScroll: triggerScroll,
                setStreamingEnded: setStreamingEnded,
                streamingActivity: streamingActivity,
                currentStreaming: currentStreaming,
                isMobile: isMobile
            }),
            (!streamingActivity || streamingActivity && streamingEnded) && nonStreamingActivities.map((activity, key)=>{
                const answerTime = activity.localTimestamp ? new Date(activity.localTimestamp) : activity.timestamp ? new Date(activity.timestamp) : new Date();
                return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                    className: `${key > 0 && "rf-pt-2"} rf-text-textModePanelConversationBot rf-animate-slideBottom rf-flex rf-flex-col rf-items-start rf-gap-2`,
                    children: [
                        isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-px-4 rf-text-[#9A9A9A]",
                            children: answerTime.toLocaleString(locale, {
                                hour: "numeric",
                                minute: "numeric"
                            })
                        }),
                        activity.htmlText ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-px-4",
                            dangerouslySetInnerHTML: {
                                __html: activity.htmlText
                            }
                        }) : activity.text ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-px-4",
                            children: (0, $86e1288ad17c6773$export$d6c6ec86eedacfd9)(activity.text)
                        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}),
                        !!activity?.attachments?.length && !(0, $2b2c37498ea3e437$export$7c55936a30618336)(activity) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: `${forceMobileView ? "rf-m-auto" : "rf-w-full"} ${activity.attachments.length <= 1 && "rf-px-4"} rf-flex rf-flex-col rf-gap-2`,
                            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $66e8c4d559e5bc15$export$2e2bcd8739ae039), {
                                activity: activity
                            })
                        })
                    ]
                }, key);
            })
        ]
    });
};
var $e6f7f993e556a691$export$2e2bcd8739ae039 = $e6f7f993e556a691$var$DisplayStandard;





const $4d531d1f5b781cf3$var$ConversationDisplay = ({ userQuestion: userQuestion, botResponses: botResponses, userQuestionTime: userQuestionTime, isMobile: isMobile, triggerScroll: triggerScroll, canBeStreaming: canBeStreaming })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isWaitingForResponse = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.isWaitingForResponse);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            userQuestion?.text && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                id: "retorik-userQuestion",
                className: "rf-pb-4 rf-text-textModePanelConversationUser rf-animate-slideBottom rf-flex rf-flex-col rf-justify-start rf-text-size-auto rf-gap-2",
                children: [
                    userQuestionTime && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-px-4 rf-text-[#9A9A9A]",
                        children: userQuestionTime.toLocaleString(locale, {
                            hour: "numeric",
                            minute: "numeric"
                        })
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-px-4",
                        children: userQuestion.text
                    })
                ]
            }, userQuestion.id),
            isWaitingForResponse && (!isMobile || isMobile && canBeStreaming) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $dfc989789a44be83$export$2e2bcd8739ae039), {
                classname: "rf-flex rf-justify-start rf-pl-8 rf-items-center",
                subClassname: "rf-w-4 rf-h-4",
                useTextColor: true,
                size: (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).medium,
                triggerScroll: triggerScroll
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                id: "retorik-botResponses",
                className: "rf-flex rf-flex-col rf-text-size-auto rf-gap-2 rf-scrollbar-hidden",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e6f7f993e556a691$export$2e2bcd8739ae039), {
                    triggerScroll: triggerScroll,
                    botResponses: botResponses || [],
                    isMobile: isMobile,
                    canBeStreaming: canBeStreaming
                })
            })
        ]
    });
};
var $4d531d1f5b781cf3$export$2e2bcd8739ae039 = $4d531d1f5b781cf3$var$ConversationDisplay;


const $ae2e632e64d8731e$var$ConversationPanelMobile = ({ homeActivity: homeActivity, itemsInConversation: itemsInConversation })=>{
    const activities = (0, $4ca988abfca5dd97$export$2e2bcd8739ae039)();
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const agentData = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.agentData);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const listClosed = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.listClosed);
    const open = (0, $079f3ffaa96f1faa$export$d95eb9b67812311f)((state)=>state.open);
    const [opacityStyle, setOpacityStyle] = (0, $lT7pJ.useState)("");
    const [scrollButtonDisplay, setScrollButtonDisplay] = (0, $lT7pJ.useState)(false);
    const [scrollButtonDirection, setScrollButtonDirection] = (0, $lT7pJ.useState)("bottom");
    const [preventScroll, setPreventScroll] = (0, $lT7pJ.useState)(false);
    const retorikConversationRef = (0, $lT7pJ.useRef)(null);
    const botEndRef = (0, $lT7pJ.useRef)(null);
    const timerRef = (0, $lT7pJ.useRef)(null);
    const handleScroll = ()=>{
        if (retorikConversationRef.current) {
            const current = retorikConversationRef.current;
            if (current.scrollHeight > current.offsetHeight) {
                setScrollButtonDisplay(true);
                if (current.scrollHeight - current.scrollTop === current.clientHeight) setScrollButtonDirection("top");
                else if (current.scrollHeight - current.scrollTop < current.clientHeight + 10) setScrollButtonDirection("top");
                else setScrollButtonDirection("bottom");
            }
            const percentage = Math.ceil(current.scrollTop / (current.scrollHeight - current.clientHeight) * 15);
            setOpacityStyle(`linear-gradient(to top, black ${100 - percentage}%, transparent 100%)`);
        }
    };
    /**
   * Scroll to the botEndRef HTML element at the bottom of the view
   */ const scrollHandler = (to, from)=>{
        if (to === "bottom") setScrollButtonDirection("top");
        else setScrollButtonDirection("bottom");
        if ((!preventScroll || from === "button") && botEndRef?.current && to === "bottom") botEndRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
        else if (to === "top" && retorikConversationRef?.current) retorikConversationRef.current.children[1].scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    };
    (0, $lT7pJ.useEffect)(()=>{
        timerRef.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            scrollHandler("bottom", "newMessage");
        }, 100);
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        itemsInConversation,
        retorikConversationRef?.current?.scrollHeight
    ]);
    (0, $lT7pJ.useLayoutEffect)(()=>{
        if (retorikConversationRef?.current) isWidget && (0, $b5fe10956c349963$export$2e2bcd8739ae039)(null, retorikConversationRef);
    });
    /**
   * On retorikConversationRef change :
   *  - check if retorikConversationRef.current is defined
   *  - if scrollHeight > clientHeight, call handleScroll
   *  - if scrollHeight <= clientHeight, set opacityStyle state to undefined
   */ (0, $lT7pJ.useEffect)(()=>{
        if (retorikConversationRef.current) {
            if (retorikConversationRef.current.scrollHeight > retorikConversationRef.current.clientHeight) handleScroll();
            else setOpacityStyle(undefined);
        }
    }, [
        retorikConversationRef?.current
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if ((listClosed || homeActivity) && botEndRef.current) {
            timerRef.current && clearTimeout(timerRef.current);
            timerRef.current = setTimeout(()=>{
                scrollHandler("bottom", "newMessage");
            }, 100);
        }
    }, [
        listClosed,
        homeActivity
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-relative rf-max-h-full rf-h-full rf-max-w-full rf-w-full rf-col-start-1 rf-col-span-full rf-row-start-1 rf-row-end-13 rf-self-start rf-overflow-hidden rf-justify-self-center rf-flex rf-flex-col rf-bg-textModePanelBackground",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e38b23b7d302f7a2$export$2e2bcd8739ae039), {
                agentName: agentData?.name,
                companyName: configuration?.companyName,
                companyNameLocalized: configuration?.companyNameLocalized,
                subCompanyMessage: configuration?.subCompanyMessage,
                subCompanyMessageLocalized: configuration?.subCompanyMessageLocalized,
                imageUrl: agentData?.portrait
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                ref: retorikConversationRef,
                id: "retorik-conversation",
                className: "rf-relative rf-max-h-full rf-h-full rf-py-4 rf-overflow-y-scroll rf-scrollbar-thin rf-self-auto rf-mb-26 rf-overflow-x-auto rf-justify-self-center rf-flex rf-flex-col rf-text-size-auto rf-text-trueblack rf-bg-textModePanelBackground rf-shadow-[3px_3px_6px_#00000029]",
                style: {
                    WebkitMaskImage: currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile ? opacityStyle : undefined
                },
                onScroll: handleScroll,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $aa3bf51137e07f42$export$2e2bcd8739ae039), {
                        direction: scrollButtonDirection,
                        display: scrollButtonDisplay && open,
                        scrollHandler: scrollHandler,
                        setPreventScroll: setPreventScroll,
                        className: "rf-fixed rf-z-ui rf-bottom-40 rf-right-6 rf-w-9 rf-h-9 rf-cursor-pointer rf-bg-[#00000050] rf-p-[7px_12px] rf-rounded-[20px] rf-flex"
                    }),
                    activities.map((activity, index)=>{
                        const userQuestionTime = activity.question ? activity.question.localTimestamp ? new Date(activity.question.localTimestamp) : activity.question.timestamp ? new Date(activity.question.timestamp) : new Date() : undefined;
                        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-pt-3",
                            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4d531d1f5b781cf3$export$2e2bcd8739ae039), {
                                userQuestion: activity.question,
                                botResponses: activity.answers,
                                userQuestionTime: userQuestionTime,
                                isMobile: true,
                                triggerScroll: ()=>scrollHandler("bottom", "newMessage"),
                                canBeStreaming: index === activities.length - 1
                            })
                        }, index);
                    }),
                    homeActivity?.attachments?.length ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-pt-4 rf-flex rf-flex-col rf-text-size-auto rf-gap-2",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $66e8c4d559e5bc15$export$2e2bcd8739ae039), {
                            activity: homeActivity
                        })
                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        ref: botEndRef
                    })
                ]
            })
        ]
    });
};
var $ae2e632e64d8731e$export$2e2bcd8739ae039 = $ae2e632e64d8731e$var$ConversationPanelMobile;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");




const $593e8f92b6050c0c$var$ConversationPanelLarge = ({ homeActivity: homeActivity, itemsInConversation: itemsInConversation })=>{
    const activities = (0, $4ca988abfca5dd97$export$2e2bcd8739ae039)();
    const mediumLandscape = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.mediumLandscape);
    const botEndRef = (0, $lT7pJ.useRef)(null);
    const timerRef = (0, $lT7pJ.useRef)(null);
    const userQuestion = (0, $lT7pJ.useMemo)(()=>{
        return activities.length && activities[activities.length - 1].question?.text ? activities[activities.length - 1].question : undefined;
    }, [
        activities
    ]);
    const botResponses = (0, $lT7pJ.useMemo)(()=>{
        return activities.length ? activities[activities.length - 1].answers : undefined;
    }, [
        activities
    ]);
    const handleScroll = ()=>{
        botEndRef?.current?.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    };
    (0, $lT7pJ.useEffect)(()=>{
        timerRef.current && clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            handleScroll();
        }, 100);
        return ()=>{
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [
        itemsInConversation
    ]);
    return homeActivity?.attachments?.length || userQuestion || botResponses ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-relative rf-max-h-full ${mediumLandscape ? "rf-col-start-4" : "rf-col-start-5"} vertical:rf-col-start-1 rf-col-span-full rf-row-start-4 rf-row-end-12 large-vertical:rf-row-start-7 large-vertical:rf-row-span-6 rf-self-start rf-overflow-hidden rf-justify-self-center rf-w-3/5 rf-flex rf-flex-col rf-rounded rf-bg-textModePanelBackground`,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
            id: "retorik-conversation",
            className: "rf-relative rf-max-h-full rf-bg-textModePanelBackground rf-py-4 rf-overflow-y-scroll rf-overflow-x-hidden rf-scrollbar-thin vertical:rf-overflow-x-auto rf-justify-self-center rf-flex rf-flex-col rf-text-size-auto rf-text-trueblack rf-shadow-[3px_3px_6px_#00000029]",
            children: [
                homeActivity?.attachments?.length ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-pt-4 rf-flex rf-flex-col rf-text-size-auto rf-gap-2",
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $66e8c4d559e5bc15$export$2e2bcd8739ae039), {
                        activity: homeActivity
                    })
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4d531d1f5b781cf3$export$2e2bcd8739ae039), {
                    userQuestion: userQuestion,
                    botResponses: botResponses,
                    triggerScroll: handleScroll,
                    canBeStreaming: true
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    ref: botEndRef
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $593e8f92b6050c0c$export$2e2bcd8739ae039 = $593e8f92b6050c0c$var$ConversationPanelLarge;


const $680a1014cb5a8413$var$ConversationPanel = ()=>{
    const activities = (0, $4ca988abfca5dd97$export$2e2bcd8739ae039)();
    const forceMobileView = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.forceMobileView);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const showHomeAttachments = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.showHomeAttachments);
    const listClosed = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.listClosed);
    const [listActivity, setListActivity] = (0, $lT7pJ.useState)(undefined);
    /**
   * Number of questions and answers in the conversation. Used to trigger useEffects more efficiently
   */ const itemsInConversation = (0, $lT7pJ.useMemo)(()=>{
        let number = 0;
        activities.forEach((element)=>{
            number += element.answers.length + 1;
        });
        return number;
    }, [
        activities
    ]);
    /**
   * Scroll to the botEndRef HTML element at the bottom of the view, then check if there is an activity in need of List display.
   * Finally, set list state depending on the check's result.
   */ (0, $lT7pJ.useEffect)(()=>{
        const answers = activities.length ? activities[activities.length - 1].answers : [];
        setListActivity(answers.find((activity)=>(0, $2b2c37498ea3e437$export$7c55936a30618336)(activity)));
    }, [
        itemsInConversation
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (listClosed || showHomeAttachments) setListActivity(undefined);
    }, [
        listClosed,
        showHomeAttachments
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: listActivity && !listClosed ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $33939e35968291bd$export$2e2bcd8739ae039), {
            activity: listActivity,
            onClose: ()=>(0, $1bda010252da638c$export$f03cfde7db70aa27)(true)
        }) : isMobile || forceMobileView ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ae2e632e64d8731e$export$2e2bcd8739ae039), {
            homeActivity: showHomeAttachments,
            itemsInConversation: itemsInConversation
        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $593e8f92b6050c0c$export$2e2bcd8739ae039), {
            homeActivity: showHomeAttachments,
            itemsInConversation: itemsInConversation
        })
    });
};
var $680a1014cb5a8413$export$2e2bcd8739ae039 = $680a1014cb5a8413$var$ConversationPanel;




var $lT7pJ = parcelRequire("lT7pJ");



var $lT7pJ = parcelRequire("lT7pJ");






parcelRequire("lT7pJ");






var $lT7pJ = parcelRequire("lT7pJ");






const $737b7742ee5c954d$var$Mode = ()=>{
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const disabledSpeechMode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.disableSpeechMode);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const [fromTextToVocal, setFromTextToVocal] = (0, $lT7pJ.useState)(false);
    const toggleMode = (newMode)=>{
        setFromTextToVocal(true);
        if (newMode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text) {
            (0, $7c69764370dcab43$export$bea4f7bfbef5d31e)(true);
            (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).ForceClosing);
        }
        (0, $7c69764370dcab43$export$d4f039427a1beff1)(newMode);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-px-4 rf-grid rf-grid-cols-1 ${disabledSpeechMode ? "rf-py-4" : "rf-grid-rows-2"} rf-items-center`,
        children: [
            !disabledSpeechMode && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-flex rf-justify-center",
                children: mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                    className: "rf-w-full rf-aspect-square rf-flex rf-justify-center rf-items-center rf-border rf-border-menuBorder rf-rounded-half rf-shadow-[0_0_20px_1px_#A4A7AF80]",
                    onClick: ()=>toggleMode((0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal),
                    "aria-label": "vocal mode",
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $bc79d8ffc04dbc80$export$2e2bcd8739ae039), {
                        className: "rf-h-5 rf-w-5 tactile:rf-h-6 tactile:rf-w-6",
                        color: "#A4A7AF"
                    })
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5d2dd969319e03a9$export$2e2bcd8739ae039), {
                    openMicrophone: fromTextToVocal
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                className: "rf-flex rf-justify-center rf-items-center",
                onClick: ()=>toggleMode((0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text),
                "aria-label": "text mode",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $9860c37d6755e19a$export$2e2bcd8739ae039), {
                    className: "rf-h-5 rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6",
                    color: mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text ? themeColors.secondary : "#A4A7AF"
                })
            })
        ]
    });
};
var $737b7742ee5c954d$export$2e2bcd8739ae039 = $737b7742ee5c954d$var$Mode;


const $00576f31e8e78cb9$var$Remote = ()=>{
    const disableSound = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.disableSound);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        id: "retorik-framework-remote",
        className: "rf-w-full rf-pt-3 rf-pb-4 rf-flex rf-flex-col rf-items-center rf-rounded-l-lg rf-shadow-[0_3px_6px_#606267]",
        style: {
            background: "linear-gradient(#F8F8FC, #EDEEF3)"
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $737b7742ee5c954d$export$2e2bcd8739ae039), {}),
            (!disableSound && mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text || mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal || isMobile) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $ee253cdb7e062133$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-[90%] rf-mb-4 rf-border-b-2 rf-border-b-[#C4C5C8]"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-full rf-flex rf-flex-col rf-justify-center rf-gap-5 large-vertical:rf-gap-6",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5d86e46c46aedee0$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $00576f31e8e78cb9$export$2e2bcd8739ae039 = $00576f31e8e78cb9$var$Remote;


const $f63ac3c3ae9f2668$var$RemoteContainer = ({ hideMenu: hideMenu = false })=>{
    const top = (0, $7efb21d01742ced3$export$2e2bcd8739ae039)();
    const dashboardOpened = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.dashboardOpened);
    /**
   * On call :
   *  - close subview if one is opened and if the parameter is false / undefined
   *  - toggle dashboardOpened state
   * @param doNotCloseViews : boolean
   */ const toggleDashboard = (doNotCloseViews)=>{
        !doNotCloseViews && (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).none);
        (0, $1bda010252da638c$export$bbd7c92fc378d660)(!dashboardOpened);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-absolute rf-hidden large:rf-flex rf-flex-col rf-items-center rf-justify-start rf-w-24 rf-right-0 rf-text-xsm rf-text-trueblack",
                style: {
                    top: top
                },
                children: [
                    !hideMenu && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $46ab1b43aa817fae$export$2e2bcd8739ae039), {
                        dashboardVisible: false,
                        onClick: ()=>toggleDashboard()
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $00576f31e8e78cb9$export$2e2bcd8739ae039), {})
                ]
            }),
            dashboardOpened && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $60271d033b85113a$export$2e2bcd8739ae039), {
                toggleDashboard: ()=>toggleDashboard(true)
            })
        ]
    });
};
var $f63ac3c3ae9f2668$export$2e2bcd8739ae039 = $f63ac3c3ae9f2668$var$RemoteContainer;



parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");






parcelRequire("lT7pJ");



const $42036cf83cf61725$var$ModeButton = ({ label: label, selected: selected, onClick: onClick })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
        className: "rf-grid rf-w-full rf-h-12 rf-pb-4 rf-justify-center rf-items-end",
        onClick: ()=>onClick((0, $45d43a6de0968f42$export$9484bbecc3c49a2e)[label]),
        "aria-label": label,
        children: label === "vocal" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $bc79d8ffc04dbc80$export$2e2bcd8739ae039), {
            className: "rf-h-5",
            color: "#A4A7AF"
        }) : label === "text" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $9860c37d6755e19a$export$2e2bcd8739ae039), {
            className: "rf-h-4",
            color: selected ? themeColors.secondary : "#A4A7AF"
        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $74d44cd7cee6f057$export$2e2bcd8739ae039), {
            className: "rf-h-[0.875rem]",
            color: selected ? themeColors.secondary : "#A4A7AF"
        })
    });
};
var $42036cf83cf61725$export$2e2bcd8739ae039 = $42036cf83cf61725$var$ModeButton;




const $cd6ee96f45afcc53$var$Mobile = ({ parametersOpened: parametersOpened, toggleParameters: toggleParameters })=>{
    const hideMenu = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.hideMenu);
    const disabledSpeechMode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.disableSpeechMode);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const appAvailable = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.appAvailable);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const [fromTextToVocal, setFromTextToVocal] = (0, $lT7pJ.useState)(false);
    const toggleMode = (newMode)=>{
        // If the parameters are opened, no action
        if (!parametersOpened) {
            setFromTextToVocal(true);
            if (newMode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text) {
                (0, $7c69764370dcab43$export$bea4f7bfbef5d31e)(true);
                (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).ForceClosing);
            }
            (0, $7c69764370dcab43$export$d4f039427a1beff1)(newMode);
        }
    };
    const handleDashboardClick = ()=>{
        toggleParameters();
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        id: "retorik-framework-menu",
        className: "rf-w-full rf-h-fit rf-flex rf-flex-col-reverse rf-border-t rf-border-t-menuBorder rf-pointer-events-auto",
        style: {
            background: "linear-gradient(to right, #F8F8FC, #EDEEF3)"
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `rf-w-full rf-grid rf-flex-1 rf-h-full ${!disabledSpeechMode ? hideMenu ? "rf-grid-cols-2" : "rf-grid-cols-3" : hideMenu ? "rf-grid-cols-1" : "rf-grid-cols-2"} rf-min-h-12 rf-grid-rows-1 rf-justify-center rf-items-end`,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $42036cf83cf61725$export$2e2bcd8739ae039), {
                        label: "text",
                        selected: parametersOpened ? false : mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text,
                        onClick: toggleMode
                    }),
                    !disabledSpeechMode && (mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-py-2 rf-w-full rf-flex rf-justify-center",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5d2dd969319e03a9$export$2e2bcd8739ae039), {
                            openMicrophone: fromTextToVocal
                        })
                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $42036cf83cf61725$export$2e2bcd8739ae039), {
                        label: "vocal",
                        selected: false,
                        onClick: toggleMode
                    })),
                    !hideMenu && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $42036cf83cf61725$export$2e2bcd8739ae039), {
                        label: "dashboard",
                        selected: parametersOpened,
                        onClick: handleDashboardClick
                    })
                ]
            }),
            !parametersOpened && mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $52c5220b9210ea92$export$2e2bcd8739ae039), {
                className: "rf-mx-3 rf-mt-2",
                withButton: currentDeviceType !== (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile
            }),
            appAvailable && !parametersOpened && mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1b3e8b9ff8a47c6c$export$2e2bcd8739ae039), {
                className: "rf-w-full rf-px-6 rf-py-2"
            })
        ]
    });
};
var $cd6ee96f45afcc53$export$2e2bcd8739ae039 = $cd6ee96f45afcc53$var$Mobile;




var $lT7pJ = parcelRequire("lT7pJ");





const $a6ad38d0574e5cc4$var$ParametersAndDashboardContainer = ({ handleBack: handleBack, hideMenu: hideMenu = false })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const divRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        divRef?.current && isWidget && (0, $b5fe10956c349963$export$2e2bcd8739ae039)(null, divRef);
    }, [
        divRef.current
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-h-full rf-flex rf-flex-col rf-py-4 rf-bg-truewhite rf-overflow-y-hidden rf-pointer-events-auto",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                title: translation.menu.backconversation,
                className: "rf-px-4 rf-text-sm",
                handleBack: handleBack
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                ref: divRef,
                className: "rf-w-full rf-flex-rf-flex-col rf-overflow-y-scroll rf-scrollbar-hidden",
                children: [
                    !hideMenu && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $60271d033b85113a$export$2e2bcd8739ae039), {
                                toggleDashboard: handleBack
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-h-6 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-4 rf-text-lightgray",
                                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.common.parameters, locale)
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5d86e46c46aedee0$export$2e2bcd8739ae039), {
                                handleBack: handleBack
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a06b445ba6af5422$export$2e2bcd8739ae039), {
                        isMobile: true
                    })
                ]
            })
        ]
    });
};
var $a6ad38d0574e5cc4$export$2e2bcd8739ae039 = $a6ad38d0574e5cc4$var$ParametersAndDashboardContainer;


const $c1a16a3ac9930b3d$var$MobileContainer = ({ hideMenu: hideMenu })=>{
    const dashboardOpened = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.dashboardOpened);
    const toggleParameters = ()=>{
        (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).none);
        (0, $1bda010252da638c$export$bbd7c92fc378d660)(!dashboardOpened);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $8be45c55c8dfd1e6$export$2e2bcd8739ae039), {
        className: "large:rf-hidden rf-p-0 rf-m-0 rf-flex rf-flex-col-reverse rf-pointer-events-none vertical:rf-row-start-0 vertical:rf-row-end-13",
        depth: (0, $45d43a6de0968f42$export$950556173b6cbecb).ui,
        background: "transparent",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $cd6ee96f45afcc53$export$2e2bcd8739ae039), {
                parametersOpened: dashboardOpened,
                toggleParameters: toggleParameters
            }),
            dashboardOpened && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a6ad38d0574e5cc4$export$2e2bcd8739ae039), {
                handleBack: toggleParameters,
                hideMenu: hideMenu
            })
        ]
    });
};
var $c1a16a3ac9930b3d$export$2e2bcd8739ae039 = $c1a16a3ac9930b3d$var$MobileContainer;



const $6679ae60a0fb3580$var$MenuDisplayer = ({ hideMenu: hideMenu })=>{
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const displayControls = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.displayControls);
    return !displayControls ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}) : isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $c1a16a3ac9930b3d$export$2e2bcd8739ae039), {
        hideMenu: !!hideMenu
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $f63ac3c3ae9f2668$export$2e2bcd8739ae039), {
                hideMenu: !!hideMenu
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $dbc8e0777cd36249$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6679ae60a0fb3580$export$2e2bcd8739ae039 = $6679ae60a0fb3580$var$MenuDisplayer;



parcelRequire("lT7pJ");
const $6e9da30149e4e457$var$ExtendIcon = ({ className: className, color: color, extended: extended })=>{
    if (extended) return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20.018",
        height: "19.382",
        viewBox: "0 0 20.018 19.382",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
            id: "Groupe_841",
            "data-name": "Groupe 841",
            transform: "translate(3.415 3.891)",
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                id: "PICTO",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                    id: "Groupe_845",
                    "data-name": "Groupe 845",
                    transform: "translate(0.003 -1)",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                            id: "Groupe_843",
                            "data-name": "Groupe 843",
                            transform: "translate(3.99 21.134) rotate(180)",
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_15",
                                    "data-name": "Ligne 15",
                                    y2: "5.046",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_16",
                                    "data-name": "Ligne 16",
                                    x1: "5.04",
                                    transform: "translate(0 12.077)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_17",
                                    "data-name": "Ligne 17",
                                    x2: "0.004",
                                    y2: "8.475",
                                    transform: "translate(5.99 6.057) rotate(45)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                            id: "Groupe_844",
                            "data-name": "Groupe 844",
                            transform: "translate(9.162 -7.493)",
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_15-2",
                                    "data-name": "Ligne 15",
                                    y2: "5.002",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_16-2",
                                    "data-name": "Ligne 16",
                                    x1: "5.067",
                                    transform: "translate(0 12.033)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_17-2",
                                    "data-name": "Ligne 17",
                                    x1: "0.046",
                                    y2: "8.463",
                                    transform: "translate(5.984 6.024) rotate(45)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
    else // return (
    //   <svg
    //     xmlns='http://www.w3.org/2000/svg'
    //     className={className || 'rf-h-6 rf-w-6'}
    //     fill='none'
    //     viewBox='0 0 24 24'
    //     stroke={color || 'currentColor'}
    //     strokeWidth={2}
    //   >
    //     <path
    //       strokeLinecap='round'
    //       strokeLinejoin='round'
    //       d='M6 18L18 6M6 6l12 12'
    //     />
    //   </svg>
    // )
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20.018",
        height: "19.358",
        viewBox: "0 0 20.018 19.358",
        className: className || "rf-h-6 rf-w-6",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
            id: "Groupe_841",
            "data-name": "Groupe 841",
            transform: "translate(3.415 3.891)",
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("g", {
                id: "PICTO",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                    id: "Groupe_845",
                    "data-name": "Groupe 845",
                    transform: "translate(0.003 -1)",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                            id: "Groupe_843",
                            "data-name": "Groupe 843",
                            transform: "translate(-2 3)",
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_15",
                                    "data-name": "Ligne 15",
                                    y2: "5.046",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_16",
                                    "data-name": "Ligne 16",
                                    x1: "5.04",
                                    transform: "translate(0 12.077)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_17",
                                    "data-name": "Ligne 17",
                                    x2: "0.004",
                                    y2: "8.475",
                                    transform: "translate(5.99 6.057) rotate(45)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("g", {
                            id: "Groupe_844",
                            "data-name": "Groupe 844",
                            transform: "translate(15.178 10.572) rotate(180)",
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_15-2",
                                    "data-name": "Ligne 15",
                                    y2: "5.002",
                                    transform: "translate(0 7.031)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_16-2",
                                    "data-name": "Ligne 16",
                                    x1: "5.067",
                                    transform: "translate(0 12.033)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("line", {
                                    id: "Ligne_17-2",
                                    "data-name": "Ligne 17",
                                    x1: "0.046",
                                    y2: "8.463",
                                    transform: "translate(5.984 6.024) rotate(45)",
                                    fill: "none",
                                    stroke: color || "currentColor",
                                    strokeLinecap: "round",
                                    strokeWidth: "2"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $6e9da30149e4e457$export$2e2bcd8739ae039 = $6e9da30149e4e457$var$ExtendIcon;


const $0d2b168c17a6d625$var$HomeView = ({ chatbotData: chatbotData, externalComponents: externalComponents })=>{
    const displayChangeLayoutButton = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.allowSwitchLayout);
    const currentLayout = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.currentLayout);
    const loaderClosed = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.loaderClosed);
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const configurations = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.configurations);
    const displayAgent = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.displayAgent);
    const displayData = (0, $lT7pJ.useMemo)(()=>{
        return configurations.views.home;
    }, [
        configurations
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $1c9be018817ca3e3$export$5d6d98eff8e04581)(!configuration.hideControls);
    }, []);
    const extendButtonHandler = ()=>{
        (0, $7c69764370dcab43$export$e8437af1f2483b8e)((0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget);
        (0, $079f3ffaa96f1faa$export$a1c83309c736819f)();
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            !!displayChangeLayoutButton && currentLayout !== (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                onClick: extendButtonHandler,
                "aria-label": "Minimize",
                className: "rf-absolute rf-z-exitwidget rf-flex rf-right-1 rf-top-1 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6e9da30149e4e457$export$2e2bcd8739ae039), {
                    className: "rf-h-4 rf-w-4",
                    color: "#000000",
                    extended: true
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $9601c14c689c9e72$export$2e2bcd8739ae039), {
                config: displayData.background
            }),
            configuration?.logo && (!isMobile || isMobile && mode !== (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $39f3e48cc7ad4ecb$export$2e2bcd8739ae039), {}),
            (!isMobile || isMobile && mode !== (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text) && chatbotData && displayAgent && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $72e6042966e2e95a$export$2e2bcd8739ae039), {
                className: `rf-relative rf-col-start-1 rf-col-end-9 ${chatbotData.fullWidthInDesktopMode ? "large:rf-col-end-9" : "large:rf-col-end-6"} large-vertical:rf-col-end-9 rf-row-span-full rf-self-end rf-h-full`,
                chatbotData: chatbotData,
                showSubtitles: true
            }),
            configuration?.answerpanel !== false && loaderClosed && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6afb04002d627629$export$2e2bcd8739ae039), {}),
                    mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e2941dbc64a06bc6$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $680a1014cb5a8413$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6679ae60a0fb3580$export$2e2bcd8739ae039), {
                hideMenu: configuration?.hideMenu
            }),
            loaderClosed && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $caa3af5b745c8d74$export$2e2bcd8739ae039), {
                externalComponents: externalComponents
            }),
            !configuration?.hideRetorikLogo && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e0a6053cfc8a3fb0$export$2e2bcd8739ae039), {})
        ]
    });
};
var $0d2b168c17a6d625$export$2e2bcd8739ae039 = $0d2b168c17a6d625$var$HomeView;


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");









var $lT7pJ = parcelRequire("lT7pJ");

const $d0c1e0fb5bc7dcdc$var$Time = ({ belowReturnButton: belowReturnButton })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const [time, setTime] = (0, $lT7pJ.useState)("");
    const timerRef = (0, $lT7pJ.useRef)(null);
    /**
   * Set current time (hours and minutes) depending on the locale (ex: adds AM/PM when needed)
   */ const setCurrentTime = ()=>{
        const now = new Date();
        setTime(now.toLocaleTimeString(locale, {
            hour: "2-digit",
            minute: "2-digit"
        }));
    };
    /**
   * On component mount :
   *  - set time
   *  - set interval for time update
   * On component unmount :
   *  - clear interval
   */ (0, $lT7pJ.useEffect)(()=>{
        setCurrentTime();
        timerRef && (timerRef.current = setInterval(setCurrentTime, 1000));
        return ()=>timerRef && clearInterval(timerRef.current);
    }, []);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-relative ${belowReturnButton ? "rf-ml-4" : "rf-col-start-1 rf-col-span-2 rf-row-start-1 rf-row-span-2 rf-self-start rf-justify-self-start rf-m-4 large:rf-m-8"}`,
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
            className: "rf-w-fit rf-h-fit rf-flex rf-flex-col rf-justify-start rf-items-start rf-text-white",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-w-full rf-text-size-auto rf-px-3 rf-py-0 large:rf-px-4 large:rf-py-1 rf-text-center rf-font-semibold rf-bg-red-600 rf-whitespace-nowrap",
                    children: `${translation.news.live.toLocaleUpperCase(locale)} \u25cf`
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-w-full rf-title-size-auto rf-px-3 rf-py-0 large:rf-px-4 large:rf-py-1 rf-text-center rf-font-bold rf-bg-blue-500",
                    children: time
                })
            ]
        })
    });
};
var $d0c1e0fb5bc7dcdc$export$2e2bcd8739ae039 = $d0c1e0fb5bc7dcdc$var$Time;




var $lT7pJ = parcelRequire("lT7pJ");





const $fca679fc2b72c3a0$var$useNews = ()=>{
    const activities = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.botEventActivities);
    if (!activities.length) return {
        newsAttachments: []
    };
    // Filter messages that can income during news, with label = Davi.BringupMessage
    const filterBringUpActivities = activities.filter((act)=>act.label !== "Davi.BringupMessage");
    const activity = filterBringUpActivities[filterBringUpActivities.length - 1];
    if (!activity || !activity.attachments?.length) return {
        newsAttachments: [],
        activity: activity
    };
    const newsAttachments = [];
    activity.attachments.forEach((attachment)=>{
        if (attachment.contentType === (0, $59de7fd3862e5431$export$7ff82c027074e396)) newsAttachments.push({
            contentType: (0, $59de7fd3862e5431$export$7ff82c027074e396),
            content: attachment.content || ""
        });
    });
    return {
        newsAttachments: newsAttachments,
        activity: activity
    };
};
var $fca679fc2b72c3a0$export$2e2bcd8739ae039 = $fca679fc2b72c3a0$var$useNews;





var $lT7pJ = parcelRequire("lT7pJ");



const $e5b3a8123371ba40$var$Banner = ({ news: news })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const currentWidth = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentWidth);
    const timerRef = (0, $lT7pJ.useRef)(null);
    const [scrollDuration, setScrollDuration] = (0, $lT7pJ.useState)(0);
    const [imageSize, setImageSize] = (0, $lT7pJ.useState)(0);
    const elementRef = (0, $lT7pJ.useRef)(null);
    /**
   * Set animation for text horizontal scrolling if necessary
   */ const updateDuration = ()=>{
        // Reset animation
        setScrollDuration(0);
        // Set animation, after a 1s timeout
        timerRef && (timerRef.current = setTimeout(()=>{
            setScrollDuration(Math.floor(news.text.length / 11));
        }, 1000));
    };
    /**
   * On news props change :
   *  - call updateDuration function
   * On component unmount :
   *  - clear timeout
   */ (0, $lT7pJ.useEffect)(()=>{
        updateDuration();
        return ()=>timerRef && clearTimeout(timerRef.current);
    }, [
        news
    ]);
    /**
   * On ref change :
   *  - set the width of the image container equal to the category container's width
   */ (0, $lT7pJ.useEffect)(()=>{
        elementRef.current && setImageSize(elementRef.current.clientWidth);
    }, [
        elementRef
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-h-fit rf-z-util rf-col-start-1 rf-col-span-full rf-row-start-9 large:rf-row-start-10 rf-row-span-3 large:rf-mb-6 rf-flex rf-flex-col rf-self-end rf-items-center rf-glass-background rf-text-white",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-justify-start rf-text-size-auto",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-px-4 rf-pb-2 rf-pt-2 large:rf-pt-3 rf-font-bold rf-bg-red-600 rf-whitespace-nowrap",
                        ref: elementRef,
                        children: (news.category || translation.news.continuous).toLocaleUpperCase(locale)
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-px-4 rf-mb-2 rf-mt-2 large:rf-mt-3 rf-font-bold rf-line-clamp-1",
                        children: news.title && news.title.toLocaleUpperCase(locale)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-h-fit rf-flex rf-flex-row rf-justify-start",
                children: [
                    isMobile && news.image?.url && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        style: {
                            minWidth: `${imageSize}px`,
                            backgroundImage: `url(${news.image?.url})`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center"
                        }
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-px-4 rf-my-2 large:rf-my-3 rf-title-large-size-auto rf-line-clamp-2",
                        children: news.subtitle ? (0, $0fdc9a557a65290b$export$d07f57595c356899)(news.subtitle) : "..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-pr-4 rf-py-4 rf-subtitle-size-auto rf-text-black rf-bg-white rf-overflow-clip",
                style: {
                    paddingLeft: currentWidth
                },
                children: scrollDuration !== 0 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                    className: "rf-w-max rf-whitespace-nowrap rf-animate-hScroll",
                    style: {
                        animation: `rf-hScroll ${scrollDuration}s infinite linear`,
                        paddingRight: currentWidth
                    },
                    children: news.text ? (0, $0fdc9a557a65290b$export$d07f57595c356899)(news.text) : "..."
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                    className: "rf-w-max rf-whitespace-nowrap",
                    children: news.text ? (0, $0fdc9a557a65290b$export$d07f57595c356899)(news.text) : "..."
                })
            })
        ]
    });
};
var $e5b3a8123371ba40$export$2e2bcd8739ae039 = $e5b3a8123371ba40$var$Banner;



const $03f2de2d8f1d9f13$var$News = ({ intervalInSeconds: intervalInSeconds = 3, onEnd: onEnd, isRetorikNews: isRetorikNews })=>{
    const { newsAttachments: newsAttachments, activity: activity } = (0, $fca679fc2b72c3a0$export$2e2bcd8739ae039)();
    const route = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.route);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const retorikNewsEnded = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.retorikNewsEnded);
    const news = (0, $lT7pJ.useMemo)(()=>{
        return newsAttachments.map((newsAttachement)=>newsAttachement.content);
    }, [
        newsAttachments
    ]);
    const [current, setCurrent] = (0, $lT7pJ.useState)(0);
    const timerRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        if (!newsAttachments.length) setTimeout(()=>{
            (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("news.getAllNews", null);
        }, 2000);
        return ()=>{
            timerRef && clearTimeout(timerRef.current);
        };
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        const currentNew = news[current];
        if (currentNew) {
            const tempActivity = {
                ...activity,
                speak: `${currentNew.title}, <break/> ${currentNew.subtitle}: <break/> ${currentNew.text}`
            };
            (0, $1bda010252da638c$export$b5caa30733bcf64f)(tempActivity);
        } else (0, $1bda010252da638c$export$b5caa30733bcf64f)(undefined);
    }, [
        activity,
        current
    ]);
    const currentMedia = (0, $lT7pJ.useMemo)(()=>{
        const currentNew = news[current];
        if (currentNew) {
            if (currentNew.media && currentNew.media.length > 0) return currentNew.media;
            else if (currentNew.image && currentNew.image.url) return [
                currentNew.image
            ];
        }
        return [];
    }, [
        news,
        current
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (retorikNewsEnded) {
            if (news.length > 0) {
                if (current < news.length - 1) {
                    const delay = current < news.length - 1 ? intervalInSeconds : intervalInSeconds * 3;
                    timerRef && clearTimeout(timerRef.current);
                    if (route === (0, $45d43a6de0968f42$export$3565eb3d00ca5a74).News || isRetorikNews) timerRef.current = setTimeout(next, delay * 1000);
                } else onEnd();
            }
            (0, $1bda010252da638c$export$f052bdc826bb4a9e)(false);
        }
    }, [
        retorikNewsEnded
    ]);
    const next = ()=>{
        const next = (current + 1) % news.length;
        changeNews(next);
    };
    const changeNews = (next)=>{
        setCurrent(next);
    };
    return news.length > 0 && current >= 0 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            !isMobile && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-relative rf-col-start-5 rf-col-span-3 rf-row-start-1 rf-row-span-9 large-vertical:rf-col-start-2 large-vertical:rf-col-end-8 large-vertical:rf-row-start-7 large-vertical:rf-row-end-11 rf-flex rf-justify-center rf-items-center",
                children: currentMedia.length > 0 && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $04a0ad14abdfdd87$export$2e2bcd8739ae039), {
                    className: "rf-max-h-4/5 large-vertical:rf-max-h-11/12 rf-max-w-full",
                    medias: news[current].media || [
                        news[current].image || {
                            url: ""
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e5b3a8123371ba40$export$2e2bcd8739ae039), {
                news: news[current]
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $03f2de2d8f1d9f13$export$2e2bcd8739ae039 = $03f2de2d8f1d9f13$var$News;






var $956e6b3bccf15e5e$var$Steps;
// Steps enum
(function($956e6b3bccf15e5e$var$Steps) {
    $956e6b3bccf15e5e$var$Steps[$956e6b3bccf15e5e$var$Steps["opening"] = 1] = "opening";
    $956e6b3bccf15e5e$var$Steps[$956e6b3bccf15e5e$var$Steps["news"] = 2] = "news";
    $956e6b3bccf15e5e$var$Steps[$956e6b3bccf15e5e$var$Steps["events"] = 3] = "events";
    $956e6b3bccf15e5e$var$Steps[$956e6b3bccf15e5e$var$Steps["weather"] = 4] = "weather";
    $956e6b3bccf15e5e$var$Steps[$956e6b3bccf15e5e$var$Steps["ending"] = 5] = "ending";
})($956e6b3bccf15e5e$var$Steps || ($956e6b3bccf15e5e$var$Steps = {}));
const $956e6b3bccf15e5e$var$NewsView = ({ chatbotData: chatbotData, hideMenu: hideMenu, isRetorikNews: isRetorikNews, handleEndedWithoutloop: handleEndedWithoutloop })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const configuration = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration);
    const agentData = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.agentData);
    const muted = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.muted);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const configurations = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.configurations);
    const [displayData, setDisplayData] = (0, $lT7pJ.useState)(configurations.views.news || configurations.views.home);
    const [step, setStep] = (0, $lT7pJ.useState)(configurations.views.news?.openingVideo ? 1 : 2);
    const timerRef = (0, $lT7pJ.useRef)(null);
    const newsEndedTimerRef = (0, $lT7pJ.useRef)(null);
    /**
   * On call :
   *  - if the component is news-only, return
   *  - else set ViewContext's route state to 'home'
   */ const handleBack = ()=>{
        if (isRetorikNews) return;
        (0, $1c9be018817ca3e3$export$2115da3e844dc899)((0, $45d43a6de0968f42$export$3565eb3d00ca5a74).Home);
    };
    (0, $lT7pJ.useEffect)(()=>{
        (0, $1c9be018817ca3e3$export$5d6d98eff8e04581)(false);
        muted && (0, $b8685bd729fa723f$export$a1680ba91cc9be33)(false);
        return ()=>{
            // Send closing events unless we are using RetorikNews component
            if (!isRetorikNews) {
                (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindow", null);
                (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindowNews", null);
            }
        };
    }, []);
    /**
   * On step change :
   *  - switch on the current step to launch corresponding processing
   * On component unmount :
   *  - clear timerRef timeout
   */ (0, $lT7pJ.useEffect)(()=>{
        switch(step){
            case 1:
                {
                    const videoUrl = configurations.views.news?.openingVideo;
                    videoUrl ? setViewContextCurrentConfiguration(videoUrl) : setStep(2);
                    break;
                }
            case 2:
                setDisplayData(configurations.views.news || configurations.views.home);
                break;
            case 3:
                break;
            case 4:
                // If the position is known, display the weather page during 10 seconds, otherwise switch to the next step directly
                configuration.position?.latitude && configuration.position?.longitude ? timerRef.current = setTimeout(()=>{
                    setStep(5);
                }, 10000) : setStep(5);
                break;
            case 5:
                {
                    const videoUrl = configurations.views.news?.openingVideo;
                    videoUrl ? setViewContextCurrentConfiguration(videoUrl) : exitNewsOrLoop();
                    break;
                }
            default:
                break;
        }
        return ()=>{
            timerRef && clearTimeout(timerRef.current);
            newsEndedTimerRef && clearTimeout(newsEndedTimerRef.current);
        };
    }, [
        step
    ]);
    /**
   * On call :
   *  - set the current display configuration to have the given video as background
   * @param videoUrl
   */ const setViewContextCurrentConfiguration = (videoUrl)=>{
        setDisplayData({
            ...configurations.views.news,
            background: {
                video: videoUrl,
                style: "video",
                blur: 0
            }
        });
    };
    /**
   * On call :
   *  - send the event 'newsEnded' used in retorik Kiosk
   *  - if the component is news-only :
   *    + if 'loop' is explicitly set to false, call props' handleEndedWithoutloop method if defined. Call handleBack method otherwise
   *    + if 'loop' is not false, loop by setting step state to Steps.news
   *  - or else if 'loop' parameter in configuration is true, get back to Steps.news step. Call handleBack method otherwise
   */ const exitNewsOrLoop = ()=>{
        // Send event 'newsEnded'
        const endEvent = new Event("newsEnded");
        document.dispatchEvent(endEvent);
        // Relaunch from the start if this is a news-only component and loop hasn't explicitly been set to false
        isRetorikNews ? displayData.loop !== false ? setStep(2) : handleEndedWithoutloop ? handleEndedWithoutloop() : handleBack() : displayData.loop ? setStep(2) : handleBack();
    };
    /**
   * On video end :
   *  - if we are at the opening step, let's set the step state to Steps.news to launch the news
   *  - if we are at the ending step, call exitNewsOrLoop function
   */ const handleVideoEnd = ()=>{
        switch(step){
            case 1:
                setStep(2);
                break;
            case 5:
                exitNewsOrLoop();
                break;
        }
    };
    /**
   * On news end :
   *  - wait 3 seconds
   *  - get to the next step (Steps.events)
   */ const handleNewsEnd = ()=>{
        newsEndedTimerRef && (newsEndedTimerRef.current = setTimeout(()=>{
            // setStep(Steps.events)
            setStep(4);
        }, 3000));
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $9601c14c689c9e72$export$2e2bcd8739ae039), {
                config: displayData.background,
                videoLoop: false,
                videoMuted: true,
                onVideoEnded: handleVideoEnd
            }),
            isMobile && !isRetorikNews && !hideMenu ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-relative rf-z-util rf-col-start-1 rf-col-span-full rf-row-start-1 rf-flex rf-flex-col rf-gap-2 rf-items-start",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                        title: translation.common.back,
                        handleBack: handleBack,
                        className: "rf-pr-2 rf-mt-4 rf-ml-4 rf-text-size-auto rf-bg-truewhite rf-rounded-lg"
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d0c1e0fb5bc7dcdc$export$2e2bcd8739ae039), {
                        belowReturnButton: true
                    })
                ]
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d0c1e0fb5bc7dcdc$export$2e2bcd8739ae039), {}),
            step === 2 && agentData && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    chatbotData && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $72e6042966e2e95a$export$2e2bcd8739ae039), {
                        className: "rf-relative rf-col-start-1 rf-col-end-9 large:rf-col-end-6 large-vertical:rf-col-end-9 rf-row-span-full rf-self-end rf-h-full",
                        chatbotData: chatbotData
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $03f2de2d8f1d9f13$export$2e2bcd8739ae039), {
                        intervalInSeconds: displayData.intervalInSeconds ? displayData.intervalInSeconds : undefined,
                        onEnd: handleNewsEnd,
                        isRetorikNews: isRetorikNews
                    })
                ]
            }),
            step === 4 && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $017178f22f9ef2d1$export$2e2bcd8739ae039), {
                handleClose: handleBack
            }),
            !hideMenu && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $861fac448a37f7dd$export$2e2bcd8739ae039), {
                dashboardVisible: true,
                onClick: handleBack
            })
        ]
    });
};
var $956e6b3bccf15e5e$export$2e2bcd8739ae039 = $956e6b3bccf15e5e$var$NewsView;




var $lT7pJ = parcelRequire("lT7pJ");






const $47e61667139d24d2$var$WarningBeforeNewsView = ({ propsToTransfer: propsToTransfer })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const [waiting, setWaiting] = (0, $lT7pJ.useState)(true);
    const handleClick = (goHome)=>{
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindow", null);
        (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)("Davi.CloseWindowNewsSoundActivated", null);
        goHome ? (0, $1c9be018817ca3e3$export$2115da3e844dc899)((0, $45d43a6de0968f42$export$3565eb3d00ca5a74).Home) : setWaiting(false);
    };
    return waiting ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-relative rf-z-util rf-col-start-1 rf-col-span-full rf-row-start-1 rf-row-span-full rf-flex rf-flex-col rf-gap-4 rf-justify-center rf-items-center rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $50f60202d3acc5ad$export$2e2bcd8739ae039), {
                title: translation.common.back,
                handleBack: ()=>handleClick(true),
                className: "rf-absolute rf-top-4 rf-left-4 rf-text-size-auto"
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                className: "rf-px-4 rf-text-center",
                children: translation.news.warningtext
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                className: "rf-card-button-secondary",
                onClick: ()=>handleClick(false),
                children: translation.common.continue
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                className: "rf-card-button-secondary",
                onClick: ()=>handleClick(true),
                children: translation.common.back
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $956e6b3bccf15e5e$export$2e2bcd8739ae039), {
        ...propsToTransfer
    });
};
var $47e61667139d24d2$export$2e2bcd8739ae039 = $47e61667139d24d2$var$WarningBeforeNewsView;


const $7468a650f7bdb7fd$var$RetorikRouter = (props)=>{
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.isUsedOnBorne);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const route = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.route);
    const lastBotEvent = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.lastBotEventActivity);
    (0, $lT7pJ.useEffect)(()=>{
        if (lastBotEvent) switch(lastBotEvent.name){
            case "news.ShowFlashInfo":
                (0, $1c9be018817ca3e3$export$2115da3e844dc899)((0, $45d43a6de0968f42$export$3565eb3d00ca5a74).News);
                break;
            case "weather.ShowWeather":
                (0, $1bda010252da638c$export$f0c096b4ecd7115d)((0, $45d43a6de0968f42$export$f05d0fed0593ead7).weather);
                break;
            default:
                break;
        }
    }, [
        lastBotEvent
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            route === (0, $45d43a6de0968f42$export$3565eb3d00ca5a74).Home && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $0d2b168c17a6d625$export$2e2bcd8739ae039), {
                ...props
            }),
            route === (0, $45d43a6de0968f42$export$3565eb3d00ca5a74).News && (mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal || !!isUsedOnBorne ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $956e6b3bccf15e5e$export$2e2bcd8739ae039), {
                ...props
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $47e61667139d24d2$export$2e2bcd8739ae039), {
                propsToTransfer: props
            }))
        ]
    });
};
var $7468a650f7bdb7fd$export$2e2bcd8739ae039 = $7468a650f7bdb7fd$var$RetorikRouter;




var $lT7pJ = parcelRequire("lT7pJ");
var $673e90b4fbb753dd$exports = {};
"use strict";
Object.defineProperty($673e90b4fbb753dd$exports, "__esModule", {
    value: true
});
function $673e90b4fbb753dd$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $lT7pJ = parcelRequire("lT7pJ");
var $673e90b4fbb753dd$var$React__default = $673e90b4fbb753dd$var$_interopDefault($lT7pJ);

var $iEwv0 = parcelRequire("iEwv0");
var $673e90b4fbb753dd$var$ClientUAInstance = new $iEwv0();
var $673e90b4fbb753dd$var$browser = $673e90b4fbb753dd$var$ClientUAInstance.getBrowser();
var $673e90b4fbb753dd$var$cpu = $673e90b4fbb753dd$var$ClientUAInstance.getCPU();
var $673e90b4fbb753dd$var$device = $673e90b4fbb753dd$var$ClientUAInstance.getDevice();
var $673e90b4fbb753dd$var$engine = $673e90b4fbb753dd$var$ClientUAInstance.getEngine();
var $673e90b4fbb753dd$var$os = $673e90b4fbb753dd$var$ClientUAInstance.getOS();
var $673e90b4fbb753dd$var$ua = $673e90b4fbb753dd$var$ClientUAInstance.getUA();
var $673e90b4fbb753dd$var$setUa = function setUa(userAgentString) {
    return $673e90b4fbb753dd$var$ClientUAInstance.setUA(userAgentString);
};
var $673e90b4fbb753dd$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $iEwv0(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $673e90b4fbb753dd$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $673e90b4fbb753dd$var$ClientUAInstance,
    browser: $673e90b4fbb753dd$var$browser,
    cpu: $673e90b4fbb753dd$var$cpu,
    device: $673e90b4fbb753dd$var$device,
    engine: $673e90b4fbb753dd$var$engine,
    os: $673e90b4fbb753dd$var$os,
    ua: $673e90b4fbb753dd$var$ua,
    setUa: $673e90b4fbb753dd$var$setUa,
    parseUserAgent: $673e90b4fbb753dd$var$parseUserAgent
});
function $673e90b4fbb753dd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673e90b4fbb753dd$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673e90b4fbb753dd$var$ownKeys(Object(source), true).forEach(function(key) {
            $673e90b4fbb753dd$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673e90b4fbb753dd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673e90b4fbb753dd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $673e90b4fbb753dd$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $673e90b4fbb753dd$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $673e90b4fbb753dd$var$_typeof(obj);
}
function $673e90b4fbb753dd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $673e90b4fbb753dd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $673e90b4fbb753dd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $673e90b4fbb753dd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $673e90b4fbb753dd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $673e90b4fbb753dd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $673e90b4fbb753dd$var$_extends() {
    $673e90b4fbb753dd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $673e90b4fbb753dd$var$_extends.apply(this, arguments);
}
function $673e90b4fbb753dd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $673e90b4fbb753dd$var$_setPrototypeOf(subClass, superClass);
}
function $673e90b4fbb753dd$var$_getPrototypeOf(o) {
    $673e90b4fbb753dd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $673e90b4fbb753dd$var$_getPrototypeOf(o);
}
function $673e90b4fbb753dd$var$_setPrototypeOf(o, p) {
    $673e90b4fbb753dd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $673e90b4fbb753dd$var$_setPrototypeOf(o, p);
}
function $673e90b4fbb753dd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $673e90b4fbb753dd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $673e90b4fbb753dd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $673e90b4fbb753dd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $673e90b4fbb753dd$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $673e90b4fbb753dd$var$_assertThisInitialized(self);
}
function $673e90b4fbb753dd$var$_slicedToArray(arr, i) {
    return $673e90b4fbb753dd$var$_arrayWithHoles(arr) || $673e90b4fbb753dd$var$_iterableToArrayLimit(arr, i) || $673e90b4fbb753dd$var$_unsupportedIterableToArray(arr, i) || $673e90b4fbb753dd$var$_nonIterableRest();
}
function $673e90b4fbb753dd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $673e90b4fbb753dd$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $673e90b4fbb753dd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $673e90b4fbb753dd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $673e90b4fbb753dd$var$_arrayLikeToArray(o, minLen);
}
function $673e90b4fbb753dd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $673e90b4fbb753dd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $673e90b4fbb753dd$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $673e90b4fbb753dd$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $673e90b4fbb753dd$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $673e90b4fbb753dd$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $673e90b4fbb753dd$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $673e90b4fbb753dd$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $673e90b4fbb753dd$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $673e90b4fbb753dd$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $673e90b4fbb753dd$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $673e90b4fbb753dd$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $673e90b4fbb753dd$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $673e90b4fbb753dd$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $673e90b4fbb753dd$var$InitialDeviceTypes;
    }
};
var $673e90b4fbb753dd$var$setUserAgent = function setUserAgent(userAgent) {
    return $673e90b4fbb753dd$var$setUa(userAgent);
};
var $673e90b4fbb753dd$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $673e90b4fbb753dd$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $673e90b4fbb753dd$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $673e90b4fbb753dd$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $673e90b4fbb753dd$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $673e90b4fbb753dd$var$setDefaults(browser.major),
        browserFullVersion: $673e90b4fbb753dd$var$setDefaults(browser.version),
        browserName: $673e90b4fbb753dd$var$setDefaults(browser.name),
        engineName: $673e90b4fbb753dd$var$setDefaults(engine.name),
        engineVersion: $673e90b4fbb753dd$var$setDefaults(engine.version),
        osName: $673e90b4fbb753dd$var$setDefaults(os.name),
        osVersion: $673e90b4fbb753dd$var$setDefaults(os.version),
        userAgent: $673e90b4fbb753dd$var$setDefaults(ua)
    };
};
var $673e90b4fbb753dd$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $673e90b4fbb753dd$var$_objectSpread2({}, type, {
        vendor: $673e90b4fbb753dd$var$setDefaults(device.vendor),
        model: $673e90b4fbb753dd$var$setDefaults(device.model),
        os: $673e90b4fbb753dd$var$setDefaults(os.name),
        osVersion: $673e90b4fbb753dd$var$setDefaults(os.version),
        ua: $673e90b4fbb753dd$var$setDefaults(ua)
    });
};
var $673e90b4fbb753dd$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $673e90b4fbb753dd$var$setDefaults(engine.name),
        engineVersion: $673e90b4fbb753dd$var$setDefaults(engine.version),
        osName: $673e90b4fbb753dd$var$setDefaults(os.name),
        osVersion: $673e90b4fbb753dd$var$setDefaults(os.version),
        userAgent: $673e90b4fbb753dd$var$setDefaults(ua)
    };
};
var $673e90b4fbb753dd$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $673e90b4fbb753dd$var$setDefaults(engine.name),
        engineVersion: $673e90b4fbb753dd$var$setDefaults(engine.version),
        osName: $673e90b4fbb753dd$var$setDefaults(os.name),
        osVersion: $673e90b4fbb753dd$var$setDefaults(os.version),
        userAgent: $673e90b4fbb753dd$var$setDefaults(ua)
    };
};
var $673e90b4fbb753dd$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $673e90b4fbb753dd$var$setDefaults(engine.name),
        engineVersion: $673e90b4fbb753dd$var$setDefaults(engine.version),
        osName: $673e90b4fbb753dd$var$setDefaults(os.name),
        osVersion: $673e90b4fbb753dd$var$setDefaults(os.version),
        userAgent: $673e90b4fbb753dd$var$setDefaults(ua)
    };
};
var $673e90b4fbb753dd$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $673e90b4fbb753dd$var$setDefaults(device.vendor),
        model: $673e90b4fbb753dd$var$setDefaults(device.model),
        engineName: $673e90b4fbb753dd$var$setDefaults(engine.name),
        engineVersion: $673e90b4fbb753dd$var$setDefaults(engine.version),
        osName: $673e90b4fbb753dd$var$setDefaults(os.name),
        osVersion: $673e90b4fbb753dd$var$setDefaults(os.version),
        userAgent: $673e90b4fbb753dd$var$setDefaults(ua)
    };
};
function $673e90b4fbb753dd$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $673e90b4fbb753dd$var$parseUserAgent(userAgent) : $673e90b4fbb753dd$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $673e90b4fbb753dd$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $673e90b4fbb753dd$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $673e90b4fbb753dd$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $673e90b4fbb753dd$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $673e90b4fbb753dd$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $673e90b4fbb753dd$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $673e90b4fbb753dd$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $673e90b4fbb753dd$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $673e90b4fbb753dd$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $673e90b4fbb753dd$var$DeviceTypes.Mobile;
};
var $673e90b4fbb753dd$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $673e90b4fbb753dd$var$DeviceTypes.Tablet;
};
var $673e90b4fbb753dd$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $673e90b4fbb753dd$var$DeviceTypes.Mobile || type === $673e90b4fbb753dd$var$DeviceTypes.Tablet;
};
var $673e90b4fbb753dd$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $673e90b4fbb753dd$var$DeviceTypes.SmartTv;
};
var $673e90b4fbb753dd$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $673e90b4fbb753dd$var$DeviceTypes.Browser;
};
var $673e90b4fbb753dd$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $673e90b4fbb753dd$var$DeviceTypes.Wearable;
};
var $673e90b4fbb753dd$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $673e90b4fbb753dd$var$DeviceTypes.Console;
};
var $673e90b4fbb753dd$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $673e90b4fbb753dd$var$DeviceTypes.Embedded;
};
var $673e90b4fbb753dd$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $673e90b4fbb753dd$var$setDefaults(vendor);
};
var $673e90b4fbb753dd$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $673e90b4fbb753dd$var$setDefaults(model);
};
var $673e90b4fbb753dd$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $673e90b4fbb753dd$var$setDefaults(type, "browser");
}; // os types
var $673e90b4fbb753dd$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $673e90b4fbb753dd$var$OsTypes.Android;
};
var $673e90b4fbb753dd$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $673e90b4fbb753dd$var$OsTypes.Windows;
};
var $673e90b4fbb753dd$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $673e90b4fbb753dd$var$OsTypes.MAC_OS;
};
var $673e90b4fbb753dd$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $673e90b4fbb753dd$var$OsTypes.WindowsPhone;
};
var $673e90b4fbb753dd$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $673e90b4fbb753dd$var$OsTypes.IOS;
};
var $673e90b4fbb753dd$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $673e90b4fbb753dd$var$setDefaults(version);
};
var $673e90b4fbb753dd$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $673e90b4fbb753dd$var$setDefaults(name);
}; // browser types
var $673e90b4fbb753dd$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.Chrome;
};
var $673e90b4fbb753dd$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.Firefox;
};
var $673e90b4fbb753dd$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.Chromium;
};
var $673e90b4fbb753dd$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.Edge;
};
var $673e90b4fbb753dd$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.Yandex;
};
var $673e90b4fbb753dd$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.Safari || name === $673e90b4fbb753dd$var$BrowserTypes.MobileSafari;
};
var $673e90b4fbb753dd$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.MobileSafari;
};
var $673e90b4fbb753dd$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.Opera;
};
var $673e90b4fbb753dd$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.InternetExplorer || name === $673e90b4fbb753dd$var$BrowserTypes.Ie;
};
var $673e90b4fbb753dd$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.MIUI;
};
var $673e90b4fbb753dd$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $673e90b4fbb753dd$var$BrowserTypes.SamsungBrowser;
};
var $673e90b4fbb753dd$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $673e90b4fbb753dd$var$setDefaults(version);
};
var $673e90b4fbb753dd$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $673e90b4fbb753dd$var$setDefaults(major);
};
var $673e90b4fbb753dd$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $673e90b4fbb753dd$var$setDefaults(name);
}; // engine types
var $673e90b4fbb753dd$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $673e90b4fbb753dd$var$setDefaults(name);
};
var $673e90b4fbb753dd$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $673e90b4fbb753dd$var$setDefaults(version);
};
var $673e90b4fbb753dd$var$isElectronType = function isElectronType() {
    var nav = $673e90b4fbb753dd$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $673e90b4fbb753dd$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $673e90b4fbb753dd$var$getIOS13 = function getIOS13() {
    var nav = $673e90b4fbb753dd$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $673e90b4fbb753dd$var$getIPad13 = function getIPad13() {
    return $673e90b4fbb753dd$var$isIOS13Check("iPad");
};
var $673e90b4fbb753dd$var$getIphone13 = function getIphone13() {
    return $673e90b4fbb753dd$var$isIOS13Check("iPhone");
};
var $673e90b4fbb753dd$var$getIPod13 = function getIPod13() {
    return $673e90b4fbb753dd$var$isIOS13Check("iPod");
};
var $673e90b4fbb753dd$var$getUseragent = function getUseragent(userAg) {
    return $673e90b4fbb753dd$var$setDefaults(userAg);
};
function $673e90b4fbb753dd$var$buildSelectorsObject(options) {
    var _ref = options ? options : $673e90b4fbb753dd$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $673e90b4fbb753dd$var$isSmartTVType(device),
        isConsole: $673e90b4fbb753dd$var$isConsoleType(device),
        isWearable: $673e90b4fbb753dd$var$isWearableType(device),
        isEmbedded: $673e90b4fbb753dd$var$isEmbeddedType(device),
        isMobileSafari: $673e90b4fbb753dd$var$isMobileSafariType(browser) || $673e90b4fbb753dd$var$getIPad13(),
        isChromium: $673e90b4fbb753dd$var$isChromiumType(browser),
        isMobile: $673e90b4fbb753dd$var$isMobileAndTabletType(device) || $673e90b4fbb753dd$var$getIPad13(),
        isMobileOnly: $673e90b4fbb753dd$var$isMobileType(device),
        isTablet: $673e90b4fbb753dd$var$isTabletType(device) || $673e90b4fbb753dd$var$getIPad13(),
        isBrowser: $673e90b4fbb753dd$var$isBrowserType(device),
        isDesktop: $673e90b4fbb753dd$var$isBrowserType(device),
        isAndroid: $673e90b4fbb753dd$var$isAndroidType(os),
        isWinPhone: $673e90b4fbb753dd$var$isWinPhoneType(os),
        isIOS: $673e90b4fbb753dd$var$isIOSType(os) || $673e90b4fbb753dd$var$getIPad13(),
        isChrome: $673e90b4fbb753dd$var$isChromeType(browser),
        isFirefox: $673e90b4fbb753dd$var$isFirefoxType(browser),
        isSafari: $673e90b4fbb753dd$var$isSafariType(browser),
        isOpera: $673e90b4fbb753dd$var$isOperaType(browser),
        isIE: $673e90b4fbb753dd$var$isIEType(browser),
        osVersion: $673e90b4fbb753dd$var$getOsVersion(os),
        osName: $673e90b4fbb753dd$var$getOsName(os),
        fullBrowserVersion: $673e90b4fbb753dd$var$getBrowserFullVersion(browser),
        browserVersion: $673e90b4fbb753dd$var$getBrowserVersion(browser),
        browserName: $673e90b4fbb753dd$var$getBrowserName(browser),
        mobileVendor: $673e90b4fbb753dd$var$getMobileVendor(device),
        mobileModel: $673e90b4fbb753dd$var$getMobileModel(device),
        engineName: $673e90b4fbb753dd$var$getEngineName(engine),
        engineVersion: $673e90b4fbb753dd$var$getEngineVersion(engine),
        getUA: $673e90b4fbb753dd$var$getUseragent(ua),
        isEdge: $673e90b4fbb753dd$var$isEdgeType(browser) || $673e90b4fbb753dd$var$isEdgeChromiumType(ua),
        isYandex: $673e90b4fbb753dd$var$isYandexType(browser),
        deviceType: $673e90b4fbb753dd$var$getDeviceType(device),
        isIOS13: $673e90b4fbb753dd$var$getIOS13(),
        isIPad13: $673e90b4fbb753dd$var$getIPad13(),
        isIPhone13: $673e90b4fbb753dd$var$getIphone13(),
        isIPod13: $673e90b4fbb753dd$var$getIPod13(),
        isElectron: $673e90b4fbb753dd$var$isElectronType(),
        isEdgeChromium: $673e90b4fbb753dd$var$isEdgeChromiumType(ua),
        isLegacyEdge: $673e90b4fbb753dd$var$isEdgeType(browser) && !$673e90b4fbb753dd$var$isEdgeChromiumType(ua),
        isWindows: $673e90b4fbb753dd$var$isWindowsType(os),
        isMacOs: $673e90b4fbb753dd$var$isMacOsType(os),
        isMIUI: $673e90b4fbb753dd$var$isMIUIType(browser),
        isSamsungBrowser: $673e90b4fbb753dd$var$isSamsungBrowserType(browser)
    };
}
var $673e90b4fbb753dd$var$isSmartTV = $673e90b4fbb753dd$var$isSmartTVType($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$isConsole = $673e90b4fbb753dd$var$isConsoleType($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$isWearable = $673e90b4fbb753dd$var$isWearableType($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$isEmbedded = $673e90b4fbb753dd$var$isEmbeddedType($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$isMobileSafari = $673e90b4fbb753dd$var$isMobileSafariType($673e90b4fbb753dd$var$browser) || $673e90b4fbb753dd$var$getIPad13();
var $673e90b4fbb753dd$var$isChromium = $673e90b4fbb753dd$var$isChromiumType($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$isMobile = $673e90b4fbb753dd$var$isMobileAndTabletType($673e90b4fbb753dd$var$device) || $673e90b4fbb753dd$var$getIPad13();
var $673e90b4fbb753dd$var$isMobileOnly = $673e90b4fbb753dd$var$isMobileType($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$isTablet = $673e90b4fbb753dd$var$isTabletType($673e90b4fbb753dd$var$device) || $673e90b4fbb753dd$var$getIPad13();
var $673e90b4fbb753dd$var$isBrowser = $673e90b4fbb753dd$var$isBrowserType($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$isDesktop = $673e90b4fbb753dd$var$isBrowserType($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$isAndroid = $673e90b4fbb753dd$var$isAndroidType($673e90b4fbb753dd$var$os);
var $673e90b4fbb753dd$var$isWinPhone = $673e90b4fbb753dd$var$isWinPhoneType($673e90b4fbb753dd$var$os);
var $673e90b4fbb753dd$var$isIOS = $673e90b4fbb753dd$var$isIOSType($673e90b4fbb753dd$var$os) || $673e90b4fbb753dd$var$getIPad13();
var $673e90b4fbb753dd$var$isChrome = $673e90b4fbb753dd$var$isChromeType($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$isFirefox = $673e90b4fbb753dd$var$isFirefoxType($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$isSafari = $673e90b4fbb753dd$var$isSafariType($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$isOpera = $673e90b4fbb753dd$var$isOperaType($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$isIE = $673e90b4fbb753dd$var$isIEType($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$osVersion = $673e90b4fbb753dd$var$getOsVersion($673e90b4fbb753dd$var$os);
var $673e90b4fbb753dd$var$osName = $673e90b4fbb753dd$var$getOsName($673e90b4fbb753dd$var$os);
var $673e90b4fbb753dd$var$fullBrowserVersion = $673e90b4fbb753dd$var$getBrowserFullVersion($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$browserVersion = $673e90b4fbb753dd$var$getBrowserVersion($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$browserName = $673e90b4fbb753dd$var$getBrowserName($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$mobileVendor = $673e90b4fbb753dd$var$getMobileVendor($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$mobileModel = $673e90b4fbb753dd$var$getMobileModel($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$engineName = $673e90b4fbb753dd$var$getEngineName($673e90b4fbb753dd$var$engine);
var $673e90b4fbb753dd$var$engineVersion = $673e90b4fbb753dd$var$getEngineVersion($673e90b4fbb753dd$var$engine);
var $673e90b4fbb753dd$var$getUA = $673e90b4fbb753dd$var$getUseragent($673e90b4fbb753dd$var$ua);
var $673e90b4fbb753dd$var$isEdge = $673e90b4fbb753dd$var$isEdgeType($673e90b4fbb753dd$var$browser) || $673e90b4fbb753dd$var$isEdgeChromiumType($673e90b4fbb753dd$var$ua);
var $673e90b4fbb753dd$var$isYandex = $673e90b4fbb753dd$var$isYandexType($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$deviceType = $673e90b4fbb753dd$var$getDeviceType($673e90b4fbb753dd$var$device);
var $673e90b4fbb753dd$var$isIOS13 = $673e90b4fbb753dd$var$getIOS13();
var $673e90b4fbb753dd$var$isIPad13 = $673e90b4fbb753dd$var$getIPad13();
var $673e90b4fbb753dd$var$isIPhone13 = $673e90b4fbb753dd$var$getIphone13();
var $673e90b4fbb753dd$var$isIPod13 = $673e90b4fbb753dd$var$getIPod13();
var $673e90b4fbb753dd$var$isElectron = $673e90b4fbb753dd$var$isElectronType();
var $673e90b4fbb753dd$var$isEdgeChromium = $673e90b4fbb753dd$var$isEdgeChromiumType($673e90b4fbb753dd$var$ua);
var $673e90b4fbb753dd$var$isLegacyEdge = $673e90b4fbb753dd$var$isEdgeType($673e90b4fbb753dd$var$browser) && !$673e90b4fbb753dd$var$isEdgeChromiumType($673e90b4fbb753dd$var$ua);
var $673e90b4fbb753dd$var$isWindows = $673e90b4fbb753dd$var$isWindowsType($673e90b4fbb753dd$var$os);
var $673e90b4fbb753dd$var$isMacOs = $673e90b4fbb753dd$var$isMacOsType($673e90b4fbb753dd$var$os);
var $673e90b4fbb753dd$var$isMIUI = $673e90b4fbb753dd$var$isMIUIType($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$isSamsungBrowser = $673e90b4fbb753dd$var$isSamsungBrowserType($673e90b4fbb753dd$var$browser);
var $673e90b4fbb753dd$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $673e90b4fbb753dd$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $673e90b4fbb753dd$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $673e90b4fbb753dd$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isAndroid ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isBrowser ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isIE ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isIOS ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isMobile ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isTablet ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isWinPhone ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $673e90b4fbb753dd$var$isMobileOnly ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isSmartTV ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isConsole ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $673e90b4fbb753dd$var$isWearable ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
var $673e90b4fbb753dd$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $673e90b4fbb753dd$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $673e90b4fbb753dd$var$React__default.createElement($lT7pJ.Fragment, null, children) : $673e90b4fbb753dd$var$React__default.createElement("div", props, children) : null;
};
function $673e90b4fbb753dd$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $673e90b4fbb753dd$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $673e90b4fbb753dd$var$_classCallCheck(this, _class);
            _this = $673e90b4fbb753dd$var$_possibleConstructorReturn(this, $673e90b4fbb753dd$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($673e90b4fbb753dd$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($673e90b4fbb753dd$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($673e90b4fbb753dd$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $673e90b4fbb753dd$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $673e90b4fbb753dd$var$_typeof(window)) !== undefined && $673e90b4fbb753dd$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $673e90b4fbb753dd$var$React__default.createElement(WrappedComponent, $673e90b4fbb753dd$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($673e90b4fbb753dd$var$React__default.Component);
}
function $673e90b4fbb753dd$var$useMobileOrientation() {
    var _useState = $lT7pJ.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $673e90b4fbb753dd$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $lT7pJ.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $lT7pJ.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $673e90b4fbb753dd$var$_typeof(window)) !== undefined && $673e90b4fbb753dd$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $673e90b4fbb753dd$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $673e90b4fbb753dd$var$parseUserAgent(hookUserAgent);
}
function $673e90b4fbb753dd$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $673e90b4fbb753dd$var$useDeviceData(hookUserAgent);
    var selectors = $673e90b4fbb753dd$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$673e90b4fbb753dd$exports.AndroidView = $673e90b4fbb753dd$var$AndroidView;
$673e90b4fbb753dd$exports.BrowserTypes = $673e90b4fbb753dd$var$BrowserTypes;
$673e90b4fbb753dd$exports.BrowserView = $673e90b4fbb753dd$var$BrowserView;
$673e90b4fbb753dd$exports.ConsoleView = $673e90b4fbb753dd$var$ConsoleView;
$673e90b4fbb753dd$exports.CustomView = $673e90b4fbb753dd$var$CustomView;
$673e90b4fbb753dd$exports.IEView = $673e90b4fbb753dd$var$IEView;
$673e90b4fbb753dd$exports.IOSView = $673e90b4fbb753dd$var$IOSView;
$673e90b4fbb753dd$exports.MobileOnlyView = $673e90b4fbb753dd$var$MobileOnlyView;
$673e90b4fbb753dd$exports.MobileView = $673e90b4fbb753dd$var$MobileView;
$673e90b4fbb753dd$exports.OsTypes = $673e90b4fbb753dd$var$OsTypes;
$673e90b4fbb753dd$exports.SmartTVView = $673e90b4fbb753dd$var$SmartTVView;
$673e90b4fbb753dd$exports.TabletView = $673e90b4fbb753dd$var$TabletView;
$673e90b4fbb753dd$exports.WearableView = $673e90b4fbb753dd$var$WearableView;
$673e90b4fbb753dd$exports.WinPhoneView = $673e90b4fbb753dd$var$WinPhoneView;
$673e90b4fbb753dd$exports.browserName = $673e90b4fbb753dd$var$browserName;
$673e90b4fbb753dd$exports.browserVersion = $673e90b4fbb753dd$var$browserVersion;
$673e90b4fbb753dd$exports.deviceDetect = $673e90b4fbb753dd$var$deviceDetect;
$673e90b4fbb753dd$exports.deviceType = $673e90b4fbb753dd$var$deviceType;
$673e90b4fbb753dd$exports.engineName = $673e90b4fbb753dd$var$engineName;
$673e90b4fbb753dd$exports.engineVersion = $673e90b4fbb753dd$var$engineVersion;
$673e90b4fbb753dd$exports.fullBrowserVersion = $673e90b4fbb753dd$var$fullBrowserVersion;
$673e90b4fbb753dd$exports.getSelectorsByUserAgent = $673e90b4fbb753dd$var$getSelectorsByUserAgent;
$673e90b4fbb753dd$exports.getUA = $673e90b4fbb753dd$var$getUA;
$673e90b4fbb753dd$exports.isAndroid = $673e90b4fbb753dd$var$isAndroid;
$673e90b4fbb753dd$exports.isBrowser = $673e90b4fbb753dd$var$isBrowser;
$673e90b4fbb753dd$exports.isChrome = $673e90b4fbb753dd$var$isChrome;
$673e90b4fbb753dd$exports.isChromium = $673e90b4fbb753dd$var$isChromium;
$673e90b4fbb753dd$exports.isConsole = $673e90b4fbb753dd$var$isConsole;
$673e90b4fbb753dd$exports.isDesktop = $673e90b4fbb753dd$var$isDesktop;
$673e90b4fbb753dd$exports.isEdge = $673e90b4fbb753dd$var$isEdge;
$673e90b4fbb753dd$exports.isEdgeChromium = $673e90b4fbb753dd$var$isEdgeChromium;
$673e90b4fbb753dd$exports.isElectron = $673e90b4fbb753dd$var$isElectron;
$673e90b4fbb753dd$exports.isEmbedded = $673e90b4fbb753dd$var$isEmbedded;
$673e90b4fbb753dd$exports.isFirefox = $673e90b4fbb753dd$var$isFirefox;
$673e90b4fbb753dd$exports.isIE = $673e90b4fbb753dd$var$isIE;
$673e90b4fbb753dd$exports.isIOS = $673e90b4fbb753dd$var$isIOS;
$673e90b4fbb753dd$exports.isIOS13 = $673e90b4fbb753dd$var$isIOS13;
$673e90b4fbb753dd$exports.isIPad13 = $673e90b4fbb753dd$var$isIPad13;
$673e90b4fbb753dd$exports.isIPhone13 = $673e90b4fbb753dd$var$isIPhone13;
$673e90b4fbb753dd$exports.isIPod13 = $673e90b4fbb753dd$var$isIPod13;
$673e90b4fbb753dd$exports.isLegacyEdge = $673e90b4fbb753dd$var$isLegacyEdge;
$673e90b4fbb753dd$exports.isMIUI = $673e90b4fbb753dd$var$isMIUI;
$673e90b4fbb753dd$exports.isMacOs = $673e90b4fbb753dd$var$isMacOs;
$673e90b4fbb753dd$exports.isMobile = $673e90b4fbb753dd$var$isMobile;
$673e90b4fbb753dd$exports.isMobileOnly = $673e90b4fbb753dd$var$isMobileOnly;
$673e90b4fbb753dd$exports.isMobileSafari = $673e90b4fbb753dd$var$isMobileSafari;
$673e90b4fbb753dd$exports.isOpera = $673e90b4fbb753dd$var$isOpera;
$673e90b4fbb753dd$exports.isSafari = $673e90b4fbb753dd$var$isSafari;
$673e90b4fbb753dd$exports.isSamsungBrowser = $673e90b4fbb753dd$var$isSamsungBrowser;
$673e90b4fbb753dd$exports.isSmartTV = $673e90b4fbb753dd$var$isSmartTV;
$673e90b4fbb753dd$exports.isTablet = $673e90b4fbb753dd$var$isTablet;
$673e90b4fbb753dd$exports.isWearable = $673e90b4fbb753dd$var$isWearable;
$673e90b4fbb753dd$exports.isWinPhone = $673e90b4fbb753dd$var$isWinPhone;
$673e90b4fbb753dd$exports.isWindows = $673e90b4fbb753dd$var$isWindows;
$673e90b4fbb753dd$exports.isYandex = $673e90b4fbb753dd$var$isYandex;
$673e90b4fbb753dd$exports.mobileModel = $673e90b4fbb753dd$var$mobileModel;
$673e90b4fbb753dd$exports.mobileVendor = $673e90b4fbb753dd$var$mobileVendor;
$673e90b4fbb753dd$exports.osName = $673e90b4fbb753dd$var$osName;
$673e90b4fbb753dd$exports.osVersion = $673e90b4fbb753dd$var$osVersion;
$673e90b4fbb753dd$exports.parseUserAgent = $673e90b4fbb753dd$var$parseUserAgent;
$673e90b4fbb753dd$exports.setUserAgent = $673e90b4fbb753dd$var$setUserAgent;
$673e90b4fbb753dd$exports.useDeviceData = $673e90b4fbb753dd$var$useDeviceData;
$673e90b4fbb753dd$exports.useDeviceSelectors = $673e90b4fbb753dd$var$useDeviceSelectors;
$673e90b4fbb753dd$exports.useMobileOrientation = $673e90b4fbb753dd$var$useMobileOrientation;
$673e90b4fbb753dd$exports.withOrientationChange = $673e90b4fbb753dd$var$withOrientationChange;












var $lT7pJ = parcelRequire("lT7pJ");

const $5d54cea5a2c4b61b$var$ModalFullscreen = ()=>{
    const content = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.modalFullscreenContent);
    const handleClick = (event)=>{
        event?.stopPropagation();
    };
    return content ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-absolute rf-z-modal rf-h-full rf-w-full rf-flex rf-flex-col rf-justify-center rf-items-center",
        style: {
            background: "rgba(18,18,18,0.7)"
        },
        onClick: (event)=>handleClick(event),
        children: content
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $5d54cea5a2c4b61b$export$2e2bcd8739ae039 = $5d54cea5a2c4b61b$var$ModalFullscreen;


const $88d8d174fc7cb1a7$var$Container = ({ fullSize: fullSize, width: width, height: height, children: children, parent: parent })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const isTactile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isTactile);
    const doNotDetectDeviceFromUserAgent = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.doNotDetectDeviceFromUserAgent);
    const forceMobileView = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.forceMobileView);
    const container = (0, $lT7pJ.useRef)(null);
    const dimensions = (0, $57fa40eeebe37d0d$export$2e2bcd8739ae039)(container);
    const [portrait, setPortrait] = (0, $lT7pJ.useState)("");
    const [large, setLarge] = (0, $lT7pJ.useState)("");
    // Call useCurrentPagination to update data sent to store. Do not remove
    const pagination = (0, $c134542dee0be23e$export$2e2bcd8739ae039)();
    const widthStyle = (0, $lT7pJ.useMemo)(()=>{
        if (typeof width === "number") return {
            width: `${width}px`
        };
        else if (typeof width === "string") return {
            width: width === "full" ? "100%" : width
        };
        return {};
    }, [
        width
    ]);
    const heightStyle = (0, $lT7pJ.useMemo)(()=>{
        if (currentDeviceType === (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile) return {
            height: window.innerHeight,
            minHeight: window.innerHeight,
            maxHeight: window.innerHeight
        };
        else if (typeof height === "number") return {
            height: `${height}px`
        };
        else if (typeof height === "string") return height === "full" ? {
            height: "100%",
            flexGrow: 1
        } : {
            height: height
        };
        return {};
    }, [
        height,
        currentDeviceType
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $0aecf0c32f1a48e0$export$fbb15aa7bdda31c9)(pagination);
    }, [
        pagination
    ]);
    const checkPortrait = (width, height)=>{
        if (width && height && width < height) setPortrait("rf-portrait");
        else {
            setPortrait("");
            return false;
        }
        return true;
    };
    /**
   * On dimensions change :
   *  - check and set the classes in the main div that will allow us to use tailwind variants
   *  - set the main div dimensions in context
   */ (0, $lT7pJ.useEffect)(()=>{
        if (forceMobileView) {
            setLarge("");
            (0, $1c9be018817ca3e3$export$1ae69652bfc21d9e)((0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile);
            setPortrait("rf-portrait");
        } else if (dimensions?.width && dimensions?.height) {
            // If we don't want to use the userAgent to get the device type
            if (doNotDetectDeviceFromUserAgent) {
                const isPortrait = checkPortrait(dimensions.width, dimensions.height);
                if (isPortrait) {
                    if (dimensions.width > (0, $bbe458fac496c294$export$2e65b7c7134e01f0)) {
                        setLarge("rf-large");
                        (0, $1c9be018817ca3e3$export$1ae69652bfc21d9e)(parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetBorne : (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).borne);
                    } else {
                        setLarge("");
                        (0, $1c9be018817ca3e3$export$1ae69652bfc21d9e)(parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget : (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile);
                    }
                } else if (dimensions.height > (0, $bbe458fac496c294$export$2e65b7c7134e01f0)) {
                    setLarge("rf-large");
                    (0, $1c9be018817ca3e3$export$1ae69652bfc21d9e)(parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetLandscape : (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).landscape);
                } else {
                    setLarge("");
                    (0, $1c9be018817ca3e3$export$1ae69652bfc21d9e)(parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget : (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile);
                }
            } else if (0, $673e90b4fbb753dd$exports.isMobile) {
                setPortrait("rf-portrait");
                setLarge("");
                (0, $1c9be018817ca3e3$export$1ae69652bfc21d9e)(parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget : (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).mobile);
            } else {
                const isPortrait = checkPortrait(dimensions.width, dimensions.height);
                // Check for 'rf-large' class
                setLarge(parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget && dimensions.width < (0, $bbe458fac496c294$export$2e65b7c7134e01f0) ? "" : "rf-large");
                if (isPortrait) (0, $1c9be018817ca3e3$export$1ae69652bfc21d9e)(parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? dimensions.width > (0, $bbe458fac496c294$export$2e65b7c7134e01f0) ? (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetBorne : (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widget : (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).borne);
                else (0, $1c9be018817ca3e3$export$1ae69652bfc21d9e)(parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).widgetLandscape : (0, $45d43a6de0968f42$export$ec1e04e4e5ef8233).landscape);
            }
        }
        dimensions?.height && (0, $1c9be018817ca3e3$export$7543d510ab87805c)(dimensions.height);
        dimensions?.width && (0, $1c9be018817ca3e3$export$98fe782f0784b2c2)(dimensions.width);
    }, [
        dimensions
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        container?.current && (0, $bbe458fac496c294$export$909f4c209eb70365).includes(currentDeviceType) && (0, $b5fe10956c349963$export$2e2bcd8739ae039)(container.current);
    }, [
        container.current
    ]);
    const customColors = (0, $lT7pJ.useMemo)(()=>{
        return themeColors ? {
            "--rf-color-primary": themeColors.primary,
            "--rf-color-secondary": themeColors.secondary,
            "--rf-color-black": themeColors.black,
            "--rf-color-whereToEatColor": themeColors.whereToEatColor,
            "--rf-color-whereToSleepColor": themeColors.whereToSleepColor,
            "--rf-color-tobeSeenColor": themeColors.tobeSeenColor,
            "--rf-color-tobeDoneColor": themeColors.tobeDoneColor,
            "--rf-color-localProductsColor": themeColors.localProductsColor,
            "--rf-color-servicesColor": themeColors.servicesColor,
            "--rf-color-cardFrameBackground": themeColors.card?.frame?.background,
            "--rf-color-cardFrameBorder": themeColors.card?.frame?.border,
            "--rf-color-cardFrameText": themeColors.card?.frame?.text,
            "--rf-color-cardButtonBackgroundDefault": themeColors.card?.button?.background?.default,
            "--rf-color-cardButtonBackgroundHover": themeColors.card?.button?.background?.hover,
            "--rf-color-cardButtonBorderDefault": themeColors.card?.button?.border?.default,
            "--rf-color-cardButtonBorderHover": themeColors.card?.button?.border?.hover,
            "--rf-color-cardButtonTextDefault": themeColors.card?.button?.text?.default,
            "--rf-color-cardButtonTextHover": themeColors.card?.button?.text?.hover,
            "--rf-color-cardButtonDiscoverBackgroundDefault": themeColors.card?.discoverButton?.background?.default,
            "--rf-color-cardButtonDiscoverBackgroundHover": themeColors.card?.discoverButton?.background?.hover,
            "--rf-color-cardButtonDiscoverBorderDefault": themeColors.card?.discoverButton?.border?.default,
            "--rf-color-cardButtonDiscoverBorderHover": themeColors.card?.discoverButton?.border?.hover,
            "--rf-color-cardButtonDiscoverTextDefault": themeColors.card?.discoverButton?.text?.default,
            "--rf-color-cardButtonDiscoverTextHover": themeColors.card?.discoverButton?.text?.hover,
            "--rf-color-textModePanelBackground": themeColors.textMode?.panel?.background,
            "--rf-color-textModePanelBorder": themeColors.textMode?.panel?.border,
            "--rf-color-textModePanelConversationUser": themeColors.textMode?.panel?.conversationUser,
            "--rf-color-textModePanelConversationBot": themeColors.textMode?.panel?.conversationBot,
            "--rf-color-vocalModeSubtitlesText": themeColors.vocalMode?.subtitles?.text,
            "--rf-color-vocalModeSubtitlesBackground": themeColors.vocalMode?.subtitles?.background,
            "--rf-color-formInputTextDefault": themeColors.formInput?.text?.default,
            "--rf-color-formInputTextHover": themeColors.formInput?.text?.hover,
            "--rf-color-formInputRadioCheckboxUncheckedBackground": themeColors.formInput?.inputRadioCheckbox?.unchecked?.background,
            "--rf-color-formInputRadioCheckboxUncheckedBorder": themeColors.formInput?.inputRadioCheckbox?.unchecked?.border,
            "--rf-color-formInputRadioCheckboxCheckedBackground": themeColors.formInput?.inputRadioCheckbox?.checked?.background,
            "--rf-color-formInputRadioCheckboxCheckedBorder": themeColors.formInput?.inputRadioCheckbox?.checked?.border,
            "--rf-color-formInputRadioCheckboxCheckedItem": themeColors.formInput?.inputRadioCheckbox?.checked?.item,
            "--rf-color-formInputButtonBackgroundDefault": themeColors.formInput?.inputButton?.background?.default,
            "--rf-color-formInputButtonBackgroundHover": themeColors.formInput?.inputButton?.background?.hover,
            "--rf-color-formInputButtonBorderDefault": themeColors.formInput?.inputButton?.border?.default,
            "--rf-color-formInputButtonBorderHover": themeColors.formInput?.inputButton?.border?.hover,
            "--rf-color-formInputButtonTextDefault": themeColors.formInput?.inputButton?.text?.default,
            "--rf-color-formInputButtonTextHover": themeColors.formInput?.inputButton?.text?.hover
        } : {};
    }, [
        themeColors
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        id: "retorik-container",
        ref: container,
        className: `rf-relative ${fullSize ? "rf-w-screen rf-h-screen" : "rf-w-full rf-h-full"} rf-max-w-screen rf-max-h-screen rf-grid rf-grid-cols-8 rf-grid-rows-container rf-bg-transparent rf-text-trueblack rf-font-default ${portrait} ${large} ${isTactile && "rf-tactile"} rf-overflow-hidden rf-animate-loaderFadeIn`,
        style: {
            ...widthStyle,
            ...heightStyle,
            ...customColors
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $5d54cea5a2c4b61b$export$2e2bcd8739ae039), {}),
            children
        ]
    });
};
var $88d8d174fc7cb1a7$export$2e2bcd8739ae039 = $88d8d174fc7cb1a7$var$Container;




var $lT7pJ = parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $b38eacf4d687d742$export$5c524ddf7208c00c = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $fe6b040f6190268e$export$a4ad2735b021c132 = "1.8.0";


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $a143bb95684cd1b7$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $a143bb95684cd1b7$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($a143bb95684cd1b7$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($a143bb95684cd1b7$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $a143bb95684cd1b7$export$7fc0d8c3ab188c4c = $a143bb95684cd1b7$export$a5733a4d26a1ec61((0, $fe6b040f6190268e$export$a4ad2735b021c132));


var $cd4133318902c2f3$var$major = (0, $fe6b040f6190268e$export$a4ad2735b021c132).split(".")[0];
var $cd4133318902c2f3$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $cd4133318902c2f3$var$major);
var $cd4133318902c2f3$var$_global = (0, $b38eacf4d687d742$export$5c524ddf7208c00c);
function $cd4133318902c2f3$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $cd4133318902c2f3$var$_global[$cd4133318902c2f3$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $cd4133318902c2f3$var$_global[$cd4133318902c2f3$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $fe6b040f6190268e$export$a4ad2735b021c132)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $fe6b040f6190268e$export$a4ad2735b021c132)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $fe6b040f6190268e$export$a4ad2735b021c132));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $fe6b040f6190268e$export$a4ad2735b021c132) + ".");
    return true;
}
function $cd4133318902c2f3$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $cd4133318902c2f3$var$_global[$cd4133318902c2f3$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $a143bb95684cd1b7$export$7fc0d8c3ab188c4c)(globalVersion)) return;
    return (_b = $cd4133318902c2f3$var$_global[$cd4133318902c2f3$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $cd4133318902c2f3$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $fe6b040f6190268e$export$a4ad2735b021c132) + ".");
    var api = $cd4133318902c2f3$var$_global[$cd4133318902c2f3$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}


var $e047a4493671465c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e047a4493671465c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $e047a4493671465c$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || "DiagComponentLogger";
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e047a4493671465c$var$logProxy("debug", this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e047a4493671465c$var$logProxy("error", this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e047a4493671465c$var$logProxy("info", this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e047a4493671465c$var$logProxy("warn", this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e047a4493671465c$var$logProxy("verbose", this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $e047a4493671465c$var$logProxy(funcName, namespace, args) {
    var logger = (0, $cd4133318902c2f3$export$a4e55266d2135a7f)("diag");
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $e047a4493671465c$var$__spreadArray([], $e047a4493671465c$var$__read(args), false));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($528b1ea68e1e1a5c$export$b7d7b4c0f3c95263 || ($528b1ea68e1e1a5c$export$b7d7b4c0f3c95263 = {}));


function $b52727c883918811$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).NONE) maxLevel = (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).NONE;
    else if (maxLevel > (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).ALL) maxLevel = (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc("error", (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).ERROR),
        warn: _filterFunc("warn", (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).WARN),
        info: _filterFunc("info", (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).INFO),
        debug: _filterFunc("debug", (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).DEBUG),
        verbose: _filterFunc("verbose", (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).VERBOSE)
    };
}




var $16cbdcf7f48d8d4c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $16cbdcf7f48d8d4c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $16cbdcf7f48d8d4c$var$API_NAME = "diag";
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $cd4133318902c2f3$export$a4e55266d2135a7f)("diag");
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $16cbdcf7f48d8d4c$var$__spreadArray([], $16cbdcf7f48d8d4c$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $cd4133318902c2f3$export$a4e55266d2135a7f)("diag");
            var newLogger = (0, $b52727c883918811$export$9a9cc475abb19689)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $cd4133318902c2f3$export$d586ae880b433238)("diag", newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $cd4133318902c2f3$export$d42ac835f38d1fb2)($16cbdcf7f48d8d4c$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $e047a4493671465c$export$b4bccc12f5b13129)(options);
        };
        self.verbose = _logProxy("verbose");
        self.debug = _logProxy("debug");
        self.info = _logProxy("info");
        self.warn = _logProxy("warn");
        self.error = _logProxy("error");
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d98ea8f6317fa8d9$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d98ea8f6317fa8d9$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $d98ea8f6317fa8d9$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $d98ea8f6317fa8d9$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $d98ea8f6317fa8d9$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $47ca45923bebde48$export$92dd2fe8ddb5cb7 = Symbol("BaggageEntryMetadata");


var $d831bfbe72d38937$var$diag = (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance();
function $d831bfbe72d38937$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $d98ea8f6317fa8d9$export$b8c511fa1a5f4987)(new Map(Object.entries(entries)));
}
function $d831bfbe72d38937$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== "string") {
        $d831bfbe72d38937$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = "";
    }
    return {
        __TYPE__: (0, $47ca45923bebde48$export$92dd2fe8ddb5cb7),
        toString: function() {
            return str;
        }
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $8de61a3e7738d1ff$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $8de61a3e7738d1ff$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $8de61a3e7738d1ff$export$78df28f9b2f9a7dc = new $8de61a3e7738d1ff$var$BaseContext();









/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @deprecated use the one declared in @opentelemetry/sdk-trace-base instead.
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $47601d93c7415601$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($47601d93c7415601$export$94df7a7a96a92f7b || ($47601d93c7415601$export$94df7a7a96a92f7b = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7886c8f9b55154b2$export$4da4ea8145910e8b;
(function(SpanKind) {
    /** Default value. Indicates that the span is used internally. */ SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Indicates that the span covers server-side handling of an RPC or other
     * remote request.
     */ SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    /**
     * Indicates that the span covers the client-side wrapper around an RPC or
     * other remote request.
     */ SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    /**
     * Indicates that the span describes producer sending a message to a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    /**
     * Indicates that the span describes consumer receiving a message from a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})($7886c8f9b55154b2$export$4da4ea8145910e8b || ($7886c8f9b55154b2$export$4da4ea8145910e8b = {}));


/**
 * An enumeration of status codes.
 */ var $cdb334e89d9a87a2$export$1e28dd9b5d01db83;
(function(SpanStatusCode) {
    /**
     * The default status.
     */ SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */ SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */ SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})($cdb334e89d9a87a2$export$1e28dd9b5d01db83 || ($cdb334e89d9a87a2$export$1e28dd9b5d01db83 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $91d5e49b421908a7$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($91d5e49b421908a7$export$bf9049ad2b0883ff || ($91d5e49b421908a7$export$bf9049ad2b0883ff = {}));



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5dc7f57baf976773$export$55cc39fb0d4bb4c0 = "0000000000000000";
var $5dc7f57baf976773$export$22be96e88d95e128 = "00000000000000000000000000000000";
var $5dc7f57baf976773$export$8591e4c852b66703 = {
    traceId: $5dc7f57baf976773$export$22be96e88d95e128,
    spanId: $5dc7f57baf976773$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $91d5e49b421908a7$export$bf9049ad2b0883ff).NONE
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $61f19b861e076797$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $5dc7f57baf976773$export$8591e4c852b66703);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();


var $eb966c722689e573$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $eb966c722689e573$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $eb966c722689e573$export$29dd34cf1269f6da(traceId) {
    return $eb966c722689e573$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $5dc7f57baf976773$export$22be96e88d95e128);
}
function $eb966c722689e573$export$8e51c6d8f0586aff(spanId) {
    return $eb966c722689e573$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $5dc7f57baf976773$export$55cc39fb0d4bb4c0);
}
function $eb966c722689e573$export$e4373b9a2c09216c(spanContext) {
    return $eb966c722689e573$export$29dd34cf1269f6da(spanContext.traceId) && $eb966c722689e573$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $eb966c722689e573$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $61f19b861e076797$export$972d28f7c6a8c6c7)(spanContext);
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dbbc06d03fee494c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $dbbc06d03fee494c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $dbbc06d03fee494c$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $8de61a3e7738d1ff$export$78df28f9b2f9a7dc;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $dbbc06d03fee494c$var$__spreadArray([
            thisArg
        ], $dbbc06d03fee494c$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();




var $7141f728d8e8e336$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $7141f728d8e8e336$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $7141f728d8e8e336$var$API_NAME = "context";
var $7141f728d8e8e336$var$NOOP_CONTEXT_MANAGER = new (0, $dbbc06d03fee494c$export$a27e5df35d1539a6)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $7141f728d8e8e336$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $cd4133318902c2f3$export$d586ae880b433238)($7141f728d8e8e336$var$API_NAME, contextManager, (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $7141f728d8e8e336$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $7141f728d8e8e336$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $cd4133318902c2f3$export$a4e55266d2135a7f)($7141f728d8e8e336$var$API_NAME) || $7141f728d8e8e336$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $cd4133318902c2f3$export$d42ac835f38d1fb2)($7141f728d8e8e336$var$API_NAME, (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance());
    };
    return ContextAPI;
}();


var $033d6775d2f4334e$export$a078c61943f9dbbe = (0, $7141f728d8e8e336$export$4148866f0a453927).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $5961b21244e407a2$export$c042e7c2f59bc046 = (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $bd8ada983038e5da$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $bd8ada983038e5da$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $bd8ada983038e5da$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $bd8ada983038e5da$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $bd8ada983038e5da$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $bd8ada983038e5da$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $bd8ada983038e5da$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $bd8ada983038e5da$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $bd8ada983038e5da$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $bd8ada983038e5da$export$b556ba0f560c45b = /** @class */ function(_super) {
    $bd8ada983038e5da$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($bd8ada983038e5da$export$834a616d1cf278b);
var $bd8ada983038e5da$export$df09a35db160df98 = /** @class */ function(_super) {
    $bd8ada983038e5da$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($bd8ada983038e5da$export$834a616d1cf278b);
var $bd8ada983038e5da$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $bd8ada983038e5da$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($bd8ada983038e5da$export$834a616d1cf278b);
var $bd8ada983038e5da$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $bd8ada983038e5da$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $bd8ada983038e5da$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($bd8ada983038e5da$export$a5a3e7829c289482);
var $bd8ada983038e5da$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $bd8ada983038e5da$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($bd8ada983038e5da$export$a5a3e7829c289482);
var $bd8ada983038e5da$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $bd8ada983038e5da$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($bd8ada983038e5da$export$a5a3e7829c289482);
var $bd8ada983038e5da$export$65e277d35235a01f = new $bd8ada983038e5da$export$c23c6f85dd4fc1e9();
var $bd8ada983038e5da$export$e6d19fe5233efc54 = new $bd8ada983038e5da$export$b556ba0f560c45b();
var $bd8ada983038e5da$export$689c32a6a552e1a6 = new $bd8ada983038e5da$export$ef064c3e0426c607();
var $bd8ada983038e5da$export$2f189cd99d2b7429 = new $bd8ada983038e5da$export$df09a35db160df98();
var $bd8ada983038e5da$export$163422b94c3edbcb = new $bd8ada983038e5da$export$7a7e4b169d5c93a8();
var $bd8ada983038e5da$export$ea67e3c6ff624776 = new $bd8ada983038e5da$export$6990a2f90809ffc1();
var $bd8ada983038e5da$export$5b8be9ab17b673b3 = new $bd8ada983038e5da$export$3ec3555bc6f693a4();
function $bd8ada983038e5da$export$bc3a498ccbb5c2b5() {
    return $bd8ada983038e5da$export$65e277d35235a01f;
}


/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $0fb580148d133347$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $bd8ada983038e5da$export$65e277d35235a01f;
    };
    return NoopMeterProvider;
}();
var $0fb580148d133347$export$d21fe83355c56e18 = new $0fb580148d133347$export$51c513ea08316108();




var $4c2ac07ad8fedd95$var$API_NAME = "metrics";
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $4c2ac07ad8fedd95$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $cd4133318902c2f3$export$d586ae880b433238)($4c2ac07ad8fedd95$var$API_NAME, provider, (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $cd4133318902c2f3$export$a4e55266d2135a7f)($4c2ac07ad8fedd95$var$API_NAME) || (0, $0fb580148d133347$export$d21fe83355c56e18);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $cd4133318902c2f3$export$d42ac835f38d1fb2)($4c2ac07ad8fedd95$var$API_NAME, (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance());
    };
    return MetricsAPI;
}();


var $ce40980a8f9ad426$export$b0c5c2fac8144e54 = (0, $4c2ac07ad8fedd95$export$1339f6eb6111c638).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $59f28a9208feddf7$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ffa424c552225cb1$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $ffa424c552225cb1$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/**
 * Baggage key
 */ var $4f1329cddf21f608$var$BAGGAGE_KEY = (0, $8de61a3e7738d1ff$export$b8c322c5a7cfce78)("OpenTelemetry Baggage Key");
function $4f1329cddf21f608$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($4f1329cddf21f608$var$BAGGAGE_KEY) || undefined;
}
function $4f1329cddf21f608$export$120a1756099436ee() {
    return $4f1329cddf21f608$export$f3bffa0b5dd10d1e((0, $7141f728d8e8e336$export$4148866f0a453927).getInstance().active());
}
function $4f1329cddf21f608$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($4f1329cddf21f608$var$BAGGAGE_KEY, baggage);
}
function $4f1329cddf21f608$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($4f1329cddf21f608$var$BAGGAGE_KEY);
}




var $f058900d338455a4$var$API_NAME = "propagation";
var $f058900d338455a4$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $59f28a9208feddf7$export$8356c7eb3af7963b)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $f058900d338455a4$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $d831bfbe72d38937$export$1034a425c7384452);
        this.getBaggage = (0, $4f1329cddf21f608$export$f3bffa0b5dd10d1e);
        this.getActiveBaggage = (0, $4f1329cddf21f608$export$120a1756099436ee);
        this.setBaggage = (0, $4f1329cddf21f608$export$adc9ca19eab3f500);
        this.deleteBaggage = (0, $4f1329cddf21f608$export$4ca3a8a743c9f633);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $cd4133318902c2f3$export$d586ae880b433238)($f058900d338455a4$var$API_NAME, propagator, (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $ffa424c552225cb1$export$f70f1d111fccf1c1);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $ffa424c552225cb1$export$a0f575f55f38720a);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $cd4133318902c2f3$export$d42ac835f38d1fb2)($f058900d338455a4$var$API_NAME, (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $cd4133318902c2f3$export$a4e55266d2135a7f)($f058900d338455a4$var$API_NAME) || $f058900d338455a4$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();


var $64245f18975a06c0$export$3e49040daa9dba20 = (0, $f058900d338455a4$export$471eda0a6213cac9).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


/**
 * span key
 */ var $7a0c3e37b5af28a2$var$SPAN_KEY = (0, $8de61a3e7738d1ff$export$b8c322c5a7cfce78)("OpenTelemetry Context Key SPAN");
function $7a0c3e37b5af28a2$export$246e04ba06066af1(context) {
    return context.getValue($7a0c3e37b5af28a2$var$SPAN_KEY) || undefined;
}
function $7a0c3e37b5af28a2$export$1be426a8e585c83e() {
    return $7a0c3e37b5af28a2$export$246e04ba06066af1((0, $7141f728d8e8e336$export$4148866f0a453927).getInstance().active());
}
function $7a0c3e37b5af28a2$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($7a0c3e37b5af28a2$var$SPAN_KEY, span);
}
function $7a0c3e37b5af28a2$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($7a0c3e37b5af28a2$var$SPAN_KEY);
}
function $7a0c3e37b5af28a2$export$c90bf5428c14cdb1(context, spanContext) {
    return $7a0c3e37b5af28a2$export$8ab2f2e6ee8ed0a8(context, new (0, $61f19b861e076797$export$972d28f7c6a8c6c7)(spanContext));
}
function $7a0c3e37b5af28a2$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $7a0c3e37b5af28a2$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}




var $d7c04f4b72bb8eb0$var$contextApi = (0, $7141f728d8e8e336$export$4148866f0a453927).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $d7c04f4b72bb8eb0$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $d7c04f4b72bb8eb0$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $61f19b861e076797$export$972d28f7c6a8c6c7)();
        var parentFromContext = context && (0, $7a0c3e37b5af28a2$export$1a635f8f0b912781)(context);
        if ($d7c04f4b72bb8eb0$var$isSpanContext(parentFromContext) && (0, $eb966c722689e573$export$e4373b9a2c09216c)(parentFromContext)) return new (0, $61f19b861e076797$export$972d28f7c6a8c6c7)(parentFromContext);
        else return new (0, $61f19b861e076797$export$972d28f7c6a8c6c7)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $d7c04f4b72bb8eb0$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $7a0c3e37b5af28a2$export$8ab2f2e6ee8ed0a8)(parentContext, span);
        return $d7c04f4b72bb8eb0$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $d7c04f4b72bb8eb0$var$isSpanContext(spanContext) {
    return typeof spanContext === "object" && typeof spanContext["spanId"] === "string" && typeof spanContext["traceId"] === "string" && typeof spanContext["traceFlags"] === "number";
}


var $45cebe76a6e2d952$var$NOOP_TRACER = new (0, $d7c04f4b72bb8eb0$export$714c1036cabcd223)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $45cebe76a6e2d952$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $45cebe76a6e2d952$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $b555c2d2ca6a71a9$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $d7c04f4b72bb8eb0$export$714c1036cabcd223)();
    };
    return NoopTracerProvider;
}();


var $063ab35ff70a3abb$var$NOOP_TRACER_PROVIDER = new (0, $b555c2d2ca6a71a9$export$87d8e93756f9e86e)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $063ab35ff70a3abb$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $45cebe76a6e2d952$export$df2c38268c6bb6b3)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $063ab35ff70a3abb$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();





var $ed505682d9854395$var$API_NAME = "trace";
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $ed505682d9854395$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $063ab35ff70a3abb$export$4137aabcb4254962)();
        this.wrapSpanContext = (0, $eb966c722689e573$export$c19cc0f1911bdb85);
        this.isSpanContextValid = (0, $eb966c722689e573$export$e4373b9a2c09216c);
        this.deleteSpan = (0, $7a0c3e37b5af28a2$export$a6bbfe9a17f7941c);
        this.getSpan = (0, $7a0c3e37b5af28a2$export$246e04ba06066af1);
        this.getActiveSpan = (0, $7a0c3e37b5af28a2$export$1be426a8e585c83e);
        this.getSpanContext = (0, $7a0c3e37b5af28a2$export$1a635f8f0b912781);
        this.setSpan = (0, $7a0c3e37b5af28a2$export$8ab2f2e6ee8ed0a8);
        this.setSpanContext = (0, $7a0c3e37b5af28a2$export$c90bf5428c14cdb1);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $cd4133318902c2f3$export$d586ae880b433238)($ed505682d9854395$var$API_NAME, this._proxyTracerProvider, (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $cd4133318902c2f3$export$a4e55266d2135a7f)($ed505682d9854395$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $cd4133318902c2f3$export$d42ac835f38d1fb2)($ed505682d9854395$var$API_NAME, (0, $16cbdcf7f48d8d4c$export$5c8937ffc688cfd3).instance());
        this._proxyTracerProvider = new (0, $063ab35ff70a3abb$export$4137aabcb4254962)();
    };
    return TraceAPI;
}();


var $74ed2dbfdbf87d9b$export$357889f174732d38 = (0, $ed505682d9854395$export$2cccde6fcc7b568a).getInstance();


var // Default export.
$fb8ae6a67ef67ee0$export$2e2bcd8739ae039 = {
    context: (0, $033d6775d2f4334e$export$a078c61943f9dbbe),
    diag: (0, $5961b21244e407a2$export$c042e7c2f59bc046),
    metrics: (0, $ce40980a8f9ad426$export$b0c5c2fac8144e54),
    propagation: (0, $64245f18975a06c0$export$3e49040daa9dba20),
    trace: (0, $74ed2dbfdbf87d9b$export$357889f174732d38)
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $42cf821ac8837652$exports = {};

$parcel$export($42cf821ac8837652$exports, "serializeKeyPairs", () => $42cf821ac8837652$export$790fc82b2ff5bf87);
$parcel$export($42cf821ac8837652$exports, "getKeyPairs", () => $42cf821ac8837652$export$ed4c06f0919b1951);
$parcel$export($42cf821ac8837652$exports, "parsePairKeyValue", () => $42cf821ac8837652$export$62659c450b08e504);
$parcel$export($42cf821ac8837652$exports, "parseKeyPairsIntoRecord", () => $42cf821ac8837652$export$1259660ed6830e21);

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $80ff1f293818cc89$export$3043215ef908d54f = "=";
var $80ff1f293818cc89$export$393a3f9e6e76438 = ";";
var $80ff1f293818cc89$export$1ab471785c2cf557 = ",";
var $80ff1f293818cc89$export$a6199dd4fe419e69 = "baggage";
var $80ff1f293818cc89$export$9a50757016085e99 = 180;
var $80ff1f293818cc89$export$c7d9e39bb295c1f = 4096;
var $80ff1f293818cc89$export$dd0527bee1f518e7 = 8192;


var $42cf821ac8837652$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $42cf821ac8837652$export$790fc82b2ff5bf87(keyPairs) {
    return keyPairs.reduce(function(hValue, current) {
        var value = "" + hValue + (hValue !== "" ? (0, $80ff1f293818cc89$export$1ab471785c2cf557) : "") + current;
        return value.length > (0, $80ff1f293818cc89$export$dd0527bee1f518e7) ? hValue : value;
    }, "");
}
function $42cf821ac8837652$export$ed4c06f0919b1951(baggage) {
    return baggage.getAllEntries().map(function(_a) {
        var _b = $42cf821ac8837652$var$__read(_a, 2), key = _b[0], value = _b[1];
        var entry = encodeURIComponent(key) + "=" + encodeURIComponent(value.value);
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) entry += (0, $80ff1f293818cc89$export$393a3f9e6e76438) + value.metadata.toString();
        return entry;
    });
}
function $42cf821ac8837652$export$62659c450b08e504(entry) {
    var valueProps = entry.split((0, $80ff1f293818cc89$export$393a3f9e6e76438));
    if (valueProps.length <= 0) return;
    var keyPairPart = valueProps.shift();
    if (!keyPairPart) return;
    var separatorIndex = keyPairPart.indexOf((0, $80ff1f293818cc89$export$3043215ef908d54f));
    if (separatorIndex <= 0) return;
    var key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    var value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    var metadata;
    if (valueProps.length > 0) metadata = (0, $d831bfbe72d38937$export$c491cedc1b2b6e9e)(valueProps.join((0, $80ff1f293818cc89$export$393a3f9e6e76438)));
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
function $42cf821ac8837652$export$1259660ed6830e21(value) {
    if (typeof value !== "string" || value.length === 0) return {};
    return value.split((0, $80ff1f293818cc89$export$1ab471785c2cf557)).map(function(entry) {
        return $42cf821ac8837652$export$62659c450b08e504(entry);
    }).filter(function(keyPair) {
        return keyPair !== undefined && keyPair.value.length > 0;
    }).reduce(function(headers, keyPair) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        headers[keyPair.key] = keyPair.value;
        return headers;
    }, {});
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f0861323f0880ea7$export$243c1c4fe84ef188;
(function(TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})($f0861323f0880ea7$export$243c1c4fe84ef188 || ($f0861323f0880ea7$export$243c1c4fe84ef188 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $fb53e5e4222c7400$export$5c524ddf7208c00c = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};



var $hIXGI = parcelRequire("hIXGI");
var $d8581688eeac76ed$var$DEFAULT_LIST_SEPARATOR = ",";
/**
 * Environment interface to define all names
 */ var $d8581688eeac76ed$var$ENVIRONMENT_BOOLEAN_KEYS = [
    "OTEL_SDK_DISABLED"
];
function $d8581688eeac76ed$var$isEnvVarABoolean(key) {
    return $d8581688eeac76ed$var$ENVIRONMENT_BOOLEAN_KEYS.indexOf(key) > -1;
}
var $d8581688eeac76ed$var$ENVIRONMENT_NUMBERS_KEYS = [
    "OTEL_BSP_EXPORT_TIMEOUT",
    "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BSP_MAX_QUEUE_SIZE",
    "OTEL_BSP_SCHEDULE_DELAY",
    "OTEL_BLRP_EXPORT_TIMEOUT",
    "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BLRP_MAX_QUEUE_SIZE",
    "OTEL_BLRP_SCHEDULE_DELAY",
    "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_LINK_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
    "OTEL_EXPORTER_OTLP_TIMEOUT",
    "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
    "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
    "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
    "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function $d8581688eeac76ed$var$isEnvVarANumber(key) {
    return $d8581688eeac76ed$var$ENVIRONMENT_NUMBERS_KEYS.indexOf(key) > -1;
}
var $d8581688eeac76ed$var$ENVIRONMENT_LISTS_KEYS = [
    "OTEL_NO_PATCH_MODULES",
    "OTEL_PROPAGATORS"
];
function $d8581688eeac76ed$var$isEnvVarAList(key) {
    return $d8581688eeac76ed$var$ENVIRONMENT_LISTS_KEYS.indexOf(key) > -1;
}
var $d8581688eeac76ed$export$d9446f3c1c12def1 = Infinity;
var $d8581688eeac76ed$export$6ad612be99f9ed48 = 128;
var $d8581688eeac76ed$export$c5bbf26b60de6148 = 128;
var $d8581688eeac76ed$export$f200b88493991cbe = 128;
var $d8581688eeac76ed$export$849dbeeeda01ae98 = {
    OTEL_SDK_DISABLED: false,
    CONTAINER_NAME: "",
    ECS_CONTAINER_METADATA_URI_V4: "",
    ECS_CONTAINER_METADATA_URI: "",
    HOSTNAME: "",
    KUBERNETES_SERVICE_HOST: "",
    NAMESPACE: "",
    OTEL_BSP_EXPORT_TIMEOUT: 30000,
    OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BSP_MAX_QUEUE_SIZE: 2048,
    OTEL_BSP_SCHEDULE_DELAY: 5000,
    OTEL_BLRP_EXPORT_TIMEOUT: 30000,
    OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
    OTEL_BLRP_SCHEDULE_DELAY: 5000,
    OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
    OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
    OTEL_EXPORTER_JAEGER_ENDPOINT: "",
    OTEL_EXPORTER_JAEGER_PASSWORD: "",
    OTEL_EXPORTER_JAEGER_USER: "",
    OTEL_EXPORTER_OTLP_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_HEADERS: "",
    OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
    OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
    OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
    OTEL_EXPORTER_OTLP_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 10000,
    OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
    OTEL_LOG_LEVEL: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).INFO,
    OTEL_NO_PATCH_MODULES: [],
    OTEL_PROPAGATORS: [
        "tracecontext",
        "baggage"
    ],
    OTEL_RESOURCE_ATTRIBUTES: "",
    OTEL_SERVICE_NAME: "",
    OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: $d8581688eeac76ed$export$d9446f3c1c12def1,
    OTEL_ATTRIBUTE_COUNT_LIMIT: $d8581688eeac76ed$export$6ad612be99f9ed48,
    OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: $d8581688eeac76ed$export$d9446f3c1c12def1,
    OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: $d8581688eeac76ed$export$6ad612be99f9ed48,
    OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: $d8581688eeac76ed$export$d9446f3c1c12def1,
    OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: $d8581688eeac76ed$export$6ad612be99f9ed48,
    OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_LINK_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: $d8581688eeac76ed$export$c5bbf26b60de6148,
    OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: $d8581688eeac76ed$export$f200b88493991cbe,
    OTEL_TRACES_EXPORTER: "",
    OTEL_TRACES_SAMPLER: (0, $f0861323f0880ea7$export$243c1c4fe84ef188).ParentBasedAlwaysOn,
    OTEL_TRACES_SAMPLER_ARG: "",
    OTEL_LOGS_EXPORTER: "",
    OTEL_EXPORTER_OTLP_INSECURE: "",
    OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
    OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
    OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
    OTEL_EXPORTER_OTLP_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
/**
 * @param key
 * @param environment
 * @param values
 */ function $d8581688eeac76ed$var$parseBoolean(key, environment, values) {
    if (typeof values[key] === "undefined") return;
    var value = String(values[key]);
    // support case-insensitive "true"
    environment[key] = value.toLowerCase() === "true";
}
/**
 * Parses a variable as number with number validation
 * @param name
 * @param environment
 * @param values
 * @param min
 * @param max
 */ function $d8581688eeac76ed$var$parseNumber(name, environment, values, min, max) {
    if (min === void 0) min = -Infinity;
    if (max === void 0) max = Infinity;
    if (typeof values[name] !== "undefined") {
        var value = Number(values[name]);
        if (!isNaN(value)) {
            if (value < min) environment[name] = min;
            else if (value > max) environment[name] = max;
            else environment[name] = value;
        }
    }
}
/**
 * Parses list-like strings from input into output.
 * @param name
 * @param environment
 * @param values
 * @param separator
 */ function $d8581688eeac76ed$var$parseStringList(name, output, input, separator) {
    if (separator === void 0) separator = $d8581688eeac76ed$var$DEFAULT_LIST_SEPARATOR;
    var givenValue = input[name];
    if (typeof givenValue === "string") output[name] = givenValue.split(separator).map(function(v) {
        return v.trim();
    });
}
// The support string -> DiagLogLevel mappings
var $d8581688eeac76ed$var$logLevelMap = {
    ALL: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).ALL,
    VERBOSE: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).VERBOSE,
    DEBUG: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).DEBUG,
    INFO: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).INFO,
    WARN: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).WARN,
    ERROR: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).ERROR,
    NONE: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).NONE
};
/**
 * Environmentally sets log level if valid log level string is provided
 * @param key
 * @param environment
 * @param values
 */ function $d8581688eeac76ed$var$setLogLevelFromEnv(key, environment, values) {
    var value = values[key];
    if (typeof value === "string") {
        var theLevel = $d8581688eeac76ed$var$logLevelMap[value.toUpperCase()];
        if (theLevel != null) environment[key] = theLevel;
    }
}
function $d8581688eeac76ed$export$99f17f8ee99049eb(values) {
    var environment = {};
    for(var env in $d8581688eeac76ed$export$849dbeeeda01ae98){
        var key = env;
        switch(key){
            case "OTEL_LOG_LEVEL":
                $d8581688eeac76ed$var$setLogLevelFromEnv(key, environment, values);
                break;
            default:
                if ($d8581688eeac76ed$var$isEnvVarABoolean(key)) $d8581688eeac76ed$var$parseBoolean(key, environment, values);
                else if ($d8581688eeac76ed$var$isEnvVarANumber(key)) $d8581688eeac76ed$var$parseNumber(key, environment, values);
                else if ($d8581688eeac76ed$var$isEnvVarAList(key)) $d8581688eeac76ed$var$parseStringList(key, environment, values);
                else {
                    var value = values[key];
                    if (typeof value !== "undefined" && value !== null) environment[key] = String(value);
                }
        }
    }
    return environment;
}
function $d8581688eeac76ed$export$728650dd4748d692() {
    return typeof $hIXGI !== "undefined" && $hIXGI && $hIXGI.env ? $d8581688eeac76ed$export$99f17f8ee99049eb($hIXGI.env) : $d8581688eeac76ed$export$99f17f8ee99049eb((0, $fb53e5e4222c7400$export$5c524ddf7208c00c));
}



function $8841abd362674da9$export$4bd44a2aa29d3d6e() {
    var globalEnv = (0, $d8581688eeac76ed$export$99f17f8ee99049eb)((0, $fb53e5e4222c7400$export$5c524ddf7208c00c));
    return Object.assign({}, (0, $d8581688eeac76ed$export$849dbeeeda01ae98), globalEnv);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $502367376d5641b7$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $502367376d5641b7$var$DEFAULT_TRACE_TIMEOUT = 10000;
var $502367376d5641b7$export$437cb26a1d99f35f = 5;
var $502367376d5641b7$export$8234d6fdc73f98ad = 1000;
var $502367376d5641b7$export$13ad5a7ba71c0e0e = 5000;
var $502367376d5641b7$export$7a6064683182b48c = 1.5;
function $502367376d5641b7$export$eea2c1c5e1a37e50(partialHeaders) {
    if (partialHeaders === void 0) partialHeaders = {};
    var headers = {};
    Object.entries(partialHeaders).forEach(function(_a) {
        var _b = $502367376d5641b7$var$__read(_a, 2), key = _b[0], value = _b[1];
        if (typeof value !== "undefined") headers[key] = String(value);
        else (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn('Header "' + key + '" has wrong value and will be ignored');
    });
    return headers;
}
function $502367376d5641b7$export$cf96c940bd801f14(url, path) {
    if (!url.endsWith("/")) url = url + "/";
    return url + path;
}
function $502367376d5641b7$export$744a53bd000073f5(url) {
    try {
        var parsedUrl = new URL(url);
        if (parsedUrl.pathname === "") parsedUrl.pathname = parsedUrl.pathname + "/";
        return parsedUrl.toString();
    } catch (_a) {
        (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Could not parse export URL: '" + url + "'");
        return url;
    }
}
function $502367376d5641b7$export$d05637f28599e6ce(timeoutMillis) {
    if (typeof timeoutMillis === "number") {
        if (timeoutMillis <= 0) // OTLP exporter configured timeout - using default value of 10000ms
        return $502367376d5641b7$export$ed1c73add0a74dba(timeoutMillis, $502367376d5641b7$var$DEFAULT_TRACE_TIMEOUT);
        return timeoutMillis;
    } else return $502367376d5641b7$var$getExporterTimeoutFromEnv();
}
function $502367376d5641b7$var$getExporterTimeoutFromEnv() {
    var _a;
    var definedTimeout = Number((_a = (0, $8841abd362674da9$export$4bd44a2aa29d3d6e)().OTEL_EXPORTER_OTLP_TRACES_TIMEOUT) !== null && _a !== void 0 ? _a : (0, $8841abd362674da9$export$4bd44a2aa29d3d6e)().OTEL_EXPORTER_OTLP_TIMEOUT);
    if (definedTimeout <= 0) // OTLP exporter configured timeout - using default value of 10000ms
    return $502367376d5641b7$export$ed1c73add0a74dba(definedTimeout, $502367376d5641b7$var$DEFAULT_TRACE_TIMEOUT);
    else return definedTimeout;
}
function $502367376d5641b7$export$ed1c73add0a74dba(timeout, defaultTimeout) {
    (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Timeout must be greater than 0", timeout);
    return defaultTimeout;
}
function $502367376d5641b7$export$bc409a649b31360b(statusCode) {
    var retryCodes = [
        429,
        502,
        503,
        504
    ];
    return retryCodes.includes(statusCode);
}
function $502367376d5641b7$export$4e009558974ad065(retryAfter) {
    if (retryAfter == null) return -1;
    var seconds = Number.parseInt(retryAfter, 10);
    if (Number.isInteger(seconds)) return seconds > 0 ? seconds * 1000 : -1;
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After#directives
    var delay = new Date(retryAfter).getTime() - Date.now();
    if (delay >= 0) return delay;
    return 0;
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $bc8bcf8be7923d40$export$85f6557964517f1a = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this._promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    Deferred.prototype.resolve = function(val) {
        this._resolve(val);
    };
    Deferred.prototype.reject = function(err) {
        this._reject(err);
    };
    return Deferred;
}();


var $200f589a6c82340f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $200f589a6c82340f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Bind the callback and only invoke the callback once regardless how many times `BindOnceFuture.call` is invoked.
 */ var $200f589a6c82340f$export$c1f52ab4952184cd = /** @class */ function() {
    function BindOnceFuture(_callback, _that) {
        this._callback = _callback;
        this._that = _that;
        this._isCalled = false;
        this._deferred = new (0, $bc8bcf8be7923d40$export$85f6557964517f1a)();
    }
    Object.defineProperty(BindOnceFuture.prototype, "isCalled", {
        get: function() {
            return this._isCalled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindOnceFuture.prototype, "promise", {
        get: function() {
            return this._deferred.promise;
        },
        enumerable: false,
        configurable: true
    });
    BindOnceFuture.prototype.call = function() {
        var _a;
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve((_a = this._callback).call.apply(_a, $200f589a6c82340f$var$__spreadArray([
                    this._that
                ], $200f589a6c82340f$var$__read(args), false))).then(function(val) {
                    return _this._deferred.resolve(val);
                }, function(err) {
                    return _this._deferred.reject(err);
                });
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    };
    return BindOnceFuture;
}();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2bc07dd4f1ae83be$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($2bc07dd4f1ae83be$export$ee0fe4df4ef0f3a1 || ($2bc07dd4f1ae83be$export$ee0fe4df4ef0f3a1 = {}));



/**
 * Collector Exporter abstract base class
 */ var $22a3da06709179f9$export$a756c21bf453f1b5 = /** @class */ function() {
    /**
     * @param config
     */ function OTLPExporterBase(config) {
        if (config === void 0) config = {};
        this._sendingPromises = [];
        this.url = this.getDefaultUrl(config);
        if (typeof config.hostname === "string") this.hostname = config.hostname;
        this.shutdown = this.shutdown.bind(this);
        this._shutdownOnce = new (0, $200f589a6c82340f$export$c1f52ab4952184cd)(this._shutdown, this);
        this._concurrencyLimit = typeof config.concurrencyLimit === "number" ? config.concurrencyLimit : Infinity;
        this.timeoutMillis = (0, $502367376d5641b7$export$d05637f28599e6ce)(config.timeoutMillis);
        // platform dependent
        this.onInit(config);
    }
    /**
     * Export items.
     * @param items
     * @param resultCallback
     */ OTLPExporterBase.prototype.export = function(items, resultCallback) {
        if (this._shutdownOnce.isCalled) {
            resultCallback({
                code: (0, $2bc07dd4f1ae83be$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error("Exporter has been shutdown")
            });
            return;
        }
        if (this._sendingPromises.length >= this._concurrencyLimit) {
            resultCallback({
                code: (0, $2bc07dd4f1ae83be$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error("Concurrent export limit reached")
            });
            return;
        }
        this._export(items).then(function() {
            resultCallback({
                code: (0, $2bc07dd4f1ae83be$export$ee0fe4df4ef0f3a1).SUCCESS
            });
        }).catch(function(error) {
            resultCallback({
                code: (0, $2bc07dd4f1ae83be$export$ee0fe4df4ef0f3a1).FAILED,
                error: error
            });
        });
    };
    OTLPExporterBase.prototype._export = function(items) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            try {
                (0, $5961b21244e407a2$export$c042e7c2f59bc046).debug("items to be sent", items);
                _this.send(items, resolve, reject);
            } catch (e) {
                reject(e);
            }
        });
    };
    /**
     * Shutdown the exporter.
     */ OTLPExporterBase.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    };
    /**
     * Exports any pending spans in the exporter
     */ OTLPExporterBase.prototype.forceFlush = function() {
        return Promise.all(this._sendingPromises).then(function() {
        /** ignore resolved values */ });
    };
    /**
     * Called by _shutdownOnce with BindOnceFuture
     */ OTLPExporterBase.prototype._shutdown = function() {
        (0, $5961b21244e407a2$export$c042e7c2f59bc046).debug("shutdown started");
        this.onShutdown();
        return this.forceFlush();
    };
    return OTLPExporterBase;
}();




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e6bb1fabfe76914d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Interface for handling error
 */ var $e6bb1fabfe76914d$export$26c718c16cda30c6 = /** @class */ function(_super) {
    $e6bb1fabfe76914d$var$__extends(OTLPExporterError, _super);
    function OTLPExporterError(message, code, data) {
        var _this = _super.call(this, message) || this;
        _this.name = "OTLPExporterError";
        _this.data = data;
        _this.code = code;
        return _this;
    }
    return OTLPExporterError;
}(Error);



var $bbabfe812c912404$var$__assign = undefined && undefined.__assign || function() {
    $bbabfe812c912404$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bbabfe812c912404$var$__assign.apply(this, arguments);
};
var $bbabfe812c912404$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $bbabfe812c912404$export$7b15ee654b029dd0(body, url, blobPropertyBag, onSuccess, onError) {
    if (navigator.sendBeacon(url, new Blob([
        body
    ], blobPropertyBag))) {
        (0, $5961b21244e407a2$export$c042e7c2f59bc046).debug("sendBeacon - can send", body);
        onSuccess();
    } else {
        var error = new (0, $e6bb1fabfe76914d$export$26c718c16cda30c6)("sendBeacon - cannot send " + body);
        onError(error);
    }
}
function $bbabfe812c912404$export$3025e92bca21971c(body, url, headers, exporterTimeout, onSuccess, onError) {
    var retryTimer;
    var xhr;
    var reqIsDestroyed = false;
    var exporterTimer = setTimeout(function() {
        clearTimeout(retryTimer);
        reqIsDestroyed = true;
        if (xhr.readyState === XMLHttpRequest.DONE) {
            var err = new (0, $e6bb1fabfe76914d$export$26c718c16cda30c6)("Request Timeout");
            onError(err);
        } else xhr.abort();
    }, exporterTimeout);
    var sendWithRetry = function(retries, minDelay) {
        if (retries === void 0) retries = (0, $502367376d5641b7$export$437cb26a1d99f35f);
        if (minDelay === void 0) minDelay = (0, $502367376d5641b7$export$8234d6fdc73f98ad);
        xhr = new XMLHttpRequest();
        xhr.open("POST", url);
        var defaultHeaders = {
            Accept: "application/json",
            "Content-Type": "application/json"
        };
        Object.entries($bbabfe812c912404$var$__assign($bbabfe812c912404$var$__assign({}, defaultHeaders), headers)).forEach(function(_a) {
            var _b = $bbabfe812c912404$var$__read(_a, 2), k = _b[0], v = _b[1];
            xhr.setRequestHeader(k, v);
        });
        xhr.send(body);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE && reqIsDestroyed === false) {
                if (xhr.status >= 200 && xhr.status <= 299) {
                    (0, $5961b21244e407a2$export$c042e7c2f59bc046).debug("xhr success", body);
                    onSuccess();
                    clearTimeout(exporterTimer);
                    clearTimeout(retryTimer);
                } else if (xhr.status && (0, $502367376d5641b7$export$bc409a649b31360b)(xhr.status) && retries > 0) {
                    var retryTime = void 0;
                    minDelay = (0, $502367376d5641b7$export$7a6064683182b48c) * minDelay;
                    // retry after interval specified in Retry-After header
                    if (xhr.getResponseHeader("Retry-After")) retryTime = (0, $502367376d5641b7$export$4e009558974ad065)(xhr.getResponseHeader("Retry-After"));
                    else // exponential backoff with jitter
                    retryTime = Math.round(Math.random() * ((0, $502367376d5641b7$export$13ad5a7ba71c0e0e) - minDelay) + minDelay);
                    retryTimer = setTimeout(function() {
                        sendWithRetry(retries - 1, minDelay);
                    }, retryTime);
                } else {
                    var error = new (0, $e6bb1fabfe76914d$export$26c718c16cda30c6)("Failed to export with XHR (status: " + xhr.status + ")", xhr.status);
                    onError(error);
                    clearTimeout(exporterTimer);
                    clearTimeout(retryTimer);
                }
            }
        };
        xhr.onabort = function() {
            if (reqIsDestroyed) {
                var err = new (0, $e6bb1fabfe76914d$export$26c718c16cda30c6)("Request Timeout");
                onError(err);
            }
            clearTimeout(exporterTimer);
            clearTimeout(retryTimer);
        };
        xhr.onerror = function() {
            if (reqIsDestroyed) {
                var err = new (0, $e6bb1fabfe76914d$export$26c718c16cda30c6)("Request Timeout");
                onError(err);
            }
            clearTimeout(exporterTimer);
            clearTimeout(retryTimer);
        };
    };
    sendWithRetry();
}




var $769d231a7548a665$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Collector Metric Exporter abstract base class
 */ var $769d231a7548a665$export$d0874567cb949b29 = /** @class */ function(_super) {
    $769d231a7548a665$var$__extends(OTLPExporterBrowserBase, _super);
    /**
     * @param config
     */ function OTLPExporterBrowserBase(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, config) || this;
        _this._useXHR = false;
        _this._useXHR = !!config.headers || typeof navigator.sendBeacon !== "function";
        if (_this._useXHR) _this._headers = Object.assign({}, (0, $502367376d5641b7$export$eea2c1c5e1a37e50)(config.headers), (0, $42cf821ac8837652$exports).parseKeyPairsIntoRecord((0, $8841abd362674da9$export$4bd44a2aa29d3d6e)().OTEL_EXPORTER_OTLP_HEADERS));
        else _this._headers = {};
        return _this;
    }
    OTLPExporterBrowserBase.prototype.onInit = function() {
        window.addEventListener("unload", this.shutdown);
    };
    OTLPExporterBrowserBase.prototype.onShutdown = function() {
        window.removeEventListener("unload", this.shutdown);
    };
    OTLPExporterBrowserBase.prototype.send = function(items, onSuccess, onError) {
        var _this = this;
        if (this._shutdownOnce.isCalled) {
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).debug("Shutdown already started. Cannot send objects");
            return;
        }
        var serviceRequest = this.convert(items);
        var body = JSON.stringify(serviceRequest);
        var promise = new Promise(function(resolve, reject) {
            if (_this._useXHR) (0, $bbabfe812c912404$export$3025e92bca21971c)(body, _this.url, _this._headers, _this.timeoutMillis, resolve, reject);
            else (0, $bbabfe812c912404$export$7b15ee654b029dd0)(body, _this.url, {
                type: "application/json"
            }, resolve, reject);
        }).then(onSuccess, onError);
        this._sendingPromises.push(promise);
        var popPromise = function() {
            var index = _this._sendingPromises.indexOf(promise);
            _this._sendingPromises.splice(index, 1);
        };
        promise.then(popPromise, popPromise);
    };
    return OTLPExporterBrowserBase;
}((0, $22a3da06709179f9$export$a756c21bf453f1b5));


var $9a612c82b1b3242b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $9a612c82b1b3242b$export$b6255b619acd6709(attributes) {
    return Object.keys(attributes).map(function(key) {
        return $9a612c82b1b3242b$export$155f69accf533147(key, attributes[key]);
    });
}
function $9a612c82b1b3242b$export$155f69accf533147(key, value) {
    return {
        key: key,
        value: $9a612c82b1b3242b$export$9544ab3c60b2d8ce(value)
    };
}
function $9a612c82b1b3242b$export$9544ab3c60b2d8ce(value) {
    var t = typeof value;
    if (t === "string") return {
        stringValue: value
    };
    if (t === "number") {
        if (!Number.isInteger(value)) return {
            doubleValue: value
        };
        return {
            intValue: value
        };
    }
    if (t === "boolean") return {
        boolValue: value
    };
    if (value instanceof Uint8Array) return {
        bytesValue: value
    };
    if (Array.isArray(value)) return {
        arrayValue: {
            values: value.map($9a612c82b1b3242b$export$9544ab3c60b2d8ce)
        }
    };
    if (t === "object" && value != null) return {
        kvlistValue: {
            values: Object.entries(value).map(function(_a) {
                var _b = $9a612c82b1b3242b$var$__read(_a, 2), k = _b[0], v = _b[1];
                return $9a612c82b1b3242b$export$155f69accf533147(k, v);
            })
        }
    };
    return {};
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c36b8f7fab19c5a8$export$544112ebebdc5fa4(hexStr) {
    var hexStrLen = hexStr.length;
    var hexAsciiCharsStr = "";
    for(var i = 0; i < hexStrLen; i += 2){
        var hexPair = hexStr.substring(i, i + 2);
        var hexVal = parseInt(hexPair, 16);
        hexAsciiCharsStr += String.fromCharCode(hexVal);
    }
    return btoa(hexAsciiCharsStr);
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $509e4da299d9385f$export$b22daef4119238cd = performance;


var $68c58dd70f6dfae6$var$NANOSECOND_DIGITS = 9;
var $68c58dd70f6dfae6$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
var $68c58dd70f6dfae6$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $68c58dd70f6dfae6$var$NANOSECOND_DIGITS_IN_MILLIS);
var $68c58dd70f6dfae6$var$SECOND_TO_NANOSECONDS = Math.pow(10, $68c58dd70f6dfae6$var$NANOSECOND_DIGITS);
function $68c58dd70f6dfae6$export$e7ec5c82995537b1(epochMillis) {
    var epochSeconds = epochMillis / 1000;
    // Decimals only.
    var seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    var nanos = Math.round(epochMillis % 1000 * $68c58dd70f6dfae6$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $68c58dd70f6dfae6$export$e752b05e58096a2f() {
    var timeOrigin = (0, $509e4da299d9385f$export$b22daef4119238cd).timeOrigin;
    if (typeof timeOrigin !== "number") {
        var perf = (0, $509e4da299d9385f$export$b22daef4119238cd);
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $68c58dd70f6dfae6$export$24b3f7dcd2848fa8(performanceNow) {
    var timeOrigin = $68c58dd70f6dfae6$export$e7ec5c82995537b1($68c58dd70f6dfae6$export$e752b05e58096a2f());
    var now = $68c58dd70f6dfae6$export$e7ec5c82995537b1(typeof performanceNow === "number" ? performanceNow : (0, $509e4da299d9385f$export$b22daef4119238cd).now());
    return $68c58dd70f6dfae6$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $68c58dd70f6dfae6$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($68c58dd70f6dfae6$export$390c59432f173a9f(time)) return time;
    else if (typeof time === "number") {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < $68c58dd70f6dfae6$export$e752b05e58096a2f()) return $68c58dd70f6dfae6$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $68c58dd70f6dfae6$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $68c58dd70f6dfae6$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError("Invalid input type");
}
function $68c58dd70f6dfae6$export$b783ad6617389e3e(startTime, endTime) {
    var seconds = endTime[0] - startTime[0];
    var nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $68c58dd70f6dfae6$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $68c58dd70f6dfae6$export$973c1c4fad6103e(time) {
    var precision = $68c58dd70f6dfae6$var$NANOSECOND_DIGITS;
    var tmp = "" + "0".repeat(precision) + time[1] + "Z";
    var nanoString = tmp.substr(tmp.length - precision - 1);
    var date = new Date(time[0] * 1000).toISOString();
    return date.replace("000Z", nanoString);
}
function $68c58dd70f6dfae6$export$2d91441ae30ebcfc(time) {
    return time[0] * $68c58dd70f6dfae6$var$SECOND_TO_NANOSECONDS + time[1];
}
function $68c58dd70f6dfae6$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $68c58dd70f6dfae6$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $68c58dd70f6dfae6$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === "number" && typeof value[1] === "number";
}
function $68c58dd70f6dfae6$export$a5e58227c317ebb9(value) {
    return $68c58dd70f6dfae6$export$390c59432f173a9f(value) || typeof value === "number" || value instanceof Date;
}
function $68c58dd70f6dfae6$export$f07bb1dbc72184c3(time1, time2) {
    var out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $68c58dd70f6dfae6$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $68c58dd70f6dfae6$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}



function $eb1dc46f6c5d720d$export$8c81c8011901e012(span, useHex) {
    var _a;
    var ctx = span.spanContext();
    var status = span.status;
    var parentSpanId = useHex ? span.parentSpanId : span.parentSpanId != null ? $c36b8f7fab19c5a8$export$544112ebebdc5fa4(span.parentSpanId) : undefined;
    return {
        traceId: useHex ? ctx.traceId : $c36b8f7fab19c5a8$export$544112ebebdc5fa4(ctx.traceId),
        spanId: useHex ? ctx.spanId : $c36b8f7fab19c5a8$export$544112ebebdc5fa4(ctx.spanId),
        parentSpanId: parentSpanId,
        traceState: (_a = ctx.traceState) === null || _a === void 0 ? void 0 : _a.serialize(),
        name: span.name,
        // Span kind is offset by 1 because the API does not define a value for unset
        kind: span.kind == null ? 0 : span.kind + 1,
        startTimeUnixNano: (0, $68c58dd70f6dfae6$export$2d91441ae30ebcfc)(span.startTime),
        endTimeUnixNano: (0, $68c58dd70f6dfae6$export$2d91441ae30ebcfc)(span.endTime),
        attributes: (0, $9a612c82b1b3242b$export$b6255b619acd6709)(span.attributes),
        droppedAttributesCount: span.droppedAttributesCount,
        events: span.events.map($eb1dc46f6c5d720d$export$c0221297e49388cc),
        droppedEventsCount: span.droppedEventsCount,
        status: {
            // API and proto enums share the same values
            code: status.code,
            message: status.message
        },
        links: span.links.map(function(link) {
            return $eb1dc46f6c5d720d$export$d40a678c50e6f4f2(link, useHex);
        }),
        droppedLinksCount: span.droppedLinksCount
    };
}
function $eb1dc46f6c5d720d$export$d40a678c50e6f4f2(link, useHex) {
    var _a;
    return {
        attributes: link.attributes ? (0, $9a612c82b1b3242b$export$b6255b619acd6709)(link.attributes) : [],
        spanId: useHex ? link.context.spanId : $c36b8f7fab19c5a8$export$544112ebebdc5fa4(link.context.spanId),
        traceId: useHex ? link.context.traceId : $c36b8f7fab19c5a8$export$544112ebebdc5fa4(link.context.traceId),
        traceState: (_a = link.context.traceState) === null || _a === void 0 ? void 0 : _a.serialize(),
        droppedAttributesCount: link.droppedAttributesCount || 0
    };
}
function $eb1dc46f6c5d720d$export$c0221297e49388cc(timedEvent) {
    return {
        attributes: timedEvent.attributes ? (0, $9a612c82b1b3242b$export$b6255b619acd6709)(timedEvent.attributes) : [],
        name: timedEvent.name,
        timeUnixNano: (0, $68c58dd70f6dfae6$export$2d91441ae30ebcfc)(timedEvent.time),
        droppedAttributesCount: timedEvent.droppedAttributesCount || 0
    };
}


var $45500bf409d5ae70$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $45500bf409d5ae70$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $45500bf409d5ae70$export$4bd5e67fadfa9fe0(spans, useHex) {
    return {
        resourceSpans: $45500bf409d5ae70$var$spanRecordsToResourceSpans(spans, useHex)
    };
}
function $45500bf409d5ae70$var$createResourceMap(readableSpans) {
    var e_1, _a;
    var resourceMap = new Map();
    try {
        for(var readableSpans_1 = $45500bf409d5ae70$var$__values(readableSpans), readableSpans_1_1 = readableSpans_1.next(); !readableSpans_1_1.done; readableSpans_1_1 = readableSpans_1.next()){
            var record = readableSpans_1_1.value;
            var ilmMap = resourceMap.get(record.resource);
            if (!ilmMap) {
                ilmMap = new Map();
                resourceMap.set(record.resource, ilmMap);
            }
            // TODO this is duplicated in basic tracer. Consolidate on a common helper in core
            var instrumentationLibraryKey = record.instrumentationLibrary.name + "@" + (record.instrumentationLibrary.version || "") + ":" + (record.instrumentationLibrary.schemaUrl || "");
            var records = ilmMap.get(instrumentationLibraryKey);
            if (!records) {
                records = [];
                ilmMap.set(instrumentationLibraryKey, records);
            }
            records.push(record);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (readableSpans_1_1 && !readableSpans_1_1.done && (_a = readableSpans_1.return)) _a.call(readableSpans_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return resourceMap;
}
function $45500bf409d5ae70$var$spanRecordsToResourceSpans(readableSpans, useHex) {
    var resourceMap = $45500bf409d5ae70$var$createResourceMap(readableSpans);
    var out = [];
    var entryIterator = resourceMap.entries();
    var entry = entryIterator.next();
    while(!entry.done){
        var _a = $45500bf409d5ae70$var$__read(entry.value, 2), resource = _a[0], ilmMap = _a[1];
        var scopeResourceSpans = [];
        var ilmIterator = ilmMap.values();
        var ilmEntry = ilmIterator.next();
        while(!ilmEntry.done){
            var scopeSpans = ilmEntry.value;
            if (scopeSpans.length > 0) {
                var _b = scopeSpans[0].instrumentationLibrary, name_1 = _b.name, version = _b.version, schemaUrl = _b.schemaUrl;
                var spans = scopeSpans.map(function(readableSpan) {
                    return (0, $eb1dc46f6c5d720d$export$8c81c8011901e012)(readableSpan, useHex);
                });
                scopeResourceSpans.push({
                    scope: {
                        name: name_1,
                        version: version
                    },
                    spans: spans,
                    schemaUrl: schemaUrl
                });
            }
            ilmEntry = ilmIterator.next();
        }
        // TODO SDK types don't provide resource schema URL at this time
        var transformedSpans = {
            resource: {
                attributes: (0, $9a612c82b1b3242b$export$b6255b619acd6709)(resource.attributes),
                droppedAttributesCount: 0
            },
            scopeSpans: scopeResourceSpans,
            schemaUrl: undefined
        };
        out.push(transformedSpans);
        entry = entryIterator.next();
    }
    return out;
}


var $4bdf0522111eec9f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4bdf0522111eec9f$var$DEFAULT_COLLECTOR_RESOURCE_PATH = "v1/traces";
var $4bdf0522111eec9f$var$DEFAULT_COLLECTOR_URL = "http://localhost:4318/" + $4bdf0522111eec9f$var$DEFAULT_COLLECTOR_RESOURCE_PATH;
/**
 * Collector Trace Exporter for Web
 */ var $4bdf0522111eec9f$export$f73dc942b4b27de3 = /** @class */ function(_super) {
    $4bdf0522111eec9f$var$__extends(OTLPTraceExporter, _super);
    function OTLPTraceExporter(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, config) || this;
        _this._headers = Object.assign(_this._headers, (0, $42cf821ac8837652$exports).parseKeyPairsIntoRecord((0, $8841abd362674da9$export$4bd44a2aa29d3d6e)().OTEL_EXPORTER_OTLP_TRACES_HEADERS));
        return _this;
    }
    OTLPTraceExporter.prototype.convert = function(spans) {
        return (0, $45500bf409d5ae70$export$4bd5e67fadfa9fe0)(spans, true);
    };
    OTLPTraceExporter.prototype.getDefaultUrl = function(config) {
        return typeof config.url === "string" ? config.url : (0, $8841abd362674da9$export$4bd44a2aa29d3d6e)().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT.length > 0 ? (0, $502367376d5641b7$export$744a53bd000073f5)((0, $8841abd362674da9$export$4bd44a2aa29d3d6e)().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT) : (0, $8841abd362674da9$export$4bd44a2aa29d3d6e)().OTEL_EXPORTER_OTLP_ENDPOINT.length > 0 ? (0, $502367376d5641b7$export$cf96c940bd801f14)((0, $8841abd362674da9$export$4bd44a2aa29d3d6e)().OTEL_EXPORTER_OTLP_ENDPOINT, $4bdf0522111eec9f$var$DEFAULT_COLLECTOR_RESOURCE_PATH) : $4bdf0522111eec9f$var$DEFAULT_COLLECTOR_URL;
    };
    return OTLPTraceExporter;
}((0, $769d231a7548a665$export$d0874567cb949b29));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d6b798d93fd2c1dd$export$85f6557964517f1a = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this._promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    Deferred.prototype.resolve = function(val) {
        this._resolve(val);
    };
    Deferred.prototype.reject = function(err) {
        this._reject(err);
    };
    return Deferred;
}();


var $32ae4d843238af81$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $32ae4d843238af81$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Bind the callback and only invoke the callback once regardless how many times `BindOnceFuture.call` is invoked.
 */ var $32ae4d843238af81$export$c1f52ab4952184cd = /** @class */ function() {
    function BindOnceFuture(_callback, _that) {
        this._callback = _callback;
        this._that = _that;
        this._isCalled = false;
        this._deferred = new (0, $d6b798d93fd2c1dd$export$85f6557964517f1a)();
    }
    Object.defineProperty(BindOnceFuture.prototype, "isCalled", {
        get: function() {
            return this._isCalled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindOnceFuture.prototype, "promise", {
        get: function() {
            return this._deferred.promise;
        },
        enumerable: false,
        configurable: true
    });
    BindOnceFuture.prototype.call = function() {
        var _a;
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve((_a = this._callback).call.apply(_a, $32ae4d843238af81$var$__spreadArray([
                    this._that
                ], $32ae4d843238af81$var$__read(args), false))).then(function(val) {
                    return _this._deferred.resolve(val);
                }, function(err) {
                    return _this._deferred.reject(err);
                });
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    };
    return BindOnceFuture;
}();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0e2283de51d87f46$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($0e2283de51d87f46$export$ee0fe4df4ef0f3a1 || ($0e2283de51d87f46$export$ee0fe4df4ef0f3a1 = {}));

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e170b32729b17901$export$243c1c4fe84ef188;
(function(TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})($e170b32729b17901$export$243c1c4fe84ef188 || ($e170b32729b17901$export$243c1c4fe84ef188 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $1945f8c5cd153f1f$export$5c524ddf7208c00c = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};



var $hIXGI = parcelRequire("hIXGI");
var $bfc57ce81e0eab65$var$DEFAULT_LIST_SEPARATOR = ",";
/**
 * Environment interface to define all names
 */ var $bfc57ce81e0eab65$var$ENVIRONMENT_BOOLEAN_KEYS = [
    "OTEL_SDK_DISABLED"
];
function $bfc57ce81e0eab65$var$isEnvVarABoolean(key) {
    return $bfc57ce81e0eab65$var$ENVIRONMENT_BOOLEAN_KEYS.indexOf(key) > -1;
}
var $bfc57ce81e0eab65$var$ENVIRONMENT_NUMBERS_KEYS = [
    "OTEL_BSP_EXPORT_TIMEOUT",
    "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BSP_MAX_QUEUE_SIZE",
    "OTEL_BSP_SCHEDULE_DELAY",
    "OTEL_BLRP_EXPORT_TIMEOUT",
    "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BLRP_MAX_QUEUE_SIZE",
    "OTEL_BLRP_SCHEDULE_DELAY",
    "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_LINK_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
    "OTEL_EXPORTER_OTLP_TIMEOUT",
    "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
    "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
    "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
    "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function $bfc57ce81e0eab65$var$isEnvVarANumber(key) {
    return $bfc57ce81e0eab65$var$ENVIRONMENT_NUMBERS_KEYS.indexOf(key) > -1;
}
var $bfc57ce81e0eab65$var$ENVIRONMENT_LISTS_KEYS = [
    "OTEL_NO_PATCH_MODULES",
    "OTEL_PROPAGATORS"
];
function $bfc57ce81e0eab65$var$isEnvVarAList(key) {
    return $bfc57ce81e0eab65$var$ENVIRONMENT_LISTS_KEYS.indexOf(key) > -1;
}
var $bfc57ce81e0eab65$export$d9446f3c1c12def1 = Infinity;
var $bfc57ce81e0eab65$export$6ad612be99f9ed48 = 128;
var $bfc57ce81e0eab65$export$c5bbf26b60de6148 = 128;
var $bfc57ce81e0eab65$export$f200b88493991cbe = 128;
var $bfc57ce81e0eab65$export$849dbeeeda01ae98 = {
    OTEL_SDK_DISABLED: false,
    CONTAINER_NAME: "",
    ECS_CONTAINER_METADATA_URI_V4: "",
    ECS_CONTAINER_METADATA_URI: "",
    HOSTNAME: "",
    KUBERNETES_SERVICE_HOST: "",
    NAMESPACE: "",
    OTEL_BSP_EXPORT_TIMEOUT: 30000,
    OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BSP_MAX_QUEUE_SIZE: 2048,
    OTEL_BSP_SCHEDULE_DELAY: 5000,
    OTEL_BLRP_EXPORT_TIMEOUT: 30000,
    OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
    OTEL_BLRP_SCHEDULE_DELAY: 5000,
    OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
    OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
    OTEL_EXPORTER_JAEGER_ENDPOINT: "",
    OTEL_EXPORTER_JAEGER_PASSWORD: "",
    OTEL_EXPORTER_JAEGER_USER: "",
    OTEL_EXPORTER_OTLP_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_HEADERS: "",
    OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
    OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
    OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
    OTEL_EXPORTER_OTLP_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 10000,
    OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
    OTEL_LOG_LEVEL: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).INFO,
    OTEL_NO_PATCH_MODULES: [],
    OTEL_PROPAGATORS: [
        "tracecontext",
        "baggage"
    ],
    OTEL_RESOURCE_ATTRIBUTES: "",
    OTEL_SERVICE_NAME: "",
    OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: $bfc57ce81e0eab65$export$d9446f3c1c12def1,
    OTEL_ATTRIBUTE_COUNT_LIMIT: $bfc57ce81e0eab65$export$6ad612be99f9ed48,
    OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: $bfc57ce81e0eab65$export$d9446f3c1c12def1,
    OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: $bfc57ce81e0eab65$export$6ad612be99f9ed48,
    OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: $bfc57ce81e0eab65$export$d9446f3c1c12def1,
    OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: $bfc57ce81e0eab65$export$6ad612be99f9ed48,
    OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_LINK_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: $bfc57ce81e0eab65$export$c5bbf26b60de6148,
    OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: $bfc57ce81e0eab65$export$f200b88493991cbe,
    OTEL_TRACES_EXPORTER: "",
    OTEL_TRACES_SAMPLER: (0, $e170b32729b17901$export$243c1c4fe84ef188).ParentBasedAlwaysOn,
    OTEL_TRACES_SAMPLER_ARG: "",
    OTEL_LOGS_EXPORTER: "",
    OTEL_EXPORTER_OTLP_INSECURE: "",
    OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
    OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
    OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
    OTEL_EXPORTER_OTLP_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
/**
 * @param key
 * @param environment
 * @param values
 */ function $bfc57ce81e0eab65$var$parseBoolean(key, environment, values) {
    if (typeof values[key] === "undefined") return;
    var value = String(values[key]);
    // support case-insensitive "true"
    environment[key] = value.toLowerCase() === "true";
}
/**
 * Parses a variable as number with number validation
 * @param name
 * @param environment
 * @param values
 * @param min
 * @param max
 */ function $bfc57ce81e0eab65$var$parseNumber(name, environment, values, min, max) {
    if (min === void 0) min = -Infinity;
    if (max === void 0) max = Infinity;
    if (typeof values[name] !== "undefined") {
        var value = Number(values[name]);
        if (!isNaN(value)) {
            if (value < min) environment[name] = min;
            else if (value > max) environment[name] = max;
            else environment[name] = value;
        }
    }
}
/**
 * Parses list-like strings from input into output.
 * @param name
 * @param environment
 * @param values
 * @param separator
 */ function $bfc57ce81e0eab65$var$parseStringList(name, output, input, separator) {
    if (separator === void 0) separator = $bfc57ce81e0eab65$var$DEFAULT_LIST_SEPARATOR;
    var givenValue = input[name];
    if (typeof givenValue === "string") output[name] = givenValue.split(separator).map(function(v) {
        return v.trim();
    });
}
// The support string -> DiagLogLevel mappings
var $bfc57ce81e0eab65$var$logLevelMap = {
    ALL: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).ALL,
    VERBOSE: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).VERBOSE,
    DEBUG: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).DEBUG,
    INFO: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).INFO,
    WARN: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).WARN,
    ERROR: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).ERROR,
    NONE: (0, $528b1ea68e1e1a5c$export$b7d7b4c0f3c95263).NONE
};
/**
 * Environmentally sets log level if valid log level string is provided
 * @param key
 * @param environment
 * @param values
 */ function $bfc57ce81e0eab65$var$setLogLevelFromEnv(key, environment, values) {
    var value = values[key];
    if (typeof value === "string") {
        var theLevel = $bfc57ce81e0eab65$var$logLevelMap[value.toUpperCase()];
        if (theLevel != null) environment[key] = theLevel;
    }
}
function $bfc57ce81e0eab65$export$99f17f8ee99049eb(values) {
    var environment = {};
    for(var env in $bfc57ce81e0eab65$export$849dbeeeda01ae98){
        var key = env;
        switch(key){
            case "OTEL_LOG_LEVEL":
                $bfc57ce81e0eab65$var$setLogLevelFromEnv(key, environment, values);
                break;
            default:
                if ($bfc57ce81e0eab65$var$isEnvVarABoolean(key)) $bfc57ce81e0eab65$var$parseBoolean(key, environment, values);
                else if ($bfc57ce81e0eab65$var$isEnvVarANumber(key)) $bfc57ce81e0eab65$var$parseNumber(key, environment, values);
                else if ($bfc57ce81e0eab65$var$isEnvVarAList(key)) $bfc57ce81e0eab65$var$parseStringList(key, environment, values);
                else {
                    var value = values[key];
                    if (typeof value !== "undefined" && value !== null) environment[key] = String(value);
                }
        }
    }
    return environment;
}
function $bfc57ce81e0eab65$export$728650dd4748d692() {
    return typeof $hIXGI !== "undefined" && $hIXGI && $hIXGI.env ? $bfc57ce81e0eab65$export$99f17f8ee99049eb($hIXGI.env) : $bfc57ce81e0eab65$export$99f17f8ee99049eb((0, $1945f8c5cd153f1f$export$5c524ddf7208c00c));
}



function $63326e086ae3cd19$export$4bd44a2aa29d3d6e() {
    var globalEnv = (0, $bfc57ce81e0eab65$export$99f17f8ee99049eb)((0, $1945f8c5cd153f1f$export$5c524ddf7208c00c));
    return Object.assign({}, (0, $bfc57ce81e0eab65$export$849dbeeeda01ae98), globalEnv);
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $f4e95a8b380959c3$export$cd67a16f6d11e5bd() {
    return function(ex) {
        (0, $5961b21244e407a2$export$c042e7c2f59bc046).error($f4e95a8b380959c3$var$stringifyException(ex));
    };
}
/**
 * Converts an exception into a string representation
 * @param {Exception} ex
 */ function $f4e95a8b380959c3$var$stringifyException(ex) {
    if (typeof ex === "string") return ex;
    else return JSON.stringify($f4e95a8b380959c3$var$flattenException(ex));
}
/**
 * Flattens an exception into key-value pairs by traversing the prototype chain
 * and coercing values to strings. Duplicate properties will not be overwritten;
 * the first insert wins.
 */ function $f4e95a8b380959c3$var$flattenException(ex) {
    var result = {};
    var current = ex;
    while(current !== null){
        Object.getOwnPropertyNames(current).forEach(function(propertyName) {
            if (result[propertyName]) return;
            var value = current[propertyName];
            if (value) result[propertyName] = String(value);
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}


/** The global error handler delegate */ var $0c401b13a0f4a52d$var$delegateHandler = (0, $f4e95a8b380959c3$export$cd67a16f6d11e5bd)();
function $0c401b13a0f4a52d$export$bdff946829732435(handler) {
    $0c401b13a0f4a52d$var$delegateHandler = handler;
}
function $0c401b13a0f4a52d$export$54c6946fc34b7cc2(ex) {
    try {
        $0c401b13a0f4a52d$var$delegateHandler(ex);
    } catch (_a) {} // eslint-disable-line no-empty
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $c1ddd3204a07409f$var$SUPPRESS_TRACING_KEY = (0, $8de61a3e7738d1ff$export$b8c322c5a7cfce78)("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function $c1ddd3204a07409f$export$869298f9835abc68(context) {
    return context.setValue($c1ddd3204a07409f$var$SUPPRESS_TRACING_KEY, true);
}
function $c1ddd3204a07409f$export$a8cb26cef1019d30(context) {
    return context.deleteValue($c1ddd3204a07409f$var$SUPPRESS_TRACING_KEY);
}
function $c1ddd3204a07409f$export$7d5f2376f7cf513(context) {
    return context.getValue($c1ddd3204a07409f$var$SUPPRESS_TRACING_KEY) === true;
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $44f3603a646e1f8f$export$13bcdd8a72da0e8f(_timer) {}


/**
 * Implementation of the {@link SpanProcessor} that batches spans exported by
 * the SDK then pushes them to the exporter pipeline.
 */ var $90892da214669d7c$export$54ea939f5d39e8a2 = /** @class */ function() {
    function BatchSpanProcessorBase(_exporter, config) {
        this._exporter = _exporter;
        this._isExporting = false;
        this._finishedSpans = [];
        this._droppedSpansCount = 0;
        var env = (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)();
        this._maxExportBatchSize = typeof (config === null || config === void 0 ? void 0 : config.maxExportBatchSize) === "number" ? config.maxExportBatchSize : env.OTEL_BSP_MAX_EXPORT_BATCH_SIZE;
        this._maxQueueSize = typeof (config === null || config === void 0 ? void 0 : config.maxQueueSize) === "number" ? config.maxQueueSize : env.OTEL_BSP_MAX_QUEUE_SIZE;
        this._scheduledDelayMillis = typeof (config === null || config === void 0 ? void 0 : config.scheduledDelayMillis) === "number" ? config.scheduledDelayMillis : env.OTEL_BSP_SCHEDULE_DELAY;
        this._exportTimeoutMillis = typeof (config === null || config === void 0 ? void 0 : config.exportTimeoutMillis) === "number" ? config.exportTimeoutMillis : env.OTEL_BSP_EXPORT_TIMEOUT;
        this._shutdownOnce = new (0, $32ae4d843238af81$export$c1f52ab4952184cd)(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize");
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    BatchSpanProcessorBase.prototype.forceFlush = function() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    };
    // does nothing.
    BatchSpanProcessorBase.prototype.onStart = function(_span, _parentContext) {};
    BatchSpanProcessorBase.prototype.onEnd = function(span) {
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & (0, $91d5e49b421908a7$export$bf9049ad2b0883ff).SAMPLED) === 0) return;
        this._addToBuffer(span);
    };
    BatchSpanProcessorBase.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    };
    BatchSpanProcessorBase.prototype._shutdown = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.onShutdown();
        }).then(function() {
            return _this._flushAll();
        }).then(function() {
            return _this._exporter.shutdown();
        });
    };
    /** Add a span in the buffer. */ BatchSpanProcessorBase.prototype._addToBuffer = function(span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            // limit reached, drop span
            if (this._droppedSpansCount === 0) (0, $5961b21244e407a2$export$c042e7c2f59bc046).debug("maxQueueSize reached, dropping spans");
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            // some spans were dropped, log once with count of spans dropped
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached");
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    };
    /**
     * Send all spans to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */ BatchSpanProcessorBase.prototype._flushAll = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var promises = [];
            // calculate number of batches
            var count = Math.ceil(_this._finishedSpans.length / _this._maxExportBatchSize);
            for(var i = 0, j = count; i < j; i++)promises.push(_this._flushOneBatch());
            Promise.all(promises).then(function() {
                resolve();
            }).catch(reject);
        });
    };
    BatchSpanProcessorBase.prototype._flushOneBatch = function() {
        var _this = this;
        this._clearTimer();
        if (this._finishedSpans.length === 0) return Promise.resolve();
        return new Promise(function(resolve, reject) {
            var timer = setTimeout(function() {
                // don't wait anymore for export, this way the next batch can start
                reject(new Error("Timeout"));
            }, _this._exportTimeoutMillis);
            // prevent downstream exporter calls from generating spans
            (0, $033d6775d2f4334e$export$a078c61943f9dbbe).with((0, $c1ddd3204a07409f$export$869298f9835abc68)((0, $033d6775d2f4334e$export$a078c61943f9dbbe).active()), function() {
                // Reset the finished spans buffer here because the next invocations of the _flush method
                // could pass the same finished spans to the exporter if the buffer is cleared
                // outside the execution of this callback.
                var spans = _this._finishedSpans.splice(0, _this._maxExportBatchSize);
                var doExport = function() {
                    return _this._exporter.export(spans, function(result) {
                        var _a;
                        clearTimeout(timer);
                        if (result.code === (0, $0e2283de51d87f46$export$ee0fe4df4ef0f3a1).SUCCESS) resolve();
                        else reject((_a = result.error) !== null && _a !== void 0 ? _a : new Error("BatchSpanProcessor: span export failed"));
                    });
                };
                var pendingResources = spans.map(function(span) {
                    return span.resource;
                }).filter(function(resource) {
                    return resource.asyncAttributesPending;
                });
                // Avoid scheduling a promise to make the behavior more predictable and easier to test
                if (pendingResources.length === 0) doExport();
                else Promise.all(pendingResources.map(function(resource) {
                    var _a;
                    return (_a = resource.waitForAsyncAttributes) === null || _a === void 0 ? void 0 : _a.call(resource);
                })).then(doExport, function(err) {
                    (0, $0c401b13a0f4a52d$export$54c6946fc34b7cc2)(err);
                    reject(err);
                });
            });
        });
    };
    BatchSpanProcessorBase.prototype._maybeStartTimer = function() {
        var _this = this;
        if (this._isExporting) return;
        var flush = function() {
            _this._isExporting = true;
            _this._flushOneBatch().finally(function() {
                _this._isExporting = false;
                if (_this._finishedSpans.length > 0) {
                    _this._clearTimer();
                    _this._maybeStartTimer();
                }
            }).catch(function(e) {
                _this._isExporting = false;
                (0, $0c401b13a0f4a52d$export$54c6946fc34b7cc2)(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== undefined) return;
        this._timer = setTimeout(function() {
            return flush();
        }, this._scheduledDelayMillis);
        (0, $44f3603a646e1f8f$export$13bcdd8a72da0e8f)(this._timer);
    };
    BatchSpanProcessorBase.prototype._clearTimer = function() {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    };
    return BatchSpanProcessorBase;
}();


var $e6a81b33fd165b69$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e6a81b33fd165b69$export$237547059fd543f9 = /** @class */ function(_super) {
    $e6a81b33fd165b69$var$__extends(BatchSpanProcessor, _super);
    function BatchSpanProcessor(_exporter, config) {
        var _this = _super.call(this, _exporter, config) || this;
        _this.onInit(config);
        return _this;
    }
    BatchSpanProcessor.prototype.onInit = function(config) {
        var _this = this;
        if ((config === null || config === void 0 ? void 0 : config.disableAutoFlushOnDocumentHide) !== true && typeof document !== "undefined") {
            this._visibilityChangeListener = function() {
                if (document.visibilityState === "hidden") _this.forceFlush();
            };
            this._pageHideListener = function() {
                _this.forceFlush();
            };
            document.addEventListener("visibilitychange", this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener("pagehide", this._pageHideListener);
        }
    };
    BatchSpanProcessor.prototype.onShutdown = function() {
        if (typeof document !== "undefined") {
            if (this._visibilityChangeListener) document.removeEventListener("visibilitychange", this._visibilityChangeListener);
            if (this._pageHideListener) document.removeEventListener("pagehide", this._pageHideListener);
        }
    };
    return BatchSpanProcessor;
}((0, $90892da214669d7c$export$54ea939f5d39e8a2));

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $80945b0da65f6fe7$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/** Combines multiple propagators into a single propagator. */ var $80945b0da65f6fe7$export$4beb26f46770357f = /** @class */ function() {
    /**
     * Construct a composite propagator from a list of propagators.
     *
     * @param [config] Configuration object for composite propagator
     */ function CompositePropagator(config) {
        if (config === void 0) config = {};
        var _a;
        this._propagators = (_a = config.propagators) !== null && _a !== void 0 ? _a : [];
        this._fields = Array.from(new Set(this._propagators// older propagators may not have fields function, null check to be sure
        .map(function(p) {
            return typeof p.fields === "function" ? p.fields() : [];
        }).reduce(function(x, y) {
            return x.concat(y);
        }, [])));
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same carrier key, the propagator later in the list
     * will "win".
     *
     * @param context Context to inject
     * @param carrier Carrier into which context will be injected
     */ CompositePropagator.prototype.inject = function(context, carrier, setter) {
        var e_1, _a;
        try {
            for(var _b = $80945b0da65f6fe7$var$__values(this._propagators), _c = _b.next(); !_c.done; _c = _b.next()){
                var propagator = _c.value;
                try {
                    propagator.inject(context, carrier, setter);
                } catch (err) {
                    (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same context key, the propagator later in the list
     * will "win".
     *
     * @param context Context to add values to
     * @param carrier Carrier from which to extract context
     */ CompositePropagator.prototype.extract = function(context, carrier, getter) {
        return this._propagators.reduce(function(ctx, propagator) {
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
            }
            return ctx;
        }, context);
    };
    CompositePropagator.prototype.fields = function() {
        // return a new array so our fields cannot be modified
        return this._fields.slice();
    };
    return CompositePropagator;
}();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * based on lodash in order to support esm builds without esModuleInterop.
 * lodash is using MIT License.
 **/ var $0f060419add7a491$var$objectTag = "[object Object]";
var $0f060419add7a491$var$nullTag = "[object Null]";
var $0f060419add7a491$var$undefinedTag = "[object Undefined]";
var $0f060419add7a491$var$funcProto = Function.prototype;
var $0f060419add7a491$var$funcToString = $0f060419add7a491$var$funcProto.toString;
var $0f060419add7a491$var$objectCtorString = $0f060419add7a491$var$funcToString.call(Object);
var $0f060419add7a491$var$getPrototype = $0f060419add7a491$var$overArg(Object.getPrototypeOf, Object);
var $0f060419add7a491$var$objectProto = Object.prototype;
var $0f060419add7a491$var$hasOwnProperty = $0f060419add7a491$var$objectProto.hasOwnProperty;
var $0f060419add7a491$var$symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var $0f060419add7a491$var$nativeObjectToString = $0f060419add7a491$var$objectProto.toString;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0f060419add7a491$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
function $0f060419add7a491$export$53b83ca8eaab0383(value) {
    if (!$0f060419add7a491$var$isObjectLike(value) || $0f060419add7a491$var$baseGetTag(value) !== $0f060419add7a491$var$objectTag) return false;
    var proto = $0f060419add7a491$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $0f060419add7a491$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $0f060419add7a491$var$funcToString.call(Ctor) === $0f060419add7a491$var$objectCtorString;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0f060419add7a491$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $0f060419add7a491$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $0f060419add7a491$var$undefinedTag : $0f060419add7a491$var$nullTag;
    return $0f060419add7a491$var$symToStringTag && $0f060419add7a491$var$symToStringTag in Object(value) ? $0f060419add7a491$var$getRawTag(value) : $0f060419add7a491$var$objectToString(value);
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $0f060419add7a491$var$getRawTag(value) {
    var isOwn = $0f060419add7a491$var$hasOwnProperty.call(value, $0f060419add7a491$var$symToStringTag), tag = value[$0f060419add7a491$var$symToStringTag];
    var unmasked = false;
    try {
        value[$0f060419add7a491$var$symToStringTag] = undefined;
        unmasked = true;
    } catch (e) {
    // silence
    }
    var result = $0f060419add7a491$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$0f060419add7a491$var$symToStringTag] = tag;
        else delete value[$0f060419add7a491$var$symToStringTag];
    }
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $0f060419add7a491$var$objectToString(value) {
    return $0f060419add7a491$var$nativeObjectToString.call(value);
}


var $2543edb765e58b8d$var$MAX_LEVEL = 20;
function $2543edb765e58b8d$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var result = args.shift();
    var objects = new WeakMap();
    while(args.length > 0)result = $2543edb765e58b8d$var$mergeTwoObjects(result, args.shift(), 0, objects);
    return result;
}
function $2543edb765e58b8d$var$takeValue(value) {
    if ($2543edb765e58b8d$var$isArray(value)) return value.slice();
    return value;
}
/**
 * Merges two objects
 * @param one - first object
 * @param two - second object
 * @param level - current deep level
 * @param objects - objects holder that has been already referenced - to prevent
 * cyclic dependency
 */ function $2543edb765e58b8d$var$mergeTwoObjects(one, two, level, objects) {
    if (level === void 0) level = 0;
    var result;
    if (level > $2543edb765e58b8d$var$MAX_LEVEL) return undefined;
    level++;
    if ($2543edb765e58b8d$var$isPrimitive(one) || $2543edb765e58b8d$var$isPrimitive(two) || $2543edb765e58b8d$var$isFunction(two)) result = $2543edb765e58b8d$var$takeValue(two);
    else if ($2543edb765e58b8d$var$isArray(one)) {
        result = one.slice();
        if ($2543edb765e58b8d$var$isArray(two)) for(var i = 0, j = two.length; i < j; i++)result.push($2543edb765e58b8d$var$takeValue(two[i]));
        else if ($2543edb765e58b8d$var$isObject(two)) {
            var keys = Object.keys(two);
            for(var i = 0, j = keys.length; i < j; i++){
                var key = keys[i];
                result[key] = $2543edb765e58b8d$var$takeValue(two[key]);
            }
        }
    } else if ($2543edb765e58b8d$var$isObject(one)) {
        if ($2543edb765e58b8d$var$isObject(two)) {
            if (!$2543edb765e58b8d$var$shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            var keys = Object.keys(two);
            for(var i = 0, j = keys.length; i < j; i++){
                var key = keys[i];
                var twoValue = two[key];
                if ($2543edb765e58b8d$var$isPrimitive(twoValue)) {
                    if (typeof twoValue === "undefined") delete result[key];
                    else // result[key] = takeValue(twoValue);
                    result[key] = twoValue;
                } else {
                    var obj1 = result[key];
                    var obj2 = twoValue;
                    if ($2543edb765e58b8d$var$wasObjectReferenced(one, key, objects) || $2543edb765e58b8d$var$wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if ($2543edb765e58b8d$var$isObject(obj1) && $2543edb765e58b8d$var$isObject(obj2)) {
                            var arr1 = objects.get(obj1) || [];
                            var arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = $2543edb765e58b8d$var$mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
/**
 * Function to check if object has been already reference
 * @param obj
 * @param key
 * @param objects
 */ function $2543edb765e58b8d$var$wasObjectReferenced(obj, key, objects) {
    var arr = objects.get(obj[key]) || [];
    for(var i = 0, j = arr.length; i < j; i++){
        var info = arr[i];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function $2543edb765e58b8d$var$isArray(value) {
    return Array.isArray(value);
}
function $2543edb765e58b8d$var$isFunction(value) {
    return typeof value === "function";
}
function $2543edb765e58b8d$var$isObject(value) {
    return !$2543edb765e58b8d$var$isPrimitive(value) && !$2543edb765e58b8d$var$isArray(value) && !$2543edb765e58b8d$var$isFunction(value) && typeof value === "object";
}
function $2543edb765e58b8d$var$isPrimitive(value) {
    return typeof value === "string" || typeof value === "number" || typeof value === "boolean" || typeof value === "undefined" || value instanceof Date || value instanceof RegExp || value === null;
}
function $2543edb765e58b8d$var$shouldMerge(one, two) {
    if (!(0, $0f060419add7a491$export$53b83ca8eaab0383)(one) || !(0, $0f060419add7a491$export$53b83ca8eaab0383)(two)) return false;
    return true;
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a3035f497d516997$export$3043215ef908d54f = "=";
var $a3035f497d516997$export$393a3f9e6e76438 = ";";
var $a3035f497d516997$export$1ab471785c2cf557 = ",";
var $a3035f497d516997$export$a6199dd4fe419e69 = "baggage";
var $a3035f497d516997$export$9a50757016085e99 = 180;
var $a3035f497d516997$export$c7d9e39bb295c1f = 4096;
var $a3035f497d516997$export$dd0527bee1f518e7 = 8192;




var $39ed3401e791ff40$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $39ed3401e791ff40$export$790fc82b2ff5bf87(keyPairs) {
    return keyPairs.reduce(function(hValue, current) {
        var value = "" + hValue + (hValue !== "" ? (0, $a3035f497d516997$export$1ab471785c2cf557) : "") + current;
        return value.length > (0, $a3035f497d516997$export$dd0527bee1f518e7) ? hValue : value;
    }, "");
}
function $39ed3401e791ff40$export$ed4c06f0919b1951(baggage) {
    return baggage.getAllEntries().map(function(_a) {
        var _b = $39ed3401e791ff40$var$__read(_a, 2), key = _b[0], value = _b[1];
        var entry = encodeURIComponent(key) + "=" + encodeURIComponent(value.value);
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) entry += (0, $a3035f497d516997$export$393a3f9e6e76438) + value.metadata.toString();
        return entry;
    });
}
function $39ed3401e791ff40$export$62659c450b08e504(entry) {
    var valueProps = entry.split((0, $a3035f497d516997$export$393a3f9e6e76438));
    if (valueProps.length <= 0) return;
    var keyPairPart = valueProps.shift();
    if (!keyPairPart) return;
    var separatorIndex = keyPairPart.indexOf((0, $a3035f497d516997$export$3043215ef908d54f));
    if (separatorIndex <= 0) return;
    var key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    var value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    var metadata;
    if (valueProps.length > 0) metadata = (0, $d831bfbe72d38937$export$c491cedc1b2b6e9e)(valueProps.join((0, $a3035f497d516997$export$393a3f9e6e76438)));
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
function $39ed3401e791ff40$export$1259660ed6830e21(value) {
    if (typeof value !== "string" || value.length === 0) return {};
    return value.split((0, $a3035f497d516997$export$1ab471785c2cf557)).map(function(entry) {
        return $39ed3401e791ff40$export$62659c450b08e504(entry);
    }).filter(function(keyPair) {
        return keyPair !== undefined && keyPair.value.length > 0;
    }).reduce(function(headers, keyPair) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        headers[keyPair.key] = keyPair.value;
        return headers;
    }, {});
}


/**
 * Propagates {@link Baggage} through Context format propagation.
 *
 * Based on the Baggage specification:
 * https://w3c.github.io/baggage/
 */ var $647d2239f8c3b03d$export$604bcc7f2bff6bb = /** @class */ function() {
    function W3CBaggagePropagator() {}
    W3CBaggagePropagator.prototype.inject = function(context, carrier, setter) {
        var baggage = (0, $64245f18975a06c0$export$3e49040daa9dba20).getBaggage(context);
        if (!baggage || (0, $c1ddd3204a07409f$export$7d5f2376f7cf513)(context)) return;
        var keyPairs = (0, $39ed3401e791ff40$export$ed4c06f0919b1951)(baggage).filter(function(pair) {
            return pair.length <= (0, $a3035f497d516997$export$c7d9e39bb295c1f);
        }).slice(0, (0, $a3035f497d516997$export$9a50757016085e99));
        var headerValue = (0, $39ed3401e791ff40$export$790fc82b2ff5bf87)(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, (0, $a3035f497d516997$export$a6199dd4fe419e69), headerValue);
    };
    W3CBaggagePropagator.prototype.extract = function(context, carrier, getter) {
        var headerValue = getter.get(carrier, (0, $a3035f497d516997$export$a6199dd4fe419e69));
        var baggageString = Array.isArray(headerValue) ? headerValue.join((0, $a3035f497d516997$export$1ab471785c2cf557)) : headerValue;
        if (!baggageString) return context;
        var baggage = {};
        if (baggageString.length === 0) return context;
        var pairs = baggageString.split((0, $a3035f497d516997$export$1ab471785c2cf557));
        pairs.forEach(function(entry) {
            var keyPair = (0, $39ed3401e791ff40$export$62659c450b08e504)(entry);
            if (keyPair) {
                var baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context;
        return (0, $64245f18975a06c0$export$3e49040daa9dba20).setBaggage(context, (0, $64245f18975a06c0$export$3e49040daa9dba20).createBaggage(baggage));
    };
    W3CBaggagePropagator.prototype.fields = function() {
        return [
            (0, $a3035f497d516997$export$a6199dd4fe419e69)
        ];
    };
    return W3CBaggagePropagator;
}();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d475dfdf92c1c381$var$VALID_KEY_CHAR_RANGE = "[_0-9a-z-*/]";
var $d475dfdf92c1c381$var$VALID_KEY = "[a-z]" + $d475dfdf92c1c381$var$VALID_KEY_CHAR_RANGE + "{0,255}";
var $d475dfdf92c1c381$var$VALID_VENDOR_KEY = "[a-z0-9]" + $d475dfdf92c1c381$var$VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + $d475dfdf92c1c381$var$VALID_KEY_CHAR_RANGE + "{0,13}";
var $d475dfdf92c1c381$var$VALID_KEY_REGEX = new RegExp("^(?:" + $d475dfdf92c1c381$var$VALID_KEY + "|" + $d475dfdf92c1c381$var$VALID_VENDOR_KEY + ")$");
var $d475dfdf92c1c381$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
var $d475dfdf92c1c381$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $d475dfdf92c1c381$export$469cc9c479301ba6(key) {
    return $d475dfdf92c1c381$var$VALID_KEY_REGEX.test(key);
}
function $d475dfdf92c1c381$export$b76e9316566cc26e(value) {
    return $d475dfdf92c1c381$var$VALID_VALUE_BASE_REGEX.test(value) && !$d475dfdf92c1c381$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}


var $8eb92c94f99a75d1$var$MAX_TRACE_STATE_ITEMS = 32;
var $8eb92c94f99a75d1$var$MAX_TRACE_STATE_LEN = 512;
var $8eb92c94f99a75d1$var$LIST_MEMBERS_SEPARATOR = ",";
var $8eb92c94f99a75d1$var$LIST_MEMBER_KEY_VALUE_SPLITTER = "=";
/**
 * TraceState must be a class and not a simple object type because of the spec
 * requirement (https://www.w3.org/TR/trace-context/#tracestate-field).
 *
 * Here is the list of allowed mutations:
 * - New key-value pair should be added into the beginning of the list
 * - The value of any key can be updated. Modified keys MUST be moved to the
 * beginning of the list.
 */ var $8eb92c94f99a75d1$export$b0addedc390b67c2 = /** @class */ function() {
    function TraceState(rawTraceState) {
        this._internalState = new Map();
        if (rawTraceState) this._parse(rawTraceState);
    }
    TraceState.prototype.set = function(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        var traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    };
    TraceState.prototype.unset = function(key) {
        var traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    };
    TraceState.prototype.get = function(key) {
        return this._internalState.get(key);
    };
    TraceState.prototype.serialize = function() {
        var _this = this;
        return this._keys().reduce(function(agg, key) {
            agg.push(key + $8eb92c94f99a75d1$var$LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
            return agg;
        }, []).join($8eb92c94f99a75d1$var$LIST_MEMBERS_SEPARATOR);
    };
    TraceState.prototype._parse = function(rawTraceState) {
        if (rawTraceState.length > $8eb92c94f99a75d1$var$MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split($8eb92c94f99a75d1$var$LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce(function(agg, part) {
            var listMember = part.trim(); // Optional Whitespace (OWS) handling
            var i = listMember.indexOf($8eb92c94f99a75d1$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if ((0, $d475dfdf92c1c381$export$469cc9c479301ba6)(key) && (0, $d475dfdf92c1c381$export$b76e9316566cc26e)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > $8eb92c94f99a75d1$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, $8eb92c94f99a75d1$var$MAX_TRACE_STATE_ITEMS));
    };
    TraceState.prototype._keys = function() {
        return Array.from(this._internalState.keys()).reverse();
    };
    TraceState.prototype._clone = function() {
        var traceState = new TraceState();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    };
    return TraceState;
}();


var $5584fa283530c440$export$830e05fa2746348 = "traceparent";
var $5584fa283530c440$export$2b12ed38dcfae2ae = "tracestate";
var $5584fa283530c440$var$VERSION = "00";
var $5584fa283530c440$var$VERSION_PART = "(?!ff)[\\da-f]{2}";
var $5584fa283530c440$var$TRACE_ID_PART = "(?![0]{32})[\\da-f]{32}";
var $5584fa283530c440$var$PARENT_ID_PART = "(?![0]{16})[\\da-f]{16}";
var $5584fa283530c440$var$FLAGS_PART = "[\\da-f]{2}";
var $5584fa283530c440$var$TRACE_PARENT_REGEX = new RegExp("^\\s?(" + $5584fa283530c440$var$VERSION_PART + ")-(" + $5584fa283530c440$var$TRACE_ID_PART + ")-(" + $5584fa283530c440$var$PARENT_ID_PART + ")-(" + $5584fa283530c440$var$FLAGS_PART + ")(-.*)?\\s?$");
function $5584fa283530c440$export$f4d87f8901a93f5d(traceParent) {
    var match = $5584fa283530c440$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === "00" && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
/**
 * Propagates {@link SpanContext} through Trace Context format propagation.
 *
 * Based on the Trace Context specification:
 * https://www.w3.org/TR/trace-context/
 */ var $5584fa283530c440$export$737c747d043a1f7b = /** @class */ function() {
    function W3CTraceContextPropagator() {}
    W3CTraceContextPropagator.prototype.inject = function(context, carrier, setter) {
        var spanContext = (0, $74ed2dbfdbf87d9b$export$357889f174732d38).getSpanContext(context);
        if (!spanContext || (0, $c1ddd3204a07409f$export$7d5f2376f7cf513)(context) || !(0, $eb966c722689e573$export$e4373b9a2c09216c)(spanContext)) return;
        var traceParent = $5584fa283530c440$var$VERSION + "-" + spanContext.traceId + "-" + spanContext.spanId + "-0" + Number(spanContext.traceFlags || (0, $91d5e49b421908a7$export$bf9049ad2b0883ff).NONE).toString(16);
        setter.set(carrier, $5584fa283530c440$export$830e05fa2746348, traceParent);
        if (spanContext.traceState) setter.set(carrier, $5584fa283530c440$export$2b12ed38dcfae2ae, spanContext.traceState.serialize());
    };
    W3CTraceContextPropagator.prototype.extract = function(context, carrier, getter) {
        var traceParentHeader = getter.get(carrier, $5584fa283530c440$export$830e05fa2746348);
        if (!traceParentHeader) return context;
        var traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== "string") return context;
        var spanContext = $5584fa283530c440$export$f4d87f8901a93f5d(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        var traceStateHeader = getter.get(carrier, $5584fa283530c440$export$2b12ed38dcfae2ae);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            var state = Array.isArray(traceStateHeader) ? traceStateHeader.join(",") : traceStateHeader;
            spanContext.traceState = new (0, $8eb92c94f99a75d1$export$b0addedc390b67c2)(typeof state === "string" ? state : undefined);
        }
        return (0, $74ed2dbfdbf87d9b$export$357889f174732d38).setSpanContext(context, spanContext);
    };
    W3CTraceContextPropagator.prototype.fields = function() {
        return [
            $5584fa283530c440$export$830e05fa2746348,
            $5584fa283530c440$export$2b12ed38dcfae2ae
        ];
    };
    return W3CTraceContextPropagator;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a const map from the given values
 * @param values - An array of values to be used as keys and values in the map.
 * @returns A populated version of the map with the values and keys derived from the values.
 */ /*#__NO_SIDE_EFFECTS__*/ function $3d716593ec506807$export$8796db7ca257d576(values) {
    // eslint-disable-next-line prefer-const, @typescript-eslint/no-explicit-any
    var res = {};
    var len = values.length;
    for(var lp = 0; lp < len; lp++){
        var val = values[lp];
        if (val) res[String(val).toUpperCase().replace(/[-.]/g, "_")] = val;
    }
    return res;
}


//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticResourceAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $732ab3392002ce26$var$TMP_CLOUD_PROVIDER = "cloud.provider";
var $732ab3392002ce26$var$TMP_CLOUD_ACCOUNT_ID = "cloud.account.id";
var $732ab3392002ce26$var$TMP_CLOUD_REGION = "cloud.region";
var $732ab3392002ce26$var$TMP_CLOUD_AVAILABILITY_ZONE = "cloud.availability_zone";
var $732ab3392002ce26$var$TMP_CLOUD_PLATFORM = "cloud.platform";
var $732ab3392002ce26$var$TMP_AWS_ECS_CONTAINER_ARN = "aws.ecs.container.arn";
var $732ab3392002ce26$var$TMP_AWS_ECS_CLUSTER_ARN = "aws.ecs.cluster.arn";
var $732ab3392002ce26$var$TMP_AWS_ECS_LAUNCHTYPE = "aws.ecs.launchtype";
var $732ab3392002ce26$var$TMP_AWS_ECS_TASK_ARN = "aws.ecs.task.arn";
var $732ab3392002ce26$var$TMP_AWS_ECS_TASK_FAMILY = "aws.ecs.task.family";
var $732ab3392002ce26$var$TMP_AWS_ECS_TASK_REVISION = "aws.ecs.task.revision";
var $732ab3392002ce26$var$TMP_AWS_EKS_CLUSTER_ARN = "aws.eks.cluster.arn";
var $732ab3392002ce26$var$TMP_AWS_LOG_GROUP_NAMES = "aws.log.group.names";
var $732ab3392002ce26$var$TMP_AWS_LOG_GROUP_ARNS = "aws.log.group.arns";
var $732ab3392002ce26$var$TMP_AWS_LOG_STREAM_NAMES = "aws.log.stream.names";
var $732ab3392002ce26$var$TMP_AWS_LOG_STREAM_ARNS = "aws.log.stream.arns";
var $732ab3392002ce26$var$TMP_CONTAINER_NAME = "container.name";
var $732ab3392002ce26$var$TMP_CONTAINER_ID = "container.id";
var $732ab3392002ce26$var$TMP_CONTAINER_RUNTIME = "container.runtime";
var $732ab3392002ce26$var$TMP_CONTAINER_IMAGE_NAME = "container.image.name";
var $732ab3392002ce26$var$TMP_CONTAINER_IMAGE_TAG = "container.image.tag";
var $732ab3392002ce26$var$TMP_DEPLOYMENT_ENVIRONMENT = "deployment.environment";
var $732ab3392002ce26$var$TMP_DEVICE_ID = "device.id";
var $732ab3392002ce26$var$TMP_DEVICE_MODEL_IDENTIFIER = "device.model.identifier";
var $732ab3392002ce26$var$TMP_DEVICE_MODEL_NAME = "device.model.name";
var $732ab3392002ce26$var$TMP_FAAS_NAME = "faas.name";
var $732ab3392002ce26$var$TMP_FAAS_ID = "faas.id";
var $732ab3392002ce26$var$TMP_FAAS_VERSION = "faas.version";
var $732ab3392002ce26$var$TMP_FAAS_INSTANCE = "faas.instance";
var $732ab3392002ce26$var$TMP_FAAS_MAX_MEMORY = "faas.max_memory";
var $732ab3392002ce26$var$TMP_HOST_ID = "host.id";
var $732ab3392002ce26$var$TMP_HOST_NAME = "host.name";
var $732ab3392002ce26$var$TMP_HOST_TYPE = "host.type";
var $732ab3392002ce26$var$TMP_HOST_ARCH = "host.arch";
var $732ab3392002ce26$var$TMP_HOST_IMAGE_NAME = "host.image.name";
var $732ab3392002ce26$var$TMP_HOST_IMAGE_ID = "host.image.id";
var $732ab3392002ce26$var$TMP_HOST_IMAGE_VERSION = "host.image.version";
var $732ab3392002ce26$var$TMP_K8S_CLUSTER_NAME = "k8s.cluster.name";
var $732ab3392002ce26$var$TMP_K8S_NODE_NAME = "k8s.node.name";
var $732ab3392002ce26$var$TMP_K8S_NODE_UID = "k8s.node.uid";
var $732ab3392002ce26$var$TMP_K8S_NAMESPACE_NAME = "k8s.namespace.name";
var $732ab3392002ce26$var$TMP_K8S_POD_UID = "k8s.pod.uid";
var $732ab3392002ce26$var$TMP_K8S_POD_NAME = "k8s.pod.name";
var $732ab3392002ce26$var$TMP_K8S_CONTAINER_NAME = "k8s.container.name";
var $732ab3392002ce26$var$TMP_K8S_REPLICASET_UID = "k8s.replicaset.uid";
var $732ab3392002ce26$var$TMP_K8S_REPLICASET_NAME = "k8s.replicaset.name";
var $732ab3392002ce26$var$TMP_K8S_DEPLOYMENT_UID = "k8s.deployment.uid";
var $732ab3392002ce26$var$TMP_K8S_DEPLOYMENT_NAME = "k8s.deployment.name";
var $732ab3392002ce26$var$TMP_K8S_STATEFULSET_UID = "k8s.statefulset.uid";
var $732ab3392002ce26$var$TMP_K8S_STATEFULSET_NAME = "k8s.statefulset.name";
var $732ab3392002ce26$var$TMP_K8S_DAEMONSET_UID = "k8s.daemonset.uid";
var $732ab3392002ce26$var$TMP_K8S_DAEMONSET_NAME = "k8s.daemonset.name";
var $732ab3392002ce26$var$TMP_K8S_JOB_UID = "k8s.job.uid";
var $732ab3392002ce26$var$TMP_K8S_JOB_NAME = "k8s.job.name";
var $732ab3392002ce26$var$TMP_K8S_CRONJOB_UID = "k8s.cronjob.uid";
var $732ab3392002ce26$var$TMP_K8S_CRONJOB_NAME = "k8s.cronjob.name";
var $732ab3392002ce26$var$TMP_OS_TYPE = "os.type";
var $732ab3392002ce26$var$TMP_OS_DESCRIPTION = "os.description";
var $732ab3392002ce26$var$TMP_OS_NAME = "os.name";
var $732ab3392002ce26$var$TMP_OS_VERSION = "os.version";
var $732ab3392002ce26$var$TMP_PROCESS_PID = "process.pid";
var $732ab3392002ce26$var$TMP_PROCESS_EXECUTABLE_NAME = "process.executable.name";
var $732ab3392002ce26$var$TMP_PROCESS_EXECUTABLE_PATH = "process.executable.path";
var $732ab3392002ce26$var$TMP_PROCESS_COMMAND = "process.command";
var $732ab3392002ce26$var$TMP_PROCESS_COMMAND_LINE = "process.command_line";
var $732ab3392002ce26$var$TMP_PROCESS_COMMAND_ARGS = "process.command_args";
var $732ab3392002ce26$var$TMP_PROCESS_OWNER = "process.owner";
var $732ab3392002ce26$var$TMP_PROCESS_RUNTIME_NAME = "process.runtime.name";
var $732ab3392002ce26$var$TMP_PROCESS_RUNTIME_VERSION = "process.runtime.version";
var $732ab3392002ce26$var$TMP_PROCESS_RUNTIME_DESCRIPTION = "process.runtime.description";
var $732ab3392002ce26$var$TMP_SERVICE_NAME = "service.name";
var $732ab3392002ce26$var$TMP_SERVICE_NAMESPACE = "service.namespace";
var $732ab3392002ce26$var$TMP_SERVICE_INSTANCE_ID = "service.instance.id";
var $732ab3392002ce26$var$TMP_SERVICE_VERSION = "service.version";
var $732ab3392002ce26$var$TMP_TELEMETRY_SDK_NAME = "telemetry.sdk.name";
var $732ab3392002ce26$var$TMP_TELEMETRY_SDK_LANGUAGE = "telemetry.sdk.language";
var $732ab3392002ce26$var$TMP_TELEMETRY_SDK_VERSION = "telemetry.sdk.version";
var $732ab3392002ce26$var$TMP_TELEMETRY_AUTO_VERSION = "telemetry.auto.version";
var $732ab3392002ce26$var$TMP_WEBENGINE_NAME = "webengine.name";
var $732ab3392002ce26$var$TMP_WEBENGINE_VERSION = "webengine.version";
var $732ab3392002ce26$var$TMP_WEBENGINE_DESCRIPTION = "webengine.description";
var $732ab3392002ce26$export$9fa486cd651f5f18 = $732ab3392002ce26$var$TMP_CLOUD_PROVIDER;
var $732ab3392002ce26$export$3b9e160fb5fd0b48 = $732ab3392002ce26$var$TMP_CLOUD_ACCOUNT_ID;
var $732ab3392002ce26$export$7dda4a2b7e6f2925 = $732ab3392002ce26$var$TMP_CLOUD_REGION;
var $732ab3392002ce26$export$ba02b007970def42 = $732ab3392002ce26$var$TMP_CLOUD_AVAILABILITY_ZONE;
var $732ab3392002ce26$export$112df106e7dd2eda = $732ab3392002ce26$var$TMP_CLOUD_PLATFORM;
var $732ab3392002ce26$export$a43adfce130205e = $732ab3392002ce26$var$TMP_AWS_ECS_CONTAINER_ARN;
var $732ab3392002ce26$export$2ba3c01be08dc7b1 = $732ab3392002ce26$var$TMP_AWS_ECS_CLUSTER_ARN;
var $732ab3392002ce26$export$323329f2ad65b2aa = $732ab3392002ce26$var$TMP_AWS_ECS_LAUNCHTYPE;
var $732ab3392002ce26$export$5275732a76e56248 = $732ab3392002ce26$var$TMP_AWS_ECS_TASK_ARN;
var $732ab3392002ce26$export$fb3f0b7a7be1babd = $732ab3392002ce26$var$TMP_AWS_ECS_TASK_FAMILY;
var $732ab3392002ce26$export$3ed6f78d5dfa8242 = $732ab3392002ce26$var$TMP_AWS_ECS_TASK_REVISION;
var $732ab3392002ce26$export$a7708dae05d391dc = $732ab3392002ce26$var$TMP_AWS_EKS_CLUSTER_ARN;
var $732ab3392002ce26$export$bf434df1f3c89b1 = $732ab3392002ce26$var$TMP_AWS_LOG_GROUP_NAMES;
var $732ab3392002ce26$export$c522b98ccd83a439 = $732ab3392002ce26$var$TMP_AWS_LOG_GROUP_ARNS;
var $732ab3392002ce26$export$40794b06cac6b1bc = $732ab3392002ce26$var$TMP_AWS_LOG_STREAM_NAMES;
var $732ab3392002ce26$export$c9f081f4b744b01b = $732ab3392002ce26$var$TMP_AWS_LOG_STREAM_ARNS;
var $732ab3392002ce26$export$3e6fef409a60fc1e = $732ab3392002ce26$var$TMP_CONTAINER_NAME;
var $732ab3392002ce26$export$4d0381aa96fe1c3b = $732ab3392002ce26$var$TMP_CONTAINER_ID;
var $732ab3392002ce26$export$8806c0adf7bb0584 = $732ab3392002ce26$var$TMP_CONTAINER_RUNTIME;
var $732ab3392002ce26$export$44771c6519c06259 = $732ab3392002ce26$var$TMP_CONTAINER_IMAGE_NAME;
var $732ab3392002ce26$export$9f5798300d33c86b = $732ab3392002ce26$var$TMP_CONTAINER_IMAGE_TAG;
var $732ab3392002ce26$export$4783aaf4e8f7afa0 = $732ab3392002ce26$var$TMP_DEPLOYMENT_ENVIRONMENT;
var $732ab3392002ce26$export$6e497113334fabdb = $732ab3392002ce26$var$TMP_DEVICE_ID;
var $732ab3392002ce26$export$73c71cc1c141692b = $732ab3392002ce26$var$TMP_DEVICE_MODEL_IDENTIFIER;
var $732ab3392002ce26$export$44e87b3b8704bc8a = $732ab3392002ce26$var$TMP_DEVICE_MODEL_NAME;
var $732ab3392002ce26$export$fe110625e5aee93d = $732ab3392002ce26$var$TMP_FAAS_NAME;
var $732ab3392002ce26$export$6bbd0c1523702b22 = $732ab3392002ce26$var$TMP_FAAS_ID;
var $732ab3392002ce26$export$b1cb8996c7f671f1 = $732ab3392002ce26$var$TMP_FAAS_VERSION;
var $732ab3392002ce26$export$aa4a460944af09fe = $732ab3392002ce26$var$TMP_FAAS_INSTANCE;
var $732ab3392002ce26$export$a099969737f46339 = $732ab3392002ce26$var$TMP_FAAS_MAX_MEMORY;
var $732ab3392002ce26$export$e0a684ea09b55cf4 = $732ab3392002ce26$var$TMP_HOST_ID;
var $732ab3392002ce26$export$3b62edd76224926e = $732ab3392002ce26$var$TMP_HOST_NAME;
var $732ab3392002ce26$export$ba26ec134241ab05 = $732ab3392002ce26$var$TMP_HOST_TYPE;
var $732ab3392002ce26$export$4ef6e9b690c5d3ad = $732ab3392002ce26$var$TMP_HOST_ARCH;
var $732ab3392002ce26$export$80c1be409ca0daf7 = $732ab3392002ce26$var$TMP_HOST_IMAGE_NAME;
var $732ab3392002ce26$export$ae211b0849dd0d75 = $732ab3392002ce26$var$TMP_HOST_IMAGE_ID;
var $732ab3392002ce26$export$729ea06c32794759 = $732ab3392002ce26$var$TMP_HOST_IMAGE_VERSION;
var $732ab3392002ce26$export$9e0ac736c1d187bc = $732ab3392002ce26$var$TMP_K8S_CLUSTER_NAME;
var $732ab3392002ce26$export$e2479edf033ed1cd = $732ab3392002ce26$var$TMP_K8S_NODE_NAME;
var $732ab3392002ce26$export$a348ce0508cee2d8 = $732ab3392002ce26$var$TMP_K8S_NODE_UID;
var $732ab3392002ce26$export$f74f5d90b490f9a6 = $732ab3392002ce26$var$TMP_K8S_NAMESPACE_NAME;
var $732ab3392002ce26$export$341429c1b099564 = $732ab3392002ce26$var$TMP_K8S_POD_UID;
var $732ab3392002ce26$export$9e6f11bbfd666f4d = $732ab3392002ce26$var$TMP_K8S_POD_NAME;
var $732ab3392002ce26$export$ee1ae14ab5631334 = $732ab3392002ce26$var$TMP_K8S_CONTAINER_NAME;
var $732ab3392002ce26$export$845974e52d5d977b = $732ab3392002ce26$var$TMP_K8S_REPLICASET_UID;
var $732ab3392002ce26$export$1735237e4ef99ddc = $732ab3392002ce26$var$TMP_K8S_REPLICASET_NAME;
var $732ab3392002ce26$export$ff557043393b8413 = $732ab3392002ce26$var$TMP_K8S_DEPLOYMENT_UID;
var $732ab3392002ce26$export$1b29810364e6fd87 = $732ab3392002ce26$var$TMP_K8S_DEPLOYMENT_NAME;
var $732ab3392002ce26$export$fd37db901d73f6dc = $732ab3392002ce26$var$TMP_K8S_STATEFULSET_UID;
var $732ab3392002ce26$export$8030a8ee6a430fb9 = $732ab3392002ce26$var$TMP_K8S_STATEFULSET_NAME;
var $732ab3392002ce26$export$6369d5a7f9c03019 = $732ab3392002ce26$var$TMP_K8S_DAEMONSET_UID;
var $732ab3392002ce26$export$f55c2f841978e686 = $732ab3392002ce26$var$TMP_K8S_DAEMONSET_NAME;
var $732ab3392002ce26$export$1618e60c71672510 = $732ab3392002ce26$var$TMP_K8S_JOB_UID;
var $732ab3392002ce26$export$fae3f547adbfd628 = $732ab3392002ce26$var$TMP_K8S_JOB_NAME;
var $732ab3392002ce26$export$c6a5d371a9279cc4 = $732ab3392002ce26$var$TMP_K8S_CRONJOB_UID;
var $732ab3392002ce26$export$2411967a413e48d4 = $732ab3392002ce26$var$TMP_K8S_CRONJOB_NAME;
var $732ab3392002ce26$export$832bf06644fbf55d = $732ab3392002ce26$var$TMP_OS_TYPE;
var $732ab3392002ce26$export$5ea67b5ceab8e5b2 = $732ab3392002ce26$var$TMP_OS_DESCRIPTION;
var $732ab3392002ce26$export$ba2bcf7e30621987 = $732ab3392002ce26$var$TMP_OS_NAME;
var $732ab3392002ce26$export$e0381cc218bde593 = $732ab3392002ce26$var$TMP_OS_VERSION;
var $732ab3392002ce26$export$f184e78598ab0d4c = $732ab3392002ce26$var$TMP_PROCESS_PID;
var $732ab3392002ce26$export$e2e53a1071096d12 = $732ab3392002ce26$var$TMP_PROCESS_EXECUTABLE_NAME;
var $732ab3392002ce26$export$cc1c2bacfc72d251 = $732ab3392002ce26$var$TMP_PROCESS_EXECUTABLE_PATH;
var $732ab3392002ce26$export$1921c91b182b21e6 = $732ab3392002ce26$var$TMP_PROCESS_COMMAND;
var $732ab3392002ce26$export$33d6a2745a92e4bf = $732ab3392002ce26$var$TMP_PROCESS_COMMAND_LINE;
var $732ab3392002ce26$export$1a3243771890bbd7 = $732ab3392002ce26$var$TMP_PROCESS_COMMAND_ARGS;
var $732ab3392002ce26$export$5bc9efe4d24f374b = $732ab3392002ce26$var$TMP_PROCESS_OWNER;
var $732ab3392002ce26$export$6c52ea893832d871 = $732ab3392002ce26$var$TMP_PROCESS_RUNTIME_NAME;
var $732ab3392002ce26$export$7c038ff97737b111 = $732ab3392002ce26$var$TMP_PROCESS_RUNTIME_VERSION;
var $732ab3392002ce26$export$cae71c4fbbf205fb = $732ab3392002ce26$var$TMP_PROCESS_RUNTIME_DESCRIPTION;
var $732ab3392002ce26$export$48c68257f49298c9 = $732ab3392002ce26$var$TMP_SERVICE_NAME;
var $732ab3392002ce26$export$77c0752ab7c26c9 = $732ab3392002ce26$var$TMP_SERVICE_NAMESPACE;
var $732ab3392002ce26$export$bb5ecf41777e0d0c = $732ab3392002ce26$var$TMP_SERVICE_INSTANCE_ID;
var $732ab3392002ce26$export$202d10b361b87ab2 = $732ab3392002ce26$var$TMP_SERVICE_VERSION;
var $732ab3392002ce26$export$2d668a3bde1cddea = $732ab3392002ce26$var$TMP_TELEMETRY_SDK_NAME;
var $732ab3392002ce26$export$b5c1717bbc4c6044 = $732ab3392002ce26$var$TMP_TELEMETRY_SDK_LANGUAGE;
var $732ab3392002ce26$export$e0b67501ecc1df37 = $732ab3392002ce26$var$TMP_TELEMETRY_SDK_VERSION;
var $732ab3392002ce26$export$3d43fbbcabb62eca = $732ab3392002ce26$var$TMP_TELEMETRY_AUTO_VERSION;
var $732ab3392002ce26$export$a6b7ffad45e0c20b = $732ab3392002ce26$var$TMP_WEBENGINE_NAME;
var $732ab3392002ce26$export$589250d7a0c7cee4 = $732ab3392002ce26$var$TMP_WEBENGINE_VERSION;
var $732ab3392002ce26$export$3318c199ccb51731 = $732ab3392002ce26$var$TMP_WEBENGINE_DESCRIPTION;
var $732ab3392002ce26$export$85d6ffe28a084c78 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $732ab3392002ce26$var$TMP_CLOUD_PROVIDER,
    $732ab3392002ce26$var$TMP_CLOUD_ACCOUNT_ID,
    $732ab3392002ce26$var$TMP_CLOUD_REGION,
    $732ab3392002ce26$var$TMP_CLOUD_AVAILABILITY_ZONE,
    $732ab3392002ce26$var$TMP_CLOUD_PLATFORM,
    $732ab3392002ce26$var$TMP_AWS_ECS_CONTAINER_ARN,
    $732ab3392002ce26$var$TMP_AWS_ECS_CLUSTER_ARN,
    $732ab3392002ce26$var$TMP_AWS_ECS_LAUNCHTYPE,
    $732ab3392002ce26$var$TMP_AWS_ECS_TASK_ARN,
    $732ab3392002ce26$var$TMP_AWS_ECS_TASK_FAMILY,
    $732ab3392002ce26$var$TMP_AWS_ECS_TASK_REVISION,
    $732ab3392002ce26$var$TMP_AWS_EKS_CLUSTER_ARN,
    $732ab3392002ce26$var$TMP_AWS_LOG_GROUP_NAMES,
    $732ab3392002ce26$var$TMP_AWS_LOG_GROUP_ARNS,
    $732ab3392002ce26$var$TMP_AWS_LOG_STREAM_NAMES,
    $732ab3392002ce26$var$TMP_AWS_LOG_STREAM_ARNS,
    $732ab3392002ce26$var$TMP_CONTAINER_NAME,
    $732ab3392002ce26$var$TMP_CONTAINER_ID,
    $732ab3392002ce26$var$TMP_CONTAINER_RUNTIME,
    $732ab3392002ce26$var$TMP_CONTAINER_IMAGE_NAME,
    $732ab3392002ce26$var$TMP_CONTAINER_IMAGE_TAG,
    $732ab3392002ce26$var$TMP_DEPLOYMENT_ENVIRONMENT,
    $732ab3392002ce26$var$TMP_DEVICE_ID,
    $732ab3392002ce26$var$TMP_DEVICE_MODEL_IDENTIFIER,
    $732ab3392002ce26$var$TMP_DEVICE_MODEL_NAME,
    $732ab3392002ce26$var$TMP_FAAS_NAME,
    $732ab3392002ce26$var$TMP_FAAS_ID,
    $732ab3392002ce26$var$TMP_FAAS_VERSION,
    $732ab3392002ce26$var$TMP_FAAS_INSTANCE,
    $732ab3392002ce26$var$TMP_FAAS_MAX_MEMORY,
    $732ab3392002ce26$var$TMP_HOST_ID,
    $732ab3392002ce26$var$TMP_HOST_NAME,
    $732ab3392002ce26$var$TMP_HOST_TYPE,
    $732ab3392002ce26$var$TMP_HOST_ARCH,
    $732ab3392002ce26$var$TMP_HOST_IMAGE_NAME,
    $732ab3392002ce26$var$TMP_HOST_IMAGE_ID,
    $732ab3392002ce26$var$TMP_HOST_IMAGE_VERSION,
    $732ab3392002ce26$var$TMP_K8S_CLUSTER_NAME,
    $732ab3392002ce26$var$TMP_K8S_NODE_NAME,
    $732ab3392002ce26$var$TMP_K8S_NODE_UID,
    $732ab3392002ce26$var$TMP_K8S_NAMESPACE_NAME,
    $732ab3392002ce26$var$TMP_K8S_POD_UID,
    $732ab3392002ce26$var$TMP_K8S_POD_NAME,
    $732ab3392002ce26$var$TMP_K8S_CONTAINER_NAME,
    $732ab3392002ce26$var$TMP_K8S_REPLICASET_UID,
    $732ab3392002ce26$var$TMP_K8S_REPLICASET_NAME,
    $732ab3392002ce26$var$TMP_K8S_DEPLOYMENT_UID,
    $732ab3392002ce26$var$TMP_K8S_DEPLOYMENT_NAME,
    $732ab3392002ce26$var$TMP_K8S_STATEFULSET_UID,
    $732ab3392002ce26$var$TMP_K8S_STATEFULSET_NAME,
    $732ab3392002ce26$var$TMP_K8S_DAEMONSET_UID,
    $732ab3392002ce26$var$TMP_K8S_DAEMONSET_NAME,
    $732ab3392002ce26$var$TMP_K8S_JOB_UID,
    $732ab3392002ce26$var$TMP_K8S_JOB_NAME,
    $732ab3392002ce26$var$TMP_K8S_CRONJOB_UID,
    $732ab3392002ce26$var$TMP_K8S_CRONJOB_NAME,
    $732ab3392002ce26$var$TMP_OS_TYPE,
    $732ab3392002ce26$var$TMP_OS_DESCRIPTION,
    $732ab3392002ce26$var$TMP_OS_NAME,
    $732ab3392002ce26$var$TMP_OS_VERSION,
    $732ab3392002ce26$var$TMP_PROCESS_PID,
    $732ab3392002ce26$var$TMP_PROCESS_EXECUTABLE_NAME,
    $732ab3392002ce26$var$TMP_PROCESS_EXECUTABLE_PATH,
    $732ab3392002ce26$var$TMP_PROCESS_COMMAND,
    $732ab3392002ce26$var$TMP_PROCESS_COMMAND_LINE,
    $732ab3392002ce26$var$TMP_PROCESS_COMMAND_ARGS,
    $732ab3392002ce26$var$TMP_PROCESS_OWNER,
    $732ab3392002ce26$var$TMP_PROCESS_RUNTIME_NAME,
    $732ab3392002ce26$var$TMP_PROCESS_RUNTIME_VERSION,
    $732ab3392002ce26$var$TMP_PROCESS_RUNTIME_DESCRIPTION,
    $732ab3392002ce26$var$TMP_SERVICE_NAME,
    $732ab3392002ce26$var$TMP_SERVICE_NAMESPACE,
    $732ab3392002ce26$var$TMP_SERVICE_INSTANCE_ID,
    $732ab3392002ce26$var$TMP_SERVICE_VERSION,
    $732ab3392002ce26$var$TMP_TELEMETRY_SDK_NAME,
    $732ab3392002ce26$var$TMP_TELEMETRY_SDK_LANGUAGE,
    $732ab3392002ce26$var$TMP_TELEMETRY_SDK_VERSION,
    $732ab3392002ce26$var$TMP_TELEMETRY_AUTO_VERSION,
    $732ab3392002ce26$var$TMP_WEBENGINE_NAME,
    $732ab3392002ce26$var$TMP_WEBENGINE_VERSION,
    $732ab3392002ce26$var$TMP_WEBENGINE_DESCRIPTION
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudProviderValues enum definition
 *
 * Name of the cloud provider.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD = "alibaba_cloud";
var $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_AWS = "aws";
var $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_AZURE = "azure";
var $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_GCP = "gcp";
var $732ab3392002ce26$export$1f18298beaae37d3 = $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD;
var $732ab3392002ce26$export$f56ad4bf836470f2 = $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_AWS;
var $732ab3392002ce26$export$a607df3e2371e436 = $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_AZURE;
var $732ab3392002ce26$export$b5cb559e526f402a = $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_GCP;
var $732ab3392002ce26$export$c2664345bd8aad14 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD,
    $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_AWS,
    $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_AZURE,
    $732ab3392002ce26$var$TMP_CLOUDPROVIDERVALUES_GCP
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudPlatformValues enum definition
 *
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = "alibaba_cloud_ecs";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = "alibaba_cloud_fc";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2 = "aws_ec2";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS = "aws_ecs";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS = "aws_eks";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA = "aws_lambda";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = "aws_elastic_beanstalk";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM = "azure_vm";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = "azure_container_instances";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS = "azure_aks";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = "azure_functions";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = "azure_app_service";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = "gcp_compute_engine";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = "gcp_cloud_run";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = "gcp_kubernetes_engine";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = "gcp_cloud_functions";
var $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE = "gcp_app_engine";
var $732ab3392002ce26$export$b7ccb6b2de7534ed = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS;
var $732ab3392002ce26$export$5e031b328860dffd = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC;
var $732ab3392002ce26$export$f0e8dec51b6cf37d = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2;
var $732ab3392002ce26$export$a325ac849a598ed7 = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS;
var $732ab3392002ce26$export$9c3f60b2b4d542e1 = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS;
var $732ab3392002ce26$export$1edcff8a13326911 = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA;
var $732ab3392002ce26$export$2f7128c57ade0d50 = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK;
var $732ab3392002ce26$export$10256094f96cd373 = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM;
var $732ab3392002ce26$export$ed505d4ca2b4d712 = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES;
var $732ab3392002ce26$export$83131f1a1f001ee = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS;
var $732ab3392002ce26$export$36f98571cef96af7 = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS;
var $732ab3392002ce26$export$66faee8e64625c5d = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE;
var $732ab3392002ce26$export$dd043c2707119e75 = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE;
var $732ab3392002ce26$export$d0a1ecf47fa77b8b = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN;
var $732ab3392002ce26$export$649c271f5295d71e = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE;
var $732ab3392002ce26$export$e9becd93e8daa01a = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS;
var $732ab3392002ce26$export$5862836e4b24761c = $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE;
var $732ab3392002ce26$export$fe811090f8b1259c = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS,
    $732ab3392002ce26$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for AwsEcsLaunchtypeValues enum definition
 *
 * The [launch type](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/launch_types.html) for an ECS task.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $732ab3392002ce26$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2 = "ec2";
var $732ab3392002ce26$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE = "fargate";
var $732ab3392002ce26$export$54d16708f9a4cde = $732ab3392002ce26$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2;
var $732ab3392002ce26$export$7bf660b6e44fe06e = $732ab3392002ce26$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE;
var $732ab3392002ce26$export$6945fb1e4f2852ef = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $732ab3392002ce26$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2,
    $732ab3392002ce26$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HostArchValues enum definition
 *
 * The CPU architecture the host system is running on.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $732ab3392002ce26$var$TMP_HOSTARCHVALUES_AMD64 = "amd64";
var $732ab3392002ce26$var$TMP_HOSTARCHVALUES_ARM32 = "arm32";
var $732ab3392002ce26$var$TMP_HOSTARCHVALUES_ARM64 = "arm64";
var $732ab3392002ce26$var$TMP_HOSTARCHVALUES_IA64 = "ia64";
var $732ab3392002ce26$var$TMP_HOSTARCHVALUES_PPC32 = "ppc32";
var $732ab3392002ce26$var$TMP_HOSTARCHVALUES_PPC64 = "ppc64";
var $732ab3392002ce26$var$TMP_HOSTARCHVALUES_X86 = "x86";
var $732ab3392002ce26$export$6050a837e7da966a = $732ab3392002ce26$var$TMP_HOSTARCHVALUES_AMD64;
var $732ab3392002ce26$export$3c7341cec70023f0 = $732ab3392002ce26$var$TMP_HOSTARCHVALUES_ARM32;
var $732ab3392002ce26$export$2fac5f715b596c6d = $732ab3392002ce26$var$TMP_HOSTARCHVALUES_ARM64;
var $732ab3392002ce26$export$231235882f6e6443 = $732ab3392002ce26$var$TMP_HOSTARCHVALUES_IA64;
var $732ab3392002ce26$export$c4a24e52d6385d55 = $732ab3392002ce26$var$TMP_HOSTARCHVALUES_PPC32;
var $732ab3392002ce26$export$18594ce63eac5c97 = $732ab3392002ce26$var$TMP_HOSTARCHVALUES_PPC64;
var $732ab3392002ce26$export$1af722303cbf3f49 = $732ab3392002ce26$var$TMP_HOSTARCHVALUES_X86;
var $732ab3392002ce26$export$f31e10d6db5b428b = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $732ab3392002ce26$var$TMP_HOSTARCHVALUES_AMD64,
    $732ab3392002ce26$var$TMP_HOSTARCHVALUES_ARM32,
    $732ab3392002ce26$var$TMP_HOSTARCHVALUES_ARM64,
    $732ab3392002ce26$var$TMP_HOSTARCHVALUES_IA64,
    $732ab3392002ce26$var$TMP_HOSTARCHVALUES_PPC32,
    $732ab3392002ce26$var$TMP_HOSTARCHVALUES_PPC64,
    $732ab3392002ce26$var$TMP_HOSTARCHVALUES_X86
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for OsTypeValues enum definition
 *
 * The operating system type.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_WINDOWS = "windows";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_LINUX = "linux";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_DARWIN = "darwin";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_FREEBSD = "freebsd";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_NETBSD = "netbsd";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_OPENBSD = "openbsd";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_DRAGONFLYBSD = "dragonflybsd";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_HPUX = "hpux";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_AIX = "aix";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_SOLARIS = "solaris";
var $732ab3392002ce26$var$TMP_OSTYPEVALUES_Z_OS = "z_os";
var $732ab3392002ce26$export$9e247b47b87a5e98 = $732ab3392002ce26$var$TMP_OSTYPEVALUES_WINDOWS;
var $732ab3392002ce26$export$79d9a21d50f1d11b = $732ab3392002ce26$var$TMP_OSTYPEVALUES_LINUX;
var $732ab3392002ce26$export$29d1fb472dabfab5 = $732ab3392002ce26$var$TMP_OSTYPEVALUES_DARWIN;
var $732ab3392002ce26$export$41f1a684ef8f38a0 = $732ab3392002ce26$var$TMP_OSTYPEVALUES_FREEBSD;
var $732ab3392002ce26$export$d11e84640954119d = $732ab3392002ce26$var$TMP_OSTYPEVALUES_NETBSD;
var $732ab3392002ce26$export$cf6bab1412b5a24 = $732ab3392002ce26$var$TMP_OSTYPEVALUES_OPENBSD;
var $732ab3392002ce26$export$e902e17ab5ff9bad = $732ab3392002ce26$var$TMP_OSTYPEVALUES_DRAGONFLYBSD;
var $732ab3392002ce26$export$9a4c793b18e0bd5e = $732ab3392002ce26$var$TMP_OSTYPEVALUES_HPUX;
var $732ab3392002ce26$export$bdec18d31f5e2d9d = $732ab3392002ce26$var$TMP_OSTYPEVALUES_AIX;
var $732ab3392002ce26$export$6226a44babc07d2d = $732ab3392002ce26$var$TMP_OSTYPEVALUES_SOLARIS;
var $732ab3392002ce26$export$a81b7e7863a06968 = $732ab3392002ce26$var$TMP_OSTYPEVALUES_Z_OS;
var $732ab3392002ce26$export$efc6a8b7a61f5577 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_WINDOWS,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_LINUX,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_DARWIN,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_FREEBSD,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_NETBSD,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_OPENBSD,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_DRAGONFLYBSD,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_HPUX,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_AIX,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_SOLARIS,
    $732ab3392002ce26$var$TMP_OSTYPEVALUES_Z_OS
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for TelemetrySdkLanguageValues enum definition
 *
 * The language of the telemetry SDK.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP = "cpp";
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET = "dotnet";
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG = "erlang";
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO = "go";
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA = "java";
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS = "nodejs";
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP = "php";
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON = "python";
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY = "ruby";
var $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS = "webjs";
var $732ab3392002ce26$export$bb305b29d3ff12b2 = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP;
var $732ab3392002ce26$export$36f70c7fec241585 = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET;
var $732ab3392002ce26$export$9254854c1a90f699 = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG;
var $732ab3392002ce26$export$870f3d5bf5403ac2 = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO;
var $732ab3392002ce26$export$a115dae9eb65ef38 = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA;
var $732ab3392002ce26$export$f599ed80e3c8d29a = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS;
var $732ab3392002ce26$export$42ae93f6bda608ef = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP;
var $732ab3392002ce26$export$7f6f8205f1621418 = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON;
var $732ab3392002ce26$export$3dd620b466e18cf = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY;
var $732ab3392002ce26$export$1414beb1e03cac7c = $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS;
var $732ab3392002ce26$export$b43162e16168dba6 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP,
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET,
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG,
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO,
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA,
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS,
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP,
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON,
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY,
    $732ab3392002ce26$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS
]);


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $70954c1ca5bfe987$export$a4ad2735b021c132 = "1.22.0";



var $e1a2740dec6d68fc$var$_a;
var $e1a2740dec6d68fc$export$3c44663382dce232 = ($e1a2740dec6d68fc$var$_a = {}, $e1a2740dec6d68fc$var$_a[(0, $732ab3392002ce26$export$85d6ffe28a084c78).TELEMETRY_SDK_NAME] = "opentelemetry", $e1a2740dec6d68fc$var$_a[(0, $732ab3392002ce26$export$85d6ffe28a084c78).PROCESS_RUNTIME_NAME] = "browser", $e1a2740dec6d68fc$var$_a[(0, $732ab3392002ce26$export$85d6ffe28a084c78).TELEMETRY_SDK_LANGUAGE] = (0, $732ab3392002ce26$export$b43162e16168dba6).WEBJS, $e1a2740dec6d68fc$var$_a[(0, $732ab3392002ce26$export$85d6ffe28a084c78).TELEMETRY_SDK_VERSION] = (0, $70954c1ca5bfe987$export$a4ad2735b021c132), $e1a2740dec6d68fc$var$_a);


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $66a13c4a05759662$export$b8c2abd2a6cf7c10() {
    return "unknown_service";
}


var $8dcd3cef0f1322fc$var$__assign = undefined && undefined.__assign || function() {
    $8dcd3cef0f1322fc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8dcd3cef0f1322fc$var$__assign.apply(this, arguments);
};
var $8dcd3cef0f1322fc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8dcd3cef0f1322fc$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8dcd3cef0f1322fc$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
/**
 * A Resource describes the entity for which a signals (metrics or trace) are
 * collected.
 */ var $8dcd3cef0f1322fc$export$39a853cfb5a94a63 = /** @class */ function() {
    function Resource(/**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */ attributes, asyncAttributesPromise) {
        var _this = this;
        var _a;
        this._attributes = attributes;
        this.asyncAttributesPending = asyncAttributesPromise != null;
        this._syncAttributes = (_a = this._attributes) !== null && _a !== void 0 ? _a : {};
        this._asyncAttributesPromise = asyncAttributesPromise === null || asyncAttributesPromise === void 0 ? void 0 : asyncAttributesPromise.then(function(asyncAttributes) {
            _this._attributes = Object.assign({}, _this._attributes, asyncAttributes);
            _this.asyncAttributesPending = false;
            return asyncAttributes;
        }, function(err) {
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).debug("a resource's async attributes promise rejected: %s", err);
            _this.asyncAttributesPending = false;
            return {};
        });
    }
    /**
     * Returns an empty Resource
     */ Resource.empty = function() {
        return Resource.EMPTY;
    };
    /**
     * Returns a Resource that identifies the SDK in use.
     */ Resource.default = function() {
        var _a;
        return new Resource((_a = {}, _a[(0, $732ab3392002ce26$export$85d6ffe28a084c78).SERVICE_NAME] = (0, $66a13c4a05759662$export$b8c2abd2a6cf7c10)(), _a[(0, $732ab3392002ce26$export$85d6ffe28a084c78).TELEMETRY_SDK_LANGUAGE] = (0, $e1a2740dec6d68fc$export$3c44663382dce232)[(0, $732ab3392002ce26$export$85d6ffe28a084c78).TELEMETRY_SDK_LANGUAGE], _a[(0, $732ab3392002ce26$export$85d6ffe28a084c78).TELEMETRY_SDK_NAME] = (0, $e1a2740dec6d68fc$export$3c44663382dce232)[(0, $732ab3392002ce26$export$85d6ffe28a084c78).TELEMETRY_SDK_NAME], _a[(0, $732ab3392002ce26$export$85d6ffe28a084c78).TELEMETRY_SDK_VERSION] = (0, $e1a2740dec6d68fc$export$3c44663382dce232)[(0, $732ab3392002ce26$export$85d6ffe28a084c78).TELEMETRY_SDK_VERSION], _a));
    };
    Object.defineProperty(Resource.prototype, "attributes", {
        get: function() {
            var _a;
            if (this.asyncAttributesPending) (0, $5961b21244e407a2$export$c042e7c2f59bc046).error("Accessing resource attributes before async attributes settled");
            return (_a = this._attributes) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a promise that will never be rejected. Resolves when all async attributes have finished being added to
     * this Resource's attributes. This is useful in exporters to block until resource detection
     * has finished.
     */ Resource.prototype.waitForAsyncAttributes = function() {
        return $8dcd3cef0f1322fc$var$__awaiter(this, void 0, void 0, function() {
            return $8dcd3cef0f1322fc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.asyncAttributesPending) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._asyncAttributesPromise
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Returns a new, merged {@link Resource} by merging the current Resource
     * with the other Resource. In case of a collision, other Resource takes
     * precedence.
     *
     * @param other the Resource that will be merged with this.
     * @returns the newly merged Resource.
     */ Resource.prototype.merge = function(other) {
        var _this = this;
        var _a;
        if (!other) return this;
        // SpanAttributes from other resource overwrite attributes from this resource.
        var mergedSyncAttributes = $8dcd3cef0f1322fc$var$__assign($8dcd3cef0f1322fc$var$__assign({}, this._syncAttributes), (_a = other._syncAttributes) !== null && _a !== void 0 ? _a : other.attributes);
        if (!this._asyncAttributesPromise && !other._asyncAttributesPromise) return new Resource(mergedSyncAttributes);
        var mergedAttributesPromise = Promise.all([
            this._asyncAttributesPromise,
            other._asyncAttributesPromise
        ]).then(function(_a) {
            var _b;
            var _c = $8dcd3cef0f1322fc$var$__read(_a, 2), thisAsyncAttributes = _c[0], otherAsyncAttributes = _c[1];
            return $8dcd3cef0f1322fc$var$__assign($8dcd3cef0f1322fc$var$__assign($8dcd3cef0f1322fc$var$__assign($8dcd3cef0f1322fc$var$__assign({}, _this._syncAttributes), thisAsyncAttributes), (_b = other._syncAttributes) !== null && _b !== void 0 ? _b : other.attributes), otherAsyncAttributes);
        });
        return new Resource(mergedSyncAttributes, mergedAttributesPromise);
    };
    Resource.EMPTY = new Resource({});
    return Resource;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $0a53bb1dd0db3a06$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $0a53bb1dd0db3a06$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $0a53bb1dd0db3a06$export$b0663eba150d60c9(attributes) {
    var e_1, _a;
    var out = {};
    if (typeof attributes !== "object" || attributes == null) return out;
    try {
        for(var _b = $0a53bb1dd0db3a06$var$__values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $0a53bb1dd0db3a06$var$__read(_c.value, 2), key = _d[0], val = _d[1];
            if (!$0a53bb1dd0db3a06$export$d3dd8ead6a0318c3(key)) {
                (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Invalid attribute key: " + key);
                continue;
            }
            if (!$0a53bb1dd0db3a06$export$1daad3d2aacf48c5(val)) {
                (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Invalid attribute value set for key: " + key);
                continue;
            }
            if (Array.isArray(val)) out[key] = val.slice();
            else out[key] = val;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return out;
}
function $0a53bb1dd0db3a06$export$d3dd8ead6a0318c3(key) {
    return typeof key === "string" && key.length > 0;
}
function $0a53bb1dd0db3a06$export$1daad3d2aacf48c5(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return $0a53bb1dd0db3a06$var$isHomogeneousAttributeValueArray(val);
    return $0a53bb1dd0db3a06$var$isValidPrimitiveAttributeValue(val);
}
function $0a53bb1dd0db3a06$var$isHomogeneousAttributeValueArray(arr) {
    var e_2, _a;
    var type;
    try {
        for(var arr_1 = $0a53bb1dd0db3a06$var$__values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()){
            var element = arr_1_1.value;
            // null/undefined elements are allowed
            if (element == null) continue;
            if (!type) {
                if ($0a53bb1dd0db3a06$var$isValidPrimitiveAttributeValue(element)) {
                    type = typeof element;
                    continue;
                }
                // encountered an invalid primitive
                return false;
            }
            if (typeof element === type) continue;
            return false;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return true;
}
function $0a53bb1dd0db3a06$var$isValidPrimitiveAttributeValue(val) {
    switch(typeof val){
        case "number":
        case "boolean":
        case "string":
            return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $535cbcef4f10c631$export$b22daef4119238cd = performance;


var $24357f53a00dc7a9$var$NANOSECOND_DIGITS = 9;
var $24357f53a00dc7a9$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
var $24357f53a00dc7a9$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $24357f53a00dc7a9$var$NANOSECOND_DIGITS_IN_MILLIS);
var $24357f53a00dc7a9$var$SECOND_TO_NANOSECONDS = Math.pow(10, $24357f53a00dc7a9$var$NANOSECOND_DIGITS);
function $24357f53a00dc7a9$export$e7ec5c82995537b1(epochMillis) {
    var epochSeconds = epochMillis / 1000;
    // Decimals only.
    var seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    var nanos = Math.round(epochMillis % 1000 * $24357f53a00dc7a9$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $24357f53a00dc7a9$export$e752b05e58096a2f() {
    var timeOrigin = (0, $535cbcef4f10c631$export$b22daef4119238cd).timeOrigin;
    if (typeof timeOrigin !== "number") {
        var perf = (0, $535cbcef4f10c631$export$b22daef4119238cd);
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $24357f53a00dc7a9$export$24b3f7dcd2848fa8(performanceNow) {
    var timeOrigin = $24357f53a00dc7a9$export$e7ec5c82995537b1($24357f53a00dc7a9$export$e752b05e58096a2f());
    var now = $24357f53a00dc7a9$export$e7ec5c82995537b1(typeof performanceNow === "number" ? performanceNow : (0, $535cbcef4f10c631$export$b22daef4119238cd).now());
    return $24357f53a00dc7a9$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $24357f53a00dc7a9$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($24357f53a00dc7a9$export$390c59432f173a9f(time)) return time;
    else if (typeof time === "number") {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < $24357f53a00dc7a9$export$e752b05e58096a2f()) return $24357f53a00dc7a9$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $24357f53a00dc7a9$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $24357f53a00dc7a9$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError("Invalid input type");
}
function $24357f53a00dc7a9$export$b783ad6617389e3e(startTime, endTime) {
    var seconds = endTime[0] - startTime[0];
    var nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $24357f53a00dc7a9$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $24357f53a00dc7a9$export$973c1c4fad6103e(time) {
    var precision = $24357f53a00dc7a9$var$NANOSECOND_DIGITS;
    var tmp = "" + "0".repeat(precision) + time[1] + "Z";
    var nanoString = tmp.substr(tmp.length - precision - 1);
    var date = new Date(time[0] * 1000).toISOString();
    return date.replace("000Z", nanoString);
}
function $24357f53a00dc7a9$export$2d91441ae30ebcfc(time) {
    return time[0] * $24357f53a00dc7a9$var$SECOND_TO_NANOSECONDS + time[1];
}
function $24357f53a00dc7a9$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $24357f53a00dc7a9$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $24357f53a00dc7a9$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === "number" && typeof value[1] === "number";
}
function $24357f53a00dc7a9$export$a5e58227c317ebb9(value) {
    return $24357f53a00dc7a9$export$390c59432f173a9f(value) || typeof value === "number" || value instanceof Date;
}
function $24357f53a00dc7a9$export$f07bb1dbc72184c3(time1, time2) {
    var out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $24357f53a00dc7a9$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $24357f53a00dc7a9$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_AWS_LAMBDA_INVOKED_ARN = "aws.lambda.invoked_arn";
var $1210dafc06b031f1$var$TMP_DB_SYSTEM = "db.system";
var $1210dafc06b031f1$var$TMP_DB_CONNECTION_STRING = "db.connection_string";
var $1210dafc06b031f1$var$TMP_DB_USER = "db.user";
var $1210dafc06b031f1$var$TMP_DB_JDBC_DRIVER_CLASSNAME = "db.jdbc.driver_classname";
var $1210dafc06b031f1$var$TMP_DB_NAME = "db.name";
var $1210dafc06b031f1$var$TMP_DB_STATEMENT = "db.statement";
var $1210dafc06b031f1$var$TMP_DB_OPERATION = "db.operation";
var $1210dafc06b031f1$var$TMP_DB_MSSQL_INSTANCE_NAME = "db.mssql.instance_name";
var $1210dafc06b031f1$var$TMP_DB_CASSANDRA_KEYSPACE = "db.cassandra.keyspace";
var $1210dafc06b031f1$var$TMP_DB_CASSANDRA_PAGE_SIZE = "db.cassandra.page_size";
var $1210dafc06b031f1$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL = "db.cassandra.consistency_level";
var $1210dafc06b031f1$var$TMP_DB_CASSANDRA_TABLE = "db.cassandra.table";
var $1210dafc06b031f1$var$TMP_DB_CASSANDRA_IDEMPOTENCE = "db.cassandra.idempotence";
var $1210dafc06b031f1$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = "db.cassandra.speculative_execution_count";
var $1210dafc06b031f1$var$TMP_DB_CASSANDRA_COORDINATOR_ID = "db.cassandra.coordinator.id";
var $1210dafc06b031f1$var$TMP_DB_CASSANDRA_COORDINATOR_DC = "db.cassandra.coordinator.dc";
var $1210dafc06b031f1$var$TMP_DB_HBASE_NAMESPACE = "db.hbase.namespace";
var $1210dafc06b031f1$var$TMP_DB_REDIS_DATABASE_INDEX = "db.redis.database_index";
var $1210dafc06b031f1$var$TMP_DB_MONGODB_COLLECTION = "db.mongodb.collection";
var $1210dafc06b031f1$var$TMP_DB_SQL_TABLE = "db.sql.table";
var $1210dafc06b031f1$var$TMP_EXCEPTION_TYPE = "exception.type";
var $1210dafc06b031f1$var$TMP_EXCEPTION_MESSAGE = "exception.message";
var $1210dafc06b031f1$var$TMP_EXCEPTION_STACKTRACE = "exception.stacktrace";
var $1210dafc06b031f1$var$TMP_EXCEPTION_ESCAPED = "exception.escaped";
var $1210dafc06b031f1$var$TMP_FAAS_TRIGGER = "faas.trigger";
var $1210dafc06b031f1$var$TMP_FAAS_EXECUTION = "faas.execution";
var $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_COLLECTION = "faas.document.collection";
var $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_OPERATION = "faas.document.operation";
var $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_TIME = "faas.document.time";
var $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_NAME = "faas.document.name";
var $1210dafc06b031f1$var$TMP_FAAS_TIME = "faas.time";
var $1210dafc06b031f1$var$TMP_FAAS_CRON = "faas.cron";
var $1210dafc06b031f1$var$TMP_FAAS_COLDSTART = "faas.coldstart";
var $1210dafc06b031f1$var$TMP_FAAS_INVOKED_NAME = "faas.invoked_name";
var $1210dafc06b031f1$var$TMP_FAAS_INVOKED_PROVIDER = "faas.invoked_provider";
var $1210dafc06b031f1$var$TMP_FAAS_INVOKED_REGION = "faas.invoked_region";
var $1210dafc06b031f1$var$TMP_NET_TRANSPORT = "net.transport";
var $1210dafc06b031f1$var$TMP_NET_PEER_IP = "net.peer.ip";
var $1210dafc06b031f1$var$TMP_NET_PEER_PORT = "net.peer.port";
var $1210dafc06b031f1$var$TMP_NET_PEER_NAME = "net.peer.name";
var $1210dafc06b031f1$var$TMP_NET_HOST_IP = "net.host.ip";
var $1210dafc06b031f1$var$TMP_NET_HOST_PORT = "net.host.port";
var $1210dafc06b031f1$var$TMP_NET_HOST_NAME = "net.host.name";
var $1210dafc06b031f1$var$TMP_NET_HOST_CONNECTION_TYPE = "net.host.connection.type";
var $1210dafc06b031f1$var$TMP_NET_HOST_CONNECTION_SUBTYPE = "net.host.connection.subtype";
var $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_NAME = "net.host.carrier.name";
var $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_MCC = "net.host.carrier.mcc";
var $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_MNC = "net.host.carrier.mnc";
var $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_ICC = "net.host.carrier.icc";
var $1210dafc06b031f1$var$TMP_PEER_SERVICE = "peer.service";
var $1210dafc06b031f1$var$TMP_ENDUSER_ID = "enduser.id";
var $1210dafc06b031f1$var$TMP_ENDUSER_ROLE = "enduser.role";
var $1210dafc06b031f1$var$TMP_ENDUSER_SCOPE = "enduser.scope";
var $1210dafc06b031f1$var$TMP_THREAD_ID = "thread.id";
var $1210dafc06b031f1$var$TMP_THREAD_NAME = "thread.name";
var $1210dafc06b031f1$var$TMP_CODE_FUNCTION = "code.function";
var $1210dafc06b031f1$var$TMP_CODE_NAMESPACE = "code.namespace";
var $1210dafc06b031f1$var$TMP_CODE_FILEPATH = "code.filepath";
var $1210dafc06b031f1$var$TMP_CODE_LINENO = "code.lineno";
var $1210dafc06b031f1$var$TMP_HTTP_METHOD = "http.method";
var $1210dafc06b031f1$var$TMP_HTTP_URL = "http.url";
var $1210dafc06b031f1$var$TMP_HTTP_TARGET = "http.target";
var $1210dafc06b031f1$var$TMP_HTTP_HOST = "http.host";
var $1210dafc06b031f1$var$TMP_HTTP_SCHEME = "http.scheme";
var $1210dafc06b031f1$var$TMP_HTTP_STATUS_CODE = "http.status_code";
var $1210dafc06b031f1$var$TMP_HTTP_FLAVOR = "http.flavor";
var $1210dafc06b031f1$var$TMP_HTTP_USER_AGENT = "http.user_agent";
var $1210dafc06b031f1$var$TMP_HTTP_REQUEST_CONTENT_LENGTH = "http.request_content_length";
var $1210dafc06b031f1$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = "http.request_content_length_uncompressed";
var $1210dafc06b031f1$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length";
var $1210dafc06b031f1$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = "http.response_content_length_uncompressed";
var $1210dafc06b031f1$var$TMP_HTTP_SERVER_NAME = "http.server_name";
var $1210dafc06b031f1$var$TMP_HTTP_ROUTE = "http.route";
var $1210dafc06b031f1$var$TMP_HTTP_CLIENT_IP = "http.client_ip";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_TABLE_NAMES = "aws.dynamodb.table_names";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY = "aws.dynamodb.consumed_capacity";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = "aws.dynamodb.item_collection_metrics";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = "aws.dynamodb.provisioned_read_capacity";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = "aws.dynamodb.provisioned_write_capacity";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_CONSISTENT_READ = "aws.dynamodb.consistent_read";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_PROJECTION = "aws.dynamodb.projection";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_LIMIT = "aws.dynamodb.limit";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET = "aws.dynamodb.attributes_to_get";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_INDEX_NAME = "aws.dynamodb.index_name";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SELECT = "aws.dynamodb.select";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = "aws.dynamodb.global_secondary_indexes";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = "aws.dynamodb.local_secondary_indexes";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = "aws.dynamodb.exclusive_start_table";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_TABLE_COUNT = "aws.dynamodb.table_count";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SCAN_FORWARD = "aws.dynamodb.scan_forward";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SEGMENT = "aws.dynamodb.segment";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS = "aws.dynamodb.total_segments";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_COUNT = "aws.dynamodb.count";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SCANNED_COUNT = "aws.dynamodb.scanned_count";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = "aws.dynamodb.attribute_definitions";
var $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = "aws.dynamodb.global_secondary_index_updates";
var $1210dafc06b031f1$var$TMP_MESSAGING_SYSTEM = "messaging.system";
var $1210dafc06b031f1$var$TMP_MESSAGING_DESTINATION = "messaging.destination";
var $1210dafc06b031f1$var$TMP_MESSAGING_DESTINATION_KIND = "messaging.destination_kind";
var $1210dafc06b031f1$var$TMP_MESSAGING_TEMP_DESTINATION = "messaging.temp_destination";
var $1210dafc06b031f1$var$TMP_MESSAGING_PROTOCOL = "messaging.protocol";
var $1210dafc06b031f1$var$TMP_MESSAGING_PROTOCOL_VERSION = "messaging.protocol_version";
var $1210dafc06b031f1$var$TMP_MESSAGING_URL = "messaging.url";
var $1210dafc06b031f1$var$TMP_MESSAGING_MESSAGE_ID = "messaging.message_id";
var $1210dafc06b031f1$var$TMP_MESSAGING_CONVERSATION_ID = "messaging.conversation_id";
var $1210dafc06b031f1$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = "messaging.message_payload_size_bytes";
var $1210dafc06b031f1$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = "messaging.message_payload_compressed_size_bytes";
var $1210dafc06b031f1$var$TMP_MESSAGING_OPERATION = "messaging.operation";
var $1210dafc06b031f1$var$TMP_MESSAGING_CONSUMER_ID = "messaging.consumer_id";
var $1210dafc06b031f1$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY = "messaging.rabbitmq.routing_key";
var $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY = "messaging.kafka.message_key";
var $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP = "messaging.kafka.consumer_group";
var $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_CLIENT_ID = "messaging.kafka.client_id";
var $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_PARTITION = "messaging.kafka.partition";
var $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_TOMBSTONE = "messaging.kafka.tombstone";
var $1210dafc06b031f1$var$TMP_RPC_SYSTEM = "rpc.system";
var $1210dafc06b031f1$var$TMP_RPC_SERVICE = "rpc.service";
var $1210dafc06b031f1$var$TMP_RPC_METHOD = "rpc.method";
var $1210dafc06b031f1$var$TMP_RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code";
var $1210dafc06b031f1$var$TMP_RPC_JSONRPC_VERSION = "rpc.jsonrpc.version";
var $1210dafc06b031f1$var$TMP_RPC_JSONRPC_REQUEST_ID = "rpc.jsonrpc.request_id";
var $1210dafc06b031f1$var$TMP_RPC_JSONRPC_ERROR_CODE = "rpc.jsonrpc.error_code";
var $1210dafc06b031f1$var$TMP_RPC_JSONRPC_ERROR_MESSAGE = "rpc.jsonrpc.error_message";
var $1210dafc06b031f1$var$TMP_MESSAGE_TYPE = "message.type";
var $1210dafc06b031f1$var$TMP_MESSAGE_ID = "message.id";
var $1210dafc06b031f1$var$TMP_MESSAGE_COMPRESSED_SIZE = "message.compressed_size";
var $1210dafc06b031f1$var$TMP_MESSAGE_UNCOMPRESSED_SIZE = "message.uncompressed_size";
var $1210dafc06b031f1$export$170bb395abfdb74 = $1210dafc06b031f1$var$TMP_AWS_LAMBDA_INVOKED_ARN;
var $1210dafc06b031f1$export$4d8f9683caa766fd = $1210dafc06b031f1$var$TMP_DB_SYSTEM;
var $1210dafc06b031f1$export$d367aaf68e61a0d5 = $1210dafc06b031f1$var$TMP_DB_CONNECTION_STRING;
var $1210dafc06b031f1$export$310240ea93b3fe22 = $1210dafc06b031f1$var$TMP_DB_USER;
var $1210dafc06b031f1$export$aa8b483f52799ba9 = $1210dafc06b031f1$var$TMP_DB_JDBC_DRIVER_CLASSNAME;
var $1210dafc06b031f1$export$d1ee0266d0ce708f = $1210dafc06b031f1$var$TMP_DB_NAME;
var $1210dafc06b031f1$export$ce244300665216c6 = $1210dafc06b031f1$var$TMP_DB_STATEMENT;
var $1210dafc06b031f1$export$dfb6a782675c717b = $1210dafc06b031f1$var$TMP_DB_OPERATION;
var $1210dafc06b031f1$export$ce5040faeb6d8f08 = $1210dafc06b031f1$var$TMP_DB_MSSQL_INSTANCE_NAME;
var $1210dafc06b031f1$export$e241e7101e6d4783 = $1210dafc06b031f1$var$TMP_DB_CASSANDRA_KEYSPACE;
var $1210dafc06b031f1$export$8823a63ac409681b = $1210dafc06b031f1$var$TMP_DB_CASSANDRA_PAGE_SIZE;
var $1210dafc06b031f1$export$b838c3d1859a7260 = $1210dafc06b031f1$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL;
var $1210dafc06b031f1$export$3f3068d83ae4cca5 = $1210dafc06b031f1$var$TMP_DB_CASSANDRA_TABLE;
var $1210dafc06b031f1$export$17334025dcb96205 = $1210dafc06b031f1$var$TMP_DB_CASSANDRA_IDEMPOTENCE;
var $1210dafc06b031f1$export$a63f22381e3297f2 = $1210dafc06b031f1$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT;
var $1210dafc06b031f1$export$e06ccece5268ed3 = $1210dafc06b031f1$var$TMP_DB_CASSANDRA_COORDINATOR_ID;
var $1210dafc06b031f1$export$ab77f08d0cc7144 = $1210dafc06b031f1$var$TMP_DB_CASSANDRA_COORDINATOR_DC;
var $1210dafc06b031f1$export$f83bf50700108cdb = $1210dafc06b031f1$var$TMP_DB_HBASE_NAMESPACE;
var $1210dafc06b031f1$export$f9c9b189f60bce02 = $1210dafc06b031f1$var$TMP_DB_REDIS_DATABASE_INDEX;
var $1210dafc06b031f1$export$b73e684c351bf304 = $1210dafc06b031f1$var$TMP_DB_MONGODB_COLLECTION;
var $1210dafc06b031f1$export$5b02e077c84b0dc7 = $1210dafc06b031f1$var$TMP_DB_SQL_TABLE;
var $1210dafc06b031f1$export$ecc84ea0f5a24384 = $1210dafc06b031f1$var$TMP_EXCEPTION_TYPE;
var $1210dafc06b031f1$export$ff69507dfa9dcf0c = $1210dafc06b031f1$var$TMP_EXCEPTION_MESSAGE;
var $1210dafc06b031f1$export$d9432f0c350b687d = $1210dafc06b031f1$var$TMP_EXCEPTION_STACKTRACE;
var $1210dafc06b031f1$export$4d3c212dd7c75f9d = $1210dafc06b031f1$var$TMP_EXCEPTION_ESCAPED;
var $1210dafc06b031f1$export$7e853a3dbd95b3a2 = $1210dafc06b031f1$var$TMP_FAAS_TRIGGER;
var $1210dafc06b031f1$export$68a5b08142e33c1d = $1210dafc06b031f1$var$TMP_FAAS_EXECUTION;
var $1210dafc06b031f1$export$f4b6288b42b8d4f8 = $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_COLLECTION;
var $1210dafc06b031f1$export$7e6d28b35ab8e751 = $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_OPERATION;
var $1210dafc06b031f1$export$b36094664197ebd9 = $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_TIME;
var $1210dafc06b031f1$export$2401d669e1b7f304 = $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_NAME;
var $1210dafc06b031f1$export$4630b1edb758007c = $1210dafc06b031f1$var$TMP_FAAS_TIME;
var $1210dafc06b031f1$export$4358b4189d5aa75e = $1210dafc06b031f1$var$TMP_FAAS_CRON;
var $1210dafc06b031f1$export$18a88fa49bf141a8 = $1210dafc06b031f1$var$TMP_FAAS_COLDSTART;
var $1210dafc06b031f1$export$ba620de28d483834 = $1210dafc06b031f1$var$TMP_FAAS_INVOKED_NAME;
var $1210dafc06b031f1$export$1ac1158b40ce77df = $1210dafc06b031f1$var$TMP_FAAS_INVOKED_PROVIDER;
var $1210dafc06b031f1$export$e8b3f54186b03f93 = $1210dafc06b031f1$var$TMP_FAAS_INVOKED_REGION;
var $1210dafc06b031f1$export$958ce88767ff5cae = $1210dafc06b031f1$var$TMP_NET_TRANSPORT;
var $1210dafc06b031f1$export$5f5e19d7784bcab5 = $1210dafc06b031f1$var$TMP_NET_PEER_IP;
var $1210dafc06b031f1$export$83ab392b303d5cc4 = $1210dafc06b031f1$var$TMP_NET_PEER_PORT;
var $1210dafc06b031f1$export$869dc6e245da8a3c = $1210dafc06b031f1$var$TMP_NET_PEER_NAME;
var $1210dafc06b031f1$export$8363f5dd3626d1c7 = $1210dafc06b031f1$var$TMP_NET_HOST_IP;
var $1210dafc06b031f1$export$7c05177443136588 = $1210dafc06b031f1$var$TMP_NET_HOST_PORT;
var $1210dafc06b031f1$export$67ebd91e5927c9b6 = $1210dafc06b031f1$var$TMP_NET_HOST_NAME;
var $1210dafc06b031f1$export$b4399aff72c58221 = $1210dafc06b031f1$var$TMP_NET_HOST_CONNECTION_TYPE;
var $1210dafc06b031f1$export$29124138bf62c161 = $1210dafc06b031f1$var$TMP_NET_HOST_CONNECTION_SUBTYPE;
var $1210dafc06b031f1$export$a1a35234333f42fa = $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_NAME;
var $1210dafc06b031f1$export$593e7f806b5bd9d0 = $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_MCC;
var $1210dafc06b031f1$export$92c4882b0877ce0 = $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_MNC;
var $1210dafc06b031f1$export$7158946157fdda52 = $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_ICC;
var $1210dafc06b031f1$export$706484bff197aa2f = $1210dafc06b031f1$var$TMP_PEER_SERVICE;
var $1210dafc06b031f1$export$37fdcbb3cc34507a = $1210dafc06b031f1$var$TMP_ENDUSER_ID;
var $1210dafc06b031f1$export$7486a34c0c780913 = $1210dafc06b031f1$var$TMP_ENDUSER_ROLE;
var $1210dafc06b031f1$export$c531f20a7a107be = $1210dafc06b031f1$var$TMP_ENDUSER_SCOPE;
var $1210dafc06b031f1$export$96304c684b1fe5bd = $1210dafc06b031f1$var$TMP_THREAD_ID;
var $1210dafc06b031f1$export$b1c76a722c30a73e = $1210dafc06b031f1$var$TMP_THREAD_NAME;
var $1210dafc06b031f1$export$f5b0a970f81eb82 = $1210dafc06b031f1$var$TMP_CODE_FUNCTION;
var $1210dafc06b031f1$export$ebd9bc6b684ae79f = $1210dafc06b031f1$var$TMP_CODE_NAMESPACE;
var $1210dafc06b031f1$export$f5c7dbf024e089b1 = $1210dafc06b031f1$var$TMP_CODE_FILEPATH;
var $1210dafc06b031f1$export$9bc82da636767e36 = $1210dafc06b031f1$var$TMP_CODE_LINENO;
var $1210dafc06b031f1$export$5ec7d06d671a3fbe = $1210dafc06b031f1$var$TMP_HTTP_METHOD;
var $1210dafc06b031f1$export$2f4ef7e39c2be395 = $1210dafc06b031f1$var$TMP_HTTP_URL;
var $1210dafc06b031f1$export$5284fc3356124326 = $1210dafc06b031f1$var$TMP_HTTP_TARGET;
var $1210dafc06b031f1$export$547e24d3f59a53ea = $1210dafc06b031f1$var$TMP_HTTP_HOST;
var $1210dafc06b031f1$export$a2928efa45f0acf4 = $1210dafc06b031f1$var$TMP_HTTP_SCHEME;
var $1210dafc06b031f1$export$d381c7525d715413 = $1210dafc06b031f1$var$TMP_HTTP_STATUS_CODE;
var $1210dafc06b031f1$export$1e443919b8f6a42e = $1210dafc06b031f1$var$TMP_HTTP_FLAVOR;
var $1210dafc06b031f1$export$7472b18f42d2d02f = $1210dafc06b031f1$var$TMP_HTTP_USER_AGENT;
var $1210dafc06b031f1$export$616f2909238995e9 = $1210dafc06b031f1$var$TMP_HTTP_REQUEST_CONTENT_LENGTH;
var $1210dafc06b031f1$export$4352992cf528a286 = $1210dafc06b031f1$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED;
var $1210dafc06b031f1$export$58d4fbfe35e08be0 = $1210dafc06b031f1$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH;
var $1210dafc06b031f1$export$b9d3e41cd56c56cc = $1210dafc06b031f1$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED;
var $1210dafc06b031f1$export$ae4c9cf5cd38f75e = $1210dafc06b031f1$var$TMP_HTTP_SERVER_NAME;
var $1210dafc06b031f1$export$391e30d1bcbfedd6 = $1210dafc06b031f1$var$TMP_HTTP_ROUTE;
var $1210dafc06b031f1$export$f21601c3f29048e9 = $1210dafc06b031f1$var$TMP_HTTP_CLIENT_IP;
var $1210dafc06b031f1$export$22c9c5cd37ccec8d = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_TABLE_NAMES;
var $1210dafc06b031f1$export$636d932d69359471 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY;
var $1210dafc06b031f1$export$79414a2a1b36e0e4 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS;
var $1210dafc06b031f1$export$a17bc449a5f10183 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY;
var $1210dafc06b031f1$export$6d8e225848319009 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY;
var $1210dafc06b031f1$export$2daa7ca667f19522 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_CONSISTENT_READ;
var $1210dafc06b031f1$export$d04f1e16b6682958 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_PROJECTION;
var $1210dafc06b031f1$export$9017e26d3dee82a7 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_LIMIT;
var $1210dafc06b031f1$export$734476f2cddb4e = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET;
var $1210dafc06b031f1$export$6ffa6129be32f13f = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_INDEX_NAME;
var $1210dafc06b031f1$export$e439ba599235e943 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SELECT;
var $1210dafc06b031f1$export$691e052bf6ec1b50 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES;
var $1210dafc06b031f1$export$4a8114ba4973adf9 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES;
var $1210dafc06b031f1$export$3d3dcdb04b37b602 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE;
var $1210dafc06b031f1$export$a3ed03c10bfca049 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_TABLE_COUNT;
var $1210dafc06b031f1$export$70f2263412a5d6f8 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SCAN_FORWARD;
var $1210dafc06b031f1$export$cc291bca867c839c = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SEGMENT;
var $1210dafc06b031f1$export$2bd41520dd577767 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS;
var $1210dafc06b031f1$export$e3002f59defbb848 = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_COUNT;
var $1210dafc06b031f1$export$338ee58c976503fa = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SCANNED_COUNT;
var $1210dafc06b031f1$export$9ef2d520d3111ebb = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS;
var $1210dafc06b031f1$export$50eb8413f579535b = $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES;
var $1210dafc06b031f1$export$e907440d5c8aa7ea = $1210dafc06b031f1$var$TMP_MESSAGING_SYSTEM;
var $1210dafc06b031f1$export$331bf1abb96af02c = $1210dafc06b031f1$var$TMP_MESSAGING_DESTINATION;
var $1210dafc06b031f1$export$ca3944a0a0fdb278 = $1210dafc06b031f1$var$TMP_MESSAGING_DESTINATION_KIND;
var $1210dafc06b031f1$export$b1f595d071164a5c = $1210dafc06b031f1$var$TMP_MESSAGING_TEMP_DESTINATION;
var $1210dafc06b031f1$export$734e634f7ff28b65 = $1210dafc06b031f1$var$TMP_MESSAGING_PROTOCOL;
var $1210dafc06b031f1$export$62c96eec39d4f8fa = $1210dafc06b031f1$var$TMP_MESSAGING_PROTOCOL_VERSION;
var $1210dafc06b031f1$export$8185788dec47d17c = $1210dafc06b031f1$var$TMP_MESSAGING_URL;
var $1210dafc06b031f1$export$6465ca78c6aedebd = $1210dafc06b031f1$var$TMP_MESSAGING_MESSAGE_ID;
var $1210dafc06b031f1$export$9e29dbd41c4d02d5 = $1210dafc06b031f1$var$TMP_MESSAGING_CONVERSATION_ID;
var $1210dafc06b031f1$export$ded3a3185a1522d5 = $1210dafc06b031f1$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES;
var $1210dafc06b031f1$export$c42edeca94088e4d = $1210dafc06b031f1$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES;
var $1210dafc06b031f1$export$b0a29003262c7994 = $1210dafc06b031f1$var$TMP_MESSAGING_OPERATION;
var $1210dafc06b031f1$export$283c55d09fbdb92c = $1210dafc06b031f1$var$TMP_MESSAGING_CONSUMER_ID;
var $1210dafc06b031f1$export$78385ca43d0e8556 = $1210dafc06b031f1$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY;
var $1210dafc06b031f1$export$b6969aab3cf94e74 = $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY;
var $1210dafc06b031f1$export$45eb738152aa5dd4 = $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP;
var $1210dafc06b031f1$export$bc66f788b071fbad = $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_CLIENT_ID;
var $1210dafc06b031f1$export$ff4aad497ab5213e = $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_PARTITION;
var $1210dafc06b031f1$export$256d25d7635b3a79 = $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_TOMBSTONE;
var $1210dafc06b031f1$export$8b1a1f43d7106aea = $1210dafc06b031f1$var$TMP_RPC_SYSTEM;
var $1210dafc06b031f1$export$7eb60929eaa797de = $1210dafc06b031f1$var$TMP_RPC_SERVICE;
var $1210dafc06b031f1$export$c6d175d5e9b8105b = $1210dafc06b031f1$var$TMP_RPC_METHOD;
var $1210dafc06b031f1$export$ccc8405c8a911fb7 = $1210dafc06b031f1$var$TMP_RPC_GRPC_STATUS_CODE;
var $1210dafc06b031f1$export$ce0f2ec42ba79570 = $1210dafc06b031f1$var$TMP_RPC_JSONRPC_VERSION;
var $1210dafc06b031f1$export$2e981273bb2873ea = $1210dafc06b031f1$var$TMP_RPC_JSONRPC_REQUEST_ID;
var $1210dafc06b031f1$export$214058615970c3e4 = $1210dafc06b031f1$var$TMP_RPC_JSONRPC_ERROR_CODE;
var $1210dafc06b031f1$export$2ad4f2a86baa9b1e = $1210dafc06b031f1$var$TMP_RPC_JSONRPC_ERROR_MESSAGE;
var $1210dafc06b031f1$export$e6c57355a990f7ee = $1210dafc06b031f1$var$TMP_MESSAGE_TYPE;
var $1210dafc06b031f1$export$ba8e66ad5476d59f = $1210dafc06b031f1$var$TMP_MESSAGE_ID;
var $1210dafc06b031f1$export$16f3d59837418b1f = $1210dafc06b031f1$var$TMP_MESSAGE_COMPRESSED_SIZE;
var $1210dafc06b031f1$export$4b889081ab98b61 = $1210dafc06b031f1$var$TMP_MESSAGE_UNCOMPRESSED_SIZE;
var $1210dafc06b031f1$export$949e366c5c69d2e9 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_AWS_LAMBDA_INVOKED_ARN,
    $1210dafc06b031f1$var$TMP_DB_SYSTEM,
    $1210dafc06b031f1$var$TMP_DB_CONNECTION_STRING,
    $1210dafc06b031f1$var$TMP_DB_USER,
    $1210dafc06b031f1$var$TMP_DB_JDBC_DRIVER_CLASSNAME,
    $1210dafc06b031f1$var$TMP_DB_NAME,
    $1210dafc06b031f1$var$TMP_DB_STATEMENT,
    $1210dafc06b031f1$var$TMP_DB_OPERATION,
    $1210dafc06b031f1$var$TMP_DB_MSSQL_INSTANCE_NAME,
    $1210dafc06b031f1$var$TMP_DB_CASSANDRA_KEYSPACE,
    $1210dafc06b031f1$var$TMP_DB_CASSANDRA_PAGE_SIZE,
    $1210dafc06b031f1$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL,
    $1210dafc06b031f1$var$TMP_DB_CASSANDRA_TABLE,
    $1210dafc06b031f1$var$TMP_DB_CASSANDRA_IDEMPOTENCE,
    $1210dafc06b031f1$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
    $1210dafc06b031f1$var$TMP_DB_CASSANDRA_COORDINATOR_ID,
    $1210dafc06b031f1$var$TMP_DB_CASSANDRA_COORDINATOR_DC,
    $1210dafc06b031f1$var$TMP_DB_HBASE_NAMESPACE,
    $1210dafc06b031f1$var$TMP_DB_REDIS_DATABASE_INDEX,
    $1210dafc06b031f1$var$TMP_DB_MONGODB_COLLECTION,
    $1210dafc06b031f1$var$TMP_DB_SQL_TABLE,
    $1210dafc06b031f1$var$TMP_EXCEPTION_TYPE,
    $1210dafc06b031f1$var$TMP_EXCEPTION_MESSAGE,
    $1210dafc06b031f1$var$TMP_EXCEPTION_STACKTRACE,
    $1210dafc06b031f1$var$TMP_EXCEPTION_ESCAPED,
    $1210dafc06b031f1$var$TMP_FAAS_TRIGGER,
    $1210dafc06b031f1$var$TMP_FAAS_EXECUTION,
    $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_COLLECTION,
    $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_OPERATION,
    $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_TIME,
    $1210dafc06b031f1$var$TMP_FAAS_DOCUMENT_NAME,
    $1210dafc06b031f1$var$TMP_FAAS_TIME,
    $1210dafc06b031f1$var$TMP_FAAS_CRON,
    $1210dafc06b031f1$var$TMP_FAAS_COLDSTART,
    $1210dafc06b031f1$var$TMP_FAAS_INVOKED_NAME,
    $1210dafc06b031f1$var$TMP_FAAS_INVOKED_PROVIDER,
    $1210dafc06b031f1$var$TMP_FAAS_INVOKED_REGION,
    $1210dafc06b031f1$var$TMP_NET_TRANSPORT,
    $1210dafc06b031f1$var$TMP_NET_PEER_IP,
    $1210dafc06b031f1$var$TMP_NET_PEER_PORT,
    $1210dafc06b031f1$var$TMP_NET_PEER_NAME,
    $1210dafc06b031f1$var$TMP_NET_HOST_IP,
    $1210dafc06b031f1$var$TMP_NET_HOST_PORT,
    $1210dafc06b031f1$var$TMP_NET_HOST_NAME,
    $1210dafc06b031f1$var$TMP_NET_HOST_CONNECTION_TYPE,
    $1210dafc06b031f1$var$TMP_NET_HOST_CONNECTION_SUBTYPE,
    $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_NAME,
    $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_MCC,
    $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_MNC,
    $1210dafc06b031f1$var$TMP_NET_HOST_CARRIER_ICC,
    $1210dafc06b031f1$var$TMP_PEER_SERVICE,
    $1210dafc06b031f1$var$TMP_ENDUSER_ID,
    $1210dafc06b031f1$var$TMP_ENDUSER_ROLE,
    $1210dafc06b031f1$var$TMP_ENDUSER_SCOPE,
    $1210dafc06b031f1$var$TMP_THREAD_ID,
    $1210dafc06b031f1$var$TMP_THREAD_NAME,
    $1210dafc06b031f1$var$TMP_CODE_FUNCTION,
    $1210dafc06b031f1$var$TMP_CODE_NAMESPACE,
    $1210dafc06b031f1$var$TMP_CODE_FILEPATH,
    $1210dafc06b031f1$var$TMP_CODE_LINENO,
    $1210dafc06b031f1$var$TMP_HTTP_METHOD,
    $1210dafc06b031f1$var$TMP_HTTP_URL,
    $1210dafc06b031f1$var$TMP_HTTP_TARGET,
    $1210dafc06b031f1$var$TMP_HTTP_HOST,
    $1210dafc06b031f1$var$TMP_HTTP_SCHEME,
    $1210dafc06b031f1$var$TMP_HTTP_STATUS_CODE,
    $1210dafc06b031f1$var$TMP_HTTP_FLAVOR,
    $1210dafc06b031f1$var$TMP_HTTP_USER_AGENT,
    $1210dafc06b031f1$var$TMP_HTTP_REQUEST_CONTENT_LENGTH,
    $1210dafc06b031f1$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
    $1210dafc06b031f1$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH,
    $1210dafc06b031f1$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
    $1210dafc06b031f1$var$TMP_HTTP_SERVER_NAME,
    $1210dafc06b031f1$var$TMP_HTTP_ROUTE,
    $1210dafc06b031f1$var$TMP_HTTP_CLIENT_IP,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_TABLE_NAMES,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_CONSISTENT_READ,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_PROJECTION,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_LIMIT,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_INDEX_NAME,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SELECT,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_TABLE_COUNT,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SCAN_FORWARD,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SEGMENT,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_COUNT,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_SCANNED_COUNT,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
    $1210dafc06b031f1$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
    $1210dafc06b031f1$var$TMP_MESSAGING_SYSTEM,
    $1210dafc06b031f1$var$TMP_MESSAGING_DESTINATION,
    $1210dafc06b031f1$var$TMP_MESSAGING_DESTINATION_KIND,
    $1210dafc06b031f1$var$TMP_MESSAGING_TEMP_DESTINATION,
    $1210dafc06b031f1$var$TMP_MESSAGING_PROTOCOL,
    $1210dafc06b031f1$var$TMP_MESSAGING_PROTOCOL_VERSION,
    $1210dafc06b031f1$var$TMP_MESSAGING_URL,
    $1210dafc06b031f1$var$TMP_MESSAGING_MESSAGE_ID,
    $1210dafc06b031f1$var$TMP_MESSAGING_CONVERSATION_ID,
    $1210dafc06b031f1$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
    $1210dafc06b031f1$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
    $1210dafc06b031f1$var$TMP_MESSAGING_OPERATION,
    $1210dafc06b031f1$var$TMP_MESSAGING_CONSUMER_ID,
    $1210dafc06b031f1$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY,
    $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY,
    $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP,
    $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_CLIENT_ID,
    $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_PARTITION,
    $1210dafc06b031f1$var$TMP_MESSAGING_KAFKA_TOMBSTONE,
    $1210dafc06b031f1$var$TMP_RPC_SYSTEM,
    $1210dafc06b031f1$var$TMP_RPC_SERVICE,
    $1210dafc06b031f1$var$TMP_RPC_METHOD,
    $1210dafc06b031f1$var$TMP_RPC_GRPC_STATUS_CODE,
    $1210dafc06b031f1$var$TMP_RPC_JSONRPC_VERSION,
    $1210dafc06b031f1$var$TMP_RPC_JSONRPC_REQUEST_ID,
    $1210dafc06b031f1$var$TMP_RPC_JSONRPC_ERROR_CODE,
    $1210dafc06b031f1$var$TMP_RPC_JSONRPC_ERROR_MESSAGE,
    $1210dafc06b031f1$var$TMP_MESSAGE_TYPE,
    $1210dafc06b031f1$var$TMP_MESSAGE_ID,
    $1210dafc06b031f1$var$TMP_MESSAGE_COMPRESSED_SIZE,
    $1210dafc06b031f1$var$TMP_MESSAGE_UNCOMPRESSED_SIZE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbSystemValues enum definition
 *
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_OTHER_SQL = "other_sql";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MSSQL = "mssql";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MYSQL = "mysql";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_ORACLE = "oracle";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_DB2 = "db2";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_POSTGRESQL = "postgresql";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_REDSHIFT = "redshift";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HIVE = "hive";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE = "cloudscape";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HSQLDB = "hsqldb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_PROGRESS = "progress";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MAXDB = "maxdb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HANADB = "hanadb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INGRES = "ingres";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_FIRSTSQL = "firstsql";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_EDB = "edb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_CACHE = "cache";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_ADABAS = "adabas";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_FIREBIRD = "firebird";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_DERBY = "derby";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_FILEMAKER = "filemaker";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INFORMIX = "informix";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INSTANTDB = "instantdb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INTERBASE = "interbase";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MARIADB = "mariadb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_NETEZZA = "netezza";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_PERVASIVE = "pervasive";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_POINTBASE = "pointbase";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_SQLITE = "sqlite";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_SYBASE = "sybase";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_TERADATA = "teradata";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_VERTICA = "vertica";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_H2 = "h2";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COLDFUSION = "coldfusion";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_CASSANDRA = "cassandra";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HBASE = "hbase";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MONGODB = "mongodb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_REDIS = "redis";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COUCHBASE = "couchbase";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COUCHDB = "couchdb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COSMOSDB = "cosmosdb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_DYNAMODB = "dynamodb";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_NEO4J = "neo4j";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_GEODE = "geode";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH = "elasticsearch";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MEMCACHED = "memcached";
var $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COCKROACHDB = "cockroachdb";
var $1210dafc06b031f1$export$a8dac6c506518069 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_OTHER_SQL;
var $1210dafc06b031f1$export$ea0447329a58abf0 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MSSQL;
var $1210dafc06b031f1$export$f10ddff4d378463e = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MYSQL;
var $1210dafc06b031f1$export$1187a6d6f356ed08 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_ORACLE;
var $1210dafc06b031f1$export$c99652dcdf96b994 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_DB2;
var $1210dafc06b031f1$export$fa83a16930a97d3b = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_POSTGRESQL;
var $1210dafc06b031f1$export$502f4a0041906d71 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_REDSHIFT;
var $1210dafc06b031f1$export$9ca2599ef62580aa = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HIVE;
var $1210dafc06b031f1$export$910728553bdc4f2 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE;
var $1210dafc06b031f1$export$927252a026981dbc = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HSQLDB;
var $1210dafc06b031f1$export$1d4496dd2fb6e5bf = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_PROGRESS;
var $1210dafc06b031f1$export$eeac513ec469c0cd = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MAXDB;
var $1210dafc06b031f1$export$accdcd0fb0e8e3f2 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HANADB;
var $1210dafc06b031f1$export$3dcc190bf239314c = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INGRES;
var $1210dafc06b031f1$export$ff4c8094bbcf5fa7 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_FIRSTSQL;
var $1210dafc06b031f1$export$3277e5141d071eb2 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_EDB;
var $1210dafc06b031f1$export$4a79cae41e08a0dd = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_CACHE;
var $1210dafc06b031f1$export$cf3b85811d34c73b = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_ADABAS;
var $1210dafc06b031f1$export$48eca9ca7c84a995 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_FIREBIRD;
var $1210dafc06b031f1$export$bc5d7654a3e6dc01 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_DERBY;
var $1210dafc06b031f1$export$422940b84b884f99 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_FILEMAKER;
var $1210dafc06b031f1$export$a49658a36841921 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INFORMIX;
var $1210dafc06b031f1$export$dd1bda064bc12f55 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INSTANTDB;
var $1210dafc06b031f1$export$3845f6f803a923b1 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INTERBASE;
var $1210dafc06b031f1$export$1b74fece6a0567e8 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MARIADB;
var $1210dafc06b031f1$export$8fc04abe03bce8d5 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_NETEZZA;
var $1210dafc06b031f1$export$f9406b4f00b760b4 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_PERVASIVE;
var $1210dafc06b031f1$export$5bc787da6daf8e9c = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_POINTBASE;
var $1210dafc06b031f1$export$92e0362f5610565 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_SQLITE;
var $1210dafc06b031f1$export$ec03fbd64421b165 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_SYBASE;
var $1210dafc06b031f1$export$486b763280f7312f = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_TERADATA;
var $1210dafc06b031f1$export$424b3c529411045a = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_VERTICA;
var $1210dafc06b031f1$export$5b4c7807bd4e54d0 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_H2;
var $1210dafc06b031f1$export$998c3a6fdfbcf7df = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COLDFUSION;
var $1210dafc06b031f1$export$dc18027519a667a3 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_CASSANDRA;
var $1210dafc06b031f1$export$a3cbb4bc103ae284 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HBASE;
var $1210dafc06b031f1$export$b1615e3bbcf0dea5 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MONGODB;
var $1210dafc06b031f1$export$e236e209844f1272 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_REDIS;
var $1210dafc06b031f1$export$a3861a07874f1889 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COUCHBASE;
var $1210dafc06b031f1$export$f84afd1ccf7f622f = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COUCHDB;
var $1210dafc06b031f1$export$408510df30ac38f0 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COSMOSDB;
var $1210dafc06b031f1$export$f704654eab77c7c7 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_DYNAMODB;
var $1210dafc06b031f1$export$5eea4c4dfe97cf90 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_NEO4J;
var $1210dafc06b031f1$export$f6740c7ce8d8a59 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_GEODE;
var $1210dafc06b031f1$export$25d0355c3ecc82d5 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH;
var $1210dafc06b031f1$export$3566ede46e0a8a41 = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MEMCACHED;
var $1210dafc06b031f1$export$2844c6dfa3d1660a = $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COCKROACHDB;
var $1210dafc06b031f1$export$53ce5c6571db6866 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_OTHER_SQL,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MSSQL,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MYSQL,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_ORACLE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_DB2,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_POSTGRESQL,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_REDSHIFT,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HIVE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HSQLDB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_PROGRESS,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MAXDB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HANADB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INGRES,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_FIRSTSQL,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_EDB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_CACHE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_ADABAS,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_FIREBIRD,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_DERBY,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_FILEMAKER,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INFORMIX,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INSTANTDB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_INTERBASE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MARIADB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_NETEZZA,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_PERVASIVE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_POINTBASE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_SQLITE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_SYBASE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_TERADATA,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_VERTICA,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_H2,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COLDFUSION,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_CASSANDRA,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_HBASE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MONGODB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_REDIS,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COUCHBASE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COUCHDB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COSMOSDB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_DYNAMODB,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_NEO4J,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_GEODE,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_MEMCACHED,
    $1210dafc06b031f1$var$TMP_DBSYSTEMVALUES_COCKROACHDB
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbCassandraConsistencyLevelValues enum definition
 *
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL = "all";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = "each_quorum";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = "quorum";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = "local_quorum";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE = "one";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO = "two";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE = "three";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = "local_one";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY = "any";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = "serial";
var $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = "local_serial";
var $1210dafc06b031f1$export$8c965dbb4c30de17 = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL;
var $1210dafc06b031f1$export$28269849572f223a = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM;
var $1210dafc06b031f1$export$c31be6925d18faf4 = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM;
var $1210dafc06b031f1$export$dd2d046c43b425dc = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM;
var $1210dafc06b031f1$export$d567e6085f609657 = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE;
var $1210dafc06b031f1$export$2638f2ef2b3637ea = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO;
var $1210dafc06b031f1$export$444dff27642c23a3 = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE;
var $1210dafc06b031f1$export$be0e7a9b9b7460eb = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE;
var $1210dafc06b031f1$export$9cda430306f12b08 = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY;
var $1210dafc06b031f1$export$79a04d8aacdacbe9 = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL;
var $1210dafc06b031f1$export$42bf18043dacb777 = $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL;
var $1210dafc06b031f1$export$a6eeaa6fe6488373 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
    $1210dafc06b031f1$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasTriggerValues enum definition
 *
 * Type of the trigger on which the function is executed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_DATASOURCE = "datasource";
var $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_HTTP = "http";
var $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_PUBSUB = "pubsub";
var $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_TIMER = "timer";
var $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_OTHER = "other";
var $1210dafc06b031f1$export$a116a6c98ad82a77 = $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_DATASOURCE;
var $1210dafc06b031f1$export$1b8130a1d4406030 = $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_HTTP;
var $1210dafc06b031f1$export$2c3c25968f77e7b3 = $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_PUBSUB;
var $1210dafc06b031f1$export$f1adafe5047573a = $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_TIMER;
var $1210dafc06b031f1$export$2aa5343c84c7d0a6 = $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_OTHER;
var $1210dafc06b031f1$export$8bd13b593ef4858d = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_DATASOURCE,
    $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_HTTP,
    $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_PUBSUB,
    $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_TIMER,
    $1210dafc06b031f1$var$TMP_FAASTRIGGERVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasDocumentOperationValues enum definition
 *
 * Describes the type of the operation that was performed on the data.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT = "insert";
var $1210dafc06b031f1$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT = "edit";
var $1210dafc06b031f1$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE = "delete";
var $1210dafc06b031f1$export$58594a32d0721c01 = $1210dafc06b031f1$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT;
var $1210dafc06b031f1$export$fb5981e11be92c91 = $1210dafc06b031f1$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT;
var $1210dafc06b031f1$export$8617289d67ca4e43 = $1210dafc06b031f1$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE;
var $1210dafc06b031f1$export$d6463783e5bb27f9 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT,
    $1210dafc06b031f1$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT,
    $1210dafc06b031f1$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasInvokedProviderValues enum definition
 *
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = "alibaba_cloud";
var $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS = "aws";
var $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE = "azure";
var $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP = "gcp";
var $1210dafc06b031f1$export$a7a256059bf89bd1 = $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD;
var $1210dafc06b031f1$export$8716f61e9f3c2aeb = $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS;
var $1210dafc06b031f1$export$ec924dafe3d951e3 = $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE;
var $1210dafc06b031f1$export$40370ddcd5c5f6d7 = $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP;
var $1210dafc06b031f1$export$668b545a1de0448 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
    $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS,
    $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE,
    $1210dafc06b031f1$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetTransportValues enum definition
 *
 * Transport protocol used. See note below.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_IP_TCP = "ip_tcp";
var $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_IP_UDP = "ip_udp";
var $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_IP = "ip";
var $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_UNIX = "unix";
var $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_PIPE = "pipe";
var $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_INPROC = "inproc";
var $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_OTHER = "other";
var $1210dafc06b031f1$export$98ad64057f1fab9f = $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_IP_TCP;
var $1210dafc06b031f1$export$efc9b6ce6290a881 = $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_IP_UDP;
var $1210dafc06b031f1$export$f3aeea475f2d61eb = $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_IP;
var $1210dafc06b031f1$export$2ff43587ce3a6428 = $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_UNIX;
var $1210dafc06b031f1$export$8a59379768b7dcc2 = $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_PIPE;
var $1210dafc06b031f1$export$24d541ca01c48083 = $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_INPROC;
var $1210dafc06b031f1$export$61986d2ea3f68e4 = $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_OTHER;
var $1210dafc06b031f1$export$3818cf83a3542239 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_IP_TCP,
    $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_IP_UDP,
    $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_IP,
    $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_UNIX,
    $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_PIPE,
    $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_INPROC,
    $1210dafc06b031f1$var$TMP_NETTRANSPORTVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionTypeValues enum definition
 *
 * The internet connection type currently being used by the host.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI = "wifi";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED = "wired";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL = "cell";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = "unavailable";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = "unknown";
var $1210dafc06b031f1$export$9f02ba1730e68d64 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI;
var $1210dafc06b031f1$export$ff976cfa645183ea = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED;
var $1210dafc06b031f1$export$9dac5d5db0d7302d = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL;
var $1210dafc06b031f1$export$856320690b0a4ede = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE;
var $1210dafc06b031f1$export$b93b5033f8372e2b = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN;
var $1210dafc06b031f1$export$a5c9a789b3c34827 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionSubtypeValues enum definition
 *
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = "gprs";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = "edge";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = "umts";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = "cdma";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = "evdo_0";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = "evdo_a";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = "cdma2000_1xrtt";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = "hsdpa";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = "hsupa";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = "hspa";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = "iden";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = "evdo_b";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE = "lte";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = "ehrpd";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = "hspap";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM = "gsm";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = "td_scdma";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = "iwlan";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR = "nr";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = "nrnsa";
var $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = "lte_ca";
var $1210dafc06b031f1$export$b3928d079bcf0650 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS;
var $1210dafc06b031f1$export$869e5d9e2d7d058f = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE;
var $1210dafc06b031f1$export$4fb8dba98d516457 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS;
var $1210dafc06b031f1$export$4c80eef388ebaccf = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA;
var $1210dafc06b031f1$export$fa867825f37e79db = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0;
var $1210dafc06b031f1$export$27a67e3163ce1ca1 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A;
var $1210dafc06b031f1$export$64eea596575c6ac7 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT;
var $1210dafc06b031f1$export$ac76a80a244a93c4 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA;
var $1210dafc06b031f1$export$1f6c75de7c7b16c8 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA;
var $1210dafc06b031f1$export$546b89c4781a174b = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA;
var $1210dafc06b031f1$export$76ada84046ded2cf = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN;
var $1210dafc06b031f1$export$cbc44b2ef04c23f2 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B;
var $1210dafc06b031f1$export$7df810136272d3ca = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE;
var $1210dafc06b031f1$export$6d0261a99bb34b75 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD;
var $1210dafc06b031f1$export$f5609166f18e0da4 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP;
var $1210dafc06b031f1$export$bb1d1d2dc1514ff9 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM;
var $1210dafc06b031f1$export$f39e3589dec1b486 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA;
var $1210dafc06b031f1$export$2ea90d5cadafeb66 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN;
var $1210dafc06b031f1$export$dacf20f714c7dfe3 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR;
var $1210dafc06b031f1$export$3057d75e98c27a82 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA;
var $1210dafc06b031f1$export$ac7da250598a79b7 = $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA;
var $1210dafc06b031f1$export$2f6476d8343c332 = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
    $1210dafc06b031f1$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HttpFlavorValues enum definition
 *
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_HTTP_1_0 = "1.0";
var $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_HTTP_1_1 = "1.1";
var $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_HTTP_2_0 = "2.0";
var $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_SPDY = "SPDY";
var $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_QUIC = "QUIC";
var $1210dafc06b031f1$export$a5eaf604e08c3278 = $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_HTTP_1_0;
var $1210dafc06b031f1$export$90c81a0909f2ae50 = $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_HTTP_1_1;
var $1210dafc06b031f1$export$76fedb424c637ab1 = $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_HTTP_2_0;
var $1210dafc06b031f1$export$64a9fa17294d693a = $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_SPDY;
var $1210dafc06b031f1$export$71f9f90e022dd018 = $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_QUIC;
var $1210dafc06b031f1$export$98fa65d23b3ad768 = {
    HTTP_1_0: $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_HTTP_1_0,
    HTTP_1_1: $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_HTTP_1_1,
    HTTP_2_0: $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_HTTP_2_0,
    SPDY: $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_SPDY,
    QUIC: $1210dafc06b031f1$var$TMP_HTTPFLAVORVALUES_QUIC
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingDestinationKindValues enum definition
 *
 * The kind of message destination.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE = "queue";
var $1210dafc06b031f1$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC = "topic";
var $1210dafc06b031f1$export$3c00656cec2b971b = $1210dafc06b031f1$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE;
var $1210dafc06b031f1$export$5b3434288d57e9db = $1210dafc06b031f1$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC;
var $1210dafc06b031f1$export$c97cf0959c06f2eb = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE,
    $1210dafc06b031f1$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingOperationValues enum definition
 *
 * A string identifying the kind of message consumption as defined in the [Operation names](#operation-names) section above. If the operation is &#34;send&#34;, this attribute MUST NOT be set, since the operation can be inferred from the span kind in that case.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE = "receive";
var $1210dafc06b031f1$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS = "process";
var $1210dafc06b031f1$export$84220b734749f5b0 = $1210dafc06b031f1$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE;
var $1210dafc06b031f1$export$e4e81e41cac54813 = $1210dafc06b031f1$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS;
var $1210dafc06b031f1$export$4a89c511599cd2ec = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE,
    $1210dafc06b031f1$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for RpcGrpcStatusCodeValues enum definition
 *
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_OK = 0;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED = 1;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN = 2;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = 3;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = 4;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND = 5;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = 6;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = 7;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = 8;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = 9;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED = 10;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = 11;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = 12;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL = 13;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = 14;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS = 15;
var $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = 16;
var $1210dafc06b031f1$export$949d8f2733439fe0 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_OK;
var $1210dafc06b031f1$export$3ab4e217bae3a065 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED;
var $1210dafc06b031f1$export$82114f8ba92008f1 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN;
var $1210dafc06b031f1$export$4747f09ec996ed1a = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT;
var $1210dafc06b031f1$export$2f64e796efee7806 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED;
var $1210dafc06b031f1$export$c2b894d36cd1d993 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND;
var $1210dafc06b031f1$export$e675f9346907cdbf = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS;
var $1210dafc06b031f1$export$ee7173f54f1f7e52 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED;
var $1210dafc06b031f1$export$a2e4b937aa6d8799 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED;
var $1210dafc06b031f1$export$ef9ed8d6d4e5cd73 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION;
var $1210dafc06b031f1$export$5186c1c5a9145ea6 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED;
var $1210dafc06b031f1$export$e67583738364c597 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE;
var $1210dafc06b031f1$export$90f86b1e23bb678f = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED;
var $1210dafc06b031f1$export$133efbe81a3e3b7a = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL;
var $1210dafc06b031f1$export$8d87e3aaaab1d8c1 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE;
var $1210dafc06b031f1$export$2acca698ff2f1632 = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS;
var $1210dafc06b031f1$export$fc7c44549e950bf = $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED;
var $1210dafc06b031f1$export$759a06c32b696c70 = {
    OK: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_OK,
    CANCELLED: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED,
    UNKNOWN: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN,
    INVALID_ARGUMENT: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
    DEADLINE_EXCEEDED: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
    NOT_FOUND: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
    ALREADY_EXISTS: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
    PERMISSION_DENIED: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
    RESOURCE_EXHAUSTED: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
    FAILED_PRECONDITION: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
    ABORTED: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED,
    OUT_OF_RANGE: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
    UNIMPLEMENTED: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
    INTERNAL: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL,
    UNAVAILABLE: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
    DATA_LOSS: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
    UNAUTHENTICATED: $1210dafc06b031f1$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessageTypeValues enum definition
 *
 * Whether this is a received or sent message.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $1210dafc06b031f1$var$TMP_MESSAGETYPEVALUES_SENT = "SENT";
var $1210dafc06b031f1$var$TMP_MESSAGETYPEVALUES_RECEIVED = "RECEIVED";
var $1210dafc06b031f1$export$10fb24096e4ea8a3 = $1210dafc06b031f1$var$TMP_MESSAGETYPEVALUES_SENT;
var $1210dafc06b031f1$export$e520006d57a4745f = $1210dafc06b031f1$var$TMP_MESSAGETYPEVALUES_RECEIVED;
var $1210dafc06b031f1$export$c83b17f5976c727c = /*#__PURE__*/ (0, $3d716593ec506807$export$8796db7ca257d576)([
    $1210dafc06b031f1$var$TMP_MESSAGETYPEVALUES_SENT,
    $1210dafc06b031f1$var$TMP_MESSAGETYPEVALUES_RECEIVED
]);


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Event name definitions
var $35d6748f230d9b19$export$a0fff09a5370d06f = "exception";


var $87da5c6ef5348745$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $87da5c6ef5348745$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
/**
 * This class represents a span.
 */ var $87da5c6ef5348745$export$5f1714a13ed34c01 = /** @class */ function() {
    /**
     * Constructs a new Span instance.
     *
     * @deprecated calling Span constructor directly is not supported. Please use tracer.startSpan.
     * */ function Span(parentTracer, context, spanName, spanContext, kind, parentSpanId, links, startTime, _deprecatedClock, attributes) {
        if (links === void 0) links = [];
        this.attributes = {};
        this.links = [];
        this.events = [];
        this._droppedAttributesCount = 0;
        this._droppedEventsCount = 0;
        this._droppedLinksCount = 0;
        this.status = {
            code: (0, $cdb334e89d9a87a2$export$1e28dd9b5d01db83).UNSET
        };
        this.endTime = [
            0,
            0
        ];
        this._ended = false;
        this._duration = [
            -1,
            -1
        ];
        this.name = spanName;
        this._spanContext = spanContext;
        this.parentSpanId = parentSpanId;
        this.kind = kind;
        this.links = links;
        var now = Date.now();
        this._performanceStartTime = (0, $535cbcef4f10c631$export$b22daef4119238cd).now();
        this._performanceOffset = now - (this._performanceStartTime + (0, $24357f53a00dc7a9$export$e752b05e58096a2f)());
        this._startTimeProvided = startTime != null;
        this.startTime = this._getTime(startTime !== null && startTime !== void 0 ? startTime : now);
        this.resource = parentTracer.resource;
        this.instrumentationLibrary = parentTracer.instrumentationLibrary;
        this._spanLimits = parentTracer.getSpanLimits();
        this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0;
        if (attributes != null) this.setAttributes(attributes);
        this._spanProcessor = parentTracer.getActiveSpanProcessor();
        this._spanProcessor.onStart(this, context);
    }
    Span.prototype.spanContext = function() {
        return this._spanContext;
    };
    Span.prototype.setAttribute = function(key, value) {
        if (value == null || this._isSpanEnded()) return this;
        if (key.length === 0) {
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Invalid attribute key: " + key);
            return this;
        }
        if (!(0, $0a53bb1dd0db3a06$export$1daad3d2aacf48c5)(value)) {
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Invalid attribute value set for key: " + key);
            return this;
        }
        if (Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    };
    Span.prototype.setAttributes = function(attributes) {
        var e_1, _a;
        try {
            for(var _b = $87da5c6ef5348745$var$__values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $87da5c6ef5348745$var$__read(_c.value, 2), k = _d[0], v = _d[1];
                this.setAttribute(k, v);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    /**
     *
     * @param name Span Name
     * @param [attributesOrStartTime] Span attributes or start time
     *     if type is {@type TimeInput} and 3rd param is undefined
     * @param [timeStamp] Specified time stamp for the event
     */ Span.prototype.addEvent = function(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded()) return this;
        if (this._spanLimits.eventCountLimit === 0) {
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("No events allowed.");
            this._droppedEventsCount++;
            return this;
        }
        if (this.events.length >= this._spanLimits.eventCountLimit) {
            if (this._droppedEventsCount === 0) (0, $5961b21244e407a2$export$c042e7c2f59bc046).debug("Dropping extra events.");
            this.events.shift();
            this._droppedEventsCount++;
        }
        if ((0, $24357f53a00dc7a9$export$a5e58227c317ebb9)(attributesOrStartTime)) {
            if (!(0, $24357f53a00dc7a9$export$a5e58227c317ebb9)(timeStamp)) timeStamp = attributesOrStartTime;
            attributesOrStartTime = undefined;
        }
        var attributes = (0, $0a53bb1dd0db3a06$export$b0663eba150d60c9)(attributesOrStartTime);
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0
        });
        return this;
    };
    Span.prototype.setStatus = function(status) {
        if (this._isSpanEnded()) return this;
        this.status = status;
        return this;
    };
    Span.prototype.updateName = function(name) {
        if (this._isSpanEnded()) return this;
        this.name = name;
        return this;
    };
    Span.prototype.end = function(endTime) {
        if (this._isSpanEnded()) {
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
            return;
        }
        this._ended = true;
        this.endTime = this._getTime(endTime);
        this._duration = (0, $24357f53a00dc7a9$export$b783ad6617389e3e)(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [
                0,
                0
            ];
        }
        if (this._droppedEventsCount > 0) (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached");
        this._spanProcessor.onEnd(this);
    };
    Span.prototype._getTime = function(inp) {
        if (typeof inp === "number" && inp < (0, $535cbcef4f10c631$export$b22daef4119238cd).now()) // must be a performance timestamp
        // apply correction and convert to hrtime
        return (0, $24357f53a00dc7a9$export$24b3f7dcd2848fa8)(inp + this._performanceOffset);
        if (typeof inp === "number") return (0, $24357f53a00dc7a9$export$e7ec5c82995537b1)(inp);
        if (inp instanceof Date) return (0, $24357f53a00dc7a9$export$e7ec5c82995537b1)(inp.getTime());
        if ((0, $24357f53a00dc7a9$export$390c59432f173a9f)(inp)) return inp;
        if (this._startTimeProvided) // if user provided a time for the start manually
        // we can't use duration to calculate event/end times
        return (0, $24357f53a00dc7a9$export$e7ec5c82995537b1)(Date.now());
        var msDuration = (0, $535cbcef4f10c631$export$b22daef4119238cd).now() - this._performanceStartTime;
        return (0, $24357f53a00dc7a9$export$f07bb1dbc72184c3)(this.startTime, (0, $24357f53a00dc7a9$export$e7ec5c82995537b1)(msDuration));
    };
    Span.prototype.isRecording = function() {
        return this._ended === false;
    };
    Span.prototype.recordException = function(exception, time) {
        var attributes = {};
        if (typeof exception === "string") attributes[(0, $1210dafc06b031f1$export$949e366c5c69d2e9).EXCEPTION_MESSAGE] = exception;
        else if (exception) {
            if (exception.code) attributes[(0, $1210dafc06b031f1$export$949e366c5c69d2e9).EXCEPTION_TYPE] = exception.code.toString();
            else if (exception.name) attributes[(0, $1210dafc06b031f1$export$949e366c5c69d2e9).EXCEPTION_TYPE] = exception.name;
            if (exception.message) attributes[(0, $1210dafc06b031f1$export$949e366c5c69d2e9).EXCEPTION_MESSAGE] = exception.message;
            if (exception.stack) attributes[(0, $1210dafc06b031f1$export$949e366c5c69d2e9).EXCEPTION_STACKTRACE] = exception.stack;
        }
        // these are minimum requirements from spec
        if (attributes[(0, $1210dafc06b031f1$export$949e366c5c69d2e9).EXCEPTION_TYPE] || attributes[(0, $1210dafc06b031f1$export$949e366c5c69d2e9).EXCEPTION_MESSAGE]) this.addEvent((0, $35d6748f230d9b19$export$a0fff09a5370d06f), attributes, time);
        else (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Failed to record an exception " + exception);
    };
    Object.defineProperty(Span.prototype, "duration", {
        get: function() {
            return this._duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "ended", {
        get: function() {
            return this._ended;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedAttributesCount", {
        get: function() {
            return this._droppedAttributesCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedEventsCount", {
        get: function() {
            return this._droppedEventsCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedLinksCount", {
        get: function() {
            return this._droppedLinksCount;
        },
        enumerable: false,
        configurable: true
    });
    Span.prototype._isSpanEnded = function() {
        if (this._ended) (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}");
        return this._ended;
    };
    // Utility function to truncate given value within size
    // for value type of string, will truncate to given limit
    // for type of non-string, will return same value
    Span.prototype._truncateToLimitUtil = function(value, limit) {
        if (value.length <= limit) return value;
        return value.substr(0, limit);
    };
    /**
     * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
     * return string with trucated to {@code attributeValueLengthLimit} characters
     *
     * If the given attribute value is array of strings then
     * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
     *
     * Otherwise return same Attribute {@code value}
     *
     * @param value Attribute value
     * @returns truncated attribute value if required, otherwise same value
     */ Span.prototype._truncateToSize = function(value) {
        var _this = this;
        var limit = this._attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn("Attribute value limit must be positive, got " + limit);
            return value;
        }
        // String
        if (typeof value === "string") return this._truncateToLimitUtil(value, limit);
        // Array of strings
        if (Array.isArray(value)) return value.map(function(val) {
            return typeof val === "string" ? _this._truncateToLimitUtil(val, limit) : val;
        });
        // Other types, no need to apply value length limit
        return value;
    };
    return Span;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $202ccca3cfdc0a7d$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($202ccca3cfdc0a7d$export$94df7a7a96a92f7b || ($202ccca3cfdc0a7d$export$94df7a7a96a92f7b = {}));


/** Sampler that samples no traces. */ var $8d28fb373a7dd415$export$abc5f11618c4d6a3 = /** @class */ function() {
    function AlwaysOffSampler() {}
    AlwaysOffSampler.prototype.shouldSample = function() {
        return {
            decision: (0, $202ccca3cfdc0a7d$export$94df7a7a96a92f7b).NOT_RECORD
        };
    };
    AlwaysOffSampler.prototype.toString = function() {
        return "AlwaysOffSampler";
    };
    return AlwaysOffSampler;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/** Sampler that samples all traces. */ var $1978845c915b108f$export$653f832afb4ffa27 = /** @class */ function() {
    function AlwaysOnSampler() {}
    AlwaysOnSampler.prototype.shouldSample = function() {
        return {
            decision: (0, $202ccca3cfdc0a7d$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED
        };
    };
    AlwaysOnSampler.prototype.toString = function() {
        return "AlwaysOnSampler";
    };
    return AlwaysOnSampler;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 



/**
 * A composite sampler that either respects the parent span's sampling decision
 * or delegates to `delegateSampler` for root spans.
 */ var $719ae78a57f85967$export$2bc0b1b09c2e3b47 = /** @class */ function() {
    function ParentBasedSampler(config) {
        var _a, _b, _c, _d;
        this._root = config.root;
        if (!this._root) {
            (0, $0c401b13a0f4a52d$export$54c6946fc34b7cc2)(new Error("ParentBasedSampler must have a root sampler configured"));
            this._root = new (0, $1978845c915b108f$export$653f832afb4ffa27)();
        }
        this._remoteParentSampled = (_a = config.remoteParentSampled) !== null && _a !== void 0 ? _a : new (0, $1978845c915b108f$export$653f832afb4ffa27)();
        this._remoteParentNotSampled = (_b = config.remoteParentNotSampled) !== null && _b !== void 0 ? _b : new (0, $8d28fb373a7dd415$export$abc5f11618c4d6a3)();
        this._localParentSampled = (_c = config.localParentSampled) !== null && _c !== void 0 ? _c : new (0, $1978845c915b108f$export$653f832afb4ffa27)();
        this._localParentNotSampled = (_d = config.localParentNotSampled) !== null && _d !== void 0 ? _d : new (0, $8d28fb373a7dd415$export$abc5f11618c4d6a3)();
    }
    ParentBasedSampler.prototype.shouldSample = function(context, traceId, spanName, spanKind, attributes, links) {
        var parentContext = (0, $74ed2dbfdbf87d9b$export$357889f174732d38).getSpanContext(context);
        if (!parentContext || !(0, $eb966c722689e573$export$e4373b9a2c09216c)(parentContext)) return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & (0, $91d5e49b421908a7$export$bf9049ad2b0883ff).SAMPLED) return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & (0, $91d5e49b421908a7$export$bf9049ad2b0883ff).SAMPLED) return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    };
    ParentBasedSampler.prototype.toString = function() {
        return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    };
    return ParentBasedSampler;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/** Sampler that samples a given fraction of traces based of trace id deterministically. */ var $0b2d04bfbef7d261$export$f1624f887f708bbf = /** @class */ function() {
    function TraceIdRatioBasedSampler(_ratio) {
        if (_ratio === void 0) _ratio = 0;
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    TraceIdRatioBasedSampler.prototype.shouldSample = function(context, traceId) {
        return {
            decision: (0, $eb966c722689e573$export$29dd34cf1269f6da)(traceId) && this._accumulate(traceId) < this._upperBound ? (0, $202ccca3cfdc0a7d$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED : (0, $202ccca3cfdc0a7d$export$94df7a7a96a92f7b).NOT_RECORD
        };
    };
    TraceIdRatioBasedSampler.prototype.toString = function() {
        return "TraceIdRatioBased{" + this._ratio + "}";
    };
    TraceIdRatioBasedSampler.prototype._normalize = function(ratio) {
        if (typeof ratio !== "number" || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    };
    TraceIdRatioBasedSampler.prototype._accumulate = function(traceId) {
        var accumulation = 0;
        for(var i = 0; i < traceId.length / 8; i++){
            var pos = i * 8;
            var part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    };
    return TraceIdRatioBasedSampler;
}();


var $68a12a27e307bdee$var$env = (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)();
var $68a12a27e307bdee$var$FALLBACK_OTEL_TRACES_SAMPLER = (0, $e170b32729b17901$export$243c1c4fe84ef188).AlwaysOn;
var $68a12a27e307bdee$var$DEFAULT_RATIO = 1;
function $68a12a27e307bdee$export$d25a2c2f78a5e968() {
    return {
        sampler: $68a12a27e307bdee$export$534308d7e73f0e71($68a12a27e307bdee$var$env),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_ATTRIBUTE_COUNT_LIMIT
        },
        spanLimits: {
            attributeValueLengthLimit: (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
            linkCountLimit: (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_SPAN_LINK_COUNT_LIMIT,
            eventCountLimit: (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_SPAN_EVENT_COUNT_LIMIT,
            attributePerEventCountLimit: (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
            attributePerLinkCountLimit: (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
        }
    };
}
function $68a12a27e307bdee$export$534308d7e73f0e71(environment) {
    if (environment === void 0) environment = (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)();
    switch(environment.OTEL_TRACES_SAMPLER){
        case (0, $e170b32729b17901$export$243c1c4fe84ef188).AlwaysOn:
            return new (0, $1978845c915b108f$export$653f832afb4ffa27)();
        case (0, $e170b32729b17901$export$243c1c4fe84ef188).AlwaysOff:
            return new (0, $8d28fb373a7dd415$export$abc5f11618c4d6a3)();
        case (0, $e170b32729b17901$export$243c1c4fe84ef188).ParentBasedAlwaysOn:
            return new (0, $719ae78a57f85967$export$2bc0b1b09c2e3b47)({
                root: new (0, $1978845c915b108f$export$653f832afb4ffa27)()
            });
        case (0, $e170b32729b17901$export$243c1c4fe84ef188).ParentBasedAlwaysOff:
            return new (0, $719ae78a57f85967$export$2bc0b1b09c2e3b47)({
                root: new (0, $8d28fb373a7dd415$export$abc5f11618c4d6a3)()
            });
        case (0, $e170b32729b17901$export$243c1c4fe84ef188).TraceIdRatio:
            return new (0, $0b2d04bfbef7d261$export$f1624f887f708bbf)($68a12a27e307bdee$var$getSamplerProbabilityFromEnv(environment));
        case (0, $e170b32729b17901$export$243c1c4fe84ef188).ParentBasedTraceIdRatio:
            return new (0, $719ae78a57f85967$export$2bc0b1b09c2e3b47)({
                root: new (0, $0b2d04bfbef7d261$export$f1624f887f708bbf)($68a12a27e307bdee$var$getSamplerProbabilityFromEnv(environment))
            });
        default:
            (0, $5961b21244e407a2$export$c042e7c2f59bc046).error('OTEL_TRACES_SAMPLER value "' + environment.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + $68a12a27e307bdee$var$FALLBACK_OTEL_TRACES_SAMPLER + '".');
            return new (0, $1978845c915b108f$export$653f832afb4ffa27)();
    }
}
function $68a12a27e307bdee$var$getSamplerProbabilityFromEnv(environment) {
    if (environment.OTEL_TRACES_SAMPLER_ARG === undefined || environment.OTEL_TRACES_SAMPLER_ARG === "") {
        (0, $5961b21244e407a2$export$c042e7c2f59bc046).error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + $68a12a27e307bdee$var$DEFAULT_RATIO + ".");
        return $68a12a27e307bdee$var$DEFAULT_RATIO;
    }
    var probability = Number(environment.OTEL_TRACES_SAMPLER_ARG);
    if (isNaN(probability)) {
        (0, $5961b21244e407a2$export$c042e7c2f59bc046).error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + $68a12a27e307bdee$var$DEFAULT_RATIO + ".");
        return $68a12a27e307bdee$var$DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        (0, $5961b21244e407a2$export$c042e7c2f59bc046).error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + $68a12a27e307bdee$var$DEFAULT_RATIO + ".");
        return $68a12a27e307bdee$var$DEFAULT_RATIO;
    }
    return probability;
}



function $6269a983e4ba1e8a$export$7ec1ebcfa9d8bd6a(userConfig) {
    var perInstanceDefaults = {
        sampler: (0, $68a12a27e307bdee$export$534308d7e73f0e71)()
    };
    var DEFAULT_CONFIG = (0, $68a12a27e307bdee$export$d25a2c2f78a5e968)();
    var target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function $6269a983e4ba1e8a$export$9f9fb435f8494555(userConfig) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var spanLimits = Object.assign({}, userConfig.spanLimits);
    var parsedEnvConfig = (0, $bfc57ce81e0eab65$export$728650dd4748d692)();
    /**
     * Reassign span attribute count limit to use first non null value defined by user or use default value
     */ spanLimits.attributeCountLimit = (_f = (_e = (_d = (_b = (_a = userConfig.spanLimits) === null || _a === void 0 ? void 0 : _a.attributeCountLimit) !== null && _b !== void 0 ? _b : (_c = userConfig.generalLimits) === null || _c === void 0 ? void 0 : _c.attributeCountLimit) !== null && _d !== void 0 ? _d : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && _e !== void 0 ? _e : parsedEnvConfig.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && _f !== void 0 ? _f : (0, $bfc57ce81e0eab65$export$6ad612be99f9ed48);
    /**
     * Reassign span attribute value length limit to use first non null value defined by user or use default value
     */ spanLimits.attributeValueLengthLimit = (_m = (_l = (_k = (_h = (_g = userConfig.spanLimits) === null || _g === void 0 ? void 0 : _g.attributeValueLengthLimit) !== null && _h !== void 0 ? _h : (_j = userConfig.generalLimits) === null || _j === void 0 ? void 0 : _j.attributeValueLengthLimit) !== null && _k !== void 0 ? _k : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _l !== void 0 ? _l : parsedEnvConfig.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _m !== void 0 ? _m : (0, $bfc57ce81e0eab65$export$d9446f3c1c12def1);
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7cad77fe7962678d$var$SPAN_ID_BYTES = 8;
var $7cad77fe7962678d$var$TRACE_ID_BYTES = 16;
var $7cad77fe7962678d$export$97307207ef48da75 = /** @class */ function() {
    function RandomIdGenerator() {
        /**
         * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
         * characters corresponding to 128 bits.
         */ this.generateTraceId = $7cad77fe7962678d$var$getIdGenerator($7cad77fe7962678d$var$TRACE_ID_BYTES);
        /**
         * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
         * characters corresponding to 64 bits.
         */ this.generateSpanId = $7cad77fe7962678d$var$getIdGenerator($7cad77fe7962678d$var$SPAN_ID_BYTES);
    }
    return RandomIdGenerator;
}();
var $7cad77fe7962678d$var$SHARED_CHAR_CODES_ARRAY = Array(32);
function $7cad77fe7962678d$var$getIdGenerator(bytes) {
    return function generateId() {
        for(var i = 0; i < bytes * 2; i++){
            $7cad77fe7962678d$var$SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if ($7cad77fe7962678d$var$SHARED_CHAR_CODES_ARRAY[i] >= 58) $7cad77fe7962678d$var$SHARED_CHAR_CODES_ARRAY[i] += 39;
        }
        return String.fromCharCode.apply(null, $7cad77fe7962678d$var$SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}


/**
 * This class represents a basic tracer.
 */ var $187dba755504cb83$export$c4b9363e2fc65361 = /** @class */ function() {
    /**
     * Constructs a new Tracer instance.
     */ function Tracer(instrumentationLibrary, config, _tracerProvider) {
        this._tracerProvider = _tracerProvider;
        var localConfig = (0, $6269a983e4ba1e8a$export$7ec1ebcfa9d8bd6a)(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new (0, $7cad77fe7962678d$export$97307207ef48da75)();
        this.resource = _tracerProvider.resource;
        this.instrumentationLibrary = instrumentationLibrary;
    }
    /**
     * Starts a new Span or returns the default NoopSpan based on the sampling
     * decision.
     */ Tracer.prototype.startSpan = function(name, options, context) {
        var _a, _b, _c;
        if (options === void 0) options = {};
        if (context === void 0) context = $033d6775d2f4334e$export$a078c61943f9dbbe.active();
        // remove span from context in case a root span is requested via options
        if (options.root) context = $74ed2dbfdbf87d9b$export$357889f174732d38.deleteSpan(context);
        var parentSpan = $74ed2dbfdbf87d9b$export$357889f174732d38.getSpan(context);
        if ((0, $c1ddd3204a07409f$export$7d5f2376f7cf513)(context)) {
            $5961b21244e407a2$export$c042e7c2f59bc046.debug("Instrumentation suppressed, returning Noop Span");
            var nonRecordingSpan = $74ed2dbfdbf87d9b$export$357889f174732d38.wrapSpanContext($5dc7f57baf976773$export$8591e4c852b66703);
            return nonRecordingSpan;
        }
        var parentSpanContext = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext();
        var spanId = this._idGenerator.generateSpanId();
        var traceId;
        var traceState;
        var parentSpanId;
        if (!parentSpanContext || !$74ed2dbfdbf87d9b$export$357889f174732d38.isSpanContextValid(parentSpanContext)) // New root span.
        traceId = this._idGenerator.generateTraceId();
        else {
            // New child span.
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            parentSpanId = parentSpanContext.spanId;
        }
        var spanKind = (_a = options.kind) !== null && _a !== void 0 ? _a : $7886c8f9b55154b2$export$4da4ea8145910e8b.INTERNAL;
        var links = ((_b = options.links) !== null && _b !== void 0 ? _b : []).map(function(link) {
            return {
                context: link.context,
                attributes: (0, $0a53bb1dd0db3a06$export$b0663eba150d60c9)(link.attributes)
            };
        });
        var attributes = (0, $0a53bb1dd0db3a06$export$b0663eba150d60c9)(options.attributes);
        // make sampling decision
        var samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        traceState = (_c = samplingResult.traceState) !== null && _c !== void 0 ? _c : traceState;
        var traceFlags = samplingResult.decision === $47601d93c7415601$export$94df7a7a96a92f7b.RECORD_AND_SAMPLED ? $91d5e49b421908a7$export$bf9049ad2b0883ff.SAMPLED : $91d5e49b421908a7$export$bf9049ad2b0883ff.NONE;
        var spanContext = {
            traceId: traceId,
            spanId: spanId,
            traceFlags: traceFlags,
            traceState: traceState
        };
        if (samplingResult.decision === $47601d93c7415601$export$94df7a7a96a92f7b.NOT_RECORD) {
            $5961b21244e407a2$export$c042e7c2f59bc046.debug("Recording is off, propagating context in a non-recording span");
            var nonRecordingSpan = $74ed2dbfdbf87d9b$export$357889f174732d38.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        // Set initial span attributes. The attributes object may have been mutated
        // by the sampler, so we sanitize the merged attributes before setting them.
        var initAttributes = (0, $0a53bb1dd0db3a06$export$b0663eba150d60c9)(Object.assign(attributes, samplingResult.attributes));
        var span = new (0, $87da5c6ef5348745$export$5f1714a13ed34c01)(this, context, name, spanContext, spanKind, parentSpanId, links, options.startTime, undefined, initAttributes);
        return span;
    };
    Tracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $033d6775d2f4334e$export$a078c61943f9dbbe.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = $74ed2dbfdbf87d9b$export$357889f174732d38.setSpan(parentContext, span);
        return $033d6775d2f4334e$export$a078c61943f9dbbe.with(contextWithSpanSet, fn, undefined, span);
    };
    /** Returns the active {@link GeneralLimits}. */ Tracer.prototype.getGeneralLimits = function() {
        return this._generalLimits;
    };
    /** Returns the active {@link SpanLimits}. */ Tracer.prototype.getSpanLimits = function() {
        return this._spanLimits;
    };
    Tracer.prototype.getActiveSpanProcessor = function() {
        return this._tracerProvider.getActiveSpanProcessor();
    };
    return Tracer;
}();



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $77f0578079abc303$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Implementation of the {@link SpanProcessor} that simply forwards all
 * received events to a list of {@link SpanProcessor}s.
 */ var $77f0578079abc303$export$3012fe5a49154394 = /** @class */ function() {
    function MultiSpanProcessor(_spanProcessors) {
        this._spanProcessors = _spanProcessors;
    }
    MultiSpanProcessor.prototype.forceFlush = function() {
        var e_1, _a;
        var promises = [];
        try {
            for(var _b = $77f0578079abc303$var$__values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                promises.push(spanProcessor.forceFlush());
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return new Promise(function(resolve) {
            Promise.all(promises).then(function() {
                resolve();
            }).catch(function(error) {
                (0, $0c401b13a0f4a52d$export$54c6946fc34b7cc2)(error || new Error("MultiSpanProcessor: forceFlush failed"));
                resolve();
            });
        });
    };
    MultiSpanProcessor.prototype.onStart = function(span, context) {
        var e_2, _a;
        try {
            for(var _b = $77f0578079abc303$var$__values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                spanProcessor.onStart(span, context);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    MultiSpanProcessor.prototype.onEnd = function(span) {
        var e_3, _a;
        try {
            for(var _b = $77f0578079abc303$var$__values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                spanProcessor.onEnd(span);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    MultiSpanProcessor.prototype.shutdown = function() {
        var e_4, _a;
        var promises = [];
        try {
            for(var _b = $77f0578079abc303$var$__values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                promises.push(spanProcessor.shutdown());
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return new Promise(function(resolve, reject) {
            Promise.all(promises).then(function() {
                resolve();
            }, reject);
        });
    };
    return MultiSpanProcessor;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** No-op implementation of SpanProcessor */ var $714f5d6c59a914e7$export$27767823ad33d189 = /** @class */ function() {
    function NoopSpanProcessor() {}
    NoopSpanProcessor.prototype.onStart = function(_span, _context) {};
    NoopSpanProcessor.prototype.onEnd = function(_span) {};
    NoopSpanProcessor.prototype.shutdown = function() {
        return Promise.resolve();
    };
    NoopSpanProcessor.prototype.forceFlush = function() {
        return Promise.resolve();
    };
    return NoopSpanProcessor;
}();




var $9faa70fdd973443d$export$11a85395fcf5a7f0;
(function(ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})($9faa70fdd973443d$export$11a85395fcf5a7f0 || ($9faa70fdd973443d$export$11a85395fcf5a7f0 = {}));
/**
 * This class represents a basic tracer provider which platform libraries can extend
 */ var $9faa70fdd973443d$export$1f2f0f67f5ecff3b = /** @class */ function() {
    function BasicTracerProvider(config) {
        if (config === void 0) config = {};
        var _a;
        this._registeredSpanProcessors = [];
        this._tracers = new Map();
        var mergedConfig = (0, $2543edb765e58b8d$export$4950aa0f605343fb)({}, (0, $68a12a27e307bdee$export$d25a2c2f78a5e968)(), (0, $6269a983e4ba1e8a$export$9f9fb435f8494555)(config));
        this.resource = (_a = mergedConfig.resource) !== null && _a !== void 0 ? _a : (0, $8dcd3cef0f1322fc$export$39a853cfb5a94a63).empty();
        this.resource = (0, $8dcd3cef0f1322fc$export$39a853cfb5a94a63).default().merge(this.resource);
        this._config = Object.assign({}, mergedConfig, {
            resource: this.resource
        });
        var defaultExporter = this._buildExporterFromEnv();
        if (defaultExporter !== undefined) {
            var batchProcessor = new (0, $e6a81b33fd165b69$export$237547059fd543f9)(defaultExporter);
            this.activeSpanProcessor = batchProcessor;
        } else this.activeSpanProcessor = new (0, $714f5d6c59a914e7$export$27767823ad33d189)();
    }
    BasicTracerProvider.prototype.getTracer = function(name, version, options) {
        var key = name + "@" + (version || "") + ":" + ((options === null || options === void 0 ? void 0 : options.schemaUrl) || "");
        if (!this._tracers.has(key)) this._tracers.set(key, new (0, $187dba755504cb83$export$c4b9363e2fc65361)({
            name: name,
            version: version,
            schemaUrl: options === null || options === void 0 ? void 0 : options.schemaUrl
        }, this._config, this));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tracers.get(key);
    };
    /**
     * Adds a new {@link SpanProcessor} to this tracer.
     * @param spanProcessor the new SpanProcessor to be added.
     */ BasicTracerProvider.prototype.addSpanProcessor = function(spanProcessor) {
        if (this._registeredSpanProcessors.length === 0) // since we might have enabled by default a batchProcessor, we disable it
        // before adding the new one
        this.activeSpanProcessor.shutdown().catch(function(err) {
            return (0, $5961b21244e407a2$export$c042e7c2f59bc046).error("Error while trying to shutdown current span processor", err);
        });
        this._registeredSpanProcessors.push(spanProcessor);
        this.activeSpanProcessor = new (0, $77f0578079abc303$export$3012fe5a49154394)(this._registeredSpanProcessors);
    };
    BasicTracerProvider.prototype.getActiveSpanProcessor = function() {
        return this.activeSpanProcessor;
    };
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ BasicTracerProvider.prototype.register = function(config) {
        if (config === void 0) config = {};
        (0, $74ed2dbfdbf87d9b$export$357889f174732d38).setGlobalTracerProvider(this);
        if (config.propagator === undefined) config.propagator = this._buildPropagatorFromEnv();
        if (config.contextManager) (0, $033d6775d2f4334e$export$a078c61943f9dbbe).setGlobalContextManager(config.contextManager);
        if (config.propagator) (0, $64245f18975a06c0$export$3e49040daa9dba20).setGlobalPropagator(config.propagator);
    };
    BasicTracerProvider.prototype.forceFlush = function() {
        var timeout = this._config.forceFlushTimeoutMillis;
        var promises = this._registeredSpanProcessors.map(function(spanProcessor) {
            return new Promise(function(resolve) {
                var state;
                var timeoutInterval = setTimeout(function() {
                    resolve(new Error("Span processor did not completed within timeout period of " + timeout + " ms"));
                    state = $9faa70fdd973443d$export$11a85395fcf5a7f0.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(function() {
                    clearTimeout(timeoutInterval);
                    if (state !== $9faa70fdd973443d$export$11a85395fcf5a7f0.timeout) {
                        state = $9faa70fdd973443d$export$11a85395fcf5a7f0.resolved;
                        resolve(state);
                    }
                }).catch(function(error) {
                    clearTimeout(timeoutInterval);
                    state = $9faa70fdd973443d$export$11a85395fcf5a7f0.error;
                    resolve(error);
                });
            });
        });
        return new Promise(function(resolve, reject) {
            Promise.all(promises).then(function(results) {
                var errors = results.filter(function(result) {
                    return result !== $9faa70fdd973443d$export$11a85395fcf5a7f0.resolved;
                });
                if (errors.length > 0) reject(errors);
                else resolve();
            }).catch(function(error) {
                return reject([
                    error
                ]);
            });
        });
    };
    BasicTracerProvider.prototype.shutdown = function() {
        return this.activeSpanProcessor.shutdown();
    };
    /**
     * TS cannot yet infer the type of this.constructor:
     * https://github.com/Microsoft/TypeScript/issues/3841#issuecomment-337560146
     * There is no need to override either of the getters in your child class.
     * The type of the registered component maps should be the same across all
     * classes in the inheritance tree.
     */ BasicTracerProvider.prototype._getPropagator = function(name) {
        var _a;
        return (_a = this.constructor._registeredPropagators.get(name)) === null || _a === void 0 ? void 0 : _a();
    };
    BasicTracerProvider.prototype._getSpanExporter = function(name) {
        var _a;
        return (_a = this.constructor._registeredExporters.get(name)) === null || _a === void 0 ? void 0 : _a();
    };
    BasicTracerProvider.prototype._buildPropagatorFromEnv = function() {
        var _this = this;
        // per spec, propagators from env must be deduplicated
        var uniquePropagatorNames = Array.from(new Set((0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_PROPAGATORS));
        var propagators = uniquePropagatorNames.map(function(name) {
            var propagator = _this._getPropagator(name);
            if (!propagator) (0, $5961b21244e407a2$export$c042e7c2f59bc046).warn('Propagator "' + name + '" requested through environment variable is unavailable.');
            return propagator;
        });
        var validPropagators = propagators.reduce(function(list, item) {
            if (item) list.push(item);
            return list;
        }, []);
        if (validPropagators.length === 0) return;
        else if (uniquePropagatorNames.length === 1) return validPropagators[0];
        else return new (0, $80945b0da65f6fe7$export$4beb26f46770357f)({
            propagators: validPropagators
        });
    };
    BasicTracerProvider.prototype._buildExporterFromEnv = function() {
        var exporterName = (0, $63326e086ae3cd19$export$4bd44a2aa29d3d6e)().OTEL_TRACES_EXPORTER;
        if (exporterName === "none" || exporterName === "") return;
        var exporter = this._getSpanExporter(exporterName);
        if (!exporter) (0, $5961b21244e407a2$export$c042e7c2f59bc046).error('Exporter "' + exporterName + '" requested through environment variable is unavailable.');
        return exporter;
    };
    BasicTracerProvider._registeredPropagators = new Map([
        [
            "tracecontext",
            function() {
                return new (0, $5584fa283530c440$export$737c747d043a1f7b)();
            }
        ],
        [
            "baggage",
            function() {
                return new (0, $647d2239f8c3b03d$export$604bcc7f2bff6bb)();
            }
        ]
    ]);
    BasicTracerProvider._registeredExporters = new Map();
    return BasicTracerProvider;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cbf01751e83f0c4d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $cbf01751e83f0c4d$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Stack Context Manager for managing the state in web
 * it doesn't fully support the async calls though
 */ var $cbf01751e83f0c4d$export$3dfe62dd209faf13 = /** @class */ function() {
    function StackContextManager() {
        /**
         * whether the context manager is enabled or not
         */ this._enabled = false;
        /**
         * Keeps the reference to current context
         */ this._currentContext = (0, $8de61a3e7738d1ff$export$78df28f9b2f9a7dc);
    }
    /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/ban-types
    StackContextManager.prototype._bindFunction = function(context, target) {
        if (context === void 0) context = (0, $8de61a3e7738d1ff$export$78df28f9b2f9a7dc);
        var manager = this;
        var contextWrapper = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.with(context, function() {
                return target.apply(_this, args);
            });
        };
        Object.defineProperty(contextWrapper, "length", {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    };
    /**
     * Returns the active context
     */ StackContextManager.prototype.active = function() {
        return this._currentContext;
    };
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ StackContextManager.prototype.bind = function(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === "function") return this._bindFunction(context, target);
        return target;
    };
    /**
     * Disable the context manager (clears the current context)
     */ StackContextManager.prototype.disable = function() {
        this._currentContext = (0, $8de61a3e7738d1ff$export$78df28f9b2f9a7dc);
        this._enabled = false;
        return this;
    };
    /**
     * Enables the context manager and creates a default(root) context
     */ StackContextManager.prototype.enable = function() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $8de61a3e7738d1ff$export$78df28f9b2f9a7dc);
        return this;
    };
    /**
     * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
     * The context will be set as active
     * @param context
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ StackContextManager.prototype.with = function(context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        var previousContext = this._currentContext;
        this._currentContext = context || (0, $8de61a3e7738d1ff$export$78df28f9b2f9a7dc);
        try {
            return fn.call.apply(fn, $cbf01751e83f0c4d$var$__spreadArray([
                thisArg
            ], $cbf01751e83f0c4d$var$__read(args), false));
        } finally{
            this._currentContext = previousContext;
        }
    };
    return StackContextManager;
}();


var $4db8b20b4b2fad32$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This class represents a web tracer with {@link StackContextManager}
 */ var $4db8b20b4b2fad32$export$a785009afeee3453 = /** @class */ function(_super) {
    $4db8b20b4b2fad32$var$__extends(WebTracerProvider, _super);
    /**
     * Constructs a new Tracer instance.
     * @param config Web Tracer config
     */ function WebTracerProvider(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, config) || this;
        if (config.contextManager) throw "contextManager should be defined in register method not in constructor";
        if (config.propagator) throw "propagator should be defined in register method not in constructor";
        return _this;
    }
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ WebTracerProvider.prototype.register = function(config) {
        if (config === void 0) config = {};
        if (config.contextManager === undefined) config.contextManager = new (0, $cbf01751e83f0c4d$export$3dfe62dd209faf13)();
        if (config.contextManager) config.contextManager.enable();
        _super.prototype.register.call(this, config);
    };
    return WebTracerProvider;
}((0, $9faa70fdd973443d$export$1f2f0f67f5ecff3b));






const $f5328b777e1b8fec$var$TelemetryContextDefaultValues = {
    enabled: true,
    tracer: undefined,
    sendErrorTrace: ()=>{}
};
const $f5328b777e1b8fec$export$7b6b7bc4acb29126 = /*#__PURE__*/ (0, $lT7pJ.createContext)($f5328b777e1b8fec$var$TelemetryContextDefaultValues);
function $f5328b777e1b8fec$export$a15d15518a3ec33d() {
    return (0, $lT7pJ.useContext)($f5328b777e1b8fec$export$7b6b7bc4acb29126);
}
function $f5328b777e1b8fec$export$bb3ea6dd2428edb6({ enabled: enabled, children: children }) {
    const addressData = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.addressData);
    const tracer = (0, $lT7pJ.useMemo)(()=>{
        if (enabled) {
            const exporter = new (0, $4bdf0522111eec9f$export$f73dc942b4b27de3)({
                url: (0, $bbe458fac496c294$export$1e8c600abff9ea62),
                headers: {},
                concurrencyLimit: 1
            });
            const provider = new (0, $4db8b20b4b2fad32$export$a785009afeee3453)({
                resource: new (0, $8dcd3cef0f1322fc$export$39a853cfb5a94a63)({
                    [(0, $732ab3392002ce26$export$85d6ffe28a084c78).SERVICE_NAME]: "retorik-framework"
                })
            });
            const processor = new (0, $e6a81b33fd165b69$export$237547059fd543f9)(exporter);
            provider.addSpanProcessor(processor);
            provider.register();
            return (0, $fb8ae6a67ef67ee0$export$2e2bcd8739ae039).trace.getTracer("retorik-framework");
        }
        return undefined;
    }, [
        enabled
    ]);
    const getCommonAttributes = ()=>{
        let tenant = "";
        if (addressData.tenant) tenant = addressData.prefix ? `${addressData.tenant} (${addressData.prefix})` : addressData.tenant;
        return {
            tenant: tenant,
            currentURL: window.location.toString()
        };
    };
    const sendErrorTrace = (error)=>{
        if (tracer) {
            const span = tracer.startSpan("Error");
            span.recordException(error);
            span.setStatus({
                code: (0, $cdb334e89d9a87a2$export$1e28dd9b5d01db83).ERROR,
                message: `${error.message}`
            });
            span.setAttributes(getCommonAttributes());
            span.end();
        }
    };
    const value = (0, $lT7pJ.useMemo)(()=>({
            enabled: enabled,
            tracer: tracer,
            sendErrorTrace: sendErrorTrace
        }), [
        enabled,
        tracer
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)($f5328b777e1b8fec$export$7b6b7bc4acb29126.Provider, {
            value: value,
            children: children
        })
    });
}










const $aa47112092dcdaca$var$ContextProvider = ({ skipLoader: skipLoader, mode: mode, viewsConfiguration: viewsConfiguration, configuration: configuration, customVoice: customVoice, addressData: addressData, agentSource: agentSource, ponyfillFactoryCredentials: ponyfillFactoryCredentials, children: children })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const supported = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.supported);
    const defaultLocale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.defaultLocale);
    const currentDeviceType = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.currentDeviceType);
    const setLocation = async (data)=>{
        const position = {
            searchForLocation: true,
            latitude: data.coords.latitude,
            longitude: data.coords.longitude
        };
        (0, $0aecf0c32f1a48e0$export$a607205d8a8f37a7)({
            latitude: position.latitude,
            longitude: position.longitude
        });
        (0, $7c69764370dcab43$export$6a52175581b4d614)({
            ...configuration,
            position: position
        });
    };
    (0, $lT7pJ.useEffect)(()=>{
        // Fetch languages and set them in store
        (0, $d0ec91114d7de49c$export$fe443f6e3680433)(addressData);
        // Set base address
        (0, $7c69764370dcab43$export$f70ece17ecf700a3)(`${addressData.baseURI && addressData.baseURI.length > 0 ? (0, $e837502f2e0b0685$export$2e2bcd8739ae039)(addressData.baseURI) : (0, $a6ed223e0fdb911e$export$2e2bcd8739ae039)(addressData.prefix)}/${addressData.tenant ? addressData.tenant + "/" : ""}`);
        // Set continous recognition state
        (0, $b8685bd729fa723f$export$7161ba896835b3cd)(currentDeviceType, configuration?.speechRecognitionOptions);
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $7c69764370dcab43$export$d4f039427a1beff1)(mode);
    }, [
        mode
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $7c69764370dcab43$export$575f08cc5f3ecd43)(!!skipLoader);
    }, [
        skipLoader
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $1c9be018817ca3e3$export$bdf2213fff3cbdda)(viewsConfiguration);
    }, [
        viewsConfiguration,
        ...Object.values(viewsConfiguration)
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $7c69764370dcab43$export$6a52175581b4d614)(configuration);
    }, [
        configuration,
        ...Object.values(configuration)
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (configuration.position?.searchForLocation) // Position enabled
        {
            if (configuration.position.latitude === undefined && configuration.position.longitude === undefined) // Try to get the position of the device if no one has been given in the configuration
            navigator.geolocation?.getCurrentPosition(setLocation, (error)=>{
                switch(error.code){
                    case error.PERMISSION_DENIED:
                        console.warn("Geolocation : User denied the request for Geolocation.");
                        break;
                    case error.POSITION_UNAVAILABLE:
                        console.warn("Geolocation : Location information is unavailable.");
                        break;
                    case error.TIMEOUT:
                        console.warn("Geolocation : The request to get user location timed out.");
                        break;
                    default:
                        console.warn("Geolocation : An unknown error occurred.");
                        break;
                }
            }, {
                timeout: 3000
            });
        }
    }, [
        configuration.position
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        configuration.position?.latitude && configuration.position.longitude && (0, $0aecf0c32f1a48e0$export$a607205d8a8f37a7)({
            latitude: configuration.position.latitude,
            longitude: configuration.position.longitude
        });
    }, [
        configuration.position?.latitude,
        configuration.position?.longitude
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (configuration.disableSound === true) {
            (0, $b8685bd729fa723f$export$a1680ba91cc9be33)(true);
            (0, $7c69764370dcab43$export$ca8db8ed18ea1d2c)(true);
        }
        if (configuration.disableSound === false) (0, $7c69764370dcab43$export$ca8db8ed18ea1d2c)(false);
    }, [
        configuration.disableSound
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $7c69764370dcab43$export$f9f752f8a699b258)(!!configuration.subtitles);
    }, [
        configuration.subtitles
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $b8685bd729fa723f$export$1311646333d3dfee)(customVoice);
    }, [
        customVoice
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $7c69764370dcab43$export$8a3fb5da57940bc2)(addressData);
    }, [
        addressData
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $7c69764370dcab43$export$a72b80ff363563a1)(agentSource);
    }, [
        agentSource
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        (0, $b8685bd729fa723f$export$3a8619c6095469fa)(ponyfillFactoryCredentials);
    }, [
        ponyfillFactoryCredentials
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (supported.length) (0, $d0ec91114d7de49c$export$c8aadf3621e41efb)((0, $276c77dad0300967$export$d64c0ac95bb7fd72)({
            all: supported,
            default: defaultLocale
        }, configuration.locales));
    }, [
        supported,
        configuration
    ]);
    return locale && supported ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $f5328b777e1b8fec$export$bb3ea6dd2428edb6), {
        enabled: !(configuration.enableTelemetry === false),
        children: children
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $aa47112092dcdaca$export$2e2bcd8739ae039 = $aa47112092dcdaca$var$ContextProvider;



const $c08cbd71abd81c74$export$6969335ea1e4e77c = (target, source)=>{
    const isObject = (obj)=>obj && typeof obj === "object";
    if (!isObject(target) || !isObject(source)) return source;
    Object.keys(source).forEach((key)=>{
        const targetValue = target[key];
        const sourceValue = source[key];
        if (targetValue || targetValue === false) {
            if (Array.isArray(targetValue) && Array.isArray(sourceValue)) source[key] = [
                ...new Set([
                    ...targetValue,
                    ...sourceValue
                ])
            ];
            else if (isObject(targetValue) && isObject(sourceValue)) source[key] = $c08cbd71abd81c74$export$6969335ea1e4e77c(targetValue, sourceValue);
            else source[key] = targetValue;
        }
    });
    return source;
};
const $c08cbd71abd81c74$var$getThemeColors = (colors)=>{
    let defaultColors = colors?.theme === "light" ? (0, $cf20bc7a6d166273$export$1196b7bf97f3d16c) : (0, $cf20bc7a6d166273$export$d80fe84b82195dbd);
    defaultColors = $c08cbd71abd81c74$export$6969335ea1e4e77c(colors, defaultColors);
    return defaultColors;
};
var $c08cbd71abd81c74$export$2e2bcd8739ae039 = $c08cbd71abd81c74$var$getThemeColors;





var $lT7pJ = parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");
var $882afee30d17764d$exports = {};
var $8e7a852ce6004328$exports = {};
"use strict";
var $8e7a852ce6004328$var$__createBinding = $8e7a852ce6004328$exports && $8e7a852ce6004328$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8e7a852ce6004328$var$__exportStar = $8e7a852ce6004328$exports && $8e7a852ce6004328$exports.__exportStar || function(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) $8e7a852ce6004328$var$__createBinding(exports, m, p);
};
Object.defineProperty($8e7a852ce6004328$exports, "__esModule", {
    value: true
});

var $imJeu = parcelRequire("imJeu");
// Note: this instantiation ensures the above import isn't
// removed on compile. The import being absent causes an error on running
new $imJeu.AgentConfig();

// Speech SDK API
$8e7a852ce6004328$var$__exportStar((parcelRequire("hVlip")), $8e7a852ce6004328$exports);


var $867264cb841f92f8$exports = {};

$parcel$defineInteropFlag($867264cb841f92f8$exports);

$parcel$export($867264cb841f92f8$exports, "default", () => $867264cb841f92f8$export$2e2bcd8739ae039);
var $dfab27a22279c8b6$exports = {};

$dfab27a22279c8b6$exports = (parcelRequire("lQpuE"));


// ../p-defer/index.js
function $867264cb841f92f8$var$pDefer() {
    var deferred = {};
    deferred.promise = new (0, (/*@__PURE__*/$parcel$interopDefault($dfab27a22279c8b6$exports)))(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}
// src/index.mjs
var $867264cb841f92f8$export$2e2bcd8739ae039 = $867264cb841f92f8$var$pDefer;


function $882afee30d17764d$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, "__esModule", {
        value: true,
        configurable: true
    });
}
function $882afee30d17764d$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $882afee30d17764d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$882afee30d17764d$var$$parcel$defineInteropFlag($882afee30d17764d$exports);
$882afee30d17764d$var$$parcel$export($882afee30d17764d$exports, "default", ()=>$882afee30d17764d$var$$882b6d93070905b3$export$2e2bcd8739ae039);
$882afee30d17764d$var$$parcel$export($882afee30d17764d$exports, "createSpeechRecognitionPonyfill", ()=>$882afee30d17764d$var$$87729c1c3277125d$export$7c06391dbd8298b0);
$882afee30d17764d$var$$parcel$export($882afee30d17764d$exports, "createSpeechSynthesisPonyfill", ()=>$882afee30d17764d$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c);
$882afee30d17764d$var$$parcel$export($882afee30d17764d$exports, "fetchAuthorizationToken", ()=>$882afee30d17764d$var$$3e54160c801e3614$export$2e2bcd8739ae039);
$882afee30d17764d$var$$parcel$export($882afee30d17764d$exports, "SpeechSynthesisUtterance", ()=>$882afee30d17764d$var$$fd1e2557ea351c52$export$2e2bcd8739ae039);
$882afee30d17764d$var$$parcel$export($882afee30d17764d$exports, "SpeechSynthesis", ()=>$882afee30d17764d$var$$0adf7fcdea541e7b$export$1268b12b5ca510be);
$882afee30d17764d$var$$parcel$export($882afee30d17764d$exports, "SpeechGrammarList", ()=>$882afee30d17764d$var$$c213b3979e1323e8$export$2e2bcd8739ae039);
/* eslint class-methods-use-this: "off" */ /* eslint complexity: ["error", 70] */ /* eslint no-await-in-loop: "off" */ /* eslint no-empty-function: "off" */ /* eslint no-magic-numbers: ["error", { "ignore": [0, 100, 150] }] */ function $882afee30d17764d$var$$e3680afa520905a3$export$2e2bcd8739ae039(array, extras) {
    const map = {
        // @ts-ignore
        ...[].reduce.call(array, (map, value, index)=>{
            // @ts-ignore
            map[index] = value;
            return map;
        }, {}),
        ...extras,
        length: array.length,
        [Symbol.iterator]: ()=>[].slice.call(map)[Symbol.iterator]()
    };
    return map;
}
var $882afee30d17764d$var$$409c56140c6d134e$export$2e2bcd8739ae039 = {
    AudioConfig: $8e7a852ce6004328$exports.AudioConfig,
    OutputFormat: $8e7a852ce6004328$exports.OutputFormat,
    ResultReason: $8e7a852ce6004328$exports.ResultReason,
    SpeechConfig: $8e7a852ce6004328$exports.SpeechConfig,
    SpeechRecognizer: $8e7a852ce6004328$exports.SpeechRecognizer,
    SpeechSynthesizer: $8e7a852ce6004328$exports.SpeechSynthesizer
};
const { ResultReason: { RecognizingSpeech: $882afee30d17764d$var$$4e800713d8cfc243$var$RecognizingSpeech, RecognizedSpeech: $882afee30d17764d$var$$4e800713d8cfc243$var$RecognizedSpeech } } = $882afee30d17764d$var$$409c56140c6d134e$export$2e2bcd8739ae039;
function $882afee30d17764d$var$$4e800713d8cfc243$export$2e2bcd8739ae039(result, { maxAlternatives: maxAlternatives = Infinity, textNormalization: textNormalization = "display" } = {}) {
    if (result.reason === $882afee30d17764d$var$$4e800713d8cfc243$var$RecognizingSpeech || result.reason === $882afee30d17764d$var$$4e800713d8cfc243$var$RecognizedSpeech && !result.json.NBest) {
        const resultList = [
            {
                confidence: 0.5,
                transcript: result.text
            }
        ];
        if (result.reason === $882afee30d17764d$var$$4e800713d8cfc243$var$RecognizedSpeech) resultList.isFinal = true;
        return resultList;
    } else if (result.reason === $882afee30d17764d$var$$4e800713d8cfc243$var$RecognizedSpeech) {
        const resultList = $882afee30d17764d$var$$e3680afa520905a3$export$2e2bcd8739ae039((result.json.NBest || []).slice(0, maxAlternatives).map(({ Confidence: confidence, Display: display, ITN: itn, Lexical: lexical, MaskedITN: maskedITN })=>({
                confidence: confidence,
                transcript: textNormalization === "itn" ? itn : textNormalization === "lexical" ? lexical : textNormalization === "maskeditn" ? maskedITN : display
            })), {
            isFinal: true
        });
        return resultList;
    }
    return [];
}
function $882afee30d17764d$var$$521b485d0cd15790$export$2e2bcd8739ae039() {
    let shiftDeferred;
    const queue = [];
    const push = (value)=>{
        if (shiftDeferred) {
            const { resolve: resolve } = shiftDeferred;
            shiftDeferred = null;
            resolve(value);
        } else queue.push(value);
    };
    const shift = ()=>{
        if (queue.length) return Promise.resolve(queue.shift());
        return (shiftDeferred || (shiftDeferred = $882afee30d17764d$var$$parcel$interopDefault($867264cb841f92f8$exports)())).promise;
    };
    return {
        push: push,
        shift: shift
    };
}
function $882afee30d17764d$var$$e2af95d6aca72d87$export$2e2bcd8739ae039(fnOrValue) {
    return typeof fnOrValue === "function" ? fnOrValue() : fnOrValue;
}
let $882afee30d17764d$var$$cec424af042710dc$var$shouldWarnOnSubscriptionKey = true;
function $882afee30d17764d$var$$cec424af042710dc$export$2e2bcd8739ae039({ credentials: credentials, looseEvents: looseEvents, ...otherOptions }) {
    if (!credentials) throw new Error("web-speech-cognitive-services: Credentials must be specified.");
    return {
        ...otherOptions,
        fetchCredentials: async ()=>{
            const { authorizationToken: authorizationToken, customVoiceHostname: customVoiceHostname, region: region, speechRecognitionHostname: speechRecognitionHostname, speechSynthesisHostname: speechSynthesisHostname, subscriptionKey: subscriptionKey } = await $882afee30d17764d$var$$e2af95d6aca72d87$export$2e2bcd8739ae039(credentials);
            if (!authorizationToken && !subscriptionKey || authorizationToken && subscriptionKey) throw new Error('web-speech-cognitive-services: Either "authorizationToken" or "subscriptionKey" must be provided.');
            else if (!region && !(speechRecognitionHostname && speechSynthesisHostname)) throw new Error('web-speech-cognitive-services: Either "region" or "speechRecognitionHostname" and "speechSynthesisHostname" must be set.');
            else if (region && (customVoiceHostname || speechRecognitionHostname || speechSynthesisHostname)) throw new Error('web-speech-cognitive-services: Only either "region" or "customVoiceHostname", "speechRecognitionHostname" and "speechSynthesisHostname" can be set.');
            else if (authorizationToken) {
                if (typeof authorizationToken !== "string") throw new Error('web-speech-cognitive-services: "authorizationToken" must be a string.');
            } else if (typeof subscriptionKey !== "string") throw new Error('web-speech-cognitive-services: "subscriptionKey" must be a string.');
            if ($882afee30d17764d$var$$cec424af042710dc$var$shouldWarnOnSubscriptionKey && subscriptionKey) {
                console.warn("web-speech-cognitive-services: In production environment, subscription key should not be used, authorization token should be used instead.");
                $882afee30d17764d$var$$cec424af042710dc$var$shouldWarnOnSubscriptionKey = false;
            }
            const resolvedCredentials = {
                region: region,
                authorizationToken: authorizationToken,
                subscriptionKey: subscriptionKey,
                customVoiceHostname: customVoiceHostname,
                speechRecognitionHostname: speechRecognitionHostname,
                speechSynthesisHostname: speechSynthesisHostname
            };
            return resolvedCredentials;
        },
        looseEvents: looseEvents
    };
}
/* eslint class-methods-use-this: "off" */ class $882afee30d17764d$var$$c213b3979e1323e8$export$2e2bcd8739ae039 {
    addFromString() {
        throw new Error("JSGF is not supported");
    }
    get phrases() {
        return this._phrases;
    }
    set phrases(value) {
        if (Array.isArray(value)) this._phrases = value;
        else if (typeof value === "string") this._phrases = [
            value
        ];
        else throw new Error(`The provided value is not an array or of type 'string'`);
    }
    constructor(){
        this._phrases = [];
    }
}
// https://docs.microsoft.com/en-us/javascript/api/microsoft-cognitiveservices-speech-sdk/speechconfig?view=azure-node-latest#outputformat
// {
//   "RecognitionStatus": "Success",
//   "Offset": 900000,
//   "Duration": 49000000,
//   "NBest": [
//     {
//       "Confidence": 0.738919,
//       "Lexical": "second",
//       "ITN": "second",
//       "MaskedITN": "second",
//       "Display": "Second."
//     }
//   ]
// }
// {
//   "RecognitionStatus": "InitialSilenceTimeout",
//   "Offset": 50000000,
//   "Duration": 0
// }
// const { AudioConfig, OutputFormat, ResultReason, SpeechConfig, SpeechRecognizer } = SDK;
function $882afee30d17764d$var$$87729c1c3277125d$var$serializeRecognitionResult({ duration: duration, errorDetails: errorDetails, json: json, offset: offset, properties: properties, reason: reason, resultId: resultId, text: text }) {
    return {
        duration: duration,
        errorDetails: errorDetails,
        json: JSON.parse(json),
        offset: offset,
        properties: properties,
        reason: reason,
        resultId: resultId,
        text: text
    };
}
function $882afee30d17764d$var$$87729c1c3277125d$var$averageAmplitude(arrayBuffer) {
    const array = new Int16Array(arrayBuffer);
    return array.reduce((averageAmplitude, amplitude)=>averageAmplitude + Math.abs(amplitude), 0) / array.length;
}
function $882afee30d17764d$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(fn) {
    return (...args)=>new Promise((resolve, reject)=>fn(...args, resolve, reject));
}
function $882afee30d17764d$var$$87729c1c3277125d$var$prepareAudioConfig(audioConfig) {
    const originalAttach = audioConfig.attach;
    const boundOriginalAttach = audioConfig.attach.bind(audioConfig);
    let firstChunk = false;
    let muted = false;
    // We modify "attach" function and detect when audible chunk is read.
    // We will only modify "attach" function once.
    audioConfig.attach = async ()=>{
        const reader = await boundOriginalAttach();
        return {
            ...reader,
            read: async ()=>{
                const chunk = await reader.read();
                // The magic number 150 is measured by:
                // 1. Set microphone volume to 0
                // 2. Observe the amplitude (100-110) for the first few chunks
                //    (There is a short static caught when turning on the microphone)
                // 3. Set the number a bit higher than the observation
                if (!firstChunk && $882afee30d17764d$var$$87729c1c3277125d$var$averageAmplitude(chunk.buffer) > 150) {
                    audioConfig.events.onEvent({
                        name: "FirstAudibleChunk"
                    });
                    firstChunk = true;
                }
                if (muted) return {
                    buffer: new ArrayBuffer(0),
                    isEnd: true,
                    timeReceived: Date.now()
                };
                return chunk;
            }
        };
    };
    return {
        audioConfig: audioConfig,
        pause: ()=>{
            muted = true;
        },
        unprepare: ()=>{
            audioConfig.attach = originalAttach;
        }
    };
}
class $882afee30d17764d$var$$87729c1c3277125d$export$7a5e8c1807e6b8ee {
    constructor(options, data){
        this.audioConfig = null;
        this.speechConfig = null;
        this.recognizer = null;
        this.enableTelemetry = true;
        this.looseEvents = false;
        this.textNormalization = "display";
        this.started = false;
        this._autoStart = false;
        this._passive = false;
        this._continuous = false;
        this._interimResults = true;
        this._grammars = new $882afee30d17764d$var$$c213b3979e1323e8$export$2e2bcd8739ae039();
        this._maxAlternatives = 1;
        this._debug = false;
        this.onstart = ()=>{};
        this.onend = ()=>{};
        this.onpassivestart = ()=>{};
        this.onpassiveend = ()=>{};
        this.onaudiostart = ()=>{};
        this.onaudioend = ()=>{};
        this.onsoundstart = ()=>{};
        this.onsoundend = ()=>{};
        this.onspeechstart = ()=>{};
        this.onspeechend = ()=>{};
        this.onerror = (value)=>{
            console.log("Error : ", value);
        };
        this.onabort = ()=>{
            this._debug && console.log("Recognition aborted");
        };
        this.onresult = (value)=>{
            this._debug && console.log("Result : ", value);
        };
        this.onpassiveresult = (value)=>{
            this._debug && console.log("Passive Result : ", value);
        };
        this.onwakeup = ()=>{
            this._debug && console.log("Wake up !");
        };
        this.start = ()=>{
            this._startOnce().catch((err)=>{
                new Error(`error : ${err.message}\ncallstack : ${err.stack}`);
            });
        };
        this.abort = undefined;
        this.stop = undefined;
        /**
   * Retrieval of credentials, initialization of speechConfig and start recognizing
   * @param fetchCredentials Function
   * @param speechRecognitionEndpointId string | undefined
   */ this.initRecognizer = async (fetchCredentials, speechRecognitionEndpointId, timerBeforeSpeechEnd)=>{
            const { authorizationToken: authorizationToken, region: region = "westus", speechRecognitionHostname: speechRecognitionHostname, subscriptionKey: subscriptionKey } = await fetchCredentials();
            if (speechRecognitionHostname) {
                if (authorizationToken) {
                    this.speechConfig = $8e7a852ce6004328$exports.SpeechConfig.fromHost(new URL(`wss://${speechRecognitionHostname}`));
                    this.speechConfig.authorizationToken = authorizationToken;
                } else this.speechConfig = $8e7a852ce6004328$exports.SpeechConfig.fromHost(new URL(`wss://${speechRecognitionHostname}`), subscriptionKey);
            } else if (region && (authorizationToken || subscriptionKey)) this.speechConfig = authorizationToken ? $8e7a852ce6004328$exports.SpeechConfig.fromAuthorizationToken(authorizationToken, region) : subscriptionKey ? $8e7a852ce6004328$exports.SpeechConfig.fromSubscription(subscriptionKey, region) : null;
            if (this.speechConfig) {
                if (speechRecognitionEndpointId && this.speechConfig) this.speechConfig.endpointId = speechRecognitionEndpointId;
                this.speechConfig.outputFormat = $8e7a852ce6004328$exports.OutputFormat.Detailed;
                this.speechConfig.speechRecognitionLanguage = this._lang || "en-US";
                timerBeforeSpeechEnd && this.speechConfig.setProperty($8e7a852ce6004328$exports.PropertyId[$8e7a852ce6004328$exports.PropertyId.Speech_SegmentationSilenceTimeoutMs], `${timerBeforeSpeechEnd}`);
                this._autoStart && this.start();
            }
        };
        /**
   * Create a new Synthesizer from audioConfig / speechConfig / lang
   * @param lang string
   */ this.createRecognizer = async ()=>{
            if (this.audioConfig && this.speechConfig) {
                this.speechConfig.speechRecognitionLanguage = this._lang;
                this.recognizer = new $8e7a852ce6004328$exports.SpeechRecognizer(this.speechConfig, this.audioConfig);
                // Add grammars
                const { dynamicGrammar: dynamicGrammar } = this.recognizer.internalData;
                this.referenceGrammars && this.referenceGrammars.length && dynamicGrammar.addReferenceGrammar(this.referenceGrammars);
                // Add phrases
                const { phrases: phrases } = this._grammars;
                if (phrases && phrases.length) {
                    const phraseList = $8e7a852ce6004328$exports.PhraseListGrammar.fromRecognizer(this.recognizer);
                    phrases.forEach((phrase)=>{
                        phraseList.addPhrase(phrase);
                    });
                }
            } else this.recognizer = null;
        };
        /**
   * Stop current recognizer, change language and start a new recognition
   * @param lang string
   */ this.changeLanguage = async (lang)=>{
            if (this.recognizer && this.audioConfig && this.speechConfig && lang && lang !== this._lang) {
                // Stop current recognition and start a new one
                await $882afee30d17764d$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                this._lang = lang;
                this._continuous && this.start();
            } else this.recognizer = null;
        };
        /**
   * In continuous mode, toggle from passive to active mode by stopping current recognition and starting a new one to prevent
   * receiving results from a current passive speech recognition.
   * If you don't care about having existing results in active recognition, just set recognition's 'passive' variable to 'false' instead
   * of using this method.
   */ this.toggleContinuousPassiveToActive = async ()=>{
            if (this._continuous && this.recognizer && this.audioConfig && this.speechConfig) {
                // Stop current recognition and start a new one
                if (this.started) await $882afee30d17764d$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                this._continuous = false;
                this._passive = false;
                this.start();
            }
        };
        /**
   * In continuous mode, toggle from passive to active mode by stopping current recognition and starting a new one to prevent
   * receiving results from a current passive speech recognition.
   * If you don't care about having existing results in active recognition, just set recognition's 'passive' variable to 'false' instead
   * of using this method.
   */ this.toggleContinuousActiveToPassive = async ()=>{
            if (!this._continuous && this.recognizer && this.audioConfig && this.speechConfig) {
                // Stop current recognition and start a new one
                if (this.started) await $882afee30d17764d$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                this._continuous = true;
                this._passive = true;
                this.start();
            }
        };
        this.processSendEvent = (type, data)=>{
            this._debug && console.log("Speech Recognizer Event : type = ", type, "\n, data = ", data);
            switch(type){
                case "start":
                    if (this._passive) this.onpassivestart && this.onpassivestart();
                    else this.onstart && this.onstart();
                    this.started = true;
                    break;
                case "end":
                    if (this._passive) this.onpassiveend && this.onpassiveend();
                    else this.onend && this.onend();
                    this.started = false;
                    break;
                case "audiostart":
                    this.onaudiostart && this.onaudiostart();
                    break;
                case "audioend":
                    this.onaudioend && this.onaudioend();
                    break;
                case "soundstart":
                    this.onsoundstart && this.onsoundstart();
                    break;
                case "soundend":
                    this.onsoundend && this.onsoundend();
                    break;
                case "speechstart":
                    this.onspeechstart && this.onspeechstart();
                    break;
                case "speechend":
                    this.onspeechend && this.onspeechend();
                    break;
                case "error":
                    this.onerror && this.onerror(data);
                    this.started = false;
                    break;
                case "abort":
                    this.onabort && this.onabort();
                    this.started = false;
                    break;
                case "result":
                    this.onresult && this.onresult(data.results);
                    break;
                case "passiveresult":
                    this.onpassiveresult && this.onpassiveresult(data.results);
                    break;
                case "wakeup":
                    this.onwakeup && this.onwakeup();
                    break;
            }
        };
        this._autoStart = !!data?.autoStart;
        this._passive = !!data?.passive;
        this._wakeWords = data?.wakeWords || [];
        this._continuous = !!data?.continuous;
        this._interimResults = !(data?.interimResults === false);
        this._lang = data?.lang ? data.lang : typeof window !== "undefined" ? window.document.documentElement.getAttribute("lang") || window.navigator.language : "en-US";
        data?.grammarsList && (this._grammars.phrases = data.grammarsList);
        this._debug = !!data?.debug || false;
        const { audioConfig: audioConfig = null, enableTelemetry: // https://github.com/Microsoft/cognitive-services-speech-sdk-js#data--telemetry
        enableTelemetry = true, fetchCredentials: fetchCredentials, looseEvents: looseEvents, referenceGrammars: referenceGrammars, speechRecognitionEndpointId: speechRecognitionEndpointId, textNormalization: textNormalization = "display" } = $882afee30d17764d$var$$cec424af042710dc$export$2e2bcd8739ae039(options);
        this.enableTelemetry = enableTelemetry;
        this.looseEvents = !!looseEvents;
        this.referenceGrammars = referenceGrammars;
        this.textNormalization = textNormalization;
        if (!audioConfig && (!window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia)) console.warn("web-speech-cognitive-services: This browser does not support WebRTC and it will not work with Cognitive Services Speech Services.");
        else try {
            this.audioConfig = audioConfig || $8e7a852ce6004328$exports.AudioConfig.fromDefaultMicrophoneInput();
            this.initRecognizer(fetchCredentials, speechRecognitionEndpointId, data?.timerBeforeSpeechEnd);
        } catch (e) {
            console.warn(e);
        }
    }
    get passive() {
        return this._passive;
    }
    set passive(value) {
        this._passive = value;
    }
    get wakeWords() {
        return this._wakeWords;
    }
    set wakeWords(value) {
        this._wakeWords = value;
    }
    get continuous() {
        return this._continuous;
    }
    set continuous(value) {
        this._continuous = value;
    }
    get grammars() {
        return this._grammars;
    }
    set grammars(value) {
        if (value instanceof $882afee30d17764d$var$$c213b3979e1323e8$export$2e2bcd8739ae039) this._grammars = value;
        else throw new Error(`The provided value is not of type 'SpeechGrammarList'`);
    }
    get interimResults() {
        return this._interimResults;
    }
    set interimResults(value) {
        this._interimResults = value;
    }
    get maxAlternatives() {
        return this._maxAlternatives;
    }
    set maxAlternatives(value) {
        this._maxAlternatives = value;
    }
    get lang() {
        return this._lang;
    }
    set lang(value) {
        this._lang = value;
    }
    async _startOnce() {
        if (this.audioConfig && !this.started) {
            const { pause: pause, unprepare: unprepare } = $882afee30d17764d$var$$87729c1c3277125d$var$prepareAudioConfig(this.audioConfig);
            const queue = $882afee30d17764d$var$$521b485d0cd15790$export$2e2bcd8739ae039();
            let soundStarted = false;
            let speechStarted = false;
            let stopping = "";
            const { detach: detachAudioConfigEvent } = this.audioConfig.events.attach((event)=>{
                const { name: name } = event;
                if (name === "AudioSourceReadyEvent") queue.push({
                    audioSourceReady: {}
                });
                else if (name === "AudioSourceOffEvent") queue.push({
                    audioSourceOff: {}
                });
                else if (name === "FirstAudibleChunk") queue.push({
                    firstAudibleChunk: {}
                });
            });
            await this.createRecognizer();
            if (this.recognizer) try {
                this.recognizer.canceled = (_, { errorDetails: errorDetails, offset: offset, reason: reason, sessionId: sessionId })=>{
                    queue.push({
                        canceled: {
                            errorDetails: errorDetails,
                            offset: offset,
                            reason: reason,
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.recognized = (_, { offset: offset, result: result, sessionId: sessionId })=>{
                    queue.push({
                        recognized: {
                            offset: offset,
                            result: $882afee30d17764d$var$$87729c1c3277125d$var$serializeRecognitionResult(result),
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.recognizing = (_, { offset: offset, result: result, sessionId: sessionId })=>{
                    queue.push({
                        recognizing: {
                            offset: offset,
                            result: $882afee30d17764d$var$$87729c1c3277125d$var$serializeRecognitionResult(result),
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.sessionStarted = (_, { sessionId: sessionId })=>{
                    queue.push({
                        sessionStarted: {
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.sessionStopped = (_, { sessionId: sessionId })=>{
                    // "sessionStopped" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                    queue.push({
                        sessionStopped: {
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.speechStartDetected = (_, { offset: offset, sessionId: sessionId })=>{
                    queue.push({
                        speechStartDetected: {
                            offset: offset,
                            sessionId: sessionId
                        }
                    });
                };
                this.recognizer.speechEndDetected = (_, { sessionId: sessionId })=>{
                    // "speechEndDetected" is never fired, probably because we are using startContinuousRecognitionAsync instead of recognizeOnceAsync.
                    // Update: "speechEndDetected" is fired for DLSpeech.listenOnceAsync()
                    queue.push({
                        speechEndDetected: {
                            sessionId: sessionId
                        }
                    });
                };
                await $882afee30d17764d$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.startContinuousRecognitionAsync.bind(this.recognizer))();
                this.abort = ()=>queue.push({
                        abort: {}
                    });
                this.stop = ()=>queue.push({
                        stop: {}
                    });
                let audioStarted = false;
                let finalEvent = null;
                let finalizedResults = [];
                for(let loop = 0; !stopping || audioStarted; loop++){
                    const event = await queue.shift();
                    const { abort: abort, audioSourceOff: audioSourceOff, audioSourceReady: audioSourceReady, canceled: canceled, firstAudibleChunk: firstAudibleChunk, recognized: recognized, recognizing: recognizing, stop: stop } = event;
                    const errorMessage = canceled && canceled.errorDetails;
                    if (/Permission\sdenied/u.test(errorMessage || "")) {
                        // If microphone is not allowed, we should not emit "start" event.
                        finalEvent = {
                            data: "not-allowed",
                            type: "error"
                        };
                        break;
                    }
                    if (!loop) this.processSendEvent("start");
                    if (errorMessage) {
                        if (/1006/u.test(errorMessage)) {
                            if (!audioStarted) {
                                this.processSendEvent("audiostart");
                                this.processSendEvent("audioend");
                            }
                            finalEvent = {
                                data: "network",
                                type: "error"
                            };
                        } else finalEvent = {
                            data: "unknown",
                            type: "error"
                        };
                        break;
                    } else if (abort || stop) {
                        if (abort) {
                            finalEvent = {
                                type: "abort"
                            };
                            // If we are aborting, we will ignore lingering recognizing/recognized events. But if we are stopping, we need them.
                            stopping = "abort";
                        } else {
                            // When we pause, we will send { isEnd: true }, Speech Services will send us "recognized" event.
                            pause();
                            stopping = "stop";
                        }
                        // Abort should not be dispatched without support of "stopContinuousRecognitionAsync".
                        // But for defensive purpose, we make sure "stopContinuousRecognitionAsync" is available before we can call.
                        if (abort && this.recognizer.stopContinuousRecognitionAsync) await $882afee30d17764d$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                    } else if (audioSourceReady) {
                        this.processSendEvent("audiostart");
                        audioStarted = true;
                    } else if (firstAudibleChunk) {
                        this.processSendEvent("soundstart");
                        soundStarted = true;
                    } else if (audioSourceOff) {
                        // Looks like we don't need this line and all the tests are still working.
                        // Guessing probably stopping is already truthy.
                        // stopping = true;
                        speechStarted && this.processSendEvent("speechend");
                        soundStarted && this.processSendEvent("soundend");
                        audioStarted && this.processSendEvent("audioend");
                        audioStarted = soundStarted = speechStarted = false;
                        break;
                    } else if (stopping !== "abort") {
                        if (recognized && recognized.result && recognized.result.reason === $8e7a852ce6004328$exports.ResultReason.NoMatch) finalEvent = {
                            data: "no-speech",
                            type: "error"
                        };
                        else if (recognized || recognizing) {
                            if (!audioStarted) {
                                // Unconfirmed prevention of quirks
                                this.processSendEvent("audiostart");
                                audioStarted = true;
                            }
                            if (!soundStarted) {
                                this.processSendEvent("soundstart");
                                soundStarted = true;
                            }
                            if (!speechStarted) {
                                this.processSendEvent("speechstart");
                                speechStarted = true;
                            }
                            if (recognized) {
                                const result = $882afee30d17764d$var$$4e800713d8cfc243$export$2e2bcd8739ae039(recognized.result, {
                                    maxAlternatives: this.maxAlternatives,
                                    textNormalization: this.textNormalization
                                });
                                const recognizable = !!result[0].transcript;
                                if (recognizable) {
                                    finalizedResults = [
                                        ...finalizedResults,
                                        ...result
                                    ];
                                    if (this._interimResults) {
                                        this.processSendEvent("result", {
                                            results: finalizedResults
                                        });
                                        this._passive && this.processSendEvent("passiveresult", {
                                            results: result
                                        });
                                    }
                                }
                                // If it is continuous, we just sent the finalized results. So we don't need to send it again after "audioend" event.
                                if (this._continuous && recognizable) finalEvent = null;
                                else this._interimResults && (finalEvent = {
                                    data: {
                                        results: finalizedResults
                                    },
                                    type: "result"
                                });
                                if (!this._continuous && this.recognizer.stopContinuousRecognitionAsync) await $882afee30d17764d$var$$87729c1c3277125d$var$cognitiveServicesAsyncToPromise(this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer))();
                                // If event order can be loosened, we can send the recognized event as soon as we receive it.
                                // 1. If it is not recognizable (no-speech), we should send an "error" event just before "end" event. We will not loosen "error" events.
                                if (this.looseEvents && finalEvent && recognizable) {
                                    this.processSendEvent(finalEvent.type, finalEvent.data);
                                    finalEvent = null;
                                }
                            } else if (recognizing) {
                                const result = $882afee30d17764d$var$$4e800713d8cfc243$export$2e2bcd8739ae039(recognizing.result, {
                                    maxAlternatives: this.maxAlternatives,
                                    textNormalization: this.textNormalization
                                });
                                if (this._passive && this._wakeWords && this._wakeWords.length > 0) {
                                    // Test wake words if some are present
                                    if (result && Array.isArray(result) && result.length > 0 && result[0].transcript) {
                                        const { transcript: transcript } = {
                                            ...result[0]
                                        };
                                        this._wakeWords.forEach((wakeWord)=>{
                                            if (transcript.toLowerCase().includes(wakeWord.toLowerCase())) this.processSendEvent("wakeup");
                                        });
                                    }
                                    this._interimResults && this.processSendEvent("passiveresult", {
                                        results: result
                                    });
                                }
                                this._interimResults && this.processSendEvent("result", {
                                    results: [
                                        ...finalizedResults,
                                        ...result
                                    ]
                                });
                            }
                        }
                    }
                }
                speechStarted && this.processSendEvent("speechend");
                soundStarted && this.processSendEvent("soundend");
                audioStarted && this.processSendEvent("audioend");
                if (finalEvent) {
                    if (finalEvent.type === "result" && (typeof finalEvent.data === "string" || !finalEvent.data?.results || !finalEvent.data.results.length)) finalEvent = {
                        data: "no-speech",
                        type: "error"
                    };
                    this.processSendEvent(finalEvent.type, finalEvent.data);
                }
                // Even though there is no "start" event emitted, we will still emit "end" event
                // This is mainly for "microphone blocked" story.
                this.processSendEvent("end");
                detachAudioConfigEvent && detachAudioConfigEvent();
            } catch (err) {
                // Logging out the erorr because Speech SDK would fail silently.
                console.error(err);
                throw err;
            } finally{
                unprepare();
                this.recognizer.close();
            }
        }
    }
}
const $882afee30d17764d$var$$87729c1c3277125d$export$7c06391dbd8298b0 = (options, data)=>{
    return {
        speechRecognition: new $882afee30d17764d$var$$87729c1c3277125d$export$7a5e8c1807e6b8ee(options, data),
        SpeechGrammarList: $882afee30d17764d$var$$c213b3979e1323e8$export$2e2bcd8739ae039
    };
};
var $882afee30d17764d$var$$87729c1c3277125d$export$2e2bcd8739ae039 = $882afee30d17764d$var$$87729c1c3277125d$export$7c06391dbd8298b0;
/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */ class $882afee30d17764d$var$$fd1e2557ea351c52$var$SpeechSynthesisUtterance extends EventTarget {
    constructor(text){
        super();
        this._lang = undefined;
        this._pitch = 1;
        this._rate = 1;
        this._voice = undefined;
        this._volume = 1;
        this.text = text;
    }
    get lang() {
        return this._lang;
    }
    set lang(value) {
        this._lang = value;
    }
    get pitch() {
        return this._pitch;
    }
    set pitch(value) {
        this._pitch = value;
    }
    get rate() {
        return this._rate;
    }
    set rate(value) {
        this._rate = value;
    }
    get voice() {
        return this._voice;
    }
    set voice(value) {
        this._voice = value;
    }
    get volume() {
        return this._volume;
    }
    set volume(value) {
        this._volume = value;
    }
    onstart() {}
    onend() {}
    onerror(error) {
        console.log(error);
    }
    onsynthesisstart() {}
    onsynthesiscompleted() {}
    onboundary(data) {
        console.log(data);
    }
    onviseme(data) {
        console.log(data);
    }
    onmark(data) {
        console.log(data);
    }
}
var $882afee30d17764d$var$$fd1e2557ea351c52$export$2e2bcd8739ae039 = $882afee30d17764d$var$$fd1e2557ea351c52$var$SpeechSynthesisUtterance;
class $882afee30d17764d$var$$fd058ea71144ee3c$export$2e2bcd8739ae039 {
    constructor({ gender: gender, lang: lang, voiceURI: voiceURI }){
        this._default = false;
        this._localService = false;
        this._gender = gender;
        this._lang = lang;
        this._name = voiceURI;
        this._voiceURI = voiceURI;
    }
    get default() {
        return this._default;
    }
    get gender() {
        return this._gender;
    }
    get lang() {
        return this._lang;
    }
    get localService() {
        return this._localService;
    }
    get name() {
        return this._name;
    }
    get voiceURI() {
        return this._voiceURI;
    }
}
class $882afee30d17764d$var$$0adf7fcdea541e7b$export$1268b12b5ca510be {
    constructor(options){
        this.speaking = false;
        this.speakerAudioDestination = new $8e7a852ce6004328$exports.SpeakerAudioDestination();
        this.audioConfig = undefined;
        this.speechConfig = null;
        this.queue = [];
        this.canceled = false;
        this.synth = null;
        this.synthesizing = false;
        // Function that returns an empty array of available voices
        this.getVoices = ()=>{
            return [];
        };
        this.onvoiceschanged = ()=>{
            console.log("Voices changed");
        };
        // Extract parameters from options using the patchOptions function
        const { audioContext: audioContext, fetchCredentials: fetchCredentials, ponyfill: ponyfill = {
            // @ts-ignore
            AudioContext: window.AudioContext || window.webkitAudioContext
        }, speechSynthesisDeploymentId: speechSynthesisDeploymentId } = $882afee30d17764d$var$$cec424af042710dc$export$2e2bcd8739ae039(options);
        // Check if the browser supports the Web Audio API, if not, return an empty object
        if (!audioContext && !ponyfill.AudioContext) console.warn("web-speech-cognitive-services: This browser does not support Web Audio and it will not work with Cognitive Services Speech Services.");
        else {
            this.audioConfig = $8e7a852ce6004328$exports.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination);
            // Init synthesizer
            this.initSpeechSynthesizer(fetchCredentials, speechSynthesisDeploymentId);
        }
    }
    mute() {
        this.speakerAudioDestination && this.speakerAudioDestination.mute();
    }
    unmute() {
        this.speakerAudioDestination && this.speakerAudioDestination.unmute();
    }
    getVolume() {
        // eslint-disable-next-line no-magic-numbers
        return this.speakerAudioDestination ? this.speakerAudioDestination.volume : -1;
    }
    setVolume(value) {
        this.speakerAudioDestination && (this.speakerAudioDestination.volume = value);
    }
    // Asynchronous function that initializes the speech synthesizer class
    async initSpeechSynthesizer(fetchCredentials, speechSynthesisDeploymentId) {
        const { speechSynthesisHostname: speechSynthesisHostname, subscriptionKey: subscriptionKey, authorizationToken: authorizationToken, region: region } = await fetchCredentials();
        if (!authorizationToken && !subscriptionKey) throw new Error("no subscription data : authorizationToken or subscriptionKey needed");
        // Configure the synthesizer and audio
        if (speechSynthesisDeploymentId) {
            const hostname = speechSynthesisHostname || `${region}.customvoice.api.speech.microsoft.com`;
            const url = `https://${encodeURI(hostname)}/api/texttospeech/v2.0/endpoints/${encodeURIComponent(speechSynthesisDeploymentId)}`;
            this.speechConfig = $8e7a852ce6004328$exports.SpeechConfig.fromEndpoint(new URL(url), subscriptionKey);
        } else if (speechSynthesisHostname) this.speechConfig = $8e7a852ce6004328$exports.SpeechConfig.fromHost(speechSynthesisHostname, subscriptionKey);
        else this.speechConfig = authorizationToken ? $8e7a852ce6004328$exports.SpeechConfig.fromAuthorizationToken(authorizationToken, region) : $8e7a852ce6004328$exports.SpeechConfig.fromSubscription(subscriptionKey, region);
        this.synth = new $8e7a852ce6004328$exports.SpeechSynthesizer(this.speechConfig, this.audioConfig);
        // Update available voices
        this.updateVoices();
    }
    // Function to recreate the synthesizer
    createSynthesizer(voice, stream) {
        if (stream) this.audioConfig = $8e7a852ce6004328$exports.AudioConfig.fromStreamOutput(stream);
        else {
            this.speakerAudioDestination = new $8e7a852ce6004328$exports.SpeakerAudioDestination();
            this.audioConfig = $8e7a852ce6004328$exports.AudioConfig.fromSpeakerOutput(this.speakerAudioDestination);
        }
        if (this.speechConfig) {
            if (voice) {
                const tempSpeechConfig = this.speechConfig;
                tempSpeechConfig.speechSynthesisVoiceName = voice;
                this.synth = new $8e7a852ce6004328$exports.SpeechSynthesizer(tempSpeechConfig, this.audioConfig);
            } else this.synth = new $8e7a852ce6004328$exports.SpeechSynthesizer(this.speechConfig, this.audioConfig);
        }
    }
    // Cancel current synthesis
    cancel() {
        if (this.synthesizing) try {
            // @ts-ignore
            this.synth && !this.synth.privDisposed && this.synth.close();
            this.queue = [];
        } catch (e) {
            console.warn(e);
        }
        else if (this.speaking) try {
            this.speakerAudioDestination.pause();
            this.speakerAudioDestination.onAudioEnd(this.speakerAudioDestination);
            this.speakerAudioDestination.close();
        } catch (e) {
            console.warn(e);
        }
        this.queue = [];
        this.canceled = true;
    }
    // Pause current synthesis
    pause() {
        if (this.speakerAudioDestination) this.speakerAudioDestination.pause();
    }
    // Resume current synthesis
    resume() {
        if (this.speakerAudioDestination && !this.canceled) this.speakerAudioDestination.resume();
    }
    /**
   * Add events listeners to the events received by the synthesizer if callbakcs are given in the utterance
   * @param {SpeechSynthesisUtterance} utterance
   */ linkEventsCallbacks(utterance) {
        if (this.synth) {
            // Events callbacks
            this.synth.synthesisStarted = ()=>{
                utterance.onsynthesisstart && utterance.onsynthesisstart();
                this.synthesizing = true;
            };
            this.synth.synthesisCompleted = ()=>{
                utterance.onsynthesiscompleted && utterance.onsynthesiscompleted();
                this.synthesizing = false;
            };
            this.synth.wordBoundary = (synth, e)=>{
                !synth && console.warn("No synthesizer");
                const data = {
                    boundaryType: e.boundaryType,
                    name: e.text,
                    elapsedTime: e.audioOffset,
                    duration: e.duration
                };
                utterance.onboundary && utterance.onboundary(data);
            };
            this.synth.visemeReceived = (synth, e)=>{
                !synth && console.warn("No synthesizer");
                const data = {
                    boundaryType: "Viseme",
                    name: `${e.visemeId}`,
                    elapsedTime: e.audioOffset,
                    duration: 0
                };
                utterance.onboundary && utterance.onboundary(data);
                utterance.onviseme && utterance.onviseme(data);
            };
            this.synth.bookmarkReached = (synth, e)=>{
                !synth && console.warn("No synthesizer");
                const data = {
                    boundaryType: "Mark",
                    name: e.text,
                    elapsedTime: e.audioOffset,
                    duration: 0
                };
                utterance.onmark && utterance.onmark(data);
            };
        }
    }
    /**
   * Launch synthesis and play sound with the speech synthesizer
   * @param {SpeechSynthesisUtterance} utterance 
   */ speak(utterance, stream) {
        // Test utterance
        if (!(utterance instanceof $882afee30d17764d$var$$fd1e2557ea351c52$export$2e2bcd8739ae039)) throw new Error("invalid utterance");
        // Add the utterance to the queue
        this.queue.push(utterance);
        // Function to process the queued utterances
        const processQueue = ()=>{
            if (this.queue.length && !this.speaking) {
                const currentUtterance = this.queue.shift(); // Get the next utterance from the queue
                if (currentUtterance) {
                    const isSSML = /<speak[\s\S]*?>/iu.test(currentUtterance.text);
                    if (currentUtterance.voice && (currentUtterance.voice.voiceURI || currentUtterance.voice._name)) this.createSynthesizer(currentUtterance.voice.voiceURI || currentUtterance.voice._name, stream);
                    else this.createSynthesizer(undefined, stream);
                    // Set volume / mute status if present in the utterance parameters
                    currentUtterance.volume && (this.speakerAudioDestination.volume = currentUtterance.volume);
                    // SpeakerAudioDestination events callbacks
                    this.speakerAudioDestination.onAudioStart = ()=>{
                        this.speaking = true;
                        currentUtterance.onstart && currentUtterance.onstart();
                    };
                    this.speakerAudioDestination.onAudioEnd = ()=>{
                        this.speaking = false;
                        currentUtterance.onend && currentUtterance.onend();
                        processQueue(); // Process the next queued utterance after the current one has finished
                    };
                    this.linkEventsCallbacks(currentUtterance);
                    return isSSML ? new Promise((reject)=>{
                        this.synth && this.synth.speakSsmlAsync(currentUtterance.text, (result)=>{
                            if (result) this.synth && this.synth.close();
                            else reject(new Error("No synthesis result."));
                        }, (error)=>{
                            reject(new Error(`Synthesis failed : ${error}`));
                        });
                    }) : new Promise((reject)=>{
                        this.synth && this.synth.speakTextAsync(currentUtterance.text, (result)=>{
                            if (result) this.synth && this.synth.close();
                            else reject(new Error("No synthesis result."));
                        }, (error)=>{
                            reject(new Error(`Synthesis failed : ${error}`));
                        });
                    });
                }
            }
        };
        processQueue(); // Start processing the queue
        this.canceled = false; // Reset canceled state after processing the queue
    }
    /**
   * Launch synthesis without sound being played and call callback function with an ArrayBuffer after synthesis finished, containing the sound data
   * @param {SpeechSynthesisUtterance} utterance 
   * @param {Function} callback 
   */ synthesizeAndGetArrayData(utterance, callback) {
        // Test utterance
        if (!(utterance instanceof $882afee30d17764d$var$$fd1e2557ea351c52$export$2e2bcd8739ae039)) throw new Error("invalid utterance");
        const isSSML = /<speak[\s\S]*?>/iu.test(utterance.text);
        if (this.speechConfig) {
            if (utterance.voice && (utterance.voice.voiceURI || utterance.voice._name)) {
                const tempSpeechConfig = this.speechConfig;
                tempSpeechConfig.speechSynthesisVoiceName = utterance.voice.voiceURI || utterance.voice._name;
                // @ts-ignore
                this.synth = new $8e7a852ce6004328$exports.SpeechSynthesizer(tempSpeechConfig, null);
            } else this.synth = new $8e7a852ce6004328$exports.SpeechSynthesizer(this.speechConfig, null);
        }
        this.linkEventsCallbacks(utterance);
        try {
            isSSML ? this.synth && this.synth.speakSsmlAsync(utterance.text, (result)=>{
                if (result && result.audioData) {
                    callback(result.audioData);
                    this.synth && this.synth.close();
                } else callback(null);
            }, (error)=>{
                console.error(error);
                callback(null);
            }) : this.synth && this.synth.speakTextAsync(utterance.text, (result)=>{
                if (result && result.audioData) {
                    callback(result.audioData);
                    this.synth && this.synth.close();
                } else callback(null);
            }, (error)=>{
                console.error(error);
                callback(null);
            });
        } catch (error) {
            console.error(error);
        }
    }
    // Asynchronous function that updates available voices
    async updateVoices() {
        const voicesResult = this.synth ? await this.synth.getVoicesAsync() : null;
        const voices = voicesResult?.voices;
        if (Array.isArray(voices)) {
            const formattedVoices = voices.map((voice)=>new $882afee30d17764d$var$$fd058ea71144ee3c$export$2e2bcd8739ae039({
                    // eslint-disable-next-line no-magic-numbers
                    gender: voice.gender === 1 ? "Female" : voice.gender === 2 ? "Male" : "Undefined",
                    lang: voice.locale,
                    voiceURI: voice.name
                }));
            this.getVoices = ()=>formattedVoices;
        } else console.warn("Failed to retrieve voices. 'voices' is not an array.");
        // Call 'onvoiceschanged' callback to notify the voices update
        this.onvoiceschanged();
    }
}
const $882afee30d17764d$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c = (options)=>{
    return {
        speechSynthesis: new $882afee30d17764d$var$$0adf7fcdea541e7b$export$1268b12b5ca510be(options),
        SpeechSynthesisUtterance: $882afee30d17764d$var$$fd1e2557ea351c52$export$2e2bcd8739ae039
    };
};
var $882afee30d17764d$var$$0adf7fcdea541e7b$export$2e2bcd8739ae039 = $882afee30d17764d$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c;
const $882afee30d17764d$var$$3e54160c801e3614$var$TOKEN_URL_TEMPLATE = "https://{region}.api.cognitive.microsoft.com/sts/v1.0/issueToken";
async function $882afee30d17764d$var$$3e54160c801e3614$export$2e2bcd8739ae039({ region: region, subscriptionKey: subscriptionKey }) {
    if (!region || !subscriptionKey) throw new Error("Region AND subscription must be provided");
    else {
        const res = await fetch($882afee30d17764d$var$$3e54160c801e3614$var$TOKEN_URL_TEMPLATE.replace(/\{region\}/u, region), {
            headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey
            },
            method: "POST"
        });
        if (!res.ok) throw new Error(`Failed to fetch authorization token, server returned ${res.status}`);
        return res.text();
    }
}
function $882afee30d17764d$var$$882b6d93070905b3$export$2e2bcd8739ae039(options, recognitionData) {
    return {
        ...$882afee30d17764d$var$$87729c1c3277125d$export$7c06391dbd8298b0(options, recognitionData),
        ...$882afee30d17764d$var$$0adf7fcdea541e7b$export$cf962f8b61871d5c(options)
    };
}













const $7e434ab128e64d14$var$buildSSML = (activity, speechMarkdownParser, sayAsWords)=>{
    let speech = activity.speak || activity.text;
    // Replace character not recognized in Microsoft TTS
    speech = speech.replaceAll("\u2019", "'");
    if (sayAsWords && sayAsWords.length) {
        const wordsUsed = [];
        sayAsWords.forEach((tuple)=>{
            if (!wordsUsed.includes(tuple.text)) {
                const regex = new RegExp(`\\b${tuple.text}\\b`, "gi");
                speech = speech.replaceAll(regex, `(${tuple.text})[ipa:"${tuple.ipa}"]`);
                wordsUsed.push(tuple.text);
            }
        });
    }
    let textParsedAsSSML = "";
    try {
        textParsedAsSSML = speechMarkdownParser.toSSML(speech);
    } catch (e) {
        console.warn("Retorik Framework > Error in speechmarkdown parser : ", e);
    }
    return `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="https://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" xml:lang="${activity.locale}">` + textParsedAsSSML + "</speak>";
};
function $7e434ab128e64d14$export$2e2bcd8739ae039({ activity: activity, voice: voice, locale: locale, sayAsWords: sayAsWords }) {
    // If there is no text to be read, create an empty utterance that will be put in the array of ended activities
    if (!voice || !activity.speak && !activity.text) return new (0, $882afee30d17764d$exports.SpeechSynthesisUtterance)("");
    const options = {
        platform: "microsoft-azure",
        includeSpeakTag: false,
        globalVoiceAndLang: {
            voice: voice.name,
            lang: voice.name.toLowerCase().includes("multilingual") ? locale : undefined
        }
    };
    const speechMarkdownParser = new (0, $71a0241bab23e208$exports.SpeechMarkdown)(options);
    const utterance = new (0, $882afee30d17764d$exports.SpeechSynthesisUtterance)($7e434ab128e64d14$var$buildSSML(activity, speechMarkdownParser, sayAsWords));
    return utterance;
}


/* Return codes:
  0 => do nothing
  1 => add to queue
  2 => stop current activity + change to the one tested
*/ const $abb8c624d32bca8f$var$checkLastbotActivity = (lastbotActivity, currentPlaying, currentReplyToId, queuedActivities, endedActivities)=>{
    // Check if the activity is the one currently being played
    if (lastbotActivity.id === currentPlaying.id) return 0;
    // Check if the activity has already been ended
    if (endedActivities.includes(lastbotActivity.id)) return 0;
    // Check if the activity has the same replyToId than the one currently being played
    if (lastbotActivity.replyToId === currentReplyToId) {
        // Check if the activity is already in the queue
        let count = 0;
        if (queuedActivities.length > 0) queuedActivities.forEach((activity)=>{
            if (activity.id === lastbotActivity.id) count++;
        });
        if (count === 0) return 1;
        else return 0;
    } else return 2;
};
var $abb8c624d32bca8f$export$2e2bcd8739ae039 = $abb8c624d32bca8f$var$checkLastbotActivity;


const $6c74f0a8006c5c67$export$a2ce4fdd6972d6a7 = async (region, key)=>{
    const tokenRes = await fetch(`https://${region}.api.cognitive.microsoft.com/sts/v1.0/issueToken`, {
        method: "POST",
        headers: {
            "Ocp-Apim-Subscription-Key": key
        }
    }).then((value)=>{
        return value.text();
    }).catch((error)=>{
        console.log("Error : ", error);
        return undefined;
    });
    return tokenRes;
};


const $6988154d82465dcf$export$4bf371fc4fa74a28 = (voices, locale, customVoice, agentData)=>{
    let voice = null;
    // Check if a custom voice is defined in the props
    if (customVoice) {
        if (customVoice.voice) {
            // Search voice with its full name (ex: AriaNeural, GuyNeural)
            const neuralVoice = new RegExp(customVoice.voice, "iu");
            voice = voices.find(({ name: name })=>neuralVoice.test(name) || name === customVoice.voice);
        } else if (customVoice.gender) // Search voice depending on given gender and locale
        voice = voices.find(({ gender: gender, lang: lang })=>{
            return gender.toLowerCase() === customVoice?.gender?.toLowerCase() && lang === locale;
        });
    }
    // Get voice depending on locale and gender
    if (!voice) voice = voices.find(({ gender: gender, lang: lang })=>{
        return gender.toLowerCase() === (agentData?.gender?.toLowerCase() || "female") && lang === locale;
    });
    // No voice found, fall back to US default voices : female => Aria / male => Guy
    if (!voice) {
        const genderedVoice = agentData?.gender?.toLowerCase() === "female" ? "AriaNeural" : "GuyNeural";
        const neuralVoice = new RegExp(genderedVoice, "iu");
        voice = voices.find(({ name: name })=>neuralVoice.test(name));
    }
    return voice;
};




var $lT7pJ = parcelRequire("lT7pJ");





const $33c0dc36ecc68581$export$52a3c04e084af2a0 = {
    onesecond: `${(0, $bbe458fac496c294$export$eefca12493f9e9b9)}/onesecond.mp3`,
    speechrecognition: `${(0, $bbe458fac496c294$export$eefca12493f9e9b9)}/blip.mp3`
};


class $7cae176105d9556f$var$IndexedDbManager {
    version = 1;
    storeName = "speechSynthesisData";
    checkDB = async ()=>{
        return new Promise((resolve)=>{
            const request = indexedDB.open("retorik-framework-db", this.version);
            request.onsuccess = ()=>{
                resolve(true);
            };
            request.onerror = ()=>{
                resolve(false);
            };
            request.onupgradeneeded = ()=>{
                const db = request.result;
                // If the data object store doesn't exist, create it
                if (!db.objectStoreNames.contains(this.storeName)) db.createObjectStore(this.storeName, {
                    keyPath: "id"
                });
            };
        });
    };
    addSpeechData = async (data)=>{
        return new Promise((resolve)=>{
            const request = indexedDB.open("retorik-framework-db", this.version);
            request.onsuccess = ()=>{
                const db = request.result;
                const tx = db.transaction(this.storeName, "readwrite");
                const store = tx.objectStore(this.storeName);
                // Base 64 encode
                data.id = window.btoa(encodeURI(data.id));
                store.add(data);
                resolve(true);
            };
            request.onerror = ()=>{
                resolve(false);
            };
        });
    };
    getSpeechData = async (id)=>{
        return new Promise((resolve)=>{
            const request = indexedDB.open("retorik-framework-db", this.version);
            request.onsuccess = ()=>{
                const db = request.result;
                const tx = db.transaction(this.storeName, "readonly");
                const store = tx.objectStore(this.storeName);
                // Base 64 encode
                const data = store.get(window.btoa(encodeURI(id)));
                data.onsuccess = ()=>{
                    resolve(data.result);
                };
            };
            request.onerror = ()=>{
                resolve(null);
            };
        });
    };
}
var $7cae176105d9556f$export$2e2bcd8739ae039 = $7cae176105d9556f$var$IndexedDbManager;




var $lT7pJ = parcelRequire("lT7pJ");









var $lT7pJ = parcelRequire("lT7pJ");







const $4ccb968dc9474451$var$springEnterDuration = 500;
const $4ccb968dc9474451$var$springLeaveDuration = 1000;
const $4ccb968dc9474451$var$LoaderCallToAction = ({ handleValidation: handleValidation })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const loaderInformationTexts = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.loaderInformationTexts);
    const loaderInformationTextsLocalized = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.loaderInformationTextsLocalized);
    const hideRetorikLogo = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.hideRetorikLogo);
    const disabledSpeechMode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.disableSpeechMode);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const container = (0, $lT7pJ.useRef)(null);
    const [hover, setHover] = (0, $lT7pJ.useState)(false);
    const animationColor = {
        "--rf-color-loader-animation": themeColors.loader.animation
    };
    const animationTimerRef = (0, $lT7pJ.useRef)();
    const [spring, api] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $lT7pJ.useEffect)(()=>{
        api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $4ccb968dc9474451$var$springEnterDuration
            }
        });
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    const handleChange = (modeId)=>{
        const tempMode = modeId === 1 ? (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal : (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).text;
        (0, $7c69764370dcab43$export$d4f039427a1beff1)(tempMode);
    };
    const handleValidate = ()=>{
        handleValidation();
        api.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $4ccb968dc9474451$var$springLeaveDuration
            }
        });
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $dc32a48dada8397f$export$407448d2b89b1813).div, {
        className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center rf-animate-loaderFadeIn",
        ref: container,
        style: {
            ...animationColor,
            ...spring
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-h-1/2 rf-pb-6 rf-flex rf-flex-col rf-items-center rf-justify-end",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-6 rf-h-6 rf-mb-16",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3f55b239f06aa14f$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-text-center",
                        style: {
                            color: themeColors.loader.text
                        },
                        children: [
                            loaderInformationTexts?.vocal.top && loaderInformationTexts.text.top || loaderInformationTextsLocalized?.vocal?.top?.[locale] && loaderInformationTextsLocalized.text?.top?.[locale] ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                children: mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? loaderInformationTextsLocalized?.vocal?.top?.[locale] || loaderInformationTexts?.vocal?.top : loaderInformationTextsLocalized?.text?.top?.[locale] || loaderInformationTexts?.text?.top
                            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                children: mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? translation.loader.loader.optimal : translation.loader.loader.classic
                            }),
                            loaderInformationTexts?.vocal?.bottom && loaderInformationTexts.text?.bottom || loaderInformationTextsLocalized?.vocal?.bottom?.[locale] && loaderInformationTextsLocalized.text?.bottom?.[locale] ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                className: "rf-font-bold",
                                children: mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? loaderInformationTextsLocalized?.vocal?.bottom?.[locale] || loaderInformationTexts?.vocal?.bottom : loaderInformationTextsLocalized?.text?.bottom?.[locale] || loaderInformationTexts?.text?.bottom
                            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                                className: "rf-font-bold",
                                children: mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal ? translation.loader.loader.vocal : translation.loader.loader.text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-w-full rf-h-1/2 rf-flex rf-flex-col ${hideRetorikLogo ? "rf-justify-start" : "rf-justify-between"} rf-items-center`,
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                    className: "rf-flex rf-flex-col rf-items-center",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8ccc1fb03c665dc5$export$2e2bcd8739ae039), {
                            texts: {
                                left: translation.loader.modes.vocal,
                                leftId: 1,
                                right: translation.loader.modes.text,
                                rightId: 2
                            },
                            colors: themeColors.loader.toggle,
                            defaultChecked: mode,
                            handleChange: handleChange,
                            showLeft: !disabledSpeechMode,
                            showRight: true
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                            className: "rf-font-bold rf-border-2 rf-rounded-lg rf-px-6 rf-py-3 rf-mt-8",
                            style: {
                                color: hover ? themeColors.loader.button.text.hover : themeColors.loader.button.text.default,
                                borderColor: hover ? themeColors.loader.button.border.hover : themeColors.loader.button.border.default,
                                background: hover ? themeColors.loader.button.background.hover : themeColors.loader.button.background.default
                            },
                            onClick: handleValidate,
                            onMouseEnter: ()=>setHover(true),
                            onMouseLeave: ()=>setHover(false),
                            children: translation.loader.loaderValidation
                        })
                    ]
                })
            })
        ]
    });
};
var $4ccb968dc9474451$export$2e2bcd8739ae039 = $4ccb968dc9474451$var$LoaderCallToAction;




var $lT7pJ = parcelRequire("lT7pJ");





const $6270f9979f56481c$var$springDuration = 500;
const $6270f9979f56481c$var$finalMessageDisplayDuration = 2500;
const $6270f9979f56481c$var$GdprWindow = ({ titleTextSize: titleTextSize })=>{
    const data = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.GDPRWindowData);
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const [finalMessage, setFinalMessage] = (0, $lT7pJ.useState)(null);
    const finalMessageTimerRef = (0, $lT7pJ.useRef)();
    const animationTimerRef = (0, $lT7pJ.useRef)();
    const [spring, api] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $lT7pJ.useEffect)(()=>{
        api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $6270f9979f56481c$var$springDuration
            }
        });
        return ()=>{
            finalMessageTimerRef?.current && clearTimeout(finalMessageTimerRef.current);
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    const texts = (0, $lT7pJ.useMemo)(()=>{
        return {
            title: data?.title?.[locale] || translation.GDPR.title,
            message: data?.message?.[locale] || translation.GDPR.message,
            link: data?.link?.[locale] || translation.GDPR.link,
            buttonAccept: data?.buttonAccept?.[locale] || translation.GDPR.buttonAccept,
            buttonRefuse: data?.buttonRefuse?.[locale] || translation.GDPR.buttonRefuse,
            messageAccepted: data?.messageAccepted?.[locale] || translation.GDPR.messageAccepted,
            messageRefused: data?.messageRefused?.[locale] || translation.GDPR.messageRefused
        };
    }, [
        translation,
        locale
    ]);
    const handleCheck = (value)=>{
        (0, $1bda010252da638c$export$7a09e6b3c59f37ad)(value);
        setFinalMessage(value ? texts.messageAccepted : texts.messageRefused);
        finalMessageTimerRef.current = setTimeout(()=>{
            api.start({
                from: {
                    opacity: 1
                },
                to: {
                    opacity: 0
                },
                config: {
                    duration: $6270f9979f56481c$var$springDuration
                }
            });
        }, $6270f9979f56481c$var$finalMessageDisplayDuration);
        animationTimerRef.current = setTimeout(()=>{
            (0, $1bda010252da638c$export$ff26692bd8e0fbbd)(false);
        }, $6270f9979f56481c$var$springDuration + $6270f9979f56481c$var$finalMessageDisplayDuration);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $dc32a48dada8397f$export$407448d2b89b1813).div, {
        className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-gap-12 rf-justify-center rf-items-center rf-text-center",
        style: {
            ...spring
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `${isMobile ? "rf-w-3/4" : "rf-w-1/2"} ${titleTextSize}`,
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(texts.title, locale)
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `${isMobile ? "rf-w-3/4" : "rf-w-1/2"} rf-flex rf-flex-col rf-items-center rf-gap-4`,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (0, $0fdc9a557a65290b$export$d07f57595c356899)(texts.message, locale).replaceAll("\n", "<br>")
                        }
                    }),
                    data?.linkURL && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("a", {
                        href: data.linkURL,
                        target: "_blank",
                        rel: "noreferrer noopener",
                        style: {
                            color: themeColors.primary,
                            textDecoration: "underline"
                        },
                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(texts.link, locale)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-h-16 rf-flex rf-flex-row rf-justify-center rf-gap-4",
                children: finalMessage ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: `${isMobile ? "rf-w-3/4" : "rf-w-1/2"} rf-animate-fadeIn`,
                    children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(finalMessage, locale)
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                            className: "rf-h-fit rf-px-4 rf-py-2 rf-rounded-lg",
                            onClick: ()=>handleCheck(true),
                            style: {
                                color: themeColors.loader.toggle.text,
                                background: themeColors.loader.toggle.background,
                                borderColor: themeColors.loader.toggle.background
                            },
                            children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(texts.buttonAccept, locale)
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                            className: "rf-h-fit rf-px-4 rf-py-2 rf-rounded-lg",
                            onClick: ()=>handleCheck(false),
                            style: {
                                color: themeColors.loader.toggle.text,
                                background: themeColors.loader.toggle.background,
                                borderColor: themeColors.loader.toggle.background
                            },
                            children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(texts.buttonRefuse, locale)
                        })
                    ]
                })
            })
        ]
    });
};
var $6270f9979f56481c$export$2e2bcd8739ae039 = $6270f9979f56481c$var$GdprWindow;


const $a8ba4ad9009aedbb$var$springEnterDuration = 500;
const $a8ba4ad9009aedbb$var$springLeaveDuration = 1000;
const $a8ba4ad9009aedbb$var$GdprAndLoader = ({ appAvailable: appAvailable, handleValidation: handleValidation })=>{
    const displayGDPR = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.GDPRDisplay);
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.isUsedOnBorne);
    const skipLoader = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.skipLoader);
    const loaderClosed = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.loaderClosed);
    const hideRetorikLogo = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.hideRetorikLogo);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const [textSize, setTextSize] = (0, $lT7pJ.useState)("");
    const [titleTextSize, setTitleTextSize] = (0, $lT7pJ.useState)();
    const container = (0, $lT7pJ.useRef)(null);
    const dimensions = (0, $57fa40eeebe37d0d$export$2e2bcd8739ae039)(container);
    const animationTimerRef = (0, $lT7pJ.useRef)();
    const [spring, api] = (0, $b3147ce4de9960c3$export$c4af9125706c4d30)(()=>({
            from: {
                opacity: 0
            }
        }));
    (0, $lT7pJ.useEffect)(()=>{
        if (isUsedOnBorne || skipLoader) {
            (0, $1bda010252da638c$export$ff26692bd8e0fbbd)(false);
            handleValidation();
        }
    }, [
        isUsedOnBorne,
        skipLoader
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        api.start({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            config: {
                duration: $a8ba4ad9009aedbb$var$springEnterDuration
            }
        });
        return ()=>{
            animationTimerRef?.current && clearTimeout(animationTimerRef.current);
        };
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        if (dimensions.width && dimensions.height && dimensions.width > 600) {
            if (dimensions.width < dimensions.height) {
                setTextSize("rf-text-lgcustom");
                setTitleTextSize("rf-text-3xl");
            } else {
                setTextSize("rf-text-basecustom");
                setTitleTextSize("rf-text-4xl");
            }
        } else {
            setTextSize("rf-text-sm");
            setTitleTextSize("rf-text-2xl");
        }
    }, [
        dimensions
    ]);
    const handleValidate = ()=>{
        handleValidation();
        api.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            config: {
                duration: $a8ba4ad9009aedbb$var$springLeaveDuration
            }
        });
    };
    (0, $lT7pJ.useEffect)(()=>{
        container?.current && isWidget && (0, $b5fe10956c349963$export$2e2bcd8739ae039)(container.current);
    }, [
        container?.current
    ]);
    return isUsedOnBorne || skipLoader ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}) : displayGDPR || !(appAvailable || loaderClosed) ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $dc32a48dada8397f$export$407448d2b89b1813).div, {
        id: "retorik-GDPR-and-loader",
        className: `rf-absolute rf-z-modal rf-top-0 rf-left-0 rf-h-full rf-w-full rf-font-default
        ${textSize}`,
        ref: container,
        style: {
            background: themeColors.loader.background,
            color: themeColors.loader.text,
            ...spring
        },
        children: [
            displayGDPR ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6270f9979f56481c$export$2e2bcd8739ae039), {
                titleTextSize: titleTextSize
            }) : !(appAvailable || loaderClosed) ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4ccb968dc9474451$export$2e2bcd8739ae039), {
                handleValidation: handleValidate
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {}),
            !hideRetorikLogo && (isMobile ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $fbd04c9fc08b5261$export$2e2bcd8739ae039), {
                className: "rf-absolute rf-bottom-10 rf-h-14"
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $fbd04c9fc08b5261$export$2e2bcd8739ae039), {
                className: "rf-absolute rf-left-4 rf-bottom-4 rf-h-14"
            }))
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $a8ba4ad9009aedbb$export$2e2bcd8739ae039 = $a8ba4ad9009aedbb$var$GdprAndLoader;


const $b049405234d6895b$var$DBManager = new (0, $7cae176105d9556f$export$2e2bcd8739ae039)();
const $b049405234d6895b$var$tagsRemoverRegex = /<[^<>]+>/g;
const $b049405234d6895b$var$RetorikSpeech = ({ ponyfill: ponyfill, onEnd: onEnd, onError: onError, onStart: onStart, utterance: utterance, nextUtterance: nextUtterance, appAvailable: appAvailable })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const loaderClosed = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.loaderClosed);
    const enableSpeechCaching = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.enableSpeechCaching);
    const speechRecognitionOptions = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.speechRecognitionOptions);
    const voice = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.voice);
    const muted = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.muted);
    const activeRecognitionState = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.activeRecognitionState);
    const boundaryRef = (0, $lT7pJ.useRef)(null);
    const audioRef = (0, $lT7pJ.useRef)(null);
    const speechRecognitionAudioRef = (0, $lT7pJ.useRef)(null);
    const [DBReady, setDBReady] = (0, $lT7pJ.useState)(false);
    const [playingBlob, setPlayingBlob] = (0, $lT7pJ.useState)(false);
    const [nextUtteranceData, setNextUtteranceData] = (0, $lT7pJ.useState)(null);
    const nextUtteranceBoundariesRef = (0, $lT7pJ.useRef)([]);
    const nextUtteranceVisemesRef = (0, $lT7pJ.useRef)([]);
    const emptyTextUtteranceRef = (0, $lT7pJ.useRef)(null);
    (0, $lT7pJ.useEffect)(()=>{
        $b049405234d6895b$var$DBManager.checkDB().then((result)=>setDBReady(result));
    }, []);
    const stopCurrentPlaying = ()=>{
        if (appAvailable || loaderClosed) {
            // Cancel synthesis if using synthesizer
            if (!playingBlob) ponyfill && ponyfill.speechSynthesis.cancel();
            resetNextUtteranceData();
            if (audioRef.current && !audioRef.current?.paused) {
                audioRef.current.pause();
                handleEnd();
            }
        }
    };
    const attachEvents = (tempUtterance, isMainUtterance)=>{
        tempUtterance.onerror = (event)=>{
            isMainUtterance ? handleError(event) : setNextUtteranceData(null);
        };
        tempUtterance.onsynthesiscompleted = ()=>{
            const endBoundary = {
                word: "",
                startTime: 0,
                endTime: 0,
                boundaryType: "EndBoundary"
            };
            if (isMainUtterance) {
                const tempBoundaries = boundaryRef?.current || [];
                boundaryRef.current = [
                    ...tempBoundaries,
                    endBoundary
                ];
                (0, $b8685bd729fa723f$export$c24886139fddc386)([
                    ...tempBoundaries,
                    endBoundary
                ]);
            } else nextUtteranceBoundariesRef.current = [
                ...nextUtteranceBoundariesRef.current,
                endBoundary
            ];
        };
        tempUtterance.onboundary = (event)=>{
            if (event.boundaryType !== "Viseme") {
                const newBoundary = {
                    word: event.name,
                    startTime: event.elapsedTime,
                    endTime: event.elapsedTime + event.duration,
                    boundaryType: event.boundaryType
                };
                if (isMainUtterance) {
                    // Update the boundaryData state with the new data.
                    const tempBoundaries = boundaryRef?.current || [];
                    boundaryRef.current = [
                        ...tempBoundaries,
                        newBoundary
                    ];
                    (0, $b8685bd729fa723f$export$c24886139fddc386)([
                        ...tempBoundaries,
                        newBoundary
                    ]);
                } else nextUtteranceBoundariesRef.current = [
                    ...nextUtteranceBoundariesRef.current,
                    newBoundary
                ];
            }
        };
        tempUtterance.onviseme = (event)=>{
            const newViseme = {
                word: event.name,
                startTime: event.elapsedTime,
                endTime: event.elapsedTime + event.duration,
                boundaryType: event.boundaryType
            };
            if (isMainUtterance) ;
            else nextUtteranceVisemesRef.current = [
                ...nextUtteranceVisemesRef.current,
                newViseme
            ];
        };
        return tempUtterance;
    };
    const processNextData = (data)=>{
        setNextUtteranceData(data?.byteLength ? {
            speechData: data,
            boundaries: nextUtteranceBoundariesRef.current,
            visemes: nextUtteranceVisemesRef.current
        } : null);
        // Reset boundary / viseme data
        resetNextUtteranceData(true);
    };
    const resetNextUtteranceData = (keepArrayBufferData)=>{
        !keepArrayBufferData && setNextUtteranceData(null);
        nextUtteranceBoundariesRef.current = [];
        nextUtteranceVisemesRef.current = [];
    };
    (0, $lT7pJ.useEffect)(()=>{
        if (utterance) {
            if (utterance.text) {
                if (ponyfill && audioRef?.current) {
                    if (nextUtteranceData) {
                        boundaryRef.current = nextUtteranceData.boundaries;
                        (0, $b8685bd729fa723f$export$c24886139fddc386)(nextUtteranceData.boundaries);
                        processData(nextUtteranceData.speechData, true);
                    } else // Play utterance whether by asking for a speech synthesis, or by retrieving data fro indexeddb
                    playUtterance(attachEvents(utterance, true));
                } else stopCurrentPlaying();
            } else handleEmptyTextUtterance();
        } else stopCurrentPlaying();
        return ()=>{
            stopCurrentPlaying();
            emptyTextUtteranceRef?.current && clearTimeout(emptyTextUtteranceRef.current);
        };
    }, [
        utterance
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (nextUtterance?.text && ponyfill) {
            const tempUtterance = attachEvents(nextUtterance);
            ponyfill.speechSynthesis.synthesizeAndGetArrayData(tempUtterance, processNextData);
        } else resetNextUtteranceData();
    }, [
        nextUtterance
    ]);
    const playUtterance = async (utt)=>{
        if (DBReady && enableSpeechCaching !== false && utt) {
            const dataFromIndexedDB = await $b049405234d6895b$var$DBManager.getSpeechData(`${locale}.${voice?.name}.${utt.text.replace($b049405234d6895b$var$tagsRemoverRegex, "").substring(0, 50)}`);
            if (dataFromIndexedDB) {
                boundaryRef.current = dataFromIndexedDB.boundaries;
                (0, $b8685bd729fa723f$export$c24886139fddc386)(dataFromIndexedDB.boundaries);
                processData(dataFromIndexedDB.value, true);
            } else ponyfill?.speechSynthesis.synthesizeAndGetArrayData(utt, processData);
        } else ponyfill?.speechSynthesis.synthesizeAndGetArrayData(utt, processData);
    };
    const processData = (data, alreadyExistsInDB)=>{
        if (data?.byteLength) {
            const blob = new Blob([
                data
            ], {
                type: "audio/mp3"
            });
            enableSpeechCaching !== false && !alreadyExistsInDB && DBReady && boundaryRef?.current && utterance && $b049405234d6895b$var$DBManager.addSpeechData({
                id: `${locale}.${voice?.name}.${utterance.text.replace($b049405234d6895b$var$tagsRemoverRegex, "").substring(0, 50)}`,
                value: data,
                boundaries: boundaryRef.current
            });
            const url = URL.createObjectURL(blob);
            if (audioRef?.current) {
                setPlayingBlob(true);
                audioRef.current.src = url;
                audioRef.current.play().catch((e)=>console.warn(e));
            }
        } else handleEmptyTextUtterance();
    };
    const resetData = ()=>{
        boundaryRef.current = [];
        (0, $b8685bd729fa723f$export$c24886139fddc386)([]);
        setPlayingBlob(false);
    };
    const handleStart = ()=>{
        if (appAvailable || loaderClosed) onStart?.();
    };
    const handleEnd = ()=>{
        if (appAvailable || loaderClosed) {
            onEnd && onEnd();
            resetData();
        } else (0, $7c69764370dcab43$export$982d69b78a955aaf)(true);
    };
    const handleError = (error)=>{
        console.log("Error : ", error);
        onError && onError();
        resetData();
    };
    const handleEmptyTextUtterance = ()=>{
        handleStart();
        emptyTextUtteranceRef?.current && clearTimeout(emptyTextUtteranceRef.current);
        emptyTextUtteranceRef.current = setTimeout(()=>{
            handleEnd();
        }, 50);
    };
    /**
   * On call :
   *  - play 1 second muted sound to prime audio output
   *  - MANDATORY FOR SAFARI IN VOCAL MODE
   */ const primeRetorikSpeech = ()=>{
        if (ponyfill && audioRef.current) {
            audioRef.current.play().catch((e)=>console.warn(e));
            speechRecognitionAudioRef?.current && speechRecognitionAudioRef.current.play().catch((e)=>console.warn(e));
            // Send animation start event to secure animation not playing on safari if permissions are not sufficient
            window.dispatchEvent(new Event("retorikSpiritEnginePlay"));
        }
    };
    /**
   * Play sound on speech recognition activation if it isn't disabled in configuration
   */ (0, $lT7pJ.useEffect)(()=>{
        if (!!speechRecognitionOptions?.enableActivationSound && activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening) speechRecognitionAudioRef?.current && speechRecognitionAudioRef.current.play().catch((e)=>console.warn(e));
    }, [
        activeRecognitionState,
        speechRecognitionOptions
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("audio", {
                ref: audioRef,
                src: (0, $33c0dc36ecc68581$export$52a3c04e084af2a0).onesecond,
                muted: appAvailable || loaderClosed ? muted : true,
                onPlay: handleStart,
                onEnded: handleEnd
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("audio", {
                ref: speechRecognitionAudioRef,
                src: (0, $33c0dc36ecc68581$export$52a3c04e084af2a0).speechrecognition,
                preload: "auto",
                muted: appAvailable || loaderClosed ? muted : true
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a8ba4ad9009aedbb$export$2e2bcd8739ae039), {
                appAvailable: appAvailable,
                handleValidation: primeRetorikSpeech
            })
        ]
    });
};
var $b049405234d6895b$export$2e2bcd8739ae039 = $b049405234d6895b$var$RetorikSpeech;


const $25d0848a4c567cd5$var$SynthesisManager = ({ isRetorikNews: isRetorikNews })=>{
    const cancel = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.cancel);
    const streamingReplyToId = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.streamingReplyToId);
    const streamingQueue = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.streamingQueue);
    const cancelRef = (0, $lT7pJ.useRef)(false);
    const currentPlaying = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.currentPlaying);
    const currentReplyToId = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.currentReplyToId);
    const endedActivities = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.endedActivities);
    const voice = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.voice);
    const customVoice = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.customVoice);
    const ponyfillCredentials = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.ponyfillCredentials);
    const route = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.route);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const agentData = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.agentData);
    const appAvailable = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.appAvailable);
    const preventExpectedInputHint = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.preventExpectedInputHint);
    const speechSynthesisOptions = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.speechSynthesisOptions);
    const currentNewsActivity = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentNewsActivity);
    const lastBotActivity = (0, $d023474b51a6fd24$export$b56465394e2b1287)((state)=>state.lastBotMessageActivity);
    const toggleMicrophone = (0, $4442d90d00cf976a$export$2e2bcd8739ae039)();
    const [utterance, setUtterance] = (0, $lT7pJ.useState)(null);
    const [nextUtterance, setNextUtterance] = (0, $lT7pJ.useState)(null);
    const [utteranceEnded, setUtteranceEnded] = (0, $lT7pJ.useState)(false);
    const queuedActivitiesRef = (0, $lT7pJ.useRef)([]);
    const currentActivityRef = (0, $lT7pJ.useRef)(null);
    const currentPlayingRef = (0, $lT7pJ.useRef)(null);
    const timerRef = (0, $lT7pJ.useRef)(null);
    const [isNewsView, setIsNewsView] = (0, $lT7pJ.useState)(!!isRetorikNews);
    const [ponyfill, setPonyfill] = (0, $lT7pJ.useState)(undefined);
    const refreshTimerRef = (0, $lT7pJ.useRef)(null);
    const [lastListTextPlayed, setLastListTextPlayed] = (0, $lT7pJ.useState)("");
    const tempCurrentStreamingRef = (0, $lT7pJ.useRef)(null);
    /**
   * Async function to retrieve a new token and assign it to the speechConfig inside ponyfill.speechSynthesis
   * @param region string
   * @param key string
   */ const refreshTokenInNineMinutes = async (region, key)=>{
        // A token is valid during 10 minutes, let's refresh it after 9 minutes
        refreshTimerRef.current = setTimeout(async ()=>{
            const token = await (0, $6c74f0a8006c5c67$export$a2ce4fdd6972d6a7)(region, key);
            if (token && ponyfill?.speechSynthesis?.speechConfig) {
                ponyfill.speechSynthesis.speechConfig.authorizationToken = token;
                refreshTokenInNineMinutes(region, key);
            }
        }, 540000) // 9 minutes
        ;
    };
    const fetchTokenAndCreatePonyfill = async (key, region)=>{
        const token = await (0, $6c74f0a8006c5c67$export$a2ce4fdd6972d6a7)(region, key);
        if (token) setPonyfill((0, $882afee30d17764d$exports.createSpeechSynthesisPonyfill)({
            credentials: {
                region: ponyfillCredentials?.region,
                authorizationToken: token
            }
        }));
    };
    /**
   * Launch token refresh after ponyfill creation if subscription key and region are given
   */ (0, $lT7pJ.useEffect)(()=>{
        ponyfill && ponyfillCredentials?.subscriptionKey && ponyfillCredentials?.region && refreshTokenInNineMinutes(ponyfillCredentials.region, ponyfillCredentials.subscriptionKey);
    }, [
        ponyfill
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (ponyfillCredentials?.authorizationToken && ponyfillCredentials?.region) {
            const data = {
                credentials: ponyfillCredentials
            };
            setPonyfill((0, $882afee30d17764d$exports.createSpeechSynthesisPonyfill)(data));
        } else if (ponyfillCredentials?.subscriptionKey && ponyfillCredentials?.region) fetchTokenAndCreatePonyfill(ponyfillCredentials.subscriptionKey, ponyfillCredentials.region);
    }, [
        ponyfillCredentials
    ]);
    const onVoicesChanged = ()=>{
        const voices = ponyfill.speechSynthesis.getVoices();
        if (voices && Array.isArray(voices) && voices.length > 0) (0, $b8685bd729fa723f$export$f7fa6f9f21f4683c)((0, $6988154d82465dcf$export$4bf371fc4fa74a28)(ponyfill.speechSynthesis.getVoices(), locale, customVoice, agentData));
    };
    /**
   * Check activity locale in case of voice change during the speech, to keep the language defined in activity
   * instead of switching languages between answers that are written in the same language
   * @param activityLocale : string
   * @returns SpeechSynthesisVoice | null
   */ const getVoiceAfterCheckingActivityLocale = (activityLocale)=>{
        return activityLocale === locale ? voice : (0, $6988154d82465dcf$export$4bf371fc4fa74a28)(ponyfill.speechSynthesis.getVoices(), activityLocale, customVoice, agentData);
    };
    (0, $lT7pJ.useEffect)(()=>{
        if (ponyfill) {
            const voices = ponyfill.speechSynthesis.getVoices();
            if (voices && Array.isArray(voices) && voices.length > 0) (0, $b8685bd729fa723f$export$f7fa6f9f21f4683c)((0, $6988154d82465dcf$export$4bf371fc4fa74a28)(ponyfill.speechSynthesis.getVoices(), locale, customVoice, agentData));
            else ponyfill.speechSynthesis.onvoiceschanged = onVoicesChanged;
        }
    }, [
        ponyfill,
        customVoice,
        agentData,
        locale
    ]);
    /**
   * On call (used with the 'cancelSpeech' event is fired) :
   *  - set speechCancelStore's cancel state to false
   */ const cancelSpeech = ()=>{
        !isNewsView && (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(true);
    };
    const checkSayAsWordsAndCreateUtterance = (params)=>{
        let sayAsWords = [];
        if (speechSynthesisOptions?.sayAs) {
            speechSynthesisOptions?.sayAs?.common?.length && (sayAsWords = [
                ...speechSynthesisOptions.sayAs.common
            ]);
            speechSynthesisOptions?.sayAs?.localized && speechSynthesisOptions.sayAs.localized[locale]?.length && (sayAsWords = [
                ...sayAsWords,
                ...speechSynthesisOptions.sayAs.localized[locale]
            ]);
        }
        return (0, $7e434ab128e64d14$export$2e2bcd8739ae039)({
            ...params,
            sayAsWords: sayAsWords
        });
    };
    const checkActivityAndCreateUtterance = (params)=>{
        if (params.activity.attachmentLayout && params.activity.attachmentLayout.toLowerCase() === "davilist") {
            const textToSpeak = params.activity.speak || params.activity.text;
            if (textToSpeak) {
                if (textToSpeak === lastListTextPlayed) return checkSayAsWordsAndCreateUtterance({
                    ...params,
                    voice: null
                });
                else setLastListTextPlayed(textToSpeak);
            }
        }
        return checkSayAsWordsAndCreateUtterance({
            ...params
        });
    };
    /**
   * On component mount :
   *  - attach event listener to 'cancelSpeech' event
   * On component unmount :
   *  - reset the timer
   *  - detach the event listener
   */ (0, $lT7pJ.useEffect)(()=>{
        // Event called from the outside to cancel speech
        document.addEventListener("cancelSpeech", cancelSpeech);
        return ()=>{
            timerRef && clearTimeout(timerRef.current);
            refreshTimerRef.current && clearTimeout(refreshTimerRef.current);
            document.removeEventListener("cancelSpeech", cancelSpeech);
        };
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        if (isNewsView) {
            if (currentNewsActivity && ponyfill) {
                const params = {
                    activity: currentNewsActivity,
                    voice: getVoiceAfterCheckingActivityLocale(currentNewsActivity.locale || locale),
                    locale: currentNewsActivity.locale || locale
                };
                setUtterance(checkSayAsWordsAndCreateUtterance({
                    ...params
                }));
            } else setUtterance(null);
        }
    }, [
        currentNewsActivity,
        ponyfill
    ]);
    /**
   * On ViewContext's route state change :
   *  - when we toggle from a view to another, we reset the data related to speech
   */ (0, $lT7pJ.useEffect)(()=>{
        (0, $b8685bd729fa723f$export$f5e94301cb5ae54b)(false);
        (0, $b8685bd729fa723f$export$c24886139fddc386)([]);
        const ended = [
            ...endedActivities
        ];
        if (currentPlaying) {
            // Add played activity id to context's endedActivities
            ended.length > 10 && ended.splice(0, 1);
            currentPlaying.id && ended.push(currentPlaying.id);
            (0, $b8685bd729fa723f$export$7cbdb517d05b0ba6)(ended);
        }
        (0, $b8685bd729fa723f$export$b03f86112d469252)(undefined);
        currentPlayingRef.current = null;
        queuedActivitiesRef.current = [];
        (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(false);
        setUtterance(null);
        setNextUtterance(null);
        !isRetorikNews && setIsNewsView(route === (0, $45d43a6de0968f42$export$3565eb3d00ca5a74).News);
    }, [
        route
    ]);
    /**
   * On RetorikContext's appAvailable state change :
   *  - appAvailable is set to true after the user interacted with the loader and every needed element is loaded
   *  - no utterance is created while appAvailable isn't true
   *  - if during the waiting time, some activities were queued, when appAvailable comes to true, let's begin creating the utterances and playing them
   */ (0, $lT7pJ.useEffect)(()=>{
        if (appAvailable && queuedActivitiesRef.current?.length) {
            const activity = queuedActivitiesRef.current[0];
            currentActivityRef.current = activity;
            const params = {
                activity: activity,
                voice: getVoiceAfterCheckingActivityLocale(activity.locale || locale),
                locale: activity.locale || locale
            };
            const queue = [
                ...queuedActivitiesRef.current
            ];
            queue.splice(0, 1);
            queuedActivitiesRef.current = queue;
            setUtterance(checkActivityAndCreateUtterance(params));
        }
    }, [
        appAvailable
    ]);
    /**
   * On speechCancelStore's cancel state change :
   *  - if there is currently non utterance being played, reset cancel state to false
   *  - if an utterance is being played, set it to null to stop playing and prevent data in queue from being played
   *  - setting an utterance to null will trigger the handleUtteranceEnded method automatically
   */ (0, $lT7pJ.useEffect)(()=>{
        cancelRef.current = cancel;
        if (cancel) {
            utterance ? setUtterance(null) : (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(false);
            setNextUtterance(null);
            (0, $b8685bd729fa723f$export$c3296e37e9ef3fed)();
        }
    }, [
        cancel
    ]);
    /**
   * On lastBotActivity, ponyfill states change :
   *  - check if the ponyfill is created and the voices loaded
   *  - if the activity doesn't have a replyToId value, put it in the queue (used for reminder process)
   *  - if the app is not available yet, put the activity in the queue if it is not yet inside
   *  - NB: an activity can be received once from the directline, but can be found several times in the activities in the botframework
   *  this is because it is processed multiple times if there is something to speak (channelDate empty, then channelData with {speak: true})
   *  - if an utterance is being played, process the new one (do nothing / put it in the queue / stop the current one and play the new one)
   *  - if an utterance has to be created, create it and set the utterance state
   */ (0, $lT7pJ.useEffect)(()=>{
        if (ponyfill && voice && lastBotActivity?.id) {
            let createNewUtterance = false;
            if (!lastBotActivity.replyToId) {
                if (isNewsView) ;
                else if (currentPlaying || queuedActivitiesRef.current?.length) queuedActivitiesRef.current = [
                    ...queuedActivitiesRef.current,
                    lastBotActivity
                ];
                else if (endedActivities.length === 0 || endedActivities[endedActivities.length - 1] !== lastBotActivity.id) createNewUtterance = true;
            } else if (lastBotActivity.replyToId === streamingReplyToId) {
                if (lastBotActivity.value?.streamingId) {
                    (0, $b8685bd729fa723f$export$b03f86112d469252)(lastBotActivity);
                    currentPlayingRef.current = lastBotActivity;
                } else queuedActivitiesRef.current = [
                    ...queuedActivitiesRef.current,
                    lastBotActivity
                ];
            } else if (!appAvailable) {
                if (!currentReplyToId) {
                    (0, $b8685bd729fa723f$export$96a5fb7d9bf39b8a)(lastBotActivity.replyToId);
                    queuedActivitiesRef.current = [
                        lastBotActivity
                    ];
                } else if (currentReplyToId === lastBotActivity.replyToId) {
                    let count = 0;
                    if (queuedActivitiesRef.current?.length) queuedActivitiesRef.current.forEach((activity)=>{
                        if (activity.id === lastBotActivity.id) count++;
                    });
                    if (count === 0) queuedActivitiesRef.current = [
                        ...queuedActivitiesRef.current,
                        lastBotActivity
                    ];
                } else {
                    (0, $b8685bd729fa723f$export$96a5fb7d9bf39b8a)(lastBotActivity.replyToId);
                    queuedActivitiesRef.current = [
                        lastBotActivity
                    ];
                }
            } else if (currentActivityRef?.current) {
                const returnCode = (0, $abb8c624d32bca8f$export$2e2bcd8739ae039)(lastBotActivity, currentActivityRef.current, currentReplyToId, queuedActivitiesRef.current, endedActivities);
                const queue = [
                    ...queuedActivitiesRef.current
                ];
                switch(returnCode){
                    case 0:
                        break;
                    case 1:
                        // Add the activity to the queue
                        queue.push(lastBotActivity);
                        queuedActivitiesRef.current = queue;
                        break;
                    case 2:
                        // Stop current activity and play the new one
                        queuedActivitiesRef.current = [];
                        createNewUtterance = true;
                        break;
                }
            } else createNewUtterance = !endedActivities.includes(lastBotActivity.id);
            if (createNewUtterance) {
                currentActivityRef.current = lastBotActivity;
                (0, $b8685bd729fa723f$export$96a5fb7d9bf39b8a)(lastBotActivity.replyToId || "customReplyToIdIfNotPresent");
                const params = {
                    activity: lastBotActivity,
                    voice: getVoiceAfterCheckingActivityLocale(lastBotActivity.locale || locale),
                    locale: lastBotActivity.locale || locale
                };
                setUtterance(checkActivityAndCreateUtterance(params));
            }
        }
    }, [
        lastBotActivity,
        ponyfill,
        voice
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (streamingReplyToId && streamingQueue.length) {
            const tempActivity = streamingQueue[0];
            const params = {
                activity: tempActivity,
                voice: getVoiceAfterCheckingActivityLocale(locale),
                locale: locale
            };
            (0, $b8685bd729fa723f$export$eb50624bfd363865)();
            setUtterance(checkSayAsWordsAndCreateUtterance(params));
            (0, $b8685bd729fa723f$export$b03f86112d469252)(undefined);
            currentPlayingRef.current = null;
            currentActivityRef.current = null;
            tempCurrentStreamingRef.current = tempActivity.text || null;
        }
    }, [
        streamingReplyToId
    ]);
    /**
   * On utteranceEnded state change :
   *  - if the state is true, an utterance just ended, so the steps are :
   *  - call the handleEnded method
   *  - set utteranceEnded state to false to wait for another utterance end
   */ (0, $lT7pJ.useEffect)(()=>{
        if (utteranceEnded) {
            handleEnded();
            setUtteranceEnded(false);
        }
    }, [
        utteranceEnded
    ]);
    const dispatchSpeechEvent = (start)=>{
        const speechEvent = start ? new Event("retorikSpeakStart") : new Event("retorikSpeakStop");
        document.dispatchEvent(speechEvent);
    };
    /**
   * On call :
   *  - set speaking state to true
   *  - clear timerref timeout
   *  - set currentPlaying and currentReplyToId states after a small delay to prevent make sure that the display will happen after the speech has begun
   */ const handleUtteranceStart = ()=>{
        (0, $b8685bd729fa723f$export$f5e94301cb5ae54b)(true);
        if (!isNewsView && currentActivityRef?.current) {
            (0, $b8685bd729fa723f$export$b03f86112d469252)(currentActivityRef.current);
            currentPlayingRef.current = currentActivityRef.current;
            currentActivityRef.current.id && (0, $0aecf0c32f1a48e0$export$84857fb581760e7)(currentActivityRef.current.id, true);
        }
        dispatchSpeechEvent(true);
        // Set next utterance to prepare synthesis data in order to improve fluidity
        if (streamingReplyToId && streamingQueue.length) {
            const tempActivity = streamingQueue[0];
            if (tempActivity.text) {
                const params = {
                    activity: tempActivity,
                    voice: getVoiceAfterCheckingActivityLocale(locale),
                    locale: locale
                };
                const tempUtterance = checkSayAsWordsAndCreateUtterance(params);
                tempUtterance.text !== nextUtterance?.text ? setNextUtterance(tempUtterance) : setNextUtterance(null);
            } else setNextUtterance(null);
        } else setNextUtterance(null);
        (0, $b8685bd729fa723f$export$d300d9470f5679ba)(tempCurrentStreamingRef?.current);
    };
    /**
   * On call :
   *  - set speaking state to false
   *  - set utteranceEnded state to true
   */ const handleUtteranceEnd = ()=>{
        (0, $b8685bd729fa723f$export$f5e94301cb5ae54b)(false);
        isNewsView ? (0, $1bda010252da638c$export$f052bdc826bb4a9e)(true) : setUtteranceEnded(true);
        dispatchSpeechEvent(false);
    };
    const checkDictateState = ()=>{
        !preventExpectedInputHint && mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal && toggleMicrophone(true);
    };
    /**
   * On call :
   *  - update the states related to the ende activity
   *  - check if the end of the utterance was called by a cancel or not
   *  - if it wasn't a cancel, deal with the queue
   *  - if this was the last activity of the queue, check if the microphone has to be opened automatically (inputHint = expectingInput)
   */ const handleEnded = ()=>{
        let futureUtterance = null;
        const ended = [
            ...endedActivities
        ];
        if (currentPlayingRef?.current) {
            // Add played activity id to context's endedActivities
            ended.length > 10 && ended.splice(0, 1);
            if (currentPlayingRef.current.id) {
                ended.push(currentPlayingRef.current.id);
                (0, $0aecf0c32f1a48e0$export$84857fb581760e7)(currentPlayingRef.current.id, false);
            }
        }
        (0, $b8685bd729fa723f$export$b03f86112d469252)(undefined);
        (0, $b8685bd729fa723f$export$7cbdb517d05b0ba6)(ended);
        // Check if the audio ended because of a cancel call
        if (cancelRef.current) {
            queuedActivitiesRef.current = [];
            tempCurrentStreamingRef.current = null;
            // killCurrentStreaming()
            (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(false);
        } else if (streamingQueue.length) {
            const tempActivity = streamingQueue[0];
            const params = {
                activity: tempActivity,
                voice: getVoiceAfterCheckingActivityLocale(locale),
                locale: locale
            };
            (0, $b8685bd729fa723f$export$eb50624bfd363865)();
            futureUtterance = checkSayAsWordsAndCreateUtterance(params);
            tempCurrentStreamingRef.current = tempActivity.text || null;
        } else {
            // setStreamingReplyToId(null)
            // Launch next activity in the queue and remove it from the queue
            if (queuedActivitiesRef.current?.length) {
                const activity = queuedActivitiesRef.current[0];
                currentActivityRef.current = activity;
                const params = {
                    activity: activity,
                    voice: getVoiceAfterCheckingActivityLocale(activity.locale || locale),
                    locale: activity.locale || locale
                };
                futureUtterance = checkActivityAndCreateUtterance(params);
                const queue = [
                    ...queuedActivitiesRef.current
                ];
                queue.splice(0, 1);
                queuedActivitiesRef.current = queue;
            } else if (currentPlayingRef?.current?.inputHint === "expectingInput") checkDictateState();
        }
        currentPlayingRef.current = null;
        setUtterance(futureUtterance);
    };
    return ponyfill ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $b049405234d6895b$export$2e2bcd8739ae039), {
        ponyfill: ponyfill,
        appAvailable: appAvailable,
        utterance: utterance,
        nextUtterance: nextUtterance,
        onStart: handleUtteranceStart,
        onError: handleUtteranceEnd,
        onEnd: handleUtteranceEnd
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $25d0848a4c567cd5$export$2e2bcd8739ae039 = $25d0848a4c567cd5$var$SynthesisManager;




var $lT7pJ = parcelRequire("lT7pJ");








const $f098c7e32a7ea9ee$var$timeoutDuration = 1000;
const $f098c7e32a7ea9ee$var$RecognitionManager = ()=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const mode = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.mode);
    const appAvailable = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.appAvailable);
    const loaderClosed = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.loaderClosed);
    const speechRecognitionOptions = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.speechRecognitionOptions);
    const ponyfillCredentials = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.ponyfillCredentials);
    const useContinuousRecognition = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.useContinuousRecognition);
    const activeRecognitionState = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.activeRecognitionState);
    const lastRecognitionInterim = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.lastRecognitionInterim);
    const speechRecognitionDynamicGrammars = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.speechRecognitionDynamicGrammars);
    const route = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.route);
    const [ponyfill, setPonyfill] = (0, $lT7pJ.useState)(null);
    const isActiveModeRef = (0, $lT7pJ.useRef)();
    const timerRef = (0, $lT7pJ.useRef)(null);
    const [recognitionAllowed, setRecognitionAllowed] = (0, $lT7pJ.useState)(false);
    const [ponyfillReady, setPonyfillReady] = (0, $lT7pJ.useState)(false);
    const getCommonAndLocalizedWakeWords = ()=>{
        let commonAndlocalizedWakeWords = [];
        if (useContinuousRecognition && speechRecognitionOptions?.wakeWords) {
            if (speechRecognitionOptions.wakeWords.common) commonAndlocalizedWakeWords = [
                ...speechRecognitionOptions.wakeWords.common
            ];
            if (speechRecognitionOptions.wakeWords.localized) {
                const localizedWakeWords = speechRecognitionOptions.wakeWords.localized[locale] || [];
                localizedWakeWords.length && (commonAndlocalizedWakeWords = [
                    ...commonAndlocalizedWakeWords,
                    ...localizedWakeWords
                ]);
            }
        }
        return commonAndlocalizedWakeWords;
    };
    const getCommonAndLocalizedGrammars = ()=>{
        let commonAndlocalizedGrammars = [];
        if (speechRecognitionOptions?.grammars) {
            if (speechRecognitionOptions.grammars.common) commonAndlocalizedGrammars = [
                ...speechRecognitionOptions.grammars.common
            ];
            if (speechRecognitionOptions.grammars.localized) {
                const localizedGrammars = speechRecognitionOptions.grammars.localized[locale] || [];
                localizedGrammars.length && (commonAndlocalizedGrammars = [
                    ...commonAndlocalizedGrammars,
                    ...localizedGrammars
                ]);
            }
        }
        return commonAndlocalizedGrammars;
    };
    const askPermission = ()=>{
        if (recognitionAllowed) ponyfill?.speechRecognition.start();
        else (0, $ee1ff1273d831edb$export$2e2bcd8739ae039)().then((permission)=>{
            setRecognitionAllowed(permission);
        }).catch(console.log);
    };
    (0, $lT7pJ.useEffect)(()=>{
        recognitionAllowed && useContinuousRecognition && ponyfill?.speechRecognition.start();
    }, [
        recognitionAllowed
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (ponyfillCredentials) {
            const options = {
                autoStart: false,
                continuous: useContinuousRecognition,
                interimResults: true,
                grammarsList: getCommonAndLocalizedGrammars(),
                lang: locale,
                passive: useContinuousRecognition,
                wakeWords: getCommonAndLocalizedWakeWords(),
                debug: false,
                timerBeforeSpeechEnd: speechRecognitionOptions?.timerBeforeSpeechEnd
            };
            setPonyfill((0, $882afee30d17764d$exports.createSpeechRecognitionPonyfill)({
                credentials: ponyfillCredentials
            }, options));
        }
    }, [
        ponyfillCredentials
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (ponyfill?.speechRecognition) {
            // Set wakeworkds
            ponyfill.speechRecognition.wakeWords = getCommonAndLocalizedWakeWords();
            // Set language
            activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening ? ponyfill.speechRecognition.changeLanguage(locale) : ponyfill.speechRecognition.lang = locale;
            // Set grammar list
            const grammarList = new (0, $882afee30d17764d$exports.SpeechGrammarList)();
            grammarList.phrases = getCommonAndLocalizedGrammars();
            if (speechRecognitionDynamicGrammars.length) speechRecognitionDynamicGrammars.forEach((grammar)=>{
                !grammarList.phrases.includes(grammar) && grammarList.phrases.push(grammar);
            });
            ponyfill.speechRecognition.grammars = grammarList;
        }
    }, [
        locale,
        speechRecognitionDynamicGrammars
    ]);
    /**
   * Abort recognition if we are not on the 'home' page
   */ (0, $lT7pJ.useEffect)(()=>{
        route !== (0, $45d43a6de0968f42$export$3565eb3d00ca5a74).Home && (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).Closing);
    }, [
        route
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (ponyfill && appAvailable && loaderClosed) {
            if (ponyfill.speechRecognition) {
                ponyfill.speechRecognition.onstart = ()=>{
                    (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).Listening);
                };
                // onend callback is called only whithout using passive speech recognition
                ponyfill.speechRecognition.onend = ()=>{
                    (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).Closing);
                };
                ponyfill.speechRecognition.onabort = ()=>{
                    (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).Closed);
                };
                ponyfill.speechRecognition.onwakeup = ()=>{
                    console.log("Hey, wake up !!");
                };
                ponyfill.speechRecognition.onresult = (result)=>{
                    const lastMessage = result.length > 0 ? result[result.length - 1].transcript : null;
                    // Only get result in Active mode
                    if (lastMessage && isActiveModeRef.current) (0, $b8685bd729fa723f$export$a5c8d6d0ec4b5ccb)(lastMessage);
                };
                setPonyfillReady(true);
            }
        }
        return ()=>{
            timerRef?.current && clearTimeout(timerRef.current);
            ponyfill?.speechRecognition?.stop && ponyfill.speechRecognition.stop();
        };
    }, [
        ponyfill,
        appAvailable,
        loaderClosed
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (ponyfillReady && mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal) // Start passive recognition if not done yet
        useContinuousRecognition && !ponyfill?.speechRecognition.started && askPermission();
    }, [
        mode,
        ponyfillReady
    ]);
    const togglePassiveToActive = ()=>{
        if (ponyfill?.speechRecognition.started) ponyfill.speechRecognition.toggleContinuousPassiveToActive();
        else if (ponyfill) {
            ponyfill.speechRecognition.passive = false;
            ponyfill.speechRecognition.continuous = false;
            ponyfill.speechRecognition.start();
        }
    };
    (0, $lT7pJ.useEffect)(()=>{
        isActiveModeRef.current = activeRecognitionState === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening;
        if (ponyfill?.speechRecognition && appAvailable && loaderClosed) {
            timerRef?.current && clearTimeout(timerRef.current);
            switch(activeRecognitionState){
                // Do nothing if we are in a transition state
                case (0, $45d43a6de0968f42$export$3f0071308968cd80).Initializing:
                    useContinuousRecognition ? togglePassiveToActive() : ponyfill.speechRecognition.start();
                    break;
                case (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening:
                    break;
                case (0, $45d43a6de0968f42$export$3f0071308968cd80).Closing:
                    if (lastRecognitionInterim) timerRef.current = setTimeout(()=>{
                        (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(lastRecognitionInterim);
                        (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).Closed);
                    }, $f098c7e32a7ea9ee$var$timeoutDuration);
                    else (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).Closed);
                    break;
                case (0, $45d43a6de0968f42$export$3f0071308968cd80).ForceClosing:
                    (0, $b8685bd729fa723f$export$a5c8d6d0ec4b5ccb)("");
                    // If an interim was processed, a 'end' event will be fired. If not, we must abort the current recognition
                    if (!lastRecognitionInterim) ponyfill.speechRecognition.started ? ponyfill.speechRecognition.abort?.() : (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).Closed);
                    break;
                case (0, $45d43a6de0968f42$export$3f0071308968cd80).Closed:
                    if (useContinuousRecognition && mode === (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal) timerRef.current = setTimeout(()=>{
                        ponyfill.speechRecognition.toggleContinuousActiveToPassive();
                    }, $f098c7e32a7ea9ee$var$timeoutDuration);
                    (0, $b8685bd729fa723f$export$a5c8d6d0ec4b5ccb)("");
                    break;
            }
        }
    }, [
        activeRecognitionState
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $f098c7e32a7ea9ee$export$2e2bcd8739ae039 = $f098c7e32a7ea9ee$var$RecognitionManager;


const $577c102a8d490505$var$SpeechManager = ({ isRetorikNews: isRetorikNews })=>{
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $25d0848a4c567cd5$export$2e2bcd8739ae039), {
                isRetorikNews: isRetorikNews
            }),
            !isRetorikNews && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $f098c7e32a7ea9ee$export$2e2bcd8739ae039), {})
        ]
    });
};
var $577c102a8d490505$export$2e2bcd8739ae039 = $577c102a8d490505$var$SpeechManager;




var $lT7pJ = parcelRequire("lT7pJ");





const $a6b91876af412c22$var$FocusManager = ()=>{
    const isWidget = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isWidget);
    const open = (0, $079f3ffaa96f1faa$export$d95eb9b67812311f)((state)=>state.open);
    const muted = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.muted);
    const activeRecognitionState = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.activeRecognitionState);
    const focusedRef = (0, $lT7pJ.useRef)(true);
    const oldMutedRef = (0, $lT7pJ.useRef)(muted);
    const recognitionStateRef = (0, $lT7pJ.useRef)(activeRecognitionState);
    (0, $lT7pJ.useEffect)(()=>{
        focusedRef.current && (oldMutedRef.current = muted);
    }, [
        muted
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        recognitionStateRef.current = activeRecognitionState;
    }, [
        activeRecognitionState
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if ((0, $673e90b4fbb753dd$exports.isMobile) && isWidget) {
            if (open) {
                focusedRef.current = true;
                oldMutedRef.current === false && (0, $b8685bd729fa723f$export$a1680ba91cc9be33)(false);
            } else {
                focusedRef.current = false;
                (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(true);
                (0, $b8685bd729fa723f$export$a1680ba91cc9be33)(true);
                recognitionStateRef.current === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening && (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).ForceClosing);
            }
        }
    }, [
        open,
        isWidget,
        (0, $673e90b4fbb753dd$exports.isMobile)
    ]);
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === "visible") {
            focusedRef.current = true;
            oldMutedRef.current === false && (0, $b8685bd729fa723f$export$a1680ba91cc9be33)(false);
        } else {
            focusedRef.current = false;
            (0, $b8685bd729fa723f$export$d0df6aec4e971f52)(true);
            (0, $b8685bd729fa723f$export$a1680ba91cc9be33)(true);
            recognitionStateRef.current === (0, $45d43a6de0968f42$export$3f0071308968cd80).Listening && (0, $b8685bd729fa723f$export$45913366c4ba414f)((0, $45d43a6de0968f42$export$3f0071308968cd80).ForceClosing);
        }
    };
    (0, $lT7pJ.useEffect)(()=>{
        (0, $673e90b4fbb753dd$exports.isMobile) && document.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [
        (0, $673e90b4fbb753dd$exports.isMobile)
    ]);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $a6b91876af412c22$export$2e2bcd8739ae039 = $a6b91876af412c22$var$FocusManager;




var $lT7pJ = parcelRequire("lT7pJ");


const $72e0b7cc78ac2535$export$ad7b40b81d5409c = "data:image/png;base64,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";


const $d113fc29ff4ecd16$var$MobileLandscapePreventer = ()=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const isMobileLandscape = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobileLandscape);
    return isMobileLandscape ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-absolute rf-w-full rf-h-full rf-z-exitwidget rf-flex rf-flex-col rf-items-center rf-bg-truewhite",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-h-1/2 rf-flex rf-items-end rf-pb-4",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                    className: "rf-h-2/3",
                    src: (0, $72e0b7cc78ac2535$export$ad7b40b81d5409c)
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-h-1/2 rf-pt-4 rf-flex rf-flex-col rf-items-center",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-font-semibold rf-text-xl",
                        children: translation.mobileLandscapePreventer.firstline
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-font-bold rf-text-3xl",
                        children: translation.mobileLandscapePreventer.secondline
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $d113fc29ff4ecd16$export$2e2bcd8739ae039 = $d113fc29ff4ecd16$var$MobileLandscapePreventer;



parcelRequire("lT7pJ");


var $lT7pJ = parcelRequire("lT7pJ");
"use client";
const $ad9e8675d6494061$export$b16d9fb1a22de840 = (0, $lT7pJ.createContext)(null);
const $ad9e8675d6494061$var$initialState = {
    didCatch: false,
    error: null
};
class $ad9e8675d6494061$export$e926676385687eaf extends (0, $lT7pJ.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $ad9e8675d6494061$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($ad9e8675d6494061$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $ad9e8675d6494061$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($ad9e8675d6494061$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $lT7pJ.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $lT7pJ.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $lT7pJ.createElement)($ad9e8675d6494061$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $ad9e8675d6494061$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $ad9e8675d6494061$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $ad9e8675d6494061$export$c052f6604b7d51fe() {
    const context = (0, $lT7pJ.useContext)($ad9e8675d6494061$export$b16d9fb1a22de840);
    $ad9e8675d6494061$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $lT7pJ.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $lT7pJ.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $ad9e8675d6494061$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $lT7pJ.forwardRef)((props, ref)=>(0, $lT7pJ.createElement)($ad9e8675d6494061$export$e926676385687eaf, errorBoundaryProps, (0, $lT7pJ.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}



parcelRequire("lT7pJ");

const $3f9d35688edc91a7$var$ErrorFallback = ({ resetErrorBoundary: resetErrorBoundary })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const handleReset = ()=>{
        resetErrorBoundary();
        window.location.reload();
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-2",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                className: "rf-uppercase",
                children: translation.error.title
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                onClick: handleReset,
                className: "rf-border rf-px-4",
                children: translation.error.button
            })
        ]
    });
};
var $3f9d35688edc91a7$export$2e2bcd8739ae039 = $3f9d35688edc91a7$var$ErrorFallback;


const $4c0f8c7831c7ab99$var$ErrorCollector = ({ children: children })=>{
    const { sendErrorTrace: sendErrorTrace } = (0, $f5328b777e1b8fec$export$a15d15518a3ec33d)();
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ad9e8675d6494061$export$e926676385687eaf), {
        FallbackComponent: (0, $3f9d35688edc91a7$export$2e2bcd8739ae039),
        onError: sendErrorTrace,
        children: children
    });
};
var $4c0f8c7831c7ab99$export$2e2bcd8739ae039 = $4c0f8c7831c7ab99$var$ErrorCollector;





var $lT7pJ = parcelRequire("lT7pJ");






const $fbce23b8754704fb$var$typingTimer = 2000;
const $fbce23b8754704fb$var$SendTypingIndicator = ({ isRetorikNews: isRetorikNews })=>{
    const speaking = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.speaking);
    const lastRecognitionInterim = (0, $b8685bd729fa723f$export$f299240efcda25a2)((state)=>state.lastRecognitionInterim);
    const route = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.route);
    const loaderClosed = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.loaderClosed);
    const appAvailable = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.appAvailable);
    const isWaitingForResponse = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.isWaitingForResponse);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const listOpened = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.listOpened);
    const retorikEvent = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.retorikEvent);
    const userIsTyping = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.userIsTyping);
    const userIsSwiping = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.userIsSwiping);
    const dataRef = (0, $lT7pJ.useRef)(false);
    (0, $lT7pJ.useEffect)(()=>{
        dataRef.current = !isWaitingForResponse && (!loaderClosed || lastRecognitionInterim !== "" || userIsTyping || userIsSwiping || speaking || currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).none || route === (0, $45d43a6de0968f42$export$3565eb3d00ca5a74).News || retorikEvent === (0, $45d43a6de0968f42$export$4f7cd669585dc69f).DetailViewOpen || listOpened);
    }, [
        appAvailable,
        loaderClosed,
        lastRecognitionInterim,
        userIsTyping,
        userIsSwiping,
        speaking,
        currentSubView,
        route,
        retorikEvent,
        listOpened,
        isWaitingForResponse
    ]);
    const checkShouldSendTypingIndicator = ()=>{
        dataRef.current && !isRetorikNews && (0, $0aecf0c32f1a48e0$export$81487d3d3f61cca3)();
    };
    (0, $lT7pJ.useEffect)(()=>{
        const interval = setInterval(()=>{
            checkShouldSendTypingIndicator();
        }, $fbce23b8754704fb$var$typingTimer);
        return ()=>{
            interval && clearInterval(interval);
        };
    }, []);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $fbce23b8754704fb$export$2e2bcd8739ae039 = $fbce23b8754704fb$var$SendTypingIndicator;













(0, $6a883133d725d0f3$export$e7ec4a9e2d586a77)();
(0, $b5ae944e35783420$export$2e2bcd8739ae039).GlobalWorkerOptions.workerSrc = "pdf.worker.js";


var $9e7e6ef3b125c124$exports = {};

var $hIXGI = parcelRequire("hIXGI");
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $9e7e6ef3b125c124$exports = root.pdfjsWorker = factory();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WorkerTask = exports.WorkerMessageHandler = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _primitives = __w_pdfjs_require__(4);
                var _pdf_manager = __w_pdfjs_require__(6);
                var _annotation = __w_pdfjs_require__(10);
                var _cleanup_helper = __w_pdfjs_require__(68);
                var _writer = __w_pdfjs_require__(73);
                var _message_handler = __w_pdfjs_require__(104);
                var _worker_stream = __w_pdfjs_require__(105);
                var _struct_tree = __w_pdfjs_require__(72);
                class WorkerTask {
                    constructor(name){
                        this.name = name;
                        this.terminated = false;
                        this._capability = new _util.PromiseCapability();
                    }
                    get finished() {
                        return this._capability.promise;
                    }
                    finish() {
                        this._capability.resolve();
                    }
                    terminate() {
                        this.terminated = true;
                    }
                    ensureNotTerminated() {
                        if (this.terminated) throw new Error("Worker task was terminated");
                    }
                }
                exports.WorkerTask = WorkerTask;
                class WorkerMessageHandler {
                    static setup(handler, port) {
                        let testMessageProcessed = false;
                        handler.on("test", function(data) {
                            if (testMessageProcessed) return;
                            testMessageProcessed = true;
                            handler.send("test", data instanceof Uint8Array);
                        });
                        handler.on("configure", function(data) {
                            (0, _util.setVerbosityLevel)(data.verbosity);
                        });
                        handler.on("GetDocRequest", function(data) {
                            return WorkerMessageHandler.createDocumentHandler(data, port);
                        });
                    }
                    static createDocumentHandler(docParams, port) {
                        let pdfManager;
                        let terminated = false;
                        let cancelXHRs = null;
                        const WorkerTasks = new Set();
                        const verbosity = (0, _util.getVerbosityLevel)();
                        const { docId: docId, apiVersion: apiVersion } = docParams;
                        const workerVersion = "3.11.174";
                        if (apiVersion !== workerVersion) throw new Error(`The API version "${apiVersion}" does not match ` + `the Worker version "${workerVersion}".`);
                        const enumerableProperties = [];
                        for(const property in [])enumerableProperties.push(property);
                        if (enumerableProperties.length) throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + enumerableProperties.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
                        const workerHandlerName = docId + "_worker";
                        let handler = new _message_handler.MessageHandler(workerHandlerName, docId, port);
                        function ensureNotTerminated() {
                            if (terminated) throw new Error("Worker was terminated");
                        }
                        function startWorkerTask(task) {
                            WorkerTasks.add(task);
                        }
                        function finishWorkerTask(task) {
                            task.finish();
                            WorkerTasks.delete(task);
                        }
                        async function loadDocument(recoveryMode) {
                            await pdfManager.ensureDoc("checkHeader");
                            await pdfManager.ensureDoc("parseStartXRef");
                            await pdfManager.ensureDoc("parse", [
                                recoveryMode
                            ]);
                            await pdfManager.ensureDoc("checkFirstPage", [
                                recoveryMode
                            ]);
                            await pdfManager.ensureDoc("checkLastPage", [
                                recoveryMode
                            ]);
                            const isPureXfa = await pdfManager.ensureDoc("isPureXfa");
                            if (isPureXfa) {
                                const task = new WorkerTask("loadXfaFonts");
                                startWorkerTask(task);
                                await Promise.all([
                                    pdfManager.loadXfaFonts(handler, task).catch((reason)=>{}).then(()=>finishWorkerTask(task)),
                                    pdfManager.loadXfaImages()
                                ]);
                            }
                            const [numPages, fingerprints] = await Promise.all([
                                pdfManager.ensureDoc("numPages"),
                                pdfManager.ensureDoc("fingerprints")
                            ]);
                            const htmlForXfa = isPureXfa ? await pdfManager.ensureDoc("htmlForXfa") : null;
                            return {
                                numPages: numPages,
                                fingerprints: fingerprints,
                                htmlForXfa: htmlForXfa
                            };
                        }
                        function getPdfManager({ data: data, password: password, disableAutoFetch: disableAutoFetch, rangeChunkSize: rangeChunkSize, length: length, docBaseUrl: docBaseUrl, enableXfa: enableXfa, evaluatorOptions: evaluatorOptions }) {
                            const pdfManagerArgs = {
                                source: null,
                                disableAutoFetch: disableAutoFetch,
                                docBaseUrl: docBaseUrl,
                                docId: docId,
                                enableXfa: enableXfa,
                                evaluatorOptions: evaluatorOptions,
                                handler: handler,
                                length: length,
                                password: password,
                                rangeChunkSize: rangeChunkSize
                            };
                            const pdfManagerCapability = new _util.PromiseCapability();
                            let newPdfManager;
                            if (data) {
                                try {
                                    pdfManagerArgs.source = data;
                                    newPdfManager = new _pdf_manager.LocalPdfManager(pdfManagerArgs);
                                    pdfManagerCapability.resolve(newPdfManager);
                                } catch (ex) {
                                    pdfManagerCapability.reject(ex);
                                }
                                return pdfManagerCapability.promise;
                            }
                            let pdfStream, cachedChunks = [];
                            try {
                                pdfStream = new _worker_stream.PDFWorkerStream(handler);
                            } catch (ex) {
                                pdfManagerCapability.reject(ex);
                                return pdfManagerCapability.promise;
                            }
                            const fullRequest = pdfStream.getFullReader();
                            fullRequest.headersReady.then(function() {
                                if (!fullRequest.isRangeSupported) return;
                                pdfManagerArgs.source = pdfStream;
                                pdfManagerArgs.length = fullRequest.contentLength;
                                pdfManagerArgs.disableAutoFetch ||= fullRequest.isStreamingSupported;
                                newPdfManager = new _pdf_manager.NetworkPdfManager(pdfManagerArgs);
                                for (const chunk of cachedChunks)newPdfManager.sendProgressiveData(chunk);
                                cachedChunks = [];
                                pdfManagerCapability.resolve(newPdfManager);
                                cancelXHRs = null;
                            }).catch(function(reason) {
                                pdfManagerCapability.reject(reason);
                                cancelXHRs = null;
                            });
                            let loaded = 0;
                            const flushChunks = function() {
                                const pdfFile = (0, _core_utils.arrayBuffersToBytes)(cachedChunks);
                                if (length && pdfFile.length !== length) (0, _util.warn)("reported HTTP length is different from actual");
                                try {
                                    pdfManagerArgs.source = pdfFile;
                                    newPdfManager = new _pdf_manager.LocalPdfManager(pdfManagerArgs);
                                    pdfManagerCapability.resolve(newPdfManager);
                                } catch (ex) {
                                    pdfManagerCapability.reject(ex);
                                }
                                cachedChunks = [];
                            };
                            new Promise(function(resolve, reject) {
                                const readChunk = function({ value: value, done: done }) {
                                    try {
                                        ensureNotTerminated();
                                        if (done) {
                                            if (!newPdfManager) flushChunks();
                                            cancelXHRs = null;
                                            return;
                                        }
                                        loaded += value.byteLength;
                                        if (!fullRequest.isStreamingSupported) handler.send("DocProgress", {
                                            loaded: loaded,
                                            total: Math.max(loaded, fullRequest.contentLength || 0)
                                        });
                                        if (newPdfManager) newPdfManager.sendProgressiveData(value);
                                        else cachedChunks.push(value);
                                        fullRequest.read().then(readChunk, reject);
                                    } catch (e) {
                                        reject(e);
                                    }
                                };
                                fullRequest.read().then(readChunk, reject);
                            }).catch(function(e) {
                                pdfManagerCapability.reject(e);
                                cancelXHRs = null;
                            });
                            cancelXHRs = function(reason) {
                                pdfStream.cancelAllRequests(reason);
                            };
                            return pdfManagerCapability.promise;
                        }
                        function setupDoc(data) {
                            function onSuccess(doc) {
                                ensureNotTerminated();
                                handler.send("GetDoc", {
                                    pdfInfo: doc
                                });
                            }
                            function onFailure(ex) {
                                ensureNotTerminated();
                                if (ex instanceof _util.PasswordException) {
                                    const task = new WorkerTask(`PasswordException: response ${ex.code}`);
                                    startWorkerTask(task);
                                    handler.sendWithPromise("PasswordRequest", ex).then(function({ password: password }) {
                                        finishWorkerTask(task);
                                        pdfManager.updatePassword(password);
                                        pdfManagerReady();
                                    }).catch(function() {
                                        finishWorkerTask(task);
                                        handler.send("DocException", ex);
                                    });
                                } else if (ex instanceof _util.InvalidPDFException || ex instanceof _util.MissingPDFException || ex instanceof _util.UnexpectedResponseException || ex instanceof _util.UnknownErrorException) handler.send("DocException", ex);
                                else handler.send("DocException", new _util.UnknownErrorException(ex.message, ex.toString()));
                            }
                            function pdfManagerReady() {
                                ensureNotTerminated();
                                loadDocument(false).then(onSuccess, function(reason) {
                                    ensureNotTerminated();
                                    if (!(reason instanceof _core_utils.XRefParseException)) {
                                        onFailure(reason);
                                        return;
                                    }
                                    pdfManager.requestLoadedStream().then(function() {
                                        ensureNotTerminated();
                                        loadDocument(true).then(onSuccess, onFailure);
                                    });
                                });
                            }
                            ensureNotTerminated();
                            getPdfManager(data).then(function(newPdfManager) {
                                if (terminated) {
                                    newPdfManager.terminate(new _util.AbortException("Worker was terminated."));
                                    throw new Error("Worker was terminated");
                                }
                                pdfManager = newPdfManager;
                                pdfManager.requestLoadedStream(true).then((stream)=>{
                                    handler.send("DataLoaded", {
                                        length: stream.bytes.byteLength
                                    });
                                });
                            }).then(pdfManagerReady, onFailure);
                        }
                        handler.on("GetPage", function(data) {
                            return pdfManager.getPage(data.pageIndex).then(function(page) {
                                return Promise.all([
                                    pdfManager.ensure(page, "rotate"),
                                    pdfManager.ensure(page, "ref"),
                                    pdfManager.ensure(page, "userUnit"),
                                    pdfManager.ensure(page, "view")
                                ]).then(function([rotate, ref, userUnit, view]) {
                                    return {
                                        rotate: rotate,
                                        ref: ref,
                                        userUnit: userUnit,
                                        view: view
                                    };
                                });
                            });
                        });
                        handler.on("GetPageIndex", function(data) {
                            const pageRef = _primitives.Ref.get(data.num, data.gen);
                            return pdfManager.ensureCatalog("getPageIndex", [
                                pageRef
                            ]);
                        });
                        handler.on("GetDestinations", function(data) {
                            return pdfManager.ensureCatalog("destinations");
                        });
                        handler.on("GetDestination", function(data) {
                            return pdfManager.ensureCatalog("getDestination", [
                                data.id
                            ]);
                        });
                        handler.on("GetPageLabels", function(data) {
                            return pdfManager.ensureCatalog("pageLabels");
                        });
                        handler.on("GetPageLayout", function(data) {
                            return pdfManager.ensureCatalog("pageLayout");
                        });
                        handler.on("GetPageMode", function(data) {
                            return pdfManager.ensureCatalog("pageMode");
                        });
                        handler.on("GetViewerPreferences", function(data) {
                            return pdfManager.ensureCatalog("viewerPreferences");
                        });
                        handler.on("GetOpenAction", function(data) {
                            return pdfManager.ensureCatalog("openAction");
                        });
                        handler.on("GetAttachments", function(data) {
                            return pdfManager.ensureCatalog("attachments");
                        });
                        handler.on("GetDocJSActions", function(data) {
                            return pdfManager.ensureCatalog("jsActions");
                        });
                        handler.on("GetPageJSActions", function({ pageIndex: pageIndex }) {
                            return pdfManager.getPage(pageIndex).then(function(page) {
                                return pdfManager.ensure(page, "jsActions");
                            });
                        });
                        handler.on("GetOutline", function(data) {
                            return pdfManager.ensureCatalog("documentOutline");
                        });
                        handler.on("GetOptionalContentConfig", function(data) {
                            return pdfManager.ensureCatalog("optionalContentConfig");
                        });
                        handler.on("GetPermissions", function(data) {
                            return pdfManager.ensureCatalog("permissions");
                        });
                        handler.on("GetMetadata", function(data) {
                            return Promise.all([
                                pdfManager.ensureDoc("documentInfo"),
                                pdfManager.ensureCatalog("metadata")
                            ]);
                        });
                        handler.on("GetMarkInfo", function(data) {
                            return pdfManager.ensureCatalog("markInfo");
                        });
                        handler.on("GetData", function(data) {
                            return pdfManager.requestLoadedStream().then(function(stream) {
                                return stream.bytes;
                            });
                        });
                        handler.on("GetAnnotations", function({ pageIndex: pageIndex, intent: intent }) {
                            return pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask(`GetAnnotations: page ${pageIndex}`);
                                startWorkerTask(task);
                                return page.getAnnotationsData(handler, task, intent).then((data)=>{
                                    finishWorkerTask(task);
                                    return data;
                                }, (reason)=>{
                                    finishWorkerTask(task);
                                    throw reason;
                                });
                            });
                        });
                        handler.on("GetFieldObjects", function(data) {
                            return pdfManager.ensureDoc("fieldObjects");
                        });
                        handler.on("HasJSActions", function(data) {
                            return pdfManager.ensureDoc("hasJSActions");
                        });
                        handler.on("GetCalculationOrderIds", function(data) {
                            return pdfManager.ensureDoc("calculationOrderIds");
                        });
                        handler.on("SaveDocument", async function({ isPureXfa: isPureXfa, numPages: numPages, annotationStorage: annotationStorage, filename: filename }) {
                            const globalPromises = [
                                pdfManager.requestLoadedStream(),
                                pdfManager.ensureCatalog("acroForm"),
                                pdfManager.ensureCatalog("acroFormRef"),
                                pdfManager.ensureDoc("startXRef"),
                                pdfManager.ensureDoc("xref"),
                                pdfManager.ensureDoc("linearization"),
                                pdfManager.ensureCatalog("structTreeRoot")
                            ];
                            const promises = [];
                            const newAnnotationsByPage = !isPureXfa ? (0, _core_utils.getNewAnnotationsMap)(annotationStorage) : null;
                            const [stream, acroForm, acroFormRef, startXRef, xref, linearization, _structTreeRoot] = await Promise.all(globalPromises);
                            const catalogRef = xref.trailer.getRaw("Root") || null;
                            let structTreeRoot;
                            if (newAnnotationsByPage) {
                                if (!_structTreeRoot) {
                                    if (await _struct_tree.StructTreeRoot.canCreateStructureTree({
                                        catalogRef: catalogRef,
                                        pdfManager: pdfManager,
                                        newAnnotationsByPage: newAnnotationsByPage
                                    })) structTreeRoot = null;
                                } else if (await _structTreeRoot.canUpdateStructTree({
                                    pdfManager: pdfManager,
                                    newAnnotationsByPage: newAnnotationsByPage
                                })) structTreeRoot = _structTreeRoot;
                                const imagePromises = _annotation.AnnotationFactory.generateImages(annotationStorage.values(), xref, pdfManager.evaluatorOptions.isOffscreenCanvasSupported);
                                const newAnnotationPromises = structTreeRoot === undefined ? promises : [];
                                for (const [pageIndex, annotations] of newAnnotationsByPage)newAnnotationPromises.push(pdfManager.getPage(pageIndex).then((page)=>{
                                    const task = new WorkerTask(`Save (editor): page ${pageIndex}`);
                                    return page.saveNewAnnotations(handler, task, annotations, imagePromises).finally(function() {
                                        finishWorkerTask(task);
                                    });
                                }));
                                if (structTreeRoot === null) promises.push(Promise.all(newAnnotationPromises).then(async (newRefs)=>{
                                    await _struct_tree.StructTreeRoot.createStructureTree({
                                        newAnnotationsByPage: newAnnotationsByPage,
                                        xref: xref,
                                        catalogRef: catalogRef,
                                        pdfManager: pdfManager,
                                        newRefs: newRefs
                                    });
                                    return newRefs;
                                }));
                                else if (structTreeRoot) promises.push(Promise.all(newAnnotationPromises).then(async (newRefs)=>{
                                    await structTreeRoot.updateStructureTree({
                                        newAnnotationsByPage: newAnnotationsByPage,
                                        pdfManager: pdfManager,
                                        newRefs: newRefs
                                    });
                                    return newRefs;
                                }));
                            }
                            if (isPureXfa) promises.push(pdfManager.serializeXfaData(annotationStorage));
                            else for(let pageIndex = 0; pageIndex < numPages; pageIndex++)promises.push(pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask(`Save: page ${pageIndex}`);
                                return page.save(handler, task, annotationStorage).finally(function() {
                                    finishWorkerTask(task);
                                });
                            }));
                            const refs = await Promise.all(promises);
                            let newRefs = [];
                            let xfaData = null;
                            if (isPureXfa) {
                                xfaData = refs[0];
                                if (!xfaData) return stream.bytes;
                            } else {
                                newRefs = refs.flat(2);
                                if (newRefs.length === 0) return stream.bytes;
                            }
                            const needAppearances = acroFormRef && acroForm instanceof _primitives.Dict && newRefs.some((ref)=>ref.needAppearances);
                            const xfa = acroForm instanceof _primitives.Dict && acroForm.get("XFA") || null;
                            let xfaDatasetsRef = null;
                            let hasXfaDatasetsEntry = false;
                            if (Array.isArray(xfa)) {
                                for(let i = 0, ii = xfa.length; i < ii; i += 2)if (xfa[i] === "datasets") {
                                    xfaDatasetsRef = xfa[i + 1];
                                    hasXfaDatasetsEntry = true;
                                }
                                if (xfaDatasetsRef === null) xfaDatasetsRef = xref.getNewTemporaryRef();
                            } else if (xfa) (0, _util.warn)("Unsupported XFA type.");
                            let newXrefInfo = Object.create(null);
                            if (xref.trailer) {
                                const infoObj = Object.create(null);
                                const xrefInfo = xref.trailer.get("Info") || null;
                                if (xrefInfo instanceof _primitives.Dict) xrefInfo.forEach((key, value)=>{
                                    if (typeof value === "string") infoObj[key] = (0, _util.stringToPDFString)(value);
                                });
                                newXrefInfo = {
                                    rootRef: catalogRef,
                                    encryptRef: xref.trailer.getRaw("Encrypt") || null,
                                    newRef: xref.getNewTemporaryRef(),
                                    infoRef: xref.trailer.getRaw("Info") || null,
                                    info: infoObj,
                                    fileIds: xref.trailer.get("ID") || null,
                                    startXRef: linearization ? startXRef : xref.lastXRefStreamPos ?? startXRef,
                                    filename: filename
                                };
                            }
                            return (0, _writer.incrementalUpdate)({
                                originalData: stream.bytes,
                                xrefInfo: newXrefInfo,
                                newRefs: newRefs,
                                xref: xref,
                                hasXfa: !!xfa,
                                xfaDatasetsRef: xfaDatasetsRef,
                                hasXfaDatasetsEntry: hasXfaDatasetsEntry,
                                needAppearances: needAppearances,
                                acroFormRef: acroFormRef,
                                acroForm: acroForm,
                                xfaData: xfaData
                            }).finally(()=>{
                                xref.resetNewTemporaryRef();
                            });
                        });
                        handler.on("GetOperatorList", function(data, sink) {
                            const pageIndex = data.pageIndex;
                            pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask(`GetOperatorList: page ${pageIndex}`);
                                startWorkerTask(task);
                                const start = verbosity >= _util.VerbosityLevel.INFOS ? Date.now() : 0;
                                page.getOperatorList({
                                    handler: handler,
                                    sink: sink,
                                    task: task,
                                    intent: data.intent,
                                    cacheKey: data.cacheKey,
                                    annotationStorage: data.annotationStorage
                                }).then(function(operatorListInfo) {
                                    finishWorkerTask(task);
                                    if (start) (0, _util.info)(`page=${pageIndex + 1} - getOperatorList: time=` + `${Date.now() - start}ms, len=${operatorListInfo.length}`);
                                    sink.close();
                                }, function(reason) {
                                    finishWorkerTask(task);
                                    if (task.terminated) return;
                                    sink.error(reason);
                                });
                            });
                        });
                        handler.on("GetTextContent", function(data, sink) {
                            const { pageIndex: pageIndex, includeMarkedContent: includeMarkedContent, disableNormalization: disableNormalization } = data;
                            pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask("GetTextContent: page " + pageIndex);
                                startWorkerTask(task);
                                const start = verbosity >= _util.VerbosityLevel.INFOS ? Date.now() : 0;
                                page.extractTextContent({
                                    handler: handler,
                                    task: task,
                                    sink: sink,
                                    includeMarkedContent: includeMarkedContent,
                                    disableNormalization: disableNormalization
                                }).then(function() {
                                    finishWorkerTask(task);
                                    if (start) (0, _util.info)(`page=${pageIndex + 1} - getTextContent: time=` + `${Date.now() - start}ms`);
                                    sink.close();
                                }, function(reason) {
                                    finishWorkerTask(task);
                                    if (task.terminated) return;
                                    sink.error(reason);
                                });
                            });
                        });
                        handler.on("GetStructTree", function(data) {
                            return pdfManager.getPage(data.pageIndex).then(function(page) {
                                return pdfManager.ensure(page, "getStructTree");
                            });
                        });
                        handler.on("FontFallback", function(data) {
                            return pdfManager.fontFallback(data.id, handler);
                        });
                        handler.on("Cleanup", function(data) {
                            return pdfManager.cleanup(true);
                        });
                        handler.on("Terminate", function(data) {
                            terminated = true;
                            const waitOn = [];
                            if (pdfManager) {
                                pdfManager.terminate(new _util.AbortException("Worker was terminated."));
                                const cleanupPromise = pdfManager.cleanup();
                                waitOn.push(cleanupPromise);
                                pdfManager = null;
                            } else (0, _cleanup_helper.clearGlobalCaches)();
                            if (cancelXHRs) cancelXHRs(new _util.AbortException("Worker was terminated."));
                            for (const task of WorkerTasks){
                                waitOn.push(task.finished);
                                task.terminate();
                            }
                            return Promise.all(waitOn).then(function() {
                                handler.destroy();
                                handler = null;
                            });
                        });
                        handler.on("Ready", function(data) {
                            setupDoc(docParams);
                            docParams = null;
                        });
                        return workerHandlerName;
                    }
                    static initializeFromPort(port) {
                        const handler = new _message_handler.MessageHandler("worker", "main", port);
                        WorkerMessageHandler.setup(handler, port);
                        handler.send("ready", null);
                    }
                }
                exports.WorkerMessageHandler = WorkerMessageHandler;
                function isMessagePort(maybePort) {
                    return typeof maybePort.postMessage === "function" && "onmessage" in maybePort;
                }
                if (typeof window === "undefined" && !_util.isNodeJS && typeof self !== "undefined" && isMessagePort(self)) WorkerMessageHandler.initializeFromPort(self);
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.getModificationDate = getModificationDate;
                exports.getUuid = getUuid;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isNodeJS = void 0;
                exports.normalizeUnicode = normalizeUnicode;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                const isNodeJS = typeof $hIXGI === "object" && $hIXGI + "" === "[object process]" && !$hIXGI.versions.nw && !($hIXGI.versions.electron && $hIXGI.type && $hIXGI.type !== "browser");
                exports.isNodeJS = isNodeJS;
                const IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                const FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                const MAX_IMAGE_SIZE_TO_CACHE = 10e6;
                exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
                const LINE_FACTOR = 1.35;
                exports.LINE_FACTOR = LINE_FACTOR;
                const LINE_DESCENT_FACTOR = 0.35;
                exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
                const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
                exports.BASELINE_FACTOR = BASELINE_FACTOR;
                const RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                const AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                const AnnotationEditorPrefix = "pdfjs_internal_editor_";
                exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
                const AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports.AnnotationEditorType = AnnotationEditorType;
                const AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
                const PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                const TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                const ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                const AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                const AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                const AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                const AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                const AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                const AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                const DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                const PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                const VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                const CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                exports.CMapCompressionType = CMapCompressionType;
                const OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                const PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                let verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function _isValidProtocol(url) {
                    switch(url?.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url, baseUrl = null, options = null) {
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                const dots = url.match(/\./g);
                                if (dots?.length >= 2) url = `http://${url}`;
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch  {}
                        }
                        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch  {}
                    return null;
                }
                function shadow(obj, prop, value, nonSerializable = false) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: !nonSerializable,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                const BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                class PasswordException extends BaseException {
                    constructor(msg, code){
                        super(msg, "PasswordException");
                        this.code = code;
                    }
                }
                exports.PasswordException = PasswordException;
                class UnknownErrorException extends BaseException {
                    constructor(msg, details){
                        super(msg, "UnknownErrorException");
                        this.details = details;
                    }
                }
                exports.UnknownErrorException = UnknownErrorException;
                class InvalidPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "InvalidPDFException");
                    }
                }
                exports.InvalidPDFException = InvalidPDFException;
                class MissingPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "MissingPDFException");
                    }
                }
                exports.MissingPDFException = MissingPDFException;
                class UnexpectedResponseException extends BaseException {
                    constructor(msg, status){
                        super(msg, "UnexpectedResponseException");
                        this.status = status;
                    }
                }
                exports.UnexpectedResponseException = UnexpectedResponseException;
                class FormatError extends BaseException {
                    constructor(msg){
                        super(msg, "FormatError");
                    }
                }
                exports.FormatError = FormatError;
                class AbortException extends BaseException {
                    constructor(msg){
                        super(msg, "AbortException");
                    }
                }
                exports.AbortException = AbortException;
                function bytesToString(bytes) {
                    if (typeof bytes !== "object" || bytes?.length === undefined) unreachable("Invalid argument for bytesToString");
                    const length = bytes.length;
                    const MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    const strBuf = [];
                    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        const chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    if (typeof str !== "string") unreachable("Invalid argument for stringToBytes");
                    const length = str.length;
                    const bytes = new Uint8Array(length);
                    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    const obj = Object.create(null);
                    for (const [key, value] of map)obj[key] = value;
                    return obj;
                }
                function isLittleEndian() {
                    const buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch  {
                        return false;
                    }
                }
                class FeatureTest {
                    static get isLittleEndian() {
                        return shadow(this, "isLittleEndian", isLittleEndian());
                    }
                    static get isEvalSupported() {
                        return shadow(this, "isEvalSupported", isEvalSupported());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                    }
                    static get platform() {
                        if (typeof navigator === "undefined") return shadow(this, "platform", {
                            isWin: false,
                            isMac: false
                        });
                        return shadow(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                    }
                }
                exports.FeatureTest = FeatureTest;
                const hexNumbers = [
                    ...Array(256).keys()
                ].map((n)=>n.toString(16).padStart(2, "0"));
                class Util {
                    static makeHexColor(r, g, b) {
                        return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
                    }
                    static scaleMinMax(transform, minMax) {
                        let temp;
                        if (transform[0]) {
                            if (transform[0] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[0];
                            minMax[1] *= transform[0];
                            if (transform[3] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[3];
                            minMax[3] *= transform[3];
                        } else {
                            temp = minMax[0];
                            minMax[0] = minMax[2];
                            minMax[2] = temp;
                            temp = minMax[1];
                            minMax[1] = minMax[3];
                            minMax[3] = temp;
                            if (transform[1] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[1];
                            minMax[3] *= transform[1];
                            if (transform[2] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[2];
                            minMax[1] *= transform[2];
                        }
                        minMax[0] += transform[4];
                        minMax[1] += transform[4];
                        minMax[2] += transform[5];
                        minMax[3] += transform[5];
                    }
                    static transform(m1, m2) {
                        return [
                            m1[0] * m2[0] + m1[2] * m2[1],
                            m1[1] * m2[0] + m1[3] * m2[1],
                            m1[0] * m2[2] + m1[2] * m2[3],
                            m1[1] * m2[2] + m1[3] * m2[3],
                            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                        ];
                    }
                    static applyTransform(p, m) {
                        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                        return [
                            xt,
                            yt
                        ];
                    }
                    static applyInverseTransform(p, m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                        return [
                            xt,
                            yt
                        ];
                    }
                    static getAxialAlignedBoundingBox(r, m) {
                        const p1 = this.applyTransform(r, m);
                        const p2 = this.applyTransform(r.slice(2, 4), m);
                        const p3 = this.applyTransform([
                            r[0],
                            r[3]
                        ], m);
                        const p4 = this.applyTransform([
                            r[2],
                            r[1]
                        ], m);
                        return [
                            Math.min(p1[0], p2[0], p3[0], p4[0]),
                            Math.min(p1[1], p2[1], p3[1], p4[1]),
                            Math.max(p1[0], p2[0], p3[0], p4[0]),
                            Math.max(p1[1], p2[1], p3[1], p4[1])
                        ];
                    }
                    static inverseTransform(m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / d,
                            -m[1] / d,
                            -m[2] / d,
                            m[0] / d,
                            (m[2] * m[5] - m[4] * m[3]) / d,
                            (m[4] * m[1] - m[5] * m[0]) / d
                        ];
                    }
                    static singularValueDecompose2dScale(m) {
                        const transpose = [
                            m[0],
                            m[2],
                            m[1],
                            m[3]
                        ];
                        const a = m[0] * transpose[0] + m[1] * transpose[2];
                        const b = m[0] * transpose[1] + m[1] * transpose[3];
                        const c = m[2] * transpose[0] + m[3] * transpose[2];
                        const d = m[2] * transpose[1] + m[3] * transpose[3];
                        const first = (a + d) / 2;
                        const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                        const sx = first + second || 1;
                        const sy = first - second || 1;
                        return [
                            Math.sqrt(sx),
                            Math.sqrt(sy)
                        ];
                    }
                    static normalizeRect(rect) {
                        const r = rect.slice(0);
                        if (rect[0] > rect[2]) {
                            r[0] = rect[2];
                            r[2] = rect[0];
                        }
                        if (rect[1] > rect[3]) {
                            r[1] = rect[3];
                            r[3] = rect[1];
                        }
                        return r;
                    }
                    static intersect(rect1, rect2) {
                        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                        if (xLow > xHigh) return null;
                        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                        if (yLow > yHigh) return null;
                        return [
                            xLow,
                            yLow,
                            xHigh,
                            yHigh
                        ];
                    }
                    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                        const tvalues = [], bounds = [
                            [],
                            []
                        ];
                        let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                        for(let i = 0; i < 2; ++i){
                            if (i === 0) {
                                b = 6 * x0 - 12 * x1 + 6 * x2;
                                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                c = 3 * x1 - 3 * x0;
                            } else {
                                b = 6 * y0 - 12 * y1 + 6 * y2;
                                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                c = 3 * y1 - 3 * y0;
                            }
                            if (Math.abs(a) < 1e-12) {
                                if (Math.abs(b) < 1e-12) continue;
                                t = -c / b;
                                if (0 < t && t < 1) tvalues.push(t);
                                continue;
                            }
                            b2ac = b * b - 4 * c * a;
                            sqrtb2ac = Math.sqrt(b2ac);
                            if (b2ac < 0) continue;
                            t1 = (-b + sqrtb2ac) / (2 * a);
                            if (0 < t1 && t1 < 1) tvalues.push(t1);
                            t2 = (-b - sqrtb2ac) / (2 * a);
                            if (0 < t2 && t2 < 1) tvalues.push(t2);
                        }
                        let j = tvalues.length, mt;
                        const jlen = j;
                        while(j--){
                            t = tvalues[j];
                            mt = 1 - t;
                            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                        }
                        bounds[0][jlen] = x0;
                        bounds[1][jlen] = y0;
                        bounds[0][jlen + 1] = x3;
                        bounds[1][jlen + 1] = y3;
                        bounds[0].length = bounds[1].length = jlen + 2;
                        return [
                            Math.min(...bounds[0]),
                            Math.min(...bounds[1]),
                            Math.max(...bounds[0]),
                            Math.max(...bounds[1])
                        ];
                    }
                }
                exports.Util = Util;
                const PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    if (str[0] >= "\xef") {
                        let encoding;
                        if (str[0] === "\xfe" && str[1] === "\xff") encoding = "utf-16be";
                        else if (str[0] === "\xff" && str[1] === "\xfe") encoding = "utf-16le";
                        else if (str[0] === "\xef" && str[1] === "\xbb" && str[2] === "\xbf") encoding = "utf-8";
                        if (encoding) try {
                            const decoder = new TextDecoder(encoding, {
                                fatal: true
                            });
                            const buffer = stringToBytes(str);
                            return decoder.decode(buffer);
                        } catch (ex) {
                            warn(`stringToPDFString: "${ex}".`);
                        }
                    }
                    const strBuf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && v?.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(let i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate(date = new Date()) {
                    const buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                class PromiseCapability {
                    #settled = false;
                    constructor(){
                        this.promise = new Promise((resolve, reject)=>{
                            this.resolve = (data)=>{
                                this.#settled = true;
                                resolve(data);
                            };
                            this.reject = (reason)=>{
                                this.#settled = true;
                                reject(reason);
                            };
                        });
                    }
                    get settled() {
                        return this.#settled;
                    }
                }
                exports.PromiseCapability = PromiseCapability;
                let NormalizeRegex = null;
                let NormalizationMap = null;
                function normalizeUnicode(str) {
                    if (!NormalizeRegex) {
                        NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                        NormalizationMap = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str.replaceAll(NormalizeRegex, (_, p1, p2)=>{
                        return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                    });
                }
                function getUuid() {
                    if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") return crypto.randomUUID();
                    const buf = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") crypto.getRandomValues(buf);
                    else for(let i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
                    return bytesToString(buf);
                }
                const AnnotationPrefix = "pdfjs_internal_id_";
                exports.AnnotationPrefix = AnnotationPrefix;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XRefParseException = exports.XRefEntryException = exports.ParserEOFException = exports.PDF_VERSION_REGEXP = exports.MissingDataException = void 0;
                exports.arrayBuffersToBytes = arrayBuffersToBytes;
                exports.collectActions = collectActions;
                exports.encodeToXmlString = encodeToXmlString;
                exports.escapePDFName = escapePDFName;
                exports.escapeString = escapeString;
                exports.getInheritableProperty = getInheritableProperty;
                exports.getLookupTableFactory = getLookupTableFactory;
                exports.getNewAnnotationsMap = getNewAnnotationsMap;
                exports.getRotationMatrix = getRotationMatrix;
                exports.isAscii = isAscii;
                exports.isWhiteSpace = isWhiteSpace;
                exports.log2 = log2;
                exports.numberToString = numberToString;
                exports.parseXFAPath = parseXFAPath;
                exports.readInt8 = readInt8;
                exports.readUint16 = readUint16;
                exports.readUint32 = readUint32;
                exports.recoverJsURL = recoverJsURL;
                exports.stringToUTF16HexString = stringToUTF16HexString;
                exports.stringToUTF16String = stringToUTF16String;
                exports.toRomanNumerals = toRomanNumerals;
                exports.validateCSSFont = validateCSSFont;
                exports.validateFontName = validateFontName;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _base_stream = __w_pdfjs_require__(5);
                const PDF_VERSION_REGEXP = /^[1-9]\.\d$/;
                exports.PDF_VERSION_REGEXP = PDF_VERSION_REGEXP;
                function getLookupTableFactory(initializer) {
                    let lookup;
                    return function() {
                        if (initializer) {
                            lookup = Object.create(null);
                            initializer(lookup);
                            initializer = null;
                        }
                        return lookup;
                    };
                }
                class MissingDataException extends _util.BaseException {
                    constructor(begin, end){
                        super(`Missing data [${begin}, ${end})`, "MissingDataException");
                        this.begin = begin;
                        this.end = end;
                    }
                }
                exports.MissingDataException = MissingDataException;
                class ParserEOFException extends _util.BaseException {
                    constructor(msg){
                        super(msg, "ParserEOFException");
                    }
                }
                exports.ParserEOFException = ParserEOFException;
                class XRefEntryException extends _util.BaseException {
                    constructor(msg){
                        super(msg, "XRefEntryException");
                    }
                }
                exports.XRefEntryException = XRefEntryException;
                class XRefParseException extends _util.BaseException {
                    constructor(msg){
                        super(msg, "XRefParseException");
                    }
                }
                exports.XRefParseException = XRefParseException;
                function arrayBuffersToBytes(arr) {
                    const length = arr.length;
                    if (length === 0) return new Uint8Array(0);
                    if (length === 1) return new Uint8Array(arr[0]);
                    let dataLength = 0;
                    for(let i = 0; i < length; i++)dataLength += arr[i].byteLength;
                    const data = new Uint8Array(dataLength);
                    let pos = 0;
                    for(let i = 0; i < length; i++){
                        const item = new Uint8Array(arr[i]);
                        data.set(item, pos);
                        pos += item.byteLength;
                    }
                    return data;
                }
                function getInheritableProperty({ dict: dict, key: key, getArray: getArray = false, stopWhenFound: stopWhenFound = true }) {
                    let values;
                    const visited = new _primitives.RefSet();
                    while(dict instanceof _primitives.Dict && !(dict.objId && visited.has(dict.objId))){
                        if (dict.objId) visited.put(dict.objId);
                        const value = getArray ? dict.getArray(key) : dict.get(key);
                        if (value !== undefined) {
                            if (stopWhenFound) return value;
                            (values ||= []).push(value);
                        }
                        dict = dict.get("Parent");
                    }
                    return values;
                }
                const ROMAN_NUMBER_MAP = [
                    "",
                    "C",
                    "CC",
                    "CCC",
                    "CD",
                    "D",
                    "DC",
                    "DCC",
                    "DCCC",
                    "CM",
                    "",
                    "X",
                    "XX",
                    "XXX",
                    "XL",
                    "L",
                    "LX",
                    "LXX",
                    "LXXX",
                    "XC",
                    "",
                    "I",
                    "II",
                    "III",
                    "IV",
                    "V",
                    "VI",
                    "VII",
                    "VIII",
                    "IX"
                ];
                function toRomanNumerals(number, lowerCase = false) {
                    (0, _util.assert)(Number.isInteger(number) && number > 0, "The number should be a positive integer.");
                    const romanBuf = [];
                    let pos;
                    while(number >= 1000){
                        number -= 1000;
                        romanBuf.push("M");
                    }
                    pos = number / 100 | 0;
                    number %= 100;
                    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
                    pos = number / 10 | 0;
                    number %= 10;
                    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
                    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
                    const romanStr = romanBuf.join("");
                    return lowerCase ? romanStr.toLowerCase() : romanStr;
                }
                function log2(x) {
                    if (x <= 0) return 0;
                    return Math.ceil(Math.log2(x));
                }
                function readInt8(data, offset) {
                    return data[offset] << 24 >> 24;
                }
                function readUint16(data, offset) {
                    return data[offset] << 8 | data[offset + 1];
                }
                function readUint32(data, offset) {
                    return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
                }
                function isWhiteSpace(ch) {
                    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
                }
                function parseXFAPath(path) {
                    const positionPattern = /(.+)\[(\d+)\]$/;
                    return path.split(".").map((component)=>{
                        const m = component.match(positionPattern);
                        if (m) return {
                            name: m[1],
                            pos: parseInt(m[2], 10)
                        };
                        return {
                            name: component,
                            pos: 0
                        };
                    });
                }
                function escapePDFName(str) {
                    const buffer = [];
                    let start = 0;
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.charCodeAt(i);
                        if (char < 0x21 || char > 0x7e || char === 0x23 || char === 0x28 || char === 0x29 || char === 0x3c || char === 0x3e || char === 0x5b || char === 0x5d || char === 0x7b || char === 0x7d || char === 0x2f || char === 0x25) {
                            if (start < i) buffer.push(str.substring(start, i));
                            buffer.push(`#${char.toString(16)}`);
                            start = i + 1;
                        }
                    }
                    if (buffer.length === 0) return str;
                    if (start < str.length) buffer.push(str.substring(start, str.length));
                    return buffer.join("");
                }
                function escapeString(str) {
                    return str.replaceAll(/([()\\\n\r])/g, (match)=>{
                        if (match === "\n") return "\\n";
                        else if (match === "\r") return "\\r";
                        return `\\${match}`;
                    });
                }
                function _collectJS(entry, xref, list, parents) {
                    if (!entry) return;
                    let parent = null;
                    if (entry instanceof _primitives.Ref) {
                        if (parents.has(entry)) return;
                        parent = entry;
                        parents.put(parent);
                        entry = xref.fetch(entry);
                    }
                    if (Array.isArray(entry)) for (const element of entry)_collectJS(element, xref, list, parents);
                    else if (entry instanceof _primitives.Dict) {
                        if ((0, _primitives.isName)(entry.get("S"), "JavaScript")) {
                            const js = entry.get("JS");
                            let code;
                            if (js instanceof _base_stream.BaseStream) code = js.getString();
                            else if (typeof js === "string") code = js;
                            code &&= (0, _util.stringToPDFString)(code).replaceAll("\0", "");
                            if (code) list.push(code);
                        }
                        _collectJS(entry.getRaw("Next"), xref, list, parents);
                    }
                    if (parent) parents.remove(parent);
                }
                function collectActions(xref, dict, eventType) {
                    const actions = Object.create(null);
                    const additionalActionsDicts = getInheritableProperty({
                        dict: dict,
                        key: "AA",
                        stopWhenFound: false
                    });
                    if (additionalActionsDicts) for(let i = additionalActionsDicts.length - 1; i >= 0; i--){
                        const additionalActions = additionalActionsDicts[i];
                        if (!(additionalActions instanceof _primitives.Dict)) continue;
                        for (const key of additionalActions.getKeys()){
                            const action = eventType[key];
                            if (!action) continue;
                            const actionDict = additionalActions.getRaw(key);
                            const parents = new _primitives.RefSet();
                            const list = [];
                            _collectJS(actionDict, xref, list, parents);
                            if (list.length > 0) actions[action] = list;
                        }
                    }
                    if (dict.has("A")) {
                        const actionDict = dict.get("A");
                        const parents = new _primitives.RefSet();
                        const list = [];
                        _collectJS(actionDict, xref, list, parents);
                        if (list.length > 0) actions.Action = list;
                    }
                    return (0, _util.objectSize)(actions) > 0 ? actions : null;
                }
                const XMLEntities = {
                    0x3c: "&lt;",
                    0x3e: "&gt;",
                    0x26: "&amp;",
                    0x22: "&quot;",
                    0x27: "&apos;"
                };
                function encodeToXmlString(str) {
                    const buffer = [];
                    let start = 0;
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.codePointAt(i);
                        if (0x20 <= char && char <= 0x7e) {
                            const entity = XMLEntities[char];
                            if (entity) {
                                if (start < i) buffer.push(str.substring(start, i));
                                buffer.push(entity);
                                start = i + 1;
                            }
                        } else {
                            if (start < i) buffer.push(str.substring(start, i));
                            buffer.push(`&#x${char.toString(16).toUpperCase()};`);
                            if (char > 0xd7ff && (char < 0xe000 || char > 0xfffd)) i++;
                            start = i + 1;
                        }
                    }
                    if (buffer.length === 0) return str;
                    if (start < str.length) buffer.push(str.substring(start, str.length));
                    return buffer.join("");
                }
                function validateFontName(fontFamily, mustWarn = false) {
                    const m = /^("|').*("|')$/.exec(fontFamily);
                    if (m && m[1] === m[2]) {
                        const re = new RegExp(`[^\\\\]${m[1]}`);
                        if (re.test(fontFamily.slice(1, -1))) {
                            if (mustWarn) (0, _util.warn)(`FontFamily contains unescaped ${m[1]}: ${fontFamily}.`);
                            return false;
                        }
                    } else {
                        for (const ident of fontFamily.split(/[ \t]+/))if (/^(\d|(-(\d|-)))/.test(ident) || !/^[\w-\\]+$/.test(ident)) {
                            if (mustWarn) (0, _util.warn)(`FontFamily contains invalid <custom-ident>: ${fontFamily}.`);
                            return false;
                        }
                    }
                    return true;
                }
                function validateCSSFont(cssFontInfo) {
                    const DEFAULT_CSS_FONT_OBLIQUE = "14";
                    const DEFAULT_CSS_FONT_WEIGHT = "400";
                    const CSS_FONT_WEIGHT_VALUES = new Set([
                        "100",
                        "200",
                        "300",
                        "400",
                        "500",
                        "600",
                        "700",
                        "800",
                        "900",
                        "1000",
                        "normal",
                        "bold",
                        "bolder",
                        "lighter"
                    ]);
                    const { fontFamily: fontFamily, fontWeight: fontWeight, italicAngle: italicAngle } = cssFontInfo;
                    if (!validateFontName(fontFamily, true)) return false;
                    const weight = fontWeight ? fontWeight.toString() : "";
                    cssFontInfo.fontWeight = CSS_FONT_WEIGHT_VALUES.has(weight) ? weight : DEFAULT_CSS_FONT_WEIGHT;
                    const angle = parseFloat(italicAngle);
                    cssFontInfo.italicAngle = isNaN(angle) || angle < -90 || angle > 90 ? DEFAULT_CSS_FONT_OBLIQUE : italicAngle.toString();
                    return true;
                }
                function recoverJsURL(str) {
                    const URL_OPEN_METHODS = [
                        "app.launchURL",
                        "window.open",
                        "xfa.host.gotoURL"
                    ];
                    const regex = new RegExp("^\\s*(" + URL_OPEN_METHODS.join("|").replaceAll(".", "\\.") + ")\\((?:'|\")([^'\"]*)(?:'|\")(?:,\\s*(\\w+)\\)|\\))", "i");
                    const jsUrl = regex.exec(str);
                    if (jsUrl?.[2]) {
                        const url = jsUrl[2];
                        let newWindow = false;
                        if (jsUrl[3] === "true" && jsUrl[1] === "app.launchURL") newWindow = true;
                        return {
                            url: url,
                            newWindow: newWindow
                        };
                    }
                    return null;
                }
                function numberToString(value) {
                    if (Number.isInteger(value)) return value.toString();
                    const roundedValue = Math.round(value * 100);
                    if (roundedValue % 100 === 0) return (roundedValue / 100).toString();
                    if (roundedValue % 10 === 0) return value.toFixed(1);
                    return value.toFixed(2);
                }
                function getNewAnnotationsMap(annotationStorage) {
                    if (!annotationStorage) return null;
                    const newAnnotationsByPage = new Map();
                    for (const [key, value] of annotationStorage){
                        if (!key.startsWith(_util.AnnotationEditorPrefix)) continue;
                        let annotations = newAnnotationsByPage.get(value.pageIndex);
                        if (!annotations) {
                            annotations = [];
                            newAnnotationsByPage.set(value.pageIndex, annotations);
                        }
                        annotations.push(value);
                    }
                    return newAnnotationsByPage.size > 0 ? newAnnotationsByPage : null;
                }
                function isAscii(str) {
                    return /^[\x00-\x7F]*$/.test(str);
                }
                function stringToUTF16HexString(str) {
                    const buf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.charCodeAt(i);
                        buf.push((char >> 8 & 0xff).toString(16).padStart(2, "0"), (char & 0xff).toString(16).padStart(2, "0"));
                    }
                    return buf.join("");
                }
                function stringToUTF16String(str, bigEndian = false) {
                    const buf = [];
                    if (bigEndian) buf.push("\xfe\xff");
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.charCodeAt(i);
                        buf.push(String.fromCharCode(char >> 8 & 0xff), String.fromCharCode(char & 0xff));
                    }
                    return buf.join("");
                }
                function getRotationMatrix(rotation, width, height) {
                    switch(rotation){
                        case 90:
                            return [
                                0,
                                1,
                                -1,
                                0,
                                width,
                                0
                            ];
                        case 180:
                            return [
                                -1,
                                0,
                                0,
                                -1,
                                width,
                                height
                            ];
                        case 270:
                            return [
                                0,
                                -1,
                                1,
                                0,
                                0,
                                height
                            ];
                        default:
                            throw new Error("Invalid rotation");
                    }
                }
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RefSetCache = exports.RefSet = exports.Ref = exports.Name = exports.EOF = exports.Dict = exports.Cmd = exports.CIRCULAR_REF = void 0;
                exports.clearPrimitiveCaches = clearPrimitiveCaches;
                exports.isCmd = isCmd;
                exports.isDict = isDict;
                exports.isName = isName;
                exports.isRefsEqual = isRefsEqual;
                var _util = __w_pdfjs_require__(2);
                const CIRCULAR_REF = Symbol("CIRCULAR_REF");
                exports.CIRCULAR_REF = CIRCULAR_REF;
                const EOF = Symbol("EOF");
                exports.EOF = EOF;
                let CmdCache = Object.create(null);
                let NameCache = Object.create(null);
                let RefCache = Object.create(null);
                function clearPrimitiveCaches() {
                    CmdCache = Object.create(null);
                    NameCache = Object.create(null);
                    RefCache = Object.create(null);
                }
                class Name {
                    constructor(name){
                        this.name = name;
                    }
                    static get(name) {
                        return NameCache[name] ||= new Name(name);
                    }
                }
                exports.Name = Name;
                class Cmd {
                    constructor(cmd){
                        this.cmd = cmd;
                    }
                    static get(cmd) {
                        return CmdCache[cmd] ||= new Cmd(cmd);
                    }
                }
                exports.Cmd = Cmd;
                const nonSerializable = function nonSerializableClosure() {
                    return nonSerializable;
                };
                class Dict {
                    constructor(xref = null){
                        this._map = Object.create(null);
                        this.xref = xref;
                        this.objId = null;
                        this.suppressEncryption = false;
                        this.__nonSerializable__ = nonSerializable;
                    }
                    assignXref(newXref) {
                        this.xref = newXref;
                    }
                    get size() {
                        return Object.keys(this._map).length;
                    }
                    get(key1, key2, key3) {
                        let value = this._map[key1];
                        if (value === undefined && key2 !== undefined) {
                            value = this._map[key2];
                            if (value === undefined && key3 !== undefined) value = this._map[key3];
                        }
                        if (value instanceof Ref && this.xref) return this.xref.fetch(value, this.suppressEncryption);
                        return value;
                    }
                    async getAsync(key1, key2, key3) {
                        let value = this._map[key1];
                        if (value === undefined && key2 !== undefined) {
                            value = this._map[key2];
                            if (value === undefined && key3 !== undefined) value = this._map[key3];
                        }
                        if (value instanceof Ref && this.xref) return this.xref.fetchAsync(value, this.suppressEncryption);
                        return value;
                    }
                    getArray(key1, key2, key3) {
                        let value = this._map[key1];
                        if (value === undefined && key2 !== undefined) {
                            value = this._map[key2];
                            if (value === undefined && key3 !== undefined) value = this._map[key3];
                        }
                        if (value instanceof Ref && this.xref) value = this.xref.fetch(value, this.suppressEncryption);
                        if (Array.isArray(value)) {
                            value = value.slice();
                            for(let i = 0, ii = value.length; i < ii; i++)if (value[i] instanceof Ref && this.xref) value[i] = this.xref.fetch(value[i], this.suppressEncryption);
                        }
                        return value;
                    }
                    getRaw(key) {
                        return this._map[key];
                    }
                    getKeys() {
                        return Object.keys(this._map);
                    }
                    getRawValues() {
                        return Object.values(this._map);
                    }
                    set(key, value) {
                        this._map[key] = value;
                    }
                    has(key) {
                        return this._map[key] !== undefined;
                    }
                    forEach(callback) {
                        for(const key in this._map)callback(key, this.get(key));
                    }
                    static get empty() {
                        const emptyDict = new Dict(null);
                        emptyDict.set = (key, value)=>{
                            (0, _util.unreachable)("Should not call `set` on the empty dictionary.");
                        };
                        return (0, _util.shadow)(this, "empty", emptyDict);
                    }
                    static merge({ xref: xref, dictArray: dictArray, mergeSubDicts: mergeSubDicts = false }) {
                        const mergedDict = new Dict(xref), properties = new Map();
                        for (const dict of dictArray){
                            if (!(dict instanceof Dict)) continue;
                            for (const [key, value] of Object.entries(dict._map)){
                                let property = properties.get(key);
                                if (property === undefined) {
                                    property = [];
                                    properties.set(key, property);
                                } else if (!mergeSubDicts || !(value instanceof Dict)) continue;
                                property.push(value);
                            }
                        }
                        for (const [name, values] of properties){
                            if (values.length === 1 || !(values[0] instanceof Dict)) {
                                mergedDict._map[name] = values[0];
                                continue;
                            }
                            const subDict = new Dict(xref);
                            for (const dict of values){
                                for (const [key, value] of Object.entries(dict._map))if (subDict._map[key] === undefined) subDict._map[key] = value;
                            }
                            if (subDict.size > 0) mergedDict._map[name] = subDict;
                        }
                        properties.clear();
                        return mergedDict.size > 0 ? mergedDict : Dict.empty;
                    }
                    clone() {
                        const dict = new Dict(this.xref);
                        for (const key of this.getKeys())dict.set(key, this.getRaw(key));
                        return dict;
                    }
                }
                exports.Dict = Dict;
                class Ref {
                    constructor(num, gen){
                        this.num = num;
                        this.gen = gen;
                    }
                    toString() {
                        if (this.gen === 0) return `${this.num}R`;
                        return `${this.num}R${this.gen}`;
                    }
                    static fromString(str) {
                        const ref = RefCache[str];
                        if (ref) return ref;
                        const m = /^(\d+)R(\d*)$/.exec(str);
                        if (!m || m[1] === "0") return null;
                        return RefCache[str] = new Ref(parseInt(m[1]), !m[2] ? 0 : parseInt(m[2]));
                    }
                    static get(num, gen) {
                        const key = gen === 0 ? `${num}R` : `${num}R${gen}`;
                        return RefCache[key] ||= new Ref(num, gen);
                    }
                }
                exports.Ref = Ref;
                class RefSet {
                    constructor(parent = null){
                        this._set = new Set(parent?._set);
                    }
                    has(ref) {
                        return this._set.has(ref.toString());
                    }
                    put(ref) {
                        this._set.add(ref.toString());
                    }
                    remove(ref) {
                        this._set.delete(ref.toString());
                    }
                    [Symbol.iterator]() {
                        return this._set.values();
                    }
                    clear() {
                        this._set.clear();
                    }
                }
                exports.RefSet = RefSet;
                class RefSetCache {
                    constructor(){
                        this._map = new Map();
                    }
                    get size() {
                        return this._map.size;
                    }
                    get(ref) {
                        return this._map.get(ref.toString());
                    }
                    has(ref) {
                        return this._map.has(ref.toString());
                    }
                    put(ref, obj) {
                        this._map.set(ref.toString(), obj);
                    }
                    putAlias(ref, aliasRef) {
                        this._map.set(ref.toString(), this.get(aliasRef));
                    }
                    [Symbol.iterator]() {
                        return this._map.values();
                    }
                    clear() {
                        this._map.clear();
                    }
                }
                exports.RefSetCache = RefSetCache;
                function isName(v, name) {
                    return v instanceof Name && (name === undefined || v.name === name);
                }
                function isCmd(v, cmd) {
                    return v instanceof Cmd && (cmd === undefined || v.cmd === cmd);
                }
                function isDict(v, type) {
                    return v instanceof Dict && (type === undefined || isName(v.get("Type"), type));
                }
                function isRefsEqual(v1, v2) {
                    return v1.num === v2.num && v1.gen === v2.gen;
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStream = void 0;
                var _util = __w_pdfjs_require__(2);
                class BaseStream {
                    constructor(){
                        if (this.constructor === BaseStream) (0, _util.unreachable)("Cannot initialize BaseStream.");
                    }
                    get length() {
                        (0, _util.unreachable)("Abstract getter `length` accessed");
                    }
                    get isEmpty() {
                        (0, _util.unreachable)("Abstract getter `isEmpty` accessed");
                    }
                    get isDataLoaded() {
                        return (0, _util.shadow)(this, "isDataLoaded", true);
                    }
                    getByte() {
                        (0, _util.unreachable)("Abstract method `getByte` called");
                    }
                    getBytes(length) {
                        (0, _util.unreachable)("Abstract method `getBytes` called");
                    }
                    peekByte() {
                        const peekedByte = this.getByte();
                        if (peekedByte !== -1) this.pos--;
                        return peekedByte;
                    }
                    peekBytes(length) {
                        const bytes = this.getBytes(length);
                        this.pos -= bytes.length;
                        return bytes;
                    }
                    getUint16() {
                        const b0 = this.getByte();
                        const b1 = this.getByte();
                        if (b0 === -1 || b1 === -1) return -1;
                        return (b0 << 8) + b1;
                    }
                    getInt32() {
                        const b0 = this.getByte();
                        const b1 = this.getByte();
                        const b2 = this.getByte();
                        const b3 = this.getByte();
                        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
                    }
                    getByteRange(begin, end) {
                        (0, _util.unreachable)("Abstract method `getByteRange` called");
                    }
                    getString(length) {
                        return (0, _util.bytesToString)(this.getBytes(length));
                    }
                    skip(n) {
                        this.pos += n || 1;
                    }
                    reset() {
                        (0, _util.unreachable)("Abstract method `reset` called");
                    }
                    moveStart() {
                        (0, _util.unreachable)("Abstract method `moveStart` called");
                    }
                    makeSubStream(start, length, dict = null) {
                        (0, _util.unreachable)("Abstract method `makeSubStream` called");
                    }
                    getBaseStreams() {
                        return null;
                    }
                }
                exports.BaseStream = BaseStream;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NetworkPdfManager = exports.LocalPdfManager = void 0;
                var _util = __w_pdfjs_require__(2);
                var _chunked_stream = __w_pdfjs_require__(7);
                var _core_utils = __w_pdfjs_require__(3);
                var _document = __w_pdfjs_require__(9);
                var _stream = __w_pdfjs_require__(8);
                function parseDocBaseUrl(url) {
                    if (url) {
                        const absoluteUrl = (0, _util.createValidAbsoluteUrl)(url);
                        if (absoluteUrl) return absoluteUrl.href;
                        (0, _util.warn)(`Invalid absolute docBaseUrl: "${url}".`);
                    }
                    return null;
                }
                class BasePdfManager {
                    constructor(args){
                        if (this.constructor === BasePdfManager) (0, _util.unreachable)("Cannot initialize BasePdfManager.");
                        this._docBaseUrl = parseDocBaseUrl(args.docBaseUrl);
                        this._docId = args.docId;
                        this._password = args.password;
                        this.enableXfa = args.enableXfa;
                        args.evaluatorOptions.isOffscreenCanvasSupported &&= _util.FeatureTest.isOffscreenCanvasSupported;
                        this.evaluatorOptions = args.evaluatorOptions;
                    }
                    get docId() {
                        return this._docId;
                    }
                    get password() {
                        return this._password;
                    }
                    get docBaseUrl() {
                        return this._docBaseUrl;
                    }
                    get catalog() {
                        return this.pdfDocument.catalog;
                    }
                    ensureDoc(prop, args) {
                        return this.ensure(this.pdfDocument, prop, args);
                    }
                    ensureXRef(prop, args) {
                        return this.ensure(this.pdfDocument.xref, prop, args);
                    }
                    ensureCatalog(prop, args) {
                        return this.ensure(this.pdfDocument.catalog, prop, args);
                    }
                    getPage(pageIndex) {
                        return this.pdfDocument.getPage(pageIndex);
                    }
                    fontFallback(id, handler) {
                        return this.pdfDocument.fontFallback(id, handler);
                    }
                    loadXfaFonts(handler, task) {
                        return this.pdfDocument.loadXfaFonts(handler, task);
                    }
                    loadXfaImages() {
                        return this.pdfDocument.loadXfaImages();
                    }
                    serializeXfaData(annotationStorage) {
                        return this.pdfDocument.serializeXfaData(annotationStorage);
                    }
                    cleanup(manuallyTriggered = false) {
                        return this.pdfDocument.cleanup(manuallyTriggered);
                    }
                    async ensure(obj, prop, args) {
                        (0, _util.unreachable)("Abstract method `ensure` called");
                    }
                    requestRange(begin, end) {
                        (0, _util.unreachable)("Abstract method `requestRange` called");
                    }
                    requestLoadedStream(noFetch = false) {
                        (0, _util.unreachable)("Abstract method `requestLoadedStream` called");
                    }
                    sendProgressiveData(chunk) {
                        (0, _util.unreachable)("Abstract method `sendProgressiveData` called");
                    }
                    updatePassword(password) {
                        this._password = password;
                    }
                    terminate(reason) {
                        (0, _util.unreachable)("Abstract method `terminate` called");
                    }
                }
                class LocalPdfManager extends BasePdfManager {
                    constructor(args){
                        super(args);
                        const stream = new _stream.Stream(args.source);
                        this.pdfDocument = new _document.PDFDocument(this, stream);
                        this._loadedStreamPromise = Promise.resolve(stream);
                    }
                    async ensure(obj, prop, args) {
                        const value = obj[prop];
                        if (typeof value === "function") return value.apply(obj, args);
                        return value;
                    }
                    requestRange(begin, end) {
                        return Promise.resolve();
                    }
                    requestLoadedStream(noFetch = false) {
                        return this._loadedStreamPromise;
                    }
                    terminate(reason) {}
                }
                exports.LocalPdfManager = LocalPdfManager;
                class NetworkPdfManager extends BasePdfManager {
                    constructor(args){
                        super(args);
                        this.streamManager = new _chunked_stream.ChunkedStreamManager(args.source, {
                            msgHandler: args.handler,
                            length: args.length,
                            disableAutoFetch: args.disableAutoFetch,
                            rangeChunkSize: args.rangeChunkSize
                        });
                        this.pdfDocument = new _document.PDFDocument(this, this.streamManager.getStream());
                    }
                    async ensure(obj, prop, args) {
                        try {
                            const value = obj[prop];
                            if (typeof value === "function") return value.apply(obj, args);
                            return value;
                        } catch (ex) {
                            if (!(ex instanceof _core_utils.MissingDataException)) throw ex;
                            await this.requestRange(ex.begin, ex.end);
                            return this.ensure(obj, prop, args);
                        }
                    }
                    requestRange(begin, end) {
                        return this.streamManager.requestRange(begin, end);
                    }
                    requestLoadedStream(noFetch = false) {
                        return this.streamManager.requestAllChunks(noFetch);
                    }
                    sendProgressiveData(chunk) {
                        this.streamManager.onReceiveData({
                            chunk: chunk
                        });
                    }
                    terminate(reason) {
                        this.streamManager.abort(reason);
                    }
                }
                exports.NetworkPdfManager = NetworkPdfManager;
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ChunkedStreamManager = exports.ChunkedStream = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                var _stream = __w_pdfjs_require__(8);
                class ChunkedStream extends _stream.Stream {
                    constructor(length, chunkSize, manager){
                        super(new Uint8Array(length), 0, length, null);
                        this.chunkSize = chunkSize;
                        this._loadedChunks = new Set();
                        this.numChunks = Math.ceil(length / chunkSize);
                        this.manager = manager;
                        this.progressiveDataLength = 0;
                        this.lastSuccessfulEnsureByteChunk = -1;
                    }
                    getMissingChunks() {
                        const chunks = [];
                        for(let chunk = 0, n = this.numChunks; chunk < n; ++chunk)if (!this._loadedChunks.has(chunk)) chunks.push(chunk);
                        return chunks;
                    }
                    get numChunksLoaded() {
                        return this._loadedChunks.size;
                    }
                    get isDataLoaded() {
                        return this.numChunksLoaded === this.numChunks;
                    }
                    onReceiveData(begin, chunk) {
                        const chunkSize = this.chunkSize;
                        if (begin % chunkSize !== 0) throw new Error(`Bad begin offset: ${begin}`);
                        const end = begin + chunk.byteLength;
                        if (end % chunkSize !== 0 && end !== this.bytes.length) throw new Error(`Bad end offset: ${end}`);
                        this.bytes.set(new Uint8Array(chunk), begin);
                        const beginChunk = Math.floor(begin / chunkSize);
                        const endChunk = Math.floor((end - 1) / chunkSize) + 1;
                        for(let curChunk = beginChunk; curChunk < endChunk; ++curChunk)this._loadedChunks.add(curChunk);
                    }
                    onReceiveProgressiveData(data) {
                        let position = this.progressiveDataLength;
                        const beginChunk = Math.floor(position / this.chunkSize);
                        this.bytes.set(new Uint8Array(data), position);
                        position += data.byteLength;
                        this.progressiveDataLength = position;
                        const endChunk = position >= this.end ? this.numChunks : Math.floor(position / this.chunkSize);
                        for(let curChunk = beginChunk; curChunk < endChunk; ++curChunk)this._loadedChunks.add(curChunk);
                    }
                    ensureByte(pos) {
                        if (pos < this.progressiveDataLength) return;
                        const chunk = Math.floor(pos / this.chunkSize);
                        if (chunk > this.numChunks) return;
                        if (chunk === this.lastSuccessfulEnsureByteChunk) return;
                        if (!this._loadedChunks.has(chunk)) throw new _core_utils.MissingDataException(pos, pos + 1);
                        this.lastSuccessfulEnsureByteChunk = chunk;
                    }
                    ensureRange(begin, end) {
                        if (begin >= end) return;
                        if (end <= this.progressiveDataLength) return;
                        const beginChunk = Math.floor(begin / this.chunkSize);
                        if (beginChunk > this.numChunks) return;
                        const endChunk = Math.min(Math.floor((end - 1) / this.chunkSize) + 1, this.numChunks);
                        for(let chunk = beginChunk; chunk < endChunk; ++chunk){
                            if (!this._loadedChunks.has(chunk)) throw new _core_utils.MissingDataException(begin, end);
                        }
                    }
                    nextEmptyChunk(beginChunk) {
                        const numChunks = this.numChunks;
                        for(let i = 0; i < numChunks; ++i){
                            const chunk = (beginChunk + i) % numChunks;
                            if (!this._loadedChunks.has(chunk)) return chunk;
                        }
                        return null;
                    }
                    hasChunk(chunk) {
                        return this._loadedChunks.has(chunk);
                    }
                    getByte() {
                        const pos = this.pos;
                        if (pos >= this.end) return -1;
                        if (pos >= this.progressiveDataLength) this.ensureByte(pos);
                        return this.bytes[this.pos++];
                    }
                    getBytes(length) {
                        const bytes = this.bytes;
                        const pos = this.pos;
                        const strEnd = this.end;
                        if (!length) {
                            if (strEnd > this.progressiveDataLength) this.ensureRange(pos, strEnd);
                            return bytes.subarray(pos, strEnd);
                        }
                        let end = pos + length;
                        if (end > strEnd) end = strEnd;
                        if (end > this.progressiveDataLength) this.ensureRange(pos, end);
                        this.pos = end;
                        return bytes.subarray(pos, end);
                    }
                    getByteRange(begin, end) {
                        if (begin < 0) begin = 0;
                        if (end > this.end) end = this.end;
                        if (end > this.progressiveDataLength) this.ensureRange(begin, end);
                        return this.bytes.subarray(begin, end);
                    }
                    makeSubStream(start, length, dict = null) {
                        if (length) {
                            if (start + length > this.progressiveDataLength) this.ensureRange(start, start + length);
                        } else if (start >= this.progressiveDataLength) this.ensureByte(start);
                        function ChunkedStreamSubstream() {}
                        ChunkedStreamSubstream.prototype = Object.create(this);
                        ChunkedStreamSubstream.prototype.getMissingChunks = function() {
                            const chunkSize = this.chunkSize;
                            const beginChunk = Math.floor(this.start / chunkSize);
                            const endChunk = Math.floor((this.end - 1) / chunkSize) + 1;
                            const missingChunks = [];
                            for(let chunk = beginChunk; chunk < endChunk; ++chunk)if (!this._loadedChunks.has(chunk)) missingChunks.push(chunk);
                            return missingChunks;
                        };
                        Object.defineProperty(ChunkedStreamSubstream.prototype, "isDataLoaded", {
                            get () {
                                if (this.numChunksLoaded === this.numChunks) return true;
                                return this.getMissingChunks().length === 0;
                            },
                            configurable: true
                        });
                        const subStream = new ChunkedStreamSubstream();
                        subStream.pos = subStream.start = start;
                        subStream.end = start + length || this.end;
                        subStream.dict = dict;
                        return subStream;
                    }
                    getBaseStreams() {
                        return [
                            this
                        ];
                    }
                }
                exports.ChunkedStream = ChunkedStream;
                class ChunkedStreamManager {
                    constructor(pdfNetworkStream, args){
                        this.length = args.length;
                        this.chunkSize = args.rangeChunkSize;
                        this.stream = new ChunkedStream(this.length, this.chunkSize, this);
                        this.pdfNetworkStream = pdfNetworkStream;
                        this.disableAutoFetch = args.disableAutoFetch;
                        this.msgHandler = args.msgHandler;
                        this.currRequestId = 0;
                        this._chunksNeededByRequest = new Map();
                        this._requestsByChunk = new Map();
                        this._promisesByRequest = new Map();
                        this.progressiveDataLength = 0;
                        this.aborted = false;
                        this._loadedStreamCapability = new _util.PromiseCapability();
                    }
                    sendRequest(begin, end) {
                        const rangeReader = this.pdfNetworkStream.getRangeReader(begin, end);
                        if (!rangeReader.isStreamingSupported) rangeReader.onProgress = this.onProgress.bind(this);
                        let chunks = [], loaded = 0;
                        return new Promise((resolve, reject)=>{
                            const readChunk = ({ value: value, done: done })=>{
                                try {
                                    if (done) {
                                        const chunkData = (0, _core_utils.arrayBuffersToBytes)(chunks);
                                        chunks = null;
                                        resolve(chunkData);
                                        return;
                                    }
                                    loaded += value.byteLength;
                                    if (rangeReader.isStreamingSupported) this.onProgress({
                                        loaded: loaded
                                    });
                                    chunks.push(value);
                                    rangeReader.read().then(readChunk, reject);
                                } catch (e) {
                                    reject(e);
                                }
                            };
                            rangeReader.read().then(readChunk, reject);
                        }).then((data)=>{
                            if (this.aborted) return;
                            this.onReceiveData({
                                chunk: data,
                                begin: begin
                            });
                        });
                    }
                    requestAllChunks(noFetch = false) {
                        if (!noFetch) {
                            const missingChunks = this.stream.getMissingChunks();
                            this._requestChunks(missingChunks);
                        }
                        return this._loadedStreamCapability.promise;
                    }
                    _requestChunks(chunks) {
                        const requestId = this.currRequestId++;
                        const chunksNeeded = new Set();
                        this._chunksNeededByRequest.set(requestId, chunksNeeded);
                        for (const chunk of chunks)if (!this.stream.hasChunk(chunk)) chunksNeeded.add(chunk);
                        if (chunksNeeded.size === 0) return Promise.resolve();
                        const capability = new _util.PromiseCapability();
                        this._promisesByRequest.set(requestId, capability);
                        const chunksToRequest = [];
                        for (const chunk of chunksNeeded){
                            let requestIds = this._requestsByChunk.get(chunk);
                            if (!requestIds) {
                                requestIds = [];
                                this._requestsByChunk.set(chunk, requestIds);
                                chunksToRequest.push(chunk);
                            }
                            requestIds.push(requestId);
                        }
                        if (chunksToRequest.length > 0) {
                            const groupedChunksToRequest = this.groupChunks(chunksToRequest);
                            for (const groupedChunk of groupedChunksToRequest){
                                const begin = groupedChunk.beginChunk * this.chunkSize;
                                const end = Math.min(groupedChunk.endChunk * this.chunkSize, this.length);
                                this.sendRequest(begin, end).catch(capability.reject);
                            }
                        }
                        return capability.promise.catch((reason)=>{
                            if (this.aborted) return;
                            throw reason;
                        });
                    }
                    getStream() {
                        return this.stream;
                    }
                    requestRange(begin, end) {
                        end = Math.min(end, this.length);
                        const beginChunk = this.getBeginChunk(begin);
                        const endChunk = this.getEndChunk(end);
                        const chunks = [];
                        for(let chunk = beginChunk; chunk < endChunk; ++chunk)chunks.push(chunk);
                        return this._requestChunks(chunks);
                    }
                    requestRanges(ranges = []) {
                        const chunksToRequest = [];
                        for (const range of ranges){
                            const beginChunk = this.getBeginChunk(range.begin);
                            const endChunk = this.getEndChunk(range.end);
                            for(let chunk = beginChunk; chunk < endChunk; ++chunk)if (!chunksToRequest.includes(chunk)) chunksToRequest.push(chunk);
                        }
                        chunksToRequest.sort(function(a, b) {
                            return a - b;
                        });
                        return this._requestChunks(chunksToRequest);
                    }
                    groupChunks(chunks) {
                        const groupedChunks = [];
                        let beginChunk = -1;
                        let prevChunk = -1;
                        for(let i = 0, ii = chunks.length; i < ii; ++i){
                            const chunk = chunks[i];
                            if (beginChunk < 0) beginChunk = chunk;
                            if (prevChunk >= 0 && prevChunk + 1 !== chunk) {
                                groupedChunks.push({
                                    beginChunk: beginChunk,
                                    endChunk: prevChunk + 1
                                });
                                beginChunk = chunk;
                            }
                            if (i + 1 === chunks.length) groupedChunks.push({
                                beginChunk: beginChunk,
                                endChunk: chunk + 1
                            });
                            prevChunk = chunk;
                        }
                        return groupedChunks;
                    }
                    onProgress(args) {
                        this.msgHandler.send("DocProgress", {
                            loaded: this.stream.numChunksLoaded * this.chunkSize + args.loaded,
                            total: this.length
                        });
                    }
                    onReceiveData(args) {
                        const chunk = args.chunk;
                        const isProgressive = args.begin === undefined;
                        const begin = isProgressive ? this.progressiveDataLength : args.begin;
                        const end = begin + chunk.byteLength;
                        const beginChunk = Math.floor(begin / this.chunkSize);
                        const endChunk = end < this.length ? Math.floor(end / this.chunkSize) : Math.ceil(end / this.chunkSize);
                        if (isProgressive) {
                            this.stream.onReceiveProgressiveData(chunk);
                            this.progressiveDataLength = end;
                        } else this.stream.onReceiveData(begin, chunk);
                        if (this.stream.isDataLoaded) this._loadedStreamCapability.resolve(this.stream);
                        const loadedRequests = [];
                        for(let curChunk = beginChunk; curChunk < endChunk; ++curChunk){
                            const requestIds = this._requestsByChunk.get(curChunk);
                            if (!requestIds) continue;
                            this._requestsByChunk.delete(curChunk);
                            for (const requestId of requestIds){
                                const chunksNeeded = this._chunksNeededByRequest.get(requestId);
                                if (chunksNeeded.has(curChunk)) chunksNeeded.delete(curChunk);
                                if (chunksNeeded.size > 0) continue;
                                loadedRequests.push(requestId);
                            }
                        }
                        if (!this.disableAutoFetch && this._requestsByChunk.size === 0) {
                            let nextEmptyChunk;
                            if (this.stream.numChunksLoaded === 1) {
                                const lastChunk = this.stream.numChunks - 1;
                                if (!this.stream.hasChunk(lastChunk)) nextEmptyChunk = lastChunk;
                            } else nextEmptyChunk = this.stream.nextEmptyChunk(endChunk);
                            if (Number.isInteger(nextEmptyChunk)) this._requestChunks([
                                nextEmptyChunk
                            ]);
                        }
                        for (const requestId of loadedRequests){
                            const capability = this._promisesByRequest.get(requestId);
                            this._promisesByRequest.delete(requestId);
                            capability.resolve();
                        }
                        this.msgHandler.send("DocProgress", {
                            loaded: this.stream.numChunksLoaded * this.chunkSize,
                            total: this.length
                        });
                    }
                    onError(err) {
                        this._loadedStreamCapability.reject(err);
                    }
                    getBeginChunk(begin) {
                        return Math.floor(begin / this.chunkSize);
                    }
                    getEndChunk(end) {
                        return Math.floor((end - 1) / this.chunkSize) + 1;
                    }
                    abort(reason) {
                        this.aborted = true;
                        this.pdfNetworkStream?.cancelAllRequests(reason);
                        for (const capability of this._promisesByRequest.values())capability.reject(reason);
                    }
                }
                exports.ChunkedStreamManager = ChunkedStreamManager;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StringStream = exports.Stream = exports.NullStream = void 0;
                var _base_stream = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(2);
                class Stream extends _base_stream.BaseStream {
                    constructor(arrayBuffer, start, length, dict){
                        super();
                        this.bytes = arrayBuffer instanceof Uint8Array ? arrayBuffer : new Uint8Array(arrayBuffer);
                        this.start = start || 0;
                        this.pos = this.start;
                        this.end = start + length || this.bytes.length;
                        this.dict = dict;
                    }
                    get length() {
                        return this.end - this.start;
                    }
                    get isEmpty() {
                        return this.length === 0;
                    }
                    getByte() {
                        if (this.pos >= this.end) return -1;
                        return this.bytes[this.pos++];
                    }
                    getBytes(length) {
                        const bytes = this.bytes;
                        const pos = this.pos;
                        const strEnd = this.end;
                        if (!length) return bytes.subarray(pos, strEnd);
                        let end = pos + length;
                        if (end > strEnd) end = strEnd;
                        this.pos = end;
                        return bytes.subarray(pos, end);
                    }
                    getByteRange(begin, end) {
                        if (begin < 0) begin = 0;
                        if (end > this.end) end = this.end;
                        return this.bytes.subarray(begin, end);
                    }
                    reset() {
                        this.pos = this.start;
                    }
                    moveStart() {
                        this.start = this.pos;
                    }
                    makeSubStream(start, length, dict = null) {
                        return new Stream(this.bytes.buffer, start, length, dict);
                    }
                }
                exports.Stream = Stream;
                class StringStream extends Stream {
                    constructor(str){
                        super((0, _util.stringToBytes)(str));
                    }
                }
                exports.StringStream = StringStream;
                class NullStream extends Stream {
                    constructor(){
                        super(new Uint8Array(0));
                    }
                }
                exports.NullStream = NullStream;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Page = exports.PDFDocument = void 0;
                var _util = __w_pdfjs_require__(2);
                var _annotation = __w_pdfjs_require__(10);
                var _core_utils = __w_pdfjs_require__(3);
                var _primitives = __w_pdfjs_require__(4);
                var _xfa_fonts = __w_pdfjs_require__(51);
                var _base_stream = __w_pdfjs_require__(5);
                var _crypto = __w_pdfjs_require__(74);
                var _catalog = __w_pdfjs_require__(66);
                var _cleanup_helper = __w_pdfjs_require__(68);
                var _dataset_reader = __w_pdfjs_require__(102);
                var _parser = __w_pdfjs_require__(16);
                var _stream = __w_pdfjs_require__(8);
                var _object_loader = __w_pdfjs_require__(76);
                var _operator_list = __w_pdfjs_require__(64);
                var _evaluator = __w_pdfjs_require__(13);
                var _decode_stream = __w_pdfjs_require__(18);
                var _struct_tree = __w_pdfjs_require__(72);
                var _writer = __w_pdfjs_require__(73);
                var _factory = __w_pdfjs_require__(77);
                var _xref = __w_pdfjs_require__(103);
                const DEFAULT_USER_UNIT = 1.0;
                const LETTER_SIZE_MEDIABOX = [
                    0,
                    0,
                    612,
                    792
                ];
                class Page {
                    constructor({ pdfManager: pdfManager, xref: xref, pageIndex: pageIndex, pageDict: pageDict, ref: ref, globalIdFactory: globalIdFactory, fontCache: fontCache, builtInCMapCache: builtInCMapCache, standardFontDataCache: standardFontDataCache, globalImageCache: globalImageCache, systemFontCache: systemFontCache, nonBlendModesSet: nonBlendModesSet, xfaFactory: xfaFactory }){
                        this.pdfManager = pdfManager;
                        this.pageIndex = pageIndex;
                        this.pageDict = pageDict;
                        this.xref = xref;
                        this.ref = ref;
                        this.fontCache = fontCache;
                        this.builtInCMapCache = builtInCMapCache;
                        this.standardFontDataCache = standardFontDataCache;
                        this.globalImageCache = globalImageCache;
                        this.systemFontCache = systemFontCache;
                        this.nonBlendModesSet = nonBlendModesSet;
                        this.evaluatorOptions = pdfManager.evaluatorOptions;
                        this.resourcesPromise = null;
                        this.xfaFactory = xfaFactory;
                        const idCounters = {
                            obj: 0
                        };
                        this._localIdFactory = class extends globalIdFactory {
                            static createObjId() {
                                return `p${pageIndex}_${++idCounters.obj}`;
                            }
                            static getPageObjId() {
                                return `p${ref.toString()}`;
                            }
                        };
                    }
                    _getInheritableProperty(key, getArray = false) {
                        const value = (0, _core_utils.getInheritableProperty)({
                            dict: this.pageDict,
                            key: key,
                            getArray: getArray,
                            stopWhenFound: false
                        });
                        if (!Array.isArray(value)) return value;
                        if (value.length === 1 || !(value[0] instanceof _primitives.Dict)) return value[0];
                        return _primitives.Dict.merge({
                            xref: this.xref,
                            dictArray: value
                        });
                    }
                    get content() {
                        return this.pageDict.getArray("Contents");
                    }
                    get resources() {
                        const resources = this._getInheritableProperty("Resources");
                        return (0, _util.shadow)(this, "resources", resources instanceof _primitives.Dict ? resources : _primitives.Dict.empty);
                    }
                    _getBoundingBox(name) {
                        if (this.xfaData) return this.xfaData.bbox;
                        let box = this._getInheritableProperty(name, true);
                        if (Array.isArray(box) && box.length === 4) {
                            box = _util.Util.normalizeRect(box);
                            if (box[2] - box[0] > 0 && box[3] - box[1] > 0) return box;
                            (0, _util.warn)(`Empty, or invalid, /${name} entry.`);
                        }
                        return null;
                    }
                    get mediaBox() {
                        return (0, _util.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || LETTER_SIZE_MEDIABOX);
                    }
                    get cropBox() {
                        return (0, _util.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
                    }
                    get userUnit() {
                        let obj = this.pageDict.get("UserUnit");
                        if (typeof obj !== "number" || obj <= 0) obj = DEFAULT_USER_UNIT;
                        return (0, _util.shadow)(this, "userUnit", obj);
                    }
                    get view() {
                        const { cropBox: cropBox, mediaBox: mediaBox } = this;
                        if (cropBox !== mediaBox && !(0, _util.isArrayEqual)(cropBox, mediaBox)) {
                            const box = _util.Util.intersect(cropBox, mediaBox);
                            if (box && box[2] - box[0] > 0 && box[3] - box[1] > 0) return (0, _util.shadow)(this, "view", box);
                            (0, _util.warn)("Empty /CropBox and /MediaBox intersection.");
                        }
                        return (0, _util.shadow)(this, "view", mediaBox);
                    }
                    get rotate() {
                        let rotate = this._getInheritableProperty("Rotate") || 0;
                        if (rotate % 90 !== 0) rotate = 0;
                        else if (rotate >= 360) rotate %= 360;
                        else if (rotate < 0) rotate = (rotate % 360 + 360) % 360;
                        return (0, _util.shadow)(this, "rotate", rotate);
                    }
                    _onSubStreamError(reason, objId) {
                        if (this.evaluatorOptions.ignoreErrors) {
                            (0, _util.warn)(`getContentStream - ignoring sub-stream (${objId}): "${reason}".`);
                            return;
                        }
                        throw reason;
                    }
                    getContentStream() {
                        return this.pdfManager.ensure(this, "content").then((content)=>{
                            if (content instanceof _base_stream.BaseStream) return content;
                            if (Array.isArray(content)) return new _decode_stream.StreamsSequenceStream(content, this._onSubStreamError.bind(this));
                            return new _stream.NullStream();
                        });
                    }
                    get xfaData() {
                        return (0, _util.shadow)(this, "xfaData", this.xfaFactory ? {
                            bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
                        } : null);
                    }
                    #replaceIdByRef(annotations, deletedAnnotations, existingAnnotations) {
                        for (const annotation of annotations)if (annotation.id) {
                            const ref = _primitives.Ref.fromString(annotation.id);
                            if (!ref) {
                                (0, _util.warn)(`A non-linked annotation cannot be modified: ${annotation.id}`);
                                continue;
                            }
                            if (annotation.deleted) {
                                deletedAnnotations.put(ref);
                                continue;
                            }
                            existingAnnotations?.put(ref);
                            annotation.ref = ref;
                            delete annotation.id;
                        }
                    }
                    async saveNewAnnotations(handler, task, annotations, imagePromises) {
                        if (this.xfaFactory) throw new Error("XFA: Cannot save new annotations.");
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            systemFontCache: this.systemFontCache,
                            options: this.evaluatorOptions
                        });
                        const deletedAnnotations = new _primitives.RefSet();
                        const existingAnnotations = new _primitives.RefSet();
                        this.#replaceIdByRef(annotations, deletedAnnotations, existingAnnotations);
                        const pageDict = this.pageDict;
                        const annotationsArray = this.annotations.filter((a)=>!(a instanceof _primitives.Ref && deletedAnnotations.has(a)));
                        const newData = await _annotation.AnnotationFactory.saveNewAnnotations(partialEvaluator, task, annotations, imagePromises);
                        for (const { ref: ref } of newData.annotations)if (ref instanceof _primitives.Ref && !existingAnnotations.has(ref)) annotationsArray.push(ref);
                        const savedDict = pageDict.get("Annots");
                        pageDict.set("Annots", annotationsArray);
                        const buffer = [];
                        await (0, _writer.writeObject)(this.ref, pageDict, buffer, this.xref);
                        if (savedDict) pageDict.set("Annots", savedDict);
                        const objects = newData.dependencies;
                        objects.push({
                            ref: this.ref,
                            data: buffer.join("")
                        }, ...newData.annotations);
                        return objects;
                    }
                    save(handler, task, annotationStorage) {
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            systemFontCache: this.systemFontCache,
                            options: this.evaluatorOptions
                        });
                        return this._parsedAnnotations.then(function(annotations) {
                            const newRefsPromises = [];
                            for (const annotation of annotations){
                                if (!annotation.mustBePrinted(annotationStorage)) continue;
                                newRefsPromises.push(annotation.save(partialEvaluator, task, annotationStorage).catch(function(reason) {
                                    (0, _util.warn)("save - ignoring annotation data during " + `"${task.name}" task: "${reason}".`);
                                    return null;
                                }));
                            }
                            return Promise.all(newRefsPromises).then(function(newRefs) {
                                return newRefs.filter((newRef)=>!!newRef);
                            });
                        });
                    }
                    loadResources(keys) {
                        if (!this.resourcesPromise) this.resourcesPromise = this.pdfManager.ensure(this, "resources");
                        return this.resourcesPromise.then(()=>{
                            const objectLoader = new _object_loader.ObjectLoader(this.resources, keys, this.xref);
                            return objectLoader.load();
                        });
                    }
                    getOperatorList({ handler: handler, sink: sink, task: task, intent: intent, cacheKey: cacheKey, annotationStorage: annotationStorage = null }) {
                        const contentStreamPromise = this.getContentStream();
                        const resourcesPromise = this.loadResources([
                            "ColorSpace",
                            "ExtGState",
                            "Font",
                            "Pattern",
                            "Properties",
                            "Shading",
                            "XObject"
                        ]);
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            systemFontCache: this.systemFontCache,
                            options: this.evaluatorOptions
                        });
                        const newAnnotationsByPage = !this.xfaFactory ? (0, _core_utils.getNewAnnotationsMap)(annotationStorage) : null;
                        let deletedAnnotations = null;
                        let newAnnotationsPromise = Promise.resolve(null);
                        if (newAnnotationsByPage) {
                            const newAnnotations = newAnnotationsByPage.get(this.pageIndex);
                            if (newAnnotations) {
                                const annotationGlobalsPromise = this.pdfManager.ensureDoc("annotationGlobals");
                                let imagePromises;
                                const missingBitmaps = new Set();
                                for (const { bitmapId: bitmapId, bitmap: bitmap } of newAnnotations)if (bitmapId && !bitmap && !missingBitmaps.has(bitmapId)) missingBitmaps.add(bitmapId);
                                const { isOffscreenCanvasSupported: isOffscreenCanvasSupported } = this.evaluatorOptions;
                                if (missingBitmaps.size > 0) {
                                    const annotationWithBitmaps = newAnnotations.slice();
                                    for (const [key, annotation] of annotationStorage){
                                        if (!key.startsWith(_util.AnnotationEditorPrefix)) continue;
                                        if (annotation.bitmap && missingBitmaps.has(annotation.bitmapId)) annotationWithBitmaps.push(annotation);
                                    }
                                    imagePromises = _annotation.AnnotationFactory.generateImages(annotationWithBitmaps, this.xref, isOffscreenCanvasSupported);
                                } else imagePromises = _annotation.AnnotationFactory.generateImages(newAnnotations, this.xref, isOffscreenCanvasSupported);
                                deletedAnnotations = new _primitives.RefSet();
                                this.#replaceIdByRef(newAnnotations, deletedAnnotations, null);
                                newAnnotationsPromise = annotationGlobalsPromise.then((annotationGlobals)=>{
                                    if (!annotationGlobals) return null;
                                    return _annotation.AnnotationFactory.printNewAnnotations(annotationGlobals, partialEvaluator, task, newAnnotations, imagePromises);
                                });
                            }
                        }
                        const dataPromises = Promise.all([
                            contentStreamPromise,
                            resourcesPromise
                        ]);
                        const pageListPromise = dataPromises.then(([contentStream])=>{
                            const opList = new _operator_list.OperatorList(intent, sink);
                            handler.send("StartRenderPage", {
                                transparency: partialEvaluator.hasBlendModes(this.resources, this.nonBlendModesSet),
                                pageIndex: this.pageIndex,
                                cacheKey: cacheKey
                            });
                            return partialEvaluator.getOperatorList({
                                stream: contentStream,
                                task: task,
                                resources: this.resources,
                                operatorList: opList
                            }).then(function() {
                                return opList;
                            });
                        });
                        return Promise.all([
                            pageListPromise,
                            this._parsedAnnotations,
                            newAnnotationsPromise
                        ]).then(function([pageOpList, annotations, newAnnotations]) {
                            if (newAnnotations) {
                                annotations = annotations.filter((a)=>!(a.ref && deletedAnnotations.has(a.ref)));
                                for(let i = 0, ii = newAnnotations.length; i < ii; i++){
                                    const newAnnotation = newAnnotations[i];
                                    if (newAnnotation.refToReplace) {
                                        const j = annotations.findIndex((a)=>a.ref && (0, _primitives.isRefsEqual)(a.ref, newAnnotation.refToReplace));
                                        if (j >= 0) {
                                            annotations.splice(j, 1, newAnnotation);
                                            newAnnotations.splice(i--, 1);
                                            ii--;
                                        }
                                    }
                                }
                                annotations = annotations.concat(newAnnotations);
                            }
                            if (annotations.length === 0 || intent & _util.RenderingIntentFlag.ANNOTATIONS_DISABLE) {
                                pageOpList.flush(true);
                                return {
                                    length: pageOpList.totalLength
                                };
                            }
                            const renderForms = !!(intent & _util.RenderingIntentFlag.ANNOTATIONS_FORMS), intentAny = !!(intent & _util.RenderingIntentFlag.ANY), intentDisplay = !!(intent & _util.RenderingIntentFlag.DISPLAY), intentPrint = !!(intent & _util.RenderingIntentFlag.PRINT);
                            const opListPromises = [];
                            for (const annotation of annotations)if (intentAny || intentDisplay && annotation.mustBeViewed(annotationStorage, renderForms) || intentPrint && annotation.mustBePrinted(annotationStorage)) opListPromises.push(annotation.getOperatorList(partialEvaluator, task, intent, renderForms, annotationStorage).catch(function(reason) {
                                (0, _util.warn)("getOperatorList - ignoring annotation data during " + `"${task.name}" task: "${reason}".`);
                                return {
                                    opList: null,
                                    separateForm: false,
                                    separateCanvas: false
                                };
                            }));
                            return Promise.all(opListPromises).then(function(opLists) {
                                let form = false, canvas = false;
                                for (const { opList: opList, separateForm: separateForm, separateCanvas: separateCanvas } of opLists){
                                    pageOpList.addOpList(opList);
                                    form ||= separateForm;
                                    canvas ||= separateCanvas;
                                }
                                pageOpList.flush(true, {
                                    form: form,
                                    canvas: canvas
                                });
                                return {
                                    length: pageOpList.totalLength
                                };
                            });
                        });
                    }
                    extractTextContent({ handler: handler, task: task, includeMarkedContent: includeMarkedContent, disableNormalization: disableNormalization, sink: sink }) {
                        const contentStreamPromise = this.getContentStream();
                        const resourcesPromise = this.loadResources([
                            "ExtGState",
                            "Font",
                            "Properties",
                            "XObject"
                        ]);
                        const dataPromises = Promise.all([
                            contentStreamPromise,
                            resourcesPromise
                        ]);
                        return dataPromises.then(([contentStream])=>{
                            const partialEvaluator = new _evaluator.PartialEvaluator({
                                xref: this.xref,
                                handler: handler,
                                pageIndex: this.pageIndex,
                                idFactory: this._localIdFactory,
                                fontCache: this.fontCache,
                                builtInCMapCache: this.builtInCMapCache,
                                standardFontDataCache: this.standardFontDataCache,
                                globalImageCache: this.globalImageCache,
                                systemFontCache: this.systemFontCache,
                                options: this.evaluatorOptions
                            });
                            return partialEvaluator.getTextContent({
                                stream: contentStream,
                                task: task,
                                resources: this.resources,
                                includeMarkedContent: includeMarkedContent,
                                disableNormalization: disableNormalization,
                                sink: sink,
                                viewBox: this.view
                            });
                        });
                    }
                    async getStructTree() {
                        const structTreeRoot = await this.pdfManager.ensureCatalog("structTreeRoot");
                        if (!structTreeRoot) return null;
                        await this._parsedAnnotations;
                        const structTree = await this.pdfManager.ensure(this, "_parseStructTree", [
                            structTreeRoot
                        ]);
                        return structTree.serializable;
                    }
                    _parseStructTree(structTreeRoot) {
                        const tree = new _struct_tree.StructTreePage(structTreeRoot, this.pageDict);
                        tree.parse(this.ref);
                        return tree;
                    }
                    async getAnnotationsData(handler, task, intent) {
                        const annotations = await this._parsedAnnotations;
                        if (annotations.length === 0) return annotations;
                        const annotationsData = [], textContentPromises = [];
                        let partialEvaluator;
                        const intentAny = !!(intent & _util.RenderingIntentFlag.ANY), intentDisplay = !!(intent & _util.RenderingIntentFlag.DISPLAY), intentPrint = !!(intent & _util.RenderingIntentFlag.PRINT);
                        for (const annotation of annotations){
                            const isVisible = intentAny || intentDisplay && annotation.viewable;
                            if (isVisible || intentPrint && annotation.printable) annotationsData.push(annotation.data);
                            if (annotation.hasTextContent && isVisible) {
                                partialEvaluator ||= new _evaluator.PartialEvaluator({
                                    xref: this.xref,
                                    handler: handler,
                                    pageIndex: this.pageIndex,
                                    idFactory: this._localIdFactory,
                                    fontCache: this.fontCache,
                                    builtInCMapCache: this.builtInCMapCache,
                                    standardFontDataCache: this.standardFontDataCache,
                                    globalImageCache: this.globalImageCache,
                                    systemFontCache: this.systemFontCache,
                                    options: this.evaluatorOptions
                                });
                                textContentPromises.push(annotation.extractTextContent(partialEvaluator, task, [
                                    -Infinity,
                                    -Infinity,
                                    Infinity,
                                    Infinity
                                ]).catch(function(reason) {
                                    (0, _util.warn)(`getAnnotationsData - ignoring textContent during "${task.name}" task: "${reason}".`);
                                }));
                            }
                        }
                        await Promise.all(textContentPromises);
                        return annotationsData;
                    }
                    get annotations() {
                        const annots = this._getInheritableProperty("Annots");
                        return (0, _util.shadow)(this, "annotations", Array.isArray(annots) ? annots : []);
                    }
                    get _parsedAnnotations() {
                        const promise = this.pdfManager.ensure(this, "annotations").then(async (annots)=>{
                            if (annots.length === 0) return annots;
                            const annotationGlobals = await this.pdfManager.ensureDoc("annotationGlobals");
                            if (!annotationGlobals) return [];
                            const annotationPromises = [];
                            for (const annotationRef of annots)annotationPromises.push(_annotation.AnnotationFactory.create(this.xref, annotationRef, annotationGlobals, this._localIdFactory, false, this.ref).catch(function(reason) {
                                (0, _util.warn)(`_parsedAnnotations: "${reason}".`);
                                return null;
                            }));
                            const sortedAnnotations = [];
                            let popupAnnotations;
                            for (const annotation of (await Promise.all(annotationPromises))){
                                if (!annotation) continue;
                                if (annotation instanceof _annotation.PopupAnnotation) {
                                    (popupAnnotations ||= []).push(annotation);
                                    continue;
                                }
                                sortedAnnotations.push(annotation);
                            }
                            if (popupAnnotations) sortedAnnotations.push(...popupAnnotations);
                            return sortedAnnotations;
                        });
                        return (0, _util.shadow)(this, "_parsedAnnotations", promise);
                    }
                    get jsActions() {
                        const actions = (0, _core_utils.collectActions)(this.xref, this.pageDict, _util.PageActionEventType);
                        return (0, _util.shadow)(this, "jsActions", actions);
                    }
                }
                exports.Page = Page;
                const PDF_HEADER_SIGNATURE = new Uint8Array([
                    0x25,
                    0x50,
                    0x44,
                    0x46,
                    0x2d
                ]);
                const STARTXREF_SIGNATURE = new Uint8Array([
                    0x73,
                    0x74,
                    0x61,
                    0x72,
                    0x74,
                    0x78,
                    0x72,
                    0x65,
                    0x66
                ]);
                const ENDOBJ_SIGNATURE = new Uint8Array([
                    0x65,
                    0x6e,
                    0x64,
                    0x6f,
                    0x62,
                    0x6a
                ]);
                const FINGERPRINT_FIRST_BYTES = 1024;
                const EMPTY_FINGERPRINT = "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
                function find(stream, signature, limit = 1024, backwards = false) {
                    const signatureLength = signature.length;
                    const scanBytes = stream.peekBytes(limit);
                    const scanLength = scanBytes.length - signatureLength;
                    if (scanLength <= 0) return false;
                    if (backwards) {
                        const signatureEnd = signatureLength - 1;
                        let pos = scanBytes.length - 1;
                        while(pos >= signatureEnd){
                            let j = 0;
                            while(j < signatureLength && scanBytes[pos - j] === signature[signatureEnd - j])j++;
                            if (j >= signatureLength) {
                                stream.pos += pos - signatureEnd;
                                return true;
                            }
                            pos--;
                        }
                    } else {
                        let pos = 0;
                        while(pos <= scanLength){
                            let j = 0;
                            while(j < signatureLength && scanBytes[pos + j] === signature[j])j++;
                            if (j >= signatureLength) {
                                stream.pos += pos;
                                return true;
                            }
                            pos++;
                        }
                    }
                    return false;
                }
                class PDFDocument {
                    constructor(pdfManager, stream){
                        if (stream.length <= 0) throw new _util.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
                        this.pdfManager = pdfManager;
                        this.stream = stream;
                        this.xref = new _xref.XRef(stream, pdfManager);
                        this._pagePromises = new Map();
                        this._version = null;
                        const idCounters = {
                            font: 0
                        };
                        this._globalIdFactory = class {
                            static getDocId() {
                                return `g_${pdfManager.docId}`;
                            }
                            static createFontId() {
                                return `f${++idCounters.font}`;
                            }
                            static createObjId() {
                                (0, _util.unreachable)("Abstract method `createObjId` called.");
                            }
                            static getPageObjId() {
                                (0, _util.unreachable)("Abstract method `getPageObjId` called.");
                            }
                        };
                    }
                    parse(recoveryMode) {
                        this.xref.parse(recoveryMode);
                        this.catalog = new _catalog.Catalog(this.pdfManager, this.xref);
                    }
                    get linearization() {
                        let linearization = null;
                        try {
                            linearization = _parser.Linearization.create(this.stream);
                        } catch (err) {
                            if (err instanceof _core_utils.MissingDataException) throw err;
                            (0, _util.info)(err);
                        }
                        return (0, _util.shadow)(this, "linearization", linearization);
                    }
                    get startXRef() {
                        const stream = this.stream;
                        let startXRef = 0;
                        if (this.linearization) {
                            stream.reset();
                            if (find(stream, ENDOBJ_SIGNATURE)) startXRef = stream.pos + 6 - stream.start;
                        } else {
                            const step = 1024;
                            const startXRefLength = STARTXREF_SIGNATURE.length;
                            let found = false, pos = stream.end;
                            while(!found && pos > 0){
                                pos -= step - startXRefLength;
                                if (pos < 0) pos = 0;
                                stream.pos = pos;
                                found = find(stream, STARTXREF_SIGNATURE, step, true);
                            }
                            if (found) {
                                stream.skip(9);
                                let ch;
                                do ch = stream.getByte();
                                while ((0, _core_utils.isWhiteSpace)(ch));
                                let str = "";
                                while(ch >= 0x20 && ch <= 0x39){
                                    str += String.fromCharCode(ch);
                                    ch = stream.getByte();
                                }
                                startXRef = parseInt(str, 10);
                                if (isNaN(startXRef)) startXRef = 0;
                            }
                        }
                        return (0, _util.shadow)(this, "startXRef", startXRef);
                    }
                    checkHeader() {
                        const stream = this.stream;
                        stream.reset();
                        if (!find(stream, PDF_HEADER_SIGNATURE)) return;
                        stream.moveStart();
                        stream.skip(PDF_HEADER_SIGNATURE.length);
                        let version = "", ch;
                        while((ch = stream.getByte()) > 0x20 && version.length < 7)version += String.fromCharCode(ch);
                        if (_core_utils.PDF_VERSION_REGEXP.test(version)) this._version = version;
                        else (0, _util.warn)(`Invalid PDF header version: ${version}`);
                    }
                    parseStartXRef() {
                        this.xref.setStartXRef(this.startXRef);
                    }
                    get numPages() {
                        let num = 0;
                        if (this.catalog.hasActualNumPages) num = this.catalog.numPages;
                        else if (this.xfaFactory) num = this.xfaFactory.getNumPages();
                        else if (this.linearization) num = this.linearization.numPages;
                        else num = this.catalog.numPages;
                        return (0, _util.shadow)(this, "numPages", num);
                    }
                    _hasOnlyDocumentSignatures(fields, recursionDepth = 0) {
                        const RECURSION_LIMIT = 10;
                        if (!Array.isArray(fields)) return false;
                        return fields.every((field)=>{
                            field = this.xref.fetchIfRef(field);
                            if (!(field instanceof _primitives.Dict)) return false;
                            if (field.has("Kids")) {
                                if (++recursionDepth > RECURSION_LIMIT) {
                                    (0, _util.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached");
                                    return false;
                                }
                                return this._hasOnlyDocumentSignatures(field.get("Kids"), recursionDepth);
                            }
                            const isSignature = (0, _primitives.isName)(field.get("FT"), "Sig");
                            const rectangle = field.get("Rect");
                            const isInvisible = Array.isArray(rectangle) && rectangle.every((value)=>value === 0);
                            return isSignature && isInvisible;
                        });
                    }
                    get _xfaStreams() {
                        const acroForm = this.catalog.acroForm;
                        if (!acroForm) return null;
                        const xfa = acroForm.get("XFA");
                        const entries = {
                            "xdp:xdp": "",
                            template: "",
                            datasets: "",
                            config: "",
                            connectionSet: "",
                            localeSet: "",
                            stylesheet: "",
                            "/xdp:xdp": ""
                        };
                        if (xfa instanceof _base_stream.BaseStream && !xfa.isEmpty) {
                            entries["xdp:xdp"] = xfa;
                            return entries;
                        }
                        if (!Array.isArray(xfa) || xfa.length === 0) return null;
                        for(let i = 0, ii = xfa.length; i < ii; i += 2){
                            let name;
                            if (i === 0) name = "xdp:xdp";
                            else if (i === ii - 2) name = "/xdp:xdp";
                            else name = xfa[i];
                            if (!entries.hasOwnProperty(name)) continue;
                            const data = this.xref.fetchIfRef(xfa[i + 1]);
                            if (!(data instanceof _base_stream.BaseStream) || data.isEmpty) continue;
                            entries[name] = data;
                        }
                        return entries;
                    }
                    get xfaDatasets() {
                        const streams = this._xfaStreams;
                        if (!streams) return (0, _util.shadow)(this, "xfaDatasets", null);
                        for (const key of [
                            "datasets",
                            "xdp:xdp"
                        ]){
                            const stream = streams[key];
                            if (!stream) continue;
                            try {
                                const str = (0, _util.stringToUTF8String)(stream.getString());
                                const data = {
                                    [key]: str
                                };
                                return (0, _util.shadow)(this, "xfaDatasets", new _dataset_reader.DatasetReader(data));
                            } catch  {
                                (0, _util.warn)("XFA - Invalid utf-8 string.");
                                break;
                            }
                        }
                        return (0, _util.shadow)(this, "xfaDatasets", null);
                    }
                    get xfaData() {
                        const streams = this._xfaStreams;
                        if (!streams) return null;
                        const data = Object.create(null);
                        for (const [key, stream] of Object.entries(streams)){
                            if (!stream) continue;
                            try {
                                data[key] = (0, _util.stringToUTF8String)(stream.getString());
                            } catch  {
                                (0, _util.warn)("XFA - Invalid utf-8 string.");
                                return null;
                            }
                        }
                        return data;
                    }
                    get xfaFactory() {
                        let data;
                        if (this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm) data = this.xfaData;
                        return (0, _util.shadow)(this, "xfaFactory", data ? new _factory.XFAFactory(data) : null);
                    }
                    get isPureXfa() {
                        return this.xfaFactory ? this.xfaFactory.isValid() : false;
                    }
                    get htmlForXfa() {
                        return this.xfaFactory ? this.xfaFactory.getPages() : null;
                    }
                    async loadXfaImages() {
                        const xfaImagesDict = await this.pdfManager.ensureCatalog("xfaImages");
                        if (!xfaImagesDict) return;
                        const keys = xfaImagesDict.getKeys();
                        const objectLoader = new _object_loader.ObjectLoader(xfaImagesDict, keys, this.xref);
                        await objectLoader.load();
                        const xfaImages = new Map();
                        for (const key of keys){
                            const stream = xfaImagesDict.get(key);
                            if (stream instanceof _base_stream.BaseStream) xfaImages.set(key, stream.getBytes());
                        }
                        this.xfaFactory.setImages(xfaImages);
                    }
                    async loadXfaFonts(handler, task) {
                        const acroForm = await this.pdfManager.ensureCatalog("acroForm");
                        if (!acroForm) return;
                        const resources = await acroForm.getAsync("DR");
                        if (!(resources instanceof _primitives.Dict)) return;
                        const objectLoader = new _object_loader.ObjectLoader(resources, [
                            "Font"
                        ], this.xref);
                        await objectLoader.load();
                        const fontRes = resources.get("Font");
                        if (!(fontRes instanceof _primitives.Dict)) return;
                        const options = Object.assign(Object.create(null), this.pdfManager.evaluatorOptions);
                        options.useSystemFonts = false;
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: -1,
                            idFactory: this._globalIdFactory,
                            fontCache: this.catalog.fontCache,
                            builtInCMapCache: this.catalog.builtInCMapCache,
                            standardFontDataCache: this.catalog.standardFontDataCache,
                            options: options
                        });
                        const operatorList = new _operator_list.OperatorList();
                        const pdfFonts = [];
                        const initialState = {
                            get font () {
                                return pdfFonts.at(-1);
                            },
                            set font (font){
                                pdfFonts.push(font);
                            },
                            clone () {
                                return this;
                            }
                        };
                        const fonts = new Map();
                        fontRes.forEach((fontName, font1)=>{
                            fonts.set(fontName, font1);
                        });
                        const promises = [];
                        for (const [fontName, font1] of fonts){
                            const descriptor = font1.get("FontDescriptor");
                            if (!(descriptor instanceof _primitives.Dict)) continue;
                            let fontFamily = descriptor.get("FontFamily");
                            fontFamily = fontFamily.replaceAll(/[ ]+(\d)/g, "$1");
                            const fontWeight = descriptor.get("FontWeight");
                            const italicAngle = -descriptor.get("ItalicAngle");
                            const cssFontInfo = {
                                fontFamily: fontFamily,
                                fontWeight: fontWeight,
                                italicAngle: italicAngle
                            };
                            if (!(0, _core_utils.validateCSSFont)(cssFontInfo)) continue;
                            promises.push(partialEvaluator.handleSetFont(resources, [
                                _primitives.Name.get(fontName),
                                1
                            ], null, operatorList, task, initialState, null, cssFontInfo).catch(function(reason) {
                                (0, _util.warn)(`loadXfaFonts: "${reason}".`);
                                return null;
                            }));
                        }
                        await Promise.all(promises);
                        const missingFonts = this.xfaFactory.setFonts(pdfFonts);
                        if (!missingFonts) return;
                        options.ignoreErrors = true;
                        promises.length = 0;
                        pdfFonts.length = 0;
                        const reallyMissingFonts = new Set();
                        for (const missing of missingFonts)if (!(0, _xfa_fonts.getXfaFontName)(`${missing}-Regular`)) reallyMissingFonts.add(missing);
                        if (reallyMissingFonts.size) missingFonts.push("PdfJS-Fallback");
                        for (const missing of missingFonts){
                            if (reallyMissingFonts.has(missing)) continue;
                            for (const fontInfo of [
                                {
                                    name: "Regular",
                                    fontWeight: 400,
                                    italicAngle: 0
                                },
                                {
                                    name: "Bold",
                                    fontWeight: 700,
                                    italicAngle: 0
                                },
                                {
                                    name: "Italic",
                                    fontWeight: 400,
                                    italicAngle: 12
                                },
                                {
                                    name: "BoldItalic",
                                    fontWeight: 700,
                                    italicAngle: 12
                                }
                            ]){
                                const name = `${missing}-${fontInfo.name}`;
                                const dict = (0, _xfa_fonts.getXfaFontDict)(name);
                                promises.push(partialEvaluator.handleSetFont(resources, [
                                    _primitives.Name.get(name),
                                    1
                                ], null, operatorList, task, initialState, dict, {
                                    fontFamily: missing,
                                    fontWeight: fontInfo.fontWeight,
                                    italicAngle: fontInfo.italicAngle
                                }).catch(function(reason) {
                                    (0, _util.warn)(`loadXfaFonts: "${reason}".`);
                                    return null;
                                }));
                            }
                        }
                        await Promise.all(promises);
                        this.xfaFactory.appendFonts(pdfFonts, reallyMissingFonts);
                    }
                    async serializeXfaData(annotationStorage) {
                        return this.xfaFactory ? this.xfaFactory.serializeData(annotationStorage) : null;
                    }
                    get version() {
                        return this.catalog.version || this._version;
                    }
                    get formInfo() {
                        const formInfo = {
                            hasFields: false,
                            hasAcroForm: false,
                            hasXfa: false,
                            hasSignatures: false
                        };
                        const acroForm = this.catalog.acroForm;
                        if (!acroForm) return (0, _util.shadow)(this, "formInfo", formInfo);
                        try {
                            const fields = acroForm.get("Fields");
                            const hasFields = Array.isArray(fields) && fields.length > 0;
                            formInfo.hasFields = hasFields;
                            const xfa = acroForm.get("XFA");
                            formInfo.hasXfa = Array.isArray(xfa) && xfa.length > 0 || xfa instanceof _base_stream.BaseStream && !xfa.isEmpty;
                            const sigFlags = acroForm.get("SigFlags");
                            const hasSignatures = !!(sigFlags & 0x1);
                            const hasOnlyDocumentSignatures = hasSignatures && this._hasOnlyDocumentSignatures(fields);
                            formInfo.hasAcroForm = hasFields && !hasOnlyDocumentSignatures;
                            formInfo.hasSignatures = hasSignatures;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`Cannot fetch form information: "${ex}".`);
                        }
                        return (0, _util.shadow)(this, "formInfo", formInfo);
                    }
                    get documentInfo() {
                        const docInfo = {
                            PDFFormatVersion: this.version,
                            Language: this.catalog.lang,
                            EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null,
                            IsLinearized: !!this.linearization,
                            IsAcroFormPresent: this.formInfo.hasAcroForm,
                            IsXFAPresent: this.formInfo.hasXfa,
                            IsCollectionPresent: !!this.catalog.collection,
                            IsSignaturesPresent: this.formInfo.hasSignatures
                        };
                        let infoDict;
                        try {
                            infoDict = this.xref.trailer.get("Info");
                        } catch (err) {
                            if (err instanceof _core_utils.MissingDataException) throw err;
                            (0, _util.info)("The document information dictionary is invalid.");
                        }
                        if (!(infoDict instanceof _primitives.Dict)) return (0, _util.shadow)(this, "documentInfo", docInfo);
                        for (const key of infoDict.getKeys()){
                            const value = infoDict.get(key);
                            switch(key){
                                case "Title":
                                case "Author":
                                case "Subject":
                                case "Keywords":
                                case "Creator":
                                case "Producer":
                                case "CreationDate":
                                case "ModDate":
                                    if (typeof value === "string") {
                                        docInfo[key] = (0, _util.stringToPDFString)(value);
                                        continue;
                                    }
                                    break;
                                case "Trapped":
                                    if (value instanceof _primitives.Name) {
                                        docInfo[key] = value;
                                        continue;
                                    }
                                    break;
                                default:
                                    let customValue;
                                    switch(typeof value){
                                        case "string":
                                            customValue = (0, _util.stringToPDFString)(value);
                                            break;
                                        case "number":
                                        case "boolean":
                                            customValue = value;
                                            break;
                                        default:
                                            if (value instanceof _primitives.Name) customValue = value;
                                            break;
                                    }
                                    if (customValue === undefined) {
                                        (0, _util.warn)(`Bad value, for custom key "${key}", in Info: ${value}.`);
                                        continue;
                                    }
                                    if (!docInfo.Custom) docInfo.Custom = Object.create(null);
                                    docInfo.Custom[key] = customValue;
                                    continue;
                            }
                            (0, _util.warn)(`Bad value, for key "${key}", in Info: ${value}.`);
                        }
                        return (0, _util.shadow)(this, "documentInfo", docInfo);
                    }
                    get fingerprints() {
                        function validate(data) {
                            return typeof data === "string" && data.length > 0 && data !== EMPTY_FINGERPRINT;
                        }
                        function hexString(hash) {
                            const buf = [];
                            for (const num of hash){
                                const hex = num.toString(16);
                                buf.push(hex.padStart(2, "0"));
                            }
                            return buf.join("");
                        }
                        const idArray = this.xref.trailer.get("ID");
                        let hashOriginal, hashModified;
                        if (Array.isArray(idArray) && validate(idArray[0])) {
                            hashOriginal = (0, _util.stringToBytes)(idArray[0]);
                            if (idArray[1] !== idArray[0] && validate(idArray[1])) hashModified = (0, _util.stringToBytes)(idArray[1]);
                        } else hashOriginal = (0, _crypto.calculateMD5)(this.stream.getByteRange(0, FINGERPRINT_FIRST_BYTES), 0, FINGERPRINT_FIRST_BYTES);
                        return (0, _util.shadow)(this, "fingerprints", [
                            hexString(hashOriginal),
                            hashModified ? hexString(hashModified) : null
                        ]);
                    }
                    async _getLinearizationPage(pageIndex) {
                        const { catalog: catalog, linearization: linearization, xref: xref } = this;
                        const ref = _primitives.Ref.get(linearization.objectNumberFirst, 0);
                        try {
                            const obj = await xref.fetchAsync(ref);
                            if (obj instanceof _primitives.Dict) {
                                let type = obj.getRaw("Type");
                                if (type instanceof _primitives.Ref) type = await xref.fetchAsync(type);
                                if ((0, _primitives.isName)(type, "Page") || !obj.has("Type") && !obj.has("Kids")) {
                                    if (!catalog.pageKidsCountCache.has(ref)) catalog.pageKidsCountCache.put(ref, 1);
                                    if (!catalog.pageIndexCache.has(ref)) catalog.pageIndexCache.put(ref, 0);
                                    return [
                                        obj,
                                        ref
                                    ];
                                }
                            }
                            throw new _util.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
                        } catch (reason) {
                            (0, _util.warn)(`_getLinearizationPage: "${reason.message}".`);
                            return catalog.getPageDict(pageIndex);
                        }
                    }
                    getPage(pageIndex) {
                        const cachedPromise = this._pagePromises.get(pageIndex);
                        if (cachedPromise) return cachedPromise;
                        const { catalog: catalog, linearization: linearization, xfaFactory: xfaFactory } = this;
                        let promise;
                        if (xfaFactory) promise = Promise.resolve([
                            _primitives.Dict.empty,
                            null
                        ]);
                        else if (linearization?.pageFirst === pageIndex) promise = this._getLinearizationPage(pageIndex);
                        else promise = catalog.getPageDict(pageIndex);
                        promise = promise.then(([pageDict, ref])=>{
                            return new Page({
                                pdfManager: this.pdfManager,
                                xref: this.xref,
                                pageIndex: pageIndex,
                                pageDict: pageDict,
                                ref: ref,
                                globalIdFactory: this._globalIdFactory,
                                fontCache: catalog.fontCache,
                                builtInCMapCache: catalog.builtInCMapCache,
                                standardFontDataCache: catalog.standardFontDataCache,
                                globalImageCache: catalog.globalImageCache,
                                systemFontCache: catalog.systemFontCache,
                                nonBlendModesSet: catalog.nonBlendModesSet,
                                xfaFactory: xfaFactory
                            });
                        });
                        this._pagePromises.set(pageIndex, promise);
                        return promise;
                    }
                    async checkFirstPage(recoveryMode = false) {
                        if (recoveryMode) return;
                        try {
                            await this.getPage(0);
                        } catch (reason) {
                            if (reason instanceof _core_utils.XRefEntryException) {
                                this._pagePromises.delete(0);
                                await this.cleanup();
                                throw new _core_utils.XRefParseException();
                            }
                        }
                    }
                    async checkLastPage(recoveryMode = false) {
                        const { catalog: catalog, pdfManager: pdfManager } = this;
                        catalog.setActualNumPages();
                        let numPages;
                        try {
                            await Promise.all([
                                pdfManager.ensureDoc("xfaFactory"),
                                pdfManager.ensureDoc("linearization"),
                                pdfManager.ensureCatalog("numPages")
                            ]);
                            if (this.xfaFactory) return;
                            else if (this.linearization) numPages = this.linearization.numPages;
                            else numPages = catalog.numPages;
                            if (!Number.isInteger(numPages)) throw new _util.FormatError("Page count is not an integer.");
                            else if (numPages <= 1) return;
                            await this.getPage(numPages - 1);
                        } catch (reason) {
                            this._pagePromises.delete(numPages - 1);
                            await this.cleanup();
                            if (reason instanceof _core_utils.XRefEntryException && !recoveryMode) throw new _core_utils.XRefParseException();
                            (0, _util.warn)(`checkLastPage - invalid /Pages tree /Count: ${numPages}.`);
                            let pagesTree;
                            try {
                                pagesTree = await catalog.getAllPageDicts(recoveryMode);
                            } catch (reasonAll) {
                                if (reasonAll instanceof _core_utils.XRefEntryException && !recoveryMode) throw new _core_utils.XRefParseException();
                                catalog.setActualNumPages(1);
                                return;
                            }
                            for (const [pageIndex, [pageDict, ref]] of pagesTree){
                                let promise;
                                if (pageDict instanceof Error) {
                                    promise = Promise.reject(pageDict);
                                    promise.catch(()=>{});
                                } else promise = Promise.resolve(new Page({
                                    pdfManager: pdfManager,
                                    xref: this.xref,
                                    pageIndex: pageIndex,
                                    pageDict: pageDict,
                                    ref: ref,
                                    globalIdFactory: this._globalIdFactory,
                                    fontCache: catalog.fontCache,
                                    builtInCMapCache: catalog.builtInCMapCache,
                                    standardFontDataCache: catalog.standardFontDataCache,
                                    globalImageCache: catalog.globalImageCache,
                                    systemFontCache: catalog.systemFontCache,
                                    nonBlendModesSet: catalog.nonBlendModesSet,
                                    xfaFactory: null
                                }));
                                this._pagePromises.set(pageIndex, promise);
                            }
                            catalog.setActualNumPages(pagesTree.size);
                        }
                    }
                    fontFallback(id, handler) {
                        return this.catalog.fontFallback(id, handler);
                    }
                    async cleanup(manuallyTriggered = false) {
                        return this.catalog ? this.catalog.cleanup(manuallyTriggered) : (0, _cleanup_helper.clearGlobalCaches)();
                    }
                    #collectFieldObjects(name, fieldRef, promises, annotationGlobals) {
                        const field = this.xref.fetchIfRef(fieldRef);
                        if (field.has("T")) {
                            const partName = (0, _util.stringToPDFString)(field.get("T"));
                            name = name === "" ? partName : `${name}.${partName}`;
                        }
                        if (!promises.has(name)) promises.set(name, []);
                        promises.get(name).push(_annotation.AnnotationFactory.create(this.xref, fieldRef, annotationGlobals, this._localIdFactory, true, null).then((annotation)=>annotation?.getFieldObject()).catch(function(reason) {
                            (0, _util.warn)(`#collectFieldObjects: "${reason}".`);
                            return null;
                        }));
                        if (field.has("Kids")) for (const kid of field.get("Kids"))this.#collectFieldObjects(name, kid, promises, annotationGlobals);
                    }
                    get fieldObjects() {
                        if (!this.formInfo.hasFields) return (0, _util.shadow)(this, "fieldObjects", Promise.resolve(null));
                        const promise = this.pdfManager.ensureDoc("annotationGlobals").then(async (annotationGlobals)=>{
                            if (!annotationGlobals) return null;
                            const allFields = Object.create(null);
                            const fieldPromises = new Map();
                            for (const fieldRef of this.catalog.acroForm.get("Fields"))this.#collectFieldObjects("", fieldRef, fieldPromises, annotationGlobals);
                            const allPromises = [];
                            for (const [name, promises] of fieldPromises)allPromises.push(Promise.all(promises).then((fields)=>{
                                fields = fields.filter((field)=>!!field);
                                if (fields.length > 0) allFields[name] = fields;
                            }));
                            await Promise.all(allPromises);
                            return allFields;
                        });
                        return (0, _util.shadow)(this, "fieldObjects", promise);
                    }
                    get hasJSActions() {
                        const promise = this.pdfManager.ensureDoc("_parseHasJSActions");
                        return (0, _util.shadow)(this, "hasJSActions", promise);
                    }
                    async _parseHasJSActions() {
                        const [catalogJsActions, fieldObjects] = await Promise.all([
                            this.pdfManager.ensureCatalog("jsActions"),
                            this.pdfManager.ensureDoc("fieldObjects")
                        ]);
                        if (catalogJsActions) return true;
                        if (fieldObjects) return Object.values(fieldObjects).some((fieldObject)=>fieldObject.some((object)=>object.actions !== null));
                        return false;
                    }
                    get calculationOrderIds() {
                        const acroForm = this.catalog.acroForm;
                        if (!acroForm?.has("CO")) return (0, _util.shadow)(this, "calculationOrderIds", null);
                        const calculationOrder = acroForm.get("CO");
                        if (!Array.isArray(calculationOrder) || calculationOrder.length === 0) return (0, _util.shadow)(this, "calculationOrderIds", null);
                        const ids = [];
                        for (const id of calculationOrder)if (id instanceof _primitives.Ref) ids.push(id.toString());
                        if (ids.length === 0) return (0, _util.shadow)(this, "calculationOrderIds", null);
                        return (0, _util.shadow)(this, "calculationOrderIds", ids);
                    }
                    get annotationGlobals() {
                        return (0, _util.shadow)(this, "annotationGlobals", _annotation.AnnotationFactory.createGlobals(this.pdfManager));
                    }
                }
                exports.PDFDocument = PDFDocument;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PopupAnnotation = exports.MarkupAnnotation = exports.AnnotationFactory = exports.AnnotationBorderStyle = exports.Annotation = void 0;
                exports.getQuadPoints = getQuadPoints;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _default_appearance = __w_pdfjs_require__(11);
                var _primitives = __w_pdfjs_require__(4);
                var _stream = __w_pdfjs_require__(8);
                var _base_stream = __w_pdfjs_require__(5);
                var _bidi = __w_pdfjs_require__(60);
                var _catalog = __w_pdfjs_require__(66);
                var _colorspace = __w_pdfjs_require__(12);
                var _file_spec = __w_pdfjs_require__(69);
                var _jpeg_stream = __w_pdfjs_require__(26);
                var _object_loader = __w_pdfjs_require__(76);
                var _operator_list = __w_pdfjs_require__(64);
                var _writer = __w_pdfjs_require__(73);
                var _factory = __w_pdfjs_require__(77);
                class AnnotationFactory {
                    static createGlobals(pdfManager) {
                        return Promise.all([
                            pdfManager.ensureCatalog("acroForm"),
                            pdfManager.ensureDoc("xfaDatasets"),
                            pdfManager.ensureCatalog("structTreeRoot"),
                            pdfManager.ensureCatalog("baseUrl"),
                            pdfManager.ensureCatalog("attachments")
                        ]).then(([acroForm, xfaDatasets, structTreeRoot, baseUrl, attachments])=>{
                            return {
                                pdfManager: pdfManager,
                                acroForm: acroForm instanceof _primitives.Dict ? acroForm : _primitives.Dict.empty,
                                xfaDatasets: xfaDatasets,
                                structTreeRoot: structTreeRoot,
                                baseUrl: baseUrl,
                                attachments: attachments
                            };
                        }, (reason)=>{
                            (0, _util.warn)(`createGlobals: "${reason}".`);
                            return null;
                        });
                    }
                    static async create(xref, ref, annotationGlobals, idFactory, collectFields, pageRef) {
                        const pageIndex = collectFields ? await this._getPageIndex(xref, ref, annotationGlobals.pdfManager) : null;
                        return annotationGlobals.pdfManager.ensure(this, "_create", [
                            xref,
                            ref,
                            annotationGlobals,
                            idFactory,
                            collectFields,
                            pageIndex,
                            pageRef
                        ]);
                    }
                    static _create(xref, ref, annotationGlobals, idFactory, collectFields = false, pageIndex = null, pageRef = null) {
                        const dict = xref.fetchIfRef(ref);
                        if (!(dict instanceof _primitives.Dict)) return undefined;
                        const { acroForm: acroForm, pdfManager: pdfManager } = annotationGlobals;
                        const id = ref instanceof _primitives.Ref ? ref.toString() : `annot_${idFactory.createObjId()}`;
                        let subtype = dict.get("Subtype");
                        subtype = subtype instanceof _primitives.Name ? subtype.name : null;
                        const parameters = {
                            xref: xref,
                            ref: ref,
                            dict: dict,
                            subtype: subtype,
                            id: id,
                            annotationGlobals: annotationGlobals,
                            collectFields: collectFields,
                            needAppearances: !collectFields && acroForm.get("NeedAppearances") === true,
                            pageIndex: pageIndex,
                            evaluatorOptions: pdfManager.evaluatorOptions,
                            pageRef: pageRef
                        };
                        switch(subtype){
                            case "Link":
                                return new LinkAnnotation(parameters);
                            case "Text":
                                return new TextAnnotation(parameters);
                            case "Widget":
                                let fieldType = (0, _core_utils.getInheritableProperty)({
                                    dict: dict,
                                    key: "FT"
                                });
                                fieldType = fieldType instanceof _primitives.Name ? fieldType.name : null;
                                switch(fieldType){
                                    case "Tx":
                                        return new TextWidgetAnnotation(parameters);
                                    case "Btn":
                                        return new ButtonWidgetAnnotation(parameters);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotation(parameters);
                                    case "Sig":
                                        return new SignatureWidgetAnnotation(parameters);
                                }
                                (0, _util.warn)(`Unimplemented widget field type "${fieldType}", ` + "falling back to base field type.");
                                return new WidgetAnnotation(parameters);
                            case "Popup":
                                return new PopupAnnotation(parameters);
                            case "FreeText":
                                return new FreeTextAnnotation(parameters);
                            case "Line":
                                return new LineAnnotation(parameters);
                            case "Square":
                                return new SquareAnnotation(parameters);
                            case "Circle":
                                return new CircleAnnotation(parameters);
                            case "PolyLine":
                                return new PolylineAnnotation(parameters);
                            case "Polygon":
                                return new PolygonAnnotation(parameters);
                            case "Caret":
                                return new CaretAnnotation(parameters);
                            case "Ink":
                                return new InkAnnotation(parameters);
                            case "Highlight":
                                return new HighlightAnnotation(parameters);
                            case "Underline":
                                return new UnderlineAnnotation(parameters);
                            case "Squiggly":
                                return new SquigglyAnnotation(parameters);
                            case "StrikeOut":
                                return new StrikeOutAnnotation(parameters);
                            case "Stamp":
                                return new StampAnnotation(parameters);
                            case "FileAttachment":
                                return new FileAttachmentAnnotation(parameters);
                            default:
                                if (!collectFields) {
                                    if (!subtype) (0, _util.warn)("Annotation is missing the required /Subtype.");
                                    else (0, _util.warn)(`Unimplemented annotation type "${subtype}", ` + "falling back to base annotation.");
                                }
                                return new Annotation(parameters);
                        }
                    }
                    static async _getPageIndex(xref, ref, pdfManager) {
                        try {
                            const annotDict = await xref.fetchIfRefAsync(ref);
                            if (!(annotDict instanceof _primitives.Dict)) return -1;
                            const pageRef = annotDict.getRaw("P");
                            if (pageRef instanceof _primitives.Ref) try {
                                const pageIndex = await pdfManager.ensureCatalog("getPageIndex", [
                                    pageRef
                                ]);
                                return pageIndex;
                            } catch (ex) {
                                (0, _util.info)(`_getPageIndex -- not a valid page reference: "${ex}".`);
                            }
                            if (annotDict.has("Kids")) return -1;
                            const numPages = await pdfManager.ensureDoc("numPages");
                            for(let pageIndex = 0; pageIndex < numPages; pageIndex++){
                                const page = await pdfManager.getPage(pageIndex);
                                const annotations = await pdfManager.ensure(page, "annotations");
                                for (const annotRef of annotations){
                                    if (annotRef instanceof _primitives.Ref && (0, _primitives.isRefsEqual)(annotRef, ref)) return pageIndex;
                                }
                            }
                        } catch (ex) {
                            (0, _util.warn)(`_getPageIndex: "${ex}".`);
                        }
                        return -1;
                    }
                    static generateImages(annotations, xref, isOffscreenCanvasSupported) {
                        if (!isOffscreenCanvasSupported) {
                            (0, _util.warn)("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images.");
                            return null;
                        }
                        let imagePromises;
                        for (const { bitmapId: bitmapId, bitmap: bitmap } of annotations){
                            if (!bitmap) continue;
                            imagePromises ||= new Map();
                            imagePromises.set(bitmapId, StampAnnotation.createImage(bitmap, xref));
                        }
                        return imagePromises;
                    }
                    static async saveNewAnnotations(evaluator, task, annotations, imagePromises) {
                        const xref = evaluator.xref;
                        let baseFontRef;
                        const dependencies = [];
                        const promises = [];
                        const { isOffscreenCanvasSupported: isOffscreenCanvasSupported } = evaluator.options;
                        for (const annotation of annotations){
                            if (annotation.deleted) continue;
                            switch(annotation.annotationType){
                                case _util.AnnotationEditorType.FREETEXT:
                                    if (!baseFontRef) {
                                        const baseFont = new _primitives.Dict(xref);
                                        baseFont.set("BaseFont", _primitives.Name.get("Helvetica"));
                                        baseFont.set("Type", _primitives.Name.get("Font"));
                                        baseFont.set("Subtype", _primitives.Name.get("Type1"));
                                        baseFont.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                                        const buffer = [];
                                        baseFontRef = xref.getNewTemporaryRef();
                                        await (0, _writer.writeObject)(baseFontRef, baseFont, buffer, xref);
                                        dependencies.push({
                                            ref: baseFontRef,
                                            data: buffer.join("")
                                        });
                                    }
                                    promises.push(FreeTextAnnotation.createNewAnnotation(xref, annotation, dependencies, {
                                        evaluator: evaluator,
                                        task: task,
                                        baseFontRef: baseFontRef
                                    }));
                                    break;
                                case _util.AnnotationEditorType.INK:
                                    promises.push(InkAnnotation.createNewAnnotation(xref, annotation, dependencies));
                                    break;
                                case _util.AnnotationEditorType.STAMP:
                                    if (!isOffscreenCanvasSupported) break;
                                    const image = await imagePromises.get(annotation.bitmapId);
                                    if (image.imageStream) {
                                        const { imageStream: imageStream, smaskStream: smaskStream } = image;
                                        const buffer = [];
                                        if (smaskStream) {
                                            const smaskRef = xref.getNewTemporaryRef();
                                            await (0, _writer.writeObject)(smaskRef, smaskStream, buffer, xref);
                                            dependencies.push({
                                                ref: smaskRef,
                                                data: buffer.join("")
                                            });
                                            imageStream.dict.set("SMask", smaskRef);
                                            buffer.length = 0;
                                        }
                                        const imageRef = image.imageRef = xref.getNewTemporaryRef();
                                        await (0, _writer.writeObject)(imageRef, imageStream, buffer, xref);
                                        dependencies.push({
                                            ref: imageRef,
                                            data: buffer.join("")
                                        });
                                        image.imageStream = image.smaskStream = null;
                                    }
                                    promises.push(StampAnnotation.createNewAnnotation(xref, annotation, dependencies, {
                                        image: image
                                    }));
                                    break;
                            }
                        }
                        return {
                            annotations: await Promise.all(promises),
                            dependencies: dependencies
                        };
                    }
                    static async printNewAnnotations(annotationGlobals, evaluator, task, annotations, imagePromises) {
                        if (!annotations) return null;
                        const { options: options, xref: xref } = evaluator;
                        const promises = [];
                        for (const annotation of annotations){
                            if (annotation.deleted) continue;
                            switch(annotation.annotationType){
                                case _util.AnnotationEditorType.FREETEXT:
                                    promises.push(FreeTextAnnotation.createNewPrintAnnotation(annotationGlobals, xref, annotation, {
                                        evaluator: evaluator,
                                        task: task,
                                        evaluatorOptions: options
                                    }));
                                    break;
                                case _util.AnnotationEditorType.INK:
                                    promises.push(InkAnnotation.createNewPrintAnnotation(annotationGlobals, xref, annotation, {
                                        evaluatorOptions: options
                                    }));
                                    break;
                                case _util.AnnotationEditorType.STAMP:
                                    if (!options.isOffscreenCanvasSupported) break;
                                    const image = await imagePromises.get(annotation.bitmapId);
                                    if (image.imageStream) {
                                        const { imageStream: imageStream, smaskStream: smaskStream } = image;
                                        if (smaskStream) imageStream.dict.set("SMask", smaskStream);
                                        image.imageRef = new _jpeg_stream.JpegStream(imageStream, imageStream.length);
                                        image.imageStream = image.smaskStream = null;
                                    }
                                    promises.push(StampAnnotation.createNewPrintAnnotation(annotationGlobals, xref, annotation, {
                                        image: image,
                                        evaluatorOptions: options
                                    }));
                                    break;
                            }
                        }
                        return Promise.all(promises);
                    }
                }
                exports.AnnotationFactory = AnnotationFactory;
                function getRgbColor(color, defaultColor = new Uint8ClampedArray(3)) {
                    if (!Array.isArray(color)) return defaultColor;
                    const rgbColor = defaultColor || new Uint8ClampedArray(3);
                    switch(color.length){
                        case 0:
                            return null;
                        case 1:
                            _colorspace.ColorSpace.singletons.gray.getRgbItem(color, 0, rgbColor, 0);
                            return rgbColor;
                        case 3:
                            _colorspace.ColorSpace.singletons.rgb.getRgbItem(color, 0, rgbColor, 0);
                            return rgbColor;
                        case 4:
                            _colorspace.ColorSpace.singletons.cmyk.getRgbItem(color, 0, rgbColor, 0);
                            return rgbColor;
                        default:
                            return defaultColor;
                    }
                }
                function getPdfColorArray(color) {
                    return Array.from(color, (c)=>c / 255);
                }
                function getQuadPoints(dict, rect) {
                    const quadPoints = dict.getArray("QuadPoints");
                    if (!Array.isArray(quadPoints) || quadPoints.length === 0 || quadPoints.length % 8 > 0) return null;
                    const quadPointsLists = [];
                    for(let i = 0, ii = quadPoints.length / 8; i < ii; i++){
                        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
                        for(let j = i * 8, jj = i * 8 + 8; j < jj; j += 2){
                            const x = quadPoints[j];
                            const y = quadPoints[j + 1];
                            minX = Math.min(x, minX);
                            maxX = Math.max(x, maxX);
                            minY = Math.min(y, minY);
                            maxY = Math.max(y, maxY);
                        }
                        if (rect !== null && (minX < rect[0] || maxX > rect[2] || minY < rect[1] || maxY > rect[3])) return null;
                        quadPointsLists.push([
                            {
                                x: minX,
                                y: maxY
                            },
                            {
                                x: maxX,
                                y: maxY
                            },
                            {
                                x: minX,
                                y: minY
                            },
                            {
                                x: maxX,
                                y: minY
                            }
                        ]);
                    }
                    return quadPointsLists;
                }
                function getTransformMatrix(rect, bbox, matrix) {
                    const [minX, minY, maxX, maxY] = _util.Util.getAxialAlignedBoundingBox(bbox, matrix);
                    if (minX === maxX || minY === maxY) return [
                        1,
                        0,
                        0,
                        1,
                        rect[0],
                        rect[1]
                    ];
                    const xRatio = (rect[2] - rect[0]) / (maxX - minX);
                    const yRatio = (rect[3] - rect[1]) / (maxY - minY);
                    return [
                        xRatio,
                        0,
                        0,
                        yRatio,
                        rect[0] - minX * xRatio,
                        rect[1] - minY * yRatio
                    ];
                }
                class Annotation {
                    constructor(params){
                        const { dict: dict, xref: xref, annotationGlobals: annotationGlobals } = params;
                        this.setTitle(dict.get("T"));
                        this.setContents(dict.get("Contents"));
                        this.setModificationDate(dict.get("M"));
                        this.setFlags(dict.get("F"));
                        this.setRectangle(dict.getArray("Rect"));
                        this.setColor(dict.getArray("C"));
                        this.setBorderStyle(dict);
                        this.setAppearance(dict);
                        this.setOptionalContent(dict);
                        const MK = dict.get("MK");
                        this.setBorderAndBackgroundColors(MK);
                        this.setRotation(MK, dict);
                        this.ref = params.ref instanceof _primitives.Ref ? params.ref : null;
                        this._streams = [];
                        if (this.appearance) this._streams.push(this.appearance);
                        const isLocked = !!(this.flags & _util.AnnotationFlag.LOCKED);
                        const isContentLocked = !!(this.flags & _util.AnnotationFlag.LOCKEDCONTENTS);
                        if (annotationGlobals.structTreeRoot) {
                            let structParent = dict.get("StructParent");
                            structParent = Number.isInteger(structParent) && structParent >= 0 ? structParent : -1;
                            annotationGlobals.structTreeRoot.addAnnotationIdToPage(params.pageRef, structParent);
                        }
                        this.data = {
                            annotationFlags: this.flags,
                            borderStyle: this.borderStyle,
                            color: this.color,
                            backgroundColor: this.backgroundColor,
                            borderColor: this.borderColor,
                            rotation: this.rotation,
                            contentsObj: this._contents,
                            hasAppearance: !!this.appearance,
                            id: params.id,
                            modificationDate: this.modificationDate,
                            rect: this.rectangle,
                            subtype: params.subtype,
                            hasOwnCanvas: false,
                            noRotate: !!(this.flags & _util.AnnotationFlag.NOROTATE),
                            noHTML: isLocked && isContentLocked
                        };
                        if (params.collectFields) {
                            const kids = dict.get("Kids");
                            if (Array.isArray(kids)) {
                                const kidIds = [];
                                for (const kid of kids)if (kid instanceof _primitives.Ref) kidIds.push(kid.toString());
                                if (kidIds.length !== 0) this.data.kidIds = kidIds;
                            }
                            this.data.actions = (0, _core_utils.collectActions)(xref, dict, _util.AnnotationActionEventType);
                            this.data.fieldName = this._constructFieldName(dict);
                            this.data.pageIndex = params.pageIndex;
                        }
                        this._isOffscreenCanvasSupported = params.evaluatorOptions.isOffscreenCanvasSupported;
                        this._fallbackFontDict = null;
                        this._needAppearances = false;
                    }
                    _hasFlag(flags, flag) {
                        return !!(flags & flag);
                    }
                    _isViewable(flags) {
                        return !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util.AnnotationFlag.NOVIEW);
                    }
                    _isPrintable(flags) {
                        return this._hasFlag(flags, _util.AnnotationFlag.PRINT) && !this._hasFlag(flags, _util.AnnotationFlag.HIDDEN) && !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE);
                    }
                    mustBeViewed(annotationStorage, _renderForms) {
                        const noView = annotationStorage?.get(this.data.id)?.noView;
                        if (noView !== undefined) return !noView;
                        return this.viewable && !this._hasFlag(this.flags, _util.AnnotationFlag.HIDDEN);
                    }
                    mustBePrinted(annotationStorage) {
                        const noPrint = annotationStorage?.get(this.data.id)?.noPrint;
                        if (noPrint !== undefined) return !noPrint;
                        return this.printable;
                    }
                    get viewable() {
                        if (this.data.quadPoints === null) return false;
                        if (this.flags === 0) return true;
                        return this._isViewable(this.flags);
                    }
                    get printable() {
                        if (this.data.quadPoints === null) return false;
                        if (this.flags === 0) return false;
                        return this._isPrintable(this.flags);
                    }
                    _parseStringHelper(data) {
                        const str = typeof data === "string" ? (0, _util.stringToPDFString)(data) : "";
                        const dir = str && (0, _bidi.bidi)(str).dir === "rtl" ? "rtl" : "ltr";
                        return {
                            str: str,
                            dir: dir
                        };
                    }
                    setDefaultAppearance(params) {
                        const { dict: dict, annotationGlobals: annotationGlobals } = params;
                        const defaultAppearance = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "DA"
                        }) || annotationGlobals.acroForm.get("DA");
                        this._defaultAppearance = typeof defaultAppearance === "string" ? defaultAppearance : "";
                        this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance);
                    }
                    setTitle(title) {
                        this._title = this._parseStringHelper(title);
                    }
                    setContents(contents) {
                        this._contents = this._parseStringHelper(contents);
                    }
                    setModificationDate(modificationDate) {
                        this.modificationDate = typeof modificationDate === "string" ? modificationDate : null;
                    }
                    setFlags(flags) {
                        this.flags = Number.isInteger(flags) && flags > 0 ? flags : 0;
                    }
                    hasFlag(flag) {
                        return this._hasFlag(this.flags, flag);
                    }
                    setRectangle(rectangle) {
                        this.rectangle = Array.isArray(rectangle) && rectangle.length === 4 ? _util.Util.normalizeRect(rectangle) : [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    setColor(color) {
                        this.color = getRgbColor(color);
                    }
                    setLineEndings(lineEndings) {
                        this.lineEndings = [
                            "None",
                            "None"
                        ];
                        if (Array.isArray(lineEndings) && lineEndings.length === 2) for(let i = 0; i < 2; i++){
                            const obj = lineEndings[i];
                            if (obj instanceof _primitives.Name) switch(obj.name){
                                case "None":
                                    continue;
                                case "Square":
                                case "Circle":
                                case "Diamond":
                                case "OpenArrow":
                                case "ClosedArrow":
                                case "Butt":
                                case "ROpenArrow":
                                case "RClosedArrow":
                                case "Slash":
                                    this.lineEndings[i] = obj.name;
                                    continue;
                            }
                            (0, _util.warn)(`Ignoring invalid lineEnding: ${obj}`);
                        }
                    }
                    setRotation(mk, dict) {
                        this.rotation = 0;
                        let angle = mk instanceof _primitives.Dict ? mk.get("R") || 0 : dict.get("Rotate") || 0;
                        if (Number.isInteger(angle) && angle !== 0) {
                            angle %= 360;
                            if (angle < 0) angle += 360;
                            if (angle % 90 === 0) this.rotation = angle;
                        }
                    }
                    setBorderAndBackgroundColors(mk) {
                        if (mk instanceof _primitives.Dict) {
                            this.borderColor = getRgbColor(mk.getArray("BC"), null);
                            this.backgroundColor = getRgbColor(mk.getArray("BG"), null);
                        } else this.borderColor = this.backgroundColor = null;
                    }
                    setBorderStyle(borderStyle) {
                        this.borderStyle = new AnnotationBorderStyle();
                        if (!(borderStyle instanceof _primitives.Dict)) return;
                        if (borderStyle.has("BS")) {
                            const dict = borderStyle.get("BS");
                            const dictType = dict.get("Type");
                            if (!dictType || (0, _primitives.isName)(dictType, "Border")) {
                                this.borderStyle.setWidth(dict.get("W"), this.rectangle);
                                this.borderStyle.setStyle(dict.get("S"));
                                this.borderStyle.setDashArray(dict.getArray("D"));
                            }
                        } else if (borderStyle.has("Border")) {
                            const array = borderStyle.getArray("Border");
                            if (Array.isArray(array) && array.length >= 3) {
                                this.borderStyle.setHorizontalCornerRadius(array[0]);
                                this.borderStyle.setVerticalCornerRadius(array[1]);
                                this.borderStyle.setWidth(array[2], this.rectangle);
                                if (array.length === 4) this.borderStyle.setDashArray(array[3], true);
                            }
                        } else this.borderStyle.setWidth(0);
                    }
                    setAppearance(dict) {
                        this.appearance = null;
                        const appearanceStates = dict.get("AP");
                        if (!(appearanceStates instanceof _primitives.Dict)) return;
                        const normalAppearanceState = appearanceStates.get("N");
                        if (normalAppearanceState instanceof _base_stream.BaseStream) {
                            this.appearance = normalAppearanceState;
                            return;
                        }
                        if (!(normalAppearanceState instanceof _primitives.Dict)) return;
                        const as = dict.get("AS");
                        if (!(as instanceof _primitives.Name) || !normalAppearanceState.has(as.name)) return;
                        const appearance = normalAppearanceState.get(as.name);
                        if (appearance instanceof _base_stream.BaseStream) this.appearance = appearance;
                    }
                    setOptionalContent(dict) {
                        this.oc = null;
                        const oc = dict.get("OC");
                        if (oc instanceof _primitives.Name) (0, _util.warn)("setOptionalContent: Support for /Name-entry is not implemented.");
                        else if (oc instanceof _primitives.Dict) this.oc = oc;
                    }
                    loadResources(keys, appearance) {
                        return appearance.dict.getAsync("Resources").then((resources)=>{
                            if (!resources) return undefined;
                            const objectLoader = new _object_loader.ObjectLoader(resources, keys, resources.xref);
                            return objectLoader.load().then(function() {
                                return resources;
                            });
                        });
                    }
                    async getOperatorList(evaluator, task, intent, renderForms, annotationStorage) {
                        const data = this.data;
                        let appearance = this.appearance;
                        const isUsingOwnCanvas = !!(this.data.hasOwnCanvas && intent & _util.RenderingIntentFlag.DISPLAY);
                        if (!appearance) {
                            if (!isUsingOwnCanvas) return {
                                opList: new _operator_list.OperatorList(),
                                separateForm: false,
                                separateCanvas: false
                            };
                            appearance = new _stream.StringStream("");
                            appearance.dict = new _primitives.Dict();
                        }
                        const appearanceDict = appearance.dict;
                        const resources = await this.loadResources([
                            "ExtGState",
                            "ColorSpace",
                            "Pattern",
                            "Shading",
                            "XObject",
                            "Font"
                        ], appearance);
                        const bbox = appearanceDict.getArray("BBox") || [
                            0,
                            0,
                            1,
                            1
                        ];
                        const matrix = appearanceDict.getArray("Matrix") || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        const transform = getTransformMatrix(data.rect, bbox, matrix);
                        const opList = new _operator_list.OperatorList();
                        let optionalContent;
                        if (this.oc) optionalContent = await evaluator.parseMarkedContentProps(this.oc, null);
                        if (optionalContent !== undefined) opList.addOp(_util.OPS.beginMarkedContentProps, [
                            "OC",
                            optionalContent
                        ]);
                        opList.addOp(_util.OPS.beginAnnotation, [
                            data.id,
                            data.rect,
                            transform,
                            matrix,
                            isUsingOwnCanvas
                        ]);
                        await evaluator.getOperatorList({
                            stream: appearance,
                            task: task,
                            resources: resources,
                            operatorList: opList,
                            fallbackFontDict: this._fallbackFontDict
                        });
                        opList.addOp(_util.OPS.endAnnotation, []);
                        if (optionalContent !== undefined) opList.addOp(_util.OPS.endMarkedContent, []);
                        this.reset();
                        return {
                            opList: opList,
                            separateForm: false,
                            separateCanvas: isUsingOwnCanvas
                        };
                    }
                    async save(evaluator, task, annotationStorage) {
                        return null;
                    }
                    get hasTextContent() {
                        return false;
                    }
                    async extractTextContent(evaluator, task, viewBox) {
                        if (!this.appearance) return;
                        const resources = await this.loadResources([
                            "ExtGState",
                            "Font",
                            "Properties",
                            "XObject"
                        ], this.appearance);
                        const text = [];
                        const buffer = [];
                        let firstPosition = null;
                        const sink = {
                            desiredSize: Math.Infinity,
                            ready: true,
                            enqueue (chunk, size) {
                                for (const item of chunk.items){
                                    if (item.str === undefined) continue;
                                    firstPosition ||= item.transform.slice(-2);
                                    buffer.push(item.str);
                                    if (item.hasEOL) {
                                        text.push(buffer.join(""));
                                        buffer.length = 0;
                                    }
                                }
                            }
                        };
                        await evaluator.getTextContent({
                            stream: this.appearance,
                            task: task,
                            resources: resources,
                            includeMarkedContent: true,
                            sink: sink,
                            viewBox: viewBox
                        });
                        this.reset();
                        if (buffer.length) text.push(buffer.join(""));
                        if (text.length > 1 || text[0]) {
                            const appearanceDict = this.appearance.dict;
                            const bbox = appearanceDict.getArray("BBox") || [
                                0,
                                0,
                                1,
                                1
                            ];
                            const matrix = appearanceDict.getArray("Matrix") || [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ];
                            const rect = this.data.rect;
                            const transform = getTransformMatrix(rect, bbox, matrix);
                            transform[4] -= rect[0];
                            transform[5] -= rect[1];
                            firstPosition = _util.Util.applyTransform(firstPosition, transform);
                            firstPosition = _util.Util.applyTransform(firstPosition, matrix);
                            this.data.textPosition = firstPosition;
                            this.data.textContent = text;
                        }
                    }
                    getFieldObject() {
                        if (this.data.kidIds) return {
                            id: this.data.id,
                            actions: this.data.actions,
                            name: this.data.fieldName,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            type: "",
                            kidIds: this.data.kidIds,
                            page: this.data.pageIndex,
                            rotation: this.rotation
                        };
                        return null;
                    }
                    reset() {
                        for (const stream of this._streams)stream.reset();
                    }
                    _constructFieldName(dict) {
                        if (!dict.has("T") && !dict.has("Parent")) {
                            (0, _util.warn)("Unknown field name, falling back to empty field name.");
                            return "";
                        }
                        if (!dict.has("Parent")) return (0, _util.stringToPDFString)(dict.get("T"));
                        const fieldName = [];
                        if (dict.has("T")) fieldName.unshift((0, _util.stringToPDFString)(dict.get("T")));
                        let loopDict = dict;
                        const visited = new _primitives.RefSet();
                        if (dict.objId) visited.put(dict.objId);
                        while(loopDict.has("Parent")){
                            loopDict = loopDict.get("Parent");
                            if (!(loopDict instanceof _primitives.Dict) || loopDict.objId && visited.has(loopDict.objId)) break;
                            if (loopDict.objId) visited.put(loopDict.objId);
                            if (loopDict.has("T")) fieldName.unshift((0, _util.stringToPDFString)(loopDict.get("T")));
                        }
                        return fieldName.join(".");
                    }
                }
                exports.Annotation = Annotation;
                class AnnotationBorderStyle {
                    constructor(){
                        this.width = 1;
                        this.style = _util.AnnotationBorderStyleType.SOLID;
                        this.dashArray = [
                            3
                        ];
                        this.horizontalCornerRadius = 0;
                        this.verticalCornerRadius = 0;
                    }
                    setWidth(width, rect = [
                        0,
                        0,
                        0,
                        0
                    ]) {
                        if (width instanceof _primitives.Name) {
                            this.width = 0;
                            return;
                        }
                        if (typeof width === "number") {
                            if (width > 0) {
                                const maxWidth = (rect[2] - rect[0]) / 2;
                                const maxHeight = (rect[3] - rect[1]) / 2;
                                if (maxWidth > 0 && maxHeight > 0 && (width > maxWidth || width > maxHeight)) {
                                    (0, _util.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${width}`);
                                    width = 1;
                                }
                            }
                            this.width = width;
                        }
                    }
                    setStyle(style) {
                        if (!(style instanceof _primitives.Name)) return;
                        switch(style.name){
                            case "S":
                                this.style = _util.AnnotationBorderStyleType.SOLID;
                                break;
                            case "D":
                                this.style = _util.AnnotationBorderStyleType.DASHED;
                                break;
                            case "B":
                                this.style = _util.AnnotationBorderStyleType.BEVELED;
                                break;
                            case "I":
                                this.style = _util.AnnotationBorderStyleType.INSET;
                                break;
                            case "U":
                                this.style = _util.AnnotationBorderStyleType.UNDERLINE;
                                break;
                            default:
                                break;
                        }
                    }
                    setDashArray(dashArray, forceStyle = false) {
                        if (Array.isArray(dashArray) && dashArray.length > 0) {
                            let isValid = true;
                            let allZeros = true;
                            for (const element of dashArray){
                                const validNumber = +element >= 0;
                                if (!validNumber) {
                                    isValid = false;
                                    break;
                                } else if (element > 0) allZeros = false;
                            }
                            if (isValid && !allZeros) {
                                this.dashArray = dashArray;
                                if (forceStyle) this.setStyle(_primitives.Name.get("D"));
                            } else this.width = 0;
                        } else if (dashArray) this.width = 0;
                    }
                    setHorizontalCornerRadius(radius) {
                        if (Number.isInteger(radius)) this.horizontalCornerRadius = radius;
                    }
                    setVerticalCornerRadius(radius) {
                        if (Number.isInteger(radius)) this.verticalCornerRadius = radius;
                    }
                }
                exports.AnnotationBorderStyle = AnnotationBorderStyle;
                class MarkupAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        const { dict: dict } = params;
                        if (dict.has("IRT")) {
                            const rawIRT = dict.getRaw("IRT");
                            this.data.inReplyTo = rawIRT instanceof _primitives.Ref ? rawIRT.toString() : null;
                            const rt = dict.get("RT");
                            this.data.replyType = rt instanceof _primitives.Name ? rt.name : _util.AnnotationReplyType.REPLY;
                        }
                        let popupRef = null;
                        if (this.data.replyType === _util.AnnotationReplyType.GROUP) {
                            const parent = dict.get("IRT");
                            this.setTitle(parent.get("T"));
                            this.data.titleObj = this._title;
                            this.setContents(parent.get("Contents"));
                            this.data.contentsObj = this._contents;
                            if (!parent.has("CreationDate")) this.data.creationDate = null;
                            else {
                                this.setCreationDate(parent.get("CreationDate"));
                                this.data.creationDate = this.creationDate;
                            }
                            if (!parent.has("M")) this.data.modificationDate = null;
                            else {
                                this.setModificationDate(parent.get("M"));
                                this.data.modificationDate = this.modificationDate;
                            }
                            popupRef = parent.getRaw("Popup");
                            if (!parent.has("C")) this.data.color = null;
                            else {
                                this.setColor(parent.getArray("C"));
                                this.data.color = this.color;
                            }
                        } else {
                            this.data.titleObj = this._title;
                            this.setCreationDate(dict.get("CreationDate"));
                            this.data.creationDate = this.creationDate;
                            popupRef = dict.getRaw("Popup");
                            if (!dict.has("C")) this.data.color = null;
                        }
                        this.data.popupRef = popupRef instanceof _primitives.Ref ? popupRef.toString() : null;
                        if (dict.has("RC")) this.data.richText = _factory.XFAFactory.getRichTextAsHtml(dict.get("RC"));
                    }
                    setCreationDate(creationDate) {
                        this.creationDate = typeof creationDate === "string" ? creationDate : null;
                    }
                    _setDefaultAppearance({ xref: xref, extra: extra, strokeColor: strokeColor, fillColor: fillColor, blendMode: blendMode, strokeAlpha: strokeAlpha, fillAlpha: fillAlpha, pointsCallback: pointsCallback }) {
                        let minX = Number.MAX_VALUE;
                        let minY = Number.MAX_VALUE;
                        let maxX = Number.MIN_VALUE;
                        let maxY = Number.MIN_VALUE;
                        const buffer = [
                            "q"
                        ];
                        if (extra) buffer.push(extra);
                        if (strokeColor) buffer.push(`${strokeColor[0]} ${strokeColor[1]} ${strokeColor[2]} RG`);
                        if (fillColor) buffer.push(`${fillColor[0]} ${fillColor[1]} ${fillColor[2]} rg`);
                        let pointsArray = this.data.quadPoints;
                        if (!pointsArray) pointsArray = [
                            [
                                {
                                    x: this.rectangle[0],
                                    y: this.rectangle[3]
                                },
                                {
                                    x: this.rectangle[2],
                                    y: this.rectangle[3]
                                },
                                {
                                    x: this.rectangle[0],
                                    y: this.rectangle[1]
                                },
                                {
                                    x: this.rectangle[2],
                                    y: this.rectangle[1]
                                }
                            ]
                        ];
                        for (const points of pointsArray){
                            const [mX, MX, mY, MY] = pointsCallback(buffer, points);
                            minX = Math.min(minX, mX);
                            maxX = Math.max(maxX, MX);
                            minY = Math.min(minY, mY);
                            maxY = Math.max(maxY, MY);
                        }
                        buffer.push("Q");
                        const formDict = new _primitives.Dict(xref);
                        const appearanceStreamDict = new _primitives.Dict(xref);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        const appearanceStream = new _stream.StringStream(buffer.join(" "));
                        appearanceStream.dict = appearanceStreamDict;
                        formDict.set("Fm0", appearanceStream);
                        const gsDict = new _primitives.Dict(xref);
                        if (blendMode) gsDict.set("BM", _primitives.Name.get(blendMode));
                        if (typeof strokeAlpha === "number") gsDict.set("CA", strokeAlpha);
                        if (typeof fillAlpha === "number") gsDict.set("ca", fillAlpha);
                        const stateDict = new _primitives.Dict(xref);
                        stateDict.set("GS0", gsDict);
                        const resources = new _primitives.Dict(xref);
                        resources.set("ExtGState", stateDict);
                        resources.set("XObject", formDict);
                        const appearanceDict = new _primitives.Dict(xref);
                        appearanceDict.set("Resources", resources);
                        const bbox = this.data.rect = [
                            minX,
                            minY,
                            maxX,
                            maxY
                        ];
                        appearanceDict.set("BBox", bbox);
                        this.appearance = new _stream.StringStream("/GS0 gs /Fm0 Do");
                        this.appearance.dict = appearanceDict;
                        this._streams.push(this.appearance, appearanceStream);
                    }
                    static async createNewAnnotation(xref, annotation, dependencies, params) {
                        const annotationRef = annotation.ref ||= xref.getNewTemporaryRef();
                        const ap = await this.createNewAppearanceStream(annotation, xref, params);
                        const buffer = [];
                        let annotationDict;
                        if (ap) {
                            const apRef = xref.getNewTemporaryRef();
                            annotationDict = this.createNewDict(annotation, xref, {
                                apRef: apRef
                            });
                            await (0, _writer.writeObject)(apRef, ap, buffer, xref);
                            dependencies.push({
                                ref: apRef,
                                data: buffer.join("")
                            });
                        } else annotationDict = this.createNewDict(annotation, xref, {});
                        if (Number.isInteger(annotation.parentTreeId)) annotationDict.set("StructParent", annotation.parentTreeId);
                        buffer.length = 0;
                        await (0, _writer.writeObject)(annotationRef, annotationDict, buffer, xref);
                        return {
                            ref: annotationRef,
                            data: buffer.join("")
                        };
                    }
                    static async createNewPrintAnnotation(annotationGlobals, xref, annotation, params) {
                        const ap = await this.createNewAppearanceStream(annotation, xref, params);
                        const annotationDict = this.createNewDict(annotation, xref, {
                            ap: ap
                        });
                        const newAnnotation = new this.prototype.constructor({
                            dict: annotationDict,
                            xref: xref,
                            annotationGlobals: annotationGlobals,
                            evaluatorOptions: params.evaluatorOptions
                        });
                        if (annotation.ref) newAnnotation.ref = newAnnotation.refToReplace = annotation.ref;
                        return newAnnotation;
                    }
                }
                exports.MarkupAnnotation = MarkupAnnotation;
                class WidgetAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref, annotationGlobals: annotationGlobals } = params;
                        const data = this.data;
                        this._needAppearances = params.needAppearances;
                        data.annotationType = _util.AnnotationType.WIDGET;
                        if (data.fieldName === undefined) data.fieldName = this._constructFieldName(dict);
                        if (data.actions === undefined) data.actions = (0, _core_utils.collectActions)(xref, dict, _util.AnnotationActionEventType);
                        let fieldValue = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "V",
                            getArray: true
                        });
                        data.fieldValue = this._decodeFormValue(fieldValue);
                        const defaultFieldValue = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "DV",
                            getArray: true
                        });
                        data.defaultFieldValue = this._decodeFormValue(defaultFieldValue);
                        if (fieldValue === undefined && annotationGlobals.xfaDatasets) {
                            const path = this._title.str;
                            if (path) {
                                this._hasValueFromXFA = true;
                                data.fieldValue = fieldValue = annotationGlobals.xfaDatasets.getValue(path);
                            }
                        }
                        if (fieldValue === undefined && data.defaultFieldValue !== null) data.fieldValue = data.defaultFieldValue;
                        data.alternativeText = (0, _util.stringToPDFString)(dict.get("TU") || "");
                        this.setDefaultAppearance(params);
                        data.hasAppearance ||= this._needAppearances && data.fieldValue !== undefined && data.fieldValue !== null;
                        const fieldType = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "FT"
                        });
                        data.fieldType = fieldType instanceof _primitives.Name ? fieldType.name : null;
                        const localResources = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "DR"
                        });
                        const acroFormResources = annotationGlobals.acroForm.get("DR");
                        const appearanceResources = this.appearance?.dict.get("Resources");
                        this._fieldResources = {
                            localResources: localResources,
                            acroFormResources: acroFormResources,
                            appearanceResources: appearanceResources,
                            mergedResources: _primitives.Dict.merge({
                                xref: xref,
                                dictArray: [
                                    localResources,
                                    appearanceResources,
                                    acroFormResources
                                ],
                                mergeSubDicts: true
                            })
                        };
                        data.fieldFlags = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "Ff"
                        });
                        if (!Number.isInteger(data.fieldFlags) || data.fieldFlags < 0) data.fieldFlags = 0;
                        data.readOnly = this.hasFieldFlag(_util.AnnotationFieldFlag.READONLY);
                        data.required = this.hasFieldFlag(_util.AnnotationFieldFlag.REQUIRED);
                        data.hidden = this._hasFlag(data.annotationFlags, _util.AnnotationFlag.HIDDEN) || this._hasFlag(data.annotationFlags, _util.AnnotationFlag.NOVIEW);
                    }
                    _decodeFormValue(formValue) {
                        if (Array.isArray(formValue)) return formValue.filter((item)=>typeof item === "string").map((item)=>(0, _util.stringToPDFString)(item));
                        else if (formValue instanceof _primitives.Name) return (0, _util.stringToPDFString)(formValue.name);
                        else if (typeof formValue === "string") return (0, _util.stringToPDFString)(formValue);
                        return null;
                    }
                    hasFieldFlag(flag) {
                        return !!(this.data.fieldFlags & flag);
                    }
                    _isViewable(flags) {
                        return !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE);
                    }
                    mustBeViewed(annotationStorage, renderForms) {
                        if (renderForms) return this.viewable;
                        return super.mustBeViewed(annotationStorage, renderForms) && !this._hasFlag(this.flags, _util.AnnotationFlag.NOVIEW);
                    }
                    getRotationMatrix(annotationStorage) {
                        let rotation = annotationStorage?.get(this.data.id)?.rotation;
                        if (rotation === undefined) rotation = this.rotation;
                        if (rotation === 0) return _util.IDENTITY_MATRIX;
                        const width = this.data.rect[2] - this.data.rect[0];
                        const height = this.data.rect[3] - this.data.rect[1];
                        return (0, _core_utils.getRotationMatrix)(rotation, width, height);
                    }
                    getBorderAndBackgroundAppearances(annotationStorage) {
                        let rotation = annotationStorage?.get(this.data.id)?.rotation;
                        if (rotation === undefined) rotation = this.rotation;
                        if (!this.backgroundColor && !this.borderColor) return "";
                        const width = this.data.rect[2] - this.data.rect[0];
                        const height = this.data.rect[3] - this.data.rect[1];
                        const rect = rotation === 0 || rotation === 180 ? `0 0 ${width} ${height} re` : `0 0 ${height} ${width} re`;
                        let str = "";
                        if (this.backgroundColor) str = `${(0, _default_appearance.getPdfColor)(this.backgroundColor, true)} ${rect} f `;
                        if (this.borderColor) {
                            const borderWidth = this.borderStyle.width || 1;
                            str += `${borderWidth} w ${(0, _default_appearance.getPdfColor)(this.borderColor, false)} ${rect} S `;
                        }
                        return str;
                    }
                    async getOperatorList(evaluator, task, intent, renderForms, annotationStorage) {
                        if (renderForms && !(this instanceof SignatureWidgetAnnotation) && !this.data.noHTML && !this.data.hasOwnCanvas) return {
                            opList: new _operator_list.OperatorList(),
                            separateForm: true,
                            separateCanvas: false
                        };
                        if (!this._hasText) return super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                        const content = await this._getAppearance(evaluator, task, intent, annotationStorage);
                        if (this.appearance && content === null) return super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                        const opList = new _operator_list.OperatorList();
                        if (!this._defaultAppearance || content === null) return {
                            opList: opList,
                            separateForm: false,
                            separateCanvas: false
                        };
                        const isUsingOwnCanvas = !!(this.data.hasOwnCanvas && intent & _util.RenderingIntentFlag.DISPLAY);
                        const matrix = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        const bbox = [
                            0,
                            0,
                            this.data.rect[2] - this.data.rect[0],
                            this.data.rect[3] - this.data.rect[1]
                        ];
                        const transform = getTransformMatrix(this.data.rect, bbox, matrix);
                        let optionalContent;
                        if (this.oc) optionalContent = await evaluator.parseMarkedContentProps(this.oc, null);
                        if (optionalContent !== undefined) opList.addOp(_util.OPS.beginMarkedContentProps, [
                            "OC",
                            optionalContent
                        ]);
                        opList.addOp(_util.OPS.beginAnnotation, [
                            this.data.id,
                            this.data.rect,
                            transform,
                            this.getRotationMatrix(annotationStorage),
                            isUsingOwnCanvas
                        ]);
                        const stream = new _stream.StringStream(content);
                        await evaluator.getOperatorList({
                            stream: stream,
                            task: task,
                            resources: this._fieldResources.mergedResources,
                            operatorList: opList
                        });
                        opList.addOp(_util.OPS.endAnnotation, []);
                        if (optionalContent !== undefined) opList.addOp(_util.OPS.endMarkedContent, []);
                        return {
                            opList: opList,
                            separateForm: false,
                            separateCanvas: isUsingOwnCanvas
                        };
                    }
                    _getMKDict(rotation) {
                        const mk = new _primitives.Dict(null);
                        if (rotation) mk.set("R", rotation);
                        if (this.borderColor) mk.set("BC", getPdfColorArray(this.borderColor));
                        if (this.backgroundColor) mk.set("BG", getPdfColorArray(this.backgroundColor));
                        return mk.size > 0 ? mk : null;
                    }
                    amendSavedDict(annotationStorage, dict) {}
                    async save(evaluator, task, annotationStorage) {
                        const storageEntry = annotationStorage?.get(this.data.id);
                        let value = storageEntry?.value, rotation = storageEntry?.rotation;
                        if (value === this.data.fieldValue || value === undefined) {
                            if (!this._hasValueFromXFA && rotation === undefined) return null;
                            value ||= this.data.fieldValue;
                        }
                        if (rotation === undefined && !this._hasValueFromXFA && Array.isArray(value) && Array.isArray(this.data.fieldValue) && value.length === this.data.fieldValue.length && value.every((x, i)=>x === this.data.fieldValue[i])) return null;
                        if (rotation === undefined) rotation = this.rotation;
                        let appearance = null;
                        if (!this._needAppearances) {
                            appearance = await this._getAppearance(evaluator, task, _util.RenderingIntentFlag.SAVE, annotationStorage);
                            if (appearance === null) return null;
                        }
                        let needAppearances = false;
                        if (appearance?.needAppearances) {
                            needAppearances = true;
                            appearance = null;
                        }
                        const { xref: xref } = evaluator;
                        const originalDict = xref.fetchIfRef(this.ref);
                        if (!(originalDict instanceof _primitives.Dict)) return null;
                        const dict = new _primitives.Dict(xref);
                        for (const key of originalDict.getKeys())if (key !== "AP") dict.set(key, originalDict.getRaw(key));
                        const xfa = {
                            path: this.data.fieldName,
                            value: value
                        };
                        const encoder = (val)=>{
                            return (0, _core_utils.isAscii)(val) ? val : (0, _core_utils.stringToUTF16String)(val, true);
                        };
                        dict.set("V", Array.isArray(value) ? value.map(encoder) : encoder(value));
                        this.amendSavedDict(annotationStorage, dict);
                        const maybeMK = this._getMKDict(rotation);
                        if (maybeMK) dict.set("MK", maybeMK);
                        const buffer = [];
                        const changes = [
                            {
                                ref: this.ref,
                                data: "",
                                xfa: xfa,
                                needAppearances: needAppearances
                            }
                        ];
                        if (appearance !== null) {
                            const newRef = xref.getNewTemporaryRef();
                            const AP = new _primitives.Dict(xref);
                            dict.set("AP", AP);
                            AP.set("N", newRef);
                            const resources = this._getSaveFieldResources(xref);
                            const appearanceStream = new _stream.StringStream(appearance);
                            const appearanceDict = appearanceStream.dict = new _primitives.Dict(xref);
                            appearanceDict.set("Subtype", _primitives.Name.get("Form"));
                            appearanceDict.set("Resources", resources);
                            appearanceDict.set("BBox", [
                                0,
                                0,
                                this.data.rect[2] - this.data.rect[0],
                                this.data.rect[3] - this.data.rect[1]
                            ]);
                            const rotationMatrix = this.getRotationMatrix(annotationStorage);
                            if (rotationMatrix !== _util.IDENTITY_MATRIX) appearanceDict.set("Matrix", rotationMatrix);
                            await (0, _writer.writeObject)(newRef, appearanceStream, buffer, xref);
                            changes.push({
                                ref: newRef,
                                data: buffer.join(""),
                                xfa: null,
                                needAppearances: false
                            });
                            buffer.length = 0;
                        }
                        dict.set("M", `D:${(0, _util.getModificationDate)()}`);
                        await (0, _writer.writeObject)(this.ref, dict, buffer, xref);
                        changes[0].data = buffer.join("");
                        return changes;
                    }
                    async _getAppearance(evaluator, task, intent, annotationStorage) {
                        const isPassword = this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD);
                        if (isPassword) return null;
                        const storageEntry = annotationStorage?.get(this.data.id);
                        let value, rotation;
                        if (storageEntry) {
                            value = storageEntry.formattedValue || storageEntry.value;
                            rotation = storageEntry.rotation;
                        }
                        if (rotation === undefined && value === undefined && !this._needAppearances) {
                            if (!this._hasValueFromXFA || this.appearance) return null;
                        }
                        const colors = this.getBorderAndBackgroundAppearances(annotationStorage);
                        if (value === undefined) {
                            value = this.data.fieldValue;
                            if (!value) return `/Tx BMC q ${colors}Q EMC`;
                        }
                        if (Array.isArray(value) && value.length === 1) value = value[0];
                        (0, _util.assert)(typeof value === "string", "Expected `value` to be a string.");
                        value = value.trim();
                        if (this.data.combo) {
                            const option = this.data.options.find(({ exportValue: exportValue })=>value === exportValue);
                            value = option?.displayValue || value;
                        }
                        if (value === "") return `/Tx BMC q ${colors}Q EMC`;
                        if (rotation === undefined) rotation = this.rotation;
                        let lineCount = -1;
                        let lines;
                        if (this.data.multiLine) {
                            lines = value.split(/\r\n?|\n/).map((line)=>line.normalize("NFC"));
                            lineCount = lines.length;
                        } else lines = [
                            value.replace(/\r\n?|\n/, "").normalize("NFC")
                        ];
                        const defaultPadding = 1;
                        const defaultHPadding = 2;
                        let totalHeight = this.data.rect[3] - this.data.rect[1];
                        let totalWidth = this.data.rect[2] - this.data.rect[0];
                        if (rotation === 90 || rotation === 270) [totalWidth, totalHeight] = [
                            totalHeight,
                            totalWidth
                        ];
                        if (!this._defaultAppearance) this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g");
                        let font1 = await WidgetAnnotation._getFontData(evaluator, task, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
                        let defaultAppearance, fontSize, lineHeight;
                        const encodedLines = [];
                        let encodingError = false;
                        for (const line of lines){
                            const encodedString = font1.encodeString(line);
                            if (encodedString.length > 1) encodingError = true;
                            encodedLines.push(encodedString.join(""));
                        }
                        if (encodingError && intent & _util.RenderingIntentFlag.SAVE) return {
                            needAppearances: true
                        };
                        if (encodingError && this._isOffscreenCanvasSupported) {
                            const fontFamily = this.data.comb ? "monospace" : "sans-serif";
                            const fakeUnicodeFont = new _default_appearance.FakeUnicodeFont(evaluator.xref, fontFamily);
                            const resources = fakeUnicodeFont.createFontResources(lines.join(""));
                            const newFont = resources.getRaw("Font");
                            if (this._fieldResources.mergedResources.has("Font")) {
                                const oldFont = this._fieldResources.mergedResources.get("Font");
                                for (const key of newFont.getKeys())oldFont.set(key, newFont.getRaw(key));
                            } else this._fieldResources.mergedResources.set("Font", newFont);
                            const fontName = fakeUnicodeFont.fontName.name;
                            font1 = await WidgetAnnotation._getFontData(evaluator, task, {
                                fontName: fontName,
                                fontSize: 0
                            }, resources);
                            for(let i = 0, ii = encodedLines.length; i < ii; i++)encodedLines[i] = (0, _core_utils.stringToUTF16String)(lines[i]);
                            const savedDefaultAppearance = Object.assign(Object.create(null), this.data.defaultAppearanceData);
                            this.data.defaultAppearanceData.fontSize = 0;
                            this.data.defaultAppearanceData.fontName = fontName;
                            [defaultAppearance, fontSize, lineHeight] = this._computeFontSize(totalHeight - 2 * defaultPadding, totalWidth - 2 * defaultHPadding, value, font1, lineCount);
                            this.data.defaultAppearanceData = savedDefaultAppearance;
                        } else {
                            if (!this._isOffscreenCanvasSupported) (0, _util.warn)("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly.");
                            [defaultAppearance, fontSize, lineHeight] = this._computeFontSize(totalHeight - 2 * defaultPadding, totalWidth - 2 * defaultHPadding, value, font1, lineCount);
                        }
                        let descent = font1.descent;
                        if (isNaN(descent)) descent = _util.BASELINE_FACTOR * lineHeight;
                        else descent = Math.max(_util.BASELINE_FACTOR * lineHeight, Math.abs(descent) * fontSize);
                        const defaultVPadding = Math.min(Math.floor((totalHeight - fontSize) / 2), defaultPadding);
                        const alignment = this.data.textAlignment;
                        if (this.data.multiLine) return this._getMultilineAppearance(defaultAppearance, encodedLines, font1, fontSize, totalWidth, totalHeight, alignment, defaultHPadding, defaultVPadding, descent, lineHeight, annotationStorage);
                        if (this.data.comb) return this._getCombAppearance(defaultAppearance, font1, encodedLines[0], fontSize, totalWidth, totalHeight, defaultHPadding, defaultVPadding, descent, lineHeight, annotationStorage);
                        const bottomPadding = defaultVPadding + descent;
                        if (alignment === 0 || alignment > 2) return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 ${(0, _core_utils.numberToString)(defaultHPadding)} ${(0, _core_utils.numberToString)(bottomPadding)} Tm (${(0, _core_utils.escapeString)(encodedLines[0])}) Tj` + " ET Q EMC";
                        const prevInfo = {
                            shift: 0
                        };
                        const renderedText = this._renderText(encodedLines[0], font1, fontSize, totalWidth, alignment, prevInfo, defaultHPadding, bottomPadding);
                        return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 0 0 Tm ${renderedText}` + " ET Q EMC";
                    }
                    static async _getFontData(evaluator, task, appearanceData, resources) {
                        const operatorList = new _operator_list.OperatorList();
                        const initialState = {
                            font: null,
                            clone () {
                                return this;
                            }
                        };
                        const { fontName: fontName, fontSize: fontSize } = appearanceData;
                        await evaluator.handleSetFont(resources, [
                            fontName && _primitives.Name.get(fontName),
                            fontSize
                        ], null, operatorList, task, initialState, null);
                        return initialState.font;
                    }
                    _getTextWidth(text, font1) {
                        return font1.charsToGlyphs(text).reduce((width, glyph)=>width + glyph.width, 0) / 1000;
                    }
                    _computeFontSize(height, width, text, font1, lineCount) {
                        let { fontSize: fontSize } = this.data.defaultAppearanceData;
                        let lineHeight = (fontSize || 12) * _util.LINE_FACTOR, numberOfLines = Math.round(height / lineHeight);
                        if (!fontSize) {
                            const roundWithTwoDigits = (x)=>Math.floor(x * 100) / 100;
                            if (lineCount === -1) {
                                const textWidth = this._getTextWidth(text, font1);
                                fontSize = roundWithTwoDigits(Math.min(height / _util.LINE_FACTOR, textWidth > width ? width / textWidth : Infinity));
                                numberOfLines = 1;
                            } else {
                                const lines = text.split(/\r\n?|\n/);
                                const cachedLines = [];
                                for (const line of lines){
                                    const encoded = font1.encodeString(line).join("");
                                    const glyphs = font1.charsToGlyphs(encoded);
                                    const positions = font1.getCharPositions(encoded);
                                    cachedLines.push({
                                        line: encoded,
                                        glyphs: glyphs,
                                        positions: positions
                                    });
                                }
                                const isTooBig = (fsize)=>{
                                    let totalHeight = 0;
                                    for (const cache of cachedLines){
                                        const chunks = this._splitLine(null, font1, fsize, width, cache);
                                        totalHeight += chunks.length * fsize;
                                        if (totalHeight > height) return true;
                                    }
                                    return false;
                                };
                                numberOfLines = Math.max(numberOfLines, lineCount);
                                while(true){
                                    lineHeight = height / numberOfLines;
                                    fontSize = roundWithTwoDigits(lineHeight / _util.LINE_FACTOR);
                                    if (isTooBig(fontSize)) {
                                        numberOfLines++;
                                        continue;
                                    }
                                    break;
                                }
                            }
                            const { fontName: fontName, fontColor: fontColor } = this.data.defaultAppearanceData;
                            this._defaultAppearance = (0, _default_appearance.createDefaultAppearance)({
                                fontSize: fontSize,
                                fontName: fontName,
                                fontColor: fontColor
                            });
                        }
                        return [
                            this._defaultAppearance,
                            fontSize,
                            height / numberOfLines
                        ];
                    }
                    _renderText(text, font1, fontSize, totalWidth, alignment, prevInfo, hPadding, vPadding) {
                        let shift;
                        if (alignment === 1) {
                            const width = this._getTextWidth(text, font1) * fontSize;
                            shift = (totalWidth - width) / 2;
                        } else if (alignment === 2) {
                            const width = this._getTextWidth(text, font1) * fontSize;
                            shift = totalWidth - width - hPadding;
                        } else shift = hPadding;
                        const shiftStr = (0, _core_utils.numberToString)(shift - prevInfo.shift);
                        prevInfo.shift = shift;
                        vPadding = (0, _core_utils.numberToString)(vPadding);
                        return `${shiftStr} ${vPadding} Td (${(0, _core_utils.escapeString)(text)}) Tj`;
                    }
                    _getSaveFieldResources(xref) {
                        const { localResources: localResources, appearanceResources: appearanceResources, acroFormResources: acroFormResources } = this._fieldResources;
                        const fontName = this.data.defaultAppearanceData?.fontName;
                        if (!fontName) return localResources || _primitives.Dict.empty;
                        for (const resources of [
                            localResources,
                            appearanceResources
                        ])if (resources instanceof _primitives.Dict) {
                            const localFont = resources.get("Font");
                            if (localFont instanceof _primitives.Dict && localFont.has(fontName)) return resources;
                        }
                        if (acroFormResources instanceof _primitives.Dict) {
                            const acroFormFont = acroFormResources.get("Font");
                            if (acroFormFont instanceof _primitives.Dict && acroFormFont.has(fontName)) {
                                const subFontDict = new _primitives.Dict(xref);
                                subFontDict.set(fontName, acroFormFont.getRaw(fontName));
                                const subResourcesDict = new _primitives.Dict(xref);
                                subResourcesDict.set("Font", subFontDict);
                                return _primitives.Dict.merge({
                                    xref: xref,
                                    dictArray: [
                                        subResourcesDict,
                                        localResources
                                    ],
                                    mergeSubDicts: true
                                });
                            }
                        }
                        return localResources || _primitives.Dict.empty;
                    }
                    getFieldObject() {
                        return null;
                    }
                }
                class TextWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this.data.hasOwnCanvas = this.data.readOnly && !this.data.noHTML;
                        this._hasText = true;
                        const dict = params.dict;
                        if (typeof this.data.fieldValue !== "string") this.data.fieldValue = "";
                        let alignment = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "Q"
                        });
                        if (!Number.isInteger(alignment) || alignment < 0 || alignment > 2) alignment = null;
                        this.data.textAlignment = alignment;
                        let maximumLength = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "MaxLen"
                        });
                        if (!Number.isInteger(maximumLength) || maximumLength < 0) maximumLength = 0;
                        this.data.maxLen = maximumLength;
                        this.data.multiLine = this.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE);
                        this.data.comb = this.hasFieldFlag(_util.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(_util.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== 0;
                        this.data.doNotScroll = this.hasFieldFlag(_util.AnnotationFieldFlag.DONOTSCROLL);
                    }
                    get hasTextContent() {
                        return !!this.appearance && !this._needAppearances;
                    }
                    _getCombAppearance(defaultAppearance, font1, text, fontSize, width, height, hPadding, vPadding, descent, lineHeight, annotationStorage) {
                        const combWidth = width / this.data.maxLen;
                        const colors = this.getBorderAndBackgroundAppearances(annotationStorage);
                        const buf = [];
                        const positions = font1.getCharPositions(text);
                        for (const [start, end] of positions)buf.push(`(${(0, _core_utils.escapeString)(text.substring(start, end))}) Tj`);
                        const renderedComb = buf.join(` ${(0, _core_utils.numberToString)(combWidth)} 0 Td `);
                        return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 ${(0, _core_utils.numberToString)(hPadding)} ${(0, _core_utils.numberToString)(vPadding + descent)} Tm ${renderedComb}` + " ET Q EMC";
                    }
                    _getMultilineAppearance(defaultAppearance, lines, font1, fontSize, width, height, alignment, hPadding, vPadding, descent, lineHeight, annotationStorage) {
                        const buf = [];
                        const totalWidth = width - 2 * hPadding;
                        const prevInfo = {
                            shift: 0
                        };
                        for(let i = 0, ii = lines.length; i < ii; i++){
                            const line = lines[i];
                            const chunks = this._splitLine(line, font1, fontSize, totalWidth);
                            for(let j = 0, jj = chunks.length; j < jj; j++){
                                const chunk = chunks[j];
                                const vShift = i === 0 && j === 0 ? -vPadding - (lineHeight - descent) : -lineHeight;
                                buf.push(this._renderText(chunk, font1, fontSize, width, alignment, prevInfo, hPadding, vShift));
                            }
                        }
                        const colors = this.getBorderAndBackgroundAppearances(annotationStorage);
                        const renderedText = buf.join("\n");
                        return `/Tx BMC q ${colors}BT ` + defaultAppearance + ` 1 0 0 1 0 ${(0, _core_utils.numberToString)(height)} Tm ${renderedText}` + " ET Q EMC";
                    }
                    _splitLine(line, font1, fontSize, width, cache = {}) {
                        line = cache.line || line;
                        const glyphs = cache.glyphs || font1.charsToGlyphs(line);
                        if (glyphs.length <= 1) return [
                            line
                        ];
                        const positions = cache.positions || font1.getCharPositions(line);
                        const scale = fontSize / 1000;
                        const chunks = [];
                        let lastSpacePosInStringStart = -1, lastSpacePosInStringEnd = -1, lastSpacePos = -1, startChunk = 0, currentWidth = 0;
                        for(let i = 0, ii = glyphs.length; i < ii; i++){
                            const [start, end] = positions[i];
                            const glyph = glyphs[i];
                            const glyphWidth = glyph.width * scale;
                            if (glyph.unicode === " ") {
                                if (currentWidth + glyphWidth > width) {
                                    chunks.push(line.substring(startChunk, start));
                                    startChunk = start;
                                    currentWidth = glyphWidth;
                                    lastSpacePosInStringStart = -1;
                                    lastSpacePos = -1;
                                } else {
                                    currentWidth += glyphWidth;
                                    lastSpacePosInStringStart = start;
                                    lastSpacePosInStringEnd = end;
                                    lastSpacePos = i;
                                }
                            } else if (currentWidth + glyphWidth > width) {
                                if (lastSpacePosInStringStart !== -1) {
                                    chunks.push(line.substring(startChunk, lastSpacePosInStringEnd));
                                    startChunk = lastSpacePosInStringEnd;
                                    i = lastSpacePos + 1;
                                    lastSpacePosInStringStart = -1;
                                    currentWidth = 0;
                                } else {
                                    chunks.push(line.substring(startChunk, start));
                                    startChunk = start;
                                    currentWidth = glyphWidth;
                                }
                            } else currentWidth += glyphWidth;
                        }
                        if (startChunk < line.length) chunks.push(line.substring(startChunk, line.length));
                        return chunks;
                    }
                    getFieldObject() {
                        return {
                            id: this.data.id,
                            value: this.data.fieldValue,
                            defaultValue: this.data.defaultFieldValue || "",
                            multiline: this.data.multiLine,
                            password: this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD),
                            charLimit: this.data.maxLen,
                            comb: this.data.comb,
                            editable: !this.data.readOnly,
                            hidden: this.data.hidden,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            actions: this.data.actions,
                            page: this.data.pageIndex,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            rotation: this.rotation,
                            type: "text"
                        };
                    }
                }
                class ButtonWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this.checkedAppearance = null;
                        this.uncheckedAppearance = null;
                        this.data.checkBox = !this.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.radioButton = this.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.pushButton = this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.isTooltipOnly = false;
                        if (this.data.checkBox) this._processCheckBox(params);
                        else if (this.data.radioButton) this._processRadioButton(params);
                        else if (this.data.pushButton) {
                            this.data.hasOwnCanvas = true;
                            this._processPushButton(params);
                        } else (0, _util.warn)("Invalid field flags for button widget annotation");
                    }
                    async getOperatorList(evaluator, task, intent, renderForms, annotationStorage) {
                        if (this.data.pushButton) return super.getOperatorList(evaluator, task, intent, false, annotationStorage);
                        let value = null;
                        let rotation = null;
                        if (annotationStorage) {
                            const storageEntry = annotationStorage.get(this.data.id);
                            value = storageEntry ? storageEntry.value : null;
                            rotation = storageEntry ? storageEntry.rotation : null;
                        }
                        if (value === null && this.appearance) return super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                        if (value === null || value === undefined) value = this.data.checkBox ? this.data.fieldValue === this.data.exportValue : this.data.fieldValue === this.data.buttonValue;
                        const appearance = value ? this.checkedAppearance : this.uncheckedAppearance;
                        if (appearance) {
                            const savedAppearance = this.appearance;
                            const savedMatrix = appearance.dict.getArray("Matrix") || _util.IDENTITY_MATRIX;
                            if (rotation) appearance.dict.set("Matrix", this.getRotationMatrix(annotationStorage));
                            this.appearance = appearance;
                            const operatorList = super.getOperatorList(evaluator, task, intent, renderForms, annotationStorage);
                            this.appearance = savedAppearance;
                            appearance.dict.set("Matrix", savedMatrix);
                            return operatorList;
                        }
                        return {
                            opList: new _operator_list.OperatorList(),
                            separateForm: false,
                            separateCanvas: false
                        };
                    }
                    async save(evaluator, task, annotationStorage) {
                        if (this.data.checkBox) return this._saveCheckbox(evaluator, task, annotationStorage);
                        if (this.data.radioButton) return this._saveRadioButton(evaluator, task, annotationStorage);
                        return null;
                    }
                    async _saveCheckbox(evaluator, task, annotationStorage) {
                        if (!annotationStorage) return null;
                        const storageEntry = annotationStorage.get(this.data.id);
                        let rotation = storageEntry?.rotation, value = storageEntry?.value;
                        if (rotation === undefined) {
                            if (value === undefined) return null;
                            const defaultValue = this.data.fieldValue === this.data.exportValue;
                            if (defaultValue === value) return null;
                        }
                        const dict = evaluator.xref.fetchIfRef(this.ref);
                        if (!(dict instanceof _primitives.Dict)) return null;
                        if (rotation === undefined) rotation = this.rotation;
                        if (value === undefined) value = this.data.fieldValue === this.data.exportValue;
                        const xfa = {
                            path: this.data.fieldName,
                            value: value ? this.data.exportValue : ""
                        };
                        const name = _primitives.Name.get(value ? this.data.exportValue : "Off");
                        dict.set("V", name);
                        dict.set("AS", name);
                        dict.set("M", `D:${(0, _util.getModificationDate)()}`);
                        const maybeMK = this._getMKDict(rotation);
                        if (maybeMK) dict.set("MK", maybeMK);
                        const buffer = [];
                        await (0, _writer.writeObject)(this.ref, dict, buffer, evaluator.xref);
                        return [
                            {
                                ref: this.ref,
                                data: buffer.join(""),
                                xfa: xfa
                            }
                        ];
                    }
                    async _saveRadioButton(evaluator, task, annotationStorage) {
                        if (!annotationStorage) return null;
                        const storageEntry = annotationStorage.get(this.data.id);
                        let rotation = storageEntry?.rotation, value = storageEntry?.value;
                        if (rotation === undefined) {
                            if (value === undefined) return null;
                            const defaultValue = this.data.fieldValue === this.data.buttonValue;
                            if (defaultValue === value) return null;
                        }
                        const dict = evaluator.xref.fetchIfRef(this.ref);
                        if (!(dict instanceof _primitives.Dict)) return null;
                        if (value === undefined) value = this.data.fieldValue === this.data.buttonValue;
                        if (rotation === undefined) rotation = this.rotation;
                        const xfa = {
                            path: this.data.fieldName,
                            value: value ? this.data.buttonValue : ""
                        };
                        const name = _primitives.Name.get(value ? this.data.buttonValue : "Off");
                        const buffer = [];
                        let parentData = null;
                        if (value) {
                            if (this.parent instanceof _primitives.Ref) {
                                const parent = evaluator.xref.fetch(this.parent);
                                parent.set("V", name);
                                await (0, _writer.writeObject)(this.parent, parent, buffer, evaluator.xref);
                                parentData = buffer.join("");
                                buffer.length = 0;
                            } else if (this.parent instanceof _primitives.Dict) this.parent.set("V", name);
                        }
                        dict.set("AS", name);
                        dict.set("M", `D:${(0, _util.getModificationDate)()}`);
                        const maybeMK = this._getMKDict(rotation);
                        if (maybeMK) dict.set("MK", maybeMK);
                        await (0, _writer.writeObject)(this.ref, dict, buffer, evaluator.xref);
                        const newRefs = [
                            {
                                ref: this.ref,
                                data: buffer.join(""),
                                xfa: xfa
                            }
                        ];
                        if (parentData) newRefs.push({
                            ref: this.parent,
                            data: parentData,
                            xfa: null
                        });
                        return newRefs;
                    }
                    _getDefaultCheckedAppearance(params, type) {
                        const width = this.data.rect[2] - this.data.rect[0];
                        const height = this.data.rect[3] - this.data.rect[1];
                        const bbox = [
                            0,
                            0,
                            width,
                            height
                        ];
                        const FONT_RATIO = 0.8;
                        const fontSize = Math.min(width, height) * FONT_RATIO;
                        let metrics, char;
                        if (type === "check") {
                            metrics = {
                                width: 0.755 * fontSize,
                                height: 0.705 * fontSize
                            };
                            char = "3";
                        } else if (type === "disc") {
                            metrics = {
                                width: 0.791 * fontSize,
                                height: 0.705 * fontSize
                            };
                            char = "l";
                        } else (0, _util.unreachable)(`_getDefaultCheckedAppearance - unsupported type: ${type}`);
                        const xShift = (0, _core_utils.numberToString)((width - metrics.width) / 2);
                        const yShift = (0, _core_utils.numberToString)((height - metrics.height) / 2);
                        const appearance = `q BT /PdfJsZaDb ${fontSize} Tf 0 g ${xShift} ${yShift} Td (${char}) Tj ET Q`;
                        const appearanceStreamDict = new _primitives.Dict(params.xref);
                        appearanceStreamDict.set("FormType", 1);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", bbox);
                        appearanceStreamDict.set("Matrix", [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ]);
                        appearanceStreamDict.set("Length", appearance.length);
                        const resources = new _primitives.Dict(params.xref);
                        const font1 = new _primitives.Dict(params.xref);
                        font1.set("PdfJsZaDb", this.fallbackFontDict);
                        resources.set("Font", font1);
                        appearanceStreamDict.set("Resources", resources);
                        this.checkedAppearance = new _stream.StringStream(appearance);
                        this.checkedAppearance.dict = appearanceStreamDict;
                        this._streams.push(this.checkedAppearance);
                    }
                    _processCheckBox(params) {
                        const customAppearance = params.dict.get("AP");
                        if (!(customAppearance instanceof _primitives.Dict)) return;
                        const normalAppearance = customAppearance.get("N");
                        if (!(normalAppearance instanceof _primitives.Dict)) return;
                        const asValue = this._decodeFormValue(params.dict.get("AS"));
                        if (typeof asValue === "string") this.data.fieldValue = asValue;
                        const yes = this.data.fieldValue !== null && this.data.fieldValue !== "Off" ? this.data.fieldValue : "Yes";
                        const exportValues = normalAppearance.getKeys();
                        if (exportValues.length === 0) exportValues.push("Off", yes);
                        else if (exportValues.length === 1) {
                            if (exportValues[0] === "Off") exportValues.push(yes);
                            else exportValues.unshift("Off");
                        } else if (exportValues.includes(yes)) {
                            exportValues.length = 0;
                            exportValues.push("Off", yes);
                        } else {
                            const otherYes = exportValues.find((v)=>v !== "Off");
                            exportValues.length = 0;
                            exportValues.push("Off", otherYes);
                        }
                        if (!exportValues.includes(this.data.fieldValue)) this.data.fieldValue = "Off";
                        this.data.exportValue = exportValues[1];
                        const checkedAppearance = normalAppearance.get(this.data.exportValue);
                        this.checkedAppearance = checkedAppearance instanceof _base_stream.BaseStream ? checkedAppearance : null;
                        const uncheckedAppearance = normalAppearance.get("Off");
                        this.uncheckedAppearance = uncheckedAppearance instanceof _base_stream.BaseStream ? uncheckedAppearance : null;
                        if (this.checkedAppearance) this._streams.push(this.checkedAppearance);
                        else this._getDefaultCheckedAppearance(params, "check");
                        if (this.uncheckedAppearance) this._streams.push(this.uncheckedAppearance);
                        this._fallbackFontDict = this.fallbackFontDict;
                        if (this.data.defaultFieldValue === null) this.data.defaultFieldValue = "Off";
                    }
                    _processRadioButton(params) {
                        this.data.fieldValue = this.data.buttonValue = null;
                        const fieldParent = params.dict.get("Parent");
                        if (fieldParent instanceof _primitives.Dict) {
                            this.parent = params.dict.getRaw("Parent");
                            const fieldParentValue = fieldParent.get("V");
                            if (fieldParentValue instanceof _primitives.Name) this.data.fieldValue = this._decodeFormValue(fieldParentValue);
                        }
                        const appearanceStates = params.dict.get("AP");
                        if (!(appearanceStates instanceof _primitives.Dict)) return;
                        const normalAppearance = appearanceStates.get("N");
                        if (!(normalAppearance instanceof _primitives.Dict)) return;
                        for (const key of normalAppearance.getKeys())if (key !== "Off") {
                            this.data.buttonValue = this._decodeFormValue(key);
                            break;
                        }
                        const checkedAppearance = normalAppearance.get(this.data.buttonValue);
                        this.checkedAppearance = checkedAppearance instanceof _base_stream.BaseStream ? checkedAppearance : null;
                        const uncheckedAppearance = normalAppearance.get("Off");
                        this.uncheckedAppearance = uncheckedAppearance instanceof _base_stream.BaseStream ? uncheckedAppearance : null;
                        if (this.checkedAppearance) this._streams.push(this.checkedAppearance);
                        else this._getDefaultCheckedAppearance(params, "disc");
                        if (this.uncheckedAppearance) this._streams.push(this.uncheckedAppearance);
                        this._fallbackFontDict = this.fallbackFontDict;
                        if (this.data.defaultFieldValue === null) this.data.defaultFieldValue = "Off";
                    }
                    _processPushButton(params) {
                        const { dict: dict, annotationGlobals: annotationGlobals } = params;
                        if (!dict.has("A") && !dict.has("AA") && !this.data.alternativeText) {
                            (0, _util.warn)("Push buttons without action dictionaries are not supported");
                            return;
                        }
                        this.data.isTooltipOnly = !dict.has("A") && !dict.has("AA");
                        _catalog.Catalog.parseDestDictionary({
                            destDict: dict,
                            resultObj: this.data,
                            docBaseUrl: annotationGlobals.baseUrl,
                            docAttachments: annotationGlobals.attachments
                        });
                    }
                    getFieldObject() {
                        let type = "button";
                        let exportValues;
                        if (this.data.checkBox) {
                            type = "checkbox";
                            exportValues = this.data.exportValue;
                        } else if (this.data.radioButton) {
                            type = "radiobutton";
                            exportValues = this.data.buttonValue;
                        }
                        return {
                            id: this.data.id,
                            value: this.data.fieldValue || "Off",
                            defaultValue: this.data.defaultFieldValue,
                            exportValues: exportValues,
                            editable: !this.data.readOnly,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            hidden: this.data.hidden,
                            actions: this.data.actions,
                            page: this.data.pageIndex,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            rotation: this.rotation,
                            type: type
                        };
                    }
                    get fallbackFontDict() {
                        const dict = new _primitives.Dict();
                        dict.set("BaseFont", _primitives.Name.get("ZapfDingbats"));
                        dict.set("Type", _primitives.Name.get("FallbackType"));
                        dict.set("Subtype", _primitives.Name.get("FallbackType"));
                        dict.set("Encoding", _primitives.Name.get("ZapfDingbatsEncoding"));
                        return (0, _util.shadow)(this, "fallbackFontDict", dict);
                    }
                }
                class ChoiceWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.indices = dict.getArray("I");
                        this.hasIndices = Array.isArray(this.indices) && this.indices.length > 0;
                        this.data.options = [];
                        const options = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "Opt"
                        });
                        if (Array.isArray(options)) for(let i = 0, ii = options.length; i < ii; i++){
                            const option = xref.fetchIfRef(options[i]);
                            const isOptionArray = Array.isArray(option);
                            this.data.options[i] = {
                                exportValue: this._decodeFormValue(isOptionArray ? xref.fetchIfRef(option[0]) : option),
                                displayValue: this._decodeFormValue(isOptionArray ? xref.fetchIfRef(option[1]) : option)
                            };
                        }
                        if (!this.hasIndices) {
                            if (typeof this.data.fieldValue === "string") this.data.fieldValue = [
                                this.data.fieldValue
                            ];
                            else if (!this.data.fieldValue) this.data.fieldValue = [];
                        } else {
                            this.data.fieldValue = [];
                            const ii = this.data.options.length;
                            for (const i of this.indices)if (Number.isInteger(i) && i >= 0 && i < ii) this.data.fieldValue.push(this.data.options[i].exportValue);
                        }
                        this.data.combo = this.hasFieldFlag(_util.AnnotationFieldFlag.COMBO);
                        this.data.multiSelect = this.hasFieldFlag(_util.AnnotationFieldFlag.MULTISELECT);
                        this._hasText = true;
                    }
                    getFieldObject() {
                        const type = this.data.combo ? "combobox" : "listbox";
                        const value = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
                        return {
                            id: this.data.id,
                            value: value,
                            defaultValue: this.data.defaultFieldValue,
                            editable: !this.data.readOnly,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            numItems: this.data.fieldValue.length,
                            multipleSelection: this.data.multiSelect,
                            hidden: this.data.hidden,
                            actions: this.data.actions,
                            items: this.data.options,
                            page: this.data.pageIndex,
                            strokeColor: this.data.borderColor,
                            fillColor: this.data.backgroundColor,
                            rotation: this.rotation,
                            type: type
                        };
                    }
                    amendSavedDict(annotationStorage, dict) {
                        if (!this.hasIndices) return;
                        let values = annotationStorage?.get(this.data.id)?.value;
                        if (!Array.isArray(values)) values = [
                            values
                        ];
                        const indices = [];
                        const { options: options } = this.data;
                        for(let i = 0, j = 0, ii = options.length; i < ii; i++)if (options[i].exportValue === values[j]) {
                            indices.push(i);
                            j += 1;
                        }
                        dict.set("I", indices);
                    }
                    async _getAppearance(evaluator, task, intent, annotationStorage) {
                        if (this.data.combo) return super._getAppearance(evaluator, task, intent, annotationStorage);
                        let exportedValue, rotation;
                        const storageEntry = annotationStorage?.get(this.data.id);
                        if (storageEntry) {
                            rotation = storageEntry.rotation;
                            exportedValue = storageEntry.value;
                        }
                        if (rotation === undefined && exportedValue === undefined && !this._needAppearances) return null;
                        if (exportedValue === undefined) exportedValue = this.data.fieldValue;
                        else if (!Array.isArray(exportedValue)) exportedValue = [
                            exportedValue
                        ];
                        const defaultPadding = 1;
                        const defaultHPadding = 2;
                        let totalHeight = this.data.rect[3] - this.data.rect[1];
                        let totalWidth = this.data.rect[2] - this.data.rect[0];
                        if (rotation === 90 || rotation === 270) [totalWidth, totalHeight] = [
                            totalHeight,
                            totalWidth
                        ];
                        const lineCount = this.data.options.length;
                        const valueIndices = [];
                        for(let i = 0; i < lineCount; i++){
                            const { exportValue: exportValue } = this.data.options[i];
                            if (exportedValue.includes(exportValue)) valueIndices.push(i);
                        }
                        if (!this._defaultAppearance) this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g");
                        const font1 = await WidgetAnnotation._getFontData(evaluator, task, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
                        let defaultAppearance;
                        let { fontSize: fontSize } = this.data.defaultAppearanceData;
                        if (!fontSize) {
                            const lineHeight = (totalHeight - defaultPadding) / lineCount;
                            let lineWidth = -1;
                            let value;
                            for (const { displayValue: displayValue } of this.data.options){
                                const width = this._getTextWidth(displayValue, font1);
                                if (width > lineWidth) {
                                    lineWidth = width;
                                    value = displayValue;
                                }
                            }
                            [defaultAppearance, fontSize] = this._computeFontSize(lineHeight, totalWidth - 2 * defaultHPadding, value, font1, -1);
                        } else defaultAppearance = this._defaultAppearance;
                        const lineHeight = fontSize * _util.LINE_FACTOR;
                        const vPadding = (lineHeight - fontSize) / 2;
                        const numberOfVisibleLines = Math.floor(totalHeight / lineHeight);
                        let firstIndex = 0;
                        if (valueIndices.length > 0) {
                            const minIndex = Math.min(...valueIndices);
                            const maxIndex = Math.max(...valueIndices);
                            firstIndex = Math.max(0, maxIndex - numberOfVisibleLines + 1);
                            if (firstIndex > minIndex) firstIndex = minIndex;
                        }
                        const end = Math.min(firstIndex + numberOfVisibleLines + 1, lineCount);
                        const buf = [
                            "/Tx BMC q",
                            `1 1 ${totalWidth} ${totalHeight} re W n`
                        ];
                        if (valueIndices.length) {
                            buf.push("0.600006 0.756866 0.854904 rg");
                            for (const index of valueIndices)if (firstIndex <= index && index < end) buf.push(`1 ${totalHeight - (index - firstIndex + 1) * lineHeight} ${totalWidth} ${lineHeight} re f`);
                        }
                        buf.push("BT", defaultAppearance, `1 0 0 1 0 ${totalHeight} Tm`);
                        const prevInfo = {
                            shift: 0
                        };
                        for(let i = firstIndex; i < end; i++){
                            const { displayValue: displayValue } = this.data.options[i];
                            const vpadding = i === firstIndex ? vPadding : 0;
                            buf.push(this._renderText(displayValue, font1, fontSize, totalWidth, 0, prevInfo, defaultHPadding, -lineHeight + vpadding));
                        }
                        buf.push("ET Q EMC");
                        return buf.join("\n");
                    }
                }
                class SignatureWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this.data.fieldValue = null;
                        this.data.hasOwnCanvas = this.data.noRotate;
                    }
                    getFieldObject() {
                        return {
                            id: this.data.id,
                            value: null,
                            page: this.data.pageIndex,
                            type: "signature"
                        };
                    }
                }
                class TextAnnotation extends MarkupAnnotation {
                    constructor(params){
                        const DEFAULT_ICON_SIZE = 22;
                        super(params);
                        this.data.noRotate = true;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        const { dict: dict } = params;
                        this.data.annotationType = _util.AnnotationType.TEXT;
                        if (this.data.hasAppearance) this.data.name = "NoIcon";
                        else {
                            this.data.rect[1] = this.data.rect[3] - DEFAULT_ICON_SIZE;
                            this.data.rect[2] = this.data.rect[0] + DEFAULT_ICON_SIZE;
                            this.data.name = dict.has("Name") ? dict.get("Name").name : "Note";
                        }
                        if (dict.has("State")) {
                            this.data.state = dict.get("State") || null;
                            this.data.stateModel = dict.get("StateModel") || null;
                        } else {
                            this.data.state = null;
                            this.data.stateModel = null;
                        }
                    }
                }
                class LinkAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, annotationGlobals: annotationGlobals } = params;
                        this.data.annotationType = _util.AnnotationType.LINK;
                        const quadPoints = getQuadPoints(dict, this.rectangle);
                        if (quadPoints) this.data.quadPoints = quadPoints;
                        this.data.borderColor ||= this.data.color;
                        _catalog.Catalog.parseDestDictionary({
                            destDict: dict,
                            resultObj: this.data,
                            docBaseUrl: annotationGlobals.baseUrl,
                            docAttachments: annotationGlobals.attachments
                        });
                    }
                }
                class PopupAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        const { dict: dict } = params;
                        this.data.annotationType = _util.AnnotationType.POPUP;
                        if (this.data.rect[0] === this.data.rect[2] || this.data.rect[1] === this.data.rect[3]) this.data.rect = null;
                        let parentItem = dict.get("Parent");
                        if (!parentItem) {
                            (0, _util.warn)("Popup annotation has a missing or invalid parent annotation.");
                            return;
                        }
                        const parentRect = parentItem.getArray("Rect");
                        this.data.parentRect = Array.isArray(parentRect) && parentRect.length === 4 ? _util.Util.normalizeRect(parentRect) : null;
                        const rt = parentItem.get("RT");
                        if ((0, _primitives.isName)(rt, _util.AnnotationReplyType.GROUP)) parentItem = parentItem.get("IRT");
                        if (!parentItem.has("M")) this.data.modificationDate = null;
                        else {
                            this.setModificationDate(parentItem.get("M"));
                            this.data.modificationDate = this.modificationDate;
                        }
                        if (!parentItem.has("C")) this.data.color = null;
                        else {
                            this.setColor(parentItem.getArray("C"));
                            this.data.color = this.color;
                        }
                        if (!this.viewable) {
                            const parentFlags = parentItem.get("F");
                            if (this._isViewable(parentFlags)) this.setFlags(parentFlags);
                        }
                        this.setTitle(parentItem.get("T"));
                        this.data.titleObj = this._title;
                        this.setContents(parentItem.get("Contents"));
                        this.data.contentsObj = this._contents;
                        if (parentItem.has("RC")) this.data.richText = _factory.XFAFactory.getRichTextAsHtml(parentItem.get("RC"));
                        this.data.open = !!dict.get("Open");
                    }
                }
                exports.PopupAnnotation = PopupAnnotation;
                class FreeTextAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        this.data.hasOwnCanvas = true;
                        const { evaluatorOptions: evaluatorOptions, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.FREETEXT;
                        this.setDefaultAppearance(params);
                        if (this.appearance) {
                            const { fontColor: fontColor, fontSize: fontSize } = (0, _default_appearance.parseAppearanceStream)(this.appearance, evaluatorOptions, xref);
                            this.data.defaultAppearanceData.fontColor = fontColor;
                            this.data.defaultAppearanceData.fontSize = fontSize || 10;
                        } else if (this._isOffscreenCanvasSupported) {
                            const strokeAlpha = params.dict.get("CA");
                            const fakeUnicodeFont = new _default_appearance.FakeUnicodeFont(xref, "sans-serif");
                            this.data.defaultAppearanceData.fontSize ||= 10;
                            const { fontColor: fontColor, fontSize: fontSize } = this.data.defaultAppearanceData;
                            this.appearance = fakeUnicodeFont.createAppearance(this._contents.str, this.rectangle, this.rotation, fontSize, fontColor, strokeAlpha);
                            this._streams.push(this.appearance, _default_appearance.FakeUnicodeFont.toUnicodeStream);
                        } else (0, _util.warn)("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
                    }
                    get hasTextContent() {
                        return !!this.appearance;
                    }
                    static createNewDict(annotation, xref, { apRef: apRef, ap: ap }) {
                        const { color: color, fontSize: fontSize, rect: rect, rotation: rotation, user: user, value: value } = annotation;
                        const freetext = new _primitives.Dict(xref);
                        freetext.set("Type", _primitives.Name.get("Annot"));
                        freetext.set("Subtype", _primitives.Name.get("FreeText"));
                        freetext.set("CreationDate", `D:${(0, _util.getModificationDate)()}`);
                        freetext.set("Rect", rect);
                        const da = `/Helv ${fontSize} Tf ${(0, _default_appearance.getPdfColor)(color, true)}`;
                        freetext.set("DA", da);
                        freetext.set("Contents", (0, _core_utils.isAscii)(value) ? value : (0, _core_utils.stringToUTF16String)(value, true));
                        freetext.set("F", 4);
                        freetext.set("Border", [
                            0,
                            0,
                            0
                        ]);
                        freetext.set("Rotate", rotation);
                        if (user) freetext.set("T", (0, _core_utils.isAscii)(user) ? user : (0, _core_utils.stringToUTF16String)(user, true));
                        if (apRef || ap) {
                            const n = new _primitives.Dict(xref);
                            freetext.set("AP", n);
                            if (apRef) n.set("N", apRef);
                            else n.set("N", ap);
                        }
                        return freetext;
                    }
                    static async createNewAppearanceStream(annotation, xref, params) {
                        const { baseFontRef: baseFontRef, evaluator: evaluator, task: task } = params;
                        const { color: color, fontSize: fontSize, rect: rect, rotation: rotation, value: value } = annotation;
                        const resources = new _primitives.Dict(xref);
                        const font1 = new _primitives.Dict(xref);
                        if (baseFontRef) font1.set("Helv", baseFontRef);
                        else {
                            const baseFont = new _primitives.Dict(xref);
                            baseFont.set("BaseFont", _primitives.Name.get("Helvetica"));
                            baseFont.set("Type", _primitives.Name.get("Font"));
                            baseFont.set("Subtype", _primitives.Name.get("Type1"));
                            baseFont.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                            font1.set("Helv", baseFont);
                        }
                        resources.set("Font", font1);
                        const helv = await WidgetAnnotation._getFontData(evaluator, task, {
                            fontName: "Helv",
                            fontSize: fontSize
                        }, resources);
                        const [x1, y1, x2, y2] = rect;
                        let w = x2 - x1;
                        let h = y2 - y1;
                        if (rotation % 180 !== 0) [w, h] = [
                            h,
                            w
                        ];
                        const lines = value.split("\n");
                        const scale = fontSize / 1000;
                        let totalWidth = -Infinity;
                        const encodedLines = [];
                        for (let line of lines){
                            const encoded = helv.encodeString(line);
                            if (encoded.length > 1) return null;
                            line = encoded.join("");
                            encodedLines.push(line);
                            let lineWidth = 0;
                            const glyphs = helv.charsToGlyphs(line);
                            for (const glyph of glyphs)lineWidth += glyph.width * scale;
                            totalWidth = Math.max(totalWidth, lineWidth);
                        }
                        let hscale = 1;
                        if (totalWidth > w) hscale = w / totalWidth;
                        let vscale = 1;
                        const lineHeight = _util.LINE_FACTOR * fontSize;
                        const lineAscent = (_util.LINE_FACTOR - _util.LINE_DESCENT_FACTOR) * fontSize;
                        const totalHeight = lineHeight * lines.length;
                        if (totalHeight > h) vscale = h / totalHeight;
                        const fscale = Math.min(hscale, vscale);
                        const newFontSize = fontSize * fscale;
                        let firstPoint, clipBox, matrix;
                        switch(rotation){
                            case 0:
                                matrix = [
                                    1,
                                    0,
                                    0,
                                    1
                                ];
                                clipBox = [
                                    rect[0],
                                    rect[1],
                                    w,
                                    h
                                ];
                                firstPoint = [
                                    rect[0],
                                    rect[3] - lineAscent
                                ];
                                break;
                            case 90:
                                matrix = [
                                    0,
                                    1,
                                    -1,
                                    0
                                ];
                                clipBox = [
                                    rect[1],
                                    -rect[2],
                                    w,
                                    h
                                ];
                                firstPoint = [
                                    rect[1],
                                    -rect[0] - lineAscent
                                ];
                                break;
                            case 180:
                                matrix = [
                                    -1,
                                    0,
                                    0,
                                    -1
                                ];
                                clipBox = [
                                    -rect[2],
                                    -rect[3],
                                    w,
                                    h
                                ];
                                firstPoint = [
                                    -rect[2],
                                    -rect[1] - lineAscent
                                ];
                                break;
                            case 270:
                                matrix = [
                                    0,
                                    -1,
                                    1,
                                    0
                                ];
                                clipBox = [
                                    -rect[3],
                                    rect[0],
                                    w,
                                    h
                                ];
                                firstPoint = [
                                    -rect[3],
                                    rect[2] - lineAscent
                                ];
                                break;
                        }
                        const buffer = [
                            "q",
                            `${matrix.join(" ")} 0 0 cm`,
                            `${clipBox.join(" ")} re W n`,
                            `BT`,
                            `${(0, _default_appearance.getPdfColor)(color, true)}`,
                            `0 Tc /Helv ${(0, _core_utils.numberToString)(newFontSize)} Tf`
                        ];
                        buffer.push(`${firstPoint.join(" ")} Td (${(0, _core_utils.escapeString)(encodedLines[0])}) Tj`);
                        const vShift = (0, _core_utils.numberToString)(lineHeight);
                        for(let i = 1, ii = encodedLines.length; i < ii; i++){
                            const line = encodedLines[i];
                            buffer.push(`0 -${vShift} Td (${(0, _core_utils.escapeString)(line)}) Tj`);
                        }
                        buffer.push("ET", "Q");
                        const appearance = buffer.join("\n");
                        const appearanceStreamDict = new _primitives.Dict(xref);
                        appearanceStreamDict.set("FormType", 1);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", rect);
                        appearanceStreamDict.set("Resources", resources);
                        appearanceStreamDict.set("Matrix", [
                            1,
                            0,
                            0,
                            1,
                            -rect[0],
                            -rect[1]
                        ]);
                        const ap = new _stream.StringStream(appearance);
                        ap.dict = appearanceStreamDict;
                        return ap;
                    }
                }
                class LineAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.LINE;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        const lineCoordinates = dict.getArray("L");
                        this.data.lineCoordinates = _util.Util.normalizeRect(lineCoordinates);
                        this.setLineEndings(dict.getArray("LE"));
                        this.data.lineEndings = this.lineEndings;
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const interiorColor = getRgbColor(dict.getArray("IC"), null);
                            const fillColor = interiorColor ? getPdfColorArray(interiorColor) : null;
                            const fillAlpha = fillColor ? strokeAlpha : null;
                            const borderWidth = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth;
                            const bbox = [
                                this.data.lineCoordinates[0] - borderAdjust,
                                this.data.lineCoordinates[1] - borderAdjust,
                                this.data.lineCoordinates[2] + borderAdjust,
                                this.data.lineCoordinates[3] + borderAdjust
                            ];
                            if (!_util.Util.intersect(this.rectangle, bbox)) this.rectangle = bbox;
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${borderWidth} w`,
                                strokeColor: strokeColor,
                                fillColor: fillColor,
                                strokeAlpha: strokeAlpha,
                                fillAlpha: fillAlpha,
                                pointsCallback: (buffer, points)=>{
                                    buffer.push(`${lineCoordinates[0]} ${lineCoordinates[1]} m`, `${lineCoordinates[2]} ${lineCoordinates[3]} l`, "S");
                                    return [
                                        points[0].x - borderWidth,
                                        points[1].x + borderWidth,
                                        points[3].y - borderWidth,
                                        points[1].y + borderWidth
                                    ];
                                }
                            });
                        }
                    }
                }
                class SquareAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.SQUARE;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const interiorColor = getRgbColor(dict.getArray("IC"), null);
                            const fillColor = interiorColor ? getPdfColorArray(interiorColor) : null;
                            const fillAlpha = fillColor ? strokeAlpha : null;
                            if (this.borderStyle.width === 0 && !fillColor) return;
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${this.borderStyle.width} w`,
                                strokeColor: strokeColor,
                                fillColor: fillColor,
                                strokeAlpha: strokeAlpha,
                                fillAlpha: fillAlpha,
                                pointsCallback: (buffer, points)=>{
                                    const x = points[2].x + this.borderStyle.width / 2;
                                    const y = points[2].y + this.borderStyle.width / 2;
                                    const width = points[3].x - points[2].x - this.borderStyle.width;
                                    const height = points[1].y - points[3].y - this.borderStyle.width;
                                    buffer.push(`${x} ${y} ${width} ${height} re`);
                                    if (fillColor) buffer.push("B");
                                    else buffer.push("S");
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class CircleAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.CIRCLE;
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const interiorColor = getRgbColor(dict.getArray("IC"), null);
                            const fillColor = interiorColor ? getPdfColorArray(interiorColor) : null;
                            const fillAlpha = fillColor ? strokeAlpha : null;
                            if (this.borderStyle.width === 0 && !fillColor) return;
                            const controlPointsDistance = 4 / 3 * Math.tan(Math.PI / 8);
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${this.borderStyle.width} w`,
                                strokeColor: strokeColor,
                                fillColor: fillColor,
                                strokeAlpha: strokeAlpha,
                                fillAlpha: fillAlpha,
                                pointsCallback: (buffer, points)=>{
                                    const x0 = points[0].x + this.borderStyle.width / 2;
                                    const y0 = points[0].y - this.borderStyle.width / 2;
                                    const x1 = points[3].x - this.borderStyle.width / 2;
                                    const y1 = points[3].y + this.borderStyle.width / 2;
                                    const xMid = x0 + (x1 - x0) / 2;
                                    const yMid = y0 + (y1 - y0) / 2;
                                    const xOffset = (x1 - x0) / 2 * controlPointsDistance;
                                    const yOffset = (y1 - y0) / 2 * controlPointsDistance;
                                    buffer.push(`${xMid} ${y1} m`, `${xMid + xOffset} ${y1} ${x1} ${yMid + yOffset} ${x1} ${yMid} c`, `${x1} ${yMid - yOffset} ${xMid + xOffset} ${y0} ${xMid} ${y0} c`, `${xMid - xOffset} ${y0} ${x0} ${yMid - yOffset} ${x0} ${yMid} c`, `${x0} ${yMid + yOffset} ${xMid - xOffset} ${y1} ${xMid} ${y1} c`, "h");
                                    if (fillColor) buffer.push("B");
                                    else buffer.push("S");
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class PolylineAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.POLYLINE;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        this.data.vertices = [];
                        if (!(this instanceof PolygonAnnotation)) {
                            this.setLineEndings(dict.getArray("LE"));
                            this.data.lineEndings = this.lineEndings;
                        }
                        const rawVertices = dict.getArray("Vertices");
                        if (!Array.isArray(rawVertices)) return;
                        for(let i = 0, ii = rawVertices.length; i < ii; i += 2)this.data.vertices.push({
                            x: rawVertices[i],
                            y: rawVertices[i + 1]
                        });
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const borderWidth = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth;
                            const bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            for (const vertex of this.data.vertices){
                                bbox[0] = Math.min(bbox[0], vertex.x - borderAdjust);
                                bbox[1] = Math.min(bbox[1], vertex.y - borderAdjust);
                                bbox[2] = Math.max(bbox[2], vertex.x + borderAdjust);
                                bbox[3] = Math.max(bbox[3], vertex.y + borderAdjust);
                            }
                            if (!_util.Util.intersect(this.rectangle, bbox)) this.rectangle = bbox;
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${borderWidth} w`,
                                strokeColor: strokeColor,
                                strokeAlpha: strokeAlpha,
                                pointsCallback: (buffer, points)=>{
                                    const vertices = this.data.vertices;
                                    for(let i = 0, ii = vertices.length; i < ii; i++)buffer.push(`${vertices[i].x} ${vertices[i].y} ${i === 0 ? "m" : "l"}`);
                                    buffer.push("S");
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class PolygonAnnotation extends PolylineAnnotation {
                    constructor(params){
                        super(params);
                        this.data.annotationType = _util.AnnotationType.POLYGON;
                    }
                }
                class CaretAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        this.data.annotationType = _util.AnnotationType.CARET;
                    }
                }
                class InkAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        this.data.hasOwnCanvas = this.data.noRotate;
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.INK;
                        this.data.inkLists = [];
                        const rawInkLists = dict.getArray("InkList");
                        if (!Array.isArray(rawInkLists)) return;
                        for(let i = 0, ii = rawInkLists.length; i < ii; ++i){
                            this.data.inkLists.push([]);
                            for(let j = 0, jj = rawInkLists[i].length; j < jj; j += 2)this.data.inkLists[i].push({
                                x: xref.fetchIfRef(rawInkLists[i][j]),
                                y: xref.fetchIfRef(rawInkLists[i][j + 1])
                            });
                        }
                        if (!this.appearance) {
                            const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = dict.get("CA");
                            const borderWidth = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth;
                            const bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            for (const inkLists of this.data.inkLists)for (const vertex of inkLists){
                                bbox[0] = Math.min(bbox[0], vertex.x - borderAdjust);
                                bbox[1] = Math.min(bbox[1], vertex.y - borderAdjust);
                                bbox[2] = Math.max(bbox[2], vertex.x + borderAdjust);
                                bbox[3] = Math.max(bbox[3], vertex.y + borderAdjust);
                            }
                            if (!_util.Util.intersect(this.rectangle, bbox)) this.rectangle = bbox;
                            this._setDefaultAppearance({
                                xref: xref,
                                extra: `${borderWidth} w`,
                                strokeColor: strokeColor,
                                strokeAlpha: strokeAlpha,
                                pointsCallback: (buffer, points)=>{
                                    for (const inkList of this.data.inkLists){
                                        for(let i = 0, ii = inkList.length; i < ii; i++)buffer.push(`${inkList[i].x} ${inkList[i].y} ${i === 0 ? "m" : "l"}`);
                                        buffer.push("S");
                                    }
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                    static createNewDict(annotation, xref, { apRef: apRef, ap: ap }) {
                        const { color: color, opacity: opacity, paths: paths, rect: rect, rotation: rotation, thickness: thickness } = annotation;
                        const ink = new _primitives.Dict(xref);
                        ink.set("Type", _primitives.Name.get("Annot"));
                        ink.set("Subtype", _primitives.Name.get("Ink"));
                        ink.set("CreationDate", `D:${(0, _util.getModificationDate)()}`);
                        ink.set("Rect", rect);
                        ink.set("InkList", paths.map((p)=>p.points));
                        ink.set("F", 4);
                        ink.set("Rotate", rotation);
                        const bs = new _primitives.Dict(xref);
                        ink.set("BS", bs);
                        bs.set("W", thickness);
                        ink.set("C", Array.from(color, (c)=>c / 255));
                        ink.set("CA", opacity);
                        const n = new _primitives.Dict(xref);
                        ink.set("AP", n);
                        if (apRef) n.set("N", apRef);
                        else n.set("N", ap);
                        return ink;
                    }
                    static async createNewAppearanceStream(annotation, xref, params) {
                        const { color: color, rect: rect, paths: paths, thickness: thickness, opacity: opacity } = annotation;
                        const appearanceBuffer = [
                            `${thickness} w 1 J 1 j`,
                            `${(0, _default_appearance.getPdfColor)(color, false)}`
                        ];
                        if (opacity !== 1) appearanceBuffer.push("/R0 gs");
                        const buffer = [];
                        for (const { bezier: bezier } of paths){
                            buffer.length = 0;
                            buffer.push(`${(0, _core_utils.numberToString)(bezier[0])} ${(0, _core_utils.numberToString)(bezier[1])} m`);
                            for(let i = 2, ii = bezier.length; i < ii; i += 6){
                                const curve = bezier.slice(i, i + 6).map(_core_utils.numberToString).join(" ");
                                buffer.push(`${curve} c`);
                            }
                            buffer.push("S");
                            appearanceBuffer.push(buffer.join("\n"));
                        }
                        const appearance = appearanceBuffer.join("\n");
                        const appearanceStreamDict = new _primitives.Dict(xref);
                        appearanceStreamDict.set("FormType", 1);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", rect);
                        appearanceStreamDict.set("Length", appearance.length);
                        if (opacity !== 1) {
                            const resources = new _primitives.Dict(xref);
                            const extGState = new _primitives.Dict(xref);
                            const r0 = new _primitives.Dict(xref);
                            r0.set("CA", opacity);
                            r0.set("Type", _primitives.Name.get("ExtGState"));
                            extGState.set("R0", r0);
                            resources.set("ExtGState", extGState);
                            appearanceStreamDict.set("Resources", resources);
                        }
                        const ap = new _stream.StringStream(appearance);
                        ap.dict = appearanceStreamDict;
                        return ap;
                    }
                }
                class HighlightAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.HIGHLIGHT;
                        const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                        if (quadPoints) {
                            const resources = this.appearance?.dict.get("Resources");
                            if (!this.appearance || !resources?.has("ExtGState")) {
                                if (this.appearance) (0, _util.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
                                const fillColor = this.color ? getPdfColorArray(this.color) : [
                                    1,
                                    1,
                                    0
                                ];
                                const fillAlpha = dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: xref,
                                    fillColor: fillColor,
                                    blendMode: "Multiply",
                                    fillAlpha: fillAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        buffer.push(`${points[0].x} ${points[0].y} m`, `${points[1].x} ${points[1].y} l`, `${points[3].x} ${points[3].y} l`, `${points[2].x} ${points[2].y} l`, "f");
                                        return [
                                            points[0].x,
                                            points[1].x,
                                            points[3].y,
                                            points[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class UnderlineAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.UNDERLINE;
                        const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                        if (quadPoints) {
                            if (!this.appearance) {
                                const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ];
                                const strokeAlpha = dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: xref,
                                    extra: "[] 0 d 0.571 w",
                                    strokeColor: strokeColor,
                                    strokeAlpha: strokeAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        buffer.push(`${points[2].x} ${points[2].y + 1.3} m`, `${points[3].x} ${points[3].y + 1.3} l`, "S");
                                        return [
                                            points[0].x,
                                            points[1].x,
                                            points[3].y,
                                            points[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class SquigglyAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.SQUIGGLY;
                        const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                        if (quadPoints) {
                            if (!this.appearance) {
                                const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ];
                                const strokeAlpha = dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: xref,
                                    extra: "[] 0 d 1 w",
                                    strokeColor: strokeColor,
                                    strokeAlpha: strokeAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        const dy = (points[0].y - points[2].y) / 6;
                                        let shift = dy;
                                        let x = points[2].x;
                                        const y = points[2].y;
                                        const xEnd = points[3].x;
                                        buffer.push(`${x} ${y + shift} m`);
                                        do {
                                            x += 2;
                                            shift = shift === 0 ? dy : 0;
                                            buffer.push(`${x} ${y + shift} l`);
                                        }while (x < xEnd);
                                        buffer.push("S");
                                        return [
                                            points[2].x,
                                            xEnd,
                                            y - 2 * dy,
                                            y + 2 * dy
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class StrikeOutAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        this.data.annotationType = _util.AnnotationType.STRIKEOUT;
                        const quadPoints = this.data.quadPoints = getQuadPoints(dict, null);
                        if (quadPoints) {
                            if (!this.appearance) {
                                const strokeColor = this.color ? getPdfColorArray(this.color) : [
                                    0,
                                    0,
                                    0
                                ];
                                const strokeAlpha = dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: xref,
                                    extra: "[] 0 d 1 w",
                                    strokeColor: strokeColor,
                                    strokeAlpha: strokeAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        buffer.push(`${(points[0].x + points[2].x) / 2} ` + `${(points[0].y + points[2].y) / 2} m`, `${(points[1].x + points[3].x) / 2} ` + `${(points[1].y + points[3].y) / 2} l`, "S");
                                        return [
                                            points[0].x,
                                            points[1].x,
                                            points[3].y,
                                            points[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.popupRef = null;
                    }
                }
                class StampAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        this.data.annotationType = _util.AnnotationType.STAMP;
                        this.data.hasOwnCanvas = this.data.noRotate;
                    }
                    static async createImage(bitmap, xref) {
                        const { width: width, height: height } = bitmap;
                        const canvas = new OffscreenCanvas(width, height);
                        const ctx = canvas.getContext("2d", {
                            alpha: true
                        });
                        ctx.drawImage(bitmap, 0, 0);
                        const data = ctx.getImageData(0, 0, width, height).data;
                        const buf32 = new Uint32Array(data.buffer);
                        const hasAlpha = buf32.some(_util.FeatureTest.isLittleEndian ? (x)=>x >>> 24 !== 0xff : (x)=>(x & 0xff) !== 0xff);
                        if (hasAlpha) {
                            ctx.fillStyle = "white";
                            ctx.fillRect(0, 0, width, height);
                            ctx.drawImage(bitmap, 0, 0);
                        }
                        const jpegBufferPromise = canvas.convertToBlob({
                            type: "image/jpeg",
                            quality: 1
                        }).then((blob)=>{
                            return blob.arrayBuffer();
                        });
                        const xobjectName = _primitives.Name.get("XObject");
                        const imageName = _primitives.Name.get("Image");
                        const image = new _primitives.Dict(xref);
                        image.set("Type", xobjectName);
                        image.set("Subtype", imageName);
                        image.set("BitsPerComponent", 8);
                        image.set("ColorSpace", _primitives.Name.get("DeviceRGB"));
                        image.set("Filter", _primitives.Name.get("DCTDecode"));
                        image.set("BBox", [
                            0,
                            0,
                            width,
                            height
                        ]);
                        image.set("Width", width);
                        image.set("Height", height);
                        let smaskStream = null;
                        if (hasAlpha) {
                            const alphaBuffer = new Uint8Array(buf32.length);
                            if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = buf32.length; i < ii; i++)alphaBuffer[i] = buf32[i] >>> 24;
                            else for(let i = 0, ii = buf32.length; i < ii; i++)alphaBuffer[i] = buf32[i] & 0xff;
                            const smask = new _primitives.Dict(xref);
                            smask.set("Type", xobjectName);
                            smask.set("Subtype", imageName);
                            smask.set("BitsPerComponent", 8);
                            smask.set("ColorSpace", _primitives.Name.get("DeviceGray"));
                            smask.set("Width", width);
                            smask.set("Height", height);
                            smaskStream = new _stream.Stream(alphaBuffer, 0, 0, smask);
                        }
                        const imageStream = new _stream.Stream(await jpegBufferPromise, 0, 0, image);
                        return {
                            imageStream: imageStream,
                            smaskStream: smaskStream,
                            width: width,
                            height: height
                        };
                    }
                    static createNewDict(annotation, xref, { apRef: apRef, ap: ap }) {
                        const { rect: rect, rotation: rotation, user: user } = annotation;
                        const stamp = new _primitives.Dict(xref);
                        stamp.set("Type", _primitives.Name.get("Annot"));
                        stamp.set("Subtype", _primitives.Name.get("Stamp"));
                        stamp.set("CreationDate", `D:${(0, _util.getModificationDate)()}`);
                        stamp.set("Rect", rect);
                        stamp.set("F", 4);
                        stamp.set("Border", [
                            0,
                            0,
                            0
                        ]);
                        stamp.set("Rotate", rotation);
                        if (user) stamp.set("T", (0, _core_utils.isAscii)(user) ? user : (0, _core_utils.stringToUTF16String)(user, true));
                        if (apRef || ap) {
                            const n = new _primitives.Dict(xref);
                            stamp.set("AP", n);
                            if (apRef) n.set("N", apRef);
                            else n.set("N", ap);
                        }
                        return stamp;
                    }
                    static async createNewAppearanceStream(annotation, xref, params) {
                        const { rotation: rotation } = annotation;
                        const { imageRef: imageRef, width: width, height: height } = params.image;
                        const resources = new _primitives.Dict(xref);
                        const xobject = new _primitives.Dict(xref);
                        resources.set("XObject", xobject);
                        xobject.set("Im0", imageRef);
                        const appearance = `q ${width} 0 0 ${height} 0 0 cm /Im0 Do Q`;
                        const appearanceStreamDict = new _primitives.Dict(xref);
                        appearanceStreamDict.set("FormType", 1);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", [
                            0,
                            0,
                            width,
                            height
                        ]);
                        appearanceStreamDict.set("Resources", resources);
                        if (rotation) {
                            const matrix = (0, _core_utils.getRotationMatrix)(rotation, width, height);
                            appearanceStreamDict.set("Matrix", matrix);
                        }
                        const ap = new _stream.StringStream(appearance);
                        ap.dict = appearanceStreamDict;
                        return ap;
                    }
                }
                class FileAttachmentAnnotation extends MarkupAnnotation {
                    constructor(params){
                        super(params);
                        const { dict: dict, xref: xref } = params;
                        const file = new _file_spec.FileSpec(dict.get("FS"), xref);
                        this.data.annotationType = _util.AnnotationType.FILEATTACHMENT;
                        this.data.hasOwnCanvas = this.data.noRotate;
                        this.data.file = file.serializable;
                        const name = dict.get("Name");
                        this.data.name = name instanceof _primitives.Name ? (0, _util.stringToPDFString)(name.name) : "PushPin";
                        const fillAlpha = dict.get("ca");
                        this.data.fillAlpha = typeof fillAlpha === "number" && fillAlpha >= 0 && fillAlpha <= 1 ? fillAlpha : null;
                    }
                }
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FakeUnicodeFont = void 0;
                exports.createDefaultAppearance = createDefaultAppearance;
                exports.getPdfColor = getPdfColor;
                exports.parseAppearanceStream = parseAppearanceStream;
                exports.parseDefaultAppearance = parseDefaultAppearance;
                var _primitives = __w_pdfjs_require__(4);
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                var _colorspace = __w_pdfjs_require__(12);
                var _evaluator = __w_pdfjs_require__(13);
                var _image_utils = __w_pdfjs_require__(59);
                var _function = __w_pdfjs_require__(57);
                var _stream = __w_pdfjs_require__(8);
                class DefaultAppearanceEvaluator extends _evaluator.EvaluatorPreprocessor {
                    constructor(str){
                        super(new _stream.StringStream(str));
                    }
                    parse() {
                        const operation = {
                            fn: 0,
                            args: []
                        };
                        const result = {
                            fontSize: 0,
                            fontName: "",
                            fontColor: new Uint8ClampedArray(3)
                        };
                        try {
                            while(true){
                                operation.args.length = 0;
                                if (!this.read(operation)) break;
                                if (this.savedStatesDepth !== 0) continue;
                                const { fn: fn, args: args } = operation;
                                switch(fn | 0){
                                    case _util.OPS.setFont:
                                        const [fontName, fontSize] = args;
                                        if (fontName instanceof _primitives.Name) result.fontName = fontName.name;
                                        if (typeof fontSize === "number" && fontSize > 0) result.fontSize = fontSize;
                                        break;
                                    case _util.OPS.setFillRGBColor:
                                        _colorspace.ColorSpace.singletons.rgb.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillGray:
                                        _colorspace.ColorSpace.singletons.gray.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillCMYKColor:
                                        _colorspace.ColorSpace.singletons.cmyk.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                }
                            }
                        } catch (reason) {
                            (0, _util.warn)(`parseDefaultAppearance - ignoring errors: "${reason}".`);
                        }
                        return result;
                    }
                }
                function parseDefaultAppearance(str) {
                    return new DefaultAppearanceEvaluator(str).parse();
                }
                class AppearanceStreamEvaluator extends _evaluator.EvaluatorPreprocessor {
                    constructor(stream, evaluatorOptions, xref){
                        super(stream);
                        this.stream = stream;
                        this.evaluatorOptions = evaluatorOptions;
                        this.xref = xref;
                        this.resources = stream.dict?.get("Resources");
                    }
                    parse() {
                        const operation = {
                            fn: 0,
                            args: []
                        };
                        let result = {
                            scaleFactor: 1,
                            fontSize: 0,
                            fontName: "",
                            fontColor: new Uint8ClampedArray(3),
                            fillColorSpace: _colorspace.ColorSpace.singletons.gray
                        };
                        let breakLoop = false;
                        const stack = [];
                        try {
                            while(true){
                                operation.args.length = 0;
                                if (breakLoop || !this.read(operation)) break;
                                const { fn: fn, args: args } = operation;
                                switch(fn | 0){
                                    case _util.OPS.save:
                                        stack.push({
                                            scaleFactor: result.scaleFactor,
                                            fontSize: result.fontSize,
                                            fontName: result.fontName,
                                            fontColor: result.fontColor.slice(),
                                            fillColorSpace: result.fillColorSpace
                                        });
                                        break;
                                    case _util.OPS.restore:
                                        result = stack.pop() || result;
                                        break;
                                    case _util.OPS.setTextMatrix:
                                        result.scaleFactor *= Math.hypot(args[0], args[1]);
                                        break;
                                    case _util.OPS.setFont:
                                        const [fontName, fontSize] = args;
                                        if (fontName instanceof _primitives.Name) result.fontName = fontName.name;
                                        if (typeof fontSize === "number" && fontSize > 0) result.fontSize = fontSize * result.scaleFactor;
                                        break;
                                    case _util.OPS.setFillColorSpace:
                                        result.fillColorSpace = _colorspace.ColorSpace.parse({
                                            cs: args[0],
                                            xref: this.xref,
                                            resources: this.resources,
                                            pdfFunctionFactory: this._pdfFunctionFactory,
                                            localColorSpaceCache: this._localColorSpaceCache
                                        });
                                        break;
                                    case _util.OPS.setFillColor:
                                        const cs = result.fillColorSpace;
                                        cs.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillRGBColor:
                                        _colorspace.ColorSpace.singletons.rgb.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillGray:
                                        _colorspace.ColorSpace.singletons.gray.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillCMYKColor:
                                        _colorspace.ColorSpace.singletons.cmyk.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.showText:
                                    case _util.OPS.showSpacedText:
                                    case _util.OPS.nextLineShowText:
                                    case _util.OPS.nextLineSetSpacingShowText:
                                        breakLoop = true;
                                        break;
                                }
                            }
                        } catch (reason) {
                            (0, _util.warn)(`parseAppearanceStream - ignoring errors: "${reason}".`);
                        }
                        this.stream.reset();
                        delete result.scaleFactor;
                        delete result.fillColorSpace;
                        return result;
                    }
                    get _localColorSpaceCache() {
                        return (0, _util.shadow)(this, "_localColorSpaceCache", new _image_utils.LocalColorSpaceCache());
                    }
                    get _pdfFunctionFactory() {
                        const pdfFunctionFactory = new _function.PDFFunctionFactory({
                            xref: this.xref,
                            isEvalSupported: this.evaluatorOptions.isEvalSupported
                        });
                        return (0, _util.shadow)(this, "_pdfFunctionFactory", pdfFunctionFactory);
                    }
                }
                function parseAppearanceStream(stream, evaluatorOptions, xref) {
                    return new AppearanceStreamEvaluator(stream, evaluatorOptions, xref).parse();
                }
                function getPdfColor(color, isFill) {
                    if (color[0] === color[1] && color[1] === color[2]) {
                        const gray = color[0] / 255;
                        return `${(0, _core_utils.numberToString)(gray)} ${isFill ? "g" : "G"}`;
                    }
                    return Array.from(color, (c)=>(0, _core_utils.numberToString)(c / 255)).join(" ") + ` ${isFill ? "rg" : "RG"}`;
                }
                function createDefaultAppearance({ fontSize: fontSize, fontName: fontName, fontColor: fontColor }) {
                    return `/${(0, _core_utils.escapePDFName)(fontName)} ${fontSize} Tf ${getPdfColor(fontColor, true)}`;
                }
                class FakeUnicodeFont {
                    constructor(xref, fontFamily){
                        this.xref = xref;
                        this.widths = null;
                        this.firstChar = Infinity;
                        this.lastChar = -Infinity;
                        this.fontFamily = fontFamily;
                        const canvas = new OffscreenCanvas(1, 1);
                        this.ctxMeasure = canvas.getContext("2d");
                        if (!FakeUnicodeFont._fontNameId) FakeUnicodeFont._fontNameId = 1;
                        this.fontName = _primitives.Name.get(`InvalidPDFjsFont_${fontFamily}_${FakeUnicodeFont._fontNameId++}`);
                    }
                    get toUnicodeRef() {
                        if (!FakeUnicodeFont._toUnicodeRef) {
                            const toUnicode = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo
<< /Registry (Adobe)
/Ordering (UCS) /Supplement 0 >> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000> <FFFF>
endcodespacerange
1 beginbfrange
<0000> <FFFF> <0000>
endbfrange
endcmap CMapName currentdict /CMap defineresource pop end end`;
                            const toUnicodeStream = FakeUnicodeFont.toUnicodeStream = new _stream.StringStream(toUnicode);
                            const toUnicodeDict = new _primitives.Dict(this.xref);
                            toUnicodeStream.dict = toUnicodeDict;
                            toUnicodeDict.set("Length", toUnicode.length);
                            FakeUnicodeFont._toUnicodeRef = this.xref.getNewPersistentRef(toUnicodeStream);
                        }
                        return FakeUnicodeFont._toUnicodeRef;
                    }
                    get fontDescriptorRef() {
                        if (!FakeUnicodeFont._fontDescriptorRef) {
                            const fontDescriptor = new _primitives.Dict(this.xref);
                            fontDescriptor.set("Type", _primitives.Name.get("FontDescriptor"));
                            fontDescriptor.set("FontName", this.fontName);
                            fontDescriptor.set("FontFamily", "MyriadPro Regular");
                            fontDescriptor.set("FontBBox", [
                                0,
                                0,
                                0,
                                0
                            ]);
                            fontDescriptor.set("FontStretch", _primitives.Name.get("Normal"));
                            fontDescriptor.set("FontWeight", 400);
                            fontDescriptor.set("ItalicAngle", 0);
                            FakeUnicodeFont._fontDescriptorRef = this.xref.getNewPersistentRef(fontDescriptor);
                        }
                        return FakeUnicodeFont._fontDescriptorRef;
                    }
                    get descendantFontRef() {
                        const descendantFont = new _primitives.Dict(this.xref);
                        descendantFont.set("BaseFont", this.fontName);
                        descendantFont.set("Type", _primitives.Name.get("Font"));
                        descendantFont.set("Subtype", _primitives.Name.get("CIDFontType0"));
                        descendantFont.set("CIDToGIDMap", _primitives.Name.get("Identity"));
                        descendantFont.set("FirstChar", this.firstChar);
                        descendantFont.set("LastChar", this.lastChar);
                        descendantFont.set("FontDescriptor", this.fontDescriptorRef);
                        descendantFont.set("DW", 1000);
                        const widths = [];
                        const chars = [
                            ...this.widths.entries()
                        ].sort();
                        let currentChar = null;
                        let currentWidths = null;
                        for (const [char, width] of chars){
                            if (!currentChar) {
                                currentChar = char;
                                currentWidths = [
                                    width
                                ];
                                continue;
                            }
                            if (char === currentChar + currentWidths.length) currentWidths.push(width);
                            else {
                                widths.push(currentChar, currentWidths);
                                currentChar = char;
                                currentWidths = [
                                    width
                                ];
                            }
                        }
                        if (currentChar) widths.push(currentChar, currentWidths);
                        descendantFont.set("W", widths);
                        const cidSystemInfo = new _primitives.Dict(this.xref);
                        cidSystemInfo.set("Ordering", "Identity");
                        cidSystemInfo.set("Registry", "Adobe");
                        cidSystemInfo.set("Supplement", 0);
                        descendantFont.set("CIDSystemInfo", cidSystemInfo);
                        return this.xref.getNewPersistentRef(descendantFont);
                    }
                    get baseFontRef() {
                        const baseFont = new _primitives.Dict(this.xref);
                        baseFont.set("BaseFont", this.fontName);
                        baseFont.set("Type", _primitives.Name.get("Font"));
                        baseFont.set("Subtype", _primitives.Name.get("Type0"));
                        baseFont.set("Encoding", _primitives.Name.get("Identity-H"));
                        baseFont.set("DescendantFonts", [
                            this.descendantFontRef
                        ]);
                        baseFont.set("ToUnicode", this.toUnicodeRef);
                        return this.xref.getNewPersistentRef(baseFont);
                    }
                    get resources() {
                        const resources = new _primitives.Dict(this.xref);
                        const font1 = new _primitives.Dict(this.xref);
                        font1.set(this.fontName.name, this.baseFontRef);
                        resources.set("Font", font1);
                        return resources;
                    }
                    _createContext() {
                        this.widths = new Map();
                        this.ctxMeasure.font = `1000px ${this.fontFamily}`;
                        return this.ctxMeasure;
                    }
                    createFontResources(text) {
                        const ctx = this._createContext();
                        for (const line of text.split(/\r\n?|\n/))for (const char of line.split("")){
                            const code = char.charCodeAt(0);
                            if (this.widths.has(code)) continue;
                            const metrics = ctx.measureText(char);
                            const width = Math.ceil(metrics.width);
                            this.widths.set(code, width);
                            this.firstChar = Math.min(code, this.firstChar);
                            this.lastChar = Math.max(code, this.lastChar);
                        }
                        return this.resources;
                    }
                    createAppearance(text, rect, rotation, fontSize, bgColor, strokeAlpha) {
                        const ctx = this._createContext();
                        const lines = [];
                        let maxWidth = -Infinity;
                        for (const line of text.split(/\r\n?|\n/)){
                            lines.push(line);
                            const lineWidth = ctx.measureText(line).width;
                            maxWidth = Math.max(maxWidth, lineWidth);
                            for (const char of line.split("")){
                                const code = char.charCodeAt(0);
                                let width = this.widths.get(code);
                                if (width === undefined) {
                                    const metrics = ctx.measureText(char);
                                    width = Math.ceil(metrics.width);
                                    this.widths.set(code, width);
                                    this.firstChar = Math.min(code, this.firstChar);
                                    this.lastChar = Math.max(code, this.lastChar);
                                }
                            }
                        }
                        maxWidth *= fontSize / 1000;
                        const [x1, y1, x2, y2] = rect;
                        let w = x2 - x1;
                        let h = y2 - y1;
                        if (rotation % 180 !== 0) [w, h] = [
                            h,
                            w
                        ];
                        let hscale = 1;
                        if (maxWidth > w) hscale = w / maxWidth;
                        let vscale = 1;
                        const lineHeight = _util.LINE_FACTOR * fontSize;
                        const lineDescent = _util.LINE_DESCENT_FACTOR * fontSize;
                        const maxHeight = lineHeight * lines.length;
                        if (maxHeight > h) vscale = h / maxHeight;
                        const fscale = Math.min(hscale, vscale);
                        const newFontSize = fontSize * fscale;
                        const buffer = [
                            "q",
                            `0 0 ${(0, _core_utils.numberToString)(w)} ${(0, _core_utils.numberToString)(h)} re W n`,
                            `BT`,
                            `1 0 0 1 0 ${(0, _core_utils.numberToString)(h + lineDescent)} Tm 0 Tc ${getPdfColor(bgColor, true)}`,
                            `/${this.fontName.name} ${(0, _core_utils.numberToString)(newFontSize)} Tf`
                        ];
                        const { resources: resources } = this;
                        strokeAlpha = typeof strokeAlpha === "number" && strokeAlpha >= 0 && strokeAlpha <= 1 ? strokeAlpha : 1;
                        if (strokeAlpha !== 1) {
                            buffer.push("/R0 gs");
                            const extGState = new _primitives.Dict(this.xref);
                            const r0 = new _primitives.Dict(this.xref);
                            r0.set("ca", strokeAlpha);
                            r0.set("CA", strokeAlpha);
                            r0.set("Type", _primitives.Name.get("ExtGState"));
                            extGState.set("R0", r0);
                            resources.set("ExtGState", extGState);
                        }
                        const vShift = (0, _core_utils.numberToString)(lineHeight);
                        for (const line of lines)buffer.push(`0 -${vShift} Td <${(0, _core_utils.stringToUTF16HexString)(line)}> Tj`);
                        buffer.push("ET", "Q");
                        const appearance = buffer.join("\n");
                        const appearanceStreamDict = new _primitives.Dict(this.xref);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceStreamDict.set("Type", _primitives.Name.get("XObject"));
                        appearanceStreamDict.set("BBox", [
                            0,
                            0,
                            w,
                            h
                        ]);
                        appearanceStreamDict.set("Length", appearance.length);
                        appearanceStreamDict.set("Resources", resources);
                        if (rotation) {
                            const matrix = (0, _core_utils.getRotationMatrix)(rotation, w, h);
                            appearanceStreamDict.set("Matrix", matrix);
                        }
                        const ap = new _stream.StringStream(appearance);
                        ap.dict = appearanceStreamDict;
                        return ap;
                    }
                }
                exports.FakeUnicodeFont = FakeUnicodeFont;
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorSpace = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _base_stream = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(3);
                function resizeRgbImage(src, dest, w1, h1, w2, h2, alpha01) {
                    const COMPONENTS = 3;
                    alpha01 = alpha01 !== 1 ? 0 : alpha01;
                    const xRatio = w1 / w2;
                    const yRatio = h1 / h2;
                    let newIndex = 0, oldIndex;
                    const xScaled = new Uint16Array(w2);
                    const w1Scanline = w1 * COMPONENTS;
                    for(let i = 0; i < w2; i++)xScaled[i] = Math.floor(i * xRatio) * COMPONENTS;
                    for(let i = 0; i < h2; i++){
                        const py = Math.floor(i * yRatio) * w1Scanline;
                        for(let j = 0; j < w2; j++){
                            oldIndex = py + xScaled[j];
                            dest[newIndex++] = src[oldIndex++];
                            dest[newIndex++] = src[oldIndex++];
                            dest[newIndex++] = src[oldIndex++];
                            newIndex += alpha01;
                        }
                    }
                }
                class ColorSpace {
                    constructor(name, numComps){
                        if (this.constructor === ColorSpace) (0, _util.unreachable)("Cannot initialize ColorSpace.");
                        this.name = name;
                        this.numComps = numComps;
                    }
                    getRgb(src, srcOffset) {
                        const rgb = new Uint8ClampedArray(3);
                        this.getRgbItem(src, srcOffset, rgb, 0);
                        return rgb;
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        (0, _util.unreachable)("Should not call ColorSpace.getRgbItem");
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        (0, _util.unreachable)("Should not call ColorSpace.getRgbBuffer");
                    }
                    getOutputLength(inputLength, alpha01) {
                        (0, _util.unreachable)("Should not call ColorSpace.getOutputLength");
                    }
                    isPassthrough(bits) {
                        return false;
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
                    }
                    fillRgb(dest, originalWidth, originalHeight, width, height, actualHeight, bpc, comps, alpha01) {
                        const count = originalWidth * originalHeight;
                        let rgbBuf = null;
                        const numComponentColors = 1 << bpc;
                        const needsResizing = originalHeight !== height || originalWidth !== width;
                        if (this.isPassthrough(bpc)) rgbBuf = comps;
                        else if (this.numComps === 1 && count > numComponentColors && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
                            const allColors = bpc <= 8 ? new Uint8Array(numComponentColors) : new Uint16Array(numComponentColors);
                            for(let i = 0; i < numComponentColors; i++)allColors[i] = i;
                            const colorMap = new Uint8ClampedArray(numComponentColors * 3);
                            this.getRgbBuffer(allColors, 0, numComponentColors, colorMap, 0, bpc, 0);
                            if (!needsResizing) {
                                let destPos = 0;
                                for(let i = 0; i < count; ++i){
                                    const key = comps[i] * 3;
                                    dest[destPos++] = colorMap[key];
                                    dest[destPos++] = colorMap[key + 1];
                                    dest[destPos++] = colorMap[key + 2];
                                    destPos += alpha01;
                                }
                            } else {
                                rgbBuf = new Uint8Array(count * 3);
                                let rgbPos = 0;
                                for(let i = 0; i < count; ++i){
                                    const key = comps[i] * 3;
                                    rgbBuf[rgbPos++] = colorMap[key];
                                    rgbBuf[rgbPos++] = colorMap[key + 1];
                                    rgbBuf[rgbPos++] = colorMap[key + 2];
                                }
                            }
                        } else if (!needsResizing) this.getRgbBuffer(comps, 0, width * actualHeight, dest, 0, bpc, alpha01);
                        else {
                            rgbBuf = new Uint8ClampedArray(count * 3);
                            this.getRgbBuffer(comps, 0, count, rgbBuf, 0, bpc, 0);
                        }
                        if (rgbBuf) {
                            if (needsResizing) resizeRgbImage(rgbBuf, dest, originalWidth, originalHeight, width, height, alpha01);
                            else {
                                let destPos = 0, rgbPos = 0;
                                for(let i = 0, ii = width * actualHeight; i < ii; i++){
                                    dest[destPos++] = rgbBuf[rgbPos++];
                                    dest[destPos++] = rgbBuf[rgbPos++];
                                    dest[destPos++] = rgbBuf[rgbPos++];
                                    destPos += alpha01;
                                }
                            }
                        }
                    }
                    get usesZeroToOneRange() {
                        return (0, _util.shadow)(this, "usesZeroToOneRange", true);
                    }
                    static _cache(cacheKey, xref, localColorSpaceCache, parsedColorSpace) {
                        if (!localColorSpaceCache) throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
                        if (!parsedColorSpace) throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
                        let csName, csRef;
                        if (cacheKey instanceof _primitives.Ref) {
                            csRef = cacheKey;
                            cacheKey = xref.fetch(cacheKey);
                        }
                        if (cacheKey instanceof _primitives.Name) csName = cacheKey.name;
                        if (csName || csRef) localColorSpaceCache.set(csName, csRef, parsedColorSpace);
                    }
                    static getCached(cacheKey, xref, localColorSpaceCache) {
                        if (!localColorSpaceCache) throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
                        if (cacheKey instanceof _primitives.Ref) {
                            const localColorSpace = localColorSpaceCache.getByRef(cacheKey);
                            if (localColorSpace) return localColorSpace;
                            try {
                                cacheKey = xref.fetch(cacheKey);
                            } catch (ex) {
                                if (ex instanceof _core_utils.MissingDataException) throw ex;
                            }
                        }
                        if (cacheKey instanceof _primitives.Name) {
                            const localColorSpace = localColorSpaceCache.getByName(cacheKey.name);
                            if (localColorSpace) return localColorSpace;
                        }
                        return null;
                    }
                    static async parseAsync({ cs: cs, xref: xref, resources: resources = null, pdfFunctionFactory: pdfFunctionFactory, localColorSpaceCache: localColorSpaceCache }) {
                        const parsedColorSpace = this._parse(cs, xref, resources, pdfFunctionFactory);
                        this._cache(cs, xref, localColorSpaceCache, parsedColorSpace);
                        return parsedColorSpace;
                    }
                    static parse({ cs: cs, xref: xref, resources: resources = null, pdfFunctionFactory: pdfFunctionFactory, localColorSpaceCache: localColorSpaceCache }) {
                        const cachedColorSpace = this.getCached(cs, xref, localColorSpaceCache);
                        if (cachedColorSpace) return cachedColorSpace;
                        const parsedColorSpace = this._parse(cs, xref, resources, pdfFunctionFactory);
                        this._cache(cs, xref, localColorSpaceCache, parsedColorSpace);
                        return parsedColorSpace;
                    }
                    static _parse(cs, xref, resources = null, pdfFunctionFactory) {
                        cs = xref.fetchIfRef(cs);
                        if (cs instanceof _primitives.Name) switch(cs.name){
                            case "G":
                            case "DeviceGray":
                                return this.singletons.gray;
                            case "RGB":
                            case "DeviceRGB":
                                return this.singletons.rgb;
                            case "CMYK":
                            case "DeviceCMYK":
                                return this.singletons.cmyk;
                            case "Pattern":
                                return new PatternCS(null);
                            default:
                                if (resources instanceof _primitives.Dict) {
                                    const colorSpaces = resources.get("ColorSpace");
                                    if (colorSpaces instanceof _primitives.Dict) {
                                        const resourcesCS = colorSpaces.get(cs.name);
                                        if (resourcesCS) {
                                            if (resourcesCS instanceof _primitives.Name) return this._parse(resourcesCS, xref, resources, pdfFunctionFactory);
                                            cs = resourcesCS;
                                            break;
                                        }
                                    }
                                }
                                throw new _util.FormatError(`Unrecognized ColorSpace: ${cs.name}`);
                        }
                        if (Array.isArray(cs)) {
                            const mode = xref.fetchIfRef(cs[0]).name;
                            let params, numComps, baseCS, whitePoint, blackPoint, gamma;
                            switch(mode){
                                case "G":
                                case "DeviceGray":
                                    return this.singletons.gray;
                                case "RGB":
                                case "DeviceRGB":
                                    return this.singletons.rgb;
                                case "CMYK":
                                case "DeviceCMYK":
                                    return this.singletons.cmyk;
                                case "CalGray":
                                    params = xref.fetchIfRef(cs[1]);
                                    whitePoint = params.getArray("WhitePoint");
                                    blackPoint = params.getArray("BlackPoint");
                                    gamma = params.get("Gamma");
                                    return new CalGrayCS(whitePoint, blackPoint, gamma);
                                case "CalRGB":
                                    params = xref.fetchIfRef(cs[1]);
                                    whitePoint = params.getArray("WhitePoint");
                                    blackPoint = params.getArray("BlackPoint");
                                    gamma = params.getArray("Gamma");
                                    const matrix = params.getArray("Matrix");
                                    return new CalRGBCS(whitePoint, blackPoint, gamma, matrix);
                                case "ICCBased":
                                    const stream = xref.fetchIfRef(cs[1]);
                                    const dict = stream.dict;
                                    numComps = dict.get("N");
                                    const alt = dict.get("Alternate");
                                    if (alt) {
                                        const altCS = this._parse(alt, xref, resources, pdfFunctionFactory);
                                        if (altCS.numComps === numComps) return altCS;
                                        (0, _util.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                                    }
                                    if (numComps === 1) return this.singletons.gray;
                                    else if (numComps === 3) return this.singletons.rgb;
                                    else if (numComps === 4) return this.singletons.cmyk;
                                    break;
                                case "Pattern":
                                    baseCS = cs[1] || null;
                                    if (baseCS) baseCS = this._parse(baseCS, xref, resources, pdfFunctionFactory);
                                    return new PatternCS(baseCS);
                                case "I":
                                case "Indexed":
                                    baseCS = this._parse(cs[1], xref, resources, pdfFunctionFactory);
                                    const hiVal = xref.fetchIfRef(cs[2]) + 1;
                                    const lookup = xref.fetchIfRef(cs[3]);
                                    return new IndexedCS(baseCS, hiVal, lookup);
                                case "Separation":
                                case "DeviceN":
                                    const name = xref.fetchIfRef(cs[1]);
                                    numComps = Array.isArray(name) ? name.length : 1;
                                    baseCS = this._parse(cs[2], xref, resources, pdfFunctionFactory);
                                    const tintFn = pdfFunctionFactory.create(cs[3]);
                                    return new AlternateCS(numComps, baseCS, tintFn);
                                case "Lab":
                                    params = xref.fetchIfRef(cs[1]);
                                    whitePoint = params.getArray("WhitePoint");
                                    blackPoint = params.getArray("BlackPoint");
                                    const range = params.getArray("Range");
                                    return new LabCS(whitePoint, blackPoint, range);
                                default:
                                    throw new _util.FormatError(`Unimplemented ColorSpace object: ${mode}`);
                            }
                        }
                        throw new _util.FormatError(`Unrecognized ColorSpace object: ${cs}`);
                    }
                    static isDefaultDecode(decode, numComps) {
                        if (!Array.isArray(decode)) return true;
                        if (numComps * 2 !== decode.length) {
                            (0, _util.warn)("The decode map is not the correct length");
                            return true;
                        }
                        for(let i = 0, ii = decode.length; i < ii; i += 2){
                            if (decode[i] !== 0 || decode[i + 1] !== 1) return false;
                        }
                        return true;
                    }
                    static get singletons() {
                        return (0, _util.shadow)(this, "singletons", {
                            get gray () {
                                return (0, _util.shadow)(this, "gray", new DeviceGrayCS());
                            },
                            get rgb () {
                                return (0, _util.shadow)(this, "rgb", new DeviceRgbCS());
                            },
                            get cmyk () {
                                return (0, _util.shadow)(this, "cmyk", new DeviceCmykCS());
                            }
                        });
                    }
                }
                exports.ColorSpace = ColorSpace;
                class AlternateCS extends ColorSpace {
                    constructor(numComps, base, tintFn){
                        super("Alternate", numComps);
                        this.base = base;
                        this.tintFn = tintFn;
                        this.tmpBuf = new Float32Array(base.numComps);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        const tmpBuf = this.tmpBuf;
                        this.tintFn(src, srcOffset, tmpBuf, 0);
                        this.base.getRgbItem(tmpBuf, 0, dest, destOffset);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const tintFn = this.tintFn;
                        const base = this.base;
                        const scale = 1 / ((1 << bits) - 1);
                        const baseNumComps = base.numComps;
                        const usesZeroToOneRange = base.usesZeroToOneRange;
                        const isPassthrough = (base.isPassthrough(8) || !usesZeroToOneRange) && alpha01 === 0;
                        let pos = isPassthrough ? destOffset : 0;
                        const baseBuf = isPassthrough ? dest : new Uint8ClampedArray(baseNumComps * count);
                        const numComps = this.numComps;
                        const scaled = new Float32Array(numComps);
                        const tinted = new Float32Array(baseNumComps);
                        let i, j;
                        for(i = 0; i < count; i++){
                            for(j = 0; j < numComps; j++)scaled[j] = src[srcOffset++] * scale;
                            tintFn(scaled, 0, tinted, 0);
                            if (usesZeroToOneRange) for(j = 0; j < baseNumComps; j++)baseBuf[pos++] = tinted[j] * 255;
                            else {
                                base.getRgbItem(tinted, 0, baseBuf, pos);
                                pos += baseNumComps;
                            }
                        }
                        if (!isPassthrough) base.getRgbBuffer(baseBuf, 0, count, dest, destOffset, 8, alpha01);
                    }
                    getOutputLength(inputLength, alpha01) {
                        return this.base.getOutputLength(inputLength * this.base.numComps / this.numComps, alpha01);
                    }
                }
                class PatternCS extends ColorSpace {
                    constructor(baseCS){
                        super("Pattern", null);
                        this.base = baseCS;
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        (0, _util.unreachable)("Should not call PatternCS.isDefaultDecode");
                    }
                }
                class IndexedCS extends ColorSpace {
                    constructor(base, highVal, lookup){
                        super("Indexed", 1);
                        this.base = base;
                        this.highVal = highVal;
                        const length = base.numComps * highVal;
                        this.lookup = new Uint8Array(length);
                        if (lookup instanceof _base_stream.BaseStream) {
                            const bytes = lookup.getBytes(length);
                            this.lookup.set(bytes);
                        } else if (typeof lookup === "string") for(let i = 0; i < length; ++i)this.lookup[i] = lookup.charCodeAt(i) & 0xff;
                        else throw new _util.FormatError(`IndexedCS - unrecognized lookup table: ${lookup}`);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        const numComps = this.base.numComps;
                        const start = src[srcOffset] * numComps;
                        this.base.getRgbBuffer(this.lookup, start, 1, dest, destOffset, 8, 0);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const base = this.base;
                        const numComps = base.numComps;
                        const outputDelta = base.getOutputLength(numComps, alpha01);
                        const lookup = this.lookup;
                        for(let i = 0; i < count; ++i){
                            const lookupPos = src[srcOffset++] * numComps;
                            base.getRgbBuffer(lookup, lookupPos, 1, dest, destOffset, 8, alpha01);
                            destOffset += outputDelta;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return this.base.getOutputLength(inputLength * this.base.numComps, alpha01);
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        if (!Array.isArray(decodeMap)) return true;
                        if (decodeMap.length !== 2) {
                            (0, _util.warn)("Decode map length is not correct");
                            return true;
                        }
                        if (!Number.isInteger(bpc) || bpc < 1) {
                            (0, _util.warn)("Bits per component is not correct");
                            return true;
                        }
                        return decodeMap[0] === 0 && decodeMap[1] === (1 << bpc) - 1;
                    }
                }
                class DeviceGrayCS extends ColorSpace {
                    constructor(){
                        super("DeviceGray", 1);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        const c = src[srcOffset] * 255;
                        dest[destOffset] = dest[destOffset + 1] = dest[destOffset + 2] = c;
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const scale = 255 / ((1 << bits) - 1);
                        let j = srcOffset, q = destOffset;
                        for(let i = 0; i < count; ++i){
                            const c = scale * src[j++];
                            dest[q++] = c;
                            dest[q++] = c;
                            dest[q++] = c;
                            q += alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01);
                    }
                }
                class DeviceRgbCS extends ColorSpace {
                    constructor(){
                        super("DeviceRGB", 3);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        dest[destOffset] = src[srcOffset] * 255;
                        dest[destOffset + 1] = src[srcOffset + 1] * 255;
                        dest[destOffset + 2] = src[srcOffset + 2] * 255;
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        if (bits === 8 && alpha01 === 0) {
                            dest.set(src.subarray(srcOffset, srcOffset + count * 3), destOffset);
                            return;
                        }
                        const scale = 255 / ((1 << bits) - 1);
                        let j = srcOffset, q = destOffset;
                        for(let i = 0; i < count; ++i){
                            dest[q++] = scale * src[j++];
                            dest[q++] = scale * src[j++];
                            dest[q++] = scale * src[j++];
                            q += alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01) / 3 | 0;
                    }
                    isPassthrough(bits) {
                        return bits === 8;
                    }
                }
                class DeviceCmykCS extends ColorSpace {
                    constructor(){
                        super("DeviceCMYK", 4);
                    }
                    #toRgb(src, srcOffset, srcScale, dest, destOffset) {
                        const c = src[srcOffset] * srcScale;
                        const m = src[srcOffset + 1] * srcScale;
                        const y = src[srcOffset + 2] * srcScale;
                        const k = src[srcOffset + 3] * srcScale;
                        dest[destOffset] = 255 + c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k + -285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y + -17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) + k * (-21.86122147463605 * k - 189.48180835922747);
                        dest[destOffset + 1] = 255 + c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k + -79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) + k * (-20.737325471181034 * k - 187.80453709719578);
                        dest[destOffset + 2] = 255 + c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k + -14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k + -193.58209356861505) + k * (-22.33816807309886 * k - 180.12613974708367);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        this.#toRgb(src, srcOffset, 1, dest, destOffset);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const scale = 1 / ((1 << bits) - 1);
                        for(let i = 0; i < count; i++){
                            this.#toRgb(src, srcOffset, scale, dest, destOffset);
                            srcOffset += 4;
                            destOffset += 3 + alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength / 4 * (3 + alpha01) | 0;
                    }
                }
                class CalGrayCS extends ColorSpace {
                    constructor(whitePoint, blackPoint, gamma){
                        super("CalGray", 1);
                        if (!whitePoint) throw new _util.FormatError("WhitePoint missing - required for color space CalGray");
                        [this.XW, this.YW, this.ZW] = whitePoint;
                        [this.XB, this.YB, this.ZB] = blackPoint || [
                            0,
                            0,
                            0
                        ];
                        this.G = gamma || 1;
                        if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) throw new _util.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                        if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                            (0, _util.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`);
                            this.XB = this.YB = this.ZB = 0;
                        }
                        if (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) (0, _util.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ` + `ZB: ${this.ZB}, only default values are supported.`);
                        if (this.G < 1) {
                            (0, _util.info)(`Invalid Gamma: ${this.G} for ${this.name}, falling back to default.`);
                            this.G = 1;
                        }
                    }
                    #toRgb(src, srcOffset, dest, destOffset, scale) {
                        const A = src[srcOffset] * scale;
                        const AG = A ** this.G;
                        const L = this.YW * AG;
                        const val = Math.max(295.8 * L ** 0.3333333333333333 - 40.8, 0);
                        dest[destOffset] = val;
                        dest[destOffset + 1] = val;
                        dest[destOffset + 2] = val;
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        this.#toRgb(src, srcOffset, dest, destOffset, 1);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const scale = 1 / ((1 << bits) - 1);
                        for(let i = 0; i < count; ++i){
                            this.#toRgb(src, srcOffset, dest, destOffset, scale);
                            srcOffset += 1;
                            destOffset += 3 + alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01);
                    }
                }
                class CalRGBCS extends ColorSpace {
                    static #BRADFORD_SCALE_MATRIX = new Float32Array([
                        0.8951,
                        0.2664,
                        -0.1614,
                        -0.7502,
                        1.7135,
                        0.0367,
                        0.0389,
                        -0.0685,
                        1.0296
                    ]);
                    static #BRADFORD_SCALE_INVERSE_MATRIX = new Float32Array([
                        0.9869929,
                        -0.1470543,
                        0.1599627,
                        0.4323053,
                        0.5183603,
                        0.0492912,
                        -0.0085287,
                        0.0400428,
                        0.9684867
                    ]);
                    static #SRGB_D65_XYZ_TO_RGB_MATRIX = new Float32Array([
                        3.2404542,
                        -1.5371385,
                        -0.4985314,
                        -0.969266,
                        1.8760108,
                        0.0415560,
                        0.0556434,
                        -0.2040259,
                        1.0572252
                    ]);
                    static #FLAT_WHITEPOINT_MATRIX = new Float32Array([
                        1,
                        1,
                        1
                    ]);
                    static #tempNormalizeMatrix = new Float32Array(3);
                    static #tempConvertMatrix1 = new Float32Array(3);
                    static #tempConvertMatrix2 = new Float32Array(3);
                    static #DECODE_L_CONSTANT = (24 / 116) ** 3 / 8.0;
                    constructor(whitePoint, blackPoint, gamma, matrix){
                        super("CalRGB", 3);
                        if (!whitePoint) throw new _util.FormatError("WhitePoint missing - required for color space CalRGB");
                        const [XW, YW, ZW] = this.whitePoint = whitePoint;
                        const [XB, YB, ZB] = this.blackPoint = blackPoint || new Float32Array(3);
                        [this.GR, this.GG, this.GB] = gamma || new Float32Array([
                            1,
                            1,
                            1
                        ]);
                        [this.MXA, this.MYA, this.MZA, this.MXB, this.MYB, this.MZB, this.MXC, this.MYC, this.MZC] = matrix || new Float32Array([
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ]);
                        if (XW < 0 || ZW < 0 || YW !== 1) throw new _util.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                        if (XB < 0 || YB < 0 || ZB < 0) {
                            (0, _util.info)(`Invalid BlackPoint for ${this.name} [${XB}, ${YB}, ${ZB}], ` + "falling back to default.");
                            this.blackPoint = new Float32Array(3);
                        }
                        if (this.GR < 0 || this.GG < 0 || this.GB < 0) {
                            (0, _util.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ` + `${this.name}, falling back to default.`);
                            this.GR = this.GG = this.GB = 1;
                        }
                    }
                    #matrixProduct(a, b, result) {
                        result[0] = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
                        result[1] = a[3] * b[0] + a[4] * b[1] + a[5] * b[2];
                        result[2] = a[6] * b[0] + a[7] * b[1] + a[8] * b[2];
                    }
                    #toFlat(sourceWhitePoint, LMS, result) {
                        result[0] = LMS[0] * 1 / sourceWhitePoint[0];
                        result[1] = LMS[1] * 1 / sourceWhitePoint[1];
                        result[2] = LMS[2] * 1 / sourceWhitePoint[2];
                    }
                    #toD65(sourceWhitePoint, LMS, result) {
                        const D65X = 0.95047;
                        const D65Y = 1;
                        const D65Z = 1.08883;
                        result[0] = LMS[0] * D65X / sourceWhitePoint[0];
                        result[1] = LMS[1] * D65Y / sourceWhitePoint[1];
                        result[2] = LMS[2] * D65Z / sourceWhitePoint[2];
                    }
                    #sRGBTransferFunction(color) {
                        if (color <= 0.0031308) return this.#adjustToRange(0, 1, 12.92 * color);
                        if (color >= 0.99554525) return 1;
                        return this.#adjustToRange(0, 1, 1.055 * color ** (1 / 2.4) - 0.055);
                    }
                    #adjustToRange(min, max, value) {
                        return Math.max(min, Math.min(max, value));
                    }
                    #decodeL(L) {
                        if (L < 0) return -this.#decodeL(-L);
                        if (L > 8.0) return ((L + 16) / 116) ** 3;
                        return L * CalRGBCS.#DECODE_L_CONSTANT;
                    }
                    #compensateBlackPoint(sourceBlackPoint, XYZ_Flat, result) {
                        if (sourceBlackPoint[0] === 0 && sourceBlackPoint[1] === 0 && sourceBlackPoint[2] === 0) {
                            result[0] = XYZ_Flat[0];
                            result[1] = XYZ_Flat[1];
                            result[2] = XYZ_Flat[2];
                            return;
                        }
                        const zeroDecodeL = this.#decodeL(0);
                        const X_DST = zeroDecodeL;
                        const X_SRC = this.#decodeL(sourceBlackPoint[0]);
                        const Y_DST = zeroDecodeL;
                        const Y_SRC = this.#decodeL(sourceBlackPoint[1]);
                        const Z_DST = zeroDecodeL;
                        const Z_SRC = this.#decodeL(sourceBlackPoint[2]);
                        const X_Scale = (1 - X_DST) / (1 - X_SRC);
                        const X_Offset = 1 - X_Scale;
                        const Y_Scale = (1 - Y_DST) / (1 - Y_SRC);
                        const Y_Offset = 1 - Y_Scale;
                        const Z_Scale = (1 - Z_DST) / (1 - Z_SRC);
                        const Z_Offset = 1 - Z_Scale;
                        result[0] = XYZ_Flat[0] * X_Scale + X_Offset;
                        result[1] = XYZ_Flat[1] * Y_Scale + Y_Offset;
                        result[2] = XYZ_Flat[2] * Z_Scale + Z_Offset;
                    }
                    #normalizeWhitePointToFlat(sourceWhitePoint, XYZ_In, result) {
                        if (sourceWhitePoint[0] === 1 && sourceWhitePoint[2] === 1) {
                            result[0] = XYZ_In[0];
                            result[1] = XYZ_In[1];
                            result[2] = XYZ_In[2];
                            return;
                        }
                        const LMS = result;
                        this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
                        const LMS_Flat = CalRGBCS.#tempNormalizeMatrix;
                        this.#toFlat(sourceWhitePoint, LMS, LMS_Flat);
                        this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_INVERSE_MATRIX, LMS_Flat, result);
                    }
                    #normalizeWhitePointToD65(sourceWhitePoint, XYZ_In, result) {
                        const LMS = result;
                        this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
                        const LMS_D65 = CalRGBCS.#tempNormalizeMatrix;
                        this.#toD65(sourceWhitePoint, LMS, LMS_D65);
                        this.#matrixProduct(CalRGBCS.#BRADFORD_SCALE_INVERSE_MATRIX, LMS_D65, result);
                    }
                    #toRgb(src, srcOffset, dest, destOffset, scale) {
                        const A = this.#adjustToRange(0, 1, src[srcOffset] * scale);
                        const B = this.#adjustToRange(0, 1, src[srcOffset + 1] * scale);
                        const C = this.#adjustToRange(0, 1, src[srcOffset + 2] * scale);
                        const AGR = A === 1 ? 1 : A ** this.GR;
                        const BGG = B === 1 ? 1 : B ** this.GG;
                        const CGB = C === 1 ? 1 : C ** this.GB;
                        const X = this.MXA * AGR + this.MXB * BGG + this.MXC * CGB;
                        const Y = this.MYA * AGR + this.MYB * BGG + this.MYC * CGB;
                        const Z = this.MZA * AGR + this.MZB * BGG + this.MZC * CGB;
                        const XYZ = CalRGBCS.#tempConvertMatrix1;
                        XYZ[0] = X;
                        XYZ[1] = Y;
                        XYZ[2] = Z;
                        const XYZ_Flat = CalRGBCS.#tempConvertMatrix2;
                        this.#normalizeWhitePointToFlat(this.whitePoint, XYZ, XYZ_Flat);
                        const XYZ_Black = CalRGBCS.#tempConvertMatrix1;
                        this.#compensateBlackPoint(this.blackPoint, XYZ_Flat, XYZ_Black);
                        const XYZ_D65 = CalRGBCS.#tempConvertMatrix2;
                        this.#normalizeWhitePointToD65(CalRGBCS.#FLAT_WHITEPOINT_MATRIX, XYZ_Black, XYZ_D65);
                        const SRGB = CalRGBCS.#tempConvertMatrix1;
                        this.#matrixProduct(CalRGBCS.#SRGB_D65_XYZ_TO_RGB_MATRIX, XYZ_D65, SRGB);
                        dest[destOffset] = this.#sRGBTransferFunction(SRGB[0]) * 255;
                        dest[destOffset + 1] = this.#sRGBTransferFunction(SRGB[1]) * 255;
                        dest[destOffset + 2] = this.#sRGBTransferFunction(SRGB[2]) * 255;
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        this.#toRgb(src, srcOffset, dest, destOffset, 1);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const scale = 1 / ((1 << bits) - 1);
                        for(let i = 0; i < count; ++i){
                            this.#toRgb(src, srcOffset, dest, destOffset, scale);
                            srcOffset += 3;
                            destOffset += 3 + alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01) / 3 | 0;
                    }
                }
                class LabCS extends ColorSpace {
                    constructor(whitePoint, blackPoint, range){
                        super("Lab", 3);
                        if (!whitePoint) throw new _util.FormatError("WhitePoint missing - required for color space Lab");
                        [this.XW, this.YW, this.ZW] = whitePoint;
                        [this.amin, this.amax, this.bmin, this.bmax] = range || [
                            -100,
                            100,
                            -100,
                            100
                        ];
                        [this.XB, this.YB, this.ZB] = blackPoint || [
                            0,
                            0,
                            0
                        ];
                        if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) throw new _util.FormatError("Invalid WhitePoint components, no fallback available");
                        if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                            (0, _util.info)("Invalid BlackPoint, falling back to default");
                            this.XB = this.YB = this.ZB = 0;
                        }
                        if (this.amin > this.amax || this.bmin > this.bmax) {
                            (0, _util.info)("Invalid Range, falling back to defaults");
                            this.amin = -100;
                            this.amax = 100;
                            this.bmin = -100;
                            this.bmax = 100;
                        }
                    }
                    #fn_g(x) {
                        return x >= 6 / 29 ? x ** 3 : 108 / 841 * (x - 4 / 29);
                    }
                    #decode(value, high1, low2, high2) {
                        return low2 + value * (high2 - low2) / high1;
                    }
                    #toRgb(src, srcOffset, maxVal, dest, destOffset) {
                        let Ls = src[srcOffset];
                        let as = src[srcOffset + 1];
                        let bs = src[srcOffset + 2];
                        if (maxVal !== false) {
                            Ls = this.#decode(Ls, maxVal, 0, 100);
                            as = this.#decode(as, maxVal, this.amin, this.amax);
                            bs = this.#decode(bs, maxVal, this.bmin, this.bmax);
                        }
                        if (as > this.amax) as = this.amax;
                        else if (as < this.amin) as = this.amin;
                        if (bs > this.bmax) bs = this.bmax;
                        else if (bs < this.bmin) bs = this.bmin;
                        const M = (Ls + 16) / 116;
                        const L = M + as / 500;
                        const N = M - bs / 200;
                        const X = this.XW * this.#fn_g(L);
                        const Y = this.YW * this.#fn_g(M);
                        const Z = this.ZW * this.#fn_g(N);
                        let r, g, b;
                        if (this.ZW < 1) {
                            r = X * 3.1339 + Y * -1.617 + Z * -0.4906;
                            g = X * -0.9785 + Y * 1.916 + Z * 0.0333;
                            b = X * 0.072 + Y * -0.229 + Z * 1.4057;
                        } else {
                            r = X * 3.2406 + Y * -1.5372 + Z * -0.4986;
                            g = X * -0.9689 + Y * 1.8758 + Z * 0.0415;
                            b = X * 0.0557 + Y * -0.204 + Z * 1.057;
                        }
                        dest[destOffset] = Math.sqrt(r) * 255;
                        dest[destOffset + 1] = Math.sqrt(g) * 255;
                        dest[destOffset + 2] = Math.sqrt(b) * 255;
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        this.#toRgb(src, srcOffset, false, dest, destOffset);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const maxVal = (1 << bits) - 1;
                        for(let i = 0; i < count; i++){
                            this.#toRgb(src, srcOffset, maxVal, dest, destOffset);
                            srcOffset += 3;
                            destOffset += 3 + alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01) / 3 | 0;
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        return true;
                    }
                    get usesZeroToOneRange() {
                        return (0, _util.shadow)(this, "usesZeroToOneRange", false);
                    }
                }
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PartialEvaluator = exports.EvaluatorPreprocessor = void 0;
                var _util = __w_pdfjs_require__(2);
                var _cmap = __w_pdfjs_require__(14);
                var _primitives = __w_pdfjs_require__(4);
                var _fonts = __w_pdfjs_require__(34);
                var _encodings = __w_pdfjs_require__(37);
                var _standard_fonts = __w_pdfjs_require__(41);
                var _pattern = __w_pdfjs_require__(50);
                var _xfa_fonts = __w_pdfjs_require__(51);
                var _to_unicode_map = __w_pdfjs_require__(42);
                var _function = __w_pdfjs_require__(57);
                var _parser = __w_pdfjs_require__(16);
                var _image_utils = __w_pdfjs_require__(59);
                var _stream = __w_pdfjs_require__(8);
                var _base_stream = __w_pdfjs_require__(5);
                var _bidi = __w_pdfjs_require__(60);
                var _colorspace = __w_pdfjs_require__(12);
                var _decode_stream = __w_pdfjs_require__(18);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _font_substitutions = __w_pdfjs_require__(61);
                var _glyphlist = __w_pdfjs_require__(39);
                var _metrics = __w_pdfjs_require__(45);
                var _unicode = __w_pdfjs_require__(40);
                var _image_resizer = __w_pdfjs_require__(62);
                var _murmurhash = __w_pdfjs_require__(63);
                var _operator_list = __w_pdfjs_require__(64);
                var _image = __w_pdfjs_require__(65);
                const DefaultPartialEvaluatorOptions = Object.freeze({
                    maxImageSize: -1,
                    disableFontFace: false,
                    ignoreErrors: false,
                    isEvalSupported: true,
                    isOffscreenCanvasSupported: false,
                    canvasMaxAreaInBytes: -1,
                    fontExtraProperties: false,
                    useSystemFonts: true,
                    cMapUrl: null,
                    standardFontDataUrl: null
                });
                const PatternType = {
                    TILING: 1,
                    SHADING: 2
                };
                const TEXT_CHUNK_BATCH_SIZE = 10;
                const deferred = Promise.resolve();
                function normalizeBlendMode(value, parsingArray = false) {
                    if (Array.isArray(value)) {
                        for (const val of value){
                            const maybeBM = normalizeBlendMode(val, true);
                            if (maybeBM) return maybeBM;
                        }
                        (0, _util.warn)(`Unsupported blend mode Array: ${value}`);
                        return "source-over";
                    }
                    if (!(value instanceof _primitives.Name)) {
                        if (parsingArray) return null;
                        return "source-over";
                    }
                    switch(value.name){
                        case "Normal":
                        case "Compatible":
                            return "source-over";
                        case "Multiply":
                            return "multiply";
                        case "Screen":
                            return "screen";
                        case "Overlay":
                            return "overlay";
                        case "Darken":
                            return "darken";
                        case "Lighten":
                            return "lighten";
                        case "ColorDodge":
                            return "color-dodge";
                        case "ColorBurn":
                            return "color-burn";
                        case "HardLight":
                            return "hard-light";
                        case "SoftLight":
                            return "soft-light";
                        case "Difference":
                            return "difference";
                        case "Exclusion":
                            return "exclusion";
                        case "Hue":
                            return "hue";
                        case "Saturation":
                            return "saturation";
                        case "Color":
                            return "color";
                        case "Luminosity":
                            return "luminosity";
                    }
                    if (parsingArray) return null;
                    (0, _util.warn)(`Unsupported blend mode: ${value.name}`);
                    return "source-over";
                }
                function incrementCachedImageMaskCount(data) {
                    if (data.fn === _util.OPS.paintImageMaskXObject && data.args[0]?.count > 0) data.args[0].count++;
                }
                class TimeSlotManager {
                    static TIME_SLOT_DURATION_MS = 20;
                    static CHECK_TIME_EVERY = 100;
                    constructor(){
                        this.reset();
                    }
                    check() {
                        if (++this.checked < TimeSlotManager.CHECK_TIME_EVERY) return false;
                        this.checked = 0;
                        return this.endTime <= Date.now();
                    }
                    reset() {
                        this.endTime = Date.now() + TimeSlotManager.TIME_SLOT_DURATION_MS;
                        this.checked = 0;
                    }
                }
                class PartialEvaluator {
                    constructor({ xref: xref, handler: handler, pageIndex: pageIndex, idFactory: idFactory, fontCache: fontCache, builtInCMapCache: builtInCMapCache, standardFontDataCache: standardFontDataCache, globalImageCache: globalImageCache, systemFontCache: systemFontCache, options: options = null }){
                        this.xref = xref;
                        this.handler = handler;
                        this.pageIndex = pageIndex;
                        this.idFactory = idFactory;
                        this.fontCache = fontCache;
                        this.builtInCMapCache = builtInCMapCache;
                        this.standardFontDataCache = standardFontDataCache;
                        this.globalImageCache = globalImageCache;
                        this.systemFontCache = systemFontCache;
                        this.options = options || DefaultPartialEvaluatorOptions;
                        this.parsingType3Font = false;
                        this._regionalImageCache = new _image_utils.RegionalImageCache();
                        this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this);
                        _image_resizer.ImageResizer.setMaxArea(this.options.canvasMaxAreaInBytes);
                    }
                    get _pdfFunctionFactory() {
                        const pdfFunctionFactory = new _function.PDFFunctionFactory({
                            xref: this.xref,
                            isEvalSupported: this.options.isEvalSupported
                        });
                        return (0, _util.shadow)(this, "_pdfFunctionFactory", pdfFunctionFactory);
                    }
                    clone(newOptions = null) {
                        const newEvaluator = Object.create(this);
                        newEvaluator.options = Object.assign(Object.create(null), this.options, newOptions);
                        return newEvaluator;
                    }
                    hasBlendModes(resources, nonBlendModesSet) {
                        if (!(resources instanceof _primitives.Dict)) return false;
                        if (resources.objId && nonBlendModesSet.has(resources.objId)) return false;
                        const processed = new _primitives.RefSet(nonBlendModesSet);
                        if (resources.objId) processed.put(resources.objId);
                        const nodes = [
                            resources
                        ], xref = this.xref;
                        while(nodes.length){
                            const node = nodes.shift();
                            const graphicStates = node.get("ExtGState");
                            if (graphicStates instanceof _primitives.Dict) for (let graphicState of graphicStates.getRawValues()){
                                if (graphicState instanceof _primitives.Ref) {
                                    if (processed.has(graphicState)) continue;
                                    try {
                                        graphicState = xref.fetch(graphicState);
                                    } catch (ex) {
                                        processed.put(graphicState);
                                        (0, _util.info)(`hasBlendModes - ignoring ExtGState: "${ex}".`);
                                        continue;
                                    }
                                }
                                if (!(graphicState instanceof _primitives.Dict)) continue;
                                if (graphicState.objId) processed.put(graphicState.objId);
                                const bm = graphicState.get("BM");
                                if (bm instanceof _primitives.Name) {
                                    if (bm.name !== "Normal") return true;
                                    continue;
                                }
                                if (bm !== undefined && Array.isArray(bm)) for (const element of bm){
                                    if (element instanceof _primitives.Name && element.name !== "Normal") return true;
                                }
                            }
                            const xObjects = node.get("XObject");
                            if (!(xObjects instanceof _primitives.Dict)) continue;
                            for (let xObject of xObjects.getRawValues()){
                                if (xObject instanceof _primitives.Ref) {
                                    if (processed.has(xObject)) continue;
                                    try {
                                        xObject = xref.fetch(xObject);
                                    } catch (ex) {
                                        processed.put(xObject);
                                        (0, _util.info)(`hasBlendModes - ignoring XObject: "${ex}".`);
                                        continue;
                                    }
                                }
                                if (!(xObject instanceof _base_stream.BaseStream)) continue;
                                if (xObject.dict.objId) processed.put(xObject.dict.objId);
                                const xResources = xObject.dict.get("Resources");
                                if (!(xResources instanceof _primitives.Dict)) continue;
                                if (xResources.objId && processed.has(xResources.objId)) continue;
                                nodes.push(xResources);
                                if (xResources.objId) processed.put(xResources.objId);
                            }
                        }
                        for (const ref of processed)nonBlendModesSet.put(ref);
                        return false;
                    }
                    async fetchBuiltInCMap(name) {
                        const cachedData = this.builtInCMapCache.get(name);
                        if (cachedData) return cachedData;
                        let data;
                        if (this.options.cMapUrl !== null) {
                            const url = `${this.options.cMapUrl}${name}.bcmap`;
                            const response = await fetch(url);
                            if (!response.ok) throw new Error(`fetchBuiltInCMap: failed to fetch file "${url}" with "${response.statusText}".`);
                            data = {
                                cMapData: new Uint8Array(await response.arrayBuffer()),
                                compressionType: _util.CMapCompressionType.BINARY
                            };
                        } else data = await this.handler.sendWithPromise("FetchBuiltInCMap", {
                            name: name
                        });
                        if (data.compressionType !== _util.CMapCompressionType.NONE) this.builtInCMapCache.set(name, data);
                        return data;
                    }
                    async fetchStandardFontData(name) {
                        const cachedData = this.standardFontDataCache.get(name);
                        if (cachedData) return new _stream.Stream(cachedData);
                        if (this.options.useSystemFonts && name !== "Symbol" && name !== "ZapfDingbats") return null;
                        const standardFontNameToFileName = (0, _standard_fonts.getFontNameToFileMap)(), filename = standardFontNameToFileName[name];
                        let data;
                        if (this.options.standardFontDataUrl !== null) {
                            const url = `${this.options.standardFontDataUrl}${filename}`;
                            const response = await fetch(url);
                            if (!response.ok) (0, _util.warn)(`fetchStandardFontData: failed to fetch file "${url}" with "${response.statusText}".`);
                            else data = await response.arrayBuffer();
                        } else try {
                            data = await this.handler.sendWithPromise("FetchStandardFontData", {
                                filename: filename
                            });
                        } catch (e) {
                            (0, _util.warn)(`fetchStandardFontData: failed to fetch file "${filename}" with "${e}".`);
                        }
                        if (!data) return null;
                        this.standardFontDataCache.set(name, data);
                        return new _stream.Stream(data);
                    }
                    async buildFormXObject(resources, xobj, smask, operatorList, task, initialState, localColorSpaceCache) {
                        const dict = xobj.dict;
                        const matrix = dict.getArray("Matrix");
                        let bbox = dict.getArray("BBox");
                        bbox = Array.isArray(bbox) && bbox.length === 4 ? _util.Util.normalizeRect(bbox) : null;
                        let optionalContent, groupOptions;
                        if (dict.has("OC")) optionalContent = await this.parseMarkedContentProps(dict.get("OC"), resources);
                        if (optionalContent !== undefined) operatorList.addOp(_util.OPS.beginMarkedContentProps, [
                            "OC",
                            optionalContent
                        ]);
                        const group = dict.get("Group");
                        if (group) {
                            groupOptions = {
                                matrix: matrix,
                                bbox: bbox,
                                smask: smask,
                                isolated: false,
                                knockout: false
                            };
                            const groupSubtype = group.get("S");
                            let colorSpace = null;
                            if ((0, _primitives.isName)(groupSubtype, "Transparency")) {
                                groupOptions.isolated = group.get("I") || false;
                                groupOptions.knockout = group.get("K") || false;
                                if (group.has("CS")) {
                                    const cs = group.getRaw("CS");
                                    const cachedColorSpace = _colorspace.ColorSpace.getCached(cs, this.xref, localColorSpaceCache);
                                    if (cachedColorSpace) colorSpace = cachedColorSpace;
                                    else colorSpace = await this.parseColorSpace({
                                        cs: cs,
                                        resources: resources,
                                        localColorSpaceCache: localColorSpaceCache
                                    });
                                }
                            }
                            if (smask?.backdrop) {
                                colorSpace ||= _colorspace.ColorSpace.singletons.rgb;
                                smask.backdrop = colorSpace.getRgb(smask.backdrop, 0);
                            }
                            operatorList.addOp(_util.OPS.beginGroup, [
                                groupOptions
                            ]);
                        }
                        const args = group ? [
                            matrix,
                            null
                        ] : [
                            matrix,
                            bbox
                        ];
                        operatorList.addOp(_util.OPS.paintFormXObjectBegin, args);
                        return this.getOperatorList({
                            stream: xobj,
                            task: task,
                            resources: dict.get("Resources") || resources,
                            operatorList: operatorList,
                            initialState: initialState
                        }).then(function() {
                            operatorList.addOp(_util.OPS.paintFormXObjectEnd, []);
                            if (group) operatorList.addOp(_util.OPS.endGroup, [
                                groupOptions
                            ]);
                            if (optionalContent !== undefined) operatorList.addOp(_util.OPS.endMarkedContent, []);
                        });
                    }
                    _sendImgData(objId, imgData, cacheGlobally = false) {
                        const transfers = imgData ? [
                            imgData.bitmap || imgData.data.buffer
                        ] : null;
                        if (this.parsingType3Font || cacheGlobally) return this.handler.send("commonobj", [
                            objId,
                            "Image",
                            imgData
                        ], transfers);
                        return this.handler.send("obj", [
                            objId,
                            this.pageIndex,
                            "Image",
                            imgData
                        ], transfers);
                    }
                    async buildPaintImageXObject({ resources: resources, image: image, isInline: isInline = false, operatorList: operatorList, cacheKey: cacheKey, localImageCache: localImageCache, localColorSpaceCache: localColorSpaceCache }) {
                        const dict = image.dict;
                        const imageRef = dict.objId;
                        const w = dict.get("W", "Width");
                        const h = dict.get("H", "Height");
                        if (!(w && typeof w === "number") || !(h && typeof h === "number")) {
                            (0, _util.warn)("Image dimensions are missing, or not numbers.");
                            return;
                        }
                        const maxImageSize = this.options.maxImageSize;
                        if (maxImageSize !== -1 && w * h > maxImageSize) {
                            const msg = "Image exceeded maximum allowed size and was removed.";
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(msg);
                                return;
                            }
                            throw new Error(msg);
                        }
                        let optionalContent;
                        if (dict.has("OC")) optionalContent = await this.parseMarkedContentProps(dict.get("OC"), resources);
                        const imageMask = dict.get("IM", "ImageMask") || false;
                        let imgData, args;
                        if (imageMask) {
                            const interpolate = dict.get("I", "Interpolate");
                            const bitStrideLength = w + 7 >> 3;
                            const imgArray = image.getBytes(bitStrideLength * h);
                            const decode = dict.getArray("D", "Decode");
                            if (this.parsingType3Font) {
                                imgData = _image.PDFImage.createRawMask({
                                    imgArray: imgArray,
                                    width: w,
                                    height: h,
                                    imageIsFromDecodeStream: image instanceof _decode_stream.DecodeStream,
                                    inverseDecode: decode?.[0] > 0,
                                    interpolate: interpolate
                                });
                                imgData.cached = !!cacheKey;
                                args = [
                                    imgData
                                ];
                                operatorList.addImageOps(_util.OPS.paintImageMaskXObject, args, optionalContent);
                                if (cacheKey) {
                                    const cacheData = {
                                        fn: _util.OPS.paintImageMaskXObject,
                                        args: args,
                                        optionalContent: optionalContent
                                    };
                                    localImageCache.set(cacheKey, imageRef, cacheData);
                                    if (imageRef) this._regionalImageCache.set(null, imageRef, cacheData);
                                }
                                return;
                            }
                            imgData = await _image.PDFImage.createMask({
                                imgArray: imgArray,
                                width: w,
                                height: h,
                                imageIsFromDecodeStream: image instanceof _decode_stream.DecodeStream,
                                inverseDecode: decode?.[0] > 0,
                                interpolate: interpolate,
                                isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported
                            });
                            if (imgData.isSingleOpaquePixel) {
                                operatorList.addImageOps(_util.OPS.paintSolidColorImageMask, [], optionalContent);
                                if (cacheKey) {
                                    const cacheData = {
                                        fn: _util.OPS.paintSolidColorImageMask,
                                        args: [],
                                        optionalContent: optionalContent
                                    };
                                    localImageCache.set(cacheKey, imageRef, cacheData);
                                    if (imageRef) this._regionalImageCache.set(null, imageRef, cacheData);
                                }
                                return;
                            }
                            const objId = `mask_${this.idFactory.createObjId()}`;
                            operatorList.addDependency(objId);
                            this._sendImgData(objId, imgData);
                            args = [
                                {
                                    data: objId,
                                    width: imgData.width,
                                    height: imgData.height,
                                    interpolate: imgData.interpolate,
                                    count: 1
                                }
                            ];
                            operatorList.addImageOps(_util.OPS.paintImageMaskXObject, args, optionalContent);
                            if (cacheKey) {
                                const cacheData = {
                                    fn: _util.OPS.paintImageMaskXObject,
                                    args: args,
                                    optionalContent: optionalContent
                                };
                                localImageCache.set(cacheKey, imageRef, cacheData);
                                if (imageRef) this._regionalImageCache.set(null, imageRef, cacheData);
                            }
                            return;
                        }
                        const SMALL_IMAGE_DIMENSIONS = 200;
                        if (isInline && !dict.has("SMask") && !dict.has("Mask") && w + h < SMALL_IMAGE_DIMENSIONS) {
                            const imageObj = new _image.PDFImage({
                                xref: this.xref,
                                res: resources,
                                image: image,
                                isInline: isInline,
                                pdfFunctionFactory: this._pdfFunctionFactory,
                                localColorSpaceCache: localColorSpaceCache
                            });
                            imgData = await imageObj.createImageData(true, false);
                            operatorList.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported;
                            operatorList.addImageOps(_util.OPS.paintInlineImageXObject, [
                                imgData
                            ], optionalContent);
                            return;
                        }
                        let objId = `img_${this.idFactory.createObjId()}`, cacheGlobally = false;
                        if (this.parsingType3Font) objId = `${this.idFactory.getDocId()}_type3_${objId}`;
                        else if (imageRef) {
                            cacheGlobally = this.globalImageCache.shouldCache(imageRef, this.pageIndex);
                            if (cacheGlobally) objId = `${this.idFactory.getDocId()}_${objId}`;
                        }
                        operatorList.addDependency(objId);
                        args = [
                            objId,
                            w,
                            h
                        ];
                        _image.PDFImage.buildImage({
                            xref: this.xref,
                            res: resources,
                            image: image,
                            isInline: isInline,
                            pdfFunctionFactory: this._pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        }).then(async (imageObj)=>{
                            imgData = await imageObj.createImageData(false, this.options.isOffscreenCanvasSupported);
                            if (cacheKey && imageRef && cacheGlobally) {
                                const length = imgData.bitmap ? imgData.width * imgData.height * 4 : imgData.data.length;
                                this.globalImageCache.addByteSize(imageRef, length);
                            }
                            return this._sendImgData(objId, imgData, cacheGlobally);
                        }).catch((reason)=>{
                            (0, _util.warn)(`Unable to decode image "${objId}": "${reason}".`);
                            return this._sendImgData(objId, null, cacheGlobally);
                        });
                        operatorList.addImageOps(_util.OPS.paintImageXObject, args, optionalContent);
                        if (cacheKey) {
                            const cacheData = {
                                fn: _util.OPS.paintImageXObject,
                                args: args,
                                optionalContent: optionalContent
                            };
                            localImageCache.set(cacheKey, imageRef, cacheData);
                            if (imageRef) {
                                this._regionalImageCache.set(null, imageRef, cacheData);
                                if (cacheGlobally) {
                                    (0, _util.assert)(!isInline, "Cannot cache an inline image globally.");
                                    this.globalImageCache.setData(imageRef, {
                                        objId: objId,
                                        fn: _util.OPS.paintImageXObject,
                                        args: args,
                                        optionalContent: optionalContent,
                                        byteSize: 0
                                    });
                                }
                            }
                        }
                    }
                    handleSMask(smask, resources, operatorList, task, stateManager, localColorSpaceCache) {
                        const smaskContent = smask.get("G");
                        const smaskOptions = {
                            subtype: smask.get("S").name,
                            backdrop: smask.get("BC")
                        };
                        const transferObj = smask.get("TR");
                        if ((0, _function.isPDFFunction)(transferObj)) {
                            const transferFn = this._pdfFunctionFactory.create(transferObj);
                            const transferMap = new Uint8Array(256);
                            const tmp = new Float32Array(1);
                            for(let i = 0; i < 256; i++){
                                tmp[0] = i / 255;
                                transferFn(tmp, 0, tmp, 0);
                                transferMap[i] = tmp[0] * 255 | 0;
                            }
                            smaskOptions.transferMap = transferMap;
                        }
                        return this.buildFormXObject(resources, smaskContent, smaskOptions, operatorList, task, stateManager.state.clone(), localColorSpaceCache);
                    }
                    handleTransferFunction(tr) {
                        let transferArray;
                        if (Array.isArray(tr)) transferArray = tr;
                        else if ((0, _function.isPDFFunction)(tr)) transferArray = [
                            tr
                        ];
                        else return null;
                        const transferMaps = [];
                        let numFns = 0, numEffectfulFns = 0;
                        for (const entry of transferArray){
                            const transferObj = this.xref.fetchIfRef(entry);
                            numFns++;
                            if ((0, _primitives.isName)(transferObj, "Identity")) {
                                transferMaps.push(null);
                                continue;
                            } else if (!(0, _function.isPDFFunction)(transferObj)) return null;
                            const transferFn = this._pdfFunctionFactory.create(transferObj);
                            const transferMap = new Uint8Array(256), tmp = new Float32Array(1);
                            for(let j = 0; j < 256; j++){
                                tmp[0] = j / 255;
                                transferFn(tmp, 0, tmp, 0);
                                transferMap[j] = tmp[0] * 255 | 0;
                            }
                            transferMaps.push(transferMap);
                            numEffectfulFns++;
                        }
                        if (!(numFns === 1 || numFns === 4)) return null;
                        if (numEffectfulFns === 0) return null;
                        return transferMaps;
                    }
                    handleTilingType(fn, color, resources, pattern, patternDict, operatorList, task, localTilingPatternCache) {
                        const tilingOpList = new _operator_list.OperatorList();
                        const patternResources = _primitives.Dict.merge({
                            xref: this.xref,
                            dictArray: [
                                patternDict.get("Resources"),
                                resources
                            ]
                        });
                        return this.getOperatorList({
                            stream: pattern,
                            task: task,
                            resources: patternResources,
                            operatorList: tilingOpList
                        }).then(function() {
                            const operatorListIR = tilingOpList.getIR();
                            const tilingPatternIR = (0, _pattern.getTilingPatternIR)(operatorListIR, patternDict, color);
                            operatorList.addDependencies(tilingOpList.dependencies);
                            operatorList.addOp(fn, tilingPatternIR);
                            if (patternDict.objId) localTilingPatternCache.set(null, patternDict.objId, {
                                operatorListIR: operatorListIR,
                                dict: patternDict
                            });
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`handleTilingType - ignoring pattern: "${reason}".`);
                                return;
                            }
                            throw reason;
                        });
                    }
                    handleSetFont(resources, fontArgs, fontRef, operatorList, task, state, fallbackFontDict = null, cssFontInfo = null) {
                        const fontName = fontArgs?.[0] instanceof _primitives.Name ? fontArgs[0].name : null;
                        return this.loadFont(fontName, fontRef, resources, fallbackFontDict, cssFontInfo).then((translated)=>{
                            if (!translated.font.isType3Font) return translated;
                            return translated.loadType3Data(this, resources, task).then(function() {
                                operatorList.addDependencies(translated.type3Dependencies);
                                return translated;
                            }).catch((reason)=>{
                                return new TranslatedFont({
                                    loadedName: "g_font_error",
                                    font: new _fonts.ErrorFont(`Type3 font load error: ${reason}`),
                                    dict: translated.font,
                                    evaluatorOptions: this.options
                                });
                            });
                        }).then((translated)=>{
                            state.font = translated.font;
                            translated.send(this.handler);
                            return translated.loadedName;
                        });
                    }
                    handleText(chars, state) {
                        const font1 = state.font;
                        const glyphs = font1.charsToGlyphs(chars);
                        if (font1.data) {
                            const isAddToPathSet = !!(state.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                            if (isAddToPathSet || state.fillColorSpace.name === "Pattern" || font1.disableFontFace || this.options.disableFontFace) PartialEvaluator.buildFontPaths(font1, glyphs, this.handler, this.options);
                        }
                        return glyphs;
                    }
                    ensureStateFont(state) {
                        if (state.font) return;
                        const reason = new _util.FormatError("Missing setFont (Tf) operator before text rendering operator.");
                        if (this.options.ignoreErrors) {
                            (0, _util.warn)(`ensureStateFont: "${reason}".`);
                            return;
                        }
                        throw reason;
                    }
                    async setGState({ resources: resources, gState: gState, operatorList: operatorList, cacheKey: cacheKey, task: task, stateManager: stateManager, localGStateCache: localGStateCache, localColorSpaceCache: localColorSpaceCache }) {
                        const gStateRef = gState.objId;
                        let isSimpleGState = true;
                        const gStateObj = [];
                        let promise = Promise.resolve();
                        for (const key of gState.getKeys()){
                            const value = gState.get(key);
                            switch(key){
                                case "Type":
                                    break;
                                case "LW":
                                case "LC":
                                case "LJ":
                                case "ML":
                                case "D":
                                case "RI":
                                case "FL":
                                case "CA":
                                case "ca":
                                    gStateObj.push([
                                        key,
                                        value
                                    ]);
                                    break;
                                case "Font":
                                    isSimpleGState = false;
                                    promise = promise.then(()=>{
                                        return this.handleSetFont(resources, null, value[0], operatorList, task, stateManager.state).then(function(loadedName) {
                                            operatorList.addDependency(loadedName);
                                            gStateObj.push([
                                                key,
                                                [
                                                    loadedName,
                                                    value[1]
                                                ]
                                            ]);
                                        });
                                    });
                                    break;
                                case "BM":
                                    gStateObj.push([
                                        key,
                                        normalizeBlendMode(value)
                                    ]);
                                    break;
                                case "SMask":
                                    if ((0, _primitives.isName)(value, "None")) {
                                        gStateObj.push([
                                            key,
                                            false
                                        ]);
                                        break;
                                    }
                                    if (value instanceof _primitives.Dict) {
                                        isSimpleGState = false;
                                        promise = promise.then(()=>{
                                            return this.handleSMask(value, resources, operatorList, task, stateManager, localColorSpaceCache);
                                        });
                                        gStateObj.push([
                                            key,
                                            true
                                        ]);
                                    } else (0, _util.warn)("Unsupported SMask type");
                                    break;
                                case "TR":
                                    const transferMaps = this.handleTransferFunction(value);
                                    gStateObj.push([
                                        key,
                                        transferMaps
                                    ]);
                                    break;
                                case "OP":
                                case "op":
                                case "OPM":
                                case "BG":
                                case "BG2":
                                case "UCR":
                                case "UCR2":
                                case "TR2":
                                case "HT":
                                case "SM":
                                case "SA":
                                case "AIS":
                                case "TK":
                                    (0, _util.info)("graphic state operator " + key);
                                    break;
                                default:
                                    (0, _util.info)("Unknown graphic state operator " + key);
                                    break;
                            }
                        }
                        return promise.then(function() {
                            if (gStateObj.length > 0) operatorList.addOp(_util.OPS.setGState, [
                                gStateObj
                            ]);
                            if (isSimpleGState) localGStateCache.set(cacheKey, gStateRef, gStateObj);
                        });
                    }
                    loadFont(fontName, font1, resources, fallbackFontDict = null, cssFontInfo = null) {
                        const errorFont = async ()=>{
                            return new TranslatedFont({
                                loadedName: "g_font_error",
                                font: new _fonts.ErrorFont(`Font "${fontName}" is not available.`),
                                dict: font1,
                                evaluatorOptions: this.options
                            });
                        };
                        let fontRef;
                        if (font1) {
                            if (font1 instanceof _primitives.Ref) fontRef = font1;
                        } else {
                            const fontRes = resources.get("Font");
                            if (fontRes) fontRef = fontRes.getRaw(fontName);
                        }
                        if (fontRef) {
                            if (this.parsingType3Font && this.type3FontRefs.has(fontRef)) return errorFont();
                            if (this.fontCache.has(fontRef)) return this.fontCache.get(fontRef);
                            font1 = this.xref.fetchIfRef(fontRef);
                        }
                        if (!(font1 instanceof _primitives.Dict)) {
                            if (!this.options.ignoreErrors && !this.parsingType3Font) {
                                (0, _util.warn)(`Font "${fontName}" is not available.`);
                                return errorFont();
                            }
                            (0, _util.warn)(`Font "${fontName}" is not available -- attempting to fallback to a default font.`);
                            font1 = fallbackFontDict || PartialEvaluator.fallbackFontDict;
                        }
                        if (font1.cacheKey && this.fontCache.has(font1.cacheKey)) return this.fontCache.get(font1.cacheKey);
                        const fontCapability = new _util.PromiseCapability();
                        let preEvaluatedFont;
                        try {
                            preEvaluatedFont = this.preEvaluateFont(font1);
                            preEvaluatedFont.cssFontInfo = cssFontInfo;
                        } catch (reason) {
                            (0, _util.warn)(`loadFont - preEvaluateFont failed: "${reason}".`);
                            return errorFont();
                        }
                        const { descriptor: descriptor, hash: hash } = preEvaluatedFont;
                        const fontRefIsRef = fontRef instanceof _primitives.Ref;
                        let fontID;
                        if (hash && descriptor instanceof _primitives.Dict) {
                            const fontAliases = descriptor.fontAliases ||= Object.create(null);
                            if (fontAliases[hash]) {
                                const aliasFontRef = fontAliases[hash].aliasRef;
                                if (fontRefIsRef && aliasFontRef && this.fontCache.has(aliasFontRef)) {
                                    this.fontCache.putAlias(fontRef, aliasFontRef);
                                    return this.fontCache.get(fontRef);
                                }
                            } else fontAliases[hash] = {
                                fontID: this.idFactory.createFontId()
                            };
                            if (fontRefIsRef) fontAliases[hash].aliasRef = fontRef;
                            fontID = fontAliases[hash].fontID;
                        } else fontID = this.idFactory.createFontId();
                        (0, _util.assert)(fontID?.startsWith("f"), 'The "fontID" must be (correctly) defined.');
                        if (fontRefIsRef) this.fontCache.put(fontRef, fontCapability.promise);
                        else {
                            font1.cacheKey = `cacheKey_${fontID}`;
                            this.fontCache.put(font1.cacheKey, fontCapability.promise);
                        }
                        font1.loadedName = `${this.idFactory.getDocId()}_${fontID}`;
                        this.translateFont(preEvaluatedFont).then((translatedFont)=>{
                            fontCapability.resolve(new TranslatedFont({
                                loadedName: font1.loadedName,
                                font: translatedFont,
                                dict: font1,
                                evaluatorOptions: this.options
                            }));
                        }).catch((reason)=>{
                            (0, _util.warn)(`loadFont - translateFont failed: "${reason}".`);
                            fontCapability.resolve(new TranslatedFont({
                                loadedName: font1.loadedName,
                                font: new _fonts.ErrorFont(reason instanceof Error ? reason.message : reason),
                                dict: font1,
                                evaluatorOptions: this.options
                            }));
                        });
                        return fontCapability.promise;
                    }
                    buildPath(operatorList, fn, args, parsingText = false) {
                        const lastIndex = operatorList.length - 1;
                        if (!args) args = [];
                        if (lastIndex < 0 || operatorList.fnArray[lastIndex] !== _util.OPS.constructPath) {
                            if (parsingText) {
                                (0, _util.warn)(`Encountered path operator "${fn}" inside of a text object.`);
                                operatorList.addOp(_util.OPS.save, null);
                            }
                            let minMax;
                            switch(fn){
                                case _util.OPS.rectangle:
                                    const x = args[0] + args[2];
                                    const y = args[1] + args[3];
                                    minMax = [
                                        Math.min(args[0], x),
                                        Math.max(args[0], x),
                                        Math.min(args[1], y),
                                        Math.max(args[1], y)
                                    ];
                                    break;
                                case _util.OPS.moveTo:
                                case _util.OPS.lineTo:
                                    minMax = [
                                        args[0],
                                        args[0],
                                        args[1],
                                        args[1]
                                    ];
                                    break;
                                default:
                                    minMax = [
                                        Infinity,
                                        -Infinity,
                                        Infinity,
                                        -Infinity
                                    ];
                                    break;
                            }
                            operatorList.addOp(_util.OPS.constructPath, [
                                [
                                    fn
                                ],
                                args,
                                minMax
                            ]);
                            if (parsingText) operatorList.addOp(_util.OPS.restore, null);
                        } else {
                            const opArgs = operatorList.argsArray[lastIndex];
                            opArgs[0].push(fn);
                            opArgs[1].push(...args);
                            const minMax = opArgs[2];
                            switch(fn){
                                case _util.OPS.rectangle:
                                    const x = args[0] + args[2];
                                    const y = args[1] + args[3];
                                    minMax[0] = Math.min(minMax[0], args[0], x);
                                    minMax[1] = Math.max(minMax[1], args[0], x);
                                    minMax[2] = Math.min(minMax[2], args[1], y);
                                    minMax[3] = Math.max(minMax[3], args[1], y);
                                    break;
                                case _util.OPS.moveTo:
                                case _util.OPS.lineTo:
                                    minMax[0] = Math.min(minMax[0], args[0]);
                                    minMax[1] = Math.max(minMax[1], args[0]);
                                    minMax[2] = Math.min(minMax[2], args[1]);
                                    minMax[3] = Math.max(minMax[3], args[1]);
                                    break;
                            }
                        }
                    }
                    parseColorSpace({ cs: cs, resources: resources, localColorSpaceCache: localColorSpaceCache }) {
                        return _colorspace.ColorSpace.parseAsync({
                            cs: cs,
                            xref: this.xref,
                            resources: resources,
                            pdfFunctionFactory: this._pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return null;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`parseColorSpace - ignoring ColorSpace: "${reason}".`);
                                return null;
                            }
                            throw reason;
                        });
                    }
                    parseShading({ shading: shading, resources: resources, localColorSpaceCache: localColorSpaceCache, localShadingPatternCache: localShadingPatternCache }) {
                        let id = localShadingPatternCache.get(shading);
                        if (!id) {
                            var shadingFill = _pattern.Pattern.parseShading(shading, this.xref, resources, this._pdfFunctionFactory, localColorSpaceCache);
                            const patternIR = shadingFill.getIR();
                            id = `pattern_${this.idFactory.createObjId()}`;
                            if (this.parsingType3Font) id = `${this.idFactory.getDocId()}_type3_${id}`;
                            localShadingPatternCache.set(shading, id);
                            if (this.parsingType3Font) this.handler.send("commonobj", [
                                id,
                                "Pattern",
                                patternIR
                            ]);
                            else this.handler.send("obj", [
                                id,
                                this.pageIndex,
                                "Pattern",
                                patternIR
                            ]);
                        }
                        return id;
                    }
                    handleColorN(operatorList, fn, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache) {
                        const patternName = args.pop();
                        if (patternName instanceof _primitives.Name) {
                            const rawPattern = patterns.getRaw(patternName.name);
                            const localTilingPattern = rawPattern instanceof _primitives.Ref && localTilingPatternCache.getByRef(rawPattern);
                            if (localTilingPattern) try {
                                const color = cs.base ? cs.base.getRgb(args, 0) : null;
                                const tilingPatternIR = (0, _pattern.getTilingPatternIR)(localTilingPattern.operatorListIR, localTilingPattern.dict, color);
                                operatorList.addOp(fn, tilingPatternIR);
                                return undefined;
                            } catch  {}
                            const pattern = this.xref.fetchIfRef(rawPattern);
                            if (pattern) {
                                const dict = pattern instanceof _base_stream.BaseStream ? pattern.dict : pattern;
                                const typeNum = dict.get("PatternType");
                                if (typeNum === PatternType.TILING) {
                                    const color = cs.base ? cs.base.getRgb(args, 0) : null;
                                    return this.handleTilingType(fn, color, resources, pattern, dict, operatorList, task, localTilingPatternCache);
                                } else if (typeNum === PatternType.SHADING) {
                                    const shading = dict.get("Shading");
                                    const matrix = dict.getArray("Matrix");
                                    const objId = this.parseShading({
                                        shading: shading,
                                        resources: resources,
                                        localColorSpaceCache: localColorSpaceCache,
                                        localShadingPatternCache: localShadingPatternCache
                                    });
                                    operatorList.addOp(fn, [
                                        "Shading",
                                        objId,
                                        matrix
                                    ]);
                                    return undefined;
                                }
                                throw new _util.FormatError(`Unknown PatternType: ${typeNum}`);
                            }
                        }
                        throw new _util.FormatError(`Unknown PatternName: ${patternName}`);
                    }
                    _parseVisibilityExpression(array, nestingCounter, currentResult) {
                        const MAX_NESTING = 10;
                        if (++nestingCounter > MAX_NESTING) {
                            (0, _util.warn)("Visibility expression is too deeply nested");
                            return;
                        }
                        const length = array.length;
                        const operator = this.xref.fetchIfRef(array[0]);
                        if (length < 2 || !(operator instanceof _primitives.Name)) {
                            (0, _util.warn)("Invalid visibility expression");
                            return;
                        }
                        switch(operator.name){
                            case "And":
                            case "Or":
                            case "Not":
                                currentResult.push(operator.name);
                                break;
                            default:
                                (0, _util.warn)(`Invalid operator ${operator.name} in visibility expression`);
                                return;
                        }
                        for(let i = 1; i < length; i++){
                            const raw = array[i];
                            const object = this.xref.fetchIfRef(raw);
                            if (Array.isArray(object)) {
                                const nestedResult = [];
                                currentResult.push(nestedResult);
                                this._parseVisibilityExpression(object, nestingCounter, nestedResult);
                            } else if (raw instanceof _primitives.Ref) currentResult.push(raw.toString());
                        }
                    }
                    async parseMarkedContentProps(contentProperties, resources) {
                        let optionalContent;
                        if (contentProperties instanceof _primitives.Name) {
                            const properties = resources.get("Properties");
                            optionalContent = properties.get(contentProperties.name);
                        } else if (contentProperties instanceof _primitives.Dict) optionalContent = contentProperties;
                        else throw new _util.FormatError("Optional content properties malformed.");
                        const optionalContentType = optionalContent.get("Type")?.name;
                        if (optionalContentType === "OCG") return {
                            type: optionalContentType,
                            id: optionalContent.objId
                        };
                        else if (optionalContentType === "OCMD") {
                            const expression = optionalContent.get("VE");
                            if (Array.isArray(expression)) {
                                const result = [];
                                this._parseVisibilityExpression(expression, 0, result);
                                if (result.length > 0) return {
                                    type: "OCMD",
                                    expression: result
                                };
                            }
                            const optionalContentGroups = optionalContent.get("OCGs");
                            if (Array.isArray(optionalContentGroups) || optionalContentGroups instanceof _primitives.Dict) {
                                const groupIds = [];
                                if (Array.isArray(optionalContentGroups)) for (const ocg of optionalContentGroups)groupIds.push(ocg.toString());
                                else groupIds.push(optionalContentGroups.objId);
                                return {
                                    type: optionalContentType,
                                    ids: groupIds,
                                    policy: optionalContent.get("P") instanceof _primitives.Name ? optionalContent.get("P").name : null,
                                    expression: null
                                };
                            } else if (optionalContentGroups instanceof _primitives.Ref) return {
                                type: optionalContentType,
                                id: optionalContentGroups.toString()
                            };
                        }
                        return null;
                    }
                    getOperatorList({ stream: stream, task: task, resources: resources, operatorList: operatorList, initialState: initialState = null, fallbackFontDict: fallbackFontDict = null }) {
                        resources ||= _primitives.Dict.empty;
                        initialState ||= new EvalState();
                        if (!operatorList) throw new Error('getOperatorList: missing "operatorList" parameter');
                        const self1 = this;
                        const xref = this.xref;
                        let parsingText = false;
                        const localImageCache = new _image_utils.LocalImageCache();
                        const localColorSpaceCache = new _image_utils.LocalColorSpaceCache();
                        const localGStateCache = new _image_utils.LocalGStateCache();
                        const localTilingPatternCache = new _image_utils.LocalTilingPatternCache();
                        const localShadingPatternCache = new Map();
                        const xobjs = resources.get("XObject") || _primitives.Dict.empty;
                        const patterns = resources.get("Pattern") || _primitives.Dict.empty;
                        const stateManager = new StateManager(initialState);
                        const preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
                        const timeSlotManager = new TimeSlotManager();
                        function closePendingRestoreOPS(argument) {
                            for(let i = 0, ii = preprocessor.savedStatesDepth; i < ii; i++)operatorList.addOp(_util.OPS.restore, []);
                        }
                        return new Promise(function promiseBody(resolve, reject) {
                            const next = function(promise) {
                                Promise.all([
                                    promise,
                                    operatorList.ready
                                ]).then(function() {
                                    try {
                                        promiseBody(resolve, reject);
                                    } catch (ex) {
                                        reject(ex);
                                    }
                                }, reject);
                            };
                            task.ensureNotTerminated();
                            timeSlotManager.reset();
                            const operation = {};
                            let stop, i, ii, cs, name, isValidName;
                            while(!(stop = timeSlotManager.check())){
                                operation.args = null;
                                if (!preprocessor.read(operation)) break;
                                let args = operation.args;
                                let fn = operation.fn;
                                switch(fn | 0){
                                    case _util.OPS.paintXObject:
                                        isValidName = args[0] instanceof _primitives.Name;
                                        name = args[0].name;
                                        if (isValidName) {
                                            const localImage = localImageCache.getByName(name);
                                            if (localImage) {
                                                operatorList.addImageOps(localImage.fn, localImage.args, localImage.optionalContent);
                                                incrementCachedImageMaskCount(localImage);
                                                args = null;
                                                continue;
                                            }
                                        }
                                        next(new Promise(function(resolveXObject, rejectXObject) {
                                            if (!isValidName) throw new _util.FormatError("XObject must be referred to by name.");
                                            let xobj = xobjs.getRaw(name);
                                            if (xobj instanceof _primitives.Ref) {
                                                const localImage = localImageCache.getByRef(xobj) || self1._regionalImageCache.getByRef(xobj);
                                                if (localImage) {
                                                    operatorList.addImageOps(localImage.fn, localImage.args, localImage.optionalContent);
                                                    incrementCachedImageMaskCount(localImage);
                                                    resolveXObject();
                                                    return;
                                                }
                                                const globalImage = self1.globalImageCache.getData(xobj, self1.pageIndex);
                                                if (globalImage) {
                                                    operatorList.addDependency(globalImage.objId);
                                                    operatorList.addImageOps(globalImage.fn, globalImage.args, globalImage.optionalContent);
                                                    resolveXObject();
                                                    return;
                                                }
                                                xobj = xref.fetch(xobj);
                                            }
                                            if (!(xobj instanceof _base_stream.BaseStream)) throw new _util.FormatError("XObject should be a stream");
                                            const type = xobj.dict.get("Subtype");
                                            if (!(type instanceof _primitives.Name)) throw new _util.FormatError("XObject should have a Name subtype");
                                            if (type.name === "Form") {
                                                stateManager.save();
                                                self1.buildFormXObject(resources, xobj, null, operatorList, task, stateManager.state.clone(), localColorSpaceCache).then(function() {
                                                    stateManager.restore();
                                                    resolveXObject();
                                                }, rejectXObject);
                                                return;
                                            } else if (type.name === "Image") {
                                                self1.buildPaintImageXObject({
                                                    resources: resources,
                                                    image: xobj,
                                                    operatorList: operatorList,
                                                    cacheKey: name,
                                                    localImageCache: localImageCache,
                                                    localColorSpaceCache: localColorSpaceCache
                                                }).then(resolveXObject, rejectXObject);
                                                return;
                                            } else if (type.name === "PS") (0, _util.info)("Ignored XObject subtype PS");
                                            else throw new _util.FormatError(`Unhandled XObject subtype ${type.name}`);
                                            resolveXObject();
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getOperatorList - ignoring XObject: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.setFont:
                                        var fontSize = args[1];
                                        next(self1.handleSetFont(resources, args, null, operatorList, task, stateManager.state, fallbackFontDict).then(function(loadedName) {
                                            operatorList.addDependency(loadedName);
                                            operatorList.addOp(_util.OPS.setFont, [
                                                loadedName,
                                                fontSize
                                            ]);
                                        }));
                                        return;
                                    case _util.OPS.beginText:
                                        parsingText = true;
                                        break;
                                    case _util.OPS.endText:
                                        parsingText = false;
                                        break;
                                    case _util.OPS.endInlineImage:
                                        var cacheKey = args[0].cacheKey;
                                        if (cacheKey) {
                                            const localImage = localImageCache.getByName(cacheKey);
                                            if (localImage) {
                                                operatorList.addImageOps(localImage.fn, localImage.args, localImage.optionalContent);
                                                incrementCachedImageMaskCount(localImage);
                                                args = null;
                                                continue;
                                            }
                                        }
                                        next(self1.buildPaintImageXObject({
                                            resources: resources,
                                            image: args[0],
                                            isInline: true,
                                            operatorList: operatorList,
                                            cacheKey: cacheKey,
                                            localImageCache: localImageCache,
                                            localColorSpaceCache: localColorSpaceCache
                                        }));
                                        return;
                                    case _util.OPS.showText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        args[0] = self1.handleText(args[0], stateManager.state);
                                        break;
                                    case _util.OPS.showSpacedText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        var combinedGlyphs = [];
                                        var state = stateManager.state;
                                        for (const arrItem of args[0]){
                                            if (typeof arrItem === "string") combinedGlyphs.push(...self1.handleText(arrItem, state));
                                            else if (typeof arrItem === "number") combinedGlyphs.push(arrItem);
                                        }
                                        args[0] = combinedGlyphs;
                                        fn = _util.OPS.showText;
                                        break;
                                    case _util.OPS.nextLineShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        operatorList.addOp(_util.OPS.nextLine);
                                        args[0] = self1.handleText(args[0], stateManager.state);
                                        fn = _util.OPS.showText;
                                        break;
                                    case _util.OPS.nextLineSetSpacingShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        operatorList.addOp(_util.OPS.nextLine);
                                        operatorList.addOp(_util.OPS.setWordSpacing, [
                                            args.shift()
                                        ]);
                                        operatorList.addOp(_util.OPS.setCharSpacing, [
                                            args.shift()
                                        ]);
                                        args[0] = self1.handleText(args[0], stateManager.state);
                                        fn = _util.OPS.showText;
                                        break;
                                    case _util.OPS.setTextRenderingMode:
                                        stateManager.state.textRenderingMode = args[0];
                                        break;
                                    case _util.OPS.setFillColorSpace:
                                        {
                                            const cachedColorSpace = _colorspace.ColorSpace.getCached(args[0], xref, localColorSpaceCache);
                                            if (cachedColorSpace) {
                                                stateManager.state.fillColorSpace = cachedColorSpace;
                                                continue;
                                            }
                                            next(self1.parseColorSpace({
                                                cs: args[0],
                                                resources: resources,
                                                localColorSpaceCache: localColorSpaceCache
                                            }).then(function(colorSpace) {
                                                if (colorSpace) stateManager.state.fillColorSpace = colorSpace;
                                            }));
                                            return;
                                        }
                                    case _util.OPS.setStrokeColorSpace:
                                        {
                                            const cachedColorSpace = _colorspace.ColorSpace.getCached(args[0], xref, localColorSpaceCache);
                                            if (cachedColorSpace) {
                                                stateManager.state.strokeColorSpace = cachedColorSpace;
                                                continue;
                                            }
                                            next(self1.parseColorSpace({
                                                cs: args[0],
                                                resources: resources,
                                                localColorSpaceCache: localColorSpaceCache
                                            }).then(function(colorSpace) {
                                                if (colorSpace) stateManager.state.strokeColorSpace = colorSpace;
                                            }));
                                            return;
                                        }
                                    case _util.OPS.setFillColor:
                                        cs = stateManager.state.fillColorSpace;
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeColor:
                                        cs = stateManager.state.strokeColorSpace;
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.setFillGray:
                                        stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
                                        args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeGray:
                                        stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
                                        args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.setFillCMYKColor:
                                        stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                                        args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeCMYKColor:
                                        stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                                        args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.setFillRGBColor:
                                        stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.rgb;
                                        args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                                        break;
                                    case _util.OPS.setStrokeRGBColor:
                                        stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.rgb;
                                        args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                                        break;
                                    case _util.OPS.setFillColorN:
                                        cs = stateManager.state.fillColorSpace;
                                        if (cs.name === "Pattern") {
                                            next(self1.handleColorN(operatorList, _util.OPS.setFillColorN, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache));
                                            return;
                                        }
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeColorN:
                                        cs = stateManager.state.strokeColorSpace;
                                        if (cs.name === "Pattern") {
                                            next(self1.handleColorN(operatorList, _util.OPS.setStrokeColorN, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache));
                                            return;
                                        }
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.shadingFill:
                                        var shadingRes = resources.get("Shading");
                                        if (!shadingRes) throw new _util.FormatError("No shading resource found");
                                        var shading = shadingRes.get(args[0].name);
                                        if (!shading) throw new _util.FormatError("No shading object found");
                                        const patternId = self1.parseShading({
                                            shading: shading,
                                            resources: resources,
                                            localColorSpaceCache: localColorSpaceCache,
                                            localShadingPatternCache: localShadingPatternCache
                                        });
                                        args = [
                                            patternId
                                        ];
                                        fn = _util.OPS.shadingFill;
                                        break;
                                    case _util.OPS.setGState:
                                        isValidName = args[0] instanceof _primitives.Name;
                                        name = args[0].name;
                                        if (isValidName) {
                                            const localGStateObj = localGStateCache.getByName(name);
                                            if (localGStateObj) {
                                                if (localGStateObj.length > 0) operatorList.addOp(_util.OPS.setGState, [
                                                    localGStateObj
                                                ]);
                                                args = null;
                                                continue;
                                            }
                                        }
                                        next(new Promise(function(resolveGState, rejectGState) {
                                            if (!isValidName) throw new _util.FormatError("GState must be referred to by name.");
                                            const extGState = resources.get("ExtGState");
                                            if (!(extGState instanceof _primitives.Dict)) throw new _util.FormatError("ExtGState should be a dictionary.");
                                            const gState = extGState.get(name);
                                            if (!(gState instanceof _primitives.Dict)) throw new _util.FormatError("GState should be a dictionary.");
                                            self1.setGState({
                                                resources: resources,
                                                gState: gState,
                                                operatorList: operatorList,
                                                cacheKey: name,
                                                task: task,
                                                stateManager: stateManager,
                                                localGStateCache: localGStateCache,
                                                localColorSpaceCache: localColorSpaceCache
                                            }).then(resolveGState, rejectGState);
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getOperatorList - ignoring ExtGState: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.moveTo:
                                    case _util.OPS.lineTo:
                                    case _util.OPS.curveTo:
                                    case _util.OPS.curveTo2:
                                    case _util.OPS.curveTo3:
                                    case _util.OPS.closePath:
                                    case _util.OPS.rectangle:
                                        self1.buildPath(operatorList, fn, args, parsingText);
                                        continue;
                                    case _util.OPS.markPoint:
                                    case _util.OPS.markPointProps:
                                    case _util.OPS.beginCompat:
                                    case _util.OPS.endCompat:
                                        continue;
                                    case _util.OPS.beginMarkedContentProps:
                                        if (!(args[0] instanceof _primitives.Name)) {
                                            (0, _util.warn)(`Expected name for beginMarkedContentProps arg0=${args[0]}`);
                                            continue;
                                        }
                                        if (args[0].name === "OC") {
                                            next(self1.parseMarkedContentProps(args[1], resources).then((data)=>{
                                                operatorList.addOp(_util.OPS.beginMarkedContentProps, [
                                                    "OC",
                                                    data
                                                ]);
                                            }).catch((reason)=>{
                                                if (reason instanceof _util.AbortException) return;
                                                if (self1.options.ignoreErrors) {
                                                    (0, _util.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${reason}".`);
                                                    return;
                                                }
                                                throw reason;
                                            }));
                                            return;
                                        }
                                        args = [
                                            args[0].name,
                                            args[1] instanceof _primitives.Dict ? args[1].get("MCID") : null
                                        ];
                                        break;
                                    case _util.OPS.beginMarkedContent:
                                    case _util.OPS.endMarkedContent:
                                    default:
                                        if (args !== null) {
                                            for(i = 0, ii = args.length; i < ii; i++){
                                                if (args[i] instanceof _primitives.Dict) break;
                                            }
                                            if (i < ii) {
                                                (0, _util.warn)("getOperatorList - ignoring operator: " + fn);
                                                continue;
                                            }
                                        }
                                }
                                operatorList.addOp(fn, args);
                            }
                            if (stop) {
                                next(deferred);
                                return;
                            }
                            closePendingRestoreOPS();
                            resolve();
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`getOperatorList - ignoring errors during "${task.name}" ` + `task: "${reason}".`);
                                closePendingRestoreOPS();
                                return;
                            }
                            throw reason;
                        });
                    }
                    getTextContent({ stream: stream, task: task, resources: resources, stateManager: stateManager = null, includeMarkedContent: includeMarkedContent = false, sink: sink, seenStyles: seenStyles = new Set(), viewBox: viewBox, markedContentData: markedContentData = null, disableNormalization: disableNormalization = false }) {
                        resources ||= _primitives.Dict.empty;
                        stateManager ||= new StateManager(new TextState());
                        if (includeMarkedContent) markedContentData ||= {
                            level: 0
                        };
                        const textContent = {
                            items: [],
                            styles: Object.create(null)
                        };
                        const textContentItem = {
                            initialized: false,
                            str: [],
                            totalWidth: 0,
                            totalHeight: 0,
                            width: 0,
                            height: 0,
                            vertical: false,
                            prevTransform: null,
                            textAdvanceScale: 0,
                            spaceInFlowMin: 0,
                            spaceInFlowMax: 0,
                            trackingSpaceMin: Infinity,
                            negativeSpaceMax: -Infinity,
                            notASpace: -Infinity,
                            transform: null,
                            fontName: null,
                            hasEOL: false
                        };
                        const twoLastChars = [
                            " ",
                            " "
                        ];
                        let twoLastCharsPos = 0;
                        function saveLastChar(char) {
                            const nextPos = (twoLastCharsPos + 1) % 2;
                            const ret = twoLastChars[twoLastCharsPos] !== " " && twoLastChars[nextPos] === " ";
                            twoLastChars[twoLastCharsPos] = char;
                            twoLastCharsPos = nextPos;
                            return ret;
                        }
                        function shouldAddWhitepsace() {
                            return twoLastChars[twoLastCharsPos] !== " " && twoLastChars[(twoLastCharsPos + 1) % 2] === " ";
                        }
                        function resetLastChars() {
                            twoLastChars[0] = twoLastChars[1] = " ";
                            twoLastCharsPos = 0;
                        }
                        const TRACKING_SPACE_FACTOR = 0.102;
                        const NOT_A_SPACE_FACTOR = 0.03;
                        const NEGATIVE_SPACE_FACTOR = -0.2;
                        const SPACE_IN_FLOW_MIN_FACTOR = 0.102;
                        const SPACE_IN_FLOW_MAX_FACTOR = 0.6;
                        const VERTICAL_SHIFT_RATIO = 0.25;
                        const self1 = this;
                        const xref = this.xref;
                        const showSpacedTextBuffer = [];
                        let xobjs = null;
                        const emptyXObjectCache = new _image_utils.LocalImageCache();
                        const emptyGStateCache = new _image_utils.LocalGStateCache();
                        const preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
                        let textState;
                        function pushWhitespace({ width: width = 0, height: height = 0, transform: transform = textContentItem.prevTransform, fontName: fontName = textContentItem.fontName }) {
                            textContent.items.push({
                                str: " ",
                                dir: "ltr",
                                width: width,
                                height: height,
                                transform: transform,
                                fontName: fontName,
                                hasEOL: false
                            });
                        }
                        function getCurrentTextTransform() {
                            const font1 = textState.font;
                            const tsm = [
                                textState.fontSize * textState.textHScale,
                                0,
                                0,
                                textState.fontSize,
                                0,
                                textState.textRise
                            ];
                            if (font1.isType3Font && (textState.fontSize <= 1 || font1.isCharBBox) && !(0, _util.isArrayEqual)(textState.fontMatrix, _util.FONT_IDENTITY_MATRIX)) {
                                const glyphHeight = font1.bbox[3] - font1.bbox[1];
                                if (glyphHeight > 0) tsm[3] *= glyphHeight * textState.fontMatrix[3];
                            }
                            return _util.Util.transform(textState.ctm, _util.Util.transform(textState.textMatrix, tsm));
                        }
                        function ensureTextContentItem() {
                            if (textContentItem.initialized) return textContentItem;
                            const { font: font1, loadedName: loadedName } = textState;
                            if (!seenStyles.has(loadedName)) {
                                seenStyles.add(loadedName);
                                textContent.styles[loadedName] = {
                                    fontFamily: font1.fallbackName,
                                    ascent: font1.ascent,
                                    descent: font1.descent,
                                    vertical: font1.vertical
                                };
                            }
                            textContentItem.fontName = loadedName;
                            const trm = textContentItem.transform = getCurrentTextTransform();
                            if (!font1.vertical) {
                                textContentItem.width = textContentItem.totalWidth = 0;
                                textContentItem.height = textContentItem.totalHeight = Math.hypot(trm[2], trm[3]);
                                textContentItem.vertical = false;
                            } else {
                                textContentItem.width = textContentItem.totalWidth = Math.hypot(trm[0], trm[1]);
                                textContentItem.height = textContentItem.totalHeight = 0;
                                textContentItem.vertical = true;
                            }
                            const scaleLineX = Math.hypot(textState.textLineMatrix[0], textState.textLineMatrix[1]);
                            const scaleCtmX = Math.hypot(textState.ctm[0], textState.ctm[1]);
                            textContentItem.textAdvanceScale = scaleCtmX * scaleLineX;
                            const { fontSize: fontSize } = textState;
                            textContentItem.trackingSpaceMin = fontSize * TRACKING_SPACE_FACTOR;
                            textContentItem.notASpace = fontSize * NOT_A_SPACE_FACTOR;
                            textContentItem.negativeSpaceMax = fontSize * NEGATIVE_SPACE_FACTOR;
                            textContentItem.spaceInFlowMin = fontSize * SPACE_IN_FLOW_MIN_FACTOR;
                            textContentItem.spaceInFlowMax = fontSize * SPACE_IN_FLOW_MAX_FACTOR;
                            textContentItem.hasEOL = false;
                            textContentItem.initialized = true;
                            return textContentItem;
                        }
                        function updateAdvanceScale() {
                            if (!textContentItem.initialized) return;
                            const scaleLineX = Math.hypot(textState.textLineMatrix[0], textState.textLineMatrix[1]);
                            const scaleCtmX = Math.hypot(textState.ctm[0], textState.ctm[1]);
                            const scaleFactor = scaleCtmX * scaleLineX;
                            if (scaleFactor === textContentItem.textAdvanceScale) return;
                            if (!textContentItem.vertical) {
                                textContentItem.totalWidth += textContentItem.width * textContentItem.textAdvanceScale;
                                textContentItem.width = 0;
                            } else {
                                textContentItem.totalHeight += textContentItem.height * textContentItem.textAdvanceScale;
                                textContentItem.height = 0;
                            }
                            textContentItem.textAdvanceScale = scaleFactor;
                        }
                        function runBidiTransform(textChunk) {
                            let text = textChunk.str.join("");
                            if (!disableNormalization) text = (0, _util.normalizeUnicode)(text);
                            const bidiResult = (0, _bidi.bidi)(text, -1, textChunk.vertical);
                            return {
                                str: bidiResult.str,
                                dir: bidiResult.dir,
                                width: Math.abs(textChunk.totalWidth),
                                height: Math.abs(textChunk.totalHeight),
                                transform: textChunk.transform,
                                fontName: textChunk.fontName,
                                hasEOL: textChunk.hasEOL
                            };
                        }
                        function handleSetFont(fontName, fontRef) {
                            return self1.loadFont(fontName, fontRef, resources).then(function(translated) {
                                if (!translated.font.isType3Font) return translated;
                                return translated.loadType3Data(self1, resources, task).catch(function() {}).then(function() {
                                    return translated;
                                });
                            }).then(function(translated) {
                                textState.loadedName = translated.loadedName;
                                textState.font = translated.font;
                                textState.fontMatrix = translated.font.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                            });
                        }
                        function applyInverseRotation(x, y, matrix) {
                            const scale = Math.hypot(matrix[0], matrix[1]);
                            return [
                                (matrix[0] * x + matrix[1] * y) / scale,
                                (matrix[2] * x + matrix[3] * y) / scale
                            ];
                        }
                        function compareWithLastPosition(glyphWidth) {
                            const currentTransform = getCurrentTextTransform();
                            let posX = currentTransform[4];
                            let posY = currentTransform[5];
                            if (textState.font?.vertical) {
                                if (posX < viewBox[0] || posX > viewBox[2] || posY + glyphWidth < viewBox[1] || posY > viewBox[3]) return false;
                            } else if (posX + glyphWidth < viewBox[0] || posX > viewBox[2] || posY < viewBox[1] || posY > viewBox[3]) return false;
                            if (!textState.font || !textContentItem.prevTransform) return true;
                            let lastPosX = textContentItem.prevTransform[4];
                            let lastPosY = textContentItem.prevTransform[5];
                            if (lastPosX === posX && lastPosY === posY) return true;
                            let rotate = -1;
                            if (currentTransform[0] && currentTransform[1] === 0 && currentTransform[2] === 0) rotate = currentTransform[0] > 0 ? 0 : 180;
                            else if (currentTransform[1] && currentTransform[0] === 0 && currentTransform[3] === 0) rotate = currentTransform[1] > 0 ? 90 : 270;
                            switch(rotate){
                                case 0:
                                    break;
                                case 90:
                                    [posX, posY] = [
                                        posY,
                                        posX
                                    ];
                                    [lastPosX, lastPosY] = [
                                        lastPosY,
                                        lastPosX
                                    ];
                                    break;
                                case 180:
                                    [posX, posY, lastPosX, lastPosY] = [
                                        -posX,
                                        -posY,
                                        -lastPosX,
                                        -lastPosY
                                    ];
                                    break;
                                case 270:
                                    [posX, posY] = [
                                        -posY,
                                        -posX
                                    ];
                                    [lastPosX, lastPosY] = [
                                        -lastPosY,
                                        -lastPosX
                                    ];
                                    break;
                                default:
                                    [posX, posY] = applyInverseRotation(posX, posY, currentTransform);
                                    [lastPosX, lastPosY] = applyInverseRotation(lastPosX, lastPosY, textContentItem.prevTransform);
                            }
                            if (textState.font.vertical) {
                                const advanceY = (lastPosY - posY) / textContentItem.textAdvanceScale;
                                const advanceX = posX - lastPosX;
                                const textOrientation = Math.sign(textContentItem.height);
                                if (advanceY < textOrientation * textContentItem.negativeSpaceMax) {
                                    if (Math.abs(advanceX) > 0.5 * textContentItem.width) {
                                        appendEOL();
                                        return true;
                                    }
                                    resetLastChars();
                                    flushTextContentItem();
                                    return true;
                                }
                                if (Math.abs(advanceX) > textContentItem.width) {
                                    appendEOL();
                                    return true;
                                }
                                if (advanceY <= textOrientation * textContentItem.notASpace) resetLastChars();
                                if (advanceY <= textOrientation * textContentItem.trackingSpaceMin) {
                                    if (shouldAddWhitepsace()) {
                                        resetLastChars();
                                        flushTextContentItem();
                                        pushWhitespace({
                                            height: Math.abs(advanceY)
                                        });
                                    } else textContentItem.height += advanceY;
                                } else if (!addFakeSpaces(advanceY, textContentItem.prevTransform, textOrientation)) {
                                    if (textContentItem.str.length === 0) {
                                        resetLastChars();
                                        pushWhitespace({
                                            height: Math.abs(advanceY)
                                        });
                                    } else textContentItem.height += advanceY;
                                }
                                if (Math.abs(advanceX) > textContentItem.width * VERTICAL_SHIFT_RATIO) flushTextContentItem();
                                return true;
                            }
                            const advanceX = (posX - lastPosX) / textContentItem.textAdvanceScale;
                            const advanceY = posY - lastPosY;
                            const textOrientation = Math.sign(textContentItem.width);
                            if (advanceX < textOrientation * textContentItem.negativeSpaceMax) {
                                if (Math.abs(advanceY) > 0.5 * textContentItem.height) {
                                    appendEOL();
                                    return true;
                                }
                                resetLastChars();
                                flushTextContentItem();
                                return true;
                            }
                            if (Math.abs(advanceY) > textContentItem.height) {
                                appendEOL();
                                return true;
                            }
                            if (advanceX <= textOrientation * textContentItem.notASpace) resetLastChars();
                            if (advanceX <= textOrientation * textContentItem.trackingSpaceMin) {
                                if (shouldAddWhitepsace()) {
                                    resetLastChars();
                                    flushTextContentItem();
                                    pushWhitespace({
                                        width: Math.abs(advanceX)
                                    });
                                } else textContentItem.width += advanceX;
                            } else if (!addFakeSpaces(advanceX, textContentItem.prevTransform, textOrientation)) {
                                if (textContentItem.str.length === 0) {
                                    resetLastChars();
                                    pushWhitespace({
                                        width: Math.abs(advanceX)
                                    });
                                } else textContentItem.width += advanceX;
                            }
                            if (Math.abs(advanceY) > textContentItem.height * VERTICAL_SHIFT_RATIO) flushTextContentItem();
                            return true;
                        }
                        function buildTextContentItem({ chars: chars, extraSpacing: extraSpacing }) {
                            const font1 = textState.font;
                            if (!chars) {
                                const charSpacing = textState.charSpacing + extraSpacing;
                                if (charSpacing) {
                                    if (!font1.vertical) textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                                    else textState.translateTextMatrix(0, -charSpacing);
                                }
                                return;
                            }
                            const glyphs = font1.charsToGlyphs(chars);
                            const scale = textState.fontMatrix[0] * textState.fontSize;
                            for(let i = 0, ii = glyphs.length; i < ii; i++){
                                const glyph = glyphs[i];
                                const { category: category } = glyph;
                                if (category.isInvisibleFormatMark) continue;
                                let charSpacing = textState.charSpacing + (i + 1 === ii ? extraSpacing : 0);
                                let glyphWidth = glyph.width;
                                if (font1.vertical) glyphWidth = glyph.vmetric ? glyph.vmetric[0] : -glyphWidth;
                                let scaledDim = glyphWidth * scale;
                                if (category.isWhitespace) {
                                    if (!font1.vertical) {
                                        charSpacing += scaledDim + textState.wordSpacing;
                                        textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                                    } else {
                                        charSpacing += -scaledDim + textState.wordSpacing;
                                        textState.translateTextMatrix(0, -charSpacing);
                                    }
                                    saveLastChar(" ");
                                    continue;
                                }
                                if (!category.isZeroWidthDiacritic && !compareWithLastPosition(scaledDim)) {
                                    if (!font1.vertical) textState.translateTextMatrix(scaledDim * textState.textHScale, 0);
                                    else textState.translateTextMatrix(0, scaledDim);
                                    continue;
                                }
                                const textChunk = ensureTextContentItem();
                                if (category.isZeroWidthDiacritic) scaledDim = 0;
                                if (!font1.vertical) {
                                    scaledDim *= textState.textHScale;
                                    textState.translateTextMatrix(scaledDim, 0);
                                    textChunk.width += scaledDim;
                                } else {
                                    textState.translateTextMatrix(0, scaledDim);
                                    scaledDim = Math.abs(scaledDim);
                                    textChunk.height += scaledDim;
                                }
                                if (scaledDim) textChunk.prevTransform = getCurrentTextTransform();
                                const glyphUnicode = glyph.unicode;
                                if (saveLastChar(glyphUnicode)) textChunk.str.push(" ");
                                textChunk.str.push(glyphUnicode);
                                if (charSpacing) {
                                    if (!font1.vertical) textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                                    else textState.translateTextMatrix(0, -charSpacing);
                                }
                            }
                        }
                        function appendEOL() {
                            resetLastChars();
                            if (textContentItem.initialized) {
                                textContentItem.hasEOL = true;
                                flushTextContentItem();
                            } else textContent.items.push({
                                str: "",
                                dir: "ltr",
                                width: 0,
                                height: 0,
                                transform: getCurrentTextTransform(),
                                fontName: textState.loadedName,
                                hasEOL: true
                            });
                        }
                        function addFakeSpaces(width, transf, textOrientation) {
                            if (textOrientation * textContentItem.spaceInFlowMin <= width && width <= textOrientation * textContentItem.spaceInFlowMax) {
                                if (textContentItem.initialized) {
                                    resetLastChars();
                                    textContentItem.str.push(" ");
                                }
                                return false;
                            }
                            const fontName = textContentItem.fontName;
                            let height = 0;
                            if (textContentItem.vertical) {
                                height = width;
                                width = 0;
                            }
                            flushTextContentItem();
                            resetLastChars();
                            pushWhitespace({
                                width: Math.abs(width),
                                height: Math.abs(height),
                                transform: transf || getCurrentTextTransform(),
                                fontName: fontName
                            });
                            return true;
                        }
                        function flushTextContentItem() {
                            if (!textContentItem.initialized || !textContentItem.str) return;
                            if (!textContentItem.vertical) textContentItem.totalWidth += textContentItem.width * textContentItem.textAdvanceScale;
                            else textContentItem.totalHeight += textContentItem.height * textContentItem.textAdvanceScale;
                            textContent.items.push(runBidiTransform(textContentItem));
                            textContentItem.initialized = false;
                            textContentItem.str.length = 0;
                        }
                        function enqueueChunk(batch = false) {
                            const length = textContent.items.length;
                            if (length === 0) return;
                            if (batch && length < TEXT_CHUNK_BATCH_SIZE) return;
                            sink.enqueue(textContent, length);
                            textContent.items = [];
                            textContent.styles = Object.create(null);
                        }
                        const timeSlotManager = new TimeSlotManager();
                        return new Promise(function promiseBody(resolve, reject) {
                            const next = function(promise) {
                                enqueueChunk(true);
                                Promise.all([
                                    promise,
                                    sink.ready
                                ]).then(function() {
                                    try {
                                        promiseBody(resolve, reject);
                                    } catch (ex) {
                                        reject(ex);
                                    }
                                }, reject);
                            };
                            task.ensureNotTerminated();
                            timeSlotManager.reset();
                            const operation = {};
                            let stop, args = [];
                            while(!(stop = timeSlotManager.check())){
                                args.length = 0;
                                operation.args = args;
                                if (!preprocessor.read(operation)) break;
                                const previousState = textState;
                                textState = stateManager.state;
                                const fn = operation.fn;
                                args = operation.args;
                                switch(fn | 0){
                                    case _util.OPS.setFont:
                                        var fontNameArg = args[0].name, fontSizeArg = args[1];
                                        if (textState.font && fontNameArg === textState.fontName && fontSizeArg === textState.fontSize) break;
                                        flushTextContentItem();
                                        textState.fontName = fontNameArg;
                                        textState.fontSize = fontSizeArg;
                                        next(handleSetFont(fontNameArg, null));
                                        return;
                                    case _util.OPS.setTextRise:
                                        textState.textRise = args[0];
                                        break;
                                    case _util.OPS.setHScale:
                                        textState.textHScale = args[0] / 100;
                                        break;
                                    case _util.OPS.setLeading:
                                        textState.leading = args[0];
                                        break;
                                    case _util.OPS.moveText:
                                        textState.translateTextLineMatrix(args[0], args[1]);
                                        textState.textMatrix = textState.textLineMatrix.slice();
                                        break;
                                    case _util.OPS.setLeadingMoveText:
                                        textState.leading = -args[1];
                                        textState.translateTextLineMatrix(args[0], args[1]);
                                        textState.textMatrix = textState.textLineMatrix.slice();
                                        break;
                                    case _util.OPS.nextLine:
                                        textState.carriageReturn();
                                        break;
                                    case _util.OPS.setTextMatrix:
                                        textState.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                        textState.setTextLineMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                        updateAdvanceScale();
                                        break;
                                    case _util.OPS.setCharSpacing:
                                        textState.charSpacing = args[0];
                                        break;
                                    case _util.OPS.setWordSpacing:
                                        textState.wordSpacing = args[0];
                                        break;
                                    case _util.OPS.beginText:
                                        textState.textMatrix = _util.IDENTITY_MATRIX.slice();
                                        textState.textLineMatrix = _util.IDENTITY_MATRIX.slice();
                                        break;
                                    case _util.OPS.showSpacedText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        const spaceFactor = (textState.font.vertical ? 1 : -1) * textState.fontSize / 1000;
                                        const elements = args[0];
                                        for(let i = 0, ii = elements.length; i < ii; i++){
                                            const item = elements[i];
                                            if (typeof item === "string") showSpacedTextBuffer.push(item);
                                            else if (typeof item === "number" && item !== 0) {
                                                const str = showSpacedTextBuffer.join("");
                                                showSpacedTextBuffer.length = 0;
                                                buildTextContentItem({
                                                    chars: str,
                                                    extraSpacing: item * spaceFactor
                                                });
                                            }
                                        }
                                        if (showSpacedTextBuffer.length > 0) {
                                            const str = showSpacedTextBuffer.join("");
                                            showSpacedTextBuffer.length = 0;
                                            buildTextContentItem({
                                                chars: str,
                                                extraSpacing: 0
                                            });
                                        }
                                        break;
                                    case _util.OPS.showText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        buildTextContentItem({
                                            chars: args[0],
                                            extraSpacing: 0
                                        });
                                        break;
                                    case _util.OPS.nextLineShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        textState.carriageReturn();
                                        buildTextContentItem({
                                            chars: args[0],
                                            extraSpacing: 0
                                        });
                                        break;
                                    case _util.OPS.nextLineSetSpacingShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        textState.wordSpacing = args[0];
                                        textState.charSpacing = args[1];
                                        textState.carriageReturn();
                                        buildTextContentItem({
                                            chars: args[2],
                                            extraSpacing: 0
                                        });
                                        break;
                                    case _util.OPS.paintXObject:
                                        flushTextContentItem();
                                        if (!xobjs) xobjs = resources.get("XObject") || _primitives.Dict.empty;
                                        var isValidName = args[0] instanceof _primitives.Name;
                                        var name = args[0].name;
                                        if (isValidName && emptyXObjectCache.getByName(name)) break;
                                        next(new Promise(function(resolveXObject, rejectXObject) {
                                            if (!isValidName) throw new _util.FormatError("XObject must be referred to by name.");
                                            let xobj = xobjs.getRaw(name);
                                            if (xobj instanceof _primitives.Ref) {
                                                if (emptyXObjectCache.getByRef(xobj)) {
                                                    resolveXObject();
                                                    return;
                                                }
                                                const globalImage = self1.globalImageCache.getData(xobj, self1.pageIndex);
                                                if (globalImage) {
                                                    resolveXObject();
                                                    return;
                                                }
                                                xobj = xref.fetch(xobj);
                                            }
                                            if (!(xobj instanceof _base_stream.BaseStream)) throw new _util.FormatError("XObject should be a stream");
                                            const type = xobj.dict.get("Subtype");
                                            if (!(type instanceof _primitives.Name)) throw new _util.FormatError("XObject should have a Name subtype");
                                            if (type.name !== "Form") {
                                                emptyXObjectCache.set(name, xobj.dict.objId, true);
                                                resolveXObject();
                                                return;
                                            }
                                            const currentState = stateManager.state.clone();
                                            const xObjStateManager = new StateManager(currentState);
                                            const matrix = xobj.dict.getArray("Matrix");
                                            if (Array.isArray(matrix) && matrix.length === 6) xObjStateManager.transform(matrix);
                                            enqueueChunk();
                                            const sinkWrapper = {
                                                enqueueInvoked: false,
                                                enqueue (chunk, size) {
                                                    this.enqueueInvoked = true;
                                                    sink.enqueue(chunk, size);
                                                },
                                                get desiredSize () {
                                                    return sink.desiredSize;
                                                },
                                                get ready () {
                                                    return sink.ready;
                                                }
                                            };
                                            self1.getTextContent({
                                                stream: xobj,
                                                task: task,
                                                resources: xobj.dict.get("Resources") || resources,
                                                stateManager: xObjStateManager,
                                                includeMarkedContent: includeMarkedContent,
                                                sink: sinkWrapper,
                                                seenStyles: seenStyles,
                                                viewBox: viewBox,
                                                markedContentData: markedContentData,
                                                disableNormalization: disableNormalization
                                            }).then(function() {
                                                if (!sinkWrapper.enqueueInvoked) emptyXObjectCache.set(name, xobj.dict.objId, true);
                                                resolveXObject();
                                            }, rejectXObject);
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getTextContent - ignoring XObject: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.setGState:
                                        isValidName = args[0] instanceof _primitives.Name;
                                        name = args[0].name;
                                        if (isValidName && emptyGStateCache.getByName(name)) break;
                                        next(new Promise(function(resolveGState, rejectGState) {
                                            if (!isValidName) throw new _util.FormatError("GState must be referred to by name.");
                                            const extGState = resources.get("ExtGState");
                                            if (!(extGState instanceof _primitives.Dict)) throw new _util.FormatError("ExtGState should be a dictionary.");
                                            const gState = extGState.get(name);
                                            if (!(gState instanceof _primitives.Dict)) throw new _util.FormatError("GState should be a dictionary.");
                                            const gStateFont = gState.get("Font");
                                            if (!gStateFont) {
                                                emptyGStateCache.set(name, gState.objId, true);
                                                resolveGState();
                                                return;
                                            }
                                            flushTextContentItem();
                                            textState.fontName = null;
                                            textState.fontSize = gStateFont[1];
                                            handleSetFont(null, gStateFont[0]).then(resolveGState, rejectGState);
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getTextContent - ignoring ExtGState: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.beginMarkedContent:
                                        flushTextContentItem();
                                        if (includeMarkedContent) {
                                            markedContentData.level++;
                                            textContent.items.push({
                                                type: "beginMarkedContent",
                                                tag: args[0] instanceof _primitives.Name ? args[0].name : null
                                            });
                                        }
                                        break;
                                    case _util.OPS.beginMarkedContentProps:
                                        flushTextContentItem();
                                        if (includeMarkedContent) {
                                            markedContentData.level++;
                                            let mcid = null;
                                            if (args[1] instanceof _primitives.Dict) mcid = args[1].get("MCID");
                                            textContent.items.push({
                                                type: "beginMarkedContentProps",
                                                id: Number.isInteger(mcid) ? `${self1.idFactory.getPageObjId()}_mc${mcid}` : null,
                                                tag: args[0] instanceof _primitives.Name ? args[0].name : null
                                            });
                                        }
                                        break;
                                    case _util.OPS.endMarkedContent:
                                        flushTextContentItem();
                                        if (includeMarkedContent) {
                                            if (markedContentData.level === 0) break;
                                            markedContentData.level--;
                                            textContent.items.push({
                                                type: "endMarkedContent"
                                            });
                                        }
                                        break;
                                    case _util.OPS.restore:
                                        if (previousState && (previousState.font !== textState.font || previousState.fontSize !== textState.fontSize || previousState.fontName !== textState.fontName)) flushTextContentItem();
                                        break;
                                }
                                if (textContent.items.length >= sink.desiredSize) {
                                    stop = true;
                                    break;
                                }
                            }
                            if (stop) {
                                next(deferred);
                                return;
                            }
                            flushTextContentItem();
                            enqueueChunk();
                            resolve();
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`getTextContent - ignoring errors during "${task.name}" ` + `task: "${reason}".`);
                                flushTextContentItem();
                                enqueueChunk();
                                return;
                            }
                            throw reason;
                        });
                    }
                    extractDataStructures(dict, baseDict, properties) {
                        const xref = this.xref;
                        let cidToGidBytes;
                        const toUnicodePromise = this.readToUnicode(properties.toUnicode || dict.get("ToUnicode") || baseDict.get("ToUnicode"));
                        if (properties.composite) {
                            const cidSystemInfo = dict.get("CIDSystemInfo");
                            if (cidSystemInfo instanceof _primitives.Dict) properties.cidSystemInfo = {
                                registry: (0, _util.stringToPDFString)(cidSystemInfo.get("Registry")),
                                ordering: (0, _util.stringToPDFString)(cidSystemInfo.get("Ordering")),
                                supplement: cidSystemInfo.get("Supplement")
                            };
                            try {
                                const cidToGidMap = dict.get("CIDToGIDMap");
                                if (cidToGidMap instanceof _base_stream.BaseStream) cidToGidBytes = cidToGidMap.getBytes();
                            } catch (ex) {
                                if (!this.options.ignoreErrors) throw ex;
                                (0, _util.warn)(`extractDataStructures - ignoring CIDToGIDMap data: "${ex}".`);
                            }
                        }
                        const differences = [];
                        let baseEncodingName = null;
                        let encoding;
                        if (dict.has("Encoding")) {
                            encoding = dict.get("Encoding");
                            if (encoding instanceof _primitives.Dict) {
                                baseEncodingName = encoding.get("BaseEncoding");
                                baseEncodingName = baseEncodingName instanceof _primitives.Name ? baseEncodingName.name : null;
                                if (encoding.has("Differences")) {
                                    const diffEncoding = encoding.get("Differences");
                                    let index = 0;
                                    for (const entry of diffEncoding){
                                        const data = xref.fetchIfRef(entry);
                                        if (typeof data === "number") index = data;
                                        else if (data instanceof _primitives.Name) differences[index++] = data.name;
                                        else throw new _util.FormatError(`Invalid entry in 'Differences' array: ${data}`);
                                    }
                                }
                            } else if (encoding instanceof _primitives.Name) baseEncodingName = encoding.name;
                            else {
                                const msg = "Encoding is not a Name nor a Dict";
                                if (!this.options.ignoreErrors) throw new _util.FormatError(msg);
                                (0, _util.warn)(msg);
                            }
                            if (baseEncodingName !== "MacRomanEncoding" && baseEncodingName !== "MacExpertEncoding" && baseEncodingName !== "WinAnsiEncoding") baseEncodingName = null;
                        }
                        const nonEmbeddedFont = !properties.file || properties.isInternalFont, isSymbolsFontName = (0, _standard_fonts.getSymbolsFonts)()[properties.name];
                        if (baseEncodingName && nonEmbeddedFont && isSymbolsFontName) baseEncodingName = null;
                        if (baseEncodingName) properties.defaultEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                        else {
                            const isSymbolicFont = !!(properties.flags & _fonts_utils.FontFlags.Symbolic);
                            const isNonsymbolicFont = !!(properties.flags & _fonts_utils.FontFlags.Nonsymbolic);
                            encoding = _encodings.StandardEncoding;
                            if (properties.type === "TrueType" && !isNonsymbolicFont) encoding = _encodings.WinAnsiEncoding;
                            if (isSymbolicFont || isSymbolsFontName) {
                                encoding = _encodings.MacRomanEncoding;
                                if (nonEmbeddedFont) {
                                    if (/Symbol/i.test(properties.name)) encoding = _encodings.SymbolSetEncoding;
                                    else if (/Dingbats/i.test(properties.name)) encoding = _encodings.ZapfDingbatsEncoding;
                                    else if (/Wingdings/i.test(properties.name)) encoding = _encodings.WinAnsiEncoding;
                                }
                            }
                            properties.defaultEncoding = encoding;
                        }
                        properties.differences = differences;
                        properties.baseEncodingName = baseEncodingName;
                        properties.hasEncoding = !!baseEncodingName || differences.length > 0;
                        properties.dict = dict;
                        return toUnicodePromise.then((readToUnicode)=>{
                            properties.toUnicode = readToUnicode;
                            return this.buildToUnicode(properties);
                        }).then((builtToUnicode)=>{
                            properties.toUnicode = builtToUnicode;
                            if (cidToGidBytes) properties.cidToGidMap = this.readCidToGidMap(cidToGidBytes, builtToUnicode);
                            return properties;
                        });
                    }
                    _simpleFontToUnicode(properties, forceGlyphs = false) {
                        (0, _util.assert)(!properties.composite, "Must be a simple font.");
                        const toUnicode = [];
                        const encoding = properties.defaultEncoding.slice();
                        const baseEncodingName = properties.baseEncodingName;
                        const differences = properties.differences;
                        for(const charcode in differences){
                            const glyphName = differences[charcode];
                            if (glyphName === ".notdef") continue;
                            encoding[charcode] = glyphName;
                        }
                        const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                        for(const charcode in encoding){
                            let glyphName = encoding[charcode];
                            if (glyphName === "") continue;
                            let unicode = glyphsUnicodeMap[glyphName];
                            if (unicode !== undefined) {
                                toUnicode[charcode] = String.fromCharCode(unicode);
                                continue;
                            }
                            let code = 0;
                            switch(glyphName[0]){
                                case "G":
                                    if (glyphName.length === 3) code = parseInt(glyphName.substring(1), 16);
                                    break;
                                case "g":
                                    if (glyphName.length === 5) code = parseInt(glyphName.substring(1), 16);
                                    break;
                                case "C":
                                case "c":
                                    if (glyphName.length >= 3 && glyphName.length <= 4) {
                                        const codeStr = glyphName.substring(1);
                                        if (forceGlyphs) {
                                            code = parseInt(codeStr, 16);
                                            break;
                                        }
                                        code = +codeStr;
                                        if (Number.isNaN(code) && Number.isInteger(parseInt(codeStr, 16))) return this._simpleFontToUnicode(properties, true);
                                    }
                                    break;
                                case "u":
                                    unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                                    if (unicode !== -1) code = unicode;
                                    break;
                                default:
                                    switch(glyphName){
                                        case "f_h":
                                        case "f_t":
                                        case "T_h":
                                            toUnicode[charcode] = glyphName.replaceAll("_", "");
                                            continue;
                                    }
                                    break;
                            }
                            if (code > 0 && code <= 0x10ffff && Number.isInteger(code)) {
                                if (baseEncodingName && code === +charcode) {
                                    const baseEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                                    if (baseEncoding && (glyphName = baseEncoding[charcode])) {
                                        toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
                                        continue;
                                    }
                                }
                                toUnicode[charcode] = String.fromCodePoint(code);
                            }
                        }
                        return toUnicode;
                    }
                    async buildToUnicode(properties) {
                        properties.hasIncludedToUnicodeMap = properties.toUnicode?.length > 0;
                        if (properties.hasIncludedToUnicodeMap) {
                            if (!properties.composite && properties.hasEncoding) properties.fallbackToUnicode = this._simpleFontToUnicode(properties);
                            return properties.toUnicode;
                        }
                        if (!properties.composite) return new _to_unicode_map.ToUnicodeMap(this._simpleFontToUnicode(properties));
                        if (properties.composite && (properties.cMap.builtInCMap && !(properties.cMap instanceof _cmap.IdentityCMap) || properties.cidSystemInfo.registry === "Adobe" && (properties.cidSystemInfo.ordering === "GB1" || properties.cidSystemInfo.ordering === "CNS1" || properties.cidSystemInfo.ordering === "Japan1" || properties.cidSystemInfo.ordering === "Korea1"))) {
                            const { registry: registry, ordering: ordering } = properties.cidSystemInfo;
                            const ucs2CMapName = _primitives.Name.get(`${registry}-${ordering}-UCS2`);
                            const ucs2CMap = await _cmap.CMapFactory.create({
                                encoding: ucs2CMapName,
                                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                                useCMap: null
                            });
                            const toUnicode = [], buf = [];
                            properties.cMap.forEach(function(charcode, cid) {
                                if (cid > 0xffff) throw new _util.FormatError("Max size of CID is 65,535");
                                const ucs2 = ucs2CMap.lookup(cid);
                                if (ucs2) {
                                    buf.length = 0;
                                    for(let i = 0, ii = ucs2.length; i < ii; i += 2)buf.push((ucs2.charCodeAt(i) << 8) + ucs2.charCodeAt(i + 1));
                                    toUnicode[charcode] = String.fromCharCode(...buf);
                                }
                            });
                            return new _to_unicode_map.ToUnicodeMap(toUnicode);
                        }
                        return new _to_unicode_map.IdentityToUnicodeMap(properties.firstChar, properties.lastChar);
                    }
                    readToUnicode(cmapObj) {
                        if (!cmapObj) return Promise.resolve(null);
                        if (cmapObj instanceof _primitives.Name) return _cmap.CMapFactory.create({
                            encoding: cmapObj,
                            fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                            useCMap: null
                        }).then(function(cmap) {
                            if (cmap instanceof _cmap.IdentityCMap) return new _to_unicode_map.IdentityToUnicodeMap(0, 0xffff);
                            return new _to_unicode_map.ToUnicodeMap(cmap.getMap());
                        });
                        else if (cmapObj instanceof _base_stream.BaseStream) return _cmap.CMapFactory.create({
                            encoding: cmapObj,
                            fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                            useCMap: null
                        }).then(function(cmap) {
                            if (cmap instanceof _cmap.IdentityCMap) return new _to_unicode_map.IdentityToUnicodeMap(0, 0xffff);
                            const map = new Array(cmap.length);
                            cmap.forEach(function(charCode, token) {
                                if (typeof token === "number") {
                                    map[charCode] = String.fromCodePoint(token);
                                    return;
                                }
                                const str = [];
                                for(let k = 0; k < token.length; k += 2){
                                    const w1 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
                                    if ((w1 & 0xf800) !== 0xd800) {
                                        str.push(w1);
                                        continue;
                                    }
                                    k += 2;
                                    const w2 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
                                    str.push(((w1 & 0x3ff) << 10) + (w2 & 0x3ff) + 0x10000);
                                }
                                map[charCode] = String.fromCodePoint(...str);
                            });
                            return new _to_unicode_map.ToUnicodeMap(map);
                        }, (reason)=>{
                            if (reason instanceof _util.AbortException) return null;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`readToUnicode - ignoring ToUnicode data: "${reason}".`);
                                return null;
                            }
                            throw reason;
                        });
                        return Promise.resolve(null);
                    }
                    readCidToGidMap(glyphsData, toUnicode) {
                        const result = [];
                        for(let j = 0, jj = glyphsData.length; j < jj; j++){
                            const glyphID = glyphsData[j++] << 8 | glyphsData[j];
                            const code = j >> 1;
                            if (glyphID === 0 && !toUnicode.has(code)) continue;
                            result[code] = glyphID;
                        }
                        return result;
                    }
                    extractWidths(dict, descriptor, properties) {
                        const xref = this.xref;
                        let glyphsWidths = [];
                        let defaultWidth = 0;
                        const glyphsVMetrics = [];
                        let defaultVMetrics;
                        let i, ii, j, jj, start, code, widths;
                        if (properties.composite) {
                            defaultWidth = dict.has("DW") ? dict.get("DW") : 1000;
                            widths = dict.get("W");
                            if (widths) for(i = 0, ii = widths.length; i < ii; i++){
                                start = xref.fetchIfRef(widths[i++]);
                                code = xref.fetchIfRef(widths[i]);
                                if (Array.isArray(code)) for(j = 0, jj = code.length; j < jj; j++)glyphsWidths[start++] = xref.fetchIfRef(code[j]);
                                else {
                                    const width = xref.fetchIfRef(widths[++i]);
                                    for(j = start; j <= code; j++)glyphsWidths[j] = width;
                                }
                            }
                            if (properties.vertical) {
                                let vmetrics = dict.getArray("DW2") || [
                                    880,
                                    -1000
                                ];
                                defaultVMetrics = [
                                    vmetrics[1],
                                    defaultWidth * 0.5,
                                    vmetrics[0]
                                ];
                                vmetrics = dict.get("W2");
                                if (vmetrics) for(i = 0, ii = vmetrics.length; i < ii; i++){
                                    start = xref.fetchIfRef(vmetrics[i++]);
                                    code = xref.fetchIfRef(vmetrics[i]);
                                    if (Array.isArray(code)) for(j = 0, jj = code.length; j < jj; j++)glyphsVMetrics[start++] = [
                                        xref.fetchIfRef(code[j++]),
                                        xref.fetchIfRef(code[j++]),
                                        xref.fetchIfRef(code[j])
                                    ];
                                    else {
                                        const vmetric = [
                                            xref.fetchIfRef(vmetrics[++i]),
                                            xref.fetchIfRef(vmetrics[++i]),
                                            xref.fetchIfRef(vmetrics[++i])
                                        ];
                                        for(j = start; j <= code; j++)glyphsVMetrics[j] = vmetric;
                                    }
                                }
                            }
                        } else {
                            const firstChar = properties.firstChar;
                            widths = dict.get("Widths");
                            if (widths) {
                                j = firstChar;
                                for(i = 0, ii = widths.length; i < ii; i++)glyphsWidths[j++] = xref.fetchIfRef(widths[i]);
                                defaultWidth = parseFloat(descriptor.get("MissingWidth")) || 0;
                            } else {
                                const baseFontName = dict.get("BaseFont");
                                if (baseFontName instanceof _primitives.Name) {
                                    const metrics = this.getBaseFontMetrics(baseFontName.name);
                                    glyphsWidths = this.buildCharCodeToWidth(metrics.widths, properties);
                                    defaultWidth = metrics.defaultWidth;
                                }
                            }
                        }
                        let isMonospace = true;
                        let firstWidth = defaultWidth;
                        for(const glyph in glyphsWidths){
                            const glyphWidth = glyphsWidths[glyph];
                            if (!glyphWidth) continue;
                            if (!firstWidth) {
                                firstWidth = glyphWidth;
                                continue;
                            }
                            if (firstWidth !== glyphWidth) {
                                isMonospace = false;
                                break;
                            }
                        }
                        if (isMonospace) properties.flags |= _fonts_utils.FontFlags.FixedPitch;
                        else properties.flags &= ~_fonts_utils.FontFlags.FixedPitch;
                        properties.defaultWidth = defaultWidth;
                        properties.widths = glyphsWidths;
                        properties.defaultVMetrics = defaultVMetrics;
                        properties.vmetrics = glyphsVMetrics;
                    }
                    isSerifFont(baseFontName) {
                        const fontNameWoStyle = baseFontName.split("-")[0];
                        return fontNameWoStyle in (0, _standard_fonts.getSerifFonts)() || /serif/gi.test(fontNameWoStyle);
                    }
                    getBaseFontMetrics(name) {
                        let defaultWidth = 0;
                        let widths = Object.create(null);
                        let monospace = false;
                        const stdFontMap = (0, _standard_fonts.getStdFontMap)();
                        let lookupName = stdFontMap[name] || name;
                        const Metrics = (0, _metrics.getMetrics)();
                        if (!(lookupName in Metrics)) lookupName = this.isSerifFont(name) ? "Times-Roman" : "Helvetica";
                        const glyphWidths = Metrics[lookupName];
                        if (typeof glyphWidths === "number") {
                            defaultWidth = glyphWidths;
                            monospace = true;
                        } else widths = glyphWidths();
                        return {
                            defaultWidth: defaultWidth,
                            monospace: monospace,
                            widths: widths
                        };
                    }
                    buildCharCodeToWidth(widthsByGlyphName, properties) {
                        const widths = Object.create(null);
                        const differences = properties.differences;
                        const encoding = properties.defaultEncoding;
                        for(let charCode = 0; charCode < 256; charCode++){
                            if (charCode in differences && widthsByGlyphName[differences[charCode]]) {
                                widths[charCode] = widthsByGlyphName[differences[charCode]];
                                continue;
                            }
                            if (charCode in encoding && widthsByGlyphName[encoding[charCode]]) {
                                widths[charCode] = widthsByGlyphName[encoding[charCode]];
                                continue;
                            }
                        }
                        return widths;
                    }
                    preEvaluateFont(dict) {
                        const baseDict = dict;
                        let type = dict.get("Subtype");
                        if (!(type instanceof _primitives.Name)) throw new _util.FormatError("invalid font Subtype");
                        let composite = false;
                        let hash, toUnicode;
                        if (type.name === "Type0") {
                            const df = dict.get("DescendantFonts");
                            if (!df) throw new _util.FormatError("Descendant fonts are not specified");
                            dict = Array.isArray(df) ? this.xref.fetchIfRef(df[0]) : df;
                            if (!(dict instanceof _primitives.Dict)) throw new _util.FormatError("Descendant font is not a dictionary.");
                            type = dict.get("Subtype");
                            if (!(type instanceof _primitives.Name)) throw new _util.FormatError("invalid font Subtype");
                            composite = true;
                        }
                        const firstChar = dict.get("FirstChar") || 0, lastChar = dict.get("LastChar") || (composite ? 0xffff : 0xff);
                        const descriptor = dict.get("FontDescriptor");
                        if (descriptor) {
                            hash = new _murmurhash.MurmurHash3_64();
                            const encoding = baseDict.getRaw("Encoding");
                            if (encoding instanceof _primitives.Name) hash.update(encoding.name);
                            else if (encoding instanceof _primitives.Ref) hash.update(encoding.toString());
                            else if (encoding instanceof _primitives.Dict) for (const entry of encoding.getRawValues()){
                                if (entry instanceof _primitives.Name) hash.update(entry.name);
                                else if (entry instanceof _primitives.Ref) hash.update(entry.toString());
                                else if (Array.isArray(entry)) {
                                    const diffLength = entry.length, diffBuf = new Array(diffLength);
                                    for(let j = 0; j < diffLength; j++){
                                        const diffEntry = entry[j];
                                        if (diffEntry instanceof _primitives.Name) diffBuf[j] = diffEntry.name;
                                        else if (typeof diffEntry === "number" || diffEntry instanceof _primitives.Ref) diffBuf[j] = diffEntry.toString();
                                    }
                                    hash.update(diffBuf.join());
                                }
                            }
                            hash.update(`${firstChar}-${lastChar}`);
                            toUnicode = dict.get("ToUnicode") || baseDict.get("ToUnicode");
                            if (toUnicode instanceof _base_stream.BaseStream) {
                                const stream = toUnicode.str || toUnicode;
                                const uint8array = stream.buffer ? new Uint8Array(stream.buffer.buffer, 0, stream.bufferLength) : new Uint8Array(stream.bytes.buffer, stream.start, stream.end - stream.start);
                                hash.update(uint8array);
                            } else if (toUnicode instanceof _primitives.Name) hash.update(toUnicode.name);
                            const widths = dict.get("Widths") || baseDict.get("Widths");
                            if (Array.isArray(widths)) {
                                const widthsBuf = [];
                                for (const entry of widths)if (typeof entry === "number" || entry instanceof _primitives.Ref) widthsBuf.push(entry.toString());
                                hash.update(widthsBuf.join());
                            }
                            if (composite) {
                                hash.update("compositeFont");
                                const compositeWidths = dict.get("W") || baseDict.get("W");
                                if (Array.isArray(compositeWidths)) {
                                    const widthsBuf = [];
                                    for (const entry of compositeWidths){
                                        if (typeof entry === "number" || entry instanceof _primitives.Ref) widthsBuf.push(entry.toString());
                                        else if (Array.isArray(entry)) {
                                            const subWidthsBuf = [];
                                            for (const element of entry)if (typeof element === "number" || element instanceof _primitives.Ref) subWidthsBuf.push(element.toString());
                                            widthsBuf.push(`[${subWidthsBuf.join()}]`);
                                        }
                                    }
                                    hash.update(widthsBuf.join());
                                }
                                const cidToGidMap = dict.getRaw("CIDToGIDMap") || baseDict.getRaw("CIDToGIDMap");
                                if (cidToGidMap instanceof _primitives.Name) hash.update(cidToGidMap.name);
                                else if (cidToGidMap instanceof _primitives.Ref) hash.update(cidToGidMap.toString());
                                else if (cidToGidMap instanceof _base_stream.BaseStream) hash.update(cidToGidMap.peekBytes());
                            }
                        }
                        return {
                            descriptor: descriptor,
                            dict: dict,
                            baseDict: baseDict,
                            composite: composite,
                            type: type.name,
                            firstChar: firstChar,
                            lastChar: lastChar,
                            toUnicode: toUnicode,
                            hash: hash ? hash.hexdigest() : ""
                        };
                    }
                    async translateFont({ descriptor: descriptor, dict: dict, baseDict: baseDict, composite: composite, type: type, firstChar: firstChar, lastChar: lastChar, toUnicode: toUnicode, cssFontInfo: cssFontInfo }) {
                        const isType3Font = type === "Type3";
                        let properties;
                        if (!descriptor) {
                            if (isType3Font) {
                                descriptor = new _primitives.Dict(null);
                                descriptor.set("FontName", _primitives.Name.get(type));
                                descriptor.set("FontBBox", dict.getArray("FontBBox") || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]);
                            } else {
                                let baseFontName = dict.get("BaseFont");
                                if (!(baseFontName instanceof _primitives.Name)) throw new _util.FormatError("Base font is not specified");
                                baseFontName = baseFontName.name.replaceAll(/[,_]/g, "-");
                                const metrics = this.getBaseFontMetrics(baseFontName);
                                const fontNameWoStyle = baseFontName.split("-")[0];
                                const flags = (this.isSerifFont(fontNameWoStyle) ? _fonts_utils.FontFlags.Serif : 0) | (metrics.monospace ? _fonts_utils.FontFlags.FixedPitch : 0) | ((0, _standard_fonts.getSymbolsFonts)()[fontNameWoStyle] ? _fonts_utils.FontFlags.Symbolic : _fonts_utils.FontFlags.Nonsymbolic);
                                properties = {
                                    type: type,
                                    name: baseFontName,
                                    loadedName: baseDict.loadedName,
                                    systemFontInfo: null,
                                    widths: metrics.widths,
                                    defaultWidth: metrics.defaultWidth,
                                    isSimulatedFlags: true,
                                    flags: flags,
                                    firstChar: firstChar,
                                    lastChar: lastChar,
                                    toUnicode: toUnicode,
                                    xHeight: 0,
                                    capHeight: 0,
                                    italicAngle: 0,
                                    isType3Font: isType3Font
                                };
                                const widths = dict.get("Widths");
                                const standardFontName = (0, _standard_fonts.getStandardFontName)(baseFontName);
                                let file = null;
                                if (standardFontName) {
                                    file = await this.fetchStandardFontData(standardFontName);
                                    properties.isInternalFont = !!file;
                                }
                                if (!properties.isInternalFont && this.options.useSystemFonts) properties.systemFontInfo = (0, _font_substitutions.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, baseFontName, standardFontName);
                                return this.extractDataStructures(dict, dict, properties).then((newProperties)=>{
                                    if (widths) {
                                        const glyphWidths = [];
                                        let j = firstChar;
                                        for (const width of widths)glyphWidths[j++] = this.xref.fetchIfRef(width);
                                        newProperties.widths = glyphWidths;
                                    } else newProperties.widths = this.buildCharCodeToWidth(metrics.widths, newProperties);
                                    return new _fonts.Font(baseFontName, file, newProperties);
                                });
                            }
                        }
                        let fontName = descriptor.get("FontName");
                        let baseFont = dict.get("BaseFont");
                        if (typeof fontName === "string") fontName = _primitives.Name.get(fontName);
                        if (typeof baseFont === "string") baseFont = _primitives.Name.get(baseFont);
                        const fontNameStr = fontName?.name;
                        const baseFontStr = baseFont?.name;
                        if (!isType3Font && fontNameStr !== baseFontStr) {
                            (0, _util.info)(`The FontDescriptor's FontName is "${fontNameStr}" but ` + `should be the same as the Font's BaseFont "${baseFontStr}".`);
                            if (fontNameStr && baseFontStr && (baseFontStr.startsWith(fontNameStr) || !(0, _standard_fonts.isKnownFontName)(fontNameStr) && (0, _standard_fonts.isKnownFontName)(baseFontStr))) fontName = null;
                        }
                        fontName ||= baseFont;
                        if (!(fontName instanceof _primitives.Name)) throw new _util.FormatError("invalid font name");
                        let fontFile, subtype, length1, length2, length3;
                        try {
                            fontFile = descriptor.get("FontFile", "FontFile2", "FontFile3");
                        } catch (ex) {
                            if (!this.options.ignoreErrors) throw ex;
                            (0, _util.warn)(`translateFont - fetching "${fontName.name}" font file: "${ex}".`);
                            fontFile = new _stream.NullStream();
                        }
                        let isInternalFont = false;
                        let glyphScaleFactors = null;
                        let systemFontInfo = null;
                        if (fontFile) {
                            if (fontFile.dict) {
                                const subtypeEntry = fontFile.dict.get("Subtype");
                                if (subtypeEntry instanceof _primitives.Name) subtype = subtypeEntry.name;
                                length1 = fontFile.dict.get("Length1");
                                length2 = fontFile.dict.get("Length2");
                                length3 = fontFile.dict.get("Length3");
                            }
                        } else if (cssFontInfo) {
                            const standardFontName = (0, _xfa_fonts.getXfaFontName)(fontName.name);
                            if (standardFontName) {
                                cssFontInfo.fontFamily = `${cssFontInfo.fontFamily}-PdfJS-XFA`;
                                cssFontInfo.metrics = standardFontName.metrics || null;
                                glyphScaleFactors = standardFontName.factors || null;
                                fontFile = await this.fetchStandardFontData(standardFontName.name);
                                isInternalFont = !!fontFile;
                                baseDict = dict = (0, _xfa_fonts.getXfaFontDict)(fontName.name);
                                composite = true;
                            }
                        } else if (!isType3Font) {
                            const standardFontName = (0, _standard_fonts.getStandardFontName)(fontName.name);
                            if (standardFontName) {
                                fontFile = await this.fetchStandardFontData(standardFontName);
                                isInternalFont = !!fontFile;
                            }
                            if (!isInternalFont && this.options.useSystemFonts) systemFontInfo = (0, _font_substitutions.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, fontName.name, standardFontName);
                        }
                        properties = {
                            type: type,
                            name: fontName.name,
                            subtype: subtype,
                            file: fontFile,
                            length1: length1,
                            length2: length2,
                            length3: length3,
                            isInternalFont: isInternalFont,
                            loadedName: baseDict.loadedName,
                            composite: composite,
                            fixedPitch: false,
                            fontMatrix: dict.getArray("FontMatrix") || _util.FONT_IDENTITY_MATRIX,
                            firstChar: firstChar,
                            lastChar: lastChar,
                            toUnicode: toUnicode,
                            bbox: descriptor.getArray("FontBBox") || dict.getArray("FontBBox"),
                            ascent: descriptor.get("Ascent"),
                            descent: descriptor.get("Descent"),
                            xHeight: descriptor.get("XHeight") || 0,
                            capHeight: descriptor.get("CapHeight") || 0,
                            flags: descriptor.get("Flags"),
                            italicAngle: descriptor.get("ItalicAngle") || 0,
                            isType3Font: isType3Font,
                            cssFontInfo: cssFontInfo,
                            scaleFactors: glyphScaleFactors,
                            systemFontInfo: systemFontInfo
                        };
                        if (composite) {
                            const cidEncoding = baseDict.get("Encoding");
                            if (cidEncoding instanceof _primitives.Name) properties.cidEncoding = cidEncoding.name;
                            const cMap = await _cmap.CMapFactory.create({
                                encoding: cidEncoding,
                                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                                useCMap: null
                            });
                            properties.cMap = cMap;
                            properties.vertical = properties.cMap.vertical;
                        }
                        return this.extractDataStructures(dict, baseDict, properties).then((newProperties)=>{
                            this.extractWidths(dict, descriptor, newProperties);
                            return new _fonts.Font(fontName.name, fontFile, newProperties);
                        });
                    }
                    static buildFontPaths(font1, glyphs, handler, evaluatorOptions) {
                        function buildPath(fontChar) {
                            const glyphName = `${font1.loadedName}_path_${fontChar}`;
                            try {
                                if (font1.renderer.hasBuiltPath(fontChar)) return;
                                handler.send("commonobj", [
                                    glyphName,
                                    "FontPath",
                                    font1.renderer.getPathJs(fontChar)
                                ]);
                            } catch (reason) {
                                if (evaluatorOptions.ignoreErrors) {
                                    (0, _util.warn)(`buildFontPaths - ignoring ${glyphName} glyph: "${reason}".`);
                                    return;
                                }
                                throw reason;
                            }
                        }
                        for (const glyph of glyphs){
                            buildPath(glyph.fontChar);
                            const accent = glyph.accent;
                            if (accent?.fontChar) buildPath(accent.fontChar);
                        }
                    }
                    static get fallbackFontDict() {
                        const dict = new _primitives.Dict();
                        dict.set("BaseFont", _primitives.Name.get("Helvetica"));
                        dict.set("Type", _primitives.Name.get("FallbackType"));
                        dict.set("Subtype", _primitives.Name.get("FallbackType"));
                        dict.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                        return (0, _util.shadow)(this, "fallbackFontDict", dict);
                    }
                }
                exports.PartialEvaluator = PartialEvaluator;
                class TranslatedFont {
                    constructor({ loadedName: loadedName, font: font1, dict: dict, evaluatorOptions: evaluatorOptions }){
                        this.loadedName = loadedName;
                        this.font = font1;
                        this.dict = dict;
                        this._evaluatorOptions = evaluatorOptions || DefaultPartialEvaluatorOptions;
                        this.type3Loaded = null;
                        this.type3Dependencies = font1.isType3Font ? new Set() : null;
                        this.sent = false;
                    }
                    send(handler) {
                        if (this.sent) return;
                        this.sent = true;
                        handler.send("commonobj", [
                            this.loadedName,
                            "Font",
                            this.font.exportData(this._evaluatorOptions.fontExtraProperties)
                        ]);
                    }
                    fallback(handler) {
                        if (!this.font.data) return;
                        this.font.disableFontFace = true;
                        PartialEvaluator.buildFontPaths(this.font, this.font.glyphCacheValues, handler, this._evaluatorOptions);
                    }
                    loadType3Data(evaluator, resources, task) {
                        if (this.type3Loaded) return this.type3Loaded;
                        if (!this.font.isType3Font) throw new Error("Must be a Type3 font.");
                        const type3Evaluator = evaluator.clone({
                            ignoreErrors: false
                        });
                        type3Evaluator.parsingType3Font = true;
                        const type3FontRefs = new _primitives.RefSet(evaluator.type3FontRefs);
                        if (this.dict.objId && !type3FontRefs.has(this.dict.objId)) type3FontRefs.put(this.dict.objId);
                        type3Evaluator.type3FontRefs = type3FontRefs;
                        const translatedFont = this.font, type3Dependencies = this.type3Dependencies;
                        let loadCharProcsPromise = Promise.resolve();
                        const charProcs = this.dict.get("CharProcs");
                        const fontResources = this.dict.get("Resources") || resources;
                        const charProcOperatorList = Object.create(null);
                        const fontBBox = _util.Util.normalizeRect(translatedFont.bbox || [
                            0,
                            0,
                            0,
                            0
                        ]), width = fontBBox[2] - fontBBox[0], height = fontBBox[3] - fontBBox[1];
                        const fontBBoxSize = Math.hypot(width, height);
                        for (const key of charProcs.getKeys())loadCharProcsPromise = loadCharProcsPromise.then(()=>{
                            const glyphStream = charProcs.get(key);
                            const operatorList = new _operator_list.OperatorList();
                            return type3Evaluator.getOperatorList({
                                stream: glyphStream,
                                task: task,
                                resources: fontResources,
                                operatorList: operatorList
                            }).then(()=>{
                                if (operatorList.fnArray[0] === _util.OPS.setCharWidthAndBounds) this._removeType3ColorOperators(operatorList, fontBBoxSize);
                                charProcOperatorList[key] = operatorList.getIR();
                                for (const dependency of operatorList.dependencies)type3Dependencies.add(dependency);
                            }).catch(function(reason) {
                                (0, _util.warn)(`Type3 font resource "${key}" is not available.`);
                                const dummyOperatorList = new _operator_list.OperatorList();
                                charProcOperatorList[key] = dummyOperatorList.getIR();
                            });
                        });
                        this.type3Loaded = loadCharProcsPromise.then(()=>{
                            translatedFont.charProcOperatorList = charProcOperatorList;
                            if (this._bbox) {
                                translatedFont.isCharBBox = true;
                                translatedFont.bbox = this._bbox;
                            }
                        });
                        return this.type3Loaded;
                    }
                    _removeType3ColorOperators(operatorList, fontBBoxSize = NaN) {
                        const charBBox = _util.Util.normalizeRect(operatorList.argsArray[0].slice(2)), width = charBBox[2] - charBBox[0], height = charBBox[3] - charBBox[1];
                        const charBBoxSize = Math.hypot(width, height);
                        if (width === 0 || height === 0) {
                            operatorList.fnArray.splice(0, 1);
                            operatorList.argsArray.splice(0, 1);
                        } else if (fontBBoxSize === 0 || Math.round(charBBoxSize / fontBBoxSize) >= 10) {
                            if (!this._bbox) this._bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            this._bbox[0] = Math.min(this._bbox[0], charBBox[0]);
                            this._bbox[1] = Math.min(this._bbox[1], charBBox[1]);
                            this._bbox[2] = Math.max(this._bbox[2], charBBox[2]);
                            this._bbox[3] = Math.max(this._bbox[3], charBBox[3]);
                        }
                        let i = 0, ii = operatorList.length;
                        while(i < ii){
                            switch(operatorList.fnArray[i]){
                                case _util.OPS.setCharWidthAndBounds:
                                    break;
                                case _util.OPS.setStrokeColorSpace:
                                case _util.OPS.setFillColorSpace:
                                case _util.OPS.setStrokeColor:
                                case _util.OPS.setStrokeColorN:
                                case _util.OPS.setFillColor:
                                case _util.OPS.setFillColorN:
                                case _util.OPS.setStrokeGray:
                                case _util.OPS.setFillGray:
                                case _util.OPS.setStrokeRGBColor:
                                case _util.OPS.setFillRGBColor:
                                case _util.OPS.setStrokeCMYKColor:
                                case _util.OPS.setFillCMYKColor:
                                case _util.OPS.shadingFill:
                                case _util.OPS.setRenderingIntent:
                                    operatorList.fnArray.splice(i, 1);
                                    operatorList.argsArray.splice(i, 1);
                                    ii--;
                                    continue;
                                case _util.OPS.setGState:
                                    const [gStateObj] = operatorList.argsArray[i];
                                    let j = 0, jj = gStateObj.length;
                                    while(j < jj){
                                        const [gStateKey] = gStateObj[j];
                                        switch(gStateKey){
                                            case "TR":
                                            case "TR2":
                                            case "HT":
                                            case "BG":
                                            case "BG2":
                                            case "UCR":
                                            case "UCR2":
                                                gStateObj.splice(j, 1);
                                                jj--;
                                                continue;
                                        }
                                        j++;
                                    }
                                    break;
                            }
                            i++;
                        }
                    }
                }
                class StateManager {
                    constructor(initialState = new EvalState()){
                        this.state = initialState;
                        this.stateStack = [];
                    }
                    save() {
                        const old = this.state;
                        this.stateStack.push(this.state);
                        this.state = old.clone();
                    }
                    restore() {
                        const prev = this.stateStack.pop();
                        if (prev) this.state = prev;
                    }
                    transform(args) {
                        this.state.ctm = _util.Util.transform(this.state.ctm, args);
                    }
                }
                class TextState {
                    constructor(){
                        this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
                        this.fontName = null;
                        this.fontSize = 0;
                        this.loadedName = null;
                        this.font = null;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.textMatrix = _util.IDENTITY_MATRIX.slice();
                        this.textLineMatrix = _util.IDENTITY_MATRIX.slice();
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.leading = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        const m = this.textMatrix;
                        m[0] = a;
                        m[1] = b;
                        m[2] = c;
                        m[3] = d;
                        m[4] = e;
                        m[5] = f;
                    }
                    setTextLineMatrix(a, b, c, d, e, f) {
                        const m = this.textLineMatrix;
                        m[0] = a;
                        m[1] = b;
                        m[2] = c;
                        m[3] = d;
                        m[4] = e;
                        m[5] = f;
                    }
                    translateTextMatrix(x, y) {
                        const m = this.textMatrix;
                        m[4] = m[0] * x + m[2] * y + m[4];
                        m[5] = m[1] * x + m[3] * y + m[5];
                    }
                    translateTextLineMatrix(x, y) {
                        const m = this.textLineMatrix;
                        m[4] = m[0] * x + m[2] * y + m[4];
                        m[5] = m[1] * x + m[3] * y + m[5];
                    }
                    carriageReturn() {
                        this.translateTextLineMatrix(0, -this.leading);
                        this.textMatrix = this.textLineMatrix.slice();
                    }
                    clone() {
                        const clone = Object.create(this);
                        clone.textMatrix = this.textMatrix.slice();
                        clone.textLineMatrix = this.textLineMatrix.slice();
                        clone.fontMatrix = this.fontMatrix.slice();
                        return clone;
                    }
                }
                class EvalState {
                    constructor(){
                        this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
                        this.font = null;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
                        this.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
                    }
                    clone() {
                        return Object.create(this);
                    }
                }
                class EvaluatorPreprocessor {
                    static get opMap() {
                        return (0, _util.shadow)(this, "opMap", {
                            w: {
                                id: _util.OPS.setLineWidth,
                                numArgs: 1,
                                variableArgs: false
                            },
                            J: {
                                id: _util.OPS.setLineCap,
                                numArgs: 1,
                                variableArgs: false
                            },
                            j: {
                                id: _util.OPS.setLineJoin,
                                numArgs: 1,
                                variableArgs: false
                            },
                            M: {
                                id: _util.OPS.setMiterLimit,
                                numArgs: 1,
                                variableArgs: false
                            },
                            d: {
                                id: _util.OPS.setDash,
                                numArgs: 2,
                                variableArgs: false
                            },
                            ri: {
                                id: _util.OPS.setRenderingIntent,
                                numArgs: 1,
                                variableArgs: false
                            },
                            i: {
                                id: _util.OPS.setFlatness,
                                numArgs: 1,
                                variableArgs: false
                            },
                            gs: {
                                id: _util.OPS.setGState,
                                numArgs: 1,
                                variableArgs: false
                            },
                            q: {
                                id: _util.OPS.save,
                                numArgs: 0,
                                variableArgs: false
                            },
                            Q: {
                                id: _util.OPS.restore,
                                numArgs: 0,
                                variableArgs: false
                            },
                            cm: {
                                id: _util.OPS.transform,
                                numArgs: 6,
                                variableArgs: false
                            },
                            m: {
                                id: _util.OPS.moveTo,
                                numArgs: 2,
                                variableArgs: false
                            },
                            l: {
                                id: _util.OPS.lineTo,
                                numArgs: 2,
                                variableArgs: false
                            },
                            c: {
                                id: _util.OPS.curveTo,
                                numArgs: 6,
                                variableArgs: false
                            },
                            v: {
                                id: _util.OPS.curveTo2,
                                numArgs: 4,
                                variableArgs: false
                            },
                            y: {
                                id: _util.OPS.curveTo3,
                                numArgs: 4,
                                variableArgs: false
                            },
                            h: {
                                id: _util.OPS.closePath,
                                numArgs: 0,
                                variableArgs: false
                            },
                            re: {
                                id: _util.OPS.rectangle,
                                numArgs: 4,
                                variableArgs: false
                            },
                            S: {
                                id: _util.OPS.stroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            s: {
                                id: _util.OPS.closeStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            f: {
                                id: _util.OPS.fill,
                                numArgs: 0,
                                variableArgs: false
                            },
                            F: {
                                id: _util.OPS.fill,
                                numArgs: 0,
                                variableArgs: false
                            },
                            "f*": {
                                id: _util.OPS.eoFill,
                                numArgs: 0,
                                variableArgs: false
                            },
                            B: {
                                id: _util.OPS.fillStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            "B*": {
                                id: _util.OPS.eoFillStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            b: {
                                id: _util.OPS.closeFillStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            "b*": {
                                id: _util.OPS.closeEOFillStroke,
                                numArgs: 0,
                                variableArgs: false
                            },
                            n: {
                                id: _util.OPS.endPath,
                                numArgs: 0,
                                variableArgs: false
                            },
                            W: {
                                id: _util.OPS.clip,
                                numArgs: 0,
                                variableArgs: false
                            },
                            "W*": {
                                id: _util.OPS.eoClip,
                                numArgs: 0,
                                variableArgs: false
                            },
                            BT: {
                                id: _util.OPS.beginText,
                                numArgs: 0,
                                variableArgs: false
                            },
                            ET: {
                                id: _util.OPS.endText,
                                numArgs: 0,
                                variableArgs: false
                            },
                            Tc: {
                                id: _util.OPS.setCharSpacing,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Tw: {
                                id: _util.OPS.setWordSpacing,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Tz: {
                                id: _util.OPS.setHScale,
                                numArgs: 1,
                                variableArgs: false
                            },
                            TL: {
                                id: _util.OPS.setLeading,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Tf: {
                                id: _util.OPS.setFont,
                                numArgs: 2,
                                variableArgs: false
                            },
                            Tr: {
                                id: _util.OPS.setTextRenderingMode,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Ts: {
                                id: _util.OPS.setTextRise,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Td: {
                                id: _util.OPS.moveText,
                                numArgs: 2,
                                variableArgs: false
                            },
                            TD: {
                                id: _util.OPS.setLeadingMoveText,
                                numArgs: 2,
                                variableArgs: false
                            },
                            Tm: {
                                id: _util.OPS.setTextMatrix,
                                numArgs: 6,
                                variableArgs: false
                            },
                            "T*": {
                                id: _util.OPS.nextLine,
                                numArgs: 0,
                                variableArgs: false
                            },
                            Tj: {
                                id: _util.OPS.showText,
                                numArgs: 1,
                                variableArgs: false
                            },
                            TJ: {
                                id: _util.OPS.showSpacedText,
                                numArgs: 1,
                                variableArgs: false
                            },
                            "'": {
                                id: _util.OPS.nextLineShowText,
                                numArgs: 1,
                                variableArgs: false
                            },
                            '"': {
                                id: _util.OPS.nextLineSetSpacingShowText,
                                numArgs: 3,
                                variableArgs: false
                            },
                            d0: {
                                id: _util.OPS.setCharWidth,
                                numArgs: 2,
                                variableArgs: false
                            },
                            d1: {
                                id: _util.OPS.setCharWidthAndBounds,
                                numArgs: 6,
                                variableArgs: false
                            },
                            CS: {
                                id: _util.OPS.setStrokeColorSpace,
                                numArgs: 1,
                                variableArgs: false
                            },
                            cs: {
                                id: _util.OPS.setFillColorSpace,
                                numArgs: 1,
                                variableArgs: false
                            },
                            SC: {
                                id: _util.OPS.setStrokeColor,
                                numArgs: 4,
                                variableArgs: true
                            },
                            SCN: {
                                id: _util.OPS.setStrokeColorN,
                                numArgs: 33,
                                variableArgs: true
                            },
                            sc: {
                                id: _util.OPS.setFillColor,
                                numArgs: 4,
                                variableArgs: true
                            },
                            scn: {
                                id: _util.OPS.setFillColorN,
                                numArgs: 33,
                                variableArgs: true
                            },
                            G: {
                                id: _util.OPS.setStrokeGray,
                                numArgs: 1,
                                variableArgs: false
                            },
                            g: {
                                id: _util.OPS.setFillGray,
                                numArgs: 1,
                                variableArgs: false
                            },
                            RG: {
                                id: _util.OPS.setStrokeRGBColor,
                                numArgs: 3,
                                variableArgs: false
                            },
                            rg: {
                                id: _util.OPS.setFillRGBColor,
                                numArgs: 3,
                                variableArgs: false
                            },
                            K: {
                                id: _util.OPS.setStrokeCMYKColor,
                                numArgs: 4,
                                variableArgs: false
                            },
                            k: {
                                id: _util.OPS.setFillCMYKColor,
                                numArgs: 4,
                                variableArgs: false
                            },
                            sh: {
                                id: _util.OPS.shadingFill,
                                numArgs: 1,
                                variableArgs: false
                            },
                            BI: {
                                id: _util.OPS.beginInlineImage,
                                numArgs: 0,
                                variableArgs: false
                            },
                            ID: {
                                id: _util.OPS.beginImageData,
                                numArgs: 0,
                                variableArgs: false
                            },
                            EI: {
                                id: _util.OPS.endInlineImage,
                                numArgs: 1,
                                variableArgs: false
                            },
                            Do: {
                                id: _util.OPS.paintXObject,
                                numArgs: 1,
                                variableArgs: false
                            },
                            MP: {
                                id: _util.OPS.markPoint,
                                numArgs: 1,
                                variableArgs: false
                            },
                            DP: {
                                id: _util.OPS.markPointProps,
                                numArgs: 2,
                                variableArgs: false
                            },
                            BMC: {
                                id: _util.OPS.beginMarkedContent,
                                numArgs: 1,
                                variableArgs: false
                            },
                            BDC: {
                                id: _util.OPS.beginMarkedContentProps,
                                numArgs: 2,
                                variableArgs: false
                            },
                            EMC: {
                                id: _util.OPS.endMarkedContent,
                                numArgs: 0,
                                variableArgs: false
                            },
                            BX: {
                                id: _util.OPS.beginCompat,
                                numArgs: 0,
                                variableArgs: false
                            },
                            EX: {
                                id: _util.OPS.endCompat,
                                numArgs: 0,
                                variableArgs: false
                            },
                            BM: null,
                            BD: null,
                            true: null,
                            fa: null,
                            fal: null,
                            fals: null,
                            false: null,
                            nu: null,
                            nul: null,
                            null: null
                        });
                    }
                    static MAX_INVALID_PATH_OPS = 10;
                    constructor(stream, xref, stateManager = new StateManager()){
                        this.parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream, EvaluatorPreprocessor.opMap),
                            xref: xref
                        });
                        this.stateManager = stateManager;
                        this.nonProcessedArgs = [];
                        this._isPathOp = false;
                        this._numInvalidPathOPS = 0;
                    }
                    get savedStatesDepth() {
                        return this.stateManager.stateStack.length;
                    }
                    read(operation) {
                        let args = operation.args;
                        while(true){
                            const obj = this.parser.getObj();
                            if (obj instanceof _primitives.Cmd) {
                                const cmd = obj.cmd;
                                const opSpec = EvaluatorPreprocessor.opMap[cmd];
                                if (!opSpec) {
                                    (0, _util.warn)(`Unknown command "${cmd}".`);
                                    continue;
                                }
                                const fn = opSpec.id;
                                const numArgs = opSpec.numArgs;
                                let argsLength = args !== null ? args.length : 0;
                                if (!this._isPathOp) this._numInvalidPathOPS = 0;
                                this._isPathOp = fn >= _util.OPS.moveTo && fn <= _util.OPS.endPath;
                                if (!opSpec.variableArgs) {
                                    if (argsLength !== numArgs) {
                                        const nonProcessedArgs = this.nonProcessedArgs;
                                        while(argsLength > numArgs){
                                            nonProcessedArgs.push(args.shift());
                                            argsLength--;
                                        }
                                        while(argsLength < numArgs && nonProcessedArgs.length !== 0){
                                            if (args === null) args = [];
                                            args.unshift(nonProcessedArgs.pop());
                                            argsLength++;
                                        }
                                    }
                                    if (argsLength < numArgs) {
                                        const partialMsg = `command ${cmd}: expected ${numArgs} args, ` + `but received ${argsLength} args.`;
                                        if (this._isPathOp && ++this._numInvalidPathOPS > EvaluatorPreprocessor.MAX_INVALID_PATH_OPS) throw new _util.FormatError(`Invalid ${partialMsg}`);
                                        (0, _util.warn)(`Skipping ${partialMsg}`);
                                        if (args !== null) args.length = 0;
                                        continue;
                                    }
                                } else if (argsLength > numArgs) (0, _util.info)(`Command ${cmd}: expected [0, ${numArgs}] args, ` + `but received ${argsLength} args.`);
                                this.preprocessCommand(fn, args);
                                operation.fn = fn;
                                operation.args = args;
                                return true;
                            }
                            if (obj === _primitives.EOF) return false;
                            if (obj !== null) {
                                if (args === null) args = [];
                                args.push(obj);
                                if (args.length > 33) throw new _util.FormatError("Too many arguments");
                            }
                        }
                    }
                    preprocessCommand(fn, args) {
                        switch(fn | 0){
                            case _util.OPS.save:
                                this.stateManager.save();
                                break;
                            case _util.OPS.restore:
                                this.stateManager.restore();
                                break;
                            case _util.OPS.transform:
                                this.stateManager.transform(args);
                                break;
                        }
                    }
                }
                exports.EvaluatorPreprocessor = EvaluatorPreprocessor;
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.IdentityCMap = exports.CMapFactory = exports.CMap = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _base_stream = __w_pdfjs_require__(5);
                var _binary_cmap = __w_pdfjs_require__(15);
                var _parser = __w_pdfjs_require__(16);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                const BUILT_IN_CMAPS = [
                    "Adobe-GB1-UCS2",
                    "Adobe-CNS1-UCS2",
                    "Adobe-Japan1-UCS2",
                    "Adobe-Korea1-UCS2",
                    "78-EUC-H",
                    "78-EUC-V",
                    "78-H",
                    "78-RKSJ-H",
                    "78-RKSJ-V",
                    "78-V",
                    "78ms-RKSJ-H",
                    "78ms-RKSJ-V",
                    "83pv-RKSJ-H",
                    "90ms-RKSJ-H",
                    "90ms-RKSJ-V",
                    "90msp-RKSJ-H",
                    "90msp-RKSJ-V",
                    "90pv-RKSJ-H",
                    "90pv-RKSJ-V",
                    "Add-H",
                    "Add-RKSJ-H",
                    "Add-RKSJ-V",
                    "Add-V",
                    "Adobe-CNS1-0",
                    "Adobe-CNS1-1",
                    "Adobe-CNS1-2",
                    "Adobe-CNS1-3",
                    "Adobe-CNS1-4",
                    "Adobe-CNS1-5",
                    "Adobe-CNS1-6",
                    "Adobe-GB1-0",
                    "Adobe-GB1-1",
                    "Adobe-GB1-2",
                    "Adobe-GB1-3",
                    "Adobe-GB1-4",
                    "Adobe-GB1-5",
                    "Adobe-Japan1-0",
                    "Adobe-Japan1-1",
                    "Adobe-Japan1-2",
                    "Adobe-Japan1-3",
                    "Adobe-Japan1-4",
                    "Adobe-Japan1-5",
                    "Adobe-Japan1-6",
                    "Adobe-Korea1-0",
                    "Adobe-Korea1-1",
                    "Adobe-Korea1-2",
                    "B5-H",
                    "B5-V",
                    "B5pc-H",
                    "B5pc-V",
                    "CNS-EUC-H",
                    "CNS-EUC-V",
                    "CNS1-H",
                    "CNS1-V",
                    "CNS2-H",
                    "CNS2-V",
                    "ETHK-B5-H",
                    "ETHK-B5-V",
                    "ETen-B5-H",
                    "ETen-B5-V",
                    "ETenms-B5-H",
                    "ETenms-B5-V",
                    "EUC-H",
                    "EUC-V",
                    "Ext-H",
                    "Ext-RKSJ-H",
                    "Ext-RKSJ-V",
                    "Ext-V",
                    "GB-EUC-H",
                    "GB-EUC-V",
                    "GB-H",
                    "GB-V",
                    "GBK-EUC-H",
                    "GBK-EUC-V",
                    "GBK2K-H",
                    "GBK2K-V",
                    "GBKp-EUC-H",
                    "GBKp-EUC-V",
                    "GBT-EUC-H",
                    "GBT-EUC-V",
                    "GBT-H",
                    "GBT-V",
                    "GBTpc-EUC-H",
                    "GBTpc-EUC-V",
                    "GBpc-EUC-H",
                    "GBpc-EUC-V",
                    "H",
                    "HKdla-B5-H",
                    "HKdla-B5-V",
                    "HKdlb-B5-H",
                    "HKdlb-B5-V",
                    "HKgccs-B5-H",
                    "HKgccs-B5-V",
                    "HKm314-B5-H",
                    "HKm314-B5-V",
                    "HKm471-B5-H",
                    "HKm471-B5-V",
                    "HKscs-B5-H",
                    "HKscs-B5-V",
                    "Hankaku",
                    "Hiragana",
                    "KSC-EUC-H",
                    "KSC-EUC-V",
                    "KSC-H",
                    "KSC-Johab-H",
                    "KSC-Johab-V",
                    "KSC-V",
                    "KSCms-UHC-H",
                    "KSCms-UHC-HW-H",
                    "KSCms-UHC-HW-V",
                    "KSCms-UHC-V",
                    "KSCpc-EUC-H",
                    "KSCpc-EUC-V",
                    "Katakana",
                    "NWP-H",
                    "NWP-V",
                    "RKSJ-H",
                    "RKSJ-V",
                    "Roman",
                    "UniCNS-UCS2-H",
                    "UniCNS-UCS2-V",
                    "UniCNS-UTF16-H",
                    "UniCNS-UTF16-V",
                    "UniCNS-UTF32-H",
                    "UniCNS-UTF32-V",
                    "UniCNS-UTF8-H",
                    "UniCNS-UTF8-V",
                    "UniGB-UCS2-H",
                    "UniGB-UCS2-V",
                    "UniGB-UTF16-H",
                    "UniGB-UTF16-V",
                    "UniGB-UTF32-H",
                    "UniGB-UTF32-V",
                    "UniGB-UTF8-H",
                    "UniGB-UTF8-V",
                    "UniJIS-UCS2-H",
                    "UniJIS-UCS2-HW-H",
                    "UniJIS-UCS2-HW-V",
                    "UniJIS-UCS2-V",
                    "UniJIS-UTF16-H",
                    "UniJIS-UTF16-V",
                    "UniJIS-UTF32-H",
                    "UniJIS-UTF32-V",
                    "UniJIS-UTF8-H",
                    "UniJIS-UTF8-V",
                    "UniJIS2004-UTF16-H",
                    "UniJIS2004-UTF16-V",
                    "UniJIS2004-UTF32-H",
                    "UniJIS2004-UTF32-V",
                    "UniJIS2004-UTF8-H",
                    "UniJIS2004-UTF8-V",
                    "UniJISPro-UCS2-HW-V",
                    "UniJISPro-UCS2-V",
                    "UniJISPro-UTF8-V",
                    "UniJISX0213-UTF32-H",
                    "UniJISX0213-UTF32-V",
                    "UniJISX02132004-UTF32-H",
                    "UniJISX02132004-UTF32-V",
                    "UniKS-UCS2-H",
                    "UniKS-UCS2-V",
                    "UniKS-UTF16-H",
                    "UniKS-UTF16-V",
                    "UniKS-UTF32-H",
                    "UniKS-UTF32-V",
                    "UniKS-UTF8-H",
                    "UniKS-UTF8-V",
                    "V",
                    "WP-Symbol"
                ];
                const MAX_MAP_RANGE = 2 ** 24 - 1;
                class CMap {
                    constructor(builtInCMap = false){
                        this.codespaceRanges = [
                            [],
                            [],
                            [],
                            []
                        ];
                        this.numCodespaceRanges = 0;
                        this._map = [];
                        this.name = "";
                        this.vertical = false;
                        this.useCMap = null;
                        this.builtInCMap = builtInCMap;
                    }
                    addCodespaceRange(n, low, high) {
                        this.codespaceRanges[n - 1].push(low, high);
                        this.numCodespaceRanges++;
                    }
                    mapCidRange(low, high, dstLow) {
                        if (high - low > MAX_MAP_RANGE) throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
                        while(low <= high)this._map[low++] = dstLow++;
                    }
                    mapBfRange(low, high, dstLow) {
                        if (high - low > MAX_MAP_RANGE) throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
                        const lastByte = dstLow.length - 1;
                        while(low <= high){
                            this._map[low++] = dstLow;
                            const nextCharCode = dstLow.charCodeAt(lastByte) + 1;
                            if (nextCharCode > 0xff) {
                                dstLow = dstLow.substring(0, lastByte - 1) + String.fromCharCode(dstLow.charCodeAt(lastByte - 1) + 1) + "\0";
                                continue;
                            }
                            dstLow = dstLow.substring(0, lastByte) + String.fromCharCode(nextCharCode);
                        }
                    }
                    mapBfRangeToArray(low, high, array) {
                        if (high - low > MAX_MAP_RANGE) throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
                        const ii = array.length;
                        let i = 0;
                        while(low <= high && i < ii){
                            this._map[low] = array[i++];
                            ++low;
                        }
                    }
                    mapOne(src, dst) {
                        this._map[src] = dst;
                    }
                    lookup(code) {
                        return this._map[code];
                    }
                    contains(code) {
                        return this._map[code] !== undefined;
                    }
                    forEach(callback) {
                        const map = this._map;
                        const length = map.length;
                        if (length <= 0x10000) {
                            for(let i = 0; i < length; i++)if (map[i] !== undefined) callback(i, map[i]);
                        } else for(const i in map)callback(i, map[i]);
                    }
                    charCodeOf(value) {
                        const map = this._map;
                        if (map.length <= 0x10000) return map.indexOf(value);
                        for(const charCode in map){
                            if (map[charCode] === value) return charCode | 0;
                        }
                        return -1;
                    }
                    getMap() {
                        return this._map;
                    }
                    readCharCode(str, offset, out) {
                        let c = 0;
                        const codespaceRanges = this.codespaceRanges;
                        for(let n = 0, nn = codespaceRanges.length; n < nn; n++){
                            c = (c << 8 | str.charCodeAt(offset + n)) >>> 0;
                            const codespaceRange = codespaceRanges[n];
                            for(let k = 0, kk = codespaceRange.length; k < kk;){
                                const low = codespaceRange[k++];
                                const high = codespaceRange[k++];
                                if (c >= low && c <= high) {
                                    out.charcode = c;
                                    out.length = n + 1;
                                    return;
                                }
                            }
                        }
                        out.charcode = 0;
                        out.length = 1;
                    }
                    getCharCodeLength(charCode) {
                        const codespaceRanges = this.codespaceRanges;
                        for(let n = 0, nn = codespaceRanges.length; n < nn; n++){
                            const codespaceRange = codespaceRanges[n];
                            for(let k = 0, kk = codespaceRange.length; k < kk;){
                                const low = codespaceRange[k++];
                                const high = codespaceRange[k++];
                                if (charCode >= low && charCode <= high) return n + 1;
                            }
                        }
                        return 1;
                    }
                    get length() {
                        return this._map.length;
                    }
                    get isIdentityCMap() {
                        if (!(this.name === "Identity-H" || this.name === "Identity-V")) return false;
                        if (this._map.length !== 0x10000) return false;
                        for(let i = 0; i < 0x10000; i++){
                            if (this._map[i] !== i) return false;
                        }
                        return true;
                    }
                }
                exports.CMap = CMap;
                class IdentityCMap extends CMap {
                    constructor(vertical, n){
                        super();
                        this.vertical = vertical;
                        this.addCodespaceRange(n, 0, 0xffff);
                    }
                    mapCidRange(low, high, dstLow) {
                        (0, _util.unreachable)("should not call mapCidRange");
                    }
                    mapBfRange(low, high, dstLow) {
                        (0, _util.unreachable)("should not call mapBfRange");
                    }
                    mapBfRangeToArray(low, high, array) {
                        (0, _util.unreachable)("should not call mapBfRangeToArray");
                    }
                    mapOne(src, dst) {
                        (0, _util.unreachable)("should not call mapCidOne");
                    }
                    lookup(code) {
                        return Number.isInteger(code) && code <= 0xffff ? code : undefined;
                    }
                    contains(code) {
                        return Number.isInteger(code) && code <= 0xffff;
                    }
                    forEach(callback) {
                        for(let i = 0; i <= 0xffff; i++)callback(i, i);
                    }
                    charCodeOf(value) {
                        return Number.isInteger(value) && value <= 0xffff ? value : -1;
                    }
                    getMap() {
                        const map = new Array(0x10000);
                        for(let i = 0; i <= 0xffff; i++)map[i] = i;
                        return map;
                    }
                    get length() {
                        return 0x10000;
                    }
                    get isIdentityCMap() {
                        (0, _util.unreachable)("should not access .isIdentityCMap");
                    }
                }
                exports.IdentityCMap = IdentityCMap;
                function strToInt(str) {
                    let a = 0;
                    for(let i = 0; i < str.length; i++)a = a << 8 | str.charCodeAt(i);
                    return a >>> 0;
                }
                function expectString(obj) {
                    if (typeof obj !== "string") throw new _util.FormatError("Malformed CMap: expected string.");
                }
                function expectInt(obj) {
                    if (!Number.isInteger(obj)) throw new _util.FormatError("Malformed CMap: expected int.");
                }
                function parseBfChar(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endbfchar")) return;
                        expectString(obj);
                        const src = strToInt(obj);
                        obj = lexer.getObj();
                        expectString(obj);
                        const dst = obj;
                        cMap.mapOne(src, dst);
                    }
                }
                function parseBfRange(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endbfrange")) return;
                        expectString(obj);
                        const low = strToInt(obj);
                        obj = lexer.getObj();
                        expectString(obj);
                        const high = strToInt(obj);
                        obj = lexer.getObj();
                        if (Number.isInteger(obj) || typeof obj === "string") {
                            const dstLow = Number.isInteger(obj) ? String.fromCharCode(obj) : obj;
                            cMap.mapBfRange(low, high, dstLow);
                        } else if ((0, _primitives.isCmd)(obj, "[")) {
                            obj = lexer.getObj();
                            const array = [];
                            while(!(0, _primitives.isCmd)(obj, "]") && obj !== _primitives.EOF){
                                array.push(obj);
                                obj = lexer.getObj();
                            }
                            cMap.mapBfRangeToArray(low, high, array);
                        } else break;
                    }
                    throw new _util.FormatError("Invalid bf range.");
                }
                function parseCidChar(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endcidchar")) return;
                        expectString(obj);
                        const src = strToInt(obj);
                        obj = lexer.getObj();
                        expectInt(obj);
                        const dst = obj;
                        cMap.mapOne(src, dst);
                    }
                }
                function parseCidRange(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endcidrange")) return;
                        expectString(obj);
                        const low = strToInt(obj);
                        obj = lexer.getObj();
                        expectString(obj);
                        const high = strToInt(obj);
                        obj = lexer.getObj();
                        expectInt(obj);
                        const dstLow = obj;
                        cMap.mapCidRange(low, high, dstLow);
                    }
                }
                function parseCodespaceRange(cMap, lexer) {
                    while(true){
                        let obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        if ((0, _primitives.isCmd)(obj, "endcodespacerange")) return;
                        if (typeof obj !== "string") break;
                        const low = strToInt(obj);
                        obj = lexer.getObj();
                        if (typeof obj !== "string") break;
                        const high = strToInt(obj);
                        cMap.addCodespaceRange(obj.length, low, high);
                    }
                    throw new _util.FormatError("Invalid codespace range.");
                }
                function parseWMode(cMap, lexer) {
                    const obj = lexer.getObj();
                    if (Number.isInteger(obj)) cMap.vertical = !!obj;
                }
                function parseCMapName(cMap, lexer) {
                    const obj = lexer.getObj();
                    if (obj instanceof _primitives.Name) cMap.name = obj.name;
                }
                async function parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap) {
                    let previous, embeddedUseCMap;
                    objLoop: while(true)try {
                        const obj = lexer.getObj();
                        if (obj === _primitives.EOF) break;
                        else if (obj instanceof _primitives.Name) {
                            if (obj.name === "WMode") parseWMode(cMap, lexer);
                            else if (obj.name === "CMapName") parseCMapName(cMap, lexer);
                            previous = obj;
                        } else if (obj instanceof _primitives.Cmd) switch(obj.cmd){
                            case "endcmap":
                                break objLoop;
                            case "usecmap":
                                if (previous instanceof _primitives.Name) embeddedUseCMap = previous.name;
                                break;
                            case "begincodespacerange":
                                parseCodespaceRange(cMap, lexer);
                                break;
                            case "beginbfchar":
                                parseBfChar(cMap, lexer);
                                break;
                            case "begincidchar":
                                parseCidChar(cMap, lexer);
                                break;
                            case "beginbfrange":
                                parseBfRange(cMap, lexer);
                                break;
                            case "begincidrange":
                                parseCidRange(cMap, lexer);
                                break;
                        }
                    } catch (ex) {
                        if (ex instanceof _core_utils.MissingDataException) throw ex;
                        (0, _util.warn)("Invalid cMap data: " + ex);
                        continue;
                    }
                    if (!useCMap && embeddedUseCMap) useCMap = embeddedUseCMap;
                    if (useCMap) return extendCMap(cMap, fetchBuiltInCMap, useCMap);
                    return cMap;
                }
                async function extendCMap(cMap, fetchBuiltInCMap, useCMap) {
                    cMap.useCMap = await createBuiltInCMap(useCMap, fetchBuiltInCMap);
                    if (cMap.numCodespaceRanges === 0) {
                        const useCodespaceRanges = cMap.useCMap.codespaceRanges;
                        for(let i = 0; i < useCodespaceRanges.length; i++)cMap.codespaceRanges[i] = useCodespaceRanges[i].slice();
                        cMap.numCodespaceRanges = cMap.useCMap.numCodespaceRanges;
                    }
                    cMap.useCMap.forEach(function(key, value) {
                        if (!cMap.contains(key)) cMap.mapOne(key, cMap.useCMap.lookup(key));
                    });
                    return cMap;
                }
                async function createBuiltInCMap(name, fetchBuiltInCMap) {
                    if (name === "Identity-H") return new IdentityCMap(false, 2);
                    else if (name === "Identity-V") return new IdentityCMap(true, 2);
                    if (!BUILT_IN_CMAPS.includes(name)) throw new Error("Unknown CMap name: " + name);
                    if (!fetchBuiltInCMap) throw new Error("Built-in CMap parameters are not provided.");
                    const { cMapData: cMapData, compressionType: compressionType } = await fetchBuiltInCMap(name);
                    const cMap = new CMap(true);
                    if (compressionType === _util.CMapCompressionType.BINARY) return new _binary_cmap.BinaryCMapReader().process(cMapData, cMap, (useCMap)=>{
                        return extendCMap(cMap, fetchBuiltInCMap, useCMap);
                    });
                    if (compressionType === _util.CMapCompressionType.NONE) {
                        const lexer = new _parser.Lexer(new _stream.Stream(cMapData));
                        return parseCMap(cMap, lexer, fetchBuiltInCMap, null);
                    }
                    throw new Error(`Invalid CMap "compressionType" value: ${compressionType}`);
                }
                class CMapFactory {
                    static async create({ encoding: encoding, fetchBuiltInCMap: fetchBuiltInCMap, useCMap: useCMap }) {
                        if (encoding instanceof _primitives.Name) return createBuiltInCMap(encoding.name, fetchBuiltInCMap);
                        else if (encoding instanceof _base_stream.BaseStream) {
                            const parsedCMap = await parseCMap(new CMap(), new _parser.Lexer(encoding), fetchBuiltInCMap, useCMap);
                            if (parsedCMap.isIdentityCMap) return createBuiltInCMap(parsedCMap.name, fetchBuiltInCMap);
                            return parsedCMap;
                        }
                        throw new Error("Encoding required.");
                    }
                }
                exports.CMapFactory = CMapFactory;
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BinaryCMapReader = void 0;
                var _util = __w_pdfjs_require__(2);
                function hexToInt(a, size) {
                    let n = 0;
                    for(let i = 0; i <= size; i++)n = n << 8 | a[i];
                    return n >>> 0;
                }
                function hexToStr(a, size) {
                    if (size === 1) return String.fromCharCode(a[0], a[1]);
                    if (size === 3) return String.fromCharCode(a[0], a[1], a[2], a[3]);
                    return String.fromCharCode(...a.subarray(0, size + 1));
                }
                function addHex(a, b, size) {
                    let c = 0;
                    for(let i = size; i >= 0; i--){
                        c += a[i] + b[i];
                        a[i] = c & 255;
                        c >>= 8;
                    }
                }
                function incHex(a, size) {
                    let c = 1;
                    for(let i = size; i >= 0 && c > 0; i--){
                        c += a[i];
                        a[i] = c & 255;
                        c >>= 8;
                    }
                }
                const MAX_NUM_SIZE = 16;
                const MAX_ENCODED_NUM_SIZE = 19;
                class BinaryCMapStream {
                    constructor(data){
                        this.buffer = data;
                        this.pos = 0;
                        this.end = data.length;
                        this.tmpBuf = new Uint8Array(MAX_ENCODED_NUM_SIZE);
                    }
                    readByte() {
                        if (this.pos >= this.end) return -1;
                        return this.buffer[this.pos++];
                    }
                    readNumber() {
                        let n = 0;
                        let last;
                        do {
                            const b = this.readByte();
                            if (b < 0) throw new _util.FormatError("unexpected EOF in bcmap");
                            last = !(b & 0x80);
                            n = n << 7 | b & 0x7f;
                        }while (!last);
                        return n;
                    }
                    readSigned() {
                        const n = this.readNumber();
                        return n & 1 ? ~(n >>> 1) : n >>> 1;
                    }
                    readHex(num, size) {
                        num.set(this.buffer.subarray(this.pos, this.pos + size + 1));
                        this.pos += size + 1;
                    }
                    readHexNumber(num, size) {
                        let last;
                        const stack = this.tmpBuf;
                        let sp = 0;
                        do {
                            const b = this.readByte();
                            if (b < 0) throw new _util.FormatError("unexpected EOF in bcmap");
                            last = !(b & 0x80);
                            stack[sp++] = b & 0x7f;
                        }while (!last);
                        let i = size, buffer = 0, bufferSize = 0;
                        while(i >= 0){
                            while(bufferSize < 8 && stack.length > 0){
                                buffer |= stack[--sp] << bufferSize;
                                bufferSize += 7;
                            }
                            num[i] = buffer & 255;
                            i--;
                            buffer >>= 8;
                            bufferSize -= 8;
                        }
                    }
                    readHexSigned(num, size) {
                        this.readHexNumber(num, size);
                        const sign = num[size] & 1 ? 255 : 0;
                        let c = 0;
                        for(let i = 0; i <= size; i++){
                            c = (c & 1) << 8 | num[i];
                            num[i] = c >> 1 ^ sign;
                        }
                    }
                    readString() {
                        const len = this.readNumber(), buf = new Array(len);
                        for(let i = 0; i < len; i++)buf[i] = this.readNumber();
                        return String.fromCharCode(...buf);
                    }
                }
                class BinaryCMapReader {
                    async process(data, cMap, extend) {
                        const stream = new BinaryCMapStream(data);
                        const header = stream.readByte();
                        cMap.vertical = !!(header & 1);
                        let useCMap = null;
                        const start = new Uint8Array(MAX_NUM_SIZE);
                        const end = new Uint8Array(MAX_NUM_SIZE);
                        const char = new Uint8Array(MAX_NUM_SIZE);
                        const charCode = new Uint8Array(MAX_NUM_SIZE);
                        const tmp = new Uint8Array(MAX_NUM_SIZE);
                        let code;
                        let b;
                        while((b = stream.readByte()) >= 0){
                            const type = b >> 5;
                            if (type === 7) {
                                switch(b & 0x1f){
                                    case 0:
                                        stream.readString();
                                        break;
                                    case 1:
                                        useCMap = stream.readString();
                                        break;
                                }
                                continue;
                            }
                            const sequence = !!(b & 0x10);
                            const dataSize = b & 15;
                            if (dataSize + 1 > MAX_NUM_SIZE) throw new Error("BinaryCMapReader.process: Invalid dataSize.");
                            const ucs2DataSize = 1;
                            const subitemsCount = stream.readNumber();
                            switch(type){
                                case 0:
                                    stream.readHex(start, dataSize);
                                    stream.readHexNumber(end, dataSize);
                                    addHex(end, start, dataSize);
                                    cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(end, dataSize);
                                        stream.readHexNumber(start, dataSize);
                                        addHex(start, end, dataSize);
                                        stream.readHexNumber(end, dataSize);
                                        addHex(end, start, dataSize);
                                        cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
                                    }
                                    break;
                                case 1:
                                    stream.readHex(start, dataSize);
                                    stream.readHexNumber(end, dataSize);
                                    addHex(end, start, dataSize);
                                    stream.readNumber();
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(end, dataSize);
                                        stream.readHexNumber(start, dataSize);
                                        addHex(start, end, dataSize);
                                        stream.readHexNumber(end, dataSize);
                                        addHex(end, start, dataSize);
                                        stream.readNumber();
                                    }
                                    break;
                                case 2:
                                    stream.readHex(char, dataSize);
                                    code = stream.readNumber();
                                    cMap.mapOne(hexToInt(char, dataSize), code);
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(char, dataSize);
                                        if (!sequence) {
                                            stream.readHexNumber(tmp, dataSize);
                                            addHex(char, tmp, dataSize);
                                        }
                                        code = stream.readSigned() + (code + 1);
                                        cMap.mapOne(hexToInt(char, dataSize), code);
                                    }
                                    break;
                                case 3:
                                    stream.readHex(start, dataSize);
                                    stream.readHexNumber(end, dataSize);
                                    addHex(end, start, dataSize);
                                    code = stream.readNumber();
                                    cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(end, dataSize);
                                        if (!sequence) {
                                            stream.readHexNumber(start, dataSize);
                                            addHex(start, end, dataSize);
                                        } else start.set(end);
                                        stream.readHexNumber(end, dataSize);
                                        addHex(end, start, dataSize);
                                        code = stream.readNumber();
                                        cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
                                    }
                                    break;
                                case 4:
                                    stream.readHex(char, ucs2DataSize);
                                    stream.readHex(charCode, dataSize);
                                    cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(char, ucs2DataSize);
                                        if (!sequence) {
                                            stream.readHexNumber(tmp, ucs2DataSize);
                                            addHex(char, tmp, ucs2DataSize);
                                        }
                                        incHex(charCode, dataSize);
                                        stream.readHexSigned(tmp, dataSize);
                                        addHex(charCode, tmp, dataSize);
                                        cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
                                    }
                                    break;
                                case 5:
                                    stream.readHex(start, ucs2DataSize);
                                    stream.readHexNumber(end, ucs2DataSize);
                                    addHex(end, start, ucs2DataSize);
                                    stream.readHex(charCode, dataSize);
                                    cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
                                    for(let i = 1; i < subitemsCount; i++){
                                        incHex(end, ucs2DataSize);
                                        if (!sequence) {
                                            stream.readHexNumber(start, ucs2DataSize);
                                            addHex(start, end, ucs2DataSize);
                                        } else start.set(end);
                                        stream.readHexNumber(end, ucs2DataSize);
                                        addHex(end, start, ucs2DataSize);
                                        stream.readHex(charCode, dataSize);
                                        cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
                                    }
                                    break;
                                default:
                                    throw new Error(`BinaryCMapReader.process - unknown type: ${type}`);
                            }
                        }
                        if (useCMap) return extend(useCMap);
                        return cMap;
                    }
                }
                exports.BinaryCMapReader = BinaryCMapReader;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Parser = exports.Linearization = exports.Lexer = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                var _ascii_85_stream = __w_pdfjs_require__(17);
                var _ascii_hex_stream = __w_pdfjs_require__(19);
                var _ccitt_stream = __w_pdfjs_require__(20);
                var _flate_stream = __w_pdfjs_require__(22);
                var _jbig2_stream = __w_pdfjs_require__(23);
                var _jpeg_stream = __w_pdfjs_require__(26);
                var _jpx_stream = __w_pdfjs_require__(29);
                var _lzw_stream = __w_pdfjs_require__(31);
                var _predictor_stream = __w_pdfjs_require__(32);
                var _run_length_stream = __w_pdfjs_require__(33);
                const MAX_LENGTH_TO_CACHE = 1000;
                function getInlineImageCacheKey(bytes) {
                    const strBuf = [], ii = bytes.length;
                    let i = 0;
                    while(i < ii - 1)strBuf.push(bytes[i++] << 8 | bytes[i++]);
                    if (i < ii) strBuf.push(bytes[i]);
                    return ii + "_" + String.fromCharCode.apply(null, strBuf);
                }
                class Parser {
                    constructor({ lexer: lexer, xref: xref, allowStreams: allowStreams = false, recoveryMode: recoveryMode = false }){
                        this.lexer = lexer;
                        this.xref = xref;
                        this.allowStreams = allowStreams;
                        this.recoveryMode = recoveryMode;
                        this.imageCache = Object.create(null);
                        this._imageId = 0;
                        this.refill();
                    }
                    refill() {
                        this.buf1 = this.lexer.getObj();
                        this.buf2 = this.lexer.getObj();
                    }
                    shift() {
                        if (this.buf2 instanceof _primitives.Cmd && this.buf2.cmd === "ID") {
                            this.buf1 = this.buf2;
                            this.buf2 = null;
                        } else {
                            this.buf1 = this.buf2;
                            this.buf2 = this.lexer.getObj();
                        }
                    }
                    tryShift() {
                        try {
                            this.shift();
                            return true;
                        } catch (e) {
                            if (e instanceof _core_utils.MissingDataException) throw e;
                            return false;
                        }
                    }
                    getObj(cipherTransform = null) {
                        const buf1 = this.buf1;
                        this.shift();
                        if (buf1 instanceof _primitives.Cmd) switch(buf1.cmd){
                            case "BI":
                                return this.makeInlineImage(cipherTransform);
                            case "[":
                                const array = [];
                                while(!(0, _primitives.isCmd)(this.buf1, "]") && this.buf1 !== _primitives.EOF)array.push(this.getObj(cipherTransform));
                                if (this.buf1 === _primitives.EOF) {
                                    if (this.recoveryMode) return array;
                                    throw new _core_utils.ParserEOFException("End of file inside array.");
                                }
                                this.shift();
                                return array;
                            case "<<":
                                const dict = new _primitives.Dict(this.xref);
                                while(!(0, _primitives.isCmd)(this.buf1, ">>") && this.buf1 !== _primitives.EOF){
                                    if (!(this.buf1 instanceof _primitives.Name)) {
                                        (0, _util.info)("Malformed dictionary: key must be a name object");
                                        this.shift();
                                        continue;
                                    }
                                    const key = this.buf1.name;
                                    this.shift();
                                    if (this.buf1 === _primitives.EOF) break;
                                    dict.set(key, this.getObj(cipherTransform));
                                }
                                if (this.buf1 === _primitives.EOF) {
                                    if (this.recoveryMode) return dict;
                                    throw new _core_utils.ParserEOFException("End of file inside dictionary.");
                                }
                                if ((0, _primitives.isCmd)(this.buf2, "stream")) return this.allowStreams ? this.makeStream(dict, cipherTransform) : dict;
                                this.shift();
                                return dict;
                            default:
                                return buf1;
                        }
                        if (Number.isInteger(buf1)) {
                            if (Number.isInteger(this.buf1) && (0, _primitives.isCmd)(this.buf2, "R")) {
                                const ref = _primitives.Ref.get(buf1, this.buf1);
                                this.shift();
                                this.shift();
                                return ref;
                            }
                            return buf1;
                        }
                        if (typeof buf1 === "string") {
                            if (cipherTransform) return cipherTransform.decryptString(buf1);
                            return buf1;
                        }
                        return buf1;
                    }
                    findDefaultInlineStreamEnd(stream) {
                        const E = 0x45, I = 0x49, SPACE = 0x20, LF = 0xa, CR = 0xd, NUL = 0x0;
                        const { knownCommands: knownCommands } = this.lexer, startPos = stream.pos, n = 15;
                        let state = 0, ch, maybeEIPos;
                        while((ch = stream.getByte()) !== -1){
                            if (state === 0) state = ch === E ? 1 : 0;
                            else if (state === 1) state = ch === I ? 2 : 0;
                            else if (ch === SPACE || ch === LF || ch === CR) {
                                maybeEIPos = stream.pos;
                                const followingBytes = stream.peekBytes(n);
                                const ii = followingBytes.length;
                                if (ii === 0) break;
                                for(let i = 0; i < ii; i++){
                                    ch = followingBytes[i];
                                    if (ch === NUL && followingBytes[i + 1] !== NUL) continue;
                                    if (ch !== LF && ch !== CR && (ch < SPACE || ch > 0x7f)) {
                                        state = 0;
                                        break;
                                    }
                                }
                                if (state !== 2) continue;
                                if (!knownCommands) {
                                    (0, _util.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
                                    continue;
                                }
                                const tmpLexer = new Lexer(new _stream.Stream(followingBytes.slice()), knownCommands);
                                tmpLexer._hexStringWarn = ()=>{};
                                let numArgs = 0;
                                while(true){
                                    const nextObj = tmpLexer.getObj();
                                    if (nextObj === _primitives.EOF) {
                                        state = 0;
                                        break;
                                    }
                                    if (nextObj instanceof _primitives.Cmd) {
                                        const knownCommand = knownCommands[nextObj.cmd];
                                        if (!knownCommand) {
                                            state = 0;
                                            break;
                                        } else if (knownCommand.variableArgs ? numArgs <= knownCommand.numArgs : numArgs === knownCommand.numArgs) break;
                                        numArgs = 0;
                                        continue;
                                    }
                                    numArgs++;
                                }
                                if (state === 2) break;
                            } else state = 0;
                        }
                        if (ch === -1) {
                            (0, _util.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker");
                            if (maybeEIPos) {
                                (0, _util.warn)('... trying to recover by using the last "EI" occurrence.');
                                stream.skip(-(stream.pos - maybeEIPos));
                            }
                        }
                        let endOffset = 4;
                        stream.skip(-endOffset);
                        ch = stream.peekByte();
                        stream.skip(endOffset);
                        if (!(0, _core_utils.isWhiteSpace)(ch)) endOffset--;
                        return stream.pos - endOffset - startPos;
                    }
                    findDCTDecodeInlineStreamEnd(stream) {
                        const startPos = stream.pos;
                        let foundEOI = false, b, markerLength;
                        while((b = stream.getByte()) !== -1){
                            if (b !== 0xff) continue;
                            switch(stream.getByte()){
                                case 0x00:
                                    break;
                                case 0xff:
                                    stream.skip(-1);
                                    break;
                                case 0xd9:
                                    foundEOI = true;
                                    break;
                                case 0xc0:
                                case 0xc1:
                                case 0xc2:
                                case 0xc3:
                                case 0xc5:
                                case 0xc6:
                                case 0xc7:
                                case 0xc9:
                                case 0xca:
                                case 0xcb:
                                case 0xcd:
                                case 0xce:
                                case 0xcf:
                                case 0xc4:
                                case 0xcc:
                                case 0xda:
                                case 0xdb:
                                case 0xdc:
                                case 0xdd:
                                case 0xde:
                                case 0xdf:
                                case 0xe0:
                                case 0xe1:
                                case 0xe2:
                                case 0xe3:
                                case 0xe4:
                                case 0xe5:
                                case 0xe6:
                                case 0xe7:
                                case 0xe8:
                                case 0xe9:
                                case 0xea:
                                case 0xeb:
                                case 0xec:
                                case 0xed:
                                case 0xee:
                                case 0xef:
                                case 0xfe:
                                    markerLength = stream.getUint16();
                                    if (markerLength > 2) stream.skip(markerLength - 2);
                                    else stream.skip(-2);
                                    break;
                            }
                            if (foundEOI) break;
                        }
                        const length = stream.pos - startPos;
                        if (b === -1) {
                            (0, _util.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead.");
                            stream.skip(-length);
                            return this.findDefaultInlineStreamEnd(stream);
                        }
                        this.inlineStreamSkipEI(stream);
                        return length;
                    }
                    findASCII85DecodeInlineStreamEnd(stream) {
                        const TILDE = 0x7e, GT = 0x3e;
                        const startPos = stream.pos;
                        let ch;
                        while((ch = stream.getByte()) !== -1)if (ch === TILDE) {
                            const tildePos = stream.pos;
                            ch = stream.peekByte();
                            while((0, _core_utils.isWhiteSpace)(ch)){
                                stream.skip();
                                ch = stream.peekByte();
                            }
                            if (ch === GT) {
                                stream.skip();
                                break;
                            }
                            if (stream.pos > tildePos) {
                                const maybeEI = stream.peekBytes(2);
                                if (maybeEI[0] === 0x45 && maybeEI[1] === 0x49) break;
                            }
                        }
                        const length = stream.pos - startPos;
                        if (ch === -1) {
                            (0, _util.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead.");
                            stream.skip(-length);
                            return this.findDefaultInlineStreamEnd(stream);
                        }
                        this.inlineStreamSkipEI(stream);
                        return length;
                    }
                    findASCIIHexDecodeInlineStreamEnd(stream) {
                        const GT = 0x3e;
                        const startPos = stream.pos;
                        let ch;
                        while((ch = stream.getByte()) !== -1){
                            if (ch === GT) break;
                        }
                        const length = stream.pos - startPos;
                        if (ch === -1) {
                            (0, _util.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead.");
                            stream.skip(-length);
                            return this.findDefaultInlineStreamEnd(stream);
                        }
                        this.inlineStreamSkipEI(stream);
                        return length;
                    }
                    inlineStreamSkipEI(stream) {
                        const E = 0x45, I = 0x49;
                        let state = 0, ch;
                        while((ch = stream.getByte()) !== -1){
                            if (state === 0) state = ch === E ? 1 : 0;
                            else if (state === 1) state = ch === I ? 2 : 0;
                            else if (state === 2) break;
                        }
                    }
                    makeInlineImage(cipherTransform) {
                        const lexer = this.lexer;
                        const stream = lexer.stream;
                        const dictMap = Object.create(null);
                        let dictLength;
                        while(!(0, _primitives.isCmd)(this.buf1, "ID") && this.buf1 !== _primitives.EOF){
                            if (!(this.buf1 instanceof _primitives.Name)) throw new _util.FormatError("Dictionary key must be a name object");
                            const key = this.buf1.name;
                            this.shift();
                            if (this.buf1 === _primitives.EOF) break;
                            dictMap[key] = this.getObj(cipherTransform);
                        }
                        if (lexer.beginInlineImagePos !== -1) dictLength = stream.pos - lexer.beginInlineImagePos;
                        const filter = this.xref.fetchIfRef(dictMap.F || dictMap.Filter);
                        let filterName;
                        if (filter instanceof _primitives.Name) filterName = filter.name;
                        else if (Array.isArray(filter)) {
                            const filterZero = this.xref.fetchIfRef(filter[0]);
                            if (filterZero instanceof _primitives.Name) filterName = filterZero.name;
                        }
                        const startPos = stream.pos;
                        let length;
                        switch(filterName){
                            case "DCT":
                            case "DCTDecode":
                                length = this.findDCTDecodeInlineStreamEnd(stream);
                                break;
                            case "A85":
                            case "ASCII85Decode":
                                length = this.findASCII85DecodeInlineStreamEnd(stream);
                                break;
                            case "AHx":
                            case "ASCIIHexDecode":
                                length = this.findASCIIHexDecodeInlineStreamEnd(stream);
                                break;
                            default:
                                length = this.findDefaultInlineStreamEnd(stream);
                        }
                        let cacheKey;
                        if (length < MAX_LENGTH_TO_CACHE && dictLength > 0) {
                            const initialStreamPos = stream.pos;
                            stream.pos = lexer.beginInlineImagePos;
                            cacheKey = getInlineImageCacheKey(stream.getBytes(dictLength + length));
                            stream.pos = initialStreamPos;
                            const cacheEntry = this.imageCache[cacheKey];
                            if (cacheEntry !== undefined) {
                                this.buf2 = _primitives.Cmd.get("EI");
                                this.shift();
                                cacheEntry.reset();
                                return cacheEntry;
                            }
                        }
                        const dict = new _primitives.Dict(this.xref);
                        for(const key in dictMap)dict.set(key, dictMap[key]);
                        let imageStream = stream.makeSubStream(startPos, length, dict);
                        if (cipherTransform) imageStream = cipherTransform.createStream(imageStream, length);
                        imageStream = this.filter(imageStream, dict, length);
                        imageStream.dict = dict;
                        if (cacheKey !== undefined) {
                            imageStream.cacheKey = `inline_img_${++this._imageId}`;
                            this.imageCache[cacheKey] = imageStream;
                        }
                        this.buf2 = _primitives.Cmd.get("EI");
                        this.shift();
                        return imageStream;
                    }
                    _findStreamLength(startPos, signature) {
                        const { stream: stream } = this.lexer;
                        stream.pos = startPos;
                        const SCAN_BLOCK_LENGTH = 2048;
                        const signatureLength = signature.length;
                        while(stream.pos < stream.end){
                            const scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
                            const scanLength = scanBytes.length - signatureLength;
                            if (scanLength <= 0) break;
                            let pos = 0;
                            while(pos < scanLength){
                                let j = 0;
                                while(j < signatureLength && scanBytes[pos + j] === signature[j])j++;
                                if (j >= signatureLength) {
                                    stream.pos += pos;
                                    return stream.pos - startPos;
                                }
                                pos++;
                            }
                            stream.pos += scanLength;
                        }
                        return -1;
                    }
                    makeStream(dict, cipherTransform) {
                        const lexer = this.lexer;
                        let stream = lexer.stream;
                        lexer.skipToNextLine();
                        const startPos = stream.pos - 1;
                        let length = dict.get("Length");
                        if (!Number.isInteger(length)) {
                            (0, _util.info)(`Bad length "${length && length.toString()}" in stream.`);
                            length = 0;
                        }
                        stream.pos = startPos + length;
                        lexer.nextChar();
                        if (this.tryShift() && (0, _primitives.isCmd)(this.buf2, "endstream")) this.shift();
                        else {
                            const ENDSTREAM_SIGNATURE = new Uint8Array([
                                0x65,
                                0x6e,
                                0x64,
                                0x73,
                                0x74,
                                0x72,
                                0x65,
                                0x61,
                                0x6d
                            ]);
                            let actualLength = this._findStreamLength(startPos, ENDSTREAM_SIGNATURE);
                            if (actualLength < 0) {
                                const MAX_TRUNCATION = 1;
                                for(let i = 1; i <= MAX_TRUNCATION; i++){
                                    const end = ENDSTREAM_SIGNATURE.length - i;
                                    const TRUNCATED_SIGNATURE = ENDSTREAM_SIGNATURE.slice(0, end);
                                    const maybeLength = this._findStreamLength(startPos, TRUNCATED_SIGNATURE);
                                    if (maybeLength >= 0) {
                                        const lastByte = stream.peekBytes(end + 1)[end];
                                        if (!(0, _core_utils.isWhiteSpace)(lastByte)) break;
                                        (0, _util.info)(`Found "${(0, _util.bytesToString)(TRUNCATED_SIGNATURE)}" when ` + "searching for endstream command.");
                                        actualLength = maybeLength;
                                        break;
                                    }
                                }
                                if (actualLength < 0) throw new _util.FormatError("Missing endstream command.");
                            }
                            length = actualLength;
                            lexer.nextChar();
                            this.shift();
                            this.shift();
                        }
                        this.shift();
                        stream = stream.makeSubStream(startPos, length, dict);
                        if (cipherTransform) stream = cipherTransform.createStream(stream, length);
                        stream = this.filter(stream, dict, length);
                        stream.dict = dict;
                        return stream;
                    }
                    filter(stream, dict, length) {
                        let filter = dict.get("F", "Filter");
                        let params = dict.get("DP", "DecodeParms");
                        if (filter instanceof _primitives.Name) {
                            if (Array.isArray(params)) (0, _util.warn)("/DecodeParms should not be an Array, when /Filter is a Name.");
                            return this.makeFilter(stream, filter.name, length, params);
                        }
                        let maybeLength = length;
                        if (Array.isArray(filter)) {
                            const filterArray = filter;
                            const paramsArray = params;
                            for(let i = 0, ii = filterArray.length; i < ii; ++i){
                                filter = this.xref.fetchIfRef(filterArray[i]);
                                if (!(filter instanceof _primitives.Name)) throw new _util.FormatError(`Bad filter name "${filter}"`);
                                params = null;
                                if (Array.isArray(paramsArray) && i in paramsArray) params = this.xref.fetchIfRef(paramsArray[i]);
                                stream = this.makeFilter(stream, filter.name, maybeLength, params);
                                maybeLength = null;
                            }
                        }
                        return stream;
                    }
                    makeFilter(stream, name, maybeLength, params) {
                        if (maybeLength === 0) {
                            (0, _util.warn)(`Empty "${name}" stream.`);
                            return new _stream.NullStream();
                        }
                        try {
                            switch(name){
                                case "Fl":
                                case "FlateDecode":
                                    if (params) return new _predictor_stream.PredictorStream(new _flate_stream.FlateStream(stream, maybeLength), maybeLength, params);
                                    return new _flate_stream.FlateStream(stream, maybeLength);
                                case "LZW":
                                case "LZWDecode":
                                    let earlyChange = 1;
                                    if (params) {
                                        if (params.has("EarlyChange")) earlyChange = params.get("EarlyChange");
                                        return new _predictor_stream.PredictorStream(new _lzw_stream.LZWStream(stream, maybeLength, earlyChange), maybeLength, params);
                                    }
                                    return new _lzw_stream.LZWStream(stream, maybeLength, earlyChange);
                                case "DCT":
                                case "DCTDecode":
                                    return new _jpeg_stream.JpegStream(stream, maybeLength, params);
                                case "JPX":
                                case "JPXDecode":
                                    return new _jpx_stream.JpxStream(stream, maybeLength, params);
                                case "A85":
                                case "ASCII85Decode":
                                    return new _ascii_85_stream.Ascii85Stream(stream, maybeLength);
                                case "AHx":
                                case "ASCIIHexDecode":
                                    return new _ascii_hex_stream.AsciiHexStream(stream, maybeLength);
                                case "CCF":
                                case "CCITTFaxDecode":
                                    return new _ccitt_stream.CCITTFaxStream(stream, maybeLength, params);
                                case "RL":
                                case "RunLengthDecode":
                                    return new _run_length_stream.RunLengthStream(stream, maybeLength);
                                case "JBIG2Decode":
                                    return new _jbig2_stream.Jbig2Stream(stream, maybeLength, params);
                            }
                            (0, _util.warn)(`Filter "${name}" is not supported.`);
                            return stream;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`Invalid stream: "${ex}"`);
                            return new _stream.NullStream();
                        }
                    }
                }
                exports.Parser = Parser;
                const specialChars = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                function toHexDigit(ch) {
                    if (ch >= 0x30 && ch <= 0x39) return ch & 0x0f;
                    if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) return (ch & 0x0f) + 9;
                    return -1;
                }
                class Lexer {
                    constructor(stream, knownCommands = null){
                        this.stream = stream;
                        this.nextChar();
                        this.strBuf = [];
                        this.knownCommands = knownCommands;
                        this._hexStringNumWarn = 0;
                        this.beginInlineImagePos = -1;
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    peekChar() {
                        return this.stream.peekByte();
                    }
                    getNumber() {
                        let ch = this.currentChar;
                        let eNotation = false;
                        let divideBy = 0;
                        let sign = 1;
                        if (ch === 0x2d) {
                            sign = -1;
                            ch = this.nextChar();
                            if (ch === 0x2d) ch = this.nextChar();
                        } else if (ch === 0x2b) ch = this.nextChar();
                        if (ch === 0x0a || ch === 0x0d) do ch = this.nextChar();
                        while (ch === 0x0a || ch === 0x0d);
                        if (ch === 0x2e) {
                            divideBy = 10;
                            ch = this.nextChar();
                        }
                        if (ch < 0x30 || ch > 0x39) {
                            const msg = `Invalid number: ${String.fromCharCode(ch)} (charCode ${ch})`;
                            if ((0, _core_utils.isWhiteSpace)(ch) || ch === -1) {
                                (0, _util.info)(`Lexer.getNumber - "${msg}".`);
                                return 0;
                            }
                            throw new _util.FormatError(msg);
                        }
                        let baseValue = ch - 0x30;
                        let powerValue = 0;
                        let powerValueSign = 1;
                        while((ch = this.nextChar()) >= 0){
                            if (ch >= 0x30 && ch <= 0x39) {
                                const currentDigit = ch - 0x30;
                                if (eNotation) powerValue = powerValue * 10 + currentDigit;
                                else {
                                    if (divideBy !== 0) divideBy *= 10;
                                    baseValue = baseValue * 10 + currentDigit;
                                }
                            } else if (ch === 0x2e) {
                                if (divideBy === 0) divideBy = 1;
                                else break;
                            } else if (ch === 0x2d) (0, _util.warn)("Badly formatted number: minus sign in the middle");
                            else if (ch === 0x45 || ch === 0x65) {
                                ch = this.peekChar();
                                if (ch === 0x2b || ch === 0x2d) {
                                    powerValueSign = ch === 0x2d ? -1 : 1;
                                    this.nextChar();
                                } else if (ch < 0x30 || ch > 0x39) break;
                                eNotation = true;
                            } else break;
                        }
                        if (divideBy !== 0) baseValue /= divideBy;
                        if (eNotation) baseValue *= 10 ** (powerValueSign * powerValue);
                        return sign * baseValue;
                    }
                    getString() {
                        let numParen = 1;
                        let done = false;
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        let ch = this.nextChar();
                        while(true){
                            let charBuffered = false;
                            switch(ch | 0){
                                case -1:
                                    (0, _util.warn)("Unterminated string");
                                    done = true;
                                    break;
                                case 0x28:
                                    ++numParen;
                                    strBuf.push("(");
                                    break;
                                case 0x29:
                                    if (--numParen === 0) {
                                        this.nextChar();
                                        done = true;
                                    } else strBuf.push(")");
                                    break;
                                case 0x5c:
                                    ch = this.nextChar();
                                    switch(ch){
                                        case -1:
                                            (0, _util.warn)("Unterminated string");
                                            done = true;
                                            break;
                                        case 0x6e:
                                            strBuf.push("\n");
                                            break;
                                        case 0x72:
                                            strBuf.push("\r");
                                            break;
                                        case 0x74:
                                            strBuf.push("	");
                                            break;
                                        case 0x62:
                                            strBuf.push("\b");
                                            break;
                                        case 0x66:
                                            strBuf.push("\f");
                                            break;
                                        case 0x5c:
                                        case 0x28:
                                        case 0x29:
                                            strBuf.push(String.fromCharCode(ch));
                                            break;
                                        case 0x30:
                                        case 0x31:
                                        case 0x32:
                                        case 0x33:
                                        case 0x34:
                                        case 0x35:
                                        case 0x36:
                                        case 0x37:
                                            let x = ch & 0x0f;
                                            ch = this.nextChar();
                                            charBuffered = true;
                                            if (ch >= 0x30 && ch <= 0x37) {
                                                x = (x << 3) + (ch & 0x0f);
                                                ch = this.nextChar();
                                                if (ch >= 0x30 && ch <= 0x37) {
                                                    charBuffered = false;
                                                    x = (x << 3) + (ch & 0x0f);
                                                }
                                            }
                                            strBuf.push(String.fromCharCode(x));
                                            break;
                                        case 0x0d:
                                            if (this.peekChar() === 0x0a) this.nextChar();
                                            break;
                                        case 0x0a:
                                            break;
                                        default:
                                            strBuf.push(String.fromCharCode(ch));
                                            break;
                                    }
                                    break;
                                default:
                                    strBuf.push(String.fromCharCode(ch));
                                    break;
                            }
                            if (done) break;
                            if (!charBuffered) ch = this.nextChar();
                        }
                        return strBuf.join("");
                    }
                    getName() {
                        let ch, previousCh;
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        while((ch = this.nextChar()) >= 0 && !specialChars[ch])if (ch === 0x23) {
                            ch = this.nextChar();
                            if (specialChars[ch]) {
                                (0, _util.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number.");
                                strBuf.push("#");
                                break;
                            }
                            const x = toHexDigit(ch);
                            if (x !== -1) {
                                previousCh = ch;
                                ch = this.nextChar();
                                const x2 = toHexDigit(ch);
                                if (x2 === -1) {
                                    (0, _util.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(ch)}) ` + "in hexadecimal number.");
                                    strBuf.push("#", String.fromCharCode(previousCh));
                                    if (specialChars[ch]) break;
                                    strBuf.push(String.fromCharCode(ch));
                                    continue;
                                }
                                strBuf.push(String.fromCharCode(x << 4 | x2));
                            } else strBuf.push("#", String.fromCharCode(ch));
                        } else strBuf.push(String.fromCharCode(ch));
                        if (strBuf.length > 127) (0, _util.warn)(`Name token is longer than allowed by the spec: ${strBuf.length}`);
                        return _primitives.Name.get(strBuf.join(""));
                    }
                    _hexStringWarn(ch) {
                        const MAX_HEX_STRING_NUM_WARN = 5;
                        if (this._hexStringNumWarn++ === MAX_HEX_STRING_NUM_WARN) {
                            (0, _util.warn)("getHexString - ignoring additional invalid characters.");
                            return;
                        }
                        if (this._hexStringNumWarn > MAX_HEX_STRING_NUM_WARN) return;
                        (0, _util.warn)(`getHexString - ignoring invalid character: ${ch}`);
                    }
                    getHexString() {
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        let ch = this.currentChar;
                        let isFirstHex = true;
                        let firstDigit, secondDigit;
                        this._hexStringNumWarn = 0;
                        while(true){
                            if (ch < 0) {
                                (0, _util.warn)("Unterminated hex string");
                                break;
                            } else if (ch === 0x3e) {
                                this.nextChar();
                                break;
                            } else if (specialChars[ch] === 1) {
                                ch = this.nextChar();
                                continue;
                            } else {
                                if (isFirstHex) {
                                    firstDigit = toHexDigit(ch);
                                    if (firstDigit === -1) {
                                        this._hexStringWarn(ch);
                                        ch = this.nextChar();
                                        continue;
                                    }
                                } else {
                                    secondDigit = toHexDigit(ch);
                                    if (secondDigit === -1) {
                                        this._hexStringWarn(ch);
                                        ch = this.nextChar();
                                        continue;
                                    }
                                    strBuf.push(String.fromCharCode(firstDigit << 4 | secondDigit));
                                }
                                isFirstHex = !isFirstHex;
                                ch = this.nextChar();
                            }
                        }
                        return strBuf.join("");
                    }
                    getObj() {
                        let comment = false;
                        let ch = this.currentChar;
                        while(true){
                            if (ch < 0) return _primitives.EOF;
                            if (comment) {
                                if (ch === 0x0a || ch === 0x0d) comment = false;
                            } else if (ch === 0x25) comment = true;
                            else if (specialChars[ch] !== 1) break;
                            ch = this.nextChar();
                        }
                        switch(ch | 0){
                            case 0x30:
                            case 0x31:
                            case 0x32:
                            case 0x33:
                            case 0x34:
                            case 0x35:
                            case 0x36:
                            case 0x37:
                            case 0x38:
                            case 0x39:
                            case 0x2b:
                            case 0x2d:
                            case 0x2e:
                                return this.getNumber();
                            case 0x28:
                                return this.getString();
                            case 0x2f:
                                return this.getName();
                            case 0x5b:
                                this.nextChar();
                                return _primitives.Cmd.get("[");
                            case 0x5d:
                                this.nextChar();
                                return _primitives.Cmd.get("]");
                            case 0x3c:
                                ch = this.nextChar();
                                if (ch === 0x3c) {
                                    this.nextChar();
                                    return _primitives.Cmd.get("<<");
                                }
                                return this.getHexString();
                            case 0x3e:
                                ch = this.nextChar();
                                if (ch === 0x3e) {
                                    this.nextChar();
                                    return _primitives.Cmd.get(">>");
                                }
                                return _primitives.Cmd.get(">");
                            case 0x7b:
                                this.nextChar();
                                return _primitives.Cmd.get("{");
                            case 0x7d:
                                this.nextChar();
                                return _primitives.Cmd.get("}");
                            case 0x29:
                                this.nextChar();
                                throw new _util.FormatError(`Illegal character: ${ch}`);
                        }
                        let str = String.fromCharCode(ch);
                        if (ch < 0x20 || ch > 0x7f) {
                            const nextCh = this.peekChar();
                            if (nextCh >= 0x20 && nextCh <= 0x7f) {
                                this.nextChar();
                                return _primitives.Cmd.get(str);
                            }
                        }
                        const knownCommands = this.knownCommands;
                        let knownCommandFound = knownCommands?.[str] !== undefined;
                        while((ch = this.nextChar()) >= 0 && !specialChars[ch]){
                            const possibleCommand = str + String.fromCharCode(ch);
                            if (knownCommandFound && knownCommands[possibleCommand] === undefined) break;
                            if (str.length === 128) throw new _util.FormatError(`Command token too long: ${str.length}`);
                            str = possibleCommand;
                            knownCommandFound = knownCommands?.[str] !== undefined;
                        }
                        if (str === "true") return true;
                        if (str === "false") return false;
                        if (str === "null") return null;
                        if (str === "BI") this.beginInlineImagePos = this.stream.pos;
                        return _primitives.Cmd.get(str);
                    }
                    skipToNextLine() {
                        let ch = this.currentChar;
                        while(ch >= 0){
                            if (ch === 0x0d) {
                                ch = this.nextChar();
                                if (ch === 0x0a) this.nextChar();
                                break;
                            } else if (ch === 0x0a) {
                                this.nextChar();
                                break;
                            }
                            ch = this.nextChar();
                        }
                    }
                }
                exports.Lexer = Lexer;
                class Linearization {
                    static create(stream) {
                        function getInt(linDict, name, allowZeroValue = false) {
                            const obj = linDict.get(name);
                            if (Number.isInteger(obj) && (allowZeroValue ? obj >= 0 : obj > 0)) return obj;
                            throw new Error(`The "${name}" parameter in the linearization ` + "dictionary is invalid.");
                        }
                        function getHints(linDict) {
                            const hints = linDict.get("H");
                            let hintsLength;
                            if (Array.isArray(hints) && ((hintsLength = hints.length) === 2 || hintsLength === 4)) {
                                for(let index = 0; index < hintsLength; index++){
                                    const hint = hints[index];
                                    if (!(Number.isInteger(hint) && hint > 0)) throw new Error(`Hint (${index}) in the linearization dictionary is invalid.`);
                                }
                                return hints;
                            }
                            throw new Error("Hint array in the linearization dictionary is invalid.");
                        }
                        const parser = new Parser({
                            lexer: new Lexer(stream),
                            xref: null
                        });
                        const obj1 = parser.getObj();
                        const obj2 = parser.getObj();
                        const obj3 = parser.getObj();
                        const linDict = parser.getObj();
                        let obj, length;
                        if (!(Number.isInteger(obj1) && Number.isInteger(obj2) && (0, _primitives.isCmd)(obj3, "obj") && linDict instanceof _primitives.Dict && typeof (obj = linDict.get("Linearized")) === "number" && obj > 0)) return null;
                        else if ((length = getInt(linDict, "L")) !== stream.length) throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
                        return {
                            length: length,
                            hints: getHints(linDict),
                            objectNumberFirst: getInt(linDict, "O"),
                            endFirst: getInt(linDict, "E"),
                            numPages: getInt(linDict, "N"),
                            mainXRefEntriesOffset: getInt(linDict, "T"),
                            pageFirst: linDict.has("P") ? getInt(linDict, "P", true) : 0
                        };
                    }
                }
                exports.Linearization = Linearization;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Ascii85Stream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _core_utils = __w_pdfjs_require__(3);
                class Ascii85Stream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        if (maybeLength) maybeLength *= 0.8;
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.input = new Uint8Array(5);
                    }
                    readBlock() {
                        const TILDA_CHAR = 0x7e;
                        const Z_LOWER_CHAR = 0x7a;
                        const EOF = -1;
                        const str = this.str;
                        let c = str.getByte();
                        while((0, _core_utils.isWhiteSpace)(c))c = str.getByte();
                        if (c === EOF || c === TILDA_CHAR) {
                            this.eof = true;
                            return;
                        }
                        const bufferLength = this.bufferLength;
                        let buffer, i;
                        if (c === Z_LOWER_CHAR) {
                            buffer = this.ensureBuffer(bufferLength + 4);
                            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
                            this.bufferLength += 4;
                        } else {
                            const input = this.input;
                            input[0] = c;
                            for(i = 1; i < 5; ++i){
                                c = str.getByte();
                                while((0, _core_utils.isWhiteSpace)(c))c = str.getByte();
                                input[i] = c;
                                if (c === EOF || c === TILDA_CHAR) break;
                            }
                            buffer = this.ensureBuffer(bufferLength + i - 1);
                            this.bufferLength += i - 1;
                            if (i < 5) {
                                for(; i < 5; ++i)input[i] = 117;
                                this.eof = true;
                            }
                            let t = 0;
                            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
                            for(i = 3; i >= 0; --i){
                                buffer[bufferLength + i] = t & 0xff;
                                t >>= 8;
                            }
                        }
                    }
                }
                exports.Ascii85Stream = Ascii85Stream;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamsSequenceStream = exports.DecodeStream = void 0;
                var _base_stream = __w_pdfjs_require__(5);
                var _stream = __w_pdfjs_require__(8);
                const emptyBuffer = new Uint8Array(0);
                class DecodeStream extends _base_stream.BaseStream {
                    constructor(maybeMinBufferLength){
                        super();
                        this._rawMinBufferLength = maybeMinBufferLength || 0;
                        this.pos = 0;
                        this.bufferLength = 0;
                        this.eof = false;
                        this.buffer = emptyBuffer;
                        this.minBufferLength = 512;
                        if (maybeMinBufferLength) while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
                    }
                    get isEmpty() {
                        while(!this.eof && this.bufferLength === 0)this.readBlock();
                        return this.bufferLength === 0;
                    }
                    ensureBuffer(requested) {
                        const buffer = this.buffer;
                        if (requested <= buffer.byteLength) return buffer;
                        let size = this.minBufferLength;
                        while(size < requested)size *= 2;
                        const buffer2 = new Uint8Array(size);
                        buffer2.set(buffer);
                        return this.buffer = buffer2;
                    }
                    getByte() {
                        const pos = this.pos;
                        while(this.bufferLength <= pos){
                            if (this.eof) return -1;
                            this.readBlock();
                        }
                        return this.buffer[this.pos++];
                    }
                    getBytes(length) {
                        const pos = this.pos;
                        let end;
                        if (length) {
                            this.ensureBuffer(pos + length);
                            end = pos + length;
                            while(!this.eof && this.bufferLength < end)this.readBlock();
                            const bufEnd = this.bufferLength;
                            if (end > bufEnd) end = bufEnd;
                        } else {
                            while(!this.eof)this.readBlock();
                            end = this.bufferLength;
                        }
                        this.pos = end;
                        return this.buffer.subarray(pos, end);
                    }
                    reset() {
                        this.pos = 0;
                    }
                    makeSubStream(start, length, dict = null) {
                        if (length === undefined) while(!this.eof)this.readBlock();
                        else {
                            const end = start + length;
                            while(this.bufferLength <= end && !this.eof)this.readBlock();
                        }
                        return new _stream.Stream(this.buffer, start, length, dict);
                    }
                    getBaseStreams() {
                        return this.str ? this.str.getBaseStreams() : null;
                    }
                }
                exports.DecodeStream = DecodeStream;
                class StreamsSequenceStream extends DecodeStream {
                    constructor(streams, onError = null){
                        let maybeLength = 0;
                        for (const stream of streams)maybeLength += stream instanceof DecodeStream ? stream._rawMinBufferLength : stream.length;
                        super(maybeLength);
                        this.streams = streams;
                        this._onError = onError;
                    }
                    readBlock() {
                        const streams = this.streams;
                        if (streams.length === 0) {
                            this.eof = true;
                            return;
                        }
                        const stream = streams.shift();
                        let chunk;
                        try {
                            chunk = stream.getBytes();
                        } catch (reason) {
                            if (this._onError) {
                                this._onError(reason, stream.dict?.objId);
                                return;
                            }
                            throw reason;
                        }
                        const bufferLength = this.bufferLength;
                        const newLength = bufferLength + chunk.length;
                        const buffer = this.ensureBuffer(newLength);
                        buffer.set(chunk, bufferLength);
                        this.bufferLength = newLength;
                    }
                    getBaseStreams() {
                        const baseStreamsBuf = [];
                        for (const stream of this.streams){
                            const baseStreams = stream.getBaseStreams();
                            if (baseStreams) baseStreamsBuf.push(...baseStreams);
                        }
                        return baseStreamsBuf.length > 0 ? baseStreamsBuf : null;
                    }
                }
                exports.StreamsSequenceStream = StreamsSequenceStream;
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AsciiHexStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                class AsciiHexStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        if (maybeLength) maybeLength *= 0.5;
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.firstDigit = -1;
                    }
                    readBlock() {
                        const UPSTREAM_BLOCK_SIZE = 8000;
                        const bytes = this.str.getBytes(UPSTREAM_BLOCK_SIZE);
                        if (!bytes.length) {
                            this.eof = true;
                            return;
                        }
                        const maxDecodeLength = bytes.length + 1 >> 1;
                        const buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
                        let bufferLength = this.bufferLength;
                        let firstDigit = this.firstDigit;
                        for (const ch of bytes){
                            let digit;
                            if (ch >= 0x30 && ch <= 0x39) digit = ch & 0x0f;
                            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) digit = (ch & 0x0f) + 9;
                            else if (ch === 0x3e) {
                                this.eof = true;
                                break;
                            } else continue;
                            if (firstDigit < 0) firstDigit = digit;
                            else {
                                buffer[bufferLength++] = firstDigit << 4 | digit;
                                firstDigit = -1;
                            }
                        }
                        if (firstDigit >= 0 && this.eof) {
                            buffer[bufferLength++] = firstDigit << 4;
                            firstDigit = -1;
                        }
                        this.firstDigit = firstDigit;
                        this.bufferLength = bufferLength;
                    }
                }
                exports.AsciiHexStream = AsciiHexStream;
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CCITTFaxStream = void 0;
                var _ccitt = __w_pdfjs_require__(21);
                var _decode_stream = __w_pdfjs_require__(18);
                var _primitives = __w_pdfjs_require__(4);
                class CCITTFaxStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, params){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        if (!(params instanceof _primitives.Dict)) params = _primitives.Dict.empty;
                        const source = {
                            next () {
                                return str.getByte();
                            }
                        };
                        this.ccittFaxDecoder = new _ccitt.CCITTFaxDecoder(source, {
                            K: params.get("K"),
                            EndOfLine: params.get("EndOfLine"),
                            EncodedByteAlign: params.get("EncodedByteAlign"),
                            Columns: params.get("Columns"),
                            Rows: params.get("Rows"),
                            EndOfBlock: params.get("EndOfBlock"),
                            BlackIs1: params.get("BlackIs1")
                        });
                    }
                    readBlock() {
                        while(!this.eof){
                            const c = this.ccittFaxDecoder.readNextChar();
                            if (c === -1) {
                                this.eof = true;
                                return;
                            }
                            this.ensureBuffer(this.bufferLength + 1);
                            this.buffer[this.bufferLength++] = c;
                        }
                    }
                }
                exports.CCITTFaxStream = CCITTFaxStream;
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CCITTFaxDecoder = void 0;
                var _util = __w_pdfjs_require__(2);
                const ccittEOL = -2;
                const ccittEOF = -1;
                const twoDimPass = 0;
                const twoDimHoriz = 1;
                const twoDimVert0 = 2;
                const twoDimVertR1 = 3;
                const twoDimVertL1 = 4;
                const twoDimVertR2 = 5;
                const twoDimVertL2 = 6;
                const twoDimVertR3 = 7;
                const twoDimVertL3 = 8;
                const twoDimTable = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        7,
                        twoDimVertL3
                    ],
                    [
                        7,
                        twoDimVertR3
                    ],
                    [
                        6,
                        twoDimVertL2
                    ],
                    [
                        6,
                        twoDimVertL2
                    ],
                    [
                        6,
                        twoDimVertR2
                    ],
                    [
                        6,
                        twoDimVertR2
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ]
                ];
                const whiteTable1 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        12,
                        ccittEOL
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2560
                    ]
                ];
                const whiteTable2 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        8,
                        29
                    ],
                    [
                        8,
                        29
                    ],
                    [
                        8,
                        30
                    ],
                    [
                        8,
                        30
                    ],
                    [
                        8,
                        45
                    ],
                    [
                        8,
                        45
                    ],
                    [
                        8,
                        46
                    ],
                    [
                        8,
                        46
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        8,
                        47
                    ],
                    [
                        8,
                        47
                    ],
                    [
                        8,
                        48
                    ],
                    [
                        8,
                        48
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        8,
                        33
                    ],
                    [
                        8,
                        33
                    ],
                    [
                        8,
                        34
                    ],
                    [
                        8,
                        34
                    ],
                    [
                        8,
                        35
                    ],
                    [
                        8,
                        35
                    ],
                    [
                        8,
                        36
                    ],
                    [
                        8,
                        36
                    ],
                    [
                        8,
                        37
                    ],
                    [
                        8,
                        37
                    ],
                    [
                        8,
                        38
                    ],
                    [
                        8,
                        38
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        8,
                        31
                    ],
                    [
                        8,
                        31
                    ],
                    [
                        8,
                        32
                    ],
                    [
                        8,
                        32
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        8,
                        53
                    ],
                    [
                        8,
                        53
                    ],
                    [
                        8,
                        54
                    ],
                    [
                        8,
                        54
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        8,
                        39
                    ],
                    [
                        8,
                        39
                    ],
                    [
                        8,
                        40
                    ],
                    [
                        8,
                        40
                    ],
                    [
                        8,
                        41
                    ],
                    [
                        8,
                        41
                    ],
                    [
                        8,
                        42
                    ],
                    [
                        8,
                        42
                    ],
                    [
                        8,
                        43
                    ],
                    [
                        8,
                        43
                    ],
                    [
                        8,
                        44
                    ],
                    [
                        8,
                        44
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        8,
                        61
                    ],
                    [
                        8,
                        61
                    ],
                    [
                        8,
                        62
                    ],
                    [
                        8,
                        62
                    ],
                    [
                        8,
                        63
                    ],
                    [
                        8,
                        63
                    ],
                    [
                        8,
                        0
                    ],
                    [
                        8,
                        0
                    ],
                    [
                        8,
                        320
                    ],
                    [
                        8,
                        320
                    ],
                    [
                        8,
                        384
                    ],
                    [
                        8,
                        384
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        8,
                        59
                    ],
                    [
                        8,
                        59
                    ],
                    [
                        8,
                        60
                    ],
                    [
                        8,
                        60
                    ],
                    [
                        9,
                        1472
                    ],
                    [
                        9,
                        1536
                    ],
                    [
                        9,
                        1600
                    ],
                    [
                        9,
                        1728
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        8,
                        49
                    ],
                    [
                        8,
                        49
                    ],
                    [
                        8,
                        50
                    ],
                    [
                        8,
                        50
                    ],
                    [
                        8,
                        51
                    ],
                    [
                        8,
                        51
                    ],
                    [
                        8,
                        52
                    ],
                    [
                        8,
                        52
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        8,
                        55
                    ],
                    [
                        8,
                        55
                    ],
                    [
                        8,
                        56
                    ],
                    [
                        8,
                        56
                    ],
                    [
                        8,
                        57
                    ],
                    [
                        8,
                        57
                    ],
                    [
                        8,
                        58
                    ],
                    [
                        8,
                        58
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        8,
                        448
                    ],
                    [
                        8,
                        448
                    ],
                    [
                        8,
                        512
                    ],
                    [
                        8,
                        512
                    ],
                    [
                        9,
                        704
                    ],
                    [
                        9,
                        768
                    ],
                    [
                        8,
                        640
                    ],
                    [
                        8,
                        640
                    ],
                    [
                        8,
                        576
                    ],
                    [
                        8,
                        576
                    ],
                    [
                        9,
                        832
                    ],
                    [
                        9,
                        896
                    ],
                    [
                        9,
                        960
                    ],
                    [
                        9,
                        1024
                    ],
                    [
                        9,
                        1088
                    ],
                    [
                        9,
                        1152
                    ],
                    [
                        9,
                        1216
                    ],
                    [
                        9,
                        1280
                    ],
                    [
                        9,
                        1344
                    ],
                    [
                        9,
                        1408
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ]
                ];
                const blackTable1 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        12,
                        ccittEOL
                    ],
                    [
                        12,
                        ccittEOL
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2560
                    ],
                    [
                        12,
                        2560
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        12,
                        52
                    ],
                    [
                        12,
                        52
                    ],
                    [
                        13,
                        640
                    ],
                    [
                        13,
                        704
                    ],
                    [
                        13,
                        768
                    ],
                    [
                        13,
                        832
                    ],
                    [
                        12,
                        55
                    ],
                    [
                        12,
                        55
                    ],
                    [
                        12,
                        56
                    ],
                    [
                        12,
                        56
                    ],
                    [
                        13,
                        1280
                    ],
                    [
                        13,
                        1344
                    ],
                    [
                        13,
                        1408
                    ],
                    [
                        13,
                        1472
                    ],
                    [
                        12,
                        59
                    ],
                    [
                        12,
                        59
                    ],
                    [
                        12,
                        60
                    ],
                    [
                        12,
                        60
                    ],
                    [
                        13,
                        1536
                    ],
                    [
                        13,
                        1600
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        13,
                        1664
                    ],
                    [
                        13,
                        1728
                    ],
                    [
                        12,
                        320
                    ],
                    [
                        12,
                        320
                    ],
                    [
                        12,
                        384
                    ],
                    [
                        12,
                        384
                    ],
                    [
                        12,
                        448
                    ],
                    [
                        12,
                        448
                    ],
                    [
                        13,
                        512
                    ],
                    [
                        13,
                        576
                    ],
                    [
                        12,
                        53
                    ],
                    [
                        12,
                        53
                    ],
                    [
                        12,
                        54
                    ],
                    [
                        12,
                        54
                    ],
                    [
                        13,
                        896
                    ],
                    [
                        13,
                        960
                    ],
                    [
                        13,
                        1024
                    ],
                    [
                        13,
                        1088
                    ],
                    [
                        13,
                        1152
                    ],
                    [
                        13,
                        1216
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ]
                ];
                const blackTable2 = [
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        11,
                        23
                    ],
                    [
                        11,
                        23
                    ],
                    [
                        12,
                        50
                    ],
                    [
                        12,
                        51
                    ],
                    [
                        12,
                        44
                    ],
                    [
                        12,
                        45
                    ],
                    [
                        12,
                        46
                    ],
                    [
                        12,
                        47
                    ],
                    [
                        12,
                        57
                    ],
                    [
                        12,
                        58
                    ],
                    [
                        12,
                        61
                    ],
                    [
                        12,
                        256
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        12,
                        48
                    ],
                    [
                        12,
                        49
                    ],
                    [
                        12,
                        62
                    ],
                    [
                        12,
                        63
                    ],
                    [
                        12,
                        30
                    ],
                    [
                        12,
                        31
                    ],
                    [
                        12,
                        32
                    ],
                    [
                        12,
                        33
                    ],
                    [
                        12,
                        40
                    ],
                    [
                        12,
                        41
                    ],
                    [
                        11,
                        22
                    ],
                    [
                        11,
                        22
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        12,
                        128
                    ],
                    [
                        12,
                        192
                    ],
                    [
                        12,
                        26
                    ],
                    [
                        12,
                        27
                    ],
                    [
                        12,
                        28
                    ],
                    [
                        12,
                        29
                    ],
                    [
                        11,
                        19
                    ],
                    [
                        11,
                        19
                    ],
                    [
                        11,
                        20
                    ],
                    [
                        11,
                        20
                    ],
                    [
                        12,
                        34
                    ],
                    [
                        12,
                        35
                    ],
                    [
                        12,
                        36
                    ],
                    [
                        12,
                        37
                    ],
                    [
                        12,
                        38
                    ],
                    [
                        12,
                        39
                    ],
                    [
                        11,
                        21
                    ],
                    [
                        11,
                        21
                    ],
                    [
                        12,
                        42
                    ],
                    [
                        12,
                        43
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ]
                ];
                const blackTable3 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        6,
                        9
                    ],
                    [
                        6,
                        8
                    ],
                    [
                        5,
                        7
                    ],
                    [
                        5,
                        7
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ]
                ];
                class CCITTFaxDecoder {
                    constructor(source, options = {}){
                        if (!source || typeof source.next !== "function") throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
                        this.source = source;
                        this.eof = false;
                        this.encoding = options.K || 0;
                        this.eoline = options.EndOfLine || false;
                        this.byteAlign = options.EncodedByteAlign || false;
                        this.columns = options.Columns || 1728;
                        this.rows = options.Rows || 0;
                        this.eoblock = options.EndOfBlock ?? true;
                        this.black = options.BlackIs1 || false;
                        this.codingLine = new Uint32Array(this.columns + 1);
                        this.refLine = new Uint32Array(this.columns + 2);
                        this.codingLine[0] = this.columns;
                        this.codingPos = 0;
                        this.row = 0;
                        this.nextLine2D = this.encoding < 0;
                        this.inputBits = 0;
                        this.inputBuf = 0;
                        this.outputBits = 0;
                        this.rowsDone = false;
                        let code1;
                        while((code1 = this._lookBits(12)) === 0)this._eatBits(1);
                        if (code1 === 1) this._eatBits(12);
                        if (this.encoding > 0) {
                            this.nextLine2D = !this._lookBits(1);
                            this._eatBits(1);
                        }
                    }
                    readNextChar() {
                        if (this.eof) return -1;
                        const refLine = this.refLine;
                        const codingLine = this.codingLine;
                        const columns = this.columns;
                        let refPos, blackPixels, bits, i;
                        if (this.outputBits === 0) {
                            if (this.rowsDone) this.eof = true;
                            if (this.eof) return -1;
                            this.err = false;
                            let code1, code2, code3;
                            if (this.nextLine2D) {
                                for(i = 0; codingLine[i] < columns; ++i)refLine[i] = codingLine[i];
                                refLine[i++] = columns;
                                refLine[i] = columns;
                                codingLine[0] = 0;
                                this.codingPos = 0;
                                refPos = 0;
                                blackPixels = 0;
                                while(codingLine[this.codingPos] < columns){
                                    code1 = this._getTwoDimCode();
                                    switch(code1){
                                        case twoDimPass:
                                            this._addPixels(refLine[refPos + 1], blackPixels);
                                            if (refLine[refPos + 1] < columns) refPos += 2;
                                            break;
                                        case twoDimHoriz:
                                            code1 = code2 = 0;
                                            if (blackPixels) {
                                                do code1 += code3 = this._getBlackCode();
                                                while (code3 >= 64);
                                                do code2 += code3 = this._getWhiteCode();
                                                while (code3 >= 64);
                                            } else {
                                                do code1 += code3 = this._getWhiteCode();
                                                while (code3 >= 64);
                                                do code2 += code3 = this._getBlackCode();
                                                while (code3 >= 64);
                                            }
                                            this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                                            if (codingLine[this.codingPos] < columns) this._addPixels(codingLine[this.codingPos] + code2, blackPixels ^ 1);
                                            while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            break;
                                        case twoDimVertR3:
                                            this._addPixels(refLine[refPos] + 3, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertR2:
                                            this._addPixels(refLine[refPos] + 2, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertR1:
                                            this._addPixels(refLine[refPos] + 1, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVert0:
                                            this._addPixels(refLine[refPos], blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertL3:
                                            this._addPixelsNeg(refLine[refPos] - 3, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                if (refPos > 0) --refPos;
                                                else ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertL2:
                                            this._addPixelsNeg(refLine[refPos] - 2, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                if (refPos > 0) --refPos;
                                                else ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertL1:
                                            this._addPixelsNeg(refLine[refPos] - 1, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                if (refPos > 0) --refPos;
                                                else ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case ccittEOF:
                                            this._addPixels(columns, 0);
                                            this.eof = true;
                                            break;
                                        default:
                                            (0, _util.info)("bad 2d code");
                                            this._addPixels(columns, 0);
                                            this.err = true;
                                    }
                                }
                            } else {
                                codingLine[0] = 0;
                                this.codingPos = 0;
                                blackPixels = 0;
                                while(codingLine[this.codingPos] < columns){
                                    code1 = 0;
                                    if (blackPixels) do code1 += code3 = this._getBlackCode();
                                    while (code3 >= 64);
                                    else do code1 += code3 = this._getWhiteCode();
                                    while (code3 >= 64);
                                    this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                                    blackPixels ^= 1;
                                }
                            }
                            let gotEOL = false;
                            if (this.byteAlign) this.inputBits &= -8;
                            if (!this.eoblock && this.row === this.rows - 1) this.rowsDone = true;
                            else {
                                code1 = this._lookBits(12);
                                if (this.eoline) while(code1 !== ccittEOF && code1 !== 1){
                                    this._eatBits(1);
                                    code1 = this._lookBits(12);
                                }
                                else while(code1 === 0){
                                    this._eatBits(1);
                                    code1 = this._lookBits(12);
                                }
                                if (code1 === 1) {
                                    this._eatBits(12);
                                    gotEOL = true;
                                } else if (code1 === ccittEOF) this.eof = true;
                            }
                            if (!this.eof && this.encoding > 0 && !this.rowsDone) {
                                this.nextLine2D = !this._lookBits(1);
                                this._eatBits(1);
                            }
                            if (this.eoblock && gotEOL && this.byteAlign) {
                                code1 = this._lookBits(12);
                                if (code1 === 1) {
                                    this._eatBits(12);
                                    if (this.encoding > 0) {
                                        this._lookBits(1);
                                        this._eatBits(1);
                                    }
                                    if (this.encoding >= 0) for(i = 0; i < 4; ++i){
                                        code1 = this._lookBits(12);
                                        if (code1 !== 1) (0, _util.info)("bad rtc code: " + code1);
                                        this._eatBits(12);
                                        if (this.encoding > 0) {
                                            this._lookBits(1);
                                            this._eatBits(1);
                                        }
                                    }
                                    this.eof = true;
                                }
                            } else if (this.err && this.eoline) {
                                while(true){
                                    code1 = this._lookBits(13);
                                    if (code1 === ccittEOF) {
                                        this.eof = true;
                                        return -1;
                                    }
                                    if (code1 >> 1 === 1) break;
                                    this._eatBits(1);
                                }
                                this._eatBits(12);
                                if (this.encoding > 0) {
                                    this._eatBits(1);
                                    this.nextLine2D = !(code1 & 1);
                                }
                            }
                            this.outputBits = codingLine[0] > 0 ? codingLine[this.codingPos = 0] : codingLine[this.codingPos = 1];
                            this.row++;
                        }
                        let c;
                        if (this.outputBits >= 8) {
                            c = this.codingPos & 1 ? 0 : 0xff;
                            this.outputBits -= 8;
                            if (this.outputBits === 0 && codingLine[this.codingPos] < columns) {
                                this.codingPos++;
                                this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
                            }
                        } else {
                            bits = 8;
                            c = 0;
                            do {
                                if (typeof this.outputBits !== "number") throw new _util.FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
                                if (this.outputBits > bits) {
                                    c <<= bits;
                                    if (!(this.codingPos & 1)) c |= 0xff >> 8 - bits;
                                    this.outputBits -= bits;
                                    bits = 0;
                                } else {
                                    c <<= this.outputBits;
                                    if (!(this.codingPos & 1)) c |= 0xff >> 8 - this.outputBits;
                                    bits -= this.outputBits;
                                    this.outputBits = 0;
                                    if (codingLine[this.codingPos] < columns) {
                                        this.codingPos++;
                                        this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
                                    } else if (bits > 0) {
                                        c <<= bits;
                                        bits = 0;
                                    }
                                }
                            }while (bits);
                        }
                        if (this.black) c ^= 0xff;
                        return c;
                    }
                    _addPixels(a1, blackPixels) {
                        const codingLine = this.codingLine;
                        let codingPos = this.codingPos;
                        if (a1 > codingLine[codingPos]) {
                            if (a1 > this.columns) {
                                (0, _util.info)("row is wrong length");
                                this.err = true;
                                a1 = this.columns;
                            }
                            if (codingPos & 1 ^ blackPixels) ++codingPos;
                            codingLine[codingPos] = a1;
                        }
                        this.codingPos = codingPos;
                    }
                    _addPixelsNeg(a1, blackPixels) {
                        const codingLine = this.codingLine;
                        let codingPos = this.codingPos;
                        if (a1 > codingLine[codingPos]) {
                            if (a1 > this.columns) {
                                (0, _util.info)("row is wrong length");
                                this.err = true;
                                a1 = this.columns;
                            }
                            if (codingPos & 1 ^ blackPixels) ++codingPos;
                            codingLine[codingPos] = a1;
                        } else if (a1 < codingLine[codingPos]) {
                            if (a1 < 0) {
                                (0, _util.info)("invalid code");
                                this.err = true;
                                a1 = 0;
                            }
                            while(codingPos > 0 && a1 < codingLine[codingPos - 1])--codingPos;
                            codingLine[codingPos] = a1;
                        }
                        this.codingPos = codingPos;
                    }
                    _findTableCode(start, end, table, limit) {
                        const limitValue = limit || 0;
                        for(let i = start; i <= end; ++i){
                            let code = this._lookBits(i);
                            if (code === ccittEOF) return [
                                true,
                                1,
                                false
                            ];
                            if (i < end) code <<= end - i;
                            if (!limitValue || code >= limitValue) {
                                const p = table[code - limitValue];
                                if (p[0] === i) {
                                    this._eatBits(i);
                                    return [
                                        true,
                                        p[1],
                                        true
                                    ];
                                }
                            }
                        }
                        return [
                            false,
                            0,
                            false
                        ];
                    }
                    _getTwoDimCode() {
                        let code = 0;
                        let p;
                        if (this.eoblock) {
                            code = this._lookBits(7);
                            p = twoDimTable[code];
                            if (p?.[0] > 0) {
                                this._eatBits(p[0]);
                                return p[1];
                            }
                        } else {
                            const result = this._findTableCode(1, 7, twoDimTable);
                            if (result[0] && result[2]) return result[1];
                        }
                        (0, _util.info)("Bad two dim code");
                        return ccittEOF;
                    }
                    _getWhiteCode() {
                        let code = 0;
                        let p;
                        if (this.eoblock) {
                            code = this._lookBits(12);
                            if (code === ccittEOF) return 1;
                            p = code >> 5 === 0 ? whiteTable1[code] : whiteTable2[code >> 3];
                            if (p[0] > 0) {
                                this._eatBits(p[0]);
                                return p[1];
                            }
                        } else {
                            let result = this._findTableCode(1, 9, whiteTable2);
                            if (result[0]) return result[1];
                            result = this._findTableCode(11, 12, whiteTable1);
                            if (result[0]) return result[1];
                        }
                        (0, _util.info)("bad white code");
                        this._eatBits(1);
                        return 1;
                    }
                    _getBlackCode() {
                        let code, p;
                        if (this.eoblock) {
                            code = this._lookBits(13);
                            if (code === ccittEOF) return 1;
                            if (code >> 7 === 0) p = blackTable1[code];
                            else if (code >> 9 === 0 && code >> 7 !== 0) p = blackTable2[(code >> 1) - 64];
                            else p = blackTable3[code >> 7];
                            if (p[0] > 0) {
                                this._eatBits(p[0]);
                                return p[1];
                            }
                        } else {
                            let result = this._findTableCode(2, 6, blackTable3);
                            if (result[0]) return result[1];
                            result = this._findTableCode(7, 12, blackTable2, 64);
                            if (result[0]) return result[1];
                            result = this._findTableCode(10, 13, blackTable1);
                            if (result[0]) return result[1];
                        }
                        (0, _util.info)("bad black code");
                        this._eatBits(1);
                        return 1;
                    }
                    _lookBits(n) {
                        let c;
                        while(this.inputBits < n){
                            if ((c = this.source.next()) === -1) {
                                if (this.inputBits === 0) return ccittEOF;
                                return this.inputBuf << n - this.inputBits & 0xffff >> 16 - n;
                            }
                            this.inputBuf = this.inputBuf << 8 | c;
                            this.inputBits += 8;
                        }
                        return this.inputBuf >> this.inputBits - n & 0xffff >> 16 - n;
                    }
                    _eatBits(n) {
                        if ((this.inputBits -= n) < 0) this.inputBits = 0;
                    }
                }
                exports.CCITTFaxDecoder = CCITTFaxDecoder;
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FlateStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _util = __w_pdfjs_require__(2);
                const codeLenCodeMap = new Int32Array([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]);
                const lengthDecode = new Int32Array([
                    0x00003,
                    0x00004,
                    0x00005,
                    0x00006,
                    0x00007,
                    0x00008,
                    0x00009,
                    0x0000a,
                    0x1000b,
                    0x1000d,
                    0x1000f,
                    0x10011,
                    0x20013,
                    0x20017,
                    0x2001b,
                    0x2001f,
                    0x30023,
                    0x3002b,
                    0x30033,
                    0x3003b,
                    0x40043,
                    0x40053,
                    0x40063,
                    0x40073,
                    0x50083,
                    0x500a3,
                    0x500c3,
                    0x500e3,
                    0x00102,
                    0x00102,
                    0x00102
                ]);
                const distDecode = new Int32Array([
                    0x00001,
                    0x00002,
                    0x00003,
                    0x00004,
                    0x10005,
                    0x10007,
                    0x20009,
                    0x2000d,
                    0x30011,
                    0x30019,
                    0x40021,
                    0x40031,
                    0x50041,
                    0x50061,
                    0x60081,
                    0x600c1,
                    0x70101,
                    0x70181,
                    0x80201,
                    0x80301,
                    0x90401,
                    0x90601,
                    0xa0801,
                    0xa0c01,
                    0xb1001,
                    0xb1801,
                    0xc2001,
                    0xc3001,
                    0xd4001,
                    0xd6001
                ]);
                const fixedLitCodeTab = [
                    new Int32Array([
                        0x70100,
                        0x80050,
                        0x80010,
                        0x80118,
                        0x70110,
                        0x80070,
                        0x80030,
                        0x900c0,
                        0x70108,
                        0x80060,
                        0x80020,
                        0x900a0,
                        0x80000,
                        0x80080,
                        0x80040,
                        0x900e0,
                        0x70104,
                        0x80058,
                        0x80018,
                        0x90090,
                        0x70114,
                        0x80078,
                        0x80038,
                        0x900d0,
                        0x7010c,
                        0x80068,
                        0x80028,
                        0x900b0,
                        0x80008,
                        0x80088,
                        0x80048,
                        0x900f0,
                        0x70102,
                        0x80054,
                        0x80014,
                        0x8011c,
                        0x70112,
                        0x80074,
                        0x80034,
                        0x900c8,
                        0x7010a,
                        0x80064,
                        0x80024,
                        0x900a8,
                        0x80004,
                        0x80084,
                        0x80044,
                        0x900e8,
                        0x70106,
                        0x8005c,
                        0x8001c,
                        0x90098,
                        0x70116,
                        0x8007c,
                        0x8003c,
                        0x900d8,
                        0x7010e,
                        0x8006c,
                        0x8002c,
                        0x900b8,
                        0x8000c,
                        0x8008c,
                        0x8004c,
                        0x900f8,
                        0x70101,
                        0x80052,
                        0x80012,
                        0x8011a,
                        0x70111,
                        0x80072,
                        0x80032,
                        0x900c4,
                        0x70109,
                        0x80062,
                        0x80022,
                        0x900a4,
                        0x80002,
                        0x80082,
                        0x80042,
                        0x900e4,
                        0x70105,
                        0x8005a,
                        0x8001a,
                        0x90094,
                        0x70115,
                        0x8007a,
                        0x8003a,
                        0x900d4,
                        0x7010d,
                        0x8006a,
                        0x8002a,
                        0x900b4,
                        0x8000a,
                        0x8008a,
                        0x8004a,
                        0x900f4,
                        0x70103,
                        0x80056,
                        0x80016,
                        0x8011e,
                        0x70113,
                        0x80076,
                        0x80036,
                        0x900cc,
                        0x7010b,
                        0x80066,
                        0x80026,
                        0x900ac,
                        0x80006,
                        0x80086,
                        0x80046,
                        0x900ec,
                        0x70107,
                        0x8005e,
                        0x8001e,
                        0x9009c,
                        0x70117,
                        0x8007e,
                        0x8003e,
                        0x900dc,
                        0x7010f,
                        0x8006e,
                        0x8002e,
                        0x900bc,
                        0x8000e,
                        0x8008e,
                        0x8004e,
                        0x900fc,
                        0x70100,
                        0x80051,
                        0x80011,
                        0x80119,
                        0x70110,
                        0x80071,
                        0x80031,
                        0x900c2,
                        0x70108,
                        0x80061,
                        0x80021,
                        0x900a2,
                        0x80001,
                        0x80081,
                        0x80041,
                        0x900e2,
                        0x70104,
                        0x80059,
                        0x80019,
                        0x90092,
                        0x70114,
                        0x80079,
                        0x80039,
                        0x900d2,
                        0x7010c,
                        0x80069,
                        0x80029,
                        0x900b2,
                        0x80009,
                        0x80089,
                        0x80049,
                        0x900f2,
                        0x70102,
                        0x80055,
                        0x80015,
                        0x8011d,
                        0x70112,
                        0x80075,
                        0x80035,
                        0x900ca,
                        0x7010a,
                        0x80065,
                        0x80025,
                        0x900aa,
                        0x80005,
                        0x80085,
                        0x80045,
                        0x900ea,
                        0x70106,
                        0x8005d,
                        0x8001d,
                        0x9009a,
                        0x70116,
                        0x8007d,
                        0x8003d,
                        0x900da,
                        0x7010e,
                        0x8006d,
                        0x8002d,
                        0x900ba,
                        0x8000d,
                        0x8008d,
                        0x8004d,
                        0x900fa,
                        0x70101,
                        0x80053,
                        0x80013,
                        0x8011b,
                        0x70111,
                        0x80073,
                        0x80033,
                        0x900c6,
                        0x70109,
                        0x80063,
                        0x80023,
                        0x900a6,
                        0x80003,
                        0x80083,
                        0x80043,
                        0x900e6,
                        0x70105,
                        0x8005b,
                        0x8001b,
                        0x90096,
                        0x70115,
                        0x8007b,
                        0x8003b,
                        0x900d6,
                        0x7010d,
                        0x8006b,
                        0x8002b,
                        0x900b6,
                        0x8000b,
                        0x8008b,
                        0x8004b,
                        0x900f6,
                        0x70103,
                        0x80057,
                        0x80017,
                        0x8011f,
                        0x70113,
                        0x80077,
                        0x80037,
                        0x900ce,
                        0x7010b,
                        0x80067,
                        0x80027,
                        0x900ae,
                        0x80007,
                        0x80087,
                        0x80047,
                        0x900ee,
                        0x70107,
                        0x8005f,
                        0x8001f,
                        0x9009e,
                        0x70117,
                        0x8007f,
                        0x8003f,
                        0x900de,
                        0x7010f,
                        0x8006f,
                        0x8002f,
                        0x900be,
                        0x8000f,
                        0x8008f,
                        0x8004f,
                        0x900fe,
                        0x70100,
                        0x80050,
                        0x80010,
                        0x80118,
                        0x70110,
                        0x80070,
                        0x80030,
                        0x900c1,
                        0x70108,
                        0x80060,
                        0x80020,
                        0x900a1,
                        0x80000,
                        0x80080,
                        0x80040,
                        0x900e1,
                        0x70104,
                        0x80058,
                        0x80018,
                        0x90091,
                        0x70114,
                        0x80078,
                        0x80038,
                        0x900d1,
                        0x7010c,
                        0x80068,
                        0x80028,
                        0x900b1,
                        0x80008,
                        0x80088,
                        0x80048,
                        0x900f1,
                        0x70102,
                        0x80054,
                        0x80014,
                        0x8011c,
                        0x70112,
                        0x80074,
                        0x80034,
                        0x900c9,
                        0x7010a,
                        0x80064,
                        0x80024,
                        0x900a9,
                        0x80004,
                        0x80084,
                        0x80044,
                        0x900e9,
                        0x70106,
                        0x8005c,
                        0x8001c,
                        0x90099,
                        0x70116,
                        0x8007c,
                        0x8003c,
                        0x900d9,
                        0x7010e,
                        0x8006c,
                        0x8002c,
                        0x900b9,
                        0x8000c,
                        0x8008c,
                        0x8004c,
                        0x900f9,
                        0x70101,
                        0x80052,
                        0x80012,
                        0x8011a,
                        0x70111,
                        0x80072,
                        0x80032,
                        0x900c5,
                        0x70109,
                        0x80062,
                        0x80022,
                        0x900a5,
                        0x80002,
                        0x80082,
                        0x80042,
                        0x900e5,
                        0x70105,
                        0x8005a,
                        0x8001a,
                        0x90095,
                        0x70115,
                        0x8007a,
                        0x8003a,
                        0x900d5,
                        0x7010d,
                        0x8006a,
                        0x8002a,
                        0x900b5,
                        0x8000a,
                        0x8008a,
                        0x8004a,
                        0x900f5,
                        0x70103,
                        0x80056,
                        0x80016,
                        0x8011e,
                        0x70113,
                        0x80076,
                        0x80036,
                        0x900cd,
                        0x7010b,
                        0x80066,
                        0x80026,
                        0x900ad,
                        0x80006,
                        0x80086,
                        0x80046,
                        0x900ed,
                        0x70107,
                        0x8005e,
                        0x8001e,
                        0x9009d,
                        0x70117,
                        0x8007e,
                        0x8003e,
                        0x900dd,
                        0x7010f,
                        0x8006e,
                        0x8002e,
                        0x900bd,
                        0x8000e,
                        0x8008e,
                        0x8004e,
                        0x900fd,
                        0x70100,
                        0x80051,
                        0x80011,
                        0x80119,
                        0x70110,
                        0x80071,
                        0x80031,
                        0x900c3,
                        0x70108,
                        0x80061,
                        0x80021,
                        0x900a3,
                        0x80001,
                        0x80081,
                        0x80041,
                        0x900e3,
                        0x70104,
                        0x80059,
                        0x80019,
                        0x90093,
                        0x70114,
                        0x80079,
                        0x80039,
                        0x900d3,
                        0x7010c,
                        0x80069,
                        0x80029,
                        0x900b3,
                        0x80009,
                        0x80089,
                        0x80049,
                        0x900f3,
                        0x70102,
                        0x80055,
                        0x80015,
                        0x8011d,
                        0x70112,
                        0x80075,
                        0x80035,
                        0x900cb,
                        0x7010a,
                        0x80065,
                        0x80025,
                        0x900ab,
                        0x80005,
                        0x80085,
                        0x80045,
                        0x900eb,
                        0x70106,
                        0x8005d,
                        0x8001d,
                        0x9009b,
                        0x70116,
                        0x8007d,
                        0x8003d,
                        0x900db,
                        0x7010e,
                        0x8006d,
                        0x8002d,
                        0x900bb,
                        0x8000d,
                        0x8008d,
                        0x8004d,
                        0x900fb,
                        0x70101,
                        0x80053,
                        0x80013,
                        0x8011b,
                        0x70111,
                        0x80073,
                        0x80033,
                        0x900c7,
                        0x70109,
                        0x80063,
                        0x80023,
                        0x900a7,
                        0x80003,
                        0x80083,
                        0x80043,
                        0x900e7,
                        0x70105,
                        0x8005b,
                        0x8001b,
                        0x90097,
                        0x70115,
                        0x8007b,
                        0x8003b,
                        0x900d7,
                        0x7010d,
                        0x8006b,
                        0x8002b,
                        0x900b7,
                        0x8000b,
                        0x8008b,
                        0x8004b,
                        0x900f7,
                        0x70103,
                        0x80057,
                        0x80017,
                        0x8011f,
                        0x70113,
                        0x80077,
                        0x80037,
                        0x900cf,
                        0x7010b,
                        0x80067,
                        0x80027,
                        0x900af,
                        0x80007,
                        0x80087,
                        0x80047,
                        0x900ef,
                        0x70107,
                        0x8005f,
                        0x8001f,
                        0x9009f,
                        0x70117,
                        0x8007f,
                        0x8003f,
                        0x900df,
                        0x7010f,
                        0x8006f,
                        0x8002f,
                        0x900bf,
                        0x8000f,
                        0x8008f,
                        0x8004f,
                        0x900ff
                    ]),
                    9
                ];
                const fixedDistCodeTab = [
                    new Int32Array([
                        0x50000,
                        0x50010,
                        0x50008,
                        0x50018,
                        0x50004,
                        0x50014,
                        0x5000c,
                        0x5001c,
                        0x50002,
                        0x50012,
                        0x5000a,
                        0x5001a,
                        0x50006,
                        0x50016,
                        0x5000e,
                        0x00000,
                        0x50001,
                        0x50011,
                        0x50009,
                        0x50019,
                        0x50005,
                        0x50015,
                        0x5000d,
                        0x5001d,
                        0x50003,
                        0x50013,
                        0x5000b,
                        0x5001b,
                        0x50007,
                        0x50017,
                        0x5000f,
                        0x00000
                    ]),
                    5
                ];
                class FlateStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        const cmf = str.getByte();
                        const flg = str.getByte();
                        if (cmf === -1 || flg === -1) throw new _util.FormatError(`Invalid header in flate stream: ${cmf}, ${flg}`);
                        if ((cmf & 0x0f) !== 0x08) throw new _util.FormatError(`Unknown compression method in flate stream: ${cmf}, ${flg}`);
                        if (((cmf << 8) + flg) % 31 !== 0) throw new _util.FormatError(`Bad FCHECK in flate stream: ${cmf}, ${flg}`);
                        if (flg & 0x20) throw new _util.FormatError(`FDICT bit set in flate stream: ${cmf}, ${flg}`);
                        this.codeSize = 0;
                        this.codeBuf = 0;
                    }
                    getBits(bits) {
                        const str = this.str;
                        let codeSize = this.codeSize;
                        let codeBuf = this.codeBuf;
                        let b;
                        while(codeSize < bits){
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad encoding in flate stream");
                            codeBuf |= b << codeSize;
                            codeSize += 8;
                        }
                        b = codeBuf & (1 << bits) - 1;
                        this.codeBuf = codeBuf >> bits;
                        this.codeSize = codeSize -= bits;
                        return b;
                    }
                    getCode(table) {
                        const str = this.str;
                        const codes = table[0];
                        const maxLen = table[1];
                        let codeSize = this.codeSize;
                        let codeBuf = this.codeBuf;
                        let b;
                        while(codeSize < maxLen){
                            if ((b = str.getByte()) === -1) break;
                            codeBuf |= b << codeSize;
                            codeSize += 8;
                        }
                        const code = codes[codeBuf & (1 << maxLen) - 1];
                        const codeLen = code >> 16;
                        const codeVal = code & 0xffff;
                        if (codeLen < 1 || codeSize < codeLen) throw new _util.FormatError("Bad encoding in flate stream");
                        this.codeBuf = codeBuf >> codeLen;
                        this.codeSize = codeSize - codeLen;
                        return codeVal;
                    }
                    generateHuffmanTable(lengths) {
                        const n = lengths.length;
                        let maxLen = 0;
                        let i;
                        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
                        const size = 1 << maxLen;
                        const codes = new Int32Array(size);
                        for(let len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
                            for(let val = 0; val < n; ++val)if (lengths[val] === len) {
                                let code2 = 0;
                                let t = code;
                                for(i = 0; i < len; ++i){
                                    code2 = code2 << 1 | t & 1;
                                    t >>= 1;
                                }
                                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                                ++code;
                            }
                        }
                        return [
                            codes,
                            maxLen
                        ];
                    }
                    readBlock() {
                        let buffer, len;
                        const str = this.str;
                        let hdr = this.getBits(3);
                        if (hdr & 1) this.eof = true;
                        hdr >>= 1;
                        if (hdr === 0) {
                            let b;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            let blockLen = b;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            blockLen |= b << 8;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            let check = b;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            check |= b << 8;
                            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) throw new _util.FormatError("Bad uncompressed block length in flate stream");
                            this.codeBuf = 0;
                            this.codeSize = 0;
                            const bufferLength = this.bufferLength, end = bufferLength + blockLen;
                            buffer = this.ensureBuffer(end);
                            this.bufferLength = end;
                            if (blockLen === 0) {
                                if (str.peekByte() === -1) this.eof = true;
                            } else {
                                const block = str.getBytes(blockLen);
                                buffer.set(block, bufferLength);
                                if (block.length < blockLen) this.eof = true;
                            }
                            return;
                        }
                        let litCodeTable;
                        let distCodeTable;
                        if (hdr === 1) {
                            litCodeTable = fixedLitCodeTab;
                            distCodeTable = fixedDistCodeTab;
                        } else if (hdr === 2) {
                            const numLitCodes = this.getBits(5) + 257;
                            const numDistCodes = this.getBits(5) + 1;
                            const numCodeLenCodes = this.getBits(4) + 4;
                            const codeLenCodeLengths = new Uint8Array(codeLenCodeMap.length);
                            let i;
                            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[codeLenCodeMap[i]] = this.getBits(3);
                            const codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
                            len = 0;
                            i = 0;
                            const codes = numLitCodes + numDistCodes;
                            const codeLengths = new Uint8Array(codes);
                            let bitsLength, bitsOffset, what;
                            while(i < codes){
                                const code = this.getCode(codeLenCodeTab);
                                if (code === 16) {
                                    bitsLength = 2;
                                    bitsOffset = 3;
                                    what = len;
                                } else if (code === 17) {
                                    bitsLength = 3;
                                    bitsOffset = 3;
                                    what = len = 0;
                                } else if (code === 18) {
                                    bitsLength = 7;
                                    bitsOffset = 11;
                                    what = len = 0;
                                } else {
                                    codeLengths[i++] = len = code;
                                    continue;
                                }
                                let repeatLength = this.getBits(bitsLength) + bitsOffset;
                                while(repeatLength-- > 0)codeLengths[i++] = what;
                            }
                            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
                            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
                        } else throw new _util.FormatError("Unknown block type in flate stream");
                        buffer = this.buffer;
                        let limit = buffer ? buffer.length : 0;
                        let pos = this.bufferLength;
                        while(true){
                            let code1 = this.getCode(litCodeTable);
                            if (code1 < 256) {
                                if (pos + 1 >= limit) {
                                    buffer = this.ensureBuffer(pos + 1);
                                    limit = buffer.length;
                                }
                                buffer[pos++] = code1;
                                continue;
                            }
                            if (code1 === 256) {
                                this.bufferLength = pos;
                                return;
                            }
                            code1 -= 257;
                            code1 = lengthDecode[code1];
                            let code2 = code1 >> 16;
                            if (code2 > 0) code2 = this.getBits(code2);
                            len = (code1 & 0xffff) + code2;
                            code1 = this.getCode(distCodeTable);
                            code1 = distDecode[code1];
                            code2 = code1 >> 16;
                            if (code2 > 0) code2 = this.getBits(code2);
                            const dist = (code1 & 0xffff) + code2;
                            if (pos + len >= limit) {
                                buffer = this.ensureBuffer(pos + len);
                                limit = buffer.length;
                            }
                            for(let k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
                        }
                    }
                }
                exports.FlateStream = FlateStream;
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Jbig2Stream = void 0;
                var _base_stream = __w_pdfjs_require__(5);
                var _decode_stream = __w_pdfjs_require__(18);
                var _primitives = __w_pdfjs_require__(4);
                var _jbig = __w_pdfjs_require__(24);
                var _util = __w_pdfjs_require__(2);
                class Jbig2Stream extends _decode_stream.DecodeStream {
                    constructor(stream, maybeLength, params){
                        super(maybeLength);
                        this.stream = stream;
                        this.dict = stream.dict;
                        this.maybeLength = maybeLength;
                        this.params = params;
                    }
                    get bytes() {
                        return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(requested) {}
                    readBlock() {
                        if (this.eof) return;
                        const jbig2Image = new _jbig.Jbig2Image();
                        const chunks = [];
                        if (this.params instanceof _primitives.Dict) {
                            const globalsStream = this.params.get("JBIG2Globals");
                            if (globalsStream instanceof _base_stream.BaseStream) {
                                const globals = globalsStream.getBytes();
                                chunks.push({
                                    data: globals,
                                    start: 0,
                                    end: globals.length
                                });
                            }
                        }
                        chunks.push({
                            data: this.bytes,
                            start: 0,
                            end: this.bytes.length
                        });
                        const data = jbig2Image.parseChunks(chunks);
                        const dataLength = data.length;
                        for(let i = 0; i < dataLength; i++)data[i] ^= 0xff;
                        this.buffer = data;
                        this.bufferLength = dataLength;
                        this.eof = true;
                    }
                }
                exports.Jbig2Stream = Jbig2Stream;
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Jbig2Image = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _arithmetic_decoder = __w_pdfjs_require__(25);
                var _ccitt = __w_pdfjs_require__(21);
                class Jbig2Error extends _util.BaseException {
                    constructor(msg){
                        super(`JBIG2 error: ${msg}`, "Jbig2Error");
                    }
                }
                class ContextCache {
                    getContexts(id) {
                        if (id in this) return this[id];
                        return this[id] = new Int8Array(65536);
                    }
                }
                class DecodingContext {
                    constructor(data, start, end){
                        this.data = data;
                        this.start = start;
                        this.end = end;
                    }
                    get decoder() {
                        const decoder = new _arithmetic_decoder.ArithmeticDecoder(this.data, this.start, this.end);
                        return (0, _util.shadow)(this, "decoder", decoder);
                    }
                    get contextCache() {
                        const cache = new ContextCache();
                        return (0, _util.shadow)(this, "contextCache", cache);
                    }
                }
                const MAX_INT_32 = 2 ** 31 - 1;
                const MIN_INT_32 = -(2 ** 31);
                function decodeInteger(contextCache, procedure, decoder) {
                    const contexts = contextCache.getContexts(procedure);
                    let prev = 1;
                    function readBits(length) {
                        let v = 0;
                        for(let i = 0; i < length; i++){
                            const bit = decoder.readBit(contexts, prev);
                            prev = prev < 256 ? prev << 1 | bit : (prev << 1 | bit) & 511 | 256;
                            v = v << 1 | bit;
                        }
                        return v >>> 0;
                    }
                    const sign = readBits(1);
                    const value = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
                    let signedValue;
                    if (sign === 0) signedValue = value;
                    else if (value > 0) signedValue = -value;
                    if (signedValue >= MIN_INT_32 && signedValue <= MAX_INT_32) return signedValue;
                    return null;
                }
                function decodeIAID(contextCache, decoder, codeLength) {
                    const contexts = contextCache.getContexts("IAID");
                    let prev = 1;
                    for(let i = 0; i < codeLength; i++){
                        const bit = decoder.readBit(contexts, prev);
                        prev = prev << 1 | bit;
                    }
                    if (codeLength < 31) return prev & (1 << codeLength) - 1;
                    return prev & 0x7fffffff;
                }
                const SegmentTypes = [
                    "SymbolDictionary",
                    null,
                    null,
                    null,
                    "IntermediateTextRegion",
                    null,
                    "ImmediateTextRegion",
                    "ImmediateLosslessTextRegion",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "PatternDictionary",
                    null,
                    null,
                    null,
                    "IntermediateHalftoneRegion",
                    null,
                    "ImmediateHalftoneRegion",
                    "ImmediateLosslessHalftoneRegion",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "IntermediateGenericRegion",
                    null,
                    "ImmediateGenericRegion",
                    "ImmediateLosslessGenericRegion",
                    "IntermediateGenericRefinementRegion",
                    null,
                    "ImmediateGenericRefinementRegion",
                    "ImmediateLosslessGenericRefinementRegion",
                    null,
                    null,
                    null,
                    null,
                    "PageInformation",
                    "EndOfPage",
                    "EndOfStripe",
                    "EndOfFile",
                    "Profiles",
                    "Tables",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "Extension"
                ];
                const CodingTemplates = [
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: 2,
                            y: -1
                        },
                        {
                            x: -4,
                            y: 0
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: 2,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: 2,
                            y: -1
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -3,
                            y: -1
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: -4,
                            y: 0
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ]
                ];
                const RefinementTemplates = [
                    {
                        coding: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            }
                        ],
                        reference: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 1,
                                y: 0
                            },
                            {
                                x: -1,
                                y: 1
                            },
                            {
                                x: 0,
                                y: 1
                            },
                            {
                                x: 1,
                                y: 1
                            }
                        ]
                    },
                    {
                        coding: [
                            {
                                x: -1,
                                y: -1
                            },
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            }
                        ],
                        reference: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 1
                            },
                            {
                                x: 1,
                                y: 1
                            }
                        ]
                    }
                ];
                const ReusedContexts = [
                    0x9b25,
                    0x0795,
                    0x00e5,
                    0x0195
                ];
                const RefinementReusedContexts = [
                    0x0020,
                    0x0008
                ];
                function decodeBitmapTemplate0(width, height, decodingContext) {
                    const decoder = decodingContext.decoder;
                    const contexts = decodingContext.contextCache.getContexts("GB");
                    const bitmap = [];
                    let contextLabel, i, j, pixel, row, row1, row2;
                    const OLD_PIXEL_MASK = 0x7bf7;
                    for(i = 0; i < height; i++){
                        row = bitmap[i] = new Uint8Array(width);
                        row1 = i < 1 ? row : bitmap[i - 1];
                        row2 = i < 2 ? row : bitmap[i - 2];
                        contextLabel = row2[0] << 13 | row2[1] << 12 | row2[2] << 11 | row1[0] << 7 | row1[1] << 6 | row1[2] << 5 | row1[3] << 4;
                        for(j = 0; j < width; j++){
                            row[j] = pixel = decoder.readBit(contexts, contextLabel);
                            contextLabel = (contextLabel & OLD_PIXEL_MASK) << 1 | (j + 3 < width ? row2[j + 3] << 11 : 0) | (j + 4 < width ? row1[j + 4] << 4 : 0) | pixel;
                        }
                    }
                    return bitmap;
                }
                function decodeBitmap(mmr, width, height, templateIndex, prediction, skip, at, decodingContext) {
                    if (mmr) {
                        const input = new Reader(decodingContext.data, decodingContext.start, decodingContext.end);
                        return decodeMMRBitmap(input, width, height, false);
                    }
                    if (templateIndex === 0 && !skip && !prediction && at.length === 4 && at[0].x === 3 && at[0].y === -1 && at[1].x === -3 && at[1].y === -1 && at[2].x === 2 && at[2].y === -2 && at[3].x === -2 && at[3].y === -2) return decodeBitmapTemplate0(width, height, decodingContext);
                    const useskip = !!skip;
                    const template = CodingTemplates[templateIndex].concat(at);
                    template.sort(function(a, b) {
                        return a.y - b.y || a.x - b.x;
                    });
                    const templateLength = template.length;
                    const templateX = new Int8Array(templateLength);
                    const templateY = new Int8Array(templateLength);
                    const changingTemplateEntries = [];
                    let reuseMask = 0, minX = 0, maxX = 0, minY = 0;
                    let c, k;
                    for(k = 0; k < templateLength; k++){
                        templateX[k] = template[k].x;
                        templateY[k] = template[k].y;
                        minX = Math.min(minX, template[k].x);
                        maxX = Math.max(maxX, template[k].x);
                        minY = Math.min(minY, template[k].y);
                        if (k < templateLength - 1 && template[k].y === template[k + 1].y && template[k].x === template[k + 1].x - 1) reuseMask |= 1 << templateLength - 1 - k;
                        else changingTemplateEntries.push(k);
                    }
                    const changingEntriesLength = changingTemplateEntries.length;
                    const changingTemplateX = new Int8Array(changingEntriesLength);
                    const changingTemplateY = new Int8Array(changingEntriesLength);
                    const changingTemplateBit = new Uint16Array(changingEntriesLength);
                    for(c = 0; c < changingEntriesLength; c++){
                        k = changingTemplateEntries[c];
                        changingTemplateX[c] = template[k].x;
                        changingTemplateY[c] = template[k].y;
                        changingTemplateBit[c] = 1 << templateLength - 1 - k;
                    }
                    const sbb_left = -minX;
                    const sbb_top = -minY;
                    const sbb_right = width - maxX;
                    const pseudoPixelContext = ReusedContexts[templateIndex];
                    let row = new Uint8Array(width);
                    const bitmap = [];
                    const decoder = decodingContext.decoder;
                    const contexts = decodingContext.contextCache.getContexts("GB");
                    let ltp = 0, j, i0, j0, contextLabel = 0, bit, shift;
                    for(let i = 0; i < height; i++){
                        if (prediction) {
                            const sltp = decoder.readBit(contexts, pseudoPixelContext);
                            ltp ^= sltp;
                            if (ltp) {
                                bitmap.push(row);
                                continue;
                            }
                        }
                        row = new Uint8Array(row);
                        bitmap.push(row);
                        for(j = 0; j < width; j++){
                            if (useskip && skip[i][j]) {
                                row[j] = 0;
                                continue;
                            }
                            if (j >= sbb_left && j < sbb_right && i >= sbb_top) {
                                contextLabel = contextLabel << 1 & reuseMask;
                                for(k = 0; k < changingEntriesLength; k++){
                                    i0 = i + changingTemplateY[k];
                                    j0 = j + changingTemplateX[k];
                                    bit = bitmap[i0][j0];
                                    if (bit) {
                                        bit = changingTemplateBit[k];
                                        contextLabel |= bit;
                                    }
                                }
                            } else {
                                contextLabel = 0;
                                shift = templateLength - 1;
                                for(k = 0; k < templateLength; k++, shift--){
                                    j0 = j + templateX[k];
                                    if (j0 >= 0 && j0 < width) {
                                        i0 = i + templateY[k];
                                        if (i0 >= 0) {
                                            bit = bitmap[i0][j0];
                                            if (bit) contextLabel |= bit << shift;
                                        }
                                    }
                                }
                            }
                            const pixel = decoder.readBit(contexts, contextLabel);
                            row[j] = pixel;
                        }
                    }
                    return bitmap;
                }
                function decodeRefinement(width, height, templateIndex, referenceBitmap, offsetX, offsetY, prediction, at, decodingContext) {
                    let codingTemplate = RefinementTemplates[templateIndex].coding;
                    if (templateIndex === 0) codingTemplate = codingTemplate.concat([
                        at[0]
                    ]);
                    const codingTemplateLength = codingTemplate.length;
                    const codingTemplateX = new Int32Array(codingTemplateLength);
                    const codingTemplateY = new Int32Array(codingTemplateLength);
                    let k;
                    for(k = 0; k < codingTemplateLength; k++){
                        codingTemplateX[k] = codingTemplate[k].x;
                        codingTemplateY[k] = codingTemplate[k].y;
                    }
                    let referenceTemplate = RefinementTemplates[templateIndex].reference;
                    if (templateIndex === 0) referenceTemplate = referenceTemplate.concat([
                        at[1]
                    ]);
                    const referenceTemplateLength = referenceTemplate.length;
                    const referenceTemplateX = new Int32Array(referenceTemplateLength);
                    const referenceTemplateY = new Int32Array(referenceTemplateLength);
                    for(k = 0; k < referenceTemplateLength; k++){
                        referenceTemplateX[k] = referenceTemplate[k].x;
                        referenceTemplateY[k] = referenceTemplate[k].y;
                    }
                    const referenceWidth = referenceBitmap[0].length;
                    const referenceHeight = referenceBitmap.length;
                    const pseudoPixelContext = RefinementReusedContexts[templateIndex];
                    const bitmap = [];
                    const decoder = decodingContext.decoder;
                    const contexts = decodingContext.contextCache.getContexts("GR");
                    let ltp = 0;
                    for(let i = 0; i < height; i++){
                        if (prediction) {
                            const sltp = decoder.readBit(contexts, pseudoPixelContext);
                            ltp ^= sltp;
                            if (ltp) throw new Jbig2Error("prediction is not supported");
                        }
                        const row = new Uint8Array(width);
                        bitmap.push(row);
                        for(let j = 0; j < width; j++){
                            let i0, j0;
                            let contextLabel = 0;
                            for(k = 0; k < codingTemplateLength; k++){
                                i0 = i + codingTemplateY[k];
                                j0 = j + codingTemplateX[k];
                                if (i0 < 0 || j0 < 0 || j0 >= width) contextLabel <<= 1;
                                else contextLabel = contextLabel << 1 | bitmap[i0][j0];
                            }
                            for(k = 0; k < referenceTemplateLength; k++){
                                i0 = i + referenceTemplateY[k] - offsetY;
                                j0 = j + referenceTemplateX[k] - offsetX;
                                if (i0 < 0 || i0 >= referenceHeight || j0 < 0 || j0 >= referenceWidth) contextLabel <<= 1;
                                else contextLabel = contextLabel << 1 | referenceBitmap[i0][j0];
                            }
                            const pixel = decoder.readBit(contexts, contextLabel);
                            row[j] = pixel;
                        }
                    }
                    return bitmap;
                }
                function decodeSymbolDictionary(huffman, refinement, symbols, numberOfNewSymbols, numberOfExportedSymbols, huffmanTables, templateIndex, at, refinementTemplateIndex, refinementAt, decodingContext, huffmanInput) {
                    if (huffman && refinement) throw new Jbig2Error("symbol refinement with Huffman is not supported");
                    const newSymbols = [];
                    let currentHeight = 0;
                    let symbolCodeLength = (0, _core_utils.log2)(symbols.length + numberOfNewSymbols);
                    const decoder = decodingContext.decoder;
                    const contextCache = decodingContext.contextCache;
                    let tableB1, symbolWidths;
                    if (huffman) {
                        tableB1 = getStandardTable(1);
                        symbolWidths = [];
                        symbolCodeLength = Math.max(symbolCodeLength, 1);
                    }
                    while(newSymbols.length < numberOfNewSymbols){
                        const deltaHeight = huffman ? huffmanTables.tableDeltaHeight.decode(huffmanInput) : decodeInteger(contextCache, "IADH", decoder);
                        currentHeight += deltaHeight;
                        let currentWidth = 0, totalWidth = 0;
                        const firstSymbol = huffman ? symbolWidths.length : 0;
                        while(true){
                            const deltaWidth = huffman ? huffmanTables.tableDeltaWidth.decode(huffmanInput) : decodeInteger(contextCache, "IADW", decoder);
                            if (deltaWidth === null) break;
                            currentWidth += deltaWidth;
                            totalWidth += currentWidth;
                            let bitmap;
                            if (refinement) {
                                const numberOfInstances = decodeInteger(contextCache, "IAAI", decoder);
                                if (numberOfInstances > 1) bitmap = decodeTextRegion(huffman, refinement, currentWidth, currentHeight, 0, numberOfInstances, 1, symbols.concat(newSymbols), symbolCodeLength, 0, 0, 1, 0, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext, 0, huffmanInput);
                                else {
                                    const symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
                                    const rdx = decodeInteger(contextCache, "IARDX", decoder);
                                    const rdy = decodeInteger(contextCache, "IARDY", decoder);
                                    const symbol = symbolId < symbols.length ? symbols[symbolId] : newSymbols[symbolId - symbols.length];
                                    bitmap = decodeRefinement(currentWidth, currentHeight, refinementTemplateIndex, symbol, rdx, rdy, false, refinementAt, decodingContext);
                                }
                                newSymbols.push(bitmap);
                            } else if (huffman) symbolWidths.push(currentWidth);
                            else {
                                bitmap = decodeBitmap(false, currentWidth, currentHeight, templateIndex, false, null, at, decodingContext);
                                newSymbols.push(bitmap);
                            }
                        }
                        if (huffman && !refinement) {
                            const bitmapSize = huffmanTables.tableBitmapSize.decode(huffmanInput);
                            huffmanInput.byteAlign();
                            let collectiveBitmap;
                            if (bitmapSize === 0) collectiveBitmap = readUncompressedBitmap(huffmanInput, totalWidth, currentHeight);
                            else {
                                const originalEnd = huffmanInput.end;
                                const bitmapEnd = huffmanInput.position + bitmapSize;
                                huffmanInput.end = bitmapEnd;
                                collectiveBitmap = decodeMMRBitmap(huffmanInput, totalWidth, currentHeight, false);
                                huffmanInput.end = originalEnd;
                                huffmanInput.position = bitmapEnd;
                            }
                            const numberOfSymbolsDecoded = symbolWidths.length;
                            if (firstSymbol === numberOfSymbolsDecoded - 1) newSymbols.push(collectiveBitmap);
                            else {
                                let i, y, xMin = 0, xMax, bitmapWidth, symbolBitmap;
                                for(i = firstSymbol; i < numberOfSymbolsDecoded; i++){
                                    bitmapWidth = symbolWidths[i];
                                    xMax = xMin + bitmapWidth;
                                    symbolBitmap = [];
                                    for(y = 0; y < currentHeight; y++)symbolBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
                                    newSymbols.push(symbolBitmap);
                                    xMin = xMax;
                                }
                            }
                        }
                    }
                    const exportedSymbols = [], flags = [];
                    let currentFlag = false, i, ii;
                    const totalSymbolsLength = symbols.length + numberOfNewSymbols;
                    while(flags.length < totalSymbolsLength){
                        let runLength = huffman ? tableB1.decode(huffmanInput) : decodeInteger(contextCache, "IAEX", decoder);
                        while(runLength--)flags.push(currentFlag);
                        currentFlag = !currentFlag;
                    }
                    for(i = 0, ii = symbols.length; i < ii; i++)if (flags[i]) exportedSymbols.push(symbols[i]);
                    for(let j = 0; j < numberOfNewSymbols; i++, j++)if (flags[i]) exportedSymbols.push(newSymbols[j]);
                    return exportedSymbols;
                }
                function decodeTextRegion(huffman, refinement, width, height, defaultPixelValue, numberOfSymbolInstances, stripSize, inputSymbols, symbolCodeLength, transposed, dsOffset, referenceCorner, combinationOperator, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext, logStripSize, huffmanInput) {
                    if (huffman && refinement) throw new Jbig2Error("refinement with Huffman is not supported");
                    const bitmap = [];
                    let i, row;
                    for(i = 0; i < height; i++){
                        row = new Uint8Array(width);
                        if (defaultPixelValue) for(let j = 0; j < width; j++)row[j] = defaultPixelValue;
                        bitmap.push(row);
                    }
                    const decoder = decodingContext.decoder;
                    const contextCache = decodingContext.contextCache;
                    let stripT = huffman ? -huffmanTables.tableDeltaT.decode(huffmanInput) : -decodeInteger(contextCache, "IADT", decoder);
                    let firstS = 0;
                    i = 0;
                    while(i < numberOfSymbolInstances){
                        const deltaT = huffman ? huffmanTables.tableDeltaT.decode(huffmanInput) : decodeInteger(contextCache, "IADT", decoder);
                        stripT += deltaT;
                        const deltaFirstS = huffman ? huffmanTables.tableFirstS.decode(huffmanInput) : decodeInteger(contextCache, "IAFS", decoder);
                        firstS += deltaFirstS;
                        let currentS = firstS;
                        do {
                            let currentT = 0;
                            if (stripSize > 1) currentT = huffman ? huffmanInput.readBits(logStripSize) : decodeInteger(contextCache, "IAIT", decoder);
                            const t = stripSize * stripT + currentT;
                            const symbolId = huffman ? huffmanTables.symbolIDTable.decode(huffmanInput) : decodeIAID(contextCache, decoder, symbolCodeLength);
                            const applyRefinement = refinement && (huffman ? huffmanInput.readBit() : decodeInteger(contextCache, "IARI", decoder));
                            let symbolBitmap = inputSymbols[symbolId];
                            let symbolWidth = symbolBitmap[0].length;
                            let symbolHeight = symbolBitmap.length;
                            if (applyRefinement) {
                                const rdw = decodeInteger(contextCache, "IARDW", decoder);
                                const rdh = decodeInteger(contextCache, "IARDH", decoder);
                                const rdx = decodeInteger(contextCache, "IARDX", decoder);
                                const rdy = decodeInteger(contextCache, "IARDY", decoder);
                                symbolWidth += rdw;
                                symbolHeight += rdh;
                                symbolBitmap = decodeRefinement(symbolWidth, symbolHeight, refinementTemplateIndex, symbolBitmap, (rdw >> 1) + rdx, (rdh >> 1) + rdy, false, refinementAt, decodingContext);
                            }
                            const offsetT = t - (referenceCorner & 1 ? 0 : symbolHeight - 1);
                            const offsetS = currentS - (referenceCorner & 2 ? symbolWidth - 1 : 0);
                            let s2, t2, symbolRow;
                            if (transposed) {
                                for(s2 = 0; s2 < symbolHeight; s2++){
                                    row = bitmap[offsetS + s2];
                                    if (!row) continue;
                                    symbolRow = symbolBitmap[s2];
                                    const maxWidth = Math.min(width - offsetT, symbolWidth);
                                    switch(combinationOperator){
                                        case 0:
                                            for(t2 = 0; t2 < maxWidth; t2++)row[offsetT + t2] |= symbolRow[t2];
                                            break;
                                        case 2:
                                            for(t2 = 0; t2 < maxWidth; t2++)row[offsetT + t2] ^= symbolRow[t2];
                                            break;
                                        default:
                                            throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                                    }
                                }
                                currentS += symbolHeight - 1;
                            } else {
                                for(t2 = 0; t2 < symbolHeight; t2++){
                                    row = bitmap[offsetT + t2];
                                    if (!row) continue;
                                    symbolRow = symbolBitmap[t2];
                                    switch(combinationOperator){
                                        case 0:
                                            for(s2 = 0; s2 < symbolWidth; s2++)row[offsetS + s2] |= symbolRow[s2];
                                            break;
                                        case 2:
                                            for(s2 = 0; s2 < symbolWidth; s2++)row[offsetS + s2] ^= symbolRow[s2];
                                            break;
                                        default:
                                            throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                                    }
                                }
                                currentS += symbolWidth - 1;
                            }
                            i++;
                            const deltaS = huffman ? huffmanTables.tableDeltaS.decode(huffmanInput) : decodeInteger(contextCache, "IADS", decoder);
                            if (deltaS === null) break;
                            currentS += deltaS + dsOffset;
                        }while (true);
                    }
                    return bitmap;
                }
                function decodePatternDictionary(mmr, patternWidth, patternHeight, maxPatternIndex, template, decodingContext) {
                    const at = [];
                    if (!mmr) {
                        at.push({
                            x: -patternWidth,
                            y: 0
                        });
                        if (template === 0) at.push({
                            x: -3,
                            y: -1
                        }, {
                            x: 2,
                            y: -2
                        }, {
                            x: -2,
                            y: -2
                        });
                    }
                    const collectiveWidth = (maxPatternIndex + 1) * patternWidth;
                    const collectiveBitmap = decodeBitmap(mmr, collectiveWidth, patternHeight, template, false, null, at, decodingContext);
                    const patterns = [];
                    for(let i = 0; i <= maxPatternIndex; i++){
                        const patternBitmap = [];
                        const xMin = patternWidth * i;
                        const xMax = xMin + patternWidth;
                        for(let y = 0; y < patternHeight; y++)patternBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
                        patterns.push(patternBitmap);
                    }
                    return patterns;
                }
                function decodeHalftoneRegion(mmr, patterns, template, regionWidth, regionHeight, defaultPixelValue, enableSkip, combinationOperator, gridWidth, gridHeight, gridOffsetX, gridOffsetY, gridVectorX, gridVectorY, decodingContext) {
                    const skip = null;
                    if (enableSkip) throw new Jbig2Error("skip is not supported");
                    if (combinationOperator !== 0) throw new Jbig2Error(`operator "${combinationOperator}" is not supported in halftone region`);
                    const regionBitmap = [];
                    let i, j, row;
                    for(i = 0; i < regionHeight; i++){
                        row = new Uint8Array(regionWidth);
                        if (defaultPixelValue) for(j = 0; j < regionWidth; j++)row[j] = defaultPixelValue;
                        regionBitmap.push(row);
                    }
                    const numberOfPatterns = patterns.length;
                    const pattern0 = patterns[0];
                    const patternWidth = pattern0[0].length, patternHeight = pattern0.length;
                    const bitsPerValue = (0, _core_utils.log2)(numberOfPatterns);
                    const at = [];
                    if (!mmr) {
                        at.push({
                            x: template <= 1 ? 3 : 2,
                            y: -1
                        });
                        if (template === 0) at.push({
                            x: -3,
                            y: -1
                        }, {
                            x: 2,
                            y: -2
                        }, {
                            x: -2,
                            y: -2
                        });
                    }
                    const grayScaleBitPlanes = [];
                    let mmrInput, bitmap;
                    if (mmr) mmrInput = new Reader(decodingContext.data, decodingContext.start, decodingContext.end);
                    for(i = bitsPerValue - 1; i >= 0; i--){
                        if (mmr) bitmap = decodeMMRBitmap(mmrInput, gridWidth, gridHeight, true);
                        else bitmap = decodeBitmap(false, gridWidth, gridHeight, template, false, skip, at, decodingContext);
                        grayScaleBitPlanes[i] = bitmap;
                    }
                    let mg, ng, bit, patternIndex, patternBitmap, x, y, patternRow, regionRow;
                    for(mg = 0; mg < gridHeight; mg++)for(ng = 0; ng < gridWidth; ng++){
                        bit = 0;
                        patternIndex = 0;
                        for(j = bitsPerValue - 1; j >= 0; j--){
                            bit ^= grayScaleBitPlanes[j][mg][ng];
                            patternIndex |= bit << j;
                        }
                        patternBitmap = patterns[patternIndex];
                        x = gridOffsetX + mg * gridVectorY + ng * gridVectorX >> 8;
                        y = gridOffsetY + mg * gridVectorX - ng * gridVectorY >> 8;
                        if (x >= 0 && x + patternWidth <= regionWidth && y >= 0 && y + patternHeight <= regionHeight) for(i = 0; i < patternHeight; i++){
                            regionRow = regionBitmap[y + i];
                            patternRow = patternBitmap[i];
                            for(j = 0; j < patternWidth; j++)regionRow[x + j] |= patternRow[j];
                        }
                        else {
                            let regionX, regionY;
                            for(i = 0; i < patternHeight; i++){
                                regionY = y + i;
                                if (regionY < 0 || regionY >= regionHeight) continue;
                                regionRow = regionBitmap[regionY];
                                patternRow = patternBitmap[i];
                                for(j = 0; j < patternWidth; j++){
                                    regionX = x + j;
                                    if (regionX >= 0 && regionX < regionWidth) regionRow[regionX] |= patternRow[j];
                                }
                            }
                        }
                    }
                    return regionBitmap;
                }
                function readSegmentHeader(data, start) {
                    const segmentHeader = {};
                    segmentHeader.number = (0, _core_utils.readUint32)(data, start);
                    const flags = data[start + 4];
                    const segmentType = flags & 0x3f;
                    if (!SegmentTypes[segmentType]) throw new Jbig2Error("invalid segment type: " + segmentType);
                    segmentHeader.type = segmentType;
                    segmentHeader.typeName = SegmentTypes[segmentType];
                    segmentHeader.deferredNonRetain = !!(flags & 0x80);
                    const pageAssociationFieldSize = !!(flags & 0x40);
                    const referredFlags = data[start + 5];
                    let referredToCount = referredFlags >> 5 & 7;
                    const retainBits = [
                        referredFlags & 31
                    ];
                    let position = start + 6;
                    if (referredFlags === 7) {
                        referredToCount = (0, _core_utils.readUint32)(data, position - 1) & 0x1fffffff;
                        position += 3;
                        let bytes = referredToCount + 7 >> 3;
                        retainBits[0] = data[position++];
                        while(--bytes > 0)retainBits.push(data[position++]);
                    } else if (referredFlags === 5 || referredFlags === 6) throw new Jbig2Error("invalid referred-to flags");
                    segmentHeader.retainBits = retainBits;
                    let referredToSegmentNumberSize = 4;
                    if (segmentHeader.number <= 256) referredToSegmentNumberSize = 1;
                    else if (segmentHeader.number <= 65536) referredToSegmentNumberSize = 2;
                    const referredTo = [];
                    let i, ii;
                    for(i = 0; i < referredToCount; i++){
                        let number;
                        if (referredToSegmentNumberSize === 1) number = data[position];
                        else if (referredToSegmentNumberSize === 2) number = (0, _core_utils.readUint16)(data, position);
                        else number = (0, _core_utils.readUint32)(data, position);
                        referredTo.push(number);
                        position += referredToSegmentNumberSize;
                    }
                    segmentHeader.referredTo = referredTo;
                    if (!pageAssociationFieldSize) segmentHeader.pageAssociation = data[position++];
                    else {
                        segmentHeader.pageAssociation = (0, _core_utils.readUint32)(data, position);
                        position += 4;
                    }
                    segmentHeader.length = (0, _core_utils.readUint32)(data, position);
                    position += 4;
                    if (segmentHeader.length === 0xffffffff) {
                        if (segmentType === 38) {
                            const genericRegionInfo = readRegionSegmentInformation(data, position);
                            const genericRegionSegmentFlags = data[position + RegionSegmentInformationFieldLength];
                            const genericRegionMmr = !!(genericRegionSegmentFlags & 1);
                            const searchPatternLength = 6;
                            const searchPattern = new Uint8Array(searchPatternLength);
                            if (!genericRegionMmr) {
                                searchPattern[0] = 0xff;
                                searchPattern[1] = 0xac;
                            }
                            searchPattern[2] = genericRegionInfo.height >>> 24 & 0xff;
                            searchPattern[3] = genericRegionInfo.height >> 16 & 0xff;
                            searchPattern[4] = genericRegionInfo.height >> 8 & 0xff;
                            searchPattern[5] = genericRegionInfo.height & 0xff;
                            for(i = position, ii = data.length; i < ii; i++){
                                let j = 0;
                                while(j < searchPatternLength && searchPattern[j] === data[i + j])j++;
                                if (j === searchPatternLength) {
                                    segmentHeader.length = i + searchPatternLength;
                                    break;
                                }
                            }
                            if (segmentHeader.length === 0xffffffff) throw new Jbig2Error("segment end was not found");
                        } else throw new Jbig2Error("invalid unknown segment length");
                    }
                    segmentHeader.headerEnd = position;
                    return segmentHeader;
                }
                function readSegments(header, data, start, end) {
                    const segments = [];
                    let position = start;
                    while(position < end){
                        const segmentHeader = readSegmentHeader(data, position);
                        position = segmentHeader.headerEnd;
                        const segment = {
                            header: segmentHeader,
                            data: data
                        };
                        if (!header.randomAccess) {
                            segment.start = position;
                            position += segmentHeader.length;
                            segment.end = position;
                        }
                        segments.push(segment);
                        if (segmentHeader.type === 51) break;
                    }
                    if (header.randomAccess) for(let i = 0, ii = segments.length; i < ii; i++){
                        segments[i].start = position;
                        position += segments[i].header.length;
                        segments[i].end = position;
                    }
                    return segments;
                }
                function readRegionSegmentInformation(data, start) {
                    return {
                        width: (0, _core_utils.readUint32)(data, start),
                        height: (0, _core_utils.readUint32)(data, start + 4),
                        x: (0, _core_utils.readUint32)(data, start + 8),
                        y: (0, _core_utils.readUint32)(data, start + 12),
                        combinationOperator: data[start + 16] & 7
                    };
                }
                const RegionSegmentInformationFieldLength = 17;
                function processSegment(segment, visitor) {
                    const header = segment.header;
                    const data = segment.data, end = segment.end;
                    let position = segment.start;
                    let args, at, i, atLength;
                    switch(header.type){
                        case 0:
                            const dictionary = {};
                            const dictionaryFlags = (0, _core_utils.readUint16)(data, position);
                            dictionary.huffman = !!(dictionaryFlags & 1);
                            dictionary.refinement = !!(dictionaryFlags & 2);
                            dictionary.huffmanDHSelector = dictionaryFlags >> 2 & 3;
                            dictionary.huffmanDWSelector = dictionaryFlags >> 4 & 3;
                            dictionary.bitmapSizeSelector = dictionaryFlags >> 6 & 1;
                            dictionary.aggregationInstancesSelector = dictionaryFlags >> 7 & 1;
                            dictionary.bitmapCodingContextUsed = !!(dictionaryFlags & 256);
                            dictionary.bitmapCodingContextRetained = !!(dictionaryFlags & 512);
                            dictionary.template = dictionaryFlags >> 10 & 3;
                            dictionary.refinementTemplate = dictionaryFlags >> 12 & 1;
                            position += 2;
                            if (!dictionary.huffman) {
                                atLength = dictionary.template === 0 ? 4 : 1;
                                at = [];
                                for(i = 0; i < atLength; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                dictionary.at = at;
                            }
                            if (dictionary.refinement && !dictionary.refinementTemplate) {
                                at = [];
                                for(i = 0; i < 2; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                dictionary.refinementAt = at;
                            }
                            dictionary.numberOfExportedSymbols = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            dictionary.numberOfNewSymbols = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            args = [
                                dictionary,
                                header.number,
                                header.referredTo,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 6:
                        case 7:
                            const textRegion = {};
                            textRegion.info = readRegionSegmentInformation(data, position);
                            position += RegionSegmentInformationFieldLength;
                            const textRegionSegmentFlags = (0, _core_utils.readUint16)(data, position);
                            position += 2;
                            textRegion.huffman = !!(textRegionSegmentFlags & 1);
                            textRegion.refinement = !!(textRegionSegmentFlags & 2);
                            textRegion.logStripSize = textRegionSegmentFlags >> 2 & 3;
                            textRegion.stripSize = 1 << textRegion.logStripSize;
                            textRegion.referenceCorner = textRegionSegmentFlags >> 4 & 3;
                            textRegion.transposed = !!(textRegionSegmentFlags & 64);
                            textRegion.combinationOperator = textRegionSegmentFlags >> 7 & 3;
                            textRegion.defaultPixelValue = textRegionSegmentFlags >> 9 & 1;
                            textRegion.dsOffset = textRegionSegmentFlags << 17 >> 27;
                            textRegion.refinementTemplate = textRegionSegmentFlags >> 15 & 1;
                            if (textRegion.huffman) {
                                const textRegionHuffmanFlags = (0, _core_utils.readUint16)(data, position);
                                position += 2;
                                textRegion.huffmanFS = textRegionHuffmanFlags & 3;
                                textRegion.huffmanDS = textRegionHuffmanFlags >> 2 & 3;
                                textRegion.huffmanDT = textRegionHuffmanFlags >> 4 & 3;
                                textRegion.huffmanRefinementDW = textRegionHuffmanFlags >> 6 & 3;
                                textRegion.huffmanRefinementDH = textRegionHuffmanFlags >> 8 & 3;
                                textRegion.huffmanRefinementDX = textRegionHuffmanFlags >> 10 & 3;
                                textRegion.huffmanRefinementDY = textRegionHuffmanFlags >> 12 & 3;
                                textRegion.huffmanRefinementSizeSelector = !!(textRegionHuffmanFlags & 0x4000);
                            }
                            if (textRegion.refinement && !textRegion.refinementTemplate) {
                                at = [];
                                for(i = 0; i < 2; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                textRegion.refinementAt = at;
                            }
                            textRegion.numberOfSymbolInstances = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            args = [
                                textRegion,
                                header.referredTo,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 16:
                            const patternDictionary = {};
                            const patternDictionaryFlags = data[position++];
                            patternDictionary.mmr = !!(patternDictionaryFlags & 1);
                            patternDictionary.template = patternDictionaryFlags >> 1 & 3;
                            patternDictionary.patternWidth = data[position++];
                            patternDictionary.patternHeight = data[position++];
                            patternDictionary.maxPatternIndex = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            args = [
                                patternDictionary,
                                header.number,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 22:
                        case 23:
                            const halftoneRegion = {};
                            halftoneRegion.info = readRegionSegmentInformation(data, position);
                            position += RegionSegmentInformationFieldLength;
                            const halftoneRegionFlags = data[position++];
                            halftoneRegion.mmr = !!(halftoneRegionFlags & 1);
                            halftoneRegion.template = halftoneRegionFlags >> 1 & 3;
                            halftoneRegion.enableSkip = !!(halftoneRegionFlags & 8);
                            halftoneRegion.combinationOperator = halftoneRegionFlags >> 4 & 7;
                            halftoneRegion.defaultPixelValue = halftoneRegionFlags >> 7 & 1;
                            halftoneRegion.gridWidth = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            halftoneRegion.gridHeight = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            halftoneRegion.gridOffsetX = (0, _core_utils.readUint32)(data, position) & 0xffffffff;
                            position += 4;
                            halftoneRegion.gridOffsetY = (0, _core_utils.readUint32)(data, position) & 0xffffffff;
                            position += 4;
                            halftoneRegion.gridVectorX = (0, _core_utils.readUint16)(data, position);
                            position += 2;
                            halftoneRegion.gridVectorY = (0, _core_utils.readUint16)(data, position);
                            position += 2;
                            args = [
                                halftoneRegion,
                                header.referredTo,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 38:
                        case 39:
                            const genericRegion = {};
                            genericRegion.info = readRegionSegmentInformation(data, position);
                            position += RegionSegmentInformationFieldLength;
                            const genericRegionSegmentFlags = data[position++];
                            genericRegion.mmr = !!(genericRegionSegmentFlags & 1);
                            genericRegion.template = genericRegionSegmentFlags >> 1 & 3;
                            genericRegion.prediction = !!(genericRegionSegmentFlags & 8);
                            if (!genericRegion.mmr) {
                                atLength = genericRegion.template === 0 ? 4 : 1;
                                at = [];
                                for(i = 0; i < atLength; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                genericRegion.at = at;
                            }
                            args = [
                                genericRegion,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 48:
                            const pageInfo = {
                                width: (0, _core_utils.readUint32)(data, position),
                                height: (0, _core_utils.readUint32)(data, position + 4),
                                resolutionX: (0, _core_utils.readUint32)(data, position + 8),
                                resolutionY: (0, _core_utils.readUint32)(data, position + 12)
                            };
                            if (pageInfo.height === 0xffffffff) delete pageInfo.height;
                            const pageSegmentFlags = data[position + 16];
                            (0, _core_utils.readUint16)(data, position + 17);
                            pageInfo.lossless = !!(pageSegmentFlags & 1);
                            pageInfo.refinement = !!(pageSegmentFlags & 2);
                            pageInfo.defaultPixelValue = pageSegmentFlags >> 2 & 1;
                            pageInfo.combinationOperator = pageSegmentFlags >> 3 & 3;
                            pageInfo.requiresBuffer = !!(pageSegmentFlags & 32);
                            pageInfo.combinationOperatorOverride = !!(pageSegmentFlags & 64);
                            args = [
                                pageInfo
                            ];
                            break;
                        case 49:
                            break;
                        case 50:
                            break;
                        case 51:
                            break;
                        case 53:
                            args = [
                                header.number,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 62:
                            break;
                        default:
                            throw new Jbig2Error(`segment type ${header.typeName}(${header.type}) is not implemented`);
                    }
                    const callbackName = "on" + header.typeName;
                    if (callbackName in visitor) visitor[callbackName].apply(visitor, args);
                }
                function processSegments(segments, visitor) {
                    for(let i = 0, ii = segments.length; i < ii; i++)processSegment(segments[i], visitor);
                }
                function parseJbig2Chunks(chunks) {
                    const visitor = new SimpleSegmentVisitor();
                    for(let i = 0, ii = chunks.length; i < ii; i++){
                        const chunk = chunks[i];
                        const segments = readSegments({}, chunk.data, chunk.start, chunk.end);
                        processSegments(segments, visitor);
                    }
                    return visitor.buffer;
                }
                function parseJbig2(data) {
                    throw new Error("Not implemented: parseJbig2");
                }
                class SimpleSegmentVisitor {
                    onPageInformation(info) {
                        this.currentPageInfo = info;
                        const rowSize = info.width + 7 >> 3;
                        const buffer = new Uint8ClampedArray(rowSize * info.height);
                        if (info.defaultPixelValue) buffer.fill(0xff);
                        this.buffer = buffer;
                    }
                    drawBitmap(regionInfo, bitmap) {
                        const pageInfo = this.currentPageInfo;
                        const width = regionInfo.width, height = regionInfo.height;
                        const rowSize = pageInfo.width + 7 >> 3;
                        const combinationOperator = pageInfo.combinationOperatorOverride ? regionInfo.combinationOperator : pageInfo.combinationOperator;
                        const buffer = this.buffer;
                        const mask0 = 128 >> (regionInfo.x & 7);
                        let offset0 = regionInfo.y * rowSize + (regionInfo.x >> 3);
                        let i, j, mask, offset;
                        switch(combinationOperator){
                            case 0:
                                for(i = 0; i < height; i++){
                                    mask = mask0;
                                    offset = offset0;
                                    for(j = 0; j < width; j++){
                                        if (bitmap[i][j]) buffer[offset] |= mask;
                                        mask >>= 1;
                                        if (!mask) {
                                            mask = 128;
                                            offset++;
                                        }
                                    }
                                    offset0 += rowSize;
                                }
                                break;
                            case 2:
                                for(i = 0; i < height; i++){
                                    mask = mask0;
                                    offset = offset0;
                                    for(j = 0; j < width; j++){
                                        if (bitmap[i][j]) buffer[offset] ^= mask;
                                        mask >>= 1;
                                        if (!mask) {
                                            mask = 128;
                                            offset++;
                                        }
                                    }
                                    offset0 += rowSize;
                                }
                                break;
                            default:
                                throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                        }
                    }
                    onImmediateGenericRegion(region, data, start, end) {
                        const regionInfo = region.info;
                        const decodingContext = new DecodingContext(data, start, end);
                        const bitmap = decodeBitmap(region.mmr, regionInfo.width, regionInfo.height, region.template, region.prediction, null, region.at, decodingContext);
                        this.drawBitmap(regionInfo, bitmap);
                    }
                    onImmediateLosslessGenericRegion() {
                        this.onImmediateGenericRegion(...arguments);
                    }
                    onSymbolDictionary(dictionary, currentSegment, referredSegments, data, start, end) {
                        let huffmanTables, huffmanInput;
                        if (dictionary.huffman) {
                            huffmanTables = getSymbolDictionaryHuffmanTables(dictionary, referredSegments, this.customTables);
                            huffmanInput = new Reader(data, start, end);
                        }
                        let symbols = this.symbols;
                        if (!symbols) this.symbols = symbols = {};
                        const inputSymbols = [];
                        for (const referredSegment of referredSegments){
                            const referredSymbols = symbols[referredSegment];
                            if (referredSymbols) inputSymbols.push(...referredSymbols);
                        }
                        const decodingContext = new DecodingContext(data, start, end);
                        symbols[currentSegment] = decodeSymbolDictionary(dictionary.huffman, dictionary.refinement, inputSymbols, dictionary.numberOfNewSymbols, dictionary.numberOfExportedSymbols, huffmanTables, dictionary.template, dictionary.at, dictionary.refinementTemplate, dictionary.refinementAt, decodingContext, huffmanInput);
                    }
                    onImmediateTextRegion(region, referredSegments, data, start, end) {
                        const regionInfo = region.info;
                        let huffmanTables, huffmanInput;
                        const symbols = this.symbols;
                        const inputSymbols = [];
                        for (const referredSegment of referredSegments){
                            const referredSymbols = symbols[referredSegment];
                            if (referredSymbols) inputSymbols.push(...referredSymbols);
                        }
                        const symbolCodeLength = (0, _core_utils.log2)(inputSymbols.length);
                        if (region.huffman) {
                            huffmanInput = new Reader(data, start, end);
                            huffmanTables = getTextRegionHuffmanTables(region, referredSegments, this.customTables, inputSymbols.length, huffmanInput);
                        }
                        const decodingContext = new DecodingContext(data, start, end);
                        const bitmap = decodeTextRegion(region.huffman, region.refinement, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.numberOfSymbolInstances, region.stripSize, inputSymbols, symbolCodeLength, region.transposed, region.dsOffset, region.referenceCorner, region.combinationOperator, huffmanTables, region.refinementTemplate, region.refinementAt, decodingContext, region.logStripSize, huffmanInput);
                        this.drawBitmap(regionInfo, bitmap);
                    }
                    onImmediateLosslessTextRegion() {
                        this.onImmediateTextRegion(...arguments);
                    }
                    onPatternDictionary(dictionary, currentSegment, data, start, end) {
                        let patterns = this.patterns;
                        if (!patterns) this.patterns = patterns = {};
                        const decodingContext = new DecodingContext(data, start, end);
                        patterns[currentSegment] = decodePatternDictionary(dictionary.mmr, dictionary.patternWidth, dictionary.patternHeight, dictionary.maxPatternIndex, dictionary.template, decodingContext);
                    }
                    onImmediateHalftoneRegion(region, referredSegments, data, start, end) {
                        const patterns = this.patterns[referredSegments[0]];
                        const regionInfo = region.info;
                        const decodingContext = new DecodingContext(data, start, end);
                        const bitmap = decodeHalftoneRegion(region.mmr, patterns, region.template, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.enableSkip, region.combinationOperator, region.gridWidth, region.gridHeight, region.gridOffsetX, region.gridOffsetY, region.gridVectorX, region.gridVectorY, decodingContext);
                        this.drawBitmap(regionInfo, bitmap);
                    }
                    onImmediateLosslessHalftoneRegion() {
                        this.onImmediateHalftoneRegion(...arguments);
                    }
                    onTables(currentSegment, data, start, end) {
                        let customTables = this.customTables;
                        if (!customTables) this.customTables = customTables = {};
                        customTables[currentSegment] = decodeTablesSegment(data, start, end);
                    }
                }
                class HuffmanLine {
                    constructor(lineData){
                        if (lineData.length === 2) {
                            this.isOOB = true;
                            this.rangeLow = 0;
                            this.prefixLength = lineData[0];
                            this.rangeLength = 0;
                            this.prefixCode = lineData[1];
                            this.isLowerRange = false;
                        } else {
                            this.isOOB = false;
                            this.rangeLow = lineData[0];
                            this.prefixLength = lineData[1];
                            this.rangeLength = lineData[2];
                            this.prefixCode = lineData[3];
                            this.isLowerRange = lineData[4] === "lower";
                        }
                    }
                }
                class HuffmanTreeNode {
                    constructor(line){
                        this.children = [];
                        if (line) {
                            this.isLeaf = true;
                            this.rangeLength = line.rangeLength;
                            this.rangeLow = line.rangeLow;
                            this.isLowerRange = line.isLowerRange;
                            this.isOOB = line.isOOB;
                        } else this.isLeaf = false;
                    }
                    buildTree(line, shift) {
                        const bit = line.prefixCode >> shift & 1;
                        if (shift <= 0) this.children[bit] = new HuffmanTreeNode(line);
                        else {
                            let node = this.children[bit];
                            if (!node) this.children[bit] = node = new HuffmanTreeNode(null);
                            node.buildTree(line, shift - 1);
                        }
                    }
                    decodeNode(reader) {
                        if (this.isLeaf) {
                            if (this.isOOB) return null;
                            const htOffset = reader.readBits(this.rangeLength);
                            return this.rangeLow + (this.isLowerRange ? -htOffset : htOffset);
                        }
                        const node = this.children[reader.readBit()];
                        if (!node) throw new Jbig2Error("invalid Huffman data");
                        return node.decodeNode(reader);
                    }
                }
                class HuffmanTable {
                    constructor(lines, prefixCodesDone){
                        if (!prefixCodesDone) this.assignPrefixCodes(lines);
                        this.rootNode = new HuffmanTreeNode(null);
                        for(let i = 0, ii = lines.length; i < ii; i++){
                            const line = lines[i];
                            if (line.prefixLength > 0) this.rootNode.buildTree(line, line.prefixLength - 1);
                        }
                    }
                    decode(reader) {
                        return this.rootNode.decodeNode(reader);
                    }
                    assignPrefixCodes(lines) {
                        const linesLength = lines.length;
                        let prefixLengthMax = 0;
                        for(let i = 0; i < linesLength; i++)prefixLengthMax = Math.max(prefixLengthMax, lines[i].prefixLength);
                        const histogram = new Uint32Array(prefixLengthMax + 1);
                        for(let i = 0; i < linesLength; i++)histogram[lines[i].prefixLength]++;
                        let currentLength = 1, firstCode = 0, currentCode, currentTemp, line;
                        histogram[0] = 0;
                        while(currentLength <= prefixLengthMax){
                            firstCode = firstCode + histogram[currentLength - 1] << 1;
                            currentCode = firstCode;
                            currentTemp = 0;
                            while(currentTemp < linesLength){
                                line = lines[currentTemp];
                                if (line.prefixLength === currentLength) {
                                    line.prefixCode = currentCode;
                                    currentCode++;
                                }
                                currentTemp++;
                            }
                            currentLength++;
                        }
                    }
                }
                function decodeTablesSegment(data, start, end) {
                    const flags = data[start];
                    const lowestValue = (0, _core_utils.readUint32)(data, start + 1) & 0xffffffff;
                    const highestValue = (0, _core_utils.readUint32)(data, start + 5) & 0xffffffff;
                    const reader = new Reader(data, start + 9, end);
                    const prefixSizeBits = (flags >> 1 & 7) + 1;
                    const rangeSizeBits = (flags >> 4 & 7) + 1;
                    const lines = [];
                    let prefixLength, rangeLength, currentRangeLow = lowestValue;
                    do {
                        prefixLength = reader.readBits(prefixSizeBits);
                        rangeLength = reader.readBits(rangeSizeBits);
                        lines.push(new HuffmanLine([
                            currentRangeLow,
                            prefixLength,
                            rangeLength,
                            0
                        ]));
                        currentRangeLow += 1 << rangeLength;
                    }while (currentRangeLow < highestValue);
                    prefixLength = reader.readBits(prefixSizeBits);
                    lines.push(new HuffmanLine([
                        lowestValue - 1,
                        prefixLength,
                        32,
                        0,
                        "lower"
                    ]));
                    prefixLength = reader.readBits(prefixSizeBits);
                    lines.push(new HuffmanLine([
                        highestValue,
                        prefixLength,
                        32,
                        0
                    ]));
                    if (flags & 1) {
                        prefixLength = reader.readBits(prefixSizeBits);
                        lines.push(new HuffmanLine([
                            prefixLength,
                            0
                        ]));
                    }
                    return new HuffmanTable(lines, false);
                }
                const standardTablesCache = {};
                function getStandardTable(number) {
                    let table = standardTablesCache[number];
                    if (table) return table;
                    let lines;
                    switch(number){
                        case 1:
                            lines = [
                                [
                                    0,
                                    1,
                                    4,
                                    0x0
                                ],
                                [
                                    16,
                                    2,
                                    8,
                                    0x2
                                ],
                                [
                                    272,
                                    3,
                                    16,
                                    0x6
                                ],
                                [
                                    65808,
                                    3,
                                    32,
                                    0x7
                                ]
                            ];
                            break;
                        case 2:
                            lines = [
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    3,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    11,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    75,
                                    6,
                                    32,
                                    0x3e
                                ],
                                [
                                    6,
                                    0x3f
                                ]
                            ];
                            break;
                        case 3:
                            lines = [
                                [
                                    -256,
                                    8,
                                    8,
                                    0xfe
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    3,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    11,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    -257,
                                    8,
                                    32,
                                    0xff,
                                    "lower"
                                ],
                                [
                                    75,
                                    7,
                                    32,
                                    0x7e
                                ],
                                [
                                    6,
                                    0x3e
                                ]
                            ];
                            break;
                        case 4:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    3,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    4,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    12,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    76,
                                    5,
                                    32,
                                    0x1f
                                ]
                            ];
                            break;
                        case 5:
                            lines = [
                                [
                                    -255,
                                    7,
                                    8,
                                    0x7e
                                ],
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    3,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    4,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    12,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    -256,
                                    7,
                                    32,
                                    0x7f,
                                    "lower"
                                ],
                                [
                                    76,
                                    6,
                                    32,
                                    0x3e
                                ]
                            ];
                            break;
                        case 6:
                            lines = [
                                [
                                    -2048,
                                    5,
                                    10,
                                    0x1c
                                ],
                                [
                                    -1024,
                                    4,
                                    9,
                                    0x8
                                ],
                                [
                                    -512,
                                    4,
                                    8,
                                    0x9
                                ],
                                [
                                    -256,
                                    4,
                                    7,
                                    0xa
                                ],
                                [
                                    -128,
                                    5,
                                    6,
                                    0x1d
                                ],
                                [
                                    -64,
                                    5,
                                    5,
                                    0x1e
                                ],
                                [
                                    -32,
                                    4,
                                    5,
                                    0xb
                                ],
                                [
                                    0,
                                    2,
                                    7,
                                    0x0
                                ],
                                [
                                    128,
                                    3,
                                    7,
                                    0x2
                                ],
                                [
                                    256,
                                    3,
                                    8,
                                    0x3
                                ],
                                [
                                    512,
                                    4,
                                    9,
                                    0xc
                                ],
                                [
                                    1024,
                                    4,
                                    10,
                                    0xd
                                ],
                                [
                                    -2049,
                                    6,
                                    32,
                                    0x3e,
                                    "lower"
                                ],
                                [
                                    2048,
                                    6,
                                    32,
                                    0x3f
                                ]
                            ];
                            break;
                        case 7:
                            lines = [
                                [
                                    -1024,
                                    4,
                                    9,
                                    0x8
                                ],
                                [
                                    -512,
                                    3,
                                    8,
                                    0x0
                                ],
                                [
                                    -256,
                                    4,
                                    7,
                                    0x9
                                ],
                                [
                                    -128,
                                    5,
                                    6,
                                    0x1a
                                ],
                                [
                                    -64,
                                    5,
                                    5,
                                    0x1b
                                ],
                                [
                                    -32,
                                    4,
                                    5,
                                    0xa
                                ],
                                [
                                    0,
                                    4,
                                    5,
                                    0xb
                                ],
                                [
                                    32,
                                    5,
                                    5,
                                    0x1c
                                ],
                                [
                                    64,
                                    5,
                                    6,
                                    0x1d
                                ],
                                [
                                    128,
                                    4,
                                    7,
                                    0xc
                                ],
                                [
                                    256,
                                    3,
                                    8,
                                    0x1
                                ],
                                [
                                    512,
                                    3,
                                    9,
                                    0x2
                                ],
                                [
                                    1024,
                                    3,
                                    10,
                                    0x3
                                ],
                                [
                                    -1025,
                                    5,
                                    32,
                                    0x1e,
                                    "lower"
                                ],
                                [
                                    2048,
                                    5,
                                    32,
                                    0x1f
                                ]
                            ];
                            break;
                        case 8:
                            lines = [
                                [
                                    -15,
                                    8,
                                    3,
                                    0xfc
                                ],
                                [
                                    -7,
                                    9,
                                    1,
                                    0x1fc
                                ],
                                [
                                    -5,
                                    8,
                                    1,
                                    0xfd
                                ],
                                [
                                    -3,
                                    9,
                                    0,
                                    0x1fd
                                ],
                                [
                                    -2,
                                    7,
                                    0,
                                    0x7c
                                ],
                                [
                                    -1,
                                    4,
                                    0,
                                    0xa
                                ],
                                [
                                    0,
                                    2,
                                    1,
                                    0x0
                                ],
                                [
                                    2,
                                    5,
                                    0,
                                    0x1a
                                ],
                                [
                                    3,
                                    6,
                                    0,
                                    0x3a
                                ],
                                [
                                    4,
                                    3,
                                    4,
                                    0x4
                                ],
                                [
                                    20,
                                    6,
                                    1,
                                    0x3b
                                ],
                                [
                                    22,
                                    4,
                                    4,
                                    0xb
                                ],
                                [
                                    38,
                                    4,
                                    5,
                                    0xc
                                ],
                                [
                                    70,
                                    5,
                                    6,
                                    0x1b
                                ],
                                [
                                    134,
                                    5,
                                    7,
                                    0x1c
                                ],
                                [
                                    262,
                                    6,
                                    7,
                                    0x3c
                                ],
                                [
                                    390,
                                    7,
                                    8,
                                    0x7d
                                ],
                                [
                                    646,
                                    6,
                                    10,
                                    0x3d
                                ],
                                [
                                    -16,
                                    9,
                                    32,
                                    0x1fe,
                                    "lower"
                                ],
                                [
                                    1670,
                                    9,
                                    32,
                                    0x1ff
                                ],
                                [
                                    2,
                                    0x1
                                ]
                            ];
                            break;
                        case 9:
                            lines = [
                                [
                                    -31,
                                    8,
                                    4,
                                    0xfc
                                ],
                                [
                                    -15,
                                    9,
                                    2,
                                    0x1fc
                                ],
                                [
                                    -11,
                                    8,
                                    2,
                                    0xfd
                                ],
                                [
                                    -7,
                                    9,
                                    1,
                                    0x1fd
                                ],
                                [
                                    -5,
                                    7,
                                    1,
                                    0x7c
                                ],
                                [
                                    -3,
                                    4,
                                    1,
                                    0xa
                                ],
                                [
                                    -1,
                                    3,
                                    1,
                                    0x2
                                ],
                                [
                                    1,
                                    3,
                                    1,
                                    0x3
                                ],
                                [
                                    3,
                                    5,
                                    1,
                                    0x1a
                                ],
                                [
                                    5,
                                    6,
                                    1,
                                    0x3a
                                ],
                                [
                                    7,
                                    3,
                                    5,
                                    0x4
                                ],
                                [
                                    39,
                                    6,
                                    2,
                                    0x3b
                                ],
                                [
                                    43,
                                    4,
                                    5,
                                    0xb
                                ],
                                [
                                    75,
                                    4,
                                    6,
                                    0xc
                                ],
                                [
                                    139,
                                    5,
                                    7,
                                    0x1b
                                ],
                                [
                                    267,
                                    5,
                                    8,
                                    0x1c
                                ],
                                [
                                    523,
                                    6,
                                    8,
                                    0x3c
                                ],
                                [
                                    779,
                                    7,
                                    9,
                                    0x7d
                                ],
                                [
                                    1291,
                                    6,
                                    11,
                                    0x3d
                                ],
                                [
                                    -32,
                                    9,
                                    32,
                                    0x1fe,
                                    "lower"
                                ],
                                [
                                    3339,
                                    9,
                                    32,
                                    0x1ff
                                ],
                                [
                                    2,
                                    0x0
                                ]
                            ];
                            break;
                        case 10:
                            lines = [
                                [
                                    -21,
                                    7,
                                    4,
                                    0x7a
                                ],
                                [
                                    -5,
                                    8,
                                    0,
                                    0xfc
                                ],
                                [
                                    -4,
                                    7,
                                    0,
                                    0x7b
                                ],
                                [
                                    -3,
                                    5,
                                    0,
                                    0x18
                                ],
                                [
                                    -2,
                                    2,
                                    2,
                                    0x0
                                ],
                                [
                                    2,
                                    5,
                                    0,
                                    0x19
                                ],
                                [
                                    3,
                                    6,
                                    0,
                                    0x36
                                ],
                                [
                                    4,
                                    7,
                                    0,
                                    0x7c
                                ],
                                [
                                    5,
                                    8,
                                    0,
                                    0xfd
                                ],
                                [
                                    6,
                                    2,
                                    6,
                                    0x1
                                ],
                                [
                                    70,
                                    5,
                                    5,
                                    0x1a
                                ],
                                [
                                    102,
                                    6,
                                    5,
                                    0x37
                                ],
                                [
                                    134,
                                    6,
                                    6,
                                    0x38
                                ],
                                [
                                    198,
                                    6,
                                    7,
                                    0x39
                                ],
                                [
                                    326,
                                    6,
                                    8,
                                    0x3a
                                ],
                                [
                                    582,
                                    6,
                                    9,
                                    0x3b
                                ],
                                [
                                    1094,
                                    6,
                                    10,
                                    0x3c
                                ],
                                [
                                    2118,
                                    7,
                                    11,
                                    0x7d
                                ],
                                [
                                    -22,
                                    8,
                                    32,
                                    0xfe,
                                    "lower"
                                ],
                                [
                                    4166,
                                    8,
                                    32,
                                    0xff
                                ],
                                [
                                    2,
                                    0x2
                                ]
                            ];
                            break;
                        case 11:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    1,
                                    0x2
                                ],
                                [
                                    4,
                                    4,
                                    0,
                                    0xc
                                ],
                                [
                                    5,
                                    4,
                                    1,
                                    0xd
                                ],
                                [
                                    7,
                                    5,
                                    1,
                                    0x1c
                                ],
                                [
                                    9,
                                    5,
                                    2,
                                    0x1d
                                ],
                                [
                                    13,
                                    6,
                                    2,
                                    0x3c
                                ],
                                [
                                    17,
                                    7,
                                    2,
                                    0x7a
                                ],
                                [
                                    21,
                                    7,
                                    3,
                                    0x7b
                                ],
                                [
                                    29,
                                    7,
                                    4,
                                    0x7c
                                ],
                                [
                                    45,
                                    7,
                                    5,
                                    0x7d
                                ],
                                [
                                    77,
                                    7,
                                    6,
                                    0x7e
                                ],
                                [
                                    141,
                                    7,
                                    32,
                                    0x7f
                                ]
                            ];
                            break;
                        case 12:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    3,
                                    3,
                                    1,
                                    0x6
                                ],
                                [
                                    5,
                                    5,
                                    0,
                                    0x1c
                                ],
                                [
                                    6,
                                    5,
                                    1,
                                    0x1d
                                ],
                                [
                                    8,
                                    6,
                                    1,
                                    0x3c
                                ],
                                [
                                    10,
                                    7,
                                    0,
                                    0x7a
                                ],
                                [
                                    11,
                                    7,
                                    1,
                                    0x7b
                                ],
                                [
                                    13,
                                    7,
                                    2,
                                    0x7c
                                ],
                                [
                                    17,
                                    7,
                                    3,
                                    0x7d
                                ],
                                [
                                    25,
                                    7,
                                    4,
                                    0x7e
                                ],
                                [
                                    41,
                                    8,
                                    5,
                                    0xfe
                                ],
                                [
                                    73,
                                    8,
                                    32,
                                    0xff
                                ]
                            ];
                            break;
                        case 13:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x4
                                ],
                                [
                                    3,
                                    4,
                                    0,
                                    0xc
                                ],
                                [
                                    4,
                                    5,
                                    0,
                                    0x1c
                                ],
                                [
                                    5,
                                    4,
                                    1,
                                    0xd
                                ],
                                [
                                    7,
                                    3,
                                    3,
                                    0x5
                                ],
                                [
                                    15,
                                    6,
                                    1,
                                    0x3a
                                ],
                                [
                                    17,
                                    6,
                                    2,
                                    0x3b
                                ],
                                [
                                    21,
                                    6,
                                    3,
                                    0x3c
                                ],
                                [
                                    29,
                                    6,
                                    4,
                                    0x3d
                                ],
                                [
                                    45,
                                    6,
                                    5,
                                    0x3e
                                ],
                                [
                                    77,
                                    7,
                                    6,
                                    0x7e
                                ],
                                [
                                    141,
                                    7,
                                    32,
                                    0x7f
                                ]
                            ];
                            break;
                        case 14:
                            lines = [
                                [
                                    -2,
                                    3,
                                    0,
                                    0x4
                                ],
                                [
                                    -1,
                                    3,
                                    0,
                                    0x5
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x7
                                ]
                            ];
                            break;
                        case 15:
                            lines = [
                                [
                                    -24,
                                    7,
                                    4,
                                    0x7c
                                ],
                                [
                                    -8,
                                    6,
                                    2,
                                    0x3c
                                ],
                                [
                                    -4,
                                    5,
                                    1,
                                    0x1c
                                ],
                                [
                                    -2,
                                    4,
                                    0,
                                    0xc
                                ],
                                [
                                    -1,
                                    3,
                                    0,
                                    0x4
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    3,
                                    0,
                                    0x5
                                ],
                                [
                                    2,
                                    4,
                                    0,
                                    0xd
                                ],
                                [
                                    3,
                                    5,
                                    1,
                                    0x1d
                                ],
                                [
                                    5,
                                    6,
                                    2,
                                    0x3d
                                ],
                                [
                                    9,
                                    7,
                                    4,
                                    0x7d
                                ],
                                [
                                    -25,
                                    7,
                                    32,
                                    0x7e,
                                    "lower"
                                ],
                                [
                                    25,
                                    7,
                                    32,
                                    0x7f
                                ]
                            ];
                            break;
                        default:
                            throw new Jbig2Error(`standard table B.${number} does not exist`);
                    }
                    for(let i = 0, ii = lines.length; i < ii; i++)lines[i] = new HuffmanLine(lines[i]);
                    table = new HuffmanTable(lines, true);
                    standardTablesCache[number] = table;
                    return table;
                }
                class Reader {
                    constructor(data, start, end){
                        this.data = data;
                        this.start = start;
                        this.end = end;
                        this.position = start;
                        this.shift = -1;
                        this.currentByte = 0;
                    }
                    readBit() {
                        if (this.shift < 0) {
                            if (this.position >= this.end) throw new Jbig2Error("end of data while reading bit");
                            this.currentByte = this.data[this.position++];
                            this.shift = 7;
                        }
                        const bit = this.currentByte >> this.shift & 1;
                        this.shift--;
                        return bit;
                    }
                    readBits(numBits) {
                        let result = 0, i;
                        for(i = numBits - 1; i >= 0; i--)result |= this.readBit() << i;
                        return result;
                    }
                    byteAlign() {
                        this.shift = -1;
                    }
                    next() {
                        if (this.position >= this.end) return -1;
                        return this.data[this.position++];
                    }
                }
                function getCustomHuffmanTable(index, referredTo, customTables) {
                    let currentIndex = 0;
                    for(let i = 0, ii = referredTo.length; i < ii; i++){
                        const table = customTables[referredTo[i]];
                        if (table) {
                            if (index === currentIndex) return table;
                            currentIndex++;
                        }
                    }
                    throw new Jbig2Error("can't find custom Huffman table");
                }
                function getTextRegionHuffmanTables(textRegion, referredTo, customTables, numberOfSymbols, reader) {
                    const codes = [];
                    for(let i = 0; i <= 34; i++){
                        const codeLength = reader.readBits(4);
                        codes.push(new HuffmanLine([
                            i,
                            codeLength,
                            0,
                            0
                        ]));
                    }
                    const runCodesTable = new HuffmanTable(codes, false);
                    codes.length = 0;
                    for(let i = 0; i < numberOfSymbols;){
                        const codeLength = runCodesTable.decode(reader);
                        if (codeLength >= 32) {
                            let repeatedLength, numberOfRepeats, j;
                            switch(codeLength){
                                case 32:
                                    if (i === 0) throw new Jbig2Error("no previous value in symbol ID table");
                                    numberOfRepeats = reader.readBits(2) + 3;
                                    repeatedLength = codes[i - 1].prefixLength;
                                    break;
                                case 33:
                                    numberOfRepeats = reader.readBits(3) + 3;
                                    repeatedLength = 0;
                                    break;
                                case 34:
                                    numberOfRepeats = reader.readBits(7) + 11;
                                    repeatedLength = 0;
                                    break;
                                default:
                                    throw new Jbig2Error("invalid code length in symbol ID table");
                            }
                            for(j = 0; j < numberOfRepeats; j++){
                                codes.push(new HuffmanLine([
                                    i,
                                    repeatedLength,
                                    0,
                                    0
                                ]));
                                i++;
                            }
                        } else {
                            codes.push(new HuffmanLine([
                                i,
                                codeLength,
                                0,
                                0
                            ]));
                            i++;
                        }
                    }
                    reader.byteAlign();
                    const symbolIDTable = new HuffmanTable(codes, false);
                    let customIndex = 0, tableFirstS, tableDeltaS, tableDeltaT;
                    switch(textRegion.huffmanFS){
                        case 0:
                        case 1:
                            tableFirstS = getStandardTable(textRegion.huffmanFS + 6);
                            break;
                        case 3:
                            tableFirstS = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman FS selector");
                    }
                    switch(textRegion.huffmanDS){
                        case 0:
                        case 1:
                        case 2:
                            tableDeltaS = getStandardTable(textRegion.huffmanDS + 8);
                            break;
                        case 3:
                            tableDeltaS = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DS selector");
                    }
                    switch(textRegion.huffmanDT){
                        case 0:
                        case 1:
                        case 2:
                            tableDeltaT = getStandardTable(textRegion.huffmanDT + 11);
                            break;
                        case 3:
                            tableDeltaT = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DT selector");
                    }
                    if (textRegion.refinement) throw new Jbig2Error("refinement with Huffman is not supported");
                    return {
                        symbolIDTable: symbolIDTable,
                        tableFirstS: tableFirstS,
                        tableDeltaS: tableDeltaS,
                        tableDeltaT: tableDeltaT
                    };
                }
                function getSymbolDictionaryHuffmanTables(dictionary, referredTo, customTables) {
                    let customIndex = 0, tableDeltaHeight, tableDeltaWidth;
                    switch(dictionary.huffmanDHSelector){
                        case 0:
                        case 1:
                            tableDeltaHeight = getStandardTable(dictionary.huffmanDHSelector + 4);
                            break;
                        case 3:
                            tableDeltaHeight = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DH selector");
                    }
                    switch(dictionary.huffmanDWSelector){
                        case 0:
                        case 1:
                            tableDeltaWidth = getStandardTable(dictionary.huffmanDWSelector + 2);
                            break;
                        case 3:
                            tableDeltaWidth = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DW selector");
                    }
                    let tableBitmapSize, tableAggregateInstances;
                    if (dictionary.bitmapSizeSelector) {
                        tableBitmapSize = getCustomHuffmanTable(customIndex, referredTo, customTables);
                        customIndex++;
                    } else tableBitmapSize = getStandardTable(1);
                    if (dictionary.aggregationInstancesSelector) tableAggregateInstances = getCustomHuffmanTable(customIndex, referredTo, customTables);
                    else tableAggregateInstances = getStandardTable(1);
                    return {
                        tableDeltaHeight: tableDeltaHeight,
                        tableDeltaWidth: tableDeltaWidth,
                        tableBitmapSize: tableBitmapSize,
                        tableAggregateInstances: tableAggregateInstances
                    };
                }
                function readUncompressedBitmap(reader, width, height) {
                    const bitmap = [];
                    for(let y = 0; y < height; y++){
                        const row = new Uint8Array(width);
                        bitmap.push(row);
                        for(let x = 0; x < width; x++)row[x] = reader.readBit();
                        reader.byteAlign();
                    }
                    return bitmap;
                }
                function decodeMMRBitmap(input, width, height, endOfBlock) {
                    const params = {
                        K: -1,
                        Columns: width,
                        Rows: height,
                        BlackIs1: true,
                        EndOfBlock: endOfBlock
                    };
                    const decoder = new _ccitt.CCITTFaxDecoder(input, params);
                    const bitmap = [];
                    let currentByte, eof = false;
                    for(let y = 0; y < height; y++){
                        const row = new Uint8Array(width);
                        bitmap.push(row);
                        let shift = -1;
                        for(let x = 0; x < width; x++){
                            if (shift < 0) {
                                currentByte = decoder.readNextChar();
                                if (currentByte === -1) {
                                    currentByte = 0;
                                    eof = true;
                                }
                                shift = 7;
                            }
                            row[x] = currentByte >> shift & 1;
                            shift--;
                        }
                    }
                    if (endOfBlock && !eof) {
                        const lookForEOFLimit = 5;
                        for(let i = 0; i < lookForEOFLimit; i++){
                            if (decoder.readNextChar() === -1) break;
                        }
                    }
                    return bitmap;
                }
                class Jbig2Image {
                    parseChunks(chunks) {
                        return parseJbig2Chunks(chunks);
                    }
                    parse(data) {
                        throw new Error("Not implemented: Jbig2Image.parse");
                    }
                }
                exports.Jbig2Image = Jbig2Image;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ArithmeticDecoder = void 0;
                const QeTable = [
                    {
                        qe: 0x5601,
                        nmps: 1,
                        nlps: 1,
                        switchFlag: 1
                    },
                    {
                        qe: 0x3401,
                        nmps: 2,
                        nlps: 6,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1801,
                        nmps: 3,
                        nlps: 9,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0ac1,
                        nmps: 4,
                        nlps: 12,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0521,
                        nmps: 5,
                        nlps: 29,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0221,
                        nmps: 38,
                        nlps: 33,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5601,
                        nmps: 7,
                        nlps: 6,
                        switchFlag: 1
                    },
                    {
                        qe: 0x5401,
                        nmps: 8,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x4801,
                        nmps: 9,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3801,
                        nmps: 10,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3001,
                        nmps: 11,
                        nlps: 17,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2401,
                        nmps: 12,
                        nlps: 18,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1c01,
                        nmps: 13,
                        nlps: 20,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1601,
                        nmps: 29,
                        nlps: 21,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5601,
                        nmps: 15,
                        nlps: 14,
                        switchFlag: 1
                    },
                    {
                        qe: 0x5401,
                        nmps: 16,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5101,
                        nmps: 17,
                        nlps: 15,
                        switchFlag: 0
                    },
                    {
                        qe: 0x4801,
                        nmps: 18,
                        nlps: 16,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3801,
                        nmps: 19,
                        nlps: 17,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3401,
                        nmps: 20,
                        nlps: 18,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3001,
                        nmps: 21,
                        nlps: 19,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2801,
                        nmps: 22,
                        nlps: 19,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2401,
                        nmps: 23,
                        nlps: 20,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2201,
                        nmps: 24,
                        nlps: 21,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1c01,
                        nmps: 25,
                        nlps: 22,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1801,
                        nmps: 26,
                        nlps: 23,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1601,
                        nmps: 27,
                        nlps: 24,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1401,
                        nmps: 28,
                        nlps: 25,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1201,
                        nmps: 29,
                        nlps: 26,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1101,
                        nmps: 30,
                        nlps: 27,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0ac1,
                        nmps: 31,
                        nlps: 28,
                        switchFlag: 0
                    },
                    {
                        qe: 0x09c1,
                        nmps: 32,
                        nlps: 29,
                        switchFlag: 0
                    },
                    {
                        qe: 0x08a1,
                        nmps: 33,
                        nlps: 30,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0521,
                        nmps: 34,
                        nlps: 31,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0441,
                        nmps: 35,
                        nlps: 32,
                        switchFlag: 0
                    },
                    {
                        qe: 0x02a1,
                        nmps: 36,
                        nlps: 33,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0221,
                        nmps: 37,
                        nlps: 34,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0141,
                        nmps: 38,
                        nlps: 35,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0111,
                        nmps: 39,
                        nlps: 36,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0085,
                        nmps: 40,
                        nlps: 37,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0049,
                        nmps: 41,
                        nlps: 38,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0025,
                        nmps: 42,
                        nlps: 39,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0015,
                        nmps: 43,
                        nlps: 40,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0009,
                        nmps: 44,
                        nlps: 41,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0005,
                        nmps: 45,
                        nlps: 42,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0001,
                        nmps: 45,
                        nlps: 43,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5601,
                        nmps: 46,
                        nlps: 46,
                        switchFlag: 0
                    }
                ];
                class ArithmeticDecoder {
                    constructor(data, start, end){
                        this.data = data;
                        this.bp = start;
                        this.dataEnd = end;
                        this.chigh = data[start];
                        this.clow = 0;
                        this.byteIn();
                        this.chigh = this.chigh << 7 & 0xffff | this.clow >> 9 & 0x7f;
                        this.clow = this.clow << 7 & 0xffff;
                        this.ct -= 7;
                        this.a = 0x8000;
                    }
                    byteIn() {
                        const data = this.data;
                        let bp = this.bp;
                        if (data[bp] === 0xff) {
                            if (data[bp + 1] > 0x8f) {
                                this.clow += 0xff00;
                                this.ct = 8;
                            } else {
                                bp++;
                                this.clow += data[bp] << 9;
                                this.ct = 7;
                                this.bp = bp;
                            }
                        } else {
                            bp++;
                            this.clow += bp < this.dataEnd ? data[bp] << 8 : 0xff00;
                            this.ct = 8;
                            this.bp = bp;
                        }
                        if (this.clow > 0xffff) {
                            this.chigh += this.clow >> 16;
                            this.clow &= 0xffff;
                        }
                    }
                    readBit(contexts, pos) {
                        let cx_index = contexts[pos] >> 1, cx_mps = contexts[pos] & 1;
                        const qeTableIcx = QeTable[cx_index];
                        const qeIcx = qeTableIcx.qe;
                        let d;
                        let a = this.a - qeIcx;
                        if (this.chigh < qeIcx) {
                            if (a < qeIcx) {
                                a = qeIcx;
                                d = cx_mps;
                                cx_index = qeTableIcx.nmps;
                            } else {
                                a = qeIcx;
                                d = 1 ^ cx_mps;
                                if (qeTableIcx.switchFlag === 1) cx_mps = d;
                                cx_index = qeTableIcx.nlps;
                            }
                        } else {
                            this.chigh -= qeIcx;
                            if ((a & 0x8000) !== 0) {
                                this.a = a;
                                return cx_mps;
                            }
                            if (a < qeIcx) {
                                d = 1 ^ cx_mps;
                                if (qeTableIcx.switchFlag === 1) cx_mps = d;
                                cx_index = qeTableIcx.nlps;
                            } else {
                                d = cx_mps;
                                cx_index = qeTableIcx.nmps;
                            }
                        }
                        do {
                            if (this.ct === 0) this.byteIn();
                            a <<= 1;
                            this.chigh = this.chigh << 1 & 0xffff | this.clow >> 15 & 1;
                            this.clow = this.clow << 1 & 0xffff;
                            this.ct--;
                        }while ((a & 0x8000) === 0);
                        this.a = a;
                        contexts[pos] = cx_index << 1 | cx_mps;
                        return d;
                    }
                }
                exports.ArithmeticDecoder = ArithmeticDecoder;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpegStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _primitives = __w_pdfjs_require__(4);
                var _jpg = __w_pdfjs_require__(27);
                var _util = __w_pdfjs_require__(2);
                class JpegStream extends _decode_stream.DecodeStream {
                    constructor(stream, maybeLength, params){
                        let ch;
                        while((ch = stream.getByte()) !== -1)if (ch === 0xff) {
                            stream.skip(-1);
                            break;
                        }
                        super(maybeLength);
                        this.stream = stream;
                        this.dict = stream.dict;
                        this.maybeLength = maybeLength;
                        this.params = params;
                    }
                    get bytes() {
                        return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(requested) {}
                    readBlock() {
                        if (this.eof) return;
                        const jpegOptions = {
                            decodeTransform: undefined,
                            colorTransform: undefined
                        };
                        const decodeArr = this.dict.getArray("D", "Decode");
                        if ((this.forceRGBA || this.forceRGB) && Array.isArray(decodeArr)) {
                            const bitsPerComponent = this.dict.get("BPC", "BitsPerComponent") || 8;
                            const decodeArrLength = decodeArr.length;
                            const transform = new Int32Array(decodeArrLength);
                            let transformNeeded = false;
                            const maxValue = (1 << bitsPerComponent) - 1;
                            for(let i = 0; i < decodeArrLength; i += 2){
                                transform[i] = (decodeArr[i + 1] - decodeArr[i]) * 256 | 0;
                                transform[i + 1] = decodeArr[i] * maxValue | 0;
                                if (transform[i] !== 256 || transform[i + 1] !== 0) transformNeeded = true;
                            }
                            if (transformNeeded) jpegOptions.decodeTransform = transform;
                        }
                        if (this.params instanceof _primitives.Dict) {
                            const colorTransform = this.params.get("ColorTransform");
                            if (Number.isInteger(colorTransform)) jpegOptions.colorTransform = colorTransform;
                        }
                        const jpegImage = new _jpg.JpegImage(jpegOptions);
                        jpegImage.parse(this.bytes);
                        const data = jpegImage.getData({
                            width: this.drawWidth,
                            height: this.drawHeight,
                            forceRGBA: this.forceRGBA,
                            forceRGB: this.forceRGB,
                            isSourcePDF: true
                        });
                        this.buffer = data;
                        this.bufferLength = data.length;
                        this.eof = true;
                    }
                }
                exports.JpegStream = JpegStream;
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpegImage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _image_utils = __w_pdfjs_require__(28);
                var _core_utils = __w_pdfjs_require__(3);
                class JpegError extends _util.BaseException {
                    constructor(msg){
                        super(`JPEG error: ${msg}`, "JpegError");
                    }
                }
                class DNLMarkerError extends _util.BaseException {
                    constructor(message, scanLines){
                        super(message, "DNLMarkerError");
                        this.scanLines = scanLines;
                    }
                }
                class EOIMarkerError extends _util.BaseException {
                    constructor(msg){
                        super(msg, "EOIMarkerError");
                    }
                }
                const dctZigZag = new Uint8Array([
                    0,
                    1,
                    8,
                    16,
                    9,
                    2,
                    3,
                    10,
                    17,
                    24,
                    32,
                    25,
                    18,
                    11,
                    4,
                    5,
                    12,
                    19,
                    26,
                    33,
                    40,
                    48,
                    41,
                    34,
                    27,
                    20,
                    13,
                    6,
                    7,
                    14,
                    21,
                    28,
                    35,
                    42,
                    49,
                    56,
                    57,
                    50,
                    43,
                    36,
                    29,
                    22,
                    15,
                    23,
                    30,
                    37,
                    44,
                    51,
                    58,
                    59,
                    52,
                    45,
                    38,
                    31,
                    39,
                    46,
                    53,
                    60,
                    61,
                    54,
                    47,
                    55,
                    62,
                    63
                ]);
                const dctCos1 = 4017;
                const dctSin1 = 799;
                const dctCos3 = 3406;
                const dctSin3 = 2276;
                const dctCos6 = 1567;
                const dctSin6 = 3784;
                const dctSqrt2 = 5793;
                const dctSqrt1d2 = 2896;
                function buildHuffmanTable(codeLengths, values) {
                    let k = 0, i, j, length = 16;
                    while(length > 0 && !codeLengths[length - 1])length--;
                    const code = [
                        {
                            children: [],
                            index: 0
                        }
                    ];
                    let p = code[0], q;
                    for(i = 0; i < length; i++){
                        for(j = 0; j < codeLengths[i]; j++){
                            p = code.pop();
                            p.children[p.index] = values[k];
                            while(p.index > 0)p = code.pop();
                            p.index++;
                            code.push(p);
                            while(code.length <= i){
                                code.push(q = {
                                    children: [],
                                    index: 0
                                });
                                p.children[p.index] = q.children;
                                p = q;
                            }
                            k++;
                        }
                        if (i + 1 < length) {
                            code.push(q = {
                                children: [],
                                index: 0
                            });
                            p.children[p.index] = q.children;
                            p = q;
                        }
                    }
                    return code[0].children;
                }
                function getBlockBufferOffset(component, row, col) {
                    return 64 * ((component.blocksPerLine + 1) * row + col);
                }
                function decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive, parseDNLMarker = false) {
                    const mcusPerLine = frame.mcusPerLine;
                    const progressive = frame.progressive;
                    const startOffset = offset;
                    let bitsData = 0, bitsCount = 0;
                    function readBit() {
                        if (bitsCount > 0) {
                            bitsCount--;
                            return bitsData >> bitsCount & 1;
                        }
                        bitsData = data[offset++];
                        if (bitsData === 0xff) {
                            const nextByte = data[offset++];
                            if (nextByte) {
                                if (nextByte === 0xdc && parseDNLMarker) {
                                    offset += 2;
                                    const scanLines = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    if (scanLines > 0 && scanLines !== frame.scanLines) throw new DNLMarkerError("Found DNL marker (0xFFDC) while parsing scan data", scanLines);
                                } else if (nextByte === 0xd9) {
                                    if (parseDNLMarker) {
                                        const maybeScanLines = blockRow * (frame.precision === 8 ? 8 : 0);
                                        if (maybeScanLines > 0 && Math.round(frame.scanLines / maybeScanLines) >= 5) throw new DNLMarkerError("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", maybeScanLines);
                                    }
                                    throw new EOIMarkerError("Found EOI marker (0xFFD9) while parsing scan data");
                                }
                                throw new JpegError(`unexpected marker ${(bitsData << 8 | nextByte).toString(16)}`);
                            }
                        }
                        bitsCount = 7;
                        return bitsData >>> 7;
                    }
                    function decodeHuffman(tree) {
                        let node = tree;
                        while(true){
                            node = node[readBit()];
                            switch(typeof node){
                                case "number":
                                    return node;
                                case "object":
                                    continue;
                            }
                            throw new JpegError("invalid huffman sequence");
                        }
                    }
                    function receive(length) {
                        let n = 0;
                        while(length > 0){
                            n = n << 1 | readBit();
                            length--;
                        }
                        return n;
                    }
                    function receiveAndExtend(length) {
                        if (length === 1) return readBit() === 1 ? 1 : -1;
                        const n = receive(length);
                        if (n >= 1 << length - 1) return n;
                        return n + (-1 << length) + 1;
                    }
                    function decodeBaseline(component, blockOffset) {
                        const t = decodeHuffman(component.huffmanTableDC);
                        const diff = t === 0 ? 0 : receiveAndExtend(t);
                        component.blockData[blockOffset] = component.pred += diff;
                        let k = 1;
                        while(k < 64){
                            const rs = decodeHuffman(component.huffmanTableAC);
                            const s = rs & 15, r = rs >> 4;
                            if (s === 0) {
                                if (r < 15) break;
                                k += 16;
                                continue;
                            }
                            k += r;
                            const z = dctZigZag[k];
                            component.blockData[blockOffset + z] = receiveAndExtend(s);
                            k++;
                        }
                    }
                    function decodeDCFirst(component, blockOffset) {
                        const t = decodeHuffman(component.huffmanTableDC);
                        const diff = t === 0 ? 0 : receiveAndExtend(t) << successive;
                        component.blockData[blockOffset] = component.pred += diff;
                    }
                    function decodeDCSuccessive(component, blockOffset) {
                        component.blockData[blockOffset] |= readBit() << successive;
                    }
                    let eobrun = 0;
                    function decodeACFirst(component, blockOffset) {
                        if (eobrun > 0) {
                            eobrun--;
                            return;
                        }
                        let k = spectralStart;
                        const e = spectralEnd;
                        while(k <= e){
                            const rs = decodeHuffman(component.huffmanTableAC);
                            const s = rs & 15, r = rs >> 4;
                            if (s === 0) {
                                if (r < 15) {
                                    eobrun = receive(r) + (1 << r) - 1;
                                    break;
                                }
                                k += 16;
                                continue;
                            }
                            k += r;
                            const z = dctZigZag[k];
                            component.blockData[blockOffset + z] = receiveAndExtend(s) * (1 << successive);
                            k++;
                        }
                    }
                    let successiveACState = 0, successiveACNextValue;
                    function decodeACSuccessive(component, blockOffset) {
                        let k = spectralStart;
                        const e = spectralEnd;
                        let r = 0;
                        let s;
                        let rs;
                        while(k <= e){
                            const offsetZ = blockOffset + dctZigZag[k];
                            const sign = component.blockData[offsetZ] < 0 ? -1 : 1;
                            switch(successiveACState){
                                case 0:
                                    rs = decodeHuffman(component.huffmanTableAC);
                                    s = rs & 15;
                                    r = rs >> 4;
                                    if (s === 0) {
                                        if (r < 15) {
                                            eobrun = receive(r) + (1 << r);
                                            successiveACState = 4;
                                        } else {
                                            r = 16;
                                            successiveACState = 1;
                                        }
                                    } else {
                                        if (s !== 1) throw new JpegError("invalid ACn encoding");
                                        successiveACNextValue = receiveAndExtend(s);
                                        successiveACState = r ? 2 : 3;
                                    }
                                    continue;
                                case 1:
                                case 2:
                                    if (component.blockData[offsetZ]) component.blockData[offsetZ] += sign * (readBit() << successive);
                                    else {
                                        r--;
                                        if (r === 0) successiveACState = successiveACState === 2 ? 3 : 0;
                                    }
                                    break;
                                case 3:
                                    if (component.blockData[offsetZ]) component.blockData[offsetZ] += sign * (readBit() << successive);
                                    else {
                                        component.blockData[offsetZ] = successiveACNextValue << successive;
                                        successiveACState = 0;
                                    }
                                    break;
                                case 4:
                                    if (component.blockData[offsetZ]) component.blockData[offsetZ] += sign * (readBit() << successive);
                                    break;
                            }
                            k++;
                        }
                        if (successiveACState === 4) {
                            eobrun--;
                            if (eobrun === 0) successiveACState = 0;
                        }
                    }
                    let blockRow = 0;
                    function decodeMcu(component, decode, mcu, row, col) {
                        const mcuRow = mcu / mcusPerLine | 0;
                        const mcuCol = mcu % mcusPerLine;
                        blockRow = mcuRow * component.v + row;
                        const blockCol = mcuCol * component.h + col;
                        const blockOffset = getBlockBufferOffset(component, blockRow, blockCol);
                        decode(component, blockOffset);
                    }
                    function decodeBlock(component, decode, mcu) {
                        blockRow = mcu / component.blocksPerLine | 0;
                        const blockCol = mcu % component.blocksPerLine;
                        const blockOffset = getBlockBufferOffset(component, blockRow, blockCol);
                        decode(component, blockOffset);
                    }
                    const componentsLength = components.length;
                    let component, i, j, k, n;
                    let decodeFn;
                    if (progressive) {
                        if (spectralStart === 0) decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
                        else decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
                    } else decodeFn = decodeBaseline;
                    let mcu = 0, fileMarker;
                    const mcuExpected = componentsLength === 1 ? components[0].blocksPerLine * components[0].blocksPerColumn : mcusPerLine * frame.mcusPerColumn;
                    let h, v;
                    while(mcu <= mcuExpected){
                        const mcuToRead = resetInterval ? Math.min(mcuExpected - mcu, resetInterval) : mcuExpected;
                        if (mcuToRead > 0) {
                            for(i = 0; i < componentsLength; i++)components[i].pred = 0;
                            eobrun = 0;
                            if (componentsLength === 1) {
                                component = components[0];
                                for(n = 0; n < mcuToRead; n++){
                                    decodeBlock(component, decodeFn, mcu);
                                    mcu++;
                                }
                            } else for(n = 0; n < mcuToRead; n++){
                                for(i = 0; i < componentsLength; i++){
                                    component = components[i];
                                    h = component.h;
                                    v = component.v;
                                    for(j = 0; j < v; j++)for(k = 0; k < h; k++)decodeMcu(component, decodeFn, mcu, j, k);
                                }
                                mcu++;
                            }
                        }
                        bitsCount = 0;
                        fileMarker = findNextFileMarker(data, offset);
                        if (!fileMarker) break;
                        if (fileMarker.invalid) {
                            const partialMsg = mcuToRead > 0 ? "unexpected" : "excessive";
                            (0, _util.warn)(`decodeScan - ${partialMsg} MCU data, current marker is: ${fileMarker.invalid}`);
                            offset = fileMarker.offset;
                        }
                        if (fileMarker.marker >= 0xffd0 && fileMarker.marker <= 0xffd7) offset += 2;
                        else break;
                    }
                    return offset - startOffset;
                }
                function quantizeAndInverse(component, blockBufferOffset, p) {
                    const qt = component.quantizationTable, blockData = component.blockData;
                    let v0, v1, v2, v3, v4, v5, v6, v7;
                    let p0, p1, p2, p3, p4, p5, p6, p7;
                    let t;
                    if (!qt) throw new JpegError("missing required Quantization Table.");
                    for(let row = 0; row < 64; row += 8){
                        p0 = blockData[blockBufferOffset + row];
                        p1 = blockData[blockBufferOffset + row + 1];
                        p2 = blockData[blockBufferOffset + row + 2];
                        p3 = blockData[blockBufferOffset + row + 3];
                        p4 = blockData[blockBufferOffset + row + 4];
                        p5 = blockData[blockBufferOffset + row + 5];
                        p6 = blockData[blockBufferOffset + row + 6];
                        p7 = blockData[blockBufferOffset + row + 7];
                        p0 *= qt[row];
                        if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
                            t = dctSqrt2 * p0 + 512 >> 10;
                            p[row] = t;
                            p[row + 1] = t;
                            p[row + 2] = t;
                            p[row + 3] = t;
                            p[row + 4] = t;
                            p[row + 5] = t;
                            p[row + 6] = t;
                            p[row + 7] = t;
                            continue;
                        }
                        p1 *= qt[row + 1];
                        p2 *= qt[row + 2];
                        p3 *= qt[row + 3];
                        p4 *= qt[row + 4];
                        p5 *= qt[row + 5];
                        p6 *= qt[row + 6];
                        p7 *= qt[row + 7];
                        v0 = dctSqrt2 * p0 + 128 >> 8;
                        v1 = dctSqrt2 * p4 + 128 >> 8;
                        v2 = p2;
                        v3 = p6;
                        v4 = dctSqrt1d2 * (p1 - p7) + 128 >> 8;
                        v7 = dctSqrt1d2 * (p1 + p7) + 128 >> 8;
                        v5 = p3 << 4;
                        v6 = p5 << 4;
                        v0 = v0 + v1 + 1 >> 1;
                        v1 = v0 - v1;
                        t = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
                        v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
                        v3 = t;
                        v4 = v4 + v6 + 1 >> 1;
                        v6 = v4 - v6;
                        v7 = v7 + v5 + 1 >> 1;
                        v5 = v7 - v5;
                        v0 = v0 + v3 + 1 >> 1;
                        v3 = v0 - v3;
                        v1 = v1 + v2 + 1 >> 1;
                        v2 = v1 - v2;
                        t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                        v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                        v7 = t;
                        t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                        v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                        v6 = t;
                        p[row] = v0 + v7;
                        p[row + 7] = v0 - v7;
                        p[row + 1] = v1 + v6;
                        p[row + 6] = v1 - v6;
                        p[row + 2] = v2 + v5;
                        p[row + 5] = v2 - v5;
                        p[row + 3] = v3 + v4;
                        p[row + 4] = v3 - v4;
                    }
                    for(let col = 0; col < 8; ++col){
                        p0 = p[col];
                        p1 = p[col + 8];
                        p2 = p[col + 16];
                        p3 = p[col + 24];
                        p4 = p[col + 32];
                        p5 = p[col + 40];
                        p6 = p[col + 48];
                        p7 = p[col + 56];
                        if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
                            t = dctSqrt2 * p0 + 8192 >> 14;
                            if (t < -2040) t = 0;
                            else if (t >= 2024) t = 255;
                            else t = t + 2056 >> 4;
                            blockData[blockBufferOffset + col] = t;
                            blockData[blockBufferOffset + col + 8] = t;
                            blockData[blockBufferOffset + col + 16] = t;
                            blockData[blockBufferOffset + col + 24] = t;
                            blockData[blockBufferOffset + col + 32] = t;
                            blockData[blockBufferOffset + col + 40] = t;
                            blockData[blockBufferOffset + col + 48] = t;
                            blockData[blockBufferOffset + col + 56] = t;
                            continue;
                        }
                        v0 = dctSqrt2 * p0 + 2048 >> 12;
                        v1 = dctSqrt2 * p4 + 2048 >> 12;
                        v2 = p2;
                        v3 = p6;
                        v4 = dctSqrt1d2 * (p1 - p7) + 2048 >> 12;
                        v7 = dctSqrt1d2 * (p1 + p7) + 2048 >> 12;
                        v5 = p3;
                        v6 = p5;
                        v0 = (v0 + v1 + 1 >> 1) + 4112;
                        v1 = v0 - v1;
                        t = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
                        v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
                        v3 = t;
                        v4 = v4 + v6 + 1 >> 1;
                        v6 = v4 - v6;
                        v7 = v7 + v5 + 1 >> 1;
                        v5 = v7 - v5;
                        v0 = v0 + v3 + 1 >> 1;
                        v3 = v0 - v3;
                        v1 = v1 + v2 + 1 >> 1;
                        v2 = v1 - v2;
                        t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                        v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                        v7 = t;
                        t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                        v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                        v6 = t;
                        p0 = v0 + v7;
                        p7 = v0 - v7;
                        p1 = v1 + v6;
                        p6 = v1 - v6;
                        p2 = v2 + v5;
                        p5 = v2 - v5;
                        p3 = v3 + v4;
                        p4 = v3 - v4;
                        if (p0 < 16) p0 = 0;
                        else if (p0 >= 4080) p0 = 255;
                        else p0 >>= 4;
                        if (p1 < 16) p1 = 0;
                        else if (p1 >= 4080) p1 = 255;
                        else p1 >>= 4;
                        if (p2 < 16) p2 = 0;
                        else if (p2 >= 4080) p2 = 255;
                        else p2 >>= 4;
                        if (p3 < 16) p3 = 0;
                        else if (p3 >= 4080) p3 = 255;
                        else p3 >>= 4;
                        if (p4 < 16) p4 = 0;
                        else if (p4 >= 4080) p4 = 255;
                        else p4 >>= 4;
                        if (p5 < 16) p5 = 0;
                        else if (p5 >= 4080) p5 = 255;
                        else p5 >>= 4;
                        if (p6 < 16) p6 = 0;
                        else if (p6 >= 4080) p6 = 255;
                        else p6 >>= 4;
                        if (p7 < 16) p7 = 0;
                        else if (p7 >= 4080) p7 = 255;
                        else p7 >>= 4;
                        blockData[blockBufferOffset + col] = p0;
                        blockData[blockBufferOffset + col + 8] = p1;
                        blockData[blockBufferOffset + col + 16] = p2;
                        blockData[blockBufferOffset + col + 24] = p3;
                        blockData[blockBufferOffset + col + 32] = p4;
                        blockData[blockBufferOffset + col + 40] = p5;
                        blockData[blockBufferOffset + col + 48] = p6;
                        blockData[blockBufferOffset + col + 56] = p7;
                    }
                }
                function buildComponentData(frame, component) {
                    const blocksPerLine = component.blocksPerLine;
                    const blocksPerColumn = component.blocksPerColumn;
                    const computationBuffer = new Int16Array(64);
                    for(let blockRow = 0; blockRow < blocksPerColumn; blockRow++)for(let blockCol = 0; blockCol < blocksPerLine; blockCol++){
                        const offset = getBlockBufferOffset(component, blockRow, blockCol);
                        quantizeAndInverse(component, offset, computationBuffer);
                    }
                    return component.blockData;
                }
                function findNextFileMarker(data, currentPos, startPos = currentPos) {
                    const maxPos = data.length - 1;
                    let newPos = startPos < currentPos ? startPos : currentPos;
                    if (currentPos >= maxPos) return null;
                    const currentMarker = (0, _core_utils.readUint16)(data, currentPos);
                    if (currentMarker >= 0xffc0 && currentMarker <= 0xfffe) return {
                        invalid: null,
                        marker: currentMarker,
                        offset: currentPos
                    };
                    let newMarker = (0, _core_utils.readUint16)(data, newPos);
                    while(!(newMarker >= 0xffc0 && newMarker <= 0xfffe)){
                        if (++newPos >= maxPos) return null;
                        newMarker = (0, _core_utils.readUint16)(data, newPos);
                    }
                    return {
                        invalid: currentMarker.toString(16),
                        marker: newMarker,
                        offset: newPos
                    };
                }
                class JpegImage {
                    constructor({ decodeTransform: decodeTransform = null, colorTransform: colorTransform = -1 } = {}){
                        this._decodeTransform = decodeTransform;
                        this._colorTransform = colorTransform;
                    }
                    parse(data, { dnlScanLines: dnlScanLines = null } = {}) {
                        function readDataBlock() {
                            const length = (0, _core_utils.readUint16)(data, offset);
                            offset += 2;
                            let endOffset = offset + length - 2;
                            const fileMarker = findNextFileMarker(data, endOffset, offset);
                            if (fileMarker?.invalid) {
                                (0, _util.warn)("readDataBlock - incorrect length, current marker is: " + fileMarker.invalid);
                                endOffset = fileMarker.offset;
                            }
                            const array = data.subarray(offset, endOffset);
                            offset += array.length;
                            return array;
                        }
                        function prepareComponents(frame) {
                            const mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / frame.maxH);
                            const mcusPerColumn = Math.ceil(frame.scanLines / 8 / frame.maxV);
                            for (const component of frame.components){
                                const blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / frame.maxH);
                                const blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines / 8) * component.v / frame.maxV);
                                const blocksPerLineForMcu = mcusPerLine * component.h;
                                const blocksPerColumnForMcu = mcusPerColumn * component.v;
                                const blocksBufferSize = 64 * blocksPerColumnForMcu * (blocksPerLineForMcu + 1);
                                component.blockData = new Int16Array(blocksBufferSize);
                                component.blocksPerLine = blocksPerLine;
                                component.blocksPerColumn = blocksPerColumn;
                            }
                            frame.mcusPerLine = mcusPerLine;
                            frame.mcusPerColumn = mcusPerColumn;
                        }
                        let offset = 0;
                        let jfif = null;
                        let adobe = null;
                        let frame, resetInterval;
                        let numSOSMarkers = 0;
                        const quantizationTables = [];
                        const huffmanTablesAC = [], huffmanTablesDC = [];
                        let fileMarker = (0, _core_utils.readUint16)(data, offset);
                        offset += 2;
                        if (fileMarker !== 0xffd8) throw new JpegError("SOI not found");
                        fileMarker = (0, _core_utils.readUint16)(data, offset);
                        offset += 2;
                        markerLoop: while(fileMarker !== 0xffd9){
                            let i, j, l;
                            switch(fileMarker){
                                case 0xffe0:
                                case 0xffe1:
                                case 0xffe2:
                                case 0xffe3:
                                case 0xffe4:
                                case 0xffe5:
                                case 0xffe6:
                                case 0xffe7:
                                case 0xffe8:
                                case 0xffe9:
                                case 0xffea:
                                case 0xffeb:
                                case 0xffec:
                                case 0xffed:
                                case 0xffee:
                                case 0xffef:
                                case 0xfffe:
                                    const appData = readDataBlock();
                                    if (fileMarker === 0xffe0) {
                                        if (appData[0] === 0x4a && appData[1] === 0x46 && appData[2] === 0x49 && appData[3] === 0x46 && appData[4] === 0) jfif = {
                                            version: {
                                                major: appData[5],
                                                minor: appData[6]
                                            },
                                            densityUnits: appData[7],
                                            xDensity: appData[8] << 8 | appData[9],
                                            yDensity: appData[10] << 8 | appData[11],
                                            thumbWidth: appData[12],
                                            thumbHeight: appData[13],
                                            thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
                                        };
                                    }
                                    if (fileMarker === 0xffee) {
                                        if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6f && appData[3] === 0x62 && appData[4] === 0x65) adobe = {
                                            version: appData[5] << 8 | appData[6],
                                            flags0: appData[7] << 8 | appData[8],
                                            flags1: appData[9] << 8 | appData[10],
                                            transformCode: appData[11]
                                        };
                                    }
                                    break;
                                case 0xffdb:
                                    const quantizationTablesLength = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    const quantizationTablesEnd = quantizationTablesLength + offset - 2;
                                    let z;
                                    while(offset < quantizationTablesEnd){
                                        const quantizationTableSpec = data[offset++];
                                        const tableData = new Uint16Array(64);
                                        if (quantizationTableSpec >> 4 === 0) for(j = 0; j < 64; j++){
                                            z = dctZigZag[j];
                                            tableData[z] = data[offset++];
                                        }
                                        else if (quantizationTableSpec >> 4 === 1) for(j = 0; j < 64; j++){
                                            z = dctZigZag[j];
                                            tableData[z] = (0, _core_utils.readUint16)(data, offset);
                                            offset += 2;
                                        }
                                        else throw new JpegError("DQT - invalid table spec");
                                        quantizationTables[quantizationTableSpec & 15] = tableData;
                                    }
                                    break;
                                case 0xffc0:
                                case 0xffc1:
                                case 0xffc2:
                                    if (frame) throw new JpegError("Only single frame JPEGs supported");
                                    offset += 2;
                                    frame = {};
                                    frame.extended = fileMarker === 0xffc1;
                                    frame.progressive = fileMarker === 0xffc2;
                                    frame.precision = data[offset++];
                                    const sofScanLines = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    frame.scanLines = dnlScanLines || sofScanLines;
                                    frame.samplesPerLine = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    frame.components = [];
                                    frame.componentIds = {};
                                    const componentsCount = data[offset++];
                                    let maxH = 0, maxV = 0;
                                    for(i = 0; i < componentsCount; i++){
                                        const componentId = data[offset];
                                        const h = data[offset + 1] >> 4;
                                        const v = data[offset + 1] & 15;
                                        if (maxH < h) maxH = h;
                                        if (maxV < v) maxV = v;
                                        const qId = data[offset + 2];
                                        l = frame.components.push({
                                            h: h,
                                            v: v,
                                            quantizationId: qId,
                                            quantizationTable: null
                                        });
                                        frame.componentIds[componentId] = l - 1;
                                        offset += 3;
                                    }
                                    frame.maxH = maxH;
                                    frame.maxV = maxV;
                                    prepareComponents(frame);
                                    break;
                                case 0xffc4:
                                    const huffmanLength = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    for(i = 2; i < huffmanLength;){
                                        const huffmanTableSpec = data[offset++];
                                        const codeLengths = new Uint8Array(16);
                                        let codeLengthSum = 0;
                                        for(j = 0; j < 16; j++, offset++)codeLengthSum += codeLengths[j] = data[offset];
                                        const huffmanValues = new Uint8Array(codeLengthSum);
                                        for(j = 0; j < codeLengthSum; j++, offset++)huffmanValues[j] = data[offset];
                                        i += 17 + codeLengthSum;
                                        (huffmanTableSpec >> 4 === 0 ? huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
                                    }
                                    break;
                                case 0xffdd:
                                    offset += 2;
                                    resetInterval = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    break;
                                case 0xffda:
                                    const parseDNLMarker = ++numSOSMarkers === 1 && !dnlScanLines;
                                    offset += 2;
                                    const selectorsCount = data[offset++], components = [];
                                    for(i = 0; i < selectorsCount; i++){
                                        const index = data[offset++];
                                        const componentIndex = frame.componentIds[index];
                                        const component = frame.components[componentIndex];
                                        component.index = index;
                                        const tableSpec = data[offset++];
                                        component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
                                        component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
                                        components.push(component);
                                    }
                                    const spectralStart = data[offset++], spectralEnd = data[offset++], successiveApproximation = data[offset++];
                                    try {
                                        const processed = decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15, parseDNLMarker);
                                        offset += processed;
                                    } catch (ex) {
                                        if (ex instanceof DNLMarkerError) {
                                            (0, _util.warn)(`${ex.message} -- attempting to re-parse the JPEG image.`);
                                            return this.parse(data, {
                                                dnlScanLines: ex.scanLines
                                            });
                                        } else if (ex instanceof EOIMarkerError) {
                                            (0, _util.warn)(`${ex.message} -- ignoring the rest of the image data.`);
                                            break markerLoop;
                                        }
                                        throw ex;
                                    }
                                    break;
                                case 0xffdc:
                                    offset += 4;
                                    break;
                                case 0xffff:
                                    if (data[offset] !== 0xff) offset--;
                                    break;
                                default:
                                    const nextFileMarker = findNextFileMarker(data, offset - 2, offset - 3);
                                    if (nextFileMarker?.invalid) {
                                        (0, _util.warn)("JpegImage.parse - unexpected data, current marker is: " + nextFileMarker.invalid);
                                        offset = nextFileMarker.offset;
                                        break;
                                    }
                                    if (!nextFileMarker || offset >= data.length - 1) {
                                        (0, _util.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                                        break markerLoop;
                                    }
                                    throw new JpegError("JpegImage.parse - unknown marker: " + fileMarker.toString(16));
                            }
                            fileMarker = (0, _core_utils.readUint16)(data, offset);
                            offset += 2;
                        }
                        this.width = frame.samplesPerLine;
                        this.height = frame.scanLines;
                        this.jfif = jfif;
                        this.adobe = adobe;
                        this.components = [];
                        for (const component of frame.components){
                            const quantizationTable = quantizationTables[component.quantizationId];
                            if (quantizationTable) component.quantizationTable = quantizationTable;
                            this.components.push({
                                index: component.index,
                                output: buildComponentData(frame, component),
                                scaleX: component.h / frame.maxH,
                                scaleY: component.v / frame.maxV,
                                blocksPerLine: component.blocksPerLine,
                                blocksPerColumn: component.blocksPerColumn
                            });
                        }
                        this.numComponents = this.components.length;
                        return undefined;
                    }
                    _getLinearizedBlockData(width, height, isSourcePDF = false) {
                        const scaleX = this.width / width, scaleY = this.height / height;
                        let component, componentScaleX, componentScaleY, blocksPerScanline;
                        let x, y, i, j, k;
                        let index;
                        let offset = 0;
                        let output;
                        const numComponents = this.components.length;
                        const dataLength = width * height * numComponents;
                        const data = new Uint8ClampedArray(dataLength);
                        const xScaleBlockOffset = new Uint32Array(width);
                        const mask3LSB = 0xfffffff8;
                        let lastComponentScaleX;
                        for(i = 0; i < numComponents; i++){
                            component = this.components[i];
                            componentScaleX = component.scaleX * scaleX;
                            componentScaleY = component.scaleY * scaleY;
                            offset = i;
                            output = component.output;
                            blocksPerScanline = component.blocksPerLine + 1 << 3;
                            if (componentScaleX !== lastComponentScaleX) {
                                for(x = 0; x < width; x++){
                                    j = 0 | x * componentScaleX;
                                    xScaleBlockOffset[x] = (j & mask3LSB) << 3 | j & 7;
                                }
                                lastComponentScaleX = componentScaleX;
                            }
                            for(y = 0; y < height; y++){
                                j = 0 | y * componentScaleY;
                                index = blocksPerScanline * (j & mask3LSB) | (j & 7) << 3;
                                for(x = 0; x < width; x++){
                                    data[offset] = output[index + xScaleBlockOffset[x]];
                                    offset += numComponents;
                                }
                            }
                        }
                        let transform = this._decodeTransform;
                        if (!isSourcePDF && numComponents === 4 && !transform) transform = new Int32Array([
                            -256,
                            255,
                            -256,
                            255,
                            -256,
                            255,
                            -256,
                            255
                        ]);
                        if (transform) {
                            for(i = 0; i < dataLength;)for(j = 0, k = 0; j < numComponents; j++, i++, k += 2)data[i] = (data[i] * transform[k] >> 8) + transform[k + 1];
                        }
                        return data;
                    }
                    get _isColorConversionNeeded() {
                        if (this.adobe) return !!this.adobe.transformCode;
                        if (this.numComponents === 3) {
                            if (this._colorTransform === 0) return false;
                            else if (this.components[0].index === 0x52 && this.components[1].index === 0x47 && this.components[2].index === 0x42) return false;
                            return true;
                        }
                        if (this._colorTransform === 1) return true;
                        return false;
                    }
                    _convertYccToRgb(data) {
                        let Y, Cb, Cr;
                        for(let i = 0, length = data.length; i < length; i += 3){
                            Y = data[i];
                            Cb = data[i + 1];
                            Cr = data[i + 2];
                            data[i] = Y - 179.456 + 1.402 * Cr;
                            data[i + 1] = Y + 135.459 - 0.344 * Cb - 0.714 * Cr;
                            data[i + 2] = Y - 226.816 + 1.772 * Cb;
                        }
                        return data;
                    }
                    _convertYccToRgba(data, out) {
                        for(let i = 0, j = 0, length = data.length; i < length; i += 3, j += 4){
                            const Y = data[i];
                            const Cb = data[i + 1];
                            const Cr = data[i + 2];
                            out[j] = Y - 179.456 + 1.402 * Cr;
                            out[j + 1] = Y + 135.459 - 0.344 * Cb - 0.714 * Cr;
                            out[j + 2] = Y - 226.816 + 1.772 * Cb;
                            out[j + 3] = 255;
                        }
                        return out;
                    }
                    _convertYcckToRgb(data) {
                        let Y, Cb, Cr, k;
                        let offset = 0;
                        for(let i = 0, length = data.length; i < length; i += 4){
                            Y = data[i];
                            Cb = data[i + 1];
                            Cr = data[i + 2];
                            k = data[i + 3];
                            data[offset++] = -122.67195406894 + Cb * (-0.0000660635669420364 * Cb + 0.000437130475926232 * Cr - 5.4080610064599e-5 * Y + 0.00048449797120281 * k - 0.154362151871126) + Cr * (-0.000957964378445773 * Cr + 0.000817076911346625 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (0.000961250184130688 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-0.000336197177618394 * k + 0.484791561490776);
                            data[offset++] = 107.268039397724 + Cb * (2.19927104525741e-5 * Cb - 0.000640992018297945 * Cr + 0.000659397001245577 * Y + 0.000426105652938837 * k - 0.176491792462875) + Cr * (-0.000778269941513683 * Cr + 0.00130872261408275 * Y + 0.000770482631801132 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-0.000318913117588328 * k - 0.213742400323665);
                            data[offset++] = -20.810012546947 + Cb * (-0.000570115196973677 * Cb - 2.63409051004589e-5 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-0.0000153496057440975 * Cr - 0.000132689043961446 * Y + 0.000560833691242812 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-0.000343531996510555 * k + 0.24165260232407);
                        }
                        return data.subarray(0, offset);
                    }
                    _convertYcckToRgba(data) {
                        for(let i = 0, length = data.length; i < length; i += 4){
                            const Y = data[i];
                            const Cb = data[i + 1];
                            const Cr = data[i + 2];
                            const k = data[i + 3];
                            data[i] = -122.67195406894 + Cb * (-0.0000660635669420364 * Cb + 0.000437130475926232 * Cr - 5.4080610064599e-5 * Y + 0.00048449797120281 * k - 0.154362151871126) + Cr * (-0.000957964378445773 * Cr + 0.000817076911346625 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (0.000961250184130688 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-0.000336197177618394 * k + 0.484791561490776);
                            data[i + 1] = 107.268039397724 + Cb * (2.19927104525741e-5 * Cb - 0.000640992018297945 * Cr + 0.000659397001245577 * Y + 0.000426105652938837 * k - 0.176491792462875) + Cr * (-0.000778269941513683 * Cr + 0.00130872261408275 * Y + 0.000770482631801132 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-0.000318913117588328 * k - 0.213742400323665);
                            data[i + 2] = -20.810012546947 + Cb * (-0.000570115196973677 * Cb - 2.63409051004589e-5 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-0.0000153496057440975 * Cr - 0.000132689043961446 * Y + 0.000560833691242812 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-0.000343531996510555 * k + 0.24165260232407);
                            data[i + 3] = 255;
                        }
                        return data;
                    }
                    _convertYcckToCmyk(data) {
                        let Y, Cb, Cr;
                        for(let i = 0, length = data.length; i < length; i += 4){
                            Y = data[i];
                            Cb = data[i + 1];
                            Cr = data[i + 2];
                            data[i] = 434.456 - Y - 1.402 * Cr;
                            data[i + 1] = 119.541 - Y + 0.344 * Cb + 0.714 * Cr;
                            data[i + 2] = 481.816 - Y - 1.772 * Cb;
                        }
                        return data;
                    }
                    _convertCmykToRgb(data) {
                        let c, m, y, k;
                        let offset = 0;
                        for(let i = 0, length = data.length; i < length; i += 4){
                            c = data[i];
                            m = data[i + 1];
                            y = data[i + 2];
                            k = data[i + 3];
                            data[offset++] = 255 + c * (-0.00006747147073602441 * c + 0.0008379262121013727 * m + 0.0002894718188643294 * y + 0.003264231057537806 * k - 1.1185611867203937) + m * (0.000026374107616089405 * m - 0.00008626949158638572 * y - 0.0002748769067499491 * k - 0.02155688794978967) + y * (-0.00003878099212869363 * y - 0.0003267808279485286 * k + 0.0686742238595345) - k * (0.0003361971776183937 * k + 0.7430659151342254);
                            data[offset++] = 255 + c * (0.00013596372813588848 * c + 0.000924537132573585 * m + 0.00010567359618683593 * y + 0.0004791864687436512 * k - 0.3109689587515875) + m * (-0.00023545346108370344 * m + 0.0002702845253534714 * y + 0.0020200308977307156 * k - 0.7488052167015494) + y * (0.00006834815998235662 * y + 0.00015168452363460973 * k - 0.09751927774728933) - k * (0.0003189131175883281 * k + 0.7364883807733168);
                            data[offset++] = 255 + c * (0.000013598650411385307 * c + 0.00012423956175490851 * m + 0.0004751985097583589 * y - 0.0000036729317476630422 * k - 0.05562186980264034) + m * (0.00016141380598724676 * m + 0.0009692239130725186 * y + 0.0007782692450036253 * k - 0.44015232367526463) + y * (5.068882914068769e-7 * y + 0.0017778369011375071 * k - 0.7591454649749609) - k * (0.0003435319965105553 * k + 0.7063770186160144);
                        }
                        return data.subarray(0, offset);
                    }
                    _convertCmykToRgba(data) {
                        for(let i = 0, length = data.length; i < length; i += 4){
                            const c = data[i];
                            const m = data[i + 1];
                            const y = data[i + 2];
                            const k = data[i + 3];
                            data[i] = 255 + c * (-0.00006747147073602441 * c + 0.0008379262121013727 * m + 0.0002894718188643294 * y + 0.003264231057537806 * k - 1.1185611867203937) + m * (0.000026374107616089405 * m - 0.00008626949158638572 * y - 0.0002748769067499491 * k - 0.02155688794978967) + y * (-0.00003878099212869363 * y - 0.0003267808279485286 * k + 0.0686742238595345) - k * (0.0003361971776183937 * k + 0.7430659151342254);
                            data[i + 1] = 255 + c * (0.00013596372813588848 * c + 0.000924537132573585 * m + 0.00010567359618683593 * y + 0.0004791864687436512 * k - 0.3109689587515875) + m * (-0.00023545346108370344 * m + 0.0002702845253534714 * y + 0.0020200308977307156 * k - 0.7488052167015494) + y * (0.00006834815998235662 * y + 0.00015168452363460973 * k - 0.09751927774728933) - k * (0.0003189131175883281 * k + 0.7364883807733168);
                            data[i + 2] = 255 + c * (0.000013598650411385307 * c + 0.00012423956175490851 * m + 0.0004751985097583589 * y - 0.0000036729317476630422 * k - 0.05562186980264034) + m * (0.00016141380598724676 * m + 0.0009692239130725186 * y + 0.0007782692450036253 * k - 0.44015232367526463) + y * (5.068882914068769e-7 * y + 0.0017778369011375071 * k - 0.7591454649749609) - k * (0.0003435319965105553 * k + 0.7063770186160144);
                            data[i + 3] = 255;
                        }
                        return data;
                    }
                    getData({ width: width, height: height, forceRGBA: forceRGBA = false, forceRGB: forceRGB = false, isSourcePDF: isSourcePDF = false }) {
                        if (this.numComponents > 4) throw new JpegError("Unsupported color mode");
                        const data = this._getLinearizedBlockData(width, height, isSourcePDF);
                        if (this.numComponents === 1 && (forceRGBA || forceRGB)) {
                            const len = data.length * (forceRGBA ? 4 : 3);
                            const rgbaData = new Uint8ClampedArray(len);
                            let offset = 0;
                            if (forceRGBA) (0, _image_utils.grayToRGBA)(data, new Uint32Array(rgbaData.buffer));
                            else for (const grayColor of data){
                                rgbaData[offset++] = grayColor;
                                rgbaData[offset++] = grayColor;
                                rgbaData[offset++] = grayColor;
                            }
                            return rgbaData;
                        } else if (this.numComponents === 3 && this._isColorConversionNeeded) {
                            if (forceRGBA) {
                                const rgbaData = new Uint8ClampedArray(data.length / 3 * 4);
                                return this._convertYccToRgba(data, rgbaData);
                            }
                            return this._convertYccToRgb(data);
                        } else if (this.numComponents === 4) {
                            if (this._isColorConversionNeeded) {
                                if (forceRGBA) return this._convertYcckToRgba(data);
                                if (forceRGB) return this._convertYcckToRgb(data);
                                return this._convertYcckToCmyk(data);
                            } else if (forceRGBA) return this._convertCmykToRgba(data);
                            else if (forceRGB) return this._convertCmykToRgb(data);
                        }
                        return data;
                    }
                }
                exports.JpegImage = JpegImage;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                exports.convertToRGBA = convertToRGBA;
                exports.grayToRGBA = grayToRGBA;
                var _util = __w_pdfjs_require__(2);
                function convertToRGBA(params) {
                    switch(params.kind){
                        case _util.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(params);
                        case _util.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA(params);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, width: width, height: height, nonBlackColor: nonBlackColor = 0xffffffff, inverseDecode: inverseDecode = false }) {
                    const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    const [zeroMapping, oneMapping] = inverseDecode ? [
                        nonBlackColor,
                        black
                    ] : [
                        black,
                        nonBlackColor
                    ];
                    const widthInSource = width >> 3;
                    const widthRemainder = width & 7;
                    const srcLength = src.length;
                    dest = new Uint32Array(dest.buffer);
                    let destPos = 0;
                    for(let i = 0; i < height; i++){
                        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
                            const elem = srcPos < srcLength ? src[srcPos] : 255;
                            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
                        }
                        if (widthRemainder === 0) continue;
                        const elem = srcPos < srcLength ? src[srcPos++] : 255;
                        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function convertRGBToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, destPos: destPos = 0, width: width, height: height }) {
                    let i = 0;
                    const len32 = src.length >> 2;
                    const src32 = new Uint32Array(src.buffer, srcPos, len32);
                    if (_util.FeatureTest.isLittleEndian) {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff000000;
                            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
                            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
                            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
                    } else {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff;
                            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
                            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
                            dest[destPos + 3] = s3 << 8 | 0xff;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function grayToRGBA(src, dest) {
                    if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
                    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpxStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _jpx = __w_pdfjs_require__(30);
                var _util = __w_pdfjs_require__(2);
                class JpxStream extends _decode_stream.DecodeStream {
                    constructor(stream, maybeLength, params){
                        super(maybeLength);
                        this.stream = stream;
                        this.dict = stream.dict;
                        this.maybeLength = maybeLength;
                        this.params = params;
                    }
                    get bytes() {
                        return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(requested) {}
                    readBlock() {
                        if (this.eof) return;
                        const jpxImage = new _jpx.JpxImage();
                        jpxImage.parse(this.bytes);
                        const width = jpxImage.width;
                        const height = jpxImage.height;
                        const componentsCount = jpxImage.componentsCount;
                        const tileCount = jpxImage.tiles.length;
                        if (tileCount === 1) this.buffer = jpxImage.tiles[0].items;
                        else {
                            const data = new Uint8ClampedArray(width * height * componentsCount);
                            for(let k = 0; k < tileCount; k++){
                                const tileComponents = jpxImage.tiles[k];
                                const tileWidth = tileComponents.width;
                                const tileHeight = tileComponents.height;
                                const tileLeft = tileComponents.left;
                                const tileTop = tileComponents.top;
                                const src = tileComponents.items;
                                let srcPosition = 0;
                                let dataPosition = (width * tileTop + tileLeft) * componentsCount;
                                const imgRowSize = width * componentsCount;
                                const tileRowSize = tileWidth * componentsCount;
                                for(let j = 0; j < tileHeight; j++){
                                    const rowBytes = src.subarray(srcPosition, srcPosition + tileRowSize);
                                    data.set(rowBytes, dataPosition);
                                    srcPosition += tileRowSize;
                                    dataPosition += imgRowSize;
                                }
                            }
                            this.buffer = data;
                        }
                        this.bufferLength = this.buffer.length;
                        this.eof = true;
                    }
                }
                exports.JpxStream = JpxStream;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpxImage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _arithmetic_decoder = __w_pdfjs_require__(25);
                class JpxError extends _util.BaseException {
                    constructor(msg){
                        super(`JPX error: ${msg}`, "JpxError");
                    }
                }
                const SubbandsGainLog2 = {
                    LL: 0,
                    LH: 1,
                    HL: 1,
                    HH: 2
                };
                class JpxImage {
                    constructor(){
                        this.failOnCorruptedImage = false;
                    }
                    parse(data) {
                        const head = (0, _core_utils.readUint16)(data, 0);
                        if (head === 0xff4f) {
                            this.parseCodestream(data, 0, data.length);
                            return;
                        }
                        const length = data.length;
                        let position = 0;
                        while(position < length){
                            let headerSize = 8;
                            let lbox = (0, _core_utils.readUint32)(data, position);
                            const tbox = (0, _core_utils.readUint32)(data, position + 4);
                            position += headerSize;
                            if (lbox === 1) {
                                lbox = (0, _core_utils.readUint32)(data, position) * 4294967296 + (0, _core_utils.readUint32)(data, position + 4);
                                position += 8;
                                headerSize += 8;
                            }
                            if (lbox === 0) lbox = length - position + headerSize;
                            if (lbox < headerSize) throw new JpxError("Invalid box field size");
                            const dataLength = lbox - headerSize;
                            let jumpDataLength = true;
                            switch(tbox){
                                case 0x6a703268:
                                    jumpDataLength = false;
                                    break;
                                case 0x636f6c72:
                                    const method = data[position];
                                    if (method === 1) {
                                        const colorspace = (0, _core_utils.readUint32)(data, position + 3);
                                        switch(colorspace){
                                            case 16:
                                            case 17:
                                            case 18:
                                                break;
                                            default:
                                                (0, _util.warn)("Unknown colorspace " + colorspace);
                                                break;
                                        }
                                    } else if (method === 2) (0, _util.info)("ICC profile not supported");
                                    break;
                                case 0x6a703263:
                                    this.parseCodestream(data, position, position + dataLength);
                                    break;
                                case 0x6a502020:
                                    if ((0, _core_utils.readUint32)(data, position) !== 0x0d0a870a) (0, _util.warn)("Invalid JP2 signature");
                                    break;
                                case 0x6a501a1a:
                                case 0x66747970:
                                case 0x72726571:
                                case 0x72657320:
                                case 0x69686472:
                                    break;
                                default:
                                    const headerType = String.fromCharCode(tbox >> 24 & 0xff, tbox >> 16 & 0xff, tbox >> 8 & 0xff, tbox & 0xff);
                                    (0, _util.warn)(`Unsupported header type ${tbox} (${headerType}).`);
                                    break;
                            }
                            if (jumpDataLength) position += dataLength;
                        }
                    }
                    parseImageProperties(stream) {
                        let newByte = stream.getByte();
                        while(newByte >= 0){
                            const oldByte = newByte;
                            newByte = stream.getByte();
                            const code = oldByte << 8 | newByte;
                            if (code === 0xff51) {
                                stream.skip(4);
                                const Xsiz = stream.getInt32() >>> 0;
                                const Ysiz = stream.getInt32() >>> 0;
                                const XOsiz = stream.getInt32() >>> 0;
                                const YOsiz = stream.getInt32() >>> 0;
                                stream.skip(16);
                                const Csiz = stream.getUint16();
                                this.width = Xsiz - XOsiz;
                                this.height = Ysiz - YOsiz;
                                this.componentsCount = Csiz;
                                this.bitsPerComponent = 8;
                                return;
                            }
                        }
                        throw new JpxError("No size marker found in JPX stream");
                    }
                    parseCodestream(data, start, end) {
                        const context = {};
                        let doNotRecover = false;
                        try {
                            let position = start;
                            while(position + 1 < end){
                                const code = (0, _core_utils.readUint16)(data, position);
                                position += 2;
                                let length = 0, j, sqcd, spqcds, spqcdSize, scalarExpounded, tile;
                                switch(code){
                                    case 0xff4f:
                                        context.mainHeader = true;
                                        break;
                                    case 0xffd9:
                                        break;
                                    case 0xff51:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const siz = {};
                                        siz.Xsiz = (0, _core_utils.readUint32)(data, position + 4);
                                        siz.Ysiz = (0, _core_utils.readUint32)(data, position + 8);
                                        siz.XOsiz = (0, _core_utils.readUint32)(data, position + 12);
                                        siz.YOsiz = (0, _core_utils.readUint32)(data, position + 16);
                                        siz.XTsiz = (0, _core_utils.readUint32)(data, position + 20);
                                        siz.YTsiz = (0, _core_utils.readUint32)(data, position + 24);
                                        siz.XTOsiz = (0, _core_utils.readUint32)(data, position + 28);
                                        siz.YTOsiz = (0, _core_utils.readUint32)(data, position + 32);
                                        const componentsCount = (0, _core_utils.readUint16)(data, position + 36);
                                        siz.Csiz = componentsCount;
                                        const components = [];
                                        j = position + 38;
                                        for(let i = 0; i < componentsCount; i++){
                                            const component = {
                                                precision: (data[j] & 0x7f) + 1,
                                                isSigned: !!(data[j] & 0x80),
                                                XRsiz: data[j + 1],
                                                YRsiz: data[j + 2]
                                            };
                                            j += 3;
                                            calculateComponentDimensions(component, siz);
                                            components.push(component);
                                        }
                                        context.SIZ = siz;
                                        context.components = components;
                                        calculateTileGrids(context, components);
                                        context.QCC = [];
                                        context.COC = [];
                                        break;
                                    case 0xff5c:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const qcd = {};
                                        j = position + 2;
                                        sqcd = data[j++];
                                        switch(sqcd & 0x1f){
                                            case 0:
                                                spqcdSize = 8;
                                                scalarExpounded = true;
                                                break;
                                            case 1:
                                                spqcdSize = 16;
                                                scalarExpounded = false;
                                                break;
                                            case 2:
                                                spqcdSize = 16;
                                                scalarExpounded = true;
                                                break;
                                            default:
                                                throw new Error("Invalid SQcd value " + sqcd);
                                        }
                                        qcd.noQuantization = spqcdSize === 8;
                                        qcd.scalarExpounded = scalarExpounded;
                                        qcd.guardBits = sqcd >> 5;
                                        spqcds = [];
                                        while(j < length + position){
                                            const spqcd = {};
                                            if (spqcdSize === 8) {
                                                spqcd.epsilon = data[j++] >> 3;
                                                spqcd.mu = 0;
                                            } else {
                                                spqcd.epsilon = data[j] >> 3;
                                                spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                                                j += 2;
                                            }
                                            spqcds.push(spqcd);
                                        }
                                        qcd.SPqcds = spqcds;
                                        if (context.mainHeader) context.QCD = qcd;
                                        else {
                                            context.currentTile.QCD = qcd;
                                            context.currentTile.QCC = [];
                                        }
                                        break;
                                    case 0xff5d:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const qcc = {};
                                        j = position + 2;
                                        let cqcc;
                                        if (context.SIZ.Csiz < 257) cqcc = data[j++];
                                        else {
                                            cqcc = (0, _core_utils.readUint16)(data, j);
                                            j += 2;
                                        }
                                        sqcd = data[j++];
                                        switch(sqcd & 0x1f){
                                            case 0:
                                                spqcdSize = 8;
                                                scalarExpounded = true;
                                                break;
                                            case 1:
                                                spqcdSize = 16;
                                                scalarExpounded = false;
                                                break;
                                            case 2:
                                                spqcdSize = 16;
                                                scalarExpounded = true;
                                                break;
                                            default:
                                                throw new Error("Invalid SQcd value " + sqcd);
                                        }
                                        qcc.noQuantization = spqcdSize === 8;
                                        qcc.scalarExpounded = scalarExpounded;
                                        qcc.guardBits = sqcd >> 5;
                                        spqcds = [];
                                        while(j < length + position){
                                            const spqcd = {};
                                            if (spqcdSize === 8) {
                                                spqcd.epsilon = data[j++] >> 3;
                                                spqcd.mu = 0;
                                            } else {
                                                spqcd.epsilon = data[j] >> 3;
                                                spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                                                j += 2;
                                            }
                                            spqcds.push(spqcd);
                                        }
                                        qcc.SPqcds = spqcds;
                                        if (context.mainHeader) context.QCC[cqcc] = qcc;
                                        else context.currentTile.QCC[cqcc] = qcc;
                                        break;
                                    case 0xff52:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const cod = {};
                                        j = position + 2;
                                        const scod = data[j++];
                                        cod.entropyCoderWithCustomPrecincts = !!(scod & 1);
                                        cod.sopMarkerUsed = !!(scod & 2);
                                        cod.ephMarkerUsed = !!(scod & 4);
                                        cod.progressionOrder = data[j++];
                                        cod.layersCount = (0, _core_utils.readUint16)(data, j);
                                        j += 2;
                                        cod.multipleComponentTransform = data[j++];
                                        cod.decompositionLevelsCount = data[j++];
                                        cod.xcb = (data[j++] & 0xf) + 2;
                                        cod.ycb = (data[j++] & 0xf) + 2;
                                        const blockStyle = data[j++];
                                        cod.selectiveArithmeticCodingBypass = !!(blockStyle & 1);
                                        cod.resetContextProbabilities = !!(blockStyle & 2);
                                        cod.terminationOnEachCodingPass = !!(blockStyle & 4);
                                        cod.verticallyStripe = !!(blockStyle & 8);
                                        cod.predictableTermination = !!(blockStyle & 16);
                                        cod.segmentationSymbolUsed = !!(blockStyle & 32);
                                        cod.reversibleTransformation = data[j++];
                                        if (cod.entropyCoderWithCustomPrecincts) {
                                            const precinctsSizes = [];
                                            while(j < length + position){
                                                const precinctsSize = data[j++];
                                                precinctsSizes.push({
                                                    PPx: precinctsSize & 0xf,
                                                    PPy: precinctsSize >> 4
                                                });
                                            }
                                            cod.precinctsSizes = precinctsSizes;
                                        }
                                        const unsupported = [];
                                        if (cod.selectiveArithmeticCodingBypass) unsupported.push("selectiveArithmeticCodingBypass");
                                        if (cod.terminationOnEachCodingPass) unsupported.push("terminationOnEachCodingPass");
                                        if (cod.verticallyStripe) unsupported.push("verticallyStripe");
                                        if (cod.predictableTermination) unsupported.push("predictableTermination");
                                        if (unsupported.length > 0) {
                                            doNotRecover = true;
                                            (0, _util.warn)(`JPX: Unsupported COD options (${unsupported.join(", ")}).`);
                                        }
                                        if (context.mainHeader) context.COD = cod;
                                        else {
                                            context.currentTile.COD = cod;
                                            context.currentTile.COC = [];
                                        }
                                        break;
                                    case 0xff90:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        tile = {};
                                        tile.index = (0, _core_utils.readUint16)(data, position + 2);
                                        tile.length = (0, _core_utils.readUint32)(data, position + 4);
                                        tile.dataEnd = tile.length + position - 2;
                                        tile.partIndex = data[position + 8];
                                        tile.partsCount = data[position + 9];
                                        context.mainHeader = false;
                                        if (tile.partIndex === 0) {
                                            tile.COD = context.COD;
                                            tile.COC = context.COC.slice(0);
                                            tile.QCD = context.QCD;
                                            tile.QCC = context.QCC.slice(0);
                                        }
                                        context.currentTile = tile;
                                        break;
                                    case 0xff93:
                                        tile = context.currentTile;
                                        if (tile.partIndex === 0) {
                                            initializeTile(context, tile.index);
                                            buildPackets(context);
                                        }
                                        length = tile.dataEnd - position;
                                        parseTilePackets(context, data, position, length);
                                        break;
                                    case 0xff53:
                                        (0, _util.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                                    case 0xff55:
                                    case 0xff57:
                                    case 0xff58:
                                    case 0xff64:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        break;
                                    default:
                                        throw new Error("Unknown codestream code: " + code.toString(16));
                                }
                                position += length;
                            }
                        } catch (e) {
                            if (doNotRecover || this.failOnCorruptedImage) throw new JpxError(e.message);
                            else (0, _util.warn)(`JPX: Trying to recover from: "${e.message}".`);
                        }
                        this.tiles = transformComponents(context);
                        this.width = context.SIZ.Xsiz - context.SIZ.XOsiz;
                        this.height = context.SIZ.Ysiz - context.SIZ.YOsiz;
                        this.componentsCount = context.SIZ.Csiz;
                    }
                }
                exports.JpxImage = JpxImage;
                function calculateComponentDimensions(component, siz) {
                    component.x0 = Math.ceil(siz.XOsiz / component.XRsiz);
                    component.x1 = Math.ceil(siz.Xsiz / component.XRsiz);
                    component.y0 = Math.ceil(siz.YOsiz / component.YRsiz);
                    component.y1 = Math.ceil(siz.Ysiz / component.YRsiz);
                    component.width = component.x1 - component.x0;
                    component.height = component.y1 - component.y0;
                }
                function calculateTileGrids(context, components) {
                    const siz = context.SIZ;
                    const tiles = [];
                    let tile;
                    const numXtiles = Math.ceil((siz.Xsiz - siz.XTOsiz) / siz.XTsiz);
                    const numYtiles = Math.ceil((siz.Ysiz - siz.YTOsiz) / siz.YTsiz);
                    for(let q = 0; q < numYtiles; q++)for(let p = 0; p < numXtiles; p++){
                        tile = {};
                        tile.tx0 = Math.max(siz.XTOsiz + p * siz.XTsiz, siz.XOsiz);
                        tile.ty0 = Math.max(siz.YTOsiz + q * siz.YTsiz, siz.YOsiz);
                        tile.tx1 = Math.min(siz.XTOsiz + (p + 1) * siz.XTsiz, siz.Xsiz);
                        tile.ty1 = Math.min(siz.YTOsiz + (q + 1) * siz.YTsiz, siz.Ysiz);
                        tile.width = tile.tx1 - tile.tx0;
                        tile.height = tile.ty1 - tile.ty0;
                        tile.components = [];
                        tiles.push(tile);
                    }
                    context.tiles = tiles;
                    const componentsCount = siz.Csiz;
                    for(let i = 0, ii = componentsCount; i < ii; i++){
                        const component = components[i];
                        for(let j = 0, jj = tiles.length; j < jj; j++){
                            const tileComponent = {};
                            tile = tiles[j];
                            tileComponent.tcx0 = Math.ceil(tile.tx0 / component.XRsiz);
                            tileComponent.tcy0 = Math.ceil(tile.ty0 / component.YRsiz);
                            tileComponent.tcx1 = Math.ceil(tile.tx1 / component.XRsiz);
                            tileComponent.tcy1 = Math.ceil(tile.ty1 / component.YRsiz);
                            tileComponent.width = tileComponent.tcx1 - tileComponent.tcx0;
                            tileComponent.height = tileComponent.tcy1 - tileComponent.tcy0;
                            tile.components[i] = tileComponent;
                        }
                    }
                }
                function getBlocksDimensions(context, component, r) {
                    const codOrCoc = component.codingStyleParameters;
                    const result = {};
                    if (!codOrCoc.entropyCoderWithCustomPrecincts) {
                        result.PPx = 15;
                        result.PPy = 15;
                    } else {
                        result.PPx = codOrCoc.precinctsSizes[r].PPx;
                        result.PPy = codOrCoc.precinctsSizes[r].PPy;
                    }
                    result.xcb_ = r > 0 ? Math.min(codOrCoc.xcb, result.PPx - 1) : Math.min(codOrCoc.xcb, result.PPx);
                    result.ycb_ = r > 0 ? Math.min(codOrCoc.ycb, result.PPy - 1) : Math.min(codOrCoc.ycb, result.PPy);
                    return result;
                }
                function buildPrecincts(context, resolution, dimensions) {
                    const precinctWidth = 1 << dimensions.PPx;
                    const precinctHeight = 1 << dimensions.PPy;
                    const isZeroRes = resolution.resLevel === 0;
                    const precinctWidthInSubband = 1 << dimensions.PPx + (isZeroRes ? 0 : -1);
                    const precinctHeightInSubband = 1 << dimensions.PPy + (isZeroRes ? 0 : -1);
                    const numprecinctswide = resolution.trx1 > resolution.trx0 ? Math.ceil(resolution.trx1 / precinctWidth) - Math.floor(resolution.trx0 / precinctWidth) : 0;
                    const numprecinctshigh = resolution.try1 > resolution.try0 ? Math.ceil(resolution.try1 / precinctHeight) - Math.floor(resolution.try0 / precinctHeight) : 0;
                    const numprecincts = numprecinctswide * numprecinctshigh;
                    resolution.precinctParameters = {
                        precinctWidth: precinctWidth,
                        precinctHeight: precinctHeight,
                        numprecinctswide: numprecinctswide,
                        numprecinctshigh: numprecinctshigh,
                        numprecincts: numprecincts,
                        precinctWidthInSubband: precinctWidthInSubband,
                        precinctHeightInSubband: precinctHeightInSubband
                    };
                }
                function buildCodeblocks(context, subband, dimensions) {
                    const xcb_ = dimensions.xcb_;
                    const ycb_ = dimensions.ycb_;
                    const codeblockWidth = 1 << xcb_;
                    const codeblockHeight = 1 << ycb_;
                    const cbx0 = subband.tbx0 >> xcb_;
                    const cby0 = subband.tby0 >> ycb_;
                    const cbx1 = subband.tbx1 + codeblockWidth - 1 >> xcb_;
                    const cby1 = subband.tby1 + codeblockHeight - 1 >> ycb_;
                    const precinctParameters = subband.resolution.precinctParameters;
                    const codeblocks = [];
                    const precincts = [];
                    let i, j, codeblock, precinctNumber;
                    for(j = cby0; j < cby1; j++)for(i = cbx0; i < cbx1; i++){
                        codeblock = {
                            cbx: i,
                            cby: j,
                            tbx0: codeblockWidth * i,
                            tby0: codeblockHeight * j,
                            tbx1: codeblockWidth * (i + 1),
                            tby1: codeblockHeight * (j + 1)
                        };
                        codeblock.tbx0_ = Math.max(subband.tbx0, codeblock.tbx0);
                        codeblock.tby0_ = Math.max(subband.tby0, codeblock.tby0);
                        codeblock.tbx1_ = Math.min(subband.tbx1, codeblock.tbx1);
                        codeblock.tby1_ = Math.min(subband.tby1, codeblock.tby1);
                        const pi = Math.floor((codeblock.tbx0_ - subband.tbx0) / precinctParameters.precinctWidthInSubband);
                        const pj = Math.floor((codeblock.tby0_ - subband.tby0) / precinctParameters.precinctHeightInSubband);
                        precinctNumber = pi + pj * precinctParameters.numprecinctswide;
                        codeblock.precinctNumber = precinctNumber;
                        codeblock.subbandType = subband.type;
                        codeblock.Lblock = 3;
                        if (codeblock.tbx1_ <= codeblock.tbx0_ || codeblock.tby1_ <= codeblock.tby0_) continue;
                        codeblocks.push(codeblock);
                        let precinct = precincts[precinctNumber];
                        if (precinct !== undefined) {
                            if (i < precinct.cbxMin) precinct.cbxMin = i;
                            else if (i > precinct.cbxMax) precinct.cbxMax = i;
                            if (j < precinct.cbyMin) precinct.cbxMin = j;
                            else if (j > precinct.cbyMax) precinct.cbyMax = j;
                        } else precincts[precinctNumber] = precinct = {
                            cbxMin: i,
                            cbyMin: j,
                            cbxMax: i,
                            cbyMax: j
                        };
                        codeblock.precinct = precinct;
                    }
                    subband.codeblockParameters = {
                        codeblockWidth: xcb_,
                        codeblockHeight: ycb_,
                        numcodeblockwide: cbx1 - cbx0 + 1,
                        numcodeblockhigh: cby1 - cby0 + 1
                    };
                    subband.codeblocks = codeblocks;
                    subband.precincts = precincts;
                }
                function createPacket(resolution, precinctNumber, layerNumber) {
                    const precinctCodeblocks = [];
                    const subbands = resolution.subbands;
                    for(let i = 0, ii = subbands.length; i < ii; i++){
                        const subband = subbands[i];
                        const codeblocks = subband.codeblocks;
                        for(let j = 0, jj = codeblocks.length; j < jj; j++){
                            const codeblock = codeblocks[j];
                            if (codeblock.precinctNumber !== precinctNumber) continue;
                            precinctCodeblocks.push(codeblock);
                        }
                    }
                    return {
                        layerNumber: layerNumber,
                        codeblocks: precinctCodeblocks
                    };
                }
                function LayerResolutionComponentPositionIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    let maxDecompositionLevelsCount = 0;
                    for(let q = 0; q < componentsCount; q++)maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
                    let l = 0, r = 0, i = 0, k = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; l < layersCount; l++){
                            for(; r <= maxDecompositionLevelsCount; r++){
                                for(; i < componentsCount; i++){
                                    const component = tile.components[i];
                                    if (r > component.codingStyleParameters.decompositionLevelsCount) continue;
                                    const resolution = component.resolutions[r];
                                    const numprecincts = resolution.precinctParameters.numprecincts;
                                    for(; k < numprecincts;){
                                        const packet = createPacket(resolution, k, l);
                                        k++;
                                        return packet;
                                    }
                                    k = 0;
                                }
                                i = 0;
                            }
                            r = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ResolutionLayerComponentPositionIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    let maxDecompositionLevelsCount = 0;
                    for(let q = 0; q < componentsCount; q++)maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
                    let r = 0, l = 0, i = 0, k = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; r <= maxDecompositionLevelsCount; r++){
                            for(; l < layersCount; l++){
                                for(; i < componentsCount; i++){
                                    const component = tile.components[i];
                                    if (r > component.codingStyleParameters.decompositionLevelsCount) continue;
                                    const resolution = component.resolutions[r];
                                    const numprecincts = resolution.precinctParameters.numprecincts;
                                    for(; k < numprecincts;){
                                        const packet = createPacket(resolution, k, l);
                                        k++;
                                        return packet;
                                    }
                                    k = 0;
                                }
                                i = 0;
                            }
                            l = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ResolutionPositionComponentLayerIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    let l, r, c, p;
                    let maxDecompositionLevelsCount = 0;
                    for(c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, component.codingStyleParameters.decompositionLevelsCount);
                    }
                    const maxNumPrecinctsInLevel = new Int32Array(maxDecompositionLevelsCount + 1);
                    for(r = 0; r <= maxDecompositionLevelsCount; ++r){
                        let maxNumPrecincts = 0;
                        for(c = 0; c < componentsCount; ++c){
                            const resolutions = tile.components[c].resolutions;
                            if (r < resolutions.length) maxNumPrecincts = Math.max(maxNumPrecincts, resolutions[r].precinctParameters.numprecincts);
                        }
                        maxNumPrecinctsInLevel[r] = maxNumPrecincts;
                    }
                    l = 0;
                    r = 0;
                    c = 0;
                    p = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; r <= maxDecompositionLevelsCount; r++){
                            for(; p < maxNumPrecinctsInLevel[r]; p++){
                                for(; c < componentsCount; c++){
                                    const component = tile.components[c];
                                    if (r > component.codingStyleParameters.decompositionLevelsCount) continue;
                                    const resolution = component.resolutions[r];
                                    const numprecincts = resolution.precinctParameters.numprecincts;
                                    if (p >= numprecincts) continue;
                                    for(; l < layersCount;){
                                        const packet = createPacket(resolution, p, l);
                                        l++;
                                        return packet;
                                    }
                                    l = 0;
                                }
                                c = 0;
                            }
                            p = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function PositionComponentResolutionLayerIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    const precinctsSizes = getPrecinctSizesInImageScale(tile);
                    const precinctsIterationSizes = precinctsSizes;
                    let l = 0, r = 0, c = 0, px = 0, py = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; py < precinctsIterationSizes.maxNumHigh; py++){
                            for(; px < precinctsIterationSizes.maxNumWide; px++){
                                for(; c < componentsCount; c++){
                                    const component = tile.components[c];
                                    const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                                    for(; r <= decompositionLevelsCount; r++){
                                        const resolution = component.resolutions[r];
                                        const sizeInImageScale = precinctsSizes.components[c].resolutions[r];
                                        const k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                                        if (k === null) continue;
                                        for(; l < layersCount;){
                                            const packet = createPacket(resolution, k, l);
                                            l++;
                                            return packet;
                                        }
                                        l = 0;
                                    }
                                    r = 0;
                                }
                                c = 0;
                            }
                            px = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ComponentPositionResolutionLayerIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    const precinctsSizes = getPrecinctSizesInImageScale(tile);
                    let l = 0, r = 0, c = 0, px = 0, py = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; c < componentsCount; ++c){
                            const component = tile.components[c];
                            const precinctsIterationSizes = precinctsSizes.components[c];
                            const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                            for(; py < precinctsIterationSizes.maxNumHigh; py++){
                                for(; px < precinctsIterationSizes.maxNumWide; px++){
                                    for(; r <= decompositionLevelsCount; r++){
                                        const resolution = component.resolutions[r];
                                        const sizeInImageScale = precinctsIterationSizes.resolutions[r];
                                        const k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                                        if (k === null) continue;
                                        for(; l < layersCount;){
                                            const packet = createPacket(resolution, k, l);
                                            l++;
                                            return packet;
                                        }
                                        l = 0;
                                    }
                                    r = 0;
                                }
                                px = 0;
                            }
                            py = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function getPrecinctIndexIfExist(pxIndex, pyIndex, sizeInImageScale, precinctIterationSizes, resolution) {
                    const posX = pxIndex * precinctIterationSizes.minWidth;
                    const posY = pyIndex * precinctIterationSizes.minHeight;
                    if (posX % sizeInImageScale.width !== 0 || posY % sizeInImageScale.height !== 0) return null;
                    const startPrecinctRowIndex = posY / sizeInImageScale.width * resolution.precinctParameters.numprecinctswide;
                    return posX / sizeInImageScale.height + startPrecinctRowIndex;
                }
                function getPrecinctSizesInImageScale(tile) {
                    const componentsCount = tile.components.length;
                    let minWidth = Number.MAX_VALUE;
                    let minHeight = Number.MAX_VALUE;
                    let maxNumWide = 0;
                    let maxNumHigh = 0;
                    const sizePerComponent = new Array(componentsCount);
                    for(let c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                        const sizePerResolution = new Array(decompositionLevelsCount + 1);
                        let minWidthCurrentComponent = Number.MAX_VALUE;
                        let minHeightCurrentComponent = Number.MAX_VALUE;
                        let maxNumWideCurrentComponent = 0;
                        let maxNumHighCurrentComponent = 0;
                        let scale = 1;
                        for(let r = decompositionLevelsCount; r >= 0; --r){
                            const resolution = component.resolutions[r];
                            const widthCurrentResolution = scale * resolution.precinctParameters.precinctWidth;
                            const heightCurrentResolution = scale * resolution.precinctParameters.precinctHeight;
                            minWidthCurrentComponent = Math.min(minWidthCurrentComponent, widthCurrentResolution);
                            minHeightCurrentComponent = Math.min(minHeightCurrentComponent, heightCurrentResolution);
                            maxNumWideCurrentComponent = Math.max(maxNumWideCurrentComponent, resolution.precinctParameters.numprecinctswide);
                            maxNumHighCurrentComponent = Math.max(maxNumHighCurrentComponent, resolution.precinctParameters.numprecinctshigh);
                            sizePerResolution[r] = {
                                width: widthCurrentResolution,
                                height: heightCurrentResolution
                            };
                            scale <<= 1;
                        }
                        minWidth = Math.min(minWidth, minWidthCurrentComponent);
                        minHeight = Math.min(minHeight, minHeightCurrentComponent);
                        maxNumWide = Math.max(maxNumWide, maxNumWideCurrentComponent);
                        maxNumHigh = Math.max(maxNumHigh, maxNumHighCurrentComponent);
                        sizePerComponent[c] = {
                            resolutions: sizePerResolution,
                            minWidth: minWidthCurrentComponent,
                            minHeight: minHeightCurrentComponent,
                            maxNumWide: maxNumWideCurrentComponent,
                            maxNumHigh: maxNumHighCurrentComponent
                        };
                    }
                    return {
                        components: sizePerComponent,
                        minWidth: minWidth,
                        minHeight: minHeight,
                        maxNumWide: maxNumWide,
                        maxNumHigh: maxNumHigh
                    };
                }
                function buildPackets(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const componentsCount = siz.Csiz;
                    for(let c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                        const resolutions = [];
                        const subbands = [];
                        for(let r = 0; r <= decompositionLevelsCount; r++){
                            const blocksDimensions = getBlocksDimensions(context, component, r);
                            const resolution = {};
                            const scale = 1 << decompositionLevelsCount - r;
                            resolution.trx0 = Math.ceil(component.tcx0 / scale);
                            resolution.try0 = Math.ceil(component.tcy0 / scale);
                            resolution.trx1 = Math.ceil(component.tcx1 / scale);
                            resolution.try1 = Math.ceil(component.tcy1 / scale);
                            resolution.resLevel = r;
                            buildPrecincts(context, resolution, blocksDimensions);
                            resolutions.push(resolution);
                            let subband;
                            if (r === 0) {
                                subband = {};
                                subband.type = "LL";
                                subband.tbx0 = Math.ceil(component.tcx0 / scale);
                                subband.tby0 = Math.ceil(component.tcy0 / scale);
                                subband.tbx1 = Math.ceil(component.tcx1 / scale);
                                subband.tby1 = Math.ceil(component.tcy1 / scale);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolution.subbands = [
                                    subband
                                ];
                            } else {
                                const bscale = 1 << decompositionLevelsCount - r + 1;
                                const resolutionSubbands = [];
                                subband = {};
                                subband.type = "HL";
                                subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                                subband.tby0 = Math.ceil(component.tcy0 / bscale);
                                subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                                subband.tby1 = Math.ceil(component.tcy1 / bscale);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolutionSubbands.push(subband);
                                subband = {};
                                subband.type = "LH";
                                subband.tbx0 = Math.ceil(component.tcx0 / bscale);
                                subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                                subband.tbx1 = Math.ceil(component.tcx1 / bscale);
                                subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolutionSubbands.push(subband);
                                subband = {};
                                subband.type = "HH";
                                subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                                subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                                subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                                subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolutionSubbands.push(subband);
                                resolution.subbands = resolutionSubbands;
                            }
                        }
                        component.resolutions = resolutions;
                        component.subbands = subbands;
                    }
                    const progressionOrder = tile.codingStyleDefaultParameters.progressionOrder;
                    switch(progressionOrder){
                        case 0:
                            tile.packetsIterator = new LayerResolutionComponentPositionIterator(context);
                            break;
                        case 1:
                            tile.packetsIterator = new ResolutionLayerComponentPositionIterator(context);
                            break;
                        case 2:
                            tile.packetsIterator = new ResolutionPositionComponentLayerIterator(context);
                            break;
                        case 3:
                            tile.packetsIterator = new PositionComponentResolutionLayerIterator(context);
                            break;
                        case 4:
                            tile.packetsIterator = new ComponentPositionResolutionLayerIterator(context);
                            break;
                        default:
                            throw new JpxError(`Unsupported progression order ${progressionOrder}`);
                    }
                }
                function parseTilePackets(context, data, offset, dataLength) {
                    let position = 0;
                    let buffer, bufferSize = 0, skipNextBit = false;
                    function readBits(count) {
                        while(bufferSize < count){
                            const b = data[offset + position];
                            position++;
                            if (skipNextBit) {
                                buffer = buffer << 7 | b;
                                bufferSize += 7;
                                skipNextBit = false;
                            } else {
                                buffer = buffer << 8 | b;
                                bufferSize += 8;
                            }
                            if (b === 0xff) skipNextBit = true;
                        }
                        bufferSize -= count;
                        return buffer >>> bufferSize & (1 << count) - 1;
                    }
                    function skipMarkerIfEqual(value) {
                        if (data[offset + position - 1] === 0xff && data[offset + position] === value) {
                            skipBytes(1);
                            return true;
                        } else if (data[offset + position] === 0xff && data[offset + position + 1] === value) {
                            skipBytes(2);
                            return true;
                        }
                        return false;
                    }
                    function skipBytes(count) {
                        position += count;
                    }
                    function alignToByte() {
                        bufferSize = 0;
                        if (skipNextBit) {
                            position++;
                            skipNextBit = false;
                        }
                    }
                    function readCodingpasses() {
                        if (readBits(1) === 0) return 1;
                        if (readBits(1) === 0) return 2;
                        let value = readBits(2);
                        if (value < 3) return value + 3;
                        value = readBits(5);
                        if (value < 31) return value + 6;
                        value = readBits(7);
                        return value + 37;
                    }
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const sopMarkerUsed = context.COD.sopMarkerUsed;
                    const ephMarkerUsed = context.COD.ephMarkerUsed;
                    const packetsIterator = tile.packetsIterator;
                    while(position < dataLength){
                        alignToByte();
                        if (sopMarkerUsed && skipMarkerIfEqual(0x91)) skipBytes(4);
                        const packet = packetsIterator.nextPacket();
                        if (!readBits(1)) continue;
                        const layerNumber = packet.layerNumber, queue = [];
                        let codeblock;
                        for(let i = 0, ii = packet.codeblocks.length; i < ii; i++){
                            codeblock = packet.codeblocks[i];
                            let precinct = codeblock.precinct;
                            const codeblockColumn = codeblock.cbx - precinct.cbxMin;
                            const codeblockRow = codeblock.cby - precinct.cbyMin;
                            let codeblockIncluded = false;
                            let firstTimeInclusion = false;
                            let valueReady, zeroBitPlanesTree;
                            if (codeblock.included !== undefined) codeblockIncluded = !!readBits(1);
                            else {
                                precinct = codeblock.precinct;
                                let inclusionTree;
                                if (precinct.inclusionTree !== undefined) inclusionTree = precinct.inclusionTree;
                                else {
                                    const width = precinct.cbxMax - precinct.cbxMin + 1;
                                    const height = precinct.cbyMax - precinct.cbyMin + 1;
                                    inclusionTree = new InclusionTree(width, height, layerNumber);
                                    zeroBitPlanesTree = new TagTree(width, height);
                                    precinct.inclusionTree = inclusionTree;
                                    precinct.zeroBitPlanesTree = zeroBitPlanesTree;
                                    for(let l = 0; l < layerNumber; l++){
                                        if (readBits(1) !== 0) throw new JpxError("Invalid tag tree");
                                    }
                                }
                                if (inclusionTree.reset(codeblockColumn, codeblockRow, layerNumber)) {
                                    while(true)if (readBits(1)) {
                                        valueReady = !inclusionTree.nextLevel();
                                        if (valueReady) {
                                            codeblock.included = true;
                                            codeblockIncluded = firstTimeInclusion = true;
                                            break;
                                        }
                                    } else {
                                        inclusionTree.incrementValue(layerNumber);
                                        break;
                                    }
                                }
                            }
                            if (!codeblockIncluded) continue;
                            if (firstTimeInclusion) {
                                zeroBitPlanesTree = precinct.zeroBitPlanesTree;
                                zeroBitPlanesTree.reset(codeblockColumn, codeblockRow);
                                while(true)if (readBits(1)) {
                                    valueReady = !zeroBitPlanesTree.nextLevel();
                                    if (valueReady) break;
                                } else zeroBitPlanesTree.incrementValue();
                                codeblock.zeroBitPlanes = zeroBitPlanesTree.value;
                            }
                            const codingpasses = readCodingpasses();
                            while(readBits(1))codeblock.Lblock++;
                            const codingpassesLog2 = (0, _core_utils.log2)(codingpasses);
                            const bits = (codingpasses < 1 << codingpassesLog2 ? codingpassesLog2 - 1 : codingpassesLog2) + codeblock.Lblock;
                            const codedDataLength = readBits(bits);
                            queue.push({
                                codeblock: codeblock,
                                codingpasses: codingpasses,
                                dataLength: codedDataLength
                            });
                        }
                        alignToByte();
                        if (ephMarkerUsed) skipMarkerIfEqual(0x92);
                        while(queue.length > 0){
                            const packetItem = queue.shift();
                            codeblock = packetItem.codeblock;
                            if (codeblock.data === undefined) codeblock.data = [];
                            codeblock.data.push({
                                data: data,
                                start: offset + position,
                                end: offset + position + packetItem.dataLength,
                                codingpasses: packetItem.codingpasses
                            });
                            position += packetItem.dataLength;
                        }
                    }
                    return position;
                }
                function copyCoefficients(coefficients, levelWidth, levelHeight, subband, delta, mb, reversible, segmentationSymbolUsed, resetContextProbabilities) {
                    const x0 = subband.tbx0;
                    const y0 = subband.tby0;
                    const width = subband.tbx1 - subband.tbx0;
                    const codeblocks = subband.codeblocks;
                    const right = subband.type.charAt(0) === "H" ? 1 : 0;
                    const bottom = subband.type.charAt(1) === "H" ? levelWidth : 0;
                    for(let i = 0, ii = codeblocks.length; i < ii; ++i){
                        const codeblock = codeblocks[i];
                        const blockWidth = codeblock.tbx1_ - codeblock.tbx0_;
                        const blockHeight = codeblock.tby1_ - codeblock.tby0_;
                        if (blockWidth === 0 || blockHeight === 0) continue;
                        if (codeblock.data === undefined) continue;
                        const bitModel = new BitModel(blockWidth, blockHeight, codeblock.subbandType, codeblock.zeroBitPlanes, mb);
                        let currentCodingpassType = 2;
                        const data = codeblock.data;
                        let totalLength = 0, codingpasses = 0;
                        let j, jj, dataItem;
                        for(j = 0, jj = data.length; j < jj; j++){
                            dataItem = data[j];
                            totalLength += dataItem.end - dataItem.start;
                            codingpasses += dataItem.codingpasses;
                        }
                        const encodedData = new Uint8Array(totalLength);
                        let position = 0;
                        for(j = 0, jj = data.length; j < jj; j++){
                            dataItem = data[j];
                            const chunk = dataItem.data.subarray(dataItem.start, dataItem.end);
                            encodedData.set(chunk, position);
                            position += chunk.length;
                        }
                        const decoder = new _arithmetic_decoder.ArithmeticDecoder(encodedData, 0, totalLength);
                        bitModel.setDecoder(decoder);
                        for(j = 0; j < codingpasses; j++){
                            switch(currentCodingpassType){
                                case 0:
                                    bitModel.runSignificancePropagationPass();
                                    break;
                                case 1:
                                    bitModel.runMagnitudeRefinementPass();
                                    break;
                                case 2:
                                    bitModel.runCleanupPass();
                                    if (segmentationSymbolUsed) bitModel.checkSegmentationSymbol();
                                    break;
                            }
                            if (resetContextProbabilities) bitModel.reset();
                            currentCodingpassType = (currentCodingpassType + 1) % 3;
                        }
                        let offset = codeblock.tbx0_ - x0 + (codeblock.tby0_ - y0) * width;
                        const sign = bitModel.coefficentsSign;
                        const magnitude = bitModel.coefficentsMagnitude;
                        const bitsDecoded = bitModel.bitsDecoded;
                        const magnitudeCorrection = reversible ? 0 : 0.5;
                        let k, n, nb;
                        position = 0;
                        const interleave = subband.type !== "LL";
                        for(j = 0; j < blockHeight; j++){
                            const row = offset / width | 0;
                            const levelOffset = 2 * row * (levelWidth - width) + right + bottom;
                            for(k = 0; k < blockWidth; k++){
                                n = magnitude[position];
                                if (n !== 0) {
                                    n = (n + magnitudeCorrection) * delta;
                                    if (sign[position] !== 0) n = -n;
                                    nb = bitsDecoded[position];
                                    const pos = interleave ? levelOffset + (offset << 1) : offset;
                                    coefficients[pos] = reversible && nb >= mb ? n : n * (1 << mb - nb);
                                }
                                offset++;
                                position++;
                            }
                            offset += width - blockWidth;
                        }
                    }
                }
                function transformTile(context, tile, c) {
                    const component = tile.components[c];
                    const codingStyleParameters = component.codingStyleParameters;
                    const quantizationParameters = component.quantizationParameters;
                    const decompositionLevelsCount = codingStyleParameters.decompositionLevelsCount;
                    const spqcds = quantizationParameters.SPqcds;
                    const scalarExpounded = quantizationParameters.scalarExpounded;
                    const guardBits = quantizationParameters.guardBits;
                    const segmentationSymbolUsed = codingStyleParameters.segmentationSymbolUsed;
                    const resetContextProbabilities = codingStyleParameters.resetContextProbabilities;
                    const precision = context.components[c].precision;
                    const reversible = codingStyleParameters.reversibleTransformation;
                    const transform = reversible ? new ReversibleTransform() : new IrreversibleTransform();
                    const subbandCoefficients = [];
                    let b = 0;
                    for(let i = 0; i <= decompositionLevelsCount; i++){
                        const resolution = component.resolutions[i];
                        const width = resolution.trx1 - resolution.trx0;
                        const height = resolution.try1 - resolution.try0;
                        const coefficients = new Float32Array(width * height);
                        for(let j = 0, jj = resolution.subbands.length; j < jj; j++){
                            let mu, epsilon;
                            if (!scalarExpounded) {
                                mu = spqcds[0].mu;
                                epsilon = spqcds[0].epsilon + (i > 0 ? 1 - i : 0);
                            } else {
                                mu = spqcds[b].mu;
                                epsilon = spqcds[b].epsilon;
                                b++;
                            }
                            const subband = resolution.subbands[j];
                            const gainLog2 = SubbandsGainLog2[subband.type];
                            const delta = reversible ? 1 : 2 ** (precision + gainLog2 - epsilon) * (1 + mu / 2048);
                            const mb = guardBits + epsilon - 1;
                            copyCoefficients(coefficients, width, height, subband, delta, mb, reversible, segmentationSymbolUsed, resetContextProbabilities);
                        }
                        subbandCoefficients.push({
                            width: width,
                            height: height,
                            items: coefficients
                        });
                    }
                    const result = transform.calculate(subbandCoefficients, component.tcx0, component.tcy0);
                    return {
                        left: component.tcx0,
                        top: component.tcy0,
                        width: result.width,
                        height: result.height,
                        items: result.items
                    };
                }
                function transformComponents(context) {
                    const siz = context.SIZ;
                    const components = context.components;
                    const componentsCount = siz.Csiz;
                    const resultImages = [];
                    for(let i = 0, ii = context.tiles.length; i < ii; i++){
                        const tile = context.tiles[i];
                        const transformedTiles = [];
                        for(let c = 0; c < componentsCount; c++)transformedTiles[c] = transformTile(context, tile, c);
                        const tile0 = transformedTiles[0];
                        const out = new Uint8ClampedArray(tile0.items.length * componentsCount);
                        const result = {
                            left: tile0.left,
                            top: tile0.top,
                            width: tile0.width,
                            height: tile0.height,
                            items: out
                        };
                        let shift, offset;
                        let pos = 0, j, jj, y0, y1, y2;
                        if (tile.codingStyleDefaultParameters.multipleComponentTransform) {
                            const fourComponents = componentsCount === 4;
                            const y0items = transformedTiles[0].items;
                            const y1items = transformedTiles[1].items;
                            const y2items = transformedTiles[2].items;
                            const y3items = fourComponents ? transformedTiles[3].items : null;
                            shift = components[0].precision - 8;
                            offset = (128 << shift) + 0.5;
                            const component0 = tile.components[0];
                            const alpha01 = componentsCount - 3;
                            jj = y0items.length;
                            if (!component0.codingStyleParameters.reversibleTransformation) for(j = 0; j < jj; j++, pos += alpha01){
                                y0 = y0items[j] + offset;
                                y1 = y1items[j];
                                y2 = y2items[j];
                                out[pos++] = y0 + 1.402 * y2 >> shift;
                                out[pos++] = y0 - 0.34413 * y1 - 0.71414 * y2 >> shift;
                                out[pos++] = y0 + 1.772 * y1 >> shift;
                            }
                            else for(j = 0; j < jj; j++, pos += alpha01){
                                y0 = y0items[j] + offset;
                                y1 = y1items[j];
                                y2 = y2items[j];
                                const g = y0 - (y2 + y1 >> 2);
                                out[pos++] = g + y2 >> shift;
                                out[pos++] = g >> shift;
                                out[pos++] = g + y1 >> shift;
                            }
                            if (fourComponents) for(j = 0, pos = 3; j < jj; j++, pos += 4)out[pos] = y3items[j] + offset >> shift;
                        } else for(let c = 0; c < componentsCount; c++){
                            const items = transformedTiles[c].items;
                            shift = components[c].precision - 8;
                            offset = (128 << shift) + 0.5;
                            for(pos = c, j = 0, jj = items.length; j < jj; j++){
                                out[pos] = items[j] + offset >> shift;
                                pos += componentsCount;
                            }
                        }
                        resultImages.push(result);
                    }
                    return resultImages;
                }
                function initializeTile(context, tileIndex) {
                    const siz = context.SIZ;
                    const componentsCount = siz.Csiz;
                    const tile = context.tiles[tileIndex];
                    for(let c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        const qcdOrQcc = context.currentTile.QCC[c] !== undefined ? context.currentTile.QCC[c] : context.currentTile.QCD;
                        component.quantizationParameters = qcdOrQcc;
                        const codOrCoc = context.currentTile.COC[c] !== undefined ? context.currentTile.COC[c] : context.currentTile.COD;
                        component.codingStyleParameters = codOrCoc;
                    }
                    tile.codingStyleDefaultParameters = context.currentTile.COD;
                }
                class TagTree {
                    constructor(width, height){
                        const levelsLength = (0, _core_utils.log2)(Math.max(width, height)) + 1;
                        this.levels = [];
                        for(let i = 0; i < levelsLength; i++){
                            const level = {
                                width: width,
                                height: height,
                                items: []
                            };
                            this.levels.push(level);
                            width = Math.ceil(width / 2);
                            height = Math.ceil(height / 2);
                        }
                    }
                    reset(i, j) {
                        let currentLevel = 0, value = 0, level;
                        while(currentLevel < this.levels.length){
                            level = this.levels[currentLevel];
                            const index = i + j * level.width;
                            if (level.items[index] !== undefined) {
                                value = level.items[index];
                                break;
                            }
                            level.index = index;
                            i >>= 1;
                            j >>= 1;
                            currentLevel++;
                        }
                        currentLevel--;
                        level = this.levels[currentLevel];
                        level.items[level.index] = value;
                        this.currentLevel = currentLevel;
                        delete this.value;
                    }
                    incrementValue() {
                        const level = this.levels[this.currentLevel];
                        level.items[level.index]++;
                    }
                    nextLevel() {
                        let currentLevel = this.currentLevel;
                        let level = this.levels[currentLevel];
                        const value = level.items[level.index];
                        currentLevel--;
                        if (currentLevel < 0) {
                            this.value = value;
                            return false;
                        }
                        this.currentLevel = currentLevel;
                        level = this.levels[currentLevel];
                        level.items[level.index] = value;
                        return true;
                    }
                }
                class InclusionTree {
                    constructor(width, height, defaultValue){
                        const levelsLength = (0, _core_utils.log2)(Math.max(width, height)) + 1;
                        this.levels = [];
                        for(let i = 0; i < levelsLength; i++){
                            const items = new Uint8Array(width * height);
                            for(let j = 0, jj = items.length; j < jj; j++)items[j] = defaultValue;
                            const level = {
                                width: width,
                                height: height,
                                items: items
                            };
                            this.levels.push(level);
                            width = Math.ceil(width / 2);
                            height = Math.ceil(height / 2);
                        }
                    }
                    reset(i, j, stopValue) {
                        let currentLevel = 0;
                        while(currentLevel < this.levels.length){
                            const level = this.levels[currentLevel];
                            const index = i + j * level.width;
                            level.index = index;
                            const value = level.items[index];
                            if (value === 0xff) break;
                            if (value > stopValue) {
                                this.currentLevel = currentLevel;
                                this.propagateValues();
                                return false;
                            }
                            i >>= 1;
                            j >>= 1;
                            currentLevel++;
                        }
                        this.currentLevel = currentLevel - 1;
                        return true;
                    }
                    incrementValue(stopValue) {
                        const level = this.levels[this.currentLevel];
                        level.items[level.index] = stopValue + 1;
                        this.propagateValues();
                    }
                    propagateValues() {
                        let levelIndex = this.currentLevel;
                        let level = this.levels[levelIndex];
                        const currentValue = level.items[level.index];
                        while(--levelIndex >= 0){
                            level = this.levels[levelIndex];
                            level.items[level.index] = currentValue;
                        }
                    }
                    nextLevel() {
                        let currentLevel = this.currentLevel;
                        let level = this.levels[currentLevel];
                        const value = level.items[level.index];
                        level.items[level.index] = 0xff;
                        currentLevel--;
                        if (currentLevel < 0) return false;
                        this.currentLevel = currentLevel;
                        level = this.levels[currentLevel];
                        level.items[level.index] = value;
                        return true;
                    }
                }
                class BitModel {
                    static UNIFORM_CONTEXT = 17;
                    static RUNLENGTH_CONTEXT = 18;
                    static LLAndLHContextsLabel = new Uint8Array([
                        0,
                        5,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8
                    ]);
                    static HLContextLabel = new Uint8Array([
                        0,
                        3,
                        4,
                        0,
                        5,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8
                    ]);
                    static HHContextLabel = new Uint8Array([
                        0,
                        1,
                        2,
                        0,
                        1,
                        2,
                        2,
                        0,
                        2,
                        2,
                        2,
                        0,
                        0,
                        0,
                        0,
                        0,
                        3,
                        4,
                        5,
                        0,
                        4,
                        5,
                        5,
                        0,
                        5,
                        5,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        6,
                        7,
                        7,
                        0,
                        7,
                        7,
                        7,
                        0,
                        7,
                        7,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8
                    ]);
                    constructor(width, height, subband, zeroBitPlanes, mb){
                        this.width = width;
                        this.height = height;
                        let contextLabelTable;
                        if (subband === "HH") contextLabelTable = BitModel.HHContextLabel;
                        else if (subband === "HL") contextLabelTable = BitModel.HLContextLabel;
                        else contextLabelTable = BitModel.LLAndLHContextsLabel;
                        this.contextLabelTable = contextLabelTable;
                        const coefficientCount = width * height;
                        this.neighborsSignificance = new Uint8Array(coefficientCount);
                        this.coefficentsSign = new Uint8Array(coefficientCount);
                        let coefficentsMagnitude;
                        if (mb > 14) coefficentsMagnitude = new Uint32Array(coefficientCount);
                        else if (mb > 6) coefficentsMagnitude = new Uint16Array(coefficientCount);
                        else coefficentsMagnitude = new Uint8Array(coefficientCount);
                        this.coefficentsMagnitude = coefficentsMagnitude;
                        this.processingFlags = new Uint8Array(coefficientCount);
                        const bitsDecoded = new Uint8Array(coefficientCount);
                        if (zeroBitPlanes !== 0) for(let i = 0; i < coefficientCount; i++)bitsDecoded[i] = zeroBitPlanes;
                        this.bitsDecoded = bitsDecoded;
                        this.reset();
                    }
                    setDecoder(decoder) {
                        this.decoder = decoder;
                    }
                    reset() {
                        this.contexts = new Int8Array(19);
                        this.contexts[0] = 8;
                        this.contexts[BitModel.UNIFORM_CONTEXT] = 92;
                        this.contexts[BitModel.RUNLENGTH_CONTEXT] = 6;
                    }
                    setNeighborsSignificance(row, column, index) {
                        const neighborsSignificance = this.neighborsSignificance;
                        const width = this.width, height = this.height;
                        const left = column > 0;
                        const right = column + 1 < width;
                        let i;
                        if (row > 0) {
                            i = index - width;
                            if (left) neighborsSignificance[i - 1] += 0x10;
                            if (right) neighborsSignificance[i + 1] += 0x10;
                            neighborsSignificance[i] += 0x04;
                        }
                        if (row + 1 < height) {
                            i = index + width;
                            if (left) neighborsSignificance[i - 1] += 0x10;
                            if (right) neighborsSignificance[i + 1] += 0x10;
                            neighborsSignificance[i] += 0x04;
                        }
                        if (left) neighborsSignificance[index - 1] += 0x01;
                        if (right) neighborsSignificance[index + 1] += 0x01;
                        neighborsSignificance[index] |= 0x80;
                    }
                    runSignificancePropagationPass() {
                        const decoder = this.decoder;
                        const width = this.width, height = this.height;
                        const coefficentsMagnitude = this.coefficentsMagnitude;
                        const coefficentsSign = this.coefficentsSign;
                        const neighborsSignificance = this.neighborsSignificance;
                        const processingFlags = this.processingFlags;
                        const contexts = this.contexts;
                        const labels = this.contextLabelTable;
                        const bitsDecoded = this.bitsDecoded;
                        const processedInverseMask = -2;
                        const processedMask = 1;
                        const firstMagnitudeBitMask = 2;
                        for(let i0 = 0; i0 < height; i0 += 4)for(let j = 0; j < width; j++){
                            let index = i0 * width + j;
                            for(let i1 = 0; i1 < 4; i1++, index += width){
                                const i = i0 + i1;
                                if (i >= height) break;
                                processingFlags[index] &= processedInverseMask;
                                if (coefficentsMagnitude[index] || !neighborsSignificance[index]) continue;
                                const contextLabel = labels[neighborsSignificance[index]];
                                const decision = decoder.readBit(contexts, contextLabel);
                                if (decision) {
                                    const sign = this.decodeSignBit(i, j, index);
                                    coefficentsSign[index] = sign;
                                    coefficentsMagnitude[index] = 1;
                                    this.setNeighborsSignificance(i, j, index);
                                    processingFlags[index] |= firstMagnitudeBitMask;
                                }
                                bitsDecoded[index]++;
                                processingFlags[index] |= processedMask;
                            }
                        }
                    }
                    decodeSignBit(row, column, index) {
                        const width = this.width, height = this.height;
                        const coefficentsMagnitude = this.coefficentsMagnitude;
                        const coefficentsSign = this.coefficentsSign;
                        let contribution, sign0, sign1, significance1;
                        let contextLabel, decoded;
                        significance1 = column > 0 && coefficentsMagnitude[index - 1] !== 0;
                        if (column + 1 < width && coefficentsMagnitude[index + 1] !== 0) {
                            sign1 = coefficentsSign[index + 1];
                            if (significance1) {
                                sign0 = coefficentsSign[index - 1];
                                contribution = 1 - sign1 - sign0;
                            } else contribution = 1 - sign1 - sign1;
                        } else if (significance1) {
                            sign0 = coefficentsSign[index - 1];
                            contribution = 1 - sign0 - sign0;
                        } else contribution = 0;
                        const horizontalContribution = 3 * contribution;
                        significance1 = row > 0 && coefficentsMagnitude[index - width] !== 0;
                        if (row + 1 < height && coefficentsMagnitude[index + width] !== 0) {
                            sign1 = coefficentsSign[index + width];
                            if (significance1) {
                                sign0 = coefficentsSign[index - width];
                                contribution = 1 - sign1 - sign0 + horizontalContribution;
                            } else contribution = 1 - sign1 - sign1 + horizontalContribution;
                        } else if (significance1) {
                            sign0 = coefficentsSign[index - width];
                            contribution = 1 - sign0 - sign0 + horizontalContribution;
                        } else contribution = horizontalContribution;
                        if (contribution >= 0) {
                            contextLabel = 9 + contribution;
                            decoded = this.decoder.readBit(this.contexts, contextLabel);
                        } else {
                            contextLabel = 9 - contribution;
                            decoded = this.decoder.readBit(this.contexts, contextLabel) ^ 1;
                        }
                        return decoded;
                    }
                    runMagnitudeRefinementPass() {
                        const decoder = this.decoder;
                        const width = this.width, height = this.height;
                        const coefficentsMagnitude = this.coefficentsMagnitude;
                        const neighborsSignificance = this.neighborsSignificance;
                        const contexts = this.contexts;
                        const bitsDecoded = this.bitsDecoded;
                        const processingFlags = this.processingFlags;
                        const processedMask = 1;
                        const firstMagnitudeBitMask = 2;
                        const length = width * height;
                        const width4 = width * 4;
                        for(let index0 = 0, indexNext; index0 < length; index0 = indexNext){
                            indexNext = Math.min(length, index0 + width4);
                            for(let j = 0; j < width; j++)for(let index = index0 + j; index < indexNext; index += width){
                                if (!coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) continue;
                                let contextLabel = 16;
                                if ((processingFlags[index] & firstMagnitudeBitMask) !== 0) {
                                    processingFlags[index] ^= firstMagnitudeBitMask;
                                    const significance = neighborsSignificance[index] & 127;
                                    contextLabel = significance === 0 ? 15 : 14;
                                }
                                const bit = decoder.readBit(contexts, contextLabel);
                                coefficentsMagnitude[index] = coefficentsMagnitude[index] << 1 | bit;
                                bitsDecoded[index]++;
                                processingFlags[index] |= processedMask;
                            }
                        }
                    }
                    runCleanupPass() {
                        const decoder = this.decoder;
                        const width = this.width, height = this.height;
                        const neighborsSignificance = this.neighborsSignificance;
                        const coefficentsMagnitude = this.coefficentsMagnitude;
                        const coefficentsSign = this.coefficentsSign;
                        const contexts = this.contexts;
                        const labels = this.contextLabelTable;
                        const bitsDecoded = this.bitsDecoded;
                        const processingFlags = this.processingFlags;
                        const processedMask = 1;
                        const firstMagnitudeBitMask = 2;
                        const oneRowDown = width;
                        const twoRowsDown = width * 2;
                        const threeRowsDown = width * 3;
                        let iNext;
                        for(let i0 = 0; i0 < height; i0 = iNext){
                            iNext = Math.min(i0 + 4, height);
                            const indexBase = i0 * width;
                            const checkAllEmpty = i0 + 3 < height;
                            for(let j = 0; j < width; j++){
                                const index0 = indexBase + j;
                                const allEmpty = checkAllEmpty && processingFlags[index0] === 0 && processingFlags[index0 + oneRowDown] === 0 && processingFlags[index0 + twoRowsDown] === 0 && processingFlags[index0 + threeRowsDown] === 0 && neighborsSignificance[index0] === 0 && neighborsSignificance[index0 + oneRowDown] === 0 && neighborsSignificance[index0 + twoRowsDown] === 0 && neighborsSignificance[index0 + threeRowsDown] === 0;
                                let i1 = 0, index = index0;
                                let i = i0, sign;
                                if (allEmpty) {
                                    const hasSignificantCoefficent = decoder.readBit(contexts, BitModel.RUNLENGTH_CONTEXT);
                                    if (!hasSignificantCoefficent) {
                                        bitsDecoded[index0]++;
                                        bitsDecoded[index0 + oneRowDown]++;
                                        bitsDecoded[index0 + twoRowsDown]++;
                                        bitsDecoded[index0 + threeRowsDown]++;
                                        continue;
                                    }
                                    i1 = decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT);
                                    if (i1 !== 0) {
                                        i = i0 + i1;
                                        index += i1 * width;
                                    }
                                    sign = this.decodeSignBit(i, j, index);
                                    coefficentsSign[index] = sign;
                                    coefficentsMagnitude[index] = 1;
                                    this.setNeighborsSignificance(i, j, index);
                                    processingFlags[index] |= firstMagnitudeBitMask;
                                    index = index0;
                                    for(let i2 = i0; i2 <= i; i2++, index += width)bitsDecoded[index]++;
                                    i1++;
                                }
                                for(i = i0 + i1; i < iNext; i++, index += width){
                                    if (coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) continue;
                                    const contextLabel = labels[neighborsSignificance[index]];
                                    const decision = decoder.readBit(contexts, contextLabel);
                                    if (decision === 1) {
                                        sign = this.decodeSignBit(i, j, index);
                                        coefficentsSign[index] = sign;
                                        coefficentsMagnitude[index] = 1;
                                        this.setNeighborsSignificance(i, j, index);
                                        processingFlags[index] |= firstMagnitudeBitMask;
                                    }
                                    bitsDecoded[index]++;
                                }
                            }
                        }
                    }
                    checkSegmentationSymbol() {
                        const decoder = this.decoder;
                        const contexts = this.contexts;
                        const symbol = decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 3 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 2 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, BitModel.UNIFORM_CONTEXT);
                        if (symbol !== 0xa) throw new JpxError("Invalid segmentation symbol");
                    }
                }
                class Transform {
                    constructor(){
                        if (this.constructor === Transform) (0, _util.unreachable)("Cannot initialize Transform.");
                    }
                    calculate(subbands, u0, v0) {
                        let ll = subbands[0];
                        for(let i = 1, ii = subbands.length; i < ii; i++)ll = this.iterate(ll, subbands[i], u0, v0);
                        return ll;
                    }
                    extend(buffer, offset, size) {
                        let i1 = offset - 1, j1 = offset + 1;
                        let i2 = offset + size - 2, j2 = offset + size;
                        buffer[i1--] = buffer[j1++];
                        buffer[j2++] = buffer[i2--];
                        buffer[i1--] = buffer[j1++];
                        buffer[j2++] = buffer[i2--];
                        buffer[i1--] = buffer[j1++];
                        buffer[j2++] = buffer[i2--];
                        buffer[i1] = buffer[j1];
                        buffer[j2] = buffer[i2];
                    }
                    filter(x, offset, length) {
                        (0, _util.unreachable)("Abstract method `filter` called");
                    }
                    iterate(ll, hl_lh_hh, u0, v0) {
                        const llWidth = ll.width, llHeight = ll.height;
                        let llItems = ll.items;
                        const width = hl_lh_hh.width;
                        const height = hl_lh_hh.height;
                        const items = hl_lh_hh.items;
                        let i, j, k, l, u, v;
                        for(k = 0, i = 0; i < llHeight; i++){
                            l = i * 2 * width;
                            for(j = 0; j < llWidth; j++, k++, l += 2)items[l] = llItems[k];
                        }
                        llItems = ll.items = null;
                        const bufferPadding = 4;
                        const rowBuffer = new Float32Array(width + 2 * bufferPadding);
                        if (width === 1) {
                            if ((u0 & 1) !== 0) for(v = 0, k = 0; v < height; v++, k += width)items[k] *= 0.5;
                        } else for(v = 0, k = 0; v < height; v++, k += width){
                            rowBuffer.set(items.subarray(k, k + width), bufferPadding);
                            this.extend(rowBuffer, bufferPadding, width);
                            this.filter(rowBuffer, bufferPadding, width);
                            items.set(rowBuffer.subarray(bufferPadding, bufferPadding + width), k);
                        }
                        let numBuffers = 16;
                        const colBuffers = [];
                        for(i = 0; i < numBuffers; i++)colBuffers.push(new Float32Array(height + 2 * bufferPadding));
                        let b, currentBuffer = 0;
                        ll = bufferPadding + height;
                        if (height === 1) {
                            if ((v0 & 1) !== 0) for(u = 0; u < width; u++)items[u] *= 0.5;
                        } else for(u = 0; u < width; u++){
                            if (currentBuffer === 0) {
                                numBuffers = Math.min(width - u, numBuffers);
                                for(k = u, l = bufferPadding; l < ll; k += width, l++)for(b = 0; b < numBuffers; b++)colBuffers[b][l] = items[k + b];
                                currentBuffer = numBuffers;
                            }
                            currentBuffer--;
                            const buffer = colBuffers[currentBuffer];
                            this.extend(buffer, bufferPadding, height);
                            this.filter(buffer, bufferPadding, height);
                            if (currentBuffer === 0) {
                                k = u - numBuffers + 1;
                                for(l = bufferPadding; l < ll; k += width, l++)for(b = 0; b < numBuffers; b++)items[k + b] = colBuffers[b][l];
                            }
                        }
                        return {
                            width: width,
                            height: height,
                            items: items
                        };
                    }
                }
                class IrreversibleTransform extends Transform {
                    filter(x, offset, length) {
                        const len = length >> 1;
                        offset |= 0;
                        let j, n, current, next;
                        const alpha = -1.586134342059924;
                        const beta = -0.052980118572961;
                        const gamma = 0.882911075530934;
                        const delta = 0.443506852043971;
                        const K = 1.230174104914001;
                        const K_ = 1 / K;
                        j = offset - 3;
                        for(n = len + 4; n--; j += 2)x[j] *= K_;
                        j = offset - 2;
                        current = delta * x[j - 1];
                        for(n = len + 3; n--; j += 2){
                            next = delta * x[j + 1];
                            x[j] = K * x[j] - current - next;
                            if (n--) {
                                j += 2;
                                current = delta * x[j + 1];
                                x[j] = K * x[j] - current - next;
                            } else break;
                        }
                        j = offset - 1;
                        current = gamma * x[j - 1];
                        for(n = len + 2; n--; j += 2){
                            next = gamma * x[j + 1];
                            x[j] -= current + next;
                            if (n--) {
                                j += 2;
                                current = gamma * x[j + 1];
                                x[j] -= current + next;
                            } else break;
                        }
                        j = offset;
                        current = beta * x[j - 1];
                        for(n = len + 1; n--; j += 2){
                            next = beta * x[j + 1];
                            x[j] -= current + next;
                            if (n--) {
                                j += 2;
                                current = beta * x[j + 1];
                                x[j] -= current + next;
                            } else break;
                        }
                        if (len !== 0) {
                            j = offset + 1;
                            current = alpha * x[j - 1];
                            for(n = len; n--; j += 2){
                                next = alpha * x[j + 1];
                                x[j] -= current + next;
                                if (n--) {
                                    j += 2;
                                    current = alpha * x[j + 1];
                                    x[j] -= current + next;
                                } else break;
                            }
                        }
                    }
                }
                class ReversibleTransform extends Transform {
                    filter(x, offset, length) {
                        const len = length >> 1;
                        offset |= 0;
                        let j, n;
                        for(j = offset, n = len + 1; n--; j += 2)x[j] -= x[j - 1] + x[j + 1] + 2 >> 2;
                        for(j = offset + 1, n = len; n--; j += 2)x[j] += x[j - 1] + x[j + 1] >> 1;
                    }
                }
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LZWStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                class LZWStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, earlyChange){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.cachedData = 0;
                        this.bitsCached = 0;
                        const maxLzwDictionarySize = 4096;
                        const lzwState = {
                            earlyChange: earlyChange,
                            codeLength: 9,
                            nextCode: 258,
                            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
                            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
                            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
                            currentSequence: new Uint8Array(maxLzwDictionarySize),
                            currentSequenceLength: 0
                        };
                        for(let i = 0; i < 256; ++i){
                            lzwState.dictionaryValues[i] = i;
                            lzwState.dictionaryLengths[i] = 1;
                        }
                        this.lzwState = lzwState;
                    }
                    readBits(n) {
                        let bitsCached = this.bitsCached;
                        let cachedData = this.cachedData;
                        while(bitsCached < n){
                            const c = this.str.getByte();
                            if (c === -1) {
                                this.eof = true;
                                return null;
                            }
                            cachedData = cachedData << 8 | c;
                            bitsCached += 8;
                        }
                        this.bitsCached = bitsCached -= n;
                        this.cachedData = cachedData;
                        this.lastCode = null;
                        return cachedData >>> bitsCached & (1 << n) - 1;
                    }
                    readBlock() {
                        const blockSize = 512, decodedSizeDelta = blockSize;
                        let estimatedDecodedSize = blockSize * 2;
                        let i, j, q;
                        const lzwState = this.lzwState;
                        if (!lzwState) return;
                        const earlyChange = lzwState.earlyChange;
                        let nextCode = lzwState.nextCode;
                        const dictionaryValues = lzwState.dictionaryValues;
                        const dictionaryLengths = lzwState.dictionaryLengths;
                        const dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
                        let codeLength = lzwState.codeLength;
                        let prevCode = lzwState.prevCode;
                        const currentSequence = lzwState.currentSequence;
                        let currentSequenceLength = lzwState.currentSequenceLength;
                        let decodedLength = 0;
                        let currentBufferLength = this.bufferLength;
                        let buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
                        for(i = 0; i < blockSize; i++){
                            const code = this.readBits(codeLength);
                            const hasPrev = currentSequenceLength > 0;
                            if (code < 256) {
                                currentSequence[0] = code;
                                currentSequenceLength = 1;
                            } else if (code >= 258) {
                                if (code < nextCode) {
                                    currentSequenceLength = dictionaryLengths[code];
                                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                                        currentSequence[j] = dictionaryValues[q];
                                        q = dictionaryPrevCodes[q];
                                    }
                                } else currentSequence[currentSequenceLength++] = currentSequence[0];
                            } else if (code === 256) {
                                codeLength = 9;
                                nextCode = 258;
                                currentSequenceLength = 0;
                                continue;
                            } else {
                                this.eof = true;
                                delete this.lzwState;
                                break;
                            }
                            if (hasPrev) {
                                dictionaryPrevCodes[nextCode] = prevCode;
                                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                                dictionaryValues[nextCode] = currentSequence[0];
                                nextCode++;
                                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
                            }
                            prevCode = code;
                            decodedLength += currentSequenceLength;
                            if (estimatedDecodedSize < decodedLength) {
                                do estimatedDecodedSize += decodedSizeDelta;
                                while (estimatedDecodedSize < decodedLength);
                                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
                            }
                            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
                        }
                        lzwState.nextCode = nextCode;
                        lzwState.codeLength = codeLength;
                        lzwState.prevCode = prevCode;
                        lzwState.currentSequenceLength = currentSequenceLength;
                        this.bufferLength = currentBufferLength;
                    }
                }
                exports.LZWStream = LZWStream;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PredictorStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                var _primitives = __w_pdfjs_require__(4);
                var _util = __w_pdfjs_require__(2);
                class PredictorStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, params){
                        super(maybeLength);
                        if (!(params instanceof _primitives.Dict)) return str;
                        const predictor = this.predictor = params.get("Predictor") || 1;
                        if (predictor <= 1) return str;
                        if (predictor !== 2 && (predictor < 10 || predictor > 15)) throw new _util.FormatError(`Unsupported predictor: ${predictor}`);
                        this.readBlock = predictor === 2 ? this.readBlockTiff : this.readBlockPng;
                        this.str = str;
                        this.dict = str.dict;
                        const colors = this.colors = params.get("Colors") || 1;
                        const bits = this.bits = params.get("BPC", "BitsPerComponent") || 8;
                        const columns = this.columns = params.get("Columns") || 1;
                        this.pixBytes = colors * bits + 7 >> 3;
                        this.rowBytes = columns * colors * bits + 7 >> 3;
                        return this;
                    }
                    readBlockTiff() {
                        const rowBytes = this.rowBytes;
                        const bufferLength = this.bufferLength;
                        const buffer = this.ensureBuffer(bufferLength + rowBytes);
                        const bits = this.bits;
                        const colors = this.colors;
                        const rawBytes = this.str.getBytes(rowBytes);
                        this.eof = !rawBytes.length;
                        if (this.eof) return;
                        let inbuf = 0, outbuf = 0;
                        let inbits = 0, outbits = 0;
                        let pos = bufferLength;
                        let i;
                        if (bits === 1 && colors === 1) for(i = 0; i < rowBytes; ++i){
                            let c = rawBytes[i] ^ inbuf;
                            c ^= c >> 1;
                            c ^= c >> 2;
                            c ^= c >> 4;
                            inbuf = (c & 1) << 7;
                            buffer[pos++] = c;
                        }
                        else if (bits === 8) {
                            for(i = 0; i < colors; ++i)buffer[pos++] = rawBytes[i];
                            for(; i < rowBytes; ++i){
                                buffer[pos] = buffer[pos - colors] + rawBytes[i];
                                pos++;
                            }
                        } else if (bits === 16) {
                            const bytesPerPixel = colors * 2;
                            for(i = 0; i < bytesPerPixel; ++i)buffer[pos++] = rawBytes[i];
                            for(; i < rowBytes; i += 2){
                                const sum = ((rawBytes[i] & 0xff) << 8) + (rawBytes[i + 1] & 0xff) + ((buffer[pos - bytesPerPixel] & 0xff) << 8) + (buffer[pos - bytesPerPixel + 1] & 0xff);
                                buffer[pos++] = sum >> 8 & 0xff;
                                buffer[pos++] = sum & 0xff;
                            }
                        } else {
                            const compArray = new Uint8Array(colors + 1);
                            const bitMask = (1 << bits) - 1;
                            let j = 0, k = bufferLength;
                            const columns = this.columns;
                            for(i = 0; i < columns; ++i)for(let kk = 0; kk < colors; ++kk){
                                if (inbits < bits) {
                                    inbuf = inbuf << 8 | rawBytes[j++] & 0xff;
                                    inbits += 8;
                                }
                                compArray[kk] = compArray[kk] + (inbuf >> inbits - bits) & bitMask;
                                inbits -= bits;
                                outbuf = outbuf << bits | compArray[kk];
                                outbits += bits;
                                if (outbits >= 8) {
                                    buffer[k++] = outbuf >> outbits - 8 & 0xff;
                                    outbits -= 8;
                                }
                            }
                            if (outbits > 0) buffer[k++] = (outbuf << 8 - outbits) + (inbuf & (1 << 8 - outbits) - 1);
                        }
                        this.bufferLength += rowBytes;
                    }
                    readBlockPng() {
                        const rowBytes = this.rowBytes;
                        const pixBytes = this.pixBytes;
                        const predictor = this.str.getByte();
                        const rawBytes = this.str.getBytes(rowBytes);
                        this.eof = !rawBytes.length;
                        if (this.eof) return;
                        const bufferLength = this.bufferLength;
                        const buffer = this.ensureBuffer(bufferLength + rowBytes);
                        let prevRow = buffer.subarray(bufferLength - rowBytes, bufferLength);
                        if (prevRow.length === 0) prevRow = new Uint8Array(rowBytes);
                        let i, j = bufferLength, up, c;
                        switch(predictor){
                            case 0:
                                for(i = 0; i < rowBytes; ++i)buffer[j++] = rawBytes[i];
                                break;
                            case 1:
                                for(i = 0; i < pixBytes; ++i)buffer[j++] = rawBytes[i];
                                for(; i < rowBytes; ++i){
                                    buffer[j] = buffer[j - pixBytes] + rawBytes[i] & 0xff;
                                    j++;
                                }
                                break;
                            case 2:
                                for(i = 0; i < rowBytes; ++i)buffer[j++] = prevRow[i] + rawBytes[i] & 0xff;
                                break;
                            case 3:
                                for(i = 0; i < pixBytes; ++i)buffer[j++] = (prevRow[i] >> 1) + rawBytes[i];
                                for(; i < rowBytes; ++i){
                                    buffer[j] = (prevRow[i] + buffer[j - pixBytes] >> 1) + rawBytes[i] & 0xff;
                                    j++;
                                }
                                break;
                            case 4:
                                for(i = 0; i < pixBytes; ++i){
                                    up = prevRow[i];
                                    c = rawBytes[i];
                                    buffer[j++] = up + c;
                                }
                                for(; i < rowBytes; ++i){
                                    up = prevRow[i];
                                    const upLeft = prevRow[i - pixBytes];
                                    const left = buffer[j - pixBytes];
                                    const p = left + up - upLeft;
                                    let pa = p - left;
                                    if (pa < 0) pa = -pa;
                                    let pb = p - up;
                                    if (pb < 0) pb = -pb;
                                    let pc = p - upLeft;
                                    if (pc < 0) pc = -pc;
                                    c = rawBytes[i];
                                    if (pa <= pb && pa <= pc) buffer[j++] = left + c;
                                    else if (pb <= pc) buffer[j++] = up + c;
                                    else buffer[j++] = upLeft + c;
                                }
                                break;
                            default:
                                throw new _util.FormatError(`Unsupported predictor: ${predictor}`);
                        }
                        this.bufferLength += rowBytes;
                    }
                }
                exports.PredictorStream = PredictorStream;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RunLengthStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                class RunLengthStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                    }
                    readBlock() {
                        const repeatHeader = this.str.getBytes(2);
                        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
                            this.eof = true;
                            return;
                        }
                        let buffer;
                        let bufferLength = this.bufferLength;
                        let n = repeatHeader[0];
                        if (n < 128) {
                            buffer = this.ensureBuffer(bufferLength + n + 1);
                            buffer[bufferLength++] = repeatHeader[1];
                            if (n > 0) {
                                const source = this.str.getBytes(n);
                                buffer.set(source, bufferLength);
                                bufferLength += n;
                            }
                        } else {
                            n = 257 - n;
                            const b = repeatHeader[1];
                            buffer = this.ensureBuffer(bufferLength + n + 1);
                            for(let i = 0; i < n; i++)buffer[bufferLength++] = b;
                        }
                        this.bufferLength = bufferLength;
                    }
                }
                exports.RunLengthStream = RunLengthStream;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Font = exports.ErrorFont = void 0;
                var _util = __w_pdfjs_require__(2);
                var _cff_parser = __w_pdfjs_require__(35);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _unicode = __w_pdfjs_require__(40);
                var _glyphlist = __w_pdfjs_require__(39);
                var _encodings = __w_pdfjs_require__(37);
                var _standard_fonts = __w_pdfjs_require__(41);
                var _to_unicode_map = __w_pdfjs_require__(42);
                var _cff_font = __w_pdfjs_require__(43);
                var _font_renderer = __w_pdfjs_require__(44);
                var _metrics = __w_pdfjs_require__(45);
                var _glyf = __w_pdfjs_require__(46);
                var _cmap = __w_pdfjs_require__(14);
                var _opentype_file_builder = __w_pdfjs_require__(47);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                var _type1_font = __w_pdfjs_require__(48);
                const PRIVATE_USE_AREAS = [
                    [
                        0xe000,
                        0xf8ff
                    ],
                    [
                        0x100000,
                        0x10fffd
                    ]
                ];
                const PDF_GLYPH_SPACE_UNITS = 1000;
                const EXPORT_DATA_PROPERTIES = [
                    "ascent",
                    "bbox",
                    "black",
                    "bold",
                    "charProcOperatorList",
                    "composite",
                    "cssFontInfo",
                    "data",
                    "defaultVMetrics",
                    "defaultWidth",
                    "descent",
                    "fallbackName",
                    "fontMatrix",
                    "isInvalidPDFjsFont",
                    "isType3Font",
                    "italic",
                    "loadedName",
                    "mimetype",
                    "missingFile",
                    "name",
                    "remeasure",
                    "subtype",
                    "systemFontInfo",
                    "type",
                    "vertical"
                ];
                const EXPORT_DATA_EXTRA_PROPERTIES = [
                    "cMap",
                    "defaultEncoding",
                    "differences",
                    "isMonospace",
                    "isSerifFont",
                    "isSymbolicFont",
                    "seacMap",
                    "toFontChar",
                    "toUnicode",
                    "vmetrics",
                    "widths"
                ];
                function adjustWidths(properties) {
                    if (!properties.fontMatrix) return;
                    if (properties.fontMatrix[0] === _util.FONT_IDENTITY_MATRIX[0]) return;
                    const scale = 0.001 / properties.fontMatrix[0];
                    const glyphsWidths = properties.widths;
                    for(const glyph in glyphsWidths)glyphsWidths[glyph] *= scale;
                    properties.defaultWidth *= scale;
                }
                function adjustTrueTypeToUnicode(properties, isSymbolicFont, nameRecords) {
                    if (properties.isInternalFont) return;
                    if (properties.hasIncludedToUnicodeMap) return;
                    if (properties.hasEncoding) return;
                    if (properties.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) return;
                    if (!isSymbolicFont) return;
                    if (nameRecords.length === 0) return;
                    if (properties.defaultEncoding === _encodings.WinAnsiEncoding) return;
                    for (const r of nameRecords){
                        if (!isWinNameRecord(r)) return;
                    }
                    const encoding = _encodings.WinAnsiEncoding;
                    const toUnicode = [], glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                    for(const charCode in encoding){
                        const glyphName = encoding[charCode];
                        if (glyphName === "") continue;
                        const unicode = glyphsUnicodeMap[glyphName];
                        if (unicode === undefined) continue;
                        toUnicode[charCode] = String.fromCharCode(unicode);
                    }
                    if (toUnicode.length > 0) properties.toUnicode.amend(toUnicode);
                }
                function adjustType1ToUnicode(properties, builtInEncoding) {
                    if (properties.isInternalFont) return;
                    if (properties.hasIncludedToUnicodeMap) return;
                    if (builtInEncoding === properties.defaultEncoding) return;
                    if (properties.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) return;
                    const toUnicode = [], glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                    for(const charCode in builtInEncoding){
                        if (properties.hasEncoding) {
                            if (properties.baseEncodingName || properties.differences[charCode] !== undefined) continue;
                        }
                        const glyphName = builtInEncoding[charCode];
                        const unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                        if (unicode !== -1) toUnicode[charCode] = String.fromCharCode(unicode);
                    }
                    if (toUnicode.length > 0) properties.toUnicode.amend(toUnicode);
                }
                function amendFallbackToUnicode(properties) {
                    if (!properties.fallbackToUnicode) return;
                    if (properties.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) return;
                    const toUnicode = [];
                    for(const charCode in properties.fallbackToUnicode){
                        if (properties.toUnicode.has(charCode)) continue;
                        toUnicode[charCode] = properties.fallbackToUnicode[charCode];
                    }
                    if (toUnicode.length > 0) properties.toUnicode.amend(toUnicode);
                }
                class Glyph {
                    constructor(originalCharCode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont){
                        this.originalCharCode = originalCharCode;
                        this.fontChar = fontChar;
                        this.unicode = unicode;
                        this.accent = accent;
                        this.width = width;
                        this.vmetric = vmetric;
                        this.operatorListId = operatorListId;
                        this.isSpace = isSpace;
                        this.isInFont = isInFont;
                    }
                    get category() {
                        return (0, _util.shadow)(this, "category", (0, _unicode.getCharUnicodeCategory)(this.unicode), true);
                    }
                }
                function int16(b0, b1) {
                    return (b0 << 8) + b1;
                }
                function writeSignedInt16(bytes, index, value) {
                    bytes[index + 1] = value;
                    bytes[index] = value >>> 8;
                }
                function signedInt16(b0, b1) {
                    const value = (b0 << 8) + b1;
                    return value & 32768 ? value - 0x10000 : value;
                }
                function int32(b0, b1, b2, b3) {
                    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
                }
                function string16(value) {
                    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
                }
                function safeString16(value) {
                    if (value > 0x7fff) value = 0x7fff;
                    else if (value < -32768) value = -32768;
                    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
                }
                function isTrueTypeFile(file) {
                    const header = file.peekBytes(4);
                    return (0, _core_utils.readUint32)(header, 0) === 0x00010000 || (0, _util.bytesToString)(header) === "true";
                }
                function isTrueTypeCollectionFile(file) {
                    const header = file.peekBytes(4);
                    return (0, _util.bytesToString)(header) === "ttcf";
                }
                function isOpenTypeFile(file) {
                    const header = file.peekBytes(4);
                    return (0, _util.bytesToString)(header) === "OTTO";
                }
                function isType1File(file) {
                    const header = file.peekBytes(2);
                    if (header[0] === 0x25 && header[1] === 0x21) return true;
                    if (header[0] === 0x80 && header[1] === 0x01) return true;
                    return false;
                }
                function isCFFFile(file) {
                    const header = file.peekBytes(4);
                    if (header[0] >= 1 && header[3] >= 1 && header[3] <= 4) return true;
                    return false;
                }
                function getFontFileType(file, { type: type, subtype: subtype, composite: composite }) {
                    let fileType, fileSubtype;
                    if (isTrueTypeFile(file) || isTrueTypeCollectionFile(file)) fileType = composite ? "CIDFontType2" : "TrueType";
                    else if (isOpenTypeFile(file)) fileType = composite ? "CIDFontType2" : "OpenType";
                    else if (isType1File(file)) {
                        if (composite) fileType = "CIDFontType0";
                        else fileType = type === "MMType1" ? "MMType1" : "Type1";
                    } else if (isCFFFile(file)) {
                        if (composite) {
                            fileType = "CIDFontType0";
                            fileSubtype = "CIDFontType0C";
                        } else {
                            fileType = type === "MMType1" ? "MMType1" : "Type1";
                            fileSubtype = "Type1C";
                        }
                    } else {
                        (0, _util.warn)("getFontFileType: Unable to detect correct font file Type/Subtype.");
                        fileType = type;
                        fileSubtype = subtype;
                    }
                    return [
                        fileType,
                        fileSubtype
                    ];
                }
                function applyStandardFontGlyphMap(map, glyphMap) {
                    for(const charCode in glyphMap)map[+charCode] = glyphMap[charCode];
                }
                function buildToFontChar(encoding, glyphsUnicodeMap, differences) {
                    const toFontChar = [];
                    let unicode;
                    for(let i = 0, ii = encoding.length; i < ii; i++){
                        unicode = (0, _unicode.getUnicodeForGlyph)(encoding[i], glyphsUnicodeMap);
                        if (unicode !== -1) toFontChar[i] = unicode;
                    }
                    for(const charCode in differences){
                        unicode = (0, _unicode.getUnicodeForGlyph)(differences[charCode], glyphsUnicodeMap);
                        if (unicode !== -1) toFontChar[+charCode] = unicode;
                    }
                    return toFontChar;
                }
                function isMacNameRecord(r) {
                    return r.platform === 1 && r.encoding === 0 && r.language === 0;
                }
                function isWinNameRecord(r) {
                    return r.platform === 3 && r.encoding === 1 && r.language === 0x409;
                }
                function convertCidString(charCode, cid, shouldThrow = false) {
                    switch(cid.length){
                        case 1:
                            return cid.charCodeAt(0);
                        case 2:
                            return cid.charCodeAt(0) << 8 | cid.charCodeAt(1);
                    }
                    const msg = `Unsupported CID string (charCode ${charCode}): "${cid}".`;
                    if (shouldThrow) throw new _util.FormatError(msg);
                    (0, _util.warn)(msg);
                    return cid;
                }
                function adjustMapping(charCodeToGlyphId, hasGlyph, newGlyphZeroId, toUnicode) {
                    const newMap = Object.create(null);
                    const toUnicodeExtraMap = new Map();
                    const toFontChar = [];
                    const usedGlyphIds = new Set();
                    let privateUseAreaIndex = 0;
                    const privateUseOffetStart = PRIVATE_USE_AREAS[privateUseAreaIndex][0];
                    let nextAvailableFontCharCode = privateUseOffetStart;
                    let privateUseOffetEnd = PRIVATE_USE_AREAS[privateUseAreaIndex][1];
                    const isInPrivateArea = (code)=>PRIVATE_USE_AREAS[0][0] <= code && code <= PRIVATE_USE_AREAS[0][1] || PRIVATE_USE_AREAS[1][0] <= code && code <= PRIVATE_USE_AREAS[1][1];
                    for(let originalCharCode in charCodeToGlyphId){
                        originalCharCode |= 0;
                        let glyphId = charCodeToGlyphId[originalCharCode];
                        if (!hasGlyph(glyphId)) continue;
                        if (nextAvailableFontCharCode > privateUseOffetEnd) {
                            privateUseAreaIndex++;
                            if (privateUseAreaIndex >= PRIVATE_USE_AREAS.length) {
                                (0, _util.warn)("Ran out of space in font private use area.");
                                break;
                            }
                            nextAvailableFontCharCode = PRIVATE_USE_AREAS[privateUseAreaIndex][0];
                            privateUseOffetEnd = PRIVATE_USE_AREAS[privateUseAreaIndex][1];
                        }
                        const fontCharCode = nextAvailableFontCharCode++;
                        if (glyphId === 0) glyphId = newGlyphZeroId;
                        let unicode = toUnicode.get(originalCharCode);
                        if (typeof unicode === "string") unicode = unicode.codePointAt(0);
                        if (unicode && !isInPrivateArea(unicode) && !usedGlyphIds.has(glyphId)) {
                            toUnicodeExtraMap.set(unicode, glyphId);
                            usedGlyphIds.add(glyphId);
                        }
                        newMap[fontCharCode] = glyphId;
                        toFontChar[originalCharCode] = fontCharCode;
                    }
                    return {
                        toFontChar: toFontChar,
                        charCodeToGlyphId: newMap,
                        toUnicodeExtraMap: toUnicodeExtraMap,
                        nextAvailableFontCharCode: nextAvailableFontCharCode
                    };
                }
                function getRanges(glyphs, toUnicodeExtraMap, numGlyphs) {
                    const codes = [];
                    for(const charCode in glyphs){
                        if (glyphs[charCode] >= numGlyphs) continue;
                        codes.push({
                            fontCharCode: charCode | 0,
                            glyphId: glyphs[charCode]
                        });
                    }
                    if (toUnicodeExtraMap) for (const [unicode, glyphId] of toUnicodeExtraMap){
                        if (glyphId >= numGlyphs) continue;
                        codes.push({
                            fontCharCode: unicode,
                            glyphId: glyphId
                        });
                    }
                    if (codes.length === 0) codes.push({
                        fontCharCode: 0,
                        glyphId: 0
                    });
                    codes.sort(function fontGetRangesSort(a, b) {
                        return a.fontCharCode - b.fontCharCode;
                    });
                    const ranges = [];
                    const length = codes.length;
                    for(let n = 0; n < length;){
                        const start = codes[n].fontCharCode;
                        const codeIndices = [
                            codes[n].glyphId
                        ];
                        ++n;
                        let end = start;
                        while(n < length && end + 1 === codes[n].fontCharCode){
                            codeIndices.push(codes[n].glyphId);
                            ++end;
                            ++n;
                            if (end === 0xffff) break;
                        }
                        ranges.push([
                            start,
                            end,
                            codeIndices
                        ]);
                    }
                    return ranges;
                }
                function createCmapTable(glyphs, toUnicodeExtraMap, numGlyphs) {
                    const ranges = getRanges(glyphs, toUnicodeExtraMap, numGlyphs);
                    const numTables = ranges.at(-1)[1] > 0xffff ? 2 : 1;
                    let cmap = "\0\0" + string16(numTables) + "\0\x03" + "\0\x01" + (0, _util.string32)(4 + numTables * 8);
                    let i, ii, j, jj;
                    for(i = ranges.length - 1; i >= 0; --i){
                        if (ranges[i][0] <= 0xffff) break;
                    }
                    const bmpLength = i + 1;
                    if (ranges[i][0] < 0xffff && ranges[i][1] === 0xffff) ranges[i][1] = 0xfffe;
                    const trailingRangesCount = ranges[i][1] < 0xffff ? 1 : 0;
                    const segCount = bmpLength + trailingRangesCount;
                    const searchParams = _opentype_file_builder.OpenTypeFileBuilder.getSearchParams(segCount, 2);
                    let startCount = "";
                    let endCount = "";
                    let idDeltas = "";
                    let idRangeOffsets = "";
                    let glyphsIds = "";
                    let bias = 0;
                    let range, start, end, codes;
                    for(i = 0, ii = bmpLength; i < ii; i++){
                        range = ranges[i];
                        start = range[0];
                        end = range[1];
                        startCount += string16(start);
                        endCount += string16(end);
                        codes = range[2];
                        let contiguous = true;
                        for(j = 1, jj = codes.length; j < jj; ++j)if (codes[j] !== codes[j - 1] + 1) {
                            contiguous = false;
                            break;
                        }
                        if (!contiguous) {
                            const offset = (segCount - i) * 2 + bias * 2;
                            bias += end - start + 1;
                            idDeltas += string16(0);
                            idRangeOffsets += string16(offset);
                            for(j = 0, jj = codes.length; j < jj; ++j)glyphsIds += string16(codes[j]);
                        } else {
                            const startCode = codes[0];
                            idDeltas += string16(startCode - start & 0xffff);
                            idRangeOffsets += string16(0);
                        }
                    }
                    if (trailingRangesCount > 0) {
                        endCount += "\xff\xff";
                        startCount += "\xff\xff";
                        idDeltas += "\0\x01";
                        idRangeOffsets += "\0\0";
                    }
                    const format314 = "\0\0" + string16(2 * segCount) + string16(searchParams.range) + string16(searchParams.entry) + string16(searchParams.rangeShift) + endCount + "\0\0" + startCount + idDeltas + idRangeOffsets + glyphsIds;
                    let format31012 = "";
                    let header31012 = "";
                    if (numTables > 1) {
                        cmap += "\0\x03\0\n" + (0, _util.string32)(4 + numTables * 8 + 4 + format314.length);
                        format31012 = "";
                        for(i = 0, ii = ranges.length; i < ii; i++){
                            range = ranges[i];
                            start = range[0];
                            codes = range[2];
                            let code = codes[0];
                            for(j = 1, jj = codes.length; j < jj; ++j)if (codes[j] !== codes[j - 1] + 1) {
                                end = range[0] + j - 1;
                                format31012 += (0, _util.string32)(start) + (0, _util.string32)(end) + (0, _util.string32)(code);
                                start = end + 1;
                                code = codes[j];
                            }
                            format31012 += (0, _util.string32)(start) + (0, _util.string32)(range[1]) + (0, _util.string32)(code);
                        }
                        header31012 = "\0\f\0\0" + (0, _util.string32)(format31012.length + 16) + "\0\0\0\0" + (0, _util.string32)(format31012.length / 12);
                    }
                    return cmap + "\0\x04" + string16(format314.length + 4) + format314 + header31012 + format31012;
                }
                function validateOS2Table(os2, file) {
                    file.pos = (file.start || 0) + os2.offset;
                    const version = file.getUint16();
                    file.skip(60);
                    const selection = file.getUint16();
                    if (version < 4 && selection & 0x0300) return false;
                    const firstChar = file.getUint16();
                    const lastChar = file.getUint16();
                    if (firstChar > lastChar) return false;
                    file.skip(6);
                    const usWinAscent = file.getUint16();
                    if (usWinAscent === 0) return false;
                    os2.data[8] = os2.data[9] = 0;
                    return true;
                }
                function createOS2Table(properties, charstrings, override) {
                    override ||= {
                        unitsPerEm: 0,
                        yMax: 0,
                        yMin: 0,
                        ascent: 0,
                        descent: 0
                    };
                    let ulUnicodeRange1 = 0;
                    let ulUnicodeRange2 = 0;
                    let ulUnicodeRange3 = 0;
                    let ulUnicodeRange4 = 0;
                    let firstCharIndex = null;
                    let lastCharIndex = 0;
                    let position = -1;
                    if (charstrings) {
                        for(let code in charstrings){
                            code |= 0;
                            if (firstCharIndex > code || !firstCharIndex) firstCharIndex = code;
                            if (lastCharIndex < code) lastCharIndex = code;
                            position = (0, _unicode.getUnicodeRangeFor)(code, position);
                            if (position < 32) ulUnicodeRange1 |= 1 << position;
                            else if (position < 64) ulUnicodeRange2 |= 1 << position - 32;
                            else if (position < 96) ulUnicodeRange3 |= 1 << position - 64;
                            else if (position < 123) ulUnicodeRange4 |= 1 << position - 96;
                            else throw new _util.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
                        }
                        if (lastCharIndex > 0xffff) lastCharIndex = 0xffff;
                    } else {
                        firstCharIndex = 0;
                        lastCharIndex = 255;
                    }
                    const bbox = properties.bbox || [
                        0,
                        0,
                        0,
                        0
                    ];
                    const unitsPerEm = override.unitsPerEm || 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
                    const scale = properties.ascentScaled ? 1.0 : unitsPerEm / PDF_GLYPH_SPACE_UNITS;
                    const typoAscent = override.ascent || Math.round(scale * (properties.ascent || bbox[3]));
                    let typoDescent = override.descent || Math.round(scale * (properties.descent || bbox[1]));
                    if (typoDescent > 0 && properties.descent > 0 && bbox[1] < 0) typoDescent = -typoDescent;
                    const winAscent = override.yMax || typoAscent;
                    const winDescent = -override.yMin || -typoDescent;
                    return "\0\x03\x02$\x01\xf4\0\x05\0\0\x02\x8a\x02\xbb\0\0\0\x8c\x02\x8a\x02\xbb\0\0\x01\xdf\x001\x01\x02\0\0\0\0\x06" + String.fromCharCode(properties.fixedPitch ? 0x09 : 0x00) + "\0\0\0\0\0\0" + (0, _util.string32)(ulUnicodeRange1) + (0, _util.string32)(ulUnicodeRange2) + (0, _util.string32)(ulUnicodeRange3) + (0, _util.string32)(ulUnicodeRange4) + "*21*" + string16(properties.italicAngle ? 1 : 0) + string16(firstCharIndex || properties.firstChar) + string16(lastCharIndex || properties.lastChar) + string16(typoAscent) + string16(typoDescent) + "\0d" + string16(winAscent) + string16(winDescent) + "\0\0\0\0" + "\0\0\0\0" + string16(properties.xHeight) + string16(properties.capHeight) + string16(0) + string16(firstCharIndex || properties.firstChar) + "\0\x03";
                }
                function createPostTable(properties) {
                    const angle = Math.floor(properties.italicAngle * 2 ** 16);
                    return "\0\x03\0\0" + (0, _util.string32)(angle) + "\0\0" + "\0\0" + (0, _util.string32)(properties.fixedPitch ? 1 : 0) + "\0\0\0\0" + "\0\0\0\0" + "\0\0\0\0" + "\0\0\0\0";
                }
                function createPostscriptName(name) {
                    return name.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
                }
                function createNameTable(name, proto) {
                    if (!proto) proto = [
                        [],
                        []
                    ];
                    const strings = [
                        proto[0][0] || "Original licence",
                        proto[0][1] || name,
                        proto[0][2] || "Unknown",
                        proto[0][3] || "uniqueID",
                        proto[0][4] || name,
                        proto[0][5] || "Version 0.11",
                        proto[0][6] || createPostscriptName(name),
                        proto[0][7] || "Unknown",
                        proto[0][8] || "Unknown",
                        proto[0][9] || "Unknown"
                    ];
                    const stringsUnicode = [];
                    let i, ii, j, jj, str;
                    for(i = 0, ii = strings.length; i < ii; i++){
                        str = proto[1][i] || strings[i];
                        const strBufUnicode = [];
                        for(j = 0, jj = str.length; j < jj; j++)strBufUnicode.push(string16(str.charCodeAt(j)));
                        stringsUnicode.push(strBufUnicode.join(""));
                    }
                    const names = [
                        strings,
                        stringsUnicode
                    ];
                    const platforms = [
                        "\0\x01",
                        "\0\x03"
                    ];
                    const encodings = [
                        "\0\0",
                        "\0\x01"
                    ];
                    const languages = [
                        "\0\0",
                        "\x04	"
                    ];
                    const namesRecordCount = strings.length * platforms.length;
                    let nameTable = "\0\0" + string16(namesRecordCount) + string16(namesRecordCount * 12 + 6);
                    let strOffset = 0;
                    for(i = 0, ii = platforms.length; i < ii; i++){
                        const strs = names[i];
                        for(j = 0, jj = strs.length; j < jj; j++){
                            str = strs[j];
                            const nameRecord = platforms[i] + encodings[i] + languages[i] + string16(j) + string16(str.length) + string16(strOffset);
                            nameTable += nameRecord;
                            strOffset += str.length;
                        }
                    }
                    nameTable += strings.join("") + stringsUnicode.join("");
                    return nameTable;
                }
                class Font {
                    constructor(name, file, properties){
                        this.name = name;
                        this.psName = null;
                        this.mimetype = null;
                        this.disableFontFace = false;
                        this.loadedName = properties.loadedName;
                        this.isType3Font = properties.isType3Font;
                        this.missingFile = false;
                        this.cssFontInfo = properties.cssFontInfo;
                        this._charsCache = Object.create(null);
                        this._glyphCache = Object.create(null);
                        let isSerifFont = !!(properties.flags & _fonts_utils.FontFlags.Serif);
                        if (!isSerifFont && !properties.isSimulatedFlags) {
                            const baseName = name.replaceAll(/[,_]/g, "-").split("-")[0], serifFonts = (0, _standard_fonts.getSerifFonts)();
                            for (const namePart of baseName.split("+"))if (serifFonts[namePart]) {
                                isSerifFont = true;
                                break;
                            }
                        }
                        this.isSerifFont = isSerifFont;
                        this.isSymbolicFont = !!(properties.flags & _fonts_utils.FontFlags.Symbolic);
                        this.isMonospace = !!(properties.flags & _fonts_utils.FontFlags.FixedPitch);
                        let { type: type, subtype: subtype } = properties;
                        this.type = type;
                        this.subtype = subtype;
                        this.systemFontInfo = properties.systemFontInfo;
                        const matches = name.match(/^InvalidPDFjsFont_(.*)_\d+$/);
                        this.isInvalidPDFjsFont = !!matches;
                        if (this.isInvalidPDFjsFont) this.fallbackName = matches[1];
                        else if (this.isMonospace) this.fallbackName = "monospace";
                        else if (this.isSerifFont) this.fallbackName = "serif";
                        else this.fallbackName = "sans-serif";
                        if (this.systemFontInfo?.guessFallback) {
                            this.systemFontInfo.guessFallback = false;
                            this.systemFontInfo.css += `,${this.fallbackName}`;
                        }
                        this.differences = properties.differences;
                        this.widths = properties.widths;
                        this.defaultWidth = properties.defaultWidth;
                        this.composite = properties.composite;
                        this.cMap = properties.cMap;
                        this.capHeight = properties.capHeight / PDF_GLYPH_SPACE_UNITS;
                        this.ascent = properties.ascent / PDF_GLYPH_SPACE_UNITS;
                        this.descent = properties.descent / PDF_GLYPH_SPACE_UNITS;
                        this.lineHeight = this.ascent - this.descent;
                        this.fontMatrix = properties.fontMatrix;
                        this.bbox = properties.bbox;
                        this.defaultEncoding = properties.defaultEncoding;
                        this.toUnicode = properties.toUnicode;
                        this.toFontChar = [];
                        if (properties.type === "Type3") {
                            for(let charCode = 0; charCode < 256; charCode++)this.toFontChar[charCode] = this.differences[charCode] || properties.defaultEncoding[charCode];
                            return;
                        }
                        this.cidEncoding = properties.cidEncoding || "";
                        this.vertical = !!properties.vertical;
                        if (this.vertical) {
                            this.vmetrics = properties.vmetrics;
                            this.defaultVMetrics = properties.defaultVMetrics;
                        }
                        if (!file || file.isEmpty) {
                            if (file) (0, _util.warn)('Font file is empty in "' + name + '" (' + this.loadedName + ")");
                            this.fallbackToSystemFont(properties);
                            return;
                        }
                        [type, subtype] = getFontFileType(file, properties);
                        if (type !== this.type || subtype !== this.subtype) (0, _util.info)("Inconsistent font file Type/SubType, expected: " + `${this.type}/${this.subtype} but found: ${type}/${subtype}.`);
                        let data;
                        try {
                            switch(type){
                                case "MMType1":
                                    (0, _util.info)("MMType1 font (" + name + "), falling back to Type1.");
                                case "Type1":
                                case "CIDFontType0":
                                    this.mimetype = "font/opentype";
                                    const cff = subtype === "Type1C" || subtype === "CIDFontType0C" ? new _cff_font.CFFFont(file, properties) : new _type1_font.Type1Font(name, file, properties);
                                    adjustWidths(properties);
                                    data = this.convert(name, cff, properties);
                                    break;
                                case "OpenType":
                                case "TrueType":
                                case "CIDFontType2":
                                    this.mimetype = "font/opentype";
                                    data = this.checkAndRepair(name, file, properties);
                                    if (this.isOpenType) {
                                        adjustWidths(properties);
                                        type = "OpenType";
                                    }
                                    break;
                                default:
                                    throw new _util.FormatError(`Font ${type} is not supported`);
                            }
                        } catch (e) {
                            (0, _util.warn)(e);
                            this.fallbackToSystemFont(properties);
                            return;
                        }
                        amendFallbackToUnicode(properties);
                        this.data = data;
                        this.type = type;
                        this.subtype = subtype;
                        this.fontMatrix = properties.fontMatrix;
                        this.widths = properties.widths;
                        this.defaultWidth = properties.defaultWidth;
                        this.toUnicode = properties.toUnicode;
                        this.seacMap = properties.seacMap;
                    }
                    get renderer() {
                        const renderer = _font_renderer.FontRendererFactory.create(this, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        return (0, _util.shadow)(this, "renderer", renderer);
                    }
                    exportData(extraProperties = false) {
                        const exportDataProperties = extraProperties ? [
                            ...EXPORT_DATA_PROPERTIES,
                            ...EXPORT_DATA_EXTRA_PROPERTIES
                        ] : EXPORT_DATA_PROPERTIES;
                        const data = Object.create(null);
                        let property, value;
                        for (property of exportDataProperties){
                            value = this[property];
                            if (value !== undefined) data[property] = value;
                        }
                        return data;
                    }
                    fallbackToSystemFont(properties) {
                        this.missingFile = true;
                        const { name: name, type: type } = this;
                        let fontName = (0, _fonts_utils.normalizeFontName)(name);
                        const stdFontMap = (0, _standard_fonts.getStdFontMap)(), nonStdFontMap = (0, _standard_fonts.getNonStdFontMap)();
                        const isStandardFont = !!stdFontMap[fontName];
                        const isMappedToStandardFont = !!(nonStdFontMap[fontName] && stdFontMap[nonStdFontMap[fontName]]);
                        fontName = stdFontMap[fontName] || nonStdFontMap[fontName] || fontName;
                        const fontBasicMetricsMap = (0, _metrics.getFontBasicMetrics)();
                        const metrics = fontBasicMetricsMap[fontName];
                        if (metrics) {
                            if (isNaN(this.ascent)) this.ascent = metrics.ascent / PDF_GLYPH_SPACE_UNITS;
                            if (isNaN(this.descent)) this.descent = metrics.descent / PDF_GLYPH_SPACE_UNITS;
                            if (isNaN(this.capHeight)) this.capHeight = metrics.capHeight / PDF_GLYPH_SPACE_UNITS;
                        }
                        this.bold = /bold/gi.test(fontName);
                        this.italic = /oblique|italic/gi.test(fontName);
                        this.black = /Black/g.test(name);
                        const isNarrow = /Narrow/g.test(name);
                        this.remeasure = (!isStandardFont || isNarrow) && Object.keys(this.widths).length > 0;
                        if ((isStandardFont || isMappedToStandardFont) && type === "CIDFontType2" && this.cidEncoding.startsWith("Identity-")) {
                            const cidToGidMap = properties.cidToGidMap;
                            const map = [];
                            applyStandardFontGlyphMap(map, (0, _standard_fonts.getGlyphMapForStandardFonts)());
                            if (/Arial-?Black/i.test(name)) applyStandardFontGlyphMap(map, (0, _standard_fonts.getSupplementalGlyphMapForArialBlack)());
                            else if (/Calibri/i.test(name)) applyStandardFontGlyphMap(map, (0, _standard_fonts.getSupplementalGlyphMapForCalibri)());
                            if (cidToGidMap) {
                                for(const charCode in map){
                                    const cid = map[charCode];
                                    if (cidToGidMap[cid] !== undefined) map[+charCode] = cidToGidMap[cid];
                                }
                                if (cidToGidMap.length !== this.toUnicode.length && properties.hasIncludedToUnicodeMap && this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                                    const cid = map[charCode];
                                    if (cidToGidMap[cid] === undefined) map[+charCode] = unicodeCharCode;
                                });
                            }
                            if (!(this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap)) this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                                map[+charCode] = unicodeCharCode;
                            });
                            this.toFontChar = map;
                            this.toUnicode = new _to_unicode_map.ToUnicodeMap(map);
                        } else if (/Symbol/i.test(fontName)) this.toFontChar = buildToFontChar(_encodings.SymbolSetEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
                        else if (/Dingbats/i.test(fontName)) this.toFontChar = buildToFontChar(_encodings.ZapfDingbatsEncoding, (0, _glyphlist.getDingbatsGlyphsUnicode)(), this.differences);
                        else if (isStandardFont) {
                            const map = buildToFontChar(this.defaultEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
                            if (type === "CIDFontType2" && !this.cidEncoding.startsWith("Identity-") && !(this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap)) this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                                map[+charCode] = unicodeCharCode;
                            });
                            this.toFontChar = map;
                        } else {
                            const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                            const map = [];
                            this.toUnicode.forEach((charCode, unicodeCharCode)=>{
                                if (!this.composite) {
                                    const glyphName = this.differences[charCode] || this.defaultEncoding[charCode];
                                    const unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                                    if (unicode !== -1) unicodeCharCode = unicode;
                                }
                                map[+charCode] = unicodeCharCode;
                            });
                            if (this.composite && this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) {
                                if (/Tahoma|Verdana/i.test(name)) applyStandardFontGlyphMap(map, (0, _standard_fonts.getGlyphMapForStandardFonts)());
                            }
                            this.toFontChar = map;
                        }
                        amendFallbackToUnicode(properties);
                        this.loadedName = fontName.split("-")[0];
                    }
                    checkAndRepair(name, font1, properties) {
                        const VALID_TABLES = [
                            "OS/2",
                            "cmap",
                            "head",
                            "hhea",
                            "hmtx",
                            "maxp",
                            "name",
                            "post",
                            "loca",
                            "glyf",
                            "fpgm",
                            "prep",
                            "cvt ",
                            "CFF "
                        ];
                        function readTables(file, numTables) {
                            const tables = Object.create(null);
                            tables["OS/2"] = null;
                            tables.cmap = null;
                            tables.head = null;
                            tables.hhea = null;
                            tables.hmtx = null;
                            tables.maxp = null;
                            tables.name = null;
                            tables.post = null;
                            for(let i = 0; i < numTables; i++){
                                const table = readTableEntry(file);
                                if (!VALID_TABLES.includes(table.tag)) continue;
                                if (table.length === 0) continue;
                                tables[table.tag] = table;
                            }
                            return tables;
                        }
                        function readTableEntry(file) {
                            const tag = file.getString(4);
                            const checksum = file.getInt32() >>> 0;
                            const offset = file.getInt32() >>> 0;
                            const length = file.getInt32() >>> 0;
                            const previousPosition = file.pos;
                            file.pos = file.start || 0;
                            file.skip(offset);
                            const data = file.getBytes(length);
                            file.pos = previousPosition;
                            if (tag === "head") {
                                data[8] = data[9] = data[10] = data[11] = 0;
                                data[17] |= 0x20;
                            }
                            return {
                                tag: tag,
                                checksum: checksum,
                                length: length,
                                offset: offset,
                                data: data
                            };
                        }
                        function readOpenTypeHeader(ttf) {
                            return {
                                version: ttf.getString(4),
                                numTables: ttf.getUint16(),
                                searchRange: ttf.getUint16(),
                                entrySelector: ttf.getUint16(),
                                rangeShift: ttf.getUint16()
                            };
                        }
                        function readTrueTypeCollectionHeader(ttc) {
                            const ttcTag = ttc.getString(4);
                            (0, _util.assert)(ttcTag === "ttcf", "Must be a TrueType Collection font.");
                            const majorVersion = ttc.getUint16();
                            const minorVersion = ttc.getUint16();
                            const numFonts = ttc.getInt32() >>> 0;
                            const offsetTable = [];
                            for(let i = 0; i < numFonts; i++)offsetTable.push(ttc.getInt32() >>> 0);
                            const header = {
                                ttcTag: ttcTag,
                                majorVersion: majorVersion,
                                minorVersion: minorVersion,
                                numFonts: numFonts,
                                offsetTable: offsetTable
                            };
                            switch(majorVersion){
                                case 1:
                                    return header;
                                case 2:
                                    header.dsigTag = ttc.getInt32() >>> 0;
                                    header.dsigLength = ttc.getInt32() >>> 0;
                                    header.dsigOffset = ttc.getInt32() >>> 0;
                                    return header;
                            }
                            throw new _util.FormatError(`Invalid TrueType Collection majorVersion: ${majorVersion}.`);
                        }
                        function readTrueTypeCollectionData(ttc, fontName) {
                            const { numFonts: numFonts, offsetTable: offsetTable } = readTrueTypeCollectionHeader(ttc);
                            const fontNameParts = fontName.split("+");
                            let fallbackData;
                            for(let i = 0; i < numFonts; i++){
                                ttc.pos = (ttc.start || 0) + offsetTable[i];
                                const potentialHeader = readOpenTypeHeader(ttc);
                                const potentialTables = readTables(ttc, potentialHeader.numTables);
                                if (!potentialTables.name) throw new _util.FormatError('TrueType Collection font must contain a "name" table.');
                                const [nameTable] = readNameTable(potentialTables.name);
                                for(let j = 0, jj = nameTable.length; j < jj; j++)for(let k = 0, kk = nameTable[j].length; k < kk; k++){
                                    const nameEntry = nameTable[j][k]?.replaceAll(/\s/g, "");
                                    if (!nameEntry) continue;
                                    if (nameEntry === fontName) return {
                                        header: potentialHeader,
                                        tables: potentialTables
                                    };
                                    if (fontNameParts.length < 2) continue;
                                    for (const part of fontNameParts)if (nameEntry === part) fallbackData = {
                                        name: part,
                                        header: potentialHeader,
                                        tables: potentialTables
                                    };
                                }
                            }
                            if (fallbackData) {
                                (0, _util.warn)(`TrueType Collection does not contain "${fontName}" font, ` + `falling back to "${fallbackData.name}" font instead.`);
                                return {
                                    header: fallbackData.header,
                                    tables: fallbackData.tables
                                };
                            }
                            throw new _util.FormatError(`TrueType Collection does not contain "${fontName}" font.`);
                        }
                        function readCmapTable(cmap, file, isSymbolicFont, hasEncoding) {
                            if (!cmap) {
                                (0, _util.warn)("No cmap table available.");
                                return {
                                    platformId: -1,
                                    encodingId: -1,
                                    mappings: [],
                                    hasShortCmap: false
                                };
                            }
                            let segment;
                            let start = (file.start || 0) + cmap.offset;
                            file.pos = start;
                            file.skip(2);
                            const numTables = file.getUint16();
                            let potentialTable;
                            let canBreak = false;
                            for(let i = 0; i < numTables; i++){
                                const platformId = file.getUint16();
                                const encodingId = file.getUint16();
                                const offset = file.getInt32() >>> 0;
                                let useTable = false;
                                if (potentialTable?.platformId === platformId && potentialTable?.encodingId === encodingId) continue;
                                if (platformId === 0 && (encodingId === 0 || encodingId === 1 || encodingId === 3)) useTable = true;
                                else if (platformId === 1 && encodingId === 0) useTable = true;
                                else if (platformId === 3 && encodingId === 1 && (hasEncoding || !potentialTable)) {
                                    useTable = true;
                                    if (!isSymbolicFont) canBreak = true;
                                } else if (isSymbolicFont && platformId === 3 && encodingId === 0) {
                                    useTable = true;
                                    let correctlySorted = true;
                                    if (i < numTables - 1) {
                                        const nextBytes = file.peekBytes(2), nextPlatformId = int16(nextBytes[0], nextBytes[1]);
                                        if (nextPlatformId < platformId) correctlySorted = false;
                                    }
                                    if (correctlySorted) canBreak = true;
                                }
                                if (useTable) potentialTable = {
                                    platformId: platformId,
                                    encodingId: encodingId,
                                    offset: offset
                                };
                                if (canBreak) break;
                            }
                            if (potentialTable) file.pos = start + potentialTable.offset;
                            if (!potentialTable || file.peekByte() === -1) {
                                (0, _util.warn)("Could not find a preferred cmap table.");
                                return {
                                    platformId: -1,
                                    encodingId: -1,
                                    mappings: [],
                                    hasShortCmap: false
                                };
                            }
                            const format = file.getUint16();
                            let hasShortCmap = false;
                            const mappings = [];
                            let j, glyphId;
                            if (format === 0) {
                                file.skip(4);
                                for(j = 0; j < 256; j++){
                                    const index = file.getByte();
                                    if (!index) continue;
                                    mappings.push({
                                        charCode: j,
                                        glyphId: index
                                    });
                                }
                                hasShortCmap = true;
                            } else if (format === 2) {
                                file.skip(4);
                                const subHeaderKeys = [];
                                let maxSubHeaderKey = 0;
                                for(let i = 0; i < 256; i++){
                                    const subHeaderKey = file.getUint16() >> 3;
                                    subHeaderKeys.push(subHeaderKey);
                                    maxSubHeaderKey = Math.max(subHeaderKey, maxSubHeaderKey);
                                }
                                const subHeaders = [];
                                for(let i = 0; i <= maxSubHeaderKey; i++)subHeaders.push({
                                    firstCode: file.getUint16(),
                                    entryCount: file.getUint16(),
                                    idDelta: signedInt16(file.getByte(), file.getByte()),
                                    idRangePos: file.pos + file.getUint16()
                                });
                                for(let i = 0; i < 256; i++)if (subHeaderKeys[i] === 0) {
                                    file.pos = subHeaders[0].idRangePos + 2 * i;
                                    glyphId = file.getUint16();
                                    mappings.push({
                                        charCode: i,
                                        glyphId: glyphId
                                    });
                                } else {
                                    const s = subHeaders[subHeaderKeys[i]];
                                    for(j = 0; j < s.entryCount; j++){
                                        const charCode = (i << 8) + j + s.firstCode;
                                        file.pos = s.idRangePos + 2 * j;
                                        glyphId = file.getUint16();
                                        if (glyphId !== 0) glyphId = (glyphId + s.idDelta) % 65536;
                                        mappings.push({
                                            charCode: charCode,
                                            glyphId: glyphId
                                        });
                                    }
                                }
                            } else if (format === 4) {
                                file.skip(4);
                                const segCount = file.getUint16() >> 1;
                                file.skip(6);
                                const segments = [];
                                let segIndex;
                                for(segIndex = 0; segIndex < segCount; segIndex++)segments.push({
                                    end: file.getUint16()
                                });
                                file.skip(2);
                                for(segIndex = 0; segIndex < segCount; segIndex++)segments[segIndex].start = file.getUint16();
                                for(segIndex = 0; segIndex < segCount; segIndex++)segments[segIndex].delta = file.getUint16();
                                let offsetsCount = 0, offsetIndex;
                                for(segIndex = 0; segIndex < segCount; segIndex++){
                                    segment = segments[segIndex];
                                    const rangeOffset = file.getUint16();
                                    if (!rangeOffset) {
                                        segment.offsetIndex = -1;
                                        continue;
                                    }
                                    offsetIndex = (rangeOffset >> 1) - (segCount - segIndex);
                                    segment.offsetIndex = offsetIndex;
                                    offsetsCount = Math.max(offsetsCount, offsetIndex + segment.end - segment.start + 1);
                                }
                                const offsets = [];
                                for(j = 0; j < offsetsCount; j++)offsets.push(file.getUint16());
                                for(segIndex = 0; segIndex < segCount; segIndex++){
                                    segment = segments[segIndex];
                                    start = segment.start;
                                    const end = segment.end;
                                    const delta = segment.delta;
                                    offsetIndex = segment.offsetIndex;
                                    for(j = start; j <= end; j++){
                                        if (j === 0xffff) continue;
                                        glyphId = offsetIndex < 0 ? j : offsets[offsetIndex + j - start];
                                        glyphId = glyphId + delta & 0xffff;
                                        mappings.push({
                                            charCode: j,
                                            glyphId: glyphId
                                        });
                                    }
                                }
                            } else if (format === 6) {
                                file.skip(4);
                                const firstCode = file.getUint16();
                                const entryCount = file.getUint16();
                                for(j = 0; j < entryCount; j++){
                                    glyphId = file.getUint16();
                                    const charCode = firstCode + j;
                                    mappings.push({
                                        charCode: charCode,
                                        glyphId: glyphId
                                    });
                                }
                            } else if (format === 12) {
                                file.skip(10);
                                const nGroups = file.getInt32() >>> 0;
                                for(j = 0; j < nGroups; j++){
                                    const startCharCode = file.getInt32() >>> 0;
                                    const endCharCode = file.getInt32() >>> 0;
                                    let glyphCode = file.getInt32() >>> 0;
                                    for(let charCode = startCharCode; charCode <= endCharCode; charCode++)mappings.push({
                                        charCode: charCode,
                                        glyphId: glyphCode++
                                    });
                                }
                            } else {
                                (0, _util.warn)("cmap table has unsupported format: " + format);
                                return {
                                    platformId: -1,
                                    encodingId: -1,
                                    mappings: [],
                                    hasShortCmap: false
                                };
                            }
                            mappings.sort(function(a, b) {
                                return a.charCode - b.charCode;
                            });
                            for(let i = 1; i < mappings.length; i++)if (mappings[i - 1].charCode === mappings[i].charCode) {
                                mappings.splice(i, 1);
                                i--;
                            }
                            return {
                                platformId: potentialTable.platformId,
                                encodingId: potentialTable.encodingId,
                                mappings: mappings,
                                hasShortCmap: hasShortCmap
                            };
                        }
                        function sanitizeMetrics(file, header, metrics, headTable, numGlyphs, dupFirstEntry) {
                            if (!header) {
                                if (metrics) metrics.data = null;
                                return;
                            }
                            file.pos = (file.start || 0) + header.offset;
                            file.pos += 4;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            const caretOffset = file.getUint16();
                            file.pos += 8;
                            file.pos += 2;
                            let numOfMetrics = file.getUint16();
                            if (caretOffset !== 0) {
                                const macStyle = int16(headTable.data[44], headTable.data[45]);
                                if (!(macStyle & 2)) {
                                    header.data[22] = 0;
                                    header.data[23] = 0;
                                }
                            }
                            if (numOfMetrics > numGlyphs) {
                                (0, _util.info)(`The numOfMetrics (${numOfMetrics}) should not be ` + `greater than the numGlyphs (${numGlyphs}).`);
                                numOfMetrics = numGlyphs;
                                header.data[34] = (numOfMetrics & 0xff00) >> 8;
                                header.data[35] = numOfMetrics & 0x00ff;
                            }
                            const numOfSidebearings = numGlyphs - numOfMetrics;
                            const numMissing = numOfSidebearings - (metrics.length - numOfMetrics * 4 >> 1);
                            if (numMissing > 0) {
                                const entries = new Uint8Array(metrics.length + numMissing * 2);
                                entries.set(metrics.data);
                                if (dupFirstEntry) {
                                    entries[metrics.length] = metrics.data[2];
                                    entries[metrics.length + 1] = metrics.data[3];
                                }
                                metrics.data = entries;
                            }
                        }
                        function sanitizeGlyph(source, sourceStart, sourceEnd, dest, destStart, hintsValid) {
                            const glyphProfile = {
                                length: 0,
                                sizeOfInstructions: 0
                            };
                            if (sourceStart < 0 || sourceStart >= source.length || sourceEnd > source.length || sourceEnd - sourceStart <= 12) return glyphProfile;
                            const glyf = source.subarray(sourceStart, sourceEnd);
                            const xMin = signedInt16(glyf[2], glyf[3]);
                            const yMin = signedInt16(glyf[4], glyf[5]);
                            const xMax = signedInt16(glyf[6], glyf[7]);
                            const yMax = signedInt16(glyf[8], glyf[9]);
                            if (xMin > xMax) {
                                writeSignedInt16(glyf, 2, xMax);
                                writeSignedInt16(glyf, 6, xMin);
                            }
                            if (yMin > yMax) {
                                writeSignedInt16(glyf, 4, yMax);
                                writeSignedInt16(glyf, 8, yMin);
                            }
                            const contoursCount = signedInt16(glyf[0], glyf[1]);
                            if (contoursCount < 0) {
                                if (contoursCount < -1) return glyphProfile;
                                dest.set(glyf, destStart);
                                glyphProfile.length = glyf.length;
                                return glyphProfile;
                            }
                            let i, j = 10, flagsCount = 0;
                            for(i = 0; i < contoursCount; i++){
                                const endPoint = glyf[j] << 8 | glyf[j + 1];
                                flagsCount = endPoint + 1;
                                j += 2;
                            }
                            const instructionsStart = j;
                            const instructionsLength = glyf[j] << 8 | glyf[j + 1];
                            glyphProfile.sizeOfInstructions = instructionsLength;
                            j += 2 + instructionsLength;
                            const instructionsEnd = j;
                            let coordinatesLength = 0;
                            for(i = 0; i < flagsCount; i++){
                                const flag = glyf[j++];
                                if (flag & 0xc0) glyf[j - 1] = flag & 0x3f;
                                let xLength = 2;
                                if (flag & 2) xLength = 1;
                                else if (flag & 16) xLength = 0;
                                let yLength = 2;
                                if (flag & 4) yLength = 1;
                                else if (flag & 32) yLength = 0;
                                const xyLength = xLength + yLength;
                                coordinatesLength += xyLength;
                                if (flag & 8) {
                                    const repeat = glyf[j++];
                                    if (repeat === 0) glyf[j - 1] ^= 8;
                                    i += repeat;
                                    coordinatesLength += repeat * xyLength;
                                }
                            }
                            if (coordinatesLength === 0) return glyphProfile;
                            let glyphDataLength = j + coordinatesLength;
                            if (glyphDataLength > glyf.length) return glyphProfile;
                            if (!hintsValid && instructionsLength > 0) {
                                dest.set(glyf.subarray(0, instructionsStart), destStart);
                                dest.set([
                                    0,
                                    0
                                ], destStart + instructionsStart);
                                dest.set(glyf.subarray(instructionsEnd, glyphDataLength), destStart + instructionsStart + 2);
                                glyphDataLength -= instructionsLength;
                                if (glyf.length - glyphDataLength > 3) glyphDataLength = glyphDataLength + 3 & -4;
                                glyphProfile.length = glyphDataLength;
                                return glyphProfile;
                            }
                            if (glyf.length - glyphDataLength > 3) {
                                glyphDataLength = glyphDataLength + 3 & -4;
                                dest.set(glyf.subarray(0, glyphDataLength), destStart);
                                glyphProfile.length = glyphDataLength;
                                return glyphProfile;
                            }
                            dest.set(glyf, destStart);
                            glyphProfile.length = glyf.length;
                            return glyphProfile;
                        }
                        function sanitizeHead(head, numGlyphs, locaLength) {
                            const data = head.data;
                            const version = int32(data[0], data[1], data[2], data[3]);
                            if (version >> 16 !== 1) {
                                (0, _util.info)("Attempting to fix invalid version in head table: " + version);
                                data[0] = 0;
                                data[1] = 1;
                                data[2] = 0;
                                data[3] = 0;
                            }
                            const indexToLocFormat = int16(data[50], data[51]);
                            if (indexToLocFormat < 0 || indexToLocFormat > 1) {
                                (0, _util.info)("Attempting to fix invalid indexToLocFormat in head table: " + indexToLocFormat);
                                const numGlyphsPlusOne = numGlyphs + 1;
                                if (locaLength === numGlyphsPlusOne << 1) {
                                    data[50] = 0;
                                    data[51] = 0;
                                } else if (locaLength === numGlyphsPlusOne << 2) {
                                    data[50] = 0;
                                    data[51] = 1;
                                } else throw new _util.FormatError("Could not fix indexToLocFormat: " + indexToLocFormat);
                            }
                        }
                        function sanitizeGlyphLocations(loca, glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions) {
                            let itemSize, itemDecode, itemEncode;
                            if (isGlyphLocationsLong) {
                                itemSize = 4;
                                itemDecode = function fontItemDecodeLong(data, offset) {
                                    return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
                                };
                                itemEncode = function fontItemEncodeLong(data, offset, value) {
                                    data[offset] = value >>> 24 & 0xff;
                                    data[offset + 1] = value >> 16 & 0xff;
                                    data[offset + 2] = value >> 8 & 0xff;
                                    data[offset + 3] = value & 0xff;
                                };
                            } else {
                                itemSize = 2;
                                itemDecode = function fontItemDecode(data, offset) {
                                    return data[offset] << 9 | data[offset + 1] << 1;
                                };
                                itemEncode = function fontItemEncode(data, offset, value) {
                                    data[offset] = value >> 9 & 0xff;
                                    data[offset + 1] = value >> 1 & 0xff;
                                };
                            }
                            const numGlyphsOut = dupFirstEntry ? numGlyphs + 1 : numGlyphs;
                            const locaDataSize = itemSize * (1 + numGlyphsOut);
                            const locaData = new Uint8Array(locaDataSize);
                            locaData.set(loca.data.subarray(0, locaDataSize));
                            loca.data = locaData;
                            const oldGlyfData = glyf.data;
                            const oldGlyfDataLength = oldGlyfData.length;
                            const newGlyfData = new Uint8Array(oldGlyfDataLength);
                            let i, j;
                            const locaEntries = [];
                            for(i = 0, j = 0; i < numGlyphs + 1; i++, j += itemSize){
                                let offset = itemDecode(locaData, j);
                                if (offset > oldGlyfDataLength) offset = oldGlyfDataLength;
                                locaEntries.push({
                                    index: i,
                                    offset: offset,
                                    endOffset: 0
                                });
                            }
                            locaEntries.sort((a, b)=>{
                                return a.offset - b.offset;
                            });
                            for(i = 0; i < numGlyphs; i++)locaEntries[i].endOffset = locaEntries[i + 1].offset;
                            locaEntries.sort((a, b)=>{
                                return a.index - b.index;
                            });
                            for(i = 0; i < numGlyphs; i++){
                                const { offset: offset, endOffset: endOffset } = locaEntries[i];
                                if (offset !== 0 || endOffset !== 0) break;
                                const nextOffset = locaEntries[i + 1].offset;
                                if (nextOffset === 0) continue;
                                locaEntries[i].endOffset = nextOffset;
                                break;
                            }
                            const missingGlyphs = Object.create(null);
                            let writeOffset = 0;
                            itemEncode(locaData, 0, writeOffset);
                            for(i = 0, j = itemSize; i < numGlyphs; i++, j += itemSize){
                                const glyphProfile = sanitizeGlyph(oldGlyfData, locaEntries[i].offset, locaEntries[i].endOffset, newGlyfData, writeOffset, hintsValid);
                                const newLength = glyphProfile.length;
                                if (newLength === 0) missingGlyphs[i] = true;
                                if (glyphProfile.sizeOfInstructions > maxSizeOfInstructions) maxSizeOfInstructions = glyphProfile.sizeOfInstructions;
                                writeOffset += newLength;
                                itemEncode(locaData, j, writeOffset);
                            }
                            if (writeOffset === 0) {
                                const simpleGlyph = new Uint8Array([
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    49,
                                    0
                                ]);
                                for(i = 0, j = itemSize; i < numGlyphsOut; i++, j += itemSize)itemEncode(locaData, j, simpleGlyph.length);
                                glyf.data = simpleGlyph;
                            } else if (dupFirstEntry) {
                                const firstEntryLength = itemDecode(locaData, itemSize);
                                if (newGlyfData.length > firstEntryLength + writeOffset) glyf.data = newGlyfData.subarray(0, firstEntryLength + writeOffset);
                                else {
                                    glyf.data = new Uint8Array(firstEntryLength + writeOffset);
                                    glyf.data.set(newGlyfData.subarray(0, writeOffset));
                                }
                                glyf.data.set(newGlyfData.subarray(0, firstEntryLength), writeOffset);
                                itemEncode(loca.data, locaData.length - itemSize, writeOffset + firstEntryLength);
                            } else glyf.data = newGlyfData.subarray(0, writeOffset);
                            return {
                                missingGlyphs: missingGlyphs,
                                maxSizeOfInstructions: maxSizeOfInstructions
                            };
                        }
                        function readPostScriptTable(post, propertiesObj, maxpNumGlyphs) {
                            const start = (font1.start || 0) + post.offset;
                            font1.pos = start;
                            const length = post.length, end = start + length;
                            const version = font1.getInt32();
                            font1.skip(28);
                            let glyphNames;
                            let valid = true;
                            let i;
                            switch(version){
                                case 0x00010000:
                                    glyphNames = _fonts_utils.MacStandardGlyphOrdering;
                                    break;
                                case 0x00020000:
                                    const numGlyphs = font1.getUint16();
                                    if (numGlyphs !== maxpNumGlyphs) {
                                        valid = false;
                                        break;
                                    }
                                    const glyphNameIndexes = [];
                                    for(i = 0; i < numGlyphs; ++i){
                                        const index = font1.getUint16();
                                        if (index >= 32768) {
                                            valid = false;
                                            break;
                                        }
                                        glyphNameIndexes.push(index);
                                    }
                                    if (!valid) break;
                                    const customNames = [], strBuf = [];
                                    while(font1.pos < end){
                                        const stringLength = font1.getByte();
                                        strBuf.length = stringLength;
                                        for(i = 0; i < stringLength; ++i)strBuf[i] = String.fromCharCode(font1.getByte());
                                        customNames.push(strBuf.join(""));
                                    }
                                    glyphNames = [];
                                    for(i = 0; i < numGlyphs; ++i){
                                        const j = glyphNameIndexes[i];
                                        if (j < 258) {
                                            glyphNames.push(_fonts_utils.MacStandardGlyphOrdering[j]);
                                            continue;
                                        }
                                        glyphNames.push(customNames[j - 258]);
                                    }
                                    break;
                                case 0x00030000:
                                    break;
                                default:
                                    (0, _util.warn)("Unknown/unsupported post table version " + version);
                                    valid = false;
                                    if (propertiesObj.defaultEncoding) glyphNames = propertiesObj.defaultEncoding;
                                    break;
                            }
                            propertiesObj.glyphNames = glyphNames;
                            return valid;
                        }
                        function readNameTable(nameTable) {
                            const start = (font1.start || 0) + nameTable.offset;
                            font1.pos = start;
                            const names = [
                                [],
                                []
                            ], records = [];
                            const length = nameTable.length, end = start + length;
                            const format = font1.getUint16();
                            const FORMAT_0_HEADER_LENGTH = 6;
                            if (format !== 0 || length < FORMAT_0_HEADER_LENGTH) return [
                                names,
                                records
                            ];
                            const numRecords = font1.getUint16();
                            const stringsStart = font1.getUint16();
                            const NAME_RECORD_LENGTH = 12;
                            let i, ii;
                            for(i = 0; i < numRecords && font1.pos + NAME_RECORD_LENGTH <= end; i++){
                                const r = {
                                    platform: font1.getUint16(),
                                    encoding: font1.getUint16(),
                                    language: font1.getUint16(),
                                    name: font1.getUint16(),
                                    length: font1.getUint16(),
                                    offset: font1.getUint16()
                                };
                                if (isMacNameRecord(r) || isWinNameRecord(r)) records.push(r);
                            }
                            for(i = 0, ii = records.length; i < ii; i++){
                                const record = records[i];
                                if (record.length <= 0) continue;
                                const pos = start + stringsStart + record.offset;
                                if (pos + record.length > end) continue;
                                font1.pos = pos;
                                const nameIndex = record.name;
                                if (record.encoding) {
                                    let str = "";
                                    for(let j = 0, jj = record.length; j < jj; j += 2)str += String.fromCharCode(font1.getUint16());
                                    names[1][nameIndex] = str;
                                } else names[0][nameIndex] = font1.getString(record.length);
                            }
                            return [
                                names,
                                records
                            ];
                        }
                        const TTOpsStackDeltas = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            -2,
                            -2,
                            -2,
                            -2,
                            0,
                            0,
                            -2,
                            -5,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            0,
                            -1,
                            -1,
                            -1,
                            -1,
                            1,
                            -1,
                            -999,
                            0,
                            1,
                            0,
                            -1,
                            -2,
                            0,
                            -1,
                            -2,
                            -1,
                            -1,
                            0,
                            -1,
                            -1,
                            0,
                            0,
                            -999,
                            -999,
                            -1,
                            -1,
                            -1,
                            -1,
                            -2,
                            -999,
                            -2,
                            -2,
                            -999,
                            0,
                            -2,
                            -2,
                            0,
                            0,
                            -2,
                            0,
                            -2,
                            0,
                            0,
                            0,
                            -2,
                            -1,
                            -1,
                            1,
                            1,
                            0,
                            0,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            0,
                            -1,
                            -1,
                            0,
                            -999,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            -2,
                            -999,
                            -999,
                            -999,
                            -999,
                            -999,
                            -1,
                            -1,
                            -2,
                            -2,
                            0,
                            0,
                            0,
                            0,
                            -1,
                            -1,
                            -999,
                            -2,
                            -2,
                            0,
                            0,
                            -1,
                            -2,
                            -2,
                            0,
                            0,
                            0,
                            -1,
                            -1,
                            -1,
                            -2
                        ];
                        function sanitizeTTProgram(table, ttContext) {
                            let data = table.data;
                            let i = 0, j, n, b, funcId, pc, lastEndf = 0, lastDeff = 0;
                            const stack = [];
                            const callstack = [];
                            const functionsCalled = [];
                            let tooComplexToFollowFunctions = ttContext.tooComplexToFollowFunctions;
                            let inFDEF = false, ifLevel = 0, inELSE = 0;
                            for(let ii = data.length; i < ii;){
                                const op = data[i++];
                                if (op === 0x40) {
                                    n = data[i++];
                                    if (inFDEF || inELSE) i += n;
                                    else for(j = 0; j < n; j++)stack.push(data[i++]);
                                } else if (op === 0x41) {
                                    n = data[i++];
                                    if (inFDEF || inELSE) i += n * 2;
                                    else for(j = 0; j < n; j++){
                                        b = data[i++];
                                        stack.push(b << 8 | data[i++]);
                                    }
                                } else if ((op & 0xf8) === 0xb0) {
                                    n = op - 0xb0 + 1;
                                    if (inFDEF || inELSE) i += n;
                                    else for(j = 0; j < n; j++)stack.push(data[i++]);
                                } else if ((op & 0xf8) === 0xb8) {
                                    n = op - 0xb8 + 1;
                                    if (inFDEF || inELSE) i += n * 2;
                                    else for(j = 0; j < n; j++){
                                        b = data[i++];
                                        stack.push(b << 8 | data[i++]);
                                    }
                                } else if (op === 0x2b && !tooComplexToFollowFunctions) {
                                    if (!inFDEF && !inELSE) {
                                        funcId = stack.at(-1);
                                        if (isNaN(funcId)) (0, _util.info)("TT: CALL empty stack (or invalid entry).");
                                        else {
                                            ttContext.functionsUsed[funcId] = true;
                                            if (funcId in ttContext.functionsStackDeltas) {
                                                const newStackLength = stack.length + ttContext.functionsStackDeltas[funcId];
                                                if (newStackLength < 0) {
                                                    (0, _util.warn)("TT: CALL invalid functions stack delta.");
                                                    ttContext.hintsValid = false;
                                                    return;
                                                }
                                                stack.length = newStackLength;
                                            } else if (funcId in ttContext.functionsDefined && !functionsCalled.includes(funcId)) {
                                                callstack.push({
                                                    data: data,
                                                    i: i,
                                                    stackTop: stack.length - 1
                                                });
                                                functionsCalled.push(funcId);
                                                pc = ttContext.functionsDefined[funcId];
                                                if (!pc) {
                                                    (0, _util.warn)("TT: CALL non-existent function");
                                                    ttContext.hintsValid = false;
                                                    return;
                                                }
                                                data = pc.data;
                                                i = pc.i;
                                            }
                                        }
                                    }
                                } else if (op === 0x2c && !tooComplexToFollowFunctions) {
                                    if (inFDEF || inELSE) {
                                        (0, _util.warn)("TT: nested FDEFs not allowed");
                                        tooComplexToFollowFunctions = true;
                                    }
                                    inFDEF = true;
                                    lastDeff = i;
                                    funcId = stack.pop();
                                    ttContext.functionsDefined[funcId] = {
                                        data: data,
                                        i: i
                                    };
                                } else if (op === 0x2d) {
                                    if (inFDEF) {
                                        inFDEF = false;
                                        lastEndf = i;
                                    } else {
                                        pc = callstack.pop();
                                        if (!pc) {
                                            (0, _util.warn)("TT: ENDF bad stack");
                                            ttContext.hintsValid = false;
                                            return;
                                        }
                                        funcId = functionsCalled.pop();
                                        data = pc.data;
                                        i = pc.i;
                                        ttContext.functionsStackDeltas[funcId] = stack.length - pc.stackTop;
                                    }
                                } else if (op === 0x89) {
                                    if (inFDEF || inELSE) {
                                        (0, _util.warn)("TT: nested IDEFs not allowed");
                                        tooComplexToFollowFunctions = true;
                                    }
                                    inFDEF = true;
                                    lastDeff = i;
                                } else if (op === 0x58) ++ifLevel;
                                else if (op === 0x1b) inELSE = ifLevel;
                                else if (op === 0x59) {
                                    if (inELSE === ifLevel) inELSE = 0;
                                    --ifLevel;
                                } else if (op === 0x1c) {
                                    if (!inFDEF && !inELSE) {
                                        const offset = stack.at(-1);
                                        if (offset > 0) i += offset - 1;
                                    }
                                }
                                if (!inFDEF && !inELSE) {
                                    let stackDelta = 0;
                                    if (op <= 0x8e) stackDelta = TTOpsStackDeltas[op];
                                    else if (op >= 0xc0 && op <= 0xdf) stackDelta = -1;
                                    else if (op >= 0xe0) stackDelta = -2;
                                    if (op >= 0x71 && op <= 0x75) {
                                        n = stack.pop();
                                        if (!isNaN(n)) stackDelta = -n * 2;
                                    }
                                    while(stackDelta < 0 && stack.length > 0){
                                        stack.pop();
                                        stackDelta++;
                                    }
                                    while(stackDelta > 0){
                                        stack.push(NaN);
                                        stackDelta--;
                                    }
                                }
                            }
                            ttContext.tooComplexToFollowFunctions = tooComplexToFollowFunctions;
                            const content = [
                                data
                            ];
                            if (i > data.length) content.push(new Uint8Array(i - data.length));
                            if (lastDeff > lastEndf) {
                                (0, _util.warn)("TT: complementing a missing function tail");
                                content.push(new Uint8Array([
                                    0x22,
                                    0x2d
                                ]));
                            }
                            foldTTTable(table, content);
                        }
                        function checkInvalidFunctions(ttContext, maxFunctionDefs) {
                            if (ttContext.tooComplexToFollowFunctions) return;
                            if (ttContext.functionsDefined.length > maxFunctionDefs) {
                                (0, _util.warn)("TT: more functions defined than expected");
                                ttContext.hintsValid = false;
                                return;
                            }
                            for(let j = 0, jj = ttContext.functionsUsed.length; j < jj; j++){
                                if (j > maxFunctionDefs) {
                                    (0, _util.warn)("TT: invalid function id: " + j);
                                    ttContext.hintsValid = false;
                                    return;
                                }
                                if (ttContext.functionsUsed[j] && !ttContext.functionsDefined[j]) {
                                    (0, _util.warn)("TT: undefined function: " + j);
                                    ttContext.hintsValid = false;
                                    return;
                                }
                            }
                        }
                        function foldTTTable(table, content) {
                            if (content.length > 1) {
                                let newLength = 0;
                                let j, jj;
                                for(j = 0, jj = content.length; j < jj; j++)newLength += content[j].length;
                                newLength = newLength + 3 & -4;
                                const result = new Uint8Array(newLength);
                                let pos = 0;
                                for(j = 0, jj = content.length; j < jj; j++){
                                    result.set(content[j], pos);
                                    pos += content[j].length;
                                }
                                table.data = result;
                                table.length = newLength;
                            }
                        }
                        function sanitizeTTPrograms(fpgm, prep, cvt, maxFunctionDefs) {
                            const ttContext = {
                                functionsDefined: [],
                                functionsUsed: [],
                                functionsStackDeltas: [],
                                tooComplexToFollowFunctions: false,
                                hintsValid: true
                            };
                            if (fpgm) sanitizeTTProgram(fpgm, ttContext);
                            if (prep) sanitizeTTProgram(prep, ttContext);
                            if (fpgm) checkInvalidFunctions(ttContext, maxFunctionDefs);
                            if (cvt && cvt.length & 1) {
                                const cvtData = new Uint8Array(cvt.length + 1);
                                cvtData.set(cvt.data);
                                cvt.data = cvtData;
                            }
                            return ttContext.hintsValid;
                        }
                        font1 = new _stream.Stream(new Uint8Array(font1.getBytes()));
                        let header, tables;
                        if (isTrueTypeCollectionFile(font1)) {
                            const ttcData = readTrueTypeCollectionData(font1, this.name);
                            header = ttcData.header;
                            tables = ttcData.tables;
                        } else {
                            header = readOpenTypeHeader(font1);
                            tables = readTables(font1, header.numTables);
                        }
                        let cff, cffFile;
                        const isTrueType = !tables["CFF "];
                        if (!isTrueType) {
                            const isComposite = properties.composite && (properties.cidToGidMap?.length > 0 || !(properties.cMap instanceof _cmap.IdentityCMap));
                            if (header.version === "OTTO" && !isComposite || !tables.head || !tables.hhea || !tables.maxp || !tables.post) {
                                cffFile = new _stream.Stream(tables["CFF "].data);
                                cff = new _cff_font.CFFFont(cffFile, properties);
                                adjustWidths(properties);
                                return this.convert(name, cff, properties);
                            }
                            delete tables.glyf;
                            delete tables.loca;
                            delete tables.fpgm;
                            delete tables.prep;
                            delete tables["cvt "];
                            this.isOpenType = true;
                        } else {
                            if (!tables.loca) throw new _util.FormatError('Required "loca" table is not found');
                            if (!tables.glyf) {
                                (0, _util.warn)('Required "glyf" table is not found -- trying to recover.');
                                tables.glyf = {
                                    tag: "glyf",
                                    data: new Uint8Array(0)
                                };
                            }
                            this.isOpenType = false;
                        }
                        if (!tables.maxp) throw new _util.FormatError('Required "maxp" table is not found');
                        font1.pos = (font1.start || 0) + tables.maxp.offset;
                        const version = font1.getInt32();
                        const numGlyphs = font1.getUint16();
                        if (properties.scaleFactors?.length === numGlyphs && isTrueType) {
                            const { scaleFactors: scaleFactors } = properties;
                            const isGlyphLocationsLong = int16(tables.head.data[50], tables.head.data[51]);
                            const glyphs = new _glyf.GlyfTable({
                                glyfTable: tables.glyf.data,
                                isGlyphLocationsLong: isGlyphLocationsLong,
                                locaTable: tables.loca.data,
                                numGlyphs: numGlyphs
                            });
                            glyphs.scale(scaleFactors);
                            const { glyf: glyf, loca: loca, isLocationLong: isLocationLong } = glyphs.write();
                            tables.glyf.data = glyf;
                            tables.loca.data = loca;
                            if (isLocationLong !== !!isGlyphLocationsLong) {
                                tables.head.data[50] = 0;
                                tables.head.data[51] = isLocationLong ? 1 : 0;
                            }
                            const metrics = tables.hmtx.data;
                            for(let i = 0; i < numGlyphs; i++){
                                const j = 4 * i;
                                const advanceWidth = Math.round(scaleFactors[i] * int16(metrics[j], metrics[j + 1]));
                                metrics[j] = advanceWidth >> 8 & 0xff;
                                metrics[j + 1] = advanceWidth & 0xff;
                                const lsb = Math.round(scaleFactors[i] * signedInt16(metrics[j + 2], metrics[j + 3]));
                                writeSignedInt16(metrics, j + 2, lsb);
                            }
                        }
                        let numGlyphsOut = numGlyphs + 1;
                        let dupFirstEntry = true;
                        if (numGlyphsOut > 0xffff) {
                            dupFirstEntry = false;
                            numGlyphsOut = numGlyphs;
                            (0, _util.warn)("Not enough space in glyfs to duplicate first glyph.");
                        }
                        let maxFunctionDefs = 0;
                        let maxSizeOfInstructions = 0;
                        if (version >= 0x00010000 && tables.maxp.length >= 22) {
                            font1.pos += 8;
                            const maxZones = font1.getUint16();
                            if (maxZones > 2) {
                                tables.maxp.data[14] = 0;
                                tables.maxp.data[15] = 2;
                            }
                            font1.pos += 4;
                            maxFunctionDefs = font1.getUint16();
                            font1.pos += 4;
                            maxSizeOfInstructions = font1.getUint16();
                        }
                        tables.maxp.data[4] = numGlyphsOut >> 8;
                        tables.maxp.data[5] = numGlyphsOut & 255;
                        const hintsValid = sanitizeTTPrograms(tables.fpgm, tables.prep, tables["cvt "], maxFunctionDefs);
                        if (!hintsValid) {
                            delete tables.fpgm;
                            delete tables.prep;
                            delete tables["cvt "];
                        }
                        sanitizeMetrics(font1, tables.hhea, tables.hmtx, tables.head, numGlyphsOut, dupFirstEntry);
                        if (!tables.head) throw new _util.FormatError('Required "head" table is not found');
                        sanitizeHead(tables.head, numGlyphs, isTrueType ? tables.loca.length : 0);
                        let missingGlyphs = Object.create(null);
                        if (isTrueType) {
                            const isGlyphLocationsLong = int16(tables.head.data[50], tables.head.data[51]);
                            const glyphsInfo = sanitizeGlyphLocations(tables.loca, tables.glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions);
                            missingGlyphs = glyphsInfo.missingGlyphs;
                            if (version >= 0x00010000 && tables.maxp.length >= 22) {
                                tables.maxp.data[26] = glyphsInfo.maxSizeOfInstructions >> 8;
                                tables.maxp.data[27] = glyphsInfo.maxSizeOfInstructions & 255;
                            }
                        }
                        if (!tables.hhea) throw new _util.FormatError('Required "hhea" table is not found');
                        if (tables.hhea.data[10] === 0 && tables.hhea.data[11] === 0) {
                            tables.hhea.data[10] = 0xff;
                            tables.hhea.data[11] = 0xff;
                        }
                        const metricsOverride = {
                            unitsPerEm: int16(tables.head.data[18], tables.head.data[19]),
                            yMax: signedInt16(tables.head.data[42], tables.head.data[43]),
                            yMin: signedInt16(tables.head.data[38], tables.head.data[39]),
                            ascent: signedInt16(tables.hhea.data[4], tables.hhea.data[5]),
                            descent: signedInt16(tables.hhea.data[6], tables.hhea.data[7]),
                            lineGap: signedInt16(tables.hhea.data[8], tables.hhea.data[9])
                        };
                        this.ascent = metricsOverride.ascent / metricsOverride.unitsPerEm;
                        this.descent = metricsOverride.descent / metricsOverride.unitsPerEm;
                        this.lineGap = metricsOverride.lineGap / metricsOverride.unitsPerEm;
                        if (this.cssFontInfo?.lineHeight) {
                            this.lineHeight = this.cssFontInfo.metrics.lineHeight;
                            this.lineGap = this.cssFontInfo.metrics.lineGap;
                        } else this.lineHeight = this.ascent - this.descent + this.lineGap;
                        if (tables.post) readPostScriptTable(tables.post, properties, numGlyphs);
                        tables.post = {
                            tag: "post",
                            data: createPostTable(properties)
                        };
                        const charCodeToGlyphId = [];
                        function hasGlyph(glyphId) {
                            return !missingGlyphs[glyphId];
                        }
                        if (properties.composite) {
                            const cidToGidMap = properties.cidToGidMap || [];
                            const isCidToGidMapEmpty = cidToGidMap.length === 0;
                            properties.cMap.forEach(function(charCode, cid) {
                                if (typeof cid === "string") cid = convertCidString(charCode, cid, true);
                                if (cid > 0xffff) throw new _util.FormatError("Max size of CID is 65,535");
                                let glyphId = -1;
                                if (isCidToGidMapEmpty) glyphId = cid;
                                else if (cidToGidMap[cid] !== undefined) glyphId = cidToGidMap[cid];
                                if (glyphId >= 0 && glyphId < numGlyphs && hasGlyph(glyphId)) charCodeToGlyphId[charCode] = glyphId;
                            });
                        } else {
                            const cmapTable = readCmapTable(tables.cmap, font1, this.isSymbolicFont, properties.hasEncoding);
                            const cmapPlatformId = cmapTable.platformId;
                            const cmapEncodingId = cmapTable.encodingId;
                            const cmapMappings = cmapTable.mappings;
                            let baseEncoding = [], forcePostTable = false;
                            if (properties.hasEncoding && (properties.baseEncodingName === "MacRomanEncoding" || properties.baseEncodingName === "WinAnsiEncoding")) baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
                            if (properties.hasEncoding && !this.isSymbolicFont && (cmapPlatformId === 3 && cmapEncodingId === 1 || cmapPlatformId === 1 && cmapEncodingId === 0)) {
                                const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                                for(let charCode = 0; charCode < 256; charCode++){
                                    let glyphName;
                                    if (this.differences[charCode] !== undefined) glyphName = this.differences[charCode];
                                    else if (baseEncoding.length && baseEncoding[charCode] !== "") glyphName = baseEncoding[charCode];
                                    else glyphName = _encodings.StandardEncoding[charCode];
                                    if (!glyphName) continue;
                                    const standardGlyphName = (0, _fonts_utils.recoverGlyphName)(glyphName, glyphsUnicodeMap);
                                    let unicodeOrCharCode;
                                    if (cmapPlatformId === 3 && cmapEncodingId === 1) unicodeOrCharCode = glyphsUnicodeMap[standardGlyphName];
                                    else if (cmapPlatformId === 1 && cmapEncodingId === 0) unicodeOrCharCode = _encodings.MacRomanEncoding.indexOf(standardGlyphName);
                                    if (unicodeOrCharCode === undefined) {
                                        if (!properties.glyphNames && properties.hasIncludedToUnicodeMap && !(this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap)) {
                                            const unicode = this.toUnicode.get(charCode);
                                            if (unicode) unicodeOrCharCode = unicode.codePointAt(0);
                                        }
                                        if (unicodeOrCharCode === undefined) continue;
                                    }
                                    for (const mapping of cmapMappings){
                                        if (mapping.charCode !== unicodeOrCharCode) continue;
                                        charCodeToGlyphId[charCode] = mapping.glyphId;
                                        break;
                                    }
                                }
                            } else if (cmapPlatformId === 0) {
                                for (const mapping of cmapMappings)charCodeToGlyphId[mapping.charCode] = mapping.glyphId;
                                forcePostTable = true;
                            } else for (const mapping of cmapMappings){
                                let charCode = mapping.charCode;
                                if (cmapPlatformId === 3 && charCode >= 0xf000 && charCode <= 0xf0ff) charCode &= 0xff;
                                charCodeToGlyphId[charCode] = mapping.glyphId;
                            }
                            if (properties.glyphNames && (baseEncoding.length || this.differences.length)) for(let i = 0; i < 256; ++i){
                                if (!forcePostTable && charCodeToGlyphId[i] !== undefined) continue;
                                const glyphName = this.differences[i] || baseEncoding[i];
                                if (!glyphName) continue;
                                const glyphId = properties.glyphNames.indexOf(glyphName);
                                if (glyphId > 0 && hasGlyph(glyphId)) charCodeToGlyphId[i] = glyphId;
                            }
                        }
                        if (charCodeToGlyphId.length === 0) charCodeToGlyphId[0] = 0;
                        let glyphZeroId = numGlyphsOut - 1;
                        if (!dupFirstEntry) glyphZeroId = 0;
                        if (!properties.cssFontInfo) {
                            const newMapping = adjustMapping(charCodeToGlyphId, hasGlyph, glyphZeroId, this.toUnicode);
                            this.toFontChar = newMapping.toFontChar;
                            tables.cmap = {
                                tag: "cmap",
                                data: createCmapTable(newMapping.charCodeToGlyphId, newMapping.toUnicodeExtraMap, numGlyphsOut)
                            };
                            if (!tables["OS/2"] || !validateOS2Table(tables["OS/2"], font1)) tables["OS/2"] = {
                                tag: "OS/2",
                                data: createOS2Table(properties, newMapping.charCodeToGlyphId, metricsOverride)
                            };
                        }
                        if (!isTrueType) try {
                            cffFile = new _stream.Stream(tables["CFF "].data);
                            const parser = new _cff_parser.CFFParser(cffFile, properties, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                            cff = parser.parse();
                            cff.duplicateFirstGlyph();
                            const compiler = new _cff_parser.CFFCompiler(cff);
                            tables["CFF "].data = compiler.compile();
                        } catch  {
                            (0, _util.warn)("Failed to compile font " + properties.loadedName);
                        }
                        if (!tables.name) tables.name = {
                            tag: "name",
                            data: createNameTable(this.name)
                        };
                        else {
                            const [namePrototype, nameRecords] = readNameTable(tables.name);
                            tables.name.data = createNameTable(name, namePrototype);
                            this.psName = namePrototype[0][6] || null;
                            if (!properties.composite) adjustTrueTypeToUnicode(properties, this.isSymbolicFont, nameRecords);
                        }
                        const builder = new _opentype_file_builder.OpenTypeFileBuilder(header.version);
                        for(const tableTag in tables)builder.addTable(tableTag, tables[tableTag].data);
                        return builder.toArray();
                    }
                    convert(fontName, font1, properties) {
                        properties.fixedPitch = false;
                        if (properties.builtInEncoding) adjustType1ToUnicode(properties, properties.builtInEncoding);
                        let glyphZeroId = 1;
                        if (font1 instanceof _cff_font.CFFFont) glyphZeroId = font1.numGlyphs - 1;
                        const mapping = font1.getGlyphMapping(properties);
                        let newMapping = null;
                        let newCharCodeToGlyphId = mapping;
                        let toUnicodeExtraMap = null;
                        if (!properties.cssFontInfo) {
                            newMapping = adjustMapping(mapping, font1.hasGlyphId.bind(font1), glyphZeroId, this.toUnicode);
                            this.toFontChar = newMapping.toFontChar;
                            newCharCodeToGlyphId = newMapping.charCodeToGlyphId;
                            toUnicodeExtraMap = newMapping.toUnicodeExtraMap;
                        }
                        const numGlyphs = font1.numGlyphs;
                        function getCharCodes(charCodeToGlyphId, glyphId) {
                            let charCodes = null;
                            for(const charCode in charCodeToGlyphId)if (glyphId === charCodeToGlyphId[charCode]) (charCodes ||= []).push(charCode | 0);
                            return charCodes;
                        }
                        function createCharCode(charCodeToGlyphId, glyphId) {
                            for(const charCode in charCodeToGlyphId){
                                if (glyphId === charCodeToGlyphId[charCode]) return charCode | 0;
                            }
                            newMapping.charCodeToGlyphId[newMapping.nextAvailableFontCharCode] = glyphId;
                            return newMapping.nextAvailableFontCharCode++;
                        }
                        const seacs = font1.seacs;
                        if (newMapping && _fonts_utils.SEAC_ANALYSIS_ENABLED && seacs?.length) {
                            const matrix = properties.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                            const charset = font1.getCharset();
                            const seacMap = Object.create(null);
                            for(let glyphId in seacs){
                                glyphId |= 0;
                                const seac = seacs[glyphId];
                                const baseGlyphName = _encodings.StandardEncoding[seac[2]];
                                const accentGlyphName = _encodings.StandardEncoding[seac[3]];
                                const baseGlyphId = charset.indexOf(baseGlyphName);
                                const accentGlyphId = charset.indexOf(accentGlyphName);
                                if (baseGlyphId < 0 || accentGlyphId < 0) continue;
                                const accentOffset = {
                                    x: seac[0] * matrix[0] + seac[1] * matrix[2] + matrix[4],
                                    y: seac[0] * matrix[1] + seac[1] * matrix[3] + matrix[5]
                                };
                                const charCodes = getCharCodes(mapping, glyphId);
                                if (!charCodes) continue;
                                for (const charCode of charCodes){
                                    const charCodeToGlyphId = newMapping.charCodeToGlyphId;
                                    const baseFontCharCode = createCharCode(charCodeToGlyphId, baseGlyphId);
                                    const accentFontCharCode = createCharCode(charCodeToGlyphId, accentGlyphId);
                                    seacMap[charCode] = {
                                        baseFontCharCode: baseFontCharCode,
                                        accentFontCharCode: accentFontCharCode,
                                        accentOffset: accentOffset
                                    };
                                }
                            }
                            properties.seacMap = seacMap;
                        }
                        const unitsPerEm = 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
                        const builder = new _opentype_file_builder.OpenTypeFileBuilder("OTTO");
                        builder.addTable("CFF ", font1.data);
                        builder.addTable("OS/2", createOS2Table(properties, newCharCodeToGlyphId));
                        builder.addTable("cmap", createCmapTable(newCharCodeToGlyphId, toUnicodeExtraMap, numGlyphs));
                        builder.addTable("head", "\0\x01\0\0\0\0\x10\0\0\0\0\0_\x0f<\xf5\0\0" + safeString16(unitsPerEm) + "\0\0\0\0\x9e\v~'" + "\0\0\0\0\x9e\v~'" + "\0\0" + safeString16(properties.descent) + "\x0f\xff" + safeString16(properties.ascent) + string16(properties.italicAngle ? 2 : 0) + "\0\x11" + "\0\0" + "\0\0" + "\0\0");
                        builder.addTable("hhea", "\0\x01\0\0" + safeString16(properties.ascent) + safeString16(properties.descent) + "\0\0" + "\xff\xff" + "\0\0" + "\0\0" + "\0\0" + safeString16(properties.capHeight) + safeString16(Math.tan(properties.italicAngle) * properties.xHeight) + "\0\0" + "\0\0" + "\0\0" + "\0\0" + "\0\0" + "\0\0" + string16(numGlyphs));
                        builder.addTable("hmtx", function fontFieldsHmtx() {
                            const charstrings = font1.charstrings;
                            const cffWidths = font1.cff ? font1.cff.widths : null;
                            let hmtx = "\0\0\0\0";
                            for(let i = 1, ii = numGlyphs; i < ii; i++){
                                let width = 0;
                                if (charstrings) {
                                    const charstring = charstrings[i - 1];
                                    width = "width" in charstring ? charstring.width : 0;
                                } else if (cffWidths) width = Math.ceil(cffWidths[i] || 0);
                                hmtx += string16(width) + string16(0);
                            }
                            return hmtx;
                        }());
                        builder.addTable("maxp", "\0\0P\0" + string16(numGlyphs));
                        builder.addTable("name", createNameTable(fontName));
                        builder.addTable("post", createPostTable(properties));
                        return builder.toArray();
                    }
                    get spaceWidth() {
                        const possibleSpaceReplacements = [
                            "space",
                            "minus",
                            "one",
                            "i",
                            "I"
                        ];
                        let width;
                        for (const glyphName of possibleSpaceReplacements){
                            if (glyphName in this.widths) {
                                width = this.widths[glyphName];
                                break;
                            }
                            const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                            const glyphUnicode = glyphsUnicodeMap[glyphName];
                            let charcode = 0;
                            if (this.composite && this.cMap.contains(glyphUnicode)) {
                                charcode = this.cMap.lookup(glyphUnicode);
                                if (typeof charcode === "string") charcode = convertCidString(glyphUnicode, charcode);
                            }
                            if (!charcode && this.toUnicode) charcode = this.toUnicode.charCodeOf(glyphUnicode);
                            if (charcode <= 0) charcode = glyphUnicode;
                            width = this.widths[charcode];
                            if (width) break;
                        }
                        return (0, _util.shadow)(this, "spaceWidth", width || this.defaultWidth);
                    }
                    _charToGlyph(charcode, isSpace = false) {
                        let glyph = this._glyphCache[charcode];
                        if (glyph?.isSpace === isSpace) return glyph;
                        let fontCharCode, width, operatorListId;
                        let widthCode = charcode;
                        if (this.cMap?.contains(charcode)) {
                            widthCode = this.cMap.lookup(charcode);
                            if (typeof widthCode === "string") widthCode = convertCidString(charcode, widthCode);
                        }
                        width = this.widths[widthCode];
                        if (typeof width !== "number") width = this.defaultWidth;
                        const vmetric = this.vmetrics?.[widthCode];
                        let unicode = this.toUnicode.get(charcode) || charcode;
                        if (typeof unicode === "number") unicode = String.fromCharCode(unicode);
                        let isInFont = this.toFontChar[charcode] !== undefined;
                        fontCharCode = this.toFontChar[charcode] || charcode;
                        if (this.missingFile) {
                            const glyphName = this.differences[charcode] || this.defaultEncoding[charcode];
                            if ((glyphName === ".notdef" || glyphName === "") && this.type === "Type1") fontCharCode = 0x20;
                            fontCharCode = (0, _unicode.mapSpecialUnicodeValues)(fontCharCode);
                        }
                        if (this.isType3Font) operatorListId = fontCharCode;
                        let accent = null;
                        if (this.seacMap?.[charcode]) {
                            isInFont = true;
                            const seac = this.seacMap[charcode];
                            fontCharCode = seac.baseFontCharCode;
                            accent = {
                                fontChar: String.fromCodePoint(seac.accentFontCharCode),
                                offset: seac.accentOffset
                            };
                        }
                        let fontChar = "";
                        if (typeof fontCharCode === "number") {
                            if (fontCharCode <= 0x10ffff) fontChar = String.fromCodePoint(fontCharCode);
                            else (0, _util.warn)(`charToGlyph - invalid fontCharCode: ${fontCharCode}`);
                        }
                        glyph = new Glyph(charcode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont);
                        return this._glyphCache[charcode] = glyph;
                    }
                    charsToGlyphs(chars) {
                        let glyphs = this._charsCache[chars];
                        if (glyphs) return glyphs;
                        glyphs = [];
                        if (this.cMap) {
                            const c = Object.create(null), ii = chars.length;
                            let i = 0;
                            while(i < ii){
                                this.cMap.readCharCode(chars, i, c);
                                const { charcode: charcode, length: length } = c;
                                i += length;
                                const glyph = this._charToGlyph(charcode, length === 1 && chars.charCodeAt(i - 1) === 0x20);
                                glyphs.push(glyph);
                            }
                        } else for(let i = 0, ii = chars.length; i < ii; ++i){
                            const charcode = chars.charCodeAt(i);
                            const glyph = this._charToGlyph(charcode, charcode === 0x20);
                            glyphs.push(glyph);
                        }
                        return this._charsCache[chars] = glyphs;
                    }
                    getCharPositions(chars) {
                        const positions = [];
                        if (this.cMap) {
                            const c = Object.create(null);
                            let i = 0;
                            while(i < chars.length){
                                this.cMap.readCharCode(chars, i, c);
                                const length = c.length;
                                positions.push([
                                    i,
                                    i + length
                                ]);
                                i += length;
                            }
                        } else for(let i = 0, ii = chars.length; i < ii; ++i)positions.push([
                            i,
                            i + 1
                        ]);
                        return positions;
                    }
                    get glyphCacheValues() {
                        return Object.values(this._glyphCache);
                    }
                    encodeString(str) {
                        const buffers = [];
                        const currentBuf = [];
                        const hasCurrentBufErrors = ()=>buffers.length % 2 === 1;
                        const getCharCode = this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap ? (unicode)=>this.toUnicode.charCodeOf(unicode) : (unicode)=>this.toUnicode.charCodeOf(String.fromCodePoint(unicode));
                        for(let i = 0, ii = str.length; i < ii; i++){
                            const unicode = str.codePointAt(i);
                            if (unicode > 0xd7ff && (unicode < 0xe000 || unicode > 0xfffd)) i++;
                            if (this.toUnicode) {
                                const charCode = getCharCode(unicode);
                                if (charCode !== -1) {
                                    if (hasCurrentBufErrors()) {
                                        buffers.push(currentBuf.join(""));
                                        currentBuf.length = 0;
                                    }
                                    const charCodeLength = this.cMap ? this.cMap.getCharCodeLength(charCode) : 1;
                                    for(let j = charCodeLength - 1; j >= 0; j--)currentBuf.push(String.fromCharCode(charCode >> 8 * j & 0xff));
                                    continue;
                                }
                            }
                            if (!hasCurrentBufErrors()) {
                                buffers.push(currentBuf.join(""));
                                currentBuf.length = 0;
                            }
                            currentBuf.push(String.fromCodePoint(unicode));
                        }
                        buffers.push(currentBuf.join(""));
                        return buffers;
                    }
                }
                exports.Font = Font;
                class ErrorFont {
                    constructor(error){
                        this.error = error;
                        this.loadedName = "g_font_error";
                        this.missingFile = true;
                    }
                    charsToGlyphs() {
                        return [];
                    }
                    encodeString(chars) {
                        return [
                            chars
                        ];
                    }
                    exportData(extraProperties = false) {
                        return {
                            error: this.error
                        };
                    }
                }
                exports.ErrorFont = ErrorFont;
            /***/ },
            /* 35 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CFFTopDict = exports.CFFStrings = exports.CFFStandardStrings = exports.CFFPrivateDict = exports.CFFParser = exports.CFFIndex = exports.CFFHeader = exports.CFFFDSelect = exports.CFFCompiler = exports.CFFCharset = exports.CFF = void 0;
                var _util = __w_pdfjs_require__(2);
                var _charsets = __w_pdfjs_require__(36);
                var _encodings = __w_pdfjs_require__(37);
                const MAX_SUBR_NESTING = 10;
                const CFFStandardStrings = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall",
                    "001.000",
                    "001.001",
                    "001.002",
                    "001.003",
                    "Black",
                    "Bold",
                    "Book",
                    "Light",
                    "Medium",
                    "Regular",
                    "Roman",
                    "Semibold"
                ];
                exports.CFFStandardStrings = CFFStandardStrings;
                const NUM_STANDARD_CFF_STRINGS = 391;
                const CharstringValidationData = [
                    null,
                    {
                        id: "hstem",
                        min: 2,
                        stackClearing: true,
                        stem: true
                    },
                    null,
                    {
                        id: "vstem",
                        min: 2,
                        stackClearing: true,
                        stem: true
                    },
                    {
                        id: "vmoveto",
                        min: 1,
                        stackClearing: true
                    },
                    {
                        id: "rlineto",
                        min: 2,
                        resetStack: true
                    },
                    {
                        id: "hlineto",
                        min: 1,
                        resetStack: true
                    },
                    {
                        id: "vlineto",
                        min: 1,
                        resetStack: true
                    },
                    {
                        id: "rrcurveto",
                        min: 6,
                        resetStack: true
                    },
                    null,
                    {
                        id: "callsubr",
                        min: 1,
                        undefStack: true
                    },
                    {
                        id: "return",
                        min: 0,
                        undefStack: true
                    },
                    null,
                    null,
                    {
                        id: "endchar",
                        min: 0,
                        stackClearing: true
                    },
                    null,
                    null,
                    null,
                    {
                        id: "hstemhm",
                        min: 2,
                        stackClearing: true,
                        stem: true
                    },
                    {
                        id: "hintmask",
                        min: 0,
                        stackClearing: true
                    },
                    {
                        id: "cntrmask",
                        min: 0,
                        stackClearing: true
                    },
                    {
                        id: "rmoveto",
                        min: 2,
                        stackClearing: true
                    },
                    {
                        id: "hmoveto",
                        min: 1,
                        stackClearing: true
                    },
                    {
                        id: "vstemhm",
                        min: 2,
                        stackClearing: true,
                        stem: true
                    },
                    {
                        id: "rcurveline",
                        min: 8,
                        resetStack: true
                    },
                    {
                        id: "rlinecurve",
                        min: 8,
                        resetStack: true
                    },
                    {
                        id: "vvcurveto",
                        min: 4,
                        resetStack: true
                    },
                    {
                        id: "hhcurveto",
                        min: 4,
                        resetStack: true
                    },
                    null,
                    {
                        id: "callgsubr",
                        min: 1,
                        undefStack: true
                    },
                    {
                        id: "vhcurveto",
                        min: 4,
                        resetStack: true
                    },
                    {
                        id: "hvcurveto",
                        min: 4,
                        resetStack: true
                    }
                ];
                const CharstringValidationData12 = [
                    null,
                    null,
                    null,
                    {
                        id: "and",
                        min: 2,
                        stackDelta: -1
                    },
                    {
                        id: "or",
                        min: 2,
                        stackDelta: -1
                    },
                    {
                        id: "not",
                        min: 1,
                        stackDelta: 0
                    },
                    null,
                    null,
                    null,
                    {
                        id: "abs",
                        min: 1,
                        stackDelta: 0
                    },
                    {
                        id: "add",
                        min: 2,
                        stackDelta: -1,
                        stackFn (stack, index) {
                            stack[index - 2] = stack[index - 2] + stack[index - 1];
                        }
                    },
                    {
                        id: "sub",
                        min: 2,
                        stackDelta: -1,
                        stackFn (stack, index) {
                            stack[index - 2] = stack[index - 2] - stack[index - 1];
                        }
                    },
                    {
                        id: "div",
                        min: 2,
                        stackDelta: -1,
                        stackFn (stack, index) {
                            stack[index - 2] = stack[index - 2] / stack[index - 1];
                        }
                    },
                    null,
                    {
                        id: "neg",
                        min: 1,
                        stackDelta: 0,
                        stackFn (stack, index) {
                            stack[index - 1] = -stack[index - 1];
                        }
                    },
                    {
                        id: "eq",
                        min: 2,
                        stackDelta: -1
                    },
                    null,
                    null,
                    {
                        id: "drop",
                        min: 1,
                        stackDelta: -1
                    },
                    null,
                    {
                        id: "put",
                        min: 2,
                        stackDelta: -2
                    },
                    {
                        id: "get",
                        min: 1,
                        stackDelta: 0
                    },
                    {
                        id: "ifelse",
                        min: 4,
                        stackDelta: -3
                    },
                    {
                        id: "random",
                        min: 0,
                        stackDelta: 1
                    },
                    {
                        id: "mul",
                        min: 2,
                        stackDelta: -1,
                        stackFn (stack, index) {
                            stack[index - 2] = stack[index - 2] * stack[index - 1];
                        }
                    },
                    null,
                    {
                        id: "sqrt",
                        min: 1,
                        stackDelta: 0
                    },
                    {
                        id: "dup",
                        min: 1,
                        stackDelta: 1
                    },
                    {
                        id: "exch",
                        min: 2,
                        stackDelta: 0
                    },
                    {
                        id: "index",
                        min: 2,
                        stackDelta: 0
                    },
                    {
                        id: "roll",
                        min: 3,
                        stackDelta: -2
                    },
                    null,
                    null,
                    null,
                    {
                        id: "hflex",
                        min: 7,
                        resetStack: true
                    },
                    {
                        id: "flex",
                        min: 13,
                        resetStack: true
                    },
                    {
                        id: "hflex1",
                        min: 9,
                        resetStack: true
                    },
                    {
                        id: "flex1",
                        min: 11,
                        resetStack: true
                    }
                ];
                class CFFParser {
                    constructor(file, properties, seacAnalysisEnabled){
                        this.bytes = file.getBytes();
                        this.properties = properties;
                        this.seacAnalysisEnabled = !!seacAnalysisEnabled;
                    }
                    parse() {
                        const properties = this.properties;
                        const cff = new CFF();
                        this.cff = cff;
                        const header = this.parseHeader();
                        const nameIndex = this.parseIndex(header.endPos);
                        const topDictIndex = this.parseIndex(nameIndex.endPos);
                        const stringIndex = this.parseIndex(topDictIndex.endPos);
                        const globalSubrIndex = this.parseIndex(stringIndex.endPos);
                        const topDictParsed = this.parseDict(topDictIndex.obj.get(0));
                        const topDict = this.createDict(CFFTopDict, topDictParsed, cff.strings);
                        cff.header = header.obj;
                        cff.names = this.parseNameIndex(nameIndex.obj);
                        cff.strings = this.parseStringIndex(stringIndex.obj);
                        cff.topDict = topDict;
                        cff.globalSubrIndex = globalSubrIndex.obj;
                        this.parsePrivateDict(cff.topDict);
                        cff.isCIDFont = topDict.hasName("ROS");
                        const charStringOffset = topDict.getByName("CharStrings");
                        const charStringIndex = this.parseIndex(charStringOffset).obj;
                        const fontMatrix = topDict.getByName("FontMatrix");
                        if (fontMatrix) properties.fontMatrix = fontMatrix;
                        const fontBBox = topDict.getByName("FontBBox");
                        if (fontBBox) {
                            properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
                            properties.descent = Math.min(fontBBox[1], fontBBox[3]);
                            properties.ascentScaled = true;
                        }
                        let charset, encoding;
                        if (cff.isCIDFont) {
                            const fdArrayIndex = this.parseIndex(topDict.getByName("FDArray")).obj;
                            for(let i = 0, ii = fdArrayIndex.count; i < ii; ++i){
                                const dictRaw = fdArrayIndex.get(i);
                                const fontDict = this.createDict(CFFTopDict, this.parseDict(dictRaw), cff.strings);
                                this.parsePrivateDict(fontDict);
                                cff.fdArray.push(fontDict);
                            }
                            encoding = null;
                            charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, true);
                            cff.fdSelect = this.parseFDSelect(topDict.getByName("FDSelect"), charStringIndex.count);
                        } else {
                            charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, false);
                            encoding = this.parseEncoding(topDict.getByName("Encoding"), properties, cff.strings, charset.charset);
                        }
                        cff.charset = charset;
                        cff.encoding = encoding;
                        const charStringsAndSeacs = this.parseCharStrings({
                            charStrings: charStringIndex,
                            localSubrIndex: topDict.privateDict.subrsIndex,
                            globalSubrIndex: globalSubrIndex.obj,
                            fdSelect: cff.fdSelect,
                            fdArray: cff.fdArray,
                            privateDict: topDict.privateDict
                        });
                        cff.charStrings = charStringsAndSeacs.charStrings;
                        cff.seacs = charStringsAndSeacs.seacs;
                        cff.widths = charStringsAndSeacs.widths;
                        return cff;
                    }
                    parseHeader() {
                        let bytes = this.bytes;
                        const bytesLength = bytes.length;
                        let offset = 0;
                        while(offset < bytesLength && bytes[offset] !== 1)++offset;
                        if (offset >= bytesLength) throw new _util.FormatError("Invalid CFF header");
                        if (offset !== 0) {
                            (0, _util.info)("cff data is shifted");
                            bytes = bytes.subarray(offset);
                            this.bytes = bytes;
                        }
                        const major = bytes[0];
                        const minor = bytes[1];
                        const hdrSize = bytes[2];
                        const offSize = bytes[3];
                        const header = new CFFHeader(major, minor, hdrSize, offSize);
                        return {
                            obj: header,
                            endPos: hdrSize
                        };
                    }
                    parseDict(dict) {
                        let pos = 0;
                        function parseOperand() {
                            let value = dict[pos++];
                            if (value === 30) return parseFloatOperand();
                            else if (value === 28) {
                                value = dict[pos++];
                                value = (value << 24 | dict[pos++] << 16) >> 16;
                                return value;
                            } else if (value === 29) {
                                value = dict[pos++];
                                value = value << 8 | dict[pos++];
                                value = value << 8 | dict[pos++];
                                value = value << 8 | dict[pos++];
                                return value;
                            } else if (value >= 32 && value <= 246) return value - 139;
                            else if (value >= 247 && value <= 250) return (value - 247) * 256 + dict[pos++] + 108;
                            else if (value >= 251 && value <= 254) return -((value - 251) * 256) - dict[pos++] - 108;
                            (0, _util.warn)('CFFParser_parseDict: "' + value + '" is a reserved command.');
                            return NaN;
                        }
                        function parseFloatOperand() {
                            let str = "";
                            const eof = 15;
                            const lookup = [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                ".",
                                "E",
                                "E-",
                                null,
                                "-"
                            ];
                            const length = dict.length;
                            while(pos < length){
                                const b = dict[pos++];
                                const b1 = b >> 4;
                                const b2 = b & 15;
                                if (b1 === eof) break;
                                str += lookup[b1];
                                if (b2 === eof) break;
                                str += lookup[b2];
                            }
                            return parseFloat(str);
                        }
                        let operands = [];
                        const entries = [];
                        pos = 0;
                        const end = dict.length;
                        while(pos < end){
                            let b = dict[pos];
                            if (b <= 21) {
                                if (b === 12) b = b << 8 | dict[++pos];
                                entries.push([
                                    b,
                                    operands
                                ]);
                                operands = [];
                                ++pos;
                            } else operands.push(parseOperand());
                        }
                        return entries;
                    }
                    parseIndex(pos) {
                        const cffIndex = new CFFIndex();
                        const bytes = this.bytes;
                        const count = bytes[pos++] << 8 | bytes[pos++];
                        const offsets = [];
                        let end = pos;
                        let i, ii;
                        if (count !== 0) {
                            const offsetSize = bytes[pos++];
                            const startPos = pos + (count + 1) * offsetSize - 1;
                            for(i = 0, ii = count + 1; i < ii; ++i){
                                let offset = 0;
                                for(let j = 0; j < offsetSize; ++j){
                                    offset <<= 8;
                                    offset += bytes[pos++];
                                }
                                offsets.push(startPos + offset);
                            }
                            end = offsets[count];
                        }
                        for(i = 0, ii = offsets.length - 1; i < ii; ++i){
                            const offsetStart = offsets[i];
                            const offsetEnd = offsets[i + 1];
                            cffIndex.add(bytes.subarray(offsetStart, offsetEnd));
                        }
                        return {
                            obj: cffIndex,
                            endPos: end
                        };
                    }
                    parseNameIndex(index) {
                        const names = [];
                        for(let i = 0, ii = index.count; i < ii; ++i){
                            const name = index.get(i);
                            names.push((0, _util.bytesToString)(name));
                        }
                        return names;
                    }
                    parseStringIndex(index) {
                        const strings = new CFFStrings();
                        for(let i = 0, ii = index.count; i < ii; ++i){
                            const data = index.get(i);
                            strings.add((0, _util.bytesToString)(data));
                        }
                        return strings;
                    }
                    createDict(Type, dict, strings) {
                        const cffDict = new Type(strings);
                        for (const [key, value] of dict)cffDict.setByKey(key, value);
                        return cffDict;
                    }
                    parseCharString(state, data, localSubrIndex, globalSubrIndex) {
                        if (!data || state.callDepth > MAX_SUBR_NESTING) return false;
                        let stackSize = state.stackSize;
                        const stack = state.stack;
                        let length = data.length;
                        for(let j = 0; j < length;){
                            const value = data[j++];
                            let validationCommand = null;
                            if (value === 12) {
                                const q = data[j++];
                                if (q === 0) {
                                    data[j - 2] = 139;
                                    data[j - 1] = 22;
                                    stackSize = 0;
                                } else validationCommand = CharstringValidationData12[q];
                            } else if (value === 28) {
                                stack[stackSize] = (data[j] << 24 | data[j + 1] << 16) >> 16;
                                j += 2;
                                stackSize++;
                            } else if (value === 14) {
                                if (stackSize >= 4) {
                                    stackSize -= 4;
                                    if (this.seacAnalysisEnabled) {
                                        state.seac = stack.slice(stackSize, stackSize + 4);
                                        return false;
                                    }
                                }
                                validationCommand = CharstringValidationData[value];
                            } else if (value >= 32 && value <= 246) {
                                stack[stackSize] = value - 139;
                                stackSize++;
                            } else if (value >= 247 && value <= 254) {
                                stack[stackSize] = value < 251 ? (value - 247 << 8) + data[j] + 108 : -(value - 251 << 8) - data[j] - 108;
                                j++;
                                stackSize++;
                            } else if (value === 255) {
                                stack[stackSize] = (data[j] << 24 | data[j + 1] << 16 | data[j + 2] << 8 | data[j + 3]) / 65536;
                                j += 4;
                                stackSize++;
                            } else if (value === 19 || value === 20) {
                                state.hints += stackSize >> 1;
                                if (state.hints === 0) {
                                    data.copyWithin(j - 1, j, -1);
                                    j -= 1;
                                    length -= 1;
                                    continue;
                                }
                                j += state.hints + 7 >> 3;
                                stackSize %= 2;
                                validationCommand = CharstringValidationData[value];
                            } else if (value === 10 || value === 29) {
                                const subrsIndex = value === 10 ? localSubrIndex : globalSubrIndex;
                                if (!subrsIndex) {
                                    validationCommand = CharstringValidationData[value];
                                    (0, _util.warn)("Missing subrsIndex for " + validationCommand.id);
                                    return false;
                                }
                                let bias = 32768;
                                if (subrsIndex.count < 1240) bias = 107;
                                else if (subrsIndex.count < 33900) bias = 1131;
                                const subrNumber = stack[--stackSize] + bias;
                                if (subrNumber < 0 || subrNumber >= subrsIndex.count || isNaN(subrNumber)) {
                                    validationCommand = CharstringValidationData[value];
                                    (0, _util.warn)("Out of bounds subrIndex for " + validationCommand.id);
                                    return false;
                                }
                                state.stackSize = stackSize;
                                state.callDepth++;
                                const valid = this.parseCharString(state, subrsIndex.get(subrNumber), localSubrIndex, globalSubrIndex);
                                if (!valid) return false;
                                state.callDepth--;
                                stackSize = state.stackSize;
                                continue;
                            } else if (value === 11) {
                                state.stackSize = stackSize;
                                return true;
                            } else if (value === 0 && j === data.length) {
                                data[j - 1] = 14;
                                validationCommand = CharstringValidationData[14];
                            } else if (value === 9) {
                                data.copyWithin(j - 1, j, -1);
                                j -= 1;
                                length -= 1;
                                continue;
                            } else validationCommand = CharstringValidationData[value];
                            if (validationCommand) {
                                if (validationCommand.stem) {
                                    state.hints += stackSize >> 1;
                                    if (value === 3 || value === 23) state.hasVStems = true;
                                    else if (state.hasVStems && (value === 1 || value === 18)) {
                                        (0, _util.warn)("CFF stem hints are in wrong order");
                                        data[j - 1] = value === 1 ? 3 : 23;
                                    }
                                }
                                if ("min" in validationCommand) {
                                    if (!state.undefStack && stackSize < validationCommand.min) {
                                        (0, _util.warn)("Not enough parameters for " + validationCommand.id + "; actual: " + stackSize + ", expected: " + validationCommand.min);
                                        if (stackSize === 0) {
                                            data[j - 1] = 14;
                                            return true;
                                        }
                                        return false;
                                    }
                                }
                                if (state.firstStackClearing && validationCommand.stackClearing) {
                                    state.firstStackClearing = false;
                                    stackSize -= validationCommand.min;
                                    if (stackSize >= 2 && validationCommand.stem) stackSize %= 2;
                                    else if (stackSize > 1) (0, _util.warn)("Found too many parameters for stack-clearing command");
                                    if (stackSize > 0) state.width = stack[stackSize - 1];
                                }
                                if ("stackDelta" in validationCommand) {
                                    if ("stackFn" in validationCommand) validationCommand.stackFn(stack, stackSize);
                                    stackSize += validationCommand.stackDelta;
                                } else if (validationCommand.stackClearing) stackSize = 0;
                                else if (validationCommand.resetStack) {
                                    stackSize = 0;
                                    state.undefStack = false;
                                } else if (validationCommand.undefStack) {
                                    stackSize = 0;
                                    state.undefStack = true;
                                    state.firstStackClearing = false;
                                }
                            }
                        }
                        if (length < data.length) data.fill(14, length);
                        state.stackSize = stackSize;
                        return true;
                    }
                    parseCharStrings({ charStrings: charStrings, localSubrIndex: localSubrIndex, globalSubrIndex: globalSubrIndex, fdSelect: fdSelect, fdArray: fdArray, privateDict: privateDict }) {
                        const seacs = [];
                        const widths = [];
                        const count = charStrings.count;
                        for(let i = 0; i < count; i++){
                            const charstring = charStrings.get(i);
                            const state = {
                                callDepth: 0,
                                stackSize: 0,
                                stack: [],
                                undefStack: true,
                                hints: 0,
                                firstStackClearing: true,
                                seac: null,
                                width: null,
                                hasVStems: false
                            };
                            let valid = true;
                            let localSubrToUse = null;
                            let privateDictToUse = privateDict;
                            if (fdSelect && fdArray.length) {
                                const fdIndex = fdSelect.getFDIndex(i);
                                if (fdIndex === -1) {
                                    (0, _util.warn)("Glyph index is not in fd select.");
                                    valid = false;
                                }
                                if (fdIndex >= fdArray.length) {
                                    (0, _util.warn)("Invalid fd index for glyph index.");
                                    valid = false;
                                }
                                if (valid) {
                                    privateDictToUse = fdArray[fdIndex].privateDict;
                                    localSubrToUse = privateDictToUse.subrsIndex;
                                }
                            } else if (localSubrIndex) localSubrToUse = localSubrIndex;
                            if (valid) valid = this.parseCharString(state, charstring, localSubrToUse, globalSubrIndex);
                            if (state.width !== null) {
                                const nominalWidth = privateDictToUse.getByName("nominalWidthX");
                                widths[i] = nominalWidth + state.width;
                            } else {
                                const defaultWidth = privateDictToUse.getByName("defaultWidthX");
                                widths[i] = defaultWidth;
                            }
                            if (state.seac !== null) seacs[i] = state.seac;
                            if (!valid) charStrings.set(i, new Uint8Array([
                                14
                            ]));
                        }
                        return {
                            charStrings: charStrings,
                            seacs: seacs,
                            widths: widths
                        };
                    }
                    emptyPrivateDictionary(parentDict) {
                        const privateDict = this.createDict(CFFPrivateDict, [], parentDict.strings);
                        parentDict.setByKey(18, [
                            0,
                            0
                        ]);
                        parentDict.privateDict = privateDict;
                    }
                    parsePrivateDict(parentDict) {
                        if (!parentDict.hasName("Private")) {
                            this.emptyPrivateDictionary(parentDict);
                            return;
                        }
                        const privateOffset = parentDict.getByName("Private");
                        if (!Array.isArray(privateOffset) || privateOffset.length !== 2) {
                            parentDict.removeByName("Private");
                            return;
                        }
                        const size = privateOffset[0];
                        const offset = privateOffset[1];
                        if (size === 0 || offset >= this.bytes.length) {
                            this.emptyPrivateDictionary(parentDict);
                            return;
                        }
                        const privateDictEnd = offset + size;
                        const dictData = this.bytes.subarray(offset, privateDictEnd);
                        const dict = this.parseDict(dictData);
                        const privateDict = this.createDict(CFFPrivateDict, dict, parentDict.strings);
                        parentDict.privateDict = privateDict;
                        if (privateDict.getByName("ExpansionFactor") === 0) privateDict.setByName("ExpansionFactor", 0.06);
                        if (!privateDict.getByName("Subrs")) return;
                        const subrsOffset = privateDict.getByName("Subrs");
                        const relativeOffset = offset + subrsOffset;
                        if (subrsOffset === 0 || relativeOffset >= this.bytes.length) {
                            this.emptyPrivateDictionary(parentDict);
                            return;
                        }
                        const subrsIndex = this.parseIndex(relativeOffset);
                        privateDict.subrsIndex = subrsIndex.obj;
                    }
                    parseCharsets(pos, length, strings, cid) {
                        if (pos === 0) return new CFFCharset(true, CFFCharsetPredefinedTypes.ISO_ADOBE, _charsets.ISOAdobeCharset);
                        else if (pos === 1) return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT, _charsets.ExpertCharset);
                        else if (pos === 2) return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT_SUBSET, _charsets.ExpertSubsetCharset);
                        const bytes = this.bytes;
                        const start = pos;
                        const format = bytes[pos++];
                        const charset = [
                            cid ? 0 : ".notdef"
                        ];
                        let id, count, i;
                        length -= 1;
                        switch(format){
                            case 0:
                                for(i = 0; i < length; i++){
                                    id = bytes[pos++] << 8 | bytes[pos++];
                                    charset.push(cid ? id : strings.get(id));
                                }
                                break;
                            case 1:
                                while(charset.length <= length){
                                    id = bytes[pos++] << 8 | bytes[pos++];
                                    count = bytes[pos++];
                                    for(i = 0; i <= count; i++)charset.push(cid ? id++ : strings.get(id++));
                                }
                                break;
                            case 2:
                                while(charset.length <= length){
                                    id = bytes[pos++] << 8 | bytes[pos++];
                                    count = bytes[pos++] << 8 | bytes[pos++];
                                    for(i = 0; i <= count; i++)charset.push(cid ? id++ : strings.get(id++));
                                }
                                break;
                            default:
                                throw new _util.FormatError("Unknown charset format");
                        }
                        const end = pos;
                        const raw = bytes.subarray(start, end);
                        return new CFFCharset(false, format, charset, raw);
                    }
                    parseEncoding(pos, properties, strings, charset) {
                        const encoding = Object.create(null);
                        const bytes = this.bytes;
                        let predefined = false;
                        let format, i, ii;
                        let raw = null;
                        function readSupplement() {
                            const supplementsCount = bytes[pos++];
                            for(i = 0; i < supplementsCount; i++){
                                const code = bytes[pos++];
                                const sid = (bytes[pos++] << 8) + (bytes[pos++] & 0xff);
                                encoding[code] = charset.indexOf(strings.get(sid));
                            }
                        }
                        if (pos === 0 || pos === 1) {
                            predefined = true;
                            format = pos;
                            const baseEncoding = pos ? _encodings.ExpertEncoding : _encodings.StandardEncoding;
                            for(i = 0, ii = charset.length; i < ii; i++){
                                const index = baseEncoding.indexOf(charset[i]);
                                if (index !== -1) encoding[index] = i;
                            }
                        } else {
                            const dataStart = pos;
                            format = bytes[pos++];
                            switch(format & 0x7f){
                                case 0:
                                    const glyphsCount = bytes[pos++];
                                    for(i = 1; i <= glyphsCount; i++)encoding[bytes[pos++]] = i;
                                    break;
                                case 1:
                                    const rangesCount = bytes[pos++];
                                    let gid = 1;
                                    for(i = 0; i < rangesCount; i++){
                                        const start = bytes[pos++];
                                        const left = bytes[pos++];
                                        for(let j = start; j <= start + left; j++)encoding[j] = gid++;
                                    }
                                    break;
                                default:
                                    throw new _util.FormatError(`Unknown encoding format: ${format} in CFF`);
                            }
                            const dataEnd = pos;
                            if (format & 0x80) {
                                bytes[dataStart] &= 0x7f;
                                readSupplement();
                            }
                            raw = bytes.subarray(dataStart, dataEnd);
                        }
                        format &= 0x7f;
                        return new CFFEncoding(predefined, format, encoding, raw);
                    }
                    parseFDSelect(pos, length) {
                        const bytes = this.bytes;
                        const format = bytes[pos++];
                        const fdSelect = [];
                        let i;
                        switch(format){
                            case 0:
                                for(i = 0; i < length; ++i){
                                    const id = bytes[pos++];
                                    fdSelect.push(id);
                                }
                                break;
                            case 3:
                                const rangesCount = bytes[pos++] << 8 | bytes[pos++];
                                for(i = 0; i < rangesCount; ++i){
                                    let first = bytes[pos++] << 8 | bytes[pos++];
                                    if (i === 0 && first !== 0) {
                                        (0, _util.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover.");
                                        first = 0;
                                    }
                                    const fdIndex = bytes[pos++];
                                    const next = bytes[pos] << 8 | bytes[pos + 1];
                                    for(let j = first; j < next; ++j)fdSelect.push(fdIndex);
                                }
                                pos += 2;
                                break;
                            default:
                                throw new _util.FormatError(`parseFDSelect: Unknown format "${format}".`);
                        }
                        if (fdSelect.length !== length) throw new _util.FormatError("parseFDSelect: Invalid font data.");
                        return new CFFFDSelect(format, fdSelect);
                    }
                }
                exports.CFFParser = CFFParser;
                class CFF {
                    constructor(){
                        this.header = null;
                        this.names = [];
                        this.topDict = null;
                        this.strings = new CFFStrings();
                        this.globalSubrIndex = null;
                        this.encoding = null;
                        this.charset = null;
                        this.charStrings = null;
                        this.fdArray = [];
                        this.fdSelect = null;
                        this.isCIDFont = false;
                    }
                    duplicateFirstGlyph() {
                        if (this.charStrings.count >= 65535) {
                            (0, _util.warn)("Not enough space in charstrings to duplicate first glyph.");
                            return;
                        }
                        const glyphZero = this.charStrings.get(0);
                        this.charStrings.add(glyphZero);
                        if (this.isCIDFont) this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
                    }
                    hasGlyphId(id) {
                        if (id < 0 || id >= this.charStrings.count) return false;
                        const glyph = this.charStrings.get(id);
                        return glyph.length > 0;
                    }
                }
                exports.CFF = CFF;
                class CFFHeader {
                    constructor(major, minor, hdrSize, offSize){
                        this.major = major;
                        this.minor = minor;
                        this.hdrSize = hdrSize;
                        this.offSize = offSize;
                    }
                }
                exports.CFFHeader = CFFHeader;
                class CFFStrings {
                    constructor(){
                        this.strings = [];
                    }
                    get(index) {
                        if (index >= 0 && index <= NUM_STANDARD_CFF_STRINGS - 1) return CFFStandardStrings[index];
                        if (index - NUM_STANDARD_CFF_STRINGS <= this.strings.length) return this.strings[index - NUM_STANDARD_CFF_STRINGS];
                        return CFFStandardStrings[0];
                    }
                    getSID(str) {
                        let index = CFFStandardStrings.indexOf(str);
                        if (index !== -1) return index;
                        index = this.strings.indexOf(str);
                        if (index !== -1) return index + NUM_STANDARD_CFF_STRINGS;
                        return -1;
                    }
                    add(value) {
                        this.strings.push(value);
                    }
                    get count() {
                        return this.strings.length;
                    }
                }
                exports.CFFStrings = CFFStrings;
                class CFFIndex {
                    constructor(){
                        this.objects = [];
                        this.length = 0;
                    }
                    add(data) {
                        this.length += data.length;
                        this.objects.push(data);
                    }
                    set(index, data) {
                        this.length += data.length - this.objects[index].length;
                        this.objects[index] = data;
                    }
                    get(index) {
                        return this.objects[index];
                    }
                    get count() {
                        return this.objects.length;
                    }
                }
                exports.CFFIndex = CFFIndex;
                class CFFDict {
                    constructor(tables, strings){
                        this.keyToNameMap = tables.keyToNameMap;
                        this.nameToKeyMap = tables.nameToKeyMap;
                        this.defaults = tables.defaults;
                        this.types = tables.types;
                        this.opcodes = tables.opcodes;
                        this.order = tables.order;
                        this.strings = strings;
                        this.values = Object.create(null);
                    }
                    setByKey(key, value) {
                        if (!(key in this.keyToNameMap)) return false;
                        if (value.length === 0) return true;
                        for (const val of value)if (isNaN(val)) {
                            (0, _util.warn)(`Invalid CFFDict value: "${value}" for key "${key}".`);
                            return true;
                        }
                        const type = this.types[key];
                        if (type === "num" || type === "sid" || type === "offset") value = value[0];
                        this.values[key] = value;
                        return true;
                    }
                    setByName(name, value) {
                        if (!(name in this.nameToKeyMap)) throw new _util.FormatError(`Invalid dictionary name "${name}"`);
                        this.values[this.nameToKeyMap[name]] = value;
                    }
                    hasName(name) {
                        return this.nameToKeyMap[name] in this.values;
                    }
                    getByName(name) {
                        if (!(name in this.nameToKeyMap)) throw new _util.FormatError(`Invalid dictionary name ${name}"`);
                        const key = this.nameToKeyMap[name];
                        if (!(key in this.values)) return this.defaults[key];
                        return this.values[key];
                    }
                    removeByName(name) {
                        delete this.values[this.nameToKeyMap[name]];
                    }
                    static createTables(layout) {
                        const tables = {
                            keyToNameMap: {},
                            nameToKeyMap: {},
                            defaults: {},
                            types: {},
                            opcodes: {},
                            order: []
                        };
                        for (const entry of layout){
                            const key = Array.isArray(entry[0]) ? (entry[0][0] << 8) + entry[0][1] : entry[0];
                            tables.keyToNameMap[key] = entry[1];
                            tables.nameToKeyMap[entry[1]] = key;
                            tables.types[key] = entry[2];
                            tables.defaults[key] = entry[3];
                            tables.opcodes[key] = Array.isArray(entry[0]) ? entry[0] : [
                                entry[0]
                            ];
                            tables.order.push(key);
                        }
                        return tables;
                    }
                }
                const CFFTopDictLayout = [
                    [
                        [
                            12,
                            30
                        ],
                        "ROS",
                        [
                            "sid",
                            "sid",
                            "num"
                        ],
                        null
                    ],
                    [
                        [
                            12,
                            20
                        ],
                        "SyntheticBase",
                        "num",
                        null
                    ],
                    [
                        0,
                        "version",
                        "sid",
                        null
                    ],
                    [
                        1,
                        "Notice",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            0
                        ],
                        "Copyright",
                        "sid",
                        null
                    ],
                    [
                        2,
                        "FullName",
                        "sid",
                        null
                    ],
                    [
                        3,
                        "FamilyName",
                        "sid",
                        null
                    ],
                    [
                        4,
                        "Weight",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            1
                        ],
                        "isFixedPitch",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            2
                        ],
                        "ItalicAngle",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            3
                        ],
                        "UnderlinePosition",
                        "num",
                        -100
                    ],
                    [
                        [
                            12,
                            4
                        ],
                        "UnderlineThickness",
                        "num",
                        50
                    ],
                    [
                        [
                            12,
                            5
                        ],
                        "PaintType",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            6
                        ],
                        "CharstringType",
                        "num",
                        2
                    ],
                    [
                        [
                            12,
                            7
                        ],
                        "FontMatrix",
                        [
                            "num",
                            "num",
                            "num",
                            "num",
                            "num",
                            "num"
                        ],
                        [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]
                    ],
                    [
                        13,
                        "UniqueID",
                        "num",
                        null
                    ],
                    [
                        5,
                        "FontBBox",
                        [
                            "num",
                            "num",
                            "num",
                            "num"
                        ],
                        [
                            0,
                            0,
                            0,
                            0
                        ]
                    ],
                    [
                        [
                            12,
                            8
                        ],
                        "StrokeWidth",
                        "num",
                        0
                    ],
                    [
                        14,
                        "XUID",
                        "array",
                        null
                    ],
                    [
                        15,
                        "charset",
                        "offset",
                        0
                    ],
                    [
                        16,
                        "Encoding",
                        "offset",
                        0
                    ],
                    [
                        17,
                        "CharStrings",
                        "offset",
                        0
                    ],
                    [
                        18,
                        "Private",
                        [
                            "offset",
                            "offset"
                        ],
                        null
                    ],
                    [
                        [
                            12,
                            21
                        ],
                        "PostScript",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            22
                        ],
                        "BaseFontName",
                        "sid",
                        null
                    ],
                    [
                        [
                            12,
                            23
                        ],
                        "BaseFontBlend",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            31
                        ],
                        "CIDFontVersion",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            32
                        ],
                        "CIDFontRevision",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            33
                        ],
                        "CIDFontType",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            34
                        ],
                        "CIDCount",
                        "num",
                        8720
                    ],
                    [
                        [
                            12,
                            35
                        ],
                        "UIDBase",
                        "num",
                        null
                    ],
                    [
                        [
                            12,
                            37
                        ],
                        "FDSelect",
                        "offset",
                        null
                    ],
                    [
                        [
                            12,
                            36
                        ],
                        "FDArray",
                        "offset",
                        null
                    ],
                    [
                        [
                            12,
                            38
                        ],
                        "FontName",
                        "sid",
                        null
                    ]
                ];
                class CFFTopDict extends CFFDict {
                    static get tables() {
                        return (0, _util.shadow)(this, "tables", this.createTables(CFFTopDictLayout));
                    }
                    constructor(strings){
                        super(CFFTopDict.tables, strings);
                        this.privateDict = null;
                    }
                }
                exports.CFFTopDict = CFFTopDict;
                const CFFPrivateDictLayout = [
                    [
                        6,
                        "BlueValues",
                        "delta",
                        null
                    ],
                    [
                        7,
                        "OtherBlues",
                        "delta",
                        null
                    ],
                    [
                        8,
                        "FamilyBlues",
                        "delta",
                        null
                    ],
                    [
                        9,
                        "FamilyOtherBlues",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            9
                        ],
                        "BlueScale",
                        "num",
                        0.039625
                    ],
                    [
                        [
                            12,
                            10
                        ],
                        "BlueShift",
                        "num",
                        7
                    ],
                    [
                        [
                            12,
                            11
                        ],
                        "BlueFuzz",
                        "num",
                        1
                    ],
                    [
                        10,
                        "StdHW",
                        "num",
                        null
                    ],
                    [
                        11,
                        "StdVW",
                        "num",
                        null
                    ],
                    [
                        [
                            12,
                            12
                        ],
                        "StemSnapH",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            13
                        ],
                        "StemSnapV",
                        "delta",
                        null
                    ],
                    [
                        [
                            12,
                            14
                        ],
                        "ForceBold",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            17
                        ],
                        "LanguageGroup",
                        "num",
                        0
                    ],
                    [
                        [
                            12,
                            18
                        ],
                        "ExpansionFactor",
                        "num",
                        0.06
                    ],
                    [
                        [
                            12,
                            19
                        ],
                        "initialRandomSeed",
                        "num",
                        0
                    ],
                    [
                        20,
                        "defaultWidthX",
                        "num",
                        0
                    ],
                    [
                        21,
                        "nominalWidthX",
                        "num",
                        0
                    ],
                    [
                        19,
                        "Subrs",
                        "offset",
                        null
                    ]
                ];
                class CFFPrivateDict extends CFFDict {
                    static get tables() {
                        return (0, _util.shadow)(this, "tables", this.createTables(CFFPrivateDictLayout));
                    }
                    constructor(strings){
                        super(CFFPrivateDict.tables, strings);
                        this.subrsIndex = null;
                    }
                }
                exports.CFFPrivateDict = CFFPrivateDict;
                const CFFCharsetPredefinedTypes = {
                    ISO_ADOBE: 0,
                    EXPERT: 1,
                    EXPERT_SUBSET: 2
                };
                class CFFCharset {
                    constructor(predefined, format, charset, raw){
                        this.predefined = predefined;
                        this.format = format;
                        this.charset = charset;
                        this.raw = raw;
                    }
                }
                exports.CFFCharset = CFFCharset;
                class CFFEncoding {
                    constructor(predefined, format, encoding, raw){
                        this.predefined = predefined;
                        this.format = format;
                        this.encoding = encoding;
                        this.raw = raw;
                    }
                }
                class CFFFDSelect {
                    constructor(format, fdSelect){
                        this.format = format;
                        this.fdSelect = fdSelect;
                    }
                    getFDIndex(glyphIndex) {
                        if (glyphIndex < 0 || glyphIndex >= this.fdSelect.length) return -1;
                        return this.fdSelect[glyphIndex];
                    }
                }
                exports.CFFFDSelect = CFFFDSelect;
                class CFFOffsetTracker {
                    constructor(){
                        this.offsets = Object.create(null);
                    }
                    isTracking(key) {
                        return key in this.offsets;
                    }
                    track(key, location) {
                        if (key in this.offsets) throw new _util.FormatError(`Already tracking location of ${key}`);
                        this.offsets[key] = location;
                    }
                    offset(value) {
                        for(const key in this.offsets)this.offsets[key] += value;
                    }
                    setEntryLocation(key, values, output) {
                        if (!(key in this.offsets)) throw new _util.FormatError(`Not tracking location of ${key}`);
                        const data = output.data;
                        const dataOffset = this.offsets[key];
                        const size = 5;
                        for(let i = 0, ii = values.length; i < ii; ++i){
                            const offset0 = i * size + dataOffset;
                            const offset1 = offset0 + 1;
                            const offset2 = offset0 + 2;
                            const offset3 = offset0 + 3;
                            const offset4 = offset0 + 4;
                            if (data[offset0] !== 0x1d || data[offset1] !== 0 || data[offset2] !== 0 || data[offset3] !== 0 || data[offset4] !== 0) throw new _util.FormatError("writing to an offset that is not empty");
                            const value = values[i];
                            data[offset0] = 0x1d;
                            data[offset1] = value >> 24 & 0xff;
                            data[offset2] = value >> 16 & 0xff;
                            data[offset3] = value >> 8 & 0xff;
                            data[offset4] = value & 0xff;
                        }
                    }
                }
                class CFFCompiler {
                    constructor(cff){
                        this.cff = cff;
                    }
                    compile() {
                        const cff = this.cff;
                        const output = {
                            data: [],
                            length: 0,
                            add (data) {
                                try {
                                    this.data.push(...data);
                                } catch  {
                                    this.data = this.data.concat(data);
                                }
                                this.length = this.data.length;
                            }
                        };
                        const header = this.compileHeader(cff.header);
                        output.add(header);
                        const nameIndex = this.compileNameIndex(cff.names);
                        output.add(nameIndex);
                        if (cff.isCIDFont) {
                            if (cff.topDict.hasName("FontMatrix")) {
                                const base = cff.topDict.getByName("FontMatrix");
                                cff.topDict.removeByName("FontMatrix");
                                for (const subDict of cff.fdArray){
                                    let matrix = base.slice(0);
                                    if (subDict.hasName("FontMatrix")) matrix = _util.Util.transform(matrix, subDict.getByName("FontMatrix"));
                                    subDict.setByName("FontMatrix", matrix);
                                }
                            }
                        }
                        const xuid = cff.topDict.getByName("XUID");
                        if (xuid?.length > 16) cff.topDict.removeByName("XUID");
                        cff.topDict.setByName("charset", 0);
                        let compiled = this.compileTopDicts([
                            cff.topDict
                        ], output.length, cff.isCIDFont);
                        output.add(compiled.output);
                        const topDictTracker = compiled.trackers[0];
                        const stringIndex = this.compileStringIndex(cff.strings.strings);
                        output.add(stringIndex);
                        const globalSubrIndex = this.compileIndex(cff.globalSubrIndex);
                        output.add(globalSubrIndex);
                        if (cff.encoding && cff.topDict.hasName("Encoding")) {
                            if (cff.encoding.predefined) topDictTracker.setEntryLocation("Encoding", [
                                cff.encoding.format
                            ], output);
                            else {
                                const encoding = this.compileEncoding(cff.encoding);
                                topDictTracker.setEntryLocation("Encoding", [
                                    output.length
                                ], output);
                                output.add(encoding);
                            }
                        }
                        const charset = this.compileCharset(cff.charset, cff.charStrings.count, cff.strings, cff.isCIDFont);
                        topDictTracker.setEntryLocation("charset", [
                            output.length
                        ], output);
                        output.add(charset);
                        const charStrings = this.compileCharStrings(cff.charStrings);
                        topDictTracker.setEntryLocation("CharStrings", [
                            output.length
                        ], output);
                        output.add(charStrings);
                        if (cff.isCIDFont) {
                            topDictTracker.setEntryLocation("FDSelect", [
                                output.length
                            ], output);
                            const fdSelect = this.compileFDSelect(cff.fdSelect);
                            output.add(fdSelect);
                            compiled = this.compileTopDicts(cff.fdArray, output.length, true);
                            topDictTracker.setEntryLocation("FDArray", [
                                output.length
                            ], output);
                            output.add(compiled.output);
                            const fontDictTrackers = compiled.trackers;
                            this.compilePrivateDicts(cff.fdArray, fontDictTrackers, output);
                        }
                        this.compilePrivateDicts([
                            cff.topDict
                        ], [
                            topDictTracker
                        ], output);
                        output.add([
                            0
                        ]);
                        return output.data;
                    }
                    encodeNumber(value) {
                        if (Number.isInteger(value)) return this.encodeInteger(value);
                        return this.encodeFloat(value);
                    }
                    static get EncodeFloatRegExp() {
                        return (0, _util.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
                    }
                    encodeFloat(num) {
                        let value = num.toString();
                        const m = CFFCompiler.EncodeFloatRegExp.exec(value);
                        if (m) {
                            const epsilon = parseFloat("1e" + ((m[2] ? +m[2] : 0) + m[1].length));
                            value = (Math.round(num * epsilon) / epsilon).toString();
                        }
                        let nibbles = "";
                        let i, ii;
                        for(i = 0, ii = value.length; i < ii; ++i){
                            const a = value[i];
                            if (a === "e") nibbles += value[++i] === "-" ? "c" : "b";
                            else if (a === ".") nibbles += "a";
                            else if (a === "-") nibbles += "e";
                            else nibbles += a;
                        }
                        nibbles += nibbles.length & 1 ? "f" : "ff";
                        const out = [
                            30
                        ];
                        for(i = 0, ii = nibbles.length; i < ii; i += 2)out.push(parseInt(nibbles.substring(i, i + 2), 16));
                        return out;
                    }
                    encodeInteger(value) {
                        let code;
                        if (value >= -107 && value <= 107) code = [
                            value + 139
                        ];
                        else if (value >= 108 && value <= 1131) {
                            value -= 108;
                            code = [
                                (value >> 8) + 247,
                                value & 0xff
                            ];
                        } else if (value >= -1131 && value <= -108) {
                            value = -value - 108;
                            code = [
                                (value >> 8) + 251,
                                value & 0xff
                            ];
                        } else if (value >= -32768 && value <= 32767) code = [
                            0x1c,
                            value >> 8 & 0xff,
                            value & 0xff
                        ];
                        else code = [
                            0x1d,
                            value >> 24 & 0xff,
                            value >> 16 & 0xff,
                            value >> 8 & 0xff,
                            value & 0xff
                        ];
                        return code;
                    }
                    compileHeader(header) {
                        return [
                            header.major,
                            header.minor,
                            4,
                            header.offSize
                        ];
                    }
                    compileNameIndex(names) {
                        const nameIndex = new CFFIndex();
                        for (const name of names){
                            const length = Math.min(name.length, 127);
                            let sanitizedName = new Array(length);
                            for(let j = 0; j < length; j++){
                                let char = name[j];
                                if (char < "!" || char > "~" || char === "[" || char === "]" || char === "(" || char === ")" || char === "{" || char === "}" || char === "<" || char === ">" || char === "/" || char === "%") char = "_";
                                sanitizedName[j] = char;
                            }
                            sanitizedName = sanitizedName.join("");
                            if (sanitizedName === "") sanitizedName = "Bad_Font_Name";
                            nameIndex.add((0, _util.stringToBytes)(sanitizedName));
                        }
                        return this.compileIndex(nameIndex);
                    }
                    compileTopDicts(dicts, length, removeCidKeys) {
                        const fontDictTrackers = [];
                        let fdArrayIndex = new CFFIndex();
                        for (const fontDict of dicts){
                            if (removeCidKeys) {
                                fontDict.removeByName("CIDFontVersion");
                                fontDict.removeByName("CIDFontRevision");
                                fontDict.removeByName("CIDFontType");
                                fontDict.removeByName("CIDCount");
                                fontDict.removeByName("UIDBase");
                            }
                            const fontDictTracker = new CFFOffsetTracker();
                            const fontDictData = this.compileDict(fontDict, fontDictTracker);
                            fontDictTrackers.push(fontDictTracker);
                            fdArrayIndex.add(fontDictData);
                            fontDictTracker.offset(length);
                        }
                        fdArrayIndex = this.compileIndex(fdArrayIndex, fontDictTrackers);
                        return {
                            trackers: fontDictTrackers,
                            output: fdArrayIndex
                        };
                    }
                    compilePrivateDicts(dicts, trackers, output) {
                        for(let i = 0, ii = dicts.length; i < ii; ++i){
                            const fontDict = dicts[i];
                            const privateDict = fontDict.privateDict;
                            if (!privateDict || !fontDict.hasName("Private")) throw new _util.FormatError("There must be a private dictionary.");
                            const privateDictTracker = new CFFOffsetTracker();
                            const privateDictData = this.compileDict(privateDict, privateDictTracker);
                            let outputLength = output.length;
                            privateDictTracker.offset(outputLength);
                            if (!privateDictData.length) outputLength = 0;
                            trackers[i].setEntryLocation("Private", [
                                privateDictData.length,
                                outputLength
                            ], output);
                            output.add(privateDictData);
                            if (privateDict.subrsIndex && privateDict.hasName("Subrs")) {
                                const subrs = this.compileIndex(privateDict.subrsIndex);
                                privateDictTracker.setEntryLocation("Subrs", [
                                    privateDictData.length
                                ], output);
                                output.add(subrs);
                            }
                        }
                    }
                    compileDict(dict, offsetTracker) {
                        const out = [];
                        for (const key of dict.order){
                            if (!(key in dict.values)) continue;
                            let values = dict.values[key];
                            let types = dict.types[key];
                            if (!Array.isArray(types)) types = [
                                types
                            ];
                            if (!Array.isArray(values)) values = [
                                values
                            ];
                            if (values.length === 0) continue;
                            for(let j = 0, jj = types.length; j < jj; ++j){
                                const type = types[j];
                                const value = values[j];
                                switch(type){
                                    case "num":
                                    case "sid":
                                        out.push(...this.encodeNumber(value));
                                        break;
                                    case "offset":
                                        const name = dict.keyToNameMap[key];
                                        if (!offsetTracker.isTracking(name)) offsetTracker.track(name, out.length);
                                        out.push(0x1d, 0, 0, 0, 0);
                                        break;
                                    case "array":
                                    case "delta":
                                        out.push(...this.encodeNumber(value));
                                        for(let k = 1, kk = values.length; k < kk; ++k)out.push(...this.encodeNumber(values[k]));
                                        break;
                                    default:
                                        throw new _util.FormatError(`Unknown data type of ${type}`);
                                }
                            }
                            out.push(...dict.opcodes[key]);
                        }
                        return out;
                    }
                    compileStringIndex(strings) {
                        const stringIndex = new CFFIndex();
                        for (const string of strings)stringIndex.add((0, _util.stringToBytes)(string));
                        return this.compileIndex(stringIndex);
                    }
                    compileCharStrings(charStrings) {
                        const charStringsIndex = new CFFIndex();
                        for(let i = 0; i < charStrings.count; i++){
                            const glyph = charStrings.get(i);
                            if (glyph.length === 0) {
                                charStringsIndex.add(new Uint8Array([
                                    0x8b,
                                    0x0e
                                ]));
                                continue;
                            }
                            charStringsIndex.add(glyph);
                        }
                        return this.compileIndex(charStringsIndex);
                    }
                    compileCharset(charset, numGlyphs, strings, isCIDFont) {
                        let out;
                        const numGlyphsLessNotDef = numGlyphs - 1;
                        if (isCIDFont) out = new Uint8Array([
                            2,
                            0,
                            0,
                            numGlyphsLessNotDef >> 8 & 0xff,
                            numGlyphsLessNotDef & 0xff
                        ]);
                        else {
                            const length = 1 + numGlyphsLessNotDef * 2;
                            out = new Uint8Array(length);
                            out[0] = 0;
                            let charsetIndex = 0;
                            const numCharsets = charset.charset.length;
                            let warned = false;
                            for(let i = 1; i < out.length; i += 2){
                                let sid = 0;
                                if (charsetIndex < numCharsets) {
                                    const name = charset.charset[charsetIndex++];
                                    sid = strings.getSID(name);
                                    if (sid === -1) {
                                        sid = 0;
                                        if (!warned) {
                                            warned = true;
                                            (0, _util.warn)(`Couldn't find ${name} in CFF strings`);
                                        }
                                    }
                                }
                                out[i] = sid >> 8 & 0xff;
                                out[i + 1] = sid & 0xff;
                            }
                        }
                        return this.compileTypedArray(out);
                    }
                    compileEncoding(encoding) {
                        return this.compileTypedArray(encoding.raw);
                    }
                    compileFDSelect(fdSelect) {
                        const format = fdSelect.format;
                        let out, i;
                        switch(format){
                            case 0:
                                out = new Uint8Array(1 + fdSelect.fdSelect.length);
                                out[0] = format;
                                for(i = 0; i < fdSelect.fdSelect.length; i++)out[i + 1] = fdSelect.fdSelect[i];
                                break;
                            case 3:
                                const start = 0;
                                let lastFD = fdSelect.fdSelect[0];
                                const ranges = [
                                    format,
                                    0,
                                    0,
                                    start >> 8 & 0xff,
                                    start & 0xff,
                                    lastFD
                                ];
                                for(i = 1; i < fdSelect.fdSelect.length; i++){
                                    const currentFD = fdSelect.fdSelect[i];
                                    if (currentFD !== lastFD) {
                                        ranges.push(i >> 8 & 0xff, i & 0xff, currentFD);
                                        lastFD = currentFD;
                                    }
                                }
                                const numRanges = (ranges.length - 3) / 3;
                                ranges[1] = numRanges >> 8 & 0xff;
                                ranges[2] = numRanges & 0xff;
                                ranges.push(i >> 8 & 0xff, i & 0xff);
                                out = new Uint8Array(ranges);
                                break;
                        }
                        return this.compileTypedArray(out);
                    }
                    compileTypedArray(data) {
                        return Array.from(data);
                    }
                    compileIndex(index, trackers = []) {
                        const objects = index.objects;
                        const count = objects.length;
                        if (count === 0) return [
                            0,
                            0
                        ];
                        const data = [
                            count >> 8 & 0xff,
                            count & 0xff
                        ];
                        let lastOffset = 1, i;
                        for(i = 0; i < count; ++i)lastOffset += objects[i].length;
                        let offsetSize;
                        if (lastOffset < 0x100) offsetSize = 1;
                        else if (lastOffset < 0x10000) offsetSize = 2;
                        else if (lastOffset < 0x1000000) offsetSize = 3;
                        else offsetSize = 4;
                        data.push(offsetSize);
                        let relativeOffset = 1;
                        for(i = 0; i < count + 1; i++){
                            if (offsetSize === 1) data.push(relativeOffset & 0xff);
                            else if (offsetSize === 2) data.push(relativeOffset >> 8 & 0xff, relativeOffset & 0xff);
                            else if (offsetSize === 3) data.push(relativeOffset >> 16 & 0xff, relativeOffset >> 8 & 0xff, relativeOffset & 0xff);
                            else data.push(relativeOffset >>> 24 & 0xff, relativeOffset >> 16 & 0xff, relativeOffset >> 8 & 0xff, relativeOffset & 0xff);
                            if (objects[i]) relativeOffset += objects[i].length;
                        }
                        for(i = 0; i < count; i++){
                            if (trackers[i]) trackers[i].offset(data.length);
                            data.push(...objects[i]);
                        }
                        return data;
                    }
                }
                exports.CFFCompiler = CFFCompiler;
            /***/ },
            /* 36 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ISOAdobeCharset = exports.ExpertSubsetCharset = exports.ExpertCharset = void 0;
                const ISOAdobeCharset = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron"
                ];
                exports.ISOAdobeCharset = ISOAdobeCharset;
                const ExpertCharset = [
                    ".notdef",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                exports.ExpertCharset = ExpertCharset;
                const ExpertSubsetCharset = [
                    ".notdef",
                    "space",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "hyphensuperior",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "centoldstyle",
                    "figuredash",
                    "hypheninferior",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior"
                ];
                exports.ExpertSubsetCharset = ExpertSubsetCharset;
            /***/ },
            /* 37 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ZapfDingbatsEncoding = exports.WinAnsiEncoding = exports.SymbolSetEncoding = exports.StandardEncoding = exports.MacRomanEncoding = exports.ExpertEncoding = void 0;
                exports.getEncoding = getEncoding;
                const ExpertEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "",
                    "",
                    "",
                    "isuperior",
                    "",
                    "",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "",
                    "",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "",
                    "",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "",
                    "Dotaccentsmall",
                    "",
                    "",
                    "Macronsmall",
                    "",
                    "",
                    "figuredash",
                    "hypheninferior",
                    "",
                    "",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "",
                    "",
                    "",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "",
                    "",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                exports.ExpertEncoding = ExpertEncoding;
                const MacExpertEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "centoldstyle",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "",
                    "threequartersemdash",
                    "",
                    "questionsmall",
                    "",
                    "",
                    "",
                    "",
                    "Ethsmall",
                    "",
                    "",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hypheninferior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "",
                    "",
                    "asuperior",
                    "centsuperior",
                    "",
                    "",
                    "",
                    "",
                    "Aacutesmall",
                    "Agravesmall",
                    "Acircumflexsmall",
                    "Adieresissmall",
                    "Atildesmall",
                    "Aringsmall",
                    "Ccedillasmall",
                    "Eacutesmall",
                    "Egravesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Iacutesmall",
                    "Igravesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ntildesmall",
                    "Oacutesmall",
                    "Ogravesmall",
                    "Ocircumflexsmall",
                    "Odieresissmall",
                    "Otildesmall",
                    "Uacutesmall",
                    "Ugravesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "",
                    "eightsuperior",
                    "fourinferior",
                    "threeinferior",
                    "sixinferior",
                    "eightinferior",
                    "seveninferior",
                    "Scaronsmall",
                    "",
                    "centinferior",
                    "twoinferior",
                    "",
                    "Dieresissmall",
                    "",
                    "Caronsmall",
                    "osuperior",
                    "fiveinferior",
                    "",
                    "commainferior",
                    "periodinferior",
                    "Yacutesmall",
                    "",
                    "dollarinferior",
                    "",
                    "",
                    "Thornsmall",
                    "",
                    "nineinferior",
                    "zeroinferior",
                    "Zcaronsmall",
                    "AEsmall",
                    "Oslashsmall",
                    "questiondownsmall",
                    "oneinferior",
                    "Lslashsmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "Cedillasmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "OEsmall",
                    "figuredash",
                    "hyphensuperior",
                    "",
                    "",
                    "",
                    "",
                    "exclamdownsmall",
                    "",
                    "Ydieresissmall",
                    "",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "ninesuperior",
                    "zerosuperior",
                    "",
                    "esuperior",
                    "rsuperior",
                    "tsuperior",
                    "",
                    "",
                    "isuperior",
                    "ssuperior",
                    "dsuperior",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "lsuperior",
                    "Ogoneksmall",
                    "Brevesmall",
                    "Macronsmall",
                    "bsuperior",
                    "nsuperior",
                    "msuperior",
                    "commasuperior",
                    "periodsuperior",
                    "Dotaccentsmall",
                    "Ringsmall",
                    "",
                    "",
                    "",
                    ""
                ];
                const MacRomanEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "",
                    "Adieresis",
                    "Aring",
                    "Ccedilla",
                    "Eacute",
                    "Ntilde",
                    "Odieresis",
                    "Udieresis",
                    "aacute",
                    "agrave",
                    "acircumflex",
                    "adieresis",
                    "atilde",
                    "aring",
                    "ccedilla",
                    "eacute",
                    "egrave",
                    "ecircumflex",
                    "edieresis",
                    "iacute",
                    "igrave",
                    "icircumflex",
                    "idieresis",
                    "ntilde",
                    "oacute",
                    "ograve",
                    "ocircumflex",
                    "odieresis",
                    "otilde",
                    "uacute",
                    "ugrave",
                    "ucircumflex",
                    "udieresis",
                    "dagger",
                    "degree",
                    "cent",
                    "sterling",
                    "section",
                    "bullet",
                    "paragraph",
                    "germandbls",
                    "registered",
                    "copyright",
                    "trademark",
                    "acute",
                    "dieresis",
                    "notequal",
                    "AE",
                    "Oslash",
                    "infinity",
                    "plusminus",
                    "lessequal",
                    "greaterequal",
                    "yen",
                    "mu",
                    "partialdiff",
                    "summation",
                    "product",
                    "pi",
                    "integral",
                    "ordfeminine",
                    "ordmasculine",
                    "Omega",
                    "ae",
                    "oslash",
                    "questiondown",
                    "exclamdown",
                    "logicalnot",
                    "radical",
                    "florin",
                    "approxequal",
                    "Delta",
                    "guillemotleft",
                    "guillemotright",
                    "ellipsis",
                    "space",
                    "Agrave",
                    "Atilde",
                    "Otilde",
                    "OE",
                    "oe",
                    "endash",
                    "emdash",
                    "quotedblleft",
                    "quotedblright",
                    "quoteleft",
                    "quoteright",
                    "divide",
                    "lozenge",
                    "ydieresis",
                    "Ydieresis",
                    "fraction",
                    "currency",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "daggerdbl",
                    "periodcentered",
                    "quotesinglbase",
                    "quotedblbase",
                    "perthousand",
                    "Acircumflex",
                    "Ecircumflex",
                    "Aacute",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Oacute",
                    "Ocircumflex",
                    "apple",
                    "Ograve",
                    "Uacute",
                    "Ucircumflex",
                    "Ugrave",
                    "dotlessi",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron"
                ];
                exports.MacRomanEncoding = MacRomanEncoding;
                const StandardEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "",
                    "questiondown",
                    "",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "",
                    "ring",
                    "cedilla",
                    "",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "AE",
                    "",
                    "ordfeminine",
                    "",
                    "",
                    "",
                    "",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "ae",
                    "",
                    "",
                    "",
                    "dotlessi",
                    "",
                    "",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "",
                    "",
                    "",
                    ""
                ];
                exports.StandardEncoding = StandardEncoding;
                const WinAnsiEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "bullet",
                    "Euro",
                    "bullet",
                    "quotesinglbase",
                    "florin",
                    "quotedblbase",
                    "ellipsis",
                    "dagger",
                    "daggerdbl",
                    "circumflex",
                    "perthousand",
                    "Scaron",
                    "guilsinglleft",
                    "OE",
                    "bullet",
                    "Zcaron",
                    "bullet",
                    "bullet",
                    "quoteleft",
                    "quoteright",
                    "quotedblleft",
                    "quotedblright",
                    "bullet",
                    "endash",
                    "emdash",
                    "tilde",
                    "trademark",
                    "scaron",
                    "guilsinglright",
                    "oe",
                    "bullet",
                    "zcaron",
                    "Ydieresis",
                    "space",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "currency",
                    "yen",
                    "brokenbar",
                    "section",
                    "dieresis",
                    "copyright",
                    "ordfeminine",
                    "guillemotleft",
                    "logicalnot",
                    "hyphen",
                    "registered",
                    "macron",
                    "degree",
                    "plusminus",
                    "twosuperior",
                    "threesuperior",
                    "acute",
                    "mu",
                    "paragraph",
                    "periodcentered",
                    "cedilla",
                    "onesuperior",
                    "ordmasculine",
                    "guillemotright",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondown",
                    "Agrave",
                    "Aacute",
                    "Acircumflex",
                    "Atilde",
                    "Adieresis",
                    "Aring",
                    "AE",
                    "Ccedilla",
                    "Egrave",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Igrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Eth",
                    "Ntilde",
                    "Ograve",
                    "Oacute",
                    "Ocircumflex",
                    "Otilde",
                    "Odieresis",
                    "multiply",
                    "Oslash",
                    "Ugrave",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Yacute",
                    "Thorn",
                    "germandbls",
                    "agrave",
                    "aacute",
                    "acircumflex",
                    "atilde",
                    "adieresis",
                    "aring",
                    "ae",
                    "ccedilla",
                    "egrave",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "igrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "eth",
                    "ntilde",
                    "ograve",
                    "oacute",
                    "ocircumflex",
                    "otilde",
                    "odieresis",
                    "divide",
                    "oslash",
                    "ugrave",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "yacute",
                    "thorn",
                    "ydieresis"
                ];
                exports.WinAnsiEncoding = WinAnsiEncoding;
                const SymbolSetEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "universal",
                    "numbersign",
                    "existential",
                    "percent",
                    "ampersand",
                    "suchthat",
                    "parenleft",
                    "parenright",
                    "asteriskmath",
                    "plus",
                    "comma",
                    "minus",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "congruent",
                    "Alpha",
                    "Beta",
                    "Chi",
                    "Delta",
                    "Epsilon",
                    "Phi",
                    "Gamma",
                    "Eta",
                    "Iota",
                    "theta1",
                    "Kappa",
                    "Lambda",
                    "Mu",
                    "Nu",
                    "Omicron",
                    "Pi",
                    "Theta",
                    "Rho",
                    "Sigma",
                    "Tau",
                    "Upsilon",
                    "sigma1",
                    "Omega",
                    "Xi",
                    "Psi",
                    "Zeta",
                    "bracketleft",
                    "therefore",
                    "bracketright",
                    "perpendicular",
                    "underscore",
                    "radicalex",
                    "alpha",
                    "beta",
                    "chi",
                    "delta",
                    "epsilon",
                    "phi",
                    "gamma",
                    "eta",
                    "iota",
                    "phi1",
                    "kappa",
                    "lambda",
                    "mu",
                    "nu",
                    "omicron",
                    "pi",
                    "theta",
                    "rho",
                    "sigma",
                    "tau",
                    "upsilon",
                    "omega1",
                    "omega",
                    "xi",
                    "psi",
                    "zeta",
                    "braceleft",
                    "bar",
                    "braceright",
                    "similar",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "Euro",
                    "Upsilon1",
                    "minute",
                    "lessequal",
                    "fraction",
                    "infinity",
                    "florin",
                    "club",
                    "diamond",
                    "heart",
                    "spade",
                    "arrowboth",
                    "arrowleft",
                    "arrowup",
                    "arrowright",
                    "arrowdown",
                    "degree",
                    "plusminus",
                    "second",
                    "greaterequal",
                    "multiply",
                    "proportional",
                    "partialdiff",
                    "bullet",
                    "divide",
                    "notequal",
                    "equivalence",
                    "approxequal",
                    "ellipsis",
                    "arrowvertex",
                    "arrowhorizex",
                    "carriagereturn",
                    "aleph",
                    "Ifraktur",
                    "Rfraktur",
                    "weierstrass",
                    "circlemultiply",
                    "circleplus",
                    "emptyset",
                    "intersection",
                    "union",
                    "propersuperset",
                    "reflexsuperset",
                    "notsubset",
                    "propersubset",
                    "reflexsubset",
                    "element",
                    "notelement",
                    "angle",
                    "gradient",
                    "registerserif",
                    "copyrightserif",
                    "trademarkserif",
                    "product",
                    "radical",
                    "dotmath",
                    "logicalnot",
                    "logicaland",
                    "logicalor",
                    "arrowdblboth",
                    "arrowdblleft",
                    "arrowdblup",
                    "arrowdblright",
                    "arrowdbldown",
                    "lozenge",
                    "angleleft",
                    "registersans",
                    "copyrightsans",
                    "trademarksans",
                    "summation",
                    "parenlefttp",
                    "parenleftex",
                    "parenleftbt",
                    "bracketlefttp",
                    "bracketleftex",
                    "bracketleftbt",
                    "bracelefttp",
                    "braceleftmid",
                    "braceleftbt",
                    "braceex",
                    "",
                    "angleright",
                    "integral",
                    "integraltp",
                    "integralex",
                    "integralbt",
                    "parenrighttp",
                    "parenrightex",
                    "parenrightbt",
                    "bracketrighttp",
                    "bracketrightex",
                    "bracketrightbt",
                    "bracerighttp",
                    "bracerightmid",
                    "bracerightbt",
                    ""
                ];
                exports.SymbolSetEncoding = SymbolSetEncoding;
                const ZapfDingbatsEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "a1",
                    "a2",
                    "a202",
                    "a3",
                    "a4",
                    "a5",
                    "a119",
                    "a118",
                    "a117",
                    "a11",
                    "a12",
                    "a13",
                    "a14",
                    "a15",
                    "a16",
                    "a105",
                    "a17",
                    "a18",
                    "a19",
                    "a20",
                    "a21",
                    "a22",
                    "a23",
                    "a24",
                    "a25",
                    "a26",
                    "a27",
                    "a28",
                    "a6",
                    "a7",
                    "a8",
                    "a9",
                    "a10",
                    "a29",
                    "a30",
                    "a31",
                    "a32",
                    "a33",
                    "a34",
                    "a35",
                    "a36",
                    "a37",
                    "a38",
                    "a39",
                    "a40",
                    "a41",
                    "a42",
                    "a43",
                    "a44",
                    "a45",
                    "a46",
                    "a47",
                    "a48",
                    "a49",
                    "a50",
                    "a51",
                    "a52",
                    "a53",
                    "a54",
                    "a55",
                    "a56",
                    "a57",
                    "a58",
                    "a59",
                    "a60",
                    "a61",
                    "a62",
                    "a63",
                    "a64",
                    "a65",
                    "a66",
                    "a67",
                    "a68",
                    "a69",
                    "a70",
                    "a71",
                    "a72",
                    "a73",
                    "a74",
                    "a203",
                    "a75",
                    "a204",
                    "a76",
                    "a77",
                    "a78",
                    "a79",
                    "a81",
                    "a82",
                    "a83",
                    "a84",
                    "a97",
                    "a98",
                    "a99",
                    "a100",
                    "",
                    "a89",
                    "a90",
                    "a93",
                    "a94",
                    "a91",
                    "a92",
                    "a205",
                    "a85",
                    "a206",
                    "a86",
                    "a87",
                    "a88",
                    "a95",
                    "a96",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "a101",
                    "a102",
                    "a103",
                    "a104",
                    "a106",
                    "a107",
                    "a108",
                    "a112",
                    "a111",
                    "a110",
                    "a109",
                    "a120",
                    "a121",
                    "a122",
                    "a123",
                    "a124",
                    "a125",
                    "a126",
                    "a127",
                    "a128",
                    "a129",
                    "a130",
                    "a131",
                    "a132",
                    "a133",
                    "a134",
                    "a135",
                    "a136",
                    "a137",
                    "a138",
                    "a139",
                    "a140",
                    "a141",
                    "a142",
                    "a143",
                    "a144",
                    "a145",
                    "a146",
                    "a147",
                    "a148",
                    "a149",
                    "a150",
                    "a151",
                    "a152",
                    "a153",
                    "a154",
                    "a155",
                    "a156",
                    "a157",
                    "a158",
                    "a159",
                    "a160",
                    "a161",
                    "a163",
                    "a164",
                    "a196",
                    "a165",
                    "a192",
                    "a166",
                    "a167",
                    "a168",
                    "a169",
                    "a170",
                    "a171",
                    "a172",
                    "a173",
                    "a162",
                    "a174",
                    "a175",
                    "a176",
                    "a177",
                    "a178",
                    "a179",
                    "a193",
                    "a180",
                    "a199",
                    "a181",
                    "a200",
                    "a182",
                    "",
                    "a201",
                    "a183",
                    "a184",
                    "a197",
                    "a185",
                    "a194",
                    "a198",
                    "a186",
                    "a195",
                    "a187",
                    "a188",
                    "a189",
                    "a190",
                    "a191",
                    ""
                ];
                exports.ZapfDingbatsEncoding = ZapfDingbatsEncoding;
                function getEncoding(encodingName) {
                    switch(encodingName){
                        case "WinAnsiEncoding":
                            return WinAnsiEncoding;
                        case "StandardEncoding":
                            return StandardEncoding;
                        case "MacRomanEncoding":
                            return MacRomanEncoding;
                        case "SymbolSetEncoding":
                            return SymbolSetEncoding;
                        case "ZapfDingbatsEncoding":
                            return ZapfDingbatsEncoding;
                        case "ExpertEncoding":
                            return ExpertEncoding;
                        case "MacExpertEncoding":
                            return MacExpertEncoding;
                        default:
                            return null;
                    }
                }
            /***/ },
            /* 38 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SEAC_ANALYSIS_ENABLED = exports.MacStandardGlyphOrdering = exports.FontFlags = void 0;
                exports.normalizeFontName = normalizeFontName;
                exports.recoverGlyphName = recoverGlyphName;
                exports.type1FontGlyphMapping = type1FontGlyphMapping;
                var _encodings = __w_pdfjs_require__(37);
                var _glyphlist = __w_pdfjs_require__(39);
                var _unicode = __w_pdfjs_require__(40);
                var _util = __w_pdfjs_require__(2);
                const SEAC_ANALYSIS_ENABLED = true;
                exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED;
                const FontFlags = {
                    FixedPitch: 1,
                    Serif: 2,
                    Symbolic: 4,
                    Script: 8,
                    Nonsymbolic: 32,
                    Italic: 64,
                    AllCap: 65536,
                    SmallCap: 131072,
                    ForceBold: 262144
                };
                exports.FontFlags = FontFlags;
                const MacStandardGlyphOrdering = [
                    ".notdef",
                    ".null",
                    "nonmarkingreturn",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "Adieresis",
                    "Aring",
                    "Ccedilla",
                    "Eacute",
                    "Ntilde",
                    "Odieresis",
                    "Udieresis",
                    "aacute",
                    "agrave",
                    "acircumflex",
                    "adieresis",
                    "atilde",
                    "aring",
                    "ccedilla",
                    "eacute",
                    "egrave",
                    "ecircumflex",
                    "edieresis",
                    "iacute",
                    "igrave",
                    "icircumflex",
                    "idieresis",
                    "ntilde",
                    "oacute",
                    "ograve",
                    "ocircumflex",
                    "odieresis",
                    "otilde",
                    "uacute",
                    "ugrave",
                    "ucircumflex",
                    "udieresis",
                    "dagger",
                    "degree",
                    "cent",
                    "sterling",
                    "section",
                    "bullet",
                    "paragraph",
                    "germandbls",
                    "registered",
                    "copyright",
                    "trademark",
                    "acute",
                    "dieresis",
                    "notequal",
                    "AE",
                    "Oslash",
                    "infinity",
                    "plusminus",
                    "lessequal",
                    "greaterequal",
                    "yen",
                    "mu",
                    "partialdiff",
                    "summation",
                    "product",
                    "pi",
                    "integral",
                    "ordfeminine",
                    "ordmasculine",
                    "Omega",
                    "ae",
                    "oslash",
                    "questiondown",
                    "exclamdown",
                    "logicalnot",
                    "radical",
                    "florin",
                    "approxequal",
                    "Delta",
                    "guillemotleft",
                    "guillemotright",
                    "ellipsis",
                    "nonbreakingspace",
                    "Agrave",
                    "Atilde",
                    "Otilde",
                    "OE",
                    "oe",
                    "endash",
                    "emdash",
                    "quotedblleft",
                    "quotedblright",
                    "quoteleft",
                    "quoteright",
                    "divide",
                    "lozenge",
                    "ydieresis",
                    "Ydieresis",
                    "fraction",
                    "currency",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "daggerdbl",
                    "periodcentered",
                    "quotesinglbase",
                    "quotedblbase",
                    "perthousand",
                    "Acircumflex",
                    "Ecircumflex",
                    "Aacute",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Oacute",
                    "Ocircumflex",
                    "apple",
                    "Ograve",
                    "Uacute",
                    "Ucircumflex",
                    "Ugrave",
                    "dotlessi",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "Lslash",
                    "lslash",
                    "Scaron",
                    "scaron",
                    "Zcaron",
                    "zcaron",
                    "brokenbar",
                    "Eth",
                    "eth",
                    "Yacute",
                    "yacute",
                    "Thorn",
                    "thorn",
                    "minus",
                    "multiply",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "onehalf",
                    "onequarter",
                    "threequarters",
                    "franc",
                    "Gbreve",
                    "gbreve",
                    "Idotaccent",
                    "Scedilla",
                    "scedilla",
                    "Cacute",
                    "cacute",
                    "Ccaron",
                    "ccaron",
                    "dcroat"
                ];
                exports.MacStandardGlyphOrdering = MacStandardGlyphOrdering;
                function recoverGlyphName(name, glyphsUnicodeMap) {
                    if (glyphsUnicodeMap[name] !== undefined) return name;
                    const unicode = (0, _unicode.getUnicodeForGlyph)(name, glyphsUnicodeMap);
                    if (unicode !== -1) for(const key in glyphsUnicodeMap){
                        if (glyphsUnicodeMap[key] === unicode) return key;
                    }
                    (0, _util.info)("Unable to recover a standard glyph name for: " + name);
                    return name;
                }
                function type1FontGlyphMapping(properties, builtInEncoding, glyphNames) {
                    const charCodeToGlyphId = Object.create(null);
                    let glyphId, charCode, baseEncoding;
                    const isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
                    if (properties.isInternalFont) {
                        baseEncoding = builtInEncoding;
                        for(charCode = 0; charCode < baseEncoding.length; charCode++){
                            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                            charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                        }
                    } else if (properties.baseEncodingName) {
                        baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
                        for(charCode = 0; charCode < baseEncoding.length; charCode++){
                            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                            charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                        }
                    } else if (isSymbolicFont) for(charCode in builtInEncoding)charCodeToGlyphId[charCode] = builtInEncoding[charCode];
                    else {
                        baseEncoding = _encodings.StandardEncoding;
                        for(charCode = 0; charCode < baseEncoding.length; charCode++){
                            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                            charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                        }
                    }
                    const differences = properties.differences;
                    let glyphsUnicodeMap;
                    if (differences) for(charCode in differences){
                        const glyphName = differences[charCode];
                        glyphId = glyphNames.indexOf(glyphName);
                        if (glyphId === -1) {
                            if (!glyphsUnicodeMap) glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                            const standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
                            if (standardGlyphName !== glyphName) glyphId = glyphNames.indexOf(standardGlyphName);
                        }
                        charCodeToGlyphId[charCode] = glyphId >= 0 ? glyphId : 0;
                    }
                    return charCodeToGlyphId;
                }
                function normalizeFontName(name) {
                    return name.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
                }
            /***/ },
            /* 39 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getGlyphsUnicode = exports.getDingbatsGlyphsUnicode = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                const getGlyphsUnicode = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.A = 0x0041;
                    t.AE = 0x00c6;
                    t.AEacute = 0x01fc;
                    t.AEmacron = 0x01e2;
                    t.AEsmall = 0xf7e6;
                    t.Aacute = 0x00c1;
                    t.Aacutesmall = 0xf7e1;
                    t.Abreve = 0x0102;
                    t.Abreveacute = 0x1eae;
                    t.Abrevecyrillic = 0x04d0;
                    t.Abrevedotbelow = 0x1eb6;
                    t.Abrevegrave = 0x1eb0;
                    t.Abrevehookabove = 0x1eb2;
                    t.Abrevetilde = 0x1eb4;
                    t.Acaron = 0x01cd;
                    t.Acircle = 0x24b6;
                    t.Acircumflex = 0x00c2;
                    t.Acircumflexacute = 0x1ea4;
                    t.Acircumflexdotbelow = 0x1eac;
                    t.Acircumflexgrave = 0x1ea6;
                    t.Acircumflexhookabove = 0x1ea8;
                    t.Acircumflexsmall = 0xf7e2;
                    t.Acircumflextilde = 0x1eaa;
                    t.Acute = 0xf6c9;
                    t.Acutesmall = 0xf7b4;
                    t.Acyrillic = 0x0410;
                    t.Adblgrave = 0x0200;
                    t.Adieresis = 0x00c4;
                    t.Adieresiscyrillic = 0x04d2;
                    t.Adieresismacron = 0x01de;
                    t.Adieresissmall = 0xf7e4;
                    t.Adotbelow = 0x1ea0;
                    t.Adotmacron = 0x01e0;
                    t.Agrave = 0x00c0;
                    t.Agravesmall = 0xf7e0;
                    t.Ahookabove = 0x1ea2;
                    t.Aiecyrillic = 0x04d4;
                    t.Ainvertedbreve = 0x0202;
                    t.Alpha = 0x0391;
                    t.Alphatonos = 0x0386;
                    t.Amacron = 0x0100;
                    t.Amonospace = 0xff21;
                    t.Aogonek = 0x0104;
                    t.Aring = 0x00c5;
                    t.Aringacute = 0x01fa;
                    t.Aringbelow = 0x1e00;
                    t.Aringsmall = 0xf7e5;
                    t.Asmall = 0xf761;
                    t.Atilde = 0x00c3;
                    t.Atildesmall = 0xf7e3;
                    t.Aybarmenian = 0x0531;
                    t.B = 0x0042;
                    t.Bcircle = 0x24b7;
                    t.Bdotaccent = 0x1e02;
                    t.Bdotbelow = 0x1e04;
                    t.Becyrillic = 0x0411;
                    t.Benarmenian = 0x0532;
                    t.Beta = 0x0392;
                    t.Bhook = 0x0181;
                    t.Blinebelow = 0x1e06;
                    t.Bmonospace = 0xff22;
                    t.Brevesmall = 0xf6f4;
                    t.Bsmall = 0xf762;
                    t.Btopbar = 0x0182;
                    t.C = 0x0043;
                    t.Caarmenian = 0x053e;
                    t.Cacute = 0x0106;
                    t.Caron = 0xf6ca;
                    t.Caronsmall = 0xf6f5;
                    t.Ccaron = 0x010c;
                    t.Ccedilla = 0x00c7;
                    t.Ccedillaacute = 0x1e08;
                    t.Ccedillasmall = 0xf7e7;
                    t.Ccircle = 0x24b8;
                    t.Ccircumflex = 0x0108;
                    t.Cdot = 0x010a;
                    t.Cdotaccent = 0x010a;
                    t.Cedillasmall = 0xf7b8;
                    t.Chaarmenian = 0x0549;
                    t.Cheabkhasiancyrillic = 0x04bc;
                    t.Checyrillic = 0x0427;
                    t.Chedescenderabkhasiancyrillic = 0x04be;
                    t.Chedescendercyrillic = 0x04b6;
                    t.Chedieresiscyrillic = 0x04f4;
                    t.Cheharmenian = 0x0543;
                    t.Chekhakassiancyrillic = 0x04cb;
                    t.Cheverticalstrokecyrillic = 0x04b8;
                    t.Chi = 0x03a7;
                    t.Chook = 0x0187;
                    t.Circumflexsmall = 0xf6f6;
                    t.Cmonospace = 0xff23;
                    t.Coarmenian = 0x0551;
                    t.Csmall = 0xf763;
                    t.D = 0x0044;
                    t.DZ = 0x01f1;
                    t.DZcaron = 0x01c4;
                    t.Daarmenian = 0x0534;
                    t.Dafrican = 0x0189;
                    t.Dcaron = 0x010e;
                    t.Dcedilla = 0x1e10;
                    t.Dcircle = 0x24b9;
                    t.Dcircumflexbelow = 0x1e12;
                    t.Dcroat = 0x0110;
                    t.Ddotaccent = 0x1e0a;
                    t.Ddotbelow = 0x1e0c;
                    t.Decyrillic = 0x0414;
                    t.Deicoptic = 0x03ee;
                    t.Delta = 0x2206;
                    t.Deltagreek = 0x0394;
                    t.Dhook = 0x018a;
                    t.Dieresis = 0xf6cb;
                    t.DieresisAcute = 0xf6cc;
                    t.DieresisGrave = 0xf6cd;
                    t.Dieresissmall = 0xf7a8;
                    t.Digammagreek = 0x03dc;
                    t.Djecyrillic = 0x0402;
                    t.Dlinebelow = 0x1e0e;
                    t.Dmonospace = 0xff24;
                    t.Dotaccentsmall = 0xf6f7;
                    t.Dslash = 0x0110;
                    t.Dsmall = 0xf764;
                    t.Dtopbar = 0x018b;
                    t.Dz = 0x01f2;
                    t.Dzcaron = 0x01c5;
                    t.Dzeabkhasiancyrillic = 0x04e0;
                    t.Dzecyrillic = 0x0405;
                    t.Dzhecyrillic = 0x040f;
                    t.E = 0x0045;
                    t.Eacute = 0x00c9;
                    t.Eacutesmall = 0xf7e9;
                    t.Ebreve = 0x0114;
                    t.Ecaron = 0x011a;
                    t.Ecedillabreve = 0x1e1c;
                    t.Echarmenian = 0x0535;
                    t.Ecircle = 0x24ba;
                    t.Ecircumflex = 0x00ca;
                    t.Ecircumflexacute = 0x1ebe;
                    t.Ecircumflexbelow = 0x1e18;
                    t.Ecircumflexdotbelow = 0x1ec6;
                    t.Ecircumflexgrave = 0x1ec0;
                    t.Ecircumflexhookabove = 0x1ec2;
                    t.Ecircumflexsmall = 0xf7ea;
                    t.Ecircumflextilde = 0x1ec4;
                    t.Ecyrillic = 0x0404;
                    t.Edblgrave = 0x0204;
                    t.Edieresis = 0x00cb;
                    t.Edieresissmall = 0xf7eb;
                    t.Edot = 0x0116;
                    t.Edotaccent = 0x0116;
                    t.Edotbelow = 0x1eb8;
                    t.Efcyrillic = 0x0424;
                    t.Egrave = 0x00c8;
                    t.Egravesmall = 0xf7e8;
                    t.Eharmenian = 0x0537;
                    t.Ehookabove = 0x1eba;
                    t.Eightroman = 0x2167;
                    t.Einvertedbreve = 0x0206;
                    t.Eiotifiedcyrillic = 0x0464;
                    t.Elcyrillic = 0x041b;
                    t.Elevenroman = 0x216a;
                    t.Emacron = 0x0112;
                    t.Emacronacute = 0x1e16;
                    t.Emacrongrave = 0x1e14;
                    t.Emcyrillic = 0x041c;
                    t.Emonospace = 0xff25;
                    t.Encyrillic = 0x041d;
                    t.Endescendercyrillic = 0x04a2;
                    t.Eng = 0x014a;
                    t.Enghecyrillic = 0x04a4;
                    t.Enhookcyrillic = 0x04c7;
                    t.Eogonek = 0x0118;
                    t.Eopen = 0x0190;
                    t.Epsilon = 0x0395;
                    t.Epsilontonos = 0x0388;
                    t.Ercyrillic = 0x0420;
                    t.Ereversed = 0x018e;
                    t.Ereversedcyrillic = 0x042d;
                    t.Escyrillic = 0x0421;
                    t.Esdescendercyrillic = 0x04aa;
                    t.Esh = 0x01a9;
                    t.Esmall = 0xf765;
                    t.Eta = 0x0397;
                    t.Etarmenian = 0x0538;
                    t.Etatonos = 0x0389;
                    t.Eth = 0x00d0;
                    t.Ethsmall = 0xf7f0;
                    t.Etilde = 0x1ebc;
                    t.Etildebelow = 0x1e1a;
                    t.Euro = 0x20ac;
                    t.Ezh = 0x01b7;
                    t.Ezhcaron = 0x01ee;
                    t.Ezhreversed = 0x01b8;
                    t.F = 0x0046;
                    t.Fcircle = 0x24bb;
                    t.Fdotaccent = 0x1e1e;
                    t.Feharmenian = 0x0556;
                    t.Feicoptic = 0x03e4;
                    t.Fhook = 0x0191;
                    t.Fitacyrillic = 0x0472;
                    t.Fiveroman = 0x2164;
                    t.Fmonospace = 0xff26;
                    t.Fourroman = 0x2163;
                    t.Fsmall = 0xf766;
                    t.G = 0x0047;
                    t.GBsquare = 0x3387;
                    t.Gacute = 0x01f4;
                    t.Gamma = 0x0393;
                    t.Gammaafrican = 0x0194;
                    t.Gangiacoptic = 0x03ea;
                    t.Gbreve = 0x011e;
                    t.Gcaron = 0x01e6;
                    t.Gcedilla = 0x0122;
                    t.Gcircle = 0x24bc;
                    t.Gcircumflex = 0x011c;
                    t.Gcommaaccent = 0x0122;
                    t.Gdot = 0x0120;
                    t.Gdotaccent = 0x0120;
                    t.Gecyrillic = 0x0413;
                    t.Ghadarmenian = 0x0542;
                    t.Ghemiddlehookcyrillic = 0x0494;
                    t.Ghestrokecyrillic = 0x0492;
                    t.Gheupturncyrillic = 0x0490;
                    t.Ghook = 0x0193;
                    t.Gimarmenian = 0x0533;
                    t.Gjecyrillic = 0x0403;
                    t.Gmacron = 0x1e20;
                    t.Gmonospace = 0xff27;
                    t.Grave = 0xf6ce;
                    t.Gravesmall = 0xf760;
                    t.Gsmall = 0xf767;
                    t.Gsmallhook = 0x029b;
                    t.Gstroke = 0x01e4;
                    t.H = 0x0048;
                    t.H18533 = 0x25cf;
                    t.H18543 = 0x25aa;
                    t.H18551 = 0x25ab;
                    t.H22073 = 0x25a1;
                    t.HPsquare = 0x33cb;
                    t.Haabkhasiancyrillic = 0x04a8;
                    t.Hadescendercyrillic = 0x04b2;
                    t.Hardsigncyrillic = 0x042a;
                    t.Hbar = 0x0126;
                    t.Hbrevebelow = 0x1e2a;
                    t.Hcedilla = 0x1e28;
                    t.Hcircle = 0x24bd;
                    t.Hcircumflex = 0x0124;
                    t.Hdieresis = 0x1e26;
                    t.Hdotaccent = 0x1e22;
                    t.Hdotbelow = 0x1e24;
                    t.Hmonospace = 0xff28;
                    t.Hoarmenian = 0x0540;
                    t.Horicoptic = 0x03e8;
                    t.Hsmall = 0xf768;
                    t.Hungarumlaut = 0xf6cf;
                    t.Hungarumlautsmall = 0xf6f8;
                    t.Hzsquare = 0x3390;
                    t.I = 0x0049;
                    t.IAcyrillic = 0x042f;
                    t.IJ = 0x0132;
                    t.IUcyrillic = 0x042e;
                    t.Iacute = 0x00cd;
                    t.Iacutesmall = 0xf7ed;
                    t.Ibreve = 0x012c;
                    t.Icaron = 0x01cf;
                    t.Icircle = 0x24be;
                    t.Icircumflex = 0x00ce;
                    t.Icircumflexsmall = 0xf7ee;
                    t.Icyrillic = 0x0406;
                    t.Idblgrave = 0x0208;
                    t.Idieresis = 0x00cf;
                    t.Idieresisacute = 0x1e2e;
                    t.Idieresiscyrillic = 0x04e4;
                    t.Idieresissmall = 0xf7ef;
                    t.Idot = 0x0130;
                    t.Idotaccent = 0x0130;
                    t.Idotbelow = 0x1eca;
                    t.Iebrevecyrillic = 0x04d6;
                    t.Iecyrillic = 0x0415;
                    t.Ifraktur = 0x2111;
                    t.Igrave = 0x00cc;
                    t.Igravesmall = 0xf7ec;
                    t.Ihookabove = 0x1ec8;
                    t.Iicyrillic = 0x0418;
                    t.Iinvertedbreve = 0x020a;
                    t.Iishortcyrillic = 0x0419;
                    t.Imacron = 0x012a;
                    t.Imacroncyrillic = 0x04e2;
                    t.Imonospace = 0xff29;
                    t.Iniarmenian = 0x053b;
                    t.Iocyrillic = 0x0401;
                    t.Iogonek = 0x012e;
                    t.Iota = 0x0399;
                    t.Iotaafrican = 0x0196;
                    t.Iotadieresis = 0x03aa;
                    t.Iotatonos = 0x038a;
                    t.Ismall = 0xf769;
                    t.Istroke = 0x0197;
                    t.Itilde = 0x0128;
                    t.Itildebelow = 0x1e2c;
                    t.Izhitsacyrillic = 0x0474;
                    t.Izhitsadblgravecyrillic = 0x0476;
                    t.J = 0x004a;
                    t.Jaarmenian = 0x0541;
                    t.Jcircle = 0x24bf;
                    t.Jcircumflex = 0x0134;
                    t.Jecyrillic = 0x0408;
                    t.Jheharmenian = 0x054b;
                    t.Jmonospace = 0xff2a;
                    t.Jsmall = 0xf76a;
                    t.K = 0x004b;
                    t.KBsquare = 0x3385;
                    t.KKsquare = 0x33cd;
                    t.Kabashkircyrillic = 0x04a0;
                    t.Kacute = 0x1e30;
                    t.Kacyrillic = 0x041a;
                    t.Kadescendercyrillic = 0x049a;
                    t.Kahookcyrillic = 0x04c3;
                    t.Kappa = 0x039a;
                    t.Kastrokecyrillic = 0x049e;
                    t.Kaverticalstrokecyrillic = 0x049c;
                    t.Kcaron = 0x01e8;
                    t.Kcedilla = 0x0136;
                    t.Kcircle = 0x24c0;
                    t.Kcommaaccent = 0x0136;
                    t.Kdotbelow = 0x1e32;
                    t.Keharmenian = 0x0554;
                    t.Kenarmenian = 0x053f;
                    t.Khacyrillic = 0x0425;
                    t.Kheicoptic = 0x03e6;
                    t.Khook = 0x0198;
                    t.Kjecyrillic = 0x040c;
                    t.Klinebelow = 0x1e34;
                    t.Kmonospace = 0xff2b;
                    t.Koppacyrillic = 0x0480;
                    t.Koppagreek = 0x03de;
                    t.Ksicyrillic = 0x046e;
                    t.Ksmall = 0xf76b;
                    t.L = 0x004c;
                    t.LJ = 0x01c7;
                    t.LL = 0xf6bf;
                    t.Lacute = 0x0139;
                    t.Lambda = 0x039b;
                    t.Lcaron = 0x013d;
                    t.Lcedilla = 0x013b;
                    t.Lcircle = 0x24c1;
                    t.Lcircumflexbelow = 0x1e3c;
                    t.Lcommaaccent = 0x013b;
                    t.Ldot = 0x013f;
                    t.Ldotaccent = 0x013f;
                    t.Ldotbelow = 0x1e36;
                    t.Ldotbelowmacron = 0x1e38;
                    t.Liwnarmenian = 0x053c;
                    t.Lj = 0x01c8;
                    t.Ljecyrillic = 0x0409;
                    t.Llinebelow = 0x1e3a;
                    t.Lmonospace = 0xff2c;
                    t.Lslash = 0x0141;
                    t.Lslashsmall = 0xf6f9;
                    t.Lsmall = 0xf76c;
                    t.M = 0x004d;
                    t.MBsquare = 0x3386;
                    t.Macron = 0xf6d0;
                    t.Macronsmall = 0xf7af;
                    t.Macute = 0x1e3e;
                    t.Mcircle = 0x24c2;
                    t.Mdotaccent = 0x1e40;
                    t.Mdotbelow = 0x1e42;
                    t.Menarmenian = 0x0544;
                    t.Mmonospace = 0xff2d;
                    t.Msmall = 0xf76d;
                    t.Mturned = 0x019c;
                    t.Mu = 0x039c;
                    t.N = 0x004e;
                    t.NJ = 0x01ca;
                    t.Nacute = 0x0143;
                    t.Ncaron = 0x0147;
                    t.Ncedilla = 0x0145;
                    t.Ncircle = 0x24c3;
                    t.Ncircumflexbelow = 0x1e4a;
                    t.Ncommaaccent = 0x0145;
                    t.Ndotaccent = 0x1e44;
                    t.Ndotbelow = 0x1e46;
                    t.Nhookleft = 0x019d;
                    t.Nineroman = 0x2168;
                    t.Nj = 0x01cb;
                    t.Njecyrillic = 0x040a;
                    t.Nlinebelow = 0x1e48;
                    t.Nmonospace = 0xff2e;
                    t.Nowarmenian = 0x0546;
                    t.Nsmall = 0xf76e;
                    t.Ntilde = 0x00d1;
                    t.Ntildesmall = 0xf7f1;
                    t.Nu = 0x039d;
                    t.O = 0x004f;
                    t.OE = 0x0152;
                    t.OEsmall = 0xf6fa;
                    t.Oacute = 0x00d3;
                    t.Oacutesmall = 0xf7f3;
                    t.Obarredcyrillic = 0x04e8;
                    t.Obarreddieresiscyrillic = 0x04ea;
                    t.Obreve = 0x014e;
                    t.Ocaron = 0x01d1;
                    t.Ocenteredtilde = 0x019f;
                    t.Ocircle = 0x24c4;
                    t.Ocircumflex = 0x00d4;
                    t.Ocircumflexacute = 0x1ed0;
                    t.Ocircumflexdotbelow = 0x1ed8;
                    t.Ocircumflexgrave = 0x1ed2;
                    t.Ocircumflexhookabove = 0x1ed4;
                    t.Ocircumflexsmall = 0xf7f4;
                    t.Ocircumflextilde = 0x1ed6;
                    t.Ocyrillic = 0x041e;
                    t.Odblacute = 0x0150;
                    t.Odblgrave = 0x020c;
                    t.Odieresis = 0x00d6;
                    t.Odieresiscyrillic = 0x04e6;
                    t.Odieresissmall = 0xf7f6;
                    t.Odotbelow = 0x1ecc;
                    t.Ogoneksmall = 0xf6fb;
                    t.Ograve = 0x00d2;
                    t.Ogravesmall = 0xf7f2;
                    t.Oharmenian = 0x0555;
                    t.Ohm = 0x2126;
                    t.Ohookabove = 0x1ece;
                    t.Ohorn = 0x01a0;
                    t.Ohornacute = 0x1eda;
                    t.Ohorndotbelow = 0x1ee2;
                    t.Ohorngrave = 0x1edc;
                    t.Ohornhookabove = 0x1ede;
                    t.Ohorntilde = 0x1ee0;
                    t.Ohungarumlaut = 0x0150;
                    t.Oi = 0x01a2;
                    t.Oinvertedbreve = 0x020e;
                    t.Omacron = 0x014c;
                    t.Omacronacute = 0x1e52;
                    t.Omacrongrave = 0x1e50;
                    t.Omega = 0x2126;
                    t.Omegacyrillic = 0x0460;
                    t.Omegagreek = 0x03a9;
                    t.Omegaroundcyrillic = 0x047a;
                    t.Omegatitlocyrillic = 0x047c;
                    t.Omegatonos = 0x038f;
                    t.Omicron = 0x039f;
                    t.Omicrontonos = 0x038c;
                    t.Omonospace = 0xff2f;
                    t.Oneroman = 0x2160;
                    t.Oogonek = 0x01ea;
                    t.Oogonekmacron = 0x01ec;
                    t.Oopen = 0x0186;
                    t.Oslash = 0x00d8;
                    t.Oslashacute = 0x01fe;
                    t.Oslashsmall = 0xf7f8;
                    t.Osmall = 0xf76f;
                    t.Ostrokeacute = 0x01fe;
                    t.Otcyrillic = 0x047e;
                    t.Otilde = 0x00d5;
                    t.Otildeacute = 0x1e4c;
                    t.Otildedieresis = 0x1e4e;
                    t.Otildesmall = 0xf7f5;
                    t.P = 0x0050;
                    t.Pacute = 0x1e54;
                    t.Pcircle = 0x24c5;
                    t.Pdotaccent = 0x1e56;
                    t.Pecyrillic = 0x041f;
                    t.Peharmenian = 0x054a;
                    t.Pemiddlehookcyrillic = 0x04a6;
                    t.Phi = 0x03a6;
                    t.Phook = 0x01a4;
                    t.Pi = 0x03a0;
                    t.Piwrarmenian = 0x0553;
                    t.Pmonospace = 0xff30;
                    t.Psi = 0x03a8;
                    t.Psicyrillic = 0x0470;
                    t.Psmall = 0xf770;
                    t.Q = 0x0051;
                    t.Qcircle = 0x24c6;
                    t.Qmonospace = 0xff31;
                    t.Qsmall = 0xf771;
                    t.R = 0x0052;
                    t.Raarmenian = 0x054c;
                    t.Racute = 0x0154;
                    t.Rcaron = 0x0158;
                    t.Rcedilla = 0x0156;
                    t.Rcircle = 0x24c7;
                    t.Rcommaaccent = 0x0156;
                    t.Rdblgrave = 0x0210;
                    t.Rdotaccent = 0x1e58;
                    t.Rdotbelow = 0x1e5a;
                    t.Rdotbelowmacron = 0x1e5c;
                    t.Reharmenian = 0x0550;
                    t.Rfraktur = 0x211c;
                    t.Rho = 0x03a1;
                    t.Ringsmall = 0xf6fc;
                    t.Rinvertedbreve = 0x0212;
                    t.Rlinebelow = 0x1e5e;
                    t.Rmonospace = 0xff32;
                    t.Rsmall = 0xf772;
                    t.Rsmallinverted = 0x0281;
                    t.Rsmallinvertedsuperior = 0x02b6;
                    t.S = 0x0053;
                    t.SF010000 = 0x250c;
                    t.SF020000 = 0x2514;
                    t.SF030000 = 0x2510;
                    t.SF040000 = 0x2518;
                    t.SF050000 = 0x253c;
                    t.SF060000 = 0x252c;
                    t.SF070000 = 0x2534;
                    t.SF080000 = 0x251c;
                    t.SF090000 = 0x2524;
                    t.SF100000 = 0x2500;
                    t.SF110000 = 0x2502;
                    t.SF190000 = 0x2561;
                    t.SF200000 = 0x2562;
                    t.SF210000 = 0x2556;
                    t.SF220000 = 0x2555;
                    t.SF230000 = 0x2563;
                    t.SF240000 = 0x2551;
                    t.SF250000 = 0x2557;
                    t.SF260000 = 0x255d;
                    t.SF270000 = 0x255c;
                    t.SF280000 = 0x255b;
                    t.SF360000 = 0x255e;
                    t.SF370000 = 0x255f;
                    t.SF380000 = 0x255a;
                    t.SF390000 = 0x2554;
                    t.SF400000 = 0x2569;
                    t.SF410000 = 0x2566;
                    t.SF420000 = 0x2560;
                    t.SF430000 = 0x2550;
                    t.SF440000 = 0x256c;
                    t.SF450000 = 0x2567;
                    t.SF460000 = 0x2568;
                    t.SF470000 = 0x2564;
                    t.SF480000 = 0x2565;
                    t.SF490000 = 0x2559;
                    t.SF500000 = 0x2558;
                    t.SF510000 = 0x2552;
                    t.SF520000 = 0x2553;
                    t.SF530000 = 0x256b;
                    t.SF540000 = 0x256a;
                    t.Sacute = 0x015a;
                    t.Sacutedotaccent = 0x1e64;
                    t.Sampigreek = 0x03e0;
                    t.Scaron = 0x0160;
                    t.Scarondotaccent = 0x1e66;
                    t.Scaronsmall = 0xf6fd;
                    t.Scedilla = 0x015e;
                    t.Schwa = 0x018f;
                    t.Schwacyrillic = 0x04d8;
                    t.Schwadieresiscyrillic = 0x04da;
                    t.Scircle = 0x24c8;
                    t.Scircumflex = 0x015c;
                    t.Scommaaccent = 0x0218;
                    t.Sdotaccent = 0x1e60;
                    t.Sdotbelow = 0x1e62;
                    t.Sdotbelowdotaccent = 0x1e68;
                    t.Seharmenian = 0x054d;
                    t.Sevenroman = 0x2166;
                    t.Shaarmenian = 0x0547;
                    t.Shacyrillic = 0x0428;
                    t.Shchacyrillic = 0x0429;
                    t.Sheicoptic = 0x03e2;
                    t.Shhacyrillic = 0x04ba;
                    t.Shimacoptic = 0x03ec;
                    t.Sigma = 0x03a3;
                    t.Sixroman = 0x2165;
                    t.Smonospace = 0xff33;
                    t.Softsigncyrillic = 0x042c;
                    t.Ssmall = 0xf773;
                    t.Stigmagreek = 0x03da;
                    t.T = 0x0054;
                    t.Tau = 0x03a4;
                    t.Tbar = 0x0166;
                    t.Tcaron = 0x0164;
                    t.Tcedilla = 0x0162;
                    t.Tcircle = 0x24c9;
                    t.Tcircumflexbelow = 0x1e70;
                    t.Tcommaaccent = 0x0162;
                    t.Tdotaccent = 0x1e6a;
                    t.Tdotbelow = 0x1e6c;
                    t.Tecyrillic = 0x0422;
                    t.Tedescendercyrillic = 0x04ac;
                    t.Tenroman = 0x2169;
                    t.Tetsecyrillic = 0x04b4;
                    t.Theta = 0x0398;
                    t.Thook = 0x01ac;
                    t.Thorn = 0x00de;
                    t.Thornsmall = 0xf7fe;
                    t.Threeroman = 0x2162;
                    t.Tildesmall = 0xf6fe;
                    t.Tiwnarmenian = 0x054f;
                    t.Tlinebelow = 0x1e6e;
                    t.Tmonospace = 0xff34;
                    t.Toarmenian = 0x0539;
                    t.Tonefive = 0x01bc;
                    t.Tonesix = 0x0184;
                    t.Tonetwo = 0x01a7;
                    t.Tretroflexhook = 0x01ae;
                    t.Tsecyrillic = 0x0426;
                    t.Tshecyrillic = 0x040b;
                    t.Tsmall = 0xf774;
                    t.Twelveroman = 0x216b;
                    t.Tworoman = 0x2161;
                    t.U = 0x0055;
                    t.Uacute = 0x00da;
                    t.Uacutesmall = 0xf7fa;
                    t.Ubreve = 0x016c;
                    t.Ucaron = 0x01d3;
                    t.Ucircle = 0x24ca;
                    t.Ucircumflex = 0x00db;
                    t.Ucircumflexbelow = 0x1e76;
                    t.Ucircumflexsmall = 0xf7fb;
                    t.Ucyrillic = 0x0423;
                    t.Udblacute = 0x0170;
                    t.Udblgrave = 0x0214;
                    t.Udieresis = 0x00dc;
                    t.Udieresisacute = 0x01d7;
                    t.Udieresisbelow = 0x1e72;
                    t.Udieresiscaron = 0x01d9;
                    t.Udieresiscyrillic = 0x04f0;
                    t.Udieresisgrave = 0x01db;
                    t.Udieresismacron = 0x01d5;
                    t.Udieresissmall = 0xf7fc;
                    t.Udotbelow = 0x1ee4;
                    t.Ugrave = 0x00d9;
                    t.Ugravesmall = 0xf7f9;
                    t.Uhookabove = 0x1ee6;
                    t.Uhorn = 0x01af;
                    t.Uhornacute = 0x1ee8;
                    t.Uhorndotbelow = 0x1ef0;
                    t.Uhorngrave = 0x1eea;
                    t.Uhornhookabove = 0x1eec;
                    t.Uhorntilde = 0x1eee;
                    t.Uhungarumlaut = 0x0170;
                    t.Uhungarumlautcyrillic = 0x04f2;
                    t.Uinvertedbreve = 0x0216;
                    t.Ukcyrillic = 0x0478;
                    t.Umacron = 0x016a;
                    t.Umacroncyrillic = 0x04ee;
                    t.Umacrondieresis = 0x1e7a;
                    t.Umonospace = 0xff35;
                    t.Uogonek = 0x0172;
                    t.Upsilon = 0x03a5;
                    t.Upsilon1 = 0x03d2;
                    t.Upsilonacutehooksymbolgreek = 0x03d3;
                    t.Upsilonafrican = 0x01b1;
                    t.Upsilondieresis = 0x03ab;
                    t.Upsilondieresishooksymbolgreek = 0x03d4;
                    t.Upsilonhooksymbol = 0x03d2;
                    t.Upsilontonos = 0x038e;
                    t.Uring = 0x016e;
                    t.Ushortcyrillic = 0x040e;
                    t.Usmall = 0xf775;
                    t.Ustraightcyrillic = 0x04ae;
                    t.Ustraightstrokecyrillic = 0x04b0;
                    t.Utilde = 0x0168;
                    t.Utildeacute = 0x1e78;
                    t.Utildebelow = 0x1e74;
                    t.V = 0x0056;
                    t.Vcircle = 0x24cb;
                    t.Vdotbelow = 0x1e7e;
                    t.Vecyrillic = 0x0412;
                    t.Vewarmenian = 0x054e;
                    t.Vhook = 0x01b2;
                    t.Vmonospace = 0xff36;
                    t.Voarmenian = 0x0548;
                    t.Vsmall = 0xf776;
                    t.Vtilde = 0x1e7c;
                    t.W = 0x0057;
                    t.Wacute = 0x1e82;
                    t.Wcircle = 0x24cc;
                    t.Wcircumflex = 0x0174;
                    t.Wdieresis = 0x1e84;
                    t.Wdotaccent = 0x1e86;
                    t.Wdotbelow = 0x1e88;
                    t.Wgrave = 0x1e80;
                    t.Wmonospace = 0xff37;
                    t.Wsmall = 0xf777;
                    t.X = 0x0058;
                    t.Xcircle = 0x24cd;
                    t.Xdieresis = 0x1e8c;
                    t.Xdotaccent = 0x1e8a;
                    t.Xeharmenian = 0x053d;
                    t.Xi = 0x039e;
                    t.Xmonospace = 0xff38;
                    t.Xsmall = 0xf778;
                    t.Y = 0x0059;
                    t.Yacute = 0x00dd;
                    t.Yacutesmall = 0xf7fd;
                    t.Yatcyrillic = 0x0462;
                    t.Ycircle = 0x24ce;
                    t.Ycircumflex = 0x0176;
                    t.Ydieresis = 0x0178;
                    t.Ydieresissmall = 0xf7ff;
                    t.Ydotaccent = 0x1e8e;
                    t.Ydotbelow = 0x1ef4;
                    t.Yericyrillic = 0x042b;
                    t.Yerudieresiscyrillic = 0x04f8;
                    t.Ygrave = 0x1ef2;
                    t.Yhook = 0x01b3;
                    t.Yhookabove = 0x1ef6;
                    t.Yiarmenian = 0x0545;
                    t.Yicyrillic = 0x0407;
                    t.Yiwnarmenian = 0x0552;
                    t.Ymonospace = 0xff39;
                    t.Ysmall = 0xf779;
                    t.Ytilde = 0x1ef8;
                    t.Yusbigcyrillic = 0x046a;
                    t.Yusbigiotifiedcyrillic = 0x046c;
                    t.Yuslittlecyrillic = 0x0466;
                    t.Yuslittleiotifiedcyrillic = 0x0468;
                    t.Z = 0x005a;
                    t.Zaarmenian = 0x0536;
                    t.Zacute = 0x0179;
                    t.Zcaron = 0x017d;
                    t.Zcaronsmall = 0xf6ff;
                    t.Zcircle = 0x24cf;
                    t.Zcircumflex = 0x1e90;
                    t.Zdot = 0x017b;
                    t.Zdotaccent = 0x017b;
                    t.Zdotbelow = 0x1e92;
                    t.Zecyrillic = 0x0417;
                    t.Zedescendercyrillic = 0x0498;
                    t.Zedieresiscyrillic = 0x04de;
                    t.Zeta = 0x0396;
                    t.Zhearmenian = 0x053a;
                    t.Zhebrevecyrillic = 0x04c1;
                    t.Zhecyrillic = 0x0416;
                    t.Zhedescendercyrillic = 0x0496;
                    t.Zhedieresiscyrillic = 0x04dc;
                    t.Zlinebelow = 0x1e94;
                    t.Zmonospace = 0xff3a;
                    t.Zsmall = 0xf77a;
                    t.Zstroke = 0x01b5;
                    t.a = 0x0061;
                    t.aabengali = 0x0986;
                    t.aacute = 0x00e1;
                    t.aadeva = 0x0906;
                    t.aagujarati = 0x0a86;
                    t.aagurmukhi = 0x0a06;
                    t.aamatragurmukhi = 0x0a3e;
                    t.aarusquare = 0x3303;
                    t.aavowelsignbengali = 0x09be;
                    t.aavowelsigndeva = 0x093e;
                    t.aavowelsigngujarati = 0x0abe;
                    t.abbreviationmarkarmenian = 0x055f;
                    t.abbreviationsigndeva = 0x0970;
                    t.abengali = 0x0985;
                    t.abopomofo = 0x311a;
                    t.abreve = 0x0103;
                    t.abreveacute = 0x1eaf;
                    t.abrevecyrillic = 0x04d1;
                    t.abrevedotbelow = 0x1eb7;
                    t.abrevegrave = 0x1eb1;
                    t.abrevehookabove = 0x1eb3;
                    t.abrevetilde = 0x1eb5;
                    t.acaron = 0x01ce;
                    t.acircle = 0x24d0;
                    t.acircumflex = 0x00e2;
                    t.acircumflexacute = 0x1ea5;
                    t.acircumflexdotbelow = 0x1ead;
                    t.acircumflexgrave = 0x1ea7;
                    t.acircumflexhookabove = 0x1ea9;
                    t.acircumflextilde = 0x1eab;
                    t.acute = 0x00b4;
                    t.acutebelowcmb = 0x0317;
                    t.acutecmb = 0x0301;
                    t.acutecomb = 0x0301;
                    t.acutedeva = 0x0954;
                    t.acutelowmod = 0x02cf;
                    t.acutetonecmb = 0x0341;
                    t.acyrillic = 0x0430;
                    t.adblgrave = 0x0201;
                    t.addakgurmukhi = 0x0a71;
                    t.adeva = 0x0905;
                    t.adieresis = 0x00e4;
                    t.adieresiscyrillic = 0x04d3;
                    t.adieresismacron = 0x01df;
                    t.adotbelow = 0x1ea1;
                    t.adotmacron = 0x01e1;
                    t.ae = 0x00e6;
                    t.aeacute = 0x01fd;
                    t.aekorean = 0x3150;
                    t.aemacron = 0x01e3;
                    t.afii00208 = 0x2015;
                    t.afii08941 = 0x20a4;
                    t.afii10017 = 0x0410;
                    t.afii10018 = 0x0411;
                    t.afii10019 = 0x0412;
                    t.afii10020 = 0x0413;
                    t.afii10021 = 0x0414;
                    t.afii10022 = 0x0415;
                    t.afii10023 = 0x0401;
                    t.afii10024 = 0x0416;
                    t.afii10025 = 0x0417;
                    t.afii10026 = 0x0418;
                    t.afii10027 = 0x0419;
                    t.afii10028 = 0x041a;
                    t.afii10029 = 0x041b;
                    t.afii10030 = 0x041c;
                    t.afii10031 = 0x041d;
                    t.afii10032 = 0x041e;
                    t.afii10033 = 0x041f;
                    t.afii10034 = 0x0420;
                    t.afii10035 = 0x0421;
                    t.afii10036 = 0x0422;
                    t.afii10037 = 0x0423;
                    t.afii10038 = 0x0424;
                    t.afii10039 = 0x0425;
                    t.afii10040 = 0x0426;
                    t.afii10041 = 0x0427;
                    t.afii10042 = 0x0428;
                    t.afii10043 = 0x0429;
                    t.afii10044 = 0x042a;
                    t.afii10045 = 0x042b;
                    t.afii10046 = 0x042c;
                    t.afii10047 = 0x042d;
                    t.afii10048 = 0x042e;
                    t.afii10049 = 0x042f;
                    t.afii10050 = 0x0490;
                    t.afii10051 = 0x0402;
                    t.afii10052 = 0x0403;
                    t.afii10053 = 0x0404;
                    t.afii10054 = 0x0405;
                    t.afii10055 = 0x0406;
                    t.afii10056 = 0x0407;
                    t.afii10057 = 0x0408;
                    t.afii10058 = 0x0409;
                    t.afii10059 = 0x040a;
                    t.afii10060 = 0x040b;
                    t.afii10061 = 0x040c;
                    t.afii10062 = 0x040e;
                    t.afii10063 = 0xf6c4;
                    t.afii10064 = 0xf6c5;
                    t.afii10065 = 0x0430;
                    t.afii10066 = 0x0431;
                    t.afii10067 = 0x0432;
                    t.afii10068 = 0x0433;
                    t.afii10069 = 0x0434;
                    t.afii10070 = 0x0435;
                    t.afii10071 = 0x0451;
                    t.afii10072 = 0x0436;
                    t.afii10073 = 0x0437;
                    t.afii10074 = 0x0438;
                    t.afii10075 = 0x0439;
                    t.afii10076 = 0x043a;
                    t.afii10077 = 0x043b;
                    t.afii10078 = 0x043c;
                    t.afii10079 = 0x043d;
                    t.afii10080 = 0x043e;
                    t.afii10081 = 0x043f;
                    t.afii10082 = 0x0440;
                    t.afii10083 = 0x0441;
                    t.afii10084 = 0x0442;
                    t.afii10085 = 0x0443;
                    t.afii10086 = 0x0444;
                    t.afii10087 = 0x0445;
                    t.afii10088 = 0x0446;
                    t.afii10089 = 0x0447;
                    t.afii10090 = 0x0448;
                    t.afii10091 = 0x0449;
                    t.afii10092 = 0x044a;
                    t.afii10093 = 0x044b;
                    t.afii10094 = 0x044c;
                    t.afii10095 = 0x044d;
                    t.afii10096 = 0x044e;
                    t.afii10097 = 0x044f;
                    t.afii10098 = 0x0491;
                    t.afii10099 = 0x0452;
                    t.afii10100 = 0x0453;
                    t.afii10101 = 0x0454;
                    t.afii10102 = 0x0455;
                    t.afii10103 = 0x0456;
                    t.afii10104 = 0x0457;
                    t.afii10105 = 0x0458;
                    t.afii10106 = 0x0459;
                    t.afii10107 = 0x045a;
                    t.afii10108 = 0x045b;
                    t.afii10109 = 0x045c;
                    t.afii10110 = 0x045e;
                    t.afii10145 = 0x040f;
                    t.afii10146 = 0x0462;
                    t.afii10147 = 0x0472;
                    t.afii10148 = 0x0474;
                    t.afii10192 = 0xf6c6;
                    t.afii10193 = 0x045f;
                    t.afii10194 = 0x0463;
                    t.afii10195 = 0x0473;
                    t.afii10196 = 0x0475;
                    t.afii10831 = 0xf6c7;
                    t.afii10832 = 0xf6c8;
                    t.afii10846 = 0x04d9;
                    t.afii299 = 0x200e;
                    t.afii300 = 0x200f;
                    t.afii301 = 0x200d;
                    t.afii57381 = 0x066a;
                    t.afii57388 = 0x060c;
                    t.afii57392 = 0x0660;
                    t.afii57393 = 0x0661;
                    t.afii57394 = 0x0662;
                    t.afii57395 = 0x0663;
                    t.afii57396 = 0x0664;
                    t.afii57397 = 0x0665;
                    t.afii57398 = 0x0666;
                    t.afii57399 = 0x0667;
                    t.afii57400 = 0x0668;
                    t.afii57401 = 0x0669;
                    t.afii57403 = 0x061b;
                    t.afii57407 = 0x061f;
                    t.afii57409 = 0x0621;
                    t.afii57410 = 0x0622;
                    t.afii57411 = 0x0623;
                    t.afii57412 = 0x0624;
                    t.afii57413 = 0x0625;
                    t.afii57414 = 0x0626;
                    t.afii57415 = 0x0627;
                    t.afii57416 = 0x0628;
                    t.afii57417 = 0x0629;
                    t.afii57418 = 0x062a;
                    t.afii57419 = 0x062b;
                    t.afii57420 = 0x062c;
                    t.afii57421 = 0x062d;
                    t.afii57422 = 0x062e;
                    t.afii57423 = 0x062f;
                    t.afii57424 = 0x0630;
                    t.afii57425 = 0x0631;
                    t.afii57426 = 0x0632;
                    t.afii57427 = 0x0633;
                    t.afii57428 = 0x0634;
                    t.afii57429 = 0x0635;
                    t.afii57430 = 0x0636;
                    t.afii57431 = 0x0637;
                    t.afii57432 = 0x0638;
                    t.afii57433 = 0x0639;
                    t.afii57434 = 0x063a;
                    t.afii57440 = 0x0640;
                    t.afii57441 = 0x0641;
                    t.afii57442 = 0x0642;
                    t.afii57443 = 0x0643;
                    t.afii57444 = 0x0644;
                    t.afii57445 = 0x0645;
                    t.afii57446 = 0x0646;
                    t.afii57448 = 0x0648;
                    t.afii57449 = 0x0649;
                    t.afii57450 = 0x064a;
                    t.afii57451 = 0x064b;
                    t.afii57452 = 0x064c;
                    t.afii57453 = 0x064d;
                    t.afii57454 = 0x064e;
                    t.afii57455 = 0x064f;
                    t.afii57456 = 0x0650;
                    t.afii57457 = 0x0651;
                    t.afii57458 = 0x0652;
                    t.afii57470 = 0x0647;
                    t.afii57505 = 0x06a4;
                    t.afii57506 = 0x067e;
                    t.afii57507 = 0x0686;
                    t.afii57508 = 0x0698;
                    t.afii57509 = 0x06af;
                    t.afii57511 = 0x0679;
                    t.afii57512 = 0x0688;
                    t.afii57513 = 0x0691;
                    t.afii57514 = 0x06ba;
                    t.afii57519 = 0x06d2;
                    t.afii57534 = 0x06d5;
                    t.afii57636 = 0x20aa;
                    t.afii57645 = 0x05be;
                    t.afii57658 = 0x05c3;
                    t.afii57664 = 0x05d0;
                    t.afii57665 = 0x05d1;
                    t.afii57666 = 0x05d2;
                    t.afii57667 = 0x05d3;
                    t.afii57668 = 0x05d4;
                    t.afii57669 = 0x05d5;
                    t.afii57670 = 0x05d6;
                    t.afii57671 = 0x05d7;
                    t.afii57672 = 0x05d8;
                    t.afii57673 = 0x05d9;
                    t.afii57674 = 0x05da;
                    t.afii57675 = 0x05db;
                    t.afii57676 = 0x05dc;
                    t.afii57677 = 0x05dd;
                    t.afii57678 = 0x05de;
                    t.afii57679 = 0x05df;
                    t.afii57680 = 0x05e0;
                    t.afii57681 = 0x05e1;
                    t.afii57682 = 0x05e2;
                    t.afii57683 = 0x05e3;
                    t.afii57684 = 0x05e4;
                    t.afii57685 = 0x05e5;
                    t.afii57686 = 0x05e6;
                    t.afii57687 = 0x05e7;
                    t.afii57688 = 0x05e8;
                    t.afii57689 = 0x05e9;
                    t.afii57690 = 0x05ea;
                    t.afii57694 = 0xfb2a;
                    t.afii57695 = 0xfb2b;
                    t.afii57700 = 0xfb4b;
                    t.afii57705 = 0xfb1f;
                    t.afii57716 = 0x05f0;
                    t.afii57717 = 0x05f1;
                    t.afii57718 = 0x05f2;
                    t.afii57723 = 0xfb35;
                    t.afii57793 = 0x05b4;
                    t.afii57794 = 0x05b5;
                    t.afii57795 = 0x05b6;
                    t.afii57796 = 0x05bb;
                    t.afii57797 = 0x05b8;
                    t.afii57798 = 0x05b7;
                    t.afii57799 = 0x05b0;
                    t.afii57800 = 0x05b2;
                    t.afii57801 = 0x05b1;
                    t.afii57802 = 0x05b3;
                    t.afii57803 = 0x05c2;
                    t.afii57804 = 0x05c1;
                    t.afii57806 = 0x05b9;
                    t.afii57807 = 0x05bc;
                    t.afii57839 = 0x05bd;
                    t.afii57841 = 0x05bf;
                    t.afii57842 = 0x05c0;
                    t.afii57929 = 0x02bc;
                    t.afii61248 = 0x2105;
                    t.afii61289 = 0x2113;
                    t.afii61352 = 0x2116;
                    t.afii61573 = 0x202c;
                    t.afii61574 = 0x202d;
                    t.afii61575 = 0x202e;
                    t.afii61664 = 0x200c;
                    t.afii63167 = 0x066d;
                    t.afii64937 = 0x02bd;
                    t.agrave = 0x00e0;
                    t.agujarati = 0x0a85;
                    t.agurmukhi = 0x0a05;
                    t.ahiragana = 0x3042;
                    t.ahookabove = 0x1ea3;
                    t.aibengali = 0x0990;
                    t.aibopomofo = 0x311e;
                    t.aideva = 0x0910;
                    t.aiecyrillic = 0x04d5;
                    t.aigujarati = 0x0a90;
                    t.aigurmukhi = 0x0a10;
                    t.aimatragurmukhi = 0x0a48;
                    t.ainarabic = 0x0639;
                    t.ainfinalarabic = 0xfeca;
                    t.aininitialarabic = 0xfecb;
                    t.ainmedialarabic = 0xfecc;
                    t.ainvertedbreve = 0x0203;
                    t.aivowelsignbengali = 0x09c8;
                    t.aivowelsigndeva = 0x0948;
                    t.aivowelsigngujarati = 0x0ac8;
                    t.akatakana = 0x30a2;
                    t.akatakanahalfwidth = 0xff71;
                    t.akorean = 0x314f;
                    t.alef = 0x05d0;
                    t.alefarabic = 0x0627;
                    t.alefdageshhebrew = 0xfb30;
                    t.aleffinalarabic = 0xfe8e;
                    t.alefhamzaabovearabic = 0x0623;
                    t.alefhamzaabovefinalarabic = 0xfe84;
                    t.alefhamzabelowarabic = 0x0625;
                    t.alefhamzabelowfinalarabic = 0xfe88;
                    t.alefhebrew = 0x05d0;
                    t.aleflamedhebrew = 0xfb4f;
                    t.alefmaddaabovearabic = 0x0622;
                    t.alefmaddaabovefinalarabic = 0xfe82;
                    t.alefmaksuraarabic = 0x0649;
                    t.alefmaksurafinalarabic = 0xfef0;
                    t.alefmaksurainitialarabic = 0xfef3;
                    t.alefmaksuramedialarabic = 0xfef4;
                    t.alefpatahhebrew = 0xfb2e;
                    t.alefqamatshebrew = 0xfb2f;
                    t.aleph = 0x2135;
                    t.allequal = 0x224c;
                    t.alpha = 0x03b1;
                    t.alphatonos = 0x03ac;
                    t.amacron = 0x0101;
                    t.amonospace = 0xff41;
                    t.ampersand = 0x0026;
                    t.ampersandmonospace = 0xff06;
                    t.ampersandsmall = 0xf726;
                    t.amsquare = 0x33c2;
                    t.anbopomofo = 0x3122;
                    t.angbopomofo = 0x3124;
                    t.angbracketleft = 0x3008;
                    t.angbracketright = 0x3009;
                    t.angkhankhuthai = 0x0e5a;
                    t.angle = 0x2220;
                    t.anglebracketleft = 0x3008;
                    t.anglebracketleftvertical = 0xfe3f;
                    t.anglebracketright = 0x3009;
                    t.anglebracketrightvertical = 0xfe40;
                    t.angleleft = 0x2329;
                    t.angleright = 0x232a;
                    t.angstrom = 0x212b;
                    t.anoteleia = 0x0387;
                    t.anudattadeva = 0x0952;
                    t.anusvarabengali = 0x0982;
                    t.anusvaradeva = 0x0902;
                    t.anusvaragujarati = 0x0a82;
                    t.aogonek = 0x0105;
                    t.apaatosquare = 0x3300;
                    t.aparen = 0x249c;
                    t.apostrophearmenian = 0x055a;
                    t.apostrophemod = 0x02bc;
                    t.apple = 0xf8ff;
                    t.approaches = 0x2250;
                    t.approxequal = 0x2248;
                    t.approxequalorimage = 0x2252;
                    t.approximatelyequal = 0x2245;
                    t.araeaekorean = 0x318e;
                    t.araeakorean = 0x318d;
                    t.arc = 0x2312;
                    t.arighthalfring = 0x1e9a;
                    t.aring = 0x00e5;
                    t.aringacute = 0x01fb;
                    t.aringbelow = 0x1e01;
                    t.arrowboth = 0x2194;
                    t.arrowdashdown = 0x21e3;
                    t.arrowdashleft = 0x21e0;
                    t.arrowdashright = 0x21e2;
                    t.arrowdashup = 0x21e1;
                    t.arrowdblboth = 0x21d4;
                    t.arrowdbldown = 0x21d3;
                    t.arrowdblleft = 0x21d0;
                    t.arrowdblright = 0x21d2;
                    t.arrowdblup = 0x21d1;
                    t.arrowdown = 0x2193;
                    t.arrowdownleft = 0x2199;
                    t.arrowdownright = 0x2198;
                    t.arrowdownwhite = 0x21e9;
                    t.arrowheaddownmod = 0x02c5;
                    t.arrowheadleftmod = 0x02c2;
                    t.arrowheadrightmod = 0x02c3;
                    t.arrowheadupmod = 0x02c4;
                    t.arrowhorizex = 0xf8e7;
                    t.arrowleft = 0x2190;
                    t.arrowleftdbl = 0x21d0;
                    t.arrowleftdblstroke = 0x21cd;
                    t.arrowleftoverright = 0x21c6;
                    t.arrowleftwhite = 0x21e6;
                    t.arrowright = 0x2192;
                    t.arrowrightdblstroke = 0x21cf;
                    t.arrowrightheavy = 0x279e;
                    t.arrowrightoverleft = 0x21c4;
                    t.arrowrightwhite = 0x21e8;
                    t.arrowtableft = 0x21e4;
                    t.arrowtabright = 0x21e5;
                    t.arrowup = 0x2191;
                    t.arrowupdn = 0x2195;
                    t.arrowupdnbse = 0x21a8;
                    t.arrowupdownbase = 0x21a8;
                    t.arrowupleft = 0x2196;
                    t.arrowupleftofdown = 0x21c5;
                    t.arrowupright = 0x2197;
                    t.arrowupwhite = 0x21e7;
                    t.arrowvertex = 0xf8e6;
                    t.asciicircum = 0x005e;
                    t.asciicircummonospace = 0xff3e;
                    t.asciitilde = 0x007e;
                    t.asciitildemonospace = 0xff5e;
                    t.ascript = 0x0251;
                    t.ascriptturned = 0x0252;
                    t.asmallhiragana = 0x3041;
                    t.asmallkatakana = 0x30a1;
                    t.asmallkatakanahalfwidth = 0xff67;
                    t.asterisk = 0x002a;
                    t.asteriskaltonearabic = 0x066d;
                    t.asteriskarabic = 0x066d;
                    t.asteriskmath = 0x2217;
                    t.asteriskmonospace = 0xff0a;
                    t.asterisksmall = 0xfe61;
                    t.asterism = 0x2042;
                    t.asuperior = 0xf6e9;
                    t.asymptoticallyequal = 0x2243;
                    t.at = 0x0040;
                    t.atilde = 0x00e3;
                    t.atmonospace = 0xff20;
                    t.atsmall = 0xfe6b;
                    t.aturned = 0x0250;
                    t.aubengali = 0x0994;
                    t.aubopomofo = 0x3120;
                    t.audeva = 0x0914;
                    t.augujarati = 0x0a94;
                    t.augurmukhi = 0x0a14;
                    t.aulengthmarkbengali = 0x09d7;
                    t.aumatragurmukhi = 0x0a4c;
                    t.auvowelsignbengali = 0x09cc;
                    t.auvowelsigndeva = 0x094c;
                    t.auvowelsigngujarati = 0x0acc;
                    t.avagrahadeva = 0x093d;
                    t.aybarmenian = 0x0561;
                    t.ayin = 0x05e2;
                    t.ayinaltonehebrew = 0xfb20;
                    t.ayinhebrew = 0x05e2;
                    t.b = 0x0062;
                    t.babengali = 0x09ac;
                    t.backslash = 0x005c;
                    t.backslashmonospace = 0xff3c;
                    t.badeva = 0x092c;
                    t.bagujarati = 0x0aac;
                    t.bagurmukhi = 0x0a2c;
                    t.bahiragana = 0x3070;
                    t.bahtthai = 0x0e3f;
                    t.bakatakana = 0x30d0;
                    t.bar = 0x007c;
                    t.barmonospace = 0xff5c;
                    t.bbopomofo = 0x3105;
                    t.bcircle = 0x24d1;
                    t.bdotaccent = 0x1e03;
                    t.bdotbelow = 0x1e05;
                    t.beamedsixteenthnotes = 0x266c;
                    t.because = 0x2235;
                    t.becyrillic = 0x0431;
                    t.beharabic = 0x0628;
                    t.behfinalarabic = 0xfe90;
                    t.behinitialarabic = 0xfe91;
                    t.behiragana = 0x3079;
                    t.behmedialarabic = 0xfe92;
                    t.behmeeminitialarabic = 0xfc9f;
                    t.behmeemisolatedarabic = 0xfc08;
                    t.behnoonfinalarabic = 0xfc6d;
                    t.bekatakana = 0x30d9;
                    t.benarmenian = 0x0562;
                    t.bet = 0x05d1;
                    t.beta = 0x03b2;
                    t.betasymbolgreek = 0x03d0;
                    t.betdagesh = 0xfb31;
                    t.betdageshhebrew = 0xfb31;
                    t.bethebrew = 0x05d1;
                    t.betrafehebrew = 0xfb4c;
                    t.bhabengali = 0x09ad;
                    t.bhadeva = 0x092d;
                    t.bhagujarati = 0x0aad;
                    t.bhagurmukhi = 0x0a2d;
                    t.bhook = 0x0253;
                    t.bihiragana = 0x3073;
                    t.bikatakana = 0x30d3;
                    t.bilabialclick = 0x0298;
                    t.bindigurmukhi = 0x0a02;
                    t.birusquare = 0x3331;
                    t.blackcircle = 0x25cf;
                    t.blackdiamond = 0x25c6;
                    t.blackdownpointingtriangle = 0x25bc;
                    t.blackleftpointingpointer = 0x25c4;
                    t.blackleftpointingtriangle = 0x25c0;
                    t.blacklenticularbracketleft = 0x3010;
                    t.blacklenticularbracketleftvertical = 0xfe3b;
                    t.blacklenticularbracketright = 0x3011;
                    t.blacklenticularbracketrightvertical = 0xfe3c;
                    t.blacklowerlefttriangle = 0x25e3;
                    t.blacklowerrighttriangle = 0x25e2;
                    t.blackrectangle = 0x25ac;
                    t.blackrightpointingpointer = 0x25ba;
                    t.blackrightpointingtriangle = 0x25b6;
                    t.blacksmallsquare = 0x25aa;
                    t.blacksmilingface = 0x263b;
                    t.blacksquare = 0x25a0;
                    t.blackstar = 0x2605;
                    t.blackupperlefttriangle = 0x25e4;
                    t.blackupperrighttriangle = 0x25e5;
                    t.blackuppointingsmalltriangle = 0x25b4;
                    t.blackuppointingtriangle = 0x25b2;
                    t.blank = 0x2423;
                    t.blinebelow = 0x1e07;
                    t.block = 0x2588;
                    t.bmonospace = 0xff42;
                    t.bobaimaithai = 0x0e1a;
                    t.bohiragana = 0x307c;
                    t.bokatakana = 0x30dc;
                    t.bparen = 0x249d;
                    t.bqsquare = 0x33c3;
                    t.braceex = 0xf8f4;
                    t.braceleft = 0x007b;
                    t.braceleftbt = 0xf8f3;
                    t.braceleftmid = 0xf8f2;
                    t.braceleftmonospace = 0xff5b;
                    t.braceleftsmall = 0xfe5b;
                    t.bracelefttp = 0xf8f1;
                    t.braceleftvertical = 0xfe37;
                    t.braceright = 0x007d;
                    t.bracerightbt = 0xf8fe;
                    t.bracerightmid = 0xf8fd;
                    t.bracerightmonospace = 0xff5d;
                    t.bracerightsmall = 0xfe5c;
                    t.bracerighttp = 0xf8fc;
                    t.bracerightvertical = 0xfe38;
                    t.bracketleft = 0x005b;
                    t.bracketleftbt = 0xf8f0;
                    t.bracketleftex = 0xf8ef;
                    t.bracketleftmonospace = 0xff3b;
                    t.bracketlefttp = 0xf8ee;
                    t.bracketright = 0x005d;
                    t.bracketrightbt = 0xf8fb;
                    t.bracketrightex = 0xf8fa;
                    t.bracketrightmonospace = 0xff3d;
                    t.bracketrighttp = 0xf8f9;
                    t.breve = 0x02d8;
                    t.brevebelowcmb = 0x032e;
                    t.brevecmb = 0x0306;
                    t.breveinvertedbelowcmb = 0x032f;
                    t.breveinvertedcmb = 0x0311;
                    t.breveinverteddoublecmb = 0x0361;
                    t.bridgebelowcmb = 0x032a;
                    t.bridgeinvertedbelowcmb = 0x033a;
                    t.brokenbar = 0x00a6;
                    t.bstroke = 0x0180;
                    t.bsuperior = 0xf6ea;
                    t.btopbar = 0x0183;
                    t.buhiragana = 0x3076;
                    t.bukatakana = 0x30d6;
                    t.bullet = 0x2022;
                    t.bulletinverse = 0x25d8;
                    t.bulletoperator = 0x2219;
                    t.bullseye = 0x25ce;
                    t.c = 0x0063;
                    t.caarmenian = 0x056e;
                    t.cabengali = 0x099a;
                    t.cacute = 0x0107;
                    t.cadeva = 0x091a;
                    t.cagujarati = 0x0a9a;
                    t.cagurmukhi = 0x0a1a;
                    t.calsquare = 0x3388;
                    t.candrabindubengali = 0x0981;
                    t.candrabinducmb = 0x0310;
                    t.candrabindudeva = 0x0901;
                    t.candrabindugujarati = 0x0a81;
                    t.capslock = 0x21ea;
                    t.careof = 0x2105;
                    t.caron = 0x02c7;
                    t.caronbelowcmb = 0x032c;
                    t.caroncmb = 0x030c;
                    t.carriagereturn = 0x21b5;
                    t.cbopomofo = 0x3118;
                    t.ccaron = 0x010d;
                    t.ccedilla = 0x00e7;
                    t.ccedillaacute = 0x1e09;
                    t.ccircle = 0x24d2;
                    t.ccircumflex = 0x0109;
                    t.ccurl = 0x0255;
                    t.cdot = 0x010b;
                    t.cdotaccent = 0x010b;
                    t.cdsquare = 0x33c5;
                    t.cedilla = 0x00b8;
                    t.cedillacmb = 0x0327;
                    t.cent = 0x00a2;
                    t.centigrade = 0x2103;
                    t.centinferior = 0xf6df;
                    t.centmonospace = 0xffe0;
                    t.centoldstyle = 0xf7a2;
                    t.centsuperior = 0xf6e0;
                    t.chaarmenian = 0x0579;
                    t.chabengali = 0x099b;
                    t.chadeva = 0x091b;
                    t.chagujarati = 0x0a9b;
                    t.chagurmukhi = 0x0a1b;
                    t.chbopomofo = 0x3114;
                    t.cheabkhasiancyrillic = 0x04bd;
                    t.checkmark = 0x2713;
                    t.checyrillic = 0x0447;
                    t.chedescenderabkhasiancyrillic = 0x04bf;
                    t.chedescendercyrillic = 0x04b7;
                    t.chedieresiscyrillic = 0x04f5;
                    t.cheharmenian = 0x0573;
                    t.chekhakassiancyrillic = 0x04cc;
                    t.cheverticalstrokecyrillic = 0x04b9;
                    t.chi = 0x03c7;
                    t.chieuchacirclekorean = 0x3277;
                    t.chieuchaparenkorean = 0x3217;
                    t.chieuchcirclekorean = 0x3269;
                    t.chieuchkorean = 0x314a;
                    t.chieuchparenkorean = 0x3209;
                    t.chochangthai = 0x0e0a;
                    t.chochanthai = 0x0e08;
                    t.chochingthai = 0x0e09;
                    t.chochoethai = 0x0e0c;
                    t.chook = 0x0188;
                    t.cieucacirclekorean = 0x3276;
                    t.cieucaparenkorean = 0x3216;
                    t.cieuccirclekorean = 0x3268;
                    t.cieuckorean = 0x3148;
                    t.cieucparenkorean = 0x3208;
                    t.cieucuparenkorean = 0x321c;
                    t.circle = 0x25cb;
                    t.circlecopyrt = 0x00a9;
                    t.circlemultiply = 0x2297;
                    t.circleot = 0x2299;
                    t.circleplus = 0x2295;
                    t.circlepostalmark = 0x3036;
                    t.circlewithlefthalfblack = 0x25d0;
                    t.circlewithrighthalfblack = 0x25d1;
                    t.circumflex = 0x02c6;
                    t.circumflexbelowcmb = 0x032d;
                    t.circumflexcmb = 0x0302;
                    t.clear = 0x2327;
                    t.clickalveolar = 0x01c2;
                    t.clickdental = 0x01c0;
                    t.clicklateral = 0x01c1;
                    t.clickretroflex = 0x01c3;
                    t.club = 0x2663;
                    t.clubsuitblack = 0x2663;
                    t.clubsuitwhite = 0x2667;
                    t.cmcubedsquare = 0x33a4;
                    t.cmonospace = 0xff43;
                    t.cmsquaredsquare = 0x33a0;
                    t.coarmenian = 0x0581;
                    t.colon = 0x003a;
                    t.colonmonetary = 0x20a1;
                    t.colonmonospace = 0xff1a;
                    t.colonsign = 0x20a1;
                    t.colonsmall = 0xfe55;
                    t.colontriangularhalfmod = 0x02d1;
                    t.colontriangularmod = 0x02d0;
                    t.comma = 0x002c;
                    t.commaabovecmb = 0x0313;
                    t.commaaboverightcmb = 0x0315;
                    t.commaaccent = 0xf6c3;
                    t.commaarabic = 0x060c;
                    t.commaarmenian = 0x055d;
                    t.commainferior = 0xf6e1;
                    t.commamonospace = 0xff0c;
                    t.commareversedabovecmb = 0x0314;
                    t.commareversedmod = 0x02bd;
                    t.commasmall = 0xfe50;
                    t.commasuperior = 0xf6e2;
                    t.commaturnedabovecmb = 0x0312;
                    t.commaturnedmod = 0x02bb;
                    t.compass = 0x263c;
                    t.congruent = 0x2245;
                    t.contourintegral = 0x222e;
                    t.control = 0x2303;
                    t.controlACK = 0x0006;
                    t.controlBEL = 0x0007;
                    t.controlBS = 0x0008;
                    t.controlCAN = 0x0018;
                    t.controlCR = 0x000d;
                    t.controlDC1 = 0x0011;
                    t.controlDC2 = 0x0012;
                    t.controlDC3 = 0x0013;
                    t.controlDC4 = 0x0014;
                    t.controlDEL = 0x007f;
                    t.controlDLE = 0x0010;
                    t.controlEM = 0x0019;
                    t.controlENQ = 0x0005;
                    t.controlEOT = 0x0004;
                    t.controlESC = 0x001b;
                    t.controlETB = 0x0017;
                    t.controlETX = 0x0003;
                    t.controlFF = 0x000c;
                    t.controlFS = 0x001c;
                    t.controlGS = 0x001d;
                    t.controlHT = 0x0009;
                    t.controlLF = 0x000a;
                    t.controlNAK = 0x0015;
                    t.controlNULL = 0x0000;
                    t.controlRS = 0x001e;
                    t.controlSI = 0x000f;
                    t.controlSO = 0x000e;
                    t.controlSOT = 0x0002;
                    t.controlSTX = 0x0001;
                    t.controlSUB = 0x001a;
                    t.controlSYN = 0x0016;
                    t.controlUS = 0x001f;
                    t.controlVT = 0x000b;
                    t.copyright = 0x00a9;
                    t.copyrightsans = 0xf8e9;
                    t.copyrightserif = 0xf6d9;
                    t.cornerbracketleft = 0x300c;
                    t.cornerbracketlefthalfwidth = 0xff62;
                    t.cornerbracketleftvertical = 0xfe41;
                    t.cornerbracketright = 0x300d;
                    t.cornerbracketrighthalfwidth = 0xff63;
                    t.cornerbracketrightvertical = 0xfe42;
                    t.corporationsquare = 0x337f;
                    t.cosquare = 0x33c7;
                    t.coverkgsquare = 0x33c6;
                    t.cparen = 0x249e;
                    t.cruzeiro = 0x20a2;
                    t.cstretched = 0x0297;
                    t.curlyand = 0x22cf;
                    t.curlyor = 0x22ce;
                    t.currency = 0x00a4;
                    t.cyrBreve = 0xf6d1;
                    t.cyrFlex = 0xf6d2;
                    t.cyrbreve = 0xf6d4;
                    t.cyrflex = 0xf6d5;
                    t.d = 0x0064;
                    t.daarmenian = 0x0564;
                    t.dabengali = 0x09a6;
                    t.dadarabic = 0x0636;
                    t.dadeva = 0x0926;
                    t.dadfinalarabic = 0xfebe;
                    t.dadinitialarabic = 0xfebf;
                    t.dadmedialarabic = 0xfec0;
                    t.dagesh = 0x05bc;
                    t.dageshhebrew = 0x05bc;
                    t.dagger = 0x2020;
                    t.daggerdbl = 0x2021;
                    t.dagujarati = 0x0aa6;
                    t.dagurmukhi = 0x0a26;
                    t.dahiragana = 0x3060;
                    t.dakatakana = 0x30c0;
                    t.dalarabic = 0x062f;
                    t.dalet = 0x05d3;
                    t.daletdagesh = 0xfb33;
                    t.daletdageshhebrew = 0xfb33;
                    t.dalethebrew = 0x05d3;
                    t.dalfinalarabic = 0xfeaa;
                    t.dammaarabic = 0x064f;
                    t.dammalowarabic = 0x064f;
                    t.dammatanaltonearabic = 0x064c;
                    t.dammatanarabic = 0x064c;
                    t.danda = 0x0964;
                    t.dargahebrew = 0x05a7;
                    t.dargalefthebrew = 0x05a7;
                    t.dasiapneumatacyrilliccmb = 0x0485;
                    t.dblGrave = 0xf6d3;
                    t.dblanglebracketleft = 0x300a;
                    t.dblanglebracketleftvertical = 0xfe3d;
                    t.dblanglebracketright = 0x300b;
                    t.dblanglebracketrightvertical = 0xfe3e;
                    t.dblarchinvertedbelowcmb = 0x032b;
                    t.dblarrowleft = 0x21d4;
                    t.dblarrowright = 0x21d2;
                    t.dbldanda = 0x0965;
                    t.dblgrave = 0xf6d6;
                    t.dblgravecmb = 0x030f;
                    t.dblintegral = 0x222c;
                    t.dbllowline = 0x2017;
                    t.dbllowlinecmb = 0x0333;
                    t.dbloverlinecmb = 0x033f;
                    t.dblprimemod = 0x02ba;
                    t.dblverticalbar = 0x2016;
                    t.dblverticallineabovecmb = 0x030e;
                    t.dbopomofo = 0x3109;
                    t.dbsquare = 0x33c8;
                    t.dcaron = 0x010f;
                    t.dcedilla = 0x1e11;
                    t.dcircle = 0x24d3;
                    t.dcircumflexbelow = 0x1e13;
                    t.dcroat = 0x0111;
                    t.ddabengali = 0x09a1;
                    t.ddadeva = 0x0921;
                    t.ddagujarati = 0x0aa1;
                    t.ddagurmukhi = 0x0a21;
                    t.ddalarabic = 0x0688;
                    t.ddalfinalarabic = 0xfb89;
                    t.dddhadeva = 0x095c;
                    t.ddhabengali = 0x09a2;
                    t.ddhadeva = 0x0922;
                    t.ddhagujarati = 0x0aa2;
                    t.ddhagurmukhi = 0x0a22;
                    t.ddotaccent = 0x1e0b;
                    t.ddotbelow = 0x1e0d;
                    t.decimalseparatorarabic = 0x066b;
                    t.decimalseparatorpersian = 0x066b;
                    t.decyrillic = 0x0434;
                    t.degree = 0x00b0;
                    t.dehihebrew = 0x05ad;
                    t.dehiragana = 0x3067;
                    t.deicoptic = 0x03ef;
                    t.dekatakana = 0x30c7;
                    t.deleteleft = 0x232b;
                    t.deleteright = 0x2326;
                    t.delta = 0x03b4;
                    t.deltaturned = 0x018d;
                    t.denominatorminusonenumeratorbengali = 0x09f8;
                    t.dezh = 0x02a4;
                    t.dhabengali = 0x09a7;
                    t.dhadeva = 0x0927;
                    t.dhagujarati = 0x0aa7;
                    t.dhagurmukhi = 0x0a27;
                    t.dhook = 0x0257;
                    t.dialytikatonos = 0x0385;
                    t.dialytikatonoscmb = 0x0344;
                    t.diamond = 0x2666;
                    t.diamondsuitwhite = 0x2662;
                    t.dieresis = 0x00a8;
                    t.dieresisacute = 0xf6d7;
                    t.dieresisbelowcmb = 0x0324;
                    t.dieresiscmb = 0x0308;
                    t.dieresisgrave = 0xf6d8;
                    t.dieresistonos = 0x0385;
                    t.dihiragana = 0x3062;
                    t.dikatakana = 0x30c2;
                    t.dittomark = 0x3003;
                    t.divide = 0x00f7;
                    t.divides = 0x2223;
                    t.divisionslash = 0x2215;
                    t.djecyrillic = 0x0452;
                    t.dkshade = 0x2593;
                    t.dlinebelow = 0x1e0f;
                    t.dlsquare = 0x3397;
                    t.dmacron = 0x0111;
                    t.dmonospace = 0xff44;
                    t.dnblock = 0x2584;
                    t.dochadathai = 0x0e0e;
                    t.dodekthai = 0x0e14;
                    t.dohiragana = 0x3069;
                    t.dokatakana = 0x30c9;
                    t.dollar = 0x0024;
                    t.dollarinferior = 0xf6e3;
                    t.dollarmonospace = 0xff04;
                    t.dollaroldstyle = 0xf724;
                    t.dollarsmall = 0xfe69;
                    t.dollarsuperior = 0xf6e4;
                    t.dong = 0x20ab;
                    t.dorusquare = 0x3326;
                    t.dotaccent = 0x02d9;
                    t.dotaccentcmb = 0x0307;
                    t.dotbelowcmb = 0x0323;
                    t.dotbelowcomb = 0x0323;
                    t.dotkatakana = 0x30fb;
                    t.dotlessi = 0x0131;
                    t.dotlessj = 0xf6be;
                    t.dotlessjstrokehook = 0x0284;
                    t.dotmath = 0x22c5;
                    t.dottedcircle = 0x25cc;
                    t.doubleyodpatah = 0xfb1f;
                    t.doubleyodpatahhebrew = 0xfb1f;
                    t.downtackbelowcmb = 0x031e;
                    t.downtackmod = 0x02d5;
                    t.dparen = 0x249f;
                    t.dsuperior = 0xf6eb;
                    t.dtail = 0x0256;
                    t.dtopbar = 0x018c;
                    t.duhiragana = 0x3065;
                    t.dukatakana = 0x30c5;
                    t.dz = 0x01f3;
                    t.dzaltone = 0x02a3;
                    t.dzcaron = 0x01c6;
                    t.dzcurl = 0x02a5;
                    t.dzeabkhasiancyrillic = 0x04e1;
                    t.dzecyrillic = 0x0455;
                    t.dzhecyrillic = 0x045f;
                    t.e = 0x0065;
                    t.eacute = 0x00e9;
                    t.earth = 0x2641;
                    t.ebengali = 0x098f;
                    t.ebopomofo = 0x311c;
                    t.ebreve = 0x0115;
                    t.ecandradeva = 0x090d;
                    t.ecandragujarati = 0x0a8d;
                    t.ecandravowelsigndeva = 0x0945;
                    t.ecandravowelsigngujarati = 0x0ac5;
                    t.ecaron = 0x011b;
                    t.ecedillabreve = 0x1e1d;
                    t.echarmenian = 0x0565;
                    t.echyiwnarmenian = 0x0587;
                    t.ecircle = 0x24d4;
                    t.ecircumflex = 0x00ea;
                    t.ecircumflexacute = 0x1ebf;
                    t.ecircumflexbelow = 0x1e19;
                    t.ecircumflexdotbelow = 0x1ec7;
                    t.ecircumflexgrave = 0x1ec1;
                    t.ecircumflexhookabove = 0x1ec3;
                    t.ecircumflextilde = 0x1ec5;
                    t.ecyrillic = 0x0454;
                    t.edblgrave = 0x0205;
                    t.edeva = 0x090f;
                    t.edieresis = 0x00eb;
                    t.edot = 0x0117;
                    t.edotaccent = 0x0117;
                    t.edotbelow = 0x1eb9;
                    t.eegurmukhi = 0x0a0f;
                    t.eematragurmukhi = 0x0a47;
                    t.efcyrillic = 0x0444;
                    t.egrave = 0x00e8;
                    t.egujarati = 0x0a8f;
                    t.eharmenian = 0x0567;
                    t.ehbopomofo = 0x311d;
                    t.ehiragana = 0x3048;
                    t.ehookabove = 0x1ebb;
                    t.eibopomofo = 0x311f;
                    t.eight = 0x0038;
                    t.eightarabic = 0x0668;
                    t.eightbengali = 0x09ee;
                    t.eightcircle = 0x2467;
                    t.eightcircleinversesansserif = 0x2791;
                    t.eightdeva = 0x096e;
                    t.eighteencircle = 0x2471;
                    t.eighteenparen = 0x2485;
                    t.eighteenperiod = 0x2499;
                    t.eightgujarati = 0x0aee;
                    t.eightgurmukhi = 0x0a6e;
                    t.eighthackarabic = 0x0668;
                    t.eighthangzhou = 0x3028;
                    t.eighthnotebeamed = 0x266b;
                    t.eightideographicparen = 0x3227;
                    t.eightinferior = 0x2088;
                    t.eightmonospace = 0xff18;
                    t.eightoldstyle = 0xf738;
                    t.eightparen = 0x247b;
                    t.eightperiod = 0x248f;
                    t.eightpersian = 0x06f8;
                    t.eightroman = 0x2177;
                    t.eightsuperior = 0x2078;
                    t.eightthai = 0x0e58;
                    t.einvertedbreve = 0x0207;
                    t.eiotifiedcyrillic = 0x0465;
                    t.ekatakana = 0x30a8;
                    t.ekatakanahalfwidth = 0xff74;
                    t.ekonkargurmukhi = 0x0a74;
                    t.ekorean = 0x3154;
                    t.elcyrillic = 0x043b;
                    t.element = 0x2208;
                    t.elevencircle = 0x246a;
                    t.elevenparen = 0x247e;
                    t.elevenperiod = 0x2492;
                    t.elevenroman = 0x217a;
                    t.ellipsis = 0x2026;
                    t.ellipsisvertical = 0x22ee;
                    t.emacron = 0x0113;
                    t.emacronacute = 0x1e17;
                    t.emacrongrave = 0x1e15;
                    t.emcyrillic = 0x043c;
                    t.emdash = 0x2014;
                    t.emdashvertical = 0xfe31;
                    t.emonospace = 0xff45;
                    t.emphasismarkarmenian = 0x055b;
                    t.emptyset = 0x2205;
                    t.enbopomofo = 0x3123;
                    t.encyrillic = 0x043d;
                    t.endash = 0x2013;
                    t.endashvertical = 0xfe32;
                    t.endescendercyrillic = 0x04a3;
                    t.eng = 0x014b;
                    t.engbopomofo = 0x3125;
                    t.enghecyrillic = 0x04a5;
                    t.enhookcyrillic = 0x04c8;
                    t.enspace = 0x2002;
                    t.eogonek = 0x0119;
                    t.eokorean = 0x3153;
                    t.eopen = 0x025b;
                    t.eopenclosed = 0x029a;
                    t.eopenreversed = 0x025c;
                    t.eopenreversedclosed = 0x025e;
                    t.eopenreversedhook = 0x025d;
                    t.eparen = 0x24a0;
                    t.epsilon = 0x03b5;
                    t.epsilontonos = 0x03ad;
                    t.equal = 0x003d;
                    t.equalmonospace = 0xff1d;
                    t.equalsmall = 0xfe66;
                    t.equalsuperior = 0x207c;
                    t.equivalence = 0x2261;
                    t.erbopomofo = 0x3126;
                    t.ercyrillic = 0x0440;
                    t.ereversed = 0x0258;
                    t.ereversedcyrillic = 0x044d;
                    t.escyrillic = 0x0441;
                    t.esdescendercyrillic = 0x04ab;
                    t.esh = 0x0283;
                    t.eshcurl = 0x0286;
                    t.eshortdeva = 0x090e;
                    t.eshortvowelsigndeva = 0x0946;
                    t.eshreversedloop = 0x01aa;
                    t.eshsquatreversed = 0x0285;
                    t.esmallhiragana = 0x3047;
                    t.esmallkatakana = 0x30a7;
                    t.esmallkatakanahalfwidth = 0xff6a;
                    t.estimated = 0x212e;
                    t.esuperior = 0xf6ec;
                    t.eta = 0x03b7;
                    t.etarmenian = 0x0568;
                    t.etatonos = 0x03ae;
                    t.eth = 0x00f0;
                    t.etilde = 0x1ebd;
                    t.etildebelow = 0x1e1b;
                    t.etnahtafoukhhebrew = 0x0591;
                    t.etnahtafoukhlefthebrew = 0x0591;
                    t.etnahtahebrew = 0x0591;
                    t.etnahtalefthebrew = 0x0591;
                    t.eturned = 0x01dd;
                    t.eukorean = 0x3161;
                    t.euro = 0x20ac;
                    t.evowelsignbengali = 0x09c7;
                    t.evowelsigndeva = 0x0947;
                    t.evowelsigngujarati = 0x0ac7;
                    t.exclam = 0x0021;
                    t.exclamarmenian = 0x055c;
                    t.exclamdbl = 0x203c;
                    t.exclamdown = 0x00a1;
                    t.exclamdownsmall = 0xf7a1;
                    t.exclammonospace = 0xff01;
                    t.exclamsmall = 0xf721;
                    t.existential = 0x2203;
                    t.ezh = 0x0292;
                    t.ezhcaron = 0x01ef;
                    t.ezhcurl = 0x0293;
                    t.ezhreversed = 0x01b9;
                    t.ezhtail = 0x01ba;
                    t.f = 0x0066;
                    t.fadeva = 0x095e;
                    t.fagurmukhi = 0x0a5e;
                    t.fahrenheit = 0x2109;
                    t.fathaarabic = 0x064e;
                    t.fathalowarabic = 0x064e;
                    t.fathatanarabic = 0x064b;
                    t.fbopomofo = 0x3108;
                    t.fcircle = 0x24d5;
                    t.fdotaccent = 0x1e1f;
                    t.feharabic = 0x0641;
                    t.feharmenian = 0x0586;
                    t.fehfinalarabic = 0xfed2;
                    t.fehinitialarabic = 0xfed3;
                    t.fehmedialarabic = 0xfed4;
                    t.feicoptic = 0x03e5;
                    t.female = 0x2640;
                    t.ff = 0xfb00;
                    t.f_f = 0xfb00;
                    t.ffi = 0xfb03;
                    t.f_f_i = 0xfb03;
                    t.ffl = 0xfb04;
                    t.f_f_l = 0xfb04;
                    t.fi = 0xfb01;
                    t.f_i = 0xfb01;
                    t.fifteencircle = 0x246e;
                    t.fifteenparen = 0x2482;
                    t.fifteenperiod = 0x2496;
                    t.figuredash = 0x2012;
                    t.filledbox = 0x25a0;
                    t.filledrect = 0x25ac;
                    t.finalkaf = 0x05da;
                    t.finalkafdagesh = 0xfb3a;
                    t.finalkafdageshhebrew = 0xfb3a;
                    t.finalkafhebrew = 0x05da;
                    t.finalmem = 0x05dd;
                    t.finalmemhebrew = 0x05dd;
                    t.finalnun = 0x05df;
                    t.finalnunhebrew = 0x05df;
                    t.finalpe = 0x05e3;
                    t.finalpehebrew = 0x05e3;
                    t.finaltsadi = 0x05e5;
                    t.finaltsadihebrew = 0x05e5;
                    t.firsttonechinese = 0x02c9;
                    t.fisheye = 0x25c9;
                    t.fitacyrillic = 0x0473;
                    t.five = 0x0035;
                    t.fivearabic = 0x0665;
                    t.fivebengali = 0x09eb;
                    t.fivecircle = 0x2464;
                    t.fivecircleinversesansserif = 0x278e;
                    t.fivedeva = 0x096b;
                    t.fiveeighths = 0x215d;
                    t.fivegujarati = 0x0aeb;
                    t.fivegurmukhi = 0x0a6b;
                    t.fivehackarabic = 0x0665;
                    t.fivehangzhou = 0x3025;
                    t.fiveideographicparen = 0x3224;
                    t.fiveinferior = 0x2085;
                    t.fivemonospace = 0xff15;
                    t.fiveoldstyle = 0xf735;
                    t.fiveparen = 0x2478;
                    t.fiveperiod = 0x248c;
                    t.fivepersian = 0x06f5;
                    t.fiveroman = 0x2174;
                    t.fivesuperior = 0x2075;
                    t.fivethai = 0x0e55;
                    t.fl = 0xfb02;
                    t.f_l = 0xfb02;
                    t.florin = 0x0192;
                    t.fmonospace = 0xff46;
                    t.fmsquare = 0x3399;
                    t.fofanthai = 0x0e1f;
                    t.fofathai = 0x0e1d;
                    t.fongmanthai = 0x0e4f;
                    t.forall = 0x2200;
                    t.four = 0x0034;
                    t.fourarabic = 0x0664;
                    t.fourbengali = 0x09ea;
                    t.fourcircle = 0x2463;
                    t.fourcircleinversesansserif = 0x278d;
                    t.fourdeva = 0x096a;
                    t.fourgujarati = 0x0aea;
                    t.fourgurmukhi = 0x0a6a;
                    t.fourhackarabic = 0x0664;
                    t.fourhangzhou = 0x3024;
                    t.fourideographicparen = 0x3223;
                    t.fourinferior = 0x2084;
                    t.fourmonospace = 0xff14;
                    t.fournumeratorbengali = 0x09f7;
                    t.fouroldstyle = 0xf734;
                    t.fourparen = 0x2477;
                    t.fourperiod = 0x248b;
                    t.fourpersian = 0x06f4;
                    t.fourroman = 0x2173;
                    t.foursuperior = 0x2074;
                    t.fourteencircle = 0x246d;
                    t.fourteenparen = 0x2481;
                    t.fourteenperiod = 0x2495;
                    t.fourthai = 0x0e54;
                    t.fourthtonechinese = 0x02cb;
                    t.fparen = 0x24a1;
                    t.fraction = 0x2044;
                    t.franc = 0x20a3;
                    t.g = 0x0067;
                    t.gabengali = 0x0997;
                    t.gacute = 0x01f5;
                    t.gadeva = 0x0917;
                    t.gafarabic = 0x06af;
                    t.gaffinalarabic = 0xfb93;
                    t.gafinitialarabic = 0xfb94;
                    t.gafmedialarabic = 0xfb95;
                    t.gagujarati = 0x0a97;
                    t.gagurmukhi = 0x0a17;
                    t.gahiragana = 0x304c;
                    t.gakatakana = 0x30ac;
                    t.gamma = 0x03b3;
                    t.gammalatinsmall = 0x0263;
                    t.gammasuperior = 0x02e0;
                    t.gangiacoptic = 0x03eb;
                    t.gbopomofo = 0x310d;
                    t.gbreve = 0x011f;
                    t.gcaron = 0x01e7;
                    t.gcedilla = 0x0123;
                    t.gcircle = 0x24d6;
                    t.gcircumflex = 0x011d;
                    t.gcommaaccent = 0x0123;
                    t.gdot = 0x0121;
                    t.gdotaccent = 0x0121;
                    t.gecyrillic = 0x0433;
                    t.gehiragana = 0x3052;
                    t.gekatakana = 0x30b2;
                    t.geometricallyequal = 0x2251;
                    t.gereshaccenthebrew = 0x059c;
                    t.gereshhebrew = 0x05f3;
                    t.gereshmuqdamhebrew = 0x059d;
                    t.germandbls = 0x00df;
                    t.gershayimaccenthebrew = 0x059e;
                    t.gershayimhebrew = 0x05f4;
                    t.getamark = 0x3013;
                    t.ghabengali = 0x0998;
                    t.ghadarmenian = 0x0572;
                    t.ghadeva = 0x0918;
                    t.ghagujarati = 0x0a98;
                    t.ghagurmukhi = 0x0a18;
                    t.ghainarabic = 0x063a;
                    t.ghainfinalarabic = 0xfece;
                    t.ghaininitialarabic = 0xfecf;
                    t.ghainmedialarabic = 0xfed0;
                    t.ghemiddlehookcyrillic = 0x0495;
                    t.ghestrokecyrillic = 0x0493;
                    t.gheupturncyrillic = 0x0491;
                    t.ghhadeva = 0x095a;
                    t.ghhagurmukhi = 0x0a5a;
                    t.ghook = 0x0260;
                    t.ghzsquare = 0x3393;
                    t.gihiragana = 0x304e;
                    t.gikatakana = 0x30ae;
                    t.gimarmenian = 0x0563;
                    t.gimel = 0x05d2;
                    t.gimeldagesh = 0xfb32;
                    t.gimeldageshhebrew = 0xfb32;
                    t.gimelhebrew = 0x05d2;
                    t.gjecyrillic = 0x0453;
                    t.glottalinvertedstroke = 0x01be;
                    t.glottalstop = 0x0294;
                    t.glottalstopinverted = 0x0296;
                    t.glottalstopmod = 0x02c0;
                    t.glottalstopreversed = 0x0295;
                    t.glottalstopreversedmod = 0x02c1;
                    t.glottalstopreversedsuperior = 0x02e4;
                    t.glottalstopstroke = 0x02a1;
                    t.glottalstopstrokereversed = 0x02a2;
                    t.gmacron = 0x1e21;
                    t.gmonospace = 0xff47;
                    t.gohiragana = 0x3054;
                    t.gokatakana = 0x30b4;
                    t.gparen = 0x24a2;
                    t.gpasquare = 0x33ac;
                    t.gradient = 0x2207;
                    t.grave = 0x0060;
                    t.gravebelowcmb = 0x0316;
                    t.gravecmb = 0x0300;
                    t.gravecomb = 0x0300;
                    t.gravedeva = 0x0953;
                    t.gravelowmod = 0x02ce;
                    t.gravemonospace = 0xff40;
                    t.gravetonecmb = 0x0340;
                    t.greater = 0x003e;
                    t.greaterequal = 0x2265;
                    t.greaterequalorless = 0x22db;
                    t.greatermonospace = 0xff1e;
                    t.greaterorequivalent = 0x2273;
                    t.greaterorless = 0x2277;
                    t.greateroverequal = 0x2267;
                    t.greatersmall = 0xfe65;
                    t.gscript = 0x0261;
                    t.gstroke = 0x01e5;
                    t.guhiragana = 0x3050;
                    t.guillemotleft = 0x00ab;
                    t.guillemotright = 0x00bb;
                    t.guilsinglleft = 0x2039;
                    t.guilsinglright = 0x203a;
                    t.gukatakana = 0x30b0;
                    t.guramusquare = 0x3318;
                    t.gysquare = 0x33c9;
                    t.h = 0x0068;
                    t.haabkhasiancyrillic = 0x04a9;
                    t.haaltonearabic = 0x06c1;
                    t.habengali = 0x09b9;
                    t.hadescendercyrillic = 0x04b3;
                    t.hadeva = 0x0939;
                    t.hagujarati = 0x0ab9;
                    t.hagurmukhi = 0x0a39;
                    t.haharabic = 0x062d;
                    t.hahfinalarabic = 0xfea2;
                    t.hahinitialarabic = 0xfea3;
                    t.hahiragana = 0x306f;
                    t.hahmedialarabic = 0xfea4;
                    t.haitusquare = 0x332a;
                    t.hakatakana = 0x30cf;
                    t.hakatakanahalfwidth = 0xff8a;
                    t.halantgurmukhi = 0x0a4d;
                    t.hamzaarabic = 0x0621;
                    t.hamzalowarabic = 0x0621;
                    t.hangulfiller = 0x3164;
                    t.hardsigncyrillic = 0x044a;
                    t.harpoonleftbarbup = 0x21bc;
                    t.harpoonrightbarbup = 0x21c0;
                    t.hasquare = 0x33ca;
                    t.hatafpatah = 0x05b2;
                    t.hatafpatah16 = 0x05b2;
                    t.hatafpatah23 = 0x05b2;
                    t.hatafpatah2f = 0x05b2;
                    t.hatafpatahhebrew = 0x05b2;
                    t.hatafpatahnarrowhebrew = 0x05b2;
                    t.hatafpatahquarterhebrew = 0x05b2;
                    t.hatafpatahwidehebrew = 0x05b2;
                    t.hatafqamats = 0x05b3;
                    t.hatafqamats1b = 0x05b3;
                    t.hatafqamats28 = 0x05b3;
                    t.hatafqamats34 = 0x05b3;
                    t.hatafqamatshebrew = 0x05b3;
                    t.hatafqamatsnarrowhebrew = 0x05b3;
                    t.hatafqamatsquarterhebrew = 0x05b3;
                    t.hatafqamatswidehebrew = 0x05b3;
                    t.hatafsegol = 0x05b1;
                    t.hatafsegol17 = 0x05b1;
                    t.hatafsegol24 = 0x05b1;
                    t.hatafsegol30 = 0x05b1;
                    t.hatafsegolhebrew = 0x05b1;
                    t.hatafsegolnarrowhebrew = 0x05b1;
                    t.hatafsegolquarterhebrew = 0x05b1;
                    t.hatafsegolwidehebrew = 0x05b1;
                    t.hbar = 0x0127;
                    t.hbopomofo = 0x310f;
                    t.hbrevebelow = 0x1e2b;
                    t.hcedilla = 0x1e29;
                    t.hcircle = 0x24d7;
                    t.hcircumflex = 0x0125;
                    t.hdieresis = 0x1e27;
                    t.hdotaccent = 0x1e23;
                    t.hdotbelow = 0x1e25;
                    t.he = 0x05d4;
                    t.heart = 0x2665;
                    t.heartsuitblack = 0x2665;
                    t.heartsuitwhite = 0x2661;
                    t.hedagesh = 0xfb34;
                    t.hedageshhebrew = 0xfb34;
                    t.hehaltonearabic = 0x06c1;
                    t.heharabic = 0x0647;
                    t.hehebrew = 0x05d4;
                    t.hehfinalaltonearabic = 0xfba7;
                    t.hehfinalalttwoarabic = 0xfeea;
                    t.hehfinalarabic = 0xfeea;
                    t.hehhamzaabovefinalarabic = 0xfba5;
                    t.hehhamzaaboveisolatedarabic = 0xfba4;
                    t.hehinitialaltonearabic = 0xfba8;
                    t.hehinitialarabic = 0xfeeb;
                    t.hehiragana = 0x3078;
                    t.hehmedialaltonearabic = 0xfba9;
                    t.hehmedialarabic = 0xfeec;
                    t.heiseierasquare = 0x337b;
                    t.hekatakana = 0x30d8;
                    t.hekatakanahalfwidth = 0xff8d;
                    t.hekutaarusquare = 0x3336;
                    t.henghook = 0x0267;
                    t.herutusquare = 0x3339;
                    t.het = 0x05d7;
                    t.hethebrew = 0x05d7;
                    t.hhook = 0x0266;
                    t.hhooksuperior = 0x02b1;
                    t.hieuhacirclekorean = 0x327b;
                    t.hieuhaparenkorean = 0x321b;
                    t.hieuhcirclekorean = 0x326d;
                    t.hieuhkorean = 0x314e;
                    t.hieuhparenkorean = 0x320d;
                    t.hihiragana = 0x3072;
                    t.hikatakana = 0x30d2;
                    t.hikatakanahalfwidth = 0xff8b;
                    t.hiriq = 0x05b4;
                    t.hiriq14 = 0x05b4;
                    t.hiriq21 = 0x05b4;
                    t.hiriq2d = 0x05b4;
                    t.hiriqhebrew = 0x05b4;
                    t.hiriqnarrowhebrew = 0x05b4;
                    t.hiriqquarterhebrew = 0x05b4;
                    t.hiriqwidehebrew = 0x05b4;
                    t.hlinebelow = 0x1e96;
                    t.hmonospace = 0xff48;
                    t.hoarmenian = 0x0570;
                    t.hohipthai = 0x0e2b;
                    t.hohiragana = 0x307b;
                    t.hokatakana = 0x30db;
                    t.hokatakanahalfwidth = 0xff8e;
                    t.holam = 0x05b9;
                    t.holam19 = 0x05b9;
                    t.holam26 = 0x05b9;
                    t.holam32 = 0x05b9;
                    t.holamhebrew = 0x05b9;
                    t.holamnarrowhebrew = 0x05b9;
                    t.holamquarterhebrew = 0x05b9;
                    t.holamwidehebrew = 0x05b9;
                    t.honokhukthai = 0x0e2e;
                    t.hookabovecomb = 0x0309;
                    t.hookcmb = 0x0309;
                    t.hookpalatalizedbelowcmb = 0x0321;
                    t.hookretroflexbelowcmb = 0x0322;
                    t.hoonsquare = 0x3342;
                    t.horicoptic = 0x03e9;
                    t.horizontalbar = 0x2015;
                    t.horncmb = 0x031b;
                    t.hotsprings = 0x2668;
                    t.house = 0x2302;
                    t.hparen = 0x24a3;
                    t.hsuperior = 0x02b0;
                    t.hturned = 0x0265;
                    t.huhiragana = 0x3075;
                    t.huiitosquare = 0x3333;
                    t.hukatakana = 0x30d5;
                    t.hukatakanahalfwidth = 0xff8c;
                    t.hungarumlaut = 0x02dd;
                    t.hungarumlautcmb = 0x030b;
                    t.hv = 0x0195;
                    t.hyphen = 0x002d;
                    t.hypheninferior = 0xf6e5;
                    t.hyphenmonospace = 0xff0d;
                    t.hyphensmall = 0xfe63;
                    t.hyphensuperior = 0xf6e6;
                    t.hyphentwo = 0x2010;
                    t.i = 0x0069;
                    t.iacute = 0x00ed;
                    t.iacyrillic = 0x044f;
                    t.ibengali = 0x0987;
                    t.ibopomofo = 0x3127;
                    t.ibreve = 0x012d;
                    t.icaron = 0x01d0;
                    t.icircle = 0x24d8;
                    t.icircumflex = 0x00ee;
                    t.icyrillic = 0x0456;
                    t.idblgrave = 0x0209;
                    t.ideographearthcircle = 0x328f;
                    t.ideographfirecircle = 0x328b;
                    t.ideographicallianceparen = 0x323f;
                    t.ideographiccallparen = 0x323a;
                    t.ideographiccentrecircle = 0x32a5;
                    t.ideographicclose = 0x3006;
                    t.ideographiccomma = 0x3001;
                    t.ideographiccommaleft = 0xff64;
                    t.ideographiccongratulationparen = 0x3237;
                    t.ideographiccorrectcircle = 0x32a3;
                    t.ideographicearthparen = 0x322f;
                    t.ideographicenterpriseparen = 0x323d;
                    t.ideographicexcellentcircle = 0x329d;
                    t.ideographicfestivalparen = 0x3240;
                    t.ideographicfinancialcircle = 0x3296;
                    t.ideographicfinancialparen = 0x3236;
                    t.ideographicfireparen = 0x322b;
                    t.ideographichaveparen = 0x3232;
                    t.ideographichighcircle = 0x32a4;
                    t.ideographiciterationmark = 0x3005;
                    t.ideographiclaborcircle = 0x3298;
                    t.ideographiclaborparen = 0x3238;
                    t.ideographicleftcircle = 0x32a7;
                    t.ideographiclowcircle = 0x32a6;
                    t.ideographicmedicinecircle = 0x32a9;
                    t.ideographicmetalparen = 0x322e;
                    t.ideographicmoonparen = 0x322a;
                    t.ideographicnameparen = 0x3234;
                    t.ideographicperiod = 0x3002;
                    t.ideographicprintcircle = 0x329e;
                    t.ideographicreachparen = 0x3243;
                    t.ideographicrepresentparen = 0x3239;
                    t.ideographicresourceparen = 0x323e;
                    t.ideographicrightcircle = 0x32a8;
                    t.ideographicsecretcircle = 0x3299;
                    t.ideographicselfparen = 0x3242;
                    t.ideographicsocietyparen = 0x3233;
                    t.ideographicspace = 0x3000;
                    t.ideographicspecialparen = 0x3235;
                    t.ideographicstockparen = 0x3231;
                    t.ideographicstudyparen = 0x323b;
                    t.ideographicsunparen = 0x3230;
                    t.ideographicsuperviseparen = 0x323c;
                    t.ideographicwaterparen = 0x322c;
                    t.ideographicwoodparen = 0x322d;
                    t.ideographiczero = 0x3007;
                    t.ideographmetalcircle = 0x328e;
                    t.ideographmooncircle = 0x328a;
                    t.ideographnamecircle = 0x3294;
                    t.ideographsuncircle = 0x3290;
                    t.ideographwatercircle = 0x328c;
                    t.ideographwoodcircle = 0x328d;
                    t.ideva = 0x0907;
                    t.idieresis = 0x00ef;
                    t.idieresisacute = 0x1e2f;
                    t.idieresiscyrillic = 0x04e5;
                    t.idotbelow = 0x1ecb;
                    t.iebrevecyrillic = 0x04d7;
                    t.iecyrillic = 0x0435;
                    t.ieungacirclekorean = 0x3275;
                    t.ieungaparenkorean = 0x3215;
                    t.ieungcirclekorean = 0x3267;
                    t.ieungkorean = 0x3147;
                    t.ieungparenkorean = 0x3207;
                    t.igrave = 0x00ec;
                    t.igujarati = 0x0a87;
                    t.igurmukhi = 0x0a07;
                    t.ihiragana = 0x3044;
                    t.ihookabove = 0x1ec9;
                    t.iibengali = 0x0988;
                    t.iicyrillic = 0x0438;
                    t.iideva = 0x0908;
                    t.iigujarati = 0x0a88;
                    t.iigurmukhi = 0x0a08;
                    t.iimatragurmukhi = 0x0a40;
                    t.iinvertedbreve = 0x020b;
                    t.iishortcyrillic = 0x0439;
                    t.iivowelsignbengali = 0x09c0;
                    t.iivowelsigndeva = 0x0940;
                    t.iivowelsigngujarati = 0x0ac0;
                    t.ij = 0x0133;
                    t.ikatakana = 0x30a4;
                    t.ikatakanahalfwidth = 0xff72;
                    t.ikorean = 0x3163;
                    t.ilde = 0x02dc;
                    t.iluyhebrew = 0x05ac;
                    t.imacron = 0x012b;
                    t.imacroncyrillic = 0x04e3;
                    t.imageorapproximatelyequal = 0x2253;
                    t.imatragurmukhi = 0x0a3f;
                    t.imonospace = 0xff49;
                    t.increment = 0x2206;
                    t.infinity = 0x221e;
                    t.iniarmenian = 0x056b;
                    t.integral = 0x222b;
                    t.integralbottom = 0x2321;
                    t.integralbt = 0x2321;
                    t.integralex = 0xf8f5;
                    t.integraltop = 0x2320;
                    t.integraltp = 0x2320;
                    t.intersection = 0x2229;
                    t.intisquare = 0x3305;
                    t.invbullet = 0x25d8;
                    t.invcircle = 0x25d9;
                    t.invsmileface = 0x263b;
                    t.iocyrillic = 0x0451;
                    t.iogonek = 0x012f;
                    t.iota = 0x03b9;
                    t.iotadieresis = 0x03ca;
                    t.iotadieresistonos = 0x0390;
                    t.iotalatin = 0x0269;
                    t.iotatonos = 0x03af;
                    t.iparen = 0x24a4;
                    t.irigurmukhi = 0x0a72;
                    t.ismallhiragana = 0x3043;
                    t.ismallkatakana = 0x30a3;
                    t.ismallkatakanahalfwidth = 0xff68;
                    t.issharbengali = 0x09fa;
                    t.istroke = 0x0268;
                    t.isuperior = 0xf6ed;
                    t.iterationhiragana = 0x309d;
                    t.iterationkatakana = 0x30fd;
                    t.itilde = 0x0129;
                    t.itildebelow = 0x1e2d;
                    t.iubopomofo = 0x3129;
                    t.iucyrillic = 0x044e;
                    t.ivowelsignbengali = 0x09bf;
                    t.ivowelsigndeva = 0x093f;
                    t.ivowelsigngujarati = 0x0abf;
                    t.izhitsacyrillic = 0x0475;
                    t.izhitsadblgravecyrillic = 0x0477;
                    t.j = 0x006a;
                    t.jaarmenian = 0x0571;
                    t.jabengali = 0x099c;
                    t.jadeva = 0x091c;
                    t.jagujarati = 0x0a9c;
                    t.jagurmukhi = 0x0a1c;
                    t.jbopomofo = 0x3110;
                    t.jcaron = 0x01f0;
                    t.jcircle = 0x24d9;
                    t.jcircumflex = 0x0135;
                    t.jcrossedtail = 0x029d;
                    t.jdotlessstroke = 0x025f;
                    t.jecyrillic = 0x0458;
                    t.jeemarabic = 0x062c;
                    t.jeemfinalarabic = 0xfe9e;
                    t.jeeminitialarabic = 0xfe9f;
                    t.jeemmedialarabic = 0xfea0;
                    t.jeharabic = 0x0698;
                    t.jehfinalarabic = 0xfb8b;
                    t.jhabengali = 0x099d;
                    t.jhadeva = 0x091d;
                    t.jhagujarati = 0x0a9d;
                    t.jhagurmukhi = 0x0a1d;
                    t.jheharmenian = 0x057b;
                    t.jis = 0x3004;
                    t.jmonospace = 0xff4a;
                    t.jparen = 0x24a5;
                    t.jsuperior = 0x02b2;
                    t.k = 0x006b;
                    t.kabashkircyrillic = 0x04a1;
                    t.kabengali = 0x0995;
                    t.kacute = 0x1e31;
                    t.kacyrillic = 0x043a;
                    t.kadescendercyrillic = 0x049b;
                    t.kadeva = 0x0915;
                    t.kaf = 0x05db;
                    t.kafarabic = 0x0643;
                    t.kafdagesh = 0xfb3b;
                    t.kafdageshhebrew = 0xfb3b;
                    t.kaffinalarabic = 0xfeda;
                    t.kafhebrew = 0x05db;
                    t.kafinitialarabic = 0xfedb;
                    t.kafmedialarabic = 0xfedc;
                    t.kafrafehebrew = 0xfb4d;
                    t.kagujarati = 0x0a95;
                    t.kagurmukhi = 0x0a15;
                    t.kahiragana = 0x304b;
                    t.kahookcyrillic = 0x04c4;
                    t.kakatakana = 0x30ab;
                    t.kakatakanahalfwidth = 0xff76;
                    t.kappa = 0x03ba;
                    t.kappasymbolgreek = 0x03f0;
                    t.kapyeounmieumkorean = 0x3171;
                    t.kapyeounphieuphkorean = 0x3184;
                    t.kapyeounpieupkorean = 0x3178;
                    t.kapyeounssangpieupkorean = 0x3179;
                    t.karoriisquare = 0x330d;
                    t.kashidaautoarabic = 0x0640;
                    t.kashidaautonosidebearingarabic = 0x0640;
                    t.kasmallkatakana = 0x30f5;
                    t.kasquare = 0x3384;
                    t.kasraarabic = 0x0650;
                    t.kasratanarabic = 0x064d;
                    t.kastrokecyrillic = 0x049f;
                    t.katahiraprolongmarkhalfwidth = 0xff70;
                    t.kaverticalstrokecyrillic = 0x049d;
                    t.kbopomofo = 0x310e;
                    t.kcalsquare = 0x3389;
                    t.kcaron = 0x01e9;
                    t.kcedilla = 0x0137;
                    t.kcircle = 0x24da;
                    t.kcommaaccent = 0x0137;
                    t.kdotbelow = 0x1e33;
                    t.keharmenian = 0x0584;
                    t.kehiragana = 0x3051;
                    t.kekatakana = 0x30b1;
                    t.kekatakanahalfwidth = 0xff79;
                    t.kenarmenian = 0x056f;
                    t.kesmallkatakana = 0x30f6;
                    t.kgreenlandic = 0x0138;
                    t.khabengali = 0x0996;
                    t.khacyrillic = 0x0445;
                    t.khadeva = 0x0916;
                    t.khagujarati = 0x0a96;
                    t.khagurmukhi = 0x0a16;
                    t.khaharabic = 0x062e;
                    t.khahfinalarabic = 0xfea6;
                    t.khahinitialarabic = 0xfea7;
                    t.khahmedialarabic = 0xfea8;
                    t.kheicoptic = 0x03e7;
                    t.khhadeva = 0x0959;
                    t.khhagurmukhi = 0x0a59;
                    t.khieukhacirclekorean = 0x3278;
                    t.khieukhaparenkorean = 0x3218;
                    t.khieukhcirclekorean = 0x326a;
                    t.khieukhkorean = 0x314b;
                    t.khieukhparenkorean = 0x320a;
                    t.khokhaithai = 0x0e02;
                    t.khokhonthai = 0x0e05;
                    t.khokhuatthai = 0x0e03;
                    t.khokhwaithai = 0x0e04;
                    t.khomutthai = 0x0e5b;
                    t.khook = 0x0199;
                    t.khorakhangthai = 0x0e06;
                    t.khzsquare = 0x3391;
                    t.kihiragana = 0x304d;
                    t.kikatakana = 0x30ad;
                    t.kikatakanahalfwidth = 0xff77;
                    t.kiroguramusquare = 0x3315;
                    t.kiromeetorusquare = 0x3316;
                    t.kirosquare = 0x3314;
                    t.kiyeokacirclekorean = 0x326e;
                    t.kiyeokaparenkorean = 0x320e;
                    t.kiyeokcirclekorean = 0x3260;
                    t.kiyeokkorean = 0x3131;
                    t.kiyeokparenkorean = 0x3200;
                    t.kiyeoksioskorean = 0x3133;
                    t.kjecyrillic = 0x045c;
                    t.klinebelow = 0x1e35;
                    t.klsquare = 0x3398;
                    t.kmcubedsquare = 0x33a6;
                    t.kmonospace = 0xff4b;
                    t.kmsquaredsquare = 0x33a2;
                    t.kohiragana = 0x3053;
                    t.kohmsquare = 0x33c0;
                    t.kokaithai = 0x0e01;
                    t.kokatakana = 0x30b3;
                    t.kokatakanahalfwidth = 0xff7a;
                    t.kooposquare = 0x331e;
                    t.koppacyrillic = 0x0481;
                    t.koreanstandardsymbol = 0x327f;
                    t.koroniscmb = 0x0343;
                    t.kparen = 0x24a6;
                    t.kpasquare = 0x33aa;
                    t.ksicyrillic = 0x046f;
                    t.ktsquare = 0x33cf;
                    t.kturned = 0x029e;
                    t.kuhiragana = 0x304f;
                    t.kukatakana = 0x30af;
                    t.kukatakanahalfwidth = 0xff78;
                    t.kvsquare = 0x33b8;
                    t.kwsquare = 0x33be;
                    t.l = 0x006c;
                    t.labengali = 0x09b2;
                    t.lacute = 0x013a;
                    t.ladeva = 0x0932;
                    t.lagujarati = 0x0ab2;
                    t.lagurmukhi = 0x0a32;
                    t.lakkhangyaothai = 0x0e45;
                    t.lamaleffinalarabic = 0xfefc;
                    t.lamalefhamzaabovefinalarabic = 0xfef8;
                    t.lamalefhamzaaboveisolatedarabic = 0xfef7;
                    t.lamalefhamzabelowfinalarabic = 0xfefa;
                    t.lamalefhamzabelowisolatedarabic = 0xfef9;
                    t.lamalefisolatedarabic = 0xfefb;
                    t.lamalefmaddaabovefinalarabic = 0xfef6;
                    t.lamalefmaddaaboveisolatedarabic = 0xfef5;
                    t.lamarabic = 0x0644;
                    t.lambda = 0x03bb;
                    t.lambdastroke = 0x019b;
                    t.lamed = 0x05dc;
                    t.lameddagesh = 0xfb3c;
                    t.lameddageshhebrew = 0xfb3c;
                    t.lamedhebrew = 0x05dc;
                    t.lamfinalarabic = 0xfede;
                    t.lamhahinitialarabic = 0xfcca;
                    t.laminitialarabic = 0xfedf;
                    t.lamjeeminitialarabic = 0xfcc9;
                    t.lamkhahinitialarabic = 0xfccb;
                    t.lamlamhehisolatedarabic = 0xfdf2;
                    t.lammedialarabic = 0xfee0;
                    t.lammeemhahinitialarabic = 0xfd88;
                    t.lammeeminitialarabic = 0xfccc;
                    t.largecircle = 0x25ef;
                    t.lbar = 0x019a;
                    t.lbelt = 0x026c;
                    t.lbopomofo = 0x310c;
                    t.lcaron = 0x013e;
                    t.lcedilla = 0x013c;
                    t.lcircle = 0x24db;
                    t.lcircumflexbelow = 0x1e3d;
                    t.lcommaaccent = 0x013c;
                    t.ldot = 0x0140;
                    t.ldotaccent = 0x0140;
                    t.ldotbelow = 0x1e37;
                    t.ldotbelowmacron = 0x1e39;
                    t.leftangleabovecmb = 0x031a;
                    t.lefttackbelowcmb = 0x0318;
                    t.less = 0x003c;
                    t.lessequal = 0x2264;
                    t.lessequalorgreater = 0x22da;
                    t.lessmonospace = 0xff1c;
                    t.lessorequivalent = 0x2272;
                    t.lessorgreater = 0x2276;
                    t.lessoverequal = 0x2266;
                    t.lesssmall = 0xfe64;
                    t.lezh = 0x026e;
                    t.lfblock = 0x258c;
                    t.lhookretroflex = 0x026d;
                    t.lira = 0x20a4;
                    t.liwnarmenian = 0x056c;
                    t.lj = 0x01c9;
                    t.ljecyrillic = 0x0459;
                    t.ll = 0xf6c0;
                    t.lladeva = 0x0933;
                    t.llagujarati = 0x0ab3;
                    t.llinebelow = 0x1e3b;
                    t.llladeva = 0x0934;
                    t.llvocalicbengali = 0x09e1;
                    t.llvocalicdeva = 0x0961;
                    t.llvocalicvowelsignbengali = 0x09e3;
                    t.llvocalicvowelsigndeva = 0x0963;
                    t.lmiddletilde = 0x026b;
                    t.lmonospace = 0xff4c;
                    t.lmsquare = 0x33d0;
                    t.lochulathai = 0x0e2c;
                    t.logicaland = 0x2227;
                    t.logicalnot = 0x00ac;
                    t.logicalnotreversed = 0x2310;
                    t.logicalor = 0x2228;
                    t.lolingthai = 0x0e25;
                    t.longs = 0x017f;
                    t.lowlinecenterline = 0xfe4e;
                    t.lowlinecmb = 0x0332;
                    t.lowlinedashed = 0xfe4d;
                    t.lozenge = 0x25ca;
                    t.lparen = 0x24a7;
                    t.lslash = 0x0142;
                    t.lsquare = 0x2113;
                    t.lsuperior = 0xf6ee;
                    t.ltshade = 0x2591;
                    t.luthai = 0x0e26;
                    t.lvocalicbengali = 0x098c;
                    t.lvocalicdeva = 0x090c;
                    t.lvocalicvowelsignbengali = 0x09e2;
                    t.lvocalicvowelsigndeva = 0x0962;
                    t.lxsquare = 0x33d3;
                    t.m = 0x006d;
                    t.mabengali = 0x09ae;
                    t.macron = 0x00af;
                    t.macronbelowcmb = 0x0331;
                    t.macroncmb = 0x0304;
                    t.macronlowmod = 0x02cd;
                    t.macronmonospace = 0xffe3;
                    t.macute = 0x1e3f;
                    t.madeva = 0x092e;
                    t.magujarati = 0x0aae;
                    t.magurmukhi = 0x0a2e;
                    t.mahapakhhebrew = 0x05a4;
                    t.mahapakhlefthebrew = 0x05a4;
                    t.mahiragana = 0x307e;
                    t.maichattawalowleftthai = 0xf895;
                    t.maichattawalowrightthai = 0xf894;
                    t.maichattawathai = 0x0e4b;
                    t.maichattawaupperleftthai = 0xf893;
                    t.maieklowleftthai = 0xf88c;
                    t.maieklowrightthai = 0xf88b;
                    t.maiekthai = 0x0e48;
                    t.maiekupperleftthai = 0xf88a;
                    t.maihanakatleftthai = 0xf884;
                    t.maihanakatthai = 0x0e31;
                    t.maitaikhuleftthai = 0xf889;
                    t.maitaikhuthai = 0x0e47;
                    t.maitholowleftthai = 0xf88f;
                    t.maitholowrightthai = 0xf88e;
                    t.maithothai = 0x0e49;
                    t.maithoupperleftthai = 0xf88d;
                    t.maitrilowleftthai = 0xf892;
                    t.maitrilowrightthai = 0xf891;
                    t.maitrithai = 0x0e4a;
                    t.maitriupperleftthai = 0xf890;
                    t.maiyamokthai = 0x0e46;
                    t.makatakana = 0x30de;
                    t.makatakanahalfwidth = 0xff8f;
                    t.male = 0x2642;
                    t.mansyonsquare = 0x3347;
                    t.maqafhebrew = 0x05be;
                    t.mars = 0x2642;
                    t.masoracirclehebrew = 0x05af;
                    t.masquare = 0x3383;
                    t.mbopomofo = 0x3107;
                    t.mbsquare = 0x33d4;
                    t.mcircle = 0x24dc;
                    t.mcubedsquare = 0x33a5;
                    t.mdotaccent = 0x1e41;
                    t.mdotbelow = 0x1e43;
                    t.meemarabic = 0x0645;
                    t.meemfinalarabic = 0xfee2;
                    t.meeminitialarabic = 0xfee3;
                    t.meemmedialarabic = 0xfee4;
                    t.meemmeeminitialarabic = 0xfcd1;
                    t.meemmeemisolatedarabic = 0xfc48;
                    t.meetorusquare = 0x334d;
                    t.mehiragana = 0x3081;
                    t.meizierasquare = 0x337e;
                    t.mekatakana = 0x30e1;
                    t.mekatakanahalfwidth = 0xff92;
                    t.mem = 0x05de;
                    t.memdagesh = 0xfb3e;
                    t.memdageshhebrew = 0xfb3e;
                    t.memhebrew = 0x05de;
                    t.menarmenian = 0x0574;
                    t.merkhahebrew = 0x05a5;
                    t.merkhakefulahebrew = 0x05a6;
                    t.merkhakefulalefthebrew = 0x05a6;
                    t.merkhalefthebrew = 0x05a5;
                    t.mhook = 0x0271;
                    t.mhzsquare = 0x3392;
                    t.middledotkatakanahalfwidth = 0xff65;
                    t.middot = 0x00b7;
                    t.mieumacirclekorean = 0x3272;
                    t.mieumaparenkorean = 0x3212;
                    t.mieumcirclekorean = 0x3264;
                    t.mieumkorean = 0x3141;
                    t.mieumpansioskorean = 0x3170;
                    t.mieumparenkorean = 0x3204;
                    t.mieumpieupkorean = 0x316e;
                    t.mieumsioskorean = 0x316f;
                    t.mihiragana = 0x307f;
                    t.mikatakana = 0x30df;
                    t.mikatakanahalfwidth = 0xff90;
                    t.minus = 0x2212;
                    t.minusbelowcmb = 0x0320;
                    t.minuscircle = 0x2296;
                    t.minusmod = 0x02d7;
                    t.minusplus = 0x2213;
                    t.minute = 0x2032;
                    t.miribaarusquare = 0x334a;
                    t.mirisquare = 0x3349;
                    t.mlonglegturned = 0x0270;
                    t.mlsquare = 0x3396;
                    t.mmcubedsquare = 0x33a3;
                    t.mmonospace = 0xff4d;
                    t.mmsquaredsquare = 0x339f;
                    t.mohiragana = 0x3082;
                    t.mohmsquare = 0x33c1;
                    t.mokatakana = 0x30e2;
                    t.mokatakanahalfwidth = 0xff93;
                    t.molsquare = 0x33d6;
                    t.momathai = 0x0e21;
                    t.moverssquare = 0x33a7;
                    t.moverssquaredsquare = 0x33a8;
                    t.mparen = 0x24a8;
                    t.mpasquare = 0x33ab;
                    t.mssquare = 0x33b3;
                    t.msuperior = 0xf6ef;
                    t.mturned = 0x026f;
                    t.mu = 0x00b5;
                    t.mu1 = 0x00b5;
                    t.muasquare = 0x3382;
                    t.muchgreater = 0x226b;
                    t.muchless = 0x226a;
                    t.mufsquare = 0x338c;
                    t.mugreek = 0x03bc;
                    t.mugsquare = 0x338d;
                    t.muhiragana = 0x3080;
                    t.mukatakana = 0x30e0;
                    t.mukatakanahalfwidth = 0xff91;
                    t.mulsquare = 0x3395;
                    t.multiply = 0x00d7;
                    t.mumsquare = 0x339b;
                    t.munahhebrew = 0x05a3;
                    t.munahlefthebrew = 0x05a3;
                    t.musicalnote = 0x266a;
                    t.musicalnotedbl = 0x266b;
                    t.musicflatsign = 0x266d;
                    t.musicsharpsign = 0x266f;
                    t.mussquare = 0x33b2;
                    t.muvsquare = 0x33b6;
                    t.muwsquare = 0x33bc;
                    t.mvmegasquare = 0x33b9;
                    t.mvsquare = 0x33b7;
                    t.mwmegasquare = 0x33bf;
                    t.mwsquare = 0x33bd;
                    t.n = 0x006e;
                    t.nabengali = 0x09a8;
                    t.nabla = 0x2207;
                    t.nacute = 0x0144;
                    t.nadeva = 0x0928;
                    t.nagujarati = 0x0aa8;
                    t.nagurmukhi = 0x0a28;
                    t.nahiragana = 0x306a;
                    t.nakatakana = 0x30ca;
                    t.nakatakanahalfwidth = 0xff85;
                    t.napostrophe = 0x0149;
                    t.nasquare = 0x3381;
                    t.nbopomofo = 0x310b;
                    t.nbspace = 0x00a0;
                    t.ncaron = 0x0148;
                    t.ncedilla = 0x0146;
                    t.ncircle = 0x24dd;
                    t.ncircumflexbelow = 0x1e4b;
                    t.ncommaaccent = 0x0146;
                    t.ndotaccent = 0x1e45;
                    t.ndotbelow = 0x1e47;
                    t.nehiragana = 0x306d;
                    t.nekatakana = 0x30cd;
                    t.nekatakanahalfwidth = 0xff88;
                    t.newsheqelsign = 0x20aa;
                    t.nfsquare = 0x338b;
                    t.ngabengali = 0x0999;
                    t.ngadeva = 0x0919;
                    t.ngagujarati = 0x0a99;
                    t.ngagurmukhi = 0x0a19;
                    t.ngonguthai = 0x0e07;
                    t.nhiragana = 0x3093;
                    t.nhookleft = 0x0272;
                    t.nhookretroflex = 0x0273;
                    t.nieunacirclekorean = 0x326f;
                    t.nieunaparenkorean = 0x320f;
                    t.nieuncieuckorean = 0x3135;
                    t.nieuncirclekorean = 0x3261;
                    t.nieunhieuhkorean = 0x3136;
                    t.nieunkorean = 0x3134;
                    t.nieunpansioskorean = 0x3168;
                    t.nieunparenkorean = 0x3201;
                    t.nieunsioskorean = 0x3167;
                    t.nieuntikeutkorean = 0x3166;
                    t.nihiragana = 0x306b;
                    t.nikatakana = 0x30cb;
                    t.nikatakanahalfwidth = 0xff86;
                    t.nikhahitleftthai = 0xf899;
                    t.nikhahitthai = 0x0e4d;
                    t.nine = 0x0039;
                    t.ninearabic = 0x0669;
                    t.ninebengali = 0x09ef;
                    t.ninecircle = 0x2468;
                    t.ninecircleinversesansserif = 0x2792;
                    t.ninedeva = 0x096f;
                    t.ninegujarati = 0x0aef;
                    t.ninegurmukhi = 0x0a6f;
                    t.ninehackarabic = 0x0669;
                    t.ninehangzhou = 0x3029;
                    t.nineideographicparen = 0x3228;
                    t.nineinferior = 0x2089;
                    t.ninemonospace = 0xff19;
                    t.nineoldstyle = 0xf739;
                    t.nineparen = 0x247c;
                    t.nineperiod = 0x2490;
                    t.ninepersian = 0x06f9;
                    t.nineroman = 0x2178;
                    t.ninesuperior = 0x2079;
                    t.nineteencircle = 0x2472;
                    t.nineteenparen = 0x2486;
                    t.nineteenperiod = 0x249a;
                    t.ninethai = 0x0e59;
                    t.nj = 0x01cc;
                    t.njecyrillic = 0x045a;
                    t.nkatakana = 0x30f3;
                    t.nkatakanahalfwidth = 0xff9d;
                    t.nlegrightlong = 0x019e;
                    t.nlinebelow = 0x1e49;
                    t.nmonospace = 0xff4e;
                    t.nmsquare = 0x339a;
                    t.nnabengali = 0x09a3;
                    t.nnadeva = 0x0923;
                    t.nnagujarati = 0x0aa3;
                    t.nnagurmukhi = 0x0a23;
                    t.nnnadeva = 0x0929;
                    t.nohiragana = 0x306e;
                    t.nokatakana = 0x30ce;
                    t.nokatakanahalfwidth = 0xff89;
                    t.nonbreakingspace = 0x00a0;
                    t.nonenthai = 0x0e13;
                    t.nonuthai = 0x0e19;
                    t.noonarabic = 0x0646;
                    t.noonfinalarabic = 0xfee6;
                    t.noonghunnaarabic = 0x06ba;
                    t.noonghunnafinalarabic = 0xfb9f;
                    t.nooninitialarabic = 0xfee7;
                    t.noonjeeminitialarabic = 0xfcd2;
                    t.noonjeemisolatedarabic = 0xfc4b;
                    t.noonmedialarabic = 0xfee8;
                    t.noonmeeminitialarabic = 0xfcd5;
                    t.noonmeemisolatedarabic = 0xfc4e;
                    t.noonnoonfinalarabic = 0xfc8d;
                    t.notcontains = 0x220c;
                    t.notelement = 0x2209;
                    t.notelementof = 0x2209;
                    t.notequal = 0x2260;
                    t.notgreater = 0x226f;
                    t.notgreaternorequal = 0x2271;
                    t.notgreaternorless = 0x2279;
                    t.notidentical = 0x2262;
                    t.notless = 0x226e;
                    t.notlessnorequal = 0x2270;
                    t.notparallel = 0x2226;
                    t.notprecedes = 0x2280;
                    t.notsubset = 0x2284;
                    t.notsucceeds = 0x2281;
                    t.notsuperset = 0x2285;
                    t.nowarmenian = 0x0576;
                    t.nparen = 0x24a9;
                    t.nssquare = 0x33b1;
                    t.nsuperior = 0x207f;
                    t.ntilde = 0x00f1;
                    t.nu = 0x03bd;
                    t.nuhiragana = 0x306c;
                    t.nukatakana = 0x30cc;
                    t.nukatakanahalfwidth = 0xff87;
                    t.nuktabengali = 0x09bc;
                    t.nuktadeva = 0x093c;
                    t.nuktagujarati = 0x0abc;
                    t.nuktagurmukhi = 0x0a3c;
                    t.numbersign = 0x0023;
                    t.numbersignmonospace = 0xff03;
                    t.numbersignsmall = 0xfe5f;
                    t.numeralsigngreek = 0x0374;
                    t.numeralsignlowergreek = 0x0375;
                    t.numero = 0x2116;
                    t.nun = 0x05e0;
                    t.nundagesh = 0xfb40;
                    t.nundageshhebrew = 0xfb40;
                    t.nunhebrew = 0x05e0;
                    t.nvsquare = 0x33b5;
                    t.nwsquare = 0x33bb;
                    t.nyabengali = 0x099e;
                    t.nyadeva = 0x091e;
                    t.nyagujarati = 0x0a9e;
                    t.nyagurmukhi = 0x0a1e;
                    t.o = 0x006f;
                    t.oacute = 0x00f3;
                    t.oangthai = 0x0e2d;
                    t.obarred = 0x0275;
                    t.obarredcyrillic = 0x04e9;
                    t.obarreddieresiscyrillic = 0x04eb;
                    t.obengali = 0x0993;
                    t.obopomofo = 0x311b;
                    t.obreve = 0x014f;
                    t.ocandradeva = 0x0911;
                    t.ocandragujarati = 0x0a91;
                    t.ocandravowelsigndeva = 0x0949;
                    t.ocandravowelsigngujarati = 0x0ac9;
                    t.ocaron = 0x01d2;
                    t.ocircle = 0x24de;
                    t.ocircumflex = 0x00f4;
                    t.ocircumflexacute = 0x1ed1;
                    t.ocircumflexdotbelow = 0x1ed9;
                    t.ocircumflexgrave = 0x1ed3;
                    t.ocircumflexhookabove = 0x1ed5;
                    t.ocircumflextilde = 0x1ed7;
                    t.ocyrillic = 0x043e;
                    t.odblacute = 0x0151;
                    t.odblgrave = 0x020d;
                    t.odeva = 0x0913;
                    t.odieresis = 0x00f6;
                    t.odieresiscyrillic = 0x04e7;
                    t.odotbelow = 0x1ecd;
                    t.oe = 0x0153;
                    t.oekorean = 0x315a;
                    t.ogonek = 0x02db;
                    t.ogonekcmb = 0x0328;
                    t.ograve = 0x00f2;
                    t.ogujarati = 0x0a93;
                    t.oharmenian = 0x0585;
                    t.ohiragana = 0x304a;
                    t.ohookabove = 0x1ecf;
                    t.ohorn = 0x01a1;
                    t.ohornacute = 0x1edb;
                    t.ohorndotbelow = 0x1ee3;
                    t.ohorngrave = 0x1edd;
                    t.ohornhookabove = 0x1edf;
                    t.ohorntilde = 0x1ee1;
                    t.ohungarumlaut = 0x0151;
                    t.oi = 0x01a3;
                    t.oinvertedbreve = 0x020f;
                    t.okatakana = 0x30aa;
                    t.okatakanahalfwidth = 0xff75;
                    t.okorean = 0x3157;
                    t.olehebrew = 0x05ab;
                    t.omacron = 0x014d;
                    t.omacronacute = 0x1e53;
                    t.omacrongrave = 0x1e51;
                    t.omdeva = 0x0950;
                    t.omega = 0x03c9;
                    t.omega1 = 0x03d6;
                    t.omegacyrillic = 0x0461;
                    t.omegalatinclosed = 0x0277;
                    t.omegaroundcyrillic = 0x047b;
                    t.omegatitlocyrillic = 0x047d;
                    t.omegatonos = 0x03ce;
                    t.omgujarati = 0x0ad0;
                    t.omicron = 0x03bf;
                    t.omicrontonos = 0x03cc;
                    t.omonospace = 0xff4f;
                    t.one = 0x0031;
                    t.onearabic = 0x0661;
                    t.onebengali = 0x09e7;
                    t.onecircle = 0x2460;
                    t.onecircleinversesansserif = 0x278a;
                    t.onedeva = 0x0967;
                    t.onedotenleader = 0x2024;
                    t.oneeighth = 0x215b;
                    t.onefitted = 0xf6dc;
                    t.onegujarati = 0x0ae7;
                    t.onegurmukhi = 0x0a67;
                    t.onehackarabic = 0x0661;
                    t.onehalf = 0x00bd;
                    t.onehangzhou = 0x3021;
                    t.oneideographicparen = 0x3220;
                    t.oneinferior = 0x2081;
                    t.onemonospace = 0xff11;
                    t.onenumeratorbengali = 0x09f4;
                    t.oneoldstyle = 0xf731;
                    t.oneparen = 0x2474;
                    t.oneperiod = 0x2488;
                    t.onepersian = 0x06f1;
                    t.onequarter = 0x00bc;
                    t.oneroman = 0x2170;
                    t.onesuperior = 0x00b9;
                    t.onethai = 0x0e51;
                    t.onethird = 0x2153;
                    t.oogonek = 0x01eb;
                    t.oogonekmacron = 0x01ed;
                    t.oogurmukhi = 0x0a13;
                    t.oomatragurmukhi = 0x0a4b;
                    t.oopen = 0x0254;
                    t.oparen = 0x24aa;
                    t.openbullet = 0x25e6;
                    t.option = 0x2325;
                    t.ordfeminine = 0x00aa;
                    t.ordmasculine = 0x00ba;
                    t.orthogonal = 0x221f;
                    t.oshortdeva = 0x0912;
                    t.oshortvowelsigndeva = 0x094a;
                    t.oslash = 0x00f8;
                    t.oslashacute = 0x01ff;
                    t.osmallhiragana = 0x3049;
                    t.osmallkatakana = 0x30a9;
                    t.osmallkatakanahalfwidth = 0xff6b;
                    t.ostrokeacute = 0x01ff;
                    t.osuperior = 0xf6f0;
                    t.otcyrillic = 0x047f;
                    t.otilde = 0x00f5;
                    t.otildeacute = 0x1e4d;
                    t.otildedieresis = 0x1e4f;
                    t.oubopomofo = 0x3121;
                    t.overline = 0x203e;
                    t.overlinecenterline = 0xfe4a;
                    t.overlinecmb = 0x0305;
                    t.overlinedashed = 0xfe49;
                    t.overlinedblwavy = 0xfe4c;
                    t.overlinewavy = 0xfe4b;
                    t.overscore = 0x00af;
                    t.ovowelsignbengali = 0x09cb;
                    t.ovowelsigndeva = 0x094b;
                    t.ovowelsigngujarati = 0x0acb;
                    t.p = 0x0070;
                    t.paampssquare = 0x3380;
                    t.paasentosquare = 0x332b;
                    t.pabengali = 0x09aa;
                    t.pacute = 0x1e55;
                    t.padeva = 0x092a;
                    t.pagedown = 0x21df;
                    t.pageup = 0x21de;
                    t.pagujarati = 0x0aaa;
                    t.pagurmukhi = 0x0a2a;
                    t.pahiragana = 0x3071;
                    t.paiyannoithai = 0x0e2f;
                    t.pakatakana = 0x30d1;
                    t.palatalizationcyrilliccmb = 0x0484;
                    t.palochkacyrillic = 0x04c0;
                    t.pansioskorean = 0x317f;
                    t.paragraph = 0x00b6;
                    t.parallel = 0x2225;
                    t.parenleft = 0x0028;
                    t.parenleftaltonearabic = 0xfd3e;
                    t.parenleftbt = 0xf8ed;
                    t.parenleftex = 0xf8ec;
                    t.parenleftinferior = 0x208d;
                    t.parenleftmonospace = 0xff08;
                    t.parenleftsmall = 0xfe59;
                    t.parenleftsuperior = 0x207d;
                    t.parenlefttp = 0xf8eb;
                    t.parenleftvertical = 0xfe35;
                    t.parenright = 0x0029;
                    t.parenrightaltonearabic = 0xfd3f;
                    t.parenrightbt = 0xf8f8;
                    t.parenrightex = 0xf8f7;
                    t.parenrightinferior = 0x208e;
                    t.parenrightmonospace = 0xff09;
                    t.parenrightsmall = 0xfe5a;
                    t.parenrightsuperior = 0x207e;
                    t.parenrighttp = 0xf8f6;
                    t.parenrightvertical = 0xfe36;
                    t.partialdiff = 0x2202;
                    t.paseqhebrew = 0x05c0;
                    t.pashtahebrew = 0x0599;
                    t.pasquare = 0x33a9;
                    t.patah = 0x05b7;
                    t.patah11 = 0x05b7;
                    t.patah1d = 0x05b7;
                    t.patah2a = 0x05b7;
                    t.patahhebrew = 0x05b7;
                    t.patahnarrowhebrew = 0x05b7;
                    t.patahquarterhebrew = 0x05b7;
                    t.patahwidehebrew = 0x05b7;
                    t.pazerhebrew = 0x05a1;
                    t.pbopomofo = 0x3106;
                    t.pcircle = 0x24df;
                    t.pdotaccent = 0x1e57;
                    t.pe = 0x05e4;
                    t.pecyrillic = 0x043f;
                    t.pedagesh = 0xfb44;
                    t.pedageshhebrew = 0xfb44;
                    t.peezisquare = 0x333b;
                    t.pefinaldageshhebrew = 0xfb43;
                    t.peharabic = 0x067e;
                    t.peharmenian = 0x057a;
                    t.pehebrew = 0x05e4;
                    t.pehfinalarabic = 0xfb57;
                    t.pehinitialarabic = 0xfb58;
                    t.pehiragana = 0x307a;
                    t.pehmedialarabic = 0xfb59;
                    t.pekatakana = 0x30da;
                    t.pemiddlehookcyrillic = 0x04a7;
                    t.perafehebrew = 0xfb4e;
                    t.percent = 0x0025;
                    t.percentarabic = 0x066a;
                    t.percentmonospace = 0xff05;
                    t.percentsmall = 0xfe6a;
                    t.period = 0x002e;
                    t.periodarmenian = 0x0589;
                    t.periodcentered = 0x00b7;
                    t.periodhalfwidth = 0xff61;
                    t.periodinferior = 0xf6e7;
                    t.periodmonospace = 0xff0e;
                    t.periodsmall = 0xfe52;
                    t.periodsuperior = 0xf6e8;
                    t.perispomenigreekcmb = 0x0342;
                    t.perpendicular = 0x22a5;
                    t.perthousand = 0x2030;
                    t.peseta = 0x20a7;
                    t.pfsquare = 0x338a;
                    t.phabengali = 0x09ab;
                    t.phadeva = 0x092b;
                    t.phagujarati = 0x0aab;
                    t.phagurmukhi = 0x0a2b;
                    t.phi = 0x03c6;
                    t.phi1 = 0x03d5;
                    t.phieuphacirclekorean = 0x327a;
                    t.phieuphaparenkorean = 0x321a;
                    t.phieuphcirclekorean = 0x326c;
                    t.phieuphkorean = 0x314d;
                    t.phieuphparenkorean = 0x320c;
                    t.philatin = 0x0278;
                    t.phinthuthai = 0x0e3a;
                    t.phisymbolgreek = 0x03d5;
                    t.phook = 0x01a5;
                    t.phophanthai = 0x0e1e;
                    t.phophungthai = 0x0e1c;
                    t.phosamphaothai = 0x0e20;
                    t.pi = 0x03c0;
                    t.pieupacirclekorean = 0x3273;
                    t.pieupaparenkorean = 0x3213;
                    t.pieupcieuckorean = 0x3176;
                    t.pieupcirclekorean = 0x3265;
                    t.pieupkiyeokkorean = 0x3172;
                    t.pieupkorean = 0x3142;
                    t.pieupparenkorean = 0x3205;
                    t.pieupsioskiyeokkorean = 0x3174;
                    t.pieupsioskorean = 0x3144;
                    t.pieupsiostikeutkorean = 0x3175;
                    t.pieupthieuthkorean = 0x3177;
                    t.pieuptikeutkorean = 0x3173;
                    t.pihiragana = 0x3074;
                    t.pikatakana = 0x30d4;
                    t.pisymbolgreek = 0x03d6;
                    t.piwrarmenian = 0x0583;
                    t.planckover2pi = 0x210f;
                    t.planckover2pi1 = 0x210f;
                    t.plus = 0x002b;
                    t.plusbelowcmb = 0x031f;
                    t.pluscircle = 0x2295;
                    t.plusminus = 0x00b1;
                    t.plusmod = 0x02d6;
                    t.plusmonospace = 0xff0b;
                    t.plussmall = 0xfe62;
                    t.plussuperior = 0x207a;
                    t.pmonospace = 0xff50;
                    t.pmsquare = 0x33d8;
                    t.pohiragana = 0x307d;
                    t.pointingindexdownwhite = 0x261f;
                    t.pointingindexleftwhite = 0x261c;
                    t.pointingindexrightwhite = 0x261e;
                    t.pointingindexupwhite = 0x261d;
                    t.pokatakana = 0x30dd;
                    t.poplathai = 0x0e1b;
                    t.postalmark = 0x3012;
                    t.postalmarkface = 0x3020;
                    t.pparen = 0x24ab;
                    t.precedes = 0x227a;
                    t.prescription = 0x211e;
                    t.primemod = 0x02b9;
                    t.primereversed = 0x2035;
                    t.product = 0x220f;
                    t.projective = 0x2305;
                    t.prolongedkana = 0x30fc;
                    t.propellor = 0x2318;
                    t.propersubset = 0x2282;
                    t.propersuperset = 0x2283;
                    t.proportion = 0x2237;
                    t.proportional = 0x221d;
                    t.psi = 0x03c8;
                    t.psicyrillic = 0x0471;
                    t.psilipneumatacyrilliccmb = 0x0486;
                    t.pssquare = 0x33b0;
                    t.puhiragana = 0x3077;
                    t.pukatakana = 0x30d7;
                    t.pvsquare = 0x33b4;
                    t.pwsquare = 0x33ba;
                    t.q = 0x0071;
                    t.qadeva = 0x0958;
                    t.qadmahebrew = 0x05a8;
                    t.qafarabic = 0x0642;
                    t.qaffinalarabic = 0xfed6;
                    t.qafinitialarabic = 0xfed7;
                    t.qafmedialarabic = 0xfed8;
                    t.qamats = 0x05b8;
                    t.qamats10 = 0x05b8;
                    t.qamats1a = 0x05b8;
                    t.qamats1c = 0x05b8;
                    t.qamats27 = 0x05b8;
                    t.qamats29 = 0x05b8;
                    t.qamats33 = 0x05b8;
                    t.qamatsde = 0x05b8;
                    t.qamatshebrew = 0x05b8;
                    t.qamatsnarrowhebrew = 0x05b8;
                    t.qamatsqatanhebrew = 0x05b8;
                    t.qamatsqatannarrowhebrew = 0x05b8;
                    t.qamatsqatanquarterhebrew = 0x05b8;
                    t.qamatsqatanwidehebrew = 0x05b8;
                    t.qamatsquarterhebrew = 0x05b8;
                    t.qamatswidehebrew = 0x05b8;
                    t.qarneyparahebrew = 0x059f;
                    t.qbopomofo = 0x3111;
                    t.qcircle = 0x24e0;
                    t.qhook = 0x02a0;
                    t.qmonospace = 0xff51;
                    t.qof = 0x05e7;
                    t.qofdagesh = 0xfb47;
                    t.qofdageshhebrew = 0xfb47;
                    t.qofhebrew = 0x05e7;
                    t.qparen = 0x24ac;
                    t.quarternote = 0x2669;
                    t.qubuts = 0x05bb;
                    t.qubuts18 = 0x05bb;
                    t.qubuts25 = 0x05bb;
                    t.qubuts31 = 0x05bb;
                    t.qubutshebrew = 0x05bb;
                    t.qubutsnarrowhebrew = 0x05bb;
                    t.qubutsquarterhebrew = 0x05bb;
                    t.qubutswidehebrew = 0x05bb;
                    t.question = 0x003f;
                    t.questionarabic = 0x061f;
                    t.questionarmenian = 0x055e;
                    t.questiondown = 0x00bf;
                    t.questiondownsmall = 0xf7bf;
                    t.questiongreek = 0x037e;
                    t.questionmonospace = 0xff1f;
                    t.questionsmall = 0xf73f;
                    t.quotedbl = 0x0022;
                    t.quotedblbase = 0x201e;
                    t.quotedblleft = 0x201c;
                    t.quotedblmonospace = 0xff02;
                    t.quotedblprime = 0x301e;
                    t.quotedblprimereversed = 0x301d;
                    t.quotedblright = 0x201d;
                    t.quoteleft = 0x2018;
                    t.quoteleftreversed = 0x201b;
                    t.quotereversed = 0x201b;
                    t.quoteright = 0x2019;
                    t.quoterightn = 0x0149;
                    t.quotesinglbase = 0x201a;
                    t.quotesingle = 0x0027;
                    t.quotesinglemonospace = 0xff07;
                    t.r = 0x0072;
                    t.raarmenian = 0x057c;
                    t.rabengali = 0x09b0;
                    t.racute = 0x0155;
                    t.radeva = 0x0930;
                    t.radical = 0x221a;
                    t.radicalex = 0xf8e5;
                    t.radoverssquare = 0x33ae;
                    t.radoverssquaredsquare = 0x33af;
                    t.radsquare = 0x33ad;
                    t.rafe = 0x05bf;
                    t.rafehebrew = 0x05bf;
                    t.ragujarati = 0x0ab0;
                    t.ragurmukhi = 0x0a30;
                    t.rahiragana = 0x3089;
                    t.rakatakana = 0x30e9;
                    t.rakatakanahalfwidth = 0xff97;
                    t.ralowerdiagonalbengali = 0x09f1;
                    t.ramiddlediagonalbengali = 0x09f0;
                    t.ramshorn = 0x0264;
                    t.ratio = 0x2236;
                    t.rbopomofo = 0x3116;
                    t.rcaron = 0x0159;
                    t.rcedilla = 0x0157;
                    t.rcircle = 0x24e1;
                    t.rcommaaccent = 0x0157;
                    t.rdblgrave = 0x0211;
                    t.rdotaccent = 0x1e59;
                    t.rdotbelow = 0x1e5b;
                    t.rdotbelowmacron = 0x1e5d;
                    t.referencemark = 0x203b;
                    t.reflexsubset = 0x2286;
                    t.reflexsuperset = 0x2287;
                    t.registered = 0x00ae;
                    t.registersans = 0xf8e8;
                    t.registerserif = 0xf6da;
                    t.reharabic = 0x0631;
                    t.reharmenian = 0x0580;
                    t.rehfinalarabic = 0xfeae;
                    t.rehiragana = 0x308c;
                    t.rekatakana = 0x30ec;
                    t.rekatakanahalfwidth = 0xff9a;
                    t.resh = 0x05e8;
                    t.reshdageshhebrew = 0xfb48;
                    t.reshhebrew = 0x05e8;
                    t.reversedtilde = 0x223d;
                    t.reviahebrew = 0x0597;
                    t.reviamugrashhebrew = 0x0597;
                    t.revlogicalnot = 0x2310;
                    t.rfishhook = 0x027e;
                    t.rfishhookreversed = 0x027f;
                    t.rhabengali = 0x09dd;
                    t.rhadeva = 0x095d;
                    t.rho = 0x03c1;
                    t.rhook = 0x027d;
                    t.rhookturned = 0x027b;
                    t.rhookturnedsuperior = 0x02b5;
                    t.rhosymbolgreek = 0x03f1;
                    t.rhotichookmod = 0x02de;
                    t.rieulacirclekorean = 0x3271;
                    t.rieulaparenkorean = 0x3211;
                    t.rieulcirclekorean = 0x3263;
                    t.rieulhieuhkorean = 0x3140;
                    t.rieulkiyeokkorean = 0x313a;
                    t.rieulkiyeoksioskorean = 0x3169;
                    t.rieulkorean = 0x3139;
                    t.rieulmieumkorean = 0x313b;
                    t.rieulpansioskorean = 0x316c;
                    t.rieulparenkorean = 0x3203;
                    t.rieulphieuphkorean = 0x313f;
                    t.rieulpieupkorean = 0x313c;
                    t.rieulpieupsioskorean = 0x316b;
                    t.rieulsioskorean = 0x313d;
                    t.rieulthieuthkorean = 0x313e;
                    t.rieultikeutkorean = 0x316a;
                    t.rieulyeorinhieuhkorean = 0x316d;
                    t.rightangle = 0x221f;
                    t.righttackbelowcmb = 0x0319;
                    t.righttriangle = 0x22bf;
                    t.rihiragana = 0x308a;
                    t.rikatakana = 0x30ea;
                    t.rikatakanahalfwidth = 0xff98;
                    t.ring = 0x02da;
                    t.ringbelowcmb = 0x0325;
                    t.ringcmb = 0x030a;
                    t.ringhalfleft = 0x02bf;
                    t.ringhalfleftarmenian = 0x0559;
                    t.ringhalfleftbelowcmb = 0x031c;
                    t.ringhalfleftcentered = 0x02d3;
                    t.ringhalfright = 0x02be;
                    t.ringhalfrightbelowcmb = 0x0339;
                    t.ringhalfrightcentered = 0x02d2;
                    t.rinvertedbreve = 0x0213;
                    t.rittorusquare = 0x3351;
                    t.rlinebelow = 0x1e5f;
                    t.rlongleg = 0x027c;
                    t.rlonglegturned = 0x027a;
                    t.rmonospace = 0xff52;
                    t.rohiragana = 0x308d;
                    t.rokatakana = 0x30ed;
                    t.rokatakanahalfwidth = 0xff9b;
                    t.roruathai = 0x0e23;
                    t.rparen = 0x24ad;
                    t.rrabengali = 0x09dc;
                    t.rradeva = 0x0931;
                    t.rragurmukhi = 0x0a5c;
                    t.rreharabic = 0x0691;
                    t.rrehfinalarabic = 0xfb8d;
                    t.rrvocalicbengali = 0x09e0;
                    t.rrvocalicdeva = 0x0960;
                    t.rrvocalicgujarati = 0x0ae0;
                    t.rrvocalicvowelsignbengali = 0x09c4;
                    t.rrvocalicvowelsigndeva = 0x0944;
                    t.rrvocalicvowelsigngujarati = 0x0ac4;
                    t.rsuperior = 0xf6f1;
                    t.rtblock = 0x2590;
                    t.rturned = 0x0279;
                    t.rturnedsuperior = 0x02b4;
                    t.ruhiragana = 0x308b;
                    t.rukatakana = 0x30eb;
                    t.rukatakanahalfwidth = 0xff99;
                    t.rupeemarkbengali = 0x09f2;
                    t.rupeesignbengali = 0x09f3;
                    t.rupiah = 0xf6dd;
                    t.ruthai = 0x0e24;
                    t.rvocalicbengali = 0x098b;
                    t.rvocalicdeva = 0x090b;
                    t.rvocalicgujarati = 0x0a8b;
                    t.rvocalicvowelsignbengali = 0x09c3;
                    t.rvocalicvowelsigndeva = 0x0943;
                    t.rvocalicvowelsigngujarati = 0x0ac3;
                    t.s = 0x0073;
                    t.sabengali = 0x09b8;
                    t.sacute = 0x015b;
                    t.sacutedotaccent = 0x1e65;
                    t.sadarabic = 0x0635;
                    t.sadeva = 0x0938;
                    t.sadfinalarabic = 0xfeba;
                    t.sadinitialarabic = 0xfebb;
                    t.sadmedialarabic = 0xfebc;
                    t.sagujarati = 0x0ab8;
                    t.sagurmukhi = 0x0a38;
                    t.sahiragana = 0x3055;
                    t.sakatakana = 0x30b5;
                    t.sakatakanahalfwidth = 0xff7b;
                    t.sallallahoualayhewasallamarabic = 0xfdfa;
                    t.samekh = 0x05e1;
                    t.samekhdagesh = 0xfb41;
                    t.samekhdageshhebrew = 0xfb41;
                    t.samekhhebrew = 0x05e1;
                    t.saraaathai = 0x0e32;
                    t.saraaethai = 0x0e41;
                    t.saraaimaimalaithai = 0x0e44;
                    t.saraaimaimuanthai = 0x0e43;
                    t.saraamthai = 0x0e33;
                    t.saraathai = 0x0e30;
                    t.saraethai = 0x0e40;
                    t.saraiileftthai = 0xf886;
                    t.saraiithai = 0x0e35;
                    t.saraileftthai = 0xf885;
                    t.saraithai = 0x0e34;
                    t.saraothai = 0x0e42;
                    t.saraueeleftthai = 0xf888;
                    t.saraueethai = 0x0e37;
                    t.saraueleftthai = 0xf887;
                    t.sarauethai = 0x0e36;
                    t.sarauthai = 0x0e38;
                    t.sarauuthai = 0x0e39;
                    t.sbopomofo = 0x3119;
                    t.scaron = 0x0161;
                    t.scarondotaccent = 0x1e67;
                    t.scedilla = 0x015f;
                    t.schwa = 0x0259;
                    t.schwacyrillic = 0x04d9;
                    t.schwadieresiscyrillic = 0x04db;
                    t.schwahook = 0x025a;
                    t.scircle = 0x24e2;
                    t.scircumflex = 0x015d;
                    t.scommaaccent = 0x0219;
                    t.sdotaccent = 0x1e61;
                    t.sdotbelow = 0x1e63;
                    t.sdotbelowdotaccent = 0x1e69;
                    t.seagullbelowcmb = 0x033c;
                    t.second = 0x2033;
                    t.secondtonechinese = 0x02ca;
                    t.section = 0x00a7;
                    t.seenarabic = 0x0633;
                    t.seenfinalarabic = 0xfeb2;
                    t.seeninitialarabic = 0xfeb3;
                    t.seenmedialarabic = 0xfeb4;
                    t.segol = 0x05b6;
                    t.segol13 = 0x05b6;
                    t.segol1f = 0x05b6;
                    t.segol2c = 0x05b6;
                    t.segolhebrew = 0x05b6;
                    t.segolnarrowhebrew = 0x05b6;
                    t.segolquarterhebrew = 0x05b6;
                    t.segoltahebrew = 0x0592;
                    t.segolwidehebrew = 0x05b6;
                    t.seharmenian = 0x057d;
                    t.sehiragana = 0x305b;
                    t.sekatakana = 0x30bb;
                    t.sekatakanahalfwidth = 0xff7e;
                    t.semicolon = 0x003b;
                    t.semicolonarabic = 0x061b;
                    t.semicolonmonospace = 0xff1b;
                    t.semicolonsmall = 0xfe54;
                    t.semivoicedmarkkana = 0x309c;
                    t.semivoicedmarkkanahalfwidth = 0xff9f;
                    t.sentisquare = 0x3322;
                    t.sentosquare = 0x3323;
                    t.seven = 0x0037;
                    t.sevenarabic = 0x0667;
                    t.sevenbengali = 0x09ed;
                    t.sevencircle = 0x2466;
                    t.sevencircleinversesansserif = 0x2790;
                    t.sevendeva = 0x096d;
                    t.seveneighths = 0x215e;
                    t.sevengujarati = 0x0aed;
                    t.sevengurmukhi = 0x0a6d;
                    t.sevenhackarabic = 0x0667;
                    t.sevenhangzhou = 0x3027;
                    t.sevenideographicparen = 0x3226;
                    t.seveninferior = 0x2087;
                    t.sevenmonospace = 0xff17;
                    t.sevenoldstyle = 0xf737;
                    t.sevenparen = 0x247a;
                    t.sevenperiod = 0x248e;
                    t.sevenpersian = 0x06f7;
                    t.sevenroman = 0x2176;
                    t.sevensuperior = 0x2077;
                    t.seventeencircle = 0x2470;
                    t.seventeenparen = 0x2484;
                    t.seventeenperiod = 0x2498;
                    t.seventhai = 0x0e57;
                    t.sfthyphen = 0x00ad;
                    t.shaarmenian = 0x0577;
                    t.shabengali = 0x09b6;
                    t.shacyrillic = 0x0448;
                    t.shaddaarabic = 0x0651;
                    t.shaddadammaarabic = 0xfc61;
                    t.shaddadammatanarabic = 0xfc5e;
                    t.shaddafathaarabic = 0xfc60;
                    t.shaddakasraarabic = 0xfc62;
                    t.shaddakasratanarabic = 0xfc5f;
                    t.shade = 0x2592;
                    t.shadedark = 0x2593;
                    t.shadelight = 0x2591;
                    t.shademedium = 0x2592;
                    t.shadeva = 0x0936;
                    t.shagujarati = 0x0ab6;
                    t.shagurmukhi = 0x0a36;
                    t.shalshelethebrew = 0x0593;
                    t.shbopomofo = 0x3115;
                    t.shchacyrillic = 0x0449;
                    t.sheenarabic = 0x0634;
                    t.sheenfinalarabic = 0xfeb6;
                    t.sheeninitialarabic = 0xfeb7;
                    t.sheenmedialarabic = 0xfeb8;
                    t.sheicoptic = 0x03e3;
                    t.sheqel = 0x20aa;
                    t.sheqelhebrew = 0x20aa;
                    t.sheva = 0x05b0;
                    t.sheva115 = 0x05b0;
                    t.sheva15 = 0x05b0;
                    t.sheva22 = 0x05b0;
                    t.sheva2e = 0x05b0;
                    t.shevahebrew = 0x05b0;
                    t.shevanarrowhebrew = 0x05b0;
                    t.shevaquarterhebrew = 0x05b0;
                    t.shevawidehebrew = 0x05b0;
                    t.shhacyrillic = 0x04bb;
                    t.shimacoptic = 0x03ed;
                    t.shin = 0x05e9;
                    t.shindagesh = 0xfb49;
                    t.shindageshhebrew = 0xfb49;
                    t.shindageshshindot = 0xfb2c;
                    t.shindageshshindothebrew = 0xfb2c;
                    t.shindageshsindot = 0xfb2d;
                    t.shindageshsindothebrew = 0xfb2d;
                    t.shindothebrew = 0x05c1;
                    t.shinhebrew = 0x05e9;
                    t.shinshindot = 0xfb2a;
                    t.shinshindothebrew = 0xfb2a;
                    t.shinsindot = 0xfb2b;
                    t.shinsindothebrew = 0xfb2b;
                    t.shook = 0x0282;
                    t.sigma = 0x03c3;
                    t.sigma1 = 0x03c2;
                    t.sigmafinal = 0x03c2;
                    t.sigmalunatesymbolgreek = 0x03f2;
                    t.sihiragana = 0x3057;
                    t.sikatakana = 0x30b7;
                    t.sikatakanahalfwidth = 0xff7c;
                    t.siluqhebrew = 0x05bd;
                    t.siluqlefthebrew = 0x05bd;
                    t.similar = 0x223c;
                    t.sindothebrew = 0x05c2;
                    t.siosacirclekorean = 0x3274;
                    t.siosaparenkorean = 0x3214;
                    t.sioscieuckorean = 0x317e;
                    t.sioscirclekorean = 0x3266;
                    t.sioskiyeokkorean = 0x317a;
                    t.sioskorean = 0x3145;
                    t.siosnieunkorean = 0x317b;
                    t.siosparenkorean = 0x3206;
                    t.siospieupkorean = 0x317d;
                    t.siostikeutkorean = 0x317c;
                    t.six = 0x0036;
                    t.sixarabic = 0x0666;
                    t.sixbengali = 0x09ec;
                    t.sixcircle = 0x2465;
                    t.sixcircleinversesansserif = 0x278f;
                    t.sixdeva = 0x096c;
                    t.sixgujarati = 0x0aec;
                    t.sixgurmukhi = 0x0a6c;
                    t.sixhackarabic = 0x0666;
                    t.sixhangzhou = 0x3026;
                    t.sixideographicparen = 0x3225;
                    t.sixinferior = 0x2086;
                    t.sixmonospace = 0xff16;
                    t.sixoldstyle = 0xf736;
                    t.sixparen = 0x2479;
                    t.sixperiod = 0x248d;
                    t.sixpersian = 0x06f6;
                    t.sixroman = 0x2175;
                    t.sixsuperior = 0x2076;
                    t.sixteencircle = 0x246f;
                    t.sixteencurrencydenominatorbengali = 0x09f9;
                    t.sixteenparen = 0x2483;
                    t.sixteenperiod = 0x2497;
                    t.sixthai = 0x0e56;
                    t.slash = 0x002f;
                    t.slashmonospace = 0xff0f;
                    t.slong = 0x017f;
                    t.slongdotaccent = 0x1e9b;
                    t.smileface = 0x263a;
                    t.smonospace = 0xff53;
                    t.sofpasuqhebrew = 0x05c3;
                    t.softhyphen = 0x00ad;
                    t.softsigncyrillic = 0x044c;
                    t.sohiragana = 0x305d;
                    t.sokatakana = 0x30bd;
                    t.sokatakanahalfwidth = 0xff7f;
                    t.soliduslongoverlaycmb = 0x0338;
                    t.solidusshortoverlaycmb = 0x0337;
                    t.sorusithai = 0x0e29;
                    t.sosalathai = 0x0e28;
                    t.sosothai = 0x0e0b;
                    t.sosuathai = 0x0e2a;
                    t.space = 0x0020;
                    t.spacehackarabic = 0x0020;
                    t.spade = 0x2660;
                    t.spadesuitblack = 0x2660;
                    t.spadesuitwhite = 0x2664;
                    t.sparen = 0x24ae;
                    t.squarebelowcmb = 0x033b;
                    t.squarecc = 0x33c4;
                    t.squarecm = 0x339d;
                    t.squarediagonalcrosshatchfill = 0x25a9;
                    t.squarehorizontalfill = 0x25a4;
                    t.squarekg = 0x338f;
                    t.squarekm = 0x339e;
                    t.squarekmcapital = 0x33ce;
                    t.squareln = 0x33d1;
                    t.squarelog = 0x33d2;
                    t.squaremg = 0x338e;
                    t.squaremil = 0x33d5;
                    t.squaremm = 0x339c;
                    t.squaremsquared = 0x33a1;
                    t.squareorthogonalcrosshatchfill = 0x25a6;
                    t.squareupperlefttolowerrightfill = 0x25a7;
                    t.squareupperrighttolowerleftfill = 0x25a8;
                    t.squareverticalfill = 0x25a5;
                    t.squarewhitewithsmallblack = 0x25a3;
                    t.srsquare = 0x33db;
                    t.ssabengali = 0x09b7;
                    t.ssadeva = 0x0937;
                    t.ssagujarati = 0x0ab7;
                    t.ssangcieuckorean = 0x3149;
                    t.ssanghieuhkorean = 0x3185;
                    t.ssangieungkorean = 0x3180;
                    t.ssangkiyeokkorean = 0x3132;
                    t.ssangnieunkorean = 0x3165;
                    t.ssangpieupkorean = 0x3143;
                    t.ssangsioskorean = 0x3146;
                    t.ssangtikeutkorean = 0x3138;
                    t.ssuperior = 0xf6f2;
                    t.sterling = 0x00a3;
                    t.sterlingmonospace = 0xffe1;
                    t.strokelongoverlaycmb = 0x0336;
                    t.strokeshortoverlaycmb = 0x0335;
                    t.subset = 0x2282;
                    t.subsetnotequal = 0x228a;
                    t.subsetorequal = 0x2286;
                    t.succeeds = 0x227b;
                    t.suchthat = 0x220b;
                    t.suhiragana = 0x3059;
                    t.sukatakana = 0x30b9;
                    t.sukatakanahalfwidth = 0xff7d;
                    t.sukunarabic = 0x0652;
                    t.summation = 0x2211;
                    t.sun = 0x263c;
                    t.superset = 0x2283;
                    t.supersetnotequal = 0x228b;
                    t.supersetorequal = 0x2287;
                    t.svsquare = 0x33dc;
                    t.syouwaerasquare = 0x337c;
                    t.t = 0x0074;
                    t.tabengali = 0x09a4;
                    t.tackdown = 0x22a4;
                    t.tackleft = 0x22a3;
                    t.tadeva = 0x0924;
                    t.tagujarati = 0x0aa4;
                    t.tagurmukhi = 0x0a24;
                    t.taharabic = 0x0637;
                    t.tahfinalarabic = 0xfec2;
                    t.tahinitialarabic = 0xfec3;
                    t.tahiragana = 0x305f;
                    t.tahmedialarabic = 0xfec4;
                    t.taisyouerasquare = 0x337d;
                    t.takatakana = 0x30bf;
                    t.takatakanahalfwidth = 0xff80;
                    t.tatweelarabic = 0x0640;
                    t.tau = 0x03c4;
                    t.tav = 0x05ea;
                    t.tavdages = 0xfb4a;
                    t.tavdagesh = 0xfb4a;
                    t.tavdageshhebrew = 0xfb4a;
                    t.tavhebrew = 0x05ea;
                    t.tbar = 0x0167;
                    t.tbopomofo = 0x310a;
                    t.tcaron = 0x0165;
                    t.tccurl = 0x02a8;
                    t.tcedilla = 0x0163;
                    t.tcheharabic = 0x0686;
                    t.tchehfinalarabic = 0xfb7b;
                    t.tchehinitialarabic = 0xfb7c;
                    t.tchehmedialarabic = 0xfb7d;
                    t.tcircle = 0x24e3;
                    t.tcircumflexbelow = 0x1e71;
                    t.tcommaaccent = 0x0163;
                    t.tdieresis = 0x1e97;
                    t.tdotaccent = 0x1e6b;
                    t.tdotbelow = 0x1e6d;
                    t.tecyrillic = 0x0442;
                    t.tedescendercyrillic = 0x04ad;
                    t.teharabic = 0x062a;
                    t.tehfinalarabic = 0xfe96;
                    t.tehhahinitialarabic = 0xfca2;
                    t.tehhahisolatedarabic = 0xfc0c;
                    t.tehinitialarabic = 0xfe97;
                    t.tehiragana = 0x3066;
                    t.tehjeeminitialarabic = 0xfca1;
                    t.tehjeemisolatedarabic = 0xfc0b;
                    t.tehmarbutaarabic = 0x0629;
                    t.tehmarbutafinalarabic = 0xfe94;
                    t.tehmedialarabic = 0xfe98;
                    t.tehmeeminitialarabic = 0xfca4;
                    t.tehmeemisolatedarabic = 0xfc0e;
                    t.tehnoonfinalarabic = 0xfc73;
                    t.tekatakana = 0x30c6;
                    t.tekatakanahalfwidth = 0xff83;
                    t.telephone = 0x2121;
                    t.telephoneblack = 0x260e;
                    t.telishagedolahebrew = 0x05a0;
                    t.telishaqetanahebrew = 0x05a9;
                    t.tencircle = 0x2469;
                    t.tenideographicparen = 0x3229;
                    t.tenparen = 0x247d;
                    t.tenperiod = 0x2491;
                    t.tenroman = 0x2179;
                    t.tesh = 0x02a7;
                    t.tet = 0x05d8;
                    t.tetdagesh = 0xfb38;
                    t.tetdageshhebrew = 0xfb38;
                    t.tethebrew = 0x05d8;
                    t.tetsecyrillic = 0x04b5;
                    t.tevirhebrew = 0x059b;
                    t.tevirlefthebrew = 0x059b;
                    t.thabengali = 0x09a5;
                    t.thadeva = 0x0925;
                    t.thagujarati = 0x0aa5;
                    t.thagurmukhi = 0x0a25;
                    t.thalarabic = 0x0630;
                    t.thalfinalarabic = 0xfeac;
                    t.thanthakhatlowleftthai = 0xf898;
                    t.thanthakhatlowrightthai = 0xf897;
                    t.thanthakhatthai = 0x0e4c;
                    t.thanthakhatupperleftthai = 0xf896;
                    t.theharabic = 0x062b;
                    t.thehfinalarabic = 0xfe9a;
                    t.thehinitialarabic = 0xfe9b;
                    t.thehmedialarabic = 0xfe9c;
                    t.thereexists = 0x2203;
                    t.therefore = 0x2234;
                    t.theta = 0x03b8;
                    t.theta1 = 0x03d1;
                    t.thetasymbolgreek = 0x03d1;
                    t.thieuthacirclekorean = 0x3279;
                    t.thieuthaparenkorean = 0x3219;
                    t.thieuthcirclekorean = 0x326b;
                    t.thieuthkorean = 0x314c;
                    t.thieuthparenkorean = 0x320b;
                    t.thirteencircle = 0x246c;
                    t.thirteenparen = 0x2480;
                    t.thirteenperiod = 0x2494;
                    t.thonangmonthothai = 0x0e11;
                    t.thook = 0x01ad;
                    t.thophuthaothai = 0x0e12;
                    t.thorn = 0x00fe;
                    t.thothahanthai = 0x0e17;
                    t.thothanthai = 0x0e10;
                    t.thothongthai = 0x0e18;
                    t.thothungthai = 0x0e16;
                    t.thousandcyrillic = 0x0482;
                    t.thousandsseparatorarabic = 0x066c;
                    t.thousandsseparatorpersian = 0x066c;
                    t.three = 0x0033;
                    t.threearabic = 0x0663;
                    t.threebengali = 0x09e9;
                    t.threecircle = 0x2462;
                    t.threecircleinversesansserif = 0x278c;
                    t.threedeva = 0x0969;
                    t.threeeighths = 0x215c;
                    t.threegujarati = 0x0ae9;
                    t.threegurmukhi = 0x0a69;
                    t.threehackarabic = 0x0663;
                    t.threehangzhou = 0x3023;
                    t.threeideographicparen = 0x3222;
                    t.threeinferior = 0x2083;
                    t.threemonospace = 0xff13;
                    t.threenumeratorbengali = 0x09f6;
                    t.threeoldstyle = 0xf733;
                    t.threeparen = 0x2476;
                    t.threeperiod = 0x248a;
                    t.threepersian = 0x06f3;
                    t.threequarters = 0x00be;
                    t.threequartersemdash = 0xf6de;
                    t.threeroman = 0x2172;
                    t.threesuperior = 0x00b3;
                    t.threethai = 0x0e53;
                    t.thzsquare = 0x3394;
                    t.tihiragana = 0x3061;
                    t.tikatakana = 0x30c1;
                    t.tikatakanahalfwidth = 0xff81;
                    t.tikeutacirclekorean = 0x3270;
                    t.tikeutaparenkorean = 0x3210;
                    t.tikeutcirclekorean = 0x3262;
                    t.tikeutkorean = 0x3137;
                    t.tikeutparenkorean = 0x3202;
                    t.tilde = 0x02dc;
                    t.tildebelowcmb = 0x0330;
                    t.tildecmb = 0x0303;
                    t.tildecomb = 0x0303;
                    t.tildedoublecmb = 0x0360;
                    t.tildeoperator = 0x223c;
                    t.tildeoverlaycmb = 0x0334;
                    t.tildeverticalcmb = 0x033e;
                    t.timescircle = 0x2297;
                    t.tipehahebrew = 0x0596;
                    t.tipehalefthebrew = 0x0596;
                    t.tippigurmukhi = 0x0a70;
                    t.titlocyrilliccmb = 0x0483;
                    t.tiwnarmenian = 0x057f;
                    t.tlinebelow = 0x1e6f;
                    t.tmonospace = 0xff54;
                    t.toarmenian = 0x0569;
                    t.tohiragana = 0x3068;
                    t.tokatakana = 0x30c8;
                    t.tokatakanahalfwidth = 0xff84;
                    t.tonebarextrahighmod = 0x02e5;
                    t.tonebarextralowmod = 0x02e9;
                    t.tonebarhighmod = 0x02e6;
                    t.tonebarlowmod = 0x02e8;
                    t.tonebarmidmod = 0x02e7;
                    t.tonefive = 0x01bd;
                    t.tonesix = 0x0185;
                    t.tonetwo = 0x01a8;
                    t.tonos = 0x0384;
                    t.tonsquare = 0x3327;
                    t.topatakthai = 0x0e0f;
                    t.tortoiseshellbracketleft = 0x3014;
                    t.tortoiseshellbracketleftsmall = 0xfe5d;
                    t.tortoiseshellbracketleftvertical = 0xfe39;
                    t.tortoiseshellbracketright = 0x3015;
                    t.tortoiseshellbracketrightsmall = 0xfe5e;
                    t.tortoiseshellbracketrightvertical = 0xfe3a;
                    t.totaothai = 0x0e15;
                    t.tpalatalhook = 0x01ab;
                    t.tparen = 0x24af;
                    t.trademark = 0x2122;
                    t.trademarksans = 0xf8ea;
                    t.trademarkserif = 0xf6db;
                    t.tretroflexhook = 0x0288;
                    t.triagdn = 0x25bc;
                    t.triaglf = 0x25c4;
                    t.triagrt = 0x25ba;
                    t.triagup = 0x25b2;
                    t.ts = 0x02a6;
                    t.tsadi = 0x05e6;
                    t.tsadidagesh = 0xfb46;
                    t.tsadidageshhebrew = 0xfb46;
                    t.tsadihebrew = 0x05e6;
                    t.tsecyrillic = 0x0446;
                    t.tsere = 0x05b5;
                    t.tsere12 = 0x05b5;
                    t.tsere1e = 0x05b5;
                    t.tsere2b = 0x05b5;
                    t.tserehebrew = 0x05b5;
                    t.tserenarrowhebrew = 0x05b5;
                    t.tserequarterhebrew = 0x05b5;
                    t.tserewidehebrew = 0x05b5;
                    t.tshecyrillic = 0x045b;
                    t.tsuperior = 0xf6f3;
                    t.ttabengali = 0x099f;
                    t.ttadeva = 0x091f;
                    t.ttagujarati = 0x0a9f;
                    t.ttagurmukhi = 0x0a1f;
                    t.tteharabic = 0x0679;
                    t.ttehfinalarabic = 0xfb67;
                    t.ttehinitialarabic = 0xfb68;
                    t.ttehmedialarabic = 0xfb69;
                    t.tthabengali = 0x09a0;
                    t.tthadeva = 0x0920;
                    t.tthagujarati = 0x0aa0;
                    t.tthagurmukhi = 0x0a20;
                    t.tturned = 0x0287;
                    t.tuhiragana = 0x3064;
                    t.tukatakana = 0x30c4;
                    t.tukatakanahalfwidth = 0xff82;
                    t.tusmallhiragana = 0x3063;
                    t.tusmallkatakana = 0x30c3;
                    t.tusmallkatakanahalfwidth = 0xff6f;
                    t.twelvecircle = 0x246b;
                    t.twelveparen = 0x247f;
                    t.twelveperiod = 0x2493;
                    t.twelveroman = 0x217b;
                    t.twentycircle = 0x2473;
                    t.twentyhangzhou = 0x5344;
                    t.twentyparen = 0x2487;
                    t.twentyperiod = 0x249b;
                    t.two = 0x0032;
                    t.twoarabic = 0x0662;
                    t.twobengali = 0x09e8;
                    t.twocircle = 0x2461;
                    t.twocircleinversesansserif = 0x278b;
                    t.twodeva = 0x0968;
                    t.twodotenleader = 0x2025;
                    t.twodotleader = 0x2025;
                    t.twodotleadervertical = 0xfe30;
                    t.twogujarati = 0x0ae8;
                    t.twogurmukhi = 0x0a68;
                    t.twohackarabic = 0x0662;
                    t.twohangzhou = 0x3022;
                    t.twoideographicparen = 0x3221;
                    t.twoinferior = 0x2082;
                    t.twomonospace = 0xff12;
                    t.twonumeratorbengali = 0x09f5;
                    t.twooldstyle = 0xf732;
                    t.twoparen = 0x2475;
                    t.twoperiod = 0x2489;
                    t.twopersian = 0x06f2;
                    t.tworoman = 0x2171;
                    t.twostroke = 0x01bb;
                    t.twosuperior = 0x00b2;
                    t.twothai = 0x0e52;
                    t.twothirds = 0x2154;
                    t.u = 0x0075;
                    t.uacute = 0x00fa;
                    t.ubar = 0x0289;
                    t.ubengali = 0x0989;
                    t.ubopomofo = 0x3128;
                    t.ubreve = 0x016d;
                    t.ucaron = 0x01d4;
                    t.ucircle = 0x24e4;
                    t.ucircumflex = 0x00fb;
                    t.ucircumflexbelow = 0x1e77;
                    t.ucyrillic = 0x0443;
                    t.udattadeva = 0x0951;
                    t.udblacute = 0x0171;
                    t.udblgrave = 0x0215;
                    t.udeva = 0x0909;
                    t.udieresis = 0x00fc;
                    t.udieresisacute = 0x01d8;
                    t.udieresisbelow = 0x1e73;
                    t.udieresiscaron = 0x01da;
                    t.udieresiscyrillic = 0x04f1;
                    t.udieresisgrave = 0x01dc;
                    t.udieresismacron = 0x01d6;
                    t.udotbelow = 0x1ee5;
                    t.ugrave = 0x00f9;
                    t.ugujarati = 0x0a89;
                    t.ugurmukhi = 0x0a09;
                    t.uhiragana = 0x3046;
                    t.uhookabove = 0x1ee7;
                    t.uhorn = 0x01b0;
                    t.uhornacute = 0x1ee9;
                    t.uhorndotbelow = 0x1ef1;
                    t.uhorngrave = 0x1eeb;
                    t.uhornhookabove = 0x1eed;
                    t.uhorntilde = 0x1eef;
                    t.uhungarumlaut = 0x0171;
                    t.uhungarumlautcyrillic = 0x04f3;
                    t.uinvertedbreve = 0x0217;
                    t.ukatakana = 0x30a6;
                    t.ukatakanahalfwidth = 0xff73;
                    t.ukcyrillic = 0x0479;
                    t.ukorean = 0x315c;
                    t.umacron = 0x016b;
                    t.umacroncyrillic = 0x04ef;
                    t.umacrondieresis = 0x1e7b;
                    t.umatragurmukhi = 0x0a41;
                    t.umonospace = 0xff55;
                    t.underscore = 0x005f;
                    t.underscoredbl = 0x2017;
                    t.underscoremonospace = 0xff3f;
                    t.underscorevertical = 0xfe33;
                    t.underscorewavy = 0xfe4f;
                    t.union = 0x222a;
                    t.universal = 0x2200;
                    t.uogonek = 0x0173;
                    t.uparen = 0x24b0;
                    t.upblock = 0x2580;
                    t.upperdothebrew = 0x05c4;
                    t.upsilon = 0x03c5;
                    t.upsilondieresis = 0x03cb;
                    t.upsilondieresistonos = 0x03b0;
                    t.upsilonlatin = 0x028a;
                    t.upsilontonos = 0x03cd;
                    t.uptackbelowcmb = 0x031d;
                    t.uptackmod = 0x02d4;
                    t.uragurmukhi = 0x0a73;
                    t.uring = 0x016f;
                    t.ushortcyrillic = 0x045e;
                    t.usmallhiragana = 0x3045;
                    t.usmallkatakana = 0x30a5;
                    t.usmallkatakanahalfwidth = 0xff69;
                    t.ustraightcyrillic = 0x04af;
                    t.ustraightstrokecyrillic = 0x04b1;
                    t.utilde = 0x0169;
                    t.utildeacute = 0x1e79;
                    t.utildebelow = 0x1e75;
                    t.uubengali = 0x098a;
                    t.uudeva = 0x090a;
                    t.uugujarati = 0x0a8a;
                    t.uugurmukhi = 0x0a0a;
                    t.uumatragurmukhi = 0x0a42;
                    t.uuvowelsignbengali = 0x09c2;
                    t.uuvowelsigndeva = 0x0942;
                    t.uuvowelsigngujarati = 0x0ac2;
                    t.uvowelsignbengali = 0x09c1;
                    t.uvowelsigndeva = 0x0941;
                    t.uvowelsigngujarati = 0x0ac1;
                    t.v = 0x0076;
                    t.vadeva = 0x0935;
                    t.vagujarati = 0x0ab5;
                    t.vagurmukhi = 0x0a35;
                    t.vakatakana = 0x30f7;
                    t.vav = 0x05d5;
                    t.vavdagesh = 0xfb35;
                    t.vavdagesh65 = 0xfb35;
                    t.vavdageshhebrew = 0xfb35;
                    t.vavhebrew = 0x05d5;
                    t.vavholam = 0xfb4b;
                    t.vavholamhebrew = 0xfb4b;
                    t.vavvavhebrew = 0x05f0;
                    t.vavyodhebrew = 0x05f1;
                    t.vcircle = 0x24e5;
                    t.vdotbelow = 0x1e7f;
                    t.vecyrillic = 0x0432;
                    t.veharabic = 0x06a4;
                    t.vehfinalarabic = 0xfb6b;
                    t.vehinitialarabic = 0xfb6c;
                    t.vehmedialarabic = 0xfb6d;
                    t.vekatakana = 0x30f9;
                    t.venus = 0x2640;
                    t.verticalbar = 0x007c;
                    t.verticallineabovecmb = 0x030d;
                    t.verticallinebelowcmb = 0x0329;
                    t.verticallinelowmod = 0x02cc;
                    t.verticallinemod = 0x02c8;
                    t.vewarmenian = 0x057e;
                    t.vhook = 0x028b;
                    t.vikatakana = 0x30f8;
                    t.viramabengali = 0x09cd;
                    t.viramadeva = 0x094d;
                    t.viramagujarati = 0x0acd;
                    t.visargabengali = 0x0983;
                    t.visargadeva = 0x0903;
                    t.visargagujarati = 0x0a83;
                    t.vmonospace = 0xff56;
                    t.voarmenian = 0x0578;
                    t.voicediterationhiragana = 0x309e;
                    t.voicediterationkatakana = 0x30fe;
                    t.voicedmarkkana = 0x309b;
                    t.voicedmarkkanahalfwidth = 0xff9e;
                    t.vokatakana = 0x30fa;
                    t.vparen = 0x24b1;
                    t.vtilde = 0x1e7d;
                    t.vturned = 0x028c;
                    t.vuhiragana = 0x3094;
                    t.vukatakana = 0x30f4;
                    t.w = 0x0077;
                    t.wacute = 0x1e83;
                    t.waekorean = 0x3159;
                    t.wahiragana = 0x308f;
                    t.wakatakana = 0x30ef;
                    t.wakatakanahalfwidth = 0xff9c;
                    t.wakorean = 0x3158;
                    t.wasmallhiragana = 0x308e;
                    t.wasmallkatakana = 0x30ee;
                    t.wattosquare = 0x3357;
                    t.wavedash = 0x301c;
                    t.wavyunderscorevertical = 0xfe34;
                    t.wawarabic = 0x0648;
                    t.wawfinalarabic = 0xfeee;
                    t.wawhamzaabovearabic = 0x0624;
                    t.wawhamzaabovefinalarabic = 0xfe86;
                    t.wbsquare = 0x33dd;
                    t.wcircle = 0x24e6;
                    t.wcircumflex = 0x0175;
                    t.wdieresis = 0x1e85;
                    t.wdotaccent = 0x1e87;
                    t.wdotbelow = 0x1e89;
                    t.wehiragana = 0x3091;
                    t.weierstrass = 0x2118;
                    t.wekatakana = 0x30f1;
                    t.wekorean = 0x315e;
                    t.weokorean = 0x315d;
                    t.wgrave = 0x1e81;
                    t.whitebullet = 0x25e6;
                    t.whitecircle = 0x25cb;
                    t.whitecircleinverse = 0x25d9;
                    t.whitecornerbracketleft = 0x300e;
                    t.whitecornerbracketleftvertical = 0xfe43;
                    t.whitecornerbracketright = 0x300f;
                    t.whitecornerbracketrightvertical = 0xfe44;
                    t.whitediamond = 0x25c7;
                    t.whitediamondcontainingblacksmalldiamond = 0x25c8;
                    t.whitedownpointingsmalltriangle = 0x25bf;
                    t.whitedownpointingtriangle = 0x25bd;
                    t.whiteleftpointingsmalltriangle = 0x25c3;
                    t.whiteleftpointingtriangle = 0x25c1;
                    t.whitelenticularbracketleft = 0x3016;
                    t.whitelenticularbracketright = 0x3017;
                    t.whiterightpointingsmalltriangle = 0x25b9;
                    t.whiterightpointingtriangle = 0x25b7;
                    t.whitesmallsquare = 0x25ab;
                    t.whitesmilingface = 0x263a;
                    t.whitesquare = 0x25a1;
                    t.whitestar = 0x2606;
                    t.whitetelephone = 0x260f;
                    t.whitetortoiseshellbracketleft = 0x3018;
                    t.whitetortoiseshellbracketright = 0x3019;
                    t.whiteuppointingsmalltriangle = 0x25b5;
                    t.whiteuppointingtriangle = 0x25b3;
                    t.wihiragana = 0x3090;
                    t.wikatakana = 0x30f0;
                    t.wikorean = 0x315f;
                    t.wmonospace = 0xff57;
                    t.wohiragana = 0x3092;
                    t.wokatakana = 0x30f2;
                    t.wokatakanahalfwidth = 0xff66;
                    t.won = 0x20a9;
                    t.wonmonospace = 0xffe6;
                    t.wowaenthai = 0x0e27;
                    t.wparen = 0x24b2;
                    t.wring = 0x1e98;
                    t.wsuperior = 0x02b7;
                    t.wturned = 0x028d;
                    t.wynn = 0x01bf;
                    t.x = 0x0078;
                    t.xabovecmb = 0x033d;
                    t.xbopomofo = 0x3112;
                    t.xcircle = 0x24e7;
                    t.xdieresis = 0x1e8d;
                    t.xdotaccent = 0x1e8b;
                    t.xeharmenian = 0x056d;
                    t.xi = 0x03be;
                    t.xmonospace = 0xff58;
                    t.xparen = 0x24b3;
                    t.xsuperior = 0x02e3;
                    t.y = 0x0079;
                    t.yaadosquare = 0x334e;
                    t.yabengali = 0x09af;
                    t.yacute = 0x00fd;
                    t.yadeva = 0x092f;
                    t.yaekorean = 0x3152;
                    t.yagujarati = 0x0aaf;
                    t.yagurmukhi = 0x0a2f;
                    t.yahiragana = 0x3084;
                    t.yakatakana = 0x30e4;
                    t.yakatakanahalfwidth = 0xff94;
                    t.yakorean = 0x3151;
                    t.yamakkanthai = 0x0e4e;
                    t.yasmallhiragana = 0x3083;
                    t.yasmallkatakana = 0x30e3;
                    t.yasmallkatakanahalfwidth = 0xff6c;
                    t.yatcyrillic = 0x0463;
                    t.ycircle = 0x24e8;
                    t.ycircumflex = 0x0177;
                    t.ydieresis = 0x00ff;
                    t.ydotaccent = 0x1e8f;
                    t.ydotbelow = 0x1ef5;
                    t.yeharabic = 0x064a;
                    t.yehbarreearabic = 0x06d2;
                    t.yehbarreefinalarabic = 0xfbaf;
                    t.yehfinalarabic = 0xfef2;
                    t.yehhamzaabovearabic = 0x0626;
                    t.yehhamzaabovefinalarabic = 0xfe8a;
                    t.yehhamzaaboveinitialarabic = 0xfe8b;
                    t.yehhamzaabovemedialarabic = 0xfe8c;
                    t.yehinitialarabic = 0xfef3;
                    t.yehmedialarabic = 0xfef4;
                    t.yehmeeminitialarabic = 0xfcdd;
                    t.yehmeemisolatedarabic = 0xfc58;
                    t.yehnoonfinalarabic = 0xfc94;
                    t.yehthreedotsbelowarabic = 0x06d1;
                    t.yekorean = 0x3156;
                    t.yen = 0x00a5;
                    t.yenmonospace = 0xffe5;
                    t.yeokorean = 0x3155;
                    t.yeorinhieuhkorean = 0x3186;
                    t.yerahbenyomohebrew = 0x05aa;
                    t.yerahbenyomolefthebrew = 0x05aa;
                    t.yericyrillic = 0x044b;
                    t.yerudieresiscyrillic = 0x04f9;
                    t.yesieungkorean = 0x3181;
                    t.yesieungpansioskorean = 0x3183;
                    t.yesieungsioskorean = 0x3182;
                    t.yetivhebrew = 0x059a;
                    t.ygrave = 0x1ef3;
                    t.yhook = 0x01b4;
                    t.yhookabove = 0x1ef7;
                    t.yiarmenian = 0x0575;
                    t.yicyrillic = 0x0457;
                    t.yikorean = 0x3162;
                    t.yinyang = 0x262f;
                    t.yiwnarmenian = 0x0582;
                    t.ymonospace = 0xff59;
                    t.yod = 0x05d9;
                    t.yoddagesh = 0xfb39;
                    t.yoddageshhebrew = 0xfb39;
                    t.yodhebrew = 0x05d9;
                    t.yodyodhebrew = 0x05f2;
                    t.yodyodpatahhebrew = 0xfb1f;
                    t.yohiragana = 0x3088;
                    t.yoikorean = 0x3189;
                    t.yokatakana = 0x30e8;
                    t.yokatakanahalfwidth = 0xff96;
                    t.yokorean = 0x315b;
                    t.yosmallhiragana = 0x3087;
                    t.yosmallkatakana = 0x30e7;
                    t.yosmallkatakanahalfwidth = 0xff6e;
                    t.yotgreek = 0x03f3;
                    t.yoyaekorean = 0x3188;
                    t.yoyakorean = 0x3187;
                    t.yoyakthai = 0x0e22;
                    t.yoyingthai = 0x0e0d;
                    t.yparen = 0x24b4;
                    t.ypogegrammeni = 0x037a;
                    t.ypogegrammenigreekcmb = 0x0345;
                    t.yr = 0x01a6;
                    t.yring = 0x1e99;
                    t.ysuperior = 0x02b8;
                    t.ytilde = 0x1ef9;
                    t.yturned = 0x028e;
                    t.yuhiragana = 0x3086;
                    t.yuikorean = 0x318c;
                    t.yukatakana = 0x30e6;
                    t.yukatakanahalfwidth = 0xff95;
                    t.yukorean = 0x3160;
                    t.yusbigcyrillic = 0x046b;
                    t.yusbigiotifiedcyrillic = 0x046d;
                    t.yuslittlecyrillic = 0x0467;
                    t.yuslittleiotifiedcyrillic = 0x0469;
                    t.yusmallhiragana = 0x3085;
                    t.yusmallkatakana = 0x30e5;
                    t.yusmallkatakanahalfwidth = 0xff6d;
                    t.yuyekorean = 0x318b;
                    t.yuyeokorean = 0x318a;
                    t.yyabengali = 0x09df;
                    t.yyadeva = 0x095f;
                    t.z = 0x007a;
                    t.zaarmenian = 0x0566;
                    t.zacute = 0x017a;
                    t.zadeva = 0x095b;
                    t.zagurmukhi = 0x0a5b;
                    t.zaharabic = 0x0638;
                    t.zahfinalarabic = 0xfec6;
                    t.zahinitialarabic = 0xfec7;
                    t.zahiragana = 0x3056;
                    t.zahmedialarabic = 0xfec8;
                    t.zainarabic = 0x0632;
                    t.zainfinalarabic = 0xfeb0;
                    t.zakatakana = 0x30b6;
                    t.zaqefgadolhebrew = 0x0595;
                    t.zaqefqatanhebrew = 0x0594;
                    t.zarqahebrew = 0x0598;
                    t.zayin = 0x05d6;
                    t.zayindagesh = 0xfb36;
                    t.zayindageshhebrew = 0xfb36;
                    t.zayinhebrew = 0x05d6;
                    t.zbopomofo = 0x3117;
                    t.zcaron = 0x017e;
                    t.zcircle = 0x24e9;
                    t.zcircumflex = 0x1e91;
                    t.zcurl = 0x0291;
                    t.zdot = 0x017c;
                    t.zdotaccent = 0x017c;
                    t.zdotbelow = 0x1e93;
                    t.zecyrillic = 0x0437;
                    t.zedescendercyrillic = 0x0499;
                    t.zedieresiscyrillic = 0x04df;
                    t.zehiragana = 0x305c;
                    t.zekatakana = 0x30bc;
                    t.zero = 0x0030;
                    t.zeroarabic = 0x0660;
                    t.zerobengali = 0x09e6;
                    t.zerodeva = 0x0966;
                    t.zerogujarati = 0x0ae6;
                    t.zerogurmukhi = 0x0a66;
                    t.zerohackarabic = 0x0660;
                    t.zeroinferior = 0x2080;
                    t.zeromonospace = 0xff10;
                    t.zerooldstyle = 0xf730;
                    t.zeropersian = 0x06f0;
                    t.zerosuperior = 0x2070;
                    t.zerothai = 0x0e50;
                    t.zerowidthjoiner = 0xfeff;
                    t.zerowidthnonjoiner = 0x200c;
                    t.zerowidthspace = 0x200b;
                    t.zeta = 0x03b6;
                    t.zhbopomofo = 0x3113;
                    t.zhearmenian = 0x056a;
                    t.zhebrevecyrillic = 0x04c2;
                    t.zhecyrillic = 0x0436;
                    t.zhedescendercyrillic = 0x0497;
                    t.zhedieresiscyrillic = 0x04dd;
                    t.zihiragana = 0x3058;
                    t.zikatakana = 0x30b8;
                    t.zinorhebrew = 0x05ae;
                    t.zlinebelow = 0x1e95;
                    t.zmonospace = 0xff5a;
                    t.zohiragana = 0x305e;
                    t.zokatakana = 0x30be;
                    t.zparen = 0x24b5;
                    t.zretroflexhook = 0x0290;
                    t.zstroke = 0x01b6;
                    t.zuhiragana = 0x305a;
                    t.zukatakana = 0x30ba;
                    t[".notdef"] = 0x0000;
                    t.angbracketleftbig = 0x2329;
                    t.angbracketleftBig = 0x2329;
                    t.angbracketleftbigg = 0x2329;
                    t.angbracketleftBigg = 0x2329;
                    t.angbracketrightBig = 0x232a;
                    t.angbracketrightbig = 0x232a;
                    t.angbracketrightBigg = 0x232a;
                    t.angbracketrightbigg = 0x232a;
                    t.arrowhookleft = 0x21aa;
                    t.arrowhookright = 0x21a9;
                    t.arrowlefttophalf = 0x21bc;
                    t.arrowleftbothalf = 0x21bd;
                    t.arrownortheast = 0x2197;
                    t.arrownorthwest = 0x2196;
                    t.arrowrighttophalf = 0x21c0;
                    t.arrowrightbothalf = 0x21c1;
                    t.arrowsoutheast = 0x2198;
                    t.arrowsouthwest = 0x2199;
                    t.backslashbig = 0x2216;
                    t.backslashBig = 0x2216;
                    t.backslashBigg = 0x2216;
                    t.backslashbigg = 0x2216;
                    t.bardbl = 0x2016;
                    t.bracehtipdownleft = 0xfe37;
                    t.bracehtipdownright = 0xfe37;
                    t.bracehtipupleft = 0xfe38;
                    t.bracehtipupright = 0xfe38;
                    t.braceleftBig = 0x007b;
                    t.braceleftbig = 0x007b;
                    t.braceleftbigg = 0x007b;
                    t.braceleftBigg = 0x007b;
                    t.bracerightBig = 0x007d;
                    t.bracerightbig = 0x007d;
                    t.bracerightbigg = 0x007d;
                    t.bracerightBigg = 0x007d;
                    t.bracketleftbig = 0x005b;
                    t.bracketleftBig = 0x005b;
                    t.bracketleftbigg = 0x005b;
                    t.bracketleftBigg = 0x005b;
                    t.bracketrightBig = 0x005d;
                    t.bracketrightbig = 0x005d;
                    t.bracketrightbigg = 0x005d;
                    t.bracketrightBigg = 0x005d;
                    t.ceilingleftbig = 0x2308;
                    t.ceilingleftBig = 0x2308;
                    t.ceilingleftBigg = 0x2308;
                    t.ceilingleftbigg = 0x2308;
                    t.ceilingrightbig = 0x2309;
                    t.ceilingrightBig = 0x2309;
                    t.ceilingrightbigg = 0x2309;
                    t.ceilingrightBigg = 0x2309;
                    t.circledotdisplay = 0x2299;
                    t.circledottext = 0x2299;
                    t.circlemultiplydisplay = 0x2297;
                    t.circlemultiplytext = 0x2297;
                    t.circleplusdisplay = 0x2295;
                    t.circleplustext = 0x2295;
                    t.contintegraldisplay = 0x222e;
                    t.contintegraltext = 0x222e;
                    t.coproductdisplay = 0x2210;
                    t.coproducttext = 0x2210;
                    t.floorleftBig = 0x230a;
                    t.floorleftbig = 0x230a;
                    t.floorleftbigg = 0x230a;
                    t.floorleftBigg = 0x230a;
                    t.floorrightbig = 0x230b;
                    t.floorrightBig = 0x230b;
                    t.floorrightBigg = 0x230b;
                    t.floorrightbigg = 0x230b;
                    t.hatwide = 0x0302;
                    t.hatwider = 0x0302;
                    t.hatwidest = 0x0302;
                    t.intercal = 0x1d40;
                    t.integraldisplay = 0x222b;
                    t.integraltext = 0x222b;
                    t.intersectiondisplay = 0x22c2;
                    t.intersectiontext = 0x22c2;
                    t.logicalanddisplay = 0x2227;
                    t.logicalandtext = 0x2227;
                    t.logicalordisplay = 0x2228;
                    t.logicalortext = 0x2228;
                    t.parenleftBig = 0x0028;
                    t.parenleftbig = 0x0028;
                    t.parenleftBigg = 0x0028;
                    t.parenleftbigg = 0x0028;
                    t.parenrightBig = 0x0029;
                    t.parenrightbig = 0x0029;
                    t.parenrightBigg = 0x0029;
                    t.parenrightbigg = 0x0029;
                    t.prime = 0x2032;
                    t.productdisplay = 0x220f;
                    t.producttext = 0x220f;
                    t.radicalbig = 0x221a;
                    t.radicalBig = 0x221a;
                    t.radicalBigg = 0x221a;
                    t.radicalbigg = 0x221a;
                    t.radicalbt = 0x221a;
                    t.radicaltp = 0x221a;
                    t.radicalvertex = 0x221a;
                    t.slashbig = 0x002f;
                    t.slashBig = 0x002f;
                    t.slashBigg = 0x002f;
                    t.slashbigg = 0x002f;
                    t.summationdisplay = 0x2211;
                    t.summationtext = 0x2211;
                    t.tildewide = 0x02dc;
                    t.tildewider = 0x02dc;
                    t.tildewidest = 0x02dc;
                    t.uniondisplay = 0x22c3;
                    t.unionmultidisplay = 0x228e;
                    t.unionmultitext = 0x228e;
                    t.unionsqdisplay = 0x2294;
                    t.unionsqtext = 0x2294;
                    t.uniontext = 0x22c3;
                    t.vextenddouble = 0x2225;
                    t.vextendsingle = 0x2223;
                });
                exports.getGlyphsUnicode = getGlyphsUnicode;
                const getDingbatsGlyphsUnicode = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.space = 0x0020;
                    t.a1 = 0x2701;
                    t.a2 = 0x2702;
                    t.a202 = 0x2703;
                    t.a3 = 0x2704;
                    t.a4 = 0x260e;
                    t.a5 = 0x2706;
                    t.a119 = 0x2707;
                    t.a118 = 0x2708;
                    t.a117 = 0x2709;
                    t.a11 = 0x261b;
                    t.a12 = 0x261e;
                    t.a13 = 0x270c;
                    t.a14 = 0x270d;
                    t.a15 = 0x270e;
                    t.a16 = 0x270f;
                    t.a105 = 0x2710;
                    t.a17 = 0x2711;
                    t.a18 = 0x2712;
                    t.a19 = 0x2713;
                    t.a20 = 0x2714;
                    t.a21 = 0x2715;
                    t.a22 = 0x2716;
                    t.a23 = 0x2717;
                    t.a24 = 0x2718;
                    t.a25 = 0x2719;
                    t.a26 = 0x271a;
                    t.a27 = 0x271b;
                    t.a28 = 0x271c;
                    t.a6 = 0x271d;
                    t.a7 = 0x271e;
                    t.a8 = 0x271f;
                    t.a9 = 0x2720;
                    t.a10 = 0x2721;
                    t.a29 = 0x2722;
                    t.a30 = 0x2723;
                    t.a31 = 0x2724;
                    t.a32 = 0x2725;
                    t.a33 = 0x2726;
                    t.a34 = 0x2727;
                    t.a35 = 0x2605;
                    t.a36 = 0x2729;
                    t.a37 = 0x272a;
                    t.a38 = 0x272b;
                    t.a39 = 0x272c;
                    t.a40 = 0x272d;
                    t.a41 = 0x272e;
                    t.a42 = 0x272f;
                    t.a43 = 0x2730;
                    t.a44 = 0x2731;
                    t.a45 = 0x2732;
                    t.a46 = 0x2733;
                    t.a47 = 0x2734;
                    t.a48 = 0x2735;
                    t.a49 = 0x2736;
                    t.a50 = 0x2737;
                    t.a51 = 0x2738;
                    t.a52 = 0x2739;
                    t.a53 = 0x273a;
                    t.a54 = 0x273b;
                    t.a55 = 0x273c;
                    t.a56 = 0x273d;
                    t.a57 = 0x273e;
                    t.a58 = 0x273f;
                    t.a59 = 0x2740;
                    t.a60 = 0x2741;
                    t.a61 = 0x2742;
                    t.a62 = 0x2743;
                    t.a63 = 0x2744;
                    t.a64 = 0x2745;
                    t.a65 = 0x2746;
                    t.a66 = 0x2747;
                    t.a67 = 0x2748;
                    t.a68 = 0x2749;
                    t.a69 = 0x274a;
                    t.a70 = 0x274b;
                    t.a71 = 0x25cf;
                    t.a72 = 0x274d;
                    t.a73 = 0x25a0;
                    t.a74 = 0x274f;
                    t.a203 = 0x2750;
                    t.a75 = 0x2751;
                    t.a204 = 0x2752;
                    t.a76 = 0x25b2;
                    t.a77 = 0x25bc;
                    t.a78 = 0x25c6;
                    t.a79 = 0x2756;
                    t.a81 = 0x25d7;
                    t.a82 = 0x2758;
                    t.a83 = 0x2759;
                    t.a84 = 0x275a;
                    t.a97 = 0x275b;
                    t.a98 = 0x275c;
                    t.a99 = 0x275d;
                    t.a100 = 0x275e;
                    t.a101 = 0x2761;
                    t.a102 = 0x2762;
                    t.a103 = 0x2763;
                    t.a104 = 0x2764;
                    t.a106 = 0x2765;
                    t.a107 = 0x2766;
                    t.a108 = 0x2767;
                    t.a112 = 0x2663;
                    t.a111 = 0x2666;
                    t.a110 = 0x2665;
                    t.a109 = 0x2660;
                    t.a120 = 0x2460;
                    t.a121 = 0x2461;
                    t.a122 = 0x2462;
                    t.a123 = 0x2463;
                    t.a124 = 0x2464;
                    t.a125 = 0x2465;
                    t.a126 = 0x2466;
                    t.a127 = 0x2467;
                    t.a128 = 0x2468;
                    t.a129 = 0x2469;
                    t.a130 = 0x2776;
                    t.a131 = 0x2777;
                    t.a132 = 0x2778;
                    t.a133 = 0x2779;
                    t.a134 = 0x277a;
                    t.a135 = 0x277b;
                    t.a136 = 0x277c;
                    t.a137 = 0x277d;
                    t.a138 = 0x277e;
                    t.a139 = 0x277f;
                    t.a140 = 0x2780;
                    t.a141 = 0x2781;
                    t.a142 = 0x2782;
                    t.a143 = 0x2783;
                    t.a144 = 0x2784;
                    t.a145 = 0x2785;
                    t.a146 = 0x2786;
                    t.a147 = 0x2787;
                    t.a148 = 0x2788;
                    t.a149 = 0x2789;
                    t.a150 = 0x278a;
                    t.a151 = 0x278b;
                    t.a152 = 0x278c;
                    t.a153 = 0x278d;
                    t.a154 = 0x278e;
                    t.a155 = 0x278f;
                    t.a156 = 0x2790;
                    t.a157 = 0x2791;
                    t.a158 = 0x2792;
                    t.a159 = 0x2793;
                    t.a160 = 0x2794;
                    t.a161 = 0x2192;
                    t.a163 = 0x2194;
                    t.a164 = 0x2195;
                    t.a196 = 0x2798;
                    t.a165 = 0x2799;
                    t.a192 = 0x279a;
                    t.a166 = 0x279b;
                    t.a167 = 0x279c;
                    t.a168 = 0x279d;
                    t.a169 = 0x279e;
                    t.a170 = 0x279f;
                    t.a171 = 0x27a0;
                    t.a172 = 0x27a1;
                    t.a173 = 0x27a2;
                    t.a162 = 0x27a3;
                    t.a174 = 0x27a4;
                    t.a175 = 0x27a5;
                    t.a176 = 0x27a6;
                    t.a177 = 0x27a7;
                    t.a178 = 0x27a8;
                    t.a179 = 0x27a9;
                    t.a193 = 0x27aa;
                    t.a180 = 0x27ab;
                    t.a199 = 0x27ac;
                    t.a181 = 0x27ad;
                    t.a200 = 0x27ae;
                    t.a182 = 0x27af;
                    t.a201 = 0x27b1;
                    t.a183 = 0x27b2;
                    t.a184 = 0x27b3;
                    t.a197 = 0x27b4;
                    t.a185 = 0x27b5;
                    t.a194 = 0x27b6;
                    t.a198 = 0x27b7;
                    t.a186 = 0x27b8;
                    t.a195 = 0x27b9;
                    t.a187 = 0x27ba;
                    t.a188 = 0x27bb;
                    t.a189 = 0x27bc;
                    t.a190 = 0x27bd;
                    t.a191 = 0x27be;
                    t.a89 = 0x2768;
                    t.a90 = 0x2769;
                    t.a93 = 0x276a;
                    t.a94 = 0x276b;
                    t.a91 = 0x276c;
                    t.a92 = 0x276d;
                    t.a205 = 0x276e;
                    t.a85 = 0x276f;
                    t.a206 = 0x2770;
                    t.a86 = 0x2771;
                    t.a87 = 0x2772;
                    t.a88 = 0x2773;
                    t.a95 = 0x2774;
                    t.a96 = 0x2775;
                    t[".notdef"] = 0x0000;
                });
                exports.getDingbatsGlyphsUnicode = getDingbatsGlyphsUnicode;
            /***/ },
            /* 40 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearUnicodeCaches = clearUnicodeCaches;
                exports.getCharUnicodeCategory = getCharUnicodeCategory;
                exports.getUnicodeForGlyph = getUnicodeForGlyph;
                exports.getUnicodeRangeFor = getUnicodeRangeFor;
                exports.mapSpecialUnicodeValues = mapSpecialUnicodeValues;
                var _core_utils = __w_pdfjs_require__(3);
                const getSpecialPUASymbols = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[63721] = 0x00a9;
                    t[63193] = 0x00a9;
                    t[63720] = 0x00ae;
                    t[63194] = 0x00ae;
                    t[63722] = 0x2122;
                    t[63195] = 0x2122;
                    t[63729] = 0x23a7;
                    t[63730] = 0x23a8;
                    t[63731] = 0x23a9;
                    t[63740] = 0x23ab;
                    t[63741] = 0x23ac;
                    t[63742] = 0x23ad;
                    t[63726] = 0x23a1;
                    t[63727] = 0x23a2;
                    t[63728] = 0x23a3;
                    t[63737] = 0x23a4;
                    t[63738] = 0x23a5;
                    t[63739] = 0x23a6;
                    t[63723] = 0x239b;
                    t[63724] = 0x239c;
                    t[63725] = 0x239d;
                    t[63734] = 0x239e;
                    t[63735] = 0x239f;
                    t[63736] = 0x23a0;
                });
                function mapSpecialUnicodeValues(code) {
                    if (code >= 0xfff0 && code <= 0xffff) return 0;
                    else if (code >= 0xf600 && code <= 0xf8ff) return getSpecialPUASymbols()[code] || code;
                    else if (code === 0x00ad) return 0x002d;
                    return code;
                }
                function getUnicodeForGlyph(name, glyphsUnicodeMap) {
                    let unicode = glyphsUnicodeMap[name];
                    if (unicode !== undefined) return unicode;
                    if (!name) return -1;
                    if (name[0] === "u") {
                        const nameLen = name.length;
                        let hexStr;
                        if (nameLen === 7 && name[1] === "n" && name[2] === "i") hexStr = name.substring(3);
                        else if (nameLen >= 5 && nameLen <= 7) hexStr = name.substring(1);
                        else return -1;
                        if (hexStr === hexStr.toUpperCase()) {
                            unicode = parseInt(hexStr, 16);
                            if (unicode >= 0) return unicode;
                        }
                    }
                    return -1;
                }
                const UnicodeRanges = [
                    [
                        0x0000,
                        0x007f
                    ],
                    [
                        0x0080,
                        0x00ff
                    ],
                    [
                        0x0100,
                        0x017f
                    ],
                    [
                        0x0180,
                        0x024f
                    ],
                    [
                        0x0250,
                        0x02af,
                        0x1d00,
                        0x1d7f,
                        0x1d80,
                        0x1dbf
                    ],
                    [
                        0x02b0,
                        0x02ff,
                        0xa700,
                        0xa71f
                    ],
                    [
                        0x0300,
                        0x036f,
                        0x1dc0,
                        0x1dff
                    ],
                    [
                        0x0370,
                        0x03ff
                    ],
                    [
                        0x2c80,
                        0x2cff
                    ],
                    [
                        0x0400,
                        0x04ff,
                        0x0500,
                        0x052f,
                        0x2de0,
                        0x2dff,
                        0xa640,
                        0xa69f
                    ],
                    [
                        0x0530,
                        0x058f
                    ],
                    [
                        0x0590,
                        0x05ff
                    ],
                    [
                        0xa500,
                        0xa63f
                    ],
                    [
                        0x0600,
                        0x06ff,
                        0x0750,
                        0x077f
                    ],
                    [
                        0x07c0,
                        0x07ff
                    ],
                    [
                        0x0900,
                        0x097f
                    ],
                    [
                        0x0980,
                        0x09ff
                    ],
                    [
                        0x0a00,
                        0x0a7f
                    ],
                    [
                        0x0a80,
                        0x0aff
                    ],
                    [
                        0x0b00,
                        0x0b7f
                    ],
                    [
                        0x0b80,
                        0x0bff
                    ],
                    [
                        0x0c00,
                        0x0c7f
                    ],
                    [
                        0x0c80,
                        0x0cff
                    ],
                    [
                        0x0d00,
                        0x0d7f
                    ],
                    [
                        0x0e00,
                        0x0e7f
                    ],
                    [
                        0x0e80,
                        0x0eff
                    ],
                    [
                        0x10a0,
                        0x10ff,
                        0x2d00,
                        0x2d2f
                    ],
                    [
                        0x1b00,
                        0x1b7f
                    ],
                    [
                        0x1100,
                        0x11ff
                    ],
                    [
                        0x1e00,
                        0x1eff,
                        0x2c60,
                        0x2c7f,
                        0xa720,
                        0xa7ff
                    ],
                    [
                        0x1f00,
                        0x1fff
                    ],
                    [
                        0x2000,
                        0x206f,
                        0x2e00,
                        0x2e7f
                    ],
                    [
                        0x2070,
                        0x209f
                    ],
                    [
                        0x20a0,
                        0x20cf
                    ],
                    [
                        0x20d0,
                        0x20ff
                    ],
                    [
                        0x2100,
                        0x214f
                    ],
                    [
                        0x2150,
                        0x218f
                    ],
                    [
                        0x2190,
                        0x21ff,
                        0x27f0,
                        0x27ff,
                        0x2900,
                        0x297f,
                        0x2b00,
                        0x2bff
                    ],
                    [
                        0x2200,
                        0x22ff,
                        0x2a00,
                        0x2aff,
                        0x27c0,
                        0x27ef,
                        0x2980,
                        0x29ff
                    ],
                    [
                        0x2300,
                        0x23ff
                    ],
                    [
                        0x2400,
                        0x243f
                    ],
                    [
                        0x2440,
                        0x245f
                    ],
                    [
                        0x2460,
                        0x24ff
                    ],
                    [
                        0x2500,
                        0x257f
                    ],
                    [
                        0x2580,
                        0x259f
                    ],
                    [
                        0x25a0,
                        0x25ff
                    ],
                    [
                        0x2600,
                        0x26ff
                    ],
                    [
                        0x2700,
                        0x27bf
                    ],
                    [
                        0x3000,
                        0x303f
                    ],
                    [
                        0x3040,
                        0x309f
                    ],
                    [
                        0x30a0,
                        0x30ff,
                        0x31f0,
                        0x31ff
                    ],
                    [
                        0x3100,
                        0x312f,
                        0x31a0,
                        0x31bf
                    ],
                    [
                        0x3130,
                        0x318f
                    ],
                    [
                        0xa840,
                        0xa87f
                    ],
                    [
                        0x3200,
                        0x32ff
                    ],
                    [
                        0x3300,
                        0x33ff
                    ],
                    [
                        0xac00,
                        0xd7af
                    ],
                    [
                        0xd800,
                        0xdfff
                    ],
                    [
                        0x10900,
                        0x1091f
                    ],
                    [
                        0x4e00,
                        0x9fff,
                        0x2e80,
                        0x2eff,
                        0x2f00,
                        0x2fdf,
                        0x2ff0,
                        0x2fff,
                        0x3400,
                        0x4dbf,
                        0x20000,
                        0x2a6df,
                        0x3190,
                        0x319f
                    ],
                    [
                        0xe000,
                        0xf8ff
                    ],
                    [
                        0x31c0,
                        0x31ef,
                        0xf900,
                        0xfaff,
                        0x2f800,
                        0x2fa1f
                    ],
                    [
                        0xfb00,
                        0xfb4f
                    ],
                    [
                        0xfb50,
                        0xfdff
                    ],
                    [
                        0xfe20,
                        0xfe2f
                    ],
                    [
                        0xfe10,
                        0xfe1f
                    ],
                    [
                        0xfe50,
                        0xfe6f
                    ],
                    [
                        0xfe70,
                        0xfeff
                    ],
                    [
                        0xff00,
                        0xffef
                    ],
                    [
                        0xfff0,
                        0xffff
                    ],
                    [
                        0x0f00,
                        0x0fff
                    ],
                    [
                        0x0700,
                        0x074f
                    ],
                    [
                        0x0780,
                        0x07bf
                    ],
                    [
                        0x0d80,
                        0x0dff
                    ],
                    [
                        0x1000,
                        0x109f
                    ],
                    [
                        0x1200,
                        0x137f,
                        0x1380,
                        0x139f,
                        0x2d80,
                        0x2ddf
                    ],
                    [
                        0x13a0,
                        0x13ff
                    ],
                    [
                        0x1400,
                        0x167f
                    ],
                    [
                        0x1680,
                        0x169f
                    ],
                    [
                        0x16a0,
                        0x16ff
                    ],
                    [
                        0x1780,
                        0x17ff
                    ],
                    [
                        0x1800,
                        0x18af
                    ],
                    [
                        0x2800,
                        0x28ff
                    ],
                    [
                        0xa000,
                        0xa48f
                    ],
                    [
                        0x1700,
                        0x171f,
                        0x1720,
                        0x173f,
                        0x1740,
                        0x175f,
                        0x1760,
                        0x177f
                    ],
                    [
                        0x10300,
                        0x1032f
                    ],
                    [
                        0x10330,
                        0x1034f
                    ],
                    [
                        0x10400,
                        0x1044f
                    ],
                    [
                        0x1d000,
                        0x1d0ff,
                        0x1d100,
                        0x1d1ff,
                        0x1d200,
                        0x1d24f
                    ],
                    [
                        0x1d400,
                        0x1d7ff
                    ],
                    [
                        0xff000,
                        0xffffd
                    ],
                    [
                        0xfe00,
                        0xfe0f,
                        0xe0100,
                        0xe01ef
                    ],
                    [
                        0xe0000,
                        0xe007f
                    ],
                    [
                        0x1900,
                        0x194f
                    ],
                    [
                        0x1950,
                        0x197f
                    ],
                    [
                        0x1980,
                        0x19df
                    ],
                    [
                        0x1a00,
                        0x1a1f
                    ],
                    [
                        0x2c00,
                        0x2c5f
                    ],
                    [
                        0x2d30,
                        0x2d7f
                    ],
                    [
                        0x4dc0,
                        0x4dff
                    ],
                    [
                        0xa800,
                        0xa82f
                    ],
                    [
                        0x10000,
                        0x1007f,
                        0x10080,
                        0x100ff,
                        0x10100,
                        0x1013f
                    ],
                    [
                        0x10140,
                        0x1018f
                    ],
                    [
                        0x10380,
                        0x1039f
                    ],
                    [
                        0x103a0,
                        0x103df
                    ],
                    [
                        0x10450,
                        0x1047f
                    ],
                    [
                        0x10480,
                        0x104af
                    ],
                    [
                        0x10800,
                        0x1083f
                    ],
                    [
                        0x10a00,
                        0x10a5f
                    ],
                    [
                        0x1d300,
                        0x1d35f
                    ],
                    [
                        0x12000,
                        0x123ff,
                        0x12400,
                        0x1247f
                    ],
                    [
                        0x1d360,
                        0x1d37f
                    ],
                    [
                        0x1b80,
                        0x1bbf
                    ],
                    [
                        0x1c00,
                        0x1c4f
                    ],
                    [
                        0x1c50,
                        0x1c7f
                    ],
                    [
                        0xa880,
                        0xa8df
                    ],
                    [
                        0xa900,
                        0xa92f
                    ],
                    [
                        0xa930,
                        0xa95f
                    ],
                    [
                        0xaa00,
                        0xaa5f
                    ],
                    [
                        0x10190,
                        0x101cf
                    ],
                    [
                        0x101d0,
                        0x101ff
                    ],
                    [
                        0x102a0,
                        0x102df,
                        0x10280,
                        0x1029f,
                        0x10920,
                        0x1093f
                    ],
                    [
                        0x1f030,
                        0x1f09f,
                        0x1f000,
                        0x1f02f
                    ]
                ];
                function getUnicodeRangeFor(value, lastPosition = -1) {
                    if (lastPosition !== -1) {
                        const range = UnicodeRanges[lastPosition];
                        for(let i = 0, ii = range.length; i < ii; i += 2){
                            if (value >= range[i] && value <= range[i + 1]) return lastPosition;
                        }
                    }
                    for(let i = 0, ii = UnicodeRanges.length; i < ii; i++){
                        const range = UnicodeRanges[i];
                        for(let j = 0, jj = range.length; j < jj; j += 2){
                            if (value >= range[j] && value <= range[j + 1]) return i;
                        }
                    }
                    return -1;
                }
                const SpecialCharRegExp = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u");
                const CategoryCache = new Map();
                function getCharUnicodeCategory(char) {
                    const cachedCategory = CategoryCache.get(char);
                    if (cachedCategory) return cachedCategory;
                    const groups = char.match(SpecialCharRegExp);
                    const category = {
                        isWhitespace: !!groups?.[1],
                        isZeroWidthDiacritic: !!groups?.[2],
                        isInvisibleFormatMark: !!groups?.[3]
                    };
                    CategoryCache.set(char, category);
                    return category;
                }
                function clearUnicodeCaches() {
                    CategoryCache.clear();
                }
            /***/ },
            /* 41 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getSerifFonts = exports.getNonStdFontMap = exports.getGlyphMapForStandardFonts = exports.getFontNameToFileMap = void 0;
                exports.getStandardFontName = getStandardFontName;
                exports.getSymbolsFonts = exports.getSupplementalGlyphMapForCalibri = exports.getSupplementalGlyphMapForArialBlack = exports.getStdFontMap = void 0;
                exports.isKnownFontName = isKnownFontName;
                var _core_utils = __w_pdfjs_require__(3);
                var _fonts_utils = __w_pdfjs_require__(38);
                const getStdFontMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t["Times-Roman"] = "Times-Roman";
                    t.Helvetica = "Helvetica";
                    t.Courier = "Courier";
                    t.Symbol = "Symbol";
                    t["Times-Bold"] = "Times-Bold";
                    t["Helvetica-Bold"] = "Helvetica-Bold";
                    t["Courier-Bold"] = "Courier-Bold";
                    t.ZapfDingbats = "ZapfDingbats";
                    t["Times-Italic"] = "Times-Italic";
                    t["Helvetica-Oblique"] = "Helvetica-Oblique";
                    t["Courier-Oblique"] = "Courier-Oblique";
                    t["Times-BoldItalic"] = "Times-BoldItalic";
                    t["Helvetica-BoldOblique"] = "Helvetica-BoldOblique";
                    t["Courier-BoldOblique"] = "Courier-BoldOblique";
                    t.ArialNarrow = "Helvetica";
                    t["ArialNarrow-Bold"] = "Helvetica-Bold";
                    t["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ArialNarrow-Italic"] = "Helvetica-Oblique";
                    t.ArialBlack = "Helvetica";
                    t["ArialBlack-Bold"] = "Helvetica-Bold";
                    t["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ArialBlack-Italic"] = "Helvetica-Oblique";
                    t["Arial-Black"] = "Helvetica";
                    t["Arial-Black-Bold"] = "Helvetica-Bold";
                    t["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Arial-Black-Italic"] = "Helvetica-Oblique";
                    t.Arial = "Helvetica";
                    t["Arial-Bold"] = "Helvetica-Bold";
                    t["Arial-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Arial-Italic"] = "Helvetica-Oblique";
                    t.ArialMT = "Helvetica";
                    t["Arial-BoldItalicMT"] = "Helvetica-BoldOblique";
                    t["Arial-BoldMT"] = "Helvetica-Bold";
                    t["Arial-ItalicMT"] = "Helvetica-Oblique";
                    t["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Arial-BoldMT-Bold"] = "Helvetica-Bold";
                    t["Arial-ItalicMT-Italic"] = "Helvetica-Oblique";
                    t.ArialUnicodeMS = "Helvetica";
                    t["ArialUnicodeMS-Bold"] = "Helvetica-Bold";
                    t["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ArialUnicodeMS-Italic"] = "Helvetica-Oblique";
                    t["Courier-BoldItalic"] = "Courier-BoldOblique";
                    t["Courier-Italic"] = "Courier-Oblique";
                    t.CourierNew = "Courier";
                    t["CourierNew-Bold"] = "Courier-Bold";
                    t["CourierNew-BoldItalic"] = "Courier-BoldOblique";
                    t["CourierNew-Italic"] = "Courier-Oblique";
                    t["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique";
                    t["CourierNewPS-BoldMT"] = "Courier-Bold";
                    t["CourierNewPS-ItalicMT"] = "Courier-Oblique";
                    t.CourierNewPSMT = "Courier";
                    t["Helvetica-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Helvetica-Italic"] = "Helvetica-Oblique";
                    t["Symbol-Bold"] = "Symbol";
                    t["Symbol-BoldItalic"] = "Symbol";
                    t["Symbol-Italic"] = "Symbol";
                    t.TimesNewRoman = "Times-Roman";
                    t["TimesNewRoman-Bold"] = "Times-Bold";
                    t["TimesNewRoman-BoldItalic"] = "Times-BoldItalic";
                    t["TimesNewRoman-Italic"] = "Times-Italic";
                    t.TimesNewRomanPS = "Times-Roman";
                    t["TimesNewRomanPS-Bold"] = "Times-Bold";
                    t["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic";
                    t["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic";
                    t["TimesNewRomanPS-BoldMT"] = "Times-Bold";
                    t["TimesNewRomanPS-Italic"] = "Times-Italic";
                    t["TimesNewRomanPS-ItalicMT"] = "Times-Italic";
                    t.TimesNewRomanPSMT = "Times-Roman";
                    t["TimesNewRomanPSMT-Bold"] = "Times-Bold";
                    t["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic";
                    t["TimesNewRomanPSMT-Italic"] = "Times-Italic";
                });
                exports.getStdFontMap = getStdFontMap;
                const getFontNameToFileMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Courier = "FoxitFixed.pfb";
                    t["Courier-Bold"] = "FoxitFixedBold.pfb";
                    t["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb";
                    t["Courier-Oblique"] = "FoxitFixedItalic.pfb";
                    t.Helvetica = "LiberationSans-Regular.ttf";
                    t["Helvetica-Bold"] = "LiberationSans-Bold.ttf";
                    t["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf";
                    t["Helvetica-Oblique"] = "LiberationSans-Italic.ttf";
                    t["Times-Roman"] = "FoxitSerif.pfb";
                    t["Times-Bold"] = "FoxitSerifBold.pfb";
                    t["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb";
                    t["Times-Italic"] = "FoxitSerifItalic.pfb";
                    t.Symbol = "FoxitSymbol.pfb";
                    t.ZapfDingbats = "FoxitDingbats.pfb";
                    t["LiberationSans-Regular"] = "LiberationSans-Regular.ttf";
                    t["LiberationSans-Bold"] = "LiberationSans-Bold.ttf";
                    t["LiberationSans-Italic"] = "LiberationSans-Italic.ttf";
                    t["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
                });
                exports.getFontNameToFileMap = getFontNameToFileMap;
                const getNonStdFontMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Calibri = "Helvetica";
                    t["Calibri-Bold"] = "Helvetica-Bold";
                    t["Calibri-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Calibri-Italic"] = "Helvetica-Oblique";
                    t.CenturyGothic = "Helvetica";
                    t["CenturyGothic-Bold"] = "Helvetica-Bold";
                    t["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique";
                    t["CenturyGothic-Italic"] = "Helvetica-Oblique";
                    t.ComicSansMS = "Comic Sans MS";
                    t["ComicSansMS-Bold"] = "Comic Sans MS-Bold";
                    t["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic";
                    t["ComicSansMS-Italic"] = "Comic Sans MS-Italic";
                    t.Impact = "Helvetica";
                    t["ItcSymbol-Bold"] = "Helvetica-Bold";
                    t["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ItcSymbol-Book"] = "Helvetica";
                    t["ItcSymbol-BookItalic"] = "Helvetica-Oblique";
                    t["ItcSymbol-Medium"] = "Helvetica";
                    t["ItcSymbol-MediumItalic"] = "Helvetica-Oblique";
                    t.LucidaConsole = "Courier";
                    t["LucidaConsole-Bold"] = "Courier-Bold";
                    t["LucidaConsole-BoldItalic"] = "Courier-BoldOblique";
                    t["LucidaConsole-Italic"] = "Courier-Oblique";
                    t["LucidaSans-Demi"] = "Helvetica-Bold";
                    t["MS-Gothic"] = "MS Gothic";
                    t["MS-Gothic-Bold"] = "MS Gothic-Bold";
                    t["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic";
                    t["MS-Gothic-Italic"] = "MS Gothic-Italic";
                    t["MS-Mincho"] = "MS Mincho";
                    t["MS-Mincho-Bold"] = "MS Mincho-Bold";
                    t["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic";
                    t["MS-Mincho-Italic"] = "MS Mincho-Italic";
                    t["MS-PGothic"] = "MS PGothic";
                    t["MS-PGothic-Bold"] = "MS PGothic-Bold";
                    t["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic";
                    t["MS-PGothic-Italic"] = "MS PGothic-Italic";
                    t["MS-PMincho"] = "MS PMincho";
                    t["MS-PMincho-Bold"] = "MS PMincho-Bold";
                    t["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic";
                    t["MS-PMincho-Italic"] = "MS PMincho-Italic";
                    t.NuptialScript = "Times-Italic";
                    t.SegoeUISymbol = "Helvetica";
                });
                exports.getNonStdFontMap = getNonStdFontMap;
                const getSerifFonts = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t["Adobe Jenson"] = true;
                    t["Adobe Text"] = true;
                    t.Albertus = true;
                    t.Aldus = true;
                    t.Alexandria = true;
                    t.Algerian = true;
                    t["American Typewriter"] = true;
                    t.Antiqua = true;
                    t.Apex = true;
                    t.Arno = true;
                    t.Aster = true;
                    t.Aurora = true;
                    t.Baskerville = true;
                    t.Bell = true;
                    t.Bembo = true;
                    t["Bembo Schoolbook"] = true;
                    t.Benguiat = true;
                    t["Berkeley Old Style"] = true;
                    t["Bernhard Modern"] = true;
                    t["Berthold City"] = true;
                    t.Bodoni = true;
                    t["Bauer Bodoni"] = true;
                    t["Book Antiqua"] = true;
                    t.Bookman = true;
                    t["Bordeaux Roman"] = true;
                    t["Californian FB"] = true;
                    t.Calisto = true;
                    t.Calvert = true;
                    t.Capitals = true;
                    t.Cambria = true;
                    t.Cartier = true;
                    t.Caslon = true;
                    t.Catull = true;
                    t.Centaur = true;
                    t["Century Old Style"] = true;
                    t["Century Schoolbook"] = true;
                    t.Chaparral = true;
                    t["Charis SIL"] = true;
                    t.Cheltenham = true;
                    t["Cholla Slab"] = true;
                    t.Clarendon = true;
                    t.Clearface = true;
                    t.Cochin = true;
                    t.Colonna = true;
                    t["Computer Modern"] = true;
                    t["Concrete Roman"] = true;
                    t.Constantia = true;
                    t["Cooper Black"] = true;
                    t.Corona = true;
                    t.Ecotype = true;
                    t.Egyptienne = true;
                    t.Elephant = true;
                    t.Excelsior = true;
                    t.Fairfield = true;
                    t["FF Scala"] = true;
                    t.Folkard = true;
                    t.Footlight = true;
                    t.FreeSerif = true;
                    t["Friz Quadrata"] = true;
                    t.Garamond = true;
                    t.Gentium = true;
                    t.Georgia = true;
                    t.Gloucester = true;
                    t["Goudy Old Style"] = true;
                    t["Goudy Schoolbook"] = true;
                    t["Goudy Pro Font"] = true;
                    t.Granjon = true;
                    t["Guardian Egyptian"] = true;
                    t.Heather = true;
                    t.Hercules = true;
                    t["High Tower Text"] = true;
                    t.Hiroshige = true;
                    t["Hoefler Text"] = true;
                    t["Humana Serif"] = true;
                    t.Imprint = true;
                    t["Ionic No. 5"] = true;
                    t.Janson = true;
                    t.Joanna = true;
                    t.Korinna = true;
                    t.Lexicon = true;
                    t.LiberationSerif = true;
                    t["Liberation Serif"] = true;
                    t["Linux Libertine"] = true;
                    t.Literaturnaya = true;
                    t.Lucida = true;
                    t["Lucida Bright"] = true;
                    t.Melior = true;
                    t.Memphis = true;
                    t.Miller = true;
                    t.Minion = true;
                    t.Modern = true;
                    t["Mona Lisa"] = true;
                    t["Mrs Eaves"] = true;
                    t["MS Serif"] = true;
                    t["Museo Slab"] = true;
                    t["New York"] = true;
                    t["Nimbus Roman"] = true;
                    t["NPS Rawlinson Roadway"] = true;
                    t.NuptialScript = true;
                    t.Palatino = true;
                    t.Perpetua = true;
                    t.Plantin = true;
                    t["Plantin Schoolbook"] = true;
                    t.Playbill = true;
                    t["Poor Richard"] = true;
                    t["Rawlinson Roadway"] = true;
                    t.Renault = true;
                    t.Requiem = true;
                    t.Rockwell = true;
                    t.Roman = true;
                    t["Rotis Serif"] = true;
                    t.Sabon = true;
                    t.Scala = true;
                    t.Seagull = true;
                    t.Sistina = true;
                    t.Souvenir = true;
                    t.STIX = true;
                    t["Stone Informal"] = true;
                    t["Stone Serif"] = true;
                    t.Sylfaen = true;
                    t.Times = true;
                    t.Trajan = true;
                    t["Trinit\xe9"] = true;
                    t["Trump Mediaeval"] = true;
                    t.Utopia = true;
                    t["Vale Type"] = true;
                    t["Bitstream Vera"] = true;
                    t["Vera Serif"] = true;
                    t.Versailles = true;
                    t.Wanted = true;
                    t.Weiss = true;
                    t["Wide Latin"] = true;
                    t.Windsor = true;
                    t.XITS = true;
                });
                exports.getSerifFonts = getSerifFonts;
                const getSymbolsFonts = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Dingbats = true;
                    t.Symbol = true;
                    t.ZapfDingbats = true;
                    t.Wingdings = true;
                    t["Wingdings-Bold"] = true;
                    t["Wingdings-Regular"] = true;
                });
                exports.getSymbolsFonts = getSymbolsFonts;
                const getGlyphMapForStandardFonts = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[2] = 10;
                    t[3] = 32;
                    t[4] = 33;
                    t[5] = 34;
                    t[6] = 35;
                    t[7] = 36;
                    t[8] = 37;
                    t[9] = 38;
                    t[10] = 39;
                    t[11] = 40;
                    t[12] = 41;
                    t[13] = 42;
                    t[14] = 43;
                    t[15] = 44;
                    t[16] = 45;
                    t[17] = 46;
                    t[18] = 47;
                    t[19] = 48;
                    t[20] = 49;
                    t[21] = 50;
                    t[22] = 51;
                    t[23] = 52;
                    t[24] = 53;
                    t[25] = 54;
                    t[26] = 55;
                    t[27] = 56;
                    t[28] = 57;
                    t[29] = 58;
                    t[30] = 894;
                    t[31] = 60;
                    t[32] = 61;
                    t[33] = 62;
                    t[34] = 63;
                    t[35] = 64;
                    t[36] = 65;
                    t[37] = 66;
                    t[38] = 67;
                    t[39] = 68;
                    t[40] = 69;
                    t[41] = 70;
                    t[42] = 71;
                    t[43] = 72;
                    t[44] = 73;
                    t[45] = 74;
                    t[46] = 75;
                    t[47] = 76;
                    t[48] = 77;
                    t[49] = 78;
                    t[50] = 79;
                    t[51] = 80;
                    t[52] = 81;
                    t[53] = 82;
                    t[54] = 83;
                    t[55] = 84;
                    t[56] = 85;
                    t[57] = 86;
                    t[58] = 87;
                    t[59] = 88;
                    t[60] = 89;
                    t[61] = 90;
                    t[62] = 91;
                    t[63] = 92;
                    t[64] = 93;
                    t[65] = 94;
                    t[66] = 95;
                    t[67] = 96;
                    t[68] = 97;
                    t[69] = 98;
                    t[70] = 99;
                    t[71] = 100;
                    t[72] = 101;
                    t[73] = 102;
                    t[74] = 103;
                    t[75] = 104;
                    t[76] = 105;
                    t[77] = 106;
                    t[78] = 107;
                    t[79] = 108;
                    t[80] = 109;
                    t[81] = 110;
                    t[82] = 111;
                    t[83] = 112;
                    t[84] = 113;
                    t[85] = 114;
                    t[86] = 115;
                    t[87] = 116;
                    t[88] = 117;
                    t[89] = 118;
                    t[90] = 119;
                    t[91] = 120;
                    t[92] = 121;
                    t[93] = 122;
                    t[94] = 123;
                    t[95] = 124;
                    t[96] = 125;
                    t[97] = 126;
                    t[98] = 196;
                    t[99] = 197;
                    t[100] = 199;
                    t[101] = 201;
                    t[102] = 209;
                    t[103] = 214;
                    t[104] = 220;
                    t[105] = 225;
                    t[106] = 224;
                    t[107] = 226;
                    t[108] = 228;
                    t[109] = 227;
                    t[110] = 229;
                    t[111] = 231;
                    t[112] = 233;
                    t[113] = 232;
                    t[114] = 234;
                    t[115] = 235;
                    t[116] = 237;
                    t[117] = 236;
                    t[118] = 238;
                    t[119] = 239;
                    t[120] = 241;
                    t[121] = 243;
                    t[122] = 242;
                    t[123] = 244;
                    t[124] = 246;
                    t[125] = 245;
                    t[126] = 250;
                    t[127] = 249;
                    t[128] = 251;
                    t[129] = 252;
                    t[130] = 8224;
                    t[131] = 176;
                    t[132] = 162;
                    t[133] = 163;
                    t[134] = 167;
                    t[135] = 8226;
                    t[136] = 182;
                    t[137] = 223;
                    t[138] = 174;
                    t[139] = 169;
                    t[140] = 8482;
                    t[141] = 180;
                    t[142] = 168;
                    t[143] = 8800;
                    t[144] = 198;
                    t[145] = 216;
                    t[146] = 8734;
                    t[147] = 177;
                    t[148] = 8804;
                    t[149] = 8805;
                    t[150] = 165;
                    t[151] = 181;
                    t[152] = 8706;
                    t[153] = 8721;
                    t[154] = 8719;
                    t[156] = 8747;
                    t[157] = 170;
                    t[158] = 186;
                    t[159] = 8486;
                    t[160] = 230;
                    t[161] = 248;
                    t[162] = 191;
                    t[163] = 161;
                    t[164] = 172;
                    t[165] = 8730;
                    t[166] = 402;
                    t[167] = 8776;
                    t[168] = 8710;
                    t[169] = 171;
                    t[170] = 187;
                    t[171] = 8230;
                    t[179] = 8220;
                    t[180] = 8221;
                    t[181] = 8216;
                    t[182] = 8217;
                    t[200] = 193;
                    t[203] = 205;
                    t[207] = 211;
                    t[210] = 218;
                    t[223] = 711;
                    t[224] = 321;
                    t[225] = 322;
                    t[226] = 352;
                    t[227] = 353;
                    t[228] = 381;
                    t[229] = 382;
                    t[233] = 221;
                    t[234] = 253;
                    t[252] = 263;
                    t[253] = 268;
                    t[254] = 269;
                    t[258] = 258;
                    t[260] = 260;
                    t[261] = 261;
                    t[265] = 280;
                    t[266] = 281;
                    t[267] = 282;
                    t[268] = 283;
                    t[269] = 313;
                    t[275] = 323;
                    t[276] = 324;
                    t[278] = 328;
                    t[283] = 344;
                    t[284] = 345;
                    t[285] = 346;
                    t[286] = 347;
                    t[292] = 367;
                    t[295] = 377;
                    t[296] = 378;
                    t[298] = 380;
                    t[305] = 963;
                    t[306] = 964;
                    t[307] = 966;
                    t[308] = 8215;
                    t[309] = 8252;
                    t[310] = 8319;
                    t[311] = 8359;
                    t[312] = 8592;
                    t[313] = 8593;
                    t[337] = 9552;
                    t[493] = 1039;
                    t[494] = 1040;
                    t[672] = 1488;
                    t[673] = 1489;
                    t[674] = 1490;
                    t[675] = 1491;
                    t[676] = 1492;
                    t[677] = 1493;
                    t[678] = 1494;
                    t[679] = 1495;
                    t[680] = 1496;
                    t[681] = 1497;
                    t[682] = 1498;
                    t[683] = 1499;
                    t[684] = 1500;
                    t[685] = 1501;
                    t[686] = 1502;
                    t[687] = 1503;
                    t[688] = 1504;
                    t[689] = 1505;
                    t[690] = 1506;
                    t[691] = 1507;
                    t[692] = 1508;
                    t[693] = 1509;
                    t[694] = 1510;
                    t[695] = 1511;
                    t[696] = 1512;
                    t[697] = 1513;
                    t[698] = 1514;
                    t[705] = 1524;
                    t[706] = 8362;
                    t[710] = 64288;
                    t[711] = 64298;
                    t[759] = 1617;
                    t[761] = 1776;
                    t[763] = 1778;
                    t[775] = 1652;
                    t[777] = 1764;
                    t[778] = 1780;
                    t[779] = 1781;
                    t[780] = 1782;
                    t[782] = 771;
                    t[783] = 64726;
                    t[786] = 8363;
                    t[788] = 8532;
                    t[790] = 768;
                    t[791] = 769;
                    t[792] = 768;
                    t[795] = 803;
                    t[797] = 64336;
                    t[798] = 64337;
                    t[799] = 64342;
                    t[800] = 64343;
                    t[801] = 64344;
                    t[802] = 64345;
                    t[803] = 64362;
                    t[804] = 64363;
                    t[805] = 64364;
                    t[2424] = 7821;
                    t[2425] = 7822;
                    t[2426] = 7823;
                    t[2427] = 7824;
                    t[2428] = 7825;
                    t[2429] = 7826;
                    t[2430] = 7827;
                    t[2433] = 7682;
                    t[2678] = 8045;
                    t[2679] = 8046;
                    t[2830] = 1552;
                    t[2838] = 686;
                    t[2840] = 751;
                    t[2842] = 753;
                    t[2843] = 754;
                    t[2844] = 755;
                    t[2846] = 757;
                    t[2856] = 767;
                    t[2857] = 848;
                    t[2858] = 849;
                    t[2862] = 853;
                    t[2863] = 854;
                    t[2864] = 855;
                    t[2865] = 861;
                    t[2866] = 862;
                    t[2906] = 7460;
                    t[2908] = 7462;
                    t[2909] = 7463;
                    t[2910] = 7464;
                    t[2912] = 7466;
                    t[2913] = 7467;
                    t[2914] = 7468;
                    t[2916] = 7470;
                    t[2917] = 7471;
                    t[2918] = 7472;
                    t[2920] = 7474;
                    t[2921] = 7475;
                    t[2922] = 7476;
                    t[2924] = 7478;
                    t[2925] = 7479;
                    t[2926] = 7480;
                    t[2928] = 7482;
                    t[2929] = 7483;
                    t[2930] = 7484;
                    t[2932] = 7486;
                    t[2933] = 7487;
                    t[2934] = 7488;
                    t[2936] = 7490;
                    t[2937] = 7491;
                    t[2938] = 7492;
                    t[2940] = 7494;
                    t[2941] = 7495;
                    t[2942] = 7496;
                    t[2944] = 7498;
                    t[2946] = 7500;
                    t[2948] = 7502;
                    t[2950] = 7504;
                    t[2951] = 7505;
                    t[2952] = 7506;
                    t[2954] = 7508;
                    t[2955] = 7509;
                    t[2956] = 7510;
                    t[2958] = 7512;
                    t[2959] = 7513;
                    t[2960] = 7514;
                    t[2962] = 7516;
                    t[2963] = 7517;
                    t[2964] = 7518;
                    t[2966] = 7520;
                    t[2967] = 7521;
                    t[2968] = 7522;
                    t[2970] = 7524;
                    t[2971] = 7525;
                    t[2972] = 7526;
                    t[2974] = 7528;
                    t[2975] = 7529;
                    t[2976] = 7530;
                    t[2978] = 1537;
                    t[2979] = 1538;
                    t[2980] = 1539;
                    t[2982] = 1549;
                    t[2983] = 1551;
                    t[2984] = 1552;
                    t[2986] = 1554;
                    t[2987] = 1555;
                    t[2988] = 1556;
                    t[2990] = 1623;
                    t[2991] = 1624;
                    t[2995] = 1775;
                    t[2999] = 1791;
                    t[3002] = 64290;
                    t[3003] = 64291;
                    t[3004] = 64292;
                    t[3006] = 64294;
                    t[3007] = 64295;
                    t[3008] = 64296;
                    t[3011] = 1900;
                    t[3014] = 8223;
                    t[3015] = 8244;
                    t[3017] = 7532;
                    t[3018] = 7533;
                    t[3019] = 7534;
                    t[3075] = 7590;
                    t[3076] = 7591;
                    t[3079] = 7594;
                    t[3080] = 7595;
                    t[3083] = 7598;
                    t[3084] = 7599;
                    t[3087] = 7602;
                    t[3088] = 7603;
                    t[3091] = 7606;
                    t[3092] = 7607;
                    t[3095] = 7610;
                    t[3096] = 7611;
                    t[3099] = 7614;
                    t[3100] = 7615;
                    t[3103] = 7618;
                    t[3104] = 7619;
                    t[3107] = 8337;
                    t[3108] = 8338;
                    t[3116] = 1884;
                    t[3119] = 1885;
                    t[3120] = 1885;
                    t[3123] = 1886;
                    t[3124] = 1886;
                    t[3127] = 1887;
                    t[3128] = 1887;
                    t[3131] = 1888;
                    t[3132] = 1888;
                    t[3135] = 1889;
                    t[3136] = 1889;
                    t[3139] = 1890;
                    t[3140] = 1890;
                    t[3143] = 1891;
                    t[3144] = 1891;
                    t[3147] = 1892;
                    t[3148] = 1892;
                    t[3153] = 580;
                    t[3154] = 581;
                    t[3157] = 584;
                    t[3158] = 585;
                    t[3161] = 588;
                    t[3162] = 589;
                    t[3165] = 891;
                    t[3166] = 892;
                    t[3169] = 1274;
                    t[3170] = 1275;
                    t[3173] = 1278;
                    t[3174] = 1279;
                    t[3181] = 7622;
                    t[3182] = 7623;
                    t[3282] = 11799;
                    t[3316] = 578;
                    t[3379] = 42785;
                    t[3393] = 1159;
                    t[3416] = 8377;
                });
                exports.getGlyphMapForStandardFonts = getGlyphMapForStandardFonts;
                const getSupplementalGlyphMapForArialBlack = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[227] = 322;
                    t[264] = 261;
                    t[291] = 346;
                });
                exports.getSupplementalGlyphMapForArialBlack = getSupplementalGlyphMapForArialBlack;
                const getSupplementalGlyphMapForCalibri = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[1] = 32;
                    t[4] = 65;
                    t[5] = 192;
                    t[6] = 193;
                    t[9] = 196;
                    t[17] = 66;
                    t[18] = 67;
                    t[21] = 268;
                    t[24] = 68;
                    t[28] = 69;
                    t[29] = 200;
                    t[30] = 201;
                    t[32] = 282;
                    t[38] = 70;
                    t[39] = 71;
                    t[44] = 72;
                    t[47] = 73;
                    t[48] = 204;
                    t[49] = 205;
                    t[58] = 74;
                    t[60] = 75;
                    t[62] = 76;
                    t[68] = 77;
                    t[69] = 78;
                    t[75] = 79;
                    t[76] = 210;
                    t[80] = 214;
                    t[87] = 80;
                    t[89] = 81;
                    t[90] = 82;
                    t[92] = 344;
                    t[94] = 83;
                    t[97] = 352;
                    t[100] = 84;
                    t[104] = 85;
                    t[109] = 220;
                    t[115] = 86;
                    t[116] = 87;
                    t[121] = 88;
                    t[122] = 89;
                    t[124] = 221;
                    t[127] = 90;
                    t[129] = 381;
                    t[258] = 97;
                    t[259] = 224;
                    t[260] = 225;
                    t[263] = 228;
                    t[268] = 261;
                    t[271] = 98;
                    t[272] = 99;
                    t[273] = 263;
                    t[275] = 269;
                    t[282] = 100;
                    t[286] = 101;
                    t[287] = 232;
                    t[288] = 233;
                    t[290] = 283;
                    t[295] = 281;
                    t[296] = 102;
                    t[336] = 103;
                    t[346] = 104;
                    t[349] = 105;
                    t[350] = 236;
                    t[351] = 237;
                    t[361] = 106;
                    t[364] = 107;
                    t[367] = 108;
                    t[371] = 322;
                    t[373] = 109;
                    t[374] = 110;
                    t[381] = 111;
                    t[382] = 242;
                    t[383] = 243;
                    t[386] = 246;
                    t[393] = 112;
                    t[395] = 113;
                    t[396] = 114;
                    t[398] = 345;
                    t[400] = 115;
                    t[401] = 347;
                    t[403] = 353;
                    t[410] = 116;
                    t[437] = 117;
                    t[442] = 252;
                    t[448] = 118;
                    t[449] = 119;
                    t[454] = 120;
                    t[455] = 121;
                    t[457] = 253;
                    t[460] = 122;
                    t[462] = 382;
                    t[463] = 380;
                    t[853] = 44;
                    t[855] = 58;
                    t[856] = 46;
                    t[876] = 47;
                    t[878] = 45;
                    t[882] = 45;
                    t[894] = 40;
                    t[895] = 41;
                    t[896] = 91;
                    t[897] = 93;
                    t[923] = 64;
                    t[1004] = 48;
                    t[1005] = 49;
                    t[1006] = 50;
                    t[1007] = 51;
                    t[1008] = 52;
                    t[1009] = 53;
                    t[1010] = 54;
                    t[1011] = 55;
                    t[1012] = 56;
                    t[1013] = 57;
                    t[1081] = 37;
                    t[1085] = 43;
                    t[1086] = 45;
                });
                exports.getSupplementalGlyphMapForCalibri = getSupplementalGlyphMapForCalibri;
                function getStandardFontName(name) {
                    const fontName = (0, _fonts_utils.normalizeFontName)(name);
                    const stdFontMap = getStdFontMap();
                    return stdFontMap[fontName];
                }
                function isKnownFontName(name) {
                    const fontName = (0, _fonts_utils.normalizeFontName)(name);
                    return !!(getStdFontMap()[fontName] || getNonStdFontMap()[fontName] || getSerifFonts()[fontName] || getSymbolsFonts()[fontName]);
                }
            /***/ },
            /* 42 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ToUnicodeMap = exports.IdentityToUnicodeMap = void 0;
                var _util = __w_pdfjs_require__(2);
                class ToUnicodeMap {
                    constructor(cmap = []){
                        this._map = cmap;
                    }
                    get length() {
                        return this._map.length;
                    }
                    forEach(callback) {
                        for(const charCode in this._map)callback(charCode, this._map[charCode].charCodeAt(0));
                    }
                    has(i) {
                        return this._map[i] !== undefined;
                    }
                    get(i) {
                        return this._map[i];
                    }
                    charCodeOf(value) {
                        const map = this._map;
                        if (map.length <= 0x10000) return map.indexOf(value);
                        for(const charCode in map){
                            if (map[charCode] === value) return charCode | 0;
                        }
                        return -1;
                    }
                    amend(map) {
                        for(const charCode in map)this._map[charCode] = map[charCode];
                    }
                }
                exports.ToUnicodeMap = ToUnicodeMap;
                class IdentityToUnicodeMap {
                    constructor(firstChar, lastChar){
                        this.firstChar = firstChar;
                        this.lastChar = lastChar;
                    }
                    get length() {
                        return this.lastChar + 1 - this.firstChar;
                    }
                    forEach(callback) {
                        for(let i = this.firstChar, ii = this.lastChar; i <= ii; i++)callback(i, i);
                    }
                    has(i) {
                        return this.firstChar <= i && i <= this.lastChar;
                    }
                    get(i) {
                        if (this.firstChar <= i && i <= this.lastChar) return String.fromCharCode(i);
                        return undefined;
                    }
                    charCodeOf(v) {
                        return Number.isInteger(v) && v >= this.firstChar && v <= this.lastChar ? v : -1;
                    }
                    amend(map) {
                        (0, _util.unreachable)("Should not call amend()");
                    }
                }
                exports.IdentityToUnicodeMap = IdentityToUnicodeMap;
            /***/ },
            /* 43 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CFFFont = void 0;
                var _cff_parser = __w_pdfjs_require__(35);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _util = __w_pdfjs_require__(2);
                class CFFFont {
                    constructor(file, properties){
                        this.properties = properties;
                        const parser = new _cff_parser.CFFParser(file, properties, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        this.cff = parser.parse();
                        this.cff.duplicateFirstGlyph();
                        const compiler = new _cff_parser.CFFCompiler(this.cff);
                        this.seacs = this.cff.seacs;
                        try {
                            this.data = compiler.compile();
                        } catch  {
                            (0, _util.warn)("Failed to compile font " + properties.loadedName);
                            this.data = file;
                        }
                        this._createBuiltInEncoding();
                    }
                    get numGlyphs() {
                        return this.cff.charStrings.count;
                    }
                    getCharset() {
                        return this.cff.charset.charset;
                    }
                    getGlyphMapping() {
                        const cff = this.cff;
                        const properties = this.properties;
                        const { cidToGidMap: cidToGidMap, cMap: cMap } = properties;
                        const charsets = cff.charset.charset;
                        let charCodeToGlyphId;
                        let glyphId;
                        if (properties.composite) {
                            let invCidToGidMap;
                            if (cidToGidMap?.length > 0) {
                                invCidToGidMap = Object.create(null);
                                for(let i = 0, ii = cidToGidMap.length; i < ii; i++){
                                    const gid = cidToGidMap[i];
                                    if (gid !== undefined) invCidToGidMap[gid] = i;
                                }
                            }
                            charCodeToGlyphId = Object.create(null);
                            let charCode;
                            if (cff.isCIDFont) for(glyphId = 0; glyphId < charsets.length; glyphId++){
                                const cid = charsets[glyphId];
                                charCode = cMap.charCodeOf(cid);
                                if (invCidToGidMap?.[charCode] !== undefined) charCode = invCidToGidMap[charCode];
                                charCodeToGlyphId[charCode] = glyphId;
                            }
                            else for(glyphId = 0; glyphId < cff.charStrings.count; glyphId++){
                                charCode = cMap.charCodeOf(glyphId);
                                charCodeToGlyphId[charCode] = glyphId;
                            }
                            return charCodeToGlyphId;
                        }
                        let encoding = cff.encoding ? cff.encoding.encoding : null;
                        if (properties.isInternalFont) encoding = properties.defaultEncoding;
                        charCodeToGlyphId = (0, _fonts_utils.type1FontGlyphMapping)(properties, encoding, charsets);
                        return charCodeToGlyphId;
                    }
                    hasGlyphId(id) {
                        return this.cff.hasGlyphId(id);
                    }
                    _createBuiltInEncoding() {
                        const { charset: charset, encoding: encoding } = this.cff;
                        if (!charset || !encoding) return;
                        const charsets = charset.charset, encodings = encoding.encoding;
                        const map = [];
                        for(const charCode in encodings){
                            const glyphId = encodings[charCode];
                            if (glyphId >= 0) {
                                const glyphName = charsets[glyphId];
                                if (glyphName) map[charCode] = glyphName;
                            }
                        }
                        if (map.length > 0) this.properties.builtInEncoding = map;
                    }
                }
                exports.CFFFont = CFFFont;
            /***/ },
            /* 44 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontRendererFactory = void 0;
                var _util = __w_pdfjs_require__(2);
                var _cff_parser = __w_pdfjs_require__(35);
                var _glyphlist = __w_pdfjs_require__(39);
                var _encodings = __w_pdfjs_require__(37);
                var _stream = __w_pdfjs_require__(8);
                function getUint32(data, offset) {
                    return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
                }
                function getUint16(data, offset) {
                    return data[offset] << 8 | data[offset + 1];
                }
                function getInt16(data, offset) {
                    return (data[offset] << 24 | data[offset + 1] << 16) >> 16;
                }
                function getInt8(data, offset) {
                    return data[offset] << 24 >> 24;
                }
                function getFloat214(data, offset) {
                    return getInt16(data, offset) / 16384;
                }
                function getSubroutineBias(subrs) {
                    const numSubrs = subrs.length;
                    let bias = 32768;
                    if (numSubrs < 1240) bias = 107;
                    else if (numSubrs < 33900) bias = 1131;
                    return bias;
                }
                function parseCmap(data, start, end) {
                    const offset = getUint16(data, start + 2) === 1 ? getUint32(data, start + 8) : getUint32(data, start + 16);
                    const format = getUint16(data, start + offset);
                    let ranges, p, i;
                    if (format === 4) {
                        getUint16(data, start + offset + 2);
                        const segCount = getUint16(data, start + offset + 6) >> 1;
                        p = start + offset + 14;
                        ranges = [];
                        for(i = 0; i < segCount; i++, p += 2)ranges[i] = {
                            end: getUint16(data, p)
                        };
                        p += 2;
                        for(i = 0; i < segCount; i++, p += 2)ranges[i].start = getUint16(data, p);
                        for(i = 0; i < segCount; i++, p += 2)ranges[i].idDelta = getUint16(data, p);
                        for(i = 0; i < segCount; i++, p += 2){
                            let idOffset = getUint16(data, p);
                            if (idOffset === 0) continue;
                            ranges[i].ids = [];
                            for(let j = 0, jj = ranges[i].end - ranges[i].start + 1; j < jj; j++){
                                ranges[i].ids[j] = getUint16(data, p + idOffset);
                                idOffset += 2;
                            }
                        }
                        return ranges;
                    } else if (format === 12) {
                        const groups = getUint32(data, start + offset + 12);
                        p = start + offset + 16;
                        ranges = [];
                        for(i = 0; i < groups; i++){
                            start = getUint32(data, p);
                            ranges.push({
                                start: start,
                                end: getUint32(data, p + 4),
                                idDelta: getUint32(data, p + 8) - start
                            });
                            p += 12;
                        }
                        return ranges;
                    }
                    throw new _util.FormatError(`unsupported cmap: ${format}`);
                }
                function parseCff(data, start, end, seacAnalysisEnabled) {
                    const properties = {};
                    const parser = new _cff_parser.CFFParser(new _stream.Stream(data, start, end - start), properties, seacAnalysisEnabled);
                    const cff = parser.parse();
                    return {
                        glyphs: cff.charStrings.objects,
                        subrs: cff.topDict.privateDict?.subrsIndex?.objects,
                        gsubrs: cff.globalSubrIndex?.objects,
                        isCFFCIDFont: cff.isCIDFont,
                        fdSelect: cff.fdSelect,
                        fdArray: cff.fdArray
                    };
                }
                function parseGlyfTable(glyf, loca, isGlyphLocationsLong) {
                    let itemSize, itemDecode;
                    if (isGlyphLocationsLong) {
                        itemSize = 4;
                        itemDecode = getUint32;
                    } else {
                        itemSize = 2;
                        itemDecode = (data, offset)=>2 * getUint16(data, offset);
                    }
                    const glyphs = [];
                    let startOffset = itemDecode(loca, 0);
                    for(let j = itemSize; j < loca.length; j += itemSize){
                        const endOffset = itemDecode(loca, j);
                        glyphs.push(glyf.subarray(startOffset, endOffset));
                        startOffset = endOffset;
                    }
                    return glyphs;
                }
                function lookupCmap(ranges, unicode) {
                    const code = unicode.codePointAt(0);
                    let gid = 0, l = 0, r = ranges.length - 1;
                    while(l < r){
                        const c = l + r + 1 >> 1;
                        if (code < ranges[c].start) r = c - 1;
                        else l = c;
                    }
                    if (ranges[l].start <= code && code <= ranges[l].end) gid = ranges[l].idDelta + (ranges[l].ids ? ranges[l].ids[code - ranges[l].start] : code) & 0xffff;
                    return {
                        charCode: code,
                        glyphId: gid
                    };
                }
                function compileGlyf(code, cmds, font1) {
                    function moveTo(x, y) {
                        cmds.push({
                            cmd: "moveTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function lineTo(x, y) {
                        cmds.push({
                            cmd: "lineTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function quadraticCurveTo(xa, ya, x, y) {
                        cmds.push({
                            cmd: "quadraticCurveTo",
                            args: [
                                xa,
                                ya,
                                x,
                                y
                            ]
                        });
                    }
                    let i = 0;
                    const numberOfContours = getInt16(code, i);
                    let flags;
                    let x = 0, y = 0;
                    i += 10;
                    if (numberOfContours < 0) do {
                        flags = getUint16(code, i);
                        const glyphIndex = getUint16(code, i + 2);
                        i += 4;
                        let arg1, arg2;
                        if (flags & 0x01) {
                            if (flags & 0x02) {
                                arg1 = getInt16(code, i);
                                arg2 = getInt16(code, i + 2);
                            } else {
                                arg1 = getUint16(code, i);
                                arg2 = getUint16(code, i + 2);
                            }
                            i += 4;
                        } else if (flags & 0x02) {
                            arg1 = getInt8(code, i++);
                            arg2 = getInt8(code, i++);
                        } else {
                            arg1 = code[i++];
                            arg2 = code[i++];
                        }
                        if (flags & 0x02) {
                            x = arg1;
                            y = arg2;
                        } else {
                            x = 0;
                            y = 0;
                        }
                        let scaleX = 1, scaleY = 1, scale01 = 0, scale10 = 0;
                        if (flags & 0x08) {
                            scaleX = scaleY = getFloat214(code, i);
                            i += 2;
                        } else if (flags & 0x40) {
                            scaleX = getFloat214(code, i);
                            scaleY = getFloat214(code, i + 2);
                            i += 4;
                        } else if (flags & 0x80) {
                            scaleX = getFloat214(code, i);
                            scale01 = getFloat214(code, i + 2);
                            scale10 = getFloat214(code, i + 4);
                            scaleY = getFloat214(code, i + 6);
                            i += 8;
                        }
                        const subglyph = font1.glyphs[glyphIndex];
                        if (subglyph) {
                            cmds.push({
                                cmd: "save"
                            }, {
                                cmd: "transform",
                                args: [
                                    scaleX,
                                    scale01,
                                    scale10,
                                    scaleY,
                                    x,
                                    y
                                ]
                            });
                            flags;
                            compileGlyf(subglyph, cmds, font1);
                            cmds.push({
                                cmd: "restore"
                            });
                        }
                    }while (flags & 0x20);
                    else {
                        const endPtsOfContours = [];
                        let j, jj;
                        for(j = 0; j < numberOfContours; j++){
                            endPtsOfContours.push(getUint16(code, i));
                            i += 2;
                        }
                        const instructionLength = getUint16(code, i);
                        i += 2 + instructionLength;
                        const numberOfPoints = endPtsOfContours.at(-1) + 1;
                        const points = [];
                        while(points.length < numberOfPoints){
                            flags = code[i++];
                            let repeat = 1;
                            if (flags & 0x08) repeat += code[i++];
                            while(repeat-- > 0)points.push({
                                flags: flags
                            });
                        }
                        for(j = 0; j < numberOfPoints; j++){
                            switch(points[j].flags & 0x12){
                                case 0x00:
                                    x += getInt16(code, i);
                                    i += 2;
                                    break;
                                case 0x02:
                                    x -= code[i++];
                                    break;
                                case 0x12:
                                    x += code[i++];
                                    break;
                            }
                            points[j].x = x;
                        }
                        for(j = 0; j < numberOfPoints; j++){
                            switch(points[j].flags & 0x24){
                                case 0x00:
                                    y += getInt16(code, i);
                                    i += 2;
                                    break;
                                case 0x04:
                                    y -= code[i++];
                                    break;
                                case 0x24:
                                    y += code[i++];
                                    break;
                            }
                            points[j].y = y;
                        }
                        let startPoint = 0;
                        for(i = 0; i < numberOfContours; i++){
                            const endPoint = endPtsOfContours[i];
                            const contour = points.slice(startPoint, endPoint + 1);
                            if (contour[0].flags & 1) contour.push(contour[0]);
                            else if (contour.at(-1).flags & 1) contour.unshift(contour.at(-1));
                            else {
                                const p = {
                                    flags: 1,
                                    x: (contour[0].x + contour.at(-1).x) / 2,
                                    y: (contour[0].y + contour.at(-1).y) / 2
                                };
                                contour.unshift(p);
                                contour.push(p);
                            }
                            moveTo(contour[0].x, contour[0].y);
                            for(j = 1, jj = contour.length; j < jj; j++){
                                if (contour[j].flags & 1) lineTo(contour[j].x, contour[j].y);
                                else if (contour[j + 1].flags & 1) {
                                    quadraticCurveTo(contour[j].x, contour[j].y, contour[j + 1].x, contour[j + 1].y);
                                    j++;
                                } else quadraticCurveTo(contour[j].x, contour[j].y, (contour[j].x + contour[j + 1].x) / 2, (contour[j].y + contour[j + 1].y) / 2);
                            }
                            startPoint = endPoint + 1;
                        }
                    }
                }
                function compileCharString(charStringCode, cmds, font1, glyphId) {
                    function moveTo(x, y) {
                        cmds.push({
                            cmd: "moveTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function lineTo(x, y) {
                        cmds.push({
                            cmd: "lineTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function bezierCurveTo(x1, y1, x2, y2, x, y) {
                        cmds.push({
                            cmd: "bezierCurveTo",
                            args: [
                                x1,
                                y1,
                                x2,
                                y2,
                                x,
                                y
                            ]
                        });
                    }
                    const stack = [];
                    let x = 0, y = 0;
                    let stems = 0;
                    function parse(code) {
                        let i = 0;
                        while(i < code.length){
                            let stackClean = false;
                            let v = code[i++];
                            let xa, xb, ya, yb, y1, y2, y3, n, subrCode;
                            switch(v){
                                case 1:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 3:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 4:
                                    y += stack.pop();
                                    moveTo(x, y);
                                    stackClean = true;
                                    break;
                                case 5:
                                    while(stack.length > 0){
                                        x += stack.shift();
                                        y += stack.shift();
                                        lineTo(x, y);
                                    }
                                    break;
                                case 6:
                                    while(stack.length > 0){
                                        x += stack.shift();
                                        lineTo(x, y);
                                        if (stack.length === 0) break;
                                        y += stack.shift();
                                        lineTo(x, y);
                                    }
                                    break;
                                case 7:
                                    while(stack.length > 0){
                                        y += stack.shift();
                                        lineTo(x, y);
                                        if (stack.length === 0) break;
                                        x += stack.shift();
                                        lineTo(x, y);
                                    }
                                    break;
                                case 8:
                                    while(stack.length > 0){
                                        xa = x + stack.shift();
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + stack.shift();
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 10:
                                    n = stack.pop();
                                    subrCode = null;
                                    if (font1.isCFFCIDFont) {
                                        const fdIndex = font1.fdSelect.getFDIndex(glyphId);
                                        if (fdIndex >= 0 && fdIndex < font1.fdArray.length) {
                                            const fontDict = font1.fdArray[fdIndex];
                                            let subrs;
                                            if (fontDict.privateDict?.subrsIndex) subrs = fontDict.privateDict.subrsIndex.objects;
                                            if (subrs) {
                                                n += getSubroutineBias(subrs);
                                                subrCode = subrs[n];
                                            }
                                        } else (0, _util.warn)("Invalid fd index for glyph index.");
                                    } else subrCode = font1.subrs[n + font1.subrsBias];
                                    if (subrCode) parse(subrCode);
                                    break;
                                case 11:
                                    return;
                                case 12:
                                    v = code[i++];
                                    switch(v){
                                        case 34:
                                            xa = x + stack.shift();
                                            xb = xa + stack.shift();
                                            y1 = y + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y, xb, y1, x, y1);
                                            xa = x + stack.shift();
                                            xb = xa + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y1, xb, y, x, y);
                                            break;
                                        case 35:
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb + stack.shift();
                                            y = yb + stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb + stack.shift();
                                            y = yb + stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            stack.pop();
                                            break;
                                        case 36:
                                            xa = x + stack.shift();
                                            y1 = y + stack.shift();
                                            xb = xa + stack.shift();
                                            y2 = y1 + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y1, xb, y2, x, y2);
                                            xa = x + stack.shift();
                                            xb = xa + stack.shift();
                                            y3 = y2 + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y2, xb, y3, x, y);
                                            break;
                                        case 37:
                                            const x0 = x, y0 = y;
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb + stack.shift();
                                            y = yb + stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb;
                                            y = yb;
                                            if (Math.abs(x - x0) > Math.abs(y - y0)) x += stack.shift();
                                            else y += stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            break;
                                        default:
                                            throw new _util.FormatError(`unknown operator: 12 ${v}`);
                                    }
                                    break;
                                case 14:
                                    if (stack.length >= 4) {
                                        const achar = stack.pop();
                                        const bchar = stack.pop();
                                        y = stack.pop();
                                        x = stack.pop();
                                        cmds.push({
                                            cmd: "save"
                                        }, {
                                            cmd: "translate",
                                            args: [
                                                x,
                                                y
                                            ]
                                        });
                                        let cmap = lookupCmap(font1.cmap, String.fromCharCode(font1.glyphNameMap[_encodings.StandardEncoding[achar]]));
                                        compileCharString(font1.glyphs[cmap.glyphId], cmds, font1, cmap.glyphId);
                                        cmds.push({
                                            cmd: "restore"
                                        });
                                        cmap = lookupCmap(font1.cmap, String.fromCharCode(font1.glyphNameMap[_encodings.StandardEncoding[bchar]]));
                                        compileCharString(font1.glyphs[cmap.glyphId], cmds, font1, cmap.glyphId);
                                    }
                                    return;
                                case 18:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 19:
                                    stems += stack.length >> 1;
                                    i += stems + 7 >> 3;
                                    stackClean = true;
                                    break;
                                case 20:
                                    stems += stack.length >> 1;
                                    i += stems + 7 >> 3;
                                    stackClean = true;
                                    break;
                                case 21:
                                    y += stack.pop();
                                    x += stack.pop();
                                    moveTo(x, y);
                                    stackClean = true;
                                    break;
                                case 22:
                                    x += stack.pop();
                                    moveTo(x, y);
                                    stackClean = true;
                                    break;
                                case 23:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 24:
                                    while(stack.length > 2){
                                        xa = x + stack.shift();
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + stack.shift();
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    x += stack.shift();
                                    y += stack.shift();
                                    lineTo(x, y);
                                    break;
                                case 25:
                                    while(stack.length > 6){
                                        x += stack.shift();
                                        y += stack.shift();
                                        lineTo(x, y);
                                    }
                                    xa = x + stack.shift();
                                    ya = y + stack.shift();
                                    xb = xa + stack.shift();
                                    yb = ya + stack.shift();
                                    x = xb + stack.shift();
                                    y = yb + stack.shift();
                                    bezierCurveTo(xa, ya, xb, yb, x, y);
                                    break;
                                case 26:
                                    if (stack.length % 2) x += stack.shift();
                                    while(stack.length > 0){
                                        xa = x;
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb;
                                        y = yb + stack.shift();
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 27:
                                    if (stack.length % 2) y += stack.shift();
                                    while(stack.length > 0){
                                        xa = x + stack.shift();
                                        ya = y;
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb;
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 28:
                                    stack.push((code[i] << 24 | code[i + 1] << 16) >> 16);
                                    i += 2;
                                    break;
                                case 29:
                                    n = stack.pop() + font1.gsubrsBias;
                                    subrCode = font1.gsubrs[n];
                                    if (subrCode) parse(subrCode);
                                    break;
                                case 30:
                                    while(stack.length > 0){
                                        xa = x;
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                        if (stack.length === 0) break;
                                        xa = x + stack.shift();
                                        ya = y;
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        y = yb + stack.shift();
                                        x = xb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 31:
                                    while(stack.length > 0){
                                        xa = x + stack.shift();
                                        ya = y;
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        y = yb + stack.shift();
                                        x = xb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                        if (stack.length === 0) break;
                                        xa = x;
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                default:
                                    if (v < 32) throw new _util.FormatError(`unknown operator: ${v}`);
                                    if (v < 247) stack.push(v - 139);
                                    else if (v < 251) stack.push((v - 247) * 256 + code[i++] + 108);
                                    else if (v < 255) stack.push(-(v - 251) * 256 - code[i++] - 108);
                                    else {
                                        stack.push((code[i] << 24 | code[i + 1] << 16 | code[i + 2] << 8 | code[i + 3]) / 65536);
                                        i += 4;
                                    }
                                    break;
                            }
                            if (stackClean) stack.length = 0;
                        }
                    }
                    parse(charStringCode);
                }
                const NOOP = [];
                class CompiledFont {
                    constructor(fontMatrix){
                        if (this.constructor === CompiledFont) (0, _util.unreachable)("Cannot initialize CompiledFont.");
                        this.fontMatrix = fontMatrix;
                        this.compiledGlyphs = Object.create(null);
                        this.compiledCharCodeToGlyphId = Object.create(null);
                    }
                    getPathJs(unicode) {
                        const { charCode: charCode, glyphId: glyphId } = lookupCmap(this.cmap, unicode);
                        let fn = this.compiledGlyphs[glyphId];
                        if (!fn) try {
                            fn = this.compileGlyph(this.glyphs[glyphId], glyphId);
                            this.compiledGlyphs[glyphId] = fn;
                        } catch (ex) {
                            this.compiledGlyphs[glyphId] = NOOP;
                            if (this.compiledCharCodeToGlyphId[charCode] === undefined) this.compiledCharCodeToGlyphId[charCode] = glyphId;
                            throw ex;
                        }
                        if (this.compiledCharCodeToGlyphId[charCode] === undefined) this.compiledCharCodeToGlyphId[charCode] = glyphId;
                        return fn;
                    }
                    compileGlyph(code, glyphId) {
                        if (!code || code.length === 0 || code[0] === 14) return NOOP;
                        let fontMatrix = this.fontMatrix;
                        if (this.isCFFCIDFont) {
                            const fdIndex = this.fdSelect.getFDIndex(glyphId);
                            if (fdIndex >= 0 && fdIndex < this.fdArray.length) {
                                const fontDict = this.fdArray[fdIndex];
                                fontMatrix = fontDict.getByName("FontMatrix") || _util.FONT_IDENTITY_MATRIX;
                            } else (0, _util.warn)("Invalid fd index for glyph index.");
                        }
                        const cmds = [
                            {
                                cmd: "save"
                            },
                            {
                                cmd: "transform",
                                args: fontMatrix.slice()
                            },
                            {
                                cmd: "scale",
                                args: [
                                    "size",
                                    "-size"
                                ]
                            }
                        ];
                        this.compileGlyphImpl(code, cmds, glyphId);
                        cmds.push({
                            cmd: "restore"
                        });
                        return cmds;
                    }
                    compileGlyphImpl() {
                        (0, _util.unreachable)("Children classes should implement this.");
                    }
                    hasBuiltPath(unicode) {
                        const { charCode: charCode, glyphId: glyphId } = lookupCmap(this.cmap, unicode);
                        return this.compiledGlyphs[glyphId] !== undefined && this.compiledCharCodeToGlyphId[charCode] !== undefined;
                    }
                }
                class TrueTypeCompiled extends CompiledFont {
                    constructor(glyphs, cmap, fontMatrix){
                        super(fontMatrix || [
                            0.000488,
                            0,
                            0,
                            0.000488,
                            0,
                            0
                        ]);
                        this.glyphs = glyphs;
                        this.cmap = cmap;
                    }
                    compileGlyphImpl(code, cmds) {
                        compileGlyf(code, cmds, this);
                    }
                }
                class Type2Compiled extends CompiledFont {
                    constructor(cffInfo, cmap, fontMatrix, glyphNameMap){
                        super(fontMatrix || [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]);
                        this.glyphs = cffInfo.glyphs;
                        this.gsubrs = cffInfo.gsubrs || [];
                        this.subrs = cffInfo.subrs || [];
                        this.cmap = cmap;
                        this.glyphNameMap = glyphNameMap || (0, _glyphlist.getGlyphsUnicode)();
                        this.gsubrsBias = getSubroutineBias(this.gsubrs);
                        this.subrsBias = getSubroutineBias(this.subrs);
                        this.isCFFCIDFont = cffInfo.isCFFCIDFont;
                        this.fdSelect = cffInfo.fdSelect;
                        this.fdArray = cffInfo.fdArray;
                    }
                    compileGlyphImpl(code, cmds, glyphId) {
                        compileCharString(code, cmds, this, glyphId);
                    }
                }
                class FontRendererFactory {
                    static create(font1, seacAnalysisEnabled) {
                        const data = new Uint8Array(font1.data);
                        let cmap, glyf, loca, cff, indexToLocFormat, unitsPerEm;
                        const numTables = getUint16(data, 4);
                        for(let i = 0, p = 12; i < numTables; i++, p += 16){
                            const tag = (0, _util.bytesToString)(data.subarray(p, p + 4));
                            const offset = getUint32(data, p + 8);
                            const length = getUint32(data, p + 12);
                            switch(tag){
                                case "cmap":
                                    cmap = parseCmap(data, offset, offset + length);
                                    break;
                                case "glyf":
                                    glyf = data.subarray(offset, offset + length);
                                    break;
                                case "loca":
                                    loca = data.subarray(offset, offset + length);
                                    break;
                                case "head":
                                    unitsPerEm = getUint16(data, offset + 18);
                                    indexToLocFormat = getUint16(data, offset + 50);
                                    break;
                                case "CFF ":
                                    cff = parseCff(data, offset, offset + length, seacAnalysisEnabled);
                                    break;
                            }
                        }
                        if (glyf) {
                            const fontMatrix = !unitsPerEm ? font1.fontMatrix : [
                                1 / unitsPerEm,
                                0,
                                0,
                                1 / unitsPerEm,
                                0,
                                0
                            ];
                            return new TrueTypeCompiled(parseGlyfTable(glyf, loca, indexToLocFormat), cmap, fontMatrix);
                        }
                        return new Type2Compiled(cff, cmap, font1.fontMatrix, font1.glyphNameMap);
                    }
                }
                exports.FontRendererFactory = FontRendererFactory;
            /***/ },
            /* 45 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getMetrics = exports.getFontBasicMetrics = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                const getMetrics = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Courier = 600;
                    t["Courier-Bold"] = 600;
                    t["Courier-BoldOblique"] = 600;
                    t["Courier-Oblique"] = 600;
                    t.Helvetica = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 278;
                        t.quotedbl = 355;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 667;
                        t.quoteright = 222;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 556;
                        t.at = 1015;
                        t.A = 667;
                        t.B = 667;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 500;
                        t.K = 667;
                        t.L = 556;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 278;
                        t.backslash = 278;
                        t.bracketright = 278;
                        t.asciicircum = 469;
                        t.underscore = 556;
                        t.quoteleft = 222;
                        t.a = 556;
                        t.b = 556;
                        t.c = 500;
                        t.d = 556;
                        t.e = 556;
                        t.f = 278;
                        t.g = 556;
                        t.h = 556;
                        t.i = 222;
                        t.j = 222;
                        t.k = 500;
                        t.l = 222;
                        t.m = 833;
                        t.n = 556;
                        t.o = 556;
                        t.p = 556;
                        t.q = 556;
                        t.r = 333;
                        t.s = 500;
                        t.t = 278;
                        t.u = 556;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 500;
                        t.braceleft = 334;
                        t.bar = 260;
                        t.braceright = 334;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 191;
                        t.quotedblleft = 333;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 500;
                        t.fl = 500;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 537;
                        t.bullet = 350;
                        t.quotesinglbase = 222;
                        t.quotedblbase = 333;
                        t.quotedblright = 333;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 556;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 222;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 556;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 667;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 500;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 500;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 222;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 500;
                        t.scedilla = 500;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 556;
                        t.acircumflex = 556;
                        t.Amacron = 667;
                        t.rcaron = 333;
                        t.ccedilla = 500;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 643;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 667;
                        t.Abreve = 667;
                        t.multiply = 584;
                        t.uacute = 556;
                        t.Tcaron = 611;
                        t.partialdiff = 476;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 500;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 260;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 333;
                        t.omacron = 556;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 222;
                        t.tcaron = 317;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 667;
                        t.Adieresis = 667;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 222;
                        t.Oacute = 778;
                        t.oacute = 556;
                        t.amacron = 556;
                        t.sacute = 500;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 556;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 556;
                        t.igrave = 278;
                        t.ohungarumlaut = 556;
                        t.Eogonek = 667;
                        t.dcroat = 556;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 299;
                        t.Kcommaaccent = 667;
                        t.Lacute = 556;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 556;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 556;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 556;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 556;
                        t.Ccaron = 722;
                        t.ugrave = 556;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 333;
                        t.Ntilde = 722;
                        t.otilde = 556;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 556;
                        t.Atilde = 667;
                        t.Aogonek = 667;
                        t.Aring = 667;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 500;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 556;
                        t.tcommaaccent = 278;
                        t.logicalnot = 584;
                        t.odieresis = 556;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 556;
                        t.eth = 556;
                        t.zcaron = 500;
                        t.ncommaaccent = 556;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t["Helvetica-Bold"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 333;
                        t.quotedbl = 474;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 722;
                        t.quoteright = 278;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 611;
                        t.at = 975;
                        t.A = 722;
                        t.B = 722;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 556;
                        t.K = 722;
                        t.L = 611;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 584;
                        t.underscore = 556;
                        t.quoteleft = 278;
                        t.a = 556;
                        t.b = 611;
                        t.c = 556;
                        t.d = 611;
                        t.e = 556;
                        t.f = 333;
                        t.g = 611;
                        t.h = 611;
                        t.i = 278;
                        t.j = 278;
                        t.k = 556;
                        t.l = 278;
                        t.m = 889;
                        t.n = 611;
                        t.o = 611;
                        t.p = 611;
                        t.q = 611;
                        t.r = 389;
                        t.s = 556;
                        t.t = 333;
                        t.u = 611;
                        t.v = 556;
                        t.w = 778;
                        t.x = 556;
                        t.y = 556;
                        t.z = 500;
                        t.braceleft = 389;
                        t.bar = 280;
                        t.braceright = 389;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 238;
                        t.quotedblleft = 500;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 611;
                        t.fl = 611;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 556;
                        t.bullet = 350;
                        t.quotesinglbase = 278;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 611;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 611;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 722;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 556;
                        t.scommaaccent = 556;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 611;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 556;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 556;
                        t.scedilla = 556;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 611;
                        t.acircumflex = 556;
                        t.Amacron = 722;
                        t.rcaron = 389;
                        t.ccedilla = 556;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 743;
                        t.Umacron = 722;
                        t.uring = 611;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 584;
                        t.uacute = 611;
                        t.Tcaron = 611;
                        t.partialdiff = 494;
                        t.ydieresis = 556;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 556;
                        t.nacute = 611;
                        t.umacron = 611;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 280;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 389;
                        t.omacron = 611;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 278;
                        t.tcaron = 389;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 278;
                        t.Oacute = 778;
                        t.oacute = 611;
                        t.amacron = 556;
                        t.sacute = 556;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 611;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 611;
                        t.igrave = 278;
                        t.ohungarumlaut = 611;
                        t.Eogonek = 667;
                        t.dcroat = 611;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 400;
                        t.Kcommaaccent = 722;
                        t.Lacute = 611;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 611;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 611;
                        t.ntilde = 611;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 611;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 611;
                        t.Ccaron = 722;
                        t.ugrave = 611;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 722;
                        t.otilde = 611;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 611;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 556;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 611;
                        t.tcommaaccent = 333;
                        t.logicalnot = 584;
                        t.odieresis = 611;
                        t.udieresis = 611;
                        t.notequal = 549;
                        t.gcommaaccent = 611;
                        t.eth = 611;
                        t.zcaron = 500;
                        t.ncommaaccent = 611;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t["Helvetica-BoldOblique"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 333;
                        t.quotedbl = 474;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 722;
                        t.quoteright = 278;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 611;
                        t.at = 975;
                        t.A = 722;
                        t.B = 722;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 556;
                        t.K = 722;
                        t.L = 611;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 584;
                        t.underscore = 556;
                        t.quoteleft = 278;
                        t.a = 556;
                        t.b = 611;
                        t.c = 556;
                        t.d = 611;
                        t.e = 556;
                        t.f = 333;
                        t.g = 611;
                        t.h = 611;
                        t.i = 278;
                        t.j = 278;
                        t.k = 556;
                        t.l = 278;
                        t.m = 889;
                        t.n = 611;
                        t.o = 611;
                        t.p = 611;
                        t.q = 611;
                        t.r = 389;
                        t.s = 556;
                        t.t = 333;
                        t.u = 611;
                        t.v = 556;
                        t.w = 778;
                        t.x = 556;
                        t.y = 556;
                        t.z = 500;
                        t.braceleft = 389;
                        t.bar = 280;
                        t.braceright = 389;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 238;
                        t.quotedblleft = 500;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 611;
                        t.fl = 611;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 556;
                        t.bullet = 350;
                        t.quotesinglbase = 278;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 611;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 611;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 722;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 556;
                        t.scommaaccent = 556;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 611;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 556;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 556;
                        t.scedilla = 556;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 611;
                        t.acircumflex = 556;
                        t.Amacron = 722;
                        t.rcaron = 389;
                        t.ccedilla = 556;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 743;
                        t.Umacron = 722;
                        t.uring = 611;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 584;
                        t.uacute = 611;
                        t.Tcaron = 611;
                        t.partialdiff = 494;
                        t.ydieresis = 556;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 556;
                        t.nacute = 611;
                        t.umacron = 611;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 280;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 389;
                        t.omacron = 611;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 278;
                        t.tcaron = 389;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 278;
                        t.Oacute = 778;
                        t.oacute = 611;
                        t.amacron = 556;
                        t.sacute = 556;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 611;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 611;
                        t.igrave = 278;
                        t.ohungarumlaut = 611;
                        t.Eogonek = 667;
                        t.dcroat = 611;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 400;
                        t.Kcommaaccent = 722;
                        t.Lacute = 611;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 611;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 611;
                        t.ntilde = 611;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 611;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 611;
                        t.Ccaron = 722;
                        t.ugrave = 611;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 722;
                        t.otilde = 611;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 611;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 556;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 611;
                        t.tcommaaccent = 333;
                        t.logicalnot = 584;
                        t.odieresis = 611;
                        t.udieresis = 611;
                        t.notequal = 549;
                        t.gcommaaccent = 611;
                        t.eth = 611;
                        t.zcaron = 500;
                        t.ncommaaccent = 611;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t["Helvetica-Oblique"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 278;
                        t.quotedbl = 355;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 667;
                        t.quoteright = 222;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 556;
                        t.at = 1015;
                        t.A = 667;
                        t.B = 667;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 500;
                        t.K = 667;
                        t.L = 556;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 278;
                        t.backslash = 278;
                        t.bracketright = 278;
                        t.asciicircum = 469;
                        t.underscore = 556;
                        t.quoteleft = 222;
                        t.a = 556;
                        t.b = 556;
                        t.c = 500;
                        t.d = 556;
                        t.e = 556;
                        t.f = 278;
                        t.g = 556;
                        t.h = 556;
                        t.i = 222;
                        t.j = 222;
                        t.k = 500;
                        t.l = 222;
                        t.m = 833;
                        t.n = 556;
                        t.o = 556;
                        t.p = 556;
                        t.q = 556;
                        t.r = 333;
                        t.s = 500;
                        t.t = 278;
                        t.u = 556;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 500;
                        t.braceleft = 334;
                        t.bar = 260;
                        t.braceright = 334;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 191;
                        t.quotedblleft = 333;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 500;
                        t.fl = 500;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 537;
                        t.bullet = 350;
                        t.quotesinglbase = 222;
                        t.quotedblbase = 333;
                        t.quotedblright = 333;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 556;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 222;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 556;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 667;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 500;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 500;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 222;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 500;
                        t.scedilla = 500;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 556;
                        t.acircumflex = 556;
                        t.Amacron = 667;
                        t.rcaron = 333;
                        t.ccedilla = 500;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 643;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 667;
                        t.Abreve = 667;
                        t.multiply = 584;
                        t.uacute = 556;
                        t.Tcaron = 611;
                        t.partialdiff = 476;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 500;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 260;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 333;
                        t.omacron = 556;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 222;
                        t.tcaron = 317;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 667;
                        t.Adieresis = 667;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 222;
                        t.Oacute = 778;
                        t.oacute = 556;
                        t.amacron = 556;
                        t.sacute = 500;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 556;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 556;
                        t.igrave = 278;
                        t.ohungarumlaut = 556;
                        t.Eogonek = 667;
                        t.dcroat = 556;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 299;
                        t.Kcommaaccent = 667;
                        t.Lacute = 556;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 556;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 556;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 556;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 556;
                        t.Ccaron = 722;
                        t.ugrave = 556;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 333;
                        t.Ntilde = 722;
                        t.otilde = 556;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 556;
                        t.Atilde = 667;
                        t.Aogonek = 667;
                        t.Aring = 667;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 500;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 556;
                        t.tcommaaccent = 278;
                        t.logicalnot = 584;
                        t.odieresis = 556;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 556;
                        t.eth = 556;
                        t.zcaron = 500;
                        t.ncommaaccent = 556;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t.Symbol = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.universal = 713;
                        t.numbersign = 500;
                        t.existential = 549;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.suchthat = 439;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asteriskmath = 500;
                        t.plus = 549;
                        t.comma = 250;
                        t.minus = 549;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 549;
                        t.equal = 549;
                        t.greater = 549;
                        t.question = 444;
                        t.congruent = 549;
                        t.Alpha = 722;
                        t.Beta = 667;
                        t.Chi = 722;
                        t.Delta = 612;
                        t.Epsilon = 611;
                        t.Phi = 763;
                        t.Gamma = 603;
                        t.Eta = 722;
                        t.Iota = 333;
                        t.theta1 = 631;
                        t.Kappa = 722;
                        t.Lambda = 686;
                        t.Mu = 889;
                        t.Nu = 722;
                        t.Omicron = 722;
                        t.Pi = 768;
                        t.Theta = 741;
                        t.Rho = 556;
                        t.Sigma = 592;
                        t.Tau = 611;
                        t.Upsilon = 690;
                        t.sigma1 = 439;
                        t.Omega = 768;
                        t.Xi = 645;
                        t.Psi = 795;
                        t.Zeta = 611;
                        t.bracketleft = 333;
                        t.therefore = 863;
                        t.bracketright = 333;
                        t.perpendicular = 658;
                        t.underscore = 500;
                        t.radicalex = 500;
                        t.alpha = 631;
                        t.beta = 549;
                        t.chi = 549;
                        t.delta = 494;
                        t.epsilon = 439;
                        t.phi = 521;
                        t.gamma = 411;
                        t.eta = 603;
                        t.iota = 329;
                        t.phi1 = 603;
                        t.kappa = 549;
                        t.lambda = 549;
                        t.mu = 576;
                        t.nu = 521;
                        t.omicron = 549;
                        t.pi = 549;
                        t.theta = 521;
                        t.rho = 549;
                        t.sigma = 603;
                        t.tau = 439;
                        t.upsilon = 576;
                        t.omega1 = 713;
                        t.omega = 686;
                        t.xi = 493;
                        t.psi = 686;
                        t.zeta = 494;
                        t.braceleft = 480;
                        t.bar = 200;
                        t.braceright = 480;
                        t.similar = 549;
                        t.Euro = 750;
                        t.Upsilon1 = 620;
                        t.minute = 247;
                        t.lessequal = 549;
                        t.fraction = 167;
                        t.infinity = 713;
                        t.florin = 500;
                        t.club = 753;
                        t.diamond = 753;
                        t.heart = 753;
                        t.spade = 753;
                        t.arrowboth = 1042;
                        t.arrowleft = 987;
                        t.arrowup = 603;
                        t.arrowright = 987;
                        t.arrowdown = 603;
                        t.degree = 400;
                        t.plusminus = 549;
                        t.second = 411;
                        t.greaterequal = 549;
                        t.multiply = 549;
                        t.proportional = 713;
                        t.partialdiff = 494;
                        t.bullet = 460;
                        t.divide = 549;
                        t.notequal = 549;
                        t.equivalence = 549;
                        t.approxequal = 549;
                        t.ellipsis = 1000;
                        t.arrowvertex = 603;
                        t.arrowhorizex = 1000;
                        t.carriagereturn = 658;
                        t.aleph = 823;
                        t.Ifraktur = 686;
                        t.Rfraktur = 795;
                        t.weierstrass = 987;
                        t.circlemultiply = 768;
                        t.circleplus = 768;
                        t.emptyset = 823;
                        t.intersection = 768;
                        t.union = 768;
                        t.propersuperset = 713;
                        t.reflexsuperset = 713;
                        t.notsubset = 713;
                        t.propersubset = 713;
                        t.reflexsubset = 713;
                        t.element = 713;
                        t.notelement = 713;
                        t.angle = 768;
                        t.gradient = 713;
                        t.registerserif = 790;
                        t.copyrightserif = 790;
                        t.trademarkserif = 890;
                        t.product = 823;
                        t.radical = 549;
                        t.dotmath = 250;
                        t.logicalnot = 713;
                        t.logicaland = 603;
                        t.logicalor = 603;
                        t.arrowdblboth = 1042;
                        t.arrowdblleft = 987;
                        t.arrowdblup = 603;
                        t.arrowdblright = 987;
                        t.arrowdbldown = 603;
                        t.lozenge = 494;
                        t.angleleft = 329;
                        t.registersans = 790;
                        t.copyrightsans = 790;
                        t.trademarksans = 786;
                        t.summation = 713;
                        t.parenlefttp = 384;
                        t.parenleftex = 384;
                        t.parenleftbt = 384;
                        t.bracketlefttp = 384;
                        t.bracketleftex = 384;
                        t.bracketleftbt = 384;
                        t.bracelefttp = 494;
                        t.braceleftmid = 494;
                        t.braceleftbt = 494;
                        t.braceex = 494;
                        t.angleright = 329;
                        t.integral = 274;
                        t.integraltp = 686;
                        t.integralex = 686;
                        t.integralbt = 686;
                        t.parenrighttp = 384;
                        t.parenrightex = 384;
                        t.parenrightbt = 384;
                        t.bracketrighttp = 384;
                        t.bracketrightex = 384;
                        t.bracketrightbt = 384;
                        t.bracerighttp = 494;
                        t.bracerightmid = 494;
                        t.bracerightbt = 494;
                        t.apple = 790;
                    });
                    t["Times-Roman"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.quotedbl = 408;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 564;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 564;
                        t.equal = 564;
                        t.greater = 564;
                        t.question = 444;
                        t.at = 921;
                        t.A = 722;
                        t.B = 667;
                        t.C = 667;
                        t.D = 722;
                        t.E = 611;
                        t.F = 556;
                        t.G = 722;
                        t.H = 722;
                        t.I = 333;
                        t.J = 389;
                        t.K = 722;
                        t.L = 611;
                        t.M = 889;
                        t.N = 722;
                        t.O = 722;
                        t.P = 556;
                        t.Q = 722;
                        t.R = 667;
                        t.S = 556;
                        t.T = 611;
                        t.U = 722;
                        t.V = 722;
                        t.W = 944;
                        t.X = 722;
                        t.Y = 722;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 469;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 444;
                        t.b = 500;
                        t.c = 444;
                        t.d = 500;
                        t.e = 444;
                        t.f = 333;
                        t.g = 500;
                        t.h = 500;
                        t.i = 278;
                        t.j = 278;
                        t.k = 500;
                        t.l = 278;
                        t.m = 778;
                        t.n = 500;
                        t.o = 500;
                        t.p = 500;
                        t.q = 500;
                        t.r = 333;
                        t.s = 389;
                        t.t = 278;
                        t.u = 500;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 444;
                        t.braceleft = 480;
                        t.bar = 200;
                        t.braceright = 480;
                        t.asciitilde = 541;
                        t.exclamdown = 333;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 180;
                        t.quotedblleft = 444;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 556;
                        t.fl = 556;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 453;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 444;
                        t.quotedblright = 444;
                        t.guillemotright = 500;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 444;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 889;
                        t.ordfeminine = 276;
                        t.Lslash = 611;
                        t.Oslash = 722;
                        t.OE = 889;
                        t.ordmasculine = 310;
                        t.ae = 667;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 722;
                        t.germandbls = 500;
                        t.Idieresis = 333;
                        t.eacute = 444;
                        t.abreve = 444;
                        t.uhungarumlaut = 500;
                        t.ecaron = 444;
                        t.Ydieresis = 722;
                        t.divide = 564;
                        t.Yacute = 722;
                        t.Acircumflex = 722;
                        t.aacute = 444;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 444;
                        t.Uacute = 722;
                        t.uogonek = 500;
                        t.Edieresis = 611;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 760;
                        t.Emacron = 611;
                        t.ccaron = 444;
                        t.aring = 444;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 444;
                        t.Tcommaaccent = 611;
                        t.Cacute = 667;
                        t.atilde = 444;
                        t.Edotaccent = 611;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 667;
                        t.Gcommaaccent = 722;
                        t.ucircumflex = 500;
                        t.acircumflex = 444;
                        t.Amacron = 722;
                        t.rcaron = 333;
                        t.ccedilla = 444;
                        t.Zdotaccent = 611;
                        t.Thorn = 556;
                        t.Omacron = 722;
                        t.Racute = 667;
                        t.Sacute = 556;
                        t.dcaron = 588;
                        t.Umacron = 722;
                        t.uring = 500;
                        t.threesuperior = 300;
                        t.Ograve = 722;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 564;
                        t.uacute = 500;
                        t.Tcaron = 611;
                        t.partialdiff = 476;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 611;
                        t.adieresis = 444;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 500;
                        t.umacron = 500;
                        t.Ncaron = 722;
                        t.Iacute = 333;
                        t.plusminus = 564;
                        t.brokenbar = 200;
                        t.registered = 760;
                        t.Gbreve = 722;
                        t.Idotaccent = 333;
                        t.summation = 600;
                        t.Egrave = 611;
                        t.racute = 333;
                        t.omacron = 500;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 667;
                        t.lcommaaccent = 278;
                        t.tcaron = 326;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 444;
                        t.zacute = 444;
                        t.iogonek = 278;
                        t.Oacute = 722;
                        t.oacute = 500;
                        t.amacron = 444;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 722;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 500;
                        t.twosuperior = 300;
                        t.Odieresis = 722;
                        t.mu = 500;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 611;
                        t.dcroat = 500;
                        t.threequarters = 750;
                        t.Scedilla = 556;
                        t.lcaron = 344;
                        t.Kcommaaccent = 722;
                        t.Lacute = 611;
                        t.trademark = 980;
                        t.edotaccent = 444;
                        t.Igrave = 333;
                        t.Imacron = 333;
                        t.Lcaron = 611;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 500;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 611;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 556;
                        t.Scommaaccent = 556;
                        t.Ohungarumlaut = 722;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 667;
                        t.ugrave = 500;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 333;
                        t.Ntilde = 722;
                        t.otilde = 500;
                        t.Rcommaaccent = 667;
                        t.Lcommaaccent = 611;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 722;
                        t.zdotaccent = 444;
                        t.Ecaron = 611;
                        t.Iogonek = 333;
                        t.kcommaaccent = 500;
                        t.minus = 564;
                        t.Icircumflex = 333;
                        t.ncaron = 500;
                        t.tcommaaccent = 278;
                        t.logicalnot = 564;
                        t.odieresis = 500;
                        t.udieresis = 500;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 444;
                        t.ncommaaccent = 500;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t["Times-Bold"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.quotedbl = 555;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 1000;
                        t.ampersand = 833;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 570;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 570;
                        t.equal = 570;
                        t.greater = 570;
                        t.question = 500;
                        t.at = 930;
                        t.A = 722;
                        t.B = 667;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 778;
                        t.I = 389;
                        t.J = 500;
                        t.K = 778;
                        t.L = 667;
                        t.M = 944;
                        t.N = 722;
                        t.O = 778;
                        t.P = 611;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 556;
                        t.T = 667;
                        t.U = 722;
                        t.V = 722;
                        t.W = 1000;
                        t.X = 722;
                        t.Y = 722;
                        t.Z = 667;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 581;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 500;
                        t.b = 556;
                        t.c = 444;
                        t.d = 556;
                        t.e = 444;
                        t.f = 333;
                        t.g = 500;
                        t.h = 556;
                        t.i = 278;
                        t.j = 333;
                        t.k = 556;
                        t.l = 278;
                        t.m = 833;
                        t.n = 556;
                        t.o = 500;
                        t.p = 556;
                        t.q = 556;
                        t.r = 444;
                        t.s = 389;
                        t.t = 333;
                        t.u = 556;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 444;
                        t.braceleft = 394;
                        t.bar = 220;
                        t.braceright = 394;
                        t.asciitilde = 520;
                        t.exclamdown = 333;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 278;
                        t.quotedblleft = 500;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 556;
                        t.fl = 556;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 540;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 500;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 500;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 300;
                        t.Lslash = 667;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 330;
                        t.ae = 722;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 722;
                        t.germandbls = 556;
                        t.Idieresis = 389;
                        t.eacute = 444;
                        t.abreve = 500;
                        t.uhungarumlaut = 556;
                        t.ecaron = 444;
                        t.Ydieresis = 722;
                        t.divide = 570;
                        t.Yacute = 722;
                        t.Acircumflex = 722;
                        t.aacute = 500;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 500;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 747;
                        t.Emacron = 667;
                        t.ccaron = 444;
                        t.aring = 500;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 500;
                        t.Tcommaaccent = 667;
                        t.Cacute = 722;
                        t.atilde = 500;
                        t.Edotaccent = 667;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 556;
                        t.acircumflex = 500;
                        t.Amacron = 722;
                        t.rcaron = 444;
                        t.ccedilla = 444;
                        t.Zdotaccent = 667;
                        t.Thorn = 611;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 556;
                        t.dcaron = 672;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 300;
                        t.Ograve = 778;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 570;
                        t.uacute = 556;
                        t.Tcaron = 667;
                        t.partialdiff = 494;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 500;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 389;
                        t.plusminus = 570;
                        t.brokenbar = 220;
                        t.registered = 747;
                        t.Gbreve = 778;
                        t.Idotaccent = 389;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 444;
                        t.omacron = 500;
                        t.Zacute = 667;
                        t.Zcaron = 667;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 278;
                        t.tcaron = 416;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 444;
                        t.zacute = 444;
                        t.iogonek = 278;
                        t.Oacute = 778;
                        t.oacute = 500;
                        t.amacron = 500;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 556;
                        t.twosuperior = 300;
                        t.Odieresis = 778;
                        t.mu = 556;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 667;
                        t.dcroat = 556;
                        t.threequarters = 750;
                        t.Scedilla = 556;
                        t.lcaron = 394;
                        t.Kcommaaccent = 778;
                        t.Lacute = 667;
                        t.trademark = 1000;
                        t.edotaccent = 444;
                        t.Igrave = 389;
                        t.Imacron = 389;
                        t.Lcaron = 667;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 556;
                        t.Scommaaccent = 556;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 722;
                        t.ugrave = 556;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 444;
                        t.Ntilde = 722;
                        t.otilde = 500;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 667;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 778;
                        t.zdotaccent = 444;
                        t.Ecaron = 667;
                        t.Iogonek = 389;
                        t.kcommaaccent = 556;
                        t.minus = 570;
                        t.Icircumflex = 389;
                        t.ncaron = 556;
                        t.tcommaaccent = 333;
                        t.logicalnot = 570;
                        t.odieresis = 500;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 444;
                        t.ncommaaccent = 556;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t["Times-BoldItalic"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 389;
                        t.quotedbl = 555;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 570;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 570;
                        t.equal = 570;
                        t.greater = 570;
                        t.question = 500;
                        t.at = 832;
                        t.A = 667;
                        t.B = 667;
                        t.C = 667;
                        t.D = 722;
                        t.E = 667;
                        t.F = 667;
                        t.G = 722;
                        t.H = 778;
                        t.I = 389;
                        t.J = 500;
                        t.K = 667;
                        t.L = 611;
                        t.M = 889;
                        t.N = 722;
                        t.O = 722;
                        t.P = 611;
                        t.Q = 722;
                        t.R = 667;
                        t.S = 556;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 889;
                        t.X = 667;
                        t.Y = 611;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 570;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 500;
                        t.b = 500;
                        t.c = 444;
                        t.d = 500;
                        t.e = 444;
                        t.f = 333;
                        t.g = 500;
                        t.h = 556;
                        t.i = 278;
                        t.j = 278;
                        t.k = 500;
                        t.l = 278;
                        t.m = 778;
                        t.n = 556;
                        t.o = 500;
                        t.p = 500;
                        t.q = 500;
                        t.r = 389;
                        t.s = 389;
                        t.t = 278;
                        t.u = 556;
                        t.v = 444;
                        t.w = 667;
                        t.x = 500;
                        t.y = 444;
                        t.z = 389;
                        t.braceleft = 348;
                        t.bar = 220;
                        t.braceright = 348;
                        t.asciitilde = 570;
                        t.exclamdown = 389;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 278;
                        t.quotedblleft = 500;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 556;
                        t.fl = 556;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 500;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 500;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 500;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 944;
                        t.ordfeminine = 266;
                        t.Lslash = 611;
                        t.Oslash = 722;
                        t.OE = 944;
                        t.ordmasculine = 300;
                        t.ae = 722;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 722;
                        t.germandbls = 500;
                        t.Idieresis = 389;
                        t.eacute = 444;
                        t.abreve = 500;
                        t.uhungarumlaut = 556;
                        t.ecaron = 444;
                        t.Ydieresis = 611;
                        t.divide = 570;
                        t.Yacute = 611;
                        t.Acircumflex = 667;
                        t.aacute = 500;
                        t.Ucircumflex = 722;
                        t.yacute = 444;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 500;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 747;
                        t.Emacron = 667;
                        t.ccaron = 444;
                        t.aring = 500;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 500;
                        t.Tcommaaccent = 611;
                        t.Cacute = 667;
                        t.atilde = 500;
                        t.Edotaccent = 667;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 667;
                        t.Gcommaaccent = 722;
                        t.ucircumflex = 556;
                        t.acircumflex = 500;
                        t.Amacron = 667;
                        t.rcaron = 389;
                        t.ccedilla = 444;
                        t.Zdotaccent = 611;
                        t.Thorn = 611;
                        t.Omacron = 722;
                        t.Racute = 667;
                        t.Sacute = 556;
                        t.dcaron = 608;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 300;
                        t.Ograve = 722;
                        t.Agrave = 667;
                        t.Abreve = 667;
                        t.multiply = 570;
                        t.uacute = 556;
                        t.Tcaron = 611;
                        t.partialdiff = 494;
                        t.ydieresis = 444;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 500;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 389;
                        t.plusminus = 570;
                        t.brokenbar = 220;
                        t.registered = 747;
                        t.Gbreve = 722;
                        t.Idotaccent = 389;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 389;
                        t.omacron = 500;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 667;
                        t.lcommaaccent = 278;
                        t.tcaron = 366;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 667;
                        t.Adieresis = 667;
                        t.egrave = 444;
                        t.zacute = 389;
                        t.iogonek = 278;
                        t.Oacute = 722;
                        t.oacute = 500;
                        t.amacron = 500;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 722;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 500;
                        t.twosuperior = 300;
                        t.Odieresis = 722;
                        t.mu = 576;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 667;
                        t.dcroat = 500;
                        t.threequarters = 750;
                        t.Scedilla = 556;
                        t.lcaron = 382;
                        t.Kcommaaccent = 667;
                        t.Lacute = 611;
                        t.trademark = 1000;
                        t.edotaccent = 444;
                        t.Igrave = 389;
                        t.Imacron = 389;
                        t.Lcaron = 611;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 556;
                        t.Scommaaccent = 556;
                        t.Ohungarumlaut = 722;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 667;
                        t.ugrave = 556;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 722;
                        t.otilde = 500;
                        t.Rcommaaccent = 667;
                        t.Lcommaaccent = 611;
                        t.Atilde = 667;
                        t.Aogonek = 667;
                        t.Aring = 667;
                        t.Otilde = 722;
                        t.zdotaccent = 389;
                        t.Ecaron = 667;
                        t.Iogonek = 389;
                        t.kcommaaccent = 500;
                        t.minus = 606;
                        t.Icircumflex = 389;
                        t.ncaron = 556;
                        t.tcommaaccent = 278;
                        t.logicalnot = 606;
                        t.odieresis = 500;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 389;
                        t.ncommaaccent = 556;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t["Times-Italic"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.quotedbl = 420;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 675;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 675;
                        t.equal = 675;
                        t.greater = 675;
                        t.question = 500;
                        t.at = 920;
                        t.A = 611;
                        t.B = 611;
                        t.C = 667;
                        t.D = 722;
                        t.E = 611;
                        t.F = 611;
                        t.G = 722;
                        t.H = 722;
                        t.I = 333;
                        t.J = 444;
                        t.K = 667;
                        t.L = 556;
                        t.M = 833;
                        t.N = 667;
                        t.O = 722;
                        t.P = 611;
                        t.Q = 722;
                        t.R = 611;
                        t.S = 500;
                        t.T = 556;
                        t.U = 722;
                        t.V = 611;
                        t.W = 833;
                        t.X = 611;
                        t.Y = 556;
                        t.Z = 556;
                        t.bracketleft = 389;
                        t.backslash = 278;
                        t.bracketright = 389;
                        t.asciicircum = 422;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 500;
                        t.b = 500;
                        t.c = 444;
                        t.d = 500;
                        t.e = 444;
                        t.f = 278;
                        t.g = 500;
                        t.h = 500;
                        t.i = 278;
                        t.j = 278;
                        t.k = 444;
                        t.l = 278;
                        t.m = 722;
                        t.n = 500;
                        t.o = 500;
                        t.p = 500;
                        t.q = 500;
                        t.r = 389;
                        t.s = 389;
                        t.t = 278;
                        t.u = 500;
                        t.v = 444;
                        t.w = 667;
                        t.x = 444;
                        t.y = 444;
                        t.z = 389;
                        t.braceleft = 400;
                        t.bar = 275;
                        t.braceright = 400;
                        t.asciitilde = 541;
                        t.exclamdown = 389;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 214;
                        t.quotedblleft = 556;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 500;
                        t.fl = 500;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 523;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 556;
                        t.quotedblright = 556;
                        t.guillemotright = 500;
                        t.ellipsis = 889;
                        t.perthousand = 1000;
                        t.questiondown = 500;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 889;
                        t.AE = 889;
                        t.ordfeminine = 276;
                        t.Lslash = 556;
                        t.Oslash = 722;
                        t.OE = 944;
                        t.ordmasculine = 310;
                        t.ae = 667;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 667;
                        t.germandbls = 500;
                        t.Idieresis = 333;
                        t.eacute = 444;
                        t.abreve = 500;
                        t.uhungarumlaut = 500;
                        t.ecaron = 444;
                        t.Ydieresis = 556;
                        t.divide = 675;
                        t.Yacute = 556;
                        t.Acircumflex = 611;
                        t.aacute = 500;
                        t.Ucircumflex = 722;
                        t.yacute = 444;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 500;
                        t.Uacute = 722;
                        t.uogonek = 500;
                        t.Edieresis = 611;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 760;
                        t.Emacron = 611;
                        t.ccaron = 444;
                        t.aring = 500;
                        t.Ncommaaccent = 667;
                        t.lacute = 278;
                        t.agrave = 500;
                        t.Tcommaaccent = 556;
                        t.Cacute = 667;
                        t.atilde = 500;
                        t.Edotaccent = 611;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 611;
                        t.Gcommaaccent = 722;
                        t.ucircumflex = 500;
                        t.acircumflex = 500;
                        t.Amacron = 611;
                        t.rcaron = 389;
                        t.ccedilla = 444;
                        t.Zdotaccent = 556;
                        t.Thorn = 611;
                        t.Omacron = 722;
                        t.Racute = 611;
                        t.Sacute = 500;
                        t.dcaron = 544;
                        t.Umacron = 722;
                        t.uring = 500;
                        t.threesuperior = 300;
                        t.Ograve = 722;
                        t.Agrave = 611;
                        t.Abreve = 611;
                        t.multiply = 675;
                        t.uacute = 500;
                        t.Tcaron = 556;
                        t.partialdiff = 476;
                        t.ydieresis = 444;
                        t.Nacute = 667;
                        t.icircumflex = 278;
                        t.Ecircumflex = 611;
                        t.adieresis = 500;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 500;
                        t.umacron = 500;
                        t.Ncaron = 667;
                        t.Iacute = 333;
                        t.plusminus = 675;
                        t.brokenbar = 275;
                        t.registered = 760;
                        t.Gbreve = 722;
                        t.Idotaccent = 333;
                        t.summation = 600;
                        t.Egrave = 611;
                        t.racute = 389;
                        t.omacron = 500;
                        t.Zacute = 556;
                        t.Zcaron = 556;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 667;
                        t.lcommaaccent = 278;
                        t.tcaron = 300;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 611;
                        t.Adieresis = 611;
                        t.egrave = 444;
                        t.zacute = 389;
                        t.iogonek = 278;
                        t.Oacute = 722;
                        t.oacute = 500;
                        t.amacron = 500;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 722;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 500;
                        t.twosuperior = 300;
                        t.Odieresis = 722;
                        t.mu = 500;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 611;
                        t.dcroat = 500;
                        t.threequarters = 750;
                        t.Scedilla = 500;
                        t.lcaron = 300;
                        t.Kcommaaccent = 667;
                        t.Lacute = 556;
                        t.trademark = 980;
                        t.edotaccent = 444;
                        t.Igrave = 333;
                        t.Imacron = 333;
                        t.Lcaron = 611;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 500;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 611;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 500;
                        t.Scommaaccent = 500;
                        t.Ohungarumlaut = 722;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 667;
                        t.ugrave = 500;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 667;
                        t.otilde = 500;
                        t.Rcommaaccent = 611;
                        t.Lcommaaccent = 556;
                        t.Atilde = 611;
                        t.Aogonek = 611;
                        t.Aring = 611;
                        t.Otilde = 722;
                        t.zdotaccent = 389;
                        t.Ecaron = 611;
                        t.Iogonek = 333;
                        t.kcommaaccent = 444;
                        t.minus = 675;
                        t.Icircumflex = 333;
                        t.ncaron = 500;
                        t.tcommaaccent = 278;
                        t.logicalnot = 675;
                        t.odieresis = 500;
                        t.udieresis = 500;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 389;
                        t.ncommaaccent = 500;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t.ZapfDingbats = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.a1 = 974;
                        t.a2 = 961;
                        t.a202 = 974;
                        t.a3 = 980;
                        t.a4 = 719;
                        t.a5 = 789;
                        t.a119 = 790;
                        t.a118 = 791;
                        t.a117 = 690;
                        t.a11 = 960;
                        t.a12 = 939;
                        t.a13 = 549;
                        t.a14 = 855;
                        t.a15 = 911;
                        t.a16 = 933;
                        t.a105 = 911;
                        t.a17 = 945;
                        t.a18 = 974;
                        t.a19 = 755;
                        t.a20 = 846;
                        t.a21 = 762;
                        t.a22 = 761;
                        t.a23 = 571;
                        t.a24 = 677;
                        t.a25 = 763;
                        t.a26 = 760;
                        t.a27 = 759;
                        t.a28 = 754;
                        t.a6 = 494;
                        t.a7 = 552;
                        t.a8 = 537;
                        t.a9 = 577;
                        t.a10 = 692;
                        t.a29 = 786;
                        t.a30 = 788;
                        t.a31 = 788;
                        t.a32 = 790;
                        t.a33 = 793;
                        t.a34 = 794;
                        t.a35 = 816;
                        t.a36 = 823;
                        t.a37 = 789;
                        t.a38 = 841;
                        t.a39 = 823;
                        t.a40 = 833;
                        t.a41 = 816;
                        t.a42 = 831;
                        t.a43 = 923;
                        t.a44 = 744;
                        t.a45 = 723;
                        t.a46 = 749;
                        t.a47 = 790;
                        t.a48 = 792;
                        t.a49 = 695;
                        t.a50 = 776;
                        t.a51 = 768;
                        t.a52 = 792;
                        t.a53 = 759;
                        t.a54 = 707;
                        t.a55 = 708;
                        t.a56 = 682;
                        t.a57 = 701;
                        t.a58 = 826;
                        t.a59 = 815;
                        t.a60 = 789;
                        t.a61 = 789;
                        t.a62 = 707;
                        t.a63 = 687;
                        t.a64 = 696;
                        t.a65 = 689;
                        t.a66 = 786;
                        t.a67 = 787;
                        t.a68 = 713;
                        t.a69 = 791;
                        t.a70 = 785;
                        t.a71 = 791;
                        t.a72 = 873;
                        t.a73 = 761;
                        t.a74 = 762;
                        t.a203 = 762;
                        t.a75 = 759;
                        t.a204 = 759;
                        t.a76 = 892;
                        t.a77 = 892;
                        t.a78 = 788;
                        t.a79 = 784;
                        t.a81 = 438;
                        t.a82 = 138;
                        t.a83 = 277;
                        t.a84 = 415;
                        t.a97 = 392;
                        t.a98 = 392;
                        t.a99 = 668;
                        t.a100 = 668;
                        t.a89 = 390;
                        t.a90 = 390;
                        t.a93 = 317;
                        t.a94 = 317;
                        t.a91 = 276;
                        t.a92 = 276;
                        t.a205 = 509;
                        t.a85 = 509;
                        t.a206 = 410;
                        t.a86 = 410;
                        t.a87 = 234;
                        t.a88 = 234;
                        t.a95 = 334;
                        t.a96 = 334;
                        t.a101 = 732;
                        t.a102 = 544;
                        t.a103 = 544;
                        t.a104 = 910;
                        t.a106 = 667;
                        t.a107 = 760;
                        t.a108 = 760;
                        t.a112 = 776;
                        t.a111 = 595;
                        t.a110 = 694;
                        t.a109 = 626;
                        t.a120 = 788;
                        t.a121 = 788;
                        t.a122 = 788;
                        t.a123 = 788;
                        t.a124 = 788;
                        t.a125 = 788;
                        t.a126 = 788;
                        t.a127 = 788;
                        t.a128 = 788;
                        t.a129 = 788;
                        t.a130 = 788;
                        t.a131 = 788;
                        t.a132 = 788;
                        t.a133 = 788;
                        t.a134 = 788;
                        t.a135 = 788;
                        t.a136 = 788;
                        t.a137 = 788;
                        t.a138 = 788;
                        t.a139 = 788;
                        t.a140 = 788;
                        t.a141 = 788;
                        t.a142 = 788;
                        t.a143 = 788;
                        t.a144 = 788;
                        t.a145 = 788;
                        t.a146 = 788;
                        t.a147 = 788;
                        t.a148 = 788;
                        t.a149 = 788;
                        t.a150 = 788;
                        t.a151 = 788;
                        t.a152 = 788;
                        t.a153 = 788;
                        t.a154 = 788;
                        t.a155 = 788;
                        t.a156 = 788;
                        t.a157 = 788;
                        t.a158 = 788;
                        t.a159 = 788;
                        t.a160 = 894;
                        t.a161 = 838;
                        t.a163 = 1016;
                        t.a164 = 458;
                        t.a196 = 748;
                        t.a165 = 924;
                        t.a192 = 748;
                        t.a166 = 918;
                        t.a167 = 927;
                        t.a168 = 928;
                        t.a169 = 928;
                        t.a170 = 834;
                        t.a171 = 873;
                        t.a172 = 828;
                        t.a173 = 924;
                        t.a162 = 924;
                        t.a174 = 917;
                        t.a175 = 930;
                        t.a176 = 931;
                        t.a177 = 463;
                        t.a178 = 883;
                        t.a179 = 836;
                        t.a193 = 836;
                        t.a180 = 867;
                        t.a199 = 867;
                        t.a181 = 696;
                        t.a200 = 696;
                        t.a182 = 874;
                        t.a201 = 874;
                        t.a183 = 760;
                        t.a184 = 946;
                        t.a197 = 771;
                        t.a185 = 865;
                        t.a194 = 771;
                        t.a198 = 888;
                        t.a186 = 967;
                        t.a195 = 888;
                        t.a187 = 831;
                        t.a188 = 873;
                        t.a189 = 927;
                        t.a190 = 970;
                        t.a191 = 918;
                    });
                });
                exports.getMetrics = getMetrics;
                const getFontBasicMetrics = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Courier = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: -426
                    };
                    t["Courier-Bold"] = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: 439
                    };
                    t["Courier-Oblique"] = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: 426
                    };
                    t["Courier-BoldOblique"] = {
                        ascent: 629,
                        descent: -157,
                        capHeight: 562,
                        xHeight: 426
                    };
                    t.Helvetica = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 523
                    };
                    t["Helvetica-Bold"] = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 532
                    };
                    t["Helvetica-Oblique"] = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 523
                    };
                    t["Helvetica-BoldOblique"] = {
                        ascent: 718,
                        descent: -207,
                        capHeight: 718,
                        xHeight: 532
                    };
                    t["Times-Roman"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 662,
                        xHeight: 450
                    };
                    t["Times-Bold"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 676,
                        xHeight: 461
                    };
                    t["Times-Italic"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 653,
                        xHeight: 441
                    };
                    t["Times-BoldItalic"] = {
                        ascent: 683,
                        descent: -217,
                        capHeight: 669,
                        xHeight: 462
                    };
                    t.Symbol = {
                        ascent: Math.NaN,
                        descent: Math.NaN,
                        capHeight: Math.NaN,
                        xHeight: Math.NaN
                    };
                    t.ZapfDingbats = {
                        ascent: Math.NaN,
                        descent: Math.NaN,
                        capHeight: Math.NaN,
                        xHeight: Math.NaN
                    };
                });
                exports.getFontBasicMetrics = getFontBasicMetrics;
            /***/ },
            /* 46 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlyfTable = void 0;
                const ON_CURVE_POINT = 1;
                const X_SHORT_VECTOR = 2;
                const Y_SHORT_VECTOR = 4;
                const REPEAT_FLAG = 8;
                const X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR = 16;
                const Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR = 32;
                const OVERLAP_SIMPLE = 64;
                const ARG_1_AND_2_ARE_WORDS = 1;
                const ARGS_ARE_XY_VALUES = 2;
                const WE_HAVE_A_SCALE = 8;
                const MORE_COMPONENTS = 32;
                const WE_HAVE_AN_X_AND_Y_SCALE = 64;
                const WE_HAVE_A_TWO_BY_TWO = 128;
                const WE_HAVE_INSTRUCTIONS = 256;
                class GlyfTable {
                    constructor({ glyfTable: glyfTable, isGlyphLocationsLong: isGlyphLocationsLong, locaTable: locaTable, numGlyphs: numGlyphs }){
                        this.glyphs = [];
                        const loca = new DataView(locaTable.buffer, locaTable.byteOffset, locaTable.byteLength);
                        const glyf = new DataView(glyfTable.buffer, glyfTable.byteOffset, glyfTable.byteLength);
                        const offsetSize = isGlyphLocationsLong ? 4 : 2;
                        let prev = isGlyphLocationsLong ? loca.getUint32(0) : 2 * loca.getUint16(0);
                        let pos = 0;
                        for(let i = 0; i < numGlyphs; i++){
                            pos += offsetSize;
                            const next = isGlyphLocationsLong ? loca.getUint32(pos) : 2 * loca.getUint16(pos);
                            if (next === prev) {
                                this.glyphs.push(new Glyph({}));
                                continue;
                            }
                            const glyph = Glyph.parse(prev, glyf);
                            this.glyphs.push(glyph);
                            prev = next;
                        }
                    }
                    getSize() {
                        return this.glyphs.reduce((a, g)=>{
                            const size = g.getSize();
                            return a + (size + 3 & -4);
                        }, 0);
                    }
                    write() {
                        const totalSize = this.getSize();
                        const glyfTable = new DataView(new ArrayBuffer(totalSize));
                        const isLocationLong = totalSize > 0x1fffe;
                        const offsetSize = isLocationLong ? 4 : 2;
                        const locaTable = new DataView(new ArrayBuffer((this.glyphs.length + 1) * offsetSize));
                        if (isLocationLong) locaTable.setUint32(0, 0);
                        else locaTable.setUint16(0, 0);
                        let pos = 0;
                        let locaIndex = 0;
                        for (const glyph of this.glyphs){
                            pos += glyph.write(pos, glyfTable);
                            pos = pos + 3 & -4;
                            locaIndex += offsetSize;
                            if (isLocationLong) locaTable.setUint32(locaIndex, pos);
                            else locaTable.setUint16(locaIndex, pos >> 1);
                        }
                        return {
                            isLocationLong: isLocationLong,
                            loca: new Uint8Array(locaTable.buffer),
                            glyf: new Uint8Array(glyfTable.buffer)
                        };
                    }
                    scale(factors) {
                        for(let i = 0, ii = this.glyphs.length; i < ii; i++)this.glyphs[i].scale(factors[i]);
                    }
                }
                exports.GlyfTable = GlyfTable;
                class Glyph {
                    constructor({ header: header = null, simple: simple = null, composites: composites = null }){
                        this.header = header;
                        this.simple = simple;
                        this.composites = composites;
                    }
                    static parse(pos, glyf) {
                        const [read, header] = GlyphHeader.parse(pos, glyf);
                        pos += read;
                        if (header.numberOfContours < 0) {
                            const composites = [];
                            while(true){
                                const [n, composite] = CompositeGlyph.parse(pos, glyf);
                                pos += n;
                                composites.push(composite);
                                if (!(composite.flags & MORE_COMPONENTS)) break;
                            }
                            return new Glyph({
                                header: header,
                                composites: composites
                            });
                        }
                        const simple = SimpleGlyph.parse(pos, glyf, header.numberOfContours);
                        return new Glyph({
                            header: header,
                            simple: simple
                        });
                    }
                    getSize() {
                        if (!this.header) return 0;
                        const size = this.simple ? this.simple.getSize() : this.composites.reduce((a, c)=>a + c.getSize(), 0);
                        return this.header.getSize() + size;
                    }
                    write(pos, buf) {
                        if (!this.header) return 0;
                        const spos = pos;
                        pos += this.header.write(pos, buf);
                        if (this.simple) pos += this.simple.write(pos, buf);
                        else for (const composite of this.composites)pos += composite.write(pos, buf);
                        return pos - spos;
                    }
                    scale(factor) {
                        if (!this.header) return;
                        const xMiddle = (this.header.xMin + this.header.xMax) / 2;
                        this.header.scale(xMiddle, factor);
                        if (this.simple) this.simple.scale(xMiddle, factor);
                        else for (const composite of this.composites)composite.scale(xMiddle, factor);
                    }
                }
                class GlyphHeader {
                    constructor({ numberOfContours: numberOfContours, xMin: xMin, yMin: yMin, xMax: xMax, yMax: yMax }){
                        this.numberOfContours = numberOfContours;
                        this.xMin = xMin;
                        this.yMin = yMin;
                        this.xMax = xMax;
                        this.yMax = yMax;
                    }
                    static parse(pos, glyf) {
                        return [
                            10,
                            new GlyphHeader({
                                numberOfContours: glyf.getInt16(pos),
                                xMin: glyf.getInt16(pos + 2),
                                yMin: glyf.getInt16(pos + 4),
                                xMax: glyf.getInt16(pos + 6),
                                yMax: glyf.getInt16(pos + 8)
                            })
                        ];
                    }
                    getSize() {
                        return 10;
                    }
                    write(pos, buf) {
                        buf.setInt16(pos, this.numberOfContours);
                        buf.setInt16(pos + 2, this.xMin);
                        buf.setInt16(pos + 4, this.yMin);
                        buf.setInt16(pos + 6, this.xMax);
                        buf.setInt16(pos + 8, this.yMax);
                        return 10;
                    }
                    scale(x, factor) {
                        this.xMin = Math.round(x + (this.xMin - x) * factor);
                        this.xMax = Math.round(x + (this.xMax - x) * factor);
                    }
                }
                class Contour {
                    constructor({ flags: flags, xCoordinates: xCoordinates, yCoordinates: yCoordinates }){
                        this.xCoordinates = xCoordinates;
                        this.yCoordinates = yCoordinates;
                        this.flags = flags;
                    }
                }
                class SimpleGlyph {
                    constructor({ contours: contours, instructions: instructions }){
                        this.contours = contours;
                        this.instructions = instructions;
                    }
                    static parse(pos, glyf, numberOfContours) {
                        const endPtsOfContours = [];
                        for(let i = 0; i < numberOfContours; i++){
                            const endPt = glyf.getUint16(pos);
                            pos += 2;
                            endPtsOfContours.push(endPt);
                        }
                        const numberOfPt = endPtsOfContours[numberOfContours - 1] + 1;
                        const instructionLength = glyf.getUint16(pos);
                        pos += 2;
                        const instructions = new Uint8Array(glyf).slice(pos, pos + instructionLength);
                        pos += instructionLength;
                        const flags = [];
                        for(let i = 0; i < numberOfPt; pos++, i++){
                            let flag = glyf.getUint8(pos);
                            flags.push(flag);
                            if (flag & REPEAT_FLAG) {
                                const count = glyf.getUint8(++pos);
                                flag ^= REPEAT_FLAG;
                                for(let m = 0; m < count; m++)flags.push(flag);
                                i += count;
                            }
                        }
                        const allXCoordinates = [];
                        let xCoordinates = [];
                        let yCoordinates = [];
                        let pointFlags = [];
                        const contours = [];
                        let endPtsOfContoursIndex = 0;
                        let lastCoordinate = 0;
                        for(let i = 0; i < numberOfPt; i++){
                            const flag = flags[i];
                            if (flag & X_SHORT_VECTOR) {
                                const x = glyf.getUint8(pos++);
                                lastCoordinate += flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR ? x : -x;
                                xCoordinates.push(lastCoordinate);
                            } else if (flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR) xCoordinates.push(lastCoordinate);
                            else {
                                lastCoordinate += glyf.getInt16(pos);
                                pos += 2;
                                xCoordinates.push(lastCoordinate);
                            }
                            if (endPtsOfContours[endPtsOfContoursIndex] === i) {
                                endPtsOfContoursIndex++;
                                allXCoordinates.push(xCoordinates);
                                xCoordinates = [];
                            }
                        }
                        lastCoordinate = 0;
                        endPtsOfContoursIndex = 0;
                        for(let i = 0; i < numberOfPt; i++){
                            const flag = flags[i];
                            if (flag & Y_SHORT_VECTOR) {
                                const y = glyf.getUint8(pos++);
                                lastCoordinate += flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR ? y : -y;
                                yCoordinates.push(lastCoordinate);
                            } else if (flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR) yCoordinates.push(lastCoordinate);
                            else {
                                lastCoordinate += glyf.getInt16(pos);
                                pos += 2;
                                yCoordinates.push(lastCoordinate);
                            }
                            pointFlags.push(flag & ON_CURVE_POINT | flag & OVERLAP_SIMPLE);
                            if (endPtsOfContours[endPtsOfContoursIndex] === i) {
                                xCoordinates = allXCoordinates[endPtsOfContoursIndex];
                                endPtsOfContoursIndex++;
                                contours.push(new Contour({
                                    flags: pointFlags,
                                    xCoordinates: xCoordinates,
                                    yCoordinates: yCoordinates
                                }));
                                yCoordinates = [];
                                pointFlags = [];
                            }
                        }
                        return new SimpleGlyph({
                            contours: contours,
                            instructions: instructions
                        });
                    }
                    getSize() {
                        let size = this.contours.length * 2 + 2 + this.instructions.length;
                        let lastX = 0;
                        let lastY = 0;
                        for (const contour of this.contours){
                            size += contour.flags.length;
                            for(let i = 0, ii = contour.xCoordinates.length; i < ii; i++){
                                const x = contour.xCoordinates[i];
                                const y = contour.yCoordinates[i];
                                let abs = Math.abs(x - lastX);
                                if (abs > 255) size += 2;
                                else if (abs > 0) size += 1;
                                lastX = x;
                                abs = Math.abs(y - lastY);
                                if (abs > 255) size += 2;
                                else if (abs > 0) size += 1;
                                lastY = y;
                            }
                        }
                        return size;
                    }
                    write(pos, buf) {
                        const spos = pos;
                        const xCoordinates = [];
                        const yCoordinates = [];
                        const flags = [];
                        let lastX = 0;
                        let lastY = 0;
                        for (const contour of this.contours){
                            for(let i = 0, ii = contour.xCoordinates.length; i < ii; i++){
                                let flag = contour.flags[i];
                                const x = contour.xCoordinates[i];
                                let delta = x - lastX;
                                if (delta === 0) {
                                    flag |= X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR;
                                    xCoordinates.push(0);
                                } else {
                                    const abs = Math.abs(delta);
                                    if (abs <= 255) {
                                        flag |= delta >= 0 ? X_SHORT_VECTOR | X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR : X_SHORT_VECTOR;
                                        xCoordinates.push(abs);
                                    } else xCoordinates.push(delta);
                                }
                                lastX = x;
                                const y = contour.yCoordinates[i];
                                delta = y - lastY;
                                if (delta === 0) {
                                    flag |= Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR;
                                    yCoordinates.push(0);
                                } else {
                                    const abs = Math.abs(delta);
                                    if (abs <= 255) {
                                        flag |= delta >= 0 ? Y_SHORT_VECTOR | Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR : Y_SHORT_VECTOR;
                                        yCoordinates.push(abs);
                                    } else yCoordinates.push(delta);
                                }
                                lastY = y;
                                flags.push(flag);
                            }
                            buf.setUint16(pos, xCoordinates.length - 1);
                            pos += 2;
                        }
                        buf.setUint16(pos, this.instructions.length);
                        pos += 2;
                        if (this.instructions.length) {
                            new Uint8Array(buf.buffer, 0, buf.buffer.byteLength).set(this.instructions, pos);
                            pos += this.instructions.length;
                        }
                        for (const flag of flags)buf.setUint8(pos++, flag);
                        for(let i = 0, ii = xCoordinates.length; i < ii; i++){
                            const x = xCoordinates[i];
                            const flag = flags[i];
                            if (flag & X_SHORT_VECTOR) buf.setUint8(pos++, x);
                            else if (!(flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR)) {
                                buf.setInt16(pos, x);
                                pos += 2;
                            }
                        }
                        for(let i = 0, ii = yCoordinates.length; i < ii; i++){
                            const y = yCoordinates[i];
                            const flag = flags[i];
                            if (flag & Y_SHORT_VECTOR) buf.setUint8(pos++, y);
                            else if (!(flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR)) {
                                buf.setInt16(pos, y);
                                pos += 2;
                            }
                        }
                        return pos - spos;
                    }
                    scale(x, factor) {
                        for (const contour of this.contours){
                            if (contour.xCoordinates.length === 0) continue;
                            for(let i = 0, ii = contour.xCoordinates.length; i < ii; i++)contour.xCoordinates[i] = Math.round(x + (contour.xCoordinates[i] - x) * factor);
                        }
                    }
                }
                class CompositeGlyph {
                    constructor({ flags: flags, glyphIndex: glyphIndex, argument1: argument1, argument2: argument2, transf: transf, instructions: instructions }){
                        this.flags = flags;
                        this.glyphIndex = glyphIndex;
                        this.argument1 = argument1;
                        this.argument2 = argument2;
                        this.transf = transf;
                        this.instructions = instructions;
                    }
                    static parse(pos, glyf) {
                        const spos = pos;
                        const transf = [];
                        let flags = glyf.getUint16(pos);
                        const glyphIndex = glyf.getUint16(pos + 2);
                        pos += 4;
                        let argument1, argument2;
                        if (flags & ARG_1_AND_2_ARE_WORDS) {
                            if (flags & ARGS_ARE_XY_VALUES) {
                                argument1 = glyf.getInt16(pos);
                                argument2 = glyf.getInt16(pos + 2);
                            } else {
                                argument1 = glyf.getUint16(pos);
                                argument2 = glyf.getUint16(pos + 2);
                            }
                            pos += 4;
                            flags ^= ARG_1_AND_2_ARE_WORDS;
                        } else {
                            if (flags & ARGS_ARE_XY_VALUES) {
                                argument1 = glyf.getInt8(pos);
                                argument2 = glyf.getInt8(pos + 1);
                            } else {
                                argument1 = glyf.getUint8(pos);
                                argument2 = glyf.getUint8(pos + 1);
                            }
                            pos += 2;
                        }
                        if (flags & WE_HAVE_A_SCALE) {
                            transf.push(glyf.getUint16(pos));
                            pos += 2;
                        } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                            transf.push(glyf.getUint16(pos), glyf.getUint16(pos + 2));
                            pos += 4;
                        } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                            transf.push(glyf.getUint16(pos), glyf.getUint16(pos + 2), glyf.getUint16(pos + 4), glyf.getUint16(pos + 6));
                            pos += 8;
                        }
                        let instructions = null;
                        if (flags & WE_HAVE_INSTRUCTIONS) {
                            const instructionLength = glyf.getUint16(pos);
                            pos += 2;
                            instructions = new Uint8Array(glyf).slice(pos, pos + instructionLength);
                            pos += instructionLength;
                        }
                        return [
                            pos - spos,
                            new CompositeGlyph({
                                flags: flags,
                                glyphIndex: glyphIndex,
                                argument1: argument1,
                                argument2: argument2,
                                transf: transf,
                                instructions: instructions
                            })
                        ];
                    }
                    getSize() {
                        let size = 4 + this.transf.length * 2;
                        if (this.flags & WE_HAVE_INSTRUCTIONS) size += 2 + this.instructions.length;
                        size += 2;
                        if (this.flags & 2) {
                            if (!(this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127)) size += 2;
                        } else if (!(this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255)) size += 2;
                        return size;
                    }
                    write(pos, buf) {
                        const spos = pos;
                        if (this.flags & ARGS_ARE_XY_VALUES) {
                            if (!(this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127)) this.flags |= ARG_1_AND_2_ARE_WORDS;
                        } else if (!(this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255)) this.flags |= ARG_1_AND_2_ARE_WORDS;
                        buf.setUint16(pos, this.flags);
                        buf.setUint16(pos + 2, this.glyphIndex);
                        pos += 4;
                        if (this.flags & ARG_1_AND_2_ARE_WORDS) {
                            if (this.flags & ARGS_ARE_XY_VALUES) {
                                buf.setInt16(pos, this.argument1);
                                buf.setInt16(pos + 2, this.argument2);
                            } else {
                                buf.setUint16(pos, this.argument1);
                                buf.setUint16(pos + 2, this.argument2);
                            }
                            pos += 4;
                        } else {
                            buf.setUint8(pos, this.argument1);
                            buf.setUint8(pos + 1, this.argument2);
                            pos += 2;
                        }
                        if (this.flags & WE_HAVE_INSTRUCTIONS) {
                            buf.setUint16(pos, this.instructions.length);
                            pos += 2;
                            if (this.instructions.length) {
                                new Uint8Array(buf.buffer, 0, buf.buffer.byteLength).set(this.instructions, pos);
                                pos += this.instructions.length;
                            }
                        }
                        return pos - spos;
                    }
                    scale(x, factor) {}
                }
            /***/ },
            /* 47 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OpenTypeFileBuilder = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                function writeInt16(dest, offset, num) {
                    dest[offset] = num >> 8 & 0xff;
                    dest[offset + 1] = num & 0xff;
                }
                function writeInt32(dest, offset, num) {
                    dest[offset] = num >> 24 & 0xff;
                    dest[offset + 1] = num >> 16 & 0xff;
                    dest[offset + 2] = num >> 8 & 0xff;
                    dest[offset + 3] = num & 0xff;
                }
                function writeData(dest, offset, data) {
                    if (data instanceof Uint8Array) dest.set(data, offset);
                    else if (typeof data === "string") for(let i = 0, ii = data.length; i < ii; i++)dest[offset++] = data.charCodeAt(i) & 0xff;
                    else for (const num of data)dest[offset++] = num & 0xff;
                }
                const OTF_HEADER_SIZE = 12;
                const OTF_TABLE_ENTRY_SIZE = 16;
                class OpenTypeFileBuilder {
                    constructor(sfnt){
                        this.sfnt = sfnt;
                        this.tables = Object.create(null);
                    }
                    static getSearchParams(entriesCount, entrySize) {
                        let maxPower2 = 1, log2 = 0;
                        while((maxPower2 ^ entriesCount) > maxPower2){
                            maxPower2 <<= 1;
                            log2++;
                        }
                        const searchRange = maxPower2 * entrySize;
                        return {
                            range: searchRange,
                            entry: log2,
                            rangeShift: entrySize * entriesCount - searchRange
                        };
                    }
                    toArray() {
                        let sfnt = this.sfnt;
                        const tables = this.tables;
                        const tablesNames = Object.keys(tables);
                        tablesNames.sort();
                        const numTables = tablesNames.length;
                        let i, j, jj, table, tableName;
                        let offset = OTF_HEADER_SIZE + numTables * OTF_TABLE_ENTRY_SIZE;
                        const tableOffsets = [
                            offset
                        ];
                        for(i = 0; i < numTables; i++){
                            table = tables[tablesNames[i]];
                            const paddedLength = (table.length + 3 & -4) >>> 0;
                            offset += paddedLength;
                            tableOffsets.push(offset);
                        }
                        const file = new Uint8Array(offset);
                        for(i = 0; i < numTables; i++){
                            table = tables[tablesNames[i]];
                            writeData(file, tableOffsets[i], table);
                        }
                        if (sfnt === "true") sfnt = (0, _util.string32)(0x00010000);
                        file[0] = sfnt.charCodeAt(0) & 0xff;
                        file[1] = sfnt.charCodeAt(1) & 0xff;
                        file[2] = sfnt.charCodeAt(2) & 0xff;
                        file[3] = sfnt.charCodeAt(3) & 0xff;
                        writeInt16(file, 4, numTables);
                        const searchParams = OpenTypeFileBuilder.getSearchParams(numTables, 16);
                        writeInt16(file, 6, searchParams.range);
                        writeInt16(file, 8, searchParams.entry);
                        writeInt16(file, 10, searchParams.rangeShift);
                        offset = OTF_HEADER_SIZE;
                        for(i = 0; i < numTables; i++){
                            tableName = tablesNames[i];
                            file[offset] = tableName.charCodeAt(0) & 0xff;
                            file[offset + 1] = tableName.charCodeAt(1) & 0xff;
                            file[offset + 2] = tableName.charCodeAt(2) & 0xff;
                            file[offset + 3] = tableName.charCodeAt(3) & 0xff;
                            let checksum = 0;
                            for(j = tableOffsets[i], jj = tableOffsets[i + 1]; j < jj; j += 4){
                                const quad = (0, _core_utils.readUint32)(file, j);
                                checksum = checksum + quad >>> 0;
                            }
                            writeInt32(file, offset + 4, checksum);
                            writeInt32(file, offset + 8, tableOffsets[i]);
                            writeInt32(file, offset + 12, tables[tableName].length);
                            offset += OTF_TABLE_ENTRY_SIZE;
                        }
                        return file;
                    }
                    addTable(tag, data) {
                        if (tag in this.tables) throw new Error("Table " + tag + " already exists");
                        this.tables[tag] = data;
                    }
                }
                exports.OpenTypeFileBuilder = OpenTypeFileBuilder;
            /***/ },
            /* 48 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Type1Font = void 0;
                var _cff_parser = __w_pdfjs_require__(35);
                var _util = __w_pdfjs_require__(2);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                var _type1_parser = __w_pdfjs_require__(49);
                function findBlock(streamBytes, signature, startIndex) {
                    const streamBytesLength = streamBytes.length;
                    const signatureLength = signature.length;
                    const scanLength = streamBytesLength - signatureLength;
                    let i = startIndex, found = false;
                    while(i < scanLength){
                        let j = 0;
                        while(j < signatureLength && streamBytes[i + j] === signature[j])j++;
                        if (j >= signatureLength) {
                            i += j;
                            while(i < streamBytesLength && (0, _core_utils.isWhiteSpace)(streamBytes[i]))i++;
                            found = true;
                            break;
                        }
                        i++;
                    }
                    return {
                        found: found,
                        length: i
                    };
                }
                function getHeaderBlock(stream, suggestedLength) {
                    const EEXEC_SIGNATURE = [
                        0x65,
                        0x65,
                        0x78,
                        0x65,
                        0x63
                    ];
                    const streamStartPos = stream.pos;
                    let headerBytes, headerBytesLength, block;
                    try {
                        headerBytes = stream.getBytes(suggestedLength);
                        headerBytesLength = headerBytes.length;
                    } catch  {}
                    if (headerBytesLength === suggestedLength) {
                        block = findBlock(headerBytes, EEXEC_SIGNATURE, suggestedLength - 2 * EEXEC_SIGNATURE.length);
                        if (block.found && block.length === suggestedLength) return {
                            stream: new _stream.Stream(headerBytes),
                            length: suggestedLength
                        };
                    }
                    (0, _util.warn)('Invalid "Length1" property in Type1 font -- trying to recover.');
                    stream.pos = streamStartPos;
                    const SCAN_BLOCK_LENGTH = 2048;
                    let actualLength;
                    while(true){
                        const scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
                        block = findBlock(scanBytes, EEXEC_SIGNATURE, 0);
                        if (block.length === 0) break;
                        stream.pos += block.length;
                        if (block.found) {
                            actualLength = stream.pos - streamStartPos;
                            break;
                        }
                    }
                    stream.pos = streamStartPos;
                    if (actualLength) return {
                        stream: new _stream.Stream(stream.getBytes(actualLength)),
                        length: actualLength
                    };
                    (0, _util.warn)('Unable to recover "Length1" property in Type1 font -- using as is.');
                    return {
                        stream: new _stream.Stream(stream.getBytes(suggestedLength)),
                        length: suggestedLength
                    };
                }
                function getEexecBlock(stream, suggestedLength) {
                    const eexecBytes = stream.getBytes();
                    if (eexecBytes.length === 0) throw new _util.FormatError("getEexecBlock - no font program found.");
                    return {
                        stream: new _stream.Stream(eexecBytes),
                        length: eexecBytes.length
                    };
                }
                class Type1Font {
                    constructor(name, file, properties){
                        const PFB_HEADER_SIZE = 6;
                        let headerBlockLength = properties.length1;
                        let eexecBlockLength = properties.length2;
                        let pfbHeader = file.peekBytes(PFB_HEADER_SIZE);
                        const pfbHeaderPresent = pfbHeader[0] === 0x80 && pfbHeader[1] === 0x01;
                        if (pfbHeaderPresent) {
                            file.skip(PFB_HEADER_SIZE);
                            headerBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
                        }
                        const headerBlock = getHeaderBlock(file, headerBlockLength);
                        const headerBlockParser = new _type1_parser.Type1Parser(headerBlock.stream, false, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        headerBlockParser.extractFontHeader(properties);
                        if (pfbHeaderPresent) {
                            pfbHeader = file.getBytes(PFB_HEADER_SIZE);
                            eexecBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
                        }
                        const eexecBlock = getEexecBlock(file, eexecBlockLength);
                        const eexecBlockParser = new _type1_parser.Type1Parser(eexecBlock.stream, true, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        const data = eexecBlockParser.extractFontProgram(properties);
                        for(const key in data.properties)properties[key] = data.properties[key];
                        const charstrings = data.charstrings;
                        const type2Charstrings = this.getType2Charstrings(charstrings);
                        const subrs = this.getType2Subrs(data.subrs);
                        this.charstrings = charstrings;
                        this.data = this.wrap(name, type2Charstrings, this.charstrings, subrs, properties);
                        this.seacs = this.getSeacs(data.charstrings);
                    }
                    get numGlyphs() {
                        return this.charstrings.length + 1;
                    }
                    getCharset() {
                        const charset = [
                            ".notdef"
                        ];
                        for (const { glyphName: glyphName } of this.charstrings)charset.push(glyphName);
                        return charset;
                    }
                    getGlyphMapping(properties) {
                        const charstrings = this.charstrings;
                        if (properties.composite) {
                            const charCodeToGlyphId = Object.create(null);
                            for(let glyphId = 0, charstringsLen = charstrings.length; glyphId < charstringsLen; glyphId++){
                                const charCode = properties.cMap.charCodeOf(glyphId);
                                charCodeToGlyphId[charCode] = glyphId + 1;
                            }
                            return charCodeToGlyphId;
                        }
                        const glyphNames = [
                            ".notdef"
                        ];
                        let builtInEncoding, glyphId;
                        for(glyphId = 0; glyphId < charstrings.length; glyphId++)glyphNames.push(charstrings[glyphId].glyphName);
                        const encoding = properties.builtInEncoding;
                        if (encoding) {
                            builtInEncoding = Object.create(null);
                            for(const charCode in encoding){
                                glyphId = glyphNames.indexOf(encoding[charCode]);
                                if (glyphId >= 0) builtInEncoding[charCode] = glyphId;
                            }
                        }
                        return (0, _fonts_utils.type1FontGlyphMapping)(properties, builtInEncoding, glyphNames);
                    }
                    hasGlyphId(id) {
                        if (id < 0 || id >= this.numGlyphs) return false;
                        if (id === 0) return true;
                        const glyph = this.charstrings[id - 1];
                        return glyph.charstring.length > 0;
                    }
                    getSeacs(charstrings) {
                        const seacMap = [];
                        for(let i = 0, ii = charstrings.length; i < ii; i++){
                            const charstring = charstrings[i];
                            if (charstring.seac) seacMap[i + 1] = charstring.seac;
                        }
                        return seacMap;
                    }
                    getType2Charstrings(type1Charstrings) {
                        const type2Charstrings = [];
                        for (const type1Charstring of type1Charstrings)type2Charstrings.push(type1Charstring.charstring);
                        return type2Charstrings;
                    }
                    getType2Subrs(type1Subrs) {
                        let bias = 0;
                        const count = type1Subrs.length;
                        if (count < 1133) bias = 107;
                        else if (count < 33769) bias = 1131;
                        else bias = 32768;
                        const type2Subrs = [];
                        let i;
                        for(i = 0; i < bias; i++)type2Subrs.push([
                            0x0b
                        ]);
                        for(i = 0; i < count; i++)type2Subrs.push(type1Subrs[i]);
                        return type2Subrs;
                    }
                    wrap(name, glyphs, charstrings, subrs, properties) {
                        const cff = new _cff_parser.CFF();
                        cff.header = new _cff_parser.CFFHeader(1, 0, 4, 4);
                        cff.names = [
                            name
                        ];
                        const topDict = new _cff_parser.CFFTopDict();
                        topDict.setByName("version", 391);
                        topDict.setByName("Notice", 392);
                        topDict.setByName("FullName", 393);
                        topDict.setByName("FamilyName", 394);
                        topDict.setByName("Weight", 395);
                        topDict.setByName("Encoding", null);
                        topDict.setByName("FontMatrix", properties.fontMatrix);
                        topDict.setByName("FontBBox", properties.bbox);
                        topDict.setByName("charset", null);
                        topDict.setByName("CharStrings", null);
                        topDict.setByName("Private", null);
                        cff.topDict = topDict;
                        const strings = new _cff_parser.CFFStrings();
                        strings.add("Version 0.11");
                        strings.add("See original notice");
                        strings.add(name);
                        strings.add(name);
                        strings.add("Medium");
                        cff.strings = strings;
                        cff.globalSubrIndex = new _cff_parser.CFFIndex();
                        const count = glyphs.length;
                        const charsetArray = [
                            ".notdef"
                        ];
                        let i, ii;
                        for(i = 0; i < count; i++){
                            const glyphName = charstrings[i].glyphName;
                            const index = _cff_parser.CFFStandardStrings.indexOf(glyphName);
                            if (index === -1) strings.add(glyphName);
                            charsetArray.push(glyphName);
                        }
                        cff.charset = new _cff_parser.CFFCharset(false, 0, charsetArray);
                        const charStringsIndex = new _cff_parser.CFFIndex();
                        charStringsIndex.add([
                            0x8b,
                            0x0e
                        ]);
                        for(i = 0; i < count; i++)charStringsIndex.add(glyphs[i]);
                        cff.charStrings = charStringsIndex;
                        const privateDict = new _cff_parser.CFFPrivateDict();
                        privateDict.setByName("Subrs", null);
                        const fields = [
                            "BlueValues",
                            "OtherBlues",
                            "FamilyBlues",
                            "FamilyOtherBlues",
                            "StemSnapH",
                            "StemSnapV",
                            "BlueShift",
                            "BlueFuzz",
                            "BlueScale",
                            "LanguageGroup",
                            "ExpansionFactor",
                            "ForceBold",
                            "StdHW",
                            "StdVW"
                        ];
                        for(i = 0, ii = fields.length; i < ii; i++){
                            const field = fields[i];
                            if (!(field in properties.privateData)) continue;
                            const value = properties.privateData[field];
                            if (Array.isArray(value)) for(let j = value.length - 1; j > 0; j--)value[j] -= value[j - 1];
                            privateDict.setByName(field, value);
                        }
                        cff.topDict.privateDict = privateDict;
                        const subrIndex = new _cff_parser.CFFIndex();
                        for(i = 0, ii = subrs.length; i < ii; i++)subrIndex.add(subrs[i]);
                        privateDict.subrsIndex = subrIndex;
                        const compiler = new _cff_parser.CFFCompiler(cff);
                        return compiler.compile();
                    }
                }
                exports.Type1Font = Type1Font;
            /***/ },
            /* 49 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Type1Parser = void 0;
                var _encodings = __w_pdfjs_require__(37);
                var _core_utils = __w_pdfjs_require__(3);
                var _stream = __w_pdfjs_require__(8);
                var _util = __w_pdfjs_require__(2);
                const HINTING_ENABLED = false;
                const COMMAND_MAP = {
                    hstem: [
                        1
                    ],
                    vstem: [
                        3
                    ],
                    vmoveto: [
                        4
                    ],
                    rlineto: [
                        5
                    ],
                    hlineto: [
                        6
                    ],
                    vlineto: [
                        7
                    ],
                    rrcurveto: [
                        8
                    ],
                    callsubr: [
                        10
                    ],
                    flex: [
                        12,
                        35
                    ],
                    drop: [
                        12,
                        18
                    ],
                    endchar: [
                        14
                    ],
                    rmoveto: [
                        21
                    ],
                    hmoveto: [
                        22
                    ],
                    vhcurveto: [
                        30
                    ],
                    hvcurveto: [
                        31
                    ]
                };
                class Type1CharString {
                    constructor(){
                        this.width = 0;
                        this.lsb = 0;
                        this.flexing = false;
                        this.output = [];
                        this.stack = [];
                    }
                    convert(encoded, subrs, seacAnalysisEnabled) {
                        const count = encoded.length;
                        let error = false;
                        let wx, sbx, subrNumber;
                        for(let i = 0; i < count; i++){
                            let value = encoded[i];
                            if (value < 32) {
                                if (value === 12) value = (value << 8) + encoded[++i];
                                switch(value){
                                    case 1:
                                        if (!HINTING_ENABLED) {
                                            this.stack = [];
                                            break;
                                        }
                                        error = this.executeCommand(2, COMMAND_MAP.hstem);
                                        break;
                                    case 3:
                                        if (!HINTING_ENABLED) {
                                            this.stack = [];
                                            break;
                                        }
                                        error = this.executeCommand(2, COMMAND_MAP.vstem);
                                        break;
                                    case 4:
                                        if (this.flexing) {
                                            if (this.stack.length < 1) {
                                                error = true;
                                                break;
                                            }
                                            const dy = this.stack.pop();
                                            this.stack.push(0, dy);
                                            break;
                                        }
                                        error = this.executeCommand(1, COMMAND_MAP.vmoveto);
                                        break;
                                    case 5:
                                        error = this.executeCommand(2, COMMAND_MAP.rlineto);
                                        break;
                                    case 6:
                                        error = this.executeCommand(1, COMMAND_MAP.hlineto);
                                        break;
                                    case 7:
                                        error = this.executeCommand(1, COMMAND_MAP.vlineto);
                                        break;
                                    case 8:
                                        error = this.executeCommand(6, COMMAND_MAP.rrcurveto);
                                        break;
                                    case 9:
                                        this.stack = [];
                                        break;
                                    case 10:
                                        if (this.stack.length < 1) {
                                            error = true;
                                            break;
                                        }
                                        subrNumber = this.stack.pop();
                                        if (!subrs[subrNumber]) {
                                            error = true;
                                            break;
                                        }
                                        error = this.convert(subrs[subrNumber], subrs, seacAnalysisEnabled);
                                        break;
                                    case 11:
                                        return error;
                                    case 13:
                                        if (this.stack.length < 2) {
                                            error = true;
                                            break;
                                        }
                                        wx = this.stack.pop();
                                        sbx = this.stack.pop();
                                        this.lsb = sbx;
                                        this.width = wx;
                                        this.stack.push(wx, sbx);
                                        error = this.executeCommand(2, COMMAND_MAP.hmoveto);
                                        break;
                                    case 14:
                                        this.output.push(COMMAND_MAP.endchar[0]);
                                        break;
                                    case 21:
                                        if (this.flexing) break;
                                        error = this.executeCommand(2, COMMAND_MAP.rmoveto);
                                        break;
                                    case 22:
                                        if (this.flexing) {
                                            this.stack.push(0);
                                            break;
                                        }
                                        error = this.executeCommand(1, COMMAND_MAP.hmoveto);
                                        break;
                                    case 30:
                                        error = this.executeCommand(4, COMMAND_MAP.vhcurveto);
                                        break;
                                    case 31:
                                        error = this.executeCommand(4, COMMAND_MAP.hvcurveto);
                                        break;
                                    case 3072:
                                        this.stack = [];
                                        break;
                                    case 3073:
                                        if (!HINTING_ENABLED) {
                                            this.stack = [];
                                            break;
                                        }
                                        error = this.executeCommand(2, COMMAND_MAP.vstem);
                                        break;
                                    case 3074:
                                        if (!HINTING_ENABLED) {
                                            this.stack = [];
                                            break;
                                        }
                                        error = this.executeCommand(2, COMMAND_MAP.hstem);
                                        break;
                                    case 3078:
                                        if (seacAnalysisEnabled) {
                                            const asb = this.stack.at(-5);
                                            this.seac = this.stack.splice(-4, 4);
                                            this.seac[0] += this.lsb - asb;
                                            error = this.executeCommand(0, COMMAND_MAP.endchar);
                                        } else error = this.executeCommand(4, COMMAND_MAP.endchar);
                                        break;
                                    case 3079:
                                        if (this.stack.length < 4) {
                                            error = true;
                                            break;
                                        }
                                        this.stack.pop();
                                        wx = this.stack.pop();
                                        const sby = this.stack.pop();
                                        sbx = this.stack.pop();
                                        this.lsb = sbx;
                                        this.width = wx;
                                        this.stack.push(wx, sbx, sby);
                                        error = this.executeCommand(3, COMMAND_MAP.rmoveto);
                                        break;
                                    case 3084:
                                        if (this.stack.length < 2) {
                                            error = true;
                                            break;
                                        }
                                        const num2 = this.stack.pop();
                                        const num1 = this.stack.pop();
                                        this.stack.push(num1 / num2);
                                        break;
                                    case 3088:
                                        if (this.stack.length < 2) {
                                            error = true;
                                            break;
                                        }
                                        subrNumber = this.stack.pop();
                                        const numArgs = this.stack.pop();
                                        if (subrNumber === 0 && numArgs === 3) {
                                            const flexArgs = this.stack.splice(-17, 17);
                                            this.stack.push(flexArgs[2] + flexArgs[0], flexArgs[3] + flexArgs[1], flexArgs[4], flexArgs[5], flexArgs[6], flexArgs[7], flexArgs[8], flexArgs[9], flexArgs[10], flexArgs[11], flexArgs[12], flexArgs[13], flexArgs[14]);
                                            error = this.executeCommand(13, COMMAND_MAP.flex, true);
                                            this.flexing = false;
                                            this.stack.push(flexArgs[15], flexArgs[16]);
                                        } else if (subrNumber === 1 && numArgs === 0) this.flexing = true;
                                        break;
                                    case 3089:
                                        break;
                                    case 3105:
                                        this.stack = [];
                                        break;
                                    default:
                                        (0, _util.warn)('Unknown type 1 charstring command of "' + value + '"');
                                        break;
                                }
                                if (error) break;
                                continue;
                            } else if (value <= 246) value -= 139;
                            else if (value <= 250) value = (value - 247) * 256 + encoded[++i] + 108;
                            else if (value <= 254) value = -((value - 251) * 256) - encoded[++i] - 108;
                            else value = (encoded[++i] & 0xff) << 24 | (encoded[++i] & 0xff) << 16 | (encoded[++i] & 0xff) << 8 | (encoded[++i] & 0xff) << 0;
                            this.stack.push(value);
                        }
                        return error;
                    }
                    executeCommand(howManyArgs, command, keepStack) {
                        const stackLength = this.stack.length;
                        if (howManyArgs > stackLength) return true;
                        const start = stackLength - howManyArgs;
                        for(let i = start; i < stackLength; i++){
                            let value = this.stack[i];
                            if (Number.isInteger(value)) this.output.push(28, value >> 8 & 0xff, value & 0xff);
                            else {
                                value = 65536 * value | 0;
                                this.output.push(255, value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                            }
                        }
                        this.output.push(...command);
                        if (keepStack) this.stack.splice(start, howManyArgs);
                        else this.stack.length = 0;
                        return false;
                    }
                }
                const EEXEC_ENCRYPT_KEY = 55665;
                const CHAR_STRS_ENCRYPT_KEY = 4330;
                function isHexDigit(code) {
                    return code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102;
                }
                function decrypt(data, key, discardNumber) {
                    if (discardNumber >= data.length) return new Uint8Array(0);
                    const c1 = 52845, c2 = 22719;
                    let r = key | 0, i, j;
                    for(i = 0; i < discardNumber; i++)r = (data[i] + r) * c1 + c2 & 65535;
                    const count = data.length - discardNumber;
                    const decrypted = new Uint8Array(count);
                    for(i = discardNumber, j = 0; j < count; i++, j++){
                        const value = data[i];
                        decrypted[j] = value ^ r >> 8;
                        r = (value + r) * c1 + c2 & 65535;
                    }
                    return decrypted;
                }
                function decryptAscii(data, key, discardNumber) {
                    const c1 = 52845, c2 = 22719;
                    let r = key | 0;
                    const count = data.length, maybeLength = count >>> 1;
                    const decrypted = new Uint8Array(maybeLength);
                    let i, j;
                    for(i = 0, j = 0; i < count; i++){
                        const digit1 = data[i];
                        if (!isHexDigit(digit1)) continue;
                        i++;
                        let digit2;
                        while(i < count && !isHexDigit(digit2 = data[i]))i++;
                        if (i < count) {
                            const value = parseInt(String.fromCharCode(digit1, digit2), 16);
                            decrypted[j++] = value ^ r >> 8;
                            r = (value + r) * c1 + c2 & 65535;
                        }
                    }
                    return decrypted.slice(discardNumber, j);
                }
                function isSpecial(c) {
                    return c === 0x2f || c === 0x5b || c === 0x5d || c === 0x7b || c === 0x7d || c === 0x28 || c === 0x29;
                }
                class Type1Parser {
                    constructor(stream, encrypted, seacAnalysisEnabled){
                        if (encrypted) {
                            const data = stream.getBytes();
                            const isBinary = !((isHexDigit(data[0]) || (0, _core_utils.isWhiteSpace)(data[0])) && isHexDigit(data[1]) && isHexDigit(data[2]) && isHexDigit(data[3]) && isHexDigit(data[4]) && isHexDigit(data[5]) && isHexDigit(data[6]) && isHexDigit(data[7]));
                            stream = new _stream.Stream(isBinary ? decrypt(data, EEXEC_ENCRYPT_KEY, 4) : decryptAscii(data, EEXEC_ENCRYPT_KEY, 4));
                        }
                        this.seacAnalysisEnabled = !!seacAnalysisEnabled;
                        this.stream = stream;
                        this.nextChar();
                    }
                    readNumberArray() {
                        this.getToken();
                        const array = [];
                        while(true){
                            const token = this.getToken();
                            if (token === null || token === "]" || token === "}") break;
                            array.push(parseFloat(token || 0));
                        }
                        return array;
                    }
                    readNumber() {
                        const token = this.getToken();
                        return parseFloat(token || 0);
                    }
                    readInt() {
                        const token = this.getToken();
                        return parseInt(token || 0, 10) | 0;
                    }
                    readBoolean() {
                        const token = this.getToken();
                        return token === "true" ? 1 : 0;
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    prevChar() {
                        this.stream.skip(-2);
                        return this.currentChar = this.stream.getByte();
                    }
                    getToken() {
                        let comment = false;
                        let ch = this.currentChar;
                        while(true){
                            if (ch === -1) return null;
                            if (comment) {
                                if (ch === 0x0a || ch === 0x0d) comment = false;
                            } else if (ch === 0x25) comment = true;
                            else if (!(0, _core_utils.isWhiteSpace)(ch)) break;
                            ch = this.nextChar();
                        }
                        if (isSpecial(ch)) {
                            this.nextChar();
                            return String.fromCharCode(ch);
                        }
                        let token = "";
                        do {
                            token += String.fromCharCode(ch);
                            ch = this.nextChar();
                        }while (ch >= 0 && !(0, _core_utils.isWhiteSpace)(ch) && !isSpecial(ch));
                        return token;
                    }
                    readCharStrings(bytes, lenIV) {
                        if (lenIV === -1) return bytes;
                        return decrypt(bytes, CHAR_STRS_ENCRYPT_KEY, lenIV);
                    }
                    extractFontProgram(properties) {
                        const stream = this.stream;
                        const subrs = [], charstrings = [];
                        const privateData = Object.create(null);
                        privateData.lenIV = 4;
                        const program = {
                            subrs: [],
                            charstrings: [],
                            properties: {
                                privateData: privateData
                            }
                        };
                        let token, length, data, lenIV;
                        while((token = this.getToken()) !== null){
                            if (token !== "/") continue;
                            token = this.getToken();
                            switch(token){
                                case "CharStrings":
                                    this.getToken();
                                    this.getToken();
                                    this.getToken();
                                    this.getToken();
                                    while(true){
                                        token = this.getToken();
                                        if (token === null || token === "end") break;
                                        if (token !== "/") continue;
                                        const glyph = this.getToken();
                                        length = this.readInt();
                                        this.getToken();
                                        data = length > 0 ? stream.getBytes(length) : new Uint8Array(0);
                                        lenIV = program.properties.privateData.lenIV;
                                        const encoded = this.readCharStrings(data, lenIV);
                                        this.nextChar();
                                        token = this.getToken();
                                        if (token === "noaccess") this.getToken();
                                        else if (token === "/") this.prevChar();
                                        charstrings.push({
                                            glyph: glyph,
                                            encoded: encoded
                                        });
                                    }
                                    break;
                                case "Subrs":
                                    this.readInt();
                                    this.getToken();
                                    while(this.getToken() === "dup"){
                                        const index = this.readInt();
                                        length = this.readInt();
                                        this.getToken();
                                        data = length > 0 ? stream.getBytes(length) : new Uint8Array(0);
                                        lenIV = program.properties.privateData.lenIV;
                                        const encoded = this.readCharStrings(data, lenIV);
                                        this.nextChar();
                                        token = this.getToken();
                                        if (token === "noaccess") this.getToken();
                                        subrs[index] = encoded;
                                    }
                                    break;
                                case "BlueValues":
                                case "OtherBlues":
                                case "FamilyBlues":
                                case "FamilyOtherBlues":
                                    const blueArray = this.readNumberArray();
                                    if (blueArray.length > 0 && blueArray.length % 2 === 0 && HINTING_ENABLED) program.properties.privateData[token] = blueArray;
                                    break;
                                case "StemSnapH":
                                case "StemSnapV":
                                    program.properties.privateData[token] = this.readNumberArray();
                                    break;
                                case "StdHW":
                                case "StdVW":
                                    program.properties.privateData[token] = this.readNumberArray()[0];
                                    break;
                                case "BlueShift":
                                case "lenIV":
                                case "BlueFuzz":
                                case "BlueScale":
                                case "LanguageGroup":
                                    program.properties.privateData[token] = this.readNumber();
                                    break;
                                case "ExpansionFactor":
                                    program.properties.privateData[token] = this.readNumber() || 0.06;
                                    break;
                                case "ForceBold":
                                    program.properties.privateData[token] = this.readBoolean();
                                    break;
                            }
                        }
                        for (const { encoded: encoded, glyph: glyph } of charstrings){
                            const charString = new Type1CharString();
                            const error = charString.convert(encoded, subrs, this.seacAnalysisEnabled);
                            let output = charString.output;
                            if (error) output = [
                                14
                            ];
                            const charStringObject = {
                                glyphName: glyph,
                                charstring: output,
                                width: charString.width,
                                lsb: charString.lsb,
                                seac: charString.seac
                            };
                            if (glyph === ".notdef") program.charstrings.unshift(charStringObject);
                            else program.charstrings.push(charStringObject);
                            if (properties.builtInEncoding) {
                                const index = properties.builtInEncoding.indexOf(glyph);
                                if (index > -1 && properties.widths[index] === undefined && index >= properties.firstChar && index <= properties.lastChar) properties.widths[index] = charString.width;
                            }
                        }
                        return program;
                    }
                    extractFontHeader(properties) {
                        let token;
                        while((token = this.getToken()) !== null){
                            if (token !== "/") continue;
                            token = this.getToken();
                            switch(token){
                                case "FontMatrix":
                                    const matrix = this.readNumberArray();
                                    properties.fontMatrix = matrix;
                                    break;
                                case "Encoding":
                                    const encodingArg = this.getToken();
                                    let encoding;
                                    if (!/^\d+$/.test(encodingArg)) encoding = (0, _encodings.getEncoding)(encodingArg);
                                    else {
                                        encoding = [];
                                        const size = parseInt(encodingArg, 10) | 0;
                                        this.getToken();
                                        for(let j = 0; j < size; j++){
                                            token = this.getToken();
                                            while(token !== "dup" && token !== "def"){
                                                token = this.getToken();
                                                if (token === null) return;
                                            }
                                            if (token === "def") break;
                                            const index = this.readInt();
                                            this.getToken();
                                            const glyph = this.getToken();
                                            encoding[index] = glyph;
                                            this.getToken();
                                        }
                                    }
                                    properties.builtInEncoding = encoding;
                                    break;
                                case "FontBBox":
                                    const fontBBox = this.readNumberArray();
                                    properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
                                    properties.descent = Math.min(fontBBox[1], fontBBox[3]);
                                    properties.ascentScaled = true;
                                    break;
                            }
                        }
                    }
                }
                exports.Type1Parser = Type1Parser;
            /***/ },
            /* 50 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Pattern = void 0;
                exports.clearPatternCaches = clearPatternCaches;
                exports.getTilingPatternIR = getTilingPatternIR;
                var _util = __w_pdfjs_require__(2);
                var _base_stream = __w_pdfjs_require__(5);
                var _colorspace = __w_pdfjs_require__(12);
                var _core_utils = __w_pdfjs_require__(3);
                const ShadingType = {
                    FUNCTION_BASED: 1,
                    AXIAL: 2,
                    RADIAL: 3,
                    FREE_FORM_MESH: 4,
                    LATTICE_FORM_MESH: 5,
                    COONS_PATCH_MESH: 6,
                    TENSOR_PATCH_MESH: 7
                };
                class Pattern {
                    constructor(){
                        (0, _util.unreachable)("Cannot initialize Pattern.");
                    }
                    static parseShading(shading, xref, res, pdfFunctionFactory, localColorSpaceCache) {
                        const dict = shading instanceof _base_stream.BaseStream ? shading.dict : shading;
                        const type = dict.get("ShadingType");
                        try {
                            switch(type){
                                case ShadingType.AXIAL:
                                case ShadingType.RADIAL:
                                    return new RadialAxialShading(dict, xref, res, pdfFunctionFactory, localColorSpaceCache);
                                case ShadingType.FREE_FORM_MESH:
                                case ShadingType.LATTICE_FORM_MESH:
                                case ShadingType.COONS_PATCH_MESH:
                                case ShadingType.TENSOR_PATCH_MESH:
                                    return new MeshShading(shading, xref, res, pdfFunctionFactory, localColorSpaceCache);
                                default:
                                    throw new _util.FormatError("Unsupported ShadingType: " + type);
                            }
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(ex);
                            return new DummyShading();
                        }
                    }
                }
                exports.Pattern = Pattern;
                class BaseShading {
                    static SMALL_NUMBER = 1e-6;
                    constructor(){
                        if (this.constructor === BaseShading) (0, _util.unreachable)("Cannot initialize BaseShading.");
                    }
                    getIR() {
                        (0, _util.unreachable)("Abstract method `getIR` called.");
                    }
                }
                class RadialAxialShading extends BaseShading {
                    constructor(dict, xref, resources, pdfFunctionFactory, localColorSpaceCache){
                        super();
                        this.coordsArr = dict.getArray("Coords");
                        this.shadingType = dict.get("ShadingType");
                        const cs = _colorspace.ColorSpace.parse({
                            cs: dict.getRaw("CS") || dict.getRaw("ColorSpace"),
                            xref: xref,
                            resources: resources,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                        const bbox = dict.getArray("BBox");
                        this.bbox = Array.isArray(bbox) && bbox.length === 4 ? _util.Util.normalizeRect(bbox) : null;
                        let t0 = 0.0, t1 = 1.0;
                        if (dict.has("Domain")) {
                            const domainArr = dict.getArray("Domain");
                            t0 = domainArr[0];
                            t1 = domainArr[1];
                        }
                        let extendStart = false, extendEnd = false;
                        if (dict.has("Extend")) {
                            const extendArr = dict.getArray("Extend");
                            extendStart = extendArr[0];
                            extendEnd = extendArr[1];
                        }
                        if (this.shadingType === ShadingType.RADIAL && (!extendStart || !extendEnd)) {
                            const [x1, y1, r1, x2, y2, r2] = this.coordsArr;
                            const distance = Math.hypot(x1 - x2, y1 - y2);
                            if (r1 <= r2 + distance && r2 <= r1 + distance) (0, _util.warn)("Unsupported radial gradient.");
                        }
                        this.extendStart = extendStart;
                        this.extendEnd = extendEnd;
                        const fnObj = dict.getRaw("Function");
                        const fn = pdfFunctionFactory.createFromArray(fnObj);
                        const NUMBER_OF_SAMPLES = 840;
                        const step = (t1 - t0) / NUMBER_OF_SAMPLES;
                        const colorStops = this.colorStops = [];
                        if (t0 >= t1 || step <= 0) {
                            (0, _util.info)("Bad shading domain.");
                            return;
                        }
                        const color = new Float32Array(cs.numComps), ratio = new Float32Array(1);
                        let rgbColor;
                        let iBase = 0;
                        ratio[0] = t0;
                        fn(ratio, 0, color, 0);
                        let rgbBase = cs.getRgb(color, 0);
                        const cssColorBase = _util.Util.makeHexColor(rgbBase[0], rgbBase[1], rgbBase[2]);
                        colorStops.push([
                            0,
                            cssColorBase
                        ]);
                        let iPrev = 1;
                        ratio[0] = t0 + step;
                        fn(ratio, 0, color, 0);
                        let rgbPrev = cs.getRgb(color, 0);
                        let maxSlopeR = rgbPrev[0] - rgbBase[0] + 1;
                        let maxSlopeG = rgbPrev[1] - rgbBase[1] + 1;
                        let maxSlopeB = rgbPrev[2] - rgbBase[2] + 1;
                        let minSlopeR = rgbPrev[0] - rgbBase[0] - 1;
                        let minSlopeG = rgbPrev[1] - rgbBase[1] - 1;
                        let minSlopeB = rgbPrev[2] - rgbBase[2] - 1;
                        for(let i = 2; i < NUMBER_OF_SAMPLES; i++){
                            ratio[0] = t0 + i * step;
                            fn(ratio, 0, color, 0);
                            rgbColor = cs.getRgb(color, 0);
                            const run = i - iBase;
                            maxSlopeR = Math.min(maxSlopeR, (rgbColor[0] - rgbBase[0] + 1) / run);
                            maxSlopeG = Math.min(maxSlopeG, (rgbColor[1] - rgbBase[1] + 1) / run);
                            maxSlopeB = Math.min(maxSlopeB, (rgbColor[2] - rgbBase[2] + 1) / run);
                            minSlopeR = Math.max(minSlopeR, (rgbColor[0] - rgbBase[0] - 1) / run);
                            minSlopeG = Math.max(minSlopeG, (rgbColor[1] - rgbBase[1] - 1) / run);
                            minSlopeB = Math.max(minSlopeB, (rgbColor[2] - rgbBase[2] - 1) / run);
                            const slopesExist = minSlopeR <= maxSlopeR && minSlopeG <= maxSlopeG && minSlopeB <= maxSlopeB;
                            if (!slopesExist) {
                                const cssColor = _util.Util.makeHexColor(rgbPrev[0], rgbPrev[1], rgbPrev[2]);
                                colorStops.push([
                                    iPrev / NUMBER_OF_SAMPLES,
                                    cssColor
                                ]);
                                maxSlopeR = rgbColor[0] - rgbPrev[0] + 1;
                                maxSlopeG = rgbColor[1] - rgbPrev[1] + 1;
                                maxSlopeB = rgbColor[2] - rgbPrev[2] + 1;
                                minSlopeR = rgbColor[0] - rgbPrev[0] - 1;
                                minSlopeG = rgbColor[1] - rgbPrev[1] - 1;
                                minSlopeB = rgbColor[2] - rgbPrev[2] - 1;
                                iBase = iPrev;
                                rgbBase = rgbPrev;
                            }
                            iPrev = i;
                            rgbPrev = rgbColor;
                        }
                        const cssColor = _util.Util.makeHexColor(rgbPrev[0], rgbPrev[1], rgbPrev[2]);
                        colorStops.push([
                            1,
                            cssColor
                        ]);
                        let background = "transparent";
                        if (dict.has("Background")) {
                            rgbColor = cs.getRgb(dict.get("Background"), 0);
                            background = _util.Util.makeHexColor(rgbColor[0], rgbColor[1], rgbColor[2]);
                        }
                        if (!extendStart) {
                            colorStops.unshift([
                                0,
                                background
                            ]);
                            colorStops[1][0] += BaseShading.SMALL_NUMBER;
                        }
                        if (!extendEnd) {
                            colorStops.at(-1)[0] -= BaseShading.SMALL_NUMBER;
                            colorStops.push([
                                1,
                                background
                            ]);
                        }
                        this.colorStops = colorStops;
                    }
                    getIR() {
                        const coordsArr = this.coordsArr;
                        const shadingType = this.shadingType;
                        let type, p0, p1, r0, r1;
                        if (shadingType === ShadingType.AXIAL) {
                            p0 = [
                                coordsArr[0],
                                coordsArr[1]
                            ];
                            p1 = [
                                coordsArr[2],
                                coordsArr[3]
                            ];
                            r0 = null;
                            r1 = null;
                            type = "axial";
                        } else if (shadingType === ShadingType.RADIAL) {
                            p0 = [
                                coordsArr[0],
                                coordsArr[1]
                            ];
                            p1 = [
                                coordsArr[3],
                                coordsArr[4]
                            ];
                            r0 = coordsArr[2];
                            r1 = coordsArr[5];
                            type = "radial";
                        } else (0, _util.unreachable)(`getPattern type unknown: ${shadingType}`);
                        return [
                            "RadialAxial",
                            type,
                            this.bbox,
                            this.colorStops,
                            p0,
                            p1,
                            r0,
                            r1
                        ];
                    }
                }
                class MeshStreamReader {
                    constructor(stream, context){
                        this.stream = stream;
                        this.context = context;
                        this.buffer = 0;
                        this.bufferLength = 0;
                        const numComps = context.numComps;
                        this.tmpCompsBuf = new Float32Array(numComps);
                        const csNumComps = context.colorSpace.numComps;
                        this.tmpCsCompsBuf = context.colorFn ? new Float32Array(csNumComps) : this.tmpCompsBuf;
                    }
                    get hasData() {
                        if (this.stream.end) return this.stream.pos < this.stream.end;
                        if (this.bufferLength > 0) return true;
                        const nextByte = this.stream.getByte();
                        if (nextByte < 0) return false;
                        this.buffer = nextByte;
                        this.bufferLength = 8;
                        return true;
                    }
                    readBits(n) {
                        let buffer = this.buffer;
                        let bufferLength = this.bufferLength;
                        if (n === 32) {
                            if (bufferLength === 0) return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                            buffer = buffer << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                            const nextByte = this.stream.getByte();
                            this.buffer = nextByte & (1 << bufferLength) - 1;
                            return (buffer << 8 - bufferLength | (nextByte & 0xff) >> bufferLength) >>> 0;
                        }
                        if (n === 8 && bufferLength === 0) return this.stream.getByte();
                        while(bufferLength < n){
                            buffer = buffer << 8 | this.stream.getByte();
                            bufferLength += 8;
                        }
                        bufferLength -= n;
                        this.bufferLength = bufferLength;
                        this.buffer = buffer & (1 << bufferLength) - 1;
                        return buffer >> bufferLength;
                    }
                    align() {
                        this.buffer = 0;
                        this.bufferLength = 0;
                    }
                    readFlag() {
                        return this.readBits(this.context.bitsPerFlag);
                    }
                    readCoordinate() {
                        const bitsPerCoordinate = this.context.bitsPerCoordinate;
                        const xi = this.readBits(bitsPerCoordinate);
                        const yi = this.readBits(bitsPerCoordinate);
                        const decode = this.context.decode;
                        const scale = bitsPerCoordinate < 32 ? 1 / ((1 << bitsPerCoordinate) - 1) : 2.3283064365386963e-10;
                        return [
                            xi * scale * (decode[1] - decode[0]) + decode[0],
                            yi * scale * (decode[3] - decode[2]) + decode[2]
                        ];
                    }
                    readComponents() {
                        const numComps = this.context.numComps;
                        const bitsPerComponent = this.context.bitsPerComponent;
                        const scale = bitsPerComponent < 32 ? 1 / ((1 << bitsPerComponent) - 1) : 2.3283064365386963e-10;
                        const decode = this.context.decode;
                        const components = this.tmpCompsBuf;
                        for(let i = 0, j = 4; i < numComps; i++, j += 2){
                            const ci = this.readBits(bitsPerComponent);
                            components[i] = ci * scale * (decode[j + 1] - decode[j]) + decode[j];
                        }
                        const color = this.tmpCsCompsBuf;
                        if (this.context.colorFn) this.context.colorFn(components, 0, color, 0);
                        return this.context.colorSpace.getRgb(color, 0);
                    }
                }
                let bCache = Object.create(null);
                function buildB(count) {
                    const lut = [];
                    for(let i = 0; i <= count; i++){
                        const t = i / count, t_ = 1 - t;
                        lut.push(new Float32Array([
                            t_ ** 3,
                            3 * t * t_ ** 2,
                            3 * t ** 2 * t_,
                            t ** 3
                        ]));
                    }
                    return lut;
                }
                function getB(count) {
                    return bCache[count] ||= buildB(count);
                }
                function clearPatternCaches() {
                    bCache = Object.create(null);
                }
                class MeshShading extends BaseShading {
                    static MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
                    static MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
                    static TRIANGLE_DENSITY = 20;
                    constructor(stream, xref, resources, pdfFunctionFactory, localColorSpaceCache){
                        super();
                        if (!(stream instanceof _base_stream.BaseStream)) throw new _util.FormatError("Mesh data is not a stream");
                        const dict = stream.dict;
                        this.shadingType = dict.get("ShadingType");
                        const bbox = dict.getArray("BBox");
                        this.bbox = Array.isArray(bbox) && bbox.length === 4 ? _util.Util.normalizeRect(bbox) : null;
                        const cs = _colorspace.ColorSpace.parse({
                            cs: dict.getRaw("CS") || dict.getRaw("ColorSpace"),
                            xref: xref,
                            resources: resources,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                        this.background = dict.has("Background") ? cs.getRgb(dict.get("Background"), 0) : null;
                        const fnObj = dict.getRaw("Function");
                        const fn = fnObj ? pdfFunctionFactory.createFromArray(fnObj) : null;
                        this.coords = [];
                        this.colors = [];
                        this.figures = [];
                        const decodeContext = {
                            bitsPerCoordinate: dict.get("BitsPerCoordinate"),
                            bitsPerComponent: dict.get("BitsPerComponent"),
                            bitsPerFlag: dict.get("BitsPerFlag"),
                            decode: dict.getArray("Decode"),
                            colorFn: fn,
                            colorSpace: cs,
                            numComps: fn ? 1 : cs.numComps
                        };
                        const reader = new MeshStreamReader(stream, decodeContext);
                        let patchMesh = false;
                        switch(this.shadingType){
                            case ShadingType.FREE_FORM_MESH:
                                this._decodeType4Shading(reader);
                                break;
                            case ShadingType.LATTICE_FORM_MESH:
                                const verticesPerRow = dict.get("VerticesPerRow") | 0;
                                if (verticesPerRow < 2) throw new _util.FormatError("Invalid VerticesPerRow");
                                this._decodeType5Shading(reader, verticesPerRow);
                                break;
                            case ShadingType.COONS_PATCH_MESH:
                                this._decodeType6Shading(reader);
                                patchMesh = true;
                                break;
                            case ShadingType.TENSOR_PATCH_MESH:
                                this._decodeType7Shading(reader);
                                patchMesh = true;
                                break;
                            default:
                                (0, _util.unreachable)("Unsupported mesh type.");
                                break;
                        }
                        if (patchMesh) {
                            this._updateBounds();
                            for(let i = 0, ii = this.figures.length; i < ii; i++)this._buildFigureFromPatch(i);
                        }
                        this._updateBounds();
                        this._packData();
                    }
                    _decodeType4Shading(reader) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const operators = [];
                        const ps = [];
                        let verticesLeft = 0;
                        while(reader.hasData){
                            const f = reader.readFlag();
                            const coord = reader.readCoordinate();
                            const color = reader.readComponents();
                            if (verticesLeft === 0) {
                                if (!(0 <= f && f <= 2)) throw new _util.FormatError("Unknown type4 flag");
                                switch(f){
                                    case 0:
                                        verticesLeft = 3;
                                        break;
                                    case 1:
                                        ps.push(ps.at(-2), ps.at(-1));
                                        verticesLeft = 1;
                                        break;
                                    case 2:
                                        ps.push(ps.at(-3), ps.at(-1));
                                        verticesLeft = 1;
                                        break;
                                }
                                operators.push(f);
                            }
                            ps.push(coords.length);
                            coords.push(coord);
                            colors.push(color);
                            verticesLeft--;
                            reader.align();
                        }
                        this.figures.push({
                            type: "triangles",
                            coords: new Int32Array(ps),
                            colors: new Int32Array(ps)
                        });
                    }
                    _decodeType5Shading(reader, verticesPerRow) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const ps = [];
                        while(reader.hasData){
                            const coord = reader.readCoordinate();
                            const color = reader.readComponents();
                            ps.push(coords.length);
                            coords.push(coord);
                            colors.push(color);
                        }
                        this.figures.push({
                            type: "lattice",
                            coords: new Int32Array(ps),
                            colors: new Int32Array(ps),
                            verticesPerRow: verticesPerRow
                        });
                    }
                    _decodeType6Shading(reader) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const ps = new Int32Array(16);
                        const cs = new Int32Array(4);
                        while(reader.hasData){
                            const f = reader.readFlag();
                            if (!(0 <= f && f <= 3)) throw new _util.FormatError("Unknown type6 flag");
                            const pi = coords.length;
                            for(let i = 0, ii = f !== 0 ? 8 : 12; i < ii; i++)coords.push(reader.readCoordinate());
                            const ci = colors.length;
                            for(let i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++)colors.push(reader.readComponents());
                            let tmp1, tmp2, tmp3, tmp4;
                            switch(f){
                                case 0:
                                    ps[12] = pi + 3;
                                    ps[13] = pi + 4;
                                    ps[14] = pi + 5;
                                    ps[15] = pi + 6;
                                    ps[8] = pi + 2;
                                    ps[11] = pi + 7;
                                    ps[4] = pi + 1;
                                    ps[7] = pi + 8;
                                    ps[0] = pi;
                                    ps[1] = pi + 11;
                                    ps[2] = pi + 10;
                                    ps[3] = pi + 9;
                                    cs[2] = ci + 1;
                                    cs[3] = ci + 2;
                                    cs[0] = ci;
                                    cs[1] = ci + 3;
                                    break;
                                case 1:
                                    tmp1 = ps[12];
                                    tmp2 = ps[13];
                                    tmp3 = ps[14];
                                    tmp4 = ps[15];
                                    ps[12] = tmp4;
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = tmp3;
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[2];
                                    tmp2 = cs[3];
                                    cs[2] = tmp2;
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 2:
                                    tmp1 = ps[15];
                                    tmp2 = ps[11];
                                    ps[12] = ps[3];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[7];
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[3];
                                    cs[2] = cs[1];
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 3:
                                    ps[12] = ps[0];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[1];
                                    ps[11] = pi + 3;
                                    ps[4] = ps[2];
                                    ps[7] = pi + 4;
                                    ps[0] = ps[3];
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    cs[2] = cs[0];
                                    cs[3] = ci;
                                    cs[0] = cs[1];
                                    cs[1] = ci + 1;
                                    break;
                            }
                            ps[5] = coords.length;
                            coords.push([
                                (-4 * coords[ps[0]][0] - coords[ps[15]][0] + 6 * (coords[ps[4]][0] + coords[ps[1]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[13]][0] + coords[ps[7]][0])) / 9,
                                (-4 * coords[ps[0]][1] - coords[ps[15]][1] + 6 * (coords[ps[4]][1] + coords[ps[1]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[13]][1] + coords[ps[7]][1])) / 9
                            ]);
                            ps[6] = coords.length;
                            coords.push([
                                (-4 * coords[ps[3]][0] - coords[ps[12]][0] + 6 * (coords[ps[2]][0] + coords[ps[7]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[4]][0] + coords[ps[14]][0])) / 9,
                                (-4 * coords[ps[3]][1] - coords[ps[12]][1] + 6 * (coords[ps[2]][1] + coords[ps[7]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[4]][1] + coords[ps[14]][1])) / 9
                            ]);
                            ps[9] = coords.length;
                            coords.push([
                                (-4 * coords[ps[12]][0] - coords[ps[3]][0] + 6 * (coords[ps[8]][0] + coords[ps[13]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[11]][0] + coords[ps[1]][0])) / 9,
                                (-4 * coords[ps[12]][1] - coords[ps[3]][1] + 6 * (coords[ps[8]][1] + coords[ps[13]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[11]][1] + coords[ps[1]][1])) / 9
                            ]);
                            ps[10] = coords.length;
                            coords.push([
                                (-4 * coords[ps[15]][0] - coords[ps[0]][0] + 6 * (coords[ps[11]][0] + coords[ps[14]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[2]][0] + coords[ps[8]][0])) / 9,
                                (-4 * coords[ps[15]][1] - coords[ps[0]][1] + 6 * (coords[ps[11]][1] + coords[ps[14]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[2]][1] + coords[ps[8]][1])) / 9
                            ]);
                            this.figures.push({
                                type: "patch",
                                coords: new Int32Array(ps),
                                colors: new Int32Array(cs)
                            });
                        }
                    }
                    _decodeType7Shading(reader) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const ps = new Int32Array(16);
                        const cs = new Int32Array(4);
                        while(reader.hasData){
                            const f = reader.readFlag();
                            if (!(0 <= f && f <= 3)) throw new _util.FormatError("Unknown type7 flag");
                            const pi = coords.length;
                            for(let i = 0, ii = f !== 0 ? 12 : 16; i < ii; i++)coords.push(reader.readCoordinate());
                            const ci = colors.length;
                            for(let i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++)colors.push(reader.readComponents());
                            let tmp1, tmp2, tmp3, tmp4;
                            switch(f){
                                case 0:
                                    ps[12] = pi + 3;
                                    ps[13] = pi + 4;
                                    ps[14] = pi + 5;
                                    ps[15] = pi + 6;
                                    ps[8] = pi + 2;
                                    ps[9] = pi + 13;
                                    ps[10] = pi + 14;
                                    ps[11] = pi + 7;
                                    ps[4] = pi + 1;
                                    ps[5] = pi + 12;
                                    ps[6] = pi + 15;
                                    ps[7] = pi + 8;
                                    ps[0] = pi;
                                    ps[1] = pi + 11;
                                    ps[2] = pi + 10;
                                    ps[3] = pi + 9;
                                    cs[2] = ci + 1;
                                    cs[3] = ci + 2;
                                    cs[0] = ci;
                                    cs[1] = ci + 3;
                                    break;
                                case 1:
                                    tmp1 = ps[12];
                                    tmp2 = ps[13];
                                    tmp3 = ps[14];
                                    tmp4 = ps[15];
                                    ps[12] = tmp4;
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = tmp3;
                                    ps[9] = pi + 9;
                                    ps[10] = pi + 10;
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[5] = pi + 8;
                                    ps[6] = pi + 11;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[2];
                                    tmp2 = cs[3];
                                    cs[2] = tmp2;
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 2:
                                    tmp1 = ps[15];
                                    tmp2 = ps[11];
                                    ps[12] = ps[3];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[7];
                                    ps[9] = pi + 9;
                                    ps[10] = pi + 10;
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[5] = pi + 8;
                                    ps[6] = pi + 11;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[3];
                                    cs[2] = cs[1];
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 3:
                                    ps[12] = ps[0];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[1];
                                    ps[9] = pi + 9;
                                    ps[10] = pi + 10;
                                    ps[11] = pi + 3;
                                    ps[4] = ps[2];
                                    ps[5] = pi + 8;
                                    ps[6] = pi + 11;
                                    ps[7] = pi + 4;
                                    ps[0] = ps[3];
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    cs[2] = cs[0];
                                    cs[3] = ci;
                                    cs[0] = cs[1];
                                    cs[1] = ci + 1;
                                    break;
                            }
                            this.figures.push({
                                type: "patch",
                                coords: new Int32Array(ps),
                                colors: new Int32Array(cs)
                            });
                        }
                    }
                    _buildFigureFromPatch(index) {
                        const figure = this.figures[index];
                        (0, _util.assert)(figure.type === "patch", "Unexpected patch mesh figure");
                        const coords = this.coords, colors = this.colors;
                        const pi = figure.coords;
                        const ci = figure.colors;
                        const figureMinX = Math.min(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
                        const figureMinY = Math.min(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
                        const figureMaxX = Math.max(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
                        const figureMaxY = Math.max(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
                        let splitXBy = Math.ceil((figureMaxX - figureMinX) * MeshShading.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
                        splitXBy = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitXBy));
                        let splitYBy = Math.ceil((figureMaxY - figureMinY) * MeshShading.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
                        splitYBy = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitYBy));
                        const verticesPerRow = splitXBy + 1;
                        const figureCoords = new Int32Array((splitYBy + 1) * verticesPerRow);
                        const figureColors = new Int32Array((splitYBy + 1) * verticesPerRow);
                        let k = 0;
                        const cl = new Uint8Array(3), cr = new Uint8Array(3);
                        const c0 = colors[ci[0]], c1 = colors[ci[1]], c2 = colors[ci[2]], c3 = colors[ci[3]];
                        const bRow = getB(splitYBy), bCol = getB(splitXBy);
                        for(let row = 0; row <= splitYBy; row++){
                            cl[0] = (c0[0] * (splitYBy - row) + c2[0] * row) / splitYBy | 0;
                            cl[1] = (c0[1] * (splitYBy - row) + c2[1] * row) / splitYBy | 0;
                            cl[2] = (c0[2] * (splitYBy - row) + c2[2] * row) / splitYBy | 0;
                            cr[0] = (c1[0] * (splitYBy - row) + c3[0] * row) / splitYBy | 0;
                            cr[1] = (c1[1] * (splitYBy - row) + c3[1] * row) / splitYBy | 0;
                            cr[2] = (c1[2] * (splitYBy - row) + c3[2] * row) / splitYBy | 0;
                            for(let col = 0; col <= splitXBy; col++, k++){
                                if ((row === 0 || row === splitYBy) && (col === 0 || col === splitXBy)) continue;
                                let x = 0, y = 0;
                                let q = 0;
                                for(let i = 0; i <= 3; i++)for(let j = 0; j <= 3; j++, q++){
                                    const m = bRow[row][i] * bCol[col][j];
                                    x += coords[pi[q]][0] * m;
                                    y += coords[pi[q]][1] * m;
                                }
                                figureCoords[k] = coords.length;
                                coords.push([
                                    x,
                                    y
                                ]);
                                figureColors[k] = colors.length;
                                const newColor = new Uint8Array(3);
                                newColor[0] = (cl[0] * (splitXBy - col) + cr[0] * col) / splitXBy | 0;
                                newColor[1] = (cl[1] * (splitXBy - col) + cr[1] * col) / splitXBy | 0;
                                newColor[2] = (cl[2] * (splitXBy - col) + cr[2] * col) / splitXBy | 0;
                                colors.push(newColor);
                            }
                        }
                        figureCoords[0] = pi[0];
                        figureColors[0] = ci[0];
                        figureCoords[splitXBy] = pi[3];
                        figureColors[splitXBy] = ci[1];
                        figureCoords[verticesPerRow * splitYBy] = pi[12];
                        figureColors[verticesPerRow * splitYBy] = ci[2];
                        figureCoords[verticesPerRow * splitYBy + splitXBy] = pi[15];
                        figureColors[verticesPerRow * splitYBy + splitXBy] = ci[3];
                        this.figures[index] = {
                            type: "lattice",
                            coords: figureCoords,
                            colors: figureColors,
                            verticesPerRow: verticesPerRow
                        };
                    }
                    _updateBounds() {
                        let minX = this.coords[0][0], minY = this.coords[0][1], maxX = minX, maxY = minY;
                        for(let i = 1, ii = this.coords.length; i < ii; i++){
                            const x = this.coords[i][0], y = this.coords[i][1];
                            minX = minX > x ? x : minX;
                            minY = minY > y ? y : minY;
                            maxX = maxX < x ? x : maxX;
                            maxY = maxY < y ? y : maxY;
                        }
                        this.bounds = [
                            minX,
                            minY,
                            maxX,
                            maxY
                        ];
                    }
                    _packData() {
                        let i, ii, j, jj;
                        const coords = this.coords;
                        const coordsPacked = new Float32Array(coords.length * 2);
                        for(i = 0, j = 0, ii = coords.length; i < ii; i++){
                            const xy = coords[i];
                            coordsPacked[j++] = xy[0];
                            coordsPacked[j++] = xy[1];
                        }
                        this.coords = coordsPacked;
                        const colors = this.colors;
                        const colorsPacked = new Uint8Array(colors.length * 3);
                        for(i = 0, j = 0, ii = colors.length; i < ii; i++){
                            const c = colors[i];
                            colorsPacked[j++] = c[0];
                            colorsPacked[j++] = c[1];
                            colorsPacked[j++] = c[2];
                        }
                        this.colors = colorsPacked;
                        const figures = this.figures;
                        for(i = 0, ii = figures.length; i < ii; i++){
                            const figure = figures[i], ps = figure.coords, cs = figure.colors;
                            for(j = 0, jj = ps.length; j < jj; j++){
                                ps[j] *= 2;
                                cs[j] *= 3;
                            }
                        }
                    }
                    getIR() {
                        return [
                            "Mesh",
                            this.shadingType,
                            this.coords,
                            this.colors,
                            this.figures,
                            this.bounds,
                            this.bbox,
                            this.background
                        ];
                    }
                }
                class DummyShading extends BaseShading {
                    getIR() {
                        return [
                            "Dummy"
                        ];
                    }
                }
                function getTilingPatternIR(operatorList, dict, color) {
                    const matrix = dict.getArray("Matrix");
                    const bbox = _util.Util.normalizeRect(dict.getArray("BBox"));
                    const xstep = dict.get("XStep");
                    const ystep = dict.get("YStep");
                    const paintType = dict.get("PaintType");
                    const tilingType = dict.get("TilingType");
                    if (bbox[2] - bbox[0] === 0 || bbox[3] - bbox[1] === 0) throw new _util.FormatError(`Invalid getTilingPatternIR /BBox array: [${bbox}].`);
                    return [
                        "TilingPattern",
                        color,
                        operatorList,
                        matrix,
                        bbox,
                        xstep,
                        ystep,
                        paintType,
                        tilingType
                    ];
                }
            /***/ },
            /* 51 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getXfaFontDict = getXfaFontDict;
                exports.getXfaFontName = getXfaFontName;
                var _calibri_factors = __w_pdfjs_require__(52);
                var _primitives = __w_pdfjs_require__(4);
                var _helvetica_factors = __w_pdfjs_require__(53);
                var _liberationsans_widths = __w_pdfjs_require__(54);
                var _myriadpro_factors = __w_pdfjs_require__(55);
                var _segoeui_factors = __w_pdfjs_require__(56);
                var _core_utils = __w_pdfjs_require__(3);
                var _fonts_utils = __w_pdfjs_require__(38);
                const getXFAFontMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t["MyriadPro-Regular"] = t["PdfJS-Fallback-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: _myriadpro_factors.MyriadProRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                        metrics: _myriadpro_factors.MyriadProRegularMetrics
                    };
                    t["MyriadPro-Bold"] = t["PdfJS-Fallback-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _myriadpro_factors.MyriadProBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                        metrics: _myriadpro_factors.MyriadProBoldMetrics
                    };
                    t["MyriadPro-It"] = t["MyriadPro-Italic"] = t["PdfJS-Fallback-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _myriadpro_factors.MyriadProItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                        metrics: _myriadpro_factors.MyriadProItalicMetrics
                    };
                    t["MyriadPro-BoldIt"] = t["MyriadPro-BoldItalic"] = t["PdfJS-Fallback-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _myriadpro_factors.MyriadProBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                        metrics: _myriadpro_factors.MyriadProBoldItalicMetrics
                    };
                    t.ArialMT = t.Arial = t["Arial-Regular"] = {
                        name: "LiberationSans-Regular",
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping
                    };
                    t["Arial-BoldMT"] = t["Arial-Bold"] = {
                        name: "LiberationSans-Bold",
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping
                    };
                    t["Arial-ItalicMT"] = t["Arial-Italic"] = {
                        name: "LiberationSans-Italic",
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping
                    };
                    t["Arial-BoldItalicMT"] = t["Arial-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping
                    };
                    t["Calibri-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: _calibri_factors.CalibriRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                        metrics: _calibri_factors.CalibriRegularMetrics
                    };
                    t["Calibri-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _calibri_factors.CalibriBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                        metrics: _calibri_factors.CalibriBoldMetrics
                    };
                    t["Calibri-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _calibri_factors.CalibriItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                        metrics: _calibri_factors.CalibriItalicMetrics
                    };
                    t["Calibri-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _calibri_factors.CalibriBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                        metrics: _calibri_factors.CalibriBoldItalicMetrics
                    };
                    t["Segoeui-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: _segoeui_factors.SegoeuiRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                        metrics: _segoeui_factors.SegoeuiRegularMetrics
                    };
                    t["Segoeui-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _segoeui_factors.SegoeuiBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                        metrics: _segoeui_factors.SegoeuiBoldMetrics
                    };
                    t["Segoeui-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _segoeui_factors.SegoeuiItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                        metrics: _segoeui_factors.SegoeuiItalicMetrics
                    };
                    t["Segoeui-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _segoeui_factors.SegoeuiBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                        metrics: _segoeui_factors.SegoeuiBoldItalicMetrics
                    };
                    t["Helvetica-Regular"] = t.Helvetica = {
                        name: "LiberationSans-Regular",
                        factors: _helvetica_factors.HelveticaRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        baseMapping: _liberationsans_widths.LiberationSansRegularMapping,
                        metrics: _helvetica_factors.HelveticaRegularMetrics
                    };
                    t["Helvetica-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _helvetica_factors.HelveticaBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldMapping,
                        metrics: _helvetica_factors.HelveticaBoldMetrics
                    };
                    t["Helvetica-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _helvetica_factors.HelveticaItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansItalicMapping,
                        metrics: _helvetica_factors.HelveticaItalicMetrics
                    };
                    t["Helvetica-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _helvetica_factors.HelveticaBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        baseMapping: _liberationsans_widths.LiberationSansBoldItalicMapping,
                        metrics: _helvetica_factors.HelveticaBoldItalicMetrics
                    };
                });
                function getXfaFontName(name) {
                    const fontName = (0, _fonts_utils.normalizeFontName)(name);
                    const fontMap = getXFAFontMap();
                    return fontMap[fontName];
                }
                function getXfaFontWidths(name) {
                    const info = getXfaFontName(name);
                    if (!info) return null;
                    const { baseWidths: baseWidths, baseMapping: baseMapping, factors: factors } = info;
                    const rescaledBaseWidths = !factors ? baseWidths : baseWidths.map((w, i)=>w * factors[i]);
                    let currentCode = -2;
                    let currentArray;
                    const newWidths = [];
                    for (const [unicode, glyphIndex] of baseMapping.map((charUnicode, index)=>[
                            charUnicode,
                            index
                        ]).sort(([unicode1], [unicode2])=>unicode1 - unicode2)){
                        if (unicode === -1) continue;
                        if (unicode === currentCode + 1) {
                            currentArray.push(rescaledBaseWidths[glyphIndex]);
                            currentCode += 1;
                        } else {
                            currentCode = unicode;
                            currentArray = [
                                rescaledBaseWidths[glyphIndex]
                            ];
                            newWidths.push(unicode, currentArray);
                        }
                    }
                    return newWidths;
                }
                function getXfaFontDict(name) {
                    const widths = getXfaFontWidths(name);
                    const dict = new _primitives.Dict(null);
                    dict.set("BaseFont", _primitives.Name.get(name));
                    dict.set("Type", _primitives.Name.get("Font"));
                    dict.set("Subtype", _primitives.Name.get("CIDFontType2"));
                    dict.set("Encoding", _primitives.Name.get("Identity-H"));
                    dict.set("CIDToGIDMap", _primitives.Name.get("Identity"));
                    dict.set("W", widths);
                    dict.set("FirstChar", widths[0]);
                    dict.set("LastChar", widths.at(-2) + widths.at(-1).length - 1);
                    const descriptor = new _primitives.Dict(null);
                    dict.set("FontDescriptor", descriptor);
                    const systemInfo = new _primitives.Dict(null);
                    systemInfo.set("Ordering", "Identity");
                    systemInfo.set("Registry", "Adobe");
                    systemInfo.set("Supplement", 0);
                    dict.set("CIDSystemInfo", systemInfo);
                    return dict;
                }
            /***/ },
            /* 52 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CalibriRegularMetrics = exports.CalibriRegularFactors = exports.CalibriItalicMetrics = exports.CalibriItalicFactors = exports.CalibriBoldMetrics = exports.CalibriBoldItalicMetrics = exports.CalibriBoldItalicFactors = exports.CalibriBoldFactors = void 0;
                const CalibriBoldFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    0.97801,
                    0.92482,
                    0.89552,
                    0.91133,
                    0.81988,
                    0.97566,
                    0.98152,
                    0.93548,
                    0.93548,
                    1.2798,
                    0.85284,
                    0.92794,
                    1,
                    0.96134,
                    1.54657,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.82845,
                    0.82845,
                    0.85284,
                    0.85284,
                    0.85284,
                    0.75859,
                    0.92138,
                    0.83908,
                    0.7762,
                    0.73293,
                    0.87289,
                    0.73133,
                    0.7514,
                    0.81921,
                    0.87356,
                    0.95958,
                    0.59526,
                    0.75727,
                    0.69225,
                    1.04924,
                    0.9121,
                    0.86943,
                    0.79795,
                    0.88198,
                    0.77958,
                    0.70864,
                    0.81055,
                    0.90399,
                    0.88653,
                    0.96017,
                    0.82577,
                    0.77892,
                    0.78257,
                    0.97507,
                    1.54657,
                    0.97507,
                    0.85284,
                    0.89552,
                    0.90176,
                    0.88762,
                    0.8785,
                    0.75241,
                    0.8785,
                    0.90518,
                    0.95015,
                    0.77618,
                    0.8785,
                    0.88401,
                    0.91916,
                    0.86304,
                    0.88401,
                    0.91488,
                    0.8785,
                    0.8801,
                    0.8785,
                    0.8785,
                    0.91343,
                    0.7173,
                    1.04106,
                    0.8785,
                    0.85075,
                    0.95794,
                    0.82616,
                    0.85162,
                    0.79492,
                    0.88331,
                    1.69808,
                    0.88331,
                    0.85284,
                    0.97801,
                    0.89552,
                    0.91133,
                    0.89552,
                    0.91133,
                    1.7801,
                    0.89552,
                    1.24487,
                    1.13254,
                    1.12401,
                    0.96839,
                    0.85284,
                    0.68787,
                    0.70645,
                    0.85592,
                    0.90747,
                    1.01466,
                    1.0088,
                    0.90323,
                    1,
                    1.07463,
                    1,
                    0.91056,
                    0.75806,
                    1.19118,
                    0.96839,
                    0.78864,
                    0.82845,
                    0.84133,
                    0.75859,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.77539,
                    0.73293,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.88506,
                    0.9121,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.85284,
                    0.87508,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.77892,
                    0.79795,
                    0.90807,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.8715,
                    0.75241,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.8785,
                    0.8785,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.90747,
                    0.89049,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.85162,
                    0.8785,
                    0.85162,
                    0.83908,
                    0.88762,
                    0.83908,
                    0.88762,
                    0.83908,
                    0.88762,
                    0.73293,
                    0.75241,
                    0.73293,
                    0.75241,
                    0.73293,
                    0.75241,
                    0.73293,
                    0.75241,
                    0.87289,
                    0.83016,
                    0.88506,
                    0.93125,
                    0.73133,
                    0.90518,
                    0.73133,
                    0.90518,
                    0.73133,
                    0.90518,
                    0.73133,
                    0.90518,
                    0.73133,
                    0.90518,
                    0.81921,
                    0.77618,
                    0.81921,
                    0.77618,
                    0.81921,
                    0.77618,
                    1,
                    1,
                    0.87356,
                    0.8785,
                    0.91075,
                    0.89608,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.76229,
                    0.90167,
                    0.59526,
                    0.91916,
                    1,
                    1,
                    0.86304,
                    0.69225,
                    0.88401,
                    1,
                    1,
                    0.70424,
                    0.79468,
                    0.91926,
                    0.88175,
                    0.70823,
                    0.94903,
                    0.9121,
                    0.8785,
                    1,
                    1,
                    0.9121,
                    0.8785,
                    0.87802,
                    0.88656,
                    0.8785,
                    0.86943,
                    0.8801,
                    0.86943,
                    0.8801,
                    0.86943,
                    0.8801,
                    0.87402,
                    0.89291,
                    0.77958,
                    0.91343,
                    1,
                    1,
                    0.77958,
                    0.91343,
                    0.70864,
                    0.7173,
                    0.70864,
                    0.7173,
                    0.70864,
                    0.7173,
                    0.70864,
                    0.7173,
                    1,
                    1,
                    0.81055,
                    0.75841,
                    0.81055,
                    1.06452,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.90399,
                    0.8785,
                    0.96017,
                    0.95794,
                    0.77892,
                    0.85162,
                    0.77892,
                    0.78257,
                    0.79492,
                    0.78257,
                    0.79492,
                    0.78257,
                    0.79492,
                    0.9297,
                    0.56892,
                    0.83908,
                    0.88762,
                    0.77539,
                    0.8715,
                    0.87508,
                    0.89049,
                    1,
                    1,
                    0.81055,
                    1.04106,
                    1.20528,
                    1.20528,
                    1,
                    1.15543,
                    0.70674,
                    0.98387,
                    0.94721,
                    1.33431,
                    1.45894,
                    0.95161,
                    1.06303,
                    0.83908,
                    0.80352,
                    0.57184,
                    0.6965,
                    0.56289,
                    0.82001,
                    0.56029,
                    0.81235,
                    1.02988,
                    0.83908,
                    0.7762,
                    0.68156,
                    0.80367,
                    0.73133,
                    0.78257,
                    0.87356,
                    0.86943,
                    0.95958,
                    0.75727,
                    0.89019,
                    1.04924,
                    0.9121,
                    0.7648,
                    0.86943,
                    0.87356,
                    0.79795,
                    0.78275,
                    0.81055,
                    0.77892,
                    0.9762,
                    0.82577,
                    0.99819,
                    0.84896,
                    0.95958,
                    0.77892,
                    0.96108,
                    1.01407,
                    0.89049,
                    1.02988,
                    0.94211,
                    0.96108,
                    0.8936,
                    0.84021,
                    0.87842,
                    0.96399,
                    0.79109,
                    0.89049,
                    1.00813,
                    1.02988,
                    0.86077,
                    0.87445,
                    0.92099,
                    0.84723,
                    0.86513,
                    0.8801,
                    0.75638,
                    0.85714,
                    0.78216,
                    0.79586,
                    0.87965,
                    0.94211,
                    0.97747,
                    0.78287,
                    0.97926,
                    0.84971,
                    1.02988,
                    0.94211,
                    0.8801,
                    0.94211,
                    0.84971,
                    0.73133,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90264,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90518,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90548,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96017,
                    0.95794,
                    0.96017,
                    0.95794,
                    0.96017,
                    0.95794,
                    0.77892,
                    0.85162,
                    1,
                    1,
                    0.89552,
                    0.90527,
                    1,
                    0.90363,
                    0.92794,
                    0.92794,
                    0.92794,
                    0.92794,
                    0.87012,
                    0.87012,
                    0.87012,
                    0.89552,
                    0.89552,
                    1.42259,
                    0.71143,
                    1.06152,
                    1,
                    1,
                    1.03372,
                    1.03372,
                    0.97171,
                    1.4956,
                    2.2807,
                    0.93835,
                    0.83406,
                    0.91133,
                    0.84107,
                    0.91133,
                    1,
                    1,
                    1,
                    0.72021,
                    1,
                    1.23108,
                    0.83489,
                    0.88525,
                    0.88525,
                    0.81499,
                    0.90527,
                    1.81055,
                    0.90527,
                    1.81055,
                    1.31006,
                    1.53711,
                    0.94434,
                    1.08696,
                    1,
                    0.95018,
                    0.77192,
                    0.85284,
                    0.90747,
                    1.17534,
                    0.69825,
                    0.9716,
                    1.37077,
                    0.90747,
                    0.90747,
                    0.85356,
                    0.90747,
                    0.90747,
                    1.44947,
                    0.85284,
                    0.8941,
                    0.8941,
                    0.70572,
                    0.8,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.08004,
                    0.91027,
                    1,
                    1,
                    1,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90727,
                    0.90727,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.CalibriBoldFactors = CalibriBoldFactors;
                const CalibriBoldMetrics = {
                    lineHeight: 1.2207,
                    lineGap: 0.2207
                };
                exports.CalibriBoldMetrics = CalibriBoldMetrics;
                const CalibriBoldItalicFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    0.97801,
                    0.92482,
                    0.89552,
                    0.91133,
                    0.81988,
                    0.97566,
                    0.98152,
                    0.93548,
                    0.93548,
                    1.2798,
                    0.85284,
                    0.92794,
                    1,
                    0.96134,
                    1.56239,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.82845,
                    0.82845,
                    0.85284,
                    0.85284,
                    0.85284,
                    0.75859,
                    0.92138,
                    0.83908,
                    0.7762,
                    0.71805,
                    0.87289,
                    0.73133,
                    0.7514,
                    0.81921,
                    0.87356,
                    0.95958,
                    0.59526,
                    0.75727,
                    0.69225,
                    1.04924,
                    0.90872,
                    0.85938,
                    0.79795,
                    0.87068,
                    0.77958,
                    0.69766,
                    0.81055,
                    0.90399,
                    0.88653,
                    0.96068,
                    0.82577,
                    0.77892,
                    0.78257,
                    0.97507,
                    1.529,
                    0.97507,
                    0.85284,
                    0.89552,
                    0.90176,
                    0.94908,
                    0.86411,
                    0.74012,
                    0.86411,
                    0.88323,
                    0.95015,
                    0.86411,
                    0.86331,
                    0.88401,
                    0.91916,
                    0.86304,
                    0.88401,
                    0.9039,
                    0.86331,
                    0.86331,
                    0.86411,
                    0.86411,
                    0.90464,
                    0.70852,
                    1.04106,
                    0.86331,
                    0.84372,
                    0.95794,
                    0.82616,
                    0.84548,
                    0.79492,
                    0.88331,
                    1.69808,
                    0.88331,
                    0.85284,
                    0.97801,
                    0.89552,
                    0.91133,
                    0.89552,
                    0.91133,
                    1.7801,
                    0.89552,
                    1.24487,
                    1.13254,
                    1.19129,
                    0.96839,
                    0.85284,
                    0.68787,
                    0.70645,
                    0.85592,
                    0.90747,
                    1.01466,
                    1.0088,
                    0.90323,
                    1,
                    1.07463,
                    1,
                    0.91056,
                    0.75806,
                    1.19118,
                    0.96839,
                    0.78864,
                    0.82845,
                    0.84133,
                    0.75859,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.77539,
                    0.71805,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.88506,
                    0.90872,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85284,
                    0.87068,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.77892,
                    0.79795,
                    0.90807,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.85887,
                    0.74012,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.8785,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.90747,
                    0.89049,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.84548,
                    0.86411,
                    0.84548,
                    0.83908,
                    0.94908,
                    0.83908,
                    0.94908,
                    0.83908,
                    0.94908,
                    0.71805,
                    0.74012,
                    0.71805,
                    0.74012,
                    0.71805,
                    0.74012,
                    0.71805,
                    0.74012,
                    0.87289,
                    0.79538,
                    0.88506,
                    0.92726,
                    0.73133,
                    0.88323,
                    0.73133,
                    0.88323,
                    0.73133,
                    0.88323,
                    0.73133,
                    0.88323,
                    0.73133,
                    0.88323,
                    0.81921,
                    0.86411,
                    0.81921,
                    0.86411,
                    0.81921,
                    0.86411,
                    1,
                    1,
                    0.87356,
                    0.86331,
                    0.91075,
                    0.8777,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.95958,
                    0.88401,
                    0.76467,
                    0.90167,
                    0.59526,
                    0.91916,
                    1,
                    1,
                    0.86304,
                    0.69225,
                    0.88401,
                    1,
                    1,
                    0.70424,
                    0.77312,
                    0.91926,
                    0.88175,
                    0.70823,
                    0.94903,
                    0.90872,
                    0.86331,
                    1,
                    1,
                    0.90872,
                    0.86331,
                    0.86906,
                    0.88116,
                    0.86331,
                    0.85938,
                    0.86331,
                    0.85938,
                    0.86331,
                    0.85938,
                    0.86331,
                    0.87402,
                    0.86549,
                    0.77958,
                    0.90464,
                    1,
                    1,
                    0.77958,
                    0.90464,
                    0.69766,
                    0.70852,
                    0.69766,
                    0.70852,
                    0.69766,
                    0.70852,
                    0.69766,
                    0.70852,
                    1,
                    1,
                    0.81055,
                    0.75841,
                    0.81055,
                    1.06452,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.90399,
                    0.86331,
                    0.96068,
                    0.95794,
                    0.77892,
                    0.84548,
                    0.77892,
                    0.78257,
                    0.79492,
                    0.78257,
                    0.79492,
                    0.78257,
                    0.79492,
                    0.9297,
                    0.56892,
                    0.83908,
                    0.94908,
                    0.77539,
                    0.85887,
                    0.87068,
                    0.89049,
                    1,
                    1,
                    0.81055,
                    1.04106,
                    1.20528,
                    1.20528,
                    1,
                    1.15543,
                    0.70088,
                    0.98387,
                    0.94721,
                    1.33431,
                    1.45894,
                    0.95161,
                    1.48387,
                    0.83908,
                    0.80352,
                    0.57118,
                    0.6965,
                    0.56347,
                    0.79179,
                    0.55853,
                    0.80346,
                    1.02988,
                    0.83908,
                    0.7762,
                    0.67174,
                    0.86036,
                    0.73133,
                    0.78257,
                    0.87356,
                    0.86441,
                    0.95958,
                    0.75727,
                    0.89019,
                    1.04924,
                    0.90872,
                    0.74889,
                    0.85938,
                    0.87891,
                    0.79795,
                    0.7957,
                    0.81055,
                    0.77892,
                    0.97447,
                    0.82577,
                    0.97466,
                    0.87179,
                    0.95958,
                    0.77892,
                    0.94252,
                    0.95612,
                    0.8753,
                    1.02988,
                    0.92733,
                    0.94252,
                    0.87411,
                    0.84021,
                    0.8728,
                    0.95612,
                    0.74081,
                    0.8753,
                    1.02189,
                    1.02988,
                    0.84814,
                    0.87445,
                    0.91822,
                    0.84723,
                    0.85668,
                    0.86331,
                    0.81344,
                    0.87581,
                    0.76422,
                    0.82046,
                    0.96057,
                    0.92733,
                    0.99375,
                    0.78022,
                    0.95452,
                    0.86015,
                    1.02988,
                    0.92733,
                    0.86331,
                    0.92733,
                    0.86015,
                    0.73133,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90631,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.88323,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.85174,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96068,
                    0.95794,
                    0.96068,
                    0.95794,
                    0.96068,
                    0.95794,
                    0.77892,
                    0.84548,
                    1,
                    1,
                    0.89552,
                    0.90527,
                    1,
                    0.90363,
                    0.92794,
                    0.92794,
                    0.92794,
                    0.89807,
                    0.87012,
                    0.87012,
                    0.87012,
                    0.89552,
                    0.89552,
                    1.42259,
                    0.71094,
                    1.06152,
                    1,
                    1,
                    1.03372,
                    1.03372,
                    0.97171,
                    1.4956,
                    2.2807,
                    0.92972,
                    0.83406,
                    0.91133,
                    0.83326,
                    0.91133,
                    1,
                    1,
                    1,
                    0.72021,
                    1,
                    1.23108,
                    0.83489,
                    0.88525,
                    0.88525,
                    0.81499,
                    0.90616,
                    1.81055,
                    0.90527,
                    1.81055,
                    1.3107,
                    1.53711,
                    0.94434,
                    1.08696,
                    1,
                    0.95018,
                    0.77192,
                    0.85284,
                    0.90747,
                    1.17534,
                    0.69825,
                    0.9716,
                    1.37077,
                    0.90747,
                    0.90747,
                    0.85356,
                    0.90747,
                    0.90747,
                    1.44947,
                    0.85284,
                    0.8941,
                    0.8941,
                    0.70572,
                    0.8,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.08004,
                    0.91027,
                    1,
                    1,
                    1,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90727,
                    0.90727,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.CalibriBoldItalicFactors = CalibriBoldItalicFactors;
                const CalibriBoldItalicMetrics = {
                    lineHeight: 1.2207,
                    lineGap: 0.2207
                };
                exports.CalibriBoldItalicMetrics = CalibriBoldItalicMetrics;
                const CalibriItalicFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    1.17223,
                    1.1293,
                    0.89552,
                    0.91133,
                    0.80395,
                    1.02269,
                    1.15601,
                    0.91056,
                    0.91056,
                    1.2798,
                    0.85284,
                    0.89807,
                    1,
                    0.90861,
                    1.39543,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.96309,
                    0.96309,
                    0.85284,
                    0.85284,
                    0.85284,
                    0.83319,
                    0.88071,
                    0.8675,
                    0.81552,
                    0.72346,
                    0.85193,
                    0.73206,
                    0.7522,
                    0.81105,
                    0.86275,
                    0.90685,
                    0.6377,
                    0.77892,
                    0.75593,
                    1.02638,
                    0.89249,
                    0.84118,
                    0.77452,
                    0.85374,
                    0.75186,
                    0.67789,
                    0.79776,
                    0.88844,
                    0.85066,
                    0.94309,
                    0.77818,
                    0.7306,
                    0.76659,
                    1.10369,
                    1.38313,
                    1.10369,
                    1.06139,
                    0.89552,
                    0.8739,
                    0.9245,
                    0.9245,
                    0.83203,
                    0.9245,
                    0.85865,
                    1.09842,
                    0.9245,
                    0.9245,
                    1.03297,
                    1.07692,
                    0.90918,
                    1.03297,
                    0.94959,
                    0.9245,
                    0.92274,
                    0.9245,
                    0.9245,
                    1.02933,
                    0.77832,
                    1.20562,
                    0.9245,
                    0.8916,
                    0.98986,
                    0.86621,
                    0.89453,
                    0.79004,
                    0.94152,
                    1.77256,
                    0.94152,
                    0.85284,
                    0.97801,
                    0.89552,
                    0.91133,
                    0.89552,
                    0.91133,
                    1.91729,
                    0.89552,
                    1.17889,
                    1.13254,
                    1.16359,
                    0.92098,
                    0.85284,
                    0.68787,
                    0.71353,
                    0.84737,
                    0.90747,
                    1.0088,
                    1.0044,
                    0.87683,
                    1,
                    1.09091,
                    1,
                    0.92229,
                    0.739,
                    1.15642,
                    0.92098,
                    0.76288,
                    0.80504,
                    0.80972,
                    0.75859,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.76318,
                    0.72346,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.86477,
                    0.89249,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.85284,
                    0.84557,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.7306,
                    0.77452,
                    0.86331,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.84843,
                    0.83203,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.94469,
                    0.9245,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.90747,
                    0.86651,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.89453,
                    0.9245,
                    0.89453,
                    0.8675,
                    0.9245,
                    0.8675,
                    0.9245,
                    0.8675,
                    0.9245,
                    0.72346,
                    0.83203,
                    0.72346,
                    0.83203,
                    0.72346,
                    0.83203,
                    0.72346,
                    0.83203,
                    0.85193,
                    0.8875,
                    0.86477,
                    0.99034,
                    0.73206,
                    0.85865,
                    0.73206,
                    0.85865,
                    0.73206,
                    0.85865,
                    0.73206,
                    0.85865,
                    0.73206,
                    0.85865,
                    0.81105,
                    0.9245,
                    0.81105,
                    0.9245,
                    0.81105,
                    0.9245,
                    1,
                    1,
                    0.86275,
                    0.9245,
                    0.90872,
                    0.93591,
                    0.90685,
                    0.82601,
                    0.90685,
                    0.82601,
                    0.90685,
                    0.82601,
                    0.90685,
                    1.03297,
                    0.90685,
                    0.82601,
                    0.77896,
                    1.05611,
                    0.6377,
                    1.07692,
                    1,
                    1,
                    0.90918,
                    0.75593,
                    1.03297,
                    1,
                    1,
                    0.76032,
                    0.9375,
                    0.98156,
                    0.93407,
                    0.77261,
                    1.11429,
                    0.89249,
                    0.9245,
                    1,
                    1,
                    0.89249,
                    0.9245,
                    0.92534,
                    0.86698,
                    0.9245,
                    0.84118,
                    0.92274,
                    0.84118,
                    0.92274,
                    0.84118,
                    0.92274,
                    0.8667,
                    0.86291,
                    0.75186,
                    1.02933,
                    1,
                    1,
                    0.75186,
                    1.02933,
                    0.67789,
                    0.77832,
                    0.67789,
                    0.77832,
                    0.67789,
                    0.77832,
                    0.67789,
                    0.77832,
                    1,
                    1,
                    0.79776,
                    0.97655,
                    0.79776,
                    1.23023,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.88844,
                    0.9245,
                    0.94309,
                    0.98986,
                    0.7306,
                    0.89453,
                    0.7306,
                    0.76659,
                    0.79004,
                    0.76659,
                    0.79004,
                    0.76659,
                    0.79004,
                    1.09231,
                    0.54873,
                    0.8675,
                    0.9245,
                    0.76318,
                    0.84843,
                    0.84557,
                    0.86651,
                    1,
                    1,
                    0.79776,
                    1.20562,
                    1.18622,
                    1.18622,
                    1,
                    1.1437,
                    0.67009,
                    0.96334,
                    0.93695,
                    1.35191,
                    1.40909,
                    0.95161,
                    1.48387,
                    0.8675,
                    0.90861,
                    0.6192,
                    0.7363,
                    0.64824,
                    0.82411,
                    0.56321,
                    0.85696,
                    1.23516,
                    0.8675,
                    0.81552,
                    0.7286,
                    0.84134,
                    0.73206,
                    0.76659,
                    0.86275,
                    0.84369,
                    0.90685,
                    0.77892,
                    0.85871,
                    1.02638,
                    0.89249,
                    0.75828,
                    0.84118,
                    0.85984,
                    0.77452,
                    0.76466,
                    0.79776,
                    0.7306,
                    0.90782,
                    0.77818,
                    0.903,
                    0.87291,
                    0.90685,
                    0.7306,
                    0.99058,
                    1.03667,
                    0.94635,
                    1.23516,
                    0.9849,
                    0.99058,
                    0.92393,
                    0.8916,
                    0.942,
                    1.03667,
                    0.75026,
                    0.94635,
                    1.0297,
                    1.23516,
                    0.90918,
                    0.94048,
                    0.98217,
                    0.89746,
                    0.84153,
                    0.92274,
                    0.82507,
                    0.88832,
                    0.84438,
                    0.88178,
                    1.03525,
                    0.9849,
                    1.00225,
                    0.78086,
                    0.97248,
                    0.89404,
                    1.23516,
                    0.9849,
                    0.92274,
                    0.9849,
                    0.89404,
                    0.73206,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.89693,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.85865,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90933,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.94309,
                    0.98986,
                    0.94309,
                    0.98986,
                    0.94309,
                    0.98986,
                    0.7306,
                    0.89453,
                    1,
                    1,
                    0.89552,
                    0.90527,
                    1,
                    0.90186,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.2566,
                    1.2566,
                    1.2566,
                    0.89552,
                    0.89552,
                    1.42259,
                    0.68994,
                    1.03809,
                    1,
                    1,
                    1.0176,
                    1.0176,
                    1.11523,
                    1.4956,
                    2.01462,
                    0.97858,
                    0.82616,
                    0.91133,
                    0.83437,
                    0.91133,
                    1,
                    1,
                    1,
                    0.70508,
                    1,
                    1.23108,
                    0.79801,
                    0.84426,
                    0.84426,
                    0.774,
                    0.90572,
                    1.81055,
                    0.90749,
                    1.81055,
                    1.28809,
                    1.55469,
                    0.94434,
                    1.07806,
                    1,
                    0.97094,
                    0.7589,
                    0.85284,
                    0.90747,
                    1.19658,
                    0.69825,
                    0.97622,
                    1.33512,
                    0.90747,
                    0.90747,
                    0.85284,
                    0.90747,
                    0.90747,
                    1.44947,
                    0.85284,
                    0.8941,
                    0.8941,
                    0.70572,
                    0.8,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.0336,
                    0.91027,
                    1,
                    1,
                    1,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05859,
                    1.05859,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.CalibriItalicFactors = CalibriItalicFactors;
                const CalibriItalicMetrics = {
                    lineHeight: 1.2207,
                    lineGap: 0.2207
                };
                exports.CalibriItalicMetrics = CalibriItalicMetrics;
                const CalibriRegularFactors = [
                    1.3877,
                    1,
                    1,
                    1,
                    1.17223,
                    1.1293,
                    0.89552,
                    0.91133,
                    0.80395,
                    1.02269,
                    1.15601,
                    0.91056,
                    0.91056,
                    1.2798,
                    0.85284,
                    0.89807,
                    1,
                    0.90861,
                    1.39016,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.91133,
                    0.96309,
                    0.96309,
                    0.85284,
                    0.85284,
                    0.85284,
                    0.83319,
                    0.88071,
                    0.8675,
                    0.81552,
                    0.73834,
                    0.85193,
                    0.73206,
                    0.7522,
                    0.81105,
                    0.86275,
                    0.90685,
                    0.6377,
                    0.77892,
                    0.75593,
                    1.02638,
                    0.89385,
                    0.85122,
                    0.77452,
                    0.86503,
                    0.75186,
                    0.68887,
                    0.79776,
                    0.88844,
                    0.85066,
                    0.94258,
                    0.77818,
                    0.7306,
                    0.76659,
                    1.10369,
                    1.39016,
                    1.10369,
                    1.06139,
                    0.89552,
                    0.8739,
                    0.86128,
                    0.94469,
                    0.8457,
                    0.94469,
                    0.89464,
                    1.09842,
                    0.84636,
                    0.94469,
                    1.03297,
                    1.07692,
                    0.90918,
                    1.03297,
                    0.95897,
                    0.94469,
                    0.9482,
                    0.94469,
                    0.94469,
                    1.04692,
                    0.78223,
                    1.20562,
                    0.94469,
                    0.90332,
                    0.98986,
                    0.86621,
                    0.90527,
                    0.79004,
                    0.94152,
                    1.77256,
                    0.94152,
                    0.85284,
                    0.97801,
                    0.89552,
                    0.91133,
                    0.89552,
                    0.91133,
                    1.91729,
                    0.89552,
                    1.17889,
                    1.13254,
                    1.08707,
                    0.92098,
                    0.85284,
                    0.68787,
                    0.71353,
                    0.84737,
                    0.90747,
                    1.0088,
                    1.0044,
                    0.87683,
                    1,
                    1.09091,
                    1,
                    0.92229,
                    0.739,
                    1.15642,
                    0.92098,
                    0.76288,
                    0.80504,
                    0.80972,
                    0.75859,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.76318,
                    0.73834,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.86477,
                    0.89385,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85284,
                    0.85311,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.7306,
                    0.77452,
                    0.86331,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.8693,
                    0.8457,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.94469,
                    0.94469,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.90747,
                    0.86651,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.90527,
                    0.94469,
                    0.90527,
                    0.8675,
                    0.86128,
                    0.8675,
                    0.86128,
                    0.8675,
                    0.86128,
                    0.73834,
                    0.8457,
                    0.73834,
                    0.8457,
                    0.73834,
                    0.8457,
                    0.73834,
                    0.8457,
                    0.85193,
                    0.92454,
                    0.86477,
                    0.9921,
                    0.73206,
                    0.89464,
                    0.73206,
                    0.89464,
                    0.73206,
                    0.89464,
                    0.73206,
                    0.89464,
                    0.73206,
                    0.89464,
                    0.81105,
                    0.84636,
                    0.81105,
                    0.84636,
                    0.81105,
                    0.84636,
                    1,
                    1,
                    0.86275,
                    0.94469,
                    0.90872,
                    0.95786,
                    0.90685,
                    0.82601,
                    0.90685,
                    0.82601,
                    0.90685,
                    0.82601,
                    0.90685,
                    1.03297,
                    0.90685,
                    0.82601,
                    0.77741,
                    1.05611,
                    0.6377,
                    1.07692,
                    1,
                    1,
                    0.90918,
                    0.75593,
                    1.03297,
                    1,
                    1,
                    0.76032,
                    0.90452,
                    0.98156,
                    1.11842,
                    0.77261,
                    1.11429,
                    0.89385,
                    0.94469,
                    1,
                    1,
                    0.89385,
                    0.94469,
                    0.95877,
                    0.86901,
                    0.94469,
                    0.85122,
                    0.9482,
                    0.85122,
                    0.9482,
                    0.85122,
                    0.9482,
                    0.8667,
                    0.90016,
                    0.75186,
                    1.04692,
                    1,
                    1,
                    0.75186,
                    1.04692,
                    0.68887,
                    0.78223,
                    0.68887,
                    0.78223,
                    0.68887,
                    0.78223,
                    0.68887,
                    0.78223,
                    1,
                    1,
                    0.79776,
                    0.92188,
                    0.79776,
                    1.23023,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.88844,
                    0.94469,
                    0.94258,
                    0.98986,
                    0.7306,
                    0.90527,
                    0.7306,
                    0.76659,
                    0.79004,
                    0.76659,
                    0.79004,
                    0.76659,
                    0.79004,
                    1.09231,
                    0.54873,
                    0.8675,
                    0.86128,
                    0.76318,
                    0.8693,
                    0.85311,
                    0.86651,
                    1,
                    1,
                    0.79776,
                    1.20562,
                    1.18622,
                    1.18622,
                    1,
                    1.1437,
                    0.67742,
                    0.96334,
                    0.93695,
                    1.35191,
                    1.40909,
                    0.95161,
                    1.48387,
                    0.86686,
                    0.90861,
                    0.62267,
                    0.74359,
                    0.65649,
                    0.85498,
                    0.56963,
                    0.88254,
                    1.23516,
                    0.8675,
                    0.81552,
                    0.75443,
                    0.84503,
                    0.73206,
                    0.76659,
                    0.86275,
                    0.85122,
                    0.90685,
                    0.77892,
                    0.85746,
                    1.02638,
                    0.89385,
                    0.75657,
                    0.85122,
                    0.86275,
                    0.77452,
                    0.74171,
                    0.79776,
                    0.7306,
                    0.95165,
                    0.77818,
                    0.89772,
                    0.88831,
                    0.90685,
                    0.7306,
                    0.98142,
                    1.02191,
                    0.96576,
                    1.23516,
                    0.99018,
                    0.98142,
                    0.9236,
                    0.89258,
                    0.94035,
                    1.02191,
                    0.78848,
                    0.96576,
                    0.9561,
                    1.23516,
                    0.90918,
                    0.92578,
                    0.95424,
                    0.89746,
                    0.83969,
                    0.9482,
                    0.80113,
                    0.89442,
                    0.85208,
                    0.86155,
                    0.98022,
                    0.99018,
                    1.00452,
                    0.81209,
                    0.99247,
                    0.89181,
                    1.23516,
                    0.99018,
                    0.9482,
                    0.99018,
                    0.89181,
                    0.73206,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.88844,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.89464,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96766,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.94258,
                    0.98986,
                    0.94258,
                    0.98986,
                    0.94258,
                    0.98986,
                    0.7306,
                    0.90527,
                    1,
                    1,
                    0.89552,
                    0.90527,
                    1,
                    0.90186,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.2566,
                    1.2566,
                    1.2566,
                    0.89552,
                    0.89552,
                    1.42259,
                    0.69043,
                    1.03809,
                    1,
                    1,
                    1.0176,
                    1.0176,
                    1.11523,
                    1.4956,
                    2.01462,
                    0.99331,
                    0.82616,
                    0.91133,
                    0.84286,
                    0.91133,
                    1,
                    1,
                    1,
                    0.70508,
                    1,
                    1.23108,
                    0.79801,
                    0.84426,
                    0.84426,
                    0.774,
                    0.90527,
                    1.81055,
                    0.90527,
                    1.81055,
                    1.28809,
                    1.55469,
                    0.94434,
                    1.07806,
                    1,
                    0.97094,
                    0.7589,
                    0.85284,
                    0.90747,
                    1.19658,
                    0.69825,
                    0.97622,
                    1.33512,
                    0.90747,
                    0.90747,
                    0.85356,
                    0.90747,
                    0.90747,
                    1.44947,
                    0.85284,
                    0.8941,
                    0.8941,
                    0.70572,
                    0.8,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.0336,
                    0.91027,
                    1,
                    1,
                    1,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05859,
                    1.05859,
                    1,
                    1,
                    1,
                    1.07185,
                    0.99413,
                    0.96334,
                    1.08065,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.CalibriRegularFactors = CalibriRegularFactors;
                const CalibriRegularMetrics = {
                    lineHeight: 1.2207,
                    lineGap: 0.2207
                };
                exports.CalibriRegularMetrics = CalibriRegularMetrics;
            /***/ },
            /* 53 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HelveticaRegularMetrics = exports.HelveticaRegularFactors = exports.HelveticaItalicMetrics = exports.HelveticaItalicFactors = exports.HelveticaBoldMetrics = exports.HelveticaBoldItalicMetrics = exports.HelveticaBoldItalicFactors = exports.HelveticaBoldFactors = void 0;
                const HelveticaBoldFactors = [
                    0.76116,
                    1,
                    1,
                    1.0006,
                    0.99998,
                    0.99974,
                    0.99973,
                    0.99973,
                    0.99982,
                    0.99977,
                    1.00087,
                    0.99998,
                    0.99998,
                    0.99959,
                    1.00003,
                    1.0006,
                    0.99998,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    1.00026,
                    0.9999,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    0.99977,
                    1.0006,
                    0.99973,
                    0.99977,
                    1.00026,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    0.99977,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99998,
                    1.0006,
                    0.99998,
                    1.00003,
                    0.99973,
                    0.99998,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00026,
                    0.99973,
                    0.99998,
                    1.00026,
                    1.00026,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.0006,
                    0.99982,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99959,
                    0.99973,
                    0.99998,
                    1.00026,
                    0.99973,
                    1.00022,
                    0.99973,
                    0.99973,
                    1,
                    0.99959,
                    1.00077,
                    0.99959,
                    1.00003,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00077,
                    0.99973,
                    0.99998,
                    1.00025,
                    0.99968,
                    0.99973,
                    1.00003,
                    1.00025,
                    0.60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    0.99998,
                    1,
                    0.99973,
                    1.0006,
                    0.99998,
                    1,
                    0.99936,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99982,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.06409,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00026,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    1.03374,
                    0.99977,
                    1.00026,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00042,
                    0.99973,
                    0.99973,
                    1.0006,
                    0.99977,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.03828,
                    1.00026,
                    0.99999,
                    1.00026,
                    1.0006,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.9993,
                    0.9998,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1,
                    1.00016,
                    0.99977,
                    0.99959,
                    0.99977,
                    0.99959,
                    0.99977,
                    0.99959,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00026,
                    0.99998,
                    1.00026,
                    0.8121,
                    1.00026,
                    0.99998,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    1.00016,
                    1.00022,
                    1.00001,
                    0.99973,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.0006,
                    0.99973,
                    0.99977,
                    0.99973,
                    1,
                    0.99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    0.99973,
                    1.00026,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1.00034,
                    0.99977,
                    1,
                    0.99997,
                    1.00026,
                    1.00078,
                    1.00036,
                    0.99973,
                    1.00013,
                    1.0006,
                    0.99977,
                    0.99977,
                    0.99988,
                    0.85148,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00022,
                    1.0006,
                    0.99977,
                    1.00001,
                    0.99999,
                    0.99977,
                    1.00069,
                    1.00022,
                    0.99977,
                    1.00001,
                    0.99984,
                    1.00026,
                    1.00001,
                    1.00024,
                    1.00001,
                    0.9999,
                    1,
                    1.0006,
                    1.00001,
                    1.00041,
                    0.99962,
                    1.00026,
                    1.0006,
                    0.99995,
                    1.00041,
                    0.99942,
                    0.99973,
                    0.99927,
                    1.00082,
                    0.99902,
                    1.00026,
                    1.00087,
                    1.0006,
                    1.00069,
                    0.99973,
                    0.99867,
                    0.99973,
                    0.9993,
                    1.00026,
                    1.00049,
                    1.00056,
                    1,
                    0.99988,
                    0.99935,
                    0.99995,
                    0.99954,
                    1.00055,
                    0.99945,
                    1.00032,
                    1.0006,
                    0.99995,
                    1.00026,
                    0.99995,
                    1.00032,
                    1.00001,
                    1.00008,
                    0.99971,
                    1.00019,
                    0.9994,
                    1.00001,
                    1.0006,
                    1.00044,
                    0.99973,
                    1.00023,
                    1.00047,
                    1,
                    0.99942,
                    0.99561,
                    0.99989,
                    1.00035,
                    0.99977,
                    1.00035,
                    0.99977,
                    1.00019,
                    0.99944,
                    1.00001,
                    1.00021,
                    0.99926,
                    1.00035,
                    1.00035,
                    0.99942,
                    1.00048,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00035,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.99989,
                    1.00057,
                    1.00001,
                    0.99936,
                    1.00052,
                    1.00012,
                    0.99996,
                    1.00043,
                    1,
                    1.00035,
                    0.9994,
                    0.99976,
                    1.00035,
                    0.99973,
                    1.00052,
                    1.00041,
                    1.00119,
                    1.00037,
                    0.99973,
                    1.00002,
                    0.99986,
                    1.00041,
                    1.00041,
                    0.99902,
                    0.9996,
                    1.00034,
                    0.99999,
                    1.00026,
                    0.99999,
                    1.00026,
                    0.99973,
                    1.00052,
                    0.99973,
                    1,
                    0.99973,
                    1.00041,
                    1.00075,
                    0.9994,
                    1.0003,
                    0.99999,
                    1,
                    1.00041,
                    0.99955,
                    1,
                    0.99915,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.00119,
                    0.99955,
                    0.99973,
                    1.0006,
                    0.99911,
                    1.0006,
                    1.00026,
                    0.99972,
                    1.00026,
                    0.99902,
                    1.00041,
                    0.99973,
                    0.99999,
                    1,
                    1,
                    1.00038,
                    1.0005,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00001,
                    0.99973,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99955,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1,
                    1,
                    1,
                    0.99973,
                    0.99973,
                    0.99972,
                    1,
                    1,
                    1.00106,
                    0.99999,
                    0.99998,
                    0.99998,
                    0.99999,
                    0.99998,
                    1.66475,
                    1,
                    0.99973,
                    0.99973,
                    1.00023,
                    0.99973,
                    0.99971,
                    1.00047,
                    1.00023,
                    1,
                    0.99991,
                    0.99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99972,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    1.00031,
                    1.00015,
                    1,
                    0.99561,
                    1.00027,
                    1.00031,
                    1.00031,
                    0.99915,
                    1.00031,
                    1.00031,
                    0.99999,
                    1.00003,
                    0.99999,
                    0.99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    0.99999,
                    1,
                    0.99861,
                    0.99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99972,
                    0.99999,
                    0.99999,
                    0.99999,
                    0.99999,
                    1.40483,
                    1,
                    0.99977,
                    1.00054,
                    1,
                    1,
                    0.99953,
                    0.99962,
                    1.00042,
                    0.9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.HelveticaBoldFactors = HelveticaBoldFactors;
                const HelveticaBoldMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.HelveticaBoldMetrics = HelveticaBoldMetrics;
                const HelveticaBoldItalicFactors = [
                    0.76116,
                    1,
                    1,
                    1.0006,
                    0.99998,
                    0.99974,
                    0.99973,
                    0.99973,
                    0.99982,
                    0.99977,
                    1.00087,
                    0.99998,
                    0.99998,
                    0.99959,
                    1.00003,
                    1.0006,
                    0.99998,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    1.00026,
                    0.9999,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    0.99977,
                    1.0006,
                    0.99973,
                    0.99977,
                    1.00026,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    0.99977,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99998,
                    1.0006,
                    0.99998,
                    1.00003,
                    0.99973,
                    0.99998,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00026,
                    0.99973,
                    0.99998,
                    1.00026,
                    1.00026,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.0006,
                    0.99982,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99959,
                    0.99973,
                    0.99998,
                    1.00026,
                    0.99973,
                    1.00022,
                    0.99973,
                    0.99973,
                    1,
                    0.99959,
                    1.00077,
                    0.99959,
                    1.00003,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00077,
                    0.99973,
                    0.99998,
                    1.00025,
                    0.99968,
                    0.99973,
                    1.00003,
                    1.00025,
                    0.60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    0.99998,
                    1,
                    0.99973,
                    1.0006,
                    0.99998,
                    1,
                    0.99936,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99982,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.06409,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00026,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    1.0044,
                    0.99977,
                    1.00026,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99971,
                    0.99973,
                    0.99973,
                    1.0006,
                    0.99977,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.0006,
                    1.00026,
                    1.01011,
                    1.00026,
                    0.99999,
                    1.00026,
                    1.0006,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.9993,
                    0.9998,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1.00022,
                    1.00026,
                    1,
                    1.00016,
                    0.99977,
                    0.99959,
                    0.99977,
                    0.99959,
                    0.99977,
                    0.99959,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00026,
                    0.99998,
                    1.00026,
                    0.8121,
                    1.00026,
                    0.99998,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    0.99977,
                    1.00026,
                    1.00016,
                    1.00022,
                    1.00001,
                    0.99973,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.0006,
                    0.99973,
                    0.99977,
                    0.99973,
                    1,
                    0.99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    0.99973,
                    1.00026,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99977,
                    1,
                    1,
                    1.00026,
                    0.99969,
                    0.99972,
                    0.99981,
                    0.9998,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    0.91155,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00022,
                    1.0006,
                    0.99977,
                    1.00001,
                    0.99999,
                    0.99977,
                    0.99966,
                    1.00022,
                    1.00032,
                    1.00001,
                    0.99944,
                    1.00026,
                    1.00001,
                    0.99968,
                    1.00001,
                    1.00047,
                    1,
                    1.0006,
                    1.00001,
                    0.99981,
                    1.00101,
                    1.00026,
                    1.0006,
                    0.99948,
                    0.99981,
                    1.00064,
                    0.99973,
                    0.99942,
                    1.00101,
                    1.00061,
                    1.00026,
                    1.00069,
                    1.0006,
                    1.00014,
                    0.99973,
                    1.01322,
                    0.99973,
                    1.00065,
                    1.00026,
                    1.00012,
                    0.99923,
                    1,
                    1.00064,
                    1.00076,
                    0.99948,
                    1.00055,
                    1.00063,
                    1.00007,
                    0.99943,
                    1.0006,
                    0.99948,
                    1.00026,
                    0.99948,
                    0.99943,
                    1.00001,
                    1.00001,
                    1.00029,
                    1.00038,
                    1.00035,
                    1.00001,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99978,
                    1.00001,
                    1.00057,
                    0.99989,
                    0.99967,
                    0.99964,
                    0.99967,
                    0.99977,
                    0.99999,
                    0.99977,
                    1.00038,
                    0.99977,
                    1.00001,
                    0.99973,
                    1.00066,
                    0.99967,
                    0.99967,
                    1.00041,
                    0.99998,
                    0.99999,
                    0.99977,
                    1.00022,
                    0.99967,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.99964,
                    1.00031,
                    1.00001,
                    0.99999,
                    0.99999,
                    1,
                    1.00023,
                    1,
                    1,
                    0.99999,
                    1.00035,
                    1.00001,
                    0.99999,
                    0.99973,
                    0.99977,
                    0.99999,
                    1.00058,
                    0.99973,
                    0.99973,
                    0.99955,
                    0.9995,
                    1.00026,
                    1.00026,
                    1.00032,
                    0.99989,
                    1.00034,
                    0.99999,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.45998,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00001,
                    0.99999,
                    0.99982,
                    0.99994,
                    0.99996,
                    1,
                    1.00042,
                    1.00044,
                    1.00029,
                    1.00023,
                    0.99973,
                    0.99973,
                    1.00026,
                    0.99949,
                    1.00002,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99975,
                    1.00026,
                    1.00026,
                    1.00032,
                    0.98685,
                    0.99973,
                    1.00026,
                    1,
                    1,
                    0.99966,
                    1.00044,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00016,
                    1.00022,
                    1.00001,
                    0.99973,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99955,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1,
                    1,
                    1,
                    0.99973,
                    0.99973,
                    0.99972,
                    1,
                    1,
                    1.00106,
                    0.99999,
                    0.99998,
                    0.99998,
                    0.99999,
                    0.99998,
                    1.66475,
                    1,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    0.99971,
                    0.99978,
                    1,
                    1,
                    0.99991,
                    0.99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00098,
                    1,
                    1,
                    1,
                    1.00049,
                    1,
                    1,
                    0.99972,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    1.00031,
                    1.00015,
                    1,
                    0.99561,
                    1.00027,
                    1.00031,
                    1.00031,
                    0.99915,
                    1.00031,
                    1.00031,
                    0.99999,
                    1.00003,
                    0.99999,
                    0.99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    0.99999,
                    1,
                    0.99861,
                    0.99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99972,
                    0.99999,
                    0.99999,
                    0.99999,
                    0.99999,
                    1.40483,
                    1,
                    0.99977,
                    1.00054,
                    1,
                    1,
                    0.99953,
                    0.99962,
                    1.00042,
                    0.9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.HelveticaBoldItalicFactors = HelveticaBoldItalicFactors;
                const HelveticaBoldItalicMetrics = {
                    lineHeight: 1.35,
                    lineGap: 0.2
                };
                exports.HelveticaBoldItalicMetrics = HelveticaBoldItalicMetrics;
                const HelveticaItalicFactors = [
                    0.76116,
                    1,
                    1,
                    1.0006,
                    1.0006,
                    1.00006,
                    0.99973,
                    0.99973,
                    0.99982,
                    1.00001,
                    1.00043,
                    0.99998,
                    0.99998,
                    0.99959,
                    1.00003,
                    1.0006,
                    0.99998,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    0.99973,
                    0.99987,
                    1.00001,
                    1.00001,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    0.99977,
                    1.0006,
                    1,
                    1.00001,
                    0.99973,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    0.99977,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99949,
                    0.99973,
                    0.99998,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99924,
                    0.99924,
                    1,
                    0.99924,
                    0.99999,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1.0006,
                    0.99973,
                    1,
                    0.99977,
                    1,
                    1,
                    1,
                    1.00005,
                    1.0009,
                    1.00005,
                    1.00003,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0009,
                    0.99973,
                    0.99998,
                    1.00025,
                    0.99968,
                    0.99973,
                    1.00003,
                    1.00025,
                    0.60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    0.99998,
                    1,
                    0.9998,
                    1.0006,
                    0.99998,
                    1,
                    0.99936,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99982,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.06409,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    1,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1.0288,
                    0.99977,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99924,
                    1.0006,
                    1.0006,
                    0.99946,
                    1.00034,
                    1,
                    0.99924,
                    1.00001,
                    1,
                    1,
                    0.99973,
                    0.99924,
                    0.99973,
                    0.99924,
                    0.99973,
                    1.06311,
                    0.99973,
                    1.00024,
                    0.99973,
                    0.99924,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.00041,
                    0.9998,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1,
                    1.00016,
                    0.99977,
                    0.99998,
                    0.99977,
                    0.99998,
                    0.99977,
                    0.99998,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    1.00026,
                    0.89547,
                    1.00026,
                    1.0006,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.00016,
                    0.99977,
                    1.00001,
                    1,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    0.99924,
                    0.99973,
                    1.00001,
                    0.99973,
                    1,
                    0.99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1.00001,
                    1,
                    1.00054,
                    0.99977,
                    1.00084,
                    1.00007,
                    0.99973,
                    1.00013,
                    0.99924,
                    1.00001,
                    1.00001,
                    0.99945,
                    0.91221,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00022,
                    1.0006,
                    1.00001,
                    1.00001,
                    0.99999,
                    0.99977,
                    0.99933,
                    1.00022,
                    1.00054,
                    1.00001,
                    1.00065,
                    1.00026,
                    1.00001,
                    1.0001,
                    1.00001,
                    1.00052,
                    1,
                    1.0006,
                    1.00001,
                    0.99945,
                    0.99897,
                    0.99968,
                    0.99924,
                    1.00036,
                    0.99945,
                    0.99949,
                    1,
                    1.0006,
                    0.99897,
                    0.99918,
                    0.99968,
                    0.99911,
                    0.99924,
                    1,
                    0.99962,
                    1.01487,
                    1,
                    1.0005,
                    0.99973,
                    1.00012,
                    1.00043,
                    1,
                    0.99995,
                    0.99994,
                    1.00036,
                    0.99947,
                    1.00019,
                    1.00063,
                    1.00025,
                    0.99924,
                    1.00036,
                    0.99973,
                    1.00036,
                    1.00025,
                    1.00001,
                    1.00001,
                    1.00027,
                    1.0001,
                    1.00068,
                    1.00001,
                    1.0006,
                    1.0006,
                    1,
                    1.00008,
                    0.99957,
                    0.99972,
                    0.9994,
                    0.99954,
                    0.99975,
                    1.00051,
                    1.00001,
                    1.00019,
                    1.00001,
                    1.0001,
                    0.99986,
                    1.00001,
                    1.00001,
                    1.00038,
                    0.99954,
                    0.99954,
                    0.9994,
                    1.00066,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00054,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.99975,
                    1.0001,
                    1.00001,
                    0.99993,
                    0.9995,
                    0.99955,
                    1.00016,
                    0.99978,
                    0.99974,
                    1.00019,
                    1.00022,
                    0.99955,
                    1.00053,
                    0.99973,
                    1.00089,
                    1.00005,
                    0.99967,
                    1.00048,
                    0.99973,
                    1.00002,
                    1.00034,
                    0.99973,
                    0.99973,
                    0.99964,
                    1.00006,
                    1.00066,
                    0.99947,
                    0.99973,
                    0.98894,
                    0.99973,
                    1,
                    0.44898,
                    1,
                    0.99946,
                    1,
                    1.00039,
                    1.00082,
                    0.99991,
                    0.99991,
                    0.99985,
                    1.00022,
                    1.00023,
                    1.00061,
                    1.00006,
                    0.99966,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00019,
                    1.0008,
                    1,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99983,
                    1.00044,
                    0.99973,
                    0.99964,
                    0.98332,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99962,
                    0.99895,
                    1.00016,
                    0.99977,
                    1.00016,
                    0.99977,
                    1.00016,
                    0.99977,
                    1.00001,
                    1,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99955,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99972,
                    1,
                    1,
                    1.00267,
                    0.99999,
                    0.99998,
                    0.99998,
                    1,
                    0.99998,
                    1.66475,
                    1,
                    0.99973,
                    0.99973,
                    1.00023,
                    0.99973,
                    1.00423,
                    0.99925,
                    0.99999,
                    1,
                    0.99991,
                    0.99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00049,
                    1,
                    1.00245,
                    1,
                    1,
                    1,
                    1,
                    0.96329,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    0.8254,
                    1.00015,
                    1,
                    1.00035,
                    1.00027,
                    1.00031,
                    1.00031,
                    1.00003,
                    1.00031,
                    1.00031,
                    0.99999,
                    1.00003,
                    0.99999,
                    0.99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    0.99999,
                    1,
                    0.99861,
                    0.99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.95317,
                    0.99999,
                    0.99999,
                    0.99999,
                    0.99999,
                    1.40483,
                    1,
                    0.99977,
                    1.00054,
                    1,
                    1,
                    0.99953,
                    0.99962,
                    1.00042,
                    0.9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.HelveticaItalicFactors = HelveticaItalicFactors;
                const HelveticaItalicMetrics = {
                    lineHeight: 1.35,
                    lineGap: 0.2
                };
                exports.HelveticaItalicMetrics = HelveticaItalicMetrics;
                const HelveticaRegularFactors = [
                    0.76116,
                    1,
                    1,
                    1.0006,
                    1.0006,
                    1.00006,
                    0.99973,
                    0.99973,
                    0.99982,
                    1.00001,
                    1.00043,
                    0.99998,
                    0.99998,
                    0.99959,
                    1.00003,
                    1.0006,
                    0.99998,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1,
                    1.00003,
                    1.00003,
                    1.00003,
                    0.99973,
                    0.99987,
                    1.00001,
                    1.00001,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00026,
                    1.00022,
                    0.99977,
                    1.0006,
                    1,
                    1.00001,
                    0.99973,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00001,
                    1.00022,
                    0.99977,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99949,
                    0.99973,
                    0.99998,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99924,
                    0.99924,
                    1,
                    0.99924,
                    0.99999,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1.0006,
                    0.99973,
                    1,
                    0.99977,
                    1,
                    1,
                    1,
                    1.00005,
                    1.0009,
                    1.00005,
                    1.00003,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0009,
                    0.99973,
                    0.99998,
                    1.00025,
                    0.99968,
                    0.99973,
                    1.00003,
                    1.00025,
                    0.60299,
                    1.00024,
                    1.06409,
                    1,
                    1,
                    0.99998,
                    1,
                    0.9998,
                    1.0006,
                    0.99998,
                    1,
                    0.99936,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00026,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99977,
                    0.99977,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00003,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99982,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.06409,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    1,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1,
                    0.99977,
                    1.04596,
                    0.99977,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00001,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99924,
                    1.0006,
                    1.0006,
                    1.00019,
                    1.00034,
                    1,
                    0.99924,
                    1.00001,
                    1,
                    1,
                    0.99973,
                    0.99924,
                    0.99973,
                    0.99924,
                    0.99973,
                    1.02572,
                    0.99973,
                    1.00005,
                    0.99973,
                    0.99924,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99999,
                    0.9998,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1.00022,
                    0.99973,
                    1,
                    1.00016,
                    0.99977,
                    0.99998,
                    0.99977,
                    0.99998,
                    0.99977,
                    0.99998,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    1.00026,
                    0.84533,
                    1.00026,
                    1.0006,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    0.99977,
                    0.99973,
                    1.00016,
                    0.99977,
                    1.00001,
                    1,
                    1.00001,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    1.00026,
                    1,
                    0.99924,
                    0.99973,
                    1.00001,
                    0.99973,
                    1,
                    0.99982,
                    1.00022,
                    1.00026,
                    1.00001,
                    1,
                    1.00026,
                    1.0006,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99928,
                    1,
                    0.99977,
                    1.00013,
                    1.00055,
                    0.99947,
                    0.99945,
                    0.99941,
                    0.99924,
                    1.00001,
                    1.00001,
                    1.0004,
                    0.91621,
                    1.00001,
                    1.00026,
                    0.99977,
                    1.00022,
                    1.0006,
                    1.00001,
                    1.00005,
                    0.99999,
                    0.99977,
                    1.00015,
                    1.00022,
                    0.99977,
                    1.00001,
                    0.99973,
                    1.00026,
                    1.00001,
                    1.00019,
                    1.00001,
                    0.99946,
                    1,
                    1.0006,
                    1.00001,
                    0.99978,
                    1.00045,
                    0.99973,
                    0.99924,
                    1.00023,
                    0.99978,
                    0.99966,
                    1,
                    1.00065,
                    1.00045,
                    1.00019,
                    0.99973,
                    0.99973,
                    0.99924,
                    1,
                    1,
                    0.96499,
                    1,
                    1.00055,
                    0.99973,
                    1.00008,
                    1.00027,
                    1,
                    0.9997,
                    0.99995,
                    1.00023,
                    0.99933,
                    1.00019,
                    1.00015,
                    1.00031,
                    0.99924,
                    1.00023,
                    0.99973,
                    1.00023,
                    1.00031,
                    1.00001,
                    0.99928,
                    1.00029,
                    1.00092,
                    1.00035,
                    1.00001,
                    1.0006,
                    1.0006,
                    1,
                    0.99988,
                    0.99975,
                    1,
                    1.00082,
                    0.99561,
                    0.9996,
                    1.00035,
                    1.00001,
                    0.99962,
                    1.00001,
                    1.00092,
                    0.99964,
                    1.00001,
                    0.99963,
                    0.99999,
                    1.00035,
                    1.00035,
                    1.00082,
                    0.99962,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00035,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.9996,
                    0.99967,
                    1.00001,
                    1.00034,
                    1.00074,
                    1.00054,
                    1.00053,
                    1.00063,
                    0.99971,
                    0.99962,
                    1.00035,
                    0.99975,
                    0.99977,
                    0.99973,
                    1.00043,
                    0.99953,
                    1.0007,
                    0.99915,
                    0.99973,
                    1.00008,
                    0.99892,
                    1.00073,
                    1.00073,
                    1.00114,
                    0.99915,
                    1.00073,
                    0.99955,
                    0.99973,
                    1.00092,
                    0.99973,
                    1,
                    0.99998,
                    1,
                    1.0003,
                    1,
                    1.00043,
                    1.00001,
                    0.99969,
                    1.0003,
                    1,
                    1.00035,
                    1.00001,
                    0.9995,
                    1,
                    1.00092,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0007,
                    0.9995,
                    1,
                    0.99924,
                    1.0006,
                    0.99924,
                    0.99972,
                    1.00062,
                    0.99973,
                    1.00114,
                    1.00073,
                    1,
                    0.99955,
                    1,
                    1,
                    1.00047,
                    0.99968,
                    1.00016,
                    0.99977,
                    1.00016,
                    0.99977,
                    1.00016,
                    0.99977,
                    1.00001,
                    1,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    0.99955,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99972,
                    1,
                    1,
                    1.00267,
                    0.99999,
                    0.99998,
                    0.99998,
                    1,
                    0.99998,
                    1.66475,
                    1,
                    0.99973,
                    0.99973,
                    1.00023,
                    0.99973,
                    0.99971,
                    0.99925,
                    1.00023,
                    1,
                    0.99991,
                    0.99984,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.00002,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96329,
                    1,
                    1.20985,
                    1.39713,
                    1.00003,
                    0.8254,
                    1.00015,
                    1,
                    1.00035,
                    1.00027,
                    1.00031,
                    1.00031,
                    0.99915,
                    1.00031,
                    1.00031,
                    0.99999,
                    1.00003,
                    0.99999,
                    0.99999,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.40579,
                    1.40579,
                    1.36625,
                    0.99999,
                    1,
                    0.99861,
                    0.99861,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.95317,
                    0.99999,
                    0.99999,
                    0.99999,
                    0.99999,
                    1.40483,
                    1,
                    0.99977,
                    1.00054,
                    1,
                    1,
                    0.99953,
                    0.99962,
                    1.00042,
                    0.9995,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.HelveticaRegularFactors = HelveticaRegularFactors;
                const HelveticaRegularMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.HelveticaRegularMetrics = HelveticaRegularMetrics;
            /***/ },
            /* 54 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LiberationSansRegularWidths = exports.LiberationSansRegularMapping = exports.LiberationSansItalicWidths = exports.LiberationSansItalicMapping = exports.LiberationSansBoldWidths = exports.LiberationSansBoldMapping = exports.LiberationSansBoldItalicWidths = exports.LiberationSansBoldItalicMapping = void 0;
                const LiberationSansBoldWidths = [
                    365,
                    0,
                    333,
                    278,
                    333,
                    474,
                    556,
                    556,
                    889,
                    722,
                    238,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    333,
                    333,
                    584,
                    584,
                    584,
                    611,
                    975,
                    722,
                    722,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    556,
                    722,
                    611,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    333,
                    278,
                    333,
                    584,
                    556,
                    333,
                    556,
                    611,
                    556,
                    611,
                    556,
                    333,
                    611,
                    611,
                    278,
                    278,
                    556,
                    278,
                    889,
                    611,
                    611,
                    611,
                    611,
                    389,
                    556,
                    333,
                    611,
                    556,
                    778,
                    556,
                    556,
                    500,
                    389,
                    280,
                    389,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    280,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    556,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    1000,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    549,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    611,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    719,
                    722,
                    611,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    722,
                    611,
                    722,
                    611,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    785,
                    556,
                    556,
                    278,
                    722,
                    556,
                    556,
                    611,
                    278,
                    611,
                    278,
                    611,
                    385,
                    611,
                    479,
                    611,
                    278,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    708,
                    723,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    1000,
                    944,
                    722,
                    389,
                    722,
                    389,
                    722,
                    389,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    611,
                    333,
                    611,
                    479,
                    611,
                    333,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    944,
                    778,
                    667,
                    556,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    278,
                    556,
                    722,
                    556,
                    1000,
                    889,
                    778,
                    611,
                    667,
                    556,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    465,
                    722,
                    333,
                    853,
                    906,
                    474,
                    825,
                    927,
                    838,
                    278,
                    722,
                    722,
                    601,
                    719,
                    667,
                    611,
                    722,
                    778,
                    278,
                    722,
                    667,
                    833,
                    722,
                    644,
                    778,
                    722,
                    667,
                    600,
                    611,
                    667,
                    821,
                    667,
                    809,
                    802,
                    278,
                    667,
                    615,
                    451,
                    611,
                    278,
                    582,
                    615,
                    610,
                    556,
                    606,
                    475,
                    460,
                    611,
                    541,
                    278,
                    558,
                    556,
                    612,
                    556,
                    445,
                    611,
                    766,
                    619,
                    520,
                    684,
                    446,
                    582,
                    715,
                    576,
                    753,
                    845,
                    278,
                    582,
                    611,
                    582,
                    845,
                    667,
                    669,
                    885,
                    567,
                    711,
                    667,
                    278,
                    276,
                    556,
                    1094,
                    1062,
                    875,
                    610,
                    722,
                    622,
                    719,
                    722,
                    719,
                    722,
                    567,
                    712,
                    667,
                    904,
                    626,
                    719,
                    719,
                    610,
                    702,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    622,
                    854,
                    667,
                    730,
                    703,
                    1005,
                    1019,
                    870,
                    979,
                    719,
                    711,
                    1031,
                    719,
                    556,
                    618,
                    615,
                    417,
                    635,
                    556,
                    709,
                    497,
                    615,
                    615,
                    500,
                    635,
                    740,
                    604,
                    611,
                    604,
                    611,
                    556,
                    490,
                    556,
                    875,
                    556,
                    615,
                    581,
                    833,
                    844,
                    729,
                    854,
                    615,
                    552,
                    854,
                    583,
                    556,
                    556,
                    611,
                    417,
                    552,
                    556,
                    278,
                    281,
                    278,
                    969,
                    906,
                    611,
                    500,
                    615,
                    556,
                    604,
                    778,
                    611,
                    487,
                    447,
                    944,
                    778,
                    944,
                    778,
                    944,
                    778,
                    667,
                    556,
                    333,
                    333,
                    556,
                    1000,
                    1000,
                    552,
                    278,
                    278,
                    278,
                    278,
                    500,
                    500,
                    500,
                    556,
                    556,
                    350,
                    1000,
                    1000,
                    240,
                    479,
                    333,
                    333,
                    604,
                    333,
                    167,
                    396,
                    556,
                    556,
                    1094,
                    556,
                    885,
                    489,
                    1115,
                    1000,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    1000,
                    500,
                    1000,
                    500,
                    1000,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    722,
                    274,
                    549,
                    549,
                    583,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    611,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333
                ];
                exports.LiberationSansBoldWidths = LiberationSansBoldWidths;
                const LiberationSansBoldMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                exports.LiberationSansBoldMapping = LiberationSansBoldMapping;
                const LiberationSansBoldItalicWidths = [
                    365,
                    0,
                    333,
                    278,
                    333,
                    474,
                    556,
                    556,
                    889,
                    722,
                    238,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    333,
                    333,
                    584,
                    584,
                    584,
                    611,
                    975,
                    722,
                    722,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    556,
                    722,
                    611,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    333,
                    278,
                    333,
                    584,
                    556,
                    333,
                    556,
                    611,
                    556,
                    611,
                    556,
                    333,
                    611,
                    611,
                    278,
                    278,
                    556,
                    278,
                    889,
                    611,
                    611,
                    611,
                    611,
                    389,
                    556,
                    333,
                    611,
                    556,
                    778,
                    556,
                    556,
                    500,
                    389,
                    280,
                    389,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    280,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    556,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    1000,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    549,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    611,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    740,
                    722,
                    611,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    722,
                    611,
                    722,
                    611,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    782,
                    556,
                    556,
                    278,
                    722,
                    556,
                    556,
                    611,
                    278,
                    611,
                    278,
                    611,
                    396,
                    611,
                    479,
                    611,
                    278,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    708,
                    723,
                    611,
                    778,
                    611,
                    778,
                    611,
                    778,
                    611,
                    1000,
                    944,
                    722,
                    389,
                    722,
                    389,
                    722,
                    389,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    611,
                    333,
                    611,
                    479,
                    611,
                    333,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    722,
                    611,
                    944,
                    778,
                    667,
                    556,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    278,
                    556,
                    722,
                    556,
                    1000,
                    889,
                    778,
                    611,
                    667,
                    556,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    722,
                    333,
                    854,
                    906,
                    473,
                    844,
                    930,
                    847,
                    278,
                    722,
                    722,
                    610,
                    671,
                    667,
                    611,
                    722,
                    778,
                    278,
                    722,
                    667,
                    833,
                    722,
                    657,
                    778,
                    718,
                    667,
                    590,
                    611,
                    667,
                    822,
                    667,
                    829,
                    781,
                    278,
                    667,
                    620,
                    479,
                    611,
                    278,
                    591,
                    620,
                    621,
                    556,
                    610,
                    479,
                    492,
                    611,
                    558,
                    278,
                    566,
                    556,
                    603,
                    556,
                    450,
                    611,
                    712,
                    605,
                    532,
                    664,
                    409,
                    591,
                    704,
                    578,
                    773,
                    834,
                    278,
                    591,
                    611,
                    591,
                    834,
                    667,
                    667,
                    886,
                    614,
                    719,
                    667,
                    278,
                    278,
                    556,
                    1094,
                    1042,
                    854,
                    622,
                    719,
                    677,
                    719,
                    722,
                    708,
                    722,
                    614,
                    722,
                    667,
                    927,
                    643,
                    719,
                    719,
                    615,
                    687,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    677,
                    781,
                    667,
                    729,
                    708,
                    979,
                    989,
                    854,
                    1000,
                    708,
                    719,
                    1042,
                    729,
                    556,
                    619,
                    604,
                    534,
                    618,
                    556,
                    736,
                    510,
                    611,
                    611,
                    507,
                    622,
                    740,
                    604,
                    611,
                    611,
                    611,
                    556,
                    889,
                    556,
                    885,
                    556,
                    646,
                    583,
                    889,
                    935,
                    707,
                    854,
                    594,
                    552,
                    865,
                    589,
                    556,
                    556,
                    611,
                    469,
                    563,
                    556,
                    278,
                    278,
                    278,
                    969,
                    906,
                    611,
                    507,
                    619,
                    556,
                    611,
                    778,
                    611,
                    575,
                    467,
                    944,
                    778,
                    944,
                    778,
                    944,
                    778,
                    667,
                    556,
                    333,
                    333,
                    556,
                    1000,
                    1000,
                    552,
                    278,
                    278,
                    278,
                    278,
                    500,
                    500,
                    500,
                    556,
                    556,
                    350,
                    1000,
                    1000,
                    240,
                    479,
                    333,
                    333,
                    604,
                    333,
                    167,
                    396,
                    556,
                    556,
                    1104,
                    556,
                    885,
                    516,
                    1146,
                    1000,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    999,
                    500,
                    1000,
                    500,
                    1000,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    722,
                    274,
                    549,
                    549,
                    583,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    611,
                    611,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333
                ];
                exports.LiberationSansBoldItalicWidths = LiberationSansBoldItalicWidths;
                const LiberationSansBoldItalicMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                exports.LiberationSansBoldItalicMapping = LiberationSansBoldItalicMapping;
                const LiberationSansItalicWidths = [
                    365,
                    0,
                    333,
                    278,
                    278,
                    355,
                    556,
                    556,
                    889,
                    667,
                    191,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    584,
                    584,
                    584,
                    556,
                    1015,
                    667,
                    667,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    500,
                    667,
                    556,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    278,
                    278,
                    278,
                    469,
                    556,
                    333,
                    556,
                    556,
                    500,
                    556,
                    556,
                    278,
                    556,
                    556,
                    222,
                    222,
                    500,
                    222,
                    833,
                    556,
                    556,
                    556,
                    556,
                    333,
                    500,
                    278,
                    556,
                    500,
                    722,
                    500,
                    500,
                    500,
                    334,
                    260,
                    334,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    260,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    537,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    1000,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    500,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    549,
                    611,
                    556,
                    556,
                    556,
                    556,
                    500,
                    556,
                    500,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    625,
                    722,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    722,
                    556,
                    722,
                    556,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    222,
                    278,
                    278,
                    733,
                    444,
                    500,
                    222,
                    667,
                    500,
                    500,
                    556,
                    222,
                    556,
                    222,
                    556,
                    281,
                    556,
                    400,
                    556,
                    222,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    615,
                    723,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    1000,
                    944,
                    722,
                    333,
                    722,
                    333,
                    722,
                    333,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    611,
                    278,
                    611,
                    354,
                    611,
                    278,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    944,
                    722,
                    667,
                    500,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    222,
                    556,
                    667,
                    556,
                    1000,
                    889,
                    778,
                    611,
                    667,
                    500,
                    611,
                    278,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    667,
                    278,
                    789,
                    846,
                    389,
                    794,
                    865,
                    775,
                    222,
                    667,
                    667,
                    570,
                    671,
                    667,
                    611,
                    722,
                    778,
                    278,
                    667,
                    667,
                    833,
                    722,
                    648,
                    778,
                    725,
                    667,
                    600,
                    611,
                    667,
                    837,
                    667,
                    831,
                    761,
                    278,
                    667,
                    570,
                    439,
                    555,
                    222,
                    550,
                    570,
                    571,
                    500,
                    556,
                    439,
                    463,
                    555,
                    542,
                    222,
                    500,
                    492,
                    548,
                    500,
                    447,
                    556,
                    670,
                    573,
                    486,
                    603,
                    374,
                    550,
                    652,
                    546,
                    728,
                    779,
                    222,
                    550,
                    556,
                    550,
                    779,
                    667,
                    667,
                    843,
                    544,
                    708,
                    667,
                    278,
                    278,
                    500,
                    1066,
                    982,
                    844,
                    589,
                    715,
                    639,
                    724,
                    667,
                    651,
                    667,
                    544,
                    704,
                    667,
                    917,
                    614,
                    715,
                    715,
                    589,
                    686,
                    833,
                    722,
                    778,
                    725,
                    667,
                    722,
                    611,
                    639,
                    795,
                    667,
                    727,
                    673,
                    920,
                    923,
                    805,
                    886,
                    651,
                    694,
                    1022,
                    682,
                    556,
                    562,
                    522,
                    493,
                    553,
                    556,
                    688,
                    465,
                    556,
                    556,
                    472,
                    564,
                    686,
                    550,
                    556,
                    556,
                    556,
                    500,
                    833,
                    500,
                    835,
                    500,
                    572,
                    518,
                    830,
                    851,
                    621,
                    736,
                    526,
                    492,
                    752,
                    534,
                    556,
                    556,
                    556,
                    378,
                    496,
                    500,
                    222,
                    222,
                    222,
                    910,
                    828,
                    556,
                    472,
                    565,
                    500,
                    556,
                    778,
                    556,
                    492,
                    339,
                    944,
                    722,
                    944,
                    722,
                    944,
                    722,
                    667,
                    500,
                    333,
                    333,
                    556,
                    1000,
                    1000,
                    552,
                    222,
                    222,
                    222,
                    222,
                    333,
                    333,
                    333,
                    556,
                    556,
                    350,
                    1000,
                    1000,
                    188,
                    354,
                    333,
                    333,
                    500,
                    333,
                    167,
                    365,
                    556,
                    556,
                    1094,
                    556,
                    885,
                    323,
                    1083,
                    1000,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    1000,
                    500,
                    998,
                    500,
                    1000,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    719,
                    274,
                    549,
                    549,
                    584,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    500,
                    500,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    294,
                    294,
                    324,
                    324,
                    316,
                    328,
                    398,
                    285
                ];
                exports.LiberationSansItalicWidths = LiberationSansItalicWidths;
                const LiberationSansItalicMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                exports.LiberationSansItalicMapping = LiberationSansItalicMapping;
                const LiberationSansRegularWidths = [
                    365,
                    0,
                    333,
                    278,
                    278,
                    355,
                    556,
                    556,
                    889,
                    667,
                    191,
                    333,
                    333,
                    389,
                    584,
                    278,
                    333,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    584,
                    584,
                    584,
                    556,
                    1015,
                    667,
                    667,
                    722,
                    722,
                    667,
                    611,
                    778,
                    722,
                    278,
                    500,
                    667,
                    556,
                    833,
                    722,
                    778,
                    667,
                    778,
                    722,
                    667,
                    611,
                    722,
                    667,
                    944,
                    667,
                    667,
                    611,
                    278,
                    278,
                    278,
                    469,
                    556,
                    333,
                    556,
                    556,
                    500,
                    556,
                    556,
                    278,
                    556,
                    556,
                    222,
                    222,
                    500,
                    222,
                    833,
                    556,
                    556,
                    556,
                    556,
                    333,
                    500,
                    278,
                    556,
                    500,
                    722,
                    500,
                    500,
                    500,
                    334,
                    260,
                    334,
                    584,
                    333,
                    556,
                    556,
                    556,
                    556,
                    260,
                    556,
                    333,
                    737,
                    370,
                    556,
                    584,
                    737,
                    552,
                    400,
                    549,
                    333,
                    333,
                    333,
                    576,
                    537,
                    278,
                    333,
                    333,
                    365,
                    556,
                    834,
                    834,
                    834,
                    611,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    1000,
                    722,
                    667,
                    667,
                    667,
                    667,
                    278,
                    278,
                    278,
                    278,
                    722,
                    722,
                    778,
                    778,
                    778,
                    778,
                    778,
                    584,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    611,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    889,
                    500,
                    556,
                    556,
                    556,
                    556,
                    278,
                    278,
                    278,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    549,
                    611,
                    556,
                    556,
                    556,
                    556,
                    500,
                    556,
                    500,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    500,
                    722,
                    615,
                    722,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    667,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    722,
                    556,
                    722,
                    556,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    222,
                    278,
                    278,
                    735,
                    444,
                    500,
                    222,
                    667,
                    500,
                    500,
                    556,
                    222,
                    556,
                    222,
                    556,
                    292,
                    556,
                    334,
                    556,
                    222,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    604,
                    723,
                    556,
                    778,
                    556,
                    778,
                    556,
                    778,
                    556,
                    1000,
                    944,
                    722,
                    333,
                    722,
                    333,
                    722,
                    333,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    667,
                    500,
                    611,
                    278,
                    611,
                    375,
                    611,
                    278,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    722,
                    556,
                    944,
                    722,
                    667,
                    500,
                    667,
                    611,
                    500,
                    611,
                    500,
                    611,
                    500,
                    222,
                    556,
                    667,
                    556,
                    1000,
                    889,
                    778,
                    611,
                    667,
                    500,
                    611,
                    278,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    667,
                    278,
                    784,
                    838,
                    384,
                    774,
                    855,
                    752,
                    222,
                    667,
                    667,
                    551,
                    668,
                    667,
                    611,
                    722,
                    778,
                    278,
                    667,
                    668,
                    833,
                    722,
                    650,
                    778,
                    722,
                    667,
                    618,
                    611,
                    667,
                    798,
                    667,
                    835,
                    748,
                    278,
                    667,
                    578,
                    446,
                    556,
                    222,
                    547,
                    578,
                    575,
                    500,
                    557,
                    446,
                    441,
                    556,
                    556,
                    222,
                    500,
                    500,
                    576,
                    500,
                    448,
                    556,
                    690,
                    569,
                    482,
                    617,
                    395,
                    547,
                    648,
                    525,
                    713,
                    781,
                    222,
                    547,
                    556,
                    547,
                    781,
                    667,
                    667,
                    865,
                    542,
                    719,
                    667,
                    278,
                    278,
                    500,
                    1057,
                    1010,
                    854,
                    583,
                    722,
                    635,
                    719,
                    667,
                    656,
                    667,
                    542,
                    677,
                    667,
                    923,
                    604,
                    719,
                    719,
                    583,
                    656,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    635,
                    760,
                    667,
                    740,
                    667,
                    917,
                    938,
                    792,
                    885,
                    656,
                    719,
                    1010,
                    722,
                    556,
                    573,
                    531,
                    365,
                    583,
                    556,
                    669,
                    458,
                    559,
                    559,
                    438,
                    583,
                    688,
                    552,
                    556,
                    542,
                    556,
                    500,
                    458,
                    500,
                    823,
                    500,
                    573,
                    521,
                    802,
                    823,
                    625,
                    719,
                    521,
                    510,
                    750,
                    542,
                    556,
                    556,
                    556,
                    365,
                    510,
                    500,
                    222,
                    278,
                    222,
                    906,
                    812,
                    556,
                    438,
                    559,
                    500,
                    552,
                    778,
                    556,
                    489,
                    411,
                    944,
                    722,
                    944,
                    722,
                    944,
                    722,
                    667,
                    500,
                    333,
                    333,
                    556,
                    1000,
                    1000,
                    552,
                    222,
                    222,
                    222,
                    222,
                    333,
                    333,
                    333,
                    556,
                    556,
                    350,
                    1000,
                    1000,
                    188,
                    354,
                    333,
                    333,
                    500,
                    333,
                    167,
                    365,
                    556,
                    556,
                    1094,
                    556,
                    885,
                    323,
                    1073,
                    1000,
                    768,
                    600,
                    834,
                    834,
                    834,
                    834,
                    1000,
                    500,
                    1000,
                    500,
                    1000,
                    500,
                    500,
                    494,
                    612,
                    823,
                    713,
                    584,
                    549,
                    713,
                    979,
                    719,
                    274,
                    549,
                    549,
                    583,
                    549,
                    549,
                    604,
                    584,
                    604,
                    604,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    729,
                    604,
                    604,
                    354,
                    354,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    494,
                    604,
                    604,
                    604,
                    604,
                    354,
                    1021,
                    1052,
                    917,
                    750,
                    750,
                    531,
                    656,
                    594,
                    510,
                    500,
                    750,
                    750,
                    500,
                    500,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    222,
                    222,
                    294,
                    294,
                    324,
                    324,
                    316,
                    328,
                    398,
                    285
                ];
                exports.LiberationSansRegularWidths = LiberationSansRegularWidths;
                const LiberationSansRegularMapping = [
                    -1,
                    -1,
                    -1,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    64,
                    65,
                    66,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    82,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    91,
                    92,
                    93,
                    94,
                    95,
                    96,
                    97,
                    98,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    107,
                    108,
                    109,
                    110,
                    111,
                    112,
                    113,
                    114,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    123,
                    124,
                    125,
                    126,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    256,
                    257,
                    258,
                    259,
                    260,
                    261,
                    262,
                    263,
                    264,
                    265,
                    266,
                    267,
                    268,
                    269,
                    270,
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278,
                    279,
                    280,
                    281,
                    282,
                    283,
                    284,
                    285,
                    286,
                    287,
                    288,
                    289,
                    290,
                    291,
                    292,
                    293,
                    294,
                    295,
                    296,
                    297,
                    298,
                    299,
                    300,
                    301,
                    302,
                    303,
                    304,
                    305,
                    306,
                    307,
                    308,
                    309,
                    310,
                    311,
                    312,
                    313,
                    314,
                    315,
                    316,
                    317,
                    318,
                    319,
                    320,
                    321,
                    322,
                    323,
                    324,
                    325,
                    326,
                    327,
                    328,
                    329,
                    330,
                    331,
                    332,
                    333,
                    334,
                    335,
                    336,
                    337,
                    338,
                    339,
                    340,
                    341,
                    342,
                    343,
                    344,
                    345,
                    346,
                    347,
                    348,
                    349,
                    350,
                    351,
                    352,
                    353,
                    354,
                    355,
                    356,
                    357,
                    358,
                    359,
                    360,
                    361,
                    362,
                    363,
                    364,
                    365,
                    366,
                    367,
                    368,
                    369,
                    370,
                    371,
                    372,
                    373,
                    374,
                    375,
                    376,
                    377,
                    378,
                    379,
                    380,
                    381,
                    382,
                    383,
                    402,
                    506,
                    507,
                    508,
                    509,
                    510,
                    511,
                    536,
                    537,
                    538,
                    539,
                    710,
                    711,
                    713,
                    728,
                    729,
                    730,
                    731,
                    732,
                    733,
                    900,
                    901,
                    902,
                    903,
                    904,
                    905,
                    906,
                    908,
                    910,
                    911,
                    912,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    938,
                    939,
                    940,
                    941,
                    942,
                    943,
                    944,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    970,
                    971,
                    972,
                    973,
                    974,
                    1024,
                    1025,
                    1026,
                    1027,
                    1028,
                    1029,
                    1030,
                    1031,
                    1032,
                    1033,
                    1034,
                    1035,
                    1036,
                    1037,
                    1038,
                    1039,
                    1040,
                    1041,
                    1042,
                    1043,
                    1044,
                    1045,
                    1046,
                    1047,
                    1048,
                    1049,
                    1050,
                    1051,
                    1052,
                    1053,
                    1054,
                    1055,
                    1056,
                    1057,
                    1058,
                    1059,
                    1060,
                    1061,
                    1062,
                    1063,
                    1064,
                    1065,
                    1066,
                    1067,
                    1068,
                    1069,
                    1070,
                    1071,
                    1072,
                    1073,
                    1074,
                    1075,
                    1076,
                    1077,
                    1078,
                    1079,
                    1080,
                    1081,
                    1082,
                    1083,
                    1084,
                    1085,
                    1086,
                    1087,
                    1088,
                    1089,
                    1090,
                    1091,
                    1092,
                    1093,
                    1094,
                    1095,
                    1096,
                    1097,
                    1098,
                    1099,
                    1100,
                    1101,
                    1102,
                    1103,
                    1104,
                    1105,
                    1106,
                    1107,
                    1108,
                    1109,
                    1110,
                    1111,
                    1112,
                    1113,
                    1114,
                    1115,
                    1116,
                    1117,
                    1118,
                    1119,
                    1138,
                    1139,
                    1168,
                    1169,
                    7808,
                    7809,
                    7810,
                    7811,
                    7812,
                    7813,
                    7922,
                    7923,
                    8208,
                    8209,
                    8211,
                    8212,
                    8213,
                    8215,
                    8216,
                    8217,
                    8218,
                    8219,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8226,
                    8230,
                    8240,
                    8242,
                    8243,
                    8249,
                    8250,
                    8252,
                    8254,
                    8260,
                    8319,
                    8355,
                    8356,
                    8359,
                    8364,
                    8453,
                    8467,
                    8470,
                    8482,
                    8486,
                    8494,
                    8539,
                    8540,
                    8541,
                    8542,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8597,
                    8616,
                    8706,
                    8710,
                    8719,
                    8721,
                    8722,
                    8730,
                    8734,
                    8735,
                    8745,
                    8747,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8962,
                    8976,
                    8992,
                    8993,
                    9472,
                    9474,
                    9484,
                    9488,
                    9492,
                    9496,
                    9500,
                    9508,
                    9516,
                    9524,
                    9532,
                    9552,
                    9553,
                    9554,
                    9555,
                    9556,
                    9557,
                    9558,
                    9559,
                    9560,
                    9561,
                    9562,
                    9563,
                    9564,
                    9565,
                    9566,
                    9567,
                    9568,
                    9569,
                    9570,
                    9571,
                    9572,
                    9573,
                    9574,
                    9575,
                    9576,
                    9577,
                    9578,
                    9579,
                    9580,
                    9600,
                    9604,
                    9608,
                    9612,
                    9616,
                    9617,
                    9618,
                    9619,
                    9632,
                    9633,
                    9642,
                    9643,
                    9644,
                    9650,
                    9658,
                    9660,
                    9668,
                    9674,
                    9675,
                    9679,
                    9688,
                    9689,
                    9702,
                    9786,
                    9787,
                    9788,
                    9792,
                    9794,
                    9824,
                    9827,
                    9829,
                    9830,
                    9834,
                    9835,
                    9836,
                    61441,
                    61442,
                    61445,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                exports.LiberationSansRegularMapping = LiberationSansRegularMapping;
            /***/ },
            /* 55 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MyriadProRegularMetrics = exports.MyriadProRegularFactors = exports.MyriadProItalicMetrics = exports.MyriadProItalicFactors = exports.MyriadProBoldMetrics = exports.MyriadProBoldItalicMetrics = exports.MyriadProBoldItalicFactors = exports.MyriadProBoldFactors = void 0;
                const MyriadProBoldFactors = [
                    1.36898,
                    1,
                    1,
                    0.72706,
                    0.80479,
                    0.83734,
                    0.98894,
                    0.99793,
                    0.9897,
                    0.93884,
                    0.86209,
                    0.94292,
                    0.94292,
                    1.16661,
                    1.02058,
                    0.93582,
                    0.96694,
                    0.93582,
                    1.19137,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.78076,
                    0.78076,
                    1.02058,
                    1.02058,
                    1.02058,
                    0.72851,
                    0.78966,
                    0.90838,
                    0.83637,
                    0.82391,
                    0.96376,
                    0.80061,
                    0.86275,
                    0.8768,
                    0.95407,
                    1.0258,
                    0.73901,
                    0.85022,
                    0.83655,
                    1.0156,
                    0.95546,
                    0.92179,
                    0.87107,
                    0.92179,
                    0.82114,
                    0.8096,
                    0.89713,
                    0.94438,
                    0.95353,
                    0.94083,
                    0.91905,
                    0.90406,
                    0.9446,
                    0.94292,
                    1.18777,
                    0.94292,
                    1.02058,
                    0.89903,
                    0.90088,
                    0.94938,
                    0.97898,
                    0.81093,
                    0.97571,
                    0.94938,
                    1.024,
                    0.9577,
                    0.95933,
                    0.98621,
                    1.0474,
                    0.97455,
                    0.98981,
                    0.9672,
                    0.95933,
                    0.9446,
                    0.97898,
                    0.97407,
                    0.97646,
                    0.78036,
                    1.10208,
                    0.95442,
                    0.95298,
                    0.97579,
                    0.9332,
                    0.94039,
                    0.938,
                    0.80687,
                    1.01149,
                    0.80687,
                    1.02058,
                    0.80479,
                    0.99793,
                    0.99793,
                    0.99793,
                    0.99793,
                    1.01149,
                    1.00872,
                    0.90088,
                    0.91882,
                    1.0213,
                    0.8361,
                    1.02058,
                    0.62295,
                    0.54324,
                    0.89022,
                    1.08595,
                    1,
                    1,
                    0.90088,
                    1,
                    0.97455,
                    0.93582,
                    0.90088,
                    1,
                    1.05686,
                    0.8361,
                    0.99642,
                    0.99642,
                    0.99642,
                    0.72851,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.868,
                    0.82391,
                    0.80061,
                    0.80061,
                    0.80061,
                    0.80061,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    0.97484,
                    0.95546,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.92179,
                    1.02058,
                    0.92179,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.90406,
                    0.86958,
                    0.98225,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.9031,
                    0.81093,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.93969,
                    0.95933,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.9446,
                    1.08595,
                    0.9446,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.94039,
                    0.97898,
                    0.94039,
                    0.90838,
                    0.94938,
                    0.90838,
                    0.94938,
                    0.90838,
                    0.94938,
                    0.82391,
                    0.81093,
                    0.82391,
                    0.81093,
                    0.82391,
                    0.81093,
                    0.82391,
                    0.81093,
                    0.96376,
                    0.84313,
                    0.97484,
                    0.97571,
                    0.80061,
                    0.94938,
                    0.80061,
                    0.94938,
                    0.80061,
                    0.94938,
                    0.80061,
                    0.94938,
                    0.80061,
                    0.94938,
                    0.8768,
                    0.9577,
                    0.8768,
                    0.9577,
                    0.8768,
                    0.9577,
                    1,
                    1,
                    0.95407,
                    0.95933,
                    0.97069,
                    0.95933,
                    1.0258,
                    0.98621,
                    1.0258,
                    0.98621,
                    1.0258,
                    0.98621,
                    1.0258,
                    0.98621,
                    1.0258,
                    0.98621,
                    0.887,
                    1.01591,
                    0.73901,
                    1.0474,
                    1,
                    1,
                    0.97455,
                    0.83655,
                    0.98981,
                    1,
                    1,
                    0.83655,
                    0.73977,
                    0.83655,
                    0.73903,
                    0.84638,
                    1.033,
                    0.95546,
                    0.95933,
                    1,
                    1,
                    0.95546,
                    0.95933,
                    0.8271,
                    0.95417,
                    0.95933,
                    0.92179,
                    0.9446,
                    0.92179,
                    0.9446,
                    0.92179,
                    0.9446,
                    0.936,
                    0.91964,
                    0.82114,
                    0.97646,
                    1,
                    1,
                    0.82114,
                    0.97646,
                    0.8096,
                    0.78036,
                    0.8096,
                    0.78036,
                    1,
                    1,
                    0.8096,
                    0.78036,
                    1,
                    1,
                    0.89713,
                    0.77452,
                    0.89713,
                    1.10208,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94438,
                    0.95442,
                    0.94083,
                    0.97579,
                    0.90406,
                    0.94039,
                    0.90406,
                    0.9446,
                    0.938,
                    0.9446,
                    0.938,
                    0.9446,
                    0.938,
                    1,
                    0.99793,
                    0.90838,
                    0.94938,
                    0.868,
                    0.9031,
                    0.92179,
                    0.9446,
                    1,
                    1,
                    0.89713,
                    1.10208,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90989,
                    0.9358,
                    0.91945,
                    0.83181,
                    0.75261,
                    0.87992,
                    0.82976,
                    0.96034,
                    0.83689,
                    0.97268,
                    1.0078,
                    0.90838,
                    0.83637,
                    0.8019,
                    0.90157,
                    0.80061,
                    0.9446,
                    0.95407,
                    0.92436,
                    1.0258,
                    0.85022,
                    0.97153,
                    1.0156,
                    0.95546,
                    0.89192,
                    0.92179,
                    0.92361,
                    0.87107,
                    0.96318,
                    0.89713,
                    0.93704,
                    0.95638,
                    0.91905,
                    0.91709,
                    0.92796,
                    1.0258,
                    0.93704,
                    0.94836,
                    1.0373,
                    0.95933,
                    1.0078,
                    0.95871,
                    0.94836,
                    0.96174,
                    0.92601,
                    0.9498,
                    0.98607,
                    0.95776,
                    0.95933,
                    1.05453,
                    1.0078,
                    0.98275,
                    0.9314,
                    0.95617,
                    0.91701,
                    1.05993,
                    0.9446,
                    0.78367,
                    0.9553,
                    1,
                    0.86832,
                    1.0128,
                    0.95871,
                    0.99394,
                    0.87548,
                    0.96361,
                    0.86774,
                    1.0078,
                    0.95871,
                    0.9446,
                    0.95871,
                    0.86774,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.94083,
                    0.97579,
                    0.94083,
                    0.97579,
                    0.94083,
                    0.97579,
                    0.90406,
                    0.94039,
                    0.96694,
                    1,
                    0.89903,
                    1,
                    1,
                    1,
                    0.93582,
                    0.93582,
                    0.93582,
                    1,
                    0.908,
                    0.908,
                    0.918,
                    0.94219,
                    0.94219,
                    0.96544,
                    1,
                    1.285,
                    1,
                    1,
                    0.81079,
                    0.81079,
                    1,
                    1,
                    0.74854,
                    1,
                    1,
                    1,
                    1,
                    0.99793,
                    1,
                    1,
                    1,
                    0.65,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.17173,
                    1,
                    0.80535,
                    0.76169,
                    1.02058,
                    1.0732,
                    1.05486,
                    1,
                    1,
                    1.30692,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.16161,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.MyriadProBoldFactors = MyriadProBoldFactors;
                const MyriadProBoldMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.MyriadProBoldMetrics = MyriadProBoldMetrics;
                const MyriadProBoldItalicFactors = [
                    1.36898,
                    1,
                    1,
                    0.66227,
                    0.80779,
                    0.81625,
                    0.97276,
                    0.97276,
                    0.97733,
                    0.92222,
                    0.83266,
                    0.94292,
                    0.94292,
                    1.16148,
                    1.02058,
                    0.93582,
                    0.96694,
                    0.93582,
                    1.17337,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.78076,
                    0.78076,
                    1.02058,
                    1.02058,
                    1.02058,
                    0.71541,
                    0.76813,
                    0.85576,
                    0.80591,
                    0.80729,
                    0.94299,
                    0.77512,
                    0.83655,
                    0.86523,
                    0.92222,
                    0.98621,
                    0.71743,
                    0.81698,
                    0.79726,
                    0.98558,
                    0.92222,
                    0.90637,
                    0.83809,
                    0.90637,
                    0.80729,
                    0.76463,
                    0.86275,
                    0.90699,
                    0.91605,
                    0.9154,
                    0.85308,
                    0.85458,
                    0.90531,
                    0.94292,
                    1.21296,
                    0.94292,
                    1.02058,
                    0.89903,
                    1.18616,
                    0.99613,
                    0.91677,
                    0.78216,
                    0.91677,
                    0.90083,
                    0.98796,
                    0.9135,
                    0.92168,
                    0.95381,
                    0.98981,
                    0.95298,
                    0.95381,
                    0.93459,
                    0.92168,
                    0.91513,
                    0.92004,
                    0.91677,
                    0.95077,
                    0.748,
                    1.04502,
                    0.91677,
                    0.92061,
                    0.94236,
                    0.89544,
                    0.89364,
                    0.9,
                    0.80687,
                    0.8578,
                    0.80687,
                    1.02058,
                    0.80779,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.97276,
                    0.8578,
                    0.99973,
                    1.18616,
                    0.91339,
                    1.08074,
                    0.82891,
                    1.02058,
                    0.55509,
                    0.71526,
                    0.89022,
                    1.08595,
                    1,
                    1,
                    1.18616,
                    1,
                    0.96736,
                    0.93582,
                    1.18616,
                    1,
                    1.04864,
                    0.82711,
                    0.99043,
                    0.99043,
                    0.99043,
                    0.71541,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.845,
                    0.80729,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.95961,
                    0.92222,
                    0.90637,
                    0.90637,
                    0.90637,
                    0.90637,
                    0.90637,
                    1.02058,
                    0.90251,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.85458,
                    0.83659,
                    0.94951,
                    0.99613,
                    0.99613,
                    0.99613,
                    0.99613,
                    0.99613,
                    0.99613,
                    0.85811,
                    0.78216,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.9135,
                    0.92168,
                    0.91513,
                    0.91513,
                    0.91513,
                    0.91513,
                    0.91513,
                    1.08595,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.89364,
                    0.92332,
                    0.89364,
                    0.85576,
                    0.99613,
                    0.85576,
                    0.99613,
                    0.85576,
                    0.99613,
                    0.80729,
                    0.78216,
                    0.80729,
                    0.78216,
                    0.80729,
                    0.78216,
                    0.80729,
                    0.78216,
                    0.94299,
                    0.76783,
                    0.95961,
                    0.91677,
                    0.77512,
                    0.90083,
                    0.77512,
                    0.90083,
                    0.77512,
                    0.90083,
                    0.77512,
                    0.90083,
                    0.77512,
                    0.90083,
                    0.86523,
                    0.9135,
                    0.86523,
                    0.9135,
                    0.86523,
                    0.9135,
                    1,
                    1,
                    0.92222,
                    0.92168,
                    0.92222,
                    0.92168,
                    0.98621,
                    0.95381,
                    0.98621,
                    0.95381,
                    0.98621,
                    0.95381,
                    0.98621,
                    0.95381,
                    0.98621,
                    0.95381,
                    0.86036,
                    0.97096,
                    0.71743,
                    0.98981,
                    1,
                    1,
                    0.95298,
                    0.79726,
                    0.95381,
                    1,
                    1,
                    0.79726,
                    0.6894,
                    0.79726,
                    0.74321,
                    0.81691,
                    1.0006,
                    0.92222,
                    0.92168,
                    1,
                    1,
                    0.92222,
                    0.92168,
                    0.79464,
                    0.92098,
                    0.92168,
                    0.90637,
                    0.91513,
                    0.90637,
                    0.91513,
                    0.90637,
                    0.91513,
                    0.909,
                    0.87514,
                    0.80729,
                    0.95077,
                    1,
                    1,
                    0.80729,
                    0.95077,
                    0.76463,
                    0.748,
                    0.76463,
                    0.748,
                    1,
                    1,
                    0.76463,
                    0.748,
                    1,
                    1,
                    0.86275,
                    0.72651,
                    0.86275,
                    1.04502,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.90699,
                    0.91677,
                    0.9154,
                    0.94236,
                    0.85458,
                    0.89364,
                    0.85458,
                    0.90531,
                    0.9,
                    0.90531,
                    0.9,
                    0.90531,
                    0.9,
                    1,
                    0.97276,
                    0.85576,
                    0.99613,
                    0.845,
                    0.85811,
                    0.90251,
                    0.91677,
                    1,
                    1,
                    0.86275,
                    1.04502,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.18616,
                    1.00899,
                    1.30628,
                    0.85576,
                    0.80178,
                    0.66862,
                    0.7927,
                    0.69323,
                    0.88127,
                    0.72459,
                    0.89711,
                    0.95381,
                    0.85576,
                    0.80591,
                    0.7805,
                    0.94729,
                    0.77512,
                    0.90531,
                    0.92222,
                    0.90637,
                    0.98621,
                    0.81698,
                    0.92655,
                    0.98558,
                    0.92222,
                    0.85359,
                    0.90637,
                    0.90976,
                    0.83809,
                    0.94523,
                    0.86275,
                    0.83509,
                    0.93157,
                    0.85308,
                    0.83392,
                    0.92346,
                    0.98621,
                    0.83509,
                    0.92886,
                    0.91324,
                    0.92168,
                    0.95381,
                    0.90646,
                    0.92886,
                    0.90557,
                    0.86847,
                    0.90276,
                    0.91324,
                    0.86842,
                    0.92168,
                    0.99531,
                    0.95381,
                    0.9224,
                    0.85408,
                    0.92699,
                    0.86847,
                    1.0051,
                    0.91513,
                    0.80487,
                    0.93481,
                    1,
                    0.88159,
                    1.05214,
                    0.90646,
                    0.97355,
                    0.81539,
                    0.89398,
                    0.85923,
                    0.95381,
                    0.90646,
                    0.91513,
                    0.90646,
                    0.85923,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.9154,
                    0.94236,
                    0.9154,
                    0.94236,
                    0.9154,
                    0.94236,
                    0.85458,
                    0.89364,
                    0.96694,
                    1,
                    0.89903,
                    1,
                    1,
                    1,
                    0.91782,
                    0.91782,
                    0.91782,
                    1,
                    0.896,
                    0.896,
                    0.896,
                    0.9332,
                    0.9332,
                    0.95973,
                    1,
                    1.26,
                    1,
                    1,
                    0.80479,
                    0.80178,
                    1,
                    1,
                    0.85633,
                    1,
                    1,
                    1,
                    1,
                    0.97276,
                    1,
                    1,
                    1,
                    0.698,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.14542,
                    1,
                    0.79199,
                    0.78694,
                    1.02058,
                    1.03493,
                    1.05486,
                    1,
                    1,
                    1.23026,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.20006,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.MyriadProBoldItalicFactors = MyriadProBoldItalicFactors;
                const MyriadProBoldItalicMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.MyriadProBoldItalicMetrics = MyriadProBoldItalicMetrics;
                const MyriadProItalicFactors = [
                    1.36898,
                    1,
                    1,
                    0.65507,
                    0.84943,
                    0.85639,
                    0.88465,
                    0.88465,
                    0.86936,
                    0.88307,
                    0.86948,
                    0.85283,
                    0.85283,
                    1.06383,
                    1.02058,
                    0.75945,
                    0.9219,
                    0.75945,
                    1.17337,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.75945,
                    0.75945,
                    1.02058,
                    1.02058,
                    1.02058,
                    0.69046,
                    0.70926,
                    0.85158,
                    0.77812,
                    0.76852,
                    0.89591,
                    0.70466,
                    0.76125,
                    0.80094,
                    0.86822,
                    0.83864,
                    0.728,
                    0.77212,
                    0.79475,
                    0.93637,
                    0.87514,
                    0.8588,
                    0.76013,
                    0.8588,
                    0.72421,
                    0.69866,
                    0.77598,
                    0.85991,
                    0.80811,
                    0.87832,
                    0.78112,
                    0.77512,
                    0.8562,
                    1.0222,
                    1.18417,
                    1.0222,
                    1.27014,
                    0.89903,
                    1.15012,
                    0.93859,
                    0.94399,
                    0.846,
                    0.94399,
                    0.81453,
                    1.0186,
                    0.94219,
                    0.96017,
                    1.03075,
                    1.02175,
                    0.912,
                    1.03075,
                    0.96998,
                    0.96017,
                    0.93859,
                    0.94399,
                    0.94399,
                    0.95493,
                    0.746,
                    1.12658,
                    0.94578,
                    0.91,
                    0.979,
                    0.882,
                    0.882,
                    0.83,
                    0.85034,
                    0.83537,
                    0.85034,
                    1.02058,
                    0.70869,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.88465,
                    0.83537,
                    0.90083,
                    1.15012,
                    0.9161,
                    0.94565,
                    0.73541,
                    1.02058,
                    0.53609,
                    0.69353,
                    0.79519,
                    1.08595,
                    1,
                    1,
                    1.15012,
                    1,
                    0.91974,
                    0.75945,
                    1.15012,
                    1,
                    0.9446,
                    0.73361,
                    0.9005,
                    0.9005,
                    0.9005,
                    0.62864,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.773,
                    0.76852,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.90561,
                    0.87514,
                    0.8588,
                    0.8588,
                    0.8588,
                    0.8588,
                    0.8588,
                    1.02058,
                    0.85751,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.77512,
                    0.76013,
                    0.88075,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.8075,
                    0.846,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.82424,
                    0.82424,
                    0.82424,
                    0.82424,
                    0.9278,
                    0.96017,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    1.08595,
                    0.8562,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.882,
                    0.94578,
                    0.882,
                    0.85158,
                    0.93859,
                    0.85158,
                    0.93859,
                    0.85158,
                    0.93859,
                    0.76852,
                    0.846,
                    0.76852,
                    0.846,
                    0.76852,
                    0.846,
                    0.76852,
                    0.846,
                    0.89591,
                    0.8544,
                    0.90561,
                    0.94399,
                    0.70466,
                    0.81453,
                    0.70466,
                    0.81453,
                    0.70466,
                    0.81453,
                    0.70466,
                    0.81453,
                    0.70466,
                    0.81453,
                    0.80094,
                    0.94219,
                    0.80094,
                    0.94219,
                    0.80094,
                    0.94219,
                    1,
                    1,
                    0.86822,
                    0.96017,
                    0.86822,
                    0.96017,
                    0.83864,
                    0.82424,
                    0.83864,
                    0.82424,
                    0.83864,
                    0.82424,
                    0.83864,
                    1.03075,
                    0.83864,
                    0.82424,
                    0.81402,
                    1.02738,
                    0.728,
                    1.02175,
                    1,
                    1,
                    0.912,
                    0.79475,
                    1.03075,
                    1,
                    1,
                    0.79475,
                    0.83911,
                    0.79475,
                    0.66266,
                    0.80553,
                    1.06676,
                    0.87514,
                    0.96017,
                    1,
                    1,
                    0.87514,
                    0.96017,
                    0.86865,
                    0.87396,
                    0.96017,
                    0.8588,
                    0.93859,
                    0.8588,
                    0.93859,
                    0.8588,
                    0.93859,
                    0.867,
                    0.84759,
                    0.72421,
                    0.95493,
                    1,
                    1,
                    0.72421,
                    0.95493,
                    0.69866,
                    0.746,
                    0.69866,
                    0.746,
                    1,
                    1,
                    0.69866,
                    0.746,
                    1,
                    1,
                    0.77598,
                    0.88417,
                    0.77598,
                    1.12658,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.85991,
                    0.94578,
                    0.87832,
                    0.979,
                    0.77512,
                    0.882,
                    0.77512,
                    0.8562,
                    0.83,
                    0.8562,
                    0.83,
                    0.8562,
                    0.83,
                    1,
                    0.88465,
                    0.85158,
                    0.93859,
                    0.773,
                    0.8075,
                    0.85751,
                    0.8562,
                    1,
                    1,
                    0.77598,
                    1.12658,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.15313,
                    1.15012,
                    1.15012,
                    1.15012,
                    1.08106,
                    1.03901,
                    0.85158,
                    0.77025,
                    0.62264,
                    0.7646,
                    0.65351,
                    0.86026,
                    0.69461,
                    0.89947,
                    1.03075,
                    0.85158,
                    0.77812,
                    0.76449,
                    0.88836,
                    0.70466,
                    0.8562,
                    0.86822,
                    0.8588,
                    0.83864,
                    0.77212,
                    0.85308,
                    0.93637,
                    0.87514,
                    0.82352,
                    0.8588,
                    0.85701,
                    0.76013,
                    0.89058,
                    0.77598,
                    0.8156,
                    0.82565,
                    0.78112,
                    0.77899,
                    0.89386,
                    0.83864,
                    0.8156,
                    0.9486,
                    0.92388,
                    0.96186,
                    1.03075,
                    0.91123,
                    0.9486,
                    0.93298,
                    0.878,
                    0.93942,
                    0.92388,
                    0.84596,
                    0.96186,
                    0.95119,
                    1.03075,
                    0.922,
                    0.88787,
                    0.95829,
                    0.88,
                    0.93559,
                    0.93859,
                    0.78815,
                    0.93758,
                    1,
                    0.89217,
                    1.03737,
                    0.91123,
                    0.93969,
                    0.77487,
                    0.85769,
                    0.86799,
                    1.03075,
                    0.91123,
                    0.93859,
                    0.91123,
                    0.86799,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.87832,
                    0.979,
                    0.87832,
                    0.979,
                    0.87832,
                    0.979,
                    0.77512,
                    0.882,
                    0.9219,
                    1,
                    0.89903,
                    1,
                    1,
                    1,
                    0.87321,
                    0.87321,
                    0.87321,
                    1,
                    1.027,
                    1.027,
                    1.027,
                    0.86847,
                    0.86847,
                    0.79121,
                    1,
                    1.124,
                    1,
                    1,
                    0.73572,
                    0.73572,
                    1,
                    1,
                    0.85034,
                    1,
                    1,
                    1,
                    1,
                    0.88465,
                    1,
                    1,
                    1,
                    0.669,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.04828,
                    1,
                    0.74948,
                    0.75187,
                    1.02058,
                    0.98391,
                    1.02119,
                    1,
                    1,
                    1.06233,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05233,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.MyriadProItalicFactors = MyriadProItalicFactors;
                const MyriadProItalicMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.MyriadProItalicMetrics = MyriadProItalicMetrics;
                const MyriadProRegularFactors = [
                    1.36898,
                    1,
                    1,
                    0.76305,
                    0.82784,
                    0.94935,
                    0.89364,
                    0.92241,
                    0.89073,
                    0.90706,
                    0.98472,
                    0.85283,
                    0.85283,
                    1.0664,
                    1.02058,
                    0.74505,
                    0.9219,
                    0.74505,
                    1.23456,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.74505,
                    0.74505,
                    1.02058,
                    1.02058,
                    1.02058,
                    0.73002,
                    0.72601,
                    0.91755,
                    0.8126,
                    0.80314,
                    0.92222,
                    0.73764,
                    0.79726,
                    0.83051,
                    0.90284,
                    0.86023,
                    0.74,
                    0.8126,
                    0.84869,
                    0.96518,
                    0.91115,
                    0.8858,
                    0.79761,
                    0.8858,
                    0.74498,
                    0.73914,
                    0.81363,
                    0.89591,
                    0.83659,
                    0.89633,
                    0.85608,
                    0.8111,
                    0.90531,
                    1.0222,
                    1.22736,
                    1.0222,
                    1.27014,
                    0.89903,
                    0.90088,
                    0.86667,
                    1.0231,
                    0.896,
                    1.01411,
                    0.90083,
                    1.05099,
                    1.00512,
                    0.99793,
                    1.05326,
                    1.09377,
                    0.938,
                    1.06226,
                    1.00119,
                    0.99793,
                    0.98714,
                    1.0231,
                    1.01231,
                    0.98196,
                    0.792,
                    1.19137,
                    0.99074,
                    0.962,
                    1.01915,
                    0.926,
                    0.942,
                    0.856,
                    0.85034,
                    0.92006,
                    0.85034,
                    1.02058,
                    0.69067,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92241,
                    0.92006,
                    0.9332,
                    0.90088,
                    0.91882,
                    0.93484,
                    0.75339,
                    1.02058,
                    0.56866,
                    0.54324,
                    0.79519,
                    1.08595,
                    1,
                    1,
                    0.90088,
                    1,
                    0.95325,
                    0.74505,
                    0.90088,
                    1,
                    0.97198,
                    0.75339,
                    0.91009,
                    0.91009,
                    0.91009,
                    0.66466,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.788,
                    0.80314,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.92915,
                    0.91115,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.8858,
                    1.02058,
                    0.8858,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.8111,
                    0.79611,
                    0.89713,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.86936,
                    0.896,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.84224,
                    0.84224,
                    0.84224,
                    0.84224,
                    0.97276,
                    0.99793,
                    0.98714,
                    0.98714,
                    0.98714,
                    0.98714,
                    0.98714,
                    1.08595,
                    0.89876,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.942,
                    1.0231,
                    0.942,
                    0.91755,
                    0.86667,
                    0.91755,
                    0.86667,
                    0.91755,
                    0.86667,
                    0.80314,
                    0.896,
                    0.80314,
                    0.896,
                    0.80314,
                    0.896,
                    0.80314,
                    0.896,
                    0.92222,
                    0.93372,
                    0.92915,
                    1.01411,
                    0.73764,
                    0.90083,
                    0.73764,
                    0.90083,
                    0.73764,
                    0.90083,
                    0.73764,
                    0.90083,
                    0.73764,
                    0.90083,
                    0.83051,
                    1.00512,
                    0.83051,
                    1.00512,
                    0.83051,
                    1.00512,
                    1,
                    1,
                    0.90284,
                    0.99793,
                    0.90976,
                    0.99793,
                    0.86023,
                    0.84224,
                    0.86023,
                    0.84224,
                    0.86023,
                    0.84224,
                    0.86023,
                    1.05326,
                    0.86023,
                    0.84224,
                    0.82873,
                    1.07469,
                    0.74,
                    1.09377,
                    1,
                    1,
                    0.938,
                    0.84869,
                    1.06226,
                    1,
                    1,
                    0.84869,
                    0.83704,
                    0.84869,
                    0.81441,
                    0.85588,
                    1.08927,
                    0.91115,
                    0.99793,
                    1,
                    1,
                    0.91115,
                    0.99793,
                    0.91887,
                    0.90991,
                    0.99793,
                    0.8858,
                    0.98714,
                    0.8858,
                    0.98714,
                    0.8858,
                    0.98714,
                    0.894,
                    0.91434,
                    0.74498,
                    0.98196,
                    1,
                    1,
                    0.74498,
                    0.98196,
                    0.73914,
                    0.792,
                    0.73914,
                    0.792,
                    1,
                    1,
                    0.73914,
                    0.792,
                    1,
                    1,
                    0.81363,
                    0.904,
                    0.81363,
                    1.19137,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89591,
                    0.99074,
                    0.89633,
                    1.01915,
                    0.8111,
                    0.942,
                    0.8111,
                    0.90531,
                    0.856,
                    0.90531,
                    0.856,
                    0.90531,
                    0.856,
                    1,
                    0.92241,
                    0.91755,
                    0.86667,
                    0.788,
                    0.86936,
                    0.8858,
                    0.89876,
                    1,
                    1,
                    0.81363,
                    1.19137,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90088,
                    0.90388,
                    1.03901,
                    0.92138,
                    0.78105,
                    0.7154,
                    0.86169,
                    0.80513,
                    0.94007,
                    0.82528,
                    0.98612,
                    1.06226,
                    0.91755,
                    0.8126,
                    0.81884,
                    0.92819,
                    0.73764,
                    0.90531,
                    0.90284,
                    0.8858,
                    0.86023,
                    0.8126,
                    0.91172,
                    0.96518,
                    0.91115,
                    0.83089,
                    0.8858,
                    0.87791,
                    0.79761,
                    0.89297,
                    0.81363,
                    0.88157,
                    0.89992,
                    0.85608,
                    0.81992,
                    0.94307,
                    0.86023,
                    0.88157,
                    0.95308,
                    0.98699,
                    0.99793,
                    1.06226,
                    0.95817,
                    0.95308,
                    0.97358,
                    0.928,
                    0.98088,
                    0.98699,
                    0.92761,
                    0.99793,
                    0.96017,
                    1.06226,
                    0.986,
                    0.944,
                    0.95978,
                    0.938,
                    0.96705,
                    0.98714,
                    0.80442,
                    0.98972,
                    1,
                    0.89762,
                    1.04552,
                    0.95817,
                    0.99007,
                    0.87064,
                    0.91879,
                    0.88888,
                    1.06226,
                    0.95817,
                    0.98714,
                    0.95817,
                    0.88888,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.89633,
                    1.01915,
                    0.89633,
                    1.01915,
                    0.89633,
                    1.01915,
                    0.8111,
                    0.942,
                    0.9219,
                    1,
                    0.89903,
                    1,
                    1,
                    1,
                    0.93173,
                    0.93173,
                    0.93173,
                    1,
                    1.06304,
                    1.06304,
                    1.06904,
                    0.89903,
                    0.89903,
                    0.80549,
                    1,
                    1.156,
                    1,
                    1,
                    0.76575,
                    0.76575,
                    1,
                    1,
                    0.72458,
                    1,
                    1,
                    1,
                    1,
                    0.92241,
                    1,
                    1,
                    1,
                    0.619,
                    1,
                    1.36145,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.07257,
                    1,
                    0.74705,
                    0.71119,
                    1.02058,
                    1.024,
                    1.02119,
                    1,
                    1,
                    1.1536,
                    1.08595,
                    1.08595,
                    1,
                    1.08595,
                    1.08595,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05638,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.MyriadProRegularFactors = MyriadProRegularFactors;
                const MyriadProRegularMetrics = {
                    lineHeight: 1.2,
                    lineGap: 0.2
                };
                exports.MyriadProRegularMetrics = MyriadProRegularMetrics;
            /***/ },
            /* 56 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SegoeuiRegularMetrics = exports.SegoeuiRegularFactors = exports.SegoeuiItalicMetrics = exports.SegoeuiItalicFactors = exports.SegoeuiBoldMetrics = exports.SegoeuiBoldItalicMetrics = exports.SegoeuiBoldItalicFactors = exports.SegoeuiBoldFactors = void 0;
                const SegoeuiBoldFactors = [
                    1.76738,
                    1,
                    1,
                    0.99297,
                    0.9824,
                    1.04016,
                    1.06497,
                    1.03424,
                    0.97529,
                    1.17647,
                    1.23203,
                    1.1085,
                    1.1085,
                    1.16939,
                    1.2107,
                    0.9754,
                    1.21408,
                    0.9754,
                    1.59578,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    1.03424,
                    0.81378,
                    0.81378,
                    1.2107,
                    1.2107,
                    1.2107,
                    0.71703,
                    0.97847,
                    0.97363,
                    0.88776,
                    0.8641,
                    1.02096,
                    0.79795,
                    0.85132,
                    0.914,
                    1.06085,
                    1.1406,
                    0.8007,
                    0.89858,
                    0.83693,
                    1.14889,
                    1.09398,
                    0.97489,
                    0.92094,
                    0.97489,
                    0.90399,
                    0.84041,
                    0.95923,
                    1.00135,
                    1,
                    1.06467,
                    0.98243,
                    0.90996,
                    0.99361,
                    1.1085,
                    1.56942,
                    1.1085,
                    1.2107,
                    0.74627,
                    0.94282,
                    0.96752,
                    1.01519,
                    0.86304,
                    1.01359,
                    0.97278,
                    1.15103,
                    1.01359,
                    0.98561,
                    1.02285,
                    1.02285,
                    1.00527,
                    1.02285,
                    1.0302,
                    0.99041,
                    1.0008,
                    1.01519,
                    1.01359,
                    1.02258,
                    0.79104,
                    1.16862,
                    0.99041,
                    0.97454,
                    1.02511,
                    0.99298,
                    0.96752,
                    0.95801,
                    0.94856,
                    1.16579,
                    0.94856,
                    1.2107,
                    0.9824,
                    1.03424,
                    1.03424,
                    1,
                    1.03424,
                    1.16579,
                    0.8727,
                    1.3871,
                    1.18622,
                    1.10818,
                    1.04478,
                    1.2107,
                    1.18622,
                    0.75155,
                    0.94994,
                    1.28826,
                    1.21408,
                    1.21408,
                    0.91056,
                    1,
                    0.91572,
                    0.9754,
                    0.64663,
                    1.18328,
                    1.24866,
                    1.04478,
                    1.14169,
                    1.15749,
                    1.17389,
                    0.71703,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.93506,
                    0.8641,
                    0.79795,
                    0.79795,
                    0.79795,
                    0.79795,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.02096,
                    1.09398,
                    0.97426,
                    0.97426,
                    0.97426,
                    0.97426,
                    0.97426,
                    1.2107,
                    0.97489,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    0.90996,
                    0.92094,
                    1.02798,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.93136,
                    0.86304,
                    0.97278,
                    0.97278,
                    0.97278,
                    0.97278,
                    1.02285,
                    1.02285,
                    1.02285,
                    1.02285,
                    0.97122,
                    0.99041,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.28826,
                    1.0008,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.96752,
                    1.01519,
                    0.96752,
                    0.97363,
                    0.96752,
                    0.97363,
                    0.96752,
                    0.97363,
                    0.96752,
                    0.8641,
                    0.86304,
                    0.8641,
                    0.86304,
                    0.8641,
                    0.86304,
                    0.8641,
                    0.86304,
                    1.02096,
                    1.03057,
                    1.02096,
                    1.03517,
                    0.79795,
                    0.97278,
                    0.79795,
                    0.97278,
                    0.79795,
                    0.97278,
                    0.79795,
                    0.97278,
                    0.79795,
                    0.97278,
                    0.914,
                    1.01359,
                    0.914,
                    1.01359,
                    0.914,
                    1.01359,
                    1,
                    1,
                    1.06085,
                    0.98561,
                    1.06085,
                    1.00879,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    1.1406,
                    1.02285,
                    0.97138,
                    1.08692,
                    0.8007,
                    1.02285,
                    1,
                    1,
                    1.00527,
                    0.83693,
                    1.02285,
                    1,
                    1,
                    0.83693,
                    0.9455,
                    0.83693,
                    0.90418,
                    0.83693,
                    1.13005,
                    1.09398,
                    0.99041,
                    1,
                    1,
                    1.09398,
                    0.99041,
                    0.96692,
                    1.09251,
                    0.99041,
                    0.97489,
                    1.0008,
                    0.97489,
                    1.0008,
                    0.97489,
                    1.0008,
                    0.93994,
                    0.97931,
                    0.90399,
                    1.02258,
                    1,
                    1,
                    0.90399,
                    1.02258,
                    0.84041,
                    0.79104,
                    0.84041,
                    0.79104,
                    0.84041,
                    0.79104,
                    0.84041,
                    0.79104,
                    1,
                    1,
                    0.95923,
                    1.07034,
                    0.95923,
                    1.16862,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.00135,
                    0.99041,
                    1.06467,
                    1.02511,
                    0.90996,
                    0.96752,
                    0.90996,
                    0.99361,
                    0.95801,
                    0.99361,
                    0.95801,
                    0.99361,
                    0.95801,
                    1.07733,
                    1.03424,
                    0.97363,
                    0.96752,
                    0.93506,
                    0.93136,
                    0.97489,
                    1.0008,
                    1,
                    1,
                    0.95923,
                    1.16862,
                    1.15103,
                    1.15103,
                    1.01173,
                    1.03959,
                    0.75953,
                    0.81378,
                    0.79912,
                    1.15103,
                    1.21994,
                    0.95161,
                    0.87815,
                    1.01149,
                    0.81525,
                    0.7676,
                    0.98167,
                    1.01134,
                    1.02546,
                    0.84097,
                    1.03089,
                    1.18102,
                    0.97363,
                    0.88776,
                    0.85134,
                    0.97826,
                    0.79795,
                    0.99361,
                    1.06085,
                    0.97489,
                    1.1406,
                    0.89858,
                    1.0388,
                    1.14889,
                    1.09398,
                    0.86039,
                    0.97489,
                    1.0595,
                    0.92094,
                    0.94793,
                    0.95923,
                    0.90996,
                    0.99346,
                    0.98243,
                    1.02112,
                    0.95493,
                    1.1406,
                    0.90996,
                    1.03574,
                    1.02597,
                    1.0008,
                    1.18102,
                    1.06628,
                    1.03574,
                    1.0192,
                    1.01932,
                    1.00886,
                    0.97531,
                    1.0106,
                    1.0008,
                    1.13189,
                    1.18102,
                    1.02277,
                    0.98683,
                    1.0016,
                    0.99561,
                    1.07237,
                    1.0008,
                    0.90434,
                    0.99921,
                    0.93803,
                    0.8965,
                    1.23085,
                    1.06628,
                    1.04983,
                    0.96268,
                    1.0499,
                    0.98439,
                    1.18102,
                    1.06628,
                    1.0008,
                    1.06628,
                    0.98439,
                    0.79795,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.09466,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.97278,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.02065,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.06467,
                    1.02511,
                    1.06467,
                    1.02511,
                    1.06467,
                    1.02511,
                    0.90996,
                    0.96752,
                    1,
                    1.21408,
                    0.89903,
                    1,
                    1,
                    0.75155,
                    1.04394,
                    1.04394,
                    1.04394,
                    1.04394,
                    0.98633,
                    0.98633,
                    0.98633,
                    0.73047,
                    0.73047,
                    1.20642,
                    0.91211,
                    1.25635,
                    1.222,
                    1.02956,
                    1.03372,
                    1.03372,
                    0.96039,
                    1.24633,
                    1,
                    1.12454,
                    0.93503,
                    1.03424,
                    1.19687,
                    1.03424,
                    1,
                    1,
                    1,
                    0.771,
                    1,
                    1,
                    1.15749,
                    1.15749,
                    1.15749,
                    1.10948,
                    0.86279,
                    0.94434,
                    0.86279,
                    0.94434,
                    0.86182,
                    1,
                    1,
                    1.16897,
                    1,
                    0.96085,
                    0.90137,
                    1.2107,
                    1.18416,
                    1.13973,
                    0.69825,
                    0.9716,
                    2.10339,
                    1.29004,
                    1.29004,
                    1.21172,
                    1.29004,
                    1.29004,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.18874,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.09193,
                    1.09193,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.SegoeuiBoldFactors = SegoeuiBoldFactors;
                const SegoeuiBoldMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                exports.SegoeuiBoldMetrics = SegoeuiBoldMetrics;
                const SegoeuiBoldItalicFactors = [
                    1.76738,
                    1,
                    1,
                    0.98946,
                    1.03959,
                    1.04016,
                    1.02809,
                    1.036,
                    0.97639,
                    1.10953,
                    1.23203,
                    1.11144,
                    1.11144,
                    1.16939,
                    1.21237,
                    0.9754,
                    1.21261,
                    0.9754,
                    1.59754,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    1.036,
                    0.81378,
                    0.81378,
                    1.21237,
                    1.21237,
                    1.21237,
                    0.73541,
                    0.97847,
                    0.97363,
                    0.89723,
                    0.87897,
                    1.0426,
                    0.79429,
                    0.85292,
                    0.91149,
                    1.05815,
                    1.1406,
                    0.79631,
                    0.90128,
                    0.83853,
                    1.04396,
                    1.10615,
                    0.97552,
                    0.94436,
                    0.97552,
                    0.88641,
                    0.80527,
                    0.96083,
                    1.00135,
                    1,
                    1.06777,
                    0.9817,
                    0.91142,
                    0.99361,
                    1.11144,
                    1.57293,
                    1.11144,
                    1.21237,
                    0.74627,
                    1.31818,
                    1.06585,
                    0.97042,
                    0.83055,
                    0.97042,
                    0.93503,
                    1.1261,
                    0.97042,
                    0.97922,
                    1.14236,
                    0.94552,
                    1.01054,
                    1.14236,
                    1.02471,
                    0.97922,
                    0.94165,
                    0.97042,
                    0.97042,
                    1.0276,
                    0.78929,
                    1.1261,
                    0.97922,
                    0.95874,
                    1.02197,
                    0.98507,
                    0.96752,
                    0.97168,
                    0.95107,
                    1.16579,
                    0.95107,
                    1.21237,
                    1.03959,
                    1.036,
                    1.036,
                    1,
                    1.036,
                    1.16579,
                    0.87357,
                    1.31818,
                    1.18754,
                    1.26781,
                    1.05356,
                    1.21237,
                    1.18622,
                    0.79487,
                    0.94994,
                    1.29004,
                    1.24047,
                    1.24047,
                    1.31818,
                    1,
                    0.91484,
                    0.9754,
                    1.31818,
                    1.1349,
                    1.24866,
                    1.05356,
                    1.13934,
                    1.15574,
                    1.17389,
                    0.73541,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.94385,
                    0.87897,
                    0.79429,
                    0.79429,
                    0.79429,
                    0.79429,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.0426,
                    1.10615,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.97552,
                    1.21237,
                    0.97552,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    0.91142,
                    0.94436,
                    0.98721,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    0.96705,
                    0.83055,
                    0.93503,
                    0.93503,
                    0.93503,
                    0.93503,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.14236,
                    0.93125,
                    0.97922,
                    0.94165,
                    0.94165,
                    0.94165,
                    0.94165,
                    0.94165,
                    1.29004,
                    0.94165,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.96752,
                    0.97042,
                    0.96752,
                    0.97363,
                    1.06585,
                    0.97363,
                    1.06585,
                    0.97363,
                    1.06585,
                    0.87897,
                    0.83055,
                    0.87897,
                    0.83055,
                    0.87897,
                    0.83055,
                    0.87897,
                    0.83055,
                    1.0426,
                    1.0033,
                    1.0426,
                    0.97042,
                    0.79429,
                    0.93503,
                    0.79429,
                    0.93503,
                    0.79429,
                    0.93503,
                    0.79429,
                    0.93503,
                    0.79429,
                    0.93503,
                    0.91149,
                    0.97042,
                    0.91149,
                    0.97042,
                    0.91149,
                    0.97042,
                    1,
                    1,
                    1.05815,
                    0.97922,
                    1.05815,
                    0.97922,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    1.1406,
                    1.14236,
                    0.97441,
                    1.04302,
                    0.79631,
                    1.01582,
                    1,
                    1,
                    1.01054,
                    0.83853,
                    1.14236,
                    1,
                    1,
                    0.83853,
                    1.09125,
                    0.83853,
                    0.90418,
                    0.83853,
                    1.19508,
                    1.10615,
                    0.97922,
                    1,
                    1,
                    1.10615,
                    0.97922,
                    1.01034,
                    1.10466,
                    0.97922,
                    0.97552,
                    0.94165,
                    0.97552,
                    0.94165,
                    0.97552,
                    0.94165,
                    0.91602,
                    0.91981,
                    0.88641,
                    1.0276,
                    1,
                    1,
                    0.88641,
                    1.0276,
                    0.80527,
                    0.78929,
                    0.80527,
                    0.78929,
                    0.80527,
                    0.78929,
                    0.80527,
                    0.78929,
                    1,
                    1,
                    0.96083,
                    1.05403,
                    0.95923,
                    1.16862,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.00135,
                    0.97922,
                    1.06777,
                    1.02197,
                    0.91142,
                    0.96752,
                    0.91142,
                    0.99361,
                    0.97168,
                    0.99361,
                    0.97168,
                    0.99361,
                    0.97168,
                    1.23199,
                    1.036,
                    0.97363,
                    1.06585,
                    0.94385,
                    0.96705,
                    0.97552,
                    0.94165,
                    1,
                    1,
                    0.96083,
                    1.1261,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    1.31818,
                    0.95161,
                    1.27126,
                    1.00811,
                    0.83284,
                    0.77702,
                    0.99137,
                    0.95253,
                    1.0347,
                    0.86142,
                    1.07205,
                    1.14236,
                    0.97363,
                    0.89723,
                    0.86869,
                    1.09818,
                    0.79429,
                    0.99361,
                    1.05815,
                    0.97552,
                    1.1406,
                    0.90128,
                    1.06662,
                    1.04396,
                    1.10615,
                    0.84918,
                    0.97552,
                    1.04694,
                    0.94436,
                    0.98015,
                    0.96083,
                    0.91142,
                    1.00356,
                    0.9817,
                    1.01945,
                    0.98999,
                    1.1406,
                    0.91142,
                    1.04961,
                    0.9898,
                    1.00639,
                    1.14236,
                    1.07514,
                    1.04961,
                    0.99607,
                    1.02897,
                    1.008,
                    0.9898,
                    0.95134,
                    1.00639,
                    1.11121,
                    1.14236,
                    1.00518,
                    0.97981,
                    1.02186,
                    1,
                    1.08578,
                    0.94165,
                    0.99314,
                    0.98387,
                    0.93028,
                    0.93377,
                    1.35125,
                    1.07514,
                    1.10687,
                    0.93491,
                    1.04232,
                    1.00351,
                    1.14236,
                    1.07514,
                    0.94165,
                    1.07514,
                    1.00351,
                    0.79429,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.09097,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.93503,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96609,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.06777,
                    1.02197,
                    1.06777,
                    1.02197,
                    1.06777,
                    1.02197,
                    0.91142,
                    0.96752,
                    1,
                    1.21261,
                    0.89903,
                    1,
                    1,
                    0.75155,
                    1.04745,
                    1.04745,
                    1.04745,
                    1.04394,
                    0.98633,
                    0.98633,
                    0.98633,
                    0.72959,
                    0.72959,
                    1.20502,
                    0.91406,
                    1.26514,
                    1.222,
                    1.02956,
                    1.03372,
                    1.03372,
                    0.96039,
                    1.24633,
                    1,
                    1.09125,
                    0.93327,
                    1.03336,
                    1.16541,
                    1.036,
                    1,
                    1,
                    1,
                    0.771,
                    1,
                    1,
                    1.15574,
                    1.15574,
                    1.15574,
                    1.15574,
                    0.86364,
                    0.94434,
                    0.86279,
                    0.94434,
                    0.86224,
                    1,
                    1,
                    1.16798,
                    1,
                    0.96085,
                    0.90068,
                    1.21237,
                    1.18416,
                    1.13904,
                    0.69825,
                    0.9716,
                    2.10339,
                    1.29004,
                    1.29004,
                    1.21339,
                    1.29004,
                    1.29004,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.18775,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.13269,
                    1.13269,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.SegoeuiBoldItalicFactors = SegoeuiBoldItalicFactors;
                const SegoeuiBoldItalicMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                exports.SegoeuiBoldItalicMetrics = SegoeuiBoldItalicMetrics;
                const SegoeuiItalicFactors = [
                    1.76738,
                    1,
                    1,
                    0.98946,
                    1.14763,
                    1.05365,
                    1.06234,
                    0.96927,
                    0.92586,
                    1.15373,
                    1.18414,
                    0.91349,
                    0.91349,
                    1.07403,
                    1.17308,
                    0.78383,
                    1.20088,
                    0.78383,
                    1.42531,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.78383,
                    0.78383,
                    1.17308,
                    1.17308,
                    1.17308,
                    0.77349,
                    0.94565,
                    0.94729,
                    0.85944,
                    0.88506,
                    0.9858,
                    0.74817,
                    0.80016,
                    0.88449,
                    0.98039,
                    0.95782,
                    0.69238,
                    0.89898,
                    0.83231,
                    0.98183,
                    1.03989,
                    0.96924,
                    0.86237,
                    0.96924,
                    0.80595,
                    0.74524,
                    0.86091,
                    0.95402,
                    0.94143,
                    0.98448,
                    0.8858,
                    0.83089,
                    0.93285,
                    1.0949,
                    1.39016,
                    1.0949,
                    1.45994,
                    0.74627,
                    1.04839,
                    0.97454,
                    0.97454,
                    0.87207,
                    0.97454,
                    0.87533,
                    1.06151,
                    0.97454,
                    1.00176,
                    1.16484,
                    1.08132,
                    0.98047,
                    1.16484,
                    1.02989,
                    1.01054,
                    0.96225,
                    0.97454,
                    0.97454,
                    1.06598,
                    0.79004,
                    1.16344,
                    1.00351,
                    0.94629,
                    0.9973,
                    0.91016,
                    0.96777,
                    0.9043,
                    0.91082,
                    0.92481,
                    0.91082,
                    1.17308,
                    0.95748,
                    0.96927,
                    0.96927,
                    1,
                    0.96927,
                    0.92481,
                    0.80597,
                    1.04839,
                    1.23393,
                    1.1781,
                    0.9245,
                    1.17308,
                    1.20808,
                    0.63218,
                    0.94261,
                    1.24822,
                    1.09971,
                    1.09971,
                    1.04839,
                    1,
                    0.85273,
                    0.78032,
                    1.04839,
                    1.09971,
                    1.22326,
                    0.9245,
                    1.09836,
                    1.13525,
                    1.15222,
                    0.70424,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.85498,
                    0.88506,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.9858,
                    1.03989,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    1.17308,
                    0.96924,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.83089,
                    0.86237,
                    0.88409,
                    0.97454,
                    0.97454,
                    0.97454,
                    0.97454,
                    0.97454,
                    0.97454,
                    0.92916,
                    0.87207,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.93146,
                    0.93146,
                    0.93146,
                    0.93146,
                    0.93854,
                    1.01054,
                    0.96225,
                    0.96225,
                    0.96225,
                    0.96225,
                    0.96225,
                    1.24822,
                    0.8761,
                    1.00351,
                    1.00351,
                    1.00351,
                    1.00351,
                    0.96777,
                    0.97454,
                    0.96777,
                    0.94729,
                    0.97454,
                    0.94729,
                    0.97454,
                    0.94729,
                    0.97454,
                    0.88506,
                    0.87207,
                    0.88506,
                    0.87207,
                    0.88506,
                    0.87207,
                    0.88506,
                    0.87207,
                    0.9858,
                    0.95391,
                    0.9858,
                    0.97454,
                    0.74817,
                    0.87533,
                    0.74817,
                    0.87533,
                    0.74817,
                    0.87533,
                    0.74817,
                    0.87533,
                    0.74817,
                    0.87533,
                    0.88449,
                    0.97454,
                    0.88449,
                    0.97454,
                    0.88449,
                    0.97454,
                    1,
                    1,
                    0.98039,
                    1.00176,
                    0.98039,
                    1.00176,
                    0.95782,
                    0.93146,
                    0.95782,
                    0.93146,
                    0.95782,
                    0.93146,
                    0.95782,
                    1.16484,
                    0.95782,
                    0.93146,
                    0.84421,
                    1.12761,
                    0.69238,
                    1.08132,
                    1,
                    1,
                    0.98047,
                    0.83231,
                    1.16484,
                    1,
                    1,
                    0.84723,
                    1.04861,
                    0.84723,
                    0.78755,
                    0.83231,
                    1.23736,
                    1.03989,
                    1.01054,
                    1,
                    1,
                    1.03989,
                    1.01054,
                    0.9857,
                    1.03849,
                    1.01054,
                    0.96924,
                    0.96225,
                    0.96924,
                    0.96225,
                    0.96924,
                    0.96225,
                    0.92383,
                    0.90171,
                    0.80595,
                    1.06598,
                    1,
                    1,
                    0.80595,
                    1.06598,
                    0.74524,
                    0.79004,
                    0.74524,
                    0.79004,
                    0.74524,
                    0.79004,
                    0.74524,
                    0.79004,
                    1,
                    1,
                    0.86091,
                    1.02759,
                    0.85771,
                    1.16344,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.95402,
                    1.00351,
                    0.98448,
                    0.9973,
                    0.83089,
                    0.96777,
                    0.83089,
                    0.93285,
                    0.9043,
                    0.93285,
                    0.9043,
                    0.93285,
                    0.9043,
                    1.31868,
                    0.96927,
                    0.94729,
                    0.97454,
                    0.85498,
                    0.92916,
                    0.96924,
                    0.8761,
                    1,
                    1,
                    0.86091,
                    1.16344,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    1.04839,
                    0.81965,
                    0.81965,
                    0.94729,
                    0.78032,
                    0.71022,
                    0.90883,
                    0.84171,
                    0.99877,
                    0.77596,
                    1.05734,
                    1.2,
                    0.94729,
                    0.85944,
                    0.82791,
                    0.9607,
                    0.74817,
                    0.93285,
                    0.98039,
                    0.96924,
                    0.95782,
                    0.89898,
                    0.98316,
                    0.98183,
                    1.03989,
                    0.78614,
                    0.96924,
                    0.97642,
                    0.86237,
                    0.86075,
                    0.86091,
                    0.83089,
                    0.90082,
                    0.8858,
                    0.97296,
                    1.01284,
                    0.95782,
                    0.83089,
                    1.0976,
                    1.04,
                    1.03342,
                    1.2,
                    1.0675,
                    1.0976,
                    0.98205,
                    1.03809,
                    1.05097,
                    1.04,
                    0.95364,
                    1.03342,
                    1.05401,
                    1.2,
                    1.02148,
                    1.0119,
                    1.04724,
                    1.0127,
                    1.02732,
                    0.96225,
                    0.8965,
                    0.97783,
                    0.93574,
                    0.94818,
                    1.30679,
                    1.0675,
                    1.11826,
                    0.99821,
                    1.0557,
                    1.0326,
                    1.2,
                    1.0675,
                    0.96225,
                    1.0675,
                    1.0326,
                    0.74817,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.03754,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.87533,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.98705,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.98448,
                    0.9973,
                    0.98448,
                    0.9973,
                    0.98448,
                    0.9973,
                    0.83089,
                    0.96777,
                    1,
                    1.20088,
                    0.89903,
                    1,
                    1,
                    0.75155,
                    0.94945,
                    0.94945,
                    0.94945,
                    0.94945,
                    1.12317,
                    1.12317,
                    1.12317,
                    0.67603,
                    0.67603,
                    1.15621,
                    0.73584,
                    1.21191,
                    1.22135,
                    1.06483,
                    0.94868,
                    0.94868,
                    0.95996,
                    1.24633,
                    1,
                    1.07497,
                    0.87709,
                    0.96927,
                    1.01473,
                    0.96927,
                    1,
                    1,
                    1,
                    0.77295,
                    1,
                    1,
                    1.09836,
                    1.09836,
                    1.09836,
                    1.01522,
                    0.86321,
                    0.94434,
                    0.8649,
                    0.94434,
                    0.86182,
                    1,
                    1,
                    1.083,
                    1,
                    0.91578,
                    0.86438,
                    1.17308,
                    1.18416,
                    1.14589,
                    0.69825,
                    0.97622,
                    1.96791,
                    1.24822,
                    1.24822,
                    1.17308,
                    1.24822,
                    1.24822,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.17984,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.10742,
                    1.10742,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.SegoeuiItalicFactors = SegoeuiItalicFactors;
                const SegoeuiItalicMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                exports.SegoeuiItalicMetrics = SegoeuiItalicMetrics;
                const SegoeuiRegularFactors = [
                    1.76738,
                    1,
                    1,
                    0.98594,
                    1.02285,
                    1.10454,
                    1.06234,
                    0.96927,
                    0.92037,
                    1.19985,
                    1.2046,
                    0.90616,
                    0.90616,
                    1.07152,
                    1.1714,
                    0.78032,
                    1.20088,
                    0.78032,
                    1.40246,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.96927,
                    0.78032,
                    0.78032,
                    1.1714,
                    1.1714,
                    1.1714,
                    0.80597,
                    0.94084,
                    0.96706,
                    0.85944,
                    0.85734,
                    0.97093,
                    0.75842,
                    0.79936,
                    0.88198,
                    0.9831,
                    0.95782,
                    0.71387,
                    0.86969,
                    0.84636,
                    1.07796,
                    1.03584,
                    0.96924,
                    0.83968,
                    0.96924,
                    0.82826,
                    0.79649,
                    0.85771,
                    0.95132,
                    0.93119,
                    0.98965,
                    0.88433,
                    0.8287,
                    0.93365,
                    1.08612,
                    1.3638,
                    1.08612,
                    1.45786,
                    0.74627,
                    0.80499,
                    0.91484,
                    1.05707,
                    0.92383,
                    1.05882,
                    0.9403,
                    1.12654,
                    1.05882,
                    1.01756,
                    1.09011,
                    1.09011,
                    0.99414,
                    1.09011,
                    1.034,
                    1.01756,
                    1.05356,
                    1.05707,
                    1.05882,
                    1.04399,
                    0.84863,
                    1.21968,
                    1.01756,
                    0.95801,
                    1.00068,
                    0.91797,
                    0.96777,
                    0.9043,
                    0.90351,
                    0.92105,
                    0.90351,
                    1.1714,
                    0.85337,
                    0.96927,
                    0.96927,
                    0.99912,
                    0.96927,
                    0.92105,
                    0.80597,
                    1.2434,
                    1.20808,
                    1.05937,
                    0.90957,
                    1.1714,
                    1.20808,
                    0.75155,
                    0.94261,
                    1.24644,
                    1.09971,
                    1.09971,
                    0.84751,
                    1,
                    0.85273,
                    0.78032,
                    0.61584,
                    1.05425,
                    1.17914,
                    0.90957,
                    1.08665,
                    1.11593,
                    1.14169,
                    0.73381,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.86035,
                    0.85734,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.97093,
                    1.03584,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    1.1714,
                    0.96924,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.8287,
                    0.83968,
                    0.89049,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.93575,
                    0.92383,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.8717,
                    0.8717,
                    0.8717,
                    0.8717,
                    1.00527,
                    1.01756,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.24644,
                    0.95923,
                    1.01756,
                    1.01756,
                    1.01756,
                    1.01756,
                    0.96777,
                    1.05707,
                    0.96777,
                    0.96706,
                    0.91484,
                    0.96706,
                    0.91484,
                    0.96706,
                    0.91484,
                    0.85734,
                    0.92383,
                    0.85734,
                    0.92383,
                    0.85734,
                    0.92383,
                    0.85734,
                    0.92383,
                    0.97093,
                    1.0969,
                    0.97093,
                    1.05882,
                    0.75842,
                    0.9403,
                    0.75842,
                    0.9403,
                    0.75842,
                    0.9403,
                    0.75842,
                    0.9403,
                    0.75842,
                    0.9403,
                    0.88198,
                    1.05882,
                    0.88198,
                    1.05882,
                    0.88198,
                    1.05882,
                    1,
                    1,
                    0.9831,
                    1.01756,
                    0.9831,
                    1.01756,
                    0.95782,
                    0.8717,
                    0.95782,
                    0.8717,
                    0.95782,
                    0.8717,
                    0.95782,
                    1.09011,
                    0.95782,
                    0.8717,
                    0.84784,
                    1.11551,
                    0.71387,
                    1.09011,
                    1,
                    1,
                    0.99414,
                    0.84636,
                    1.09011,
                    1,
                    1,
                    0.84636,
                    1.0536,
                    0.84636,
                    0.94298,
                    0.84636,
                    1.23297,
                    1.03584,
                    1.01756,
                    1,
                    1,
                    1.03584,
                    1.01756,
                    1.00323,
                    1.03444,
                    1.01756,
                    0.96924,
                    1.05356,
                    0.96924,
                    1.05356,
                    0.96924,
                    1.05356,
                    0.93066,
                    0.98293,
                    0.82826,
                    1.04399,
                    1,
                    1,
                    0.82826,
                    1.04399,
                    0.79649,
                    0.84863,
                    0.79649,
                    0.84863,
                    0.79649,
                    0.84863,
                    0.79649,
                    0.84863,
                    1,
                    1,
                    0.85771,
                    1.17318,
                    0.85771,
                    1.21968,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.95132,
                    1.01756,
                    0.98965,
                    1.00068,
                    0.8287,
                    0.96777,
                    0.8287,
                    0.93365,
                    0.9043,
                    0.93365,
                    0.9043,
                    0.93365,
                    0.9043,
                    1.08571,
                    0.96927,
                    0.96706,
                    0.91484,
                    0.86035,
                    0.93575,
                    0.96924,
                    0.95923,
                    1,
                    1,
                    0.85771,
                    1.21968,
                    1.11437,
                    1.11437,
                    0.93109,
                    0.91202,
                    0.60411,
                    0.84164,
                    0.55572,
                    1.01173,
                    0.97361,
                    0.81818,
                    0.81818,
                    0.96635,
                    0.78032,
                    0.72727,
                    0.92366,
                    0.98601,
                    1.03405,
                    0.77968,
                    1.09799,
                    1.2,
                    0.96706,
                    0.85944,
                    0.85638,
                    0.96491,
                    0.75842,
                    0.93365,
                    0.9831,
                    0.96924,
                    0.95782,
                    0.86969,
                    0.94152,
                    1.07796,
                    1.03584,
                    0.78437,
                    0.96924,
                    0.98715,
                    0.83968,
                    0.83491,
                    0.85771,
                    0.8287,
                    0.94492,
                    0.88433,
                    0.9287,
                    1.0098,
                    0.95782,
                    0.8287,
                    1.0625,
                    0.98248,
                    1.03424,
                    1.2,
                    1.01071,
                    1.0625,
                    0.95246,
                    1.03809,
                    1.04912,
                    0.98248,
                    1.00221,
                    1.03424,
                    1.05443,
                    1.2,
                    1.04785,
                    0.99609,
                    1.00169,
                    1.05176,
                    0.99346,
                    1.05356,
                    0.9087,
                    1.03004,
                    0.95542,
                    0.93117,
                    1.23362,
                    1.01071,
                    1.07831,
                    1.02512,
                    1.05205,
                    1.03502,
                    1.2,
                    1.01071,
                    1.05356,
                    1.01071,
                    1.03502,
                    0.75842,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.03719,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.9403,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.04021,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.98965,
                    1.00068,
                    0.98965,
                    1.00068,
                    0.98965,
                    1.00068,
                    0.8287,
                    0.96777,
                    1,
                    1.20088,
                    0.89903,
                    1,
                    1,
                    0.75155,
                    1.03077,
                    1.03077,
                    1.03077,
                    1.03077,
                    1.13196,
                    1.13196,
                    1.13196,
                    0.67428,
                    0.67428,
                    1.16039,
                    0.73291,
                    1.20996,
                    1.22135,
                    1.06483,
                    0.94868,
                    0.94868,
                    0.95996,
                    1.24633,
                    1,
                    1.07497,
                    0.87796,
                    0.96927,
                    1.01518,
                    0.96927,
                    1,
                    1,
                    1,
                    0.77295,
                    1,
                    1,
                    1.10539,
                    1.10539,
                    1.11358,
                    1.06967,
                    0.86279,
                    0.94434,
                    0.86279,
                    0.94434,
                    0.86182,
                    1,
                    1,
                    1.083,
                    1,
                    0.91578,
                    0.86507,
                    1.1714,
                    1.18416,
                    1.14589,
                    0.69825,
                    0.97622,
                    1.9697,
                    1.24822,
                    1.24822,
                    1.17238,
                    1.24822,
                    1.24822,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.42603,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.18083,
                    1.42603,
                    1,
                    1.42603,
                    1.42603,
                    0.99862,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.2886,
                    1.04315,
                    1.15296,
                    1.34163,
                    1,
                    1,
                    1,
                    1.10938,
                    1.10938,
                    1,
                    1,
                    1,
                    1.05425,
                    1.09971,
                    1.09971,
                    1.09971,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ];
                exports.SegoeuiRegularFactors = SegoeuiRegularFactors;
                const SegoeuiRegularMetrics = {
                    lineHeight: 1.33008,
                    lineGap: 0
                };
                exports.SegoeuiRegularMetrics = SegoeuiRegularMetrics;
            /***/ },
            /* 57 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PostScriptEvaluator = exports.PostScriptCompiler = exports.PDFFunctionFactory = void 0;
                exports.isPDFFunction = isPDFFunction;
                var _primitives = __w_pdfjs_require__(4);
                var _util = __w_pdfjs_require__(2);
                var _ps_parser = __w_pdfjs_require__(58);
                var _base_stream = __w_pdfjs_require__(5);
                var _image_utils = __w_pdfjs_require__(59);
                class PDFFunctionFactory {
                    constructor({ xref: xref, isEvalSupported: isEvalSupported = true }){
                        this.xref = xref;
                        this.isEvalSupported = isEvalSupported !== false;
                    }
                    create(fn) {
                        const cachedFunction = this.getCached(fn);
                        if (cachedFunction) return cachedFunction;
                        const parsedFunction = PDFFunction.parse({
                            xref: this.xref,
                            isEvalSupported: this.isEvalSupported,
                            fn: fn instanceof _primitives.Ref ? this.xref.fetch(fn) : fn
                        });
                        this._cache(fn, parsedFunction);
                        return parsedFunction;
                    }
                    createFromArray(fnObj) {
                        const cachedFunction = this.getCached(fnObj);
                        if (cachedFunction) return cachedFunction;
                        const parsedFunction = PDFFunction.parseArray({
                            xref: this.xref,
                            isEvalSupported: this.isEvalSupported,
                            fnObj: fnObj instanceof _primitives.Ref ? this.xref.fetch(fnObj) : fnObj
                        });
                        this._cache(fnObj, parsedFunction);
                        return parsedFunction;
                    }
                    getCached(cacheKey) {
                        let fnRef;
                        if (cacheKey instanceof _primitives.Ref) fnRef = cacheKey;
                        else if (cacheKey instanceof _primitives.Dict) fnRef = cacheKey.objId;
                        else if (cacheKey instanceof _base_stream.BaseStream) fnRef = cacheKey.dict?.objId;
                        if (fnRef) {
                            const localFunction = this._localFunctionCache.getByRef(fnRef);
                            if (localFunction) return localFunction;
                        }
                        return null;
                    }
                    _cache(cacheKey, parsedFunction) {
                        if (!parsedFunction) throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
                        let fnRef;
                        if (cacheKey instanceof _primitives.Ref) fnRef = cacheKey;
                        else if (cacheKey instanceof _primitives.Dict) fnRef = cacheKey.objId;
                        else if (cacheKey instanceof _base_stream.BaseStream) fnRef = cacheKey.dict?.objId;
                        if (fnRef) this._localFunctionCache.set(null, fnRef, parsedFunction);
                    }
                    get _localFunctionCache() {
                        return (0, _util.shadow)(this, "_localFunctionCache", new _image_utils.LocalFunctionCache());
                    }
                }
                exports.PDFFunctionFactory = PDFFunctionFactory;
                function toNumberArray(arr) {
                    if (!Array.isArray(arr)) return null;
                    const length = arr.length;
                    for(let i = 0; i < length; i++)if (typeof arr[i] !== "number") {
                        const result = new Array(length);
                        for(let j = 0; j < length; j++)result[j] = +arr[j];
                        return result;
                    }
                    return arr;
                }
                class PDFFunction {
                    static getSampleArray(size, outputSize, bps, stream) {
                        let i, ii;
                        let length = 1;
                        for(i = 0, ii = size.length; i < ii; i++)length *= size[i];
                        length *= outputSize;
                        const array = new Array(length);
                        let codeSize = 0;
                        let codeBuf = 0;
                        const sampleMul = 1.0 / (2.0 ** bps - 1);
                        const strBytes = stream.getBytes((length * bps + 7) / 8);
                        let strIdx = 0;
                        for(i = 0; i < length; i++){
                            while(codeSize < bps){
                                codeBuf <<= 8;
                                codeBuf |= strBytes[strIdx++];
                                codeSize += 8;
                            }
                            codeSize -= bps;
                            array[i] = (codeBuf >> codeSize) * sampleMul;
                            codeBuf &= (1 << codeSize) - 1;
                        }
                        return array;
                    }
                    static parse({ xref: xref, isEvalSupported: isEvalSupported, fn: fn }) {
                        const dict = fn.dict || fn;
                        const typeNum = dict.get("FunctionType");
                        switch(typeNum){
                            case 0:
                                return this.constructSampled({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    fn: fn,
                                    dict: dict
                                });
                            case 1:
                                break;
                            case 2:
                                return this.constructInterpolated({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    dict: dict
                                });
                            case 3:
                                return this.constructStiched({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    dict: dict
                                });
                            case 4:
                                return this.constructPostScript({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    fn: fn,
                                    dict: dict
                                });
                        }
                        throw new _util.FormatError("Unknown type of function");
                    }
                    static parseArray({ xref: xref, isEvalSupported: isEvalSupported, fnObj: fnObj }) {
                        if (!Array.isArray(fnObj)) return this.parse({
                            xref: xref,
                            isEvalSupported: isEvalSupported,
                            fn: fnObj
                        });
                        const fnArray = [];
                        for (const fn of fnObj)fnArray.push(this.parse({
                            xref: xref,
                            isEvalSupported: isEvalSupported,
                            fn: xref.fetchIfRef(fn)
                        }));
                        return function(src, srcOffset, dest, destOffset) {
                            for(let i = 0, ii = fnArray.length; i < ii; i++)fnArray[i](src, srcOffset, dest, destOffset + i);
                        };
                    }
                    static constructSampled({ xref: xref, isEvalSupported: isEvalSupported, fn: fn, dict: dict }) {
                        function toMultiArray(arr) {
                            const inputLength = arr.length;
                            const out = [];
                            let index = 0;
                            for(let i = 0; i < inputLength; i += 2)out[index++] = [
                                arr[i],
                                arr[i + 1]
                            ];
                            return out;
                        }
                        function interpolate(x, xmin, xmax, ymin, ymax) {
                            return ymin + (x - xmin) * ((ymax - ymin) / (xmax - xmin));
                        }
                        let domain = toNumberArray(dict.getArray("Domain"));
                        let range = toNumberArray(dict.getArray("Range"));
                        if (!domain || !range) throw new _util.FormatError("No domain or range");
                        const inputSize = domain.length / 2;
                        const outputSize = range.length / 2;
                        domain = toMultiArray(domain);
                        range = toMultiArray(range);
                        const size = toNumberArray(dict.getArray("Size"));
                        const bps = dict.get("BitsPerSample");
                        const order = dict.get("Order") || 1;
                        if (order !== 1) (0, _util.info)("No support for cubic spline interpolation: " + order);
                        let encode = toNumberArray(dict.getArray("Encode"));
                        if (!encode) {
                            encode = [];
                            for(let i = 0; i < inputSize; ++i)encode.push([
                                0,
                                size[i] - 1
                            ]);
                        } else encode = toMultiArray(encode);
                        let decode = toNumberArray(dict.getArray("Decode"));
                        decode = !decode ? range : toMultiArray(decode);
                        const samples = this.getSampleArray(size, outputSize, bps, fn);
                        return function constructSampledFn(src, srcOffset, dest, destOffset) {
                            const cubeVertices = 1 << inputSize;
                            const cubeN = new Float64Array(cubeVertices);
                            const cubeVertex = new Uint32Array(cubeVertices);
                            let i, j;
                            for(j = 0; j < cubeVertices; j++)cubeN[j] = 1;
                            let k = outputSize, pos = 1;
                            for(i = 0; i < inputSize; ++i){
                                const domain_2i = domain[i][0];
                                const domain_2i_1 = domain[i][1];
                                const xi = Math.min(Math.max(src[srcOffset + i], domain_2i), domain_2i_1);
                                let e = interpolate(xi, domain_2i, domain_2i_1, encode[i][0], encode[i][1]);
                                const size_i = size[i];
                                e = Math.min(Math.max(e, 0), size_i - 1);
                                const e0 = e < size_i - 1 ? Math.floor(e) : e - 1;
                                const n0 = e0 + 1 - e;
                                const n1 = e - e0;
                                const offset0 = e0 * k;
                                const offset1 = offset0 + k;
                                for(j = 0; j < cubeVertices; j++)if (j & pos) {
                                    cubeN[j] *= n1;
                                    cubeVertex[j] += offset1;
                                } else {
                                    cubeN[j] *= n0;
                                    cubeVertex[j] += offset0;
                                }
                                k *= size_i;
                                pos <<= 1;
                            }
                            for(j = 0; j < outputSize; ++j){
                                let rj = 0;
                                for(i = 0; i < cubeVertices; i++)rj += samples[cubeVertex[i] + j] * cubeN[i];
                                rj = interpolate(rj, 0, 1, decode[j][0], decode[j][1]);
                                dest[destOffset + j] = Math.min(Math.max(rj, range[j][0]), range[j][1]);
                            }
                        };
                    }
                    static constructInterpolated({ xref: xref, isEvalSupported: isEvalSupported, dict: dict }) {
                        const c0 = toNumberArray(dict.getArray("C0")) || [
                            0
                        ];
                        const c1 = toNumberArray(dict.getArray("C1")) || [
                            1
                        ];
                        const n = dict.get("N");
                        const diff = [];
                        for(let i = 0, ii = c0.length; i < ii; ++i)diff.push(c1[i] - c0[i]);
                        const length = diff.length;
                        return function constructInterpolatedFn(src, srcOffset, dest, destOffset) {
                            const x = n === 1 ? src[srcOffset] : src[srcOffset] ** n;
                            for(let j = 0; j < length; ++j)dest[destOffset + j] = c0[j] + x * diff[j];
                        };
                    }
                    static constructStiched({ xref: xref, isEvalSupported: isEvalSupported, dict: dict }) {
                        const domain = toNumberArray(dict.getArray("Domain"));
                        if (!domain) throw new _util.FormatError("No domain");
                        const inputSize = domain.length / 2;
                        if (inputSize !== 1) throw new _util.FormatError("Bad domain for stiched function");
                        const fns = [];
                        for (const fn of dict.get("Functions"))fns.push(this.parse({
                            xref: xref,
                            isEvalSupported: isEvalSupported,
                            fn: xref.fetchIfRef(fn)
                        }));
                        const bounds = toNumberArray(dict.getArray("Bounds"));
                        const encode = toNumberArray(dict.getArray("Encode"));
                        const tmpBuf = new Float32Array(1);
                        return function constructStichedFn(src, srcOffset, dest, destOffset) {
                            const clip = function constructStichedFromIRClip(v, min, max) {
                                if (v > max) v = max;
                                else if (v < min) v = min;
                                return v;
                            };
                            const v = clip(src[srcOffset], domain[0], domain[1]);
                            const length = bounds.length;
                            let i;
                            for(i = 0; i < length; ++i){
                                if (v < bounds[i]) break;
                            }
                            let dmin = domain[0];
                            if (i > 0) dmin = bounds[i - 1];
                            let dmax = domain[1];
                            if (i < bounds.length) dmax = bounds[i];
                            const rmin = encode[2 * i];
                            const rmax = encode[2 * i + 1];
                            tmpBuf[0] = dmin === dmax ? rmin : rmin + (v - dmin) * (rmax - rmin) / (dmax - dmin);
                            fns[i](tmpBuf, 0, dest, destOffset);
                        };
                    }
                    static constructPostScript({ xref: xref, isEvalSupported: isEvalSupported, fn: fn, dict: dict }) {
                        const domain = toNumberArray(dict.getArray("Domain"));
                        const range = toNumberArray(dict.getArray("Range"));
                        if (!domain) throw new _util.FormatError("No domain.");
                        if (!range) throw new _util.FormatError("No range.");
                        const lexer = new _ps_parser.PostScriptLexer(fn);
                        const parser = new _ps_parser.PostScriptParser(lexer);
                        const code = parser.parse();
                        if (isEvalSupported && _util.FeatureTest.isEvalSupported) {
                            const compiled = new PostScriptCompiler().compile(code, domain, range);
                            if (compiled) return new Function("src", "srcOffset", "dest", "destOffset", compiled);
                        }
                        (0, _util.info)("Unable to compile PS function");
                        const numOutputs = range.length >> 1;
                        const numInputs = domain.length >> 1;
                        const evaluator = new PostScriptEvaluator(code);
                        const cache = Object.create(null);
                        const MAX_CACHE_SIZE = 8192;
                        let cache_available = MAX_CACHE_SIZE;
                        const tmpBuf = new Float32Array(numInputs);
                        return function constructPostScriptFn(src, srcOffset, dest, destOffset) {
                            let i, value;
                            let key = "";
                            const input = tmpBuf;
                            for(i = 0; i < numInputs; i++){
                                value = src[srcOffset + i];
                                input[i] = value;
                                key += value + "_";
                            }
                            const cachedValue = cache[key];
                            if (cachedValue !== undefined) {
                                dest.set(cachedValue, destOffset);
                                return;
                            }
                            const output = new Float32Array(numOutputs);
                            const stack = evaluator.execute(input);
                            const stackIndex = stack.length - numOutputs;
                            for(i = 0; i < numOutputs; i++){
                                value = stack[stackIndex + i];
                                let bound = range[i * 2];
                                if (value < bound) value = bound;
                                else {
                                    bound = range[i * 2 + 1];
                                    if (value > bound) value = bound;
                                }
                                output[i] = value;
                            }
                            if (cache_available > 0) {
                                cache_available--;
                                cache[key] = output;
                            }
                            dest.set(output, destOffset);
                        };
                    }
                }
                function isPDFFunction(v) {
                    let fnDict;
                    if (v instanceof _primitives.Dict) fnDict = v;
                    else if (v instanceof _base_stream.BaseStream) fnDict = v.dict;
                    else return false;
                    return fnDict.has("FunctionType");
                }
                class PostScriptStack {
                    static MAX_STACK_SIZE = 100;
                    constructor(initialStack){
                        this.stack = initialStack ? Array.from(initialStack) : [];
                    }
                    push(value) {
                        if (this.stack.length >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
                        this.stack.push(value);
                    }
                    pop() {
                        if (this.stack.length <= 0) throw new Error("PostScript function stack underflow.");
                        return this.stack.pop();
                    }
                    copy(n) {
                        if (this.stack.length + n >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
                        const stack = this.stack;
                        for(let i = stack.length - n, j = n - 1; j >= 0; j--, i++)stack.push(stack[i]);
                    }
                    index(n) {
                        this.push(this.stack[this.stack.length - n - 1]);
                    }
                    roll(n, p) {
                        const stack = this.stack;
                        const l = stack.length - n;
                        const r = stack.length - 1;
                        const c = l + (p - Math.floor(p / n) * n);
                        for(let i = l, j = r; i < j; i++, j--){
                            const t = stack[i];
                            stack[i] = stack[j];
                            stack[j] = t;
                        }
                        for(let i = l, j = c - 1; i < j; i++, j--){
                            const t = stack[i];
                            stack[i] = stack[j];
                            stack[j] = t;
                        }
                        for(let i = c, j = r; i < j; i++, j--){
                            const t = stack[i];
                            stack[i] = stack[j];
                            stack[j] = t;
                        }
                    }
                }
                class PostScriptEvaluator {
                    constructor(operators){
                        this.operators = operators;
                    }
                    execute(initialStack) {
                        const stack = new PostScriptStack(initialStack);
                        let counter = 0;
                        const operators = this.operators;
                        const length = operators.length;
                        let operator, a, b;
                        while(counter < length){
                            operator = operators[counter++];
                            if (typeof operator === "number") {
                                stack.push(operator);
                                continue;
                            }
                            switch(operator){
                                case "jz":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (!a) counter = b;
                                    break;
                                case "j":
                                    a = stack.pop();
                                    counter = a;
                                    break;
                                case "abs":
                                    a = stack.pop();
                                    stack.push(Math.abs(a));
                                    break;
                                case "add":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a + b);
                                    break;
                                case "and":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (typeof a === "boolean" && typeof b === "boolean") stack.push(a && b);
                                    else stack.push(a & b);
                                    break;
                                case "atan":
                                    b = stack.pop();
                                    a = stack.pop();
                                    a = Math.atan2(a, b) / Math.PI * 180;
                                    if (a < 0) a += 360;
                                    stack.push(a);
                                    break;
                                case "bitshift":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (a > 0) stack.push(a << b);
                                    else stack.push(a >> b);
                                    break;
                                case "ceiling":
                                    a = stack.pop();
                                    stack.push(Math.ceil(a));
                                    break;
                                case "copy":
                                    a = stack.pop();
                                    stack.copy(a);
                                    break;
                                case "cos":
                                    a = stack.pop();
                                    stack.push(Math.cos(a % 360 / 180 * Math.PI));
                                    break;
                                case "cvi":
                                    a = stack.pop() | 0;
                                    stack.push(a);
                                    break;
                                case "cvr":
                                    break;
                                case "div":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a / b);
                                    break;
                                case "dup":
                                    stack.copy(1);
                                    break;
                                case "eq":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a === b);
                                    break;
                                case "exch":
                                    stack.roll(2, 1);
                                    break;
                                case "exp":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a ** b);
                                    break;
                                case "false":
                                    stack.push(false);
                                    break;
                                case "floor":
                                    a = stack.pop();
                                    stack.push(Math.floor(a));
                                    break;
                                case "ge":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a >= b);
                                    break;
                                case "gt":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a > b);
                                    break;
                                case "idiv":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a / b | 0);
                                    break;
                                case "index":
                                    a = stack.pop();
                                    stack.index(a);
                                    break;
                                case "le":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a <= b);
                                    break;
                                case "ln":
                                    a = stack.pop();
                                    stack.push(Math.log(a));
                                    break;
                                case "log":
                                    a = stack.pop();
                                    stack.push(Math.log10(a));
                                    break;
                                case "lt":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a < b);
                                    break;
                                case "mod":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a % b);
                                    break;
                                case "mul":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a * b);
                                    break;
                                case "ne":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a !== b);
                                    break;
                                case "neg":
                                    a = stack.pop();
                                    stack.push(-a);
                                    break;
                                case "not":
                                    a = stack.pop();
                                    if (typeof a === "boolean") stack.push(!a);
                                    else stack.push(~a);
                                    break;
                                case "or":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (typeof a === "boolean" && typeof b === "boolean") stack.push(a || b);
                                    else stack.push(a | b);
                                    break;
                                case "pop":
                                    stack.pop();
                                    break;
                                case "roll":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.roll(a, b);
                                    break;
                                case "round":
                                    a = stack.pop();
                                    stack.push(Math.round(a));
                                    break;
                                case "sin":
                                    a = stack.pop();
                                    stack.push(Math.sin(a % 360 / 180 * Math.PI));
                                    break;
                                case "sqrt":
                                    a = stack.pop();
                                    stack.push(Math.sqrt(a));
                                    break;
                                case "sub":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a - b);
                                    break;
                                case "true":
                                    stack.push(true);
                                    break;
                                case "truncate":
                                    a = stack.pop();
                                    a = a < 0 ? Math.ceil(a) : Math.floor(a);
                                    stack.push(a);
                                    break;
                                case "xor":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (typeof a === "boolean" && typeof b === "boolean") stack.push(a !== b);
                                    else stack.push(a ^ b);
                                    break;
                                default:
                                    throw new _util.FormatError(`Unknown operator ${operator}`);
                            }
                        }
                        return stack.stack;
                    }
                }
                exports.PostScriptEvaluator = PostScriptEvaluator;
                class AstNode {
                    constructor(type){
                        this.type = type;
                    }
                    visit(visitor) {
                        (0, _util.unreachable)("abstract method");
                    }
                }
                class AstArgument extends AstNode {
                    constructor(index, min, max){
                        super("args");
                        this.index = index;
                        this.min = min;
                        this.max = max;
                    }
                    visit(visitor) {
                        visitor.visitArgument(this);
                    }
                }
                class AstLiteral extends AstNode {
                    constructor(number){
                        super("literal");
                        this.number = number;
                        this.min = number;
                        this.max = number;
                    }
                    visit(visitor) {
                        visitor.visitLiteral(this);
                    }
                }
                class AstBinaryOperation extends AstNode {
                    constructor(op, arg1, arg2, min, max){
                        super("binary");
                        this.op = op;
                        this.arg1 = arg1;
                        this.arg2 = arg2;
                        this.min = min;
                        this.max = max;
                    }
                    visit(visitor) {
                        visitor.visitBinaryOperation(this);
                    }
                }
                class AstMin extends AstNode {
                    constructor(arg, max){
                        super("max");
                        this.arg = arg;
                        this.min = arg.min;
                        this.max = max;
                    }
                    visit(visitor) {
                        visitor.visitMin(this);
                    }
                }
                class AstVariable extends AstNode {
                    constructor(index, min, max){
                        super("var");
                        this.index = index;
                        this.min = min;
                        this.max = max;
                    }
                    visit(visitor) {
                        visitor.visitVariable(this);
                    }
                }
                class AstVariableDefinition extends AstNode {
                    constructor(variable, arg){
                        super("definition");
                        this.variable = variable;
                        this.arg = arg;
                    }
                    visit(visitor) {
                        visitor.visitVariableDefinition(this);
                    }
                }
                class ExpressionBuilderVisitor {
                    constructor(){
                        this.parts = [];
                    }
                    visitArgument(arg) {
                        this.parts.push("Math.max(", arg.min, ", Math.min(", arg.max, ", src[srcOffset + ", arg.index, "]))");
                    }
                    visitVariable(variable) {
                        this.parts.push("v", variable.index);
                    }
                    visitLiteral(literal) {
                        this.parts.push(literal.number);
                    }
                    visitBinaryOperation(operation) {
                        this.parts.push("(");
                        operation.arg1.visit(this);
                        this.parts.push(" ", operation.op, " ");
                        operation.arg2.visit(this);
                        this.parts.push(")");
                    }
                    visitVariableDefinition(definition) {
                        this.parts.push("var ");
                        definition.variable.visit(this);
                        this.parts.push(" = ");
                        definition.arg.visit(this);
                        this.parts.push(";");
                    }
                    visitMin(max) {
                        this.parts.push("Math.min(");
                        max.arg.visit(this);
                        this.parts.push(", ", max.max, ")");
                    }
                    toString() {
                        return this.parts.join("");
                    }
                }
                function buildAddOperation(num1, num2) {
                    if (num2.type === "literal" && num2.number === 0) return num1;
                    if (num1.type === "literal" && num1.number === 0) return num2;
                    if (num2.type === "literal" && num1.type === "literal") return new AstLiteral(num1.number + num2.number);
                    return new AstBinaryOperation("+", num1, num2, num1.min + num2.min, num1.max + num2.max);
                }
                function buildMulOperation(num1, num2) {
                    if (num2.type === "literal") {
                        if (num2.number === 0) return new AstLiteral(0);
                        else if (num2.number === 1) return num1;
                        else if (num1.type === "literal") return new AstLiteral(num1.number * num2.number);
                    }
                    if (num1.type === "literal") {
                        if (num1.number === 0) return new AstLiteral(0);
                        else if (num1.number === 1) return num2;
                    }
                    const min = Math.min(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
                    const max = Math.max(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
                    return new AstBinaryOperation("*", num1, num2, min, max);
                }
                function buildSubOperation(num1, num2) {
                    if (num2.type === "literal") {
                        if (num2.number === 0) return num1;
                        else if (num1.type === "literal") return new AstLiteral(num1.number - num2.number);
                    }
                    if (num2.type === "binary" && num2.op === "-" && num1.type === "literal" && num1.number === 1 && num2.arg1.type === "literal" && num2.arg1.number === 1) return num2.arg2;
                    return new AstBinaryOperation("-", num1, num2, num1.min - num2.max, num1.max - num2.min);
                }
                function buildMinOperation(num1, max) {
                    if (num1.min >= max) return new AstLiteral(max);
                    else if (num1.max <= max) return num1;
                    return new AstMin(num1, max);
                }
                class PostScriptCompiler {
                    compile(code, domain, range) {
                        const stack = [];
                        const instructions = [];
                        const inputSize = domain.length >> 1, outputSize = range.length >> 1;
                        let lastRegister = 0;
                        let n, j;
                        let num1, num2, ast1, ast2, tmpVar, item;
                        for(let i = 0; i < inputSize; i++)stack.push(new AstArgument(i, domain[i * 2], domain[i * 2 + 1]));
                        for(let i = 0, ii = code.length; i < ii; i++){
                            item = code[i];
                            if (typeof item === "number") {
                                stack.push(new AstLiteral(item));
                                continue;
                            }
                            switch(item){
                                case "add":
                                    if (stack.length < 2) return null;
                                    num2 = stack.pop();
                                    num1 = stack.pop();
                                    stack.push(buildAddOperation(num1, num2));
                                    break;
                                case "cvr":
                                    if (stack.length < 1) return null;
                                    break;
                                case "mul":
                                    if (stack.length < 2) return null;
                                    num2 = stack.pop();
                                    num1 = stack.pop();
                                    stack.push(buildMulOperation(num1, num2));
                                    break;
                                case "sub":
                                    if (stack.length < 2) return null;
                                    num2 = stack.pop();
                                    num1 = stack.pop();
                                    stack.push(buildSubOperation(num1, num2));
                                    break;
                                case "exch":
                                    if (stack.length < 2) return null;
                                    ast1 = stack.pop();
                                    ast2 = stack.pop();
                                    stack.push(ast1, ast2);
                                    break;
                                case "pop":
                                    if (stack.length < 1) return null;
                                    stack.pop();
                                    break;
                                case "index":
                                    if (stack.length < 1) return null;
                                    num1 = stack.pop();
                                    if (num1.type !== "literal") return null;
                                    n = num1.number;
                                    if (n < 0 || !Number.isInteger(n) || stack.length < n) return null;
                                    ast1 = stack[stack.length - n - 1];
                                    if (ast1.type === "literal" || ast1.type === "var") {
                                        stack.push(ast1);
                                        break;
                                    }
                                    tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                                    stack[stack.length - n - 1] = tmpVar;
                                    stack.push(tmpVar);
                                    instructions.push(new AstVariableDefinition(tmpVar, ast1));
                                    break;
                                case "dup":
                                    if (stack.length < 1) return null;
                                    if (typeof code[i + 1] === "number" && code[i + 2] === "gt" && code[i + 3] === i + 7 && code[i + 4] === "jz" && code[i + 5] === "pop" && code[i + 6] === code[i + 1]) {
                                        num1 = stack.pop();
                                        stack.push(buildMinOperation(num1, code[i + 1]));
                                        i += 6;
                                        break;
                                    }
                                    ast1 = stack.at(-1);
                                    if (ast1.type === "literal" || ast1.type === "var") {
                                        stack.push(ast1);
                                        break;
                                    }
                                    tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                                    stack[stack.length - 1] = tmpVar;
                                    stack.push(tmpVar);
                                    instructions.push(new AstVariableDefinition(tmpVar, ast1));
                                    break;
                                case "roll":
                                    if (stack.length < 2) return null;
                                    num2 = stack.pop();
                                    num1 = stack.pop();
                                    if (num2.type !== "literal" || num1.type !== "literal") return null;
                                    j = num2.number;
                                    n = num1.number;
                                    if (n <= 0 || !Number.isInteger(n) || !Number.isInteger(j) || stack.length < n) return null;
                                    j = (j % n + n) % n;
                                    if (j === 0) break;
                                    stack.push(...stack.splice(stack.length - n, n - j));
                                    break;
                                default:
                                    return null;
                            }
                        }
                        if (stack.length !== outputSize) return null;
                        const result = [];
                        for (const instruction of instructions){
                            const statementBuilder = new ExpressionBuilderVisitor();
                            instruction.visit(statementBuilder);
                            result.push(statementBuilder.toString());
                        }
                        for(let i = 0, ii = stack.length; i < ii; i++){
                            const expr = stack[i], statementBuilder = new ExpressionBuilderVisitor();
                            expr.visit(statementBuilder);
                            const min = range[i * 2], max = range[i * 2 + 1];
                            const out = [
                                statementBuilder.toString()
                            ];
                            if (min > expr.min) {
                                out.unshift("Math.max(", min, ", ");
                                out.push(")");
                            }
                            if (max < expr.max) {
                                out.unshift("Math.min(", max, ", ");
                                out.push(")");
                            }
                            out.unshift("dest[destOffset + ", i, "] = ");
                            out.push(";");
                            result.push(out.join(""));
                        }
                        return result.join("\n");
                    }
                }
                exports.PostScriptCompiler = PostScriptCompiler;
            /***/ },
            /* 58 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PostScriptParser = exports.PostScriptLexer = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _core_utils = __w_pdfjs_require__(3);
                class PostScriptParser {
                    constructor(lexer){
                        this.lexer = lexer;
                        this.operators = [];
                        this.token = null;
                        this.prev = null;
                    }
                    nextToken() {
                        this.prev = this.token;
                        this.token = this.lexer.getToken();
                    }
                    accept(type) {
                        if (this.token.type === type) {
                            this.nextToken();
                            return true;
                        }
                        return false;
                    }
                    expect(type) {
                        if (this.accept(type)) return true;
                        throw new _util.FormatError(`Unexpected symbol: found ${this.token.type} expected ${type}.`);
                    }
                    parse() {
                        this.nextToken();
                        this.expect(PostScriptTokenTypes.LBRACE);
                        this.parseBlock();
                        this.expect(PostScriptTokenTypes.RBRACE);
                        return this.operators;
                    }
                    parseBlock() {
                        while(true){
                            if (this.accept(PostScriptTokenTypes.NUMBER)) this.operators.push(this.prev.value);
                            else if (this.accept(PostScriptTokenTypes.OPERATOR)) this.operators.push(this.prev.value);
                            else if (this.accept(PostScriptTokenTypes.LBRACE)) this.parseCondition();
                            else return;
                        }
                    }
                    parseCondition() {
                        const conditionLocation = this.operators.length;
                        this.operators.push(null, null);
                        this.parseBlock();
                        this.expect(PostScriptTokenTypes.RBRACE);
                        if (this.accept(PostScriptTokenTypes.IF)) {
                            this.operators[conditionLocation] = this.operators.length;
                            this.operators[conditionLocation + 1] = "jz";
                        } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
                            const jumpLocation = this.operators.length;
                            this.operators.push(null, null);
                            const endOfTrue = this.operators.length;
                            this.parseBlock();
                            this.expect(PostScriptTokenTypes.RBRACE);
                            this.expect(PostScriptTokenTypes.IFELSE);
                            this.operators[jumpLocation] = this.operators.length;
                            this.operators[jumpLocation + 1] = "j";
                            this.operators[conditionLocation] = endOfTrue;
                            this.operators[conditionLocation + 1] = "jz";
                        } else throw new _util.FormatError("PS Function: error parsing conditional.");
                    }
                }
                exports.PostScriptParser = PostScriptParser;
                const PostScriptTokenTypes = {
                    LBRACE: 0,
                    RBRACE: 1,
                    NUMBER: 2,
                    OPERATOR: 3,
                    IF: 4,
                    IFELSE: 5
                };
                class PostScriptToken {
                    static get opCache() {
                        return (0, _util.shadow)(this, "opCache", Object.create(null));
                    }
                    constructor(type, value){
                        this.type = type;
                        this.value = value;
                    }
                    static getOperator(op) {
                        return PostScriptToken.opCache[op] ||= new PostScriptToken(PostScriptTokenTypes.OPERATOR, op);
                    }
                    static get LBRACE() {
                        return (0, _util.shadow)(this, "LBRACE", new PostScriptToken(PostScriptTokenTypes.LBRACE, "{"));
                    }
                    static get RBRACE() {
                        return (0, _util.shadow)(this, "RBRACE", new PostScriptToken(PostScriptTokenTypes.RBRACE, "}"));
                    }
                    static get IF() {
                        return (0, _util.shadow)(this, "IF", new PostScriptToken(PostScriptTokenTypes.IF, "IF"));
                    }
                    static get IFELSE() {
                        return (0, _util.shadow)(this, "IFELSE", new PostScriptToken(PostScriptTokenTypes.IFELSE, "IFELSE"));
                    }
                }
                class PostScriptLexer {
                    constructor(stream){
                        this.stream = stream;
                        this.nextChar();
                        this.strBuf = [];
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    getToken() {
                        let comment = false;
                        let ch = this.currentChar;
                        while(true){
                            if (ch < 0) return _primitives.EOF;
                            if (comment) {
                                if (ch === 0x0a || ch === 0x0d) comment = false;
                            } else if (ch === 0x25) comment = true;
                            else if (!(0, _core_utils.isWhiteSpace)(ch)) break;
                            ch = this.nextChar();
                        }
                        switch(ch | 0){
                            case 0x30:
                            case 0x31:
                            case 0x32:
                            case 0x33:
                            case 0x34:
                            case 0x35:
                            case 0x36:
                            case 0x37:
                            case 0x38:
                            case 0x39:
                            case 0x2b:
                            case 0x2d:
                            case 0x2e:
                                return new PostScriptToken(PostScriptTokenTypes.NUMBER, this.getNumber());
                            case 0x7b:
                                this.nextChar();
                                return PostScriptToken.LBRACE;
                            case 0x7d:
                                this.nextChar();
                                return PostScriptToken.RBRACE;
                        }
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        strBuf[0] = String.fromCharCode(ch);
                        while((ch = this.nextChar()) >= 0 && (ch >= 0x41 && ch <= 0x5a || ch >= 0x61 && ch <= 0x7a))strBuf.push(String.fromCharCode(ch));
                        const str = strBuf.join("");
                        switch(str.toLowerCase()){
                            case "if":
                                return PostScriptToken.IF;
                            case "ifelse":
                                return PostScriptToken.IFELSE;
                            default:
                                return PostScriptToken.getOperator(str);
                        }
                    }
                    getNumber() {
                        let ch = this.currentChar;
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        strBuf[0] = String.fromCharCode(ch);
                        while((ch = this.nextChar()) >= 0){
                            if (ch >= 0x30 && ch <= 0x39 || ch === 0x2d || ch === 0x2e) strBuf.push(String.fromCharCode(ch));
                            else break;
                        }
                        const value = parseFloat(strBuf.join(""));
                        if (isNaN(value)) throw new _util.FormatError(`Invalid floating point number: ${value}`);
                        return value;
                    }
                }
                exports.PostScriptLexer = PostScriptLexer;
            /***/ },
            /* 59 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RegionalImageCache = exports.LocalTilingPatternCache = exports.LocalImageCache = exports.LocalGStateCache = exports.LocalFunctionCache = exports.LocalColorSpaceCache = exports.GlobalImageCache = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                class BaseLocalCache {
                    constructor(options){
                        if (this.constructor === BaseLocalCache) (0, _util.unreachable)("Cannot initialize BaseLocalCache.");
                        this._onlyRefs = options?.onlyRefs === true;
                        if (!this._onlyRefs) {
                            this._nameRefMap = new Map();
                            this._imageMap = new Map();
                        }
                        this._imageCache = new _primitives.RefSetCache();
                    }
                    getByName(name) {
                        if (this._onlyRefs) (0, _util.unreachable)("Should not call `getByName` method.");
                        const ref = this._nameRefMap.get(name);
                        if (ref) return this.getByRef(ref);
                        return this._imageMap.get(name) || null;
                    }
                    getByRef(ref) {
                        return this._imageCache.get(ref) || null;
                    }
                    set(name, ref, data) {
                        (0, _util.unreachable)("Abstract method `set` called.");
                    }
                }
                class LocalImageCache extends BaseLocalCache {
                    set(name, ref = null, data) {
                        if (typeof name !== "string") throw new Error('LocalImageCache.set - expected "name" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalImageCache = LocalImageCache;
                class LocalColorSpaceCache extends BaseLocalCache {
                    set(name = null, ref = null, data) {
                        if (typeof name !== "string" && !ref) throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            if (name !== null) this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalColorSpaceCache = LocalColorSpaceCache;
                class LocalFunctionCache extends BaseLocalCache {
                    constructor(options){
                        super({
                            onlyRefs: true
                        });
                    }
                    set(name = null, ref, data) {
                        if (!ref) throw new Error('LocalFunctionCache.set - expected "ref" argument.');
                        if (this._imageCache.has(ref)) return;
                        this._imageCache.put(ref, data);
                    }
                }
                exports.LocalFunctionCache = LocalFunctionCache;
                class LocalGStateCache extends BaseLocalCache {
                    set(name, ref = null, data) {
                        if (typeof name !== "string") throw new Error('LocalGStateCache.set - expected "name" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalGStateCache = LocalGStateCache;
                class LocalTilingPatternCache extends BaseLocalCache {
                    constructor(options){
                        super({
                            onlyRefs: true
                        });
                    }
                    set(name = null, ref, data) {
                        if (!ref) throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
                        if (this._imageCache.has(ref)) return;
                        this._imageCache.put(ref, data);
                    }
                }
                exports.LocalTilingPatternCache = LocalTilingPatternCache;
                class RegionalImageCache extends BaseLocalCache {
                    constructor(options){
                        super({
                            onlyRefs: true
                        });
                    }
                    set(name = null, ref, data) {
                        if (!ref) throw new Error('RegionalImageCache.set - expected "ref" argument.');
                        if (this._imageCache.has(ref)) return;
                        this._imageCache.put(ref, data);
                    }
                }
                exports.RegionalImageCache = RegionalImageCache;
                class GlobalImageCache {
                    static NUM_PAGES_THRESHOLD = 2;
                    static MIN_IMAGES_TO_CACHE = 10;
                    static MAX_BYTE_SIZE = 5 * _util.MAX_IMAGE_SIZE_TO_CACHE;
                    constructor(){
                        this._refCache = new _primitives.RefSetCache();
                        this._imageCache = new _primitives.RefSetCache();
                    }
                    get _byteSize() {
                        let byteSize = 0;
                        for (const imageData of this._imageCache)byteSize += imageData.byteSize;
                        return byteSize;
                    }
                    get _cacheLimitReached() {
                        if (this._imageCache.size < GlobalImageCache.MIN_IMAGES_TO_CACHE) return false;
                        if (this._byteSize < GlobalImageCache.MAX_BYTE_SIZE) return false;
                        return true;
                    }
                    shouldCache(ref, pageIndex) {
                        let pageIndexSet = this._refCache.get(ref);
                        if (!pageIndexSet) {
                            pageIndexSet = new Set();
                            this._refCache.put(ref, pageIndexSet);
                        }
                        pageIndexSet.add(pageIndex);
                        if (pageIndexSet.size < GlobalImageCache.NUM_PAGES_THRESHOLD) return false;
                        if (!this._imageCache.has(ref) && this._cacheLimitReached) return false;
                        return true;
                    }
                    addByteSize(ref, byteSize) {
                        const imageData = this._imageCache.get(ref);
                        if (!imageData) return;
                        if (imageData.byteSize) return;
                        imageData.byteSize = byteSize;
                    }
                    getData(ref, pageIndex) {
                        const pageIndexSet = this._refCache.get(ref);
                        if (!pageIndexSet) return null;
                        if (pageIndexSet.size < GlobalImageCache.NUM_PAGES_THRESHOLD) return null;
                        const imageData = this._imageCache.get(ref);
                        if (!imageData) return null;
                        pageIndexSet.add(pageIndex);
                        return imageData;
                    }
                    setData(ref, data) {
                        if (!this._refCache.has(ref)) throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
                        if (this._imageCache.has(ref)) return;
                        if (this._cacheLimitReached) {
                            (0, _util.warn)("GlobalImageCache.setData - cache limit reached.");
                            return;
                        }
                        this._imageCache.put(ref, data);
                    }
                    clear(onlyData = false) {
                        if (!onlyData) this._refCache.clear();
                        this._imageCache.clear();
                    }
                }
                exports.GlobalImageCache = GlobalImageCache;
            /***/ },
            /* 60 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.bidi = bidi;
                var _util = __w_pdfjs_require__(2);
                const baseTypes = [
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "S",
                    "B",
                    "S",
                    "WS",
                    "B",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "B",
                    "B",
                    "B",
                    "S",
                    "WS",
                    "ON",
                    "ON",
                    "ET",
                    "ET",
                    "ET",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ES",
                    "CS",
                    "ES",
                    "CS",
                    "CS",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "CS",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "B",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "CS",
                    "ON",
                    "ET",
                    "ET",
                    "ET",
                    "ET",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "ON",
                    "ON",
                    "BN",
                    "ON",
                    "ON",
                    "ET",
                    "ET",
                    "EN",
                    "EN",
                    "ON",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "EN",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L"
                ];
                const arabicTypes = [
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "ON",
                    "ON",
                    "AL",
                    "ET",
                    "ET",
                    "AL",
                    "CS",
                    "AL",
                    "ON",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "ET",
                    "AN",
                    "AN",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AN",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL"
                ];
                function isOdd(i) {
                    return (i & 1) !== 0;
                }
                function isEven(i) {
                    return (i & 1) === 0;
                }
                function findUnequal(arr, start, value) {
                    let j, jj;
                    for(j = start, jj = arr.length; j < jj; ++j){
                        if (arr[j] !== value) return j;
                    }
                    return j;
                }
                function setValues(arr, start, end, value) {
                    for(let j = start; j < end; ++j)arr[j] = value;
                }
                function reverseValues(arr, start, end) {
                    for(let i = start, j = end - 1; i < j; ++i, --j){
                        const temp = arr[i];
                        arr[i] = arr[j];
                        arr[j] = temp;
                    }
                }
                function createBidiText(str, isLTR, vertical = false) {
                    let dir = "ltr";
                    if (vertical) dir = "ttb";
                    else if (!isLTR) dir = "rtl";
                    return {
                        str: str,
                        dir: dir
                    };
                }
                const chars = [];
                const types = [];
                function bidi(str, startLevel = -1, vertical = false) {
                    let isLTR = true;
                    const strLength = str.length;
                    if (strLength === 0 || vertical) return createBidiText(str, isLTR, vertical);
                    chars.length = strLength;
                    types.length = strLength;
                    let numBidi = 0;
                    let i, ii;
                    for(i = 0; i < strLength; ++i){
                        chars[i] = str.charAt(i);
                        const charCode = str.charCodeAt(i);
                        let charType = "L";
                        if (charCode <= 0x00ff) charType = baseTypes[charCode];
                        else if (0x0590 <= charCode && charCode <= 0x05f4) charType = "R";
                        else if (0x0600 <= charCode && charCode <= 0x06ff) {
                            charType = arabicTypes[charCode & 0xff];
                            if (!charType) (0, _util.warn)("Bidi: invalid Unicode character " + charCode.toString(16));
                        } else if (0x0700 <= charCode && charCode <= 0x08ac || 0xfb50 <= charCode && charCode <= 0xfdff || 0xfe70 <= charCode && charCode <= 0xfeff) charType = "AL";
                        if (charType === "R" || charType === "AL" || charType === "AN") numBidi++;
                        types[i] = charType;
                    }
                    if (numBidi === 0) {
                        isLTR = true;
                        return createBidiText(str, isLTR);
                    }
                    if (startLevel === -1) {
                        if (numBidi / strLength < 0.3 && strLength > 4) {
                            isLTR = true;
                            startLevel = 0;
                        } else {
                            isLTR = false;
                            startLevel = 1;
                        }
                    }
                    const levels = [];
                    for(i = 0; i < strLength; ++i)levels[i] = startLevel;
                    const e = isOdd(startLevel) ? "R" : "L";
                    const sor = e;
                    const eor = sor;
                    let lastType = sor;
                    for(i = 0; i < strLength; ++i)if (types[i] === "NSM") types[i] = lastType;
                    else lastType = types[i];
                    lastType = sor;
                    let t;
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "EN") types[i] = lastType === "AL" ? "AN" : "EN";
                        else if (t === "R" || t === "L" || t === "AL") lastType = t;
                    }
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "AL") types[i] = "R";
                    }
                    for(i = 1; i < strLength - 1; ++i){
                        if (types[i] === "ES" && types[i - 1] === "EN" && types[i + 1] === "EN") types[i] = "EN";
                        if (types[i] === "CS" && (types[i - 1] === "EN" || types[i - 1] === "AN") && types[i + 1] === types[i - 1]) types[i] = types[i - 1];
                    }
                    for(i = 0; i < strLength; ++i)if (types[i] === "EN") {
                        for(let j = i - 1; j >= 0; --j){
                            if (types[j] !== "ET") break;
                            types[j] = "EN";
                        }
                        for(let j = i + 1; j < strLength; ++j){
                            if (types[j] !== "ET") break;
                            types[j] = "EN";
                        }
                    }
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "WS" || t === "ES" || t === "ET" || t === "CS") types[i] = "ON";
                    }
                    lastType = sor;
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "EN") types[i] = lastType === "L" ? "L" : "EN";
                        else if (t === "R" || t === "L") lastType = t;
                    }
                    for(i = 0; i < strLength; ++i)if (types[i] === "ON") {
                        const end = findUnequal(types, i + 1, "ON");
                        let before = sor;
                        if (i > 0) before = types[i - 1];
                        let after = eor;
                        if (end + 1 < strLength) after = types[end + 1];
                        if (before !== "L") before = "R";
                        if (after !== "L") after = "R";
                        if (before === after) setValues(types, i, end, before);
                        i = end - 1;
                    }
                    for(i = 0; i < strLength; ++i)if (types[i] === "ON") types[i] = e;
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (isEven(levels[i])) {
                            if (t === "R") levels[i] += 1;
                            else if (t === "AN" || t === "EN") levels[i] += 2;
                        } else if (t === "L" || t === "AN" || t === "EN") levels[i] += 1;
                    }
                    let highestLevel = -1;
                    let lowestOddLevel = 99;
                    let level;
                    for(i = 0, ii = levels.length; i < ii; ++i){
                        level = levels[i];
                        if (highestLevel < level) highestLevel = level;
                        if (lowestOddLevel > level && isOdd(level)) lowestOddLevel = level;
                    }
                    for(level = highestLevel; level >= lowestOddLevel; --level){
                        let start = -1;
                        for(i = 0, ii = levels.length; i < ii; ++i){
                            if (levels[i] < level) {
                                if (start >= 0) {
                                    reverseValues(chars, start, i);
                                    start = -1;
                                }
                            } else if (start < 0) start = i;
                        }
                        if (start >= 0) reverseValues(chars, start, levels.length);
                    }
                    for(i = 0, ii = chars.length; i < ii; ++i){
                        const ch = chars[i];
                        if (ch === "<" || ch === ">") chars[i] = "";
                    }
                    return createBidiText(chars.join(""), isLTR);
                }
            /***/ },
            /* 61 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFontSubstitution = getFontSubstitution;
                var _fonts_utils = __w_pdfjs_require__(38);
                var _core_utils = __w_pdfjs_require__(3);
                const NORMAL = {
                    style: "normal",
                    weight: "normal"
                };
                const BOLD = {
                    style: "normal",
                    weight: "bold"
                };
                const ITALIC = {
                    style: "italic",
                    weight: "normal"
                };
                const BOLDITALIC = {
                    style: "italic",
                    weight: "bold"
                };
                const substitutionMap = new Map([
                    [
                        "Times-Roman",
                        {
                            local: [
                                "Times New Roman",
                                "Times-Roman",
                                "Times",
                                "Liberation Serif",
                                "Nimbus Roman",
                                "Nimbus Roman L",
                                "Tinos",
                                "Thorndale",
                                "TeX Gyre Termes",
                                "FreeSerif",
                                "DejaVu Serif",
                                "Bitstream Vera Serif",
                                "Ubuntu"
                            ],
                            style: NORMAL,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Times-Bold",
                        {
                            alias: "Times-Roman",
                            style: BOLD,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Times-Italic",
                        {
                            alias: "Times-Roman",
                            style: ITALIC,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Times-BoldItalic",
                        {
                            alias: "Times-Roman",
                            style: BOLDITALIC,
                            ultimate: "serif"
                        }
                    ],
                    [
                        "Helvetica",
                        {
                            local: [
                                "Helvetica",
                                "Helvetica Neue",
                                "Arial",
                                "Arial Nova",
                                "Liberation Sans",
                                "Arimo",
                                "Nimbus Sans",
                                "Nimbus Sans L",
                                "A030",
                                "TeX Gyre Heros",
                                "FreeSans",
                                "DejaVu Sans",
                                "Albany",
                                "Bitstream Vera Sans",
                                "Arial Unicode MS",
                                "Microsoft Sans Serif",
                                "Apple Symbols",
                                "Cantarell"
                            ],
                            path: "LiberationSans-Regular.ttf",
                            style: NORMAL,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Helvetica-Bold",
                        {
                            alias: "Helvetica",
                            path: "LiberationSans-Bold.ttf",
                            style: BOLD,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Helvetica-Oblique",
                        {
                            alias: "Helvetica",
                            path: "LiberationSans-Italic.ttf",
                            style: ITALIC,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Helvetica-BoldOblique",
                        {
                            alias: "Helvetica",
                            path: "LiberationSans-BoldItalic.ttf",
                            style: BOLDITALIC,
                            ultimate: "sans-serif"
                        }
                    ],
                    [
                        "Courier",
                        {
                            local: [
                                "Courier",
                                "Courier New",
                                "Liberation Mono",
                                "Nimbus Mono",
                                "Nimbus Mono L",
                                "Cousine",
                                "Cumberland",
                                "TeX Gyre Cursor",
                                "FreeMono"
                            ],
                            style: NORMAL,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "Courier-Bold",
                        {
                            alias: "Courier",
                            style: BOLD,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "Courier-Oblique",
                        {
                            alias: "Courier",
                            style: ITALIC,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "Courier-BoldOblique",
                        {
                            alias: "Courier",
                            style: BOLDITALIC,
                            ultimate: "monospace"
                        }
                    ],
                    [
                        "ArialBlack",
                        {
                            local: [
                                "Arial Black"
                            ],
                            style: {
                                style: "normal",
                                weight: "900"
                            },
                            fallback: "Helvetica-Bold"
                        }
                    ],
                    [
                        "ArialBlack-Bold",
                        {
                            alias: "ArialBlack"
                        }
                    ],
                    [
                        "ArialBlack-Italic",
                        {
                            alias: "ArialBlack",
                            style: {
                                style: "italic",
                                weight: "900"
                            },
                            fallback: "Helvetica-BoldOblique"
                        }
                    ],
                    [
                        "ArialBlack-BoldItalic",
                        {
                            alias: "ArialBlack-Italic"
                        }
                    ],
                    [
                        "ArialNarrow",
                        {
                            local: [
                                "Arial Narrow",
                                "Liberation Sans Narrow",
                                "Helvetica Condensed",
                                "Nimbus Sans Narrow",
                                "TeX Gyre Heros Cn"
                            ],
                            style: NORMAL,
                            fallback: "Helvetica"
                        }
                    ],
                    [
                        "ArialNarrow-Bold",
                        {
                            alias: "ArialNarrow",
                            style: BOLD,
                            fallback: "Helvetica-Bold"
                        }
                    ],
                    [
                        "ArialNarrow-Italic",
                        {
                            alias: "ArialNarrow",
                            style: ITALIC,
                            fallback: "Helvetica-Oblique"
                        }
                    ],
                    [
                        "ArialNarrow-BoldItalic",
                        {
                            alias: "ArialNarrow",
                            style: BOLDITALIC,
                            fallback: "Helvetica-BoldOblique"
                        }
                    ],
                    [
                        "Calibri",
                        {
                            local: [
                                "Calibri",
                                "Carlito"
                            ],
                            style: NORMAL,
                            fallback: "Helvetica"
                        }
                    ],
                    [
                        "Calibri-Bold",
                        {
                            alias: "Calibri",
                            style: BOLD,
                            fallback: "Helvetica-Bold"
                        }
                    ],
                    [
                        "Calibri-Italic",
                        {
                            alias: "Calibri",
                            style: ITALIC,
                            fallback: "Helvetica-Oblique"
                        }
                    ],
                    [
                        "Calibri-BoldItalic",
                        {
                            alias: "Calibri",
                            style: BOLDITALIC,
                            fallback: "Helvetica-BoldOblique"
                        }
                    ],
                    [
                        "Wingdings",
                        {
                            local: [
                                "Wingdings",
                                "URW Dingbats"
                            ],
                            style: NORMAL
                        }
                    ],
                    [
                        "Wingdings-Regular",
                        {
                            alias: "Wingdings"
                        }
                    ],
                    [
                        "Wingdings-Bold",
                        {
                            alias: "Wingdings"
                        }
                    ]
                ]);
                const fontAliases = new Map([
                    [
                        "Arial-Black",
                        "ArialBlack"
                    ]
                ]);
                function getStyleToAppend(style) {
                    switch(style){
                        case BOLD:
                            return "Bold";
                        case ITALIC:
                            return "Italic";
                        case BOLDITALIC:
                            return "Bold Italic";
                        default:
                            if (style?.weight === "bold") return "Bold";
                            if (style?.style === "italic") return "Italic";
                    }
                    return "";
                }
                function generateFont({ alias: alias, local: local, path: path, fallback: fallback, style: style, ultimate: ultimate }, src, localFontPath, useFallback = true, usePath = true, append = "") {
                    const result = {
                        style: null,
                        ultimate: null
                    };
                    if (local) {
                        const extra = append ? ` ${append}` : "";
                        for (const name of local)src.push(`local(${name}${extra})`);
                    }
                    if (alias) {
                        const substitution = substitutionMap.get(alias);
                        const aliasAppend = append || getStyleToAppend(style);
                        Object.assign(result, generateFont(substitution, src, localFontPath, useFallback && !fallback, usePath && !path, aliasAppend));
                    }
                    if (style) result.style = style;
                    if (ultimate) result.ultimate = ultimate;
                    if (useFallback && fallback) {
                        const fallbackInfo = substitutionMap.get(fallback);
                        const { ultimate: fallbackUltimate } = generateFont(fallbackInfo, src, localFontPath, useFallback, usePath && !path, append);
                        result.ultimate ||= fallbackUltimate;
                    }
                    if (usePath && path && localFontPath) src.push(`url(${localFontPath}${path})`);
                    return result;
                }
                function getFontSubstitution(systemFontCache, idFactory, localFontPath, baseFontName, standardFontName) {
                    baseFontName = (0, _fonts_utils.normalizeFontName)(baseFontName);
                    const key = baseFontName;
                    let substitutionInfo = systemFontCache.get(key);
                    if (substitutionInfo) return substitutionInfo;
                    let substitution = substitutionMap.get(baseFontName);
                    if (!substitution) {
                        for (const [alias, subst] of fontAliases)if (baseFontName.startsWith(alias)) {
                            baseFontName = `${subst}${baseFontName.substring(alias.length)}`;
                            substitution = substitutionMap.get(baseFontName);
                            break;
                        }
                    }
                    let mustAddBaseFont = false;
                    if (!substitution) {
                        substitution = substitutionMap.get(standardFontName);
                        mustAddBaseFont = true;
                    }
                    const loadedName = `${idFactory.getDocId()}_s${idFactory.createFontId()}`;
                    if (!substitution) {
                        if (!(0, _core_utils.validateFontName)(baseFontName)) {
                            systemFontCache.set(key, null);
                            return null;
                        }
                        const bold = /bold/gi.test(baseFontName);
                        const italic = /oblique|italic/gi.test(baseFontName);
                        const style = bold && italic && BOLDITALIC || bold && BOLD || italic && ITALIC || NORMAL;
                        substitutionInfo = {
                            css: loadedName,
                            guessFallback: true,
                            loadedName: loadedName,
                            baseFontName: baseFontName,
                            src: `local(${baseFontName})`,
                            style: style
                        };
                        systemFontCache.set(key, substitutionInfo);
                        return substitutionInfo;
                    }
                    const src = [];
                    if (mustAddBaseFont && (0, _core_utils.validateFontName)(baseFontName)) src.push(`local(${baseFontName})`);
                    const { style: style, ultimate: ultimate } = generateFont(substitution, src, localFontPath);
                    const guessFallback = ultimate === null;
                    const fallback = guessFallback ? "" : `,${ultimate}`;
                    substitutionInfo = {
                        css: `${loadedName}${fallback}`,
                        guessFallback: guessFallback,
                        loadedName: loadedName,
                        baseFontName: baseFontName,
                        src: src.join(","),
                        style: style
                    };
                    systemFontCache.set(key, substitutionInfo);
                    return substitutionInfo;
                }
            /***/ },
            /* 62 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ImageResizer = void 0;
                var _util = __w_pdfjs_require__(2);
                const MIN_IMAGE_DIM = 2048;
                const MAX_IMAGE_DIM = 65537;
                const MAX_ERROR = 128;
                class ImageResizer {
                    constructor(imgData, isMask){
                        this._imgData = imgData;
                        this._isMask = isMask;
                    }
                    static needsToBeResized(width, height) {
                        if (width <= this._goodSquareLength && height <= this._goodSquareLength) return false;
                        const { MAX_DIM: MAX_DIM } = this;
                        if (width > MAX_DIM || height > MAX_DIM) return true;
                        const area = width * height;
                        if (this._hasMaxArea) return area > this.MAX_AREA;
                        if (area < this._goodSquareLength ** 2) return false;
                        if (this._areGoodDims(width, height)) {
                            this._goodSquareLength = Math.max(this._goodSquareLength, Math.floor(Math.sqrt(width * height)));
                            return false;
                        }
                        this._goodSquareLength = this._guessMax(this._goodSquareLength, MAX_DIM, MAX_ERROR, 0);
                        const maxArea = this.MAX_AREA = this._goodSquareLength ** 2;
                        return area > maxArea;
                    }
                    static get MAX_DIM() {
                        return (0, _util.shadow)(this, "MAX_DIM", this._guessMax(MIN_IMAGE_DIM, MAX_IMAGE_DIM, 0, 1));
                    }
                    static get MAX_AREA() {
                        this._hasMaxArea = true;
                        return (0, _util.shadow)(this, "MAX_AREA", this._guessMax(ImageResizer._goodSquareLength, this.MAX_DIM, MAX_ERROR, 0) ** 2);
                    }
                    static set MAX_AREA(area) {
                        if (area >= 0) {
                            this._hasMaxArea = true;
                            (0, _util.shadow)(this, "MAX_AREA", area);
                        }
                    }
                    static setMaxArea(area) {
                        if (!this._hasMaxArea) this.MAX_AREA = area >> 2;
                    }
                    static _areGoodDims(width, height) {
                        try {
                            const canvas = new OffscreenCanvas(width, height);
                            const ctx = canvas.getContext("2d");
                            ctx.fillRect(0, 0, 1, 1);
                            const opacity = ctx.getImageData(0, 0, 1, 1).data[3];
                            canvas.width = canvas.height = 1;
                            return opacity !== 0;
                        } catch  {
                            return false;
                        }
                    }
                    static _guessMax(start, end, tolerance, defaultHeight) {
                        while(start + tolerance + 1 < end){
                            const middle = Math.floor((start + end) / 2);
                            const height = defaultHeight || middle;
                            if (this._areGoodDims(middle, height)) start = middle;
                            else end = middle;
                        }
                        return start;
                    }
                    static async createImage(imgData, isMask = false) {
                        return new ImageResizer(imgData, isMask)._createImage();
                    }
                    async _createImage() {
                        const data = this._encodeBMP();
                        const blob = new Blob([
                            data.buffer
                        ], {
                            type: "image/bmp"
                        });
                        const bitmapPromise = createImageBitmap(blob);
                        const { MAX_AREA: MAX_AREA, MAX_DIM: MAX_DIM } = ImageResizer;
                        const { _imgData: imgData } = this;
                        const { width: width, height: height } = imgData;
                        const minFactor = Math.max(width / MAX_DIM, height / MAX_DIM, Math.sqrt(width * height / MAX_AREA));
                        const firstFactor = Math.max(minFactor, 2);
                        const factor = Math.round(10 * (minFactor + 1.25)) / 10 / firstFactor;
                        const N = Math.floor(Math.log2(factor));
                        const steps = new Array(N + 2).fill(2);
                        steps[0] = firstFactor;
                        steps.splice(-1, 1, factor / (1 << N));
                        let newWidth = width;
                        let newHeight = height;
                        let bitmap = await bitmapPromise;
                        for (const step of steps){
                            const prevWidth = newWidth;
                            const prevHeight = newHeight;
                            newWidth = Math.floor(newWidth / step) - 1;
                            newHeight = Math.floor(newHeight / step) - 1;
                            const canvas = new OffscreenCanvas(newWidth, newHeight);
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                            bitmap = canvas.transferToImageBitmap();
                        }
                        imgData.data = null;
                        imgData.bitmap = bitmap;
                        imgData.width = newWidth;
                        imgData.height = newHeight;
                        return imgData;
                    }
                    _encodeBMP() {
                        const { width: width, height: height, kind: kind } = this._imgData;
                        let data = this._imgData.data;
                        let bitPerPixel;
                        let colorTable = new Uint8Array(0);
                        let maskTable = colorTable;
                        let compression = 0;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                {
                                    bitPerPixel = 1;
                                    colorTable = new Uint8Array(this._isMask ? [
                                        255,
                                        255,
                                        255,
                                        255,
                                        0,
                                        0,
                                        0,
                                        0
                                    ] : [
                                        0,
                                        0,
                                        0,
                                        0,
                                        255,
                                        255,
                                        255,
                                        255
                                    ]);
                                    const rowLen = width + 7 >> 3;
                                    const rowSize = rowLen + 3 & -4;
                                    if (rowLen !== rowSize) {
                                        const newData = new Uint8Array(rowSize * height);
                                        let k = 0;
                                        for(let i = 0, ii = height * rowLen; i < ii; i += rowLen, k += rowSize)newData.set(data.subarray(i, i + rowLen), k);
                                        data = newData;
                                    }
                                    break;
                                }
                            case _util.ImageKind.RGB_24BPP:
                                bitPerPixel = 24;
                                if (width & 3) {
                                    const rowLen = 3 * width;
                                    const rowSize = rowLen + 3 & -4;
                                    const extraLen = rowSize - rowLen;
                                    const newData = new Uint8Array(rowSize * height);
                                    let k = 0;
                                    for(let i = 0, ii = height * rowLen; i < ii; i += rowLen){
                                        const row = data.subarray(i, i + rowLen);
                                        for(let j = 0; j < rowLen; j += 3){
                                            newData[k++] = row[j + 2];
                                            newData[k++] = row[j + 1];
                                            newData[k++] = row[j];
                                        }
                                        k += extraLen;
                                    }
                                    data = newData;
                                } else for(let i = 0, ii = data.length; i < ii; i += 3){
                                    const tmp = data[i];
                                    data[i] = data[i + 2];
                                    data[i + 2] = tmp;
                                }
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                bitPerPixel = 32;
                                compression = 3;
                                maskTable = new Uint8Array(68);
                                const view = new DataView(maskTable.buffer);
                                if (_util.FeatureTest.isLittleEndian) {
                                    view.setUint32(0, 0x000000ff, true);
                                    view.setUint32(4, 0x0000ff00, true);
                                    view.setUint32(8, 0x00ff0000, true);
                                    view.setUint32(12, 0xff000000, true);
                                } else {
                                    view.setUint32(0, 0xff000000, true);
                                    view.setUint32(4, 0x00ff0000, true);
                                    view.setUint32(8, 0x0000ff00, true);
                                    view.setUint32(12, 0x000000ff, true);
                                }
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        let i = 0;
                        const headerLength = 40 + maskTable.length;
                        const fileLength = 14 + headerLength + colorTable.length + data.length;
                        const bmpData = new Uint8Array(fileLength);
                        const view1 = new DataView(bmpData.buffer);
                        view1.setUint16(i, 0x4d42, true);
                        i += 2;
                        view1.setUint32(i, fileLength, true);
                        i += 4;
                        view1.setUint32(i, 0, true);
                        i += 4;
                        view1.setUint32(i, 14 + headerLength + colorTable.length, true);
                        i += 4;
                        view1.setUint32(i, headerLength, true);
                        i += 4;
                        view1.setInt32(i, width, true);
                        i += 4;
                        view1.setInt32(i, -height, true);
                        i += 4;
                        view1.setUint16(i, 1, true);
                        i += 2;
                        view1.setUint16(i, bitPerPixel, true);
                        i += 2;
                        view1.setUint32(i, compression, true);
                        i += 4;
                        view1.setUint32(i, 0, true);
                        i += 4;
                        view1.setInt32(i, 0, true);
                        i += 4;
                        view1.setInt32(i, 0, true);
                        i += 4;
                        view1.setUint32(i, colorTable.length / 4, true);
                        i += 4;
                        view1.setUint32(i, 0, true);
                        i += 4;
                        bmpData.set(maskTable, i);
                        i += maskTable.length;
                        bmpData.set(colorTable, i);
                        i += colorTable.length;
                        bmpData.set(data, i);
                        return bmpData;
                    }
                }
                exports.ImageResizer = ImageResizer;
                ImageResizer._goodSquareLength = MIN_IMAGE_DIM;
            /***/ },
            /* 63 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(2);
                const SEED = 0xc3d2e1f0;
                const MASK_HIGH = 0xffff0000;
                const MASK_LOW = 0xffff;
                class MurmurHash3_64 {
                    constructor(seed){
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                    update(input) {
                        let data, length;
                        if (typeof input === "string") {
                            data = new Uint8Array(input.length * 2);
                            length = 0;
                            for(let i = 0, ii = input.length; i < ii; i++){
                                const code = input.charCodeAt(i);
                                if (code <= 0xff) data[length++] = code;
                                else {
                                    data[length++] = code >>> 8;
                                    data[length++] = code & 0xff;
                                }
                            }
                        } else if ((0, _util.isArrayBuffer)(input)) {
                            data = input.slice();
                            length = data.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts = length >> 2;
                        const tailLength = length - blockCounts * 4;
                        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                        let k1 = 0, k2 = 0;
                        let h1 = this.h1, h2 = this.h2;
                        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
                        const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                        for(let i = 0; i < blockCounts; i++)if (i & 1) {
                            k1 = dataUint32[i];
                            k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                            k1 = k1 << 15 | k1 >>> 17;
                            k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                            h1 ^= k1;
                            h1 = h1 << 13 | h1 >>> 19;
                            h1 = h1 * 5 + 0xe6546b64;
                        } else {
                            k2 = dataUint32[i];
                            k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                            k2 = k2 << 15 | k2 >>> 17;
                            k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                            h2 ^= k2;
                            h2 = h2 << 13 | h2 >>> 19;
                            h2 = h2 * 5 + 0xe6546b64;
                        }
                        k1 = 0;
                        switch(tailLength){
                            case 3:
                                k1 ^= data[blockCounts * 4 + 2] << 16;
                            case 2:
                                k1 ^= data[blockCounts * 4 + 1] << 8;
                            case 1:
                                k1 ^= data[blockCounts * 4];
                                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                k1 = k1 << 15 | k1 >>> 17;
                                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                if (blockCounts & 1) h1 ^= k1;
                                else h2 ^= k1;
                        }
                        this.h1 = h1;
                        this.h2 = h2;
                    }
                    hexdigest() {
                        let h1 = this.h1, h2 = this.h2;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                    }
                }
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 64 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OperatorList = void 0;
                var _util = __w_pdfjs_require__(2);
                function addState(parentState, pattern, checkFn, iterateFn, processFn) {
                    let state = parentState;
                    for(let i = 0, ii = pattern.length - 1; i < ii; i++){
                        const item = pattern[i];
                        state = state[item] ||= [];
                    }
                    state[pattern.at(-1)] = {
                        checkFn: checkFn,
                        iterateFn: iterateFn,
                        processFn: processFn
                    };
                }
                const InitialState = [];
                addState(InitialState, [
                    _util.OPS.save,
                    _util.OPS.transform,
                    _util.OPS.paintInlineImageXObject,
                    _util.OPS.restore
                ], null, function iterateInlineImageGroup(context, i) {
                    const fnArray = context.fnArray;
                    const iFirstSave = context.iCurr - 3;
                    const pos = (i - iFirstSave) % 4;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.save;
                        case 1:
                            return fnArray[i] === _util.OPS.transform;
                        case 2:
                            return fnArray[i] === _util.OPS.paintInlineImageXObject;
                        case 3:
                            return fnArray[i] === _util.OPS.restore;
                    }
                    throw new Error(`iterateInlineImageGroup - invalid pos: ${pos}`);
                }, function foundInlineImageGroup(context, i) {
                    const MIN_IMAGES_IN_INLINE_IMAGES_BLOCK = 10;
                    const MAX_IMAGES_IN_INLINE_IMAGES_BLOCK = 200;
                    const MAX_WIDTH = 1000;
                    const IMAGE_PADDING = 1;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstSave = curr - 3;
                    const iFirstTransform = curr - 2;
                    const iFirstPIIXO = curr - 1;
                    const count = Math.min(Math.floor((i - iFirstSave) / 4), MAX_IMAGES_IN_INLINE_IMAGES_BLOCK);
                    if (count < MIN_IMAGES_IN_INLINE_IMAGES_BLOCK) return i - (i - iFirstSave) % 4;
                    let maxX = 0;
                    const map = [];
                    let maxLineHeight = 0;
                    let currentX = IMAGE_PADDING, currentY = IMAGE_PADDING;
                    for(let q = 0; q < count; q++){
                        const transform = argsArray[iFirstTransform + (q << 2)];
                        const img = argsArray[iFirstPIIXO + (q << 2)][0];
                        if (currentX + img.width > MAX_WIDTH) {
                            maxX = Math.max(maxX, currentX);
                            currentY += maxLineHeight + 2 * IMAGE_PADDING;
                            currentX = 0;
                            maxLineHeight = 0;
                        }
                        map.push({
                            transform: transform,
                            x: currentX,
                            y: currentY,
                            w: img.width,
                            h: img.height
                        });
                        currentX += img.width + 2 * IMAGE_PADDING;
                        maxLineHeight = Math.max(maxLineHeight, img.height);
                    }
                    const imgWidth = Math.max(maxX, currentX) + IMAGE_PADDING;
                    const imgHeight = currentY + maxLineHeight + IMAGE_PADDING;
                    const imgData = new Uint8Array(imgWidth * imgHeight * 4);
                    const imgRowSize = imgWidth << 2;
                    for(let q = 0; q < count; q++){
                        const data = argsArray[iFirstPIIXO + (q << 2)][0].data;
                        const rowSize = map[q].w << 2;
                        let dataOffset = 0;
                        let offset = map[q].x + map[q].y * imgWidth << 2;
                        imgData.set(data.subarray(0, rowSize), offset - imgRowSize);
                        for(let k = 0, kk = map[q].h; k < kk; k++){
                            imgData.set(data.subarray(dataOffset, dataOffset + rowSize), offset);
                            dataOffset += rowSize;
                            offset += imgRowSize;
                        }
                        imgData.set(data.subarray(dataOffset - rowSize, dataOffset), offset);
                        while(offset >= 0){
                            data[offset - 4] = data[offset];
                            data[offset - 3] = data[offset + 1];
                            data[offset - 2] = data[offset + 2];
                            data[offset - 1] = data[offset + 3];
                            data[offset + rowSize] = data[offset + rowSize - 4];
                            data[offset + rowSize + 1] = data[offset + rowSize - 3];
                            data[offset + rowSize + 2] = data[offset + rowSize - 2];
                            data[offset + rowSize + 3] = data[offset + rowSize - 1];
                            offset -= imgRowSize;
                        }
                    }
                    const img = {
                        width: imgWidth,
                        height: imgHeight
                    };
                    if (context.isOffscreenCanvasSupported) {
                        const canvas = new OffscreenCanvas(imgWidth, imgHeight);
                        const ctx = canvas.getContext("2d");
                        ctx.putImageData(new ImageData(new Uint8ClampedArray(imgData.buffer), imgWidth, imgHeight), 0, 0);
                        img.bitmap = canvas.transferToImageBitmap();
                        img.data = null;
                    } else {
                        img.kind = _util.ImageKind.RGBA_32BPP;
                        img.data = imgData;
                    }
                    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintInlineImageXObjectGroup);
                    argsArray.splice(iFirstSave, count * 4, [
                        img,
                        map
                    ]);
                    return iFirstSave + 1;
                });
                addState(InitialState, [
                    _util.OPS.save,
                    _util.OPS.transform,
                    _util.OPS.paintImageMaskXObject,
                    _util.OPS.restore
                ], null, function iterateImageMaskGroup(context, i) {
                    const fnArray = context.fnArray;
                    const iFirstSave = context.iCurr - 3;
                    const pos = (i - iFirstSave) % 4;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.save;
                        case 1:
                            return fnArray[i] === _util.OPS.transform;
                        case 2:
                            return fnArray[i] === _util.OPS.paintImageMaskXObject;
                        case 3:
                            return fnArray[i] === _util.OPS.restore;
                    }
                    throw new Error(`iterateImageMaskGroup - invalid pos: ${pos}`);
                }, function foundImageMaskGroup(context, i) {
                    const MIN_IMAGES_IN_MASKS_BLOCK = 10;
                    const MAX_IMAGES_IN_MASKS_BLOCK = 100;
                    const MAX_SAME_IMAGES_IN_MASKS_BLOCK = 1000;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstSave = curr - 3;
                    const iFirstTransform = curr - 2;
                    const iFirstPIMXO = curr - 1;
                    let count = Math.floor((i - iFirstSave) / 4);
                    if (count < MIN_IMAGES_IN_MASKS_BLOCK) return i - (i - iFirstSave) % 4;
                    let isSameImage = false;
                    let iTransform, transformArgs;
                    const firstPIMXOArg0 = argsArray[iFirstPIMXO][0];
                    const firstTransformArg0 = argsArray[iFirstTransform][0], firstTransformArg1 = argsArray[iFirstTransform][1], firstTransformArg2 = argsArray[iFirstTransform][2], firstTransformArg3 = argsArray[iFirstTransform][3];
                    if (firstTransformArg1 === firstTransformArg2) {
                        isSameImage = true;
                        iTransform = iFirstTransform + 4;
                        let iPIMXO = iFirstPIMXO + 4;
                        for(let q = 1; q < count; q++, iTransform += 4, iPIMXO += 4){
                            transformArgs = argsArray[iTransform];
                            if (argsArray[iPIMXO][0] !== firstPIMXOArg0 || transformArgs[0] !== firstTransformArg0 || transformArgs[1] !== firstTransformArg1 || transformArgs[2] !== firstTransformArg2 || transformArgs[3] !== firstTransformArg3) {
                                if (q < MIN_IMAGES_IN_MASKS_BLOCK) isSameImage = false;
                                else count = q;
                                break;
                            }
                        }
                    }
                    if (isSameImage) {
                        count = Math.min(count, MAX_SAME_IMAGES_IN_MASKS_BLOCK);
                        const positions = new Float32Array(count * 2);
                        iTransform = iFirstTransform;
                        for(let q = 0; q < count; q++, iTransform += 4){
                            transformArgs = argsArray[iTransform];
                            positions[q << 1] = transformArgs[4];
                            positions[(q << 1) + 1] = transformArgs[5];
                        }
                        fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectRepeat);
                        argsArray.splice(iFirstSave, count * 4, [
                            firstPIMXOArg0,
                            firstTransformArg0,
                            firstTransformArg1,
                            firstTransformArg2,
                            firstTransformArg3,
                            positions
                        ]);
                    } else {
                        count = Math.min(count, MAX_IMAGES_IN_MASKS_BLOCK);
                        const images = [];
                        for(let q = 0; q < count; q++){
                            transformArgs = argsArray[iFirstTransform + (q << 2)];
                            const maskParams = argsArray[iFirstPIMXO + (q << 2)][0];
                            images.push({
                                data: maskParams.data,
                                width: maskParams.width,
                                height: maskParams.height,
                                interpolate: maskParams.interpolate,
                                count: maskParams.count,
                                transform: transformArgs
                            });
                        }
                        fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectGroup);
                        argsArray.splice(iFirstSave, count * 4, [
                            images
                        ]);
                    }
                    return iFirstSave + 1;
                });
                addState(InitialState, [
                    _util.OPS.save,
                    _util.OPS.transform,
                    _util.OPS.paintImageXObject,
                    _util.OPS.restore
                ], function(context) {
                    const argsArray = context.argsArray;
                    const iFirstTransform = context.iCurr - 2;
                    return argsArray[iFirstTransform][1] === 0 && argsArray[iFirstTransform][2] === 0;
                }, function iterateImageGroup(context, i) {
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const iFirstSave = context.iCurr - 3;
                    const pos = (i - iFirstSave) % 4;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.save;
                        case 1:
                            if (fnArray[i] !== _util.OPS.transform) return false;
                            const iFirstTransform = context.iCurr - 2;
                            const firstTransformArg0 = argsArray[iFirstTransform][0];
                            const firstTransformArg3 = argsArray[iFirstTransform][3];
                            if (argsArray[i][0] !== firstTransformArg0 || argsArray[i][1] !== 0 || argsArray[i][2] !== 0 || argsArray[i][3] !== firstTransformArg3) return false;
                            return true;
                        case 2:
                            if (fnArray[i] !== _util.OPS.paintImageXObject) return false;
                            const iFirstPIXO = context.iCurr - 1;
                            const firstPIXOArg0 = argsArray[iFirstPIXO][0];
                            if (argsArray[i][0] !== firstPIXOArg0) return false;
                            return true;
                        case 3:
                            return fnArray[i] === _util.OPS.restore;
                    }
                    throw new Error(`iterateImageGroup - invalid pos: ${pos}`);
                }, function(context, i) {
                    const MIN_IMAGES_IN_BLOCK = 3;
                    const MAX_IMAGES_IN_BLOCK = 1000;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstSave = curr - 3;
                    const iFirstTransform = curr - 2;
                    const iFirstPIXO = curr - 1;
                    const firstPIXOArg0 = argsArray[iFirstPIXO][0];
                    const firstTransformArg0 = argsArray[iFirstTransform][0];
                    const firstTransformArg3 = argsArray[iFirstTransform][3];
                    const count = Math.min(Math.floor((i - iFirstSave) / 4), MAX_IMAGES_IN_BLOCK);
                    if (count < MIN_IMAGES_IN_BLOCK) return i - (i - iFirstSave) % 4;
                    const positions = new Float32Array(count * 2);
                    let iTransform = iFirstTransform;
                    for(let q = 0; q < count; q++, iTransform += 4){
                        const transformArgs = argsArray[iTransform];
                        positions[q << 1] = transformArgs[4];
                        positions[(q << 1) + 1] = transformArgs[5];
                    }
                    const args = [
                        firstPIXOArg0,
                        firstTransformArg0,
                        firstTransformArg3,
                        positions
                    ];
                    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageXObjectRepeat);
                    argsArray.splice(iFirstSave, count * 4, args);
                    return iFirstSave + 1;
                });
                addState(InitialState, [
                    _util.OPS.beginText,
                    _util.OPS.setFont,
                    _util.OPS.setTextMatrix,
                    _util.OPS.showText,
                    _util.OPS.endText
                ], null, function iterateShowTextGroup(context, i) {
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const iFirstSave = context.iCurr - 4;
                    const pos = (i - iFirstSave) % 5;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.beginText;
                        case 1:
                            return fnArray[i] === _util.OPS.setFont;
                        case 2:
                            return fnArray[i] === _util.OPS.setTextMatrix;
                        case 3:
                            if (fnArray[i] !== _util.OPS.showText) return false;
                            const iFirstSetFont = context.iCurr - 3;
                            const firstSetFontArg0 = argsArray[iFirstSetFont][0];
                            const firstSetFontArg1 = argsArray[iFirstSetFont][1];
                            if (argsArray[i][0] !== firstSetFontArg0 || argsArray[i][1] !== firstSetFontArg1) return false;
                            return true;
                        case 4:
                            return fnArray[i] === _util.OPS.endText;
                    }
                    throw new Error(`iterateShowTextGroup - invalid pos: ${pos}`);
                }, function(context, i) {
                    const MIN_CHARS_IN_BLOCK = 3;
                    const MAX_CHARS_IN_BLOCK = 1000;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstBeginText = curr - 4;
                    const iFirstSetFont = curr - 3;
                    const iFirstSetTextMatrix = curr - 2;
                    const iFirstShowText = curr - 1;
                    const iFirstEndText = curr;
                    const firstSetFontArg0 = argsArray[iFirstSetFont][0];
                    const firstSetFontArg1 = argsArray[iFirstSetFont][1];
                    let count = Math.min(Math.floor((i - iFirstBeginText) / 5), MAX_CHARS_IN_BLOCK);
                    if (count < MIN_CHARS_IN_BLOCK) return i - (i - iFirstBeginText) % 5;
                    let iFirst = iFirstBeginText;
                    if (iFirstBeginText >= 4 && fnArray[iFirstBeginText - 4] === fnArray[iFirstSetFont] && fnArray[iFirstBeginText - 3] === fnArray[iFirstSetTextMatrix] && fnArray[iFirstBeginText - 2] === fnArray[iFirstShowText] && fnArray[iFirstBeginText - 1] === fnArray[iFirstEndText] && argsArray[iFirstBeginText - 4][0] === firstSetFontArg0 && argsArray[iFirstBeginText - 4][1] === firstSetFontArg1) {
                        count++;
                        iFirst -= 5;
                    }
                    let iEndText = iFirst + 4;
                    for(let q = 1; q < count; q++){
                        fnArray.splice(iEndText, 3);
                        argsArray.splice(iEndText, 3);
                        iEndText += 2;
                    }
                    return iEndText + 1;
                });
                class NullOptimizer {
                    constructor(queue){
                        this.queue = queue;
                    }
                    _optimize() {}
                    push(fn, args) {
                        this.queue.fnArray.push(fn);
                        this.queue.argsArray.push(args);
                        this._optimize();
                    }
                    flush() {}
                    reset() {}
                }
                class QueueOptimizer extends NullOptimizer {
                    constructor(queue){
                        super(queue);
                        this.state = null;
                        this.context = {
                            iCurr: 0,
                            fnArray: queue.fnArray,
                            argsArray: queue.argsArray,
                            isOffscreenCanvasSupported: false
                        };
                        this.match = null;
                        this.lastProcessed = 0;
                    }
                    set isOffscreenCanvasSupported(value) {
                        this.context.isOffscreenCanvasSupported = value;
                    }
                    _optimize() {
                        const fnArray = this.queue.fnArray;
                        let i = this.lastProcessed, ii = fnArray.length;
                        let state = this.state;
                        let match = this.match;
                        if (!state && !match && i + 1 === ii && !InitialState[fnArray[i]]) {
                            this.lastProcessed = ii;
                            return;
                        }
                        const context = this.context;
                        while(i < ii){
                            if (match) {
                                const iterate = (0, match.iterateFn)(context, i);
                                if (iterate) {
                                    i++;
                                    continue;
                                }
                                i = (0, match.processFn)(context, i + 1);
                                ii = fnArray.length;
                                match = null;
                                state = null;
                                if (i >= ii) break;
                            }
                            state = (state || InitialState)[fnArray[i]];
                            if (!state || Array.isArray(state)) {
                                i++;
                                continue;
                            }
                            context.iCurr = i;
                            i++;
                            if (state.checkFn && !(0, state.checkFn)(context)) {
                                state = null;
                                continue;
                            }
                            match = state;
                            state = null;
                        }
                        this.state = state;
                        this.match = match;
                        this.lastProcessed = i;
                    }
                    flush() {
                        while(this.match){
                            const length = this.queue.fnArray.length;
                            this.lastProcessed = (0, this.match.processFn)(this.context, length);
                            this.match = null;
                            this.state = null;
                            this._optimize();
                        }
                    }
                    reset() {
                        this.state = null;
                        this.match = null;
                        this.lastProcessed = 0;
                    }
                }
                class OperatorList {
                    static CHUNK_SIZE = 1000;
                    static CHUNK_SIZE_ABOUT = this.CHUNK_SIZE - 5;
                    constructor(intent = 0, streamSink){
                        this._streamSink = streamSink;
                        this.fnArray = [];
                        this.argsArray = [];
                        this.optimizer = streamSink && !(intent & _util.RenderingIntentFlag.OPLIST) ? new QueueOptimizer(this) : new NullOptimizer(this);
                        this.dependencies = new Set();
                        this._totalLength = 0;
                        this.weight = 0;
                        this._resolved = streamSink ? null : Promise.resolve();
                    }
                    set isOffscreenCanvasSupported(value) {
                        this.optimizer.isOffscreenCanvasSupported = value;
                    }
                    get length() {
                        return this.argsArray.length;
                    }
                    get ready() {
                        return this._resolved || this._streamSink.ready;
                    }
                    get totalLength() {
                        return this._totalLength + this.length;
                    }
                    addOp(fn, args) {
                        this.optimizer.push(fn, args);
                        this.weight++;
                        if (this._streamSink) {
                            if (this.weight >= OperatorList.CHUNK_SIZE) this.flush();
                            else if (this.weight >= OperatorList.CHUNK_SIZE_ABOUT && (fn === _util.OPS.restore || fn === _util.OPS.endText)) this.flush();
                        }
                    }
                    addImageOps(fn, args, optionalContent) {
                        if (optionalContent !== undefined) this.addOp(_util.OPS.beginMarkedContentProps, [
                            "OC",
                            optionalContent
                        ]);
                        this.addOp(fn, args);
                        if (optionalContent !== undefined) this.addOp(_util.OPS.endMarkedContent, []);
                    }
                    addDependency(dependency) {
                        if (this.dependencies.has(dependency)) return;
                        this.dependencies.add(dependency);
                        this.addOp(_util.OPS.dependency, [
                            dependency
                        ]);
                    }
                    addDependencies(dependencies) {
                        for (const dependency of dependencies)this.addDependency(dependency);
                    }
                    addOpList(opList) {
                        if (!(opList instanceof OperatorList)) {
                            (0, _util.warn)('addOpList - ignoring invalid "opList" parameter.');
                            return;
                        }
                        for (const dependency of opList.dependencies)this.dependencies.add(dependency);
                        for(let i = 0, ii = opList.length; i < ii; i++)this.addOp(opList.fnArray[i], opList.argsArray[i]);
                    }
                    getIR() {
                        return {
                            fnArray: this.fnArray,
                            argsArray: this.argsArray,
                            length: this.length
                        };
                    }
                    get _transfers() {
                        const transfers = [];
                        const { fnArray: fnArray, argsArray: argsArray, length: length } = this;
                        for(let i = 0; i < length; i++)switch(fnArray[i]){
                            case _util.OPS.paintInlineImageXObject:
                            case _util.OPS.paintInlineImageXObjectGroup:
                            case _util.OPS.paintImageMaskXObject:
                                const arg = argsArray[i][0];
                                if (!arg.cached && arg.data?.buffer instanceof ArrayBuffer) transfers.push(arg.data.buffer);
                                break;
                        }
                        return transfers;
                    }
                    flush(lastChunk = false, separateAnnots = null) {
                        this.optimizer.flush();
                        const length = this.length;
                        this._totalLength += length;
                        this._streamSink.enqueue({
                            fnArray: this.fnArray,
                            argsArray: this.argsArray,
                            lastChunk: lastChunk,
                            separateAnnots: separateAnnots,
                            length: length
                        }, 1, this._transfers);
                        this.dependencies.clear();
                        this.fnArray.length = 0;
                        this.argsArray.length = 0;
                        this.weight = 0;
                        this.optimizer.reset();
                    }
                }
                exports.OperatorList = OperatorList;
            /***/ },
            /* 65 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFImage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _image_utils = __w_pdfjs_require__(28);
                var _base_stream = __w_pdfjs_require__(5);
                var _colorspace = __w_pdfjs_require__(12);
                var _decode_stream = __w_pdfjs_require__(18);
                var _image_resizer = __w_pdfjs_require__(62);
                var _jpeg_stream = __w_pdfjs_require__(26);
                var _jpx = __w_pdfjs_require__(30);
                var _primitives = __w_pdfjs_require__(4);
                function decodeAndClamp(value, addend, coefficient, max) {
                    value = addend + value * coefficient;
                    if (value < 0) value = 0;
                    else if (value > max) value = max;
                    return value;
                }
                function resizeImageMask(src, bpc, w1, h1, w2, h2) {
                    const length = w2 * h2;
                    let dest;
                    if (bpc <= 8) dest = new Uint8Array(length);
                    else if (bpc <= 16) dest = new Uint16Array(length);
                    else dest = new Uint32Array(length);
                    const xRatio = w1 / w2;
                    const yRatio = h1 / h2;
                    let i, j, py, newIndex = 0, oldIndex;
                    const xScaled = new Uint16Array(w2);
                    const w1Scanline = w1;
                    for(i = 0; i < w2; i++)xScaled[i] = Math.floor(i * xRatio);
                    for(i = 0; i < h2; i++){
                        py = Math.floor(i * yRatio) * w1Scanline;
                        for(j = 0; j < w2; j++){
                            oldIndex = py + xScaled[j];
                            dest[newIndex++] = src[oldIndex];
                        }
                    }
                    return dest;
                }
                class PDFImage {
                    constructor({ xref: xref, res: res, image: image, isInline: isInline = false, smask: smask = null, mask: mask = null, isMask: isMask = false, pdfFunctionFactory: pdfFunctionFactory, localColorSpaceCache: localColorSpaceCache }){
                        this.image = image;
                        const dict = image.dict;
                        const filter = dict.get("F", "Filter");
                        let filterName;
                        if (filter instanceof _primitives.Name) filterName = filter.name;
                        else if (Array.isArray(filter)) {
                            const filterZero = xref.fetchIfRef(filter[0]);
                            if (filterZero instanceof _primitives.Name) filterName = filterZero.name;
                        }
                        switch(filterName){
                            case "JPXDecode":
                                const jpxImage = new _jpx.JpxImage();
                                jpxImage.parseImageProperties(image.stream);
                                image.stream.reset();
                                image.width = jpxImage.width;
                                image.height = jpxImage.height;
                                image.bitsPerComponent = jpxImage.bitsPerComponent;
                                image.numComps = jpxImage.componentsCount;
                                break;
                            case "JBIG2Decode":
                                image.bitsPerComponent = 1;
                                image.numComps = 1;
                                break;
                        }
                        let width = dict.get("W", "Width");
                        let height = dict.get("H", "Height");
                        if (Number.isInteger(image.width) && image.width > 0 && Number.isInteger(image.height) && image.height > 0 && (image.width !== width || image.height !== height)) {
                            (0, _util.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary.");
                            width = image.width;
                            height = image.height;
                        }
                        if (width < 1 || height < 1) throw new _util.FormatError(`Invalid image width: ${width} or height: ${height}`);
                        this.width = width;
                        this.height = height;
                        this.interpolate = dict.get("I", "Interpolate");
                        this.imageMask = dict.get("IM", "ImageMask") || false;
                        this.matte = dict.get("Matte") || false;
                        let bitsPerComponent = image.bitsPerComponent;
                        if (!bitsPerComponent) {
                            bitsPerComponent = dict.get("BPC", "BitsPerComponent");
                            if (!bitsPerComponent) {
                                if (this.imageMask) bitsPerComponent = 1;
                                else throw new _util.FormatError(`Bits per component missing in image: ${this.imageMask}`);
                            }
                        }
                        this.bpc = bitsPerComponent;
                        if (!this.imageMask) {
                            let colorSpace = dict.getRaw("CS") || dict.getRaw("ColorSpace");
                            if (!colorSpace) {
                                (0, _util.info)("JPX images (which do not require color spaces)");
                                switch(image.numComps){
                                    case 1:
                                        colorSpace = _primitives.Name.get("DeviceGray");
                                        break;
                                    case 3:
                                        colorSpace = _primitives.Name.get("DeviceRGB");
                                        break;
                                    case 4:
                                        colorSpace = _primitives.Name.get("DeviceCMYK");
                                        break;
                                    default:
                                        throw new Error(`JPX images with ${image.numComps} color components not supported.`);
                                }
                            }
                            this.colorSpace = _colorspace.ColorSpace.parse({
                                cs: colorSpace,
                                xref: xref,
                                resources: isInline ? res : null,
                                pdfFunctionFactory: pdfFunctionFactory,
                                localColorSpaceCache: localColorSpaceCache
                            });
                            this.numComps = this.colorSpace.numComps;
                        }
                        this.decode = dict.getArray("D", "Decode");
                        this.needsDecode = false;
                        if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, bitsPerComponent) || isMask && !_colorspace.ColorSpace.isDefaultDecode(this.decode, 1))) {
                            this.needsDecode = true;
                            const max = (1 << bitsPerComponent) - 1;
                            this.decodeCoefficients = [];
                            this.decodeAddends = [];
                            const isIndexed = this.colorSpace?.name === "Indexed";
                            for(let i = 0, j = 0; i < this.decode.length; i += 2, ++j){
                                const dmin = this.decode[i];
                                const dmax = this.decode[i + 1];
                                this.decodeCoefficients[j] = isIndexed ? (dmax - dmin) / max : dmax - dmin;
                                this.decodeAddends[j] = isIndexed ? dmin : max * dmin;
                            }
                        }
                        if (smask) this.smask = new PDFImage({
                            xref: xref,
                            res: res,
                            image: smask,
                            isInline: isInline,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                        else if (mask) {
                            if (mask instanceof _base_stream.BaseStream) {
                                const maskDict = mask.dict, imageMask = maskDict.get("IM", "ImageMask");
                                if (!imageMask) (0, _util.warn)("Ignoring /Mask in image without /ImageMask.");
                                else this.mask = new PDFImage({
                                    xref: xref,
                                    res: res,
                                    image: mask,
                                    isInline: isInline,
                                    isMask: true,
                                    pdfFunctionFactory: pdfFunctionFactory,
                                    localColorSpaceCache: localColorSpaceCache
                                });
                            } else this.mask = mask;
                        }
                    }
                    static async buildImage({ xref: xref, res: res, image: image, isInline: isInline = false, pdfFunctionFactory: pdfFunctionFactory, localColorSpaceCache: localColorSpaceCache }) {
                        const imageData = image;
                        let smaskData = null;
                        let maskData = null;
                        const smask = image.dict.get("SMask");
                        const mask = image.dict.get("Mask");
                        if (smask) {
                            if (smask instanceof _base_stream.BaseStream) smaskData = smask;
                            else (0, _util.warn)("Unsupported /SMask format.");
                        } else if (mask) {
                            if (mask instanceof _base_stream.BaseStream || Array.isArray(mask)) maskData = mask;
                            else (0, _util.warn)("Unsupported /Mask format.");
                        }
                        return new PDFImage({
                            xref: xref,
                            res: res,
                            image: imageData,
                            isInline: isInline,
                            smask: smaskData,
                            mask: maskData,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                    }
                    static createRawMask({ imgArray: imgArray, width: width, height: height, imageIsFromDecodeStream: imageIsFromDecodeStream, inverseDecode: inverseDecode, interpolate: interpolate }) {
                        const computedLength = (width + 7 >> 3) * height;
                        const actualLength = imgArray.byteLength;
                        const haveFullData = computedLength === actualLength;
                        let data, i;
                        if (imageIsFromDecodeStream && (!inverseDecode || haveFullData)) data = imgArray;
                        else if (!inverseDecode) data = new Uint8Array(imgArray);
                        else {
                            data = new Uint8Array(computedLength);
                            data.set(imgArray);
                            data.fill(0xff, actualLength);
                        }
                        if (inverseDecode) for(i = 0; i < actualLength; i++)data[i] ^= 0xff;
                        return {
                            data: data,
                            width: width,
                            height: height,
                            interpolate: interpolate
                        };
                    }
                    static async createMask({ imgArray: imgArray, width: width, height: height, imageIsFromDecodeStream: imageIsFromDecodeStream, inverseDecode: inverseDecode, interpolate: interpolate, isOffscreenCanvasSupported: isOffscreenCanvasSupported = false }) {
                        const isSingleOpaquePixel = width === 1 && height === 1 && inverseDecode === (imgArray.length === 0 || !!(imgArray[0] & 128));
                        if (isSingleOpaquePixel) return {
                            isSingleOpaquePixel: isSingleOpaquePixel
                        };
                        if (isOffscreenCanvasSupported) {
                            if (_image_resizer.ImageResizer.needsToBeResized(width, height)) {
                                const data = new Uint8ClampedArray(width * height * 4);
                                (0, _image_utils.convertBlackAndWhiteToRGBA)({
                                    src: imgArray,
                                    dest: data,
                                    width: width,
                                    height: height,
                                    nonBlackColor: 0,
                                    inverseDecode: inverseDecode
                                });
                                return _image_resizer.ImageResizer.createImage({
                                    kind: _util.ImageKind.RGBA_32BPP,
                                    data: data,
                                    width: width,
                                    height: height,
                                    interpolate: interpolate
                                });
                            }
                            const canvas = new OffscreenCanvas(width, height);
                            const ctx = canvas.getContext("2d");
                            const imgData = ctx.createImageData(width, height);
                            (0, _image_utils.convertBlackAndWhiteToRGBA)({
                                src: imgArray,
                                dest: imgData.data,
                                width: width,
                                height: height,
                                nonBlackColor: 0,
                                inverseDecode: inverseDecode
                            });
                            ctx.putImageData(imgData, 0, 0);
                            const bitmap = canvas.transferToImageBitmap();
                            return {
                                data: null,
                                width: width,
                                height: height,
                                interpolate: interpolate,
                                bitmap: bitmap
                            };
                        }
                        return this.createRawMask({
                            imgArray: imgArray,
                            width: width,
                            height: height,
                            inverseDecode: inverseDecode,
                            imageIsFromDecodeStream: imageIsFromDecodeStream,
                            interpolate: interpolate
                        });
                    }
                    get drawWidth() {
                        return Math.max(this.width, this.smask?.width || 0, this.mask?.width || 0);
                    }
                    get drawHeight() {
                        return Math.max(this.height, this.smask?.height || 0, this.mask?.height || 0);
                    }
                    decodeBuffer(buffer) {
                        const bpc = this.bpc;
                        const numComps = this.numComps;
                        const decodeAddends = this.decodeAddends;
                        const decodeCoefficients = this.decodeCoefficients;
                        const max = (1 << bpc) - 1;
                        let i, ii;
                        if (bpc === 1) {
                            for(i = 0, ii = buffer.length; i < ii; i++)buffer[i] = +!buffer[i];
                            return;
                        }
                        let index = 0;
                        for(i = 0, ii = this.width * this.height; i < ii; i++)for(let j = 0; j < numComps; j++){
                            buffer[index] = decodeAndClamp(buffer[index], decodeAddends[j], decodeCoefficients[j], max);
                            index++;
                        }
                    }
                    getComponents(buffer) {
                        const bpc = this.bpc;
                        if (bpc === 8) return buffer;
                        const width = this.width;
                        const height = this.height;
                        const numComps = this.numComps;
                        const length = width * height * numComps;
                        let bufferPos = 0;
                        let output;
                        if (bpc <= 8) output = new Uint8Array(length);
                        else if (bpc <= 16) output = new Uint16Array(length);
                        else output = new Uint32Array(length);
                        const rowComps = width * numComps;
                        const max = (1 << bpc) - 1;
                        let i = 0, ii, buf;
                        if (bpc === 1) {
                            let mask, loop1End, loop2End;
                            for(let j = 0; j < height; j++){
                                loop1End = i + (rowComps & -8);
                                loop2End = i + rowComps;
                                while(i < loop1End){
                                    buf = buffer[bufferPos++];
                                    output[i] = buf >> 7 & 1;
                                    output[i + 1] = buf >> 6 & 1;
                                    output[i + 2] = buf >> 5 & 1;
                                    output[i + 3] = buf >> 4 & 1;
                                    output[i + 4] = buf >> 3 & 1;
                                    output[i + 5] = buf >> 2 & 1;
                                    output[i + 6] = buf >> 1 & 1;
                                    output[i + 7] = buf & 1;
                                    i += 8;
                                }
                                if (i < loop2End) {
                                    buf = buffer[bufferPos++];
                                    mask = 128;
                                    while(i < loop2End){
                                        output[i++] = +!!(buf & mask);
                                        mask >>= 1;
                                    }
                                }
                            }
                        } else {
                            let bits = 0;
                            buf = 0;
                            for(i = 0, ii = length; i < ii; ++i){
                                if (i % rowComps === 0) {
                                    buf = 0;
                                    bits = 0;
                                }
                                while(bits < bpc){
                                    buf = buf << 8 | buffer[bufferPos++];
                                    bits += 8;
                                }
                                const remainingBits = bits - bpc;
                                let value = buf >> remainingBits;
                                if (value < 0) value = 0;
                                else if (value > max) value = max;
                                output[i] = value;
                                buf &= (1 << remainingBits) - 1;
                                bits = remainingBits;
                            }
                        }
                        return output;
                    }
                    fillOpacity(rgbaBuf, width, height, actualHeight, image) {
                        const smask = this.smask;
                        const mask = this.mask;
                        let alphaBuf, sw, sh, i, ii, j;
                        if (smask) {
                            sw = smask.width;
                            sh = smask.height;
                            alphaBuf = new Uint8ClampedArray(sw * sh);
                            smask.fillGrayBuffer(alphaBuf);
                            if (sw !== width || sh !== height) alphaBuf = resizeImageMask(alphaBuf, smask.bpc, sw, sh, width, height);
                        } else if (mask) {
                            if (mask instanceof PDFImage) {
                                sw = mask.width;
                                sh = mask.height;
                                alphaBuf = new Uint8ClampedArray(sw * sh);
                                mask.numComps = 1;
                                mask.fillGrayBuffer(alphaBuf);
                                for(i = 0, ii = sw * sh; i < ii; ++i)alphaBuf[i] = 255 - alphaBuf[i];
                                if (sw !== width || sh !== height) alphaBuf = resizeImageMask(alphaBuf, mask.bpc, sw, sh, width, height);
                            } else if (Array.isArray(mask)) {
                                alphaBuf = new Uint8ClampedArray(width * height);
                                const numComps = this.numComps;
                                for(i = 0, ii = width * height; i < ii; ++i){
                                    let opacity = 0;
                                    const imageOffset = i * numComps;
                                    for(j = 0; j < numComps; ++j){
                                        const color = image[imageOffset + j];
                                        const maskOffset = j * 2;
                                        if (color < mask[maskOffset] || color > mask[maskOffset + 1]) {
                                            opacity = 255;
                                            break;
                                        }
                                    }
                                    alphaBuf[i] = opacity;
                                }
                            } else throw new _util.FormatError("Unknown mask format.");
                        }
                        if (alphaBuf) for(i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4)rgbaBuf[j] = alphaBuf[i];
                        else for(i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4)rgbaBuf[j] = 255;
                    }
                    undoPreblend(buffer, width, height) {
                        const matte = this.smask?.matte;
                        if (!matte) return;
                        const matteRgb = this.colorSpace.getRgb(matte, 0);
                        const matteR = matteRgb[0];
                        const matteG = matteRgb[1];
                        const matteB = matteRgb[2];
                        const length = width * height * 4;
                        for(let i = 0; i < length; i += 4){
                            const alpha = buffer[i + 3];
                            if (alpha === 0) {
                                buffer[i] = 255;
                                buffer[i + 1] = 255;
                                buffer[i + 2] = 255;
                                continue;
                            }
                            const k = 255 / alpha;
                            buffer[i] = (buffer[i] - matteR) * k + matteR;
                            buffer[i + 1] = (buffer[i + 1] - matteG) * k + matteG;
                            buffer[i + 2] = (buffer[i + 2] - matteB) * k + matteB;
                        }
                    }
                    async createImageData(forceRGBA = false, isOffscreenCanvasSupported = false) {
                        const drawWidth = this.drawWidth;
                        const drawHeight = this.drawHeight;
                        const imgData = {
                            width: drawWidth,
                            height: drawHeight,
                            interpolate: this.interpolate,
                            kind: 0,
                            data: null
                        };
                        const numComps = this.numComps;
                        const originalWidth = this.width;
                        const originalHeight = this.height;
                        const bpc = this.bpc;
                        const rowBytes = originalWidth * numComps * bpc + 7 >> 3;
                        const mustBeResized = isOffscreenCanvasSupported && _image_resizer.ImageResizer.needsToBeResized(drawWidth, drawHeight);
                        if (!forceRGBA) {
                            let kind;
                            if (this.colorSpace.name === "DeviceGray" && bpc === 1) kind = _util.ImageKind.GRAYSCALE_1BPP;
                            else if (this.colorSpace.name === "DeviceRGB" && bpc === 8 && !this.needsDecode) kind = _util.ImageKind.RGB_24BPP;
                            if (kind && !this.smask && !this.mask && drawWidth === originalWidth && drawHeight === originalHeight) {
                                const data = this.getImageBytes(originalHeight * rowBytes, {});
                                if (isOffscreenCanvasSupported) {
                                    if (mustBeResized) return _image_resizer.ImageResizer.createImage({
                                        data: data,
                                        kind: kind,
                                        width: drawWidth,
                                        height: drawHeight,
                                        interpolate: this.interpolate
                                    }, this.needsDecode);
                                    return this.createBitmap(kind, originalWidth, originalHeight, data);
                                }
                                imgData.kind = kind;
                                imgData.data = data;
                                if (this.needsDecode) {
                                    (0, _util.assert)(kind === _util.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                                    const buffer = imgData.data;
                                    for(let i = 0, ii = buffer.length; i < ii; i++)buffer[i] ^= 0xff;
                                }
                                return imgData;
                            }
                            if (this.image instanceof _jpeg_stream.JpegStream && !this.smask && !this.mask && !this.needsDecode) {
                                let imageLength = originalHeight * rowBytes;
                                if (isOffscreenCanvasSupported && !mustBeResized) {
                                    let isHandled = false;
                                    switch(this.colorSpace.name){
                                        case "DeviceGray":
                                            imageLength *= 4;
                                            isHandled = true;
                                            break;
                                        case "DeviceRGB":
                                            imageLength = imageLength / 3 * 4;
                                            isHandled = true;
                                            break;
                                        case "DeviceCMYK":
                                            isHandled = true;
                                            break;
                                    }
                                    if (isHandled) {
                                        const rgba = this.getImageBytes(imageLength, {
                                            drawWidth: drawWidth,
                                            drawHeight: drawHeight,
                                            forceRGBA: true
                                        });
                                        return this.createBitmap(_util.ImageKind.RGBA_32BPP, drawWidth, drawHeight, rgba);
                                    }
                                } else switch(this.colorSpace.name){
                                    case "DeviceGray":
                                        imageLength *= 3;
                                    case "DeviceRGB":
                                    case "DeviceCMYK":
                                        imgData.kind = _util.ImageKind.RGB_24BPP;
                                        imgData.data = this.getImageBytes(imageLength, {
                                            drawWidth: drawWidth,
                                            drawHeight: drawHeight,
                                            forceRGB: true
                                        });
                                        if (mustBeResized) return _image_resizer.ImageResizer.createImage(imgData);
                                        return imgData;
                                }
                            }
                        }
                        const imgArray = this.getImageBytes(originalHeight * rowBytes, {
                            internal: true
                        });
                        const actualHeight = 0 | imgArray.length / rowBytes * drawHeight / originalHeight;
                        const comps = this.getComponents(imgArray);
                        let alpha01, maybeUndoPreblend;
                        let canvas, ctx, canvasImgData, data;
                        if (isOffscreenCanvasSupported && !mustBeResized) {
                            canvas = new OffscreenCanvas(drawWidth, drawHeight);
                            ctx = canvas.getContext("2d");
                            canvasImgData = ctx.createImageData(drawWidth, drawHeight);
                            data = canvasImgData.data;
                        }
                        imgData.kind = _util.ImageKind.RGBA_32BPP;
                        if (!forceRGBA && !this.smask && !this.mask) {
                            if (!isOffscreenCanvasSupported || mustBeResized) {
                                imgData.kind = _util.ImageKind.RGB_24BPP;
                                data = new Uint8ClampedArray(drawWidth * drawHeight * 3);
                                alpha01 = 0;
                            } else {
                                const arr = new Uint32Array(data.buffer);
                                arr.fill(_util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff);
                                alpha01 = 1;
                            }
                            maybeUndoPreblend = false;
                        } else {
                            if (!isOffscreenCanvasSupported || mustBeResized) data = new Uint8ClampedArray(drawWidth * drawHeight * 4);
                            alpha01 = 1;
                            maybeUndoPreblend = true;
                            this.fillOpacity(data, drawWidth, drawHeight, actualHeight, comps);
                        }
                        if (this.needsDecode) this.decodeBuffer(comps);
                        this.colorSpace.fillRgb(data, originalWidth, originalHeight, drawWidth, drawHeight, actualHeight, bpc, comps, alpha01);
                        if (maybeUndoPreblend) this.undoPreblend(data, drawWidth, actualHeight);
                        if (isOffscreenCanvasSupported && !mustBeResized) {
                            ctx.putImageData(canvasImgData, 0, 0);
                            const bitmap = canvas.transferToImageBitmap();
                            return {
                                data: null,
                                width: drawWidth,
                                height: drawHeight,
                                bitmap: bitmap,
                                interpolate: this.interpolate
                            };
                        }
                        imgData.data = data;
                        if (mustBeResized) return _image_resizer.ImageResizer.createImage(imgData);
                        return imgData;
                    }
                    fillGrayBuffer(buffer) {
                        const numComps = this.numComps;
                        if (numComps !== 1) throw new _util.FormatError(`Reading gray scale from a color image: ${numComps}`);
                        const width = this.width;
                        const height = this.height;
                        const bpc = this.bpc;
                        const rowBytes = width * numComps * bpc + 7 >> 3;
                        const imgArray = this.getImageBytes(height * rowBytes, {
                            internal: true
                        });
                        const comps = this.getComponents(imgArray);
                        let i, length;
                        if (bpc === 1) {
                            length = width * height;
                            if (this.needsDecode) for(i = 0; i < length; ++i)buffer[i] = comps[i] - 1 & 255;
                            else for(i = 0; i < length; ++i)buffer[i] = -comps[i] & 255;
                            return;
                        }
                        if (this.needsDecode) this.decodeBuffer(comps);
                        length = width * height;
                        const scale = 255 / ((1 << bpc) - 1);
                        for(i = 0; i < length; ++i)buffer[i] = scale * comps[i];
                    }
                    createBitmap(kind, width, height, src) {
                        const canvas = new OffscreenCanvas(width, height);
                        const ctx = canvas.getContext("2d");
                        let imgData;
                        if (kind === _util.ImageKind.RGBA_32BPP) imgData = new ImageData(src, width, height);
                        else {
                            imgData = ctx.createImageData(width, height);
                            (0, _image_utils.convertToRGBA)({
                                kind: kind,
                                src: src,
                                dest: new Uint32Array(imgData.data.buffer),
                                width: width,
                                height: height,
                                inverseDecode: this.needsDecode
                            });
                        }
                        ctx.putImageData(imgData, 0, 0);
                        const bitmap = canvas.transferToImageBitmap();
                        return {
                            data: null,
                            width: width,
                            height: height,
                            bitmap: bitmap,
                            interpolate: this.interpolate
                        };
                    }
                    getImageBytes(length, { drawWidth: drawWidth, drawHeight: drawHeight, forceRGBA: forceRGBA = false, forceRGB: forceRGB = false, internal: internal = false }) {
                        this.image.reset();
                        this.image.drawWidth = drawWidth || this.width;
                        this.image.drawHeight = drawHeight || this.height;
                        this.image.forceRGBA = !!forceRGBA;
                        this.image.forceRGB = !!forceRGB;
                        const imageBytes = this.image.getBytes(length);
                        if (internal || this.image instanceof _decode_stream.DecodeStream) return imageBytes;
                        (0, _util.assert)(imageBytes instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.');
                        return new Uint8Array(imageBytes);
                    }
                }
                exports.PDFImage = PDFImage;
            /***/ },
            /* 66 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Catalog = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _name_number_tree = __w_pdfjs_require__(67);
                var _base_stream = __w_pdfjs_require__(5);
                var _cleanup_helper = __w_pdfjs_require__(68);
                var _colorspace = __w_pdfjs_require__(12);
                var _file_spec = __w_pdfjs_require__(69);
                var _image_utils = __w_pdfjs_require__(59);
                var _metadata_parser = __w_pdfjs_require__(70);
                var _struct_tree = __w_pdfjs_require__(72);
                function fetchDestination(dest) {
                    if (dest instanceof _primitives.Dict) dest = dest.get("D");
                    return Array.isArray(dest) ? dest : null;
                }
                class Catalog {
                    constructor(pdfManager, xref){
                        this.pdfManager = pdfManager;
                        this.xref = xref;
                        this._catDict = xref.getCatalogObj();
                        if (!(this._catDict instanceof _primitives.Dict)) throw new _util.FormatError("Catalog object is not a dictionary.");
                        this.toplevelPagesDict;
                        this._actualNumPages = null;
                        this.fontCache = new _primitives.RefSetCache();
                        this.builtInCMapCache = new Map();
                        this.standardFontDataCache = new Map();
                        this.globalImageCache = new _image_utils.GlobalImageCache();
                        this.pageKidsCountCache = new _primitives.RefSetCache();
                        this.pageIndexCache = new _primitives.RefSetCache();
                        this.nonBlendModesSet = new _primitives.RefSet();
                        this.systemFontCache = new Map();
                    }
                    cloneDict() {
                        return this._catDict.clone();
                    }
                    get version() {
                        const version = this._catDict.get("Version");
                        if (version instanceof _primitives.Name) {
                            if (_core_utils.PDF_VERSION_REGEXP.test(version.name)) return (0, _util.shadow)(this, "version", version.name);
                            (0, _util.warn)(`Invalid PDF catalog version: ${version.name}`);
                        }
                        return (0, _util.shadow)(this, "version", null);
                    }
                    get lang() {
                        const lang = this._catDict.get("Lang");
                        return (0, _util.shadow)(this, "lang", typeof lang === "string" ? (0, _util.stringToPDFString)(lang) : null);
                    }
                    get needsRendering() {
                        const needsRendering = this._catDict.get("NeedsRendering");
                        return (0, _util.shadow)(this, "needsRendering", typeof needsRendering === "boolean" ? needsRendering : false);
                    }
                    get collection() {
                        let collection = null;
                        try {
                            const obj = this._catDict.get("Collection");
                            if (obj instanceof _primitives.Dict && obj.size > 0) collection = obj;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.info)("Cannot fetch Collection entry; assuming no collection is present.");
                        }
                        return (0, _util.shadow)(this, "collection", collection);
                    }
                    get acroForm() {
                        let acroForm = null;
                        try {
                            const obj = this._catDict.get("AcroForm");
                            if (obj instanceof _primitives.Dict && obj.size > 0) acroForm = obj;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
                        }
                        return (0, _util.shadow)(this, "acroForm", acroForm);
                    }
                    get acroFormRef() {
                        const value = this._catDict.getRaw("AcroForm");
                        return (0, _util.shadow)(this, "acroFormRef", value instanceof _primitives.Ref ? value : null);
                    }
                    get metadata() {
                        const streamRef = this._catDict.getRaw("Metadata");
                        if (!(streamRef instanceof _primitives.Ref)) return (0, _util.shadow)(this, "metadata", null);
                        let metadata = null;
                        try {
                            const stream = this.xref.fetch(streamRef, !this.xref.encrypt?.encryptMetadata);
                            if (stream instanceof _base_stream.BaseStream && stream.dict instanceof _primitives.Dict) {
                                const type = stream.dict.get("Type");
                                const subtype = stream.dict.get("Subtype");
                                if ((0, _primitives.isName)(type, "Metadata") && (0, _primitives.isName)(subtype, "XML")) {
                                    const data = (0, _util.stringToUTF8String)(stream.getString());
                                    if (data) metadata = new _metadata_parser.MetadataParser(data).serializable;
                                }
                            }
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.info)(`Skipping invalid Metadata: "${ex}".`);
                        }
                        return (0, _util.shadow)(this, "metadata", metadata);
                    }
                    get markInfo() {
                        let markInfo = null;
                        try {
                            markInfo = this._readMarkInfo();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read mark info.");
                        }
                        return (0, _util.shadow)(this, "markInfo", markInfo);
                    }
                    _readMarkInfo() {
                        const obj = this._catDict.get("MarkInfo");
                        if (!(obj instanceof _primitives.Dict)) return null;
                        const markInfo = {
                            Marked: false,
                            UserProperties: false,
                            Suspects: false
                        };
                        for(const key in markInfo){
                            const value = obj.get(key);
                            if (typeof value === "boolean") markInfo[key] = value;
                        }
                        return markInfo;
                    }
                    get structTreeRoot() {
                        let structTree = null;
                        try {
                            structTree = this._readStructTreeRoot();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable read to structTreeRoot info.");
                        }
                        return (0, _util.shadow)(this, "structTreeRoot", structTree);
                    }
                    _readStructTreeRoot() {
                        const rawObj = this._catDict.getRaw("StructTreeRoot");
                        const obj = this.xref.fetchIfRef(rawObj);
                        if (!(obj instanceof _primitives.Dict)) return null;
                        const root = new _struct_tree.StructTreeRoot(obj, rawObj);
                        root.init();
                        return root;
                    }
                    get toplevelPagesDict() {
                        const pagesObj = this._catDict.get("Pages");
                        if (!(pagesObj instanceof _primitives.Dict)) throw new _util.FormatError("Invalid top-level pages dictionary.");
                        return (0, _util.shadow)(this, "toplevelPagesDict", pagesObj);
                    }
                    get documentOutline() {
                        let obj = null;
                        try {
                            obj = this._readDocumentOutline();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read document outline.");
                        }
                        return (0, _util.shadow)(this, "documentOutline", obj);
                    }
                    _readDocumentOutline() {
                        let obj = this._catDict.get("Outlines");
                        if (!(obj instanceof _primitives.Dict)) return null;
                        obj = obj.getRaw("First");
                        if (!(obj instanceof _primitives.Ref)) return null;
                        const root = {
                            items: []
                        };
                        const queue = [
                            {
                                obj: obj,
                                parent: root
                            }
                        ];
                        const processed = new _primitives.RefSet();
                        processed.put(obj);
                        const xref = this.xref, blackColor = new Uint8ClampedArray(3);
                        while(queue.length > 0){
                            const i = queue.shift();
                            const outlineDict = xref.fetchIfRef(i.obj);
                            if (outlineDict === null) continue;
                            if (!outlineDict.has("Title")) throw new _util.FormatError("Invalid outline item encountered.");
                            const data = {
                                url: null,
                                dest: null,
                                action: null
                            };
                            Catalog.parseDestDictionary({
                                destDict: outlineDict,
                                resultObj: data,
                                docBaseUrl: this.baseUrl,
                                docAttachments: this.attachments
                            });
                            const title = outlineDict.get("Title");
                            const flags = outlineDict.get("F") || 0;
                            const color = outlineDict.getArray("C");
                            const count = outlineDict.get("Count");
                            let rgbColor = blackColor;
                            if (Array.isArray(color) && color.length === 3 && (color[0] !== 0 || color[1] !== 0 || color[2] !== 0)) rgbColor = _colorspace.ColorSpace.singletons.rgb.getRgb(color, 0);
                            const outlineItem = {
                                action: data.action,
                                attachment: data.attachment,
                                dest: data.dest,
                                url: data.url,
                                unsafeUrl: data.unsafeUrl,
                                newWindow: data.newWindow,
                                setOCGState: data.setOCGState,
                                title: (0, _util.stringToPDFString)(title),
                                color: rgbColor,
                                count: Number.isInteger(count) ? count : undefined,
                                bold: !!(flags & 2),
                                italic: !!(flags & 1),
                                items: []
                            };
                            i.parent.items.push(outlineItem);
                            obj = outlineDict.getRaw("First");
                            if (obj instanceof _primitives.Ref && !processed.has(obj)) {
                                queue.push({
                                    obj: obj,
                                    parent: outlineItem
                                });
                                processed.put(obj);
                            }
                            obj = outlineDict.getRaw("Next");
                            if (obj instanceof _primitives.Ref && !processed.has(obj)) {
                                queue.push({
                                    obj: obj,
                                    parent: i.parent
                                });
                                processed.put(obj);
                            }
                        }
                        return root.items.length > 0 ? root.items : null;
                    }
                    get permissions() {
                        let permissions = null;
                        try {
                            permissions = this._readPermissions();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read permissions.");
                        }
                        return (0, _util.shadow)(this, "permissions", permissions);
                    }
                    _readPermissions() {
                        const encrypt = this.xref.trailer.get("Encrypt");
                        if (!(encrypt instanceof _primitives.Dict)) return null;
                        let flags = encrypt.get("P");
                        if (typeof flags !== "number") return null;
                        flags += 2 ** 32;
                        const permissions = [];
                        for(const key in _util.PermissionFlag){
                            const value = _util.PermissionFlag[key];
                            if (flags & value) permissions.push(value);
                        }
                        return permissions;
                    }
                    get optionalContentConfig() {
                        let config = null;
                        try {
                            const properties = this._catDict.get("OCProperties");
                            if (!properties) return (0, _util.shadow)(this, "optionalContentConfig", null);
                            const defaultConfig = properties.get("D");
                            if (!defaultConfig) return (0, _util.shadow)(this, "optionalContentConfig", null);
                            const groupsData = properties.get("OCGs");
                            if (!Array.isArray(groupsData)) return (0, _util.shadow)(this, "optionalContentConfig", null);
                            const groups = [];
                            const groupRefs = [];
                            for (const groupRef of groupsData){
                                if (!(groupRef instanceof _primitives.Ref)) continue;
                                groupRefs.push(groupRef);
                                const group = this.xref.fetchIfRef(groupRef);
                                groups.push({
                                    id: groupRef.toString(),
                                    name: typeof group.get("Name") === "string" ? (0, _util.stringToPDFString)(group.get("Name")) : null,
                                    intent: typeof group.get("Intent") === "string" ? (0, _util.stringToPDFString)(group.get("Intent")) : null
                                });
                            }
                            config = this._readOptionalContentConfig(defaultConfig, groupRefs);
                            config.groups = groups;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`Unable to read optional content config: ${ex}`);
                        }
                        return (0, _util.shadow)(this, "optionalContentConfig", config);
                    }
                    _readOptionalContentConfig(config, contentGroupRefs) {
                        function parseOnOff(refs) {
                            const onParsed = [];
                            if (Array.isArray(refs)) for (const value of refs){
                                if (!(value instanceof _primitives.Ref)) continue;
                                if (contentGroupRefs.includes(value)) onParsed.push(value.toString());
                            }
                            return onParsed;
                        }
                        function parseOrder(refs, nestedLevels = 0) {
                            if (!Array.isArray(refs)) return null;
                            const order = [];
                            for (const value of refs){
                                if (value instanceof _primitives.Ref && contentGroupRefs.includes(value)) {
                                    parsedOrderRefs.put(value);
                                    order.push(value.toString());
                                    continue;
                                }
                                const nestedOrder = parseNestedOrder(value, nestedLevels);
                                if (nestedOrder) order.push(nestedOrder);
                            }
                            if (nestedLevels > 0) return order;
                            const hiddenGroups = [];
                            for (const groupRef of contentGroupRefs){
                                if (parsedOrderRefs.has(groupRef)) continue;
                                hiddenGroups.push(groupRef.toString());
                            }
                            if (hiddenGroups.length) order.push({
                                name: null,
                                order: hiddenGroups
                            });
                            return order;
                        }
                        function parseNestedOrder(ref, nestedLevels) {
                            if (++nestedLevels > MAX_NESTED_LEVELS) {
                                (0, _util.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS.");
                                return null;
                            }
                            const value = xref.fetchIfRef(ref);
                            if (!Array.isArray(value)) return null;
                            const nestedName = xref.fetchIfRef(value[0]);
                            if (typeof nestedName !== "string") return null;
                            const nestedOrder = parseOrder(value.slice(1), nestedLevels);
                            if (!nestedOrder || !nestedOrder.length) return null;
                            return {
                                name: (0, _util.stringToPDFString)(nestedName),
                                order: nestedOrder
                            };
                        }
                        const xref = this.xref, parsedOrderRefs = new _primitives.RefSet(), MAX_NESTED_LEVELS = 10;
                        return {
                            name: typeof config.get("Name") === "string" ? (0, _util.stringToPDFString)(config.get("Name")) : null,
                            creator: typeof config.get("Creator") === "string" ? (0, _util.stringToPDFString)(config.get("Creator")) : null,
                            baseState: config.get("BaseState") instanceof _primitives.Name ? config.get("BaseState").name : null,
                            on: parseOnOff(config.get("ON")),
                            off: parseOnOff(config.get("OFF")),
                            order: parseOrder(config.get("Order")),
                            groups: null
                        };
                    }
                    setActualNumPages(num = null) {
                        this._actualNumPages = num;
                    }
                    get hasActualNumPages() {
                        return this._actualNumPages !== null;
                    }
                    get _pagesCount() {
                        const obj = this.toplevelPagesDict.get("Count");
                        if (!Number.isInteger(obj)) throw new _util.FormatError("Page count in top-level pages dictionary is not an integer.");
                        return (0, _util.shadow)(this, "_pagesCount", obj);
                    }
                    get numPages() {
                        return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
                    }
                    get destinations() {
                        const obj = this._readDests(), dests = Object.create(null);
                        if (obj instanceof _name_number_tree.NameTree) for (const [key, value] of obj.getAll()){
                            const dest = fetchDestination(value);
                            if (dest) dests[(0, _util.stringToPDFString)(key)] = dest;
                        }
                        else if (obj instanceof _primitives.Dict) obj.forEach(function(key, value) {
                            const dest = fetchDestination(value);
                            if (dest) dests[key] = dest;
                        });
                        return (0, _util.shadow)(this, "destinations", dests);
                    }
                    getDestination(id) {
                        const obj = this._readDests();
                        if (obj instanceof _name_number_tree.NameTree) {
                            const dest = fetchDestination(obj.get(id));
                            if (dest) return dest;
                            const allDest = this.destinations[id];
                            if (allDest) {
                                (0, _util.warn)(`Found "${id}" at an incorrect position in the NameTree.`);
                                return allDest;
                            }
                        } else if (obj instanceof _primitives.Dict) {
                            const dest = fetchDestination(obj.get(id));
                            if (dest) return dest;
                        }
                        return null;
                    }
                    _readDests() {
                        const obj = this._catDict.get("Names");
                        if (obj?.has("Dests")) return new _name_number_tree.NameTree(obj.getRaw("Dests"), this.xref);
                        else if (this._catDict.has("Dests")) return this._catDict.get("Dests");
                        return undefined;
                    }
                    get pageLabels() {
                        let obj = null;
                        try {
                            obj = this._readPageLabels();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read page labels.");
                        }
                        return (0, _util.shadow)(this, "pageLabels", obj);
                    }
                    _readPageLabels() {
                        const obj = this._catDict.getRaw("PageLabels");
                        if (!obj) return null;
                        const pageLabels = new Array(this.numPages);
                        let style = null, prefix = "";
                        const numberTree = new _name_number_tree.NumberTree(obj, this.xref);
                        const nums = numberTree.getAll();
                        let currentLabel = "", currentIndex = 1;
                        for(let i = 0, ii = this.numPages; i < ii; i++){
                            const labelDict = nums.get(i);
                            if (labelDict !== undefined) {
                                if (!(labelDict instanceof _primitives.Dict)) throw new _util.FormatError("PageLabel is not a dictionary.");
                                if (labelDict.has("Type") && !(0, _primitives.isName)(labelDict.get("Type"), "PageLabel")) throw new _util.FormatError("Invalid type in PageLabel dictionary.");
                                if (labelDict.has("S")) {
                                    const s = labelDict.get("S");
                                    if (!(s instanceof _primitives.Name)) throw new _util.FormatError("Invalid style in PageLabel dictionary.");
                                    style = s.name;
                                } else style = null;
                                if (labelDict.has("P")) {
                                    const p = labelDict.get("P");
                                    if (typeof p !== "string") throw new _util.FormatError("Invalid prefix in PageLabel dictionary.");
                                    prefix = (0, _util.stringToPDFString)(p);
                                } else prefix = "";
                                if (labelDict.has("St")) {
                                    const st = labelDict.get("St");
                                    if (!(Number.isInteger(st) && st >= 1)) throw new _util.FormatError("Invalid start in PageLabel dictionary.");
                                    currentIndex = st;
                                } else currentIndex = 1;
                            }
                            switch(style){
                                case "D":
                                    currentLabel = currentIndex;
                                    break;
                                case "R":
                                case "r":
                                    currentLabel = (0, _core_utils.toRomanNumerals)(currentIndex, style === "r");
                                    break;
                                case "A":
                                case "a":
                                    const LIMIT = 26;
                                    const A_UPPER_CASE = 0x41, A_LOWER_CASE = 0x61;
                                    const baseCharCode = style === "a" ? A_LOWER_CASE : A_UPPER_CASE;
                                    const letterIndex = currentIndex - 1;
                                    const character = String.fromCharCode(baseCharCode + letterIndex % LIMIT);
                                    currentLabel = character.repeat(Math.floor(letterIndex / LIMIT) + 1);
                                    break;
                                default:
                                    if (style) throw new _util.FormatError(`Invalid style "${style}" in PageLabel dictionary.`);
                                    currentLabel = "";
                            }
                            pageLabels[i] = prefix + currentLabel;
                            currentIndex++;
                        }
                        return pageLabels;
                    }
                    get pageLayout() {
                        const obj = this._catDict.get("PageLayout");
                        let pageLayout = "";
                        if (obj instanceof _primitives.Name) switch(obj.name){
                            case "SinglePage":
                            case "OneColumn":
                            case "TwoColumnLeft":
                            case "TwoColumnRight":
                            case "TwoPageLeft":
                            case "TwoPageRight":
                                pageLayout = obj.name;
                        }
                        return (0, _util.shadow)(this, "pageLayout", pageLayout);
                    }
                    get pageMode() {
                        const obj = this._catDict.get("PageMode");
                        let pageMode = "UseNone";
                        if (obj instanceof _primitives.Name) switch(obj.name){
                            case "UseNone":
                            case "UseOutlines":
                            case "UseThumbs":
                            case "FullScreen":
                            case "UseOC":
                            case "UseAttachments":
                                pageMode = obj.name;
                        }
                        return (0, _util.shadow)(this, "pageMode", pageMode);
                    }
                    get viewerPreferences() {
                        const obj = this._catDict.get("ViewerPreferences");
                        if (!(obj instanceof _primitives.Dict)) return (0, _util.shadow)(this, "viewerPreferences", null);
                        let prefs = null;
                        for (const key of obj.getKeys()){
                            const value = obj.get(key);
                            let prefValue;
                            switch(key){
                                case "HideToolbar":
                                case "HideMenubar":
                                case "HideWindowUI":
                                case "FitWindow":
                                case "CenterWindow":
                                case "DisplayDocTitle":
                                case "PickTrayByPDFSize":
                                    if (typeof value === "boolean") prefValue = value;
                                    break;
                                case "NonFullScreenPageMode":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "UseNone":
                                        case "UseOutlines":
                                        case "UseThumbs":
                                        case "UseOC":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "UseNone";
                                    }
                                    break;
                                case "Direction":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "L2R":
                                        case "R2L":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "L2R";
                                    }
                                    break;
                                case "ViewArea":
                                case "ViewClip":
                                case "PrintArea":
                                case "PrintClip":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "MediaBox":
                                        case "CropBox":
                                        case "BleedBox":
                                        case "TrimBox":
                                        case "ArtBox":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "CropBox";
                                    }
                                    break;
                                case "PrintScaling":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "None":
                                        case "AppDefault":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "AppDefault";
                                    }
                                    break;
                                case "Duplex":
                                    if (value instanceof _primitives.Name) switch(value.name){
                                        case "Simplex":
                                        case "DuplexFlipShortEdge":
                                        case "DuplexFlipLongEdge":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "None";
                                    }
                                    break;
                                case "PrintPageRange":
                                    if (Array.isArray(value) && value.length % 2 === 0) {
                                        const isValid = value.every((page, i, arr)=>{
                                            return Number.isInteger(page) && page > 0 && (i === 0 || page >= arr[i - 1]) && page <= this.numPages;
                                        });
                                        if (isValid) prefValue = value;
                                    }
                                    break;
                                case "NumCopies":
                                    if (Number.isInteger(value) && value > 0) prefValue = value;
                                    break;
                                default:
                                    (0, _util.warn)(`Ignoring non-standard key in ViewerPreferences: ${key}.`);
                                    continue;
                            }
                            if (prefValue === undefined) {
                                (0, _util.warn)(`Bad value, for key "${key}", in ViewerPreferences: ${value}.`);
                                continue;
                            }
                            if (!prefs) prefs = Object.create(null);
                            prefs[key] = prefValue;
                        }
                        return (0, _util.shadow)(this, "viewerPreferences", prefs);
                    }
                    get openAction() {
                        const obj = this._catDict.get("OpenAction");
                        const openAction = Object.create(null);
                        if (obj instanceof _primitives.Dict) {
                            const destDict = new _primitives.Dict(this.xref);
                            destDict.set("A", obj);
                            const resultObj = {
                                url: null,
                                dest: null,
                                action: null
                            };
                            Catalog.parseDestDictionary({
                                destDict: destDict,
                                resultObj: resultObj
                            });
                            if (Array.isArray(resultObj.dest)) openAction.dest = resultObj.dest;
                            else if (resultObj.action) openAction.action = resultObj.action;
                        } else if (Array.isArray(obj)) openAction.dest = obj;
                        return (0, _util.shadow)(this, "openAction", (0, _util.objectSize)(openAction) > 0 ? openAction : null);
                    }
                    get attachments() {
                        const obj = this._catDict.get("Names");
                        let attachments = null;
                        if (obj instanceof _primitives.Dict && obj.has("EmbeddedFiles")) {
                            const nameTree = new _name_number_tree.NameTree(obj.getRaw("EmbeddedFiles"), this.xref);
                            for (const [key, value] of nameTree.getAll()){
                                const fs = new _file_spec.FileSpec(value, this.xref);
                                if (!attachments) attachments = Object.create(null);
                                attachments[(0, _util.stringToPDFString)(key)] = fs.serializable;
                            }
                        }
                        return (0, _util.shadow)(this, "attachments", attachments);
                    }
                    get xfaImages() {
                        const obj = this._catDict.get("Names");
                        let xfaImages = null;
                        if (obj instanceof _primitives.Dict && obj.has("XFAImages")) {
                            const nameTree = new _name_number_tree.NameTree(obj.getRaw("XFAImages"), this.xref);
                            for (const [key, value] of nameTree.getAll()){
                                if (!xfaImages) xfaImages = new _primitives.Dict(this.xref);
                                xfaImages.set((0, _util.stringToPDFString)(key), value);
                            }
                        }
                        return (0, _util.shadow)(this, "xfaImages", xfaImages);
                    }
                    _collectJavaScript() {
                        const obj = this._catDict.get("Names");
                        let javaScript = null;
                        function appendIfJavaScriptDict(name, jsDict) {
                            if (!(jsDict instanceof _primitives.Dict)) return;
                            if (!(0, _primitives.isName)(jsDict.get("S"), "JavaScript")) return;
                            let js = jsDict.get("JS");
                            if (js instanceof _base_stream.BaseStream) js = js.getString();
                            else if (typeof js !== "string") return;
                            js = (0, _util.stringToPDFString)(js).replaceAll("\0", "");
                            if (js) (javaScript ||= new Map()).set(name, js);
                        }
                        if (obj instanceof _primitives.Dict && obj.has("JavaScript")) {
                            const nameTree = new _name_number_tree.NameTree(obj.getRaw("JavaScript"), this.xref);
                            for (const [key, value] of nameTree.getAll())appendIfJavaScriptDict((0, _util.stringToPDFString)(key), value);
                        }
                        const openAction = this._catDict.get("OpenAction");
                        if (openAction) appendIfJavaScriptDict("OpenAction", openAction);
                        return javaScript;
                    }
                    get jsActions() {
                        const javaScript = this._collectJavaScript();
                        let actions = (0, _core_utils.collectActions)(this.xref, this._catDict, _util.DocumentActionEventType);
                        if (javaScript) {
                            actions ||= Object.create(null);
                            for (const [key, val] of javaScript)if (key in actions) actions[key].push(val);
                            else actions[key] = [
                                val
                            ];
                        }
                        return (0, _util.shadow)(this, "jsActions", actions);
                    }
                    async fontFallback(id, handler) {
                        const translatedFonts = await Promise.all(this.fontCache);
                        for (const translatedFont of translatedFonts)if (translatedFont.loadedName === id) {
                            translatedFont.fallback(handler);
                            return;
                        }
                    }
                    async cleanup(manuallyTriggered = false) {
                        (0, _cleanup_helper.clearGlobalCaches)();
                        this.globalImageCache.clear(manuallyTriggered);
                        this.pageKidsCountCache.clear();
                        this.pageIndexCache.clear();
                        this.nonBlendModesSet.clear();
                        const translatedFonts = await Promise.all(this.fontCache);
                        for (const { dict: dict } of translatedFonts)delete dict.cacheKey;
                        this.fontCache.clear();
                        this.builtInCMapCache.clear();
                        this.standardFontDataCache.clear();
                        this.systemFontCache.clear();
                    }
                    async getPageDict(pageIndex) {
                        const nodesToVisit = [
                            this.toplevelPagesDict
                        ];
                        const visitedNodes = new _primitives.RefSet();
                        const pagesRef = this._catDict.getRaw("Pages");
                        if (pagesRef instanceof _primitives.Ref) visitedNodes.put(pagesRef);
                        const xref = this.xref, pageKidsCountCache = this.pageKidsCountCache, pageIndexCache = this.pageIndexCache;
                        let currentPageIndex = 0;
                        while(nodesToVisit.length){
                            const currentNode = nodesToVisit.pop();
                            if (currentNode instanceof _primitives.Ref) {
                                const count = pageKidsCountCache.get(currentNode);
                                if (count >= 0 && currentPageIndex + count <= pageIndex) {
                                    currentPageIndex += count;
                                    continue;
                                }
                                if (visitedNodes.has(currentNode)) throw new _util.FormatError("Pages tree contains circular reference.");
                                visitedNodes.put(currentNode);
                                const obj = await xref.fetchAsync(currentNode);
                                if (obj instanceof _primitives.Dict) {
                                    let type = obj.getRaw("Type");
                                    if (type instanceof _primitives.Ref) type = await xref.fetchAsync(type);
                                    if ((0, _primitives.isName)(type, "Page") || !obj.has("Kids")) {
                                        if (!pageKidsCountCache.has(currentNode)) pageKidsCountCache.put(currentNode, 1);
                                        if (!pageIndexCache.has(currentNode)) pageIndexCache.put(currentNode, currentPageIndex);
                                        if (currentPageIndex === pageIndex) return [
                                            obj,
                                            currentNode
                                        ];
                                        currentPageIndex++;
                                        continue;
                                    }
                                }
                                nodesToVisit.push(obj);
                                continue;
                            }
                            if (!(currentNode instanceof _primitives.Dict)) throw new _util.FormatError("Page dictionary kid reference points to wrong type of object.");
                            const { objId: objId } = currentNode;
                            let count = currentNode.getRaw("Count");
                            if (count instanceof _primitives.Ref) count = await xref.fetchAsync(count);
                            if (Number.isInteger(count) && count >= 0) {
                                if (objId && !pageKidsCountCache.has(objId)) pageKidsCountCache.put(objId, count);
                                if (currentPageIndex + count <= pageIndex) {
                                    currentPageIndex += count;
                                    continue;
                                }
                            }
                            let kids = currentNode.getRaw("Kids");
                            if (kids instanceof _primitives.Ref) kids = await xref.fetchAsync(kids);
                            if (!Array.isArray(kids)) {
                                let type = currentNode.getRaw("Type");
                                if (type instanceof _primitives.Ref) type = await xref.fetchAsync(type);
                                if ((0, _primitives.isName)(type, "Page") || !currentNode.has("Kids")) {
                                    if (currentPageIndex === pageIndex) return [
                                        currentNode,
                                        null
                                    ];
                                    currentPageIndex++;
                                    continue;
                                }
                                throw new _util.FormatError("Page dictionary kids object is not an array.");
                            }
                            for(let last = kids.length - 1; last >= 0; last--)nodesToVisit.push(kids[last]);
                        }
                        throw new Error(`Page index ${pageIndex} not found.`);
                    }
                    async getAllPageDicts(recoveryMode = false) {
                        const { ignoreErrors: ignoreErrors } = this.pdfManager.evaluatorOptions;
                        const queue = [
                            {
                                currentNode: this.toplevelPagesDict,
                                posInKids: 0
                            }
                        ];
                        const visitedNodes = new _primitives.RefSet();
                        const pagesRef = this._catDict.getRaw("Pages");
                        if (pagesRef instanceof _primitives.Ref) visitedNodes.put(pagesRef);
                        const map = new Map(), xref = this.xref, pageIndexCache = this.pageIndexCache;
                        let pageIndex = 0;
                        function addPageDict(pageDict, pageRef) {
                            if (pageRef && !pageIndexCache.has(pageRef)) pageIndexCache.put(pageRef, pageIndex);
                            map.set(pageIndex++, [
                                pageDict,
                                pageRef
                            ]);
                        }
                        function addPageError(error) {
                            if (error instanceof _core_utils.XRefEntryException && !recoveryMode) throw error;
                            if (recoveryMode && ignoreErrors && pageIndex === 0) {
                                (0, _util.warn)(`getAllPageDicts - Skipping invalid first page: "${error}".`);
                                error = _primitives.Dict.empty;
                            }
                            map.set(pageIndex++, [
                                error,
                                null
                            ]);
                        }
                        while(queue.length > 0){
                            const queueItem = queue.at(-1);
                            const { currentNode: currentNode, posInKids: posInKids } = queueItem;
                            let kids = currentNode.getRaw("Kids");
                            if (kids instanceof _primitives.Ref) try {
                                kids = await xref.fetchAsync(kids);
                            } catch (ex) {
                                addPageError(ex);
                                break;
                            }
                            if (!Array.isArray(kids)) {
                                addPageError(new _util.FormatError("Page dictionary kids object is not an array."));
                                break;
                            }
                            if (posInKids >= kids.length) {
                                queue.pop();
                                continue;
                            }
                            const kidObj = kids[posInKids];
                            let obj;
                            if (kidObj instanceof _primitives.Ref) {
                                if (visitedNodes.has(kidObj)) {
                                    addPageError(new _util.FormatError("Pages tree contains circular reference."));
                                    break;
                                }
                                visitedNodes.put(kidObj);
                                try {
                                    obj = await xref.fetchAsync(kidObj);
                                } catch (ex) {
                                    addPageError(ex);
                                    break;
                                }
                            } else obj = kidObj;
                            if (!(obj instanceof _primitives.Dict)) {
                                addPageError(new _util.FormatError("Page dictionary kid reference points to wrong type of object."));
                                break;
                            }
                            let type = obj.getRaw("Type");
                            if (type instanceof _primitives.Ref) try {
                                type = await xref.fetchAsync(type);
                            } catch (ex) {
                                addPageError(ex);
                                break;
                            }
                            if ((0, _primitives.isName)(type, "Page") || !obj.has("Kids")) addPageDict(obj, kidObj instanceof _primitives.Ref ? kidObj : null);
                            else queue.push({
                                currentNode: obj,
                                posInKids: 0
                            });
                            queueItem.posInKids++;
                        }
                        return map;
                    }
                    getPageIndex(pageRef) {
                        const cachedPageIndex = this.pageIndexCache.get(pageRef);
                        if (cachedPageIndex !== undefined) return Promise.resolve(cachedPageIndex);
                        const xref = this.xref;
                        function pagesBeforeRef(kidRef) {
                            let total = 0, parentRef;
                            return xref.fetchAsync(kidRef).then(function(node) {
                                if ((0, _primitives.isRefsEqual)(kidRef, pageRef) && !(0, _primitives.isDict)(node, "Page") && !(node instanceof _primitives.Dict && !node.has("Type") && node.has("Contents"))) throw new _util.FormatError("The reference does not point to a /Page dictionary.");
                                if (!node) return null;
                                if (!(node instanceof _primitives.Dict)) throw new _util.FormatError("Node must be a dictionary.");
                                parentRef = node.getRaw("Parent");
                                return node.getAsync("Parent");
                            }).then(function(parent) {
                                if (!parent) return null;
                                if (!(parent instanceof _primitives.Dict)) throw new _util.FormatError("Parent must be a dictionary.");
                                return parent.getAsync("Kids");
                            }).then(function(kids) {
                                if (!kids) return null;
                                const kidPromises = [];
                                let found = false;
                                for (const kid of kids){
                                    if (!(kid instanceof _primitives.Ref)) throw new _util.FormatError("Kid must be a reference.");
                                    if ((0, _primitives.isRefsEqual)(kid, kidRef)) {
                                        found = true;
                                        break;
                                    }
                                    kidPromises.push(xref.fetchAsync(kid).then(function(obj) {
                                        if (!(obj instanceof _primitives.Dict)) throw new _util.FormatError("Kid node must be a dictionary.");
                                        if (obj.has("Count")) total += obj.get("Count");
                                        else total++;
                                    }));
                                }
                                if (!found) throw new _util.FormatError("Kid reference not found in parent's kids.");
                                return Promise.all(kidPromises).then(function() {
                                    return [
                                        total,
                                        parentRef
                                    ];
                                });
                            });
                        }
                        let total = 0;
                        const next = (ref)=>pagesBeforeRef(ref).then((args)=>{
                                if (!args) {
                                    this.pageIndexCache.put(pageRef, total);
                                    return total;
                                }
                                const [count, parentRef] = args;
                                total += count;
                                return next(parentRef);
                            });
                        return next(pageRef);
                    }
                    get baseUrl() {
                        const uri = this._catDict.get("URI");
                        if (uri instanceof _primitives.Dict) {
                            const base = uri.get("Base");
                            if (typeof base === "string") {
                                const absoluteUrl = (0, _util.createValidAbsoluteUrl)(base, null, {
                                    tryConvertEncoding: true
                                });
                                if (absoluteUrl) return (0, _util.shadow)(this, "baseUrl", absoluteUrl.href);
                            }
                        }
                        return (0, _util.shadow)(this, "baseUrl", this.pdfManager.docBaseUrl);
                    }
                    static parseDestDictionary({ destDict: destDict, resultObj: resultObj, docBaseUrl: docBaseUrl = null, docAttachments: docAttachments = null }) {
                        if (!(destDict instanceof _primitives.Dict)) {
                            (0, _util.warn)("parseDestDictionary: `destDict` must be a dictionary.");
                            return;
                        }
                        let action = destDict.get("A"), url, dest;
                        if (!(action instanceof _primitives.Dict)) {
                            if (destDict.has("Dest")) action = destDict.get("Dest");
                            else {
                                action = destDict.get("AA");
                                if (action instanceof _primitives.Dict) {
                                    if (action.has("D")) action = action.get("D");
                                    else if (action.has("U")) action = action.get("U");
                                }
                            }
                        }
                        if (action instanceof _primitives.Dict) {
                            const actionType = action.get("S");
                            if (!(actionType instanceof _primitives.Name)) {
                                (0, _util.warn)("parseDestDictionary: Invalid type in Action dictionary.");
                                return;
                            }
                            const actionName = actionType.name;
                            switch(actionName){
                                case "ResetForm":
                                    const flags = action.get("Flags");
                                    const include = ((typeof flags === "number" ? flags : 0) & 1) === 0;
                                    const fields = [];
                                    const refs = [];
                                    for (const obj of action.get("Fields") || []){
                                        if (obj instanceof _primitives.Ref) refs.push(obj.toString());
                                        else if (typeof obj === "string") fields.push((0, _util.stringToPDFString)(obj));
                                    }
                                    resultObj.resetForm = {
                                        fields: fields,
                                        refs: refs,
                                        include: include
                                    };
                                    break;
                                case "URI":
                                    url = action.get("URI");
                                    if (url instanceof _primitives.Name) url = "/" + url.name;
                                    break;
                                case "GoTo":
                                    dest = action.get("D");
                                    break;
                                case "Launch":
                                case "GoToR":
                                    const urlDict = action.get("F");
                                    if (urlDict instanceof _primitives.Dict) url = urlDict.get("F") || null;
                                    else if (typeof urlDict === "string") url = urlDict;
                                    let remoteDest = action.get("D");
                                    if (remoteDest) {
                                        if (remoteDest instanceof _primitives.Name) remoteDest = remoteDest.name;
                                        if (typeof url === "string") {
                                            const baseUrl = url.split("#")[0];
                                            if (typeof remoteDest === "string") url = baseUrl + "#" + remoteDest;
                                            else if (Array.isArray(remoteDest)) url = baseUrl + "#" + JSON.stringify(remoteDest);
                                        }
                                    }
                                    const newWindow = action.get("NewWindow");
                                    if (typeof newWindow === "boolean") resultObj.newWindow = newWindow;
                                    break;
                                case "GoToE":
                                    const target = action.get("T");
                                    let attachment;
                                    if (docAttachments && target instanceof _primitives.Dict) {
                                        const relationship = target.get("R");
                                        const name = target.get("N");
                                        if ((0, _primitives.isName)(relationship, "C") && typeof name === "string") attachment = docAttachments[(0, _util.stringToPDFString)(name)];
                                    }
                                    if (attachment) resultObj.attachment = attachment;
                                    else (0, _util.warn)(`parseDestDictionary - unimplemented "GoToE" action.`);
                                    break;
                                case "Named":
                                    const namedAction = action.get("N");
                                    if (namedAction instanceof _primitives.Name) resultObj.action = namedAction.name;
                                    break;
                                case "SetOCGState":
                                    const state = action.get("State");
                                    const preserveRB = action.get("PreserveRB");
                                    if (!Array.isArray(state) || state.length === 0) break;
                                    const stateArr = [];
                                    for (const elem of state){
                                        if (elem instanceof _primitives.Name) switch(elem.name){
                                            case "ON":
                                            case "OFF":
                                            case "Toggle":
                                                stateArr.push(elem.name);
                                                break;
                                        }
                                        else if (elem instanceof _primitives.Ref) stateArr.push(elem.toString());
                                    }
                                    if (stateArr.length !== state.length) break;
                                    resultObj.setOCGState = {
                                        state: stateArr,
                                        preserveRB: typeof preserveRB === "boolean" ? preserveRB : true
                                    };
                                    break;
                                case "JavaScript":
                                    const jsAction = action.get("JS");
                                    let js;
                                    if (jsAction instanceof _base_stream.BaseStream) js = jsAction.getString();
                                    else if (typeof jsAction === "string") js = jsAction;
                                    const jsURL = js && (0, _core_utils.recoverJsURL)((0, _util.stringToPDFString)(js));
                                    if (jsURL) {
                                        url = jsURL.url;
                                        resultObj.newWindow = jsURL.newWindow;
                                        break;
                                    }
                                default:
                                    if (actionName === "JavaScript" || actionName === "SubmitForm") break;
                                    (0, _util.warn)(`parseDestDictionary - unsupported action: "${actionName}".`);
                                    break;
                            }
                        } else if (destDict.has("Dest")) dest = destDict.get("Dest");
                        if (typeof url === "string") {
                            const absoluteUrl = (0, _util.createValidAbsoluteUrl)(url, docBaseUrl, {
                                addDefaultProtocol: true,
                                tryConvertEncoding: true
                            });
                            if (absoluteUrl) resultObj.url = absoluteUrl.href;
                            resultObj.unsafeUrl = url;
                        }
                        if (dest) {
                            if (dest instanceof _primitives.Name) dest = dest.name;
                            if (typeof dest === "string") resultObj.dest = (0, _util.stringToPDFString)(dest);
                            else if (Array.isArray(dest)) resultObj.dest = dest;
                        }
                    }
                }
                exports.Catalog = Catalog;
            /***/ },
            /* 67 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NumberTree = exports.NameTree = void 0;
                var _primitives = __w_pdfjs_require__(4);
                var _util = __w_pdfjs_require__(2);
                class NameOrNumberTree {
                    constructor(root, xref, type){
                        if (this.constructor === NameOrNumberTree) (0, _util.unreachable)("Cannot initialize NameOrNumberTree.");
                        this.root = root;
                        this.xref = xref;
                        this._type = type;
                    }
                    getAll() {
                        const map = new Map();
                        if (!this.root) return map;
                        const xref = this.xref;
                        const processed = new _primitives.RefSet();
                        processed.put(this.root);
                        const queue = [
                            this.root
                        ];
                        while(queue.length > 0){
                            const obj = xref.fetchIfRef(queue.shift());
                            if (!(obj instanceof _primitives.Dict)) continue;
                            if (obj.has("Kids")) {
                                const kids = obj.get("Kids");
                                if (!Array.isArray(kids)) continue;
                                for (const kid of kids){
                                    if (processed.has(kid)) throw new _util.FormatError(`Duplicate entry in "${this._type}" tree.`);
                                    queue.push(kid);
                                    processed.put(kid);
                                }
                                continue;
                            }
                            const entries = obj.get(this._type);
                            if (!Array.isArray(entries)) continue;
                            for(let i = 0, ii = entries.length; i < ii; i += 2)map.set(xref.fetchIfRef(entries[i]), xref.fetchIfRef(entries[i + 1]));
                        }
                        return map;
                    }
                    get(key) {
                        if (!this.root) return null;
                        const xref = this.xref;
                        let kidsOrEntries = xref.fetchIfRef(this.root);
                        let loopCount = 0;
                        const MAX_LEVELS = 10;
                        while(kidsOrEntries.has("Kids")){
                            if (++loopCount > MAX_LEVELS) {
                                (0, _util.warn)(`Search depth limit reached for "${this._type}" tree.`);
                                return null;
                            }
                            const kids = kidsOrEntries.get("Kids");
                            if (!Array.isArray(kids)) return null;
                            let l = 0, r = kids.length - 1;
                            while(l <= r){
                                const m = l + r >> 1;
                                const kid = xref.fetchIfRef(kids[m]);
                                const limits = kid.get("Limits");
                                if (key < xref.fetchIfRef(limits[0])) r = m - 1;
                                else if (key > xref.fetchIfRef(limits[1])) l = m + 1;
                                else {
                                    kidsOrEntries = kid;
                                    break;
                                }
                            }
                            if (l > r) return null;
                        }
                        const entries = kidsOrEntries.get(this._type);
                        if (Array.isArray(entries)) {
                            let l = 0, r = entries.length - 2;
                            while(l <= r){
                                const tmp = l + r >> 1, m = tmp + (tmp & 1);
                                const currentKey = xref.fetchIfRef(entries[m]);
                                if (key < currentKey) r = m - 2;
                                else if (key > currentKey) l = m + 2;
                                else return xref.fetchIfRef(entries[m + 1]);
                            }
                        }
                        return null;
                    }
                }
                class NameTree extends NameOrNumberTree {
                    constructor(root, xref){
                        super(root, xref, "Names");
                    }
                }
                exports.NameTree = NameTree;
                class NumberTree extends NameOrNumberTree {
                    constructor(root, xref){
                        super(root, xref, "Nums");
                    }
                }
                exports.NumberTree = NumberTree;
            /***/ },
            /* 68 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearGlobalCaches = clearGlobalCaches;
                var _pattern = __w_pdfjs_require__(50);
                var _primitives = __w_pdfjs_require__(4);
                var _unicode = __w_pdfjs_require__(40);
                function clearGlobalCaches() {
                    (0, _pattern.clearPatternCaches)();
                    (0, _primitives.clearPrimitiveCaches)();
                    (0, _unicode.clearUnicodeCaches)();
                }
            /***/ },
            /* 69 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FileSpec = void 0;
                var _util = __w_pdfjs_require__(2);
                var _base_stream = __w_pdfjs_require__(5);
                var _primitives = __w_pdfjs_require__(4);
                function pickPlatformItem(dict) {
                    if (dict.has("UF")) return dict.get("UF");
                    else if (dict.has("F")) return dict.get("F");
                    else if (dict.has("Unix")) return dict.get("Unix");
                    else if (dict.has("Mac")) return dict.get("Mac");
                    else if (dict.has("DOS")) return dict.get("DOS");
                    return null;
                }
                class FileSpec {
                    constructor(root, xref){
                        if (!(root instanceof _primitives.Dict)) return;
                        this.xref = xref;
                        this.root = root;
                        if (root.has("FS")) this.fs = root.get("FS");
                        this.description = root.has("Desc") ? (0, _util.stringToPDFString)(root.get("Desc")) : "";
                        if (root.has("RF")) (0, _util.warn)("Related file specifications are not supported");
                        this.contentAvailable = true;
                        if (!root.has("EF")) {
                            this.contentAvailable = false;
                            (0, _util.warn)("Non-embedded file specifications are not supported");
                        }
                    }
                    get filename() {
                        if (!this._filename && this.root) {
                            const filename = pickPlatformItem(this.root) || "unnamed";
                            this._filename = (0, _util.stringToPDFString)(filename).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/");
                        }
                        return this._filename;
                    }
                    get content() {
                        if (!this.contentAvailable) return null;
                        if (!this.contentRef && this.root) this.contentRef = pickPlatformItem(this.root.get("EF"));
                        let content = null;
                        if (this.contentRef) {
                            const fileObj = this.xref.fetchIfRef(this.contentRef);
                            if (fileObj instanceof _base_stream.BaseStream) content = fileObj.getBytes();
                            else (0, _util.warn)("Embedded file specification points to non-existing/invalid content");
                        } else (0, _util.warn)("Embedded file specification does not have a content");
                        return content;
                    }
                    get serializable() {
                        return {
                            filename: this.filename,
                            content: this.content
                        };
                    }
                }
                exports.FileSpec = FileSpec;
            /***/ },
            /* 70 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MetadataParser = void 0;
                var _xml_parser = __w_pdfjs_require__(71);
                class MetadataParser {
                    constructor(data){
                        data = this._repair(data);
                        const parser = new _xml_parser.SimpleXMLParser({
                            lowerCaseName: true
                        });
                        const xmlDocument = parser.parseFromString(data);
                        this._metadataMap = new Map();
                        this._data = data;
                        if (xmlDocument) this._parse(xmlDocument);
                    }
                    _repair(data) {
                        return data.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function(all, codes) {
                            const bytes = codes.replaceAll(/\\([0-3])([0-7])([0-7])/g, function(code, d1, d2, d3) {
                                return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
                            }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function(str, name) {
                                switch(name){
                                    case "amp":
                                        return "&";
                                    case "apos":
                                        return "'";
                                    case "gt":
                                        return ">";
                                    case "lt":
                                        return "<";
                                    case "quot":
                                        return '"';
                                }
                                throw new Error(`_repair: ${name} isn't defined.`);
                            });
                            const charBuf = [
                                ">"
                            ];
                            for(let i = 0, ii = bytes.length; i < ii; i += 2){
                                const code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
                                if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) charBuf.push(String.fromCharCode(code));
                                else charBuf.push("&#x" + (0x10000 + code).toString(16).substring(1) + ";");
                            }
                            return charBuf.join("");
                        });
                    }
                    _getSequence(entry) {
                        const name = entry.nodeName;
                        if (name !== "rdf:bag" && name !== "rdf:seq" && name !== "rdf:alt") return null;
                        return entry.childNodes.filter((node)=>node.nodeName === "rdf:li");
                    }
                    _parseArray(entry) {
                        if (!entry.hasChildNodes()) return;
                        const [seqNode] = entry.childNodes;
                        const sequence = this._getSequence(seqNode) || [];
                        this._metadataMap.set(entry.nodeName, sequence.map((node)=>node.textContent.trim()));
                    }
                    _parse(xmlDocument) {
                        let rdf = xmlDocument.documentElement;
                        if (rdf.nodeName !== "rdf:rdf") {
                            rdf = rdf.firstChild;
                            while(rdf && rdf.nodeName !== "rdf:rdf")rdf = rdf.nextSibling;
                        }
                        if (!rdf || rdf.nodeName !== "rdf:rdf" || !rdf.hasChildNodes()) return;
                        for (const desc of rdf.childNodes){
                            if (desc.nodeName !== "rdf:description") continue;
                            for (const entry of desc.childNodes){
                                const name = entry.nodeName;
                                switch(name){
                                    case "#text":
                                        continue;
                                    case "dc:creator":
                                    case "dc:subject":
                                        this._parseArray(entry);
                                        continue;
                                }
                                this._metadataMap.set(name, entry.textContent.trim());
                            }
                        }
                    }
                    get serializable() {
                        return {
                            parsedData: this._metadataMap,
                            rawData: this._data
                        };
                    }
                }
                exports.MetadataParser = MetadataParser;
            /***/ },
            /* 71 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XMLParserErrorCode = exports.XMLParserBase = exports.SimpleXMLParser = exports.SimpleDOMNode = void 0;
                var _core_utils = __w_pdfjs_require__(3);
                const XMLParserErrorCode = {
                    NoError: 0,
                    EndOfDocument: -1,
                    UnterminatedCdat: -2,
                    UnterminatedXmlDeclaration: -3,
                    UnterminatedDoctypeDeclaration: -4,
                    UnterminatedComment: -5,
                    MalformedElement: -6,
                    OutOfMemory: -7,
                    UnterminatedAttributeValue: -8,
                    UnterminatedElement: -9,
                    ElementNeverBegun: -10
                };
                exports.XMLParserErrorCode = XMLParserErrorCode;
                function isWhitespace(s, index) {
                    const ch = s[index];
                    return ch === " " || ch === "\n" || ch === "\r" || ch === "	";
                }
                function isWhitespaceString(s) {
                    for(let i = 0, ii = s.length; i < ii; i++){
                        if (!isWhitespace(s, i)) return false;
                    }
                    return true;
                }
                class XMLParserBase {
                    _resolveEntities(s) {
                        return s.replaceAll(/&([^;]+);/g, (all, entity)=>{
                            if (entity.substring(0, 2) === "#x") return String.fromCodePoint(parseInt(entity.substring(2), 16));
                            else if (entity.substring(0, 1) === "#") return String.fromCodePoint(parseInt(entity.substring(1), 10));
                            switch(entity){
                                case "lt":
                                    return "<";
                                case "gt":
                                    return ">";
                                case "amp":
                                    return "&";
                                case "quot":
                                    return '"';
                                case "apos":
                                    return "'";
                            }
                            return this.onResolveEntity(entity);
                        });
                    }
                    _parseContent(s, start) {
                        const attributes = [];
                        let pos = start;
                        function skipWs() {
                            while(pos < s.length && isWhitespace(s, pos))++pos;
                        }
                        while(pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "/")++pos;
                        const name = s.substring(start, pos);
                        skipWs();
                        while(pos < s.length && s[pos] !== ">" && s[pos] !== "/" && s[pos] !== "?"){
                            skipWs();
                            let attrName = "", attrValue = "";
                            while(pos < s.length && !isWhitespace(s, pos) && s[pos] !== "="){
                                attrName += s[pos];
                                ++pos;
                            }
                            skipWs();
                            if (s[pos] !== "=") return null;
                            ++pos;
                            skipWs();
                            const attrEndChar = s[pos];
                            if (attrEndChar !== '"' && attrEndChar !== "'") return null;
                            const attrEndIndex = s.indexOf(attrEndChar, ++pos);
                            if (attrEndIndex < 0) return null;
                            attrValue = s.substring(pos, attrEndIndex);
                            attributes.push({
                                name: attrName,
                                value: this._resolveEntities(attrValue)
                            });
                            pos = attrEndIndex + 1;
                            skipWs();
                        }
                        return {
                            name: name,
                            attributes: attributes,
                            parsed: pos - start
                        };
                    }
                    _parseProcessingInstruction(s, start) {
                        let pos = start;
                        function skipWs() {
                            while(pos < s.length && isWhitespace(s, pos))++pos;
                        }
                        while(pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "?" && s[pos] !== "/")++pos;
                        const name = s.substring(start, pos);
                        skipWs();
                        const attrStart = pos;
                        while(pos < s.length && (s[pos] !== "?" || s[pos + 1] !== ">"))++pos;
                        const value = s.substring(attrStart, pos);
                        return {
                            name: name,
                            value: value,
                            parsed: pos - start
                        };
                    }
                    parseXml(s) {
                        let i = 0;
                        while(i < s.length){
                            const ch = s[i];
                            let j = i;
                            if (ch === "<") {
                                ++j;
                                const ch2 = s[j];
                                let q;
                                switch(ch2){
                                    case "/":
                                        ++j;
                                        q = s.indexOf(">", j);
                                        if (q < 0) {
                                            this.onError(XMLParserErrorCode.UnterminatedElement);
                                            return;
                                        }
                                        this.onEndElement(s.substring(j, q));
                                        j = q + 1;
                                        break;
                                    case "?":
                                        ++j;
                                        const pi = this._parseProcessingInstruction(s, j);
                                        if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== "?>") {
                                            this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration);
                                            return;
                                        }
                                        this.onPi(pi.name, pi.value);
                                        j += pi.parsed + 2;
                                        break;
                                    case "!":
                                        if (s.substring(j + 1, j + 3) === "--") {
                                            q = s.indexOf("-->", j + 3);
                                            if (q < 0) {
                                                this.onError(XMLParserErrorCode.UnterminatedComment);
                                                return;
                                            }
                                            this.onComment(s.substring(j + 3, q));
                                            j = q + 3;
                                        } else if (s.substring(j + 1, j + 8) === "[CDATA[") {
                                            q = s.indexOf("]]>", j + 8);
                                            if (q < 0) {
                                                this.onError(XMLParserErrorCode.UnterminatedCdat);
                                                return;
                                            }
                                            this.onCdata(s.substring(j + 8, q));
                                            j = q + 3;
                                        } else if (s.substring(j + 1, j + 8) === "DOCTYPE") {
                                            const q2 = s.indexOf("[", j + 8);
                                            let complexDoctype = false;
                                            q = s.indexOf(">", j + 8);
                                            if (q < 0) {
                                                this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                                                return;
                                            }
                                            if (q2 > 0 && q > q2) {
                                                q = s.indexOf("]>", j + 8);
                                                if (q < 0) {
                                                    this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                                                    return;
                                                }
                                                complexDoctype = true;
                                            }
                                            const doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0));
                                            this.onDoctype(doctypeContent);
                                            j = q + (complexDoctype ? 2 : 1);
                                        } else {
                                            this.onError(XMLParserErrorCode.MalformedElement);
                                            return;
                                        }
                                        break;
                                    default:
                                        const content = this._parseContent(s, j);
                                        if (content === null) {
                                            this.onError(XMLParserErrorCode.MalformedElement);
                                            return;
                                        }
                                        let isClosed = false;
                                        if (s.substring(j + content.parsed, j + content.parsed + 2) === "/>") isClosed = true;
                                        else if (s.substring(j + content.parsed, j + content.parsed + 1) !== ">") {
                                            this.onError(XMLParserErrorCode.UnterminatedElement);
                                            return;
                                        }
                                        this.onBeginElement(content.name, content.attributes, isClosed);
                                        j += content.parsed + (isClosed ? 2 : 1);
                                        break;
                                }
                            } else {
                                while(j < s.length && s[j] !== "<")j++;
                                const text = s.substring(i, j);
                                this.onText(this._resolveEntities(text));
                            }
                            i = j;
                        }
                    }
                    onResolveEntity(name) {
                        return `&${name};`;
                    }
                    onPi(name, value) {}
                    onComment(text) {}
                    onCdata(text) {}
                    onDoctype(doctypeContent) {}
                    onText(text) {}
                    onBeginElement(name, attributes, isEmpty) {}
                    onEndElement(name) {}
                    onError(code) {}
                }
                exports.XMLParserBase = XMLParserBase;
                class SimpleDOMNode {
                    constructor(nodeName, nodeValue){
                        this.nodeName = nodeName;
                        this.nodeValue = nodeValue;
                        Object.defineProperty(this, "parentNode", {
                            value: null,
                            writable: true
                        });
                    }
                    get firstChild() {
                        return this.childNodes?.[0];
                    }
                    get nextSibling() {
                        const childNodes = this.parentNode.childNodes;
                        if (!childNodes) return undefined;
                        const index = childNodes.indexOf(this);
                        if (index === -1) return undefined;
                        return childNodes[index + 1];
                    }
                    get textContent() {
                        if (!this.childNodes) return this.nodeValue || "";
                        return this.childNodes.map(function(child) {
                            return child.textContent;
                        }).join("");
                    }
                    get children() {
                        return this.childNodes || [];
                    }
                    hasChildNodes() {
                        return this.childNodes?.length > 0;
                    }
                    searchNode(paths, pos) {
                        if (pos >= paths.length) return this;
                        const component = paths[pos];
                        if (component.name.startsWith("#") && pos < paths.length - 1) return this.searchNode(paths, pos + 1);
                        const stack = [];
                        let node = this;
                        while(true){
                            if (component.name === node.nodeName) {
                                if (component.pos === 0) {
                                    const res = node.searchNode(paths, pos + 1);
                                    if (res !== null) return res;
                                } else if (stack.length === 0) return null;
                                else {
                                    const [parent] = stack.pop();
                                    let siblingPos = 0;
                                    for (const child of parent.childNodes)if (component.name === child.nodeName) {
                                        if (siblingPos === component.pos) return child.searchNode(paths, pos + 1);
                                        siblingPos++;
                                    }
                                    return node.searchNode(paths, pos + 1);
                                }
                            }
                            if (node.childNodes?.length > 0) {
                                stack.push([
                                    node,
                                    0
                                ]);
                                node = node.childNodes[0];
                            } else if (stack.length === 0) return null;
                            else {
                                while(stack.length !== 0){
                                    const [parent, currentPos] = stack.pop();
                                    const newPos = currentPos + 1;
                                    if (newPos < parent.childNodes.length) {
                                        stack.push([
                                            parent,
                                            newPos
                                        ]);
                                        node = parent.childNodes[newPos];
                                        break;
                                    }
                                }
                                if (stack.length === 0) return null;
                            }
                        }
                    }
                    dump(buffer) {
                        if (this.nodeName === "#text") {
                            buffer.push((0, _core_utils.encodeToXmlString)(this.nodeValue));
                            return;
                        }
                        buffer.push(`<${this.nodeName}`);
                        if (this.attributes) for (const attribute of this.attributes)buffer.push(` ${attribute.name}="${(0, _core_utils.encodeToXmlString)(attribute.value)}"`);
                        if (this.hasChildNodes()) {
                            buffer.push(">");
                            for (const child of this.childNodes)child.dump(buffer);
                            buffer.push(`</${this.nodeName}>`);
                        } else if (this.nodeValue) buffer.push(`>${(0, _core_utils.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`);
                        else buffer.push("/>");
                    }
                }
                exports.SimpleDOMNode = SimpleDOMNode;
                class SimpleXMLParser extends XMLParserBase {
                    constructor({ hasAttributes: hasAttributes = false, lowerCaseName: lowerCaseName = false }){
                        super();
                        this._currentFragment = null;
                        this._stack = null;
                        this._errorCode = XMLParserErrorCode.NoError;
                        this._hasAttributes = hasAttributes;
                        this._lowerCaseName = lowerCaseName;
                    }
                    parseFromString(data) {
                        this._currentFragment = [];
                        this._stack = [];
                        this._errorCode = XMLParserErrorCode.NoError;
                        this.parseXml(data);
                        if (this._errorCode !== XMLParserErrorCode.NoError) return undefined;
                        const [documentElement] = this._currentFragment;
                        if (!documentElement) return undefined;
                        return {
                            documentElement: documentElement
                        };
                    }
                    onText(text) {
                        if (isWhitespaceString(text)) return;
                        const node = new SimpleDOMNode("#text", text);
                        this._currentFragment.push(node);
                    }
                    onCdata(text) {
                        const node = new SimpleDOMNode("#text", text);
                        this._currentFragment.push(node);
                    }
                    onBeginElement(name, attributes, isEmpty) {
                        if (this._lowerCaseName) name = name.toLowerCase();
                        const node = new SimpleDOMNode(name);
                        node.childNodes = [];
                        if (this._hasAttributes) node.attributes = attributes;
                        this._currentFragment.push(node);
                        if (isEmpty) return;
                        this._stack.push(this._currentFragment);
                        this._currentFragment = node.childNodes;
                    }
                    onEndElement(name) {
                        this._currentFragment = this._stack.pop() || [];
                        const lastElement = this._currentFragment.at(-1);
                        if (!lastElement) return null;
                        for (const childNode of lastElement.childNodes)childNode.parentNode = lastElement;
                        return lastElement;
                    }
                    onError(code) {
                        this._errorCode = code;
                    }
                }
                exports.SimpleXMLParser = SimpleXMLParser;
            /***/ },
            /* 72 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StructTreeRoot = exports.StructTreePage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _name_number_tree = __w_pdfjs_require__(67);
                var _writer = __w_pdfjs_require__(73);
                const MAX_DEPTH = 40;
                const StructElementType = {
                    PAGE_CONTENT: 1,
                    STREAM_CONTENT: 2,
                    OBJECT: 3,
                    ANNOTATION: 4,
                    ELEMENT: 5
                };
                class StructTreeRoot {
                    constructor(rootDict, rootRef){
                        this.dict = rootDict;
                        this.ref = rootRef instanceof _primitives.Ref ? rootRef : null;
                        this.roleMap = new Map();
                        this.structParentIds = null;
                    }
                    init() {
                        this.readRoleMap();
                    }
                    #addIdToPage(pageRef, id, type) {
                        if (!(pageRef instanceof _primitives.Ref) || id < 0) return;
                        this.structParentIds ||= new _primitives.RefSetCache();
                        let ids = this.structParentIds.get(pageRef);
                        if (!ids) {
                            ids = [];
                            this.structParentIds.put(pageRef, ids);
                        }
                        ids.push([
                            id,
                            type
                        ]);
                    }
                    addAnnotationIdToPage(pageRef, id) {
                        this.#addIdToPage(pageRef, id, StructElementType.ANNOTATION);
                    }
                    readRoleMap() {
                        const roleMapDict = this.dict.get("RoleMap");
                        if (!(roleMapDict instanceof _primitives.Dict)) return;
                        roleMapDict.forEach((key, value)=>{
                            if (!(value instanceof _primitives.Name)) return;
                            this.roleMap.set(key, value.name);
                        });
                    }
                    static async canCreateStructureTree({ catalogRef: catalogRef, pdfManager: pdfManager, newAnnotationsByPage: newAnnotationsByPage }) {
                        if (!(catalogRef instanceof _primitives.Ref)) {
                            (0, _util.warn)("Cannot save the struct tree: no catalog reference.");
                            return false;
                        }
                        let nextKey = 0;
                        let hasNothingToUpdate = true;
                        for (const [pageIndex, elements] of newAnnotationsByPage){
                            const { ref: pageRef } = await pdfManager.getPage(pageIndex);
                            if (!(pageRef instanceof _primitives.Ref)) {
                                (0, _util.warn)(`Cannot save the struct tree: page ${pageIndex} has no ref.`);
                                hasNothingToUpdate = true;
                                break;
                            }
                            for (const element of elements)if (element.accessibilityData?.type) {
                                element.parentTreeId = nextKey++;
                                hasNothingToUpdate = false;
                            }
                        }
                        if (hasNothingToUpdate) {
                            for (const elements of newAnnotationsByPage.values())for (const element of elements)delete element.parentTreeId;
                            return false;
                        }
                        return true;
                    }
                    static async createStructureTree({ newAnnotationsByPage: newAnnotationsByPage, xref: xref, catalogRef: catalogRef, pdfManager: pdfManager, newRefs: newRefs }) {
                        const root = pdfManager.catalog.cloneDict();
                        const structTreeRootRef = xref.getNewTemporaryRef();
                        root.set("StructTreeRoot", structTreeRootRef);
                        const buffer = [];
                        await (0, _writer.writeObject)(catalogRef, root, buffer, xref);
                        newRefs.push({
                            ref: catalogRef,
                            data: buffer.join("")
                        });
                        const structTreeRoot = new _primitives.Dict(xref);
                        structTreeRoot.set("Type", _primitives.Name.get("StructTreeRoot"));
                        const parentTreeRef = xref.getNewTemporaryRef();
                        structTreeRoot.set("ParentTree", parentTreeRef);
                        const kids = [];
                        structTreeRoot.set("K", kids);
                        const parentTree = new _primitives.Dict(xref);
                        const nums = [];
                        parentTree.set("Nums", nums);
                        const nextKey = await this.#writeKids({
                            newAnnotationsByPage: newAnnotationsByPage,
                            structTreeRootRef: structTreeRootRef,
                            kids: kids,
                            nums: nums,
                            xref: xref,
                            pdfManager: pdfManager,
                            newRefs: newRefs,
                            buffer: buffer
                        });
                        structTreeRoot.set("ParentTreeNextKey", nextKey);
                        buffer.length = 0;
                        await (0, _writer.writeObject)(parentTreeRef, parentTree, buffer, xref);
                        newRefs.push({
                            ref: parentTreeRef,
                            data: buffer.join("")
                        });
                        buffer.length = 0;
                        await (0, _writer.writeObject)(structTreeRootRef, structTreeRoot, buffer, xref);
                        newRefs.push({
                            ref: structTreeRootRef,
                            data: buffer.join("")
                        });
                    }
                    async canUpdateStructTree({ pdfManager: pdfManager, newAnnotationsByPage: newAnnotationsByPage }) {
                        if (!this.ref) {
                            (0, _util.warn)("Cannot update the struct tree: no root reference.");
                            return false;
                        }
                        let nextKey = this.dict.get("ParentTreeNextKey");
                        if (!Number.isInteger(nextKey) || nextKey < 0) {
                            (0, _util.warn)("Cannot update the struct tree: invalid next key.");
                            return false;
                        }
                        const parentTree = this.dict.get("ParentTree");
                        if (!(parentTree instanceof _primitives.Dict)) {
                            (0, _util.warn)("Cannot update the struct tree: ParentTree isn't a dict.");
                            return false;
                        }
                        const nums = parentTree.get("Nums");
                        if (!Array.isArray(nums)) {
                            (0, _util.warn)("Cannot update the struct tree: nums isn't an array.");
                            return false;
                        }
                        const { numPages: numPages } = pdfManager.catalog;
                        for (const pageIndex of newAnnotationsByPage.keys()){
                            const { pageDict: pageDict, ref: pageRef } = await pdfManager.getPage(pageIndex);
                            if (!(pageRef instanceof _primitives.Ref)) {
                                (0, _util.warn)(`Cannot save the struct tree: page ${pageIndex} has no ref.`);
                                return false;
                            }
                            const id = pageDict.get("StructParents");
                            if (!Number.isInteger(id) || id < 0 || id >= numPages) {
                                (0, _util.warn)(`Cannot save the struct tree: page ${pageIndex} has no id.`);
                                return false;
                            }
                        }
                        let hasNothingToUpdate = true;
                        for (const [pageIndex, elements] of newAnnotationsByPage){
                            const { pageDict: pageDict } = await pdfManager.getPage(pageIndex);
                            StructTreeRoot.#collectParents({
                                elements: elements,
                                xref: this.dict.xref,
                                pageDict: pageDict,
                                parentTree: parentTree
                            });
                            for (const element of elements)if (element.accessibilityData?.type) {
                                element.parentTreeId = nextKey++;
                                hasNothingToUpdate = false;
                            }
                        }
                        if (hasNothingToUpdate) {
                            for (const elements of newAnnotationsByPage.values())for (const element of elements){
                                delete element.parentTreeId;
                                delete element.structTreeParent;
                            }
                            return false;
                        }
                        return true;
                    }
                    async updateStructureTree({ newAnnotationsByPage: newAnnotationsByPage, pdfManager: pdfManager, newRefs: newRefs }) {
                        const xref = this.dict.xref;
                        const structTreeRoot = this.dict.clone();
                        const structTreeRootRef = this.ref;
                        let parentTreeRef = structTreeRoot.getRaw("ParentTree");
                        let parentTree;
                        if (parentTreeRef instanceof _primitives.Ref) parentTree = xref.fetch(parentTreeRef);
                        else {
                            parentTree = parentTreeRef;
                            parentTreeRef = xref.getNewTemporaryRef();
                            structTreeRoot.set("ParentTree", parentTreeRef);
                        }
                        parentTree = parentTree.clone();
                        let nums = parentTree.getRaw("Nums");
                        let numsRef = null;
                        if (nums instanceof _primitives.Ref) {
                            numsRef = nums;
                            nums = xref.fetch(numsRef);
                        }
                        nums = nums.slice();
                        if (!numsRef) parentTree.set("Nums", nums);
                        let kids = structTreeRoot.getRaw("K");
                        let kidsRef = null;
                        if (kids instanceof _primitives.Ref) {
                            kidsRef = kids;
                            kids = xref.fetch(kidsRef);
                        } else {
                            kidsRef = xref.getNewTemporaryRef();
                            structTreeRoot.set("K", kidsRef);
                        }
                        kids = Array.isArray(kids) ? kids.slice() : [
                            kids
                        ];
                        const buffer = [];
                        const newNextkey = await StructTreeRoot.#writeKids({
                            newAnnotationsByPage: newAnnotationsByPage,
                            structTreeRootRef: structTreeRootRef,
                            kids: kids,
                            nums: nums,
                            xref: xref,
                            pdfManager: pdfManager,
                            newRefs: newRefs,
                            buffer: buffer
                        });
                        structTreeRoot.set("ParentTreeNextKey", newNextkey);
                        buffer.length = 0;
                        await (0, _writer.writeObject)(kidsRef, kids, buffer, xref);
                        newRefs.push({
                            ref: kidsRef,
                            data: buffer.join("")
                        });
                        if (numsRef) {
                            buffer.length = 0;
                            await (0, _writer.writeObject)(numsRef, nums, buffer, xref);
                            newRefs.push({
                                ref: numsRef,
                                data: buffer.join("")
                            });
                        }
                        buffer.length = 0;
                        await (0, _writer.writeObject)(parentTreeRef, parentTree, buffer, xref);
                        newRefs.push({
                            ref: parentTreeRef,
                            data: buffer.join("")
                        });
                        buffer.length = 0;
                        await (0, _writer.writeObject)(structTreeRootRef, structTreeRoot, buffer, xref);
                        newRefs.push({
                            ref: structTreeRootRef,
                            data: buffer.join("")
                        });
                    }
                    static async #writeKids({ newAnnotationsByPage: newAnnotationsByPage, structTreeRootRef: structTreeRootRef, kids: kids, nums: nums, xref: xref, pdfManager: pdfManager, newRefs: newRefs, buffer: buffer }) {
                        const objr = _primitives.Name.get("OBJR");
                        let nextKey = -Infinity;
                        for (const [pageIndex, elements] of newAnnotationsByPage){
                            const { ref: pageRef } = await pdfManager.getPage(pageIndex);
                            for (const { accessibilityData: { type: type, title: title, lang: lang, alt: alt, expanded: expanded, actualText: actualText }, ref: ref, parentTreeId: parentTreeId, structTreeParent: structTreeParent } of elements){
                                nextKey = Math.max(nextKey, parentTreeId);
                                const tagRef = xref.getNewTemporaryRef();
                                const tagDict = new _primitives.Dict(xref);
                                tagDict.set("S", _primitives.Name.get(type));
                                if (title) tagDict.set("T", title);
                                if (lang) tagDict.set("Lang", lang);
                                if (alt) tagDict.set("Alt", alt);
                                if (expanded) tagDict.set("E", expanded);
                                if (actualText) tagDict.set("ActualText", actualText);
                                if (structTreeParent) await this.#updateParentTag({
                                    structTreeParent: structTreeParent,
                                    tagDict: tagDict,
                                    newTagRef: tagRef,
                                    fallbackRef: structTreeRootRef,
                                    xref: xref,
                                    newRefs: newRefs,
                                    buffer: buffer
                                });
                                else tagDict.set("P", structTreeRootRef);
                                const objDict = new _primitives.Dict(xref);
                                tagDict.set("K", objDict);
                                objDict.set("Type", objr);
                                objDict.set("Pg", pageRef);
                                objDict.set("Obj", ref);
                                buffer.length = 0;
                                await (0, _writer.writeObject)(tagRef, tagDict, buffer, xref);
                                newRefs.push({
                                    ref: tagRef,
                                    data: buffer.join("")
                                });
                                nums.push(parentTreeId, tagRef);
                                kids.push(tagRef);
                            }
                        }
                        return nextKey + 1;
                    }
                    static #collectParents({ elements: elements, xref: xref, pageDict: pageDict, parentTree: parentTree }) {
                        const idToElement = new Map();
                        for (const element of elements)if (element.structTreeParentId) {
                            const id = parseInt(element.structTreeParentId.split("_mc")[1], 10);
                            idToElement.set(id, element);
                        }
                        const id = pageDict.get("StructParents");
                        const numberTree = new _name_number_tree.NumberTree(parentTree, xref);
                        const parentArray = numberTree.get(id);
                        if (!Array.isArray(parentArray)) return;
                        const updateElement = (kid, pageKid, kidRef)=>{
                            const element = idToElement.get(kid);
                            if (element) {
                                const parentRef = pageKid.getRaw("P");
                                const parentDict = xref.fetchIfRef(parentRef);
                                if (parentRef instanceof _primitives.Ref && parentDict instanceof _primitives.Dict) element.structTreeParent = {
                                    ref: kidRef,
                                    dict: pageKid
                                };
                                return true;
                            }
                            return false;
                        };
                        for (const kidRef of parentArray){
                            if (!(kidRef instanceof _primitives.Ref)) continue;
                            const pageKid = xref.fetch(kidRef);
                            const k = pageKid.get("K");
                            if (Number.isInteger(k)) {
                                updateElement(k, pageKid, kidRef);
                                continue;
                            }
                            if (!Array.isArray(k)) continue;
                            for (let kid of k){
                                kid = xref.fetchIfRef(kid);
                                if (Number.isInteger(kid) && updateElement(kid, pageKid, kidRef)) break;
                            }
                        }
                    }
                    static async #updateParentTag({ structTreeParent: { ref: ref, dict: dict }, tagDict: tagDict, newTagRef: newTagRef, fallbackRef: fallbackRef, xref: xref, newRefs: newRefs, buffer: buffer }) {
                        const parentRef = dict.getRaw("P");
                        let parentDict = xref.fetchIfRef(parentRef);
                        tagDict.set("P", parentRef);
                        let saveParentDict = false;
                        let parentKids;
                        let parentKidsRef = parentDict.getRaw("K");
                        if (!(parentKidsRef instanceof _primitives.Ref)) {
                            parentKids = parentKidsRef;
                            parentKidsRef = xref.getNewTemporaryRef();
                            parentDict = parentDict.clone();
                            parentDict.set("K", parentKidsRef);
                            saveParentDict = true;
                        } else parentKids = xref.fetch(parentKidsRef);
                        if (Array.isArray(parentKids)) {
                            const index = parentKids.indexOf(ref);
                            if (index >= 0) {
                                parentKids = parentKids.slice();
                                parentKids.splice(index + 1, 0, newTagRef);
                            } else {
                                (0, _util.warn)("Cannot update the struct tree: parent kid not found.");
                                tagDict.set("P", fallbackRef);
                                return;
                            }
                        } else if (parentKids instanceof _primitives.Dict) {
                            parentKids = [
                                parentKidsRef,
                                newTagRef
                            ];
                            parentKidsRef = xref.getNewTemporaryRef();
                            parentDict.set("K", parentKidsRef);
                            saveParentDict = true;
                        }
                        buffer.length = 0;
                        await (0, _writer.writeObject)(parentKidsRef, parentKids, buffer, xref);
                        newRefs.push({
                            ref: parentKidsRef,
                            data: buffer.join("")
                        });
                        if (!saveParentDict) return;
                        buffer.length = 0;
                        await (0, _writer.writeObject)(parentRef, parentDict, buffer, xref);
                        newRefs.push({
                            ref: parentRef,
                            data: buffer.join("")
                        });
                    }
                }
                exports.StructTreeRoot = StructTreeRoot;
                class StructElementNode {
                    constructor(tree, dict){
                        this.tree = tree;
                        this.dict = dict;
                        this.kids = [];
                        this.parseKids();
                    }
                    get role() {
                        const nameObj = this.dict.get("S");
                        const name = nameObj instanceof _primitives.Name ? nameObj.name : "";
                        const { root: root } = this.tree;
                        if (root.roleMap.has(name)) return root.roleMap.get(name);
                        return name;
                    }
                    parseKids() {
                        let pageObjId = null;
                        const objRef = this.dict.getRaw("Pg");
                        if (objRef instanceof _primitives.Ref) pageObjId = objRef.toString();
                        const kids = this.dict.get("K");
                        if (Array.isArray(kids)) for (const kid of kids){
                            const element = this.parseKid(pageObjId, kid);
                            if (element) this.kids.push(element);
                        }
                        else {
                            const element = this.parseKid(pageObjId, kids);
                            if (element) this.kids.push(element);
                        }
                    }
                    parseKid(pageObjId, kid) {
                        if (Number.isInteger(kid)) {
                            if (this.tree.pageDict.objId !== pageObjId) return null;
                            return new StructElement({
                                type: StructElementType.PAGE_CONTENT,
                                mcid: kid,
                                pageObjId: pageObjId
                            });
                        }
                        let kidDict = null;
                        if (kid instanceof _primitives.Ref) kidDict = this.dict.xref.fetch(kid);
                        else if (kid instanceof _primitives.Dict) kidDict = kid;
                        if (!kidDict) return null;
                        const pageRef = kidDict.getRaw("Pg");
                        if (pageRef instanceof _primitives.Ref) pageObjId = pageRef.toString();
                        const type = kidDict.get("Type") instanceof _primitives.Name ? kidDict.get("Type").name : null;
                        if (type === "MCR") {
                            if (this.tree.pageDict.objId !== pageObjId) return null;
                            const kidRef = kidDict.getRaw("Stm");
                            return new StructElement({
                                type: StructElementType.STREAM_CONTENT,
                                refObjId: kidRef instanceof _primitives.Ref ? kidRef.toString() : null,
                                pageObjId: pageObjId,
                                mcid: kidDict.get("MCID")
                            });
                        }
                        if (type === "OBJR") {
                            if (this.tree.pageDict.objId !== pageObjId) return null;
                            const kidRef = kidDict.getRaw("Obj");
                            return new StructElement({
                                type: StructElementType.OBJECT,
                                refObjId: kidRef instanceof _primitives.Ref ? kidRef.toString() : null,
                                pageObjId: pageObjId
                            });
                        }
                        return new StructElement({
                            type: StructElementType.ELEMENT,
                            dict: kidDict
                        });
                    }
                }
                class StructElement {
                    constructor({ type: type, dict: dict = null, mcid: mcid = null, pageObjId: pageObjId = null, refObjId: refObjId = null }){
                        this.type = type;
                        this.dict = dict;
                        this.mcid = mcid;
                        this.pageObjId = pageObjId;
                        this.refObjId = refObjId;
                        this.parentNode = null;
                    }
                }
                class StructTreePage {
                    constructor(structTreeRoot, pageDict){
                        this.root = structTreeRoot;
                        this.rootDict = structTreeRoot ? structTreeRoot.dict : null;
                        this.pageDict = pageDict;
                        this.nodes = [];
                    }
                    parse(pageRef) {
                        if (!this.root || !this.rootDict) return;
                        const parentTree = this.rootDict.get("ParentTree");
                        if (!parentTree) return;
                        const id = this.pageDict.get("StructParents");
                        const ids = pageRef instanceof _primitives.Ref && this.root.structParentIds?.get(pageRef);
                        if (!Number.isInteger(id) && !ids) return;
                        const map = new Map();
                        const numberTree = new _name_number_tree.NumberTree(parentTree, this.rootDict.xref);
                        if (Number.isInteger(id)) {
                            const parentArray = numberTree.get(id);
                            if (Array.isArray(parentArray)) {
                                for (const ref of parentArray)if (ref instanceof _primitives.Ref) this.addNode(this.rootDict.xref.fetch(ref), map);
                            }
                        }
                        if (!ids) return;
                        for (const [elemId, type] of ids){
                            const obj = numberTree.get(elemId);
                            if (obj) {
                                const elem = this.addNode(this.rootDict.xref.fetchIfRef(obj), map);
                                if (elem?.kids?.length === 1 && elem.kids[0].type === StructElementType.OBJECT) elem.kids[0].type = type;
                            }
                        }
                    }
                    addNode(dict, map, level = 0) {
                        if (level > MAX_DEPTH) {
                            (0, _util.warn)("StructTree MAX_DEPTH reached.");
                            return null;
                        }
                        if (map.has(dict)) return map.get(dict);
                        const element = new StructElementNode(this, dict);
                        map.set(dict, element);
                        const parent = dict.get("P");
                        if (!parent || (0, _primitives.isName)(parent.get("Type"), "StructTreeRoot")) {
                            if (!this.addTopLevelNode(dict, element)) map.delete(dict);
                            return element;
                        }
                        const parentNode = this.addNode(parent, map, level + 1);
                        if (!parentNode) return element;
                        let save = false;
                        for (const kid of parentNode.kids)if (kid.type === StructElementType.ELEMENT && kid.dict === dict) {
                            kid.parentNode = element;
                            save = true;
                        }
                        if (!save) map.delete(dict);
                        return element;
                    }
                    addTopLevelNode(dict, element) {
                        const obj = this.rootDict.get("K");
                        if (!obj) return false;
                        if (obj instanceof _primitives.Dict) {
                            if (obj.objId !== dict.objId) return false;
                            this.nodes[0] = element;
                            return true;
                        }
                        if (!Array.isArray(obj)) return true;
                        let save = false;
                        for(let i = 0; i < obj.length; i++){
                            const kidRef = obj[i];
                            if (kidRef?.toString() === dict.objId) {
                                this.nodes[i] = element;
                                save = true;
                            }
                        }
                        return save;
                    }
                    get serializable() {
                        function nodeToSerializable(node, parent, level = 0) {
                            if (level > MAX_DEPTH) {
                                (0, _util.warn)("StructTree too deep to be fully serialized.");
                                return;
                            }
                            const obj = Object.create(null);
                            obj.role = node.role;
                            obj.children = [];
                            parent.children.push(obj);
                            const alt = node.dict.get("Alt");
                            if (typeof alt === "string") obj.alt = (0, _util.stringToPDFString)(alt);
                            const lang = node.dict.get("Lang");
                            if (typeof lang === "string") obj.lang = (0, _util.stringToPDFString)(lang);
                            for (const kid of node.kids){
                                const kidElement = kid.type === StructElementType.ELEMENT ? kid.parentNode : null;
                                if (kidElement) {
                                    nodeToSerializable(kidElement, obj, level + 1);
                                    continue;
                                } else if (kid.type === StructElementType.PAGE_CONTENT || kid.type === StructElementType.STREAM_CONTENT) obj.children.push({
                                    type: "content",
                                    id: `p${kid.pageObjId}_mc${kid.mcid}`
                                });
                                else if (kid.type === StructElementType.OBJECT) obj.children.push({
                                    type: "object",
                                    id: kid.refObjId
                                });
                                else if (kid.type === StructElementType.ANNOTATION) obj.children.push({
                                    type: "annotation",
                                    id: `${_util.AnnotationPrefix}${kid.refObjId}`
                                });
                            }
                        }
                        const root = Object.create(null);
                        root.children = [];
                        root.role = "Root";
                        for (const child of this.nodes){
                            if (!child) continue;
                            nodeToSerializable(child, root);
                        }
                        return root;
                    }
                }
                exports.StructTreePage = StructTreePage;
            /***/ },
            /* 73 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.incrementalUpdate = incrementalUpdate;
                exports.writeDict = writeDict;
                exports.writeObject = writeObject;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _core_utils = __w_pdfjs_require__(3);
                var _xml_parser = __w_pdfjs_require__(71);
                var _base_stream = __w_pdfjs_require__(5);
                var _crypto = __w_pdfjs_require__(74);
                async function writeObject(ref, obj, buffer, { encrypt: encrypt = null }) {
                    const transform = encrypt?.createCipherTransform(ref.num, ref.gen);
                    buffer.push(`${ref.num} ${ref.gen} obj\n`);
                    if (obj instanceof _primitives.Dict) await writeDict(obj, buffer, transform);
                    else if (obj instanceof _base_stream.BaseStream) await writeStream(obj, buffer, transform);
                    else if (Array.isArray(obj)) await writeArray(obj, buffer, transform);
                    buffer.push("\nendobj\n");
                }
                async function writeDict(dict, buffer, transform) {
                    buffer.push("<<");
                    for (const key of dict.getKeys()){
                        buffer.push(` /${(0, _core_utils.escapePDFName)(key)} `);
                        await writeValue(dict.getRaw(key), buffer, transform);
                    }
                    buffer.push(">>");
                }
                async function writeStream(stream, buffer, transform) {
                    let string = stream.getString();
                    const { dict: dict } = stream;
                    const [filter, params] = await Promise.all([
                        dict.getAsync("Filter"),
                        dict.getAsync("DecodeParms")
                    ]);
                    const filterZero = Array.isArray(filter) ? await dict.xref.fetchIfRefAsync(filter[0]) : filter;
                    const isFilterZeroFlateDecode = (0, _primitives.isName)(filterZero, "FlateDecode");
                    const MIN_LENGTH_FOR_COMPRESSING = 256;
                    if (typeof CompressionStream !== "undefined" && (string.length >= MIN_LENGTH_FOR_COMPRESSING || isFilterZeroFlateDecode)) try {
                        const byteArray = (0, _util.stringToBytes)(string);
                        const cs = new CompressionStream("deflate");
                        const writer = cs.writable.getWriter();
                        writer.write(byteArray);
                        writer.close();
                        const buf = await new Response(cs.readable).arrayBuffer();
                        string = (0, _util.bytesToString)(new Uint8Array(buf));
                        let newFilter, newParams;
                        if (!filter) newFilter = _primitives.Name.get("FlateDecode");
                        else if (!isFilterZeroFlateDecode) {
                            newFilter = Array.isArray(filter) ? [
                                _primitives.Name.get("FlateDecode"),
                                ...filter
                            ] : [
                                _primitives.Name.get("FlateDecode"),
                                filter
                            ];
                            if (params) newParams = Array.isArray(params) ? [
                                null,
                                ...params
                            ] : [
                                null,
                                params
                            ];
                        }
                        if (newFilter) dict.set("Filter", newFilter);
                        if (newParams) dict.set("DecodeParms", newParams);
                    } catch (ex) {
                        (0, _util.info)(`writeStream - cannot compress data: "${ex}".`);
                    }
                    if (transform) string = transform.encryptString(string);
                    dict.set("Length", string.length);
                    await writeDict(dict, buffer, transform);
                    buffer.push(" stream\n", string, "\nendstream");
                }
                async function writeArray(array, buffer, transform) {
                    buffer.push("[");
                    let first = true;
                    for (const val of array){
                        if (!first) buffer.push(" ");
                        else first = false;
                        await writeValue(val, buffer, transform);
                    }
                    buffer.push("]");
                }
                async function writeValue(value, buffer, transform) {
                    if (value instanceof _primitives.Name) buffer.push(`/${(0, _core_utils.escapePDFName)(value.name)}`);
                    else if (value instanceof _primitives.Ref) buffer.push(`${value.num} ${value.gen} R`);
                    else if (Array.isArray(value)) await writeArray(value, buffer, transform);
                    else if (typeof value === "string") {
                        if (transform) value = transform.encryptString(value);
                        buffer.push(`(${(0, _core_utils.escapeString)(value)})`);
                    } else if (typeof value === "number") buffer.push((0, _core_utils.numberToString)(value));
                    else if (typeof value === "boolean") buffer.push(value.toString());
                    else if (value instanceof _primitives.Dict) await writeDict(value, buffer, transform);
                    else if (value instanceof _base_stream.BaseStream) await writeStream(value, buffer, transform);
                    else if (value === null) buffer.push("null");
                    else (0, _util.warn)(`Unhandled value in writer: ${typeof value}, please file a bug.`);
                }
                function writeInt(number, size, offset, buffer) {
                    for(let i = size + offset - 1; i > offset - 1; i--){
                        buffer[i] = number & 0xff;
                        number >>= 8;
                    }
                    return offset + size;
                }
                function writeString(string, offset, buffer) {
                    for(let i = 0, len = string.length; i < len; i++)buffer[offset + i] = string.charCodeAt(i) & 0xff;
                }
                function computeMD5(filesize, xrefInfo) {
                    const time = Math.floor(Date.now() / 1000);
                    const filename = xrefInfo.filename || "";
                    const md5Buffer = [
                        time.toString(),
                        filename,
                        filesize.toString()
                    ];
                    let md5BufferLen = md5Buffer.reduce((a, str)=>a + str.length, 0);
                    for (const value of Object.values(xrefInfo.info)){
                        md5Buffer.push(value);
                        md5BufferLen += value.length;
                    }
                    const array = new Uint8Array(md5BufferLen);
                    let offset = 0;
                    for (const str of md5Buffer){
                        writeString(str, offset, array);
                        offset += str.length;
                    }
                    return (0, _util.bytesToString)((0, _crypto.calculateMD5)(array));
                }
                function writeXFADataForAcroform(str, newRefs) {
                    const xml = new _xml_parser.SimpleXMLParser({
                        hasAttributes: true
                    }).parseFromString(str);
                    for (const { xfa: xfa } of newRefs){
                        if (!xfa) continue;
                        const { path: path, value: value } = xfa;
                        if (!path) continue;
                        const nodePath = (0, _core_utils.parseXFAPath)(path);
                        let node = xml.documentElement.searchNode(nodePath, 0);
                        if (!node && nodePath.length > 1) node = xml.documentElement.searchNode([
                            nodePath.at(-1)
                        ], 0);
                        if (node) node.childNodes = Array.isArray(value) ? value.map((val)=>new _xml_parser.SimpleDOMNode("value", val)) : [
                            new _xml_parser.SimpleDOMNode("#text", value)
                        ];
                        else (0, _util.warn)(`Node not found for path: ${path}`);
                    }
                    const buffer = [];
                    xml.documentElement.dump(buffer);
                    return buffer.join("");
                }
                async function updateAcroform({ xref: xref, acroForm: acroForm, acroFormRef: acroFormRef, hasXfa: hasXfa, hasXfaDatasetsEntry: hasXfaDatasetsEntry, xfaDatasetsRef: xfaDatasetsRef, needAppearances: needAppearances, newRefs: newRefs }) {
                    if (hasXfa && !hasXfaDatasetsEntry && !xfaDatasetsRef) (0, _util.warn)("XFA - Cannot save it");
                    if (!needAppearances && (!hasXfa || !xfaDatasetsRef || hasXfaDatasetsEntry)) return;
                    const dict = acroForm.clone();
                    if (hasXfa && !hasXfaDatasetsEntry) {
                        const newXfa = acroForm.get("XFA").slice();
                        newXfa.splice(2, 0, "datasets");
                        newXfa.splice(3, 0, xfaDatasetsRef);
                        dict.set("XFA", newXfa);
                    }
                    if (needAppearances) dict.set("NeedAppearances", true);
                    const buffer = [];
                    await writeObject(acroFormRef, dict, buffer, xref);
                    newRefs.push({
                        ref: acroFormRef,
                        data: buffer.join("")
                    });
                }
                function updateXFA({ xfaData: xfaData, xfaDatasetsRef: xfaDatasetsRef, newRefs: newRefs, xref: xref }) {
                    if (xfaData === null) {
                        const datasets = xref.fetchIfRef(xfaDatasetsRef);
                        xfaData = writeXFADataForAcroform(datasets.getString(), newRefs);
                    }
                    const encrypt = xref.encrypt;
                    if (encrypt) {
                        const transform = encrypt.createCipherTransform(xfaDatasetsRef.num, xfaDatasetsRef.gen);
                        xfaData = transform.encryptString(xfaData);
                    }
                    const data = `${xfaDatasetsRef.num} ${xfaDatasetsRef.gen} obj\n` + `<< /Type /EmbeddedFile /Length ${xfaData.length}>>\nstream\n` + xfaData + "\nendstream\nendobj\n";
                    newRefs.push({
                        ref: xfaDatasetsRef,
                        data: data
                    });
                }
                async function incrementalUpdate({ originalData: originalData, xrefInfo: xrefInfo, newRefs: newRefs, xref: xref = null, hasXfa: hasXfa = false, xfaDatasetsRef: xfaDatasetsRef = null, hasXfaDatasetsEntry: hasXfaDatasetsEntry = false, needAppearances: needAppearances, acroFormRef: acroFormRef = null, acroForm: acroForm = null, xfaData: xfaData = null }) {
                    await updateAcroform({
                        xref: xref,
                        acroForm: acroForm,
                        acroFormRef: acroFormRef,
                        hasXfa: hasXfa,
                        hasXfaDatasetsEntry: hasXfaDatasetsEntry,
                        xfaDatasetsRef: xfaDatasetsRef,
                        needAppearances: needAppearances,
                        newRefs: newRefs
                    });
                    if (hasXfa) updateXFA({
                        xfaData: xfaData,
                        xfaDatasetsRef: xfaDatasetsRef,
                        newRefs: newRefs,
                        xref: xref
                    });
                    const newXref = new _primitives.Dict(null);
                    const refForXrefTable = xrefInfo.newRef;
                    let buffer, baseOffset;
                    const lastByte = originalData.at(-1);
                    if (lastByte === 0x0a || lastByte === 0x0d) {
                        buffer = [];
                        baseOffset = originalData.length;
                    } else {
                        buffer = [
                            "\n"
                        ];
                        baseOffset = originalData.length + 1;
                    }
                    newXref.set("Size", refForXrefTable.num + 1);
                    newXref.set("Prev", xrefInfo.startXRef);
                    newXref.set("Type", _primitives.Name.get("XRef"));
                    if (xrefInfo.rootRef !== null) newXref.set("Root", xrefInfo.rootRef);
                    if (xrefInfo.infoRef !== null) newXref.set("Info", xrefInfo.infoRef);
                    if (xrefInfo.encryptRef !== null) newXref.set("Encrypt", xrefInfo.encryptRef);
                    newRefs.push({
                        ref: refForXrefTable,
                        data: ""
                    });
                    newRefs = newRefs.sort((a, b)=>{
                        return a.ref.num - b.ref.num;
                    });
                    const xrefTableData = [
                        [
                            0,
                            1,
                            0xffff
                        ]
                    ];
                    const indexes = [
                        0,
                        1
                    ];
                    let maxOffset = 0;
                    for (const { ref: ref, data: data } of newRefs){
                        maxOffset = Math.max(maxOffset, baseOffset);
                        xrefTableData.push([
                            1,
                            baseOffset,
                            Math.min(ref.gen, 0xffff)
                        ]);
                        baseOffset += data.length;
                        indexes.push(ref.num, 1);
                        buffer.push(data);
                    }
                    newXref.set("Index", indexes);
                    if (Array.isArray(xrefInfo.fileIds) && xrefInfo.fileIds.length > 0) {
                        const md5 = computeMD5(baseOffset, xrefInfo);
                        newXref.set("ID", [
                            xrefInfo.fileIds[0],
                            md5
                        ]);
                    }
                    const offsetSize = Math.ceil(Math.log2(maxOffset) / 8);
                    const sizes = [
                        1,
                        offsetSize,
                        2
                    ];
                    const structSize = sizes[0] + sizes[1] + sizes[2];
                    const tableLength = structSize * xrefTableData.length;
                    newXref.set("W", sizes);
                    newXref.set("Length", tableLength);
                    buffer.push(`${refForXrefTable.num} ${refForXrefTable.gen} obj\n`);
                    await writeDict(newXref, buffer, null);
                    buffer.push(" stream\n");
                    const bufferLen = buffer.reduce((a, str)=>a + str.length, 0);
                    const footer = `\nendstream\nendobj\nstartxref\n${baseOffset}\n%%EOF\n`;
                    const array = new Uint8Array(originalData.length + bufferLen + tableLength + footer.length);
                    array.set(originalData);
                    let offset = originalData.length;
                    for (const str of buffer){
                        writeString(str, offset, array);
                        offset += str.length;
                    }
                    for (const [type, objOffset, gen] of xrefTableData){
                        offset = writeInt(type, sizes[0], offset, array);
                        offset = writeInt(objOffset, sizes[1], offset, array);
                        offset = writeInt(gen, sizes[2], offset, array);
                    }
                    writeString(footer, offset, array);
                    return array;
                }
            /***/ },
            /* 74 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.calculateSHA256 = exports.calculateMD5 = exports.PDF20 = exports.PDF17 = exports.CipherTransformFactory = exports.ARCFourCipher = exports.AES256Cipher = exports.AES128Cipher = void 0;
                exports.calculateSHA384 = calculateSHA384;
                exports.calculateSHA512 = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _decrypt_stream = __w_pdfjs_require__(75);
                class ARCFourCipher {
                    constructor(key){
                        this.a = 0;
                        this.b = 0;
                        const s = new Uint8Array(256);
                        const keyLength = key.length;
                        for(let i = 0; i < 256; ++i)s[i] = i;
                        for(let i = 0, j = 0; i < 256; ++i){
                            const tmp = s[i];
                            j = j + tmp + key[i % keyLength] & 0xff;
                            s[i] = s[j];
                            s[j] = tmp;
                        }
                        this.s = s;
                    }
                    encryptBlock(data) {
                        let a = this.a, b = this.b;
                        const s = this.s;
                        const n = data.length;
                        const output = new Uint8Array(n);
                        for(let i = 0; i < n; ++i){
                            a = a + 1 & 0xff;
                            const tmp = s[a];
                            b = b + tmp & 0xff;
                            const tmp2 = s[b];
                            s[a] = tmp2;
                            s[b] = tmp;
                            output[i] = data[i] ^ s[tmp + tmp2 & 0xff];
                        }
                        this.a = a;
                        this.b = b;
                        return output;
                    }
                    decryptBlock(data) {
                        return this.encryptBlock(data);
                    }
                    encrypt(data) {
                        return this.encryptBlock(data);
                    }
                }
                exports.ARCFourCipher = ARCFourCipher;
                const calculateMD5 = function calculateMD5Closure() {
                    const r = new Uint8Array([
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21
                    ]);
                    const k = new Int32Array([
                        -680876936,
                        -389564586,
                        606105819,
                        -1044525330,
                        -176418897,
                        1200080426,
                        -1473231341,
                        -45705983,
                        1770035416,
                        -1958414417,
                        -42063,
                        -1990404162,
                        1804603682,
                        -40341101,
                        -1502002290,
                        1236535329,
                        -165796510,
                        -1069501632,
                        643717713,
                        -373897302,
                        -701558691,
                        38016083,
                        -660478335,
                        -405537848,
                        568446438,
                        -1019803690,
                        -187363961,
                        1163531501,
                        -1444681467,
                        -51403784,
                        1735328473,
                        -1926607734,
                        -378558,
                        -2022574463,
                        1839030562,
                        -35309556,
                        -1530992060,
                        1272893353,
                        -155497632,
                        -1094730640,
                        681279174,
                        -358537222,
                        -722521979,
                        76029189,
                        -640364487,
                        -421815835,
                        530742520,
                        -995338651,
                        -198630844,
                        1126891415,
                        -1416354905,
                        -57434055,
                        1700485571,
                        -1894986606,
                        -1051523,
                        -2054922799,
                        1873313359,
                        -30611744,
                        -1560198380,
                        1309151649,
                        -145523070,
                        -1120210379,
                        718787259,
                        -343485551
                    ]);
                    function hash(data, offset, length) {
                        let h0 = 1732584193, h1 = -271733879, h2 = -1732584194, h3 = 271733878;
                        const paddedLength = length + 72 & -64;
                        const padded = new Uint8Array(paddedLength);
                        let i, j;
                        for(i = 0; i < length; ++i)padded[i] = data[offset++];
                        padded[i++] = 0x80;
                        const n = paddedLength - 8;
                        while(i < n)padded[i++] = 0;
                        padded[i++] = length << 3 & 0xff;
                        padded[i++] = length >> 5 & 0xff;
                        padded[i++] = length >> 13 & 0xff;
                        padded[i++] = length >> 21 & 0xff;
                        padded[i++] = length >>> 29 & 0xff;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        const w = new Int32Array(16);
                        for(i = 0; i < paddedLength;){
                            for(j = 0; j < 16; ++j, i += 4)w[j] = padded[i] | padded[i + 1] << 8 | padded[i + 2] << 16 | padded[i + 3] << 24;
                            let a = h0, b = h1, c = h2, d = h3, f, g;
                            for(j = 0; j < 64; ++j){
                                if (j < 16) {
                                    f = b & c | ~b & d;
                                    g = j;
                                } else if (j < 32) {
                                    f = d & b | ~d & c;
                                    g = 5 * j + 1 & 15;
                                } else if (j < 48) {
                                    f = b ^ c ^ d;
                                    g = 3 * j + 5 & 15;
                                } else {
                                    f = c ^ (b | ~d);
                                    g = 7 * j & 15;
                                }
                                const tmp = d, rotateArg = a + f + k[j] + w[g] | 0, rotate = r[j];
                                d = c;
                                c = b;
                                b = b + (rotateArg << rotate | rotateArg >>> 32 - rotate) | 0;
                                a = tmp;
                            }
                            h0 = h0 + a | 0;
                            h1 = h1 + b | 0;
                            h2 = h2 + c | 0;
                            h3 = h3 + d | 0;
                        }
                        return new Uint8Array([
                            h0 & 0xFF,
                            h0 >> 8 & 0xFF,
                            h0 >> 16 & 0xFF,
                            h0 >>> 24 & 0xFF,
                            h1 & 0xFF,
                            h1 >> 8 & 0xFF,
                            h1 >> 16 & 0xFF,
                            h1 >>> 24 & 0xFF,
                            h2 & 0xFF,
                            h2 >> 8 & 0xFF,
                            h2 >> 16 & 0xFF,
                            h2 >>> 24 & 0xFF,
                            h3 & 0xFF,
                            h3 >> 8 & 0xFF,
                            h3 >> 16 & 0xFF,
                            h3 >>> 24 & 0xFF
                        ]);
                    }
                    return hash;
                }();
                exports.calculateMD5 = calculateMD5;
                class Word64 {
                    constructor(highInteger, lowInteger){
                        this.high = highInteger | 0;
                        this.low = lowInteger | 0;
                    }
                    and(word) {
                        this.high &= word.high;
                        this.low &= word.low;
                    }
                    xor(word) {
                        this.high ^= word.high;
                        this.low ^= word.low;
                    }
                    or(word) {
                        this.high |= word.high;
                        this.low |= word.low;
                    }
                    shiftRight(places) {
                        if (places >= 32) {
                            this.low = this.high >>> places - 32 | 0;
                            this.high = 0;
                        } else {
                            this.low = this.low >>> places | this.high << 32 - places;
                            this.high = this.high >>> places | 0;
                        }
                    }
                    shiftLeft(places) {
                        if (places >= 32) {
                            this.high = this.low << places - 32;
                            this.low = 0;
                        } else {
                            this.high = this.high << places | this.low >>> 32 - places;
                            this.low <<= places;
                        }
                    }
                    rotateRight(places) {
                        let low, high;
                        if (places & 32) {
                            high = this.low;
                            low = this.high;
                        } else {
                            low = this.low;
                            high = this.high;
                        }
                        places &= 31;
                        this.low = low >>> places | high << 32 - places;
                        this.high = high >>> places | low << 32 - places;
                    }
                    not() {
                        this.high = ~this.high;
                        this.low = ~this.low;
                    }
                    add(word) {
                        const lowAdd = (this.low >>> 0) + (word.low >>> 0);
                        let highAdd = (this.high >>> 0) + (word.high >>> 0);
                        if (lowAdd > 0xffffffff) highAdd += 1;
                        this.low = lowAdd | 0;
                        this.high = highAdd | 0;
                    }
                    copyTo(bytes, offset) {
                        bytes[offset] = this.high >>> 24 & 0xff;
                        bytes[offset + 1] = this.high >> 16 & 0xff;
                        bytes[offset + 2] = this.high >> 8 & 0xff;
                        bytes[offset + 3] = this.high & 0xff;
                        bytes[offset + 4] = this.low >>> 24 & 0xff;
                        bytes[offset + 5] = this.low >> 16 & 0xff;
                        bytes[offset + 6] = this.low >> 8 & 0xff;
                        bytes[offset + 7] = this.low & 0xff;
                    }
                    assign(word) {
                        this.high = word.high;
                        this.low = word.low;
                    }
                }
                const calculateSHA256 = function calculateSHA256Closure() {
                    function rotr(x, n) {
                        return x >>> n | x << 32 - n;
                    }
                    function ch(x, y, z) {
                        return x & y ^ ~x & z;
                    }
                    function maj(x, y, z) {
                        return x & y ^ x & z ^ y & z;
                    }
                    function sigma(x) {
                        return rotr(x, 2) ^ rotr(x, 13) ^ rotr(x, 22);
                    }
                    function sigmaPrime(x) {
                        return rotr(x, 6) ^ rotr(x, 11) ^ rotr(x, 25);
                    }
                    function littleSigma(x) {
                        return rotr(x, 7) ^ rotr(x, 18) ^ x >>> 3;
                    }
                    function littleSigmaPrime(x) {
                        return rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
                    }
                    const k = [
                        0x428a2f98,
                        0x71374491,
                        0xb5c0fbcf,
                        0xe9b5dba5,
                        0x3956c25b,
                        0x59f111f1,
                        0x923f82a4,
                        0xab1c5ed5,
                        0xd807aa98,
                        0x12835b01,
                        0x243185be,
                        0x550c7dc3,
                        0x72be5d74,
                        0x80deb1fe,
                        0x9bdc06a7,
                        0xc19bf174,
                        0xe49b69c1,
                        0xefbe4786,
                        0x0fc19dc6,
                        0x240ca1cc,
                        0x2de92c6f,
                        0x4a7484aa,
                        0x5cb0a9dc,
                        0x76f988da,
                        0x983e5152,
                        0xa831c66d,
                        0xb00327c8,
                        0xbf597fc7,
                        0xc6e00bf3,
                        0xd5a79147,
                        0x06ca6351,
                        0x14292967,
                        0x27b70a85,
                        0x2e1b2138,
                        0x4d2c6dfc,
                        0x53380d13,
                        0x650a7354,
                        0x766a0abb,
                        0x81c2c92e,
                        0x92722c85,
                        0xa2bfe8a1,
                        0xa81a664b,
                        0xc24b8b70,
                        0xc76c51a3,
                        0xd192e819,
                        0xd6990624,
                        0xf40e3585,
                        0x106aa070,
                        0x19a4c116,
                        0x1e376c08,
                        0x2748774c,
                        0x34b0bcb5,
                        0x391c0cb3,
                        0x4ed8aa4a,
                        0x5b9cca4f,
                        0x682e6ff3,
                        0x748f82ee,
                        0x78a5636f,
                        0x84c87814,
                        0x8cc70208,
                        0x90befffa,
                        0xa4506ceb,
                        0xbef9a3f7,
                        0xc67178f2
                    ];
                    function hash(data, offset, length) {
                        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a, h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
                        const paddedLength = Math.ceil((length + 9) / 64) * 64;
                        const padded = new Uint8Array(paddedLength);
                        let i, j;
                        for(i = 0; i < length; ++i)padded[i] = data[offset++];
                        padded[i++] = 0x80;
                        const n = paddedLength - 8;
                        while(i < n)padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = length >>> 29 & 0xff;
                        padded[i++] = length >> 21 & 0xff;
                        padded[i++] = length >> 13 & 0xff;
                        padded[i++] = length >> 5 & 0xff;
                        padded[i++] = length << 3 & 0xff;
                        const w = new Uint32Array(64);
                        for(i = 0; i < paddedLength;){
                            for(j = 0; j < 16; ++j){
                                w[j] = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
                                i += 4;
                            }
                            for(j = 16; j < 64; ++j)w[j] = littleSigmaPrime(w[j - 2]) + w[j - 7] + littleSigma(w[j - 15]) + w[j - 16] | 0;
                            let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, t1, t2;
                            for(j = 0; j < 64; ++j){
                                t1 = h + sigmaPrime(e) + ch(e, f, g) + k[j] + w[j];
                                t2 = sigma(a) + maj(a, b, c);
                                h = g;
                                g = f;
                                f = e;
                                e = d + t1 | 0;
                                d = c;
                                c = b;
                                b = a;
                                a = t1 + t2 | 0;
                            }
                            h0 = h0 + a | 0;
                            h1 = h1 + b | 0;
                            h2 = h2 + c | 0;
                            h3 = h3 + d | 0;
                            h4 = h4 + e | 0;
                            h5 = h5 + f | 0;
                            h6 = h6 + g | 0;
                            h7 = h7 + h | 0;
                        }
                        return new Uint8Array([
                            h0 >> 24 & 0xFF,
                            h0 >> 16 & 0xFF,
                            h0 >> 8 & 0xFF,
                            h0 & 0xFF,
                            h1 >> 24 & 0xFF,
                            h1 >> 16 & 0xFF,
                            h1 >> 8 & 0xFF,
                            h1 & 0xFF,
                            h2 >> 24 & 0xFF,
                            h2 >> 16 & 0xFF,
                            h2 >> 8 & 0xFF,
                            h2 & 0xFF,
                            h3 >> 24 & 0xFF,
                            h3 >> 16 & 0xFF,
                            h3 >> 8 & 0xFF,
                            h3 & 0xFF,
                            h4 >> 24 & 0xFF,
                            h4 >> 16 & 0xFF,
                            h4 >> 8 & 0xFF,
                            h4 & 0xFF,
                            h5 >> 24 & 0xFF,
                            h5 >> 16 & 0xFF,
                            h5 >> 8 & 0xFF,
                            h5 & 0xFF,
                            h6 >> 24 & 0xFF,
                            h6 >> 16 & 0xFF,
                            h6 >> 8 & 0xFF,
                            h6 & 0xFF,
                            h7 >> 24 & 0xFF,
                            h7 >> 16 & 0xFF,
                            h7 >> 8 & 0xFF,
                            h7 & 0xFF
                        ]);
                    }
                    return hash;
                }();
                exports.calculateSHA256 = calculateSHA256;
                const calculateSHA512 = function calculateSHA512Closure() {
                    function ch(result, x, y, z, tmp) {
                        result.assign(x);
                        result.and(y);
                        tmp.assign(x);
                        tmp.not();
                        tmp.and(z);
                        result.xor(tmp);
                    }
                    function maj(result, x, y, z, tmp) {
                        result.assign(x);
                        result.and(y);
                        tmp.assign(x);
                        tmp.and(z);
                        result.xor(tmp);
                        tmp.assign(y);
                        tmp.and(z);
                        result.xor(tmp);
                    }
                    function sigma(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(28);
                        tmp.assign(x);
                        tmp.rotateRight(34);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.rotateRight(39);
                        result.xor(tmp);
                    }
                    function sigmaPrime(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(14);
                        tmp.assign(x);
                        tmp.rotateRight(18);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.rotateRight(41);
                        result.xor(tmp);
                    }
                    function littleSigma(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(1);
                        tmp.assign(x);
                        tmp.rotateRight(8);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.shiftRight(7);
                        result.xor(tmp);
                    }
                    function littleSigmaPrime(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(19);
                        tmp.assign(x);
                        tmp.rotateRight(61);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.shiftRight(6);
                        result.xor(tmp);
                    }
                    const k = [
                        new Word64(0x428a2f98, 0xd728ae22),
                        new Word64(0x71374491, 0x23ef65cd),
                        new Word64(0xb5c0fbcf, 0xec4d3b2f),
                        new Word64(0xe9b5dba5, 0x8189dbbc),
                        new Word64(0x3956c25b, 0xf348b538),
                        new Word64(0x59f111f1, 0xb605d019),
                        new Word64(0x923f82a4, 0xaf194f9b),
                        new Word64(0xab1c5ed5, 0xda6d8118),
                        new Word64(0xd807aa98, 0xa3030242),
                        new Word64(0x12835b01, 0x45706fbe),
                        new Word64(0x243185be, 0x4ee4b28c),
                        new Word64(0x550c7dc3, 0xd5ffb4e2),
                        new Word64(0x72be5d74, 0xf27b896f),
                        new Word64(0x80deb1fe, 0x3b1696b1),
                        new Word64(0x9bdc06a7, 0x25c71235),
                        new Word64(0xc19bf174, 0xcf692694),
                        new Word64(0xe49b69c1, 0x9ef14ad2),
                        new Word64(0xefbe4786, 0x384f25e3),
                        new Word64(0x0fc19dc6, 0x8b8cd5b5),
                        new Word64(0x240ca1cc, 0x77ac9c65),
                        new Word64(0x2de92c6f, 0x592b0275),
                        new Word64(0x4a7484aa, 0x6ea6e483),
                        new Word64(0x5cb0a9dc, 0xbd41fbd4),
                        new Word64(0x76f988da, 0x831153b5),
                        new Word64(0x983e5152, 0xee66dfab),
                        new Word64(0xa831c66d, 0x2db43210),
                        new Word64(0xb00327c8, 0x98fb213f),
                        new Word64(0xbf597fc7, 0xbeef0ee4),
                        new Word64(0xc6e00bf3, 0x3da88fc2),
                        new Word64(0xd5a79147, 0x930aa725),
                        new Word64(0x06ca6351, 0xe003826f),
                        new Word64(0x14292967, 0x0a0e6e70),
                        new Word64(0x27b70a85, 0x46d22ffc),
                        new Word64(0x2e1b2138, 0x5c26c926),
                        new Word64(0x4d2c6dfc, 0x5ac42aed),
                        new Word64(0x53380d13, 0x9d95b3df),
                        new Word64(0x650a7354, 0x8baf63de),
                        new Word64(0x766a0abb, 0x3c77b2a8),
                        new Word64(0x81c2c92e, 0x47edaee6),
                        new Word64(0x92722c85, 0x1482353b),
                        new Word64(0xa2bfe8a1, 0x4cf10364),
                        new Word64(0xa81a664b, 0xbc423001),
                        new Word64(0xc24b8b70, 0xd0f89791),
                        new Word64(0xc76c51a3, 0x0654be30),
                        new Word64(0xd192e819, 0xd6ef5218),
                        new Word64(0xd6990624, 0x5565a910),
                        new Word64(0xf40e3585, 0x5771202a),
                        new Word64(0x106aa070, 0x32bbd1b8),
                        new Word64(0x19a4c116, 0xb8d2d0c8),
                        new Word64(0x1e376c08, 0x5141ab53),
                        new Word64(0x2748774c, 0xdf8eeb99),
                        new Word64(0x34b0bcb5, 0xe19b48a8),
                        new Word64(0x391c0cb3, 0xc5c95a63),
                        new Word64(0x4ed8aa4a, 0xe3418acb),
                        new Word64(0x5b9cca4f, 0x7763e373),
                        new Word64(0x682e6ff3, 0xd6b2b8a3),
                        new Word64(0x748f82ee, 0x5defb2fc),
                        new Word64(0x78a5636f, 0x43172f60),
                        new Word64(0x84c87814, 0xa1f0ab72),
                        new Word64(0x8cc70208, 0x1a6439ec),
                        new Word64(0x90befffa, 0x23631e28),
                        new Word64(0xa4506ceb, 0xde82bde9),
                        new Word64(0xbef9a3f7, 0xb2c67915),
                        new Word64(0xc67178f2, 0xe372532b),
                        new Word64(0xca273ece, 0xea26619c),
                        new Word64(0xd186b8c7, 0x21c0c207),
                        new Word64(0xeada7dd6, 0xcde0eb1e),
                        new Word64(0xf57d4f7f, 0xee6ed178),
                        new Word64(0x06f067aa, 0x72176fba),
                        new Word64(0x0a637dc5, 0xa2c898a6),
                        new Word64(0x113f9804, 0xbef90dae),
                        new Word64(0x1b710b35, 0x131c471b),
                        new Word64(0x28db77f5, 0x23047d84),
                        new Word64(0x32caab7b, 0x40c72493),
                        new Word64(0x3c9ebe0a, 0x15c9bebc),
                        new Word64(0x431d67c4, 0x9c100d4c),
                        new Word64(0x4cc5d4be, 0xcb3e42b6),
                        new Word64(0x597f299c, 0xfc657e2a),
                        new Word64(0x5fcb6fab, 0x3ad6faec),
                        new Word64(0x6c44198c, 0x4a475817)
                    ];
                    function hash(data, offset, length, mode384 = false) {
                        let h0, h1, h2, h3, h4, h5, h6, h7;
                        if (!mode384) {
                            h0 = new Word64(0x6a09e667, 0xf3bcc908);
                            h1 = new Word64(0xbb67ae85, 0x84caa73b);
                            h2 = new Word64(0x3c6ef372, 0xfe94f82b);
                            h3 = new Word64(0xa54ff53a, 0x5f1d36f1);
                            h4 = new Word64(0x510e527f, 0xade682d1);
                            h5 = new Word64(0x9b05688c, 0x2b3e6c1f);
                            h6 = new Word64(0x1f83d9ab, 0xfb41bd6b);
                            h7 = new Word64(0x5be0cd19, 0x137e2179);
                        } else {
                            h0 = new Word64(0xcbbb9d5d, 0xc1059ed8);
                            h1 = new Word64(0x629a292a, 0x367cd507);
                            h2 = new Word64(0x9159015a, 0x3070dd17);
                            h3 = new Word64(0x152fecd8, 0xf70e5939);
                            h4 = new Word64(0x67332667, 0xffc00b31);
                            h5 = new Word64(0x8eb44a87, 0x68581511);
                            h6 = new Word64(0xdb0c2e0d, 0x64f98fa7);
                            h7 = new Word64(0x47b5481d, 0xbefa4fa4);
                        }
                        const paddedLength = Math.ceil((length + 17) / 128) * 128;
                        const padded = new Uint8Array(paddedLength);
                        let i, j;
                        for(i = 0; i < length; ++i)padded[i] = data[offset++];
                        padded[i++] = 0x80;
                        const n = paddedLength - 16;
                        while(i < n)padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = length >>> 29 & 0xff;
                        padded[i++] = length >> 21 & 0xff;
                        padded[i++] = length >> 13 & 0xff;
                        padded[i++] = length >> 5 & 0xff;
                        padded[i++] = length << 3 & 0xff;
                        const w = new Array(80);
                        for(i = 0; i < 80; i++)w[i] = new Word64(0, 0);
                        let a = new Word64(0, 0), b = new Word64(0, 0), c = new Word64(0, 0);
                        let d = new Word64(0, 0), e = new Word64(0, 0), f = new Word64(0, 0);
                        let g = new Word64(0, 0), h = new Word64(0, 0);
                        const t1 = new Word64(0, 0), t2 = new Word64(0, 0);
                        const tmp1 = new Word64(0, 0), tmp2 = new Word64(0, 0);
                        let tmp3;
                        for(i = 0; i < paddedLength;){
                            for(j = 0; j < 16; ++j){
                                w[j].high = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
                                w[j].low = padded[i + 4] << 24 | padded[i + 5] << 16 | padded[i + 6] << 8 | padded[i + 7];
                                i += 8;
                            }
                            for(j = 16; j < 80; ++j){
                                tmp3 = w[j];
                                littleSigmaPrime(tmp3, w[j - 2], tmp2);
                                tmp3.add(w[j - 7]);
                                littleSigma(tmp1, w[j - 15], tmp2);
                                tmp3.add(tmp1);
                                tmp3.add(w[j - 16]);
                            }
                            a.assign(h0);
                            b.assign(h1);
                            c.assign(h2);
                            d.assign(h3);
                            e.assign(h4);
                            f.assign(h5);
                            g.assign(h6);
                            h.assign(h7);
                            for(j = 0; j < 80; ++j){
                                t1.assign(h);
                                sigmaPrime(tmp1, e, tmp2);
                                t1.add(tmp1);
                                ch(tmp1, e, f, g, tmp2);
                                t1.add(tmp1);
                                t1.add(k[j]);
                                t1.add(w[j]);
                                sigma(t2, a, tmp2);
                                maj(tmp1, a, b, c, tmp2);
                                t2.add(tmp1);
                                tmp3 = h;
                                h = g;
                                g = f;
                                f = e;
                                d.add(t1);
                                e = d;
                                d = c;
                                c = b;
                                b = a;
                                tmp3.assign(t1);
                                tmp3.add(t2);
                                a = tmp3;
                            }
                            h0.add(a);
                            h1.add(b);
                            h2.add(c);
                            h3.add(d);
                            h4.add(e);
                            h5.add(f);
                            h6.add(g);
                            h7.add(h);
                        }
                        let result;
                        if (!mode384) {
                            result = new Uint8Array(64);
                            h0.copyTo(result, 0);
                            h1.copyTo(result, 8);
                            h2.copyTo(result, 16);
                            h3.copyTo(result, 24);
                            h4.copyTo(result, 32);
                            h5.copyTo(result, 40);
                            h6.copyTo(result, 48);
                            h7.copyTo(result, 56);
                        } else {
                            result = new Uint8Array(48);
                            h0.copyTo(result, 0);
                            h1.copyTo(result, 8);
                            h2.copyTo(result, 16);
                            h3.copyTo(result, 24);
                            h4.copyTo(result, 32);
                            h5.copyTo(result, 40);
                        }
                        return result;
                    }
                    return hash;
                }();
                exports.calculateSHA512 = calculateSHA512;
                function calculateSHA384(data, offset, length) {
                    return calculateSHA512(data, offset, length, true);
                }
                class NullCipher {
                    decryptBlock(data) {
                        return data;
                    }
                    encrypt(data) {
                        return data;
                    }
                }
                class AESBaseCipher {
                    constructor(){
                        if (this.constructor === AESBaseCipher) (0, _util.unreachable)("Cannot initialize AESBaseCipher.");
                        this._s = new Uint8Array([
                            0x63,
                            0x7c,
                            0x77,
                            0x7b,
                            0xf2,
                            0x6b,
                            0x6f,
                            0xc5,
                            0x30,
                            0x01,
                            0x67,
                            0x2b,
                            0xfe,
                            0xd7,
                            0xab,
                            0x76,
                            0xca,
                            0x82,
                            0xc9,
                            0x7d,
                            0xfa,
                            0x59,
                            0x47,
                            0xf0,
                            0xad,
                            0xd4,
                            0xa2,
                            0xaf,
                            0x9c,
                            0xa4,
                            0x72,
                            0xc0,
                            0xb7,
                            0xfd,
                            0x93,
                            0x26,
                            0x36,
                            0x3f,
                            0xf7,
                            0xcc,
                            0x34,
                            0xa5,
                            0xe5,
                            0xf1,
                            0x71,
                            0xd8,
                            0x31,
                            0x15,
                            0x04,
                            0xc7,
                            0x23,
                            0xc3,
                            0x18,
                            0x96,
                            0x05,
                            0x9a,
                            0x07,
                            0x12,
                            0x80,
                            0xe2,
                            0xeb,
                            0x27,
                            0xb2,
                            0x75,
                            0x09,
                            0x83,
                            0x2c,
                            0x1a,
                            0x1b,
                            0x6e,
                            0x5a,
                            0xa0,
                            0x52,
                            0x3b,
                            0xd6,
                            0xb3,
                            0x29,
                            0xe3,
                            0x2f,
                            0x84,
                            0x53,
                            0xd1,
                            0x00,
                            0xed,
                            0x20,
                            0xfc,
                            0xb1,
                            0x5b,
                            0x6a,
                            0xcb,
                            0xbe,
                            0x39,
                            0x4a,
                            0x4c,
                            0x58,
                            0xcf,
                            0xd0,
                            0xef,
                            0xaa,
                            0xfb,
                            0x43,
                            0x4d,
                            0x33,
                            0x85,
                            0x45,
                            0xf9,
                            0x02,
                            0x7f,
                            0x50,
                            0x3c,
                            0x9f,
                            0xa8,
                            0x51,
                            0xa3,
                            0x40,
                            0x8f,
                            0x92,
                            0x9d,
                            0x38,
                            0xf5,
                            0xbc,
                            0xb6,
                            0xda,
                            0x21,
                            0x10,
                            0xff,
                            0xf3,
                            0xd2,
                            0xcd,
                            0x0c,
                            0x13,
                            0xec,
                            0x5f,
                            0x97,
                            0x44,
                            0x17,
                            0xc4,
                            0xa7,
                            0x7e,
                            0x3d,
                            0x64,
                            0x5d,
                            0x19,
                            0x73,
                            0x60,
                            0x81,
                            0x4f,
                            0xdc,
                            0x22,
                            0x2a,
                            0x90,
                            0x88,
                            0x46,
                            0xee,
                            0xb8,
                            0x14,
                            0xde,
                            0x5e,
                            0x0b,
                            0xdb,
                            0xe0,
                            0x32,
                            0x3a,
                            0x0a,
                            0x49,
                            0x06,
                            0x24,
                            0x5c,
                            0xc2,
                            0xd3,
                            0xac,
                            0x62,
                            0x91,
                            0x95,
                            0xe4,
                            0x79,
                            0xe7,
                            0xc8,
                            0x37,
                            0x6d,
                            0x8d,
                            0xd5,
                            0x4e,
                            0xa9,
                            0x6c,
                            0x56,
                            0xf4,
                            0xea,
                            0x65,
                            0x7a,
                            0xae,
                            0x08,
                            0xba,
                            0x78,
                            0x25,
                            0x2e,
                            0x1c,
                            0xa6,
                            0xb4,
                            0xc6,
                            0xe8,
                            0xdd,
                            0x74,
                            0x1f,
                            0x4b,
                            0xbd,
                            0x8b,
                            0x8a,
                            0x70,
                            0x3e,
                            0xb5,
                            0x66,
                            0x48,
                            0x03,
                            0xf6,
                            0x0e,
                            0x61,
                            0x35,
                            0x57,
                            0xb9,
                            0x86,
                            0xc1,
                            0x1d,
                            0x9e,
                            0xe1,
                            0xf8,
                            0x98,
                            0x11,
                            0x69,
                            0xd9,
                            0x8e,
                            0x94,
                            0x9b,
                            0x1e,
                            0x87,
                            0xe9,
                            0xce,
                            0x55,
                            0x28,
                            0xdf,
                            0x8c,
                            0xa1,
                            0x89,
                            0x0d,
                            0xbf,
                            0xe6,
                            0x42,
                            0x68,
                            0x41,
                            0x99,
                            0x2d,
                            0x0f,
                            0xb0,
                            0x54,
                            0xbb,
                            0x16
                        ]);
                        this._inv_s = new Uint8Array([
                            0x52,
                            0x09,
                            0x6a,
                            0xd5,
                            0x30,
                            0x36,
                            0xa5,
                            0x38,
                            0xbf,
                            0x40,
                            0xa3,
                            0x9e,
                            0x81,
                            0xf3,
                            0xd7,
                            0xfb,
                            0x7c,
                            0xe3,
                            0x39,
                            0x82,
                            0x9b,
                            0x2f,
                            0xff,
                            0x87,
                            0x34,
                            0x8e,
                            0x43,
                            0x44,
                            0xc4,
                            0xde,
                            0xe9,
                            0xcb,
                            0x54,
                            0x7b,
                            0x94,
                            0x32,
                            0xa6,
                            0xc2,
                            0x23,
                            0x3d,
                            0xee,
                            0x4c,
                            0x95,
                            0x0b,
                            0x42,
                            0xfa,
                            0xc3,
                            0x4e,
                            0x08,
                            0x2e,
                            0xa1,
                            0x66,
                            0x28,
                            0xd9,
                            0x24,
                            0xb2,
                            0x76,
                            0x5b,
                            0xa2,
                            0x49,
                            0x6d,
                            0x8b,
                            0xd1,
                            0x25,
                            0x72,
                            0xf8,
                            0xf6,
                            0x64,
                            0x86,
                            0x68,
                            0x98,
                            0x16,
                            0xd4,
                            0xa4,
                            0x5c,
                            0xcc,
                            0x5d,
                            0x65,
                            0xb6,
                            0x92,
                            0x6c,
                            0x70,
                            0x48,
                            0x50,
                            0xfd,
                            0xed,
                            0xb9,
                            0xda,
                            0x5e,
                            0x15,
                            0x46,
                            0x57,
                            0xa7,
                            0x8d,
                            0x9d,
                            0x84,
                            0x90,
                            0xd8,
                            0xab,
                            0x00,
                            0x8c,
                            0xbc,
                            0xd3,
                            0x0a,
                            0xf7,
                            0xe4,
                            0x58,
                            0x05,
                            0xb8,
                            0xb3,
                            0x45,
                            0x06,
                            0xd0,
                            0x2c,
                            0x1e,
                            0x8f,
                            0xca,
                            0x3f,
                            0x0f,
                            0x02,
                            0xc1,
                            0xaf,
                            0xbd,
                            0x03,
                            0x01,
                            0x13,
                            0x8a,
                            0x6b,
                            0x3a,
                            0x91,
                            0x11,
                            0x41,
                            0x4f,
                            0x67,
                            0xdc,
                            0xea,
                            0x97,
                            0xf2,
                            0xcf,
                            0xce,
                            0xf0,
                            0xb4,
                            0xe6,
                            0x73,
                            0x96,
                            0xac,
                            0x74,
                            0x22,
                            0xe7,
                            0xad,
                            0x35,
                            0x85,
                            0xe2,
                            0xf9,
                            0x37,
                            0xe8,
                            0x1c,
                            0x75,
                            0xdf,
                            0x6e,
                            0x47,
                            0xf1,
                            0x1a,
                            0x71,
                            0x1d,
                            0x29,
                            0xc5,
                            0x89,
                            0x6f,
                            0xb7,
                            0x62,
                            0x0e,
                            0xaa,
                            0x18,
                            0xbe,
                            0x1b,
                            0xfc,
                            0x56,
                            0x3e,
                            0x4b,
                            0xc6,
                            0xd2,
                            0x79,
                            0x20,
                            0x9a,
                            0xdb,
                            0xc0,
                            0xfe,
                            0x78,
                            0xcd,
                            0x5a,
                            0xf4,
                            0x1f,
                            0xdd,
                            0xa8,
                            0x33,
                            0x88,
                            0x07,
                            0xc7,
                            0x31,
                            0xb1,
                            0x12,
                            0x10,
                            0x59,
                            0x27,
                            0x80,
                            0xec,
                            0x5f,
                            0x60,
                            0x51,
                            0x7f,
                            0xa9,
                            0x19,
                            0xb5,
                            0x4a,
                            0x0d,
                            0x2d,
                            0xe5,
                            0x7a,
                            0x9f,
                            0x93,
                            0xc9,
                            0x9c,
                            0xef,
                            0xa0,
                            0xe0,
                            0x3b,
                            0x4d,
                            0xae,
                            0x2a,
                            0xf5,
                            0xb0,
                            0xc8,
                            0xeb,
                            0xbb,
                            0x3c,
                            0x83,
                            0x53,
                            0x99,
                            0x61,
                            0x17,
                            0x2b,
                            0x04,
                            0x7e,
                            0xba,
                            0x77,
                            0xd6,
                            0x26,
                            0xe1,
                            0x69,
                            0x14,
                            0x63,
                            0x55,
                            0x21,
                            0x0c,
                            0x7d
                        ]);
                        this._mix = new Uint32Array([
                            0x00000000,
                            0x0e090d0b,
                            0x1c121a16,
                            0x121b171d,
                            0x3824342c,
                            0x362d3927,
                            0x24362e3a,
                            0x2a3f2331,
                            0x70486858,
                            0x7e416553,
                            0x6c5a724e,
                            0x62537f45,
                            0x486c5c74,
                            0x4665517f,
                            0x547e4662,
                            0x5a774b69,
                            0xe090d0b0,
                            0xee99ddbb,
                            0xfc82caa6,
                            0xf28bc7ad,
                            0xd8b4e49c,
                            0xd6bde997,
                            0xc4a6fe8a,
                            0xcaaff381,
                            0x90d8b8e8,
                            0x9ed1b5e3,
                            0x8ccaa2fe,
                            0x82c3aff5,
                            0xa8fc8cc4,
                            0xa6f581cf,
                            0xb4ee96d2,
                            0xbae79bd9,
                            0xdb3bbb7b,
                            0xd532b670,
                            0xc729a16d,
                            0xc920ac66,
                            0xe31f8f57,
                            0xed16825c,
                            0xff0d9541,
                            0xf104984a,
                            0xab73d323,
                            0xa57ade28,
                            0xb761c935,
                            0xb968c43e,
                            0x9357e70f,
                            0x9d5eea04,
                            0x8f45fd19,
                            0x814cf012,
                            0x3bab6bcb,
                            0x35a266c0,
                            0x27b971dd,
                            0x29b07cd6,
                            0x038f5fe7,
                            0x0d8652ec,
                            0x1f9d45f1,
                            0x119448fa,
                            0x4be30393,
                            0x45ea0e98,
                            0x57f11985,
                            0x59f8148e,
                            0x73c737bf,
                            0x7dce3ab4,
                            0x6fd52da9,
                            0x61dc20a2,
                            0xad766df6,
                            0xa37f60fd,
                            0xb16477e0,
                            0xbf6d7aeb,
                            0x955259da,
                            0x9b5b54d1,
                            0x894043cc,
                            0x87494ec7,
                            0xdd3e05ae,
                            0xd33708a5,
                            0xc12c1fb8,
                            0xcf2512b3,
                            0xe51a3182,
                            0xeb133c89,
                            0xf9082b94,
                            0xf701269f,
                            0x4de6bd46,
                            0x43efb04d,
                            0x51f4a750,
                            0x5ffdaa5b,
                            0x75c2896a,
                            0x7bcb8461,
                            0x69d0937c,
                            0x67d99e77,
                            0x3daed51e,
                            0x33a7d815,
                            0x21bccf08,
                            0x2fb5c203,
                            0x058ae132,
                            0x0b83ec39,
                            0x1998fb24,
                            0x1791f62f,
                            0x764dd68d,
                            0x7844db86,
                            0x6a5fcc9b,
                            0x6456c190,
                            0x4e69e2a1,
                            0x4060efaa,
                            0x527bf8b7,
                            0x5c72f5bc,
                            0x0605bed5,
                            0x080cb3de,
                            0x1a17a4c3,
                            0x141ea9c8,
                            0x3e218af9,
                            0x302887f2,
                            0x223390ef,
                            0x2c3a9de4,
                            0x96dd063d,
                            0x98d40b36,
                            0x8acf1c2b,
                            0x84c61120,
                            0xaef93211,
                            0xa0f03f1a,
                            0xb2eb2807,
                            0xbce2250c,
                            0xe6956e65,
                            0xe89c636e,
                            0xfa877473,
                            0xf48e7978,
                            0xdeb15a49,
                            0xd0b85742,
                            0xc2a3405f,
                            0xccaa4d54,
                            0x41ecdaf7,
                            0x4fe5d7fc,
                            0x5dfec0e1,
                            0x53f7cdea,
                            0x79c8eedb,
                            0x77c1e3d0,
                            0x65daf4cd,
                            0x6bd3f9c6,
                            0x31a4b2af,
                            0x3fadbfa4,
                            0x2db6a8b9,
                            0x23bfa5b2,
                            0x09808683,
                            0x07898b88,
                            0x15929c95,
                            0x1b9b919e,
                            0xa17c0a47,
                            0xaf75074c,
                            0xbd6e1051,
                            0xb3671d5a,
                            0x99583e6b,
                            0x97513360,
                            0x854a247d,
                            0x8b432976,
                            0xd134621f,
                            0xdf3d6f14,
                            0xcd267809,
                            0xc32f7502,
                            0xe9105633,
                            0xe7195b38,
                            0xf5024c25,
                            0xfb0b412e,
                            0x9ad7618c,
                            0x94de6c87,
                            0x86c57b9a,
                            0x88cc7691,
                            0xa2f355a0,
                            0xacfa58ab,
                            0xbee14fb6,
                            0xb0e842bd,
                            0xea9f09d4,
                            0xe49604df,
                            0xf68d13c2,
                            0xf8841ec9,
                            0xd2bb3df8,
                            0xdcb230f3,
                            0xcea927ee,
                            0xc0a02ae5,
                            0x7a47b13c,
                            0x744ebc37,
                            0x6655ab2a,
                            0x685ca621,
                            0x42638510,
                            0x4c6a881b,
                            0x5e719f06,
                            0x5078920d,
                            0x0a0fd964,
                            0x0406d46f,
                            0x161dc372,
                            0x1814ce79,
                            0x322bed48,
                            0x3c22e043,
                            0x2e39f75e,
                            0x2030fa55,
                            0xec9ab701,
                            0xe293ba0a,
                            0xf088ad17,
                            0xfe81a01c,
                            0xd4be832d,
                            0xdab78e26,
                            0xc8ac993b,
                            0xc6a59430,
                            0x9cd2df59,
                            0x92dbd252,
                            0x80c0c54f,
                            0x8ec9c844,
                            0xa4f6eb75,
                            0xaaffe67e,
                            0xb8e4f163,
                            0xb6edfc68,
                            0x0c0a67b1,
                            0x02036aba,
                            0x10187da7,
                            0x1e1170ac,
                            0x342e539d,
                            0x3a275e96,
                            0x283c498b,
                            0x26354480,
                            0x7c420fe9,
                            0x724b02e2,
                            0x605015ff,
                            0x6e5918f4,
                            0x44663bc5,
                            0x4a6f36ce,
                            0x587421d3,
                            0x567d2cd8,
                            0x37a10c7a,
                            0x39a80171,
                            0x2bb3166c,
                            0x25ba1b67,
                            0x0f853856,
                            0x018c355d,
                            0x13972240,
                            0x1d9e2f4b,
                            0x47e96422,
                            0x49e06929,
                            0x5bfb7e34,
                            0x55f2733f,
                            0x7fcd500e,
                            0x71c45d05,
                            0x63df4a18,
                            0x6dd64713,
                            0xd731dcca,
                            0xd938d1c1,
                            0xcb23c6dc,
                            0xc52acbd7,
                            0xef15e8e6,
                            0xe11ce5ed,
                            0xf307f2f0,
                            0xfd0efffb,
                            0xa779b492,
                            0xa970b999,
                            0xbb6bae84,
                            0xb562a38f,
                            0x9f5d80be,
                            0x91548db5,
                            0x834f9aa8,
                            0x8d4697a3
                        ]);
                        this._mixCol = new Uint8Array(256);
                        for(let i = 0; i < 256; i++)this._mixCol[i] = i < 128 ? i << 1 : i << 1 ^ 0x1b;
                        this.buffer = new Uint8Array(16);
                        this.bufferPosition = 0;
                    }
                    _expandKey(cipherKey) {
                        (0, _util.unreachable)("Cannot call `_expandKey` on the base class");
                    }
                    _decrypt(input, key) {
                        let t, u, v;
                        const state = new Uint8Array(16);
                        state.set(input);
                        for(let j = 0, k = this._keySize; j < 16; ++j, ++k)state[j] ^= key[k];
                        for(let i = this._cyclesOfRepetition - 1; i >= 1; --i){
                            t = state[13];
                            state[13] = state[9];
                            state[9] = state[5];
                            state[5] = state[1];
                            state[1] = t;
                            t = state[14];
                            u = state[10];
                            state[14] = state[6];
                            state[10] = state[2];
                            state[6] = t;
                            state[2] = u;
                            t = state[15];
                            u = state[11];
                            v = state[7];
                            state[15] = state[3];
                            state[11] = t;
                            state[7] = u;
                            state[3] = v;
                            for(let j = 0; j < 16; ++j)state[j] = this._inv_s[state[j]];
                            for(let j = 0, k = i * 16; j < 16; ++j, ++k)state[j] ^= key[k];
                            for(let j = 0; j < 16; j += 4){
                                const s0 = this._mix[state[j]];
                                const s1 = this._mix[state[j + 1]];
                                const s2 = this._mix[state[j + 2]];
                                const s3 = this._mix[state[j + 3]];
                                t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
                                state[j] = t >>> 24 & 0xff;
                                state[j + 1] = t >> 16 & 0xff;
                                state[j + 2] = t >> 8 & 0xff;
                                state[j + 3] = t & 0xff;
                            }
                        }
                        t = state[13];
                        state[13] = state[9];
                        state[9] = state[5];
                        state[5] = state[1];
                        state[1] = t;
                        t = state[14];
                        u = state[10];
                        state[14] = state[6];
                        state[10] = state[2];
                        state[6] = t;
                        state[2] = u;
                        t = state[15];
                        u = state[11];
                        v = state[7];
                        state[15] = state[3];
                        state[11] = t;
                        state[7] = u;
                        state[3] = v;
                        for(let j = 0; j < 16; ++j){
                            state[j] = this._inv_s[state[j]];
                            state[j] ^= key[j];
                        }
                        return state;
                    }
                    _encrypt(input, key) {
                        const s = this._s;
                        let t, u, v;
                        const state = new Uint8Array(16);
                        state.set(input);
                        for(let j = 0; j < 16; ++j)state[j] ^= key[j];
                        for(let i = 1; i < this._cyclesOfRepetition; i++){
                            for(let j = 0; j < 16; ++j)state[j] = s[state[j]];
                            v = state[1];
                            state[1] = state[5];
                            state[5] = state[9];
                            state[9] = state[13];
                            state[13] = v;
                            v = state[2];
                            u = state[6];
                            state[2] = state[10];
                            state[6] = state[14];
                            state[10] = v;
                            state[14] = u;
                            v = state[3];
                            u = state[7];
                            t = state[11];
                            state[3] = state[15];
                            state[7] = v;
                            state[11] = u;
                            state[15] = t;
                            for(let j = 0; j < 16; j += 4){
                                const s0 = state[j + 0];
                                const s1 = state[j + 1];
                                const s2 = state[j + 2];
                                const s3 = state[j + 3];
                                t = s0 ^ s1 ^ s2 ^ s3;
                                state[j + 0] ^= t ^ this._mixCol[s0 ^ s1];
                                state[j + 1] ^= t ^ this._mixCol[s1 ^ s2];
                                state[j + 2] ^= t ^ this._mixCol[s2 ^ s3];
                                state[j + 3] ^= t ^ this._mixCol[s3 ^ s0];
                            }
                            for(let j = 0, k = i * 16; j < 16; ++j, ++k)state[j] ^= key[k];
                        }
                        for(let j = 0; j < 16; ++j)state[j] = s[state[j]];
                        v = state[1];
                        state[1] = state[5];
                        state[5] = state[9];
                        state[9] = state[13];
                        state[13] = v;
                        v = state[2];
                        u = state[6];
                        state[2] = state[10];
                        state[6] = state[14];
                        state[10] = v;
                        state[14] = u;
                        v = state[3];
                        u = state[7];
                        t = state[11];
                        state[3] = state[15];
                        state[7] = v;
                        state[11] = u;
                        state[15] = t;
                        for(let j = 0, k = this._keySize; j < 16; ++j, ++k)state[j] ^= key[k];
                        return state;
                    }
                    _decryptBlock2(data, finalize) {
                        const sourceLength = data.length;
                        let buffer = this.buffer, bufferLength = this.bufferPosition;
                        const result = [];
                        let iv = this.iv;
                        for(let i = 0; i < sourceLength; ++i){
                            buffer[bufferLength] = data[i];
                            ++bufferLength;
                            if (bufferLength < 16) continue;
                            const plain = this._decrypt(buffer, this._key);
                            for(let j = 0; j < 16; ++j)plain[j] ^= iv[j];
                            iv = buffer;
                            result.push(plain);
                            buffer = new Uint8Array(16);
                            bufferLength = 0;
                        }
                        this.buffer = buffer;
                        this.bufferLength = bufferLength;
                        this.iv = iv;
                        if (result.length === 0) return new Uint8Array(0);
                        let outputLength = 16 * result.length;
                        if (finalize) {
                            const lastBlock = result.at(-1);
                            let psLen = lastBlock[15];
                            if (psLen <= 16) {
                                for(let i = 15, ii = 16 - psLen; i >= ii; --i)if (lastBlock[i] !== psLen) {
                                    psLen = 0;
                                    break;
                                }
                                outputLength -= psLen;
                                result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
                            }
                        }
                        const output = new Uint8Array(outputLength);
                        for(let i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16)output.set(result[i], j);
                        return output;
                    }
                    decryptBlock(data, finalize, iv = null) {
                        const sourceLength = data.length;
                        const buffer = this.buffer;
                        let bufferLength = this.bufferPosition;
                        if (iv) this.iv = iv;
                        else {
                            for(let i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength)buffer[bufferLength] = data[i];
                            if (bufferLength < 16) {
                                this.bufferLength = bufferLength;
                                return new Uint8Array(0);
                            }
                            this.iv = buffer;
                            data = data.subarray(16);
                        }
                        this.buffer = new Uint8Array(16);
                        this.bufferLength = 0;
                        this.decryptBlock = this._decryptBlock2;
                        return this.decryptBlock(data, finalize);
                    }
                    encrypt(data, iv) {
                        const sourceLength = data.length;
                        let buffer = this.buffer, bufferLength = this.bufferPosition;
                        const result = [];
                        if (!iv) iv = new Uint8Array(16);
                        for(let i = 0; i < sourceLength; ++i){
                            buffer[bufferLength] = data[i];
                            ++bufferLength;
                            if (bufferLength < 16) continue;
                            for(let j = 0; j < 16; ++j)buffer[j] ^= iv[j];
                            const cipher = this._encrypt(buffer, this._key);
                            iv = cipher;
                            result.push(cipher);
                            buffer = new Uint8Array(16);
                            bufferLength = 0;
                        }
                        this.buffer = buffer;
                        this.bufferLength = bufferLength;
                        this.iv = iv;
                        if (result.length === 0) return new Uint8Array(0);
                        const outputLength = 16 * result.length;
                        const output = new Uint8Array(outputLength);
                        for(let i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16)output.set(result[i], j);
                        return output;
                    }
                }
                class AES128Cipher extends AESBaseCipher {
                    constructor(key){
                        super();
                        this._cyclesOfRepetition = 10;
                        this._keySize = 160;
                        this._rcon = new Uint8Array([
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d
                        ]);
                        this._key = this._expandKey(key);
                    }
                    _expandKey(cipherKey) {
                        const b = 176;
                        const s = this._s;
                        const rcon = this._rcon;
                        const result = new Uint8Array(b);
                        result.set(cipherKey);
                        for(let j = 16, i = 1; j < b; ++i){
                            let t1 = result[j - 3];
                            let t2 = result[j - 2];
                            let t3 = result[j - 1];
                            let t4 = result[j - 4];
                            t1 = s[t1];
                            t2 = s[t2];
                            t3 = s[t3];
                            t4 = s[t4];
                            t1 ^= rcon[i];
                            for(let n = 0; n < 4; ++n){
                                result[j] = t1 ^= result[j - 16];
                                j++;
                                result[j] = t2 ^= result[j - 16];
                                j++;
                                result[j] = t3 ^= result[j - 16];
                                j++;
                                result[j] = t4 ^= result[j - 16];
                                j++;
                            }
                        }
                        return result;
                    }
                }
                exports.AES128Cipher = AES128Cipher;
                class AES256Cipher extends AESBaseCipher {
                    constructor(key){
                        super();
                        this._cyclesOfRepetition = 14;
                        this._keySize = 224;
                        this._key = this._expandKey(key);
                    }
                    _expandKey(cipherKey) {
                        const b = 240;
                        const s = this._s;
                        const result = new Uint8Array(b);
                        result.set(cipherKey);
                        let r = 1;
                        let t1, t2, t3, t4;
                        for(let j = 32, i = 1; j < b; ++i){
                            if (j % 32 === 16) {
                                t1 = s[t1];
                                t2 = s[t2];
                                t3 = s[t3];
                                t4 = s[t4];
                            } else if (j % 32 === 0) {
                                t1 = result[j - 3];
                                t2 = result[j - 2];
                                t3 = result[j - 1];
                                t4 = result[j - 4];
                                t1 = s[t1];
                                t2 = s[t2];
                                t3 = s[t3];
                                t4 = s[t4];
                                t1 ^= r;
                                if ((r <<= 1) >= 256) r = (r ^ 0x1b) & 0xff;
                            }
                            for(let n = 0; n < 4; ++n){
                                result[j] = t1 ^= result[j - 32];
                                j++;
                                result[j] = t2 ^= result[j - 32];
                                j++;
                                result[j] = t3 ^= result[j - 32];
                                j++;
                                result[j] = t4 ^= result[j - 32];
                                j++;
                            }
                        }
                        return result;
                    }
                }
                exports.AES256Cipher = AES256Cipher;
                class PDF17 {
                    checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerValidationSalt, password.length);
                        hashData.set(userBytes, password.length + ownerValidationSalt.length);
                        const result = calculateSHA256(hashData, 0, hashData.length);
                        return (0, _util.isArrayEqual)(result, ownerPassword);
                    }
                    checkUserPassword(password, userValidationSalt, userPassword) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userValidationSalt, password.length);
                        const result = calculateSHA256(hashData, 0, hashData.length);
                        return (0, _util.isArrayEqual)(result, userPassword);
                    }
                    getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerKeySalt, password.length);
                        hashData.set(userBytes, password.length + ownerKeySalt.length);
                        const key = calculateSHA256(hashData, 0, hashData.length);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
                    }
                    getUserKey(password, userKeySalt, userEncryption) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userKeySalt, password.length);
                        const key = calculateSHA256(hashData, 0, hashData.length);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
                    }
                }
                exports.PDF17 = PDF17;
                class PDF20 {
                    _hash(password, input, userBytes) {
                        let k = calculateSHA256(input, 0, input.length).subarray(0, 32);
                        let e = [
                            0
                        ];
                        let i = 0;
                        while(i < 64 || e.at(-1) > i - 32){
                            const combinedLength = password.length + k.length + userBytes.length, combinedArray = new Uint8Array(combinedLength);
                            let writeOffset = 0;
                            combinedArray.set(password, writeOffset);
                            writeOffset += password.length;
                            combinedArray.set(k, writeOffset);
                            writeOffset += k.length;
                            combinedArray.set(userBytes, writeOffset);
                            const k1 = new Uint8Array(combinedLength * 64);
                            for(let j = 0, pos = 0; j < 64; j++, pos += combinedLength)k1.set(combinedArray, pos);
                            const cipher = new AES128Cipher(k.subarray(0, 16));
                            e = cipher.encrypt(k1, k.subarray(16, 32));
                            const remainder = e.slice(0, 16).reduce((a, b)=>a + b, 0) % 3;
                            if (remainder === 0) k = calculateSHA256(e, 0, e.length);
                            else if (remainder === 1) k = calculateSHA384(e, 0, e.length);
                            else if (remainder === 2) k = calculateSHA512(e, 0, e.length);
                            i++;
                        }
                        return k.subarray(0, 32);
                    }
                    checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerValidationSalt, password.length);
                        hashData.set(userBytes, password.length + ownerValidationSalt.length);
                        const result = this._hash(password, hashData, userBytes);
                        return (0, _util.isArrayEqual)(result, ownerPassword);
                    }
                    checkUserPassword(password, userValidationSalt, userPassword) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userValidationSalt, password.length);
                        const result = this._hash(password, hashData, []);
                        return (0, _util.isArrayEqual)(result, userPassword);
                    }
                    getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerKeySalt, password.length);
                        hashData.set(userBytes, password.length + ownerKeySalt.length);
                        const key = this._hash(password, hashData, userBytes);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
                    }
                    getUserKey(password, userKeySalt, userEncryption) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userKeySalt, password.length);
                        const key = this._hash(password, hashData, []);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
                    }
                }
                exports.PDF20 = PDF20;
                class CipherTransform {
                    constructor(stringCipherConstructor, streamCipherConstructor){
                        this.StringCipherConstructor = stringCipherConstructor;
                        this.StreamCipherConstructor = streamCipherConstructor;
                    }
                    createStream(stream, length) {
                        const cipher = new this.StreamCipherConstructor();
                        return new _decrypt_stream.DecryptStream(stream, length, function cipherTransformDecryptStream(data, finalize) {
                            return cipher.decryptBlock(data, finalize);
                        });
                    }
                    decryptString(s) {
                        const cipher = new this.StringCipherConstructor();
                        let data = (0, _util.stringToBytes)(s);
                        data = cipher.decryptBlock(data, true);
                        return (0, _util.bytesToString)(data);
                    }
                    encryptString(s) {
                        const cipher = new this.StringCipherConstructor();
                        if (cipher instanceof AESBaseCipher) {
                            const strLen = s.length;
                            const pad = 16 - strLen % 16;
                            s += String.fromCharCode(pad).repeat(pad);
                            const iv = new Uint8Array(16);
                            if (typeof crypto !== "undefined") crypto.getRandomValues(iv);
                            else for(let i = 0; i < 16; i++)iv[i] = Math.floor(256 * Math.random());
                            let data = (0, _util.stringToBytes)(s);
                            data = cipher.encrypt(data, iv);
                            const buf = new Uint8Array(16 + data.length);
                            buf.set(iv);
                            buf.set(data, 16);
                            return (0, _util.bytesToString)(buf);
                        }
                        let data = (0, _util.stringToBytes)(s);
                        data = cipher.encrypt(data);
                        return (0, _util.bytesToString)(data);
                    }
                }
                class CipherTransformFactory {
                    static #defaultPasswordBytes = new Uint8Array([
                        0x28,
                        0xbf,
                        0x4e,
                        0x5e,
                        0x4e,
                        0x75,
                        0x8a,
                        0x41,
                        0x64,
                        0x00,
                        0x4e,
                        0x56,
                        0xff,
                        0xfa,
                        0x01,
                        0x08,
                        0x2e,
                        0x2e,
                        0x00,
                        0xb6,
                        0xd0,
                        0x68,
                        0x3e,
                        0x80,
                        0x2f,
                        0x0c,
                        0xa9,
                        0xfe,
                        0x64,
                        0x53,
                        0x69,
                        0x7a
                    ]);
                    #createEncryptionKey20(revision, password, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms) {
                        if (password) {
                            const passwordLength = Math.min(127, password.length);
                            password = password.subarray(0, passwordLength);
                        } else password = [];
                        const pdfAlgorithm = revision === 6 ? new PDF20() : new PDF17();
                        if (pdfAlgorithm.checkUserPassword(password, userValidationSalt, userPassword)) return pdfAlgorithm.getUserKey(password, userKeySalt, userEncryption);
                        else if (password.length && pdfAlgorithm.checkOwnerPassword(password, ownerValidationSalt, uBytes, ownerPassword)) return pdfAlgorithm.getOwnerKey(password, ownerKeySalt, uBytes, ownerEncryption);
                        return null;
                    }
                    #prepareKeyData(fileId, password, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata) {
                        const hashDataSize = 40 + ownerPassword.length + fileId.length;
                        const hashData = new Uint8Array(hashDataSize);
                        let i = 0, j, n;
                        if (password) {
                            n = Math.min(32, password.length);
                            for(; i < n; ++i)hashData[i] = password[i];
                        }
                        j = 0;
                        while(i < 32)hashData[i++] = CipherTransformFactory.#defaultPasswordBytes[j++];
                        for(j = 0, n = ownerPassword.length; j < n; ++j)hashData[i++] = ownerPassword[j];
                        hashData[i++] = flags & 0xff;
                        hashData[i++] = flags >> 8 & 0xff;
                        hashData[i++] = flags >> 16 & 0xff;
                        hashData[i++] = flags >>> 24 & 0xff;
                        for(j = 0, n = fileId.length; j < n; ++j)hashData[i++] = fileId[j];
                        if (revision >= 4 && !encryptMetadata) {
                            hashData[i++] = 0xff;
                            hashData[i++] = 0xff;
                            hashData[i++] = 0xff;
                            hashData[i++] = 0xff;
                        }
                        let hash = calculateMD5(hashData, 0, i);
                        const keyLengthInBytes = keyLength >> 3;
                        if (revision >= 3) for(j = 0; j < 50; ++j)hash = calculateMD5(hash, 0, keyLengthInBytes);
                        const encryptionKey = hash.subarray(0, keyLengthInBytes);
                        let cipher, checkData;
                        if (revision >= 3) {
                            for(i = 0; i < 32; ++i)hashData[i] = CipherTransformFactory.#defaultPasswordBytes[i];
                            for(j = 0, n = fileId.length; j < n; ++j)hashData[i++] = fileId[j];
                            cipher = new ARCFourCipher(encryptionKey);
                            checkData = cipher.encryptBlock(calculateMD5(hashData, 0, i));
                            n = encryptionKey.length;
                            const derivedKey = new Uint8Array(n);
                            for(j = 1; j <= 19; ++j){
                                for(let k = 0; k < n; ++k)derivedKey[k] = encryptionKey[k] ^ j;
                                cipher = new ARCFourCipher(derivedKey);
                                checkData = cipher.encryptBlock(checkData);
                            }
                            for(j = 0, n = checkData.length; j < n; ++j){
                                if (userPassword[j] !== checkData[j]) return null;
                            }
                        } else {
                            cipher = new ARCFourCipher(encryptionKey);
                            checkData = cipher.encryptBlock(CipherTransformFactory.#defaultPasswordBytes);
                            for(j = 0, n = checkData.length; j < n; ++j){
                                if (userPassword[j] !== checkData[j]) return null;
                            }
                        }
                        return encryptionKey;
                    }
                    #decodeUserPassword(password, ownerPassword, revision, keyLength) {
                        const hashData = new Uint8Array(32);
                        let i = 0;
                        const n = Math.min(32, password.length);
                        for(; i < n; ++i)hashData[i] = password[i];
                        let j = 0;
                        while(i < 32)hashData[i++] = CipherTransformFactory.#defaultPasswordBytes[j++];
                        let hash = calculateMD5(hashData, 0, i);
                        const keyLengthInBytes = keyLength >> 3;
                        if (revision >= 3) for(j = 0; j < 50; ++j)hash = calculateMD5(hash, 0, hash.length);
                        let cipher, userPassword;
                        if (revision >= 3) {
                            userPassword = ownerPassword;
                            const derivedKey = new Uint8Array(keyLengthInBytes);
                            for(j = 19; j >= 0; j--){
                                for(let k = 0; k < keyLengthInBytes; ++k)derivedKey[k] = hash[k] ^ j;
                                cipher = new ARCFourCipher(derivedKey);
                                userPassword = cipher.encryptBlock(userPassword);
                            }
                        } else {
                            cipher = new ARCFourCipher(hash.subarray(0, keyLengthInBytes));
                            userPassword = cipher.encryptBlock(ownerPassword);
                        }
                        return userPassword;
                    }
                    #buildObjectKey(num, gen, encryptionKey, isAes = false) {
                        const key = new Uint8Array(encryptionKey.length + 9);
                        const n = encryptionKey.length;
                        let i;
                        for(i = 0; i < n; ++i)key[i] = encryptionKey[i];
                        key[i++] = num & 0xff;
                        key[i++] = num >> 8 & 0xff;
                        key[i++] = num >> 16 & 0xff;
                        key[i++] = gen & 0xff;
                        key[i++] = gen >> 8 & 0xff;
                        if (isAes) {
                            key[i++] = 0x73;
                            key[i++] = 0x41;
                            key[i++] = 0x6c;
                            key[i++] = 0x54;
                        }
                        const hash = calculateMD5(key, 0, i);
                        return hash.subarray(0, Math.min(encryptionKey.length + 5, 16));
                    }
                    #buildCipherConstructor(cf, name, num, gen, key) {
                        if (!(name instanceof _primitives.Name)) throw new _util.FormatError("Invalid crypt filter name.");
                        const self1 = this;
                        const cryptFilter = cf.get(name.name);
                        const cfm = cryptFilter?.get("CFM");
                        if (!cfm || cfm.name === "None") return function() {
                            return new NullCipher();
                        };
                        if (cfm.name === "V2") return function() {
                            return new ARCFourCipher(self1.#buildObjectKey(num, gen, key, false));
                        };
                        if (cfm.name === "AESV2") return function() {
                            return new AES128Cipher(self1.#buildObjectKey(num, gen, key, true));
                        };
                        if (cfm.name === "AESV3") return function() {
                            return new AES256Cipher(key);
                        };
                        throw new _util.FormatError("Unknown crypto method");
                    }
                    constructor(dict, fileId, password){
                        const filter = dict.get("Filter");
                        if (!(0, _primitives.isName)(filter, "Standard")) throw new _util.FormatError("unknown encryption method");
                        this.filterName = filter.name;
                        this.dict = dict;
                        const algorithm = dict.get("V");
                        if (!Number.isInteger(algorithm) || algorithm !== 1 && algorithm !== 2 && algorithm !== 4 && algorithm !== 5) throw new _util.FormatError("unsupported encryption algorithm");
                        this.algorithm = algorithm;
                        let keyLength = dict.get("Length");
                        if (!keyLength) {
                            if (algorithm <= 3) keyLength = 40;
                            else {
                                const cfDict = dict.get("CF");
                                const streamCryptoName = dict.get("StmF");
                                if (cfDict instanceof _primitives.Dict && streamCryptoName instanceof _primitives.Name) {
                                    cfDict.suppressEncryption = true;
                                    const handlerDict = cfDict.get(streamCryptoName.name);
                                    keyLength = handlerDict?.get("Length") || 128;
                                    if (keyLength < 40) keyLength <<= 3;
                                }
                            }
                        }
                        if (!Number.isInteger(keyLength) || keyLength < 40 || keyLength % 8 !== 0) throw new _util.FormatError("invalid key length");
                        const ownerBytes = (0, _util.stringToBytes)(dict.get("O")), userBytes = (0, _util.stringToBytes)(dict.get("U"));
                        const ownerPassword = ownerBytes.subarray(0, 32);
                        const userPassword = userBytes.subarray(0, 32);
                        const flags = dict.get("P");
                        const revision = dict.get("R");
                        const encryptMetadata = (algorithm === 4 || algorithm === 5) && dict.get("EncryptMetadata") !== false;
                        this.encryptMetadata = encryptMetadata;
                        const fileIdBytes = (0, _util.stringToBytes)(fileId);
                        let passwordBytes;
                        if (password) {
                            if (revision === 6) try {
                                password = (0, _util.utf8StringToString)(password);
                            } catch  {
                                (0, _util.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                            }
                            passwordBytes = (0, _util.stringToBytes)(password);
                        }
                        let encryptionKey;
                        if (algorithm !== 5) encryptionKey = this.#prepareKeyData(fileIdBytes, passwordBytes, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
                        else {
                            const ownerValidationSalt = ownerBytes.subarray(32, 40);
                            const ownerKeySalt = ownerBytes.subarray(40, 48);
                            const uBytes = userBytes.subarray(0, 48);
                            const userValidationSalt = userBytes.subarray(32, 40);
                            const userKeySalt = userBytes.subarray(40, 48);
                            const ownerEncryption = (0, _util.stringToBytes)(dict.get("OE"));
                            const userEncryption = (0, _util.stringToBytes)(dict.get("UE"));
                            const perms = (0, _util.stringToBytes)(dict.get("Perms"));
                            encryptionKey = this.#createEncryptionKey20(revision, passwordBytes, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms);
                        }
                        if (!encryptionKey && !password) throw new _util.PasswordException("No password given", _util.PasswordResponses.NEED_PASSWORD);
                        else if (!encryptionKey && password) {
                            const decodedPassword = this.#decodeUserPassword(passwordBytes, ownerPassword, revision, keyLength);
                            encryptionKey = this.#prepareKeyData(fileIdBytes, decodedPassword, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
                        }
                        if (!encryptionKey) throw new _util.PasswordException("Incorrect Password", _util.PasswordResponses.INCORRECT_PASSWORD);
                        this.encryptionKey = encryptionKey;
                        if (algorithm >= 4) {
                            const cf = dict.get("CF");
                            if (cf instanceof _primitives.Dict) cf.suppressEncryption = true;
                            this.cf = cf;
                            this.stmf = dict.get("StmF") || _primitives.Name.get("Identity");
                            this.strf = dict.get("StrF") || _primitives.Name.get("Identity");
                            this.eff = dict.get("EFF") || this.stmf;
                        }
                    }
                    createCipherTransform(num, gen) {
                        if (this.algorithm === 4 || this.algorithm === 5) return new CipherTransform(this.#buildCipherConstructor(this.cf, this.strf, num, gen, this.encryptionKey), this.#buildCipherConstructor(this.cf, this.stmf, num, gen, this.encryptionKey));
                        const key = this.#buildObjectKey(num, gen, this.encryptionKey, false);
                        const cipherConstructor = function() {
                            return new ARCFourCipher(key);
                        };
                        return new CipherTransform(cipherConstructor, cipherConstructor);
                    }
                }
                exports.CipherTransformFactory = CipherTransformFactory;
            /***/ },
            /* 75 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DecryptStream = void 0;
                var _decode_stream = __w_pdfjs_require__(18);
                const chunkSize = 512;
                class DecryptStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, decrypt){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.decrypt = decrypt;
                        this.nextChunk = null;
                        this.initialized = false;
                    }
                    readBlock() {
                        let chunk;
                        if (this.initialized) chunk = this.nextChunk;
                        else {
                            chunk = this.str.getBytes(chunkSize);
                            this.initialized = true;
                        }
                        if (!chunk || chunk.length === 0) {
                            this.eof = true;
                            return;
                        }
                        this.nextChunk = this.str.getBytes(chunkSize);
                        const hasMoreData = this.nextChunk?.length > 0;
                        const decrypt = this.decrypt;
                        chunk = decrypt(chunk, !hasMoreData);
                        const bufferLength = this.bufferLength, newLength = bufferLength + chunk.length, buffer = this.ensureBuffer(newLength);
                        buffer.set(chunk, bufferLength);
                        this.bufferLength = newLength;
                    }
                }
                exports.DecryptStream = DecryptStream;
            /***/ },
            /* 76 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ObjectLoader = void 0;
                var _primitives = __w_pdfjs_require__(4);
                var _base_stream = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(3);
                var _util = __w_pdfjs_require__(2);
                function mayHaveChildren(value) {
                    return value instanceof _primitives.Ref || value instanceof _primitives.Dict || value instanceof _base_stream.BaseStream || Array.isArray(value);
                }
                function addChildren(node, nodesToVisit) {
                    if (node instanceof _primitives.Dict) node = node.getRawValues();
                    else if (node instanceof _base_stream.BaseStream) node = node.dict.getRawValues();
                    else if (!Array.isArray(node)) return;
                    for (const rawValue of node)if (mayHaveChildren(rawValue)) nodesToVisit.push(rawValue);
                }
                class ObjectLoader {
                    constructor(dict, keys, xref){
                        this.dict = dict;
                        this.keys = keys;
                        this.xref = xref;
                        this.refSet = null;
                    }
                    async load() {
                        if (this.xref.stream.isDataLoaded) return undefined;
                        const { keys: keys, dict: dict } = this;
                        this.refSet = new _primitives.RefSet();
                        const nodesToVisit = [];
                        for (const key of keys){
                            const rawValue = dict.getRaw(key);
                            if (rawValue !== undefined) nodesToVisit.push(rawValue);
                        }
                        return this._walk(nodesToVisit);
                    }
                    async _walk(nodesToVisit) {
                        const nodesToRevisit = [];
                        const pendingRequests = [];
                        while(nodesToVisit.length){
                            let currentNode = nodesToVisit.pop();
                            if (currentNode instanceof _primitives.Ref) {
                                if (this.refSet.has(currentNode)) continue;
                                try {
                                    this.refSet.put(currentNode);
                                    currentNode = this.xref.fetch(currentNode);
                                } catch (ex) {
                                    if (!(ex instanceof _core_utils.MissingDataException)) {
                                        (0, _util.warn)(`ObjectLoader._walk - requesting all data: "${ex}".`);
                                        this.refSet = null;
                                        const { manager: manager } = this.xref.stream;
                                        return manager.requestAllChunks();
                                    }
                                    nodesToRevisit.push(currentNode);
                                    pendingRequests.push({
                                        begin: ex.begin,
                                        end: ex.end
                                    });
                                }
                            }
                            if (currentNode instanceof _base_stream.BaseStream) {
                                const baseStreams = currentNode.getBaseStreams();
                                if (baseStreams) {
                                    let foundMissingData = false;
                                    for (const stream of baseStreams){
                                        if (stream.isDataLoaded) continue;
                                        foundMissingData = true;
                                        pendingRequests.push({
                                            begin: stream.start,
                                            end: stream.end
                                        });
                                    }
                                    if (foundMissingData) nodesToRevisit.push(currentNode);
                                }
                            }
                            addChildren(currentNode, nodesToVisit);
                        }
                        if (pendingRequests.length) {
                            await this.xref.stream.manager.requestRanges(pendingRequests);
                            for (const node of nodesToRevisit)if (node instanceof _primitives.Ref) this.refSet.remove(node);
                            return this._walk(nodesToRevisit);
                        }
                        this.refSet = null;
                        return undefined;
                    }
                }
                exports.ObjectLoader = ObjectLoader;
            /***/ },
            /* 77 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XFAFactory = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _bind = __w_pdfjs_require__(79);
                var _data = __w_pdfjs_require__(89);
                var _fonts = __w_pdfjs_require__(85);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                var _parser = __w_pdfjs_require__(90);
                var _xhtml = __w_pdfjs_require__(100);
                class XFAFactory {
                    constructor(data){
                        try {
                            this.root = new _parser.XFAParser().parse(XFAFactory._createDocument(data));
                            const binder = new _bind.Binder(this.root);
                            this.form = binder.bind();
                            this.dataHandler = new _data.DataHandler(this.root, binder.getData());
                            this.form[_symbol_utils.$globalData].template = this.form;
                        } catch (e) {
                            (0, _util.warn)(`XFA - an error occurred during parsing and binding: ${e}`);
                        }
                    }
                    isValid() {
                        return this.root && this.form;
                    }
                    _createPagesHelper() {
                        const iterator = this.form[_symbol_utils.$toPages]();
                        return new Promise((resolve, reject)=>{
                            const nextIteration = ()=>{
                                try {
                                    const value = iterator.next();
                                    if (value.done) resolve(value.value);
                                    else setTimeout(nextIteration, 0);
                                } catch (e) {
                                    reject(e);
                                }
                            };
                            setTimeout(nextIteration, 0);
                        });
                    }
                    async _createPages() {
                        try {
                            this.pages = await this._createPagesHelper();
                            this.dims = this.pages.children.map((c)=>{
                                const { width: width, height: height } = c.attributes.style;
                                return [
                                    0,
                                    0,
                                    parseInt(width),
                                    parseInt(height)
                                ];
                            });
                        } catch (e) {
                            (0, _util.warn)(`XFA - an error occurred during layout: ${e}`);
                        }
                    }
                    getBoundingBox(pageIndex) {
                        return this.dims[pageIndex];
                    }
                    async getNumPages() {
                        if (!this.pages) await this._createPages();
                        return this.dims.length;
                    }
                    setImages(images) {
                        this.form[_symbol_utils.$globalData].images = images;
                    }
                    setFonts(fonts) {
                        this.form[_symbol_utils.$globalData].fontFinder = new _fonts.FontFinder(fonts);
                        const missingFonts = [];
                        for (let typeface of this.form[_symbol_utils.$globalData].usedTypefaces){
                            typeface = (0, _utils.stripQuotes)(typeface);
                            const font1 = this.form[_symbol_utils.$globalData].fontFinder.find(typeface);
                            if (!font1) missingFonts.push(typeface);
                        }
                        if (missingFonts.length > 0) return missingFonts;
                        return null;
                    }
                    appendFonts(fonts, reallyMissingFonts) {
                        this.form[_symbol_utils.$globalData].fontFinder.add(fonts, reallyMissingFonts);
                    }
                    async getPages() {
                        if (!this.pages) await this._createPages();
                        const pages = this.pages;
                        this.pages = null;
                        return pages;
                    }
                    serializeData(storage) {
                        return this.dataHandler.serialize(storage);
                    }
                    static _createDocument(data) {
                        if (!data["/xdp:xdp"]) return data["xdp:xdp"];
                        return Object.values(data).join("");
                    }
                    static getRichTextAsHtml(rc) {
                        if (!rc || typeof rc !== "string") return null;
                        try {
                            let root = new _parser.XFAParser(_xhtml.XhtmlNamespace, true).parse(rc);
                            if (![
                                "body",
                                "xhtml"
                            ].includes(root[_symbol_utils.$nodeName])) {
                                const newRoot = _xhtml.XhtmlNamespace.body({});
                                newRoot[_symbol_utils.$appendChild](root);
                                root = newRoot;
                            }
                            const result = root[_symbol_utils.$toHTML]();
                            if (!result.success) return null;
                            const { html: html } = result;
                            const { attributes: attributes } = html;
                            if (attributes) {
                                if (attributes.class) attributes.class = attributes.class.filter((attr)=>!attr.startsWith("xfa"));
                                attributes.dir = "auto";
                            }
                            return {
                                html: html,
                                str: root[_symbol_utils.$text]()
                            };
                        } catch (e) {
                            (0, _util.warn)(`XFA - an error occurred during parsing of rich text: ${e}`);
                        }
                        return null;
                    }
                }
                exports.XFAFactory = XFAFactory;
            /***/ },
            /* 78 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.$uid = exports.$toStyle = exports.$toString = exports.$toPages = exports.$toHTML = exports.$text = exports.$tabIndex = exports.$setValue = exports.$setSetAttributes = exports.$setId = exports.$searchNode = exports.$root = exports.$resolvePrototypes = exports.$removeChild = exports.$pushPara = exports.$pushGlyphs = exports.$popPara = exports.$onText = exports.$onChildCheck = exports.$onChild = exports.$nsAttributes = exports.$nodeName = exports.$namespaceId = exports.$lastAttribute = exports.$isUsable = exports.$isTransparent = exports.$isThereMoreWidth = exports.$isSplittable = exports.$isNsAgnostic = exports.$isDescendent = exports.$isDataValue = exports.$isCDATAXml = exports.$isBindable = exports.$insertAt = exports.$indexOf = exports.$ids = exports.$hasSettableValue = exports.$globalData = exports.$getTemplateRoot = exports.$getSubformParent = exports.$getRealChildrenByNameIt = exports.$getParent = exports.$getNextPage = exports.$getExtra = exports.$getDataValue = exports.$getContainedChildren = exports.$getChildrenByNameIt = exports.$getChildrenByName = exports.$getChildrenByClass = exports.$getChildren = exports.$getAvailableSpace = exports.$getAttributes = exports.$getAttributeIt = exports.$flushHTML = exports.$finalize = exports.$extra = exports.$dump = exports.$data = exports.$content = exports.$consumed = exports.$clone = exports.$cleanup = exports.$cleanPage = exports.$clean = exports.$childrenToHTML = exports.$appendChild = exports.$addHTML = exports.$acceptWhitespace = void 0;
                const $acceptWhitespace = Symbol();
                exports.$acceptWhitespace = $acceptWhitespace;
                const $addHTML = Symbol();
                exports.$addHTML = $addHTML;
                const $appendChild = Symbol();
                exports.$appendChild = $appendChild;
                const $childrenToHTML = Symbol();
                exports.$childrenToHTML = $childrenToHTML;
                const $clean = Symbol();
                exports.$clean = $clean;
                const $cleanPage = Symbol();
                exports.$cleanPage = $cleanPage;
                const $cleanup = Symbol();
                exports.$cleanup = $cleanup;
                const $clone = Symbol();
                exports.$clone = $clone;
                const $consumed = Symbol();
                exports.$consumed = $consumed;
                const $content = Symbol("content");
                exports.$content = $content;
                const $data = Symbol("data");
                exports.$data = $data;
                const $dump = Symbol();
                exports.$dump = $dump;
                const $extra = Symbol("extra");
                exports.$extra = $extra;
                const $finalize = Symbol();
                exports.$finalize = $finalize;
                const $flushHTML = Symbol();
                exports.$flushHTML = $flushHTML;
                const $getAttributeIt = Symbol();
                exports.$getAttributeIt = $getAttributeIt;
                const $getAttributes = Symbol();
                exports.$getAttributes = $getAttributes;
                const $getAvailableSpace = Symbol();
                exports.$getAvailableSpace = $getAvailableSpace;
                const $getChildrenByClass = Symbol();
                exports.$getChildrenByClass = $getChildrenByClass;
                const $getChildrenByName = Symbol();
                exports.$getChildrenByName = $getChildrenByName;
                const $getChildrenByNameIt = Symbol();
                exports.$getChildrenByNameIt = $getChildrenByNameIt;
                const $getDataValue = Symbol();
                exports.$getDataValue = $getDataValue;
                const $getExtra = Symbol();
                exports.$getExtra = $getExtra;
                const $getRealChildrenByNameIt = Symbol();
                exports.$getRealChildrenByNameIt = $getRealChildrenByNameIt;
                const $getChildren = Symbol();
                exports.$getChildren = $getChildren;
                const $getContainedChildren = Symbol();
                exports.$getContainedChildren = $getContainedChildren;
                const $getNextPage = Symbol();
                exports.$getNextPage = $getNextPage;
                const $getSubformParent = Symbol();
                exports.$getSubformParent = $getSubformParent;
                const $getParent = Symbol();
                exports.$getParent = $getParent;
                const $getTemplateRoot = Symbol();
                exports.$getTemplateRoot = $getTemplateRoot;
                const $globalData = Symbol();
                exports.$globalData = $globalData;
                const $hasSettableValue = Symbol();
                exports.$hasSettableValue = $hasSettableValue;
                const $ids = Symbol();
                exports.$ids = $ids;
                const $indexOf = Symbol();
                exports.$indexOf = $indexOf;
                const $insertAt = Symbol();
                exports.$insertAt = $insertAt;
                const $isCDATAXml = Symbol();
                exports.$isCDATAXml = $isCDATAXml;
                const $isBindable = Symbol();
                exports.$isBindable = $isBindable;
                const $isDataValue = Symbol();
                exports.$isDataValue = $isDataValue;
                const $isDescendent = Symbol();
                exports.$isDescendent = $isDescendent;
                const $isNsAgnostic = Symbol();
                exports.$isNsAgnostic = $isNsAgnostic;
                const $isSplittable = Symbol();
                exports.$isSplittable = $isSplittable;
                const $isThereMoreWidth = Symbol();
                exports.$isThereMoreWidth = $isThereMoreWidth;
                const $isTransparent = Symbol();
                exports.$isTransparent = $isTransparent;
                const $isUsable = Symbol();
                exports.$isUsable = $isUsable;
                const $lastAttribute = Symbol();
                exports.$lastAttribute = $lastAttribute;
                const $namespaceId = Symbol("namespaceId");
                exports.$namespaceId = $namespaceId;
                const $nodeName = Symbol("nodeName");
                exports.$nodeName = $nodeName;
                const $nsAttributes = Symbol();
                exports.$nsAttributes = $nsAttributes;
                const $onChild = Symbol();
                exports.$onChild = $onChild;
                const $onChildCheck = Symbol();
                exports.$onChildCheck = $onChildCheck;
                const $onText = Symbol();
                exports.$onText = $onText;
                const $pushGlyphs = Symbol();
                exports.$pushGlyphs = $pushGlyphs;
                const $popPara = Symbol();
                exports.$popPara = $popPara;
                const $pushPara = Symbol();
                exports.$pushPara = $pushPara;
                const $removeChild = Symbol();
                exports.$removeChild = $removeChild;
                const $root = Symbol("root");
                exports.$root = $root;
                const $resolvePrototypes = Symbol();
                exports.$resolvePrototypes = $resolvePrototypes;
                const $searchNode = Symbol();
                exports.$searchNode = $searchNode;
                const $setId = Symbol();
                exports.$setId = $setId;
                const $setSetAttributes = Symbol();
                exports.$setSetAttributes = $setSetAttributes;
                const $setValue = Symbol();
                exports.$setValue = $setValue;
                const $tabIndex = Symbol();
                exports.$tabIndex = $tabIndex;
                const $text = Symbol();
                exports.$text = $text;
                const $toPages = Symbol();
                exports.$toPages = $toPages;
                const $toHTML = Symbol();
                exports.$toHTML = $toHTML;
                const $toString = Symbol();
                exports.$toString = $toString;
                const $toStyle = Symbol();
                exports.$toStyle = $toStyle;
                const $uid = Symbol("uid");
                exports.$uid = $uid;
            /***/ },
            /* 79 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Binder = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _template = __w_pdfjs_require__(80);
                var _som = __w_pdfjs_require__(88);
                var _xfa_object = __w_pdfjs_require__(87);
                var _namespaces = __w_pdfjs_require__(81);
                var _util = __w_pdfjs_require__(2);
                const NS_DATASETS = _namespaces.NamespaceIds.datasets.id;
                function createText(content) {
                    const node = new _template.Text({});
                    node[_symbol_utils.$content] = content;
                    return node;
                }
                class Binder {
                    constructor(root){
                        this.root = root;
                        this.datasets = root.datasets;
                        this.data = root.datasets?.data || new _xfa_object.XmlObject(_namespaces.NamespaceIds.datasets.id, "data");
                        this.emptyMerge = this.data[_symbol_utils.$getChildren]().length === 0;
                        this.root.form = this.form = root.template[_symbol_utils.$clone]();
                    }
                    _isConsumeData() {
                        return !this.emptyMerge && this._mergeMode;
                    }
                    _isMatchTemplate() {
                        return !this._isConsumeData();
                    }
                    bind() {
                        this._bindElement(this.form, this.data);
                        return this.form;
                    }
                    getData() {
                        return this.data;
                    }
                    _bindValue(formNode, data, picture) {
                        formNode[_symbol_utils.$data] = data;
                        if (formNode[_symbol_utils.$hasSettableValue]()) {
                            if (data[_symbol_utils.$isDataValue]()) {
                                const value = data[_symbol_utils.$getDataValue]();
                                formNode[_symbol_utils.$setValue](createText(value));
                            } else if (formNode instanceof _template.Field && formNode.ui?.choiceList?.open === "multiSelect") {
                                const value = data[_symbol_utils.$getChildren]().map((child)=>child[_symbol_utils.$content].trim()).join("\n");
                                formNode[_symbol_utils.$setValue](createText(value));
                            } else if (this._isConsumeData()) (0, _util.warn)(`XFA - Nodes haven't the same type.`);
                        } else if (!data[_symbol_utils.$isDataValue]() || this._isMatchTemplate()) this._bindElement(formNode, data);
                        else (0, _util.warn)(`XFA - Nodes haven't the same type.`);
                    }
                    _findDataByNameToConsume(name, isValue, dataNode, global) {
                        if (!name) return null;
                        let generator, match;
                        for(let i = 0; i < 3; i++){
                            generator = dataNode[_symbol_utils.$getRealChildrenByNameIt](name, false, true);
                            while(true){
                                match = generator.next().value;
                                if (!match) break;
                                if (isValue === match[_symbol_utils.$isDataValue]()) return match;
                            }
                            if (dataNode[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.datasets.id && dataNode[_symbol_utils.$nodeName] === "data") break;
                            dataNode = dataNode[_symbol_utils.$getParent]();
                        }
                        if (!global) return null;
                        generator = this.data[_symbol_utils.$getRealChildrenByNameIt](name, true, false);
                        match = generator.next().value;
                        if (match) return match;
                        generator = this.data[_symbol_utils.$getAttributeIt](name, true);
                        match = generator.next().value;
                        if (match?.[_symbol_utils.$isDataValue]()) return match;
                        return null;
                    }
                    _setProperties(formNode, dataNode) {
                        if (!formNode.hasOwnProperty("setProperty")) return;
                        for (const { ref: ref, target: target, connection: connection } of formNode.setProperty.children){
                            if (connection) continue;
                            if (!ref) continue;
                            const nodes = (0, _som.searchNode)(this.root, dataNode, ref, false, false);
                            if (!nodes) {
                                (0, _util.warn)(`XFA - Invalid reference: ${ref}.`);
                                continue;
                            }
                            const [node] = nodes;
                            if (!node[_symbol_utils.$isDescendent](this.data)) {
                                (0, _util.warn)(`XFA - Invalid node: must be a data node.`);
                                continue;
                            }
                            const targetNodes = (0, _som.searchNode)(this.root, formNode, target, false, false);
                            if (!targetNodes) {
                                (0, _util.warn)(`XFA - Invalid target: ${target}.`);
                                continue;
                            }
                            const [targetNode] = targetNodes;
                            if (!targetNode[_symbol_utils.$isDescendent](formNode)) {
                                (0, _util.warn)(`XFA - Invalid target: must be a property or subproperty.`);
                                continue;
                            }
                            const targetParent = targetNode[_symbol_utils.$getParent]();
                            if (targetNode instanceof _template.SetProperty || targetParent instanceof _template.SetProperty) {
                                (0, _util.warn)(`XFA - Invalid target: cannot be a setProperty or one of its properties.`);
                                continue;
                            }
                            if (targetNode instanceof _template.BindItems || targetParent instanceof _template.BindItems) {
                                (0, _util.warn)(`XFA - Invalid target: cannot be a bindItems or one of its properties.`);
                                continue;
                            }
                            const content = node[_symbol_utils.$text]();
                            const name = targetNode[_symbol_utils.$nodeName];
                            if (targetNode instanceof _xfa_object.XFAAttribute) {
                                const attrs = Object.create(null);
                                attrs[name] = content;
                                const obj = Reflect.construct(Object.getPrototypeOf(targetParent).constructor, [
                                    attrs
                                ]);
                                targetParent[name] = obj[name];
                                continue;
                            }
                            if (!targetNode.hasOwnProperty(_symbol_utils.$content)) {
                                (0, _util.warn)(`XFA - Invalid node to use in setProperty`);
                                continue;
                            }
                            targetNode[_symbol_utils.$data] = node;
                            targetNode[_symbol_utils.$content] = content;
                            targetNode[_symbol_utils.$finalize]();
                        }
                    }
                    _bindItems(formNode, dataNode) {
                        if (!formNode.hasOwnProperty("items") || !formNode.hasOwnProperty("bindItems") || formNode.bindItems.isEmpty()) return;
                        for (const item of formNode.items.children)formNode[_symbol_utils.$removeChild](item);
                        formNode.items.clear();
                        const labels = new _template.Items({});
                        const values = new _template.Items({});
                        formNode[_symbol_utils.$appendChild](labels);
                        formNode.items.push(labels);
                        formNode[_symbol_utils.$appendChild](values);
                        formNode.items.push(values);
                        for (const { ref: ref, labelRef: labelRef, valueRef: valueRef, connection: connection } of formNode.bindItems.children){
                            if (connection) continue;
                            if (!ref) continue;
                            const nodes = (0, _som.searchNode)(this.root, dataNode, ref, false, false);
                            if (!nodes) {
                                (0, _util.warn)(`XFA - Invalid reference: ${ref}.`);
                                continue;
                            }
                            for (const node of nodes){
                                if (!node[_symbol_utils.$isDescendent](this.datasets)) {
                                    (0, _util.warn)(`XFA - Invalid ref (${ref}): must be a datasets child.`);
                                    continue;
                                }
                                const labelNodes = (0, _som.searchNode)(this.root, node, labelRef, true, false);
                                if (!labelNodes) {
                                    (0, _util.warn)(`XFA - Invalid label: ${labelRef}.`);
                                    continue;
                                }
                                const [labelNode] = labelNodes;
                                if (!labelNode[_symbol_utils.$isDescendent](this.datasets)) {
                                    (0, _util.warn)(`XFA - Invalid label: must be a datasets child.`);
                                    continue;
                                }
                                const valueNodes = (0, _som.searchNode)(this.root, node, valueRef, true, false);
                                if (!valueNodes) {
                                    (0, _util.warn)(`XFA - Invalid value: ${valueRef}.`);
                                    continue;
                                }
                                const [valueNode] = valueNodes;
                                if (!valueNode[_symbol_utils.$isDescendent](this.datasets)) {
                                    (0, _util.warn)(`XFA - Invalid value: must be a datasets child.`);
                                    continue;
                                }
                                const label = createText(labelNode[_symbol_utils.$text]());
                                const value = createText(valueNode[_symbol_utils.$text]());
                                labels[_symbol_utils.$appendChild](label);
                                labels.text.push(label);
                                values[_symbol_utils.$appendChild](value);
                                values.text.push(value);
                            }
                        }
                    }
                    _bindOccurrences(formNode, matches, picture) {
                        let baseClone;
                        if (matches.length > 1) {
                            baseClone = formNode[_symbol_utils.$clone]();
                            baseClone[_symbol_utils.$removeChild](baseClone.occur);
                            baseClone.occur = null;
                        }
                        this._bindValue(formNode, matches[0], picture);
                        this._setProperties(formNode, matches[0]);
                        this._bindItems(formNode, matches[0]);
                        if (matches.length === 1) return;
                        const parent = formNode[_symbol_utils.$getParent]();
                        const name = formNode[_symbol_utils.$nodeName];
                        const pos = parent[_symbol_utils.$indexOf](formNode);
                        for(let i = 1, ii = matches.length; i < ii; i++){
                            const match = matches[i];
                            const clone = baseClone[_symbol_utils.$clone]();
                            parent[name].push(clone);
                            parent[_symbol_utils.$insertAt](pos + i, clone);
                            this._bindValue(clone, match, picture);
                            this._setProperties(clone, match);
                            this._bindItems(clone, match);
                        }
                    }
                    _createOccurrences(formNode) {
                        if (!this.emptyMerge) return;
                        const { occur: occur } = formNode;
                        if (!occur || occur.initial <= 1) return;
                        const parent = formNode[_symbol_utils.$getParent]();
                        const name = formNode[_symbol_utils.$nodeName];
                        if (!(parent[name] instanceof _xfa_object.XFAObjectArray)) return;
                        let currentNumber;
                        if (formNode.name) currentNumber = parent[name].children.filter((e)=>e.name === formNode.name).length;
                        else currentNumber = parent[name].children.length;
                        const pos = parent[_symbol_utils.$indexOf](formNode) + 1;
                        const ii = occur.initial - currentNumber;
                        if (ii) {
                            const nodeClone = formNode[_symbol_utils.$clone]();
                            nodeClone[_symbol_utils.$removeChild](nodeClone.occur);
                            nodeClone.occur = null;
                            parent[name].push(nodeClone);
                            parent[_symbol_utils.$insertAt](pos, nodeClone);
                            for(let i = 1; i < ii; i++){
                                const clone = nodeClone[_symbol_utils.$clone]();
                                parent[name].push(clone);
                                parent[_symbol_utils.$insertAt](pos + i, clone);
                            }
                        }
                    }
                    _getOccurInfo(formNode) {
                        const { name: name, occur: occur } = formNode;
                        if (!occur || !name) return [
                            1,
                            1
                        ];
                        const max = occur.max === -1 ? Infinity : occur.max;
                        return [
                            occur.min,
                            max
                        ];
                    }
                    _setAndBind(formNode, dataNode) {
                        this._setProperties(formNode, dataNode);
                        this._bindItems(formNode, dataNode);
                        this._bindElement(formNode, dataNode);
                    }
                    _bindElement(formNode, dataNode) {
                        const uselessNodes = [];
                        this._createOccurrences(formNode);
                        for (const child of formNode[_symbol_utils.$getChildren]()){
                            if (child[_symbol_utils.$data]) continue;
                            if (this._mergeMode === undefined && child[_symbol_utils.$nodeName] === "subform") {
                                this._mergeMode = child.mergeMode === "consumeData";
                                const dataChildren = dataNode[_symbol_utils.$getChildren]();
                                if (dataChildren.length > 0) this._bindOccurrences(child, [
                                    dataChildren[0]
                                ], null);
                                else if (this.emptyMerge) {
                                    const nsId = dataNode[_symbol_utils.$namespaceId] === NS_DATASETS ? -1 : dataNode[_symbol_utils.$namespaceId];
                                    const dataChild = child[_symbol_utils.$data] = new _xfa_object.XmlObject(nsId, child.name || "root");
                                    dataNode[_symbol_utils.$appendChild](dataChild);
                                    this._bindElement(child, dataChild);
                                }
                                continue;
                            }
                            if (!child[_symbol_utils.$isBindable]()) continue;
                            let global = false;
                            let picture = null;
                            let ref = null;
                            let match = null;
                            if (child.bind) {
                                switch(child.bind.match){
                                    case "none":
                                        this._setAndBind(child, dataNode);
                                        continue;
                                    case "global":
                                        global = true;
                                        break;
                                    case "dataRef":
                                        if (!child.bind.ref) {
                                            (0, _util.warn)(`XFA - ref is empty in node ${child[_symbol_utils.$nodeName]}.`);
                                            this._setAndBind(child, dataNode);
                                            continue;
                                        }
                                        ref = child.bind.ref;
                                        break;
                                    default:
                                        break;
                                }
                                if (child.bind.picture) picture = child.bind.picture[_symbol_utils.$content];
                            }
                            const [min, max] = this._getOccurInfo(child);
                            if (ref) {
                                match = (0, _som.searchNode)(this.root, dataNode, ref, true, false);
                                if (match === null) {
                                    match = (0, _som.createDataNode)(this.data, dataNode, ref);
                                    if (!match) continue;
                                    if (this._isConsumeData()) match[_symbol_utils.$consumed] = true;
                                    this._setAndBind(child, match);
                                    continue;
                                } else {
                                    if (this._isConsumeData()) match = match.filter((node)=>!node[_symbol_utils.$consumed]);
                                    if (match.length > max) match = match.slice(0, max);
                                    else if (match.length === 0) match = null;
                                    if (match && this._isConsumeData()) match.forEach((node)=>{
                                        node[_symbol_utils.$consumed] = true;
                                    });
                                }
                            } else {
                                if (!child.name) {
                                    this._setAndBind(child, dataNode);
                                    continue;
                                }
                                if (this._isConsumeData()) {
                                    const matches = [];
                                    while(matches.length < max){
                                        const found = this._findDataByNameToConsume(child.name, child[_symbol_utils.$hasSettableValue](), dataNode, global);
                                        if (!found) break;
                                        found[_symbol_utils.$consumed] = true;
                                        matches.push(found);
                                    }
                                    match = matches.length > 0 ? matches : null;
                                } else {
                                    match = dataNode[_symbol_utils.$getRealChildrenByNameIt](child.name, false, this.emptyMerge).next().value;
                                    if (!match) {
                                        if (min === 0) {
                                            uselessNodes.push(child);
                                            continue;
                                        }
                                        const nsId = dataNode[_symbol_utils.$namespaceId] === NS_DATASETS ? -1 : dataNode[_symbol_utils.$namespaceId];
                                        match = child[_symbol_utils.$data] = new _xfa_object.XmlObject(nsId, child.name);
                                        if (this.emptyMerge) match[_symbol_utils.$consumed] = true;
                                        dataNode[_symbol_utils.$appendChild](match);
                                        this._setAndBind(child, match);
                                        continue;
                                    }
                                    if (this.emptyMerge) match[_symbol_utils.$consumed] = true;
                                    match = [
                                        match
                                    ];
                                }
                            }
                            if (match) this._bindOccurrences(child, match, picture);
                            else if (min > 0) this._setAndBind(child, dataNode);
                            else uselessNodes.push(child);
                        }
                        uselessNodes.forEach((node)=>node[_symbol_utils.$getParent]()[_symbol_utils.$removeChild](node));
                    }
                }
                exports.Binder = Binder;
            /***/ },
            /* 80 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Value = exports.Text = exports.TemplateNamespace = exports.Template = exports.SetProperty = exports.Items = exports.Field = exports.BindItems = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _namespaces = __w_pdfjs_require__(81);
                var _layout = __w_pdfjs_require__(82);
                var _html_utils = __w_pdfjs_require__(83);
                var _xfa_object = __w_pdfjs_require__(87);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                var _fonts = __w_pdfjs_require__(85);
                var _core_utils = __w_pdfjs_require__(3);
                var _som = __w_pdfjs_require__(88);
                const TEMPLATE_NS_ID = _namespaces.NamespaceIds.template.id;
                const SVG_NS = "http://www.w3.org/2000/svg";
                const MAX_ATTEMPTS_FOR_LRTB_LAYOUT = 2;
                const MAX_EMPTY_PAGES = 3;
                const DEFAULT_TAB_INDEX = 5000;
                const HEADING_PATTERN = /^H(\d+)$/;
                const MIMES = new Set([
                    "image/gif",
                    "image/jpeg",
                    "image/jpg",
                    "image/pjpeg",
                    "image/png",
                    "image/apng",
                    "image/x-png",
                    "image/bmp",
                    "image/x-ms-bmp",
                    "image/tiff",
                    "image/tif",
                    "application/octet-stream"
                ]);
                const IMAGES_HEADERS = [
                    [
                        [
                            0x42,
                            0x4d
                        ],
                        "image/bmp"
                    ],
                    [
                        [
                            0xff,
                            0xd8,
                            0xff
                        ],
                        "image/jpeg"
                    ],
                    [
                        [
                            0x49,
                            0x49,
                            0x2a,
                            0x00
                        ],
                        "image/tiff"
                    ],
                    [
                        [
                            0x4d,
                            0x4d,
                            0x00,
                            0x2a
                        ],
                        "image/tiff"
                    ],
                    [
                        [
                            0x47,
                            0x49,
                            0x46,
                            0x38,
                            0x39,
                            0x61
                        ],
                        "image/gif"
                    ],
                    [
                        [
                            0x89,
                            0x50,
                            0x4e,
                            0x47,
                            0x0d,
                            0x0a,
                            0x1a,
                            0x0a
                        ],
                        "image/png"
                    ]
                ];
                function getBorderDims(node) {
                    if (!node || !node.border) return {
                        w: 0,
                        h: 0
                    };
                    const borderExtra = node.border[_symbol_utils.$getExtra]();
                    if (!borderExtra) return {
                        w: 0,
                        h: 0
                    };
                    return {
                        w: borderExtra.widths[0] + borderExtra.widths[2] + borderExtra.insets[0] + borderExtra.insets[2],
                        h: borderExtra.widths[1] + borderExtra.widths[3] + borderExtra.insets[1] + borderExtra.insets[3]
                    };
                }
                function hasMargin(node) {
                    return node.margin && (node.margin.topInset || node.margin.rightInset || node.margin.bottomInset || node.margin.leftInset);
                }
                function _setValue(templateNode, value) {
                    if (!templateNode.value) {
                        const nodeValue = new Value({});
                        templateNode[_symbol_utils.$appendChild](nodeValue);
                        templateNode.value = nodeValue;
                    }
                    templateNode.value[_symbol_utils.$setValue](value);
                }
                function* getContainedChildren(node) {
                    for (const child of node[_symbol_utils.$getChildren]()){
                        if (child instanceof SubformSet) {
                            yield* child[_symbol_utils.$getContainedChildren]();
                            continue;
                        }
                        yield child;
                    }
                }
                function isRequired(node) {
                    return node.validate?.nullTest === "error";
                }
                function setTabIndex(node) {
                    while(node){
                        if (!node.traversal) {
                            node[_symbol_utils.$tabIndex] = node[_symbol_utils.$getParent]()[_symbol_utils.$tabIndex];
                            return;
                        }
                        if (node[_symbol_utils.$tabIndex]) return;
                        let next = null;
                        for (const child of node.traversal[_symbol_utils.$getChildren]())if (child.operation === "next") {
                            next = child;
                            break;
                        }
                        if (!next || !next.ref) {
                            node[_symbol_utils.$tabIndex] = node[_symbol_utils.$getParent]()[_symbol_utils.$tabIndex];
                            return;
                        }
                        const root = node[_symbol_utils.$getTemplateRoot]();
                        node[_symbol_utils.$tabIndex] = ++root[_symbol_utils.$tabIndex];
                        const ref = root[_symbol_utils.$searchNode](next.ref, node);
                        if (!ref) return;
                        node = ref[0];
                    }
                }
                function applyAssist(obj, attributes) {
                    const assist = obj.assist;
                    if (assist) {
                        const assistTitle = assist[_symbol_utils.$toHTML]();
                        if (assistTitle) attributes.title = assistTitle;
                        const role = assist.role;
                        const match = role.match(HEADING_PATTERN);
                        if (match) {
                            const ariaRole = "heading";
                            const ariaLevel = match[1];
                            attributes.role = ariaRole;
                            attributes["aria-level"] = ariaLevel;
                        }
                    }
                    if (obj.layout === "table") attributes.role = "table";
                    else if (obj.layout === "row") attributes.role = "row";
                    else {
                        const parent = obj[_symbol_utils.$getParent]();
                        if (parent.layout === "row") attributes.role = parent.assist?.role === "TH" ? "columnheader" : "cell";
                    }
                }
                function ariaLabel(obj) {
                    if (!obj.assist) return null;
                    const assist = obj.assist;
                    if (assist.speak && assist.speak[_symbol_utils.$content] !== "") return assist.speak[_symbol_utils.$content];
                    if (assist.toolTip) return assist.toolTip[_symbol_utils.$content];
                    return null;
                }
                function valueToHtml(value) {
                    return _utils.HTMLResult.success({
                        name: "div",
                        attributes: {
                            class: [
                                "xfaRich"
                            ],
                            style: Object.create(null)
                        },
                        children: [
                            {
                                name: "span",
                                attributes: {
                                    style: Object.create(null)
                                },
                                value: value
                            }
                        ]
                    });
                }
                function setFirstUnsplittable(node) {
                    const root = node[_symbol_utils.$getTemplateRoot]();
                    if (root[_symbol_utils.$extra].firstUnsplittable === null) {
                        root[_symbol_utils.$extra].firstUnsplittable = node;
                        root[_symbol_utils.$extra].noLayoutFailure = true;
                    }
                }
                function unsetFirstUnsplittable(node) {
                    const root = node[_symbol_utils.$getTemplateRoot]();
                    if (root[_symbol_utils.$extra].firstUnsplittable === node) root[_symbol_utils.$extra].noLayoutFailure = false;
                }
                function handleBreak(node) {
                    if (node[_symbol_utils.$extra]) return false;
                    node[_symbol_utils.$extra] = Object.create(null);
                    if (node.targetType === "auto") return false;
                    const root = node[_symbol_utils.$getTemplateRoot]();
                    let target = null;
                    if (node.target) {
                        target = root[_symbol_utils.$searchNode](node.target, node[_symbol_utils.$getParent]());
                        if (!target) return false;
                        target = target[0];
                    }
                    const { currentPageArea: currentPageArea, currentContentArea: currentContentArea } = root[_symbol_utils.$extra];
                    if (node.targetType === "pageArea") {
                        if (!(target instanceof PageArea)) target = null;
                        if (node.startNew) {
                            node[_symbol_utils.$extra].target = target || currentPageArea;
                            return true;
                        } else if (target && target !== currentPageArea) {
                            node[_symbol_utils.$extra].target = target;
                            return true;
                        }
                        return false;
                    }
                    if (!(target instanceof ContentArea)) target = null;
                    const pageArea = target && target[_symbol_utils.$getParent]();
                    let index;
                    let nextPageArea = pageArea;
                    if (node.startNew) {
                        if (target) {
                            const contentAreas = pageArea.contentArea.children;
                            const indexForCurrent = contentAreas.indexOf(currentContentArea);
                            const indexForTarget = contentAreas.indexOf(target);
                            if (indexForCurrent !== -1 && indexForCurrent < indexForTarget) nextPageArea = null;
                            index = indexForTarget - 1;
                        } else index = currentPageArea.contentArea.children.indexOf(currentContentArea);
                    } else if (target && target !== currentContentArea) {
                        const contentAreas = pageArea.contentArea.children;
                        index = contentAreas.indexOf(target) - 1;
                        nextPageArea = pageArea === currentPageArea ? null : pageArea;
                    } else return false;
                    node[_symbol_utils.$extra].target = nextPageArea;
                    node[_symbol_utils.$extra].index = index;
                    return true;
                }
                function handleOverflow(node, extraNode, space) {
                    const root = node[_symbol_utils.$getTemplateRoot]();
                    const saved = root[_symbol_utils.$extra].noLayoutFailure;
                    const savedMethod = extraNode[_symbol_utils.$getSubformParent];
                    extraNode[_symbol_utils.$getSubformParent] = ()=>node;
                    root[_symbol_utils.$extra].noLayoutFailure = true;
                    const res = extraNode[_symbol_utils.$toHTML](space);
                    node[_symbol_utils.$addHTML](res.html, res.bbox);
                    root[_symbol_utils.$extra].noLayoutFailure = saved;
                    extraNode[_symbol_utils.$getSubformParent] = savedMethod;
                }
                class AppearanceFilter extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "appearanceFilter");
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Arc extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "arc", true);
                        this.circular = (0, _utils.getInteger)({
                            data: attributes.circular,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.startAngle = (0, _utils.getFloat)({
                            data: attributes.startAngle,
                            defaultValue: 0,
                            validate: (x)=>true
                        });
                        this.sweepAngle = (0, _utils.getFloat)({
                            data: attributes.sweepAngle,
                            defaultValue: 360,
                            validate: (x)=>true
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.edge = null;
                        this.fill = null;
                    }
                    [_symbol_utils.$toHTML]() {
                        const edge = this.edge || new Edge({});
                        const edgeStyle = edge[_symbol_utils.$toStyle]();
                        const style = Object.create(null);
                        if (this.fill?.presence === "visible") Object.assign(style, this.fill[_symbol_utils.$toStyle]());
                        else style.fill = "transparent";
                        style.strokeWidth = (0, _html_utils.measureToString)(edge.presence === "visible" ? edge.thickness : 0);
                        style.stroke = edgeStyle.color;
                        let arc;
                        const attributes = {
                            xmlns: SVG_NS,
                            style: {
                                width: "100%",
                                height: "100%",
                                overflow: "visible"
                            }
                        };
                        if (this.sweepAngle === 360) arc = {
                            name: "ellipse",
                            attributes: {
                                xmlns: SVG_NS,
                                cx: "50%",
                                cy: "50%",
                                rx: "50%",
                                ry: "50%",
                                style: style
                            }
                        };
                        else {
                            const startAngle = this.startAngle * Math.PI / 180;
                            const sweepAngle = this.sweepAngle * Math.PI / 180;
                            const largeArc = this.sweepAngle > 180 ? 1 : 0;
                            const [x1, y1, x2, y2] = [
                                50 * (1 + Math.cos(startAngle)),
                                50 * (1 - Math.sin(startAngle)),
                                50 * (1 + Math.cos(startAngle + sweepAngle)),
                                50 * (1 - Math.sin(startAngle + sweepAngle))
                            ];
                            arc = {
                                name: "path",
                                attributes: {
                                    xmlns: SVG_NS,
                                    d: `M ${x1} ${y1} A 50 50 0 ${largeArc} 0 ${x2} ${y2}`,
                                    vectorEffect: "non-scaling-stroke",
                                    style: style
                                }
                            };
                            Object.assign(attributes, {
                                viewBox: "0 0 100 100",
                                preserveAspectRatio: "none"
                            });
                        }
                        const svg = {
                            name: "svg",
                            children: [
                                arc
                            ],
                            attributes: attributes
                        };
                        const parent = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        if (hasMargin(parent)) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                svg
                            ]
                        });
                        svg.attributes.style.position = "absolute";
                        return _utils.HTMLResult.success(svg);
                    }
                }
                class Area extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "area", true);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.desc = null;
                        this.extras = null;
                        this.area = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                    }
                    *[_symbol_utils.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [_symbol_utils.$isTransparent]() {
                        return true;
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                    [_symbol_utils.$addHTML](html, bbox) {
                        const [x, y, w, h] = bbox;
                        this[_symbol_utils.$extra].width = Math.max(this[_symbol_utils.$extra].width, x + w);
                        this[_symbol_utils.$extra].height = Math.max(this[_symbol_utils.$extra].height, y + h);
                        this[_symbol_utils.$extra].children.push(html);
                    }
                    [_symbol_utils.$getAvailableSpace]() {
                        return this[_symbol_utils.$extra].availableSpace;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "position");
                        const attributes = {
                            style: style,
                            id: this[_symbol_utils.$uid],
                            class: [
                                "xfaArea"
                            ]
                        };
                        if ((0, _html_utils.isPrintOnly)(this)) attributes.class.push("xfaPrintOnly");
                        if (this.name) attributes.xfaName = this.name;
                        const children = [];
                        this[_symbol_utils.$extra] = {
                            children: children,
                            width: 0,
                            height: 0,
                            availableSpace: availableSpace
                        };
                        const result = this[_symbol_utils.$childrenToHTML]({
                            filter: new Set([
                                "area",
                                "draw",
                                "field",
                                "exclGroup",
                                "subform",
                                "subformSet"
                            ]),
                            include: true
                        });
                        if (!result.success) {
                            if (result.isBreak()) return result;
                            delete this[_symbol_utils.$extra];
                            return _utils.HTMLResult.FAILURE;
                        }
                        style.width = (0, _html_utils.measureToString)(this[_symbol_utils.$extra].width);
                        style.height = (0, _html_utils.measureToString)(this[_symbol_utils.$extra].height);
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        const bbox = [
                            this.x,
                            this.y,
                            this[_symbol_utils.$extra].width,
                            this[_symbol_utils.$extra].height
                        ];
                        delete this[_symbol_utils.$extra];
                        return _utils.HTMLResult.success(html, bbox);
                    }
                }
                class Assist extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "assist", true);
                        this.id = attributes.id || "";
                        this.role = attributes.role || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.speak = null;
                        this.toolTip = null;
                    }
                    [_symbol_utils.$toHTML]() {
                        return this.toolTip?.[_symbol_utils.$content] || null;
                    }
                }
                class Barcode extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "barcode", true);
                        this.charEncoding = (0, _utils.getKeyword)({
                            data: attributes.charEncoding ? attributes.charEncoding.toLowerCase() : "",
                            defaultValue: "",
                            validate: (k)=>[
                                    "utf-8",
                                    "big-five",
                                    "fontspecific",
                                    "gbk",
                                    "gb-18030",
                                    "gb-2312",
                                    "ksc-5601",
                                    "none",
                                    "shift-jis",
                                    "ucs-2",
                                    "utf-16"
                                ].includes(k) || k.match(/iso-8859-\d{2}/)
                        });
                        this.checksum = (0, _utils.getStringOption)(attributes.checksum, [
                            "none",
                            "1mod10",
                            "1mod10_1mod11",
                            "2mod10",
                            "auto"
                        ]);
                        this.dataColumnCount = (0, _utils.getInteger)({
                            data: attributes.dataColumnCount,
                            defaultValue: -1,
                            validate: (x)=>x >= 0
                        });
                        this.dataLength = (0, _utils.getInteger)({
                            data: attributes.dataLength,
                            defaultValue: -1,
                            validate: (x)=>x >= 0
                        });
                        this.dataPrep = (0, _utils.getStringOption)(attributes.dataPrep, [
                            "none",
                            "flateCompress"
                        ]);
                        this.dataRowCount = (0, _utils.getInteger)({
                            data: attributes.dataRowCount,
                            defaultValue: -1,
                            validate: (x)=>x >= 0
                        });
                        this.endChar = attributes.endChar || "";
                        this.errorCorrectionLevel = (0, _utils.getInteger)({
                            data: attributes.errorCorrectionLevel,
                            defaultValue: -1,
                            validate: (x)=>x >= 0 && x <= 8
                        });
                        this.id = attributes.id || "";
                        this.moduleHeight = (0, _utils.getMeasurement)(attributes.moduleHeight, "5mm");
                        this.moduleWidth = (0, _utils.getMeasurement)(attributes.moduleWidth, "0.25mm");
                        this.printCheckDigit = (0, _utils.getInteger)({
                            data: attributes.printCheckDigit,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.rowColumnRatio = (0, _utils.getRatio)(attributes.rowColumnRatio);
                        this.startChar = attributes.startChar || "";
                        this.textLocation = (0, _utils.getStringOption)(attributes.textLocation, [
                            "below",
                            "above",
                            "aboveEmbedded",
                            "belowEmbedded",
                            "none"
                        ]);
                        this.truncate = (0, _utils.getInteger)({
                            data: attributes.truncate,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.type = (0, _utils.getStringOption)(attributes.type ? attributes.type.toLowerCase() : "", [
                            "aztec",
                            "codabar",
                            "code2of5industrial",
                            "code2of5interleaved",
                            "code2of5matrix",
                            "code2of5standard",
                            "code3of9",
                            "code3of9extended",
                            "code11",
                            "code49",
                            "code93",
                            "code128",
                            "code128a",
                            "code128b",
                            "code128c",
                            "code128sscc",
                            "datamatrix",
                            "ean8",
                            "ean8add2",
                            "ean8add5",
                            "ean13",
                            "ean13add2",
                            "ean13add5",
                            "ean13pwcd",
                            "fim",
                            "logmars",
                            "maxicode",
                            "msi",
                            "pdf417",
                            "pdf417macro",
                            "plessey",
                            "postauscust2",
                            "postauscust3",
                            "postausreplypaid",
                            "postausstandard",
                            "postukrm4scc",
                            "postusdpbc",
                            "postusimb",
                            "postusstandard",
                            "postus5zip",
                            "qrcode",
                            "rfid",
                            "rss14",
                            "rss14expanded",
                            "rss14limited",
                            "rss14stacked",
                            "rss14stackedomni",
                            "rss14truncated",
                            "telepen",
                            "ucc128",
                            "ucc128random",
                            "ucc128sscc",
                            "upca",
                            "upcaadd2",
                            "upcaadd5",
                            "upcapwcd",
                            "upce",
                            "upceadd2",
                            "upceadd5",
                            "upcean2",
                            "upcean5",
                            "upsmaxicode"
                        ]);
                        this.upsMode = (0, _utils.getStringOption)(attributes.upsMode, [
                            "usCarrier",
                            "internationalCarrier",
                            "secureSymbol",
                            "standardSymbol"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.wideNarrowRatio = (0, _utils.getRatio)(attributes.wideNarrowRatio);
                        this.encrypt = null;
                        this.extras = null;
                    }
                }
                class Bind extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "bind", true);
                        this.match = (0, _utils.getStringOption)(attributes.match, [
                            "once",
                            "dataRef",
                            "global",
                            "none"
                        ]);
                        this.ref = attributes.ref || "";
                        this.picture = null;
                    }
                }
                class BindItems extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "bindItems");
                        this.connection = attributes.connection || "";
                        this.labelRef = attributes.labelRef || "";
                        this.ref = attributes.ref || "";
                        this.valueRef = attributes.valueRef || "";
                    }
                }
                exports.BindItems = BindItems;
                class Bookend extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "bookend");
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class BooleanElement extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "boolean");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] === 1 ? "1" : "0");
                    }
                }
                class Border extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "border", true);
                        this.break = (0, _utils.getStringOption)(attributes.break, [
                            "close",
                            "open"
                        ]);
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.corner = new _xfa_object.XFAObjectArray(4);
                        this.edge = new _xfa_object.XFAObjectArray(4);
                        this.extras = null;
                        this.fill = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$getExtra]() {
                        if (!this[_symbol_utils.$extra]) {
                            const edges = this.edge.children.slice();
                            if (edges.length < 4) {
                                const defaultEdge = edges.at(-1) || new Edge({});
                                for(let i = edges.length; i < 4; i++)edges.push(defaultEdge);
                            }
                            const widths = edges.map((edge)=>edge.thickness);
                            const insets = [
                                0,
                                0,
                                0,
                                0
                            ];
                            if (this.margin) {
                                insets[0] = this.margin.topInset;
                                insets[1] = this.margin.rightInset;
                                insets[2] = this.margin.bottomInset;
                                insets[3] = this.margin.leftInset;
                            }
                            this[_symbol_utils.$extra] = {
                                widths: widths,
                                insets: insets,
                                edges: edges
                            };
                        }
                        return this[_symbol_utils.$extra];
                    }
                    [_symbol_utils.$toStyle]() {
                        const { edges: edges } = this[_symbol_utils.$getExtra]();
                        const edgeStyles = edges.map((node)=>{
                            const style = node[_symbol_utils.$toStyle]();
                            style.color ||= "#000000";
                            return style;
                        });
                        const style = Object.create(null);
                        if (this.margin) Object.assign(style, this.margin[_symbol_utils.$toStyle]());
                        if (this.fill?.presence === "visible") Object.assign(style, this.fill[_symbol_utils.$toStyle]());
                        if (this.corner.children.some((node)=>node.radius !== 0)) {
                            const cornerStyles = this.corner.children.map((node)=>node[_symbol_utils.$toStyle]());
                            if (cornerStyles.length === 2 || cornerStyles.length === 3) {
                                const last = cornerStyles.at(-1);
                                for(let i = cornerStyles.length; i < 4; i++)cornerStyles.push(last);
                            }
                            style.borderRadius = cornerStyles.map((s)=>s.radius).join(" ");
                        }
                        switch(this.presence){
                            case "invisible":
                            case "hidden":
                                style.borderStyle = "";
                                break;
                            case "inactive":
                                style.borderStyle = "none";
                                break;
                            default:
                                style.borderStyle = edgeStyles.map((s)=>s.style).join(" ");
                                break;
                        }
                        style.borderWidth = edgeStyles.map((s)=>s.width).join(" ");
                        style.borderColor = edgeStyles.map((s)=>s.color).join(" ");
                        return style;
                    }
                }
                class Break extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "break", true);
                        this.after = (0, _utils.getStringOption)(attributes.after, [
                            "auto",
                            "contentArea",
                            "pageArea",
                            "pageEven",
                            "pageOdd"
                        ]);
                        this.afterTarget = attributes.afterTarget || "";
                        this.before = (0, _utils.getStringOption)(attributes.before, [
                            "auto",
                            "contentArea",
                            "pageArea",
                            "pageEven",
                            "pageOdd"
                        ]);
                        this.beforeTarget = attributes.beforeTarget || "";
                        this.bookendLeader = attributes.bookendLeader || "";
                        this.bookendTrailer = attributes.bookendTrailer || "";
                        this.id = attributes.id || "";
                        this.overflowLeader = attributes.overflowLeader || "";
                        this.overflowTarget = attributes.overflowTarget || "";
                        this.overflowTrailer = attributes.overflowTrailer || "";
                        this.startNew = (0, _utils.getInteger)({
                            data: attributes.startNew,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class BreakAfter extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "breakAfter", true);
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.startNew = (0, _utils.getInteger)({
                            data: attributes.startNew,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.target = attributes.target || "";
                        this.targetType = (0, _utils.getStringOption)(attributes.targetType, [
                            "auto",
                            "contentArea",
                            "pageArea"
                        ]);
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.script = null;
                    }
                }
                class BreakBefore extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "breakBefore", true);
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.startNew = (0, _utils.getInteger)({
                            data: attributes.startNew,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.target = attributes.target || "";
                        this.targetType = (0, _utils.getStringOption)(attributes.targetType, [
                            "auto",
                            "contentArea",
                            "pageArea"
                        ]);
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.script = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        this[_symbol_utils.$extra] = {};
                        return _utils.HTMLResult.FAILURE;
                    }
                }
                class Button extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "button", true);
                        this.highlight = (0, _utils.getStringOption)(attributes.highlight, [
                            "inverted",
                            "none",
                            "outline",
                            "push"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const parent = this[_symbol_utils.$getParent]();
                        const grandpa = parent[_symbol_utils.$getParent]();
                        const htmlButton = {
                            name: "button",
                            attributes: {
                                id: this[_symbol_utils.$uid],
                                class: [
                                    "xfaButton"
                                ],
                                style: {}
                            },
                            children: []
                        };
                        for (const event of grandpa.event.children){
                            if (event.activity !== "click" || !event.script) continue;
                            const jsURL = (0, _core_utils.recoverJsURL)(event.script[_symbol_utils.$content]);
                            if (!jsURL) continue;
                            const href = (0, _html_utils.fixURL)(jsURL.url);
                            if (!href) continue;
                            htmlButton.children.push({
                                name: "a",
                                attributes: {
                                    id: "link" + this[_symbol_utils.$uid],
                                    href: href,
                                    newWindow: jsURL.newWindow,
                                    class: [
                                        "xfaLink"
                                    ],
                                    style: {}
                                },
                                children: []
                            });
                        }
                        return _utils.HTMLResult.success(htmlButton);
                    }
                }
                class Calculate extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "calculate", true);
                        this.id = attributes.id || "";
                        this.override = (0, _utils.getStringOption)(attributes.override, [
                            "disabled",
                            "error",
                            "ignore",
                            "warning"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.message = null;
                        this.script = null;
                    }
                }
                class Caption extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "caption", true);
                        this.id = attributes.id || "";
                        this.placement = (0, _utils.getStringOption)(attributes.placement, [
                            "left",
                            "bottom",
                            "inline",
                            "right",
                            "top"
                        ]);
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.reserve = Math.ceil((0, _utils.getMeasurement)(attributes.reserve));
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.font = null;
                        this.margin = null;
                        this.para = null;
                        this.value = null;
                    }
                    [_symbol_utils.$setValue](value) {
                        _setValue(this, value);
                    }
                    [_symbol_utils.$getExtra](availableSpace) {
                        if (!this[_symbol_utils.$extra]) {
                            let { width: width, height: height } = availableSpace;
                            switch(this.placement){
                                case "left":
                                case "right":
                                case "inline":
                                    width = this.reserve <= 0 ? width : this.reserve;
                                    break;
                                case "top":
                                case "bottom":
                                    height = this.reserve <= 0 ? height : this.reserve;
                                    break;
                            }
                            this[_symbol_utils.$extra] = (0, _html_utils.layoutNode)(this, {
                                width: width,
                                height: height
                            });
                        }
                        return this[_symbol_utils.$extra];
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        if (!this.value) return _utils.HTMLResult.EMPTY;
                        this[_symbol_utils.$pushPara]();
                        const value = this.value[_symbol_utils.$toHTML](availableSpace).html;
                        if (!value) {
                            this[_symbol_utils.$popPara]();
                            return _utils.HTMLResult.EMPTY;
                        }
                        const savedReserve = this.reserve;
                        if (this.reserve <= 0) {
                            const { w: w, h: h } = this[_symbol_utils.$getExtra](availableSpace);
                            switch(this.placement){
                                case "left":
                                case "right":
                                case "inline":
                                    this.reserve = w;
                                    break;
                                case "top":
                                case "bottom":
                                    this.reserve = h;
                                    break;
                            }
                        }
                        const children = [];
                        if (typeof value === "string") children.push({
                            name: "#text",
                            value: value
                        });
                        else children.push(value);
                        const style = (0, _html_utils.toStyle)(this, "font", "margin", "visibility");
                        switch(this.placement){
                            case "left":
                            case "right":
                                if (this.reserve > 0) style.width = (0, _html_utils.measureToString)(this.reserve);
                                break;
                            case "top":
                            case "bottom":
                                if (this.reserve > 0) style.height = (0, _html_utils.measureToString)(this.reserve);
                                break;
                        }
                        (0, _html_utils.setPara)(this, null, value);
                        this[_symbol_utils.$popPara]();
                        this.reserve = savedReserve;
                        return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: style,
                                class: [
                                    "xfaCaption"
                                ]
                            },
                            children: children
                        });
                    }
                }
                class Certificate extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "certificate");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Certificates extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "certificates", true);
                        this.credentialServerPolicy = (0, _utils.getStringOption)(attributes.credentialServerPolicy, [
                            "optional",
                            "required"
                        ]);
                        this.id = attributes.id || "";
                        this.url = attributes.url || "";
                        this.urlPolicy = attributes.urlPolicy || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.encryption = null;
                        this.issuers = null;
                        this.keyUsage = null;
                        this.oids = null;
                        this.signing = null;
                        this.subjectDNs = null;
                    }
                }
                class CheckButton extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "checkButton", true);
                        this.id = attributes.id || "";
                        this.mark = (0, _utils.getStringOption)(attributes.mark, [
                            "default",
                            "check",
                            "circle",
                            "cross",
                            "diamond",
                            "square",
                            "star"
                        ]);
                        this.shape = (0, _utils.getStringOption)(attributes.shape, [
                            "square",
                            "round"
                        ]);
                        this.size = (0, _utils.getMeasurement)(attributes.size, "10pt");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)("margin");
                        const size = (0, _html_utils.measureToString)(this.size);
                        style.width = style.height = size;
                        let type;
                        let className;
                        let groupId;
                        const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        const items = field.items.children.length && field.items.children[0][_symbol_utils.$toHTML]().html || [];
                        const exportedValue = {
                            on: (items[0] !== undefined ? items[0] : "on").toString(),
                            off: (items[1] !== undefined ? items[1] : "off").toString()
                        };
                        const value = field.value?.[_symbol_utils.$text]() || "off";
                        const checked = value === exportedValue.on || undefined;
                        const container = field[_symbol_utils.$getSubformParent]();
                        const fieldId = field[_symbol_utils.$uid];
                        let dataId;
                        if (container instanceof ExclGroup) {
                            groupId = container[_symbol_utils.$uid];
                            type = "radio";
                            className = "xfaRadio";
                            dataId = container[_symbol_utils.$data]?.[_symbol_utils.$uid] || container[_symbol_utils.$uid];
                        } else {
                            type = "checkbox";
                            className = "xfaCheckbox";
                            dataId = field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid];
                        }
                        const input = {
                            name: "input",
                            attributes: {
                                class: [
                                    className
                                ],
                                style: style,
                                fieldId: fieldId,
                                dataId: dataId,
                                type: type,
                                checked: checked,
                                xfaOn: exportedValue.on,
                                xfaOff: exportedValue.off,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        if (groupId) input.attributes.name = groupId;
                        if (isRequired(field)) {
                            input.attributes["aria-required"] = true;
                            input.attributes.required = true;
                        }
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                input
                            ]
                        });
                    }
                }
                class ChoiceList extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "choiceList", true);
                        this.commitOn = (0, _utils.getStringOption)(attributes.commitOn, [
                            "select",
                            "exit"
                        ]);
                        this.id = attributes.id || "";
                        this.open = (0, _utils.getStringOption)(attributes.open, [
                            "userControl",
                            "always",
                            "multiSelect",
                            "onEntry"
                        ]);
                        this.textEntry = (0, _utils.getInteger)({
                            data: attributes.textEntry,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "margin");
                        const ui = this[_symbol_utils.$getParent]();
                        const field = ui[_symbol_utils.$getParent]();
                        const fontSize = field.font?.size || 10;
                        const optionStyle = {
                            fontSize: `calc(${fontSize}px * var(--scale-factor))`
                        };
                        const children = [];
                        if (field.items.children.length > 0) {
                            const items = field.items;
                            let displayedIndex = 0;
                            let saveIndex = 0;
                            if (items.children.length === 2) {
                                displayedIndex = items.children[0].save;
                                saveIndex = 1 - displayedIndex;
                            }
                            const displayed = items.children[displayedIndex][_symbol_utils.$toHTML]().html;
                            const values = items.children[saveIndex][_symbol_utils.$toHTML]().html;
                            let selected = false;
                            const value = field.value?.[_symbol_utils.$text]() || "";
                            for(let i = 0, ii = displayed.length; i < ii; i++){
                                const option = {
                                    name: "option",
                                    attributes: {
                                        value: values[i] || displayed[i],
                                        style: optionStyle
                                    },
                                    value: displayed[i]
                                };
                                if (values[i] === value) option.attributes.selected = selected = true;
                                children.push(option);
                            }
                            if (!selected) children.splice(0, 0, {
                                name: "option",
                                attributes: {
                                    hidden: true,
                                    selected: true
                                },
                                value: " "
                            });
                        }
                        const selectAttributes = {
                            class: [
                                "xfaSelect"
                            ],
                            fieldId: field[_symbol_utils.$uid],
                            dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                            style: style,
                            "aria-label": ariaLabel(field),
                            "aria-required": false
                        };
                        if (isRequired(field)) {
                            selectAttributes["aria-required"] = true;
                            selectAttributes.required = true;
                        }
                        if (this.open === "multiSelect") selectAttributes.multiple = true;
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                {
                                    name: "select",
                                    children: children,
                                    attributes: selectAttributes
                                }
                            ]
                        });
                    }
                }
                class Color extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "color", true);
                        this.cSpace = (0, _utils.getStringOption)(attributes.cSpace, [
                            "SRGB"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.value = attributes.value ? (0, _utils.getColor)(attributes.value) : "";
                        this.extras = null;
                    }
                    [_symbol_utils.$hasSettableValue]() {
                        return false;
                    }
                    [_symbol_utils.$toStyle]() {
                        return this.value ? _util.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
                    }
                }
                class Comb extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "comb");
                        this.id = attributes.id || "";
                        this.numberOfCells = (0, _utils.getInteger)({
                            data: attributes.numberOfCells,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Connect extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "connect", true);
                        this.connection = attributes.connection || "";
                        this.id = attributes.id || "";
                        this.ref = attributes.ref || "";
                        this.usage = (0, _utils.getStringOption)(attributes.usage, [
                            "exportAndImport",
                            "exportOnly",
                            "importOnly"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.picture = null;
                    }
                }
                class ContentArea extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "contentArea", true);
                        this.h = (0, _utils.getMeasurement)(attributes.h);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = (0, _utils.getMeasurement)(attributes.w);
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.desc = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const left = (0, _html_utils.measureToString)(this.x);
                        const top = (0, _html_utils.measureToString)(this.y);
                        const style = {
                            left: left,
                            top: top,
                            width: (0, _html_utils.measureToString)(this.w),
                            height: (0, _html_utils.measureToString)(this.h)
                        };
                        const classNames = [
                            "xfaContentarea"
                        ];
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        return _utils.HTMLResult.success({
                            name: "div",
                            children: [],
                            attributes: {
                                style: style,
                                class: classNames,
                                id: this[_symbol_utils.$uid]
                            }
                        });
                    }
                }
                class Corner extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "corner", true);
                        this.id = attributes.id || "";
                        this.inverted = (0, _utils.getInteger)({
                            data: attributes.inverted,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.join = (0, _utils.getStringOption)(attributes.join, [
                            "square",
                            "round"
                        ]);
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.radius = (0, _utils.getMeasurement)(attributes.radius);
                        this.stroke = (0, _utils.getStringOption)(attributes.stroke, [
                            "solid",
                            "dashDot",
                            "dashDotDot",
                            "dashed",
                            "dotted",
                            "embossed",
                            "etched",
                            "lowered",
                            "raised"
                        ]);
                        this.thickness = (0, _utils.getMeasurement)(attributes.thickness, "0.5pt");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "visibility");
                        style.radius = (0, _html_utils.measureToString)(this.join === "square" ? 0 : this.radius);
                        return style;
                    }
                }
                class DateElement extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "date");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const date = this[_symbol_utils.$content].trim();
                        this[_symbol_utils.$content] = date ? new Date(date) : null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class DateTime extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "dateTime");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const date = this[_symbol_utils.$content].trim();
                        this[_symbol_utils.$content] = date ? new Date(date) : null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class DateTimeEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "dateTimeEdit", true);
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.picker = (0, _utils.getStringOption)(attributes.picker, [
                            "host",
                            "none"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                        const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        const html = {
                            name: "input",
                            attributes: {
                                type: "text",
                                fieldId: field[_symbol_utils.$uid],
                                dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        if (isRequired(field)) {
                            html.attributes["aria-required"] = true;
                            html.attributes.required = true;
                        }
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                html
                            ]
                        });
                    }
                }
                class Decimal extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "decimal");
                        this.fracDigits = (0, _utils.getInteger)({
                            data: attributes.fracDigits,
                            defaultValue: 2,
                            validate: (x)=>true
                        });
                        this.id = attributes.id || "";
                        this.leadDigits = (0, _utils.getInteger)({
                            data: attributes.leadDigits,
                            defaultValue: -1,
                            validate: (x)=>true
                        });
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const number = parseFloat(this[_symbol_utils.$content].trim());
                        this[_symbol_utils.$content] = isNaN(number) ? null : number;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] !== null ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class DefaultUi extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "defaultUi", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class Desc extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "desc", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                }
                class DigestMethod extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "digestMethod", [
                            "",
                            "SHA1",
                            "SHA256",
                            "SHA512",
                            "RIPEMD160"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class DigestMethods extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "digestMethods", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.digestMethod = new _xfa_object.XFAObjectArray();
                    }
                }
                class Draw extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "draw", true);
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.locale = attributes.locale || "";
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.rotate = (0, _utils.getInteger)({
                            data: attributes.rotate,
                            defaultValue: 0,
                            validate: (x)=>x % 90 === 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.border = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.font = null;
                        this.keep = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.ui = null;
                        this.value = null;
                        this.setProperty = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$setValue](value) {
                        _setValue(this, value);
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        setTabIndex(this);
                        if (this.presence === "hidden" || this.presence === "inactive") return _utils.HTMLResult.EMPTY;
                        (0, _html_utils.fixDimensions)(this);
                        this[_symbol_utils.$pushPara]();
                        const savedW = this.w;
                        const savedH = this.h;
                        const { w: w, h: h, isBroken: isBroken } = (0, _html_utils.layoutNode)(this, availableSpace);
                        if (w && this.w === "") {
                            if (isBroken && this[_symbol_utils.$getSubformParent]()[_symbol_utils.$isThereMoreWidth]()) {
                                this[_symbol_utils.$popPara]();
                                return _utils.HTMLResult.FAILURE;
                            }
                            this.w = w;
                        }
                        if (h && this.h === "") this.h = h;
                        setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                            this.w = savedW;
                            this.h = savedH;
                            this[_symbol_utils.$popPara]();
                            return _utils.HTMLResult.FAILURE;
                        }
                        unsetFirstUnsplittable(this);
                        const style = (0, _html_utils.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
                        (0, _html_utils.setMinMaxDimensions)(this, style);
                        if (style.margin) {
                            style.padding = style.margin;
                            delete style.margin;
                        }
                        const classNames = [
                            "xfaDraw"
                        ];
                        if (this.font) classNames.push("xfaFont");
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        const attributes = {
                            style: style,
                            id: this[_symbol_utils.$uid],
                            class: classNames
                        };
                        if (this.name) attributes.xfaName = this.name;
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: []
                        };
                        applyAssist(this, attributes);
                        const bbox = (0, _html_utils.computeBbox)(this, html, availableSpace);
                        const value = this.value ? this.value[_symbol_utils.$toHTML](availableSpace).html : null;
                        if (value === null) {
                            this.w = savedW;
                            this.h = savedH;
                            this[_symbol_utils.$popPara]();
                            return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        }
                        html.children.push(value);
                        (0, _html_utils.setPara)(this, style, value);
                        this.w = savedW;
                        this.h = savedH;
                        this[_symbol_utils.$popPara]();
                        return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                    }
                }
                class Edge extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "edge", true);
                        this.cap = (0, _utils.getStringOption)(attributes.cap, [
                            "square",
                            "butt",
                            "round"
                        ]);
                        this.id = attributes.id || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.stroke = (0, _utils.getStringOption)(attributes.stroke, [
                            "solid",
                            "dashDot",
                            "dashDotDot",
                            "dashed",
                            "dotted",
                            "embossed",
                            "etched",
                            "lowered",
                            "raised"
                        ]);
                        this.thickness = (0, _utils.getMeasurement)(attributes.thickness, "0.5pt");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "visibility");
                        Object.assign(style, {
                            linecap: this.cap,
                            width: (0, _html_utils.measureToString)(this.thickness),
                            color: this.color ? this.color[_symbol_utils.$toStyle]() : "#000000",
                            style: ""
                        });
                        if (this.presence !== "visible") style.style = "none";
                        else switch(this.stroke){
                            case "solid":
                                style.style = "solid";
                                break;
                            case "dashDot":
                                style.style = "dashed";
                                break;
                            case "dashDotDot":
                                style.style = "dashed";
                                break;
                            case "dashed":
                                style.style = "dashed";
                                break;
                            case "dotted":
                                style.style = "dotted";
                                break;
                            case "embossed":
                                style.style = "ridge";
                                break;
                            case "etched":
                                style.style = "groove";
                                break;
                            case "lowered":
                                style.style = "inset";
                                break;
                            case "raised":
                                style.style = "outset";
                                break;
                        }
                        return style;
                    }
                }
                class Encoding extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encoding", [
                            "adbe.x509.rsa_sha1",
                            "adbe.pkcs7.detached",
                            "adbe.pkcs7.sha1"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Encodings extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encodings", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.encoding = new _xfa_object.XFAObjectArray();
                    }
                }
                class Encrypt extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encrypt", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = null;
                    }
                }
                class EncryptData extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryptData", true);
                        this.id = attributes.id || "";
                        this.operation = (0, _utils.getStringOption)(attributes.operation, [
                            "encrypt",
                            "decrypt"
                        ]);
                        this.target = attributes.target || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.filter = null;
                        this.manifest = null;
                    }
                }
                class Encryption extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryption", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = new _xfa_object.XFAObjectArray();
                    }
                }
                class EncryptionMethod extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryptionMethod", [
                            "",
                            "AES256-CBC",
                            "TRIPLEDES-CBC",
                            "AES128-CBC",
                            "AES192-CBC"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class EncryptionMethods extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryptionMethods", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.encryptionMethod = new _xfa_object.XFAObjectArray();
                    }
                }
                class Event extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "event", true);
                        this.activity = (0, _utils.getStringOption)(attributes.activity, [
                            "click",
                            "change",
                            "docClose",
                            "docReady",
                            "enter",
                            "exit",
                            "full",
                            "indexChange",
                            "initialize",
                            "mouseDown",
                            "mouseEnter",
                            "mouseExit",
                            "mouseUp",
                            "postExecute",
                            "postOpen",
                            "postPrint",
                            "postSave",
                            "postSign",
                            "postSubmit",
                            "preExecute",
                            "preOpen",
                            "prePrint",
                            "preSave",
                            "preSign",
                            "preSubmit",
                            "ready",
                            "validationState"
                        ]);
                        this.id = attributes.id || "";
                        this.listen = (0, _utils.getStringOption)(attributes.listen, [
                            "refOnly",
                            "refAndDescendents"
                        ]);
                        this.name = attributes.name || "";
                        this.ref = attributes.ref || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.encryptData = null;
                        this.execute = null;
                        this.script = null;
                        this.signData = null;
                        this.submit = null;
                    }
                }
                class ExData extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "exData");
                        this.contentType = attributes.contentType || "";
                        this.href = attributes.href || "";
                        this.id = attributes.id || "";
                        this.maxLength = (0, _utils.getInteger)({
                            data: attributes.maxLength,
                            defaultValue: -1,
                            validate: (x)=>x >= -1
                        });
                        this.name = attributes.name || "";
                        this.rid = attributes.rid || "";
                        this.transferEncoding = (0, _utils.getStringOption)(attributes.transferEncoding, [
                            "none",
                            "base64",
                            "package"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$isCDATAXml]() {
                        return this.contentType === "text/html";
                    }
                    [_symbol_utils.$onChild](child) {
                        if (this.contentType === "text/html" && child[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) {
                            this[_symbol_utils.$content] = child;
                            return true;
                        }
                        if (this.contentType === "text/xml") {
                            this[_symbol_utils.$content] = child;
                            return true;
                        }
                        return false;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        if (this.contentType !== "text/html" || !this[_symbol_utils.$content]) return _utils.HTMLResult.EMPTY;
                        return this[_symbol_utils.$content][_symbol_utils.$toHTML](availableSpace);
                    }
                }
                class ExObject extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "exObject", true);
                        this.archive = attributes.archive || "";
                        this.classId = attributes.classId || "";
                        this.codeBase = attributes.codeBase || "";
                        this.codeType = attributes.codeType || "";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                }
                class ExclGroup extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "exclGroup", true);
                        this.access = (0, _utils.getStringOption)(attributes.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.accessKey = attributes.accessKey || "";
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.layout = (0, _utils.getStringOption)(attributes.layout, [
                            "position",
                            "lr-tb",
                            "rl-row",
                            "rl-tb",
                            "row",
                            "table",
                            "tb"
                        ]);
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.border = null;
                        this.calculate = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.validate = null;
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                    [_symbol_utils.$hasSettableValue]() {
                        return true;
                    }
                    [_symbol_utils.$setValue](value) {
                        for (const field of this.field.children){
                            if (!field.value) {
                                const nodeValue = new Value({});
                                field[_symbol_utils.$appendChild](nodeValue);
                                field.value = nodeValue;
                            }
                            field.value[_symbol_utils.$setValue](value);
                        }
                    }
                    [_symbol_utils.$isThereMoreWidth]() {
                        return this.layout.endsWith("-tb") && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine > 0 || this[_symbol_utils.$getParent]()[_symbol_utils.$isThereMoreWidth]();
                    }
                    [_symbol_utils.$isSplittable]() {
                        const parent = this[_symbol_utils.$getSubformParent]();
                        if (!parent[_symbol_utils.$isSplittable]()) return false;
                        if (this[_symbol_utils.$extra]._isSplittable !== undefined) return this[_symbol_utils.$extra]._isSplittable;
                        if (this.layout === "position" || this.layout.includes("row")) {
                            this[_symbol_utils.$extra]._isSplittable = false;
                            return false;
                        }
                        if (parent.layout?.endsWith("-tb") && parent[_symbol_utils.$extra].numberInLine !== 0) return false;
                        this[_symbol_utils.$extra]._isSplittable = true;
                        return true;
                    }
                    [_symbol_utils.$flushHTML]() {
                        return (0, _layout.flushHTML)(this);
                    }
                    [_symbol_utils.$addHTML](html, bbox) {
                        (0, _layout.addHTML)(this, html, bbox);
                    }
                    [_symbol_utils.$getAvailableSpace]() {
                        return (0, _layout.getAvailableSpace)(this);
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        setTabIndex(this);
                        if (this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) return _utils.HTMLResult.EMPTY;
                        (0, _html_utils.fixDimensions)(this);
                        const children = [];
                        const attributes = {
                            id: this[_symbol_utils.$uid],
                            class: []
                        };
                        (0, _html_utils.setAccess)(this, attributes.class);
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = Object.create(null);
                        Object.assign(this[_symbol_utils.$extra], {
                            children: children,
                            attributes: attributes,
                            attempt: 0,
                            line: null,
                            numberInLine: 0,
                            availableSpace: {
                                width: Math.min(this.w || Infinity, availableSpace.width),
                                height: Math.min(this.h || Infinity, availableSpace.height)
                            },
                            width: 0,
                            height: 0,
                            prevHeight: 0,
                            currentWidth: 0
                        });
                        const isSplittable = this[_symbol_utils.$isSplittable]();
                        if (!isSplittable) setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) return _utils.HTMLResult.FAILURE;
                        const filter = new Set([
                            "field"
                        ]);
                        if (this.layout.includes("row")) {
                            const columnWidths = this[_symbol_utils.$getSubformParent]().columnWidths;
                            if (Array.isArray(columnWidths) && columnWidths.length > 0) {
                                this[_symbol_utils.$extra].columnWidths = columnWidths;
                                this[_symbol_utils.$extra].currentColumn = 0;
                            }
                        }
                        const style = (0, _html_utils.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign");
                        const classNames = [
                            "xfaExclgroup"
                        ];
                        const cl = (0, _html_utils.layoutClass)(this);
                        if (cl) classNames.push(cl);
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        attributes.style = style;
                        attributes.class = classNames;
                        if (this.name) attributes.xfaName = this.name;
                        this[_symbol_utils.$pushPara]();
                        const isLrTb = this.layout === "lr-tb" || this.layout === "rl-tb";
                        const maxRun = isLrTb ? MAX_ATTEMPTS_FOR_LRTB_LAYOUT : 1;
                        for(; this[_symbol_utils.$extra].attempt < maxRun; this[_symbol_utils.$extra].attempt++){
                            if (isLrTb && this[_symbol_utils.$extra].attempt === MAX_ATTEMPTS_FOR_LRTB_LAYOUT - 1) this[_symbol_utils.$extra].numberInLine = 0;
                            const result = this[_symbol_utils.$childrenToHTML]({
                                filter: filter,
                                include: true
                            });
                            if (result.success) break;
                            if (result.isBreak()) {
                                this[_symbol_utils.$popPara]();
                                return result;
                            }
                            if (isLrTb && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine === 0 && !this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                                this[_symbol_utils.$extra].attempt = maxRun;
                                break;
                            }
                        }
                        this[_symbol_utils.$popPara]();
                        if (!isSplittable) unsetFirstUnsplittable(this);
                        if (this[_symbol_utils.$extra].attempt === maxRun) {
                            if (!isSplittable) delete this[_symbol_utils.$extra];
                            return _utils.HTMLResult.FAILURE;
                        }
                        let marginH = 0;
                        let marginV = 0;
                        if (this.margin) {
                            marginH = this.margin.leftInset + this.margin.rightInset;
                            marginV = this.margin.topInset + this.margin.bottomInset;
                        }
                        const width = Math.max(this[_symbol_utils.$extra].width + marginH, this.w || 0);
                        const height = Math.max(this[_symbol_utils.$extra].height + marginV, this.h || 0);
                        const bbox = [
                            this.x,
                            this.y,
                            width,
                            height
                        ];
                        if (this.w === "") style.width = (0, _html_utils.measureToString)(width);
                        if (this.h === "") style.height = (0, _html_utils.measureToString)(height);
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        applyAssist(this, attributes);
                        delete this[_symbol_utils.$extra];
                        return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                    }
                }
                class Execute extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "execute");
                        this.connection = attributes.connection || "";
                        this.executeType = (0, _utils.getStringOption)(attributes.executeType, [
                            "import",
                            "remerge"
                        ]);
                        this.id = attributes.id || "";
                        this.runAt = (0, _utils.getStringOption)(attributes.runAt, [
                            "client",
                            "both",
                            "server"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Extras extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "extras", true);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.extras = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                }
                class Field extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "field", true);
                        this.access = (0, _utils.getStringOption)(attributes.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.accessKey = attributes.accessKey || "";
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.locale = attributes.locale || "";
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.rotate = (0, _utils.getInteger)({
                            data: attributes.rotate,
                            defaultValue: 0,
                            validate: (x)=>x % 90 === 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.border = null;
                        this.calculate = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.font = null;
                        this.format = null;
                        this.items = new _xfa_object.XFAObjectArray(2);
                        this.keep = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.ui = null;
                        this.validate = null;
                        this.value = null;
                        this.bindItems = new _xfa_object.XFAObjectArray();
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                    [_symbol_utils.$setValue](value) {
                        _setValue(this, value);
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        setTabIndex(this);
                        if (!this.ui) {
                            this.ui = new Ui({});
                            this.ui[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                            this[_symbol_utils.$appendChild](this.ui);
                            let node;
                            switch(this.items.children.length){
                                case 0:
                                    node = new TextEdit({});
                                    this.ui.textEdit = node;
                                    break;
                                case 1:
                                    node = new CheckButton({});
                                    this.ui.checkButton = node;
                                    break;
                                case 2:
                                    node = new ChoiceList({});
                                    this.ui.choiceList = node;
                                    break;
                            }
                            this.ui[_symbol_utils.$appendChild](node);
                        }
                        if (!this.ui || this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) return _utils.HTMLResult.EMPTY;
                        if (this.caption) delete this.caption[_symbol_utils.$extra];
                        this[_symbol_utils.$pushPara]();
                        const caption = this.caption ? this.caption[_symbol_utils.$toHTML](availableSpace).html : null;
                        const savedW = this.w;
                        const savedH = this.h;
                        let marginH = 0;
                        let marginV = 0;
                        if (this.margin) {
                            marginH = this.margin.leftInset + this.margin.rightInset;
                            marginV = this.margin.topInset + this.margin.bottomInset;
                        }
                        let borderDims = null;
                        if (this.w === "" || this.h === "") {
                            let width = null;
                            let height = null;
                            let uiW = 0;
                            let uiH = 0;
                            if (this.ui.checkButton) uiW = uiH = this.ui.checkButton.size;
                            else {
                                const { w: w, h: h } = (0, _html_utils.layoutNode)(this, availableSpace);
                                if (w !== null) {
                                    uiW = w;
                                    uiH = h;
                                } else uiH = (0, _fonts.getMetrics)(this.font, true).lineNoGap;
                            }
                            borderDims = getBorderDims(this.ui[_symbol_utils.$getExtra]());
                            uiW += borderDims.w;
                            uiH += borderDims.h;
                            if (this.caption) {
                                const { w: w, h: h, isBroken: isBroken } = this.caption[_symbol_utils.$getExtra](availableSpace);
                                if (isBroken && this[_symbol_utils.$getSubformParent]()[_symbol_utils.$isThereMoreWidth]()) {
                                    this[_symbol_utils.$popPara]();
                                    return _utils.HTMLResult.FAILURE;
                                }
                                width = w;
                                height = h;
                                switch(this.caption.placement){
                                    case "left":
                                    case "right":
                                    case "inline":
                                        width += uiW;
                                        break;
                                    case "top":
                                    case "bottom":
                                        height += uiH;
                                        break;
                                }
                            } else {
                                width = uiW;
                                height = uiH;
                            }
                            if (width && this.w === "") {
                                width += marginH;
                                this.w = Math.min(this.maxW <= 0 ? Infinity : this.maxW, this.minW + 1 < width ? width : this.minW);
                            }
                            if (height && this.h === "") {
                                height += marginV;
                                this.h = Math.min(this.maxH <= 0 ? Infinity : this.maxH, this.minH + 1 < height ? height : this.minH);
                            }
                        }
                        this[_symbol_utils.$popPara]();
                        (0, _html_utils.fixDimensions)(this);
                        setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                            this.w = savedW;
                            this.h = savedH;
                            this[_symbol_utils.$popPara]();
                            return _utils.HTMLResult.FAILURE;
                        }
                        unsetFirstUnsplittable(this);
                        const style = (0, _html_utils.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
                        (0, _html_utils.setMinMaxDimensions)(this, style);
                        const classNames = [
                            "xfaField"
                        ];
                        if (this.font) classNames.push("xfaFont");
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        const attributes = {
                            style: style,
                            id: this[_symbol_utils.$uid],
                            class: classNames
                        };
                        if (style.margin) {
                            style.padding = style.margin;
                            delete style.margin;
                        }
                        (0, _html_utils.setAccess)(this, classNames);
                        if (this.name) attributes.xfaName = this.name;
                        const children = [];
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        applyAssist(this, attributes);
                        const borderStyle = this.border ? this.border[_symbol_utils.$toStyle]() : null;
                        const bbox = (0, _html_utils.computeBbox)(this, html, availableSpace);
                        const ui = this.ui[_symbol_utils.$toHTML]().html;
                        if (!ui) {
                            Object.assign(style, borderStyle);
                            return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        }
                        if (this[_symbol_utils.$tabIndex]) {
                            if (ui.children?.[0]) ui.children[0].attributes.tabindex = this[_symbol_utils.$tabIndex];
                            else ui.attributes.tabindex = this[_symbol_utils.$tabIndex];
                        }
                        if (!ui.attributes.style) ui.attributes.style = Object.create(null);
                        let aElement = null;
                        if (this.ui.button) {
                            if (ui.children.length === 1) [aElement] = ui.children.splice(0, 1);
                            Object.assign(ui.attributes.style, borderStyle);
                        } else Object.assign(style, borderStyle);
                        children.push(ui);
                        if (this.value) {
                            if (this.ui.imageEdit) ui.children.push(this.value[_symbol_utils.$toHTML]().html);
                            else if (!this.ui.button) {
                                let value = "";
                                if (this.value.exData) value = this.value.exData[_symbol_utils.$text]();
                                else if (this.value.text) value = this.value.text[_symbol_utils.$getExtra]();
                                else {
                                    const htmlValue = this.value[_symbol_utils.$toHTML]().html;
                                    if (htmlValue !== null) value = htmlValue.children[0].value;
                                }
                                if (this.ui.textEdit && this.value.text?.maxChars) ui.children[0].attributes.maxLength = this.value.text.maxChars;
                                if (value) {
                                    if (this.ui.numericEdit) {
                                        value = parseFloat(value);
                                        value = isNaN(value) ? "" : value.toString();
                                    }
                                    if (ui.children[0].name === "textarea") ui.children[0].attributes.textContent = value;
                                    else ui.children[0].attributes.value = value;
                                }
                            }
                        }
                        if (!this.ui.imageEdit && ui.children?.[0] && this.h) {
                            borderDims = borderDims || getBorderDims(this.ui[_symbol_utils.$getExtra]());
                            let captionHeight = 0;
                            if (this.caption && [
                                "top",
                                "bottom"
                            ].includes(this.caption.placement)) {
                                captionHeight = this.caption.reserve;
                                if (captionHeight <= 0) captionHeight = this.caption[_symbol_utils.$getExtra](availableSpace).h;
                                const inputHeight = this.h - captionHeight - marginV - borderDims.h;
                                ui.children[0].attributes.style.height = (0, _html_utils.measureToString)(inputHeight);
                            } else ui.children[0].attributes.style.height = "100%";
                        }
                        if (aElement) ui.children.push(aElement);
                        if (!caption) {
                            if (ui.attributes.class) ui.attributes.class.push("xfaLeft");
                            this.w = savedW;
                            this.h = savedH;
                            return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        }
                        if (this.ui.button) {
                            if (style.padding) delete style.padding;
                            if (caption.name === "div") caption.name = "span";
                            ui.children.push(caption);
                            return _utils.HTMLResult.success(html, bbox);
                        } else if (this.ui.checkButton) caption.attributes.class[0] = "xfaCaptionForCheckButton";
                        if (!ui.attributes.class) ui.attributes.class = [];
                        ui.children.splice(0, 0, caption);
                        switch(this.caption.placement){
                            case "left":
                                ui.attributes.class.push("xfaLeft");
                                break;
                            case "right":
                                ui.attributes.class.push("xfaRight");
                                break;
                            case "top":
                                ui.attributes.class.push("xfaTop");
                                break;
                            case "bottom":
                                ui.attributes.class.push("xfaBottom");
                                break;
                            case "inline":
                                ui.attributes.class.push("xfaLeft");
                                break;
                        }
                        this.w = savedW;
                        this.h = savedH;
                        return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                    }
                }
                exports.Field = Field;
                class Fill extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "fill", true);
                        this.id = attributes.id || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                        this.linear = null;
                        this.pattern = null;
                        this.radial = null;
                        this.solid = null;
                        this.stipple = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        const parent = this[_symbol_utils.$getParent]();
                        const grandpa = parent[_symbol_utils.$getParent]();
                        const ggrandpa = grandpa[_symbol_utils.$getParent]();
                        const style = Object.create(null);
                        let propName = "color";
                        let altPropName = propName;
                        if (parent instanceof Border) {
                            propName = "background-color";
                            altPropName = "background";
                            if (ggrandpa instanceof Ui) style.backgroundColor = "white";
                        }
                        if (parent instanceof Rectangle || parent instanceof Arc) {
                            propName = altPropName = "fill";
                            style.fill = "white";
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (name === "extras" || name === "color") continue;
                            const obj = this[name];
                            if (!(obj instanceof _xfa_object.XFAObject)) continue;
                            const color = obj[_symbol_utils.$toStyle](this.color);
                            if (color) style[color.startsWith("#") ? propName : altPropName] = color;
                            return style;
                        }
                        if (this.color?.value) {
                            const color = this.color[_symbol_utils.$toStyle]();
                            style[color.startsWith("#") ? propName : altPropName] = color;
                        }
                        return style;
                    }
                }
                class Filter extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "filter", true);
                        this.addRevocationInfo = (0, _utils.getStringOption)(attributes.addRevocationInfo, [
                            "",
                            "required",
                            "optional",
                            "none"
                        ]);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.version = (0, _utils.getInteger)({
                            data: this.version,
                            defaultValue: 5,
                            validate: (x)=>x >= 1 && x <= 5
                        });
                        this.appearanceFilter = null;
                        this.certificates = null;
                        this.digestMethods = null;
                        this.encodings = null;
                        this.encryptionMethods = null;
                        this.handler = null;
                        this.lockDocument = null;
                        this.mdp = null;
                        this.reasons = null;
                        this.timeStamp = null;
                    }
                }
                class Float extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "float");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const number = parseFloat(this[_symbol_utils.$content].trim());
                        this[_symbol_utils.$content] = isNaN(number) ? null : number;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] !== null ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class Font extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "font", true);
                        this.baselineShift = (0, _utils.getMeasurement)(attributes.baselineShift);
                        this.fontHorizontalScale = (0, _utils.getFloat)({
                            data: attributes.fontHorizontalScale,
                            defaultValue: 100,
                            validate: (x)=>x >= 0
                        });
                        this.fontVerticalScale = (0, _utils.getFloat)({
                            data: attributes.fontVerticalScale,
                            defaultValue: 100,
                            validate: (x)=>x >= 0
                        });
                        this.id = attributes.id || "";
                        this.kerningMode = (0, _utils.getStringOption)(attributes.kerningMode, [
                            "none",
                            "pair"
                        ]);
                        this.letterSpacing = (0, _utils.getMeasurement)(attributes.letterSpacing, "0");
                        this.lineThrough = (0, _utils.getInteger)({
                            data: attributes.lineThrough,
                            defaultValue: 0,
                            validate: (x)=>x === 1 || x === 2
                        });
                        this.lineThroughPeriod = (0, _utils.getStringOption)(attributes.lineThroughPeriod, [
                            "all",
                            "word"
                        ]);
                        this.overline = (0, _utils.getInteger)({
                            data: attributes.overline,
                            defaultValue: 0,
                            validate: (x)=>x === 1 || x === 2
                        });
                        this.overlinePeriod = (0, _utils.getStringOption)(attributes.overlinePeriod, [
                            "all",
                            "word"
                        ]);
                        this.posture = (0, _utils.getStringOption)(attributes.posture, [
                            "normal",
                            "italic"
                        ]);
                        this.size = (0, _utils.getMeasurement)(attributes.size, "10pt");
                        this.typeface = attributes.typeface || "Courier";
                        this.underline = (0, _utils.getInteger)({
                            data: attributes.underline,
                            defaultValue: 0,
                            validate: (x)=>x === 1 || x === 2
                        });
                        this.underlinePeriod = (0, _utils.getStringOption)(attributes.underlinePeriod, [
                            "all",
                            "word"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.weight = (0, _utils.getStringOption)(attributes.weight, [
                            "normal",
                            "bold"
                        ]);
                        this.extras = null;
                        this.fill = null;
                    }
                    [_symbol_utils.$clean](builder) {
                        super[_symbol_utils.$clean](builder);
                        this[_symbol_utils.$globalData].usedTypefaces.add(this.typeface);
                    }
                    [_symbol_utils.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "fill");
                        const color = style.color;
                        if (color) {
                            if (color === "#000000") delete style.color;
                            else if (!color.startsWith("#")) {
                                style.background = color;
                                style.backgroundClip = "text";
                                style.color = "transparent";
                            }
                        }
                        if (this.baselineShift) style.verticalAlign = (0, _html_utils.measureToString)(this.baselineShift);
                        style.fontKerning = this.kerningMode === "none" ? "none" : "normal";
                        style.letterSpacing = (0, _html_utils.measureToString)(this.letterSpacing);
                        if (this.lineThrough !== 0) {
                            style.textDecoration = "line-through";
                            if (this.lineThrough === 2) style.textDecorationStyle = "double";
                        }
                        if (this.overline !== 0) {
                            style.textDecoration = "overline";
                            if (this.overline === 2) style.textDecorationStyle = "double";
                        }
                        style.fontStyle = this.posture;
                        style.fontSize = (0, _html_utils.measureToString)(0.99 * this.size);
                        (0, _html_utils.setFontFamily)(this, this, this[_symbol_utils.$globalData].fontFinder, style);
                        if (this.underline !== 0) {
                            style.textDecoration = "underline";
                            if (this.underline === 2) style.textDecorationStyle = "double";
                        }
                        style.fontWeight = this.weight;
                        return style;
                    }
                }
                class Format extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "format", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.picture = null;
                    }
                }
                class Handler extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "handler");
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Hyphenation extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "hyphenation");
                        this.excludeAllCaps = (0, _utils.getInteger)({
                            data: attributes.excludeAllCaps,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.excludeInitialCap = (0, _utils.getInteger)({
                            data: attributes.excludeInitialCap,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.hyphenate = (0, _utils.getInteger)({
                            data: attributes.hyphenate,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.id = attributes.id || "";
                        this.pushCharacterCount = (0, _utils.getInteger)({
                            data: attributes.pushCharacterCount,
                            defaultValue: 3,
                            validate: (x)=>x >= 0
                        });
                        this.remainCharacterCount = (0, _utils.getInteger)({
                            data: attributes.remainCharacterCount,
                            defaultValue: 3,
                            validate: (x)=>x >= 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.wordCharacterCount = (0, _utils.getInteger)({
                            data: attributes.wordCharacterCount,
                            defaultValue: 7,
                            validate: (x)=>x >= 0
                        });
                    }
                }
                class Image extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "image");
                        this.aspect = (0, _utils.getStringOption)(attributes.aspect, [
                            "fit",
                            "actual",
                            "height",
                            "none",
                            "width"
                        ]);
                        this.contentType = attributes.contentType || "";
                        this.href = attributes.href || "";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.transferEncoding = (0, _utils.getStringOption)(attributes.transferEncoding, [
                            "base64",
                            "none",
                            "package"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$toHTML]() {
                        if (this.contentType && !MIMES.has(this.contentType.toLowerCase())) return _utils.HTMLResult.EMPTY;
                        let buffer = this[_symbol_utils.$globalData].images && this[_symbol_utils.$globalData].images.get(this.href);
                        if (!buffer && (this.href || !this[_symbol_utils.$content])) return _utils.HTMLResult.EMPTY;
                        if (!buffer && this.transferEncoding === "base64") buffer = (0, _util.stringToBytes)(atob(this[_symbol_utils.$content]));
                        if (!buffer) return _utils.HTMLResult.EMPTY;
                        if (!this.contentType) {
                            for (const [header, type] of IMAGES_HEADERS)if (buffer.length > header.length && header.every((x, i)=>x === buffer[i])) {
                                this.contentType = type;
                                break;
                            }
                            if (!this.contentType) return _utils.HTMLResult.EMPTY;
                        }
                        const blob = new Blob([
                            buffer
                        ], {
                            type: this.contentType
                        });
                        let style;
                        switch(this.aspect){
                            case "fit":
                            case "actual":
                                break;
                            case "height":
                                style = {
                                    height: "100%",
                                    objectFit: "fill"
                                };
                                break;
                            case "none":
                                style = {
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "fill"
                                };
                                break;
                            case "width":
                                style = {
                                    width: "100%",
                                    objectFit: "fill"
                                };
                                break;
                        }
                        const parent = this[_symbol_utils.$getParent]();
                        return _utils.HTMLResult.success({
                            name: "img",
                            attributes: {
                                class: [
                                    "xfaImage"
                                ],
                                style: style,
                                src: URL.createObjectURL(blob),
                                alt: parent ? ariaLabel(parent[_symbol_utils.$getParent]()) : null
                            }
                        });
                    }
                }
                class ImageEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "imageEdit", true);
                        this.data = (0, _utils.getStringOption)(attributes.data, [
                            "link",
                            "embed"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        if (this.data === "embed") return _utils.HTMLResult.success({
                            name: "div",
                            children: [],
                            attributes: {}
                        });
                        return _utils.HTMLResult.EMPTY;
                    }
                }
                class Integer extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "integer");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const number = parseInt(this[_symbol_utils.$content].trim(), 10);
                        this[_symbol_utils.$content] = isNaN(number) ? null : number;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] !== null ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class Issuers extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "issuers", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = new _xfa_object.XFAObjectArray();
                    }
                }
                class Items extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "items", true);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.ref = attributes.ref || "";
                        this.save = (0, _utils.getInteger)({
                            data: attributes.save,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$toHTML]() {
                        const output = [];
                        for (const child of this[_symbol_utils.$getChildren]())output.push(child[_symbol_utils.$text]());
                        return _utils.HTMLResult.success(output);
                    }
                }
                exports.Items = Items;
                class Keep extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "keep", true);
                        this.id = attributes.id || "";
                        const options = [
                            "none",
                            "contentArea",
                            "pageArea"
                        ];
                        this.intact = (0, _utils.getStringOption)(attributes.intact, options);
                        this.next = (0, _utils.getStringOption)(attributes.next, options);
                        this.previous = (0, _utils.getStringOption)(attributes.previous, options);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class KeyUsage extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "keyUsage");
                        const options = [
                            "",
                            "yes",
                            "no"
                        ];
                        this.crlSign = (0, _utils.getStringOption)(attributes.crlSign, options);
                        this.dataEncipherment = (0, _utils.getStringOption)(attributes.dataEncipherment, options);
                        this.decipherOnly = (0, _utils.getStringOption)(attributes.decipherOnly, options);
                        this.digitalSignature = (0, _utils.getStringOption)(attributes.digitalSignature, options);
                        this.encipherOnly = (0, _utils.getStringOption)(attributes.encipherOnly, options);
                        this.id = attributes.id || "";
                        this.keyAgreement = (0, _utils.getStringOption)(attributes.keyAgreement, options);
                        this.keyCertSign = (0, _utils.getStringOption)(attributes.keyCertSign, options);
                        this.keyEncipherment = (0, _utils.getStringOption)(attributes.keyEncipherment, options);
                        this.nonRepudiation = (0, _utils.getStringOption)(attributes.nonRepudiation, options);
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Line extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "line", true);
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.slope = (0, _utils.getStringOption)(attributes.slope, [
                            "\\",
                            "/"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.edge = null;
                    }
                    [_symbol_utils.$toHTML]() {
                        const parent = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        const edge = this.edge || new Edge({});
                        const edgeStyle = edge[_symbol_utils.$toStyle]();
                        const style = Object.create(null);
                        const thickness = edge.presence === "visible" ? edge.thickness : 0;
                        style.strokeWidth = (0, _html_utils.measureToString)(thickness);
                        style.stroke = edgeStyle.color;
                        let x1, y1, x2, y2;
                        let width = "100%";
                        let height = "100%";
                        if (parent.w <= thickness) {
                            [x1, y1, x2, y2] = [
                                "50%",
                                0,
                                "50%",
                                "100%"
                            ];
                            width = style.strokeWidth;
                        } else if (parent.h <= thickness) {
                            [x1, y1, x2, y2] = [
                                0,
                                "50%",
                                "100%",
                                "50%"
                            ];
                            height = style.strokeWidth;
                        } else if (this.slope === "\\") [x1, y1, x2, y2] = [
                            0,
                            0,
                            "100%",
                            "100%"
                        ];
                        else [x1, y1, x2, y2] = [
                            0,
                            "100%",
                            "100%",
                            0
                        ];
                        const line = {
                            name: "line",
                            attributes: {
                                xmlns: SVG_NS,
                                x1: x1,
                                y1: y1,
                                x2: x2,
                                y2: y2,
                                style: style
                            }
                        };
                        const svg = {
                            name: "svg",
                            children: [
                                line
                            ],
                            attributes: {
                                xmlns: SVG_NS,
                                width: width,
                                height: height,
                                style: {
                                    overflow: "visible"
                                }
                            }
                        };
                        if (hasMargin(parent)) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                svg
                            ]
                        });
                        svg.attributes.style.position = "absolute";
                        return _utils.HTMLResult.success(svg);
                    }
                }
                class Linear extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "linear", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "toRight",
                            "toBottom",
                            "toLeft",
                            "toTop"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](startColor) {
                        startColor = startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                        const transf = this.type.replace(/([RBLT])/, " $1").toLowerCase();
                        const endColor = this.color ? this.color[_symbol_utils.$toStyle]() : "#000000";
                        return `linear-gradient(${transf}, ${startColor}, ${endColor})`;
                    }
                }
                class LockDocument extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "lockDocument");
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = (0, _utils.getStringOption)(this[_symbol_utils.$content], [
                            "auto",
                            "0",
                            "1"
                        ]);
                    }
                }
                class Manifest extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "manifest", true);
                        this.action = (0, _utils.getStringOption)(attributes.action, [
                            "include",
                            "all",
                            "exclude"
                        ]);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.ref = new _xfa_object.XFAObjectArray();
                    }
                }
                class Margin extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "margin", true);
                        this.bottomInset = (0, _utils.getMeasurement)(attributes.bottomInset, "0");
                        this.id = attributes.id || "";
                        this.leftInset = (0, _utils.getMeasurement)(attributes.leftInset, "0");
                        this.rightInset = (0, _utils.getMeasurement)(attributes.rightInset, "0");
                        this.topInset = (0, _utils.getMeasurement)(attributes.topInset, "0");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        return {
                            margin: (0, _html_utils.measureToString)(this.topInset) + " " + (0, _html_utils.measureToString)(this.rightInset) + " " + (0, _html_utils.measureToString)(this.bottomInset) + " " + (0, _html_utils.measureToString)(this.leftInset)
                        };
                    }
                }
                class Mdp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "mdp");
                        this.id = attributes.id || "";
                        this.permissions = (0, _utils.getInteger)({
                            data: attributes.permissions,
                            defaultValue: 2,
                            validate: (x)=>x === 1 || x === 3
                        });
                        this.signatureType = (0, _utils.getStringOption)(attributes.signatureType, [
                            "filler",
                            "author"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Medium extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "medium");
                        this.id = attributes.id || "";
                        this.imagingBBox = (0, _utils.getBBox)(attributes.imagingBBox);
                        this.long = (0, _utils.getMeasurement)(attributes.long);
                        this.orientation = (0, _utils.getStringOption)(attributes.orientation, [
                            "portrait",
                            "landscape"
                        ]);
                        this.short = (0, _utils.getMeasurement)(attributes.short);
                        this.stock = attributes.stock || "";
                        this.trayIn = (0, _utils.getStringOption)(attributes.trayIn, [
                            "auto",
                            "delegate",
                            "pageFront"
                        ]);
                        this.trayOut = (0, _utils.getStringOption)(attributes.trayOut, [
                            "auto",
                            "delegate"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Message extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "message", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.text = new _xfa_object.XFAObjectArray();
                    }
                }
                class NumericEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "numericEdit", true);
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                        const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        const html = {
                            name: "input",
                            attributes: {
                                type: "text",
                                fieldId: field[_symbol_utils.$uid],
                                dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        if (isRequired(field)) {
                            html.attributes["aria-required"] = true;
                            html.attributes.required = true;
                        }
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                html
                            ]
                        });
                    }
                }
                class Occur extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "occur", true);
                        this.id = attributes.id || "";
                        this.initial = attributes.initial !== "" ? (0, _utils.getInteger)({
                            data: attributes.initial,
                            defaultValue: "",
                            validate: (x)=>true
                        }) : "";
                        this.max = attributes.max !== "" ? (0, _utils.getInteger)({
                            data: attributes.max,
                            defaultValue: 1,
                            validate: (x)=>true
                        }) : "";
                        this.min = attributes.min !== "" ? (0, _utils.getInteger)({
                            data: attributes.min,
                            defaultValue: 1,
                            validate: (x)=>true
                        }) : "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_symbol_utils.$clean]() {
                        const parent = this[_symbol_utils.$getParent]();
                        const originalMin = this.min;
                        if (this.min === "") this.min = parent instanceof PageArea || parent instanceof PageSet ? 0 : 1;
                        if (this.max === "") {
                            if (originalMin === "") this.max = parent instanceof PageArea || parent instanceof PageSet ? -1 : 1;
                            else this.max = this.min;
                        }
                        if (this.max !== -1 && this.max < this.min) this.max = this.min;
                        if (this.initial === "") this.initial = parent instanceof Template ? 1 : this.min;
                    }
                }
                class Oid extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "oid");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Oids extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "oids", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.oid = new _xfa_object.XFAObjectArray();
                    }
                }
                class Overflow extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "overflow");
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.target = attributes.target || "";
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$getExtra]() {
                        if (!this[_symbol_utils.$extra]) {
                            const parent = this[_symbol_utils.$getParent]();
                            const root = this[_symbol_utils.$getTemplateRoot]();
                            const target = root[_symbol_utils.$searchNode](this.target, parent);
                            const leader = root[_symbol_utils.$searchNode](this.leader, parent);
                            const trailer = root[_symbol_utils.$searchNode](this.trailer, parent);
                            this[_symbol_utils.$extra] = {
                                target: target?.[0] || null,
                                leader: leader?.[0] || null,
                                trailer: trailer?.[0] || null,
                                addLeader: false,
                                addTrailer: false
                            };
                        }
                        return this[_symbol_utils.$extra];
                    }
                }
                class PageArea extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "pageArea", true);
                        this.blankOrNotBlank = (0, _utils.getStringOption)(attributes.blankOrNotBlank, [
                            "any",
                            "blank",
                            "notBlank"
                        ]);
                        this.id = attributes.id || "";
                        this.initialNumber = (0, _utils.getInteger)({
                            data: attributes.initialNumber,
                            defaultValue: 1,
                            validate: (x)=>true
                        });
                        this.name = attributes.name || "";
                        this.numbered = (0, _utils.getInteger)({
                            data: attributes.numbered,
                            defaultValue: 1,
                            validate: (x)=>true
                        });
                        this.oddOrEven = (0, _utils.getStringOption)(attributes.oddOrEven, [
                            "any",
                            "even",
                            "odd"
                        ]);
                        this.pagePosition = (0, _utils.getStringOption)(attributes.pagePosition, [
                            "any",
                            "first",
                            "last",
                            "only",
                            "rest"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.desc = null;
                        this.extras = null;
                        this.medium = null;
                        this.occur = null;
                        this.area = new _xfa_object.XFAObjectArray();
                        this.contentArea = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$isUsable]() {
                        if (!this[_symbol_utils.$extra]) {
                            this[_symbol_utils.$extra] = {
                                numberOfUse: 0
                            };
                            return true;
                        }
                        return !this.occur || this.occur.max === -1 || this[_symbol_utils.$extra].numberOfUse < this.occur.max;
                    }
                    [_symbol_utils.$cleanPage]() {
                        delete this[_symbol_utils.$extra];
                    }
                    [_symbol_utils.$getNextPage]() {
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = {
                            numberOfUse: 0
                        };
                        const parent = this[_symbol_utils.$getParent]();
                        if (parent.relation === "orderedOccurrence") {
                            if (this[_symbol_utils.$isUsable]()) {
                                this[_symbol_utils.$extra].numberOfUse += 1;
                                return this;
                            }
                        }
                        return parent[_symbol_utils.$getNextPage]();
                    }
                    [_symbol_utils.$getAvailableSpace]() {
                        return this[_symbol_utils.$extra].space || {
                            width: 0,
                            height: 0
                        };
                    }
                    [_symbol_utils.$toHTML]() {
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = {
                            numberOfUse: 1
                        };
                        const children = [];
                        this[_symbol_utils.$extra].children = children;
                        const style = Object.create(null);
                        if (this.medium && this.medium.short && this.medium.long) {
                            style.width = (0, _html_utils.measureToString)(this.medium.short);
                            style.height = (0, _html_utils.measureToString)(this.medium.long);
                            this[_symbol_utils.$extra].space = {
                                width: this.medium.short,
                                height: this.medium.long
                            };
                            if (this.medium.orientation === "landscape") {
                                const x = style.width;
                                style.width = style.height;
                                style.height = x;
                                this[_symbol_utils.$extra].space = {
                                    width: this.medium.long,
                                    height: this.medium.short
                                };
                            }
                        } else (0, _util.warn)("XFA - No medium specified in pageArea: please file a bug.");
                        this[_symbol_utils.$childrenToHTML]({
                            filter: new Set([
                                "area",
                                "draw",
                                "field",
                                "subform"
                            ]),
                            include: true
                        });
                        this[_symbol_utils.$childrenToHTML]({
                            filter: new Set([
                                "contentArea"
                            ]),
                            include: true
                        });
                        return _utils.HTMLResult.success({
                            name: "div",
                            children: children,
                            attributes: {
                                class: [
                                    "xfaPage"
                                ],
                                id: this[_symbol_utils.$uid],
                                style: style,
                                xfaName: this.name
                            }
                        });
                    }
                }
                class PageSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "pageSet", true);
                        this.duplexImposition = (0, _utils.getStringOption)(attributes.duplexImposition, [
                            "longEdge",
                            "shortEdge"
                        ]);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relation = (0, _utils.getStringOption)(attributes.relation, [
                            "orderedOccurrence",
                            "duplexPaginated",
                            "simplexPaginated"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.occur = null;
                        this.pageArea = new _xfa_object.XFAObjectArray();
                        this.pageSet = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$cleanPage]() {
                        for (const page of this.pageArea.children)page[_symbol_utils.$cleanPage]();
                        for (const page of this.pageSet.children)page[_symbol_utils.$cleanPage]();
                    }
                    [_symbol_utils.$isUsable]() {
                        return !this.occur || this.occur.max === -1 || this[_symbol_utils.$extra].numberOfUse < this.occur.max;
                    }
                    [_symbol_utils.$getNextPage]() {
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = {
                            numberOfUse: 1,
                            pageIndex: -1,
                            pageSetIndex: -1
                        };
                        if (this.relation === "orderedOccurrence") {
                            if (this[_symbol_utils.$extra].pageIndex + 1 < this.pageArea.children.length) {
                                this[_symbol_utils.$extra].pageIndex += 1;
                                const pageArea = this.pageArea.children[this[_symbol_utils.$extra].pageIndex];
                                return pageArea[_symbol_utils.$getNextPage]();
                            }
                            if (this[_symbol_utils.$extra].pageSetIndex + 1 < this.pageSet.children.length) {
                                this[_symbol_utils.$extra].pageSetIndex += 1;
                                return this.pageSet.children[this[_symbol_utils.$extra].pageSetIndex][_symbol_utils.$getNextPage]();
                            }
                            if (this[_symbol_utils.$isUsable]()) {
                                this[_symbol_utils.$extra].numberOfUse += 1;
                                this[_symbol_utils.$extra].pageIndex = -1;
                                this[_symbol_utils.$extra].pageSetIndex = -1;
                                return this[_symbol_utils.$getNextPage]();
                            }
                            const parent = this[_symbol_utils.$getParent]();
                            if (parent instanceof PageSet) return parent[_symbol_utils.$getNextPage]();
                            this[_symbol_utils.$cleanPage]();
                            return this[_symbol_utils.$getNextPage]();
                        }
                        const pageNumber = this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].pageNumber;
                        const parity = pageNumber % 2 === 0 ? "even" : "odd";
                        const position = pageNumber === 0 ? "first" : "rest";
                        let page = this.pageArea.children.find((p)=>p.oddOrEven === parity && p.pagePosition === position);
                        if (page) return page;
                        page = this.pageArea.children.find((p)=>p.oddOrEven === "any" && p.pagePosition === position);
                        if (page) return page;
                        page = this.pageArea.children.find((p)=>p.oddOrEven === "any" && p.pagePosition === "any");
                        if (page) return page;
                        return this.pageArea.children[0];
                    }
                }
                class Para extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "para", true);
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.lineHeight = attributes.lineHeight ? (0, _utils.getMeasurement)(attributes.lineHeight, "0pt") : "";
                        this.marginLeft = attributes.marginLeft ? (0, _utils.getMeasurement)(attributes.marginLeft, "0pt") : "";
                        this.marginRight = attributes.marginRight ? (0, _utils.getMeasurement)(attributes.marginRight, "0pt") : "";
                        this.orphans = (0, _utils.getInteger)({
                            data: attributes.orphans,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.preserve = attributes.preserve || "";
                        this.radixOffset = attributes.radixOffset ? (0, _utils.getMeasurement)(attributes.radixOffset, "0pt") : "";
                        this.spaceAbove = attributes.spaceAbove ? (0, _utils.getMeasurement)(attributes.spaceAbove, "0pt") : "";
                        this.spaceBelow = attributes.spaceBelow ? (0, _utils.getMeasurement)(attributes.spaceBelow, "0pt") : "";
                        this.tabDefault = attributes.tabDefault ? (0, _utils.getMeasurement)(this.tabDefault) : "";
                        this.tabStops = (attributes.tabStops || "").trim().split(/\s+/).map((x, i)=>i % 2 === 1 ? (0, _utils.getMeasurement)(x) : x);
                        this.textIndent = attributes.textIndent ? (0, _utils.getMeasurement)(attributes.textIndent, "0pt") : "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.vAlign = (0, _utils.getStringOption)(attributes.vAlign, [
                            "top",
                            "bottom",
                            "middle"
                        ]);
                        this.widows = (0, _utils.getInteger)({
                            data: attributes.widows,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.hyphenation = null;
                    }
                    [_symbol_utils.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "hAlign");
                        if (this.marginLeft !== "") style.paddingLeft = (0, _html_utils.measureToString)(this.marginLeft);
                        if (this.marginRight !== "") style.paddingight = (0, _html_utils.measureToString)(this.marginRight);
                        if (this.spaceAbove !== "") style.paddingTop = (0, _html_utils.measureToString)(this.spaceAbove);
                        if (this.spaceBelow !== "") style.paddingBottom = (0, _html_utils.measureToString)(this.spaceBelow);
                        if (this.textIndent !== "") {
                            style.textIndent = (0, _html_utils.measureToString)(this.textIndent);
                            (0, _html_utils.fixTextIndent)(style);
                        }
                        if (this.lineHeight > 0) style.lineHeight = (0, _html_utils.measureToString)(this.lineHeight);
                        if (this.tabDefault !== "") style.tabSize = (0, _html_utils.measureToString)(this.tabDefault);
                        this.tabStops.length;
                        if (this.hyphenatation) Object.assign(style, this.hyphenatation[_symbol_utils.$toStyle]());
                        return style;
                    }
                }
                class PasswordEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "passwordEdit", true);
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.passwordChar = attributes.passwordChar || "*";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                }
                class Pattern extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "pattern", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "crossHatch",
                            "crossDiagonal",
                            "diagonalLeft",
                            "diagonalRight",
                            "horizontal",
                            "vertical"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](startColor) {
                        startColor = startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                        const endColor = this.color ? this.color[_symbol_utils.$toStyle]() : "#000000";
                        const width = 5;
                        const cmd = "repeating-linear-gradient";
                        const colors = `${startColor},${startColor} ${width}px,${endColor} ${width}px,${endColor} ${2 * width}px`;
                        switch(this.type){
                            case "crossHatch":
                                return `${cmd}(to top,${colors}) ${cmd}(to right,${colors})`;
                            case "crossDiagonal":
                                return `${cmd}(45deg,${colors}) ${cmd}(-45deg,${colors})`;
                            case "diagonalLeft":
                                return `${cmd}(45deg,${colors})`;
                            case "diagonalRight":
                                return `${cmd}(-45deg,${colors})`;
                            case "horizontal":
                                return `${cmd}(to top,${colors})`;
                            case "vertical":
                                return `${cmd}(to right,${colors})`;
                        }
                        return "";
                    }
                }
                class Picture extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "picture");
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Proto extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "proto", true);
                        this.appearanceFilter = new _xfa_object.XFAObjectArray();
                        this.arc = new _xfa_object.XFAObjectArray();
                        this.area = new _xfa_object.XFAObjectArray();
                        this.assist = new _xfa_object.XFAObjectArray();
                        this.barcode = new _xfa_object.XFAObjectArray();
                        this.bindItems = new _xfa_object.XFAObjectArray();
                        this.bookend = new _xfa_object.XFAObjectArray();
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.border = new _xfa_object.XFAObjectArray();
                        this.break = new _xfa_object.XFAObjectArray();
                        this.breakAfter = new _xfa_object.XFAObjectArray();
                        this.breakBefore = new _xfa_object.XFAObjectArray();
                        this.button = new _xfa_object.XFAObjectArray();
                        this.calculate = new _xfa_object.XFAObjectArray();
                        this.caption = new _xfa_object.XFAObjectArray();
                        this.certificate = new _xfa_object.XFAObjectArray();
                        this.certificates = new _xfa_object.XFAObjectArray();
                        this.checkButton = new _xfa_object.XFAObjectArray();
                        this.choiceList = new _xfa_object.XFAObjectArray();
                        this.color = new _xfa_object.XFAObjectArray();
                        this.comb = new _xfa_object.XFAObjectArray();
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.contentArea = new _xfa_object.XFAObjectArray();
                        this.corner = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.dateTimeEdit = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.defaultUi = new _xfa_object.XFAObjectArray();
                        this.desc = new _xfa_object.XFAObjectArray();
                        this.digestMethod = new _xfa_object.XFAObjectArray();
                        this.digestMethods = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.edge = new _xfa_object.XFAObjectArray();
                        this.encoding = new _xfa_object.XFAObjectArray();
                        this.encodings = new _xfa_object.XFAObjectArray();
                        this.encrypt = new _xfa_object.XFAObjectArray();
                        this.encryptData = new _xfa_object.XFAObjectArray();
                        this.encryption = new _xfa_object.XFAObjectArray();
                        this.encryptionMethod = new _xfa_object.XFAObjectArray();
                        this.encryptionMethods = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.execute = new _xfa_object.XFAObjectArray();
                        this.extras = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.fill = new _xfa_object.XFAObjectArray();
                        this.filter = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.font = new _xfa_object.XFAObjectArray();
                        this.format = new _xfa_object.XFAObjectArray();
                        this.handler = new _xfa_object.XFAObjectArray();
                        this.hyphenation = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.imageEdit = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.issuers = new _xfa_object.XFAObjectArray();
                        this.items = new _xfa_object.XFAObjectArray();
                        this.keep = new _xfa_object.XFAObjectArray();
                        this.keyUsage = new _xfa_object.XFAObjectArray();
                        this.line = new _xfa_object.XFAObjectArray();
                        this.linear = new _xfa_object.XFAObjectArray();
                        this.lockDocument = new _xfa_object.XFAObjectArray();
                        this.manifest = new _xfa_object.XFAObjectArray();
                        this.margin = new _xfa_object.XFAObjectArray();
                        this.mdp = new _xfa_object.XFAObjectArray();
                        this.medium = new _xfa_object.XFAObjectArray();
                        this.message = new _xfa_object.XFAObjectArray();
                        this.numericEdit = new _xfa_object.XFAObjectArray();
                        this.occur = new _xfa_object.XFAObjectArray();
                        this.oid = new _xfa_object.XFAObjectArray();
                        this.oids = new _xfa_object.XFAObjectArray();
                        this.overflow = new _xfa_object.XFAObjectArray();
                        this.pageArea = new _xfa_object.XFAObjectArray();
                        this.pageSet = new _xfa_object.XFAObjectArray();
                        this.para = new _xfa_object.XFAObjectArray();
                        this.passwordEdit = new _xfa_object.XFAObjectArray();
                        this.pattern = new _xfa_object.XFAObjectArray();
                        this.picture = new _xfa_object.XFAObjectArray();
                        this.radial = new _xfa_object.XFAObjectArray();
                        this.reason = new _xfa_object.XFAObjectArray();
                        this.reasons = new _xfa_object.XFAObjectArray();
                        this.rectangle = new _xfa_object.XFAObjectArray();
                        this.ref = new _xfa_object.XFAObjectArray();
                        this.script = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                        this.signData = new _xfa_object.XFAObjectArray();
                        this.signature = new _xfa_object.XFAObjectArray();
                        this.signing = new _xfa_object.XFAObjectArray();
                        this.solid = new _xfa_object.XFAObjectArray();
                        this.speak = new _xfa_object.XFAObjectArray();
                        this.stipple = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                        this.subjectDN = new _xfa_object.XFAObjectArray();
                        this.subjectDNs = new _xfa_object.XFAObjectArray();
                        this.submit = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.textEdit = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                        this.timeStamp = new _xfa_object.XFAObjectArray();
                        this.toolTip = new _xfa_object.XFAObjectArray();
                        this.traversal = new _xfa_object.XFAObjectArray();
                        this.traverse = new _xfa_object.XFAObjectArray();
                        this.ui = new _xfa_object.XFAObjectArray();
                        this.validate = new _xfa_object.XFAObjectArray();
                        this.value = new _xfa_object.XFAObjectArray();
                        this.variables = new _xfa_object.XFAObjectArray();
                    }
                }
                class Radial extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "radial", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "toEdge",
                            "toCenter"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](startColor) {
                        startColor = startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                        const endColor = this.color ? this.color[_symbol_utils.$toStyle]() : "#000000";
                        const colors = this.type === "toEdge" ? `${startColor},${endColor}` : `${endColor},${startColor}`;
                        return `radial-gradient(circle at center, ${colors})`;
                    }
                }
                class Reason extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "reason");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Reasons extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "reasons", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.reason = new _xfa_object.XFAObjectArray();
                    }
                }
                class Rectangle extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "rectangle", true);
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.corner = new _xfa_object.XFAObjectArray(4);
                        this.edge = new _xfa_object.XFAObjectArray(4);
                        this.fill = null;
                    }
                    [_symbol_utils.$toHTML]() {
                        const edge = this.edge.children.length ? this.edge.children[0] : new Edge({});
                        const edgeStyle = edge[_symbol_utils.$toStyle]();
                        const style = Object.create(null);
                        if (this.fill?.presence === "visible") Object.assign(style, this.fill[_symbol_utils.$toStyle]());
                        else style.fill = "transparent";
                        style.strokeWidth = (0, _html_utils.measureToString)(edge.presence === "visible" ? edge.thickness : 0);
                        style.stroke = edgeStyle.color;
                        const corner = this.corner.children.length ? this.corner.children[0] : new Corner({});
                        const cornerStyle = corner[_symbol_utils.$toStyle]();
                        const rect = {
                            name: "rect",
                            attributes: {
                                xmlns: SVG_NS,
                                width: "100%",
                                height: "100%",
                                x: 0,
                                y: 0,
                                rx: cornerStyle.radius,
                                ry: cornerStyle.radius,
                                style: style
                            }
                        };
                        const svg = {
                            name: "svg",
                            children: [
                                rect
                            ],
                            attributes: {
                                xmlns: SVG_NS,
                                style: {
                                    overflow: "visible"
                                },
                                width: "100%",
                                height: "100%"
                            }
                        };
                        const parent = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        if (hasMargin(parent)) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                svg
                            ]
                        });
                        svg.attributes.style.position = "absolute";
                        return _utils.HTMLResult.success(svg);
                    }
                }
                class RefElement extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "ref");
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Script extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "script");
                        this.binding = attributes.binding || "";
                        this.contentType = attributes.contentType || "";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.runAt = (0, _utils.getStringOption)(attributes.runAt, [
                            "client",
                            "both",
                            "server"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class SetProperty extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "setProperty");
                        this.connection = attributes.connection || "";
                        this.ref = attributes.ref || "";
                        this.target = attributes.target || "";
                    }
                }
                exports.SetProperty = SetProperty;
                class SignData extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "signData", true);
                        this.id = attributes.id || "";
                        this.operation = (0, _utils.getStringOption)(attributes.operation, [
                            "sign",
                            "clear",
                            "verify"
                        ]);
                        this.ref = attributes.ref || "";
                        this.target = attributes.target || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.filter = null;
                        this.manifest = null;
                    }
                }
                class Signature extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "signature", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "PDF1.3",
                            "PDF1.6"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.filter = null;
                        this.manifest = null;
                        this.margin = null;
                    }
                }
                class Signing extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "signing", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = new _xfa_object.XFAObjectArray();
                    }
                }
                class Solid extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "solid", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](startColor) {
                        return startColor ? startColor[_symbol_utils.$toStyle]() : "#FFFFFF";
                    }
                }
                class Speak extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "speak");
                        this.disable = (0, _utils.getInteger)({
                            data: attributes.disable,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.id = attributes.id || "";
                        this.priority = (0, _utils.getStringOption)(attributes.priority, [
                            "custom",
                            "caption",
                            "name",
                            "toolTip"
                        ]);
                        this.rid = attributes.rid || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Stipple extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "stipple", true);
                        this.id = attributes.id || "";
                        this.rate = (0, _utils.getInteger)({
                            data: attributes.rate,
                            defaultValue: 50,
                            validate: (x)=>x >= 0 && x <= 100
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_symbol_utils.$toStyle](bgColor) {
                        const alpha = this.rate / 100;
                        return _util.Util.makeHexColor(Math.round(bgColor.value.r * (1 - alpha) + this.value.r * alpha), Math.round(bgColor.value.g * (1 - alpha) + this.value.g * alpha), Math.round(bgColor.value.b * (1 - alpha) + this.value.b * alpha));
                    }
                }
                class Subform extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subform", true);
                        this.access = (0, _utils.getStringOption)(attributes.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.allowMacro = (0, _utils.getInteger)({
                            data: attributes.allowMacro,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.columnWidths = (attributes.columnWidths || "").trim().split(/\s+/).map((x)=>x === "-1" ? -1 : (0, _utils.getMeasurement)(x));
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.layout = (0, _utils.getStringOption)(attributes.layout, [
                            "position",
                            "lr-tb",
                            "rl-row",
                            "rl-tb",
                            "row",
                            "table",
                            "tb"
                        ]);
                        this.locale = attributes.locale || "";
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.mergeMode = (0, _utils.getStringOption)(attributes.mergeMode, [
                            "consumeData",
                            "matchTemplate"
                        ]);
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.restoreState = (0, _utils.getStringOption)(attributes.restoreState, [
                            "manual",
                            "auto"
                        ]);
                        this.scope = (0, _utils.getStringOption)(attributes.scope, [
                            "name",
                            "none"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.bookend = null;
                        this.border = null;
                        this.break = null;
                        this.calculate = null;
                        this.desc = null;
                        this.extras = null;
                        this.keep = null;
                        this.margin = null;
                        this.occur = null;
                        this.overflow = null;
                        this.pageSet = null;
                        this.para = null;
                        this.traversal = null;
                        this.validate = null;
                        this.variables = null;
                        this.area = new _xfa_object.XFAObjectArray();
                        this.breakAfter = new _xfa_object.XFAObjectArray();
                        this.breakBefore = new _xfa_object.XFAObjectArray();
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.proto = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$getSubformParent]() {
                        const parent = this[_symbol_utils.$getParent]();
                        if (parent instanceof SubformSet) return parent[_symbol_utils.$getSubformParent]();
                        return parent;
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                    [_symbol_utils.$isThereMoreWidth]() {
                        return this.layout.endsWith("-tb") && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine > 0 || this[_symbol_utils.$getParent]()[_symbol_utils.$isThereMoreWidth]();
                    }
                    *[_symbol_utils.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [_symbol_utils.$flushHTML]() {
                        return (0, _layout.flushHTML)(this);
                    }
                    [_symbol_utils.$addHTML](html, bbox) {
                        (0, _layout.addHTML)(this, html, bbox);
                    }
                    [_symbol_utils.$getAvailableSpace]() {
                        return (0, _layout.getAvailableSpace)(this);
                    }
                    [_symbol_utils.$isSplittable]() {
                        const parent = this[_symbol_utils.$getSubformParent]();
                        if (!parent[_symbol_utils.$isSplittable]()) return false;
                        if (this[_symbol_utils.$extra]._isSplittable !== undefined) return this[_symbol_utils.$extra]._isSplittable;
                        if (this.layout === "position" || this.layout.includes("row")) {
                            this[_symbol_utils.$extra]._isSplittable = false;
                            return false;
                        }
                        if (this.keep && this.keep.intact !== "none") {
                            this[_symbol_utils.$extra]._isSplittable = false;
                            return false;
                        }
                        if (parent.layout?.endsWith("-tb") && parent[_symbol_utils.$extra].numberInLine !== 0) return false;
                        this[_symbol_utils.$extra]._isSplittable = true;
                        return true;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        setTabIndex(this);
                        if (this.break) {
                            if (this.break.after !== "auto" || this.break.afterTarget !== "") {
                                const node = new BreakAfter({
                                    targetType: this.break.after,
                                    target: this.break.afterTarget,
                                    startNew: this.break.startNew.toString()
                                });
                                node[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                                this[_symbol_utils.$appendChild](node);
                                this.breakAfter.push(node);
                            }
                            if (this.break.before !== "auto" || this.break.beforeTarget !== "") {
                                const node = new BreakBefore({
                                    targetType: this.break.before,
                                    target: this.break.beforeTarget,
                                    startNew: this.break.startNew.toString()
                                });
                                node[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                                this[_symbol_utils.$appendChild](node);
                                this.breakBefore.push(node);
                            }
                            if (this.break.overflowTarget !== "") {
                                const node = new Overflow({
                                    target: this.break.overflowTarget,
                                    leader: this.break.overflowLeader,
                                    trailer: this.break.overflowTrailer
                                });
                                node[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                                this[_symbol_utils.$appendChild](node);
                                this.overflow.push(node);
                            }
                            this[_symbol_utils.$removeChild](this.break);
                            this.break = null;
                        }
                        if (this.presence === "hidden" || this.presence === "inactive") return _utils.HTMLResult.EMPTY;
                        if (this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) (0, _util.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug.");
                        if (this.breakBefore.children.length >= 1) {
                            const breakBefore = this.breakBefore.children[0];
                            if (handleBreak(breakBefore)) return _utils.HTMLResult.breakNode(breakBefore);
                        }
                        if (this[_symbol_utils.$extra]?.afterBreakAfter) return _utils.HTMLResult.EMPTY;
                        (0, _html_utils.fixDimensions)(this);
                        const children = [];
                        const attributes = {
                            id: this[_symbol_utils.$uid],
                            class: []
                        };
                        (0, _html_utils.setAccess)(this, attributes.class);
                        if (!this[_symbol_utils.$extra]) this[_symbol_utils.$extra] = Object.create(null);
                        Object.assign(this[_symbol_utils.$extra], {
                            children: children,
                            line: null,
                            attributes: attributes,
                            attempt: 0,
                            numberInLine: 0,
                            availableSpace: {
                                width: Math.min(this.w || Infinity, availableSpace.width),
                                height: Math.min(this.h || Infinity, availableSpace.height)
                            },
                            width: 0,
                            height: 0,
                            prevHeight: 0,
                            currentWidth: 0
                        });
                        const root = this[_symbol_utils.$getTemplateRoot]();
                        const savedNoLayoutFailure = root[_symbol_utils.$extra].noLayoutFailure;
                        const isSplittable = this[_symbol_utils.$isSplittable]();
                        if (!isSplittable) setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) return _utils.HTMLResult.FAILURE;
                        const filter = new Set([
                            "area",
                            "draw",
                            "exclGroup",
                            "field",
                            "subform",
                            "subformSet"
                        ]);
                        if (this.layout.includes("row")) {
                            const columnWidths = this[_symbol_utils.$getSubformParent]().columnWidths;
                            if (Array.isArray(columnWidths) && columnWidths.length > 0) {
                                this[_symbol_utils.$extra].columnWidths = columnWidths;
                                this[_symbol_utils.$extra].currentColumn = 0;
                            }
                        }
                        const style = (0, _html_utils.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign");
                        const classNames = [
                            "xfaSubform"
                        ];
                        const cl = (0, _html_utils.layoutClass)(this);
                        if (cl) classNames.push(cl);
                        attributes.style = style;
                        attributes.class = classNames;
                        if (this.name) attributes.xfaName = this.name;
                        if (this.overflow) {
                            const overflowExtra = this.overflow[_symbol_utils.$getExtra]();
                            if (overflowExtra.addLeader) {
                                overflowExtra.addLeader = false;
                                handleOverflow(this, overflowExtra.leader, availableSpace);
                            }
                        }
                        this[_symbol_utils.$pushPara]();
                        const isLrTb = this.layout === "lr-tb" || this.layout === "rl-tb";
                        const maxRun = isLrTb ? MAX_ATTEMPTS_FOR_LRTB_LAYOUT : 1;
                        for(; this[_symbol_utils.$extra].attempt < maxRun; this[_symbol_utils.$extra].attempt++){
                            if (isLrTb && this[_symbol_utils.$extra].attempt === MAX_ATTEMPTS_FOR_LRTB_LAYOUT - 1) this[_symbol_utils.$extra].numberInLine = 0;
                            const result = this[_symbol_utils.$childrenToHTML]({
                                filter: filter,
                                include: true
                            });
                            if (result.success) break;
                            if (result.isBreak()) {
                                this[_symbol_utils.$popPara]();
                                return result;
                            }
                            if (isLrTb && this[_symbol_utils.$extra].attempt === 0 && this[_symbol_utils.$extra].numberInLine === 0 && !root[_symbol_utils.$extra].noLayoutFailure) {
                                this[_symbol_utils.$extra].attempt = maxRun;
                                break;
                            }
                        }
                        this[_symbol_utils.$popPara]();
                        if (!isSplittable) unsetFirstUnsplittable(this);
                        root[_symbol_utils.$extra].noLayoutFailure = savedNoLayoutFailure;
                        if (this[_symbol_utils.$extra].attempt === maxRun) {
                            if (this.overflow) this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].overflowNode = this.overflow;
                            if (!isSplittable) delete this[_symbol_utils.$extra];
                            return _utils.HTMLResult.FAILURE;
                        }
                        if (this.overflow) {
                            const overflowExtra = this.overflow[_symbol_utils.$getExtra]();
                            if (overflowExtra.addTrailer) {
                                overflowExtra.addTrailer = false;
                                handleOverflow(this, overflowExtra.trailer, availableSpace);
                            }
                        }
                        let marginH = 0;
                        let marginV = 0;
                        if (this.margin) {
                            marginH = this.margin.leftInset + this.margin.rightInset;
                            marginV = this.margin.topInset + this.margin.bottomInset;
                        }
                        const width = Math.max(this[_symbol_utils.$extra].width + marginH, this.w || 0);
                        const height = Math.max(this[_symbol_utils.$extra].height + marginV, this.h || 0);
                        const bbox = [
                            this.x,
                            this.y,
                            width,
                            height
                        ];
                        if (this.w === "") style.width = (0, _html_utils.measureToString)(width);
                        if (this.h === "") style.height = (0, _html_utils.measureToString)(height);
                        if ((style.width === "0px" || style.height === "0px") && children.length === 0) return _utils.HTMLResult.EMPTY;
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        applyAssist(this, attributes);
                        const result = _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        if (this.breakAfter.children.length >= 1) {
                            const breakAfter = this.breakAfter.children[0];
                            if (handleBreak(breakAfter)) {
                                this[_symbol_utils.$extra].afterBreakAfter = result;
                                return _utils.HTMLResult.breakNode(breakAfter);
                            }
                        }
                        delete this[_symbol_utils.$extra];
                        return result;
                    }
                }
                class SubformSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subformSet", true);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relation = (0, _utils.getStringOption)(attributes.relation, [
                            "ordered",
                            "choice",
                            "unordered"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.bookend = null;
                        this.break = null;
                        this.desc = null;
                        this.extras = null;
                        this.occur = null;
                        this.overflow = null;
                        this.breakAfter = new _xfa_object.XFAObjectArray();
                        this.breakBefore = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                    }
                    *[_symbol_utils.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [_symbol_utils.$getSubformParent]() {
                        let parent = this[_symbol_utils.$getParent]();
                        while(!(parent instanceof Subform))parent = parent[_symbol_utils.$getParent]();
                        return parent;
                    }
                    [_symbol_utils.$isBindable]() {
                        return true;
                    }
                }
                class SubjectDN extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subjectDN");
                        this.delimiter = attributes.delimiter || ",";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = new Map(this[_symbol_utils.$content].split(this.delimiter).map((kv)=>{
                            kv = kv.split("=", 2);
                            kv[0] = kv[0].trim();
                            return kv;
                        }));
                    }
                }
                class SubjectDNs extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subjectDNs", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.subjectDN = new _xfa_object.XFAObjectArray();
                    }
                }
                class Submit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "submit", true);
                        this.embedPDF = (0, _utils.getInteger)({
                            data: attributes.embedPDF,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.format = (0, _utils.getStringOption)(attributes.format, [
                            "xdp",
                            "formdata",
                            "pdf",
                            "urlencoded",
                            "xfd",
                            "xml"
                        ]);
                        this.id = attributes.id || "";
                        this.target = attributes.target || "";
                        this.textEncoding = (0, _utils.getKeyword)({
                            data: attributes.textEncoding ? attributes.textEncoding.toLowerCase() : "",
                            defaultValue: "",
                            validate: (k)=>[
                                    "utf-8",
                                    "big-five",
                                    "fontspecific",
                                    "gbk",
                                    "gb-18030",
                                    "gb-2312",
                                    "ksc-5601",
                                    "none",
                                    "shift-jis",
                                    "ucs-2",
                                    "utf-16"
                                ].includes(k) || k.match(/iso-8859-\d{2}/)
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.xdpContent = attributes.xdpContent || "";
                        this.encrypt = null;
                        this.encryptData = new _xfa_object.XFAObjectArray();
                        this.signData = new _xfa_object.XFAObjectArray();
                    }
                }
                class Template extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "template", true);
                        this.baseProfile = (0, _utils.getStringOption)(attributes.baseProfile, [
                            "full",
                            "interactiveForms"
                        ]);
                        this.extras = null;
                        this.subform = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$finalize]() {
                        if (this.subform.children.length === 0) (0, _util.warn)("XFA - No subforms in template node.");
                        if (this.subform.children.length >= 2) (0, _util.warn)("XFA - Several subforms in template node: please file a bug.");
                        this[_symbol_utils.$tabIndex] = DEFAULT_TAB_INDEX;
                    }
                    [_symbol_utils.$isSplittable]() {
                        return true;
                    }
                    [_symbol_utils.$searchNode](expr, container) {
                        if (expr.startsWith("#")) return [
                            this[_symbol_utils.$ids].get(expr.slice(1))
                        ];
                        return (0, _som.searchNode)(this, container, expr, true, true);
                    }
                    *[_symbol_utils.$toPages]() {
                        if (!this.subform.children.length) return _utils.HTMLResult.success({
                            name: "div",
                            children: []
                        });
                        this[_symbol_utils.$extra] = {
                            overflowNode: null,
                            firstUnsplittable: null,
                            currentContentArea: null,
                            currentPageArea: null,
                            noLayoutFailure: false,
                            pageNumber: 1,
                            pagePosition: "first",
                            oddOrEven: "odd",
                            blankOrNotBlank: "nonBlank",
                            paraStack: []
                        };
                        const root = this.subform.children[0];
                        root.pageSet[_symbol_utils.$cleanPage]();
                        const pageAreas = root.pageSet.pageArea.children;
                        const mainHtml = {
                            name: "div",
                            children: []
                        };
                        let pageArea = null;
                        let breakBefore = null;
                        let breakBeforeTarget = null;
                        if (root.breakBefore.children.length >= 1) {
                            breakBefore = root.breakBefore.children[0];
                            breakBeforeTarget = breakBefore.target;
                        } else if (root.subform.children.length >= 1 && root.subform.children[0].breakBefore.children.length >= 1) {
                            breakBefore = root.subform.children[0].breakBefore.children[0];
                            breakBeforeTarget = breakBefore.target;
                        } else if (root.break?.beforeTarget) {
                            breakBefore = root.break;
                            breakBeforeTarget = breakBefore.beforeTarget;
                        } else if (root.subform.children.length >= 1 && root.subform.children[0].break?.beforeTarget) {
                            breakBefore = root.subform.children[0].break;
                            breakBeforeTarget = breakBefore.beforeTarget;
                        }
                        if (breakBefore) {
                            const target = this[_symbol_utils.$searchNode](breakBeforeTarget, breakBefore[_symbol_utils.$getParent]());
                            if (target instanceof PageArea) {
                                pageArea = target;
                                breakBefore[_symbol_utils.$extra] = {};
                            }
                        }
                        if (!pageArea) pageArea = pageAreas[0];
                        pageArea[_symbol_utils.$extra] = {
                            numberOfUse: 1
                        };
                        const pageAreaParent = pageArea[_symbol_utils.$getParent]();
                        pageAreaParent[_symbol_utils.$extra] = {
                            numberOfUse: 1,
                            pageIndex: pageAreaParent.pageArea.children.indexOf(pageArea),
                            pageSetIndex: 0
                        };
                        let targetPageArea;
                        let leader = null;
                        let trailer = null;
                        let hasSomething = true;
                        let hasSomethingCounter = 0;
                        let startIndex = 0;
                        while(true){
                            if (!hasSomething) {
                                mainHtml.children.pop();
                                if (++hasSomethingCounter === MAX_EMPTY_PAGES) {
                                    (0, _util.warn)("XFA - Something goes wrong: please file a bug.");
                                    return mainHtml;
                                }
                            } else hasSomethingCounter = 0;
                            targetPageArea = null;
                            this[_symbol_utils.$extra].currentPageArea = pageArea;
                            const page = pageArea[_symbol_utils.$toHTML]().html;
                            mainHtml.children.push(page);
                            if (leader) {
                                this[_symbol_utils.$extra].noLayoutFailure = true;
                                page.children.push(leader[_symbol_utils.$toHTML](pageArea[_symbol_utils.$extra].space).html);
                                leader = null;
                            }
                            if (trailer) {
                                this[_symbol_utils.$extra].noLayoutFailure = true;
                                page.children.push(trailer[_symbol_utils.$toHTML](pageArea[_symbol_utils.$extra].space).html);
                                trailer = null;
                            }
                            const contentAreas = pageArea.contentArea.children;
                            const htmlContentAreas = page.children.filter((node)=>node.attributes.class.includes("xfaContentarea"));
                            hasSomething = false;
                            this[_symbol_utils.$extra].firstUnsplittable = null;
                            this[_symbol_utils.$extra].noLayoutFailure = false;
                            const flush = (index)=>{
                                const html = root[_symbol_utils.$flushHTML]();
                                if (html) {
                                    hasSomething ||= html.children?.length > 0;
                                    htmlContentAreas[index].children.push(html);
                                }
                            };
                            for(let i = startIndex, ii = contentAreas.length; i < ii; i++){
                                const contentArea = this[_symbol_utils.$extra].currentContentArea = contentAreas[i];
                                const space = {
                                    width: contentArea.w,
                                    height: contentArea.h
                                };
                                startIndex = 0;
                                if (leader) {
                                    htmlContentAreas[i].children.push(leader[_symbol_utils.$toHTML](space).html);
                                    leader = null;
                                }
                                if (trailer) {
                                    htmlContentAreas[i].children.push(trailer[_symbol_utils.$toHTML](space).html);
                                    trailer = null;
                                }
                                const html = root[_symbol_utils.$toHTML](space);
                                if (html.success) {
                                    if (html.html) {
                                        hasSomething ||= html.html.children?.length > 0;
                                        htmlContentAreas[i].children.push(html.html);
                                    } else if (!hasSomething && mainHtml.children.length > 1) mainHtml.children.pop();
                                    return mainHtml;
                                }
                                if (html.isBreak()) {
                                    const node = html.breakNode;
                                    flush(i);
                                    if (node.targetType === "auto") continue;
                                    if (node.leader) {
                                        leader = this[_symbol_utils.$searchNode](node.leader, node[_symbol_utils.$getParent]());
                                        leader = leader ? leader[0] : null;
                                    }
                                    if (node.trailer) {
                                        trailer = this[_symbol_utils.$searchNode](node.trailer, node[_symbol_utils.$getParent]());
                                        trailer = trailer ? trailer[0] : null;
                                    }
                                    if (node.targetType === "pageArea") {
                                        targetPageArea = node[_symbol_utils.$extra].target;
                                        i = Infinity;
                                    } else if (!node[_symbol_utils.$extra].target) i = node[_symbol_utils.$extra].index;
                                    else {
                                        targetPageArea = node[_symbol_utils.$extra].target;
                                        startIndex = node[_symbol_utils.$extra].index + 1;
                                        i = Infinity;
                                    }
                                    continue;
                                }
                                if (this[_symbol_utils.$extra].overflowNode) {
                                    const node = this[_symbol_utils.$extra].overflowNode;
                                    this[_symbol_utils.$extra].overflowNode = null;
                                    const overflowExtra = node[_symbol_utils.$getExtra]();
                                    const target = overflowExtra.target;
                                    overflowExtra.addLeader = overflowExtra.leader !== null;
                                    overflowExtra.addTrailer = overflowExtra.trailer !== null;
                                    flush(i);
                                    const currentIndex = i;
                                    i = Infinity;
                                    if (target instanceof PageArea) targetPageArea = target;
                                    else if (target instanceof ContentArea) {
                                        const index = contentAreas.indexOf(target);
                                        if (index !== -1) {
                                            if (index > currentIndex) i = index - 1;
                                            else startIndex = index;
                                        } else {
                                            targetPageArea = target[_symbol_utils.$getParent]();
                                            startIndex = targetPageArea.contentArea.children.indexOf(target);
                                        }
                                    }
                                    continue;
                                }
                                flush(i);
                            }
                            this[_symbol_utils.$extra].pageNumber += 1;
                            if (targetPageArea) {
                                if (targetPageArea[_symbol_utils.$isUsable]()) targetPageArea[_symbol_utils.$extra].numberOfUse += 1;
                                else targetPageArea = null;
                            }
                            pageArea = targetPageArea || pageArea[_symbol_utils.$getNextPage]();
                            yield null;
                        }
                    }
                }
                exports.Template = Template;
                class Text extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "text");
                        this.id = attributes.id || "";
                        this.maxChars = (0, _utils.getInteger)({
                            data: attributes.maxChars,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.name = attributes.name || "";
                        this.rid = attributes.rid || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$acceptWhitespace]() {
                        return true;
                    }
                    [_symbol_utils.$onChild](child) {
                        if (child[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) {
                            this[_symbol_utils.$content] = child;
                            return true;
                        }
                        (0, _util.warn)(`XFA - Invalid content in Text: ${child[_symbol_utils.$nodeName]}.`);
                        return false;
                    }
                    [_symbol_utils.$onText](str) {
                        if (this[_symbol_utils.$content] instanceof _xfa_object.XFAObject) return;
                        super[_symbol_utils.$onText](str);
                    }
                    [_symbol_utils.$finalize]() {
                        if (typeof this[_symbol_utils.$content] === "string") this[_symbol_utils.$content] = this[_symbol_utils.$content].replaceAll("\r\n", "\n");
                    }
                    [_symbol_utils.$getExtra]() {
                        if (typeof this[_symbol_utils.$content] === "string") return this[_symbol_utils.$content].split(/[\u2029\u2028\n]/).reduce((acc, line)=>{
                            if (line) acc.push(line);
                            return acc;
                        }, []).join("\n");
                        return this[_symbol_utils.$content][_symbol_utils.$text]();
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        if (typeof this[_symbol_utils.$content] === "string") {
                            const html = valueToHtml(this[_symbol_utils.$content]).html;
                            if (this[_symbol_utils.$content].includes("\u2029")) {
                                html.name = "div";
                                html.children = [];
                                this[_symbol_utils.$content].split("\u2029").map((para)=>para.split(/[\u2028\n]/).reduce((acc, line)=>{
                                        acc.push({
                                            name: "span",
                                            value: line
                                        }, {
                                            name: "br"
                                        });
                                        return acc;
                                    }, [])).forEach((lines)=>{
                                    html.children.push({
                                        name: "p",
                                        children: lines
                                    });
                                });
                            } else if (/[\u2028\n]/.test(this[_symbol_utils.$content])) {
                                html.name = "div";
                                html.children = [];
                                this[_symbol_utils.$content].split(/[\u2028\n]/).forEach((line)=>{
                                    html.children.push({
                                        name: "span",
                                        value: line
                                    }, {
                                        name: "br"
                                    });
                                });
                            }
                            return _utils.HTMLResult.success(html);
                        }
                        return this[_symbol_utils.$content][_symbol_utils.$toHTML](availableSpace);
                    }
                }
                exports.Text = Text;
                class TextEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "textEdit", true);
                        this.allowRichText = (0, _utils.getInteger)({
                            data: attributes.allowRichText,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.multiLine = (0, _utils.getInteger)({
                            data: attributes.multiLine,
                            defaultValue: "",
                            validate: (x)=>x === 0 || x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.vScrollPolicy = (0, _utils.getStringOption)(attributes.vScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                        let html;
                        const field = this[_symbol_utils.$getParent]()[_symbol_utils.$getParent]();
                        if (this.multiLine === "") this.multiLine = field instanceof Draw ? 1 : 0;
                        if (this.multiLine === 1) html = {
                            name: "textarea",
                            attributes: {
                                dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                                fieldId: field[_symbol_utils.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        else html = {
                            name: "input",
                            attributes: {
                                type: "text",
                                dataId: field[_symbol_utils.$data]?.[_symbol_utils.$uid] || field[_symbol_utils.$uid],
                                fieldId: field[_symbol_utils.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style,
                                "aria-label": ariaLabel(field),
                                "aria-required": false
                            }
                        };
                        if (isRequired(field)) {
                            html.attributes["aria-required"] = true;
                            html.attributes.required = true;
                        }
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                html
                            ]
                        });
                    }
                }
                class Time extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "time");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_symbol_utils.$finalize]() {
                        const date = this[_symbol_utils.$content].trim();
                        this[_symbol_utils.$content] = date ? new Date(date) : null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return valueToHtml(this[_symbol_utils.$content] ? this[_symbol_utils.$content].toString() : "");
                    }
                }
                class TimeStamp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "timeStamp");
                        this.id = attributes.id || "";
                        this.server = attributes.server || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class ToolTip extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "toolTip");
                        this.id = attributes.id || "";
                        this.rid = attributes.rid || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Traversal extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "traversal", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.traverse = new _xfa_object.XFAObjectArray();
                    }
                }
                class Traverse extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "traverse", true);
                        this.id = attributes.id || "";
                        this.operation = (0, _utils.getStringOption)(attributes.operation, [
                            "next",
                            "back",
                            "down",
                            "first",
                            "left",
                            "right",
                            "up"
                        ]);
                        this.ref = attributes.ref || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.script = null;
                    }
                    get name() {
                        return this.operation;
                    }
                    [_symbol_utils.$isTransparent]() {
                        return false;
                    }
                }
                class Ui extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "ui", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.picture = null;
                        this.barcode = null;
                        this.button = null;
                        this.checkButton = null;
                        this.choiceList = null;
                        this.dateTimeEdit = null;
                        this.defaultUi = null;
                        this.imageEdit = null;
                        this.numericEdit = null;
                        this.passwordEdit = null;
                        this.signature = null;
                        this.textEdit = null;
                    }
                    [_symbol_utils.$getExtra]() {
                        if (this[_symbol_utils.$extra] === undefined) {
                            for (const name of Object.getOwnPropertyNames(this)){
                                if (name === "extras" || name === "picture") continue;
                                const obj = this[name];
                                if (!(obj instanceof _xfa_object.XFAObject)) continue;
                                this[_symbol_utils.$extra] = obj;
                                return obj;
                            }
                            this[_symbol_utils.$extra] = null;
                        }
                        return this[_symbol_utils.$extra];
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const obj = this[_symbol_utils.$getExtra]();
                        if (obj) return obj[_symbol_utils.$toHTML](availableSpace);
                        return _utils.HTMLResult.EMPTY;
                    }
                }
                class Validate extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "validate", true);
                        this.formatTest = (0, _utils.getStringOption)(attributes.formatTest, [
                            "warning",
                            "disabled",
                            "error"
                        ]);
                        this.id = attributes.id || "";
                        this.nullTest = (0, _utils.getStringOption)(attributes.nullTest, [
                            "disabled",
                            "error",
                            "warning"
                        ]);
                        this.scriptTest = (0, _utils.getStringOption)(attributes.scriptTest, [
                            "error",
                            "disabled",
                            "warning"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.message = null;
                        this.picture = null;
                        this.script = null;
                    }
                }
                class Value extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "value", true);
                        this.id = attributes.id || "";
                        this.override = (0, _utils.getInteger)({
                            data: attributes.override,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.arc = null;
                        this.boolean = null;
                        this.date = null;
                        this.dateTime = null;
                        this.decimal = null;
                        this.exData = null;
                        this.float = null;
                        this.image = null;
                        this.integer = null;
                        this.line = null;
                        this.rectangle = null;
                        this.text = null;
                        this.time = null;
                    }
                    [_symbol_utils.$setValue](value) {
                        const parent = this[_symbol_utils.$getParent]();
                        if (parent instanceof Field) {
                            if (parent.ui?.imageEdit) {
                                if (!this.image) {
                                    this.image = new Image({});
                                    this[_symbol_utils.$appendChild](this.image);
                                }
                                this.image[_symbol_utils.$content] = value[_symbol_utils.$content];
                                return;
                            }
                        }
                        const valueName = value[_symbol_utils.$nodeName];
                        if (this[valueName] !== null) {
                            this[valueName][_symbol_utils.$content] = value[_symbol_utils.$content];
                            return;
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            const obj = this[name];
                            if (obj instanceof _xfa_object.XFAObject) {
                                this[name] = null;
                                this[_symbol_utils.$removeChild](obj);
                            }
                        }
                        this[value[_symbol_utils.$nodeName]] = value;
                        this[_symbol_utils.$appendChild](value);
                    }
                    [_symbol_utils.$text]() {
                        if (this.exData) {
                            if (typeof this.exData[_symbol_utils.$content] === "string") return this.exData[_symbol_utils.$content].trim();
                            return this.exData[_symbol_utils.$content][_symbol_utils.$text]().trim();
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (name === "image") continue;
                            const obj = this[name];
                            if (obj instanceof _xfa_object.XFAObject) return (obj[_symbol_utils.$content] || "").toString().trim();
                        }
                        return null;
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        for (const name of Object.getOwnPropertyNames(this)){
                            const obj = this[name];
                            if (!(obj instanceof _xfa_object.XFAObject)) continue;
                            return obj[_symbol_utils.$toHTML](availableSpace);
                        }
                        return _utils.HTMLResult.EMPTY;
                    }
                }
                exports.Value = Value;
                class Variables extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "variables", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.manifest = new _xfa_object.XFAObjectArray();
                        this.script = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                    [_symbol_utils.$isTransparent]() {
                        return true;
                    }
                }
                class TemplateNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (TemplateNamespace.hasOwnProperty(name)) {
                            const node = TemplateNamespace[name](attributes);
                            node[_symbol_utils.$setSetAttributes](attributes);
                            return node;
                        }
                        return undefined;
                    }
                    static appearanceFilter(attrs) {
                        return new AppearanceFilter(attrs);
                    }
                    static arc(attrs) {
                        return new Arc(attrs);
                    }
                    static area(attrs) {
                        return new Area(attrs);
                    }
                    static assist(attrs) {
                        return new Assist(attrs);
                    }
                    static barcode(attrs) {
                        return new Barcode(attrs);
                    }
                    static bind(attrs) {
                        return new Bind(attrs);
                    }
                    static bindItems(attrs) {
                        return new BindItems(attrs);
                    }
                    static bookend(attrs) {
                        return new Bookend(attrs);
                    }
                    static boolean(attrs) {
                        return new BooleanElement(attrs);
                    }
                    static border(attrs) {
                        return new Border(attrs);
                    }
                    static break(attrs) {
                        return new Break(attrs);
                    }
                    static breakAfter(attrs) {
                        return new BreakAfter(attrs);
                    }
                    static breakBefore(attrs) {
                        return new BreakBefore(attrs);
                    }
                    static button(attrs) {
                        return new Button(attrs);
                    }
                    static calculate(attrs) {
                        return new Calculate(attrs);
                    }
                    static caption(attrs) {
                        return new Caption(attrs);
                    }
                    static certificate(attrs) {
                        return new Certificate(attrs);
                    }
                    static certificates(attrs) {
                        return new Certificates(attrs);
                    }
                    static checkButton(attrs) {
                        return new CheckButton(attrs);
                    }
                    static choiceList(attrs) {
                        return new ChoiceList(attrs);
                    }
                    static color(attrs) {
                        return new Color(attrs);
                    }
                    static comb(attrs) {
                        return new Comb(attrs);
                    }
                    static connect(attrs) {
                        return new Connect(attrs);
                    }
                    static contentArea(attrs) {
                        return new ContentArea(attrs);
                    }
                    static corner(attrs) {
                        return new Corner(attrs);
                    }
                    static date(attrs) {
                        return new DateElement(attrs);
                    }
                    static dateTime(attrs) {
                        return new DateTime(attrs);
                    }
                    static dateTimeEdit(attrs) {
                        return new DateTimeEdit(attrs);
                    }
                    static decimal(attrs) {
                        return new Decimal(attrs);
                    }
                    static defaultUi(attrs) {
                        return new DefaultUi(attrs);
                    }
                    static desc(attrs) {
                        return new Desc(attrs);
                    }
                    static digestMethod(attrs) {
                        return new DigestMethod(attrs);
                    }
                    static digestMethods(attrs) {
                        return new DigestMethods(attrs);
                    }
                    static draw(attrs) {
                        return new Draw(attrs);
                    }
                    static edge(attrs) {
                        return new Edge(attrs);
                    }
                    static encoding(attrs) {
                        return new Encoding(attrs);
                    }
                    static encodings(attrs) {
                        return new Encodings(attrs);
                    }
                    static encrypt(attrs) {
                        return new Encrypt(attrs);
                    }
                    static encryptData(attrs) {
                        return new EncryptData(attrs);
                    }
                    static encryption(attrs) {
                        return new Encryption(attrs);
                    }
                    static encryptionMethod(attrs) {
                        return new EncryptionMethod(attrs);
                    }
                    static encryptionMethods(attrs) {
                        return new EncryptionMethods(attrs);
                    }
                    static event(attrs) {
                        return new Event(attrs);
                    }
                    static exData(attrs) {
                        return new ExData(attrs);
                    }
                    static exObject(attrs) {
                        return new ExObject(attrs);
                    }
                    static exclGroup(attrs) {
                        return new ExclGroup(attrs);
                    }
                    static execute(attrs) {
                        return new Execute(attrs);
                    }
                    static extras(attrs) {
                        return new Extras(attrs);
                    }
                    static field(attrs) {
                        return new Field(attrs);
                    }
                    static fill(attrs) {
                        return new Fill(attrs);
                    }
                    static filter(attrs) {
                        return new Filter(attrs);
                    }
                    static float(attrs) {
                        return new Float(attrs);
                    }
                    static font(attrs) {
                        return new Font(attrs);
                    }
                    static format(attrs) {
                        return new Format(attrs);
                    }
                    static handler(attrs) {
                        return new Handler(attrs);
                    }
                    static hyphenation(attrs) {
                        return new Hyphenation(attrs);
                    }
                    static image(attrs) {
                        return new Image(attrs);
                    }
                    static imageEdit(attrs) {
                        return new ImageEdit(attrs);
                    }
                    static integer(attrs) {
                        return new Integer(attrs);
                    }
                    static issuers(attrs) {
                        return new Issuers(attrs);
                    }
                    static items(attrs) {
                        return new Items(attrs);
                    }
                    static keep(attrs) {
                        return new Keep(attrs);
                    }
                    static keyUsage(attrs) {
                        return new KeyUsage(attrs);
                    }
                    static line(attrs) {
                        return new Line(attrs);
                    }
                    static linear(attrs) {
                        return new Linear(attrs);
                    }
                    static lockDocument(attrs) {
                        return new LockDocument(attrs);
                    }
                    static manifest(attrs) {
                        return new Manifest(attrs);
                    }
                    static margin(attrs) {
                        return new Margin(attrs);
                    }
                    static mdp(attrs) {
                        return new Mdp(attrs);
                    }
                    static medium(attrs) {
                        return new Medium(attrs);
                    }
                    static message(attrs) {
                        return new Message(attrs);
                    }
                    static numericEdit(attrs) {
                        return new NumericEdit(attrs);
                    }
                    static occur(attrs) {
                        return new Occur(attrs);
                    }
                    static oid(attrs) {
                        return new Oid(attrs);
                    }
                    static oids(attrs) {
                        return new Oids(attrs);
                    }
                    static overflow(attrs) {
                        return new Overflow(attrs);
                    }
                    static pageArea(attrs) {
                        return new PageArea(attrs);
                    }
                    static pageSet(attrs) {
                        return new PageSet(attrs);
                    }
                    static para(attrs) {
                        return new Para(attrs);
                    }
                    static passwordEdit(attrs) {
                        return new PasswordEdit(attrs);
                    }
                    static pattern(attrs) {
                        return new Pattern(attrs);
                    }
                    static picture(attrs) {
                        return new Picture(attrs);
                    }
                    static proto(attrs) {
                        return new Proto(attrs);
                    }
                    static radial(attrs) {
                        return new Radial(attrs);
                    }
                    static reason(attrs) {
                        return new Reason(attrs);
                    }
                    static reasons(attrs) {
                        return new Reasons(attrs);
                    }
                    static rectangle(attrs) {
                        return new Rectangle(attrs);
                    }
                    static ref(attrs) {
                        return new RefElement(attrs);
                    }
                    static script(attrs) {
                        return new Script(attrs);
                    }
                    static setProperty(attrs) {
                        return new SetProperty(attrs);
                    }
                    static signData(attrs) {
                        return new SignData(attrs);
                    }
                    static signature(attrs) {
                        return new Signature(attrs);
                    }
                    static signing(attrs) {
                        return new Signing(attrs);
                    }
                    static solid(attrs) {
                        return new Solid(attrs);
                    }
                    static speak(attrs) {
                        return new Speak(attrs);
                    }
                    static stipple(attrs) {
                        return new Stipple(attrs);
                    }
                    static subform(attrs) {
                        return new Subform(attrs);
                    }
                    static subformSet(attrs) {
                        return new SubformSet(attrs);
                    }
                    static subjectDN(attrs) {
                        return new SubjectDN(attrs);
                    }
                    static subjectDNs(attrs) {
                        return new SubjectDNs(attrs);
                    }
                    static submit(attrs) {
                        return new Submit(attrs);
                    }
                    static template(attrs) {
                        return new Template(attrs);
                    }
                    static text(attrs) {
                        return new Text(attrs);
                    }
                    static textEdit(attrs) {
                        return new TextEdit(attrs);
                    }
                    static time(attrs) {
                        return new Time(attrs);
                    }
                    static timeStamp(attrs) {
                        return new TimeStamp(attrs);
                    }
                    static toolTip(attrs) {
                        return new ToolTip(attrs);
                    }
                    static traversal(attrs) {
                        return new Traversal(attrs);
                    }
                    static traverse(attrs) {
                        return new Traverse(attrs);
                    }
                    static ui(attrs) {
                        return new Ui(attrs);
                    }
                    static validate(attrs) {
                        return new Validate(attrs);
                    }
                    static value(attrs) {
                        return new Value(attrs);
                    }
                    static variables(attrs) {
                        return new Variables(attrs);
                    }
                }
                exports.TemplateNamespace = TemplateNamespace;
            /***/ },
            /* 81 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NamespaceIds = exports.$buildXFAObject = void 0;
                const $buildXFAObject = Symbol();
                exports.$buildXFAObject = $buildXFAObject;
                const NamespaceIds = {
                    config: {
                        id: 0,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xci/")
                    },
                    connectionSet: {
                        id: 1,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-connection-set/")
                    },
                    datasets: {
                        id: 2,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-data/")
                    },
                    form: {
                        id: 3,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-form/")
                    },
                    localeSet: {
                        id: 4,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-locale-set/")
                    },
                    pdf: {
                        id: 5,
                        check: (ns)=>ns === "http://ns.adobe.com/xdp/pdf/"
                    },
                    signature: {
                        id: 6,
                        check: (ns)=>ns === "http://www.w3.org/2000/09/xmldsig#"
                    },
                    sourceSet: {
                        id: 7,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-source-set/")
                    },
                    stylesheet: {
                        id: 8,
                        check: (ns)=>ns === "http://www.w3.org/1999/XSL/Transform"
                    },
                    template: {
                        id: 9,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-template/")
                    },
                    xdc: {
                        id: 10,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xdc/")
                    },
                    xdp: {
                        id: 11,
                        check: (ns)=>ns === "http://ns.adobe.com/xdp/"
                    },
                    xfdf: {
                        id: 12,
                        check: (ns)=>ns === "http://ns.adobe.com/xfdf/"
                    },
                    xhtml: {
                        id: 13,
                        check: (ns)=>ns === "http://www.w3.org/1999/xhtml"
                    },
                    xmpmeta: {
                        id: 14,
                        check: (ns)=>ns === "http://ns.adobe.com/xmpmeta/"
                    }
                };
                exports.NamespaceIds = NamespaceIds;
            /***/ },
            /* 82 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addHTML = addHTML;
                exports.checkDimensions = checkDimensions;
                exports.flushHTML = flushHTML;
                exports.getAvailableSpace = getAvailableSpace;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _html_utils = __w_pdfjs_require__(83);
                function createLine(node, children) {
                    return {
                        name: "div",
                        attributes: {
                            class: [
                                node.layout === "lr-tb" ? "xfaLr" : "xfaRl"
                            ]
                        },
                        children: children
                    };
                }
                function flushHTML(node) {
                    if (!node[_symbol_utils.$extra]) return null;
                    const attributes = node[_symbol_utils.$extra].attributes;
                    const html = {
                        name: "div",
                        attributes: attributes,
                        children: node[_symbol_utils.$extra].children
                    };
                    if (node[_symbol_utils.$extra].failingNode) {
                        const htmlFromFailing = node[_symbol_utils.$extra].failingNode[_symbol_utils.$flushHTML]();
                        if (htmlFromFailing) {
                            if (node.layout.endsWith("-tb")) html.children.push(createLine(node, [
                                htmlFromFailing
                            ]));
                            else html.children.push(htmlFromFailing);
                        }
                    }
                    if (html.children.length === 0) return null;
                    return html;
                }
                function addHTML(node, html, bbox) {
                    const extra = node[_symbol_utils.$extra];
                    const availableSpace = extra.availableSpace;
                    const [x, y, w, h] = bbox;
                    switch(node.layout){
                        case "position":
                            extra.width = Math.max(extra.width, x + w);
                            extra.height = Math.max(extra.height, y + h);
                            extra.children.push(html);
                            break;
                        case "lr-tb":
                        case "rl-tb":
                            if (!extra.line || extra.attempt === 1) {
                                extra.line = createLine(node, []);
                                extra.children.push(extra.line);
                                extra.numberInLine = 0;
                            }
                            extra.numberInLine += 1;
                            extra.line.children.push(html);
                            if (extra.attempt === 0) {
                                extra.currentWidth += w;
                                extra.height = Math.max(extra.height, extra.prevHeight + h);
                            } else {
                                extra.currentWidth = w;
                                extra.prevHeight = extra.height;
                                extra.height += h;
                                extra.attempt = 0;
                            }
                            extra.width = Math.max(extra.width, extra.currentWidth);
                            break;
                        case "rl-row":
                        case "row":
                            {
                                extra.children.push(html);
                                extra.width += w;
                                extra.height = Math.max(extra.height, h);
                                const height = (0, _html_utils.measureToString)(extra.height);
                                for (const child of extra.children)child.attributes.style.height = height;
                                break;
                            }
                        case "table":
                            extra.width = Math.min(availableSpace.width, Math.max(extra.width, w));
                            extra.height += h;
                            extra.children.push(html);
                            break;
                        case "tb":
                            extra.width = Math.min(availableSpace.width, Math.max(extra.width, w));
                            extra.height += h;
                            extra.children.push(html);
                            break;
                    }
                }
                function getAvailableSpace(node) {
                    const availableSpace = node[_symbol_utils.$extra].availableSpace;
                    const marginV = node.margin ? node.margin.topInset + node.margin.bottomInset : 0;
                    const marginH = node.margin ? node.margin.leftInset + node.margin.rightInset : 0;
                    switch(node.layout){
                        case "lr-tb":
                        case "rl-tb":
                            if (node[_symbol_utils.$extra].attempt === 0) return {
                                width: availableSpace.width - marginH - node[_symbol_utils.$extra].currentWidth,
                                height: availableSpace.height - marginV - node[_symbol_utils.$extra].prevHeight
                            };
                            return {
                                width: availableSpace.width - marginH,
                                height: availableSpace.height - marginV - node[_symbol_utils.$extra].height
                            };
                        case "rl-row":
                        case "row":
                            const width = node[_symbol_utils.$extra].columnWidths.slice(node[_symbol_utils.$extra].currentColumn).reduce((a, x)=>a + x);
                            return {
                                width: width,
                                height: availableSpace.height - marginH
                            };
                        case "table":
                        case "tb":
                            return {
                                width: availableSpace.width - marginH,
                                height: availableSpace.height - marginV - node[_symbol_utils.$extra].height
                            };
                        case "position":
                        default:
                            return availableSpace;
                    }
                }
                function getTransformedBBox(node) {
                    let w = node.w === "" ? NaN : node.w;
                    let h = node.h === "" ? NaN : node.h;
                    let [centerX, centerY] = [
                        0,
                        0
                    ];
                    switch(node.anchorType || ""){
                        case "bottomCenter":
                            [centerX, centerY] = [
                                w / 2,
                                h
                            ];
                            break;
                        case "bottomLeft":
                            [centerX, centerY] = [
                                0,
                                h
                            ];
                            break;
                        case "bottomRight":
                            [centerX, centerY] = [
                                w,
                                h
                            ];
                            break;
                        case "middleCenter":
                            [centerX, centerY] = [
                                w / 2,
                                h / 2
                            ];
                            break;
                        case "middleLeft":
                            [centerX, centerY] = [
                                0,
                                h / 2
                            ];
                            break;
                        case "middleRight":
                            [centerX, centerY] = [
                                w,
                                h / 2
                            ];
                            break;
                        case "topCenter":
                            [centerX, centerY] = [
                                w / 2,
                                0
                            ];
                            break;
                        case "topRight":
                            [centerX, centerY] = [
                                w,
                                0
                            ];
                            break;
                    }
                    let x, y;
                    switch(node.rotate || 0){
                        case 0:
                            [x, y] = [
                                -centerX,
                                -centerY
                            ];
                            break;
                        case 90:
                            [x, y] = [
                                -centerY,
                                centerX
                            ];
                            [w, h] = [
                                h,
                                -w
                            ];
                            break;
                        case 180:
                            [x, y] = [
                                centerX,
                                centerY
                            ];
                            [w, h] = [
                                -w,
                                -h
                            ];
                            break;
                        case 270:
                            [x, y] = [
                                centerY,
                                -centerX
                            ];
                            [w, h] = [
                                -h,
                                w
                            ];
                            break;
                    }
                    return [
                        node.x + x + Math.min(0, w),
                        node.y + y + Math.min(0, h),
                        Math.abs(w),
                        Math.abs(h)
                    ];
                }
                function checkDimensions(node, space) {
                    if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].firstUnsplittable === null) return true;
                    if (node.w === 0 || node.h === 0) return true;
                    const ERROR = 2;
                    const parent = node[_symbol_utils.$getSubformParent]();
                    const attempt = parent[_symbol_utils.$extra]?.attempt || 0;
                    const [, y, w, h] = getTransformedBBox(node);
                    switch(parent.layout){
                        case "lr-tb":
                        case "rl-tb":
                            if (attempt === 0) {
                                if (!node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) {
                                    if (node.h !== "" && Math.round(h - space.height) > ERROR) return false;
                                    if (node.w !== "") {
                                        if (Math.round(w - space.width) <= ERROR) return true;
                                        if (parent[_symbol_utils.$extra].numberInLine === 0) return space.height > ERROR;
                                        return false;
                                    }
                                    return space.width > ERROR;
                                }
                                if (node.w !== "") return Math.round(w - space.width) <= ERROR;
                                return space.width > ERROR;
                            }
                            if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) return true;
                            if (node.h !== "" && Math.round(h - space.height) > ERROR) return false;
                            if (node.w === "" || Math.round(w - space.width) <= ERROR) return space.height > ERROR;
                            if (parent[_symbol_utils.$isThereMoreWidth]()) return false;
                            return space.height > ERROR;
                        case "table":
                        case "tb":
                            if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) return true;
                            if (node.h !== "" && !node[_symbol_utils.$isSplittable]()) return Math.round(h - space.height) <= ERROR;
                            if (node.w === "" || Math.round(w - space.width) <= ERROR) return space.height > ERROR;
                            if (parent[_symbol_utils.$isThereMoreWidth]()) return false;
                            return space.height > ERROR;
                        case "position":
                            if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) return true;
                            if (node.h === "" || Math.round(h + y - space.height) <= ERROR) return true;
                            const area = node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].currentContentArea;
                            return h + y > area.h;
                        case "rl-row":
                        case "row":
                            if (node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].noLayoutFailure) return true;
                            if (node.h !== "") return Math.round(h - space.height) <= ERROR;
                            return true;
                        default:
                            return true;
                    }
                }
            /***/ },
            /* 83 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.computeBbox = computeBbox;
                exports.createWrapper = createWrapper;
                exports.fixDimensions = fixDimensions;
                exports.fixTextIndent = fixTextIndent;
                exports.fixURL = fixURL;
                exports.isPrintOnly = isPrintOnly;
                exports.layoutClass = layoutClass;
                exports.layoutNode = layoutNode;
                exports.measureToString = measureToString;
                exports.setAccess = setAccess;
                exports.setFontFamily = setFontFamily;
                exports.setMinMaxDimensions = setMinMaxDimensions;
                exports.setPara = setPara;
                exports.toStyle = toStyle;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _util = __w_pdfjs_require__(2);
                var _utils = __w_pdfjs_require__(84);
                var _fonts = __w_pdfjs_require__(85);
                var _text = __w_pdfjs_require__(86);
                var _xfa_object = __w_pdfjs_require__(87);
                function measureToString(m) {
                    if (typeof m === "string") return "0px";
                    return Number.isInteger(m) ? `${m}px` : `${m.toFixed(2)}px`;
                }
                const converters = {
                    anchorType (node, style) {
                        const parent = node[_symbol_utils.$getSubformParent]();
                        if (!parent || parent.layout && parent.layout !== "position") return;
                        if (!("transform" in style)) style.transform = "";
                        switch(node.anchorType){
                            case "bottomCenter":
                                style.transform += "translate(-50%, -100%)";
                                break;
                            case "bottomLeft":
                                style.transform += "translate(0,-100%)";
                                break;
                            case "bottomRight":
                                style.transform += "translate(-100%,-100%)";
                                break;
                            case "middleCenter":
                                style.transform += "translate(-50%,-50%)";
                                break;
                            case "middleLeft":
                                style.transform += "translate(0,-50%)";
                                break;
                            case "middleRight":
                                style.transform += "translate(-100%,-50%)";
                                break;
                            case "topCenter":
                                style.transform += "translate(-50%,0)";
                                break;
                            case "topRight":
                                style.transform += "translate(-100%,0)";
                                break;
                        }
                    },
                    dimensions (node, style) {
                        const parent = node[_symbol_utils.$getSubformParent]();
                        let width = node.w;
                        const height = node.h;
                        if (parent.layout?.includes("row")) {
                            const extra = parent[_symbol_utils.$extra];
                            const colSpan = node.colSpan;
                            let w;
                            if (colSpan === -1) {
                                w = extra.columnWidths.slice(extra.currentColumn).reduce((a, x)=>a + x, 0);
                                extra.currentColumn = 0;
                            } else {
                                w = extra.columnWidths.slice(extra.currentColumn, extra.currentColumn + colSpan).reduce((a, x)=>a + x, 0);
                                extra.currentColumn = (extra.currentColumn + node.colSpan) % extra.columnWidths.length;
                            }
                            if (!isNaN(w)) width = node.w = w;
                        }
                        style.width = width !== "" ? measureToString(width) : "auto";
                        style.height = height !== "" ? measureToString(height) : "auto";
                    },
                    position (node, style) {
                        const parent = node[_symbol_utils.$getSubformParent]();
                        if (parent?.layout && parent.layout !== "position") return;
                        style.position = "absolute";
                        style.left = measureToString(node.x);
                        style.top = measureToString(node.y);
                    },
                    rotate (node, style) {
                        if (node.rotate) {
                            if (!("transform" in style)) style.transform = "";
                            style.transform += `rotate(-${node.rotate}deg)`;
                            style.transformOrigin = "top left";
                        }
                    },
                    presence (node, style) {
                        switch(node.presence){
                            case "invisible":
                                style.visibility = "hidden";
                                break;
                            case "hidden":
                            case "inactive":
                                style.display = "none";
                                break;
                        }
                    },
                    hAlign (node, style) {
                        if (node[_symbol_utils.$nodeName] === "para") switch(node.hAlign){
                            case "justifyAll":
                                style.textAlign = "justify-all";
                                break;
                            case "radix":
                                style.textAlign = "left";
                                break;
                            default:
                                style.textAlign = node.hAlign;
                        }
                        else switch(node.hAlign){
                            case "left":
                                style.alignSelf = "start";
                                break;
                            case "center":
                                style.alignSelf = "center";
                                break;
                            case "right":
                                style.alignSelf = "end";
                                break;
                        }
                    },
                    margin (node, style) {
                        if (node.margin) style.margin = node.margin[_symbol_utils.$toStyle]().margin;
                    }
                };
                function setMinMaxDimensions(node, style) {
                    const parent = node[_symbol_utils.$getSubformParent]();
                    if (parent.layout === "position") {
                        if (node.minW > 0) style.minWidth = measureToString(node.minW);
                        if (node.maxW > 0) style.maxWidth = measureToString(node.maxW);
                        if (node.minH > 0) style.minHeight = measureToString(node.minH);
                        if (node.maxH > 0) style.maxHeight = measureToString(node.maxH);
                    }
                }
                function layoutText(text, xfaFont, margin, lineHeight, fontFinder, width) {
                    const measure = new _text.TextMeasure(xfaFont, margin, lineHeight, fontFinder);
                    if (typeof text === "string") measure.addString(text);
                    else text[_symbol_utils.$pushGlyphs](measure);
                    return measure.compute(width);
                }
                function layoutNode(node, availableSpace) {
                    let height = null;
                    let width = null;
                    let isBroken = false;
                    if ((!node.w || !node.h) && node.value) {
                        let marginH = 0;
                        let marginV = 0;
                        if (node.margin) {
                            marginH = node.margin.leftInset + node.margin.rightInset;
                            marginV = node.margin.topInset + node.margin.bottomInset;
                        }
                        let lineHeight = null;
                        let margin = null;
                        if (node.para) {
                            margin = Object.create(null);
                            lineHeight = node.para.lineHeight === "" ? null : node.para.lineHeight;
                            margin.top = node.para.spaceAbove === "" ? 0 : node.para.spaceAbove;
                            margin.bottom = node.para.spaceBelow === "" ? 0 : node.para.spaceBelow;
                            margin.left = node.para.marginLeft === "" ? 0 : node.para.marginLeft;
                            margin.right = node.para.marginRight === "" ? 0 : node.para.marginRight;
                        }
                        let font1 = node.font;
                        if (!font1) {
                            const root = node[_symbol_utils.$getTemplateRoot]();
                            let parent = node[_symbol_utils.$getParent]();
                            while(parent && parent !== root){
                                if (parent.font) {
                                    font1 = parent.font;
                                    break;
                                }
                                parent = parent[_symbol_utils.$getParent]();
                            }
                        }
                        const maxWidth = (node.w || availableSpace.width) - marginH;
                        const fontFinder = node[_symbol_utils.$globalData].fontFinder;
                        if (node.value.exData && node.value.exData[_symbol_utils.$content] && node.value.exData.contentType === "text/html") {
                            const res = layoutText(node.value.exData[_symbol_utils.$content], font1, margin, lineHeight, fontFinder, maxWidth);
                            width = res.width;
                            height = res.height;
                            isBroken = res.isBroken;
                        } else {
                            const text = node.value[_symbol_utils.$text]();
                            if (text) {
                                const res = layoutText(text, font1, margin, lineHeight, fontFinder, maxWidth);
                                width = res.width;
                                height = res.height;
                                isBroken = res.isBroken;
                            }
                        }
                        if (width !== null && !node.w) width += marginH;
                        if (height !== null && !node.h) height += marginV;
                    }
                    return {
                        w: width,
                        h: height,
                        isBroken: isBroken
                    };
                }
                function computeBbox(node, html, availableSpace) {
                    let bbox;
                    if (node.w !== "" && node.h !== "") bbox = [
                        node.x,
                        node.y,
                        node.w,
                        node.h
                    ];
                    else {
                        if (!availableSpace) return null;
                        let width = node.w;
                        if (width === "") {
                            if (node.maxW === 0) {
                                const parent = node[_symbol_utils.$getSubformParent]();
                                width = parent.layout === "position" && parent.w !== "" ? 0 : node.minW;
                            } else width = Math.min(node.maxW, availableSpace.width);
                            html.attributes.style.width = measureToString(width);
                        }
                        let height = node.h;
                        if (height === "") {
                            if (node.maxH === 0) {
                                const parent = node[_symbol_utils.$getSubformParent]();
                                height = parent.layout === "position" && parent.h !== "" ? 0 : node.minH;
                            } else height = Math.min(node.maxH, availableSpace.height);
                            html.attributes.style.height = measureToString(height);
                        }
                        bbox = [
                            node.x,
                            node.y,
                            width,
                            height
                        ];
                    }
                    return bbox;
                }
                function fixDimensions(node) {
                    const parent = node[_symbol_utils.$getSubformParent]();
                    if (parent.layout?.includes("row")) {
                        const extra = parent[_symbol_utils.$extra];
                        const colSpan = node.colSpan;
                        let width;
                        if (colSpan === -1) width = extra.columnWidths.slice(extra.currentColumn).reduce((a, w)=>a + w, 0);
                        else width = extra.columnWidths.slice(extra.currentColumn, extra.currentColumn + colSpan).reduce((a, w)=>a + w, 0);
                        if (!isNaN(width)) node.w = width;
                    }
                    if (parent.layout && parent.layout !== "position") node.x = node.y = 0;
                    if (node.layout === "table") {
                        if (node.w === "" && Array.isArray(node.columnWidths)) node.w = node.columnWidths.reduce((a, x)=>a + x, 0);
                    }
                }
                function layoutClass(node) {
                    switch(node.layout){
                        case "position":
                            return "xfaPosition";
                        case "lr-tb":
                            return "xfaLrTb";
                        case "rl-row":
                            return "xfaRlRow";
                        case "rl-tb":
                            return "xfaRlTb";
                        case "row":
                            return "xfaRow";
                        case "table":
                            return "xfaTable";
                        case "tb":
                            return "xfaTb";
                        default:
                            return "xfaPosition";
                    }
                }
                function toStyle(node, ...names) {
                    const style = Object.create(null);
                    for (const name of names){
                        const value = node[name];
                        if (value === null) continue;
                        if (converters.hasOwnProperty(name)) {
                            converters[name](node, style);
                            continue;
                        }
                        if (value instanceof _xfa_object.XFAObject) {
                            const newStyle = value[_symbol_utils.$toStyle]();
                            if (newStyle) Object.assign(style, newStyle);
                            else (0, _util.warn)(`(DEBUG) - XFA - style for ${name} not implemented yet`);
                        }
                    }
                    return style;
                }
                function createWrapper(node, html) {
                    const { attributes: attributes } = html;
                    const { style: style } = attributes;
                    const wrapper = {
                        name: "div",
                        attributes: {
                            class: [
                                "xfaWrapper"
                            ],
                            style: Object.create(null)
                        },
                        children: []
                    };
                    attributes.class.push("xfaWrapped");
                    if (node.border) {
                        const { widths: widths, insets: insets } = node.border[_symbol_utils.$extra];
                        let width, height;
                        let top = insets[0];
                        let left = insets[3];
                        const insetsH = insets[0] + insets[2];
                        const insetsW = insets[1] + insets[3];
                        switch(node.border.hand){
                            case "even":
                                top -= widths[0] / 2;
                                left -= widths[3] / 2;
                                width = `calc(100% + ${(widths[1] + widths[3]) / 2 - insetsW}px)`;
                                height = `calc(100% + ${(widths[0] + widths[2]) / 2 - insetsH}px)`;
                                break;
                            case "left":
                                top -= widths[0];
                                left -= widths[3];
                                width = `calc(100% + ${widths[1] + widths[3] - insetsW}px)`;
                                height = `calc(100% + ${widths[0] + widths[2] - insetsH}px)`;
                                break;
                            case "right":
                                width = insetsW ? `calc(100% - ${insetsW}px)` : "100%";
                                height = insetsH ? `calc(100% - ${insetsH}px)` : "100%";
                                break;
                        }
                        const classNames = [
                            "xfaBorder"
                        ];
                        if (isPrintOnly(node.border)) classNames.push("xfaPrintOnly");
                        const border = {
                            name: "div",
                            attributes: {
                                class: classNames,
                                style: {
                                    top: `${top}px`,
                                    left: `${left}px`,
                                    width: width,
                                    height: height
                                }
                            },
                            children: []
                        };
                        for (const key of [
                            "border",
                            "borderWidth",
                            "borderColor",
                            "borderRadius",
                            "borderStyle"
                        ])if (style[key] !== undefined) {
                            border.attributes.style[key] = style[key];
                            delete style[key];
                        }
                        wrapper.children.push(border, html);
                    } else wrapper.children.push(html);
                    for (const key of [
                        "background",
                        "backgroundClip",
                        "top",
                        "left",
                        "width",
                        "height",
                        "minWidth",
                        "minHeight",
                        "maxWidth",
                        "maxHeight",
                        "transform",
                        "transformOrigin",
                        "visibility"
                    ])if (style[key] !== undefined) {
                        wrapper.attributes.style[key] = style[key];
                        delete style[key];
                    }
                    wrapper.attributes.style.position = style.position === "absolute" ? "absolute" : "relative";
                    delete style.position;
                    if (style.alignSelf) {
                        wrapper.attributes.style.alignSelf = style.alignSelf;
                        delete style.alignSelf;
                    }
                    return wrapper;
                }
                function fixTextIndent(styles) {
                    const indent = (0, _utils.getMeasurement)(styles.textIndent, "0px");
                    if (indent >= 0) return;
                    const align = styles.textAlign === "right" ? "right" : "left";
                    const name = "padding" + (align === "left" ? "Left" : "Right");
                    const padding = (0, _utils.getMeasurement)(styles[name], "0px");
                    styles[name] = `${padding - indent}px`;
                }
                function setAccess(node, classNames) {
                    switch(node.access){
                        case "nonInteractive":
                            classNames.push("xfaNonInteractive");
                            break;
                        case "readOnly":
                            classNames.push("xfaReadOnly");
                            break;
                        case "protected":
                            classNames.push("xfaDisabled");
                            break;
                    }
                }
                function isPrintOnly(node) {
                    return node.relevant.length > 0 && !node.relevant[0].excluded && node.relevant[0].viewname === "print";
                }
                function getCurrentPara(node) {
                    const stack = node[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].paraStack;
                    return stack.length ? stack.at(-1) : null;
                }
                function setPara(node, nodeStyle, value) {
                    if (value.attributes.class?.includes("xfaRich")) {
                        if (nodeStyle) {
                            if (node.h === "") nodeStyle.height = "auto";
                            if (node.w === "") nodeStyle.width = "auto";
                        }
                        const para = getCurrentPara(node);
                        if (para) {
                            const valueStyle = value.attributes.style;
                            valueStyle.display = "flex";
                            valueStyle.flexDirection = "column";
                            switch(para.vAlign){
                                case "top":
                                    valueStyle.justifyContent = "start";
                                    break;
                                case "bottom":
                                    valueStyle.justifyContent = "end";
                                    break;
                                case "middle":
                                    valueStyle.justifyContent = "center";
                                    break;
                            }
                            const paraStyle = para[_symbol_utils.$toStyle]();
                            for (const [key, val] of Object.entries(paraStyle))if (!(key in valueStyle)) valueStyle[key] = val;
                        }
                    }
                }
                function setFontFamily(xfaFont, node, fontFinder, style) {
                    if (!fontFinder) {
                        delete style.fontFamily;
                        return;
                    }
                    const name = (0, _utils.stripQuotes)(xfaFont.typeface);
                    style.fontFamily = `"${name}"`;
                    const typeface = fontFinder.find(name);
                    if (typeface) {
                        const { fontFamily: fontFamily } = typeface.regular.cssFontInfo;
                        if (fontFamily !== name) style.fontFamily = `"${fontFamily}"`;
                        const para = getCurrentPara(node);
                        if (para && para.lineHeight !== "") return;
                        if (style.lineHeight) return;
                        const pdfFont = (0, _fonts.selectFont)(xfaFont, typeface);
                        if (pdfFont) style.lineHeight = Math.max(1.2, pdfFont.lineHeight);
                    }
                }
                function fixURL(str) {
                    const absoluteUrl = (0, _util.createValidAbsoluteUrl)(str, null, {
                        addDefaultProtocol: true,
                        tryConvertEncoding: true
                    });
                    return absoluteUrl ? absoluteUrl.href : null;
                }
            /***/ },
            /* 84 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HTMLResult = void 0;
                exports.getBBox = getBBox;
                exports.getColor = getColor;
                exports.getFloat = getFloat;
                exports.getInteger = getInteger;
                exports.getKeyword = getKeyword;
                exports.getMeasurement = getMeasurement;
                exports.getRatio = getRatio;
                exports.getRelevant = getRelevant;
                exports.getStringOption = getStringOption;
                exports.stripQuotes = stripQuotes;
                var _util = __w_pdfjs_require__(2);
                const dimConverters = {
                    pt: (x)=>x,
                    cm: (x)=>x / 2.54 * 72,
                    mm: (x)=>x / 25.4 * 72,
                    in: (x)=>x * 72,
                    px: (x)=>x
                };
                const measurementPattern = /([+-]?\d+\.?\d*)(.*)/;
                function stripQuotes(str) {
                    if (str.startsWith("'") || str.startsWith('"')) return str.slice(1, -1);
                    return str;
                }
                function getInteger({ data: data, defaultValue: defaultValue, validate: validate }) {
                    if (!data) return defaultValue;
                    data = data.trim();
                    const n = parseInt(data, 10);
                    if (!isNaN(n) && validate(n)) return n;
                    return defaultValue;
                }
                function getFloat({ data: data, defaultValue: defaultValue, validate: validate }) {
                    if (!data) return defaultValue;
                    data = data.trim();
                    const n = parseFloat(data);
                    if (!isNaN(n) && validate(n)) return n;
                    return defaultValue;
                }
                function getKeyword({ data: data, defaultValue: defaultValue, validate: validate }) {
                    if (!data) return defaultValue;
                    data = data.trim();
                    if (validate(data)) return data;
                    return defaultValue;
                }
                function getStringOption(data, options) {
                    return getKeyword({
                        data: data,
                        defaultValue: options[0],
                        validate: (k)=>options.includes(k)
                    });
                }
                function getMeasurement(str, def = "0") {
                    def ||= "0";
                    if (!str) return getMeasurement(def);
                    const match = str.trim().match(measurementPattern);
                    if (!match) return getMeasurement(def);
                    const [, valueStr, unit] = match;
                    const value = parseFloat(valueStr);
                    if (isNaN(value)) return getMeasurement(def);
                    if (value === 0) return 0;
                    const conv = dimConverters[unit];
                    if (conv) return conv(value);
                    return value;
                }
                function getRatio(data) {
                    if (!data) return {
                        num: 1,
                        den: 1
                    };
                    const ratio = data.trim().split(/\s*:\s*/).map((x)=>parseFloat(x)).filter((x)=>!isNaN(x));
                    if (ratio.length === 1) ratio.push(1);
                    if (ratio.length === 0) return {
                        num: 1,
                        den: 1
                    };
                    const [num, den] = ratio;
                    return {
                        num: num,
                        den: den
                    };
                }
                function getRelevant(data) {
                    if (!data) return [];
                    return data.trim().split(/\s+/).map((e)=>{
                        return {
                            excluded: e[0] === "-",
                            viewname: e.substring(1)
                        };
                    });
                }
                function getColor(data, def = [
                    0,
                    0,
                    0
                ]) {
                    let [r, g, b] = def;
                    if (!data) return {
                        r: r,
                        g: g,
                        b: b
                    };
                    const color = data.trim().split(/\s*,\s*/).map((c)=>Math.min(Math.max(0, parseInt(c.trim(), 10)), 255)).map((c)=>isNaN(c) ? 0 : c);
                    if (color.length < 3) return {
                        r: r,
                        g: g,
                        b: b
                    };
                    [r, g, b] = color;
                    return {
                        r: r,
                        g: g,
                        b: b
                    };
                }
                function getBBox(data) {
                    const def = -1;
                    if (!data) return {
                        x: def,
                        y: def,
                        width: def,
                        height: def
                    };
                    const bbox = data.trim().split(/\s*,\s*/).map((m)=>getMeasurement(m, "-1"));
                    if (bbox.length < 4 || bbox[2] < 0 || bbox[3] < 0) return {
                        x: def,
                        y: def,
                        width: def,
                        height: def
                    };
                    const [x, y, width, height] = bbox;
                    return {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    };
                }
                class HTMLResult {
                    static get FAILURE() {
                        return (0, _util.shadow)(this, "FAILURE", new HTMLResult(false, null, null, null));
                    }
                    static get EMPTY() {
                        return (0, _util.shadow)(this, "EMPTY", new HTMLResult(true, null, null, null));
                    }
                    constructor(success, html, bbox, breakNode){
                        this.success = success;
                        this.html = html;
                        this.bbox = bbox;
                        this.breakNode = breakNode;
                    }
                    isBreak() {
                        return !!this.breakNode;
                    }
                    static breakNode(node) {
                        return new HTMLResult(false, null, null, node);
                    }
                    static success(html, bbox = null) {
                        return new HTMLResult(true, html, bbox, null);
                    }
                }
                exports.HTMLResult = HTMLResult;
            /***/ },
            /* 85 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontFinder = void 0;
                exports.getMetrics = getMetrics;
                exports.selectFont = selectFont;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                class FontFinder {
                    constructor(pdfFonts){
                        this.fonts = new Map();
                        this.cache = new Map();
                        this.warned = new Set();
                        this.defaultFont = null;
                        this.add(pdfFonts);
                    }
                    add(pdfFonts, reallyMissingFonts = null) {
                        for (const pdfFont of pdfFonts)this.addPdfFont(pdfFont);
                        for (const pdfFont of this.fonts.values())if (!pdfFont.regular) pdfFont.regular = pdfFont.italic || pdfFont.bold || pdfFont.bolditalic;
                        if (!reallyMissingFonts || reallyMissingFonts.size === 0) return;
                        const myriad = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
                        for (const missing of reallyMissingFonts)this.fonts.set(missing, myriad);
                    }
                    addPdfFont(pdfFont) {
                        const cssFontInfo = pdfFont.cssFontInfo;
                        const name = cssFontInfo.fontFamily;
                        let font1 = this.fonts.get(name);
                        if (!font1) {
                            font1 = Object.create(null);
                            this.fonts.set(name, font1);
                            if (!this.defaultFont) this.defaultFont = font1;
                        }
                        let property = "";
                        const fontWeight = parseFloat(cssFontInfo.fontWeight);
                        if (parseFloat(cssFontInfo.italicAngle) !== 0) property = fontWeight >= 700 ? "bolditalic" : "italic";
                        else if (fontWeight >= 700) property = "bold";
                        if (!property) {
                            if (pdfFont.name.includes("Bold") || pdfFont.psName?.includes("Bold")) property = "bold";
                            if (pdfFont.name.includes("Italic") || pdfFont.name.endsWith("It") || pdfFont.psName?.includes("Italic") || pdfFont.psName?.endsWith("It")) property += "italic";
                        }
                        if (!property) property = "regular";
                        font1[property] = pdfFont;
                    }
                    getDefault() {
                        return this.defaultFont;
                    }
                    find(fontName, mustWarn = true) {
                        let font1 = this.fonts.get(fontName) || this.cache.get(fontName);
                        if (font1) return font1;
                        const pattern = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
                        let name = fontName.replaceAll(pattern, "");
                        font1 = this.fonts.get(name);
                        if (font1) {
                            this.cache.set(fontName, font1);
                            return font1;
                        }
                        name = name.toLowerCase();
                        const maybe = [];
                        for (const [family, pdfFont] of this.fonts.entries())if (family.replaceAll(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        if (maybe.length === 0) {
                            for (const [, pdfFont] of this.fonts.entries())if (pdfFont.regular.name?.replaceAll(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        }
                        if (maybe.length === 0) {
                            name = name.replaceAll(/psmt|mt/gi, "");
                            for (const [family, pdfFont] of this.fonts.entries())if (family.replaceAll(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        }
                        if (maybe.length === 0) {
                            for (const pdfFont of this.fonts.values())if (pdfFont.regular.name?.replaceAll(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        }
                        if (maybe.length >= 1) {
                            if (maybe.length !== 1 && mustWarn) (0, _util.warn)(`XFA - Too many choices to guess the correct font: ${fontName}`);
                            this.cache.set(fontName, maybe[0]);
                            return maybe[0];
                        }
                        if (mustWarn && !this.warned.has(fontName)) {
                            this.warned.add(fontName);
                            (0, _util.warn)(`XFA - Cannot find the font: ${fontName}`);
                        }
                        return null;
                    }
                }
                exports.FontFinder = FontFinder;
                function selectFont(xfaFont, typeface) {
                    if (xfaFont.posture === "italic") {
                        if (xfaFont.weight === "bold") return typeface.bolditalic;
                        return typeface.italic;
                    } else if (xfaFont.weight === "bold") return typeface.bold;
                    return typeface.regular;
                }
                function getMetrics(xfaFont, real = false) {
                    let pdfFont = null;
                    if (xfaFont) {
                        const name = (0, _utils.stripQuotes)(xfaFont.typeface);
                        const typeface = xfaFont[_symbol_utils.$globalData].fontFinder.find(name);
                        pdfFont = selectFont(xfaFont, typeface);
                    }
                    if (!pdfFont) return {
                        lineHeight: 12,
                        lineGap: 2,
                        lineNoGap: 10
                    };
                    const size = xfaFont.size || 10;
                    const lineHeight = pdfFont.lineHeight ? Math.max(real ? 0 : 1.2, pdfFont.lineHeight) : 1.2;
                    const lineGap = pdfFont.lineGap === undefined ? 0.2 : pdfFont.lineGap;
                    return {
                        lineHeight: lineHeight * size,
                        lineGap: lineGap * size,
                        lineNoGap: Math.max(1, lineHeight - lineGap) * size
                    };
                }
            /***/ },
            /* 86 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextMeasure = void 0;
                var _fonts = __w_pdfjs_require__(85);
                const WIDTH_FACTOR = 1.02;
                class FontInfo {
                    constructor(xfaFont, margin, lineHeight, fontFinder){
                        this.lineHeight = lineHeight;
                        this.paraMargin = margin || {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                        };
                        if (!xfaFont) {
                            [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                            return;
                        }
                        this.xfaFont = {
                            typeface: xfaFont.typeface,
                            posture: xfaFont.posture,
                            weight: xfaFont.weight,
                            size: xfaFont.size,
                            letterSpacing: xfaFont.letterSpacing
                        };
                        const typeface = fontFinder.find(xfaFont.typeface);
                        if (!typeface) {
                            [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                            return;
                        }
                        this.pdfFont = (0, _fonts.selectFont)(xfaFont, typeface);
                        if (!this.pdfFont) [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                    }
                    defaultFont(fontFinder) {
                        const font1 = fontFinder.find("Helvetica", false) || fontFinder.find("Myriad Pro", false) || fontFinder.find("Arial", false) || fontFinder.getDefault();
                        if (font1?.regular) {
                            const pdfFont = font1.regular;
                            const info = pdfFont.cssFontInfo;
                            const xfaFont = {
                                typeface: info.fontFamily,
                                posture: "normal",
                                weight: "normal",
                                size: 10,
                                letterSpacing: 0
                            };
                            return [
                                pdfFont,
                                xfaFont
                            ];
                        }
                        const xfaFont = {
                            typeface: "Courier",
                            posture: "normal",
                            weight: "normal",
                            size: 10,
                            letterSpacing: 0
                        };
                        return [
                            null,
                            xfaFont
                        ];
                    }
                }
                class FontSelector {
                    constructor(defaultXfaFont, defaultParaMargin, defaultLineHeight, fontFinder){
                        this.fontFinder = fontFinder;
                        this.stack = [
                            new FontInfo(defaultXfaFont, defaultParaMargin, defaultLineHeight, fontFinder)
                        ];
                    }
                    pushData(xfaFont, margin, lineHeight) {
                        const lastFont = this.stack.at(-1);
                        for (const name of [
                            "typeface",
                            "posture",
                            "weight",
                            "size",
                            "letterSpacing"
                        ])if (!xfaFont[name]) xfaFont[name] = lastFont.xfaFont[name];
                        for (const name of [
                            "top",
                            "bottom",
                            "left",
                            "right"
                        ])if (isNaN(margin[name])) margin[name] = lastFont.paraMargin[name];
                        const fontInfo = new FontInfo(xfaFont, margin, lineHeight || lastFont.lineHeight, this.fontFinder);
                        if (!fontInfo.pdfFont) fontInfo.pdfFont = lastFont.pdfFont;
                        this.stack.push(fontInfo);
                    }
                    popFont() {
                        this.stack.pop();
                    }
                    topFont() {
                        return this.stack.at(-1);
                    }
                }
                class TextMeasure {
                    constructor(defaultXfaFont, defaultParaMargin, defaultLineHeight, fonts){
                        this.glyphs = [];
                        this.fontSelector = new FontSelector(defaultXfaFont, defaultParaMargin, defaultLineHeight, fonts);
                        this.extraHeight = 0;
                    }
                    pushData(xfaFont, margin, lineHeight) {
                        this.fontSelector.pushData(xfaFont, margin, lineHeight);
                    }
                    popFont(xfaFont) {
                        return this.fontSelector.popFont();
                    }
                    addPara() {
                        const lastFont = this.fontSelector.topFont();
                        this.extraHeight += lastFont.paraMargin.top + lastFont.paraMargin.bottom;
                    }
                    addString(str) {
                        if (!str) return;
                        const lastFont = this.fontSelector.topFont();
                        const fontSize = lastFont.xfaFont.size;
                        if (lastFont.pdfFont) {
                            const letterSpacing = lastFont.xfaFont.letterSpacing;
                            const pdfFont = lastFont.pdfFont;
                            const fontLineHeight = pdfFont.lineHeight || 1.2;
                            const lineHeight = lastFont.lineHeight || Math.max(1.2, fontLineHeight) * fontSize;
                            const lineGap = pdfFont.lineGap === undefined ? 0.2 : pdfFont.lineGap;
                            const noGap = fontLineHeight - lineGap;
                            const firstLineHeight = Math.max(1, noGap) * fontSize;
                            const scale = fontSize / 1000;
                            const fallbackWidth = pdfFont.defaultWidth || pdfFont.charsToGlyphs(" ")[0].width;
                            for (const line of str.split(/[\u2029\n]/)){
                                const encodedLine = pdfFont.encodeString(line).join("");
                                const glyphs = pdfFont.charsToGlyphs(encodedLine);
                                for (const glyph of glyphs){
                                    const width = glyph.width || fallbackWidth;
                                    this.glyphs.push([
                                        width * scale + letterSpacing,
                                        lineHeight,
                                        firstLineHeight,
                                        glyph.unicode,
                                        false
                                    ]);
                                }
                                this.glyphs.push([
                                    0,
                                    0,
                                    0,
                                    "\n",
                                    true
                                ]);
                            }
                            this.glyphs.pop();
                            return;
                        }
                        for (const line of str.split(/[\u2029\n]/)){
                            for (const char of line.split(""))this.glyphs.push([
                                fontSize,
                                1.2 * fontSize,
                                fontSize,
                                char,
                                false
                            ]);
                            this.glyphs.push([
                                0,
                                0,
                                0,
                                "\n",
                                true
                            ]);
                        }
                        this.glyphs.pop();
                    }
                    compute(maxWidth) {
                        let lastSpacePos = -1, lastSpaceWidth = 0, width = 0, height = 0, currentLineWidth = 0, currentLineHeight = 0;
                        let isBroken = false;
                        let isFirstLine = true;
                        for(let i = 0, ii = this.glyphs.length; i < ii; i++){
                            const [glyphWidth, lineHeight, firstLineHeight, char, isEOL] = this.glyphs[i];
                            const isSpace = char === " ";
                            const glyphHeight = isFirstLine ? firstLineHeight : lineHeight;
                            if (isEOL) {
                                width = Math.max(width, currentLineWidth);
                                currentLineWidth = 0;
                                height += currentLineHeight;
                                currentLineHeight = glyphHeight;
                                lastSpacePos = -1;
                                lastSpaceWidth = 0;
                                isFirstLine = false;
                                continue;
                            }
                            if (isSpace) {
                                if (currentLineWidth + glyphWidth > maxWidth) {
                                    width = Math.max(width, currentLineWidth);
                                    currentLineWidth = 0;
                                    height += currentLineHeight;
                                    currentLineHeight = glyphHeight;
                                    lastSpacePos = -1;
                                    lastSpaceWidth = 0;
                                    isBroken = true;
                                    isFirstLine = false;
                                } else {
                                    currentLineHeight = Math.max(glyphHeight, currentLineHeight);
                                    lastSpaceWidth = currentLineWidth;
                                    currentLineWidth += glyphWidth;
                                    lastSpacePos = i;
                                }
                                continue;
                            }
                            if (currentLineWidth + glyphWidth > maxWidth) {
                                height += currentLineHeight;
                                currentLineHeight = glyphHeight;
                                if (lastSpacePos !== -1) {
                                    i = lastSpacePos;
                                    width = Math.max(width, lastSpaceWidth);
                                    currentLineWidth = 0;
                                    lastSpacePos = -1;
                                    lastSpaceWidth = 0;
                                } else {
                                    width = Math.max(width, currentLineWidth);
                                    currentLineWidth = glyphWidth;
                                }
                                isBroken = true;
                                isFirstLine = false;
                                continue;
                            }
                            currentLineWidth += glyphWidth;
                            currentLineHeight = Math.max(glyphHeight, currentLineHeight);
                        }
                        width = Math.max(width, currentLineWidth);
                        height += currentLineHeight + this.extraHeight;
                        return {
                            width: WIDTH_FACTOR * width,
                            height: height,
                            isBroken: isBroken
                        };
                    }
                }
                exports.TextMeasure = TextMeasure;
            /***/ },
            /* 87 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XmlObject = exports.XFAObjectArray = exports.XFAObject = exports.XFAAttribute = exports.StringObject = exports.OptionObject = exports.Option10 = exports.Option01 = exports.IntegerObject = exports.ContentObject = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _namespaces = __w_pdfjs_require__(81);
                var _som = __w_pdfjs_require__(88);
                const _applyPrototype = Symbol();
                const _attributes = Symbol();
                const _attributeNames = Symbol();
                const _children = Symbol("_children");
                const _cloneAttribute = Symbol();
                const _dataValue = Symbol();
                const _defaultValue = Symbol();
                const _filteredChildrenGenerator = Symbol();
                const _getPrototype = Symbol();
                const _getUnsetAttributes = Symbol();
                const _hasChildren = Symbol();
                const _max = Symbol();
                const _options = Symbol();
                const _parent = Symbol("parent");
                const _resolvePrototypesHelper = Symbol();
                const _setAttributes = Symbol();
                const _validator = Symbol();
                let uid = 0;
                const NS_DATASETS = _namespaces.NamespaceIds.datasets.id;
                class XFAObject {
                    constructor(nsId, name, hasChildren = false){
                        this[_symbol_utils.$namespaceId] = nsId;
                        this[_symbol_utils.$nodeName] = name;
                        this[_hasChildren] = hasChildren;
                        this[_parent] = null;
                        this[_children] = [];
                        this[_symbol_utils.$uid] = `${name}${uid++}`;
                        this[_symbol_utils.$globalData] = null;
                    }
                    get isXFAObject() {
                        return true;
                    }
                    get isXFAObjectArray() {
                        return false;
                    }
                    createNodes(path) {
                        let root = this, node = null;
                        for (const { name: name, index: index } of path){
                            for(let i = 0, ii = isFinite(index) ? index : 0; i <= ii; i++){
                                const nsId = root[_symbol_utils.$namespaceId] === NS_DATASETS ? -1 : root[_symbol_utils.$namespaceId];
                                node = new XmlObject(nsId, name);
                                root[_symbol_utils.$appendChild](node);
                            }
                            root = node;
                        }
                        return node;
                    }
                    [_symbol_utils.$onChild](child) {
                        if (!this[_hasChildren] || !this[_symbol_utils.$onChildCheck](child)) return false;
                        const name = child[_symbol_utils.$nodeName];
                        const node = this[name];
                        if (node instanceof XFAObjectArray) {
                            if (node.push(child)) {
                                this[_symbol_utils.$appendChild](child);
                                return true;
                            }
                        } else {
                            if (node !== null) this[_symbol_utils.$removeChild](node);
                            this[name] = child;
                            this[_symbol_utils.$appendChild](child);
                            return true;
                        }
                        let id = "";
                        if (this.id) id = ` (id: ${this.id})`;
                        else if (this.name) id = ` (name: ${this.name} ${this.h.value})`;
                        (0, _util.warn)(`XFA - node "${this[_symbol_utils.$nodeName]}"${id} has already enough "${name}"!`);
                        return false;
                    }
                    [_symbol_utils.$onChildCheck](child) {
                        return this.hasOwnProperty(child[_symbol_utils.$nodeName]) && child[_symbol_utils.$namespaceId] === this[_symbol_utils.$namespaceId];
                    }
                    [_symbol_utils.$isNsAgnostic]() {
                        return false;
                    }
                    [_symbol_utils.$acceptWhitespace]() {
                        return false;
                    }
                    [_symbol_utils.$isCDATAXml]() {
                        return false;
                    }
                    [_symbol_utils.$isBindable]() {
                        return false;
                    }
                    [_symbol_utils.$popPara]() {
                        if (this.para) this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].paraStack.pop();
                    }
                    [_symbol_utils.$pushPara]() {
                        this[_symbol_utils.$getTemplateRoot]()[_symbol_utils.$extra].paraStack.push(this.para);
                    }
                    [_symbol_utils.$setId](ids) {
                        if (this.id && this[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.template.id) ids.set(this.id, this);
                    }
                    [_symbol_utils.$getTemplateRoot]() {
                        return this[_symbol_utils.$globalData].template;
                    }
                    [_symbol_utils.$isSplittable]() {
                        return false;
                    }
                    [_symbol_utils.$isThereMoreWidth]() {
                        return false;
                    }
                    [_symbol_utils.$appendChild](child) {
                        child[_parent] = this;
                        this[_children].push(child);
                        if (!child[_symbol_utils.$globalData] && this[_symbol_utils.$globalData]) child[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                    }
                    [_symbol_utils.$removeChild](child) {
                        const i = this[_children].indexOf(child);
                        this[_children].splice(i, 1);
                    }
                    [_symbol_utils.$hasSettableValue]() {
                        return this.hasOwnProperty("value");
                    }
                    [_symbol_utils.$setValue](_) {}
                    [_symbol_utils.$onText](_) {}
                    [_symbol_utils.$finalize]() {}
                    [_symbol_utils.$clean](builder) {
                        delete this[_hasChildren];
                        if (this[_symbol_utils.$cleanup]) {
                            builder.clean(this[_symbol_utils.$cleanup]);
                            delete this[_symbol_utils.$cleanup];
                        }
                    }
                    [_symbol_utils.$indexOf](child) {
                        return this[_children].indexOf(child);
                    }
                    [_symbol_utils.$insertAt](i, child) {
                        child[_parent] = this;
                        this[_children].splice(i, 0, child);
                        if (!child[_symbol_utils.$globalData] && this[_symbol_utils.$globalData]) child[_symbol_utils.$globalData] = this[_symbol_utils.$globalData];
                    }
                    [_symbol_utils.$isTransparent]() {
                        return !this.name;
                    }
                    [_symbol_utils.$lastAttribute]() {
                        return "";
                    }
                    [_symbol_utils.$text]() {
                        if (this[_children].length === 0) return this[_symbol_utils.$content];
                        return this[_children].map((c)=>c[_symbol_utils.$text]()).join("");
                    }
                    get [_attributeNames]() {
                        const proto = Object.getPrototypeOf(this);
                        if (!proto._attributes) {
                            const attributes = proto._attributes = new Set();
                            for (const name of Object.getOwnPropertyNames(this)){
                                if (this[name] === null || this[name] instanceof XFAObject || this[name] instanceof XFAObjectArray) break;
                                attributes.add(name);
                            }
                        }
                        return (0, _util.shadow)(this, _attributeNames, proto._attributes);
                    }
                    [_symbol_utils.$isDescendent](parent) {
                        let node = this;
                        while(node){
                            if (node === parent) return true;
                            node = node[_symbol_utils.$getParent]();
                        }
                        return false;
                    }
                    [_symbol_utils.$getParent]() {
                        return this[_parent];
                    }
                    [_symbol_utils.$getSubformParent]() {
                        return this[_symbol_utils.$getParent]();
                    }
                    [_symbol_utils.$getChildren](name = null) {
                        if (!name) return this[_children];
                        return this[name];
                    }
                    [_symbol_utils.$dump]() {
                        const dumped = Object.create(null);
                        if (this[_symbol_utils.$content]) dumped.$content = this[_symbol_utils.$content];
                        for (const name of Object.getOwnPropertyNames(this)){
                            const value = this[name];
                            if (value === null) continue;
                            if (value instanceof XFAObject) dumped[name] = value[_symbol_utils.$dump]();
                            else if (value instanceof XFAObjectArray) {
                                if (!value.isEmpty()) dumped[name] = value.dump();
                            } else dumped[name] = value;
                        }
                        return dumped;
                    }
                    [_symbol_utils.$toStyle]() {
                        return null;
                    }
                    [_symbol_utils.$toHTML]() {
                        return _utils.HTMLResult.EMPTY;
                    }
                    *[_symbol_utils.$getContainedChildren]() {
                        for (const node of this[_symbol_utils.$getChildren]())yield node;
                    }
                    *[_filteredChildrenGenerator](filter, include) {
                        for (const node of this[_symbol_utils.$getContainedChildren]())if (!filter || include === filter.has(node[_symbol_utils.$nodeName])) {
                            const availableSpace = this[_symbol_utils.$getAvailableSpace]();
                            const res = node[_symbol_utils.$toHTML](availableSpace);
                            if (!res.success) this[_symbol_utils.$extra].failingNode = node;
                            yield res;
                        }
                    }
                    [_symbol_utils.$flushHTML]() {
                        return null;
                    }
                    [_symbol_utils.$addHTML](html, bbox) {
                        this[_symbol_utils.$extra].children.push(html);
                    }
                    [_symbol_utils.$getAvailableSpace]() {}
                    [_symbol_utils.$childrenToHTML]({ filter: filter = null, include: include = true }) {
                        if (!this[_symbol_utils.$extra].generator) this[_symbol_utils.$extra].generator = this[_filteredChildrenGenerator](filter, include);
                        else {
                            const availableSpace = this[_symbol_utils.$getAvailableSpace]();
                            const res = this[_symbol_utils.$extra].failingNode[_symbol_utils.$toHTML](availableSpace);
                            if (!res.success) return res;
                            if (res.html) this[_symbol_utils.$addHTML](res.html, res.bbox);
                            delete this[_symbol_utils.$extra].failingNode;
                        }
                        while(true){
                            const gen = this[_symbol_utils.$extra].generator.next();
                            if (gen.done) break;
                            const res = gen.value;
                            if (!res.success) return res;
                            if (res.html) this[_symbol_utils.$addHTML](res.html, res.bbox);
                        }
                        this[_symbol_utils.$extra].generator = null;
                        return _utils.HTMLResult.EMPTY;
                    }
                    [_symbol_utils.$setSetAttributes](attributes) {
                        this[_setAttributes] = new Set(Object.keys(attributes));
                    }
                    [_getUnsetAttributes](protoAttributes) {
                        const allAttr = this[_attributeNames];
                        const setAttr = this[_setAttributes];
                        return [
                            ...protoAttributes
                        ].filter((x)=>allAttr.has(x) && !setAttr.has(x));
                    }
                    [_symbol_utils.$resolvePrototypes](ids, ancestors = new Set()) {
                        for (const child of this[_children])child[_resolvePrototypesHelper](ids, ancestors);
                    }
                    [_resolvePrototypesHelper](ids, ancestors) {
                        const proto = this[_getPrototype](ids, ancestors);
                        if (proto) this[_applyPrototype](proto, ids, ancestors);
                        else this[_symbol_utils.$resolvePrototypes](ids, ancestors);
                    }
                    [_getPrototype](ids, ancestors) {
                        const { use: use, usehref: usehref } = this;
                        if (!use && !usehref) return null;
                        let proto = null;
                        let somExpression = null;
                        let id = null;
                        let ref = use;
                        if (usehref) {
                            ref = usehref;
                            if (usehref.startsWith("#som(") && usehref.endsWith(")")) somExpression = usehref.slice(5, -1);
                            else if (usehref.startsWith(".#som(") && usehref.endsWith(")")) somExpression = usehref.slice(6, -1);
                            else if (usehref.startsWith("#")) id = usehref.slice(1);
                            else if (usehref.startsWith(".#")) id = usehref.slice(2);
                        } else if (use.startsWith("#")) id = use.slice(1);
                        else somExpression = use;
                        this.use = this.usehref = "";
                        if (id) proto = ids.get(id);
                        else {
                            proto = (0, _som.searchNode)(ids.get(_symbol_utils.$root), this, somExpression, true, false);
                            if (proto) proto = proto[0];
                        }
                        if (!proto) {
                            (0, _util.warn)(`XFA - Invalid prototype reference: ${ref}.`);
                            return null;
                        }
                        if (proto[_symbol_utils.$nodeName] !== this[_symbol_utils.$nodeName]) {
                            (0, _util.warn)(`XFA - Incompatible prototype: ${proto[_symbol_utils.$nodeName]} !== ${this[_symbol_utils.$nodeName]}.`);
                            return null;
                        }
                        if (ancestors.has(proto)) {
                            (0, _util.warn)(`XFA - Cycle detected in prototypes use.`);
                            return null;
                        }
                        ancestors.add(proto);
                        const protoProto = proto[_getPrototype](ids, ancestors);
                        if (protoProto) proto[_applyPrototype](protoProto, ids, ancestors);
                        proto[_symbol_utils.$resolvePrototypes](ids, ancestors);
                        ancestors.delete(proto);
                        return proto;
                    }
                    [_applyPrototype](proto, ids, ancestors) {
                        if (ancestors.has(proto)) {
                            (0, _util.warn)(`XFA - Cycle detected in prototypes use.`);
                            return;
                        }
                        if (!this[_symbol_utils.$content] && proto[_symbol_utils.$content]) this[_symbol_utils.$content] = proto[_symbol_utils.$content];
                        const newAncestors = new Set(ancestors);
                        newAncestors.add(proto);
                        for (const unsetAttrName of this[_getUnsetAttributes](proto[_setAttributes])){
                            this[unsetAttrName] = proto[unsetAttrName];
                            if (this[_setAttributes]) this[_setAttributes].add(unsetAttrName);
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (this[_attributeNames].has(name)) continue;
                            const value = this[name];
                            const protoValue = proto[name];
                            if (value instanceof XFAObjectArray) {
                                for (const child of value[_children])child[_resolvePrototypesHelper](ids, ancestors);
                                for(let i = value[_children].length, ii = protoValue[_children].length; i < ii; i++){
                                    const child = proto[_children][i][_symbol_utils.$clone]();
                                    if (value.push(child)) {
                                        child[_parent] = this;
                                        this[_children].push(child);
                                        child[_resolvePrototypesHelper](ids, ancestors);
                                    } else break;
                                }
                                continue;
                            }
                            if (value !== null) {
                                value[_symbol_utils.$resolvePrototypes](ids, ancestors);
                                if (protoValue) value[_applyPrototype](protoValue, ids, ancestors);
                                continue;
                            }
                            if (protoValue !== null) {
                                const child = protoValue[_symbol_utils.$clone]();
                                child[_parent] = this;
                                this[name] = child;
                                this[_children].push(child);
                                child[_resolvePrototypesHelper](ids, ancestors);
                            }
                        }
                    }
                    static [_cloneAttribute](obj) {
                        if (Array.isArray(obj)) return obj.map((x)=>XFAObject[_cloneAttribute](x));
                        if (typeof obj === "object" && obj !== null) return Object.assign({}, obj);
                        return obj;
                    }
                    [_symbol_utils.$clone]() {
                        const clone = Object.create(Object.getPrototypeOf(this));
                        for (const $symbol of Object.getOwnPropertySymbols(this))try {
                            clone[$symbol] = this[$symbol];
                        } catch  {
                            (0, _util.shadow)(clone, $symbol, this[$symbol]);
                        }
                        clone[_symbol_utils.$uid] = `${clone[_symbol_utils.$nodeName]}${uid++}`;
                        clone[_children] = [];
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (this[_attributeNames].has(name)) {
                                clone[name] = XFAObject[_cloneAttribute](this[name]);
                                continue;
                            }
                            const value = this[name];
                            clone[name] = value instanceof XFAObjectArray ? new XFAObjectArray(value[_max]) : null;
                        }
                        for (const child of this[_children]){
                            const name = child[_symbol_utils.$nodeName];
                            const clonedChild = child[_symbol_utils.$clone]();
                            clone[_children].push(clonedChild);
                            clonedChild[_parent] = clone;
                            if (clone[name] === null) clone[name] = clonedChild;
                            else clone[name][_children].push(clonedChild);
                        }
                        return clone;
                    }
                    [_symbol_utils.$getChildren](name = null) {
                        if (!name) return this[_children];
                        return this[_children].filter((c)=>c[_symbol_utils.$nodeName] === name);
                    }
                    [_symbol_utils.$getChildrenByClass](name) {
                        return this[name];
                    }
                    [_symbol_utils.$getChildrenByName](name, allTransparent, first = true) {
                        return Array.from(this[_symbol_utils.$getChildrenByNameIt](name, allTransparent, first));
                    }
                    *[_symbol_utils.$getChildrenByNameIt](name, allTransparent, first = true) {
                        if (name === "parent") {
                            yield this[_parent];
                            return;
                        }
                        for (const child of this[_children]){
                            if (child[_symbol_utils.$nodeName] === name) yield child;
                            if (child.name === name) yield child;
                            if (allTransparent || child[_symbol_utils.$isTransparent]()) yield* child[_symbol_utils.$getChildrenByNameIt](name, allTransparent, false);
                        }
                        if (first && this[_attributeNames].has(name)) yield new XFAAttribute(this, name, this[name]);
                    }
                }
                exports.XFAObject = XFAObject;
                class XFAObjectArray {
                    constructor(max = Infinity){
                        this[_max] = max;
                        this[_children] = [];
                    }
                    get isXFAObject() {
                        return false;
                    }
                    get isXFAObjectArray() {
                        return true;
                    }
                    push(child) {
                        const len = this[_children].length;
                        if (len <= this[_max]) {
                            this[_children].push(child);
                            return true;
                        }
                        (0, _util.warn)(`XFA - node "${child[_symbol_utils.$nodeName]}" accepts no more than ${this[_max]} children`);
                        return false;
                    }
                    isEmpty() {
                        return this[_children].length === 0;
                    }
                    dump() {
                        return this[_children].length === 1 ? this[_children][0][_symbol_utils.$dump]() : this[_children].map((x)=>x[_symbol_utils.$dump]());
                    }
                    [_symbol_utils.$clone]() {
                        const clone = new XFAObjectArray(this[_max]);
                        clone[_children] = this[_children].map((c)=>c[_symbol_utils.$clone]());
                        return clone;
                    }
                    get children() {
                        return this[_children];
                    }
                    clear() {
                        this[_children].length = 0;
                    }
                }
                exports.XFAObjectArray = XFAObjectArray;
                class XFAAttribute {
                    constructor(node, name, value){
                        this[_parent] = node;
                        this[_symbol_utils.$nodeName] = name;
                        this[_symbol_utils.$content] = value;
                        this[_symbol_utils.$consumed] = false;
                        this[_symbol_utils.$uid] = `attribute${uid++}`;
                    }
                    [_symbol_utils.$getParent]() {
                        return this[_parent];
                    }
                    [_symbol_utils.$isDataValue]() {
                        return true;
                    }
                    [_symbol_utils.$getDataValue]() {
                        return this[_symbol_utils.$content].trim();
                    }
                    [_symbol_utils.$setValue](value) {
                        value = value.value || "";
                        this[_symbol_utils.$content] = value.toString();
                    }
                    [_symbol_utils.$text]() {
                        return this[_symbol_utils.$content];
                    }
                    [_symbol_utils.$isDescendent](parent) {
                        return this[_parent] === parent || this[_parent][_symbol_utils.$isDescendent](parent);
                    }
                }
                exports.XFAAttribute = XFAAttribute;
                class XmlObject extends XFAObject {
                    constructor(nsId, name, attributes = {}){
                        super(nsId, name);
                        this[_symbol_utils.$content] = "";
                        this[_dataValue] = null;
                        if (name !== "#text") {
                            const map = new Map();
                            this[_attributes] = map;
                            for (const [attrName, value] of Object.entries(attributes))map.set(attrName, new XFAAttribute(this, attrName, value));
                            if (attributes.hasOwnProperty(_symbol_utils.$nsAttributes)) {
                                const dataNode = attributes[_symbol_utils.$nsAttributes].xfa.dataNode;
                                if (dataNode !== undefined) {
                                    if (dataNode === "dataGroup") this[_dataValue] = false;
                                    else if (dataNode === "dataValue") this[_dataValue] = true;
                                }
                            }
                        }
                        this[_symbol_utils.$consumed] = false;
                    }
                    [_symbol_utils.$toString](buf) {
                        const tagName = this[_symbol_utils.$nodeName];
                        if (tagName === "#text") {
                            buf.push((0, _core_utils.encodeToXmlString)(this[_symbol_utils.$content]));
                            return;
                        }
                        const utf8TagName = (0, _util.utf8StringToString)(tagName);
                        const prefix = this[_symbol_utils.$namespaceId] === NS_DATASETS ? "xfa:" : "";
                        buf.push(`<${prefix}${utf8TagName}`);
                        for (const [name, value] of this[_attributes].entries()){
                            const utf8Name = (0, _util.utf8StringToString)(name);
                            buf.push(` ${utf8Name}="${(0, _core_utils.encodeToXmlString)(value[_symbol_utils.$content])}"`);
                        }
                        if (this[_dataValue] !== null) {
                            if (this[_dataValue]) buf.push(` xfa:dataNode="dataValue"`);
                            else buf.push(` xfa:dataNode="dataGroup"`);
                        }
                        if (!this[_symbol_utils.$content] && this[_children].length === 0) {
                            buf.push("/>");
                            return;
                        }
                        buf.push(">");
                        if (this[_symbol_utils.$content]) {
                            if (typeof this[_symbol_utils.$content] === "string") buf.push((0, _core_utils.encodeToXmlString)(this[_symbol_utils.$content]));
                            else this[_symbol_utils.$content][_symbol_utils.$toString](buf);
                        } else for (const child of this[_children])child[_symbol_utils.$toString](buf);
                        buf.push(`</${prefix}${utf8TagName}>`);
                    }
                    [_symbol_utils.$onChild](child) {
                        if (this[_symbol_utils.$content]) {
                            const node = new XmlObject(this[_symbol_utils.$namespaceId], "#text");
                            this[_symbol_utils.$appendChild](node);
                            node[_symbol_utils.$content] = this[_symbol_utils.$content];
                            this[_symbol_utils.$content] = "";
                        }
                        this[_symbol_utils.$appendChild](child);
                        return true;
                    }
                    [_symbol_utils.$onText](str) {
                        this[_symbol_utils.$content] += str;
                    }
                    [_symbol_utils.$finalize]() {
                        if (this[_symbol_utils.$content] && this[_children].length > 0) {
                            const node = new XmlObject(this[_symbol_utils.$namespaceId], "#text");
                            this[_symbol_utils.$appendChild](node);
                            node[_symbol_utils.$content] = this[_symbol_utils.$content];
                            delete this[_symbol_utils.$content];
                        }
                    }
                    [_symbol_utils.$toHTML]() {
                        if (this[_symbol_utils.$nodeName] === "#text") return _utils.HTMLResult.success({
                            name: "#text",
                            value: this[_symbol_utils.$content]
                        });
                        return _utils.HTMLResult.EMPTY;
                    }
                    [_symbol_utils.$getChildren](name = null) {
                        if (!name) return this[_children];
                        return this[_children].filter((c)=>c[_symbol_utils.$nodeName] === name);
                    }
                    [_symbol_utils.$getAttributes]() {
                        return this[_attributes];
                    }
                    [_symbol_utils.$getChildrenByClass](name) {
                        const value = this[_attributes].get(name);
                        if (value !== undefined) return value;
                        return this[_symbol_utils.$getChildren](name);
                    }
                    *[_symbol_utils.$getChildrenByNameIt](name, allTransparent) {
                        const value = this[_attributes].get(name);
                        if (value) yield value;
                        for (const child of this[_children]){
                            if (child[_symbol_utils.$nodeName] === name) yield child;
                            if (allTransparent) yield* child[_symbol_utils.$getChildrenByNameIt](name, allTransparent);
                        }
                    }
                    *[_symbol_utils.$getAttributeIt](name, skipConsumed) {
                        const value = this[_attributes].get(name);
                        if (value && (!skipConsumed || !value[_symbol_utils.$consumed])) yield value;
                        for (const child of this[_children])yield* child[_symbol_utils.$getAttributeIt](name, skipConsumed);
                    }
                    *[_symbol_utils.$getRealChildrenByNameIt](name, allTransparent, skipConsumed) {
                        for (const child of this[_children]){
                            if (child[_symbol_utils.$nodeName] === name && (!skipConsumed || !child[_symbol_utils.$consumed])) yield child;
                            if (allTransparent) yield* child[_symbol_utils.$getRealChildrenByNameIt](name, allTransparent, skipConsumed);
                        }
                    }
                    [_symbol_utils.$isDataValue]() {
                        if (this[_dataValue] === null) return this[_children].length === 0 || this[_children][0][_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id;
                        return this[_dataValue];
                    }
                    [_symbol_utils.$getDataValue]() {
                        if (this[_dataValue] === null) {
                            if (this[_children].length === 0) return this[_symbol_utils.$content].trim();
                            if (this[_children][0][_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) return this[_children][0][_symbol_utils.$text]().trim();
                            return null;
                        }
                        return this[_symbol_utils.$content].trim();
                    }
                    [_symbol_utils.$setValue](value) {
                        value = value.value || "";
                        this[_symbol_utils.$content] = value.toString();
                    }
                    [_symbol_utils.$dump](hasNS = false) {
                        const dumped = Object.create(null);
                        if (hasNS) dumped.$ns = this[_symbol_utils.$namespaceId];
                        if (this[_symbol_utils.$content]) dumped.$content = this[_symbol_utils.$content];
                        dumped.$name = this[_symbol_utils.$nodeName];
                        dumped.children = [];
                        for (const child of this[_children])dumped.children.push(child[_symbol_utils.$dump](hasNS));
                        dumped.attributes = Object.create(null);
                        for (const [name, value] of this[_attributes])dumped.attributes[name] = value[_symbol_utils.$content];
                        return dumped;
                    }
                }
                exports.XmlObject = XmlObject;
                class ContentObject extends XFAObject {
                    constructor(nsId, name){
                        super(nsId, name);
                        this[_symbol_utils.$content] = "";
                    }
                    [_symbol_utils.$onText](text) {
                        this[_symbol_utils.$content] += text;
                    }
                    [_symbol_utils.$finalize]() {}
                }
                exports.ContentObject = ContentObject;
                class OptionObject extends ContentObject {
                    constructor(nsId, name, options){
                        super(nsId, name);
                        this[_options] = options;
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = (0, _utils.getKeyword)({
                            data: this[_symbol_utils.$content],
                            defaultValue: this[_options][0],
                            validate: (k)=>this[_options].includes(k)
                        });
                    }
                    [_symbol_utils.$clean](builder) {
                        super[_symbol_utils.$clean](builder);
                        delete this[_options];
                    }
                }
                exports.OptionObject = OptionObject;
                class StringObject extends ContentObject {
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim();
                    }
                }
                exports.StringObject = StringObject;
                class IntegerObject extends ContentObject {
                    constructor(nsId, name, defaultValue, validator){
                        super(nsId, name);
                        this[_defaultValue] = defaultValue;
                        this[_validator] = validator;
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = (0, _utils.getInteger)({
                            data: this[_symbol_utils.$content],
                            defaultValue: this[_defaultValue],
                            validate: this[_validator]
                        });
                    }
                    [_symbol_utils.$clean](builder) {
                        super[_symbol_utils.$clean](builder);
                        delete this[_defaultValue];
                        delete this[_validator];
                    }
                }
                exports.IntegerObject = IntegerObject;
                class Option01 extends IntegerObject {
                    constructor(nsId, name){
                        super(nsId, name, 0, (n)=>n === 1);
                    }
                }
                exports.Option01 = Option01;
                class Option10 extends IntegerObject {
                    constructor(nsId, name){
                        super(nsId, name, 1, (n)=>n === 0);
                    }
                }
                exports.Option10 = Option10;
            /***/ },
            /* 88 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createDataNode = createDataNode;
                exports.searchNode = searchNode;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _util = __w_pdfjs_require__(2);
                const namePattern = /^[^.[]+/;
                const indexPattern = /^[^\]]+/;
                const operators = {
                    dot: 0,
                    dotDot: 1,
                    dotHash: 2,
                    dotBracket: 3,
                    dotParen: 4
                };
                const shortcuts = new Map([
                    [
                        "$data",
                        (root, current)=>root.datasets ? root.datasets.data : root
                    ],
                    [
                        "$record",
                        (root, current)=>(root.datasets ? root.datasets.data : root)[_symbol_utils.$getChildren]()[0]
                    ],
                    [
                        "$template",
                        (root, current)=>root.template
                    ],
                    [
                        "$connectionSet",
                        (root, current)=>root.connectionSet
                    ],
                    [
                        "$form",
                        (root, current)=>root.form
                    ],
                    [
                        "$layout",
                        (root, current)=>root.layout
                    ],
                    [
                        "$host",
                        (root, current)=>root.host
                    ],
                    [
                        "$dataWindow",
                        (root, current)=>root.dataWindow
                    ],
                    [
                        "$event",
                        (root, current)=>root.event
                    ],
                    [
                        "!",
                        (root, current)=>root.datasets
                    ],
                    [
                        "$xfa",
                        (root, current)=>root
                    ],
                    [
                        "xfa",
                        (root, current)=>root
                    ],
                    [
                        "$",
                        (root, current)=>current
                    ]
                ]);
                const somCache = new WeakMap();
                function parseIndex(index) {
                    index = index.trim();
                    if (index === "*") return Infinity;
                    return parseInt(index, 10) || 0;
                }
                function parseExpression(expr, dotDotAllowed, noExpr = true) {
                    let match = expr.match(namePattern);
                    if (!match) return null;
                    let [name] = match;
                    const parsed = [
                        {
                            name: name,
                            cacheName: "." + name,
                            index: 0,
                            js: null,
                            formCalc: null,
                            operator: operators.dot
                        }
                    ];
                    let pos = name.length;
                    while(pos < expr.length){
                        const spos = pos;
                        const char = expr.charAt(pos++);
                        if (char === "[") {
                            match = expr.slice(pos).match(indexPattern);
                            if (!match) {
                                (0, _util.warn)("XFA - Invalid index in SOM expression");
                                return null;
                            }
                            parsed.at(-1).index = parseIndex(match[0]);
                            pos += match[0].length + 1;
                            continue;
                        }
                        let operator;
                        switch(expr.charAt(pos)){
                            case ".":
                                if (!dotDotAllowed) return null;
                                pos++;
                                operator = operators.dotDot;
                                break;
                            case "#":
                                pos++;
                                operator = operators.dotHash;
                                break;
                            case "[":
                                if (noExpr) {
                                    (0, _util.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now.");
                                    return null;
                                }
                                operator = operators.dotBracket;
                                break;
                            case "(":
                                if (noExpr) {
                                    (0, _util.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now.");
                                    return null;
                                }
                                operator = operators.dotParen;
                                break;
                            default:
                                operator = operators.dot;
                                break;
                        }
                        match = expr.slice(pos).match(namePattern);
                        if (!match) break;
                        [name] = match;
                        pos += name.length;
                        parsed.push({
                            name: name,
                            cacheName: expr.slice(spos, pos),
                            operator: operator,
                            index: 0,
                            js: null,
                            formCalc: null
                        });
                    }
                    return parsed;
                }
                function searchNode(root, container, expr, dotDotAllowed = true, useCache = true) {
                    const parsed = parseExpression(expr, dotDotAllowed);
                    if (!parsed) return null;
                    const fn = shortcuts.get(parsed[0].name);
                    let i = 0;
                    let isQualified;
                    if (fn) {
                        isQualified = true;
                        root = [
                            fn(root, container)
                        ];
                        i = 1;
                    } else {
                        isQualified = container === null;
                        root = [
                            container || root
                        ];
                    }
                    for(let ii = parsed.length; i < ii; i++){
                        const { name: name, cacheName: cacheName, operator: operator, index: index } = parsed[i];
                        const nodes = [];
                        for (const node of root){
                            if (!node.isXFAObject) continue;
                            let children, cached;
                            if (useCache) {
                                cached = somCache.get(node);
                                if (!cached) {
                                    cached = new Map();
                                    somCache.set(node, cached);
                                }
                                children = cached.get(cacheName);
                            }
                            if (!children) {
                                switch(operator){
                                    case operators.dot:
                                        children = node[_symbol_utils.$getChildrenByName](name, false);
                                        break;
                                    case operators.dotDot:
                                        children = node[_symbol_utils.$getChildrenByName](name, true);
                                        break;
                                    case operators.dotHash:
                                        children = node[_symbol_utils.$getChildrenByClass](name);
                                        children = children.isXFAObjectArray ? children.children : [
                                            children
                                        ];
                                        break;
                                    default:
                                        break;
                                }
                                if (useCache) cached.set(cacheName, children);
                            }
                            if (children.length > 0) nodes.push(children);
                        }
                        if (nodes.length === 0 && !isQualified && i === 0) {
                            const parent = container[_symbol_utils.$getParent]();
                            container = parent;
                            if (!container) return null;
                            i = -1;
                            root = [
                                container
                            ];
                            continue;
                        }
                        root = isFinite(index) ? nodes.filter((node)=>index < node.length).map((node)=>node[index]) : nodes.flat();
                    }
                    if (root.length === 0) return null;
                    return root;
                }
                function createDataNode(root, container, expr) {
                    const parsed = parseExpression(expr);
                    if (!parsed) return null;
                    if (parsed.some((x)=>x.operator === operators.dotDot)) return null;
                    const fn = shortcuts.get(parsed[0].name);
                    let i = 0;
                    if (fn) {
                        root = fn(root, container);
                        i = 1;
                    } else root = container || root;
                    for(let ii = parsed.length; i < ii; i++){
                        const { name: name, operator: operator, index: index } = parsed[i];
                        if (!isFinite(index)) {
                            parsed[i].index = 0;
                            return root.createNodes(parsed.slice(i));
                        }
                        let children;
                        switch(operator){
                            case operators.dot:
                                children = root[_symbol_utils.$getChildrenByName](name, false);
                                break;
                            case operators.dotDot:
                                children = root[_symbol_utils.$getChildrenByName](name, true);
                                break;
                            case operators.dotHash:
                                children = root[_symbol_utils.$getChildrenByClass](name);
                                children = children.isXFAObjectArray ? children.children : [
                                    children
                                ];
                                break;
                            default:
                                break;
                        }
                        if (children.length === 0) return root.createNodes(parsed.slice(i));
                        if (index < children.length) {
                            const child = children[index];
                            if (!child.isXFAObject) {
                                (0, _util.warn)(`XFA - Cannot create a node.`);
                                return null;
                            }
                            root = child;
                        } else {
                            parsed[i].index = index - children.length;
                            return root.createNodes(parsed.slice(i));
                        }
                    }
                    return null;
                }
            /***/ },
            /* 89 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DataHandler = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                class DataHandler {
                    constructor(root, data){
                        this.data = data;
                        this.dataset = root.datasets || null;
                    }
                    serialize(storage) {
                        const stack = [
                            [
                                -1,
                                this.data[_symbol_utils.$getChildren]()
                            ]
                        ];
                        while(stack.length > 0){
                            const last = stack.at(-1);
                            const [i, children] = last;
                            if (i + 1 === children.length) {
                                stack.pop();
                                continue;
                            }
                            const child = children[++last[0]];
                            const storageEntry = storage.get(child[_symbol_utils.$uid]);
                            if (storageEntry) child[_symbol_utils.$setValue](storageEntry);
                            else {
                                const attributes = child[_symbol_utils.$getAttributes]();
                                for (const value of attributes.values()){
                                    const entry = storage.get(value[_symbol_utils.$uid]);
                                    if (entry) {
                                        value[_symbol_utils.$setValue](entry);
                                        break;
                                    }
                                }
                            }
                            const nodes = child[_symbol_utils.$getChildren]();
                            if (nodes.length > 0) stack.push([
                                -1,
                                nodes
                            ]);
                        }
                        const buf = [
                            `<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">`
                        ];
                        if (this.dataset) {
                            for (const child of this.dataset[_symbol_utils.$getChildren]())if (child[_symbol_utils.$nodeName] !== "data") child[_symbol_utils.$toString](buf);
                        }
                        this.data[_symbol_utils.$toString](buf);
                        buf.push("</xfa:datasets>");
                        return buf.join("");
                    }
                }
                exports.DataHandler = DataHandler;
            /***/ },
            /* 90 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XFAParser = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _xml_parser = __w_pdfjs_require__(71);
                var _builder = __w_pdfjs_require__(91);
                var _util = __w_pdfjs_require__(2);
                class XFAParser extends _xml_parser.XMLParserBase {
                    constructor(rootNameSpace = null, richText = false){
                        super();
                        this._builder = new _builder.Builder(rootNameSpace);
                        this._stack = [];
                        this._globalData = {
                            usedTypefaces: new Set()
                        };
                        this._ids = new Map();
                        this._current = this._builder.buildRoot(this._ids);
                        this._errorCode = _xml_parser.XMLParserErrorCode.NoError;
                        this._whiteRegex = /^\s+$/;
                        this._nbsps = /\xa0+/g;
                        this._richText = richText;
                    }
                    parse(data) {
                        this.parseXml(data);
                        if (this._errorCode !== _xml_parser.XMLParserErrorCode.NoError) return undefined;
                        this._current[_symbol_utils.$finalize]();
                        return this._current.element;
                    }
                    onText(text) {
                        text = text.replace(this._nbsps, (match)=>match.slice(1) + " ");
                        if (this._richText || this._current[_symbol_utils.$acceptWhitespace]()) {
                            this._current[_symbol_utils.$onText](text, this._richText);
                            return;
                        }
                        if (this._whiteRegex.test(text)) return;
                        this._current[_symbol_utils.$onText](text.trim());
                    }
                    onCdata(text) {
                        this._current[_symbol_utils.$onText](text);
                    }
                    _mkAttributes(attributes, tagName) {
                        let namespace = null;
                        let prefixes = null;
                        const attributeObj = Object.create({});
                        for (const { name: name, value: value } of attributes){
                            if (name === "xmlns") {
                                if (!namespace) namespace = value;
                                else (0, _util.warn)(`XFA - multiple namespace definition in <${tagName}>`);
                            } else if (name.startsWith("xmlns:")) {
                                const prefix = name.substring(6);
                                if (!prefixes) prefixes = [];
                                prefixes.push({
                                    prefix: prefix,
                                    value: value
                                });
                            } else {
                                const i = name.indexOf(":");
                                if (i === -1) attributeObj[name] = value;
                                else {
                                    let nsAttrs = attributeObj[_symbol_utils.$nsAttributes];
                                    if (!nsAttrs) nsAttrs = attributeObj[_symbol_utils.$nsAttributes] = Object.create(null);
                                    const [ns, attrName] = [
                                        name.slice(0, i),
                                        name.slice(i + 1)
                                    ];
                                    const attrs = nsAttrs[ns] ||= Object.create(null);
                                    attrs[attrName] = value;
                                }
                            }
                        }
                        return [
                            namespace,
                            prefixes,
                            attributeObj
                        ];
                    }
                    _getNameAndPrefix(name, nsAgnostic) {
                        const i = name.indexOf(":");
                        if (i === -1) return [
                            name,
                            null
                        ];
                        return [
                            name.substring(i + 1),
                            nsAgnostic ? "" : name.substring(0, i)
                        ];
                    }
                    onBeginElement(tagName, attributes, isEmpty) {
                        const [namespace, prefixes, attributesObj] = this._mkAttributes(attributes, tagName);
                        const [name, nsPrefix] = this._getNameAndPrefix(tagName, this._builder.isNsAgnostic());
                        const node = this._builder.build({
                            nsPrefix: nsPrefix,
                            name: name,
                            attributes: attributesObj,
                            namespace: namespace,
                            prefixes: prefixes
                        });
                        node[_symbol_utils.$globalData] = this._globalData;
                        if (isEmpty) {
                            node[_symbol_utils.$finalize]();
                            if (this._current[_symbol_utils.$onChild](node)) node[_symbol_utils.$setId](this._ids);
                            node[_symbol_utils.$clean](this._builder);
                            return;
                        }
                        this._stack.push(this._current);
                        this._current = node;
                    }
                    onEndElement(name) {
                        const node = this._current;
                        if (node[_symbol_utils.$isCDATAXml]() && typeof node[_symbol_utils.$content] === "string") {
                            const parser = new XFAParser();
                            parser._globalData = this._globalData;
                            const root = parser.parse(node[_symbol_utils.$content]);
                            node[_symbol_utils.$content] = null;
                            node[_symbol_utils.$onChild](root);
                        }
                        node[_symbol_utils.$finalize]();
                        this._current = this._stack.pop();
                        if (this._current[_symbol_utils.$onChild](node)) node[_symbol_utils.$setId](this._ids);
                        node[_symbol_utils.$clean](this._builder);
                    }
                    onError(code) {
                        this._errorCode = code;
                    }
                }
                exports.XFAParser = XFAParser;
            /***/ },
            /* 91 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Builder = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _symbol_utils = __w_pdfjs_require__(78);
                var _setup = __w_pdfjs_require__(92);
                var _template = __w_pdfjs_require__(80);
                var _unknown = __w_pdfjs_require__(101);
                var _util = __w_pdfjs_require__(2);
                var _xfa_object = __w_pdfjs_require__(87);
                class Root extends _xfa_object.XFAObject {
                    constructor(ids){
                        super(-1, "root", Object.create(null));
                        this.element = null;
                        this[_symbol_utils.$ids] = ids;
                    }
                    [_symbol_utils.$onChild](child) {
                        this.element = child;
                        return true;
                    }
                    [_symbol_utils.$finalize]() {
                        super[_symbol_utils.$finalize]();
                        if (this.element.template instanceof _template.Template) {
                            this[_symbol_utils.$ids].set(_symbol_utils.$root, this.element);
                            this.element.template[_symbol_utils.$resolvePrototypes](this[_symbol_utils.$ids]);
                            this.element.template[_symbol_utils.$ids] = this[_symbol_utils.$ids];
                        }
                    }
                }
                class Empty extends _xfa_object.XFAObject {
                    constructor(){
                        super(-1, "", Object.create(null));
                    }
                    [_symbol_utils.$onChild](_) {
                        return false;
                    }
                }
                class Builder {
                    constructor(rootNameSpace = null){
                        this._namespaceStack = [];
                        this._nsAgnosticLevel = 0;
                        this._namespacePrefixes = new Map();
                        this._namespaces = new Map();
                        this._nextNsId = Math.max(...Object.values(_namespaces.NamespaceIds).map(({ id: id })=>id));
                        this._currentNamespace = rootNameSpace || new _unknown.UnknownNamespace(++this._nextNsId);
                    }
                    buildRoot(ids) {
                        return new Root(ids);
                    }
                    build({ nsPrefix: nsPrefix, name: name, attributes: attributes, namespace: namespace, prefixes: prefixes }) {
                        const hasNamespaceDef = namespace !== null;
                        if (hasNamespaceDef) {
                            this._namespaceStack.push(this._currentNamespace);
                            this._currentNamespace = this._searchNamespace(namespace);
                        }
                        if (prefixes) this._addNamespacePrefix(prefixes);
                        if (attributes.hasOwnProperty(_symbol_utils.$nsAttributes)) {
                            const dataTemplate = _setup.NamespaceSetUp.datasets;
                            const nsAttrs = attributes[_symbol_utils.$nsAttributes];
                            let xfaAttrs = null;
                            for (const [ns, attrs] of Object.entries(nsAttrs)){
                                const nsToUse = this._getNamespaceToUse(ns);
                                if (nsToUse === dataTemplate) {
                                    xfaAttrs = {
                                        xfa: attrs
                                    };
                                    break;
                                }
                            }
                            if (xfaAttrs) attributes[_symbol_utils.$nsAttributes] = xfaAttrs;
                            else delete attributes[_symbol_utils.$nsAttributes];
                        }
                        const namespaceToUse = this._getNamespaceToUse(nsPrefix);
                        const node = namespaceToUse?.[_namespaces.$buildXFAObject](name, attributes) || new Empty();
                        if (node[_symbol_utils.$isNsAgnostic]()) this._nsAgnosticLevel++;
                        if (hasNamespaceDef || prefixes || node[_symbol_utils.$isNsAgnostic]()) node[_symbol_utils.$cleanup] = {
                            hasNamespace: hasNamespaceDef,
                            prefixes: prefixes,
                            nsAgnostic: node[_symbol_utils.$isNsAgnostic]()
                        };
                        return node;
                    }
                    isNsAgnostic() {
                        return this._nsAgnosticLevel > 0;
                    }
                    _searchNamespace(nsName) {
                        let ns = this._namespaces.get(nsName);
                        if (ns) return ns;
                        for (const [name, { check: check }] of Object.entries(_namespaces.NamespaceIds))if (check(nsName)) {
                            ns = _setup.NamespaceSetUp[name];
                            if (ns) {
                                this._namespaces.set(nsName, ns);
                                return ns;
                            }
                            break;
                        }
                        ns = new _unknown.UnknownNamespace(++this._nextNsId);
                        this._namespaces.set(nsName, ns);
                        return ns;
                    }
                    _addNamespacePrefix(prefixes) {
                        for (const { prefix: prefix, value: value } of prefixes){
                            const namespace = this._searchNamespace(value);
                            let prefixStack = this._namespacePrefixes.get(prefix);
                            if (!prefixStack) {
                                prefixStack = [];
                                this._namespacePrefixes.set(prefix, prefixStack);
                            }
                            prefixStack.push(namespace);
                        }
                    }
                    _getNamespaceToUse(prefix) {
                        if (!prefix) return this._currentNamespace;
                        const prefixStack = this._namespacePrefixes.get(prefix);
                        if (prefixStack?.length > 0) return prefixStack.at(-1);
                        (0, _util.warn)(`Unknown namespace prefix: ${prefix}.`);
                        return null;
                    }
                    clean(data) {
                        const { hasNamespace: hasNamespace, prefixes: prefixes, nsAgnostic: nsAgnostic } = data;
                        if (hasNamespace) this._currentNamespace = this._namespaceStack.pop();
                        if (prefixes) prefixes.forEach(({ prefix: prefix })=>{
                            this._namespacePrefixes.get(prefix).pop();
                        });
                        if (nsAgnostic) this._nsAgnosticLevel--;
                    }
                }
                exports.Builder = Builder;
            /***/ },
            /* 92 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NamespaceSetUp = void 0;
                var _config = __w_pdfjs_require__(93);
                var _connection_set = __w_pdfjs_require__(94);
                var _datasets = __w_pdfjs_require__(95);
                var _locale_set = __w_pdfjs_require__(96);
                var _signature = __w_pdfjs_require__(97);
                var _stylesheet = __w_pdfjs_require__(98);
                var _template = __w_pdfjs_require__(80);
                var _xdp = __w_pdfjs_require__(99);
                var _xhtml = __w_pdfjs_require__(100);
                const NamespaceSetUp = {
                    config: _config.ConfigNamespace,
                    connection: _connection_set.ConnectionSetNamespace,
                    datasets: _datasets.DatasetsNamespace,
                    localeSet: _locale_set.LocaleSetNamespace,
                    signature: _signature.SignatureNamespace,
                    stylesheet: _stylesheet.StylesheetNamespace,
                    template: _template.TemplateNamespace,
                    xdp: _xdp.XdpNamespace,
                    xhtml: _xhtml.XhtmlNamespace
                };
                exports.NamespaceSetUp = NamespaceSetUp;
            /***/ },
            /* 93 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ConfigNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _symbol_utils = __w_pdfjs_require__(78);
                var _xfa_object = __w_pdfjs_require__(87);
                var _utils = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                const CONFIG_NS_ID = _namespaces.NamespaceIds.config.id;
                class Acrobat extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "acrobat", true);
                        this.acrobat7 = null;
                        this.autoSave = null;
                        this.common = null;
                        this.validate = null;
                        this.validateApprovalSignatures = null;
                        this.submitUrl = new _xfa_object.XFAObjectArray();
                    }
                }
                class Acrobat7 extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "acrobat7", true);
                        this.dynamicRender = null;
                    }
                }
                class ADBE_JSConsole extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ADBE_JSConsole", [
                            "delegate",
                            "Enable",
                            "Disable"
                        ]);
                    }
                }
                class ADBE_JSDebugger extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ADBE_JSDebugger", [
                            "delegate",
                            "Enable",
                            "Disable"
                        ]);
                    }
                }
                class AddSilentPrint extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "addSilentPrint");
                    }
                }
                class AddViewerPreferences extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "addViewerPreferences");
                    }
                }
                class AdjustData extends _xfa_object.Option10 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "adjustData");
                    }
                }
                class AdobeExtensionLevel extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "adobeExtensionLevel", 0, (n)=>n >= 1 && n <= 8);
                    }
                }
                class Agent extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "agent", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.common = new _xfa_object.XFAObjectArray();
                    }
                }
                class AlwaysEmbed extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "alwaysEmbed");
                    }
                }
                class Amd extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "amd");
                    }
                }
                class Area extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "area");
                        this.level = (0, _utils.getInteger)({
                            data: attributes.level,
                            defaultValue: 0,
                            validate: (n)=>n >= 1 && n <= 3
                        });
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "",
                            "barcode",
                            "coreinit",
                            "deviceDriver",
                            "font",
                            "general",
                            "layout",
                            "merge",
                            "script",
                            "signature",
                            "sourceSet",
                            "templateCache"
                        ]);
                    }
                }
                class Attributes extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "attributes", [
                            "preserve",
                            "delegate",
                            "ignore"
                        ]);
                    }
                }
                class AutoSave extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "autoSave", [
                            "disabled",
                            "enabled"
                        ]);
                    }
                }
                class Base extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "base");
                    }
                }
                class BatchOutput extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "batchOutput");
                        this.format = (0, _utils.getStringOption)(attributes.format, [
                            "none",
                            "concat",
                            "zip",
                            "zipCompress"
                        ]);
                    }
                }
                class BehaviorOverride extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "behaviorOverride");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = new Map(this[_symbol_utils.$content].trim().split(/\s+/).filter((x)=>x.includes(":")).map((x)=>x.split(":", 2)));
                    }
                }
                class Cache extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "cache", true);
                        this.templateCache = null;
                    }
                }
                class Change extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "change");
                    }
                }
                class Common extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "common", true);
                        this.data = null;
                        this.locale = null;
                        this.localeSet = null;
                        this.messaging = null;
                        this.suppressBanner = null;
                        this.template = null;
                        this.validationMessaging = null;
                        this.versionControl = null;
                        this.log = new _xfa_object.XFAObjectArray();
                    }
                }
                class Compress extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compress");
                        this.scope = (0, _utils.getStringOption)(attributes.scope, [
                            "imageOnly",
                            "document"
                        ]);
                    }
                }
                class CompressLogicalStructure extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compressLogicalStructure");
                    }
                }
                class CompressObjectStream extends _xfa_object.Option10 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compressObjectStream");
                    }
                }
                class Compression extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compression", true);
                        this.compressLogicalStructure = null;
                        this.compressObjectStream = null;
                        this.level = null;
                        this.type = null;
                    }
                }
                class Config extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "config", true);
                        this.acrobat = null;
                        this.present = null;
                        this.trace = null;
                        this.agent = new _xfa_object.XFAObjectArray();
                    }
                }
                class Conformance extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "conformance", [
                            "A",
                            "B"
                        ]);
                    }
                }
                class ContentCopy extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "contentCopy");
                    }
                }
                class Copies extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "copies", 1, (n)=>n >= 1);
                    }
                }
                class Creator extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "creator");
                    }
                }
                class CurrentPage extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "currentPage", 0, (n)=>n >= 0);
                    }
                }
                class Data extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "data", true);
                        this.adjustData = null;
                        this.attributes = null;
                        this.incrementalLoad = null;
                        this.outputXSL = null;
                        this.range = null;
                        this.record = null;
                        this.startNode = null;
                        this.uri = null;
                        this.window = null;
                        this.xsl = null;
                        this.excludeNS = new _xfa_object.XFAObjectArray();
                        this.transform = new _xfa_object.XFAObjectArray();
                    }
                }
                class Debug extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "debug", true);
                        this.uri = null;
                    }
                }
                class DefaultTypeface extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "defaultTypeface");
                        this.writingScript = (0, _utils.getStringOption)(attributes.writingScript, [
                            "*",
                            "Arabic",
                            "Cyrillic",
                            "EastEuropeanRoman",
                            "Greek",
                            "Hebrew",
                            "Japanese",
                            "Korean",
                            "Roman",
                            "SimplifiedChinese",
                            "Thai",
                            "TraditionalChinese",
                            "Vietnamese"
                        ]);
                    }
                }
                class Destination extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "destination", [
                            "pdf",
                            "pcl",
                            "ps",
                            "webClient",
                            "zpl"
                        ]);
                    }
                }
                class DocumentAssembly extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "documentAssembly");
                    }
                }
                class Driver extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "driver", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class DuplexOption extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "duplexOption", [
                            "simplex",
                            "duplexFlipLongEdge",
                            "duplexFlipShortEdge"
                        ]);
                    }
                }
                class DynamicRender extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "dynamicRender", [
                            "forbidden",
                            "required"
                        ]);
                    }
                }
                class Embed extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "embed");
                    }
                }
                class Encrypt extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "encrypt");
                    }
                }
                class Encryption extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "encryption", true);
                        this.encrypt = null;
                        this.encryptionLevel = null;
                        this.permissions = null;
                    }
                }
                class EncryptionLevel extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "encryptionLevel", [
                            "40bit",
                            "128bit"
                        ]);
                    }
                }
                class Enforce extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "enforce");
                    }
                }
                class Equate extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "equate");
                        this.force = (0, _utils.getInteger)({
                            data: attributes.force,
                            defaultValue: 1,
                            validate: (n)=>n === 0
                        });
                        this.from = attributes.from || "";
                        this.to = attributes.to || "";
                    }
                }
                class EquateRange extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "equateRange");
                        this.from = attributes.from || "";
                        this.to = attributes.to || "";
                        this._unicodeRange = attributes.unicodeRange || "";
                    }
                    get unicodeRange() {
                        const ranges = [];
                        const unicodeRegex = /U\+([0-9a-fA-F]+)/;
                        const unicodeRange = this._unicodeRange;
                        for (let range of unicodeRange.split(",").map((x)=>x.trim()).filter((x)=>!!x)){
                            range = range.split("-", 2).map((x)=>{
                                const found = x.match(unicodeRegex);
                                if (!found) return 0;
                                return parseInt(found[1], 16);
                            });
                            if (range.length === 1) range.push(range[0]);
                            ranges.push(range);
                        }
                        return (0, _util.shadow)(this, "unicodeRange", ranges);
                    }
                }
                class Exclude extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "exclude");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/).filter((x)=>x && [
                                "calculate",
                                "close",
                                "enter",
                                "exit",
                                "initialize",
                                "ready",
                                "validate"
                            ].includes(x));
                    }
                }
                class ExcludeNS extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "excludeNS");
                    }
                }
                class FlipLabel extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "flipLabel", [
                            "usePrinterSetting",
                            "on",
                            "off"
                        ]);
                    }
                }
                class FontInfo extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "fontInfo", true);
                        this.embed = null;
                        this.map = null;
                        this.subsetBelow = null;
                        this.alwaysEmbed = new _xfa_object.XFAObjectArray();
                        this.defaultTypeface = new _xfa_object.XFAObjectArray();
                        this.neverEmbed = new _xfa_object.XFAObjectArray();
                    }
                }
                class FormFieldFilling extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "formFieldFilling");
                    }
                }
                class GroupParent extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "groupParent");
                    }
                }
                class IfEmpty extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ifEmpty", [
                            "dataValue",
                            "dataGroup",
                            "ignore",
                            "remove"
                        ]);
                    }
                }
                class IncludeXDPContent extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "includeXDPContent");
                    }
                }
                class IncrementalLoad extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "incrementalLoad", [
                            "none",
                            "forwardOnly"
                        ]);
                    }
                }
                class IncrementalMerge extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "incrementalMerge");
                    }
                }
                class Interactive extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "interactive");
                    }
                }
                class Jog extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "jog", [
                            "usePrinterSetting",
                            "none",
                            "pageSet"
                        ]);
                    }
                }
                class LabelPrinter extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "labelPrinter", true);
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "zpl",
                            "dpl",
                            "ipl",
                            "tcpl"
                        ]);
                        this.batchOutput = null;
                        this.flipLabel = null;
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class Layout extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "layout", [
                            "paginate",
                            "panel"
                        ]);
                    }
                }
                class Level extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "level", 0, (n)=>n > 0);
                    }
                }
                class Linearized extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "linearized");
                    }
                }
                class Locale extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "locale");
                    }
                }
                class LocaleSet extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "localeSet");
                    }
                }
                class Log extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "log", true);
                        this.mode = null;
                        this.threshold = null;
                        this.to = null;
                        this.uri = null;
                    }
                }
                class MapElement extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "map", true);
                        this.equate = new _xfa_object.XFAObjectArray();
                        this.equateRange = new _xfa_object.XFAObjectArray();
                    }
                }
                class MediumInfo extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "mediumInfo", true);
                        this.map = null;
                    }
                }
                class Message extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "message", true);
                        this.msgId = null;
                        this.severity = null;
                    }
                }
                class Messaging extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "messaging", true);
                        this.message = new _xfa_object.XFAObjectArray();
                    }
                }
                class Mode extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "mode", [
                            "append",
                            "overwrite"
                        ]);
                    }
                }
                class ModifyAnnots extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "modifyAnnots");
                    }
                }
                class MsgId extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "msgId", 1, (n)=>n >= 1);
                    }
                }
                class NameAttr extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "nameAttr");
                    }
                }
                class NeverEmbed extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "neverEmbed");
                    }
                }
                class NumberOfCopies extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "numberOfCopies", null, (n)=>n >= 2 && n <= 5);
                    }
                }
                class OpenAction extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "openAction", true);
                        this.destination = null;
                    }
                }
                class Output extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "output", true);
                        this.to = null;
                        this.type = null;
                        this.uri = null;
                    }
                }
                class OutputBin extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "outputBin");
                    }
                }
                class OutputXSL extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "outputXSL", true);
                        this.uri = null;
                    }
                }
                class Overprint extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "overprint", [
                            "none",
                            "both",
                            "draw",
                            "field"
                        ]);
                    }
                }
                class Packets extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "packets");
                    }
                    [_symbol_utils.$finalize]() {
                        if (this[_symbol_utils.$content] === "*") return;
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/).filter((x)=>[
                                "config",
                                "datasets",
                                "template",
                                "xfdf",
                                "xslt"
                            ].includes(x));
                    }
                }
                class PageOffset extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pageOffset");
                        this.x = (0, _utils.getInteger)({
                            data: attributes.x,
                            defaultValue: "useXDCSetting",
                            validate: (n)=>true
                        });
                        this.y = (0, _utils.getInteger)({
                            data: attributes.y,
                            defaultValue: "useXDCSetting",
                            validate: (n)=>true
                        });
                    }
                }
                class PageRange extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pageRange");
                    }
                    [_symbol_utils.$finalize]() {
                        const numbers = this[_symbol_utils.$content].trim().split(/\s+/).map((x)=>parseInt(x, 10));
                        const ranges = [];
                        for(let i = 0, ii = numbers.length; i < ii; i += 2)ranges.push(numbers.slice(i, i + 2));
                        this[_symbol_utils.$content] = ranges;
                    }
                }
                class Pagination extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pagination", [
                            "simplex",
                            "duplexShortEdge",
                            "duplexLongEdge"
                        ]);
                    }
                }
                class PaginationOverride extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "paginationOverride", [
                            "none",
                            "forceDuplex",
                            "forceDuplexLongEdge",
                            "forceDuplexShortEdge",
                            "forceSimplex"
                        ]);
                    }
                }
                class Part extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "part", 1, (n)=>false);
                    }
                }
                class Pcl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pcl", true);
                        this.name = attributes.name || "";
                        this.batchOutput = null;
                        this.fontInfo = null;
                        this.jog = null;
                        this.mediumInfo = null;
                        this.outputBin = null;
                        this.pageOffset = null;
                        this.staple = null;
                        this.xdc = null;
                    }
                }
                class Pdf extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pdf", true);
                        this.name = attributes.name || "";
                        this.adobeExtensionLevel = null;
                        this.batchOutput = null;
                        this.compression = null;
                        this.creator = null;
                        this.encryption = null;
                        this.fontInfo = null;
                        this.interactive = null;
                        this.linearized = null;
                        this.openAction = null;
                        this.pdfa = null;
                        this.producer = null;
                        this.renderPolicy = null;
                        this.scriptModel = null;
                        this.silentPrint = null;
                        this.submitFormat = null;
                        this.tagged = null;
                        this.version = null;
                        this.viewerPreferences = null;
                        this.xdc = null;
                    }
                }
                class Pdfa extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pdfa", true);
                        this.amd = null;
                        this.conformance = null;
                        this.includeXDPContent = null;
                        this.part = null;
                    }
                }
                class Permissions extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "permissions", true);
                        this.accessibleContent = null;
                        this.change = null;
                        this.contentCopy = null;
                        this.documentAssembly = null;
                        this.formFieldFilling = null;
                        this.modifyAnnots = null;
                        this.plaintextMetadata = null;
                        this.print = null;
                        this.printHighQuality = null;
                    }
                }
                class PickTrayByPDFSize extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pickTrayByPDFSize");
                    }
                }
                class Picture extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "picture");
                    }
                }
                class PlaintextMetadata extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "plaintextMetadata");
                    }
                }
                class Presence extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "presence", [
                            "preserve",
                            "dissolve",
                            "dissolveStructure",
                            "ignore",
                            "remove"
                        ]);
                    }
                }
                class Present extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "present", true);
                        this.behaviorOverride = null;
                        this.cache = null;
                        this.common = null;
                        this.copies = null;
                        this.destination = null;
                        this.incrementalMerge = null;
                        this.layout = null;
                        this.output = null;
                        this.overprint = null;
                        this.pagination = null;
                        this.paginationOverride = null;
                        this.script = null;
                        this.validate = null;
                        this.xdp = null;
                        this.driver = new _xfa_object.XFAObjectArray();
                        this.labelPrinter = new _xfa_object.XFAObjectArray();
                        this.pcl = new _xfa_object.XFAObjectArray();
                        this.pdf = new _xfa_object.XFAObjectArray();
                        this.ps = new _xfa_object.XFAObjectArray();
                        this.submitUrl = new _xfa_object.XFAObjectArray();
                        this.webClient = new _xfa_object.XFAObjectArray();
                        this.zpl = new _xfa_object.XFAObjectArray();
                    }
                }
                class Print extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "print");
                    }
                }
                class PrintHighQuality extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "printHighQuality");
                    }
                }
                class PrintScaling extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "printScaling", [
                            "appdefault",
                            "noScaling"
                        ]);
                    }
                }
                class PrinterName extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "printerName");
                    }
                }
                class Producer extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "producer");
                    }
                }
                class Ps extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ps", true);
                        this.name = attributes.name || "";
                        this.batchOutput = null;
                        this.fontInfo = null;
                        this.jog = null;
                        this.mediumInfo = null;
                        this.outputBin = null;
                        this.staple = null;
                        this.xdc = null;
                    }
                }
                class Range extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "range");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s*,\s*/, 2).map((range)=>range.split("-").map((x)=>parseInt(x.trim(), 10))).filter((range)=>range.every((x)=>!isNaN(x))).map((range)=>{
                            if (range.length === 1) range.push(range[0]);
                            return range;
                        });
                    }
                }
                class Record extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "record");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim();
                        const n = parseInt(this[_symbol_utils.$content], 10);
                        if (!isNaN(n) && n >= 0) this[_symbol_utils.$content] = n;
                    }
                }
                class Relevant extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "relevant");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/);
                    }
                }
                class Rename extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "rename");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim();
                        if (this[_symbol_utils.$content].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[_symbol_utils.$content])) (0, _util.warn)("XFA - Rename: invalid XFA name");
                    }
                }
                class RenderPolicy extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "renderPolicy", [
                            "server",
                            "client"
                        ]);
                    }
                }
                class RunScripts extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "runScripts", [
                            "both",
                            "client",
                            "none",
                            "server"
                        ]);
                    }
                }
                class Script extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "script", true);
                        this.currentPage = null;
                        this.exclude = null;
                        this.runScripts = null;
                    }
                }
                class ScriptModel extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "scriptModel", [
                            "XFA",
                            "none"
                        ]);
                    }
                }
                class Severity extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "severity", [
                            "ignore",
                            "error",
                            "information",
                            "trace",
                            "warning"
                        ]);
                    }
                }
                class SilentPrint extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "silentPrint", true);
                        this.addSilentPrint = null;
                        this.printerName = null;
                    }
                }
                class Staple extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "staple");
                        this.mode = (0, _utils.getStringOption)(attributes.mode, [
                            "usePrinterSetting",
                            "on",
                            "off"
                        ]);
                    }
                }
                class StartNode extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "startNode");
                    }
                }
                class StartPage extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "startPage", 0, (n)=>true);
                    }
                }
                class SubmitFormat extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "submitFormat", [
                            "html",
                            "delegate",
                            "fdf",
                            "xml",
                            "pdf"
                        ]);
                    }
                }
                class SubmitUrl extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "submitUrl");
                    }
                }
                class SubsetBelow extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "subsetBelow", 100, (n)=>n >= 0 && n <= 100);
                    }
                }
                class SuppressBanner extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "suppressBanner");
                    }
                }
                class Tagged extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "tagged");
                    }
                }
                class Template extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "template", true);
                        this.base = null;
                        this.relevant = null;
                        this.startPage = null;
                        this.uri = null;
                        this.xsl = null;
                    }
                }
                class Threshold extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "threshold", [
                            "trace",
                            "error",
                            "information",
                            "warning"
                        ]);
                    }
                }
                class To extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "to", [
                            "null",
                            "memory",
                            "stderr",
                            "stdout",
                            "system",
                            "uri"
                        ]);
                    }
                }
                class TemplateCache extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "templateCache");
                        this.maxEntries = (0, _utils.getInteger)({
                            data: attributes.maxEntries,
                            defaultValue: 5,
                            validate: (n)=>n >= 0
                        });
                    }
                }
                class Trace extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "trace", true);
                        this.area = new _xfa_object.XFAObjectArray();
                    }
                }
                class Transform extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "transform", true);
                        this.groupParent = null;
                        this.ifEmpty = null;
                        this.nameAttr = null;
                        this.picture = null;
                        this.presence = null;
                        this.rename = null;
                        this.whitespace = null;
                    }
                }
                class Type extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "type", [
                            "none",
                            "ascii85",
                            "asciiHex",
                            "ccittfax",
                            "flate",
                            "lzw",
                            "runLength",
                            "native",
                            "xdp",
                            "mergedXDP"
                        ]);
                    }
                }
                class Uri extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "uri");
                    }
                }
                class Validate extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "validate", [
                            "preSubmit",
                            "prePrint",
                            "preExecute",
                            "preSave"
                        ]);
                    }
                }
                class ValidateApprovalSignatures extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "validateApprovalSignatures");
                    }
                    [_symbol_utils.$finalize]() {
                        this[_symbol_utils.$content] = this[_symbol_utils.$content].trim().split(/\s+/).filter((x)=>[
                                "docReady",
                                "postSign"
                            ].includes(x));
                    }
                }
                class ValidationMessaging extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "validationMessaging", [
                            "allMessagesIndividually",
                            "allMessagesTogether",
                            "firstMessageOnly",
                            "noMessages"
                        ]);
                    }
                }
                class Version extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "version", [
                            "1.7",
                            "1.6",
                            "1.5",
                            "1.4",
                            "1.3",
                            "1.2"
                        ]);
                    }
                }
                class VersionControl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "VersionControl");
                        this.outputBelow = (0, _utils.getStringOption)(attributes.outputBelow, [
                            "warn",
                            "error",
                            "update"
                        ]);
                        this.sourceAbove = (0, _utils.getStringOption)(attributes.sourceAbove, [
                            "warn",
                            "error"
                        ]);
                        this.sourceBelow = (0, _utils.getStringOption)(attributes.sourceBelow, [
                            "update",
                            "maintain"
                        ]);
                    }
                }
                class ViewerPreferences extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "viewerPreferences", true);
                        this.ADBE_JSConsole = null;
                        this.ADBE_JSDebugger = null;
                        this.addViewerPreferences = null;
                        this.duplexOption = null;
                        this.enforce = null;
                        this.numberOfCopies = null;
                        this.pageRange = null;
                        this.pickTrayByPDFSize = null;
                        this.printScaling = null;
                    }
                }
                class WebClient extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "webClient", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class Whitespace extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "whitespace", [
                            "preserve",
                            "ltrim",
                            "normalize",
                            "rtrim",
                            "trim"
                        ]);
                    }
                }
                class Window extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "window");
                    }
                    [_symbol_utils.$finalize]() {
                        const pair = this[_symbol_utils.$content].trim().split(/\s*,\s*/, 2).map((x)=>parseInt(x, 10));
                        if (pair.some((x)=>isNaN(x))) {
                            this[_symbol_utils.$content] = [
                                0,
                                0
                            ];
                            return;
                        }
                        if (pair.length === 1) pair.push(pair[0]);
                        this[_symbol_utils.$content] = pair;
                    }
                }
                class Xdc extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "xdc", true);
                        this.uri = new _xfa_object.XFAObjectArray();
                        this.xsl = new _xfa_object.XFAObjectArray();
                    }
                }
                class Xdp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "xdp", true);
                        this.packets = null;
                    }
                }
                class Xsl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "xsl", true);
                        this.debug = null;
                        this.uri = null;
                    }
                }
                class Zpl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "zpl", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.batchOutput = null;
                        this.flipLabel = null;
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class ConfigNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (ConfigNamespace.hasOwnProperty(name)) return ConfigNamespace[name](attributes);
                        return undefined;
                    }
                    static acrobat(attrs) {
                        return new Acrobat(attrs);
                    }
                    static acrobat7(attrs) {
                        return new Acrobat7(attrs);
                    }
                    static ADBE_JSConsole(attrs) {
                        return new ADBE_JSConsole(attrs);
                    }
                    static ADBE_JSDebugger(attrs) {
                        return new ADBE_JSDebugger(attrs);
                    }
                    static addSilentPrint(attrs) {
                        return new AddSilentPrint(attrs);
                    }
                    static addViewerPreferences(attrs) {
                        return new AddViewerPreferences(attrs);
                    }
                    static adjustData(attrs) {
                        return new AdjustData(attrs);
                    }
                    static adobeExtensionLevel(attrs) {
                        return new AdobeExtensionLevel(attrs);
                    }
                    static agent(attrs) {
                        return new Agent(attrs);
                    }
                    static alwaysEmbed(attrs) {
                        return new AlwaysEmbed(attrs);
                    }
                    static amd(attrs) {
                        return new Amd(attrs);
                    }
                    static area(attrs) {
                        return new Area(attrs);
                    }
                    static attributes(attrs) {
                        return new Attributes(attrs);
                    }
                    static autoSave(attrs) {
                        return new AutoSave(attrs);
                    }
                    static base(attrs) {
                        return new Base(attrs);
                    }
                    static batchOutput(attrs) {
                        return new BatchOutput(attrs);
                    }
                    static behaviorOverride(attrs) {
                        return new BehaviorOverride(attrs);
                    }
                    static cache(attrs) {
                        return new Cache(attrs);
                    }
                    static change(attrs) {
                        return new Change(attrs);
                    }
                    static common(attrs) {
                        return new Common(attrs);
                    }
                    static compress(attrs) {
                        return new Compress(attrs);
                    }
                    static compressLogicalStructure(attrs) {
                        return new CompressLogicalStructure(attrs);
                    }
                    static compressObjectStream(attrs) {
                        return new CompressObjectStream(attrs);
                    }
                    static compression(attrs) {
                        return new Compression(attrs);
                    }
                    static config(attrs) {
                        return new Config(attrs);
                    }
                    static conformance(attrs) {
                        return new Conformance(attrs);
                    }
                    static contentCopy(attrs) {
                        return new ContentCopy(attrs);
                    }
                    static copies(attrs) {
                        return new Copies(attrs);
                    }
                    static creator(attrs) {
                        return new Creator(attrs);
                    }
                    static currentPage(attrs) {
                        return new CurrentPage(attrs);
                    }
                    static data(attrs) {
                        return new Data(attrs);
                    }
                    static debug(attrs) {
                        return new Debug(attrs);
                    }
                    static defaultTypeface(attrs) {
                        return new DefaultTypeface(attrs);
                    }
                    static destination(attrs) {
                        return new Destination(attrs);
                    }
                    static documentAssembly(attrs) {
                        return new DocumentAssembly(attrs);
                    }
                    static driver(attrs) {
                        return new Driver(attrs);
                    }
                    static duplexOption(attrs) {
                        return new DuplexOption(attrs);
                    }
                    static dynamicRender(attrs) {
                        return new DynamicRender(attrs);
                    }
                    static embed(attrs) {
                        return new Embed(attrs);
                    }
                    static encrypt(attrs) {
                        return new Encrypt(attrs);
                    }
                    static encryption(attrs) {
                        return new Encryption(attrs);
                    }
                    static encryptionLevel(attrs) {
                        return new EncryptionLevel(attrs);
                    }
                    static enforce(attrs) {
                        return new Enforce(attrs);
                    }
                    static equate(attrs) {
                        return new Equate(attrs);
                    }
                    static equateRange(attrs) {
                        return new EquateRange(attrs);
                    }
                    static exclude(attrs) {
                        return new Exclude(attrs);
                    }
                    static excludeNS(attrs) {
                        return new ExcludeNS(attrs);
                    }
                    static flipLabel(attrs) {
                        return new FlipLabel(attrs);
                    }
                    static fontInfo(attrs) {
                        return new FontInfo(attrs);
                    }
                    static formFieldFilling(attrs) {
                        return new FormFieldFilling(attrs);
                    }
                    static groupParent(attrs) {
                        return new GroupParent(attrs);
                    }
                    static ifEmpty(attrs) {
                        return new IfEmpty(attrs);
                    }
                    static includeXDPContent(attrs) {
                        return new IncludeXDPContent(attrs);
                    }
                    static incrementalLoad(attrs) {
                        return new IncrementalLoad(attrs);
                    }
                    static incrementalMerge(attrs) {
                        return new IncrementalMerge(attrs);
                    }
                    static interactive(attrs) {
                        return new Interactive(attrs);
                    }
                    static jog(attrs) {
                        return new Jog(attrs);
                    }
                    static labelPrinter(attrs) {
                        return new LabelPrinter(attrs);
                    }
                    static layout(attrs) {
                        return new Layout(attrs);
                    }
                    static level(attrs) {
                        return new Level(attrs);
                    }
                    static linearized(attrs) {
                        return new Linearized(attrs);
                    }
                    static locale(attrs) {
                        return new Locale(attrs);
                    }
                    static localeSet(attrs) {
                        return new LocaleSet(attrs);
                    }
                    static log(attrs) {
                        return new Log(attrs);
                    }
                    static map(attrs) {
                        return new MapElement(attrs);
                    }
                    static mediumInfo(attrs) {
                        return new MediumInfo(attrs);
                    }
                    static message(attrs) {
                        return new Message(attrs);
                    }
                    static messaging(attrs) {
                        return new Messaging(attrs);
                    }
                    static mode(attrs) {
                        return new Mode(attrs);
                    }
                    static modifyAnnots(attrs) {
                        return new ModifyAnnots(attrs);
                    }
                    static msgId(attrs) {
                        return new MsgId(attrs);
                    }
                    static nameAttr(attrs) {
                        return new NameAttr(attrs);
                    }
                    static neverEmbed(attrs) {
                        return new NeverEmbed(attrs);
                    }
                    static numberOfCopies(attrs) {
                        return new NumberOfCopies(attrs);
                    }
                    static openAction(attrs) {
                        return new OpenAction(attrs);
                    }
                    static output(attrs) {
                        return new Output(attrs);
                    }
                    static outputBin(attrs) {
                        return new OutputBin(attrs);
                    }
                    static outputXSL(attrs) {
                        return new OutputXSL(attrs);
                    }
                    static overprint(attrs) {
                        return new Overprint(attrs);
                    }
                    static packets(attrs) {
                        return new Packets(attrs);
                    }
                    static pageOffset(attrs) {
                        return new PageOffset(attrs);
                    }
                    static pageRange(attrs) {
                        return new PageRange(attrs);
                    }
                    static pagination(attrs) {
                        return new Pagination(attrs);
                    }
                    static paginationOverride(attrs) {
                        return new PaginationOverride(attrs);
                    }
                    static part(attrs) {
                        return new Part(attrs);
                    }
                    static pcl(attrs) {
                        return new Pcl(attrs);
                    }
                    static pdf(attrs) {
                        return new Pdf(attrs);
                    }
                    static pdfa(attrs) {
                        return new Pdfa(attrs);
                    }
                    static permissions(attrs) {
                        return new Permissions(attrs);
                    }
                    static pickTrayByPDFSize(attrs) {
                        return new PickTrayByPDFSize(attrs);
                    }
                    static picture(attrs) {
                        return new Picture(attrs);
                    }
                    static plaintextMetadata(attrs) {
                        return new PlaintextMetadata(attrs);
                    }
                    static presence(attrs) {
                        return new Presence(attrs);
                    }
                    static present(attrs) {
                        return new Present(attrs);
                    }
                    static print(attrs) {
                        return new Print(attrs);
                    }
                    static printHighQuality(attrs) {
                        return new PrintHighQuality(attrs);
                    }
                    static printScaling(attrs) {
                        return new PrintScaling(attrs);
                    }
                    static printerName(attrs) {
                        return new PrinterName(attrs);
                    }
                    static producer(attrs) {
                        return new Producer(attrs);
                    }
                    static ps(attrs) {
                        return new Ps(attrs);
                    }
                    static range(attrs) {
                        return new Range(attrs);
                    }
                    static record(attrs) {
                        return new Record(attrs);
                    }
                    static relevant(attrs) {
                        return new Relevant(attrs);
                    }
                    static rename(attrs) {
                        return new Rename(attrs);
                    }
                    static renderPolicy(attrs) {
                        return new RenderPolicy(attrs);
                    }
                    static runScripts(attrs) {
                        return new RunScripts(attrs);
                    }
                    static script(attrs) {
                        return new Script(attrs);
                    }
                    static scriptModel(attrs) {
                        return new ScriptModel(attrs);
                    }
                    static severity(attrs) {
                        return new Severity(attrs);
                    }
                    static silentPrint(attrs) {
                        return new SilentPrint(attrs);
                    }
                    static staple(attrs) {
                        return new Staple(attrs);
                    }
                    static startNode(attrs) {
                        return new StartNode(attrs);
                    }
                    static startPage(attrs) {
                        return new StartPage(attrs);
                    }
                    static submitFormat(attrs) {
                        return new SubmitFormat(attrs);
                    }
                    static submitUrl(attrs) {
                        return new SubmitUrl(attrs);
                    }
                    static subsetBelow(attrs) {
                        return new SubsetBelow(attrs);
                    }
                    static suppressBanner(attrs) {
                        return new SuppressBanner(attrs);
                    }
                    static tagged(attrs) {
                        return new Tagged(attrs);
                    }
                    static template(attrs) {
                        return new Template(attrs);
                    }
                    static templateCache(attrs) {
                        return new TemplateCache(attrs);
                    }
                    static threshold(attrs) {
                        return new Threshold(attrs);
                    }
                    static to(attrs) {
                        return new To(attrs);
                    }
                    static trace(attrs) {
                        return new Trace(attrs);
                    }
                    static transform(attrs) {
                        return new Transform(attrs);
                    }
                    static type(attrs) {
                        return new Type(attrs);
                    }
                    static uri(attrs) {
                        return new Uri(attrs);
                    }
                    static validate(attrs) {
                        return new Validate(attrs);
                    }
                    static validateApprovalSignatures(attrs) {
                        return new ValidateApprovalSignatures(attrs);
                    }
                    static validationMessaging(attrs) {
                        return new ValidationMessaging(attrs);
                    }
                    static version(attrs) {
                        return new Version(attrs);
                    }
                    static versionControl(attrs) {
                        return new VersionControl(attrs);
                    }
                    static viewerPreferences(attrs) {
                        return new ViewerPreferences(attrs);
                    }
                    static webClient(attrs) {
                        return new WebClient(attrs);
                    }
                    static whitespace(attrs) {
                        return new Whitespace(attrs);
                    }
                    static window(attrs) {
                        return new Window(attrs);
                    }
                    static xdc(attrs) {
                        return new Xdc(attrs);
                    }
                    static xdp(attrs) {
                        return new Xdp(attrs);
                    }
                    static xsl(attrs) {
                        return new Xsl(attrs);
                    }
                    static zpl(attrs) {
                        return new Zpl(attrs);
                    }
                }
                exports.ConfigNamespace = ConfigNamespace;
            /***/ },
            /* 94 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ConnectionSetNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                const CONNECTION_SET_NS_ID = _namespaces.NamespaceIds.connectionSet.id;
                class ConnectionSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "connectionSet", true);
                        this.wsdlConnection = new _xfa_object.XFAObjectArray();
                        this.xmlConnection = new _xfa_object.XFAObjectArray();
                        this.xsdConnection = new _xfa_object.XFAObjectArray();
                    }
                }
                class EffectiveInputPolicy extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "effectiveInputPolicy");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class EffectiveOutputPolicy extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "effectiveOutputPolicy");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Operation extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "operation");
                        this.id = attributes.id || "";
                        this.input = attributes.input || "";
                        this.name = attributes.name || "";
                        this.output = attributes.output || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class RootElement extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "rootElement");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class SoapAction extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "soapAction");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class SoapAddress extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "soapAddress");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Uri extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "uri");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class WsdlAddress extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "wsdlAddress");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class WsdlConnection extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "wsdlConnection", true);
                        this.dataDescription = attributes.dataDescription || "";
                        this.name = attributes.name || "";
                        this.effectiveInputPolicy = null;
                        this.effectiveOutputPolicy = null;
                        this.operation = null;
                        this.soapAction = null;
                        this.soapAddress = null;
                        this.wsdlAddress = null;
                    }
                }
                class XmlConnection extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "xmlConnection", true);
                        this.dataDescription = attributes.dataDescription || "";
                        this.name = attributes.name || "";
                        this.uri = null;
                    }
                }
                class XsdConnection extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "xsdConnection", true);
                        this.dataDescription = attributes.dataDescription || "";
                        this.name = attributes.name || "";
                        this.rootElement = null;
                        this.uri = null;
                    }
                }
                class ConnectionSetNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (ConnectionSetNamespace.hasOwnProperty(name)) return ConnectionSetNamespace[name](attributes);
                        return undefined;
                    }
                    static connectionSet(attrs) {
                        return new ConnectionSet(attrs);
                    }
                    static effectiveInputPolicy(attrs) {
                        return new EffectiveInputPolicy(attrs);
                    }
                    static effectiveOutputPolicy(attrs) {
                        return new EffectiveOutputPolicy(attrs);
                    }
                    static operation(attrs) {
                        return new Operation(attrs);
                    }
                    static rootElement(attrs) {
                        return new RootElement(attrs);
                    }
                    static soapAction(attrs) {
                        return new SoapAction(attrs);
                    }
                    static soapAddress(attrs) {
                        return new SoapAddress(attrs);
                    }
                    static uri(attrs) {
                        return new Uri(attrs);
                    }
                    static wsdlAddress(attrs) {
                        return new WsdlAddress(attrs);
                    }
                    static wsdlConnection(attrs) {
                        return new WsdlConnection(attrs);
                    }
                    static xmlConnection(attrs) {
                        return new XmlConnection(attrs);
                    }
                    static xsdConnection(attrs) {
                        return new XsdConnection(attrs);
                    }
                }
                exports.ConnectionSetNamespace = ConnectionSetNamespace;
            /***/ },
            /* 95 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DatasetsNamespace = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                const DATASETS_NS_ID = _namespaces.NamespaceIds.datasets.id;
                class Data extends _xfa_object.XmlObject {
                    constructor(attributes){
                        super(DATASETS_NS_ID, "data", attributes);
                    }
                    [_symbol_utils.$isNsAgnostic]() {
                        return true;
                    }
                }
                class Datasets extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(DATASETS_NS_ID, "datasets", true);
                        this.data = null;
                        this.Signature = null;
                    }
                    [_symbol_utils.$onChild](child) {
                        const name = child[_symbol_utils.$nodeName];
                        if (name === "data" && child[_symbol_utils.$namespaceId] === DATASETS_NS_ID || name === "Signature" && child[_symbol_utils.$namespaceId] === _namespaces.NamespaceIds.signature.id) this[name] = child;
                        this[_symbol_utils.$appendChild](child);
                    }
                }
                class DatasetsNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (DatasetsNamespace.hasOwnProperty(name)) return DatasetsNamespace[name](attributes);
                        return undefined;
                    }
                    static datasets(attributes) {
                        return new Datasets(attributes);
                    }
                    static data(attributes) {
                        return new Data(attributes);
                    }
                }
                exports.DatasetsNamespace = DatasetsNamespace;
            /***/ },
            /* 96 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LocaleSetNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                var _utils = __w_pdfjs_require__(84);
                const LOCALE_SET_NS_ID = _namespaces.NamespaceIds.localeSet.id;
                class CalendarSymbols extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "calendarSymbols", true);
                        this.name = "gregorian";
                        this.dayNames = new _xfa_object.XFAObjectArray(2);
                        this.eraNames = null;
                        this.meridiemNames = null;
                        this.monthNames = new _xfa_object.XFAObjectArray(2);
                    }
                }
                class CurrencySymbol extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "currencySymbol");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "symbol",
                            "isoname",
                            "decimal"
                        ]);
                    }
                }
                class CurrencySymbols extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "currencySymbols", true);
                        this.currencySymbol = new _xfa_object.XFAObjectArray(3);
                    }
                }
                class DatePattern extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "datePattern");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class DatePatterns extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "datePatterns", true);
                        this.datePattern = new _xfa_object.XFAObjectArray(4);
                    }
                }
                class DateTimeSymbols extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "dateTimeSymbols");
                    }
                }
                class Day extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "day");
                    }
                }
                class DayNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "dayNames", true);
                        this.abbr = (0, _utils.getInteger)({
                            data: attributes.abbr,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.day = new _xfa_object.XFAObjectArray(7);
                    }
                }
                class Era extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "era");
                    }
                }
                class EraNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "eraNames", true);
                        this.era = new _xfa_object.XFAObjectArray(2);
                    }
                }
                class Locale extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "locale", true);
                        this.desc = attributes.desc || "";
                        this.name = "isoname";
                        this.calendarSymbols = null;
                        this.currencySymbols = null;
                        this.datePatterns = null;
                        this.dateTimeSymbols = null;
                        this.numberPatterns = null;
                        this.numberSymbols = null;
                        this.timePatterns = null;
                        this.typeFaces = null;
                    }
                }
                class LocaleSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "localeSet", true);
                        this.locale = new _xfa_object.XFAObjectArray();
                    }
                }
                class Meridiem extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "meridiem");
                    }
                }
                class MeridiemNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "meridiemNames", true);
                        this.meridiem = new _xfa_object.XFAObjectArray(2);
                    }
                }
                class Month extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "month");
                    }
                }
                class MonthNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "monthNames", true);
                        this.abbr = (0, _utils.getInteger)({
                            data: attributes.abbr,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.month = new _xfa_object.XFAObjectArray(12);
                    }
                }
                class NumberPattern extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberPattern");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class NumberPatterns extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberPatterns", true);
                        this.numberPattern = new _xfa_object.XFAObjectArray(4);
                    }
                }
                class NumberSymbol extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberSymbol");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "decimal",
                            "grouping",
                            "percent",
                            "minus",
                            "zero"
                        ]);
                    }
                }
                class NumberSymbols extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberSymbols", true);
                        this.numberSymbol = new _xfa_object.XFAObjectArray(5);
                    }
                }
                class TimePattern extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "timePattern");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class TimePatterns extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "timePatterns", true);
                        this.timePattern = new _xfa_object.XFAObjectArray(4);
                    }
                }
                class TypeFace extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "typeFace", true);
                        this.name = attributes.name | "";
                    }
                }
                class TypeFaces extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "typeFaces", true);
                        this.typeFace = new _xfa_object.XFAObjectArray();
                    }
                }
                class LocaleSetNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (LocaleSetNamespace.hasOwnProperty(name)) return LocaleSetNamespace[name](attributes);
                        return undefined;
                    }
                    static calendarSymbols(attrs) {
                        return new CalendarSymbols(attrs);
                    }
                    static currencySymbol(attrs) {
                        return new CurrencySymbol(attrs);
                    }
                    static currencySymbols(attrs) {
                        return new CurrencySymbols(attrs);
                    }
                    static datePattern(attrs) {
                        return new DatePattern(attrs);
                    }
                    static datePatterns(attrs) {
                        return new DatePatterns(attrs);
                    }
                    static dateTimeSymbols(attrs) {
                        return new DateTimeSymbols(attrs);
                    }
                    static day(attrs) {
                        return new Day(attrs);
                    }
                    static dayNames(attrs) {
                        return new DayNames(attrs);
                    }
                    static era(attrs) {
                        return new Era(attrs);
                    }
                    static eraNames(attrs) {
                        return new EraNames(attrs);
                    }
                    static locale(attrs) {
                        return new Locale(attrs);
                    }
                    static localeSet(attrs) {
                        return new LocaleSet(attrs);
                    }
                    static meridiem(attrs) {
                        return new Meridiem(attrs);
                    }
                    static meridiemNames(attrs) {
                        return new MeridiemNames(attrs);
                    }
                    static month(attrs) {
                        return new Month(attrs);
                    }
                    static monthNames(attrs) {
                        return new MonthNames(attrs);
                    }
                    static numberPattern(attrs) {
                        return new NumberPattern(attrs);
                    }
                    static numberPatterns(attrs) {
                        return new NumberPatterns(attrs);
                    }
                    static numberSymbol(attrs) {
                        return new NumberSymbol(attrs);
                    }
                    static numberSymbols(attrs) {
                        return new NumberSymbols(attrs);
                    }
                    static timePattern(attrs) {
                        return new TimePattern(attrs);
                    }
                    static timePatterns(attrs) {
                        return new TimePatterns(attrs);
                    }
                    static typeFace(attrs) {
                        return new TypeFace(attrs);
                    }
                    static typeFaces(attrs) {
                        return new TypeFaces(attrs);
                    }
                }
                exports.LocaleSetNamespace = LocaleSetNamespace;
            /***/ },
            /* 97 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SignatureNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                const SIGNATURE_NS_ID = _namespaces.NamespaceIds.signature.id;
                class Signature extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(SIGNATURE_NS_ID, "signature", true);
                    }
                }
                class SignatureNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (SignatureNamespace.hasOwnProperty(name)) return SignatureNamespace[name](attributes);
                        return undefined;
                    }
                    static signature(attributes) {
                        return new Signature(attributes);
                    }
                }
                exports.SignatureNamespace = SignatureNamespace;
            /***/ },
            /* 98 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StylesheetNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                const STYLESHEET_NS_ID = _namespaces.NamespaceIds.stylesheet.id;
                class Stylesheet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(STYLESHEET_NS_ID, "stylesheet", true);
                    }
                }
                class StylesheetNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (StylesheetNamespace.hasOwnProperty(name)) return StylesheetNamespace[name](attributes);
                        return undefined;
                    }
                    static stylesheet(attributes) {
                        return new Stylesheet(attributes);
                    }
                }
                exports.StylesheetNamespace = StylesheetNamespace;
            /***/ },
            /* 99 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XdpNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _symbol_utils = __w_pdfjs_require__(78);
                var _xfa_object = __w_pdfjs_require__(87);
                const XDP_NS_ID = _namespaces.NamespaceIds.xdp.id;
                class Xdp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(XDP_NS_ID, "xdp", true);
                        this.uuid = attributes.uuid || "";
                        this.timeStamp = attributes.timeStamp || "";
                        this.config = null;
                        this.connectionSet = null;
                        this.datasets = null;
                        this.localeSet = null;
                        this.stylesheet = new _xfa_object.XFAObjectArray();
                        this.template = null;
                    }
                    [_symbol_utils.$onChildCheck](child) {
                        const ns = _namespaces.NamespaceIds[child[_symbol_utils.$nodeName]];
                        return ns && child[_symbol_utils.$namespaceId] === ns.id;
                    }
                }
                class XdpNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (XdpNamespace.hasOwnProperty(name)) return XdpNamespace[name](attributes);
                        return undefined;
                    }
                    static xdp(attributes) {
                        return new Xdp(attributes);
                    }
                }
                exports.XdpNamespace = XdpNamespace;
            /***/ },
            /* 100 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XhtmlNamespace = void 0;
                var _symbol_utils = __w_pdfjs_require__(78);
                var _namespaces = __w_pdfjs_require__(81);
                var _html_utils = __w_pdfjs_require__(83);
                var _utils = __w_pdfjs_require__(84);
                var _xfa_object = __w_pdfjs_require__(87);
                const XHTML_NS_ID = _namespaces.NamespaceIds.xhtml.id;
                const $richText = Symbol();
                const VALID_STYLES = new Set([
                    "color",
                    "font",
                    "font-family",
                    "font-size",
                    "font-stretch",
                    "font-style",
                    "font-weight",
                    "margin",
                    "margin-bottom",
                    "margin-left",
                    "margin-right",
                    "margin-top",
                    "letter-spacing",
                    "line-height",
                    "orphans",
                    "page-break-after",
                    "page-break-before",
                    "page-break-inside",
                    "tab-interval",
                    "tab-stop",
                    "text-align",
                    "text-decoration",
                    "text-indent",
                    "vertical-align",
                    "widows",
                    "kerning-mode",
                    "xfa-font-horizontal-scale",
                    "xfa-font-vertical-scale",
                    "xfa-spacerun",
                    "xfa-tab-stops"
                ]);
                const StyleMapping = new Map([
                    [
                        "page-break-after",
                        "breakAfter"
                    ],
                    [
                        "page-break-before",
                        "breakBefore"
                    ],
                    [
                        "page-break-inside",
                        "breakInside"
                    ],
                    [
                        "kerning-mode",
                        (value)=>value === "none" ? "none" : "normal"
                    ],
                    [
                        "xfa-font-horizontal-scale",
                        (value)=>`scaleX(${Math.max(0, Math.min(parseInt(value) / 100)).toFixed(2)})`
                    ],
                    [
                        "xfa-font-vertical-scale",
                        (value)=>`scaleY(${Math.max(0, Math.min(parseInt(value) / 100)).toFixed(2)})`
                    ],
                    [
                        "xfa-spacerun",
                        ""
                    ],
                    [
                        "xfa-tab-stops",
                        ""
                    ],
                    [
                        "font-size",
                        (value, original)=>{
                            value = original.fontSize = (0, _utils.getMeasurement)(value);
                            return (0, _html_utils.measureToString)(0.99 * value);
                        }
                    ],
                    [
                        "letter-spacing",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "line-height",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-bottom",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-left",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-right",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-top",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "text-indent",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "font-family",
                        (value)=>value
                    ],
                    [
                        "vertical-align",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ]
                ]);
                const spacesRegExp = /\s+/g;
                const crlfRegExp = /[\r\n]+/g;
                const crlfForRichTextRegExp = /\r\n?/g;
                function mapStyle(styleStr, node, richText) {
                    const style = Object.create(null);
                    if (!styleStr) return style;
                    const original = Object.create(null);
                    for (const [key, value] of styleStr.split(";").map((s)=>s.split(":", 2))){
                        const mapping = StyleMapping.get(key);
                        if (mapping === "") continue;
                        let newValue = value;
                        if (mapping) newValue = typeof mapping === "string" ? mapping : mapping(value, original);
                        if (key.endsWith("scale")) style.transform = style.transform ? `${style[key]} ${newValue}` : newValue;
                        else style[key.replaceAll(/-([a-zA-Z])/g, (_, x)=>x.toUpperCase())] = newValue;
                    }
                    if (style.fontFamily) (0, _html_utils.setFontFamily)({
                        typeface: style.fontFamily,
                        weight: style.fontWeight || "normal",
                        posture: style.fontStyle || "normal",
                        size: original.fontSize || 0
                    }, node, node[_symbol_utils.$globalData].fontFinder, style);
                    if (richText && style.verticalAlign && style.verticalAlign !== "0px" && style.fontSize) {
                        const SUB_SUPER_SCRIPT_FACTOR = 0.583;
                        const VERTICAL_FACTOR = 0.333;
                        const fontSize = (0, _utils.getMeasurement)(style.fontSize);
                        style.fontSize = (0, _html_utils.measureToString)(fontSize * SUB_SUPER_SCRIPT_FACTOR);
                        style.verticalAlign = (0, _html_utils.measureToString)(Math.sign((0, _utils.getMeasurement)(style.verticalAlign)) * fontSize * VERTICAL_FACTOR);
                    }
                    if (richText && style.fontSize) style.fontSize = `calc(${style.fontSize} * var(--scale-factor))`;
                    (0, _html_utils.fixTextIndent)(style);
                    return style;
                }
                function checkStyle(node) {
                    if (!node.style) return "";
                    return node.style.trim().split(/\s*;\s*/).filter((s)=>!!s).map((s)=>s.split(/\s*:\s*/, 2)).filter(([key, value])=>{
                        if (key === "font-family") node[_symbol_utils.$globalData].usedTypefaces.add(value);
                        return VALID_STYLES.has(key);
                    }).map((kv)=>kv.join(":")).join(";");
                }
                const NoWhites = new Set([
                    "body",
                    "html"
                ]);
                class XhtmlObject extends _xfa_object.XmlObject {
                    constructor(attributes, name){
                        super(XHTML_NS_ID, name);
                        this[$richText] = false;
                        this.style = attributes.style || "";
                    }
                    [_symbol_utils.$clean](builder) {
                        super[_symbol_utils.$clean](builder);
                        this.style = checkStyle(this);
                    }
                    [_symbol_utils.$acceptWhitespace]() {
                        return !NoWhites.has(this[_symbol_utils.$nodeName]);
                    }
                    [_symbol_utils.$onText](str, richText = false) {
                        if (!richText) {
                            str = str.replaceAll(crlfRegExp, "");
                            if (!this.style.includes("xfa-spacerun:yes")) str = str.replaceAll(spacesRegExp, " ");
                        } else this[$richText] = true;
                        if (str) this[_symbol_utils.$content] += str;
                    }
                    [_symbol_utils.$pushGlyphs](measure, mustPop = true) {
                        const xfaFont = Object.create(null);
                        const margin = {
                            top: NaN,
                            bottom: NaN,
                            left: NaN,
                            right: NaN
                        };
                        let lineHeight = null;
                        for (const [key, value] of this.style.split(";").map((s)=>s.split(":", 2)))switch(key){
                            case "font-family":
                                xfaFont.typeface = (0, _utils.stripQuotes)(value);
                                break;
                            case "font-size":
                                xfaFont.size = (0, _utils.getMeasurement)(value);
                                break;
                            case "font-weight":
                                xfaFont.weight = value;
                                break;
                            case "font-style":
                                xfaFont.posture = value;
                                break;
                            case "letter-spacing":
                                xfaFont.letterSpacing = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin":
                                const values = value.split(/ \t/).map((x)=>(0, _utils.getMeasurement)(x));
                                switch(values.length){
                                    case 1:
                                        margin.top = margin.bottom = margin.left = margin.right = values[0];
                                        break;
                                    case 2:
                                        margin.top = margin.bottom = values[0];
                                        margin.left = margin.right = values[1];
                                        break;
                                    case 3:
                                        margin.top = values[0];
                                        margin.bottom = values[2];
                                        margin.left = margin.right = values[1];
                                        break;
                                    case 4:
                                        margin.top = values[0];
                                        margin.left = values[1];
                                        margin.bottom = values[2];
                                        margin.right = values[3];
                                        break;
                                }
                                break;
                            case "margin-top":
                                margin.top = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin-bottom":
                                margin.bottom = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin-left":
                                margin.left = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin-right":
                                margin.right = (0, _utils.getMeasurement)(value);
                                break;
                            case "line-height":
                                lineHeight = (0, _utils.getMeasurement)(value);
                                break;
                        }
                        measure.pushData(xfaFont, margin, lineHeight);
                        if (this[_symbol_utils.$content]) measure.addString(this[_symbol_utils.$content]);
                        else for (const child of this[_symbol_utils.$getChildren]()){
                            if (child[_symbol_utils.$nodeName] === "#text") {
                                measure.addString(child[_symbol_utils.$content]);
                                continue;
                            }
                            child[_symbol_utils.$pushGlyphs](measure);
                        }
                        if (mustPop) measure.popFont();
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const children = [];
                        this[_symbol_utils.$extra] = {
                            children: children
                        };
                        this[_symbol_utils.$childrenToHTML]({});
                        if (children.length === 0 && !this[_symbol_utils.$content]) return _utils.HTMLResult.EMPTY;
                        let value;
                        if (this[$richText]) value = this[_symbol_utils.$content] ? this[_symbol_utils.$content].replaceAll(crlfForRichTextRegExp, "\n") : undefined;
                        else value = this[_symbol_utils.$content] || undefined;
                        return _utils.HTMLResult.success({
                            name: this[_symbol_utils.$nodeName],
                            attributes: {
                                href: this.href,
                                style: mapStyle(this.style, this, this[$richText])
                            },
                            children: children,
                            value: value
                        });
                    }
                }
                class A extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "a");
                        this.href = (0, _html_utils.fixURL)(attributes.href) || "";
                    }
                }
                class B extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "b");
                    }
                    [_symbol_utils.$pushGlyphs](measure) {
                        measure.pushFont({
                            weight: "bold"
                        });
                        super[_symbol_utils.$pushGlyphs](measure);
                        measure.popFont();
                    }
                }
                class Body extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "body");
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const res = super[_symbol_utils.$toHTML](availableSpace);
                        const { html: html } = res;
                        if (!html) return _utils.HTMLResult.EMPTY;
                        html.name = "div";
                        html.attributes.class = [
                            "xfaRich"
                        ];
                        return res;
                    }
                }
                class Br extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "br");
                    }
                    [_symbol_utils.$text]() {
                        return "\n";
                    }
                    [_symbol_utils.$pushGlyphs](measure) {
                        measure.addString("\n");
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        return _utils.HTMLResult.success({
                            name: "br"
                        });
                    }
                }
                class Html extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "html");
                    }
                    [_symbol_utils.$toHTML](availableSpace) {
                        const children = [];
                        this[_symbol_utils.$extra] = {
                            children: children
                        };
                        this[_symbol_utils.$childrenToHTML]({});
                        if (children.length === 0) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                class: [
                                    "xfaRich"
                                ],
                                style: {}
                            },
                            value: this[_symbol_utils.$content] || ""
                        });
                        if (children.length === 1) {
                            const child = children[0];
                            if (child.attributes?.class.includes("xfaRich")) return _utils.HTMLResult.success(child);
                        }
                        return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                class: [
                                    "xfaRich"
                                ],
                                style: {}
                            },
                            children: children
                        });
                    }
                }
                class I extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "i");
                    }
                    [_symbol_utils.$pushGlyphs](measure) {
                        measure.pushFont({
                            posture: "italic"
                        });
                        super[_symbol_utils.$pushGlyphs](measure);
                        measure.popFont();
                    }
                }
                class Li extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "li");
                    }
                }
                class Ol extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "ol");
                    }
                }
                class P extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "p");
                    }
                    [_symbol_utils.$pushGlyphs](measure) {
                        super[_symbol_utils.$pushGlyphs](measure, false);
                        measure.addString("\n");
                        measure.addPara();
                        measure.popFont();
                    }
                    [_symbol_utils.$text]() {
                        const siblings = this[_symbol_utils.$getParent]()[_symbol_utils.$getChildren]();
                        if (siblings.at(-1) === this) return super[_symbol_utils.$text]();
                        return super[_symbol_utils.$text]() + "\n";
                    }
                }
                class Span extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "span");
                    }
                }
                class Sub extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "sub");
                    }
                }
                class Sup extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "sup");
                    }
                }
                class Ul extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "ul");
                    }
                }
                class XhtmlNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (XhtmlNamespace.hasOwnProperty(name)) return XhtmlNamespace[name](attributes);
                        return undefined;
                    }
                    static a(attributes) {
                        return new A(attributes);
                    }
                    static b(attributes) {
                        return new B(attributes);
                    }
                    static body(attributes) {
                        return new Body(attributes);
                    }
                    static br(attributes) {
                        return new Br(attributes);
                    }
                    static html(attributes) {
                        return new Html(attributes);
                    }
                    static i(attributes) {
                        return new I(attributes);
                    }
                    static li(attributes) {
                        return new Li(attributes);
                    }
                    static ol(attributes) {
                        return new Ol(attributes);
                    }
                    static p(attributes) {
                        return new P(attributes);
                    }
                    static span(attributes) {
                        return new Span(attributes);
                    }
                    static sub(attributes) {
                        return new Sub(attributes);
                    }
                    static sup(attributes) {
                        return new Sup(attributes);
                    }
                    static ul(attributes) {
                        return new Ul(attributes);
                    }
                }
                exports.XhtmlNamespace = XhtmlNamespace;
            /***/ },
            /* 101 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.UnknownNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(81);
                var _xfa_object = __w_pdfjs_require__(87);
                class UnknownNamespace {
                    constructor(nsId){
                        this.namespaceId = nsId;
                    }
                    [_namespaces.$buildXFAObject](name, attributes) {
                        return new _xfa_object.XmlObject(this.namespaceId, name, attributes);
                    }
                }
                exports.UnknownNamespace = UnknownNamespace;
            /***/ },
            /* 102 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DatasetReader = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(3);
                var _xml_parser = __w_pdfjs_require__(71);
                function decodeString(str) {
                    try {
                        return (0, _util.stringToUTF8String)(str);
                    } catch (ex) {
                        (0, _util.warn)(`UTF-8 decoding failed: "${ex}".`);
                        return str;
                    }
                }
                class DatasetXMLParser extends _xml_parser.SimpleXMLParser {
                    constructor(options){
                        super(options);
                        this.node = null;
                    }
                    onEndElement(name) {
                        const node = super.onEndElement(name);
                        if (node && name === "xfa:datasets") {
                            this.node = node;
                            throw new Error("Aborting DatasetXMLParser.");
                        }
                    }
                }
                class DatasetReader {
                    constructor(data){
                        if (data.datasets) this.node = new _xml_parser.SimpleXMLParser({
                            hasAttributes: true
                        }).parseFromString(data.datasets).documentElement;
                        else {
                            const parser = new DatasetXMLParser({
                                hasAttributes: true
                            });
                            try {
                                parser.parseFromString(data["xdp:xdp"]);
                            } catch  {}
                            this.node = parser.node;
                        }
                    }
                    getValue(path) {
                        if (!this.node || !path) return "";
                        const node = this.node.searchNode((0, _core_utils.parseXFAPath)(path), 0);
                        if (!node) return "";
                        const first = node.firstChild;
                        if (first?.nodeName === "value") return node.children.map((child)=>decodeString(child.textContent));
                        return decodeString(node.textContent);
                    }
                }
                exports.DatasetReader = DatasetReader;
            /***/ },
            /* 103 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XRef = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(4);
                var _parser = __w_pdfjs_require__(16);
                var _core_utils = __w_pdfjs_require__(3);
                var _base_stream = __w_pdfjs_require__(5);
                var _crypto = __w_pdfjs_require__(74);
                class XRef {
                    #firstXRefStmPos = null;
                    constructor(stream, pdfManager){
                        this.stream = stream;
                        this.pdfManager = pdfManager;
                        this.entries = [];
                        this._xrefStms = new Set();
                        this._cacheMap = new Map();
                        this._pendingRefs = new _primitives.RefSet();
                        this._newPersistentRefNum = null;
                        this._newTemporaryRefNum = null;
                    }
                    getNewPersistentRef(obj) {
                        if (this._newPersistentRefNum === null) this._newPersistentRefNum = this.entries.length || 1;
                        const num = this._newPersistentRefNum++;
                        this._cacheMap.set(num, obj);
                        return _primitives.Ref.get(num, 0);
                    }
                    getNewTemporaryRef() {
                        if (this._newTemporaryRefNum === null) this._newTemporaryRefNum = this.entries.length || 1;
                        return _primitives.Ref.get(this._newTemporaryRefNum++, 0);
                    }
                    resetNewTemporaryRef() {
                        this._newTemporaryRefNum = null;
                    }
                    setStartXRef(startXRef) {
                        this.startXRefQueue = [
                            startXRef
                        ];
                    }
                    parse(recoveryMode = false) {
                        let trailerDict;
                        if (!recoveryMode) trailerDict = this.readXRef();
                        else {
                            (0, _util.warn)("Indexing all PDF objects");
                            trailerDict = this.indexObjects();
                        }
                        trailerDict.assignXref(this);
                        this.trailer = trailerDict;
                        let encrypt;
                        try {
                            encrypt = trailerDict.get("Encrypt");
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`XRef.parse - Invalid "Encrypt" reference: "${ex}".`);
                        }
                        if (encrypt instanceof _primitives.Dict) {
                            const ids = trailerDict.get("ID");
                            const fileId = ids?.length ? ids[0] : "";
                            encrypt.suppressEncryption = true;
                            this.encrypt = new _crypto.CipherTransformFactory(encrypt, fileId, this.pdfManager.password);
                        }
                        let root;
                        try {
                            root = trailerDict.get("Root");
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`XRef.parse - Invalid "Root" reference: "${ex}".`);
                        }
                        if (root instanceof _primitives.Dict) try {
                            const pages = root.get("Pages");
                            if (pages instanceof _primitives.Dict) {
                                this.root = root;
                                return;
                            }
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`XRef.parse - Invalid "Pages" reference: "${ex}".`);
                        }
                        if (!recoveryMode) throw new _core_utils.XRefParseException();
                        throw new _util.InvalidPDFException("Invalid Root reference.");
                    }
                    processXRefTable(parser) {
                        if (!("tableState" in this)) this.tableState = {
                            entryNum: 0,
                            streamPos: parser.lexer.stream.pos,
                            parserBuf1: parser.buf1,
                            parserBuf2: parser.buf2
                        };
                        const obj = this.readXRefTable(parser);
                        if (!(0, _primitives.isCmd)(obj, "trailer")) throw new _util.FormatError("Invalid XRef table: could not find trailer dictionary");
                        let dict = parser.getObj();
                        if (!(dict instanceof _primitives.Dict) && dict.dict) dict = dict.dict;
                        if (!(dict instanceof _primitives.Dict)) throw new _util.FormatError("Invalid XRef table: could not parse trailer dictionary");
                        delete this.tableState;
                        return dict;
                    }
                    readXRefTable(parser) {
                        const stream = parser.lexer.stream;
                        const tableState = this.tableState;
                        stream.pos = tableState.streamPos;
                        parser.buf1 = tableState.parserBuf1;
                        parser.buf2 = tableState.parserBuf2;
                        let obj;
                        while(true){
                            if (!("firstEntryNum" in tableState) || !("entryCount" in tableState)) {
                                if ((0, _primitives.isCmd)(obj = parser.getObj(), "trailer")) break;
                                tableState.firstEntryNum = obj;
                                tableState.entryCount = parser.getObj();
                            }
                            let first = tableState.firstEntryNum;
                            const count = tableState.entryCount;
                            if (!Number.isInteger(first) || !Number.isInteger(count)) throw new _util.FormatError("Invalid XRef table: wrong types in subsection header");
                            for(let i = tableState.entryNum; i < count; i++){
                                tableState.streamPos = stream.pos;
                                tableState.entryNum = i;
                                tableState.parserBuf1 = parser.buf1;
                                tableState.parserBuf2 = parser.buf2;
                                const entry = {};
                                entry.offset = parser.getObj();
                                entry.gen = parser.getObj();
                                const type = parser.getObj();
                                if (type instanceof _primitives.Cmd) switch(type.cmd){
                                    case "f":
                                        entry.free = true;
                                        break;
                                    case "n":
                                        entry.uncompressed = true;
                                        break;
                                }
                                if (!Number.isInteger(entry.offset) || !Number.isInteger(entry.gen) || !(entry.free || entry.uncompressed)) throw new _util.FormatError(`Invalid entry in XRef subsection: ${first}, ${count}`);
                                if (i === 0 && entry.free && first === 1) first = 0;
                                if (!this.entries[i + first]) this.entries[i + first] = entry;
                            }
                            tableState.entryNum = 0;
                            tableState.streamPos = stream.pos;
                            tableState.parserBuf1 = parser.buf1;
                            tableState.parserBuf2 = parser.buf2;
                            delete tableState.firstEntryNum;
                            delete tableState.entryCount;
                        }
                        if (this.entries[0] && !this.entries[0].free) throw new _util.FormatError("Invalid XRef table: unexpected first object");
                        return obj;
                    }
                    processXRefStream(stream) {
                        if (!("streamState" in this)) {
                            const streamParameters = stream.dict;
                            const byteWidths = streamParameters.get("W");
                            let range = streamParameters.get("Index");
                            if (!range) range = [
                                0,
                                streamParameters.get("Size")
                            ];
                            this.streamState = {
                                entryRanges: range,
                                byteWidths: byteWidths,
                                entryNum: 0,
                                streamPos: stream.pos
                            };
                        }
                        this.readXRefStream(stream);
                        delete this.streamState;
                        return stream.dict;
                    }
                    readXRefStream(stream) {
                        const streamState = this.streamState;
                        stream.pos = streamState.streamPos;
                        const [typeFieldWidth, offsetFieldWidth, generationFieldWidth] = streamState.byteWidths;
                        const entryRanges = streamState.entryRanges;
                        while(entryRanges.length > 0){
                            const [first, n] = entryRanges;
                            if (!Number.isInteger(first) || !Number.isInteger(n)) throw new _util.FormatError(`Invalid XRef range fields: ${first}, ${n}`);
                            if (!Number.isInteger(typeFieldWidth) || !Number.isInteger(offsetFieldWidth) || !Number.isInteger(generationFieldWidth)) throw new _util.FormatError(`Invalid XRef entry fields length: ${first}, ${n}`);
                            for(let i = streamState.entryNum; i < n; ++i){
                                streamState.entryNum = i;
                                streamState.streamPos = stream.pos;
                                let type = 0, offset = 0, generation = 0;
                                for(let j = 0; j < typeFieldWidth; ++j){
                                    const typeByte = stream.getByte();
                                    if (typeByte === -1) throw new _util.FormatError("Invalid XRef byteWidths 'type'.");
                                    type = type << 8 | typeByte;
                                }
                                if (typeFieldWidth === 0) type = 1;
                                for(let j = 0; j < offsetFieldWidth; ++j){
                                    const offsetByte = stream.getByte();
                                    if (offsetByte === -1) throw new _util.FormatError("Invalid XRef byteWidths 'offset'.");
                                    offset = offset << 8 | offsetByte;
                                }
                                for(let j = 0; j < generationFieldWidth; ++j){
                                    const generationByte = stream.getByte();
                                    if (generationByte === -1) throw new _util.FormatError("Invalid XRef byteWidths 'generation'.");
                                    generation = generation << 8 | generationByte;
                                }
                                const entry = {};
                                entry.offset = offset;
                                entry.gen = generation;
                                switch(type){
                                    case 0:
                                        entry.free = true;
                                        break;
                                    case 1:
                                        entry.uncompressed = true;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new _util.FormatError(`Invalid XRef entry type: ${type}`);
                                }
                                if (!this.entries[first + i]) this.entries[first + i] = entry;
                            }
                            streamState.entryNum = 0;
                            streamState.streamPos = stream.pos;
                            entryRanges.splice(0, 2);
                        }
                    }
                    indexObjects() {
                        const TAB = 0x9, LF = 0xa, CR = 0xd, SPACE = 0x20;
                        const PERCENT = 0x25, LT = 0x3c;
                        function readToken(data, offset) {
                            let token = "", ch = data[offset];
                            while(ch !== LF && ch !== CR && ch !== LT){
                                if (++offset >= data.length) break;
                                token += String.fromCharCode(ch);
                                ch = data[offset];
                            }
                            return token;
                        }
                        function skipUntil(data, offset, what) {
                            const length = what.length, dataLength = data.length;
                            let skipped = 0;
                            while(offset < dataLength){
                                let i = 0;
                                while(i < length && data[offset + i] === what[i])++i;
                                if (i >= length) break;
                                offset++;
                                skipped++;
                            }
                            return skipped;
                        }
                        const gEndobjRegExp = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer\s*<<)\b/g;
                        const gStartxrefRegExp = /\b(startxref|\d+\s+\d+\s+obj)\b/g;
                        const objRegExp = /^(\d+)\s+(\d+)\s+obj\b/;
                        const trailerBytes = new Uint8Array([
                            116,
                            114,
                            97,
                            105,
                            108,
                            101,
                            114
                        ]);
                        const startxrefBytes = new Uint8Array([
                            115,
                            116,
                            97,
                            114,
                            116,
                            120,
                            114,
                            101,
                            102
                        ]);
                        const xrefBytes = new Uint8Array([
                            47,
                            88,
                            82,
                            101,
                            102
                        ]);
                        this.entries.length = 0;
                        this._cacheMap.clear();
                        const stream = this.stream;
                        stream.pos = 0;
                        const buffer = stream.getBytes(), bufferStr = (0, _util.bytesToString)(buffer), length = buffer.length;
                        let position = stream.start;
                        const trailers = [], xrefStms = [];
                        while(position < length){
                            let ch = buffer[position];
                            if (ch === TAB || ch === LF || ch === CR || ch === SPACE) {
                                ++position;
                                continue;
                            }
                            if (ch === PERCENT) {
                                do {
                                    ++position;
                                    if (position >= length) break;
                                    ch = buffer[position];
                                }while (ch !== LF && ch !== CR);
                                continue;
                            }
                            const token = readToken(buffer, position);
                            let m;
                            if (token.startsWith("xref") && (token.length === 4 || /\s/.test(token[4]))) {
                                position += skipUntil(buffer, position, trailerBytes);
                                trailers.push(position);
                                position += skipUntil(buffer, position, startxrefBytes);
                            } else if (m = objRegExp.exec(token)) {
                                const num = m[1] | 0, gen = m[2] | 0;
                                const startPos = position + token.length;
                                let contentLength, updateEntries = false;
                                if (!this.entries[num]) updateEntries = true;
                                else if (this.entries[num].gen === gen) try {
                                    const parser = new _parser.Parser({
                                        lexer: new _parser.Lexer(stream.makeSubStream(startPos))
                                    });
                                    parser.getObj();
                                    updateEntries = true;
                                } catch (ex) {
                                    if (ex instanceof _core_utils.ParserEOFException) (0, _util.warn)(`indexObjects -- checking object (${token}): "${ex}".`);
                                    else updateEntries = true;
                                }
                                if (updateEntries) this.entries[num] = {
                                    offset: position - stream.start,
                                    gen: gen,
                                    uncompressed: true
                                };
                                gEndobjRegExp.lastIndex = startPos;
                                const match = gEndobjRegExp.exec(bufferStr);
                                if (match) {
                                    const endPos = gEndobjRegExp.lastIndex + 1;
                                    contentLength = endPos - position;
                                    if (match[1] !== "endobj") {
                                        (0, _util.warn)(`indexObjects: Found "${match[1]}" inside of another "obj", ` + 'caused by missing "endobj" -- trying to recover.');
                                        contentLength -= match[1].length + 1;
                                    }
                                } else contentLength = length - position;
                                const content = buffer.subarray(position, position + contentLength);
                                const xrefTagOffset = skipUntil(content, 0, xrefBytes);
                                if (xrefTagOffset < contentLength && content[xrefTagOffset + 5] < 64) {
                                    xrefStms.push(position - stream.start);
                                    this._xrefStms.add(position - stream.start);
                                }
                                position += contentLength;
                            } else if (token.startsWith("trailer") && (token.length === 7 || /\s/.test(token[7]))) {
                                trailers.push(position);
                                const startPos = position + token.length;
                                let contentLength;
                                gStartxrefRegExp.lastIndex = startPos;
                                const match = gStartxrefRegExp.exec(bufferStr);
                                if (match) {
                                    const endPos = gStartxrefRegExp.lastIndex + 1;
                                    contentLength = endPos - position;
                                    if (match[1] !== "startxref") {
                                        (0, _util.warn)(`indexObjects: Found "${match[1]}" after "trailer", ` + 'caused by missing "startxref" -- trying to recover.');
                                        contentLength -= match[1].length + 1;
                                    }
                                } else contentLength = length - position;
                                position += contentLength;
                            } else position += token.length + 1;
                        }
                        for (const xrefStm of xrefStms){
                            this.startXRefQueue.push(xrefStm);
                            this.readXRef(true);
                        }
                        const trailerDicts = [];
                        let isEncrypted = false;
                        for (const trailer of trailers){
                            stream.pos = trailer;
                            const parser = new _parser.Parser({
                                lexer: new _parser.Lexer(stream),
                                xref: this,
                                allowStreams: true,
                                recoveryMode: true
                            });
                            const obj = parser.getObj();
                            if (!(0, _primitives.isCmd)(obj, "trailer")) continue;
                            const dict = parser.getObj();
                            if (!(dict instanceof _primitives.Dict)) continue;
                            trailerDicts.push(dict);
                            if (dict.has("Encrypt")) isEncrypted = true;
                        }
                        let trailerDict, trailerError;
                        for (const dict of [
                            ...trailerDicts,
                            "genFallback",
                            ...trailerDicts
                        ]){
                            if (dict === "genFallback") {
                                if (!trailerError) break;
                                this._generationFallback = true;
                                continue;
                            }
                            let validPagesDict = false;
                            try {
                                const rootDict = dict.get("Root");
                                if (!(rootDict instanceof _primitives.Dict)) continue;
                                const pagesDict = rootDict.get("Pages");
                                if (!(pagesDict instanceof _primitives.Dict)) continue;
                                const pagesCount = pagesDict.get("Count");
                                if (Number.isInteger(pagesCount)) validPagesDict = true;
                            } catch (ex) {
                                trailerError = ex;
                                continue;
                            }
                            if (validPagesDict && (!isEncrypted || dict.has("Encrypt")) && dict.has("ID")) return dict;
                            trailerDict = dict;
                        }
                        if (trailerDict) return trailerDict;
                        if (this.topDict) return this.topDict;
                        throw new _util.InvalidPDFException("Invalid PDF structure.");
                    }
                    readXRef(recoveryMode = false) {
                        const stream = this.stream;
                        const startXRefParsedCache = new Set();
                        while(this.startXRefQueue.length){
                            try {
                                const startXRef = this.startXRefQueue[0];
                                if (startXRefParsedCache.has(startXRef)) {
                                    (0, _util.warn)("readXRef - skipping XRef table since it was already parsed.");
                                    this.startXRefQueue.shift();
                                    continue;
                                }
                                startXRefParsedCache.add(startXRef);
                                stream.pos = startXRef + stream.start;
                                const parser = new _parser.Parser({
                                    lexer: new _parser.Lexer(stream),
                                    xref: this,
                                    allowStreams: true
                                });
                                let obj = parser.getObj();
                                let dict;
                                if ((0, _primitives.isCmd)(obj, "xref")) {
                                    dict = this.processXRefTable(parser);
                                    if (!this.topDict) this.topDict = dict;
                                    obj = dict.get("XRefStm");
                                    if (Number.isInteger(obj) && !this._xrefStms.has(obj)) {
                                        this._xrefStms.add(obj);
                                        this.startXRefQueue.push(obj);
                                        this.#firstXRefStmPos ??= obj;
                                    }
                                } else if (Number.isInteger(obj)) {
                                    if (!Number.isInteger(parser.getObj()) || !(0, _primitives.isCmd)(parser.getObj(), "obj") || !((obj = parser.getObj()) instanceof _base_stream.BaseStream)) throw new _util.FormatError("Invalid XRef stream");
                                    dict = this.processXRefStream(obj);
                                    if (!this.topDict) this.topDict = dict;
                                    if (!dict) throw new _util.FormatError("Failed to read XRef stream");
                                } else throw new _util.FormatError("Invalid XRef stream header");
                                obj = dict.get("Prev");
                                if (Number.isInteger(obj)) this.startXRefQueue.push(obj);
                                else if (obj instanceof _primitives.Ref) this.startXRefQueue.push(obj.num);
                            } catch (e) {
                                if (e instanceof _core_utils.MissingDataException) throw e;
                                (0, _util.info)("(while reading XRef): " + e);
                            }
                            this.startXRefQueue.shift();
                        }
                        if (this.topDict) return this.topDict;
                        if (recoveryMode) return undefined;
                        throw new _core_utils.XRefParseException();
                    }
                    get lastXRefStreamPos() {
                        return this.#firstXRefStmPos ?? (this._xrefStms.size > 0 ? Math.max(...this._xrefStms) : null);
                    }
                    getEntry(i) {
                        const xrefEntry = this.entries[i];
                        if (xrefEntry && !xrefEntry.free && xrefEntry.offset) return xrefEntry;
                        return null;
                    }
                    fetchIfRef(obj, suppressEncryption = false) {
                        if (obj instanceof _primitives.Ref) return this.fetch(obj, suppressEncryption);
                        return obj;
                    }
                    fetch(ref, suppressEncryption = false) {
                        if (!(ref instanceof _primitives.Ref)) throw new Error("ref object is not a reference");
                        const num = ref.num;
                        const cacheEntry = this._cacheMap.get(num);
                        if (cacheEntry !== undefined) {
                            if (cacheEntry instanceof _primitives.Dict && !cacheEntry.objId) cacheEntry.objId = ref.toString();
                            return cacheEntry;
                        }
                        let xrefEntry = this.getEntry(num);
                        if (xrefEntry === null) {
                            this._cacheMap.set(num, xrefEntry);
                            return xrefEntry;
                        }
                        if (this._pendingRefs.has(ref)) {
                            this._pendingRefs.remove(ref);
                            (0, _util.warn)(`Ignoring circular reference: ${ref}.`);
                            return _primitives.CIRCULAR_REF;
                        }
                        this._pendingRefs.put(ref);
                        try {
                            xrefEntry = xrefEntry.uncompressed ? this.fetchUncompressed(ref, xrefEntry, suppressEncryption) : this.fetchCompressed(ref, xrefEntry, suppressEncryption);
                            this._pendingRefs.remove(ref);
                        } catch (ex) {
                            this._pendingRefs.remove(ref);
                            throw ex;
                        }
                        if (xrefEntry instanceof _primitives.Dict) xrefEntry.objId = ref.toString();
                        else if (xrefEntry instanceof _base_stream.BaseStream) xrefEntry.dict.objId = ref.toString();
                        return xrefEntry;
                    }
                    fetchUncompressed(ref, xrefEntry, suppressEncryption = false) {
                        const gen = ref.gen;
                        let num = ref.num;
                        if (xrefEntry.gen !== gen) {
                            const msg = `Inconsistent generation in XRef: ${ref}`;
                            if (this._generationFallback && xrefEntry.gen < gen) {
                                (0, _util.warn)(msg);
                                return this.fetchUncompressed(_primitives.Ref.get(num, xrefEntry.gen), xrefEntry, suppressEncryption);
                            }
                            throw new _core_utils.XRefEntryException(msg);
                        }
                        const stream = this.stream.makeSubStream(xrefEntry.offset + this.stream.start);
                        const parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream),
                            xref: this,
                            allowStreams: true
                        });
                        const obj1 = parser.getObj();
                        const obj2 = parser.getObj();
                        const obj3 = parser.getObj();
                        if (obj1 !== num || obj2 !== gen || !(obj3 instanceof _primitives.Cmd)) throw new _core_utils.XRefEntryException(`Bad (uncompressed) XRef entry: ${ref}`);
                        if (obj3.cmd !== "obj") {
                            if (obj3.cmd.startsWith("obj")) {
                                num = parseInt(obj3.cmd.substring(3), 10);
                                if (!Number.isNaN(num)) return num;
                            }
                            throw new _core_utils.XRefEntryException(`Bad (uncompressed) XRef entry: ${ref}`);
                        }
                        xrefEntry = this.encrypt && !suppressEncryption ? parser.getObj(this.encrypt.createCipherTransform(num, gen)) : parser.getObj();
                        if (!(xrefEntry instanceof _base_stream.BaseStream)) this._cacheMap.set(num, xrefEntry);
                        return xrefEntry;
                    }
                    fetchCompressed(ref, xrefEntry, suppressEncryption = false) {
                        const tableOffset = xrefEntry.offset;
                        const stream = this.fetch(_primitives.Ref.get(tableOffset, 0));
                        if (!(stream instanceof _base_stream.BaseStream)) throw new _util.FormatError("bad ObjStm stream");
                        const first = stream.dict.get("First");
                        const n = stream.dict.get("N");
                        if (!Number.isInteger(first) || !Number.isInteger(n)) throw new _util.FormatError("invalid first and n parameters for ObjStm stream");
                        let parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream),
                            xref: this,
                            allowStreams: true
                        });
                        const nums = new Array(n);
                        const offsets = new Array(n);
                        for(let i = 0; i < n; ++i){
                            const num = parser.getObj();
                            if (!Number.isInteger(num)) throw new _util.FormatError(`invalid object number in the ObjStm stream: ${num}`);
                            const offset = parser.getObj();
                            if (!Number.isInteger(offset)) throw new _util.FormatError(`invalid object offset in the ObjStm stream: ${offset}`);
                            nums[i] = num;
                            offsets[i] = offset;
                        }
                        const start = (stream.start || 0) + first;
                        const entries = new Array(n);
                        for(let i = 0; i < n; ++i){
                            const length = i < n - 1 ? offsets[i + 1] - offsets[i] : undefined;
                            if (length < 0) throw new _util.FormatError("Invalid offset in the ObjStm stream.");
                            parser = new _parser.Parser({
                                lexer: new _parser.Lexer(stream.makeSubStream(start + offsets[i], length, stream.dict)),
                                xref: this,
                                allowStreams: true
                            });
                            const obj = parser.getObj();
                            entries[i] = obj;
                            if (obj instanceof _base_stream.BaseStream) continue;
                            const num = nums[i], entry = this.entries[num];
                            if (entry && entry.offset === tableOffset && entry.gen === i) this._cacheMap.set(num, obj);
                        }
                        xrefEntry = entries[xrefEntry.gen];
                        if (xrefEntry === undefined) throw new _core_utils.XRefEntryException(`Bad (compressed) XRef entry: ${ref}`);
                        return xrefEntry;
                    }
                    async fetchIfRefAsync(obj, suppressEncryption) {
                        if (obj instanceof _primitives.Ref) return this.fetchAsync(obj, suppressEncryption);
                        return obj;
                    }
                    async fetchAsync(ref, suppressEncryption) {
                        try {
                            return this.fetch(ref, suppressEncryption);
                        } catch (ex) {
                            if (!(ex instanceof _core_utils.MissingDataException)) throw ex;
                            await this.pdfManager.requestRange(ex.begin, ex.end);
                            return this.fetchAsync(ref, suppressEncryption);
                        }
                    }
                    getCatalogObj() {
                        return this.root;
                    }
                }
                exports.XRef = XRef;
            /***/ },
            /* 104 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(2);
                const CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                class MessageHandler {
                    constructor(sourceName, targetName, comObj){
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event)=>{
                            const data = event.data;
                            if (data.targetName !== this.sourceName) return;
                            if (data.stream) {
                                this.#processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                const callbackId = data.callbackId;
                                const capability = this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                                delete this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action = this.actionHandler[data.action];
                            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
                            if (data.callbackId) {
                                const cbSourceName = this.sourceName;
                                const cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                this.#createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName, handler) {
                        const ah = this.actionHandler;
                        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
                        ah[actionName] = handler;
                    }
                    send(actionName, data, transfers) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName,
                            data: data
                        }, transfers);
                    }
                    sendWithPromise(actionName, data, transfers) {
                        const callbackId = this.callbackId++;
                        const capability = new _util.PromiseCapability();
                        this.callbackCapabilities[callbackId] = capability;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName,
                                callbackId: callbackId,
                                data: data
                            }, transfers);
                        } catch (ex) {
                            capability.reject(ex);
                        }
                        return capability.promise;
                    }
                    sendWithStream(actionName, data, queueingStrategy, transfers) {
                        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                        return new ReadableStream({
                            start: (controller)=>{
                                const startCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId] = {
                                    controller: controller,
                                    startCall: startCapability,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    action: actionName,
                                    streamId: streamId,
                                    data: data,
                                    desiredSize: controller.desiredSize
                                }, transfers);
                                return startCapability.promise;
                            },
                            pull: (controller)=>{
                                const pullCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].pullCall = pullCapability;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL,
                                    streamId: streamId,
                                    desiredSize: controller.desiredSize
                                });
                                return pullCapability.promise;
                            },
                            cancel: (reason)=>{
                                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                const cancelCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].cancelCall = cancelCapability;
                                this.streamControllers[streamId].isClosed = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                                return cancelCapability.promise;
                            }
                        }, queueingStrategy);
                    }
                    #createStreamSink(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const self1 = this, action = this.actionHandler[data.action];
                        const streamSink = {
                            enqueue (chunk, size = 1, transfers) {
                                if (this.isCancelled) return;
                                const lastDesiredSize = this.desiredSize;
                                this.desiredSize -= size;
                                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = new _util.PromiseCapability();
                                    this.ready = this.sinkCapability.promise;
                                }
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ENQUEUE,
                                    streamId: streamId,
                                    chunk: chunk
                                }, transfers);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CLOSE,
                                    streamId: streamId
                                });
                                delete self1.streamSinks[streamId];
                            },
                            error (reason) {
                                (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ERROR,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            },
                            sinkCapability: new _util.PromiseCapability(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data.desiredSize,
                            ready: null
                        };
                        streamSink.sinkCapability.resolve();
                        streamSink.ready = streamSink.sinkCapability.promise;
                        this.streamSinks[streamId] = streamSink;
                        new Promise(function(resolve) {
                            resolve(action(data.data, streamSink));
                        }).then(function() {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                success: true
                            });
                        }, function(reason) {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        });
                    }
                    #processStreamMessage(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                        switch(data.stream){
                            case StreamKind.START_COMPLETE:
                                if (data.success) streamController.startCall.resolve();
                                else streamController.startCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL_COMPLETE:
                                if (data.success) streamController.pullCall.resolve();
                                else streamController.pullCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL:
                                if (!streamSink) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                    break;
                                }
                                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                                streamSink.desiredSize = data.desiredSize;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onPull?.());
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                break;
                            case StreamKind.ENQUEUE:
                                (0, _util.assert)(streamController, "enqueue should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.controller.enqueue(data.chunk);
                                break;
                            case StreamKind.CLOSE:
                                (0, _util.assert)(streamController, "close should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.isClosed = true;
                                streamController.controller.close();
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.ERROR:
                                (0, _util.assert)(streamController, "error should have stream controller");
                                streamController.controller.error(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL_COMPLETE:
                                if (data.success) streamController.cancelCall.resolve();
                                else streamController.cancelCall.reject(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL:
                                if (!streamSink) break;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onCancel?.(wrapReason(data.reason)));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                streamSink.sinkCapability.reject(wrapReason(data.reason));
                                streamSink.isCancelled = true;
                                delete this.streamSinks[streamId];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async #deleteStreamController(streamController, streamId) {
                        await Promise.allSettled([
                            streamController.startCall?.promise,
                            streamController.pullCall?.promise,
                            streamController.cancelCall?.promise
                        ]);
                        delete this.streamControllers[streamId];
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 105 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFWorkerStream = void 0;
                var _util = __w_pdfjs_require__(2);
                class PDFWorkerStream {
                    constructor(msgHandler){
                        this._msgHandler = msgHandler;
                        this._contentLength = null;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFWorkerStreamReader(this._msgHandler);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        const reader = new PDFWorkerStreamRangeReader(begin, end, this._msgHandler);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFWorkerStream = PDFWorkerStream;
                class PDFWorkerStreamReader {
                    constructor(msgHandler){
                        this._msgHandler = msgHandler;
                        this.onProgress = null;
                        this._contentLength = null;
                        this._isRangeSupported = false;
                        this._isStreamingSupported = false;
                        const readableStream = this._msgHandler.sendWithStream("GetReader");
                        this._reader = readableStream.getReader();
                        this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((data)=>{
                            this._isStreamingSupported = data.isStreamingSupported;
                            this._isRangeSupported = data.isRangeSupported;
                            this._contentLength = data.contentLength;
                        });
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    async read() {
                        const { value: value, done: done } = await this._reader.read();
                        if (done) return {
                            value: undefined,
                            done: true
                        };
                        return {
                            value: value.buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader.cancel(reason);
                    }
                }
                class PDFWorkerStreamRangeReader {
                    constructor(begin, end, msgHandler){
                        this._msgHandler = msgHandler;
                        this.onProgress = null;
                        const readableStream = this._msgHandler.sendWithStream("GetRangeReader", {
                            begin: begin,
                            end: end
                        });
                        this._reader = readableStream.getReader();
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        const { value: value, done: done } = await this._reader.read();
                        if (done) return {
                            value: undefined,
                            done: true
                        };
                        return {
                            value: value.buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader.cancel(reason);
                    }
                }
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module, module.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "WorkerMessageHandler", {
                enumerable: true,
                get: function() {
                    return _worker.WorkerMessageHandler;
                }
            });
            var _worker = __w_pdfjs_require__(1);
            const pdfjsVersion = "3.11.174";
            const pdfjsBuild = "ce8716743";
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});




// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $640cb49c3d31a828$var$extendStatics = function(d, b) {
    $640cb49c3d31a828$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $640cb49c3d31a828$var$extendStatics(d, b);
};
function $640cb49c3d31a828$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $640cb49c3d31a828$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $640cb49c3d31a828$export$18ce0697a983be9b = function() {
    $640cb49c3d31a828$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $640cb49c3d31a828$export$18ce0697a983be9b.apply(this, arguments);
};
function $640cb49c3d31a828$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $640cb49c3d31a828$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $640cb49c3d31a828$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $640cb49c3d31a828$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $640cb49c3d31a828$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $640cb49c3d31a828$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $640cb49c3d31a828$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $640cb49c3d31a828$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $640cb49c3d31a828$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $640cb49c3d31a828$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $640cb49c3d31a828$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $640cb49c3d31a828$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $640cb49c3d31a828$export$45d3717a4c69092e(o, m, p);
}
function $640cb49c3d31a828$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $640cb49c3d31a828$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $640cb49c3d31a828$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($640cb49c3d31a828$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $640cb49c3d31a828$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $640cb49c3d31a828$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $640cb49c3d31a828$export$10c90e4f7922046c(v) {
    return this instanceof $640cb49c3d31a828$export$10c90e4f7922046c ? (this.v = v, this) : new $640cb49c3d31a828$export$10c90e4f7922046c(v);
}
function $640cb49c3d31a828$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $640cb49c3d31a828$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $640cb49c3d31a828$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $640cb49c3d31a828$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $640cb49c3d31a828$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $640cb49c3d31a828$export$19a8beecd37a4c45 === "function" ? $640cb49c3d31a828$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $640cb49c3d31a828$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $640cb49c3d31a828$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $640cb49c3d31a828$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $640cb49c3d31a828$export$45d3717a4c69092e(result, mod, k);
    }
    $640cb49c3d31a828$var$__setModuleDefault(result, mod);
    return result;
}
function $640cb49c3d31a828$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $640cb49c3d31a828$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $640cb49c3d31a828$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $640cb49c3d31a828$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $640cb49c3d31a828$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $640cb49c3d31a828$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $640cb49c3d31a828$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $640cb49c3d31a828$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $640cb49c3d31a828$export$2e2bcd8739ae039 = {
    __extends: $640cb49c3d31a828$export$a8ba968b8961cb8a,
    __assign: $640cb49c3d31a828$export$18ce0697a983be9b,
    __rest: $640cb49c3d31a828$export$3c9a16f847548506,
    __decorate: $640cb49c3d31a828$export$29e00dfd3077644b,
    __param: $640cb49c3d31a828$export$d5ad3fd78186038f,
    __metadata: $640cb49c3d31a828$export$f1db080c865becb9,
    __awaiter: $640cb49c3d31a828$export$1050f835b63b671e,
    __generator: $640cb49c3d31a828$export$67ebef60e6f28a6,
    __createBinding: $640cb49c3d31a828$export$45d3717a4c69092e,
    __exportStar: $640cb49c3d31a828$export$f33643c0debef087,
    __values: $640cb49c3d31a828$export$19a8beecd37a4c45,
    __read: $640cb49c3d31a828$export$8d051b38c9118094,
    __spread: $640cb49c3d31a828$export$afc72e2116322959,
    __spreadArrays: $640cb49c3d31a828$export$6388937ca91ccae8,
    __spreadArray: $640cb49c3d31a828$export$1216008129fb82ed,
    __await: $640cb49c3d31a828$export$10c90e4f7922046c,
    __asyncGenerator: $640cb49c3d31a828$export$e427f37a30a4de9b,
    __asyncDelegator: $640cb49c3d31a828$export$bbd80228419bb833,
    __asyncValues: $640cb49c3d31a828$export$e3b29a3d6162315f,
    __makeTemplateObject: $640cb49c3d31a828$export$4fb47efe1390b86f,
    __importStar: $640cb49c3d31a828$export$c21735bcef00d192,
    __importDefault: $640cb49c3d31a828$export$da59b14a69baef04,
    __classPrivateFieldGet: $640cb49c3d31a828$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $640cb49c3d31a828$export$d40a35129aaff81f,
    __classPrivateFieldIn: $640cb49c3d31a828$export$81fdc39f203e4e04,
    __addDisposableResource: $640cb49c3d31a828$export$88ac25d8e944e405,
    __disposeResources: $640cb49c3d31a828$export$8f076105dc360e92
};


/**
 * Verifies if an application can use DOM.
 */ function $9d0d0f30b2e111bb$export$71594e8a50f746f4() {
    return(// eslint-disable-next-line no-restricted-globals
    typeof window !== "undefined" && !!// eslint-disable-next-line no-restricted-globals, deprecation/deprecation
    (window.document && window.document.createElement));
}


var $f70a84ea62eace59$var$_window = undefined;
// Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.
try {
    // eslint-disable-next-line no-restricted-globals
    $f70a84ea62eace59$var$_window = window;
} catch (e) {
/* no-op */ }
function $f70a84ea62eace59$export$38b2d434cce3ea22(rootElement) {
    if (!(0, $9d0d0f30b2e111bb$export$71594e8a50f746f4)() || typeof $f70a84ea62eace59$var$_window === "undefined") return undefined;
    else {
        var el = rootElement;
        return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : $f70a84ea62eace59$var$_window;
    }
}


/**
 * Storing global state in local module variables has issues when more than one copy
 * if the module gets loaded on the page (due to a bundling error or simply by consuming
 * a prebundled script.)
 *
 * This file contains helpers to deal with the getting and setting local state, and allows
 * callers to get called back when it mutates.
 */ var $22c1fdaba1636b40$var$GLOBAL_SETTINGS_PROP_NAME = "__globalSettings__";
var $22c1fdaba1636b40$var$CALLBACK_STATE_PROP_NAME = "__callbacks__";
var $22c1fdaba1636b40$var$_counter = 0;
/**
 * Global settings helper, which stores settings in the global (window) namespace.
 * If window is not provided, it will store settings in module scope. Provides a
 * way to observe changes as well when their values change.
 *
 * @public
 * {@docCategory GlobalSettings}
 */ var $22c1fdaba1636b40$export$e962ef7984a884aa = /** @class */ function() {
    function GlobalSettings() {}
    GlobalSettings.getValue = function(key, defaultValue) {
        var globalSettings = $22c1fdaba1636b40$var$_getGlobalSettings();
        if (globalSettings[key] === undefined) globalSettings[key] = typeof defaultValue === "function" ? defaultValue() : defaultValue;
        return globalSettings[key];
    };
    GlobalSettings.setValue = function(key, value) {
        var globalSettings = $22c1fdaba1636b40$var$_getGlobalSettings();
        var callbacks = globalSettings[$22c1fdaba1636b40$var$CALLBACK_STATE_PROP_NAME];
        var oldValue = globalSettings[key];
        if (value !== oldValue) {
            globalSettings[key] = value;
            var changeDescription = {
                oldValue: oldValue,
                value: value,
                key: key
            };
            for(var id in callbacks)if (callbacks.hasOwnProperty(id)) callbacks[id](changeDescription);
        }
        return value;
    };
    GlobalSettings.addChangeListener = function(cb) {
        // Note: we use generated ids on the callbacks to create a map of the callbacks, which optimizes removal.
        // (It's faster to delete a key than it is to look up the index of an object and splice an array.)
        var id = cb.__id__;
        var callbacks = $22c1fdaba1636b40$var$_getCallbacks();
        if (!id) id = cb.__id__ = String($22c1fdaba1636b40$var$_counter++);
        callbacks[id] = cb;
    };
    GlobalSettings.removeChangeListener = function(cb) {
        var callbacks = $22c1fdaba1636b40$var$_getCallbacks();
        delete callbacks[cb.__id__];
    };
    return GlobalSettings;
}();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $22c1fdaba1636b40$var$_getGlobalSettings() {
    var _a;
    var win = (0, $f70a84ea62eace59$export$38b2d434cce3ea22)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalObj = win || {};
    if (!globalObj[$22c1fdaba1636b40$var$GLOBAL_SETTINGS_PROP_NAME]) globalObj[$22c1fdaba1636b40$var$GLOBAL_SETTINGS_PROP_NAME] = (_a = {}, _a[$22c1fdaba1636b40$var$CALLBACK_STATE_PROP_NAME] = {}, _a);
    return globalObj[$22c1fdaba1636b40$var$GLOBAL_SETTINGS_PROP_NAME];
}
function $22c1fdaba1636b40$var$_getCallbacks() {
    var globalSettings = $22c1fdaba1636b40$var$_getGlobalSettings();
    return globalSettings[$22c1fdaba1636b40$var$CALLBACK_STATE_PROP_NAME];
}

/* eslint-disable no-console */ var $0746d9cb5f703649$var$_warningCallback = undefined;
function $0746d9cb5f703649$export$c106dd0671a0fc2d(message) {
    if (console && console.warn) console.warn(message);
}
function $0746d9cb5f703649$export$70b267401ac98961(warningCallback) {
    $0746d9cb5f703649$var$_warningCallback = warningCallback;
}


/**
 * Sets the current RTL value.
 */ function $cbc9a470be9e2629$export$64006deca925fb65(isRTL) {
    if ($cbc9a470be9e2629$var$_rtl !== isRTL) $cbc9a470be9e2629$var$_rtl = isRTL;
}
function $cbc9a470be9e2629$export$b2303637e9533380() {
    if ($cbc9a470be9e2629$var$_rtl === undefined) $cbc9a470be9e2629$var$_rtl = // eslint-disable-next-line no-restricted-globals
    typeof document !== "undefined" && // eslint-disable-next-line no-restricted-globals
    !!document.documentElement && // eslint-disable-next-line no-restricted-globals
    document.documentElement.getAttribute("dir") === "rtl";
    return $cbc9a470be9e2629$var$_rtl;
}
// This has been split into 2 lines because it was working in Fabric due to the code being transpiled to es5, so this
// was converted to var while not working in Fluent that uses babel to transpile the code to be es6-like. Splitting the
// logic into two lines, however, allows it to work in both scenarios.
var $cbc9a470be9e2629$var$_rtl;
$cbc9a470be9e2629$var$_rtl = $cbc9a470be9e2629$export$b2303637e9533380();
function $cbc9a470be9e2629$export$6c4e12d3949051a() {
    return {
        rtl: $cbc9a470be9e2629$export$b2303637e9533380()
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $b64732b010191a16$var$extendStatics = function(d, b) {
    $b64732b010191a16$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b64732b010191a16$var$extendStatics(d, b);
};
function $b64732b010191a16$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b64732b010191a16$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b64732b010191a16$export$18ce0697a983be9b = function() {
    $b64732b010191a16$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b64732b010191a16$export$18ce0697a983be9b.apply(this, arguments);
};
function $b64732b010191a16$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b64732b010191a16$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b64732b010191a16$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b64732b010191a16$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b64732b010191a16$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b64732b010191a16$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $b64732b010191a16$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b64732b010191a16$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b64732b010191a16$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b64732b010191a16$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b64732b010191a16$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b64732b010191a16$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b64732b010191a16$export$45d3717a4c69092e(o, m, p);
}
function $b64732b010191a16$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b64732b010191a16$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b64732b010191a16$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b64732b010191a16$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b64732b010191a16$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b64732b010191a16$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b64732b010191a16$export$10c90e4f7922046c(v) {
    return this instanceof $b64732b010191a16$export$10c90e4f7922046c ? (this.v = v, this) : new $b64732b010191a16$export$10c90e4f7922046c(v);
}
function $b64732b010191a16$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b64732b010191a16$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b64732b010191a16$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b64732b010191a16$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b64732b010191a16$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b64732b010191a16$export$19a8beecd37a4c45 === "function" ? $b64732b010191a16$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b64732b010191a16$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b64732b010191a16$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $b64732b010191a16$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b64732b010191a16$export$45d3717a4c69092e(result, mod, k);
    }
    $b64732b010191a16$var$__setModuleDefault(result, mod);
    return result;
}
function $b64732b010191a16$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b64732b010191a16$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b64732b010191a16$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b64732b010191a16$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b64732b010191a16$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b64732b010191a16$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b64732b010191a16$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b64732b010191a16$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $b64732b010191a16$export$2e2bcd8739ae039 = {
    __extends: $b64732b010191a16$export$a8ba968b8961cb8a,
    __assign: $b64732b010191a16$export$18ce0697a983be9b,
    __rest: $b64732b010191a16$export$3c9a16f847548506,
    __decorate: $b64732b010191a16$export$29e00dfd3077644b,
    __param: $b64732b010191a16$export$d5ad3fd78186038f,
    __metadata: $b64732b010191a16$export$f1db080c865becb9,
    __awaiter: $b64732b010191a16$export$1050f835b63b671e,
    __generator: $b64732b010191a16$export$67ebef60e6f28a6,
    __createBinding: $b64732b010191a16$export$45d3717a4c69092e,
    __exportStar: $b64732b010191a16$export$f33643c0debef087,
    __values: $b64732b010191a16$export$19a8beecd37a4c45,
    __read: $b64732b010191a16$export$8d051b38c9118094,
    __spread: $b64732b010191a16$export$afc72e2116322959,
    __spreadArrays: $b64732b010191a16$export$6388937ca91ccae8,
    __spreadArray: $b64732b010191a16$export$1216008129fb82ed,
    __await: $b64732b010191a16$export$10c90e4f7922046c,
    __asyncGenerator: $b64732b010191a16$export$e427f37a30a4de9b,
    __asyncDelegator: $b64732b010191a16$export$bbd80228419bb833,
    __asyncValues: $b64732b010191a16$export$e3b29a3d6162315f,
    __makeTemplateObject: $b64732b010191a16$export$4fb47efe1390b86f,
    __importStar: $b64732b010191a16$export$c21735bcef00d192,
    __importDefault: $b64732b010191a16$export$da59b14a69baef04,
    __classPrivateFieldGet: $b64732b010191a16$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b64732b010191a16$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b64732b010191a16$export$81fdc39f203e4e04,
    __addDisposableResource: $b64732b010191a16$export$88ac25d8e944e405,
    __disposeResources: $b64732b010191a16$export$8f076105dc360e92
};


var $fc36c4009cda92d3$export$acb42adc2faed244 = {
    /**
     * Avoids style injection, use getRules() to read the styles.
     */ none: 0,
    /**
     * Inserts rules using the insertRule api.
     */ insertNode: 1,
    /**
     * Appends rules using appendChild.
     */ appendChild: 2
};
var $fc36c4009cda92d3$var$STYLESHEET_SETTING = "__stylesheet__";
/**
 * MSIE 11 doesn't cascade styles based on DOM ordering, but rather on the order that each style node
 * is created. As such, to maintain consistent priority, IE11 should reuse a single style node.
 */ var $fc36c4009cda92d3$var$REUSE_STYLE_NODE = typeof navigator !== "undefined" && /rv:11.0/.test(navigator.userAgent);
var $fc36c4009cda92d3$var$_global = {};
// Grab window.
try {
    // Why the cast?
    // if compiled/type checked in same program with `@fluentui/font-icons-mdl2` which extends `Window` on global
    // ( check packages/font-icons-mdl2/src/index.ts ) the definitions don't match! Thus the need of this extra assertion
    $fc36c4009cda92d3$var$_global = window || {};
} catch (_a) {
/* leave as blank object */ }
var $fc36c4009cda92d3$var$_stylesheet;
/**
 * Represents the state of styles registered in the page. Abstracts
 * the surface for adding styles to the stylesheet, exposes helpers
 * for reading the styles registered in server rendered scenarios.
 *
 * @public
 */ var $fc36c4009cda92d3$export$cd02bf5de16fbd7c = /** @class */ function() {
    function Stylesheet(config, serializedStylesheet) {
        var _a, _b, _c, _d, _e, _f;
        this._rules = [];
        this._preservedRules = [];
        this._counter = 0;
        this._keyToClassName = {};
        this._onInsertRuleCallbacks = [];
        this._onResetCallbacks = [];
        this._classNameToArgs = {};
        this._config = (0, $b64732b010191a16$export$18ce0697a983be9b)({
            // If there is no document we won't have an element to inject into.
            injectionMode: typeof document === "undefined" ? $fc36c4009cda92d3$export$acb42adc2faed244.none : $fc36c4009cda92d3$export$acb42adc2faed244.insertNode,
            defaultPrefix: "css",
            namespace: undefined,
            cspSettings: undefined
        }, config);
        this._classNameToArgs = (_a = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.classNameToArgs) !== null && _a !== void 0 ? _a : this._classNameToArgs;
        this._counter = (_b = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.counter) !== null && _b !== void 0 ? _b : this._counter;
        this._keyToClassName = (_d = (_c = this._config.classNameCache) !== null && _c !== void 0 ? _c : serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.keyToClassName) !== null && _d !== void 0 ? _d : this._keyToClassName;
        this._preservedRules = (_e = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.preservedRules) !== null && _e !== void 0 ? _e : this._preservedRules;
        this._rules = (_f = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.rules) !== null && _f !== void 0 ? _f : this._rules;
    }
    /**
     * Gets the singleton instance.
     */ Stylesheet.getInstance = function() {
        $fc36c4009cda92d3$var$_stylesheet = $fc36c4009cda92d3$var$_global[$fc36c4009cda92d3$var$STYLESHEET_SETTING];
        if (!$fc36c4009cda92d3$var$_stylesheet || $fc36c4009cda92d3$var$_stylesheet._lastStyleElement && $fc36c4009cda92d3$var$_stylesheet._lastStyleElement.ownerDocument !== document) {
            var fabricConfig = ($fc36c4009cda92d3$var$_global === null || $fc36c4009cda92d3$var$_global === void 0 ? void 0 : $fc36c4009cda92d3$var$_global.FabricConfig) || {};
            var stylesheet = new Stylesheet(fabricConfig.mergeStyles, fabricConfig.serializedStylesheet);
            $fc36c4009cda92d3$var$_stylesheet = stylesheet;
            $fc36c4009cda92d3$var$_global[$fc36c4009cda92d3$var$STYLESHEET_SETTING] = stylesheet;
        }
        return $fc36c4009cda92d3$var$_stylesheet;
    };
    /**
     * Serializes the Stylesheet instance into a format which allows rehydration on creation.
     * @returns string representation of `ISerializedStylesheet` interface.
     */ Stylesheet.prototype.serialize = function() {
        return JSON.stringify({
            classNameToArgs: this._classNameToArgs,
            counter: this._counter,
            keyToClassName: this._keyToClassName,
            preservedRules: this._preservedRules,
            rules: this._rules
        });
    };
    /**
     * Configures the stylesheet.
     */ Stylesheet.prototype.setConfig = function(config) {
        this._config = (0, $b64732b010191a16$export$18ce0697a983be9b)((0, $b64732b010191a16$export$18ce0697a983be9b)({}, this._config), config);
    };
    /**
     * Configures a reset callback.
     *
     * @param callback - A callback which will be called when the Stylesheet is reset.
     * @returns function which when called un-registers provided callback.
     */ Stylesheet.prototype.onReset = function(callback) {
        var _this = this;
        this._onResetCallbacks.push(callback);
        return function() {
            _this._onResetCallbacks = _this._onResetCallbacks.filter(function(cb) {
                return cb !== callback;
            });
        };
    };
    /**
     * Configures an insert rule callback.
     *
     * @param callback - A callback which will be called when a rule is inserted.
     * @returns function which when called un-registers provided callback.
     */ Stylesheet.prototype.onInsertRule = function(callback) {
        var _this = this;
        this._onInsertRuleCallbacks.push(callback);
        return function() {
            _this._onInsertRuleCallbacks = _this._onInsertRuleCallbacks.filter(function(cb) {
                return cb !== callback;
            });
        };
    };
    /**
     * Generates a unique classname.
     *
     * @param displayName - Optional value to use as a prefix.
     */ Stylesheet.prototype.getClassName = function(displayName) {
        var namespace = this._config.namespace;
        var prefix = displayName || this._config.defaultPrefix;
        return "".concat(namespace ? namespace + "-" : "").concat(prefix, "-").concat(this._counter++);
    };
    /**
     * Used internally to cache information about a class which was
     * registered with the stylesheet.
     */ Stylesheet.prototype.cacheClassName = function(className, key, args, rules) {
        this._keyToClassName[key] = className;
        this._classNameToArgs[className] = {
            args: args,
            rules: rules
        };
    };
    /**
     * Gets the appropriate classname given a key which was previously
     * registered using cacheClassName.
     */ Stylesheet.prototype.classNameFromKey = function(key) {
        return this._keyToClassName[key];
    };
    /**
     * Gets all classnames cache with the stylesheet.
     */ Stylesheet.prototype.getClassNameCache = function() {
        return this._keyToClassName;
    };
    /**
     * Gets the arguments associated with a given classname which was
     * previously registered using cacheClassName.
     */ Stylesheet.prototype.argsFromClassName = function(className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.args;
    };
    /**
     * Gets the rules associated with a given classname which was
     * previously registered using cacheClassName.
     */ Stylesheet.prototype.insertedRulesFromClassName = function(className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.rules;
    };
    /**
     * Inserts a css rule into the stylesheet.
     * @param preserve - Preserves the rule beyond a reset boundary.
     */ Stylesheet.prototype.insertRule = function(rule, preserve) {
        var injectionMode = this._config.injectionMode;
        var element = injectionMode !== $fc36c4009cda92d3$export$acb42adc2faed244.none ? this._getStyleElement() : undefined;
        if (preserve) this._preservedRules.push(rule);
        if (element) switch(injectionMode){
            case $fc36c4009cda92d3$export$acb42adc2faed244.insertNode:
                var sheet = element.sheet;
                try {
                    sheet.insertRule(rule, sheet.cssRules.length);
                } catch (e) {
                // The browser will throw exceptions on unsupported rules (such as a moz prefix in webkit.)
                // We need to swallow the exceptions for this scenario, otherwise we'd need to filter
                // which could be slower and bulkier.
                }
                break;
            case $fc36c4009cda92d3$export$acb42adc2faed244.appendChild:
                element.appendChild(document.createTextNode(rule));
                break;
        }
        else this._rules.push(rule);
        // eslint-disable-next-line deprecation/deprecation
        if (this._config.onInsertRule) // eslint-disable-next-line deprecation/deprecation
        this._config.onInsertRule(rule);
        this._onInsertRuleCallbacks.forEach(function(callback) {
            return callback();
        });
    };
    /**
     * Gets all rules registered with the stylesheet; only valid when
     * using InsertionMode.none.
     */ Stylesheet.prototype.getRules = function(includePreservedRules) {
        return (includePreservedRules ? this._preservedRules.join("") : "") + this._rules.join("");
    };
    /**
     * Resets the internal state of the stylesheet. Only used in server
     * rendered scenarios where we're using InsertionMode.none.
     */ Stylesheet.prototype.reset = function() {
        this._rules = [];
        this._counter = 0;
        this._classNameToArgs = {};
        this._keyToClassName = {};
        this._onResetCallbacks.forEach(function(callback) {
            return callback();
        });
    };
    // Forces the regeneration of incoming styles without totally resetting the stylesheet.
    Stylesheet.prototype.resetKeys = function() {
        this._keyToClassName = {};
    };
    Stylesheet.prototype._getStyleElement = function() {
        var _this = this;
        if (!this._styleElement && typeof document !== "undefined") {
            this._styleElement = this._createStyleElement();
            if (!$fc36c4009cda92d3$var$REUSE_STYLE_NODE) // Reset the style element on the next frame.
            window.requestAnimationFrame(function() {
                _this._styleElement = undefined;
            });
        }
        return this._styleElement;
    };
    Stylesheet.prototype._createStyleElement = function() {
        var head = document.head;
        var styleElement = document.createElement("style");
        var nodeToInsertBefore = null;
        styleElement.setAttribute("data-merge-styles", "true");
        var cspSettings = this._config.cspSettings;
        if (cspSettings) {
            if (cspSettings.nonce) styleElement.setAttribute("nonce", cspSettings.nonce);
        }
        if (this._lastStyleElement) // If the `nextElementSibling` is null, then the insertBefore will act as a regular append.
        // https://developer.mozilla.org/en-US/docs/Web/API/Node/insertBefore#Syntax
        nodeToInsertBefore = this._lastStyleElement.nextElementSibling;
        else {
            var placeholderStyleTag = this._findPlaceholderStyleTag();
            if (placeholderStyleTag) nodeToInsertBefore = placeholderStyleTag.nextElementSibling;
            else nodeToInsertBefore = head.childNodes[0];
        }
        head.insertBefore(styleElement, head.contains(nodeToInsertBefore) ? nodeToInsertBefore : null);
        this._lastStyleElement = styleElement;
        return styleElement;
    };
    Stylesheet.prototype._findPlaceholderStyleTag = function() {
        var head = document.head;
        if (head) return head.querySelector("style[data-merge-styles]");
        return null;
    };
    return Stylesheet;
}();




var $d45f536f0a3a8f69$var$rules = {};
function $d45f536f0a3a8f69$export$81a4f1c533782259(rulePairs, index) {
    var rule = rulePairs[index];
    if (rule.charAt(0) !== "-") rulePairs[index] = $d45f536f0a3a8f69$var$rules[rule] = $d45f536f0a3a8f69$var$rules[rule] || rule.replace(/([A-Z])/g, "-$1").toLowerCase();
}


var $d6fa4e9ce06ade0e$var$_vendorSettings;
function $d6fa4e9ce06ade0e$export$80b0e239f56c8c7d() {
    var _a;
    if (!$d6fa4e9ce06ade0e$var$_vendorSettings) {
        // eslint-disable-next-line no-restricted-globals
        var doc = typeof document !== "undefined" ? document : undefined;
        var nav = typeof navigator !== "undefined" ? navigator : undefined;
        var userAgent = (_a = nav === null || nav === void 0 ? void 0 : nav.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (!doc) $d6fa4e9ce06ade0e$var$_vendorSettings = {
            isWebkit: true,
            isMoz: true,
            isOpera: true,
            isMs: true
        };
        else $d6fa4e9ce06ade0e$var$_vendorSettings = {
            isWebkit: !!(doc && "WebkitAppearance" in doc.documentElement.style),
            isMoz: !!(userAgent && userAgent.indexOf("firefox") > -1),
            isOpera: !!(userAgent && userAgent.indexOf("opera") > -1),
            isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
        };
    }
    return $d6fa4e9ce06ade0e$var$_vendorSettings;
}
function $d6fa4e9ce06ade0e$export$9f7e3c53560dab05(vendorSettings) {
    $d6fa4e9ce06ade0e$var$_vendorSettings = vendorSettings;
}


var $53a5779013235aa4$var$autoPrefixNames = {
    "user-select": 1
};
function $53a5779013235aa4$export$6c6679cd94cc8e5a(rulePairs, index) {
    var vendorSettings = (0, $d6fa4e9ce06ade0e$export$80b0e239f56c8c7d)();
    var name = rulePairs[index];
    if ($53a5779013235aa4$var$autoPrefixNames[name]) {
        var value = rulePairs[index + 1];
        if ($53a5779013235aa4$var$autoPrefixNames[name]) {
            if (vendorSettings.isWebkit) rulePairs.push("-webkit-" + name, value);
            if (vendorSettings.isMoz) rulePairs.push("-moz-" + name, value);
            if (vendorSettings.isMs) rulePairs.push("-ms-" + name, value);
            if (vendorSettings.isOpera) rulePairs.push("-o-" + name, value);
        }
    }
}


var $9faaaec3dd6cecef$var$NON_PIXEL_NUMBER_PROPS = [
    "column-count",
    "font-weight",
    "flex",
    "flex-grow",
    "flex-shrink",
    "fill-opacity",
    "opacity",
    "order",
    "z-index",
    "zoom"
];
function $9faaaec3dd6cecef$export$4d98e579c8cf34c8(rulePairs, index) {
    var name = rulePairs[index];
    var value = rulePairs[index + 1];
    if (typeof value === "number") {
        var isNonPixelProp = $9faaaec3dd6cecef$var$NON_PIXEL_NUMBER_PROPS.indexOf(name) > -1;
        var isVariableOrPrefixed = name.indexOf("--") > -1;
        var unit = isNonPixelProp || isVariableOrPrefixed ? "" : "px";
        rulePairs[index + 1] = "".concat(value).concat(unit);
    }
}


var $5bfc0b61272b9529$var$_a;
var $5bfc0b61272b9529$var$LEFT = "left";
var $5bfc0b61272b9529$var$RIGHT = "right";
var $5bfc0b61272b9529$var$NO_FLIP = "@noflip";
var $5bfc0b61272b9529$var$NAME_REPLACEMENTS = ($5bfc0b61272b9529$var$_a = {}, $5bfc0b61272b9529$var$_a[$5bfc0b61272b9529$var$LEFT] = $5bfc0b61272b9529$var$RIGHT, $5bfc0b61272b9529$var$_a[$5bfc0b61272b9529$var$RIGHT] = $5bfc0b61272b9529$var$LEFT, $5bfc0b61272b9529$var$_a);
var $5bfc0b61272b9529$var$VALUE_REPLACEMENTS = {
    "w-resize": "e-resize",
    "sw-resize": "se-resize",
    "nw-resize": "ne-resize"
};
function $5bfc0b61272b9529$export$79e12f79f6fb4537(options, rulePairs, index) {
    if (options.rtl) {
        var name_1 = rulePairs[index];
        if (!name_1) return;
        var value = rulePairs[index + 1];
        if (typeof value === "string" && value.indexOf($5bfc0b61272b9529$var$NO_FLIP) >= 0) rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, "");
        else if (name_1.indexOf($5bfc0b61272b9529$var$LEFT) >= 0) rulePairs[index] = name_1.replace($5bfc0b61272b9529$var$LEFT, $5bfc0b61272b9529$var$RIGHT);
        else if (name_1.indexOf($5bfc0b61272b9529$var$RIGHT) >= 0) rulePairs[index] = name_1.replace($5bfc0b61272b9529$var$RIGHT, $5bfc0b61272b9529$var$LEFT);
        else if (String(value).indexOf($5bfc0b61272b9529$var$LEFT) >= 0) rulePairs[index + 1] = value.replace($5bfc0b61272b9529$var$LEFT, $5bfc0b61272b9529$var$RIGHT);
        else if (String(value).indexOf($5bfc0b61272b9529$var$RIGHT) >= 0) rulePairs[index + 1] = value.replace($5bfc0b61272b9529$var$RIGHT, $5bfc0b61272b9529$var$LEFT);
        else if ($5bfc0b61272b9529$var$NAME_REPLACEMENTS[name_1]) rulePairs[index] = $5bfc0b61272b9529$var$NAME_REPLACEMENTS[name_1];
        else if ($5bfc0b61272b9529$var$VALUE_REPLACEMENTS[value]) rulePairs[index + 1] = $5bfc0b61272b9529$var$VALUE_REPLACEMENTS[value];
        else switch(name_1){
            case "margin":
            case "padding":
                rulePairs[index + 1] = $5bfc0b61272b9529$var$flipQuad(value);
                break;
            case "box-shadow":
                rulePairs[index + 1] = $5bfc0b61272b9529$var$negateNum(value, 0);
                break;
        }
    }
}
/**
 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
 */ function $5bfc0b61272b9529$var$negateNum(value, partIndex) {
    var parts = value.split(" ");
    var numberVal = parseInt(parts[partIndex], 10);
    parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
    return parts.join(" ");
}
/**
 * Given a string quad, flips the left and right values.
 */ function $5bfc0b61272b9529$var$flipQuad(value) {
    if (typeof value === "string") {
        var parts = value.split(" ");
        if (parts.length === 4) return "".concat(parts[0], " ").concat(parts[3], " ").concat(parts[2], " ").concat(parts[1]);
    }
    return value;
}


/**
 * Split a string into tokens separated by whitespace, except all text within parentheses
 * is treated as a single token (whitespace is ignored within parentheses).
 *
 * Unlike String.split(' '), multiple consecutive space characters are collapsed and
 * removed from the returned array (including leading and trailing spaces).
 *
 * For example:
 * `tokenizeWithParentheses("3px calc(var(--x) / 2) 9px    0 ")`
 *   => `["3px", "calc(var(--x) / 2)", "9px", "0"]`
 *
 * @returns The array of tokens. Returns an empty array if the string was empty or contained only whitespace.
 */ function $faa262d5761671e4$export$73b82e713dad971(value) {
    var parts = [];
    var partStart = 0;
    var parens = 0;
    for(var i = 0; i < value.length; i++)switch(value[i]){
        case "(":
            parens++;
            break;
        case ")":
            if (parens) parens--;
            break;
        case "	":
        case " ":
            if (!parens) {
                // Add the new part if it's not an empty string
                if (i > partStart) parts.push(value.substring(partStart, i));
                partStart = i + 1;
            }
            break;
    }
    // Add the last part
    if (partStart < value.length) parts.push(value.substring(partStart));
    return parts;
}


var $41688763f289313f$var$DISPLAY_NAME = "displayName";
function $41688763f289313f$var$getDisplayName(rules) {
    var rootStyle = rules && rules["&"];
    return rootStyle ? rootStyle.displayName : undefined;
}
var $41688763f289313f$var$globalSelectorRegExp = /\:global\((.+?)\)/g;
/**
 * Finds comma separated selectors in a :global() e.g. ":global(.class1, .class2, .class3)"
 * and wraps them each in their own global ":global(.class1), :global(.class2), :global(.class3)"
 *
 * @param selectorWithGlobals The selector to process
 * @returns The updated selector
 */ function $41688763f289313f$var$expandCommaSeparatedGlobals(selectorWithGlobals) {
    // We the selector does not have a :global() we can shortcut
    if (!$41688763f289313f$var$globalSelectorRegExp.test(selectorWithGlobals)) return selectorWithGlobals;
    var replacementInfo = [];
    var findGlobal = /\:global\((.+?)\)/g;
    var match = null;
    // Create a result list for global selectors so we can replace them.
    while(match = findGlobal.exec(selectorWithGlobals))// Only if the found selector is a comma separated list we'll process it.
    if (match[1].indexOf(",") > -1) replacementInfo.push([
        match.index,
        match.index + match[0].length,
        // Wrap each of the found selectors in :global()
        match[1].split(",").map(function(v) {
            return ":global(".concat(v.trim(), ")");
        }).join(", ")
    ]);
    // Replace the found selectors with their wrapped variants in reverse order
    return replacementInfo.reverse().reduce(function(selector, _a) {
        var matchIndex = _a[0], matchEndIndex = _a[1], replacement = _a[2];
        var prefix = selector.slice(0, matchIndex);
        var suffix = selector.slice(matchEndIndex);
        return prefix + replacement + suffix;
    }, selectorWithGlobals);
}
function $41688763f289313f$var$expandSelector(newSelector, currentSelector) {
    if (newSelector.indexOf(":global(") >= 0) return newSelector.replace($41688763f289313f$var$globalSelectorRegExp, "$1");
    else if (newSelector.indexOf(":") === 0) return currentSelector + newSelector;
    else if (newSelector.indexOf("&") < 0) return currentSelector + " " + newSelector;
    return newSelector;
}
function $41688763f289313f$var$extractSelector(currentSelector, rules, selector, value) {
    if (rules === void 0) rules = {
        __order: []
    };
    if (selector.indexOf("@") === 0) {
        selector = selector + "{" + currentSelector;
        $41688763f289313f$var$extractRules([
            value
        ], rules, selector);
    } else if (selector.indexOf(",") > -1) $41688763f289313f$var$expandCommaSeparatedGlobals(selector).split(",").map(function(s) {
        return s.trim();
    }).forEach(function(separatedSelector) {
        return $41688763f289313f$var$extractRules([
            value
        ], rules, $41688763f289313f$var$expandSelector(separatedSelector, currentSelector));
    });
    else $41688763f289313f$var$extractRules([
        value
    ], rules, $41688763f289313f$var$expandSelector(selector, currentSelector));
}
function $41688763f289313f$var$extractRules(args, rules, currentSelector) {
    if (rules === void 0) rules = {
        __order: []
    };
    if (currentSelector === void 0) currentSelector = "&";
    var stylesheet = (0, $fc36c4009cda92d3$export$cd02bf5de16fbd7c).getInstance();
    var currentRules = rules[currentSelector];
    if (!currentRules) {
        currentRules = {};
        rules[currentSelector] = currentRules;
        rules.__order.push(currentSelector);
    }
    for(var _i = 0, args_1 = args; _i < args_1.length; _i++){
        var arg = args_1[_i];
        // If the arg is a string, we need to look up the class map and merge.
        if (typeof arg === "string") {
            var expandedRules = stylesheet.argsFromClassName(arg);
            if (expandedRules) $41688763f289313f$var$extractRules(expandedRules, rules, currentSelector);
        // Else if the arg is an array, we need to recurse in.
        } else if (Array.isArray(arg)) $41688763f289313f$var$extractRules(arg, rules, currentSelector);
        else {
            for(var prop in arg)if (arg.hasOwnProperty(prop)) {
                var propValue = arg[prop];
                if (prop === "selectors") {
                    // every child is a selector.
                    var selectors = arg.selectors;
                    for(var newSelector in selectors)if (selectors.hasOwnProperty(newSelector)) $41688763f289313f$var$extractSelector(currentSelector, rules, newSelector, selectors[newSelector]);
                } else if (typeof propValue === "object") // prop is a selector.
                {
                    if (propValue !== null) $41688763f289313f$var$extractSelector(currentSelector, rules, prop, propValue);
                } else if (propValue !== undefined) {
                    // Else, add the rule to the currentSelector.
                    if (prop === "margin" || prop === "padding") $41688763f289313f$var$expandQuads(currentRules, prop, propValue);
                    else currentRules[prop] = propValue;
                }
            }
        }
    }
    return rules;
}
function $41688763f289313f$var$expandQuads(currentRules, name, value) {
    var parts = typeof value === "string" ? (0, $faa262d5761671e4$export$73b82e713dad971)(value) : [
        value
    ];
    if (parts.length === 0) parts.push(value);
    if (parts[parts.length - 1] === "!important") // Remove !important from parts, and append it to each part individually
    parts = parts.slice(0, -1).map(function(p) {
        return p + " !important";
    });
    currentRules[name + "Top"] = parts[0];
    currentRules[name + "Right"] = parts[1] || parts[0];
    currentRules[name + "Bottom"] = parts[2] || parts[0];
    currentRules[name + "Left"] = parts[3] || parts[1] || parts[0];
}
function $41688763f289313f$var$getKeyForRules(options, rules) {
    var serialized = [
        options.rtl ? "rtl" : "ltr"
    ];
    var hasProps = false;
    for(var _i = 0, _a = rules.__order; _i < _a.length; _i++){
        var selector = _a[_i];
        serialized.push(selector);
        var rulesForSelector = rules[selector];
        for(var propName in rulesForSelector)if (rulesForSelector.hasOwnProperty(propName) && rulesForSelector[propName] !== undefined) {
            hasProps = true;
            serialized.push(propName, rulesForSelector[propName]);
        }
    }
    return hasProps ? serialized.join("") : undefined;
}
function $41688763f289313f$var$repeatString(target, count) {
    if (count <= 0) return "";
    if (count === 1) return target;
    return target + $41688763f289313f$var$repeatString(target, count - 1);
}
function $41688763f289313f$export$4080b13ebe249c61(options, ruleEntries) {
    if (!ruleEntries) return "";
    var allEntries = [];
    for(var entry in ruleEntries)if (ruleEntries.hasOwnProperty(entry) && entry !== $41688763f289313f$var$DISPLAY_NAME && ruleEntries[entry] !== undefined) allEntries.push(entry, ruleEntries[entry]);
    // Apply transforms.
    for(var i = 0; i < allEntries.length; i += 2){
        (0, $d45f536f0a3a8f69$export$81a4f1c533782259)(allEntries, i);
        (0, $9faaaec3dd6cecef$export$4d98e579c8cf34c8)(allEntries, i);
        (0, $5bfc0b61272b9529$export$79e12f79f6fb4537)(options, allEntries, i);
        (0, $53a5779013235aa4$export$6c6679cd94cc8e5a)(allEntries, i);
    }
    // Apply punctuation.
    for(var i = 1; i < allEntries.length; i += 4)allEntries.splice(i, 1, ":", allEntries[i], ";");
    return allEntries.join("");
}
function $41688763f289313f$export$f51c5a57f5409a02(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var rules = $41688763f289313f$var$extractRules(args);
    var key = $41688763f289313f$var$getKeyForRules(options, rules);
    if (key) {
        var stylesheet = (0, $fc36c4009cda92d3$export$cd02bf5de16fbd7c).getInstance();
        var registration = {
            className: stylesheet.classNameFromKey(key),
            key: key,
            args: args
        };
        if (!registration.className) {
            registration.className = stylesheet.getClassName($41688763f289313f$var$getDisplayName(rules));
            var rulesToInsert = [];
            for(var _a = 0, _b = rules.__order; _a < _b.length; _a++){
                var selector = _b[_a];
                rulesToInsert.push(selector, $41688763f289313f$export$4080b13ebe249c61(options, rules[selector]));
            }
            registration.rulesToInsert = rulesToInsert;
        }
        return registration;
    }
    return undefined;
}
function $41688763f289313f$export$cf30abcc7f4a413c(registration, specificityMultiplier) {
    if (specificityMultiplier === void 0) specificityMultiplier = 1;
    var stylesheet = (0, $fc36c4009cda92d3$export$cd02bf5de16fbd7c).getInstance();
    var className = registration.className, key = registration.key, args = registration.args, rulesToInsert = registration.rulesToInsert;
    if (rulesToInsert) {
        // rulesToInsert is an ordered array of selector/rule pairs.
        for(var i = 0; i < rulesToInsert.length; i += 2){
            var rules = rulesToInsert[i + 1];
            if (rules) {
                var selector = rulesToInsert[i];
                selector = selector.replace(/&/g, $41688763f289313f$var$repeatString(".".concat(registration.className), specificityMultiplier));
                // Insert. Note if a media query, we must close the query with a final bracket.
                var processedRule = "".concat(selector, "{").concat(rules, "}").concat(selector.indexOf("@") === 0 ? "}" : "");
                stylesheet.insertRule(processedRule);
            }
        }
        stylesheet.cacheClassName(className, key, args, rulesToInsert);
    }
}
function $41688763f289313f$export$40e90054d98a04a(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var registration = $41688763f289313f$export$f51c5a57f5409a02.apply(void 0, (0, $b64732b010191a16$export$1216008129fb82ed)([
        options
    ], args, false));
    if (registration) {
        $41688763f289313f$export$cf30abcc7f4a413c(registration, options.specificityMultiplier);
        return registration.className;
    }
    return "";
}


function $f0eb144b01193d25$export$566c6c2ff0443c7(font) {
    var stylesheet = (0, $fc36c4009cda92d3$export$cd02bf5de16fbd7c).getInstance();
    var rule = (0, $41688763f289313f$export$4080b13ebe249c61)((0, $cbc9a470be9e2629$export$6c4e12d3949051a)(), font);
    var className = stylesheet.classNameFromKey(rule);
    if (className) return;
    var name = stylesheet.getClassName();
    stylesheet.insertRule("@font-face{".concat(rule, "}"), true);
    stylesheet.cacheClassName(name, rule, [], [
        "font-face",
        rule
    ]);
}


function $6ee6f4c443cb5583$export$b1c01d3d68dc0b88() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var classes = [];
    var objects = [];
    var stylesheet = (0, $fc36c4009cda92d3$export$cd02bf5de16fbd7c).getInstance();
    function _processArgs(argsList) {
        for(var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++){
            var arg = argsList_1[_i];
            if (arg) {
                if (typeof arg === "string") {
                    if (arg.indexOf(" ") >= 0) _processArgs(arg.split(" "));
                    else {
                        var translatedArgs = stylesheet.argsFromClassName(arg);
                        if (translatedArgs) _processArgs(translatedArgs);
                        else // Avoid adding the same class twice.
                        if (classes.indexOf(arg) === -1) classes.push(arg);
                    }
                } else if (Array.isArray(arg)) _processArgs(arg);
                else if (typeof arg === "object") objects.push(arg);
            }
        }
    }
    _processArgs(args);
    return {
        classes: classes,
        objects: objects
    };
}




function $1f101111d586669c$export$e618dc39ac9ad607() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $1f101111d586669c$export$f77a3199de250644(args, (0, $cbc9a470be9e2629$export$6c4e12d3949051a)());
}
function $1f101111d586669c$export$f77a3199de250644(args, options) {
    var styleArgs = args instanceof Array ? args : [
        args
    ];
    var _a = (0, $6ee6f4c443cb5583$export$b1c01d3d68dc0b88)(styleArgs), classes = _a.classes, objects = _a.objects;
    if (objects.length) classes.push((0, $41688763f289313f$export$40e90054d98a04a)(options || {}, objects));
    return classes.join(" ");
}


var $a5216fef1aadcd25$var$ICON_SETTING_NAME = "icons";
var $a5216fef1aadcd25$var$_iconSettings = (0, $22c1fdaba1636b40$export$e962ef7984a884aa).getValue($a5216fef1aadcd25$var$ICON_SETTING_NAME, {
    __options: {
        disableWarnings: false,
        warnOnMissingIcons: true
    },
    __remapped: {}
});
// Reset icon registration on stylesheet resets.
var $a5216fef1aadcd25$var$stylesheet = (0, $fc36c4009cda92d3$export$cd02bf5de16fbd7c).getInstance();
if ($a5216fef1aadcd25$var$stylesheet && $a5216fef1aadcd25$var$stylesheet.onReset) $a5216fef1aadcd25$var$stylesheet.onReset(function() {
    for(var name_1 in $a5216fef1aadcd25$var$_iconSettings)if ($a5216fef1aadcd25$var$_iconSettings.hasOwnProperty(name_1) && !!$a5216fef1aadcd25$var$_iconSettings[name_1].subset) $a5216fef1aadcd25$var$_iconSettings[name_1].subset.className = undefined;
});
/**
 * Normalizes an icon name for consistent mapping.
 * Current implementation is to convert the icon name to lower case.
 *
 * @param name - Icon name to normalize.
 * @returns {string} Normalized icon name to use for indexing and mapping.
 */ var $a5216fef1aadcd25$var$normalizeIconName = function(name) {
    return name.toLowerCase();
};
function $a5216fef1aadcd25$export$99b432e1290ef823(iconSubset, options) {
    var subset = (0, $640cb49c3d31a828$export$18ce0697a983be9b)((0, $640cb49c3d31a828$export$18ce0697a983be9b)({}, iconSubset), {
        isRegistered: false,
        className: undefined
    });
    var icons = iconSubset.icons;
    // Grab options, optionally mix user provided ones on top.
    options = options ? (0, $640cb49c3d31a828$export$18ce0697a983be9b)((0, $640cb49c3d31a828$export$18ce0697a983be9b)({}, $a5216fef1aadcd25$var$_iconSettings.__options), options) : $a5216fef1aadcd25$var$_iconSettings.__options;
    for(var iconName in icons)if (icons.hasOwnProperty(iconName)) {
        var code = icons[iconName];
        var normalizedIconName = $a5216fef1aadcd25$var$normalizeIconName(iconName);
        if ($a5216fef1aadcd25$var$_iconSettings[normalizedIconName]) $a5216fef1aadcd25$var$_warnDuplicateIcon(iconName);
        else $a5216fef1aadcd25$var$_iconSettings[normalizedIconName] = {
            code: code,
            subset: subset
        };
    }
}
function $a5216fef1aadcd25$export$d4eb2d2d2a4efe94(iconNames) {
    var options = $a5216fef1aadcd25$var$_iconSettings.__options;
    var _loop_1 = function(iconName) {
        var normalizedIconName = $a5216fef1aadcd25$var$normalizeIconName(iconName);
        if ($a5216fef1aadcd25$var$_iconSettings[normalizedIconName]) delete $a5216fef1aadcd25$var$_iconSettings[normalizedIconName];
        else // Warn that we are trying to delete an icon that doesn't exist
        if (!options.disableWarnings) (0, $0746d9cb5f703649$export$c106dd0671a0fc2d)('The icon "'.concat(iconName, '" tried to unregister but was not registered.'));
        // Delete any aliases for this iconName
        if ($a5216fef1aadcd25$var$_iconSettings.__remapped[normalizedIconName]) delete $a5216fef1aadcd25$var$_iconSettings.__remapped[normalizedIconName];
        // Delete any items that were an alias for this iconName
        Object.keys($a5216fef1aadcd25$var$_iconSettings.__remapped).forEach(function(key) {
            if ($a5216fef1aadcd25$var$_iconSettings.__remapped[key] === normalizedIconName) delete $a5216fef1aadcd25$var$_iconSettings.__remapped[key];
        });
    };
    for(var _i = 0, iconNames_1 = iconNames; _i < iconNames_1.length; _i++){
        var iconName = iconNames_1[_i];
        _loop_1(iconName);
    }
}
function $a5216fef1aadcd25$export$4fad376c7613260(iconName, mappedToName) {
    $a5216fef1aadcd25$var$_iconSettings.__remapped[$a5216fef1aadcd25$var$normalizeIconName(iconName)] = $a5216fef1aadcd25$var$normalizeIconName(mappedToName);
}
function $a5216fef1aadcd25$export$16b26cd5e98d9100(name) {
    var icon = undefined;
    var options = $a5216fef1aadcd25$var$_iconSettings.__options;
    name = name ? $a5216fef1aadcd25$var$normalizeIconName(name) : "";
    name = $a5216fef1aadcd25$var$_iconSettings.__remapped[name] || name;
    if (name) {
        icon = $a5216fef1aadcd25$var$_iconSettings[name];
        if (icon) {
            var subset = icon.subset;
            if (subset && subset.fontFace) {
                if (!subset.isRegistered) {
                    (0, $f0eb144b01193d25$export$566c6c2ff0443c7)(subset.fontFace);
                    subset.isRegistered = true;
                }
                if (!subset.className) subset.className = (0, $1f101111d586669c$export$e618dc39ac9ad607)(subset.style, {
                    fontFamily: subset.fontFace.fontFamily,
                    fontWeight: subset.fontFace.fontWeight || "normal",
                    fontStyle: subset.fontFace.fontStyle || "normal"
                });
            }
        } else // eslint-disable-next-line deprecation/deprecation
        if (!options.disableWarnings && options.warnOnMissingIcons) (0, $0746d9cb5f703649$export$c106dd0671a0fc2d)('The icon "'.concat(name, '" was used but not registered. See https://github.com/microsoft/fluentui/wiki/Using-icons for more information.'));
    }
    return icon;
}
function $a5216fef1aadcd25$export$931896f68834c675(options) {
    $a5216fef1aadcd25$var$_iconSettings.__options = (0, $640cb49c3d31a828$export$18ce0697a983be9b)((0, $640cb49c3d31a828$export$18ce0697a983be9b)({}, $a5216fef1aadcd25$var$_iconSettings.__options), options);
}
var $a5216fef1aadcd25$var$_missingIcons = [];
var $a5216fef1aadcd25$var$_missingIconsTimer = undefined;
function $a5216fef1aadcd25$var$_warnDuplicateIcon(iconName) {
    var options = $a5216fef1aadcd25$var$_iconSettings.__options;
    var warningDelay = 2000;
    var maxIconsInMessage = 10;
    if (!options.disableWarnings) {
        $a5216fef1aadcd25$var$_missingIcons.push(iconName);
        if ($a5216fef1aadcd25$var$_missingIconsTimer === undefined) $a5216fef1aadcd25$var$_missingIconsTimer = setTimeout(function() {
            (0, $0746d9cb5f703649$export$c106dd0671a0fc2d)("Some icons were re-registered. Applications should only call registerIcons for any given icon once. Redefining what an icon is may have unintended consequences. Duplicates include: \n" + $a5216fef1aadcd25$var$_missingIcons.slice(0, maxIconsInMessage).join(", ") + ($a5216fef1aadcd25$var$_missingIcons.length > maxIconsInMessage ? " (+ ".concat($a5216fef1aadcd25$var$_missingIcons.length - maxIconsInMessage, " more)") : ""));
            $a5216fef1aadcd25$var$_missingIconsTimer = undefined;
            $a5216fef1aadcd25$var$_missingIcons = [];
        }, warningDelay);
    }
}




var $a0b99536f83d2b4d$export$61818e3b2f7b5d12 = "https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001";


// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.
// A packages cache that makes sure that we don't inject the same packageName twice in the same bundle -
// this cache is local to the module closure inside this bundle
var $6a1ca41917aa4f58$var$packagesCache = {};
// Cache access to window to avoid IE11 memory leak.
var $6a1ca41917aa4f58$var$_win = undefined;
try {
    $6a1ca41917aa4f58$var$_win = window;
} catch (e) {
/* no-op */ }
function $6a1ca41917aa4f58$export$f99c3c9c04cda7ae(packageName, packageVersion) {
    if (typeof $6a1ca41917aa4f58$var$_win !== "undefined") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var packages = $6a1ca41917aa4f58$var$_win.__packages__ = $6a1ca41917aa4f58$var$_win.__packages__ || {};
        // We allow either the global packages or local packages caches to invalidate so testing can
        // just clear the global to set this state
        if (!packages[packageName] || !$6a1ca41917aa4f58$var$packagesCache[packageName]) {
            $6a1ca41917aa4f58$var$packagesCache[packageName] = packageVersion;
            var versions = packages[packageName] = packages[packageName] || [];
            versions.push(packageVersion);
        }
    }
}


(0, $6a1ca41917aa4f58$export$f99c3c9c04cda7ae)("@fluentui/set-version", "6.0.0");


(0, $6a1ca41917aa4f58$export$f99c3c9c04cda7ae)("@fluentui/style-utilities", "8.10.3");



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $d7661eab063caad7$var$extendStatics = function(d, b) {
    $d7661eab063caad7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d7661eab063caad7$var$extendStatics(d, b);
};
function $d7661eab063caad7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d7661eab063caad7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d7661eab063caad7$export$18ce0697a983be9b = function() {
    $d7661eab063caad7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d7661eab063caad7$export$18ce0697a983be9b.apply(this, arguments);
};
function $d7661eab063caad7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d7661eab063caad7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d7661eab063caad7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d7661eab063caad7$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d7661eab063caad7$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d7661eab063caad7$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $d7661eab063caad7$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d7661eab063caad7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d7661eab063caad7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d7661eab063caad7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d7661eab063caad7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d7661eab063caad7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d7661eab063caad7$export$45d3717a4c69092e(o, m, p);
}
function $d7661eab063caad7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d7661eab063caad7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d7661eab063caad7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d7661eab063caad7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d7661eab063caad7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d7661eab063caad7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d7661eab063caad7$export$10c90e4f7922046c(v) {
    return this instanceof $d7661eab063caad7$export$10c90e4f7922046c ? (this.v = v, this) : new $d7661eab063caad7$export$10c90e4f7922046c(v);
}
function $d7661eab063caad7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d7661eab063caad7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d7661eab063caad7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d7661eab063caad7$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d7661eab063caad7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d7661eab063caad7$export$19a8beecd37a4c45 === "function" ? $d7661eab063caad7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d7661eab063caad7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d7661eab063caad7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $d7661eab063caad7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d7661eab063caad7$export$45d3717a4c69092e(result, mod, k);
    }
    $d7661eab063caad7$var$__setModuleDefault(result, mod);
    return result;
}
function $d7661eab063caad7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d7661eab063caad7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d7661eab063caad7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d7661eab063caad7$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d7661eab063caad7$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d7661eab063caad7$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d7661eab063caad7$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d7661eab063caad7$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $d7661eab063caad7$export$2e2bcd8739ae039 = {
    __extends: $d7661eab063caad7$export$a8ba968b8961cb8a,
    __assign: $d7661eab063caad7$export$18ce0697a983be9b,
    __rest: $d7661eab063caad7$export$3c9a16f847548506,
    __decorate: $d7661eab063caad7$export$29e00dfd3077644b,
    __param: $d7661eab063caad7$export$d5ad3fd78186038f,
    __metadata: $d7661eab063caad7$export$f1db080c865becb9,
    __awaiter: $d7661eab063caad7$export$1050f835b63b671e,
    __generator: $d7661eab063caad7$export$67ebef60e6f28a6,
    __createBinding: $d7661eab063caad7$export$45d3717a4c69092e,
    __exportStar: $d7661eab063caad7$export$f33643c0debef087,
    __values: $d7661eab063caad7$export$19a8beecd37a4c45,
    __read: $d7661eab063caad7$export$8d051b38c9118094,
    __spread: $d7661eab063caad7$export$afc72e2116322959,
    __spreadArrays: $d7661eab063caad7$export$6388937ca91ccae8,
    __spreadArray: $d7661eab063caad7$export$1216008129fb82ed,
    __await: $d7661eab063caad7$export$10c90e4f7922046c,
    __asyncGenerator: $d7661eab063caad7$export$e427f37a30a4de9b,
    __asyncDelegator: $d7661eab063caad7$export$bbd80228419bb833,
    __asyncValues: $d7661eab063caad7$export$e3b29a3d6162315f,
    __makeTemplateObject: $d7661eab063caad7$export$4fb47efe1390b86f,
    __importStar: $d7661eab063caad7$export$c21735bcef00d192,
    __importDefault: $d7661eab063caad7$export$da59b14a69baef04,
    __classPrivateFieldGet: $d7661eab063caad7$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d7661eab063caad7$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d7661eab063caad7$export$81fdc39f203e4e04,
    __addDisposableResource: $d7661eab063caad7$export$88ac25d8e944e405,
    __disposeResources: $d7661eab063caad7$export$8f076105dc360e92
};



var $135c79815f35f38e$var$CustomizationsGlobalKey = "customizations";
var $135c79815f35f38e$var$NO_CUSTOMIZATIONS = {
    settings: {},
    scopedSettings: {},
    inCustomizerContext: false
};
var $135c79815f35f38e$var$_allSettings = (0, $22c1fdaba1636b40$export$e962ef7984a884aa).getValue($135c79815f35f38e$var$CustomizationsGlobalKey, {
    settings: {},
    scopedSettings: {},
    inCustomizerContext: false
});
var $135c79815f35f38e$var$_events = [];
var $135c79815f35f38e$export$cbb5b5586292cdb = /** @class */ function() {
    function Customizations() {}
    Customizations.reset = function() {
        $135c79815f35f38e$var$_allSettings.settings = {};
        $135c79815f35f38e$var$_allSettings.scopedSettings = {};
    };
    /** Apply global Customization settings.
     * @example Customizations.applySettings(\{ theme: \{...\} \});
     */ Customizations.applySettings = function(settings) {
        $135c79815f35f38e$var$_allSettings.settings = (0, $d7661eab063caad7$export$18ce0697a983be9b)((0, $d7661eab063caad7$export$18ce0697a983be9b)({}, $135c79815f35f38e$var$_allSettings.settings), settings);
        Customizations._raiseChange();
    };
    /** Apply Customizations to a particular named scope, like a component.
     * @example Customizations.applyScopedSettings('Nav', \{ styles: () =\> \{\} \});
     */ Customizations.applyScopedSettings = function(scopeName, settings) {
        $135c79815f35f38e$var$_allSettings.scopedSettings[scopeName] = (0, $d7661eab063caad7$export$18ce0697a983be9b)((0, $d7661eab063caad7$export$18ce0697a983be9b)({}, $135c79815f35f38e$var$_allSettings.scopedSettings[scopeName]), settings);
        Customizations._raiseChange();
    };
    Customizations.getSettings = function(properties, scopeName, localSettings) {
        if (localSettings === void 0) localSettings = $135c79815f35f38e$var$NO_CUSTOMIZATIONS;
        var settings = {};
        var localScopedSettings = scopeName && localSettings.scopedSettings[scopeName] || {};
        var globalScopedSettings = scopeName && $135c79815f35f38e$var$_allSettings.scopedSettings[scopeName] || {};
        for(var _i = 0, properties_1 = properties; _i < properties_1.length; _i++){
            var property = properties_1[_i];
            settings[property] = localScopedSettings[property] || localSettings.settings[property] || globalScopedSettings[property] || $135c79815f35f38e$var$_allSettings.settings[property];
        }
        return settings;
    };
    /** Used to run some code that sets Customizations without triggering an update until the end.
     * Useful for applying Customizations that don't affect anything currently rendered, or for
     * applying many customizations at once.
     * @param suppressUpdate - Do not raise the change event at the end, preventing all updates
     */ Customizations.applyBatchedUpdates = function(code, suppressUpdate) {
        Customizations._suppressUpdates = true;
        try {
            code();
        } catch (_a) {
        /* do nothing */ }
        Customizations._suppressUpdates = false;
        if (!suppressUpdate) Customizations._raiseChange();
    };
    Customizations.observe = function(onChange) {
        $135c79815f35f38e$var$_events.push(onChange);
    };
    Customizations.unobserve = function(onChange) {
        $135c79815f35f38e$var$_events = $135c79815f35f38e$var$_events.filter(function(cb) {
            return cb !== onChange;
        });
    };
    Customizations._raiseChange = function() {
        if (!Customizations._suppressUpdates) $135c79815f35f38e$var$_events.forEach(function(cb) {
            return cb();
        });
    };
    return Customizations;
}();


// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
var $bcc04e6de081a211$var$__assign = undefined && undefined.__assign || function() {
    $bcc04e6de081a211$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bcc04e6de081a211$var$__assign.apply(this, arguments);
};
// Store the theming state in __themeState__ global scope for reuse in the case of duplicate
// load-themed-styles hosted on the page.
var $bcc04e6de081a211$var$_root = typeof window === "undefined" ? $parcel$global : window; // eslint-disable-line @typescript-eslint/no-explicit-any
// Nonce string to inject into script tag if one provided. This is used in CSP (Content Security Policy).
var $bcc04e6de081a211$var$_styleNonce = $bcc04e6de081a211$var$_root && $bcc04e6de081a211$var$_root.CSPSettings && $bcc04e6de081a211$var$_root.CSPSettings.nonce;
var $bcc04e6de081a211$var$_themeState = $bcc04e6de081a211$var$initializeThemeState();
/**
 * Matches theming tokens. For example, "[theme: themeSlotName, default: #FFF]" (including the quotes).
 */ var $bcc04e6de081a211$var$_themeTokenRegex = /[\'\"]\[theme:\s*(\w+)\s*(?:\,\s*default:\s*([\\"\']?[\.\,\(\)\#\-\s\w]*[\.\,\(\)\#\-\w][\"\']?))?\s*\][\'\"]/g;
var $bcc04e6de081a211$var$now = function() {
    return typeof performance !== "undefined" && !!performance.now ? performance.now() : Date.now();
};
function $bcc04e6de081a211$var$measure(func) {
    var start = $bcc04e6de081a211$var$now();
    func();
    var end = $bcc04e6de081a211$var$now();
    $bcc04e6de081a211$var$_themeState.perf.duration += end - start;
}
/**
 * initialize global state object
 */ function $bcc04e6de081a211$var$initializeThemeState() {
    var state = $bcc04e6de081a211$var$_root.__themeState__ || {
        theme: undefined,
        lastStyleElement: undefined,
        registeredStyles: []
    };
    if (!state.runState) state = $bcc04e6de081a211$var$__assign($bcc04e6de081a211$var$__assign({}, state), {
        perf: {
            count: 0,
            duration: 0
        },
        runState: {
            flushTimer: 0,
            mode: 0 /* Mode.sync */ ,
            buffer: []
        }
    });
    if (!state.registeredThemableStyles) state = $bcc04e6de081a211$var$__assign($bcc04e6de081a211$var$__assign({}, state), {
        registeredThemableStyles: []
    });
    $bcc04e6de081a211$var$_root.__themeState__ = state;
    return state;
}
function $bcc04e6de081a211$export$277cf3cf4a1518cd(styles, loadAsync) {
    if (loadAsync === void 0) loadAsync = false;
    $bcc04e6de081a211$var$measure(function() {
        var styleParts = Array.isArray(styles) ? styles : $bcc04e6de081a211$export$bb01df06f2c55008(styles);
        var _a = $bcc04e6de081a211$var$_themeState.runState, mode = _a.mode, buffer = _a.buffer, flushTimer = _a.flushTimer;
        if (loadAsync || mode === 1 /* Mode.async */ ) {
            buffer.push(styleParts);
            if (!flushTimer) $bcc04e6de081a211$var$_themeState.runState.flushTimer = $bcc04e6de081a211$var$asyncLoadStyles();
        } else $bcc04e6de081a211$var$applyThemableStyles(styleParts);
    });
}
function $bcc04e6de081a211$export$181b9c90f55ff807(loadStylesFn) {
    $bcc04e6de081a211$var$_themeState.loadStyles = loadStylesFn;
}
function $bcc04e6de081a211$export$116c501adb0c3234(mode) {
    $bcc04e6de081a211$var$_themeState.runState.mode = mode;
}
function $bcc04e6de081a211$export$4909b86c8034bf73() {
    $bcc04e6de081a211$var$measure(function() {
        var styleArrays = $bcc04e6de081a211$var$_themeState.runState.buffer.slice();
        $bcc04e6de081a211$var$_themeState.runState.buffer = [];
        var mergedStyleArray = [].concat.apply([], styleArrays);
        if (mergedStyleArray.length > 0) $bcc04e6de081a211$var$applyThemableStyles(mergedStyleArray);
    });
}
/**
 * register async loadStyles
 */ function $bcc04e6de081a211$var$asyncLoadStyles() {
    return setTimeout(function() {
        $bcc04e6de081a211$var$_themeState.runState.flushTimer = 0;
        $bcc04e6de081a211$export$4909b86c8034bf73();
    }, 0);
}
/**
 * Loads a set of style text. If it is registered too early, we will register it when the window.load event
 * is fired.
 * @param {string} styleText Style to register.
 * @param {IStyleRecord} styleRecord Existing style record to re-apply.
 */ function $bcc04e6de081a211$var$applyThemableStyles(stylesArray, styleRecord) {
    if ($bcc04e6de081a211$var$_themeState.loadStyles) $bcc04e6de081a211$var$_themeState.loadStyles($bcc04e6de081a211$var$resolveThemableArray(stylesArray).styleString, stylesArray);
    else $bcc04e6de081a211$var$registerStyles(stylesArray);
}
function $bcc04e6de081a211$export$a1d87755f3c9500d(theme) {
    $bcc04e6de081a211$var$_themeState.theme = theme;
    // reload styles.
    $bcc04e6de081a211$var$reloadStyles();
}
function $bcc04e6de081a211$export$537f61d53c932351(option) {
    if (option === void 0) option = 3 /* ClearStyleOptions.all */ ;
    if (option === 3 /* ClearStyleOptions.all */  || option === 2 /* ClearStyleOptions.onlyNonThemable */ ) {
        $bcc04e6de081a211$var$clearStylesInternal($bcc04e6de081a211$var$_themeState.registeredStyles);
        $bcc04e6de081a211$var$_themeState.registeredStyles = [];
    }
    if (option === 3 /* ClearStyleOptions.all */  || option === 1 /* ClearStyleOptions.onlyThemable */ ) {
        $bcc04e6de081a211$var$clearStylesInternal($bcc04e6de081a211$var$_themeState.registeredThemableStyles);
        $bcc04e6de081a211$var$_themeState.registeredThemableStyles = [];
    }
}
function $bcc04e6de081a211$var$clearStylesInternal(records) {
    records.forEach(function(styleRecord) {
        var styleElement = styleRecord && styleRecord.styleElement;
        if (styleElement && styleElement.parentElement) styleElement.parentElement.removeChild(styleElement);
    });
}
/**
 * Reloads styles.
 */ function $bcc04e6de081a211$var$reloadStyles() {
    if ($bcc04e6de081a211$var$_themeState.theme) {
        var themableStyles = [];
        for(var _i = 0, _a = $bcc04e6de081a211$var$_themeState.registeredThemableStyles; _i < _a.length; _i++){
            var styleRecord = _a[_i];
            themableStyles.push(styleRecord.themableStyle);
        }
        if (themableStyles.length > 0) {
            $bcc04e6de081a211$export$537f61d53c932351(1 /* ClearStyleOptions.onlyThemable */ );
            $bcc04e6de081a211$var$applyThemableStyles([].concat.apply([], themableStyles));
        }
    }
}
function $bcc04e6de081a211$export$208ca8297aba2218(styles) {
    if (styles) styles = $bcc04e6de081a211$var$resolveThemableArray($bcc04e6de081a211$export$bb01df06f2c55008(styles)).styleString;
    return styles;
}
/**
 * Resolves ThemingInstruction objects in an array and joins the result into a string.
 * @param {ThemableArray} splitStyleArray ThemableArray to resolve and join.
 */ function $bcc04e6de081a211$var$resolveThemableArray(splitStyleArray) {
    var theme = $bcc04e6de081a211$var$_themeState.theme;
    var themable = false;
    // Resolve the array of theming instructions to an array of strings.
    // Then join the array to produce the final CSS string.
    var resolvedArray = (splitStyleArray || []).map(function(currentValue) {
        var themeSlot = currentValue.theme;
        if (themeSlot) {
            themable = true;
            // A theming annotation. Resolve it.
            var themedValue = theme ? theme[themeSlot] : undefined;
            var defaultValue = currentValue.defaultValue || "inherit";
            // Warn to console if we hit an unthemed value even when themes are provided, but only if "DEBUG" is true.
            // Allow the themedValue to be undefined to explicitly request the default value.
            if (theme && !themedValue && console && !(themeSlot in theme) && typeof DEBUG !== "undefined" && DEBUG) console.warn('Theming value not provided for "'.concat(themeSlot, '". Falling back to "').concat(defaultValue, '".'));
            return themedValue || defaultValue;
        } else // A non-themable string. Preserve it.
        return currentValue.rawString;
    });
    return {
        styleString: resolvedArray.join(""),
        themable: themable
    };
}
function $bcc04e6de081a211$export$bb01df06f2c55008(styles) {
    var result = [];
    if (styles) {
        var pos = 0; // Current position in styles.
        var tokenMatch = void 0;
        while(tokenMatch = $bcc04e6de081a211$var$_themeTokenRegex.exec(styles)){
            var matchIndex = tokenMatch.index;
            if (matchIndex > pos) result.push({
                rawString: styles.substring(pos, matchIndex)
            });
            result.push({
                theme: tokenMatch[1],
                defaultValue: tokenMatch[2] // May be undefined
            });
            // index of the first character after the current match
            pos = $bcc04e6de081a211$var$_themeTokenRegex.lastIndex;
        }
        // Push the rest of the string after the last match.
        result.push({
            rawString: styles.substring(pos)
        });
    }
    return result;
}
/**
 * Registers a set of style text. If it is registered too early, we will register it when the
 * window.load event is fired.
 * @param {ThemableArray} styleArray Array of IThemingInstruction objects to register.
 * @param {IStyleRecord} styleRecord May specify a style Element to update.
 */ function $bcc04e6de081a211$var$registerStyles(styleArray) {
    if (typeof document === "undefined") return;
    var head = document.getElementsByTagName("head")[0];
    var styleElement = document.createElement("style");
    var _a = $bcc04e6de081a211$var$resolveThemableArray(styleArray), styleString = _a.styleString, themable = _a.themable;
    styleElement.setAttribute("data-load-themed-styles", "true");
    if ($bcc04e6de081a211$var$_styleNonce) styleElement.setAttribute("nonce", $bcc04e6de081a211$var$_styleNonce);
    styleElement.appendChild(document.createTextNode(styleString));
    $bcc04e6de081a211$var$_themeState.perf.count++;
    head.appendChild(styleElement);
    var ev = document.createEvent("HTMLEvents");
    ev.initEvent("styleinsert", true, false);
    ev.args = {
        newStyle: styleElement
    };
    document.dispatchEvent(ev);
    var record = {
        styleElement: styleElement,
        themableStyle: styleArray
    };
    if (themable) $bcc04e6de081a211$var$_themeState.registeredThemableStyles.push(record);
    else $bcc04e6de081a211$var$_themeState.registeredStyles.push(record);
}


// When adding or removing a color, make sure you keep this consistent with IColorClassNames
// by adding the color variants.
var $f5d1d3080198998b$export$109c1b21def6ffa4 = {
    themeDarker: "#004578",
    themeDark: "#005a9e",
    themeDarkAlt: "#106ebe",
    themePrimary: "#0078d4",
    themeSecondary: "#2b88d8",
    themeTertiary: "#71afe5",
    themeLight: "#c7e0f4",
    themeLighter: "#deecf9",
    themeLighterAlt: "#eff6fc",
    black: "#000000",
    blackTranslucent40: "rgba(0,0,0,.4)",
    neutralDark: "#201f1e",
    neutralPrimary: "#323130",
    neutralPrimaryAlt: "#3b3a39",
    neutralSecondary: "#605e5c",
    neutralSecondaryAlt: "#8a8886",
    neutralTertiary: "#a19f9d",
    neutralTertiaryAlt: "#c8c6c4",
    neutralQuaternary: "#d2d0ce",
    neutralQuaternaryAlt: "#e1dfdd",
    neutralLight: "#edebe9",
    neutralLighter: "#f3f2f1",
    neutralLighterAlt: "#faf9f8",
    accent: "#0078d4",
    white: "#ffffff",
    whiteTranslucent40: "rgba(255,255,255,.4)",
    yellowDark: "#d29200",
    yellow: "#ffb900",
    yellowLight: "#fff100",
    orange: "#d83b01",
    orangeLight: "#ea4300",
    orangeLighter: "#ff8c00",
    redDark: "#a4262c",
    red: "#e81123",
    magentaDark: "#5c005c",
    magenta: "#b4009e",
    magentaLight: "#e3008c",
    purpleDark: "#32145a",
    purple: "#5c2d91",
    purpleLight: "#b4a0ff",
    blueDark: "#002050",
    blueMid: "#00188f",
    blue: "#0078d4",
    blueLight: "#00bcf2",
    tealDark: "#004b50",
    teal: "#008272",
    tealLight: "#00b294",
    greenDark: "#004b1c",
    green: "#107c10",
    greenLight: "#bad80a"
};


var $f16339646f34ceef$export$9b00c83187ceb0d1;
(function(Depths) {
    Depths.depth0 = "0 0 0 0 transparent";
    Depths.depth4 = "0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)";
    Depths.depth8 = "0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)";
    Depths.depth16 = "0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)";
    Depths.depth64 = "0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)";
})($f16339646f34ceef$export$9b00c83187ceb0d1 || ($f16339646f34ceef$export$9b00c83187ceb0d1 = {}));


var $182ec72fe2f1734f$export$1b052b16bf67042a = {
    elevation4: (0, $f16339646f34ceef$export$9b00c83187ceb0d1).depth4,
    elevation8: (0, $f16339646f34ceef$export$9b00c83187ceb0d1).depth8,
    elevation16: (0, $f16339646f34ceef$export$9b00c83187ceb0d1).depth16,
    elevation64: (0, $f16339646f34ceef$export$9b00c83187ceb0d1).depth64,
    roundedCorner2: "2px",
    roundedCorner4: "4px",
    roundedCorner6: "6px"
};



// Font face names to be registered.
var $f50780d4b0723ca0$export$ed6682c3a2de350f;
(function(LocalizedFontNames) {
    LocalizedFontNames.Arabic = "Segoe UI Web (Arabic)";
    LocalizedFontNames.Cyrillic = "Segoe UI Web (Cyrillic)";
    LocalizedFontNames.EastEuropean = "Segoe UI Web (East European)";
    LocalizedFontNames.Greek = "Segoe UI Web (Greek)";
    LocalizedFontNames.Hebrew = "Segoe UI Web (Hebrew)";
    LocalizedFontNames.Thai = "Leelawadee UI Web";
    LocalizedFontNames.Vietnamese = "Segoe UI Web (Vietnamese)";
    LocalizedFontNames.WestEuropean = "Segoe UI Web (West European)";
    LocalizedFontNames.Selawik = "Selawik Web";
    LocalizedFontNames.Armenian = "Segoe UI Web (Armenian)";
    LocalizedFontNames.Georgian = "Segoe UI Web (Georgian)";
})($f50780d4b0723ca0$export$ed6682c3a2de350f || ($f50780d4b0723ca0$export$ed6682c3a2de350f = {}));
var $f50780d4b0723ca0$export$a84f0633d5188de4;
(function(LocalizedFontFamilies) {
    LocalizedFontFamilies.Arabic = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.Arabic, "'");
    LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
    LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
    LocalizedFontFamilies.Cyrillic = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.Cyrillic, "'");
    LocalizedFontFamilies.EastEuropean = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.EastEuropean, "'");
    LocalizedFontFamilies.Greek = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.Greek, "'");
    LocalizedFontFamilies.Hebrew = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.Hebrew, "'");
    LocalizedFontFamilies.Hindi = "'Nirmala UI'";
    LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
    LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
    LocalizedFontFamilies.Selawik = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.Selawik, "'");
    LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
    LocalizedFontFamilies.Vietnamese = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.Vietnamese, "'");
    LocalizedFontFamilies.WestEuropean = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.WestEuropean, "'");
    LocalizedFontFamilies.Armenian = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.Armenian, "'");
    LocalizedFontFamilies.Georgian = "'".concat($f50780d4b0723ca0$export$ed6682c3a2de350f.Georgian, "'");
})($f50780d4b0723ca0$export$a84f0633d5188de4 || ($f50780d4b0723ca0$export$a84f0633d5188de4 = {}));
var $f50780d4b0723ca0$export$f2bd2ec6ef52693e;
(function(FontSizes) {
    FontSizes.size10 = "10px";
    FontSizes.size12 = "12px";
    FontSizes.size14 = "14px";
    FontSizes.size16 = "16px";
    FontSizes.size18 = "18px";
    FontSizes.size20 = "20px";
    FontSizes.size24 = "24px";
    FontSizes.size28 = "28px";
    FontSizes.size32 = "32px";
    FontSizes.size42 = "42px";
    FontSizes.size68 = "68px";
    FontSizes.mini = "10px";
    FontSizes.xSmall = "10px";
    FontSizes.small = "12px";
    FontSizes.smallPlus = "12px";
    FontSizes.medium = "14px";
    FontSizes.mediumPlus = "16px";
    FontSizes.icon = "16px";
    FontSizes.large = "18px";
    FontSizes.xLarge = "20px";
    FontSizes.xLargePlus = "24px";
    FontSizes.xxLarge = "28px";
    FontSizes.xxLargePlus = "32px";
    FontSizes.superLarge = "42px";
    FontSizes.mega = "68px";
})($f50780d4b0723ca0$export$f2bd2ec6ef52693e || ($f50780d4b0723ca0$export$f2bd2ec6ef52693e = {}));
var $f50780d4b0723ca0$export$32743b01f42d159e;
(function(FontWeights) {
    FontWeights.light = 100;
    FontWeights.semilight = 300;
    FontWeights.regular = 400;
    FontWeights.semibold = 600;
    FontWeights.bold = 700;
})($f50780d4b0723ca0$export$32743b01f42d159e || ($f50780d4b0723ca0$export$32743b01f42d159e = {}));
var $f50780d4b0723ca0$export$7f8918a48f5782fd;
(function(IconFontSizes) {
    IconFontSizes.xSmall = "10px";
    IconFontSizes.small = "12px";
    IconFontSizes.medium = "16px";
    IconFontSizes.large = "20px";
})($f50780d4b0723ca0$export$7f8918a48f5782fd || ($f50780d4b0723ca0$export$7f8918a48f5782fd = {}));



// Fallback fonts, if specified system or web fonts are unavailable.
var $ae6ee0aeacba4c75$var$FontFamilyFallbacks = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif";
// By default, we favor system fonts for the default.
// All localized fonts use a web font and never use the system font.
var $ae6ee0aeacba4c75$var$defaultFontFamily = "'Segoe UI', '".concat((0, $f50780d4b0723ca0$export$ed6682c3a2de350f).WestEuropean, "'");
// Mapping of language prefix to to font family.
var $ae6ee0aeacba4c75$var$LanguageToFontMap = {
    ar: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Arabic,
    bg: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Cyrillic,
    cs: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    el: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Greek,
    et: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    he: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Hebrew,
    hi: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Hindi,
    hr: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    hu: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    ja: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Japanese,
    kk: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    ko: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Korean,
    lt: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    lv: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    pl: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    ru: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Cyrillic,
    sk: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    "sr-latn": (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    th: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Thai,
    tr: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).EastEuropean,
    uk: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Cyrillic,
    vi: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Vietnamese,
    "zh-hans": (0, $f50780d4b0723ca0$export$a84f0633d5188de4).ChineseSimplified,
    "zh-hant": (0, $f50780d4b0723ca0$export$a84f0633d5188de4).ChineseTraditional,
    hy: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Armenian,
    ka: (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Georgian
};
function $ae6ee0aeacba4c75$var$_fontFamilyWithFallbacks(fontFamily) {
    return "".concat(fontFamily, ", ").concat($ae6ee0aeacba4c75$var$FontFamilyFallbacks);
}
/**
 * If there is a localized font for this language, return that.
 * Returns undefined if there is no localized font for that language.
 */ function $ae6ee0aeacba4c75$var$_getLocalizedFontFamily(language) {
    for(var lang in $ae6ee0aeacba4c75$var$LanguageToFontMap){
        if ($ae6ee0aeacba4c75$var$LanguageToFontMap.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $ae6ee0aeacba4c75$var$LanguageToFontMap[lang];
    }
    return $ae6ee0aeacba4c75$var$defaultFontFamily;
}
function $ae6ee0aeacba4c75$var$_createFont(size, weight, fontFamily) {
    return {
        fontFamily: fontFamily,
        MozOsxFontSmoothing: "grayscale",
        WebkitFontSmoothing: "antialiased",
        fontSize: size,
        fontWeight: weight
    };
}
function $ae6ee0aeacba4c75$export$a4fa8de6a1c20b63(localeCode) {
    var localizedFont = $ae6ee0aeacba4c75$var$_getLocalizedFontFamily(localeCode);
    var fontFamilyWithFallback = $ae6ee0aeacba4c75$var$_fontFamilyWithFallbacks(localizedFont);
    var fontStyles = {
        tiny: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).mini, (0, $f50780d4b0723ca0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        xSmall: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).xSmall, (0, $f50780d4b0723ca0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        small: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).small, (0, $f50780d4b0723ca0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        smallPlus: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).smallPlus, (0, $f50780d4b0723ca0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        medium: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).medium, (0, $f50780d4b0723ca0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        mediumPlus: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).mediumPlus, (0, $f50780d4b0723ca0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        large: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).large, (0, $f50780d4b0723ca0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        xLarge: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).xLarge, (0, $f50780d4b0723ca0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xLargePlus: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).xLargePlus, (0, $f50780d4b0723ca0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xxLarge: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).xxLarge, (0, $f50780d4b0723ca0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xxLargePlus: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).xxLargePlus, (0, $f50780d4b0723ca0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        superLarge: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).superLarge, (0, $f50780d4b0723ca0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        mega: $ae6ee0aeacba4c75$var$_createFont((0, $f50780d4b0723ca0$export$f2bd2ec6ef52693e).mega, (0, $f50780d4b0723ca0$export$32743b01f42d159e).semibold, fontFamilyWithFallback)
    };
    return fontStyles;
}



function $6675a10cf135a7c1$export$f65ca476c09acec0(rootElement) {
    // eslint-disable-next-line no-restricted-globals
    if (!(0, $9d0d0f30b2e111bb$export$71594e8a50f746f4)() || typeof document === "undefined") return undefined;
    else {
        var el = rootElement;
        // eslint-disable-next-line no-restricted-globals
        return el && el.ownerDocument ? el.ownerDocument : document;
    }
}



function $3d4a2f8ed66b4987$export$f92dfeb71e9bb569(key) {
    var result = null;
    try {
        var win = (0, $f70a84ea62eace59$export$38b2d434cce3ea22)();
        result = win ? win.localStorage.getItem(key) : null;
    } catch (e) {
    /* Eat the exception */ }
    return result;
}
function $3d4a2f8ed66b4987$export$8a8216c44337cd5(key, data) {
    try {
        var win = (0, $f70a84ea62eace59$export$38b2d434cce3ea22)();
        win && win.localStorage.setItem(key, data);
    } catch (e) {
    /* Eat the exception */ }
}



function $a9b64f388d739e5a$export$f92dfeb71e9bb569(key) {
    var result = null;
    try {
        var win = (0, $f70a84ea62eace59$export$38b2d434cce3ea22)();
        result = win ? win.sessionStorage.getItem(key) : null;
    } catch (e) {
    /* Eat the exception */ }
    return result;
}
function $a9b64f388d739e5a$export$8a8216c44337cd5(key, data) {
    var _a;
    try {
        (_a = (0, $f70a84ea62eace59$export$38b2d434cce3ea22)()) === null || _a === void 0 || _a.sessionStorage.setItem(key, data);
    } catch (e) {
    /* Eat the exception */ }
}


// Default to undefined so that we initialize on first read.
var $c4c1cf1d926501c2$var$_language;
var $c4c1cf1d926501c2$var$STORAGE_KEY = "language";
function $c4c1cf1d926501c2$export$64783e31db14f0ba(persistenceType) {
    if (persistenceType === void 0) persistenceType = "sessionStorage";
    if ($c4c1cf1d926501c2$var$_language === undefined) {
        var doc = (0, $6675a10cf135a7c1$export$f65ca476c09acec0)();
        var savedLanguage = persistenceType === "localStorage" ? $3d4a2f8ed66b4987$export$f92dfeb71e9bb569($c4c1cf1d926501c2$var$STORAGE_KEY) : persistenceType === "sessionStorage" ? $a9b64f388d739e5a$export$f92dfeb71e9bb569($c4c1cf1d926501c2$var$STORAGE_KEY) : undefined;
        if (savedLanguage) $c4c1cf1d926501c2$var$_language = savedLanguage;
        if ($c4c1cf1d926501c2$var$_language === undefined && doc) $c4c1cf1d926501c2$var$_language = doc.documentElement.getAttribute("lang");
        if ($c4c1cf1d926501c2$var$_language === undefined) $c4c1cf1d926501c2$var$_language = "en";
    }
    return $c4c1cf1d926501c2$var$_language;
}
function $c4c1cf1d926501c2$export$4b6bf64406ec64af(language, persistenceParam) {
    var doc = (0, $6675a10cf135a7c1$export$f65ca476c09acec0)();
    if (doc) doc.documentElement.setAttribute("lang", language);
    var persistenceType = persistenceParam === true ? "none" : !persistenceParam ? "sessionStorage" : persistenceParam;
    if (persistenceType === "localStorage") $3d4a2f8ed66b4987$export$8a8216c44337cd5($c4c1cf1d926501c2$var$STORAGE_KEY, language);
    else if (persistenceType === "sessionStorage") $a9b64f388d739e5a$export$8a8216c44337cd5($c4c1cf1d926501c2$var$STORAGE_KEY, language);
    $c4c1cf1d926501c2$var$_language = language;
}


// Default urls.
var $3273e2035e7e7721$var$DefaultBaseUrl = "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets";
var $3273e2035e7e7721$export$3d534eec2182c14b = (0, $ae6ee0aeacba4c75$export$a4fa8de6a1c20b63)((0, $c4c1cf1d926501c2$export$64783e31db14f0ba)());
function $3273e2035e7e7721$var$_registerFontFace(fontFamily, url, fontWeight, localFontName) {
    fontFamily = "'".concat(fontFamily, "'");
    var localFontSrc = localFontName !== undefined ? "local('".concat(localFontName, "'),") : "";
    (0, $f0eb144b01193d25$export$566c6c2ff0443c7)({
        fontFamily: fontFamily,
        src: localFontSrc + "url('".concat(url, ".woff2') format('woff2'),") + "url('".concat(url, ".woff') format('woff')"),
        fontWeight: fontWeight,
        fontStyle: "normal",
        fontDisplay: "swap"
    });
}
function $3273e2035e7e7721$var$_registerFontFaceSet(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
    if (cdnFontName === void 0) cdnFontName = "segoeui";
    var urlBase = "".concat(baseUrl, "/").concat(cdnFolder, "/").concat(cdnFontName);
    $3273e2035e7e7721$var$_registerFontFace(fontFamily, urlBase + "-light", (0, $f50780d4b0723ca0$export$32743b01f42d159e).light, localFontName && localFontName + " Light");
    $3273e2035e7e7721$var$_registerFontFace(fontFamily, urlBase + "-semilight", (0, $f50780d4b0723ca0$export$32743b01f42d159e).semilight, localFontName && localFontName + " SemiLight");
    $3273e2035e7e7721$var$_registerFontFace(fontFamily, urlBase + "-regular", (0, $f50780d4b0723ca0$export$32743b01f42d159e).regular, localFontName);
    $3273e2035e7e7721$var$_registerFontFace(fontFamily, urlBase + "-semibold", (0, $f50780d4b0723ca0$export$32743b01f42d159e).semibold, localFontName && localFontName + " SemiBold");
    $3273e2035e7e7721$var$_registerFontFace(fontFamily, urlBase + "-bold", (0, $f50780d4b0723ca0$export$32743b01f42d159e).bold, localFontName && localFontName + " Bold");
}
function $3273e2035e7e7721$export$1c5ba4c2e362bd9e(baseUrl) {
    if (baseUrl) {
        var fontUrl = "".concat(baseUrl, "/fonts");
        // Produce @font-face definitions for all supported web fonts.
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).Thai, "leelawadeeui-thai", "leelawadeeui");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).Arabic, "segoeui-arabic");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).Cyrillic, "segoeui-cyrillic");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).EastEuropean, "segoeui-easteuropean");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).Greek, "segoeui-greek");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).Hebrew, "segoeui-hebrew");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).Vietnamese, "segoeui-vietnamese");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).WestEuropean, "segoeui-westeuropean", "segoeui", "Segoe UI");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$a84f0633d5188de4).Selawik, "selawik", "selawik");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).Armenian, "segoeui-armenian");
        $3273e2035e7e7721$var$_registerFontFaceSet(fontUrl, (0, $f50780d4b0723ca0$export$ed6682c3a2de350f).Georgian, "segoeui-georgian");
        // Leelawadee UI (Thai) does not have a 'light' weight, so we override
        // the font-face generated above to use the 'semilight' weight instead.
        $3273e2035e7e7721$var$_registerFontFace("Leelawadee UI Web", "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-semilight"), (0, $f50780d4b0723ca0$export$32743b01f42d159e).light);
        // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
        // the font-face generated above to use the 'bold' weight instead.
        $3273e2035e7e7721$var$_registerFontFace("Leelawadee UI Web", "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-bold"), (0, $f50780d4b0723ca0$export$32743b01f42d159e).semibold);
    }
}
/**
 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
 */ function $3273e2035e7e7721$var$_getFontBaseUrl() {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var fabricConfig = (_a = (0, $f70a84ea62eace59$export$38b2d434cce3ea22)()) === null || _a === void 0 ? void 0 : _a.FabricConfig;
    return (_b = fabricConfig === null || fabricConfig === void 0 ? void 0 : fabricConfig.fontBaseUrl) !== null && _b !== void 0 ? _b : $3273e2035e7e7721$var$DefaultBaseUrl;
}
/**
 * Register the font faces.
 */ $3273e2035e7e7721$export$1c5ba4c2e362bd9e($3273e2035e7e7721$var$_getFontBaseUrl());


/**
 * Simple deep merge function. Takes all arguments and returns a deep copy of the objects merged
 * together in the order provided. If an object creates a circular reference, it will assign the
 * original reference.
 */ function $13d2fa52a512745f$export$4950aa0f605343fb(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var arg = args_1[_a];
        $13d2fa52a512745f$var$_merge(target || {}, arg);
    }
    return target;
}
/**
 * The _merge helper iterates through all props on source and assigns them to target.
 * When the value is an object, we will create a deep clone of the object. However if
 * there is a circular reference, the value will not be deep cloned and will persist
 * the reference.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $13d2fa52a512745f$var$_merge(target, source, circularReferences) {
    if (circularReferences === void 0) circularReferences = [];
    circularReferences.push(source);
    for(var name_1 in source){
        if (source.hasOwnProperty(name_1)) {
            if (name_1 !== "__proto__" && name_1 !== "constructor" && name_1 !== "prototype") {
                var value = source[name_1];
                if (typeof value === "object" && value !== null && !Array.isArray(value)) {
                    var isCircularReference = circularReferences.indexOf(value) > -1;
                    target[name_1] = isCircularReference ? value : $13d2fa52a512745f$var$_merge(target[name_1] || {}, value, circularReferences);
                } else target[name_1] = value;
            }
        }
    }
    circularReferences.pop();
    return target;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $ba7c7d5a712e005c$var$extendStatics = function(d, b) {
    $ba7c7d5a712e005c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ba7c7d5a712e005c$var$extendStatics(d, b);
};
function $ba7c7d5a712e005c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ba7c7d5a712e005c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ba7c7d5a712e005c$export$18ce0697a983be9b = function() {
    $ba7c7d5a712e005c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ba7c7d5a712e005c$export$18ce0697a983be9b.apply(this, arguments);
};
function $ba7c7d5a712e005c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ba7c7d5a712e005c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ba7c7d5a712e005c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ba7c7d5a712e005c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ba7c7d5a712e005c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ba7c7d5a712e005c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $ba7c7d5a712e005c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ba7c7d5a712e005c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ba7c7d5a712e005c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ba7c7d5a712e005c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ba7c7d5a712e005c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ba7c7d5a712e005c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ba7c7d5a712e005c$export$45d3717a4c69092e(o, m, p);
}
function $ba7c7d5a712e005c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ba7c7d5a712e005c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ba7c7d5a712e005c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ba7c7d5a712e005c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ba7c7d5a712e005c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ba7c7d5a712e005c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ba7c7d5a712e005c$export$10c90e4f7922046c(v) {
    return this instanceof $ba7c7d5a712e005c$export$10c90e4f7922046c ? (this.v = v, this) : new $ba7c7d5a712e005c$export$10c90e4f7922046c(v);
}
function $ba7c7d5a712e005c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ba7c7d5a712e005c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ba7c7d5a712e005c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ba7c7d5a712e005c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ba7c7d5a712e005c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ba7c7d5a712e005c$export$19a8beecd37a4c45 === "function" ? $ba7c7d5a712e005c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ba7c7d5a712e005c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ba7c7d5a712e005c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $ba7c7d5a712e005c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ba7c7d5a712e005c$export$45d3717a4c69092e(result, mod, k);
    }
    $ba7c7d5a712e005c$var$__setModuleDefault(result, mod);
    return result;
}
function $ba7c7d5a712e005c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ba7c7d5a712e005c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ba7c7d5a712e005c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ba7c7d5a712e005c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ba7c7d5a712e005c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ba7c7d5a712e005c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ba7c7d5a712e005c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ba7c7d5a712e005c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $ba7c7d5a712e005c$export$2e2bcd8739ae039 = {
    __extends: $ba7c7d5a712e005c$export$a8ba968b8961cb8a,
    __assign: $ba7c7d5a712e005c$export$18ce0697a983be9b,
    __rest: $ba7c7d5a712e005c$export$3c9a16f847548506,
    __decorate: $ba7c7d5a712e005c$export$29e00dfd3077644b,
    __param: $ba7c7d5a712e005c$export$d5ad3fd78186038f,
    __metadata: $ba7c7d5a712e005c$export$f1db080c865becb9,
    __awaiter: $ba7c7d5a712e005c$export$1050f835b63b671e,
    __generator: $ba7c7d5a712e005c$export$67ebef60e6f28a6,
    __createBinding: $ba7c7d5a712e005c$export$45d3717a4c69092e,
    __exportStar: $ba7c7d5a712e005c$export$f33643c0debef087,
    __values: $ba7c7d5a712e005c$export$19a8beecd37a4c45,
    __read: $ba7c7d5a712e005c$export$8d051b38c9118094,
    __spread: $ba7c7d5a712e005c$export$afc72e2116322959,
    __spreadArrays: $ba7c7d5a712e005c$export$6388937ca91ccae8,
    __spreadArray: $ba7c7d5a712e005c$export$1216008129fb82ed,
    __await: $ba7c7d5a712e005c$export$10c90e4f7922046c,
    __asyncGenerator: $ba7c7d5a712e005c$export$e427f37a30a4de9b,
    __asyncDelegator: $ba7c7d5a712e005c$export$bbd80228419bb833,
    __asyncValues: $ba7c7d5a712e005c$export$e3b29a3d6162315f,
    __makeTemplateObject: $ba7c7d5a712e005c$export$4fb47efe1390b86f,
    __importStar: $ba7c7d5a712e005c$export$c21735bcef00d192,
    __importDefault: $ba7c7d5a712e005c$export$da59b14a69baef04,
    __classPrivateFieldGet: $ba7c7d5a712e005c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ba7c7d5a712e005c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ba7c7d5a712e005c$export$81fdc39f203e4e04,
    __addDisposableResource: $ba7c7d5a712e005c$export$88ac25d8e944e405,
    __disposeResources: $ba7c7d5a712e005c$export$8f076105dc360e92
};


function $05ccc64345d95024$export$1084519c371c0719(p, e, s, isInverted, depComments) {
    if (depComments === void 0) depComments = false;
    var semanticColors = (0, $ba7c7d5a712e005c$export$18ce0697a983be9b)({
        primaryButtonBorder: "transparent",
        errorText: !isInverted ? "#a4262c" : "#F1707B",
        messageText: !isInverted ? "#323130" : "#F3F2F1",
        messageLink: !isInverted ? "#005A9E" : "#6CB8F6",
        messageLinkHovered: !isInverted ? "#004578" : "#82C7FF",
        infoIcon: !isInverted ? "#605e5c" : "#C8C6C4",
        errorIcon: !isInverted ? "#A80000" : "#F1707B",
        blockingIcon: !isInverted ? "#FDE7E9" : "#442726",
        warningIcon: !isInverted ? "#797775" : "#C8C6C4",
        severeWarningIcon: !isInverted ? "#D83B01" : "#FCE100",
        successIcon: !isInverted ? "#107C10" : "#92C353",
        infoBackground: !isInverted ? "#f3f2f1" : "#323130",
        errorBackground: !isInverted ? "#FDE7E9" : "#442726",
        blockingBackground: !isInverted ? "#FDE7E9" : "#442726",
        warningBackground: !isInverted ? "#FFF4CE" : "#433519",
        severeWarningBackground: !isInverted ? "#FED9CC" : "#4F2A0F",
        successBackground: !isInverted ? "#DFF6DD" : "#393D1B",
        // deprecated
        warningHighlight: !isInverted ? "#ffb900" : "#fff100",
        successText: !isInverted ? "#107C10" : "#92c353"
    }, s);
    var fullSemanticColors = $05ccc64345d95024$export$aca509a1becd8a60(p, e, semanticColors, isInverted);
    return $05ccc64345d95024$var$_fixDeprecatedSlots(fullSemanticColors, depComments);
}
function $05ccc64345d95024$export$aca509a1becd8a60(p, e, s, isInverted, depComments) {
    if (depComments === void 0) depComments = false;
    var result = {};
    // map palette
    var _a = p || {}, white = _a.white, black = _a.black, themePrimary = _a.themePrimary, themeDark = _a.themeDark, themeDarker = _a.themeDarker, themeDarkAlt = _a.themeDarkAlt, themeLighter = _a.themeLighter, neutralLight = _a.neutralLight, neutralLighter = _a.neutralLighter, neutralDark = _a.neutralDark, neutralQuaternary = _a.neutralQuaternary, neutralQuaternaryAlt = _a.neutralQuaternaryAlt, neutralPrimary = _a.neutralPrimary, neutralSecondary = _a.neutralSecondary, neutralSecondaryAlt = _a.neutralSecondaryAlt, neutralTertiary = _a.neutralTertiary, neutralTertiaryAlt = _a.neutralTertiaryAlt, neutralLighterAlt = _a.neutralLighterAlt, accent = _a.accent;
    if (white) {
        result.bodyBackground = white;
        result.bodyFrameBackground = white;
        result.accentButtonText = white;
        result.buttonBackground = white;
        result.primaryButtonText = white;
        result.primaryButtonTextHovered = white;
        result.primaryButtonTextPressed = white;
        result.inputBackground = white;
        result.inputForegroundChecked = white;
        result.listBackground = white;
        result.menuBackground = white;
        result.cardStandoutBackground = white;
    }
    if (black) {
        result.bodyTextChecked = black;
        result.buttonTextCheckedHovered = black;
    }
    if (themePrimary) {
        result.link = themePrimary;
        result.primaryButtonBackground = themePrimary;
        result.inputBackgroundChecked = themePrimary;
        result.inputIcon = themePrimary;
        result.inputFocusBorderAlt = themePrimary;
        result.menuIcon = themePrimary;
        result.menuHeader = themePrimary;
        result.accentButtonBackground = themePrimary;
    }
    if (themeDark) {
        result.primaryButtonBackgroundPressed = themeDark;
        result.inputBackgroundCheckedHovered = themeDark;
        result.inputIconHovered = themeDark;
    }
    if (themeDarker) result.linkHovered = themeDarker;
    if (themeDarkAlt) result.primaryButtonBackgroundHovered = themeDarkAlt;
    if (themeLighter) result.inputPlaceholderBackgroundChecked = themeLighter;
    if (neutralLight) {
        result.bodyBackgroundChecked = neutralLight;
        result.bodyFrameDivider = neutralLight;
        result.bodyDivider = neutralLight;
        result.variantBorder = neutralLight;
        result.buttonBackgroundCheckedHovered = neutralLight;
        result.buttonBackgroundPressed = neutralLight;
        result.listItemBackgroundChecked = neutralLight;
        result.listHeaderBackgroundPressed = neutralLight;
        result.menuItemBackgroundPressed = neutralLight;
        // eslint-disable-next-line deprecation/deprecation
        result.menuItemBackgroundChecked = neutralLight;
    }
    if (neutralLighter) {
        result.bodyBackgroundHovered = neutralLighter;
        result.buttonBackgroundHovered = neutralLighter;
        result.buttonBackgroundDisabled = neutralLighter;
        result.buttonBorderDisabled = neutralLighter;
        result.primaryButtonBackgroundDisabled = neutralLighter;
        result.disabledBackground = neutralLighter;
        result.listItemBackgroundHovered = neutralLighter;
        result.listHeaderBackgroundHovered = neutralLighter;
        result.menuItemBackgroundHovered = neutralLighter;
    }
    if (neutralQuaternary) {
        result.primaryButtonTextDisabled = neutralQuaternary;
        result.disabledSubtext = neutralQuaternary;
    }
    if (neutralQuaternaryAlt) result.listItemBackgroundCheckedHovered = neutralQuaternaryAlt;
    if (neutralTertiary) {
        result.disabledBodyText = neutralTertiary;
        result.variantBorderHovered = (s === null || s === void 0 ? void 0 : s.variantBorderHovered) || neutralTertiary;
        result.buttonTextDisabled = neutralTertiary;
        result.inputIconDisabled = neutralTertiary;
        result.disabledText = neutralTertiary;
    }
    if (neutralPrimary) {
        result.bodyText = neutralPrimary;
        result.actionLink = neutralPrimary;
        result.buttonText = neutralPrimary;
        result.inputBorderHovered = neutralPrimary;
        result.inputText = neutralPrimary;
        result.listText = neutralPrimary;
        result.menuItemText = neutralPrimary;
    }
    if (neutralLighterAlt) {
        result.bodyStandoutBackground = neutralLighterAlt;
        result.defaultStateBackground = neutralLighterAlt;
    }
    if (neutralDark) {
        result.actionLinkHovered = neutralDark;
        result.buttonTextHovered = neutralDark;
        result.buttonTextChecked = neutralDark;
        result.buttonTextPressed = neutralDark;
        result.inputTextHovered = neutralDark;
        result.menuItemTextHovered = neutralDark;
    }
    if (neutralSecondary) {
        result.bodySubtext = neutralSecondary;
        result.focusBorder = neutralSecondary;
        result.inputBorder = neutralSecondary;
        result.smallInputBorder = neutralSecondary;
        result.inputPlaceholderText = neutralSecondary;
    }
    if (neutralSecondaryAlt) result.buttonBorder = neutralSecondaryAlt;
    if (neutralTertiaryAlt) {
        result.disabledBodySubtext = neutralTertiaryAlt;
        result.disabledBorder = neutralTertiaryAlt;
        result.buttonBackgroundChecked = neutralTertiaryAlt;
        result.menuDivider = neutralTertiaryAlt;
    }
    if (accent) result.accentButtonBackground = accent;
    // map effects
    if (e === null || e === void 0 ? void 0 : e.elevation4) result.cardShadow = e.elevation4;
    if (!isInverted && (e === null || e === void 0 ? void 0 : e.elevation8)) result.cardShadowHovered = e.elevation8;
    else if (result.variantBorderHovered) result.cardShadowHovered = "0 0 1px " + result.variantBorderHovered;
    result = (0, $ba7c7d5a712e005c$export$18ce0697a983be9b)((0, $ba7c7d5a712e005c$export$18ce0697a983be9b)({}, result), s);
    return result;
}
function $05ccc64345d95024$var$_fixDeprecatedSlots(s, depComments) {
    // Add @deprecated tag as comment if enabled
    var dep = "";
    if (depComments === true) dep = " /* @deprecated */";
    /* eslint-disable deprecation/deprecation */ s.listTextColor = s.listText + dep;
    s.menuItemBackgroundChecked += dep;
    s.warningHighlight += dep;
    s.warningText = s.messageText + dep;
    s.successText += dep;
    /* eslint-enable deprecation/deprecation */ return s;
}


function $1a12bf625e360ad4$export$919aa3481b25eaec(theme, partialTheme) {
    var _a, _b, _c;
    if (partialTheme === void 0) partialTheme = {};
    var mergedTheme = (0, $13d2fa52a512745f$export$4950aa0f605343fb)({}, theme, partialTheme, {
        semanticColors: (0, $05ccc64345d95024$export$aca509a1becd8a60)(partialTheme.palette, partialTheme.effects, partialTheme.semanticColors, partialTheme.isInverted === undefined ? theme.isInverted : partialTheme.isInverted)
    });
    if (((_a = partialTheme.palette) === null || _a === void 0 ? void 0 : _a.themePrimary) && !((_b = partialTheme.palette) === null || _b === void 0 ? void 0 : _b.accent)) mergedTheme.palette.accent = partialTheme.palette.themePrimary;
    if (partialTheme.defaultFontStyle) for(var _i = 0, _d = Object.keys(mergedTheme.fonts); _i < _d.length; _i++){
        var fontStyle = _d[_i];
        mergedTheme.fonts[fontStyle] = (0, $13d2fa52a512745f$export$4950aa0f605343fb)(mergedTheme.fonts[fontStyle], partialTheme.defaultFontStyle, (_c = partialTheme === null || partialTheme === void 0 ? void 0 : partialTheme.fonts) === null || _c === void 0 ? void 0 : _c[fontStyle]);
    }
    return mergedTheme;
}


var $5c98ab4de9b62cde$export$f1e7669f0aafe571 = {
    s2: "4px",
    s1: "8px",
    m: "16px",
    l1: "20px",
    l2: "32px"
};



function $cf7d63fe01a39e97$export$25d302a5b900a763(theme, depComments) {
    if (theme === void 0) theme = {};
    if (depComments === void 0) depComments = false;
    var isInverted = !!theme.isInverted;
    var baseTheme = {
        palette: (0, $f5d1d3080198998b$export$109c1b21def6ffa4),
        effects: (0, $182ec72fe2f1734f$export$1b052b16bf67042a),
        fonts: (0, $3273e2035e7e7721$export$3d534eec2182c14b),
        spacing: (0, $5c98ab4de9b62cde$export$f1e7669f0aafe571),
        isInverted: isInverted,
        disableGlobalClassNames: false,
        semanticColors: (0, $05ccc64345d95024$export$1084519c371c0719)((0, $f5d1d3080198998b$export$109c1b21def6ffa4), (0, $182ec72fe2f1734f$export$1b052b16bf67042a), undefined, isInverted, depComments),
        rtl: undefined
    };
    return (0, $1a12bf625e360ad4$export$919aa3481b25eaec)(baseTheme, theme);
}


var $429b16cc0ebf06a3$var$_theme = (0, $cf7d63fe01a39e97$export$25d302a5b900a763)({});
var $429b16cc0ebf06a3$var$_onThemeChangeCallbacks = [];
var $429b16cc0ebf06a3$export$cf613f78cce4b73f = "theme";
function $429b16cc0ebf06a3$export$8a248add43552e89() {
    var _a;
    var _b, _c;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var win = (0, $f70a84ea62eace59$export$38b2d434cce3ea22)();
    if ((_b = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _b === void 0 ? void 0 : _b.legacyTheme) // does everything the `else` clause does and more, such as invoke legacy theming
    $429b16cc0ebf06a3$export$a1d87755f3c9500d(win.FabricConfig.legacyTheme);
    else if (!(0, $135c79815f35f38e$export$cbb5b5586292cdb).getSettings([
        $429b16cc0ebf06a3$export$cf613f78cce4b73f
    ]).theme) {
        if ((_c = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _c === void 0 ? void 0 : _c.theme) $429b16cc0ebf06a3$var$_theme = (0, $cf7d63fe01a39e97$export$25d302a5b900a763)(win.FabricConfig.theme);
        // Set the default theme.
        (0, $135c79815f35f38e$export$cbb5b5586292cdb).applySettings((_a = {}, _a[$429b16cc0ebf06a3$export$cf613f78cce4b73f] = $429b16cc0ebf06a3$var$_theme, _a));
    }
}
$429b16cc0ebf06a3$export$8a248add43552e89();
function $429b16cc0ebf06a3$export$89cbf1a0881c8b9c(depComments) {
    if (depComments === void 0) depComments = false;
    if (depComments === true) $429b16cc0ebf06a3$var$_theme = (0, $cf7d63fe01a39e97$export$25d302a5b900a763)({}, depComments);
    return $429b16cc0ebf06a3$var$_theme;
}
function $429b16cc0ebf06a3$export$e7b32ab372e04de(callback) {
    if ($429b16cc0ebf06a3$var$_onThemeChangeCallbacks.indexOf(callback) === -1) $429b16cc0ebf06a3$var$_onThemeChangeCallbacks.push(callback);
}
function $429b16cc0ebf06a3$export$d0ea9fdf152462c9(callback) {
    var i = $429b16cc0ebf06a3$var$_onThemeChangeCallbacks.indexOf(callback);
    if (i === -1) return;
    $429b16cc0ebf06a3$var$_onThemeChangeCallbacks.splice(i, 1);
}
function $429b16cc0ebf06a3$export$a1d87755f3c9500d(theme, depComments) {
    var _a;
    if (depComments === void 0) depComments = false;
    $429b16cc0ebf06a3$var$_theme = (0, $cf7d63fe01a39e97$export$25d302a5b900a763)(theme, depComments);
    // Invoke the legacy method of theming the page as well.
    (0, $bcc04e6de081a211$export$a1d87755f3c9500d)((0, $640cb49c3d31a828$export$18ce0697a983be9b)((0, $640cb49c3d31a828$export$18ce0697a983be9b)((0, $640cb49c3d31a828$export$18ce0697a983be9b)((0, $640cb49c3d31a828$export$18ce0697a983be9b)({}, $429b16cc0ebf06a3$var$_theme.palette), $429b16cc0ebf06a3$var$_theme.semanticColors), $429b16cc0ebf06a3$var$_theme.effects), $429b16cc0ebf06a3$var$_loadFonts($429b16cc0ebf06a3$var$_theme)));
    (0, $135c79815f35f38e$export$cbb5b5586292cdb).applySettings((_a = {}, _a[$429b16cc0ebf06a3$export$cf613f78cce4b73f] = $429b16cc0ebf06a3$var$_theme, _a));
    $429b16cc0ebf06a3$var$_onThemeChangeCallbacks.forEach(function(callback) {
        try {
            callback($429b16cc0ebf06a3$var$_theme);
        } catch (e) {
        // don't let a bad callback break everything else
        }
    });
    return $429b16cc0ebf06a3$var$_theme;
}
/**
 * Loads font variables into a JSON object.
 * @param theme - The theme object
 */ function $429b16cc0ebf06a3$var$_loadFonts(theme) {
    var lines = {};
    for(var _i = 0, _a = Object.keys(theme.fonts); _i < _a.length; _i++){
        var fontName = _a[_i];
        var font = theme.fonts[fontName];
        for(var _b = 0, _c = Object.keys(font); _b < _c.length; _b++){
            var propName = _c[_b];
            var name_1 = fontName + propName.charAt(0).toUpperCase() + propName.slice(1);
            var value = font[propName];
            if (propName === "fontSize" && typeof value === "number") // if it's a number, convert it to px by default like our theming system does
            value = value + "px";
            lines[name_1] = value;
        }
    }
    return lines;
}


(0, $429b16cc0ebf06a3$export$8a248add43552e89)();


function $024ef69aaa10db95$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons"',
            src: "url('".concat(baseUrl, "fabric-icons-a13498cf.woff') format('woff')")
        },
        icons: {
            GlobalNavButton: "\uE700",
            ChevronDown: "\uE70D",
            ChevronUp: "\uE70E",
            Edit: "\uE70F",
            Add: "\uE710",
            Cancel: "\uE711",
            More: "\uE712",
            Settings: "\uE713",
            Mail: "\uE715",
            Filter: "\uE71C",
            Search: "\uE721",
            Share: "\uE72D",
            BlockedSite: "\uE72F",
            FavoriteStar: "\uE734",
            FavoriteStarFill: "\uE735",
            CheckMark: "\uE73E",
            Delete: "\uE74D",
            ChevronLeft: "\uE76B",
            ChevronRight: "\uE76C",
            Calendar: "\uE787",
            Megaphone: "\uE789",
            Undo: "\uE7A7",
            Flag: "\uE7C1",
            Page: "\uE7C3",
            Pinned: "\uE840",
            View: "\uE890",
            Clear: "\uE894",
            Download: "\uE896",
            Upload: "\uE898",
            Folder: "\uE8B7",
            Sort: "\uE8CB",
            AlignRight: "\uE8E2",
            AlignLeft: "\uE8E4",
            Tag: "\uE8EC",
            AddFriend: "\uE8FA",
            Info: "\uE946",
            SortLines: "\uE9D0",
            List: "\uEA37",
            CircleRing: "\uEA3A",
            Heart: "\uEB51",
            HeartFill: "\uEB52",
            Tiles: "\uECA5",
            Embed: "\uECCE",
            Glimmer: "\uECF4",
            Ascending: "\uEDC0",
            Descending: "\uEDC1",
            SortUp: "\uEE68",
            SortDown: "\uEE69",
            SyncToPC: "\uEE6E",
            LargeGrid: "\uEECB",
            SkypeCheck: "\uEF80",
            SkypeClock: "\uEF81",
            SkypeMinus: "\uEF82",
            ClearFilter: "\uEF8F",
            Flow: "\uEF90",
            StatusCircleCheckmark: "\uF13E",
            MoreVertical: "\uF2BC"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $76cf319aa4e8f11b$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-0"',
            src: "url('".concat(baseUrl, "fabric-icons-0-467ee27f.woff') format('woff')")
        },
        icons: {
            "PageLink": "\uE302",
            "CommentSolid": "\uE30E",
            "ChangeEntitlements": "\uE310",
            "Installation": "\uE311",
            "WebAppBuilderModule": "\uE313",
            "WebAppBuilderFragment": "\uE314",
            "WebAppBuilderSlot": "\uE315",
            "BullseyeTargetEdit": "\uE319",
            "WebAppBuilderFragmentCreate": "\uE31B",
            "PageData": "\uE31C",
            "PageHeaderEdit": "\uE31D",
            "ProductList": "\uE31E",
            "UnpublishContent": "\uE31F",
            "DependencyAdd": "\uE344",
            "DependencyRemove": "\uE345",
            "EntitlementPolicy": "\uE346",
            "EntitlementRedemption": "\uE347",
            "SchoolDataSyncLogo": "\uE34C",
            "PinSolid12": "\uE352",
            "PinSolidOff12": "\uE353",
            "AddLink": "\uE35E",
            "SharepointAppIcon16": "\uE365",
            "DataflowsLink": "\uE366",
            "TimePicker": "\uE367",
            "UserWarning": "\uE368",
            "ComplianceAudit": "\uE369",
            "InternetSharing": "\uE704",
            "Brightness": "\uE706",
            "MapPin": "\uE707",
            "Airplane": "\uE709",
            "Tablet": "\uE70A",
            "QuickNote": "\uE70B",
            "Video": "\uE714",
            "People": "\uE716",
            "Phone": "\uE717",
            "Pin": "\uE718",
            "Shop": "\uE719",
            "Stop": "\uE71A",
            "Link": "\uE71B",
            "AllApps": "\uE71D",
            "Zoom": "\uE71E",
            "ZoomOut": "\uE71F",
            "Microphone": "\uE720",
            "Camera": "\uE722",
            "Attach": "\uE723",
            "Send": "\uE724",
            "FavoriteList": "\uE728",
            "PageSolid": "\uE729",
            "Forward": "\uE72A",
            "Back": "\uE72B",
            "Refresh": "\uE72C",
            "Lock": "\uE72E",
            "ReportHacked": "\uE730",
            "EMI": "\uE731",
            "MiniLink": "\uE732",
            "Blocked": "\uE733",
            "ReadingMode": "\uE736",
            "Favicon": "\uE737",
            "Remove": "\uE738",
            "Checkbox": "\uE739",
            "CheckboxComposite": "\uE73A",
            "CheckboxFill": "\uE73B",
            "CheckboxIndeterminate": "\uE73C",
            "CheckboxCompositeReversed": "\uE73D",
            "BackToWindow": "\uE73F",
            "FullScreen": "\uE740",
            "Print": "\uE749",
            "Up": "\uE74A",
            "Down": "\uE74B",
            "OEM": "\uE74C",
            "Save": "\uE74E",
            "ReturnKey": "\uE751",
            "Cloud": "\uE753",
            "Flashlight": "\uE754",
            "CommandPrompt": "\uE756",
            "Sad": "\uE757",
            "RealEstate": "\uE758",
            "SIPMove": "\uE759",
            "EraseTool": "\uE75C",
            "GripperTool": "\uE75E",
            "Dialpad": "\uE75F",
            "PageLeft": "\uE760",
            "PageRight": "\uE761",
            "MultiSelect": "\uE762",
            "KeyboardClassic": "\uE765",
            "Play": "\uE768",
            "Pause": "\uE769",
            "InkingTool": "\uE76D",
            "Emoji2": "\uE76E",
            "GripperBarHorizontal": "\uE76F",
            "System": "\uE770",
            "Personalize": "\uE771",
            "SearchAndApps": "\uE773",
            "Globe": "\uE774",
            "EaseOfAccess": "\uE776",
            "ContactInfo": "\uE779",
            "Unpin": "\uE77A",
            "Contact": "\uE77B",
            "Memo": "\uE77C",
            "IncomingCall": "\uE77E"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $8c43ddeb2add31c4$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-1"',
            src: "url('".concat(baseUrl, "fabric-icons-1-4d521695.woff') format('woff')")
        },
        icons: {
            "Paste": "\uE77F",
            "WindowsLogo": "\uE782",
            "Error": "\uE783",
            "GripperBarVertical": "\uE784",
            "Unlock": "\uE785",
            "Slideshow": "\uE786",
            "Trim": "\uE78A",
            "AutoEnhanceOn": "\uE78D",
            "AutoEnhanceOff": "\uE78E",
            "Color": "\uE790",
            "SaveAs": "\uE792",
            "Light": "\uE793",
            "Filters": "\uE795",
            "AspectRatio": "\uE799",
            "Contrast": "\uE7A1",
            "Redo": "\uE7A6",
            "Crop": "\uE7A8",
            "PhotoCollection": "\uE7AA",
            "Album": "\uE7AB",
            "Rotate": "\uE7AD",
            "PanoIndicator": "\uE7B0",
            "Translate": "\uE7B2",
            "RedEye": "\uE7B3",
            "ViewOriginal": "\uE7B4",
            "ThumbnailView": "\uE7B6",
            "Package": "\uE7B8",
            "Telemarketer": "\uE7B9",
            "Warning": "\uE7BA",
            "Financial": "\uE7BB",
            "Education": "\uE7BE",
            "ShoppingCart": "\uE7BF",
            "Train": "\uE7C0",
            "Move": "\uE7C2",
            "TouchPointer": "\uE7C9",
            "Merge": "\uE7D5",
            "TurnRight": "\uE7DB",
            "Ferry": "\uE7E3",
            "Highlight": "\uE7E6",
            "PowerButton": "\uE7E8",
            "Tab": "\uE7E9",
            "Admin": "\uE7EF",
            "TVMonitor": "\uE7F4",
            "Speakers": "\uE7F5",
            "Game": "\uE7FC",
            "HorizontalTabKey": "\uE7FD",
            "UnstackSelected": "\uE7FE",
            "StackIndicator": "\uE7FF",
            "Nav2DMapView": "\uE800",
            "StreetsideSplitMinimize": "\uE802",
            "Car": "\uE804",
            "Bus": "\uE806",
            "EatDrink": "\uE807",
            "SeeDo": "\uE808",
            "LocationCircle": "\uE80E",
            "Home": "\uE80F",
            "SwitcherStartEnd": "\uE810",
            "ParkingLocation": "\uE811",
            "IncidentTriangle": "\uE814",
            "Touch": "\uE815",
            "MapDirections": "\uE816",
            "CaretHollow": "\uE817",
            "CaretSolid": "\uE818",
            "History": "\uE81C",
            "Location": "\uE81D",
            "MapLayers": "\uE81E",
            "SearchNearby": "\uE820",
            "Work": "\uE821",
            "Recent": "\uE823",
            "Hotel": "\uE824",
            "Bank": "\uE825",
            "LocationDot": "\uE827",
            "Dictionary": "\uE82D",
            "ChromeBack": "\uE830",
            "FolderOpen": "\uE838",
            "PinnedFill": "\uE842",
            "RevToggleKey": "\uE845",
            "USB": "\uE88E",
            "Previous": "\uE892",
            "Next": "\uE893",
            "Sync": "\uE895",
            "Help": "\uE897",
            "Emoji": "\uE899",
            "MailForward": "\uE89C",
            "ClosePane": "\uE89F",
            "OpenPane": "\uE8A0",
            "PreviewLink": "\uE8A1",
            "ZoomIn": "\uE8A3",
            "Bookmarks": "\uE8A4",
            "Document": "\uE8A5",
            "ProtectedDocument": "\uE8A6",
            "OpenInNewWindow": "\uE8A7",
            "MailFill": "\uE8A8",
            "ViewAll": "\uE8A9",
            "Switch": "\uE8AB",
            "Rename": "\uE8AC",
            "Go": "\uE8AD",
            "Remote": "\uE8AF",
            "SelectAll": "\uE8B3",
            "Orientation": "\uE8B4",
            "Import": "\uE8B5"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $ae63f8c56964b417$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-2"',
            src: "url('".concat(baseUrl, "fabric-icons-2-63c99abf.woff') format('woff')")
        },
        icons: {
            "Picture": "\uE8B9",
            "ChromeClose": "\uE8BB",
            "ShowResults": "\uE8BC",
            "Message": "\uE8BD",
            "CalendarDay": "\uE8BF",
            "CalendarWeek": "\uE8C0",
            "MailReplyAll": "\uE8C2",
            "Read": "\uE8C3",
            "Cut": "\uE8C6",
            "PaymentCard": "\uE8C7",
            "Copy": "\uE8C8",
            "Important": "\uE8C9",
            "MailReply": "\uE8CA",
            "GotoToday": "\uE8D1",
            "Font": "\uE8D2",
            "FontColor": "\uE8D3",
            "FolderFill": "\uE8D5",
            "Permissions": "\uE8D7",
            "DisableUpdates": "\uE8D8",
            "Unfavorite": "\uE8D9",
            "Italic": "\uE8DB",
            "Underline": "\uE8DC",
            "Bold": "\uE8DD",
            "MoveToFolder": "\uE8DE",
            "Dislike": "\uE8E0",
            "Like": "\uE8E1",
            "AlignCenter": "\uE8E3",
            "OpenFile": "\uE8E5",
            "ClearSelection": "\uE8E6",
            "FontDecrease": "\uE8E7",
            "FontIncrease": "\uE8E8",
            "FontSize": "\uE8E9",
            "CellPhone": "\uE8EA",
            "RepeatOne": "\uE8ED",
            "RepeatAll": "\uE8EE",
            "Calculator": "\uE8EF",
            "Library": "\uE8F1",
            "PostUpdate": "\uE8F3",
            "NewFolder": "\uE8F4",
            "CalendarReply": "\uE8F5",
            "UnsyncFolder": "\uE8F6",
            "SyncFolder": "\uE8F7",
            "BlockContact": "\uE8F8",
            "Accept": "\uE8FB",
            "BulletedList": "\uE8FD",
            "Preview": "\uE8FF",
            "News": "\uE900",
            "Chat": "\uE901",
            "Group": "\uE902",
            "World": "\uE909",
            "Comment": "\uE90A",
            "DockLeft": "\uE90C",
            "DockRight": "\uE90D",
            "Repair": "\uE90F",
            "Accounts": "\uE910",
            "Street": "\uE913",
            "RadioBullet": "\uE915",
            "Stopwatch": "\uE916",
            "Clock": "\uE917",
            "WorldClock": "\uE918",
            "AlarmClock": "\uE919",
            "Photo": "\uE91B",
            "ActionCenter": "\uE91C",
            "Hospital": "\uE91D",
            "Timer": "\uE91E",
            "FullCircleMask": "\uE91F",
            "LocationFill": "\uE920",
            "ChromeMinimize": "\uE921",
            "ChromeRestore": "\uE923",
            "Annotation": "\uE924",
            "Fingerprint": "\uE928",
            "Handwriting": "\uE929",
            "ChromeFullScreen": "\uE92D",
            "Completed": "\uE930",
            "Label": "\uE932",
            "FlickDown": "\uE935",
            "FlickUp": "\uE936",
            "FlickLeft": "\uE937",
            "FlickRight": "\uE938",
            "MiniExpand": "\uE93A",
            "MiniContract": "\uE93B",
            "Streaming": "\uE93E",
            "MusicInCollection": "\uE940",
            "OneDriveLogo": "\uE941",
            "CompassNW": "\uE942",
            "Code": "\uE943",
            "LightningBolt": "\uE945",
            "CalculatorMultiply": "\uE947",
            "CalculatorAddition": "\uE948",
            "CalculatorSubtract": "\uE949",
            "CalculatorPercentage": "\uE94C",
            "CalculatorEqualTo": "\uE94E",
            "PrintfaxPrinterFile": "\uE956",
            "StorageOptical": "\uE958",
            "Communications": "\uE95A",
            "Headset": "\uE95B",
            "Health": "\uE95E",
            "Webcam2": "\uE960",
            "FrontCamera": "\uE96B",
            "ChevronUpSmall": "\uE96D"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $6806cb685a31e098$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-3"',
            src: "url('".concat(baseUrl, "fabric-icons-3-089e217a.woff') format('woff')")
        },
        icons: {
            "ChevronDownSmall": "\uE96E",
            "ChevronLeftSmall": "\uE96F",
            "ChevronRightSmall": "\uE970",
            "ChevronUpMed": "\uE971",
            "ChevronDownMed": "\uE972",
            "ChevronLeftMed": "\uE973",
            "ChevronRightMed": "\uE974",
            "Devices2": "\uE975",
            "PC1": "\uE977",
            "PresenceChickletVideo": "\uE979",
            "Reply": "\uE97A",
            "HalfAlpha": "\uE97E",
            "ConstructionCone": "\uE98F",
            "DoubleChevronLeftMed": "\uE991",
            "Volume0": "\uE992",
            "Volume1": "\uE993",
            "Volume2": "\uE994",
            "Volume3": "\uE995",
            "Chart": "\uE999",
            "Robot": "\uE99A",
            "Manufacturing": "\uE99C",
            "LockSolid": "\uE9A2",
            "FitPage": "\uE9A6",
            "FitWidth": "\uE9A7",
            "BidiLtr": "\uE9AA",
            "BidiRtl": "\uE9AB",
            "RightDoubleQuote": "\uE9B1",
            "Sunny": "\uE9BD",
            "CloudWeather": "\uE9BE",
            "Cloudy": "\uE9BF",
            "PartlyCloudyDay": "\uE9C0",
            "PartlyCloudyNight": "\uE9C1",
            "ClearNight": "\uE9C2",
            "RainShowersDay": "\uE9C3",
            "Rain": "\uE9C4",
            "Thunderstorms": "\uE9C6",
            "RainSnow": "\uE9C7",
            "Snow": "\uE9C8",
            "BlowingSnow": "\uE9C9",
            "Frigid": "\uE9CA",
            "Fog": "\uE9CB",
            "Squalls": "\uE9CC",
            "Duststorm": "\uE9CD",
            "Unknown": "\uE9CE",
            "Precipitation": "\uE9CF",
            "Ribbon": "\uE9D1",
            "AreaChart": "\uE9D2",
            "Assign": "\uE9D3",
            "FlowChart": "\uE9D4",
            "CheckList": "\uE9D5",
            "Diagnostic": "\uE9D9",
            "Generate": "\uE9DA",
            "LineChart": "\uE9E6",
            "Equalizer": "\uE9E9",
            "BarChartHorizontal": "\uE9EB",
            "BarChartVertical": "\uE9EC",
            "Freezing": "\uE9EF",
            "FunnelChart": "\uE9F1",
            "Processing": "\uE9F5",
            "Quantity": "\uE9F8",
            "ReportDocument": "\uE9F9",
            "StackColumnChart": "\uE9FC",
            "SnowShowerDay": "\uE9FD",
            "HailDay": "\uEA00",
            "WorkFlow": "\uEA01",
            "HourGlass": "\uEA03",
            "StoreLogoMed20": "\uEA04",
            "TimeSheet": "\uEA05",
            "TriangleSolid": "\uEA08",
            "UpgradeAnalysis": "\uEA0B",
            "VideoSolid": "\uEA0C",
            "RainShowersNight": "\uEA0F",
            "SnowShowerNight": "\uEA11",
            "Teamwork": "\uEA12",
            "HailNight": "\uEA13",
            "PeopleAdd": "\uEA15",
            "Glasses": "\uEA16",
            "DateTime2": "\uEA17",
            "Shield": "\uEA18",
            "Header1": "\uEA19",
            "PageAdd": "\uEA1A",
            "NumberedList": "\uEA1C",
            "PowerBILogo": "\uEA1E",
            "Info2": "\uEA1F",
            "MusicInCollectionFill": "\uEA36",
            "Asterisk": "\uEA38",
            "ErrorBadge": "\uEA39",
            "CircleFill": "\uEA3B",
            "Record2": "\uEA3F",
            "AllAppsMirrored": "\uEA40",
            "BookmarksMirrored": "\uEA41",
            "BulletedListMirrored": "\uEA42",
            "CaretHollowMirrored": "\uEA45",
            "CaretSolidMirrored": "\uEA46",
            "ChromeBackMirrored": "\uEA47",
            "ClearSelectionMirrored": "\uEA48",
            "ClosePaneMirrored": "\uEA49",
            "DockLeftMirrored": "\uEA4C",
            "DoubleChevronLeftMedMirrored": "\uEA4D",
            "GoMirrored": "\uEA4F"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $c1db7c9ea0f3c642$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-4"',
            src: "url('".concat(baseUrl, "fabric-icons-4-a656cc0a.woff') format('woff')")
        },
        icons: {
            "HelpMirrored": "\uEA51",
            "ImportMirrored": "\uEA52",
            "ImportAllMirrored": "\uEA53",
            "ListMirrored": "\uEA55",
            "MailForwardMirrored": "\uEA56",
            "MailReplyMirrored": "\uEA57",
            "MailReplyAllMirrored": "\uEA58",
            "MiniContractMirrored": "\uEA59",
            "MiniExpandMirrored": "\uEA5A",
            "OpenPaneMirrored": "\uEA5B",
            "ParkingLocationMirrored": "\uEA5E",
            "SendMirrored": "\uEA63",
            "ShowResultsMirrored": "\uEA65",
            "ThumbnailViewMirrored": "\uEA67",
            "Media": "\uEA69",
            "Devices3": "\uEA6C",
            "Focus": "\uEA6F",
            "VideoLightOff": "\uEA74",
            "Lightbulb": "\uEA80",
            "StatusTriangle": "\uEA82",
            "VolumeDisabled": "\uEA85",
            "Puzzle": "\uEA86",
            "EmojiNeutral": "\uEA87",
            "EmojiDisappointed": "\uEA88",
            "HomeSolid": "\uEA8A",
            "Ringer": "\uEA8F",
            "PDF": "\uEA90",
            "HeartBroken": "\uEA92",
            "StoreLogo16": "\uEA96",
            "MultiSelectMirrored": "\uEA98",
            "Broom": "\uEA99",
            "AddToShoppingList": "\uEA9A",
            "Cocktails": "\uEA9D",
            "Wines": "\uEABF",
            "Articles": "\uEAC1",
            "Cycling": "\uEAC7",
            "DietPlanNotebook": "\uEAC8",
            "Pill": "\uEACB",
            "ExerciseTracker": "\uEACC",
            "HandsFree": "\uEAD0",
            "Medical": "\uEAD4",
            "Running": "\uEADA",
            "Weights": "\uEADB",
            "Trackers": "\uEADF",
            "AddNotes": "\uEAE3",
            "AllCurrency": "\uEAE4",
            "BarChart4": "\uEAE7",
            "CirclePlus": "\uEAEE",
            "Coffee": "\uEAEF",
            "Cotton": "\uEAF3",
            "Market": "\uEAFC",
            "Money": "\uEAFD",
            "PieDouble": "\uEB04",
            "PieSingle": "\uEB05",
            "RemoveFilter": "\uEB08",
            "Savings": "\uEB0B",
            "Sell": "\uEB0C",
            "StockDown": "\uEB0F",
            "StockUp": "\uEB11",
            "Lamp": "\uEB19",
            "Source": "\uEB1B",
            "MSNVideos": "\uEB1C",
            "Cricket": "\uEB1E",
            "Golf": "\uEB1F",
            "Baseball": "\uEB20",
            "Soccer": "\uEB21",
            "MoreSports": "\uEB22",
            "AutoRacing": "\uEB24",
            "CollegeHoops": "\uEB25",
            "CollegeFootball": "\uEB26",
            "ProFootball": "\uEB27",
            "ProHockey": "\uEB28",
            "Rugby": "\uEB2D",
            "SubstitutionsIn": "\uEB31",
            "Tennis": "\uEB33",
            "Arrivals": "\uEB34",
            "Design": "\uEB3C",
            "Website": "\uEB41",
            "Drop": "\uEB42",
            "HistoricalWeather": "\uEB43",
            "SkiResorts": "\uEB45",
            "Snowflake": "\uEB46",
            "BusSolid": "\uEB47",
            "FerrySolid": "\uEB48",
            "AirplaneSolid": "\uEB4C",
            "TrainSolid": "\uEB4D",
            "Ticket": "\uEB54",
            "WifiWarning4": "\uEB63",
            "Devices4": "\uEB66",
            "AzureLogo": "\uEB6A",
            "BingLogo": "\uEB6B",
            "MSNLogo": "\uEB6C",
            "OutlookLogoInverse": "\uEB6D",
            "OfficeLogo": "\uEB6E",
            "SkypeLogo": "\uEB6F",
            "Door": "\uEB75",
            "EditMirrored": "\uEB7E",
            "GiftCard": "\uEB8E",
            "DoubleBookmark": "\uEB8F",
            "StatusErrorFull": "\uEB90"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $19fb2c54b1fb3907$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-5"',
            src: "url('".concat(baseUrl, "fabric-icons-5-f95ba260.woff') format('woff')")
        },
        icons: {
            "Certificate": "\uEB95",
            "FastForward": "\uEB9D",
            "Rewind": "\uEB9E",
            "Photo2": "\uEB9F",
            "OpenSource": "\uEBC2",
            "Movers": "\uEBCD",
            "CloudDownload": "\uEBD3",
            "Family": "\uEBDA",
            "WindDirection": "\uEBE6",
            "Bug": "\uEBE8",
            "SiteScan": "\uEBEC",
            "BrowserScreenShot": "\uEBED",
            "F12DevTools": "\uEBEE",
            "CSS": "\uEBEF",
            "JS": "\uEBF0",
            "DeliveryTruck": "\uEBF4",
            "ReminderPerson": "\uEBF7",
            "ReminderGroup": "\uEBF8",
            "ReminderTime": "\uEBF9",
            "TabletMode": "\uEBFC",
            "Umbrella": "\uEC04",
            "NetworkTower": "\uEC05",
            "CityNext": "\uEC06",
            "CityNext2": "\uEC07",
            "Section": "\uEC0C",
            "OneNoteLogoInverse": "\uEC0D",
            "ToggleFilled": "\uEC11",
            "ToggleBorder": "\uEC12",
            "SliderThumb": "\uEC13",
            "ToggleThumb": "\uEC14",
            "Documentation": "\uEC17",
            "Badge": "\uEC1B",
            "Giftbox": "\uEC1F",
            "VisualStudioLogo": "\uEC22",
            "HomeGroup": "\uEC26",
            "ExcelLogoInverse": "\uEC28",
            "WordLogoInverse": "\uEC29",
            "PowerPointLogoInverse": "\uEC2A",
            "Cafe": "\uEC32",
            "SpeedHigh": "\uEC4A",
            "Commitments": "\uEC4D",
            "ThisPC": "\uEC4E",
            "MusicNote": "\uEC4F",
            "MicOff": "\uEC54",
            "PlaybackRate1x": "\uEC57",
            "EdgeLogo": "\uEC60",
            "CompletedSolid": "\uEC61",
            "AlbumRemove": "\uEC62",
            "MessageFill": "\uEC70",
            "TabletSelected": "\uEC74",
            "MobileSelected": "\uEC75",
            "LaptopSelected": "\uEC76",
            "TVMonitorSelected": "\uEC77",
            "DeveloperTools": "\uEC7A",
            "Shapes": "\uEC7C",
            "InsertTextBox": "\uEC7D",
            "LowerBrightness": "\uEC8A",
            "WebComponents": "\uEC8B",
            "OfflineStorage": "\uEC8C",
            "DOM": "\uEC8D",
            "CloudUpload": "\uEC8E",
            "ScrollUpDown": "\uEC8F",
            "DateTime": "\uEC92",
            "Event": "\uECA3",
            "Cake": "\uECA4",
            "Org": "\uECA6",
            "PartyLeader": "\uECA7",
            "DRM": "\uECA8",
            "CloudAdd": "\uECA9",
            "AppIconDefault": "\uECAA",
            "Photo2Add": "\uECAB",
            "Photo2Remove": "\uECAC",
            "Calories": "\uECAD",
            "POI": "\uECAF",
            "AddTo": "\uECC8",
            "RadioBtnOff": "\uECCA",
            "RadioBtnOn": "\uECCB",
            "ExploreContent": "\uECCD",
            "Product": "\uECDC",
            "ProgressLoopInner": "\uECDE",
            "ProgressLoopOuter": "\uECDF",
            "Blocked2": "\uECE4",
            "FangBody": "\uECEB",
            "Toolbox": "\uECED",
            "PageHeader": "\uECEE",
            "ChatInviteFriend": "\uECFE",
            "Brush": "\uECFF",
            "Shirt": "\uED00",
            "Crown": "\uED01",
            "Diamond": "\uED02",
            "ScaleUp": "\uED09",
            "QRCode": "\uED14",
            "Feedback": "\uED15",
            "SharepointLogoInverse": "\uED18",
            "YammerLogo": "\uED19",
            "Hide": "\uED1A",
            "Uneditable": "\uED1D",
            "ReturnToSession": "\uED24",
            "OpenFolderHorizontal": "\uED25",
            "CalendarMirrored": "\uED28"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $bdc9ff86e1052fcc$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-6"',
            src: "url('".concat(baseUrl, "fabric-icons-6-ef6fd590.woff') format('woff')")
        },
        icons: {
            "SwayLogoInverse": "\uED29",
            "OutOfOffice": "\uED34",
            "Trophy": "\uED3F",
            "ReopenPages": "\uED50",
            "EmojiTabSymbols": "\uED58",
            "AADLogo": "\uED68",
            "AccessLogo": "\uED69",
            "AdminALogoInverse32": "\uED6A",
            "AdminCLogoInverse32": "\uED6B",
            "AdminDLogoInverse32": "\uED6C",
            "AdminELogoInverse32": "\uED6D",
            "AdminLLogoInverse32": "\uED6E",
            "AdminMLogoInverse32": "\uED6F",
            "AdminOLogoInverse32": "\uED70",
            "AdminPLogoInverse32": "\uED71",
            "AdminSLogoInverse32": "\uED72",
            "AdminYLogoInverse32": "\uED73",
            "DelveLogoInverse": "\uED76",
            "ExchangeLogoInverse": "\uED78",
            "LyncLogo": "\uED79",
            "OfficeVideoLogoInverse": "\uED7A",
            "SocialListeningLogo": "\uED7C",
            "VisioLogoInverse": "\uED7D",
            "Balloons": "\uED7E",
            "Cat": "\uED7F",
            "MailAlert": "\uED80",
            "MailCheck": "\uED81",
            "MailLowImportance": "\uED82",
            "MailPause": "\uED83",
            "MailRepeat": "\uED84",
            "SecurityGroup": "\uED85",
            "Table": "\uED86",
            "VoicemailForward": "\uED87",
            "VoicemailReply": "\uED88",
            "Waffle": "\uED89",
            "RemoveEvent": "\uED8A",
            "EventInfo": "\uED8B",
            "ForwardEvent": "\uED8C",
            "WipePhone": "\uED8D",
            "AddOnlineMeeting": "\uED8E",
            "JoinOnlineMeeting": "\uED8F",
            "RemoveLink": "\uED90",
            "PeopleBlock": "\uED91",
            "PeopleRepeat": "\uED92",
            "PeopleAlert": "\uED93",
            "PeoplePause": "\uED94",
            "TransferCall": "\uED95",
            "AddPhone": "\uED96",
            "UnknownCall": "\uED97",
            "NoteReply": "\uED98",
            "NoteForward": "\uED99",
            "NotePinned": "\uED9A",
            "RemoveOccurrence": "\uED9B",
            "Timeline": "\uED9C",
            "EditNote": "\uED9D",
            "CircleHalfFull": "\uED9E",
            "Room": "\uED9F",
            "Unsubscribe": "\uEDA0",
            "Subscribe": "\uEDA1",
            "HardDrive": "\uEDA2",
            "RecurringTask": "\uEDB2",
            "TaskManager": "\uEDB7",
            "TaskManagerMirrored": "\uEDB8",
            "Combine": "\uEDBB",
            "Split": "\uEDBC",
            "DoubleChevronUp": "\uEDBD",
            "DoubleChevronLeft": "\uEDBE",
            "DoubleChevronRight": "\uEDBF",
            "TextBox": "\uEDC2",
            "TextField": "\uEDC3",
            "NumberField": "\uEDC4",
            "Dropdown": "\uEDC5",
            "PenWorkspace": "\uEDC6",
            "BookingsLogo": "\uEDC7",
            "ClassNotebookLogoInverse": "\uEDC8",
            "DelveAnalyticsLogo": "\uEDCA",
            "DocsLogoInverse": "\uEDCB",
            "Dynamics365Logo": "\uEDCC",
            "DynamicSMBLogo": "\uEDCD",
            "OfficeAssistantLogo": "\uEDCE",
            "OfficeStoreLogo": "\uEDCF",
            "OneNoteEduLogoInverse": "\uEDD0",
            "PlannerLogo": "\uEDD1",
            "PowerApps": "\uEDD2",
            "Suitcase": "\uEDD3",
            "ProjectLogoInverse": "\uEDD4",
            "CaretLeft8": "\uEDD5",
            "CaretRight8": "\uEDD6",
            "CaretUp8": "\uEDD7",
            "CaretDown8": "\uEDD8",
            "CaretLeftSolid8": "\uEDD9",
            "CaretRightSolid8": "\uEDDA",
            "CaretUpSolid8": "\uEDDB",
            "CaretDownSolid8": "\uEDDC",
            "ClearFormatting": "\uEDDD",
            "Superscript": "\uEDDE",
            "Subscript": "\uEDDF",
            "Strikethrough": "\uEDE0",
            "Export": "\uEDE1",
            "ExportMirrored": "\uEDE2"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $2047f6280f675905$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-7"',
            src: "url('".concat(baseUrl, "fabric-icons-7-2b97bb99.woff') format('woff')")
        },
        icons: {
            "SingleBookmark": "\uEDFF",
            "SingleBookmarkSolid": "\uEE00",
            "DoubleChevronDown": "\uEE04",
            "FollowUser": "\uEE05",
            "ReplyAll": "\uEE0A",
            "WorkforceManagement": "\uEE0F",
            "RecruitmentManagement": "\uEE12",
            "Questionnaire": "\uEE19",
            "ManagerSelfService": "\uEE23",
            "ProductionFloorManagement": "\uEE29",
            "ProductRelease": "\uEE2E",
            "ProductVariant": "\uEE30",
            "ReplyMirrored": "\uEE35",
            "ReplyAllMirrored": "\uEE36",
            "Medal": "\uEE38",
            "AddGroup": "\uEE3D",
            "QuestionnaireMirrored": "\uEE4B",
            "CloudImportExport": "\uEE55",
            "TemporaryUser": "\uEE58",
            "CaretSolid16": "\uEE62",
            "GroupedDescending": "\uEE66",
            "GroupedAscending": "\uEE67",
            "AwayStatus": "\uEE6A",
            "MyMoviesTV": "\uEE6C",
            "GenericScan": "\uEE6F",
            "AustralianRules": "\uEE70",
            "WifiEthernet": "\uEE77",
            "TrackersMirrored": "\uEE92",
            "DateTimeMirrored": "\uEE93",
            "StopSolid": "\uEE95",
            "DoubleChevronUp12": "\uEE96",
            "DoubleChevronDown12": "\uEE97",
            "DoubleChevronLeft12": "\uEE98",
            "DoubleChevronRight12": "\uEE99",
            "CalendarAgenda": "\uEE9A",
            "ConnectVirtualMachine": "\uEE9D",
            "AddEvent": "\uEEB5",
            "AssetLibrary": "\uEEB6",
            "DataConnectionLibrary": "\uEEB7",
            "DocLibrary": "\uEEB8",
            "FormLibrary": "\uEEB9",
            "FormLibraryMirrored": "\uEEBA",
            "ReportLibrary": "\uEEBB",
            "ReportLibraryMirrored": "\uEEBC",
            "ContactCard": "\uEEBD",
            "CustomList": "\uEEBE",
            "CustomListMirrored": "\uEEBF",
            "IssueTracking": "\uEEC0",
            "IssueTrackingMirrored": "\uEEC1",
            "PictureLibrary": "\uEEC2",
            "OfficeAddinsLogo": "\uEEC7",
            "OfflineOneDriveParachute": "\uEEC8",
            "OfflineOneDriveParachuteDisabled": "\uEEC9",
            "TriangleSolidUp12": "\uEECC",
            "TriangleSolidDown12": "\uEECD",
            "TriangleSolidLeft12": "\uEECE",
            "TriangleSolidRight12": "\uEECF",
            "TriangleUp12": "\uEED0",
            "TriangleDown12": "\uEED1",
            "TriangleLeft12": "\uEED2",
            "TriangleRight12": "\uEED3",
            "ArrowUpRight8": "\uEED4",
            "ArrowDownRight8": "\uEED5",
            "DocumentSet": "\uEED6",
            "GoToDashboard": "\uEEED",
            "DelveAnalytics": "\uEEEE",
            "ArrowUpRightMirrored8": "\uEEEF",
            "ArrowDownRightMirrored8": "\uEEF0",
            "CompanyDirectory": "\uEF0D",
            "OpenEnrollment": "\uEF1C",
            "CompanyDirectoryMirrored": "\uEF2B",
            "OneDriveAdd": "\uEF32",
            "ProfileSearch": "\uEF35",
            "Header2": "\uEF36",
            "Header3": "\uEF37",
            "Header4": "\uEF38",
            "RingerSolid": "\uEF3A",
            "Eyedropper": "\uEF3C",
            "MarketDown": "\uEF42",
            "CalendarWorkWeek": "\uEF51",
            "SidePanel": "\uEF52",
            "GlobeFavorite": "\uEF53",
            "CaretTopLeftSolid8": "\uEF54",
            "CaretTopRightSolid8": "\uEF55",
            "ViewAll2": "\uEF56",
            "DocumentReply": "\uEF57",
            "PlayerSettings": "\uEF58",
            "ReceiptForward": "\uEF59",
            "ReceiptReply": "\uEF5A",
            "ReceiptCheck": "\uEF5B",
            "Fax": "\uEF5C",
            "RecurringEvent": "\uEF5D",
            "ReplyAlt": "\uEF5E",
            "ReplyAllAlt": "\uEF5F",
            "EditStyle": "\uEF60",
            "EditMail": "\uEF61",
            "Lifesaver": "\uEF62",
            "LifesaverLock": "\uEF63",
            "InboxCheck": "\uEF64",
            "FolderSearch": "\uEF65"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $06910dea4eaec01e$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-8"',
            src: "url('".concat(baseUrl, "fabric-icons-8-6fdf1528.woff') format('woff')")
        },
        icons: {
            "CollapseMenu": "\uEF66",
            "ExpandMenu": "\uEF67",
            "Boards": "\uEF68",
            "SunAdd": "\uEF69",
            "SunQuestionMark": "\uEF6A",
            "LandscapeOrientation": "\uEF6B",
            "DocumentSearch": "\uEF6C",
            "PublicCalendar": "\uEF6D",
            "PublicContactCard": "\uEF6E",
            "PublicEmail": "\uEF6F",
            "PublicFolder": "\uEF70",
            "WordDocument": "\uEF71",
            "PowerPointDocument": "\uEF72",
            "ExcelDocument": "\uEF73",
            "GroupedList": "\uEF74",
            "ClassroomLogo": "\uEF75",
            "Sections": "\uEF76",
            "EditPhoto": "\uEF77",
            "Starburst": "\uEF78",
            "ShareiOS": "\uEF79",
            "AirTickets": "\uEF7A",
            "PencilReply": "\uEF7B",
            "Tiles2": "\uEF7C",
            "SkypeCircleCheck": "\uEF7D",
            "SkypeCircleClock": "\uEF7E",
            "SkypeCircleMinus": "\uEF7F",
            "SkypeMessage": "\uEF83",
            "ClosedCaption": "\uEF84",
            "ATPLogo": "\uEF85",
            "OfficeFormsLogoInverse": "\uEF86",
            "RecycleBin": "\uEF87",
            "EmptyRecycleBin": "\uEF88",
            "Hide2": "\uEF89",
            "Breadcrumb": "\uEF8C",
            "BirthdayCake": "\uEF8D",
            "TimeEntry": "\uEF95",
            "CRMProcesses": "\uEFB1",
            "PageEdit": "\uEFB6",
            "PageArrowRight": "\uEFB8",
            "PageRemove": "\uEFBA",
            "Database": "\uEFC7",
            "DataManagementSettings": "\uEFC8",
            "CRMServices": "\uEFD2",
            "EditContact": "\uEFD3",
            "ConnectContacts": "\uEFD4",
            "AppIconDefaultAdd": "\uEFDA",
            "AppIconDefaultList": "\uEFDE",
            "ActivateOrders": "\uEFE0",
            "DeactivateOrders": "\uEFE1",
            "ProductCatalog": "\uEFE8",
            "ScatterChart": "\uEFEB",
            "AccountActivity": "\uEFF4",
            "DocumentManagement": "\uEFFC",
            "CRMReport": "\uEFFE",
            "KnowledgeArticle": "\uF000",
            "Relationship": "\uF003",
            "HomeVerify": "\uF00E",
            "ZipFolder": "\uF012",
            "SurveyQuestions": "\uF01B",
            "TextDocument": "\uF029",
            "TextDocumentShared": "\uF02B",
            "PageCheckedOut": "\uF02C",
            "PageShared": "\uF02D",
            "SaveAndClose": "\uF038",
            "Script": "\uF03A",
            "Archive": "\uF03F",
            "ActivityFeed": "\uF056",
            "Compare": "\uF057",
            "EventDate": "\uF059",
            "ArrowUpRight": "\uF069",
            "CaretRight": "\uF06B",
            "SetAction": "\uF071",
            "ChatBot": "\uF08B",
            "CaretSolidLeft": "\uF08D",
            "CaretSolidDown": "\uF08E",
            "CaretSolidRight": "\uF08F",
            "CaretSolidUp": "\uF090",
            "PowerAppsLogo": "\uF091",
            "PowerApps2Logo": "\uF092",
            "SearchIssue": "\uF09A",
            "SearchIssueMirrored": "\uF09B",
            "FabricAssetLibrary": "\uF09C",
            "FabricDataConnectionLibrary": "\uF09D",
            "FabricDocLibrary": "\uF09E",
            "FabricFormLibrary": "\uF09F",
            "FabricFormLibraryMirrored": "\uF0A0",
            "FabricReportLibrary": "\uF0A1",
            "FabricReportLibraryMirrored": "\uF0A2",
            "FabricPublicFolder": "\uF0A3",
            "FabricFolderSearch": "\uF0A4",
            "FabricMovetoFolder": "\uF0A5",
            "FabricUnsyncFolder": "\uF0A6",
            "FabricSyncFolder": "\uF0A7",
            "FabricOpenFolderHorizontal": "\uF0A8",
            "FabricFolder": "\uF0A9",
            "FabricFolderFill": "\uF0AA",
            "FabricNewFolder": "\uF0AB",
            "FabricPictureLibrary": "\uF0AC",
            "PhotoVideoMedia": "\uF0B1",
            "AddFavorite": "\uF0C8"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $e82d45683d4120a3$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-9"',
            src: "url('".concat(baseUrl, "fabric-icons-9-c6162b42.woff') format('woff')")
        },
        icons: {
            "AddFavoriteFill": "\uF0C9",
            "BufferTimeBefore": "\uF0CF",
            "BufferTimeAfter": "\uF0D0",
            "BufferTimeBoth": "\uF0D1",
            "PublishContent": "\uF0D4",
            "ClipboardList": "\uF0E3",
            "ClipboardListMirrored": "\uF0E4",
            "CannedChat": "\uF0F2",
            "SkypeForBusinessLogo": "\uF0FC",
            "TabCenter": "\uF100",
            "PageCheckedin": "\uF104",
            "PageList": "\uF106",
            "ReadOutLoud": "\uF112",
            "CaretBottomLeftSolid8": "\uF121",
            "CaretBottomRightSolid8": "\uF122",
            "FolderHorizontal": "\uF12B",
            "MicrosoftStaffhubLogo": "\uF130",
            "GiftboxOpen": "\uF133",
            "StatusCircleOuter": "\uF136",
            "StatusCircleInner": "\uF137",
            "StatusCircleRing": "\uF138",
            "StatusTriangleOuter": "\uF139",
            "StatusTriangleInner": "\uF13A",
            "StatusTriangleExclamation": "\uF13B",
            "StatusCircleExclamation": "\uF13C",
            "StatusCircleErrorX": "\uF13D",
            "StatusCircleInfo": "\uF13F",
            "StatusCircleBlock": "\uF140",
            "StatusCircleBlock2": "\uF141",
            "StatusCircleQuestionMark": "\uF142",
            "StatusCircleSync": "\uF143",
            "Toll": "\uF160",
            "ExploreContentSingle": "\uF164",
            "CollapseContent": "\uF165",
            "CollapseContentSingle": "\uF166",
            "InfoSolid": "\uF167",
            "GroupList": "\uF168",
            "ProgressRingDots": "\uF16A",
            "CaloriesAdd": "\uF172",
            "BranchFork": "\uF173",
            "MuteChat": "\uF17A",
            "AddHome": "\uF17B",
            "AddWork": "\uF17C",
            "MobileReport": "\uF18A",
            "ScaleVolume": "\uF18C",
            "HardDriveGroup": "\uF18F",
            "FastMode": "\uF19A",
            "ToggleLeft": "\uF19E",
            "ToggleRight": "\uF19F",
            "TriangleShape": "\uF1A7",
            "RectangleShape": "\uF1A9",
            "CubeShape": "\uF1AA",
            "Trophy2": "\uF1AE",
            "BucketColor": "\uF1B6",
            "BucketColorFill": "\uF1B7",
            "Taskboard": "\uF1C2",
            "SingleColumn": "\uF1D3",
            "DoubleColumn": "\uF1D4",
            "TripleColumn": "\uF1D5",
            "ColumnLeftTwoThirds": "\uF1D6",
            "ColumnRightTwoThirds": "\uF1D7",
            "AccessLogoFill": "\uF1DB",
            "AnalyticsLogo": "\uF1DE",
            "AnalyticsQuery": "\uF1DF",
            "NewAnalyticsQuery": "\uF1E0",
            "AnalyticsReport": "\uF1E1",
            "WordLogo": "\uF1E3",
            "WordLogoFill": "\uF1E4",
            "ExcelLogo": "\uF1E5",
            "ExcelLogoFill": "\uF1E6",
            "OneNoteLogo": "\uF1E7",
            "OneNoteLogoFill": "\uF1E8",
            "OutlookLogo": "\uF1E9",
            "OutlookLogoFill": "\uF1EA",
            "PowerPointLogo": "\uF1EB",
            "PowerPointLogoFill": "\uF1EC",
            "PublisherLogo": "\uF1ED",
            "PublisherLogoFill": "\uF1EE",
            "ScheduleEventAction": "\uF1EF",
            "FlameSolid": "\uF1F3",
            "ServerProcesses": "\uF1FE",
            "Server": "\uF201",
            "SaveAll": "\uF203",
            "LinkedInLogo": "\uF20A",
            "Decimals": "\uF218",
            "SidePanelMirrored": "\uF221",
            "ProtectRestrict": "\uF22A",
            "Blog": "\uF22B",
            "UnknownMirrored": "\uF22E",
            "PublicContactCardMirrored": "\uF230",
            "GridViewSmall": "\uF232",
            "GridViewMedium": "\uF233",
            "GridViewLarge": "\uF234",
            "Step": "\uF241",
            "StepInsert": "\uF242",
            "StepShared": "\uF243",
            "StepSharedAdd": "\uF244",
            "StepSharedInsert": "\uF245",
            "ViewDashboard": "\uF246",
            "ViewList": "\uF247"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $0b9f37c2041205c6$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-10"',
            src: "url('".concat(baseUrl, "fabric-icons-10-c4ded8e4.woff') format('woff')")
        },
        icons: {
            "ViewListGroup": "\uF248",
            "ViewListTree": "\uF249",
            "TriggerAuto": "\uF24A",
            "TriggerUser": "\uF24B",
            "PivotChart": "\uF24C",
            "StackedBarChart": "\uF24D",
            "StackedLineChart": "\uF24E",
            "BuildQueue": "\uF24F",
            "BuildQueueNew": "\uF250",
            "UserFollowed": "\uF25C",
            "ContactLink": "\uF25F",
            "Stack": "\uF26F",
            "Bullseye": "\uF272",
            "VennDiagram": "\uF273",
            "FiveTileGrid": "\uF274",
            "FocalPoint": "\uF277",
            "Insert": "\uF278",
            "RingerRemove": "\uF279",
            "TeamsLogoInverse": "\uF27A",
            "TeamsLogo": "\uF27B",
            "TeamsLogoFill": "\uF27C",
            "SkypeForBusinessLogoFill": "\uF27D",
            "SharepointLogo": "\uF27E",
            "SharepointLogoFill": "\uF27F",
            "DelveLogo": "\uF280",
            "DelveLogoFill": "\uF281",
            "OfficeVideoLogo": "\uF282",
            "OfficeVideoLogoFill": "\uF283",
            "ExchangeLogo": "\uF284",
            "ExchangeLogoFill": "\uF285",
            "Signin": "\uF286",
            "DocumentApproval": "\uF28B",
            "CloneToDesktop": "\uF28C",
            "InstallToDrive": "\uF28D",
            "Blur": "\uF28E",
            "Build": "\uF28F",
            "ProcessMetaTask": "\uF290",
            "BranchFork2": "\uF291",
            "BranchLocked": "\uF292",
            "BranchCommit": "\uF293",
            "BranchCompare": "\uF294",
            "BranchMerge": "\uF295",
            "BranchPullRequest": "\uF296",
            "BranchSearch": "\uF297",
            "BranchShelveset": "\uF298",
            "RawSource": "\uF299",
            "MergeDuplicate": "\uF29A",
            "RowsGroup": "\uF29B",
            "RowsChild": "\uF29C",
            "Deploy": "\uF29D",
            "Redeploy": "\uF29E",
            "ServerEnviroment": "\uF29F",
            "VisioDiagram": "\uF2A0",
            "HighlightMappedShapes": "\uF2A1",
            "TextCallout": "\uF2A2",
            "IconSetsFlag": "\uF2A4",
            "VisioLogo": "\uF2A7",
            "VisioLogoFill": "\uF2A8",
            "VisioDocument": "\uF2A9",
            "TimelineProgress": "\uF2AA",
            "TimelineDelivery": "\uF2AB",
            "Backlog": "\uF2AC",
            "TeamFavorite": "\uF2AD",
            "TaskGroup": "\uF2AE",
            "TaskGroupMirrored": "\uF2AF",
            "ScopeTemplate": "\uF2B0",
            "AssessmentGroupTemplate": "\uF2B1",
            "NewTeamProject": "\uF2B2",
            "CommentAdd": "\uF2B3",
            "CommentNext": "\uF2B4",
            "CommentPrevious": "\uF2B5",
            "ShopServer": "\uF2B6",
            "LocaleLanguage": "\uF2B7",
            "QueryList": "\uF2B8",
            "UserSync": "\uF2B9",
            "UserPause": "\uF2BA",
            "StreamingOff": "\uF2BB",
            "ArrowTallUpLeft": "\uF2BD",
            "ArrowTallUpRight": "\uF2BE",
            "ArrowTallDownLeft": "\uF2BF",
            "ArrowTallDownRight": "\uF2C0",
            "FieldEmpty": "\uF2C1",
            "FieldFilled": "\uF2C2",
            "FieldChanged": "\uF2C3",
            "FieldNotChanged": "\uF2C4",
            "RingerOff": "\uF2C5",
            "PlayResume": "\uF2C6",
            "BulletedList2": "\uF2C7",
            "BulletedList2Mirrored": "\uF2C8",
            "ImageCrosshair": "\uF2C9",
            "GitGraph": "\uF2CA",
            "Repo": "\uF2CB",
            "RepoSolid": "\uF2CC",
            "FolderQuery": "\uF2CD",
            "FolderList": "\uF2CE",
            "FolderListMirrored": "\uF2CF",
            "LocationOutline": "\uF2D0",
            "POISolid": "\uF2D1",
            "CalculatorNotEqualTo": "\uF2D2",
            "BoxSubtractSolid": "\uF2D3"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $0ebba41b9f0ec804$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-11"',
            src: "url('".concat(baseUrl, "fabric-icons-11-2a8393d6.woff') format('woff')")
        },
        icons: {
            "BoxAdditionSolid": "\uF2D4",
            "BoxMultiplySolid": "\uF2D5",
            "BoxPlaySolid": "\uF2D6",
            "BoxCheckmarkSolid": "\uF2D7",
            "CirclePauseSolid": "\uF2D8",
            "CirclePause": "\uF2D9",
            "MSNVideosSolid": "\uF2DA",
            "CircleStopSolid": "\uF2DB",
            "CircleStop": "\uF2DC",
            "NavigateBack": "\uF2DD",
            "NavigateBackMirrored": "\uF2DE",
            "NavigateForward": "\uF2DF",
            "NavigateForwardMirrored": "\uF2E0",
            "UnknownSolid": "\uF2E1",
            "UnknownMirroredSolid": "\uF2E2",
            "CircleAddition": "\uF2E3",
            "CircleAdditionSolid": "\uF2E4",
            "FilePDB": "\uF2E5",
            "FileTemplate": "\uF2E6",
            "FileSQL": "\uF2E7",
            "FileJAVA": "\uF2E8",
            "FileASPX": "\uF2E9",
            "FileCSS": "\uF2EA",
            "FileSass": "\uF2EB",
            "FileLess": "\uF2EC",
            "FileHTML": "\uF2ED",
            "JavaScriptLanguage": "\uF2EE",
            "CSharpLanguage": "\uF2EF",
            "CSharp": "\uF2F0",
            "VisualBasicLanguage": "\uF2F1",
            "VB": "\uF2F2",
            "CPlusPlusLanguage": "\uF2F3",
            "CPlusPlus": "\uF2F4",
            "FSharpLanguage": "\uF2F5",
            "FSharp": "\uF2F6",
            "TypeScriptLanguage": "\uF2F7",
            "PythonLanguage": "\uF2F8",
            "PY": "\uF2F9",
            "CoffeeScript": "\uF2FA",
            "MarkDownLanguage": "\uF2FB",
            "FullWidth": "\uF2FE",
            "FullWidthEdit": "\uF2FF",
            "Plug": "\uF300",
            "PlugSolid": "\uF301",
            "PlugConnected": "\uF302",
            "PlugDisconnected": "\uF303",
            "UnlockSolid": "\uF304",
            "Variable": "\uF305",
            "Parameter": "\uF306",
            "CommentUrgent": "\uF307",
            "Storyboard": "\uF308",
            "DiffInline": "\uF309",
            "DiffSideBySide": "\uF30A",
            "ImageDiff": "\uF30B",
            "ImagePixel": "\uF30C",
            "FileBug": "\uF30D",
            "FileCode": "\uF30E",
            "FileComment": "\uF30F",
            "BusinessHoursSign": "\uF310",
            "FileImage": "\uF311",
            "FileSymlink": "\uF312",
            "AutoFillTemplate": "\uF313",
            "WorkItem": "\uF314",
            "WorkItemBug": "\uF315",
            "LogRemove": "\uF316",
            "ColumnOptions": "\uF317",
            "Packages": "\uF318",
            "BuildIssue": "\uF319",
            "AssessmentGroup": "\uF31A",
            "VariableGroup": "\uF31B",
            "FullHistory": "\uF31C",
            "Wheelchair": "\uF31F",
            "SingleColumnEdit": "\uF321",
            "DoubleColumnEdit": "\uF322",
            "TripleColumnEdit": "\uF323",
            "ColumnLeftTwoThirdsEdit": "\uF324",
            "ColumnRightTwoThirdsEdit": "\uF325",
            "StreamLogo": "\uF329",
            "PassiveAuthentication": "\uF32A",
            "AlertSolid": "\uF331",
            "MegaphoneSolid": "\uF332",
            "TaskSolid": "\uF333",
            "ConfigurationSolid": "\uF334",
            "BugSolid": "\uF335",
            "CrownSolid": "\uF336",
            "Trophy2Solid": "\uF337",
            "QuickNoteSolid": "\uF338",
            "ConstructionConeSolid": "\uF339",
            "PageListSolid": "\uF33A",
            "PageListMirroredSolid": "\uF33B",
            "StarburstSolid": "\uF33C",
            "ReadingModeSolid": "\uF33D",
            "SadSolid": "\uF33E",
            "HealthSolid": "\uF33F",
            "ShieldSolid": "\uF340",
            "GiftBoxSolid": "\uF341",
            "ShoppingCartSolid": "\uF342",
            "MailSolid": "\uF343",
            "ChatSolid": "\uF344",
            "RibbonSolid": "\uF345"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $39a78d3ffa43c0b2$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-12"',
            src: "url('".concat(baseUrl, "fabric-icons-12-7e945a1e.woff') format('woff')")
        },
        icons: {
            "FinancialSolid": "\uF346",
            "FinancialMirroredSolid": "\uF347",
            "HeadsetSolid": "\uF348",
            "PermissionsSolid": "\uF349",
            "ParkingSolid": "\uF34A",
            "ParkingMirroredSolid": "\uF34B",
            "DiamondSolid": "\uF34C",
            "AsteriskSolid": "\uF34D",
            "OfflineStorageSolid": "\uF34E",
            "BankSolid": "\uF34F",
            "DecisionSolid": "\uF350",
            "Parachute": "\uF351",
            "ParachuteSolid": "\uF352",
            "FiltersSolid": "\uF353",
            "ColorSolid": "\uF354",
            "ReviewSolid": "\uF355",
            "ReviewRequestSolid": "\uF356",
            "ReviewRequestMirroredSolid": "\uF357",
            "ReviewResponseSolid": "\uF358",
            "FeedbackRequestSolid": "\uF359",
            "FeedbackRequestMirroredSolid": "\uF35A",
            "FeedbackResponseSolid": "\uF35B",
            "WorkItemBar": "\uF35C",
            "WorkItemBarSolid": "\uF35D",
            "Separator": "\uF35E",
            "NavigateExternalInline": "\uF35F",
            "PlanView": "\uF360",
            "TimelineMatrixView": "\uF361",
            "EngineeringGroup": "\uF362",
            "ProjectCollection": "\uF363",
            "CaretBottomRightCenter8": "\uF364",
            "CaretBottomLeftCenter8": "\uF365",
            "CaretTopRightCenter8": "\uF366",
            "CaretTopLeftCenter8": "\uF367",
            "DonutChart": "\uF368",
            "ChevronUnfold10": "\uF369",
            "ChevronFold10": "\uF36A",
            "DoubleChevronDown8": "\uF36B",
            "DoubleChevronUp8": "\uF36C",
            "DoubleChevronLeft8": "\uF36D",
            "DoubleChevronRight8": "\uF36E",
            "ChevronDownEnd6": "\uF36F",
            "ChevronUpEnd6": "\uF370",
            "ChevronLeftEnd6": "\uF371",
            "ChevronRightEnd6": "\uF372",
            "ContextMenu": "\uF37C",
            "AzureAPIManagement": "\uF37F",
            "AzureServiceEndpoint": "\uF380",
            "VSTSLogo": "\uF381",
            "VSTSAltLogo1": "\uF382",
            "VSTSAltLogo2": "\uF383",
            "FileTypeSolution": "\uF387",
            "WordLogoInverse16": "\uF390",
            "WordLogo16": "\uF391",
            "WordLogoFill16": "\uF392",
            "PowerPointLogoInverse16": "\uF393",
            "PowerPointLogo16": "\uF394",
            "PowerPointLogoFill16": "\uF395",
            "ExcelLogoInverse16": "\uF396",
            "ExcelLogo16": "\uF397",
            "ExcelLogoFill16": "\uF398",
            "OneNoteLogoInverse16": "\uF399",
            "OneNoteLogo16": "\uF39A",
            "OneNoteLogoFill16": "\uF39B",
            "OutlookLogoInverse16": "\uF39C",
            "OutlookLogo16": "\uF39D",
            "OutlookLogoFill16": "\uF39E",
            "PublisherLogoInverse16": "\uF39F",
            "PublisherLogo16": "\uF3A0",
            "PublisherLogoFill16": "\uF3A1",
            "VisioLogoInverse16": "\uF3A2",
            "VisioLogo16": "\uF3A3",
            "VisioLogoFill16": "\uF3A4",
            "TestBeaker": "\uF3A5",
            "TestBeakerSolid": "\uF3A6",
            "TestExploreSolid": "\uF3A7",
            "TestAutoSolid": "\uF3A8",
            "TestUserSolid": "\uF3A9",
            "TestImpactSolid": "\uF3AA",
            "TestPlan": "\uF3AB",
            "TestStep": "\uF3AC",
            "TestParameter": "\uF3AD",
            "TestSuite": "\uF3AE",
            "TestCase": "\uF3AF",
            "Sprint": "\uF3B0",
            "SignOut": "\uF3B1",
            "TriggerApproval": "\uF3B2",
            "Rocket": "\uF3B3",
            "AzureKeyVault": "\uF3B4",
            "Onboarding": "\uF3BA",
            "Transition": "\uF3BC",
            "LikeSolid": "\uF3BF",
            "DislikeSolid": "\uF3C0",
            "CRMCustomerInsightsApp": "\uF3C8",
            "EditCreate": "\uF3C9",
            "PlayReverseResume": "\uF3E4",
            "PlayReverse": "\uF3E5",
            "SearchData": "\uF3F1",
            "UnSetColor": "\uF3F9",
            "DeclineCall": "\uF405"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $7952eb22b4e7a28e$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-13"',
            src: "url('".concat(baseUrl, "fabric-icons-13-c3989a02.woff') format('woff')")
        },
        icons: {
            "RectangularClipping": "\uF407",
            "TeamsLogo16": "\uF40A",
            "TeamsLogoFill16": "\uF40B",
            "Spacer": "\uF40D",
            "SkypeLogo16": "\uF40E",
            "SkypeForBusinessLogo16": "\uF40F",
            "SkypeForBusinessLogoFill16": "\uF410",
            "FilterSolid": "\uF412",
            "MailUndelivered": "\uF415",
            "MailTentative": "\uF416",
            "MailTentativeMirrored": "\uF417",
            "MailReminder": "\uF418",
            "ReceiptUndelivered": "\uF419",
            "ReceiptTentative": "\uF41A",
            "ReceiptTentativeMirrored": "\uF41B",
            "Inbox": "\uF41C",
            "IRMReply": "\uF41D",
            "IRMReplyMirrored": "\uF41E",
            "IRMForward": "\uF41F",
            "IRMForwardMirrored": "\uF420",
            "VoicemailIRM": "\uF421",
            "EventAccepted": "\uF422",
            "EventTentative": "\uF423",
            "EventTentativeMirrored": "\uF424",
            "EventDeclined": "\uF425",
            "IDBadge": "\uF427",
            "BackgroundColor": "\uF42B",
            "OfficeFormsLogoInverse16": "\uF433",
            "OfficeFormsLogo": "\uF434",
            "OfficeFormsLogoFill": "\uF435",
            "OfficeFormsLogo16": "\uF436",
            "OfficeFormsLogoFill16": "\uF437",
            "OfficeFormsLogoInverse24": "\uF43A",
            "OfficeFormsLogo24": "\uF43B",
            "OfficeFormsLogoFill24": "\uF43C",
            "PageLock": "\uF43F",
            "NotExecuted": "\uF440",
            "NotImpactedSolid": "\uF441",
            "FieldReadOnly": "\uF442",
            "FieldRequired": "\uF443",
            "BacklogBoard": "\uF444",
            "ExternalBuild": "\uF445",
            "ExternalTFVC": "\uF446",
            "ExternalXAML": "\uF447",
            "IssueSolid": "\uF448",
            "DefectSolid": "\uF449",
            "LadybugSolid": "\uF44A",
            "NugetLogo": "\uF44C",
            "TFVCLogo": "\uF44D",
            "ProjectLogo32": "\uF47E",
            "ProjectLogoFill32": "\uF47F",
            "ProjectLogo16": "\uF480",
            "ProjectLogoFill16": "\uF481",
            "SwayLogo32": "\uF482",
            "SwayLogoFill32": "\uF483",
            "SwayLogo16": "\uF484",
            "SwayLogoFill16": "\uF485",
            "ClassNotebookLogo32": "\uF486",
            "ClassNotebookLogoFill32": "\uF487",
            "ClassNotebookLogo16": "\uF488",
            "ClassNotebookLogoFill16": "\uF489",
            "ClassNotebookLogoInverse32": "\uF48A",
            "ClassNotebookLogoInverse16": "\uF48B",
            "StaffNotebookLogo32": "\uF48C",
            "StaffNotebookLogoFill32": "\uF48D",
            "StaffNotebookLogo16": "\uF48E",
            "StaffNotebookLogoFill16": "\uF48F",
            "StaffNotebookLogoInverted32": "\uF490",
            "StaffNotebookLogoInverted16": "\uF491",
            "KaizalaLogo": "\uF492",
            "TaskLogo": "\uF493",
            "ProtectionCenterLogo32": "\uF494",
            "GallatinLogo": "\uF496",
            "Globe2": "\uF49A",
            "Guitar": "\uF49B",
            "Breakfast": "\uF49C",
            "Brunch": "\uF49D",
            "BeerMug": "\uF49E",
            "Vacation": "\uF49F",
            "Teeth": "\uF4A0",
            "Taxi": "\uF4A1",
            "Chopsticks": "\uF4A2",
            "SyncOccurence": "\uF4A3",
            "UnsyncOccurence": "\uF4A4",
            "GIF": "\uF4A9",
            "PrimaryCalendar": "\uF4AE",
            "SearchCalendar": "\uF4AF",
            "VideoOff": "\uF4B0",
            "MicrosoftFlowLogo": "\uF4B1",
            "BusinessCenterLogo": "\uF4B2",
            "ToDoLogoBottom": "\uF4B3",
            "ToDoLogoTop": "\uF4B4",
            "EditSolid12": "\uF4B5",
            "EditSolidMirrored12": "\uF4B6",
            "UneditableSolid12": "\uF4B7",
            "UneditableSolidMirrored12": "\uF4B8",
            "UneditableMirrored": "\uF4B9",
            "AdminALogo32": "\uF4BA",
            "AdminALogoFill32": "\uF4BB",
            "ToDoLogoInverse": "\uF4BC"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $cb20b05fc5ea420d$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-14"',
            src: "url('".concat(baseUrl, "fabric-icons-14-5cf58db8.woff') format('woff')")
        },
        icons: {
            "Snooze": "\uF4BD",
            "WaffleOffice365": "\uF4E0",
            "ImageSearch": "\uF4E8",
            "NewsSearch": "\uF4E9",
            "VideoSearch": "\uF4EA",
            "R": "\uF4EB",
            "FontColorA": "\uF4EC",
            "FontColorSwatch": "\uF4ED",
            "LightWeight": "\uF4EE",
            "NormalWeight": "\uF4EF",
            "SemiboldWeight": "\uF4F0",
            "GroupObject": "\uF4F1",
            "UngroupObject": "\uF4F2",
            "AlignHorizontalLeft": "\uF4F3",
            "AlignHorizontalCenter": "\uF4F4",
            "AlignHorizontalRight": "\uF4F5",
            "AlignVerticalTop": "\uF4F6",
            "AlignVerticalCenter": "\uF4F7",
            "AlignVerticalBottom": "\uF4F8",
            "HorizontalDistributeCenter": "\uF4F9",
            "VerticalDistributeCenter": "\uF4FA",
            "Ellipse": "\uF4FB",
            "Line": "\uF4FC",
            "Octagon": "\uF4FD",
            "Hexagon": "\uF4FE",
            "Pentagon": "\uF4FF",
            "RightTriangle": "\uF500",
            "HalfCircle": "\uF501",
            "QuarterCircle": "\uF502",
            "ThreeQuarterCircle": "\uF503",
            "6PointStar": "\uF504",
            "12PointStar": "\uF505",
            "ArrangeBringToFront": "\uF506",
            "ArrangeSendToBack": "\uF507",
            "ArrangeSendBackward": "\uF508",
            "ArrangeBringForward": "\uF509",
            "BorderDash": "\uF50A",
            "BorderDot": "\uF50B",
            "LineStyle": "\uF50C",
            "LineThickness": "\uF50D",
            "WindowEdit": "\uF50E",
            "HintText": "\uF50F",
            "MediaAdd": "\uF510",
            "AnchorLock": "\uF511",
            "AutoHeight": "\uF512",
            "ChartSeries": "\uF513",
            "ChartXAngle": "\uF514",
            "ChartYAngle": "\uF515",
            "Combobox": "\uF516",
            "LineSpacing": "\uF517",
            "Padding": "\uF518",
            "PaddingTop": "\uF519",
            "PaddingBottom": "\uF51A",
            "PaddingLeft": "\uF51B",
            "PaddingRight": "\uF51C",
            "NavigationFlipper": "\uF51D",
            "AlignJustify": "\uF51E",
            "TextOverflow": "\uF51F",
            "VisualsFolder": "\uF520",
            "VisualsStore": "\uF521",
            "PictureCenter": "\uF522",
            "PictureFill": "\uF523",
            "PicturePosition": "\uF524",
            "PictureStretch": "\uF525",
            "PictureTile": "\uF526",
            "Slider": "\uF527",
            "SliderHandleSize": "\uF528",
            "DefaultRatio": "\uF529",
            "NumberSequence": "\uF52A",
            "GUID": "\uF52B",
            "ReportAdd": "\uF52C",
            "DashboardAdd": "\uF52D",
            "MapPinSolid": "\uF52E",
            "WebPublish": "\uF52F",
            "PieSingleSolid": "\uF530",
            "BlockedSolid": "\uF531",
            "DrillDown": "\uF532",
            "DrillDownSolid": "\uF533",
            "DrillExpand": "\uF534",
            "DrillShow": "\uF535",
            "SpecialEvent": "\uF536",
            "OneDriveFolder16": "\uF53B",
            "FunctionalManagerDashboard": "\uF542",
            "BIDashboard": "\uF543",
            "CodeEdit": "\uF544",
            "RenewalCurrent": "\uF545",
            "RenewalFuture": "\uF546",
            "SplitObject": "\uF547",
            "BulkUpload": "\uF548",
            "DownloadDocument": "\uF549",
            "GreetingCard": "\uF54B",
            "Flower": "\uF54E",
            "WaitlistConfirm": "\uF550",
            "WaitlistConfirmMirrored": "\uF551",
            "LaptopSecure": "\uF552",
            "DragObject": "\uF553",
            "EntryView": "\uF554",
            "EntryDecline": "\uF555",
            "ContactCardSettings": "\uF556",
            "ContactCardSettingsMirrored": "\uF557"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $e9adfc30ff59b162$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-15"',
            src: "url('".concat(baseUrl, "fabric-icons-15-3807251b.woff') format('woff')")
        },
        icons: {
            "CalendarSettings": "\uF558",
            "CalendarSettingsMirrored": "\uF559",
            "HardDriveLock": "\uF55A",
            "HardDriveUnlock": "\uF55B",
            "AccountManagement": "\uF55C",
            "ReportWarning": "\uF569",
            "TransitionPop": "\uF5B2",
            "TransitionPush": "\uF5B3",
            "TransitionEffect": "\uF5B4",
            "LookupEntities": "\uF5B5",
            "ExploreData": "\uF5B6",
            "AddBookmark": "\uF5B7",
            "SearchBookmark": "\uF5B8",
            "DrillThrough": "\uF5B9",
            "MasterDatabase": "\uF5BA",
            "CertifiedDatabase": "\uF5BB",
            "MaximumValue": "\uF5BC",
            "MinimumValue": "\uF5BD",
            "VisualStudioIDELogo32": "\uF5D0",
            "PasteAsText": "\uF5D5",
            "PasteAsCode": "\uF5D6",
            "BrowserTab": "\uF5D7",
            "BrowserTabScreenshot": "\uF5D8",
            "DesktopScreenshot": "\uF5D9",
            "FileYML": "\uF5DA",
            "ClipboardSolid": "\uF5DC",
            "FabricUserFolder": "\uF5E5",
            "FabricNetworkFolder": "\uF5E6",
            "BullseyeTarget": "\uF5F0",
            "AnalyticsView": "\uF5F1",
            "Video360Generic": "\uF609",
            "Untag": "\uF60B",
            "Leave": "\uF627",
            "Trending12": "\uF62D",
            "Blocked12": "\uF62E",
            "Warning12": "\uF62F",
            "CheckedOutByOther12": "\uF630",
            "CheckedOutByYou12": "\uF631",
            "CircleShapeSolid": "\uF63C",
            "SquareShapeSolid": "\uF63D",
            "TriangleShapeSolid": "\uF63E",
            "DropShapeSolid": "\uF63F",
            "RectangleShapeSolid": "\uF640",
            "ZoomToFit": "\uF649",
            "InsertColumnsLeft": "\uF64A",
            "InsertColumnsRight": "\uF64B",
            "InsertRowsAbove": "\uF64C",
            "InsertRowsBelow": "\uF64D",
            "DeleteColumns": "\uF64E",
            "DeleteRows": "\uF64F",
            "DeleteRowsMirrored": "\uF650",
            "DeleteTable": "\uF651",
            "AccountBrowser": "\uF652",
            "VersionControlPush": "\uF664",
            "StackedColumnChart2": "\uF666",
            "TripleColumnWide": "\uF66E",
            "QuadColumn": "\uF66F",
            "WhiteBoardApp16": "\uF673",
            "WhiteBoardApp32": "\uF674",
            "PinnedSolid": "\uF676",
            "InsertSignatureLine": "\uF677",
            "ArrangeByFrom": "\uF678",
            "Phishing": "\uF679",
            "CreateMailRule": "\uF67A",
            "PublishCourse": "\uF699",
            "DictionaryRemove": "\uF69A",
            "UserRemove": "\uF69B",
            "UserEvent": "\uF69C",
            "Encryption": "\uF69D",
            "PasswordField": "\uF6AA",
            "OpenInNewTab": "\uF6AB",
            "Hide3": "\uF6AC",
            "VerifiedBrandSolid": "\uF6AD",
            "MarkAsProtected": "\uF6AE",
            "AuthenticatorApp": "\uF6B1",
            "WebTemplate": "\uF6B2",
            "DefenderTVM": "\uF6B3",
            "MedalSolid": "\uF6B9",
            "D365TalentLearn": "\uF6BB",
            "D365TalentInsight": "\uF6BC",
            "D365TalentHRCore": "\uF6BD",
            "BacklogList": "\uF6BF",
            "ButtonControl": "\uF6C0",
            "TableGroup": "\uF6D9",
            "MountainClimbing": "\uF6DB",
            "TagUnknown": "\uF6DF",
            "TagUnknownMirror": "\uF6E0",
            "TagUnknown12": "\uF6E1",
            "TagUnknown12Mirror": "\uF6E2",
            "Link12": "\uF6E3",
            "Presentation": "\uF6E4",
            "Presentation12": "\uF6E5",
            "Lock12": "\uF6E6",
            "BuildDefinition": "\uF6E9",
            "ReleaseDefinition": "\uF6EA",
            "SaveTemplate": "\uF6EC",
            "UserGauge": "\uF6ED",
            "BlockedSiteSolid12": "\uF70A",
            "TagSolid": "\uF70E",
            "OfficeChat": "\uF70F"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $4600826ca61dbba5$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-16"',
            src: "url('".concat(baseUrl, "fabric-icons-16-9cf93f3b.woff') format('woff')")
        },
        icons: {
            "OfficeChatSolid": "\uF710",
            "MailSchedule": "\uF72E",
            "WarningSolid": "\uF736",
            "Blocked2Solid": "\uF737",
            "SkypeCircleArrow": "\uF747",
            "SkypeArrow": "\uF748",
            "SyncStatus": "\uF751",
            "SyncStatusSolid": "\uF752",
            "ProjectDocument": "\uF759",
            "ToDoLogoOutline": "\uF75B",
            "VisioOnlineLogoFill32": "\uF75F",
            "VisioOnlineLogo32": "\uF760",
            "VisioOnlineLogoCloud32": "\uF761",
            "VisioDiagramSync": "\uF762",
            "Event12": "\uF763",
            "EventDateMissed12": "\uF764",
            "UserOptional": "\uF767",
            "ResponsesMenu": "\uF768",
            "DoubleDownArrow": "\uF769",
            "DistributeDown": "\uF76A",
            "BookmarkReport": "\uF76B",
            "FilterSettings": "\uF76C",
            "GripperDotsVertical": "\uF772",
            "MailAttached": "\uF774",
            "AddIn": "\uF775",
            "LinkedDatabase": "\uF779",
            "TableLink": "\uF77A",
            "PromotedDatabase": "\uF77D",
            "BarChartVerticalFilter": "\uF77E",
            "BarChartVerticalFilterSolid": "\uF77F",
            "MicOff2": "\uF781",
            "MicrosoftTranslatorLogo": "\uF782",
            "ShowTimeAs": "\uF787",
            "FileRequest": "\uF789",
            "WorkItemAlert": "\uF78F",
            "PowerBILogo16": "\uF790",
            "PowerBILogoBackplate16": "\uF791",
            "BulletedListText": "\uF792",
            "BulletedListBullet": "\uF793",
            "BulletedListTextMirrored": "\uF794",
            "BulletedListBulletMirrored": "\uF795",
            "NumberedListText": "\uF796",
            "NumberedListNumber": "\uF797",
            "NumberedListTextMirrored": "\uF798",
            "NumberedListNumberMirrored": "\uF799",
            "RemoveLinkChain": "\uF79A",
            "RemoveLinkX": "\uF79B",
            "FabricTextHighlight": "\uF79C",
            "ClearFormattingA": "\uF79D",
            "ClearFormattingEraser": "\uF79E",
            "Photo2Fill": "\uF79F",
            "IncreaseIndentText": "\uF7A0",
            "IncreaseIndentArrow": "\uF7A1",
            "DecreaseIndentText": "\uF7A2",
            "DecreaseIndentArrow": "\uF7A3",
            "IncreaseIndentTextMirrored": "\uF7A4",
            "IncreaseIndentArrowMirrored": "\uF7A5",
            "DecreaseIndentTextMirrored": "\uF7A6",
            "DecreaseIndentArrowMirrored": "\uF7A7",
            "CheckListText": "\uF7A8",
            "CheckListCheck": "\uF7A9",
            "CheckListTextMirrored": "\uF7AA",
            "CheckListCheckMirrored": "\uF7AB",
            "NumberSymbol": "\uF7AC",
            "Coupon": "\uF7BC",
            "VerifiedBrand": "\uF7BD",
            "ReleaseGate": "\uF7BE",
            "ReleaseGateCheck": "\uF7BF",
            "ReleaseGateError": "\uF7C0",
            "M365InvoicingLogo": "\uF7C1",
            "RemoveFromShoppingList": "\uF7D5",
            "ShieldAlert": "\uF7D7",
            "FabricTextHighlightComposite": "\uF7DA",
            "Dataflows": "\uF7DD",
            "GenericScanFilled": "\uF7DE",
            "DiagnosticDataBarTooltip": "\uF7DF",
            "SaveToMobile": "\uF7E0",
            "Orientation2": "\uF7E1",
            "ScreenCast": "\uF7E2",
            "ShowGrid": "\uF7E3",
            "SnapToGrid": "\uF7E4",
            "ContactList": "\uF7E5",
            "NewMail": "\uF7EA",
            "EyeShadow": "\uF7EB",
            "FabricFolderConfirm": "\uF7FF",
            "InformationBarriers": "\uF803",
            "CommentActive": "\uF804",
            "ColumnVerticalSectionEdit": "\uF806",
            "WavingHand": "\uF807",
            "ShakeDevice": "\uF80A",
            "SmartGlassRemote": "\uF80B",
            "Rotate90Clockwise": "\uF80D",
            "Rotate90CounterClockwise": "\uF80E",
            "CampaignTemplate": "\uF811",
            "ChartTemplate": "\uF812",
            "PageListFilter": "\uF813",
            "SecondaryNav": "\uF814",
            "ColumnVerticalSection": "\uF81E",
            "SkypeCircleSlash": "\uF825",
            "SkypeSlash": "\uF826"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}


// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

function $af5090ce21ebc7fe$export$daed2daeba655e15(baseUrl, options) {
    if (baseUrl === void 0) baseUrl = "";
    var subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none"
        },
        fontFace: {
            fontFamily: '"FabricMDL2Icons-17"',
            src: "url('".concat(baseUrl, "fabric-icons-17-0c4ed701.woff') format('woff')")
        },
        icons: {
            "CustomizeToolbar": "\uF828",
            "DuplicateRow": "\uF82A",
            "RemoveFromTrash": "\uF82B",
            "MailOptions": "\uF82C",
            "Childof": "\uF82D",
            "Footer": "\uF82E",
            "Header": "\uF82F",
            "BarChartVerticalFill": "\uF830",
            "StackedColumnChart2Fill": "\uF831",
            "PlainText": "\uF834",
            "AccessibiltyChecker": "\uF835",
            "DatabaseSync": "\uF842",
            "ReservationOrders": "\uF845",
            "TabOneColumn": "\uF849",
            "TabTwoColumn": "\uF84A",
            "TabThreeColumn": "\uF84B",
            "BulletedTreeList": "\uF84C",
            "MicrosoftTranslatorLogoGreen": "\uF852",
            "MicrosoftTranslatorLogoBlue": "\uF853",
            "InternalInvestigation": "\uF854",
            "AddReaction": "\uF85D",
            "ContactHeart": "\uF862",
            "VisuallyImpaired": "\uF866",
            "EventToDoLogo": "\uF869",
            "Variable2": "\uF86D",
            "ModelingView": "\uF871",
            "DisconnectVirtualMachine": "\uF873",
            "ReportLock": "\uF875",
            "Uneditable2": "\uF876",
            "Uneditable2Mirrored": "\uF877",
            "BarChartVerticalEdit": "\uF89D",
            "GlobalNavButtonActive": "\uF89F",
            "PollResults": "\uF8A0",
            "Rerun": "\uF8A1",
            "QandA": "\uF8A2",
            "QandAMirror": "\uF8A3",
            "BookAnswers": "\uF8A4",
            "AlertSettings": "\uF8B6",
            "TrimStart": "\uF8BB",
            "TrimEnd": "\uF8BC",
            "TableComputed": "\uF8F5",
            "DecreaseIndentLegacy": "\uE290",
            "IncreaseIndentLegacy": "\uE291",
            "SizeLegacy": "\uE2B2"
        }
    };
    (0, $a5216fef1aadcd25$export$99b432e1290ef823)(subset, options);
}




var $2380105df9c790d6$export$9836c3198c99edae = function() {
    (0, $a5216fef1aadcd25$export$4fad376c7613260)("trash", "delete");
    (0, $a5216fef1aadcd25$export$4fad376c7613260)("onedrive", "onedrivelogo");
    (0, $a5216fef1aadcd25$export$4fad376c7613260)("alertsolid12", "eventdatemissed12");
    (0, $a5216fef1aadcd25$export$4fad376c7613260)("sixpointstar", "6pointstar");
    (0, $a5216fef1aadcd25$export$4fad376c7613260)("twelvepointstar", "12pointstar");
    (0, $a5216fef1aadcd25$export$4fad376c7613260)("toggleon", "toggleleft");
    (0, $a5216fef1aadcd25$export$4fad376c7613260)("toggleoff", "toggleright");
};
var $2380105df9c790d6$export$2e2bcd8739ae039 = $2380105df9c790d6$export$9836c3198c99edae;



// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.

(0, $6a1ca41917aa4f58$export$f99c3c9c04cda7ae)("@fluentui/font-icons-mdl2", "8.5.32");


var $e25ab669c29b5f8e$var$DEFAULT_BASE_URL = "".concat((0, $a0b99536f83d2b4d$export$61818e3b2f7b5d12), "/assets/icons/");
var $e25ab669c29b5f8e$var$win = (0, $f70a84ea62eace59$export$38b2d434cce3ea22)();
function $e25ab669c29b5f8e$export$daed2daeba655e15(baseUrl, options) {
    var _a, _b;
    if (baseUrl === void 0) baseUrl = ((_a = $e25ab669c29b5f8e$var$win === null || $e25ab669c29b5f8e$var$win === void 0 ? void 0 : $e25ab669c29b5f8e$var$win.FabricConfig) === null || _a === void 0 ? void 0 : _a.iconBaseUrl) || ((_b = $e25ab669c29b5f8e$var$win === null || $e25ab669c29b5f8e$var$win === void 0 ? void 0 : $e25ab669c29b5f8e$var$win.FabricConfig) === null || _b === void 0 ? void 0 : _b.fontBaseUrl) || $e25ab669c29b5f8e$var$DEFAULT_BASE_URL;
    [
        (0, $024ef69aaa10db95$export$daed2daeba655e15),
        (0, $76cf319aa4e8f11b$export$daed2daeba655e15),
        (0, $8c43ddeb2add31c4$export$daed2daeba655e15),
        (0, $ae63f8c56964b417$export$daed2daeba655e15),
        (0, $6806cb685a31e098$export$daed2daeba655e15),
        (0, $c1db7c9ea0f3c642$export$daed2daeba655e15),
        (0, $19fb2c54b1fb3907$export$daed2daeba655e15),
        (0, $bdc9ff86e1052fcc$export$daed2daeba655e15),
        (0, $2047f6280f675905$export$daed2daeba655e15),
        (0, $06910dea4eaec01e$export$daed2daeba655e15),
        (0, $e82d45683d4120a3$export$daed2daeba655e15),
        (0, $0b9f37c2041205c6$export$daed2daeba655e15),
        (0, $0ebba41b9f0ec804$export$daed2daeba655e15),
        (0, $39a78d3ffa43c0b2$export$daed2daeba655e15),
        (0, $7952eb22b4e7a28e$export$daed2daeba655e15),
        (0, $cb20b05fc5ea420d$export$daed2daeba655e15),
        (0, $e9adfc30ff59b162$export$daed2daeba655e15),
        (0, $4600826ca61dbba5$export$daed2daeba655e15),
        (0, $af5090ce21ebc7fe$export$daed2daeba655e15)
    ].forEach(function(initialize) {
        return initialize(baseUrl, options);
    });
    (0, $2380105df9c790d6$export$9836c3198c99edae)();
}



parcelRequire("lT7pJ");

const $92c6b20da1bd4695$export$f23ef6cb462a47f7 = (element)=>{
    const div = document.createElement("div");
    div.style.width = "100%";
    const root = (0, $8bc84ab6fef2cb4e$export$882461b6382ed46c)(div);
    root.render(element);
    return div;
};



var $iBTKZ = parcelRequire("iBTKZ");




var $lT7pJ = parcelRequire("lT7pJ");

const $64c22f9c91f2c118$var$md = new (0, $c1dfe7a9dc4f2ee7$export$2e2bcd8739ae039)({
    breaks: true,
    html: true,
    xhtmlOut: true,
    linkify: false,
    typographer: true,
    quotes: `""''`
});
const $64c22f9c91f2c118$var$getSizeFromEnum = (size)=>{
    switch(size){
        case (0, $d97a7c55f35040d9$exports.TextSize).Small:
            return "rf-small-size-auto";
        case (0, $d97a7c55f35040d9$exports.TextSize).Medium:
            return "rf-text-medium-size-auto";
        case (0, $d97a7c55f35040d9$exports.TextSize).Large:
            return "rf-text-large-size-auto";
        case (0, $d97a7c55f35040d9$exports.TextSize).ExtraLarge:
            return "rf-text-extralarge-size-auto";
        case (0, $d97a7c55f35040d9$exports.TextSize).Default:
        default:
            return "rf-text-size-auto";
    }
};
const $64c22f9c91f2c118$var$TextBlock = ({ text: text, isTitle: isTitle, isSubtitle: isSubtitle, size: size, horizontalAlignment: horizontalAlignment, wrap: wrap, maxLines: maxLines })=>{
    const [style, setStyle] = (0, $lT7pJ.useState)("");
    (0, $lT7pJ.useEffect)(()=>{
        if (text) {
            // Text size
            let styleToApply = isTitle ? "rf-title-size-auto" : isSubtitle ? "rf-subtitle-size-auto" : size ? $64c22f9c91f2c118$var$getSizeFromEnum(size) : "rf-text-size-auto";
            // Text horizontal alignment
            if (horizontalAlignment) switch(horizontalAlignment){
                case 1:
                    styleToApply += " rf-text-center";
                    break;
                case 2:
                    styleToApply += " rf-text-right";
                    break;
                case 0:
                default:
                    styleToApply += " rf-text-left";
                    break;
            }
            else styleToApply += " rf-text-left";
            // Wrap ?
            wrap ? (isTitle || isSubtitle) && (styleToApply += " rf-line-clamp-2") : styleToApply += " rf-truncate";
            // Max lines ? If this is a title it has already been set to 2 lines if wrap is not false
            !isTitle && maxLines && maxLines > 0 && maxLines <= 10 && (styleToApply += ` rf-line-clamp-${maxLines}`);
            setStyle(styleToApply);
        }
    }, []);
    return text ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-w-full rf-text-cardFrameText ${style}`,
        dangerouslySetInnerHTML: {
            __html: (0, $0fdc9a557a65290b$export$d07f57595c356899)($64c22f9c91f2c118$var$md.render(text))
        }
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $64c22f9c91f2c118$export$2e2bcd8739ae039 = $64c22f9c91f2c118$var$TextBlock;



class $e53abcc697d38737$export$92739f4310a31a0d extends (0, $iBTKZ.TextBlock) {
    internalRender() {
        const element = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        let isTitle = false;
        let isSubtitle = false;
        if (this.size && this.size === (0, $d97a7c55f35040d9$exports.TextSize).Large) isTitle = true;
        else if (this.size && this.size === (0, $d97a7c55f35040d9$exports.TextSize).Medium) isSubtitle = true;
        const props = {
            text: this.text,
            isTitle: isTitle,
            isSubtitle: isSubtitle,
            size: this.size,
            horizontalAlignment: this.horizontalAlignment,
            wrap: this.wrap,
            maxLines: this.maxLines
        };
        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $64c22f9c91f2c118$export$2e2bcd8739ae039), {
            ...props
        });
    };
}


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");


var $iBTKZ = parcelRequire("iBTKZ");


var $lT7pJ = parcelRequire("lT7pJ");




const $4716d59f6cf5fd06$var$InputToggle = ({ id: id, title: title, valueOn: valueOn, defaultValue: defaultValue })=>{
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [on, setOn] = (0, $lT7pJ.useState)(values.get(id) || defaultValue === valueOn);
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$ff456dc518e4aa26)(id, defaultValue === valueOn);
    }, []);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call parent's handleChange method
   *  - set on state to its opposite
   */ const handleToggle = ()=>{
        console.log("Toggle Change : ", id);
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            (0, $649c384b79ea2395$export$7fc8a028c7b38ace)(id, !on);
            setOn(!on);
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-text-size-auto rf-text-white",
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("label", {
            className: "rf-flex rf-flex-row rf-items-start",
            children: [
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                    type: "checkbox",
                    onChange: handleToggle,
                    className: "rf-toggle-custom",
                    checked: on
                }),
                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-input-label",
                    children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(title || id)
                })
            ]
        })
    });
};
var $4716d59f6cf5fd06$export$2e2bcd8739ae039 = $4716d59f6cf5fd06$var$InputToggle;


class $673e3f1cfe302e01$export$c99bfd6b0ed44fbd extends (0, $iBTKZ.ToggleInput) {
    _value = this.defaultValue || this.valueOff;
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    internalRender() {
        const element = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4716d59f6cf5fd06$export$2e2bcd8739ae039), {
            id: this.id,
            title: this.title,
            valueOn: this.valueOn,
            defaultValue: this.defaultValue || this.valueOff
        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $49f51cfbe488d9fc$var$extendStatics = function(d, b) {
    $49f51cfbe488d9fc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $49f51cfbe488d9fc$var$extendStatics(d, b);
};
function $49f51cfbe488d9fc$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $49f51cfbe488d9fc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $49f51cfbe488d9fc$export$18ce0697a983be9b = function() {
    $49f51cfbe488d9fc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $49f51cfbe488d9fc$export$18ce0697a983be9b.apply(this, arguments);
};
function $49f51cfbe488d9fc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $49f51cfbe488d9fc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $49f51cfbe488d9fc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $49f51cfbe488d9fc$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $49f51cfbe488d9fc$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $49f51cfbe488d9fc$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $49f51cfbe488d9fc$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $49f51cfbe488d9fc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $49f51cfbe488d9fc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $49f51cfbe488d9fc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $49f51cfbe488d9fc$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $49f51cfbe488d9fc$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $49f51cfbe488d9fc$export$45d3717a4c69092e(o, m, p);
}
function $49f51cfbe488d9fc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $49f51cfbe488d9fc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $49f51cfbe488d9fc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($49f51cfbe488d9fc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $49f51cfbe488d9fc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $49f51cfbe488d9fc$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $49f51cfbe488d9fc$export$10c90e4f7922046c(v) {
    return this instanceof $49f51cfbe488d9fc$export$10c90e4f7922046c ? (this.v = v, this) : new $49f51cfbe488d9fc$export$10c90e4f7922046c(v);
}
function $49f51cfbe488d9fc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $49f51cfbe488d9fc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $49f51cfbe488d9fc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $49f51cfbe488d9fc$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $49f51cfbe488d9fc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $49f51cfbe488d9fc$export$19a8beecd37a4c45 === "function" ? $49f51cfbe488d9fc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $49f51cfbe488d9fc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $49f51cfbe488d9fc$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $49f51cfbe488d9fc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $49f51cfbe488d9fc$export$45d3717a4c69092e(result, mod, k);
    }
    $49f51cfbe488d9fc$var$__setModuleDefault(result, mod);
    return result;
}
function $49f51cfbe488d9fc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $49f51cfbe488d9fc$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $49f51cfbe488d9fc$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $49f51cfbe488d9fc$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $49f51cfbe488d9fc$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $49f51cfbe488d9fc$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $49f51cfbe488d9fc$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $49f51cfbe488d9fc$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $49f51cfbe488d9fc$export$2e2bcd8739ae039 = {
    __extends: $49f51cfbe488d9fc$export$a8ba968b8961cb8a,
    __assign: $49f51cfbe488d9fc$export$18ce0697a983be9b,
    __rest: $49f51cfbe488d9fc$export$3c9a16f847548506,
    __decorate: $49f51cfbe488d9fc$export$29e00dfd3077644b,
    __param: $49f51cfbe488d9fc$export$d5ad3fd78186038f,
    __metadata: $49f51cfbe488d9fc$export$f1db080c865becb9,
    __awaiter: $49f51cfbe488d9fc$export$1050f835b63b671e,
    __generator: $49f51cfbe488d9fc$export$67ebef60e6f28a6,
    __createBinding: $49f51cfbe488d9fc$export$45d3717a4c69092e,
    __exportStar: $49f51cfbe488d9fc$export$f33643c0debef087,
    __values: $49f51cfbe488d9fc$export$19a8beecd37a4c45,
    __read: $49f51cfbe488d9fc$export$8d051b38c9118094,
    __spread: $49f51cfbe488d9fc$export$afc72e2116322959,
    __spreadArrays: $49f51cfbe488d9fc$export$6388937ca91ccae8,
    __spreadArray: $49f51cfbe488d9fc$export$1216008129fb82ed,
    __await: $49f51cfbe488d9fc$export$10c90e4f7922046c,
    __asyncGenerator: $49f51cfbe488d9fc$export$e427f37a30a4de9b,
    __asyncDelegator: $49f51cfbe488d9fc$export$bbd80228419bb833,
    __asyncValues: $49f51cfbe488d9fc$export$e3b29a3d6162315f,
    __makeTemplateObject: $49f51cfbe488d9fc$export$4fb47efe1390b86f,
    __importStar: $49f51cfbe488d9fc$export$c21735bcef00d192,
    __importDefault: $49f51cfbe488d9fc$export$da59b14a69baef04,
    __classPrivateFieldGet: $49f51cfbe488d9fc$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $49f51cfbe488d9fc$export$d40a35129aaff81f,
    __classPrivateFieldIn: $49f51cfbe488d9fc$export$81fdc39f203e4e04,
    __addDisposableResource: $49f51cfbe488d9fc$export$88ac25d8e944e405,
    __disposeResources: $49f51cfbe488d9fc$export$8f076105dc360e92
};




var $lT7pJ = parcelRequire("lT7pJ");


var $iBTKZ = parcelRequire("iBTKZ");


var $lT7pJ = parcelRequire("lT7pJ");







/**
 * Oddmonths used to calculate the max amount of days in a month
 */ const $8e966be598f24c5a$var$oddMonths = [
    4,
    6,
    9,
    11
];
const $8e966be598f24c5a$var$InputDate = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue })=>{
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [year, setYear] = (0, $lT7pJ.useState)(new Date().getFullYear());
    const [month, setMonth] = (0, $lT7pJ.useState)(new Date().getMonth() + 1);
    const [day, setDay] = (0, $lT7pJ.useState)(new Date().getDate());
    const [maxYear, setMaxYear] = (0, $lT7pJ.useState)(0);
    const [minYear, setMinYear] = (0, $lT7pJ.useState)(100000);
    const [maxMonth, setMaxMonth] = (0, $lT7pJ.useState)(12);
    const [minMonth, setMinMonth] = (0, $lT7pJ.useState)(1);
    const [maxDay, setMaxDay] = (0, $lT7pJ.useState)(31);
    const [minDay, setMinDay] = (0, $lT7pJ.useState)(1);
    const [maxValueAsDate, setMaxValueAsDate] = (0, $lT7pJ.useState)(undefined);
    const [minValueAsDate, setMinValueAsDate] = (0, $lT7pJ.useState)(undefined);
    const [updatingDate, setUpdatingDate] = (0, $lT7pJ.useState)(false);
    const [dayWheel, setDayWheel] = (0, $lT7pJ.useState)(0);
    const [monthWheel, setMonthWheel] = (0, $lT7pJ.useState)(0);
    const [yearWheel, setYearWheel] = (0, $lT7pJ.useState)(0);
    const days = (0, $lT7pJ.useMemo)(()=>{
        if (month && year) {
            // If we check the february month, either 28 or 29 days depending on the year
            if (month === 2) return year % 4 === 0 ? 29 : 28;
            // 30 days for oddMonths, 31 otherwise
            return $8e966be598f24c5a$var$oddMonths.includes(month) ? 30 : 31;
        }
        return undefined;
    }, [
        month,
        year
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On days state change :
   *  - set day state if current day is higher than days
   */ (0, $lT7pJ.useEffect)(()=>{
        day && days && day > days && setDay(days);
    }, [
        days
    ]);
    /**
   * On component mount :
   *  - set day / month / year from localStorage value if there is one, current Date otherwise
   *  - set max values from props or current Date + 150 years otherwise
   */ (0, $lT7pJ.useEffect)(()=>{
        const dateAsArray = (0, $6b02161c48723176$export$ffedad9fbd47bff0)(values.get(id) || defaultValue);
        setYear(dateAsArray[0]);
        setMonth(dateAsArray[1]);
        setDay(dateAsArray[2]);
        // Set min and max years
        const now = new Date();
        if (maxValue) {
            const maxAsDate = new Date(maxValue);
            setMaxValueAsDate(maxAsDate);
            setMaxYear(maxAsDate.getFullYear());
            setMaxMonth(maxAsDate.getMonth() + 1);
            setMaxDay(maxAsDate.getDate());
        } else setMaxYear(now.getFullYear() + 150);
        if (minValue) {
            const minAsDate = new Date(minValue);
            setMinValueAsDate(minAsDate);
            setMinYear(minAsDate.getFullYear());
            setMinMonth(minAsDate.getMonth() + 1);
            setMinDay(minAsDate.getDate());
        } else setMinYear(now.getFullYear() - 150);
    }, []);
    /**
   * On day / month / year state change :
   *  - check if a day / month / year change is needed to keep the date a proper one
   *  - for example on february, there are either 28 or 29 days depending on the year
   *  - set the value in localStorage
   *  - if an update is needed, set the updatingDate state to true to prevent concurrent modification, update, and set updatingdate back to false to release lock
   */ (0, $lT7pJ.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        if (!updatingDate && day && month && year) {
            let updating = false;
            let dateAsString = `${year}-${month}-${day}`;
            const date = new Date(dateAsString);
            if (minValue && minValueAsDate && date < minValueAsDate) {
                dateAsString = minValue;
                updating = true;
            } else if (maxValue && maxValueAsDate && date > maxValueAsDate) {
                dateAsString = maxValue;
                updating = true;
            }
            // Save date
            (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, dateAsString);
            // Update states if necessary
            if (updating) {
                setUpdatingDate(true);
                const dateAsArray = dateAsString.split("-");
                setYear(parseInt(dateAsArray[0]));
                setMonth(parseInt(dateAsArray[1]));
                setDay(parseInt(dateAsArray[2]));
                setUpdatingDate(false);
            }
        }
    }, [
        day,
        month,
        year
    ]);
    /**
   * On dayWheel change, if dayWheel !== 0 :
   *  - try to update the day state
   *  - reset dayWheel state to 0
   */ (0, $lT7pJ.useEffect)(()=>{
        if (dayWheel !== 0 && day && days) {
            if (dayWheel > 0) day + 1 > days ? setDay(1) : setDay((day)=>day + 1);
            else day - 1 > 0 ? setDay((day)=>day - 1) : setDay(days);
            // Reset dayWheel
            setDayWheel(0);
        }
    }, [
        dayWheel
    ]);
    /**
   * On monthWheel change, if monthWheel !== 0 :
   *  - try to update the month state
   *  - reset monthWheel state to 0
   */ (0, $lT7pJ.useEffect)(()=>{
        if (monthWheel !== 0 && month) {
            if (monthWheel > 0) month + 1 > 12 ? setMonth(1) : setMonth((month)=>month + 1);
            else month - 1 > 0 ? setMonth((month)=>month - 1) : setMonth(12);
            // Reset monthWheel
            setMonthWheel(0);
        }
    }, [
        monthWheel
    ]);
    /**
   * On yearWheel change, if yearWheel !== 0 :
   *  - try to update the year state
   *  - reset yearWheel state to 0
   */ (0, $lT7pJ.useEffect)(()=>{
        if (yearWheel !== 0 && year && minYear && maxYear) {
            if (yearWheel > 0) year !== maxYear && setYear((year)=>year + 1);
            else year !== minYear && setYear((year)=>year - 1);
            // Reset yearWheel
            setYearWheel(0);
        }
    }, [
        yearWheel
    ]);
    /**
   * On wheel event on day / month / year part :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - call wheel state depending on the type, that will trigger the related day / month / year state update if possible
   * @param delta : number
   * @param type : string
   */ const handleWheel = (delta, type)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) switch(type){
            case "day":
                setDayWheel(delta);
                break;
            case "month":
                setMonthWheel(delta);
                break;
            case "year":
                setYearWheel(delta);
                break;
            default:
                break;
        }
    };
    /**
   * On click on a day / month / year :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - set chosen day / month / year if it is within the accepted bounds
   * @param value : number
   * @param type : string
   */ const handleClick = (value, type)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) switch(type){
            case "day":
                day && setDay(value);
                break;
            case "month":
                month && value !== -1 && setMonth(value);
                break;
            case "year":
                year && value !== -1 && setYear(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg rf-subtitle-size-auto rf-text-formInputRadioCheckboxUncheckedBackground rf-unselectable",
        style: {
            background: "linear-gradient(rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0.5) 34%, black 34%, black 65%, rgb(0, 0, 0, 0.5) 65%, rgb(0, 0, 0, 0.5) 100%)"
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                type: "date",
                className: "rf-hidden"
            }),
            year && month && day && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $3e5faa3ecd7b3792$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "day",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear && month === minMonth && day === minDay ? -1 : day === 1 ? days || 1 : day - 1, "day"),
                                children: year === minYear && month === minMonth && day === minDay ? "\u2800" : day === 1 ? `${days}` : `${day - 1}`
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: day
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear && month === maxMonth && day === maxDay ? -1 : day === days ? 1 : day + 1, "day"),
                                children: year === maxYear && month === maxMonth && day === maxDay ? "\u2800" : day === days ? "1" : `${day + 1}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $3e5faa3ecd7b3792$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "month",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear && month === minMonth ? -1 : month === 1 ? 12 : month - 1, "month"),
                                children: year === minYear && month === minMonth ? "\u2800" : month === 1 ? `${(0, $0fdc9a557a65290b$export$d07f57595c356899)((0, $6b02161c48723176$export$9e9b71dbaf488f87)(12, locale))}` : `${(0, $0fdc9a557a65290b$export$d07f57595c356899)((0, $6b02161c48723176$export$9e9b71dbaf488f87)(month - 1, locale))}`
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: `${(0, $0fdc9a557a65290b$export$d07f57595c356899)((0, $6b02161c48723176$export$9e9b71dbaf488f87)(month, locale))}`
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear && month === maxMonth ? -1 : month === 12 ? 1 : month + 1, "month"),
                                children: year === maxYear && month === maxMonth ? "\u2800" : month === 12 ? `${(0, $0fdc9a557a65290b$export$d07f57595c356899)((0, $6b02161c48723176$export$9e9b71dbaf488f87)(1, locale))}` : `${(0, $0fdc9a557a65290b$export$d07f57595c356899)((0, $6b02161c48723176$export$9e9b71dbaf488f87)(month + 1, locale))}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $3e5faa3ecd7b3792$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-px-4 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "year",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === minYear ? -1 : year - 1, "year"),
                                children: year === minYear ? "\u2800" : year - 1
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: year
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(year === maxYear ? -1 : year + 1, "year"),
                                children: year === maxYear ? "\u2800" : year + 1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $8e966be598f24c5a$export$2e2bcd8739ae039 = $8e966be598f24c5a$var$InputDate;




class $dc96a8fcfbd484ff$export$a9633577dcb92569 extends (0, $iBTKZ.DateInput) {
    // Add custom property to schema
    static calendarProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "calendar", false);
    // Calendar property accessors
    get calendar() {
        return !!this.getValue($dc96a8fcfbd484ff$export$a9633577dcb92569.calendarProperty);
    }
    internalRender() {
        const element = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? this.calendar ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ab605451f28d48cc$export$2e2bcd8739ae039), {
            id: this.id,
            defaultValue: this.defaultValue,
            maxValue: this.max,
            minValue: this.min
        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $8e966be598f24c5a$export$2e2bcd8739ae039), {
            id: this.id,
            defaultValue: this.defaultValue,
            maxValue: this.max,
            minValue: this.min
        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($dc96a8fcfbd484ff$export$a9633577dcb92569.calendarProperty)
], $dc96a8fcfbd484ff$export$a9633577dcb92569.prototype, "calendar", null);




var $lT7pJ = parcelRequire("lT7pJ");


var $iBTKZ = parcelRequire("iBTKZ");


var $lT7pJ = parcelRequire("lT7pJ");




const $7ab6cdcbe7e432b6$var$InputTime = ({ id: id, defaultValue: defaultValue, maxValue: maxValue, minValue: minValue })=>{
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [hour, setHour] = (0, $lT7pJ.useState)(12);
    const [minute, setMinute] = (0, $lT7pJ.useState)(0);
    const [maxHour, setMaxHour] = (0, $lT7pJ.useState)(23);
    const [minHour, setMinHour] = (0, $lT7pJ.useState)(0);
    const [maxMinute, setMaxMinute] = (0, $lT7pJ.useState)(59);
    const [minMinute, setMinMinute] = (0, $lT7pJ.useState)(0);
    const [updatingTime, setUpdatingTime] = (0, $lT7pJ.useState)(false);
    const [hourWheel, setHourWheel] = (0, $lT7pJ.useState)(0);
    const [minuteWheel, setMinuteWheel] = (0, $lT7pJ.useState)(0);
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On component mount :
   *  - set hour / minute from localStorage value if there is one, or defaultValue, or 12:00 if no other data
   *  - set maxHour and maxMinute states if maxValue prop is set
   *  - set minHour and minMinute states if minValue prop is set
   */ (0, $lT7pJ.useEffect)(()=>{
        // Set hour and minute from localstorage or defaultvalue if one of those is set
        const timeFromLocalStorage = values.get(id) || defaultValue;
        const timeAsArray = timeFromLocalStorage ? timeFromLocalStorage.split(":") : [];
        if (timeAsArray.length === 2) {
            !isNaN(parseInt(timeAsArray[0])) && setHour(parseInt(timeAsArray[0]));
            !isNaN(parseInt(timeAsArray[1])) && setMinute(parseInt(timeAsArray[1]));
        }
        // Set min and max times
        if (maxValue) {
            const maxTimeAsArray = maxValue.split(":");
            setMaxHour(parseInt(maxTimeAsArray[0]));
            setMaxMinute(parseInt(maxTimeAsArray[1]));
        }
        if (minValue) {
            const minTimeAsArray = minValue.split(":");
            setMinHour(parseInt(minTimeAsArray[0]));
            setMinMinute(parseInt(minTimeAsArray[1]));
        }
    }, []);
    /**
   * On hour / minute state change :
   *  - check if a hour / minute change is needed to respect minValue or maxValue
   *  - set the value in localStorage
   *  - if an update is needed, set the updatingTime state to true to prevent concurrent modification, update, and set updatingTime back to false to release lock
   */ (0, $lT7pJ.useEffect)(()=>{
        // Check if we are in the bounds of minValue and maxValue if there are some
        if (!updatingTime && hour !== undefined && minute !== undefined) {
            let updating = false;
            // Deal with hours and minutes lower than 10 : add a '0' before to keep 2-characters length for each
            const tempHour = hour < 10 ? `0${hour}` : hour;
            const tempMinute = minute < 10 ? `0${minute}` : minute;
            let timeAsString = `${tempHour}:${tempMinute}`;
            // Check if the time is lower than the minimal value if given, or greater than the maximal one if given
            if (minValue && (hour < minHour || hour === minHour && minute < minMinute)) {
                timeAsString = minValue;
                updating = true;
            } else if (maxValue && (hour > maxHour || hour === maxHour && minute > maxMinute)) {
                timeAsString = maxValue;
                updating = true;
            }
            // Save time
            (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, timeAsString);
            // Update states if necessary
            if (updating) {
                setUpdatingTime(true);
                const timeAsArray = timeAsString.split(":");
                setHour(parseInt(timeAsArray[0]));
                setMinute(parseInt(timeAsArray[1]));
                setUpdatingTime(false);
            }
        }
    }, [
        hour,
        minute
    ]);
    /**
   * On hourWheel change, if hourWheel !== 0 :
   *  - try to update the hour state
   *  - reset hourWheel state to 0
   */ (0, $lT7pJ.useEffect)(()=>{
        if (hourWheel !== 0 && hour !== undefined) {
            if (hourWheel > 0) hour + 1 > 23 ? setHour(0) : setHour((hour)=>hour + 1);
            else hour - 1 < 0 ? setHour(23) : setHour((hour)=>hour - 1);
            // Reset dayWheel
            setHourWheel(0);
        }
    }, [
        hourWheel
    ]);
    /**
   * On minuteWheel change, if minuteWheel !== 0 :
   *  - try to update the minute state
   *  - reset minuteWheel state to 0
   */ (0, $lT7pJ.useEffect)(()=>{
        if (minuteWheel !== 0 && minute !== undefined) {
            if (minuteWheel > 0) minute + 1 > 59 ? setMinute(0) : setMinute((minute)=>minute + 1);
            else minute - 1 < 0 ? setMinute(59) : setMinute((minute)=>minute - 1);
            // Reset monthWheel
            setMinuteWheel(0);
        }
    }, [
        minuteWheel
    ]);
    /**
   * On wheel event on hour / minute part :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call wheel state depending on the type, that will trigger the related hour / minute state update if possible
   * @param delta : number
   * @param type : string
   */ const handleWheel = (delta, type)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) switch(type){
            case "hour":
                setHourWheel(delta);
                break;
            case "minute":
                setMinuteWheel(delta);
                break;
            default:
                break;
        }
    };
    /**
   * On click on a hour / minute :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - set chosen hour / minute if it is within the accepted bounds
   * @param value : number
   * @param type : string
   */ const handleClick = (value, type)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) switch(type){
            case "hour":
                hour !== undefined && value !== -1 && setHour(value);
                break;
            case "minute":
                minute !== undefined && value !== -1 && setMinute(value);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-py-2 rf-flex rf-flex-row rf-justify-center rf-items-center rf-rounded-lg rf-subtitle-size-auto rf-text-formInputRadioCheckboxUncheckedBackground rf-unselectable",
        style: {
            background: "linear-gradient(rgb(0, 0, 0, 0.5) 0%, rgb(0, 0, 0, 0.5) 34%, black 34%, black 65%, rgb(0, 0, 0, 0.5) 65%, rgb(0, 0, 0, 0.5) 100%)"
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                type: "time",
                className: "rf-hidden"
            }),
            hour !== undefined && minute !== undefined && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $3e5faa3ecd7b3792$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-pr-1 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "hour",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(minValue && hour === minHour ? -1 : hour === 0 ? 23 : hour - 1, "hour"),
                                children: minValue && hour === minHour ? "\u2800" : hour === 0 ? "23" : hour < 11 ? `0${hour - 1}` : hour - 1
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: hour < 10 ? `0${hour}` : hour
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(maxValue && hour === maxHour ? -1 : hour === 23 ? 0 : hour + 1, "hour"),
                                children: maxValue && hour === maxHour ? "\u2800" : hour === 23 ? "00" : hour < 9 ? `0${hour + 1}` : hour + 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-flex rf-flex-col rf-items-center rf-py-1",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                children: "\u2800"
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-text-primary",
                                children: ":"
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                children: "\u2800"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $3e5faa3ecd7b3792$export$2e2bcd8739ae039), {
                        className: "rf-flex rf-flex-col rf-items-center rf-pl-1 rf-py-1",
                        handleWheel: handleWheel,
                        paramInHandle: "minute",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(minValue && hour === minHour && minute === minMinute ? -1 : minute === 0 ? 59 : minute - 1, "minute"),
                                children: minValue && hour === minHour && minute === minMinute ? "\u2800" : minute === 0 ? "59" : minute < 11 ? `0${minute - 1}` : minute - 1
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 rf-text-primary",
                                children: minute < 10 ? `0${minute}` : minute
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                className: "rf-py-1 hover:rf-cursor-pointer",
                                onClick: ()=>handleClick(maxValue && hour === maxHour && minute === maxMinute ? -1 : minute === 59 ? 0 : minute + 1, "minute"),
                                children: maxValue && hour === maxHour && minute === maxMinute ? "\u2800" : minute < 9 ? `0${minute + 1}` : minute === 59 ? "00" : minute + 1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $7ab6cdcbe7e432b6$export$2e2bcd8739ae039 = $7ab6cdcbe7e432b6$var$InputTime;


class $a181a5e19ff36346$export$27dc9c3aadf0815c extends (0, $iBTKZ.TimeInput) {
    _value = this.defaultValue || undefined;
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    internalRender() {
        const element = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $7ab6cdcbe7e432b6$export$2e2bcd8739ae039), {
            id: this.id,
            defaultValue: this.defaultValue,
            maxValue: this.max,
            minValue: this.min
        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
    };
}


/* eslint-disable react/jsx-boolean-value */ 


var $lT7pJ = parcelRequire("lT7pJ");



var $lT7pJ = parcelRequire("lT7pJ");




const $b87c327c25e03088$var$Radio = ({ id: id, choices: choices, split: split })=>{
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [display, setDisplay] = (0, $lT7pJ.useState)([]);
    const [chosen, setChosen] = (0, $lT7pJ.useState)(values.get(id) || "");
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $lT7pJ.useEffect)(()=>{
        if (choices) {
            if (split) {
                const nbRows = Math.ceil(choices.length / 2);
                setDisplay([
                    choices.slice(0, nbRows),
                    choices.slice(nbRows)
                ]);
            } else setDisplay(choices);
        }
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            setChosen(value);
            (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, value);
        }
    };
    return display && display.length > 0 ? split ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-text-size-auto rf-text-white",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[0].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-radio-custom",
                                onChange: ()=>handleChange(choice.value)
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("label", {
                                htmlFor: `radio-${key}`,
                                className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                            })
                        ]
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[1].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-radio-custom",
                                onChange: ()=>handleChange(choice.value)
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("label", {
                                htmlFor: `radio-${key}`,
                                className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                            })
                        ]
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-flex rf-flex-row rf-items-start rf-mb-3",
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                        type: "radio",
                        value: choice.value,
                        checked: choice.value === chosen,
                        className: "rf-radio-custom",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("label", {
                        htmlFor: `radio-${key}`,
                        className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $b87c327c25e03088$export$2e2bcd8739ae039 = $b87c327c25e03088$var$Radio;




var $lT7pJ = parcelRequire("lT7pJ");




const $115df03768f92932$var$RadioAsButton = ({ id: id, choices: choices })=>{
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [display, setDisplay] = (0, $lT7pJ.useState)([]);
    const [chosen, setChosen] = (0, $lT7pJ.useState)(values.get(id) || "");
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $lT7pJ.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            setChosen(value);
            (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, value);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-flex-wrap rf-justify-center rf-items-center rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("label", {
                className: `rf-mx-2 rf-flex rf-justify-center rf-items-center rf-px-4 rf-py-2 large:rf-px-5 large:rf-py-3 rf-border rf-rounded-lg ${choice.value === chosen ? "rf-bg-formInputButtonBackgroundHover rf-text-formInputButtonTextHover rf-border-formInputButtonBorderHover" : "rf-bg-formInputButtonBackgroundDefault rf-text-formInputButtonTextDefault rf-border-formInputButtonBorderDefault"} rf-mb-4 hover:rf-cursor-pointer`,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                        type: "radio",
                        value: choice.value,
                        checked: choice.value === chosen,
                        className: "rf-input-hidden",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $115df03768f92932$export$2e2bcd8739ae039 = $115df03768f92932$var$RadioAsButton;




var $lT7pJ = parcelRequire("lT7pJ");






const $0432a30281a6e4ae$var$Checkbox = ({ id: id, choices: choices, split: split })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [display, setDisplay] = (0, $lT7pJ.useState)([]);
    const [chosen, setChosen] = (0, $lT7pJ.useState)(values.get(id) || []);
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $lT7pJ.useEffect)(()=>{
        if (choices) {
            if (split) {
                const nbRows = Math.ceil(choices.length / 2);
                setDisplay([
                    choices.slice(0, nbRows),
                    choices.slice(nbRows)
                ]);
            } else setDisplay(choices);
        }
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $lT7pJ.useEffect)(()=>{
        (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, chosen);
    }, [
        chosen
    ]);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleChangeCheckbox method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? split ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-text-size-auto rf-text-white",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-1/2 rf-pr-2 rf-flex rf-flex-col rf-items-start",
                children: display[0].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-relative rf-mb-3",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("label", {
                            className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                                    type: "checkbox",
                                    value: choice.value,
                                    checked: chosen.includes(choice.value),
                                    onChange: ()=>handleChange(choice.value),
                                    className: "rf-checkbox-custom"
                                }),
                                chosen.includes(choice.value) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e1e0df67609bc0b5$export$2e2bcd8739ae039), {
                                    className: "rf-absolute rf-left-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                                    color: themeColors.formInput.inputRadioCheckbox.checked.item
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                    className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                                    children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                                })
                            ]
                        })
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-1/2 rf-flex rf-flex-col rf-items-start",
                children: display[1].map((choice, key)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-relative rf-mb-3",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("label", {
                            className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                            children: [
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                                    type: "checkbox",
                                    value: choice.value,
                                    checked: chosen.includes(choice.value),
                                    onChange: ()=>handleChange(choice.value),
                                    className: "rf-checkbox-custom"
                                }),
                                chosen.includes(choice.value) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e1e0df67609bc0b5$export$2e2bcd8739ae039), {
                                    className: "rf-absolute rf-left-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                                    color: themeColors.formInput.inputRadioCheckbox.checked.item
                                }),
                                /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                    className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                                    children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                                })
                            ]
                        })
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-col rf-items-start rf-text-size-auto rf-text-white",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-relative rf-mb-3",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("label", {
                    className: "rf-w-full rf-flex rf-flex-row rf-items-start",
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                            type: "checkbox",
                            value: choice.value,
                            checked: chosen.includes(choice.value),
                            onChange: ()=>handleChange(choice.value),
                            className: "rf-checkbox-custom"
                        }),
                        chosen.includes(choice.value) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e1e0df67609bc0b5$export$2e2bcd8739ae039), {
                            className: "rf-absolute rf-left-1 rf-top-1 rf-h-4 rf-w-4 large:rf-h-5 large:rf-w-5 large-vertical:rf-h-6 large-vertical:rf-w-6 rf-transition-all",
                            color: themeColors.formInput.inputRadioCheckbox.checked.item
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                            className: "rf-input-label rf-mr-2 rf-max-w-[calc(100%-2rem)]",
                            children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                        })
                    ]
                })
            }, key);
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $0432a30281a6e4ae$export$2e2bcd8739ae039 = $0432a30281a6e4ae$var$Checkbox;




var $lT7pJ = parcelRequire("lT7pJ");




const $192f3018d83a7a41$var$CheckboxAsButton = ({ id: id, choices: choices })=>{
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [display, setDisplay] = (0, $lT7pJ.useState)([]);
    const [chosen, setChosen] = (0, $lT7pJ.useState)(values.get(id) || []);
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $lT7pJ.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $lT7pJ.useEffect)(()=>{
        (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, chosen);
    }, [
        chosen
    ]);
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleChangeCheckbox method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-w-full rf-mt-4 rf-flex rf-flex-row rf-flex-wrap rf-justify-center rf-items-center rf-text-size-auto",
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("label", {
                className: `rf-mx-2 rf-flex rf-justify-center rf-items-center rf-px-4 rf-py-2 large:rf-px-5 large:rf-py-3 rf-border rf-rounded-lg ${chosen.includes(choice.value) ? "rf-bg-formInputButtonBackgroundHover rf-text-formInputButtonTextHover rf-border-formInputButtonBorderHover" : "rf-bg-formInputButtonBackgroundDefault rf-text-formInputButtonTextDefault rf-border-formInputButtonBorderDefault"} rf-mb-4 hover:rf-cursor-pointer`,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                        type: "checkbox",
                        value: choice.value,
                        checked: chosen.includes(choice.value),
                        className: "rf-input-hidden",
                        onChange: ()=>handleChange(choice.value)
                    }),
                    (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $192f3018d83a7a41$export$2e2bcd8739ae039 = $192f3018d83a7a41$var$CheckboxAsButton;




var $lT7pJ = parcelRequire("lT7pJ");






const $48384ce893c2966d$var$Select = ({ id: id, choices: choices, placeholder: placeholder })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [display, setDisplay] = (0, $lT7pJ.useState)([]);
    const [open, setOpen] = (0, $lT7pJ.useState)(false);
    const [chosen, setChosen] = (0, $lT7pJ.useState)(values.get(id) || null);
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices prop change :
   *  - if choices is defined, fill display state with choices value
   */ (0, $lT7pJ.useEffect)(()=>{
        choices && setDisplay(choices);
    }, [
        choices
    ]);
    /**
   * On call :
   *  - set open state to its contrary
   */ const toggleOpen = ()=>{
        setOpen(!open);
    };
    /**
   * On call :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with choice value
   *  - call parent's handleSelect method
   *  - call toggleOpen method
   * @param choice : Choice
   */ const handleChange = (choice)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            setChosen(choice);
            (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, choice);
            toggleOpen();
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-mt-4 rf-text-size-auto rf-text-formInputTextDefault",
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                onClick: toggleOpen,
                className: `rf-w-full rf-flex rf-flex-row rf-justify-between rf-items-center rf-p-4 rf-border-2 rf-rounded ${open ? "rf-border-formInputRadioCheckboxCheckedBorder" : "rf-border-formInputRadioCheckboxUncheckedBorder"} rf-bg-formInputRadioCheckboxUncheckedBackground`,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-truncate",
                        children: chosen?.title || placeholder || translation.inputs.choose
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-h-2",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $491a12661fd84d1f$export$2e2bcd8739ae039), {
                            className: "rf-h-full"
                        })
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("ul", {
                className: "rf-mt-1 rf-max-h-48 rf-pl-0 rf-w-full rf-rounded rf-border-2 rf-border-formInputRadioCheckboxUncheckedBorder rf-bg-formInputRadioCheckboxUncheckedBackground rf-overflow-y-scroll rf-scrollbar-thin",
                style: {
                    listStyle: "none"
                },
                children: display.map((choice, key)=>{
                    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("li", {
                        onClick: ()=>handleChange(choice),
                        className: "rf-px-4 rf-py-2 hover:rf-text-formInputRadioCheckboxCheckedItem hover:rf-bg-formInputRadioCheckboxCheckedBackground",
                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                    }, key);
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $48384ce893c2966d$export$2e2bcd8739ae039 = $48384ce893c2966d$var$Select;



class $ea797332a95bee75$export$3d2f970ec3b98a50 extends $d97a7c55f35040d9$exports.ChoiceSetInput {
    static JsonTypeName = "ChoiceSetClass";
    getJsonTypeName() {
        return $ea797332a95bee75$export$3d2f970ec3b98a50.JsonTypeName;
    }
    // Add custom preperties to schema
    static splitProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "split", false);
    static displayAsButtonProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "asButtons", false);
    // Split property accessors
    get split() {
        return !!this.getValue($ea797332a95bee75$export$3d2f970ec3b98a50.splitProperty);
    }
    set split(value) {
        if (this.split !== value) {
            this.setValue($ea797332a95bee75$export$3d2f970ec3b98a50.splitProperty, value);
            this.updateLayout();
        }
    }
    // AsButtons property accessors
    get asButtons() {
        return !!this.getValue($ea797332a95bee75$export$3d2f970ec3b98a50.displayAsButtonProperty);
    }
    set asButtons(value) {
        if (this.asButtons !== value) {
            this.setValue($ea797332a95bee75$export$3d2f970ec3b98a50.displayAsButtonProperty, value);
            this.updateLayout();
        }
    }
    internalRender() {
        const element = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        // Return empty fragment if no id provided
        if (!this.id) return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
        // Check if we use checkboxes, radio buttons or select input
        let inputType = "select";
        if (this.asButtons) inputType = this.isMultiSelect ? "checkboxbuttons" : "radiobuttons";
        else if (!this.isCompact) inputType = this.isMultiSelect ? "checkbox" : "radio";
        switch(inputType){
            case "select":
                break;
            case "checkbox":
                return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $0432a30281a6e4ae$export$2e2bcd8739ae039), {
                    id: this.id,
                    choices: this.choices,
                    split: this.split
                });
            case "radio":
                return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $b87c327c25e03088$export$2e2bcd8739ae039), {
                    id: this.id,
                    choices: this.choices,
                    split: this.split
                });
            case "checkboxbuttons":
                return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $192f3018d83a7a41$export$2e2bcd8739ae039), {
                    id: this.id,
                    choices: this.choices
                });
            case "radiobuttons":
                return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $115df03768f92932$export$2e2bcd8739ae039), {
                    id: this.id,
                    choices: this.choices
                });
        }
        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $48384ce893c2966d$export$2e2bcd8739ae039), {
            id: this.id,
            choices: this.choices,
            placeholder: this.placeholder
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($ea797332a95bee75$export$3d2f970ec3b98a50.splitProperty)
], $ea797332a95bee75$export$3d2f970ec3b98a50.prototype, "split", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($ea797332a95bee75$export$3d2f970ec3b98a50.displayAsButtonProperty)
], $ea797332a95bee75$export$3d2f970ec3b98a50.prototype, "asButtons", null);





var $lT7pJ = parcelRequire("lT7pJ");



var $lT7pJ = parcelRequire("lT7pJ");




/**
 * Default data if not given in props :
 *  - defaultEmoji = default displayed object
 */ const $4d128ebf23115416$var$defaultEmoji = "\uD83D\uDFCA";
// emoji examples ['🟊', '♠', '✺', 'Ϙ', '◎', '₱', '😔', '😐', '😀']
const $4d128ebf23115416$var$Likert = ({ id: id, ratingMin: ratingMin, ratingMax: ratingMax, emojis: emojis, strokeColor: strokeColor })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [data, setData] = (0, $lT7pJ.useState)([]);
    const [rating, setRating] = (0, $lT7pJ.useState)(values.get(id) || ratingMin || 0);
    const [hover, setHover] = (0, $lT7pJ.useState)(0);
    const hoverColor = strokeColor || themeColors.formInput.likert.hover;
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On component mount :
   *  - create array of Dataset to be mapped for display
   *  - set stroke color if given in props
   */ (0, $lT7pJ.useEffect)(()=>{
        const min = ratingMin || 0;
        const range = min <= 0 ? Math.abs(min) + ratingMax + 1 : ratingMax;
        let dataArray = [];
        // If there are as many emojis as values, let's use them all
        if (emojis.length === range) for(let i = 0; i < range; i++)dataArray = [
            ...dataArray,
            {
                emoji: emojis[i],
                value: min + i
            }
        ];
        else for(let i = 0; i < range; i++)dataArray = [
            ...dataArray,
            {
                emoji: emojis[0] || $4d128ebf23115416$var$defaultEmoji,
                value: min + i
            }
        ];
        setData(dataArray);
    }, []);
    /**
   * On element click :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - call parent function from props with the value retrieved
   *  - set rating
   */ const handleClick = (value)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, value);
            setRating(value);
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: "rf-my-4 rf-flex rf-flex-row rf-flex-nowrap rf-justify-center rf-items-center rf-title-large-size-auto",
        children: data.map((tuple, index)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-px-1 rf-likert-custom",
                style: {
                    color: tuple.value <= (hover || rating) ? hoverColor : themeColors.formInput.likert.default
                },
                onClick: ()=>handleClick(tuple.value),
                onMouseEnter: ()=>setHover(tuple.value),
                onMouseLeave: ()=>setHover(rating),
                children: tuple.emoji
            }, index);
        })
    });
};
var $4d128ebf23115416$export$2e2bcd8739ae039 = $4d128ebf23115416$var$Likert;



class $7c63de084d26d3e3$export$527d02f4ea70b77 extends $d97a7c55f35040d9$exports.Input {
    _value = this.ratingMin;
    static JsonTypeName = "Retorik.Likert";
    getJsonTypeName() {
        return $7c63de084d26d3e3$export$527d02f4ea70b77.JsonTypeName;
    }
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    static ratingMinProperty = new $d97a7c55f35040d9$exports.NumProperty($d97a7c55f35040d9$exports.Versions.v1_0, "ratingMin", 1);
    static ratingMaxProperty = new $d97a7c55f35040d9$exports.NumProperty($d97a7c55f35040d9$exports.Versions.v1_0, "ratingMax", 5);
    static emojisProperty = new $d97a7c55f35040d9$exports.StringArrayProperty($d97a7c55f35040d9$exports.Versions.v1_0, "emojis", []);
    static strokeColorProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "strokeColor", true);
    // ratingMin property accessors
    get ratingMin() {
        return this.getValue($7c63de084d26d3e3$export$527d02f4ea70b77.ratingMinProperty) || "";
    }
    set ratingMin(val) {
        if (this.ratingMin !== val) this.setValue($7c63de084d26d3e3$export$527d02f4ea70b77.ratingMinProperty, val);
    }
    // ratingMax property accessors
    get ratingMax() {
        return this.getValue($7c63de084d26d3e3$export$527d02f4ea70b77.ratingMaxProperty) || "";
    }
    set ratingMax(val) {
        if (this.ratingMax !== val) this.setValue($7c63de084d26d3e3$export$527d02f4ea70b77.ratingMaxProperty, val);
    }
    // emojis property accessors
    get emojis() {
        return this.getValue($7c63de084d26d3e3$export$527d02f4ea70b77.emojisProperty) || "";
    }
    set emojis(val) {
        if (this.emojis !== val) this.setValue($7c63de084d26d3e3$export$527d02f4ea70b77.emojisProperty, val);
    }
    // strokeColor property accessors
    get strokeColor() {
        return this.getValue($7c63de084d26d3e3$export$527d02f4ea70b77.strokeColorProperty) || "";
    }
    set strokeColor(val) {
        if (this.strokeColor !== val) this.setValue($7c63de084d26d3e3$export$527d02f4ea70b77.strokeColorProperty, val);
    }
    internalRender() {
        const element = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4d128ebf23115416$export$2e2bcd8739ae039), {
            id: this.id,
            ratingMin: this.ratingMin,
            ratingMax: this.ratingMax,
            emojis: this.emojis,
            strokeColor: this.strokeColor
        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($7c63de084d26d3e3$export$527d02f4ea70b77.ratingMinProperty)
], $7c63de084d26d3e3$export$527d02f4ea70b77.prototype, "ratingMin", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($7c63de084d26d3e3$export$527d02f4ea70b77.ratingMaxProperty)
], $7c63de084d26d3e3$export$527d02f4ea70b77.prototype, "ratingMax", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($7c63de084d26d3e3$export$527d02f4ea70b77.emojisProperty)
], $7c63de084d26d3e3$export$527d02f4ea70b77.prototype, "emojis", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($7c63de084d26d3e3$export$527d02f4ea70b77.strokeColorProperty)
], $7c63de084d26d3e3$export$527d02f4ea70b77.prototype, "strokeColor", null);


/* eslint-disable react/jsx-boolean-value */ 


var $lT7pJ = parcelRequire("lT7pJ");


/* eslint-disable react/jsx-boolean-value */ 

class $a1b1d5c04da4498f$export$fce58f7f7dbd3025 extends $d97a7c55f35040d9$exports.SerializableObject {
    static JsonTypeName = "ChoiceWithUrl";
    getJsonTypeName() {
        return $a1b1d5c04da4498f$export$fce58f7f7dbd3025.JsonTypeName;
    }
    getSchemaKey() {
        return $a1b1d5c04da4498f$export$fce58f7f7dbd3025.JsonTypeName;
    }
    static titleProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "title", true);
    static valueProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "value", true);
    // Add url property to schema
    static urlProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "url", true);
    get title() {
        return this.getValue($a1b1d5c04da4498f$export$fce58f7f7dbd3025.titleProperty) || "";
    }
    set title(val) {
        if (this.title !== val) this.setValue($a1b1d5c04da4498f$export$fce58f7f7dbd3025.titleProperty, val);
    }
    get value() {
        return this.getValue($a1b1d5c04da4498f$export$fce58f7f7dbd3025.valueProperty) || "";
    }
    set value(val) {
        if (this.value !== val) this.setValue($a1b1d5c04da4498f$export$fce58f7f7dbd3025.valueProperty, val);
    }
    get url() {
        return this.getValue($a1b1d5c04da4498f$export$fce58f7f7dbd3025.urlProperty) || "";
    }
    set url(val) {
        if (this.url !== val) this.setValue($a1b1d5c04da4498f$export$fce58f7f7dbd3025.urlProperty, val);
    }
    constructor(title, value, url){
        super();
        this.title = title || "";
        this.value = value || "";
        this.url = url || "";
    }
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($a1b1d5c04da4498f$export$fce58f7f7dbd3025.titleProperty)
], $a1b1d5c04da4498f$export$fce58f7f7dbd3025.prototype, "title", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($a1b1d5c04da4498f$export$fce58f7f7dbd3025.valueProperty)
], $a1b1d5c04da4498f$export$fce58f7f7dbd3025.prototype, "value", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($a1b1d5c04da4498f$export$fce58f7f7dbd3025.urlProperty)
], $a1b1d5c04da4498f$export$fce58f7f7dbd3025.prototype, "url", null);




var $lT7pJ = parcelRequire("lT7pJ");




const $e398da77014e0eb1$var$MultiSelect = ({ id: id, choices: choices, smallImages: smallImages, showCaptions: showCaptions })=>{
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [display, setDisplay] = (0, $lT7pJ.useState)([]);
    const [chosen, setChosen] = (0, $lT7pJ.useState)(values.get(id) || []);
    const [overflow, setOverflow] = (0, $lT7pJ.useState)(false);
    const [style, setStyle] = (0, $lT7pJ.useState)("");
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices props change :
   *  - fill display state with choices value
   *  - set overflow and style states depending on the smallImages boolean prop and the number of choices
   */ (0, $lT7pJ.useEffect)(()=>{
        if (choices) {
            setDisplay(choices);
            if (smallImages) {
                if (choices.length > 6) {
                    setOverflow(true);
                    setStyle("rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4");
                } else {
                    setOverflow(false);
                    setStyle("rf-grid rf-grid-rows-2 rf-grid-cols-3");
                }
            } else if (choices.length > 2) {
                setOverflow(true);
                setStyle("rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4");
            } else {
                setOverflow(false);
                setStyle("rf-grid rf-grid-rows-1 rf-grid-cols-2");
            }
        }
    }, [
        choices
    ]);
    /**
   * On chosen state change :
   *  - call parent's handleChangeCheckbox method
   */ (0, $lT7pJ.useEffect)(()=>{
        (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, chosen);
    }, [
        chosen
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - check for checked / unchecked values and fill chosen state with these
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            let tempChosen = [
                ...chosen
            ];
            if (tempChosen.includes(value)) tempChosen = tempChosen.filter((chosenValue)=>chosenValue !== value);
            else tempChosen = [
                ...tempChosen,
                value
            ];
            setChosen(tempChosen);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-w-full rf-gap-4 rf-text-size-auto rf-text-white ${style} rf-scrollbar-x-custom`,
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `rf-h-fit rf-flex rf-flex-col rf-items-start ${overflow && "rf-flex-[0_0_40%]"}`,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("label", {
                        className: `rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center rf-border-2 rf-rounded-lg ${chosen.includes(choice.value) ? "rf-border-primary" : "rf-border-formInputRadioCheckboxUncheckedBorder"} hover:rf-cursor-pointer rf-aspect-square rf-overflow-hidden`,
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                                src: choice.url,
                                className: "rf-max-w-full rf-max-h-full"
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                                type: "checkbox",
                                value: choice.value,
                                checked: chosen.includes(choice.value),
                                className: "rf-input-hidden",
                                onChange: ()=>handleChange(choice.value)
                            })
                        ]
                    }),
                    showCaptions && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-mt-2 rf-w-full rf-line-clamp-2",
                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $e398da77014e0eb1$export$2e2bcd8739ae039 = $e398da77014e0eb1$var$MultiSelect;




var $lT7pJ = parcelRequire("lT7pJ");




const $b1c5cc798a0ccc3b$var$MonoSelect = ({ id: id, choices: choices, smallImages: smallImages, showCaptions: showCaptions })=>{
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [display, setDisplay] = (0, $lT7pJ.useState)([]);
    const [chosen, setChosen] = (0, $lT7pJ.useState)(values.get(id) || "");
    const [overflow, setOverflow] = (0, $lT7pJ.useState)(false);
    const [style, setStyle] = (0, $lT7pJ.useState)("");
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On choices props change :
   *  - fill display state with choices value
   *  - set overflow and style states depending on the smallImages boolean prop and the number of choices
   */ (0, $lT7pJ.useEffect)(()=>{
        if (choices) {
            setDisplay(choices);
            if (smallImages) {
                if (choices.length > 6) {
                    setOverflow(true);
                    setStyle("rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4");
                } else {
                    setOverflow(false);
                    setStyle(`rf-grid ${choices.length > 3 && "rf-grid-rows-2"} rf-grid-cols-3`);
                }
            } else if (choices.length > 2) {
                setOverflow(true);
                setStyle("rf-flex rf-flex-row rf-justify-start rf-align-center rf-overflow-x-scroll rf-pb-4");
            } else {
                setOverflow(false);
                setStyle("rf-grid rf-grid-rows-1 rf-grid-cols-2");
            }
        }
    }, [
        choices
    ]);
    /**
   * On call:
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - fill chosen state with value
   *  - call parent's handleSelect method
   * @param value : string
   */ const handleChange = (value)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            setChosen(value);
            (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, value);
        }
    };
    return display && display.length > 0 ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-w-full rf-gap-4 rf-text-size-auto rf-text-white ${style} rf-scrollbar-x-custom`,
        children: display.map((choice, key)=>{
            return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `rf-h-fit rf-flex rf-flex-col rf-items-start ${overflow && "rf-flex-[0_0_40%]"}`,
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("label", {
                        className: `rf-w-full rf-h-full rf-flex rf-justify-center rf-items-center rf-border-2 rf-rounded-lg ${choice.value === chosen ? "rf-border-primary" : "rf-border-formInputRadioCheckboxUncheckedBorder"} hover:rf-cursor-pointer rf-aspect-square rf-overflow-hidden`,
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                                src: choice.url,
                                className: "rf-max-w-full rf-max-h-full"
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                                type: "radio",
                                value: choice.value,
                                checked: choice.value === chosen,
                                className: "rf-input-hidden",
                                onChange: ()=>handleChange(choice.value)
                            })
                        ]
                    }),
                    showCaptions && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-pt-2 rf-w-full rf-line-clamp-2",
                        children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(choice.title)
                    })
                ]
            }, key);
        })
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $b1c5cc798a0ccc3b$export$2e2bcd8739ae039 = $b1c5cc798a0ccc3b$var$MonoSelect;


class $ec06906de42e84ca$export$97d8aa00da3f172d extends $d97a7c55f35040d9$exports.Input {
    _value;
    static JsonTypeName = "Retorik.ImageChoiceSet";
    getJsonTypeName() {
        return $ec06906de42e84ca$export$97d8aa00da3f172d.JsonTypeName;
    }
    // Add custom preperties to schema
    static isMultiSelectProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "isMultiSelect", false);
    static smallImagesProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "smallImages", false);
    static showCaptionsProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "showCaptions", false);
    static choicesWithUrlProperty = new $d97a7c55f35040d9$exports.SerializableObjectCollectionProperty($d97a7c55f35040d9$exports.Versions.v1_0, "choicesWithUrl", (0, $a1b1d5c04da4498f$export$fce58f7f7dbd3025));
    // multiSelect property accessors
    get isMultiSelect() {
        return !!this.getValue($ec06906de42e84ca$export$97d8aa00da3f172d.isMultiSelectProperty);
    }
    set isMultiSelect(value) {
        if (this.isMultiSelect !== value) {
            this.setValue($ec06906de42e84ca$export$97d8aa00da3f172d.isMultiSelectProperty, value);
            this.updateLayout();
        }
    }
    // smallImages property accessors
    get smallImages() {
        return !!this.getValue($ec06906de42e84ca$export$97d8aa00da3f172d.smallImagesProperty);
    }
    set smallImages(value) {
        if (this.smallImages !== value) {
            this.setValue($ec06906de42e84ca$export$97d8aa00da3f172d.smallImagesProperty, value);
            this.updateLayout();
        }
    }
    // showCaptions property accessors
    get showCaptions() {
        return !!this.getValue($ec06906de42e84ca$export$97d8aa00da3f172d.showCaptionsProperty);
    }
    set showCaptions(value) {
        if (this.smallImages !== value) {
            this.setValue($ec06906de42e84ca$export$97d8aa00da3f172d.showCaptionsProperty, value);
            this.updateLayout();
        }
    }
    // choicesWithUrl property accessors
    get choicesWithUrl() {
        return this.getValue($ec06906de42e84ca$export$97d8aa00da3f172d.choicesWithUrlProperty) || [];
    }
    set choicesWithUrl(value) {
        if (this.choicesWithUrl !== value) {
            this.setValue($ec06906de42e84ca$export$97d8aa00da3f172d.choicesWithUrlProperty, value);
            this.updateLayout();
        }
    }
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    internalRender() {
        const element = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        if (!this.id) return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
        if (this.isMultiSelect) return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e398da77014e0eb1$export$2e2bcd8739ae039), {
            id: this.id,
            choices: this.choicesWithUrl,
            smallImages: this.smallImages,
            showCaptions: this.showCaptions
        });
        else return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $b1c5cc798a0ccc3b$export$2e2bcd8739ae039), {
            id: this.id,
            choices: this.choicesWithUrl,
            smallImages: this.smallImages,
            showCaptions: this.showCaptions
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($ec06906de42e84ca$export$97d8aa00da3f172d.isMultiSelectProperty)
], $ec06906de42e84ca$export$97d8aa00da3f172d.prototype, "isMultiSelect", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($ec06906de42e84ca$export$97d8aa00da3f172d.smallImagesProperty)
], $ec06906de42e84ca$export$97d8aa00da3f172d.prototype, "smallImages", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($ec06906de42e84ca$export$97d8aa00da3f172d.showCaptionsProperty)
], $ec06906de42e84ca$export$97d8aa00da3f172d.prototype, "showCaptions", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($ec06906de42e84ca$export$97d8aa00da3f172d.choicesWithUrlProperty)
], $ec06906de42e84ca$export$97d8aa00da3f172d.prototype, "choicesWithUrl", null);





var $lT7pJ = parcelRequire("lT7pJ");



var $lT7pJ = parcelRequire("lT7pJ");




const $1be4fb3a30c76f88$var$Slider = ({ id: id, minValue: minValue, maxValue: maxValue, minLabel: minLabel, maxLabel: maxLabel })=>{
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const values = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.values);
    const [sliderValue, setSliderValue] = (0, $lT7pJ.useState)(values.get(id) || ((minValue || 0) + (maxValue || 100)) / 2);
    const [sliderStyle, setSliderStyle] = (0, $lT7pJ.useState)(`linear-gradient(to right, ${themeColors.primary} ${(sliderValue - (minValue || 0)) / ((maxValue || 100) - (minValue || 0)) * 100}%, #7878805C ${(sliderValue - (minValue || 0)) / ((maxValue || 100) - (minValue || 0)) * 100}%)`);
    (0, $lT7pJ.useEffect)(()=>{
        currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && (0, $649c384b79ea2395$export$a619c8fe018044c1)(id);
    }, []);
    /**
   * On slider value change :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - set sliderValue state
   *  - call parent function with event value
   * @param e : changeEvent
   */ const handleChange = (e)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            setSliderValue(e.target.value);
            (0, $649c384b79ea2395$export$80746c6bc6142fc8)(id, e.target.value);
        }
    };
    /**
   * On value input in slider :
   *  - check if the component will be rendered in history, if so bypass every interaction
   *  - get value as percentage
   *  - set the slider color depending on the percentage obtained
   * @param e : inputEvent
   */ const handleOnInput = (e)=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) {
            // Value as percentage, we substract minValue up and down to get the right percentage if minValue !== 0
            const valPourcentage = (e.target.value - (minValue || 0)) / (e.target.max - (minValue || 0)) * 100;
            setSliderStyle(`linear-gradient(to right, ${themeColors.primary} ${valPourcentage}%, #7878805C ${valPourcentage}%)`);
        }
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-px-6 rf-pt-14 ${minLabel || maxLabel ? "rf-pb-5" : "rf-pb-14"} rf-rounded-lg rf-text-size-auto rf-text-white`,
        style: {
            background: "rgba(0, 0, 0, 0.5)"
        },
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("input", {
                style: {
                    background: sliderStyle
                },
                onInput: handleOnInput,
                onChange: handleChange,
                value: sliderValue,
                type: "range",
                min: minValue || 0,
                max: maxValue || 100,
                className: "rf-slider-custom"
            }),
            (minLabel || maxLabel) && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: "rf-w-full rf-mt-5 rf-flex rf-flex-row rf-justify-between rf-items-center",
                children: [
                    minLabel && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        children: minLabel
                    }),
                    maxLabel && (minLabel ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        children: maxLabel
                    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                children: "\u2800"
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                                children: maxLabel
                            })
                        ]
                    }))
                ]
            })
        ]
    });
};
var $1be4fb3a30c76f88$export$2e2bcd8739ae039 = $1be4fb3a30c76f88$var$Slider;



class $91034624c67d412e$export$7f21b8f94f2ce32b extends $d97a7c55f35040d9$exports.Input {
    _value = this.minValue && this.maxValue ? Math.floor((this.minValue + this.maxValue) / 2) : 50;
    get value() {
        return this._value;
    }
    isSet() {
        return this._value;
    }
    static JsonTypeName = "Retorik.Slider";
    getJsonTypeName() {
        return $91034624c67d412e$export$7f21b8f94f2ce32b.JsonTypeName;
    }
    // Add custom properties to schema
    static minValueProperty = new $d97a7c55f35040d9$exports.NumProperty($d97a7c55f35040d9$exports.Versions.v1_0, "minValue");
    static maxValueProperty = new $d97a7c55f35040d9$exports.NumProperty($d97a7c55f35040d9$exports.Versions.v1_0, "maxValue");
    static minLabelProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "minLabel", true);
    static maxLabelProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "maxLabel", true);
    // minValue property accessors
    get minValue() {
        return this.getValue($91034624c67d412e$export$7f21b8f94f2ce32b.minValueProperty);
    }
    set minValue(value) {
        if (this.minValue !== value) {
            this.setValue($91034624c67d412e$export$7f21b8f94f2ce32b.minValueProperty, value);
            this.updateLayout();
        }
    }
    // maxValue property accessors
    get maxValue() {
        return this.getValue($91034624c67d412e$export$7f21b8f94f2ce32b.maxValueProperty);
    }
    set maxValue(value) {
        if (this.maxValue !== value) {
            this.setValue($91034624c67d412e$export$7f21b8f94f2ce32b.maxValueProperty, value);
            this.updateLayout();
        }
    }
    // minLabel property accessors
    get minLabel() {
        return this.getValue($91034624c67d412e$export$7f21b8f94f2ce32b.minLabelProperty);
    }
    set minLabel(value) {
        if (this.minLabel !== value) {
            this.setValue($91034624c67d412e$export$7f21b8f94f2ce32b.minLabelProperty, value);
            this.updateLayout();
        }
    }
    // maxLabel property accessors
    get maxLabel() {
        return this.getValue($91034624c67d412e$export$7f21b8f94f2ce32b.maxLabelProperty);
    }
    set maxLabel(value) {
        if (this.maxLabel !== value) {
            this.setValue($91034624c67d412e$export$7f21b8f94f2ce32b.maxLabelProperty, value);
            this.updateLayout();
        }
    }
    internalRender() {
        const element = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
        return element;
    }
    renderReact = ()=>{
        return this.id ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1be4fb3a30c76f88$export$2e2bcd8739ae039), {
            id: this.id,
            minValue: this.minValue,
            maxValue: this.maxValue,
            minLabel: this.minLabel,
            maxLabel: this.maxLabel
        }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($91034624c67d412e$export$7f21b8f94f2ce32b.minValueProperty)
], $91034624c67d412e$export$7f21b8f94f2ce32b.prototype, "minValue", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($91034624c67d412e$export$7f21b8f94f2ce32b.maxValueProperty)
], $91034624c67d412e$export$7f21b8f94f2ce32b.prototype, "maxValue", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($91034624c67d412e$export$7f21b8f94f2ce32b.minLabelProperty)
], $91034624c67d412e$export$7f21b8f94f2ce32b.prototype, "minLabel", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($91034624c67d412e$export$7f21b8f94f2ce32b.maxLabelProperty)
], $91034624c67d412e$export$7f21b8f94f2ce32b.prototype, "maxLabel", null);




parcelRequire("lT7pJ");


/* eslint-disable react/jsx-boolean-value */ 

var $lT7pJ = parcelRequire("lT7pJ");
















const $e6b11d107213ad6a$var$ActionButton = ({ text: text, fullWidth: fullWidth, position: position, display: display, urlToOpen: urlToOpen, data: data })=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const currentSubView = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.currentSubView);
    const unlockClickedButton = (0, $1bda010252da638c$export$77e4cc5334565f28)((state)=>state.unlockClickedButton);
    const isUsedOnBorne = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.isUsedOnBorne);
    const enableDocumentPrinting = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration.enableDocumentPrinting);
    const isMobile = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.isMobile);
    const locale = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.locale);
    const currentValue = (0, $649c384b79ea2395$export$a8a6e22a57e6f7d2)((state)=>state.currentValue);
    const themeColors = (0, $1c9be018817ca3e3$export$d13b2577cb75f2ad)((state)=>state.themeColors);
    const [style, setStyle] = (0, $lT7pJ.useState)();
    const [clicked, setClicked] = (0, $lT7pJ.useState)(false);
    const [hover, setHover] = (0, $lT7pJ.useState)(false);
    const [qrCodeData, setQrCodeData] = (0, $lT7pJ.useState)();
    const [textToDisplay, setTextToDisplay] = (0, $lT7pJ.useState)();
    const [triedToValidateWithoutValue, setTriedToValidateWithoutValue] = (0, $lT7pJ.useState)(false);
    const animationColor = {
        "--rf-color-loader-animation": themeColors.card.button.text.default
    };
    const defaultText = (0, $lT7pJ.useMemo)(()=>{
        return text || (urlToOpen ? translation.link.goto : translation.common.submit);
    }, [
        text,
        locale
    ]);
    const setQrCodeDataAsync = async ()=>{
        if (urlToOpen) {
            const qrCodeString = await (0, (/*@__PURE__*/$parcel$interopDefault($33b99b026c95b649$exports))).toDataURL(encodeURI(urlToOpen));
            setQrCodeData(qrCodeString);
        }
    };
    (0, $lT7pJ.useEffect)(()=>{
        setTextToDisplay((0, $0fdc9a557a65290b$export$d07f57595c356899)(defaultText, locale));
    }, [
        defaultText,
        translation,
        locale
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (triedToValidateWithoutValue && currentValue) {
            const values = Object.values(currentValue);
            if (!values.find((value)=>Array.isArray(value) && !value.length)) setTextToDisplay((0, $0fdc9a557a65290b$export$d07f57595c356899)(defaultText, locale));
        }
    }, [
        triedToValidateWithoutValue,
        currentValue
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        if (urlToOpen && isUsedOnBorne) setQrCodeDataAsync();
    }, [
        urlToOpen,
        isUsedOnBorne
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        unlockClickedButton && setClicked(false);
    }, [
        unlockClickedButton
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        // Set width : full or fit
        let temp = fullWidth ? "rf-w-full" : "rf-w-fit";
        // Set position if not in full width
        if (!fullWidth && position) switch(position){
            case "right":
                temp += " rf-float-right";
                break;
            case "center":
                temp += " rf-mx-auto";
                break;
            case "left":
            default:
                break;
        }
        setStyle(temp);
    }, []);
    const handleOpenPreview = ()=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history) urlToOpen && (0, $1bda010252da638c$export$4317154639841e84)(/*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $97fc7d6e74a4cfb9$export$2e2bcd8739ae039), {
            url: urlToOpen,
            printingAllowed: !!enableDocumentPrinting
        }));
    };
    const handleClick = ()=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && !clicked) {
            if (urlToOpen) window.open(urlToOpen, "_blank", "noopener noreferrer");
            else {
                if (data) {
                    if (data.type) {
                        if (data.type.toLowerCase() === "message") data.text && (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(data.text);
                        else if (data.type.toLowerCase() === "event") (0, $0aecf0c32f1a48e0$export$7329bcdc3edcd90e)(data.name, data.value);
                    } else {
                        if (typeof data === "string") (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(data);
                        else if (typeof data === "object") (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, data);
                    }
                } else if (currentValue) {
                    const values = Object.values(currentValue);
                    // Check if a value is an empty array. If so, break the process
                    if (values.find((value)=>Array.isArray(value) && !value.length)) {
                        setTriedToValidateWithoutValue(true);
                        setTextToDisplay((0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.inputs.noaction, locale));
                        return;
                    } else (0, $0aecf0c32f1a48e0$export$465cb47180de50f0)(undefined, currentValue);
                } else {
                    setTriedToValidateWithoutValue(true);
                    setTextToDisplay((0, $0fdc9a557a65290b$export$d07f57595c356899)(translation.inputs.noaction, locale));
                    return;
                }
                setClicked(true);
                setHover(false);
                (0, $1bda010252da638c$export$5d55805fc8a86c05)();
            }
        }
    };
    const handleEnter = ()=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && !clicked) setHover(true);
    };
    const handleLeave = ()=>{
        if (currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && !clicked) setHover(false);
    };
    return urlToOpen && isUsedOnBorne ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: "rf-w-full rf-flex rf-flex-col rf-justify-center rf-items-center rf-text-cardButtonTextDefault",
        children: [
            urlToOpen.length > 4 && urlToOpen.substring(urlToOpen.length - 4) === ".pdf" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-pb-6 rf-flex rf-justify-start rf-text-primary rf-underline rf-italic rf-text-sm",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("p", {
                    className: "rf-cursor-pointer",
                    onClick: handleOpenPreview,
                    children: translation.link.buttonText
                })
            }),
            qrCodeData ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $afe82365b658f5fb$export$2e2bcd8739ae039), {
                        src: qrCodeData
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                        className: "rf-relative rf-text-center rf-mx-8 rf-mt-2 rf-italic",
                        children: [
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $048e611f22f84ada$export$2e2bcd8739ae039), {
                                className: "rf-absolute rf-top-[0.125rem] -rf-left-6 rf-h-4"
                            }),
                            (0, $412d46e5db76a0eb$export$2eb1c1cc4b12d451)({
                                translation: translation,
                                isUsedOnBorne: isUsedOnBorne,
                                data: {
                                    url: urlToOpen,
                                    download: true
                                }
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-6 rf-h-6",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $83a1eb52d5b16844$export$2e2bcd8739ae039), {
                    color: "gray",
                    loaderColor: themeColors.primary,
                    backgroundColor: "transparent"
                })
            })
        ]
    }) : text && display.toLowerCase() === "link" ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
        className: `rf-w-full rf-mt-2 rf-flex rf-justify-start rf-items-center rf-text-cardButtonTextDefault ${currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history && "rf-cursor-pointer"}`,
        onPointerEnter: handleEnter,
        onPointerLeave: handleLeave,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: `rf-h-6 rf-w-6 rf-rounded ${hover ? "rf-bg-cardButtonBackgroundHover" : "rf-bg-cardButtonBackgroundDefault"}`,
                children: clicked && !urlToOpen ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-h-6 rf-w-6 rf-flex rf-justify-center rf-items-center",
                    style: {
                        ...animationColor
                    },
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-w-2 rf-h-2",
                        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3f55b239f06aa14f$export$2e2bcd8739ae039), {
                            size: (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).small
                        })
                    })
                }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4365628ed5afaad5$export$2e2bcd8739ae039), {
                    className: `rf-h-6 rf-p-1 rf-border rf-rounded ${hover ? "rf-border-cardButtonBorderHover" : "rf-border-cardButtonBorderDefault"}`,
                    color: hover ? themeColors.card.button.text.hover : themeColors.card.button.text.default
                })
            }),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-ml-4",
                children: (0, $0fdc9a557a65290b$export$d07f57595c356899)(text, locale)
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `rf-relative ${currentSubView !== (0, $45d43a6de0968f42$export$f05d0fed0593ead7).history ? clicked ? "rf-card-button-clicked" : "rf-card-button" : "rf-card-button-history"} rf-mt-2 ${fullWidth ? "rf-text-center" : "rf-text-left"} ${style}`,
        onClick: handleClick,
        children: clicked && !urlToOpen ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            className: `rf-w-full rf-h-[1.25rem] large:rf-h-[1.3rem] rf-flex rf-justify-center rf-items-center ${fullWidth ? "" : "rf-pl-6 large:rf-pl-12"}`,
            style: {
                ...animationColor
            },
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-4 rf-h-4 large:rf-w-6 large:rf-h-6",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3f55b239f06aa14f$export$2e2bcd8739ae039), {
                    size: isMobile ? (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).medium : (0, $45d43a6de0968f42$export$a2a634340dd7e3e3).large
                })
            })
        }) : textToDisplay
    });
};
var $e6b11d107213ad6a$export$2e2bcd8739ae039 = $e6b11d107213ad6a$var$ActionButton;


class $18e8849ca62f483c$export$ea4365d42c3e8532 extends $d97a7c55f35040d9$exports.SubmitAction {
    internalRenderedElement = document.createElement("div");
    static fullWidthProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "fullWidth", false);
    static positionProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "position", true, undefined, "left");
    static displayProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "display", true, undefined, "button");
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($18e8849ca62f483c$export$ea4365d42c3e8532.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($18e8849ca62f483c$export$ea4365d42c3e8532.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($18e8849ca62f483c$export$ea4365d42c3e8532.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($18e8849ca62f483c$export$ea4365d42c3e8532.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($18e8849ca62f483c$export$ea4365d42c3e8532.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($18e8849ca62f483c$export$ea4365d42c3e8532.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
    }
    renderReact = ()=>{
        const props = {
            text: this.title,
            fullWidth: this.fullWidth,
            position: this.position,
            display: this.display,
            data: this.data
        };
        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e6b11d107213ad6a$export$2e2bcd8739ae039), {
            ...props
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($18e8849ca62f483c$export$ea4365d42c3e8532.fullWidthProperty)
], $18e8849ca62f483c$export$ea4365d42c3e8532.prototype, "fullWidth", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($18e8849ca62f483c$export$ea4365d42c3e8532.positionProperty)
], $18e8849ca62f483c$export$ea4365d42c3e8532.prototype, "position", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($18e8849ca62f483c$export$ea4365d42c3e8532.displayProperty)
], $18e8849ca62f483c$export$ea4365d42c3e8532.prototype, "display", null);




parcelRequire("lT7pJ");



class $a618676f0709b2e9$export$3226295bbd9dad06 extends $d97a7c55f35040d9$exports.OpenUrlAction {
    internalRenderedElement = document.createElement("div");
    static fullWidthProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "fullWidth", false);
    static positionProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "position", true, undefined, "left");
    static displayProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "display", true, undefined, "button");
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($a618676f0709b2e9$export$3226295bbd9dad06.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($a618676f0709b2e9$export$3226295bbd9dad06.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($a618676f0709b2e9$export$3226295bbd9dad06.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($a618676f0709b2e9$export$3226295bbd9dad06.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($a618676f0709b2e9$export$3226295bbd9dad06.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($a618676f0709b2e9$export$3226295bbd9dad06.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
    }
    renderReact = ()=>{
        const props = {
            text: this.title,
            fullWidth: this.fullWidth,
            position: this.position,
            display: this.display,
            urlToOpen: this.url
        };
        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e6b11d107213ad6a$export$2e2bcd8739ae039), {
            ...props
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($a618676f0709b2e9$export$3226295bbd9dad06.fullWidthProperty)
], $a618676f0709b2e9$export$3226295bbd9dad06.prototype, "fullWidth", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($a618676f0709b2e9$export$3226295bbd9dad06.positionProperty)
], $a618676f0709b2e9$export$3226295bbd9dad06.prototype, "position", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($a618676f0709b2e9$export$3226295bbd9dad06.displayProperty)
], $a618676f0709b2e9$export$3226295bbd9dad06.prototype, "display", null);




parcelRequire("lT7pJ");



class $a0a23027c21b2801$export$17915a7271c45b27 extends $d97a7c55f35040d9$exports.ShowCardAction {
    internalRenderedElement = document.createElement("div");
    static fullWidthProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "fullWidth", false);
    static positionProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "position", true, undefined, "left");
    static displayProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "display", true, undefined, "button");
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($a0a23027c21b2801$export$17915a7271c45b27.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($a0a23027c21b2801$export$17915a7271c45b27.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($a0a23027c21b2801$export$17915a7271c45b27.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($a0a23027c21b2801$export$17915a7271c45b27.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($a0a23027c21b2801$export$17915a7271c45b27.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($a0a23027c21b2801$export$17915a7271c45b27.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
    }
    renderReact = ()=>{
        const props = {
            text: this.title,
            fullWidth: this.fullWidth,
            position: this.position,
            display: this.display
        };
        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e6b11d107213ad6a$export$2e2bcd8739ae039), {
            ...props
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($a0a23027c21b2801$export$17915a7271c45b27.fullWidthProperty)
], $a0a23027c21b2801$export$17915a7271c45b27.prototype, "fullWidth", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($a0a23027c21b2801$export$17915a7271c45b27.positionProperty)
], $a0a23027c21b2801$export$17915a7271c45b27.prototype, "position", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($a0a23027c21b2801$export$17915a7271c45b27.displayProperty)
], $a0a23027c21b2801$export$17915a7271c45b27.prototype, "display", null);




parcelRequire("lT7pJ");



class $d45c9038655ed930$export$e4bbccd75e2f23fc extends $d97a7c55f35040d9$exports.ToggleVisibilityAction {
    internalRenderedElement = document.createElement("div");
    static fullWidthProperty = new $d97a7c55f35040d9$exports.BoolProperty($d97a7c55f35040d9$exports.Versions.v1_0, "fullWidth", false);
    static positionProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "position", true, undefined, "left");
    static displayProperty = new $d97a7c55f35040d9$exports.StringProperty($d97a7c55f35040d9$exports.Versions.v1_0, "display", true, undefined, "button");
    // fullWidth property accessors
    get fullWidth() {
        return this.getValue($d45c9038655ed930$export$e4bbccd75e2f23fc.fullWidthProperty);
    }
    set fullWidth(value) {
        if (this.fullWidth !== value) this.setValue($d45c9038655ed930$export$e4bbccd75e2f23fc.fullWidthProperty, value);
    }
    // position property accessors
    get position() {
        return this.getValue($d45c9038655ed930$export$e4bbccd75e2f23fc.positionProperty);
    }
    set position(value) {
        if (this.position !== value) this.setValue($d45c9038655ed930$export$e4bbccd75e2f23fc.positionProperty, value);
    }
    // display property accessors
    get display() {
        return this.getValue($d45c9038655ed930$export$e4bbccd75e2f23fc.displayProperty);
    }
    set display(value) {
        if (this.display !== value) this.setValue($d45c9038655ed930$export$e4bbccd75e2f23fc.displayProperty, value);
    }
    get renderedElement() {
        return this.internalRenderedElement;
    }
    render() {
        this.internalRenderedElement = (0, $92c6b20da1bd4695$export$f23ef6cb462a47f7)(this.renderReact());
    }
    renderReact = ()=>{
        const props = {
            text: this.title,
            fullWidth: this.fullWidth,
            position: this.position,
            display: this.display
        };
        return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $e6b11d107213ad6a$export$2e2bcd8739ae039), {
            ...props
        });
    };
}
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($d45c9038655ed930$export$e4bbccd75e2f23fc.fullWidthProperty)
], $d45c9038655ed930$export$e4bbccd75e2f23fc.prototype, "fullWidth", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($d45c9038655ed930$export$e4bbccd75e2f23fc.positionProperty)
], $d45c9038655ed930$export$e4bbccd75e2f23fc.prototype, "position", null);
(0, $49f51cfbe488d9fc$export$29e00dfd3077644b)([
    $d97a7c55f35040d9$exports.property($d45c9038655ed930$export$e4bbccd75e2f23fc.displayProperty)
], $d45c9038655ed930$export$e4bbccd75e2f23fc.prototype, "display", null);


let $73904eef07431659$var$iconsInitialized = false;
/**
 * STORYBOOK : elements that have no decorator and thus don't have to be commented to build storybook :
 *  - TextBlock
 *  - Input.Toggle
 * Every other element has to be commented otherwise storybook build will fail
 */ const $73904eef07431659$export$6108075486421829 = ()=>{
    if (!$73904eef07431659$var$iconsInitialized) {
        (0, $e25ab669c29b5f8e$export$daed2daeba655e15)();
        $73904eef07431659$var$iconsInitialized = true;
    }
    // Override existing elements
    $d97a7c55f35040d9$exports.GlobalRegistry.elements.register("TextBlock", (0, $e53abcc697d38737$export$92739f4310a31a0d));
    $d97a7c55f35040d9$exports.GlobalRegistry.elements.register("Input.Toggle", (0, $673e3f1cfe302e01$export$c99bfd6b0ed44fbd));
    $d97a7c55f35040d9$exports.GlobalRegistry.elements.register("Input.Date", (0, $dc96a8fcfbd484ff$export$a9633577dcb92569));
    $d97a7c55f35040d9$exports.GlobalRegistry.elements.register("Input.Time", (0, $a181a5e19ff36346$export$27dc9c3aadf0815c));
    $d97a7c55f35040d9$exports.GlobalRegistry.elements.register("Input.ChoiceSet", (0, $ea797332a95bee75$export$3d2f970ec3b98a50));
    // Register new elements
    $d97a7c55f35040d9$exports.GlobalRegistry.elements.register("Retorik.ImageChoiceSet", (0, $ec06906de42e84ca$export$97d8aa00da3f172d));
    $d97a7c55f35040d9$exports.GlobalRegistry.elements.register("Retorik.Likert", (0, $7c63de084d26d3e3$export$527d02f4ea70b77));
    $d97a7c55f35040d9$exports.GlobalRegistry.elements.register("Retorik.Slider", (0, $91034624c67d412e$export$7f21b8f94f2ce32b));
    // Override existing actions
    $d97a7c55f35040d9$exports.GlobalRegistry.actions.register("Action.Submit", (0, $18e8849ca62f483c$export$ea4365d42c3e8532));
    $d97a7c55f35040d9$exports.GlobalRegistry.actions.register("Action.OpenUrl", (0, $a618676f0709b2e9$export$3226295bbd9dad06));
    $d97a7c55f35040d9$exports.GlobalRegistry.actions.register("Action.ShowCard", (0, $a0a23027c21b2801$export$17915a7271c45b27));
    $d97a7c55f35040d9$exports.GlobalRegistry.actions.register("Action.ToggleVisibility", (0, $d45c9038655ed930$export$e4bbccd75e2f23fc));
};


// Configure react-pdf worker
(0, $b5ae944e35783420$export$2e2bcd8739ae039).GlobalWorkerOptions.workerSrc = $9e7e6ef3b125c124$exports;
// Overload adaptive card rendering classes
(0, $73904eef07431659$export$6108075486421829)();
const $4bebd0dd2d5ff69c$var$RetorikContainer = ({ config: config, viewsConfig: viewsConfig, chatbotData: chatbotData, chatbotDataWidget: chatbotDataWidget, agentData: agentData, ponyfillFactoryCredentials: ponyfillFactoryCredentials, addressData: addressData, userData: userData, skipLoader: skipLoader, defaultMode: defaultMode, customVoice: customVoice, externalEventHandler: externalEventHandler, externalComponents: externalComponents, width: width, height: height, colors: colors, parent: parent })=>{
    (0, $lT7pJ.useEffect)(()=>{
        (0, $1c9be018817ca3e3$export$2eb835c7cd21b3a5)((0, $c08cbd71abd81c74$export$2e2bcd8739ae039)(colors));
    }, []);
    const currentLayout = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.currentLayout);
    return config && viewsConfig && chatbotData && chatbotDataWidget && agentData && ponyfillFactoryCredentials ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $aa47112092dcdaca$export$2e2bcd8739ae039), {
        skipLoader: skipLoader,
        mode: defaultMode || (0, $45d43a6de0968f42$export$9484bbecc3c49a2e).vocal,
        viewsConfiguration: viewsConfig,
        configuration: config,
        addressData: addressData,
        agentSource: agentData,
        ponyfillFactoryCredentials: ponyfillFactoryCredentials,
        customVoice: customVoice,
        children: [
            !config.forceMobileView && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d113fc29ff4ecd16$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d712f7d262fd02fc$export$2e2bcd8739ae039), {
                addressData: addressData,
                userData: userData,
                externalEventHandler: externalEventHandler,
                isRetorikNews: parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).news,
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $4c0f8c7831c7ab99$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $577c102a8d490505$export$2e2bcd8739ae039), {
                            isRetorikNews: parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).news
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a6b91876af412c22$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $88d8d174fc7cb1a7$export$2e2bcd8739ae039), {
                            fullSize: parent !== (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget && config.fullSize !== false,
                            width: width,
                            height: height,
                            parent: parent,
                            children: parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).news ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $956e6b3bccf15e5e$export$2e2bcd8739ae039), {
                                chatbotData: currentLayout === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).agent ? chatbotData : chatbotDataWidget,
                                hideMenu: true,
                                isRetorikNews: true
                            }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $7468a650f7bdb7fd$export$2e2bcd8739ae039), {
                                chatbotData: currentLayout === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).agent ? chatbotData : chatbotDataWidget,
                                externalComponents: externalComponents
                            })
                        }),
                        /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $fbce23b8754704fb$export$2e2bcd8739ae039), {
                            isRetorikNews: parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).news
                        })
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {});
};
var $4bebd0dd2d5ff69c$export$2e2bcd8739ae039 = $4bebd0dd2d5ff69c$var$RetorikContainer;





const $776569acf3b31dd9$var$getRetorikConfigs = async (props)=>{
    const retorikProps = {
        ...props
    };
    let res = null;
    const baseAddress = `${retorikProps.addressData.baseURI && retorikProps.addressData.baseURI.length > 0 ? (0, $e837502f2e0b0685$export$2e2bcd8739ae039)(retorikProps.addressData.baseURI) : (0, $a6ed223e0fdb911e$export$2e2bcd8739ae039)(retorikProps.addressData.prefix)}/${retorikProps.addressData.tenant ? retorikProps.addressData.tenant + "/" : ""}`;
    const fullAddress = `${baseAddress}api/integration/framework`;
    try {
        const response = await fetch(fullAddress);
        const json = await response.json();
        res = $776569acf3b31dd9$var$processJson(json, retorikProps, baseAddress);
    } catch (error) {
        console.log(error);
    }
    return res;
};
var $e20701db8a24ecdd$exports = {};

$e20701db8a24ecdd$exports = (parcelRequire("ghbiQ")).getBundleURL("3ufsE") + "background.bf75fd73.webp";



const $776569acf3b31dd9$var$processJson = (json, retorikProps, baseAddress)=>{
    if (json) {
        // Get full address for backgrounds & logo
        let logo, background, newsBackground, personnage;
        if (json.personnage) personnage = `${0, $bbe458fac496c294$export$2475544086fd222b}/${json.personnage}`;
        else personnage = `${0, $bbe458fac496c294$export$2475544086fd222b}/long-shot/zahra`;
        if (retorikProps.addressData.tenant && baseAddress.indexOf(`/${retorikProps.addressData.tenant}`)) baseAddress = baseAddress.replace(`/${retorikProps.addressData.tenant}`, "");
        baseAddress = baseAddress.endsWith("/") ? baseAddress.slice(0, -1) : baseAddress;
        if (json.logo) logo = `${baseAddress}${json.logo}`;
        if (json.background && json.background.length > 0) background = `${baseAddress}${json.background}`;
        else background = new URL($e20701db8a24ecdd$exports);
        if (json.newsBackground && json.newsBackground.length > 0) newsBackground = `${baseAddress}${json.newsBackground}`;
        else newsBackground = new URL($e20701db8a24ecdd$exports);
        // Handle size & height : string or number
        let size = json.agentSize || undefined;
        if (json.agentSize && !isNaN(+json.agentSize)) size = +json.agentSize // convert to int
        ;
        let height = json.agentHeight || undefined;
        if (json.agentHeight && !isNaN(+json.agentHeight)) height = +json.agentHeight // convert to int
        ;
        // For widget
        // Handle size & height : string or number
        let sizeWidget = json.agentSizeWidget || json.agentSize || undefined;
        if (json.agentSizeWidget && !isNaN(+json.agentSizeWidget)) sizeWidget = +json.agentSizeWidget // convert to int
        ;
        let heightWidget = json.agentHeightWidget || json.agentHeight || undefined;
        if (json.agentHeightWidget && !isNaN(+json.agentHeightWidget)) heightWidget = +json.agentHeightWidget // convert to int
        ;
        const props = {
            config: {
                fullSize: undefined,
                isUsedOnBorne: undefined,
                locales: {
                    getDefaultFromBrowser: undefined
                },
                position: {
                    searchForLocation: json.detectLocation,
                    latitude: undefined,
                    longitude: undefined,
                    city: undefined,
                    country: undefined
                },
                subtitles: json.subtitles,
                logo: json.logo ? {
                    src: logo
                } : undefined,
                answerpanel: undefined,
                skipWelcome: json.skipWelcome,
                preventExpectedInputHint: json.preventExpectedInputHint,
                pagination: undefined,
                remote: undefined,
                companyName: json.companyName,
                companyNameLocalized: json.companyNameLocalized,
                subCompanyMessage: json.subCompanyMessage,
                subCompanyMessageLocalized: json.subCompanyMessageLocalized,
                loaderInformationTexts: {
                    text: {
                        top: json.textModeHomeTitle,
                        bottom: json.textModeHomeSubtitle
                    },
                    vocal: {
                        top: json.voiceModeHomeTitle,
                        bottom: json.voiceModeHomeSubtitle
                    }
                },
                loaderInformationTextsLocalized: {
                    text: {
                        top: json.textModeHomeTitleLocalized,
                        bottom: json.textModeHomeSubtitleLocalized
                    },
                    vocal: {
                        top: json.voiceModeHomeTitleLocalized,
                        bottom: json.voiceModeHomeSubtitleLocalized
                    }
                },
                hideRetorikLogo: json.hideRetorikLogo,
                baseMenu: undefined,
                customMenu: undefined,
                subMenu: undefined,
                hideMenu: json.hideMenu,
                hideControls: json.hideControls,
                doNotDetectDeviceFromUserAgent: json.doNotDetectDeviceFromUserAgent,
                enableConversationCookie: json.enableConversationCookie,
                conversationCookieMaxAge: json.conversationCookieMaxAge,
                enableTelemetry: json.enableTelemetry,
                allowSwitchLayout: json.allowSwitchLayout,
                forceMobileView: json.forceMobileFullScreenLayout,
                enableSpeechCaching: json.enableSpeechCaching,
                speechRecognitionOptions: json.speechRecognitionOptions,
                speechSynthesisOptions: json.speechSynthesisOptions,
                enableDocumentPrinting: undefined,
                disableSpeechMode: json.disableSpeechMode,
                disableSound: json.disableSound,
                timerForFilterSelectionListMode: undefined
            },
            viewsConfig: {
                homeRoute: "home",
                webcamRotation: undefined,
                views: {
                    home: {
                        background: {
                            style: "image",
                            image: background,
                            video: undefined,
                            webcam: undefined,
                            neutral: undefined,
                            blur: undefined,
                            overlayOpacity: undefined
                        }
                    },
                    news: {
                        intervalInSeconds: 2,
                        loop: true,
                        openingVideo: "",
                        background: {
                            style: "image",
                            image: newsBackground,
                            video: undefined,
                            webcam: undefined,
                            neutral: undefined,
                            blur: undefined,
                            overlayOpacity: undefined
                        }
                    }
                }
            },
            chatbotData: {
                size: size,
                height: height
            },
            chatbotDataWidget: {
                size: sizeWidget,
                height: heightWidget
            },
            agentData: personnage,
            ponyfillFactoryCredentials: {
                region: json.voiceCredentialsRegion ?? "francecentral",
                subscriptionKey: json.voiceCredentialsSubscriptionKey ?? "2f62867e22a544b78a16c99a2707ef49"
            },
            addressData: retorikProps.addressData,
            userData: retorikProps.userData,
            customVoice: {
                voice: json.voice,
                gender: undefined
            },
            colors: {
                theme: json.colorSettings.theme,
                primary: json.colorSettings.primary,
                secondary: json.colorSettings.secondary,
                black: json.colorSettings.black,
                whereToEatColor: json.colorSettings.whereToEatColor,
                whereToSleepColor: json.colorSettings.whereToSleepColor,
                tobeSeenColor: json.colorSettings.tobeSeenColor,
                tobeDoneColor: json.colorSettings.tobeDoneColor,
                localProductsColor: json.colorSettings.localProductsColor,
                servicesColor: json.colorSettings.servicesColor,
                companyName: json.colorSettings.companyName,
                agendaColor: json.colorSettings.agendaColor,
                occupantColor: json.colorSettings.occupantColor,
                loader: {
                    animation: json.colorSettings.loader?.animation,
                    background: json.colorSettings.loader?.background,
                    text: json.colorSettings.loader?.text,
                    toggle: {
                        text: json.colorSettings.loader?.toggle?.text,
                        background: json.colorSettings.loader?.toggle?.background
                    },
                    button: {
                        background: {
                            default: json.colorSettings.loader?.button?.background?.default,
                            hover: json.colorSettings.loader?.button?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.loader?.button?.border?.default,
                            hover: json.colorSettings.loader?.button?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.loader?.button?.text?.default,
                            hover: json.colorSettings.loader?.button?.text?.hover
                        }
                    }
                },
                card: {
                    frame: {
                        background: json.colorSettings.card?.frame?.background,
                        border: json.colorSettings.card?.frame?.border,
                        text: json.colorSettings.card?.frame?.text
                    },
                    button: {
                        background: {
                            default: json.colorSettings.card?.button?.background?.default,
                            hover: json.colorSettings.card?.button?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.card?.button?.border?.default,
                            hover: json.colorSettings.card?.button?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.card?.button?.text?.default,
                            hover: json.colorSettings.card?.button?.text?.hover
                        }
                    },
                    discoverButton: {
                        background: {
                            default: json.colorSettings.card?.discoverButton?.background?.default,
                            hover: json.colorSettings.card?.discoverButton?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.card?.discoverButton?.border?.default,
                            hover: json.colorSettings.card?.discoverButton?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.card?.discoverButton?.text?.default,
                            hover: json.colorSettings.card?.discoverButton?.text?.hover
                        }
                    }
                },
                textMode: {
                    panel: {
                        background: json.colorSettings.textMode?.panel?.background,
                        border: json.colorSettings.textMode?.panel?.border,
                        conversationUser: json.colorSettings.textMode?.panel?.conversationUser,
                        conversationBot: json.colorSettings.textMode?.panel?.conversationBot
                    }
                },
                vocalMode: {
                    subtitles: {
                        text: json.colorSettings.vocalMode?.subtitles?.text,
                        background: json.colorSettings.vocalMode?.subtitles?.background
                    }
                },
                formInput: {
                    text: {
                        default: json.colorSettings.formInput?.inputText?.default,
                        hover: json.colorSettings.formInput?.inputText?.hover
                    },
                    inputRadioCheckbox: {
                        unchecked: {
                            background: json.colorSettings.formInput?.inputRadioCheckbox?.unchecked?.background,
                            border: json.colorSettings.formInput?.inputRadioCheckbox?.unchecked?.border
                        },
                        checked: {
                            background: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.background,
                            border: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.border,
                            item: json.colorSettings.formInput?.inputRadioCheckbox?.checked?.item
                        }
                    },
                    inputButton: {
                        background: {
                            default: json.colorSettings.formInput?.inputButton?.background?.default,
                            hover: json.colorSettings.formInput?.inputButton?.background?.hover
                        },
                        border: {
                            default: json.colorSettings.formInput?.inputButton?.border?.default,
                            hover: json.colorSettings.formInput?.inputButton?.border?.hover
                        },
                        text: {
                            default: json.colorSettings.formInput?.inputButton?.text?.default,
                            hover: json.colorSettings.formInput?.inputButton?.text?.hover
                        }
                    },
                    likert: {
                        default: json.colorSettings.formInput?.likert?.default,
                        hover: json.colorSettings.formInput?.likert?.hover
                    }
                }
            },
            defaultMode: json.defaultMode,
            skipLoader: json.skipLoader
        };
        return props;
    }
    return null;
};
var $776569acf3b31dd9$export$2e2bcd8739ae039 = $776569acf3b31dd9$var$getRetorikConfigs;



parcelRequire("lT7pJ");



const $71d8c5a6ede06616$var$Loader = ({ className: className, parent: parent, width: width, height: height, fullSize: fullSize })=>{
    const animationColor = {
        "--rf-color-loader-animation": "#00D7FF"
    };
    let widthStyle = {};
    let heightStyle = {};
    if (parent === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget) {
        widthStyle = {
            width: "100%"
        };
        heightStyle = {
            height: height
        };
    }
    if (width === "full") widthStyle = {
        width: "100%"
    };
    else if (typeof width === "number") widthStyle = {
        width: `${width}px`
    };
    else if (typeof width === "string") widthStyle = {
        width: width
    };
    if (height === "full") heightStyle = {
        height: "100%",
        flexGrow: 1
    };
    else if (typeof height === "number") heightStyle = {
        height: `${height}px`
    };
    else if (typeof height === "string") heightStyle = {
        height: height
    };
    if (0, $673e90b4fbb753dd$exports.isMobile) heightStyle = {
        height: window.innerHeight,
        minHeight: window.innerHeight,
        maxHeight: window.innerHeight
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
        className: `${fullSize ? "rf-w-screen rf-h-screen" : "rf-w-full rf-h-full"} rf-max-w-screen rf-max-h-screen rf-bg-white ${className}`,
        style: {
            ...widthStyle,
            ...heightStyle
        },
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
            className: "rf-h-full rf-w-full rf-flex rf-flex-col rf-items-center",
            style: {
                background: "rgba(18,18,18,0.7)",
                ...animationColor
            },
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                className: "rf-w-full rf-h-1/2 rf-pb-6 rf-flex rf-flex-col rf-items-center rf-justify-end",
                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                    className: "rf-w-6 rf-h-6 rf-mb-16",
                    children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $3f55b239f06aa14f$export$2e2bcd8739ae039), {})
                })
            })
        })
    });
};
var $71d8c5a6ede06616$export$2e2bcd8739ae039 = $71d8c5a6ede06616$var$Loader;








const $d5cb7275de1c4931$export$284b58786299e6c5 = async ({ configurationData: configurationData, addressData: addressData })=>{
    if (configurationData) {
        if (typeof configurationData.userConsent === "boolean") return {
            displayGDPR: false,
            userConsent: configurationData.userConsent
        };
        else return {
            displayGDPR: true,
            data: configurationData
        };
    } else {
        const baseAddress = `${addressData.baseURI?.length ? (0, $e837502f2e0b0685$export$2e2bcd8739ae039)(addressData.baseURI) : (0, $a6ed223e0fdb911e$export$2e2bcd8739ae039)(addressData.prefix)}/${addressData.tenant ? addressData.tenant + "/" : ""}`;
        const fullAddress = `${baseAddress}api/gdpr/settings`;
        const response = await fetch(fullAddress).then((res)=>res.json()).catch((error)=>{
            console.warn(error);
            return undefined;
        });
        if (response) {
            // Format response data to get a GDPR-type object
            const responseToData = {
                title: {},
                message: {},
                link: {},
                linkURL: undefined,
                buttonAccept: {},
                buttonRefuse: {},
                messageAccepted: {},
                messageRefused: {}
            };
            for(const locale in response.localizationContainer){
                // Title
                response.localizationContainer[locale]?.ConsentTitle && (responseToData.title[locale] = response.localizationContainer[locale]?.ConsentTitle);
                // Message
                response.localizationContainer[locale]?.ConsentBody && (responseToData.message[locale] = response.localizationContainer[locale]?.ConsentBody);
                // Link
                response.localizationContainer[locale]?.PrivacyStatementTitle && (responseToData.link[locale] = response.localizationContainer[locale]?.PrivacyStatementTitle);
                // Message accepted
                response.localizationContainer[locale]?.ConsentAknowledgementAccepted && (responseToData.messageAccepted[locale] = response.localizationContainer[locale]?.ConsentAknowledgementAccepted);
                // Message refused
                response.localizationContainer[locale]?.ConsentAknowledgementRefused && (responseToData.messageRefused[locale] = response.localizationContainer[locale]?.ConsentAknowledgementRefused);
            }
            // LinkURl is the same for all languages
            responseToData.linkURL = response.privacyStatementUrl;
            return {
                displayGDPR: response.enableConsent,
                data: responseToData
            };
        }
    }
    return {
        displayGDPR: false,
        userConsent: false
    };
};



const $d81c99a856ae2114$var$RetorikConfigHandler = (props)=>{
    const [fetchedConfig, setFetchedConfig] = (0, $lT7pJ.useState)();
    const [mainConfig, setMainConfig] = (0, $lT7pJ.useState)(undefined);
    const [isConfigUpdated, setIsConfigUpdated] = (0, $lT7pJ.useState)(false);
    /**
   * Check if emergency data can be retrieved to remove the button in menu if no data available
   * @param configuration RetorikMainComponentConfiguration
   */ const checkEmergencyAndSetConfig = async (configuration)=>{
        const data = await (0, $d7c9dc99116a96ed$export$cdd2c9f4b3acf5fb)(configuration.addressData);
        const tempConfiguration = {
            ...configuration
        };
        if (!data) {
            const views = tempConfiguration.config?.baseMenu || (0, $bbe458fac496c294$export$9bbca248acc786d3);
            const tempBaseMenu = views.filter((menu)=>// @ts-ignore : error on menu.view that doesn't exist in type CustomMenu
                !menu.view || menu.view !== (0, $45d43a6de0968f42$export$3b4d92ba873f009a).emergency);
            tempConfiguration.config && (tempConfiguration.config.baseMenu = tempBaseMenu);
        }
        setMainConfig(tempConfiguration);
        setIsConfigUpdated(true);
    };
    const fetchConfigurationFromRetorikStudio = async ()=>{
        const fetchedConfig = await (0, $776569acf3b31dd9$export$2e2bcd8739ae039)(props);
        console.log("Retorik Framework > configuration fetched from Retorik Studio");
        fetchedConfig && setFetchedConfig(fetchedConfig);
    };
    const checkGDPR = async ()=>{
        const data = await (0, $d5cb7275de1c4931$export$284b58786299e6c5)({
            configurationData: props.GDPR,
            addressData: props.addressData
        });
        // Set GDPR data in utilsStore
        data.data && (0, $1bda010252da638c$export$2d640df2114a2d77)(data.data);
        (0, $1bda010252da638c$export$ff26692bd8e0fbbd)(data.displayGDPR);
        typeof data.userConsent === "boolean" && (0, $1bda010252da638c$export$7a09e6b3c59f37ad)(data.userConsent);
    };
    /**
   * Fetch configuration once and det GDPR data from Retorik Studio and set them in store
   */ (0, $lT7pJ.useEffect)(()=>{
        props && fetchConfigurationFromRetorikStudio();
        props.addressData && checkGDPR();
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        if (fetchedConfig && props) {
            const { skipLoader: skipLoader, defaultMode: defaultMode, config: _config, viewsConfig: viewsConfig, chatbotData: chatbotData, chatbotDataWidget: chatbotDataWidget, agentData: agentData, ponyfillFactoryCredentials: ponyfillFactoryCredentials, customVoice: customVoice, colors: colors } = fetchedConfig;
            const mergedMainConfig = {
                config: props.config !== undefined ? (0, $c08cbd71abd81c74$export$6969335ea1e4e77c)(props.config, _config) : _config,
                viewsConfig: props.viewsConfig !== undefined ? (0, $c08cbd71abd81c74$export$6969335ea1e4e77c)(props.viewsConfig, viewsConfig) : viewsConfig,
                chatbotData: props.chatbotData !== undefined ? {
                    ...chatbotData,
                    ...props.chatbotData
                } : chatbotData,
                chatbotDataWidget: props.chatbotDataWidget !== undefined ? {
                    ...chatbotDataWidget,
                    ...props.chatbotDataWidget
                } : chatbotDataWidget,
                agentData: props.agentData !== undefined ? props.agentData : agentData,
                ponyfillFactoryCredentials: props.ponyfillFactoryCredentials !== undefined ? props.ponyfillFactoryCredentials : ponyfillFactoryCredentials,
                customVoice: props.customVoice !== undefined ? {
                    ...customVoice,
                    ...props.customVoice
                } : customVoice,
                colors: props.colors !== undefined ? (0, $c08cbd71abd81c74$export$6969335ea1e4e77c)(props.colors, (0, $c08cbd71abd81c74$export$2e2bcd8739ae039)(colors)) : (0, $c08cbd71abd81c74$export$2e2bcd8739ae039)(colors),
                skipLoader: props.skipLoader !== undefined ? props.skipLoader : skipLoader,
                defaultMode: props.defaultMode !== undefined ? props.defaultMode : defaultMode,
                // Data not retrieved from Retorik Studio
                addressData: props.addressData,
                userData: props.userData,
                externalEventHandler: props.externalEventHandler,
                externalComponents: props.externalComponents,
                width: props.width,
                height: props.height
            };
            // Prevent menus from being copied again after each modification of configuration
            if (mergedMainConfig.config) {
                mergedMainConfig.config.baseMenu = props.config?.baseMenu || props.menuConfig?.baseMenu;
                mergedMainConfig.config.customMenu = props.config?.customMenu || props.menuConfig?.customMenu;
                mergedMainConfig.config.subMenu = props.config?.subMenu || props.menuConfig?.subMenu;
            }
            checkEmergencyAndSetConfig(mergedMainConfig);
        }
    }, [
        props,
        fetchedConfig
    ]);
    return mainConfig ? /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $4bebd0dd2d5ff69c$export$2e2bcd8739ae039), {
        parent: props.parent,
        ...mainConfig
    }) : /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $71d8c5a6ede06616$export$2e2bcd8739ae039), {
        className: isConfigUpdated ? "rf-animate-loaderFadeOut" : "",
        parent: props.parent,
        width: props.width,
        height: props.height,
        fullSize: !!(props.parent !== (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget && props?.config?.fullSize !== false)
    });
};
var $d81c99a856ae2114$export$2e2bcd8739ae039 = $d81c99a856ae2114$var$RetorikConfigHandler;


const $dbd18630e6cdc284$var$RetorikAgent = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au retorikAgent
    // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer
    // -------------------------
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ec2ce1c4441090f2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d81c99a856ae2114$export$2e2bcd8739ae039), {
            parent: (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).agent,
            ...props
        })
    });
};
var $dbd18630e6cdc284$export$2e2bcd8739ae039 = $dbd18630e6cdc284$var$RetorikAgent;




var $lT7pJ = parcelRequire("lT7pJ");





var $lT7pJ = parcelRequire("lT7pJ");




// Get style for widget's border (except colors)
const $8e2951772cccfbf6$export$d6ad062ea094ff6f = (borderData)=>{
    if (!borderData || !borderData.color && borderData.thickness === undefined && borderData.rounded === undefined) return "rf-border rf-rounded rf-border-gray";
    const borderThickness = borderData.thickness !== undefined && borderData.thickness !== 1 ? `rf-border-${borderData.thickness}` : "rf-border";
    const borderRounded = borderData.rounded === false ? "" : "rf-rounded-lg";
    return `${borderThickness} ${borderRounded}`;
};
// Get style for widget's button (except colors)
const $8e2951772cccfbf6$export$5bc78eab59412c50 = (buttonData)=>{
    if (!buttonData || !buttonData.text && !buttonData.image && !buttonData.border && !buttonData.background && !buttonData.position) return "rf-rounded-lg rf-font-bold";
    // Button border
    const borderStyle = buttonData.border?.rounded === false ? "" : "rf-rounded-lg";
    // Button text
    const textStyle = buttonData.text?.bold && buttonData.text.bold === false ? "" : "rf-font-bold";
    return `${borderStyle} ${textStyle}`;
};





const $a24939a50bc568ac$var$LayoutHandler = (props)=>{
    const translation = (0, $d0ec91114d7de49c$export$6650dace022cfacc)((state)=>state.currentTranslations);
    const currentLayout = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.currentLayout);
    const displayChangeLayoutButton = (0, $7c69764370dcab43$export$bd22554f31e5f96f)((state)=>state.configuration).allowSwitchLayout;
    const { open: open, loaded: loaded, widgetDisplayType: widgetDisplayType } = (0, $079f3ffaa96f1faa$export$d95eb9b67812311f)();
    const [currentConfiguration, setCurrentConfiguration] = (0, $lT7pJ.useState)(props.widgetConfig?.large);
    const [widgetButton, setWidgetButton] = (0, $lT7pJ.useState)("");
    const [widgetBorder, setWidgetBorder] = (0, $lT7pJ.useState)("");
    const [mobileWidth, setMobileWidth] = (0, $lT7pJ.useState)(window.innerWidth < 600);
    const [frameStyle, setFrameStyle] = (0, $lT7pJ.useState)({});
    const handleResize = ()=>{
        setMobileWidth(window.innerWidth < 600);
    };
    (0, $lT7pJ.useEffect)(()=>{
        setWidgetButton((0, $8e2951772cccfbf6$export$5bc78eab59412c50)(props.widgetConfig?.button));
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    (0, $lT7pJ.useEffect)(()=>{
        mobileWidth ? setFrameStyle({
            width: open ? "100%" : "0px",
            height: "100%"
        }) : setFrameStyle({
            top: currentConfiguration?.position?.top,
            bottom: currentConfiguration?.position?.bottom ? currentConfiguration?.position?.bottom : currentConfiguration?.position?.top || currentConfiguration?.position?.left || currentConfiguration?.position?.right ? undefined : "1rem",
            left: currentConfiguration?.position?.left,
            right: currentConfiguration?.position?.right ? currentConfiguration?.position?.right : currentConfiguration?.position?.top || currentConfiguration?.position?.bottom || currentConfiguration?.position?.left ? undefined : "1rem",
            borderColor: currentConfiguration?.border?.color || (0, $cf20bc7a6d166273$export$4aebf65ed07cf17b).rgb
        });
    }, [
        mobileWidth,
        currentConfiguration
    ]);
    (0, $lT7pJ.useEffect)(()=>{
        switch(widgetDisplayType){
            case "large":
                setCurrentConfiguration(props.widgetConfig?.large);
                setWidgetBorder((0, $8e2951772cccfbf6$export$d6ad062ea094ff6f)(props.widgetConfig?.large?.border));
                break;
            case "thumbnail":
                setCurrentConfiguration(props.widgetConfig?.thumbnail || props.widgetConfig?.large);
                setWidgetBorder((0, $8e2951772cccfbf6$export$d6ad062ea094ff6f)(props.widgetConfig?.thumbnail?.border || props.widgetConfig?.large?.border));
                break;
            default:
                break;
        }
    }, [
        widgetDisplayType
    ]);
    const extendButtonHandler = ()=>{
        // if different display type available
        if (props.widgetConfig?.large && props.widgetConfig?.thumbnail) (0, $079f3ffaa96f1faa$export$f0e9d14ede4c01bd)();
        else (0, $7c69764370dcab43$export$e8437af1f2483b8e)((0, $45d43a6de0968f42$export$a31c5a03aaeee5f).agent);
    };
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, $ee253cdb7e062133$exports.Fragment), {
        children: [
            props.widgetConfig?.button?.display !== false && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("button", {
                className: `rf-fixed rf-px-2 rf-flex rf-flex-row rf-items-center ${widgetButton}`,
                style: {
                    color: props.widgetConfig?.button?.text?.color || (0, $cf20bc7a6d166273$export$4aebf65ed07cf17b).rgb,
                    backgroundColor: props.widgetConfig?.button?.background?.color || "transparent",
                    borderWidth: props.widgetConfig?.button?.border?.thickness !== undefined ? `${props.widgetConfig?.button?.border?.thickness}px` : "1px",
                    borderColor: props.widgetConfig?.button?.border?.color || (0, $cf20bc7a6d166273$export$4aebf65ed07cf17b).rgb,
                    top: props.widgetConfig?.button?.position?.top,
                    bottom: props.widgetConfig?.button?.position?.bottom ? props.widgetConfig?.button?.position?.bottom : props.widgetConfig?.button?.position?.top || props.widgetConfig?.button?.position?.left || props.widgetConfig?.button?.position?.right ? undefined : "1rem",
                    left: props.widgetConfig?.button?.position?.left,
                    right: props.widgetConfig?.button?.position?.right ? props.widgetConfig?.button?.position?.right : props.widgetConfig?.button?.position?.top || props.widgetConfig?.button?.position?.bottom || props.widgetConfig?.button?.position?.left ? undefined : "1rem"
                },
                onClick: (0, $079f3ffaa96f1faa$export$77c0ba4d0d97cee5),
                id: "retorik-widget-button",
                children: [
                    props.widgetConfig?.button?.image?.url && props.widgetConfig?.button?.image?.position !== "right" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                        className: `${props.widgetConfig?.button?.image.marginY === false ? "" : "rf-my-1"}`,
                        src: `${props.widgetConfig.button.image.url}`,
                        alt: "Retorik widget",
                        style: {
                            height: props.widgetConfig?.button?.image.height || "2rem"
                        }
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: "rf-py-2 rf-ml-1",
                        children: props.widgetConfig?.button?.text?.content || translation.common.needhelp
                    }),
                    props.widgetConfig?.button?.image?.url && props.widgetConfig?.button?.image?.position === "right" && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("img", {
                        className: `${props.widgetConfig?.button?.image.marginY === false ? "" : "rf-my-1"}`,
                        src: `${props.widgetConfig.button.image.url}`,
                        alt: "Retorik widget",
                        style: {
                            height: props.widgetConfig?.button?.image.height || "2rem"
                        }
                    })
                ]
            }),
            loaded && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)("div", {
                className: `${currentLayout === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? "rf-fixed rf-pt-8 rf-height-fill-available rf-transition-all rf-overflow-hidden rf-max-w-[100vw]" : ""}`,
                style: currentLayout === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? {
                    ...frameStyle,
                    width: open ? mobileWidth ? "100%" : currentConfiguration?.width || "400px" : "0px",
                    height: currentConfiguration?.height || (mobileWidth ? "100%" : "630px")
                } : {},
                "data-testid": "widget-wrapper",
                children: [
                    currentLayout === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($lT7pJ))).Fragment, {
                        children: [
                            !!displayChangeLayoutButton && !mobileWidth && /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                                onClick: extendButtonHandler,
                                "aria-label": "Extend",
                                className: "rf-absolute rf-z-exitwidget rf-flex rf-right-8 rf-top-0 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg",
                                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $6e9da30149e4e457$export$2e2bcd8739ae039), {
                                    className: "rf-h-4 rf-w-4",
                                    color: "#000000",
                                    extended: false
                                })
                            }),
                            /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("button", {
                                onClick: (0, $079f3ffaa96f1faa$export$77c0ba4d0d97cee5),
                                "aria-label": "Close",
                                className: "rf-absolute rf-z-exitwidget rf-flex rf-right-0 rf-top-0 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg",
                                children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $1bb6c2a3a9b42097$export$2e2bcd8739ae039), {
                                    className: "rf-h-4 rf-w-4",
                                    color: "#000000"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)("div", {
                        className: `${currentLayout === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? `rf-relative rf-h-full rf-w-full rf-overflow-hidden ${!mobileWidth && widgetBorder}` : ""}`,
                        style: currentLayout === (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget ? {
                            borderColor: frameStyle.borderColor
                        } : {},
                        children: props.children
                    })
                ]
            })
        ]
    });
};
var $a24939a50bc568ac$export$2e2bcd8739ae039 = $a24939a50bc568ac$var$LayoutHandler;




window.Retorik = {
    ...window.Retorik,
    openWidget: $079f3ffaa96f1faa$export$a1c83309c736819f,
    closeWidget: $079f3ffaa96f1faa$export$d27f1b0993b666c,
    toggleWidget: $079f3ffaa96f1faa$export$77c0ba4d0d97cee5,
    toggleDisplay: $079f3ffaa96f1faa$export$f0e9d14ede4c01bd
};
const $70f732d5e9e4f751$var$RetorikWidget = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au widget
    // Ce qui est commun avec RetorikAgent ou autres doit aller dans RetorikComposer ou ContextProvider
    // -------------------------
    (0, $lT7pJ.useEffect)(()=>{
        (0, $7c69764370dcab43$export$e8437af1f2483b8e)((0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget);
    }, []);
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ec2ce1c4441090f2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $a24939a50bc568ac$export$2e2bcd8739ae039), {
            ...props,
            children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d81c99a856ae2114$export$2e2bcd8739ae039), {
                ...props,
                width: "full",
                height: "full",
                parent: (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).widget
            })
        })
    });
};
var $70f732d5e9e4f751$export$2e2bcd8739ae039 = $70f732d5e9e4f751$var$RetorikWidget;



parcelRequire("lT7pJ");



const $d9a7ab884f806af3$var$RetorikNews = (props)=>{
    // --------- /!\ -----------
    // Ne mettre ici que de la logique spécifique au retorikNews
    // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer ou ContextProvider
    // -------------------------
    return /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $ec2ce1c4441090f2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ee253cdb7e062133$exports.jsx)((0, $d81c99a856ae2114$export$2e2bcd8739ae039), {
            parent: (0, $45d43a6de0968f42$export$a31c5a03aaeee5f).news,
            ...props
        })
    });
};
var $d9a7ab884f806af3$export$2e2bcd8739ae039 = $d9a7ab884f806af3$var$RetorikNews;





const $ebb259a895a8db91$export$30a86d91af8ff6e6 = {
    alice: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/long-shot/alice`,
    greg: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/long-shot/greg`,
    jeanmarc: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/jean-marc`,
    jessica: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/long-shot/jessica`,
    jessica_short: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/medium-shot/jessica`,
    ikaa: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/long-shot/ikaa`,
    karine: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/karine`,
    lea: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/lea`,
    prosper: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/prosper`,
    raphael: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/raphael`,
    rowan: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/long-shot/rowan`,
    rowan_short: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/medium-shot/rowan`,
    zahra: `${(0, $bbe458fac496c294$export$2475544086fd222b)}/long-shot/zahra`
};















const $260857b30ae6b7bb$export$7a001476a013672 = ()=>{
    (0, $d0ec91114d7de49c$export$3118ae18000e2700)();
    (0, $1bda010252da638c$export$93b55f822ac81934)();
    (0, $7c69764370dcab43$export$cd85ac4858c7290c)();
    (0, $b8685bd729fa723f$export$b6d2196a3ce412d8)();
    (0, $d023474b51a6fd24$export$b7b23f8e09258fa6)();
    (0, $0aecf0c32f1a48e0$export$8f3b2f6aa8e2c248)();
    (0, $649c384b79ea2395$export$64bb98402f29970)();
};
const $260857b30ae6b7bb$export$b69254d879536cde = (0, $717da5514a866660$export$2e2bcd8739ae039).bind(null, (0, $dbd18630e6cdc284$export$2e2bcd8739ae039));
const $260857b30ae6b7bb$var$renderWidget = (0, $69bffc2b72abf404$export$2e2bcd8739ae039).bind(null, (0, $70f732d5e9e4f751$export$2e2bcd8739ae039));
var $260857b30ae6b7bb$export$2e2bcd8739ae039 = (0, $dbd18630e6cdc284$export$2e2bcd8739ae039);
window.Retorik = {
    ...window.Retorik,
    renderAgent: $260857b30ae6b7bb$export$b69254d879536cde,
    renderWidget: $260857b30ae6b7bb$var$renderWidget,
    showAgent: $1bda010252da638c$export$ae67eb518a2aae74,
    hideAgent: $1bda010252da638c$export$e73dbd7ba351e3e,
    setLocale: $d0ec91114d7de49c$export$c8aadf3621e41efb,
    sendMessage: $0aecf0c32f1a48e0$export$465cb47180de50f0,
    sendEvent: $0aecf0c32f1a48e0$export$7329bcdc3edcd90e,
    sendActivity: $1bda010252da638c$export$d4c8c6daac289378,
    displaySubtitles: (0, $7c69764370dcab43$export$708f3eb1d5828832),
    changeAgent: (0, $7c69764370dcab43$export$a72b80ff363563a1)
};


//# sourceMappingURL=index.js.map
